(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecbf3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecbf3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7kEWw", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $556a290bb2673f32$export$6503ec6e8aabbaf; }, function (v) { return $556a290bb2673f32$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $556a290bb2673f32$export$f7ad0328861e2f03; }, function (v) { return $556a290bb2673f32$export$f7ad0328861e2f03 = v; });
var $556a290bb2673f32$export$6503ec6e8aabbaf;
var $556a290bb2673f32$export$f7ad0328861e2f03;
"use strict";
var $556a290bb2673f32$var$mapping = new Map();
function $556a290bb2673f32$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$556a290bb2673f32$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $556a290bb2673f32$var$resolve(id) {
    var resolved = $556a290bb2673f32$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$556a290bb2673f32$export$6503ec6e8aabbaf = $556a290bb2673f32$var$register;
$556a290bb2673f32$export$f7ad0328861e2f03 = $556a290bb2673f32$var$resolve;

});

parcelRegister("1sJKT", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $110be60655585a54$export$bdfd709ae4826697; }, function (v) { return $110be60655585a54$export$bdfd709ae4826697 = v; });
$parcel$export(module.exports, "getOrigin", function () { return $110be60655585a54$export$5a759dc7a1cfb72a; }, function (v) { return $110be60655585a54$export$5a759dc7a1cfb72a = v; });
var $110be60655585a54$export$bdfd709ae4826697;
var $110be60655585a54$export$c9e73fbda7da57b6;
var $110be60655585a54$export$5a759dc7a1cfb72a;
"use strict";
var $110be60655585a54$var$bundleURL = {};
function $110be60655585a54$var$getBundleURLCached(id) {
    var value = $110be60655585a54$var$bundleURL[id];
    if (!value) {
        value = $110be60655585a54$var$getBundleURL();
        $110be60655585a54$var$bundleURL[id] = value;
    }
    return value;
}
function $110be60655585a54$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $110be60655585a54$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $110be60655585a54$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $110be60655585a54$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$110be60655585a54$export$bdfd709ae4826697 = $110be60655585a54$var$getBundleURLCached;
$110be60655585a54$export$c9e73fbda7da57b6 = $110be60655585a54$var$getBaseURL;
$110be60655585a54$export$5a759dc7a1cfb72a = $110be60655585a54$var$getOrigin;

});

parcelRegister("8ovux", function(module, exports) {
// shim for using process in browser
var $61c8fe3383bdc9e8$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $61c8fe3383bdc9e8$var$cachedSetTimeout;
var $61c8fe3383bdc9e8$var$cachedClearTimeout;
function $61c8fe3383bdc9e8$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $61c8fe3383bdc9e8$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $61c8fe3383bdc9e8$var$cachedSetTimeout = setTimeout;
        else $61c8fe3383bdc9e8$var$cachedSetTimeout = $61c8fe3383bdc9e8$var$defaultSetTimout;
    } catch (e) {
        $61c8fe3383bdc9e8$var$cachedSetTimeout = $61c8fe3383bdc9e8$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $61c8fe3383bdc9e8$var$cachedClearTimeout = clearTimeout;
        else $61c8fe3383bdc9e8$var$cachedClearTimeout = $61c8fe3383bdc9e8$var$defaultClearTimeout;
    } catch (e) {
        $61c8fe3383bdc9e8$var$cachedClearTimeout = $61c8fe3383bdc9e8$var$defaultClearTimeout;
    }
})();
function $61c8fe3383bdc9e8$var$runTimeout(fun) {
    if ($61c8fe3383bdc9e8$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($61c8fe3383bdc9e8$var$cachedSetTimeout === $61c8fe3383bdc9e8$var$defaultSetTimout || !$61c8fe3383bdc9e8$var$cachedSetTimeout) && setTimeout) {
        $61c8fe3383bdc9e8$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $61c8fe3383bdc9e8$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $61c8fe3383bdc9e8$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $61c8fe3383bdc9e8$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $61c8fe3383bdc9e8$var$runClearTimeout(marker) {
    if ($61c8fe3383bdc9e8$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($61c8fe3383bdc9e8$var$cachedClearTimeout === $61c8fe3383bdc9e8$var$defaultClearTimeout || !$61c8fe3383bdc9e8$var$cachedClearTimeout) && clearTimeout) {
        $61c8fe3383bdc9e8$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $61c8fe3383bdc9e8$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $61c8fe3383bdc9e8$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $61c8fe3383bdc9e8$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $61c8fe3383bdc9e8$var$queue = [];
var $61c8fe3383bdc9e8$var$draining = false;
var $61c8fe3383bdc9e8$var$currentQueue;
var $61c8fe3383bdc9e8$var$queueIndex = -1;
function $61c8fe3383bdc9e8$var$cleanUpNextTick() {
    if (!$61c8fe3383bdc9e8$var$draining || !$61c8fe3383bdc9e8$var$currentQueue) return;
    $61c8fe3383bdc9e8$var$draining = false;
    if ($61c8fe3383bdc9e8$var$currentQueue.length) $61c8fe3383bdc9e8$var$queue = $61c8fe3383bdc9e8$var$currentQueue.concat($61c8fe3383bdc9e8$var$queue);
    else $61c8fe3383bdc9e8$var$queueIndex = -1;
    if ($61c8fe3383bdc9e8$var$queue.length) $61c8fe3383bdc9e8$var$drainQueue();
}
function $61c8fe3383bdc9e8$var$drainQueue() {
    if ($61c8fe3383bdc9e8$var$draining) return;
    var timeout = $61c8fe3383bdc9e8$var$runTimeout($61c8fe3383bdc9e8$var$cleanUpNextTick);
    $61c8fe3383bdc9e8$var$draining = true;
    var len = $61c8fe3383bdc9e8$var$queue.length;
    while(len){
        $61c8fe3383bdc9e8$var$currentQueue = $61c8fe3383bdc9e8$var$queue;
        $61c8fe3383bdc9e8$var$queue = [];
        while(++$61c8fe3383bdc9e8$var$queueIndex < len)if ($61c8fe3383bdc9e8$var$currentQueue) $61c8fe3383bdc9e8$var$currentQueue[$61c8fe3383bdc9e8$var$queueIndex].run();
        $61c8fe3383bdc9e8$var$queueIndex = -1;
        len = $61c8fe3383bdc9e8$var$queue.length;
    }
    $61c8fe3383bdc9e8$var$currentQueue = null;
    $61c8fe3383bdc9e8$var$draining = false;
    $61c8fe3383bdc9e8$var$runClearTimeout(timeout);
}
$61c8fe3383bdc9e8$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $61c8fe3383bdc9e8$var$queue.push(new $61c8fe3383bdc9e8$var$Item(fun, args));
    if ($61c8fe3383bdc9e8$var$queue.length === 1 && !$61c8fe3383bdc9e8$var$draining) $61c8fe3383bdc9e8$var$runTimeout($61c8fe3383bdc9e8$var$drainQueue);
};
// v8 likes predictible objects
function $61c8fe3383bdc9e8$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$61c8fe3383bdc9e8$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$61c8fe3383bdc9e8$var$process.title = "browser";
$61c8fe3383bdc9e8$var$process.browser = true;
$61c8fe3383bdc9e8$var$process.env = {};
$61c8fe3383bdc9e8$var$process.argv = [];
$61c8fe3383bdc9e8$var$process.version = ""; // empty string to avoid regexp issues
$61c8fe3383bdc9e8$var$process.versions = {};
function $61c8fe3383bdc9e8$var$noop() {}
$61c8fe3383bdc9e8$var$process.on = $61c8fe3383bdc9e8$var$noop;
$61c8fe3383bdc9e8$var$process.addListener = $61c8fe3383bdc9e8$var$noop;
$61c8fe3383bdc9e8$var$process.once = $61c8fe3383bdc9e8$var$noop;
$61c8fe3383bdc9e8$var$process.off = $61c8fe3383bdc9e8$var$noop;
$61c8fe3383bdc9e8$var$process.removeListener = $61c8fe3383bdc9e8$var$noop;
$61c8fe3383bdc9e8$var$process.removeAllListeners = $61c8fe3383bdc9e8$var$noop;
$61c8fe3383bdc9e8$var$process.emit = $61c8fe3383bdc9e8$var$noop;
$61c8fe3383bdc9e8$var$process.prependListener = $61c8fe3383bdc9e8$var$noop;
$61c8fe3383bdc9e8$var$process.prependOnceListener = $61c8fe3383bdc9e8$var$noop;
$61c8fe3383bdc9e8$var$process.listeners = function(name) {
    return [];
};
$61c8fe3383bdc9e8$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$61c8fe3383bdc9e8$var$process.cwd = function() {
    return "/";
};
$61c8fe3383bdc9e8$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$61c8fe3383bdc9e8$var$process.umask = function() {
    return 0;
};

});

parcelRegister("l5MLt", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $f5afe4435b7da213$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $f5afe4435b7da213$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $f5afe4435b7da213$export$3c9a16f847548506; });
$parcel$export(module.exports, "__awaiter", function () { return $f5afe4435b7da213$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $f5afe4435b7da213$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__exportStar", function () { return $f5afe4435b7da213$export$f33643c0debef087; });
$parcel$export(module.exports, "__values", function () { return $f5afe4435b7da213$export$19a8beecd37a4c45; });
$parcel$export(module.exports, "__read", function () { return $f5afe4435b7da213$export$8d051b38c9118094; });
$parcel$export(module.exports, "__spread", function () { return $f5afe4435b7da213$export$afc72e2116322959; });
$parcel$export(module.exports, "__spreadArrays", function () { return $f5afe4435b7da213$export$6388937ca91ccae8; });
$parcel$export(module.exports, "__importStar", function () { return $f5afe4435b7da213$export$c21735bcef00d192; });
$parcel$export(module.exports, "__importDefault", function () { return $f5afe4435b7da213$export$da59b14a69baef04; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $f5afe4435b7da213$var$extendStatics = function(d, b) {
    $f5afe4435b7da213$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $f5afe4435b7da213$var$extendStatics(d, b);
};
function $f5afe4435b7da213$export$a8ba968b8961cb8a(d, b) {
    $f5afe4435b7da213$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f5afe4435b7da213$export$18ce0697a983be9b = function() {
    $f5afe4435b7da213$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f5afe4435b7da213$export$18ce0697a983be9b.apply(this, arguments);
};
function $f5afe4435b7da213$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f5afe4435b7da213$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f5afe4435b7da213$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f5afe4435b7da213$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f5afe4435b7da213$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f5afe4435b7da213$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $f5afe4435b7da213$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $f5afe4435b7da213$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $f5afe4435b7da213$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f5afe4435b7da213$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f5afe4435b7da213$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f5afe4435b7da213$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f5afe4435b7da213$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f5afe4435b7da213$export$10c90e4f7922046c(v) {
    return this instanceof $f5afe4435b7da213$export$10c90e4f7922046c ? (this.v = v, this) : new $f5afe4435b7da213$export$10c90e4f7922046c(v);
}
function $f5afe4435b7da213$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f5afe4435b7da213$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f5afe4435b7da213$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f5afe4435b7da213$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $f5afe4435b7da213$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f5afe4435b7da213$export$19a8beecd37a4c45 === "function" ? $f5afe4435b7da213$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f5afe4435b7da213$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $f5afe4435b7da213$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $f5afe4435b7da213$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f5afe4435b7da213$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $f5afe4435b7da213$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("4IkmO", function(module, exports) {

$parcel$export(module.exports, "Hub", function () { return $36eb11ebdaa44f36$export$8c41bb232f1008b1; });
$parcel$export(module.exports, "makeMain", function () { return $36eb11ebdaa44f36$export$4188a14ad302d1bc; });
$parcel$export(module.exports, "getHubFromCarrier", function () { return $36eb11ebdaa44f36$export$bfa8a924a84a76b7; });
$parcel$export(module.exports, "getCurrentHub", function () { return $36eb11ebdaa44f36$export$a07cdf6544bbd7c; });

var $l5MLt = parcelRequire("l5MLt");
parcelRequire("adAOX");
var $iae15 = parcelRequire("iae15");
var $79aQT = parcelRequire("79aQT");
var $iHHw0 = parcelRequire("iHHw0");
var $7HZmq = parcelRequire("7HZmq");
var $iEupb = parcelRequire("iEupb");

var $7mSNn = parcelRequire("7mSNn");

var $l6Sat = parcelRequire("l6Sat");

var $jA7RW = parcelRequire("jA7RW");
var $36eb11ebdaa44f36$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var $36eb11ebdaa44f36$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ var $36eb11ebdaa44f36$export$8c41bb232f1008b1 = /** @class */ function() {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */ function Hub(client, scope, _version) {
        if (scope === void 0) scope = new (0, $l6Sat.Scope)();
        if (_version === void 0) _version = $36eb11ebdaa44f36$export$24a86ef7798177e4;
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */ this._stack = [
            {}
        ];
        this.getStackTop().scope = scope;
        if (client) this.bindClient(client);
    }
    /**
     * @inheritDoc
     */ Hub.prototype.isOlderThan = function(version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.bindClient = function(client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.pushScope = function() {
        // We want to clone the content of prev scope
        var scope = (0, $l6Sat.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.popScope = function() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.withScope = function(callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getClient = function() {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */ Hub.prototype.getScope = function() {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */ Hub.prototype.getStack = function() {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */ Hub.prototype.getStackTop = function() {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function(exception, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $iEupb.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error("Sentry syntheticException");
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException
            };
        }
        this._invokeClient("captureException", exception, (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureMessage = function(message, level, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $iEupb.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException
            };
        }
        this._invokeClient("captureMessage", message, level, (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureEvent = function(event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : (0, $iEupb.uuid4)();
        if (event.type !== "transaction") this._lastEventId = eventId;
        this._invokeClient("captureEvent", event, (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, hint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.lastEventId = function() {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.addBreadcrumb = function(breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client) return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = client.getOptions && client.getOptions() || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? $36eb11ebdaa44f36$var$DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0) return;
        var timestamp = (0, $79aQT.dateTimestampInSeconds)();
        var mergedBreadcrumb = (0, $l5MLt.__assign)({
            timestamp: timestamp
        }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb ? (0, $iae15.consoleSandbox)(function() {
            return beforeBreadcrumb(mergedBreadcrumb, hint);
        }) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setUser = function(user) {
        var scope = this.getScope();
        if (scope) scope.setUser(user);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTags = function(tags) {
        var scope = this.getScope();
        if (scope) scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtras = function(extras) {
        var scope = this.getScope();
        if (scope) scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTag = function(key, value) {
        var scope = this.getScope();
        if (scope) scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtra = function(key, extra) {
        var scope = this.getScope();
        if (scope) scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function(name, context) {
        var scope = this.getScope();
        if (scope) scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.configureScope = function(callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) callback(scope);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.run = function(callback) {
        var oldHub = $36eb11ebdaa44f36$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $36eb11ebdaa44f36$export$4188a14ad302d1bc(oldHub);
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getIntegration = function(integration) {
        var client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $7mSNn.IS_DEBUG_BUILD) && (0, $iae15.logger).warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSpan = function(context) {
        return this._callExtensionMethod("startSpan", context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startTransaction = function(context, customSamplingContext) {
        return this._callExtensionMethod("startTransaction", context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.traceHeaders = function() {
        return this._callExtensionMethod("traceHeaders");
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureSession = function(endSession) {
        if (endSession === void 0) endSession = false;
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.endSession = function() {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) session.close();
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) scope.setSession();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSession = function(context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = client && client.getOptions() || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = (0, $iHHw0.getGlobalObject)();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new (0, $jA7RW.Session)((0, $l5MLt.__assign)((0, $l5MLt.__assign)((0, $l5MLt.__assign)({
            release: release,
            environment: environment
        }, scope && {
            user: scope.getUser()
        }), userAgent && {
            userAgent: userAgent
        }), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === "ok") currentSession.update({
                status: "exited"
            });
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */ Hub.prototype._sendSessionUpdate = function() {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope) return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) client.captureSession(session);
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function(method) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        (_a = client)[method].apply(_a, (0, $l5MLt.__spread)(args, [
            scope
        ]));
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var carrier = $36eb11ebdaa44f36$export$19eade501500c6c1();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $7mSNn.IS_DEBUG_BUILD) && (0, $iae15.logger).warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}();
function $36eb11ebdaa44f36$export$19eade501500c6c1() {
    var carrier = (0, $iHHw0.getGlobalObject)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return carrier;
}
function $36eb11ebdaa44f36$export$4188a14ad302d1bc(hub) {
    var registry = $36eb11ebdaa44f36$export$19eade501500c6c1();
    var oldHub = $36eb11ebdaa44f36$export$bfa8a924a84a76b7(registry);
    $36eb11ebdaa44f36$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
function $36eb11ebdaa44f36$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    var registry = $36eb11ebdaa44f36$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$36eb11ebdaa44f36$var$hasHubOnCarrier(registry) || $36eb11ebdaa44f36$export$bfa8a924a84a76b7(registry).isOlderThan($36eb11ebdaa44f36$export$24a86ef7798177e4)) $36eb11ebdaa44f36$export$849f05434e95d2f2(registry, new $36eb11ebdaa44f36$export$8c41bb232f1008b1());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, $7HZmq.isNodeEnv)()) return $36eb11ebdaa44f36$var$getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return $36eb11ebdaa44f36$export$bfa8a924a84a76b7(registry);
}
function $36eb11ebdaa44f36$export$1c4d656130202699() {
    (0, $7mSNn.IS_DEBUG_BUILD) && (0, $iae15.logger).warn("Function `getActiveDomain` is deprecated and will be removed in a future version.");
    var sentry = $36eb11ebdaa44f36$export$19eade501500c6c1().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */ function $36eb11ebdaa44f36$var$getHubFromActiveDomain(registry) {
    try {
        var sentry = $36eb11ebdaa44f36$export$19eade501500c6c1().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) return $36eb11ebdaa44f36$export$bfa8a924a84a76b7(registry);
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!$36eb11ebdaa44f36$var$hasHubOnCarrier(activeDomain) || $36eb11ebdaa44f36$export$bfa8a924a84a76b7(activeDomain).isOlderThan($36eb11ebdaa44f36$export$24a86ef7798177e4)) {
            var registryHubTopStack = $36eb11ebdaa44f36$export$bfa8a924a84a76b7(registry).getStackTop();
            $36eb11ebdaa44f36$export$849f05434e95d2f2(activeDomain, new $36eb11ebdaa44f36$export$8c41bb232f1008b1(registryHubTopStack.client, (0, $l6Sat.Scope).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return $36eb11ebdaa44f36$export$bfa8a924a84a76b7(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return $36eb11ebdaa44f36$export$bfa8a924a84a76b7(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $36eb11ebdaa44f36$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
function $36eb11ebdaa44f36$export$bfa8a924a84a76b7(carrier) {
    return (0, $iHHw0.getGlobalSingleton)("hub", function() {
        return new $36eb11ebdaa44f36$export$8c41bb232f1008b1();
    }, carrier);
}
function $36eb11ebdaa44f36$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("adAOX", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", function () { return (parcelRequire("iHHw0")).getGlobalObject; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return (parcelRequire("iHHw0")).getGlobalSingleton; });
$parcel$export(module.exports, "isPlainObject", function () { return (parcelRequire("7GcQw")).isPlainObject; });
$parcel$export(module.exports, "isThenable", function () { return (parcelRequire("7GcQw")).isThenable; });
$parcel$export(module.exports, "consoleSandbox", function () { return (parcelRequire("iae15")).consoleSandbox; });
$parcel$export(module.exports, "logger", function () { return (parcelRequire("iae15")).logger; });
$parcel$export(module.exports, "uuid4", function () { return (parcelRequire("iEupb")).uuid4; });
$parcel$export(module.exports, "dropUndefinedKeys", function () { return (parcelRequire("kd4fD")).dropUndefinedKeys; });
$parcel$export(module.exports, "SyncPromise", function () { return (parcelRequire("8lVec")).SyncPromise; });





parcelRequire("iHHw0");

parcelRequire("7GcQw");
parcelRequire("iae15");

parcelRequire("iEupb");

var $7HZmq = parcelRequire("7HZmq");

parcelRequire("kd4fD");







parcelRequire("8lVec");

var $79aQT = parcelRequire("79aQT");





$parcel$exportWildcard(module.exports, $7HZmq);
$parcel$exportWildcard(module.exports, $79aQT);

});
parcelRegister("iHHw0", function(module, exports) {

$parcel$export(module.exports, "getGlobalObject", function () { return $d9ddff5de85e8786$export$256479dc0cea61c4; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $d9ddff5de85e8786$export$7e223ec222791509; });
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $7HZmq = parcelRequire("7HZmq");
var $d9ddff5de85e8786$var$fallbackGlobalObject = {};
function $d9ddff5de85e8786$export$256479dc0cea61c4() {
    return (0, $7HZmq.isNodeEnv)() ? $parcel$global : typeof window !== "undefined" // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== "undefined" ? self : $d9ddff5de85e8786$var$fallbackGlobalObject;
}
function $d9ddff5de85e8786$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $d9ddff5de85e8786$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("7HZmq", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; }, function (v) { return isNodeEnv = v; });
$parcel$export(module.exports, "dynamicRequire", function () { return dynamicRequire; }, function (v) { return dynamicRequire = v; });
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $cpA2Q = parcelRequire("cpA2Q");

var $8ovux = parcelRequire("8ovux");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $cpA2Q.isBrowserBundle)() && Object.prototype.toString.call(typeof $8ovux !== "undefined" ? $8ovux : 0) === "[object process]";
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, "process").cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("cpA2Q", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $9093c798a44a0529$export$2928c40372e623c0; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $9093c798a44a0529$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("7GcQw", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $59766ba098722c64$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $59766ba098722c64$export$49034edbe6b62415; });
$parcel$export(module.exports, "isString", function () { return $59766ba098722c64$export$844ec244b1367d54; });
$parcel$export(module.exports, "isPrimitive", function () { return $59766ba098722c64$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $59766ba098722c64$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $59766ba098722c64$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $59766ba098722c64$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $59766ba098722c64$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $59766ba098722c64$export$f5b060c2914b97c8; });
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $59766ba098722c64$var$objectToString = Object.prototype.toString;
function $59766ba098722c64$export$e6127cc7fe7395c3(wat) {
    switch($59766ba098722c64$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $59766ba098722c64$export$49034edbe6b62415(wat, Error);
    }
}
function $59766ba098722c64$var$isBuiltin(wat, ty) {
    return $59766ba098722c64$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $59766ba098722c64$export$9f9636d330b71954(wat) {
    return $59766ba098722c64$var$isBuiltin(wat, "ErrorEvent");
}
function $59766ba098722c64$export$ef9e2056653f0c8e(wat) {
    return $59766ba098722c64$var$isBuiltin(wat, "DOMError");
}
function $59766ba098722c64$export$12e869b2a583f783(wat) {
    return $59766ba098722c64$var$isBuiltin(wat, "DOMException");
}
function $59766ba098722c64$export$844ec244b1367d54(wat) {
    return $59766ba098722c64$var$isBuiltin(wat, "String");
}
function $59766ba098722c64$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== "object" && typeof wat !== "function";
}
function $59766ba098722c64$export$53b83ca8eaab0383(wat) {
    return $59766ba098722c64$var$isBuiltin(wat, "Object");
}
function $59766ba098722c64$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $59766ba098722c64$export$49034edbe6b62415(wat, Event);
}
function $59766ba098722c64$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $59766ba098722c64$export$49034edbe6b62415(wat, Element);
}
function $59766ba098722c64$export$49841c62b9eff15(wat) {
    return $59766ba098722c64$var$isBuiltin(wat, "RegExp");
}
function $59766ba098722c64$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
function $59766ba098722c64$export$bc2894c7158efbac(wat) {
    return $59766ba098722c64$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $59766ba098722c64$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
function $59766ba098722c64$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});

parcelRegister("iae15", function(module, exports) {

$parcel$export(module.exports, "consoleSandbox", function () { return $d3940893e44babd4$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "logger", function () { return $d3940893e44babd4$export$af88d00dbe7f521; });

var $l5MLt = parcelRequire("l5MLt");

var $bx7l3 = parcelRequire("bx7l3");

var $iHHw0 = parcelRequire("iHHw0");
// TODO: Implement different loggers for different environments
var $d3940893e44babd4$var$global = (0, $iHHw0.getGlobalObject)();
/** Prefix for logging strings */ var $d3940893e44babd4$var$PREFIX = "Sentry Logger ";
var $d3940893e44babd4$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert"
];
function $d3940893e44babd4$export$cda52e2a8927a2ca(callback) {
    var global = (0, $iHHw0.getGlobalObject)();
    if (!("console" in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $d3940893e44babd4$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $d3940893e44babd4$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $bx7l3.IS_DEBUG_BUILD) $d3940893e44babd4$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $d3940893e44babd4$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $d3940893e44babd4$var$global.console)[name].apply(_a, (0, $l5MLt.__spread)([
                    $d3940893e44babd4$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $d3940893e44babd4$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $d3940893e44babd4$export$af88d00dbe7f521;
if (0, $bx7l3.IS_DEBUG_BUILD) $d3940893e44babd4$export$af88d00dbe7f521 = (0, $iHHw0.getGlobalSingleton)("logger", $d3940893e44babd4$var$makeLogger);
else $d3940893e44babd4$export$af88d00dbe7f521 = $d3940893e44babd4$var$makeLogger();

});
parcelRegister("bx7l3", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", function () { return $865878152573f007$export$48a8984ec0bf2e44; });
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $865878152573f007$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === "undefined" ? true : __SENTRY_DEBUG__;

});


parcelRegister("iEupb", function(module, exports) {

$parcel$export(module.exports, "uuid4", function () { return $d9438c3f44f9bf80$export$19f53698e68b2496; });

var $l5MLt = parcelRequire("l5MLt");

var $iHHw0 = parcelRequire("iHHw0");

var $kd4fD = parcelRequire("kd4fD");

var $6hkJG = parcelRequire("6hkJG");
function $d9438c3f44f9bf80$export$19f53698e68b2496() {
    var global = (0, $iHHw0.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $d9438c3f44f9bf80$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || "";
    var fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $d9438c3f44f9bf80$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $d9438c3f44f9bf80$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $d9438c3f44f9bf80$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $d9438c3f44f9bf80$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $d9438c3f44f9bf80$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $d9438c3f44f9bf80$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: "generic",
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $l5MLt.__assign)((0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && "data" in newMechanism) {
        var mergedData = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $d9438c3f44f9bf80$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $d9438c3f44f9bf80$export$d364f2020ab30578(input) {
    var match = input.match($d9438c3f44f9bf80$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $d9438c3f44f9bf80$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $6hkJG.snipLine)(line, 0);
    });
    frame.context_line = (0, $6hkJG.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $6hkJG.snipLine)(line, 0);
    });
}
function $d9438c3f44f9bf80$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $d9438c3f44f9bf80$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $kd4fD.addNonEnumerableProperty)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});
parcelRegister("kd4fD", function(module, exports) {

$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $eb6851b783b571b8$export$e73679ffaf56810e; });
$parcel$export(module.exports, "dropUndefinedKeys", function () { return $eb6851b783b571b8$export$d25f2688db1bb433; });

var $l5MLt = parcelRequire("l5MLt");

var $bqYW0 = parcelRequire("bqYW0");

var $7GcQw = parcelRequire("7GcQw");

var $6hkJG = parcelRequire("6hkJG");
function $eb6851b783b571b8$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") try {
        $eb6851b783b571b8$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $eb6851b783b571b8$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $eb6851b783b571b8$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $eb6851b783b571b8$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
}
function $eb6851b783b571b8$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $eb6851b783b571b8$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join("&");
}
function $eb6851b783b571b8$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $7GcQw.isError)(value)) newObj = (0, $l5MLt.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $eb6851b783b571b8$var$getOwnProperties(value));
    else if ((0, $7GcQw.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $l5MLt.__assign)({
            type: event_1.type,
            target: $eb6851b783b571b8$var$serializeEventTarget(event_1.target),
            currentTarget: $eb6851b783b571b8$var$serializeEventTarget(event_1.currentTarget)
        }, $eb6851b783b571b8$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== "undefined" && (0, $7GcQw.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $eb6851b783b571b8$var$serializeEventTarget(target) {
    try {
        return (0, $7GcQw.isElement)(target) ? (0, $bqYW0.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $eb6851b783b571b8$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $eb6851b783b571b8$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($eb6851b783b571b8$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $6hkJG.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $6hkJG.truncate)(serialized, maxLength);
    }
    return "";
}
function $eb6851b783b571b8$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $7GcQw.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $l5MLt.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== "undefined") rv[key] = $eb6851b783b571b8$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($eb6851b783b571b8$export$d25f2688db1bb433);
    return val;
}
function $eb6851b783b571b8$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $7GcQw.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("bqYW0", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $853163c0efc81663$export$5647df6b7814ac86; });

var $iHHw0 = parcelRequire("iHHw0");

var $7GcQw = parcelRequire("7GcQw");
function $853163c0efc81663$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = " > ";
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $853163c0efc81663$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $853163c0efc81663$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return "";
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + '="' + keyAttrPair[1] + '"]');
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $7GcQw.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + '="' + attr + '"]');
    }
    return out.join("");
}
function $853163c0efc81663$export$1cfafeee2987818b() {
    var global = (0, $iHHw0.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return "";
    }
}

});

parcelRegister("6hkJG", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $49246a4a3d15c781$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $49246a4a3d15c781$export$4215662d762d6f9d; });

var $7GcQw = parcelRequire("7GcQw");
function $49246a4a3d15c781$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $49246a4a3d15c781$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $49246a4a3d15c781$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
function $49246a4a3d15c781$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $7GcQw.isString)(value)) return false;
    if ((0, $7GcQw.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === "string") return value.indexOf(pattern) !== -1;
    return false;
}
function $49246a4a3d15c781$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}

});



parcelRegister("8lVec", function(module, exports) {

$parcel$export(module.exports, "SyncPromise", function () { return $614cad2a7a9a568d$export$6f292d4960313241; });
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $7GcQw = parcelRequire("7GcQw");
function $614cad2a7a9a568d$export$1fda8aa4d135f8aa(value) {
    return new $614cad2a7a9a568d$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $614cad2a7a9a568d$export$78e43115b553f358(reason) {
    return new $614cad2a7a9a568d$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $614cad2a7a9a568d$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $7GcQw.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});

parcelRegister("79aQT", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return dateTimestampInSeconds; }, function (v) { return dateTimestampInSeconds = v; });
$parcel$export(module.exports, "timestampInSeconds", function () { return timestampInSeconds; }, function (v) { return timestampInSeconds = v; });

var $iHHw0 = parcelRequire("iHHw0");

var $7HZmq = parcelRequire("7HZmq");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $iHHw0.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $7HZmq.dynamicRequire)(module, "perf_hooks");
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $7HZmq.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $iHHw0.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = "none";
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = "timeOrigin";
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = "dateNow";
    return dateNow;
}();

});


parcelRegister("7mSNn", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", function () { return $55d517b6a811b3c0$export$48a8984ec0bf2e44; });
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $55d517b6a811b3c0$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === "undefined" ? true : __SENTRY_DEBUG__;

});

parcelRegister("l6Sat", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $f5e42d1fd59223df$export$775b6bb06e53a214; });
$parcel$export(module.exports, "addGlobalEventProcessor", function () { return $f5e42d1fd59223df$export$8e4e25f54d456511; });

var $l5MLt = parcelRequire("l5MLt");
parcelRequire("adAOX");
var $79aQT = parcelRequire("79aQT");
var $iHHw0 = parcelRequire("iHHw0");
var $7GcQw = parcelRequire("7GcQw");
var $8lVec = parcelRequire("8lVec");
/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */ var $f5e42d1fd59223df$var$MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var $f5e42d1fd59223df$export$775b6bb06e53a214 = /** @class */ function() {
    function Scope() {
        /** Flag if notifying is happening. */ this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */ this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */ this._eventProcessors = [];
        /** Array of breadcrumbs. */ this._breadcrumbs = [];
        /** User */ this._user = {};
        /** Tags */ this._tags = {};
        /** Extra */ this._extra = {};
        /** Contexts */ this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */ this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */ Scope.clone = function(scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0, $l5MLt.__spread)(scope._breadcrumbs);
            newScope._tags = (0, $l5MLt.__assign)({}, scope._tags);
            newScope._extra = (0, $l5MLt.__assign)({}, scope._extra);
            newScope._contexts = (0, $l5MLt.__assign)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0, $l5MLt.__spread)(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */ Scope.prototype.addScopeListener = function(callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addEventProcessor = function(callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setUser = function(user) {
        this._user = user || {};
        if (this._session) this._session.update({
            user: user
        });
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getUser = function() {
        return this._user;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getRequestSession = function() {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setRequestSession = function(requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTags = function(tags) {
        this._tags = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTag = function(key, value) {
        var _a;
        this._tags = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtras = function(extras) {
        this._extra = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtra = function(key, extra) {
        var _a;
        this._extra = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setFingerprint = function(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setLevel = function(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTransactionName = function(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */ Scope.prototype.setTransaction = function(name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setContext = function(key, context) {
        var _a;
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSpan = function(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSpan = function() {
        return this._span;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getTransaction = function() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSession = function(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSession = function() {
        return this._session;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.update = function(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === "function") {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._tags), captureContext._tags);
            this._extra = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._extra), captureContext._extra);
            this._contexts = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
        } else if ((0, $7GcQw.isPlainObject)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._tags), captureContext.tags);
            this._extra = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._extra), captureContext.extra);
            this._contexts = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
        }
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clear = function() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addBreadcrumb = function(breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === "number" ? Math.min(maxBreadcrumbs, $f5e42d1fd59223df$var$MAX_BREADCRUMBS) : $f5e42d1fd59223df$var$MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        var mergedBreadcrumb = (0, $l5MLt.__assign)({
            timestamp: (0, $79aQT.dateTimestampInSeconds)()
        }, breadcrumb);
        this._breadcrumbs = (0, $l5MLt.__spread)(this._breadcrumbs, [
            mergedBreadcrumb
        ]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clearBreadcrumbs = function() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */ Scope.prototype.applyToEvent = function(event, hint) {
        if (this._extra && Object.keys(this._extra).length) event.extra = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._extra), event.extra);
        if (this._tags && Object.keys(this._tags).length) event.tags = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._tags), event.tags);
        if (this._user && Object.keys(this._user).length) event.user = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._user), event.user);
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._contexts), event.contexts);
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = (0, $l5MLt.__assign)({
                trace: this._span.getTraceContext()
            }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) event.tags = (0, $l5MLt.__assign)({
                transaction: transactionName
            }, event.tags);
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0, $l5MLt.__spread)(event.breadcrumbs || [], this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors((0, $l5MLt.__spread)($f5e42d1fd59223df$var$getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */ Scope.prototype.setSDKProcessingMetadata = function(newData) {
        this._sdkProcessingMetadata = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */ Scope.prototype._notifyEventProcessors = function(processors, event, hint, index) {
        var _this = this;
        if (index === void 0) index = 0;
        return new (0, $8lVec.SyncPromise)(function(resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== "function") resolve(event);
            else {
                var result = processor((0, $l5MLt.__assign)({}, event), hint);
                if ((0, $7GcQw.isThenable)(result)) result.then(function(final) {
                    return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                }).then(null, reject);
                else _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    };
    /**
     * This will be called on every set call.
     */ Scope.prototype._notifyScopeListeners = function() {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function(callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */ Scope.prototype._applyFingerprint = function(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
            event.fingerprint
        ] : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    };
    return Scope;
}();
/**
 * Returns the global event processors.
 */ function $f5e42d1fd59223df$var$getGlobalEventProcessors() {
    return (0, $iHHw0.getGlobalSingleton)("globalEventProcessors", function() {
        return [];
    });
}
function $f5e42d1fd59223df$export$8e4e25f54d456511(callback) {
    $f5e42d1fd59223df$var$getGlobalEventProcessors().push(callback);
}

});

parcelRegister("jA7RW", function(module, exports) {

$parcel$export(module.exports, "Session", function () { return $e4177bb6586dac64$export$1fb4852a55678982; });
parcelRequire("adAOX");
var $kd4fD = parcelRequire("kd4fD");
var $79aQT = parcelRequire("79aQT");
var $iEupb = parcelRequire("iEupb");
/**
 * @inheritdoc
 */ var $e4177bb6586dac64$export$1fb4852a55678982 = /** @class */ function() {
    function Session(context) {
        this.errors = 0;
        this.sid = (0, $iEupb.uuid4)();
        this.duration = 0;
        this.status = "ok";
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = (0, $79aQT.timestampInSeconds)();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) this.update(context);
    }
    /** JSDoc */ // eslint-disable-next-line complexity
    Session.prototype.update = function(context) {
        if (context === void 0) context = {};
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) this.ipAddress = context.user.ip_address;
            if (!this.did && !context.did) this.did = context.user.id || context.user.email || context.user.username;
        }
        this.timestamp = context.timestamp || (0, $79aQT.timestampInSeconds)();
        if (context.ignoreDuration) this.ignoreDuration = context.ignoreDuration;
        if (context.sid) // Good enough uuid validation. — Kamil
        this.sid = context.sid.length === 32 ? context.sid : (0, $iEupb.uuid4)();
        if (context.init !== undefined) this.init = context.init;
        if (!this.did && context.did) this.did = "" + context.did;
        if (typeof context.started === "number") this.started = context.started;
        if (this.ignoreDuration) this.duration = undefined;
        else if (typeof context.duration === "number") this.duration = context.duration;
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) this.release = context.release;
        if (context.environment) this.environment = context.environment;
        if (!this.ipAddress && context.ipAddress) this.ipAddress = context.ipAddress;
        if (!this.userAgent && context.userAgent) this.userAgent = context.userAgent;
        if (typeof context.errors === "number") this.errors = context.errors;
        if (context.status) this.status = context.status;
    };
    /** JSDoc */ Session.prototype.close = function(status) {
        if (status) this.update({
            status: status
        });
        else if (this.status === "ok") this.update({
            status: "exited"
        });
        else this.update();
    };
    /** JSDoc */ Session.prototype.toJSON = function() {
        return (0, $kd4fD.dropUndefinedKeys)({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === "number" || typeof this.did === "string" ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent
            }
        });
    };
    return Session;
}();

});


parcelRegister("fNJax", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; }, function (v) { return isNodeEnv = v; });
$parcel$export(module.exports, "dynamicRequire", function () { return dynamicRequire; }, function (v) { return dynamicRequire = v; });
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $7zKa2 = parcelRequire("7zKa2");

var $8ovux = parcelRequire("8ovux");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $7zKa2.isBrowserBundle)() && Object.prototype.toString.call(typeof $8ovux !== "undefined" ? $8ovux : 0) === "[object process]";
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, "process").cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("7zKa2", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $583f9be4c07a0928$export$2928c40372e623c0; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $583f9be4c07a0928$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}

});


parcelRegister("i3ov7", function(module, exports) {

$parcel$export(module.exports, "Severity", function () { return $d24b8333678043ca$export$918a9776c0a3cf27; });
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */ var $d24b8333678043ca$export$918a9776c0a3cf27;
(function(Severity) {
    /** JSDoc */ Severity["Fatal"] = "fatal";
    /** JSDoc */ Severity["Error"] = "error";
    /** JSDoc */ Severity["Warning"] = "warning";
    /** JSDoc */ Severity["Log"] = "log";
    /** JSDoc */ Severity["Info"] = "info";
    /** JSDoc */ Severity["Debug"] = "debug";
    /** JSDoc */ Severity["Critical"] = "critical";
})($d24b8333678043ca$export$918a9776c0a3cf27 || ($d24b8333678043ca$export$918a9776c0a3cf27 = {}));
var $d24b8333678043ca$export$484b1ea9aec914c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug",
    "critical"
];

});

parcelRegister("b7FqB", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return dateTimestampInSeconds; }, function (v) { return dateTimestampInSeconds = v; });

var $fU0Yz = parcelRequire("fU0Yz");

var $fNJax = parcelRequire("fNJax");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $fU0Yz.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $fNJax.dynamicRequire)(module, "perf_hooks");
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $fNJax.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $fU0Yz.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = "none";
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = "timeOrigin";
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = "dateNow";
    return dateNow;
}();

});
parcelRegister("fU0Yz", function(module, exports) {

$parcel$export(module.exports, "getGlobalObject", function () { return $b93cd7c5c7d78ae3$export$256479dc0cea61c4; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $b93cd7c5c7d78ae3$export$7e223ec222791509; });
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $fNJax = parcelRequire("fNJax");
var $b93cd7c5c7d78ae3$var$fallbackGlobalObject = {};
function $b93cd7c5c7d78ae3$export$256479dc0cea61c4() {
    return (0, $fNJax.isNodeEnv)() ? $parcel$global : typeof window !== "undefined" // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== "undefined" ? self : $b93cd7c5c7d78ae3$var$fallbackGlobalObject;
}
function $b93cd7c5c7d78ae3$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $b93cd7c5c7d78ae3$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});


parcelRegister("7i9JW", function(module, exports) {

$parcel$export(module.exports, "BrowserClient", function () { return $54f1c506f1e0fcb4$export$1df9218a526d318d; });

var $l5MLt = parcelRequire("l5MLt");

var $8CA9n = parcelRequire("8CA9n");
var $cLshu = parcelRequire("cLshu");
parcelRequire("4TfCJ");
var $fU0Yz = parcelRequire("fU0Yz");
var $6uhZG = parcelRequire("6uhZG");

var $4ArnI = parcelRequire("4ArnI");

var $aNuE0 = parcelRequire("aNuE0");

var $aHBFP = parcelRequire("aHBFP");

var $6ZyCi = parcelRequire("6ZyCi");
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var $54f1c506f1e0fcb4$export$1df9218a526d318d = /** @class */ function(_super) {
    (0, $l5MLt.__extends)(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */ function BrowserClient(options) {
        if (options === void 0) options = {};
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: "sentry.javascript.browser",
            packages: [
                {
                    name: "npm:@sentry/browser",
                    version: (0, $cLshu.SDK_VERSION)
                }
            ],
            version: (0, $cLshu.SDK_VERSION)
        };
        _this = _super.call(this, (0, $4ArnI.BrowserBackend), options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */ BrowserClient.prototype.showReportDialog = function(options) {
        if (options === void 0) options = {};
        // doesn't work without a document (React Native)
        var document = (0, $fU0Yz.getGlobalObject)().document;
        if (!document) return;
        if (!this._isEnabled()) {
            (0, $aNuE0.IS_DEBUG_BUILD) && (0, $6uhZG.logger).error("Trying to call showReportDialog with Sentry Client disabled");
            return;
        }
        (0, $aHBFP.injectReportDialog)((0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, options), {
            dsn: options.dsn || this.getDsn()
        }));
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._prepareEvent = function(event, scope, hint) {
        event.platform = event.platform || "javascript";
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._sendEvent = function(event) {
        var integration = this.getIntegration((0, $6ZyCi.Breadcrumbs));
        if (integration) integration.addSentryBreadcrumb(event);
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}((0, $8CA9n.BaseClient));

});
parcelRegister("8CA9n", function(module, exports) {

$parcel$export(module.exports, "BaseClient", function () { return $646dea073f37d8c1$export$4f22f74eddb7716a; });

var $l5MLt = parcelRequire("l5MLt");

var $l6Sat = parcelRequire("l6Sat");
parcelRequire("4TfCJ");
var $49X0E = parcelRequire("49X0E");
var $b7FqB = parcelRequire("b7FqB");
var $7CXdk = parcelRequire("7CXdk");
var $6uhZG = parcelRequire("6uhZG");
var $d9nst = parcelRequire("d9nst");
var $8I7eB = parcelRequire("8I7eB");
var $eFWdY = parcelRequire("eFWdY");
var $7B1Bh = parcelRequire("7B1Bh");
var $5Q0pQ = parcelRequire("5Q0pQ");

var $cNRiV = parcelRequire("cNRiV");

var $j7nMo = parcelRequire("j7nMo");
var $646dea073f37d8c1$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */ var $646dea073f37d8c1$export$4f22f74eddb7716a = /** @class */ function() {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */ function BaseClient(backendClass, options) {
        /** Array of used integrations. */ this._integrations = {};
        /** Number of calls being processed */ this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) this._dsn = (0, $d9nst.makeDsn)(options.dsn);
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function(exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if ((0, $49X0E.checkOrSetAlreadyCaught)(exception)) {
            (0, $cNRiV.IS_DEBUG_BUILD) && (0, $6uhZG.logger).log($646dea073f37d8c1$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend().eventFromException(exception, hint).then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureMessage = function(message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = (0, $7CXdk.isPrimitive)(message) ? this._getBackend().eventFromMessage(String(message), level, hint) : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent.then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureEvent = function(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $49X0E.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $cNRiV.IS_DEBUG_BUILD) && (0, $6uhZG.logger).log($646dea073f37d8c1$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureSession = function(session) {
        if (!this._isEnabled()) {
            (0, $cNRiV.IS_DEBUG_BUILD) && (0, $6uhZG.logger).warn("SDK not enabled, will not capture session.");
            return;
        }
        if (!(typeof session.release === "string")) (0, $cNRiV.IS_DEBUG_BUILD) && (0, $6uhZG.logger).warn("Discarded session because of missing or non-string release");
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({
                init: false
            });
        }
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getDsn = function() {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getOptions = function() {
        return this._options;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getTransport = function() {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.flush = function(timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
            return _this.getTransport().close(timeout).then(function(transportFlushed) {
                return clientFinished && transportFlushed;
            });
        });
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.close = function(timeout) {
        var _this = this;
        return this.flush(timeout).then(function(result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */ BaseClient.prototype.setupIntegrations = function() {
        if (this._isEnabled() && !this._integrations.initialized) this._integrations = (0, $j7nMo.setupIntegrations)(this._options);
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getIntegration = function(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $cNRiV.IS_DEBUG_BUILD) && (0, $6uhZG.logger).warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */ BaseClient.prototype._updateSessionFromEvent = function(session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for(var exceptions_1 = (0, $l5MLt.__values)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()){
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === "ok";
        var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            session.update((0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, crashed && {
                status: "crashed"
            }), {
                errors: session.errors || Number(errored || crashed)
            }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */ BaseClient.prototype._sendSession = function(session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */ BaseClient.prototype._isClientDoneProcessing = function(timeout) {
        var _this = this;
        return new (0, $eFWdY.SyncPromise)(function(resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function() {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */ BaseClient.prototype._getBackend = function() {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ BaseClient.prototype._isEnabled = function() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */ BaseClient.prototype._prepareEvent = function(event, scope, hint) {
        var _this = this;
        var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
        var prepared = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, event), {
            event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0, $49X0E.uuid4)()),
            timestamp: event.timestamp || (0, $b7FqB.dateTimestampInSeconds)()
        });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) finalScope = (0, $l6Sat.Scope).clone(finalScope).update(hint.captureContext);
        // We prepare the result here with a resolved Event.
        var result = (0, $eFWdY.resolvedSyncPromise)(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
        return result.then(function(evt) {
            if (evt) // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
            // it is only attached as extra data to the event if the event somehow skips being normalized
            evt.sdkProcessingMetadata = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, evt.sdkProcessingMetadata), {
                normalizeDepth: (0, $8I7eB.normalize)(normalizeDepth) + " (" + typeof normalizeDepth + ")"
            });
            if (typeof normalizeDepth === "number" && normalizeDepth > 0) return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */ BaseClient.prototype._normalizeEvent = function(event, depth, maxBreadth) {
        if (!event) return null;
        var normalized = (0, $l5MLt.__assign)((0, $l5MLt.__assign)((0, $l5MLt.__assign)((0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, event), event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function(b) {
                return (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, b), b.data && {
                    data: (0, $8I7eB.normalize)(b.data, depth, maxBreadth)
                });
            })
        }), event.user && {
            user: (0, $8I7eB.normalize)(event.user, depth, maxBreadth)
        }), event.contexts && {
            contexts: (0, $8I7eB.normalize)(event.contexts, depth, maxBreadth)
        }), event.extra && {
            extra: (0, $8I7eB.normalize)(event.extra, depth, maxBreadth)
        });
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        normalized.contexts.trace = event.contexts.trace;
        normalized.sdkProcessingMetadata = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, normalized.sdkProcessingMetadata), {
            baseClientNormalized: true
        });
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */ BaseClient.prototype._applyClientOptions = function(event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!("environment" in event)) event.environment = "environment" in options ? environment : "production";
        if (event.release === undefined && release !== undefined) event.release = release;
        if (event.dist === undefined && dist !== undefined) event.dist = dist;
        if (event.message) event.message = (0, $5Q0pQ.truncate)(event.message, maxValueLength);
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) exception.value = (0, $5Q0pQ.truncate)(exception.value, maxValueLength);
        var request = event.request;
        if (request && request.url) request.url = (0, $5Q0pQ.truncate)(request.url, maxValueLength);
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */ BaseClient.prototype._applyIntegrationsMetadata = function(event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = (0, $l5MLt.__spread)(event.sdk.integrations || [], integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */ BaseClient.prototype._sendEvent = function(event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */ BaseClient.prototype._captureEvent = function(event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function(finalEvent) {
            return finalEvent.event_id;
        }, function(reason) {
            (0, $cNRiV.IS_DEBUG_BUILD) && (0, $6uhZG.logger).error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */ BaseClient.prototype._processEvent = function(event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        var transport = this.getTransport();
        function recordLostEvent(outcome, category) {
            if (transport.recordLostEvent) transport.recordLostEvent(outcome, category);
        }
        if (!this._isEnabled()) return (0, $eFWdY.rejectedSyncPromise)(new (0, $7B1Bh.SentryError)("SDK not enabled, will not capture event."));
        var isTransaction = event.type === "transaction";
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === "number" && Math.random() > sampleRate) {
            recordLostEvent("sample_rate", "event");
            return (0, $eFWdY.rejectedSyncPromise)(new (0, $7B1Bh.SentryError)("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint).then(function(prepared) {
            if (prepared === null) {
                recordLostEvent("event_processor", event.type || "event");
                throw new (0, $7B1Bh.SentryError)("An event processor returned null, will not send event.");
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) return prepared;
            var beforeSendResult = beforeSend(prepared, hint);
            return $646dea073f37d8c1$var$_ensureBeforeSendRv(beforeSendResult);
        }).then(function(processedEvent) {
            if (processedEvent === null) {
                recordLostEvent("before_send", event.type || "event");
                throw new (0, $7B1Bh.SentryError)("`beforeSend` returned `null`, will not send event.");
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) _this._updateSessionFromEvent(session, processedEvent);
            _this._sendEvent(processedEvent);
            return processedEvent;
        }).then(null, function(reason) {
            if (reason instanceof (0, $7B1Bh.SentryError)) throw reason;
            _this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $7B1Bh.SentryError)("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */ BaseClient.prototype._process = function(promise) {
        var _this = this;
        this._numProcessing += 1;
        promise.then(function(value) {
            _this._numProcessing -= 1;
            return value;
        }, function(reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */ function $646dea073f37d8c1$var$_ensureBeforeSendRv(rv) {
    var nullErr = "`beforeSend` method has to return `null` or a valid event.";
    if ((0, $7CXdk.isThenable)(rv)) return rv.then(function(event) {
        if (!((0, $7CXdk.isPlainObject)(event) || event === null)) throw new (0, $7B1Bh.SentryError)(nullErr);
        return event;
    }, function(e) {
        throw new (0, $7B1Bh.SentryError)("beforeSend rejected with " + e);
    });
    else if (!((0, $7CXdk.isPlainObject)(rv) || rv === null)) throw new (0, $7B1Bh.SentryError)(nullErr);
    return rv;
}

});
parcelRegister("4TfCJ", function(module, exports) {
$parcel$export(module.exports, "forget", function () { return (parcelRequire("2LYxa")).forget; });
$parcel$export(module.exports, "getLocationHref", function () { return (parcelRequire("hPLeT")).getLocationHref; });
$parcel$export(module.exports, "htmlTreeAsString", function () { return (parcelRequire("hPLeT")).htmlTreeAsString; });
$parcel$export(module.exports, "dsnToString", function () { return (parcelRequire("d9nst")).dsnToString; });
$parcel$export(module.exports, "makeDsn", function () { return (parcelRequire("d9nst")).makeDsn; });
$parcel$export(module.exports, "SentryError", function () { return (parcelRequire("7B1Bh")).SentryError; });
$parcel$export(module.exports, "getGlobalObject", function () { return (parcelRequire("fU0Yz")).getGlobalObject; });
$parcel$export(module.exports, "addInstrumentationHandler", function () { return (parcelRequire("fMu7V")).addInstrumentationHandler; });
$parcel$export(module.exports, "isDOMError", function () { return (parcelRequire("7CXdk")).isDOMError; });
$parcel$export(module.exports, "isDOMException", function () { return (parcelRequire("7CXdk")).isDOMException; });
$parcel$export(module.exports, "isError", function () { return (parcelRequire("7CXdk")).isError; });
$parcel$export(module.exports, "isErrorEvent", function () { return (parcelRequire("7CXdk")).isErrorEvent; });
$parcel$export(module.exports, "isEvent", function () { return (parcelRequire("7CXdk")).isEvent; });
$parcel$export(module.exports, "isInstanceOf", function () { return (parcelRequire("7CXdk")).isInstanceOf; });
$parcel$export(module.exports, "isPlainObject", function () { return (parcelRequire("7CXdk")).isPlainObject; });
$parcel$export(module.exports, "isPrimitive", function () { return (parcelRequire("7CXdk")).isPrimitive; });
$parcel$export(module.exports, "isString", function () { return (parcelRequire("7CXdk")).isString; });
$parcel$export(module.exports, "isThenable", function () { return (parcelRequire("7CXdk")).isThenable; });
$parcel$export(module.exports, "logger", function () { return (parcelRequire("6uhZG")).logger; });
$parcel$export(module.exports, "addExceptionMechanism", function () { return (parcelRequire("49X0E")).addExceptionMechanism; });
$parcel$export(module.exports, "addExceptionTypeValue", function () { return (parcelRequire("49X0E")).addExceptionTypeValue; });
$parcel$export(module.exports, "checkOrSetAlreadyCaught", function () { return (parcelRequire("49X0E")).checkOrSetAlreadyCaught; });
$parcel$export(module.exports, "getEventDescription", function () { return (parcelRequire("49X0E")).getEventDescription; });
$parcel$export(module.exports, "parseUrl", function () { return (parcelRequire("49X0E")).parseUrl; });
$parcel$export(module.exports, "uuid4", function () { return (parcelRequire("49X0E")).uuid4; });
$parcel$export(module.exports, "normalize", function () { return (parcelRequire("8I7eB")).normalize; });
$parcel$export(module.exports, "normalizeToSize", function () { return (parcelRequire("8I7eB")).normalizeToSize; });
$parcel$export(module.exports, "addNonEnumerableProperty", function () { return (parcelRequire("QXRHa")).addNonEnumerableProperty; });
$parcel$export(module.exports, "extractExceptionKeysForMessage", function () { return (parcelRequire("QXRHa")).extractExceptionKeysForMessage; });
$parcel$export(module.exports, "fill", function () { return (parcelRequire("QXRHa")).fill; });
$parcel$export(module.exports, "getOriginalFunction", function () { return (parcelRequire("QXRHa")).getOriginalFunction; });
$parcel$export(module.exports, "markFunctionWrapped", function () { return (parcelRequire("QXRHa")).markFunctionWrapped; });
$parcel$export(module.exports, "urlEncode", function () { return (parcelRequire("QXRHa")).urlEncode; });
$parcel$export(module.exports, "makePromiseBuffer", function () { return (parcelRequire("3UOOR")).makePromiseBuffer; });
$parcel$export(module.exports, "severityFromString", function () { return (parcelRequire("1s3gX")).severityFromString; });
$parcel$export(module.exports, "createStackParser", function () { return (parcelRequire("7sb6o")).createStackParser; });
$parcel$export(module.exports, "getFunctionName", function () { return (parcelRequire("7sb6o")).getFunctionName; });
$parcel$export(module.exports, "eventStatusFromHttpCode", function () { return (parcelRequire("jIt7f")).eventStatusFromHttpCode; });
$parcel$export(module.exports, "isMatchingPattern", function () { return (parcelRequire("5Q0pQ")).isMatchingPattern; });
$parcel$export(module.exports, "safeJoin", function () { return (parcelRequire("5Q0pQ")).safeJoin; });
$parcel$export(module.exports, "truncate", function () { return (parcelRequire("5Q0pQ")).truncate; });
$parcel$export(module.exports, "isNativeFetch", function () { return (parcelRequire("jAd8t")).isNativeFetch; });
$parcel$export(module.exports, "supportsFetch", function () { return (parcelRequire("jAd8t")).supportsFetch; });
$parcel$export(module.exports, "supportsReferrerPolicy", function () { return (parcelRequire("jAd8t")).supportsReferrerPolicy; });
$parcel$export(module.exports, "rejectedSyncPromise", function () { return (parcelRequire("eFWdY")).rejectedSyncPromise; });
$parcel$export(module.exports, "resolvedSyncPromise", function () { return (parcelRequire("eFWdY")).resolvedSyncPromise; });
$parcel$export(module.exports, "SyncPromise", function () { return (parcelRequire("eFWdY")).SyncPromise; });
$parcel$export(module.exports, "createEnvelope", function () { return (parcelRequire("6MTdb")).createEnvelope; });
$parcel$export(module.exports, "getEnvelopeType", function () { return (parcelRequire("6MTdb")).getEnvelopeType; });
$parcel$export(module.exports, "serializeEnvelope", function () { return (parcelRequire("6MTdb")).serializeEnvelope; });
$parcel$export(module.exports, "createClientReportEnvelope", function () { return (parcelRequire("9bKWg")).createClientReportEnvelope; });
$parcel$export(module.exports, "disabledUntil", function () { return (parcelRequire("6n6df")).disabledUntil; });
$parcel$export(module.exports, "isRateLimited", function () { return (parcelRequire("6n6df")).isRateLimited; });
$parcel$export(module.exports, "updateRateLimits", function () { return (parcelRequire("6n6df")).updateRateLimits; });
parcelRequire("2LYxa");
parcelRequire("hPLeT");
parcelRequire("d9nst");

parcelRequire("7B1Bh");
parcelRequire("fU0Yz");
parcelRequire("fMu7V");
parcelRequire("7CXdk");
parcelRequire("6uhZG");

parcelRequire("49X0E");

var $fNJax = parcelRequire("fNJax");
parcelRequire("8I7eB");
parcelRequire("QXRHa");

parcelRequire("3UOOR");
parcelRequire("1s3gX");
parcelRequire("7sb6o");
parcelRequire("jIt7f");
parcelRequire("5Q0pQ");
parcelRequire("jAd8t");
parcelRequire("eFWdY");

var $b7FqB = parcelRequire("b7FqB");


parcelRequire("6MTdb");
parcelRequire("9bKWg");
parcelRequire("6n6df");
$parcel$exportWildcard(module.exports, $fNJax);
$parcel$exportWildcard(module.exports, $b7FqB);

});
parcelRegister("2LYxa", function(module, exports) {

$parcel$export(module.exports, "forget", function () { return $204eed59c330a631$export$93c25f2590a5b540; });
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $204eed59c330a631$export$93c25f2590a5b540(promise) {
    promise.then(null, function(e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}

});

parcelRegister("hPLeT", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $cfbbd7cb5d6dbda7$export$5647df6b7814ac86; });
$parcel$export(module.exports, "getLocationHref", function () { return $cfbbd7cb5d6dbda7$export$1cfafeee2987818b; });

var $fU0Yz = parcelRequire("fU0Yz");

var $7CXdk = parcelRequire("7CXdk");
function $cfbbd7cb5d6dbda7$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = " > ";
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $cfbbd7cb5d6dbda7$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $cfbbd7cb5d6dbda7$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return "";
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + '="' + keyAttrPair[1] + '"]');
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $7CXdk.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + '="' + attr + '"]');
    }
    return out.join("");
}
function $cfbbd7cb5d6dbda7$export$1cfafeee2987818b() {
    var global = (0, $fU0Yz.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return "";
    }
}

});
parcelRegister("7CXdk", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $58da03adb8b2d734$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $58da03adb8b2d734$export$49034edbe6b62415; });
$parcel$export(module.exports, "isErrorEvent", function () { return $58da03adb8b2d734$export$9f9636d330b71954; });
$parcel$export(module.exports, "isDOMError", function () { return $58da03adb8b2d734$export$ef9e2056653f0c8e; });
$parcel$export(module.exports, "isDOMException", function () { return $58da03adb8b2d734$export$12e869b2a583f783; });
$parcel$export(module.exports, "isString", function () { return $58da03adb8b2d734$export$844ec244b1367d54; });
$parcel$export(module.exports, "isPrimitive", function () { return $58da03adb8b2d734$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $58da03adb8b2d734$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $58da03adb8b2d734$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $58da03adb8b2d734$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $58da03adb8b2d734$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $58da03adb8b2d734$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $58da03adb8b2d734$export$bc2894c7158efbac; });
$parcel$export(module.exports, "isNaN", function () { return $58da03adb8b2d734$export$c9f5652083b8129d; });
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $58da03adb8b2d734$var$objectToString = Object.prototype.toString;
function $58da03adb8b2d734$export$e6127cc7fe7395c3(wat) {
    switch($58da03adb8b2d734$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $58da03adb8b2d734$export$49034edbe6b62415(wat, Error);
    }
}
function $58da03adb8b2d734$var$isBuiltin(wat, ty) {
    return $58da03adb8b2d734$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $58da03adb8b2d734$export$9f9636d330b71954(wat) {
    return $58da03adb8b2d734$var$isBuiltin(wat, "ErrorEvent");
}
function $58da03adb8b2d734$export$ef9e2056653f0c8e(wat) {
    return $58da03adb8b2d734$var$isBuiltin(wat, "DOMError");
}
function $58da03adb8b2d734$export$12e869b2a583f783(wat) {
    return $58da03adb8b2d734$var$isBuiltin(wat, "DOMException");
}
function $58da03adb8b2d734$export$844ec244b1367d54(wat) {
    return $58da03adb8b2d734$var$isBuiltin(wat, "String");
}
function $58da03adb8b2d734$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== "object" && typeof wat !== "function";
}
function $58da03adb8b2d734$export$53b83ca8eaab0383(wat) {
    return $58da03adb8b2d734$var$isBuiltin(wat, "Object");
}
function $58da03adb8b2d734$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $58da03adb8b2d734$export$49034edbe6b62415(wat, Event);
}
function $58da03adb8b2d734$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $58da03adb8b2d734$export$49034edbe6b62415(wat, Element);
}
function $58da03adb8b2d734$export$49841c62b9eff15(wat) {
    return $58da03adb8b2d734$var$isBuiltin(wat, "RegExp");
}
function $58da03adb8b2d734$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
function $58da03adb8b2d734$export$bc2894c7158efbac(wat) {
    return $58da03adb8b2d734$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $58da03adb8b2d734$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
function $58da03adb8b2d734$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});


parcelRegister("d9nst", function(module, exports) {

$parcel$export(module.exports, "dsnToString", function () { return $992e4ff0f4b01026$export$44d472fbb931a776; });
$parcel$export(module.exports, "makeDsn", function () { return $992e4ff0f4b01026$export$128827c3562ec0cb; });

var $l5MLt = parcelRequire("l5MLt");

var $7B1Bh = parcelRequire("7B1Bh");

var $411pt = parcelRequire("411pt");
/** Regular expression used to parse a Dsn. */ var $992e4ff0f4b01026$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $992e4ff0f4b01026$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
function $992e4ff0f4b01026$export$44d472fbb931a776(dsn, withPassword) {
    if (withPassword === void 0) withPassword = false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : "") + ("@" + host + (port ? ":" + port : "") + "/" + (path ? path + "/" : path) + projectId);
}
function $992e4ff0f4b01026$var$dsnFromString(str) {
    var match = $992e4ff0f4b01026$var$DSN_REGEX.exec(str);
    if (!match) throw new (0, $7B1Bh.SentryError)("Invalid Sentry Dsn: " + str);
    var _a = (0, $l5MLt.__read)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? "" : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? "" : _c, lastPath = _a[5];
    var path = "";
    var projectId = lastPath;
    var split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $992e4ff0f4b01026$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $992e4ff0f4b01026$var$dsnFromComponents(components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ("user" in components && !("publicKey" in components)) components.publicKey = components.user;
    return {
        user: components.publicKey || "",
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $992e4ff0f4b01026$var$validateDsn(dsn) {
    if (!(0, $411pt.IS_DEBUG_BUILD)) return;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    requiredComponents.forEach(function(component) {
        if (!dsn[component]) throw new (0, $7B1Bh.SentryError)("Invalid Sentry Dsn: " + component + " missing");
    });
    if (!projectId.match(/^\d+$/)) throw new (0, $7B1Bh.SentryError)("Invalid Sentry Dsn: Invalid projectId " + projectId);
    if (!$992e4ff0f4b01026$var$isValidProtocol(protocol)) throw new (0, $7B1Bh.SentryError)("Invalid Sentry Dsn: Invalid protocol " + protocol);
    if (port && isNaN(parseInt(port, 10))) throw new (0, $7B1Bh.SentryError)("Invalid Sentry Dsn: Invalid port " + port);
    return true;
}
function $992e4ff0f4b01026$export$128827c3562ec0cb(from) {
    var components = typeof from === "string" ? $992e4ff0f4b01026$var$dsnFromString(from) : $992e4ff0f4b01026$var$dsnFromComponents(from);
    $992e4ff0f4b01026$var$validateDsn(components);
    return components;
}

});
parcelRegister("7B1Bh", function(module, exports) {

$parcel$export(module.exports, "SentryError", function () { return $587d3ade6ca671a8$export$5949942ba2a7c0e2; });

var $l5MLt = parcelRequire("l5MLt");

var $2ysBb = parcelRequire("2ysBb");
/** An error emitted by Sentry SDKs and related utilities. */ var $587d3ade6ca671a8$export$5949942ba2a7c0e2 = /** @class */ function(_super) {
    (0, $l5MLt.__extends)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        (0, $2ysBb.setPrototypeOf)(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error);

});
parcelRegister("2ysBb", function(module, exports) {

$parcel$export(module.exports, "setPrototypeOf", function () { return $1dc4f0d62679b49a$export$1cb0d91350beb6cc; });
var $1dc4f0d62679b49a$export$1cb0d91350beb6cc = Object.setPrototypeOf || (({
    __proto__: []
}) instanceof Array ? $1dc4f0d62679b49a$var$setProtoOf : $1dc4f0d62679b49a$var$mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $1dc4f0d62679b49a$var$setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $1dc4f0d62679b49a$var$mixinProperties(obj, proto) {
    for(var prop in proto)if (!Object.prototype.hasOwnProperty.call(obj, prop)) // @ts-ignore typescript complains about indexing so we remove
    obj[prop] = proto[prop];
    return obj;
}

});


parcelRegister("411pt", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", function () { return $2ec859621be4bd1f$export$48a8984ec0bf2e44; });
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $2ec859621be4bd1f$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === "undefined" ? true : __SENTRY_DEBUG__;

});


parcelRegister("fMu7V", function(module, exports) {

$parcel$export(module.exports, "addInstrumentationHandler", function () { return $b7d2b546a83171c6$export$285b9172a3741fb7; });

var $l5MLt = parcelRequire("l5MLt");

var $411pt = parcelRequire("411pt");

var $fU0Yz = parcelRequire("fU0Yz");

var $7CXdk = parcelRequire("7CXdk");

var $6uhZG = parcelRequire("6uhZG");

var $QXRHa = parcelRequire("QXRHa");

var $7sb6o = parcelRequire("7sb6o");

var $jAd8t = parcelRequire("jAd8t");
var $b7d2b546a83171c6$var$global = (0, $fU0Yz.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ var $b7d2b546a83171c6$var$handlers = {};
var $b7d2b546a83171c6$var$instrumented = {};
/** Instruments given API */ function $b7d2b546a83171c6$var$instrument(type) {
    if ($b7d2b546a83171c6$var$instrumented[type]) return;
    $b7d2b546a83171c6$var$instrumented[type] = true;
    switch(type){
        case "console":
            $b7d2b546a83171c6$var$instrumentConsole();
            break;
        case "dom":
            $b7d2b546a83171c6$var$instrumentDOM();
            break;
        case "xhr":
            $b7d2b546a83171c6$var$instrumentXHR();
            break;
        case "fetch":
            $b7d2b546a83171c6$var$instrumentFetch();
            break;
        case "history":
            $b7d2b546a83171c6$var$instrumentHistory();
            break;
        case "error":
            $b7d2b546a83171c6$var$instrumentError();
            break;
        case "unhandledrejection":
            $b7d2b546a83171c6$var$instrumentUnhandledRejection();
            break;
        default:
            (0, $411pt.IS_DEBUG_BUILD) && (0, $6uhZG.logger).warn("unknown instrumentation type:", type);
            return;
    }
}
function $b7d2b546a83171c6$export$285b9172a3741fb7(type, callback) {
    $b7d2b546a83171c6$var$handlers[type] = $b7d2b546a83171c6$var$handlers[type] || [];
    $b7d2b546a83171c6$var$handlers[type].push(callback);
    $b7d2b546a83171c6$var$instrument(type);
}
/** JSDoc */ function $b7d2b546a83171c6$var$triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !$b7d2b546a83171c6$var$handlers[type]) return;
    try {
        for(var _b = (0, $l5MLt.__values)($b7d2b546a83171c6$var$handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()){
            var handler = _c.value;
            try {
                handler(data);
            } catch (e) {
                (0, $411pt.IS_DEBUG_BUILD) && (0, $6uhZG.logger).error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0, $7sb6o.getFunctionName)(handler) + "\nError:", e);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/** JSDoc */ function $b7d2b546a83171c6$var$instrumentConsole() {
    if (!("console" in $b7d2b546a83171c6$var$global)) return;
    (0, $6uhZG.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in $b7d2b546a83171c6$var$global.console)) return;
        (0, $QXRHa.fill)($b7d2b546a83171c6$var$global.console, level, function(originalConsoleMethod) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                $b7d2b546a83171c6$var$triggerHandlers("console", {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($b7d2b546a83171c6$var$global.console, args);
            };
        });
    });
}
/** JSDoc */ function $b7d2b546a83171c6$var$instrumentFetch() {
    if (!(0, $jAd8t.supportsNativeFetch)()) return;
    (0, $QXRHa.fill)($b7d2b546a83171c6$var$global, "fetch", function(originalFetch) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var handlerData = {
                args: args,
                fetchData: {
                    method: $b7d2b546a83171c6$var$getFetchMethod(args),
                    url: $b7d2b546a83171c6$var$getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            $b7d2b546a83171c6$var$triggerHandlers("fetch", (0, $l5MLt.__assign)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($b7d2b546a83171c6$var$global, args).then(function(response) {
                $b7d2b546a83171c6$var$triggerHandlers("fetch", (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                }));
                return response;
            }, function(error) {
                $b7d2b546a83171c6$var$triggerHandlers("fetch", (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Extract `method` from fetch call arguments */ function $b7d2b546a83171c6$var$getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if ("Request" in $b7d2b546a83171c6$var$global && (0, $7CXdk.isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return "GET";
}
/** Extract `url` from fetch call arguments */ function $b7d2b546a83171c6$var$getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if (typeof fetchArgs[0] === "string") return fetchArgs[0];
    if ("Request" in $b7d2b546a83171c6$var$global && (0, $7CXdk.isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */ /** JSDoc */ function $b7d2b546a83171c6$var$instrumentXHR() {
    if (!("XMLHttpRequest" in $b7d2b546a83171c6$var$global)) return;
    var xhrproto = XMLHttpRequest.prototype;
    (0, $QXRHa.fill)(xhrproto, "open", function(originalOpen) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $7CXdk.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $7CXdk.isString)(url) && xhrInfo.method === "POST" && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    $b7d2b546a83171c6$var$triggerHandlers("xhr", {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ("onreadystatechange" in xhr && typeof xhr.onreadystatechange === "function") (0, $QXRHa.fill)(xhr, "onreadystatechange", function(original) {
                return function() {
                    var readyStateArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)readyStateArgs[_i] = arguments[_i];
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener("readystatechange", onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, $QXRHa.fill)(xhrproto, "send", function(originalSend) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
            $b7d2b546a83171c6$var$triggerHandlers("xhr", {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
var $b7d2b546a83171c6$var$lastHref;
/** JSDoc */ function $b7d2b546a83171c6$var$instrumentHistory() {
    if (!(0, $jAd8t.supportsHistory)()) return;
    var oldOnPopState = $b7d2b546a83171c6$var$global.onpopstate;
    $b7d2b546a83171c6$var$global.onpopstate = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var to = $b7d2b546a83171c6$var$global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = $b7d2b546a83171c6$var$lastHref;
        $b7d2b546a83171c6$var$lastHref = to;
        $b7d2b546a83171c6$var$triggerHandlers("history", {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = $b7d2b546a83171c6$var$lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $b7d2b546a83171c6$var$lastHref = to;
                $b7d2b546a83171c6$var$triggerHandlers("history", {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $QXRHa.fill)($b7d2b546a83171c6$var$global.history, "pushState", historyReplacementFunction);
    (0, $QXRHa.fill)($b7d2b546a83171c6$var$global.history, "replaceState", historyReplacementFunction);
}
var $b7d2b546a83171c6$var$debounceDuration = 1000;
var $b7d2b546a83171c6$var$debounceTimerID;
var $b7d2b546a83171c6$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $b7d2b546a83171c6$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $b7d2b546a83171c6$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== "keypress") return false;
    try {
        var target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $b7d2b546a83171c6$var$makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) globalListener = false;
    return function(event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $b7d2b546a83171c6$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($b7d2b546a83171c6$var$shouldSkipDOMEvent(event)) return;
        var name = event.type === "keypress" ? "input" : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($b7d2b546a83171c6$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $b7d2b546a83171c6$var$lastCapturedEvent = event;
        } else if ($b7d2b546a83171c6$var$shouldShortcircuitPreviousDebounce($b7d2b546a83171c6$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $b7d2b546a83171c6$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($b7d2b546a83171c6$var$debounceTimerID);
        $b7d2b546a83171c6$var$debounceTimerID = $b7d2b546a83171c6$var$global.setTimeout(function() {
            $b7d2b546a83171c6$var$debounceTimerID = undefined;
        }, $b7d2b546a83171c6$var$debounceDuration);
    };
}
/** JSDoc */ function $b7d2b546a83171c6$var$instrumentDOM() {
    if (!("document" in $b7d2b546a83171c6$var$global)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = $b7d2b546a83171c6$var$triggerHandlers.bind(null, "dom");
    var globalDOMEventHandler = $b7d2b546a83171c6$var$makeDOMEventHandler(triggerDOMHandler, true);
    $b7d2b546a83171c6$var$global.document.addEventListener("click", globalDOMEventHandler, false);
    $b7d2b546a83171c6$var$global.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach(function(target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = $b7d2b546a83171c6$var$global[target] && $b7d2b546a83171c6$var$global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $QXRHa.fill)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    var el = this;
                    var handlers_1 = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_1[type] = handlers_1[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        var handler = $b7d2b546a83171c6$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount += 1;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $QXRHa.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    var el = this;
                    var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_2[type];
                    if (handlerForType) {
                        handlerForType.refCount -= 1;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers_2).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var $b7d2b546a83171c6$var$_oldOnErrorHandler = null;
/** JSDoc */ function $b7d2b546a83171c6$var$instrumentError() {
    $b7d2b546a83171c6$var$_oldOnErrorHandler = $b7d2b546a83171c6$var$global.onerror;
    $b7d2b546a83171c6$var$global.onerror = function(msg, url, line, column, error) {
        $b7d2b546a83171c6$var$triggerHandlers("error", {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($b7d2b546a83171c6$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $b7d2b546a83171c6$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
var $b7d2b546a83171c6$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $b7d2b546a83171c6$var$instrumentUnhandledRejection() {
    $b7d2b546a83171c6$var$_oldOnUnhandledRejectionHandler = $b7d2b546a83171c6$var$global.onunhandledrejection;
    $b7d2b546a83171c6$var$global.onunhandledrejection = function(e) {
        $b7d2b546a83171c6$var$triggerHandlers("unhandledrejection", e);
        if ($b7d2b546a83171c6$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $b7d2b546a83171c6$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
}

});
parcelRegister("6uhZG", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", function () { return $4b9380a6759960bc$export$2a2b1d2252a69ecb; });
$parcel$export(module.exports, "logger", function () { return $4b9380a6759960bc$export$af88d00dbe7f521; });

var $l5MLt = parcelRequire("l5MLt");

var $411pt = parcelRequire("411pt");

var $fU0Yz = parcelRequire("fU0Yz");
// TODO: Implement different loggers for different environments
var $4b9380a6759960bc$var$global = (0, $fU0Yz.getGlobalObject)();
/** Prefix for logging strings */ var $4b9380a6759960bc$var$PREFIX = "Sentry Logger ";
var $4b9380a6759960bc$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert"
];
function $4b9380a6759960bc$export$cda52e2a8927a2ca(callback) {
    var global = (0, $fU0Yz.getGlobalObject)();
    if (!("console" in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $4b9380a6759960bc$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $4b9380a6759960bc$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $411pt.IS_DEBUG_BUILD) $4b9380a6759960bc$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $4b9380a6759960bc$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $4b9380a6759960bc$var$global.console)[name].apply(_a, (0, $l5MLt.__spread)([
                    $4b9380a6759960bc$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $4b9380a6759960bc$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $4b9380a6759960bc$export$af88d00dbe7f521;
if (0, $411pt.IS_DEBUG_BUILD) $4b9380a6759960bc$export$af88d00dbe7f521 = (0, $fU0Yz.getGlobalSingleton)("logger", $4b9380a6759960bc$var$makeLogger);
else $4b9380a6759960bc$export$af88d00dbe7f521 = $4b9380a6759960bc$var$makeLogger();

});

parcelRegister("QXRHa", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $09f34b6558e96c97$export$9563e054e6f787fb; });
$parcel$export(module.exports, "markFunctionWrapped", function () { return $09f34b6558e96c97$export$5c1499e2e5d010ae; });
$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $09f34b6558e96c97$export$e73679ffaf56810e; });
$parcel$export(module.exports, "getOriginalFunction", function () { return $09f34b6558e96c97$export$e6cc1e135e2092e5; });
$parcel$export(module.exports, "urlEncode", function () { return $09f34b6558e96c97$export$9ef804feabbcbaf1; });
$parcel$export(module.exports, "convertToPlainObject", function () { return $09f34b6558e96c97$export$62ff257738bf57f5; });
$parcel$export(module.exports, "extractExceptionKeysForMessage", function () { return $09f34b6558e96c97$export$b0244d5063c0b61b; });

var $l5MLt = parcelRequire("l5MLt");

var $hPLeT = parcelRequire("hPLeT");

var $7CXdk = parcelRequire("7CXdk");

var $5Q0pQ = parcelRequire("5Q0pQ");
function $09f34b6558e96c97$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") try {
        $09f34b6558e96c97$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $09f34b6558e96c97$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $09f34b6558e96c97$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $09f34b6558e96c97$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
}
function $09f34b6558e96c97$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $09f34b6558e96c97$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join("&");
}
function $09f34b6558e96c97$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $7CXdk.isError)(value)) newObj = (0, $l5MLt.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $09f34b6558e96c97$var$getOwnProperties(value));
    else if ((0, $7CXdk.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $l5MLt.__assign)({
            type: event_1.type,
            target: $09f34b6558e96c97$var$serializeEventTarget(event_1.target),
            currentTarget: $09f34b6558e96c97$var$serializeEventTarget(event_1.currentTarget)
        }, $09f34b6558e96c97$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== "undefined" && (0, $7CXdk.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $09f34b6558e96c97$var$serializeEventTarget(target) {
    try {
        return (0, $7CXdk.isElement)(target) ? (0, $hPLeT.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $09f34b6558e96c97$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $09f34b6558e96c97$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($09f34b6558e96c97$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $5Q0pQ.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $5Q0pQ.truncate)(serialized, maxLength);
    }
    return "";
}
function $09f34b6558e96c97$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $7CXdk.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $l5MLt.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== "undefined") rv[key] = $09f34b6558e96c97$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($09f34b6558e96c97$export$d25f2688db1bb433);
    return val;
}
function $09f34b6558e96c97$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $7CXdk.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("5Q0pQ", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $440221aca6985234$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $440221aca6985234$export$4215662d762d6f9d; });
$parcel$export(module.exports, "safeJoin", function () { return $440221aca6985234$export$465e9d514283d4fd; });
$parcel$export(module.exports, "isMatchingPattern", function () { return $440221aca6985234$export$cdded5b28a5f8c6d; });

var $7CXdk = parcelRequire("7CXdk");
function $440221aca6985234$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $440221aca6985234$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $440221aca6985234$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
function $440221aca6985234$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $7CXdk.isString)(value)) return false;
    if ((0, $7CXdk.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === "string") return value.indexOf(pattern) !== -1;
    return false;
}
function $440221aca6985234$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}

});


parcelRegister("7sb6o", function(module, exports) {

$parcel$export(module.exports, "createStackParser", function () { return $56d3c28e758a1525$export$a5739666fb2d03d4; });
$parcel$export(module.exports, "getFunctionName", function () { return $56d3c28e758a1525$export$aad197c7121a6651; });

var $l5MLt = parcelRequire("l5MLt");
var $56d3c28e758a1525$var$STACKTRACE_LIMIT = 50;
function $56d3c28e758a1525$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $l5MLt.__values)(stack.split("\n").slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $l5MLt.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $56d3c28e758a1525$export$c55c24c0eeba0205(frames);
    };
}
function $56d3c28e758a1525$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || "";
    var lastFrameFunction = localStack[localStack.length - 1].function || "";
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf("captureMessage") !== -1 || firstFrameFunction.indexOf("captureException") !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf("sentryWrapped") !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $56d3c28e758a1525$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || "?"
        });
    }).reverse();
}
var $56d3c28e758a1525$var$defaultFunctionName = "<anonymous>";
function $56d3c28e758a1525$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $56d3c28e758a1525$var$defaultFunctionName;
        return fn.name || $56d3c28e758a1525$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $56d3c28e758a1525$var$defaultFunctionName;
    }
}

});

parcelRegister("jAd8t", function(module, exports) {

$parcel$export(module.exports, "supportsFetch", function () { return $e41b9197912746d7$export$edf3cb81fd7d2a3e; });
$parcel$export(module.exports, "isNativeFetch", function () { return $e41b9197912746d7$export$18cf36ed71d733e7; });
$parcel$export(module.exports, "supportsNativeFetch", function () { return $e41b9197912746d7$export$c82d238e23c40b21; });
$parcel$export(module.exports, "supportsReferrerPolicy", function () { return $e41b9197912746d7$export$2d308b428295192f; });
$parcel$export(module.exports, "supportsHistory", function () { return $e41b9197912746d7$export$67fc34576016d6ec; });

var $411pt = parcelRequire("411pt");

var $fU0Yz = parcelRequire("fU0Yz");

var $6uhZG = parcelRequire("6uhZG");
function $e41b9197912746d7$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
function $e41b9197912746d7$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
function $e41b9197912746d7$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
function $e41b9197912746d7$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in (0, $fU0Yz.getGlobalObject)())) return false;
    try {
        new Headers();
        new Request("");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function $e41b9197912746d7$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $e41b9197912746d7$export$c82d238e23c40b21() {
    if (!$e41b9197912746d7$export$edf3cb81fd7d2a3e()) return false;
    var global = (0, $fU0Yz.getGlobalObject)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($e41b9197912746d7$export$18cf36ed71d733e7(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        var sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $e41b9197912746d7$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $411pt.IS_DEBUG_BUILD) && (0, $6uhZG.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $e41b9197912746d7$export$531055a6c684a70a() {
    return "ReportingObserver" in (0, $fU0Yz.getGlobalObject)();
}
function $e41b9197912746d7$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$e41b9197912746d7$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}
function $e41b9197912746d7$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, $fU0Yz.getGlobalObject)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = "history" in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRegister("49X0E", function(module, exports) {

$parcel$export(module.exports, "uuid4", function () { return $3075c6c1fb1590f1$export$19f53698e68b2496; });
$parcel$export(module.exports, "parseUrl", function () { return $3075c6c1fb1590f1$export$7a5253c0f62e0150; });
$parcel$export(module.exports, "getEventDescription", function () { return $3075c6c1fb1590f1$export$4157119e2b157127; });
$parcel$export(module.exports, "addExceptionTypeValue", function () { return $3075c6c1fb1590f1$export$f26508487bf83ee7; });
$parcel$export(module.exports, "addExceptionMechanism", function () { return $3075c6c1fb1590f1$export$c69a9a0313b03bb1; });
$parcel$export(module.exports, "checkOrSetAlreadyCaught", function () { return $3075c6c1fb1590f1$export$6de4ffac6a2f1098; });

var $l5MLt = parcelRequire("l5MLt");

var $fU0Yz = parcelRequire("fU0Yz");

var $QXRHa = parcelRequire("QXRHa");

var $5Q0pQ = parcelRequire("5Q0pQ");
function $3075c6c1fb1590f1$export$19f53698e68b2496() {
    var global = (0, $fU0Yz.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $3075c6c1fb1590f1$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || "";
    var fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $3075c6c1fb1590f1$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $3075c6c1fb1590f1$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $3075c6c1fb1590f1$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $3075c6c1fb1590f1$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $3075c6c1fb1590f1$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $3075c6c1fb1590f1$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: "generic",
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $l5MLt.__assign)((0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && "data" in newMechanism) {
        var mergedData = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $3075c6c1fb1590f1$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $3075c6c1fb1590f1$export$d364f2020ab30578(input) {
    var match = input.match($3075c6c1fb1590f1$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $3075c6c1fb1590f1$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $5Q0pQ.snipLine)(line, 0);
    });
    frame.context_line = (0, $5Q0pQ.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $5Q0pQ.snipLine)(line, 0);
    });
}
function $3075c6c1fb1590f1$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $3075c6c1fb1590f1$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $QXRHa.addNonEnumerableProperty)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});

parcelRegister("8I7eB", function(module, exports) {

$parcel$export(module.exports, "normalize", function () { return $65780b6bc20493cf$export$a3295358bff77e; });
$parcel$export(module.exports, "normalizeToSize", function () { return $65780b6bc20493cf$export$23fbbb20bed71033; });

var $l5MLt = parcelRequire("l5MLt");

var $7CXdk = parcelRequire("7CXdk");

var $0w0Zm = parcelRequire("0w0Zm");

var $QXRHa = parcelRequire("QXRHa");

var $7sb6o = parcelRequire("7sb6o");
function $65780b6bc20493cf$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $65780b6bc20493cf$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $65780b6bc20493cf$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $65780b6bc20493cf$export$a3295358bff77e(object, depth);
    if ($65780b6bc20493cf$var$jsonSize(normalized) > maxSize) return $65780b6bc20493cf$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $65780b6bc20493cf$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $0w0Zm.memoBuilder)();
    var _a = (0, $l5MLt.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $7CXdk.isNaN)(value)) return value;
    var stringified = $65780b6bc20493cf$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $7CXdk.isError)(value) || (0, $7CXdk.isEvent)(value) ? (0, $QXRHa.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $65780b6bc20493cf$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $65780b6bc20493cf$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        // React's SyntheticEvent thingy
        if ((0, $7CXdk.isSyntheticEvent)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return "[undefined]";
        if (typeof value === "function") return "[Function: " + (0, $7sb6o.getFunctionName)(value) + "]";
        if (typeof value === "symbol") return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $65780b6bc20493cf$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $65780b6bc20493cf$var$jsonSize(value) {
    return $65780b6bc20493cf$var$utf8Length(JSON.stringify(value));
}

});
parcelRegister("0w0Zm", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", function () { return $0018d5b41e2a02e8$export$8115b0b78e956ab3; });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $0018d5b41e2a02e8$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === "function";
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});


parcelRegister("3UOOR", function(module, exports) {

$parcel$export(module.exports, "makePromiseBuffer", function () { return $2d9e05b99d8050fc$export$85a4f67f852183e6; });

var $7B1Bh = parcelRequire("7B1Bh");

var $eFWdY = parcelRequire("eFWdY");
function $2d9e05b99d8050fc$export$85a4f67f852183e6(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */ function add(taskProducer) {
        if (!isReady()) return (0, $eFWdY.rejectedSyncPromise)(new (0, $7B1Bh.SentryError)("Not adding Promise due to buffer limit reached."));
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(function() {
            return remove(task);
        })// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, function() {
            return remove(task).then(null, function() {
            // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */ function drain(timeout) {
        return new (0, $eFWdY.SyncPromise)(function(resolve, reject) {
            var counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function(item) {
                (0, $eFWdY.resolvedSyncPromise)(item).then(function() {
                    // eslint-disable-next-line no-plusplus
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});
parcelRegister("eFWdY", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", function () { return $aaf20f30cb741ea2$export$1fda8aa4d135f8aa; });
$parcel$export(module.exports, "SyncPromise", function () { return $aaf20f30cb741ea2$export$6f292d4960313241; });
$parcel$export(module.exports, "rejectedSyncPromise", function () { return $aaf20f30cb741ea2$export$78e43115b553f358; });
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $7CXdk = parcelRequire("7CXdk");
function $aaf20f30cb741ea2$export$1fda8aa4d135f8aa(value) {
    return new $aaf20f30cb741ea2$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $aaf20f30cb741ea2$export$78e43115b553f358(reason) {
    return new $aaf20f30cb741ea2$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $aaf20f30cb741ea2$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $7CXdk.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});


parcelRegister("1s3gX", function(module, exports) {

$parcel$export(module.exports, "severityFromString", function () { return $10eaf1d04ac4b08e$export$e01cef29b4327697; });

var $i3ov7 = parcelRequire("i3ov7");

var $fbLi0 = parcelRequire("fbLi0");
function $10eaf1d04ac4b08e$var$isSupportedSeverity(level) {
    return (0, $fbLi0.SeverityLevels).indexOf(level) !== -1;
}
function $10eaf1d04ac4b08e$export$e01cef29b4327697(level) {
    if (level === "warn") return (0, $i3ov7.Severity).Warning;
    if ($10eaf1d04ac4b08e$var$isSupportedSeverity(level)) return level;
    return (0, $i3ov7.Severity).Log;
}

});
parcelRegister("fbLi0", function(module, exports) {

$parcel$export(module.exports, "SeverityLevels", function () { return $b0ec90cbeab06e92$export$484b1ea9aec914c; });
var $b0ec90cbeab06e92$export$484b1ea9aec914c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug",
    "critical"
];

});


parcelRegister("jIt7f", function(module, exports) {

$parcel$export(module.exports, "eventStatusFromHttpCode", function () { return $e5a8b637db9339c3$export$82713360d763c449; });
/**
 * Converts an HTTP status code to sentry status {@link EventStatus}.
 *
 * @param code number HTTP status code
 * @returns EventStatus
 */ function $e5a8b637db9339c3$export$82713360d763c449(code) {
    if (code >= 200 && code < 300) return "success";
    if (code === 429) return "rate_limit";
    if (code >= 400 && code < 500) return "invalid";
    if (code >= 500) return "failed";
    return "unknown";
}

});

parcelRegister("6MTdb", function(module, exports) {

$parcel$export(module.exports, "createEnvelope", function () { return $4f120da33bdda915$export$f93f7f385160c44e; });
$parcel$export(module.exports, "getEnvelopeType", function () { return $4f120da33bdda915$export$d84939284bbafcd4; });
$parcel$export(module.exports, "serializeEnvelope", function () { return $4f120da33bdda915$export$32f9b428425aac85; });

var $l5MLt = parcelRequire("l5MLt");

var $7CXdk = parcelRequire("7CXdk");
function $4f120da33bdda915$export$f93f7f385160c44e(headers, items) {
    if (items === void 0) items = [];
    return [
        headers,
        items
    ];
}
function $4f120da33bdda915$export$d650323442802f6f(envelope, newItem) {
    var _a = (0, $l5MLt.__read)(envelope, 2), headers = _a[0], items = _a[1];
    return [
        headers,
        (0, $l5MLt.__spread)(items, [
            newItem
        ])
    ];
}
function $4f120da33bdda915$export$d84939284bbafcd4(envelope) {
    var _a = (0, $l5MLt.__read)(envelope, 2), _b = (0, $l5MLt.__read)(_a[1], 1), _c = (0, $l5MLt.__read)(_b[0], 1), firstItemHeader = _c[0];
    return firstItemHeader.type;
}
function $4f120da33bdda915$export$32f9b428425aac85(envelope) {
    var _a = (0, $l5MLt.__read)(envelope, 2), headers = _a[0], items = _a[1];
    var serializedHeaders = JSON.stringify(headers);
    // Have to cast items to any here since Envelope is a union type
    // Fixed in Typescript 4.2
    // TODO: Remove any[] cast when we upgrade to TS 4.2
    // https://github.com/microsoft/TypeScript/issues/36390
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return items.reduce(function(acc, item) {
        var _a = (0, $l5MLt.__read)(item, 2), itemHeaders = _a[0], payload = _a[1];
        // We do not serialize payloads that are primitives
        var serializedPayload = (0, $7CXdk.isPrimitive)(payload) ? String(payload) : JSON.stringify(payload);
        return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
    }, serializedHeaders);
}

});

parcelRegister("9bKWg", function(module, exports) {

$parcel$export(module.exports, "createClientReportEnvelope", function () { return $6b098d2c9e1dcce4$export$f3b9ed77c03eeb00; });

var $6MTdb = parcelRequire("6MTdb");

var $b7FqB = parcelRequire("b7FqB");
function $6b098d2c9e1dcce4$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $b7FqB.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $6MTdb.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("6n6df", function(module, exports) {

$parcel$export(module.exports, "disabledUntil", function () { return $4a39b5bec2f07e52$export$b89fc7b2e4c799e7; });
$parcel$export(module.exports, "isRateLimited", function () { return $4a39b5bec2f07e52$export$6c91fec22056810a; });
$parcel$export(module.exports, "updateRateLimits", function () { return $4a39b5bec2f07e52$export$699aff705e0d49d4; });

var $l5MLt = parcelRequire("l5MLt");
var $4a39b5bec2f07e52$export$b09ce39faaeb1e7c = 60000; // 60 seconds
function $4a39b5bec2f07e52$export$615352e17ed7741(header, now) {
    if (now === void 0) now = Date.now();
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) return headerDate - now;
    return $4a39b5bec2f07e52$export$b09ce39faaeb1e7c;
}
function $4a39b5bec2f07e52$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
function $4a39b5bec2f07e52$export$6c91fec22056810a(limits, category, now) {
    if (now === void 0) now = Date.now();
    return $4a39b5bec2f07e52$export$b89fc7b2e4c799e7(limits, category) > now;
}
function $4a39b5bec2f07e52$export$699aff705e0d49d4(limits, headers, now) {
    var e_1, _a, e_2, _b;
    if (now === void 0) now = Date.now();
    var updatedRateLimits = (0, $l5MLt.__assign)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers["x-sentry-rate-limits"];
    var retryAfterHeader = headers["retry-after"];
    if (rateLimitHeader) try {
        /**
             * rate limit headers are of the form
             *     <header>,<header>,..
             * where each <header> is of the form
             *     <retry_after>: <categories>: <scope>: <reason_code>
             * where
             *     <retry_after> is a delay in seconds
             *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
             *         <category>;<category>;...
             *     <scope> is what's being limited (org, project, or key) - ignored by SDK
             *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
             */ for(var _c = (0, $l5MLt.__values)(rateLimitHeader.trim().split(",")), _d = _c.next(); !_d.done; _d = _c.next()){
            var limit = _d.value;
            var parameters = limit.split(":", 2);
            var headerDelay = parseInt(parameters[0], 10);
            var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
            if (!parameters[1]) updatedRateLimits.all = now + delay;
            else try {
                for(var _e = (e_2 = void 0, (0, $l5MLt.__values)(parameters[1].split(";"))), _f = _e.next(); !_f.done; _f = _e.next()){
                    var category = _f.value;
                    updatedRateLimits[category] = now + delay;
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $4a39b5bec2f07e52$export$615352e17ed7741(retryAfterHeader, now);
    return updatedRateLimits;
}

});


parcelRegister("cNRiV", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", function () { return $952368bcc6c38fe0$export$48a8984ec0bf2e44; });
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $952368bcc6c38fe0$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === "undefined" ? true : __SENTRY_DEBUG__;

});

parcelRegister("j7nMo", function(module, exports) {

$parcel$export(module.exports, "setupIntegrations", function () { return $deb11de4e553e55f$export$51abed9797baa598; });

var $l5MLt = parcelRequire("l5MLt");

var $l6Sat = parcelRequire("l6Sat");
var $4IkmO = parcelRequire("4IkmO");
parcelRequire("4TfCJ");
var $QXRHa = parcelRequire("QXRHa");
var $6uhZG = parcelRequire("6uhZG");

var $cNRiV = parcelRequire("cNRiV");
var $deb11de4e553e55f$export$b14a8888f80a0b3e = [];
/**
 * @private
 */ function $deb11de4e553e55f$var$filterDuplicates(integrations) {
    return integrations.reduce(function(acc, integrations) {
        if (acc.every(function(accIntegration) {
            return integrations.name !== accIntegration.name;
        })) acc.push(integrations);
        return acc;
    }, []);
}
function $deb11de4e553e55f$export$68bc4c01ab8ae766(options) {
    var defaultIntegrations = options.defaultIntegrations && (0, $l5MLt.__spread)(options.defaultIntegrations) || [];
    var userIntegrations = options.integrations;
    var integrations = (0, $l5MLt.__spread)($deb11de4e553e55f$var$filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) // Filter out integrations that are also included in user options
    integrations = (0, $l5MLt.__spread)(integrations.filter(function(integrations) {
        return userIntegrations.every(function(userIntegration) {
            return userIntegration.name !== integrations.name;
        });
    }), $deb11de4e553e55f$var$filterDuplicates(userIntegrations));
    else if (typeof userIntegrations === "function") {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [
            integrations
        ];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function(i) {
        return i.name;
    });
    var alwaysLastToRun = "Debug";
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) integrations.push.apply(integrations, (0, $l5MLt.__spread)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    return integrations;
}
function $deb11de4e553e55f$export$e7390a03b70a6f2f(integration) {
    if ($deb11de4e553e55f$export$b14a8888f80a0b3e.indexOf(integration.name) !== -1) return;
    integration.setupOnce((0, $l6Sat.addGlobalEventProcessor), (0, $4IkmO.getCurrentHub));
    $deb11de4e553e55f$export$b14a8888f80a0b3e.push(integration.name);
    (0, $cNRiV.IS_DEBUG_BUILD) && (0, $6uhZG.logger).log("Integration installed: " + integration.name);
}
function $deb11de4e553e55f$export$51abed9797baa598(options) {
    var integrations = {};
    $deb11de4e553e55f$export$68bc4c01ab8ae766(options).forEach(function(integration) {
        integrations[integration.name] = integration;
        $deb11de4e553e55f$export$e7390a03b70a6f2f(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    (0, $QXRHa.addNonEnumerableProperty)(integrations, "initialized", true);
    return integrations;
}

});


parcelRegister("cLshu", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", function () { return $94afcfdddef75333$export$31499a9cd224b78c; });
var $94afcfdddef75333$export$31499a9cd224b78c = "6.19.7";

});

parcelRegister("4ArnI", function(module, exports) {

$parcel$export(module.exports, "BrowserBackend", function () { return $356fc39b0b6997f7$export$2526e21aec9d0ce7; });

var $l5MLt = parcelRequire("l5MLt");

var $hsk8X = parcelRequire("hsk8X");
var $fQ7ke = parcelRequire("fQ7ke");

var $i3ov7 = parcelRequire("i3ov7");
parcelRequire("4TfCJ");
var $jAd8t = parcelRequire("jAd8t");

var $5p3Zc = parcelRequire("5p3Zc");

var $2vKvu = parcelRequire("2vKvu");
var $lk4e6 = parcelRequire("lk4e6");
var $a8gGK = parcelRequire("a8gGK");
var $iBm6I = parcelRequire("iBm6I");
/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */ var $356fc39b0b6997f7$export$2526e21aec9d0ce7 = /** @class */ function(_super) {
    (0, $l5MLt.__extends)(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromException = function(exception, hint) {
        return (0, $5p3Zc.eventFromException)(exception, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromMessage = function(message, level, hint) {
        if (level === void 0) level = (0, $i3ov7.Severity).Info;
        return (0, $5p3Zc.eventFromMessage)(message, level, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype._setupTransport = function() {
        if (!this._options.dsn) // We return the noop transport here in case there is no Dsn.
        return _super.prototype._setupTransport.call(this);
        var transportOptions = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._options.transportOptions), {
            dsn: this._options.dsn,
            tunnel: this._options.tunnel,
            sendClientReports: this._options.sendClientReports,
            _metadata: this._options._metadata
        });
        var api = (0, $fQ7ke.initAPIDetails)(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
        var url = (0, $fQ7ke.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel);
        if (this._options.transport) return new this._options.transport(transportOptions);
        if ((0, $jAd8t.supportsFetch)()) {
            var requestOptions = (0, $l5MLt.__assign)({}, transportOptions.fetchParameters);
            this._newTransport = (0, $lk4e6.makeNewFetchTransport)({
                requestOptions: requestOptions,
                url: url
            });
            return new (0, $2vKvu.FetchTransport)(transportOptions);
        }
        this._newTransport = (0, $a8gGK.makeNewXHRTransport)({
            url: url,
            headers: transportOptions.headers
        });
        return new (0, $iBm6I.XHRTransport)(transportOptions);
    };
    return BrowserBackend;
}((0, $hsk8X.BaseBackend));

});
parcelRegister("hsk8X", function(module, exports) {

$parcel$export(module.exports, "BaseBackend", function () { return $cb54ad4532452a0f$export$8f43a53a38d7e95f; });

var $l5MLt = parcelRequire("l5MLt");
parcelRequire("4TfCJ");
var $6uhZG = parcelRequire("6uhZG");
var $7B1Bh = parcelRequire("7B1Bh");

var $fQ7ke = parcelRequire("fQ7ke");

var $cNRiV = parcelRequire("cNRiV");

var $dxGiC = parcelRequire("dxGiC");

var $5dMMZ = parcelRequire("5dMMZ");
/**
 * This is the base implemention of a Backend.
 * @hidden
 */ var $cb54ad4532452a0f$export$8f43a53a38d7e95f = /** @class */ function() {
    /** Creates a new backend instance. */ function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) (0, $cNRiV.IS_DEBUG_BUILD) && (0, $6uhZG.logger).warn("No DSN provided, backend will not do anything.");
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function(_exception, _hint) {
        throw new (0, $7B1Bh.SentryError)("Backend has to implement `eventFromException` method");
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.eventFromMessage = function(_message, _level, _hint) {
        throw new (0, $7B1Bh.SentryError)("Backend has to implement `eventFromMessage` method");
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendEvent = function(event) {
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $fQ7ke.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var env = (0, $dxGiC.createEventEnvelope)(event, api);
            this._newTransport.send(env).then(null, function(reason) {
                (0, $cNRiV.IS_DEBUG_BUILD) && (0, $6uhZG.logger).error("Error while sending event:", reason);
            });
        } else this._transport.sendEvent(event).then(null, function(reason) {
            (0, $cNRiV.IS_DEBUG_BUILD) && (0, $6uhZG.logger).error("Error while sending event:", reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendSession = function(session) {
        if (!this._transport.sendSession) {
            (0, $cNRiV.IS_DEBUG_BUILD) && (0, $6uhZG.logger).warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $fQ7ke.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var _a = (0, $l5MLt.__read)((0, $dxGiC.createSessionEnvelope)(session, api), 1), env = _a[0];
            this._newTransport.send(env).then(null, function(reason) {
                (0, $cNRiV.IS_DEBUG_BUILD) && (0, $6uhZG.logger).error("Error while sending session:", reason);
            });
        } else this._transport.sendSession(session).then(null, function(reason) {
            (0, $cNRiV.IS_DEBUG_BUILD) && (0, $6uhZG.logger).error("Error while sending session:", reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.getTransport = function() {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */ BaseBackend.prototype._setupTransport = function() {
        return new (0, $5dMMZ.NoopTransport)();
    };
    return BaseBackend;
}();

});
parcelRegister("fQ7ke", function(module, exports) {

$parcel$export(module.exports, "getStoreEndpointWithUrlEncodedAuth", function () { return $b88165004cb1647d$export$c1677e22ac2217a5; });
$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", function () { return $b88165004cb1647d$export$9964600bfe84e6a3; });
$parcel$export(module.exports, "initAPIDetails", function () { return $b88165004cb1647d$export$ad00a06efb2a29cb; });
$parcel$export(module.exports, "getReportDialogEndpoint", function () { return $b88165004cb1647d$export$671c7ed8e40a7a57; });
parcelRequire("4TfCJ");
var $d9nst = parcelRequire("d9nst");
var $QXRHa = parcelRequire("QXRHa");
var $b88165004cb1647d$var$SENTRY_API_VERSION = "7";
/**
 * Helper class to provide urls, headers and metadata that can be used to form
 * different types of requests to Sentry endpoints.
 * Supports both envelopes and regular event requests.
 *
 * @deprecated Please use APIDetails
 **/ var $b88165004cb1647d$export$2c4e825dc9120f87 = /** @class */ function() {
    /** Create a new instance of API */ function API(dsn, metadata, tunnel) {
        if (metadata === void 0) metadata = {};
        this.dsn = dsn;
        this._dsnObject = (0, $d9nst.makeDsn)(dsn);
        this.metadata = metadata;
        this._tunnel = tunnel;
    }
    /** Returns the Dsn object. */ API.prototype.getDsn = function() {
        return this._dsnObject;
    };
    /** Does this transport force envelopes? */ API.prototype.forceEnvelope = function() {
        return !!this._tunnel;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */ API.prototype.getBaseApiEndpoint = function() {
        return $b88165004cb1647d$var$getBaseApiEndpoint(this._dsnObject);
    };
    /** Returns the store endpoint URL. */ API.prototype.getStoreEndpoint = function() {
        return $b88165004cb1647d$var$getStoreEndpoint(this._dsnObject);
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getStoreEndpointWithUrlEncodedAuth = function() {
        return $b88165004cb1647d$export$c1677e22ac2217a5(this._dsnObject);
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function() {
        return $b88165004cb1647d$export$9964600bfe84e6a3(this._dsnObject, this._tunnel);
    };
    return API;
}();
function $b88165004cb1647d$export$ad00a06efb2a29cb(dsn, metadata, tunnel) {
    return {
        initDsn: dsn,
        metadata: metadata || {},
        dsn: (0, $d9nst.makeDsn)(dsn),
        tunnel: tunnel
    };
}
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $b88165004cb1647d$var$getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? dsn.protocol + ":" : "";
    var port = dsn.port ? ":" + dsn.port : "";
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : "") + "/api/";
}
/** Returns the ingest API endpoint for target. */ function $b88165004cb1647d$var$_getIngestEndpoint(dsn, target) {
    return "" + $b88165004cb1647d$var$getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $b88165004cb1647d$var$_encodedAuth(dsn) {
    return (0, $QXRHa.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $b88165004cb1647d$var$SENTRY_API_VERSION
    });
}
/** Returns the store endpoint URL. */ function $b88165004cb1647d$var$getStoreEndpoint(dsn) {
    return $b88165004cb1647d$var$_getIngestEndpoint(dsn, "store");
}
function $b88165004cb1647d$export$c1677e22ac2217a5(dsn) {
    return $b88165004cb1647d$var$getStoreEndpoint(dsn) + "?" + $b88165004cb1647d$var$_encodedAuth(dsn);
}
/** Returns the envelope endpoint URL. */ function $b88165004cb1647d$var$_getEnvelopeEndpoint(dsn) {
    return $b88165004cb1647d$var$_getIngestEndpoint(dsn, "envelope");
}
function $b88165004cb1647d$export$9964600bfe84e6a3(dsn, tunnel) {
    return tunnel ? tunnel : $b88165004cb1647d$var$_getEnvelopeEndpoint(dsn) + "?" + $b88165004cb1647d$var$_encodedAuth(dsn);
}
function $b88165004cb1647d$export$1e4d4724de7b199e(dsn, clientName, clientVersion) {
    // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
    var header = [
        "Sentry sentry_version=" + $b88165004cb1647d$var$SENTRY_API_VERSION
    ];
    header.push("sentry_client=" + clientName + "/" + clientVersion);
    header.push("sentry_key=" + dsn.publicKey);
    if (dsn.pass) header.push("sentry_secret=" + dsn.pass);
    return {
        "Content-Type": "application/json",
        "X-Sentry-Auth": header.join(", ")
    };
}
function $b88165004cb1647d$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    var dsn = (0, $d9nst.makeDsn)(dsnLike);
    var endpoint = $b88165004cb1647d$var$getBaseApiEndpoint(dsn) + "embed/error-page/";
    var encodedOptions = "dsn=" + (0, $d9nst.dsnToString)(dsn);
    for(var key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "user") {
            if (!dialogOptions.user) continue;
            if (dialogOptions.user.name) encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
            if (dialogOptions.user.email) encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
        } else encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
    }
    return endpoint + "?" + encodedOptions;
}

});

parcelRegister("dxGiC", function(module, exports) {

$parcel$export(module.exports, "createSessionEnvelope", function () { return $9dbf2b2b810ed8c5$export$124b03c077baa2f3; });
$parcel$export(module.exports, "sessionToSentryRequest", function () { return $9dbf2b2b810ed8c5$export$977ee6eda1884ec3; });
$parcel$export(module.exports, "createEventEnvelope", function () { return $9dbf2b2b810ed8c5$export$c31057337a18010f; });
$parcel$export(module.exports, "eventToSentryRequest", function () { return $9dbf2b2b810ed8c5$export$2006389de558b996; });

var $l5MLt = parcelRequire("l5MLt");
parcelRequire("4TfCJ");
var $6MTdb = parcelRequire("6MTdb");
var $d9nst = parcelRequire("d9nst");
var $8I7eB = parcelRequire("8I7eB");

var $fQ7ke = parcelRequire("fQ7ke");
/** Extract sdk info from from the API metadata */ function $9dbf2b2b810ed8c5$var$getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) return;
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $9dbf2b2b810ed8c5$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0, $l5MLt.__spread)(event.sdk.integrations || [], sdkInfo.integrations || []);
    event.sdk.packages = (0, $l5MLt.__spread)(event.sdk.packages || [], sdkInfo.packages || []);
    return event;
}
function $9dbf2b2b810ed8c5$export$124b03c077baa2f3(session, api) {
    var sdkInfo = $9dbf2b2b810ed8c5$var$getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $d9nst.dsnToString)(api.dsn)
    });
    // I know this is hacky but we don't want to add `sessions` to request type since it's never rate limited
    var type = "aggregates" in session ? "sessions" : "session";
    // TODO (v7) Have to cast type because envelope items do not accept a `SentryRequestType`
    var envelopeItem = [
        {
            type: type
        },
        session
    ];
    var envelope = (0, $6MTdb.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
    return [
        envelope,
        type
    ];
}
function $9dbf2b2b810ed8c5$export$977ee6eda1884ec3(session, api) {
    var _a = (0, $l5MLt.__read)($9dbf2b2b810ed8c5$export$124b03c077baa2f3(session, api), 2), envelope = _a[0], type = _a[1];
    return {
        body: (0, $6MTdb.serializeEnvelope)(envelope),
        type: type,
        url: (0, $fQ7ke.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel)
    };
}
function $9dbf2b2b810ed8c5$export$c31057337a18010f(event, api) {
    var sdkInfo = $9dbf2b2b810ed8c5$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || "event";
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $9dbf2b2b810ed8c5$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : "unset";
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var envelopeHeaders = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $d9nst.dsnToString)(api.dsn)
    });
    var eventItem = [
        {
            type: eventType,
            sample_rates: [
                {
                    id: samplingMethod,
                    rate: sampleRate
                }
            ]
        },
        event
    ];
    return (0, $6MTdb.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
function $9dbf2b2b810ed8c5$export$2006389de558b996(event, api) {
    var sdkInfo = $9dbf2b2b810ed8c5$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || "event";
    var useEnvelope = eventType === "transaction" || !!api.tunnel;
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $9dbf2b2b810ed8c5$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : "unset";
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var body;
    try {
        // 99.9% of events should get through just fine - no change in behavior for them
        body = JSON.stringify(event);
    } catch (err) {
        // Record data about the error without replacing original event data, then force renormalization
        event.tags.JSONStringifyError = true;
        event.extra.JSONStringifyError = err;
        try {
            body = JSON.stringify((0, $8I7eB.normalize)(event));
        } catch (newErr) {
            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
            // debug with this hack, we won't ever land here.
            var innerErr = newErr;
            body = JSON.stringify({
                message: "JSON.stringify error after renormalization",
                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
                extra: {
                    message: innerErr.message,
                    stack: innerErr.stack
                }
            });
        }
    }
    var req = {
        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
        // the mystery
        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        body: body,
        type: eventType,
        url: useEnvelope ? (0, $fQ7ke.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel) : (0, $fQ7ke.getStoreEndpointWithUrlEncodedAuth)(api.dsn)
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({
            event_id: event.event_id,
            sent_at: new Date().toISOString()
        }, sdkInfo && {
            sdk: sdkInfo
        }), !!api.tunnel && {
            dsn: (0, $d9nst.dsnToString)(api.dsn)
        });
        var eventItem = [
            {
                type: eventType,
                sample_rates: [
                    {
                        id: samplingMethod,
                        rate: sampleRate
                    }
                ]
            },
            req.body
        ];
        var envelope = (0, $6MTdb.createEnvelope)(envelopeHeaders, [
            eventItem
        ]);
        req.body = (0, $6MTdb.serializeEnvelope)(envelope);
    }
    return req;
}

});

parcelRegister("5dMMZ", function(module, exports) {

$parcel$export(module.exports, "NoopTransport", function () { return $3cd4032ac4fbc2dd$export$6f2767450ea1346c; });
parcelRequire("4TfCJ");
var $eFWdY = parcelRequire("eFWdY");
/** Noop transport */ var $3cd4032ac4fbc2dd$export$6f2767450ea1346c = /** @class */ function() {
    function NoopTransport() {}
    /**
     * @inheritDoc
     */ NoopTransport.prototype.sendEvent = function(_) {
        return (0, $eFWdY.resolvedSyncPromise)({
            reason: "NoopTransport: Event has been skipped because no Dsn is configured.",
            status: "skipped"
        });
    };
    /**
     * @inheritDoc
     */ NoopTransport.prototype.close = function(_) {
        return (0, $eFWdY.resolvedSyncPromise)(true);
    };
    return NoopTransport;
}();

});


parcelRegister("5p3Zc", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", function () { return $3ef2611ea91cee5d$export$a6c2d27607295951; });
$parcel$export(module.exports, "eventFromException", function () { return $3ef2611ea91cee5d$export$ea3ec7e569b823fc; });
$parcel$export(module.exports, "eventFromUnknownInput", function () { return $3ef2611ea91cee5d$export$9dd56ed1ef0c3420; });
$parcel$export(module.exports, "eventFromMessage", function () { return $3ef2611ea91cee5d$export$5425b53185d13d6c; });

var $l5MLt = parcelRequire("l5MLt");

var $i3ov7 = parcelRequire("i3ov7");
parcelRequire("4TfCJ");
var $49X0E = parcelRequire("49X0E");
var $7sb6o = parcelRequire("7sb6o");
var $QXRHa = parcelRequire("QXRHa");
var $7CXdk = parcelRequire("7CXdk");
var $8I7eB = parcelRequire("8I7eB");
var $eFWdY = parcelRequire("eFWdY");

var $3XGul = parcelRequire("3XGul");
function $3ef2611ea91cee5d$export$a6c2d27607295951(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = $3ef2611ea91cee5d$export$d478b2c12fbcfdda(ex);
    var exception = {
        type: ex && ex.name,
        value: $3ef2611ea91cee5d$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $3ef2611ea91cee5d$export$a6a5dd73e489caf(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0, $7CXdk.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: "Non-Error " + (isUnhandledRejection ? "promise rejection" : "exception") + " captured with keys: " + (0, $QXRHa.extractExceptionKeysForMessage)(exception)
                }
            ]
        },
        extra: {
            __serialized__: (0, $8I7eB.normalizeToSize)(exception)
        }
    };
    if (syntheticException) {
        var frames_1 = $3ef2611ea91cee5d$export$d478b2c12fbcfdda(syntheticException);
        if (frames_1.length) event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
function $3ef2611ea91cee5d$export$73fbea5a0a5234af(ex) {
    return {
        exception: {
            values: [
                $3ef2611ea91cee5d$export$a6c2d27607295951(ex)
            ]
        }
    };
}
function $3ef2611ea91cee5d$export$d478b2c12fbcfdda(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || "";
    var popSize = $3ef2611ea91cee5d$var$getPopSize(ex);
    try {
        return (0, $7sb6o.createStackParser)((0, $3XGul.opera10StackParser), (0, $3XGul.opera11StackParser), (0, $3XGul.chromeStackParser), (0, $3XGul.winjsStackParser), (0, $3XGul.geckoStackParser))(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $3ef2611ea91cee5d$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $3ef2611ea91cee5d$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") return ex.framesToPop;
        if ($3ef2611ea91cee5d$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $3ef2611ea91cee5d$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
function $3ef2611ea91cee5d$export$ea3ec7e569b823fc(exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $3ef2611ea91cee5d$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace);
    (0, $49X0E.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = (0, $i3ov7.Severity).Error;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $eFWdY.resolvedSyncPromise)(event);
}
function $3ef2611ea91cee5d$export$5425b53185d13d6c(message, level, hint, attachStacktrace) {
    if (level === void 0) level = (0, $i3ov7.Severity).Info;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $3ef2611ea91cee5d$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $eFWdY.resolvedSyncPromise)(event);
}
function $3ef2611ea91cee5d$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0, $7CXdk.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return $3ef2611ea91cee5d$export$73fbea5a0a5234af(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $7CXdk.isDOMError)(exception) || (0, $7CXdk.isDOMException)(exception)) {
        var domException = exception;
        if ("stack" in exception) event = $3ef2611ea91cee5d$export$73fbea5a0a5234af(exception);
        else {
            var name_1 = domException.name || ((0, $7CXdk.isDOMError)(domException) ? "DOMError" : "DOMException");
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = $3ef2611ea91cee5d$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
            (0, $49X0E.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) event.tags = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, event.tags), {
            "DOMException.code": "" + domException.code
        });
        return event;
    }
    if ((0, $7CXdk.isError)(exception)) // we have a real Error object, do nothing
    return $3ef2611ea91cee5d$export$73fbea5a0a5234af(exception);
    if ((0, $7CXdk.isPlainObject)(exception) || (0, $7CXdk.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = $3ef2611ea91cee5d$export$a6a5dd73e489caf(objectException, syntheticException, isUnhandledRejection);
        (0, $49X0E.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $3ef2611ea91cee5d$export$47d86ae4b3c9994(exception, syntheticException, attachStacktrace);
    (0, $49X0E.addExceptionTypeValue)(event, "" + exception, undefined);
    (0, $49X0E.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $3ef2611ea91cee5d$export$47d86ae4b3c9994(input, syntheticException, attachStacktrace) {
    var event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = $3ef2611ea91cee5d$export$d478b2c12fbcfdda(syntheticException);
        if (frames_2.length) event.stacktrace = {
            frames: frames_2
        };
    }
    return event;
}

});
parcelRegister("3XGul", function(module, exports) {

$parcel$export(module.exports, "chromeStackParser", function () { return $2e27d714c7665f80$export$c693d9295441d8f9; });
$parcel$export(module.exports, "geckoStackParser", function () { return $2e27d714c7665f80$export$c9ddf1e2b5d48bff; });
$parcel$export(module.exports, "winjsStackParser", function () { return $2e27d714c7665f80$export$b6d155d85c1dcba5; });
$parcel$export(module.exports, "opera10StackParser", function () { return $2e27d714c7665f80$export$966ec832d9699d6; });
$parcel$export(module.exports, "opera11StackParser", function () { return $2e27d714c7665f80$export$989a1824b4734ce6; });

var $l5MLt = parcelRequire("l5MLt");
// global reference to slice
var $2e27d714c7665f80$var$UNKNOWN_FUNCTION = "?";
var $2e27d714c7665f80$var$OPERA10_PRIORITY = 10;
var $2e27d714c7665f80$var$OPERA11_PRIORITY = 20;
var $2e27d714c7665f80$var$CHROME_PRIORITY = 30;
var $2e27d714c7665f80$var$WINJS_PRIORITY = 40;
var $2e27d714c7665f80$var$GECKO_PRIORITY = 50;
function $2e27d714c7665f80$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $2e27d714c7665f80$var$chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $2e27d714c7665f80$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var $2e27d714c7665f80$var$chrome = function(line) {
    var parts = $2e27d714c7665f80$var$chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            var subMatch = $2e27d714c7665f80$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = (0, $l5MLt.__read)($2e27d714c7665f80$var$extractSafariExtensionDetails(parts[1] || $2e27d714c7665f80$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return $2e27d714c7665f80$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var $2e27d714c7665f80$export$c693d9295441d8f9 = [
    $2e27d714c7665f80$var$CHROME_PRIORITY,
    $2e27d714c7665f80$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $2e27d714c7665f80$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $2e27d714c7665f80$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $2e27d714c7665f80$var$gecko = function(line) {
    var _a;
    var parts = $2e27d714c7665f80$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            var subMatch = $2e27d714c7665f80$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || $2e27d714c7665f80$var$UNKNOWN_FUNCTION;
        _a = (0, $l5MLt.__read)($2e27d714c7665f80$var$extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return $2e27d714c7665f80$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var $2e27d714c7665f80$export$c9ddf1e2b5d48bff = [
    $2e27d714c7665f80$var$GECKO_PRIORITY,
    $2e27d714c7665f80$var$gecko
];
var $2e27d714c7665f80$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $2e27d714c7665f80$var$winjs = function(line) {
    var parts = $2e27d714c7665f80$var$winjsRegex.exec(line);
    return parts ? $2e27d714c7665f80$var$createFrame(parts[2], parts[1] || $2e27d714c7665f80$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var $2e27d714c7665f80$export$b6d155d85c1dcba5 = [
    $2e27d714c7665f80$var$WINJS_PRIORITY,
    $2e27d714c7665f80$var$winjs
];
var $2e27d714c7665f80$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $2e27d714c7665f80$var$opera10 = function(line) {
    var parts = $2e27d714c7665f80$var$opera10Regex.exec(line);
    return parts ? $2e27d714c7665f80$var$createFrame(parts[2], parts[3] || $2e27d714c7665f80$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var $2e27d714c7665f80$export$966ec832d9699d6 = [
    $2e27d714c7665f80$var$OPERA10_PRIORITY,
    $2e27d714c7665f80$var$opera10
];
var $2e27d714c7665f80$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $2e27d714c7665f80$var$opera11 = function(line) {
    var parts = $2e27d714c7665f80$var$opera11Regex.exec(line);
    return parts ? $2e27d714c7665f80$var$createFrame(parts[5], parts[3] || parts[4] || $2e27d714c7665f80$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var $2e27d714c7665f80$export$989a1824b4734ce6 = [
    $2e27d714c7665f80$var$OPERA11_PRIORITY,
    $2e27d714c7665f80$var$opera11
];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var $2e27d714c7665f80$var$extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf("safari-extension") !== -1;
    var isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : $2e27d714c7665f80$var$UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename
    ] : [
        func,
        filename
    ];
};

});


parcelRegister("2vKvu", function(module, exports) {

$parcel$export(module.exports, "FetchTransport", function () { return $1d428d58b4b63235$export$2bdee3f9b92f4e82; });

var $l5MLt = parcelRequire("l5MLt");
parcelRequire("4TfCJ");
var $7B1Bh = parcelRequire("7B1Bh");
var $jAd8t = parcelRequire("jAd8t");
var $eFWdY = parcelRequire("eFWdY");

var $bD0gR = parcelRequire("bD0gR");

var $3y5eO = parcelRequire("3y5eO");
/** `fetch` based transport */ var $1d428d58b4b63235$export$2bdee3f9b92f4e82 = /** @class */ function(_super) {
    (0, $l5MLt.__extends)(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) fetchImpl = (0, $3y5eO.getNativeFetchImplementation)();
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ FetchTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent("ratelimit_backoff", sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        var options = {
            body: sentryRequest.body,
            method: "POST",
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
            // (see https://caniuse.com/#feat=referrer-policy),
            // it doesn't. And it throws an exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (0, $jAd8t.supportsReferrerPolicy)() ? "origin" : ""
        };
        if (this.options.fetchParameters !== undefined) Object.assign(options, this.options.fetchParameters);
        if (this.options.headers !== undefined) options.headers = this.options.headers;
        return this._buffer.add(function() {
            return new (0, $eFWdY.SyncPromise)(function(resolve, reject) {
                _this._fetch(sentryRequest.url, options).then(function(response) {
                    var headers = {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject
                    });
                }).catch(reject);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $7B1Bh.SentryError)) _this.recordLostEvent("queue_overflow", sentryRequest.type);
            else _this.recordLostEvent("network_error", sentryRequest.type);
            throw reason;
        });
    };
    return FetchTransport;
}((0, $bD0gR.BaseTransport));

});
parcelRegister("bD0gR", function(module, exports) {

$parcel$export(module.exports, "BaseTransport", function () { return $87738c08e97a0c44$export$74b99d619e90f481; });

var $l5MLt = parcelRequire("l5MLt");

var $dxGiC = parcelRequire("dxGiC");
var $fQ7ke = parcelRequire("fQ7ke");
parcelRequire("4TfCJ");
var $9bKWg = parcelRequire("9bKWg");
var $6n6df = parcelRequire("6n6df");
var $d9nst = parcelRequire("d9nst");
var $jIt7f = parcelRequire("jIt7f");
var $fU0Yz = parcelRequire("fU0Yz");
var $6uhZG = parcelRequire("6uhZG");
var $3UOOR = parcelRequire("3UOOR");
var $6MTdb = parcelRequire("6MTdb");

var $aNuE0 = parcelRequire("aNuE0");

var $3y5eO = parcelRequire("3y5eO");
function $87738c08e97a0c44$var$requestTypeToCategory(ty) {
    var tyStr = ty;
    return tyStr === "event" ? "error" : tyStr;
}
var $87738c08e97a0c44$var$global = (0, $fU0Yz.getGlobalObject)();
/** Base Transport class implementation */ var $87738c08e97a0c44$export$74b99d619e90f481 = /** @class */ function() {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */ this._buffer = (0, $3UOOR.makePromiseBuffer)(30);
        /** Locks transport after receiving rate limits in a response */ this._rateLimits = {};
        this._outcomes = {};
        this._api = (0, $fQ7ke.initAPIDetails)(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = (0, $fQ7ke.getStoreEndpointWithUrlEncodedAuth)(this._api.dsn);
        if (this.options.sendClientReports && $87738c08e97a0c44$var$global.document) $87738c08e97a0c44$var$global.document.addEventListener("visibilitychange", function() {
            if ($87738c08e97a0c44$var$global.document.visibilityState === "hidden") _this._flushOutcomes();
        });
    }
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendEvent = function(event) {
        return this._sendRequest((0, $dxGiC.eventToSentryRequest)(event, this._api), event);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendSession = function(session) {
        return this._sendRequest((0, $dxGiC.sessionToSentryRequest)(session, this._api), session);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.close = function(timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.recordLostEvent = function(reason, category) {
        var _a;
        if (!this.options.sendClientReports) return;
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = $87738c08e97a0c44$var$requestTypeToCategory(category) + ":" + reason;
        (0, $aNuE0.IS_DEBUG_BUILD) && (0, $6uhZG.logger).log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], _a !== null && _a !== void 0 ? _a : 0) + 1;
    };
    /**
     * Send outcomes as an envelope
     */ BaseTransport.prototype._flushOutcomes = function() {
        if (!this.options.sendClientReports) return;
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            (0, $aNuE0.IS_DEBUG_BUILD) && (0, $6uhZG.logger).log("No outcomes to flush");
            return;
        }
        (0, $aNuE0.IS_DEBUG_BUILD) && (0, $6uhZG.logger).log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = (0, $fQ7ke.getEnvelopeEndpointWithUrlEncodedAuth)(this._api.dsn, this._api.tunnel);
        var discardedEvents = Object.keys(outcomes).map(function(key) {
            var _a = (0, $l5MLt.__read)(key.split(":"), 2), category = _a[0], reason = _a[1];
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        // TODO: Improve types on discarded_events to get rid of cast
        });
        var envelope = (0, $9bKWg.createClientReportEnvelope)(discardedEvents, this._api.tunnel && (0, $d9nst.dsnToString)(this._api.dsn));
        try {
            (0, $3y5eO.sendReport)(url, (0, $6MTdb.serializeEnvelope)(envelope));
        } catch (e) {
            (0, $aNuE0.IS_DEBUG_BUILD) && (0, $6uhZG.logger).error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */ BaseTransport.prototype._handleResponse = function(_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = (0, $jIt7f.eventStatusFromHttpCode)(response.status);
        this._rateLimits = (0, $6n6df.updateRateLimits)(this._rateLimits, headers);
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(requestType)) (0, $aNuE0.IS_DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
        (0, $6uhZG.logger).warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        if (status === "success") {
            resolve({
                status: status
            });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     *
     * @deprecated Please use `disabledUntil` from @sentry/utils
     */ BaseTransport.prototype._disabledUntil = function(requestType) {
        var category = $87738c08e97a0c44$var$requestTypeToCategory(requestType);
        return new Date((0, $6n6df.disabledUntil)(this._rateLimits, category));
    };
    /**
     * Checks if a category is rate limited
     *
     * @deprecated Please use `isRateLimited` from @sentry/utils
     */ BaseTransport.prototype._isRateLimited = function(requestType) {
        var category = $87738c08e97a0c44$var$requestTypeToCategory(requestType);
        return (0, $6n6df.isRateLimited)(this._rateLimits, category);
    };
    return BaseTransport;
}();

});
parcelRegister("aNuE0", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", function () { return $7dc6404aba78e63d$export$48a8984ec0bf2e44; });
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $7dc6404aba78e63d$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === "undefined" ? true : __SENTRY_DEBUG__;

});

parcelRegister("3y5eO", function(module, exports) {

$parcel$export(module.exports, "getNativeFetchImplementation", function () { return $29589c309b47653f$export$8be2119ce08e3379; });
$parcel$export(module.exports, "sendReport", function () { return $29589c309b47653f$export$84bb63b2c17ec44d; });
parcelRequire("4TfCJ");
var $2LYxa = parcelRequire("2LYxa");
var $fU0Yz = parcelRequire("fU0Yz");
var $jAd8t = parcelRequire("jAd8t");
var $6uhZG = parcelRequire("6uhZG");

var $aNuE0 = parcelRequire("aNuE0");
var $29589c309b47653f$var$global = (0, $fU0Yz.getGlobalObject)();
var $29589c309b47653f$var$cachedFetchImpl;
function $29589c309b47653f$export$8be2119ce08e3379() {
    if ($29589c309b47653f$var$cachedFetchImpl) return $29589c309b47653f$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $jAd8t.isNativeFetch)($29589c309b47653f$var$global.fetch)) return $29589c309b47653f$var$cachedFetchImpl = $29589c309b47653f$var$global.fetch.bind($29589c309b47653f$var$global);
    var document = $29589c309b47653f$var$global.document;
    var fetchImpl = $29589c309b47653f$var$global.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        var sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $aNuE0.IS_DEBUG_BUILD) && (0, $6uhZG.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    return $29589c309b47653f$var$cachedFetchImpl = fetchImpl.bind($29589c309b47653f$var$global);
/* eslint-enable @typescript-eslint/unbound-method */ }
function $29589c309b47653f$export$84bb63b2c17ec44d(url, body) {
    var isRealNavigator = Object.prototype.toString.call($29589c309b47653f$var$global && $29589c309b47653f$var$global.navigator) === "[object Navigator]";
    var hasSendBeacon = isRealNavigator && typeof $29589c309b47653f$var$global.navigator.sendBeacon === "function";
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = $29589c309b47653f$var$global.navigator.sendBeacon.bind($29589c309b47653f$var$global.navigator);
        return sendBeacon(url, body);
    }
    if ((0, $jAd8t.supportsFetch)()) {
        var fetch_1 = $29589c309b47653f$export$8be2119ce08e3379();
        return (0, $2LYxa.forget)(fetch_1(url, {
            body: body,
            method: "POST",
            credentials: "omit",
            keepalive: true
        }));
    }
}

});



parcelRegister("lk4e6", function(module, exports) {

$parcel$export(module.exports, "makeNewFetchTransport", function () { return $f85ebe7ed1e07e04$export$1c57e6bfd09bad13; });

var $l5MLt = parcelRequire("l5MLt");

var $qwXMq = parcelRequire("qwXMq");

var $3y5eO = parcelRequire("3y5eO");
function $f85ebe7ed1e07e04$export$1c57e6bfd09bad13(options, nativeFetch) {
    if (nativeFetch === void 0) nativeFetch = (0, $3y5eO.getNativeFetchImplementation)();
    function makeRequest(request) {
        var requestOptions = (0, $l5MLt.__assign)({
            body: request.body,
            method: "POST",
            referrerPolicy: "origin"
        }, options.requestOptions);
        return nativeFetch(options.url, requestOptions).then(function(response) {
            return response.text().then(function(body) {
                return {
                    body: body,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    },
                    reason: response.statusText,
                    statusCode: response.status
                };
            });
        });
    }
    return (0, $qwXMq.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});
parcelRegister("qwXMq", function(module, exports) {

$parcel$export(module.exports, "createTransport", function () { return $04fbffa059a49e63$export$d09f50d9ab7f7b69; });
parcelRequire("4TfCJ");
var $6n6df = parcelRequire("6n6df");
var $jIt7f = parcelRequire("jIt7f");
var $6MTdb = parcelRequire("6MTdb");
var $3UOOR = parcelRequire("3UOOR");
var $eFWdY = parcelRequire("eFWdY");
var $04fbffa059a49e63$export$d8a725a7dce95622 = "error";
var $04fbffa059a49e63$export$99adc6fe67a3c63e = "transaction";
var $04fbffa059a49e63$export$9d7ad34f132fe68f = "attachment";
var $04fbffa059a49e63$export$42d9e7b5fc564c45 = "session";
var $04fbffa059a49e63$export$e515cf6dfd2f98b8 = 30;
function $04fbffa059a49e63$export$d09f50d9ab7f7b69(options, makeRequest, buffer) {
    if (buffer === void 0) buffer = (0, $3UOOR.makePromiseBuffer)(options.bufferSize || $04fbffa059a49e63$export$e515cf6dfd2f98b8);
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    function send(envelope) {
        var envCategory = (0, $6MTdb.getEnvelopeType)(envelope);
        var category = envCategory === "event" ? "error" : envCategory;
        var request = {
            category: category,
            body: (0, $6MTdb.serializeEnvelope)(envelope)
        };
        // Don't add to buffer if transport is already rate-limited
        if ((0, $6n6df.isRateLimited)(rateLimits, category)) return (0, $eFWdY.rejectedSyncPromise)({
            status: "rate_limit",
            reason: $04fbffa059a49e63$var$getRateLimitReason(rateLimits, category)
        });
        var requestTask = function() {
            return makeRequest(request).then(function(_a) {
                var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
                var status = (0, $jIt7f.eventStatusFromHttpCode)(statusCode);
                if (headers) rateLimits = (0, $6n6df.updateRateLimits)(rateLimits, headers);
                if (status === "success") return (0, $eFWdY.resolvedSyncPromise)({
                    status: status,
                    reason: reason
                });
                return (0, $eFWdY.rejectedSyncPromise)({
                    status: status,
                    reason: reason || body || (status === "rate_limit" ? $04fbffa059a49e63$var$getRateLimitReason(rateLimits, category) : "Unknown transport error")
                });
            });
        };
        return buffer.add(requestTask);
    }
    return {
        send: send,
        flush: flush
    };
}
function $04fbffa059a49e63$var$getRateLimitReason(rateLimits, category) {
    return "Too many " + category + " requests, backing off until: " + new Date((0, $6n6df.disabledUntil)(rateLimits, category)).toISOString();
}

});


parcelRegister("a8gGK", function(module, exports) {

$parcel$export(module.exports, "makeNewXHRTransport", function () { return $760798b3969491a3$export$4c0ac1dd4bbf4921; });

var $qwXMq = parcelRequire("qwXMq");
parcelRequire("4TfCJ");
var $eFWdY = parcelRequire("eFWdY");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ var $760798b3969491a3$var$XHR_READYSTATE_DONE = 4;
function $760798b3969491a3$export$4c0ac1dd4bbf4921(options) {
    function makeRequest(request) {
        return new (0, $eFWdY.SyncPromise)(function(resolve, _reject) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (xhr.readyState === $760798b3969491a3$var$XHR_READYSTATE_DONE) {
                    var response = {
                        body: xhr.response,
                        headers: {
                            "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                            "retry-after": xhr.getResponseHeader("Retry-After")
                        },
                        reason: xhr.statusText,
                        statusCode: xhr.status
                    };
                    resolve(response);
                }
            };
            xhr.open("POST", options.url);
            for(var header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $qwXMq.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});

parcelRegister("iBm6I", function(module, exports) {

$parcel$export(module.exports, "XHRTransport", function () { return $d8acd4c1da0a847c$export$874a283af77e8e62; });

var $l5MLt = parcelRequire("l5MLt");
parcelRequire("4TfCJ");
var $7B1Bh = parcelRequire("7B1Bh");
var $eFWdY = parcelRequire("eFWdY");

var $bD0gR = parcelRequire("bD0gR");
/** `XHR` based transport */ var $d8acd4c1da0a847c$export$874a283af77e8e62 = /** @class */ function(_super) {
    (0, $l5MLt.__extends)(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ XHRTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent("ratelimit_backoff", sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        return this._buffer.add(function() {
            return new (0, $eFWdY.SyncPromise)(function(resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function() {
                    if (request.readyState === 4) {
                        var headers = {
                            "x-sentry-rate-limits": request.getResponseHeader("X-Sentry-Rate-Limits"),
                            "retry-after": request.getResponseHeader("Retry-After")
                        };
                        _this._handleResponse({
                            requestType: sentryRequest.type,
                            response: request,
                            headers: headers,
                            resolve: resolve,
                            reject: reject
                        });
                    }
                };
                request.open("POST", sentryRequest.url);
                for(var header in _this.options.headers)if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) request.setRequestHeader(header, _this.options.headers[header]);
                request.send(sentryRequest.body);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $7B1Bh.SentryError)) _this.recordLostEvent("queue_overflow", sentryRequest.type);
            else _this.recordLostEvent("network_error", sentryRequest.type);
            throw reason;
        });
    };
    return XHRTransport;
}((0, $bD0gR.BaseTransport));

});


parcelRegister("aHBFP", function(module, exports) {

$parcel$export(module.exports, "shouldIgnoreOnError", function () { return $7cab24b67d60cd40$export$b79738ab10c590b2; });
$parcel$export(module.exports, "wrap", function () { return $7cab24b67d60cd40$export$4997ffc0176396a6; });
$parcel$export(module.exports, "injectReportDialog", function () { return $7cab24b67d60cd40$export$deb9aac8ea0b576c; });

var $l5MLt = parcelRequire("l5MLt");

var $3XbtU = parcelRequire("3XbtU");
var $fQ7ke = parcelRequire("fQ7ke");
parcelRequire("4TfCJ");
var $49X0E = parcelRequire("49X0E");
var $QXRHa = parcelRequire("QXRHa");
var $fU0Yz = parcelRequire("fU0Yz");
var $6uhZG = parcelRequire("6uhZG");

var $aNuE0 = parcelRequire("aNuE0");
var $7cab24b67d60cd40$var$global = (0, $fU0Yz.getGlobalObject)();
var $7cab24b67d60cd40$var$ignoreOnError = 0;
function $7cab24b67d60cd40$export$b79738ab10c590b2() {
    return $7cab24b67d60cd40$var$ignoreOnError > 0;
}
function $7cab24b67d60cd40$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $7cab24b67d60cd40$var$ignoreOnError += 1;
    setTimeout(function() {
        $7cab24b67d60cd40$var$ignoreOnError -= 1;
    });
}
function $7cab24b67d60cd40$export$4997ffc0176396a6(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) options = {};
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $QXRHa.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return $7cab24b67d60cd40$export$4997ffc0176396a6(arg, options);
            });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $7cab24b67d60cd40$export$1265a142ff5ba165();
            (0, $3XbtU.withScope)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0, $49X0E.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $49X0E.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $3XbtU.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $QXRHa.markFunctionWrapped)(sentryWrapped, fn);
    (0, $QXRHa.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get: function() {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}
function $7cab24b67d60cd40$export$deb9aac8ea0b576c(options) {
    if (options === void 0) options = {};
    if (!$7cab24b67d60cd40$var$global.document) return;
    if (!options.eventId) {
        (0, $aNuE0.IS_DEBUG_BUILD) && (0, $6uhZG.logger).error("Missing eventId option in showReportDialog call");
        return;
    }
    if (!options.dsn) {
        (0, $aNuE0.IS_DEBUG_BUILD) && (0, $6uhZG.logger).error("Missing dsn option in showReportDialog call");
        return;
    }
    var script = $7cab24b67d60cd40$var$global.document.createElement("script");
    script.async = true;
    script.src = (0, $fQ7ke.getReportDialogEndpoint)(options.dsn, options);
    if (options.onLoad) // eslint-disable-next-line @typescript-eslint/unbound-method
    script.onload = options.onLoad;
    var injectionPoint = $7cab24b67d60cd40$var$global.document.head || $7cab24b67d60cd40$var$global.document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
}

});
parcelRegister("3XbtU", function(module, exports) {

$parcel$export(module.exports, "captureException", function () { return $2e0fc9c273b6a272$export$f5282963edea4a68; });
$parcel$export(module.exports, "captureMessage", function () { return $2e0fc9c273b6a272$export$45654777c133ae80; });
$parcel$export(module.exports, "captureEvent", function () { return $2e0fc9c273b6a272$export$1462b974fdcf6ba2; });
$parcel$export(module.exports, "configureScope", function () { return $2e0fc9c273b6a272$export$99d44f04437e9cb8; });
$parcel$export(module.exports, "addBreadcrumb", function () { return $2e0fc9c273b6a272$export$efda9a273d7a036d; });
$parcel$export(module.exports, "setContext", function () { return $2e0fc9c273b6a272$export$2f04de43fe27971a; });
$parcel$export(module.exports, "setExtras", function () { return $2e0fc9c273b6a272$export$bb4922da0dd51b92; });
$parcel$export(module.exports, "setTags", function () { return $2e0fc9c273b6a272$export$74a8fb34822092e6; });
$parcel$export(module.exports, "setExtra", function () { return $2e0fc9c273b6a272$export$8e8e7789d42ed61d; });
$parcel$export(module.exports, "setTag", function () { return $2e0fc9c273b6a272$export$a37d07ee78eb4569; });
$parcel$export(module.exports, "setUser", function () { return $2e0fc9c273b6a272$export$8b6bb3dd62a01be2; });
$parcel$export(module.exports, "withScope", function () { return $2e0fc9c273b6a272$export$ec58d9285c204497; });
$parcel$export(module.exports, "startTransaction", function () { return $2e0fc9c273b6a272$export$e262da7ae6480481; });

var $l5MLt = parcelRequire("l5MLt");

var $4IkmO = parcelRequire("4IkmO");
/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2e0fc9c273b6a272$var$callOnHub(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var hub = (0, $4IkmO.getCurrentHub)();
    if (hub && hub[method]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return hub[method].apply(hub, (0, $l5MLt.__spread)(args));
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
function $2e0fc9c273b6a272$export$f5282963edea4a68(exception, captureContext) {
    var syntheticException = new Error("Sentry syntheticException");
    return $2e0fc9c273b6a272$var$callOnHub("captureException", exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException
    });
}
function $2e0fc9c273b6a272$export$45654777c133ae80(message, captureContext) {
    var syntheticException = new Error(message);
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === "string" ? captureContext : undefined;
    var context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    return $2e0fc9c273b6a272$var$callOnHub("captureMessage", message, level, (0, $l5MLt.__assign)({
        originalException: message,
        syntheticException: syntheticException
    }, context));
}
function $2e0fc9c273b6a272$export$1462b974fdcf6ba2(event) {
    return $2e0fc9c273b6a272$var$callOnHub("captureEvent", event);
}
function $2e0fc9c273b6a272$export$99d44f04437e9cb8(callback) {
    $2e0fc9c273b6a272$var$callOnHub("configureScope", callback);
}
function $2e0fc9c273b6a272$export$efda9a273d7a036d(breadcrumb) {
    $2e0fc9c273b6a272$var$callOnHub("addBreadcrumb", breadcrumb);
}
function $2e0fc9c273b6a272$export$2f04de43fe27971a(name, context) {
    $2e0fc9c273b6a272$var$callOnHub("setContext", name, context);
}
function $2e0fc9c273b6a272$export$bb4922da0dd51b92(extras) {
    $2e0fc9c273b6a272$var$callOnHub("setExtras", extras);
}
function $2e0fc9c273b6a272$export$74a8fb34822092e6(tags) {
    $2e0fc9c273b6a272$var$callOnHub("setTags", tags);
}
function $2e0fc9c273b6a272$export$8e8e7789d42ed61d(key, extra) {
    $2e0fc9c273b6a272$var$callOnHub("setExtra", key, extra);
}
function $2e0fc9c273b6a272$export$a37d07ee78eb4569(key, value) {
    $2e0fc9c273b6a272$var$callOnHub("setTag", key, value);
}
function $2e0fc9c273b6a272$export$8b6bb3dd62a01be2(user) {
    $2e0fc9c273b6a272$var$callOnHub("setUser", user);
}
function $2e0fc9c273b6a272$export$ec58d9285c204497(callback) {
    $2e0fc9c273b6a272$var$callOnHub("withScope", callback);
}
function $2e0fc9c273b6a272$export$5b9bc6fc91daaf9f(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    $2e0fc9c273b6a272$var$callOnHub.apply(void 0, (0, $l5MLt.__spread)([
        "_invokeClient",
        method
    ], args));
}
function $2e0fc9c273b6a272$export$e262da7ae6480481(context, customSamplingContext) {
    return $2e0fc9c273b6a272$var$callOnHub("startTransaction", (0, $l5MLt.__assign)({}, context), customSamplingContext);
}

});


parcelRegister("6ZyCi", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", function () { return $51734ac0387cfb87$export$2dc68d50d56fbbd; });

var $l5MLt = parcelRequire("l5MLt");

var $4IkmO = parcelRequire("4IkmO");

var $i3ov7 = parcelRequire("i3ov7");
parcelRequire("4TfCJ");
var $fMu7V = parcelRequire("fMu7V");
var $49X0E = parcelRequire("49X0E");
var $fU0Yz = parcelRequire("fU0Yz");
var $hPLeT = parcelRequire("hPLeT");
var $5Q0pQ = parcelRequire("5Q0pQ");
var $1s3gX = parcelRequire("1s3gX");
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ var $51734ac0387cfb87$export$2dc68d50d56fbbd = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */ this.name = Breadcrumbs.id;
        this._options = (0, $l5MLt.__assign)({
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true
        }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */ Breadcrumbs.prototype.addSentryBreadcrumb = function(event) {
        if (!this._options.sentry) return;
        (0, $4IkmO.getCurrentHub)().addBreadcrumb({
            category: "sentry." + (event.type === "transaction" ? "transaction" : "event"),
            event_id: event.event_id,
            level: event.level,
            message: (0, $49X0E.getEventDescription)(event)
        }, {
            event: event
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */ Breadcrumbs.prototype.setupOnce = function() {
        if (this._options.console) (0, $fMu7V.addInstrumentationHandler)("console", $51734ac0387cfb87$var$_consoleBreadcrumb);
        if (this._options.dom) (0, $fMu7V.addInstrumentationHandler)("dom", $51734ac0387cfb87$var$_domBreadcrumb(this._options.dom));
        if (this._options.xhr) (0, $fMu7V.addInstrumentationHandler)("xhr", $51734ac0387cfb87$var$_xhrBreadcrumb);
        if (this._options.fetch) (0, $fMu7V.addInstrumentationHandler)("fetch", $51734ac0387cfb87$var$_fetchBreadcrumb);
        if (this._options.history) (0, $fMu7V.addInstrumentationHandler)("history", $51734ac0387cfb87$var$_historyBreadcrumb);
    };
    /**
     * @inheritDoc
     */ Breadcrumbs.id = "Breadcrumbs";
    return Breadcrumbs;
}();
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $51734ac0387cfb87$var$_domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target ? (0, $hPLeT.htmlTreeAsString)(handlerData.event.target, keyAttrs) : (0, $hPLeT.htmlTreeAsString)(handlerData.event, keyAttrs);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        (0, $4IkmO.getCurrentHub)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $51734ac0387cfb87$var$_consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: "console",
        data: {
            arguments: handlerData.args,
            logger: "console"
        },
        level: (0, $1s3gX.severityFromString)(handlerData.level),
        message: (0, $5Q0pQ.safeJoin)(handlerData.args, " ")
    };
    if (handlerData.level === "assert") {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + ((0, $5Q0pQ.safeJoin)(handlerData.args.slice(1), " ") || "console.assert");
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $4IkmO.getCurrentHub)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $51734ac0387cfb87$var$_xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) return;
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        (0, $4IkmO.getCurrentHub)().addBreadcrumb({
            category: "xhr",
            data: {
                method: method,
                url: url,
                status_code: status_code
            },
            type: "http"
        }, {
            xhr: handlerData.xhr,
            input: body
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $51734ac0387cfb87$var$_fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) (0, $4IkmO.getCurrentHub)().addBreadcrumb({
        category: "fetch",
        data: handlerData.fetchData,
        level: (0, $i3ov7.Severity).Error,
        type: "http"
    }, {
        data: handlerData.error,
        input: handlerData.args
    });
    else (0, $4IkmO.getCurrentHub)().addBreadcrumb({
        category: "fetch",
        data: (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, handlerData.fetchData), {
            status_code: handlerData.response.status
        }),
        type: "http"
    }, {
        input: handlerData.args,
        response: handlerData.response
    });
}
/**
 * Creates breadcrumbs from history API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $51734ac0387cfb87$var$_historyBreadcrumb(handlerData) {
    var global = (0, $fU0Yz.getGlobalObject)();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = (0, $49X0E.parseUrl)(global.location.href);
    var parsedFrom = (0, $49X0E.parseUrl)(from);
    var parsedTo = (0, $49X0E.parseUrl)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $4IkmO.getCurrentHub)().addBreadcrumb({
        category: "navigation",
        data: {
            from: from,
            to: to
        }
    });
}

});


parcelRegister("lRlFX", function(module, exports) {

$parcel$export(module.exports, "Dedupe", function () { return $fe9f5c8b7916be26$export$688d98c249d31ad3; });
parcelRequire("8Hjyf");
var $hvFeM = parcelRequire("hvFeM");

var $dUraT = parcelRequire("dUraT");
/** Deduplication filter */ var $fe9f5c8b7916be26$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($fe9f5c8b7916be26$export$3c6361fddf6cd929(currentEvent, self._previousEvent)) {
                        (0, $dUraT.IS_DEBUG_BUILD) && (0, $hvFeM.logger).warn("Event dropped due to being a duplicate of previously captured event.");
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = "Dedupe";
    return Dedupe;
}();
function $fe9f5c8b7916be26$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($fe9f5c8b7916be26$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($fe9f5c8b7916be26$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $fe9f5c8b7916be26$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$fe9f5c8b7916be26$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$fe9f5c8b7916be26$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $fe9f5c8b7916be26$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $fe9f5c8b7916be26$var$_getExceptionFromEvent(previousEvent);
    var currentException = $fe9f5c8b7916be26$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$fe9f5c8b7916be26$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$fe9f5c8b7916be26$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $fe9f5c8b7916be26$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $fe9f5c8b7916be26$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $fe9f5c8b7916be26$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $fe9f5c8b7916be26$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $fe9f5c8b7916be26$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $fe9f5c8b7916be26$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}

});
parcelRegister("8Hjyf", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", function () { return (parcelRequire("ibb0d")).getGlobalObject; });
$parcel$export(module.exports, "isError", function () { return (parcelRequire("kv7sQ")).isError; });
$parcel$export(module.exports, "isInstanceOf", function () { return (parcelRequire("kv7sQ")).isInstanceOf; });
$parcel$export(module.exports, "isPlainObject", function () { return (parcelRequire("kv7sQ")).isPlainObject; });
$parcel$export(module.exports, "CONSOLE_LEVELS", function () { return (parcelRequire("hvFeM")).CONSOLE_LEVELS; });
$parcel$export(module.exports, "consoleSandbox", function () { return (parcelRequire("hvFeM")).consoleSandbox; });
$parcel$export(module.exports, "logger", function () { return (parcelRequire("hvFeM")).logger; });
$parcel$export(module.exports, "uuid4", function () { return (parcelRequire("iRVKO")).uuid4; });
$parcel$export(module.exports, "normalize", function () { return (parcelRequire("2ekk0")).normalize; });
$parcel$export(module.exports, "fill", function () { return (parcelRequire("UVxy6")).fill; });
$parcel$export(module.exports, "basename", function () { return (parcelRequire("dDyy4")).basename; });
$parcel$export(module.exports, "relative", function () { return (parcelRequire("dDyy4")).relative; });
$parcel$export(module.exports, "severityFromString", function () { return (parcelRequire("lvXAL")).severityFromString; });
$parcel$export(module.exports, "safeJoin", function () { return (parcelRequire("8rOgB")).safeJoin; });
$parcel$export(module.exports, "supportsReportingObserver", function () { return (parcelRequire("ej7pe")).supportsReportingObserver; });





parcelRequire("ibb0d");

parcelRequire("kv7sQ");
parcelRequire("hvFeM");

parcelRequire("iRVKO");

var $aN6Uu = parcelRequire("aN6Uu");
parcelRequire("2ekk0");
parcelRequire("UVxy6");
parcelRequire("dDyy4");

parcelRequire("lvXAL");


parcelRequire("8rOgB");
parcelRequire("ej7pe");


var $eB9Df = parcelRequire("eB9Df");





$parcel$exportWildcard(module.exports, $aN6Uu);
$parcel$exportWildcard(module.exports, $eB9Df);

});
parcelRegister("ibb0d", function(module, exports) {

$parcel$export(module.exports, "getGlobalObject", function () { return $d3c1c9f35c911e65$export$256479dc0cea61c4; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $d3c1c9f35c911e65$export$7e223ec222791509; });
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $aN6Uu = parcelRequire("aN6Uu");
var $d3c1c9f35c911e65$var$fallbackGlobalObject = {};
function $d3c1c9f35c911e65$export$256479dc0cea61c4() {
    return (0, $aN6Uu.isNodeEnv)() ? $parcel$global : typeof window !== "undefined" // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== "undefined" ? self : $d3c1c9f35c911e65$var$fallbackGlobalObject;
}
function $d3c1c9f35c911e65$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $d3c1c9f35c911e65$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("aN6Uu", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; }, function (v) { return isNodeEnv = v; });
$parcel$export(module.exports, "dynamicRequire", function () { return dynamicRequire; }, function (v) { return dynamicRequire = v; });
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $5CMcT = parcelRequire("5CMcT");

var $8ovux = parcelRequire("8ovux");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $5CMcT.isBrowserBundle)() && Object.prototype.toString.call(typeof $8ovux !== "undefined" ? $8ovux : 0) === "[object process]";
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, "process").cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("5CMcT", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $4185e544e045b40c$export$2928c40372e623c0; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $4185e544e045b40c$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("kv7sQ", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $eecc7e1f5a2b7dc1$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $eecc7e1f5a2b7dc1$export$49034edbe6b62415; });
$parcel$export(module.exports, "isString", function () { return $eecc7e1f5a2b7dc1$export$844ec244b1367d54; });
$parcel$export(module.exports, "isPrimitive", function () { return $eecc7e1f5a2b7dc1$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $eecc7e1f5a2b7dc1$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $eecc7e1f5a2b7dc1$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $eecc7e1f5a2b7dc1$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $eecc7e1f5a2b7dc1$export$49841c62b9eff15; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $eecc7e1f5a2b7dc1$export$bc2894c7158efbac; });
$parcel$export(module.exports, "isNaN", function () { return $eecc7e1f5a2b7dc1$export$c9f5652083b8129d; });
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $eecc7e1f5a2b7dc1$var$objectToString = Object.prototype.toString;
function $eecc7e1f5a2b7dc1$export$e6127cc7fe7395c3(wat) {
    switch($eecc7e1f5a2b7dc1$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $eecc7e1f5a2b7dc1$export$49034edbe6b62415(wat, Error);
    }
}
function $eecc7e1f5a2b7dc1$var$isBuiltin(wat, ty) {
    return $eecc7e1f5a2b7dc1$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $eecc7e1f5a2b7dc1$export$9f9636d330b71954(wat) {
    return $eecc7e1f5a2b7dc1$var$isBuiltin(wat, "ErrorEvent");
}
function $eecc7e1f5a2b7dc1$export$ef9e2056653f0c8e(wat) {
    return $eecc7e1f5a2b7dc1$var$isBuiltin(wat, "DOMError");
}
function $eecc7e1f5a2b7dc1$export$12e869b2a583f783(wat) {
    return $eecc7e1f5a2b7dc1$var$isBuiltin(wat, "DOMException");
}
function $eecc7e1f5a2b7dc1$export$844ec244b1367d54(wat) {
    return $eecc7e1f5a2b7dc1$var$isBuiltin(wat, "String");
}
function $eecc7e1f5a2b7dc1$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== "object" && typeof wat !== "function";
}
function $eecc7e1f5a2b7dc1$export$53b83ca8eaab0383(wat) {
    return $eecc7e1f5a2b7dc1$var$isBuiltin(wat, "Object");
}
function $eecc7e1f5a2b7dc1$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $eecc7e1f5a2b7dc1$export$49034edbe6b62415(wat, Event);
}
function $eecc7e1f5a2b7dc1$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $eecc7e1f5a2b7dc1$export$49034edbe6b62415(wat, Element);
}
function $eecc7e1f5a2b7dc1$export$49841c62b9eff15(wat) {
    return $eecc7e1f5a2b7dc1$var$isBuiltin(wat, "RegExp");
}
function $eecc7e1f5a2b7dc1$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
function $eecc7e1f5a2b7dc1$export$bc2894c7158efbac(wat) {
    return $eecc7e1f5a2b7dc1$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $eecc7e1f5a2b7dc1$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
function $eecc7e1f5a2b7dc1$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});

parcelRegister("hvFeM", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", function () { return $cbf551cf592a33d2$export$2a2b1d2252a69ecb; });
$parcel$export(module.exports, "consoleSandbox", function () { return $cbf551cf592a33d2$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "logger", function () { return $cbf551cf592a33d2$export$af88d00dbe7f521; });

var $l5MLt = parcelRequire("l5MLt");

var $QrNvV = parcelRequire("QrNvV");

var $ibb0d = parcelRequire("ibb0d");
// TODO: Implement different loggers for different environments
var $cbf551cf592a33d2$var$global = (0, $ibb0d.getGlobalObject)();
/** Prefix for logging strings */ var $cbf551cf592a33d2$var$PREFIX = "Sentry Logger ";
var $cbf551cf592a33d2$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert"
];
function $cbf551cf592a33d2$export$cda52e2a8927a2ca(callback) {
    var global = (0, $ibb0d.getGlobalObject)();
    if (!("console" in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $cbf551cf592a33d2$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $cbf551cf592a33d2$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $QrNvV.IS_DEBUG_BUILD) $cbf551cf592a33d2$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $cbf551cf592a33d2$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $cbf551cf592a33d2$var$global.console)[name].apply(_a, (0, $l5MLt.__spread)([
                    $cbf551cf592a33d2$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $cbf551cf592a33d2$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $cbf551cf592a33d2$export$af88d00dbe7f521;
if (0, $QrNvV.IS_DEBUG_BUILD) $cbf551cf592a33d2$export$af88d00dbe7f521 = (0, $ibb0d.getGlobalSingleton)("logger", $cbf551cf592a33d2$var$makeLogger);
else $cbf551cf592a33d2$export$af88d00dbe7f521 = $cbf551cf592a33d2$var$makeLogger();

});
parcelRegister("QrNvV", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", function () { return $09da6b78483dbfc8$export$48a8984ec0bf2e44; });
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $09da6b78483dbfc8$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === "undefined" ? true : __SENTRY_DEBUG__;

});


parcelRegister("iRVKO", function(module, exports) {

$parcel$export(module.exports, "uuid4", function () { return $dbc9f9f4ea7f98c1$export$19f53698e68b2496; });

var $l5MLt = parcelRequire("l5MLt");

var $ibb0d = parcelRequire("ibb0d");

var $UVxy6 = parcelRequire("UVxy6");

var $8rOgB = parcelRequire("8rOgB");
function $dbc9f9f4ea7f98c1$export$19f53698e68b2496() {
    var global = (0, $ibb0d.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $dbc9f9f4ea7f98c1$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || "";
    var fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $dbc9f9f4ea7f98c1$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $dbc9f9f4ea7f98c1$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $dbc9f9f4ea7f98c1$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $dbc9f9f4ea7f98c1$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $dbc9f9f4ea7f98c1$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $dbc9f9f4ea7f98c1$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: "generic",
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $l5MLt.__assign)((0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && "data" in newMechanism) {
        var mergedData = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $dbc9f9f4ea7f98c1$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $dbc9f9f4ea7f98c1$export$d364f2020ab30578(input) {
    var match = input.match($dbc9f9f4ea7f98c1$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $dbc9f9f4ea7f98c1$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $8rOgB.snipLine)(line, 0);
    });
    frame.context_line = (0, $8rOgB.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $8rOgB.snipLine)(line, 0);
    });
}
function $dbc9f9f4ea7f98c1$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $dbc9f9f4ea7f98c1$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $UVxy6.addNonEnumerableProperty)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});
parcelRegister("UVxy6", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $0ab1dd585f178602$export$9563e054e6f787fb; });
$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $0ab1dd585f178602$export$e73679ffaf56810e; });
$parcel$export(module.exports, "convertToPlainObject", function () { return $0ab1dd585f178602$export$62ff257738bf57f5; });

var $l5MLt = parcelRequire("l5MLt");

var $6kvzA = parcelRequire("6kvzA");

var $kv7sQ = parcelRequire("kv7sQ");

var $8rOgB = parcelRequire("8rOgB");
function $0ab1dd585f178602$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") try {
        $0ab1dd585f178602$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $0ab1dd585f178602$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $0ab1dd585f178602$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $0ab1dd585f178602$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
}
function $0ab1dd585f178602$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $0ab1dd585f178602$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join("&");
}
function $0ab1dd585f178602$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $kv7sQ.isError)(value)) newObj = (0, $l5MLt.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $0ab1dd585f178602$var$getOwnProperties(value));
    else if ((0, $kv7sQ.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $l5MLt.__assign)({
            type: event_1.type,
            target: $0ab1dd585f178602$var$serializeEventTarget(event_1.target),
            currentTarget: $0ab1dd585f178602$var$serializeEventTarget(event_1.currentTarget)
        }, $0ab1dd585f178602$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== "undefined" && (0, $kv7sQ.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $0ab1dd585f178602$var$serializeEventTarget(target) {
    try {
        return (0, $kv7sQ.isElement)(target) ? (0, $6kvzA.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $0ab1dd585f178602$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $0ab1dd585f178602$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($0ab1dd585f178602$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $8rOgB.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $8rOgB.truncate)(serialized, maxLength);
    }
    return "";
}
function $0ab1dd585f178602$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $kv7sQ.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $l5MLt.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== "undefined") rv[key] = $0ab1dd585f178602$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($0ab1dd585f178602$export$d25f2688db1bb433);
    return val;
}
function $0ab1dd585f178602$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $kv7sQ.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("6kvzA", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $49bd1a0d721711ac$export$5647df6b7814ac86; });

var $ibb0d = parcelRequire("ibb0d");

var $kv7sQ = parcelRequire("kv7sQ");
function $49bd1a0d721711ac$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = " > ";
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $49bd1a0d721711ac$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $49bd1a0d721711ac$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return "";
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + '="' + keyAttrPair[1] + '"]');
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $kv7sQ.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + '="' + attr + '"]');
    }
    return out.join("");
}
function $49bd1a0d721711ac$export$1cfafeee2987818b() {
    var global = (0, $ibb0d.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return "";
    }
}

});

parcelRegister("8rOgB", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $6267d649fdd1f584$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $6267d649fdd1f584$export$4215662d762d6f9d; });
$parcel$export(module.exports, "safeJoin", function () { return $6267d649fdd1f584$export$465e9d514283d4fd; });

var $kv7sQ = parcelRequire("kv7sQ");
function $6267d649fdd1f584$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $6267d649fdd1f584$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $6267d649fdd1f584$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
function $6267d649fdd1f584$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $kv7sQ.isString)(value)) return false;
    if ((0, $kv7sQ.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === "string") return value.indexOf(pattern) !== -1;
    return false;
}
function $6267d649fdd1f584$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}

});



parcelRegister("2ekk0", function(module, exports) {

$parcel$export(module.exports, "normalize", function () { return $19fca703f5ac1a60$export$a3295358bff77e; });

var $l5MLt = parcelRequire("l5MLt");

var $kv7sQ = parcelRequire("kv7sQ");

var $lsu6Q = parcelRequire("lsu6Q");

var $UVxy6 = parcelRequire("UVxy6");

var $dvP8D = parcelRequire("dvP8D");
function $19fca703f5ac1a60$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $19fca703f5ac1a60$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $19fca703f5ac1a60$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $19fca703f5ac1a60$export$a3295358bff77e(object, depth);
    if ($19fca703f5ac1a60$var$jsonSize(normalized) > maxSize) return $19fca703f5ac1a60$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $19fca703f5ac1a60$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $lsu6Q.memoBuilder)();
    var _a = (0, $l5MLt.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $kv7sQ.isNaN)(value)) return value;
    var stringified = $19fca703f5ac1a60$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $kv7sQ.isError)(value) || (0, $kv7sQ.isEvent)(value) ? (0, $UVxy6.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $19fca703f5ac1a60$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $19fca703f5ac1a60$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        // React's SyntheticEvent thingy
        if ((0, $kv7sQ.isSyntheticEvent)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return "[undefined]";
        if (typeof value === "function") return "[Function: " + (0, $dvP8D.getFunctionName)(value) + "]";
        if (typeof value === "symbol") return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $19fca703f5ac1a60$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $19fca703f5ac1a60$var$jsonSize(value) {
    return $19fca703f5ac1a60$var$utf8Length(JSON.stringify(value));
}

});
parcelRegister("lsu6Q", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", function () { return $f9f39193387b3d82$export$8115b0b78e956ab3; });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $f9f39193387b3d82$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === "function";
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("dvP8D", function(module, exports) {

$parcel$export(module.exports, "getFunctionName", function () { return $9d65d6a2257540d8$export$aad197c7121a6651; });

var $l5MLt = parcelRequire("l5MLt");
var $9d65d6a2257540d8$var$STACKTRACE_LIMIT = 50;
function $9d65d6a2257540d8$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $l5MLt.__values)(stack.split("\n").slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $l5MLt.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $9d65d6a2257540d8$export$c55c24c0eeba0205(frames);
    };
}
function $9d65d6a2257540d8$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || "";
    var lastFrameFunction = localStack[localStack.length - 1].function || "";
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf("captureMessage") !== -1 || firstFrameFunction.indexOf("captureException") !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf("sentryWrapped") !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $9d65d6a2257540d8$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || "?"
        });
    }).reverse();
}
var $9d65d6a2257540d8$var$defaultFunctionName = "<anonymous>";
function $9d65d6a2257540d8$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $9d65d6a2257540d8$var$defaultFunctionName;
        return fn.name || $9d65d6a2257540d8$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $9d65d6a2257540d8$var$defaultFunctionName;
    }
}

});


parcelRegister("dDyy4", function(module, exports) {

$parcel$export(module.exports, "relative", function () { return $9ed9b77b8de16a6c$export$f0e7d1106eeabbe6; });
$parcel$export(module.exports, "basename", function () { return $9ed9b77b8de16a6c$export$9bf319d8f74f51d1; });
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
/** JSDoc */ function $9ed9b77b8de16a6c$var$normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = parts.length - 1; i >= 0; i--){
        var last = parts[i];
        if (last === ".") parts.splice(i, 1);
        else if (last === "..") {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up++;
        } else if (up) {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) // eslint-disable-next-line no-plusplus
    for(; up--; up)parts.unshift("..");
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var $9ed9b77b8de16a6c$var$splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
/** JSDoc */ function $9ed9b77b8de16a6c$var$splitPath(filename) {
    var parts = $9ed9b77b8de16a6c$var$splitPathRe.exec(filename);
    return parts ? parts.slice(1) : [];
}
function $9ed9b77b8de16a6c$export$f7ad0328861e2f03() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var resolvedPath = "";
    var resolvedAbsolute = false;
    for(var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        var path = i >= 0 ? args[i] : "/";
        // Skip empty entries
        if (!path) continue;
        resolvedPath = path + "/" + resolvedPath;
        resolvedAbsolute = path.charAt(0) === "/";
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = $9ed9b77b8de16a6c$var$normalizeArray(resolvedPath.split("/").filter(function(p) {
        return !!p;
    }), !resolvedAbsolute).join("/");
    return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
}
/** JSDoc */ function $9ed9b77b8de16a6c$var$trim(arr) {
    var start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== "") break;
    }
    var end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== "") break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
function $9ed9b77b8de16a6c$export$f0e7d1106eeabbe6(from, to) {
    /* eslint-disable no-param-reassign */ from = $9ed9b77b8de16a6c$export$f7ad0328861e2f03(from).substr(1);
    to = $9ed9b77b8de16a6c$export$f7ad0328861e2f03(to).substr(1);
    /* eslint-enable no-param-reassign */ var fromParts = $9ed9b77b8de16a6c$var$trim(from.split("/"));
    var toParts = $9ed9b77b8de16a6c$var$trim(to.split("/"));
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for(var i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    var outputParts = [];
    for(var i = samePartsLength; i < fromParts.length; i++)outputParts.push("..");
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join("/");
}
function $9ed9b77b8de16a6c$export$6af368f973c74c5(path) {
    var isPathAbsolute = $9ed9b77b8de16a6c$export$e434c7255acda994(path);
    var trailingSlash = path.substr(-1) === "/";
    // Normalize the path
    var normalizedPath = $9ed9b77b8de16a6c$var$normalizeArray(path.split("/").filter(function(p) {
        return !!p;
    }), !isPathAbsolute).join("/");
    if (!normalizedPath && !isPathAbsolute) normalizedPath = ".";
    if (normalizedPath && trailingSlash) normalizedPath += "/";
    return (isPathAbsolute ? "/" : "") + normalizedPath;
}
function $9ed9b77b8de16a6c$export$e434c7255acda994(path) {
    return path.charAt(0) === "/";
}
function $9ed9b77b8de16a6c$export$f7e2c8231c57a8bd() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $9ed9b77b8de16a6c$export$6af368f973c74c5(args.join("/"));
}
function $9ed9b77b8de16a6c$export$7f7b8152cc673abe(path) {
    var result = $9ed9b77b8de16a6c$var$splitPath(path);
    var root = result[0];
    var dir = result[1];
    if (!root && !dir) // No dirname whatsoever
    return ".";
    if (dir) // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
    return root + dir;
}
function $9ed9b77b8de16a6c$export$9bf319d8f74f51d1(path, ext) {
    var f = $9ed9b77b8de16a6c$var$splitPath(path)[2];
    if (ext && f.substr(ext.length * -1) === ext) f = f.substr(0, f.length - ext.length);
    return f;
}

});

parcelRegister("lvXAL", function(module, exports) {

$parcel$export(module.exports, "severityFromString", function () { return $fa9ab7efdc6c0358$export$e01cef29b4327697; });

var $i3ov7 = parcelRequire("i3ov7");

var $lMZXX = parcelRequire("lMZXX");
function $fa9ab7efdc6c0358$var$isSupportedSeverity(level) {
    return (0, $lMZXX.SeverityLevels).indexOf(level) !== -1;
}
function $fa9ab7efdc6c0358$export$e01cef29b4327697(level) {
    if (level === "warn") return (0, $i3ov7.Severity).Warning;
    if ($fa9ab7efdc6c0358$var$isSupportedSeverity(level)) return level;
    return (0, $i3ov7.Severity).Log;
}

});
parcelRegister("lMZXX", function(module, exports) {

$parcel$export(module.exports, "SeverityLevels", function () { return $fdce25d76df32c55$export$484b1ea9aec914c; });
var $fdce25d76df32c55$export$484b1ea9aec914c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug",
    "critical"
];

});


parcelRegister("ej7pe", function(module, exports) {

$parcel$export(module.exports, "supportsReportingObserver", function () { return $a6a895b7e12d77e2$export$531055a6c684a70a; });

var $QrNvV = parcelRequire("QrNvV");

var $ibb0d = parcelRequire("ibb0d");

var $hvFeM = parcelRequire("hvFeM");
function $a6a895b7e12d77e2$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
function $a6a895b7e12d77e2$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
function $a6a895b7e12d77e2$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
function $a6a895b7e12d77e2$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in (0, $ibb0d.getGlobalObject)())) return false;
    try {
        new Headers();
        new Request("");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function $a6a895b7e12d77e2$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $a6a895b7e12d77e2$export$c82d238e23c40b21() {
    if (!$a6a895b7e12d77e2$export$edf3cb81fd7d2a3e()) return false;
    var global = (0, $ibb0d.getGlobalObject)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($a6a895b7e12d77e2$export$18cf36ed71d733e7(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        var sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $a6a895b7e12d77e2$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $QrNvV.IS_DEBUG_BUILD) && (0, $hvFeM.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $a6a895b7e12d77e2$export$531055a6c684a70a() {
    return "ReportingObserver" in (0, $ibb0d.getGlobalObject)();
}
function $a6a895b7e12d77e2$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$a6a895b7e12d77e2$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}
function $a6a895b7e12d77e2$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, $ibb0d.getGlobalObject)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = "history" in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});

parcelRegister("eB9Df", function(module, exports) {

$parcel$export(module.exports, "timestampWithMs", function () { return timestampWithMs; }, function (v) { return timestampWithMs = v; });

var $ibb0d = parcelRequire("ibb0d");

var $aN6Uu = parcelRequire("aN6Uu");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $ibb0d.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $aN6Uu.dynamicRequire)(module, "perf_hooks");
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $aN6Uu.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $ibb0d.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = "none";
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = "timeOrigin";
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = "dateNow";
    return dateNow;
}();

});


parcelRegister("dUraT", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", function () { return $a20595a3cce5f4ea$export$48a8984ec0bf2e44; });
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $a20595a3cce5f4ea$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === "undefined" ? true : __SENTRY_DEBUG__;

});


parcelRegister("ciA2E", function(module, exports) {

$parcel$export(module.exports, "ExtraErrorData", function () { return $8f431f9f688cb164$export$56d961ef3a52a072; });

var $l5MLt = parcelRequire("l5MLt");
parcelRequire("8Hjyf");
var $kv7sQ = parcelRequire("kv7sQ");
var $hvFeM = parcelRequire("hvFeM");
var $2ekk0 = parcelRequire("2ekk0");

var $dUraT = parcelRequire("dUraT");
/** Patch toString calls to return proper name for wrapped functions */ var $8f431f9f688cb164$export$56d961ef3a52a072 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function ExtraErrorData(options) {
        /**
         * @inheritDoc
         */ this.name = ExtraErrorData.id;
        this._options = (0, $l5MLt.__assign)({
            depth: 3
        }, options);
    }
    /**
     * @inheritDoc
     */ ExtraErrorData.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event, hint) {
            var self = getCurrentHub().getIntegration(ExtraErrorData);
            if (!self) return event;
            return self.enhanceEventWithErrorData(event, hint);
        });
    };
    /**
     * Attaches extracted information from the Error object to extra field in the Event
     */ ExtraErrorData.prototype.enhanceEventWithErrorData = function(event, hint) {
        var _a;
        if (!hint || !hint.originalException || !(0, $kv7sQ.isError)(hint.originalException)) return event;
        var name = hint.originalException.name || hint.originalException.constructor.name;
        var errorData = this._extractErrorData(hint.originalException);
        if (errorData) {
            var contexts = (0, $l5MLt.__assign)({}, event.contexts);
            var normalizedErrorData = (0, $2ekk0.normalize)(errorData, this._options.depth);
            if ((0, $kv7sQ.isPlainObject)(normalizedErrorData)) contexts = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, event.contexts), (_a = {}, _a[name] = (0, $l5MLt.__assign)({}, normalizedErrorData), _a));
            return (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, event), {
                contexts: contexts
            });
        }
        return event;
    };
    /**
     * Extract extra information from the Error object
     */ ExtraErrorData.prototype._extractErrorData = function(error) {
        var e_1, _a, e_2, _b;
        // We are trying to enhance already existing event, so no harm done if it won't succeed
        try {
            var nativeKeys = [
                "name",
                "message",
                "stack",
                "line",
                "column",
                "fileName",
                "lineNumber",
                "columnNumber",
                "toJSON"
            ];
            var extraErrorInfo = {};
            try {
                // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
                for(var _c = (0, $l5MLt.__values)(Object.keys(error)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var key = _d.value;
                    if (nativeKeys.indexOf(key) !== -1) continue;
                    var value = error[key];
                    extraErrorInfo[key] = (0, $kv7sQ.isError)(value) ? value.toString() : value;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
            if (typeof error.toJSON === "function") {
                var serializedError = error.toJSON();
                try {
                    for(var _e = (0, $l5MLt.__values)(Object.keys(serializedError)), _f = _e.next(); !_f.done; _f = _e.next()){
                        var key = _f.value;
                        var value = serializedError[key];
                        extraErrorInfo[key] = (0, $kv7sQ.isError)(value) ? value.toString() : value;
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            return extraErrorInfo;
        } catch (oO) {
            (0, $dUraT.IS_DEBUG_BUILD) && (0, $hvFeM.logger).error("Unable to extract extra data from the Error object:", oO);
        }
        return null;
    };
    /**
     * @inheritDoc
     */ ExtraErrorData.id = "ExtraErrorData";
    return ExtraErrorData;
}();

});

parcelRegister("gtIV9", function(module, exports) {

$parcel$export(module.exports, "RewriteFrames", function () { return $bff23321a3f74ca6$export$af39fa91d1acf248; });

var $l5MLt = parcelRequire("l5MLt");
parcelRequire("8Hjyf");
var $dDyy4 = parcelRequire("dDyy4");
/** Rewrite event frames paths */ var $bff23321a3f74ca6$export$af39fa91d1acf248 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function RewriteFrames(options) {
        var _this = this;
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = RewriteFrames.id;
        /**
         * @inheritDoc
         */ this._prefix = "app:///";
        /**
         * @inheritDoc
         */ this._iteratee = function(frame) {
            if (!frame.filename) return frame;
            // Check if the frame filename begins with `/` or a Windows-style prefix such as `C:\`
            var isWindowsFrame = /^[A-Z]:\\/.test(frame.filename);
            var startsWithSlash = /^\//.test(frame.filename);
            if (isWindowsFrame || startsWithSlash) {
                var filename = isWindowsFrame ? frame.filename.replace(/^[A-Z]:/, "") // remove Windows-style prefix
                .replace(/\\/g, "/") // replace all `\\` instances with `/`
                 : frame.filename;
                var base = _this._root ? (0, $dDyy4.relative)(_this._root, filename) : (0, $dDyy4.basename)(filename);
                frame.filename = "" + _this._prefix + base;
            }
            return frame;
        };
        if (options.root) this._root = options.root;
        if (options.prefix) this._prefix = options.prefix;
        if (options.iteratee) this._iteratee = options.iteratee;
    }
    /**
     * @inheritDoc
     */ RewriteFrames.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var self = getCurrentHub().getIntegration(RewriteFrames);
            if (self) return self.process(event);
            return event;
        });
    };
    /** JSDoc */ RewriteFrames.prototype.process = function(originalEvent) {
        var processedEvent = originalEvent;
        if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = this._processExceptionsEvent(processedEvent);
        if (originalEvent.stacktrace) processedEvent = this._processStacktraceEvent(processedEvent);
        return processedEvent;
    };
    /** JSDoc */ RewriteFrames.prototype._processExceptionsEvent = function(event) {
        var _this = this;
        try {
            return (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, event), {
                exception: (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, event.exception), {
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map(function(value) {
                        return (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, value), {
                            stacktrace: _this._processStacktrace(value.stacktrace)
                        });
                    })
                })
            });
        } catch (_oO) {
            return event;
        }
    };
    /** JSDoc */ RewriteFrames.prototype._processStacktraceEvent = function(event) {
        try {
            return (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, event), {
                stacktrace: this._processStacktrace(event.stacktrace)
            });
        } catch (_oO) {
            return event;
        }
    };
    /** JSDoc */ RewriteFrames.prototype._processStacktrace = function(stacktrace) {
        var _this = this;
        return (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, stacktrace), {
            frames: stacktrace && stacktrace.frames && stacktrace.frames.map(function(f) {
                return _this._iteratee(f);
            })
        });
    };
    /**
     * @inheritDoc
     */ RewriteFrames.id = "RewriteFrames";
    return RewriteFrames;
}();

});

parcelRegister("1ZBmx", function(module, exports) {

$parcel$export(module.exports, "getSsrState", function () { return $80e073600c742ec7$export$8b26fc8110ba9d33; });
$parcel$export(module.exports, "getSsrStats", function () { return $80e073600c742ec7$export$f59eb203d31e7447; });
$parcel$export(module.exports, "IS_SERVER", function () { return $80e073600c742ec7$export$d2f4d8e74279c212; });
$parcel$export(module.exports, "appWasServerSideRendered", function () { return $80e073600c742ec7$export$642262419f51fae8; });
$parcel$export(module.exports, "canHydrateFromSsr", function () { return $80e073600c742ec7$export$ff492be938a8806a; });
$parcel$export(module.exports, "getInitialOrBucketState", function () { return $80e073600c742ec7$export$230aeef4b9e0f6e3; });
const $80e073600c742ec7$export$93484e5d50f84920 = "__ssr_state__";
const $80e073600c742ec7$export$d0f43d4b04198724 = "__ssr_stats__";
const $80e073600c742ec7$export$8b26fc8110ba9d33 = ()=>window[$80e073600c742ec7$export$93484e5d50f84920] || {};
const $80e073600c742ec7$export$f59eb203d31e7447 = ()=>window[$80e073600c742ec7$export$d0f43d4b04198724] || {};
/**
 * Private constant to make sure we don't need to keep calling Object.keys
 * but we can still mock the public API easily.
 */ const $80e073600c742ec7$var$APP_DID_SSR = Object.keys($80e073600c742ec7$export$8b26fc8110ba9d33()).length > 0;
const $80e073600c742ec7$export$d2f4d8e74279c212 = undefined;
const $80e073600c742ec7$export$642262419f51fae8 = ()=>$80e073600c742ec7$var$APP_DID_SSR;
const $80e073600c742ec7$export$ff492be938a8806a = ()=>!$80e073600c742ec7$export$d2f4d8e74279c212 && $80e073600c742ec7$export$642262419f51fae8();
const $80e073600c742ec7$export$230aeef4b9e0f6e3 = ()=>$80e073600c742ec7$export$642262419f51fae8() ? $80e073600c742ec7$export$8b26fc8110ba9d33().reduxStoreState : // eslint-disable-next-line no-restricted-properties
    window.__initial_state__;

});

parcelRegister("9nHZC", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1pTZ9"));

});
parcelRegister("1pTZ9", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $10838dc59f7e72f9$export$dca3b0875bd9a954; }, function (v) { return $10838dc59f7e72f9$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $10838dc59f7e72f9$export$16fa2f45be04daa8; }, function (v) { return $10838dc59f7e72f9$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $10838dc59f7e72f9$export$ffb0004e005737fa; }, function (v) { return $10838dc59f7e72f9$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $10838dc59f7e72f9$export$e2c29f18771995cb; }, function (v) { return $10838dc59f7e72f9$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $10838dc59f7e72f9$export$221d75b3f55bb0bd; }, function (v) { return $10838dc59f7e72f9$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $10838dc59f7e72f9$export$5f8d39834fd61797; }, function (v) { return $10838dc59f7e72f9$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $10838dc59f7e72f9$export$74bf444e3cd11ea5; }, function (v) { return $10838dc59f7e72f9$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $10838dc59f7e72f9$export$ae55be85d98224ed; }, function (v) { return $10838dc59f7e72f9$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $10838dc59f7e72f9$export$e530037191fcd5d7; }, function (v) { return $10838dc59f7e72f9$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $10838dc59f7e72f9$export$fd42f52fd3ae1109; }, function (v) { return $10838dc59f7e72f9$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $10838dc59f7e72f9$export$c8a8987d4410bf2d; }, function (v) { return $10838dc59f7e72f9$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $10838dc59f7e72f9$export$d38cd72104c1f0e9; }, function (v) { return $10838dc59f7e72f9$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $10838dc59f7e72f9$export$7d1e3a5e95ceca43; }, function (v) { return $10838dc59f7e72f9$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $10838dc59f7e72f9$export$257a8862b851cb5b; }, function (v) { return $10838dc59f7e72f9$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $10838dc59f7e72f9$export$a8257692ac88316c; }, function (v) { return $10838dc59f7e72f9$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $10838dc59f7e72f9$export$488013bae63b21da; }, function (v) { return $10838dc59f7e72f9$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $10838dc59f7e72f9$export$7c73462e0d25e514; }, function (v) { return $10838dc59f7e72f9$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $10838dc59f7e72f9$export$35808ee640e87ca7; }, function (v) { return $10838dc59f7e72f9$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $10838dc59f7e72f9$export$fae74005e78b1a27; }, function (v) { return $10838dc59f7e72f9$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $10838dc59f7e72f9$export$dc8fbce3eb94dc1e; }, function (v) { return $10838dc59f7e72f9$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $10838dc59f7e72f9$export$6d9c69b0de29b591; }, function (v) { return $10838dc59f7e72f9$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $10838dc59f7e72f9$export$d5a552a76deda3c2; }, function (v) { return $10838dc59f7e72f9$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $10838dc59f7e72f9$export$e5c5a5f917a5871c; }, function (v) { return $10838dc59f7e72f9$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $10838dc59f7e72f9$export$1538c33de8887b59; }, function (v) { return $10838dc59f7e72f9$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $10838dc59f7e72f9$export$13e3392192263954; }, function (v) { return $10838dc59f7e72f9$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $10838dc59f7e72f9$export$b8f5890fc79d6aca; }, function (v) { return $10838dc59f7e72f9$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $10838dc59f7e72f9$export$60241385465d0a34; }, function (v) { return $10838dc59f7e72f9$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $10838dc59f7e72f9$export$83d89fbfd8236492; }, function (v) { return $10838dc59f7e72f9$export$83d89fbfd8236492 = v; });
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $10838dc59f7e72f9$export$dca3b0875bd9a954;
var $10838dc59f7e72f9$export$16fa2f45be04daa8;
var $10838dc59f7e72f9$export$ffb0004e005737fa;
var $10838dc59f7e72f9$export$e2c29f18771995cb;
var $10838dc59f7e72f9$export$221d75b3f55bb0bd;
var $10838dc59f7e72f9$export$5f8d39834fd61797;
var $10838dc59f7e72f9$export$74bf444e3cd11ea5;
var $10838dc59f7e72f9$export$ae55be85d98224ed;
var $10838dc59f7e72f9$export$e530037191fcd5d7;
var $10838dc59f7e72f9$export$fd42f52fd3ae1109;
var $10838dc59f7e72f9$export$c8a8987d4410bf2d;
var $10838dc59f7e72f9$export$d38cd72104c1f0e9;
var $10838dc59f7e72f9$export$7d1e3a5e95ceca43;
var $10838dc59f7e72f9$export$257a8862b851cb5b;
var $10838dc59f7e72f9$export$a8257692ac88316c;
var $10838dc59f7e72f9$export$488013bae63b21da;
var $10838dc59f7e72f9$export$7c73462e0d25e514;
var $10838dc59f7e72f9$export$35808ee640e87ca7;
var $10838dc59f7e72f9$export$fae74005e78b1a27;
var $10838dc59f7e72f9$export$dc8fbce3eb94dc1e;
var $10838dc59f7e72f9$export$6d9c69b0de29b591;
var $10838dc59f7e72f9$export$d5a552a76deda3c2;
var $10838dc59f7e72f9$export$e5c5a5f917a5871c;
var $10838dc59f7e72f9$export$1538c33de8887b59;
var $10838dc59f7e72f9$export$13e3392192263954;
var $10838dc59f7e72f9$export$b8f5890fc79d6aca;
var $10838dc59f7e72f9$export$60241385465d0a34;
var $10838dc59f7e72f9$export$83d89fbfd8236492;
"use strict";

var $de9zv = parcelRequire("de9zv");
var $10838dc59f7e72f9$var$n = "function" === typeof Symbol && Symbol.for, $10838dc59f7e72f9$var$p = $10838dc59f7e72f9$var$n ? Symbol.for("react.element") : 60103, $10838dc59f7e72f9$var$q = $10838dc59f7e72f9$var$n ? Symbol.for("react.portal") : 60106, $10838dc59f7e72f9$var$r = $10838dc59f7e72f9$var$n ? Symbol.for("react.fragment") : 60107, $10838dc59f7e72f9$var$t = $10838dc59f7e72f9$var$n ? Symbol.for("react.strict_mode") : 60108, $10838dc59f7e72f9$var$u = $10838dc59f7e72f9$var$n ? Symbol.for("react.profiler") : 60114, $10838dc59f7e72f9$var$v = $10838dc59f7e72f9$var$n ? Symbol.for("react.provider") : 60109, $10838dc59f7e72f9$var$w = $10838dc59f7e72f9$var$n ? Symbol.for("react.context") : 60110, $10838dc59f7e72f9$var$x = $10838dc59f7e72f9$var$n ? Symbol.for("react.forward_ref") : 60112, $10838dc59f7e72f9$var$y = $10838dc59f7e72f9$var$n ? Symbol.for("react.suspense") : 60113, $10838dc59f7e72f9$var$z = $10838dc59f7e72f9$var$n ? Symbol.for("react.memo") : 60115, $10838dc59f7e72f9$var$A = $10838dc59f7e72f9$var$n ? Symbol.for("react.lazy") : 60116, $10838dc59f7e72f9$var$B = "function" === typeof Symbol && Symbol.iterator;
function $10838dc59f7e72f9$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $10838dc59f7e72f9$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $10838dc59f7e72f9$var$E = {};
function $10838dc59f7e72f9$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $10838dc59f7e72f9$var$E;
    this.updater = c || $10838dc59f7e72f9$var$D;
}
$10838dc59f7e72f9$var$F.prototype.isReactComponent = {};
$10838dc59f7e72f9$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($10838dc59f7e72f9$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$10838dc59f7e72f9$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $10838dc59f7e72f9$var$G() {}
$10838dc59f7e72f9$var$G.prototype = $10838dc59f7e72f9$var$F.prototype;
function $10838dc59f7e72f9$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $10838dc59f7e72f9$var$E;
    this.updater = c || $10838dc59f7e72f9$var$D;
}
var $10838dc59f7e72f9$var$I = $10838dc59f7e72f9$var$H.prototype = new $10838dc59f7e72f9$var$G;
$10838dc59f7e72f9$var$I.constructor = $10838dc59f7e72f9$var$H;
$de9zv($10838dc59f7e72f9$var$I, $10838dc59f7e72f9$var$F.prototype);
$10838dc59f7e72f9$var$I.isPureReactComponent = !0;
var $10838dc59f7e72f9$var$J = {
    current: null
}, $10838dc59f7e72f9$var$K = Object.prototype.hasOwnProperty, $10838dc59f7e72f9$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $10838dc59f7e72f9$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$10838dc59f7e72f9$var$K.call(b, e) && !$10838dc59f7e72f9$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $10838dc59f7e72f9$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $10838dc59f7e72f9$var$J.current
    };
}
function $10838dc59f7e72f9$var$N(a, b) {
    return {
        $$typeof: $10838dc59f7e72f9$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $10838dc59f7e72f9$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $10838dc59f7e72f9$var$p;
}
function $10838dc59f7e72f9$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $10838dc59f7e72f9$var$P = /\/+/g, $10838dc59f7e72f9$var$Q = [];
function $10838dc59f7e72f9$var$R(a, b, c, e) {
    if ($10838dc59f7e72f9$var$Q.length) {
        var d = $10838dc59f7e72f9$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $10838dc59f7e72f9$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $10838dc59f7e72f9$var$Q.length && $10838dc59f7e72f9$var$Q.push(a);
}
function $10838dc59f7e72f9$var$T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $10838dc59f7e72f9$var$p:
                case $10838dc59f7e72f9$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $10838dc59f7e72f9$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $10838dc59f7e72f9$var$U(d, k);
        g += $10838dc59f7e72f9$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $10838dc59f7e72f9$var$B && a[$10838dc59f7e72f9$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $10838dc59f7e72f9$var$U(d, k++), g += $10838dc59f7e72f9$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($10838dc59f7e72f9$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $10838dc59f7e72f9$var$V(a, b, c) {
    return null == a ? 0 : $10838dc59f7e72f9$var$T(a, "", b, c);
}
function $10838dc59f7e72f9$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $10838dc59f7e72f9$var$escape(a.key) : b.toString(36);
}
function $10838dc59f7e72f9$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $10838dc59f7e72f9$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $10838dc59f7e72f9$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($10838dc59f7e72f9$var$O(a) && (a = $10838dc59f7e72f9$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($10838dc59f7e72f9$var$P, "$&/") + "/") + c)), e.push(a));
}
function $10838dc59f7e72f9$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($10838dc59f7e72f9$var$P, "$&/") + "/");
    b = $10838dc59f7e72f9$var$R(b, g, e, d);
    $10838dc59f7e72f9$var$V(a, $10838dc59f7e72f9$var$aa, b);
    $10838dc59f7e72f9$var$S(b);
}
var $10838dc59f7e72f9$var$Y = {
    current: null
};
function $10838dc59f7e72f9$var$Z() {
    var a = $10838dc59f7e72f9$var$Y.current;
    if (null === a) throw Error($10838dc59f7e72f9$var$C(321));
    return a;
}
var $10838dc59f7e72f9$var$ba = {
    ReactCurrentDispatcher: $10838dc59f7e72f9$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $10838dc59f7e72f9$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $de9zv
};
$10838dc59f7e72f9$export$dca3b0875bd9a954 = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        $10838dc59f7e72f9$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = $10838dc59f7e72f9$var$R(null, null, b, c);
        $10838dc59f7e72f9$var$V(a, $10838dc59f7e72f9$var$W, b);
        $10838dc59f7e72f9$var$S(b);
    },
    count: function(a) {
        return $10838dc59f7e72f9$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        $10838dc59f7e72f9$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!$10838dc59f7e72f9$var$O(a)) throw Error($10838dc59f7e72f9$var$C(143));
        return a;
    }
};
$10838dc59f7e72f9$export$16fa2f45be04daa8 = $10838dc59f7e72f9$var$F;
$10838dc59f7e72f9$export$ffb0004e005737fa = $10838dc59f7e72f9$var$r;
$10838dc59f7e72f9$export$e2c29f18771995cb = $10838dc59f7e72f9$var$u;
$10838dc59f7e72f9$export$221d75b3f55bb0bd = $10838dc59f7e72f9$var$H;
$10838dc59f7e72f9$export$5f8d39834fd61797 = $10838dc59f7e72f9$var$t;
$10838dc59f7e72f9$export$74bf444e3cd11ea5 = $10838dc59f7e72f9$var$y;
$10838dc59f7e72f9$export$ae55be85d98224ed = $10838dc59f7e72f9$var$ba;
$10838dc59f7e72f9$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($10838dc59f7e72f9$var$C(267, a));
    var e = $de9zv({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $10838dc59f7e72f9$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$10838dc59f7e72f9$var$K.call(b, h) && !$10838dc59f7e72f9$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $10838dc59f7e72f9$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$10838dc59f7e72f9$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $10838dc59f7e72f9$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $10838dc59f7e72f9$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$10838dc59f7e72f9$export$c8a8987d4410bf2d = $10838dc59f7e72f9$var$M;
$10838dc59f7e72f9$export$d38cd72104c1f0e9 = function(a) {
    var b = $10838dc59f7e72f9$var$M.bind(null, a);
    b.type = a;
    return b;
};
$10838dc59f7e72f9$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$10838dc59f7e72f9$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $10838dc59f7e72f9$var$x,
        render: a
    };
};
$10838dc59f7e72f9$export$a8257692ac88316c = $10838dc59f7e72f9$var$O;
$10838dc59f7e72f9$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $10838dc59f7e72f9$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$10838dc59f7e72f9$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $10838dc59f7e72f9$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$10838dc59f7e72f9$export$35808ee640e87ca7 = function(a, b) {
    return $10838dc59f7e72f9$var$Z().useCallback(a, b);
};
$10838dc59f7e72f9$export$fae74005e78b1a27 = function(a, b) {
    return $10838dc59f7e72f9$var$Z().useContext(a, b);
};
$10838dc59f7e72f9$export$dc8fbce3eb94dc1e = function() {};
$10838dc59f7e72f9$export$6d9c69b0de29b591 = function(a, b) {
    return $10838dc59f7e72f9$var$Z().useEffect(a, b);
};
$10838dc59f7e72f9$export$d5a552a76deda3c2 = function(a, b, c) {
    return $10838dc59f7e72f9$var$Z().useImperativeHandle(a, b, c);
};
$10838dc59f7e72f9$export$e5c5a5f917a5871c = function(a, b) {
    return $10838dc59f7e72f9$var$Z().useLayoutEffect(a, b);
};
$10838dc59f7e72f9$export$1538c33de8887b59 = function(a, b) {
    return $10838dc59f7e72f9$var$Z().useMemo(a, b);
};
$10838dc59f7e72f9$export$13e3392192263954 = function(a, b, c) {
    return $10838dc59f7e72f9$var$Z().useReducer(a, b, c);
};
$10838dc59f7e72f9$export$b8f5890fc79d6aca = function(a) {
    return $10838dc59f7e72f9$var$Z().useRef(a);
};
$10838dc59f7e72f9$export$60241385465d0a34 = function(a) {
    return $10838dc59f7e72f9$var$Z().useState(a);
};
$10838dc59f7e72f9$export$83d89fbfd8236492 = "16.14.0";

});
parcelRegister("de9zv", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $9a1401e806f92dca$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $9a1401e806f92dca$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $9a1401e806f92dca$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $9a1401e806f92dca$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $9a1401e806f92dca$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $9a1401e806f92dca$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $9a1401e806f92dca$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($9a1401e806f92dca$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($9a1401e806f92dca$var$getOwnPropertySymbols) {
            symbols = $9a1401e806f92dca$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($9a1401e806f92dca$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("lnOmc", function(module, exports) {
"use strict";
function $f912cecf7c50156c$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($f912cecf7c50156c$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$f912cecf7c50156c$var$checkDCE();

module.exports = (parcelRequire("7YHK8"));

});
parcelRegister("7YHK8", function(module, exports) {
/** @license React v16.14.0
 * react-dom.profiling.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $9nHZC = parcelRequire("9nHZC");

var $de9zv = parcelRequire("de9zv");

var $wmpq0 = parcelRequire("wmpq0");

var $jpvB9 = parcelRequire("jpvB9");
function u(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$9nHZC) throw Error(u(227));
function ba(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var ca = !1, da = null, ea = !1, fa = null, ha = {
    onError: function(a) {
        ca = !0;
        da = a;
    }
};
function ia(a, b, c, d, e, f, g, h, k) {
    ca = !1;
    da = null;
    ba.apply(ha, arguments);
}
function ja(a, b, c, d, e, f, g, h, k) {
    ia.apply(this, arguments);
    if (ca) {
        if (ca) {
            var l = da;
            ca = !1;
            da = null;
        } else throw Error(u(198));
        ea || (ea = !0, fa = l);
    }
}
var ka = null, la = null, ma = null;
function na(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = ma(c);
    ja(d, b, void 0, a);
    a.currentTarget = null;
}
var pa = null, qa = {};
function ra() {
    if (pa) for(var a in qa){
        var b = qa[a], c = pa.indexOf(a);
        if (!(-1 < c)) throw Error(u(96, a));
        if (!sa[c]) {
            if (!b.extractEvents) throw Error(u(97, a));
            sa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                if (ta.hasOwnProperty(h)) throw Error(u(99, h));
                ta[h] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && ua(k[e], g, h);
                    e = !0;
                } else f.registrationName ? (ua(f.registrationName, g, h), e = !0) : e = !1;
                if (!e) throw Error(u(98, d, a));
            }
        }
    }
}
function ua(a, b, c) {
    if (va[a]) throw Error(u(100, a));
    va[a] = b;
    wa[a] = b.eventTypes[c].dependencies;
}
var sa = [], ta = {}, va = {}, wa = {};
function xa(a) {
    var b = !1, c;
    for(c in a)if (a.hasOwnProperty(c)) {
        var d = a[c];
        if (!qa.hasOwnProperty(c) || qa[c] !== d) {
            if (qa[c]) throw Error(u(102, c));
            qa[c] = d;
            b = !0;
        }
    }
    b && ra();
}
var ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), za = null, Aa = null, Ba = null;
function Ca(a) {
    if (a = la(a)) {
        if ("function" !== typeof za) throw Error(u(280));
        var b = a.stateNode;
        b && (b = ka(b), za(a.stateNode, a.type, b));
    }
}
function Da(a) {
    Aa ? Ba ? Ba.push(a) : Ba = [
        a
    ] : Aa = a;
}
function Ea() {
    if (Aa) {
        var a = Aa, b = Ba;
        Ba = Aa = null;
        Ca(a);
        if (b) for(a = 0; a < b.length; a++)Ca(b[a]);
    }
}
function Fa(a, b) {
    return a(b);
}
function Ga(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ha() {}
var Ia = Fa, Ja = !1, Ka = !1;
function La() {
    if (null !== Aa || null !== Ba) Ha(), Ea();
}
function Ma(a, b, c) {
    if (Ka) return a(b, c);
    Ka = !0;
    try {
        return Ia(a, b, c);
    } finally{
        Ka = !1, La();
    }
}
var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Oa = Object.prototype.hasOwnProperty, Pa = {}, Qa = {};
function Ra(a) {
    if (Oa.call(Qa, a)) return !0;
    if (Oa.call(Pa, a)) return !1;
    if (Na.test(a)) return Qa[a] = !0;
    Pa[a] = !0;
    return !1;
}
function Sa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function Ta(a, b, c, d) {
    if (null === b || "undefined" === typeof b || Sa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function C(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new C(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new C(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new C(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new C(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new C(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new C(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new C(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new C(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new C(a, 5, !1, a.toLowerCase(), null, !1);
});
var Ua = /[\-:]([a-z])/g;
function Va(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    D[b] = new C(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    D[b] = new C(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(Ua, Va);
    D[b] = new C(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new C(a, 1, !1, a.toLowerCase(), null, !1);
});
D.xlinkHref = new C("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new C(a, 1, !1, a.toLowerCase(), null, !0);
});
var Wa = $9nHZC.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = {
    current: null
});
Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = {
    suspense: null
});
function Xa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (Ta(b, c, e, d) && (c = null), d || null === e ? Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var Ya = /^(.*)[\\\/]/, E = "function" === typeof Symbol && Symbol.for, Za = E ? Symbol.for("react.element") : 60103, $a = E ? Symbol.for("react.portal") : 60106, ab = E ? Symbol.for("react.fragment") : 60107, bb = E ? Symbol.for("react.strict_mode") : 60108, cb = E ? Symbol.for("react.profiler") : 60114, db = E ? Symbol.for("react.provider") : 60109, eb = E ? Symbol.for("react.context") : 60110, fb = E ? Symbol.for("react.concurrent_mode") : 60111, gb = E ? Symbol.for("react.forward_ref") : 60112, hb = E ? Symbol.for("react.suspense") : 60113, ib = E ? Symbol.for("react.suspense_list") : 60120, jb = E ? Symbol.for("react.memo") : 60115, kb = E ? Symbol.for("react.lazy") : 60116, lb = E ? Symbol.for("react.block") : 60121, mb = "function" === typeof Symbol && Symbol.iterator;
function nb(a) {
    if (null === a || "object" !== typeof a) return null;
    a = mb && a[mb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function ob(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
}
function pb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ab:
            return "Fragment";
        case $a:
            return "Portal";
        case cb:
            return "Profiler";
        case bb:
            return "StrictMode";
        case hb:
            return "Suspense";
        case ib:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case eb:
            return "Context.Consumer";
        case db:
            return "Context.Provider";
        case gb:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case jb:
            return pb(a.type);
        case lb:
            return pb(a.render);
        case kb:
            if (a = 1 === a._status ? a._result : null) return pb(a);
    }
    return null;
}
function qb(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = pb(a.type);
                c = null;
                d && (c = pb(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace(Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
function rb(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function sb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function tb(a) {
    var b = sb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function ub(a) {
    a._valueTracker || (a._valueTracker = tb(a));
}
function vb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = sb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function wb(a, b) {
    var c = b.checked;
    return $de9zv({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function xb(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = rb(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function yb(a, b) {
    b = b.checked;
    null != b && Xa(a, "checked", b, !1);
}
function zb(a, b) {
    yb(a, b);
    var c = rb(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? Ab(a, b.type, c) : b.hasOwnProperty("defaultValue") && Ab(a, b.type, rb(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function Db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function Ab(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function Eb(a) {
    var b = "";
    $9nHZC.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function Fb(a, b) {
    a = $de9zv({
        children: void 0
    }, b);
    if (b = Eb(b.children)) a.children = b;
    return a;
}
function Gb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + rb(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function Hb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(u(91));
    return $de9zv({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function Ib(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(u(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(u(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: rb(c)
    };
}
function Jb(a, b) {
    var c = rb(b.value), d = rb(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function Kb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var Lb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function Mb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function Nb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? Mb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var Ob, Pb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== Lb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        Ob = Ob || document.createElement("div");
        Ob.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = Ob.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function Qb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
function Rb(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Sb = {
    animationend: Rb("Animation", "AnimationEnd"),
    animationiteration: Rb("Animation", "AnimationIteration"),
    animationstart: Rb("Animation", "AnimationStart"),
    transitionend: Rb("Transition", "TransitionEnd")
}, Tb = {}, Ub = {};
ya && (Ub = document.createElement("div").style, "AnimationEvent" in window || (delete Sb.animationend.animation, delete Sb.animationiteration.animation, delete Sb.animationstart.animation), "TransitionEvent" in window || delete Sb.transitionend.transition);
function Vb(a) {
    if (Tb[a]) return Tb[a];
    if (!Sb[a]) return a;
    var b = Sb[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ub) return Tb[a] = b[c];
    return a;
}
var Wb = Vb("animationend"), Xb = Vb("animationiteration"), Yb = Vb("animationstart"), Zb = Vb("transitionend"), $b = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), ac = new ("function" === typeof WeakMap ? WeakMap : Map);
function bc(a) {
    var b = ac.get(a);
    void 0 === b && (b = new Map, ac.set(a, b));
    return b;
}
function cc(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function dc(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ec(a) {
    if (cc(a) !== a) throw Error(u(188));
}
function fc(a) {
    var b = a.alternate;
    if (!b) {
        b = cc(a);
        if (null === b) throw Error(u(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ec(e), a;
                if (f === d) return ec(e), b;
                f = f.sibling;
            }
            throw Error(u(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(u(189));
            }
        }
        if (c.alternate !== d) throw Error(u(190));
    }
    if (3 !== c.tag) throw Error(u(188));
    return c.stateNode.current === c ? a : b;
}
function gc(a) {
    a = fc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function hc(a, b) {
    if (null == b) throw Error(u(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function ic(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var jc = null;
function kc(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)na(a, b[d], c[d]);
        else b && na(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function lc(a) {
    null !== a && (jc = hc(jc, a));
    a = jc;
    jc = null;
    if (a) {
        ic(a, kc);
        if (jc) throw Error(u(95));
        if (ea) throw a = fa, ea = !1, fa = null, a;
    }
}
function mc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function nc(a) {
    if (!ya) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
var oc = [];
function pc(a) {
    a.topLevelType = null;
    a.nativeEvent = null;
    a.targetInst = null;
    a.ancestors.length = 0;
    10 > oc.length && oc.push(a);
}
function qc(a, b, c, d) {
    if (oc.length) {
        var e = oc.pop();
        e.topLevelType = a;
        e.eventSystemFlags = d;
        e.nativeEvent = b;
        e.targetInst = c;
        return e;
    }
    return {
        topLevelType: a,
        eventSystemFlags: d,
        nativeEvent: b,
        targetInst: c,
        ancestors: []
    };
}
function rc(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d = c;
        if (3 === d.tag) d = d.stateNode.containerInfo;
        else {
            for(; d.return;)d = d.return;
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        }
        if (!d) break;
        b = c.tag;
        5 !== b && 6 !== b || a.ancestors.push(c);
        c = sc(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = mc(a.nativeEvent);
        d = a.topLevelType;
        var f = a.nativeEvent, g = a.eventSystemFlags;
        0 === c && (g |= 64);
        for(var h = null, k = 0; k < sa.length; k++){
            var l = sa[k];
            l && (l = l.extractEvents(d, b, f, e, g)) && (h = hc(h, l));
        }
        lc(h);
    }
}
function tc(a, b, c) {
    if (!c.has(a)) {
        switch(a){
            case "scroll":
                uc(b, "scroll", !0);
                break;
            case "focus":
            case "blur":
                uc(b, "focus", !0);
                uc(b, "blur", !0);
                c.set("blur", null);
                c.set("focus", null);
                break;
            case "cancel":
            case "close":
                nc(a) && uc(b, a, !0);
                break;
            case "invalid":
            case "submit":
            case "reset":
                break;
            default:
                -1 === $b.indexOf(a) && F(a, b);
        }
        c.set(a, null);
    }
}
var vc, wc, xc, yc = !1, zc = [], Ac = null, Bc = null, Cc = null, Dc = new Map, Ec = new Map, Fc = [], Gc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), Hc = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Ic(a, b) {
    var c = bc(b);
    Gc.forEach(function(a) {
        tc(a, b, c);
    });
    Hc.forEach(function(a) {
        tc(a, b, c);
    });
}
function Jc(a, b, c, d, e) {
    return {
        blockedOn: a,
        topLevelType: b,
        eventSystemFlags: c | 32,
        nativeEvent: e,
        container: d
    };
}
function Kc(a, b) {
    switch(a){
        case "focus":
        case "blur":
            Ac = null;
            break;
        case "dragenter":
        case "dragleave":
            Bc = null;
            break;
        case "mouseover":
        case "mouseout":
            Cc = null;
            break;
        case "pointerover":
        case "pointerout":
            Dc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Ec.delete(b.pointerId);
    }
}
function Lc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = Jc(b, c, d, e, f), null !== b && (b = Mc(b), null !== b && wc(b)), a;
    a.eventSystemFlags |= d;
    return a;
}
function Nc(a, b, c, d, e) {
    switch(b){
        case "focus":
            return Ac = Lc(Ac, a, b, c, d, e), !0;
        case "dragenter":
            return Bc = Lc(Bc, a, b, c, d, e), !0;
        case "mouseover":
            return Cc = Lc(Cc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Dc.set(f, Lc(Dc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Ec.set(f, Lc(Ec.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Oc(a) {
    var b = sc(a.target);
    if (null !== b) {
        var c = cc(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = dc(c), null !== b) {
                    a.blockedOn = b;
                    $wmpq0.unstable_runWithPriority(a.priority, function() {
                        xc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Pc(a) {
    if (null !== a.blockedOn) return !1;
    var b = Qc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    if (null !== b) {
        var c = Mc(b);
        null !== c && wc(c);
        a.blockedOn = b;
        return !1;
    }
    return !0;
}
function Rc(a, b, c) {
    Pc(a) && c.delete(b);
}
function Sc() {
    for(yc = !1; 0 < zc.length;){
        var a = zc[0];
        if (null !== a.blockedOn) {
            a = Mc(a.blockedOn);
            null !== a && vc(a);
            break;
        }
        var b = Qc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
        null !== b ? a.blockedOn = b : zc.shift();
    }
    null !== Ac && Pc(Ac) && (Ac = null);
    null !== Bc && Pc(Bc) && (Bc = null);
    null !== Cc && Pc(Cc) && (Cc = null);
    Dc.forEach(Rc);
    Ec.forEach(Rc);
}
function Tc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, yc || (yc = !0, $wmpq0.unstable_scheduleCallback($wmpq0.unstable_NormalPriority, Sc)));
}
function Uc(a) {
    function b(b) {
        return Tc(b, a);
    }
    if (0 < zc.length) {
        Tc(zc[0], a);
        for(var c = 1; c < zc.length; c++){
            var d = zc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Ac && Tc(Ac, a);
    null !== Bc && Tc(Bc, a);
    null !== Cc && Tc(Cc, a);
    Dc.forEach(b);
    Ec.forEach(b);
    for(c = 0; c < Fc.length; c++)d = Fc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Fc.length && (c = Fc[0], null === c.blockedOn);)Oc(c), null === c.blockedOn && Fc.shift();
}
var Vc = {}, Wc = new Map, Xc = new Map, Yc = [
    "abort",
    "abort",
    Wb,
    "animationEnd",
    Xb,
    "animationIteration",
    Yb,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Zb,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Zc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1], f = "on" + (e[0].toUpperCase() + e.slice(1));
        f = {
            phasedRegistrationNames: {
                bubbled: f,
                captured: f + "Capture"
            },
            dependencies: [
                d
            ],
            eventPriority: b
        };
        Xc.set(d, b);
        Wc.set(d, f);
        Vc[e] = f;
    }
}
Zc("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Zc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Zc(Yc, 2);
for(var $c = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), ad = 0; ad < $c.length; ad++)Xc.set($c[ad], 0);
var bd = $wmpq0.unstable_UserBlockingPriority, cd = $wmpq0.unstable_runWithPriority, dd = !0;
function F(a, b) {
    uc(b, a, !1);
}
function uc(a, b, c) {
    var d = Xc.get(b);
    switch(void 0 === d ? 2 : d){
        case 0:
            d = ed.bind(null, b, 1, a);
            break;
        case 1:
            d = fd.bind(null, b, 1, a);
            break;
        default:
            d = gd.bind(null, b, 1, a);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function ed(a, b, c, d) {
    Ja || Ha();
    var e = gd, f = Ja;
    Ja = !0;
    try {
        Ga(e, a, b, c, d);
    } finally{
        (Ja = f) || La();
    }
}
function fd(a, b, c, d) {
    cd(bd, gd.bind(null, a, b, c, d));
}
function gd(a, b, c, d) {
    if (dd) {
        if (0 < zc.length && -1 < Gc.indexOf(a)) a = Jc(null, a, b, c, d), zc.push(a);
        else {
            var e = Qc(a, b, c, d);
            if (null === e) Kc(a, d);
            else if (-1 < Gc.indexOf(a)) a = Jc(e, a, b, c, d), zc.push(a);
            else if (!Nc(e, a, b, c, d)) {
                Kc(a, d);
                a = qc(a, d, null, b);
                try {
                    Ma(rc, a);
                } finally{
                    pc(a);
                }
            }
        }
    }
}
function Qc(a, b, c, d) {
    c = mc(d);
    c = sc(c);
    if (null !== c) {
        var e = cc(c);
        if (null === e) c = null;
        else {
            var f = e.tag;
            if (13 === f) {
                c = dc(e);
                if (null !== c) return c;
                c = null;
            } else if (3 === f) {
                if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
                c = null;
            } else e !== c && (c = null);
        }
    }
    a = qc(a, d, c, b);
    try {
        Ma(rc, a);
    } finally{
        pc(a);
    }
    return null;
}
var hd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, id = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(hd).forEach(function(a) {
    id.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        hd[b] = hd[a];
    });
});
function jd(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || hd.hasOwnProperty(a) && hd[a] ? ("" + b).trim() : b + "px";
}
function kd(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = jd(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ld = $de9zv({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function md(a, b) {
    if (b) {
        if (ld[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(u(137, a, ""));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(u(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(u(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(u(62, ""));
    }
}
function nd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var od = Lb.html;
function pd(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = bc(a);
    b = wa[b];
    for(var d = 0; d < b.length; d++)tc(b[d], a, c);
}
function qd() {}
function rd(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function sd(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function td(a, b) {
    var c = sd(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = sd(c);
    }
}
function ud(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? ud(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function vd() {
    for(var a = window, b = rd(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = rd(a.document);
    }
    return b;
}
function wd(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var xd = "$", yd = "/$", zd = "$?", Ad = "$!", Bd = null, Cd = null;
function Dd(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function Ed(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Fd = "function" === typeof setTimeout ? setTimeout : void 0, Gd = "function" === typeof clearTimeout ? clearTimeout : void 0;
function Hd(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function Id(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if (c === xd || c === Ad || c === zd) {
                if (0 === b) return a;
                b--;
            } else c === yd && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Jd = Math.random().toString(36).slice(2), Kd = "__reactInternalInstance$" + Jd, Ld = "__reactEventHandlers$" + Jd, Md = "__reactContainere$" + Jd;
function sc(a) {
    var b = a[Kd];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[Md] || c[Kd]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Id(a); null !== a;){
                if (c = a[Kd]) return c;
                a = Id(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Mc(a) {
    a = a[Kd] || a[Md];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function Nd(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(u(33));
}
function Od(a) {
    return a[Ld] || null;
}
function Pd(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function Qd(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = ka(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(u(231, b, typeof c));
    return c;
}
function Rd(a, b, c) {
    if (b = Qd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = hc(c._dispatchListeners, b), c._dispatchInstances = hc(c._dispatchInstances, a);
}
function Sd(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = Pd(b);
        for(b = c.length; 0 < b--;)Rd(c[b], "captured", a);
        for(b = 0; b < c.length; b++)Rd(c[b], "bubbled", a);
    }
}
function Td(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = Qd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = hc(c._dispatchListeners, b), c._dispatchInstances = hc(c._dispatchInstances, a));
}
function Ud(a) {
    a && a.dispatchConfig.registrationName && Td(a._targetInst, null, a);
}
function Vd(a) {
    ic(a, Sd);
}
var Wd = null, Xd = null, Yd = null;
function Zd() {
    if (Yd) return Yd;
    var a, b = Xd, c = b.length, d, e = "value" in Wd ? Wd.value : Wd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return Yd = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $d() {
    return !0;
}
function ae() {
    return !1;
}
function G(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? $d : ae;
    this.isPropagationStopped = ae;
    return this;
}
$de9zv(G.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $d);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $d);
    },
    persist: function() {
        this.isPersistent = $d;
    },
    isPersistent: ae,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = ae;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
G.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
G.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $de9zv(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $de9zv({}, d.Interface, a);
    c.extend = d.extend;
    be(c);
    return c;
};
be(G);
function ce(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function de(a) {
    if (!(a instanceof this)) throw Error(u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function be(a) {
    a.eventPool = [];
    a.getPooled = ce;
    a.release = de;
}
var ee = G.extend({
    data: null
}), fe = G.extend({
    data: null
}), ge = [
    9,
    13,
    27,
    32
], he = ya && "CompositionEvent" in window, ie = null;
ya && "documentMode" in document && (ie = document.documentMode);
var je = ya && "TextEvent" in window && !ie, ke = ya && (!he || ie && 8 < ie && 11 >= ie), le = String.fromCharCode(32), me = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, ne = !1;
function oe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== ge.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function pe(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var qe = !1;
function re(a, b) {
    switch(a){
        case "compositionend":
            return pe(b);
        case "keypress":
            if (32 !== b.which) return null;
            ne = !0;
            return le;
        case "textInput":
            return a = b.data, a === le && ne ? null : a;
        default:
            return null;
    }
}
function se(a, b) {
    if (qe) return "compositionend" === a || !he && oe(a, b) ? (a = Zd(), Yd = Xd = Wd = null, qe = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return ke && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var te = {
    eventTypes: me,
    extractEvents: function(a, b, c, d) {
        var e;
        if (he) b: {
            switch(a){
                case "compositionstart":
                    var f = me.compositionStart;
                    break b;
                case "compositionend":
                    f = me.compositionEnd;
                    break b;
                case "compositionupdate":
                    f = me.compositionUpdate;
                    break b;
            }
            f = void 0;
        }
        else qe ? oe(a, c) && (f = me.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = me.compositionStart);
        f ? (ke && "ko" !== c.locale && (qe || f !== me.compositionStart ? f === me.compositionEnd && qe && (e = Zd()) : (Wd = d, Xd = "value" in Wd ? Wd.value : Wd.textContent, qe = !0)), f = ee.getPooled(f, b, c, d), e ? f.data = e : (e = pe(c), null !== e && (f.data = e)), Vd(f), e = f) : e = null;
        (a = je ? re(a, c) : se(a, c)) ? (b = fe.getPooled(me.beforeInput, b, c, d), b.data = a, Vd(b)) : b = null;
        return null === e ? b : null === b ? e : [
            e,
            b
        ];
    }
}, ue = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function ve(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!ue[a.type] : "textarea" === b ? !0 : !1;
}
var we = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function xe(a, b, c) {
    a = G.getPooled(we.change, a, b, c);
    a.type = "change";
    Da(c);
    Vd(a);
    return a;
}
var ye = null, ze = null;
function Ae(a) {
    lc(a);
}
function Be(a) {
    var b = Nd(a);
    if (vb(b)) return a;
}
function Ce(a, b) {
    if ("change" === a) return b;
}
var De = !1;
ya && (De = nc("input") && (!document.documentMode || 9 < document.documentMode));
function Ee() {
    ye && (ye.detachEvent("onpropertychange", Fe), ze = ye = null);
}
function Fe(a) {
    if ("value" === a.propertyName && Be(ze)) {
        if (a = xe(ze, a, mc(a)), Ja) lc(a);
        else {
            Ja = !0;
            try {
                Fa(Ae, a);
            } finally{
                Ja = !1, La();
            }
        }
    }
}
function Ge(a, b, c) {
    "focus" === a ? (Ee(), ye = b, ze = c, ye.attachEvent("onpropertychange", Fe)) : "blur" === a && Ee();
}
function He(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return Be(ze);
}
function Ie(a, b) {
    if ("click" === a) return Be(b);
}
function Je(a, b) {
    if ("input" === a || "change" === a) return Be(b);
}
var Ke = {
    eventTypes: we,
    _isInputEventSupported: De,
    extractEvents: function(a, b, c, d) {
        var e = b ? Nd(b) : window, f = e.nodeName && e.nodeName.toLowerCase();
        if ("select" === f || "input" === f && "file" === e.type) var g = Ce;
        else if (ve(e)) {
            if (De) g = Je;
            else {
                g = He;
                var h = Ge;
            }
        } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = Ie);
        if (g && (g = g(a, b))) return xe(g, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Ab(e, "number", e.value);
    }
}, Le = G.extend({
    view: null,
    detail: null
}), Me = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Ne(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Me[a]) ? !!b[a] : !1;
}
function Oe() {
    return Ne;
}
var Pe = 0, Qe = 0, Re = !1, Se = !1, Te = Le.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: Oe,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = Pe;
        Pe = a.screenX;
        return Re ? "mousemove" === a.type ? a.screenX - b : 0 : (Re = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = Qe;
        Qe = a.screenY;
        return Se ? "mousemove" === a.type ? a.screenY - b : 0 : (Se = !0, 0);
    }
}), Ue = Te.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), Ve = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, We = {
    eventTypes: Ve,
    extractEvents: function(a, b, c, d, e) {
        var f = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
        f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
        if (g) {
            if (g = b, b = (b = c.relatedTarget || c.toElement) ? sc(b) : null, null !== b) {
                var h = cc(b);
                if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
            }
        } else g = null;
        if (g === b) return null;
        if ("mouseout" === a || "mouseover" === a) {
            var k = Te;
            var l = Ve.mouseLeave;
            var m = Ve.mouseEnter;
            var q = "mouse";
        } else if ("pointerout" === a || "pointerover" === a) k = Ue, l = Ve.pointerLeave, m = Ve.pointerEnter, q = "pointer";
        a = null == g ? f : Nd(g);
        f = null == b ? f : Nd(b);
        l = k.getPooled(l, g, c, d);
        l.type = q + "leave";
        l.target = a;
        l.relatedTarget = f;
        c = k.getPooled(m, b, c, d);
        c.type = q + "enter";
        c.target = f;
        c.relatedTarget = a;
        d = g;
        q = b;
        if (d && q) a: {
            k = d;
            m = q;
            g = 0;
            for(a = k; a; a = Pd(a))g++;
            a = 0;
            for(b = m; b; b = Pd(b))a++;
            for(; 0 < g - a;)k = Pd(k), g--;
            for(; 0 < a - g;)m = Pd(m), a--;
            for(; g--;){
                if (k === m || k === m.alternate) break a;
                k = Pd(k);
                m = Pd(m);
            }
            k = null;
        }
        else k = null;
        m = k;
        for(k = []; d && d !== m;){
            g = d.alternate;
            if (null !== g && g === m) break;
            k.push(d);
            d = Pd(d);
        }
        for(d = []; q && q !== m;){
            g = q.alternate;
            if (null !== g && g === m) break;
            d.push(q);
            q = Pd(q);
        }
        for(q = 0; q < k.length; q++)Td(k[q], "bubbled", l);
        for(q = d.length; 0 < q--;)Td(d[q], "captured", c);
        return 0 === (e & 64) ? [
            l
        ] : [
            l,
            c
        ];
    }
};
function Xe(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var Ye = "function" === typeof Object.is ? Object.is : Xe, Ze = Object.prototype.hasOwnProperty;
function $e(a, b) {
    if (Ye(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ze.call(b, c[d]) || !Ye(a[c[d]], b[c[d]])) return !1;
    return !0;
}
var af = ya && "documentMode" in document && 11 >= document.documentMode, bf = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, cf = null, df = null, ef = null, ff = !1;
function gf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if (ff || null == cf || cf !== rd(c)) return null;
    c = cf;
    "selectionStart" in c && wd(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return ef && $e(ef, c) ? null : (ef = c, a = G.getPooled(bf.select, df, a, b), a.type = "select", a.target = cf, Vd(a), a);
}
var hf = {
    eventTypes: bf,
    extractEvents: function(a, b, c, d, e, f) {
        e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
        if (!(f = !e)) {
            a: {
                e = bc(e);
                f = wa.onSelect;
                for(var g = 0; g < f.length; g++)if (!e.has(f[g])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? Nd(b) : window;
        switch(a){
            case "focus":
                if (ve(e) || "true" === e.contentEditable) cf = e, df = b, ef = null;
                break;
            case "blur":
                ef = df = cf = null;
                break;
            case "mousedown":
                ff = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return ff = !1, gf(c, d);
            case "selectionchange":
                if (af) break;
            case "keydown":
            case "keyup":
                return gf(c, d);
        }
        return null;
    }
}, jf = G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), kf = G.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), lf = Le.extend({
    relatedTarget: null
});
function mf(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var nf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, of = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, pf = Le.extend({
    key: function(a) {
        if (a.key) {
            var b = nf[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = mf(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? of[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: Oe,
    charCode: function(a) {
        return "keypress" === a.type ? mf(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? mf(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), qf = Te.extend({
    dataTransfer: null
}), rf = Le.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: Oe
}), sf = G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), tf = Te.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), uf = {
    eventTypes: Vc,
    extractEvents: function(a, b, c, d) {
        var e = Wc.get(a);
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === mf(c)) return null;
            case "keydown":
            case "keyup":
                a = pf;
                break;
            case "blur":
            case "focus":
                a = lf;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = Te;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = qf;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = rf;
                break;
            case Wb:
            case Xb:
            case Yb:
                a = jf;
                break;
            case Zb:
                a = sf;
                break;
            case "scroll":
                a = Le;
                break;
            case "wheel":
                a = tf;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = kf;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = Ue;
                break;
            default:
                a = G;
        }
        b = a.getPooled(e, b, c, d);
        Vd(b);
        return b;
    }
};
if (pa) throw Error(u(101));
pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ra();
var vf = Mc;
ka = Od;
la = vf;
ma = Nd;
xa({
    SimpleEventPlugin: uf,
    EnterLeaveEventPlugin: We,
    ChangeEventPlugin: Ke,
    SelectEventPlugin: hf,
    BeforeInputEventPlugin: te
});
var wf = [], xf = -1;
function H(a) {
    0 > xf || (a.current = wf[xf], wf[xf] = null, xf--);
}
function I(a, b) {
    xf++;
    wf[xf] = a.current;
    a.current = b;
}
var yf = {}, J = {
    current: yf
}, K = {
    current: !1
}, zf = yf;
function Af(a, b) {
    var c = a.type.contextTypes;
    if (!c) return yf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function M(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Bf() {
    H(K);
    H(J);
}
function Cf(a, b, c) {
    if (J.current !== yf) throw Error(u(168));
    I(J, b);
    I(K, c);
}
function Df(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(u(108, pb(b) || "Unknown", e));
    return $de9zv({}, c, {}, d);
}
function Ef(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || yf;
    zf = J.current;
    I(J, a);
    I(K, K.current);
    return !0;
}
function Ff(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(u(169));
    c ? (a = Df(a, b, zf), d.__reactInternalMemoizedMergedChildContext = a, H(K), H(J), I(J, a)) : H(K);
    I(K, c);
}
var Gf = $wmpq0.unstable_runWithPriority, Hf = $wmpq0.unstable_scheduleCallback, If = $wmpq0.unstable_cancelCallback, Jf = $wmpq0.unstable_shouldYield, Kf = $wmpq0.unstable_requestPaint, Lf = $wmpq0.unstable_now, Mf = $wmpq0.unstable_getCurrentPriorityLevel, Nf = $wmpq0.unstable_ImmediatePriority, Of = $wmpq0.unstable_UserBlockingPriority, Pf = $wmpq0.unstable_NormalPriority, Qf = $wmpq0.unstable_LowPriority, Rf = $wmpq0.unstable_IdlePriority;
if (null == $jpvB9.__interactionsRef || null == $jpvB9.__interactionsRef.current) throw Error(u(302));
var Sf = {}, Tf = void 0 !== Kf ? Kf : function() {}, Uf = null, Vf = null, Wf = !1, Xf = Lf(), N = 1E4 > Xf ? Lf : function() {
    return Lf() - Xf;
};
function Yf() {
    switch(Mf()){
        case Nf:
            return 99;
        case Of:
            return 98;
        case Pf:
            return 97;
        case Qf:
            return 96;
        case Rf:
            return 95;
        default:
            throw Error(u(332));
    }
}
function Zf(a) {
    switch(a){
        case 99:
            return Nf;
        case 98:
            return Of;
        case 97:
            return Pf;
        case 96:
            return Qf;
        case 95:
            return Rf;
        default:
            throw Error(u(332));
    }
}
function $f(a, b) {
    a = Zf(a);
    return Gf(a, b);
}
function ag(a, b, c) {
    a = Zf(a);
    return Hf(a, b, c);
}
function bg(a) {
    null === Uf ? (Uf = [
        a
    ], Vf = Hf(Nf, cg)) : Uf.push(a);
    return Sf;
}
function dg() {
    if (null !== Vf) {
        var a = Vf;
        Vf = null;
        If(a);
    }
    cg();
}
function cg() {
    if (!Wf && null !== Uf) {
        Wf = !0;
        var a = 0;
        try {
            var b = Uf;
            $f(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            Uf = null;
        } catch (c) {
            throw null !== Uf && (Uf = Uf.slice(a + 1)), Hf(Nf, dg), c;
        } finally{
            Wf = !1;
        }
    }
}
function eg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function fg(a, b) {
    if (1073741823 === b) return 99;
    if (1 === b || 2 === b) return 95;
    a = 10 * (1073741821 - b) - 10 * (1073741821 - a);
    return 0 >= a ? 99 : 250 >= a ? 98 : 5250 >= a ? 97 : 95;
}
function gg(a, b) {
    if (a && a.defaultProps) {
        b = $de9zv({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
var hg = {
    current: null
}, ig = null, jg = null, kg = null;
function lg() {
    kg = jg = ig = null;
}
function mg(a) {
    var b = hg.current;
    H(hg);
    a.type._context._currentValue = b;
}
function ng(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a.return;
    }
}
function og(a, b) {
    ig = a;
    kg = jg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && (pg = !0), a.firstContext = null);
}
function qg(a, b) {
    if (kg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) kg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === jg) {
            if (null === ig) throw Error(u(308));
            jg = b;
            ig.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else jg = jg.next = b;
    }
    return a._currentValue;
}
var rg = !1;
function sg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        baseQueue: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function tg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        baseQueue: a.baseQueue,
        shared: a.shared,
        effects: a.effects
    });
}
function ug(a, b) {
    a = {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
    return a.next = a;
}
function vg(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function wg(a, b) {
    var c = a.alternate;
    null !== c && tg(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function xg(a, b, c, d) {
    var e = a.updateQueue;
    rg = !1;
    var f = e.baseQueue, g = e.shared.pending;
    if (null !== g) {
        if (null !== f) {
            var h = f.next;
            f.next = g.next;
            g.next = h;
        }
        f = g;
        e.shared.pending = null;
        h = a.alternate;
        null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }
    if (null !== f) {
        h = f.next;
        var k = e.baseState, l = 0, m = null, q = null, x = null;
        if (null !== h) {
            var y = h;
            do {
                g = y.expirationTime;
                if (g < d) {
                    var S = {
                        expirationTime: y.expirationTime,
                        suspenseConfig: y.suspenseConfig,
                        tag: y.tag,
                        payload: y.payload,
                        callback: y.callback,
                        next: null
                    };
                    null === x ? (q = x = S, m = k) : x = x.next = S;
                    g > l && (l = g);
                } else {
                    null !== x && (x = x.next = {
                        expirationTime: 1073741823,
                        suspenseConfig: y.suspenseConfig,
                        tag: y.tag,
                        payload: y.payload,
                        callback: y.callback,
                        next: null
                    });
                    yg(g, y.suspenseConfig);
                    a: {
                        var L = a, A = y;
                        g = b;
                        S = c;
                        switch(A.tag){
                            case 1:
                                L = A.payload;
                                if ("function" === typeof L) {
                                    k = L.call(S, k, g);
                                    break a;
                                }
                                k = L;
                                break a;
                            case 3:
                                L.effectTag = L.effectTag & -4097 | 64;
                            case 0:
                                L = A.payload;
                                g = "function" === typeof L ? L.call(S, k, g) : L;
                                if (null === g || void 0 === g) break a;
                                k = $de9zv({}, k, g);
                                break a;
                            case 2:
                                rg = !0;
                        }
                    }
                    null !== y.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [
                        y
                    ] : g.push(y));
                }
                y = y.next;
                if (null === y || y === h) {
                    if (g = e.shared.pending, null === g) break;
                    else y = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
                }
            }while (1);
        }
        null === x ? m = k : x.next = q;
        e.baseState = m;
        e.baseQueue = x;
        zg(l);
        a.expirationTime = l;
        a.memoizedState = k;
    }
}
function Ag(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = e;
            e = c;
            if ("function" !== typeof d) throw Error(u(191, d));
            d.call(e);
        }
    }
}
var Bg = Wa.ReactCurrentBatchConfig, Cg = (new $9nHZC.Component).refs;
function Dg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $de9zv({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var Hg = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? cc(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Eg(), e = Bg.suspense;
        d = Fg(d, a, e);
        e = ug(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        vg(a, e);
        Gg(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Eg(), e = Bg.suspense;
        d = Fg(d, a, e);
        e = ug(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        vg(a, e);
        Gg(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = Eg(), d = Bg.suspense;
        c = Fg(c, a, d);
        d = ug(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        vg(a, d);
        Gg(a, c);
    }
};
function Ig(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$e(c, d) || !$e(e, f) : !0;
}
function Jg(a, b, c) {
    var d = !1, e = yf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = qg(f) : (e = M(b) ? zf : J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Af(a, e) : yf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Hg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Kg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Hg.enqueueReplaceState(b, b.state, null);
}
function Lg(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Cg;
    sg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = qg(f) : (f = M(b) ? zf : J.current, e.context = Af(a, f));
    xg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Dg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Hg.enqueueReplaceState(e, e.state, null), xg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var Mg = Array.isArray;
function Ng(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(u(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(u(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Cg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(u(284));
        if (!c._owner) throw Error(u(290, a));
    }
    return a;
}
function Og(a, b) {
    if ("textarea" !== a.type) throw Error(u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function Pg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Qg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Rg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Ng(a, b, c), d.return = a, d;
        d = Sg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Ng(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Tg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Ug(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Rg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case Za:
                    return c = Sg(b.type, b.key, b.props, null, a.mode, c), c.ref = Ng(a, null, b), c.return = a, c;
                case $a:
                    return b = Tg(b, a.mode, c), b.return = a, b;
            }
            if (Mg(b) || nb(b)) return b = Ug(b, a.mode, c, null), b.return = a, b;
            Og(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case Za:
                    return c.key === e ? c.type === ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $a:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Mg(c) || nb(c)) return null !== e ? null : m(a, b, c, d, null);
            Og(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case Za:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $a:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Mg(d) || nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Og(b, d);
        }
        return null;
    }
    function S(e, g, h, k) {
        for(var l = null, m = null, p = g, v = g = 0, A = null; null !== p && v < h.length; v++){
            p.index > v ? (A = p, p = null) : A = p.sibling;
            var w = x(e, p, h[v], k);
            if (null === w) {
                null === p && (p = A);
                break;
            }
            a && p && null === w.alternate && b(e, p);
            g = f(w, g, v);
            null === m ? l = w : m.sibling = w;
            m = w;
            p = A;
        }
        if (v === h.length) return c(e, p), l;
        if (null === p) {
            for(; v < h.length; v++)p = q(e, h[v], k), null !== p && (g = f(p, g, v), null === m ? l = p : m.sibling = p, m = p);
            return l;
        }
        for(p = d(e, p); v < h.length; v++)A = y(p, e, v, h[v], k), null !== A && (a && null !== A.alternate && p.delete(null === A.key ? v : A.key), g = f(A, g, v), null === m ? l = A : m.sibling = A, m = A);
        a && p.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function L(e, g, h, k) {
        var l = nb(h);
        if ("function" !== typeof l) throw Error(u(150));
        h = l.call(h);
        if (null == h) throw Error(u(151));
        for(var m = l = null, p = g, v = g = 0, A = null, w = h.next(); null !== p && !w.done; v++, w = h.next()){
            p.index > v ? (A = p, p = null) : A = p.sibling;
            var X = x(e, p, w.value, k);
            if (null === X) {
                null === p && (p = A);
                break;
            }
            a && p && null === X.alternate && b(e, p);
            g = f(X, g, v);
            null === m ? l = X : m.sibling = X;
            m = X;
            p = A;
        }
        if (w.done) return c(e, p), l;
        if (null === p) {
            for(; !w.done; v++, w = h.next())w = q(e, w.value, k), null !== w && (g = f(w, g, v), null === m ? l = w : m.sibling = w, m = w);
            return l;
        }
        for(p = d(e, p); !w.done; v++, w = h.next())w = y(p, e, v, w.value, k), null !== w && (a && null !== w.alternate && p.delete(null === w.key ? v : w.key), g = f(w, g, v), null === m ? l = w : m.sibling = w, m = w);
        a && p.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ab && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case Za:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ab) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Ng(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ab ? (d = Ug(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Sg(f.type, f.key, f.props, null, a.mode, h), h.ref = Ng(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $a:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Tg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Rg(f, a.mode, h), d.return = a, a = d), g(a);
        if (Mg(f)) return S(a, d, f, h);
        if (nb(f)) return L(a, d, f, h);
        l && Og(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, Error(u(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
    };
}
var Vg = Pg(!0), Wg = Pg(!1), Xg = {}, Yg = {
    current: Xg
}, Zg = {
    current: Xg
}, $g = {
    current: Xg
};
function ah(a) {
    if (a === Xg) throw Error(u(174));
    return a;
}
function bh(a, b) {
    I($g, b);
    I(Zg, a);
    I(Yg, Xg);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : Nb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = Nb(b, a);
    }
    H(Yg);
    I(Yg, b);
}
function ch() {
    H(Yg);
    H(Zg);
    H($g);
}
function dh(a) {
    ah($g.current);
    var b = ah(Yg.current);
    var c = Nb(b, a.type);
    b !== c && (I(Zg, a), I(Yg, c));
}
function eh(a) {
    Zg.current === a && (H(Yg), H(Zg));
}
var O = {
    current: 0
};
function fh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === zd || c.data === Ad)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
function gh(a, b) {
    return {
        responder: a,
        props: b
    };
}
var hh = Wa.ReactCurrentDispatcher, ih = Wa.ReactCurrentBatchConfig, jh = 0, P = null, Q = null, R = null, kh = !1;
function lh() {
    throw Error(u(321));
}
function mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!Ye(a[c], b[c])) return !1;
    return !0;
}
function nh(a, b, c, d, e, f) {
    jh = f;
    P = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    hh.current = null === a || null === a.memoizedState ? oh : ph;
    a = c(d, e);
    if (b.expirationTime === jh) {
        f = 0;
        do {
            b.expirationTime = 0;
            if (!(25 > f)) throw Error(u(301));
            f += 1;
            R = Q = null;
            b.updateQueue = null;
            hh.current = qh;
            a = c(d, e);
        }while (b.expirationTime === jh);
    }
    hh.current = rh;
    b = null !== Q && null !== Q.next;
    jh = 0;
    R = Q = P = null;
    kh = !1;
    if (b) throw Error(u(300));
    return a;
}
function sh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === R ? P.memoizedState = R = a : R = R.next = a;
    return R;
}
function th() {
    if (null === Q) {
        var a = P.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = Q.next;
    var b = null === R ? P.memoizedState : R.next;
    if (null !== b) R = b, Q = a;
    else {
        if (null === a) throw Error(u(310));
        Q = a;
        a = {
            memoizedState: Q.memoizedState,
            baseState: Q.baseState,
            baseQueue: Q.baseQueue,
            queue: Q.queue,
            next: null
        };
        null === R ? P.memoizedState = R = a : R = R.next = a;
    }
    return R;
}
function uh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function vh(a) {
    var b = th(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = Q, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.expirationTime;
            if (l < jh) {
                var m = {
                    expirationTime: k.expirationTime,
                    suspenseConfig: k.suspenseConfig,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = m, f = d) : h = h.next = m;
                l > P.expirationTime && (P.expirationTime = l, zg(l));
            } else null !== h && (h = h.next = {
                expirationTime: 1073741823,
                suspenseConfig: k.suspenseConfig,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), yg(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        Ye(d, b.memoizedState) || (pg = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function wh(a) {
    var b = th(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        Ye(f, b.memoizedState) || (pg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function xh(a) {
    var b = sh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: uh,
        lastRenderedState: a
    };
    a = a.dispatch = yh.bind(null, P, a);
    return [
        b.memoizedState,
        a
    ];
}
function zh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = P.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, P.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Ah() {
    return th().memoizedState;
}
function Bh(a, b, c, d) {
    var e = sh();
    P.effectTag |= a;
    e.memoizedState = zh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Ch(a, b, c, d) {
    var e = th();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== Q) {
        var g = Q.memoizedState;
        f = g.destroy;
        if (null !== d && mh(d, g.deps)) {
            zh(b, c, f, d);
            return;
        }
    }
    P.effectTag |= a;
    e.memoizedState = zh(1 | b, c, f, d);
}
function Dh(a, b) {
    return Bh(516, 4, a, b);
}
function Eh(a, b) {
    return Ch(516, 4, a, b);
}
function Fh(a, b) {
    return Ch(4, 2, a, b);
}
function Gh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function Hh(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Ch(4, 2, Gh.bind(null, b, a), c);
}
function Jh() {}
function Kh(a, b) {
    sh().memoizedState = [
        a,
        void 0 === b ? null : b
    ];
    return a;
}
function Lh(a, b) {
    var c = th();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Mh(a, b) {
    var c = th();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Nh(a, b, c) {
    var d = Yf();
    $f(98 > d ? 98 : d, function() {
        a(!0);
    });
    $f(97 < d ? 97 : d, function() {
        var d = ih.suspense;
        ih.suspense = void 0 === b ? null : b;
        try {
            a(!1), c();
        } finally{
            ih.suspense = d;
        }
    });
}
function yh(a, b, c) {
    var d = Eg(), e = Bg.suspense;
    d = Fg(d, a, e);
    e = {
        expirationTime: d,
        suspenseConfig: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === P || null !== f && f === P) kh = !0, e.expirationTime = jh, P.expirationTime = jh;
    else {
        if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.eagerReducer = f;
            e.eagerState = h;
            if (Ye(h, g)) return;
        } catch (k) {} finally{}
        Gg(a, d);
    }
}
var rh = {
    readContext: qg,
    useCallback: lh,
    useContext: lh,
    useEffect: lh,
    useImperativeHandle: lh,
    useLayoutEffect: lh,
    useMemo: lh,
    useReducer: lh,
    useRef: lh,
    useState: lh,
    useDebugValue: lh,
    useResponder: lh,
    useDeferredValue: lh,
    useTransition: lh
}, oh = {
    readContext: qg,
    useCallback: Kh,
    useContext: qg,
    useEffect: Dh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Bh(4, 2, Gh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Bh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = sh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = sh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = yh.bind(null, P, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = sh();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: xh,
    useDebugValue: Jh,
    useResponder: gh,
    useDeferredValue: function(a, b) {
        var c = xh(a), d = c[0], e = c[1];
        Dh(function() {
            var c = ih.suspense;
            ih.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                ih.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = xh(!1), c = b[0];
        b = b[1];
        return [
            Kh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, ph = {
    readContext: qg,
    useCallback: Lh,
    useContext: qg,
    useEffect: Eh,
    useImperativeHandle: Hh,
    useLayoutEffect: Fh,
    useMemo: Mh,
    useReducer: vh,
    useRef: Ah,
    useState: function() {
        return vh(uh);
    },
    useDebugValue: Jh,
    useResponder: gh,
    useDeferredValue: function(a, b) {
        var c = vh(uh), d = c[0], e = c[1];
        Eh(function() {
            var c = ih.suspense;
            ih.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                ih.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = vh(uh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, qh = {
    readContext: qg,
    useCallback: Lh,
    useContext: qg,
    useEffect: Eh,
    useImperativeHandle: Hh,
    useLayoutEffect: Fh,
    useMemo: Mh,
    useReducer: wh,
    useRef: Ah,
    useState: function() {
        return wh(uh);
    },
    useDebugValue: Jh,
    useResponder: gh,
    useDeferredValue: function(a, b) {
        var c = wh(uh), d = c[0], e = c[1];
        Eh(function() {
            var c = ih.suspense;
            ih.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                ih.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = wh(uh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, Oh = $wmpq0.unstable_now, Ph = 0, Qh = -1;
function Rh(a, b) {
    if (0 <= Qh) {
        var c = Oh() - Qh;
        a.actualDuration += c;
        b && (a.selfBaseDuration = c);
        Qh = -1;
    }
}
var Sh = null, Th = null, Uh = !1;
function Vh(a, b) {
    var c = Wh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function Xh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function Yh(a) {
    if (Uh) {
        var b = Th;
        if (b) {
            var c = b;
            if (!Xh(a, b)) {
                b = Hd(c.nextSibling);
                if (!b || !Xh(a, b)) {
                    a.effectTag = a.effectTag & -1025 | 2;
                    Uh = !1;
                    Sh = a;
                    return;
                }
                Vh(Sh, c);
            }
            Sh = a;
            Th = Hd(b.firstChild);
        } else a.effectTag = a.effectTag & -1025 | 2, Uh = !1, Sh = a;
    }
}
function Zh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    Sh = a;
}
function $h(a) {
    if (a !== Sh) return !1;
    if (!Uh) return Zh(a), Uh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !Ed(b, a.memoizedProps)) for(b = Th; b;)Vh(a, b), b = Hd(b.nextSibling);
    Zh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(u(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if (c === yd) {
                        if (0 === b) {
                            Th = Hd(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else c !== xd && c !== Ad && c !== zd || b++;
                }
                a = a.nextSibling;
            }
            Th = null;
        }
    } else Th = Sh ? Hd(a.stateNode.nextSibling) : null;
    return !0;
}
function ai() {
    Th = Sh = null;
    Uh = !1;
}
var bi = Wa.ReactCurrentOwner, pg = !1;
function ci(a, b, c, d) {
    b.child = null === a ? Wg(b, null, c, d) : Vg(b, a.child, c, d);
}
function di(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    og(b, e);
    d = nh(a, b, c, d, f, e);
    if (null !== a && !pg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), ei(a, b, e);
    b.effectTag |= 1;
    ci(a, b, d, e);
    return b.child;
}
function fi(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !gi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, hi(a, b, g, d, e, f);
        a = Sg(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : $e, c(e, d) && a.ref === b.ref)) return ei(a, b, f);
    b.effectTag |= 1;
    a = Qg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function hi(a, b, c, d, e, f) {
    return null !== a && $e(a.memoizedProps, d) && a.ref === b.ref && (pg = !1, e < f) ? (b.expirationTime = a.expirationTime, ei(a, b, f)) : ii(a, b, c, d, f);
}
function ji(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function ii(a, b, c, d, e) {
    var f = M(c) ? zf : J.current;
    f = Af(b, f);
    og(b, e);
    c = nh(a, b, c, d, f, e);
    if (null !== a && !pg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), ei(a, b, e);
    b.effectTag |= 1;
    ci(a, b, c, e);
    return b.child;
}
function ki(a, b, c, d, e) {
    if (M(c)) {
        var f = !0;
        Ef(b);
    } else f = !1;
    og(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Jg(b, c, d), Lg(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = qg(l) : (l = M(c) ? zf : J.current, l = Af(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Kg(b, g, d, l);
        rg = !1;
        var x = b.memoizedState;
        g.state = x;
        xg(b, d, g, e);
        k = b.memoizedState;
        h !== d || x !== k || K.current || rg ? ("function" === typeof m && (Dg(b, c, m, d), k = b.memoizedState), (h = rg || Ig(b, c, h, d, x, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, tg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : gg(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = qg(l) : (l = M(c) ? zf : J.current, l = Af(b, l)), m = c.getDerivedStateFromProps, (q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Kg(b, g, d, l), rg = !1, k = b.memoizedState, g.state = k, xg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || K.current || rg ? ("function" === typeof m && (Dg(b, c, m, d), x = b.memoizedState), (m = rg || Ig(b, c, h, d, k, x, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return li(a, b, c, d, f, e);
}
function li(a, b, c, d, e, f) {
    ji(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && Ff(b, c, !1), ei(a, b, f);
    d = b.stateNode;
    bi.current = b;
    if (g && "function" !== typeof c.getDerivedStateFromError) {
        var h = null;
        Qh = -1;
    } else h = d.render();
    b.effectTag |= 1;
    null !== a && g ? (g = h, b.child = Vg(b, a.child, null, f), b.child = Vg(b, null, g, f)) : ci(a, b, h, f);
    b.memoizedState = d.state;
    e && Ff(b, c, !0);
    return b.child;
}
function mi(a) {
    var b = a.stateNode;
    b.pendingContext ? Cf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Cf(a, b.context, !1);
    bh(a, b.containerInfo);
}
var ni = {
    dehydrated: null,
    retryTime: 0
};
function oi(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = O.current, g = !1, h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    I(O, f & 1);
    if (null === a) {
        void 0 !== e.fallback && Yh(b);
        if (g) {
            g = e.fallback;
            e = Ug(null, d, 0, null);
            e.return = b;
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
            c = Ug(g, d, c, null);
            c.return = b;
            e.sibling = c;
            b.memoizedState = ni;
            b.child = e;
            return c;
        }
        d = e.children;
        b.memoizedState = null;
        return b.child = Wg(b, null, d, c);
    }
    if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;
        if (g) {
            e = e.fallback;
            c = Qg(a, a.pendingProps);
            c.return = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
            if (b.mode & 8) {
                g = 0;
                for(a = c.child; null !== a;)g += a.treeBaseDuration, a = a.sibling;
                c.treeBaseDuration = g;
            }
            d = Qg(d, e);
            d.return = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = ni;
            b.child = c;
            return d;
        }
        c = Vg(b, a.child, e.children, c);
        b.memoizedState = null;
        return b.child = c;
    }
    a = a.child;
    if (g) {
        g = e.fallback;
        e = Ug(null, d, 0, null);
        e.return = b;
        e.child = a;
        null !== a && (a.return = e);
        if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
        if (b.mode & 8) {
            a = 0;
            for(f = e.child; null !== f;)a += f.treeBaseDuration, f = f.sibling;
            e.treeBaseDuration = a;
        }
        c = Ug(g, d, c, null);
        c.return = b;
        e.sibling = c;
        c.effectTag |= 2;
        e.childExpirationTime = 0;
        b.memoizedState = ni;
        b.child = e;
        return c;
    }
    b.memoizedState = null;
    return b.child = Vg(b, a, e.children, c);
}
function pi(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    ng(a.return, b);
}
function qi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function ri(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    ci(a, b, d.children, c);
    d = O.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && pi(a, c);
            else if (19 === a.tag) pi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(O, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === fh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            qi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === fh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            qi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            qi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function ei(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Qh = -1;
    var d = b.expirationTime;
    0 !== d && zg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error(u(153));
    if (null !== b.child) {
        a = b.child;
        c = Qg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Qg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
var si, ti, ui, vi;
si = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
ti = function() {};
ui = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        ah(Yg.current);
        a = null;
        switch(c){
            case "input":
                f = wb(g, f);
                d = wb(g, d);
                a = [];
                break;
            case "option":
                f = Fb(g, f);
                d = Fb(g, d);
                a = [];
                break;
            case "select":
                f = $de9zv({}, f, {
                    value: void 0
                });
                d = $de9zv({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = Hb(g, f);
                d = Hb(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = qd);
        }
        md(c, d);
        var h, k;
        c = null;
        for(h in f)if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) {
            if ("style" === h) for(k in g = f[h], g)g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
            else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
        }
        for(h in d){
            var l = d[h];
            g = null != f ? f[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) {
                if ("style" === h) {
                    if (g) {
                        for(k in g)!g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                        for(k in l)l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                    } else c || (a || (a = []), a.push(h, c)), c = l;
                } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (va.hasOwnProperty(h) ? (null != l && pd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
            }
        }
        c && (a = a || []).push("style", c);
        e = a;
        if (b.updateQueue = e) b.effectTag |= 4;
    }
};
vi = function(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
};
function wi(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function xi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return M(b.type) && Bf(), null;
        case 3:
            return ch(), H(K), H(J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !$h(b) || (b.effectTag |= 4), ti(b), null;
        case 5:
            eh(b);
            c = ah($g.current);
            var e = b.type;
            if (null !== a && null != b.stateNode) ui(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(u(166));
                    return null;
                }
                a = ah(Yg.current);
                if ($h(b)) {
                    d = b.stateNode;
                    e = b.type;
                    var f = b.memoizedProps;
                    d[Kd] = b;
                    d[Ld] = f;
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < $b.length; a++)F($b[a], d);
                            break;
                        case "source":
                            F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", d);
                            F("load", d);
                            break;
                        case "form":
                            F("reset", d);
                            F("submit", d);
                            break;
                        case "details":
                            F("toggle", d);
                            break;
                        case "input":
                            xb(d, f);
                            F("invalid", d);
                            pd(c, "onChange");
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            F("invalid", d);
                            pd(c, "onChange");
                            break;
                        case "textarea":
                            Ib(d, f), F("invalid", d), pd(c, "onChange");
                    }
                    md(e, f);
                    a = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (a = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (a = [
                            "children",
                            "" + h
                        ]) : va.hasOwnProperty(g) && null != h && pd(c, g);
                    }
                    switch(e){
                        case "input":
                            ub(d);
                            Db(d, f, !0);
                            break;
                        case "textarea":
                            ub(d);
                            Kb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = qd);
                    }
                    c = a;
                    b.updateQueue = c;
                    null !== c && (b.effectTag |= 4);
                } else {
                    g = 9 === c.nodeType ? c : c.ownerDocument;
                    a === od && (a = Mb(e));
                    a === od ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
                        is: d.is
                    }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
                    a[Kd] = b;
                    a[Ld] = d;
                    si(a, b, !1, !1);
                    b.stateNode = a;
                    g = nd(e, d);
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", a);
                            h = d;
                            break;
                        case "video":
                        case "audio":
                            for(h = 0; h < $b.length; h++)F($b[h], a);
                            h = d;
                            break;
                        case "source":
                            F("error", a);
                            h = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", a);
                            F("load", a);
                            h = d;
                            break;
                        case "form":
                            F("reset", a);
                            F("submit", a);
                            h = d;
                            break;
                        case "details":
                            F("toggle", a);
                            h = d;
                            break;
                        case "input":
                            xb(a, d);
                            h = wb(a, d);
                            F("invalid", a);
                            pd(c, "onChange");
                            break;
                        case "option":
                            h = Fb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            h = $de9zv({}, d, {
                                value: void 0
                            });
                            F("invalid", a);
                            pd(c, "onChange");
                            break;
                        case "textarea":
                            Ib(a, d);
                            h = Hb(a, d);
                            F("invalid", a);
                            pd(c, "onChange");
                            break;
                        default:
                            h = d;
                    }
                    md(e, h);
                    var k = h;
                    for(f in k)if (k.hasOwnProperty(f)) {
                        var l = k[f];
                        "style" === f ? kd(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && Pb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && Qb(a, l) : "number" === typeof l && Qb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (va.hasOwnProperty(f) ? null != l && pd(c, f) : null != l && Xa(a, f, l, g));
                    }
                    switch(e){
                        case "input":
                            ub(a);
                            Db(a, d, !1);
                            break;
                        case "textarea":
                            ub(a);
                            Kb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + rb(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            c = d.value;
                            null != c ? Gb(a, !!d.multiple, c, !1) : null != d.defaultValue && Gb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof h.onClick && (a.onclick = qd);
                    }
                    Dd(e, d) && (b.effectTag |= 4);
                }
                null !== b.ref && (b.effectTag |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) vi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(u(166));
                c = ah($g.current);
                ah(Yg.current);
                $h(b) ? (c = b.stateNode, d = b.memoizedProps, c[Kd] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[Kd] = b, b.stateNode = c);
            }
            return null;
        case 13:
            H(O);
            d = b.memoizedState;
            if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
            c = null !== d;
            d = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && $h(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
            if (c && !d && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (O.current & 1)) T === yi && (T = zi);
                else {
                    if (T === yi || T === zi) T = Ai;
                    0 !== Bi && null !== Ci && (Di(Ci, U), Ei(Ci, Bi));
                }
            }
            if (c || d) b.effectTag |= 4;
            return null;
        case 4:
            return ch(), ti(b), null;
        case 10:
            return mg(b), null;
        case 17:
            return M(b.type) && Bf(), null;
        case 19:
            H(O);
            d = b.memoizedState;
            if (null === d) return null;
            e = 0 !== (b.effectTag & 64);
            f = d.rendering;
            if (null === f) {
                if (e) wi(d, !1);
                else {
                    if (T !== yi || null !== a && 0 !== (a.effectTag & 64)) for(f = b.child; null !== f;){
                        a = fh(f);
                        if (null !== a) {
                            b.effectTag |= 64;
                            wi(d, !1);
                            e = a.updateQueue;
                            null !== e && (b.updateQueue = e, b.effectTag |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            for(d = b.child; null !== d;)e = d, a = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, f = e.alternate, null === f ? (e.childExpirationTime = 0, e.expirationTime = a, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.selfBaseDuration = 0, e.treeBaseDuration = 0) : (e.childExpirationTime = f.childExpirationTime, e.expirationTime = f.expirationTime, e.child = f.child, e.memoizedProps = f.memoizedProps, e.memoizedState = f.memoizedState, e.updateQueue = f.updateQueue, a = f.dependencies, e.dependencies = null === a ? null : {
                                expirationTime: a.expirationTime,
                                firstContext: a.firstContext,
                                responders: a.responders
                            }, e.selfBaseDuration = f.selfBaseDuration, e.treeBaseDuration = f.treeBaseDuration), d = d.sibling;
                            I(O, O.current & 1 | 2);
                            return b.child;
                        }
                        f = f.sibling;
                    }
                }
            } else {
                if (!e) {
                    if (a = fh(f), null !== a) {
                        if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), wi(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * N() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, wi(d, !1), --c, b.expirationTime = b.childExpirationTime = c, Fi(c));
                }
                d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
            }
            return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = N() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = N(), c.sibling = null, b = O.current, I(O, e ? b & 1 | 2 : b & 1), c) : null;
    }
    throw Error(u(156, b.tag));
}
function Gi(a) {
    switch(a.tag){
        case 1:
            M(a.type) && Bf();
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 3:
            ch();
            H(K);
            H(J);
            b = a.effectTag;
            if (0 !== (b & 64)) throw Error(u(285));
            a.effectTag = b & -4097 | 64;
            return a;
        case 5:
            return eh(a), null;
        case 13:
            return H(O), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 19:
            return H(O), null;
        case 4:
            return ch(), null;
        case 10:
            return mg(a), null;
        default:
            return null;
    }
}
function Hi(a, b) {
    return {
        value: a,
        source: b,
        stack: qb(b)
    };
}
var Ii = "function" === typeof WeakSet ? WeakSet : Set;
function Ji(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = qb(c));
    null !== c && pb(c.type);
    b = b.value;
    null !== a && 1 === a.tag && pb(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function Ki(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        Li(a, c);
    }
}
function Mi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Li(a, c);
        }
        else b.current = null;
    }
}
function Ni(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.effectTag & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : gg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(u(163));
}
function Oi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.destroy;
                c.destroy = void 0;
                void 0 !== d && d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Pi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Qi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            Pi(3, c);
            return;
        case 1:
            a = c.stateNode;
            if (c.effectTag & 4) {
                if (null === b) a.componentDidMount();
                else {
                    var d = c.elementType === c.type ? b.memoizedProps : gg(c.type, b.memoizedProps);
                    a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
                }
            }
            b = c.updateQueue;
            null !== b && Ag(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Ag(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.effectTag & 4 && Dd(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            d = c.memoizedProps.onRender;
            "function" === typeof d && d(c.memoizedProps.id, null === b ? "mount" : "update", c.actualDuration, c.treeBaseDuration, c.actualStartTime, Ph, a.memoizedInteractions);
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Uc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
            return;
    }
    throw Error(u(163));
}
function Ri(a, b, c) {
    "function" === typeof Si && Si(b);
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a.next;
                $f(97 < c ? 97 : c, function() {
                    var a = d;
                    do {
                        var c = a.destroy;
                        if (void 0 !== c) {
                            var g = b;
                            try {
                                c();
                            } catch (h) {
                                Li(g, h);
                            }
                        }
                        a = a.next;
                    }while (a !== d);
                });
            }
            break;
        case 1:
            Mi(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && Ki(b, c);
            break;
        case 5:
            Mi(b);
            break;
        case 4:
            Ti(a, b, c);
    }
}
function Ui(a) {
    var b = a.alternate;
    a.return = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && Ui(b);
}
function Vi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Wi(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (Vi(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        throw Error(u(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(u(161));
    }
    c.effectTag & 16 && (Qb(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || Vi(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? Xi(a, c, b) : Yi(a, c, b);
}
function Xi(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = qd));
    else if (4 !== d && (a = a.child, null !== a)) for(Xi(a, b, c), a = a.sibling; null !== a;)Xi(a, b, c), a = a.sibling;
}
function Yi(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Yi(a, b, c), a = a.sibling; null !== a;)Yi(a, b, c), a = a.sibling;
}
function Ti(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d.return;
            a: for(;;){
                if (null === e) throw Error(u(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e.return;
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if (Ri(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;
            else {
                if (m === k) break a;
                for(; null === m.sibling;){
                    if (null === m.return || m.return === k) break a;
                    m = m.return;
                }
                m.sibling.return = m.return;
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child.return = d;
                d = d.child;
                continue;
            }
        } else if (Ri(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d.return || d.return === b) return;
            d = d.return;
            4 === d.tag && (e = !1);
        }
        d.sibling.return = d.return;
        d = d.sibling;
    }
}
function Zi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            Oi(3, b);
            return;
        case 1:
            return;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[Ld] = d;
                    "input" === a && "radio" === d.type && null != d.name && yb(c, d);
                    nd(a, e);
                    b = nd(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? kd(c, h) : "dangerouslySetInnerHTML" === g ? Pb(c, h) : "children" === g ? Qb(c, h) : Xa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            zb(c, d);
                            break;
                        case "textarea":
                            Jb(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? Gb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? Gb(c, !!d.multiple, d.defaultValue, !0) : Gb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = !1, Uc(b.containerInfo));
            return;
        case 12:
            return;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, $i = N());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = jd("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f = a.child.sibling;
                    f.return = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === c) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            aj(b);
            return;
        case 19:
            aj(b);
            return;
        case 17:
            return;
    }
    throw Error(u(163));
}
function aj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ii);
        b.forEach(function(b) {
            var d = bj.bind(null, a, b);
            c.has(b) || (!0 !== b.__reactDoNotTraceInteractions && (d = $jpvB9.unstable_wrap(d)), c.add(b), b.then(d, d));
        });
    }
}
var cj = "function" === typeof WeakMap ? WeakMap : Map;
function dj(a, b, c) {
    c = ug(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        ej || (ej = !0, fj = d);
        Ji(a, b);
    };
    return c;
}
function gj(a, b, c) {
    c = ug(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ji(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === hj ? hj = new Set([
            this
        ]) : hj.add(this), Ji(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var ij = Math.ceil, jj = Wa.ReactCurrentDispatcher, kj = Wa.ReactCurrentOwner, V = 0, lj = 8, mj = 16, nj = 32, yi = 0, oj = 1, pj = 2, zi = 3, Ai = 4, qj = 5, W = V, Ci = null, Y = null, U = 0, T = yi, rj = null, sj = 1073741823, tj = 1073741823, uj = null, Bi = 0, vj = !1, $i = 0, wj = 500, Z = null, ej = !1, fj = null, hj = null, xj = !1, yj = null, zj = 90, Aj = 0, Bj = null, Cj = 0, Dj = null, Ej = null, Fj = 0;
function Eg() {
    return (W & (mj | nj)) !== V ? 1073741821 - (N() / 10 | 0) : 0 !== Fj ? Fj : Fj = 1073741821 - (N() / 10 | 0);
}
function Fg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = Yf();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if ((W & mj) !== V) return U;
    if (null !== c) a = eg(a, c.timeoutMs | 0 || 5E3, 250);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = eg(a, 150, 100);
            break;
        case 97:
        case 96:
            a = eg(a, 5E3, 250);
            break;
        case 95:
            a = 2;
            break;
        default:
            throw Error(u(326));
    }
    null !== Ci && a === U && --a;
    return a;
}
function Gg(a, b) {
    if (50 < Cj) throw Cj = 0, Dj = null, Error(u(185));
    a = Gj(a, b);
    if (null !== a) {
        var c = Yf();
        1073741823 === b ? (W & lj) !== V && (W & (mj | nj)) === V ? (Hj(a, b), Ij(a)) : (Jj(a), Hj(a, b), W === V && dg()) : (Jj(a), Hj(a, b));
        (W & 4) === V || 98 !== c && 99 !== c || (null === Bj ? Bj = new Map([
            [
                a,
                b
            ]
        ]) : (c = Bj.get(a), (void 0 === c || c > b) && Bj.set(a, b)));
    }
}
function Gj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    null !== e && (Ci === e && (zg(b), T === Ai && Di(e, U)), Ei(e, b));
    return e;
}
function Kj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!Lj(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
}
function Jj(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = bg(Ij.bind(null, a));
    else {
        var b = Kj(a), c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
        else {
            var d = Eg();
            d = fg(d, b);
            if (null !== c) {
                var e = a.callbackPriority;
                if (a.callbackExpirationTime === b && e >= d) return;
                c !== Sf && If(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? bg(Ij.bind(null, a)) : ag(d, Mj.bind(null, a), {
                timeout: 10 * (1073741821 - b) - N()
            });
            a.callbackNode = b;
        }
    }
}
function Mj(a, b) {
    Fj = 0;
    if (b) return b = Eg(), Nj(a, b), Jj(a), null;
    var c = Kj(a);
    if (0 !== c) {
        b = a.callbackNode;
        if ((W & (mj | nj)) !== V) throw Error(u(327));
        Oj();
        if (a !== Ci || c !== U) Pj(a, c), Qj(a, c);
        if (null !== Y) {
            var d = W;
            W |= mj;
            var e = Rj(), f = Sj(a);
            for(;;)try {
                Tj();
                break;
            } catch (h) {
                Uj(a, h);
            }
            lg();
            W = d;
            jj.current = e;
            $jpvB9.__interactionsRef.current = f;
            if (T === oj) throw b = rj, Pj(a, c), Di(a, c), Jj(a), b;
            if (null === Y) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = T, Ci = null, d){
                case yi:
                case oj:
                    throw Error(u(345));
                case pj:
                    Nj(a, 2 < c ? 2 : c);
                    break;
                case zi:
                    Di(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Vj(e));
                    if (1073741823 === sj && (e = $i + wj - N(), 10 < e)) {
                        if (vj && (f = a.lastPingedTime, 0 === f || f >= c)) {
                            a.lastPingedTime = c;
                            Pj(a, c);
                            break;
                        }
                        f = Kj(a);
                        if (0 !== f && f !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        a.timeoutHandle = Fd(Wj.bind(null, a), e);
                        break;
                    }
                    Wj(a);
                    break;
                case Ai:
                    Di(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Vj(e));
                    if (vj && (e = a.lastPingedTime, 0 === e || e >= c)) {
                        a.lastPingedTime = c;
                        Pj(a, c);
                        break;
                    }
                    e = Kj(a);
                    if (0 !== e && e !== c) break;
                    if (0 !== d && d !== c) {
                        a.lastPingedTime = d;
                        break;
                    }
                    1073741823 !== tj ? d = 10 * (1073741821 - tj) - N() : 1073741823 === sj ? d = 0 : (d = 10 * (1073741821 - sj) - 5E3, e = N(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * ij(d / 1960)) - d, c < d && (d = c));
                    if (10 < d) {
                        a.timeoutHandle = Fd(Wj.bind(null, a), d);
                        break;
                    }
                    Wj(a);
                    break;
                case qj:
                    if (1073741823 !== sj && null !== uj) {
                        f = sj;
                        var g = uj;
                        d = g.busyMinDurationMs | 0;
                        0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = N() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                        if (10 < d) {
                            Di(a, c);
                            a.timeoutHandle = Fd(Wj.bind(null, a), d);
                            break;
                        }
                    }
                    Wj(a);
                    break;
                default:
                    throw Error(u(329));
            }
            Jj(a);
            if (a.callbackNode === b) return Mj.bind(null, a);
        }
    }
    return null;
}
function Ij(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if ((W & (mj | nj)) !== V) throw Error(u(327));
    Oj();
    if (a !== Ci || b !== U) Pj(a, b), Qj(a, b);
    if (null !== Y) {
        var c = W;
        W |= mj;
        var d = Rj(), e = Sj(a);
        for(;;)try {
            Xj();
            break;
        } catch (f) {
            Uj(a, f);
        }
        lg();
        W = c;
        jj.current = d;
        $jpvB9.__interactionsRef.current = e;
        if (T === oj) throw c = rj, Pj(a, b), Di(a, b), Jj(a), c;
        if (null !== Y) throw Error(u(261));
        a.finishedWork = a.current.alternate;
        a.finishedExpirationTime = b;
        Ci = null;
        Wj(a);
        Jj(a);
    }
    return null;
}
function Yj() {
    if (null !== Bj) {
        var a = Bj;
        Bj = null;
        a.forEach(function(a, c) {
            Nj(c, a);
            Jj(c);
        });
        dg();
    }
}
function Zj(a, b) {
    var c = W;
    W |= 1;
    try {
        return a(b);
    } finally{
        W = c, W === V && dg();
    }
}
function ak(a, b) {
    var c = W;
    W &= -2;
    W |= lj;
    try {
        return a(b);
    } finally{
        W = c, W === V && dg();
    }
}
function Pj(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gd(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Bf();
                break;
            case 3:
                ch();
                H(K);
                H(J);
                break;
            case 5:
                eh(d);
                break;
            case 4:
                ch();
                break;
            case 13:
                H(O);
                break;
            case 19:
                H(O);
                break;
            case 10:
                mg(d);
        }
        c = c.return;
    }
    Ci = a;
    Y = Qg(a.current, null);
    U = b;
    T = yi;
    rj = null;
    tj = sj = 1073741823;
    uj = null;
    Bi = 0;
    vj = !1;
    Ej = null;
}
function Uj(a, b) {
    do {
        try {
            lg();
            hh.current = rh;
            if (kh) for(var c = P.memoizedState; null !== c;){
                var d = c.queue;
                null !== d && (d.pending = null);
                c = c.next;
            }
            jh = 0;
            R = Q = P = null;
            kh = !1;
            if (null === Y || null === Y.return) return T = oj, rj = b, Y = null;
            Y.mode & 8 && Rh(Y, !0);
            a: {
                var e = a, f = Y.return, g = Y, h = b;
                b = U;
                g.effectTag |= 2048;
                g.firstEffect = g.lastEffect = null;
                if (null !== h && "object" === typeof h && "function" === typeof h.then) {
                    var k = h;
                    if (0 === (g.mode & 2)) {
                        var l = g.alternate;
                        l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
                    }
                    var m = 0 !== (O.current & 1), q = f;
                    do {
                        var x;
                        if (x = 13 === q.tag) {
                            var y = q.memoizedState;
                            if (null !== y) x = null !== y.dehydrated ? !0 : !1;
                            else {
                                var S = q.memoizedProps;
                                x = void 0 === S.fallback ? !1 : !0 !== S.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
                            }
                        }
                        if (x) {
                            var L = q.updateQueue;
                            if (null === L) {
                                var A = new Set;
                                A.add(k);
                                q.updateQueue = A;
                            } else L.add(k);
                            if (0 === (q.mode & 2)) {
                                q.effectTag |= 64;
                                g.effectTag &= -2981;
                                if (1 === g.tag) {
                                    if (null === g.alternate) g.tag = 17;
                                    else {
                                        var v = ug(1073741823, null);
                                        v.tag = 2;
                                        vg(g, v);
                                    }
                                }
                                g.expirationTime = 1073741823;
                                break a;
                            }
                            h = void 0;
                            g = b;
                            var w = e.pingCache;
                            null === w ? (w = e.pingCache = new cj, h = new Set, w.set(k, h)) : (h = w.get(k), void 0 === h && (h = new Set, w.set(k, h)));
                            if (!h.has(g)) {
                                h.add(g);
                                var X = bk.bind(null, e, k, g);
                                k.then(X, X);
                            }
                            q.effectTag |= 4096;
                            q.expirationTime = b;
                            break a;
                        }
                        q = q.return;
                    }while (null !== q);
                    h = Error((pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + qb(g));
                }
                T !== qj && (T = pj);
                h = Hi(h, g);
                q = f;
                do {
                    switch(q.tag){
                        case 3:
                            k = h;
                            q.effectTag |= 4096;
                            q.expirationTime = b;
                            var z = dj(q, k, b);
                            wg(q, z);
                            break a;
                        case 1:
                            k = h;
                            var B = q.type, p = q.stateNode;
                            if (0 === (q.effectTag & 64) && ("function" === typeof B.getDerivedStateFromError || null !== p && "function" === typeof p.componentDidCatch && (null === hj || !hj.has(p)))) {
                                q.effectTag |= 4096;
                                q.expirationTime = b;
                                var Bb = gj(q, k, b);
                                wg(q, Bb);
                                break a;
                            }
                    }
                    q = q.return;
                }while (null !== q);
            }
            Y = ck(Y);
        } catch (oa) {
            b = oa;
            continue;
        }
        break;
    }while (1);
}
function Rj() {
    var a = jj.current;
    jj.current = rh;
    return null === a ? rh : a;
}
function Sj(a) {
    var b = $jpvB9.__interactionsRef.current;
    $jpvB9.__interactionsRef.current = a.memoizedInteractions;
    return b;
}
function yg(a, b) {
    a < sj && 2 < a && (sj = a);
    null !== b && a < tj && 2 < a && (tj = a, uj = b);
}
function zg(a) {
    a > Bi && (Bi = a);
}
function Xj() {
    for(; null !== Y;)Y = dk(Y);
}
function Tj() {
    for(; null !== Y && !Jf();)Y = dk(Y);
}
function dk(a) {
    var b = a.alternate;
    0 !== (a.mode & 8) ? (Qh = Oh(), 0 > a.actualStartTime && (a.actualStartTime = Oh()), b = ek(b, a, U), Rh(a, !0)) : b = ek(b, a, U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = ck(a));
    kj.current = null;
    return b;
}
function ck(a) {
    Y = a;
    do {
        var b = Y.alternate;
        a = Y.return;
        if (0 === (Y.effectTag & 2048)) {
            if (0 === (Y.mode & 8)) b = xi(b, Y, U);
            else {
                var c = Y;
                Qh = Oh();
                0 > c.actualStartTime && (c.actualStartTime = Oh());
                b = xi(b, Y, U);
                Rh(Y, !1);
            }
            c = Y;
            if (1 === U || 1 !== c.childExpirationTime) {
                var d = 0;
                if (0 !== (c.mode & 8)) {
                    for(var e = c.actualDuration, f = c.selfBaseDuration, g = null === c.alternate || c.child !== c.alternate.child, h = c.child; null !== h;){
                        var k = h.expirationTime, l = h.childExpirationTime;
                        k > d && (d = k);
                        l > d && (d = l);
                        g && (e += h.actualDuration);
                        f += h.treeBaseDuration;
                        h = h.sibling;
                    }
                    c.actualDuration = e;
                    c.treeBaseDuration = f;
                } else for(e = c.child; null !== e;)f = e.expirationTime, g = e.childExpirationTime, f > d && (d = f), g > d && (d = g), e = e.sibling;
                c.childExpirationTime = d;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = Y.firstEffect), null !== Y.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = Y.firstEffect), a.lastEffect = Y.lastEffect), 1 < Y.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = Y : a.firstEffect = Y, a.lastEffect = Y));
        } else {
            b = Gi(Y);
            if (0 !== (Y.mode & 8)) {
                Rh(Y, !1);
                c = Y.actualDuration;
                for(d = Y.child; null !== d;)c += d.actualDuration, d = d.sibling;
                Y.actualDuration = c;
            }
            if (null !== b) return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }
        b = Y.sibling;
        if (null !== b) return b;
        Y = a;
    }while (null !== Y);
    T === yi && (T = qj);
    return null;
}
function Vj(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
}
function Wj(a) {
    var b = Yf();
    $f(99, fk.bind(null, a, b));
    return null;
}
function fk(a, b) {
    do Oj();
    while (null !== yj);
    if ((W & (mj | nj)) !== V) throw Error(u(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error(u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = Vj(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === Ci && (Y = Ci = null, U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        var f = W;
        W |= nj;
        var g = Sj(a);
        kj.current = null;
        Bd = dd;
        var h = vd();
        if (wd(h)) {
            if ("selectionStart" in h) var k = {
                start: h.selectionStart,
                end: h.selectionEnd
            };
            else a: {
                k = (k = h.ownerDocument) && k.defaultView || window;
                var l = k.getSelection && k.getSelection();
                if (l && 0 !== l.rangeCount) {
                    k = l.anchorNode;
                    var m = l.anchorOffset, q = l.focusNode;
                    l = l.focusOffset;
                    try {
                        k.nodeType, q.nodeType;
                    } catch (Cb) {
                        k = null;
                        break a;
                    }
                    var x = 0, y = -1, S = -1, L = 0, A = 0, v = h, w = null;
                    b: for(;;){
                        for(var X;;){
                            v !== k || 0 !== m && 3 !== v.nodeType || (y = x + m);
                            v !== q || 0 !== l && 3 !== v.nodeType || (S = x + l);
                            3 === v.nodeType && (x += v.nodeValue.length);
                            if (null === (X = v.firstChild)) break;
                            w = v;
                            v = X;
                        }
                        for(;;){
                            if (v === h) break b;
                            w === k && ++L === m && (y = x);
                            w === q && ++A === l && (S = x);
                            if (null !== (X = v.nextSibling)) break;
                            v = w;
                            w = v.parentNode;
                        }
                        v = X;
                    }
                    k = -1 === y || -1 === S ? null : {
                        start: y,
                        end: S
                    };
                } else k = null;
            }
            k = k || {
                start: 0,
                end: 0
            };
        } else k = null;
        Cd = {
            activeElementDetached: null,
            focusedElem: h,
            selectionRange: k
        };
        dd = !1;
        Z = e;
        do try {
            gk();
        } catch (Cb) {
            if (null === Z) throw Error(u(330));
            Li(Z, Cb);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ph = Oh();
        Z = e;
        do try {
            for(h = a, k = b; null !== Z;){
                var z = Z.effectTag;
                z & 16 && Qb(Z.stateNode, "");
                if (z & 128) {
                    var B = Z.alternate;
                    if (null !== B) {
                        var p = B.ref;
                        null !== p && ("function" === typeof p ? p(null) : p.current = null);
                    }
                }
                switch(z & 1038){
                    case 2:
                        Wi(Z);
                        Z.effectTag &= -3;
                        break;
                    case 6:
                        Wi(Z);
                        Z.effectTag &= -3;
                        Zi(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.effectTag &= -1025;
                        break;
                    case 1028:
                        Z.effectTag &= -1025;
                        Zi(Z.alternate, Z);
                        break;
                    case 4:
                        Zi(Z.alternate, Z);
                        break;
                    case 8:
                        m = Z, Ti(h, m, k), Ui(m);
                }
                Z = Z.nextEffect;
            }
        } catch (Cb) {
            if (null === Z) throw Error(u(330));
            Li(Z, Cb);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        p = Cd;
        B = vd();
        z = p.focusedElem;
        k = p.selectionRange;
        if (B !== z && z && z.ownerDocument && ud(z.ownerDocument.documentElement, z)) {
            null !== k && wd(z) && (B = k.start, p = k.end, void 0 === p && (p = B), "selectionStart" in z ? (z.selectionStart = B, z.selectionEnd = Math.min(p, z.value.length)) : (p = (B = z.ownerDocument || document) && B.defaultView || window, p.getSelection && (p = p.getSelection(), m = z.textContent.length, h = Math.min(k.start, m), k = void 0 === k.end ? h : Math.min(k.end, m), !p.extend && h > k && (m = k, k = h, h = m), m = td(z, h), q = td(z, k), m && q && (1 !== p.rangeCount || p.anchorNode !== m.node || p.anchorOffset !== m.offset || p.focusNode !== q.node || p.focusOffset !== q.offset) && (B = B.createRange(), B.setStart(m.node, m.offset), p.removeAllRanges(), h > k ? (p.addRange(B), p.extend(q.node, q.offset)) : (B.setEnd(q.node, q.offset), p.addRange(B))))));
            B = [];
            for(p = z; p = p.parentNode;)1 === p.nodeType && B.push({
                element: p,
                left: p.scrollLeft,
                top: p.scrollTop
            });
            "function" === typeof z.focus && z.focus();
            for(z = 0; z < B.length; z++)p = B[z], p.element.scrollLeft = p.left, p.element.scrollTop = p.top;
        }
        dd = !!Bd;
        Cd = Bd = null;
        a.current = c;
        Z = e;
        do try {
            for(z = a; null !== Z;){
                var Bb = Z.effectTag;
                Bb & 36 && Qi(z, Z.alternate, Z);
                if (Bb & 128) {
                    B = void 0;
                    var oa = Z.ref;
                    if (null !== oa) {
                        var Ih = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                B = Ih;
                                break;
                            default:
                                B = Ih;
                        }
                        "function" === typeof oa ? oa(B) : oa.current = B;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (Cb) {
            if (null === Z) throw Error(u(330));
            Li(Z, Cb);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        Tf();
        $jpvB9.__interactionsRef.current = g;
        W = f;
    } else a.current = c, Ph = Oh();
    if (Bb = xj) xj = !1, yj = a, Aj = d, zj = b;
    else for(Z = e; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z = b;
    b = a.firstPendingTime;
    if (0 !== b) {
        if (null !== Ej) for(e = Ej, Ej = null, oa = 0; oa < e.length; oa++)hk(a, e[oa], a.memoizedInteractions);
        Hj(a, b);
    } else hj = null;
    Bb || ik(a, d);
    1073741823 === b ? a === Dj ? Cj++ : (Cj = 0, Dj = a) : Cj = 0;
    "function" === typeof jk && jk(c.stateNode, d);
    Jj(a);
    if (ej) throw ej = !1, a = fj, fj = null, a;
    if ((W & lj) !== V) return null;
    dg();
    return null;
}
function gk() {
    for(; null !== Z;){
        var a = Z.effectTag;
        0 !== (a & 256) && Ni(Z.alternate, Z);
        0 === (a & 512) || xj || (xj = !0, ag(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return $f(a, kk);
    }
}
function kk() {
    if (null === yj) return !1;
    var a = yj, b = Aj;
    yj = null;
    Aj = 0;
    if ((W & (mj | nj)) !== V) throw Error(u(331));
    var c = W;
    W |= nj;
    for(var d = Sj(a), e = a.current.firstEffect; null !== e;){
        try {
            var f = e;
            if (0 !== (f.effectTag & 512)) switch(f.tag){
                case 0:
                case 11:
                case 15:
                case 22:
                    Oi(5, f), Pi(5, f);
            }
        } catch (g) {
            if (null === e) throw Error(u(330));
            Li(e, g);
        }
        f = e.nextEffect;
        e.nextEffect = null;
        e = f;
    }
    $jpvB9.__interactionsRef.current = d;
    ik(a, b);
    W = c;
    dg();
    return !0;
}
function lk(a, b, c) {
    b = Hi(c, b);
    b = dj(a, b, 1073741823);
    vg(a, b);
    a = Gj(a, 1073741823);
    null !== a && (Jj(a), Hj(a, 1073741823));
}
function Li(a, b) {
    if (3 === a.tag) lk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            lk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === hj || !hj.has(d))) {
                a = Hi(b, a);
                a = gj(c, a, 1073741823);
                vg(c, a);
                c = Gj(c, 1073741823);
                null !== c && (Jj(c), Hj(c, 1073741823));
                break;
            }
        }
        c = c.return;
    }
}
function bk(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    Ci === a && U === c ? T === Ai || T === zi && 1073741823 === sj && N() - $i < wj ? Pj(a, U) : vj = !0 : Lj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, Jj(a), Hj(a, c)));
}
function bj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = Eg(), b = Fg(b, a, null));
    a = Gj(a, b);
    null !== a && (Jj(a), Hj(a, b));
}
var ek;
ek = function(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || K.current) pg = !0;
        else {
            if (d < c) {
                pg = !1;
                switch(b.tag){
                    case 3:
                        mi(b);
                        ai();
                        break;
                    case 5:
                        dh(b);
                        if (b.mode & 4 && 1 !== c && e.hidden) return Fi(1), b.expirationTime = b.childExpirationTime = 1, null;
                        break;
                    case 1:
                        M(b.type) && Ef(b);
                        break;
                    case 4:
                        bh(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        d = b.memoizedProps.value;
                        e = b.type._context;
                        I(hg, e._currentValue);
                        e._currentValue = d;
                        break;
                    case 12:
                        b.childExpirationTime >= c && (b.effectTag |= 4);
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            d = b.child.childExpirationTime;
                            if (0 !== d && d >= c) return oi(a, b, c);
                            I(O, O.current & 1);
                            b = ei(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        I(O, O.current & 1);
                        break;
                    case 19:
                        d = b.childExpirationTime >= c;
                        if (0 !== (a.effectTag & 64)) {
                            if (d) return ri(a, b, c);
                            b.effectTag |= 64;
                        }
                        e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null);
                        I(O, O.current);
                        if (!d) return null;
                }
                return ei(a, b, c);
            }
            pg = !1;
        }
    } else pg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = Af(b, J.current);
            og(b, c);
            e = nh(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (M(d)) {
                    var f = !0;
                    Ef(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                sg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Dg(b, d, g, a);
                e.updater = Hg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                Lg(b, d, a, c);
                b = li(null, b, d, !0, f, c);
            } else b.tag = 0, ci(null, b, e, c), b = b.child;
            return b;
        case 16:
            a: {
                e = b.elementType;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                ob(e);
                if (1 !== e._status) throw e._result;
                e = e._result;
                b.type = e;
                f = b.tag = mk(e);
                a = gg(e, a);
                switch(f){
                    case 0:
                        b = ii(null, b, e, a, c);
                        break a;
                    case 1:
                        b = ki(null, b, e, a, c);
                        break a;
                    case 11:
                        b = di(null, b, e, a, c);
                        break a;
                    case 14:
                        b = fi(null, b, e, gg(e.type, a), d, c);
                        break a;
                }
                throw Error(u(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : gg(d, e), ii(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : gg(d, e), ki(a, b, d, e, c);
        case 3:
            mi(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(u(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            tg(a, b);
            xg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) ai(), b = ei(a, b, c);
            else {
                if (e = b.stateNode.hydrate) Th = Hd(b.stateNode.containerInfo.firstChild), Sh = b, e = Uh = !0;
                if (e) for(c = Wg(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                else ci(a, b, d, c), ai();
                b = b.child;
            }
            return b;
        case 5:
            return dh(b), null === a && Yh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ed(d, e) ? g = null : null !== f && Ed(d, f) && (b.effectTag |= 16), ji(a, b), b.mode & 4 && 1 !== c && e.hidden ? (Fi(1), b.expirationTime = b.childExpirationTime = 1, b = null) : (ci(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && Yh(b), null;
        case 13:
            return oi(a, b, c);
        case 4:
            return bh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Vg(b, null, d, c) : ci(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : gg(d, e), di(a, b, d, e, c);
        case 7:
            return ci(a, b, b.pendingProps, c), b.child;
        case 8:
            return ci(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return b.effectTag |= 4, ci(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(hg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = Ye(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !K.current) {
                            b = ei(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = ug(c, null), l.tag = 2, vg(h, l));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    l = h.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    ng(h.return, c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                ci(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, og(b, c), e = qg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, ci(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = gg(e, b.pendingProps), f = gg(e.type, f), fi(a, b, e, f, d, c);
        case 15:
            return hi(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : gg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, M(d) ? (a = !0, Ef(b)) : a = !1, og(b, c), Jg(b, d, e), Lg(b, d, e, c), li(null, b, d, !0, a, c);
        case 19:
            return ri(a, b, c);
    }
    throw Error(u(156, b.tag));
};
function Fi(a) {
    null === Ej ? Ej = [
        a
    ] : Ej.push(a);
}
function hk(a, b, c) {
    if (0 < c.size) {
        var d = a.pendingInteractionMap, e = d.get(b);
        null != e ? c.forEach(function(a) {
            e.has(a) || a.__count++;
            e.add(a);
        }) : (d.set(b, new Set(c)), c.forEach(function(a) {
            a.__count++;
        }));
        d = $jpvB9.__subscriberRef.current;
        if (null !== d) d.onWorkScheduled(c, 1E3 * b + a.interactionThreadID);
    }
}
function Hj(a, b) {
    hk(a, b, $jpvB9.__interactionsRef.current);
}
function Qj(a, b) {
    var c = new Set;
    a.pendingInteractionMap.forEach(function(a, d) {
        d >= b && a.forEach(function(a) {
            return c.add(a);
        });
    });
    a.memoizedInteractions = c;
    if (0 < c.size) {
        var d = $jpvB9.__subscriberRef.current;
        if (null !== d) {
            a = 1E3 * b + a.interactionThreadID;
            try {
                d.onWorkStarted(c, a);
            } catch (e) {
                ag(99, function() {
                    throw e;
                });
            }
        }
    }
}
function ik(a, b) {
    var c = a.firstPendingTime;
    try {
        var d = $jpvB9.__subscriberRef.current;
        if (null !== d && 0 < a.memoizedInteractions.size) d.onWorkStopped(a.memoizedInteractions, 1E3 * b + a.interactionThreadID);
    } catch (f) {
        ag(99, function() {
            throw f;
        });
    } finally{
        var e = a.pendingInteractionMap;
        e.forEach(function(a, b) {
            b > c && (e.delete(b), a.forEach(function(a) {
                a.__count--;
                if (null !== d && 0 === a.__count) try {
                    d.onInteractionScheduledWorkCompleted(a);
                } catch (k) {
                    ag(99, function() {
                        throw k;
                    });
                }
            }));
        });
    }
}
var jk = null, Si = null, nk = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__;
function ok(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        jk = function(a, e) {
            try {
                var d = 64 === (a.current.effectTag & 64), g = 1073741821 - (N() / 10 | 0), h = fg(g, e);
                b.onCommitFiberRoot(c, a, h, d);
            } catch (k) {}
        };
        Si = function(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function pk(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
    this.actualDuration = 0;
    this.actualStartTime = -1;
    this.treeBaseDuration = this.selfBaseDuration = 0;
}
function Wh(a, b, c, d) {
    return new pk(a, b, c, d);
}
function gi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function mk(a) {
    if ("function" === typeof a) return gi(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === gb) return 11;
        if (a === jb) return 14;
    }
    return 2;
}
function Qg(a, b) {
    var c = a.alternate;
    null === c ? (c = Wh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null, c.actualDuration = 0, c.actualStartTime = -1);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    c.selfBaseDuration = a.selfBaseDuration;
    c.treeBaseDuration = a.treeBaseDuration;
    return c;
}
function Sg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) gi(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ab:
            return Ug(c.children, e, f, b);
        case fb:
            g = 8;
            e |= 7;
            break;
        case bb:
            g = 8;
            e |= 1;
            break;
        case cb:
            return a = Wh(12, c, b, e | 8), a.elementType = cb, a.type = cb, a.expirationTime = f, a;
        case hb:
            return a = Wh(13, c, b, e), a.type = hb, a.elementType = hb, a.expirationTime = f, a;
        case ib:
            return a = Wh(19, c, b, e), a.elementType = ib, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case db:
                    g = 10;
                    break a;
                case eb:
                    g = 9;
                    break a;
                case gb:
                    g = 11;
                    break a;
                case jb:
                    g = 14;
                    break a;
                case kb:
                    g = 16;
                    d = null;
                    break a;
                case lb:
                    g = 22;
                    break a;
            }
            throw Error(u(130, null == a ? a : typeof a, ""));
    }
    b = Wh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function Ug(a, b, c, d) {
    a = Wh(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function Rg(a, b, c) {
    a = Wh(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function Tg(a, b, c) {
    b = Wh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function qk(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
    this.interactionThreadID = $jpvB9.unstable_getThreadID();
    this.memoizedInteractions = new Set;
    this.pendingInteractionMap = new Map;
}
function Lj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
}
function Di(a, b) {
    var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function Ei(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function Nj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
}
function rk(a, b, c, d) {
    var e = b.current, f = Eg(), g = Bg.suspense;
    f = Fg(f, e, g);
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if (cc(c) !== c || 1 !== c.tag) throw Error(u(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (M(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(u(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (M(k)) {
                c = Df(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = yf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = ug(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    vg(e, b);
    Gg(e, f);
    return f;
}
function sk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function tk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function uk(a, b) {
    tk(a, b);
    (a = a.alternate) && tk(a, b);
}
function vk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new qk(a, b, c);
    var e = 2 === b ? 7 : 1 === b ? 3 : 0;
    nk && (e |= 8);
    e = Wh(3, null, null, e);
    d.current = e;
    e.stateNode = d;
    sg(e);
    a[Md] = d.current;
    c && 0 !== b && Ic(a, 9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
}
vk.prototype.render = function(a) {
    rk(a, this._internalRoot, null, null);
};
vk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    rk(null, a, null, function() {
        b[Md] = null;
    });
};
function wk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function xk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new vk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function yk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = sk(g);
                h.call(a);
            };
        }
        rk(b, g, a, e);
    } else {
        f = c._reactRootContainer = xk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = sk(g);
                k.call(a);
            };
        }
        ak(function() {
            rk(b, g, a, e);
        });
    }
    return sk(g);
}
function zk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
vc = function(a) {
    if (13 === a.tag) {
        var b = eg(Eg(), 150, 100);
        Gg(a, b);
        uk(a, b);
    }
};
wc = function(a) {
    13 === a.tag && (Gg(a, 3), uk(a, 3));
};
xc = function(a) {
    if (13 === a.tag) {
        var b = Eg();
        b = Fg(b, a, null);
        Gg(a, b);
        uk(a, b);
    }
};
za = function(a, b, c) {
    switch(b){
        case "input":
            zb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Od(d);
                        if (!e) throw Error(u(90));
                        vb(d);
                        zb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            Jb(a, c);
            break;
        case "select":
            b = c.value, null != b && Gb(a, !!c.multiple, b, !1);
    }
};
Fa = Zj;
Ga = function(a, b, c, d, e) {
    var f = W;
    W |= 4;
    try {
        return $f(98, a.bind(null, b, c, d, e));
    } finally{
        W = f, W === V && dg();
    }
};
Ha = function() {
    (W & (1 | mj | nj)) === V && (Yj(), Oj());
};
Ia = function(a, b) {
    var c = W;
    W |= 2;
    try {
        return a(b);
    } finally{
        W = c, W === V && dg();
    }
};
function Ak(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!wk(b)) throw Error(u(200));
    return zk(a, b, null, c);
}
var Bk = {
    Events: [
        Mc,
        Nd,
        Od,
        xa,
        ta,
        Vd,
        function(a) {
            ic(a, Ud);
        },
        Da,
        Ea,
        gd,
        lc,
        Oj,
        {
            current: !1
        }
    ]
};
(function(a) {
    var b = a.findFiberByHostInstance;
    return ok($de9zv({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: Wa.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = gc(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: sc,
    bundleType: 0,
    version: "16.14.0",
    rendererPackageName: "react-dom"
});
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Bk;
exports.createPortal = Ak;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternalFiber;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(u(188));
        throw Error(u(268, Object.keys(a)));
    }
    a = gc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    if ((W & (mj | nj)) !== V) throw Error(u(187));
    var c = W;
    W |= 1;
    try {
        return $f(99, a.bind(null, b));
    } finally{
        W = c, dg();
    }
};
exports.hydrate = function(a, b, c) {
    if (!wk(b)) throw Error(u(200));
    return yk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!wk(b)) throw Error(u(200));
    return yk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!wk(a)) throw Error(u(40));
    return a._reactRootContainer ? (ak(function() {
        yk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[Md] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Zj;
exports.unstable_createPortal = function(a, b) {
    return Ak(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!wk(c)) throw Error(u(200));
    if (null == a || void 0 === a._reactInternalFiber) throw Error(u(38));
    return yk(a, b, c, !1, d);
};
exports.version = "16.14.0";

});
parcelRegister("wmpq0", function(module, exports) {
"use strict";

module.exports = (parcelRequire("6Np2z"));

});
parcelRegister("6Np2z", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $4f2abe30f61c0c61$export$c4744153514ff05d; }, function (v) { return $4f2abe30f61c0c61$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $4f2abe30f61c0c61$export$d66a1c1c77bd778b; }, function (v) { return $4f2abe30f61c0c61$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $4f2abe30f61c0c61$export$3e506c1ccc9cc1a7; }, function (v) { return $4f2abe30f61c0c61$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $4f2abe30f61c0c61$export$e26fe2ed2fa76875; }, function (v) { return $4f2abe30f61c0c61$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $4f2abe30f61c0c61$export$502329bbf4b505b1; }, function (v) { return $4f2abe30f61c0c61$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $4f2abe30f61c0c61$export$6e3807111c4874c4; }, function (v) { return $4f2abe30f61c0c61$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $4f2abe30f61c0c61$export$c27134553091fb3a; }, function (v) { return $4f2abe30f61c0c61$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $4f2abe30f61c0c61$export$33ee1acdc04fd2a2; }, function (v) { return $4f2abe30f61c0c61$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $4f2abe30f61c0c61$export$b00a404bbd5edef2; }, function (v) { return $4f2abe30f61c0c61$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $4f2abe30f61c0c61$export$8352ce38b91d0c62; }, function (v) { return $4f2abe30f61c0c61$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $4f2abe30f61c0c61$export$d3dfb8e4810cb555; }, function (v) { return $4f2abe30f61c0c61$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $4f2abe30f61c0c61$export$839f9183b0465a69; }, function (v) { return $4f2abe30f61c0c61$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $4f2abe30f61c0c61$export$72fdf0e06517287b; }, function (v) { return $4f2abe30f61c0c61$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $4f2abe30f61c0c61$export$4b844e58a3e414b4; }, function (v) { return $4f2abe30f61c0c61$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $4f2abe30f61c0c61$export$816d2913ae6b83b1; }, function (v) { return $4f2abe30f61c0c61$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $4f2abe30f61c0c61$export$61bcfe829111a1d0; }, function (v) { return $4f2abe30f61c0c61$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $4f2abe30f61c0c61$export$7ee8c9beb337bc3f; }, function (v) { return $4f2abe30f61c0c61$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $4f2abe30f61c0c61$export$b5836b71941fa3ed; }, function (v) { return $4f2abe30f61c0c61$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $4f2abe30f61c0c61$export$cf845f2c119da08a; }, function (v) { return $4f2abe30f61c0c61$export$cf845f2c119da08a = v; });
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4f2abe30f61c0c61$export$c4744153514ff05d;
var $4f2abe30f61c0c61$export$d66a1c1c77bd778b;
var $4f2abe30f61c0c61$export$3e506c1ccc9cc1a7;
var $4f2abe30f61c0c61$export$e26fe2ed2fa76875;
var $4f2abe30f61c0c61$export$502329bbf4b505b1;
var $4f2abe30f61c0c61$export$6e3807111c4874c4;
var $4f2abe30f61c0c61$export$c27134553091fb3a;
var $4f2abe30f61c0c61$export$33ee1acdc04fd2a2;
var $4f2abe30f61c0c61$export$b00a404bbd5edef2;
var $4f2abe30f61c0c61$export$8352ce38b91d0c62;
var $4f2abe30f61c0c61$export$d3dfb8e4810cb555;
var $4f2abe30f61c0c61$export$839f9183b0465a69;
var $4f2abe30f61c0c61$export$72fdf0e06517287b;
var $4f2abe30f61c0c61$export$4b844e58a3e414b4;
var $4f2abe30f61c0c61$export$816d2913ae6b83b1;
var $4f2abe30f61c0c61$export$61bcfe829111a1d0;
var $4f2abe30f61c0c61$export$7ee8c9beb337bc3f;
var $4f2abe30f61c0c61$export$b5836b71941fa3ed;
var $4f2abe30f61c0c61$export$cf845f2c119da08a;
"use strict";
var $4f2abe30f61c0c61$var$f, $4f2abe30f61c0c61$var$g, $4f2abe30f61c0c61$var$h, $4f2abe30f61c0c61$var$k, $4f2abe30f61c0c61$var$l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $4f2abe30f61c0c61$var$p = null, $4f2abe30f61c0c61$var$q = null, $4f2abe30f61c0c61$var$t = function() {
        if (null !== $4f2abe30f61c0c61$var$p) try {
            var a = $4f2abe30f61c0c61$export$c4744153514ff05d();
            $4f2abe30f61c0c61$var$p(!0, a);
            $4f2abe30f61c0c61$var$p = null;
        } catch (b) {
            throw setTimeout($4f2abe30f61c0c61$var$t, 0), b;
        }
    }, $4f2abe30f61c0c61$var$u = Date.now();
    $4f2abe30f61c0c61$export$c4744153514ff05d = function() {
        return Date.now() - $4f2abe30f61c0c61$var$u;
    };
    $4f2abe30f61c0c61$var$f = function(a) {
        null !== $4f2abe30f61c0c61$var$p ? setTimeout($4f2abe30f61c0c61$var$f, 0, a) : ($4f2abe30f61c0c61$var$p = a, setTimeout($4f2abe30f61c0c61$var$t, 0));
    };
    $4f2abe30f61c0c61$var$g = function(a, b) {
        $4f2abe30f61c0c61$var$q = setTimeout(a, b);
    };
    $4f2abe30f61c0c61$var$h = function() {
        clearTimeout($4f2abe30f61c0c61$var$q);
    };
    $4f2abe30f61c0c61$var$k = function() {
        return !1;
    };
    $4f2abe30f61c0c61$var$l = $4f2abe30f61c0c61$export$d66a1c1c77bd778b = function() {};
} else {
    var $4f2abe30f61c0c61$var$w = window.performance, $4f2abe30f61c0c61$var$x = window.Date, $4f2abe30f61c0c61$var$y = window.setTimeout, $4f2abe30f61c0c61$var$z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $4f2abe30f61c0c61$var$A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof $4f2abe30f61c0c61$var$A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof $4f2abe30f61c0c61$var$w && "function" === typeof $4f2abe30f61c0c61$var$w.now) $4f2abe30f61c0c61$export$c4744153514ff05d = function() {
        return $4f2abe30f61c0c61$var$w.now();
    };
    else {
        var $4f2abe30f61c0c61$var$B = $4f2abe30f61c0c61$var$x.now();
        $4f2abe30f61c0c61$export$c4744153514ff05d = function() {
            return $4f2abe30f61c0c61$var$x.now() - $4f2abe30f61c0c61$var$B;
        };
    }
    var $4f2abe30f61c0c61$var$C = !1, $4f2abe30f61c0c61$var$D = null, $4f2abe30f61c0c61$var$E = -1, $4f2abe30f61c0c61$var$F = 5, $4f2abe30f61c0c61$var$G = 0;
    $4f2abe30f61c0c61$var$k = function() {
        return $4f2abe30f61c0c61$export$c4744153514ff05d() >= $4f2abe30f61c0c61$var$G;
    };
    $4f2abe30f61c0c61$var$l = function() {};
    $4f2abe30f61c0c61$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : $4f2abe30f61c0c61$var$F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $4f2abe30f61c0c61$var$H = new MessageChannel, $4f2abe30f61c0c61$var$I = $4f2abe30f61c0c61$var$H.port2;
    $4f2abe30f61c0c61$var$H.port1.onmessage = function() {
        if (null !== $4f2abe30f61c0c61$var$D) {
            var a = $4f2abe30f61c0c61$export$c4744153514ff05d();
            $4f2abe30f61c0c61$var$G = a + $4f2abe30f61c0c61$var$F;
            try {
                $4f2abe30f61c0c61$var$D(!0, a) ? $4f2abe30f61c0c61$var$I.postMessage(null) : ($4f2abe30f61c0c61$var$C = !1, $4f2abe30f61c0c61$var$D = null);
            } catch (b) {
                throw $4f2abe30f61c0c61$var$I.postMessage(null), b;
            }
        } else $4f2abe30f61c0c61$var$C = !1;
    };
    $4f2abe30f61c0c61$var$f = function(a) {
        $4f2abe30f61c0c61$var$D = a;
        $4f2abe30f61c0c61$var$C || ($4f2abe30f61c0c61$var$C = !0, $4f2abe30f61c0c61$var$I.postMessage(null));
    };
    $4f2abe30f61c0c61$var$g = function(a, b) {
        $4f2abe30f61c0c61$var$E = $4f2abe30f61c0c61$var$y(function() {
            a($4f2abe30f61c0c61$export$c4744153514ff05d());
        }, b);
    };
    $4f2abe30f61c0c61$var$h = function() {
        $4f2abe30f61c0c61$var$z($4f2abe30f61c0c61$var$E);
        $4f2abe30f61c0c61$var$E = -1;
    };
}
function $4f2abe30f61c0c61$var$J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $4f2abe30f61c0c61$var$K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $4f2abe30f61c0c61$var$L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $4f2abe30f61c0c61$var$M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $4f2abe30f61c0c61$var$K(n, c)) void 0 !== r && 0 > $4f2abe30f61c0c61$var$K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $4f2abe30f61c0c61$var$K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $4f2abe30f61c0c61$var$K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $4f2abe30f61c0c61$var$N = [], $4f2abe30f61c0c61$var$O = [], $4f2abe30f61c0c61$var$P = 1, $4f2abe30f61c0c61$var$Q = null, $4f2abe30f61c0c61$var$R = 3, $4f2abe30f61c0c61$var$S = !1, $4f2abe30f61c0c61$var$T = !1, $4f2abe30f61c0c61$var$U = !1;
function $4f2abe30f61c0c61$var$V(a) {
    for(var b = $4f2abe30f61c0c61$var$L($4f2abe30f61c0c61$var$O); null !== b;){
        if (null === b.callback) $4f2abe30f61c0c61$var$M($4f2abe30f61c0c61$var$O);
        else if (b.startTime <= a) $4f2abe30f61c0c61$var$M($4f2abe30f61c0c61$var$O), b.sortIndex = b.expirationTime, $4f2abe30f61c0c61$var$J($4f2abe30f61c0c61$var$N, b);
        else break;
        b = $4f2abe30f61c0c61$var$L($4f2abe30f61c0c61$var$O);
    }
}
function $4f2abe30f61c0c61$var$W(a) {
    $4f2abe30f61c0c61$var$U = !1;
    $4f2abe30f61c0c61$var$V(a);
    if (!$4f2abe30f61c0c61$var$T) {
        if (null !== $4f2abe30f61c0c61$var$L($4f2abe30f61c0c61$var$N)) $4f2abe30f61c0c61$var$T = !0, $4f2abe30f61c0c61$var$f($4f2abe30f61c0c61$var$X);
        else {
            var b = $4f2abe30f61c0c61$var$L($4f2abe30f61c0c61$var$O);
            null !== b && $4f2abe30f61c0c61$var$g($4f2abe30f61c0c61$var$W, b.startTime - a);
        }
    }
}
function $4f2abe30f61c0c61$var$X(a, b) {
    $4f2abe30f61c0c61$var$T = !1;
    $4f2abe30f61c0c61$var$U && ($4f2abe30f61c0c61$var$U = !1, $4f2abe30f61c0c61$var$h());
    $4f2abe30f61c0c61$var$S = !0;
    var c = $4f2abe30f61c0c61$var$R;
    try {
        $4f2abe30f61c0c61$var$V(b);
        for($4f2abe30f61c0c61$var$Q = $4f2abe30f61c0c61$var$L($4f2abe30f61c0c61$var$N); null !== $4f2abe30f61c0c61$var$Q && (!($4f2abe30f61c0c61$var$Q.expirationTime > b) || a && !$4f2abe30f61c0c61$var$k());){
            var d = $4f2abe30f61c0c61$var$Q.callback;
            if (null !== d) {
                $4f2abe30f61c0c61$var$Q.callback = null;
                $4f2abe30f61c0c61$var$R = $4f2abe30f61c0c61$var$Q.priorityLevel;
                var e = d($4f2abe30f61c0c61$var$Q.expirationTime <= b);
                b = $4f2abe30f61c0c61$export$c4744153514ff05d();
                "function" === typeof e ? $4f2abe30f61c0c61$var$Q.callback = e : $4f2abe30f61c0c61$var$Q === $4f2abe30f61c0c61$var$L($4f2abe30f61c0c61$var$N) && $4f2abe30f61c0c61$var$M($4f2abe30f61c0c61$var$N);
                $4f2abe30f61c0c61$var$V(b);
            } else $4f2abe30f61c0c61$var$M($4f2abe30f61c0c61$var$N);
            $4f2abe30f61c0c61$var$Q = $4f2abe30f61c0c61$var$L($4f2abe30f61c0c61$var$N);
        }
        if (null !== $4f2abe30f61c0c61$var$Q) var m = !0;
        else {
            var n = $4f2abe30f61c0c61$var$L($4f2abe30f61c0c61$var$O);
            null !== n && $4f2abe30f61c0c61$var$g($4f2abe30f61c0c61$var$W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $4f2abe30f61c0c61$var$Q = null, $4f2abe30f61c0c61$var$R = c, $4f2abe30f61c0c61$var$S = !1;
    }
}
function $4f2abe30f61c0c61$var$Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var $4f2abe30f61c0c61$var$Z = $4f2abe30f61c0c61$var$l;
$4f2abe30f61c0c61$export$3e506c1ccc9cc1a7 = 5;
$4f2abe30f61c0c61$export$e26fe2ed2fa76875 = 1;
$4f2abe30f61c0c61$export$502329bbf4b505b1 = 4;
$4f2abe30f61c0c61$export$6e3807111c4874c4 = 3;
$4f2abe30f61c0c61$export$c27134553091fb3a = null;
$4f2abe30f61c0c61$export$33ee1acdc04fd2a2 = 2;
$4f2abe30f61c0c61$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$4f2abe30f61c0c61$export$8352ce38b91d0c62 = function() {
    $4f2abe30f61c0c61$var$T || $4f2abe30f61c0c61$var$S || ($4f2abe30f61c0c61$var$T = !0, $4f2abe30f61c0c61$var$f($4f2abe30f61c0c61$var$X));
};
$4f2abe30f61c0c61$export$d3dfb8e4810cb555 = function() {
    return $4f2abe30f61c0c61$var$R;
};
$4f2abe30f61c0c61$export$839f9183b0465a69 = function() {
    return $4f2abe30f61c0c61$var$L($4f2abe30f61c0c61$var$N);
};
$4f2abe30f61c0c61$export$72fdf0e06517287b = function(a) {
    switch($4f2abe30f61c0c61$var$R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $4f2abe30f61c0c61$var$R;
    }
    var c = $4f2abe30f61c0c61$var$R;
    $4f2abe30f61c0c61$var$R = b;
    try {
        return a();
    } finally{
        $4f2abe30f61c0c61$var$R = c;
    }
};
$4f2abe30f61c0c61$export$4b844e58a3e414b4 = function() {};
$4f2abe30f61c0c61$export$816d2913ae6b83b1 = $4f2abe30f61c0c61$var$Z;
$4f2abe30f61c0c61$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $4f2abe30f61c0c61$var$R;
    $4f2abe30f61c0c61$var$R = a;
    try {
        return b();
    } finally{
        $4f2abe30f61c0c61$var$R = c;
    }
};
$4f2abe30f61c0c61$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $4f2abe30f61c0c61$export$c4744153514ff05d();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : $4f2abe30f61c0c61$var$Y(a);
    } else c = $4f2abe30f61c0c61$var$Y(a), e = d;
    c = e + c;
    a = {
        id: $4f2abe30f61c0c61$var$P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, $4f2abe30f61c0c61$var$J($4f2abe30f61c0c61$var$O, a), null === $4f2abe30f61c0c61$var$L($4f2abe30f61c0c61$var$N) && a === $4f2abe30f61c0c61$var$L($4f2abe30f61c0c61$var$O) && ($4f2abe30f61c0c61$var$U ? $4f2abe30f61c0c61$var$h() : $4f2abe30f61c0c61$var$U = !0, $4f2abe30f61c0c61$var$g($4f2abe30f61c0c61$var$W, e - d))) : (a.sortIndex = c, $4f2abe30f61c0c61$var$J($4f2abe30f61c0c61$var$N, a), $4f2abe30f61c0c61$var$T || $4f2abe30f61c0c61$var$S || ($4f2abe30f61c0c61$var$T = !0, $4f2abe30f61c0c61$var$f($4f2abe30f61c0c61$var$X)));
    return a;
};
$4f2abe30f61c0c61$export$b5836b71941fa3ed = function() {
    var a = $4f2abe30f61c0c61$export$c4744153514ff05d();
    $4f2abe30f61c0c61$var$V(a);
    var b = $4f2abe30f61c0c61$var$L($4f2abe30f61c0c61$var$N);
    return b !== $4f2abe30f61c0c61$var$Q && null !== $4f2abe30f61c0c61$var$Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < $4f2abe30f61c0c61$var$Q.expirationTime || $4f2abe30f61c0c61$var$k();
};
$4f2abe30f61c0c61$export$cf845f2c119da08a = function(a) {
    var b = $4f2abe30f61c0c61$var$R;
    return function() {
        var c = $4f2abe30f61c0c61$var$R;
        $4f2abe30f61c0c61$var$R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $4f2abe30f61c0c61$var$R = c;
        }
    };
};

});


parcelRegister("jpvB9", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ltBOS"));

});
parcelRegister("ltBOS", function(module, exports) {

$parcel$export(module.exports, "__interactionsRef", function () { return $fa29a497f62c7b07$export$236303149b061964; }, function (v) { return $fa29a497f62c7b07$export$236303149b061964 = v; });
$parcel$export(module.exports, "__subscriberRef", function () { return $fa29a497f62c7b07$export$d8c36835f54f0a3b; }, function (v) { return $fa29a497f62c7b07$export$d8c36835f54f0a3b = v; });
$parcel$export(module.exports, "unstable_clear", function () { return $fa29a497f62c7b07$export$4a908c8bc96de6cd; }, function (v) { return $fa29a497f62c7b07$export$4a908c8bc96de6cd = v; });
$parcel$export(module.exports, "unstable_getCurrent", function () { return $fa29a497f62c7b07$export$49d8199c8144c803; }, function (v) { return $fa29a497f62c7b07$export$49d8199c8144c803 = v; });
$parcel$export(module.exports, "unstable_getThreadID", function () { return $fa29a497f62c7b07$export$c7d3dd8712817dbc; }, function (v) { return $fa29a497f62c7b07$export$c7d3dd8712817dbc = v; });
$parcel$export(module.exports, "unstable_subscribe", function () { return $fa29a497f62c7b07$export$932a6d6a24b633a5; }, function (v) { return $fa29a497f62c7b07$export$932a6d6a24b633a5 = v; });
$parcel$export(module.exports, "unstable_trace", function () { return $fa29a497f62c7b07$export$8405cb466bd0a1f1; }, function (v) { return $fa29a497f62c7b07$export$8405cb466bd0a1f1 = v; });
$parcel$export(module.exports, "unstable_unsubscribe", function () { return $fa29a497f62c7b07$export$4fd753a282912317; }, function (v) { return $fa29a497f62c7b07$export$4fd753a282912317 = v; });
$parcel$export(module.exports, "unstable_wrap", function () { return $fa29a497f62c7b07$export$230d7bceee602808; }, function (v) { return $fa29a497f62c7b07$export$230d7bceee602808 = v; });
/** @license React v0.19.1
 * scheduler-tracing.profiling.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fa29a497f62c7b07$export$236303149b061964;
var $fa29a497f62c7b07$export$d8c36835f54f0a3b;
var $fa29a497f62c7b07$export$4a908c8bc96de6cd;
var $fa29a497f62c7b07$export$49d8199c8144c803;
var $fa29a497f62c7b07$export$c7d3dd8712817dbc;
var $fa29a497f62c7b07$export$932a6d6a24b633a5;
var $fa29a497f62c7b07$export$8405cb466bd0a1f1;
var $fa29a497f62c7b07$export$4fd753a282912317;
var $fa29a497f62c7b07$export$230d7bceee602808;
"use strict";
var $fa29a497f62c7b07$var$g = 0, $fa29a497f62c7b07$var$l = 0;
$fa29a497f62c7b07$export$236303149b061964 = null;
$fa29a497f62c7b07$export$d8c36835f54f0a3b = null;
$fa29a497f62c7b07$export$236303149b061964 = {
    current: new Set
};
$fa29a497f62c7b07$export$d8c36835f54f0a3b = {
    current: null
};
var $fa29a497f62c7b07$var$m = null;
$fa29a497f62c7b07$var$m = new Set;
function $fa29a497f62c7b07$var$n(e) {
    var d = !1, a = null;
    $fa29a497f62c7b07$var$m.forEach(function(c) {
        try {
            c.onInteractionTraced(e);
        } catch (b) {
            d || (d = !0, a = b);
        }
    });
    if (d) throw a;
}
function $fa29a497f62c7b07$var$p(e) {
    var d = !1, a = null;
    $fa29a497f62c7b07$var$m.forEach(function(c) {
        try {
            c.onInteractionScheduledWorkCompleted(e);
        } catch (b) {
            d || (d = !0, a = b);
        }
    });
    if (d) throw a;
}
function $fa29a497f62c7b07$var$q(e, d) {
    var a = !1, c = null;
    $fa29a497f62c7b07$var$m.forEach(function(b) {
        try {
            b.onWorkScheduled(e, d);
        } catch (f) {
            a || (a = !0, c = f);
        }
    });
    if (a) throw c;
}
function $fa29a497f62c7b07$var$r(e, d) {
    var a = !1, c = null;
    $fa29a497f62c7b07$var$m.forEach(function(b) {
        try {
            b.onWorkStarted(e, d);
        } catch (f) {
            a || (a = !0, c = f);
        }
    });
    if (a) throw c;
}
function $fa29a497f62c7b07$var$t(e, d) {
    var a = !1, c = null;
    $fa29a497f62c7b07$var$m.forEach(function(b) {
        try {
            b.onWorkStopped(e, d);
        } catch (f) {
            a || (a = !0, c = f);
        }
    });
    if (a) throw c;
}
function $fa29a497f62c7b07$var$u(e, d) {
    var a = !1, c = null;
    $fa29a497f62c7b07$var$m.forEach(function(b) {
        try {
            b.onWorkCanceled(e, d);
        } catch (f) {
            a || (a = !0, c = f);
        }
    });
    if (a) throw c;
}
$fa29a497f62c7b07$export$4a908c8bc96de6cd = function(e) {
    var d = $fa29a497f62c7b07$export$236303149b061964.current;
    $fa29a497f62c7b07$export$236303149b061964.current = new Set;
    try {
        return e();
    } finally{
        $fa29a497f62c7b07$export$236303149b061964.current = d;
    }
};
$fa29a497f62c7b07$export$49d8199c8144c803 = function() {
    return $fa29a497f62c7b07$export$236303149b061964.current;
};
$fa29a497f62c7b07$export$c7d3dd8712817dbc = function() {
    return ++$fa29a497f62c7b07$var$l;
};
$fa29a497f62c7b07$export$932a6d6a24b633a5 = function(e) {
    $fa29a497f62c7b07$var$m.add(e);
    1 === $fa29a497f62c7b07$var$m.size && ($fa29a497f62c7b07$export$d8c36835f54f0a3b.current = {
        onInteractionScheduledWorkCompleted: $fa29a497f62c7b07$var$p,
        onInteractionTraced: $fa29a497f62c7b07$var$n,
        onWorkCanceled: $fa29a497f62c7b07$var$u,
        onWorkScheduled: $fa29a497f62c7b07$var$q,
        onWorkStarted: $fa29a497f62c7b07$var$r,
        onWorkStopped: $fa29a497f62c7b07$var$t
    });
};
$fa29a497f62c7b07$export$8405cb466bd0a1f1 = function(e, d, a) {
    var c = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : 0, b = {
        __count: 1,
        id: $fa29a497f62c7b07$var$g++,
        name: e,
        timestamp: d
    }, f = $fa29a497f62c7b07$export$236303149b061964.current, k = new Set(f);
    k.add(b);
    $fa29a497f62c7b07$export$236303149b061964.current = k;
    var h = $fa29a497f62c7b07$export$d8c36835f54f0a3b.current;
    try {
        if (null !== h) h.onInteractionTraced(b);
    } finally{
        try {
            if (null !== h) h.onWorkStarted(k, c);
        } finally{
            try {
                var v = a();
            } finally{
                $fa29a497f62c7b07$export$236303149b061964.current = f;
                try {
                    if (null !== h) h.onWorkStopped(k, c);
                } finally{
                    if (b.__count--, null !== h && 0 === b.__count) h.onInteractionScheduledWorkCompleted(b);
                }
            }
        }
    }
    return v;
};
$fa29a497f62c7b07$export$4fd753a282912317 = function(e) {
    $fa29a497f62c7b07$var$m.delete(e);
    0 === $fa29a497f62c7b07$var$m.size && ($fa29a497f62c7b07$export$d8c36835f54f0a3b.current = null);
};
$fa29a497f62c7b07$export$230d7bceee602808 = function(e) {
    function d() {
        var d = $fa29a497f62c7b07$export$236303149b061964.current;
        $fa29a497f62c7b07$export$236303149b061964.current = c;
        b = $fa29a497f62c7b07$export$d8c36835f54f0a3b.current;
        try {
            try {
                if (null !== b) b.onWorkStarted(c, a);
            } finally{
                try {
                    var h = e.apply(void 0, arguments);
                } finally{
                    if ($fa29a497f62c7b07$export$236303149b061964.current = d, null !== b) b.onWorkStopped(c, a);
                }
            }
            return h;
        } finally{
            f || (f = !0, c.forEach(function(a) {
                a.__count--;
                if (null !== b && 0 === a.__count) b.onInteractionScheduledWorkCompleted(a);
            }));
        }
    }
    var a = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 0, c = $fa29a497f62c7b07$export$236303149b061964.current, b = $fa29a497f62c7b07$export$d8c36835f54f0a3b.current;
    if (null !== b) b.onWorkScheduled(c, a);
    c.forEach(function(a) {
        a.__count++;
    });
    var f = !1;
    d.cancel = function() {
        b = $fa29a497f62c7b07$export$d8c36835f54f0a3b.current;
        try {
            if (null !== b) b.onWorkCanceled(c, a);
        } finally{
            c.forEach(function(a) {
                a.__count--;
                if (b && 0 === a.__count) b.onInteractionScheduledWorkCompleted(a);
            });
        }
    };
    return d;
};

});




parcelRegister("agjvf", function(module, exports) {

$parcel$export(module.exports, "addLocaleData", function () { return $778a86e0f1892717$export$9b0a0997606861b1; });
$parcel$export(module.exports, "injectIntl", function () { return $778a86e0f1892717$export$3afb67c2a576ab2c; });
$parcel$export(module.exports, "defineMessages", function () { return $778a86e0f1892717$export$1adfeb024f5185b; });
$parcel$export(module.exports, "IntlProvider", function () { return $778a86e0f1892717$export$480518999dfc4151; });
$parcel$export(module.exports, "FormattedRelative", function () { return $778a86e0f1892717$export$a560185ee54e4a40; });
$parcel$export(module.exports, "FormattedMessage", function () { return $778a86e0f1892717$export$561a3c611f78824a; });
$parcel$export(module.exports, "FormattedHTMLMessage", function () { return $778a86e0f1892717$export$1055f6fa4dffb817; });
/*
 * Copyright 2019, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $iZpK3 = parcelRequire("iZpK3");

var $7k4sH = parcelRequire("7k4sH");

var $ftOpI = parcelRequire("ftOpI");

var $blCBi = parcelRequire("blCBi");

var $9nHZC = parcelRequire("9nHZC");

var $1t1PC = parcelRequire("1t1PC");

var $5kF1c = parcelRequire("5kF1c");

var $96wQ2 = parcelRequire("96wQ2");
// GENERATED FILE
var $778a86e0f1892717$var$defaultLocaleData = {
    "locale": "en",
    "pluralRuleFunction": function pluralRuleFunction(n, ord) {
        var s = String(n).split("."), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
        if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";
        return n == 1 && v0 ? "one" : "other";
    },
    "fields": {
        "year": {
            "displayName": "year",
            "relative": {
                "0": "this year",
                "1": "next year",
                "-1": "last year"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} year",
                    "other": "in {0} years"
                },
                "past": {
                    "one": "{0} year ago",
                    "other": "{0} years ago"
                }
            }
        },
        "year-short": {
            "displayName": "yr.",
            "relative": {
                "0": "this yr.",
                "1": "next yr.",
                "-1": "last yr."
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} yr.",
                    "other": "in {0} yr."
                },
                "past": {
                    "one": "{0} yr. ago",
                    "other": "{0} yr. ago"
                }
            }
        },
        "month": {
            "displayName": "month",
            "relative": {
                "0": "this month",
                "1": "next month",
                "-1": "last month"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} month",
                    "other": "in {0} months"
                },
                "past": {
                    "one": "{0} month ago",
                    "other": "{0} months ago"
                }
            }
        },
        "month-short": {
            "displayName": "mo.",
            "relative": {
                "0": "this mo.",
                "1": "next mo.",
                "-1": "last mo."
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} mo.",
                    "other": "in {0} mo."
                },
                "past": {
                    "one": "{0} mo. ago",
                    "other": "{0} mo. ago"
                }
            }
        },
        "day": {
            "displayName": "day",
            "relative": {
                "0": "today",
                "1": "tomorrow",
                "-1": "yesterday"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} day",
                    "other": "in {0} days"
                },
                "past": {
                    "one": "{0} day ago",
                    "other": "{0} days ago"
                }
            }
        },
        "day-short": {
            "displayName": "day",
            "relative": {
                "0": "today",
                "1": "tomorrow",
                "-1": "yesterday"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} day",
                    "other": "in {0} days"
                },
                "past": {
                    "one": "{0} day ago",
                    "other": "{0} days ago"
                }
            }
        },
        "hour": {
            "displayName": "hour",
            "relative": {
                "0": "this hour"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} hour",
                    "other": "in {0} hours"
                },
                "past": {
                    "one": "{0} hour ago",
                    "other": "{0} hours ago"
                }
            }
        },
        "hour-short": {
            "displayName": "hr.",
            "relative": {
                "0": "this hour"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} hr.",
                    "other": "in {0} hr."
                },
                "past": {
                    "one": "{0} hr. ago",
                    "other": "{0} hr. ago"
                }
            }
        },
        "minute": {
            "displayName": "minute",
            "relative": {
                "0": "this minute"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} minute",
                    "other": "in {0} minutes"
                },
                "past": {
                    "one": "{0} minute ago",
                    "other": "{0} minutes ago"
                }
            }
        },
        "minute-short": {
            "displayName": "min.",
            "relative": {
                "0": "this minute"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} min.",
                    "other": "in {0} min."
                },
                "past": {
                    "one": "{0} min. ago",
                    "other": "{0} min. ago"
                }
            }
        },
        "second": {
            "displayName": "second",
            "relative": {
                "0": "now"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} second",
                    "other": "in {0} seconds"
                },
                "past": {
                    "one": "{0} second ago",
                    "other": "{0} seconds ago"
                }
            }
        },
        "second-short": {
            "displayName": "sec.",
            "relative": {
                "0": "now"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} sec.",
                    "other": "in {0} sec."
                },
                "past": {
                    "one": "{0} sec. ago",
                    "other": "{0} sec. ago"
                }
            }
        }
    }
};
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ function $778a86e0f1892717$export$9b0a0997606861b1() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var locales = Array.isArray(data) ? data : [
        data
    ];
    locales.forEach(function(localeData) {
        if (localeData && localeData.locale) {
            (0, (/*@__PURE__*/$parcel$interopDefault($7k4sH))).__addLocaleData(localeData);
            (0, (/*@__PURE__*/$parcel$interopDefault($ftOpI))).__addLocaleData(localeData);
        }
    });
}
function $778a86e0f1892717$var$hasLocaleData(locale) {
    var localeParts = (locale || "").split("-");
    while(localeParts.length > 0){
        if ($778a86e0f1892717$var$hasIMFAndIRFLocaleData(localeParts.join("-"))) return true;
        localeParts.pop();
    }
    return false;
}
function $778a86e0f1892717$var$hasIMFAndIRFLocaleData(locale) {
    var normalizedLocale = locale && locale.toLowerCase();
    return !!((0, (/*@__PURE__*/$parcel$interopDefault($7k4sH))).__localeData__[normalizedLocale] && (0, (/*@__PURE__*/$parcel$interopDefault($ftOpI))).__localeData__[normalizedLocale]);
}
var $778a86e0f1892717$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $778a86e0f1892717$var$asyncGenerator = function() {
    function AwaitValue(value) {
        this.value = value;
    }
    function AsyncGenerator(gen) {
        var front, back;
        function send(key, arg) {
            return new Promise(function(resolve, reject) {
                var request = {
                    key: key,
                    arg: arg,
                    resolve: resolve,
                    reject: reject,
                    next: null
                };
                if (back) back = back.next = request;
                else {
                    front = back = request;
                    resume(key, arg);
                }
            });
        }
        function resume(key, arg) {
            try {
                var result = gen[key](arg);
                var value = result.value;
                if (value instanceof AwaitValue) Promise.resolve(value.value).then(function(arg) {
                    resume("next", arg);
                }, function(arg) {
                    resume("throw", arg);
                });
                else settle(result.done ? "return" : "normal", result.value);
            } catch (err) {
                settle("throw", err);
            }
        }
        function settle(type, value) {
            switch(type){
                case "return":
                    front.resolve({
                        value: value,
                        done: true
                    });
                    break;
                case "throw":
                    front.reject(value);
                    break;
                default:
                    front.resolve({
                        value: value,
                        done: false
                    });
                    break;
            }
            front = front.next;
            if (front) resume(front.key, front.arg);
            else back = null;
        }
        this._invoke = send;
        if (typeof gen.return !== "function") this.return = undefined;
    }
    if (typeof Symbol === "function" && Symbol.asyncIterator) AsyncGenerator.prototype[Symbol.asyncIterator] = function() {
        return this;
    };
    AsyncGenerator.prototype.next = function(arg) {
        return this._invoke("next", arg);
    };
    AsyncGenerator.prototype.throw = function(arg) {
        return this._invoke("throw", arg);
    };
    AsyncGenerator.prototype.return = function(arg) {
        return this._invoke("return", arg);
    };
    return {
        wrap: function(fn) {
            return function() {
                return new AsyncGenerator(fn.apply(this, arguments));
            };
        },
        await: function(value) {
            return new AwaitValue(value);
        }
    };
}();
var $778a86e0f1892717$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $778a86e0f1892717$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $778a86e0f1892717$var$defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $778a86e0f1892717$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $778a86e0f1892717$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $778a86e0f1892717$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $778a86e0f1892717$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $778a86e0f1892717$var$toConsumableArray = function(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
};
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var $778a86e0f1892717$var$bool = (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).bool;
var $778a86e0f1892717$var$number = (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).number;
var $778a86e0f1892717$var$string = (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).string;
var $778a86e0f1892717$var$func = (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func;
var $778a86e0f1892717$var$object = (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).object;
var $778a86e0f1892717$var$oneOf = (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).oneOf;
var $778a86e0f1892717$var$shape = (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).shape;
var $778a86e0f1892717$var$any = (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).any;
var $778a86e0f1892717$var$oneOfType = (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).oneOfType;
var $778a86e0f1892717$var$localeMatcher = $778a86e0f1892717$var$oneOf([
    "best fit",
    "lookup"
]);
var $778a86e0f1892717$var$narrowShortLong = $778a86e0f1892717$var$oneOf([
    "narrow",
    "short",
    "long"
]);
var $778a86e0f1892717$var$numeric2digit = $778a86e0f1892717$var$oneOf([
    "numeric",
    "2-digit"
]);
var $778a86e0f1892717$var$funcReq = $778a86e0f1892717$var$func.isRequired;
var $778a86e0f1892717$var$intlConfigPropTypes = {
    locale: $778a86e0f1892717$var$string,
    timeZone: $778a86e0f1892717$var$string,
    formats: $778a86e0f1892717$var$object,
    messages: $778a86e0f1892717$var$object,
    textComponent: $778a86e0f1892717$var$any,
    defaultLocale: $778a86e0f1892717$var$string,
    defaultFormats: $778a86e0f1892717$var$object,
    onError: $778a86e0f1892717$var$func
};
var $778a86e0f1892717$var$intlFormatPropTypes = {
    formatDate: $778a86e0f1892717$var$funcReq,
    formatTime: $778a86e0f1892717$var$funcReq,
    formatRelative: $778a86e0f1892717$var$funcReq,
    formatNumber: $778a86e0f1892717$var$funcReq,
    formatPlural: $778a86e0f1892717$var$funcReq,
    formatMessage: $778a86e0f1892717$var$funcReq,
    formatHTMLMessage: $778a86e0f1892717$var$funcReq
};
var $778a86e0f1892717$export$db9134ac6ad368cf = $778a86e0f1892717$var$shape($778a86e0f1892717$var$_extends({}, $778a86e0f1892717$var$intlConfigPropTypes, $778a86e0f1892717$var$intlFormatPropTypes, {
    formatters: $778a86e0f1892717$var$object,
    now: $778a86e0f1892717$var$funcReq
}));
var $778a86e0f1892717$var$messageDescriptorPropTypes = {
    id: $778a86e0f1892717$var$string.isRequired,
    description: $778a86e0f1892717$var$oneOfType([
        $778a86e0f1892717$var$string,
        $778a86e0f1892717$var$object
    ]),
    defaultMessage: $778a86e0f1892717$var$string
};
var $778a86e0f1892717$var$dateTimeFormatPropTypes = {
    localeMatcher: $778a86e0f1892717$var$localeMatcher,
    formatMatcher: $778a86e0f1892717$var$oneOf([
        "basic",
        "best fit"
    ]),
    timeZone: $778a86e0f1892717$var$string,
    hour12: $778a86e0f1892717$var$bool,
    weekday: $778a86e0f1892717$var$narrowShortLong,
    era: $778a86e0f1892717$var$narrowShortLong,
    year: $778a86e0f1892717$var$numeric2digit,
    month: $778a86e0f1892717$var$oneOf([
        "numeric",
        "2-digit",
        "narrow",
        "short",
        "long"
    ]),
    day: $778a86e0f1892717$var$numeric2digit,
    hour: $778a86e0f1892717$var$numeric2digit,
    minute: $778a86e0f1892717$var$numeric2digit,
    second: $778a86e0f1892717$var$numeric2digit,
    timeZoneName: $778a86e0f1892717$var$oneOf([
        "short",
        "long"
    ])
};
var $778a86e0f1892717$var$numberFormatPropTypes = {
    localeMatcher: $778a86e0f1892717$var$localeMatcher,
    style: $778a86e0f1892717$var$oneOf([
        "decimal",
        "currency",
        "percent"
    ]),
    currency: $778a86e0f1892717$var$string,
    currencyDisplay: $778a86e0f1892717$var$oneOf([
        "symbol",
        "code",
        "name"
    ]),
    useGrouping: $778a86e0f1892717$var$bool,
    minimumIntegerDigits: $778a86e0f1892717$var$number,
    minimumFractionDigits: $778a86e0f1892717$var$number,
    maximumFractionDigits: $778a86e0f1892717$var$number,
    minimumSignificantDigits: $778a86e0f1892717$var$number,
    maximumSignificantDigits: $778a86e0f1892717$var$number
};
var $778a86e0f1892717$var$relativeFormatPropTypes = {
    style: $778a86e0f1892717$var$oneOf([
        "best fit",
        "numeric"
    ]),
    units: $778a86e0f1892717$var$oneOf([
        "second",
        "minute",
        "hour",
        "day",
        "month",
        "year",
        "second-short",
        "minute-short",
        "hour-short",
        "day-short",
        "month-short",
        "year-short"
    ])
};
var $778a86e0f1892717$var$pluralFormatPropTypes = {
    style: $778a86e0f1892717$var$oneOf([
        "cardinal",
        "ordinal"
    ])
};
/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/ var $778a86e0f1892717$var$intlConfigPropNames = Object.keys($778a86e0f1892717$var$intlConfigPropTypes);
var $778a86e0f1892717$var$ESCAPED_CHARS = {
    "&": "&amp;",
    ">": "&gt;",
    "<": "&lt;",
    '"': "&quot;",
    "'": "&#x27;"
};
var $778a86e0f1892717$var$UNSAFE_CHARS_REGEX = /[&><"']/g;
function $778a86e0f1892717$var$escape(str) {
    return ("" + str).replace($778a86e0f1892717$var$UNSAFE_CHARS_REGEX, function(match) {
        return $778a86e0f1892717$var$ESCAPED_CHARS[match];
    });
}
function $778a86e0f1892717$var$filterProps(props, whitelist) {
    var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return whitelist.reduce(function(filtered, name) {
        if (props.hasOwnProperty(name)) filtered[name] = props[name];
        else if (defaults$$1.hasOwnProperty(name)) filtered[name] = defaults$$1[name];
        return filtered;
    }, {});
}
function $778a86e0f1892717$var$invariantIntlContext() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, intl = _ref.intl;
    (0, (/*@__PURE__*/$parcel$interopDefault($5kF1c)))(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
function $778a86e0f1892717$var$shallowEquals(objA, objB) {
    if (objA === objB) return true;
    if ((typeof objA === "undefined" ? "undefined" : $778a86e0f1892717$var$_typeof(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : $778a86e0f1892717$var$_typeof(objB)) !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    for(var i = 0; i < keysA.length; i++){
        if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
function $778a86e0f1892717$var$shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
    var props = _ref2.props, state = _ref2.state, _ref2$context = _ref2.context, context = _ref2$context === undefined ? {} : _ref2$context;
    var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var _context$intl = context.intl, intl = _context$intl === undefined ? {} : _context$intl;
    var _nextContext$intl = nextContext.intl, nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;
    return !$778a86e0f1892717$var$shallowEquals(nextProps, props) || !$778a86e0f1892717$var$shallowEquals(nextState, state) || !(nextIntl === intl || $778a86e0f1892717$var$shallowEquals($778a86e0f1892717$var$filterProps(nextIntl, $778a86e0f1892717$var$intlConfigPropNames), $778a86e0f1892717$var$filterProps(intl, $778a86e0f1892717$var$intlConfigPropNames)));
}
function $778a86e0f1892717$var$createError(message, exception) {
    var eMsg = exception ? "\n" + exception : "";
    return "[React Intl] " + message + eMsg;
}
function $778a86e0f1892717$var$defaultErrorHandler(error) {}
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ // Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux
function $778a86e0f1892717$var$getDisplayName(Component$$1) {
    return Component$$1.displayName || Component$$1.name || "Component";
}
function $778a86e0f1892717$export$3afb67c2a576ab2c(WrappedComponent) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$intlPropName = options.intlPropName, intlPropName = _options$intlPropName === undefined ? "intl" : _options$intlPropName, _options$withRef = options.withRef, withRef = _options$withRef === undefined ? false : _options$withRef;
    var InjectIntl = function(_Component) {
        $778a86e0f1892717$var$inherits(InjectIntl, _Component);
        function InjectIntl(props, context) {
            $778a86e0f1892717$var$classCallCheck(this, InjectIntl);
            var _this = $778a86e0f1892717$var$possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));
            $778a86e0f1892717$var$invariantIntlContext(context);
            return _this;
        }
        $778a86e0f1892717$var$createClass(InjectIntl, [
            {
                key: "getWrappedInstance",
                value: function getWrappedInstance() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($5kF1c)))(withRef, "[React Intl] To access the wrapped instance, the `{withRef: true}` option must be set when calling: `injectIntl()`");
                    return this._wrappedInstance;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedComponent, $778a86e0f1892717$var$_extends({}, this.props, $778a86e0f1892717$var$defineProperty({}, intlPropName, this.context.intl), {
                        ref: withRef ? /* istanbul ignore next */ function(ref) {
                            return _this2._wrappedInstance = ref;
                        } : null
                    }));
                }
            }
        ]);
        return InjectIntl;
    }((0, $9nHZC.Component));
    InjectIntl.displayName = "InjectIntl(" + $778a86e0f1892717$var$getDisplayName(WrappedComponent) + ")";
    InjectIntl.contextTypes = {
        intl: $778a86e0f1892717$export$db9134ac6ad368cf
    };
    InjectIntl.WrappedComponent = WrappedComponent;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1t1PC)))(InjectIntl, WrappedComponent);
}
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ function $778a86e0f1892717$export$1adfeb024f5185b(messageDescriptors) {
    // This simply returns what's passed-in because it's meant to be a hook for
    // babel-plugin-react-intl.
    return messageDescriptors;
}
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ // This is a "hack" until a proper `intl-pluralformat` package is created.
function $778a86e0f1892717$var$resolveLocale(locales) {
    // IntlMessageFormat#_resolveLocale() does not depend on `this`.
    return (0, (/*@__PURE__*/$parcel$interopDefault($7k4sH))).prototype._resolveLocale(locales);
}
function $778a86e0f1892717$var$findPluralFunction(locale) {
    // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
    return (0, (/*@__PURE__*/$parcel$interopDefault($7k4sH))).prototype._findPluralRuleFunction(locale);
}
var $778a86e0f1892717$var$IntlPluralFormat = function IntlPluralFormat(locales) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    $778a86e0f1892717$var$classCallCheck(this, IntlPluralFormat);
    var useOrdinal = options.style === "ordinal";
    var pluralFn = $778a86e0f1892717$var$findPluralFunction($778a86e0f1892717$var$resolveLocale(locales));
    this.format = function(value) {
        return pluralFn(value, useOrdinal);
    };
};
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var $778a86e0f1892717$var$DATE_TIME_FORMAT_OPTIONS = Object.keys($778a86e0f1892717$var$dateTimeFormatPropTypes);
var $778a86e0f1892717$var$NUMBER_FORMAT_OPTIONS = Object.keys($778a86e0f1892717$var$numberFormatPropTypes);
var $778a86e0f1892717$var$RELATIVE_FORMAT_OPTIONS = Object.keys($778a86e0f1892717$var$relativeFormatPropTypes);
var $778a86e0f1892717$var$PLURAL_FORMAT_OPTIONS = Object.keys($778a86e0f1892717$var$pluralFormatPropTypes);
var $778a86e0f1892717$var$RELATIVE_FORMAT_THRESHOLDS = {
    second: 60,
    minute: 60,
    hour: 24,
    day: 30,
    month: 12
};
function $778a86e0f1892717$var$updateRelativeFormatThresholds(newThresholds) {
    var thresholds = (0, (/*@__PURE__*/$parcel$interopDefault($ftOpI))).thresholds;
    thresholds.second = newThresholds.second;
    thresholds.minute = newThresholds.minute;
    thresholds.hour = newThresholds.hour;
    thresholds.day = newThresholds.day;
    thresholds.month = newThresholds.month;
    thresholds["second-short"] = newThresholds["second-short"];
    thresholds["minute-short"] = newThresholds["minute-short"];
    thresholds["hour-short"] = newThresholds["hour-short"];
    thresholds["day-short"] = newThresholds["day-short"];
    thresholds["month-short"] = newThresholds["month-short"];
}
function $778a86e0f1892717$var$getNamedFormat(formats, type, name, onError) {
    var format = formats && formats[type] && formats[type][name];
    if (format) return format;
    onError($778a86e0f1892717$var$createError("No " + type + " format named: " + name));
}
function $778a86e0f1892717$var$formatDate(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale, formats = config.formats, timeZone = config.timeZone;
    var format = options.format;
    var onError = config.onError || $778a86e0f1892717$var$defaultErrorHandler;
    var date = new Date(value);
    var defaults$$1 = $778a86e0f1892717$var$_extends({}, timeZone && {
        timeZone: timeZone
    }, format && $778a86e0f1892717$var$getNamedFormat(formats, "date", format, onError));
    var filteredOptions = $778a86e0f1892717$var$filterProps(options, $778a86e0f1892717$var$DATE_TIME_FORMAT_OPTIONS, defaults$$1);
    try {
        return state.getDateTimeFormat(locale, filteredOptions).format(date);
    } catch (e) {
        onError($778a86e0f1892717$var$createError("Error formatting date.", e));
    }
    return String(date);
}
function $778a86e0f1892717$var$formatTime(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale, formats = config.formats, timeZone = config.timeZone;
    var format = options.format;
    var onError = config.onError || $778a86e0f1892717$var$defaultErrorHandler;
    var date = new Date(value);
    var defaults$$1 = $778a86e0f1892717$var$_extends({}, timeZone && {
        timeZone: timeZone
    }, format && $778a86e0f1892717$var$getNamedFormat(formats, "time", format, onError));
    var filteredOptions = $778a86e0f1892717$var$filterProps(options, $778a86e0f1892717$var$DATE_TIME_FORMAT_OPTIONS, defaults$$1);
    if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = $778a86e0f1892717$var$_extends({}, filteredOptions, {
        hour: "numeric",
        minute: "numeric"
    });
    try {
        return state.getDateTimeFormat(locale, filteredOptions).format(date);
    } catch (e) {
        onError($778a86e0f1892717$var$createError("Error formatting time.", e));
    }
    return String(date);
}
function $778a86e0f1892717$var$formatRelative(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale, formats = config.formats;
    var format = options.format;
    var onError = config.onError || $778a86e0f1892717$var$defaultErrorHandler;
    var date = new Date(value);
    var now = new Date(options.now);
    var defaults$$1 = format && $778a86e0f1892717$var$getNamedFormat(formats, "relative", format, onError);
    var filteredOptions = $778a86e0f1892717$var$filterProps(options, $778a86e0f1892717$var$RELATIVE_FORMAT_OPTIONS, defaults$$1);
    // Capture the current threshold values, then temporarily override them with
    // specific values just for this render.
    var oldThresholds = $778a86e0f1892717$var$_extends({}, (0, (/*@__PURE__*/$parcel$interopDefault($ftOpI))).thresholds);
    $778a86e0f1892717$var$updateRelativeFormatThresholds($778a86e0f1892717$var$RELATIVE_FORMAT_THRESHOLDS);
    try {
        return state.getRelativeFormat(locale, filteredOptions).format(date, {
            now: isFinite(now) ? now : state.now()
        });
    } catch (e) {
        onError($778a86e0f1892717$var$createError("Error formatting relative time.", e));
    } finally{
        $778a86e0f1892717$var$updateRelativeFormatThresholds(oldThresholds);
    }
    return String(date);
}
function $778a86e0f1892717$var$formatNumber(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale, formats = config.formats;
    var format = options.format;
    var onError = config.onError || $778a86e0f1892717$var$defaultErrorHandler;
    var defaults$$1 = format && $778a86e0f1892717$var$getNamedFormat(formats, "number", format, onError);
    var filteredOptions = $778a86e0f1892717$var$filterProps(options, $778a86e0f1892717$var$NUMBER_FORMAT_OPTIONS, defaults$$1);
    try {
        return state.getNumberFormat(locale, filteredOptions).format(value);
    } catch (e) {
        onError($778a86e0f1892717$var$createError("Error formatting number.", e));
    }
    return String(value);
}
function $778a86e0f1892717$var$formatPlural(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale;
    var filteredOptions = $778a86e0f1892717$var$filterProps(options, $778a86e0f1892717$var$PLURAL_FORMAT_OPTIONS);
    var onError = config.onError || $778a86e0f1892717$var$defaultErrorHandler;
    try {
        return state.getPluralFormat(locale, filteredOptions).format(value);
    } catch (e) {
        onError($778a86e0f1892717$var$createError("Error formatting plural.", e));
    }
    return "other";
}
function $778a86e0f1892717$var$formatMessage(config, state) {
    var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale, formats = config.formats, messages = config.messages, defaultLocale = config.defaultLocale, defaultFormats = config.defaultFormats;
    var id = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, (/*@__PURE__*/$parcel$interopDefault($5kF1c)))(id, "[React Intl] An `id` must be provided to format a message.");
    var message = messages && messages[id];
    var hasValues = Object.keys(values).length > 0;
    // Avoid expensive message formatting for simple messages without values. In
    // development messages will always be formatted in case of missing values.
    if (!hasValues && true) return message || defaultMessage || id;
    var formattedMessage = void 0;
    var onError = config.onError || $778a86e0f1892717$var$defaultErrorHandler;
    if (message) try {
        var formatter = state.getMessageFormat(message, locale, formats);
        formattedMessage = formatter.format(values);
    } catch (e) {
        onError($778a86e0f1892717$var$createError('Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ", using default message as fallback." : ""), e));
    }
    else // This prevents warnings from littering the console in development
    // when no `messages` are passed into the <IntlProvider> for the
    // default locale, and a default message is in the source.
    if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) onError($778a86e0f1892717$var$createError('Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ", using default message as fallback." : "")));
    if (!formattedMessage && defaultMessage) try {
        var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);
        formattedMessage = _formatter.format(values);
    } catch (e) {
        onError($778a86e0f1892717$var$createError('Error formatting the default message for: "' + id + '"', e));
    }
    if (!formattedMessage) onError($778a86e0f1892717$var$createError('Cannot format message: "' + id + '", ' + ("using message " + (message || defaultMessage ? "source" : "id") + " as fallback.")));
    return formattedMessage || message || defaultMessage || id;
}
function $778a86e0f1892717$var$formatHTMLMessage(config, state, messageDescriptor) {
    var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    // Process all the values before they are used when formatting the ICU
    // Message string. Since the formatted message might be injected via
    // `innerHTML`, all String-based values need to be HTML-escaped.
    var escapedValues = Object.keys(rawValues).reduce(function(escaped, name) {
        var value = rawValues[name];
        escaped[name] = typeof value === "string" ? $778a86e0f1892717$var$escape(value) : value;
        return escaped;
    }, {});
    return $778a86e0f1892717$var$formatMessage(config, state, messageDescriptor, escapedValues);
}
var $778a86e0f1892717$var$format = Object.freeze({
    formatDate: $778a86e0f1892717$var$formatDate,
    formatTime: $778a86e0f1892717$var$formatTime,
    formatRelative: $778a86e0f1892717$var$formatRelative,
    formatNumber: $778a86e0f1892717$var$formatNumber,
    formatPlural: $778a86e0f1892717$var$formatPlural,
    formatMessage: $778a86e0f1892717$var$formatMessage,
    formatHTMLMessage: $778a86e0f1892717$var$formatHTMLMessage
});
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var $778a86e0f1892717$var$intlConfigPropNames$1 = Object.keys($778a86e0f1892717$var$intlConfigPropTypes);
var $778a86e0f1892717$var$intlFormatPropNames = Object.keys($778a86e0f1892717$var$intlFormatPropTypes);
// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var $778a86e0f1892717$var$defaultProps = {
    formats: {},
    messages: {},
    timeZone: null,
    textComponent: "span",
    defaultLocale: "en",
    defaultFormats: {},
    onError: $778a86e0f1892717$var$defaultErrorHandler
};
var $778a86e0f1892717$export$480518999dfc4151 = function(_Component) {
    $778a86e0f1892717$var$inherits(IntlProvider, _Component);
    function IntlProvider(props) {
        var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $778a86e0f1892717$var$classCallCheck(this, IntlProvider);
        var _this = $778a86e0f1892717$var$possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));
        (0, (/*@__PURE__*/$parcel$interopDefault($5kF1c)))(typeof Intl !== "undefined", "[React Intl] The `Intl` APIs must be available in the runtime, and do not appear to be built-in. An `Intl` polyfill should be loaded.\nSee: http://formatjs.io/guides/runtime-environments/");
        var intlContext = context.intl;
        // Used to stabilize time when performing an initial rendering so that
        // all relative times use the same reference "now" time.
        var initialNow = void 0;
        if (isFinite(props.initialNow)) initialNow = Number(props.initialNow);
        else // When an `initialNow` isn't provided via `props`, look to see an
        // <IntlProvider> exists in the ancestry and call its `now()`
        // function to propagate its value for "now".
        initialNow = intlContext ? intlContext.now() : Date.now();
        // Creating `Intl*` formatters is expensive. If there's a parent
        // `<IntlProvider>`, then its formatters will be used. Otherwise, this
        // memoize the `Intl*` constructors and cache them for the lifecycle of
        // this IntlProvider instance.
        var _ref = intlContext || {}, _ref$formatters = _ref.formatters, formatters = _ref$formatters === undefined ? {
            getDateTimeFormat: (0, (/*@__PURE__*/$parcel$interopDefault($96wQ2)))(Intl.DateTimeFormat),
            getNumberFormat: (0, (/*@__PURE__*/$parcel$interopDefault($96wQ2)))(Intl.NumberFormat),
            getMessageFormat: (0, (/*@__PURE__*/$parcel$interopDefault($96wQ2)))((0, (/*@__PURE__*/$parcel$interopDefault($7k4sH)))),
            getRelativeFormat: (0, (/*@__PURE__*/$parcel$interopDefault($96wQ2)))((0, (/*@__PURE__*/$parcel$interopDefault($ftOpI)))),
            getPluralFormat: (0, (/*@__PURE__*/$parcel$interopDefault($96wQ2)))($778a86e0f1892717$var$IntlPluralFormat)
        } : _ref$formatters;
        _this.state = $778a86e0f1892717$var$_extends({}, formatters, {
            // Wrapper to provide stable "now" time for initial render.
            now: function now() {
                return _this._didDisplay ? Date.now() : initialNow;
            }
        });
        return _this;
    }
    $778a86e0f1892717$var$createClass(IntlProvider, [
        {
            key: "getConfig",
            value: function getConfig() {
                var intlContext = this.context.intl;
                // Build a whitelisted config object from `props`, defaults, and
                // `context.intl`, if an <IntlProvider> exists in the ancestry.
                var config = $778a86e0f1892717$var$filterProps(this.props, $778a86e0f1892717$var$intlConfigPropNames$1, intlContext);
                // Apply default props. This must be applied last after the props have
                // been resolved and inherited from any <IntlProvider> in the ancestry.
                // This matches how React resolves `defaultProps`.
                for(var propName in $778a86e0f1892717$var$defaultProps)if (config[propName] === undefined) config[propName] = $778a86e0f1892717$var$defaultProps[propName];
                if (!$778a86e0f1892717$var$hasLocaleData(config.locale)) {
                    var _config = config, locale = _config.locale, defaultLocale = _config.defaultLocale, defaultFormats = _config.defaultFormats, onError = _config.onError;
                    onError($778a86e0f1892717$var$createError('Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.')));
                    // Since there's no registered locale data for `locale`, this will
                    // fallback to the `defaultLocale` to make sure things can render.
                    // The `messages` are overridden to the `defaultProps` empty object
                    // to maintain referential equality across re-renders. It's assumed
                    // each <FormattedMessage> contains a `defaultMessage` prop.
                    config = $778a86e0f1892717$var$_extends({}, config, {
                        locale: defaultLocale,
                        formats: defaultFormats,
                        messages: $778a86e0f1892717$var$defaultProps.messages
                    });
                }
                return config;
            }
        },
        {
            key: "getBoundFormatFns",
            value: function getBoundFormatFns(config, state) {
                return $778a86e0f1892717$var$intlFormatPropNames.reduce(function(boundFormatFns, name) {
                    boundFormatFns[name] = $778a86e0f1892717$var$format[name].bind(null, config, state);
                    return boundFormatFns;
                }, {});
            }
        },
        {
            key: "getChildContext",
            value: function getChildContext() {
                var config = this.getConfig();
                // Bind intl factories and current config to the format functions.
                var boundFormatFns = this.getBoundFormatFns(config, this.state);
                var _state = this.state, now = _state.now, formatters = $778a86e0f1892717$var$objectWithoutProperties(_state, [
                    "now"
                ]);
                return {
                    intl: $778a86e0f1892717$var$_extends({}, config, boundFormatFns, {
                        formatters: formatters,
                        now: now
                    })
                };
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate() {
                for(var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++)next[_key] = arguments[_key];
                return $778a86e0f1892717$var$shouldIntlComponentUpdate.apply(undefined, [
                    this
                ].concat(next));
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._didDisplay = true;
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $9nHZC.Children).only(this.props.children);
            }
        }
    ]);
    return IntlProvider;
}((0, $9nHZC.Component));
$778a86e0f1892717$export$480518999dfc4151.displayName = "IntlProvider";
$778a86e0f1892717$export$480518999dfc4151.contextTypes = {
    intl: $778a86e0f1892717$export$db9134ac6ad368cf
};
$778a86e0f1892717$export$480518999dfc4151.childContextTypes = {
    intl: $778a86e0f1892717$export$db9134ac6ad368cf.isRequired
};
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var $778a86e0f1892717$export$40ae3194919d16b = function(_Component) {
    $778a86e0f1892717$var$inherits(FormattedDate, _Component);
    function FormattedDate(props, context) {
        $778a86e0f1892717$var$classCallCheck(this, FormattedDate);
        var _this = $778a86e0f1892717$var$possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));
        $778a86e0f1892717$var$invariantIntlContext(context);
        return _this;
    }
    $778a86e0f1892717$var$createClass(FormattedDate, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate() {
                for(var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++)next[_key] = arguments[_key];
                return $778a86e0f1892717$var$shouldIntlComponentUpdate.apply(undefined, [
                    this
                ].concat(next));
            }
        },
        {
            key: "render",
            value: function render() {
                var _context$intl = this.context.intl, formatDate = _context$intl.formatDate, Text = _context$intl.textComponent;
                var _props = this.props, value = _props.value, children = _props.children;
                var formattedDate = formatDate(value, this.props);
                if (typeof children === "function") return children(formattedDate);
                return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Text, null, formattedDate);
            }
        }
    ]);
    return FormattedDate;
}((0, $9nHZC.Component));
$778a86e0f1892717$export$40ae3194919d16b.displayName = "FormattedDate";
$778a86e0f1892717$export$40ae3194919d16b.contextTypes = {
    intl: $778a86e0f1892717$export$db9134ac6ad368cf
};
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var $778a86e0f1892717$export$5b390a54f8a846f7 = function(_Component) {
    $778a86e0f1892717$var$inherits(FormattedTime, _Component);
    function FormattedTime(props, context) {
        $778a86e0f1892717$var$classCallCheck(this, FormattedTime);
        var _this = $778a86e0f1892717$var$possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));
        $778a86e0f1892717$var$invariantIntlContext(context);
        return _this;
    }
    $778a86e0f1892717$var$createClass(FormattedTime, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate() {
                for(var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++)next[_key] = arguments[_key];
                return $778a86e0f1892717$var$shouldIntlComponentUpdate.apply(undefined, [
                    this
                ].concat(next));
            }
        },
        {
            key: "render",
            value: function render() {
                var _context$intl = this.context.intl, formatTime = _context$intl.formatTime, Text = _context$intl.textComponent;
                var _props = this.props, value = _props.value, children = _props.children;
                var formattedTime = formatTime(value, this.props);
                if (typeof children === "function") return children(formattedTime);
                return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Text, null, formattedTime);
            }
        }
    ]);
    return FormattedTime;
}((0, $9nHZC.Component));
$778a86e0f1892717$export$5b390a54f8a846f7.displayName = "FormattedTime";
$778a86e0f1892717$export$5b390a54f8a846f7.contextTypes = {
    intl: $778a86e0f1892717$export$db9134ac6ad368cf
};
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var $778a86e0f1892717$var$SECOND = 1000;
var $778a86e0f1892717$var$MINUTE = 60000;
var $778a86e0f1892717$var$HOUR = 3600000;
var $778a86e0f1892717$var$DAY = 86400000;
// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var $778a86e0f1892717$var$MAX_TIMER_DELAY = 2147483647;
function $778a86e0f1892717$var$selectUnits(delta) {
    var absDelta = Math.abs(delta);
    if (absDelta < $778a86e0f1892717$var$MINUTE) return "second";
    if (absDelta < $778a86e0f1892717$var$HOUR) return "minute";
    if (absDelta < $778a86e0f1892717$var$DAY) return "hour";
    // The maximum scheduled delay will be measured in days since the maximum
    // timer delay is less than the number of milliseconds in 25 days.
    return "day";
}
function $778a86e0f1892717$var$getUnitDelay(units) {
    switch(units){
        case "second":
            return $778a86e0f1892717$var$SECOND;
        case "minute":
            return $778a86e0f1892717$var$MINUTE;
        case "hour":
            return $778a86e0f1892717$var$HOUR;
        case "day":
            return $778a86e0f1892717$var$DAY;
        default:
            return $778a86e0f1892717$var$MAX_TIMER_DELAY;
    }
}
function $778a86e0f1892717$var$isSameDate(a, b) {
    if (a === b) return true;
    var aTime = new Date(a).getTime();
    var bTime = new Date(b).getTime();
    return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}
var $778a86e0f1892717$export$a560185ee54e4a40 = function(_Component) {
    $778a86e0f1892717$var$inherits(FormattedRelative, _Component);
    function FormattedRelative(props, context) {
        $778a86e0f1892717$var$classCallCheck(this, FormattedRelative);
        var _this = $778a86e0f1892717$var$possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));
        $778a86e0f1892717$var$invariantIntlContext(context);
        var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();
        // `now` is stored as state so that `render()` remains a function of
        // props + state, instead of accessing `Date.now()` inside `render()`.
        _this.state = {
            now: now
        };
        return _this;
    }
    $778a86e0f1892717$var$createClass(FormattedRelative, [
        {
            key: "scheduleNextUpdate",
            value: function scheduleNextUpdate(props, state) {
                var _this2 = this;
                // Cancel and pending update because we're scheduling a new update.
                clearTimeout(this._timer);
                var value = props.value, units = props.units, updateInterval = props.updateInterval;
                var time = new Date(value).getTime();
                // If the `updateInterval` is falsy, including `0` or we don't have a
                // valid date, then auto updates have been turned off, so we bail and
                // skip scheduling an update.
                if (!updateInterval || !isFinite(time)) return;
                var delta = time - state.now;
                var unitDelay = $778a86e0f1892717$var$getUnitDelay(units || $778a86e0f1892717$var$selectUnits(delta));
                var unitRemainder = Math.abs(delta % unitDelay);
                // We want the largest possible timer delay which will still display
                // accurate information while reducing unnecessary re-renders. The delay
                // should be until the next "interesting" moment, like a tick from
                // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
                var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);
                this._timer = setTimeout(function() {
                    _this2.setState({
                        now: _this2.context.intl.now()
                    });
                }, delay);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.scheduleNextUpdate(this.props, this.state);
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(_ref) {
                var nextValue = _ref.value;
                // When the `props.value` date changes, `state.now` needs to be updated,
                // and the next update can be rescheduled.
                if (!$778a86e0f1892717$var$isSameDate(nextValue, this.props.value)) this.setState({
                    now: this.context.intl.now()
                });
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate() {
                for(var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++)next[_key] = arguments[_key];
                return $778a86e0f1892717$var$shouldIntlComponentUpdate.apply(undefined, [
                    this
                ].concat(next));
            }
        },
        {
            key: "componentWillUpdate",
            value: function componentWillUpdate(nextProps, nextState) {
                this.scheduleNextUpdate(nextProps, nextState);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                clearTimeout(this._timer);
            }
        },
        {
            key: "render",
            value: function render() {
                var _context$intl = this.context.intl, formatRelative = _context$intl.formatRelative, Text = _context$intl.textComponent;
                var _props = this.props, value = _props.value, children = _props.children;
                var formattedRelative = formatRelative(value, $778a86e0f1892717$var$_extends({}, this.props, this.state));
                if (typeof children === "function") return children(formattedRelative);
                return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Text, null, formattedRelative);
            }
        }
    ]);
    return FormattedRelative;
}((0, $9nHZC.Component));
$778a86e0f1892717$export$a560185ee54e4a40.displayName = "FormattedRelative";
$778a86e0f1892717$export$a560185ee54e4a40.contextTypes = {
    intl: $778a86e0f1892717$export$db9134ac6ad368cf
};
$778a86e0f1892717$export$a560185ee54e4a40.defaultProps = {
    updateInterval: 10000
};
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var $778a86e0f1892717$export$db80edc1e6b2f63d = function(_Component) {
    $778a86e0f1892717$var$inherits(FormattedNumber, _Component);
    function FormattedNumber(props, context) {
        $778a86e0f1892717$var$classCallCheck(this, FormattedNumber);
        var _this = $778a86e0f1892717$var$possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));
        $778a86e0f1892717$var$invariantIntlContext(context);
        return _this;
    }
    $778a86e0f1892717$var$createClass(FormattedNumber, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate() {
                for(var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++)next[_key] = arguments[_key];
                return $778a86e0f1892717$var$shouldIntlComponentUpdate.apply(undefined, [
                    this
                ].concat(next));
            }
        },
        {
            key: "render",
            value: function render() {
                var _context$intl = this.context.intl, formatNumber = _context$intl.formatNumber, Text = _context$intl.textComponent;
                var _props = this.props, value = _props.value, children = _props.children;
                var formattedNumber = formatNumber(value, this.props);
                if (typeof children === "function") return children(formattedNumber);
                return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Text, null, formattedNumber);
            }
        }
    ]);
    return FormattedNumber;
}((0, $9nHZC.Component));
$778a86e0f1892717$export$db80edc1e6b2f63d.displayName = "FormattedNumber";
$778a86e0f1892717$export$db80edc1e6b2f63d.contextTypes = {
    intl: $778a86e0f1892717$export$db9134ac6ad368cf
};
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var $778a86e0f1892717$export$da755058eada5424 = function(_Component) {
    $778a86e0f1892717$var$inherits(FormattedPlural, _Component);
    function FormattedPlural(props, context) {
        $778a86e0f1892717$var$classCallCheck(this, FormattedPlural);
        var _this = $778a86e0f1892717$var$possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));
        $778a86e0f1892717$var$invariantIntlContext(context);
        return _this;
    }
    $778a86e0f1892717$var$createClass(FormattedPlural, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate() {
                for(var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++)next[_key] = arguments[_key];
                return $778a86e0f1892717$var$shouldIntlComponentUpdate.apply(undefined, [
                    this
                ].concat(next));
            }
        },
        {
            key: "render",
            value: function render() {
                var _context$intl = this.context.intl, formatPlural = _context$intl.formatPlural, Text = _context$intl.textComponent;
                var _props = this.props, value = _props.value, other = _props.other, children = _props.children;
                var pluralCategory = formatPlural(value, this.props);
                var formattedPlural = this.props[pluralCategory] || other;
                if (typeof children === "function") return children(formattedPlural);
                return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Text, null, formattedPlural);
            }
        }
    ]);
    return FormattedPlural;
}((0, $9nHZC.Component));
$778a86e0f1892717$export$da755058eada5424.displayName = "FormattedPlural";
$778a86e0f1892717$export$da755058eada5424.contextTypes = {
    intl: $778a86e0f1892717$export$db9134ac6ad368cf
};
$778a86e0f1892717$export$da755058eada5424.defaultProps = {
    style: "cardinal"
};
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var $778a86e0f1892717$var$defaultFormatMessage = function defaultFormatMessage(descriptor, values) {
    return $778a86e0f1892717$var$formatMessage({}, {
        getMessageFormat: (0, (/*@__PURE__*/$parcel$interopDefault($96wQ2)))((0, (/*@__PURE__*/$parcel$interopDefault($7k4sH))))
    }, descriptor, values);
};
var $778a86e0f1892717$export$561a3c611f78824a = function(_Component) {
    $778a86e0f1892717$var$inherits(FormattedMessage, _Component);
    function FormattedMessage(props, context) {
        $778a86e0f1892717$var$classCallCheck(this, FormattedMessage);
        var _this = $778a86e0f1892717$var$possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));
        if (!props.defaultMessage) $778a86e0f1892717$var$invariantIntlContext(context);
        return _this;
    }
    $778a86e0f1892717$var$createClass(FormattedMessage, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var values = this.props.values;
                var nextValues = nextProps.values;
                if (!$778a86e0f1892717$var$shallowEquals(nextValues, values)) return true;
                // Since `values` has already been checked, we know they're not
                // different, so the current `values` are carried over so the shallow
                // equals comparison on the other props isn't affected by the `values`.
                var nextPropsToCheck = $778a86e0f1892717$var$_extends({}, nextProps, {
                    values: values
                });
                for(var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)next[_key - 1] = arguments[_key];
                return $778a86e0f1892717$var$shouldIntlComponentUpdate.apply(undefined, [
                    this,
                    nextPropsToCheck
                ].concat(next));
            }
        },
        {
            key: "render",
            value: function render() {
                var _ref = this.context.intl || {}, _ref$formatMessage = _ref.formatMessage, formatMessage$$1 = _ref$formatMessage === undefined ? $778a86e0f1892717$var$defaultFormatMessage : _ref$formatMessage, _ref$textComponent = _ref.textComponent, Text = _ref$textComponent === undefined ? "span" : _ref$textComponent;
                var _props = this.props, id = _props.id, description = _props.description, defaultMessage = _props.defaultMessage, values = _props.values, _props$tagName = _props.tagName, Component$$1 = _props$tagName === undefined ? Text : _props$tagName, children = _props.children;
                var tokenDelimiter = void 0;
                var tokenizedValues = void 0;
                var elements = void 0;
                var hasValues = values && Object.keys(values).length > 0;
                if (hasValues) {
                    // Creates a token with a random UID that should not be guessable or
                    // conflict with other parts of the `message` string.
                    var uid = Math.floor(Math.random() * 0x10000000000).toString(16);
                    var generateToken = function() {
                        var counter = 0;
                        return function() {
                            return "ELEMENT-" + uid + "-" + (counter += 1);
                        };
                    }();
                    // Splitting with a delimiter to support IE8. When using a regex
                    // with a capture group IE8 does not include the capture group in
                    // the resulting array.
                    tokenDelimiter = "@__" + uid + "__@";
                    tokenizedValues = {};
                    elements = {};
                    // Iterates over the `props` to keep track of any React Element
                    // values so they can be represented by the `token` as a placeholder
                    // when the `message` is formatted. This allows the formatted
                    // message to then be broken-up into parts with references to the
                    // React Elements inserted back in.
                    Object.keys(values).forEach(function(name) {
                        var value = values[name];
                        if ((0, $9nHZC.isValidElement)(value)) {
                            var token = generateToken();
                            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
                            elements[token] = value;
                        } else tokenizedValues[name] = value;
                    });
                }
                var descriptor = {
                    id: id,
                    description: description,
                    defaultMessage: defaultMessage
                };
                var formattedMessage = formatMessage$$1(descriptor, tokenizedValues || values);
                var nodes = void 0;
                var hasElements = elements && Object.keys(elements).length > 0;
                if (hasElements) // Split the message into parts so the React Element values captured
                // above can be inserted back into the rendered message. This
                // approach allows messages to render with React Elements while
                // keeping React's virtual diffing working properly.
                nodes = formattedMessage.split(tokenDelimiter).filter(function(part) {
                    return !!part;
                }).map(function(part) {
                    return elements[part] || part;
                });
                else nodes = [
                    formattedMessage
                ];
                if (typeof children === "function") return children.apply(undefined, $778a86e0f1892717$var$toConsumableArray(nodes));
                // Needs to use `createElement()` instead of JSX, otherwise React will
                // warn about a missing `key` prop with rich-text message formatting.
                return (0, $9nHZC.createElement).apply(undefined, [
                    Component$$1,
                    null
                ].concat($778a86e0f1892717$var$toConsumableArray(nodes)));
            }
        }
    ]);
    return FormattedMessage;
}((0, $9nHZC.Component));
$778a86e0f1892717$export$561a3c611f78824a.displayName = "FormattedMessage";
$778a86e0f1892717$export$561a3c611f78824a.contextTypes = {
    intl: $778a86e0f1892717$export$db9134ac6ad368cf
};
$778a86e0f1892717$export$561a3c611f78824a.defaultProps = {
    values: {}
};
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var $778a86e0f1892717$export$1055f6fa4dffb817 = function(_Component) {
    $778a86e0f1892717$var$inherits(FormattedHTMLMessage, _Component);
    function FormattedHTMLMessage(props, context) {
        $778a86e0f1892717$var$classCallCheck(this, FormattedHTMLMessage);
        var _this = $778a86e0f1892717$var$possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));
        $778a86e0f1892717$var$invariantIntlContext(context);
        return _this;
    }
    $778a86e0f1892717$var$createClass(FormattedHTMLMessage, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var values = this.props.values;
                var nextValues = nextProps.values;
                if (!$778a86e0f1892717$var$shallowEquals(nextValues, values)) return true;
                // Since `values` has already been checked, we know they're not
                // different, so the current `values` are carried over so the shallow
                // equals comparison on the other props isn't affected by the `values`.
                var nextPropsToCheck = $778a86e0f1892717$var$_extends({}, nextProps, {
                    values: values
                });
                for(var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)next[_key - 1] = arguments[_key];
                return $778a86e0f1892717$var$shouldIntlComponentUpdate.apply(undefined, [
                    this,
                    nextPropsToCheck
                ].concat(next));
            }
        },
        {
            key: "render",
            value: function render() {
                var _context$intl = this.context.intl, formatHTMLMessage = _context$intl.formatHTMLMessage, Text = _context$intl.textComponent;
                var _props = this.props, id = _props.id, description = _props.description, defaultMessage = _props.defaultMessage, rawValues = _props.values, _props$tagName = _props.tagName, Component$$1 = _props$tagName === undefined ? Text : _props$tagName, children = _props.children;
                var descriptor = {
                    id: id,
                    description: description,
                    defaultMessage: defaultMessage
                };
                var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);
                if (typeof children === "function") return children(formattedHTMLMessage);
                // Since the message presumably has HTML in it, we need to set
                // `innerHTML` in order for it to be rendered and not escaped by React.
                // To be safe, all string prop values were escaped when formatting the
                // message. It is assumed that the message is not UGC, and came from the
                // developer making it more like a template.
                //
                // Note: There's a perf impact of using this component since there's no
                // way for React to do its virtual DOM diffing.
                var html = {
                    __html: formattedHTMLMessage
                };
                return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Component$$1, {
                    dangerouslySetInnerHTML: html
                });
            }
        }
    ]);
    return FormattedHTMLMessage;
}((0, $9nHZC.Component));
$778a86e0f1892717$export$1055f6fa4dffb817.displayName = "FormattedHTMLMessage";
$778a86e0f1892717$export$1055f6fa4dffb817.contextTypes = {
    intl: $778a86e0f1892717$export$db9134ac6ad368cf
};
$778a86e0f1892717$export$1055f6fa4dffb817.defaultProps = {
    values: {}
};
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ $778a86e0f1892717$export$9b0a0997606861b1($778a86e0f1892717$var$defaultLocaleData);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ $778a86e0f1892717$export$9b0a0997606861b1((0, (/*@__PURE__*/$parcel$interopDefault($iZpK3))));

});
parcelRegister("iZpK3", function(module, exports) {
"use strict";

});

parcelRegister("7k4sH", function(module, exports) {
/* jshint node:true */ "use strict";

var $iUbYr = parcelRequire("iUbYr");
var IntlMessageFormat = $iUbYr.default;
parcelRequire("iZpK3");
// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports["default"] = exports;

});
parcelRegister("iUbYr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc36beb9d2571dc7$export$2e2bcd8739ae039; }, function (v) { return $dc36beb9d2571dc7$export$2e2bcd8739ae039 = v; });
/* jslint esnext: true */ var $dc36beb9d2571dc7$export$2e2bcd8739ae039;
"use strict";

var $iFz6k = parcelRequire("iFz6k");

var $4Fsm0 = parcelRequire("4Fsm0");
$iFz6k.default.__addLocaleData($4Fsm0.default);
$iFz6k.default.defaultLocale = "en";
$dc36beb9d2571dc7$export$2e2bcd8739ae039 = $iFz6k.default;

});
parcelRegister("iFz6k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d97748aa9051851c$export$2e2bcd8739ae039; }, function (v) { return $d97748aa9051851c$export$2e2bcd8739ae039 = v; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /* jslint esnext: true */ var $d97748aa9051851c$export$2e2bcd8739ae039;
"use strict";

var $igdzl = parcelRequire("igdzl");

var $kY5Ys = parcelRequire("kY5Ys");

var $yXhlH = parcelRequire("yXhlH");

var $ifbLp = parcelRequire("ifbLp");
$d97748aa9051851c$export$2e2bcd8739ae039 = $d97748aa9051851c$var$MessageFormat;
// -- MessageFormat --------------------------------------------------------
function $d97748aa9051851c$var$MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === "string" ? $d97748aa9051851c$var$MessageFormat.__parse(message) : message;
    if (!(ast && ast.type === "messageFormatPattern")) throw new TypeError("A message must be provided as a String or AST.");
    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats($d97748aa9051851c$var$MessageFormat.formats, formats);
    // Defined first because it's used to build the format pattern.
    $kY5Ys.defineProperty(this, "_locale", {
        value: this._resolveLocale(locales)
    });
    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern = this._compilePattern(ast, locales, formats, pluralFn);
    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function(values) {
        try {
            return messageFormat._format(pattern, values);
        } catch (e) {
            if (e.variableId) throw new Error("The intl string context variable '" + e.variableId + "'" + " was not provided to the string '" + message + "'");
            else throw e;
        }
    };
}
// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
$kY5Ys.defineProperty($d97748aa9051851c$var$MessageFormat, "formats", {
    enumerable: true,
    value: {
        number: {
            "currency": {
                style: "currency"
            },
            "percent": {
                style: "percent"
            }
        },
        date: {
            "short": {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            "medium": {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            "long": {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            "full": {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            "short": {
                hour: "numeric",
                minute: "numeric"
            },
            "medium": {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            "long": {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            "full": {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    }
});
// Define internal private properties for dealing with locale data.
$kY5Ys.defineProperty($d97748aa9051851c$var$MessageFormat, "__localeData__", {
    value: $kY5Ys.objCreate(null)
});
$kY5Ys.defineProperty($d97748aa9051851c$var$MessageFormat, "__addLocaleData", {
    value: function(data) {
        if (!(data && data.locale)) throw new Error("Locale data provided to IntlMessageFormat is missing a `locale` property");
        $d97748aa9051851c$var$MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
    }
});
// Defines `__parse()` static method as an exposed private.
$kY5Ys.defineProperty($d97748aa9051851c$var$MessageFormat, "__parse", {
    value: $ifbLp.default.parse
});
// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
$kY5Ys.defineProperty($d97748aa9051851c$var$MessageFormat, "defaultLocale", {
    enumerable: true,
    writable: true,
    value: undefined
});
$d97748aa9051851c$var$MessageFormat.prototype.resolvedOptions = function() {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};
$d97748aa9051851c$var$MessageFormat.prototype._compilePattern = function(ast, locales, formats, pluralFn) {
    var compiler = new $yXhlH.default(locales, formats, pluralFn);
    return compiler.compile(ast);
};
$d97748aa9051851c$var$MessageFormat.prototype._findPluralRuleFunction = function(locale) {
    var localeData = $d97748aa9051851c$var$MessageFormat.__localeData__;
    var data = localeData[locale.toLowerCase()];
    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while(data){
        if (data.pluralRuleFunction) return data.pluralRuleFunction;
        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }
    throw new Error("Locale data added to IntlMessageFormat is missing a `pluralRuleFunction` for :" + locale);
};
$d97748aa9051851c$var$MessageFormat.prototype._format = function(pattern, values) {
    var result = "", i, len, part, id, value, err;
    for(i = 0, len = pattern.length; i < len; i += 1){
        part = pattern[i];
        // Exist early for string parts.
        if (typeof part === "string") {
            result += part;
            continue;
        }
        id = part.id;
        // Enforce that all required values are provided by the caller.
        if (!(values && $igdzl.hop.call(values, id))) {
            err = new Error("A value must be provided for: " + id);
            err.variableId = id;
            throw err;
        }
        value = values[id];
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) result += this._format(part.getOption(value), values);
        else result += part.format(value);
    }
    return result;
};
$d97748aa9051851c$var$MessageFormat.prototype._mergeFormats = function(defaults, formats) {
    var mergedFormats = {}, type, mergedType;
    for(type in defaults){
        if (!$igdzl.hop.call(defaults, type)) continue;
        mergedFormats[type] = mergedType = $kY5Ys.objCreate(defaults[type]);
        if (formats && $igdzl.hop.call(formats, type)) $igdzl.extend(mergedType, formats[type]);
    }
    return mergedFormats;
};
$d97748aa9051851c$var$MessageFormat.prototype._resolveLocale = function(locales) {
    if (typeof locales === "string") locales = [
        locales
    ];
    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat($d97748aa9051851c$var$MessageFormat.defaultLocale);
    var localeData = $d97748aa9051851c$var$MessageFormat.__localeData__;
    var i, len, localeParts, data;
    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for(i = 0, len = locales.length; i < len; i += 1){
        localeParts = locales[i].toLowerCase().split("-");
        while(localeParts.length){
            data = localeData[localeParts.join("-")];
            if (data) // Return the normalized locale string; e.g., we return "en-US",
            // instead of "en-us".
            return data.locale;
            localeParts.pop();
        }
    }
    var defaultLocale = locales.pop();
    throw new Error("No locale data has been added to IntlMessageFormat for: " + locales.join(", ") + ", or the default locale: " + defaultLocale);
};

});
parcelRegister("igdzl", function(module, exports) {

$parcel$export(module.exports, "extend", function () { return $d4b43f2557893252$export$8b58be045bf06082; }, function (v) { return $d4b43f2557893252$export$8b58be045bf06082 = v; });
$parcel$export(module.exports, "hop", function () { return $d4b43f2557893252$export$ddc501d3db01d79c; }, function (v) { return $d4b43f2557893252$export$ddc501d3db01d79c = v; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /* jslint esnext: true */ var $d4b43f2557893252$export$8b58be045bf06082;
var $d4b43f2557893252$export$ddc501d3db01d79c;
"use strict";
$d4b43f2557893252$export$8b58be045bf06082 = $d4b43f2557893252$var$extend;
var $d4b43f2557893252$var$hop = Object.prototype.hasOwnProperty;
function $d4b43f2557893252$var$extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1), i, len, source, key;
    for(i = 0, len = sources.length; i < len; i += 1){
        source = sources[i];
        if (!source) continue;
        for(key in source)if ($d4b43f2557893252$var$hop.call(source, key)) obj[key] = source[key];
    }
    return obj;
}
$d4b43f2557893252$export$ddc501d3db01d79c = $d4b43f2557893252$var$hop;

});

parcelRegister("kY5Ys", function(module, exports) {

$parcel$export(module.exports, "defineProperty", function () { return $f43e0b95c023bc10$export$fdab3c20aae16ddf; }, function (v) { return $f43e0b95c023bc10$export$fdab3c20aae16ddf = v; });
$parcel$export(module.exports, "objCreate", function () { return $f43e0b95c023bc10$export$c09f2411a4ae511b; }, function (v) { return $f43e0b95c023bc10$export$c09f2411a4ae511b = v; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /* jslint esnext: true */ var $f43e0b95c023bc10$export$fdab3c20aae16ddf;
var $f43e0b95c023bc10$export$c09f2411a4ae511b;
"use strict";

var $igdzl = parcelRequire("igdzl");
// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License
var $f43e0b95c023bc10$var$realDefineProp = function() {
    try {
        return !!Object.defineProperty({}, "a", {});
    } catch (e) {
        return false;
    }
}();
var $f43e0b95c023bc10$var$es3 = !$f43e0b95c023bc10$var$realDefineProp && !Object.prototype.__defineGetter__;
var $f43e0b95c023bc10$var$defineProperty = $f43e0b95c023bc10$var$realDefineProp ? Object.defineProperty : function(obj, name, desc) {
    if ("get" in desc && obj.__defineGetter__) obj.__defineGetter__(name, desc.get);
    else if (!$igdzl.hop.call(obj, name) || "value" in desc) obj[name] = desc.value;
};
var $f43e0b95c023bc10$var$objCreate = Object.create || function(proto, props) {
    var obj, k;
    function F() {}
    F.prototype = proto;
    obj = new F();
    for(k in props)if ($igdzl.hop.call(props, k)) $f43e0b95c023bc10$var$defineProperty(obj, k, props[k]);
    return obj;
};
$f43e0b95c023bc10$export$fdab3c20aae16ddf = $f43e0b95c023bc10$var$defineProperty, $f43e0b95c023bc10$export$c09f2411a4ae511b = $f43e0b95c023bc10$var$objCreate;

});

parcelRegister("yXhlH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $069128a12dd1bc48$export$2e2bcd8739ae039; }, function (v) { return $069128a12dd1bc48$export$2e2bcd8739ae039 = v; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /* jslint esnext: true */ var $069128a12dd1bc48$export$2e2bcd8739ae039;
"use strict";
$069128a12dd1bc48$export$2e2bcd8739ae039 = $069128a12dd1bc48$var$Compiler;
function $069128a12dd1bc48$var$Compiler(locales, formats, pluralFn) {
    this.locales = locales;
    this.formats = formats;
    this.pluralFn = pluralFn;
}
$069128a12dd1bc48$var$Compiler.prototype.compile = function(ast) {
    this.pluralStack = [];
    this.currentPlural = null;
    this.pluralNumberFormat = null;
    return this.compileMessage(ast);
};
$069128a12dd1bc48$var$Compiler.prototype.compileMessage = function(ast) {
    if (!(ast && ast.type === "messageFormatPattern")) throw new Error('Message AST is not of type: "messageFormatPattern"');
    var elements = ast.elements, pattern = [];
    var i, len, element;
    for(i = 0, len = elements.length; i < len; i += 1){
        element = elements[i];
        switch(element.type){
            case "messageTextElement":
                pattern.push(this.compileMessageText(element));
                break;
            case "argumentElement":
                pattern.push(this.compileArgument(element));
                break;
            default:
                throw new Error("Message element does not have a valid type");
        }
    }
    return pattern;
};
$069128a12dd1bc48$var$Compiler.prototype.compileMessageText = function(element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        return new $069128a12dd1bc48$var$PluralOffsetString(this.currentPlural.id, this.currentPlural.format.offset, this.pluralNumberFormat, element.value);
    }
    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, "#");
};
$069128a12dd1bc48$var$Compiler.prototype.compileArgument = function(element) {
    var format = element.format;
    if (!format) return new $069128a12dd1bc48$var$StringFormat(element.id);
    var formats = this.formats, locales = this.locales, pluralFn = this.pluralFn, options;
    switch(format.type){
        case "numberFormat":
            options = formats.number[format.style];
            return {
                id: element.id,
                format: new Intl.NumberFormat(locales, options).format
            };
        case "dateFormat":
            options = formats.date[format.style];
            return {
                id: element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };
        case "timeFormat":
            options = formats.time[format.style];
            return {
                id: element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };
        case "pluralFormat":
            options = this.compileOptions(element);
            return new $069128a12dd1bc48$var$PluralFormat(element.id, format.ordinal, format.offset, options, pluralFn);
        case "selectFormat":
            options = this.compileOptions(element);
            return new $069128a12dd1bc48$var$SelectFormat(element.id, options);
        default:
            throw new Error("Message element does not have a valid format type");
    }
};
$069128a12dd1bc48$var$Compiler.prototype.compileOptions = function(element) {
    var format = element.format, options = format.options, optionsHash = {};
    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === "pluralFormat" ? element : null;
    var i, len, option;
    for(i = 0, len = options.length; i < len; i += 1){
        option = options[i];
        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }
    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();
    return optionsHash;
};
// -- Compiler Helper Classes --------------------------------------------------
function $069128a12dd1bc48$var$StringFormat(id) {
    this.id = id;
}
$069128a12dd1bc48$var$StringFormat.prototype.format = function(value) {
    if (!value && typeof value !== "number") return "";
    return typeof value === "string" ? value : String(value);
};
function $069128a12dd1bc48$var$PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id = id;
    this.useOrdinal = useOrdinal;
    this.offset = offset;
    this.options = options;
    this.pluralFn = pluralFn;
}
$069128a12dd1bc48$var$PluralFormat.prototype.getOption = function(value) {
    var options = this.options;
    var option = options["=" + value] || options[this.pluralFn(value - this.offset, this.useOrdinal)];
    return option || options.other;
};
function $069128a12dd1bc48$var$PluralOffsetString(id, offset, numberFormat, string) {
    this.id = id;
    this.offset = offset;
    this.numberFormat = numberFormat;
    this.string = string;
}
$069128a12dd1bc48$var$PluralOffsetString.prototype.format = function(value) {
    var number = this.numberFormat.format(value - this.offset);
    return this.string.replace(/(^|[^\\])#/g, "$1" + number).replace(/\\#/g, "#");
};
function $069128a12dd1bc48$var$SelectFormat(id, options) {
    this.id = id;
    this.options = options;
}
$069128a12dd1bc48$var$SelectFormat.prototype.getOption = function(value) {
    var options = this.options;
    return options[value] || options.other;
};

});

parcelRegister("ifbLp", function(module, exports) {
"use strict";

exports = module.exports = (parcelRequire("6vjuz")).default;
exports["default"] = exports;

});
parcelRegister("6vjuz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bc4c2120aefbf28$export$2e2bcd8739ae039; }, function (v) { return $4bc4c2120aefbf28$export$2e2bcd8739ae039 = v; });
var $4bc4c2120aefbf28$export$2e2bcd8739ae039;
"use strict";
$4bc4c2120aefbf28$export$2e2bcd8739ae039 = function() {
    "use strict";
    /*
   * Generated by PEG.js 0.9.0.
   *
   * http://pegjs.org/
   */ function peg$subclass(child, parent) {
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
    }
    function peg$SyntaxError(message, expected, found, location) {
        this.message = message;
        this.expected = expected;
        this.found = found;
        this.location = location;
        this.name = "SyntaxError";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, peg$SyntaxError);
    }
    peg$subclass(peg$SyntaxError, Error);
    function peg$parse(input) {
        var options = arguments.length > 1 ? arguments[1] : {}, parser = this, peg$FAILED = {}, peg$startRuleFunctions = {
            start: peg$parsestart
        }, peg$startRuleFunction = peg$parsestart, peg$c0 = function(elements) {
            return {
                type: "messageFormatPattern",
                elements: elements,
                location: location()
            };
        }, peg$c1 = function(text) {
            var string = "", i, j, outerLen, inner, innerLen;
            for(i = 0, outerLen = text.length; i < outerLen; i += 1){
                inner = text[i];
                for(j = 0, innerLen = inner.length; j < innerLen; j += 1)string += inner[j];
            }
            return string;
        }, peg$c2 = function(messageText) {
            return {
                type: "messageTextElement",
                value: messageText,
                location: location()
            };
        }, peg$c3 = /^[^ \t\n\r,.+={}#]/, peg$c4 = {
            type: "class",
            value: "[^ \\t\\n\\r,.+={}#]",
            description: "[^ \\t\\n\\r,.+={}#]"
        }, peg$c5 = "{", peg$c6 = {
            type: "literal",
            value: "{",
            description: '"{"'
        }, peg$c7 = ",", peg$c8 = {
            type: "literal",
            value: ",",
            description: '","'
        }, peg$c9 = "}", peg$c10 = {
            type: "literal",
            value: "}",
            description: '"}"'
        }, peg$c11 = function(id, format) {
            return {
                type: "argumentElement",
                id: id,
                format: format && format[2],
                location: location()
            };
        }, peg$c12 = "number", peg$c13 = {
            type: "literal",
            value: "number",
            description: '"number"'
        }, peg$c14 = "date", peg$c15 = {
            type: "literal",
            value: "date",
            description: '"date"'
        }, peg$c16 = "time", peg$c17 = {
            type: "literal",
            value: "time",
            description: '"time"'
        }, peg$c18 = function(type, style) {
            return {
                type: type + "Format",
                style: style && style[2],
                location: location()
            };
        }, peg$c19 = "plural", peg$c20 = {
            type: "literal",
            value: "plural",
            description: '"plural"'
        }, peg$c21 = function(pluralStyle) {
            return {
                type: pluralStyle.type,
                ordinal: false,
                offset: pluralStyle.offset || 0,
                options: pluralStyle.options,
                location: location()
            };
        }, peg$c22 = "selectordinal", peg$c23 = {
            type: "literal",
            value: "selectordinal",
            description: '"selectordinal"'
        }, peg$c24 = function(pluralStyle) {
            return {
                type: pluralStyle.type,
                ordinal: true,
                offset: pluralStyle.offset || 0,
                options: pluralStyle.options,
                location: location()
            };
        }, peg$c25 = "select", peg$c26 = {
            type: "literal",
            value: "select",
            description: '"select"'
        }, peg$c27 = function(options) {
            return {
                type: "selectFormat",
                options: options,
                location: location()
            };
        }, peg$c28 = "=", peg$c29 = {
            type: "literal",
            value: "=",
            description: '"="'
        }, peg$c30 = function(selector, pattern) {
            return {
                type: "optionalFormatPattern",
                selector: selector,
                value: pattern,
                location: location()
            };
        }, peg$c31 = "offset:", peg$c32 = {
            type: "literal",
            value: "offset:",
            description: '"offset:"'
        }, peg$c33 = function(number) {
            return number;
        }, peg$c34 = function(offset, options) {
            return {
                type: "pluralFormat",
                offset: offset,
                options: options,
                location: location()
            };
        }, peg$c35 = {
            type: "other",
            description: "whitespace"
        }, peg$c36 = /^[ \t\n\r]/, peg$c37 = {
            type: "class",
            value: "[ \\t\\n\\r]",
            description: "[ \\t\\n\\r]"
        }, peg$c38 = {
            type: "other",
            description: "optionalWhitespace"
        }, peg$c39 = /^[0-9]/, peg$c40 = {
            type: "class",
            value: "[0-9]",
            description: "[0-9]"
        }, peg$c41 = /^[0-9a-f]/i, peg$c42 = {
            type: "class",
            value: "[0-9a-f]i",
            description: "[0-9a-f]i"
        }, peg$c43 = "0", peg$c44 = {
            type: "literal",
            value: "0",
            description: '"0"'
        }, peg$c45 = /^[1-9]/, peg$c46 = {
            type: "class",
            value: "[1-9]",
            description: "[1-9]"
        }, peg$c47 = function(digits) {
            return parseInt(digits, 10);
        }, peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/, peg$c49 = {
            type: "class",
            value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]",
            description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]"
        }, peg$c50 = "\\\\", peg$c51 = {
            type: "literal",
            value: "\\\\",
            description: '"\\\\\\\\"'
        }, peg$c52 = function() {
            return "\\";
        }, peg$c53 = "\\#", peg$c54 = {
            type: "literal",
            value: "\\#",
            description: '"\\\\#"'
        }, peg$c55 = function() {
            return "\\#";
        }, peg$c56 = "\\{", peg$c57 = {
            type: "literal",
            value: "\\{",
            description: '"\\\\{"'
        }, peg$c58 = function() {
            return "{";
        }, peg$c59 = "\\}", peg$c60 = {
            type: "literal",
            value: "\\}",
            description: '"\\\\}"'
        }, peg$c61 = function() {
            return "}";
        }, peg$c62 = "\\u", peg$c63 = {
            type: "literal",
            value: "\\u",
            description: '"\\\\u"'
        }, peg$c64 = function(digits) {
            return String.fromCharCode(parseInt(digits, 16));
        }, peg$c65 = function(chars) {
            return chars.join("");
        }, peg$currPos = 0, peg$savedPos = 0, peg$posDetailsCache = [
            {
                line: 1,
                column: 1,
                seenCR: false
            }
        ], peg$maxFailPos = 0, peg$maxFailExpected = [], peg$silentFails = 0, peg$result;
        if ("startRule" in options) {
            if (!(options.startRule in peg$startRuleFunctions)) throw new Error("Can't start parsing from rule \"" + options.startRule + '".');
            peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
        }
        function text() {
            return input.substring(peg$savedPos, peg$currPos);
        }
        function location() {
            return peg$computeLocation(peg$savedPos, peg$currPos);
        }
        function expected(description) {
            throw peg$buildException(null, [
                {
                    type: "other",
                    description: description
                }
            ], input.substring(peg$savedPos, peg$currPos), peg$computeLocation(peg$savedPos, peg$currPos));
        }
        function error(message) {
            throw peg$buildException(message, null, input.substring(peg$savedPos, peg$currPos), peg$computeLocation(peg$savedPos, peg$currPos));
        }
        function peg$computePosDetails(pos) {
            var details = peg$posDetailsCache[pos], p, ch;
            if (details) return details;
            else {
                p = pos - 1;
                while(!peg$posDetailsCache[p])p--;
                details = peg$posDetailsCache[p];
                details = {
                    line: details.line,
                    column: details.column,
                    seenCR: details.seenCR
                };
                while(p < pos){
                    ch = input.charAt(p);
                    if (ch === "\n") {
                        if (!details.seenCR) details.line++;
                        details.column = 1;
                        details.seenCR = false;
                    } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
                        details.line++;
                        details.column = 1;
                        details.seenCR = true;
                    } else {
                        details.column++;
                        details.seenCR = false;
                    }
                    p++;
                }
                peg$posDetailsCache[pos] = details;
                return details;
            }
        }
        function peg$computeLocation(startPos, endPos) {
            var startPosDetails = peg$computePosDetails(startPos), endPosDetails = peg$computePosDetails(endPos);
            return {
                start: {
                    offset: startPos,
                    line: startPosDetails.line,
                    column: startPosDetails.column
                },
                end: {
                    offset: endPos,
                    line: endPosDetails.line,
                    column: endPosDetails.column
                }
            };
        }
        function peg$fail(expected) {
            if (peg$currPos < peg$maxFailPos) return;
            if (peg$currPos > peg$maxFailPos) {
                peg$maxFailPos = peg$currPos;
                peg$maxFailExpected = [];
            }
            peg$maxFailExpected.push(expected);
        }
        function peg$buildException(message, expected, found, location) {
            function cleanupExpected(expected) {
                var i = 1;
                expected.sort(function(a, b) {
                    if (a.description < b.description) return -1;
                    else if (a.description > b.description) return 1;
                    else return 0;
                });
                while(i < expected.length)if (expected[i - 1] === expected[i]) expected.splice(i, 1);
                else i++;
            }
            function buildMessage(expected, found) {
                function stringEscape(s) {
                    function hex(ch) {
                        return ch.charCodeAt(0).toString(16).toUpperCase();
                    }
                    return s.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\x08/g, "\\b").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\f/g, "\\f").replace(/\r/g, "\\r").replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) {
                        return "\\x0" + hex(ch);
                    }).replace(/[\x10-\x1F\x80-\xFF]/g, function(ch) {
                        return "\\x" + hex(ch);
                    }).replace(/[\u0100-\u0FFF]/g, function(ch) {
                        return "\\u0" + hex(ch);
                    }).replace(/[\u1000-\uFFFF]/g, function(ch) {
                        return "\\u" + hex(ch);
                    });
                }
                var expectedDescs = new Array(expected.length), expectedDesc, foundDesc, i;
                for(i = 0; i < expected.length; i++)expectedDescs[i] = expected[i].description;
                expectedDesc = expected.length > 1 ? expectedDescs.slice(0, -1).join(", ") + " or " + expectedDescs[expected.length - 1] : expectedDescs[0];
                foundDesc = found ? '"' + stringEscape(found) + '"' : "end of input";
                return "Expected " + expectedDesc + " but " + foundDesc + " found.";
            }
            if (expected !== null) cleanupExpected(expected);
            return new peg$SyntaxError(message !== null ? message : buildMessage(expected, found), expected, found, location);
        }
        function peg$parsestart() {
            var s0;
            s0 = peg$parsemessageFormatPattern();
            return s0;
        }
        function peg$parsemessageFormatPattern() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parsemessageFormatElement();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parsemessageFormatElement();
            }
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c0(s1);
            }
            s0 = s1;
            return s0;
        }
        function peg$parsemessageFormatElement() {
            var s0;
            s0 = peg$parsemessageTextElement();
            if (s0 === peg$FAILED) s0 = peg$parseargumentElement();
            return s0;
        }
        function peg$parsemessageText() {
            var s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$currPos;
            s3 = peg$parse_();
            if (s3 !== peg$FAILED) {
                s4 = peg$parsechars();
                if (s4 !== peg$FAILED) {
                    s5 = peg$parse_();
                    if (s5 !== peg$FAILED) {
                        s3 = [
                            s3,
                            s4,
                            s5
                        ];
                        s2 = s3;
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
            } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$currPos;
                s3 = peg$parse_();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parsechars();
                    if (s4 !== peg$FAILED) {
                        s5 = peg$parse_();
                        if (s5 !== peg$FAILED) {
                            s3 = [
                                s3,
                                s4,
                                s5
                            ];
                            s2 = s3;
                        } else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
            }
            else s1 = peg$FAILED;
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c1(s1);
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parsews();
                if (s1 !== peg$FAILED) s0 = input.substring(s0, peg$currPos);
                else s0 = s1;
            }
            return s0;
        }
        function peg$parsemessageTextElement() {
            var s0, s1;
            s0 = peg$currPos;
            s1 = peg$parsemessageText();
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c2(s1);
            }
            s0 = s1;
            return s0;
        }
        function peg$parseargument() {
            var s0, s1, s2;
            s0 = peg$parsenumber();
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = [];
                if (peg$c3.test(input.charAt(peg$currPos))) {
                    s2 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c4);
                }
                if (s2 !== peg$FAILED) while(s2 !== peg$FAILED){
                    s1.push(s2);
                    if (peg$c3.test(input.charAt(peg$currPos))) {
                        s2 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s2 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c4);
                    }
                }
                else s1 = peg$FAILED;
                if (s1 !== peg$FAILED) s0 = input.substring(s0, peg$currPos);
                else s0 = s1;
            }
            return s0;
        }
        function peg$parseargumentElement() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 123) {
                s1 = peg$c5;
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c6);
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                if (s2 !== peg$FAILED) {
                    s3 = peg$parseargument();
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            s5 = peg$currPos;
                            if (input.charCodeAt(peg$currPos) === 44) {
                                s6 = peg$c7;
                                peg$currPos++;
                            } else {
                                s6 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c8);
                            }
                            if (s6 !== peg$FAILED) {
                                s7 = peg$parse_();
                                if (s7 !== peg$FAILED) {
                                    s8 = peg$parseelementFormat();
                                    if (s8 !== peg$FAILED) {
                                        s6 = [
                                            s6,
                                            s7,
                                            s8
                                        ];
                                        s5 = s6;
                                    } else {
                                        peg$currPos = s5;
                                        s5 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s5;
                                    s5 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s5;
                                s5 = peg$FAILED;
                            }
                            if (s5 === peg$FAILED) s5 = null;
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parse_();
                                if (s6 !== peg$FAILED) {
                                    if (input.charCodeAt(peg$currPos) === 125) {
                                        s7 = peg$c9;
                                        peg$currPos++;
                                    } else {
                                        s7 = peg$FAILED;
                                        if (peg$silentFails === 0) peg$fail(peg$c10);
                                    }
                                    if (s7 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s1 = peg$c11(s3, s5);
                                        s0 = s1;
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseelementFormat() {
            var s0;
            s0 = peg$parsesimpleFormat();
            if (s0 === peg$FAILED) {
                s0 = peg$parsepluralFormat();
                if (s0 === peg$FAILED) {
                    s0 = peg$parseselectOrdinalFormat();
                    if (s0 === peg$FAILED) s0 = peg$parseselectFormat();
                }
            }
            return s0;
        }
        function peg$parsesimpleFormat() {
            var s0, s1, s2, s3, s4, s5, s6;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 6) === peg$c12) {
                s1 = peg$c12;
                peg$currPos += 6;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c13);
            }
            if (s1 === peg$FAILED) {
                if (input.substr(peg$currPos, 4) === peg$c14) {
                    s1 = peg$c14;
                    peg$currPos += 4;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c15);
                }
                if (s1 === peg$FAILED) {
                    if (input.substr(peg$currPos, 4) === peg$c16) {
                        s1 = peg$c16;
                        peg$currPos += 4;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c17);
                    }
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                if (s2 !== peg$FAILED) {
                    s3 = peg$currPos;
                    if (input.charCodeAt(peg$currPos) === 44) {
                        s4 = peg$c7;
                        peg$currPos++;
                    } else {
                        s4 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c8);
                    }
                    if (s4 !== peg$FAILED) {
                        s5 = peg$parse_();
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parsechars();
                            if (s6 !== peg$FAILED) {
                                s4 = [
                                    s4,
                                    s5,
                                    s6
                                ];
                                s3 = s4;
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                    if (s3 === peg$FAILED) s3 = null;
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c18(s1, s3);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsepluralFormat() {
            var s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 6) === peg$c19) {
                s1 = peg$c19;
                peg$currPos += 6;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c20);
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 44) {
                        s3 = peg$c7;
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c8);
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parsepluralStyle();
                            if (s5 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c21(s5);
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseselectOrdinalFormat() {
            var s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 13) === peg$c22) {
                s1 = peg$c22;
                peg$currPos += 13;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c23);
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 44) {
                        s3 = peg$c7;
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c8);
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parsepluralStyle();
                            if (s5 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c24(s5);
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseselectFormat() {
            var s0, s1, s2, s3, s4, s5, s6;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 6) === peg$c25) {
                s1 = peg$c25;
                peg$currPos += 6;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c26);
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 44) {
                        s3 = peg$c7;
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c8);
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            s5 = [];
                            s6 = peg$parseoptionalFormatPattern();
                            if (s6 !== peg$FAILED) while(s6 !== peg$FAILED){
                                s5.push(s6);
                                s6 = peg$parseoptionalFormatPattern();
                            }
                            else s5 = peg$FAILED;
                            if (s5 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c27(s5);
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseselector() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            s1 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 61) {
                s2 = peg$c28;
                peg$currPos++;
            } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c29);
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parsenumber();
                if (s3 !== peg$FAILED) {
                    s2 = [
                        s2,
                        s3
                    ];
                    s1 = s2;
                } else {
                    peg$currPos = s1;
                    s1 = peg$FAILED;
                }
            } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) s0 = input.substring(s0, peg$currPos);
            else s0 = s1;
            if (s0 === peg$FAILED) s0 = peg$parsechars();
            return s0;
        }
        function peg$parseoptionalFormatPattern() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8;
            s0 = peg$currPos;
            s1 = peg$parse_();
            if (s1 !== peg$FAILED) {
                s2 = peg$parseselector();
                if (s2 !== peg$FAILED) {
                    s3 = peg$parse_();
                    if (s3 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 123) {
                            s4 = peg$c5;
                            peg$currPos++;
                        } else {
                            s4 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c6);
                        }
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parse_();
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parsemessageFormatPattern();
                                if (s6 !== peg$FAILED) {
                                    s7 = peg$parse_();
                                    if (s7 !== peg$FAILED) {
                                        if (input.charCodeAt(peg$currPos) === 125) {
                                            s8 = peg$c9;
                                            peg$currPos++;
                                        } else {
                                            s8 = peg$FAILED;
                                            if (peg$silentFails === 0) peg$fail(peg$c10);
                                        }
                                        if (s8 !== peg$FAILED) {
                                            peg$savedPos = s0;
                                            s1 = peg$c30(s2, s6);
                                            s0 = s1;
                                        } else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseoffset() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 7) === peg$c31) {
                s1 = peg$c31;
                peg$currPos += 7;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c32);
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                if (s2 !== peg$FAILED) {
                    s3 = peg$parsenumber();
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c33(s3);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsepluralStyle() {
            var s0, s1, s2, s3, s4;
            s0 = peg$currPos;
            s1 = peg$parseoffset();
            if (s1 === peg$FAILED) s1 = null;
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$parseoptionalFormatPattern();
                    if (s4 !== peg$FAILED) while(s4 !== peg$FAILED){
                        s3.push(s4);
                        s4 = peg$parseoptionalFormatPattern();
                    }
                    else s3 = peg$FAILED;
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c34(s1, s3);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsews() {
            var s0, s1;
            peg$silentFails++;
            s0 = [];
            if (peg$c36.test(input.charAt(peg$currPos))) {
                s1 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c37);
            }
            if (s1 !== peg$FAILED) while(s1 !== peg$FAILED){
                s0.push(s1);
                if (peg$c36.test(input.charAt(peg$currPos))) {
                    s1 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c37);
                }
            }
            else s0 = peg$FAILED;
            peg$silentFails--;
            if (s0 === peg$FAILED) {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c35);
            }
            return s0;
        }
        function peg$parse_() {
            var s0, s1, s2;
            peg$silentFails++;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parsews();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parsews();
            }
            if (s1 !== peg$FAILED) s0 = input.substring(s0, peg$currPos);
            else s0 = s1;
            peg$silentFails--;
            if (s0 === peg$FAILED) {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c38);
            }
            return s0;
        }
        function peg$parsedigit() {
            var s0;
            if (peg$c39.test(input.charAt(peg$currPos))) {
                s0 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c40);
            }
            return s0;
        }
        function peg$parsehexDigit() {
            var s0;
            if (peg$c41.test(input.charAt(peg$currPos))) {
                s0 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c42);
            }
            return s0;
        }
        function peg$parsenumber() {
            var s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 48) {
                s1 = peg$c43;
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c44);
            }
            if (s1 === peg$FAILED) {
                s1 = peg$currPos;
                s2 = peg$currPos;
                if (peg$c45.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c46);
                }
                if (s3 !== peg$FAILED) {
                    s4 = [];
                    s5 = peg$parsedigit();
                    while(s5 !== peg$FAILED){
                        s4.push(s5);
                        s5 = peg$parsedigit();
                    }
                    if (s4 !== peg$FAILED) {
                        s3 = [
                            s3,
                            s4
                        ];
                        s2 = s3;
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
                if (s2 !== peg$FAILED) s1 = input.substring(s1, peg$currPos);
                else s1 = s2;
            }
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c47(s1);
            }
            s0 = s1;
            return s0;
        }
        function peg$parsechar() {
            var s0, s1, s2, s3, s4, s5, s6, s7;
            if (peg$c48.test(input.charAt(peg$currPos))) {
                s0 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c49);
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c50) {
                    s1 = peg$c50;
                    peg$currPos += 2;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c51);
                }
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c52();
                }
                s0 = s1;
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c53) {
                        s1 = peg$c53;
                        peg$currPos += 2;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c54);
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c55();
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input.substr(peg$currPos, 2) === peg$c56) {
                            s1 = peg$c56;
                            peg$currPos += 2;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c57);
                        }
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c58();
                        }
                        s0 = s1;
                        if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            if (input.substr(peg$currPos, 2) === peg$c59) {
                                s1 = peg$c59;
                                peg$currPos += 2;
                            } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c60);
                            }
                            if (s1 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c61();
                            }
                            s0 = s1;
                            if (s0 === peg$FAILED) {
                                s0 = peg$currPos;
                                if (input.substr(peg$currPos, 2) === peg$c62) {
                                    s1 = peg$c62;
                                    peg$currPos += 2;
                                } else {
                                    s1 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c63);
                                }
                                if (s1 !== peg$FAILED) {
                                    s2 = peg$currPos;
                                    s3 = peg$currPos;
                                    s4 = peg$parsehexDigit();
                                    if (s4 !== peg$FAILED) {
                                        s5 = peg$parsehexDigit();
                                        if (s5 !== peg$FAILED) {
                                            s6 = peg$parsehexDigit();
                                            if (s6 !== peg$FAILED) {
                                                s7 = peg$parsehexDigit();
                                                if (s7 !== peg$FAILED) {
                                                    s4 = [
                                                        s4,
                                                        s5,
                                                        s6,
                                                        s7
                                                    ];
                                                    s3 = s4;
                                                } else {
                                                    peg$currPos = s3;
                                                    s3 = peg$FAILED;
                                                }
                                            } else {
                                                peg$currPos = s3;
                                                s3 = peg$FAILED;
                                            }
                                        } else {
                                            peg$currPos = s3;
                                            s3 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                    if (s3 !== peg$FAILED) s2 = input.substring(s2, peg$currPos);
                                    else s2 = s3;
                                    if (s2 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s1 = peg$c64(s2);
                                        s0 = s1;
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                        }
                    }
                }
            }
            return s0;
        }
        function peg$parsechars() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parsechar();
            if (s2 !== peg$FAILED) while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parsechar();
            }
            else s1 = peg$FAILED;
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c65(s1);
            }
            s0 = s1;
            return s0;
        }
        peg$result = peg$startRuleFunction();
        if (peg$result !== peg$FAILED && peg$currPos === input.length) return peg$result;
        else {
            if (peg$result !== peg$FAILED && peg$currPos < input.length) peg$fail({
                type: "end",
                description: "end of input"
            });
            throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
        }
    }
    return {
        SyntaxError: peg$SyntaxError,
        parse: peg$parse
    };
}();

});



parcelRegister("4Fsm0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3660fc485f1f4ece$export$2e2bcd8739ae039; }, function (v) { return $3660fc485f1f4ece$export$2e2bcd8739ae039 = v; });
// GENERATED FILE
var $3660fc485f1f4ece$export$2e2bcd8739ae039;
"use strict";
$3660fc485f1f4ece$export$2e2bcd8739ae039 = {
    "locale": "en",
    "pluralRuleFunction": function(n, ord) {
        var s = String(n).split("."), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
        if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";
        return n == 1 && v0 ? "one" : "other";
    }
};

});



parcelRegister("ftOpI", function(module, exports) {
/* jshint node:true */ "use strict";

var $9gSNc = parcelRequire("9gSNc");
var IntlRelativeFormat = $9gSNc.default;
parcelRequire("iZpK3");
// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports["default"] = exports;

});
parcelRegister("9gSNc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c001c578b98ddd4$export$2e2bcd8739ae039; }, function (v) { return $6c001c578b98ddd4$export$2e2bcd8739ae039 = v; });
/* jslint esnext: true */ var $6c001c578b98ddd4$export$2e2bcd8739ae039;
"use strict";

var $dWdGp = parcelRequire("dWdGp");

var $jEXFJ = parcelRequire("jEXFJ");
$dWdGp.default.__addLocaleData($jEXFJ.default);
$dWdGp.default.defaultLocale = "en";
$6c001c578b98ddd4$export$2e2bcd8739ae039 = $dWdGp.default;

});
parcelRegister("dWdGp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a25b4e4cf1808cce$export$2e2bcd8739ae039; }, function (v) { return $a25b4e4cf1808cce$export$2e2bcd8739ae039 = v; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /* jslint esnext: true */ var $a25b4e4cf1808cce$export$2e2bcd8739ae039;
"use strict";

var $7k4sH = parcelRequire("7k4sH");

var $4YZfE = parcelRequire("4YZfE");

var $50jAZ = parcelRequire("50jAZ");
$a25b4e4cf1808cce$export$2e2bcd8739ae039 = $a25b4e4cf1808cce$var$RelativeFormat;
// -----------------------------------------------------------------------------
var $a25b4e4cf1808cce$var$FIELDS = [
    "second",
    "second-short",
    "minute",
    "minute-short",
    "hour",
    "hour-short",
    "day",
    "day-short",
    "month",
    "month-short",
    "year",
    "year-short"
];
var $a25b4e4cf1808cce$var$STYLES = [
    "best fit",
    "numeric"
];
// -- RelativeFormat -----------------------------------------------------------
function $a25b4e4cf1808cce$var$RelativeFormat(locales, options) {
    options = options || {};
    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if ($50jAZ.isArray(locales)) locales = locales.concat();
    $50jAZ.defineProperty(this, "_locale", {
        value: this._resolveLocale(locales)
    });
    $50jAZ.defineProperty(this, "_options", {
        value: {
            style: this._resolveStyle(options.style),
            units: this._isValidUnits(options.units) && options.units
        }
    });
    $50jAZ.defineProperty(this, "_locales", {
        value: locales
    });
    $50jAZ.defineProperty(this, "_fields", {
        value: this._findFields(this._locale)
    });
    $50jAZ.defineProperty(this, "_messages", {
        value: $50jAZ.objCreate(null)
    });
    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}
// Define internal private properties for dealing with locale data.
$50jAZ.defineProperty($a25b4e4cf1808cce$var$RelativeFormat, "__localeData__", {
    value: $50jAZ.objCreate(null)
});
$50jAZ.defineProperty($a25b4e4cf1808cce$var$RelativeFormat, "__addLocaleData", {
    value: function(data) {
        if (!(data && data.locale)) throw new Error("Locale data provided to IntlRelativeFormat is missing a `locale` property value");
        $a25b4e4cf1808cce$var$RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;
        // Add data to IntlMessageFormat.
        $7k4sH.default.__addLocaleData(data);
    }
});
// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
$50jAZ.defineProperty($a25b4e4cf1808cce$var$RelativeFormat, "defaultLocale", {
    enumerable: true,
    writable: true,
    value: undefined
});
// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
$50jAZ.defineProperty($a25b4e4cf1808cce$var$RelativeFormat, "thresholds", {
    enumerable: true,
    value: {
        second: 45,
        "second-short": 45,
        minute: 45,
        "minute-short": 45,
        hour: 22,
        "hour-short": 22,
        day: 26,
        "day-short": 26,
        month: 11,
        "month-short": 11 // months to year
    }
});
$a25b4e4cf1808cce$var$RelativeFormat.prototype.resolvedOptions = function() {
    return {
        locale: this._locale,
        style: this._options.style,
        units: this._options.units
    };
};
$a25b4e4cf1808cce$var$RelativeFormat.prototype._compileMessage = function(units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales = this._locales;
    var resolvedLocale = this._locale;
    var field = this._fields[units];
    var relativeTime = field.relativeTime;
    var future = "";
    var past = "";
    var i;
    for(i in relativeTime.future)if (relativeTime.future.hasOwnProperty(i)) future += " " + i + " {" + relativeTime.future[i].replace("{0}", "#") + "}";
    for(i in relativeTime.past)if (relativeTime.past.hasOwnProperty(i)) past += " " + i + " {" + relativeTime.past[i].replace("{0}", "#") + "}";
    var message = "{when, select, future {{0, plural, " + future + "}}" + "past {{0, plural, " + past + "}}}";
    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new $7k4sH.default(message, locales);
};
$a25b4e4cf1808cce$var$RelativeFormat.prototype._getMessage = function(units) {
    var messages = this._messages;
    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) messages[units] = this._compileMessage(units);
    return messages[units];
};
$a25b4e4cf1808cce$var$RelativeFormat.prototype._getRelativeUnits = function(diff, units) {
    var field = this._fields[units];
    if (field.relative) return field.relative[diff];
};
$a25b4e4cf1808cce$var$RelativeFormat.prototype._findFields = function(locale) {
    var localeData = $a25b4e4cf1808cce$var$RelativeFormat.__localeData__;
    var data = localeData[locale.toLowerCase()];
    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while(data){
        if (data.fields) return data.fields;
        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }
    throw new Error("Locale data added to IntlRelativeFormat is missing `fields` for :" + locale);
};
$a25b4e4cf1808cce$var$RelativeFormat.prototype._format = function(date, options) {
    var now = options && options.now !== undefined ? options.now : $50jAZ.dateNow();
    if (date === undefined) date = now;
    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) throw new RangeError("The `now` option provided to IntlRelativeFormat#format() is not in valid range.");
    if (!isFinite(date)) throw new RangeError("The date value provided to IntlRelativeFormat#format() is not in valid range.");
    var diffReport = $4YZfE.default(now, date);
    var units = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];
    if (this._options.style !== "numeric") {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) return relativeUnits;
    }
    return this._getMessage(units).format({
        "0": Math.abs(diffInUnits),
        when: diffInUnits < 0 ? "past" : "future"
    });
};
$a25b4e4cf1808cce$var$RelativeFormat.prototype._isValidUnits = function(units) {
    if (!units || $50jAZ.arrIndexOf.call($a25b4e4cf1808cce$var$FIELDS, units) >= 0) return true;
    if (typeof units === "string") {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && $50jAZ.arrIndexOf.call($a25b4e4cf1808cce$var$FIELDS, suggestion) >= 0) throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` ' + "value, did you mean: " + suggestion);
    }
    throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' + 'must be one of: "' + $a25b4e4cf1808cce$var$FIELDS.join('", "') + '"');
};
$a25b4e4cf1808cce$var$RelativeFormat.prototype._resolveLocale = function(locales) {
    if (typeof locales === "string") locales = [
        locales
    ];
    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat($a25b4e4cf1808cce$var$RelativeFormat.defaultLocale);
    var localeData = $a25b4e4cf1808cce$var$RelativeFormat.__localeData__;
    var i, len, localeParts, data;
    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for(i = 0, len = locales.length; i < len; i += 1){
        localeParts = locales[i].toLowerCase().split("-");
        while(localeParts.length){
            data = localeData[localeParts.join("-")];
            if (data) // Return the normalized locale string; e.g., we return "en-US",
            // instead of "en-us".
            return data.locale;
            localeParts.pop();
        }
    }
    var defaultLocale = locales.pop();
    throw new Error("No locale data has been added to IntlRelativeFormat for: " + locales.join(", ") + ", or the default locale: " + defaultLocale);
};
$a25b4e4cf1808cce$var$RelativeFormat.prototype._resolveStyle = function(style) {
    // Default to "best fit" style.
    if (!style) return $a25b4e4cf1808cce$var$STYLES[0];
    if ($50jAZ.arrIndexOf.call($a25b4e4cf1808cce$var$STYLES, style) >= 0) return style;
    throw new Error('"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' + 'must be one of: "' + $a25b4e4cf1808cce$var$STYLES.join('", "') + '"');
};
$a25b4e4cf1808cce$var$RelativeFormat.prototype._selectUnits = function(diffReport) {
    var i, l, units;
    var fields = $a25b4e4cf1808cce$var$FIELDS.filter(function(field) {
        return field.indexOf("-short") < 1;
    });
    for(i = 0, l = fields.length; i < l; i += 1){
        units = fields[i];
        if (Math.abs(diffReport[units]) < $a25b4e4cf1808cce$var$RelativeFormat.thresholds[units]) break;
    }
    return units;
};

});
parcelRegister("4YZfE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a0c474884f43f9d$export$2e2bcd8739ae039; }, function (v) { return $3a0c474884f43f9d$export$2e2bcd8739ae039 = v; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /* jslint esnext: true */ var $3a0c474884f43f9d$export$2e2bcd8739ae039;
"use strict";
var $3a0c474884f43f9d$var$round = Math.round;
function $3a0c474884f43f9d$var$daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}
$3a0c474884f43f9d$export$2e2bcd8739ae039 = function(from, to) {
    // Convert to ms timestamps.
    from = +from;
    to = +to;
    var millisecond = $3a0c474884f43f9d$var$round(to - from), second = $3a0c474884f43f9d$var$round(millisecond / 1000), minute = $3a0c474884f43f9d$var$round(second / 60), hour = $3a0c474884f43f9d$var$round(minute / 60), day = $3a0c474884f43f9d$var$round(hour / 24), week = $3a0c474884f43f9d$var$round(day / 7);
    var rawYears = $3a0c474884f43f9d$var$daysToYears(day), month = $3a0c474884f43f9d$var$round(rawYears * 12), year = $3a0c474884f43f9d$var$round(rawYears);
    return {
        millisecond: millisecond,
        second: second,
        "second-short": second,
        minute: minute,
        "minute-short": minute,
        hour: hour,
        "hour-short": hour,
        day: day,
        "day-short": day,
        week: week,
        "week-short": week,
        month: month,
        "month-short": month,
        year: year,
        "year-short": year
    };
};

});

parcelRegister("50jAZ", function(module, exports) {

$parcel$export(module.exports, "defineProperty", function () { return $3a4c271be52f42eb$export$fdab3c20aae16ddf; }, function (v) { return $3a4c271be52f42eb$export$fdab3c20aae16ddf = v; });
$parcel$export(module.exports, "objCreate", function () { return $3a4c271be52f42eb$export$c09f2411a4ae511b; }, function (v) { return $3a4c271be52f42eb$export$c09f2411a4ae511b = v; });
$parcel$export(module.exports, "arrIndexOf", function () { return $3a4c271be52f42eb$export$9f3b3ffa84393d30; }, function (v) { return $3a4c271be52f42eb$export$9f3b3ffa84393d30 = v; });
$parcel$export(module.exports, "isArray", function () { return $3a4c271be52f42eb$export$43bee75e5e14138e; }, function (v) { return $3a4c271be52f42eb$export$43bee75e5e14138e = v; });
$parcel$export(module.exports, "dateNow", function () { return $3a4c271be52f42eb$export$ceae11818251d43c; }, function (v) { return $3a4c271be52f42eb$export$ceae11818251d43c = v; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /* jslint esnext: true */ // Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License
var $3a4c271be52f42eb$export$fdab3c20aae16ddf;
var $3a4c271be52f42eb$export$c09f2411a4ae511b;
var $3a4c271be52f42eb$export$9f3b3ffa84393d30;
var $3a4c271be52f42eb$export$43bee75e5e14138e;
var $3a4c271be52f42eb$export$ceae11818251d43c;
"use strict";
var $3a4c271be52f42eb$var$hop = Object.prototype.hasOwnProperty;
var $3a4c271be52f42eb$var$toString = Object.prototype.toString;
var $3a4c271be52f42eb$var$realDefineProp = function() {
    try {
        return !!Object.defineProperty({}, "a", {});
    } catch (e) {
        return false;
    }
}();
var $3a4c271be52f42eb$var$es3 = !$3a4c271be52f42eb$var$realDefineProp && !Object.prototype.__defineGetter__;
var $3a4c271be52f42eb$var$defineProperty = $3a4c271be52f42eb$var$realDefineProp ? Object.defineProperty : function(obj, name, desc) {
    if ("get" in desc && obj.__defineGetter__) obj.__defineGetter__(name, desc.get);
    else if (!$3a4c271be52f42eb$var$hop.call(obj, name) || "value" in desc) obj[name] = desc.value;
};
var $3a4c271be52f42eb$var$objCreate = Object.create || function(proto, props) {
    var obj, k;
    function F() {}
    F.prototype = proto;
    obj = new F();
    for(k in props)if ($3a4c271be52f42eb$var$hop.call(props, k)) $3a4c271be52f42eb$var$defineProperty(obj, k, props[k]);
    return obj;
};
var $3a4c271be52f42eb$var$arrIndexOf = Array.prototype.indexOf || function(search, fromIndex) {
    /*jshint validthis:true */ var arr = this;
    if (!arr.length) return -1;
    for(var i = fromIndex || 0, max = arr.length; i < max; i++){
        if (arr[i] === search) return i;
    }
    return -1;
};
var $3a4c271be52f42eb$var$isArray = Array.isArray || function(obj) {
    return $3a4c271be52f42eb$var$toString.call(obj) === "[object Array]";
};
var $3a4c271be52f42eb$var$dateNow = Date.now || function() {
    return new Date().getTime();
};
$3a4c271be52f42eb$export$fdab3c20aae16ddf = $3a4c271be52f42eb$var$defineProperty, $3a4c271be52f42eb$export$c09f2411a4ae511b = $3a4c271be52f42eb$var$objCreate, $3a4c271be52f42eb$export$9f3b3ffa84393d30 = $3a4c271be52f42eb$var$arrIndexOf, $3a4c271be52f42eb$export$43bee75e5e14138e = $3a4c271be52f42eb$var$isArray, $3a4c271be52f42eb$export$ceae11818251d43c = $3a4c271be52f42eb$var$dateNow;

});


parcelRegister("jEXFJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5000a5bc2e8b758$export$2e2bcd8739ae039; }, function (v) { return $e5000a5bc2e8b758$export$2e2bcd8739ae039 = v; });
// GENERATED FILE
var $e5000a5bc2e8b758$export$2e2bcd8739ae039;
"use strict";
$e5000a5bc2e8b758$export$2e2bcd8739ae039 = {
    "locale": "en",
    "pluralRuleFunction": function(n, ord) {
        var s = String(n).split("."), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
        if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";
        return n == 1 && v0 ? "one" : "other";
    },
    "fields": {
        "year": {
            "displayName": "year",
            "relative": {
                "0": "this year",
                "1": "next year",
                "-1": "last year"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} year",
                    "other": "in {0} years"
                },
                "past": {
                    "one": "{0} year ago",
                    "other": "{0} years ago"
                }
            }
        },
        "year-short": {
            "displayName": "yr.",
            "relative": {
                "0": "this yr.",
                "1": "next yr.",
                "-1": "last yr."
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} yr.",
                    "other": "in {0} yr."
                },
                "past": {
                    "one": "{0} yr. ago",
                    "other": "{0} yr. ago"
                }
            }
        },
        "month": {
            "displayName": "month",
            "relative": {
                "0": "this month",
                "1": "next month",
                "-1": "last month"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} month",
                    "other": "in {0} months"
                },
                "past": {
                    "one": "{0} month ago",
                    "other": "{0} months ago"
                }
            }
        },
        "month-short": {
            "displayName": "mo.",
            "relative": {
                "0": "this mo.",
                "1": "next mo.",
                "-1": "last mo."
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} mo.",
                    "other": "in {0} mo."
                },
                "past": {
                    "one": "{0} mo. ago",
                    "other": "{0} mo. ago"
                }
            }
        },
        "day": {
            "displayName": "day",
            "relative": {
                "0": "today",
                "1": "tomorrow",
                "-1": "yesterday"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} day",
                    "other": "in {0} days"
                },
                "past": {
                    "one": "{0} day ago",
                    "other": "{0} days ago"
                }
            }
        },
        "day-short": {
            "displayName": "day",
            "relative": {
                "0": "today",
                "1": "tomorrow",
                "-1": "yesterday"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} day",
                    "other": "in {0} days"
                },
                "past": {
                    "one": "{0} day ago",
                    "other": "{0} days ago"
                }
            }
        },
        "hour": {
            "displayName": "hour",
            "relative": {
                "0": "this hour"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} hour",
                    "other": "in {0} hours"
                },
                "past": {
                    "one": "{0} hour ago",
                    "other": "{0} hours ago"
                }
            }
        },
        "hour-short": {
            "displayName": "hr.",
            "relative": {
                "0": "this hour"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} hr.",
                    "other": "in {0} hr."
                },
                "past": {
                    "one": "{0} hr. ago",
                    "other": "{0} hr. ago"
                }
            }
        },
        "minute": {
            "displayName": "minute",
            "relative": {
                "0": "this minute"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} minute",
                    "other": "in {0} minutes"
                },
                "past": {
                    "one": "{0} minute ago",
                    "other": "{0} minutes ago"
                }
            }
        },
        "minute-short": {
            "displayName": "min.",
            "relative": {
                "0": "this minute"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} min.",
                    "other": "in {0} min."
                },
                "past": {
                    "one": "{0} min. ago",
                    "other": "{0} min. ago"
                }
            }
        },
        "second": {
            "displayName": "second",
            "relative": {
                "0": "now"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} second",
                    "other": "in {0} seconds"
                },
                "past": {
                    "one": "{0} second ago",
                    "other": "{0} seconds ago"
                }
            }
        },
        "second-short": {
            "displayName": "sec.",
            "relative": {
                "0": "now"
            },
            "relativeTime": {
                "future": {
                    "one": "in {0} sec.",
                    "other": "in {0} sec."
                },
                "past": {
                    "one": "{0} sec. ago",
                    "other": "{0} sec. ago"
                }
            }
        }
    }
};

});



parcelRegister("blCBi", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $842f9921afede62f$var$ReactIs, $842f9921afede62f$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("8FDg6"))();

});
parcelRegister("8FDg6", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $5tTE9 = parcelRequire("5tTE9");
function $65009b0ce9c8b29e$var$emptyFunction() {}
function $65009b0ce9c8b29e$var$emptyFunctionWithReset() {}
$65009b0ce9c8b29e$var$emptyFunctionWithReset.resetWarningCache = $65009b0ce9c8b29e$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $5tTE9) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $65009b0ce9c8b29e$var$emptyFunctionWithReset,
        resetWarningCache: $65009b0ce9c8b29e$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("5tTE9", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $3fdad36b4e74adf3$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $3fdad36b4e74adf3$var$ReactPropTypesSecret;

});



parcelRegister("1t1PC", function(module, exports) {
"use strict";

var $fAROH = parcelRequire("fAROH");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $1119eb92d1fd6f98$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $1119eb92d1fd6f98$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $1119eb92d1fd6f98$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $1119eb92d1fd6f98$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $1119eb92d1fd6f98$var$TYPE_STATICS = {};
$1119eb92d1fd6f98$var$TYPE_STATICS[$fAROH.ForwardRef] = $1119eb92d1fd6f98$var$FORWARD_REF_STATICS;
$1119eb92d1fd6f98$var$TYPE_STATICS[$fAROH.Memo] = $1119eb92d1fd6f98$var$MEMO_STATICS;
function $1119eb92d1fd6f98$var$getStatics(component) {
    // React v16.11 and below
    if ($fAROH.isMemo(component)) return $1119eb92d1fd6f98$var$MEMO_STATICS;
     // React v16.12 and above
    return $1119eb92d1fd6f98$var$TYPE_STATICS[component["$$typeof"]] || $1119eb92d1fd6f98$var$REACT_STATICS;
}
var $1119eb92d1fd6f98$var$defineProperty = Object.defineProperty;
var $1119eb92d1fd6f98$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $1119eb92d1fd6f98$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $1119eb92d1fd6f98$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $1119eb92d1fd6f98$var$getPrototypeOf = Object.getPrototypeOf;
var $1119eb92d1fd6f98$var$objectPrototype = Object.prototype;
function $1119eb92d1fd6f98$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($1119eb92d1fd6f98$var$objectPrototype) {
            var inheritedComponent = $1119eb92d1fd6f98$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $1119eb92d1fd6f98$var$objectPrototype) $1119eb92d1fd6f98$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $1119eb92d1fd6f98$var$getOwnPropertyNames(sourceComponent);
        if ($1119eb92d1fd6f98$var$getOwnPropertySymbols) keys = keys.concat($1119eb92d1fd6f98$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $1119eb92d1fd6f98$var$getStatics(targetComponent);
        var sourceStatics = $1119eb92d1fd6f98$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$1119eb92d1fd6f98$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $1119eb92d1fd6f98$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $1119eb92d1fd6f98$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $1119eb92d1fd6f98$var$hoistNonReactStatics;

});
parcelRegister("fAROH", function(module, exports) {
"use strict";

module.exports = (parcelRequire("b0CDv"));

});
parcelRegister("b0CDv", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $803daa246ee2b043$export$2b8d127b894957b9; }, function (v) { return $803daa246ee2b043$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $803daa246ee2b043$export$cea3a54a6425200c; }, function (v) { return $803daa246ee2b043$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $803daa246ee2b043$export$a7c73072b1a182ae; }, function (v) { return $803daa246ee2b043$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $803daa246ee2b043$export$9f27bc3417b4524d; }, function (v) { return $803daa246ee2b043$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $803daa246ee2b043$export$db77ccec0bb4ccac; }, function (v) { return $803daa246ee2b043$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $803daa246ee2b043$export$8392c0c9d3dcbd35; }, function (v) { return $803daa246ee2b043$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $803daa246ee2b043$export$ffb0004e005737fa; }, function (v) { return $803daa246ee2b043$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $803daa246ee2b043$export$b624eff549462981; }, function (v) { return $803daa246ee2b043$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $803daa246ee2b043$export$7897aa7841a5380c; }, function (v) { return $803daa246ee2b043$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $803daa246ee2b043$export$602eac185826482c; }, function (v) { return $803daa246ee2b043$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $803daa246ee2b043$export$e2c29f18771995cb; }, function (v) { return $803daa246ee2b043$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $803daa246ee2b043$export$5f8d39834fd61797; }, function (v) { return $803daa246ee2b043$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $803daa246ee2b043$export$74bf444e3cd11ea5; }, function (v) { return $803daa246ee2b043$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $803daa246ee2b043$export$92387174baf9b227; }, function (v) { return $803daa246ee2b043$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $803daa246ee2b043$export$ec112efeb987d9c6; }, function (v) { return $803daa246ee2b043$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $803daa246ee2b043$export$b706b080d889d2c9; }, function (v) { return $803daa246ee2b043$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $803daa246ee2b043$export$5be5a87408f70ddc; }, function (v) { return $803daa246ee2b043$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $803daa246ee2b043$export$45a5e7f76e0caa8d; }, function (v) { return $803daa246ee2b043$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $803daa246ee2b043$export$455c2e768291efa6; }, function (v) { return $803daa246ee2b043$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $803daa246ee2b043$export$9522e17588c12572; }, function (v) { return $803daa246ee2b043$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $803daa246ee2b043$export$2110ac352bb060b9; }, function (v) { return $803daa246ee2b043$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $803daa246ee2b043$export$56885ab8b9c456ab; }, function (v) { return $803daa246ee2b043$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $803daa246ee2b043$export$d927fcb6adf8f9de; }, function (v) { return $803daa246ee2b043$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $803daa246ee2b043$export$b82d16f27459e05a; }, function (v) { return $803daa246ee2b043$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $803daa246ee2b043$export$522c17b4f5e123e8; }, function (v) { return $803daa246ee2b043$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $803daa246ee2b043$export$1aabd8a0274ecfd6; }, function (v) { return $803daa246ee2b043$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $803daa246ee2b043$export$9b621391a187a31a; }, function (v) { return $803daa246ee2b043$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $803daa246ee2b043$export$f5bbd400c2f4426f; }, function (v) { return $803daa246ee2b043$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $803daa246ee2b043$export$2b8d127b894957b9;
var $803daa246ee2b043$export$cea3a54a6425200c;
var $803daa246ee2b043$export$a7c73072b1a182ae;
var $803daa246ee2b043$export$9f27bc3417b4524d;
var $803daa246ee2b043$export$db77ccec0bb4ccac;
var $803daa246ee2b043$export$8392c0c9d3dcbd35;
var $803daa246ee2b043$export$ffb0004e005737fa;
var $803daa246ee2b043$export$b624eff549462981;
var $803daa246ee2b043$export$7897aa7841a5380c;
var $803daa246ee2b043$export$602eac185826482c;
var $803daa246ee2b043$export$e2c29f18771995cb;
var $803daa246ee2b043$export$5f8d39834fd61797;
var $803daa246ee2b043$export$74bf444e3cd11ea5;
var $803daa246ee2b043$export$92387174baf9b227;
var $803daa246ee2b043$export$ec112efeb987d9c6;
var $803daa246ee2b043$export$b706b080d889d2c9;
var $803daa246ee2b043$export$5be5a87408f70ddc;
var $803daa246ee2b043$export$45a5e7f76e0caa8d;
var $803daa246ee2b043$export$455c2e768291efa6;
var $803daa246ee2b043$export$9522e17588c12572;
var $803daa246ee2b043$export$2110ac352bb060b9;
var $803daa246ee2b043$export$56885ab8b9c456ab;
var $803daa246ee2b043$export$d927fcb6adf8f9de;
var $803daa246ee2b043$export$b82d16f27459e05a;
var $803daa246ee2b043$export$522c17b4f5e123e8;
var $803daa246ee2b043$export$1aabd8a0274ecfd6;
var $803daa246ee2b043$export$9b621391a187a31a;
var $803daa246ee2b043$export$f5bbd400c2f4426f;
"use strict";
var $803daa246ee2b043$var$b = "function" === typeof Symbol && Symbol.for, $803daa246ee2b043$var$c = $803daa246ee2b043$var$b ? Symbol.for("react.element") : 60103, $803daa246ee2b043$var$d = $803daa246ee2b043$var$b ? Symbol.for("react.portal") : 60106, $803daa246ee2b043$var$e = $803daa246ee2b043$var$b ? Symbol.for("react.fragment") : 60107, $803daa246ee2b043$var$f = $803daa246ee2b043$var$b ? Symbol.for("react.strict_mode") : 60108, $803daa246ee2b043$var$g = $803daa246ee2b043$var$b ? Symbol.for("react.profiler") : 60114, $803daa246ee2b043$var$h = $803daa246ee2b043$var$b ? Symbol.for("react.provider") : 60109, $803daa246ee2b043$var$k = $803daa246ee2b043$var$b ? Symbol.for("react.context") : 60110, $803daa246ee2b043$var$l = $803daa246ee2b043$var$b ? Symbol.for("react.async_mode") : 60111, $803daa246ee2b043$var$m = $803daa246ee2b043$var$b ? Symbol.for("react.concurrent_mode") : 60111, $803daa246ee2b043$var$n = $803daa246ee2b043$var$b ? Symbol.for("react.forward_ref") : 60112, $803daa246ee2b043$var$p = $803daa246ee2b043$var$b ? Symbol.for("react.suspense") : 60113, $803daa246ee2b043$var$q = $803daa246ee2b043$var$b ? Symbol.for("react.suspense_list") : 60120, $803daa246ee2b043$var$r = $803daa246ee2b043$var$b ? Symbol.for("react.memo") : 60115, $803daa246ee2b043$var$t = $803daa246ee2b043$var$b ? Symbol.for("react.lazy") : 60116, $803daa246ee2b043$var$v = $803daa246ee2b043$var$b ? Symbol.for("react.block") : 60121, $803daa246ee2b043$var$w = $803daa246ee2b043$var$b ? Symbol.for("react.fundamental") : 60117, $803daa246ee2b043$var$x = $803daa246ee2b043$var$b ? Symbol.for("react.responder") : 60118, $803daa246ee2b043$var$y = $803daa246ee2b043$var$b ? Symbol.for("react.scope") : 60119;
function $803daa246ee2b043$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $803daa246ee2b043$var$c:
                switch(a = a.type, a){
                    case $803daa246ee2b043$var$l:
                    case $803daa246ee2b043$var$m:
                    case $803daa246ee2b043$var$e:
                    case $803daa246ee2b043$var$g:
                    case $803daa246ee2b043$var$f:
                    case $803daa246ee2b043$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $803daa246ee2b043$var$k:
                            case $803daa246ee2b043$var$n:
                            case $803daa246ee2b043$var$t:
                            case $803daa246ee2b043$var$r:
                            case $803daa246ee2b043$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $803daa246ee2b043$var$d:
                return u;
        }
    }
}
function $803daa246ee2b043$var$A(a) {
    return $803daa246ee2b043$var$z(a) === $803daa246ee2b043$var$m;
}
$803daa246ee2b043$export$2b8d127b894957b9 = $803daa246ee2b043$var$l;
$803daa246ee2b043$export$cea3a54a6425200c = $803daa246ee2b043$var$m;
$803daa246ee2b043$export$a7c73072b1a182ae = $803daa246ee2b043$var$k;
$803daa246ee2b043$export$9f27bc3417b4524d = $803daa246ee2b043$var$h;
$803daa246ee2b043$export$db77ccec0bb4ccac = $803daa246ee2b043$var$c;
$803daa246ee2b043$export$8392c0c9d3dcbd35 = $803daa246ee2b043$var$n;
$803daa246ee2b043$export$ffb0004e005737fa = $803daa246ee2b043$var$e;
$803daa246ee2b043$export$b624eff549462981 = $803daa246ee2b043$var$t;
$803daa246ee2b043$export$7897aa7841a5380c = $803daa246ee2b043$var$r;
$803daa246ee2b043$export$602eac185826482c = $803daa246ee2b043$var$d;
$803daa246ee2b043$export$e2c29f18771995cb = $803daa246ee2b043$var$g;
$803daa246ee2b043$export$5f8d39834fd61797 = $803daa246ee2b043$var$f;
$803daa246ee2b043$export$74bf444e3cd11ea5 = $803daa246ee2b043$var$p;
$803daa246ee2b043$export$92387174baf9b227 = function(a) {
    return $803daa246ee2b043$var$A(a) || $803daa246ee2b043$var$z(a) === $803daa246ee2b043$var$l;
};
$803daa246ee2b043$export$ec112efeb987d9c6 = $803daa246ee2b043$var$A;
$803daa246ee2b043$export$b706b080d889d2c9 = function(a) {
    return $803daa246ee2b043$var$z(a) === $803daa246ee2b043$var$k;
};
$803daa246ee2b043$export$5be5a87408f70ddc = function(a) {
    return $803daa246ee2b043$var$z(a) === $803daa246ee2b043$var$h;
};
$803daa246ee2b043$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $803daa246ee2b043$var$c;
};
$803daa246ee2b043$export$455c2e768291efa6 = function(a) {
    return $803daa246ee2b043$var$z(a) === $803daa246ee2b043$var$n;
};
$803daa246ee2b043$export$9522e17588c12572 = function(a) {
    return $803daa246ee2b043$var$z(a) === $803daa246ee2b043$var$e;
};
$803daa246ee2b043$export$2110ac352bb060b9 = function(a) {
    return $803daa246ee2b043$var$z(a) === $803daa246ee2b043$var$t;
};
$803daa246ee2b043$export$56885ab8b9c456ab = function(a) {
    return $803daa246ee2b043$var$z(a) === $803daa246ee2b043$var$r;
};
$803daa246ee2b043$export$d927fcb6adf8f9de = function(a) {
    return $803daa246ee2b043$var$z(a) === $803daa246ee2b043$var$d;
};
$803daa246ee2b043$export$b82d16f27459e05a = function(a) {
    return $803daa246ee2b043$var$z(a) === $803daa246ee2b043$var$g;
};
$803daa246ee2b043$export$522c17b4f5e123e8 = function(a) {
    return $803daa246ee2b043$var$z(a) === $803daa246ee2b043$var$f;
};
$803daa246ee2b043$export$1aabd8a0274ecfd6 = function(a) {
    return $803daa246ee2b043$var$z(a) === $803daa246ee2b043$var$p;
};
$803daa246ee2b043$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $803daa246ee2b043$var$e || a === $803daa246ee2b043$var$m || a === $803daa246ee2b043$var$g || a === $803daa246ee2b043$var$f || a === $803daa246ee2b043$var$p || a === $803daa246ee2b043$var$q || "object" === typeof a && null !== a && (a.$$typeof === $803daa246ee2b043$var$t || a.$$typeof === $803daa246ee2b043$var$r || a.$$typeof === $803daa246ee2b043$var$h || a.$$typeof === $803daa246ee2b043$var$k || a.$$typeof === $803daa246ee2b043$var$n || a.$$typeof === $803daa246ee2b043$var$w || a.$$typeof === $803daa246ee2b043$var$x || a.$$typeof === $803daa246ee2b043$var$y || a.$$typeof === $803daa246ee2b043$var$v);
};
$803daa246ee2b043$export$f5bbd400c2f4426f = $803daa246ee2b043$var$z;

});



parcelRegister("5kF1c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $3e1ea3664e115af1$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $3e1ea3664e115af1$var$invariant;

});

parcelRegister("96wQ2", function(module, exports) {
"use strict";

exports = module.exports = (parcelRequire("KO5dw")).default;
exports["default"] = exports;

});
parcelRegister("KO5dw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08cb257645f95eac$export$2e2bcd8739ae039; }, function (v) { return $08cb257645f95eac$export$2e2bcd8739ae039 = v; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /* jshint esnext: true */ var $08cb257645f95eac$export$2e2bcd8739ae039;
"use strict";

var $g9iU5 = parcelRequire("g9iU5");
$08cb257645f95eac$export$2e2bcd8739ae039 = $08cb257645f95eac$var$createFormatCache;
// -----------------------------------------------------------------------------
function $08cb257645f95eac$var$createFormatCache(FormatConstructor) {
    var cache = $g9iU5.objCreate(null);
    return function() {
        var args = Array.prototype.slice.call(arguments);
        var cacheId = $08cb257645f95eac$var$getCacheId(args);
        var format = cacheId && cache[cacheId];
        if (!format) {
            format = new ($g9iU5.bind.apply(FormatConstructor, [
                null
            ].concat(args)))();
            if (cacheId) cache[cacheId] = format;
        }
        return format;
    };
}
// -- Utilities ----------------------------------------------------------------
function $08cb257645f95eac$var$getCacheId(inputs) {
    // When JSON is not available in the runtime, we will not create a cache id.
    if (typeof JSON === "undefined") return;
    var cacheId = [];
    var i, len, input;
    for(i = 0, len = inputs.length; i < len; i += 1){
        input = inputs[i];
        if (input && typeof input === "object") cacheId.push($08cb257645f95eac$var$orderedProps(input));
        else cacheId.push(input);
    }
    return JSON.stringify(cacheId);
}
function $08cb257645f95eac$var$orderedProps(obj) {
    var props = [], keys = [];
    var key, i, len, prop;
    for(key in obj)if (obj.hasOwnProperty(key)) keys.push(key);
    var orderedKeys = keys.sort();
    for(i = 0, len = orderedKeys.length; i < len; i += 1){
        key = orderedKeys[i];
        prop = {};
        prop[key] = obj[key];
        props[i] = prop;
    }
    return props;
}

});
parcelRegister("g9iU5", function(module, exports) {

$parcel$export(module.exports, "bind", function () { return $bc1c26768da4cbe9$export$2385a24977818dd0; }, function (v) { return $bc1c26768da4cbe9$export$2385a24977818dd0 = v; });
$parcel$export(module.exports, "objCreate", function () { return $bc1c26768da4cbe9$export$c09f2411a4ae511b; }, function (v) { return $bc1c26768da4cbe9$export$c09f2411a4ae511b = v; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /* jslint esnext: true */ // Function.prototype.bind implementation from Mozilla Developer Network:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill
var $bc1c26768da4cbe9$export$2385a24977818dd0;
var $bc1c26768da4cbe9$export$fdab3c20aae16ddf;
var $bc1c26768da4cbe9$export$c09f2411a4ae511b;
"use strict";
var $bc1c26768da4cbe9$var$bind = Function.prototype.bind || function(oThis) {
    if (typeof this !== "function") // closest thing possible to the ECMAScript 5
    // internal IsCallable function
    throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
    var aArgs = Array.prototype.slice.call(arguments, 1), fToBind = this, fNOP = function() {}, fBound = function() {
        return fToBind.apply(this instanceof fNOP ? this : oThis, aArgs.concat(Array.prototype.slice.call(arguments)));
    };
    if (this.prototype) // native functions don't have a prototype
    fNOP.prototype = this.prototype;
    fBound.prototype = new fNOP();
    return fBound;
};
// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License
var $bc1c26768da4cbe9$var$hop = Object.prototype.hasOwnProperty;
var $bc1c26768da4cbe9$var$realDefineProp = function() {
    try {
        return !!Object.defineProperty({}, "a", {});
    } catch (e) {
        return false;
    }
}();
var $bc1c26768da4cbe9$var$es3 = !$bc1c26768da4cbe9$var$realDefineProp && !Object.prototype.__defineGetter__;
var $bc1c26768da4cbe9$var$defineProperty = $bc1c26768da4cbe9$var$realDefineProp ? Object.defineProperty : function(obj, name, desc) {
    if ("get" in desc && obj.__defineGetter__) obj.__defineGetter__(name, desc.get);
    else if (!$bc1c26768da4cbe9$var$hop.call(obj, name) || "value" in desc) obj[name] = desc.value;
};
var $bc1c26768da4cbe9$var$objCreate = Object.create || function(proto, props) {
    var obj, k;
    function F() {}
    F.prototype = proto;
    obj = new F();
    for(k in props)if ($bc1c26768da4cbe9$var$hop.call(props, k)) $bc1c26768da4cbe9$var$defineProperty(obj, k, props[k]);
    return obj;
};
$bc1c26768da4cbe9$export$2385a24977818dd0 = $bc1c26768da4cbe9$var$bind, $bc1c26768da4cbe9$export$fdab3c20aae16ddf = $bc1c26768da4cbe9$var$defineProperty, $bc1c26768da4cbe9$export$c09f2411a4ae511b = $bc1c26768da4cbe9$var$objCreate;

});




parcelRegister("8shKB", function(module, exports) {
/* eslint-disable no-underscore-dangle */ 
var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");

var $dQqAn = parcelRequire("dQqAn");
/**
 * This is a copy of react-loadable/index.js.
 *
 * To get hydration working with Parcel we need to override the `isWebpackReady`
 * function that react-loadable uses, which checks for some global properties webpack provides.
 *
 * This file is only used by Parcel builds.
 */ const $4bbe032af5ef296a$var$ALL_INITIALIZERS = [];
const $4bbe032af5ef296a$var$READY_INITIALIZERS = [];
function $4bbe032af5ef296a$var$modulesReady(moduleIds) {
    if (typeof __preload_ready__ !== "object") return false;
    return moduleIds.every((moduleId)=>{
        return typeof moduleId !== "undefined" && typeof __preload_ready__[moduleId] !== "undefined";
    });
}
function $4bbe032af5ef296a$var$load(loader) {
    const promise = loader();
    const state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function $4bbe032af5ef296a$var$loadMap(obj) {
    const state = {
        loading: false,
        loaded: {},
        error: null
    };
    const promises = [];
    try {
        Object.keys(obj).forEach((key)=>{
            const result = $4bbe032af5ef296a$var$load(obj[key]);
            if (!result.loading) {
                state.loaded[key] = result.loaded;
                state.error = result.error;
            } else state.loading = true;
            promises.push(result.promise);
            result.promise.then((res)=>{
                state.loaded[key] = res;
            }).catch((err)=>{
                state.error = err;
            });
        });
    } catch (err) {
        state.error = err;
    }
    state.promise = Promise.all(promises).then((res)=>{
        state.loading = false;
        return res;
    }).catch((err)=>{
        state.loading = false;
        throw err;
    });
    return state;
}
function $4bbe032af5ef296a$var$resolveModule(obj) {
    // eslint-disable-next-line no-underscore-dangle
    return obj && obj.__esModule ? obj.default : obj;
}
function $4bbe032af5ef296a$var$render(loaded, props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($4bbe032af5ef296a$var$resolveModule(loaded), props);
}
function $4bbe032af5ef296a$var$createLoadableComponent(loadFn, options) {
    var _class;
    if (!options.loading) throw new Error("react-loadable requires a `loading` component");
    const opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        render: $4bbe032af5ef296a$var$render,
        webpack: null,
        modules: null
    }, options);
    let res = null;
    function init() {
        if (!res) res = loadFn(opts.loader);
        return res.promise;
    }
    $4bbe032af5ef296a$var$ALL_INITIALIZERS.push(init);
    if (Array.isArray(opts.modules)) // eslint-disable-next-line consistent-return
    $4bbe032af5ef296a$var$READY_INITIALIZERS.push(()=>{
        /**
       * SSR specific override.
       *
       * We always want to `init` for server side rendered
       * pages as the bundles will have been prefetched.
       *
       * If the page has not been SSRed, then we fallback to just loading the module manually.
       */ if ($4bbe032af5ef296a$var$modulesReady(opts.modules)) return init();
    });
    // TODO: Replace usage of unsafe lifecycle methods
    // eslint-disable-next-line react/no-unsafe
    return _class = class LoadableComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component {
        /* eslint react/sort-comp: warn */ static preload() {
            return init();
        }
        constructor(props){
            super(props);
            this._mounted = void 0;
            this._delay = void 0;
            this._timeout = void 0;
            this.retry = ()=>{
                this.setState({
                    error: null,
                    loading: true,
                    timedOut: false
                });
                res = loadFn(opts.loader);
                this._loadModule();
            };
            init();
            this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: false,
                loading: res.loading,
                loaded: res.loaded
            };
        }
        /* eslint react/no-unsafe: warn */ UNSAFE_componentWillMount() {
            this._mounted = true;
            this._loadModule();
        }
        componentWillUnmount() {
            this._mounted = false;
            this._clearTimeouts();
        }
        _loadModule() {
            if (this.context.loadable && Array.isArray(opts.modules)) // @ts-ignore
            opts.modules.forEach((moduleName)=>{
                this.context.loadable.report(moduleName);
            });
            if (!res.loading) return;
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) this.setState({
                    pastDelay: true
                });
                else this._delay = setTimeout(()=>{
                    this.setState({
                        pastDelay: true
                    });
                }, opts.delay);
            }
            if (typeof opts.timeout === "number") this._timeout = setTimeout(()=>{
                this.setState({
                    timedOut: true
                });
            // @ts-ignore
            }, opts.timeout);
            const update = ()=>{
                if (!this._mounted) return;
                this.setState({
                    error: res.error,
                    loaded: res.loaded,
                    loading: res.loading
                });
                this._clearTimeouts();
            };
            res.promise.then(()=>{
                update();
            }).catch((_err)=>{
                update();
            });
        }
        _clearTimeouts() {
            clearTimeout(this._delay);
            clearTimeout(this._timeout);
        }
        render() {
            if (this.state.loading || this.state.error) return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dQqAn.default), // register Loadable loading state as a UFO Hold
            {
                name: "loadable-hold"
            }, (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(opts.loading, {
                isLoading: this.state.loading,
                pastDelay: this.state.pastDelay,
                timedOut: this.state.timedOut,
                error: this.state.error,
                retry: this.retry
            }));
            else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
            else return null;
        }
    }, _class.contextTypes = {
        loadable: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).shape({
            report: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func.isRequired
        })
    }, _class;
}
// react-loadable, unlike React.lazy, checks for an `__esModule` property on
// the exports object when determining whether to use the default export,
// falling back to using the entire exports object. Always prefer the default
// export if it's available, falling back to the entire exports object for
// compatibility.
function $4bbe032af5ef296a$var$Loadable(opts) {
    return $4bbe032af5ef296a$var$createLoadableComponent($4bbe032af5ef296a$var$load, {
        ...opts,
        render: opts.render != null ? opts.render : (loaded, props)=>(0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(// Always prefer a default property from an ESM, falling back for
            // compatibility.
            Object.prototype.hasOwnProperty.call(loaded, "default") ? loaded.default : loaded, props)
    });
}
function $4bbe032af5ef296a$var$LoadableMap(opts) {
    if (typeof opts.render !== "function") throw new Error("LoadableMap requires a `render(loaded, props)` function");
    return $4bbe032af5ef296a$var$createLoadableComponent($4bbe032af5ef296a$var$loadMap, opts);
}
$4bbe032af5ef296a$var$Loadable.Map = $4bbe032af5ef296a$var$LoadableMap;
class $4bbe032af5ef296a$var$Capture extends (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component {
    getChildContext() {
        return {
            loadable: {
                report: this.props.report
            }
        };
    }
    render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Children.only(this.props.children);
    }
}
$4bbe032af5ef296a$var$Capture.propTypes = {
    report: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func.isRequired
};
$4bbe032af5ef296a$var$Capture.childContextTypes = {
    loadable: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).shape({
        report: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func.isRequired
    }).isRequired
};
$4bbe032af5ef296a$var$Loadable.Capture = $4bbe032af5ef296a$var$Capture;
function $4bbe032af5ef296a$var$flushInitializers(initializers) {
    const promises = [];
    while(initializers.length){
        const init = initializers.pop();
        promises.push(init());
    }
    // eslint-disable-next-line consistent-return
    return Promise.all(promises).then(()=>{
        if (initializers.length) return $4bbe032af5ef296a$var$flushInitializers(initializers);
    });
}
$4bbe032af5ef296a$var$Loadable.preloadAll = ()=>{
    return new Promise((resolve, reject)=>{
        $4bbe032af5ef296a$var$flushInitializers($4bbe032af5ef296a$var$ALL_INITIALIZERS).then(resolve, reject);
    });
};
$4bbe032af5ef296a$var$Loadable.preloadReady = ()=>{
    return new Promise((resolve, _reject)=>{
        // We always will resolve, errors should be handled within loading UIs.
        $4bbe032af5ef296a$var$flushInitializers($4bbe032af5ef296a$var$READY_INITIALIZERS).then(resolve, resolve);
    });
};
module.exports = $4bbe032af5ef296a$var$Loadable;

});
parcelRegister("dQqAn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $a144c10a187d4751$export$2e2bcd8739ae039; });

var $g6V4s = parcelRequire("g6V4s");
var $a144c10a187d4751$export$2e2bcd8739ae039 = (0, $g6V4s.default);

});
parcelRegister("g6V4s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bba979f6817e660c$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $59ZFR = parcelRequire("59ZFR");

var $aMGnY = parcelRequire("aMGnY");
function $bba979f6817e660c$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, name = _ref.name, _ref$hold = _ref.hold, hold = _ref$hold === void 0 ? true : _ref$hold;
    // react-18: useId instead
    var context = (0, $9nHZC.useContext)((0, $59ZFR.default));
    (0, $aMGnY.default)(function() {
        if (hold && context != null) return context.hold(name);
    }, [
        hold,
        context,
        name
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, children) : null;
}

});
parcelRegister("59ZFR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c1da235399d37df$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "useInteractionContext", function () { return $3c1da235399d37df$export$11bcb6e9af2aca35; });

var $9nHZC = parcelRequire("9nHZC");

var $5fUc4 = parcelRequire("5fUc4");
var $3c1da235399d37df$export$2e2bcd8739ae039 = (0, $5fUc4.default);
function $3c1da235399d37df$export$11bcb6e9af2aca35() {
    return (0, $9nHZC.useContext)((0, $5fUc4.default));
}

});
parcelRegister("5fUc4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d39f159263e3d97$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");
var $3d39f159263e3d97$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $9nHZC.createContext)(null);

});


parcelRegister("aMGnY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d9f43ff8d568e9d$export$2e2bcd8739ae039; });
// code-reaper-ignore-file -- Uses `useLayoutEffect` in the browser and `useEffect` in the server.

var $9nHZC = parcelRequire("9nHZC");
var $7d9f43ff8d568e9d$export$2e2bcd8739ae039 = (0, $9nHZC.useLayoutEffect);

});




parcelRegister("hw8PW", function(module, exports) {

$parcel$export(module.exports, "FeatureProvider", function () { return $1087ce300e1debcd$export$98541361bc463108; });
$parcel$export(module.exports, "useFeature", function () { return $1087ce300e1debcd$export$fc97652867e5867e; });
$parcel$export(module.exports, "getUserIdentifier", function () { return $1087ce300e1debcd$export$a2477cf492c4a319; });
$parcel$export(module.exports, "withFeature", function () { return $1087ce300e1debcd$export$6ab931c565f2d9ac; });
$parcel$export(module.exports, "EnvironmentType", function () { return (parcelRequire("bwg5y")).EnvironmentType; });
$parcel$export(module.exports, "StatsigFeatureKeys", function () { return (parcelRequire("7JtYi")).StatsigFeatureKeys; });
$parcel$export(module.exports, "FeatureKeys", function () { return (parcelRequire("7JtYi")).FeatureKeys; });
$parcel$export(module.exports, "getGlobalFeatureFlagClient", function () { return (parcelRequire("l9p9x")).getGlobalFeatureFlagClient; });
$parcel$export(module.exports, "getFlagValue", function () { return (parcelRequire("l9p9x")).getFlagValue; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $bwg5y = parcelRequire("bwg5y");

var $l9p9x = parcelRequire("l9p9x");

var $7JtYi = parcelRequire("7JtYi");
const $1087ce300e1debcd$var$IS_SERVER = undefined;
const $1087ce300e1debcd$var$useClient = ({ apiKey: apiKey, analyticsWebClient: analyticsWebClient, featureFlagUser: featureFlagUser, options: options })=>{
    const getFeatureFlagClient = (0, $9nHZC.useCallback)(()=>{
        let newClient;
        // This feature flag client can't be used on the server until the launchdarkly node SDK is added
        if (!$1087ce300e1debcd$var$IS_SERVER && apiKey && analyticsWebClient && featureFlagUser) newClient = (0, $l9p9x.getGlobalFeatureFlagClient)({
            apiKey: apiKey,
            analyticsWebClient: analyticsWebClient,
            featureFlagUser: featureFlagUser,
            options: options
        });
        return newClient;
    }, [
        apiKey,
        analyticsWebClient,
        featureFlagUser,
        options
    ]);
    // We wrap the client to give us an immutable object to pass to the
    // context provider. This allows us to create a new object when the client
    // is updated so consumers know that they need to re-render.
    const [currentClient, setCurrentClient] = (0, $9nHZC.useState)(()=>{
        return {
            client: getFeatureFlagClient() || null
        };
    });
    (0, $9nHZC.useEffect)(()=>{
        if (!currentClient.client) {
            // if we don't have a client for any reason, try to
            // create one when the client arguments change
            const newClient = getFeatureFlagClient() || null;
            if (newClient !== currentClient.client) setCurrentClient({
                client: newClient
            });
        }
    }, [
        analyticsWebClient,
        apiKey,
        currentClient,
        getFeatureFlagClient,
        options,
        setCurrentClient,
        featureFlagUser
    ]);
    (0, $9nHZC.useEffect)(()=>{
        // handle featureFlagUser updates
        if (currentClient && currentClient.client && featureFlagUser) currentClient.client.updateFeatureFlagUser(featureFlagUser);
    }, [
        featureFlagUser,
        currentClient
    ]);
    return currentClient;
};
const $1087ce300e1debcd$export$af2dba9de05062d6 = /*#__PURE__*/ (0, $9nHZC.createContext)({
    client: null
});
const $1087ce300e1debcd$export$98541361bc463108 = ({ apiKey: apiKey, analyticsWebClient: analyticsWebClient, featureFlagUser: featureFlagUser, options: options, children: children })=>{
    const client = $1087ce300e1debcd$var$useClient({
        apiKey: apiKey,
        analyticsWebClient: analyticsWebClient,
        featureFlagUser: featureFlagUser,
        options: options
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($1087ce300e1debcd$export$af2dba9de05062d6.Provider, {
        value: client
    }, children);
};
const $1087ce300e1debcd$export$fc97652867e5867e = (key, defaultValue = false, options)=>{
    const clientWrapper = (0, $9nHZC.useContext)($1087ce300e1debcd$export$af2dba9de05062d6);
    const { client: client } = clientWrapper;
    const [flagValue, setFlagValue] = (0, $9nHZC.useState)(()=>{
        // if we have a client, get the value before falling back to the defaultValue
        return client ? client.getFlagValue(key, defaultValue, options) : defaultValue;
    });
    (0, $9nHZC.useEffect)(()=>{
        if (client) // subscribe to updates of the flag
        return client.on(key, defaultValue, setFlagValue, options);
        return ()=>{};
    }, [
        client,
        clientWrapper,
        defaultValue,
        key,
        options
    ]);
    return flagValue;
};
const $1087ce300e1debcd$var$getFeatureName = (featureKey)=>Object.keys((0, $7JtYi.FeatureKeys)).filter((key)=>(0, $7JtYi.FeatureKeys)[key] === featureKey)[0];
function $1087ce300e1debcd$var$isPropWithFeatures(props) {
    return !!props.features;
}
const $1087ce300e1debcd$var$getFeatureGroups = (userSettings)=>{
    const groups = [];
    if (userSettings.isAtlassian) groups.push("atlassian-staff");
    if (userSettings.isBitbucket) groups.push("bitbucket-team");
    return groups;
};
const $1087ce300e1debcd$export$a2477cf492c4a319 = (userSettings)=>{
    if (!(userSettings !== null && userSettings !== void 0 && userSettings.aaid)) return {
        isAnonymous: true
    };
    return {
        identifier: {
            type: (0, $bwg5y.Identifiers).ATLASSIAN_ACCOUNT_ID,
            value: userSettings.aaid
        },
        isAnonymous: false,
        custom: {
            feature_groups: $1087ce300e1debcd$var$getFeatureGroups(userSettings),
            atlassian_staff: !!userSettings.isAtlassian,
            bitbucket_team: !!userSettings.isBitbucket,
            workspace_uuid: userSettings.workspaceUuid,
            project_uuid: userSettings.projectUuid,
            repository_uuid: userSettings.repositoryUuid
        }
    };
};
const $1087ce300e1debcd$export$6ab931c565f2d9ac = (key, defaultValue, options)=>(WrappedComponent)=>{
        return (props)=>{
            const name = $1087ce300e1debcd$var$getFeatureName(key);
            const flagValue = $1087ce300e1debcd$export$fc97652867e5867e(key, defaultValue, options);
            const featureProp = (0, $9nHZC.useMemo)(()=>{
                return $1087ce300e1debcd$var$isPropWithFeatures(props) ? {
                    ...props.features,
                    [name]: flagValue
                } : {
                    [name]: flagValue
                };
            }, [
                name,
                flagValue,
                props
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
                features: featureProp
            }));
        };
    };

});
parcelRegister("fPPqr", function(module, exports) {
function $b87382764b1827b4$var$_extends() {
    return module.exports = $b87382764b1827b4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $b87382764b1827b4$var$_extends.apply(null, arguments);
}
module.exports = $b87382764b1827b4$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bwg5y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l5MLt = parcelRequire("l5MLt");

$l5MLt.__exportStar((parcelRequire("aD4zw")), module.exports);

var $j4Q8z = parcelRequire("j4Q8z");
module.exports.default = $j4Q8z.default;

});
parcelRegister("aD4zw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7bd117ceb00bee16$var$Identifiers;
(function(Identifiers) {
    Identifiers["ANALYTICS_ANONYMOUS_ID"] = "analyticsAnonymousId";
    Identifiers["ATLASSIAN_ACCOUNT_ID"] = "atlassianAccountId";
    Identifiers["TENANT_ID"] = "tenantId";
    Identifiers["TRELLO_ANONYMOUS_ID"] = "trelloAnonymousUserId";
    Identifiers["TRELLO_USER_ID"] = "trelloUserId";
    Identifiers["FF_CLIENT_ANONYMOUS_ID"] = "ffClientAnonymousId";
})($7bd117ceb00bee16$var$Identifiers = module.exports.Identifiers || (module.exports.Identifiers = {}));
/**
 * Reasons from a FeatureFlag evaluation to explain the value provided.
 *
 * By default it uses 'OFF' = 0, which consider 0 in EvaluationReason and '0' in EvaluationReason
 * are valid EvaluationReason value
 * We set the enum value to string thus it can perform proper 'reason in EvaluationReason' check
 *
 */ var $7bd117ceb00bee16$var$EvaluationReason;
(function(EvaluationReason) {
    EvaluationReason["OFF"] = "OFF";
    EvaluationReason["FALLTHROUGH"] = "FALLTHROUGH";
    EvaluationReason["RULE_MATCH"] = "RULE_MATCH";
    EvaluationReason["TARGET_MATCH"] = "TARGET_MATCH";
    EvaluationReason["PREREQUISITE_FAILED"] = "PREREQUISITE_FAILED";
    EvaluationReason["ERROR"] = "ERROR";
    EvaluationReason["INELIGIBLE"] = "INELIGIBLE";
    EvaluationReason["OVERRIDE"] = "OVERRIDE";
})($7bd117ceb00bee16$var$EvaluationReason = module.exports.EvaluationReason || (module.exports.EvaluationReason = {}));
/**
 * The error kind when there is a problem evaluating a FeatureFlag
 */ var $7bd117ceb00bee16$var$EvaluationErrorKind;
(function(EvaluationErrorKind) {
    EvaluationErrorKind["CLIENT_NOT_READY"] = "CLIENT_NOT_READY";
    EvaluationErrorKind["FLAG_NOT_FOUND"] = "FLAG_NOT_FOUND";
    EvaluationErrorKind["WRONG_TYPE"] = "WRONG_TYPE";
    EvaluationErrorKind["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    EvaluationErrorKind["SERVER_ERROR"] = "SERVER_ERROR";
    EvaluationErrorKind["OTHER"] = "OTHER";
})($7bd117ceb00bee16$var$EvaluationErrorKind = module.exports.EvaluationErrorKind || (module.exports.EvaluationErrorKind = {}));
var $7bd117ceb00bee16$var$EnvironmentType;
(function(EnvironmentType) {
    EnvironmentType["LOCAL"] = "local";
    EnvironmentType["DEV"] = "dev";
    EnvironmentType["STAGING"] = "staging";
    EnvironmentType["PROD"] = "prod";
})($7bd117ceb00bee16$var$EnvironmentType = module.exports.EnvironmentType || (module.exports.EnvironmentType = {}));

});

parcelRegister("j4Q8z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l5MLt = parcelRequire("l5MLt");

var $de36d564edbbb7a5$var$core_1 = $l5MLt.__importDefault((parcelRequire("jzNeI")));
var $de36d564edbbb7a5$var$FeatureFlagClient = /** @class */ function() {
    function FeatureFlagClient(apiKey, analyticsWebClient, featureFlagUser, options) {
        this.client = new $de36d564edbbb7a5$var$core_1.default(apiKey, analyticsWebClient, featureFlagUser, options);
    }
    FeatureFlagClient.prototype.ready = function() {
        return this.client.ready();
    };
    FeatureFlagClient.prototype.getFlagValue = function(flagKey, defaultValue, options) {
        return this.client.getFlagValue(flagKey, defaultValue, options);
    };
    FeatureFlagClient.prototype.getFlagDetails = function(flagKey, defaultValue, options) {
        return this.client.getFlagDetails(flagKey, defaultValue, options);
    };
    FeatureFlagClient.prototype.getFlags = function() {
        return this.client.getFlags();
    };
    FeatureFlagClient.prototype.on = function(flagKey, defaultValue, callback, options) {
        return this.client.on(flagKey, defaultValue, callback, options);
    };
    FeatureFlagClient.prototype.onAnyFlagUpdated = function(callback) {
        return this.client.onAnyFlagUpdated(callback);
    };
    FeatureFlagClient.prototype.updateFeatureFlagUser = function(featureFlagUser) {
        return this.client.updateFeatureFlagUser(featureFlagUser);
    };
    FeatureFlagClient.prototype.destroy = function() {
        this.client.destroy();
    };
    return FeatureFlagClient;
}();
module.exports.default = $de36d564edbbb7a5$var$FeatureFlagClient;

});
parcelRegister("jzNeI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cAWPc = parcelRequire("cAWPc");
module.exports.default = $cAWPc.default;

});
parcelRegister("cAWPc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l5MLt = parcelRequire("l5MLt");

var $92b67a3724908575$var$fast_json_stable_stringify_1 = $l5MLt.__importDefault((parcelRequire("d5Zp7")));

var $92b67a3724908575$var$Refresh_1 = $l5MLt.__importDefault((parcelRequire("kG7mU")));

var $92b67a3724908575$var$storage_1 = $l5MLt.__importDefault((parcelRequire("N8ydp")));

var $92b67a3724908575$var$exposureEvents_1 = $l5MLt.__importDefault((parcelRequire("1RIXj")));

var $80R0U = parcelRequire("80R0U");

var $92b67a3724908575$var$subscriptions_1 = $l5MLt.__importStar((parcelRequire("4EZqT")));

var $92b67a3724908575$var$Anonymous_1 = $l5MLt.__importDefault((parcelRequire("do9aj")));

var $92b67a3724908575$var$Ready_1 = $l5MLt.__importDefault((parcelRequire("7rKP9")));

var $92b67a3724908575$var$clone_object_1 = $l5MLt.__importDefault((parcelRequire("lUBQn")));
var $92b67a3724908575$var$Client = /** @class */ function() {
    function Client(apiKey, analyticsWebClient, originalFeatureFlagUser, options) {
        $80R0U.validateConstructorArgs(apiKey, analyticsWebClient, originalFeatureFlagUser, options);
        var featureFlagUser = $92b67a3724908575$var$clone_object_1.default(originalFeatureFlagUser);
        var user = $92b67a3724908575$var$Anonymous_1.default.processAnonymousUser(featureFlagUser);
        this.featureFlagUpdateBroadcastHandler = this.featureFlagUpdateBroadcastHandler.bind(this);
        this.featureFlagUpdateHttpHandler = this.featureFlagUpdateHttpHandler.bind(this);
        this.featureFlagUpdateFailedHandler = this.featureFlagUpdateFailedHandler.bind(this);
        this.readyResolver = new $92b67a3724908575$var$Ready_1.default();
        this.exposureEvents = new $92b67a3724908575$var$exposureEvents_1.default(analyticsWebClient);
        this.storage = new $92b67a3724908575$var$storage_1.default(options.environment, options.productKey, user);
        this.storage.purgeStaleFlagState();
        this.broadcast = new $92b67a3724908575$var$subscriptions_1.Broadcast(apiKey, user, this.featureFlagUpdateBroadcastHandler);
        this.restoreFlagStateFromStorage();
        this.userData = user;
        this.refresh = new $92b67a3724908575$var$Refresh_1.default(apiKey, options.environment, this.userData, this.featureFlagUpdateHttpHandler, {
            interval: options.pollingInterval
        }, this.dataVersion, this.lastUpdatedTimestamp, this.featureFlagUpdateFailedHandler);
        this.refresh.start();
        this.subscriptions = new $92b67a3724908575$var$subscriptions_1.default();
    }
    Client.prototype.ready = function() {
        return this.readyResolver.getPromise();
    };
    Client.prototype.getFlagValue = function(flagKey, defaultValue, options) {
        var validatedFlag = this.getFlagDetails(flagKey, defaultValue, options);
        return validatedFlag.value;
    };
    Client.prototype.getFlagDetails = function(flagKey, defaultValue, options) {
        var _a;
        $80R0U.validateDefaultValue(defaultValue);
        var flag = this.flags[flagKey];
        var validatedFlag = $80R0U.validateFlag(flag, defaultValue, this.refresh.getStatus(), options);
        if ((_a = options) === null || _a === void 0 ? void 0 : _a.shouldSendExposureEvent) this.exposureEvents.sendExposureEvent(flagKey, validatedFlag.value, validatedFlag.evaluationDetail, options.exposureData);
        return validatedFlag;
    };
    Client.prototype.getFlags = function() {
        return $92b67a3724908575$var$clone_object_1.default(this.flags);
    };
    Client.prototype.on = function(flagKey, defaultValue, callback, options) {
        $80R0U.validateDefaultValue(defaultValue);
        return this.subscriptions.on(flagKey, defaultValue, callback, this.getFlagValue.bind(this), options);
    };
    Client.prototype.onAnyFlagUpdated = function(callback) {
        return this.subscriptions.onAnyFlagUpdated(callback);
    };
    Client.prototype.updateFeatureFlagUser = function(originalFeatureFlagUser) {
        var _a, _b;
        if (!originalFeatureFlagUser) throw new Error("featureFlagUser is missing");
        var featureFlagUser = $92b67a3724908575$var$clone_object_1.default(originalFeatureFlagUser);
        var user = $92b67a3724908575$var$Anonymous_1.default.processAnonymousUser(featureFlagUser);
        if ($92b67a3724908575$var$fast_json_stable_stringify_1.default(this.userData) === $92b67a3724908575$var$fast_json_stable_stringify_1.default(user)) return this.ready();
        this.readyResolver.reset();
        this.userData = user;
        this.storage.updateUserContext(user);
        var storedData = this.storage.getFlagsState();
        if (storedData) {
            var changedFlagKeys = this.updateInMemoryFlags($80R0U.flagStateToFlagUpdate(this.flags, storedData));
            this.sendSubscriptionUpdates(changedFlagKeys);
            this.readyResolver.triggerReady();
        }
        this.lastUpdatedTimestamp = ((_a = storedData) === null || _a === void 0 ? void 0 : _a.timestamp) || 0;
        this.dataVersion = (_b = storedData) === null || _b === void 0 ? void 0 : _b.version;
        this.refresh.stop();
        this.refresh.updateUserContext(user, this.dataVersion, this.lastUpdatedTimestamp);
        this.refresh.start();
        this.broadcast.updateUserContext(user);
        return this.ready();
    };
    Client.prototype.addFlag = function(flagKey, flag) {
        this.flags[flagKey] = flag;
    };
    // Convenience API, not official
    Client.prototype.destroy = function() {
        this.refresh.stop();
        this.subscriptions.stop();
        this.broadcast.stop();
        this.readyResolver.triggerReady();
    };
    Client.prototype.restoreFlagStateFromStorage = function() {
        var _a, _b, _c;
        var storedData = this.storage.getFlagsState();
        this.flags = ((_a = storedData) === null || _a === void 0 ? void 0 : _a.flags) || {};
        this.lastUpdatedTimestamp = ((_b = storedData) === null || _b === void 0 ? void 0 : _b.timestamp) || 0;
        this.dataVersion = (_c = storedData) === null || _c === void 0 ? void 0 : _c.version;
        if (storedData !== null && storedData !== undefined) this.readyResolver.triggerReady();
    };
    Client.prototype.getCurrentFeatureFlagState = function() {
        return {
            timestamp: this.lastUpdatedTimestamp,
            version: this.dataVersion,
            flags: this.flags
        };
    };
    Client.prototype.featureFlagUpdateFailedHandler = function() {
        this.readyResolver.triggerReady();
    };
    Client.prototype.featureFlagUpdateHttpHandler = function(update) {
        this.processFeatureFlagUpdate(update);
        // broadcast the flag state to other tabs
        this.broadcast.sendFeatureFlagState(this.getCurrentFeatureFlagState());
    };
    Client.prototype.featureFlagUpdateBroadcastHandler = function(featureFlagState) {
        // return if broadcasted ff state is stale
        if (featureFlagState.timestamp < this.lastUpdatedTimestamp) return;
        this.processFeatureFlagUpdate($80R0U.flagStateToFlagUpdate(this.flags, featureFlagState));
    };
    Client.prototype.processFeatureFlagUpdate = function(update) {
        this.lastUpdatedTimestamp = Date.now();
        this.dataVersion = update.versionData || this.dataVersion;
        var changedFlagKeys = this.updateInMemoryFlags(update);
        this.sendSubscriptionUpdates(changedFlagKeys);
        this.refresh.setVersionAndTimestamp(this.dataVersion, this.lastUpdatedTimestamp);
        this.storage.setFlagsState(this.getCurrentFeatureFlagState());
        this.readyResolver.triggerReady();
    };
    Client.prototype.updateInMemoryFlags = function(update) {
        var _this = this;
        var _a;
        var changedFlags = [];
        (_a = update.deletedFlags) === null || _a === void 0 || _a.forEach(function(flagKey) {
            if (flagKey in _this.flags) {
                delete _this.flags[flagKey];
                changedFlags.push(flagKey);
            }
        });
        Object.keys(update.flags).forEach(function(flagKey) {
            if ($80R0U.hasFlagValueChanged(_this.flags[flagKey], update.flags[flagKey])) changedFlags.push(flagKey);
            _this.flags[flagKey] = update.flags[flagKey];
        });
        return changedFlags;
    };
    Client.prototype.sendSubscriptionUpdates = function(changedFlagKeys) {
        var _this = this;
        if (changedFlagKeys.length > 0) {
            this.subscriptions.anyFlagUpdated();
            changedFlagKeys.forEach(function(flagKey) {
                return _this.subscriptions.flagValueUpdated(flagKey);
            });
        }
    };
    return Client;
}();
module.exports.default = $92b67a3724908575$var$Client;

});
parcelRegister("d5Zp7", function(module, exports) {
"use strict";
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === "function") opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === "boolean" ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === "function") node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == "number") return isFinite(node) ? "" + node : "null";
        if (typeof node !== "object") return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = "[";
            for(i = 0; i < node.length; i++){
                if (i) out += ",";
                out += stringify(node[i]) || "null";
            }
            return out + "]";
        }
        if (node === null) return "null";
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify("__cycle__");
            throw new TypeError("Converting circular structure to JSON");
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = "";
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ",";
            out += JSON.stringify(key) + ":" + value;
        }
        seen.splice(seenIndex, 1);
        return "{" + out + "}";
    }(data);
};

});

parcelRegister("kG7mU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l5MLt = parcelRequire("l5MLt");

var $f0dd7220d0305799$var$fast_json_stable_stringify_1 = $l5MLt.__importDefault((parcelRequire("d5Zp7")));

var $kbJV3 = parcelRequire("kbJV3");

var $f0dd7220d0305799$var$fetcher_1 = $l5MLt.__importDefault((parcelRequire("kWlpm")));

var $lfSfy = parcelRequire("lfSfy");

var $f0dd7220d0305799$var$MetadataManager_1 = $l5MLt.__importDefault((parcelRequire("dtLgs")));

var $9f6OI = parcelRequire("9f6OI");

var $80R0U = parcelRequire("80R0U");
module.exports.SCHEDULER_OPTIONS_DEFAULT = {
    minWaitInterval: 300000,
    maxWaitInterval: 1200000,
    backOffFactor: 2,
    backOffJitter: 0.1,
    interval: 300000,
    maxInstantRetryTimes: 0
};
module.exports.NO_CACHE_RETRY_OPTIONS_DEFAULT = $l5MLt.__assign($l5MLt.__assign({}, module.exports.SCHEDULER_OPTIONS_DEFAULT), {
    minWaitInterval: 500,
    interval: 500,
    maxInstantRetryTimes: 1
});
var $f0dd7220d0305799$var$Refresh = /** @class */ function() {
    function Refresh(apiKey, env, user, onFeatureFlagUpdate, pollingConfig, version, lastUpdateTimestamp, onError, noCachePollingConfig) {
        if (lastUpdateTimestamp === void 0) lastUpdateTimestamp = 0;
        if (onError === void 0) onError = function() {};
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        this.failureCount = 0;
        this.user = user;
        this.onFeatureFlagUpdate = onFeatureFlagUpdate;
        this.version = version;
        this.lastUpdateTimestamp = lastUpdateTimestamp;
        this.pollingConfig = {
            minWaitInterval: ((_a = pollingConfig) === null || _a === void 0 ? void 0 : _a.minWaitInterval) || module.exports.SCHEDULER_OPTIONS_DEFAULT.minWaitInterval,
            maxWaitInterval: ((_b = pollingConfig) === null || _b === void 0 ? void 0 : _b.maxWaitInterval) || module.exports.SCHEDULER_OPTIONS_DEFAULT.maxWaitInterval,
            backOffFactor: ((_c = pollingConfig) === null || _c === void 0 ? void 0 : _c.backOffFactor) || module.exports.SCHEDULER_OPTIONS_DEFAULT.backOffFactor,
            backOffJitter: ((_d = pollingConfig) === null || _d === void 0 ? void 0 : _d.backOffJitter) !== undefined ? pollingConfig.backOffJitter : module.exports.SCHEDULER_OPTIONS_DEFAULT.backOffJitter,
            interval: ((_e = pollingConfig) === null || _e === void 0 ? void 0 : _e.interval) || module.exports.SCHEDULER_OPTIONS_DEFAULT.interval,
            maxInstantRetryTimes: 0
        };
        this.noCachePollingConfig = {
            minWaitInterval: ((_f = noCachePollingConfig) === null || _f === void 0 ? void 0 : _f.minWaitInterval) || module.exports.NO_CACHE_RETRY_OPTIONS_DEFAULT.minWaitInterval,
            maxWaitInterval: ((_g = noCachePollingConfig) === null || _g === void 0 ? void 0 : _g.maxWaitInterval) || module.exports.NO_CACHE_RETRY_OPTIONS_DEFAULT.maxWaitInterval,
            backOffFactor: ((_h = noCachePollingConfig) === null || _h === void 0 ? void 0 : _h.backOffFactor) || module.exports.NO_CACHE_RETRY_OPTIONS_DEFAULT.backOffFactor,
            backOffJitter: ((_j = noCachePollingConfig) === null || _j === void 0 ? void 0 : _j.backOffJitter) !== undefined ? noCachePollingConfig.backOffJitter : module.exports.NO_CACHE_RETRY_OPTIONS_DEFAULT.backOffJitter,
            interval: ((_k = noCachePollingConfig) === null || _k === void 0 ? void 0 : _k.interval) || module.exports.NO_CACHE_RETRY_OPTIONS_DEFAULT.interval,
            maxInstantRetryTimes: ((_l = noCachePollingConfig) === null || _l === void 0 ? void 0 : _l.maxInstantRetryTimes) !== undefined ? noCachePollingConfig.maxInstantRetryTimes : module.exports.NO_CACHE_RETRY_OPTIONS_DEFAULT.maxInstantRetryTimes
        };
        this.onError = onError;
        this.fetcher = new $f0dd7220d0305799$var$fetcher_1.default(apiKey, env);
        this.metadataManager = new $f0dd7220d0305799$var$MetadataManager_1.default(this.pollingConfig);
        this.status = $kbJV3.RefreshStatus.INITIALISED;
        this.updateMetadataOnInitialisation();
    }
    // start refresh by fetchAndReschedule
    Refresh.prototype.start = function() {
        this.stop();
        this.fetchAndReschedule();
    };
    // cancel pending schedule
    Refresh.prototype.stop = function() {
        if (this.timerId) {
            window.clearTimeout(this.timerId);
            this.timerId = undefined;
        }
    };
    // update user, with optional version and timestamp
    Refresh.prototype.updateUserContext = function(user, version, lastUpdateTimestamp) {
        if (lastUpdateTimestamp === void 0) lastUpdateTimestamp = 0;
        this.user = user;
        this.version = version;
        this.lastUpdateTimestamp = lastUpdateTimestamp;
        this.failureCount = 0;
        this.updateMetadataOnUserChange();
    };
    // update version and timestamp
    Refresh.prototype.setVersionAndTimestamp = function(version, lastUpdateTimestamp) {
        this.version = version;
        this.lastUpdateTimestamp = lastUpdateTimestamp;
    };
    Refresh.prototype.getStatus = function() {
        return this.status;
    };
    // schedule a fetchAndReschedule
    Refresh.prototype.schedule = function() {
        var _this = this;
        this.timerId = window.setTimeout(function() {
            _this.fetchAndReschedule();
        }, this.calculateInterval());
    };
    // conditional fetch ffs via fetcher, and schedule another fetchAndReschedule unless we have 400/401 from ffs
    Refresh.prototype.fetchAndReschedule = function() {
        var _this = this;
        var fetchedUser = $f0dd7220d0305799$var$fast_json_stable_stringify_1.default(this.user);
        if (this.isFetchRequired()) this.fetcher.fetchFeatureFlags(this.user, this.metadataManager.get(), this.version).then(function(resp) {
            if (fetchedUser === $f0dd7220d0305799$var$fast_json_stable_stringify_1.default(_this.user)) {
                _this.failureCount = 0;
                _this.onFeatureFlagUpdate($80R0U.flagResponseToFlagUpdate(resp));
                _this.schedule();
                _this.status = $kbJV3.RefreshStatus.SUCCESS;
            }
            _this.updateMetadataOnRequestComplete();
        }).catch(function(err) {
            if (err instanceof $9f6OI.ResponseError && (err.status === 400 || err.status === 401)) {
                // no retry needed
                var message = "Feature flag service returned " + err.status + ', "' + err.body + '". This request will not be retried until the user data has been changed.';
                console.error(message);
                _this.onError();
            } else {
                _this.failureCount += 1;
                // Being called after the second attempt as a user with no cache will
                // retry instantly if the first request fails.
                if (_this.failureCount > 1) _this.onError();
                _this.schedule();
            }
            _this.status = $kbJV3.RefreshStatus.ERROR;
            _this.updateMetadataOnRequestComplete();
        });
        else {
            this.schedule();
            this.status = $kbJV3.RefreshStatus.SUCCESS;
        }
    };
    Refresh.prototype.isFetchRequired = function() {
        return Date.now() - this.getPollingConfig().interval >= this.lastUpdateTimestamp;
    };
    Refresh.prototype.updateMetadataOnUserChange = function() {
        // if fetch required, it will be a INITIALIZATION fetch, otherwise it's going to be a delay POLLING fetch
        this.metadataManager.updateClientCauseReason(this.isFetchRequired() ? $lfSfy.ClientCauseReason.INITIALIZATION : $lfSfy.ClientCauseReason.POLLING);
        // always set user state to SWITCHED user for next fetch
        this.metadataManager.updateClientUserState($lfSfy.ClientUserState.SWITCHED);
    };
    Refresh.prototype.updateMetadataOnInitialisation = function() {
        // if fetch required, it will be a INITIALIZATION fetch, otherwise it's going to be a delay POLLING fetch
        this.metadataManager.updateClientCauseReason(this.isFetchRequired() ? $lfSfy.ClientCauseReason.INITIALIZATION : $lfSfy.ClientCauseReason.POLLING);
        // no cache (lastUpdateTimestamp === 0) means we fetch for NEW user, if we have cache we fetch for SAME user
        this.metadataManager.updateClientUserState(this.lastUpdateTimestamp === 0 ? $lfSfy.ClientUserState.NEW : $lfSfy.ClientUserState.SAME);
    };
    Refresh.prototype.updateMetadataOnRequestComplete = function() {
        if (this.failureCount) // when current fetch failed, next fetch will be a RETRY
        // the calling user has not changed
        this.metadataManager.updateClientCauseReason($lfSfy.ClientCauseReason.RETRY);
        else {
            // when current fetch success, next fetch will be a POLLING
            // and the calling user will be SAME user
            this.metadataManager.updateClientCauseReason($lfSfy.ClientCauseReason.POLLING);
            this.metadataManager.updateClientUserState($lfSfy.ClientUserState.SAME);
        }
    };
    // calculate wait interval based on failure count
    Refresh.prototype.calculateInterval = function() {
        var _a = this.getPollingConfig(), interval = _a.interval, minWaitInterval = _a.minWaitInterval, maxWaitInterval = _a.maxWaitInterval, backOffFactor = _a.backOffFactor, backOffJitter = _a.backOffJitter, maxInstantRetryTimes = _a.maxInstantRetryTimes;
        if (maxInstantRetryTimes !== undefined && maxInstantRetryTimes !== 0 && maxInstantRetryTimes >= this.failureCount) return 0;
        if (this.failureCount === 0) return interval;
        var ms = minWaitInterval * Math.pow(backOffFactor, this.failureCount - 1);
        if (backOffJitter) {
            var rand = Math.random();
            var deviation = Math.floor(rand * backOffJitter * ms);
            if (Math.floor(rand * 10) < 5) ms -= deviation;
            else ms += deviation;
        }
        return Number(Math.min(ms, maxWaitInterval));
    };
    Refresh.prototype.getPollingConfig = function() {
        if (this.version === undefined && this.lastUpdateTimestamp === 0) return this.noCachePollingConfig;
        return this.pollingConfig;
    };
    return Refresh;
}();
module.exports.default = $f0dd7220d0305799$var$Refresh;

});
parcelRegister("kbJV3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $eb287454752663e9$var$RefreshStatus;
(function(RefreshStatus) {
    RefreshStatus["INITIALISED"] = "INITIALISED";
    RefreshStatus["SUCCESS"] = "SUCCESS";
    RefreshStatus["ERROR"] = "ERROR";
})($eb287454752663e9$var$RefreshStatus = module.exports.RefreshStatus || (module.exports.RefreshStatus = {}));

});

parcelRegister("kWlpm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hWPGN = parcelRequire("hWPGN");
module.exports.default = $hWPGN.default;

});
parcelRegister("hWPGN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l5MLt = parcelRequire("l5MLt");

var $bwg5y = parcelRequire("bwg5y");

var $9f6OI = parcelRequire("9f6OI");
var $d10ff2dc2d632d8a$var$PROD_BASE_URL = "https://api.atlassian.com/flags";
var $d10ff2dc2d632d8a$var$STAGING_BASE_URL = "https://api.stg.atlassian.com/flags";
var $d10ff2dc2d632d8a$var$DEV_BASE_URL = "https://api.dev.atlassian.com/flags";
var $d10ff2dc2d632d8a$var$Fetcher = /** @class */ function() {
    function Fetcher(apiKey, serviceEnv, baseUrl) {
        if (serviceEnv === void 0) serviceEnv = $bwg5y.EnvironmentType.PROD;
        this.apiKey = apiKey;
        this.baseUrl = Fetcher.buildBaseUrl(serviceEnv, baseUrl);
    }
    Fetcher.prototype.fetchFeatureFlags = function(user, metadata, version) {
        var requestBody = {
            apiKey: this.apiKey,
            identifier: user.identifier,
            isAnonymous: user.isAnonymous,
            additionalIdentifiers: user.additionalIdentifiers,
            customAttributes: user.custom,
            versionData: version,
            metadata: metadata
        };
        return fetch(this.baseUrl + "/api/v1/frontend/featureFlagValues", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Client-Name": metadata.client.name,
                "X-Client-Version": metadata.client.version,
                "X-Api-Key": this.apiKey
            },
            body: JSON.stringify(requestBody)
        }).then(function(response) {
            return Fetcher.handleResponseError(response);
        }).then(function(response) {
            return Fetcher.extractBody(response);
        }).catch(function(error) {
            return Promise.reject(error);
        });
    };
    Fetcher.handleResponseError = function(response) {
        return $l5MLt.__awaiter(this, void 0, void 0, function() {
            var body;
            return $l5MLt.__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!response.ok) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            response.text()
                        ];
                    case 1:
                        body = _a.sent();
                        throw new $9f6OI.ResponseError(response.status, body);
                    case 2:
                        return [
                            2 /*return*/ ,
                            response
                        ];
                }
            });
        });
    };
    Fetcher.extractBody = function(response) {
        return $l5MLt.__awaiter(this, void 0, void 0, function() {
            return $l5MLt.__generator(this, function(_a) {
                if (response.status === 204) return [
                    2 /*return*/ ,
                    {}
                ];
                return [
                    2 /*return*/ ,
                    response.text().then(function(text) {
                        return JSON.parse(text || "{}");
                    })
                ];
            });
        });
    };
    Fetcher.buildBaseUrl = function(serviceEnv, baseUrl) {
        if (baseUrl) return baseUrl;
        if (serviceEnv === $bwg5y.EnvironmentType.DEV || serviceEnv === $bwg5y.EnvironmentType.LOCAL) return $d10ff2dc2d632d8a$var$DEV_BASE_URL;
        if (serviceEnv === $bwg5y.EnvironmentType.STAGING) return $d10ff2dc2d632d8a$var$STAGING_BASE_URL;
        return $d10ff2dc2d632d8a$var$PROD_BASE_URL;
    };
    return Fetcher;
}();
module.exports.default = $d10ff2dc2d632d8a$var$Fetcher;

});
parcelRegister("9f6OI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l5MLt = parcelRequire("l5MLt");
/* eslint-disable no-underscore-dangle */ var $6baacd81712ff738$var$ResponseError = /** @class */ function(_super) {
    $l5MLt.__extends(ResponseError, _super);
    function ResponseError(status, body) {
        var _this = // Extending error requires this workaround, see https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        _super.call(this, "Response Error: " + status) || this;
        Object.setPrototypeOf(_this, ResponseError.prototype);
        _this._status = status;
        _this._body = body;
        return _this;
    }
    Object.defineProperty(ResponseError.prototype, "status", {
        get: function() {
            return this._status;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResponseError.prototype, "body", {
        get: function() {
            return this._body;
        },
        enumerable: true,
        configurable: true
    });
    return ResponseError;
}(Error);
module.exports.ResponseError = $6baacd81712ff738$var$ResponseError;

});



parcelRegister("lfSfy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f7951495d59f0fec$var$ClientVisibilityState;
(function(ClientVisibilityState) {
    ClientVisibilityState["VISIBLE"] = "visible";
    ClientVisibilityState["HIDDEN"] = "hidden";
    ClientVisibilityState["PRERENDER"] = "prerender";
})($f7951495d59f0fec$var$ClientVisibilityState = module.exports.ClientVisibilityState || (module.exports.ClientVisibilityState = {}));
var $f7951495d59f0fec$var$ClientCauseReason;
(function(ClientCauseReason) {
    ClientCauseReason["INITIALIZATION"] = "initialization";
    ClientCauseReason["POLLING"] = "polling";
    ClientCauseReason["RETRY"] = "retry";
})($f7951495d59f0fec$var$ClientCauseReason = module.exports.ClientCauseReason || (module.exports.ClientCauseReason = {}));
var $f7951495d59f0fec$var$ClientStorageState;
(function(ClientStorageState) {
    ClientStorageState["AVAILABLE"] = "available";
    ClientStorageState["NOT_AVAILABLE"] = "notAvailable";
    ClientStorageState["FULL"] = "full";
    ClientStorageState["ERRORED"] = "errored";
})($f7951495d59f0fec$var$ClientStorageState = module.exports.ClientStorageState || (module.exports.ClientStorageState = {}));
var $f7951495d59f0fec$var$ClientUserState;
(function(ClientUserState) {
    ClientUserState["NEW"] = "new";
    ClientUserState["SAME"] = "same";
    ClientUserState["SWITCHED"] = "switched";
})($f7951495d59f0fec$var$ClientUserState = module.exports.ClientUserState || (module.exports.ClientUserState = {}));

});

parcelRegister("dtLgs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l5MLt = parcelRequire("l5MLt");

var $6PgeO = parcelRequire("6PgeO");

var $9d02a5860e33146f$var$storage_1 = $l5MLt.__importDefault((parcelRequire("N8ydp")));
var $9d02a5860e33146f$var$MetadataManager = /** @class */ function() {
    function MetadataManager(pollingConfig) {
        this.pollingSeconds = pollingConfig.interval / 1000;
    }
    MetadataManager.prototype.updateClientCauseReason = function(reason) {
        this.clientCauseReason = reason;
    };
    MetadataManager.prototype.updateClientUserState = function(state) {
        this.clientUserState = state;
    };
    MetadataManager.prototype.get = function() {
        var metadata = {
            client: {
                name: "feature-flag-web-client",
                version: $6PgeO.version
            },
            config: {
                pollingSeconds: this.pollingSeconds
            },
            state: {
                // Need to cast VisibilityState (type) to ClientVisibilityState (enum)
                visibility: document.visibilityState,
                storage: $9d02a5860e33146f$var$storage_1.default.getStorageStatus(),
                userContext: this.clientUserState,
                cause: this.clientCauseReason
            }
        };
        return metadata;
    };
    return MetadataManager;
}();
module.exports.default = $9d02a5860e33146f$var$MetadataManager;

});
parcelRegister("6PgeO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.version = "1.19.1";

});

parcelRegister("N8ydp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dJVWp = parcelRequire("dJVWp");
module.exports.default = $dJVWp.default;

});
parcelRegister("dJVWp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l5MLt = parcelRequire("l5MLt");

var $a00c6c34470db3fd$var$hash_1 = $l5MLt.__importDefault((parcelRequire("aOgOd")));

var $lfSfy = parcelRequire("lfSfy");
module.exports.STORAGE_KEY_PREFIX = "feature-flags-atl";
var $a00c6c34470db3fd$var$STORAGE_KEY_FLAG_STATE_PREFIX = module.exports.STORAGE_KEY_PREFIX + ".flags";
var $a00c6c34470db3fd$var$STORAGE_KEY_ANON_ID = module.exports.STORAGE_KEY_PREFIX + ".anonId";
var $a00c6c34470db3fd$var$STORAGE_KEY_DETECT_SUPPORT = module.exports.STORAGE_KEY_PREFIX + ".storage.support";
var $a00c6c34470db3fd$var$StorageExceedQuota = false;
// Expire after 7 days
module.exports.FLAG_STATE_EXPIRY_PERIOD = 604800000;
var $a00c6c34470db3fd$var$Storage = /** @class */ function() {
    function Storage(env, product, user) {
        this.env = env;
        this.product = product;
        this.generateKey(user);
    }
    Storage.prototype.updateUserContext = function(user) {
        this.generateKey(user);
    };
    Storage.prototype.getFlagsState = function() {
        return Storage.getFlagState(this.key);
    };
    Storage.prototype.setFlagsState = function(data) {
        Storage.setItem(this.key, JSON.stringify(data));
    };
    Storage.prototype.purgeStaleFlagState = function() {
        var _this = this;
        try {
            Object.keys(window.localStorage).filter(function(key) {
                return key.startsWith($a00c6c34470db3fd$var$STORAGE_KEY_FLAG_STATE_PREFIX) && key !== _this.key;
            }).forEach(function(key) {
                var flagState = Storage.getFlagState(key);
                if (flagState && Date.now() - flagState.timestamp >= module.exports.FLAG_STATE_EXPIRY_PERIOD) Storage.removeItem(key);
            });
        } catch (error) {
        // This could fail due to localstorage permissions being restricted, in this case do nothing
        }
    };
    Storage.getFlagState = function(key) {
        var rawData = Storage.getItem(key);
        if (!rawData) return null;
        return JSON.parse(rawData);
    };
    Storage.getAnonymousId = function() {
        return Storage.getItem($a00c6c34470db3fd$var$STORAGE_KEY_ANON_ID);
    };
    Storage.setAnonymousId = function(anonymousId) {
        Storage.setItem($a00c6c34470db3fd$var$STORAGE_KEY_ANON_ID, anonymousId);
    };
    Storage.setItem = function(key, value) {
        try {
            window.localStorage.setItem(key, value);
            $a00c6c34470db3fd$var$StorageExceedQuota = false;
        } catch (error) {
            if (Storage.isQuotaExceeded(error)) $a00c6c34470db3fd$var$StorageExceedQuota = true;
        // This could fail due to localstorage being full or localstorage permissions being restricted.
        // In either case, we do nothing.
        }
    };
    Storage.getItem = function(key) {
        try {
            return window.localStorage.getItem(key);
        } catch (error) {
            // This could fail due to localstorage permissions being restricted, in this case do nothing
            return null;
        }
    };
    Storage.removeItem = function(key) {
        try {
            window.localStorage.removeItem(key);
        } catch (error) {
        // This could fail due to localstorage permissions being restricted, in this case do nothing
        }
    };
    Storage.prototype.generateKey = function(user) {
        this.key = $a00c6c34470db3fd$var$STORAGE_KEY_FLAG_STATE_PREFIX + "." + this.env + "." + this.product + "." + $a00c6c34470db3fd$var$hash_1.default(user);
    };
    Storage.isQuotaExceeded = function(e) {
        // according to https://developer.mozilla.org/en-US/docs/Web/API/DOMException
        // DOMException.code is deprecated API should no longer be used
        if (e instanceof DOMException) switch(e.name){
            case "QUOTA_EXCEEDED_ERR":
                // Safari
                return true;
            case "QuotaExceededError":
                // Chrome
                return true;
            case "NS_ERROR_DOM_QUOTA_REACHED":
                // Firefox
                return true;
            default:
                return false;
        }
        // Internet Explorer 8
        return e.number === -2147024882;
    };
    Storage.getStorageStatus = function() {
        var TEST_VALUE = "test_value";
        try {
            if (!window.localStorage) return $lfSfy.ClientStorageState.NOT_AVAILABLE;
            if ($a00c6c34470db3fd$var$StorageExceedQuota) return $lfSfy.ClientStorageState.FULL;
            window.localStorage.setItem($a00c6c34470db3fd$var$STORAGE_KEY_DETECT_SUPPORT, TEST_VALUE);
            var value = window.localStorage.getItem($a00c6c34470db3fd$var$STORAGE_KEY_DETECT_SUPPORT);
            window.localStorage.removeItem($a00c6c34470db3fd$var$STORAGE_KEY_DETECT_SUPPORT);
            // handle localStorage silently failing
            return value === TEST_VALUE ? $lfSfy.ClientStorageState.AVAILABLE : $lfSfy.ClientStorageState.ERRORED;
        } catch (e) {
            if (Storage.isQuotaExceeded(e)) return $lfSfy.ClientStorageState.FULL;
            // permission issue or localStorage disabled
            return $lfSfy.ClientStorageState.NOT_AVAILABLE;
        }
    };
    return Storage;
}();
module.exports.default = $a00c6c34470db3fd$var$Storage;

});
parcelRegister("aOgOd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l5MLt = parcelRequire("l5MLt");

var $7deb9ccde217d06f$var$fast_json_stable_stringify_1 = $l5MLt.__importDefault((parcelRequire("d5Zp7")));

var $3NNb5 = parcelRequire("3NNb5");
function $7deb9ccde217d06f$var$hashObject(obj) {
    return $3NNb5.Md5.hashStr($7deb9ccde217d06f$var$fast_json_stable_stringify_1.default(obj));
}
module.exports.default = $7deb9ccde217d06f$var$hashObject;

});
parcelRegister("3NNb5", function(module, exports) {
"use strict";
/*

TypeScript Md5
==============

Based on work by
* Joseph Myers: http://www.myersdaily.org/joseph/javascript/md5-text.html
* André Cruz: https://github.com/satazor/SparkMD5
* Raymond Hill: https://github.com/gorhill/yamd5.js

Effectively a TypeScrypt re-write of Raymond Hill JS Library

The MIT License (MIT)

Copyright (C) 2014 Raymond Hill

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.



            DO WHAT THE FUCK YOU WANT TO PUBLIC LICENSE
                    Version 2, December 2004

 Copyright (C) 2015 André Cruz <amdfcruz@gmail.com>

 Everyone is permitted to copy and distribute verbatim or modified
 copies of this license document, and changing it is allowed as long
 as the name is changed.

            DO WHAT THE FUCK YOU WANT TO PUBLIC LICENSE
   TERMS AND CONDITIONS FOR COPYING, DISTRIBUTION AND MODIFICATION

  0. You just DO WHAT THE FUCK YOU WANT TO.


*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2c4c186432800e7e$var$Md5 = /** @class */ function() {
    function Md5() {
        this._state = new Int32Array(4);
        this._buffer = new ArrayBuffer(68);
        this._buffer8 = new Uint8Array(this._buffer, 0, 68);
        this._buffer32 = new Uint32Array(this._buffer, 0, 17);
        this.start();
    }
    // One time hashing functions
    Md5.hashStr = function(str, raw) {
        if (raw === void 0) raw = false;
        return this.onePassHasher.start().appendStr(str).end(raw);
    };
    Md5.hashAsciiStr = function(str, raw) {
        if (raw === void 0) raw = false;
        return this.onePassHasher.start().appendAsciiStr(str).end(raw);
    };
    Md5._hex = function(x) {
        var hc = Md5.hexChars;
        var ho = Md5.hexOut;
        var n;
        var offset;
        var j;
        var i;
        for(i = 0; i < 4; i += 1){
            offset = i * 8;
            n = x[i];
            for(j = 0; j < 8; j += 2){
                ho[offset + 1 + j] = hc.charAt(n & 0x0F);
                n >>>= 4;
                ho[offset + 0 + j] = hc.charAt(n & 0x0F);
                n >>>= 4;
            }
        }
        return ho.join("");
    };
    Md5._md5cycle = function(x, k) {
        var a = x[0];
        var b = x[1];
        var c = x[2];
        var d = x[3];
        // ff()
        a += (b & c | ~b & d) + k[0] - 680876936 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[1] - 389564586 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[2] + 606105819 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[3] - 1044525330 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[4] - 176418897 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[5] + 1200080426 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[6] - 1473231341 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[7] - 45705983 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[8] + 1770035416 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[9] - 1958414417 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[10] - 42063 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[11] - 1990404162 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[12] + 1804603682 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[13] - 40341101 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[14] - 1502002290 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[15] + 1236535329 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        // gg()
        a += (b & d | c & ~d) + k[1] - 165796510 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[6] - 1069501632 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[11] + 643717713 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[0] - 373897302 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[5] - 701558691 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[10] + 38016083 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[15] - 660478335 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[4] - 405537848 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[9] + 568446438 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[14] - 1019803690 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[3] - 187363961 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[8] + 1163531501 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[13] - 1444681467 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[2] - 51403784 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[7] + 1735328473 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[12] - 1926607734 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        // hh()
        a += (b ^ c ^ d) + k[5] - 378558 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[8] - 2022574463 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[11] + 1839030562 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[14] - 35309556 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[1] - 1530992060 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[4] + 1272893353 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[7] - 155497632 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[10] - 1094730640 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[13] + 681279174 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[0] - 358537222 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[3] - 722521979 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[6] + 76029189 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[9] - 640364487 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[12] - 421815835 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[15] + 530742520 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[2] - 995338651 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        // ii()
        a += (c ^ (b | ~d)) + k[0] - 198630844 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[7] + 1126891415 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[14] - 1416354905 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[5] - 57434055 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[12] + 1700485571 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[3] - 1894986606 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[10] - 1051523 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[1] - 2054922799 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[8] + 1873313359 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[15] - 30611744 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[6] - 1560198380 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[13] + 1309151649 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[4] - 145523070 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[11] - 1120210379 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[2] + 718787259 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[9] - 343485551 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        x[0] = a + x[0] | 0;
        x[1] = b + x[1] | 0;
        x[2] = c + x[2] | 0;
        x[3] = d + x[3] | 0;
    };
    Md5.prototype.start = function() {
        this._dataLength = 0;
        this._bufferLength = 0;
        this._state.set(Md5.stateIdentity);
        return this;
    };
    // Char to code point to to array conversion:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/charCodeAt
    // #Example.3A_Fixing_charCodeAt_to_handle_non-Basic-Multilingual-Plane_characters_if_their_presence_earlier_in_the_string_is_unknown
    Md5.prototype.appendStr = function(str) {
        var buf8 = this._buffer8;
        var buf32 = this._buffer32;
        var bufLen = this._bufferLength;
        var code;
        var i;
        for(i = 0; i < str.length; i += 1){
            code = str.charCodeAt(i);
            if (code < 128) buf8[bufLen++] = code;
            else if (code < 0x800) {
                buf8[bufLen++] = (code >>> 6) + 0xC0;
                buf8[bufLen++] = code & 0x3F | 0x80;
            } else if (code < 0xD800 || code > 0xDBFF) {
                buf8[bufLen++] = (code >>> 12) + 0xE0;
                buf8[bufLen++] = code >>> 6 & 0x3F | 0x80;
                buf8[bufLen++] = code & 0x3F | 0x80;
            } else {
                code = (code - 0xD800) * 0x400 + (str.charCodeAt(++i) - 0xDC00) + 0x10000;
                if (code > 0x10FFFF) throw new Error("Unicode standard supports code points up to U+10FFFF");
                buf8[bufLen++] = (code >>> 18) + 0xF0;
                buf8[bufLen++] = code >>> 12 & 0x3F | 0x80;
                buf8[bufLen++] = code >>> 6 & 0x3F | 0x80;
                buf8[bufLen++] = code & 0x3F | 0x80;
            }
            if (bufLen >= 64) {
                this._dataLength += 64;
                Md5._md5cycle(this._state, buf32);
                bufLen -= 64;
                buf32[0] = buf32[16];
            }
        }
        this._bufferLength = bufLen;
        return this;
    };
    Md5.prototype.appendAsciiStr = function(str) {
        var buf8 = this._buffer8;
        var buf32 = this._buffer32;
        var bufLen = this._bufferLength;
        var i;
        var j = 0;
        for(;;){
            i = Math.min(str.length - j, 64 - bufLen);
            while(i--)buf8[bufLen++] = str.charCodeAt(j++);
            if (bufLen < 64) break;
            this._dataLength += 64;
            Md5._md5cycle(this._state, buf32);
            bufLen = 0;
        }
        this._bufferLength = bufLen;
        return this;
    };
    Md5.prototype.appendByteArray = function(input) {
        var buf8 = this._buffer8;
        var buf32 = this._buffer32;
        var bufLen = this._bufferLength;
        var i;
        var j = 0;
        for(;;){
            i = Math.min(input.length - j, 64 - bufLen);
            while(i--)buf8[bufLen++] = input[j++];
            if (bufLen < 64) break;
            this._dataLength += 64;
            Md5._md5cycle(this._state, buf32);
            bufLen = 0;
        }
        this._bufferLength = bufLen;
        return this;
    };
    Md5.prototype.getState = function() {
        var self = this;
        var s = self._state;
        return {
            buffer: String.fromCharCode.apply(null, self._buffer8),
            buflen: self._bufferLength,
            length: self._dataLength,
            state: [
                s[0],
                s[1],
                s[2],
                s[3]
            ]
        };
    };
    Md5.prototype.setState = function(state) {
        var buf = state.buffer;
        var x = state.state;
        var s = this._state;
        var i;
        this._dataLength = state.length;
        this._bufferLength = state.buflen;
        s[0] = x[0];
        s[1] = x[1];
        s[2] = x[2];
        s[3] = x[3];
        for(i = 0; i < buf.length; i += 1)this._buffer8[i] = buf.charCodeAt(i);
    };
    Md5.prototype.end = function(raw) {
        if (raw === void 0) raw = false;
        var bufLen = this._bufferLength;
        var buf8 = this._buffer8;
        var buf32 = this._buffer32;
        var i = (bufLen >> 2) + 1;
        var dataBitsLen;
        this._dataLength += bufLen;
        buf8[bufLen] = 0x80;
        buf8[bufLen + 1] = buf8[bufLen + 2] = buf8[bufLen + 3] = 0;
        buf32.set(Md5.buffer32Identity.subarray(i), i);
        if (bufLen > 55) {
            Md5._md5cycle(this._state, buf32);
            buf32.set(Md5.buffer32Identity);
        }
        // Do the final computation based on the tail and length
        // Beware that the final length may not fit in 32 bits so we take care of that
        dataBitsLen = this._dataLength * 8;
        if (dataBitsLen <= 0xFFFFFFFF) buf32[14] = dataBitsLen;
        else {
            var matches = dataBitsLen.toString(16).match(/(.*?)(.{0,8})$/);
            if (matches === null) return;
            var lo = parseInt(matches[2], 16);
            var hi = parseInt(matches[1], 16) || 0;
            buf32[14] = lo;
            buf32[15] = hi;
        }
        Md5._md5cycle(this._state, buf32);
        return raw ? this._state : Md5._hex(this._state);
    };
    // Private Static Variables
    Md5.stateIdentity = new Int32Array([
        1732584193,
        -271733879,
        -1732584194,
        271733878
    ]);
    Md5.buffer32Identity = new Int32Array([
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ]);
    Md5.hexChars = "0123456789abcdef";
    Md5.hexOut = [];
    // Permanent instance is to use for one-call hashing
    Md5.onePassHasher = new Md5();
    return Md5;
}();
module.exports.Md5 = $2c4c186432800e7e$var$Md5;
if ($2c4c186432800e7e$var$Md5.hashStr("hello") !== "5d41402abc4b2a76b9719d911017c592") console.error("Md5 self test failed.");

});





parcelRegister("80R0U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l5MLt = parcelRequire("l5MLt");

var $5d57723c94520d94$var$fast_json_stable_stringify_1 = $l5MLt.__importDefault((parcelRequire("d5Zp7")));

var $bwg5y = parcelRequire("bwg5y");

var $kbJV3 = parcelRequire("kbJV3");

var $5d57723c94520d94$var$clone_object_1 = $l5MLt.__importDefault((parcelRequire("lUBQn")));
function $5d57723c94520d94$var$featureFlagToRawFlag(featureFlag) {
    var rawFlag = {
        value: featureFlag.value
    };
    if (featureFlag.reason) rawFlag.evaluationDetail = {
        reason: featureFlag.reason,
        ruleId: featureFlag.ruleId
    };
    return rawFlag;
}
module.exports.featureFlagToRawFlag = $5d57723c94520d94$var$featureFlagToRawFlag;
function $5d57723c94520d94$var$flagResponseToFlagUpdate(response) {
    var _a;
    var flags = {};
    (_a = response.featureFlagValues) === null || _a === void 0 || _a.forEach(function(featureFlag) {
        flags[featureFlag.key] = $5d57723c94520d94$var$featureFlagToRawFlag(featureFlag);
    });
    return {
        flags: flags,
        deletedFlags: response.deletedFlags || [],
        versionData: response.versionData
    };
}
module.exports.flagResponseToFlagUpdate = $5d57723c94520d94$var$flagResponseToFlagUpdate;
function $5d57723c94520d94$var$flagStateToFlagUpdate(currentFlags, newFlagState) {
    var _a;
    var newFlags = ((_a = newFlagState) === null || _a === void 0 ? void 0 : _a.flags) || {};
    var deletedFlags = Object.keys(currentFlags).filter(function(flagKey) {
        return newFlags[flagKey] === undefined;
    });
    return {
        flags: newFlags,
        deletedFlags: deletedFlags,
        versionData: newFlagState.version
    };
}
module.exports.flagStateToFlagUpdate = $5d57723c94520d94$var$flagStateToFlagUpdate;
function $5d57723c94520d94$var$hasFlagValueChanged(oldFlag, newFlag) {
    var _a, _b;
    return $5d57723c94520d94$var$fast_json_stable_stringify_1.default((_a = oldFlag) === null || _a === void 0 ? void 0 : _a.value) !== $5d57723c94520d94$var$fast_json_stable_stringify_1.default((_b = newFlag) === null || _b === void 0 ? void 0 : _b.value);
}
module.exports.hasFlagValueChanged = $5d57723c94520d94$var$hasFlagValueChanged;
function $5d57723c94520d94$var$refreshStatusToEvaluationErrorKind(status) {
    switch(status){
        case $kbJV3.RefreshStatus.INITIALISED:
            return $bwg5y.EvaluationErrorKind.CLIENT_NOT_READY;
        case $kbJV3.RefreshStatus.ERROR:
            return $bwg5y.EvaluationErrorKind.SERVER_ERROR;
        case $kbJV3.RefreshStatus.SUCCESS:
            return $bwg5y.EvaluationErrorKind.FLAG_NOT_FOUND;
        default:
            return $bwg5y.EvaluationErrorKind.OTHER;
    }
}
module.exports.refreshStatusToEvaluationErrorKind = $5d57723c94520d94$var$refreshStatusToEvaluationErrorKind;
function $5d57723c94520d94$var$validateFlag(flag, defaultValue, refreshStatus, options) {
    var _a, _b;
    if (!flag) return {
        value: defaultValue,
        evaluationDetail: {
            reason: $bwg5y.EvaluationReason.ERROR,
            errorKind: $5d57723c94520d94$var$refreshStatusToEvaluationErrorKind(refreshStatus)
        }
    };
    if (typeof flag.value !== typeof defaultValue) return {
        value: defaultValue,
        evaluationDetail: {
            reason: $bwg5y.EvaluationReason.ERROR,
            errorKind: $bwg5y.EvaluationErrorKind.WRONG_TYPE
        }
    };
    if (((_b = (_a = options) === null || _a === void 0 ? void 0 : _a.oneOf) === null || _b === void 0 ? void 0 : _b.length) && options.oneOf.indexOf(flag.value) < 0) return {
        value: defaultValue,
        evaluationDetail: {
            reason: $bwg5y.EvaluationReason.ERROR,
            errorKind: $bwg5y.EvaluationErrorKind.VALIDATION_ERROR
        }
    };
    return $5d57723c94520d94$var$clone_object_1.default(flag);
}
module.exports.validateFlag = $5d57723c94520d94$var$validateFlag;
function $5d57723c94520d94$var$isBlank(str) {
    return !str || /^\s*$/.test(str);
}
module.exports.isBlank = $5d57723c94520d94$var$isBlank;
function $5d57723c94520d94$var$isFunction(func) {
    return typeof func === "function";
}
module.exports.isFunction = $5d57723c94520d94$var$isFunction;
function $5d57723c94520d94$var$validateConstructorArgs(apiKey, analyticsWebClient, featureFlagUser, options) {
    var _a, _b, _c;
    if ($5d57723c94520d94$var$isBlank(apiKey)) throw new Error("apiKey is missing");
    if (!$5d57723c94520d94$var$isFunction((_a = analyticsWebClient) === null || _a === void 0 ? void 0 : _a.sendOperationalEvent)) throw new Error("analyticsWebClient.sendOperationalEvent is missing or not a function");
    if (!featureFlagUser) throw new Error("featureFlagUser is missing");
    if ($5d57723c94520d94$var$isBlank((_b = options) === null || _b === void 0 ? void 0 : _b.productKey)) throw new Error("options.productKey is missing");
    if (Object.values($bwg5y.EnvironmentType).indexOf((_c = options) === null || _c === void 0 ? void 0 : _c.environment) === -1) throw new Error("options.environment is missing or invalid");
    if (options.pollingInterval !== undefined && options.pollingInterval !== null) {
        var prodMinInterval = 60000;
        var nonProdMinInterval = 1000;
        if (options.pollingInterval <= prodMinInterval) {
            if (options.environment === $bwg5y.EnvironmentType.PROD) {
                // eslint-disable-next-line no-param-reassign
                options.pollingInterval = prodMinInterval;
                console.warn("options.pollingInterval needs to be greater than " + prodMinInterval);
            } else if (options.pollingInterval <= nonProdMinInterval) throw new Error("options.pollingInterval needs to be greater than " + nonProdMinInterval);
            else console.warn("options.pollingInterval needs to be greater than " + prodMinInterval + " in Production");
        }
    }
}
module.exports.validateConstructorArgs = $5d57723c94520d94$var$validateConstructorArgs;
function $5d57723c94520d94$var$validateDefaultValue(value) {
    if (value === undefined || value === null) throw new Error("defaultValue is missing");
}
module.exports.validateDefaultValue = $5d57723c94520d94$var$validateDefaultValue;
/* eslint-disable no-bitwise */ function $5d57723c94520d94$var$uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(char) {
        var random = Math.random() * 16 | 0;
        var uuid = char === "x" ? random : random & 0x3 | 0x8;
        return uuid.toString(16);
    });
}
module.exports.uuidv4 = $5d57723c94520d94$var$uuidv4; /* eslint-enable no-bitwise */ 

});
parcelRegister("lUBQn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $ff3c2ee92cf50d24$var$cloneObject(obj) {
    var str = JSON.stringify(obj);
    return JSON.parse(str);
}
module.exports.default = $ff3c2ee92cf50d24$var$cloneObject;

});



parcelRegister("1RIXj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7tC2K = parcelRequire("7tC2K");
module.exports.default = $7tC2K.default;

});
parcelRegister("7tC2K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l5MLt = parcelRequire("l5MLt");

var $5718c075f4006984$var$hash_1 = $l5MLt.__importDefault((parcelRequire("aOgOd")));
module.exports.ONE_HOUR = 3600000;
var $5718c075f4006984$var$ExposureEvents = /** @class */ function() {
    function ExposureEvents(analyticsWebClient) {
        this.spamBuster = {};
        this.analyticsWebClient = analyticsWebClient;
    }
    ExposureEvents.prototype.sendExposureEvent = function(flagKey, value, evaluationDetail, exposureData) {
        var _a, _b, _c;
        var attributes = $l5MLt.__assign($l5MLt.__assign({}, exposureData), {
            flagKey: flagKey,
            reason: (_a = evaluationDetail) === null || _a === void 0 ? void 0 : _a.reason,
            ruleId: (_b = evaluationDetail) === null || _b === void 0 ? void 0 : _b.ruleId,
            errorKind: (_c = evaluationDetail) === null || _c === void 0 ? void 0 : _c.errorKind,
            value: value
        });
        if (this.shouldSendEvent(attributes)) this.analyticsWebClient.sendOperationalEvent({
            actionSubject: "feature",
            action: "exposed",
            attributes: attributes,
            tags: [
                "measurement"
            ],
            source: "@atlassiansox/feature-flag-web-client"
        });
    };
    ExposureEvents.prototype.shouldSendEvent = function(attributes) {
        var hash = $5718c075f4006984$var$hash_1.default(attributes);
        if (this.spamBuster[hash] === undefined || this.spamBuster[hash] + module.exports.ONE_HOUR < Date.now()) {
            this.spamBuster[hash] = Date.now();
            return true;
        }
        return false;
    };
    return ExposureEvents;
}();
module.exports.default = $5718c075f4006984$var$ExposureEvents;

});


parcelRegister("4EZqT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eo87G = parcelRequire("eo87G");
module.exports.default = $eo87G.default;

var $enr3o = parcelRequire("enr3o");
module.exports.Broadcast = $enr3o.default;

});
parcelRegister("eo87G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l5MLt = parcelRequire("l5MLt");

var $a7999b9efe967f7d$var$mitt_1 = $l5MLt.__importDefault((parcelRequire("123dl")));
module.exports.FLAG_PREFIX = "flagKey.";
module.exports.ALL_FLAGS = "allFlags";
var $a7999b9efe967f7d$var$Subscriptions = /** @class */ function() {
    function Subscriptions() {
        this.emitter = $a7999b9efe967f7d$var$mitt_1.default();
    }
    Subscriptions.prototype.on = function(flagKey, defaultValue, callback, getFlagValue, options) {
        var _this = this;
        var wrapCallback = function() {
            return callback(getFlagValue(flagKey, defaultValue, options));
        };
        this.emitter.on(module.exports.FLAG_PREFIX + flagKey, wrapCallback);
        return function() {
            return _this.emitter.off(module.exports.FLAG_PREFIX + flagKey, wrapCallback);
        };
    };
    Subscriptions.prototype.onAnyFlagUpdated = function(callback) {
        var _this = this;
        this.emitter.on(module.exports.ALL_FLAGS, callback);
        return function() {
            return _this.emitter.off(module.exports.ALL_FLAGS, callback);
        };
    };
    Subscriptions.prototype.anyFlagUpdated = function() {
        this.emitter.emit(module.exports.ALL_FLAGS);
    };
    Subscriptions.prototype.flagValueUpdated = function(flagKey) {
        this.emitter.emit(module.exports.FLAG_PREFIX + flagKey);
    };
    Subscriptions.prototype.stop = function() {
        // There is no way to clear the emitter so instead we're creating a new one
        this.emitter = $a7999b9efe967f7d$var$mitt_1.default();
    };
    return Subscriptions;
}();
module.exports.default = $a7999b9efe967f7d$var$Subscriptions;

});
parcelRegister("123dl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $0c08789e4536fdae$export$2e2bcd8739ae039; });
//      
// An event handler can take an optional event argument
// and should not return a value
// An array of all currently registered event handlers for a type
// A map of event types and their corresponding event handlers.
/** Mitt: Tiny (~200b) functional event emitter / pubsub.
 *  @name mitt
 *  @returns {Mitt}
 */ function $0c08789e4536fdae$var$mitt(all) {
    all = all || Object.create(null);
    return {
        /**
		 * Register an event handler for the given type.
		 *
		 * @param  {String} type	Type of event to listen for, or `"*"` for all events
		 * @param  {Function} handler Function to call in response to given event
		 * @memberOf mitt
		 */ on: function on(type, handler) {
            (all[type] || (all[type] = [])).push(handler);
        },
        /**
		 * Remove an event handler for the given type.
		 *
		 * @param  {String} type	Type of event to unregister `handler` from, or `"*"`
		 * @param  {Function} handler Handler function to remove
		 * @memberOf mitt
		 */ off: function off(type, handler) {
            if (all[type]) all[type].splice(all[type].indexOf(handler) >>> 0, 1);
        },
        /**
		 * Invoke all handlers for the given type.
		 * If present, `"*"` handlers are invoked after type-matched handlers.
		 *
		 * @param {String} type  The event type to invoke
		 * @param {Any} [evt]  Any value (object is recommended and powerful), passed to each handler
		 * @memberOf mitt
		 */ emit: function emit(type, evt) {
            (all[type] || []).slice().map(function(handler) {
                handler(evt);
            });
            (all["*"] || []).slice().map(function(handler) {
                handler(type, evt);
            });
        }
    };
}
var $0c08789e4536fdae$export$2e2bcd8739ae039 = $0c08789e4536fdae$var$mitt;

});


parcelRegister("enr3o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l5MLt = parcelRequire("l5MLt");

var $a77832fef61adec7$var$hash_1 = $l5MLt.__importDefault((parcelRequire("aOgOd")));
module.exports.CHANNEL_PREFIX = "flagData";
var $a77832fef61adec7$var$Broadcast = /** @class */ function() {
    function Broadcast(apiKey, user, stateUpdateCallback) {
        this.apiKey = apiKey;
        this.stateUpdateCallback = stateUpdateCallback;
        this.setupChannel(user);
    }
    Broadcast.prototype.updateUserContext = function(user) {
        this.stop();
        this.setupChannel(user);
    };
    Broadcast.prototype.sendFeatureFlagState = function(featureFlagState) {
        var _a;
        (_a = this.channel) === null || _a === void 0 || _a.postMessage(featureFlagState);
    };
    Broadcast.prototype.stop = function() {
        var _a;
        (_a = this.channel) === null || _a === void 0 || _a.close();
    };
    Broadcast.prototype.setupChannel = function(user) {
        var _this = this;
        try {
            // Keep reference to old channel so we can check the name of the current subscription
            // is the same as the channel we received a message for.
            // Due to a bug in Firefox which events can be recieved after
            // the channel has been closed.
            var channel_1 = new BroadcastChannel(this.createChannelName(user));
            channel_1.onmessage = function(e) {
                var _a;
                if (channel_1.name === ((_a = _this.channel) === null || _a === void 0 ? void 0 : _a.name)) _this.stateUpdateCallback(e.data);
            };
            this.channel = channel_1;
        } catch (error) {
        // This could fail due to BroadcastChannel not available.
        // In that case, we do nothing.
        }
    };
    Broadcast.prototype.createChannelName = function(user) {
        return module.exports.CHANNEL_PREFIX + "." + this.apiKey + "." + $a77832fef61adec7$var$hash_1.default(user);
    };
    return Broadcast;
}();
module.exports.default = $a77832fef61adec7$var$Broadcast;

});


parcelRegister("do9aj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l5MLt = parcelRequire("l5MLt");

var $bwg5y = parcelRequire("bwg5y");

var $9bf4a049823e78ab$var$storage_1 = $l5MLt.__importDefault((parcelRequire("N8ydp")));

var $80R0U = parcelRequire("80R0U");
var $9bf4a049823e78ab$var$Anonymous = /** @class */ function() {
    function Anonymous() {}
    Anonymous.processAnonymousUser = function(featureFlagUser) {
        var identifier = featureFlagUser.identifier;
        if (identifier) return $l5MLt.__assign($l5MLt.__assign({}, featureFlagUser), {
            identifier: identifier
        });
        identifier = {
            type: $bwg5y.Identifiers.FF_CLIENT_ANONYMOUS_ID,
            value: Anonymous.generateAnonymousId()
        };
        return $l5MLt.__assign($l5MLt.__assign({}, featureFlagUser), {
            isAnonymous: true,
            identifier: identifier
        });
    };
    Anonymous.generateAnonymousId = function() {
        var storedAnonymousId = $9bf4a049823e78ab$var$storage_1.default.getAnonymousId();
        if (storedAnonymousId) return storedAnonymousId;
        var anonymousId = $80R0U.uuidv4();
        $9bf4a049823e78ab$var$storage_1.default.setAnonymousId(anonymousId);
        return anonymousId;
    };
    return Anonymous;
}();
module.exports.default = $9bf4a049823e78ab$var$Anonymous;

});

parcelRegister("7rKP9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_PROMISE_TIMEOUT = 3000;
var $56bf6045a598a9f8$var$Ready = /** @class */ function() {
    function Ready() {
        this.initialisePromise();
        this.initialiseDefaultPromise();
    }
    Ready.prototype.initialiseDefaultPromise = function() {
        this.defaultReadyPromise = new Promise(function(resolve) {
            setTimeout(resolve, module.exports.DEFAULT_PROMISE_TIMEOUT);
        });
    };
    Ready.prototype.initialisePromise = function() {
        var _this = this;
        /*
          A promise can only be resolved by calling the `resolve` function in the constructor callback.
          Since we need resolve the promise by external input, we must save the reference to this resolve function.
          This is safe as the callback function is called synchronously as defined by the ES spec.
        */ this.readyPromise = new Promise(function(resolve) {
            _this.resolveReadyPromise = resolve;
        });
    };
    Ready.prototype.getPromise = function() {
        return Promise.race([
            this.readyPromise,
            this.defaultReadyPromise
        ]);
    };
    Ready.prototype.triggerReady = function() {
        if (this.resolveReadyPromise !== undefined) {
            this.resolveReadyPromise();
            this.resolveReadyPromise = undefined;
        }
    };
    Ready.prototype.reset = function() {
        if (this.resolveReadyPromise === undefined) this.initialisePromise();
        this.initialiseDefaultPromise();
    };
    return Ready;
}();
module.exports.default = $56bf6045a598a9f8$var$Ready;

});





parcelRegister("l9p9x", function(module, exports) {

$parcel$export(module.exports, "getFlagValue", function () { return $b388364348eca1e4$export$2ba274643c6c5931; });
$parcel$export(module.exports, "getGlobalFeatureFlagClient", function () { return $b388364348eca1e4$export$bd77ff6015b82549; });

var $fkrZU = parcelRequire("fkrZU");

var $bwg5y = parcelRequire("bwg5y");
let $b388364348eca1e4$var$globalFeatureFlagClient = null;
const $b388364348eca1e4$export$2ba274643c6c5931 = (flagKey, defaultValue, options)=>{
    var _globalFeatureFlagCli, _globalFeatureFlagCli2;
    return (_globalFeatureFlagCli = (_globalFeatureFlagCli2 = $b388364348eca1e4$var$globalFeatureFlagClient) === null || _globalFeatureFlagCli2 === void 0 ? void 0 : _globalFeatureFlagCli2.getFlagValue(flagKey, defaultValue, options)) !== null && _globalFeatureFlagCli !== void 0 ? _globalFeatureFlagCli : defaultValue;
};
const $b388364348eca1e4$export$bd77ff6015b82549 = ({ apiKey: apiKey, analyticsWebClient: analyticsWebClient, featureFlagUser: featureFlagUser, options: options })=>{
    if (!$b388364348eca1e4$var$globalFeatureFlagClient) {
        $b388364348eca1e4$var$globalFeatureFlagClient = new (0, (/*@__PURE__*/$parcel$interopDefault($bwg5y)))(apiKey, analyticsWebClient, featureFlagUser, options);
        try {
            /**
       * Platform Feature flags (PFF): https://hello.atlassian.net/wiki/spaces/AF/pages/2634731342/Platform+Feature+Flags
       *
       * This creates a PFF resolver that allows calls to `getBooleanFF` inside of Platform components to use your feature flag client
       * and LD project, rather than installing a feature flag client of their own, or passing those flags in via props.
       */ $b388364348eca1e4$var$globalFeatureFlagClient.ready().then(()=>{
                (0, $fkrZU.setBooleanFeatureFlagResolver)((flagKey)=>Boolean($b388364348eca1e4$var$globalFeatureFlagClient.getFlagValue(flagKey, false)));
            });
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error("Could not initialize Platform Feature Flags", error);
        }
    }
    return $b388364348eca1e4$var$globalFeatureFlagClient;
};

});
parcelRegister("fkrZU", function(module, exports) {

$parcel$export(module.exports, "setBooleanFeatureFlagResolver", function () { return $b28e70ff58d23270$export$ba05d765b8392e5e; });

var $516Sp = parcelRequire("516Sp");
function $b28e70ff58d23270$export$ba05d765b8392e5e(flagResolver) {
    (0, $516Sp.setBooleanResolver)(flagResolver);
}
function $b28e70ff58d23270$export$470e5c2be1411c89(name) {
    return (0, $516Sp.resolveBooleanFlag)(name);
}
function $b28e70ff58d23270$export$b40ec24ac8275656(name) {
    return (0, $516Sp.resolveBooleanFlag)(name);
}

});
parcelRegister("516Sp", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $3a72614761f5c6b5$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $3a72614761f5c6b5$export$6333b6aff9fc6275; });

var $2GcCq = parcelRequire("2GcCq");

var $8ovux = parcelRequire("8ovux");
var $3a72614761f5c6b5$var$pkgName = "@atlaskit/platform-feature-flags";
var $3a72614761f5c6b5$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $3a72614761f5c6b5$var$hasProcessEnv = typeof $8ovux !== "undefined" && typeof $8ovux.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $3a72614761f5c6b5$var$ENV_ENABLE_PLATFORM_FF = $3a72614761f5c6b5$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $3a72614761f5c6b5$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $3a72614761f5c6b5$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $3a72614761f5c6b5$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $3a72614761f5c6b5$var$ENV_ENABLE_PLATFORM_FF || $3a72614761f5c6b5$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $3a72614761f5c6b5$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $3a72614761f5c6b5$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$3a72614761f5c6b5$var$globalVar[$3a72614761f5c6b5$export$7e41b1b2bdee3f98] = $3a72614761f5c6b5$var$globalVar[$3a72614761f5c6b5$export$7e41b1b2bdee3f98] || $3a72614761f5c6b5$var$DEFAULT_PFF_GLOBAL;
function $3a72614761f5c6b5$export$f2b591175b3e424c(resolver) {
    $3a72614761f5c6b5$var$globalVar[$3a72614761f5c6b5$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $3a72614761f5c6b5$export$6333b6aff9fc6275(flagKey) {
    if ($3a72614761f5c6b5$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $2GcCq.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $3a72614761f5c6b5$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $3a72614761f5c6b5$var$globalVar[$3a72614761f5c6b5$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("2GcCq", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $1f394ad6df659cd3$export$1c9f709888824e05; });
var $1f394ad6df659cd3$var$_ref, $1f394ad6df659cd3$var$_process, $1f394ad6df659cd3$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $1f394ad6df659cd3$var$TESTS_MODE = ($1f394ad6df659cd3$var$_ref = (globalThis === null || globalThis === void 0 || ($1f394ad6df659cd3$var$_process = globalThis.process) === null || $1f394ad6df659cd3$var$_process === void 0 || ($1f394ad6df659cd3$var$_process = $1f394ad6df659cd3$var$_process.env) === null || $1f394ad6df659cd3$var$_process === void 0 ? void 0 : $1f394ad6df659cd3$var$_process.JEST_WORKER_ID) !== undefined, $1f394ad6df659cd3$var$_ref !== void 0) ? $1f394ad6df659cd3$var$_ref : false;
var $1f394ad6df659cd3$var$DEBUG_MODE = !$1f394ad6df659cd3$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($1f394ad6df659cd3$var$_process2 = globalThis.process) === null || $1f394ad6df659cd3$var$_process2 === void 0 || ($1f394ad6df659cd3$var$_process2 = $1f394ad6df659cd3$var$_process2.env) === null || $1f394ad6df659cd3$var$_process2 === void 0 ? void 0 : $1f394ad6df659cd3$var$_process2.NODE_ENV) !== "production";
var $1f394ad6df659cd3$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$1f394ad6df659cd3$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("7JtYi", function(module, exports) {

$parcel$export(module.exports, "FeatureKeys", function () { return $ad6c38e1e855d195$export$c6924e03165427f7; });
$parcel$export(module.exports, "StatsigFeatureKeys", function () { return $ad6c38e1e855d195$export$b0938df42d8d817b; });
const $ad6c38e1e855d195$export$c6924e03165427f7 = {
    isExampleFlag: "example-flag",
    bbogDiscoverExperiment: "bb.og.discover",
    pipelinesArtifactPreviewSizeLimit: "pipelines-artifact-preview-size-limit",
    useExperimentApiRecommendations: "use-experiment-api-recommendations",
    isNudgeReviewersEnabled: "pr-nudge-reviewers",
    isProjectSettingsInheritanceProviderEnabled: "project-settings-inheritance-provider",
    enableRunPipelineFromBranchPage: "run-pipelines-from-single-branch-page",
    pipelinesMaxStepDuration: "pipelines-max-step-duration",
    pipelinesMaximumAllowedStepSizeForCloudRunners: "pipelines-maximum-allowed-step-size-for-cloud-runners",
    isDeploymentsFilteringEnabled: "deployments-filtering",
    isPipelinesManualStepsInStagesEnabled: "pipelines-allow-manual-steps-in-stages",
    isPipelinesEditorInFrontbucketEnabled: "pipelines-editor-ui-in-frontbucket",
    logViewerDarkModeEnabled: "bitbucket-pipelines-log-viewer-dark-mode-enabled",
    pipelinesEditorDarkModeEnabled: "bitbucket-pipelines-editor-dark-mode-enabled",
    isPipelinesSettingsInFrontbucketEnabled: "pipelines-settings-ui-in-frontbucket",
    isBuildLinkRedirectionFixEnabled: "build-link-redirection-fix",
    isPipelinesRunnersSettingsInFrontbucketEnabled: "pipelines-runners-settings-ui-in-frontbucket",
    incrementalRequestEnabled: "bitbucket-pipelines-incremental-log-request",
    isSagaLinkifyDisabled: "bitbucket-pipelines-disable-saga-linkify",
    isPipelinesDeploymentsSettingsInFrontbucketEnabled: "pipelines-deployments-settings-ui-in-frontbucket",
    isPipelinesSecuredPrefixedVariablesEnabled: "pipelines-secured-prefixed-variables",
    isPipelinesMacOSTartRunnerEnabled: "pipelines-mac-os-tart-runner",
    isPipelinesRunnerUuidDisplayEnabled: "pipelines-enable-runner-table-uuid-display",
    isRunPipelineModalInFrontbucket: "pipelines-run-pipeline-modal-in-frontbucket",
    isStepMetricsEnabled: "pipelines-step-metrics-enabled",
    isPipelineTypeHandleSpecialChars: "pipelines-pipeline-type-filter-handle-special-chars",
    isPrDependenciesEnabled: "pr-dependencies",
    isPrReviewGroupsEnabled: "pr-review-groups",
    isPipelinesStickyEnvParamEnabled: "pipelines-sticky-env-parameter",
    isPipelineListSidebarEnabled: "enable-pipeline-list-sidebar",
    isPipelineRunsHistoryEnabled: "enable-pipeline-runs-history",
    isPipelinesPageLoadOptimisationEnabled: "enable-pipelines-page-load-optimisation",
    enableSendingDefaulVariableValues: "enable-sending-default-variables-for-run-pipeline-modal",
    sumCreateWorkspacePreChangeEnabled: "ADMINX-1261-workspaces-list-sum-pre-change",
    enableAddingVariablesFix: "adding-variables-in-editor-fix",
    useUpdatedStepDurationFormat: "pipelines-update-stage-step-duration-format",
    enableImprovedErrorMapping: "pipelines-improved-error-mapping",
    enableCustomCronSupport: "bitbucket-pipelines-custom-cron-pattern-support",
    enablePersistPipelineListFilters: "pipelines-persist-pipeline-list-filters",
    isDescriptionEnabled: "bitbucket-pipelines-variable-description",
    logLineWrapped: "platform.pipelines.log-line-wrapped",
    descriptivePrUpdateFlag: "descriptive-pr-update-flag",
    darkModePOC: "dark-mode-poc",
    enableHandleAllowanceResponse: "handle-allowance-returning-404",
    extensibleMergeChecksEnabled: "extensible-merge-checks-enabled",
    enableDiscoverySdk: "bitbucket.app-recommendations.discovery-sdk",
    enableDiscoverySdkIAllLocales: "bitbucket.app-recommendations.discovery-sdk.all-locale",
    clearPrFilter: "clear-pr-filter",
    updatedStepList: "updated-pipelines-step-list",
    enableStashCommitLink: "pipelines-add-stash-commit-link",
    showShadowRepositoryConfiguration: "show-shadow-repository-configuration",
    cookieConsentBannerEnabled: "platform.moonjelly.browser-storage-controls",
    postOfficeInAppSwitcher: "post-office-in-bitbucket-switcher",
    markFilesNewFeatures: "mark-files-new-features",
    compassEditableEmptyState: "bbc-compass-new-empty-state-side-card",
    compassXpSearchNonAdmin: "compass-in-cross-product-search-non-admin",
    disableCompassBitbucketRepositoryCard: "disable-compass-bitbucket-repository-card",
    isDefaultDisableFlagsForPdvsEnabled: "default-disable-flags-for-pdvs",
    enableAutoreviewFeedbackUi: "autoreview-feedback-ui_0ya4n",
    enableChoreographer: "post-office_enable_bitbucket_choreographer_98iep",
    editorDeprecateDangerousPlugins: "editor.deprecate-dangerous-plugins",
    staleBranchesFilter: "stale-branches-filter",
    isNavThemeSelectorEnabled: "enable-navigation-color-theme-picker"
};
const $ad6c38e1e855d195$export$b0938df42d8d817b = {
    bbcNewNav: "bbc_new_nav",
    isPipelinesStepFilterEnabled: "enable_pipelines_step_filter",
    prCreateDeleteBranchDefault: "bbc-frontbucket-default-delete-branch",
    useConsolidatedForgeRenderer: "forge-ui-use-consolidated-renderer",
    improvedStickyToBottomEnabled: "bitbucket_pipelines_improve_sticky_scrolling"
};

});


parcelRegister("dOsQd", function(module, exports) {
$parcel$export(module.exports, "ApolloProvider", function () { return (parcelRequire("5gpbZ")).ApolloProvider; });
$parcel$export(module.exports, "useApolloClient", function () { return (parcelRequire("lLsFN")).useApolloClient; });
$parcel$export(module.exports, "useMutation", function () { return (parcelRequire("3FUVb")).useMutation; });
$parcel$export(module.exports, "useQuery", function () { return (parcelRequire("2U6Qd")).useQuery; });
parcelRequire("5gpbZ");parcelRequire("lLsFN");parcelRequire("3FUVb");parcelRequire("2U6Qd");

});
parcelRegister("5gpbZ", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", function () { return $3d51fd10085afc58$export$a47505d961ee3a1; });
$parcel$export(module.exports, "ApolloProvider", function () { return $3d51fd10085afc58$export$c16b04c8a9956446; });
$parcel$export(module.exports, "DocumentType", function () { return $3d51fd10085afc58$export$d1d99cf900472499; });
$parcel$export(module.exports, "operationName", function () { return $3d51fd10085afc58$export$5db520940cf00715; });
$parcel$export(module.exports, "parser", function () { return $3d51fd10085afc58$export$8f49e4af10703ce3; });

var $9nHZC = parcelRequire("9nHZC");

var $Tvg0H = parcelRequire("Tvg0H");
var $3d51fd10085afc58$var$apolloContext;
function $3d51fd10085afc58$export$a47505d961ee3a1() {
    if (!$3d51fd10085afc58$var$apolloContext) $3d51fd10085afc58$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createContext({});
    return $3d51fd10085afc58$var$apolloContext;
}
function $3d51fd10085afc58$export$c2ee824bcc89ca6a() {
    $3d51fd10085afc58$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createContext({});
}
var $3d51fd10085afc58$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $3d51fd10085afc58$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $Tvg0H.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $3d51fd10085afc58$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $3d51fd10085afc58$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $Tvg0H.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $3d51fd10085afc58$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($3d51fd10085afc58$export$d1d99cf900472499 || ($3d51fd10085afc58$export$d1d99cf900472499 = {}));
var $3d51fd10085afc58$var$cache = new Map();
function $3d51fd10085afc58$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $3d51fd10085afc58$export$d1d99cf900472499.Query:
            name = "Query";
            break;
        case $3d51fd10085afc58$export$d1d99cf900472499.Mutation:
            name = "Mutation";
            break;
        case $3d51fd10085afc58$export$d1d99cf900472499.Subscription:
            name = "Subscription";
            break;
    }
    return name;
}
function $3d51fd10085afc58$export$8f49e4af10703ce3(document) {
    var cached = $3d51fd10085afc58$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $Tvg0H.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === "FragmentDefinition";
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === "OperationDefinition" && x.operation === "query";
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === "OperationDefinition" && x.operation === "mutation";
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === "OperationDefinition" && x.operation === "subscription";
    });
    (0, $Tvg0H.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $Tvg0H.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $3d51fd10085afc58$export$d1d99cf900472499.Query : $3d51fd10085afc58$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $3d51fd10085afc58$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $Tvg0H.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === "Name") name = definition.name.value;
    else name = "data";
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $3d51fd10085afc58$var$cache.set(document, payload);
    return payload;
}

});
parcelRegister("Tvg0H", function(module, exports) {

$parcel$export(module.exports, "InvariantError", function () { return $0a6d62340e28b494$export$cea12affaee22fe8; });
$parcel$export(module.exports, "invariant", function () { return $0a6d62340e28b494$export$f5708dca728d7177; });

var $l5MLt = parcelRequire("l5MLt");

var $8ovux = parcelRequire("8ovux");
var $0a6d62340e28b494$var$genericMessage = "Invariant Violation";
var $0a6d62340e28b494$var$_a = Object.setPrototypeOf, $0a6d62340e28b494$var$setPrototypeOf = $0a6d62340e28b494$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $0a6d62340e28b494$var$_a;
var $0a6d62340e28b494$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $l5MLt.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $0a6d62340e28b494$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $0a6d62340e28b494$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $0a6d62340e28b494$var$genericMessage;
        $0a6d62340e28b494$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $0a6d62340e28b494$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $0a6d62340e28b494$export$cea12affaee22fe8(message);
}
function $0a6d62340e28b494$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $0a6d62340e28b494$var$wrapConsoleMethod("warn");
    invariant.error = $0a6d62340e28b494$var$wrapConsoleMethod("error");
})($0a6d62340e28b494$export$f5708dca728d7177 || ($0a6d62340e28b494$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $0a6d62340e28b494$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $8ovux === "object") $0a6d62340e28b494$export$e54fe5b0f43758f7 = $8ovux;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($0a6d62340e28b494$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $0a6d62340e28b494$var$invariant$1 = $0a6d62340e28b494$export$f5708dca728d7177;
var $0a6d62340e28b494$export$2e2bcd8739ae039 = $0a6d62340e28b494$var$invariant$1;

});


parcelRegister("lLsFN", function(module, exports) {

$parcel$export(module.exports, "useQuery", function () { return $fd843aab7faaef6d$export$dd0a697e1782aedd; });
$parcel$export(module.exports, "useMutation", function () { return $fd843aab7faaef6d$export$609860bf8b0084c; });
$parcel$export(module.exports, "useApolloClient", function () { return $fd843aab7faaef6d$export$eb9a56e7a29e494; });

var $5gpbZ = parcelRequire("5gpbZ");

var $l5MLt = parcelRequire("l5MLt");

var $9nHZC = parcelRequire("9nHZC");

var $grvSO = parcelRequire("grvSO");

var $4OFPo = parcelRequire("4OFPo");

var $Tvg0H = parcelRequire("Tvg0H");
var $fd843aab7faaef6d$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $4OFPo.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $Tvg0H.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $5gpbZ.parser)(document);
        var requiredOperationName = (0, $5gpbZ.operationName)(type);
        var usedOperationName = (0, $5gpbZ.operationName)(operation.type);
        (0, $Tvg0H.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $fd843aab7faaef6d$var$QueryData = function(_super) {
    (0, $l5MLt.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, onNewData = _a.onNewData;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.onNewData();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.onNewData = onNewData;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $grvSO.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) this.handleErrorOrCompleted();
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.ssrInitiated = function() {
        return this.context && this.context.renderPromises;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = (0, $l5MLt.__assign)({
            loading: true,
            networkStatus: (0, $grvSO.NetworkStatus).loading,
            called: true,
            data: undefined,
            stale: false,
            client: this.client
        }, this.observableQueryFields());
        if (ssrDisabled && (this.ssrInitiated() || fetchDisabled)) {
            this.previousData.result = ssrLoading;
            return ssrLoading;
        }
        var result;
        if (this.ssrInitiated()) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $5gpbZ.DocumentType).Query);
        var displayName = options.displayName || "Query";
        if (this.ssrInitiated() && (options.fetchPolicy === "network-only" || options.fetchPolicy === "cache-and-network")) options.fetchPolicy = "cache-first";
        return (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        var _a, _b;
        if (this.ssrInitiated()) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $l5MLt.__assign)({}, observableQueryOptions));
            if (this.ssrInitiated()) (_b = (_a = this.context) === null || _a === void 0 ? void 0 : _a.renderPromises) === null || _b === void 0 || _b.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $4OFPo.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $4OFPo.equal)(previousResult.data, data)) return;
                _this.onNewData();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty("graphQLErrors")) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $4OFPo.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.onNewData();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $grvSO.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== "cache-only") {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $grvSO.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        this.currentObservable.query && this.currentObservable.query.resetQueryStoreErrors();
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery || !this.previousData.result) return;
        var _a = this.previousData.result, data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $4OFPo.equal)(this.previousOptions.query, query) && (0, $4OFPo.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($fd843aab7faaef6d$var$OperationData);
function $fd843aab7faaef6d$var$useDeepMemo(memoFn, key) {
    var ref = (0, $9nHZC.useRef)();
    if (!ref.current || !(0, $4OFPo.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $fd843aab7faaef6d$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $9nHZC.useContext)((0, $5gpbZ.getApolloContext)());
    var _a = (0, $9nHZC.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $9nHZC.useRef)();
    var queryData = queryDataRef.current || new $fd843aab7faaef6d$var$QueryData({
        options: updatedOptions,
        context: context,
        onNewData: function() {
            if (!queryData.ssrInitiated()) Promise.resolve().then(forceUpdate);
            else forceUpdate();
        }
    });
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    if (queryData.ssrInitiated() && !queryDataRef.current) queryDataRef.current = queryData;
    var memo = {
        options: (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $fd843aab7faaef6d$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $9nHZC.useEffect)(function() {
        if (!queryDataRef.current) queryDataRef.current = queryData;
        return function() {
            return queryData.cleanup();
        };
    }, []);
    (0, $9nHZC.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    return result;
}
function $fd843aab7faaef6d$export$dd0a697e1782aedd(query, options) {
    return $fd843aab7faaef6d$var$useBaseQuery(query, options, false);
}
function $fd843aab7faaef6d$export$fd83eea6ecd2d8fa(query, options) {
    return $fd843aab7faaef6d$var$useBaseQuery(query, options, true);
}
var $fd843aab7faaef6d$var$MutationData = function(_super) {
    (0, $l5MLt.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $5gpbZ.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $5gpbZ.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $l5MLt.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $l5MLt.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $grvSO.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $4OFPo.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($fd843aab7faaef6d$var$OperationData);
function $fd843aab7faaef6d$export$609860bf8b0084c(mutation, options) {
    var context = (0, $9nHZC.useContext)((0, $5gpbZ.getApolloContext)());
    var _a = (0, $9nHZC.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $9nHZC.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $fd843aab7faaef6d$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $9nHZC.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $fd843aab7faaef6d$var$SubscriptionData = function(_super) {
    (0, $l5MLt.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === "function") shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $4OFPo.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($fd843aab7faaef6d$var$OperationData);
function $fd843aab7faaef6d$export$368b4214baeb914c(subscription, options) {
    var context = (0, $9nHZC.useContext)((0, $5gpbZ.getApolloContext)());
    var updatedOptions = options ? (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $9nHZC.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $9nHZC.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $fd843aab7faaef6d$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $9nHZC.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $9nHZC.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $fd843aab7faaef6d$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).useContext((0, $5gpbZ.getApolloContext)()).client;
    (0, $Tvg0H.invariant)(client, 1);
    return client;
}
function $fd843aab7faaef6d$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $fd843aab7faaef6d$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $fd843aab7faaef6d$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});
parcelRegister("grvSO", function(module, exports) {

$parcel$export(module.exports, "NetworkStatus", function () { return $bf87e649b6dff900$export$bd096ddbd246c79c; });
$parcel$export(module.exports, "ApolloError", function () { return $bf87e649b6dff900$export$26a337512320b8c6; });
$parcel$export(module.exports, "ApolloClient", function () { return $bf87e649b6dff900$export$13f5a5f0f1dbab88; });
$parcel$export(module.exports, "default", function () { return $bf87e649b6dff900$export$2e2bcd8739ae039; });

var $l5MLt = parcelRequire("l5MLt");

var $jm5tp = parcelRequire("jm5tp");
var $4OFPo = parcelRequire("4OFPo");

var $cHmNF = parcelRequire("cHmNF");
var $jTh3A = parcelRequire("jTh3A");

var $8tqiY = parcelRequire("8tqiY");

var $Tvg0H = parcelRequire("Tvg0H");

var $dOVPe = parcelRequire("dOVPe");
var $bf87e649b6dff900$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($bf87e649b6dff900$export$bd096ddbd246c79c || ($bf87e649b6dff900$export$bd096ddbd246c79c = {}));
function $bf87e649b6dff900$var$isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var $bf87e649b6dff900$var$Observable = function(_super) {
    (0, $l5MLt.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, $8tqiY.default] = function() {
        return this;
    };
    Observable.prototype["@@observable"] = function() {
        return this;
    };
    return Observable;
}((0, $jTh3A.default));
function $bf87e649b6dff900$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function $bf87e649b6dff900$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty("graphQLErrors");
}
var $bf87e649b6dff900$var$generateErrorMessage = function(err) {
    var message = "";
    if ($bf87e649b6dff900$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : "Error message not found.";
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += "Network error: " + err.networkError.message + "\n";
    message = message.replace(/\n$/, "");
    return message;
};
var $bf87e649b6dff900$export$26a337512320b8c6 = function(_super) {
    (0, $l5MLt.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = $bf87e649b6dff900$var$generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var $bf87e649b6dff900$export$160bafb6ac1e0641;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})($bf87e649b6dff900$export$160bafb6ac1e0641 || ($bf87e649b6dff900$export$160bafb6ac1e0641 = {}));
var $bf87e649b6dff900$var$hasError = function(storeValue, policy) {
    if (policy === void 0) policy = "none";
    return storeValue && (storeValue.networkError || policy === "none" && $bf87e649b6dff900$var$isNonEmptyArray(storeValue.graphQLErrors));
};
var $bf87e649b6dff900$export$6c1b56eac59c9584 = function(_super) {
    (0, $l5MLt.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, $jm5tp.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: $bf87e649b6dff900$export$bd096ddbd246c79c.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === "network-only" || fetchPolicy === "no-cache";
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if ($bf87e649b6dff900$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new $bf87e649b6dff900$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: $bf87e649b6dff900$var$isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === "all") result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== "cache-only";
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? $bf87e649b6dff900$export$bd096ddbd246c79c.loading : $bf87e649b6dff900$export$bd096ddbd246c79c.ready
            };
        }
        if (!partial) this.updateLastResult((0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, result), {
            stale: false
        }));
        return (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $4OFPo.equal)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === "cache-only") return Promise.reject(new (0, $Tvg0H.InvariantError)(1));
        if (fetchPolicy !== "no-cache" && fetchPolicy !== "cache-and-network") fetchPolicy = "network-only";
        if (!(0, $4OFPo.equal)(this.variables, variables)) this.variables = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this.variables), variables);
        if (!(0, $4OFPo.equal)(this.options.variables, this.variables)) this.options.variables = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), $bf87e649b6dff900$export$160bafb6ac1e0641.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, $Tvg0H.invariant)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $l5MLt.__assign)((0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: "network-only"
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, $bf87e649b6dff900$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === "cache-only" || oldFetchPolicy === "standby" || fetchPolicy === "network-only"), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, $4OFPo.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, $jm5tp.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        $bf87e649b6dff900$var$assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $jm5tp.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $bf87e649b6dff900$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            $bf87e649b6dff900$var$assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function(error) {
            _this.updateLastResult((0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: $bf87e649b6dff900$export$bd096ddbd246c79c.error,
                loading: false
            }));
            $bf87e649b6dff900$var$iterateObserversSafely(_this.observers, "error", _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== "cache-only" && queryManager.transform(query_1).serverQuery && !(0, $4OFPo.equal)(previousVariables, variables)) _this.refetch();
                        else $bf87e649b6dff900$var$iterateObserversSafely(_this.observers, "next", result);
                    });
                    else $bf87e649b6dff900$var$iterateObserversSafely(_this.observers, "next", result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}($bf87e649b6dff900$var$Observable);
function $bf87e649b6dff900$var$defaultSubscriptionObserverErrorCallback(error) {}
function $bf87e649b6dff900$var$iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function $bf87e649b6dff900$var$assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, $Tvg0H.invariant)(fetchPolicy !== "cache-first" && fetchPolicy !== "cache-only", 3);
}
var $bf87e649b6dff900$var$MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var $bf87e649b6dff900$var$QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, $Tvg0H.invariant)(!previousQuery || previousQuery.document === query.document || (0, $4OFPo.equal)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $bf87e649b6dff900$export$bd096ddbd246c79c.loading) {
            if (!(0, $4OFPo.equal)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = $bf87e649b6dff900$export$bd096ddbd246c79c.setVariables;
        else if (query.isPoll) networkStatus = $bf87e649b6dff900$export$bd096ddbd246c79c.poll;
        else if (query.isRefetch) networkStatus = $bf87e649b6dff900$export$bd096ddbd246c79c.refetch;
        else networkStatus = $bf87e649b6dff900$export$bd096ddbd246c79c.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === "string" && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $bf87e649b6dff900$export$bd096ddbd246c79c.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = $bf87e649b6dff900$var$isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = $bf87e649b6dff900$export$bd096ddbd246c79c.ready;
        if (typeof fetchMoreForQueryId === "string" && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $bf87e649b6dff900$export$bd096ddbd246c79c.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = $bf87e649b6dff900$export$bd096ddbd246c79c.error;
        if (typeof fetchMoreForQueryId === "string") this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = $bf87e649b6dff900$export$bd096ddbd246c79c.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = $bf87e649b6dff900$export$bd096ddbd246c79c.loading;
        });
    };
    return QueryStore;
}();
function $bf87e649b6dff900$var$capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $bf87e649b6dff900$var$LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $jm5tp.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $jm5tp.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $l5MLt.__awaiter)(this, void 0, void 0, function() {
            return (0, $l5MLt.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $jm5tp.hasDirectives)([
            "client"
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, $jm5tp.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, $Tvg0H.invariant)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $l5MLt.__awaiter)(this, void 0, void 0, function() {
            return (0, $l5MLt.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $l5MLt.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $dOVPe.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === "client" && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === "always" && arg.value.kind === "BooleanValue" && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $dOVPe.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $jm5tp.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $l5MLt.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $l5MLt.__generator)(this, function(_b) {
                mainDefinition = (0, $jm5tp.getMainDefinition)(document);
                fragments = (0, $jm5tp.getFragmentDefinitions)(document);
                fragmentMap = (0, $jm5tp.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? $bf87e649b6dff900$var$capitalizeFirstLetter(definitionOperation) : "Query";
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $l5MLt.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $l5MLt.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $l5MLt.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $l5MLt.__generator)(this, function(_a) {
                            if (!(0, $jm5tp.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $jm5tp.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== "undefined") resultsToMerge.push((_a = {}, _a[(0, $jm5tp.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $jm5tp.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $Tvg0H.invariant)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $jm5tp.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $l5MLt.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $l5MLt.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $jm5tp.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, $jm5tp.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === "export" && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === "as" && arg.value.kind === "StringValue") execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function $bf87e649b6dff900$var$multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new $bf87e649b6dff900$var$Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function $bf87e649b6dff900$var$asyncMap(observable, mapFn) {
    return new $bf87e649b6dff900$var$Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function(e) {
                error && error.call(observer, e);
            },
            complete: function() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var $bf87e649b6dff900$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $bf87e649b6dff900$var$QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new $bf87e649b6dff900$var$MutationStore();
        this.queryStore = new $bf87e649b6dff900$var$QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, $jm5tp.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new $bf87e649b6dff900$var$LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $Tvg0H.InvariantError)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? "none" : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $l5MLt.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, $l5MLt.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $Tvg0H.invariant)(mutation, 9);
                        (0, $Tvg0H.invariant)(!fetchPolicy || fetchPolicy === "no-cache", 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $bf87e649b6dff900$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $jm5tp.graphQLResultHasError)(result) && errorPolicy === "none") {
                                            error = new $bf87e649b6dff900$export$26a337512320b8c6({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== "no-cache") self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new $bf87e649b6dff900$export$26a337512320b8c6({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === "function") refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ($bf87e649b6dff900$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === "string") self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: "network-only"
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === "ignore" && storeResult && (0, $jm5tp.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, $l5MLt.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, $l5MLt.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? "cache-first" : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === "network-only" || fetchPolicy === "no-cache";
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === "cache-and-network";
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== "cache-only" && fetchPolicy !== "standby";
                        if ((0, $jm5tp.hasDirectives)([
                            "live"
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== "no-cache" ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === $bf87e649b6dff900$export$160bafb6ac1e0641.poll,
                            isRefetch: fetchType === $bf87e649b6dff900$export$160bafb6ac1e0641.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if ($bf87e649b6dff900$export$17f5e6bd290bb15d(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new $bf87e649b6dff900$export$26a337512320b8c6({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== "cache-and-network") return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === "no-cache") this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === "ignore" || errorPolicy === "all");
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === "standby") return;
            var loading = $bf87e649b6dff900$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === "cache-only" || fetchPolicy === "cache-and-network";
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = $bf87e649b6dff900$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || "none";
            if (errorPolicy === "none" && hasGraphQLErrors || queryStoreValue.networkError) return invoke("error", new $bf87e649b6dff900$export$26a337512320b8c6({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== "no-cache" && fetchPolicy !== "network-only") _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== "none" && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === "cache-only");
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === "all" && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke("next", resultFromStore);
            } catch (networkError) {
                invoke("error", new $bf87e649b6dff900$export$26a337512320b8c6({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, $jm5tp.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $jm5tp.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $jm5tp.getDefaultValues)((0, $jm5tp.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, $Tvg0H.invariant)(options.fetchPolicy !== "standby", 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === "undefined") options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, $l5MLt.__assign)({}, options);
        return new $bf87e649b6dff900$export$6c1b56eac59c9584({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $Tvg0H.invariant)(options.query, 12);
        (0, $Tvg0H.invariant)(options.query.kind === "Document", 13);
        (0, $Tvg0H.invariant)(!options.returnPartialData, 14);
        (0, $Tvg0H.invariant)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function(newData) {
                _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $Tvg0H.InvariantError)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== "cache-only" && (includeStandby || fetchPolicy !== "standby")) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== "no-cache") {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, $jm5tp.graphQLResultHasError)(result)) throw new $bf87e649b6dff900$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new $bf87e649b6dff900$var$Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === "no-cache" || fetchPolicy === "network-only") return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === "string") {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, $Tvg0H.invariant)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) info.listeners.forEach(function(listener) {
                if (listener) listener(_this.queryStore.get(id), info.newData);
            });
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $jm5tp.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = $bf87e649b6dff900$var$multiplex((0, $cHmNF.execute)(link, operation)));
                    var cleanup = function() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = $bf87e649b6dff900$var$multiplex((0, $cHmNF.execute)(link, operation));
        } else {
            observable = $bf87e649b6dff900$var$Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = $bf87e649b6dff900$var$asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? "none" : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === "none" && $bf87e649b6dff900$var$isNonEmptyArray(result.errors)) return reject(new $bf87e649b6dff900$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === "all") errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === "no-cache") resultFromStore = result.data;
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function(error) {
                    cleanup();
                    reject(error);
                },
                complete: function() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: $bf87e649b6dff900$export$bd096ddbd246c79c.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== $bf87e649b6dff900$export$bd096ddbd246c79c.ready && query.networkStatus !== $bf87e649b6dff900$export$bd096ddbd246c79c.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, $Tvg0H.invariant)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, options), {
                fetchPolicy: "network-only"
            });
            var maybeFetch_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, $bf87e649b6dff900$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var $bf87e649b6dff900$var$DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, $jm5tp.graphQLResultHasError)(result);
        if (ignoreErrors && (0, $jm5tp.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: "ROOT_QUERY",
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, $jm5tp.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: "ROOT_SUBSCRIPTION",
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === "function") optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, $jm5tp.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: "ROOT_MUTATION",
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, $jm5tp.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, $jm5tp.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: "ROOT_QUERY",
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, $jm5tp.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: "ROOT_QUERY",
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var $bf87e649b6dff900$var$version = "2.6.10";
var $bf87e649b6dff900$var$hasSuggestedDevtools = false;
var $bf87e649b6dff900$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, $cHmNF.ApolloLink).empty();
        if (!link || !cache) throw new (0, $Tvg0H.InvariantError)(4);
        this.link = link;
        this.cache = cache;
        this.store = new $bf87e649b6dff900$var$DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === "undefined" ? defaultConnectToDevTools : connectToDevTools && typeof window !== "undefined") window.__APOLLO_CLIENT__ = this;
        this.version = $bf87e649b6dff900$var$version;
        this.localState = new $bf87e649b6dff900$var$LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new $bf87e649b6dff900$var$QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === "network-only" || options.fetchPolicy === "cache-and-network")) options = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this.defaultOptions.query), options);
        (0, $Tvg0H.invariant)(options.fetchPolicy !== "cache-and-network", 5);
        if (this.disableNetworkFetches && options.fetchPolicy === "network-only") options = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $cHmNF.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
var $bf87e649b6dff900$export$2e2bcd8739ae039 = $bf87e649b6dff900$export$13f5a5f0f1dbab88;

});
parcelRegister("jm5tp", function(module, exports) {

$parcel$export(module.exports, "storeKeyNameFromField", function () { return $e174514ccd685b7e$export$54be8689c65f3b56; });
$parcel$export(module.exports, "getStoreKeyName", function () { return $e174514ccd685b7e$export$3cdb6c178b88cabe; });
$parcel$export(module.exports, "argumentsObjectFromField", function () { return $e174514ccd685b7e$export$3f5a60fb6a781b4f; });
$parcel$export(module.exports, "resultKeyNameFromField", function () { return $e174514ccd685b7e$export$7d1ad22471852218; });
$parcel$export(module.exports, "isField", function () { return $e174514ccd685b7e$export$fb56ad75dd311c12; });
$parcel$export(module.exports, "isInlineFragment", function () { return $e174514ccd685b7e$export$22a1cdafaf27bcff; });
$parcel$export(module.exports, "isIdValue", function () { return $e174514ccd685b7e$export$e33b89a9aa87695; });
$parcel$export(module.exports, "toIdValue", function () { return $e174514ccd685b7e$export$b124f125e34d720a; });
$parcel$export(module.exports, "isJsonValue", function () { return $e174514ccd685b7e$export$226c1c6d1a5b660a; });
$parcel$export(module.exports, "getDirectiveInfoFromField", function () { return $e174514ccd685b7e$export$2a7f471142984a91; });
$parcel$export(module.exports, "shouldInclude", function () { return $e174514ccd685b7e$export$3dc388a5f013b4a5; });
$parcel$export(module.exports, "hasDirectives", function () { return $e174514ccd685b7e$export$2dafb573e282fe8d; });
$parcel$export(module.exports, "hasClientExports", function () { return $e174514ccd685b7e$export$8d1e9e5bbfa5d09a; });
$parcel$export(module.exports, "getFragmentQueryDocument", function () { return $e174514ccd685b7e$export$abbf37c7cf644e41; });
$parcel$export(module.exports, "assign", function () { return $e174514ccd685b7e$export$e6e34fd1f2686227; });
$parcel$export(module.exports, "getOperationDefinition", function () { return $e174514ccd685b7e$export$7a5b1fa979d2c158; });
$parcel$export(module.exports, "getOperationName", function () { return $e174514ccd685b7e$export$41bca9dc6871dd4e; });
$parcel$export(module.exports, "getFragmentDefinitions", function () { return $e174514ccd685b7e$export$5320a7ba9466a3df; });
$parcel$export(module.exports, "getQueryDefinition", function () { return $e174514ccd685b7e$export$d96b2213c1b9d3a9; });
$parcel$export(module.exports, "getMainDefinition", function () { return $e174514ccd685b7e$export$f431198736b7f96d; });
$parcel$export(module.exports, "createFragmentMap", function () { return $e174514ccd685b7e$export$193789b4c8246dd4; });
$parcel$export(module.exports, "getDefaultValues", function () { return $e174514ccd685b7e$export$84c19026e616569e; });
$parcel$export(module.exports, "addTypenameToDocument", function () { return $e174514ccd685b7e$export$43b332f87950a467; });
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", function () { return $e174514ccd685b7e$export$74985f3324559867; });
$parcel$export(module.exports, "buildQueryFromSelectionSet", function () { return $e174514ccd685b7e$export$57c368c23873f32b; });
$parcel$export(module.exports, "removeClientSetsFromDocument", function () { return $e174514ccd685b7e$export$8eae69e876ee321e; });
$parcel$export(module.exports, "canUseWeakMap", function () { return $e174514ccd685b7e$export$772fbc04a0ad4ce9; });
$parcel$export(module.exports, "cloneDeep", function () { return $e174514ccd685b7e$export$629a2bd3f5a49ecc; });
$parcel$export(module.exports, "isProduction", function () { return $e174514ccd685b7e$export$f15d00aa73aafac4; });
$parcel$export(module.exports, "isTest", function () { return $e174514ccd685b7e$export$410cbc2864fa25b5; });
$parcel$export(module.exports, "tryFunctionOrLogError", function () { return $e174514ccd685b7e$export$50a91acae4904909; });
$parcel$export(module.exports, "graphQLResultHasError", function () { return $e174514ccd685b7e$export$b4df399e879e53ab; });
$parcel$export(module.exports, "mergeDeep", function () { return $e174514ccd685b7e$export$dd702b3c8240390c; });
$parcel$export(module.exports, "mergeDeepArray", function () { return $e174514ccd685b7e$export$160070228be94b08; });

var $dOVPe = parcelRequire("dOVPe");

var $Tvg0H = parcelRequire("Tvg0H");

var $l5MLt = parcelRequire("l5MLt");

var $d5Zp7 = parcelRequire("d5Zp7");

var $4OFPo = parcelRequire("4OFPo");

var $8ovux = parcelRequire("8ovux");
function $e174514ccd685b7e$export$dc071f102752d0eb(value) {
    return [
        "StringValue",
        "BooleanValue",
        "EnumValue"
    ].indexOf(value.kind) > -1;
}
function $e174514ccd685b7e$export$3ff5e9927c3257c6(value) {
    return [
        "IntValue",
        "FloatValue"
    ].indexOf(value.kind) > -1;
}
function $e174514ccd685b7e$var$isStringValue(value) {
    return value.kind === "StringValue";
}
function $e174514ccd685b7e$var$isBooleanValue(value) {
    return value.kind === "BooleanValue";
}
function $e174514ccd685b7e$var$isIntValue(value) {
    return value.kind === "IntValue";
}
function $e174514ccd685b7e$var$isFloatValue(value) {
    return value.kind === "FloatValue";
}
function $e174514ccd685b7e$var$isVariable(value) {
    return value.kind === "Variable";
}
function $e174514ccd685b7e$var$isObjectValue(value) {
    return value.kind === "ObjectValue";
}
function $e174514ccd685b7e$var$isListValue(value) {
    return value.kind === "ListValue";
}
function $e174514ccd685b7e$var$isEnumValue(value) {
    return value.kind === "EnumValue";
}
function $e174514ccd685b7e$var$isNullValue(value) {
    return value.kind === "NullValue";
}
function $e174514ccd685b7e$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($e174514ccd685b7e$var$isIntValue(value) || $e174514ccd685b7e$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($e174514ccd685b7e$var$isBooleanValue(value) || $e174514ccd685b7e$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($e174514ccd685b7e$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $e174514ccd685b7e$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($e174514ccd685b7e$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($e174514ccd685b7e$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $e174514ccd685b7e$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($e174514ccd685b7e$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($e174514ccd685b7e$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $Tvg0H.InvariantError)(17);
}
function $e174514ccd685b7e$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $e174514ccd685b7e$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $e174514ccd685b7e$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $e174514ccd685b7e$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $e174514ccd685b7e$var$KNOWN_DIRECTIVES = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export"
];
function $e174514ccd685b7e$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives["connection"] && directives["connection"]["key"]) {
        if (directives["connection"]["filter"] && directives["connection"]["filter"].length > 0) {
            var filterKeys = directives["connection"]["filter"] ? directives["connection"]["filter"] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives["connection"]["key"] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives["connection"]["key"];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($d5Zp7)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($e174514ccd685b7e$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $e174514ccd685b7e$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $e174514ccd685b7e$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $e174514ccd685b7e$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $e174514ccd685b7e$export$fb56ad75dd311c12(selection) {
    return selection.kind === "Field";
}
function $e174514ccd685b7e$export$22a1cdafaf27bcff(selection) {
    return selection.kind === "InlineFragment";
}
function $e174514ccd685b7e$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === "id" && typeof idObject.generated === "boolean";
}
function $e174514ccd685b7e$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $l5MLt.__assign)({
        type: "id",
        generated: generated
    }, typeof idConfig === "string" ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $e174514ccd685b7e$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === "object" && jsonObject.type === "json";
}
function $e174514ccd685b7e$var$defaultValueFromVariable(node) {
    throw new (0, $Tvg0H.InvariantError)(18);
}
function $e174514ccd685b7e$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $e174514ccd685b7e$var$defaultValueFromVariable;
    switch(node.kind){
        case "Variable":
            return onVariable(node);
        case "NullValue":
            return null;
        case "IntValue":
            return parseInt(node.value, 10);
        case "FloatValue":
            return parseFloat(node.value);
        case "ListValue":
            return node.values.map(function(v) {
                return $e174514ccd685b7e$export$b3db129ed867b445(v, onVariable);
            });
        case "ObjectValue":
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $e174514ccd685b7e$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $e174514ccd685b7e$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $e174514ccd685b7e$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $e174514ccd685b7e$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $e174514ccd685b7e$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === "Variable") {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $Tvg0H.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === "skip" ? !evaledValue : evaledValue;
    });
}
function $e174514ccd685b7e$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $dOVPe.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $e174514ccd685b7e$export$2dafb573e282fe8d(names, doc) {
    return $e174514ccd685b7e$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $e174514ccd685b7e$export$8d1e9e5bbfa5d09a(document) {
    return document && $e174514ccd685b7e$export$2dafb573e282fe8d([
        "client"
    ], document) && $e174514ccd685b7e$export$2dafb573e282fe8d([
        "export"
    ], document);
}
function $e174514ccd685b7e$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === "skip" || value === "include";
}
function $e174514ccd685b7e$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($e174514ccd685b7e$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $Tvg0H.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $Tvg0H.invariant)(ifArgument.name && ifArgument.name.value === "if", 15);
        var ifValue = ifArgument.value;
        (0, $Tvg0H.invariant)(ifValue && (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $e174514ccd685b7e$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === "OperationDefinition") throw new (0, $Tvg0H.InvariantError)(11);
        if (definition.kind === "FragmentDefinition") fragments.push(definition);
    });
    if (typeof actualFragmentName === "undefined") {
        (0, $Tvg0H.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, document), {
        definitions: (0, $l5MLt.__spreadArrays)([
            {
                kind: "OperationDefinition",
                operation: "query",
                selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                        {
                            kind: "FragmentSpread",
                            name: {
                                kind: "Name",
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $e174514ccd685b7e$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === "undefined" || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $e174514ccd685b7e$export$a92e7a440b22bdf0(doc) {
    $e174514ccd685b7e$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition" && definition.operation === "mutation";
    })[0];
    (0, $Tvg0H.invariant)(mutationDef, 1);
    return mutationDef;
}
function $e174514ccd685b7e$export$a7d0d8111d2386df(doc) {
    (0, $Tvg0H.invariant)(doc && doc.kind === "Document", 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== "FragmentDefinition";
    }).map(function(definition) {
        if (definition.kind !== "OperationDefinition") throw new (0, $Tvg0H.InvariantError)(3);
        return definition;
    });
    (0, $Tvg0H.invariant)(operations.length <= 1, 4);
    return doc;
}
function $e174514ccd685b7e$export$7a5b1fa979d2c158(doc) {
    $e174514ccd685b7e$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition";
    })[0];
}
function $e174514ccd685b7e$export$78a8e95d8d43ad7f(document) {
    var def = $e174514ccd685b7e$export$7a5b1fa979d2c158(document);
    (0, $Tvg0H.invariant)(def, 5);
    return def;
}
function $e174514ccd685b7e$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition" && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $e174514ccd685b7e$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "FragmentDefinition";
    });
}
function $e174514ccd685b7e$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $e174514ccd685b7e$export$7a5b1fa979d2c158(doc);
    (0, $Tvg0H.invariant)(queryDef && queryDef.operation === "query", 6);
    return queryDef;
}
function $e174514ccd685b7e$export$772111caef41b3f5(doc) {
    (0, $Tvg0H.invariant)(doc.kind === "Document", 7);
    (0, $Tvg0H.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $Tvg0H.invariant)(fragmentDef.kind === "FragmentDefinition", 9);
    return fragmentDef;
}
function $e174514ccd685b7e$export$f431198736b7f96d(queryDoc) {
    $e174514ccd685b7e$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === "OperationDefinition") {
            var operation = definition.operation;
            if (operation === "query" || operation === "mutation" || operation === "subscription") return definition;
        }
        if (definition.kind === "FragmentDefinition" && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $Tvg0H.InvariantError)(10);
}
function $e174514ccd685b7e$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $e174514ccd685b7e$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $e174514ccd685b7e$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $e174514ccd685b7e$export$e6e34fd1f2686227.apply(void 0, (0, $l5MLt.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $e174514ccd685b7e$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $e174514ccd685b7e$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $e174514ccd685b7e$var$TYPENAME_FIELD = {
    kind: "Field",
    name: {
        kind: "Name",
        value: "__typename"
    }
};
function $e174514ccd685b7e$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === "FragmentSpread" && $e174514ccd685b7e$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $e174514ccd685b7e$var$nullIfDocIsEmpty(doc) {
    return $e174514ccd685b7e$var$isEmpty($e174514ccd685b7e$export$7a5b1fa979d2c158(doc) || $e174514ccd685b7e$export$772111caef41b3f5(doc), $e174514ccd685b7e$export$193789b4c8246dd4($e174514ccd685b7e$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $e174514ccd685b7e$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $e174514ccd685b7e$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $e174514ccd685b7e$var$nullIfDocIsEmpty((0, $dOVPe.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== "VariableDefinition") variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($e174514ccd685b7e$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === "Variable") variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $e174514ccd685b7e$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($e174514ccd685b7e$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $e174514ccd685b7e$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $e174514ccd685b7e$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $e174514ccd685b7e$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $e174514ccd685b7e$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $e174514ccd685b7e$export$43b332f87950a467(doc) {
    return (0, $dOVPe.visit)($e174514ccd685b7e$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === "OperationDefinition") return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $e174514ccd685b7e$export$fb56ad75dd311c12(selection) && (selection.name.value === "__typename" || selection.name.value.lastIndexOf("__", 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($e174514ccd685b7e$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === "export";
                })) return;
                return (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, node), {
                    selections: (0, $l5MLt.__spreadArrays)(selections, [
                        $e174514ccd685b7e$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $e174514ccd685b7e$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === "connection";
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === "key";
        });
        return willRemove;
    }
};
function $e174514ccd685b7e$export$74985f3324559867(doc) {
    return $e174514ccd685b7e$export$e5ae0530da5fe96c([
        $e174514ccd685b7e$var$connectionRemoveConfig
    ], $e174514ccd685b7e$export$a7d0d8111d2386df(doc));
}
function $e174514ccd685b7e$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $e174514ccd685b7e$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $e174514ccd685b7e$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$e174514ccd685b7e$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($e174514ccd685b7e$var$getDirectiveMatcher(directives)) || nestedCheck && $e174514ccd685b7e$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $e174514ccd685b7e$export$deed3420cb5d2e1d(directives, doc) {
    $e174514ccd685b7e$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $e174514ccd685b7e$var$nullIfDocIsEmpty((0, $dOVPe.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join("-");
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $e174514ccd685b7e$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($e174514ccd685b7e$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $e174514ccd685b7e$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === "Variable" && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $e174514ccd685b7e$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $e174514ccd685b7e$var$getArgumentMatcher(config);
    return $e174514ccd685b7e$var$nullIfDocIsEmpty((0, $dOVPe.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $e174514ccd685b7e$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $e174514ccd685b7e$var$nullIfDocIsEmpty((0, $dOVPe.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $e174514ccd685b7e$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($e174514ccd685b7e$export$fb56ad75dd311c12(selection) || $e174514ccd685b7e$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $e174514ccd685b7e$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === "FragmentSpread") allFragments.push(selection);
    });
    return allFragments;
}
function $e174514ccd685b7e$export$57c368c23873f32b(document) {
    var definition = $e174514ccd685b7e$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === "query") return document;
    var modifiedDoc = (0, $dOVPe.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, node), {
                    operation: "query"
                });
            }
        }
    });
    return modifiedDoc;
}
function $e174514ccd685b7e$export$8eae69e876ee321e(document) {
    $e174514ccd685b7e$export$a7d0d8111d2386df(document);
    var modifiedDoc = $e174514ccd685b7e$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === "client";
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $dOVPe.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $e174514ccd685b7e$export$fb56ad75dd311c12(selection) && selection.name.value === "__typename";
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $e174514ccd685b7e$export$772fbc04a0ad4ce9 = typeof WeakMap === "function" && !(typeof navigator === "object" && navigator.product === "ReactNative");
var $e174514ccd685b7e$var$toString = Object.prototype.toString;
function $e174514ccd685b7e$export$629a2bd3f5a49ecc(value) {
    return $e174514ccd685b7e$var$cloneDeepHelper(value, new Map());
}
function $e174514ccd685b7e$var$cloneDeepHelper(val, seen) {
    switch($e174514ccd685b7e$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $e174514ccd685b7e$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $e174514ccd685b7e$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $e174514ccd685b7e$export$4bd44a2aa29d3d6e() {
    if (typeof $8ovux !== "undefined" && "production") return "production";
    return "development";
}
function $e174514ccd685b7e$export$f0cb0fda19c18b37(env) {
    return $e174514ccd685b7e$export$4bd44a2aa29d3d6e() === env;
}
function $e174514ccd685b7e$export$f15d00aa73aafac4() {
    return $e174514ccd685b7e$export$f0cb0fda19c18b37("production") === true;
}
function $e174514ccd685b7e$export$df77466336fe5355() {
    return $e174514ccd685b7e$export$f0cb0fda19c18b37("development") === true;
}
function $e174514ccd685b7e$export$410cbc2864fa25b5() {
    return $e174514ccd685b7e$export$f0cb0fda19c18b37("test") === true;
}
function $e174514ccd685b7e$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $e174514ccd685b7e$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $e174514ccd685b7e$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === "object" || typeof o[prop] === "function") && !Object.isFrozen(o[prop])) $e174514ccd685b7e$var$deepFreeze(o[prop]);
    });
    return o;
}
function $e174514ccd685b7e$export$7f9c177735b71f18(obj) {
    if ($e174514ccd685b7e$export$df77466336fe5355() || $e174514ccd685b7e$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === "function" && typeof Symbol("") === "string";
        if (!symbolIsPolyfilled) return $e174514ccd685b7e$var$deepFreeze(obj);
    }
    return obj;
}
var $e174514ccd685b7e$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $e174514ccd685b7e$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $e174514ccd685b7e$export$160070228be94b08(sources);
}
function $e174514ccd685b7e$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $e174514ccd685b7e$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $e174514ccd685b7e$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $e174514ccd685b7e$var$isObject(obj) {
    return obj !== null && typeof obj === "object";
}
function $e174514ccd685b7e$var$mergeHelper(target, source, pastCopies) {
    if ($e174514ccd685b7e$var$isObject(source) && $e174514ccd685b7e$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $e174514ccd685b7e$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($e174514ccd685b7e$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $e174514ccd685b7e$var$mergeHelper($e174514ccd685b7e$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $e174514ccd685b7e$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === "object" && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $l5MLt.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $e174514ccd685b7e$var$haveWarned = Object.create({});
function $e174514ccd685b7e$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = "warn";
    if (!$e174514ccd685b7e$export$f15d00aa73aafac4() && !$e174514ccd685b7e$var$haveWarned[msg]) {
        if (!$e174514ccd685b7e$export$410cbc2864fa25b5()) $e174514ccd685b7e$var$haveWarned[msg] = true;
        if (type === "error") console.error(msg);
        else console.warn(msg);
    }
}
function $e174514ccd685b7e$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}

});
parcelRegister("dOVPe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.visit = $a0fcccca537eeced$var$visit;
module.exports.visitInParallel = $a0fcccca537eeced$var$visitInParallel;
module.exports.getVisitFn = $a0fcccca537eeced$var$getVisitFn;
module.exports.BREAK = module.exports.QueryDocumentKeys = void 0;

var $a0fcccca537eeced$var$_inspect = $a0fcccca537eeced$var$_interopRequireDefault((parcelRequire("eybgR")));

var $8Emgj = parcelRequire("8Emgj");
function $a0fcccca537eeced$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a0fcccca537eeced$var$QueryDocumentKeys = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        // or removed in the future.
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "description",
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
module.exports.QueryDocumentKeys = $a0fcccca537eeced$var$QueryDocumentKeys;
var $a0fcccca537eeced$var$BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */ module.exports.BREAK = $a0fcccca537eeced$var$BREAK;
function $a0fcccca537eeced$var$visit(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $a0fcccca537eeced$var$QueryDocumentKeys;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $8Emgj.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $a0fcccca537eeced$var$_inspect.default)(node), "."));
            var visitFn = $a0fcccca537eeced$var$getVisitFn(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $a0fcccca537eeced$var$BREAK) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $8Emgj.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */ function $a0fcccca537eeced$var$visitInParallel(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $a0fcccca537eeced$var$getVisitFn(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $a0fcccca537eeced$var$BREAK) skipping[i] = $a0fcccca537eeced$var$BREAK;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $a0fcccca537eeced$var$getVisitFn(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $a0fcccca537eeced$var$BREAK) skipping[i] = $a0fcccca537eeced$var$BREAK;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */ function $a0fcccca537eeced$var$getVisitFn(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === "function") // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === "function") // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === "function") // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === "function") // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("eybgR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a97cfbd507561305$var$inspect;

var $a97cfbd507561305$var$_nodejsCustomInspectSymbol = $a97cfbd507561305$var$_interopRequireDefault((parcelRequire("idRrN")));
function $a97cfbd507561305$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a97cfbd507561305$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a97cfbd507561305$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $a97cfbd507561305$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a97cfbd507561305$var$_typeof(obj);
}
var $a97cfbd507561305$var$MAX_ARRAY_LENGTH = 10;
var $a97cfbd507561305$var$MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */ function $a97cfbd507561305$var$inspect(value) {
    return $a97cfbd507561305$var$formatValue(value, []);
}
function $a97cfbd507561305$var$formatValue(value, seenValues) {
    switch($a97cfbd507561305$var$_typeof(value)){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? "[function ".concat(value.name, "]") : "[function]";
        case "object":
            if (value === null) return "null";
            return $a97cfbd507561305$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $a97cfbd507561305$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return "[Circular]";
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $a97cfbd507561305$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === "string" ? customValue : $a97cfbd507561305$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $a97cfbd507561305$var$formatArray(value, seenValues);
    return $a97cfbd507561305$var$formatObject(value, seenValues);
}
function $a97cfbd507561305$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return "{}";
    if (seenValues.length > $a97cfbd507561305$var$MAX_RECURSIVE_DEPTH) return "[" + $a97cfbd507561305$var$getObjectTag(object) + "]";
    var properties = keys.map(function(key) {
        var value = $a97cfbd507561305$var$formatValue(object[key], seenValues);
        return key + ": " + value;
    });
    return "{ " + properties.join(", ") + " }";
}
function $a97cfbd507561305$var$formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > $a97cfbd507561305$var$MAX_RECURSIVE_DEPTH) return "[Array]";
    var len = Math.min($a97cfbd507561305$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($a97cfbd507561305$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return "[" + items.join(", ") + "]";
}
function $a97cfbd507561305$var$getCustomFn(object) {
    var customInspectFn = object[String($a97cfbd507561305$var$_nodejsCustomInspectSymbol.default)];
    if (typeof customInspectFn === "function") return customInspectFn;
    if (typeof object.inspect === "function") return object.inspect;
}
function $a97cfbd507561305$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        var name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}

});
parcelRegister("idRrN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $d442e66a812fdd53$var$nodejsCustomInspectSymbol = typeof Symbol === "function" && typeof Symbol.for === "function" ? Symbol.for("nodejs.util.inspect.custom") : undefined;
var $d442e66a812fdd53$var$_default = $d442e66a812fdd53$var$nodejsCustomInspectSymbol;
module.exports.default = $d442e66a812fdd53$var$_default;

});


parcelRegister("8Emgj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isNode = $64c353f8108a12c4$var$isNode;
module.exports.Token = module.exports.Location = void 0;

var $64c353f8108a12c4$var$_defineInspect = $64c353f8108a12c4$var$_interopRequireDefault((parcelRequire("ifbBA")));
function $64c353f8108a12c4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ var $64c353f8108a12c4$var$Location = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
module.exports.Location = $64c353f8108a12c4$var$Location;
(0, $64c353f8108a12c4$var$_defineInspect.default)($64c353f8108a12c4$var$Location);
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */ var $64c353f8108a12c4$var$Token = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
module.exports.Token = $64c353f8108a12c4$var$Token;
(0, $64c353f8108a12c4$var$_defineInspect.default)($64c353f8108a12c4$var$Token);
/**
 * @internal
 */ function $64c353f8108a12c4$var$isNode(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === "string";
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("ifbBA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d482a1401d96d47a$var$defineInspect;

var $d482a1401d96d47a$var$_invariant = $d482a1401d96d47a$var$_interopRequireDefault((parcelRequire("1H63r")));

var $d482a1401d96d47a$var$_nodejsCustomInspectSymbol = $d482a1401d96d47a$var$_interopRequireDefault((parcelRequire("idRrN")));
function $d482a1401d96d47a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * The `defineInspect()` function defines `inspect()` prototype method as alias of `toJSON`
 */ function $d482a1401d96d47a$var$defineInspect(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === "function" || (0, $d482a1401d96d47a$var$_invariant.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if ($d482a1401d96d47a$var$_nodejsCustomInspectSymbol.default) classObject.prototype[$d482a1401d96d47a$var$_nodejsCustomInspectSymbol.default] = fn;
}

});
parcelRegister("1H63r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $13be80def6651c79$var$invariant;
function $13be80def6651c79$var$invariant(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : "Unexpected invariant triggered.");
}

});




parcelRegister("4OFPo", function(module, exports) {

$parcel$export(module.exports, "equal", function () { return $381c4712242651b7$export$411ce8e5a71e3069; });
var $381c4712242651b7$var$_a = Object.prototype, $381c4712242651b7$var$toString = $381c4712242651b7$var$_a.toString, $381c4712242651b7$var$hasOwnProperty = $381c4712242651b7$var$_a.hasOwnProperty;
var $381c4712242651b7$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $381c4712242651b7$export$411ce8e5a71e3069(a, b) {
    try {
        return $381c4712242651b7$var$check(a, b);
    } finally{
        $381c4712242651b7$var$previousComparisons.clear();
    }
}
function $381c4712242651b7$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $381c4712242651b7$var$toString.call(a);
    var bTag = $381c4712242651b7$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case "[object Array]":
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case "[object Object]":
            if ($381c4712242651b7$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$381c4712242651b7$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$381c4712242651b7$var$check(a[key], b[key])) return false;
            }
            return true;
        case "[object Error]":
            return a.name === b.name && a.message === b.message;
        case "[object Number]":
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case "[object Boolean]":
        case "[object Date]":
            return +a === +b;
        case "[object RegExp]":
        case "[object String]":
            return a == "" + b;
        case "[object Map]":
        case "[object Set]":
            if (a.size !== b.size) return false;
            if ($381c4712242651b7$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === "[object Map]";
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$381c4712242651b7$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $381c4712242651b7$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $381c4712242651b7$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $381c4712242651b7$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $381c4712242651b7$export$2e2bcd8739ae039 = $381c4712242651b7$export$411ce8e5a71e3069;

});


parcelRegister("cHmNF", function(module, exports) {

$parcel$export(module.exports, "fromError", function () { return fromError; });
$parcel$export(module.exports, "ApolloLink", function () { return ApolloLink; });
$parcel$export(module.exports, "from", function () { return from; });
$parcel$export(module.exports, "execute", function () { return execute; });
$parcel$export(module.exports, "Observable", function () { return (parcelRequire("jTh3A")).default; });

var $jTh3A = parcelRequire("jTh3A");

var $Tvg0H = parcelRequire("Tvg0H");

var $l5MLt = parcelRequire("l5MLt");

var $jm5tp = parcelRequire("jm5tp");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        "query",
        "operationName",
        "variables",
        "extensions",
        "context"
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $Tvg0H.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, $l5MLt.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, $jTh3A.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, $jTh3A.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== "string" ? (0, $jm5tp.getOperationName)(transformedOperation.query) : "";
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, $l5MLt.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === "function") context = (0, $l5MLt.__assign)({}, context, next(context));
        else context = (0, $l5MLt.__assign)({}, context, next);
    };
    var getContext = function() {
        return (0, $l5MLt.__assign)({}, context);
    };
    Object.defineProperty(operation, "setContext", {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, "getContext", {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, "toKey", {
        enumerable: false,
        value: function() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, $jTh3A.default).of();
}
function toLink(handler) {
    return typeof handler === "function" ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, $jTh3A.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $jTh3A.default).of() : rightLink.request(operation) || (0, $jTh3A.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $jTh3A.default).of() : rightLink.request(operation, forward) || (0, $jTh3A.default).of();
    });
}
var concat = function(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $jTh3A.default).of();
        }) || (0, $jTh3A.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $jTh3A.default).of();
        }) || (0, $jTh3A.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $Tvg0H.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, $jTh3A.default).of();
}

});
parcelRegister("jTh3A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7b062821ea72061$export$2e2bcd8739ae039; });

var $9KtXo = parcelRequire("9KtXo");
var $e7b062821ea72061$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($9KtXo)));
var $e7b062821ea72061$export$2e2bcd8739ae039 = $e7b062821ea72061$export$77cea355fa80b5f4;

});
parcelRegister("9KtXo", function(module, exports) {

module.exports = (parcelRequire("5pb9u")).Observable;

});
parcelRegister("5pb9u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $3ef7f01d11360bee$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3ef7f01d11360bee$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3ef7f01d11360bee$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3ef7f01d11360bee$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3ef7f01d11360bee$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $3ef7f01d11360bee$var$hasSymbols = function() {
    return typeof Symbol === "function";
};
var $3ef7f01d11360bee$var$hasSymbol = function(name) {
    return $3ef7f01d11360bee$var$hasSymbols() && Boolean(Symbol[name]);
};
var $3ef7f01d11360bee$var$getSymbol = function(name) {
    return $3ef7f01d11360bee$var$hasSymbol(name) ? Symbol[name] : "@@" + name;
};
if ($3ef7f01d11360bee$var$hasSymbols() && !$3ef7f01d11360bee$var$hasSymbol("observable")) Symbol.observable = Symbol("observable");
var $3ef7f01d11360bee$var$SymbolIterator = $3ef7f01d11360bee$var$getSymbol("iterator");
var $3ef7f01d11360bee$var$SymbolObservable = $3ef7f01d11360bee$var$getSymbol("observable");
var $3ef7f01d11360bee$var$SymbolSpecies = $3ef7f01d11360bee$var$getSymbol("species"); // === Abstract Operations ===
function $3ef7f01d11360bee$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== "function") throw new TypeError(value + " is not a function");
    return value;
}
function $3ef7f01d11360bee$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$3ef7f01d11360bee$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $3ef7f01d11360bee$var$Observable;
}
function $3ef7f01d11360bee$var$isObservable(x) {
    return x instanceof $3ef7f01d11360bee$var$Observable; // SPEC: Brand check
}
function $3ef7f01d11360bee$var$hostReportError(e) {
    if ($3ef7f01d11360bee$var$hostReportError.log) $3ef7f01d11360bee$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $3ef7f01d11360bee$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $3ef7f01d11360bee$var$hostReportError(e);
        }
    });
}
function $3ef7f01d11360bee$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === "function") cleanup();
        else {
            var unsubscribe = $3ef7f01d11360bee$var$getMethod(cleanup, "unsubscribe");
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $3ef7f01d11360bee$var$hostReportError(e);
    }
}
function $3ef7f01d11360bee$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = "closed";
}
function $3ef7f01d11360bee$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = "ready";
    for(var i = 0; i < queue.length; ++i){
        $3ef7f01d11360bee$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === "closed") break;
    }
}
function $3ef7f01d11360bee$var$notifySubscription(subscription, type, value) {
    subscription._state = "running";
    var observer = subscription._observer;
    try {
        var m = $3ef7f01d11360bee$var$getMethod(observer, type);
        switch(type){
            case "next":
                if (m) m.call(observer, value);
                break;
            case "error":
                $3ef7f01d11360bee$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case "complete":
                $3ef7f01d11360bee$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $3ef7f01d11360bee$var$hostReportError(e);
    }
    if (subscription._state === "closed") $3ef7f01d11360bee$var$cleanupSubscription(subscription);
    else if (subscription._state === "running") subscription._state = "ready";
}
function $3ef7f01d11360bee$var$onNotify(subscription, type, value) {
    if (subscription._state === "closed") return;
    if (subscription._state === "buffering") {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== "ready") {
        subscription._state = "buffering";
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $3ef7f01d11360bee$var$enqueue(function() {
            return $3ef7f01d11360bee$var$flushSubscription(subscription);
        });
        return;
    }
    $3ef7f01d11360bee$var$notifySubscription(subscription, type, value);
}
var $3ef7f01d11360bee$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $3ef7f01d11360bee$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = "initializing";
        var subscriptionObserver = new $3ef7f01d11360bee$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === "initializing") this._state = "ready";
    }
    $3ef7f01d11360bee$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== "closed") {
                    $3ef7f01d11360bee$var$closeSubscription(this);
                    $3ef7f01d11360bee$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === "closed";
            }
        }
    ]);
    return Subscription;
}();
var $3ef7f01d11360bee$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $3ef7f01d11360bee$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $3ef7f01d11360bee$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $3ef7f01d11360bee$var$onNotify(this._subscription, "next", value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $3ef7f01d11360bee$var$onNotify(this._subscription, "error", value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $3ef7f01d11360bee$var$onNotify(this._subscription, "complete");
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === "closed";
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $3ef7f01d11360bee$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $3ef7f01d11360bee$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError("Observable cannot be called as a function");
        if (typeof subscriber !== "function") throw new TypeError("Observable initializer must be a function");
        this._subscriber = subscriber;
    }
    $3ef7f01d11360bee$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $3ef7f01d11360bee$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== "function") {
                        reject(new TypeError(fn + " is not a function"));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = $3ef7f01d11360bee$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = $3ef7f01d11360bee$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = $3ef7f01d11360bee$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError("Cannot reduce an empty sequence"));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $3ef7f01d11360bee$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = $3ef7f01d11360bee$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $3ef7f01d11360bee$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === "function" ? this : Observable;
                if (x == null) throw new TypeError(x + " is not an object");
                var method = $3ef7f01d11360bee$var$getMethod(x, $3ef7f01d11360bee$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + " is not an object");
                    if ($3ef7f01d11360bee$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($3ef7f01d11360bee$var$hasSymbol("iterator")) {
                    method = $3ef7f01d11360bee$var$getMethod(x, $3ef7f01d11360bee$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $3ef7f01d11360bee$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $3ef7f01d11360bee$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + " is not observable");
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === "function" ? this : Observable;
                return new C(function(observer) {
                    $3ef7f01d11360bee$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $3ef7f01d11360bee$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $3ef7f01d11360bee$var$Observable;
if ($3ef7f01d11360bee$var$hasSymbols()) Object.defineProperty($3ef7f01d11360bee$var$Observable, Symbol("extensions"), {
    value: {
        symbol: $3ef7f01d11360bee$var$SymbolObservable,
        hostReportError: $3ef7f01d11360bee$var$hostReportError
    },
    configurable: true
});

});




parcelRegister("8tqiY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62b56fc89d937f3d$export$2e2bcd8739ae039; });
/* global window */ 
var $g5YNW = parcelRequire("g5YNW");
var root;
if (typeof self !== "undefined") root = self;
else if (typeof window !== "undefined") root = window;
else if (typeof $parcel$global !== "undefined") root = $parcel$global;
else root = module;
var result = (0, $g5YNW.default)(root);
var $62b56fc89d937f3d$export$2e2bcd8739ae039 = result;

});
parcelRegister("g5YNW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb7c477eee6c0e8a$export$2e2bcd8739ae039; });
function $bb7c477eee6c0e8a$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === "function") {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol("observable");
            Symbol.observable = result;
        }
    } else result = "@@observable";
    return result;
}

});




parcelRegister("3FUVb", function(module, exports) {

$parcel$export(module.exports, "useMutation", function () { return $2ad15ad1e71bf317$export$609860bf8b0084c; });

var $9nHZC = parcelRequire("9nHZC");

var $lLsFN = parcelRequire("lLsFN");

var $59ZFR = parcelRequire("59ZFR");

var $hjQ5h = parcelRequire("hjQ5h");
var $2ad15ad1e71bf317$export$609860bf8b0084c = function useMutation() {
    var _apolloResult$;
    var ufoContext = (0, $9nHZC.useContext)((0, $59ZFR.default));
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var apolloResult = (0, $lLsFN.useMutation).apply(void 0, args);
    var query = args[0];
    var operationName = (0, $hjQ5h.default)(query);
    var isLoading = apolloResult === null || apolloResult === void 0 || (_apolloResult$ = apolloResult[1]) === null || _apolloResult$ === void 0 ? void 0 : _apolloResult$.loading;
    (0, $9nHZC.useEffect)(function() {
        if (isLoading) return ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.hold(operationName);
    }, [
        isLoading,
        operationName,
        ufoContext
    ]);
    return apolloResult;
};

});
parcelRegister("hjQ5h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9bc9cd9d9843417$export$2e2bcd8739ae039; });
function $c9bc9cd9d9843417$export$2e2bcd8739ae039(gqlQueryNode) {
    var _gqlQueryNode$definit, _ref, _operationDef$name;
    var operationDef = gqlQueryNode === null || gqlQueryNode === void 0 || (_gqlQueryNode$definit = gqlQueryNode.definitions) === null || _gqlQueryNode$definit === void 0 ? void 0 : _gqlQueryNode$definit.find(function(d) {
        return d.kind === "OperationDefinition" && d.name;
    });
    var operationName = (_ref = (operationDef === null || operationDef === void 0 ? void 0 : operationDef.kind) === "OperationDefinition" ? operationDef === null || operationDef === void 0 || (_operationDef$name = operationDef.name) === null || _operationDef$name === void 0 ? void 0 : _operationDef$name.value : undefined) !== null && _ref !== void 0 ? _ref : "unnamed";
    return operationName;
}

});


parcelRegister("2U6Qd", function(module, exports) {

$parcel$export(module.exports, "useQuery", function () { return $21d61e3c007f4d83$export$dd0a697e1782aedd; });

var $9nHZC = parcelRequire("9nHZC");

var $lLsFN = parcelRequire("lLsFN");

var $59ZFR = parcelRequire("59ZFR");

var $hjQ5h = parcelRequire("hjQ5h");
var $21d61e3c007f4d83$export$dd0a697e1782aedd = function useQuery() {
    var ufoContext = (0, $9nHZC.useContext)((0, $59ZFR.default));
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var apolloResult = (0, $lLsFN.useQuery).apply(void 0, args);
    var query = args[0];
    var operationName = (0, $hjQ5h.default)(query);
    var isLoading = apolloResult === null || apolloResult === void 0 ? void 0 : apolloResult.loading;
    (0, $9nHZC.useEffect)(function() {
        if (isLoading) return ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.hold(operationName);
    }, [
        isLoading,
        operationName,
        ufoContext
    ]);
    return apolloResult;
};

});


parcelRegister("gbiiY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc7bdf6821eea346$export$2e2bcd8739ae039; });

var $76bPa = parcelRequire("76bPa");

var $cM3J6 = parcelRequire("cM3J6");
var $bc7bdf6821eea346$var$docCache = new Map();
var $bc7bdf6821eea346$var$fragmentSourceMap = new Map();
var $bc7bdf6821eea346$var$printFragmentWarnings = true;
var $bc7bdf6821eea346$var$experimentalFragmentVariables = false;
function $bc7bdf6821eea346$var$normalize(string) {
    return string.replace(/[\s,]+/g, " ").trim();
}
function $bc7bdf6821eea346$var$cacheKeyFromLoc(loc) {
    return $bc7bdf6821eea346$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $bc7bdf6821eea346$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === "FragmentDefinition") {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $bc7bdf6821eea346$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $bc7bdf6821eea346$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($bc7bdf6821eea346$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $bc7bdf6821eea346$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $76bPa.__assign)((0, $76bPa.__assign)({}, ast), {
        definitions: definitions
    });
}
function $bc7bdf6821eea346$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === "object") workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $bc7bdf6821eea346$var$parseDocument(source) {
    var cacheKey = $bc7bdf6821eea346$var$normalize(source);
    if (!$bc7bdf6821eea346$var$docCache.has(cacheKey)) {
        var parsed = (0, $cM3J6.parse)(source, {
            experimentalFragmentVariables: $bc7bdf6821eea346$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $bc7bdf6821eea346$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== "Document") throw new Error("Not a valid GraphQL document.");
        $bc7bdf6821eea346$var$docCache.set(cacheKey, $bc7bdf6821eea346$var$stripLoc($bc7bdf6821eea346$var$processFragments(parsed)));
    }
    return $bc7bdf6821eea346$var$docCache.get(cacheKey);
}
function $bc7bdf6821eea346$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === "string") literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === "Document") result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $bc7bdf6821eea346$var$parseDocument(result);
}
function $bc7bdf6821eea346$export$657554ef4dc7ac2d() {
    $bc7bdf6821eea346$var$docCache.clear();
    $bc7bdf6821eea346$var$fragmentSourceMap.clear();
}
function $bc7bdf6821eea346$export$e4294e638636c6ab() {
    $bc7bdf6821eea346$var$printFragmentWarnings = false;
}
function $bc7bdf6821eea346$export$78cf889af350c840() {
    $bc7bdf6821eea346$var$experimentalFragmentVariables = true;
}
function $bc7bdf6821eea346$export$5290df9bbbd3cfa() {
    $bc7bdf6821eea346$var$experimentalFragmentVariables = false;
}
var $bc7bdf6821eea346$var$extras = {
    gql: $bc7bdf6821eea346$export$72e4926bf8358653,
    resetCaches: $bc7bdf6821eea346$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $bc7bdf6821eea346$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $bc7bdf6821eea346$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $bc7bdf6821eea346$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $bc7bdf6821eea346$var$extras.gql, gql_1.resetCaches = $bc7bdf6821eea346$var$extras.resetCaches, gql_1.disableFragmentWarnings = $bc7bdf6821eea346$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $bc7bdf6821eea346$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $bc7bdf6821eea346$var$extras.disableExperimentalFragmentVariables;
})($bc7bdf6821eea346$export$72e4926bf8358653 || ($bc7bdf6821eea346$export$72e4926bf8358653 = {}));
$bc7bdf6821eea346$export$72e4926bf8358653["default"] = $bc7bdf6821eea346$export$72e4926bf8358653;
var $bc7bdf6821eea346$export$2e2bcd8739ae039 = $bc7bdf6821eea346$export$72e4926bf8358653;

});
parcelRegister("76bPa", function(module, exports) {

$parcel$export(module.exports, "__assign", function () { return $52b2440006d3a14b$export$18ce0697a983be9b; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $52b2440006d3a14b$var$extendStatics = function(d, b) {
    $52b2440006d3a14b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $52b2440006d3a14b$var$extendStatics(d, b);
};
function $52b2440006d3a14b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $52b2440006d3a14b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $52b2440006d3a14b$export$18ce0697a983be9b = function() {
    $52b2440006d3a14b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $52b2440006d3a14b$export$18ce0697a983be9b.apply(this, arguments);
};
function $52b2440006d3a14b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $52b2440006d3a14b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $52b2440006d3a14b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $52b2440006d3a14b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $52b2440006d3a14b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $52b2440006d3a14b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $52b2440006d3a14b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $52b2440006d3a14b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $52b2440006d3a14b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $52b2440006d3a14b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $52b2440006d3a14b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $52b2440006d3a14b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $52b2440006d3a14b$export$45d3717a4c69092e(o, m, p);
}
function $52b2440006d3a14b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $52b2440006d3a14b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $52b2440006d3a14b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($52b2440006d3a14b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $52b2440006d3a14b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $52b2440006d3a14b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $52b2440006d3a14b$export$10c90e4f7922046c(v) {
    return this instanceof $52b2440006d3a14b$export$10c90e4f7922046c ? (this.v = v, this) : new $52b2440006d3a14b$export$10c90e4f7922046c(v);
}
function $52b2440006d3a14b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $52b2440006d3a14b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $52b2440006d3a14b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $52b2440006d3a14b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $52b2440006d3a14b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $52b2440006d3a14b$export$19a8beecd37a4c45 === "function" ? $52b2440006d3a14b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $52b2440006d3a14b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $52b2440006d3a14b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $52b2440006d3a14b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $52b2440006d3a14b$export$45d3717a4c69092e(result, mod, k);
    }
    $52b2440006d3a14b$var$__setModuleDefault(result, mod);
    return result;
}
function $52b2440006d3a14b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $52b2440006d3a14b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $52b2440006d3a14b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $52b2440006d3a14b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $52b2440006d3a14b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $52b2440006d3a14b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $52b2440006d3a14b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $52b2440006d3a14b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $52b2440006d3a14b$export$2e2bcd8739ae039 = {
    __extends: $52b2440006d3a14b$export$a8ba968b8961cb8a,
    __assign: $52b2440006d3a14b$export$18ce0697a983be9b,
    __rest: $52b2440006d3a14b$export$3c9a16f847548506,
    __decorate: $52b2440006d3a14b$export$29e00dfd3077644b,
    __param: $52b2440006d3a14b$export$d5ad3fd78186038f,
    __metadata: $52b2440006d3a14b$export$f1db080c865becb9,
    __awaiter: $52b2440006d3a14b$export$1050f835b63b671e,
    __generator: $52b2440006d3a14b$export$67ebef60e6f28a6,
    __createBinding: $52b2440006d3a14b$export$45d3717a4c69092e,
    __exportStar: $52b2440006d3a14b$export$f33643c0debef087,
    __values: $52b2440006d3a14b$export$19a8beecd37a4c45,
    __read: $52b2440006d3a14b$export$8d051b38c9118094,
    __spread: $52b2440006d3a14b$export$afc72e2116322959,
    __spreadArrays: $52b2440006d3a14b$export$6388937ca91ccae8,
    __spreadArray: $52b2440006d3a14b$export$1216008129fb82ed,
    __await: $52b2440006d3a14b$export$10c90e4f7922046c,
    __asyncGenerator: $52b2440006d3a14b$export$e427f37a30a4de9b,
    __asyncDelegator: $52b2440006d3a14b$export$bbd80228419bb833,
    __asyncValues: $52b2440006d3a14b$export$e3b29a3d6162315f,
    __makeTemplateObject: $52b2440006d3a14b$export$4fb47efe1390b86f,
    __importStar: $52b2440006d3a14b$export$c21735bcef00d192,
    __importDefault: $52b2440006d3a14b$export$da59b14a69baef04,
    __classPrivateFieldGet: $52b2440006d3a14b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $52b2440006d3a14b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $52b2440006d3a14b$export$81fdc39f203e4e04,
    __addDisposableResource: $52b2440006d3a14b$export$88ac25d8e944e405,
    __disposeResources: $52b2440006d3a14b$export$8f076105dc360e92
};

});

parcelRegister("cM3J6", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $7935f872110c293d$export$98e6a39c04603d36; });

var $hVZrm = parcelRequire("hVZrm");

var $bejjD = parcelRequire("bejjD");

var $cr92G = parcelRequire("cr92G");

var $1PhYp = parcelRequire("1PhYp");

var $edwOT = parcelRequire("edwOT");

var $25YVd = parcelRequire("25YVd");

var $ltW8y = parcelRequire("ltW8y");
function $7935f872110c293d$export$98e6a39c04603d36(source, options) {
    var parser = new $7935f872110c293d$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $7935f872110c293d$export$5303528d1070ff6f(source, options) {
    var parser = new $7935f872110c293d$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $1PhYp.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $1PhYp.TokenKind).EOF);
    return value;
}
function $7935f872110c293d$export$28b8f402ccc88182(source, options) {
    var parser = new $7935f872110c293d$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $1PhYp.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $1PhYp.TokenKind).EOF);
    return type;
}
var $7935f872110c293d$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $edwOT.isSource)(source) ? source : new (0, $edwOT.Source)(source);
        this._lexer = new (0, $ltW8y.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $1PhYp.TokenKind).NAME);
        return {
            kind: (0, $bejjD.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $bejjD.Kind).DOCUMENT,
            definitions: this.many((0, $1PhYp.TokenKind).SOF, this.parseDefinition, (0, $1PhYp.TokenKind).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $1PhYp.TokenKind).NAME)) switch(this._lexer.token.value){
            case "query":
            case "mutation":
            case "subscription":
                return this.parseOperationDefinition();
            case "fragment":
                return this.parseFragmentDefinition();
            case "schema":
            case "scalar":
            case "type":
            case "interface":
            case "union":
            case "enum":
            case "input":
            case "directive":
                return this.parseTypeSystemDefinition();
            case "extend":
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $1PhYp.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $1PhYp.TokenKind).BRACE_L)) return {
            kind: (0, $bejjD.Kind).OPERATION_DEFINITION,
            operation: "query",
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $1PhYp.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $bejjD.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $1PhYp.TokenKind).NAME);
        switch(operationToken.value){
            case "query":
                return "query";
            case "mutation":
                return "mutation";
            case "subscription":
                return "subscription";
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $1PhYp.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $1PhYp.TokenKind).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $bejjD.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $1PhYp.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $1PhYp.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $1PhYp.TokenKind).DOLLAR);
        return {
            kind: (0, $bejjD.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $bejjD.Kind).SELECTION_SET,
            selections: this.many((0, $1PhYp.TokenKind).BRACE_L, this.parseSelection, (0, $1PhYp.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $1PhYp.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $1PhYp.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $bejjD.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $1PhYp.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $1PhYp.TokenKind).PAREN_L, item, (0, $1PhYp.TokenKind).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $1PhYp.TokenKind).COLON);
        return {
            kind: (0, $bejjD.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $bejjD.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $1PhYp.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $1PhYp.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword("on");
        if (!hasTypeCondition && this.peek((0, $1PhYp.TokenKind).NAME)) return {
            kind: (0, $bejjD.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $bejjD.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword("fragment"); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $bejjD.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $bejjD.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === "on") throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $1PhYp.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $1PhYp.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $1PhYp.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $bejjD.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $1PhYp.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $bejjD.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $1PhYp.TokenKind).STRING:
            case (0, $1PhYp.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $1PhYp.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case "true":
                        return {
                            kind: (0, $bejjD.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case "false":
                        return {
                            kind: (0, $bejjD.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case "null":
                        return {
                            kind: (0, $bejjD.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $bejjD.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $1PhYp.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $bejjD.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $1PhYp.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $bejjD.Kind).LIST,
            values: this.any((0, $1PhYp.TokenKind).BRACKET_L, item, (0, $1PhYp.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $bejjD.Kind).OBJECT,
            fields: this.any((0, $1PhYp.TokenKind).BRACE_L, item, (0, $1PhYp.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $1PhYp.TokenKind).COLON);
        return {
            kind: (0, $bejjD.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $1PhYp.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $1PhYp.TokenKind).AT);
        return {
            kind: (0, $bejjD.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $1PhYp.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $1PhYp.TokenKind).BRACKET_R);
            type = {
                kind: (0, $bejjD.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $1PhYp.TokenKind).BANG)) return {
            kind: (0, $bejjD.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $bejjD.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $1PhYp.TokenKind).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaDefinition();
            case "scalar":
                return this.parseScalarTypeDefinition();
            case "type":
                return this.parseObjectTypeDefinition();
            case "interface":
                return this.parseInterfaceTypeDefinition();
            case "union":
                return this.parseUnionTypeDefinition();
            case "enum":
                return this.parseEnumTypeDefinition();
            case "input":
                return this.parseInputObjectTypeDefinition();
            case "directive":
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $1PhYp.TokenKind).STRING) || this.peek((0, $1PhYp.TokenKind).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("schema");
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $1PhYp.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $1PhYp.TokenKind).BRACE_R);
        return {
            kind: (0, $bejjD.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $1PhYp.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $bejjD.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("scalar");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $bejjD.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("type");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $bejjD.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword("implements")) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $1PhYp.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $1PhYp.TokenKind).AMP) || this.peek((0, $1PhYp.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, $1PhYp.TokenKind).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $1PhYp.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $1PhYp.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $1PhYp.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $1PhYp.TokenKind).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $1PhYp.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $bejjD.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $1PhYp.TokenKind).PAREN_L, this.parseInputValueDef, (0, $1PhYp.TokenKind).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $1PhYp.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $1PhYp.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $bejjD.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("interface");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $bejjD.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("union");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $bejjD.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $1PhYp.TokenKind).EQUALS) ? this.delimitedMany((0, $1PhYp.TokenKind).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("enum");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $bejjD.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $1PhYp.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $1PhYp.TokenKind).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $bejjD.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("input");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $bejjD.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $1PhYp.TokenKind).BRACE_L, this.parseInputValueDef, (0, $1PhYp.TokenKind).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $1PhYp.TokenKind).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaExtension();
            case "scalar":
                return this.parseScalarTypeExtension();
            case "type":
                return this.parseObjectTypeExtension();
            case "interface":
                return this.parseInterfaceTypeExtension();
            case "union":
                return this.parseUnionTypeExtension();
            case "enum":
                return this.parseEnumTypeExtension();
            case "input":
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("schema");
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $1PhYp.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $1PhYp.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $bejjD.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("scalar");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $bejjD.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("type");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $bejjD.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("interface");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $bejjD.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("union");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $bejjD.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("enum");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $bejjD.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("input");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $bejjD.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("directive");
        this.expectToken((0, $1PhYp.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword("repeatable");
        this.expectKeyword("on");
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $bejjD.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $1PhYp.TokenKind).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $25YVd.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $cr92G.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $hVZrm.syntaxError)(this._lexer.source, token.start, "Expected ".concat($7935f872110c293d$var$getTokenKindDesc(kind), ", found ").concat($7935f872110c293d$var$getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $1PhYp.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $hVZrm.syntaxError)(this._lexer.source, token.start, 'Expected "'.concat(value, '", found ').concat($7935f872110c293d$var$getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $1PhYp.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $hVZrm.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($7935f872110c293d$var$getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $7935f872110c293d$var$getTokenDesc(token) {
    var value = token.value;
    return $7935f872110c293d$var$getTokenKindDesc(token.kind) + (value != null ? ' "'.concat(value, '"') : "");
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $7935f872110c293d$var$getTokenKindDesc(kind) {
    return (0, $ltW8y.isPunctuatorTokenKind)(kind) ? '"'.concat(kind, '"') : kind;
}

});
parcelRegister("hVZrm", function(module, exports) {

$parcel$export(module.exports, "syntaxError", function () { return $65070066b9557f1e$export$bbee0c6176c019d4; });

var $3GgvN = parcelRequire("3GgvN");
function $65070066b9557f1e$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $3GgvN.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("3GgvN", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", function () { return $3e1032629a6ec70d$export$92d6ed0888e7cb7f; });

var $frMqO = parcelRequire("frMqO");

var $59GJs = parcelRequire("59GJs");

var $df9N3 = parcelRequire("df9N3");

var $2e42F = parcelRequire("2e42F");
function $3e1032629a6ec70d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $3e1032629a6ec70d$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $3e1032629a6ec70d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $3e1032629a6ec70d$var$_typeof(obj);
}
function $3e1032629a6ec70d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3e1032629a6ec70d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3e1032629a6ec70d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3e1032629a6ec70d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3e1032629a6ec70d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $3e1032629a6ec70d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $3e1032629a6ec70d$var$_setPrototypeOf(subClass, superClass);
}
function $3e1032629a6ec70d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3e1032629a6ec70d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $3e1032629a6ec70d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $3e1032629a6ec70d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $3e1032629a6ec70d$var$_possibleConstructorReturn(this, result);
    };
}
function $3e1032629a6ec70d$var$_possibleConstructorReturn(self, call) {
    if (call && ($3e1032629a6ec70d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $3e1032629a6ec70d$var$_assertThisInitialized(self);
}
function $3e1032629a6ec70d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3e1032629a6ec70d$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $3e1032629a6ec70d$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$3e1032629a6ec70d$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $3e1032629a6ec70d$var$_construct(Class, arguments, $3e1032629a6ec70d$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $3e1032629a6ec70d$var$_setPrototypeOf(Wrapper, Class);
    };
    return $3e1032629a6ec70d$var$_wrapNativeSuper(Class);
}
function $3e1032629a6ec70d$var$_construct(Parent, args, Class) {
    if ($3e1032629a6ec70d$var$_isNativeReflectConstruct()) $3e1032629a6ec70d$var$_construct = Reflect.construct;
    else $3e1032629a6ec70d$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $3e1032629a6ec70d$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $3e1032629a6ec70d$var$_construct.apply(null, arguments);
}
function $3e1032629a6ec70d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3e1032629a6ec70d$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $3e1032629a6ec70d$var$_setPrototypeOf(o, p) {
    $3e1032629a6ec70d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3e1032629a6ec70d$var$_setPrototypeOf(o, p);
}
function $3e1032629a6ec70d$var$_getPrototypeOf(o) {
    $3e1032629a6ec70d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3e1032629a6ec70d$var$_getPrototypeOf(o);
}
var $3e1032629a6ec70d$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $3e1032629a6ec70d$var$_inherits(GraphQLError, _Error);
    var _super = $3e1032629a6ec70d$var$_createSuper(GraphQLError);
    /**
   * A message describing the Error for debugging purposes.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   *
   * Note: should be treated as readonly, despite invariant usage.
   */ /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _locations2, _source2, _positions2, _extensions2;
        var _this;
        $3e1032629a6ec70d$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message); // Compute list of blame nodes.
        var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [
            nodes
        ] : undefined; // Compute locations in the source for the given nodes/positions.
        var _source = source;
        if (!_source && _nodes) {
            var _nodes$0$loc;
            _source = (_nodes$0$loc = _nodes[0].loc) === null || _nodes$0$loc === void 0 ? void 0 : _nodes$0$loc.source;
        }
        var _positions = positions;
        if (!_positions && _nodes) _positions = _nodes.reduce(function(list, node) {
            if (node.loc) list.push(node.loc.start);
            return list;
        }, []);
        if (_positions && _positions.length === 0) _positions = undefined;
        var _locations;
        if (positions && source) _locations = positions.map(function(pos) {
            return (0, $df9N3.getLocation)(source, pos);
        });
        else if (_nodes) _locations = _nodes.reduce(function(list, node) {
            if (node.loc) list.push((0, $df9N3.getLocation)(node.loc.source, node.loc.start));
            return list;
        }, []);
        var _extensions = extensions;
        if (_extensions == null && originalError != null) {
            var originalExtensions = originalError.extensions;
            if ((0, $frMqO.default)(originalExtensions)) _extensions = originalExtensions;
        }
        Object.defineProperties($3e1032629a6ec70d$var$_assertThisInitialized(_this), {
            name: {
                value: "GraphQLError"
            },
            message: {
                value: message,
                // By being enumerable, JSON.stringify will include `message` in the
                // resulting output. This ensures that the simplest possible GraphQL
                // service adheres to the spec.
                enumerable: true,
                writable: true
            },
            locations: {
                // Coercing falsy values to undefined ensures they will not be included
                // in JSON.stringify() when not provided.
                value: (_locations2 = _locations) !== null && _locations2 !== void 0 ? _locations2 : undefined,
                // By being enumerable, JSON.stringify will include `locations` in the
                // resulting output. This ensures that the simplest possible GraphQL
                // service adheres to the spec.
                enumerable: _locations != null
            },
            path: {
                // Coercing falsy values to undefined ensures they will not be included
                // in JSON.stringify() when not provided.
                value: path !== null && path !== void 0 ? path : undefined,
                // By being enumerable, JSON.stringify will include `path` in the
                // resulting output. This ensures that the simplest possible GraphQL
                // service adheres to the spec.
                enumerable: path != null
            },
            nodes: {
                value: _nodes !== null && _nodes !== void 0 ? _nodes : undefined
            },
            source: {
                value: (_source2 = _source) !== null && _source2 !== void 0 ? _source2 : undefined
            },
            positions: {
                value: (_positions2 = _positions) !== null && _positions2 !== void 0 ? _positions2 : undefined
            },
            originalError: {
                value: originalError
            },
            extensions: {
                // Coercing falsy values to undefined ensures they will not be included
                // in JSON.stringify() when not provided.
                value: (_extensions2 = _extensions) !== null && _extensions2 !== void 0 ? _extensions2 : undefined,
                // By being enumerable, JSON.stringify will include `path` in the
                // resulting output. This ensures that the simplest possible GraphQL
                // service adheres to the spec.
                enumerable: _extensions != null
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($3e1032629a6ec70d$var$_assertThisInitialized(_this), "stack", {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $3e1032629a6ec70d$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($3e1032629a6ec70d$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($3e1032629a6ec70d$var$_assertThisInitialized(_this), "stack", {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $3e1032629a6ec70d$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $3e1032629a6ec70d$export$55ee1551a3f962e6(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $59GJs.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return "Object";
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $3e1032629a6ec70d$var$_wrapNativeSuper(Error));
function $3e1032629a6ec70d$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i2 = 0, _error$nodes2 = error.nodes; _i2 < _error$nodes2.length; _i2++){
        var node = _error$nodes2[_i2];
        if (node.loc) output += "\n\n" + (0, $2e42F.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i4 = 0, _error$locations2 = error.locations; _i4 < _error$locations2.length; _i4++){
        var location = _error$locations2[_i4];
        output += "\n\n" + (0, $2e42F.printSourceLocation)(error.source, location);
    }
    return output;
}

});
parcelRegister("frMqO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f105bed47fe5bb0$export$2e2bcd8739ae039; });
function $3f105bed47fe5bb0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $3f105bed47fe5bb0$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $3f105bed47fe5bb0$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $3f105bed47fe5bb0$var$_typeof(obj);
}
function $3f105bed47fe5bb0$export$2e2bcd8739ae039(value) {
    return $3f105bed47fe5bb0$var$_typeof(value) == "object" && value !== null;
}

});

parcelRegister("59GJs", function(module, exports) {

$parcel$export(module.exports, "SYMBOL_TO_STRING_TAG", function () { return $0433b7dd8fa36a14$export$5deadc579ccc7c9c; });
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $0433b7dd8fa36a14$export$f6cdee3c26d6da57 = typeof Symbol === "function" && Symbol.iterator != null ? Symbol.iterator : "@@iterator"; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $0433b7dd8fa36a14$export$8d0083df0471478e = typeof Symbol === "function" && Symbol.asyncIterator != null ? Symbol.asyncIterator : "@@asyncIterator"; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $0433b7dd8fa36a14$export$5deadc579ccc7c9c = typeof Symbol === "function" && Symbol.toStringTag != null ? Symbol.toStringTag : "@@toStringTag";

});

parcelRegister("df9N3", function(module, exports) {

$parcel$export(module.exports, "getLocation", function () { return $b7bbad986af4692e$export$e7fd20fad3cf4b5f; });
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $b7bbad986af4692e$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("2e42F", function(module, exports) {

$parcel$export(module.exports, "printLocation", function () { return $3e3acd3a9a2ae23a$export$96a9681e539deed; });
$parcel$export(module.exports, "printSourceLocation", function () { return $3e3acd3a9a2ae23a$export$867940333fd9f869; });

var $df9N3 = parcelRequire("df9N3");
function $3e3acd3a9a2ae23a$export$96a9681e539deed(location) {
    return $3e3acd3a9a2ae23a$export$867940333fd9f869(location.source, (0, $df9N3.getLocation)(location.source, location.start));
}
function $3e3acd3a9a2ae23a$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $3e3acd3a9a2ae23a$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $3e3acd3a9a2ae23a$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                "",
                subLine
            ];
        }), [
            [
                " ",
                $3e3acd3a9a2ae23a$var$whitespace(subLineColumnNum - 1) + "^"
            ],
            [
                "",
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $3e3acd3a9a2ae23a$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            "",
            $3e3acd3a9a2ae23a$var$whitespace(columnNum - 1) + "^"
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $3e3acd3a9a2ae23a$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $3e3acd3a9a2ae23a$var$leftPad(padLen, prefix) + (line ? " | " + line : " |");
    }).join("\n");
}
function $3e3acd3a9a2ae23a$var$whitespace(len) {
    return Array(len + 1).join(" ");
}
function $3e3acd3a9a2ae23a$var$leftPad(len, str) {
    return $3e3acd3a9a2ae23a$var$whitespace(len - str.length) + str;
}

});



parcelRegister("bejjD", function(module, exports) {

$parcel$export(module.exports, "Kind", function () { return $d5e3b42a28173f6b$export$a84bdc57c5122798; });
/**
 * The set of allowed kind values for AST nodes.
 */ var $d5e3b42a28173f6b$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: "Name",
    // Document
    DOCUMENT: "Document",
    OPERATION_DEFINITION: "OperationDefinition",
    VARIABLE_DEFINITION: "VariableDefinition",
    SELECTION_SET: "SelectionSet",
    FIELD: "Field",
    ARGUMENT: "Argument",
    // Fragments
    FRAGMENT_SPREAD: "FragmentSpread",
    INLINE_FRAGMENT: "InlineFragment",
    FRAGMENT_DEFINITION: "FragmentDefinition",
    // Values
    VARIABLE: "Variable",
    INT: "IntValue",
    FLOAT: "FloatValue",
    STRING: "StringValue",
    BOOLEAN: "BooleanValue",
    NULL: "NullValue",
    ENUM: "EnumValue",
    LIST: "ListValue",
    OBJECT: "ObjectValue",
    OBJECT_FIELD: "ObjectField",
    // Directives
    DIRECTIVE: "Directive",
    // Types
    NAMED_TYPE: "NamedType",
    LIST_TYPE: "ListType",
    NON_NULL_TYPE: "NonNullType",
    // Type System Definitions
    SCHEMA_DEFINITION: "SchemaDefinition",
    OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
    // Type Definitions
    SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
    OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
    FIELD_DEFINITION: "FieldDefinition",
    INPUT_VALUE_DEFINITION: "InputValueDefinition",
    INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
    UNION_TYPE_DEFINITION: "UnionTypeDefinition",
    ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
    ENUM_VALUE_DEFINITION: "EnumValueDefinition",
    INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
    // Directive Definitions
    DIRECTIVE_DEFINITION: "DirectiveDefinition",
    // Type System Extensions
    SCHEMA_EXTENSION: "SchemaExtension",
    // Type Extensions
    SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
    OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
    INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
    UNION_TYPE_EXTENSION: "UnionTypeExtension",
    ENUM_TYPE_EXTENSION: "EnumTypeExtension",
    INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("cr92G", function(module, exports) {

$parcel$export(module.exports, "Location", function () { return $70e136d21892e434$export$18a2be9195644f38; });
$parcel$export(module.exports, "Token", function () { return $70e136d21892e434$export$50792b0e93539fde; });

var $9oT2j = parcelRequire("9oT2j");
var $70e136d21892e434$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $9oT2j.default)($70e136d21892e434$export$18a2be9195644f38);
var $70e136d21892e434$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $9oT2j.default)($70e136d21892e434$export$50792b0e93539fde);
function $70e136d21892e434$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === "string";
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("9oT2j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $695d47496ae21a55$export$2e2bcd8739ae039; });

var $3QaL7 = parcelRequire("3QaL7");

var $dXhbh = parcelRequire("dXhbh");
function $695d47496ae21a55$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === "function" || (0, $3QaL7.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $dXhbh.default) classObject.prototype[0, $dXhbh.default] = fn;
}

});
parcelRegister("3QaL7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94e164cf95bc111e$export$2e2bcd8739ae039; });
function $94e164cf95bc111e$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : "Unexpected invariant triggered.");
}

});

parcelRegister("dXhbh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3a800eb937c6ad5$export$2e2bcd8739ae039; });
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $c3a800eb937c6ad5$var$nodejsCustomInspectSymbol = typeof Symbol === "function" && typeof Symbol.for === "function" ? Symbol.for("nodejs.util.inspect.custom") : undefined;
var $c3a800eb937c6ad5$export$2e2bcd8739ae039 = $c3a800eb937c6ad5$var$nodejsCustomInspectSymbol;

});



parcelRegister("1PhYp", function(module, exports) {

$parcel$export(module.exports, "TokenKind", function () { return $082f00b5bfd61428$export$8b9d26ab11394711; });
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $082f00b5bfd61428$export$8b9d26ab11394711 = Object.freeze({
    SOF: "<SOF>",
    EOF: "<EOF>",
    BANG: "!",
    DOLLAR: "$",
    AMP: "&",
    PAREN_L: "(",
    PAREN_R: ")",
    SPREAD: "...",
    COLON: ":",
    EQUALS: "=",
    AT: "@",
    BRACKET_L: "[",
    BRACKET_R: "]",
    BRACE_L: "{",
    PIPE: "|",
    BRACE_R: "}",
    NAME: "Name",
    INT: "Int",
    FLOAT: "Float",
    STRING: "String",
    BLOCK_STRING: "BlockString",
    COMMENT: "Comment"
}); /**
 * The enum type representing the token kinds values.
 */ 

});

parcelRegister("edwOT", function(module, exports) {

$parcel$export(module.exports, "Source", function () { return $4a2cf16742c6f8e7$export$1d2df86270c81ecb; });
$parcel$export(module.exports, "isSource", function () { return $4a2cf16742c6f8e7$export$75135ee9ed6e435b; });

var $59GJs = parcelRequire("59GJs");

var $2YUkw = parcelRequire("2YUkw");

var $etQAI = parcelRequire("etQAI");

var $dY2aZ = parcelRequire("dY2aZ");
function $4a2cf16742c6f8e7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4a2cf16742c6f8e7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4a2cf16742c6f8e7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4a2cf16742c6f8e7$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $4a2cf16742c6f8e7$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "GraphQL request";
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === "string" || (0, $etQAI.default)(0, "Body must be a string. Received: ".concat((0, $2YUkw.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $etQAI.default)(0, "line in locationOffset is 1-indexed and must be positive.");
        this.locationOffset.column > 0 || (0, $etQAI.default)(0, "column in locationOffset is 1-indexed and must be positive.");
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $4a2cf16742c6f8e7$var$_createClass(Source, [
        {
            key: (0, $59GJs.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return "Source";
            }
        }
    ]);
    return Source;
}();
function $4a2cf16742c6f8e7$export$75135ee9ed6e435b(source) {
    return (0, $dY2aZ.default)(source, $4a2cf16742c6f8e7$export$1d2df86270c81ecb);
}

});
parcelRegister("2YUkw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $215b881fabbef4c7$export$2e2bcd8739ae039; });

var $dXhbh = parcelRequire("dXhbh");
function $215b881fabbef4c7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $215b881fabbef4c7$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $215b881fabbef4c7$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $215b881fabbef4c7$var$_typeof(obj);
}
var $215b881fabbef4c7$var$MAX_ARRAY_LENGTH = 10;
var $215b881fabbef4c7$var$MAX_RECURSIVE_DEPTH = 2;
function $215b881fabbef4c7$export$2e2bcd8739ae039(value) {
    return $215b881fabbef4c7$var$formatValue(value, []);
}
function $215b881fabbef4c7$var$formatValue(value, seenValues) {
    switch($215b881fabbef4c7$var$_typeof(value)){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? "[function ".concat(value.name, "]") : "[function]";
        case "object":
            if (value === null) return "null";
            return $215b881fabbef4c7$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $215b881fabbef4c7$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return "[Circular]";
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $215b881fabbef4c7$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === "string" ? customValue : $215b881fabbef4c7$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $215b881fabbef4c7$var$formatArray(value, seenValues);
    return $215b881fabbef4c7$var$formatObject(value, seenValues);
}
function $215b881fabbef4c7$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return "{}";
    if (seenValues.length > $215b881fabbef4c7$var$MAX_RECURSIVE_DEPTH) return "[" + $215b881fabbef4c7$var$getObjectTag(object) + "]";
    var properties = keys.map(function(key) {
        var value = $215b881fabbef4c7$var$formatValue(object[key], seenValues);
        return key + ": " + value;
    });
    return "{ " + properties.join(", ") + " }";
}
function $215b881fabbef4c7$var$formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > $215b881fabbef4c7$var$MAX_RECURSIVE_DEPTH) return "[Array]";
    var len = Math.min($215b881fabbef4c7$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($215b881fabbef4c7$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return "[" + items.join(", ") + "]";
}
function $215b881fabbef4c7$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $dXhbh.default))];
    if (typeof customInspectFn === "function") return customInspectFn;
    if (typeof object.inspect === "function") return object.inspect;
}
function $215b881fabbef4c7$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        var name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}

});

parcelRegister("etQAI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7ccd4d34eaa201b$export$2e2bcd8739ae039; });
function $c7ccd4d34eaa201b$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("dY2aZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95f42b2bd17ec2cb$export$2e2bcd8739ae039; });
/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
var $95f42b2bd17ec2cb$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

});


parcelRegister("25YVd", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", function () { return $e0e2cc0d03476b88$export$b45ffd2948484c41; });
/**
 * The set of allowed directive location values.
 */ var $e0e2cc0d03476b88$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: "QUERY",
    MUTATION: "MUTATION",
    SUBSCRIPTION: "SUBSCRIPTION",
    FIELD: "FIELD",
    FRAGMENT_DEFINITION: "FRAGMENT_DEFINITION",
    FRAGMENT_SPREAD: "FRAGMENT_SPREAD",
    INLINE_FRAGMENT: "INLINE_FRAGMENT",
    VARIABLE_DEFINITION: "VARIABLE_DEFINITION",
    // Type System Definitions
    SCHEMA: "SCHEMA",
    SCALAR: "SCALAR",
    OBJECT: "OBJECT",
    FIELD_DEFINITION: "FIELD_DEFINITION",
    ARGUMENT_DEFINITION: "ARGUMENT_DEFINITION",
    INTERFACE: "INTERFACE",
    UNION: "UNION",
    ENUM: "ENUM",
    ENUM_VALUE: "ENUM_VALUE",
    INPUT_OBJECT: "INPUT_OBJECT",
    INPUT_FIELD_DEFINITION: "INPUT_FIELD_DEFINITION"
}); /**
 * The enum type representing the directive location values.
 */ 

});

parcelRegister("ltW8y", function(module, exports) {

$parcel$export(module.exports, "Lexer", function () { return $b7db6c84fc00db2f$export$6168dc8908a6c652; });
$parcel$export(module.exports, "isPunctuatorTokenKind", function () { return $b7db6c84fc00db2f$export$59ac0f4da287406a; });

var $hVZrm = parcelRequire("hVZrm");

var $cr92G = parcelRequire("cr92G");

var $1PhYp = parcelRequire("1PhYp");

var $khGju = parcelRequire("khGju");
var $b7db6c84fc00db2f$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $cr92G.Token)((0, $1PhYp.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $1PhYp.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $b7db6c84fc00db2f$var$readToken(this, token);
        }while (token.kind === (0, $1PhYp.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function $b7db6c84fc00db2f$export$59ac0f4da287406a(kind) {
    return kind === (0, $1PhYp.TokenKind).BANG || kind === (0, $1PhYp.TokenKind).DOLLAR || kind === (0, $1PhYp.TokenKind).AMP || kind === (0, $1PhYp.TokenKind).PAREN_L || kind === (0, $1PhYp.TokenKind).PAREN_R || kind === (0, $1PhYp.TokenKind).SPREAD || kind === (0, $1PhYp.TokenKind).COLON || kind === (0, $1PhYp.TokenKind).EQUALS || kind === (0, $1PhYp.TokenKind).AT || kind === (0, $1PhYp.TokenKind).BRACKET_L || kind === (0, $1PhYp.TokenKind).BRACKET_R || kind === (0, $1PhYp.TokenKind).BRACE_L || kind === (0, $1PhYp.TokenKind).PIPE || kind === (0, $1PhYp.TokenKind).BRACE_R;
}
function $b7db6c84fc00db2f$var$printCharCode(code) {
    return isNaN(code) ? (0, $1PhYp.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : '"\\u'.concat(("00" + code.toString(16).toUpperCase()).slice(-4), '"');
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $b7db6c84fc00db2f$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $cr92G.Token)((0, $1PhYp.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $b7db6c84fc00db2f$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $cr92G.Token)((0, $1PhYp.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $cr92G.Token)((0, $1PhYp.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $cr92G.Token)((0, $1PhYp.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $cr92G.Token)((0, $1PhYp.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $cr92G.Token)((0, $1PhYp.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $cr92G.Token)((0, $1PhYp.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $cr92G.Token)((0, $1PhYp.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $cr92G.Token)((0, $1PhYp.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $cr92G.Token)((0, $1PhYp.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $cr92G.Token)((0, $1PhYp.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $cr92G.Token)((0, $1PhYp.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $cr92G.Token)((0, $1PhYp.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $cr92G.Token)((0, $1PhYp.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $b7db6c84fc00db2f$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $b7db6c84fc00db2f$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $b7db6c84fc00db2f$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $b7db6c84fc00db2f$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $hVZrm.syntaxError)(source, pos, $b7db6c84fc00db2f$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $cr92G.Token)((0, $1PhYp.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $b7db6c84fc00db2f$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($b7db6c84fc00db2f$var$printCharCode(code), ".");
    if (code === 39) // '
    return "Unexpected single quote character ('), did you mean to use a double quote (\")?";
    return "Cannot parse the unexpected character ".concat($b7db6c84fc00db2f$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $b7db6c84fc00db2f$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $cr92G.Token)((0, $1PhYp.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $b7db6c84fc00db2f$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $hVZrm.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($b7db6c84fc00db2f$var$printCharCode(code), "."));
    } else {
        position = $b7db6c84fc00db2f$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $b7db6c84fc00db2f$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $b7db6c84fc00db2f$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $b7db6c84fc00db2f$var$isNameStart(code)) throw (0, $hVZrm.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($b7db6c84fc00db2f$var$printCharCode(code), "."));
    return new (0, $cr92G.Token)(isFloat ? (0, $1PhYp.TokenKind).FLOAT : (0, $1PhYp.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $b7db6c84fc00db2f$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $hVZrm.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($b7db6c84fc00db2f$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $b7db6c84fc00db2f$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = "";
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $cr92G.Token)((0, $1PhYp.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $hVZrm.syntaxError)(source, position, "Invalid character within String: ".concat($b7db6c84fc00db2f$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += "/";
                    break;
                case 92:
                    value += "\\";
                    break;
                case 98:
                    value += "\b";
                    break;
                case 102:
                    value += "\f";
                    break;
                case 110:
                    value += "\n";
                    break;
                case 114:
                    value += "\r";
                    break;
                case 116:
                    value += "	";
                    break;
                case 117:
                    // uXXXX
                    var charCode = $b7db6c84fc00db2f$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $hVZrm.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $hVZrm.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $hVZrm.syntaxError)(source, position, "Unterminated string.");
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $b7db6c84fc00db2f$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = "";
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $cr92G.Token)((0, $1PhYp.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $khGju.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $hVZrm.syntaxError)(source, position, "Invalid character within String: ".concat($b7db6c84fc00db2f$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $hVZrm.syntaxError)(source, position, "Unterminated string.");
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $b7db6c84fc00db2f$var$uniCharCode(a, b, c, d) {
    return $b7db6c84fc00db2f$var$char2hex(a) << 12 | $b7db6c84fc00db2f$var$char2hex(b) << 8 | $b7db6c84fc00db2f$var$char2hex(c) << 4 | $b7db6c84fc00db2f$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $b7db6c84fc00db2f$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $b7db6c84fc00db2f$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $cr92G.Token)((0, $1PhYp.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $b7db6c84fc00db2f$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

});
parcelRegister("khGju", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringValue", function () { return $008e91098b75dc12$export$fd88c0b652c46ccc; });
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $008e91098b75dc12$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $008e91098b75dc12$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $008e91098b75dc12$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $008e91098b75dc12$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join("\n");
}
function $008e91098b75dc12$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== " " && str[i] !== "	") return false;
    }
    return true;
}
function $008e91098b75dc12$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $008e91098b75dc12$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf("\n") === -1;
    var hasLeadingSpace = value[0] === " " || value[0] === "	";
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === "\\";
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ""; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += "\n" + indentation;
    result += indentation ? value.replace(/\n/g, "\n" + indentation) : value;
    if (printAsMultipleLines) result += "\n";
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});




parcelRegister("dV1BF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a221d8452d2d6908$export$2e2bcd8739ae039; }, function (v) { return $a221d8452d2d6908$export$2e2bcd8739ae039 = v; });
var $a221d8452d2d6908$export$1e511d4a378977f5;
var $a221d8452d2d6908$export$dcef8f9bb9a41431;
var $a221d8452d2d6908$export$2e2bcd8739ae039;
$a221d8452d2d6908$export$1e511d4a378977f5 = true;
$a221d8452d2d6908$export$dcef8f9bb9a41431 = undefined;
var $a221d8452d2d6908$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $a221d8452d2d6908$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $9nHZC = parcelRequire("9nHZC");
var $a221d8452d2d6908$var$_react2 = $a221d8452d2d6908$var$_interopRequireDefault($9nHZC);

var $blCBi = parcelRequire("blCBi");
var $a221d8452d2d6908$var$_propTypes2 = $a221d8452d2d6908$var$_interopRequireDefault($blCBi);

var $d7bcz = parcelRequire("d7bcz");
var $a221d8452d2d6908$var$_reactSideEffect2 = $a221d8452d2d6908$var$_interopRequireDefault($d7bcz);

var $iQBlb = parcelRequire("iQBlb");
var $a221d8452d2d6908$var$_deepEqual2 = $a221d8452d2d6908$var$_interopRequireDefault($iQBlb);

var $8mjcI = parcelRequire("8mjcI");

var $9kYqB = parcelRequire("9kYqB");
function $a221d8452d2d6908$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a221d8452d2d6908$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $a221d8452d2d6908$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a221d8452d2d6908$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a221d8452d2d6908$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $a221d8452d2d6908$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $a221d8452d2d6908$var$_inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $a221d8452d2d6908$var$_classCallCheck(this, HelmetWrapper);
            return $a221d8452d2d6908$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, $a221d8452d2d6908$var$_deepEqual2.default)(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $9kYqB.TAG_NAMES.SCRIPT:
                case $9kYqB.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $9kYqB.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $a221d8452d2d6908$var$_extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $a221d8452d2d6908$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _extends2));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $9kYqB.TAG_NAMES.TITLE:
                    return $a221d8452d2d6908$var$_extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = $a221d8452d2d6908$var$_extends({}, newChildProps), _extends3));
                case $9kYqB.TAG_NAMES.BODY:
                    return $a221d8452d2d6908$var$_extends({}, newProps, {
                        bodyAttributes: $a221d8452d2d6908$var$_extends({}, newChildProps)
                    });
                case $9kYqB.TAG_NAMES.HTML:
                    return $a221d8452d2d6908$var$_extends({}, newProps, {
                        htmlAttributes: $a221d8452d2d6908$var$_extends({}, newChildProps)
                    });
            }
            return $a221d8452d2d6908$var$_extends({}, newProps, (_extends4 = {}, _extends4[child.type] = $a221d8452d2d6908$var$_extends({}, newChildProps), _extends4));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $a221d8452d2d6908$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _extends5;
                newFlattenedProps = $a221d8452d2d6908$var$_extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            $a221d8452d2d6908$var$_react2.default.Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $a221d8452d2d6908$var$_objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = (0, $8mjcI.convertReactPropstoHtmlAttributes)(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $9kYqB.TAG_NAMES.LINK:
                    case $9kYqB.TAG_NAMES.META:
                    case $9kYqB.TAG_NAMES.NOSCRIPT:
                    case $9kYqB.TAG_NAMES.SCRIPT:
                    case $9kYqB.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $a221d8452d2d6908$var$_objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $a221d8452d2d6908$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return $a221d8452d2d6908$var$_react2.default.createElement(Component, newProps);
        };
        $a221d8452d2d6908$var$_createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
            * @param {Object} bodyAttributes: {"className": "root"}
            * @param {String} defaultTitle: "Default Title"
            * @param {Boolean} defer: true
            * @param {Boolean} encodeSpecialCharacters: true
            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
            * @param {String} title: "Title"
            * @param {Object} titleAttributes: {"itemprop": "name"}
            * @param {String} titleTemplate: "MySite.com - %s"
            */ set: function set(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }($a221d8452d2d6908$var$_react2.default.Component), _class.propTypes = {
        base: $a221d8452d2d6908$var$_propTypes2.default.object,
        bodyAttributes: $a221d8452d2d6908$var$_propTypes2.default.object,
        children: $a221d8452d2d6908$var$_propTypes2.default.oneOfType([
            $a221d8452d2d6908$var$_propTypes2.default.arrayOf($a221d8452d2d6908$var$_propTypes2.default.node),
            $a221d8452d2d6908$var$_propTypes2.default.node
        ]),
        defaultTitle: $a221d8452d2d6908$var$_propTypes2.default.string,
        defer: $a221d8452d2d6908$var$_propTypes2.default.bool,
        encodeSpecialCharacters: $a221d8452d2d6908$var$_propTypes2.default.bool,
        htmlAttributes: $a221d8452d2d6908$var$_propTypes2.default.object,
        link: $a221d8452d2d6908$var$_propTypes2.default.arrayOf($a221d8452d2d6908$var$_propTypes2.default.object),
        meta: $a221d8452d2d6908$var$_propTypes2.default.arrayOf($a221d8452d2d6908$var$_propTypes2.default.object),
        noscript: $a221d8452d2d6908$var$_propTypes2.default.arrayOf($a221d8452d2d6908$var$_propTypes2.default.object),
        onChangeClientState: $a221d8452d2d6908$var$_propTypes2.default.func,
        script: $a221d8452d2d6908$var$_propTypes2.default.arrayOf($a221d8452d2d6908$var$_propTypes2.default.object),
        style: $a221d8452d2d6908$var$_propTypes2.default.arrayOf($a221d8452d2d6908$var$_propTypes2.default.object),
        title: $a221d8452d2d6908$var$_propTypes2.default.string,
        titleAttributes: $a221d8452d2d6908$var$_propTypes2.default.object,
        titleTemplate: $a221d8452d2d6908$var$_propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = (0, $8mjcI.mapStateOnServer)({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $a221d8452d2d6908$var$NullComponent = function NullComponent() {
    return null;
};
var $a221d8452d2d6908$var$HelmetSideEffects = (0, $a221d8452d2d6908$var$_reactSideEffect2.default)($8mjcI.reducePropsToState, $8mjcI.handleClientStateChange, $8mjcI.mapStateOnServer)($a221d8452d2d6908$var$NullComponent);
var $a221d8452d2d6908$var$HelmetExport = $a221d8452d2d6908$var$Helmet($a221d8452d2d6908$var$HelmetSideEffects);
$a221d8452d2d6908$var$HelmetExport.renderStatic = $a221d8452d2d6908$var$HelmetExport.rewind;
$a221d8452d2d6908$export$dcef8f9bb9a41431 = $a221d8452d2d6908$var$HelmetExport;
$a221d8452d2d6908$export$2e2bcd8739ae039 = $a221d8452d2d6908$var$HelmetExport;

});
parcelRegister("d7bcz", function(module, exports) {
"use strict";
function $98c49e39ecdbb016$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $9nHZC = parcelRequire("9nHZC");
var $98c49e39ecdbb016$var$React__default = $98c49e39ecdbb016$var$_interopDefault($9nHZC);

var $98c49e39ecdbb016$var$ExecutionEnvironment = $98c49e39ecdbb016$var$_interopDefault((parcelRequire("9XBEw")));

var $98c49e39ecdbb016$var$shallowEqual = $98c49e39ecdbb016$var$_interopDefault((parcelRequire("8OdGB")));
function $98c49e39ecdbb016$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $98c49e39ecdbb016$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $98c49e39ecdbb016$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $98c49e39ecdbb016$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== "function") throw new Error("Expected reducePropsToState to be a function.");
    if (typeof handleStateChangeOnClient !== "function") throw new Error("Expected handleStateChangeOnClient to be a function.");
    if (typeof mapStateOnServer !== "undefined" && typeof mapStateOnServer !== "function") throw new Error("Expected mapStateOnServer to either be undefined or a function.");
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== "function") throw new Error("Expected WrappedComponent to be a React component.");
        var mountedInstances = [];
        var state = void 0;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = function(_Component) {
            $98c49e39ecdbb016$var$_inherits(SideEffect, _Component);
            function SideEffect() {
                $98c49e39ecdbb016$var$_classCallCheck(this, SideEffect);
                return $98c49e39ecdbb016$var$_possibleConstructorReturn(this, _Component.apply(this, arguments));
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error("You may only call rewind() on the server. Call peek() to read the current state.");
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
                return !$98c49e39ecdbb016$var$shallowEqual(nextProps, this.props);
            };
            SideEffect.prototype.componentWillMount = function componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            SideEffect.prototype.render = function render() {
                return $98c49e39ecdbb016$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($9nHZC.Component);
        SideEffect.displayName = "SideEffect(" + getDisplayName(WrappedComponent) + ")";
        SideEffect.canUseDOM = $98c49e39ecdbb016$var$ExecutionEnvironment.canUseDOM;
        return SideEffect;
    };
}
module.exports = $98c49e39ecdbb016$var$withSideEffect;

});
parcelRegister("9XBEw", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    "use strict";
    var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== "undefined",
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === "function" && typeof define.amd === "object" && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});

parcelRegister("8OdGB", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});


parcelRegister("iQBlb", function(module, exports) {

var $6lSCp = parcelRequire("6lSCp");

var $dGczz = parcelRequire("dGczz");

var $dyEoL = parcelRequire("dyEoL");

var $8izdB = parcelRequire("8izdB");

var $3b01Y = parcelRequire("3b01Y");

var $bsGHW = parcelRequire("bsGHW");
var $db8a0c6620f59ea8$var$getTime = Date.prototype.getTime;
function $db8a0c6620f59ea8$var$deepEqual(actual, expected, options) {
    var opts = options || {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (opts.strict ? $dyEoL(actual, expected) : actual === expected) return true;
    // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
    if (!actual || !expected || typeof actual !== "object" && typeof expected !== "object") return opts.strict ? $dyEoL(actual, expected) : actual == expected;
    /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */ // eslint-disable-next-line no-use-before-define
    return $db8a0c6620f59ea8$var$objEquiv(actual, expected, opts);
}
function $db8a0c6620f59ea8$var$isUndefinedOrNull(value) {
    return value === null || value === undefined;
}
function $db8a0c6620f59ea8$var$isBuffer(x) {
    if (!x || typeof x !== "object" || typeof x.length !== "number") return false;
    if (typeof x.copy !== "function" || typeof x.slice !== "function") return false;
    if (x.length > 0 && typeof x[0] !== "number") return false;
    return true;
}
function $db8a0c6620f59ea8$var$objEquiv(a, b, opts) {
    /* eslint max-statements: [2, 50] */ var i, key;
    if (typeof a !== typeof b) return false;
    if ($db8a0c6620f59ea8$var$isUndefinedOrNull(a) || $db8a0c6620f59ea8$var$isUndefinedOrNull(b)) return false;
    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    if ($dGczz(a) !== $dGczz(b)) return false;
    var aIsRegex = $8izdB(a);
    var bIsRegex = $8izdB(b);
    if (aIsRegex !== bIsRegex) return false;
    if (aIsRegex || bIsRegex) return a.source === b.source && $3b01Y(a) === $3b01Y(b);
    if ($bsGHW(a) && $bsGHW(b)) return $db8a0c6620f59ea8$var$getTime.call(a) === $db8a0c6620f59ea8$var$getTime.call(b);
    var aIsBuffer = $db8a0c6620f59ea8$var$isBuffer(a);
    var bIsBuffer = $db8a0c6620f59ea8$var$isBuffer(b);
    if (aIsBuffer !== bIsBuffer) return false;
    if (aIsBuffer || bIsBuffer) {
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    if (typeof a !== typeof b) return false;
    try {
        var ka = $6lSCp(a);
        var kb = $6lSCp(b);
    } catch (e) {
        return false;
    }
    // having the same number of owned properties (keys incorporates hasOwnProperty)
    if (ka.length !== kb.length) return false;
    // the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    // ~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    }
    // equivalent values for every corresponding key, and ~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$db8a0c6620f59ea8$var$deepEqual(a[key], b[key], opts)) return false;
    }
    return true;
}
module.exports = $db8a0c6620f59ea8$var$deepEqual;

});
parcelRegister("6lSCp", function(module, exports) {
"use strict";
var $49ff125cbf752fc8$var$slice = Array.prototype.slice;

var $hLD0Q = parcelRequire("hLD0Q");
var $49ff125cbf752fc8$var$origKeys = Object.keys;

var $49ff125cbf752fc8$var$keysShim = $49ff125cbf752fc8$var$origKeys ? function keys(o) {
    return $49ff125cbf752fc8$var$origKeys(o);
} : (parcelRequire("lsOxj"));
var $49ff125cbf752fc8$var$originalKeys = Object.keys;
$49ff125cbf752fc8$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($hLD0Q(object)) return $49ff125cbf752fc8$var$originalKeys($49ff125cbf752fc8$var$slice.call(object));
            return $49ff125cbf752fc8$var$originalKeys(object);
        };
    } else Object.keys = $49ff125cbf752fc8$var$keysShim;
    return Object.keys || $49ff125cbf752fc8$var$keysShim;
};
module.exports = $49ff125cbf752fc8$var$keysShim;

});
parcelRegister("hLD0Q", function(module, exports) {
"use strict";
var $cef5168bcdb6dac6$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $cef5168bcdb6dac6$var$toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $cef5168bcdb6dac6$var$toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

});

parcelRegister("lsOxj", function(module, exports) {
"use strict";
var $fa0369f19c21d744$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $fa0369f19c21d744$var$has = Object.prototype.hasOwnProperty;
    var $fa0369f19c21d744$var$toStr = Object.prototype.toString;
    var $fa0369f19c21d744$var$isArgs = (parcelRequire("hLD0Q")); // eslint-disable-line global-require
    var $fa0369f19c21d744$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $fa0369f19c21d744$var$hasDontEnumBug = !$fa0369f19c21d744$var$isEnumerable.call({
        toString: null
    }, "toString");
    var $fa0369f19c21d744$var$hasProtoEnumBug = $fa0369f19c21d744$var$isEnumerable.call(function() {}, "prototype");
    var $fa0369f19c21d744$var$dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var $fa0369f19c21d744$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $fa0369f19c21d744$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $fa0369f19c21d744$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!$fa0369f19c21d744$var$excludedKeys["$" + k] && $fa0369f19c21d744$var$has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                $fa0369f19c21d744$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $fa0369f19c21d744$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !$fa0369f19c21d744$var$hasAutomationEqualityBug) return $fa0369f19c21d744$var$equalsConstructorPrototype(o);
        try {
            return $fa0369f19c21d744$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $fa0369f19c21d744$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = $fa0369f19c21d744$var$toStr.call(object) === "[object Function]";
        var isArguments = $fa0369f19c21d744$var$isArgs(object);
        var isString = isObject && $fa0369f19c21d744$var$toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = $fa0369f19c21d744$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$fa0369f19c21d744$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && $fa0369f19c21d744$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($fa0369f19c21d744$var$hasDontEnumBug) {
            var skipConstructor = $fa0369f19c21d744$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $fa0369f19c21d744$var$dontEnums.length; ++k)if (!(skipConstructor && $fa0369f19c21d744$var$dontEnums[k] === "constructor") && $fa0369f19c21d744$var$has.call(object, $fa0369f19c21d744$var$dontEnums[k])) theKeys.push($fa0369f19c21d744$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $fa0369f19c21d744$var$keysShim;

});


parcelRegister("dGczz", function(module, exports) {
"use strict";

var $9f58f34ef0333e4b$var$hasToStringTag = (parcelRequire("eAn9y"))();

var $5J0jd = parcelRequire("5J0jd");
var $9f58f34ef0333e4b$var$$toString = $5J0jd("Object.prototype.toString");
var $9f58f34ef0333e4b$var$isStandardArguments = function isArguments(value) {
    if ($9f58f34ef0333e4b$var$hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $9f58f34ef0333e4b$var$$toString(value) === "[object Arguments]";
};
var $9f58f34ef0333e4b$var$isLegacyArguments = function isArguments(value) {
    if ($9f58f34ef0333e4b$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $9f58f34ef0333e4b$var$$toString(value) !== "[object Array]" && $9f58f34ef0333e4b$var$$toString(value.callee) === "[object Function]";
};
var $9f58f34ef0333e4b$var$supportsStandardArguments = function() {
    return $9f58f34ef0333e4b$var$isStandardArguments(arguments);
}();
$9f58f34ef0333e4b$var$isStandardArguments.isLegacyArguments = $9f58f34ef0333e4b$var$isLegacyArguments; // for tests
module.exports = $9f58f34ef0333e4b$var$supportsStandardArguments ? $9f58f34ef0333e4b$var$isStandardArguments : $9f58f34ef0333e4b$var$isLegacyArguments;

});
parcelRegister("eAn9y", function(module, exports) {
"use strict";

var $4L8lW = parcelRequire("4L8lW");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $4L8lW() && !!Symbol.toStringTag;
};

});
parcelRegister("4L8lW", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("5J0jd", function(module, exports) {
"use strict";

var $26MBv = parcelRequire("26MBv");

var $imlRG = parcelRequire("imlRG");
var $42b16513cf07f322$var$$indexOf = $imlRG($26MBv("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $26MBv(name, !!allowMissing);
    if (typeof intrinsic === "function" && $42b16513cf07f322$var$$indexOf(name, ".prototype.") > -1) return $imlRG(intrinsic);
    return intrinsic;
};

});
parcelRegister("26MBv", function(module, exports) {
"use strict";
var $1891d80b9aae78c6$var$undefined1;

var $hRcHJ = parcelRequire("hRcHJ");

var $h4eeK = parcelRequire("h4eeK");

var $kaSE5 = parcelRequire("kaSE5");

var $j3cY8 = parcelRequire("j3cY8");

var $eZdfU = parcelRequire("eZdfU");

var $2BwJo = parcelRequire("2BwJo");

var $5ij7O = parcelRequire("5ij7O");
var $1891d80b9aae78c6$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $1891d80b9aae78c6$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1891d80b9aae78c6$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $1891d80b9aae78c6$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($1891d80b9aae78c6$var$$gOPD) try {
    $1891d80b9aae78c6$var$$gOPD({}, "");
} catch (e) {
    $1891d80b9aae78c6$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $1891d80b9aae78c6$var$throwTypeError = function() {
    throw new $2BwJo();
};
var $1891d80b9aae78c6$var$ThrowTypeError = $1891d80b9aae78c6$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1891d80b9aae78c6$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $1891d80b9aae78c6$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $1891d80b9aae78c6$var$throwTypeError;
        }
    }
}() : $1891d80b9aae78c6$var$throwTypeError;

var $1891d80b9aae78c6$var$hasSymbols = (parcelRequire("9DJMD"))();

var $1891d80b9aae78c6$var$hasProto = (parcelRequire("fTgtb"))();
var $1891d80b9aae78c6$var$getProto = Object.getPrototypeOf || ($1891d80b9aae78c6$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $1891d80b9aae78c6$var$needsEval = {};
var $1891d80b9aae78c6$var$TypedArray = typeof Uint8Array === "undefined" || !$1891d80b9aae78c6$var$getProto ? undefined : $1891d80b9aae78c6$var$getProto(Uint8Array);
var $1891d80b9aae78c6$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $1891d80b9aae78c6$var$hasSymbols && $1891d80b9aae78c6$var$getProto ? $1891d80b9aae78c6$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $1891d80b9aae78c6$var$needsEval,
    "%AsyncGenerator%": $1891d80b9aae78c6$var$needsEval,
    "%AsyncGeneratorFunction%": $1891d80b9aae78c6$var$needsEval,
    "%AsyncIteratorPrototype%": $1891d80b9aae78c6$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $hRcHJ,
    "%eval%": eval,
    "%EvalError%": $h4eeK,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $1891d80b9aae78c6$var$$Function,
    "%GeneratorFunction%": $1891d80b9aae78c6$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $1891d80b9aae78c6$var$hasSymbols && $1891d80b9aae78c6$var$getProto ? $1891d80b9aae78c6$var$getProto($1891d80b9aae78c6$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$1891d80b9aae78c6$var$hasSymbols || !$1891d80b9aae78c6$var$getProto ? undefined : $1891d80b9aae78c6$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $kaSE5,
    "%ReferenceError%": $j3cY8,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$1891d80b9aae78c6$var$hasSymbols || !$1891d80b9aae78c6$var$getProto ? undefined : $1891d80b9aae78c6$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $1891d80b9aae78c6$var$hasSymbols && $1891d80b9aae78c6$var$getProto ? $1891d80b9aae78c6$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $1891d80b9aae78c6$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $eZdfU,
    "%ThrowTypeError%": $1891d80b9aae78c6$var$ThrowTypeError,
    "%TypedArray%": $1891d80b9aae78c6$var$TypedArray,
    "%TypeError%": $2BwJo,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $5ij7O,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($1891d80b9aae78c6$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1891d80b9aae78c6$var$errorProto = $1891d80b9aae78c6$var$getProto($1891d80b9aae78c6$var$getProto(e));
    $1891d80b9aae78c6$var$INTRINSICS["%Error.prototype%"] = $1891d80b9aae78c6$var$errorProto;
}
var $1891d80b9aae78c6$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $1891d80b9aae78c6$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $1891d80b9aae78c6$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $1891d80b9aae78c6$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $1891d80b9aae78c6$var$getProto) value = $1891d80b9aae78c6$var$getProto(gen.prototype);
    }
    $1891d80b9aae78c6$var$INTRINSICS[name] = value;
    return value;
};
var $1891d80b9aae78c6$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $5650u = parcelRequire("5650u");

var $c0Lw2 = parcelRequire("c0Lw2");
var $1891d80b9aae78c6$var$$concat = $5650u.call(Function.call, Array.prototype.concat);
var $1891d80b9aae78c6$var$$spliceApply = $5650u.call(Function.apply, Array.prototype.splice);
var $1891d80b9aae78c6$var$$replace = $5650u.call(Function.call, String.prototype.replace);
var $1891d80b9aae78c6$var$$strSlice = $5650u.call(Function.call, String.prototype.slice);
var $1891d80b9aae78c6$var$$exec = $5650u.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1891d80b9aae78c6$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1891d80b9aae78c6$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1891d80b9aae78c6$var$stringToPath = function stringToPath(string) {
    var first = $1891d80b9aae78c6$var$$strSlice(string, 0, 1);
    var last = $1891d80b9aae78c6$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $eZdfU("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $eZdfU("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $1891d80b9aae78c6$var$$replace(string, $1891d80b9aae78c6$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1891d80b9aae78c6$var$$replace(subString, $1891d80b9aae78c6$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $1891d80b9aae78c6$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($c0Lw2($1891d80b9aae78c6$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1891d80b9aae78c6$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($c0Lw2($1891d80b9aae78c6$var$INTRINSICS, intrinsicName)) {
        var value = $1891d80b9aae78c6$var$INTRINSICS[intrinsicName];
        if (value === $1891d80b9aae78c6$var$needsEval) value = $1891d80b9aae78c6$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $2BwJo("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $eZdfU("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $2BwJo("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $2BwJo('"allowMissing" argument must be a boolean');
    if ($1891d80b9aae78c6$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $eZdfU("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $1891d80b9aae78c6$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $1891d80b9aae78c6$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1891d80b9aae78c6$var$$spliceApply(parts, $1891d80b9aae78c6$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1891d80b9aae78c6$var$$strSlice(part, 0, 1);
        var last = $1891d80b9aae78c6$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $eZdfU("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($c0Lw2($1891d80b9aae78c6$var$INTRINSICS, intrinsicRealName)) value = $1891d80b9aae78c6$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $2BwJo("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($1891d80b9aae78c6$var$$gOPD && i + 1 >= parts.length) {
                var desc = $1891d80b9aae78c6$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $c0Lw2(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1891d80b9aae78c6$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("hRcHJ", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("h4eeK", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("kaSE5", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("j3cY8", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("eZdfU", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("2BwJo", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("5ij7O", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("9DJMD", function(module, exports) {
"use strict";
var $704b45313b867181$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $4L8lW = parcelRequire("4L8lW");
module.exports = function hasNativeSymbols() {
    if (typeof $704b45313b867181$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $704b45313b867181$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $4L8lW();
};

});

parcelRegister("fTgtb", function(module, exports) {
"use strict";
var $b918c49c0ea8ee84$var$test = {
    __proto__: null,
    foo: {}
};
var $b918c49c0ea8ee84$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $b918c49c0ea8ee84$var$test
    }).foo === $b918c49c0ea8ee84$var$test.foo && !($b918c49c0ea8ee84$var$test instanceof $b918c49c0ea8ee84$var$$Object);
};

});

parcelRegister("5650u", function(module, exports) {
"use strict";

var $EFXe3 = parcelRequire("EFXe3");
module.exports = Function.prototype.bind || $EFXe3;

});
parcelRegister("EFXe3", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $07a447c8404aa8a3$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $07a447c8404aa8a3$var$toStr = Object.prototype.toString;
var $07a447c8404aa8a3$var$max = Math.max;
var $07a447c8404aa8a3$var$funcType = "[object Function]";
var $07a447c8404aa8a3$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $07a447c8404aa8a3$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $07a447c8404aa8a3$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $07a447c8404aa8a3$var$toStr.apply(target) !== $07a447c8404aa8a3$var$funcType) throw new TypeError($07a447c8404aa8a3$var$ERROR_MESSAGE + target);
    var args = $07a447c8404aa8a3$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $07a447c8404aa8a3$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $07a447c8404aa8a3$var$concatty(args, arguments));
    };
    var boundLength = $07a447c8404aa8a3$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $07a447c8404aa8a3$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("c0Lw2", function(module, exports) {
"use strict";
var $8bea57bc75d3ed66$var$call = Function.prototype.call;
var $8bea57bc75d3ed66$var$$hasOwn = Object.prototype.hasOwnProperty;

var $5650u = parcelRequire("5650u");
/** @type {import('.')} */ module.exports = $5650u.call($8bea57bc75d3ed66$var$call, $8bea57bc75d3ed66$var$$hasOwn);

});


parcelRegister("imlRG", function(module, exports) {
"use strict";

var $5650u = parcelRequire("5650u");

var $26MBv = parcelRequire("26MBv");

var $swDc9 = parcelRequire("swDc9");

var $2BwJo = parcelRequire("2BwJo");
var $d5db3df6d0a7dc4d$var$$apply = $26MBv("%Function.prototype.apply%");
var $d5db3df6d0a7dc4d$var$$call = $26MBv("%Function.prototype.call%");
var $d5db3df6d0a7dc4d$var$$reflectApply = $26MBv("%Reflect.apply%", true) || $5650u.call($d5db3df6d0a7dc4d$var$$call, $d5db3df6d0a7dc4d$var$$apply);

var $1wtY3 = parcelRequire("1wtY3");
var $d5db3df6d0a7dc4d$var$$max = $26MBv("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $2BwJo("a function is required");
    var func = $d5db3df6d0a7dc4d$var$$reflectApply($5650u, $d5db3df6d0a7dc4d$var$$call, arguments);
    return $swDc9(func, 1 + $d5db3df6d0a7dc4d$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $d5db3df6d0a7dc4d$var$applyBind = function applyBind() {
    return $d5db3df6d0a7dc4d$var$$reflectApply($5650u, $d5db3df6d0a7dc4d$var$$apply, arguments);
};
if ($1wtY3) $1wtY3(module.exports, "apply", {
    value: $d5db3df6d0a7dc4d$var$applyBind
});
else module.exports.apply = $d5db3df6d0a7dc4d$var$applyBind;

});
parcelRegister("swDc9", function(module, exports) {
"use strict";

var $26MBv = parcelRequire("26MBv");

var $jxKWo = parcelRequire("jxKWo");

var $055bed82e6e4278a$var$hasDescriptors = (parcelRequire("3ZRUl"))();

var $4A14z = parcelRequire("4A14z");

var $2BwJo = parcelRequire("2BwJo");
var $055bed82e6e4278a$var$$floor = $26MBv("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $2BwJo("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $055bed82e6e4278a$var$$floor(length) !== length) throw new $2BwJo("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $4A14z) {
        var desc = $4A14z(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($055bed82e6e4278a$var$hasDescriptors) $jxKWo(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $jxKWo(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("jxKWo", function(module, exports) {
"use strict";

var $1wtY3 = parcelRequire("1wtY3");

var $eZdfU = parcelRequire("eZdfU");

var $2BwJo = parcelRequire("2BwJo");

var $4A14z = parcelRequire("4A14z");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $2BwJo("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $2BwJo("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $2BwJo("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $2BwJo("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $2BwJo("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $2BwJo("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$4A14z && $4A14z(obj, property);
    if ($1wtY3) $1wtY3(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $eZdfU("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("1wtY3", function(module, exports) {
"use strict";

var $26MBv = parcelRequire("26MBv");
/** @type {import('.')} */ var $11c00688ee49ec57$var$$defineProperty = $26MBv("%Object.defineProperty%", true) || false;
if ($11c00688ee49ec57$var$$defineProperty) try {
    $11c00688ee49ec57$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $11c00688ee49ec57$var$$defineProperty = false;
}
module.exports = $11c00688ee49ec57$var$$defineProperty;

});

parcelRegister("4A14z", function(module, exports) {
"use strict";

var $26MBv = parcelRequire("26MBv");
var $355b5b370816b237$var$$gOPD = $26MBv("%Object.getOwnPropertyDescriptor%", true);
if ($355b5b370816b237$var$$gOPD) try {
    $355b5b370816b237$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $355b5b370816b237$var$$gOPD = null;
}
module.exports = $355b5b370816b237$var$$gOPD;

});


parcelRegister("3ZRUl", function(module, exports) {
"use strict";

var $1wtY3 = parcelRequire("1wtY3");
var $2e90e29630b596d6$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$1wtY3;
};
$2e90e29630b596d6$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$1wtY3) return null;
    try {
        return $1wtY3([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $2e90e29630b596d6$var$hasPropertyDescriptors;

});





parcelRegister("dyEoL", function(module, exports) {
"use strict";

var $hIoJR = parcelRequire("hIoJR");

var $imlRG = parcelRequire("imlRG");

var $7Xjbi = parcelRequire("7Xjbi");

var $kibQc = parcelRequire("kibQc");

var $614L0 = parcelRequire("614L0");
var $9dedc9a015c7d42c$var$polyfill = $imlRG($kibQc(), Object);
$hIoJR($9dedc9a015c7d42c$var$polyfill, {
    getPolyfill: $kibQc,
    implementation: $7Xjbi,
    shim: $614L0
});
module.exports = $9dedc9a015c7d42c$var$polyfill;

});
parcelRegister("hIoJR", function(module, exports) {
"use strict";

var $6lSCp = parcelRequire("6lSCp");
var $ce59bc4ac8eb147d$var$hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var $ce59bc4ac8eb147d$var$toStr = Object.prototype.toString;
var $ce59bc4ac8eb147d$var$concat = Array.prototype.concat;

var $jxKWo = parcelRequire("jxKWo");
var $ce59bc4ac8eb147d$var$isFunction = function(fn) {
    return typeof fn === "function" && $ce59bc4ac8eb147d$var$toStr.call(fn) === "[object Function]";
};

var $ce59bc4ac8eb147d$var$supportsDescriptors = (parcelRequire("3ZRUl"))();
var $ce59bc4ac8eb147d$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$ce59bc4ac8eb147d$var$isFunction(predicate) || !predicate()) return;
    }
    if ($ce59bc4ac8eb147d$var$supportsDescriptors) $jxKWo(object, name, value, true);
    else $jxKWo(object, name, value);
};
var $ce59bc4ac8eb147d$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $6lSCp(map);
    if ($ce59bc4ac8eb147d$var$hasSymbols) props = $ce59bc4ac8eb147d$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$ce59bc4ac8eb147d$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$ce59bc4ac8eb147d$var$defineProperties.supportsDescriptors = !!$ce59bc4ac8eb147d$var$supportsDescriptors;
module.exports = $ce59bc4ac8eb147d$var$defineProperties;

});

parcelRegister("7Xjbi", function(module, exports) {
"use strict";
var $5cacec188b6d5fb2$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($5cacec188b6d5fb2$var$numberIsNaN(a) && $5cacec188b6d5fb2$var$numberIsNaN(b)) return true;
    return false;
};

});

parcelRegister("kibQc", function(module, exports) {
"use strict";

var $7Xjbi = parcelRequire("7Xjbi");
module.exports = function getPolyfill() {
    return typeof Object.is === "function" ? Object.is : $7Xjbi;
};

});

parcelRegister("614L0", function(module, exports) {
"use strict";

var $kibQc = parcelRequire("kibQc");

var $hIoJR = parcelRequire("hIoJR");
module.exports = function shimObjectIs() {
    var polyfill = $kibQc();
    $hIoJR(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("8izdB", function(module, exports) {
"use strict";

var $5J0jd = parcelRequire("5J0jd");

var $60ab52cbbf8b7ea9$var$hasToStringTag = (parcelRequire("eAn9y"))();
var $60ab52cbbf8b7ea9$var$has;
var $60ab52cbbf8b7ea9$var$$exec;
var $60ab52cbbf8b7ea9$var$isRegexMarker;
var $60ab52cbbf8b7ea9$var$badStringifier;
if ($60ab52cbbf8b7ea9$var$hasToStringTag) {
    $60ab52cbbf8b7ea9$var$has = $5J0jd("Object.prototype.hasOwnProperty");
    $60ab52cbbf8b7ea9$var$$exec = $5J0jd("RegExp.prototype.exec");
    $60ab52cbbf8b7ea9$var$isRegexMarker = {};
    var $60ab52cbbf8b7ea9$var$throwRegexMarker = function() {
        throw $60ab52cbbf8b7ea9$var$isRegexMarker;
    };
    $60ab52cbbf8b7ea9$var$badStringifier = {
        toString: $60ab52cbbf8b7ea9$var$throwRegexMarker,
        valueOf: $60ab52cbbf8b7ea9$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === "symbol") $60ab52cbbf8b7ea9$var$badStringifier[Symbol.toPrimitive] = $60ab52cbbf8b7ea9$var$throwRegexMarker;
}
var $60ab52cbbf8b7ea9$var$$toString = $5J0jd("Object.prototype.toString");
var $60ab52cbbf8b7ea9$var$gOPD = Object.getOwnPropertyDescriptor;
var $60ab52cbbf8b7ea9$var$regexClass = "[object RegExp]";
module.exports = $60ab52cbbf8b7ea9$var$hasToStringTag ? function isRegex(value) {
    if (!value || typeof value !== "object") return false;
    var descriptor = $60ab52cbbf8b7ea9$var$gOPD(value, "lastIndex");
    var hasLastIndexDataProperty = descriptor && $60ab52cbbf8b7ea9$var$has(descriptor, "value");
    if (!hasLastIndexDataProperty) return false;
    try {
        $60ab52cbbf8b7ea9$var$$exec(value, $60ab52cbbf8b7ea9$var$badStringifier);
    } catch (e) {
        return e === $60ab52cbbf8b7ea9$var$isRegexMarker;
    }
} : function isRegex(value) {
    // In older browsers, typeof regex incorrectly returns 'function'
    if (!value || typeof value !== "object" && typeof value !== "function") return false;
    return $60ab52cbbf8b7ea9$var$$toString(value) === $60ab52cbbf8b7ea9$var$regexClass;
};

});

parcelRegister("3b01Y", function(module, exports) {
"use strict";

var $hIoJR = parcelRequire("hIoJR");

var $imlRG = parcelRequire("imlRG");

var $OdmVf = parcelRequire("OdmVf");

var $6fX8O = parcelRequire("6fX8O");

var $aZm5L = parcelRequire("aZm5L");
var $25026c508dd6791f$var$flagsBound = $imlRG($6fX8O());
$hIoJR($25026c508dd6791f$var$flagsBound, {
    getPolyfill: $6fX8O,
    implementation: $OdmVf,
    shim: $aZm5L
});
module.exports = $25026c508dd6791f$var$flagsBound;

});
parcelRegister("OdmVf", function(module, exports) {
"use strict";

var $i9bDN = parcelRequire("i9bDN");

var $2BwJo = parcelRequire("2BwJo");
var $096f0a6003ffcfc2$var$$Object = Object;
module.exports = $i9bDN(function flags() {
    if (this == null || this !== $096f0a6003ffcfc2$var$$Object(this)) throw new $2BwJo("RegExp.prototype.flags getter called on non-object");
    var result = "";
    if (this.hasIndices) result += "d";
    if (this.global) result += "g";
    if (this.ignoreCase) result += "i";
    if (this.multiline) result += "m";
    if (this.dotAll) result += "s";
    if (this.unicode) result += "u";
    if (this.unicodeSets) result += "v";
    if (this.sticky) result += "y";
    return result;
}, "get flags", true);

});
parcelRegister("i9bDN", function(module, exports) {
"use strict";

var $jxKWo = parcelRequire("jxKWo");

var $d36218e21a980cf7$var$hasDescriptors = (parcelRequire("3ZRUl"))();

var $d36218e21a980cf7$var$functionsHaveConfigurableNames = (parcelRequire("keCre")).functionsHaveConfigurableNames();

var $2BwJo = parcelRequire("2BwJo");
/** @type {import('.')} */ module.exports = function setFunctionName(fn, name) {
    if (typeof fn !== "function") throw new $2BwJo("`fn` is not a function");
    var loose = arguments.length > 2 && !!arguments[2];
    if (!loose || $d36218e21a980cf7$var$functionsHaveConfigurableNames) {
        if ($d36218e21a980cf7$var$hasDescriptors) $jxKWo(/** @type {Parameters<define>[0]} */ fn, "name", name, true, true);
        else $jxKWo(/** @type {Parameters<define>[0]} */ fn, "name", name);
    }
    return fn;
};

});
parcelRegister("keCre", function(module, exports) {
"use strict";
var $ebb2ee7921c70002$var$functionsHaveNames = function functionsHaveNames() {
    return typeof (function f() {}).name === "string";
};
var $ebb2ee7921c70002$var$gOPD = Object.getOwnPropertyDescriptor;
if ($ebb2ee7921c70002$var$gOPD) try {
    $ebb2ee7921c70002$var$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $ebb2ee7921c70002$var$gOPD = null;
}
$ebb2ee7921c70002$var$functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
    if (!$ebb2ee7921c70002$var$functionsHaveNames() || !$ebb2ee7921c70002$var$gOPD) return false;
    var desc = $ebb2ee7921c70002$var$gOPD(function() {}, "name");
    return !!desc && !!desc.configurable;
};
var $ebb2ee7921c70002$var$$bind = Function.prototype.bind;
$ebb2ee7921c70002$var$functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
    return $ebb2ee7921c70002$var$functionsHaveNames() && typeof $ebb2ee7921c70002$var$$bind === "function" && (function f() {}).bind().name !== "";
};
module.exports = $ebb2ee7921c70002$var$functionsHaveNames;

});



parcelRegister("6fX8O", function(module, exports) {
"use strict";

var $OdmVf = parcelRequire("OdmVf");

var $hIoJR = parcelRequire("hIoJR");
var $48e205031caa6be6$require$supportsDescriptors = $hIoJR.supportsDescriptors;
var $48e205031caa6be6$var$$gOPD = Object.getOwnPropertyDescriptor;
module.exports = function getPolyfill() {
    if ($48e205031caa6be6$require$supportsDescriptors && /a/mig.flags === "gim") {
        var descriptor = $48e205031caa6be6$var$$gOPD(RegExp.prototype, "flags");
        if (descriptor && typeof descriptor.get === "function" && typeof RegExp.prototype.dotAll === "boolean" && typeof RegExp.prototype.hasIndices === "boolean") {
            /* eslint getter-return: 0 */ var calls = "";
            var o = {};
            Object.defineProperty(o, "hasIndices", {
                get: function() {
                    calls += "d";
                }
            });
            Object.defineProperty(o, "sticky", {
                get: function() {
                    calls += "y";
                }
            });
            if (calls === "dy") return descriptor.get;
        }
    }
    return $OdmVf;
};

});

parcelRegister("aZm5L", function(module, exports) {
"use strict";

var $hIoJR = parcelRequire("hIoJR");
var $8000bce130ff326f$require$supportsDescriptors = $hIoJR.supportsDescriptors;

var $6fX8O = parcelRequire("6fX8O");
var $8000bce130ff326f$var$gOPD = Object.getOwnPropertyDescriptor;
var $8000bce130ff326f$var$defineProperty = Object.defineProperty;
var $8000bce130ff326f$var$TypeErr = TypeError;
var $8000bce130ff326f$var$getProto = Object.getPrototypeOf;
var $8000bce130ff326f$var$regex = /a/;
module.exports = function shimFlags() {
    if (!$8000bce130ff326f$require$supportsDescriptors || !$8000bce130ff326f$var$getProto) throw new $8000bce130ff326f$var$TypeErr("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");
    var polyfill = $6fX8O();
    var proto = $8000bce130ff326f$var$getProto($8000bce130ff326f$var$regex);
    var descriptor = $8000bce130ff326f$var$gOPD(proto, "flags");
    if (!descriptor || descriptor.get !== polyfill) $8000bce130ff326f$var$defineProperty(proto, "flags", {
        configurable: true,
        enumerable: false,
        get: polyfill
    });
    return polyfill;
};

});


parcelRegister("bsGHW", function(module, exports) {
"use strict";
var $85837014955498d7$var$getDay = Date.prototype.getDay;
var $85837014955498d7$var$tryDateObject = function tryDateGetDayCall(value) {
    try {
        $85837014955498d7$var$getDay.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $85837014955498d7$var$toStr = Object.prototype.toString;
var $85837014955498d7$var$dateClass = "[object Date]";

var $85837014955498d7$var$hasToStringTag = (parcelRequire("eAn9y"))();
module.exports = function isDateObject(value) {
    if (typeof value !== "object" || value === null) return false;
    return $85837014955498d7$var$hasToStringTag ? $85837014955498d7$var$tryDateObject(value) : $85837014955498d7$var$toStr.call(value) === $85837014955498d7$var$dateClass;
};

});


parcelRegister("8mjcI", function(module, exports) {

$parcel$export(module.exports, "reducePropsToState", function () { return $615f4654e673bfc5$export$bfed3b07ff81c934; }, function (v) { return $615f4654e673bfc5$export$bfed3b07ff81c934 = v; });
$parcel$export(module.exports, "mapStateOnServer", function () { return $615f4654e673bfc5$export$971402543ca2bd1d; }, function (v) { return $615f4654e673bfc5$export$971402543ca2bd1d = v; });
$parcel$export(module.exports, "handleClientStateChange", function () { return $615f4654e673bfc5$export$8e0854f6f2040fff; }, function (v) { return $615f4654e673bfc5$export$8e0854f6f2040fff = v; });
$parcel$export(module.exports, "convertReactPropstoHtmlAttributes", function () { return $615f4654e673bfc5$export$8f437c7c6568a694; }, function (v) { return $615f4654e673bfc5$export$8f437c7c6568a694 = v; });
var $615f4654e673bfc5$export$1e511d4a378977f5;
var $615f4654e673bfc5$export$c106dd0671a0fc2d;
var $615f4654e673bfc5$export$6cb2c4c0a22909c0;
var $615f4654e673bfc5$export$bfed3b07ff81c934;
var $615f4654e673bfc5$export$971402543ca2bd1d;
var $615f4654e673bfc5$export$8e0854f6f2040fff;
var $615f4654e673bfc5$export$8f437c7c6568a694;
$615f4654e673bfc5$export$1e511d4a378977f5 = true;
$615f4654e673bfc5$export$c106dd0671a0fc2d = $615f4654e673bfc5$export$6cb2c4c0a22909c0 = $615f4654e673bfc5$export$bfed3b07ff81c934 = $615f4654e673bfc5$export$971402543ca2bd1d = $615f4654e673bfc5$export$8e0854f6f2040fff = $615f4654e673bfc5$export$8f437c7c6568a694 = undefined;
var $615f4654e673bfc5$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $615f4654e673bfc5$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $9nHZC = parcelRequire("9nHZC");
var $615f4654e673bfc5$var$_react2 = $615f4654e673bfc5$var$_interopRequireDefault($9nHZC);

var $de9zv = parcelRequire("de9zv");
var $615f4654e673bfc5$var$_objectAssign2 = $615f4654e673bfc5$var$_interopRequireDefault($de9zv);

var $9kYqB = parcelRequire("9kYqB");
function $615f4654e673bfc5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $615f4654e673bfc5$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $615f4654e673bfc5$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $615f4654e673bfc5$var$getInnermostProperty(propsList, $9kYqB.TAG_NAMES.TITLE);
    var innermostTemplate = $615f4654e673bfc5$var$getInnermostProperty(propsList, $9kYqB.HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return innermostTitle;
    });
    var innermostDefaultTitle = $615f4654e673bfc5$var$getInnermostProperty(propsList, $9kYqB.HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $615f4654e673bfc5$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $615f4654e673bfc5$var$getInnermostProperty(propsList, $9kYqB.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $615f4654e673bfc5$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $615f4654e673bfc5$var$_extends({}, tagAttrs, current);
    }, {});
};
var $615f4654e673bfc5$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$9kYqB.TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$9kYqB.TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $615f4654e673bfc5$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $615f4654e673bfc5$var$warn("Helmet: " + tagName + ' should be of type "Array". Instead found type "' + $615f4654e673bfc5$var$_typeof(props[tagName]) + '"');
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $9kYqB.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $9kYqB.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $9kYqB.TAG_PROPERTIES.INNER_HTML || attributeKey === $9kYqB.TAG_PROPERTIES.CSS_TEXT || attributeKey === $9kYqB.TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, $615f4654e673bfc5$var$_objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $615f4654e673bfc5$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $615f4654e673bfc5$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $615f4654e673bfc5$var$getBaseTagFromPropsList([
            $9kYqB.TAG_PROPERTIES.HREF
        ], propsList),
        bodyAttributes: $615f4654e673bfc5$var$getAttributesFromPropsList($9kYqB.ATTRIBUTE_NAMES.BODY, propsList),
        defer: $615f4654e673bfc5$var$getInnermostProperty(propsList, $9kYqB.HELMET_PROPS.DEFER),
        encode: $615f4654e673bfc5$var$getInnermostProperty(propsList, $9kYqB.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $615f4654e673bfc5$var$getAttributesFromPropsList($9kYqB.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $615f4654e673bfc5$var$getTagsFromPropsList($9kYqB.TAG_NAMES.LINK, [
            $9kYqB.TAG_PROPERTIES.REL,
            $9kYqB.TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $615f4654e673bfc5$var$getTagsFromPropsList($9kYqB.TAG_NAMES.META, [
            $9kYqB.TAG_PROPERTIES.NAME,
            $9kYqB.TAG_PROPERTIES.CHARSET,
            $9kYqB.TAG_PROPERTIES.HTTPEQUIV,
            $9kYqB.TAG_PROPERTIES.PROPERTY,
            $9kYqB.TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $615f4654e673bfc5$var$getTagsFromPropsList($9kYqB.TAG_NAMES.NOSCRIPT, [
            $9kYqB.TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $615f4654e673bfc5$var$getOnChangeClientState(propsList),
        scriptTags: $615f4654e673bfc5$var$getTagsFromPropsList($9kYqB.TAG_NAMES.SCRIPT, [
            $9kYqB.TAG_PROPERTIES.SRC,
            $9kYqB.TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $615f4654e673bfc5$var$getTagsFromPropsList($9kYqB.TAG_NAMES.STYLE, [
            $9kYqB.TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $615f4654e673bfc5$var$getTitleFromPropsList(propsList),
        titleAttributes: $615f4654e673bfc5$var$getAttributesFromPropsList($9kYqB.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $615f4654e673bfc5$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $615f4654e673bfc5$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $615f4654e673bfc5$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $615f4654e673bfc5$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $615f4654e673bfc5$var$rafPolyfill : $parcel$global.requestAnimationFrame || $615f4654e673bfc5$var$rafPolyfill;
var $615f4654e673bfc5$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $615f4654e673bfc5$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $615f4654e673bfc5$var$cafPolyfill;
var $615f4654e673bfc5$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $615f4654e673bfc5$var$_helmetCallback = null;
var $615f4654e673bfc5$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($615f4654e673bfc5$var$_helmetCallback) $615f4654e673bfc5$var$cancelAnimationFrame($615f4654e673bfc5$var$_helmetCallback);
    if (newState.defer) $615f4654e673bfc5$var$_helmetCallback = $615f4654e673bfc5$var$requestAnimationFrame(function() {
        $615f4654e673bfc5$var$commitTagChanges(newState, function() {
            $615f4654e673bfc5$var$_helmetCallback = null;
        });
    });
    else {
        $615f4654e673bfc5$var$commitTagChanges(newState);
        $615f4654e673bfc5$var$_helmetCallback = null;
    }
};
var $615f4654e673bfc5$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $615f4654e673bfc5$var$updateAttributes($9kYqB.TAG_NAMES.BODY, bodyAttributes);
    $615f4654e673bfc5$var$updateAttributes($9kYqB.TAG_NAMES.HTML, htmlAttributes);
    $615f4654e673bfc5$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $615f4654e673bfc5$var$updateTags($9kYqB.TAG_NAMES.BASE, baseTag),
        linkTags: $615f4654e673bfc5$var$updateTags($9kYqB.TAG_NAMES.LINK, linkTags),
        metaTags: $615f4654e673bfc5$var$updateTags($9kYqB.TAG_NAMES.META, metaTags),
        noscriptTags: $615f4654e673bfc5$var$updateTags($9kYqB.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $615f4654e673bfc5$var$updateTags($9kYqB.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $615f4654e673bfc5$var$updateTags($9kYqB.TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $615f4654e673bfc5$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $615f4654e673bfc5$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $615f4654e673bfc5$var$flattenArray(title);
    $615f4654e673bfc5$var$updateAttributes($9kYqB.TAG_NAMES.TITLE, attributes);
};
var $615f4654e673bfc5$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($9kYqB.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($9kYqB.HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($9kYqB.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($9kYqB.HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $615f4654e673bfc5$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($9kYqB.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $9kYqB.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $9kYqB.TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $9kYqB.TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($9kYqB.HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $615f4654e673bfc5$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + '="' + attributes[key] + '"' : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $615f4654e673bfc5$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $615f4654e673bfc5$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $615f4654e673bfc5$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $9kYqB.HELMET_ATTRIBUTE + '="true" ' + attributeString + ">" + $615f4654e673bfc5$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $9kYqB.HELMET_ATTRIBUTE + '="true">' + $615f4654e673bfc5$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $615f4654e673bfc5$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $9kYqB.TAG_PROPERTIES.INNER_HTML || attribute === $9kYqB.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + '="' + $615f4654e673bfc5$var$encodeSpecialCharacters(tag[attribute], encode) + '"';
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $9kYqB.SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $9kYqB.HELMET_ATTRIBUTE + '="true" ' + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $615f4654e673bfc5$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$9kYqB.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $615f4654e673bfc5$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$9kYqB.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $615f4654e673bfc5$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$9kYqB.HELMET_ATTRIBUTE] = true, _initProps);
    var props = $615f4654e673bfc5$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        $615f4654e673bfc5$var$_react2.default.createElement($9kYqB.TAG_NAMES.TITLE, props, title)
    ];
};
var $615f4654e673bfc5$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$9kYqB.HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $9kYqB.REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $9kYqB.TAG_PROPERTIES.INNER_HTML || mappedAttribute === $9kYqB.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return $615f4654e673bfc5$var$_react2.default.createElement(type, mappedTag);
    });
};
var $615f4654e673bfc5$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $9kYqB.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $615f4654e673bfc5$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $615f4654e673bfc5$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $9kYqB.ATTRIBUTE_NAMES.BODY:
        case $9kYqB.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $615f4654e673bfc5$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $615f4654e673bfc5$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $615f4654e673bfc5$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $615f4654e673bfc5$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $615f4654e673bfc5$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $615f4654e673bfc5$var$getMethodsForTag($9kYqB.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $615f4654e673bfc5$var$getMethodsForTag($9kYqB.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $615f4654e673bfc5$var$getMethodsForTag($9kYqB.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $615f4654e673bfc5$var$getMethodsForTag($9kYqB.TAG_NAMES.LINK, linkTags, encode),
        meta: $615f4654e673bfc5$var$getMethodsForTag($9kYqB.TAG_NAMES.META, metaTags, encode),
        noscript: $615f4654e673bfc5$var$getMethodsForTag($9kYqB.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $615f4654e673bfc5$var$getMethodsForTag($9kYqB.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $615f4654e673bfc5$var$getMethodsForTag($9kYqB.TAG_NAMES.STYLE, styleTags, encode),
        title: $615f4654e673bfc5$var$getMethodsForTag($9kYqB.TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
$615f4654e673bfc5$export$8f437c7c6568a694 = $615f4654e673bfc5$var$convertReactPropstoHtmlAttributes;
$615f4654e673bfc5$export$8e0854f6f2040fff = $615f4654e673bfc5$var$handleClientStateChange;
$615f4654e673bfc5$export$971402543ca2bd1d = $615f4654e673bfc5$var$mapStateOnServer;
$615f4654e673bfc5$export$bfed3b07ff81c934 = $615f4654e673bfc5$var$reducePropsToState;
$615f4654e673bfc5$export$6cb2c4c0a22909c0 = $615f4654e673bfc5$var$requestAnimationFrame;
$615f4654e673bfc5$export$c106dd0671a0fc2d = $615f4654e673bfc5$var$warn;

});
parcelRegister("9kYqB", function(module, exports) {

$parcel$export(module.exports, "ATTRIBUTE_NAMES", function () { return $6cc4db1302454caa$export$8b4d23abccee6cc2; }, function (v) { return $6cc4db1302454caa$export$8b4d23abccee6cc2 = v; });
$parcel$export(module.exports, "TAG_NAMES", function () { return $6cc4db1302454caa$export$7e674a85a2656dce; }, function (v) { return $6cc4db1302454caa$export$7e674a85a2656dce = v; });
$parcel$export(module.exports, "TAG_PROPERTIES", function () { return $6cc4db1302454caa$export$55a55363959ee034; }, function (v) { return $6cc4db1302454caa$export$55a55363959ee034 = v; });
$parcel$export(module.exports, "REACT_TAG_MAP", function () { return $6cc4db1302454caa$export$f5ab464b3d67ea9c; }, function (v) { return $6cc4db1302454caa$export$f5ab464b3d67ea9c = v; });
$parcel$export(module.exports, "HELMET_PROPS", function () { return $6cc4db1302454caa$export$6bb0645fb3f2618c; }, function (v) { return $6cc4db1302454caa$export$6bb0645fb3f2618c = v; });
$parcel$export(module.exports, "HTML_TAG_MAP", function () { return $6cc4db1302454caa$export$3fedf55cd3a4e6fa; }, function (v) { return $6cc4db1302454caa$export$3fedf55cd3a4e6fa = v; });
$parcel$export(module.exports, "SELF_CLOSING_TAGS", function () { return $6cc4db1302454caa$export$7f7c530a82f07f20; }, function (v) { return $6cc4db1302454caa$export$7f7c530a82f07f20 = v; });
$parcel$export(module.exports, "HELMET_ATTRIBUTE", function () { return $6cc4db1302454caa$export$1f547d7d8e831b2b; }, function (v) { return $6cc4db1302454caa$export$1f547d7d8e831b2b = v; });
var $6cc4db1302454caa$export$1e511d4a378977f5;
var $6cc4db1302454caa$export$8b4d23abccee6cc2;
var $6cc4db1302454caa$export$7e674a85a2656dce;
var $6cc4db1302454caa$export$7a7b396eb62fa0f9;
var $6cc4db1302454caa$export$55a55363959ee034;
var $6cc4db1302454caa$export$f5ab464b3d67ea9c;
var $6cc4db1302454caa$export$6bb0645fb3f2618c;
var $6cc4db1302454caa$export$3fedf55cd3a4e6fa;
var $6cc4db1302454caa$export$7f7c530a82f07f20;
var $6cc4db1302454caa$export$1f547d7d8e831b2b;
$6cc4db1302454caa$export$1e511d4a378977f5 = true;
var $6cc4db1302454caa$var$ATTRIBUTE_NAMES = $6cc4db1302454caa$export$8b4d23abccee6cc2 = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $6cc4db1302454caa$var$TAG_NAMES = $6cc4db1302454caa$export$7e674a85a2656dce = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $6cc4db1302454caa$var$VALID_TAG_NAMES = $6cc4db1302454caa$export$7a7b396eb62fa0f9 = Object.keys($6cc4db1302454caa$var$TAG_NAMES).map(function(name) {
    return $6cc4db1302454caa$var$TAG_NAMES[name];
});
var $6cc4db1302454caa$var$TAG_PROPERTIES = $6cc4db1302454caa$export$55a55363959ee034 = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};
var $6cc4db1302454caa$var$REACT_TAG_MAP = $6cc4db1302454caa$export$f5ab464b3d67ea9c = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $6cc4db1302454caa$var$HELMET_PROPS = $6cc4db1302454caa$export$6bb0645fb3f2618c = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $6cc4db1302454caa$var$HTML_TAG_MAP = $6cc4db1302454caa$export$3fedf55cd3a4e6fa = Object.keys($6cc4db1302454caa$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$6cc4db1302454caa$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $6cc4db1302454caa$var$SELF_CLOSING_TAGS = $6cc4db1302454caa$export$7f7c530a82f07f20 = [
    $6cc4db1302454caa$var$TAG_NAMES.NOSCRIPT,
    $6cc4db1302454caa$var$TAG_NAMES.SCRIPT,
    $6cc4db1302454caa$var$TAG_NAMES.STYLE
];
var $6cc4db1302454caa$var$HELMET_ATTRIBUTE = $6cc4db1302454caa$export$1f547d7d8e831b2b = "data-react-helmet";

});



parcelRegister("huxZk", function(module, exports) {

$parcel$export(module.exports, "createIntl", function () { return $cbbf9a59506bdb69$export$7e4cbedfdd7b4c0d; });
$parcel$export(module.exports, "default", function () { return $cbbf9a59506bdb69$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $jGOup = parcelRequire("jGOup");

var $9nHZC = parcelRequire("9nHZC");

var $h1pNM = parcelRequire("h1pNM");

var $gyaUL = parcelRequire("gyaUL");

var $32DlT = parcelRequire("32DlT");
var $5Nrk0 = parcelRequire("5Nrk0");
var $hgZSp = parcelRequire("hgZSp");

var $iJJ9C = parcelRequire("iJJ9C");
function $cbbf9a59506bdb69$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $cbbf9a59506bdb69$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $iJJ9C.isFormatXMLElementFn)(v) ? (0, $gyaUL.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $cbbf9a59506bdb69$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $cbbf9a59506bdb69$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $hgZSp.formatMessage).apply(void 0, (0, $jGOup.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $9nHZC.Children.toArray(chunks);
    return chunks;
};
var $cbbf9a59506bdb69$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $jGOup.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $cbbf9a59506bdb69$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $32DlT.createIntl)((0, $jGOup.__assign)((0, $jGOup.__assign)((0, $jGOup.__assign)({}, (0, $gyaUL.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    return (0, $jGOup.__assign)((0, $jGOup.__assign)({}, coreIntl), {
        formatMessage: $cbbf9a59506bdb69$var$formatMessage.bind(null, {
            locale: coreIntl.locale,
            timeZone: coreIntl.timeZone,
            fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
            formats: coreIntl.formats,
            defaultLocale: coreIntl.defaultLocale,
            defaultFormats: coreIntl.defaultFormats,
            messages: coreIntl.messages,
            onError: coreIntl.onError,
            defaultRichTextElements: defaultRichTextElements
        }, coreIntl.formatters)
    });
};
var $cbbf9a59506bdb69$var$IntlProvider = /** @class */ function(_super) {
    (0, $jGOup.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $5Nrk0.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: $cbbf9a59506bdb69$export$7e4cbedfdd7b4c0d($cbbf9a59506bdb69$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $cbbf9a59506bdb69$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $cbbf9a59506bdb69$var$processIntlConfig(props);
        if (!(0, $gyaUL.shallowEqual)(prevConfig, config)) return {
            intl: $cbbf9a59506bdb69$export$7e4cbedfdd7b4c0d(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $gyaUL.invariantIntlContext)(this.state.intl);
        return $9nHZC.createElement((0, $h1pNM.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = "IntlProvider";
    IntlProvider.defaultProps = (0, $gyaUL.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($9nHZC.PureComponent);
var $cbbf9a59506bdb69$export$2e2bcd8739ae039 = $cbbf9a59506bdb69$var$IntlProvider;

});
parcelRegister("jGOup", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $e5591ab50f978a3f$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $e5591ab50f978a3f$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $e5591ab50f978a3f$export$3c9a16f847548506; });
$parcel$export(module.exports, "__spreadArray", function () { return $e5591ab50f978a3f$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $e5591ab50f978a3f$var$extendStatics = function(d, b) {
    $e5591ab50f978a3f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $e5591ab50f978a3f$var$extendStatics(d, b);
};
function $e5591ab50f978a3f$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $e5591ab50f978a3f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e5591ab50f978a3f$export$18ce0697a983be9b = function() {
    $e5591ab50f978a3f$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e5591ab50f978a3f$export$18ce0697a983be9b.apply(this, arguments);
};
function $e5591ab50f978a3f$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e5591ab50f978a3f$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e5591ab50f978a3f$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e5591ab50f978a3f$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $e5591ab50f978a3f$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $e5591ab50f978a3f$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $e5591ab50f978a3f$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $e5591ab50f978a3f$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e5591ab50f978a3f$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e5591ab50f978a3f$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $e5591ab50f978a3f$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $e5591ab50f978a3f$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $e5591ab50f978a3f$export$45d3717a4c69092e(o, m, p);
}
function $e5591ab50f978a3f$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e5591ab50f978a3f$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e5591ab50f978a3f$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e5591ab50f978a3f$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e5591ab50f978a3f$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e5591ab50f978a3f$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $e5591ab50f978a3f$export$10c90e4f7922046c(v) {
    return this instanceof $e5591ab50f978a3f$export$10c90e4f7922046c ? (this.v = v, this) : new $e5591ab50f978a3f$export$10c90e4f7922046c(v);
}
function $e5591ab50f978a3f$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e5591ab50f978a3f$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e5591ab50f978a3f$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e5591ab50f978a3f$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $e5591ab50f978a3f$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e5591ab50f978a3f$export$19a8beecd37a4c45 === "function" ? $e5591ab50f978a3f$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e5591ab50f978a3f$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $e5591ab50f978a3f$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $e5591ab50f978a3f$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e5591ab50f978a3f$export$45d3717a4c69092e(result, mod, k);
    }
    $e5591ab50f978a3f$var$__setModuleDefault(result, mod);
    return result;
}
function $e5591ab50f978a3f$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e5591ab50f978a3f$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $e5591ab50f978a3f$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $e5591ab50f978a3f$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $e5591ab50f978a3f$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $e5591ab50f978a3f$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $e5591ab50f978a3f$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $e5591ab50f978a3f$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $e5591ab50f978a3f$export$2e2bcd8739ae039 = {
    __extends: $e5591ab50f978a3f$export$a8ba968b8961cb8a,
    __assign: $e5591ab50f978a3f$export$18ce0697a983be9b,
    __rest: $e5591ab50f978a3f$export$3c9a16f847548506,
    __decorate: $e5591ab50f978a3f$export$29e00dfd3077644b,
    __param: $e5591ab50f978a3f$export$d5ad3fd78186038f,
    __metadata: $e5591ab50f978a3f$export$f1db080c865becb9,
    __awaiter: $e5591ab50f978a3f$export$1050f835b63b671e,
    __generator: $e5591ab50f978a3f$export$67ebef60e6f28a6,
    __createBinding: $e5591ab50f978a3f$export$45d3717a4c69092e,
    __exportStar: $e5591ab50f978a3f$export$f33643c0debef087,
    __values: $e5591ab50f978a3f$export$19a8beecd37a4c45,
    __read: $e5591ab50f978a3f$export$8d051b38c9118094,
    __spread: $e5591ab50f978a3f$export$afc72e2116322959,
    __spreadArrays: $e5591ab50f978a3f$export$6388937ca91ccae8,
    __spreadArray: $e5591ab50f978a3f$export$1216008129fb82ed,
    __await: $e5591ab50f978a3f$export$10c90e4f7922046c,
    __asyncGenerator: $e5591ab50f978a3f$export$e427f37a30a4de9b,
    __asyncDelegator: $e5591ab50f978a3f$export$bbd80228419bb833,
    __asyncValues: $e5591ab50f978a3f$export$e3b29a3d6162315f,
    __makeTemplateObject: $e5591ab50f978a3f$export$4fb47efe1390b86f,
    __importStar: $e5591ab50f978a3f$export$c21735bcef00d192,
    __importDefault: $e5591ab50f978a3f$export$da59b14a69baef04,
    __classPrivateFieldGet: $e5591ab50f978a3f$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $e5591ab50f978a3f$export$d40a35129aaff81f,
    __classPrivateFieldIn: $e5591ab50f978a3f$export$81fdc39f203e4e04,
    __addDisposableResource: $e5591ab50f978a3f$export$88ac25d8e944e405,
    __disposeResources: $e5591ab50f978a3f$export$8f076105dc360e92
};

});

parcelRegister("h1pNM", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return $c6468b62ec14a276$export$2881499e37b75b9a; });
$parcel$export(module.exports, "Context", function () { return $c6468b62ec14a276$export$841858b892ce1f4c; });
$parcel$export(module.exports, "default", function () { return $c6468b62ec14a276$export$2e2bcd8739ae039; });

var $jGOup = parcelRequire("jGOup");

var $9nHZC = parcelRequire("9nHZC");

var $1t1PC = parcelRequire("1t1PC");

var $gyaUL = parcelRequire("gyaUL");
function $c6468b62ec14a276$var$getDisplayName(Component) {
    return Component.displayName || Component.name || "Component";
}
// TODO: We should provide initial value here
var $c6468b62ec14a276$var$IntlContext = $9nHZC.createContext(null);
var $c6468b62ec14a276$var$IntlConsumer = $c6468b62ec14a276$var$IntlContext.Consumer, $c6468b62ec14a276$var$IntlProvider = $c6468b62ec14a276$var$IntlContext.Provider;
var $c6468b62ec14a276$export$2881499e37b75b9a = $c6468b62ec14a276$var$IntlProvider;
var $c6468b62ec14a276$export$841858b892ce1f4c = $c6468b62ec14a276$var$IntlContext;
function $c6468b62ec14a276$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? "intl" : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $9nHZC.createElement($c6468b62ec14a276$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $gyaUL.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $9nHZC.createElement(WrappedComponent, (0, $jGOup.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($c6468b62ec14a276$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($1t1PC)))($9nHZC.forwardRef(function(props, ref) {
        return $9nHZC.createElement(WithIntl, (0, $jGOup.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1t1PC)))(WithIntl, WrappedComponent);
}

});
parcelRegister("gyaUL", function(module, exports) {

$parcel$export(module.exports, "invariantIntlContext", function () { return $c0c849bd2e4012f9$export$45c4bbf6e55bba1f; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $c0c849bd2e4012f9$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "assignUniqueKeysToParts", function () { return $c0c849bd2e4012f9$export$cfec03d26465fa63; });
$parcel$export(module.exports, "shallowEqual", function () { return $c0c849bd2e4012f9$export$d36bdfa510afb180; });

var $jGOup = parcelRequire("jGOup");

var $9nHZC = parcelRequire("9nHZC");

var $4kRXG = parcelRequire("4kRXG");

var $5Nrk0 = parcelRequire("5Nrk0");
function $c0c849bd2e4012f9$export$45c4bbf6e55bba1f(intl) {
    (0, $4kRXG.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $c0c849bd2e4012f9$export$b52f8d6fc0d47415 = (0, $jGOup.__assign)((0, $jGOup.__assign)({}, (0, $5Nrk0.DEFAULT_INTL_CONFIG)), {
    textComponent: $9nHZC.Fragment
});
function $c0c849bd2e4012f9$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($9nHZC.Children.toArray(parts));
    };
}
function $c0c849bd2e4012f9$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("4kRXG", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $3282e3538dffb7bd$export$f5708dca728d7177; });
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $3282e3538dffb7bd$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $3282e3538dffb7bd$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === "function") return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join("");
}
function $3282e3538dffb7bd$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $3282e3538dffb7bd$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $3282e3538dffb7bd$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $3282e3538dffb7bd$export$3fae2929ed23c202(map, pl, field) {
    return $3282e3538dffb7bd$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $3282e3538dffb7bd$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $3282e3538dffb7bd$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === "literal";
}
function $3282e3538dffb7bd$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $3282e3538dffb7bd$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $3282e3538dffb7bd$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}

});

parcelRegister("5Nrk0", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $4386b8e04059a7e8$export$d697c39a2985a4c; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $4386b8e04059a7e8$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "createIntlCache", function () { return $4386b8e04059a7e8$export$51c4f4e973f2dc00; });
$parcel$export(module.exports, "createFormatters", function () { return $4386b8e04059a7e8$export$c3f4cd5551df13fd; });
$parcel$export(module.exports, "getNamedFormat", function () { return $4386b8e04059a7e8$export$4ee1db8ce44a209b; });

var $k5nvU = parcelRequire("k5nvU");

var $dWzd9 = parcelRequire("dWzd9");

var $4kHyt = parcelRequire("4kHyt");

var $043Q6 = parcelRequire("043Q6");
function $4386b8e04059a7e8$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $4386b8e04059a7e8$var$defaultErrorHandler = function(error) {};
var $4386b8e04059a7e8$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: "en",
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $4386b8e04059a7e8$var$defaultErrorHandler
};
function $4386b8e04059a7e8$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $4386b8e04059a7e8$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $4386b8e04059a7e8$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $4386b8e04059a7e8$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $4kHyt.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $k5nvU.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $4386b8e04059a7e8$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $4kHyt.strategies).variadic
    });
    var getNumberFormat = (0, $4kHyt.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $k5nvU.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $4386b8e04059a7e8$var$createFastMemoizeCache(cache.number),
        strategy: (0, $4kHyt.strategies).variadic
    });
    var getPluralRules = (0, $4kHyt.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $k5nvU.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $4386b8e04059a7e8$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $4kHyt.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $4kHyt.default)(function(message, locales, overrideFormats, opts) {
            return new (0, $dWzd9.IntlMessageFormat)(message, locales, overrideFormats, (0, $k5nvU.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $4386b8e04059a7e8$var$createFastMemoizeCache(cache.message),
            strategy: (0, $4kHyt.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $4kHyt.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $k5nvU.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $4386b8e04059a7e8$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $4kHyt.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $4kHyt.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $k5nvU.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $4386b8e04059a7e8$var$createFastMemoizeCache(cache.list),
            strategy: (0, $4kHyt.strategies).variadic
        }),
        getDisplayNames: (0, $4kHyt.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $k5nvU.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $4386b8e04059a7e8$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $4kHyt.strategies).variadic
        })
    };
}
function $4386b8e04059a7e8$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $043Q6.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("k5nvU", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $e9f6839aaac07bc7$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $e9f6839aaac07bc7$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__spreadArray", function () { return $e9f6839aaac07bc7$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $e9f6839aaac07bc7$var$extendStatics = function(d, b) {
    $e9f6839aaac07bc7$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $e9f6839aaac07bc7$var$extendStatics(d, b);
};
function $e9f6839aaac07bc7$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $e9f6839aaac07bc7$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e9f6839aaac07bc7$export$18ce0697a983be9b = function() {
    $e9f6839aaac07bc7$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e9f6839aaac07bc7$export$18ce0697a983be9b.apply(this, arguments);
};
function $e9f6839aaac07bc7$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e9f6839aaac07bc7$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e9f6839aaac07bc7$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e9f6839aaac07bc7$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $e9f6839aaac07bc7$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $e9f6839aaac07bc7$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $e9f6839aaac07bc7$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $e9f6839aaac07bc7$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e9f6839aaac07bc7$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e9f6839aaac07bc7$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $e9f6839aaac07bc7$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $e9f6839aaac07bc7$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $e9f6839aaac07bc7$export$45d3717a4c69092e(o, m, p);
}
function $e9f6839aaac07bc7$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e9f6839aaac07bc7$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e9f6839aaac07bc7$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e9f6839aaac07bc7$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e9f6839aaac07bc7$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e9f6839aaac07bc7$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $e9f6839aaac07bc7$export$10c90e4f7922046c(v) {
    return this instanceof $e9f6839aaac07bc7$export$10c90e4f7922046c ? (this.v = v, this) : new $e9f6839aaac07bc7$export$10c90e4f7922046c(v);
}
function $e9f6839aaac07bc7$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e9f6839aaac07bc7$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e9f6839aaac07bc7$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e9f6839aaac07bc7$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $e9f6839aaac07bc7$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e9f6839aaac07bc7$export$19a8beecd37a4c45 === "function" ? $e9f6839aaac07bc7$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e9f6839aaac07bc7$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $e9f6839aaac07bc7$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $e9f6839aaac07bc7$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e9f6839aaac07bc7$export$45d3717a4c69092e(result, mod, k);
    }
    $e9f6839aaac07bc7$var$__setModuleDefault(result, mod);
    return result;
}
function $e9f6839aaac07bc7$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e9f6839aaac07bc7$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $e9f6839aaac07bc7$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $e9f6839aaac07bc7$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $e9f6839aaac07bc7$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $e9f6839aaac07bc7$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $e9f6839aaac07bc7$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $e9f6839aaac07bc7$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $e9f6839aaac07bc7$export$2e2bcd8739ae039 = {
    __extends: $e9f6839aaac07bc7$export$a8ba968b8961cb8a,
    __assign: $e9f6839aaac07bc7$export$18ce0697a983be9b,
    __rest: $e9f6839aaac07bc7$export$3c9a16f847548506,
    __decorate: $e9f6839aaac07bc7$export$29e00dfd3077644b,
    __param: $e9f6839aaac07bc7$export$d5ad3fd78186038f,
    __metadata: $e9f6839aaac07bc7$export$f1db080c865becb9,
    __awaiter: $e9f6839aaac07bc7$export$1050f835b63b671e,
    __generator: $e9f6839aaac07bc7$export$67ebef60e6f28a6,
    __createBinding: $e9f6839aaac07bc7$export$45d3717a4c69092e,
    __exportStar: $e9f6839aaac07bc7$export$f33643c0debef087,
    __values: $e9f6839aaac07bc7$export$19a8beecd37a4c45,
    __read: $e9f6839aaac07bc7$export$8d051b38c9118094,
    __spread: $e9f6839aaac07bc7$export$afc72e2116322959,
    __spreadArrays: $e9f6839aaac07bc7$export$6388937ca91ccae8,
    __spreadArray: $e9f6839aaac07bc7$export$1216008129fb82ed,
    __await: $e9f6839aaac07bc7$export$10c90e4f7922046c,
    __asyncGenerator: $e9f6839aaac07bc7$export$e427f37a30a4de9b,
    __asyncDelegator: $e9f6839aaac07bc7$export$bbd80228419bb833,
    __asyncValues: $e9f6839aaac07bc7$export$e3b29a3d6162315f,
    __makeTemplateObject: $e9f6839aaac07bc7$export$4fb47efe1390b86f,
    __importStar: $e9f6839aaac07bc7$export$c21735bcef00d192,
    __importDefault: $e9f6839aaac07bc7$export$da59b14a69baef04,
    __classPrivateFieldGet: $e9f6839aaac07bc7$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $e9f6839aaac07bc7$export$d40a35129aaff81f,
    __classPrivateFieldIn: $e9f6839aaac07bc7$export$81fdc39f203e4e04,
    __addDisposableResource: $e9f6839aaac07bc7$export$88ac25d8e944e405,
    __disposeResources: $e9f6839aaac07bc7$export$8f076105dc360e92
};

});

parcelRegister("dWzd9", function(module, exports) {

$parcel$export(module.exports, "IntlMessageFormat", function () { return $a26c0157d85cb894$export$d342343268debc40; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $k5nvU = parcelRequire("k5nvU");

var $caeho = parcelRequire("caeho");

var $4kHyt = parcelRequire("4kHyt");

var $bGcOL = parcelRequire("bGcOL");
// -- MessageFormat --------------------------------------------------------
function $a26c0157d85cb894$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $k5nvU.__assign)((0, $k5nvU.__assign)((0, $k5nvU.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $k5nvU.__assign)((0, $k5nvU.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $a26c0157d85cb894$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $a26c0157d85cb894$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $k5nvU.__assign)({}, defaultConfig));
}
function $a26c0157d85cb894$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $a26c0157d85cb894$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $4kHyt.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $k5nvU.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $a26c0157d85cb894$var$createFastMemoizeCache(cache.number),
            strategy: (0, $4kHyt.strategies).variadic
        }),
        getDateTimeFormat: (0, $4kHyt.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $k5nvU.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $a26c0157d85cb894$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $4kHyt.strategies).variadic
        }),
        getPluralRules: (0, $4kHyt.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $k5nvU.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $a26c0157d85cb894$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $4kHyt.strategies).variadic
        })
    };
}
var $a26c0157d85cb894$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $bGcOL.PART_TYPE).literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $bGcOL.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            return {
                locale: Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag
            });
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $a26c0157d85cb894$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.formatters = opts && opts.formatters || $a26c0157d85cb894$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.__parse = (0, $caeho.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("caeho", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", function () { return (parcelRequire("iW1v8")).isArgumentElement; });
$parcel$export(module.exports, "isDateElement", function () { return (parcelRequire("iW1v8")).isDateElement; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return (parcelRequire("iW1v8")).isDateTimeSkeleton; });
$parcel$export(module.exports, "isLiteralElement", function () { return (parcelRequire("iW1v8")).isLiteralElement; });
$parcel$export(module.exports, "isNumberElement", function () { return (parcelRequire("iW1v8")).isNumberElement; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return (parcelRequire("iW1v8")).isNumberSkeleton; });
$parcel$export(module.exports, "isPluralElement", function () { return (parcelRequire("iW1v8")).isPluralElement; });
$parcel$export(module.exports, "isPoundElement", function () { return (parcelRequire("iW1v8")).isPoundElement; });
$parcel$export(module.exports, "isSelectElement", function () { return (parcelRequire("iW1v8")).isSelectElement; });
$parcel$export(module.exports, "isTagElement", function () { return (parcelRequire("iW1v8")).isTagElement; });
$parcel$export(module.exports, "isTimeElement", function () { return (parcelRequire("iW1v8")).isTimeElement; });
$parcel$export(module.exports, "TYPE", function () { return (parcelRequire("iW1v8")).TYPE; });

$parcel$export(module.exports, "parse", function () { return $8db17ed2692aebbb$export$98e6a39c04603d36; });

var $8JCW9 = parcelRequire("8JCW9");

var $db3dg = parcelRequire("db3dg");

var $5ogNk = parcelRequire("5ogNk");

var $iW1v8 = parcelRequire("iW1v8");
function $8db17ed2692aebbb$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $iW1v8.isSelectElement)(el) || (0, $iW1v8.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $8db17ed2692aebbb$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $iW1v8.isNumberElement)(el) && (0, $iW1v8.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $iW1v8.isDateElement)(el) || (0, $iW1v8.isTimeElement)(el)) && (0, $iW1v8.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $iW1v8.isTagElement)(el)) $8db17ed2692aebbb$var$pruneLocation(el.children);
    });
}
function $8db17ed2692aebbb$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $8JCW9.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $5ogNk.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $db3dg.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $8db17ed2692aebbb$var$pruneLocation(result.val);
    return result.val;
}

});
parcelRegister("8JCW9", function(module, exports) {

$parcel$export(module.exports, "__assign", function () { return $65c0babc3cc6fadf$export$18ce0697a983be9b; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $65c0babc3cc6fadf$var$extendStatics = function(d, b) {
    $65c0babc3cc6fadf$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $65c0babc3cc6fadf$var$extendStatics(d, b);
};
function $65c0babc3cc6fadf$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $65c0babc3cc6fadf$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $65c0babc3cc6fadf$export$18ce0697a983be9b = function() {
    $65c0babc3cc6fadf$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $65c0babc3cc6fadf$export$18ce0697a983be9b.apply(this, arguments);
};
function $65c0babc3cc6fadf$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $65c0babc3cc6fadf$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $65c0babc3cc6fadf$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $65c0babc3cc6fadf$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $65c0babc3cc6fadf$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $65c0babc3cc6fadf$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $65c0babc3cc6fadf$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $65c0babc3cc6fadf$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $65c0babc3cc6fadf$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $65c0babc3cc6fadf$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $65c0babc3cc6fadf$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $65c0babc3cc6fadf$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $65c0babc3cc6fadf$export$45d3717a4c69092e(o, m, p);
}
function $65c0babc3cc6fadf$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $65c0babc3cc6fadf$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $65c0babc3cc6fadf$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($65c0babc3cc6fadf$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $65c0babc3cc6fadf$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $65c0babc3cc6fadf$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $65c0babc3cc6fadf$export$10c90e4f7922046c(v) {
    return this instanceof $65c0babc3cc6fadf$export$10c90e4f7922046c ? (this.v = v, this) : new $65c0babc3cc6fadf$export$10c90e4f7922046c(v);
}
function $65c0babc3cc6fadf$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $65c0babc3cc6fadf$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $65c0babc3cc6fadf$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $65c0babc3cc6fadf$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $65c0babc3cc6fadf$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $65c0babc3cc6fadf$export$19a8beecd37a4c45 === "function" ? $65c0babc3cc6fadf$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $65c0babc3cc6fadf$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $65c0babc3cc6fadf$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $65c0babc3cc6fadf$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $65c0babc3cc6fadf$export$45d3717a4c69092e(result, mod, k);
    }
    $65c0babc3cc6fadf$var$__setModuleDefault(result, mod);
    return result;
}
function $65c0babc3cc6fadf$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $65c0babc3cc6fadf$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $65c0babc3cc6fadf$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $65c0babc3cc6fadf$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $65c0babc3cc6fadf$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $65c0babc3cc6fadf$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $65c0babc3cc6fadf$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $65c0babc3cc6fadf$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $65c0babc3cc6fadf$export$2e2bcd8739ae039 = {
    __extends: $65c0babc3cc6fadf$export$a8ba968b8961cb8a,
    __assign: $65c0babc3cc6fadf$export$18ce0697a983be9b,
    __rest: $65c0babc3cc6fadf$export$3c9a16f847548506,
    __decorate: $65c0babc3cc6fadf$export$29e00dfd3077644b,
    __param: $65c0babc3cc6fadf$export$d5ad3fd78186038f,
    __metadata: $65c0babc3cc6fadf$export$f1db080c865becb9,
    __awaiter: $65c0babc3cc6fadf$export$1050f835b63b671e,
    __generator: $65c0babc3cc6fadf$export$67ebef60e6f28a6,
    __createBinding: $65c0babc3cc6fadf$export$45d3717a4c69092e,
    __exportStar: $65c0babc3cc6fadf$export$f33643c0debef087,
    __values: $65c0babc3cc6fadf$export$19a8beecd37a4c45,
    __read: $65c0babc3cc6fadf$export$8d051b38c9118094,
    __spread: $65c0babc3cc6fadf$export$afc72e2116322959,
    __spreadArrays: $65c0babc3cc6fadf$export$6388937ca91ccae8,
    __spreadArray: $65c0babc3cc6fadf$export$1216008129fb82ed,
    __await: $65c0babc3cc6fadf$export$10c90e4f7922046c,
    __asyncGenerator: $65c0babc3cc6fadf$export$e427f37a30a4de9b,
    __asyncDelegator: $65c0babc3cc6fadf$export$bbd80228419bb833,
    __asyncValues: $65c0babc3cc6fadf$export$e3b29a3d6162315f,
    __makeTemplateObject: $65c0babc3cc6fadf$export$4fb47efe1390b86f,
    __importStar: $65c0babc3cc6fadf$export$c21735bcef00d192,
    __importDefault: $65c0babc3cc6fadf$export$da59b14a69baef04,
    __classPrivateFieldGet: $65c0babc3cc6fadf$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $65c0babc3cc6fadf$export$d40a35129aaff81f,
    __classPrivateFieldIn: $65c0babc3cc6fadf$export$81fdc39f203e4e04,
    __addDisposableResource: $65c0babc3cc6fadf$export$88ac25d8e944e405,
    __disposeResources: $65c0babc3cc6fadf$export$8f076105dc360e92
};

});

parcelRegister("db3dg", function(module, exports) {

$parcel$export(module.exports, "ErrorKind", function () { return $997ecb7819373346$export$896afd8541959ee5; });
var $997ecb7819373346$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($997ecb7819373346$export$896afd8541959ee5 || ($997ecb7819373346$export$896afd8541959ee5 = {}));

});

parcelRegister("5ogNk", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $3ecc38b4074a1241$export$7acfa6ed01010e37; });

var $8JCW9 = parcelRequire("8JCW9");

var $db3dg = parcelRequire("db3dg");

var $iW1v8 = parcelRequire("iW1v8");

var $lyrz2 = parcelRequire("lyrz2");
parcelRequire("ge5qT");
var $elrYJ = parcelRequire("elrYJ");
var $ikHFr = parcelRequire("ikHFr");
var $3ecc38b4074a1241$var$_a;
var $3ecc38b4074a1241$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $lyrz2.SPACE_SEPARATOR_REGEX).source, "*"));
var $3ecc38b4074a1241$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $lyrz2.SPACE_SEPARATOR_REGEX).source, "*$"));
function $3ecc38b4074a1241$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $3ecc38b4074a1241$var$hasNativeStartsWith = !!String.prototype.startsWith;
var $3ecc38b4074a1241$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $3ecc38b4074a1241$var$hasNativeFromEntries = !!Object.fromEntries;
var $3ecc38b4074a1241$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $3ecc38b4074a1241$var$hasTrimStart = !!String.prototype.trimStart;
var $3ecc38b4074a1241$var$hasTrimEnd = !!String.prototype.trimEnd;
var $3ecc38b4074a1241$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $3ecc38b4074a1241$var$isSafeInteger = $3ecc38b4074a1241$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $3ecc38b4074a1241$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $3ecc38b4074a1241$var$re = $3ecc38b4074a1241$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $3ecc38b4074a1241$var$REGEX_SUPPORTS_U_AND_Y = (($3ecc38b4074a1241$var$_a = $3ecc38b4074a1241$var$re.exec("a")) === null || $3ecc38b4074a1241$var$_a === void 0 ? void 0 : $3ecc38b4074a1241$var$_a[0]) === "a";
} catch (_) {
    $3ecc38b4074a1241$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $3ecc38b4074a1241$var$startsWith = $3ecc38b4074a1241$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $3ecc38b4074a1241$var$fromCodePoint = $3ecc38b4074a1241$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $3ecc38b4074a1241$var$fromEntries = // native
$3ecc38b4074a1241$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $3ecc38b4074a1241$var$codePointAt = $3ecc38b4074a1241$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $3ecc38b4074a1241$var$trimStart = $3ecc38b4074a1241$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($3ecc38b4074a1241$var$SPACE_SEPARATOR_START_REGEX, "");
};
var $3ecc38b4074a1241$var$trimEnd = $3ecc38b4074a1241$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($3ecc38b4074a1241$var$SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $3ecc38b4074a1241$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $3ecc38b4074a1241$var$matchIdentifierAtIndex;
if ($3ecc38b4074a1241$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $3ecc38b4074a1241$var$IDENTIFIER_PREFIX_RE_1 = $3ecc38b4074a1241$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    $3ecc38b4074a1241$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $3ecc38b4074a1241$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $3ecc38b4074a1241$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
$3ecc38b4074a1241$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $3ecc38b4074a1241$var$codePointAt(s, index);
        if (c === undefined || $3ecc38b4074a1241$var$_isWhiteSpace(c) || $3ecc38b4074a1241$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $3ecc38b4074a1241$var$fromCodePoint.apply(void 0, match);
};
var $3ecc38b4074a1241$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $iW1v8.TYPE).pound,
                    location: $3ecc38b4074a1241$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $db3dg.ErrorKind).UNMATCHED_CLOSING_TAG, $3ecc38b4074a1241$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $3ecc38b4074a1241$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: (0, $iW1v8.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $3ecc38b4074a1241$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$3ecc38b4074a1241$var$_isAlpha(this.char())) return this.error((0, $db3dg.ErrorKind).INVALID_TAG, $3ecc38b4074a1241$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $db3dg.ErrorKind).UNMATCHED_CLOSING_TAG, $3ecc38b4074a1241$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error((0, $db3dg.ErrorKind).INVALID_TAG, $3ecc38b4074a1241$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $iW1v8.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $3ecc38b4074a1241$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $db3dg.ErrorKind).UNCLOSED_TAG, $3ecc38b4074a1241$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $db3dg.ErrorKind).INVALID_TAG, $3ecc38b4074a1241$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $3ecc38b4074a1241$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $3ecc38b4074a1241$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $iW1v8.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$3ecc38b4074a1241$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $3ecc38b4074a1241$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $3ecc38b4074a1241$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $db3dg.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $3ecc38b4074a1241$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $db3dg.ErrorKind).EMPTY_ARGUMENT, $3ecc38b4074a1241$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $db3dg.ErrorKind).MALFORMED_ARGUMENT, $3ecc38b4074a1241$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $db3dg.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $3ecc38b4074a1241$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $iW1v8.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $3ecc38b4074a1241$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $db3dg.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $3ecc38b4074a1241$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $db3dg.ErrorKind).MALFORMED_ARGUMENT, $3ecc38b4074a1241$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $3ecc38b4074a1241$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $3ecc38b4074a1241$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $db3dg.ErrorKind).EXPECT_ARGUMENT_TYPE, $3ecc38b4074a1241$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $3ecc38b4074a1241$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $db3dg.ErrorKind).EXPECT_ARGUMENT_STYLE, $3ecc38b4074a1241$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $3ecc38b4074a1241$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $3ecc38b4074a1241$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $3ecc38b4074a1241$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $3ecc38b4074a1241$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $iW1v8.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $db3dg.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var style = {
                            type: (0, $iW1v8.SKELETON_TYPE).dateTime,
                            pattern: skeleton,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $elrYJ.parseDateTimeSkeleton)(skeleton) : {}
                        };
                        var type = argType === "date" ? (0, $iW1v8.TYPE).date : (0, $iW1v8.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? (0, $iW1v8.TYPE).number : argType === "date" ? (0, $iW1v8.TYPE).date : (0, $iW1v8.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error((0, $db3dg.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $3ecc38b4074a1241$var$createLocation(typeEndPosition_1, (0, $8JCW9.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error((0, $db3dg.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $3ecc38b4074a1241$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $db3dg.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $db3dg.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $3ecc38b4074a1241$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: (0, $iW1v8.TYPE).select,
                        value: value,
                        options: $3ecc38b4074a1241$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $iW1v8.TYPE).plural,
                        value: value,
                        options: $3ecc38b4074a1241$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $db3dg.ErrorKind).INVALID_ARGUMENT_TYPE, $3ecc38b4074a1241$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $db3dg.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $3ecc38b4074a1241$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $db3dg.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $3ecc38b4074a1241$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $ikHFr.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $db3dg.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $iW1v8.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $ikHFr.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $db3dg.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $db3dg.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $3ecc38b4074a1241$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? (0, $db3dg.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $db3dg.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? (0, $db3dg.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $db3dg.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $3ecc38b4074a1241$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $3ecc38b4074a1241$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? (0, $db3dg.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $db3dg.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $3ecc38b4074a1241$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $db3dg.ErrorKind).MISSING_OTHER_CLAUSE, $3ecc38b4074a1241$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $3ecc38b4074a1241$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$3ecc38b4074a1241$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = $3ecc38b4074a1241$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($3ecc38b4074a1241$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $3ecc38b4074a1241$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $3ecc38b4074a1241$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $3ecc38b4074a1241$var$_isAlphaOrSlash(codepoint) {
    return $3ecc38b4074a1241$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $3ecc38b4074a1241$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $3ecc38b4074a1241$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $3ecc38b4074a1241$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("iW1v8", function(module, exports) {

$parcel$export(module.exports, "TYPE", function () { return $dc8ecee539f615fe$export$b87f371cbc396fcf; });
$parcel$export(module.exports, "SKELETON_TYPE", function () { return $dc8ecee539f615fe$export$906452485466fa53; });
$parcel$export(module.exports, "isLiteralElement", function () { return $dc8ecee539f615fe$export$cfa10c5697238752; });
$parcel$export(module.exports, "isArgumentElement", function () { return $dc8ecee539f615fe$export$4f55724281bdfaf9; });
$parcel$export(module.exports, "isNumberElement", function () { return $dc8ecee539f615fe$export$e11187b219e191e1; });
$parcel$export(module.exports, "isDateElement", function () { return $dc8ecee539f615fe$export$32d811605da75f40; });
$parcel$export(module.exports, "isTimeElement", function () { return $dc8ecee539f615fe$export$34ec46f596b1702f; });
$parcel$export(module.exports, "isSelectElement", function () { return $dc8ecee539f615fe$export$dcfe1c11d168b5a1; });
$parcel$export(module.exports, "isPluralElement", function () { return $dc8ecee539f615fe$export$6c796d116f0a4fbc; });
$parcel$export(module.exports, "isPoundElement", function () { return $dc8ecee539f615fe$export$c0ece297bdd0c082; });
$parcel$export(module.exports, "isTagElement", function () { return $dc8ecee539f615fe$export$5c83de34745812b; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return $dc8ecee539f615fe$export$3f9a19cd4152eda3; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return $dc8ecee539f615fe$export$7680c41f1a55f4cf; });
var $dc8ecee539f615fe$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($dc8ecee539f615fe$export$b87f371cbc396fcf || ($dc8ecee539f615fe$export$b87f371cbc396fcf = {}));
var $dc8ecee539f615fe$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($dc8ecee539f615fe$export$906452485466fa53 || ($dc8ecee539f615fe$export$906452485466fa53 = {}));
function $dc8ecee539f615fe$export$cfa10c5697238752(el) {
    return el.type === $dc8ecee539f615fe$export$b87f371cbc396fcf.literal;
}
function $dc8ecee539f615fe$export$4f55724281bdfaf9(el) {
    return el.type === $dc8ecee539f615fe$export$b87f371cbc396fcf.argument;
}
function $dc8ecee539f615fe$export$e11187b219e191e1(el) {
    return el.type === $dc8ecee539f615fe$export$b87f371cbc396fcf.number;
}
function $dc8ecee539f615fe$export$32d811605da75f40(el) {
    return el.type === $dc8ecee539f615fe$export$b87f371cbc396fcf.date;
}
function $dc8ecee539f615fe$export$34ec46f596b1702f(el) {
    return el.type === $dc8ecee539f615fe$export$b87f371cbc396fcf.time;
}
function $dc8ecee539f615fe$export$dcfe1c11d168b5a1(el) {
    return el.type === $dc8ecee539f615fe$export$b87f371cbc396fcf.select;
}
function $dc8ecee539f615fe$export$6c796d116f0a4fbc(el) {
    return el.type === $dc8ecee539f615fe$export$b87f371cbc396fcf.plural;
}
function $dc8ecee539f615fe$export$c0ece297bdd0c082(el) {
    return el.type === $dc8ecee539f615fe$export$b87f371cbc396fcf.pound;
}
function $dc8ecee539f615fe$export$5c83de34745812b(el) {
    return el.type === $dc8ecee539f615fe$export$b87f371cbc396fcf.tag;
}
function $dc8ecee539f615fe$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === "object" && el.type === $dc8ecee539f615fe$export$906452485466fa53.number);
}
function $dc8ecee539f615fe$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === "object" && el.type === $dc8ecee539f615fe$export$906452485466fa53.dateTime);
}
function $dc8ecee539f615fe$export$f0ac572c1121c662(value) {
    return {
        type: $dc8ecee539f615fe$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $dc8ecee539f615fe$export$425e864b0ba114f1(value, style) {
    return {
        type: $dc8ecee539f615fe$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("lyrz2", function(module, exports) {

$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", function () { return $fb1227991ba1b516$export$523451f94304dd6c; });
// @generated from regex-gen.ts
var $fb1227991ba1b516$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $fb1227991ba1b516$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("ge5qT", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return (parcelRequire("elrYJ")).parseDateTimeSkeleton; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return (parcelRequire("ikHFr")).parseNumberSkeleton; });
$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return (parcelRequire("ikHFr")).parseNumberSkeletonFromString; });
parcelRequire("elrYJ");
parcelRequire("ikHFr");

});
parcelRegister("elrYJ", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return $a718bad27fef7314$export$f7b99fb377fe69fa; });
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $a718bad27fef7314$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $a718bad27fef7314$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($a718bad27fef7314$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "short" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}

});

parcelRegister("ikHFr", function(module, exports) {

$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return $d58bf7b6be4276a0$export$71cee2f16fba2480; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return $d58bf7b6be4276a0$export$47c6f8480bda3e11; });

var $khgDp = parcelRequire("khgDp");

var $8bDPm = parcelRequire("8bDPm");
function $d58bf7b6be4276a0$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $8bDPm.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $d58bf7b6be4276a0$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var $d58bf7b6be4276a0$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $d58bf7b6be4276a0$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $d58bf7b6be4276a0$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $d58bf7b6be4276a0$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $d58bf7b6be4276a0$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($d58bf7b6be4276a0$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $d58bf7b6be4276a0$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $d58bf7b6be4276a0$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$d58bf7b6be4276a0$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $d58bf7b6be4276a0$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $d58bf7b6be4276a0$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $d58bf7b6be4276a0$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $d58bf7b6be4276a0$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = (0, $khgDp.__assign)((0, $khgDp.__assign)((0, $khgDp.__assign)({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return (0, $khgDp.__assign)((0, $khgDp.__assign)({}, all), $d58bf7b6be4276a0$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = (0, $khgDp.__assign)((0, $khgDp.__assign)((0, $khgDp.__assign)({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return (0, $khgDp.__assign)((0, $khgDp.__assign)({}, all), $d58bf7b6be4276a0$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($d58bf7b6be4276a0$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($d58bf7b6be4276a0$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($d58bf7b6be4276a0$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($d58bf7b6be4276a0$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = (0, $khgDp.__assign)((0, $khgDp.__assign)({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = (0, $khgDp.__assign)((0, $khgDp.__assign)({}, result), $d58bf7b6be4276a0$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($d58bf7b6be4276a0$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $khgDp.__assign)((0, $khgDp.__assign)({}, result), $d58bf7b6be4276a0$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $d58bf7b6be4276a0$var$parseSign(token.stem);
        if (signOpts) result = (0, $khgDp.__assign)((0, $khgDp.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $d58bf7b6be4276a0$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $khgDp.__assign)((0, $khgDp.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("khgDp", function(module, exports) {

$parcel$export(module.exports, "__assign", function () { return $ec324c786bf97113$export$18ce0697a983be9b; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $ec324c786bf97113$var$extendStatics = function(d, b) {
    $ec324c786bf97113$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $ec324c786bf97113$var$extendStatics(d, b);
};
function $ec324c786bf97113$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $ec324c786bf97113$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ec324c786bf97113$export$18ce0697a983be9b = function() {
    $ec324c786bf97113$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ec324c786bf97113$export$18ce0697a983be9b.apply(this, arguments);
};
function $ec324c786bf97113$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ec324c786bf97113$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $ec324c786bf97113$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $ec324c786bf97113$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $ec324c786bf97113$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $ec324c786bf97113$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $ec324c786bf97113$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $ec324c786bf97113$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $ec324c786bf97113$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ec324c786bf97113$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $ec324c786bf97113$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $ec324c786bf97113$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $ec324c786bf97113$export$45d3717a4c69092e(o, m, p);
}
function $ec324c786bf97113$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ec324c786bf97113$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ec324c786bf97113$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ec324c786bf97113$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $ec324c786bf97113$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $ec324c786bf97113$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $ec324c786bf97113$export$10c90e4f7922046c(v) {
    return this instanceof $ec324c786bf97113$export$10c90e4f7922046c ? (this.v = v, this) : new $ec324c786bf97113$export$10c90e4f7922046c(v);
}
function $ec324c786bf97113$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ec324c786bf97113$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $ec324c786bf97113$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ec324c786bf97113$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $ec324c786bf97113$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $ec324c786bf97113$export$19a8beecd37a4c45 === "function" ? $ec324c786bf97113$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $ec324c786bf97113$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $ec324c786bf97113$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $ec324c786bf97113$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ec324c786bf97113$export$45d3717a4c69092e(result, mod, k);
    }
    $ec324c786bf97113$var$__setModuleDefault(result, mod);
    return result;
}
function $ec324c786bf97113$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $ec324c786bf97113$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $ec324c786bf97113$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $ec324c786bf97113$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $ec324c786bf97113$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $ec324c786bf97113$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $ec324c786bf97113$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $ec324c786bf97113$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $ec324c786bf97113$export$2e2bcd8739ae039 = {
    __extends: $ec324c786bf97113$export$a8ba968b8961cb8a,
    __assign: $ec324c786bf97113$export$18ce0697a983be9b,
    __rest: $ec324c786bf97113$export$3c9a16f847548506,
    __decorate: $ec324c786bf97113$export$29e00dfd3077644b,
    __param: $ec324c786bf97113$export$d5ad3fd78186038f,
    __metadata: $ec324c786bf97113$export$f1db080c865becb9,
    __awaiter: $ec324c786bf97113$export$1050f835b63b671e,
    __generator: $ec324c786bf97113$export$67ebef60e6f28a6,
    __createBinding: $ec324c786bf97113$export$45d3717a4c69092e,
    __exportStar: $ec324c786bf97113$export$f33643c0debef087,
    __values: $ec324c786bf97113$export$19a8beecd37a4c45,
    __read: $ec324c786bf97113$export$8d051b38c9118094,
    __spread: $ec324c786bf97113$export$afc72e2116322959,
    __spreadArrays: $ec324c786bf97113$export$6388937ca91ccae8,
    __spreadArray: $ec324c786bf97113$export$1216008129fb82ed,
    __await: $ec324c786bf97113$export$10c90e4f7922046c,
    __asyncGenerator: $ec324c786bf97113$export$e427f37a30a4de9b,
    __asyncDelegator: $ec324c786bf97113$export$bbd80228419bb833,
    __asyncValues: $ec324c786bf97113$export$e3b29a3d6162315f,
    __makeTemplateObject: $ec324c786bf97113$export$4fb47efe1390b86f,
    __importStar: $ec324c786bf97113$export$c21735bcef00d192,
    __importDefault: $ec324c786bf97113$export$da59b14a69baef04,
    __classPrivateFieldGet: $ec324c786bf97113$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $ec324c786bf97113$export$d40a35129aaff81f,
    __classPrivateFieldIn: $ec324c786bf97113$export$81fdc39f203e4e04,
    __addDisposableResource: $ec324c786bf97113$export$88ac25d8e944e405,
    __disposeResources: $ec324c786bf97113$export$8f076105dc360e92
};

});

parcelRegister("8bDPm", function(module, exports) {

$parcel$export(module.exports, "WHITE_SPACE_REGEX", function () { return $5f5e3eb6be80d492$export$2b8db14d8bcaece7; });
// @generated from regex-gen.ts
var $5f5e3eb6be80d492$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});





parcelRegister("4kHyt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $327ad0d0c2345229$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "strategies", function () { return $327ad0d0c2345229$export$c5491a8691a23b9e; });
//
// Main
//
function $327ad0d0c2345229$export$2e2bcd8739ae039(fn, options) {
    var cache = options && options.cache ? options.cache : $327ad0d0c2345229$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $327ad0d0c2345229$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $327ad0d0c2345229$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $327ad0d0c2345229$var$isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean"; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $327ad0d0c2345229$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $327ad0d0c2345229$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $327ad0d0c2345229$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $327ad0d0c2345229$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $327ad0d0c2345229$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $327ad0d0c2345229$var$monadic : $327ad0d0c2345229$var$variadic;
    return $327ad0d0c2345229$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $327ad0d0c2345229$var$strategyVariadic(fn, options) {
    return $327ad0d0c2345229$var$assemble(fn, this, $327ad0d0c2345229$var$variadic, options.cache.create(), options.serializer);
}
function $327ad0d0c2345229$var$strategyMonadic(fn, options) {
    return $327ad0d0c2345229$var$assemble(fn, this, $327ad0d0c2345229$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $327ad0d0c2345229$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $327ad0d0c2345229$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$327ad0d0c2345229$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$327ad0d0c2345229$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $327ad0d0c2345229$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $327ad0d0c2345229$var$ObjectWithoutPrototypeCache();
    }
};
var $327ad0d0c2345229$export$c5491a8691a23b9e = {
    variadic: $327ad0d0c2345229$var$strategyVariadic,
    monadic: $327ad0d0c2345229$var$strategyMonadic
};

});

parcelRegister("bGcOL", function(module, exports) {

$parcel$export(module.exports, "PART_TYPE", function () { return $880d8f47d0114459$export$49694c2877b44c57; });
$parcel$export(module.exports, "formatToParts", function () { return $880d8f47d0114459$export$275d4a3bb5f66fda; });
parcelRequire("caeho");
var $iW1v8 = parcelRequire("iW1v8");

var $f2aIU = parcelRequire("f2aIU");
var $880d8f47d0114459$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($880d8f47d0114459$export$49694c2877b44c57 || ($880d8f47d0114459$export$49694c2877b44c57 = {}));
function $880d8f47d0114459$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $880d8f47d0114459$export$49694c2877b44c57.literal || part.type !== $880d8f47d0114459$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $880d8f47d0114459$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $880d8f47d0114459$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $iW1v8.isLiteralElement)(els[0])) return [
        {
            type: $880d8f47d0114459$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $iW1v8.isLiteralElement)(el)) {
            result.push({
                type: $880d8f47d0114459$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $iW1v8.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $880d8f47d0114459$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $f2aIU.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $iW1v8.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $880d8f47d0114459$export$49694c2877b44c57.literal : $880d8f47d0114459$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $iW1v8.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $iW1v8.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $880d8f47d0114459$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $iW1v8.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $iW1v8.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $880d8f47d0114459$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $iW1v8.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $iW1v8.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $880d8f47d0114459$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $iW1v8.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$880d8f47d0114459$export$df0c12a2d414a163(formatFn)) throw new (0, $f2aIU.InvalidValueTypeError)(value_1, "function", originalMessage);
            var parts = $880d8f47d0114459$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $880d8f47d0114459$export$49694c2877b44c57.literal : $880d8f47d0114459$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $iW1v8.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $f2aIU.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $880d8f47d0114459$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $iW1v8.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $f2aIU.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $f2aIU.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $f2aIU.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $880d8f47d0114459$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $880d8f47d0114459$var$mergeLiteral(result);
}

});
parcelRegister("f2aIU", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $af1f5c5ea389d253$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "FormatError", function () { return $af1f5c5ea389d253$export$7369836851cc1329; });
$parcel$export(module.exports, "InvalidValueError", function () { return $af1f5c5ea389d253$export$565c3afc07dfa382; });
$parcel$export(module.exports, "InvalidValueTypeError", function () { return $af1f5c5ea389d253$export$cbc0db47c750f7c9; });
$parcel$export(module.exports, "MissingValueError", function () { return $af1f5c5ea389d253$export$8bfc137e4d23fdf0; });

var $k5nvU = parcelRequire("k5nvU");
var $af1f5c5ea389d253$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($af1f5c5ea389d253$export$d4e71bc0b80dc0fb || ($af1f5c5ea389d253$export$d4e71bc0b80dc0fb = {}));
var $af1f5c5ea389d253$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $k5nvU.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $af1f5c5ea389d253$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $k5nvU.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $af1f5c5ea389d253$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($af1f5c5ea389d253$export$7369836851cc1329);
var $af1f5c5ea389d253$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $k5nvU.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $af1f5c5ea389d253$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($af1f5c5ea389d253$export$7369836851cc1329);
var $af1f5c5ea389d253$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $k5nvU.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $af1f5c5ea389d253$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($af1f5c5ea389d253$export$7369836851cc1329);

});



parcelRegister("043Q6", function(module, exports) {

$parcel$export(module.exports, "IntlErrorCode", function () { return $00c35a41cf9e6348$export$557d6acb76e8a244; });
$parcel$export(module.exports, "IntlError", function () { return $00c35a41cf9e6348$export$c016d36112f6ddf8; });
$parcel$export(module.exports, "UnsupportedFormatterError", function () { return $00c35a41cf9e6348$export$549f97e137a05c90; });
$parcel$export(module.exports, "InvalidConfigError", function () { return $00c35a41cf9e6348$export$3ca04dd7fb305893; });
$parcel$export(module.exports, "MissingDataError", function () { return $00c35a41cf9e6348$export$c1eaf877d81384b6; });
$parcel$export(module.exports, "IntlFormatError", function () { return $00c35a41cf9e6348$export$e3b7eee1dbc44895; });
$parcel$export(module.exports, "MessageFormatError", function () { return $00c35a41cf9e6348$export$74a601a3d3f31621; });
$parcel$export(module.exports, "MissingTranslationError", function () { return $00c35a41cf9e6348$export$2ddcb436d0aa3688; });

var $k5nvU = parcelRequire("k5nvU");
var $00c35a41cf9e6348$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($00c35a41cf9e6348$export$557d6acb76e8a244 || ($00c35a41cf9e6348$export$557d6acb76e8a244 = {}));
var $00c35a41cf9e6348$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $k5nvU.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, " \n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : "")) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === "function") // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $00c35a41cf9e6348$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $k5nvU.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $00c35a41cf9e6348$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($00c35a41cf9e6348$export$c016d36112f6ddf8);
var $00c35a41cf9e6348$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $k5nvU.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $00c35a41cf9e6348$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($00c35a41cf9e6348$export$c016d36112f6ddf8);
var $00c35a41cf9e6348$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $k5nvU.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $00c35a41cf9e6348$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($00c35a41cf9e6348$export$c016d36112f6ddf8);
var $00c35a41cf9e6348$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $k5nvU.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        return _super.call(this, $00c35a41cf9e6348$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, " \nLocale: ").concat(locale, "\n"), exception) || this;
    }
    return IntlFormatError;
}($00c35a41cf9e6348$export$c016d36112f6ddf8);
var $00c35a41cf9e6348$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $k5nvU.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, " \nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, " \n"), locale, exception) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MessageFormatError;
}($00c35a41cf9e6348$export$e3b7eee1dbc44895);
var $00c35a41cf9e6348$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $k5nvU.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $00c35a41cf9e6348$export$557d6acb76e8a244.MISSING_TRANSLATION, 'Missing message: "'.concat(descriptor.id, '" for locale "').concat(locale, '", using ').concat(descriptor.defaultMessage ? "default message" : "id", " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($00c35a41cf9e6348$export$c016d36112f6ddf8);

});




parcelRegister("32DlT", function(module, exports) {

$parcel$export(module.exports, "createIntl", function () { return $2370158719001aa3$export$7e4cbedfdd7b4c0d; });

var $k5nvU = parcelRequire("k5nvU");

var $5Nrk0 = parcelRequire("5Nrk0");

var $043Q6 = parcelRequire("043Q6");

var $1whKi = parcelRequire("1whKi");

var $bbJbp = parcelRequire("bbJbp");

var $fqZV9 = parcelRequire("fqZV9");

var $4LmiQ = parcelRequire("4LmiQ");

var $hgZSp = parcelRequire("hgZSp");

var $7t9p9 = parcelRequire("7t9p9");

var $k3OFH = parcelRequire("k3OFH");
function $2370158719001aa3$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === "string";
}
function $2370158719001aa3$var$verifyConfigMessages(config) {
    if (config.defaultRichTextElements && $2370158719001aa3$var$messagesContainString(config.messages || {})) console.warn('[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. \nPlease consider using "@formatjs/cli" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution');
}
function $2370158719001aa3$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $5Nrk0.createFormatters)(cache);
    var resolvedConfig = (0, $k5nvU.__assign)((0, $k5nvU.__assign)({}, (0, $5Nrk0.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $043Q6.InvalidConfigError)('"locale" was not configured, using "'.concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details')));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || "en";
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $043Q6.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.NumberFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $043Q6.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.DateTimeFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    $2370158719001aa3$var$verifyConfigMessages(resolvedConfig);
    return (0, $k5nvU.__assign)((0, $k5nvU.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $1whKi.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $1whKi.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $bbJbp.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $fqZV9.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $fqZV9.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $fqZV9.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $fqZV9.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $fqZV9.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $4LmiQ.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $hgZSp.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $7t9p9.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $7t9p9.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $k3OFH.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("1whKi", function(module, exports) {

$parcel$export(module.exports, "formatNumber", function () { return $11b68b8debe4b06e$export$f5dd818bff069720; });
$parcel$export(module.exports, "formatNumberToParts", function () { return $11b68b8debe4b06e$export$6871080848f10b2f; });

var $5Nrk0 = parcelRequire("5Nrk0");

var $043Q6 = parcelRequire("043Q6");
var $11b68b8debe4b06e$var$NUMBER_FORMAT_OPTIONS = [
    "localeMatcher",
    "style",
    "currency",
    "currencyDisplay",
    "unit",
    "unitDisplay",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    // ES2020 NumberFormat
    "compactDisplay",
    "currencyDisplay",
    "currencySign",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "numberingSystem"
];
function $11b68b8debe4b06e$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $5Nrk0.getNamedFormat)(formats, "number", format, onError) || {};
    var filteredOptions = (0, $5Nrk0.filterProps)(options, $11b68b8debe4b06e$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $11b68b8debe4b06e$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $11b68b8debe4b06e$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $043Q6.IntlError)((0, $043Q6.IntlErrorCode).FORMAT_ERROR, "Error formatting number.", e));
    }
    return String(value);
}
function $11b68b8debe4b06e$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $11b68b8debe4b06e$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $043Q6.IntlError)((0, $043Q6.IntlErrorCode).FORMAT_ERROR, "Error formatting number.", e));
    }
    return [];
}

});

parcelRegister("bbJbp", function(module, exports) {

$parcel$export(module.exports, "formatRelativeTime", function () { return $8253c52da783021f$export$b4ea3b48dcf921f6; });

var $5Nrk0 = parcelRequire("5Nrk0");

var $f2aIU = parcelRequire("f2aIU");

var $043Q6 = parcelRequire("043Q6");
var $8253c52da783021f$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    "numeric",
    "style"
];
function $8253c52da783021f$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $5Nrk0.getNamedFormat)(formats, "relative", format, onError) || {};
    var filteredOptions = (0, $5Nrk0.filterProps)(options, $8253c52da783021f$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $8253c52da783021f$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = "second";
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $f2aIU.FormatError)('Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-relativetimeformat"\n', (0, $f2aIU.ErrorCode).MISSING_INTL_API));
    try {
        return $8253c52da783021f$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $043Q6.IntlFormatError)("Error formatting relative time.", config.locale, e));
    }
    return String(value);
}

});

parcelRegister("fqZV9", function(module, exports) {

$parcel$export(module.exports, "formatDate", function () { return $b3c950e0c54f66ac$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "formatTime", function () { return $b3c950e0c54f66ac$export$3203edd9e5edd663; });
$parcel$export(module.exports, "formatDateTimeRange", function () { return $b3c950e0c54f66ac$export$a7fc3a91cb2ec376; });
$parcel$export(module.exports, "formatDateToParts", function () { return $b3c950e0c54f66ac$export$dc1f059bce486b1; });
$parcel$export(module.exports, "formatTimeToParts", function () { return $b3c950e0c54f66ac$export$af6e5d7a5c73edeb; });

var $k5nvU = parcelRequire("k5nvU");

var $5Nrk0 = parcelRequire("5Nrk0");

var $043Q6 = parcelRequire("043Q6");
var $b3c950e0c54f66ac$var$DATE_TIME_FORMAT_OPTIONS = [
    "localeMatcher",
    "formatMatcher",
    "timeZone",
    "hour12",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "hourCycle",
    "dateStyle",
    "timeStyle",
    "calendar",
    // 'dayPeriod',
    "numberingSystem"
];
function $b3c950e0c54f66ac$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $k5nvU.__assign)((0, $k5nvU.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $5Nrk0.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $5Nrk0.filterProps)(options, $b3c950e0c54f66ac$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === "time" && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $k5nvU.__assign)((0, $k5nvU.__assign)({}, filteredOptions), {
        hour: "numeric",
        minute: "numeric"
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $b3c950e0c54f66ac$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $b3c950e0c54f66ac$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $043Q6.IntlError)((0, $043Q6.IntlErrorCode).FORMAT_ERROR, "Error formatting date.", e));
    }
    return String(date);
}
function $b3c950e0c54f66ac$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $b3c950e0c54f66ac$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $043Q6.IntlError)((0, $043Q6.IntlErrorCode).FORMAT_ERROR, "Error formatting time.", e));
    }
    return String(date);
}
function $b3c950e0c54f66ac$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $5Nrk0.filterProps)(options, $b3c950e0c54f66ac$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $043Q6.IntlError)((0, $043Q6.IntlErrorCode).FORMAT_ERROR, "Error formatting date time range.", e));
    }
    return String(from);
}
function $b3c950e0c54f66ac$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $b3c950e0c54f66ac$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $043Q6.IntlError)((0, $043Q6.IntlErrorCode).FORMAT_ERROR, "Error formatting date.", e));
    }
    return [];
}
function $b3c950e0c54f66ac$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $b3c950e0c54f66ac$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $043Q6.IntlError)((0, $043Q6.IntlErrorCode).FORMAT_ERROR, "Error formatting time.", e));
    }
    return [];
}

});

parcelRegister("4LmiQ", function(module, exports) {

$parcel$export(module.exports, "formatPlural", function () { return $377cda1d25fded24$export$bbbd05c900f3568d; });

var $5Nrk0 = parcelRequire("5Nrk0");

var $043Q6 = parcelRequire("043Q6");

var $f2aIU = parcelRequire("f2aIU");
var $377cda1d25fded24$var$PLURAL_FORMAT_OPTIONS = [
    "localeMatcher",
    "type"
];
function $377cda1d25fded24$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $f2aIU.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $f2aIU.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $5Nrk0.filterProps)(options, $377cda1d25fded24$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $043Q6.IntlFormatError)("Error formatting plural.", locale, e));
    }
    return "other";
}

});

parcelRegister("hgZSp", function(module, exports) {

$parcel$export(module.exports, "formatMessage", function () { return $c933edb3af28b0cd$export$25868d1e8e76735f; });

var $k5nvU = parcelRequire("k5nvU");

var $4kRXG = parcelRequire("4kRXG");

var $dWzd9 = parcelRequire("dWzd9");

var $043Q6 = parcelRequire("043Q6");
parcelRequire("caeho");
var $iW1v8 = parcelRequire("iW1v8");
function $c933edb3af28b0cd$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $k5nvU.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $c933edb3af28b0cd$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $k5nvU.__assign)((0, $k5nvU.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $k5nvU.__assign)((0, $k5nvU.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $c933edb3af28b0cd$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $dWzd9.IntlMessageFormat).formats;
    return (0, $k5nvU.__assign)((0, $k5nvU.__assign)((0, $k5nvU.__assign)({}, mfFormats), f1), {
        date: $c933edb3af28b0cd$var$deepMergeOptions($c933edb3af28b0cd$var$setTimeZoneInOptions(mfFormats.date, timeZone), $c933edb3af28b0cd$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $c933edb3af28b0cd$var$deepMergeOptions($c933edb3af28b0cd$var$setTimeZoneInOptions(mfFormats.time, timeZone), $c933edb3af28b0cd$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
function $c933edb3af28b0cd$export$25868d1e8e76735f(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ""
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $4kRXG.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $iW1v8.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === "string" && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $k5nvU.__assign)((0, $k5nvU.__assign)({}, defaultRichTextElements), values || {});
    formats = $c933edb3af28b0cd$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $c933edb3af28b0cd$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === "") return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $043Q6.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $043Q6.MessageFormatError)('Error formatting default message for: "'.concat(id, '", rendering default message verbatim'), locale, messageDescriptor, e));
            return typeof defaultMessage === "string" ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $k5nvU.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $043Q6.MessageFormatError)('Error formatting message: "'.concat(id, '", using ').concat(defaultMessage ? "default message" : "id", " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $043Q6.MessageFormatError)('Error formatting the default message for: "'.concat(id, '", rendering message verbatim'), locale, messageDescriptor, e));
    }
    if (typeof message === "string") return message;
    if (typeof defaultMessage === "string") return defaultMessage;
    return id;
}

});

parcelRegister("7t9p9", function(module, exports) {

$parcel$export(module.exports, "formatList", function () { return $57028968afc4db87$export$e8b8be48b45905bb; });
$parcel$export(module.exports, "formatListToParts", function () { return $57028968afc4db87$export$6f284aad1934db69; });

var $k5nvU = parcelRequire("k5nvU");

var $5Nrk0 = parcelRequire("5Nrk0");

var $f2aIU = parcelRequire("f2aIU");

var $043Q6 = parcelRequire("043Q6");
var $57028968afc4db87$var$LIST_FORMAT_OPTIONS = [
    "localeMatcher",
    "type",
    "style"
];
var $57028968afc4db87$var$now = Date.now();
function $57028968afc4db87$var$generateToken(i) {
    return "".concat($57028968afc4db87$var$now, "_").concat(i, "_").concat($57028968afc4db87$var$now);
}
function $57028968afc4db87$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $57028968afc4db87$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== "string") all.push(val);
        else if (typeof all[all.length - 1] === "string") all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results;
}
function $57028968afc4db87$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $f2aIU.FormatError)('Intl.ListFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-listformat"\n', (0, $f2aIU.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $5Nrk0.filterProps)(options, $57028968afc4db87$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === "object") {
                var id = $57028968afc4db87$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === "literal" ? part : (0, $k5nvU.__assign)((0, $k5nvU.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $043Q6.IntlError)((0, $043Q6.IntlErrorCode).FORMAT_ERROR, "Error formatting list.", e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("k3OFH", function(module, exports) {

$parcel$export(module.exports, "formatDisplayName", function () { return $e9ab64ccae307c34$export$62fe1a4d9e891fa2; });

var $5Nrk0 = parcelRequire("5Nrk0");

var $f2aIU = parcelRequire("f2aIU");

var $043Q6 = parcelRequire("043Q6");
var $e9ab64ccae307c34$var$DISPLAY_NAMES_OPTONS = [
    "localeMatcher",
    "style",
    "type",
    "fallback"
];
function $e9ab64ccae307c34$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $f2aIU.FormatError)('Intl.DisplayNames is not available in this environment.\nTry polyfilling it using "@formatjs/intl-displaynames"\n', (0, $f2aIU.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $5Nrk0.filterProps)(options, $e9ab64ccae307c34$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $043Q6.IntlError)((0, $043Q6.IntlErrorCode).FORMAT_ERROR, "Error formatting display name.", e));
    }
}

});


parcelRegister("iJJ9C", function(module, exports) {

$parcel$export(module.exports, "isFormatXMLElementFn", function () { return $da3f74a6d674d685$export$df0c12a2d414a163; });
parcelRequire("caeho");
var $iW1v8 = parcelRequire("iW1v8");

var $7PILA = parcelRequire("7PILA");
var $da3f74a6d674d685$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($da3f74a6d674d685$export$49694c2877b44c57 || ($da3f74a6d674d685$export$49694c2877b44c57 = {}));
function $da3f74a6d674d685$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $da3f74a6d674d685$export$49694c2877b44c57.literal || part.type !== $da3f74a6d674d685$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $da3f74a6d674d685$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $da3f74a6d674d685$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $iW1v8.isLiteralElement)(els[0])) return [
        {
            type: $da3f74a6d674d685$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $iW1v8.isLiteralElement)(el)) {
            result.push({
                type: $da3f74a6d674d685$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $iW1v8.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $da3f74a6d674d685$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $7PILA.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $iW1v8.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $da3f74a6d674d685$export$49694c2877b44c57.literal : $da3f74a6d674d685$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $iW1v8.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $iW1v8.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $da3f74a6d674d685$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $iW1v8.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $iW1v8.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $da3f74a6d674d685$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $iW1v8.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $iW1v8.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $da3f74a6d674d685$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $iW1v8.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$da3f74a6d674d685$export$df0c12a2d414a163(formatFn)) throw new (0, $7PILA.InvalidValueTypeError)(value_1, "function", originalMessage);
            var parts = $da3f74a6d674d685$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $da3f74a6d674d685$export$49694c2877b44c57.literal : $da3f74a6d674d685$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $iW1v8.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $7PILA.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $da3f74a6d674d685$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $iW1v8.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $7PILA.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $7PILA.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $7PILA.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $da3f74a6d674d685$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $da3f74a6d674d685$var$mergeLiteral(result);
}

});
parcelRegister("7PILA", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $5b40058285aeb5d6$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "FormatError", function () { return $5b40058285aeb5d6$export$7369836851cc1329; });
$parcel$export(module.exports, "InvalidValueError", function () { return $5b40058285aeb5d6$export$565c3afc07dfa382; });
$parcel$export(module.exports, "InvalidValueTypeError", function () { return $5b40058285aeb5d6$export$cbc0db47c750f7c9; });
$parcel$export(module.exports, "MissingValueError", function () { return $5b40058285aeb5d6$export$8bfc137e4d23fdf0; });

var $jGOup = parcelRequire("jGOup");
var $5b40058285aeb5d6$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($5b40058285aeb5d6$export$d4e71bc0b80dc0fb || ($5b40058285aeb5d6$export$d4e71bc0b80dc0fb = {}));
var $5b40058285aeb5d6$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $jGOup.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $5b40058285aeb5d6$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $jGOup.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $5b40058285aeb5d6$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($5b40058285aeb5d6$export$7369836851cc1329);
var $5b40058285aeb5d6$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $jGOup.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $5b40058285aeb5d6$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($5b40058285aeb5d6$export$7369836851cc1329);
var $5b40058285aeb5d6$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $jGOup.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $5b40058285aeb5d6$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($5b40058285aeb5d6$export$7369836851cc1329);

});



parcelRegister("dGzLf", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return (parcelRequire("64MZm")).default; });
$parcel$export(module.exports, "connect", function () { return (parcelRequire("5oGLl")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("eeHDY")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("aAre5")).useSelector; });
$parcel$export(module.exports, "shallowEqual", function () { return (parcelRequire("1ED64")).default; });

var $64MZm = parcelRequire("64MZm");

var $aAk2r = parcelRequire("aAk2r");

var $dgBbb = parcelRequire("dgBbb");

var $5oGLl = parcelRequire("5oGLl");

var $eeHDY = parcelRequire("eeHDY");

var $aAre5 = parcelRequire("aAre5");

var $cVELt = parcelRequire("cVELt");

var $c3LUC = parcelRequire("c3LUC");
parcelRequire("l4Hgm");
var $lnOmc = parcelRequire("lnOmc");

var $1ED64 = parcelRequire("1ED64");
(0, $c3LUC.setBatch)((0, $lnOmc.unstable_batchedUpdates));

});
parcelRegister("64MZm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46c91dee9b3e2a7d$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");

var $dgBbb = parcelRequire("dgBbb");

var $3FjOU = parcelRequire("3FjOU");
function $46c91dee9b3e2a7d$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $9nHZC.useMemo)(function() {
        var subscription = new (0, $3FjOU.default)(store);
        subscription.onStateChange = subscription.notifyNestedSubs;
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $9nHZC.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $9nHZC.useEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $dgBbb.ReactReduxContext);
    return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
$46c91dee9b3e2a7d$var$Provider.propTypes = {
    store: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).shape({
        subscribe: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func.isRequired,
        dispatch: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func.isRequired,
        getState: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func.isRequired
    }),
    context: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).any
};
var $46c91dee9b3e2a7d$export$2e2bcd8739ae039 = $46c91dee9b3e2a7d$var$Provider;

});
parcelRegister("dgBbb", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", function () { return $9a899c048b14114b$export$cc80c08dc91f1c00; });

var $9nHZC = parcelRequire("9nHZC");
var $9a899c048b14114b$export$cc80c08dc91f1c00 = (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createContext(null);
var $9a899c048b14114b$export$2e2bcd8739ae039 = $9a899c048b14114b$export$cc80c08dc91f1c00;

});

parcelRegister("3FjOU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ab493485e6d6ed2$export$2e2bcd8739ae039; });

var $c3LUC = parcelRequire("c3LUC");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var $2ab493485e6d6ed2$var$CLEARED = null;
var $2ab493485e6d6ed2$var$nullListeners = {
    notify: function notify() {}
};
function $2ab493485e6d6ed2$var$createListenerCollection() {
    var batch = (0, $c3LUC.getBatch)(); // the current/next pattern is copied from redux's createStore code.
    // TODO: refactor+expose that code to be reusable here?
    var current = [];
    var next = [];
    return {
        clear: function clear() {
            next = $2ab493485e6d6ed2$var$CLEARED;
            current = $2ab493485e6d6ed2$var$CLEARED;
        },
        notify: function notify() {
            var listeners = current = next;
            batch(function() {
                for(var i = 0; i < listeners.length; i++)listeners[i]();
            });
        },
        get: function get() {
            return next;
        },
        subscribe: function subscribe(listener) {
            var isSubscribed = true;
            if (next === current) next = current.slice();
            next.push(listener);
            return function unsubscribe() {
                if (!isSubscribed || current === $2ab493485e6d6ed2$var$CLEARED) return;
                isSubscribed = false;
                if (next === current) next = current.slice();
                next.splice(next.indexOf(listener), 1);
            };
        }
    };
}
var $2ab493485e6d6ed2$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscription(store, parentSub) {
        this.store = store;
        this.parentSub = parentSub;
        this.unsubscribe = null;
        this.listeners = $2ab493485e6d6ed2$var$nullListeners;
        this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
    }
    var _proto = Subscription.prototype;
    _proto.addNestedSub = function addNestedSub(listener) {
        this.trySubscribe();
        return this.listeners.subscribe(listener);
    };
    _proto.notifyNestedSubs = function notifyNestedSubs() {
        this.listeners.notify();
    };
    _proto.handleChangeWrapper = function handleChangeWrapper() {
        if (this.onStateChange) this.onStateChange();
    };
    _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.unsubscribe);
    };
    _proto.trySubscribe = function trySubscribe() {
        if (!this.unsubscribe) {
            this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper);
            this.listeners = $2ab493485e6d6ed2$var$createListenerCollection();
        }
    };
    _proto.tryUnsubscribe = function tryUnsubscribe() {
        if (this.unsubscribe) {
            this.unsubscribe();
            this.unsubscribe = null;
            this.listeners.clear();
            this.listeners = $2ab493485e6d6ed2$var$nullListeners;
        }
    };
    return Subscription;
}();

});
parcelRegister("c3LUC", function(module, exports) {

$parcel$export(module.exports, "setBatch", function () { return $8c7aee3c4df04d2a$export$4b9874722d0da7bc; });
$parcel$export(module.exports, "getBatch", function () { return $8c7aee3c4df04d2a$export$fc47d4c0ba3bd2c6; });
// Default to a dummy "batch" implementation that just runs the callback
function $8c7aee3c4df04d2a$var$defaultNoopBatch(callback) {
    callback();
}
var $8c7aee3c4df04d2a$var$batch = $8c7aee3c4df04d2a$var$defaultNoopBatch; // Allow injecting another batching function later
var $8c7aee3c4df04d2a$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $8c7aee3c4df04d2a$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $8c7aee3c4df04d2a$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $8c7aee3c4df04d2a$var$batch;
};

});



parcelRegister("aAk2r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b4ccf605efd5571$export$2e2bcd8739ae039; });

var $ii97e = parcelRequire("ii97e");

var $4dya5 = parcelRequire("4dya5");

var $1t1PC = parcelRequire("1t1PC");

var $5kF1c = parcelRequire("5kF1c");

var $9nHZC = parcelRequire("9nHZC");

var $fAROH = parcelRequire("fAROH");

var $3FjOU = parcelRequire("3FjOU");

var $dgBbb = parcelRequire("dgBbb");
var $7b4ccf605efd5571$var$EMPTY_ARRAY = [];
var $7b4ccf605efd5571$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $7b4ccf605efd5571$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $7b4ccf605efd5571$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
var $7b4ccf605efd5571$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
}; // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect because we want
// `connect` to perform sync updates to a ref to save the latest props after
// a render is actually committed to the DOM.
var $7b4ccf605efd5571$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $9nHZC.useLayoutEffect) : (0, $9nHZC.useEffect);
function $7b4ccf605efd5571$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? "connectAdvanced" : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? "store" : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $dgBbb.ReactReduxContext) : _ref2$context, connectOptions = (0, $4dya5.default)(_ref2, [
        "getDisplayName",
        "methodName",
        "renderCountProp",
        "shouldHandleStateChanges",
        "storeKey",
        "withRef",
        "forwardRef",
        "context"
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5kF1c)))(renderCountProp === undefined, "renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
    (0, (/*@__PURE__*/$parcel$interopDefault($5kF1c)))(!withRef, "withRef is removed. To access the wrapped instance, use a ref on the connected component");
    var customStoreWarningMessage = "To use a custom Redux store for specific components, create a custom React context with React.createContext(), and pass the context object to React Redux's Provider and specific components like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. You may also pass a {context : MyContext} option to connect";
    (0, (/*@__PURE__*/$parcel$interopDefault($5kF1c)))(storeKey === "store", "storeKey has been removed and does not do anything. " + customStoreWarningMessage);
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $ii97e.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $9nHZC.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $9nHZC.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var forwardedRef = props.forwardedRef, wrapperProps = (0, $4dya5.default)(props, [
                    "forwardedRef"
                ]);
                return [
                    props.context,
                    forwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], forwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $9nHZC.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $fAROH.isContextConsumer)((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $9nHZC.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context
            var didStoreComeFromProps = Boolean(props.store);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            (0, (/*@__PURE__*/$parcel$interopDefault($5kF1c)))(didStoreComeFromProps || didStoreComeFromContext, 'Could not find "store" in the context of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
            var store = props.store || contextValue.store;
            var childPropsSelector = (0, $9nHZC.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $9nHZC.useMemo)(function() {
                if (!shouldHandleStateChanges) return $7b4ccf605efd5571$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = new (0, $3FjOU.default)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $9nHZC.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $ii97e.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $9nHZC.useReducer)($7b4ccf605efd5571$var$storeStateUpdatesReducer, $7b4ccf605efd5571$var$EMPTY_ARRAY, $7b4ccf605efd5571$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $9nHZC.useRef)();
            var lastWrapperProps = (0, $9nHZC.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $9nHZC.useRef)();
            var renderIsScheduled = (0, $9nHZC.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $7b4ccf605efd5571$var$useIsomorphicLayoutEffect(function() {
                // We want to capture the wrapper props and child props we used for later comparisons
                lastWrapperProps.current = wrapperProps;
                lastChildProps.current = actualChildProps;
                renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
                if (childPropsFromStoreUpdate.current) {
                    childPropsFromStoreUpdate.current = null;
                    notifyNestedSubs();
                }
            }); // Our re-subscribe logic only runs when the store/subscription setup changes
            $7b4ccf605efd5571$var$useIsomorphicLayoutEffect(function() {
                // If we're not subscribed to the store, nothing to do here
                if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
                var didUnsubscribe = false;
                var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
                var checkForUpdates = function checkForUpdates() {
                    if (didUnsubscribe) // Don't run stale listeners.
                    // Redux doesn't guarantee unsubscriptions happen until next dispatch.
                    return;
                    var latestStoreState = store.getState();
                    var newChildProps, error;
                    try {
                        // Actually run the selector with the most recent store state and wrapper props
                        // to determine what the child props should be
                        newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
                    } catch (e) {
                        error = e;
                        lastThrownError = e;
                    }
                    if (!error) lastThrownError = null;
                     // If the child props haven't changed, nothing to do here - cascade the subscription update
                    if (newChildProps === lastChildProps.current) {
                        if (!renderIsScheduled.current) notifyNestedSubs();
                    } else {
                        // Save references to the new child props.  Note that we track the "child props from store update"
                        // as a ref instead of a useState/useReducer because we need a way to determine if that value has
                        // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
                        // forcing another re-render, which we don't want.
                        lastChildProps.current = newChildProps;
                        childPropsFromStoreUpdate.current = newChildProps;
                        renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
                        forceComponentUpdateDispatch({
                            type: "STORE_UPDATED",
                            payload: {
                                latestStoreState: latestStoreState,
                                error: error
                            }
                        });
                    }
                }; // Actually subscribe to the nearest connected ancestor (or store)
                subscription.onStateChange = checkForUpdates;
                subscription.trySubscribe(); // Pull data from the store after first render in case the store has
                // changed since we began.
                checkForUpdates();
                var unsubscribeWrapper = function unsubscribeWrapper() {
                    didUnsubscribe = true;
                    subscription.tryUnsubscribe();
                    subscription.onStateChange = null;
                    if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
                    // parent re-rendered without this component and we're about to unmount.
                    // This shouldn't happen as long as we do top-down subscriptions correctly, but
                    // if we ever do those wrong, this throw will surface the error in our tests.
                    // In that case, throw the error from here so it doesn't get lost.
                    throw lastThrownError;
                };
                return unsubscribeWrapper;
            }, [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $9nHZC.useMemo)(function() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedComponent, (0, $ii97e.default)({}, actualChildProps, {
                    ref: forwardedRef
                }));
            }, [
                forwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $9nHZC.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function forwardConnectRef(props, ref) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Connect, (0, $ii97e.default)({}, props, {
                    forwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($1t1PC)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($1t1PC)))(Connect, WrappedComponent);
    };
}

});
parcelRegister("ii97e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d510fa9d9c1efd38$export$2e2bcd8739ae039; });
function $d510fa9d9c1efd38$export$2e2bcd8739ae039() {
    return $d510fa9d9c1efd38$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d510fa9d9c1efd38$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("4dya5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3122e01b8c9df210$export$2e2bcd8739ae039; });
function $3122e01b8c9df210$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("5oGLl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ee05d63f47fcb4e$export$2e2bcd8739ae039; });

var $ii97e = parcelRequire("ii97e");

var $4dya5 = parcelRequire("4dya5");

var $aAk2r = parcelRequire("aAk2r");

var $1ED64 = parcelRequire("1ED64");

var $gzXr9 = parcelRequire("gzXr9");

var $39m55 = parcelRequire("39m55");

var $4ghnp = parcelRequire("4ghnp");

var $cuchK = parcelRequire("cuchK");
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $3ee05d63f47fcb4e$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $3ee05d63f47fcb4e$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $3ee05d63f47fcb4e$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $aAk2r.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $39m55.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $gzXr9.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $4ghnp.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $cuchK.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $3ee05d63f47fcb4e$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $1ED64.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $1ED64.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $1ED64.default) : _ref3$areMergedPropsE, extraOptions = (0, $4dya5.default)(_ref3, [
            "pure",
            "areStatesEqual",
            "areOwnPropsEqual",
            "areStatePropsEqual",
            "areMergedPropsEqual"
        ]);
        var initMapStateToProps = $3ee05d63f47fcb4e$var$match(mapStateToProps, mapStateToPropsFactories, "mapStateToProps");
        var initMapDispatchToProps = $3ee05d63f47fcb4e$var$match(mapDispatchToProps, mapDispatchToPropsFactories, "mapDispatchToProps");
        var initMergeProps = $3ee05d63f47fcb4e$var$match(mergeProps, mergePropsFactories, "mergeProps");
        return connectHOC(selectorFactory, (0, $ii97e.default)({
            // used in error messages
            methodName: "connect",
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $3ee05d63f47fcb4e$export$2e2bcd8739ae039 = $3ee05d63f47fcb4e$export$9f9feb656dec1fc4();

});
parcelRegister("1ED64", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1347dab82861998d$export$2e2bcd8739ae039; });
var $1347dab82861998d$var$hasOwn = Object.prototype.hasOwnProperty;
function $1347dab82861998d$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $1347dab82861998d$export$2e2bcd8739ae039(objA, objB) {
    if ($1347dab82861998d$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!$1347dab82861998d$var$hasOwn.call(objB, keysA[i]) || !$1347dab82861998d$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});

parcelRegister("gzXr9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c11e0524a0456273$export$2e2bcd8739ae039; });

var $jF3Yx = parcelRequire("jF3Yx");

var $gpWAh = parcelRequire("gpWAh");
function $c11e0524a0456273$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === "function" ? (0, $gpWAh.wrapMapToPropsFunc)(mapDispatchToProps, "mapDispatchToProps") : undefined;
}
function $c11e0524a0456273$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $gpWAh.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $c11e0524a0456273$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $gpWAh.wrapMapToPropsConstant)(function(dispatch) {
        return (0, $jF3Yx.bindActionCreators)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $c11e0524a0456273$export$2e2bcd8739ae039 = [
    $c11e0524a0456273$export$a9f27b4b187c1166,
    $c11e0524a0456273$export$ba20d1a7aa0c4a90,
    $c11e0524a0456273$export$94a6e55709d4d961
];

});
parcelRegister("jF3Yx", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $e504ee1ddb79fba3$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "combineReducers", function () { return $e504ee1ddb79fba3$export$66e4520cdb265d18; });
$parcel$export(module.exports, "bindActionCreators", function () { return $e504ee1ddb79fba3$export$aea084d96e84da92; });
$parcel$export(module.exports, "compose", function () { return $e504ee1ddb79fba3$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "applyMiddleware", function () { return $e504ee1ddb79fba3$export$9ff26e0402cc7b7; });

var $8tqiY = parcelRequire("8tqiY");
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $e504ee1ddb79fba3$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $e504ee1ddb79fba3$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $e504ee1ddb79fba3$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $e504ee1ddb79fba3$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $e504ee1ddb79fba3$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $e504ee1ddb79fba3$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ function $e504ee1ddb79fba3$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error("It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function.");
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error("Expected the enhancer to be a function.");
        return enhancer($e504ee1ddb79fba3$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error("Expected the reducer to be a function.");
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error("You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error("Expected the listener to be a function.");
        if (isDispatching) throw new Error("You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api-reference/store#subscribelistener for more details.");
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error("You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api-reference/store#subscribelistener for more details.");
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$e504ee1ddb79fba3$var$isPlainObject(action)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (typeof action.type === "undefined") throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (isDispatching) throw new Error("Reducers may not dispatch actions.");
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error("Expected the nextReducer to be a function.");
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $e504ee1ddb79fba3$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new TypeError("Expected the observer to be an object.");
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[0, $8tqiY.default] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $e504ee1ddb79fba3$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[0, $8tqiY.default] = observable, _ref2;
}
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $e504ee1ddb79fba3$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $e504ee1ddb79fba3$var$getUndefinedStateErrorMessage(key, action) {
    var actionType = action && action.type;
    var actionDescription = actionType && 'action "' + String(actionType) + '"' || "an action";
    return "Given " + actionDescription + ', reducer "' + key + '" returned undefined. ' + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}
function $e504ee1ddb79fba3$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $e504ee1ddb79fba3$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$e504ee1ddb79fba3$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + ({}).toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $e504ee1ddb79fba3$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $e504ee1ddb79fba3$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $e504ee1ddb79fba3$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
        if (typeof reducer(undefined, {
            type: $e504ee1ddb79fba3$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ("Don't try to handle " + $e504ee1ddb79fba3$export$4219e499db7ca678.INIT + ' or other actions in "redux/*" ') + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $e504ee1ddb79fba3$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $e504ee1ddb79fba3$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var errorMessage = $e504ee1ddb79fba3$var$getUndefinedStateErrorMessage(_key, action);
                throw new Error(errorMessage);
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $e504ee1ddb79fba3$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $e504ee1ddb79fba3$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $e504ee1ddb79fba3$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? "null" : typeof actionCreators) + ". " + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $e504ee1ddb79fba3$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
function $e504ee1ddb79fba3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e504ee1ddb79fba3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) keys.push.apply(keys, Object.getOwnPropertySymbols(object));
    if (enumerableOnly) keys = keys.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    return keys;
}
function $e504ee1ddb79fba3$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e504ee1ddb79fba3$var$ownKeys(source, true).forEach(function(key) {
            $e504ee1ddb79fba3$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e504ee1ddb79fba3$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $e504ee1ddb79fba3$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $e504ee1ddb79fba3$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error("Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $e504ee1ddb79fba3$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return $e504ee1ddb79fba3$var$_objectSpread2({}, store, {
                dispatch: _dispatch
            });
        };
    };
}
/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */ function $e504ee1ddb79fba3$var$isCrushed() {}

});

parcelRegister("gpWAh", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", function () { return $03159ea83041ed66$export$710f7c60f68acd3e; });
$parcel$export(module.exports, "wrapMapToPropsFunc", function () { return $03159ea83041ed66$export$8d46c7f53c8c602f; });
parcelRequire("ftYv6");
function $03159ea83041ed66$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $03159ea83041ed66$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $03159ea83041ed66$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $03159ea83041ed66$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $03159ea83041ed66$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("ftYv6", function(module, exports) {

var $3dtCF = parcelRequire("3dtCF");

var $foLni = parcelRequire("foLni");
function $b4587e9a89bb1770$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $3dtCF.default)(value)) (0, $foLni.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

});
parcelRegister("3dtCF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25799070e310a14f$export$2e2bcd8739ae039; });
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $25799070e310a14f$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});

parcelRegister("foLni", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b35dd88a311e082a$export$2e2bcd8739ae039; });
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $b35dd88a311e082a$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});




parcelRegister("39m55", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24b35737671c267b$export$2e2bcd8739ae039; });

var $gpWAh = parcelRequire("gpWAh");
function $24b35737671c267b$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === "function" ? (0, $gpWAh.wrapMapToPropsFunc)(mapStateToProps, "mapStateToProps") : undefined;
}
function $24b35737671c267b$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $gpWAh.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
var $24b35737671c267b$export$2e2bcd8739ae039 = [
    $24b35737671c267b$export$23fc470827b14aa,
    $24b35737671c267b$export$514bc8c1a53c1d66
];

});

parcelRegister("4ghnp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31a622ad707e6466$export$2e2bcd8739ae039; });

var $ii97e = parcelRequire("ii97e");
parcelRequire("ftYv6");
function $31a622ad707e6466$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $ii97e.default)({}, ownProps, {}, stateProps, {}, dispatchProps);
}
function $31a622ad707e6466$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $31a622ad707e6466$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === "function" ? $31a622ad707e6466$export$5b105939c84b5234(mergeProps) : undefined;
}
function $31a622ad707e6466$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $31a622ad707e6466$export$691c327fc30bc857;
    } : undefined;
}
var $31a622ad707e6466$export$2e2bcd8739ae039 = [
    $31a622ad707e6466$export$d61b680184bc3f00,
    $31a622ad707e6466$export$a13ba70ef50dda6d
];

});

parcelRegister("cuchK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9171d0f4b8b4be9c$export$2e2bcd8739ae039; });

var $4dya5 = parcelRequire("4dya5");
parcelRequire("38BRE");
function $9171d0f4b8b4be9c$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $9171d0f4b8b4be9c$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $9171d0f4b8b4be9c$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $4dya5.default)(_ref2, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $9171d0f4b8b4be9c$export$d20c0c2ca6eb2b6f : $9171d0f4b8b4be9c$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("38BRE", function(module, exports) {

var $foLni = parcelRequire("foLni");
function $248f7d89ebc96ca2$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $foLni.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $248f7d89ebc96ca2$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $248f7d89ebc96ca2$var$verify(mapStateToProps, "mapStateToProps", displayName);
    $248f7d89ebc96ca2$var$verify(mapDispatchToProps, "mapDispatchToProps", displayName);
    $248f7d89ebc96ca2$var$verify(mergeProps, "mergeProps", displayName);
}

});



parcelRegister("eeHDY", function(module, exports) {

$parcel$export(module.exports, "useDispatch", function () { return $a5d43a36d4453250$export$8ad76b76a4c905f8; });

var $dgBbb = parcelRequire("dgBbb");

var $cVELt = parcelRequire("cVELt");
function $a5d43a36d4453250$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $dgBbb.ReactReduxContext);
    var useStore = context === (0, $dgBbb.ReactReduxContext) ? (0, $cVELt.useStore) : (0, $cVELt.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $a5d43a36d4453250$export$8ad76b76a4c905f8 = $a5d43a36d4453250$export$bc9b55530897c558();

});
parcelRegister("cVELt", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", function () { return $969a6def3c7061f5$export$671dba69185d0304; });
$parcel$export(module.exports, "useStore", function () { return $969a6def3c7061f5$export$6ccbb43953eebf8; });

var $9nHZC = parcelRequire("9nHZC");

var $dgBbb = parcelRequire("dgBbb");

var $5sRFk = parcelRequire("5sRFk");
function $969a6def3c7061f5$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $dgBbb.ReactReduxContext);
    var useReduxContext = context === (0, $dgBbb.ReactReduxContext) ? (0, $5sRFk.useReduxContext) : function() {
        return (0, $9nHZC.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $969a6def3c7061f5$export$6ccbb43953eebf8 = $969a6def3c7061f5$export$671dba69185d0304();

});
parcelRegister("5sRFk", function(module, exports) {

$parcel$export(module.exports, "useReduxContext", function () { return $3fa932252532125d$export$c1275ca9a6fd3ec5; });

var $9nHZC = parcelRequire("9nHZC");

var $5kF1c = parcelRequire("5kF1c");

var $dgBbb = parcelRequire("dgBbb");
function $3fa932252532125d$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $9nHZC.useContext)((0, $dgBbb.ReactReduxContext));
    (0, (/*@__PURE__*/$parcel$interopDefault($5kF1c)))(contextValue, "could not find react-redux context value; please ensure the component is wrapped in a <Provider>");
    return contextValue;
}

});



parcelRegister("aAre5", function(module, exports) {

$parcel$export(module.exports, "useSelector", function () { return $7b5262b83b9d7b63$export$2105062e25df4afe; });

var $9nHZC = parcelRequire("9nHZC");

var $5kF1c = parcelRequire("5kF1c");

var $5sRFk = parcelRequire("5sRFk");

var $3FjOU = parcelRequire("3FjOU");

var $dgBbb = parcelRequire("dgBbb");
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed
var $7b5262b83b9d7b63$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? (0, $9nHZC.useLayoutEffect) : (0, $9nHZC.useEffect);
var $7b5262b83b9d7b63$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $7b5262b83b9d7b63$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $9nHZC.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $9nHZC.useMemo)(function() {
        return new (0, $3FjOU.default)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $9nHZC.useRef)();
    var latestSelector = (0, $9nHZC.useRef)();
    var latestSelectedState = (0, $9nHZC.useRef)();
    var selectedState;
    try {
        if (selector !== latestSelector.current || latestSubscriptionCallbackError.current) selectedState = selector(store.getState());
        else selectedState = latestSelectedState.current;
    } catch (err) {
        var errorMessage = "An error occured while selecting the store state: " + err.message + ".";
        if (latestSubscriptionCallbackError.current) errorMessage += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\nOriginal stack trace:";
        throw new Error(errorMessage);
    }
    $7b5262b83b9d7b63$var$useIsomorphicLayoutEffect(function() {
        latestSelector.current = selector;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    $7b5262b83b9d7b63$var$useIsomorphicLayoutEffect(function() {
        function checkForUpdates() {
            try {
                var newSelectedState = latestSelector.current(store.getState());
                if (equalityFn(newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = newSelectedState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender({});
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $7b5262b83b9d7b63$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $dgBbb.ReactReduxContext);
    var useReduxContext = context === (0, $dgBbb.ReactReduxContext) ? (0, $5sRFk.useReduxContext) : function() {
        return (0, $9nHZC.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $7b5262b83b9d7b63$var$refEquality;
        (0, (/*@__PURE__*/$parcel$interopDefault($5kF1c)))(selector, "You must pass a selector to useSelectors");
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        return $7b5262b83b9d7b63$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
    };
}
var $7b5262b83b9d7b63$export$2105062e25df4afe = $7b5262b83b9d7b63$export$2b53f90d2bd1cbfb();

});

parcelRegister("l4Hgm", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", function () { return (parcelRequire("lnOmc")).unstable_batchedUpdates; });
/* eslint-disable import/no-unresolved */ 
var $lnOmc = parcelRequire("lnOmc");

});


parcelRegister("koRrl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("e2zNv")).default; });
$parcel$export(module.exports, "FabricChannel", function () { return (parcelRequire("4L3N1")).FabricChannel; });

var $e2zNv = parcelRequire("e2zNv");

var $4A7zb = parcelRequire("4A7zb");

var $4L3N1 = parcelRequire("4L3N1");

});
parcelRegister("e2zNv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a38d0538ffc2c4b4$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $4L3N1 = parcelRequire("4L3N1");

var $aJSeL = parcelRequire("aJSeL");

var $1VEpc = parcelRequire("1VEpc");

var $4A7zb = parcelRequire("4A7zb");

var $idi38 = parcelRequire("idi38");

var $1PNqA = parcelRequire("1PNqA");

var $j64yG = parcelRequire("j64yG");

var $9PEsk = parcelRequire("9PEsk");

var $6j5QH = parcelRequire("6j5QH");

var $fVddm = parcelRequire("fVddm");

var $gd6WA = parcelRequire("gd6WA");

var $8ovdN = parcelRequire("8ovdN");

var $5xzZY = parcelRequire("5xzZY");

var $905KP = parcelRequire("905KP");

var $ePl3B = parcelRequire("ePl3B");

var $dFBLR = parcelRequire("dFBLR");
var $a38d0538ffc2c4b4$var$_listenerMap;
function $a38d0538ffc2c4b4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a38d0538ffc2c4b4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $a38d0538ffc2c4b4$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a38d0538ffc2c4b4$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $a38d0538ffc2c4b4$var$listenerMap = ($a38d0538ffc2c4b4$var$_listenerMap = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($a38d0538ffc2c4b4$var$_listenerMap, (0, $4L3N1.FabricChannel).elements, (0, $aJSeL.default)), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($a38d0538ffc2c4b4$var$_listenerMap, (0, $4L3N1.FabricChannel).editor, (0, $1PNqA.default)), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($a38d0538ffc2c4b4$var$_listenerMap, (0, $4L3N1.FabricChannel).atlaskit, (0, $1VEpc.default)), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($a38d0538ffc2c4b4$var$_listenerMap, (0, $4L3N1.FabricChannel).navigation, (0, $idi38.default)), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($a38d0538ffc2c4b4$var$_listenerMap, (0, $4L3N1.FabricChannel).media, (0, $j64yG.default)), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($a38d0538ffc2c4b4$var$_listenerMap, (0, $4L3N1.FabricChannel).peopleTeams, (0, $9PEsk.default)), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($a38d0538ffc2c4b4$var$_listenerMap, (0, $4L3N1.FabricChannel).notifications, (0, $6j5QH.default)), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($a38d0538ffc2c4b4$var$_listenerMap, (0, $4L3N1.FabricChannel).recentWork, (0, $fVddm.default)), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($a38d0538ffc2c4b4$var$_listenerMap, (0, $4L3N1.FabricChannel).atlas, (0, $gd6WA.default)), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($a38d0538ffc2c4b4$var$_listenerMap, (0, $4L3N1.FabricChannel).crossFlow, (0, $8ovdN.default)), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($a38d0538ffc2c4b4$var$_listenerMap, (0, $4L3N1.FabricChannel).linkingPlatform, (0, $5xzZY.default)), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($a38d0538ffc2c4b4$var$_listenerMap, (0, $4L3N1.FabricChannel).postOffice, (0, $905KP.default)), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($a38d0538ffc2c4b4$var$_listenerMap, (0, $4L3N1.FabricChannel).aiMate, (0, $ePl3B.default)), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($a38d0538ffc2c4b4$var$_listenerMap, (0, $4L3N1.FabricChannel).avp, (0, $dFBLR.default)), $a38d0538ffc2c4b4$var$_listenerMap);
var $a38d0538ffc2c4b4$var$FabricAnalyticsListeners = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(FabricAnalyticsListeners, _React$Component);
    var _super = $a38d0538ffc2c4b4$var$_createSuper(FabricAnalyticsListeners);
    function FabricAnalyticsListeners(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, FabricAnalyticsListeners);
        _this = _super.call(this, props);
        _this.logger = new (0, $4A7zb.default)({
            logLevel: props.logLevel
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(FabricAnalyticsListeners, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, client = _this$props.client, children = _this$props.children, logLevel = _this$props.logLevel, excludedChannels = _this$props.excludedChannels;
                if (typeof logLevel === "number") this.logger.setLogLevel(logLevel);
                var listeners = Object.keys($a38d0538ffc2c4b4$var$listenerMap).filter(function(channel) {
                    return !excludedChannels || excludedChannels.indexOf(channel) < 0;
                }).map(function(channel) {
                    return $a38d0538ffc2c4b4$var$listenerMap[channel];
                }).reduce(function(prev, Listener) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Listener, {
                        client: client,
                        logger: _this2.logger
                    }, prev);
                }, children);
                return listeners;
            }
        }
    ]);
    return FabricAnalyticsListeners;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component);
var $a38d0538ffc2c4b4$export$2e2bcd8739ae039 = $a38d0538ffc2c4b4$var$FabricAnalyticsListeners;

});
parcelRegister("uqRmf", function(module, exports) {
function $05b7a33740b3c1ad$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $05b7a33740b3c1ad$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eVDe4", function(module, exports) {

var $1UJOC = parcelRequire("1UJOC");
function $ade4d0ffa1ffbf93$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $1UJOC(o.key), o);
    }
}
function $ade4d0ffa1ffbf93$var$_createClass(e, r, t) {
    return r && $ade4d0ffa1ffbf93$var$_defineProperties(e.prototype, r), t && $ade4d0ffa1ffbf93$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $ade4d0ffa1ffbf93$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1UJOC", function(module, exports) {

var $340K4 = parcelRequire("340K4");
var $164e8f680fcad107$var$_typeof = $340K4.default;

var $hghao = parcelRequire("hghao");
function $164e8f680fcad107$var$toPropertyKey(t) {
    var i = $hghao(t, "string");
    return "symbol" == $164e8f680fcad107$var$_typeof(i) ? i : i + "";
}
module.exports = $164e8f680fcad107$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("340K4", function(module, exports) {
function $23b2522b7af3bfd5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $23b2522b7af3bfd5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $23b2522b7af3bfd5$var$_typeof(o);
}
module.exports = $23b2522b7af3bfd5$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hghao", function(module, exports) {

var $340K4 = parcelRequire("340K4");
var $c9113f3d2f3f14ee$var$_typeof = $340K4.default;
function $c9113f3d2f3f14ee$var$toPrimitive(t, r) {
    if ("object" != $c9113f3d2f3f14ee$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c9113f3d2f3f14ee$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $c9113f3d2f3f14ee$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("3BD5g", function(module, exports) {

var $ivwvu = parcelRequire("ivwvu");
function $2a03250fff068e83$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $ivwvu(t, e);
}
module.exports = $2a03250fff068e83$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ivwvu", function(module, exports) {
function $d794566babb387f1$var$_setPrototypeOf(t, e) {
    return module.exports = $d794566babb387f1$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $d794566babb387f1$var$_setPrototypeOf(t, e);
}
module.exports = $d794566babb387f1$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("ck3YL", function(module, exports) {

var $340K4 = parcelRequire("340K4");
var $8f8a70732cab5d15$var$_typeof = $340K4.default;

var $lwdaQ = parcelRequire("lwdaQ");
function $8f8a70732cab5d15$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $8f8a70732cab5d15$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $lwdaQ(t);
}
module.exports = $8f8a70732cab5d15$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lwdaQ", function(module, exports) {
function $faa6ce32a6645a1d$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $faa6ce32a6645a1d$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("lH0U2", function(module, exports) {
function $fcae506db94e80fc$var$_getPrototypeOf(t) {
    return module.exports = $fcae506db94e80fc$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $fcae506db94e80fc$var$_getPrototypeOf(t);
}
module.exports = $fcae506db94e80fc$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kFnE9", function(module, exports) {

var $1UJOC = parcelRequire("1UJOC");
function $f0b9fab34e19d7b3$var$_defineProperty(e, r, t) {
    return (r = $1UJOC(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $f0b9fab34e19d7b3$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4L3N1", function(module, exports) {

$parcel$export(module.exports, "FabricChannel", function () { return $376e7dc75ec39c03$export$8faa0b115ef0268b; });
var $376e7dc75ec39c03$export$8faa0b115ef0268b = /*#__PURE__*/ function(FabricChannel) {
    FabricChannel["atlaskit"] = "atlaskit";
    FabricChannel["elements"] = "fabric-elements";
    FabricChannel["navigation"] = "navigation";
    FabricChannel["editor"] = "editor";
    FabricChannel["media"] = "media";
    FabricChannel["peopleTeams"] = "peopleTeams";
    FabricChannel["notifications"] = "notifications";
    FabricChannel["recentWork"] = "recentWork";
    FabricChannel["atlas"] = "atlas";
    FabricChannel["crossFlow"] = "crossFlow";
    FabricChannel["linkingPlatform"] = "linkingPlatform";
    FabricChannel["postOffice"] = "postOffice";
    FabricChannel["aiMate"] = "aiMate";
    FabricChannel["avp"] = "avp";
    return FabricChannel;
}({});

});

parcelRegister("aJSeL", function(module, exports) {

$parcel$export(module.exports, "ELEMENTS_TAG", function () { return $7d182db14cda785c$export$ed71ae78997933a; });
$parcel$export(module.exports, "default", function () { return $7d182db14cda785c$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $7uBvK = parcelRequire("7uBvK");

var $4L3N1 = parcelRequire("4L3N1");

var $9Zooo = parcelRequire("9Zooo");
function $7d182db14cda785c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7d182db14cda785c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $7d182db14cda785c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7d182db14cda785c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $7d182db14cda785c$export$ed71ae78997933a = "fabricElements";
var $7d182db14cda785c$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(FabricElementsListener, _React$Component);
    var _super = $7d182db14cda785c$var$_createSuper(FabricElementsListener);
    function FabricElementsListener() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, FabricElementsListener);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleEventWrapper", function(event) {
            (0, $9Zooo.handleEvent)(event, $7d182db14cda785c$export$ed71ae78997933a, _this.props.logger, _this.props.client);
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(FabricElementsListener, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7uBvK.default), {
                    onEvent: this.handleEventWrapper,
                    channel: (0, $4L3N1.FabricChannel).elements
                }, this.props.children);
            }
        }
    ]);
    return FabricElementsListener;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component);

});
parcelRegister("7uBvK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57486ead48589080$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $dEQSq = parcelRequire("dEQSq");

var $5hDQx = parcelRequire("5hDQx");

var $gaHDg = parcelRequire("gaHDg");

var $8ovux = parcelRequire("8ovux");
var $57486ead48589080$var$ExportedAnalyticsListener = function ExportedAnalyticsListener(props) {
    var _process$env;
    var isModernContextEnabledEnv = typeof $8ovux !== "undefined" && $8ovux !== null && ((_process$env = {}, _process$env === void 0) ? void 0 : _process$env["ANALYTICS_NEXT_MODERN_CONTEXT"]);
    return isModernContextEnabledEnv || (0, $dEQSq.getBooleanFF)("platform.analytics-next-use-modern-context_fqgbx") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $gaHDg.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5hDQx.default), props);
};
var $57486ead48589080$export$2e2bcd8739ae039 = $57486ead48589080$var$ExportedAnalyticsListener;

});
parcelRegister("dEQSq", function(module, exports) {

$parcel$export(module.exports, "getBooleanFF", function () { return $9f1807080d265c87$export$470e5c2be1411c89; });

var $d8xKh = parcelRequire("d8xKh");
function $9f1807080d265c87$export$ba05d765b8392e5e(flagResolver) {
    (0, $d8xKh.setBooleanResolver)(flagResolver);
}
function $9f1807080d265c87$export$470e5c2be1411c89(name) {
    return (0, $d8xKh.resolveBooleanFlag)(name);
}

});
parcelRegister("d8xKh", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $990632df1d1d03e4$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $990632df1d1d03e4$export$6333b6aff9fc6275; });

var $6XAHn = parcelRequire("6XAHn");

var $8ovux = parcelRequire("8ovux");
var $990632df1d1d03e4$var$pkgName = "@atlaskit/platform-feature-flags";
var $990632df1d1d03e4$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $990632df1d1d03e4$var$hasProcessEnv = typeof $8ovux !== "undefined" && typeof $8ovux.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $990632df1d1d03e4$var$ENV_ENABLE_PLATFORM_FF = $990632df1d1d03e4$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $990632df1d1d03e4$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $990632df1d1d03e4$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $990632df1d1d03e4$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $990632df1d1d03e4$var$ENV_ENABLE_PLATFORM_FF || $990632df1d1d03e4$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $990632df1d1d03e4$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $990632df1d1d03e4$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$990632df1d1d03e4$var$globalVar[$990632df1d1d03e4$export$7e41b1b2bdee3f98] = $990632df1d1d03e4$var$globalVar[$990632df1d1d03e4$export$7e41b1b2bdee3f98] || $990632df1d1d03e4$var$DEFAULT_PFF_GLOBAL;
function $990632df1d1d03e4$export$f2b591175b3e424c(resolver) {
    $990632df1d1d03e4$var$globalVar[$990632df1d1d03e4$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $990632df1d1d03e4$export$6333b6aff9fc6275(flagKey) {
    if ($990632df1d1d03e4$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $6XAHn.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $990632df1d1d03e4$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $990632df1d1d03e4$var$globalVar[$990632df1d1d03e4$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("6XAHn", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $5114b853018543ba$export$1c9f709888824e05; });
var $5114b853018543ba$var$_ref, $5114b853018543ba$var$_process, $5114b853018543ba$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $5114b853018543ba$var$TESTS_MODE = ($5114b853018543ba$var$_ref = (globalThis === null || globalThis === void 0 || ($5114b853018543ba$var$_process = globalThis.process) === null || $5114b853018543ba$var$_process === void 0 || ($5114b853018543ba$var$_process = $5114b853018543ba$var$_process.env) === null || $5114b853018543ba$var$_process === void 0 ? void 0 : $5114b853018543ba$var$_process.JEST_WORKER_ID) !== undefined, $5114b853018543ba$var$_ref !== void 0) ? $5114b853018543ba$var$_ref : false;
var $5114b853018543ba$var$DEBUG_MODE = !$5114b853018543ba$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($5114b853018543ba$var$_process2 = globalThis.process) === null || $5114b853018543ba$var$_process2 === void 0 || ($5114b853018543ba$var$_process2 = $5114b853018543ba$var$_process2.env) === null || $5114b853018543ba$var$_process2 === void 0 ? void 0 : $5114b853018543ba$var$_process2.NODE_ENV) !== "production";
var $5114b853018543ba$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$5114b853018543ba$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("5hDQx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d8d72f7a7082bb3$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");

var $kZnbM = parcelRequire("kZnbM");
function $3d8d72f7a7082bb3$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3d8d72f7a7082bb3$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $3d8d72f7a7082bb3$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3d8d72f7a7082bb3$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $3d8d72f7a7082bb3$var$ContextTypes = {
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func
};
var $3d8d72f7a7082bb3$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $3d8d72f7a7082bb3$var$AnalyticsListener = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(AnalyticsListener, _Component);
    var _super = $3d8d72f7a7082bb3$var$_createSuper(AnalyticsListener);
    function AnalyticsListener(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsListener);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers,
                getAtlaskitAnalyticsContext: _this.getAtlaskitAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getAnalyticsEventHandlers", function() {
            var _this$props = _this.props, channel = _this$props.channel, onEvent = _this$props.onEvent;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla === void 0 ? $3d8d72f7a7082bb3$var$noop : _this$context$getAtla;
            var handler = function handler(event, eventChannel) {
                if (channel === "*" || channel === eventChannel) onEvent(event, eventChannel);
            };
            return [
                handler
            ].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(getAtlaskitAnalyticsEventHandlers()));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getAtlaskitAnalyticsContext", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla2 === void 0 ? $3d8d72f7a7082bb3$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsContext();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsListener, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kZnbM.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsListener;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($3d8d72f7a7082bb3$var$AnalyticsListener, "contextTypes", $3d8d72f7a7082bb3$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($3d8d72f7a7082bb3$var$AnalyticsListener, "childContextTypes", $3d8d72f7a7082bb3$var$ContextTypes);
var $3d8d72f7a7082bb3$export$2e2bcd8739ae039 = $3d8d72f7a7082bb3$var$AnalyticsListener;

});
parcelRegister("b4Ivn", function(module, exports) {

var $e6uS6 = parcelRequire("e6uS6");

var $cK5mg = parcelRequire("cK5mg");

var $fWTDc = parcelRequire("fWTDc");

var $fA4G5 = parcelRequire("fA4G5");
function $8102973954a0de48$var$_toConsumableArray(r) {
    return $e6uS6(r) || $cK5mg(r) || $fWTDc(r) || $fA4G5();
}
module.exports = $8102973954a0de48$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("e6uS6", function(module, exports) {

var $5AC78 = parcelRequire("5AC78");
function $a44992ac906fdccc$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $5AC78(r);
}
module.exports = $a44992ac906fdccc$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5AC78", function(module, exports) {
function $411de130f26163ad$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $411de130f26163ad$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("cK5mg", function(module, exports) {
function $946deff10f61105e$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $946deff10f61105e$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fWTDc", function(module, exports) {

var $5AC78 = parcelRequire("5AC78");
function $b9c76d00378379ca$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5AC78(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5AC78(r, a) : void 0;
    }
}
module.exports = $b9c76d00378379ca$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fA4G5", function(module, exports) {
function $b57dd8b754b20817$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $b57dd8b754b20817$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("kZnbM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f47b7e0035b9a5f4$export$2e2bcd8739ae039; });

var $eMyZG = parcelRequire("eMyZG");
var $f47b7e0035b9a5f4$export$2e2bcd8739ae039 = (0, $eMyZG.default);

});
parcelRegister("eMyZG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac30b1728e9f6956$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");
var $ac30b1728e9f6956$var$AnalyticsNextContext = (0, $9nHZC.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $ac30b1728e9f6956$export$2e2bcd8739ae039 = $ac30b1728e9f6956$var$AnalyticsNextContext;

});



parcelRegister("gaHDg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc5f6cfa3da2cf8d$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");

var $VoWGC = parcelRequire("VoWGC");

var $6zl99 = parcelRequire("6zl99");
var $bc5f6cfa3da2cf8d$var$AnalyticsListener = function AnalyticsListener(_ref) {
    var children = _ref.children, channel = _ref.channel, onEvent = _ref.onEvent;
    var analyticsContext = (0, $VoWGC.useAnalyticsContext)();
    var onEventRef = (0, $6zl99.useTrackedRef)(onEvent);
    var channelRef = (0, $6zl99.useTrackedRef)(channel);
    var getAtlaskitAnalyticsEventHandlers = (0, $9nHZC.useCallback)(function() {
        var thisHandler = function thisHandler(event, eventChannel) {
            if (channelRef.current === "*" || channelRef.current === eventChannel) onEventRef.current(event, eventChannel);
        };
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(analyticsContext.getAtlaskitAnalyticsEventHandlers()), [
            thisHandler
        ]);
    }, [
        analyticsContext,
        channelRef,
        onEventRef
    ]);
    var value = (0, $9nHZC.useMemo)(function() {
        return {
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers,
            getAtlaskitAnalyticsContext: analyticsContext.getAtlaskitAnalyticsContext
        };
    }, [
        analyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kZnbM.default).Provider, {
        value: value
    }, children);
};
var $bc5f6cfa3da2cf8d$export$2e2bcd8739ae039 = $bc5f6cfa3da2cf8d$var$AnalyticsListener;

});
parcelRegister("VoWGC", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $0ac8aca74fc18c8b$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $0ac8aca74fc18c8b$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});

parcelRegister("6zl99", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $4c866a3d78330870$export$1d27a74659855e44; });

var $9nHZC = parcelRequire("9nHZC");
var $4c866a3d78330870$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    ref.current = value;
    return ref;
};

});



parcelRegister("9Zooo", function(module, exports) {

$parcel$export(module.exports, "handleEvent", function () { return $745cbb5fc9306033$export$d6e5ca10785815df; });

var $brP9b = parcelRequire("brP9b");

var $knqbI = parcelRequire("knqbI");
var $745cbb5fc9306033$export$d6e5ca10785815df = function handleEvent(event, tags, logger, client) {
    if (!event.payload) return;
    var payload = (0, $knqbI.processEventPayload)(event, tags);
    (0, $brP9b.sendEvent)(logger, client)(payload);
};

});
parcelRegister("brP9b", function(module, exports) {

$parcel$export(module.exports, "sendEvent", function () { return $8559e41748968bef$export$7329bcdc3edcd90e; });

var $lOQkO = parcelRequire("lOQkO");
var $8559e41748968bef$var$_excluded = [
    "eventType"
];
var $8559e41748968bef$var$isPromise = function isPromise(c) {
    return typeof c.then === "function";
};
var $8559e41748968bef$export$7329bcdc3edcd90e = function sendEvent(logger, client) {
    return function(event) {
        if (client) {
            var eventType = event.eventType, gasEvent = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(event, $8559e41748968bef$var$_excluded);
            var withClient = function withClient(cb) {
                if ($8559e41748968bef$var$isPromise(client)) client.then(cb).catch(function(e) {
                    return logger.warn("There was an error sending the event", e);
                });
                else try {
                    cb(client);
                } catch (e) {
                    logger.warn("There was an error sending the event", e);
                }
            };
            switch(event.eventType){
                case "ui":
                    logger.debug("Sending UI Event via analytics client", gasEvent);
                    withClient(function(client) {
                        return client.sendUIEvent(gasEvent);
                    });
                    break;
                case "operational":
                    logger.debug("Sending Operational Event via analytics client", gasEvent);
                    withClient(function(client) {
                        return client.sendOperationalEvent(gasEvent);
                    });
                    break;
                case "track":
                    logger.debug("Sending Track Event via analytics client", gasEvent);
                    withClient(function(client) {
                        return client.sendTrackEvent(gasEvent);
                    });
                    break;
                case "screen":
                    logger.debug("Sending Screen Event via analytics client", gasEvent);
                    withClient(function(client) {
                        return client.sendScreenEvent(gasEvent);
                    });
                    break;
                default:
                    logger.error("cannot map eventType ".concat(event.eventType, " to an analytics-web-client function"));
            }
        } else logger.warn("AnalyticsWebClient instance is not provided");
    };
};

});
parcelRegister("lOQkO", function(module, exports) {

var $j7eBO = parcelRequire("j7eBO");
function $fe26dd0eef5eac29$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $j7eBO(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $fe26dd0eef5eac29$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("j7eBO", function(module, exports) {
function $deaa00ca207b80a8$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $deaa00ca207b80a8$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("knqbI", function(module, exports) {

$parcel$export(module.exports, "processEventPayload", function () { return $ed5a4503a8bed1c7$export$c37d638b7f2ca192; });

var $340K4 = parcelRequire("340K4");

var $b4Ivn = parcelRequire("b4Ivn");

var $lOQkO = parcelRequire("lOQkO");

var $kFnE9 = parcelRequire("kFnE9");

var $7Qr4H = parcelRequire("7Qr4H");
parcelRequire("jlzQX");
var $8ISrG = parcelRequire("8ISrG");
var $9P22G = parcelRequire("9P22G");

var $dGehf = parcelRequire("dGehf");

var $aJSeL = parcelRequire("aJSeL");

var $1PNqA = parcelRequire("1PNqA");
function $ed5a4503a8bed1c7$var$_toPropertyKey(t) {
    var i = $ed5a4503a8bed1c7$var$_toPrimitive(t, "string");
    return "symbol" == (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(i) ? i : String(i);
}
function $ed5a4503a8bed1c7$var$_toPrimitive(t, r) {
    if ("object" != (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ed5a4503a8bed1c7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ed5a4503a8bed1c7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ed5a4503a8bed1c7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ed5a4503a8bed1c7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ed5a4503a8bed1c7$var$extractFieldsFromContext = function extractFieldsFromContext(fieldsToPick) {
    return function(contexts) {
        return contexts.map(function(ctx) {
            return fieldsToPick.reduce(function(result, key) {
                return ctx[key] ? (0, (/*@__PURE__*/$parcel$interopDefault($dGehf)))(result, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, key, ctx[key])) : result;
            }, {});
        }).reduce(function(result, item) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($dGehf)))(result, item);
        }, {});
    };
};
var $ed5a4503a8bed1c7$var$fieldExtractor = function fieldExtractor(contextKey) {
    return $ed5a4503a8bed1c7$var$extractFieldsFromContext([
        "source",
        "objectType",
        "objectId",
        "containerType",
        "containerId",
        contextKey
    ]);
};
var $ed5a4503a8bed1c7$var$getContextKey = function getContextKey(tag) {
    switch(tag){
        case 0, $aJSeL.ELEMENTS_TAG:
            return 0, $9P22G.ELEMENTS_CONTEXT;
        case 0, $1PNqA.EDITOR_TAG:
            return 0, $8ISrG.EDITOR_CONTEXT;
        default:
            return "";
    }
};
var $ed5a4503a8bed1c7$var$updatePayloadWithContext = function updatePayloadWithContext(primaryTag, event) {
    if (event.context.length === 0) return $ed5a4503a8bed1c7$var$_objectSpread({
        source: (0, $7Qr4H.DEFAULT_SOURCE)
    }, event.payload);
    var contextKey = $ed5a4503a8bed1c7$var$getContextKey(primaryTag) || "attributes";
    var _fieldExtractor = $ed5a4503a8bed1c7$var$fieldExtractor(contextKey)(event.context), attributes = _fieldExtractor[contextKey], fields = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_fieldExtractor, [
        contextKey
    ].map($ed5a4503a8bed1c7$var$_toPropertyKey));
    if (attributes) event.payload.attributes = (0, (/*@__PURE__*/$parcel$interopDefault($dGehf)))(attributes, event.payload.attributes || {});
    return $ed5a4503a8bed1c7$var$_objectSpread($ed5a4503a8bed1c7$var$_objectSpread({
        source: (0, $7Qr4H.DEFAULT_SOURCE)
    }, fields), event.payload);
};
var $ed5a4503a8bed1c7$var$addTags = function addTags(tags) {
    var originalTags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var mergedTags = new Set([].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(originalTags), (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(tags)));
    return Array.from(mergedTags);
};
/**
 * The primary tag is used for matching the analytics event payload
 * with its context.
 */ function $ed5a4503a8bed1c7$var$getPrimaryTag(tags) {
    if (typeof tags === "string") return tags;
    if (!tags.length) throw new Error("Empty tags string array. Unable to match analytics event payload with context");
    return tags[0];
}
var $ed5a4503a8bed1c7$export$c37d638b7f2ca192 = function processEventPayload(event, tags) {
    var primaryTag = $ed5a4503a8bed1c7$var$getPrimaryTag(tags);
    var tagsArray = typeof tags === "string" ? [
        tags
    ] : tags;
    return $ed5a4503a8bed1c7$var$_objectSpread($ed5a4503a8bed1c7$var$_objectSpread({}, $ed5a4503a8bed1c7$var$updatePayloadWithContext(primaryTag, event)), {}, {
        tags: $ed5a4503a8bed1c7$var$addTags(tagsArray, event.payload.tags)
    });
};

});
parcelRegister("7Qr4H", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", function () { return $5b62643cdd7d7d20$export$a1562d08625f5d7e; });
$parcel$export(module.exports, "TRACK_EVENT_TYPE", function () { return $5b62643cdd7d7d20$export$947dac6c72b26f81; });
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", function () { return $5b62643cdd7d7d20$export$f1d537d508d2945a; });
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", function () { return $5b62643cdd7d7d20$export$12346a674644c156; });
$parcel$export(module.exports, "DEFAULT_SOURCE", function () { return $5b62643cdd7d7d20$export$b055de0e665cb20c; });
// same types defined in analytics-web-client but avoid creating dependency with that
var $5b62643cdd7d7d20$export$a1562d08625f5d7e = "ui";
var $5b62643cdd7d7d20$export$947dac6c72b26f81 = "track";
var $5b62643cdd7d7d20$export$f1d537d508d2945a = "screen";
var $5b62643cdd7d7d20$export$12346a674644c156 = "operational";
var $5b62643cdd7d7d20$export$b055de0e665cb20c = "unknown";

});

parcelRegister("jlzQX", function(module, exports) {

$parcel$export(module.exports, "ELEMENTS_CONTEXT", function () { return (parcelRequire("9P22G")).ELEMENTS_CONTEXT; });
$parcel$export(module.exports, "FabricElementsAnalyticsContext", function () { return (parcelRequire("9P22G")).FabricElementsAnalyticsContext; });
$parcel$export(module.exports, "NAVIGATION_CONTEXT", function () { return (parcelRequire("1irk6")).NAVIGATION_CONTEXT; });
$parcel$export(module.exports, "NavigationAnalyticsContext", function () { return (parcelRequire("1irk6")).NavigationAnalyticsContext; });
$parcel$export(module.exports, "EDITOR_CONTEXT", function () { return (parcelRequire("8ISrG")).EDITOR_CONTEXT; });
$parcel$export(module.exports, "EDITOR_APPEARANCE_CONTEXT", function () { return (parcelRequire("8ISrG")).EDITOR_APPEARANCE_CONTEXT; });
$parcel$export(module.exports, "FabricEditorAnalyticsContext", function () { return (parcelRequire("8ISrG")).FabricEditorAnalyticsContext; });
$parcel$export(module.exports, "MEDIA_CONTEXT", function () { return (parcelRequire("alUZw")).MEDIA_CONTEXT; });
$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", function () { return (parcelRequire("30ljN")).PEOPLE_TEAMS_CONTEXT; });
$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", function () { return (parcelRequire("5fLLg")).NOTIFICATIONS_CONTEXT; });
$parcel$export(module.exports, "NotificationsAnalyticsContext", function () { return (parcelRequire("5fLLg")).NotificationsAnalyticsContext; });
$parcel$export(module.exports, "RECENT_WORK_CONTEXT", function () { return (parcelRequire("g4CHS")).RECENT_WORK_CONTEXT; });
$parcel$export(module.exports, "ATLAS_CONTEXT", function () { return (parcelRequire("9pWv9")).ATLAS_CONTEXT; });
$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", function () { return (parcelRequire("fZvH8")).LINKING_PLATFORM_CONTEXT; });
$parcel$export(module.exports, "POST_OFFICE_CONTEXT", function () { return (parcelRequire("dffvs")).POST_OFFICE_CONTEXT; });
$parcel$export(module.exports, "PostOfficeAnalyticsContext", function () { return (parcelRequire("dffvs")).PostOfficeAnalyticsContext; });
$parcel$export(module.exports, "AI_MATE_CONTEXT", function () { return (parcelRequire("dUXBR")).AI_MATE_CONTEXT; });
$parcel$export(module.exports, "AVP_CONTEXT", function () { return (parcelRequire("2FN96")).AVP_CONTEXT; });

var $9P22G = parcelRequire("9P22G");

var $1irk6 = parcelRequire("1irk6");

var $8ISrG = parcelRequire("8ISrG");

var $alUZw = parcelRequire("alUZw");

var $30ljN = parcelRequire("30ljN");

var $5fLLg = parcelRequire("5fLLg");

var $g4CHS = parcelRequire("g4CHS");

var $9pWv9 = parcelRequire("9pWv9");

var $fZvH8 = parcelRequire("fZvH8");

var $dffvs = parcelRequire("dffvs");

var $dUXBR = parcelRequire("dUXBR");

var $2FN96 = parcelRequire("2FN96");

});
parcelRegister("9P22G", function(module, exports) {

$parcel$export(module.exports, "ELEMENTS_CONTEXT", function () { return $726a760d900c48c4$export$80450e0a84a5ede9; });
$parcel$export(module.exports, "FabricElementsAnalyticsContext", function () { return $726a760d900c48c4$export$3fe25500478a635c; });

var $7H3SZ = parcelRequire("7H3SZ");
var $726a760d900c48c4$export$80450e0a84a5ede9 = "fabricElementsCtx";
var $726a760d900c48c4$export$3fe25500478a635c = (0, $7H3SZ.default)($726a760d900c48c4$export$80450e0a84a5ede9, "FabricElementsAnalyticsContext");

});
parcelRegister("7H3SZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $599f9036875e212c$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $e3AwO = parcelRequire("e3AwO");
var $599f9036875e212c$var$createNamespaceContext = function createNamespaceContext(namespace) {
    var displayName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "NamespacedContext";
    var Component = function Component(props) {
        var newData = (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, namespace, props.data);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $e3AwO.default), {
            data: newData
        }, (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Children.only(props.children));
    };
    Component.displayName = displayName;
    return Component;
};
var $599f9036875e212c$export$2e2bcd8739ae039 = $599f9036875e212c$var$createNamespaceContext;

});
parcelRegister("e3AwO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3bdae44acb6bdce$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $hU6wd = parcelRequire("hU6wd");

var $5fcrJ = parcelRequire("5fcrJ");

var $aRd9l = parcelRequire("aRd9l");

var $fsgWC = parcelRequire("fsgWC");
var $a3bdae44acb6bdce$var$ExportedAnalyticsContext = function ExportedAnalyticsContext(props) {
    var isModernContext = (0, $5fcrJ.default) || (0, $hU6wd.fg)("platform.analytics-next-use-modern-context_fqgbx");
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fsgWC.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aRd9l.default), props);
};
var $a3bdae44acb6bdce$export$2e2bcd8739ae039 = $a3bdae44acb6bdce$var$ExportedAnalyticsContext;

});
parcelRegister("hU6wd", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $d08cb912e18a4bf9$export$b40ec24ac8275656; });

var $fpHR1 = parcelRequire("fpHR1");
function $d08cb912e18a4bf9$export$ba05d765b8392e5e(flagResolver) {
    (0, $fpHR1.setBooleanResolver)(flagResolver);
}
function $d08cb912e18a4bf9$export$470e5c2be1411c89(name) {
    return (0, $fpHR1.resolveBooleanFlag)(name);
}
function $d08cb912e18a4bf9$export$b40ec24ac8275656(name) {
    return (0, $fpHR1.resolveBooleanFlag)(name);
}

});
parcelRegister("fpHR1", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $b38b3559a8cd9d52$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $b38b3559a8cd9d52$export$6333b6aff9fc6275; });

var $eyVto = parcelRequire("eyVto");

var $8ovux = parcelRequire("8ovux");
var $b38b3559a8cd9d52$var$pkgName = "@atlaskit/platform-feature-flags";
var $b38b3559a8cd9d52$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $b38b3559a8cd9d52$var$hasProcessEnv = typeof $8ovux !== "undefined" && typeof $8ovux.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $b38b3559a8cd9d52$var$ENV_ENABLE_PLATFORM_FF = $b38b3559a8cd9d52$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $b38b3559a8cd9d52$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $b38b3559a8cd9d52$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $b38b3559a8cd9d52$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $b38b3559a8cd9d52$var$ENV_ENABLE_PLATFORM_FF || $b38b3559a8cd9d52$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $b38b3559a8cd9d52$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $b38b3559a8cd9d52$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$b38b3559a8cd9d52$var$globalVar[$b38b3559a8cd9d52$export$7e41b1b2bdee3f98] = $b38b3559a8cd9d52$var$globalVar[$b38b3559a8cd9d52$export$7e41b1b2bdee3f98] || $b38b3559a8cd9d52$var$DEFAULT_PFF_GLOBAL;
function $b38b3559a8cd9d52$export$f2b591175b3e424c(resolver) {
    $b38b3559a8cd9d52$var$globalVar[$b38b3559a8cd9d52$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $b38b3559a8cd9d52$export$6333b6aff9fc6275(flagKey) {
    if ($b38b3559a8cd9d52$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $eyVto.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $b38b3559a8cd9d52$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $b38b3559a8cd9d52$var$globalVar[$b38b3559a8cd9d52$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("eyVto", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $a9a0d29e7fd9e3da$export$1c9f709888824e05; });
var $a9a0d29e7fd9e3da$var$_ref, $a9a0d29e7fd9e3da$var$_process, $a9a0d29e7fd9e3da$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $a9a0d29e7fd9e3da$var$TESTS_MODE = ($a9a0d29e7fd9e3da$var$_ref = (globalThis === null || globalThis === void 0 || ($a9a0d29e7fd9e3da$var$_process = globalThis.process) === null || $a9a0d29e7fd9e3da$var$_process === void 0 || ($a9a0d29e7fd9e3da$var$_process = $a9a0d29e7fd9e3da$var$_process.env) === null || $a9a0d29e7fd9e3da$var$_process === void 0 ? void 0 : $a9a0d29e7fd9e3da$var$_process.JEST_WORKER_ID) !== undefined, $a9a0d29e7fd9e3da$var$_ref !== void 0) ? $a9a0d29e7fd9e3da$var$_ref : false;
var $a9a0d29e7fd9e3da$var$DEBUG_MODE = !$a9a0d29e7fd9e3da$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($a9a0d29e7fd9e3da$var$_process2 = globalThis.process) === null || $a9a0d29e7fd9e3da$var$_process2 === void 0 || ($a9a0d29e7fd9e3da$var$_process2 = $a9a0d29e7fd9e3da$var$_process2.env) === null || $a9a0d29e7fd9e3da$var$_process2 === void 0 ? void 0 : $a9a0d29e7fd9e3da$var$_process2.NODE_ENV) !== "production";
var $a9a0d29e7fd9e3da$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$a9a0d29e7fd9e3da$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("5fcrJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d18020ce475981d$export$2e2bcd8739ae039; });

var $8ovux = parcelRequire("8ovux");
var $3d18020ce475981d$var$_process$env;
var $3d18020ce475981d$export$2e2bcd8739ae039 = typeof $8ovux !== "undefined" && $8ovux !== null && (($3d18020ce475981d$var$_process$env = {}, $3d18020ce475981d$var$_process$env === void 0) ? void 0 : $3d18020ce475981d$var$_process$env["ANALYTICS_NEXT_MODERN_CONTEXT"]);

});

parcelRegister("aRd9l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e790ddad4177ca2$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");

var $kZnbM = parcelRequire("kZnbM");
function $7e790ddad4177ca2$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7e790ddad4177ca2$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $7e790ddad4177ca2$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7e790ddad4177ca2$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $7e790ddad4177ca2$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func
};
var $7e790ddad4177ca2$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $7e790ddad4177ca2$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(AnalyticsContext, _Component);
    var _super = $7e790ddad4177ca2$var$_createSuper(AnalyticsContext);
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsContext);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $7e790ddad4177ca2$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $7e790ddad4177ca2$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kZnbM.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsContext;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($7e790ddad4177ca2$var$AnalyticsContext, "contextTypes", $7e790ddad4177ca2$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($7e790ddad4177ca2$var$AnalyticsContext, "childContextTypes", $7e790ddad4177ca2$var$ContextTypes);
var $7e790ddad4177ca2$export$2e2bcd8739ae039 = $7e790ddad4177ca2$var$AnalyticsContext;

});

parcelRegister("fsgWC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4069d57a1150d04$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");

var $7zjqg = parcelRequire("7zjqg");

var $3Gnen = parcelRequire("3Gnen");
var $b4069d57a1150d04$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $3Gnen.useTrackedRef)(data);
    var _useAnalyticsContext = (0, $7zjqg.useAnalyticsContext)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $9nHZC.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $9nHZC.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kZnbM.default).Provider, {
        value: value
    }, children);
};
var $b4069d57a1150d04$export$2e2bcd8739ae039 = $b4069d57a1150d04$var$AnalyticsContext;

});
parcelRegister("7zjqg", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $582ade33003631d7$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $582ade33003631d7$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});

parcelRegister("3Gnen", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $2ae7507e881e4ef9$export$1d27a74659855e44; });

var $9nHZC = parcelRequire("9nHZC");
var $2ae7507e881e4ef9$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    ref.current = value;
    return ref;
};

});





parcelRegister("1irk6", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_CONTEXT", function () { return $0f1caab74676587f$export$1fd3aad76a7c6788; });
$parcel$export(module.exports, "NavigationAnalyticsContext", function () { return $0f1caab74676587f$export$d0a82da1a0b94929; });

var $7H3SZ = parcelRequire("7H3SZ");
var $0f1caab74676587f$export$1fd3aad76a7c6788 = "navigationCtx";
var $0f1caab74676587f$export$d0a82da1a0b94929 = (0, $7H3SZ.default)($0f1caab74676587f$export$1fd3aad76a7c6788, "NavigationAnalyticsContext");

});

parcelRegister("8ISrG", function(module, exports) {

$parcel$export(module.exports, "EDITOR_CONTEXT", function () { return $659caa84368c8523$export$8c8f6d8f1fa796f0; });
$parcel$export(module.exports, "EDITOR_APPEARANCE_CONTEXT", function () { return $659caa84368c8523$export$9eb2b47430ed3f7c; });
$parcel$export(module.exports, "FabricEditorAnalyticsContext", function () { return $659caa84368c8523$export$629cada6c5e621e1; });

var $7H3SZ = parcelRequire("7H3SZ");
var $659caa84368c8523$export$8c8f6d8f1fa796f0 = "fabricEditorCtx";
var $659caa84368c8523$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
var $659caa84368c8523$export$629cada6c5e621e1 = (0, $7H3SZ.default)($659caa84368c8523$export$8c8f6d8f1fa796f0, "FabricEditorAnalyticsContext");

});

parcelRegister("alUZw", function(module, exports) {

$parcel$export(module.exports, "MEDIA_CONTEXT", function () { return $789812db1e24ac62$export$70df29c238ba7306; });
// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
var $789812db1e24ac62$export$70df29c238ba7306 = "mediaCtx"; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

});

parcelRegister("30ljN", function(module, exports) {

$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", function () { return $2301e88cc5296bc4$export$b326383bee6cb993; });

var $7H3SZ = parcelRequire("7H3SZ");
var $2301e88cc5296bc4$export$b326383bee6cb993 = "peopleTeamsCtx";
var $2301e88cc5296bc4$export$4119ddb38ccbfb87 = (0, $7H3SZ.default)($2301e88cc5296bc4$export$b326383bee6cb993, "PeopleTeamsAnalyticsContext");

});

parcelRegister("5fLLg", function(module, exports) {

$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", function () { return $3d3366e44200bf52$export$da1befb791e93c7e; });
$parcel$export(module.exports, "NotificationsAnalyticsContext", function () { return $3d3366e44200bf52$export$6f8e7ff1e3feafd7; });

var $7H3SZ = parcelRequire("7H3SZ");
var $3d3366e44200bf52$export$da1befb791e93c7e = "NotificationsCtx";
var $3d3366e44200bf52$export$6f8e7ff1e3feafd7 = (0, $7H3SZ.default)($3d3366e44200bf52$export$da1befb791e93c7e, "NotificationsAnalyticsContext");

});

parcelRegister("g4CHS", function(module, exports) {

$parcel$export(module.exports, "RECENT_WORK_CONTEXT", function () { return $bb3b0b6cf8206931$export$fc7a65795610cb71; });

var $7H3SZ = parcelRequire("7H3SZ");
var $bb3b0b6cf8206931$export$fc7a65795610cb71 = "RecentWorkCtx";
var $bb3b0b6cf8206931$export$745926731087ebe2 = (0, $7H3SZ.default)($bb3b0b6cf8206931$export$fc7a65795610cb71, "RecentWorkAnalyticsContext");

});

parcelRegister("9pWv9", function(module, exports) {

$parcel$export(module.exports, "ATLAS_CONTEXT", function () { return $6db3d4042b5bac3a$export$4906017439f33fc0; });

var $7H3SZ = parcelRequire("7H3SZ");
var $6db3d4042b5bac3a$export$4906017439f33fc0 = "atlasCtx";
var $6db3d4042b5bac3a$export$43ebbe41370d4543 = (0, $7H3SZ.default)($6db3d4042b5bac3a$export$4906017439f33fc0, "AtlasAnalyticsContext");

});

parcelRegister("fZvH8", function(module, exports) {

$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", function () { return $ba45236d225fa54e$export$3240443bf2b83834; });

var $7H3SZ = parcelRequire("7H3SZ");
var $ba45236d225fa54e$export$3240443bf2b83834 = "linkingPlatformCtx";
var $ba45236d225fa54e$export$6d568da622ce0a08 = (0, $7H3SZ.default)($ba45236d225fa54e$export$3240443bf2b83834, "LinkingPlatformAnalyticsContext");

});

parcelRegister("dffvs", function(module, exports) {

$parcel$export(module.exports, "POST_OFFICE_CONTEXT", function () { return $9a48b4532e348fdb$export$ef0c05448f0f8f9; });
$parcel$export(module.exports, "PostOfficeAnalyticsContext", function () { return $9a48b4532e348fdb$export$dcd232f3be312f94; });

var $7H3SZ = parcelRequire("7H3SZ");
var $9a48b4532e348fdb$export$ef0c05448f0f8f9 = "postOfficeCtx";
var $9a48b4532e348fdb$export$dcd232f3be312f94 = (0, $7H3SZ.default)($9a48b4532e348fdb$export$ef0c05448f0f8f9, "PostOfficeAnalyticsContext");

});

parcelRegister("dUXBR", function(module, exports) {

$parcel$export(module.exports, "AI_MATE_CONTEXT", function () { return $a21ebe8da0511dbd$export$5c3a6fd8b96e8b66; });

var $7H3SZ = parcelRequire("7H3SZ");
var $a21ebe8da0511dbd$export$5c3a6fd8b96e8b66 = "aiMateCtx";
var $a21ebe8da0511dbd$export$de3826c30468da26 = (0, $7H3SZ.default)($a21ebe8da0511dbd$export$5c3a6fd8b96e8b66, "AIMateAnalyticsContext");

});

parcelRegister("2FN96", function(module, exports) {

$parcel$export(module.exports, "AVP_CONTEXT", function () { return $1f258876862e9af8$export$c2a811a4e42f4af5; });

var $7H3SZ = parcelRequire("7H3SZ");
var $1f258876862e9af8$export$c2a811a4e42f4af5 = "avpCtx";
var $1f258876862e9af8$export$da383e8879a25b03 = (0, $7H3SZ.default)($1f258876862e9af8$export$c2a811a4e42f4af5, "AVPAnalyticsContext");

});


parcelRegister("dGehf", function(module, exports) {

var $32e5n = parcelRequire("32e5n");

var $cWjwR = parcelRequire("cWjwR");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $9f5a45bbe0d427a6$var$merge = $cWjwR(function(object, source, srcIndex) {
    $32e5n(object, source, srcIndex);
});
module.exports = $9f5a45bbe0d427a6$var$merge;

});
parcelRegister("32e5n", function(module, exports) {

var $dF7QF = parcelRequire("dF7QF");

var $aB1Jn = parcelRequire("aB1Jn");

var $en3ln = parcelRequire("en3ln");

var $7uW5h = parcelRequire("7uW5h");

var $3kSRQ = parcelRequire("3kSRQ");

var $1IIVj = parcelRequire("1IIVj");

var $htRhI = parcelRequire("htRhI");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $235c7c1dbc7fbe70$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $en3ln(source, function(srcValue, key) {
        stack || (stack = new $dF7QF);
        if ($3kSRQ(srcValue)) $7uW5h(object, source, key, srcIndex, $235c7c1dbc7fbe70$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($htRhI(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $aB1Jn(object, key, newValue);
        }
    }, $1IIVj);
}
module.exports = $235c7c1dbc7fbe70$var$baseMerge;

});
parcelRegister("dF7QF", function(module, exports) {

var $3qOsF = parcelRequire("3qOsF");

var $jeee1 = parcelRequire("jeee1");

var $jwLpy = parcelRequire("jwLpy");

var $cMgAy = parcelRequire("cMgAy");

var $hk8dM = parcelRequire("hk8dM");

var $fxvQh = parcelRequire("fxvQh");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9f25313eb0d9ffa7$var$Stack(entries) {
    var data = this.__data__ = new $3qOsF(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$9f25313eb0d9ffa7$var$Stack.prototype.clear = $jeee1;
$9f25313eb0d9ffa7$var$Stack.prototype["delete"] = $jwLpy;
$9f25313eb0d9ffa7$var$Stack.prototype.get = $cMgAy;
$9f25313eb0d9ffa7$var$Stack.prototype.has = $hk8dM;
$9f25313eb0d9ffa7$var$Stack.prototype.set = $fxvQh;
module.exports = $9f25313eb0d9ffa7$var$Stack;

});
parcelRegister("3qOsF", function(module, exports) {

var $5jukz = parcelRequire("5jukz");

var $4y8bw = parcelRequire("4y8bw");

var $fAqb5 = parcelRequire("fAqb5");

var $corsT = parcelRequire("corsT");

var $1J4HX = parcelRequire("1J4HX");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $27faf1679bc51a4f$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$27faf1679bc51a4f$var$ListCache.prototype.clear = $5jukz;
$27faf1679bc51a4f$var$ListCache.prototype["delete"] = $4y8bw;
$27faf1679bc51a4f$var$ListCache.prototype.get = $fAqb5;
$27faf1679bc51a4f$var$ListCache.prototype.has = $corsT;
$27faf1679bc51a4f$var$ListCache.prototype.set = $1J4HX;
module.exports = $27faf1679bc51a4f$var$ListCache;

});
parcelRegister("5jukz", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $3de64127468d136c$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $3de64127468d136c$var$listCacheClear;

});

parcelRegister("4y8bw", function(module, exports) {

var $foTnW = parcelRequire("foTnW");
/** Used for built-in method references. */ var $3500afc08619c9ff$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $3500afc08619c9ff$var$splice = $3500afc08619c9ff$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3500afc08619c9ff$var$listCacheDelete(key) {
    var data = this.__data__, index = $foTnW(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $3500afc08619c9ff$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $3500afc08619c9ff$var$listCacheDelete;

});
parcelRegister("foTnW", function(module, exports) {

var $c3Max = parcelRequire("c3Max");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $b3640f435c407a32$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($c3Max(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $b3640f435c407a32$var$assocIndexOf;

});
parcelRegister("c3Max", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $8c7b212e565437b5$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $8c7b212e565437b5$var$eq;

});



parcelRegister("fAqb5", function(module, exports) {

var $foTnW = parcelRequire("foTnW");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b58e8631cf97771a$var$listCacheGet(key) {
    var data = this.__data__, index = $foTnW(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $b58e8631cf97771a$var$listCacheGet;

});

parcelRegister("corsT", function(module, exports) {

var $foTnW = parcelRequire("foTnW");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $905d07e399359d47$var$listCacheHas(key) {
    return $foTnW(this.__data__, key) > -1;
}
module.exports = $905d07e399359d47$var$listCacheHas;

});

parcelRegister("1J4HX", function(module, exports) {

var $foTnW = parcelRequire("foTnW");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $141da54ee34261d6$var$listCacheSet(key, value) {
    var data = this.__data__, index = $foTnW(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $141da54ee34261d6$var$listCacheSet;

});


parcelRegister("jeee1", function(module, exports) {

var $3qOsF = parcelRequire("3qOsF");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $dffa5bf108fe61f4$var$stackClear() {
    this.__data__ = new $3qOsF;
    this.size = 0;
}
module.exports = $dffa5bf108fe61f4$var$stackClear;

});

parcelRegister("jwLpy", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e375c85bb6b2803c$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $e375c85bb6b2803c$var$stackDelete;

});

parcelRegister("cMgAy", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $94d6d5ddcf1ccc69$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $94d6d5ddcf1ccc69$var$stackGet;

});

parcelRegister("hk8dM", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c9caae7a4159dc35$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $c9caae7a4159dc35$var$stackHas;

});

parcelRegister("fxvQh", function(module, exports) {

var $3qOsF = parcelRequire("3qOsF");

var $fz3Q0 = parcelRequire("fz3Q0");

var $brfVP = parcelRequire("brfVP");
/** Used as the size to enable large array optimizations. */ var $b502a3429b58766e$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $b502a3429b58766e$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $3qOsF) {
        var pairs = data.__data__;
        if (!$fz3Q0 || pairs.length < $b502a3429b58766e$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $brfVP(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $b502a3429b58766e$var$stackSet;

});
parcelRegister("fz3Q0", function(module, exports) {

var $aRcAK = parcelRequire("aRcAK");

var $bR8DU = parcelRequire("bR8DU");
/* Built-in method references that are verified to be native. */ var $b54d1a0730b25ed4$var$Map = $aRcAK($bR8DU, "Map");
module.exports = $b54d1a0730b25ed4$var$Map;

});
parcelRegister("aRcAK", function(module, exports) {

var $gzcBu = parcelRequire("gzcBu");

var $bnLHE = parcelRequire("bnLHE");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $7e789f16f152e37d$var$getNative(object, key) {
    var value = $bnLHE(object, key);
    return $gzcBu(value) ? value : undefined;
}
module.exports = $7e789f16f152e37d$var$getNative;

});
parcelRegister("gzcBu", function(module, exports) {

var $ikNgc = parcelRequire("ikNgc");

var $cFgjC = parcelRequire("cFgjC");

var $3kSRQ = parcelRequire("3kSRQ");

var $gx0ME = parcelRequire("gx0ME");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $c0f9b107020e1ac6$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $c0f9b107020e1ac6$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $c0f9b107020e1ac6$var$funcProto = Function.prototype, $c0f9b107020e1ac6$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $c0f9b107020e1ac6$var$funcToString = $c0f9b107020e1ac6$var$funcProto.toString;
/** Used to check objects for own properties. */ var $c0f9b107020e1ac6$var$hasOwnProperty = $c0f9b107020e1ac6$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $c0f9b107020e1ac6$var$reIsNative = RegExp("^" + $c0f9b107020e1ac6$var$funcToString.call($c0f9b107020e1ac6$var$hasOwnProperty).replace($c0f9b107020e1ac6$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $c0f9b107020e1ac6$var$baseIsNative(value) {
    if (!$3kSRQ(value) || $cFgjC(value)) return false;
    var pattern = $ikNgc(value) ? $c0f9b107020e1ac6$var$reIsNative : $c0f9b107020e1ac6$var$reIsHostCtor;
    return pattern.test($gx0ME(value));
}
module.exports = $c0f9b107020e1ac6$var$baseIsNative;

});
parcelRegister("ikNgc", function(module, exports) {

var $44oBv = parcelRequire("44oBv");

var $3kSRQ = parcelRequire("3kSRQ");
/** `Object#toString` result references. */ var $d5904e510dfe9cf7$var$asyncTag = "[object AsyncFunction]", $d5904e510dfe9cf7$var$funcTag = "[object Function]", $d5904e510dfe9cf7$var$genTag = "[object GeneratorFunction]", $d5904e510dfe9cf7$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $d5904e510dfe9cf7$var$isFunction(value) {
    if (!$3kSRQ(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $44oBv(value);
    return tag == $d5904e510dfe9cf7$var$funcTag || tag == $d5904e510dfe9cf7$var$genTag || tag == $d5904e510dfe9cf7$var$asyncTag || tag == $d5904e510dfe9cf7$var$proxyTag;
}
module.exports = $d5904e510dfe9cf7$var$isFunction;

});
parcelRegister("44oBv", function(module, exports) {

var $lgMoJ = parcelRequire("lgMoJ");

var $jtmEt = parcelRequire("jtmEt");

var $51FmI = parcelRequire("51FmI");
/** `Object#toString` result references. */ var $2f6a9ef2ea2ecd78$var$nullTag = "[object Null]", $2f6a9ef2ea2ecd78$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $2f6a9ef2ea2ecd78$var$symToStringTag = $lgMoJ ? $lgMoJ.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $2f6a9ef2ea2ecd78$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $2f6a9ef2ea2ecd78$var$undefinedTag : $2f6a9ef2ea2ecd78$var$nullTag;
    return $2f6a9ef2ea2ecd78$var$symToStringTag && $2f6a9ef2ea2ecd78$var$symToStringTag in Object(value) ? $jtmEt(value) : $51FmI(value);
}
module.exports = $2f6a9ef2ea2ecd78$var$baseGetTag;

});
parcelRegister("lgMoJ", function(module, exports) {

var $bR8DU = parcelRequire("bR8DU");
/** Built-in value references. */ var $f7c0a2635033f36e$var$Symbol = $bR8DU.Symbol;
module.exports = $f7c0a2635033f36e$var$Symbol;

});
parcelRegister("bR8DU", function(module, exports) {

var $2z7cE = parcelRequire("2z7cE");
/** Detect free variable `self`. */ var $8a1b59333e3f5011$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $8a1b59333e3f5011$var$root = $2z7cE || $8a1b59333e3f5011$var$freeSelf || Function("return this")();
module.exports = $8a1b59333e3f5011$var$root;

});
parcelRegister("2z7cE", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $1de47006abbd69c4$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $1de47006abbd69c4$var$freeGlobal;

});



parcelRegister("jtmEt", function(module, exports) {

var $lgMoJ = parcelRequire("lgMoJ");
/** Used for built-in method references. */ var $e2d24be945440189$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e2d24be945440189$var$hasOwnProperty = $e2d24be945440189$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e2d24be945440189$var$nativeObjectToString = $e2d24be945440189$var$objectProto.toString;
/** Built-in value references. */ var $e2d24be945440189$var$symToStringTag = $lgMoJ ? $lgMoJ.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $e2d24be945440189$var$getRawTag(value) {
    var isOwn = $e2d24be945440189$var$hasOwnProperty.call(value, $e2d24be945440189$var$symToStringTag), tag = value[$e2d24be945440189$var$symToStringTag];
    try {
        value[$e2d24be945440189$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $e2d24be945440189$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$e2d24be945440189$var$symToStringTag] = tag;
        else delete value[$e2d24be945440189$var$symToStringTag];
    }
    return result;
}
module.exports = $e2d24be945440189$var$getRawTag;

});

parcelRegister("51FmI", function(module, exports) {
/** Used for built-in method references. */ var $3a8d2207e71db098$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3a8d2207e71db098$var$nativeObjectToString = $3a8d2207e71db098$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3a8d2207e71db098$var$objectToString(value) {
    return $3a8d2207e71db098$var$nativeObjectToString.call(value);
}
module.exports = $3a8d2207e71db098$var$objectToString;

});


parcelRegister("3kSRQ", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $26ddccdd617ae71c$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $26ddccdd617ae71c$var$isObject;

});


parcelRegister("cFgjC", function(module, exports) {

var $lWnkg = parcelRequire("lWnkg");
/** Used to detect methods masquerading as native. */ var $9385f844a2e2ba54$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($lWnkg && $lWnkg.keys && $lWnkg.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $9385f844a2e2ba54$var$isMasked(func) {
    return !!$9385f844a2e2ba54$var$maskSrcKey && $9385f844a2e2ba54$var$maskSrcKey in func;
}
module.exports = $9385f844a2e2ba54$var$isMasked;

});
parcelRegister("lWnkg", function(module, exports) {

var $bR8DU = parcelRequire("bR8DU");
/** Used to detect overreaching core-js shims. */ var $ff911bc31ce028a5$var$coreJsData = $bR8DU["__core-js_shared__"];
module.exports = $ff911bc31ce028a5$var$coreJsData;

});


parcelRegister("gx0ME", function(module, exports) {
/** Used for built-in method references. */ var $c090560b3c7fcd46$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $c090560b3c7fcd46$var$funcToString = $c090560b3c7fcd46$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $c090560b3c7fcd46$var$toSource(func) {
    if (func != null) {
        try {
            return $c090560b3c7fcd46$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $c090560b3c7fcd46$var$toSource;

});


parcelRegister("bnLHE", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $8496d87fc5fda84a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $8496d87fc5fda84a$var$getValue;

});



parcelRegister("brfVP", function(module, exports) {

var $fNh2j = parcelRequire("fNh2j");

var $bc86O = parcelRequire("bc86O");

var $fCS1r = parcelRequire("fCS1r");

var $dqV97 = parcelRequire("dqV97");

var $2DALP = parcelRequire("2DALP");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $853e930688e4279f$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$853e930688e4279f$var$MapCache.prototype.clear = $fNh2j;
$853e930688e4279f$var$MapCache.prototype["delete"] = $bc86O;
$853e930688e4279f$var$MapCache.prototype.get = $fCS1r;
$853e930688e4279f$var$MapCache.prototype.has = $dqV97;
$853e930688e4279f$var$MapCache.prototype.set = $2DALP;
module.exports = $853e930688e4279f$var$MapCache;

});
parcelRegister("fNh2j", function(module, exports) {

var $1JlUd = parcelRequire("1JlUd");

var $3qOsF = parcelRequire("3qOsF");

var $fz3Q0 = parcelRequire("fz3Q0");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $b7f8a5a9f9c2b422$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $1JlUd,
        "map": new ($fz3Q0 || $3qOsF),
        "string": new $1JlUd
    };
}
module.exports = $b7f8a5a9f9c2b422$var$mapCacheClear;

});
parcelRegister("1JlUd", function(module, exports) {

var $4Wvpr = parcelRequire("4Wvpr");

var $f6NUw = parcelRequire("f6NUw");

var $ep51h = parcelRequire("ep51h");

var $k9yKa = parcelRequire("k9yKa");

var $ebSVx = parcelRequire("ebSVx");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $142afc71cb970793$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$142afc71cb970793$var$Hash.prototype.clear = $4Wvpr;
$142afc71cb970793$var$Hash.prototype["delete"] = $f6NUw;
$142afc71cb970793$var$Hash.prototype.get = $ep51h;
$142afc71cb970793$var$Hash.prototype.has = $k9yKa;
$142afc71cb970793$var$Hash.prototype.set = $ebSVx;
module.exports = $142afc71cb970793$var$Hash;

});
parcelRegister("4Wvpr", function(module, exports) {

var $cTmlY = parcelRequire("cTmlY");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $3994f17899b710ce$var$hashClear() {
    this.__data__ = $cTmlY ? $cTmlY(null) : {};
    this.size = 0;
}
module.exports = $3994f17899b710ce$var$hashClear;

});
parcelRegister("cTmlY", function(module, exports) {

var $aRcAK = parcelRequire("aRcAK");
/* Built-in method references that are verified to be native. */ var $962bf6080beb37f6$var$nativeCreate = $aRcAK(Object, "create");
module.exports = $962bf6080beb37f6$var$nativeCreate;

});


parcelRegister("f6NUw", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $affe21c988623689$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $affe21c988623689$var$hashDelete;

});

parcelRegister("ep51h", function(module, exports) {

var $cTmlY = parcelRequire("cTmlY");
/** Used to stand-in for `undefined` hash values. */ var $a7c74b4c64342a0e$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $a7c74b4c64342a0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a7c74b4c64342a0e$var$hasOwnProperty = $a7c74b4c64342a0e$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $a7c74b4c64342a0e$var$hashGet(key) {
    var data = this.__data__;
    if ($cTmlY) {
        var result = data[key];
        return result === $a7c74b4c64342a0e$var$HASH_UNDEFINED ? undefined : result;
    }
    return $a7c74b4c64342a0e$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $a7c74b4c64342a0e$var$hashGet;

});

parcelRegister("k9yKa", function(module, exports) {

var $cTmlY = parcelRequire("cTmlY");
/** Used for built-in method references. */ var $eabf994119b4c355$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $eabf994119b4c355$var$hasOwnProperty = $eabf994119b4c355$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $eabf994119b4c355$var$hashHas(key) {
    var data = this.__data__;
    return $cTmlY ? data[key] !== undefined : $eabf994119b4c355$var$hasOwnProperty.call(data, key);
}
module.exports = $eabf994119b4c355$var$hashHas;

});

parcelRegister("ebSVx", function(module, exports) {

var $cTmlY = parcelRequire("cTmlY");
/** Used to stand-in for `undefined` hash values. */ var $a54cb3261958d193$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $a54cb3261958d193$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $cTmlY && value === undefined ? $a54cb3261958d193$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $a54cb3261958d193$var$hashSet;

});



parcelRegister("bc86O", function(module, exports) {

var $bg8lv = parcelRequire("bg8lv");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $82671af0baa89632$var$mapCacheDelete(key) {
    var result = $bg8lv(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $82671af0baa89632$var$mapCacheDelete;

});
parcelRegister("bg8lv", function(module, exports) {

var $k8xCp = parcelRequire("k8xCp");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $8327a9a9166584ee$var$getMapData(map, key) {
    var data = map.__data__;
    return $k8xCp(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $8327a9a9166584ee$var$getMapData;

});
parcelRegister("k8xCp", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $ea8ea1f0bc41bcac$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $ea8ea1f0bc41bcac$var$isKeyable;

});



parcelRegister("fCS1r", function(module, exports) {

var $bg8lv = parcelRequire("bg8lv");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b6044f54e66cc228$var$mapCacheGet(key) {
    return $bg8lv(this, key).get(key);
}
module.exports = $b6044f54e66cc228$var$mapCacheGet;

});

parcelRegister("dqV97", function(module, exports) {

var $bg8lv = parcelRequire("bg8lv");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $9c7a081b6794a9b7$var$mapCacheHas(key) {
    return $bg8lv(this, key).has(key);
}
module.exports = $9c7a081b6794a9b7$var$mapCacheHas;

});

parcelRegister("2DALP", function(module, exports) {

var $bg8lv = parcelRequire("bg8lv");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $1ebbbf1b03bb3e31$var$mapCacheSet(key, value) {
    var data = $bg8lv(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $1ebbbf1b03bb3e31$var$mapCacheSet;

});




parcelRegister("aB1Jn", function(module, exports) {

var $5BVtC = parcelRequire("5BVtC");

var $c3Max = parcelRequire("c3Max");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $7b6eb3d0a27778a6$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$c3Max(object[key], value) || value === undefined && !(key in object)) $5BVtC(object, key, value);
}
module.exports = $7b6eb3d0a27778a6$var$assignMergeValue;

});
parcelRegister("5BVtC", function(module, exports) {

var $iYGnF = parcelRequire("iYGnF");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $415cfe1dec2e54c1$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $iYGnF) $iYGnF(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = $415cfe1dec2e54c1$var$baseAssignValue;

});
parcelRegister("iYGnF", function(module, exports) {

var $aRcAK = parcelRequire("aRcAK");
var $dd0eb48728bb2cd2$var$defineProperty = function() {
    try {
        var func = $aRcAK(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = $dd0eb48728bb2cd2$var$defineProperty;

});



parcelRegister("en3ln", function(module, exports) {

var $hEOMz = parcelRequire("hEOMz");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $a765cea9cc888101$var$baseFor = $hEOMz();
module.exports = $a765cea9cc888101$var$baseFor;

});
parcelRegister("hEOMz", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $cdad90677d71f84d$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $cdad90677d71f84d$var$createBaseFor;

});


parcelRegister("7uW5h", function(module, exports) {

var $aB1Jn = parcelRequire("aB1Jn");

var $eu3ax = parcelRequire("eu3ax");

var $1zntn = parcelRequire("1zntn");

var $8HdJ8 = parcelRequire("8HdJ8");

var $lHUcx = parcelRequire("lHUcx");

var $3gXKg = parcelRequire("3gXKg");

var $lsPUZ = parcelRequire("lsPUZ");

var $dwPiH = parcelRequire("dwPiH");

var $bObB2 = parcelRequire("bObB2");

var $ikNgc = parcelRequire("ikNgc");

var $3kSRQ = parcelRequire("3kSRQ");

var $bzbjJ = parcelRequire("bzbjJ");

var $bwDQt = parcelRequire("bwDQt");

var $htRhI = parcelRequire("htRhI");

var $eG6Uo = parcelRequire("eG6Uo");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $57586408e12d618c$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $htRhI(object, key), srcValue = $htRhI(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $aB1Jn(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $lsPUZ(srcValue), isBuff = !isArr && $bObB2(srcValue), isTyped = !isArr && !isBuff && $bwDQt(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($lsPUZ(objValue)) newValue = objValue;
            else if ($dwPiH(objValue)) newValue = $8HdJ8(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $eu3ax(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $1zntn(srcValue, true);
            } else newValue = [];
        } else if ($bzbjJ(srcValue) || $3gXKg(srcValue)) {
            newValue = objValue;
            if ($3gXKg(objValue)) newValue = $eG6Uo(objValue);
            else if (!$3kSRQ(objValue) || $ikNgc(objValue)) newValue = $lHUcx(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    $aB1Jn(object, key, newValue);
}
module.exports = $57586408e12d618c$var$baseMergeDeep;

});
parcelRegister("eu3ax", function(module, exports) {

var $bR8DU = parcelRequire("bR8DU");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $bR8DU.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("1zntn", function(module, exports) {

var $kPYJh = parcelRequire("kPYJh");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $124b44873b6670e3$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $kPYJh(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $124b44873b6670e3$var$cloneTypedArray;

});
parcelRegister("kPYJh", function(module, exports) {

var $l4waM = parcelRequire("l4waM");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $f2b7ada1d81a4b42$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $l4waM(result).set(new $l4waM(arrayBuffer));
    return result;
}
module.exports = $f2b7ada1d81a4b42$var$cloneArrayBuffer;

});
parcelRegister("l4waM", function(module, exports) {

var $bR8DU = parcelRequire("bR8DU");
/** Built-in value references. */ var $f572ed93dc91ec8c$var$Uint8Array = $bR8DU.Uint8Array;
module.exports = $f572ed93dc91ec8c$var$Uint8Array;

});



parcelRegister("8HdJ8", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $654cfcc2b328d435$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $654cfcc2b328d435$var$copyArray;

});

parcelRegister("lHUcx", function(module, exports) {

var $kyH8W = parcelRequire("kyH8W");

var $jrAzq = parcelRequire("jrAzq");

var $6qnde = parcelRequire("6qnde");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $fcd9358387ba34d9$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$6qnde(object) ? $kyH8W($jrAzq(object)) : {};
}
module.exports = $fcd9358387ba34d9$var$initCloneObject;

});
parcelRegister("kyH8W", function(module, exports) {

var $3kSRQ = parcelRequire("3kSRQ");
/** Built-in value references. */ var $ef7872f8c895dee8$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $ef7872f8c895dee8$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$3kSRQ(proto)) return {};
        if ($ef7872f8c895dee8$var$objectCreate) return $ef7872f8c895dee8$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $ef7872f8c895dee8$var$baseCreate;

});

parcelRegister("jrAzq", function(module, exports) {

var $fIxxp = parcelRequire("fIxxp");
/** Built-in value references. */ var $e27ce80b4e9622e2$var$getPrototype = $fIxxp(Object.getPrototypeOf, Object);
module.exports = $e27ce80b4e9622e2$var$getPrototype;

});
parcelRegister("fIxxp", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $b714fb047e3cb361$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $b714fb047e3cb361$var$overArg;

});


parcelRegister("6qnde", function(module, exports) {
/** Used for built-in method references. */ var $4ad72d4bc2d039b3$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $4ad72d4bc2d039b3$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $4ad72d4bc2d039b3$var$objectProto;
    return value === proto;
}
module.exports = $4ad72d4bc2d039b3$var$isPrototype;

});


parcelRegister("3gXKg", function(module, exports) {

var $lAE6x = parcelRequire("lAE6x");

var $fSpTQ = parcelRequire("fSpTQ");
/** Used for built-in method references. */ var $262135df3ba2c461$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $262135df3ba2c461$var$hasOwnProperty = $262135df3ba2c461$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $262135df3ba2c461$var$propertyIsEnumerable = $262135df3ba2c461$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $262135df3ba2c461$var$isArguments = $lAE6x(function() {
    return arguments;
}()) ? $lAE6x : function(value) {
    return $fSpTQ(value) && $262135df3ba2c461$var$hasOwnProperty.call(value, "callee") && !$262135df3ba2c461$var$propertyIsEnumerable.call(value, "callee");
};
module.exports = $262135df3ba2c461$var$isArguments;

});
parcelRegister("lAE6x", function(module, exports) {

var $44oBv = parcelRequire("44oBv");

var $fSpTQ = parcelRequire("fSpTQ");
/** `Object#toString` result references. */ var $fb7c11b07ecab4b9$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $fb7c11b07ecab4b9$var$baseIsArguments(value) {
    return $fSpTQ(value) && $44oBv(value) == $fb7c11b07ecab4b9$var$argsTag;
}
module.exports = $fb7c11b07ecab4b9$var$baseIsArguments;

});
parcelRegister("fSpTQ", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $b8effd4edb97eaad$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $b8effd4edb97eaad$var$isObjectLike;

});



parcelRegister("lsPUZ", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $fa047c584c41a605$var$isArray = Array.isArray;
module.exports = $fa047c584c41a605$var$isArray;

});

parcelRegister("dwPiH", function(module, exports) {

var $d1hHV = parcelRequire("d1hHV");

var $fSpTQ = parcelRequire("fSpTQ");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $9d960ec701a2a4b2$var$isArrayLikeObject(value) {
    return $fSpTQ(value) && $d1hHV(value);
}
module.exports = $9d960ec701a2a4b2$var$isArrayLikeObject;

});
parcelRegister("d1hHV", function(module, exports) {

var $ikNgc = parcelRequire("ikNgc");

var $cDdYu = parcelRequire("cDdYu");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $97a91ab44a826349$var$isArrayLike(value) {
    return value != null && $cDdYu(value.length) && !$ikNgc(value);
}
module.exports = $97a91ab44a826349$var$isArrayLike;

});
parcelRegister("cDdYu", function(module, exports) {
/** Used as references for various `Number` constants. */ var $9323f7a05215189b$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $9323f7a05215189b$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $9323f7a05215189b$var$MAX_SAFE_INTEGER;
}
module.exports = $9323f7a05215189b$var$isLength;

});



parcelRegister("bObB2", function(module, exports) {

var $bR8DU = parcelRequire("bR8DU");

var $jxF5W = parcelRequire("jxF5W");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $bR8DU.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $jxF5W;
module.exports = isBuffer;

});
parcelRegister("jxF5W", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $e3a0f9fb28f54da8$var$stubFalse() {
    return false;
}
module.exports = $e3a0f9fb28f54da8$var$stubFalse;

});


parcelRegister("bzbjJ", function(module, exports) {

var $44oBv = parcelRequire("44oBv");

var $jrAzq = parcelRequire("jrAzq");

var $fSpTQ = parcelRequire("fSpTQ");
/** `Object#toString` result references. */ var $86bbbdf4a7c7d5b1$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $86bbbdf4a7c7d5b1$var$funcProto = Function.prototype, $86bbbdf4a7c7d5b1$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $86bbbdf4a7c7d5b1$var$funcToString = $86bbbdf4a7c7d5b1$var$funcProto.toString;
/** Used to check objects for own properties. */ var $86bbbdf4a7c7d5b1$var$hasOwnProperty = $86bbbdf4a7c7d5b1$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $86bbbdf4a7c7d5b1$var$objectCtorString = $86bbbdf4a7c7d5b1$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $86bbbdf4a7c7d5b1$var$isPlainObject(value) {
    if (!$fSpTQ(value) || $44oBv(value) != $86bbbdf4a7c7d5b1$var$objectTag) return false;
    var proto = $jrAzq(value);
    if (proto === null) return true;
    var Ctor = $86bbbdf4a7c7d5b1$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $86bbbdf4a7c7d5b1$var$funcToString.call(Ctor) == $86bbbdf4a7c7d5b1$var$objectCtorString;
}
module.exports = $86bbbdf4a7c7d5b1$var$isPlainObject;

});

parcelRegister("bwDQt", function(module, exports) {

var $8KjT7 = parcelRequire("8KjT7");

var $lV9Iv = parcelRequire("lV9Iv");

var $ciO9b = parcelRequire("ciO9b");
/* Node.js helper references. */ var $8641974eecd5d7d8$var$nodeIsTypedArray = $ciO9b && $ciO9b.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $8641974eecd5d7d8$var$isTypedArray = $8641974eecd5d7d8$var$nodeIsTypedArray ? $lV9Iv($8641974eecd5d7d8$var$nodeIsTypedArray) : $8KjT7;
module.exports = $8641974eecd5d7d8$var$isTypedArray;

});
parcelRegister("8KjT7", function(module, exports) {

var $44oBv = parcelRequire("44oBv");

var $cDdYu = parcelRequire("cDdYu");

var $fSpTQ = parcelRequire("fSpTQ");
/** `Object#toString` result references. */ var $65e20bf0282fa666$var$argsTag = "[object Arguments]", $65e20bf0282fa666$var$arrayTag = "[object Array]", $65e20bf0282fa666$var$boolTag = "[object Boolean]", $65e20bf0282fa666$var$dateTag = "[object Date]", $65e20bf0282fa666$var$errorTag = "[object Error]", $65e20bf0282fa666$var$funcTag = "[object Function]", $65e20bf0282fa666$var$mapTag = "[object Map]", $65e20bf0282fa666$var$numberTag = "[object Number]", $65e20bf0282fa666$var$objectTag = "[object Object]", $65e20bf0282fa666$var$regexpTag = "[object RegExp]", $65e20bf0282fa666$var$setTag = "[object Set]", $65e20bf0282fa666$var$stringTag = "[object String]", $65e20bf0282fa666$var$weakMapTag = "[object WeakMap]";
var $65e20bf0282fa666$var$arrayBufferTag = "[object ArrayBuffer]", $65e20bf0282fa666$var$dataViewTag = "[object DataView]", $65e20bf0282fa666$var$float32Tag = "[object Float32Array]", $65e20bf0282fa666$var$float64Tag = "[object Float64Array]", $65e20bf0282fa666$var$int8Tag = "[object Int8Array]", $65e20bf0282fa666$var$int16Tag = "[object Int16Array]", $65e20bf0282fa666$var$int32Tag = "[object Int32Array]", $65e20bf0282fa666$var$uint8Tag = "[object Uint8Array]", $65e20bf0282fa666$var$uint8ClampedTag = "[object Uint8ClampedArray]", $65e20bf0282fa666$var$uint16Tag = "[object Uint16Array]", $65e20bf0282fa666$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $65e20bf0282fa666$var$typedArrayTags = {};
$65e20bf0282fa666$var$typedArrayTags[$65e20bf0282fa666$var$float32Tag] = $65e20bf0282fa666$var$typedArrayTags[$65e20bf0282fa666$var$float64Tag] = $65e20bf0282fa666$var$typedArrayTags[$65e20bf0282fa666$var$int8Tag] = $65e20bf0282fa666$var$typedArrayTags[$65e20bf0282fa666$var$int16Tag] = $65e20bf0282fa666$var$typedArrayTags[$65e20bf0282fa666$var$int32Tag] = $65e20bf0282fa666$var$typedArrayTags[$65e20bf0282fa666$var$uint8Tag] = $65e20bf0282fa666$var$typedArrayTags[$65e20bf0282fa666$var$uint8ClampedTag] = $65e20bf0282fa666$var$typedArrayTags[$65e20bf0282fa666$var$uint16Tag] = $65e20bf0282fa666$var$typedArrayTags[$65e20bf0282fa666$var$uint32Tag] = true;
$65e20bf0282fa666$var$typedArrayTags[$65e20bf0282fa666$var$argsTag] = $65e20bf0282fa666$var$typedArrayTags[$65e20bf0282fa666$var$arrayTag] = $65e20bf0282fa666$var$typedArrayTags[$65e20bf0282fa666$var$arrayBufferTag] = $65e20bf0282fa666$var$typedArrayTags[$65e20bf0282fa666$var$boolTag] = $65e20bf0282fa666$var$typedArrayTags[$65e20bf0282fa666$var$dataViewTag] = $65e20bf0282fa666$var$typedArrayTags[$65e20bf0282fa666$var$dateTag] = $65e20bf0282fa666$var$typedArrayTags[$65e20bf0282fa666$var$errorTag] = $65e20bf0282fa666$var$typedArrayTags[$65e20bf0282fa666$var$funcTag] = $65e20bf0282fa666$var$typedArrayTags[$65e20bf0282fa666$var$mapTag] = $65e20bf0282fa666$var$typedArrayTags[$65e20bf0282fa666$var$numberTag] = $65e20bf0282fa666$var$typedArrayTags[$65e20bf0282fa666$var$objectTag] = $65e20bf0282fa666$var$typedArrayTags[$65e20bf0282fa666$var$regexpTag] = $65e20bf0282fa666$var$typedArrayTags[$65e20bf0282fa666$var$setTag] = $65e20bf0282fa666$var$typedArrayTags[$65e20bf0282fa666$var$stringTag] = $65e20bf0282fa666$var$typedArrayTags[$65e20bf0282fa666$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $65e20bf0282fa666$var$baseIsTypedArray(value) {
    return $fSpTQ(value) && $cDdYu(value.length) && !!$65e20bf0282fa666$var$typedArrayTags[$44oBv(value)];
}
module.exports = $65e20bf0282fa666$var$baseIsTypedArray;

});

parcelRegister("lV9Iv", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $ff567563751ccf19$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $ff567563751ccf19$var$baseUnary;

});

parcelRegister("ciO9b", function(module, exports) {

var $2z7cE = parcelRequire("2z7cE");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $2z7cE.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});


parcelRegister("htRhI", function(module, exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $cb9e7a5a4e1f3f37$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
module.exports = $cb9e7a5a4e1f3f37$var$safeGet;

});

parcelRegister("eG6Uo", function(module, exports) {

var $bFHqq = parcelRequire("bFHqq");

var $1IIVj = parcelRequire("1IIVj");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $aafa58d7609725fe$var$toPlainObject(value) {
    return $bFHqq(value, $1IIVj(value));
}
module.exports = $aafa58d7609725fe$var$toPlainObject;

});
parcelRegister("bFHqq", function(module, exports) {

var $7LKGc = parcelRequire("7LKGc");

var $5BVtC = parcelRequire("5BVtC");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $87f53569129e040f$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $5BVtC(object, key, newValue);
        else $7LKGc(object, key, newValue);
    }
    return object;
}
module.exports = $87f53569129e040f$var$copyObject;

});
parcelRegister("7LKGc", function(module, exports) {

var $5BVtC = parcelRequire("5BVtC");

var $c3Max = parcelRequire("c3Max");
/** Used for built-in method references. */ var $5a8121cfae704df0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5a8121cfae704df0$var$hasOwnProperty = $5a8121cfae704df0$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $5a8121cfae704df0$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($5a8121cfae704df0$var$hasOwnProperty.call(object, key) && $c3Max(objValue, value)) || value === undefined && !(key in object)) $5BVtC(object, key, value);
}
module.exports = $5a8121cfae704df0$var$assignValue;

});


parcelRegister("1IIVj", function(module, exports) {

var $fkQ3E = parcelRequire("fkQ3E");

var $7dwOj = parcelRequire("7dwOj");

var $d1hHV = parcelRequire("d1hHV");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $140cbf58a46f9f32$var$keysIn(object) {
    return $d1hHV(object) ? $fkQ3E(object, true) : $7dwOj(object);
}
module.exports = $140cbf58a46f9f32$var$keysIn;

});
parcelRegister("fkQ3E", function(module, exports) {

var $93aAG = parcelRequire("93aAG");

var $3gXKg = parcelRequire("3gXKg");

var $lsPUZ = parcelRequire("lsPUZ");

var $bObB2 = parcelRequire("bObB2");

var $btWIf = parcelRequire("btWIf");

var $bwDQt = parcelRequire("bwDQt");
/** Used for built-in method references. */ var $b2a11ade7b5918d7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b2a11ade7b5918d7$var$hasOwnProperty = $b2a11ade7b5918d7$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $b2a11ade7b5918d7$var$arrayLikeKeys(value, inherited) {
    var isArr = $lsPUZ(value), isArg = !isArr && $3gXKg(value), isBuff = !isArr && !isArg && $bObB2(value), isType = !isArr && !isArg && !isBuff && $bwDQt(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $93aAG(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $b2a11ade7b5918d7$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $btWIf(key, length)))) result.push(key);
    return result;
}
module.exports = $b2a11ade7b5918d7$var$arrayLikeKeys;

});
parcelRegister("93aAG", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $696c9bee60c7cd44$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $696c9bee60c7cd44$var$baseTimes;

});

parcelRegister("btWIf", function(module, exports) {
/** Used as references for various `Number` constants. */ var $85bff24309e13c17$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $85bff24309e13c17$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $85bff24309e13c17$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $85bff24309e13c17$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $85bff24309e13c17$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $85bff24309e13c17$var$isIndex;

});


parcelRegister("7dwOj", function(module, exports) {

var $3kSRQ = parcelRequire("3kSRQ");

var $6qnde = parcelRequire("6qnde");

var $1eCa4 = parcelRequire("1eCa4");
/** Used for built-in method references. */ var $541332c3fe642a0f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $541332c3fe642a0f$var$hasOwnProperty = $541332c3fe642a0f$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $541332c3fe642a0f$var$baseKeysIn(object) {
    if (!$3kSRQ(object)) return $1eCa4(object);
    var isProto = $6qnde(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$541332c3fe642a0f$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $541332c3fe642a0f$var$baseKeysIn;

});
parcelRegister("1eCa4", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $0e64b34e7e779334$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $0e64b34e7e779334$var$nativeKeysIn;

});






parcelRegister("cWjwR", function(module, exports) {

var $cpZZr = parcelRequire("cpZZr");

var $lNx75 = parcelRequire("lNx75");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $96ba0ce0d0f44ebb$var$createAssigner(assigner) {
    return $cpZZr(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && $lNx75(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = $96ba0ce0d0f44ebb$var$createAssigner;

});
parcelRegister("cpZZr", function(module, exports) {

var $eQNRM = parcelRequire("eQNRM");

var $SWwNo = parcelRequire("SWwNo");

var $1vkgR = parcelRequire("1vkgR");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $90a7e7bb84e84b16$var$baseRest(func, start) {
    return $1vkgR($SWwNo(func, start, $eQNRM), func + "");
}
module.exports = $90a7e7bb84e84b16$var$baseRest;

});
parcelRegister("eQNRM", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $acfc9a6dde51ea64$var$identity(value) {
    return value;
}
module.exports = $acfc9a6dde51ea64$var$identity;

});

parcelRegister("SWwNo", function(module, exports) {

var $fMRVk = parcelRequire("fMRVk");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0a5271b1cb136bad$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $0a5271b1cb136bad$var$overRest(func, start, transform) {
    start = $0a5271b1cb136bad$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $0a5271b1cb136bad$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $fMRVk(func, this, otherArgs);
    };
}
module.exports = $0a5271b1cb136bad$var$overRest;

});
parcelRegister("fMRVk", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $b7e52acd9d3bff95$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $b7e52acd9d3bff95$var$apply;

});


parcelRegister("1vkgR", function(module, exports) {

var $2ZvZZ = parcelRequire("2ZvZZ");

var $2w2hO = parcelRequire("2w2hO");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $1188691208fddea2$var$setToString = $2w2hO($2ZvZZ);
module.exports = $1188691208fddea2$var$setToString;

});
parcelRegister("2ZvZZ", function(module, exports) {

var $4pPZL = parcelRequire("4pPZL");

var $iYGnF = parcelRequire("iYGnF");

var $eQNRM = parcelRequire("eQNRM");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $22da199014cd696b$var$baseSetToString = !$iYGnF ? $eQNRM : function(func, string) {
    return $iYGnF(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $4pPZL(string),
        "writable": true
    });
};
module.exports = $22da199014cd696b$var$baseSetToString;

});
parcelRegister("4pPZL", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $3371d45d6d43c620$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $3371d45d6d43c620$var$constant;

});


parcelRegister("2w2hO", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $1d5057f0f95e7ed9$var$HOT_COUNT = 800, $1d5057f0f95e7ed9$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1d5057f0f95e7ed9$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $1d5057f0f95e7ed9$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $1d5057f0f95e7ed9$var$nativeNow(), remaining = $1d5057f0f95e7ed9$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $1d5057f0f95e7ed9$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $1d5057f0f95e7ed9$var$shortOut;

});



parcelRegister("lNx75", function(module, exports) {

var $c3Max = parcelRequire("c3Max");

var $d1hHV = parcelRequire("d1hHV");

var $btWIf = parcelRequire("btWIf");

var $3kSRQ = parcelRequire("3kSRQ");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $fde7dc32f6e3d245$var$isIterateeCall(value, index, object) {
    if (!$3kSRQ(object)) return false;
    var type = typeof index;
    if (type == "number" ? $d1hHV(object) && $btWIf(index, object.length) : type == "string" && index in object) return $c3Max(object[index], value);
    return false;
}
module.exports = $fde7dc32f6e3d245$var$isIterateeCall;

});



parcelRegister("1PNqA", function(module, exports) {

$parcel$export(module.exports, "EDITOR_TAG", function () { return $1560e52fa456ec29$export$a1d9dc589a29b3aa; });
$parcel$export(module.exports, "default", function () { return $1560e52fa456ec29$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $7uBvK = parcelRequire("7uBvK");

var $4L3N1 = parcelRequire("4L3N1");

var $9Zooo = parcelRequire("9Zooo");
function $1560e52fa456ec29$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1560e52fa456ec29$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $1560e52fa456ec29$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1560e52fa456ec29$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $1560e52fa456ec29$export$a1d9dc589a29b3aa = "editor";
var $1560e52fa456ec29$export$8aa0d788f94a809 = "fabricEditor";
var $1560e52fa456ec29$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(FabricEditorListener, _React$Component);
    var _super = $1560e52fa456ec29$var$_createSuper(FabricEditorListener);
    function FabricEditorListener() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, FabricEditorListener);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleEventWrapper", function(event) {
            (0, $9Zooo.handleEvent)(event, [
                $1560e52fa456ec29$export$a1d9dc589a29b3aa,
                $1560e52fa456ec29$export$8aa0d788f94a809
            ], _this.props.logger, _this.props.client);
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(FabricEditorListener, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7uBvK.default), {
                    onEvent: this.handleEventWrapper,
                    channel: (0, $4L3N1.FabricChannel).editor
                }, this.props.children);
            }
        }
    ]);
    return FabricEditorListener;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component);

});




parcelRegister("1VEpc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $167a74f87a1df9b6$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $4L3N1 = parcelRequire("4L3N1");

var $fLsgS = parcelRequire("fLsgS");

var $6Hkdn = parcelRequire("6Hkdn");
function $167a74f87a1df9b6$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6Hkdn.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        channel: (0, $4L3N1.FabricChannel).atlaskit,
        processEvent: (0, $fLsgS.default)
    }));
}

});
parcelRegister("fLsgS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7a12ce187a7abe4$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9NMTI = parcelRequire("9NMTI");

var $dGehf = parcelRequire("dGehf");

var $7Qr4H = parcelRequire("7Qr4H");

var $bJsql = parcelRequire("bJsql");
function $b7a12ce187a7abe4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b7a12ce187a7abe4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b7a12ce187a7abe4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b7a12ce187a7abe4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b7a12ce187a7abe4$var$ATLASKIT_TAG = "atlaskit";
var $b7a12ce187a7abe4$var$listenerVersion = "8.10.0";
var /**
 * This util exists to convert the Atlaskit event format into the analytics platform format.
 *
 * Atlaskit event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $b7a12ce187a7abe4$export$2e2bcd8739ae039 = function(event, logger) {
    var sources = (0, $bJsql.getSources)(event);
    var source = (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))(sources) || (0, $7Qr4H.DEFAULT_SOURCE);
    var extraAttributes = (0, $bJsql.getExtraAttributes)(event);
    var components = (0, $bJsql.getComponents)(event);
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))((0, $bJsql.getPackageInfo)(event)) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var _event$payload = event.payload, _event$payload$eventT = _event$payload.eventType, eventType = _event$payload$eventT === void 0 ? (0, $7Qr4H.UI_EVENT_TYPE) : _event$payload$eventT, action = _event$payload.action, actionSubjectId = _event$payload.actionSubjectId, payloadAttributes = _event$payload.attributes, containerId = _event$payload.containerId;
    var attributes = $b7a12ce187a7abe4$var$_objectSpread($b7a12ce187a7abe4$var$_objectSpread({
        listenerVersion: $b7a12ce187a7abe4$var$listenerVersion,
        sourceHierarchy: sources.join(".") || undefined,
        componentHierarchy: components.join(".") || undefined,
        packageHierarchy: (0, $bJsql.getPackageHierarchy)(event) || undefined
    }, {
        packageName: packageName,
        packageVersion: packageVersion
    }), (0, (/*@__PURE__*/$parcel$interopDefault($dGehf)))(extraAttributes, payloadAttributes));
    // Ensure atlaskit tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add($b7a12ce187a7abe4$var$ATLASKIT_TAG);
    if (event.payload) {
        if (eventType === (0, $7Qr4H.UI_EVENT_TYPE)) return {
            eventType: eventType,
            source: source,
            actionSubject: (0, $bJsql.getActionSubject)(event),
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: attributes,
            containerId: containerId,
            tags: Array.from(tags)
        };
        if (eventType === (0, $7Qr4H.TRACK_EVENT_TYPE) || eventType === (0, $7Qr4H.OPERATIONAL_EVENT_TYPE) || eventType === (0, $7Qr4H.SCREEN_EVENT_TYPE)) logger.error("Track, screen and operational events are currently not supported for atlaskit events");
        else logger.error("Invalid event type", eventType);
    }
    return null;
};

});
parcelRegister("9NMTI", function(module, exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $722e9eb3d96d4105$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = $722e9eb3d96d4105$var$last;

});

parcelRegister("bJsql", function(module, exports) {

$parcel$export(module.exports, "extractFromEventContext", function () { return $88a9f20f3ea9f826$export$9b947b4502cd2705; });
$parcel$export(module.exports, "getActionSubject", function () { return $88a9f20f3ea9f826$export$6f40cdf6d42c018d; });
$parcel$export(module.exports, "getSources", function () { return $88a9f20f3ea9f826$export$5f9bc633b116660f; });
$parcel$export(module.exports, "getComponents", function () { return $88a9f20f3ea9f826$export$4e811121b221213b; });
$parcel$export(module.exports, "getExtraAttributes", function () { return $88a9f20f3ea9f826$export$67c3590839ebecdd; });
$parcel$export(module.exports, "getPackageInfo", function () { return $88a9f20f3ea9f826$export$cd17d76da7967240; });
$parcel$export(module.exports, "getPackageHierarchy", function () { return $88a9f20f3ea9f826$export$4e0b83da1896ebc7; });
/**
 * Largely taken from analytics-web-react
 */ 
var $dGehf = parcelRequire("dGehf");
var $88a9f20f3ea9f826$export$9b947b4502cd2705 = function extractFromEventContext(propertyName, event) {
    return event.context.map(function(contextItem) {
        return contextItem[propertyName];
    }).filter(Boolean);
};
var $88a9f20f3ea9f826$export$6f40cdf6d42c018d = function getActionSubject(event) {
    var overrides = $88a9f20f3ea9f826$export$9b947b4502cd2705("actionSubjectOverride", event);
    var closestContext = event.context.length > 0 ? event.context[event.context.length - 1] : {};
    var actionSubject = event.payload.actionSubject || closestContext.component;
    return overrides.length > 0 ? overrides[0] : actionSubject;
};
var $88a9f20f3ea9f826$export$5f9bc633b116660f = function getSources(event) {
    return $88a9f20f3ea9f826$export$9b947b4502cd2705("source", event);
};
var $88a9f20f3ea9f826$export$4e811121b221213b = function getComponents(event) {
    return $88a9f20f3ea9f826$export$9b947b4502cd2705("component", event);
};
var $88a9f20f3ea9f826$export$67c3590839ebecdd = function getExtraAttributes(event) {
    return $88a9f20f3ea9f826$export$9b947b4502cd2705("attributes", event).reduce(function(result, extraAttributes) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dGehf)))(result, extraAttributes);
    }, {});
};
var $88a9f20f3ea9f826$export$cd17d76da7967240 = function getPackageInfo(event) {
    return event.context.map(function(contextItem) {
        return {
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        };
    }).filter(function(p) {
        return p.packageName;
    });
};
var $88a9f20f3ea9f826$export$18cd124b5098d330 = function getPackageVersion(event) {
    return $88a9f20f3ea9f826$export$9b947b4502cd2705("packageVersion", event);
};
function $88a9f20f3ea9f826$export$4e0b83da1896ebc7(event) {
    var packages = $88a9f20f3ea9f826$export$cd17d76da7967240(event) || [];
    return packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    }).join(",") || undefined;
}

});


parcelRegister("6Hkdn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e067074e0418ec0$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $7uBvK = parcelRequire("7uBvK");

var $brP9b = parcelRequire("brP9b");
function $4e067074e0418ec0$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $4e067074e0418ec0$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $4e067074e0418ec0$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4e067074e0418ec0$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $4e067074e0418ec0$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(GenericAnalyticsListener, _React$Component);
    var _super = $4e067074e0418ec0$var$_createSuper(GenericAnalyticsListener);
    function GenericAnalyticsListener() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, GenericAnalyticsListener);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "listenerHandler", function(event) {
            var _this$props = _this.props, client = _this$props.client, logger = _this$props.logger, channel = _this$props.channel, processEvent = _this$props.processEvent;
            if (!event.payload) return;
            logger.debug("Received ".concat(channel, " event"), event);
            var payload = processEvent(event, logger);
            logger.debug("Processed ".concat(channel, " event"), payload);
            if (payload) (0, $brP9b.sendEvent)(logger, client)(payload);
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(GenericAnalyticsListener, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7uBvK.default), {
                    onEvent: this.listenerHandler,
                    channel: this.props.channel
                }, this.props.children);
            }
        }
    ]);
    return GenericAnalyticsListener;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component);

});


parcelRegister("4A7zb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $356064c813cd113f$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
var $356064c813cd113f$export$ffe0c436e29512cf = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    OFF: 4
};
var $356064c813cd113f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Logger() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, logLevel = _ref.logLevel;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, Logger);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "logLevel", $356064c813cd113f$export$ffe0c436e29512cf.OFF);
        if (typeof logLevel === "number") this.setLogLevel(logLevel);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(Logger, [
        {
            key: "setLogLevel",
            value: function setLogLevel(logLevel) {
                if (logLevel >= $356064c813cd113f$export$ffe0c436e29512cf.DEBUG && logLevel <= $356064c813cd113f$export$ffe0c436e29512cf.OFF) this.logLevel = +logLevel;
                else this.logLevel = $356064c813cd113f$export$ffe0c436e29512cf.OFF;
            }
        },
        {
            key: "logMessage",
            value: function logMessage(level, type) {
                if (level >= this.logLevel) {
                    var _console;
                    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
                    (_console = console)[type].apply(_console, args);
                }
            }
        },
        {
            key: "debug",
            value: function debug() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                this.logMessage.apply(this, [
                    $356064c813cd113f$export$ffe0c436e29512cf.DEBUG,
                    "log"
                ].concat(args));
            }
        },
        {
            key: "info",
            value: function info() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                this.logMessage.apply(this, [
                    $356064c813cd113f$export$ffe0c436e29512cf.INFO,
                    "info"
                ].concat(args));
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                this.logMessage.apply(this, [
                    $356064c813cd113f$export$ffe0c436e29512cf.WARN,
                    "warn"
                ].concat(args));
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
                this.logMessage.apply(this, [
                    $356064c813cd113f$export$ffe0c436e29512cf.ERROR,
                    "error"
                ].concat(args));
            }
        }
    ]);
    return Logger;
}();

});

parcelRegister("idi38", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d427712422205987$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $4L3N1 = parcelRequire("4L3N1");

var $gVL9l = parcelRequire("gVL9l");

var $6Hkdn = parcelRequire("6Hkdn");
function $d427712422205987$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6Hkdn.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        channel: (0, $4L3N1.FabricChannel).navigation,
        processEvent: (0, $gVL9l.default)
    }));
}

});
parcelRegister("gVL9l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5368b2a9aaf8ef7$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9NMTI = parcelRequire("9NMTI");

var $dGehf = parcelRequire("dGehf");

var $7Qr4H = parcelRequire("7Qr4H");
parcelRequire("jlzQX");
var $1irk6 = parcelRequire("1irk6");

var $hIuHa = parcelRequire("hIuHa");
function $c5368b2a9aaf8ef7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c5368b2a9aaf8ef7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c5368b2a9aaf8ef7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c5368b2a9aaf8ef7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c5368b2a9aaf8ef7$var$NAVIGATION_TAG = "navigation";
var $c5368b2a9aaf8ef7$var$listenerVersion = "8.10.0";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $c5368b2a9aaf8ef7$export$2e2bcd8739ae039 = function(event, logger) {
    var sources = (0, $hIuHa.getSources)(event, (0, $1irk6.NAVIGATION_CONTEXT));
    var source = (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))(sources) || (0, $7Qr4H.DEFAULT_SOURCE);
    var extraAttributes = (0, $hIuHa.getExtraAttributes)(event, (0, $1irk6.NAVIGATION_CONTEXT));
    var components = (0, $hIuHa.getComponents)(event, (0, $1irk6.NAVIGATION_CONTEXT));
    var packages = (0, $hIuHa.getPackageInfo)(event, (0, $1irk6.NAVIGATION_CONTEXT));
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))((0, $hIuHa.getPackageInfo)(event, (0, $1irk6.NAVIGATION_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event$payload = event.payload, _event$payload$eventT = _event$payload.eventType, eventType = _event$payload$eventT === void 0 ? (0, $7Qr4H.UI_EVENT_TYPE) : _event$payload$eventT, action = _event$payload.action, actionSubject = _event$payload.actionSubject, actionSubjectId = _event$payload.actionSubjectId, payloadAttributes = _event$payload.attributes, name = _event$payload.name;
    var attributes = $c5368b2a9aaf8ef7$var$_objectSpread($c5368b2a9aaf8ef7$var$_objectSpread({
        listenerVersion: $c5368b2a9aaf8ef7$var$listenerVersion,
        sourceHierarchy: sources.join(".") || undefined,
        componentHierarchy: components.join(".") || undefined,
        packageHierarchy: packageHierarchy.join(",") || undefined
    }, {
        packageName: packageName,
        packageVersion: packageVersion
    }), (0, (/*@__PURE__*/$parcel$interopDefault($dGehf)))(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add($c5368b2a9aaf8ef7$var$NAVIGATION_TAG);
    if (event.payload) switch(eventType){
        case 0, $7Qr4H.UI_EVENT_TYPE:
        case 0, $7Qr4H.OPERATIONAL_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7Qr4H.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7Qr4H.TRACK_EVENT_TYPE:
            logger.error("Track events are currently not supported for navigation events");
            break;
        default:
            logger.error("Invalid event type", eventType);
            break;
    }
    return null;
};

});
parcelRegister("hIuHa", function(module, exports) {

$parcel$export(module.exports, "getSources", function () { return $ce5e5b29e9199fb4$export$5f9bc633b116660f; });
$parcel$export(module.exports, "getComponents", function () { return $ce5e5b29e9199fb4$export$4e811121b221213b; });
$parcel$export(module.exports, "getExtraAttributes", function () { return $ce5e5b29e9199fb4$export$67c3590839ebecdd; });
$parcel$export(module.exports, "getPackageInfo", function () { return $ce5e5b29e9199fb4$export$cd17d76da7967240; });
/**
 * Largely taken from analytics-web-react
 */ 
var $dGehf = parcelRequire("dGehf");
var $ce5e5b29e9199fb4$var$extractFromEventContext = function extractFromEventContext(propertyNames, event) {
    var namespacedContextOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var contextName = arguments.length > 3 ? arguments[3] : undefined;
    return event.context.reduce(function(acc, contextItem) {
        propertyNames.forEach(function(propertyName) {
            var navContext = contextItem[contextName];
            var navContextProp = navContext ? navContext[propertyName] : null;
            var value = namespacedContextOnly ? navContextProp : navContextProp || contextItem[propertyName];
            if (value) acc.push(value);
        });
        return acc;
    }, []);
};
var $ce5e5b29e9199fb4$export$5f9bc633b116660f = function getSources(event, contextName) {
    return $ce5e5b29e9199fb4$var$extractFromEventContext([
        "source"
    ], event, false, contextName);
};
var $ce5e5b29e9199fb4$export$4e811121b221213b = function getComponents(event, contextName) {
    return $ce5e5b29e9199fb4$var$extractFromEventContext([
        "component",
        "componentName"
    ], event, false, contextName);
};
var $ce5e5b29e9199fb4$export$67c3590839ebecdd = function getExtraAttributes(event, contextName) {
    return $ce5e5b29e9199fb4$var$extractFromEventContext([
        "attributes"
    ], event, true, contextName).reduce(function(result, extraAttributes) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dGehf)))(result, extraAttributes);
    }, {});
};
var $ce5e5b29e9199fb4$export$cd17d76da7967240 = function getPackageInfo(event, contextName) {
    return event.context.map(function(contextItem) {
        var navContext = contextItem[contextName];
        var item = navContext ? navContext : contextItem;
        return {
            packageName: item.packageName,
            packageVersion: item.packageVersion
        };
    }).filter(function(p) {
        return p.packageName;
    });
};
var $ce5e5b29e9199fb4$export$18cd124b5098d330 = function getPackageVersion(event, contextName) {
    return $ce5e5b29e9199fb4$var$extractFromEventContext([
        "packageVersion"
    ], event, true, contextName);
};

});



parcelRegister("j64yG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de721d15ae840162$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $4L3N1 = parcelRequire("4L3N1");

var $fudrX = parcelRequire("fudrX");

var $6Hkdn = parcelRequire("6Hkdn");
function $de721d15ae840162$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6Hkdn.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        channel: (0, $4L3N1.FabricChannel).media,
        processEvent: (0, $fudrX.processEvent)
    }));
}

});
parcelRegister("fudrX", function(module, exports) {

$parcel$export(module.exports, "processEvent", function () { return $b46417352cded5a7$export$22af68e3614bf024; });

var $kFnE9 = parcelRequire("kFnE9");

var $b4Ivn = parcelRequire("b4Ivn");

var $7Qr4H = parcelRequire("7Qr4H");
parcelRequire("jlzQX");
var $alUZw = parcelRequire("alUZw");

var $dGehf = parcelRequire("dGehf");

var $9NMTI = parcelRequire("9NMTI");

var $bJsql = parcelRequire("bJsql");
function $b46417352cded5a7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b46417352cded5a7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b46417352cded5a7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b46417352cded5a7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b46417352cded5a7$var$listenerVersion = "8.10.0";
function $b46417352cded5a7$var$getMediaContexts(event) {
    return (0, $bJsql.extractFromEventContext)((0, $alUZw.MEDIA_CONTEXT), event);
}
function $b46417352cded5a7$var$getMediaRegion() {
    try {
        return window && window.sessionStorage && window.sessionStorage.getItem("media-api-region");
    } catch (e) {
        return;
    }
}
function $b46417352cded5a7$export$22af68e3614bf024(event) {
    var sources = (0, $bJsql.getSources)(event);
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))((0, $bJsql.getPackageInfo)(event)) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var extraAttributes = (0, $bJsql.getExtraAttributes)(event);
    var mediaContexts = $b46417352cded5a7$var$getMediaContexts(event) || [];
    var mediaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($dGehf))).apply(void 0, [
        {}
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(mediaContexts)));
    var tags = new Set(event.payload.tags || []);
    tags.add("media");
    var components = (0, $bJsql.getComponents)(event);
    var mediaRegion = $b46417352cded5a7$var$getMediaRegion();
    var payload = {
        source: (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))(sources) || (0, $7Qr4H.DEFAULT_SOURCE),
        actionSubject: event.payload.actionSubject,
        action: event.payload.action,
        eventType: event.payload.eventType,
        actionSubjectId: event.payload.actionSubjectId,
        // for backward compatibilty
        name: event.payload.name,
        tags: Array.from(tags),
        attributes: $b46417352cded5a7$var$_objectSpread($b46417352cded5a7$var$_objectSpread({
            packageName: packageName,
            packageVersion: packageVersion
        }, (0, (/*@__PURE__*/$parcel$interopDefault($dGehf)))({}, extraAttributes, mediaAttributes, event.payload.attributes)), {}, {
            componentHierarchy: components.join(".") || undefined,
            packageHierarchy: (0, $bJsql.getPackageHierarchy)(event),
            sourceHierarchy: sources.join(".") || undefined,
            listenerVersion: $b46417352cded5a7$var$listenerVersion
        }, mediaRegion ? {
            mediaRegion: mediaRegion
        } : undefined)
    };
    return payload;
}

});


parcelRegister("9PEsk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $728842322307830d$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $4L3N1 = parcelRequire("4L3N1");

var $6lpA2 = parcelRequire("6lpA2");

var $6Hkdn = parcelRequire("6Hkdn");
function $728842322307830d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6Hkdn.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        channel: (0, $4L3N1.FabricChannel).peopleTeams,
        processEvent: (0, $6lpA2.default)
    }));
}

});
parcelRegister("6lpA2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49e88bed6866d5a0$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9NMTI = parcelRequire("9NMTI");

var $dGehf = parcelRequire("dGehf");

var $7Qr4H = parcelRequire("7Qr4H");
parcelRequire("jlzQX");
var $30ljN = parcelRequire("30ljN");

var $hIuHa = parcelRequire("hIuHa");
function $49e88bed6866d5a0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $49e88bed6866d5a0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $49e88bed6866d5a0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $49e88bed6866d5a0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $49e88bed6866d5a0$var$PEOPLE_TEAMS_TAG = "peopleTeams";
var $49e88bed6866d5a0$var$listenerVersion = "8.10.0";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $49e88bed6866d5a0$export$2e2bcd8739ae039 = function(event, logger) {
    var sources = (0, $hIuHa.getSources)(event, (0, $30ljN.PEOPLE_TEAMS_CONTEXT));
    var source = (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))(sources) || (0, $7Qr4H.DEFAULT_SOURCE);
    var extraAttributes = (0, $hIuHa.getExtraAttributes)(event, (0, $30ljN.PEOPLE_TEAMS_CONTEXT));
    var components = (0, $hIuHa.getComponents)(event, (0, $30ljN.PEOPLE_TEAMS_CONTEXT));
    var packages = (0, $hIuHa.getPackageInfo)(event, (0, $30ljN.PEOPLE_TEAMS_CONTEXT));
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))((0, $hIuHa.getPackageInfo)(event, (0, $30ljN.PEOPLE_TEAMS_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event$payload = event.payload, _event$payload$eventT = _event$payload.eventType, eventType = _event$payload$eventT === void 0 ? (0, $7Qr4H.UI_EVENT_TYPE) : _event$payload$eventT, action = _event$payload.action, actionSubject = _event$payload.actionSubject, actionSubjectId = _event$payload.actionSubjectId, payloadAttributes = _event$payload.attributes, name = _event$payload.name;
    var attributes = $49e88bed6866d5a0$var$_objectSpread($49e88bed6866d5a0$var$_objectSpread({
        listenerVersion: $49e88bed6866d5a0$var$listenerVersion,
        sourceHierarchy: sources.join(".") || undefined,
        componentHierarchy: components.join(".") || undefined,
        packageHierarchy: packageHierarchy.join(",") || undefined
    }, {
        packageName: packageName,
        packageVersion: packageVersion
    }), (0, (/*@__PURE__*/$parcel$interopDefault($dGehf)))(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add($49e88bed6866d5a0$var$PEOPLE_TEAMS_TAG);
    if (event.payload) switch(eventType){
        case 0, $7Qr4H.UI_EVENT_TYPE:
        case 0, $7Qr4H.OPERATIONAL_EVENT_TYPE:
        case 0, $7Qr4H.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7Qr4H.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error("Invalid event type", eventType);
            break;
    }
    return null;
};

});


parcelRegister("6j5QH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49790dee2bbcffe5$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $4L3N1 = parcelRequire("4L3N1");

var $lN7Y3 = parcelRequire("lN7Y3");

var $6Hkdn = parcelRequire("6Hkdn");
function $49790dee2bbcffe5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6Hkdn.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        channel: (0, $4L3N1.FabricChannel).notifications,
        processEvent: (0, $lN7Y3.default)
    }));
}

});
parcelRegister("lN7Y3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdd45ac86d7aa7bd$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9NMTI = parcelRequire("9NMTI");

var $dGehf = parcelRequire("dGehf");

var $7Qr4H = parcelRequire("7Qr4H");

var $hIuHa = parcelRequire("hIuHa");
parcelRequire("jlzQX");
var $5fLLg = parcelRequire("5fLLg");

var $4L3N1 = parcelRequire("4L3N1");
function $fdd45ac86d7aa7bd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fdd45ac86d7aa7bd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fdd45ac86d7aa7bd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fdd45ac86d7aa7bd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fdd45ac86d7aa7bd$var$listenerVersion = "8.10.0";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $fdd45ac86d7aa7bd$export$2e2bcd8739ae039 = function(event, logger) {
    var sources = (0, $hIuHa.getSources)(event, (0, $5fLLg.NOTIFICATIONS_CONTEXT));
    var source = (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))(sources) || (0, $7Qr4H.DEFAULT_SOURCE);
    var extraAttributes = (0, $hIuHa.getExtraAttributes)(event, (0, $5fLLg.NOTIFICATIONS_CONTEXT));
    var components = (0, $hIuHa.getComponents)(event, (0, $5fLLg.NOTIFICATIONS_CONTEXT));
    var packages = (0, $hIuHa.getPackageInfo)(event, (0, $5fLLg.NOTIFICATIONS_CONTEXT));
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))((0, $hIuHa.getPackageInfo)(event, (0, $5fLLg.NOTIFICATIONS_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event$payload = event.payload, _event$payload$eventT = _event$payload.eventType, eventType = _event$payload$eventT === void 0 ? (0, $7Qr4H.UI_EVENT_TYPE) : _event$payload$eventT, action = _event$payload.action, actionSubject = _event$payload.actionSubject, actionSubjectId = _event$payload.actionSubjectId, payloadAttributes = _event$payload.attributes, name = _event$payload.name;
    var attributes = $fdd45ac86d7aa7bd$var$_objectSpread($fdd45ac86d7aa7bd$var$_objectSpread({
        listenerVersion: $fdd45ac86d7aa7bd$var$listenerVersion,
        sourceHierarchy: sources.join(".") || undefined,
        componentHierarchy: components.join(".") || undefined,
        packageHierarchy: packageHierarchy.join(",") || undefined
    }, {
        packageName: packageName,
        packageVersion: packageVersion
    }), (0, (/*@__PURE__*/$parcel$interopDefault($dGehf)))(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add((0, $4L3N1.FabricChannel).notifications);
    if (event.payload) switch(eventType){
        case 0, $7Qr4H.UI_EVENT_TYPE:
        case 0, $7Qr4H.OPERATIONAL_EVENT_TYPE:
        case 0, $7Qr4H.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7Qr4H.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error("Invalid event type", eventType);
            break;
    }
    return null;
};

});


parcelRegister("fVddm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9766e05ab912b14$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $4L3N1 = parcelRequire("4L3N1");

var $8GK87 = parcelRequire("8GK87");

var $6Hkdn = parcelRequire("6Hkdn");
function $b9766e05ab912b14$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6Hkdn.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        channel: (0, $4L3N1.FabricChannel).recentWork,
        processEvent: (0, $8GK87.default)
    }));
}

});
parcelRegister("8GK87", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65360767826fbed8$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9NMTI = parcelRequire("9NMTI");

var $dGehf = parcelRequire("dGehf");

var $7Qr4H = parcelRequire("7Qr4H");

var $hIuHa = parcelRequire("hIuHa");
parcelRequire("jlzQX");
var $g4CHS = parcelRequire("g4CHS");

var $4L3N1 = parcelRequire("4L3N1");
function $65360767826fbed8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $65360767826fbed8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $65360767826fbed8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $65360767826fbed8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $65360767826fbed8$var$listenerVersion = "8.10.0";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $65360767826fbed8$export$2e2bcd8739ae039 = function(event, logger) {
    var sources = (0, $hIuHa.getSources)(event, (0, $g4CHS.RECENT_WORK_CONTEXT));
    var source = (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))(sources) || (0, $7Qr4H.DEFAULT_SOURCE);
    var extraAttributes = (0, $hIuHa.getExtraAttributes)(event, (0, $g4CHS.RECENT_WORK_CONTEXT));
    var components = (0, $hIuHa.getComponents)(event, (0, $g4CHS.RECENT_WORK_CONTEXT));
    var packages = (0, $hIuHa.getPackageInfo)(event, (0, $g4CHS.RECENT_WORK_CONTEXT));
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))((0, $hIuHa.getPackageInfo)(event, (0, $g4CHS.RECENT_WORK_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event$payload = event.payload, _event$payload$eventT = _event$payload.eventType, eventType = _event$payload$eventT === void 0 ? (0, $7Qr4H.UI_EVENT_TYPE) : _event$payload$eventT, action = _event$payload.action, actionSubject = _event$payload.actionSubject, actionSubjectId = _event$payload.actionSubjectId, payloadAttributes = _event$payload.attributes, name = _event$payload.name;
    var attributes = $65360767826fbed8$var$_objectSpread($65360767826fbed8$var$_objectSpread({
        listenerVersion: $65360767826fbed8$var$listenerVersion,
        sourceHierarchy: sources.join(".") || undefined,
        componentHierarchy: components.join(".") || undefined,
        packageHierarchy: packageHierarchy.join(",") || undefined
    }, {
        packageName: packageName,
        packageVersion: packageVersion
    }), (0, (/*@__PURE__*/$parcel$interopDefault($dGehf)))(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add((0, $4L3N1.FabricChannel).recentWork);
    if (event.payload) switch(eventType){
        case 0, $7Qr4H.UI_EVENT_TYPE:
        case 0, $7Qr4H.OPERATIONAL_EVENT_TYPE:
        case 0, $7Qr4H.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7Qr4H.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error("Invalid event type", eventType);
            break;
    }
    return null;
};

});


parcelRegister("gd6WA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bcd33f2b0abef4dd$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $4L3N1 = parcelRequire("4L3N1");

var $ahGlp = parcelRequire("ahGlp");

var $6Hkdn = parcelRequire("6Hkdn");
function $bcd33f2b0abef4dd$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6Hkdn.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        channel: (0, $4L3N1.FabricChannel).atlas,
        processEvent: (0, $ahGlp.default)
    }));
}

});
parcelRegister("ahGlp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77cc569c91e95de3$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9NMTI = parcelRequire("9NMTI");

var $dGehf = parcelRequire("dGehf");

var $7Qr4H = parcelRequire("7Qr4H");

var $hIuHa = parcelRequire("hIuHa");
parcelRequire("jlzQX");
var $9pWv9 = parcelRequire("9pWv9");
function $77cc569c91e95de3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $77cc569c91e95de3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $77cc569c91e95de3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $77cc569c91e95de3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $77cc569c91e95de3$var$ATLAS_TAG = "atlas";
var $77cc569c91e95de3$var$listenerVersion = "8.10.0";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $77cc569c91e95de3$export$2e2bcd8739ae039 = function(event, logger) {
    var sources = (0, $hIuHa.getSources)(event, (0, $9pWv9.ATLAS_CONTEXT));
    var source = (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))(sources) || (0, $7Qr4H.DEFAULT_SOURCE);
    var extraAttributes = (0, $hIuHa.getExtraAttributes)(event, (0, $9pWv9.ATLAS_CONTEXT));
    var components = (0, $hIuHa.getComponents)(event, (0, $9pWv9.ATLAS_CONTEXT));
    var packages = (0, $hIuHa.getPackageInfo)(event, (0, $9pWv9.ATLAS_CONTEXT));
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))((0, $hIuHa.getPackageInfo)(event, (0, $9pWv9.ATLAS_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event$payload = event.payload, _event$payload$eventT = _event$payload.eventType, eventType = _event$payload$eventT === void 0 ? (0, $7Qr4H.UI_EVENT_TYPE) : _event$payload$eventT, action = _event$payload.action, actionSubject = _event$payload.actionSubject, actionSubjectId = _event$payload.actionSubjectId, payloadAttributes = _event$payload.attributes, name = _event$payload.name;
    var attributes = $77cc569c91e95de3$var$_objectSpread($77cc569c91e95de3$var$_objectSpread({
        listenerVersion: $77cc569c91e95de3$var$listenerVersion,
        sourceHierarchy: sources.join(".") || undefined,
        componentHierarchy: components.join(".") || undefined,
        packageHierarchy: packageHierarchy.join(",") || undefined
    }, {
        packageName: packageName,
        packageVersion: packageVersion
    }), (0, (/*@__PURE__*/$parcel$interopDefault($dGehf)))(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add($77cc569c91e95de3$var$ATLAS_TAG);
    if (event.payload) switch(eventType){
        case 0, $7Qr4H.UI_EVENT_TYPE:
        case 0, $7Qr4H.OPERATIONAL_EVENT_TYPE:
        case 0, $7Qr4H.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7Qr4H.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error("Invalid event type", eventType);
            break;
    }
    return null;
};

});


parcelRegister("8ovdN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61c8c8915a0cdbf6$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $4L3N1 = parcelRequire("4L3N1");

var $2UsNr = parcelRequire("2UsNr");

var $6Hkdn = parcelRequire("6Hkdn");
function $61c8c8915a0cdbf6$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6Hkdn.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        channel: (0, $4L3N1.FabricChannel).crossFlow,
        processEvent: (0, $2UsNr.default)
    }));
}

});
parcelRegister("2UsNr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21e7261c11f1f4c9$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $7Qr4H = parcelRequire("7Qr4H");

var $9NMTI = parcelRequire("9NMTI");
parcelRequire("jlzQX");
var $1irk6 = parcelRequire("1irk6");

var $bJsql = parcelRequire("bJsql");

var $hIuHa = parcelRequire("hIuHa");
function $21e7261c11f1f4c9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $21e7261c11f1f4c9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $21e7261c11f1f4c9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $21e7261c11f1f4c9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $21e7261c11f1f4c9$var$CROSS_FLOW_TAG = "crossFlow";
var $21e7261c11f1f4c9$export$2e2bcd8739ae039 = function(event, logger) {
    var _event$payload$source;
    var _event$payload = event.payload, _event$payload$eventT = _event$payload.eventType, eventType = _event$payload$eventT === void 0 ? (0, $7Qr4H.UI_EVENT_TYPE) : _event$payload$eventT, action = _event$payload.action, actionSubject = _event$payload.actionSubject, actionSubjectId = _event$payload.actionSubjectId, name = _event$payload.name;
    var sources = (0, $bJsql.getSources)(event);
    var lastSourceFromContext = (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))(sources);
    var source = (_event$payload$source = event.payload.source) !== null && _event$payload$source !== void 0 ? _event$payload$source : lastSourceFromContext;
    if (lastSourceFromContext !== source) sources.push(source);
    var attributes = $21e7261c11f1f4c9$var$_objectSpread($21e7261c11f1f4c9$var$_objectSpread($21e7261c11f1f4c9$var$_objectSpread($21e7261c11f1f4c9$var$_objectSpread({}, (0, $bJsql.getExtraAttributes)(event)), (0, $hIuHa.getExtraAttributes)(event, (0, $1irk6.NAVIGATION_CONTEXT))), event.payload.attributes), {}, {
        namespaces: sources.join(".")
    });
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add($21e7261c11f1f4c9$var$CROSS_FLOW_TAG);
    if (event.payload) switch(eventType){
        case 0, $7Qr4H.UI_EVENT_TYPE:
        case 0, $7Qr4H.OPERATIONAL_EVENT_TYPE:
        case 0, $7Qr4H.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7Qr4H.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error("Invalid event type", eventType);
            break;
    }
    return null;
};

});


parcelRegister("5xzZY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $408bf55cb9404a50$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $8bbyU = parcelRequire("8bbyU");

var $4L3N1 = parcelRequire("4L3N1");

var $6Hkdn = parcelRequire("6Hkdn");
function $408bf55cb9404a50$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6Hkdn.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        channel: (0, $4L3N1.FabricChannel).linkingPlatform,
        processEvent: (0, $8bbyU.default)
    }));
}

});
parcelRegister("8bbyU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f4851ce5b0e0080$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9NMTI = parcelRequire("9NMTI");

var $dGehf = parcelRequire("dGehf");

var $7Qr4H = parcelRequire("7Qr4H");
parcelRequire("jlzQX");
var $fZvH8 = parcelRequire("fZvH8");

var $hIuHa = parcelRequire("hIuHa");

var $4L3N1 = parcelRequire("4L3N1");
function $5f4851ce5b0e0080$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5f4851ce5b0e0080$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5f4851ce5b0e0080$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5f4851ce5b0e0080$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5f4851ce5b0e0080$var$listenerVersion = "8.10.0";
var $5f4851ce5b0e0080$export$2e2bcd8739ae039 = function(event) {
    var sources = (0, $hIuHa.getSources)(event, (0, $fZvH8.LINKING_PLATFORM_CONTEXT));
    var packages = (0, $hIuHa.getPackageInfo)(event, (0, $fZvH8.LINKING_PLATFORM_CONTEXT));
    var components = (0, $hIuHa.getComponents)(event, (0, $fZvH8.LINKING_PLATFORM_CONTEXT));
    var extraAttributes = (0, $hIuHa.getExtraAttributes)(event, (0, $fZvH8.LINKING_PLATFORM_CONTEXT));
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))(packages) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var tags = new Set(event.payload.tags || []);
    tags.add((0, $4L3N1.FabricChannel).linkingPlatform);
    var payload = {
        name: event.payload.name,
        action: event.payload.action,
        actionSubject: event.payload.actionSubject,
        actionSubjectId: event.payload.actionSubjectId,
        eventType: event.payload.eventType,
        attributes: $5f4851ce5b0e0080$var$_objectSpread({
            packageName: packageName,
            packageVersion: packageVersion,
            listenerVersion: $5f4851ce5b0e0080$var$listenerVersion,
            sourceHierarchy: sources.join(".") || undefined,
            componentHierarchy: components.join(".") || undefined,
            packageHierarchy: packageHierarchy.join(",") || undefined
        }, (0, (/*@__PURE__*/$parcel$interopDefault($dGehf)))(extraAttributes, event.payload.attributes)),
        tags: Array.from(tags),
        source: (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))(sources) || (0, $7Qr4H.DEFAULT_SOURCE),
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
};

});


parcelRegister("905KP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68d893d465bd1bd6$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $4L3N1 = parcelRequire("4L3N1");

var $krRJx = parcelRequire("krRJx");

var $6Hkdn = parcelRequire("6Hkdn");
function $68d893d465bd1bd6$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6Hkdn.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        channel: (0, $4L3N1.FabricChannel).postOffice,
        processEvent: (0, $krRJx.default)
    }));
}

});
parcelRegister("krRJx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee30029f5b8db977$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9NMTI = parcelRequire("9NMTI");

var $dGehf = parcelRequire("dGehf");

var $7Qr4H = parcelRequire("7Qr4H");
parcelRequire("jlzQX");
var $dffvs = parcelRequire("dffvs");

var $hIuHa = parcelRequire("hIuHa");

var $4L3N1 = parcelRequire("4L3N1");
function $ee30029f5b8db977$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ee30029f5b8db977$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ee30029f5b8db977$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ee30029f5b8db977$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ee30029f5b8db977$var$POST_OFFICE_TAG = (0, $4L3N1.FabricChannel).postOffice;
var $ee30029f5b8db977$var$listenerVersion = "8.10.0";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $ee30029f5b8db977$export$2e2bcd8739ae039 = function(event, logger) {
    var sources = (0, $hIuHa.getSources)(event, (0, $dffvs.POST_OFFICE_CONTEXT));
    var source = (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))(sources) || (0, $7Qr4H.DEFAULT_SOURCE);
    var extraAttributes = (0, $hIuHa.getExtraAttributes)(event, (0, $dffvs.POST_OFFICE_CONTEXT));
    var components = (0, $hIuHa.getComponents)(event, (0, $dffvs.POST_OFFICE_CONTEXT));
    var packages = (0, $hIuHa.getPackageInfo)(event, (0, $dffvs.POST_OFFICE_CONTEXT));
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))((0, $hIuHa.getPackageInfo)(event, (0, $dffvs.POST_OFFICE_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event$payload = event.payload, _event$payload$eventT = _event$payload.eventType, eventType = _event$payload$eventT === void 0 ? (0, $7Qr4H.UI_EVENT_TYPE) : _event$payload$eventT, action = _event$payload.action, actionSubject = _event$payload.actionSubject, actionSubjectId = _event$payload.actionSubjectId, payloadAttributes = _event$payload.attributes, name = _event$payload.name;
    var attributes = $ee30029f5b8db977$var$_objectSpread($ee30029f5b8db977$var$_objectSpread({
        listenerVersion: $ee30029f5b8db977$var$listenerVersion,
        sourceHierarchy: sources.join(".") || undefined,
        componentHierarchy: components.join(".") || undefined,
        packageHierarchy: packageHierarchy.join(",") || undefined
    }, {
        packageName: packageName,
        packageVersion: packageVersion
    }), (0, (/*@__PURE__*/$parcel$interopDefault($dGehf)))(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add($ee30029f5b8db977$var$POST_OFFICE_TAG);
    if (event.payload) switch(eventType){
        case 0, $7Qr4H.UI_EVENT_TYPE:
        case 0, $7Qr4H.OPERATIONAL_EVENT_TYPE:
        case 0, $7Qr4H.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7Qr4H.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error("Invalid event type", eventType);
            break;
    }
    return null;
};

});


parcelRegister("ePl3B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $acb6299fd1a173bd$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $4L3N1 = parcelRequire("4L3N1");

var $3LDFb = parcelRequire("3LDFb");

var $6Hkdn = parcelRequire("6Hkdn");
function $acb6299fd1a173bd$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6Hkdn.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        channel: (0, $4L3N1.FabricChannel).aiMate,
        processEvent: (0, $3LDFb.default)
    }));
}

});
parcelRegister("3LDFb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2be487288b82b7d2$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9NMTI = parcelRequire("9NMTI");

var $dGehf = parcelRequire("dGehf");

var $7Qr4H = parcelRequire("7Qr4H");
parcelRequire("jlzQX");
var $dUXBR = parcelRequire("dUXBR");

var $hIuHa = parcelRequire("hIuHa");
function $2be487288b82b7d2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2be487288b82b7d2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2be487288b82b7d2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2be487288b82b7d2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2be487288b82b7d2$var$AI_MATE_TAG = "aiMate";
var $2be487288b82b7d2$var$listenerVersion = "8.10.0";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $2be487288b82b7d2$export$2e2bcd8739ae039 = function(event, logger) {
    var sources = (0, $hIuHa.getSources)(event, (0, $dUXBR.AI_MATE_CONTEXT));
    var source = (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))(sources) || (0, $7Qr4H.DEFAULT_SOURCE);
    var extraAttributes = (0, $hIuHa.getExtraAttributes)(event, (0, $dUXBR.AI_MATE_CONTEXT));
    var components = (0, $hIuHa.getComponents)(event, (0, $dUXBR.AI_MATE_CONTEXT));
    var packages = (0, $hIuHa.getPackageInfo)(event, (0, $dUXBR.AI_MATE_CONTEXT));
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))((0, $hIuHa.getPackageInfo)(event, (0, $dUXBR.AI_MATE_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event$payload = event.payload, _event$payload$eventT = _event$payload.eventType, eventType = _event$payload$eventT === void 0 ? (0, $7Qr4H.UI_EVENT_TYPE) : _event$payload$eventT, action = _event$payload.action, actionSubject = _event$payload.actionSubject, actionSubjectId = _event$payload.actionSubjectId, payloadAttributes = _event$payload.attributes, name = _event$payload.name;
    var attributes = $2be487288b82b7d2$var$_objectSpread($2be487288b82b7d2$var$_objectSpread({
        listenerVersion: $2be487288b82b7d2$var$listenerVersion,
        sourceHierarchy: sources.join(".") || undefined,
        componentHierarchy: components.join(".") || undefined,
        packageHierarchy: packageHierarchy.join(",") || undefined
    }, {
        packageName: packageName,
        packageVersion: packageVersion
    }), (0, (/*@__PURE__*/$parcel$interopDefault($dGehf)))(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add($2be487288b82b7d2$var$AI_MATE_TAG);
    if (event.payload) switch(eventType){
        case 0, $7Qr4H.UI_EVENT_TYPE:
        case 0, $7Qr4H.OPERATIONAL_EVENT_TYPE:
        case 0, $7Qr4H.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7Qr4H.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error("Invalid event type", eventType);
            break;
    }
    return null;
};

});


parcelRegister("dFBLR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f3c673b49504c89$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $4L3N1 = parcelRequire("4L3N1");

var $KbLX8 = parcelRequire("KbLX8");

var $6Hkdn = parcelRequire("6Hkdn");
function $9f3c673b49504c89$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6Hkdn.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        channel: (0, $4L3N1.FabricChannel).avp,
        processEvent: (0, $KbLX8.default)
    }));
}

});
parcelRegister("KbLX8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08ad6dc08b0ae83d$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9NMTI = parcelRequire("9NMTI");

var $dGehf = parcelRequire("dGehf");

var $7Qr4H = parcelRequire("7Qr4H");
parcelRequire("jlzQX");
var $2FN96 = parcelRequire("2FN96");

var $hIuHa = parcelRequire("hIuHa");
function $08ad6dc08b0ae83d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $08ad6dc08b0ae83d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $08ad6dc08b0ae83d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $08ad6dc08b0ae83d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $08ad6dc08b0ae83d$var$AVP_TAG = "avp";
var $08ad6dc08b0ae83d$var$listenerVersion = "8.10.0";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $08ad6dc08b0ae83d$export$2e2bcd8739ae039 = function(event, logger) {
    var sources = (0, $hIuHa.getSources)(event, (0, $2FN96.AVP_CONTEXT));
    var source = (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))(sources) || (0, $7Qr4H.DEFAULT_SOURCE);
    var extraAttributes = (0, $hIuHa.getExtraAttributes)(event, (0, $2FN96.AVP_CONTEXT));
    var components = (0, $hIuHa.getComponents)(event, (0, $2FN96.AVP_CONTEXT));
    var packages = (0, $hIuHa.getPackageInfo)(event, (0, $2FN96.AVP_CONTEXT));
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))((0, $hIuHa.getPackageInfo)(event, (0, $2FN96.AVP_CONTEXT))) || {}, packageName = _ref.packageName, packageVersion = _ref.packageVersion;
    var packageHierarchy = packages.map(function(p) {
        return p.packageVersion ? "".concat(p.packageName, "@").concat(p.packageVersion) : p.packageName;
    });
    var _event$payload = event.payload, _event$payload$eventT = _event$payload.eventType, eventType = _event$payload$eventT === void 0 ? (0, $7Qr4H.UI_EVENT_TYPE) : _event$payload$eventT, action = _event$payload.action, actionSubject = _event$payload.actionSubject, actionSubjectId = _event$payload.actionSubjectId, payloadAttributes = _event$payload.attributes, name = _event$payload.name;
    var attributes = $08ad6dc08b0ae83d$var$_objectSpread($08ad6dc08b0ae83d$var$_objectSpread({
        listenerVersion: $08ad6dc08b0ae83d$var$listenerVersion,
        sourceHierarchy: sources.join(".") || undefined,
        componentHierarchy: components.join(".") || undefined,
        packageHierarchy: packageHierarchy.join(",") || undefined
    }, {
        packageName: packageName,
        packageVersion: packageVersion
    }), (0, (/*@__PURE__*/$parcel$interopDefault($dGehf)))(extraAttributes, payloadAttributes));
    // Ensure navigation tag is not duplicated by using Set
    var tags = new Set(event.payload.tags || []);
    tags.add($08ad6dc08b0ae83d$var$AVP_TAG);
    if (event.payload) switch(eventType){
        case 0, $7Qr4H.UI_EVENT_TYPE:
        case 0, $7Qr4H.OPERATIONAL_EVENT_TYPE:
        case 0, $7Qr4H.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $7Qr4H.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error("Invalid event type", eventType);
            break;
    }
    return null;
};

});




parcelRegister("jNWOd", function(module, exports) {

$parcel$export(module.exports, "SmartCardProvider", function () { return $e6b036280ecee4b9$export$497ecb0280204df4; });

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("ayiNt");
var $faAZ4 = parcelRequire("faAZ4");

var $i5kzR = parcelRequire("i5kzR");

var $1MA75 = parcelRequire("1MA75");

var $bkHUG = parcelRequire("bkHUG");

var $aA57s = parcelRequire("aA57s");

var $jgfL0 = parcelRequire("jgfL0");
function $e6b036280ecee4b9$export$497ecb0280204df4(_ref) {
    var storeOptions = _ref.storeOptions, customClient = _ref.client, customAuthFlow = _ref.authFlow, children = _ref.children, renderers = _ref.renderers, featureFlags = _ref.featureFlags, isAdminHubAIEnabled = _ref.isAdminHubAIEnabled, product = _ref.product;
    var parentContext = (0, $9nHZC.useContext)((0, $aA57s.SmartCardContext));
    var defaultInitialState = (0, $9nHZC.useMemo)(function() {
        return {};
    }, []);
    var _ref2 = storeOptions || {
        initialState: defaultInitialState
    }, initialState = _ref2.initialState;
    var store = (0, $9nHZC.useMemo)(function() {
        return (0, $faAZ4.default)((0, $bkHUG.cardReducer), initialState);
    }, [
        initialState
    ]);
    var providerValue = (0, $9nHZC.useMemo)(function() {
        var client = customClient || new (0, $jgfL0.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        var authFlow = customAuthFlow || "oauth2";
        var getPreview = function getPreview(url, platform) {
            var cardState = (0, $i5kzR.getUrl)(store, url);
            return cardState.details ? (0, $1MA75.extractPreview)(cardState.details.data, platform) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            featureFlags: featureFlags,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product
        };
    }, [
        customClient,
        customAuthFlow,
        isAdminHubAIEnabled,
        product,
        renderers,
        featureFlags,
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aA57s.SmartCardContext).Provider, {
        value: parentContext || providerValue
    }, children);
}
var $e6b036280ecee4b9$export$2e2bcd8739ae039 = $e6b036280ecee4b9$export$497ecb0280204df4;

});
parcelRegister("ayiNt", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return (parcelRequire("faAZ4")).default; });

var $faAZ4 = parcelRequire("faAZ4");

var $2Z1M0 = parcelRequire("2Z1M0");

var $41bcK = parcelRequire("41bcK");

var $uKBnp = parcelRequire("uKBnp");

var $fQr1O = parcelRequire("fQr1O");
parcelRequire("8NxqW");
/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/ function $7aeba909c05ce5c8$var$isCrushed() {}

});
parcelRegister("faAZ4", function(module, exports) {

$parcel$export(module.exports, "ActionTypes", function () { return $b0b47a71b681b33a$export$1385d81a6c6bbcd4; });
$parcel$export(module.exports, "default", function () { return $b0b47a71b681b33a$export$2e2bcd8739ae039; });

var $4vOvC = parcelRequire("4vOvC");

var $8tqiY = parcelRequire("8tqiY");
var $b0b47a71b681b33a$export$1385d81a6c6bbcd4 = {
    INIT: "@@redux/INIT"
};
function $b0b47a71b681b33a$export$2e2bcd8739ae039(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error("Expected the enhancer to be a function.");
        return enhancer($b0b47a71b681b33a$export$2e2bcd8739ae039)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error("Expected the reducer to be a function.");
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error("Expected listener to be a function.");
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!(0, $4vOvC.default)(action)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (typeof action.type === "undefined") throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (isDispatching) throw new Error("Reducers may not dispatch actions.");
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error("Expected the nextReducer to be a function.");
        currentReducer = nextReducer;
        dispatch({
            type: $b0b47a71b681b33a$export$1385d81a6c6bbcd4.INIT
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object") throw new TypeError("Expected the observer to be an object.");
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[0, $8tqiY.default] = function() {
            return this;
        }, _ref;
    }
    // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $b0b47a71b681b33a$export$1385d81a6c6bbcd4.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[0, $8tqiY.default] = observable, _ref2;
}

});
parcelRegister("4vOvC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34913cb3f49d4d2b$export$2e2bcd8739ae039; });

var $9mt1a = parcelRequire("9mt1a");

var $j8Kvr = parcelRequire("j8Kvr");

var $bqTHd = parcelRequire("bqTHd");
/** `Object#toString` result references. */ var $34913cb3f49d4d2b$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $34913cb3f49d4d2b$var$funcProto = Function.prototype, $34913cb3f49d4d2b$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $34913cb3f49d4d2b$var$funcToString = $34913cb3f49d4d2b$var$funcProto.toString;
/** Used to check objects for own properties. */ var $34913cb3f49d4d2b$var$hasOwnProperty = $34913cb3f49d4d2b$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $34913cb3f49d4d2b$var$objectCtorString = $34913cb3f49d4d2b$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $34913cb3f49d4d2b$var$isPlainObject(value) {
    if (!(0, $bqTHd.default)(value) || (0, $9mt1a.default)(value) != $34913cb3f49d4d2b$var$objectTag) return false;
    var proto = (0, $j8Kvr.default)(value);
    if (proto === null) return true;
    var Ctor = $34913cb3f49d4d2b$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $34913cb3f49d4d2b$var$funcToString.call(Ctor) == $34913cb3f49d4d2b$var$objectCtorString;
}
var $34913cb3f49d4d2b$export$2e2bcd8739ae039 = $34913cb3f49d4d2b$var$isPlainObject;

});
parcelRegister("9mt1a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d0cad75be377627$export$2e2bcd8739ae039; });

var $jici1 = parcelRequire("jici1");

var $cwaMb = parcelRequire("cwaMb");

var $63uTE = parcelRequire("63uTE");
/** `Object#toString` result references. */ var $6d0cad75be377627$var$nullTag = "[object Null]", $6d0cad75be377627$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $6d0cad75be377627$var$symToStringTag = (0, $jici1.default) ? (0, $jici1.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $6d0cad75be377627$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $6d0cad75be377627$var$undefinedTag : $6d0cad75be377627$var$nullTag;
    return $6d0cad75be377627$var$symToStringTag && $6d0cad75be377627$var$symToStringTag in Object(value) ? (0, $cwaMb.default)(value) : (0, $63uTE.default)(value);
}
var $6d0cad75be377627$export$2e2bcd8739ae039 = $6d0cad75be377627$var$baseGetTag;

});
parcelRegister("jici1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0b93b40100a1991$export$2e2bcd8739ae039; });

var $8kDqY = parcelRequire("8kDqY");
/** Built-in value references. */ var $e0b93b40100a1991$var$Symbol = (0, $8kDqY.default).Symbol;
var $e0b93b40100a1991$export$2e2bcd8739ae039 = $e0b93b40100a1991$var$Symbol;

});
parcelRegister("8kDqY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $610ec7c2cc9b8b80$export$2e2bcd8739ae039; });

var $7jSBg = parcelRequire("7jSBg");
/** Detect free variable `self`. */ var $610ec7c2cc9b8b80$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $610ec7c2cc9b8b80$var$root = (0, $7jSBg.default) || $610ec7c2cc9b8b80$var$freeSelf || Function("return this")();
var $610ec7c2cc9b8b80$export$2e2bcd8739ae039 = $610ec7c2cc9b8b80$var$root;

});
parcelRegister("7jSBg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5544a92f1b8e3a00$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $5544a92f1b8e3a00$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $5544a92f1b8e3a00$export$2e2bcd8739ae039 = $5544a92f1b8e3a00$var$freeGlobal;

});



parcelRegister("cwaMb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91d0d51bef9c8305$export$2e2bcd8739ae039; });

var $jici1 = parcelRequire("jici1");
/** Used for built-in method references. */ var $91d0d51bef9c8305$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $91d0d51bef9c8305$var$hasOwnProperty = $91d0d51bef9c8305$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $91d0d51bef9c8305$var$nativeObjectToString = $91d0d51bef9c8305$var$objectProto.toString;
/** Built-in value references. */ var $91d0d51bef9c8305$var$symToStringTag = (0, $jici1.default) ? (0, $jici1.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $91d0d51bef9c8305$var$getRawTag(value) {
    var isOwn = $91d0d51bef9c8305$var$hasOwnProperty.call(value, $91d0d51bef9c8305$var$symToStringTag), tag = value[$91d0d51bef9c8305$var$symToStringTag];
    try {
        value[$91d0d51bef9c8305$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $91d0d51bef9c8305$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$91d0d51bef9c8305$var$symToStringTag] = tag;
        else delete value[$91d0d51bef9c8305$var$symToStringTag];
    }
    return result;
}
var $91d0d51bef9c8305$export$2e2bcd8739ae039 = $91d0d51bef9c8305$var$getRawTag;

});

parcelRegister("63uTE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $468afd52247308f8$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $468afd52247308f8$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $468afd52247308f8$var$nativeObjectToString = $468afd52247308f8$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $468afd52247308f8$var$objectToString(value) {
    return $468afd52247308f8$var$nativeObjectToString.call(value);
}
var $468afd52247308f8$export$2e2bcd8739ae039 = $468afd52247308f8$var$objectToString;

});


parcelRegister("j8Kvr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03988fda002ba382$export$2e2bcd8739ae039; });

var $4q1BL = parcelRequire("4q1BL");
/** Built-in value references. */ var $03988fda002ba382$var$getPrototype = (0, $4q1BL.default)(Object.getPrototypeOf, Object);
var $03988fda002ba382$export$2e2bcd8739ae039 = $03988fda002ba382$var$getPrototype;

});
parcelRegister("4q1BL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $337ad676807c9904$export$2e2bcd8739ae039; });
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $337ad676807c9904$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $337ad676807c9904$export$2e2bcd8739ae039 = $337ad676807c9904$var$overArg;

});


parcelRegister("bqTHd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $852d53781a2c57ae$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $852d53781a2c57ae$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $852d53781a2c57ae$export$2e2bcd8739ae039 = $852d53781a2c57ae$var$isObjectLike;

});



parcelRegister("2Z1M0", function(module, exports) {

var $faAZ4 = parcelRequire("faAZ4");

var $4vOvC = parcelRequire("4vOvC");
parcelRequire("8NxqW");
function $22c2a76787b69e65$var$getUndefinedStateErrorMessage(key, action) {
    var actionType = action && action.type;
    var actionName = actionType && '"' + actionType.toString() + '"' || "an action";
    return "Given action " + actionName + ', reducer "' + key + '" returned undefined. ' + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}
function $22c2a76787b69e65$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === (0, $faAZ4.ActionTypes).INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!(0, $4vOvC.default)(inputState)) return "The " + argumentName + ' has unexpected type of "' + ({}).toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $22c2a76787b69e65$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: (0, $faAZ4.ActionTypes).INIT
        });
        if (typeof initialState === "undefined") throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
        var type = "@@redux/PROBE_UNKNOWN_ACTION_" + Math.random().toString(36).substring(7).split("").join(".");
        if (typeof reducer(undefined, {
            type: type
        }) === "undefined") throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ("Don't try to handle " + (0, $faAZ4.ActionTypes).INIT + ' or other actions in "redux/*" ') + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    });
}
function $22c2a76787b69e65$export$2e2bcd8739ae039(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache = void 0;
    var shapeAssertionError = void 0;
    try {
        $22c2a76787b69e65$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var errorMessage = $22c2a76787b69e65$var$getUndefinedStateErrorMessage(_key, action);
                throw new Error(errorMessage);
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        return hasChanged ? nextState : state;
    };
}

});
parcelRegister("8NxqW", function(module, exports) {
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $667cd58a90e6e642$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});


parcelRegister("41bcK", function(module, exports) {
function $2ecff269525f1727$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(undefined, arguments));
    };
}
function $2ecff269525f1727$export$2e2bcd8739ae039(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $2ecff269525f1727$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? "null" : typeof actionCreators) + ". " + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
    var keys = Object.keys(actionCreators);
    var boundActionCreators = {};
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $2ecff269525f1727$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}

});

parcelRegister("uKBnp", function(module, exports) {

var $fQr1O = parcelRequire("fQr1O");
var $05c6f39cd60f4f46$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $05c6f39cd60f4f46$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function(reducer, preloadedState, enhancer) {
            var store = createStore(reducer, preloadedState, enhancer);
            var _dispatch = store.dispatch;
            var chain = [];
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch(action) {
                    return _dispatch(action);
                }
            };
            chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = (0, $fQr1O.default).apply(undefined, chain)(store.dispatch);
            return $05c6f39cd60f4f46$var$_extends({}, store, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("fQr1O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b890ad92c5ac1658$export$2e2bcd8739ae039; });
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $b890ad92c5ac1658$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(undefined, arguments));
        };
    });
}

});



parcelRegister("i5kzR", function(module, exports) {

$parcel$export(module.exports, "getUrl", function () { return $d2a8a7d81e1eef66$export$94df0e59ebebf4a7; });
var $d2a8a7d81e1eef66$export$94df0e59ebebf4a7 = function getUrl(store, url) {
    return store.getState()[url] || {
        status: "pending"
    };
};

});

parcelRegister("1MA75", function(module, exports) {

$parcel$export(module.exports, "extractPreview", function () { return $14c64976cccca7d4$export$4b0d98b1b7f6d115; });

var $cLRYs = parcelRequire("cLRYs");

var $jU0dv = parcelRequire("jU0dv");
var $14c64976cccca7d4$export$4b0d98b1b7f6d115 = function extractPreview(jsonLd, platform, iframeUrlType) {
    var preview = jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.preview;
    var isSupported = (0, $cLRYs.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === "string") return {
            src: preview
        };
        else if (preview["@type"] === "Link" && iframeUrlType === "interactiveHref" && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview["atlassian:aspectRatio"]
        };
        else if (preview["@type"] === "Link") return {
            src: (0, $jU0dv.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview["atlassian:aspectRatio"]
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === "interactiveHref" && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview["atlassian:aspectRatio"]
                };
                return {
                    src: (0, $jU0dv.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview["atlassian:aspectRatio"]
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
};

});
parcelRegister("cLRYs", function(module, exports) {

$parcel$export(module.exports, "extractPlatformIsSupported", function () { return $94c3bdfb42be99b2$export$3e8ad908070b68b2; });
var $94c3bdfb42be99b2$export$3e8ad908070b68b2 = function extractPlatformIsSupported(preview, platform) {
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === "string") return true;
        else {
            var supportedPlatforms = preview["atlassian:supportedPlatforms"];
            if (supportedPlatforms) {
                var isWeb = platform === "web";
                return isWeb && supportedPlatforms.includes("web") || !isWeb && supportedPlatforms.includes("mobile");
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});

parcelRegister("jU0dv", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromLinkJsonLd", function () { return $e7d36a586c7ea055$export$396ba4ef2e37dc65; });
/**
 * Extracts the URL from a JSON-LD Link object or array of link objects.
 *
 * If the link is a string, it is assumed to be a URL and is returned as is.
 * If the link is an array, returns the URL in the first link object.
 * Otherwise the href property is returned.
 *
 * @param link - The JSON-LD link object or array of link objects.
 * @returns URL string if one is found, otherwise undefined.
 */ var $e7d36a586c7ea055$export$396ba4ef2e37dc65 = function extractUrlFromLinkJsonLd(link) {
    if (typeof link === "string") return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return extractUrlFromLinkJsonLd(link[0]);
    } else return link.href;
};

});


parcelRegister("bkHUG", function(module, exports) {

$parcel$export(module.exports, "cardReducer", function () { return $8403a034cf6741f8$export$3c7c3113a97b6492; });

var $kFnE9 = parcelRequire("kFnE9");

var $4Fcf8 = parcelRequire("4Fcf8");
var $d3DMN = parcelRequire("d3DMN");
function $8403a034cf6741f8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8403a034cf6741f8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8403a034cf6741f8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8403a034cf6741f8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8403a034cf6741f8$var$isCardAction = function isCardAction(action) {
    return [
        (0, $4Fcf8.ACTION_PENDING),
        (0, $4Fcf8.ACTION_RESOLVING),
        (0, $4Fcf8.ACTION_RESOLVED),
        (0, $4Fcf8.ACTION_RELOADING),
        (0, $4Fcf8.ACTION_ERROR),
        (0, $4Fcf8.ACTION_ERROR_FALLBACK),
        (0, $4Fcf8.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $8403a034cf6741f8$var$persistPayloadToState(payload, state, type) {
    var nextDetails = payload;
    var nextState = $8403a034cf6741f8$var$_objectSpread({}, state);
    if (nextDetails) {
        nextState.status = (0, $d3DMN.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $8403a034cf6741f8$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $4Fcf8.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $4Fcf8.ACTION_RESOLVING:
            return $8403a034cf6741f8$var$_objectSpread($8403a034cf6741f8$var$_objectSpread({}, state), {}, {
                status: action.type
            });
        case 0, $4Fcf8.ACTION_RESOLVED:
            return $8403a034cf6741f8$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $4Fcf8.ACTION_RELOADING:
            return $8403a034cf6741f8$var$persistPayloadToState(action.payload, state, "resolved");
        case 0, $4Fcf8.ACTION_ERROR:
            return $8403a034cf6741f8$var$_objectSpread($8403a034cf6741f8$var$_objectSpread({}, state), {}, {
                status: action.type,
                error: action.error
            });
        case 0, $4Fcf8.ACTION_ERROR_FALLBACK:
            return $8403a034cf6741f8$var$_objectSpread($8403a034cf6741f8$var$_objectSpread({}, state), {}, {
                status: action.type,
                error: action.error,
                details: action.payload
            });
        case 0, $4Fcf8.ACTION_UPDATE_METADATA_STATUS:
            return $8403a034cf6741f8$var$_objectSpread($8403a034cf6741f8$var$_objectSpread({}, state), {}, {
                metadataStatus: action.metadataStatus
            });
    }
}
var $8403a034cf6741f8$export$3c7c3113a97b6492 = function cardReducer(state, action) {
    if (!$8403a034cf6741f8$var$isCardAction(action)) return state;
    var cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    var hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        var nextState = $8403a034cf6741f8$var$reduceToNextState(cardState, action);
        return $8403a034cf6741f8$var$_objectSpread($8403a034cf6741f8$var$_objectSpread({}, state), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, action.url, nextState));
    }
};

});
parcelRegister("4Fcf8", function(module, exports) {

$parcel$export(module.exports, "ACTION_PENDING", function () { return $36547d008ca360f7$export$6e470aad5ba8952e; });
$parcel$export(module.exports, "ACTION_RESOLVING", function () { return $36547d008ca360f7$export$9a6a932a0a39498e; });
$parcel$export(module.exports, "ACTION_RESOLVED", function () { return $36547d008ca360f7$export$63ec8bc7a8a75482; });
$parcel$export(module.exports, "ACTION_RELOADING", function () { return $36547d008ca360f7$export$b8cfaa842c9ab487; });
$parcel$export(module.exports, "ACTION_ERROR", function () { return $36547d008ca360f7$export$6d8ed3f9433dd372; });
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", function () { return $36547d008ca360f7$export$cfbbb7126bc8a0c6; });
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", function () { return $36547d008ca360f7$export$2c5edb971b673330; });
$parcel$export(module.exports, "cardAction", function () { return $36547d008ca360f7$export$a884a52152489cc3; });
// TODO: eventually move this file to @atlaskit/link-actions
var $36547d008ca360f7$export$6e470aad5ba8952e = "pending";
var $36547d008ca360f7$export$9a6a932a0a39498e = "resolving";
var $36547d008ca360f7$export$63ec8bc7a8a75482 = "resolved";
var $36547d008ca360f7$export$b8cfaa842c9ab487 = "reloading";
var $36547d008ca360f7$export$6d8ed3f9433dd372 = "errored";
var $36547d008ca360f7$export$cfbbb7126bc8a0c6 = "fallback";
var $36547d008ca360f7$export$76b5c1aca20759c6 = "preload";
var $36547d008ca360f7$export$2c5edb971b673330 = "metadata";
var $36547d008ca360f7$export$a884a52152489cc3 = function cardAction(type, _ref, payload, error, metadataStatus, ignoreStatusCheck) {
    var url = _ref.url;
    return {
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    };
};

});

parcelRegister("d3DMN", function(module, exports) {

$parcel$export(module.exports, "getStatus", function () { return $981a6adffe6f57ec$export$b70265791d2079d4; });
var $981a6adffe6f57ec$var$getStatusForNotFoundVisibility = function getStatusForNotFoundVisibility(meta) {
    var _meta$requestAccess;
    var accessType = (_meta$requestAccess = meta.requestAccess) === null || _meta$requestAccess === void 0 ? void 0 : _meta$requestAccess.accessType;
    if (!accessType || accessType === "ACCESS_EXISTS") return "not_found";
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return "forbidden";
};
var $981a6adffe6f57ec$export$b70265791d2079d4 = function getStatus(_ref) {
    var meta = _ref.meta;
    var access = meta.access, visibility = meta.visibility;
    switch(access){
        case "forbidden":
            if (visibility === "not_found") return $981a6adffe6f57ec$var$getStatusForNotFoundVisibility(meta);
            else return "forbidden";
        case "unauthorized":
            return "unauthorized";
        default:
            return "resolved";
    }
};

});


parcelRegister("aA57s", function(module, exports) {

$parcel$export(module.exports, "SmartCardContext", function () { return $7b413cc48e326b77$export$156b523e63b4f63a; });
$parcel$export(module.exports, "useSmartLinkContext", function () { return $7b413cc48e326b77$export$e1d190b530cf0ee9; });

var $9nHZC = parcelRequire("9nHZC");

var $7b413cc48e326b77$export$156b523e63b4f63a = /*#__PURE__*/ (0, $9nHZC.createContext)(undefined);
function $7b413cc48e326b77$export$e1d190b530cf0ee9() {
    var context = (0, $9nHZC.useContext)($7b413cc48e326b77$export$156b523e63b4f63a);
    if (!context) throw Error("useSmartCard() must be wrapped in <SmartCardProvider>");
    return context;
}
var $7b413cc48e326b77$export$2e2bcd8739ae039 = $7b413cc48e326b77$export$156b523e63b4f63a;

});

parcelRegister("jgfL0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e05bbbf9be47623a$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $lOQkO = parcelRequire("lOQkO");

var $b4Ivn = parcelRequire("b4Ivn");

var $4mVfk = parcelRequire("4mVfk");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");

var $8DpVo = parcelRequire("8DpVo");
parcelRequire("hdcxN");

var $ht5OE = parcelRequire("ht5OE");

var $77Hya = parcelRequire("77Hya");

var $4OBz4 = parcelRequire("4OBz4");

var $8GBmj = parcelRequire("8GBmj");
var $c24b4 = parcelRequire("c24b4");
var $d3DMN = parcelRequire("d3DMN");
var $1VYkQ = parcelRequire("1VYkQ");

var $i9fQh = parcelRequire("i9fQh");

var $rE472 = parcelRequire("rE472");

var $f0KmV = parcelRequire("f0KmV");
var $e05bbbf9be47623a$var$_excluded = [
    "error"
];
function $e05bbbf9be47623a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e05bbbf9be47623a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e05bbbf9be47623a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e05bbbf9be47623a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e05bbbf9be47623a$var$MAX_BATCH_SIZE = 50;
var $e05bbbf9be47623a$var$MIN_TIME_BETWEEN_BATCHES = 250;
var $e05bbbf9be47623a$var$URL_RESPONSE_CACHE_SIZE = 100;
var $e05bbbf9be47623a$export$d6a66073b5d79eb3 = new (0, $rE472.LRUMap)($e05bbbf9be47623a$var$URL_RESPONSE_CACHE_SIZE);
var $e05bbbf9be47623a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function CardClient(envKey, baseUrlOverride) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, CardClient);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "postBatchResolve", /*#__PURE__*/ function() {
            var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee(resources) {
                var _Intl;
                var resourceType, deDuplicatedResources, resolvedResources, headers, map, i, resource, data, _args = arguments;
                return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            resourceType = _args.length > 1 && _args[1] !== undefined ? _args[1] : "URL";
                            // De-duplicate requested URLs (see `this.createLoader` for more detail).
                            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
                            deDuplicatedResources = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(new Set(resources));
                            resolvedResources = [];
                            headers = $e05bbbf9be47623a$var$_objectSpread($e05bbbf9be47623a$var$_objectSpread({}, (0, $f0KmV.fg)("platform.linking-platform.datasource.add-timezone-header") ? {
                                "origin-timezone": (_Intl = Intl) === null || _Intl === void 0 ? void 0 : _Intl.DateTimeFormat().resolvedOptions().timeZone
                            } : {}), _this.product ? {
                                "X-Product": _this.product
                            } : {});
                            _context.prev = 4;
                            if (!(resourceType === "URL")) {
                                _context.next = 9;
                                break;
                            }
                            _context.next = 8;
                            return (0, $1VYkQ.request)("post", "".concat(_this.resolverUrl, "/resolve/batch"), deDuplicatedResources.map(function(resourceUrl) {
                                return {
                                    resourceUrl: resourceUrl
                                };
                            }), headers);
                        case 8:
                            resolvedResources = _context.sent;
                        case 9:
                            if (!(resourceType === "ARI")) {
                                _context.next = 13;
                                break;
                            }
                            _context.next = 12;
                            return (0, $1VYkQ.request)("post", "".concat(_this.resolverUrl, "/resolve/ari/batch"), deDuplicatedResources.map(function(ari) {
                                return {
                                    ari: ari
                                };
                            }), headers);
                        case 12:
                            resolvedResources = _context.sent;
                        case 13:
                            _context.next = 18;
                            break;
                        case 15:
                            _context.prev = 15;
                            _context.t0 = _context["catch"](4);
                            // we make sure we return a valid dataloader response by creating an error
                            // response for each url/ari
                            resolvedResources = resources.map(function() {
                                // @ts-ignore
                                var status = (0, $i9fQh.isErrorResponse)(_context.t0) ? _context.t0.status : 500;
                                var errorResponse = {
                                    status: status,
                                    // @ts-ignore
                                    error: _context.t0
                                };
                                return errorResponse;
                            });
                        case 18:
                            // Reduce into a map to make accessing faster and easier.
                            map = {}; // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
                            for(i = 0; i < deDuplicatedResources.length; ++i){
                                resource = deDuplicatedResources[i];
                                data = resolvedResources[i];
                                map[resource] = data;
                            }
                            // Reconvert list back into the original order in which it was given to us.
                            return _context.abrupt("return", resources.map(function(originalResource) {
                                return map[originalResource];
                            }));
                        case 21:
                        case "end":
                            return _context.stop();
                    }
                }, _callee, null, [
                    [
                        4,
                        15
                    ]
                ]);
            }));
            return function(_x) {
                return _ref.apply(this, arguments);
            };
        }());
        // Endpoint for batch resolve url
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "batchResolve", /*#__PURE__*/ function() {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee2(urls) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee2$(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            return _context2.abrupt("return", _this.postBatchResolve(urls, "URL"));
                        case 1:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee2);
            }));
            return function(_x2) {
                return _ref2.apply(this, arguments);
            };
        }());
        // Endpoint for batch resolve ari
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "batchResolveAris", /*#__PURE__*/ function() {
            var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee3(aris) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee3$(_context3) {
                    while(true)switch(_context3.prev = _context3.next){
                        case 0:
                            return _context3.abrupt("return", _this.postBatchResolve(aris, "ARI"));
                        case 1:
                        case "end":
                            return _context3.stop();
                    }
                }, _callee3);
            }));
            return function(_x3) {
                return _ref3.apply(this, arguments);
            };
        }());
        this.resolverUrl = (0, $c24b4.getResolverUrl)(envKey, baseUrlOverride);
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(CardClient, [
        {
            key: "setProduct",
            value: function setProduct(product) {
                this.product = product;
            }
        },
        {
            key: "createLoader",
            value: function createLoader() {
                var batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($4OBz4)))({
                    limit: 1,
                    interval: $e05bbbf9be47623a$var$MIN_TIME_BETWEEN_BATCHES
                });
                var throttledBatchResolve = batchResolveThrottler(this.batchResolve);
                return new (0, (/*@__PURE__*/$parcel$interopDefault($ht5OE)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
                // This is for two reasons:
                //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
                //  2: we want to avoid sending out heaps of requests from the client at once
                function(urls) {
                    return throttledBatchResolve(urls);
                }, {
                    maxBatchSize: $e05bbbf9be47623a$var$MAX_BATCH_SIZE,
                    // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
                    // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
                    // - the user clicks "request access", and then following the auth prompts and gets access
                    // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
                    //   because the smartlink's URL (which is the cache key) is exactly the same
                    //
                    // For this reason, we disable DataLoader's cache.
                    // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
                    // ourselves in `this.batchResolve`.
                    cache: false
                });
            }
        },
        {
            key: "getLoader",
            value: function getLoader(hostname) {
                if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
                return this.loadersByDomain[hostname];
            }
        },
        {
            key: "resolveUrl",
            value: function() {
                var _resolveUrl = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee4(url) {
                    var force, hostname, loader, responsePromise, response, isUnresolvedLink, _args4 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                force = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : false;
                                hostname = new URL(url).hostname;
                                loader = this.getLoader(hostname);
                                responsePromise = $e05bbbf9be47623a$export$d6a66073b5d79eb3.get(url);
                                if (!responsePromise || force) {
                                    responsePromise = loader.load(url);
                                    $e05bbbf9be47623a$export$d6a66073b5d79eb3.set(url, responsePromise);
                                }
                                _context4.prev = 5;
                                _context4.next = 8;
                                return responsePromise;
                            case 8:
                                response = _context4.sent;
                                _context4.next = 15;
                                break;
                            case 11:
                                _context4.prev = 11;
                                _context4.t0 = _context4["catch"](5);
                                // Technically this never happens, since batchResolve handles errors and doesn't throw,
                                // But just in case.
                                $e05bbbf9be47623a$export$d6a66073b5d79eb3.delete(url);
                                throw _context4.t0;
                            case 15:
                                isUnresolvedLink = !(0, $i9fQh.isSuccessfulResponse)(response) || (0, $d3DMN.getStatus)(response.body) !== "resolved";
                                if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
                                $e05bbbf9be47623a$export$d6a66073b5d79eb3.delete(url);
                                return _context4.abrupt("return", response);
                            case 18:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this, [
                        [
                            5,
                            11
                        ]
                    ]);
                }));
                function resolveUrl(_x4) {
                    return _resolveUrl.apply(this, arguments);
                }
                return resolveUrl;
            }()
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee6(url) {
                    var _this2 = this;
                    var response, retriedResponse;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                _context6.next = 2;
                                return this.resolveUrl(url, false);
                            case 2:
                                response = _context6.sent;
                                if (!(0, $i9fQh.isSuccessfulResponse)(response)) {
                                    _context6.next = 7;
                                    break;
                                }
                                return _context6.abrupt("return", response.body);
                            case 7:
                                _context6.prev = 7;
                                _context6.next = 10;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($77Hya)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee5() {
                                    var _response;
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee5$(_context5) {
                                        while(true)switch(_context5.prev = _context5.next){
                                            case 0:
                                                if (_this2.resolvedCache[url]) {
                                                    _context5.next = 11;
                                                    break;
                                                }
                                                _context5.next = 3;
                                                return _this2.resolveUrl(url, false);
                                            case 3:
                                                _response = _context5.sent;
                                                if (!(0, $i9fQh.isSuccessfulResponse)(_response)) {
                                                    _context5.next = 8;
                                                    break;
                                                }
                                                return _context5.abrupt("return", _response);
                                            case 8:
                                                throw new Error("Retry for URL failed");
                                            case 9:
                                                _context5.next = 12;
                                                break;
                                            case 11:
                                                throw new Error("Retry unneeded - link has been resolved.");
                                            case 12:
                                            case "end":
                                                return _context5.stop();
                                        }
                                    }, _callee5);
                                })), this.retryConfig);
                            case 10:
                                retriedResponse = _context6.sent;
                                return _context6.abrupt("return", retriedResponse.body);
                            case 14:
                                _context6.prev = 14;
                                _context6.t0 = _context6["catch"](7);
                                return _context6.abrupt("return", undefined);
                            case 17:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this, [
                        [
                            7,
                            14
                        ]
                    ]);
                }));
                function prefetchData(_x5) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "isRateLimitError",
            value: function isRateLimitError(response) {
                return (0, $i9fQh.isErrorResponse)(response) && response.error.status === 429;
            }
        },
        {
            key: "fetchData",
            value: function() {
                var _fetchData = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee8(url, force) {
                    var _this3 = this;
                    var response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                _context8.next = 2;
                                return this.resolveUrl(url, force);
                            case 2:
                                response = _context8.sent;
                                if (!this.isRateLimitError(response)) {
                                    _context8.next = 7;
                                    break;
                                }
                                _context8.next = 6;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($77Hya)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee7() {
                                    var retryResponse;
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee7$(_context7) {
                                        while(true)switch(_context7.prev = _context7.next){
                                            case 0:
                                                _context7.next = 2;
                                                return _this3.resolveUrl(url, false);
                                            case 2:
                                                retryResponse = _context7.sent;
                                                if (!_this3.isRateLimitError(retryResponse)) {
                                                    _context7.next = 5;
                                                    break;
                                                }
                                                throw _this3.mapErrorResponse(retryResponse, new URL(url).hostname);
                                            case 5:
                                                return _context7.abrupt("return", retryResponse);
                                            case 6:
                                            case "end":
                                                return _context7.stop();
                                        }
                                    }, _callee7);
                                })), this.retryConfig);
                            case 6:
                                response = _context8.sent;
                            case 7:
                                if ((0, $i9fQh.isSuccessfulResponse)(response)) {
                                    _context8.next = 9;
                                    break;
                                }
                                throw this.mapErrorResponse(response, new URL(url).hostname);
                            case 9:
                                // Set a flag in the `resolvedCache` for this URL. The intent of this is
                                // to ensure that the exponential backoff method in `prefetchData` does
                                // not continue to retry fetching for this URL, especially if it was previously
                                // in a failed state. Note: this scenario only occurs on initial page load, if the
                                // user scrolls through the page very fast. Once the URL is visible, prefetching
                                // no longer takes place.
                                this.resolvedCache[url] = true;
                                // Return the JSON-LD response back up!
                                return _context8.abrupt("return", response.body);
                            case 11:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this);
                }));
                function fetchData(_x6, _x7) {
                    return _fetchData.apply(this, arguments);
                }
                return fetchData;
            }()
        },
        {
            key: "fetchDataAris",
            value: function() {
                var _fetchDataAris = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee9(aris) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                _context9.next = 2;
                                return this.batchResolveAris(aris);
                            case 2:
                                return _context9.abrupt("return", _context9.sent);
                            case 3:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this);
                }));
                function fetchDataAris(_x8) {
                    return _fetchDataAris.apply(this, arguments);
                }
                return fetchDataAris;
            }()
        },
        {
            key: "postData",
            value: function() {
                var _postData = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee10(data) {
                    var requestData;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                requestData = {
                                    key: data.key,
                                    action: data.action,
                                    context: data.context
                                };
                                _context10.next = 3;
                                return (0, $1VYkQ.request)("post", "".concat(this.resolverUrl, "/invoke"), requestData);
                            case 3:
                                return _context10.abrupt("return", _context10.sent);
                            case 4:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this);
                }));
                function postData(_x9) {
                    return _postData.apply(this, arguments);
                }
                return postData;
            }()
        },
        {
            key: "search",
            value: function() {
                var _search = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee11(data) {
                    var key, action, query, context, requestData, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                key = data.key, action = data.action; // Note: context in action is different to context in data, see types.
                                query = action.query, context = action.context;
                                requestData = {
                                    key: key,
                                    search: {
                                        query: query,
                                        context: context
                                    }
                                };
                                _context11.next = 5;
                                return (0, $1VYkQ.request)("post", "".concat(this.resolverUrl, "/invoke/search"), requestData);
                            case 5:
                                response = _context11.sent;
                                if (!(0, $i9fQh.isErrorResponse)(response)) {
                                    _context11.next = 8;
                                    break;
                                }
                                throw this.mapErrorResponse(response);
                            case 8:
                                return _context11.abrupt("return", response);
                            case 9:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this);
                }));
                function search(_x10) {
                    return _search.apply(this, arguments);
                }
                return search;
            }()
        },
        {
            key: "fetchAvailableSearchProviders",
            value: function() {
                var _fetchAvailableSearchProviders = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee12() {
                    var response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee12$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                _context12.next = 2;
                                return (0, $1VYkQ.request)("post", "".concat(this.resolverUrl, "/providers"), {
                                    type: "search"
                                });
                            case 2:
                                response = _context12.sent;
                                return _context12.abrupt("return", response.providers);
                            case 4:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, this);
                }));
                function fetchAvailableSearchProviders() {
                    return _fetchAvailableSearchProviders.apply(this, arguments);
                }
                return fetchAvailableSearchProviders;
            }()
        },
        {
            key: "mapErrorResponse",
            value: function mapErrorResponse(response) {
                var hostname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                // Catch non-200 server responses to fallback or return useful information.
                if (response !== null && response !== void 0 && response.error) {
                    var errorType = response.error.type;
                    var errorMessage = response.error.message;
                    var extensionKey = response.error.extensionKey;
                    // this means there was a network error and we fallback to blue link
                    // without impacting SLO's
                    if (response.error instanceof (0, $1VYkQ.NetworkError)) return new (0, $8GBmj.APIError)("fallback", hostname, errorMessage, errorType);
                    switch(errorType){
                        // BadRequestError - indicative of an API error, render
                        // a blue link to mitigate customer impact.
                        case "ResolveBadRequestError":
                        case "SearchBadRequestError":
                            return new (0, $8GBmj.APIError)("fallback", hostname, errorMessage, errorType, extensionKey);
                        // AuthError - if the user logs in, we may be able
                        // to recover. Render an unauthorized card.
                        case "ResolveAuthError":
                        case "SearchAuthError":
                            return new (0, $8GBmj.APIError)("auth", hostname, errorMessage, errorType, extensionKey);
                        // UnsupportedError - we do not know how to render this URL.
                        // Bail out and ask the Editor to render as a blue link.
                        case "ResolveUnsupportedError":
                        case "SearchUnsupportedError":
                            // Search isn't supported
                            return new (0, $8GBmj.APIError)("fatal", hostname, errorMessage, errorType, extensionKey);
                        case "ResolveFailedError":
                        case "SearchFailedError":
                        case "ResolveTimeoutError":
                        case "SearchTimeoutError":
                        case "SearchRateLimitError":
                        case "ResolveRateLimitError":
                        case "InternalServerError":
                            // ORS failures
                            return new (0, $8GBmj.APIError)("error", hostname, errorMessage, errorType, extensionKey);
                    }
                    if ((0, $f0KmV.fg)("map_new_ors_generic_error_types_in_link_provider")) switch(errorType){
                        case "BadRequestError":
                            return new (0, $8GBmj.APIError)("fallback", hostname, errorMessage, errorType, extensionKey);
                        case "AuthError":
                            return new (0, $8GBmj.APIError)("auth", hostname, errorMessage, errorType, extensionKey);
                        case "UnsupportedError":
                            // URL isn't supported
                            return new (0, $8GBmj.APIError)("fatal", hostname, errorMessage, errorType, extensionKey);
                        case "TimeoutError":
                        case "RateLimitError":
                            return new (0, $8GBmj.APIError)("error", hostname, errorMessage, errorType, extensionKey);
                    }
                }
                // Catch all: we don't know this error, bail out.
                var _ref6 = response || {}, error = _ref6.error, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref6, $e05bbbf9be47623a$var$_excluded);
                return new (0, $8GBmj.APIError)("fatal", hostname, // reason we stringify the error differently is because
                // JSON.stringify will return "{}" if it is an instance of Error
                // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
                // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
                // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
                // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
                // we assume 'rest'  to "serializable" meaning all its properties are enumerable
                response ? "".concat(this.stringifyError(error), " ").concat(JSON.stringify(rest)) : "Response undefined", "UnexpectedError");
            }
        },
        {
            key: "stringifyError",
            value: function stringifyError(err) {
                /**
       * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
       * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
       * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
       * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
       */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
                (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(err) === "object" ? Object.getOwnPropertyNames(err) : undefined);
            }
        }
    ]);
    return CardClient;
}();

});
parcelRegister("4mVfk", function(module, exports) {
function $32e59f6e0af762b3$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $32e59f6e0af762b3$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $32e59f6e0af762b3$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $32e59f6e0af762b3$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $32e59f6e0af762b3$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8DpVo", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $649613577020f26f$var$runtime = (parcelRequire("c9lpw"))();
module.exports = $649613577020f26f$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $649613577020f26f$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $649613577020f26f$var$runtime;
    else Function("r", "regeneratorRuntime = r")($649613577020f26f$var$runtime);
}

});
parcelRegister("c9lpw", function(module, exports) {

var $340K4 = parcelRequire("340K4");
var $8d86eefd7dcf9e13$var$_typeof = $340K4.default;
function $8d86eefd7dcf9e13$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $8d86eefd7dcf9e13$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $8d86eefd7dcf9e13$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($8d86eefd7dcf9e13$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $8d86eefd7dcf9e13$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hdcxN", function(module, exports) {

var $8ovux = parcelRequire("8ovux");
(function(global1, undefined) {
    "use strict";
    if (global1.setImmediate) return;
    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global1.document;
    var registerImmediate;
    function setImmediate(callback) {
        // Callback can either be a function or a string
        if (typeof callback !== "function") callback = new Function("" + callback);
        // Copy function arguments
        var args = new Array(arguments.length - 1);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i + 1];
        // Store and register the task
        var task = {
            callback: callback,
            args: args
        };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
    }
    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }
    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch(args.length){
            case 0:
                callback();
                break;
            case 1:
                callback(args[0]);
                break;
            case 2:
                callback(args[0], args[1]);
                break;
            case 3:
                callback(args[0], args[1], args[2]);
                break;
            default:
                callback.apply(undefined, args);
                break;
        }
    }
    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
        // "too much recursion" error.
        setTimeout(runIfPresent, 0, handle);
        else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally{
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }
    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            $8ovux.nextTick(function() {
                runIfPresent(handle);
            });
        };
    }
    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global1.postMessage && !global1.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global1.onmessage;
            global1.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global1.postMessage("", "*");
            global1.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }
    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global1 && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) runIfPresent(+event.data.slice(messagePrefix.length));
        };
        if (global1.addEventListener) global1.addEventListener("message", onGlobalMessage, false);
        else global1.attachEvent("onmessage", onGlobalMessage);
        registerImmediate = function(handle) {
            global1.postMessage(messagePrefix + handle, "*");
        };
    }
    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };
        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }
    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function() {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }
    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }
    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global1);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global1;
    // Don't get fooled by e.g. browserify environments.
    if (({}).toString.call(global1.process) === "[object process]") // For Node.js before 0.9
    installNextTickImplementation();
    else if (canUsePostMessage()) // For non-IE10 modern browsers
    installPostMessageImplementation();
    else if (global1.MessageChannel) // For web workers, where supported
    installMessageChannelImplementation();
    else if (doc && "onreadystatechange" in doc.createElement("script")) // For IE 6–8
    installReadyStateChangeImplementation();
    else // For older browsers
    installSetTimeoutImplementation();
    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof $parcel$global === "undefined" ? module.exports : $parcel$global : self);

});

parcelRegister("ht5OE", function(module, exports) {

var $8ovux = parcelRequire("8ovux");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $cb79a803bd670424$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== "function") throw new TypeError("DataLoader must be constructed with a function which accepts " + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $cb79a803bd670424$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $cb79a803bd670424$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $cb79a803bd670424$var$getValidCacheKeyFn(options);
        this._cacheMap = $cb79a803bd670424$var$getValidCacheMap(options);
        this._batch = null;
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError("The loader.load() function must be called with a value," + ("but got: " + String(key) + "."));
        var batch = $cb79a803bd670424$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        return resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$cb79a803bd670424$var$isArrayLike(keys)) throw new TypeError("The loader.loadMany() function must be called with Array<key> " + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    };
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $cb79a803bd670424$var$enqueuePostPromiseJob = typeof $8ovux === "object" && typeof $8ovux.nextTick === "function" ? function(fn) {
    if (!$cb79a803bd670424$var$resolvedPromise) $cb79a803bd670424$var$resolvedPromise = Promise.resolve();
    $cb79a803bd670424$var$resolvedPromise.then(function() {
        return $8ovux.nextTick(fn);
    });
} : setImmediate || setTimeout; // Private: cached resolved Promise instance
var $cb79a803bd670424$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $cb79a803bd670424$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize && (!existingBatch.cacheHits || existingBatch.cacheHits.length < loader._maxBatchSize)) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        return $cb79a803bd670424$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $cb79a803bd670424$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $cb79a803bd670424$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise = loader._batchLoadFn(batch.keys); // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== "function") return $cb79a803bd670424$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$cb79a803bd670424$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $cb79a803bd670424$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        return $cb79a803bd670424$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $cb79a803bd670424$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $cb79a803bd670424$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $cb79a803bd670424$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $cb79a803bd670424$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== "number" || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $cb79a803bd670424$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $cb79a803bd670424$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== "function") throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $cb79a803bd670424$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== "function") throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $cb79a803bd670424$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            "get",
            "set",
            "delete",
            "clear"
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== "function";
        });
        if (missingFunctions.length !== 0) throw new TypeError("Custom cacheMap missing methods: " + missingFunctions.join(", "));
    }
    return cacheMap;
} // Private
function $cb79a803bd670424$var$isArrayLike(x) {
    return typeof x === "object" && x !== null && typeof x.length === "number" && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $cb79a803bd670424$var$DataLoader;

});

parcelRegister("77Hya", function(module, exports) {
// Packages

var $7HNTh = parcelRequire("7HNTh");
function $52faf7ff7ca32f4d$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!("randomize" in options)) options.randomize = true;
        op = $7HNTh.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error("Aborted"));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $52faf7ff7ca32f4d$var$retry;

});
parcelRegister("7HNTh", function(module, exports) {

module.exports = (parcelRequire("eJrXF"));

});
parcelRegister("eJrXF", function(module, exports) {

var $j6E1n = parcelRequire("j6E1n");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $j6E1n(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error("minTimeout is greater than maxTimeout");
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === "function") methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("j6E1n", function(module, exports) {
function $de8d9f3d7450d76c$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === "boolean") options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $de8d9f3d7450d76c$var$RetryOperation;
$de8d9f3d7450d76c$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$de8d9f3d7450d76c$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$de8d9f3d7450d76c$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error("RetryOperation timeout occurred"));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$de8d9f3d7450d76c$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$de8d9f3d7450d76c$var$RetryOperation.prototype.try = function(fn) {
    console.log("Using RetryOperation.try() is deprecated");
    this.attempt(fn);
};
$de8d9f3d7450d76c$var$RetryOperation.prototype.start = function(fn) {
    console.log("Using RetryOperation.start() is deprecated");
    this.attempt(fn);
};
$de8d9f3d7450d76c$var$RetryOperation.prototype.start = $de8d9f3d7450d76c$var$RetryOperation.prototype.try;
$de8d9f3d7450d76c$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$de8d9f3d7450d76c$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$de8d9f3d7450d76c$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRegister("4OBz4", function(module, exports) {
"use strict";
class $3818f8807cf08d8f$var$AbortError extends Error {
    constructor(){
        super("Throttled function aborted");
        this.name = "AbortError";
    }
}
const $3818f8807cf08d8f$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError("Expected `limit` to be a finite number");
    if (!Number.isFinite(interval)) throw new TypeError("Expected `interval` to be a finite number");
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $3818f8807cf08d8f$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $3818f8807cf08d8f$var$pThrottle;
module.exports.AbortError = $3818f8807cf08d8f$var$AbortError;

});

parcelRegister("8GBmj", function(module, exports) {

$parcel$export(module.exports, "APIError", function () { return $652f39a5c7452035$export$3e5b797e39668f84; });

var $eVDe4 = parcelRequire("eVDe4");

var $uqRmf = parcelRequire("uqRmf");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $6FnrE = parcelRequire("6FnrE");
function $652f39a5c7452035$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $652f39a5c7452035$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $652f39a5c7452035$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($652f39a5c7452035$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $652f39a5c7452035$export$3e5b797e39668f84 = /*#__PURE__*/ function(_Error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(APIError, _Error);
    var _super = $652f39a5c7452035$var$_createSuper(APIError);
    function APIError(kind, hostname, message, type, extensionKey) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, APIError);
        _this = _super.call(this, "".concat(kind, ": ").concat(message));
        _this.kind = kind;
        _this.hostname = hostname;
        _this.message = message;
        _this.type = type;
        _this.extensionKey = extensionKey;
        _this.name = "APIError";
        // The error type received from the server.
        _this.type = type;
        // The kind mapped to on the client.
        _this.kind = kind;
        // The message received from the server.
        _this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        _this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        _this.extensionKey = extensionKey;
        return _this;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(APIError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6FnrE)))(Error));

});
parcelRegister("6FnrE", function(module, exports) {

var $lH0U2 = parcelRequire("lH0U2");

var $ivwvu = parcelRequire("ivwvu");

var $k7ov8 = parcelRequire("k7ov8");

var $fgvGZ = parcelRequire("fgvGZ");
function $4da8c21827ebf75d$var$_wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return module.exports = $4da8c21827ebf75d$var$_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !$k7ov8(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return $fgvGZ(t, arguments, $lH0U2(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $ivwvu(Wrapper, t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $4da8c21827ebf75d$var$_wrapNativeSuper(t);
}
module.exports = $4da8c21827ebf75d$var$_wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("k7ov8", function(module, exports) {
function $ea5777873f3a7580$var$_isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
module.exports = $ea5777873f3a7580$var$_isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fgvGZ", function(module, exports) {

var $ajVGk = parcelRequire("ajVGk");

var $ivwvu = parcelRequire("ivwvu");
function $b1d0ef16f2e1ad70$var$_construct(t, e, r) {
    if ($ajVGk()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $ivwvu(p, r.prototype), p;
}
module.exports = $b1d0ef16f2e1ad70$var$_construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ajVGk", function(module, exports) {
function $78386c240e80c646$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $78386c240e80c646$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $78386c240e80c646$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("c24b4", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", function () { return $8c28e9881055d984$export$f654b28f82155665; });
$parcel$export(module.exports, "getResolverUrl", function () { return $8c28e9881055d984$export$dc37652c1696f231; });
var $8c28e9881055d984$var$devBaseUrl = "https://api-private.dev.atlassian.com";
var $8c28e9881055d984$var$stgBaseUrl = "https://pug.jira-dev.com/gateway/api";
var $8c28e9881055d984$var$prodBaseUrl = "https://api-private.atlassian.com";
var $8c28e9881055d984$export$e2b040f052407032 = {
    dev: $8c28e9881055d984$var$devBaseUrl,
    development: $8c28e9881055d984$var$devBaseUrl,
    stg: $8c28e9881055d984$var$stgBaseUrl,
    staging: $8c28e9881055d984$var$stgBaseUrl,
    prd: $8c28e9881055d984$var$prodBaseUrl,
    prod: $8c28e9881055d984$var$prodBaseUrl,
    production: $8c28e9881055d984$var$prodBaseUrl
};
var $8c28e9881055d984$export$f654b28f82155665 = function getBaseUrl(envKey) {
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $8c28e9881055d984$export$e2b040f052407032 ? $8c28e9881055d984$export$e2b040f052407032[envKey] : $8c28e9881055d984$var$prodBaseUrl;
    // Otherwise, use the current origin of the page.
    return typeof window.location !== "undefined" ? window.location.origin : "";
};
var $8c28e9881055d984$export$dc37652c1696f231 = function getResolverUrl(envKey, baseUrlOverride) {
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        var baseUrl = baseUrlOverride || $8c28e9881055d984$export$f654b28f82155665(envKey);
        return "".concat(baseUrl, "/object-resolver");
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return "/gateway/api/object-resolver";
};
var $8c28e9881055d984$export$2e2bcd8739ae039 = $8c28e9881055d984$export$e2b040f052407032;

});

parcelRegister("1VYkQ", function(module, exports) {

$parcel$export(module.exports, "NetworkError", function () { return $1689eaa6dda3ae49$export$bae979e68e4dc802; });
$parcel$export(module.exports, "request", function () { return $1689eaa6dda3ae49$export$b5fe3f66a567bec0; });

var $kFnE9 = parcelRequire("kFnE9");

var $4mVfk = parcelRequire("4mVfk");

var $eVDe4 = parcelRequire("eVDe4");

var $uqRmf = parcelRequire("uqRmf");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $6FnrE = parcelRequire("6FnrE");

var $8DpVo = parcelRequire("8DpVo");
function $1689eaa6dda3ae49$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1689eaa6dda3ae49$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1689eaa6dda3ae49$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1689eaa6dda3ae49$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1689eaa6dda3ae49$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1689eaa6dda3ae49$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $1689eaa6dda3ae49$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1689eaa6dda3ae49$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $1689eaa6dda3ae49$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
var $1689eaa6dda3ae49$export$bae979e68e4dc802 = /*#__PURE__*/ function(_Error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(NetworkError, _Error);
    var _super = $1689eaa6dda3ae49$var$_createSuper(NetworkError);
    function NetworkError(error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, NetworkError);
        return _super.call(this, error);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(NetworkError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6FnrE)))(Error));
function $1689eaa6dda3ae49$export$b5fe3f66a567bec0(_x, _x2, _x3, _x4) {
    return $1689eaa6dda3ae49$var$_request.apply(this, arguments);
}
function $1689eaa6dda3ae49$var$_request() {
    $1689eaa6dda3ae49$var$_request = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee(method, url, data, headers) {
        var statuses, requestConfig, response, text, _args = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    statuses = _args.length > 4 && _args[4] !== undefined ? _args[4] : $1689eaa6dda3ae49$var$ALLOWED_RESPONSE_STATUS_CODES;
                    requestConfig = $1689eaa6dda3ae49$var$_objectSpread({
                        method: method,
                        credentials: "include",
                        headers: $1689eaa6dda3ae49$var$_objectSpread({
                            Accept: "application/json",
                            "Cache-Control": "no-cache",
                            "Content-Type": "application/json"
                        }, headers)
                    }, data ? {
                        body: JSON.stringify(data)
                    } : {});
                    _context.prev = 2;
                    _context.next = 5;
                    return fetch(url, requestConfig);
                case 5:
                    response = _context.sent;
                    if (!(response.ok || statuses !== null && statuses !== void 0 && statuses.includes(response.status))) {
                        _context.next = 17;
                        break;
                    }
                    if (!statuses.includes(204)) {
                        _context.next = 14;
                        break;
                    }
                    _context.next = 10;
                    return response.text();
                case 10:
                    text = _context.sent;
                    return _context.abrupt("return", text ? JSON.parse(text) : undefined);
                case 14:
                    _context.next = 16;
                    return response.json();
                case 16:
                    return _context.abrupt("return", _context.sent);
                case 17:
                    throw response;
                case 20:
                    _context.prev = 20;
                    _context.t0 = _context["catch"](2);
                    if (!(typeof _context.t0 === "string" || _context.t0 instanceof TypeError)) {
                        _context.next = 24;
                        break;
                    }
                    throw new $1689eaa6dda3ae49$export$bae979e68e4dc802(_context.t0);
                case 24:
                    throw _context.t0;
                case 25:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                2,
                20
            ]
        ]);
    }));
    return $1689eaa6dda3ae49$var$_request.apply(this, arguments);
}

});

parcelRegister("i9fQh", function(module, exports) {

$parcel$export(module.exports, "isSuccessfulResponse", function () { return $d3655b36d3bcfdd5$export$1b59fe731a28a49d; });
$parcel$export(module.exports, "isErrorResponse", function () { return $d3655b36d3bcfdd5$export$bea7bee8a87e7c52; });
var $d3655b36d3bcfdd5$export$1b59fe731a28a49d = function isSuccessfulResponse(response) {
    if (!response) return false;
    var hasSuccessfulStatus = response.status === 200;
    var hasSuccessBody = "body" in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
var $d3655b36d3bcfdd5$export$bea7bee8a87e7c52 = function isErrorResponse(response) {
    if (!response) return false;
    var hasStatus = "status" in response && response.status >= 200;
    var hasErrorBody = "error" in response;
    return hasStatus && hasErrorBody;
};

});

parcelRegister("rE472", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});

parcelRegister("f0KmV", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $aedad2ff1b9342a1$export$b40ec24ac8275656; });

var $hFF9r = parcelRequire("hFF9r");
function $aedad2ff1b9342a1$export$ba05d765b8392e5e(flagResolver) {
    (0, $hFF9r.setBooleanResolver)(flagResolver);
}
function $aedad2ff1b9342a1$export$470e5c2be1411c89(name) {
    return (0, $hFF9r.resolveBooleanFlag)(name);
}
function $aedad2ff1b9342a1$export$b40ec24ac8275656(name) {
    return (0, $hFF9r.resolveBooleanFlag)(name);
}

});
parcelRegister("hFF9r", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $cdd62fcaca8904d9$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $cdd62fcaca8904d9$export$6333b6aff9fc6275; });

var $3gocj = parcelRequire("3gocj");

var $8ovux = parcelRequire("8ovux");
var $cdd62fcaca8904d9$var$pkgName = "@atlaskit/platform-feature-flags";
var $cdd62fcaca8904d9$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $cdd62fcaca8904d9$var$hasProcessEnv = typeof $8ovux !== "undefined" && typeof $8ovux.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $cdd62fcaca8904d9$var$ENV_ENABLE_PLATFORM_FF = $cdd62fcaca8904d9$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $cdd62fcaca8904d9$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $cdd62fcaca8904d9$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $cdd62fcaca8904d9$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $cdd62fcaca8904d9$var$ENV_ENABLE_PLATFORM_FF || $cdd62fcaca8904d9$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $cdd62fcaca8904d9$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $cdd62fcaca8904d9$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$cdd62fcaca8904d9$var$globalVar[$cdd62fcaca8904d9$export$7e41b1b2bdee3f98] = $cdd62fcaca8904d9$var$globalVar[$cdd62fcaca8904d9$export$7e41b1b2bdee3f98] || $cdd62fcaca8904d9$var$DEFAULT_PFF_GLOBAL;
function $cdd62fcaca8904d9$export$f2b591175b3e424c(resolver) {
    $cdd62fcaca8904d9$var$globalVar[$cdd62fcaca8904d9$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $cdd62fcaca8904d9$export$6333b6aff9fc6275(flagKey) {
    if ($cdd62fcaca8904d9$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $3gocj.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $cdd62fcaca8904d9$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $cdd62fcaca8904d9$var$globalVar[$cdd62fcaca8904d9$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("3gocj", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $2605a2d7ef88c3a5$export$1c9f709888824e05; });
var $2605a2d7ef88c3a5$var$_ref, $2605a2d7ef88c3a5$var$_process, $2605a2d7ef88c3a5$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $2605a2d7ef88c3a5$var$TESTS_MODE = ($2605a2d7ef88c3a5$var$_ref = (globalThis === null || globalThis === void 0 || ($2605a2d7ef88c3a5$var$_process = globalThis.process) === null || $2605a2d7ef88c3a5$var$_process === void 0 || ($2605a2d7ef88c3a5$var$_process = $2605a2d7ef88c3a5$var$_process.env) === null || $2605a2d7ef88c3a5$var$_process === void 0 ? void 0 : $2605a2d7ef88c3a5$var$_process.JEST_WORKER_ID) !== undefined, $2605a2d7ef88c3a5$var$_ref !== void 0) ? $2605a2d7ef88c3a5$var$_ref : false;
var $2605a2d7ef88c3a5$var$DEBUG_MODE = !$2605a2d7ef88c3a5$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($2605a2d7ef88c3a5$var$_process2 = globalThis.process) === null || $2605a2d7ef88c3a5$var$_process2 === void 0 || ($2605a2d7ef88c3a5$var$_process2 = $2605a2d7ef88c3a5$var$_process2.env) === null || $2605a2d7ef88c3a5$var$_process2 === void 0 ? void 0 : $2605a2d7ef88c3a5$var$_process2.NODE_ENV) !== "production";
var $2605a2d7ef88c3a5$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$2605a2d7ef88c3a5$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});





parcelRegister("kBIj3", function(module, exports) {

$parcel$export(module.exports, "TargetConsumer", function () { return $f009a1ad03207a26$export$f643dd64c1952cc8; });
$parcel$export(module.exports, "SpotlightConsumer", function () { return $f009a1ad03207a26$export$3503199acd121708; });
$parcel$export(module.exports, "default", function () { return $f009a1ad03207a26$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $1Db2R = parcelRequire("1Db2R");

var $8p2GL = parcelRequire("8p2GL");

var $97YIy = parcelRequire("97YIy");

var $aP6k3 = parcelRequire("aP6k3");

var $1GLSi = parcelRequire("1GLSi");

var $4b221 = parcelRequire("4b221");

var $8ovux = parcelRequire("8ovux");
function $f009a1ad03207a26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f009a1ad03207a26$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f009a1ad03207a26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f009a1ad03207a26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f009a1ad03207a26$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f009a1ad03207a26$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $f009a1ad03207a26$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f009a1ad03207a26$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $f009a1ad03207a26$var$_createContext = /*#__PURE__*/ (0, $9nHZC.createContext)(undefined), $f009a1ad03207a26$export$f643dd64c1952cc8 = $f009a1ad03207a26$var$_createContext.Consumer, $f009a1ad03207a26$var$TargetProvider = $f009a1ad03207a26$var$_createContext.Provider;
var $f009a1ad03207a26$export$7b5aa0f5b37a336d = /*#__PURE__*/ (0, $9nHZC.createContext)({
    opened: (0, $8p2GL.default),
    closed: (0, $8p2GL.default),
    targets: {}
});
var $f009a1ad03207a26$export$3503199acd121708 = $f009a1ad03207a26$export$7b5aa0f5b37a336d.Consumer, $f009a1ad03207a26$var$SpotlightStateProvider = $f009a1ad03207a26$export$7b5aa0f5b37a336d.Provider;
var $f009a1ad03207a26$var$Container = function Container(_ref) {
    var Wrapper = _ref.component, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Wrapper, null, children);
};
/**
 * __Spotlight manager__
 *
 * A spotlight manager manages the visibility of spotlights used to introduce new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ var $f009a1ad03207a26$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_PureComponent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(SpotlightManager, _PureComponent);
    var _super = $f009a1ad03207a26$var$_createSuper(SpotlightManager);
    function SpotlightManager() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, SpotlightManager);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "state", {
            spotlightCount: 0,
            targets: {}
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "targetRef", function(name) {
            return function(element) {
                _this.setState(function(state) {
                    return {
                        targets: $f009a1ad03207a26$var$_objectSpread($f009a1ad03207a26$var$_objectSpread({}, state.targets), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, name, element || undefined))
                    };
                });
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "spotlightOpen", function() {
            _this.setState(function(state) {
                return {
                    spotlightCount: state.spotlightCount + 1
                };
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "spotlightClose", function() {
            _this.setState(function(state) {
                return {
                    spotlightCount: state.spotlightCount - 1
                };
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getStateProviderValue", (0, $1Db2R.default)(function(targets) {
            return {
                opened: _this.spotlightOpen,
                closed: _this.spotlightClose,
                targets: targets
            };
        }));
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(SpotlightManager, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                typeof $8ovux;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, blanketIsTinted = _this$props.blanketIsTinted, children = _this$props.children, Tag = _this$props.component, onBlanketClicked = _this$props.onBlanketClicked;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($f009a1ad03207a26$var$SpotlightStateProvider, {
                    value: this.getStateProviderValue(this.state.targets)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($f009a1ad03207a26$var$TargetProvider, {
                    value: this.targetRef
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($f009a1ad03207a26$var$Container, {
                    component: Tag || (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $4b221.Fade), {
                    hasEntered: this.state.spotlightCount > 0
                }, function(animationStyles) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $97YIy.default), {
                        zIndex: (0, $aP6k3.layers).spotlight()
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $1GLSi.default), {
                        style: animationStyles,
                        isTinted: blanketIsTinted,
                        onBlanketClicked: onBlanketClicked
                    }));
                }), children)));
            }
        }
    ]);
    return SpotlightManager;
}((0, $9nHZC.PureComponent));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($f009a1ad03207a26$export$2e2bcd8739ae039, "defaultProps", {
    blanketIsTinted: true
});

});
parcelRegister("1Db2R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13020045c173b97a$export$2e2bcd8739ae039; });
var $13020045c173b97a$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $13020045c173b97a$var$isEqual(first, second) {
    if (first === second) return true;
    if ($13020045c173b97a$var$safeIsNaN(first) && $13020045c173b97a$var$safeIsNaN(second)) return true;
    return false;
}
function $13020045c173b97a$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$13020045c173b97a$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $13020045c173b97a$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $13020045c173b97a$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});

parcelRegister("8p2GL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61e2be6f7c724b60$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $61e2be6f7c724b60$export$2e2bcd8739ae039() {}

});

parcelRegister("97YIy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a53ddc37fdb6f55$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $ftJv5 = parcelRequire("ftJv5");

var $p2ZyH = parcelRequire("p2ZyH");

var $hYGKC = parcelRequire("hYGKC");

var $kjvwg = parcelRequire("kjvwg");

var $4uVg3 = parcelRequire("4uVg3");
function $6a53ddc37fdb6f55$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? "effect" : _ref$mountStrategy;
    var isSubsequentRender = (0, $kjvwg.default)(mountStrategy);
    (0, $4uVg3.default)(zIndex);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return !(0, $ftJv5.fg)("dsp-19516-design-system-portal-logic-update") ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $p2ZyH.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $hYGKC.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("ftJv5", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $b44cdbe403047ddc$export$b40ec24ac8275656; });

var $8AO5i = parcelRequire("8AO5i");
function $b44cdbe403047ddc$export$ba05d765b8392e5e(flagResolver) {
    (0, $8AO5i.setBooleanResolver)(flagResolver);
}
function $b44cdbe403047ddc$export$470e5c2be1411c89(name) {
    return (0, $8AO5i.resolveBooleanFlag)(name);
}
function $b44cdbe403047ddc$export$b40ec24ac8275656(name) {
    return (0, $8AO5i.resolveBooleanFlag)(name);
}

});
parcelRegister("8AO5i", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $6418894218a6514b$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $6418894218a6514b$export$6333b6aff9fc6275; });

var $gTvWm = parcelRequire("gTvWm");

var $8ovux = parcelRequire("8ovux");
var $6418894218a6514b$var$pkgName = "@atlaskit/platform-feature-flags";
var $6418894218a6514b$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $6418894218a6514b$var$hasProcessEnv = typeof $8ovux !== "undefined" && typeof $8ovux.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $6418894218a6514b$var$ENV_ENABLE_PLATFORM_FF = $6418894218a6514b$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $6418894218a6514b$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $6418894218a6514b$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $6418894218a6514b$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $6418894218a6514b$var$ENV_ENABLE_PLATFORM_FF || $6418894218a6514b$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $6418894218a6514b$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $6418894218a6514b$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$6418894218a6514b$var$globalVar[$6418894218a6514b$export$7e41b1b2bdee3f98] = $6418894218a6514b$var$globalVar[$6418894218a6514b$export$7e41b1b2bdee3f98] || $6418894218a6514b$var$DEFAULT_PFF_GLOBAL;
function $6418894218a6514b$export$f2b591175b3e424c(resolver) {
    $6418894218a6514b$var$globalVar[$6418894218a6514b$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $6418894218a6514b$export$6333b6aff9fc6275(flagKey) {
    if ($6418894218a6514b$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $gTvWm.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $6418894218a6514b$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $6418894218a6514b$var$globalVar[$6418894218a6514b$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("gTvWm", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $c4ca8f179bd5d1df$export$1c9f709888824e05; });
var $c4ca8f179bd5d1df$var$_ref, $c4ca8f179bd5d1df$var$_process, $c4ca8f179bd5d1df$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $c4ca8f179bd5d1df$var$TESTS_MODE = ($c4ca8f179bd5d1df$var$_ref = (globalThis === null || globalThis === void 0 || ($c4ca8f179bd5d1df$var$_process = globalThis.process) === null || $c4ca8f179bd5d1df$var$_process === void 0 || ($c4ca8f179bd5d1df$var$_process = $c4ca8f179bd5d1df$var$_process.env) === null || $c4ca8f179bd5d1df$var$_process === void 0 ? void 0 : $c4ca8f179bd5d1df$var$_process.JEST_WORKER_ID) !== undefined, $c4ca8f179bd5d1df$var$_ref !== void 0) ? $c4ca8f179bd5d1df$var$_ref : false;
var $c4ca8f179bd5d1df$var$DEBUG_MODE = !$c4ca8f179bd5d1df$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($c4ca8f179bd5d1df$var$_process2 = globalThis.process) === null || $c4ca8f179bd5d1df$var$_process2 === void 0 || ($c4ca8f179bd5d1df$var$_process2 = $c4ca8f179bd5d1df$var$_process2.env) === null || $c4ca8f179bd5d1df$var$_process2 === void 0 ? void 0 : $c4ca8f179bd5d1df$var$_process2.NODE_ENV) !== "production";
var $c4ca8f179bd5d1df$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$c4ca8f179bd5d1df$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("p2ZyH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04b4a80a3997303c$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $lnOmc = parcelRequire("lnOmc");

var $31uCb = parcelRequire("31uCb");
function $04b4a80a3997303c$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $9nHZC.useMemo)(function() {
        return (0, $31uCb.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $31uCb.appendPortalContainerIfNotAppended)(container);
    (0, $9nHZC.useEffect)(function() {
        return function() {
            (0, $31uCb.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $lnOmc.createPortal)(children, container);
}

});
parcelRegister("31uCb", function(module, exports) {

$parcel$export(module.exports, "createContainer", function () { return $233936914469b43c$export$26ae5ca175b4ec5a; });
$parcel$export(module.exports, "removePortalContainer", function () { return $233936914469b43c$export$da99f98bf3fe55b3; });
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", function () { return $233936914469b43c$export$c582005add11e141; });
$parcel$export(module.exports, "createAtlaskitPortal", function () { return $233936914469b43c$export$fef014d7cef9e543; });
$parcel$export(module.exports, "createPortalParent", function () { return $233936914469b43c$export$95029ca7aca2989e; });

var $2F5ub = parcelRequire("2F5ub");
var $233936914469b43c$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement("div");
    container.className = (0, $2F5ub.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $233936914469b43c$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $233936914469b43c$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $2F5ub.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement("div");
        parent.className = (0, $2F5ub.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = "flex";
        (_getBody = $233936914469b43c$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $233936914469b43c$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $233936914469b43c$var$getPortalParent().removeChild(container);
};
var $233936914469b43c$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $233936914469b43c$var$getPortalParent().appendChild(container);
};
var $233936914469b43c$export$842dfe7a9f24298 = function isDocumentDefined() {
    return document !== undefined;
};
var $233936914469b43c$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($233936914469b43c$export$842dfe7a9f24298()) {
        var atlaskitportal = document.createElement("div");
        atlaskitportal.className = (0, $2F5ub.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $233936914469b43c$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($233936914469b43c$export$842dfe7a9f24298()) {
        var parentElement = document.querySelector((0, $2F5ub.portalParentSelector));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement("div");
            parent.className = (0, $2F5ub.portalParentClassName);
            parent.style.display = "flex";
            (_getBody2 = $233936914469b43c$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};

});
parcelRegister("2F5ub", function(module, exports) {

$parcel$export(module.exports, "portalParentClassName", function () { return $1f03aa80d44176d6$export$e4c79eb95c23a0da; });
$parcel$export(module.exports, "portalParentSelector", function () { return $1f03aa80d44176d6$export$72f415121273627e; });
$parcel$export(module.exports, "portalClassName", function () { return $1f03aa80d44176d6$export$13f57c02915787b3; });
var $1f03aa80d44176d6$export$e4c79eb95c23a0da = "atlaskit-portal-container";
var $1f03aa80d44176d6$export$72f415121273627e = "body > .atlaskit-portal-container";
var $1f03aa80d44176d6$export$13f57c02915787b3 = "atlaskit-portal";

});



parcelRegister("hYGKC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d16933b6739ba3cb$export$2e2bcd8739ae039; });

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $lnOmc = parcelRequire("lnOmc");

var $fdvyD = parcelRequire("fdvyD");

var $31uCb = parcelRequire("31uCb");
function $d16933b6739ba3cb$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $9nHZC.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $fdvyD.useIsomorphicLayoutEffect)(function() {
        var tempPortalContainer = (0, $31uCb.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $31uCb.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    return atlaskitPortal ? /*#__PURE__*/ (0, $lnOmc.createPortal)(children, atlaskitPortal) : null;
}

});
parcelRegister("9q1kH", function(module, exports) {

var $ZIKor = parcelRequire("ZIKor");

var $avQiy = parcelRequire("avQiy");

var $fWTDc = parcelRequire("fWTDc");

var $8qOET = parcelRequire("8qOET");
function $6db7936d3372e7ed$var$_slicedToArray(r, e) {
    return $ZIKor(r) || $avQiy(r, e) || $fWTDc(r, e) || $8qOET();
}
module.exports = $6db7936d3372e7ed$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ZIKor", function(module, exports) {
function $0b98687f4ee9bf29$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $0b98687f4ee9bf29$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("avQiy", function(module, exports) {
function $7a755e0122dd4cc8$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $7a755e0122dd4cc8$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8qOET", function(module, exports) {
function $62380c26773a00d2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $62380c26773a00d2$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fdvyD", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $b1408c98b36a96af$export$700979bc83e7db82; });

var $9nHZC = parcelRequire("9nHZC");
var $b1408c98b36a96af$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $9nHZC.useLayoutEffect) : (0, $9nHZC.useEffect);

});


parcelRegister("kjvwg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec9e08181b45e750$export$2e2bcd8739ae039; });

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $fdvyD = parcelRequire("fdvyD");
var $ec9e08181b45e750$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $9nHZC.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $9nHZC.useState)(function() {
        return mountStrategy === "layoutEffect" ? (0, $fdvyD.useIsomorphicLayoutEffect) : (0, $9nHZC.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $ec9e08181b45e750$export$2e2bcd8739ae039 = $ec9e08181b45e750$var$useIsSubsequentRender;

});

parcelRegister("4uVg3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $346660fb75267ee2$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $eGIUw = parcelRequire("eGIUw");

var $ldXTU = parcelRequire("ldXTU");
var $346660fb75267ee2$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $9nHZC.useEffect)(function() {
        (0, $ldXTU.default)((0, $eGIUw.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $ldXTU.default)((0, $eGIUw.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $346660fb75267ee2$export$2e2bcd8739ae039 = $346660fb75267ee2$var$useFirePortalEvent;

});
parcelRegister("eGIUw", function(module, exports) {

$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", function () { return $ab17d33e2e1bb01a$export$ed5835cc67e87f72; });
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", function () { return $ab17d33e2e1bb01a$export$80816bd900e5bd00; });
var $ab17d33e2e1bb01a$export$ed5835cc67e87f72 = "akPortalMount";
var $ab17d33e2e1bb01a$export$80816bd900e5bd00 = "akPortalUnmount";

});

parcelRegister("ldXTU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f73946eba2dc487d$export$2e2bcd8739ae039; });
var $f73946eba2dc487d$var$zIndexToName = {
    100: "card",
    200: "navigation",
    300: "dialog",
    400: "layer",
    500: "blanket",
    510: "modal",
    600: "flag",
    700: "spotlight",
    9999: "tooltip"
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $f73946eba2dc487d$var$getLayerName = function getLayerName(zIndex) {
    return $f73946eba2dc487d$var$zIndexToName.hasOwnProperty(zIndex) ? $f73946eba2dc487d$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $f73946eba2dc487d$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $f73946eba2dc487d$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $f73946eba2dc487d$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $f73946eba2dc487d$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("aP6k3", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $7e1392527dfcea6f$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $7e1392527dfcea6f$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $7e1392527dfcea6f$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "borderRadius", function () { return $7e1392527dfcea6f$export$7a57f79000377ca2; });
$parcel$export(module.exports, "gridSize", function () { return $7e1392527dfcea6f$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "fontSize", function () { return $7e1392527dfcea6f$export$85e3c3ca0c6fb93; });
$parcel$export(module.exports, "fontSizeSmall", function () { return $7e1392527dfcea6f$export$6746fe0d9c9fab54; });
$parcel$export(module.exports, "fontFamily", function () { return $7e1392527dfcea6f$export$a5975749f0374264; });
$parcel$export(module.exports, "codeFontFamily", function () { return $7e1392527dfcea6f$export$356129969ee49c55; });
$parcel$export(module.exports, "layers", function () { return $7e1392527dfcea6f$export$7be255094ccdc533; });
$parcel$export(module.exports, "visuallyHidden", function () { return $7e1392527dfcea6f$export$a1b3edb637fb4f35; });
$parcel$export(module.exports, "skeletonShimmer", function () { return $7e1392527dfcea6f$export$e497e856b4f89fcd; });

var $1OnrY = parcelRequire("1OnrY");

var $jp7ng = parcelRequire("jp7ng");
var $7e1392527dfcea6f$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $7e1392527dfcea6f$export$c93026a968943f95 = "light";
var $7e1392527dfcea6f$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $7e1392527dfcea6f$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $7e1392527dfcea6f$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $7e1392527dfcea6f$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $7e1392527dfcea6f$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $7e1392527dfcea6f$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $7e1392527dfcea6f$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $7e1392527dfcea6f$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $jp7ng.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $7e1392527dfcea6f$export$6d8204c2cb2e06b8() / 4;
    (0, $1OnrY.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $7e1392527dfcea6f$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $7e1392527dfcea6f$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $7e1392527dfcea6f$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $1OnrY.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $7e1392527dfcea6f$export$ba1d834b86d72a09 = $7e1392527dfcea6f$export$a1b3edb637fb4f35;
var $7e1392527dfcea6f$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $jp7ng.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $jp7ng.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $jp7ng.N30A), ")")
            }
        }
    };
};

});
parcelRegister("1OnrY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $151ca6b1cd217037$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "propDeprecationWarning", function () { return $151ca6b1cd217037$export$eb1decd851a5ae56; });

var $cYfJg = parcelRequire("cYfJg");

var $8ovux = parcelRequire("8ovux");
function $151ca6b1cd217037$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $cYfJg.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $151ca6b1cd217037$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $8ovux;
}

});
parcelRegister("cYfJg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97174a19909da408$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $97174a19909da408$var$printed = {};
function $97174a19909da408$export$2e2bcd8739ae039(message) {
    if ($97174a19909da408$var$printed[message]) return;
    $97174a19909da408$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}

});


parcelRegister("jp7ng", function(module, exports) {

$parcel$export(module.exports, "R50", function () { return $e2061278dda0afbc$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R75", function () { return $e2061278dda0afbc$export$b34b069eff244586; });
$parcel$export(module.exports, "R100", function () { return $e2061278dda0afbc$export$be802dd0d8b57f35; });
$parcel$export(module.exports, "R200", function () { return $e2061278dda0afbc$export$60847d42f9da92a6; });
$parcel$export(module.exports, "R300", function () { return $e2061278dda0afbc$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $e2061278dda0afbc$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $e2061278dda0afbc$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y50", function () { return $e2061278dda0afbc$export$8d9596b529bbb9cf; });
$parcel$export(module.exports, "Y75", function () { return $e2061278dda0afbc$export$41060a744ab0b7ae; });
$parcel$export(module.exports, "Y100", function () { return $e2061278dda0afbc$export$1cc05bbbf340e559; });
$parcel$export(module.exports, "Y200", function () { return $e2061278dda0afbc$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $e2061278dda0afbc$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $e2061278dda0afbc$export$59619663aa6500fb; });
$parcel$export(module.exports, "Y500", function () { return $e2061278dda0afbc$export$874739ea9e379ab6; });
$parcel$export(module.exports, "G50", function () { return $e2061278dda0afbc$export$8a6341c32b6a3ee6; });
$parcel$export(module.exports, "G75", function () { return $e2061278dda0afbc$export$69a3bf21b9686c2b; });
$parcel$export(module.exports, "G100", function () { return $e2061278dda0afbc$export$afbce1382ec95f73; });
$parcel$export(module.exports, "G200", function () { return $e2061278dda0afbc$export$747d86715d4175de; });
$parcel$export(module.exports, "G300", function () { return $e2061278dda0afbc$export$940e1f69e873f202; });
$parcel$export(module.exports, "G400", function () { return $e2061278dda0afbc$export$a49394138f7b8e85; });
$parcel$export(module.exports, "G500", function () { return $e2061278dda0afbc$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $e2061278dda0afbc$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $e2061278dda0afbc$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $e2061278dda0afbc$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $e2061278dda0afbc$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $e2061278dda0afbc$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $e2061278dda0afbc$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $e2061278dda0afbc$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "P50", function () { return $e2061278dda0afbc$export$363e4475840015bb; });
$parcel$export(module.exports, "P75", function () { return $e2061278dda0afbc$export$4b0a4417ed59760f; });
$parcel$export(module.exports, "P100", function () { return $e2061278dda0afbc$export$6011520a64d9a187; });
$parcel$export(module.exports, "P200", function () { return $e2061278dda0afbc$export$a7175d4e9206bc80; });
$parcel$export(module.exports, "P300", function () { return $e2061278dda0afbc$export$b48405b95304b5a1; });
$parcel$export(module.exports, "P400", function () { return $e2061278dda0afbc$export$c71e4279dd54a18d; });
$parcel$export(module.exports, "P500", function () { return $e2061278dda0afbc$export$147899de772240ec; });
$parcel$export(module.exports, "T50", function () { return $e2061278dda0afbc$export$2cf711fe14c66f06; });
$parcel$export(module.exports, "T75", function () { return $e2061278dda0afbc$export$7a8f4d33f6f9772c; });
$parcel$export(module.exports, "T100", function () { return $e2061278dda0afbc$export$776c9c497ef08533; });
$parcel$export(module.exports, "T200", function () { return $e2061278dda0afbc$export$69cb3ca10c1e330e; });
$parcel$export(module.exports, "T300", function () { return $e2061278dda0afbc$export$9dc1ef0f3f48059b; });
$parcel$export(module.exports, "T400", function () { return $e2061278dda0afbc$export$7c835c78b6fcdef8; });
$parcel$export(module.exports, "T500", function () { return $e2061278dda0afbc$export$6036577f95c3877e; });
$parcel$export(module.exports, "N0", function () { return $e2061278dda0afbc$export$29a4f05edc054374; });
$parcel$export(module.exports, "N10", function () { return $e2061278dda0afbc$export$e655ef011c4aa1a2; });
$parcel$export(module.exports, "N20", function () { return $e2061278dda0afbc$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $e2061278dda0afbc$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N40", function () { return $e2061278dda0afbc$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N50", function () { return $e2061278dda0afbc$export$8754fc7e6d8b3000; });
$parcel$export(module.exports, "N60", function () { return $e2061278dda0afbc$export$c2e91cbeada39b8b; });
$parcel$export(module.exports, "N70", function () { return $e2061278dda0afbc$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N80", function () { return $e2061278dda0afbc$export$eaa8c8a70ac22806; });
$parcel$export(module.exports, "N90", function () { return $e2061278dda0afbc$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N100", function () { return $e2061278dda0afbc$export$d6447c357493214f; });
$parcel$export(module.exports, "N200", function () { return $e2061278dda0afbc$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N300", function () { return $e2061278dda0afbc$export$e2ef2124cf4024b1; });
$parcel$export(module.exports, "N400", function () { return $e2061278dda0afbc$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $e2061278dda0afbc$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N600", function () { return $e2061278dda0afbc$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N700", function () { return $e2061278dda0afbc$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $e2061278dda0afbc$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N900", function () { return $e2061278dda0afbc$export$fbda843f0a27fe96; });
$parcel$export(module.exports, "N10A", function () { return $e2061278dda0afbc$export$791e57b27ca738ef; });
$parcel$export(module.exports, "N20A", function () { return $e2061278dda0afbc$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $e2061278dda0afbc$export$920c0d5c49070351; });
$parcel$export(module.exports, "N40A", function () { return $e2061278dda0afbc$export$46987b49aab6d1a8; });
$parcel$export(module.exports, "N50A", function () { return $e2061278dda0afbc$export$7d3359664e8bb0e5; });
$parcel$export(module.exports, "N60A", function () { return $e2061278dda0afbc$export$d2d3bedfb276cac0; });
$parcel$export(module.exports, "N70A", function () { return $e2061278dda0afbc$export$6e5e7499ff054f6d; });
$parcel$export(module.exports, "N80A", function () { return $e2061278dda0afbc$export$59264b346c877fa7; });
$parcel$export(module.exports, "N90A", function () { return $e2061278dda0afbc$export$d092757d7c64925c; });
$parcel$export(module.exports, "N100A", function () { return $e2061278dda0afbc$export$486ab785e4bac3c6; });
$parcel$export(module.exports, "N200A", function () { return $e2061278dda0afbc$export$fba592bbc6419fea; });
$parcel$export(module.exports, "N300A", function () { return $e2061278dda0afbc$export$13609db0e6812ab8; });
$parcel$export(module.exports, "N400A", function () { return $e2061278dda0afbc$export$fbae4efaa892d883; });
$parcel$export(module.exports, "N500A", function () { return $e2061278dda0afbc$export$f13946d26f440ce6; });
$parcel$export(module.exports, "N600A", function () { return $e2061278dda0afbc$export$19f58225ac52a306; });
$parcel$export(module.exports, "N700A", function () { return $e2061278dda0afbc$export$6384f09da70e7b62; });
$parcel$export(module.exports, "N800A", function () { return $e2061278dda0afbc$export$d0dccc730683edc2; });
$parcel$export(module.exports, "DN900", function () { return $e2061278dda0afbc$export$2f6319cf7d736c2a; });
$parcel$export(module.exports, "DN800", function () { return $e2061278dda0afbc$export$95126bc8884d6634; });
$parcel$export(module.exports, "DN700", function () { return $e2061278dda0afbc$export$8338d8c35d44ff1; });
$parcel$export(module.exports, "DN600", function () { return $e2061278dda0afbc$export$5368d76ae4fbbda7; });
$parcel$export(module.exports, "DN500", function () { return $e2061278dda0afbc$export$9f0a771d16ec8d36; });
$parcel$export(module.exports, "DN400", function () { return $e2061278dda0afbc$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $e2061278dda0afbc$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN200", function () { return $e2061278dda0afbc$export$bfe21c59123ecf33; });
$parcel$export(module.exports, "DN100", function () { return $e2061278dda0afbc$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN90", function () { return $e2061278dda0afbc$export$682927c6ed76be02; });
$parcel$export(module.exports, "DN80", function () { return $e2061278dda0afbc$export$91fd9994c5be9757; });
$parcel$export(module.exports, "DN70", function () { return $e2061278dda0afbc$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $e2061278dda0afbc$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN50", function () { return $e2061278dda0afbc$export$8e8133c1ba5845b5; });
$parcel$export(module.exports, "DN40", function () { return $e2061278dda0afbc$export$33ff357f6620b39; });
$parcel$export(module.exports, "DN30", function () { return $e2061278dda0afbc$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN20", function () { return $e2061278dda0afbc$export$9776a6e503bdbf76; });
$parcel$export(module.exports, "DN10", function () { return $e2061278dda0afbc$export$6c813d5160dff5db; });
$parcel$export(module.exports, "DN0", function () { return $e2061278dda0afbc$export$3d4f271a500072a; });
$parcel$export(module.exports, "DN800A", function () { return $e2061278dda0afbc$export$fe151285c22759ec; });
$parcel$export(module.exports, "DN700A", function () { return $e2061278dda0afbc$export$a101c6190d0da34; });
$parcel$export(module.exports, "DN600A", function () { return $e2061278dda0afbc$export$4b16f52932fda51; });
$parcel$export(module.exports, "DN500A", function () { return $e2061278dda0afbc$export$a74bcd7b9845b0d8; });
$parcel$export(module.exports, "DN400A", function () { return $e2061278dda0afbc$export$9209c179316d1751; });
$parcel$export(module.exports, "DN300A", function () { return $e2061278dda0afbc$export$88f55133f636c8dd; });
$parcel$export(module.exports, "DN200A", function () { return $e2061278dda0afbc$export$51126f85d1009512; });
$parcel$export(module.exports, "DN100A", function () { return $e2061278dda0afbc$export$a069b547bd23af78; });
$parcel$export(module.exports, "DN90A", function () { return $e2061278dda0afbc$export$40cce05af3b2600a; });
$parcel$export(module.exports, "DN80A", function () { return $e2061278dda0afbc$export$b78942185925a0d; });
$parcel$export(module.exports, "DN70A", function () { return $e2061278dda0afbc$export$e058fb44b8eaafca; });
$parcel$export(module.exports, "DN60A", function () { return $e2061278dda0afbc$export$92b0b8de26920c18; });
$parcel$export(module.exports, "DN50A", function () { return $e2061278dda0afbc$export$67564f7459d3fc9e; });
$parcel$export(module.exports, "DN40A", function () { return $e2061278dda0afbc$export$77868e1ca884ffa3; });
$parcel$export(module.exports, "DN30A", function () { return $e2061278dda0afbc$export$2afd71d7d3ea2cd5; });
$parcel$export(module.exports, "DN20A", function () { return $e2061278dda0afbc$export$f2a0acaab9972c70; });
$parcel$export(module.exports, "DN10A", function () { return $e2061278dda0afbc$export$9ab70e67d6475361; });
$parcel$export(module.exports, "background", function () { return $e2061278dda0afbc$export$8ce1fd94bee2f412; });
$parcel$export(module.exports, "backgroundActive", function () { return $e2061278dda0afbc$export$b861914ea877b580; });
$parcel$export(module.exports, "backgroundHover", function () { return $e2061278dda0afbc$export$3f1b020df94387af; });
$parcel$export(module.exports, "backgroundOnLayer", function () { return $e2061278dda0afbc$export$c0183dbab98ca63e; });
$parcel$export(module.exports, "text", function () { return $e2061278dda0afbc$export$6f093cfa640b7166; });
$parcel$export(module.exports, "textHover", function () { return $e2061278dda0afbc$export$42f8e9c698766e7a; });
$parcel$export(module.exports, "textActive", function () { return $e2061278dda0afbc$export$c2d157ca1c34b6e3; });
$parcel$export(module.exports, "subtleText", function () { return $e2061278dda0afbc$export$1905ba28d7cf066f; });
$parcel$export(module.exports, "placeholderText", function () { return $e2061278dda0afbc$export$bd9002130d306d39; });
$parcel$export(module.exports, "heading", function () { return $e2061278dda0afbc$export$46e4a324ac90507f; });
$parcel$export(module.exports, "subtleHeading", function () { return $e2061278dda0afbc$export$79f3f2b82beb0d36; });
$parcel$export(module.exports, "codeBlock", function () { return $e2061278dda0afbc$export$7bb0d5c671655cc4; });
$parcel$export(module.exports, "link", function () { return $e2061278dda0afbc$export$9c30223ca0a664fb; });
$parcel$export(module.exports, "linkHover", function () { return $e2061278dda0afbc$export$7ed258b0728b004b; });
$parcel$export(module.exports, "linkActive", function () { return $e2061278dda0afbc$export$dfa920d8decc8a59; });
$parcel$export(module.exports, "linkOutline", function () { return $e2061278dda0afbc$export$6069e6ad5c78f632; });
$parcel$export(module.exports, "primary", function () { return $e2061278dda0afbc$export$9ad721cf3b3debe0; });
$parcel$export(module.exports, "blue", function () { return $e2061278dda0afbc$export$2aa0182783e7e9de; });
$parcel$export(module.exports, "teal", function () { return $e2061278dda0afbc$export$8bf7dff220b82b4a; });
$parcel$export(module.exports, "purple", function () { return $e2061278dda0afbc$export$e13cce2a2d16a9d4; });
$parcel$export(module.exports, "red", function () { return $e2061278dda0afbc$export$a90204d1394caf30; });
$parcel$export(module.exports, "yellow", function () { return $e2061278dda0afbc$export$594c5a8758200c32; });
$parcel$export(module.exports, "green", function () { return $e2061278dda0afbc$export$955a2ebd2fb142ae; });
$parcel$export(module.exports, "skeleton", function () { return $e2061278dda0afbc$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $kD01A = parcelRequire("kD01A");
var $e2061278dda0afbc$export$4b84fd0e2c617bd = "#FFEBE6";
var $e2061278dda0afbc$export$b34b069eff244586 = "#FFBDAD";
var $e2061278dda0afbc$export$be802dd0d8b57f35 = "#FF8F73";
var $e2061278dda0afbc$export$60847d42f9da92a6 = "#FF7452";
var $e2061278dda0afbc$export$4a7404f376229999 = "#FF5630";
var $e2061278dda0afbc$export$2010d0fb4295b346 = "#DE350B";
var $e2061278dda0afbc$export$2837b5a1a71d5c02 = "#BF2600";
var $e2061278dda0afbc$export$8d9596b529bbb9cf = "#FFFAE6";
var $e2061278dda0afbc$export$41060a744ab0b7ae = "#FFF0B3";
var $e2061278dda0afbc$export$1cc05bbbf340e559 = "#FFE380";
var $e2061278dda0afbc$export$5aae31392d72caaa = "#FFC400";
var $e2061278dda0afbc$export$c6930421db9fa514 = "#FFAB00";
var $e2061278dda0afbc$export$59619663aa6500fb = "#FF991F";
var $e2061278dda0afbc$export$874739ea9e379ab6 = "#FF8B00";
var $e2061278dda0afbc$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $e2061278dda0afbc$export$69a3bf21b9686c2b = "#ABF5D1";
var $e2061278dda0afbc$export$afbce1382ec95f73 = "#79F2C0";
var $e2061278dda0afbc$export$747d86715d4175de = "#57D9A3";
var $e2061278dda0afbc$export$940e1f69e873f202 = "#36B37E";
var $e2061278dda0afbc$export$a49394138f7b8e85 = "#00875A";
var $e2061278dda0afbc$export$6fa04827ac68a4fb = "#006644";
var $e2061278dda0afbc$export$226de0355ed012f8 = "#DEEBFF";
var $e2061278dda0afbc$export$8c13c2ee36917869 = "#B3D4FF";
var $e2061278dda0afbc$export$ecfc1dff386a3e7a = "#4C9AFF";
var $e2061278dda0afbc$export$215b7063051591f1 = "#2684FF";
var $e2061278dda0afbc$export$e62e8919cca44969 = "#0065FF";
var $e2061278dda0afbc$export$b3de0ae08da2ce64 = "#0052CC";
var $e2061278dda0afbc$export$a6ee3d71bc067634 = "#0747A6";
var $e2061278dda0afbc$export$363e4475840015bb = "#EAE6FF";
var $e2061278dda0afbc$export$4b0a4417ed59760f = "#C0B6F2";
var $e2061278dda0afbc$export$6011520a64d9a187 = "#998DD9";
var $e2061278dda0afbc$export$a7175d4e9206bc80 = "#8777D9";
var $e2061278dda0afbc$export$b48405b95304b5a1 = "#6554C0";
var $e2061278dda0afbc$export$c71e4279dd54a18d = "#5243AA";
var $e2061278dda0afbc$export$147899de772240ec = "#403294";
var $e2061278dda0afbc$export$2cf711fe14c66f06 = "#E6FCFF";
var $e2061278dda0afbc$export$7a8f4d33f6f9772c = "#B3F5FF";
var $e2061278dda0afbc$export$776c9c497ef08533 = "#79E2F2";
var $e2061278dda0afbc$export$69cb3ca10c1e330e = "#00C7E6";
var $e2061278dda0afbc$export$9dc1ef0f3f48059b = "#00B8D9";
var $e2061278dda0afbc$export$7c835c78b6fcdef8 = "#00A3BF";
var $e2061278dda0afbc$export$6036577f95c3877e = "#008DA6";
var $e2061278dda0afbc$export$29a4f05edc054374 = "#FFFFFF";
var $e2061278dda0afbc$export$e655ef011c4aa1a2 = "#FAFBFC";
var $e2061278dda0afbc$export$9fdfb749e33cdf97 = "#F4F5F7";
var $e2061278dda0afbc$export$3e51e8f1440314ba = "#EBECF0";
var $e2061278dda0afbc$export$1ce2d1575d444ceb = "#DFE1E6";
var $e2061278dda0afbc$export$8754fc7e6d8b3000 = "#C1C7D0";
var $e2061278dda0afbc$export$c2e91cbeada39b8b = "#B3BAC5";
var $e2061278dda0afbc$export$5f71e19f3a7ad9de = "#A5ADBA";
var $e2061278dda0afbc$export$eaa8c8a70ac22806 = "#97A0AF";
var $e2061278dda0afbc$export$7c87d337fb91a97d = "#8993A4";
var $e2061278dda0afbc$export$d6447c357493214f = "#7A869A";
var $e2061278dda0afbc$export$f563ee71e9ee74cd = "#6B778C";
var $e2061278dda0afbc$export$e2ef2124cf4024b1 = "#5E6C84";
var $e2061278dda0afbc$export$eece5f492e429f08 = "#505F79";
var $e2061278dda0afbc$export$c39c0fe0f26207ae = "#42526E";
var $e2061278dda0afbc$export$7090862dc3038a9f = "#344563";
var $e2061278dda0afbc$export$ad0bacf983b7ddaa = "#253858";
var $e2061278dda0afbc$export$7d61b15e0da132af = "#172B4D";
var $e2061278dda0afbc$export$fbda843f0a27fe96 = "#091E42";
var $e2061278dda0afbc$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $e2061278dda0afbc$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $e2061278dda0afbc$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $e2061278dda0afbc$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $e2061278dda0afbc$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $e2061278dda0afbc$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $e2061278dda0afbc$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $e2061278dda0afbc$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $e2061278dda0afbc$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $e2061278dda0afbc$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $e2061278dda0afbc$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $e2061278dda0afbc$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $e2061278dda0afbc$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $e2061278dda0afbc$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $e2061278dda0afbc$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $e2061278dda0afbc$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $e2061278dda0afbc$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $e2061278dda0afbc$export$2f6319cf7d736c2a = "#E6EDFA";
var $e2061278dda0afbc$export$95126bc8884d6634 = "#DCE5F5";
var $e2061278dda0afbc$export$8338d8c35d44ff1 = "#CED9EB";
var $e2061278dda0afbc$export$5368d76ae4fbbda7 = "#B8C7E0";
var $e2061278dda0afbc$export$9f0a771d16ec8d36 = "#ABBBD6";
var $e2061278dda0afbc$export$abcf8c38338b4aa5 = "#9FB0CC";
var $e2061278dda0afbc$export$97e81faa16a182c7 = "#8C9CB8";
var $e2061278dda0afbc$export$bfe21c59123ecf33 = "#7988A3";
var $e2061278dda0afbc$export$ee82aa2ea6a1558 = "#67758F";
var $e2061278dda0afbc$export$682927c6ed76be02 = "#56637A";
var $e2061278dda0afbc$export$91fd9994c5be9757 = "#455166";
var $e2061278dda0afbc$export$d281fbfe3cff2df6 = "#3B475C";
var $e2061278dda0afbc$export$3902c91d8b98a753 = "#313D52";
var $e2061278dda0afbc$export$8e8133c1ba5845b5 = "#283447";
var $e2061278dda0afbc$export$33ff357f6620b39 = "#202B3D";
var $e2061278dda0afbc$export$633847cf062b69e0 = "#1B2638";
var $e2061278dda0afbc$export$9776a6e503bdbf76 = "#121A29";
var $e2061278dda0afbc$export$6c813d5160dff5db = "#0E1624";
var $e2061278dda0afbc$export$3d4f271a500072a = "#0D1424";
var $e2061278dda0afbc$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $e2061278dda0afbc$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $e2061278dda0afbc$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $e2061278dda0afbc$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $e2061278dda0afbc$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $e2061278dda0afbc$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $e2061278dda0afbc$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $e2061278dda0afbc$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $e2061278dda0afbc$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $e2061278dda0afbc$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $e2061278dda0afbc$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $e2061278dda0afbc$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $e2061278dda0afbc$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $e2061278dda0afbc$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $e2061278dda0afbc$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $e2061278dda0afbc$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $e2061278dda0afbc$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $e2061278dda0afbc$export$8ce1fd94bee2f412 = (0, $kD01A.default)({
    light: "var(--ds-surface, ".concat($e2061278dda0afbc$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($e2061278dda0afbc$export$633847cf062b69e0, ")")
});
var $e2061278dda0afbc$export$b861914ea877b580 = (0, $kD01A.default)({
    light: "var(--ds-background-selected, ".concat($e2061278dda0afbc$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($e2061278dda0afbc$export$8c13c2ee36917869, ")")
});
var $e2061278dda0afbc$export$3f1b020df94387af = (0, $kD01A.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($e2061278dda0afbc$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($e2061278dda0afbc$export$d281fbfe3cff2df6, ")")
});
var $e2061278dda0afbc$export$c0183dbab98ca63e = (0, $kD01A.default)({
    light: "var(--ds-surface-overlay, ".concat($e2061278dda0afbc$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($e2061278dda0afbc$export$8e8133c1ba5845b5, ")")
});
var $e2061278dda0afbc$export$6f093cfa640b7166 = (0, $kD01A.default)({
    light: "var(--ds-text, ".concat($e2061278dda0afbc$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($e2061278dda0afbc$export$5368d76ae4fbbda7, ")")
});
var $e2061278dda0afbc$export$42f8e9c698766e7a = (0, $kD01A.default)({
    light: "var(--ds-text, ".concat($e2061278dda0afbc$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($e2061278dda0afbc$export$5368d76ae4fbbda7, ")")
});
var $e2061278dda0afbc$export$c2d157ca1c34b6e3 = (0, $kD01A.default)({
    light: "var(--ds-text-selected, ".concat($e2061278dda0afbc$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($e2061278dda0afbc$export$b3de0ae08da2ce64, ")")
});
var $e2061278dda0afbc$export$1905ba28d7cf066f = (0, $kD01A.default)({
    light: "var(--ds-text-subtlest, ".concat($e2061278dda0afbc$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($e2061278dda0afbc$export$97e81faa16a182c7, ")")
});
var $e2061278dda0afbc$export$bd9002130d306d39 = (0, $kD01A.default)({
    light: "var(--ds-text-subtlest, ".concat($e2061278dda0afbc$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($e2061278dda0afbc$export$bfe21c59123ecf33, ")")
});
var $e2061278dda0afbc$export$46e4a324ac90507f = (0, $kD01A.default)({
    light: "var(--ds-text, ".concat($e2061278dda0afbc$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($e2061278dda0afbc$export$5368d76ae4fbbda7, ")")
});
var $e2061278dda0afbc$export$79f3f2b82beb0d36 = (0, $kD01A.default)({
    light: "var(--ds-text-subtlest, ".concat($e2061278dda0afbc$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($e2061278dda0afbc$export$97e81faa16a182c7, ")")
});
var $e2061278dda0afbc$export$7bb0d5c671655cc4 = (0, $kD01A.default)({
    light: $e2061278dda0afbc$export$9fdfb749e33cdf97,
    dark: $e2061278dda0afbc$export$8e8133c1ba5845b5
});
var $e2061278dda0afbc$export$9c30223ca0a664fb = (0, $kD01A.default)({
    light: "var(--ds-link, ".concat($e2061278dda0afbc$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($e2061278dda0afbc$export$ecfc1dff386a3e7a, ")")
});
var $e2061278dda0afbc$export$7ed258b0728b004b = (0, $kD01A.default)({
    light: "var(--ds-link-pressed, ".concat($e2061278dda0afbc$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($e2061278dda0afbc$export$215b7063051591f1, ")")
});
var $e2061278dda0afbc$export$dfa920d8decc8a59 = (0, $kD01A.default)({
    light: "var(--ds-link-pressed, ".concat($e2061278dda0afbc$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($e2061278dda0afbc$export$ecfc1dff386a3e7a, ")")
});
var $e2061278dda0afbc$export$6069e6ad5c78f632 = (0, $kD01A.default)({
    light: "var(--ds-border-focused, ".concat($e2061278dda0afbc$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($e2061278dda0afbc$export$215b7063051591f1, ")")
});
var $e2061278dda0afbc$export$9ad721cf3b3debe0 = (0, $kD01A.default)({
    light: "var(--ds-background-brand-bold, ".concat($e2061278dda0afbc$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($e2061278dda0afbc$export$ecfc1dff386a3e7a, ")")
});
var $e2061278dda0afbc$export$2aa0182783e7e9de = (0, $kD01A.default)({
    light: $e2061278dda0afbc$export$b3de0ae08da2ce64,
    dark: $e2061278dda0afbc$export$ecfc1dff386a3e7a
});
var $e2061278dda0afbc$export$8bf7dff220b82b4a = (0, $kD01A.default)({
    light: $e2061278dda0afbc$export$9dc1ef0f3f48059b,
    dark: $e2061278dda0afbc$export$69cb3ca10c1e330e
});
var $e2061278dda0afbc$export$e13cce2a2d16a9d4 = (0, $kD01A.default)({
    light: $e2061278dda0afbc$export$b48405b95304b5a1,
    dark: $e2061278dda0afbc$export$6011520a64d9a187
});
var $e2061278dda0afbc$export$a90204d1394caf30 = (0, $kD01A.default)({
    light: $e2061278dda0afbc$export$4a7404f376229999,
    dark: $e2061278dda0afbc$export$4a7404f376229999
});
var $e2061278dda0afbc$export$594c5a8758200c32 = (0, $kD01A.default)({
    light: $e2061278dda0afbc$export$c6930421db9fa514,
    dark: $e2061278dda0afbc$export$c6930421db9fa514
});
var $e2061278dda0afbc$export$955a2ebd2fb142ae = (0, $kD01A.default)({
    light: $e2061278dda0afbc$export$940e1f69e873f202,
    dark: $e2061278dda0afbc$export$940e1f69e873f202
});
var $e2061278dda0afbc$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($e2061278dda0afbc$export$8d43898f60b96a82, ")");
};

});
parcelRegister("kD01A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f047780c8893f5cc$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $aKXLZ = parcelRequire("aKXLZ");
// Unpack custom variants, and get correct value for the current theme
function $f047780c8893f5cc$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $aKXLZ.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $f047780c8893f5cc$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $f047780c8893f5cc$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $aKXLZ.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("aKXLZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d4c90f65c735054$export$2e2bcd8739ae039; });

var $aP6k3 = parcelRequire("aP6k3");
function $7d4c90f65c735054$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $aP6k3.CHANNEL) in props.theme) return props.theme[0, $aP6k3.CHANNEL];
        else if ("mode" in props.theme && (0, $aP6k3.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $aP6k3.DEFAULT_THEME_MODE)
    };
}

});




parcelRegister("1GLSi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13aed9a11dfe9de2$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $jp7ng = parcelRequire("jp7ng");

var $aP6k3 = parcelRequire("aP6k3");
function $13aed9a11dfe9de2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $13aed9a11dfe9de2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $13aed9a11dfe9de2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $13aed9a11dfe9de2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// IE11 and Edge: z-index needed because fixed position calculates z-index relative
// to body instead of nearest stacking context (Portal in our case).
var $13aed9a11dfe9de2$var$blanketStyles = (0, $avKww.css)({
    position: "fixed",
    zIndex: (0, $aP6k3.layers).spotlight(),
    inset: 0,
    transition: "opacity 220ms"
});
/**
 * __Blanket__
 *
 * A replacement for `@atlaskit/blanket`.
 *
 * We use this for spotlights instead of `@atlaskit/blanket`
 * because spotlights must sit on top of other layered elements,
 * such as modals, which have their own blankets.
 *
 * @internal
 */ var $13aed9a11dfe9de2$var$Blanket = function Blanket(props) {
    var onBlanketClicked = props.onBlanketClicked;
    return (0, $avKww.jsx)("div", {
        role: "presentation",
        css: $13aed9a11dfe9de2$var$blanketStyles,
        style: $13aed9a11dfe9de2$var$_objectSpread($13aed9a11dfe9de2$var$_objectSpread({}, props.style), {}, {
            backgroundColor: props.isTinted ? "var(--ds-blanket, ".concat((0, $jp7ng.N100A), ")") : "transparent"
        }),
        onClick: onBlanketClicked
    });
};
var $13aed9a11dfe9de2$export$2e2bcd8739ae039 = $13aed9a11dfe9de2$var$Blanket;

});
parcelRegister("avKww", function(module, exports) {

$parcel$export(module.exports, "createElement", function () { return $7a70e3441d1a7c75$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "Global", function () { return $7a70e3441d1a7c75$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $7a70e3441d1a7c75$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $7a70e3441d1a7c75$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ClassNames", function () { return $7a70e3441d1a7c75$export$9b9c0f9d9f3552b8; });
$parcel$export(module.exports, "jsx", function () { return $7a70e3441d1a7c75$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "CacheProvider", function () { return (parcelRequire("hp0gY")).C; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("hp0gY")).T; });
$parcel$export(module.exports, "ThemeProvider", function () { return (parcelRequire("hp0gY")).a; });
$parcel$export(module.exports, "__unsafe_useEmotionCache", function () { return (parcelRequire("hp0gY"))._; });
$parcel$export(module.exports, "useTheme", function () { return (parcelRequire("hp0gY")).u; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("hp0gY")).w; });
$parcel$export(module.exports, "withTheme", function () { return (parcelRequire("hp0gY")).b; });

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("3hca7");

var $hp0gY = parcelRequire("hp0gY");
parcelRequire("fPPqr");
parcelRequire("lr19y");
parcelRequire("1t1PC");


var $7Eyl7 = parcelRequire("7Eyl7");

var $9xCOS = parcelRequire("9xCOS");

var $gxh9m = parcelRequire("gxh9m");
var $7a70e3441d1a7c75$var$pkg = {
    name: "@emotion/react",
    version: "11.10.6",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": "./macro.js"
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.js",
        "macro.d.ts",
        "macro.js.flow"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.10.6",
        "@emotion/cache": "^11.10.5",
        "@emotion/serialize": "^1.1.1",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.0",
        "@emotion/utils": "^1.2.0",
        "@emotion/weak-memoize": "^0.3.0",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.10.6",
        "@emotion/css-prettifier": "1.1.1",
        "@emotion/server": "11.10.0",
        "@emotion/styled": "11.10.6",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": "./macro.js"
            }
        }
    }
};
var $7a70e3441d1a7c75$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $hp0gY.h).call(props, "css")) // $FlowFixMe
    return (0, $9nHZC.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $hp0gY.E);
    createElementArgArray[1] = (0, $hp0gY.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $9nHZC.createElement).apply(null, createElementArgArray);
};
var $7a70e3441d1a7c75$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $7a70e3441d1a7c75$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $hp0gY.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $9xCOS.serializeStyles)([
        styles
    ], undefined, (0, $9nHZC.useContext)((0, $hp0gY.T)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = (0, $9nHZC.useRef)();
    (0, $gxh9m.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $gxh9m.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $7Eyl7.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $7a70e3441d1a7c75$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $9xCOS.serializeStyles)(args);
}
var $7a70e3441d1a7c75$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $7a70e3441d1a7c75$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $7a70e3441d1a7c75$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $7a70e3441d1a7c75$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $7Eyl7.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $7a70e3441d1a7c75$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $gxh9m.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)var res = (0, $7Eyl7.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $7a70e3441d1a7c75$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $hp0gY.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $9xCOS.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $7Eyl7.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $7a70e3441d1a7c75$var$merge(cache.registered, css, $7a70e3441d1a7c75$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: (0, $9nHZC.useContext)((0, $hp0gY.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ (0, $9nHZC.createElement)((0, $9nHZC.Fragment), null, /*#__PURE__*/ (0, $9nHZC.createElement)($7a70e3441d1a7c75$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $7a70e3441d1a7c75$var$isBrowser, $7a70e3441d1a7c75$var$isTestEnv, $7a70e3441d1a7c75$var$globalContext, $7a70e3441d1a7c75$var$globalKey;

});
parcelRegister("3hca7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $262c64c44d77c401$export$2e2bcd8739ae039; });

var $3lOoE = parcelRequire("3lOoE");

var $kre9Y = parcelRequire("kre9Y");
parcelRequire("iK3AD");
parcelRequire("4o2oX");
var $262c64c44d77c401$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $kre9Y.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $kre9Y.token)(character)) break;
        (0, $kre9Y.next)();
    }
    return (0, $kre9Y.slice)(begin, (0, $kre9Y.position));
};
var $262c64c44d77c401$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $kre9Y.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $kre9Y.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $262c64c44d77c401$var$identifierWithPointTracking((0, $kre9Y.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $kre9Y.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $kre9Y.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $kre9Y.from)(character);
    }
    while (character = (0, $kre9Y.next)());
    return parsed;
};
var $262c64c44d77c401$var$getRules = function getRules(value, points) {
    return (0, $kre9Y.dealloc)($262c64c44d77c401$var$toRules((0, $kre9Y.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $262c64c44d77c401$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $262c64c44d77c401$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$262c64c44d77c401$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $262c64c44d77c401$var$fixedElements.set(element, true);
    var points = [];
    var rules = $262c64c44d77c401$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $262c64c44d77c401$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $262c64c44d77c401$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $262c64c44d77c401$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($262c64c44d77c401$var$ignoreFlag) > -1;
};
var $262c64c44d77c401$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($262c64c44d77c401$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $262c64c44d77c401$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $262c64c44d77c401$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$262c64c44d77c401$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $262c64c44d77c401$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $262c64c44d77c401$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$262c64c44d77c401$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $262c64c44d77c401$var$nullifyElement(element);
    } else if ($262c64c44d77c401$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $262c64c44d77c401$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $262c64c44d77c401$var$prefix(value, length) {
    switch((0, $kre9Y.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $kre9Y.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $kre9Y.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $kre9Y.WEBKIT) + value + (0, $kre9Y.MOZ) + value + (0, $kre9Y.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $kre9Y.WEBKIT) + value + (0, $kre9Y.MS) + value + value;
        // order
        case 6165:
            return (0, $kre9Y.WEBKIT) + value + (0, $kre9Y.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $kre9Y.WEBKIT) + value + (0, $kre9Y.replace)(value, /(\w+).+(:[^]+)/, (0, $kre9Y.WEBKIT) + "box-$1$2" + (0, $kre9Y.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $kre9Y.WEBKIT) + value + (0, $kre9Y.MS) + "flex-item-" + (0, $kre9Y.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $kre9Y.WEBKIT) + value + (0, $kre9Y.MS) + "flex-line-pack" + (0, $kre9Y.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $kre9Y.WEBKIT) + value + (0, $kre9Y.MS) + (0, $kre9Y.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $kre9Y.WEBKIT) + value + (0, $kre9Y.MS) + (0, $kre9Y.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $kre9Y.WEBKIT) + "box-" + (0, $kre9Y.replace)(value, "-grow", "") + (0, $kre9Y.WEBKIT) + value + (0, $kre9Y.MS) + (0, $kre9Y.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $kre9Y.WEBKIT) + (0, $kre9Y.replace)(value, /([^-])(transform)/g, "$1" + (0, $kre9Y.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $kre9Y.replace)((0, $kre9Y.replace)((0, $kre9Y.replace)(value, /(zoom-|grab)/, (0, $kre9Y.WEBKIT) + "$1"), /(image-set)/, (0, $kre9Y.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $kre9Y.replace)(value, /(image-set\([^]*)/, (0, $kre9Y.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $kre9Y.replace)((0, $kre9Y.replace)(value, /(.+:)(flex-)?(.*)/, (0, $kre9Y.WEBKIT) + "box-pack:$3" + (0, $kre9Y.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $kre9Y.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $kre9Y.replace)(value, /(.+)-inline(.+)/, (0, $kre9Y.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $kre9Y.strlen)(value) - 1 - length > 6) switch((0, $kre9Y.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $kre9Y.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $kre9Y.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $kre9Y.WEBKIT) + "$2-$3" + "$1" + (0, $kre9Y.MOZ) + ((0, $kre9Y.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $kre9Y.indexof)(value, "stretch") ? $262c64c44d77c401$var$prefix((0, $kre9Y.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $kre9Y.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $kre9Y.charat)(value, (0, $kre9Y.strlen)(value) - 3 - (~(0, $kre9Y.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $kre9Y.replace)(value, ":", ":" + (0, $kre9Y.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $kre9Y.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $kre9Y.WEBKIT) + ((0, $kre9Y.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $kre9Y.WEBKIT) + "$2$3" + "$1" + (0, $kre9Y.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $kre9Y.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $kre9Y.WEBKIT) + value + (0, $kre9Y.MS) + (0, $kre9Y.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $kre9Y.WEBKIT) + value + (0, $kre9Y.MS) + (0, $kre9Y.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $kre9Y.WEBKIT) + value + (0, $kre9Y.MS) + (0, $kre9Y.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $kre9Y.WEBKIT) + value + (0, $kre9Y.MS) + value + value;
    }
    return value;
}
var $262c64c44d77c401$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $kre9Y.DECLARATION:
                element["return"] = $262c64c44d77c401$var$prefix(element.value, element.length);
                break;
            case 0, $kre9Y.KEYFRAMES:
                return (0, $kre9Y.serialize)([
                    (0, $kre9Y.copy)(element, {
                        value: (0, $kre9Y.replace)(element.value, "@", "@" + (0, $kre9Y.WEBKIT))
                    })
                ], callback);
            case 0, $kre9Y.RULESET:
                if (element.length) return (0, $kre9Y.combine)(element.props, function(value) {
                    switch((0, $kre9Y.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $kre9Y.serialize)([
                                (0, $kre9Y.copy)(element, {
                                    props: [
                                        (0, $kre9Y.replace)(value, /:(read-\w+)/, ":" + (0, $kre9Y.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $kre9Y.serialize)([
                                (0, $kre9Y.copy)(element, {
                                    props: [
                                        (0, $kre9Y.replace)(value, /:(plac\w+)/, ":" + (0, $kre9Y.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $kre9Y.copy)(element, {
                                    props: [
                                        (0, $kre9Y.replace)(value, /:(plac\w+)/, ":" + (0, $kre9Y.MOZ) + "$1")
                                    ]
                                }),
                                (0, $kre9Y.copy)(element, {
                                    props: [
                                        (0, $kre9Y.replace)(value, /:(plac\w+)/, (0, $kre9Y.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $262c64c44d77c401$var$defaultStylisPlugins = [
    $262c64c44d77c401$var$prefixer
];
var $262c64c44d77c401$var$createCache = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $262c64c44d77c401$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $262c64c44d77c401$var$compat,
        $262c64c44d77c401$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $kre9Y.stringify),
        (0, $kre9Y.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $kre9Y.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $kre9Y.serialize)((0, $kre9Y.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $3lOoE.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};
var $262c64c44d77c401$export$2e2bcd8739ae039 = $262c64c44d77c401$var$createCache;

});
parcelRegister("3lOoE", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $270a6cf4e5bfc269$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $270a6cf4e5bfc269$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $270a6cf4e5bfc269$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $270a6cf4e5bfc269$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($270a6cf4e5bfc269$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $270a6cf4e5bfc269$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("kre9Y", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $711e8ff70cd01441$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $711e8ff70cd01441$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $711e8ff70cd01441$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $711e8ff70cd01441$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $711e8ff70cd01441$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $711e8ff70cd01441$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $711e8ff70cd01441$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $711e8ff70cd01441$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $711e8ff70cd01441$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $711e8ff70cd01441$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $711e8ff70cd01441$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $711e8ff70cd01441$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $711e8ff70cd01441$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $711e8ff70cd01441$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $711e8ff70cd01441$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $711e8ff70cd01441$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $711e8ff70cd01441$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $711e8ff70cd01441$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $711e8ff70cd01441$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $711e8ff70cd01441$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $711e8ff70cd01441$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $711e8ff70cd01441$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $711e8ff70cd01441$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $711e8ff70cd01441$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $711e8ff70cd01441$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $711e8ff70cd01441$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $711e8ff70cd01441$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $711e8ff70cd01441$export$38bcb760f1d4871c; });
var $711e8ff70cd01441$export$71ad59f2e432cfe8 = "-ms-";
var $711e8ff70cd01441$export$2c0f367103c8d01c = "-moz-";
var $711e8ff70cd01441$export$39dfd62a25e0fe93 = "-webkit-";
var $711e8ff70cd01441$export$a29989082612d0d9 = "comm";
var $711e8ff70cd01441$export$aa3a2e812ca8570d = "rule";
var $711e8ff70cd01441$export$527d108ccf083c2b = "decl";
var $711e8ff70cd01441$export$d3d35020fa5b54f0 = "@page";
var $711e8ff70cd01441$export$500415a86c544f73 = "@media";
var $711e8ff70cd01441$export$a763edbf796b780a = "@import";
var $711e8ff70cd01441$export$2790aeb8b4e5c826 = "@charset";
var $711e8ff70cd01441$export$1cc683e23b84b133 = "@viewport";
var $711e8ff70cd01441$export$9447a5efea57e862 = "@supports";
var $711e8ff70cd01441$export$ef011b4e114b1fba = "@document";
var $711e8ff70cd01441$export$6aad947bda0f3f46 = "@namespace";
var $711e8ff70cd01441$export$b44a8529a35fcb60 = "@keyframes";
var $711e8ff70cd01441$export$2c16de31893252e6 = "@font-face";
var $711e8ff70cd01441$export$3d846dd52e150c6f = "@counter-style";
var $711e8ff70cd01441$export$22314bfbb57653fe = "@font-feature-values";
var $711e8ff70cd01441$export$2335f513bbd82c6d = Math.abs;
var $711e8ff70cd01441$export$6788812c4e6611e6 = String.fromCharCode;
var $711e8ff70cd01441$export$e6e34fd1f2686227 = Object.assign;
function $711e8ff70cd01441$export$d6af199866bfb566(e, r) {
    return $711e8ff70cd01441$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $711e8ff70cd01441$export$a9db5e087081082d(e, 0)) << 2 ^ $711e8ff70cd01441$export$a9db5e087081082d(e, 1)) << 2 ^ $711e8ff70cd01441$export$a9db5e087081082d(e, 2)) << 2 ^ $711e8ff70cd01441$export$a9db5e087081082d(e, 3) : 0;
}
function $711e8ff70cd01441$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $711e8ff70cd01441$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $711e8ff70cd01441$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $711e8ff70cd01441$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $711e8ff70cd01441$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $711e8ff70cd01441$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $711e8ff70cd01441$export$36776f635604f274(e) {
    return e.length;
}
function $711e8ff70cd01441$export$f9084667e487ed46(e) {
    return e.length;
}
function $711e8ff70cd01441$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $711e8ff70cd01441$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $711e8ff70cd01441$export$53f1d5ea8de3d7c = 1;
var $711e8ff70cd01441$export$4e0c71f277ca26b3 = 1;
var $711e8ff70cd01441$export$f24224f1c91d8156 = 0;
var $711e8ff70cd01441$export$5880b8b5730aff45 = 0;
var $711e8ff70cd01441$export$c0306caf338ac095 = 0;
var $711e8ff70cd01441$export$30a86d91af8ff6e6 = "";
function $711e8ff70cd01441$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $711e8ff70cd01441$export$53f1d5ea8de3d7c,
        column: $711e8ff70cd01441$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $711e8ff70cd01441$export$784d13d8ee351f07(e, r) {
    return $711e8ff70cd01441$export$e6e34fd1f2686227($711e8ff70cd01441$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $711e8ff70cd01441$export$eba6f6f03b0a92e7() {
    return $711e8ff70cd01441$export$c0306caf338ac095;
}
function $711e8ff70cd01441$export$232faf9add678146() {
    $711e8ff70cd01441$export$c0306caf338ac095 = $711e8ff70cd01441$export$5880b8b5730aff45 > 0 ? $711e8ff70cd01441$export$a9db5e087081082d($711e8ff70cd01441$export$30a86d91af8ff6e6, --$711e8ff70cd01441$export$5880b8b5730aff45) : 0;
    if ($711e8ff70cd01441$export$4e0c71f277ca26b3--, $711e8ff70cd01441$export$c0306caf338ac095 === 10) $711e8ff70cd01441$export$4e0c71f277ca26b3 = 1, $711e8ff70cd01441$export$53f1d5ea8de3d7c--;
    return $711e8ff70cd01441$export$c0306caf338ac095;
}
function $711e8ff70cd01441$export$48cfd1e771a65c4f() {
    $711e8ff70cd01441$export$c0306caf338ac095 = $711e8ff70cd01441$export$5880b8b5730aff45 < $711e8ff70cd01441$export$f24224f1c91d8156 ? $711e8ff70cd01441$export$a9db5e087081082d($711e8ff70cd01441$export$30a86d91af8ff6e6, $711e8ff70cd01441$export$5880b8b5730aff45++) : 0;
    if ($711e8ff70cd01441$export$4e0c71f277ca26b3++, $711e8ff70cd01441$export$c0306caf338ac095 === 10) $711e8ff70cd01441$export$4e0c71f277ca26b3 = 1, $711e8ff70cd01441$export$53f1d5ea8de3d7c++;
    return $711e8ff70cd01441$export$c0306caf338ac095;
}
function $711e8ff70cd01441$export$4d3fb11e950abb9e() {
    return $711e8ff70cd01441$export$a9db5e087081082d($711e8ff70cd01441$export$30a86d91af8ff6e6, $711e8ff70cd01441$export$5880b8b5730aff45);
}
function $711e8ff70cd01441$export$e88cb2efb12ae807() {
    return $711e8ff70cd01441$export$5880b8b5730aff45;
}
function $711e8ff70cd01441$export$58adb3bec8346d0f(e, r) {
    return $711e8ff70cd01441$export$2f35ab04d2335697($711e8ff70cd01441$export$30a86d91af8ff6e6, e, r);
}
function $711e8ff70cd01441$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $711e8ff70cd01441$export$2de70f21292aac9e(e) {
    return $711e8ff70cd01441$export$53f1d5ea8de3d7c = $711e8ff70cd01441$export$4e0c71f277ca26b3 = 1, $711e8ff70cd01441$export$f24224f1c91d8156 = $711e8ff70cd01441$export$36776f635604f274($711e8ff70cd01441$export$30a86d91af8ff6e6 = e), $711e8ff70cd01441$export$5880b8b5730aff45 = 0, [];
}
function $711e8ff70cd01441$export$45918ac1574455b1(e) {
    return $711e8ff70cd01441$export$30a86d91af8ff6e6 = "", e;
}
function $711e8ff70cd01441$export$410ac95b9ec204b8(e) {
    return $711e8ff70cd01441$export$87c2784dc9fc4ab($711e8ff70cd01441$export$58adb3bec8346d0f($711e8ff70cd01441$export$5880b8b5730aff45 - 1, $711e8ff70cd01441$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $711e8ff70cd01441$export$660b2ee2d4fb4eff(e) {
    return $711e8ff70cd01441$export$45918ac1574455b1($711e8ff70cd01441$export$5f8c09e3ae6f64e1($711e8ff70cd01441$export$2de70f21292aac9e(e)));
}
function $711e8ff70cd01441$export$7af1228ff777d175(e) {
    while($711e8ff70cd01441$export$c0306caf338ac095 = $711e8ff70cd01441$export$4d3fb11e950abb9e())if ($711e8ff70cd01441$export$c0306caf338ac095 < 33) $711e8ff70cd01441$export$48cfd1e771a65c4f();
    else break;
    return $711e8ff70cd01441$export$9e1725a4cfeada27(e) > 2 || $711e8ff70cd01441$export$9e1725a4cfeada27($711e8ff70cd01441$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $711e8ff70cd01441$export$5f8c09e3ae6f64e1(e) {
    while($711e8ff70cd01441$export$48cfd1e771a65c4f())switch($711e8ff70cd01441$export$9e1725a4cfeada27($711e8ff70cd01441$export$c0306caf338ac095)){
        case 0:
            $711e8ff70cd01441$export$10d8903dec122b9d($711e8ff70cd01441$export$c2ab62c7bf24634($711e8ff70cd01441$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $711e8ff70cd01441$export$10d8903dec122b9d($711e8ff70cd01441$export$410ac95b9ec204b8($711e8ff70cd01441$export$c0306caf338ac095), e);
            break;
        default:
            $711e8ff70cd01441$export$10d8903dec122b9d($711e8ff70cd01441$export$6788812c4e6611e6($711e8ff70cd01441$export$c0306caf338ac095), e);
    }
    return e;
}
function $711e8ff70cd01441$export$955ba06d119e085e(e, r) {
    while(--r && $711e8ff70cd01441$export$48cfd1e771a65c4f())if ($711e8ff70cd01441$export$c0306caf338ac095 < 48 || $711e8ff70cd01441$export$c0306caf338ac095 > 102 || $711e8ff70cd01441$export$c0306caf338ac095 > 57 && $711e8ff70cd01441$export$c0306caf338ac095 < 65 || $711e8ff70cd01441$export$c0306caf338ac095 > 70 && $711e8ff70cd01441$export$c0306caf338ac095 < 97) break;
    return $711e8ff70cd01441$export$58adb3bec8346d0f(e, $711e8ff70cd01441$export$e88cb2efb12ae807() + (r < 6 && $711e8ff70cd01441$export$4d3fb11e950abb9e() == 32 && $711e8ff70cd01441$export$48cfd1e771a65c4f() == 32));
}
function $711e8ff70cd01441$export$c889f2fcc19dbf12(e) {
    while($711e8ff70cd01441$export$48cfd1e771a65c4f())switch($711e8ff70cd01441$export$c0306caf338ac095){
        case e:
            return $711e8ff70cd01441$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $711e8ff70cd01441$export$c889f2fcc19dbf12($711e8ff70cd01441$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $711e8ff70cd01441$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $711e8ff70cd01441$export$48cfd1e771a65c4f();
            break;
    }
    return $711e8ff70cd01441$export$5880b8b5730aff45;
}
function $711e8ff70cd01441$export$4254d4e2b3745c4c(e, r) {
    while($711e8ff70cd01441$export$48cfd1e771a65c4f())if (e + $711e8ff70cd01441$export$c0306caf338ac095 === 57) break;
    else if (e + $711e8ff70cd01441$export$c0306caf338ac095 === 84 && $711e8ff70cd01441$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $711e8ff70cd01441$export$58adb3bec8346d0f(r, $711e8ff70cd01441$export$5880b8b5730aff45 - 1) + "*" + $711e8ff70cd01441$export$6788812c4e6611e6(e === 47 ? e : $711e8ff70cd01441$export$48cfd1e771a65c4f());
}
function $711e8ff70cd01441$export$c2ab62c7bf24634(e) {
    while(!$711e8ff70cd01441$export$9e1725a4cfeada27($711e8ff70cd01441$export$4d3fb11e950abb9e()))$711e8ff70cd01441$export$48cfd1e771a65c4f();
    return $711e8ff70cd01441$export$58adb3bec8346d0f(e, $711e8ff70cd01441$export$5880b8b5730aff45);
}
function $711e8ff70cd01441$export$ef7acd7185315e22(e) {
    return $711e8ff70cd01441$export$45918ac1574455b1($711e8ff70cd01441$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $711e8ff70cd01441$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $711e8ff70cd01441$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var O = g;
    while(w)switch(h = $, $ = $711e8ff70cd01441$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $711e8ff70cd01441$export$a9db5e087081082d(O, l - 1) == 58) {
                if ($711e8ff70cd01441$export$f8e21b1e77979a08(O += $711e8ff70cd01441$export$77ad94ebf1c2b9ed($711e8ff70cd01441$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            O += $711e8ff70cd01441$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            O += $711e8ff70cd01441$export$7af1228ff777d175(h);
            break;
        case 92:
            O += $711e8ff70cd01441$export$955ba06d119e085e($711e8ff70cd01441$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($711e8ff70cd01441$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $711e8ff70cd01441$export$10d8903dec122b9d($711e8ff70cd01441$export$4a34f930e789283c($711e8ff70cd01441$export$4254d4e2b3745c4c($711e8ff70cd01441$export$48cfd1e771a65c4f(), $711e8ff70cd01441$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    O += "/";
            }
            break;
        case 123 * b:
            u[f++] = $711e8ff70cd01441$export$36776f635604f274(O) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (p > 0 && $711e8ff70cd01441$export$36776f635604f274(O) - l) $711e8ff70cd01441$export$10d8903dec122b9d(p > 32 ? $711e8ff70cd01441$export$f8483753829ec8f3(O + ";", n, a, l - 1) : $711e8ff70cd01441$export$f8483753829ec8f3($711e8ff70cd01441$export$77ad94ebf1c2b9ed(O, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    O += ";";
                default:
                    $711e8ff70cd01441$export$10d8903dec122b9d(y = $711e8ff70cd01441$export$3307ffa7023ede1e(O, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $711e8ff70cd01441$export$98e6a39c04603d36(O, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $711e8ff70cd01441$export$a9db5e087081082d(O, 3) === 110 ? 100 : v){
                            case 100:
                            case 109:
                            case 115:
                                $711e8ff70cd01441$export$98e6a39c04603d36(e, y, y, n && $711e8ff70cd01441$export$10d8903dec122b9d($711e8ff70cd01441$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $711e8ff70cd01441$export$98e6a39c04603d36(O, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = O = "", l = t;
            break;
        case 58:
            l = 1 + $711e8ff70cd01441$export$36776f635604f274(O), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $711e8ff70cd01441$export$232faf9add678146() == 125) continue;
            }
            switch(O += $711e8ff70cd01441$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (O += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($711e8ff70cd01441$export$36776f635604f274(O) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($711e8ff70cd01441$export$4d3fb11e950abb9e() === 45) O += $711e8ff70cd01441$export$410ac95b9ec204b8($711e8ff70cd01441$export$48cfd1e771a65c4f());
                    v = $711e8ff70cd01441$export$4d3fb11e950abb9e(), o = l = $711e8ff70cd01441$export$36776f635604f274(g = O += $711e8ff70cd01441$export$c2ab62c7bf24634($711e8ff70cd01441$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $711e8ff70cd01441$export$36776f635604f274(O) == 2) b = 0;
            }
    }
    return s;
}
function $711e8ff70cd01441$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $711e8ff70cd01441$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var k = 0, g = $711e8ff70cd01441$export$2f35ab04d2335697(e, v + 1, v = $711e8ff70cd01441$export$2335f513bbd82c6d(w = u[b])), m = e; k < h; ++k)if (m = $711e8ff70cd01441$export$87c2784dc9fc4ab(w > 0 ? p[k] + " " + g : $711e8ff70cd01441$export$77ad94ebf1c2b9ed(g, /&\f/g, p[k]))) f[d++] = m;
    return $711e8ff70cd01441$export$35059013cd4a06db(e, r, a, s === 0 ? $711e8ff70cd01441$export$aa3a2e812ca8570d : i, f, o, l);
}
function $711e8ff70cd01441$export$4a34f930e789283c(e, r, a) {
    return $711e8ff70cd01441$export$35059013cd4a06db(e, r, a, $711e8ff70cd01441$export$a29989082612d0d9, $711e8ff70cd01441$export$6788812c4e6611e6($711e8ff70cd01441$export$eba6f6f03b0a92e7()), $711e8ff70cd01441$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $711e8ff70cd01441$export$f8483753829ec8f3(e, r, a, n) {
    return $711e8ff70cd01441$export$35059013cd4a06db(e, r, a, $711e8ff70cd01441$export$527d108ccf083c2b, $711e8ff70cd01441$export$2f35ab04d2335697(e, 0, n), $711e8ff70cd01441$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $711e8ff70cd01441$export$82e9f45cca5ba907(n, c, s) {
    switch($711e8ff70cd01441$export$d6af199866bfb566(n, c)){
        case 5103:
            return $711e8ff70cd01441$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $711e8ff70cd01441$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $711e8ff70cd01441$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $711e8ff70cd01441$export$39dfd62a25e0fe93 + n + $711e8ff70cd01441$export$2c0f367103c8d01c + n + $711e8ff70cd01441$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($711e8ff70cd01441$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $711e8ff70cd01441$export$39dfd62a25e0fe93 + n + $711e8ff70cd01441$export$71ad59f2e432cfe8 + $711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $711e8ff70cd01441$export$39dfd62a25e0fe93 + n + $711e8ff70cd01441$export$71ad59f2e432cfe8 + $711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $711e8ff70cd01441$export$39dfd62a25e0fe93 + n + $711e8ff70cd01441$export$71ad59f2e432cfe8 + $711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $711e8ff70cd01441$export$39dfd62a25e0fe93 + n + $711e8ff70cd01441$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $711e8ff70cd01441$export$39dfd62a25e0fe93 + n + $711e8ff70cd01441$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $711e8ff70cd01441$export$39dfd62a25e0fe93 + n + $711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $711e8ff70cd01441$export$39dfd62a25e0fe93 + "box-$1$2" + $711e8ff70cd01441$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $711e8ff70cd01441$export$39dfd62a25e0fe93 + n + $711e8ff70cd01441$export$71ad59f2e432cfe8 + "flex-item-" + $711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$711e8ff70cd01441$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $711e8ff70cd01441$export$71ad59f2e432cfe8 + "grid-row-" + $711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $711e8ff70cd01441$export$39dfd62a25e0fe93 + n + $711e8ff70cd01441$export$71ad59f2e432cfe8 + "flex-line-pack" + $711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $711e8ff70cd01441$export$39dfd62a25e0fe93 + n + $711e8ff70cd01441$export$71ad59f2e432cfe8 + $711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $711e8ff70cd01441$export$39dfd62a25e0fe93 + n + $711e8ff70cd01441$export$71ad59f2e432cfe8 + $711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $711e8ff70cd01441$export$39dfd62a25e0fe93 + "box-" + $711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, "-grow", "") + $711e8ff70cd01441$export$39dfd62a25e0fe93 + n + $711e8ff70cd01441$export$71ad59f2e432cfe8 + $711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $711e8ff70cd01441$export$39dfd62a25e0fe93 + $711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $711e8ff70cd01441$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $711e8ff70cd01441$export$77ad94ebf1c2b9ed($711e8ff70cd01441$export$77ad94ebf1c2b9ed($711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $711e8ff70cd01441$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $711e8ff70cd01441$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $711e8ff70cd01441$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $711e8ff70cd01441$export$77ad94ebf1c2b9ed($711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $711e8ff70cd01441$export$39dfd62a25e0fe93 + "box-pack:$3" + $711e8ff70cd01441$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $711e8ff70cd01441$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$711e8ff70cd01441$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $711e8ff70cd01441$export$71ad59f2e432cfe8 + "grid-column-align" + $711e8ff70cd01441$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $711e8ff70cd01441$export$71ad59f2e432cfe8 + $711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $711e8ff70cd01441$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$711e8ff70cd01441$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $711e8ff70cd01441$export$71ad59f2e432cfe8 + $711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $711e8ff70cd01441$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$711e8ff70cd01441$export$f8e21b1e77979a08(s, "span") ? $711e8ff70cd01441$export$4659b591c19bdf3d(s, /\d+/) : +$711e8ff70cd01441$export$4659b591c19bdf3d(s, /\d+/) - +$711e8ff70cd01441$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $711e8ff70cd01441$export$71ad59f2e432cfe8 + $711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $711e8ff70cd01441$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $711e8ff70cd01441$export$71ad59f2e432cfe8 + $711e8ff70cd01441$export$77ad94ebf1c2b9ed($711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $711e8ff70cd01441$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($711e8ff70cd01441$export$36776f635604f274(n) - 1 - c > 6) switch($711e8ff70cd01441$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($711e8ff70cd01441$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $711e8ff70cd01441$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $711e8ff70cd01441$export$2c0f367103c8d01c + ($711e8ff70cd01441$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$711e8ff70cd01441$export$f8e21b1e77979a08(n, "stretch") ? $711e8ff70cd01441$export$82e9f45cca5ba907($711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $711e8ff70cd01441$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $711e8ff70cd01441$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($711e8ff70cd01441$export$a9db5e087081082d(n, c + 6) === 121) return $711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, ":", ":" + $711e8ff70cd01441$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($711e8ff70cd01441$export$a9db5e087081082d(n, $711e8ff70cd01441$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $711e8ff70cd01441$export$39dfd62a25e0fe93 + ($711e8ff70cd01441$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $711e8ff70cd01441$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $711e8ff70cd01441$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, ":", ":" + $711e8ff70cd01441$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $711e8ff70cd01441$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $711e8ff70cd01441$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $711e8ff70cd01441$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $711e8ff70cd01441$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $711e8ff70cd01441$export$a763edbf796b780a:
        case $711e8ff70cd01441$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $711e8ff70cd01441$export$a29989082612d0d9:
            return "";
        case $711e8ff70cd01441$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $711e8ff70cd01441$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $711e8ff70cd01441$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $711e8ff70cd01441$export$36776f635604f274(a = $711e8ff70cd01441$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $711e8ff70cd01441$export$5a7767152ae0305f(e) {
    var r = $711e8ff70cd01441$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $711e8ff70cd01441$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $711e8ff70cd01441$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $711e8ff70cd01441$export$527d108ccf083c2b:
                n.return = $711e8ff70cd01441$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $711e8ff70cd01441$export$b44a8529a35fcb60:
                return $711e8ff70cd01441$export$dfdc1655ccc5b9cb([
                    $711e8ff70cd01441$export$784d13d8ee351f07(n, {
                        value: $711e8ff70cd01441$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $711e8ff70cd01441$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $711e8ff70cd01441$export$aa3a2e812ca8570d:
                if (n.length) return $711e8ff70cd01441$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($711e8ff70cd01441$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $711e8ff70cd01441$export$dfdc1655ccc5b9cb([
                                $711e8ff70cd01441$export$784d13d8ee351f07(n, {
                                    props: [
                                        $711e8ff70cd01441$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $711e8ff70cd01441$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $711e8ff70cd01441$export$dfdc1655ccc5b9cb([
                                $711e8ff70cd01441$export$784d13d8ee351f07(n, {
                                    props: [
                                        $711e8ff70cd01441$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $711e8ff70cd01441$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $711e8ff70cd01441$export$784d13d8ee351f07(n, {
                                    props: [
                                        $711e8ff70cd01441$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $711e8ff70cd01441$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $711e8ff70cd01441$export$784d13d8ee351f07(n, {
                                    props: [
                                        $711e8ff70cd01441$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $711e8ff70cd01441$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $711e8ff70cd01441$export$76a88f7de6507443(e) {
    switch(e.type){
        case $711e8ff70cd01441$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $711e8ff70cd01441$export$1be1fc439b849fdf($711e8ff70cd01441$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($711e8ff70cd01441$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $711e8ff70cd01441$export$2f35ab04d2335697(r, 1, $711e8ff70cd01441$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $711e8ff70cd01441$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $711e8ff70cd01441$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $711e8ff70cd01441$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("iK3AD", function(module, exports) {
var $da4f4ec51c5fde7c$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $da4f4ec51c5fde7c$export$2e2bcd8739ae039 = $da4f4ec51c5fde7c$var$weakMemoize;

});

parcelRegister("4o2oX", function(module, exports) {
function $331b44304454e0ad$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("hp0gY", function(module, exports) {

$parcel$export(module.exports, "h", function () { return $cab4fb9dfae85193$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "C", function () { return $cab4fb9dfae85193$export$e7094788287c5e9b; });
$parcel$export(module.exports, "_", function () { return $cab4fb9dfae85193$export$71511d61b312f219; });
$parcel$export(module.exports, "w", function () { return $cab4fb9dfae85193$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $cab4fb9dfae85193$export$971d5caa766a69d7; });
$parcel$export(module.exports, "u", function () { return $cab4fb9dfae85193$export$3b14a55fb2447963; });
$parcel$export(module.exports, "a", function () { return $cab4fb9dfae85193$export$407448d2b89b1813; });
$parcel$export(module.exports, "b", function () { return $cab4fb9dfae85193$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "c", function () { return $cab4fb9dfae85193$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $cab4fb9dfae85193$export$a9c23c6ac3fc3eca; });

var $9nHZC = parcelRequire("9nHZC");

var $3hca7 = parcelRequire("3hca7");

var $ii97e = parcelRequire("ii97e");

var $lr19y = parcelRequire("lr19y");

var $7AYpb = parcelRequire("7AYpb");

var $7Eyl7 = parcelRequire("7Eyl7");

var $9xCOS = parcelRequire("9xCOS");

var $gxh9m = parcelRequire("gxh9m");
var $cab4fb9dfae85193$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $cab4fb9dfae85193$var$EmotionCacheContext = /* #__PURE__ */ (0, $9nHZC.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $3hca7.default)({
    key: "css"
}) : null);
var $cab4fb9dfae85193$export$e7094788287c5e9b = $cab4fb9dfae85193$var$EmotionCacheContext.Provider;
var $cab4fb9dfae85193$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $9nHZC.useContext)($cab4fb9dfae85193$var$EmotionCacheContext);
};
var $cab4fb9dfae85193$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $9nHZC.useContext)($cab4fb9dfae85193$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $cab4fb9dfae85193$export$971d5caa766a69d7 = /* #__PURE__ */ (0, $9nHZC.createContext)({});
var $cab4fb9dfae85193$export$3b14a55fb2447963 = function useTheme() {
    return (0, $9nHZC.useContext)($cab4fb9dfae85193$export$971d5caa766a69d7);
};
var $cab4fb9dfae85193$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $ii97e.default)({}, outerTheme, theme);
};
var $cab4fb9dfae85193$var$createCacheWithTheme = /* #__PURE__ */ (0, $lr19y.default)(function(outerTheme) {
    return (0, $lr19y.default)(function(theme) {
        return $cab4fb9dfae85193$var$getTheme(outerTheme, theme);
    });
});
var $cab4fb9dfae85193$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = (0, $9nHZC.useContext)($cab4fb9dfae85193$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $cab4fb9dfae85193$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ (0, $9nHZC.createElement)($cab4fb9dfae85193$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $cab4fb9dfae85193$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = (0, $9nHZC.useContext)($cab4fb9dfae85193$export$971d5caa766a69d7);
        return /*#__PURE__*/ (0, $9nHZC.createElement)(Component, (0, $ii97e.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ (0, $9nHZC.forwardRef)(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $7AYpb.default)(WithTheme, Component);
}
var $cab4fb9dfae85193$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $cab4fb9dfae85193$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $cab4fb9dfae85193$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $cab4fb9dfae85193$var$getLastPart(match[1]);
    return undefined;
};
var $cab4fb9dfae85193$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $cab4fb9dfae85193$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $cab4fb9dfae85193$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $cab4fb9dfae85193$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($cab4fb9dfae85193$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $cab4fb9dfae85193$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $cab4fb9dfae85193$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $cab4fb9dfae85193$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $cab4fb9dfae85193$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($cab4fb9dfae85193$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$cab4fb9dfae85193$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $cab4fb9dfae85193$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $7Eyl7.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $gxh9m.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $7Eyl7.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $cab4fb9dfae85193$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $cab4fb9dfae85193$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$cab4fb9dfae85193$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $7Eyl7.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $9xCOS.serializeStyles)(registeredStyles, undefined, (0, $9nHZC.useContext)($cab4fb9dfae85193$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($cab4fb9dfae85193$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $cab4fb9dfae85193$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ (0, $9nHZC.createElement)((0, $9nHZC.Fragment), null, /*#__PURE__*/ (0, $9nHZC.createElement)($cab4fb9dfae85193$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ (0, $9nHZC.createElement)(WrappedComponent, newProps));
});

});
parcelRegister("lr19y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9ad03926206530b$export$2e2bcd8739ae039; });
var $f9ad03926206530b$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $f9ad03926206530b$export$2e2bcd8739ae039 = $f9ad03926206530b$var$weakMemoize;

});

parcelRegister("7AYpb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $587ac06be949d985$export$2e2bcd8739ae039; });

var $1t1PC = parcelRequire("1t1PC");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $587ac06be949d985$var$hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1t1PC)))(targetComponent, sourceComponent);
};
var $587ac06be949d985$export$2e2bcd8739ae039 = $587ac06be949d985$var$hoistNonReactStatics;

});

parcelRegister("7Eyl7", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $5926e7f20168875b$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $5926e7f20168875b$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $5926e7f20168875b$export$6f077d94b33a01aa; });
var $5926e7f20168875b$var$isBrowser = typeof document !== "undefined";
function $5926e7f20168875b$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $5926e7f20168875b$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5926e7f20168875b$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5926e7f20168875b$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5926e7f20168875b$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = "";
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            if (!$5926e7f20168875b$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5926e7f20168875b$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("9xCOS", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $6f254ee56dc947d4$export$6321afa313b251b5; });

var $LzBsJ = parcelRequire("LzBsJ");

var $eiQtu = parcelRequire("eiQtu");

var $9G7bF = parcelRequire("9G7bF");
var $6f254ee56dc947d4$var$isDevelopment = false;
var $6f254ee56dc947d4$var$hyphenateRegex = /[A-Z]|^ms/g;
var $6f254ee56dc947d4$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $6f254ee56dc947d4$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $6f254ee56dc947d4$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $6f254ee56dc947d4$var$processStyleName = /* #__PURE__ */ (0, $9G7bF.default)(function(styleName) {
    return $6f254ee56dc947d4$var$isCustomProperty(styleName) ? styleName : styleName.replace($6f254ee56dc947d4$var$hyphenateRegex, "-$&").toLowerCase();
});
var $6f254ee56dc947d4$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($6f254ee56dc947d4$var$animationRegex, function(match, p1, p2) {
                $6f254ee56dc947d4$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $6f254ee56dc947d4$var$cursor
                };
                return p1;
            });
    }
    if ((0, $eiQtu.default)[key] !== 1 && !$6f254ee56dc947d4$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $6f254ee56dc947d4$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $6f254ee56dc947d4$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $6f254ee56dc947d4$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $6f254ee56dc947d4$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $6f254ee56dc947d4$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $6f254ee56dc947d4$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $6f254ee56dc947d4$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $6f254ee56dc947d4$var$cursor;
                var result = interpolation(mergedProps);
                $6f254ee56dc947d4$var$cursor = previousCursor;
                return $6f254ee56dc947d4$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $6f254ee56dc947d4$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $6f254ee56dc947d4$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($6f254ee56dc947d4$var$isProcessableValue(asString)) string += $6f254ee56dc947d4$var$processStyleName(key) + ":" + $6f254ee56dc947d4$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === "NO_COMPONENT_SELECTOR" && $6f254ee56dc947d4$var$isDevelopment) throw new Error($6f254ee56dc947d4$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($6f254ee56dc947d4$var$isProcessableValue(value[_i])) string += $6f254ee56dc947d4$var$processStyleName(key) + ":" + $6f254ee56dc947d4$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $6f254ee56dc947d4$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case "animation":
                    case "animationName":
                        string += $6f254ee56dc947d4$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $6f254ee56dc947d4$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list
var $6f254ee56dc947d4$var$cursor;
function $6f254ee56dc947d4$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $6f254ee56dc947d4$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $6f254ee56dc947d4$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $6f254ee56dc947d4$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    }
    $6f254ee56dc947d4$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $6f254ee56dc947d4$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $LzBsJ.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $6f254ee56dc947d4$var$cursor
    };
}

});
parcelRegister("LzBsJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08f001f626f69141$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $08f001f626f69141$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("eiQtu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a69b737fe9b997bc$export$2e2bcd8739ae039; });
var $a69b737fe9b997bc$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});

parcelRegister("9G7bF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70bd9c82422bfadc$export$2e2bcd8739ae039; });
function $70bd9c82422bfadc$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("gxh9m", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $c09d080e50903fe8$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $c09d080e50903fe8$export$811a713a7276cb9d; });

var $9nHZC = parcelRequire("9nHZC");
var $c09d080e50903fe8$var$isBrowser = typeof document !== "undefined";
var $c09d080e50903fe8$var$syncFallback = function syncFallback(create) {
    return create();
};
var $c09d080e50903fe8$var$useInsertionEffect = $9nHZC.useInsertionEffect ? $9nHZC.useInsertionEffect : false;
var $c09d080e50903fe8$export$db21c7ffa21794e7 = !$c09d080e50903fe8$var$isBrowser ? $c09d080e50903fe8$var$syncFallback : $c09d080e50903fe8$var$useInsertionEffect || $c09d080e50903fe8$var$syncFallback;
var $c09d080e50903fe8$export$811a713a7276cb9d = $c09d080e50903fe8$var$useInsertionEffect || $9nHZC.useLayoutEffect;

});




parcelRegister("4b221", function(module, exports) {

$parcel$export(module.exports, "Fade", function () { return $30a9c3f0addde856$export$c983850c6c9d8b0e; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $3Jogu = parcelRequire("3Jogu");
function $30a9c3f0addde856$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $30a9c3f0addde856$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $30a9c3f0addde856$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $30a9c3f0addde856$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $30a9c3f0addde856$var$duration = {
    enter: 0,
    exit: 100
};
var $30a9c3f0addde856$export$c983850c6c9d8b0e = function Fade(_ref) {
    var hasEntered = _ref.hasEntered, children = _ref.children, onExited = _ref.onExited;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3Jogu.default), {
        in: hasEntered,
        timeout: $30a9c3f0addde856$var$duration,
        onExited: onExited,
        unmountOnExit: true,
        appear: true
    }, function(status) {
        var base = {
            transition: "opacity ".concat($30a9c3f0addde856$var$duration.exit, "ms"),
            opacity: 0
        };
        var anim = {
            entered: {
                opacity: 1
            },
            exiting: {
                opacity: 0
            }
        };
        var style = $30a9c3f0addde856$var$_objectSpread($30a9c3f0addde856$var$_objectSpread({}, base), anim[status]);
        return children(style);
    });
};

});
parcelRegister("3Jogu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b78659110b9eea4$export$2e2bcd8739ae039; });

var $4dya5 = parcelRequire("4dya5");

var $fXGwT = parcelRequire("fXGwT");


var $9nHZC = parcelRequire("9nHZC");

var $lnOmc = parcelRequire("lnOmc");

var $1WuHg = parcelRequire("1WuHg");


var $dgjLk = parcelRequire("dgjLk");
var $2b78659110b9eea4$export$bb38bb9a1161268 = "unmounted";
var $2b78659110b9eea4$export$84cbff306f539230 = "exited";
var $2b78659110b9eea4$export$df38205c966be359 = "entering";
var $2b78659110b9eea4$export$78e9e6e3e014d60a = "entered";
var $2b78659110b9eea4$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $2b78659110b9eea4$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $fXGwT.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $2b78659110b9eea4$export$84cbff306f539230;
                _this.appearStatus = $2b78659110b9eea4$export$df38205c966be359;
            } else initialStatus = $2b78659110b9eea4$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $2b78659110b9eea4$export$bb38bb9a1161268;
        else initialStatus = $2b78659110b9eea4$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $2b78659110b9eea4$export$bb38bb9a1161268) return {
            status: $2b78659110b9eea4$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $2b78659110b9eea4$export$df38205c966be359 && status !== $2b78659110b9eea4$export$78e9e6e3e014d60a) nextStatus = $2b78659110b9eea4$export$df38205c966be359;
            } else if (status === $2b78659110b9eea4$export$df38205c966be359 || status === $2b78659110b9eea4$export$78e9e6e3e014d60a) nextStatus = $2b78659110b9eea4$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $2b78659110b9eea4$export$df38205c966be359) this.performEnter(mounting);
            else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $2b78659110b9eea4$export$84cbff306f539230) this.setState({
            status: $2b78659110b9eea4$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($lnOmc))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $1WuHg.default).disabled) {
            this.safeSetState({
                status: $2b78659110b9eea4$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $2b78659110b9eea4$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $2b78659110b9eea4$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($lnOmc))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $1WuHg.default).disabled) {
            this.safeSetState({
                status: $2b78659110b9eea4$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $2b78659110b9eea4$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $2b78659110b9eea4$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($lnOmc))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $2b78659110b9eea4$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $4dya5.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dgjLk.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component);
$2b78659110b9eea4$var$Transition.contextType = (0, $dgjLk.default);
$2b78659110b9eea4$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $2b78659110b9eea4$var$noop() {}
$2b78659110b9eea4$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $2b78659110b9eea4$var$noop,
    onEntering: $2b78659110b9eea4$var$noop,
    onEntered: $2b78659110b9eea4$var$noop,
    onExit: $2b78659110b9eea4$var$noop,
    onExiting: $2b78659110b9eea4$var$noop,
    onExited: $2b78659110b9eea4$var$noop
};
$2b78659110b9eea4$var$Transition.UNMOUNTED = $2b78659110b9eea4$export$bb38bb9a1161268;
$2b78659110b9eea4$var$Transition.EXITED = $2b78659110b9eea4$export$84cbff306f539230;
$2b78659110b9eea4$var$Transition.ENTERING = $2b78659110b9eea4$export$df38205c966be359;
$2b78659110b9eea4$var$Transition.ENTERED = $2b78659110b9eea4$export$78e9e6e3e014d60a;
$2b78659110b9eea4$var$Transition.EXITING = $2b78659110b9eea4$export$4aacc83d4d59139f;
var $2b78659110b9eea4$export$2e2bcd8739ae039 = $2b78659110b9eea4$var$Transition;

});
parcelRegister("fXGwT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9ed5b33e01a4ed3$export$2e2bcd8739ae039; });

var $beNtY = parcelRequire("beNtY");
function $b9ed5b33e01a4ed3$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $beNtY.default)(t, o);
}

});
parcelRegister("beNtY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82e762b3f063404c$export$2e2bcd8739ae039; });
function $82e762b3f063404c$export$2e2bcd8739ae039(t, e) {
    return $82e762b3f063404c$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $82e762b3f063404c$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("1WuHg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16a304f5d49e46fe$export$2e2bcd8739ae039; });
var $16a304f5d49e46fe$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("dgjLk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a7c195c1f3adc76$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");
var $9a7c195c1f3adc76$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createContext(null);

});




parcelRegister("6x4M3", function(module, exports) {
$parcel$export(module.exports, "ConnectIframe", function () { return (parcelRequire("5y4no")).default; });
$parcel$export(module.exports, "ConnectIframes", function () { return (parcelRequire("6D09s")).default; });
$parcel$export(module.exports, "ConnectModuleIframe", function () { return (parcelRequire("qh48v")).default; });
$parcel$export(module.exports, "ConnectModules", function () { return (parcelRequire("4yK0k")).default; });
$parcel$export(module.exports, "FileEditor", function () { return (parcelRequire("stBBD")).default; });
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("1WaGk")).default; });
$parcel$export(module.exports, "WebItems", function () { return (parcelRequire("g3o6D")).default; });
parcelRequire("4JPAe");

});
parcelRegister("4JPAe", function(module, exports) {

$parcel$export(module.exports, "WebItems", function () { return (parcelRequire("g3o6D")).default; });
$parcel$export(module.exports, "FileEditor", function () { return (parcelRequire("stBBD")).default; });
$parcel$export(module.exports, "ConnectIframes", function () { return (parcelRequire("6D09s")).default; });
$parcel$export(module.exports, "ConnectIframe", function () { return (parcelRequire("5y4no")).default; });
$parcel$export(module.exports, "ConnectModuleIframe", function () { return (parcelRequire("qh48v")).default; });
$parcel$export(module.exports, "ConnectModules", function () { return (parcelRequire("4yK0k")).default; });
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("1WaGk")).default; });
// Higher level components

var $g3o6D = parcelRequire("g3o6D");

var $8yYpP = parcelRequire("8yYpP");

var $stBBD = parcelRequire("stBBD");

var $5jZxZ = parcelRequire("5jZxZ");

var $gNnCu = parcelRequire("gNnCu");

var $4fayc = parcelRequire("4fayc");

var $5VrJZ = parcelRequire("5VrJZ");

var $iiGhh = parcelRequire("iiGhh");

var $6D09s = parcelRequire("6D09s");

var $5y4no = parcelRequire("5y4no");

var $qh48v = parcelRequire("qh48v");

var $kXHjP = parcelRequire("kXHjP");

var $4yK0k = parcelRequire("4yK0k");

var $7SwUm = parcelRequire("7SwUm");

var $fwy1w = parcelRequire("fwy1w");

var $9nekP = parcelRequire("9nekP");

var $gX1I5 = parcelRequire("gX1I5");

var $1WaGk = parcelRequire("1WaGk");

var $eIoiN = parcelRequire("eIoiN");

});
parcelRegister("g3o6D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c97b39cf645869e$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $dEKDm = parcelRequire("dEKDm");

var $4yK0k = parcelRequire("4yK0k");

var $eIoiN = parcelRequire("eIoiN");

var $gzRhZ = parcelRequire("gzRhZ");
const $1c97b39cf645869e$var$WebItemLoader = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dEKDm.default), {
        size: "small"
    });
const $1c97b39cf645869e$var$WebItemLoaderFailed = ()=>null;
var $1c97b39cf645869e$export$2e2bcd8739ae039 = (0, $eIoiN.default)(({ children: children, loadingComponent: Loading = $1c97b39cf645869e$var$WebItemLoader, loadingFailedComponent: LoadingFailed = $1c97b39cf645869e$var$WebItemLoaderFailed, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $4yK0k.ConnectModules), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        moduleType: "webItems"
    }), ({ modules: modules, loading: loading, error: error })=>{
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(LoadingFailed, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
            loadingFailedComponent: $1c97b39cf645869e$var$WebItemLoaderFailed
        }));
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Loading, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
            loadingComponent: $1c97b39cf645869e$var$WebItemLoader
        }));
        const items = modules.map((m)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $gzRhZ.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
                module: m,
                key: m.id
            })));
        return typeof children === "function" ? children(items) : items.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, items) : false;
    }));

});
parcelRegister("dEKDm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f132f48b32f1ac7$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $5fUc4 = parcelRequire("5fUc4");

var $jp7ng = parcelRequire("jp7ng");

var $5LVXk = parcelRequire("5LVXk");

var $3aWJd = parcelRequire("3aWJd");
/**
 * Returns the appropriate circle stroke color.
 */ function $9f132f48b32f1ac7$var$getStrokeColor(_ref) {
    var mode = _ref.mode, appearance = _ref.appearance;
    if (mode === "light") return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $jp7ng.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $jp7ng.N0), ")");
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $jp7ng.DN900), ")") : "var(--ds-icon-inverse, ".concat((0, $jp7ng.DN500), ")");
}
var $9f132f48b32f1ac7$var$rotate = (0, $avKww.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $9f132f48b32f1ac7$var$rotateStyles = (0, $avKww.css)({
    animation: "".concat($9f132f48b32f1ac7$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $9f132f48b32f1ac7$var$loadIn = (0, $avKww.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $9f132f48b32f1ac7$var$loadInStyles = (0, $avKww.css)({
    animation: "".concat($9f132f48b32f1ac7$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $9f132f48b32f1ac7$var$wrapperStyles = (0, $avKww.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $9f132f48b32f1ac7$var$circleStyles = (0, $avKww.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $9f132f48b32f1ac7$var$useLayoutEffect = typeof window === "undefined" ? (0, $9nHZC.useEffect) : (0, $9nHZC.useLayoutEffect);
var $9f132f48b32f1ac7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function Spinner(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "inherit" : _ref2$appearance, _ref2$delay = _ref2.delay, delay = _ref2$delay === void 0 ? 0 : _ref2$delay, interactionName = _ref2.interactionName, label = _ref2.label, _ref2$size = _ref2.size, providedSize = _ref2$size === void 0 ? "medium" : _ref2$size, testId = _ref2.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $3aWJd.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var _useGlobalTheme = (0, $5LVXk.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var stroke = $9f132f48b32f1ac7$var$getStrokeColor({
        mode: mode,
        appearance: appearance
    });
    var context = (0, $9nHZC.useContext)((0, $5fUc4.default));
    $9f132f48b32f1ac7$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $avKww.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $9f132f48b32f1ac7$var$wrapperStyles,
            $9f132f48b32f1ac7$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $avKww.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label,
        css: $9f132f48b32f1ac7$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        }
    }, (0, $avKww.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $9f132f48b32f1ac7$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));

});
parcelRegister("5LVXk", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", function () { return $433e4c635ec03d38$export$7692396083754928; });
$parcel$export(module.exports, "default", function () { return $433e4c635ec03d38$export$2e2bcd8739ae039; });

var $dHFxE = parcelRequire("dHFxE");
// Create default global light theme
var $433e4c635ec03d38$var$_createTheme = (0, $dHFxE.createTheme)(function() {
    return {
        mode: "light"
    };
}), $433e4c635ec03d38$var$Provider = $433e4c635ec03d38$var$_createTheme.Provider, $433e4c635ec03d38$var$Consumer = $433e4c635ec03d38$var$_createTheme.Consumer, $433e4c635ec03d38$export$7692396083754928 = $433e4c635ec03d38$var$_createTheme.useTheme;
var $433e4c635ec03d38$var$Theme = {
    Provider: $433e4c635ec03d38$var$Provider,
    Consumer: $433e4c635ec03d38$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$433e4c635ec03d38$export$2e2bcd8739ae039 = $433e4c635ec03d38$var$Theme;

});
parcelRegister("dHFxE", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $9f9f83dc95bd1e6f$export$25d302a5b900a763; });

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");
var $9f9f83dc95bd1e6f$var$_excluded = [
    "children"
];
function $9f9f83dc95bd1e6f$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $9nHZC.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $9nHZC.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(props, $9f9f83dc95bd1e6f$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $9nHZC.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $9nHZC.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("3aWJd", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $24ffdc7e510ef350$export$4e9f1640bbe7a1a8; });
var $24ffdc7e510ef350$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("4yK0k", function(module, exports) {

$parcel$export(module.exports, "ConnectModules", function () { return $9c709005c707c3e1$export$6fd3428b668de5ab; });
$parcel$export(module.exports, "default", function () { return $9c709005c707c3e1$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $eIoiN = parcelRequire("eIoiN");

var $9gkf9 = parcelRequire("9gkf9");

var $gMl0m = parcelRequire("gMl0m");
class $9c709005c707c3e1$export$6fd3428b668de5ab extends $9nHZC.Component {
    constructor(props){
        super(props);
        this.props = void 0;
        this.state = void 0;
        this.getModules = void 0;
        this.loadModules = (connectProps)=>{
            if (!this.state.loading) return;
            const { query: query, moduleType: moduleType, moduleKey: moduleKey, moduleId: moduleId, location: location, targetHref: targetHref, appKey: appKey } = connectProps;
            const { principalId: principalId, target: target } = this.state;
            if (!principalId) return;
            const requests = query || [
                {
                    target: target,
                    modules: [
                        {
                            moduleType: moduleType,
                            moduleKey: moduleKey,
                            moduleId: moduleId,
                            location: location,
                            targetHref: targetHref,
                            appKey: appKey
                        }
                    ]
                }
            ];
            this.getModules = new (0, $gMl0m.default)((_, resolve, reject)=>{
                connectProps.addonManager.getModules(principalId, ...requests).then(resolve).catch(reject);
            });
            this.getModules.then((modules)=>{
                this.setState({
                    modules: modules,
                    loading: false
                });
            })// @ts-ignore TODO: fix noImplicitAny error here
            .catch((error)=>{
                if (this.getModules && this.getModules.canceled) return;
                this.setState({
                    error: error,
                    loading: false
                });
            });
        };
        this.setup = (connectProps)=>{
            const { addonManager: addonManager, module: mod, modules: modules = [] } = connectProps;
            if (mod) {
                this.setState({
                    loading: false,
                    modules: [
                        mod
                    ]
                });
                return;
            }
            if ((0, $9gkf9.isArray)(modules) && modules.length) {
                this.setState({
                    loading: false,
                    modules: modules
                });
                return;
            }
            const cachedModules = connectProps.cacheResolver && connectProps.cacheResolver(connectProps);
            if ((0, $9gkf9.isArray)(cachedModules) && cachedModules.length) {
                this.setState({
                    loading: false,
                    modules: cachedModules
                });
                return;
            }
            const { targetHref: targetHref } = connectProps;
            let { principalId: principalId, target: target } = connectProps;
            // if this module has expired, we need to call the modules API to fetch new data
            // we do this by attaching the target from cache to the request
            if (!target && targetHref && addonManager.targets.has(targetHref)) {
                const tar = addonManager.targets.get(targetHref);
                if (tar) {
                    /* eslint-disable prefer-destructuring */ principalId = tar.principalId;
                    target = tar.target;
                /* eslint-enable prefer-destructuring */ }
            }
            this.setState({
                loading: true,
                principalId: principalId,
                target: target,
                modules: []
            });
        };
        this.state = {
            modules: [],
            loading: false,
            error: null
        };
    }
    /* eslint react/no-unsafe: warn */ UNSAFE_componentWillMount() {
        this.setup(this.props);
    }
    componentDidMount() {
        this.loadModules(this.props);
        if (typeof this.props.onMount === "function") this.props.onMount(this.state);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setup(nextProps);
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (// check props
        this.props.principalId === nextProps.principalId && this.props.moduleType === nextProps.moduleType && this.props.moduleKey === nextProps.moduleKey && this.props.moduleId === nextProps.moduleId && this.props.location === nextProps.location && this.props.targetHref === nextProps.targetHref && this.props.appKey === nextProps.appKey && this.props.target === nextProps.target && this.props.query === nextProps.query && // check state
        this.state.loading === nextState.loading && this.state.principalId === nextState.principalId && this.state.error === nextState.error && this.state.principalId === nextState.principalId && this.state.modules.length === nextState.modules.length && this.state.modules.every((val, index)=>val === nextState.modules[index])) {
            const cachedModules = nextProps.cacheResolver && nextProps.cacheResolver(nextProps);
            return !(0, $9gkf9.isArray)(cachedModules) || cachedModules.length <= 0;
        }
        return true;
    }
    componentWillUnmount() {
        if (this.getModules) this.getModules.cancel();
    }
    // eslint-disable-next-line react/sort-comp
    componentDidUpdate() {
        this.loadModules(this.props);
        if (typeof this.props.onUpdate === "function") this.props.onUpdate(this.state);
    }
    render() {
        if (typeof this.props.children === "function") return this.props.children(this.state);
        return null;
    }
}
$9c709005c707c3e1$export$6fd3428b668de5ab.defaultProps = {
    /* eslint react/default-props-match-prop-types: warn */ options: {},
    cacheResolver: (props)=>{
        if ((0, $9gkf9.isArray)(props.query) && props.query.length > 0) return props.query.reduce((mods, req)=>{
            return mods.concat(props.addonManager.filterModules(...req.modules.map((c)=>({
                    ...c,
                    targetHref: (0, $9gkf9.getObjectValue)(req.target, "links.self.href", "")
                }))));
        }, []);
        const { moduleId: moduleId, appKey: appKey, moduleKey: moduleKey, moduleType: moduleType, location: location } = props;
        return props.addonManager.filterModules({
            moduleId: moduleId,
            appKey: appKey,
            moduleKey: moduleKey,
            moduleType: moduleType,
            location: location,
            targetHref: (0, $9gkf9.getObjectValue)(props.target, "links.self.href", props.targetHref)
        });
    }
};
var $9c709005c707c3e1$export$2e2bcd8739ae039 = (0, $eIoiN.default)($9c709005c707c3e1$export$6fd3428b668de5ab);

});
parcelRegister("eIoiN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04f88a5bdc6f5848$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");
function $04f88a5bdc6f5848$export$2e2bcd8739ae039(Component) {
    var _class;
    return _class = class extends (0, $9nHZC.PureComponent) {
        constructor(...args){
            super(...args);
            this.context = void 0;
        }
        /* eslint react/sort-comp:warn */ render() {
            const { connectHost: connectHost, addonManager: addonManager, analyticsEventHandler: analyticsEventHandler, dialogProvider: dialogProvider, inlineDialogProvider: inlineDialogProvider, flagProvider: flagProvider, messageProvider: messageProvider } = this.context;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, this.props, {
                connectHost: connectHost,
                addonManager: addonManager,
                analyticsEventHandler: analyticsEventHandler,
                providers: {
                    dialogProvider: dialogProvider,
                    inlineDialogProvider: inlineDialogProvider,
                    flagProvider: flagProvider,
                    messageProvider: messageProvider
                }
            }));
        }
    }, _class.component = Component, _class.contextTypes = {
        connectHost: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).object.isRequired,
        addonManager: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).object.isRequired,
        analyticsEventHandler: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
        dialogProvider: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).object,
        inlineDialogProvider: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).object,
        flagProvider: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).object,
        messageProvider: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).object
    }, _class;
}

});

parcelRegister("9gkf9", function(module, exports) {

$parcel$export(module.exports, "isObject", function () { return $5c4867b67e1bccc9$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isArray", function () { return $5c4867b67e1bccc9$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isFunction", function () { return $5c4867b67e1bccc9$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isNumeric", function () { return $5c4867b67e1bccc9$export$e90fb89750dba83f; });
$parcel$export(module.exports, "getObjectValue", function () { return $5c4867b67e1bccc9$export$e1a3353b722e75de; });
function $5c4867b67e1bccc9$export$844ec244b1367d54(str) {
    return typeof str === "string" || str instanceof String;
}
function $5c4867b67e1bccc9$export$a6cdc56e425d0d0a(obj) {
    return typeof obj === "object" && obj !== null && !Array.isArray(obj) && !(obj instanceof RegExp) && !(obj instanceof Date);
}
function $5c4867b67e1bccc9$export$43bee75e5e14138e(array) {
    return Array.isArray && Array.isArray(array) || array && typeof array.length === "number" && array.constructor === Array;
}
function $5c4867b67e1bccc9$export$f6e2535fb5126e54(fn) {
    return fn && ({}).toString.call(fn) === "[object Function]";
}
function $5c4867b67e1bccc9$export$e90fb89750dba83f(value, base = 10) {
    const parsedInt = parseInt(value, base);
    return !isNaN(parsedInt);
}
function $5c4867b67e1bccc9$export$e1a3353b722e75de(obj, path, defaultValue) {
    return $5c4867b67e1bccc9$export$844ec244b1367d54(path) && $5c4867b67e1bccc9$export$a6cdc56e425d0d0a(obj) && path.split(".")// @ts-ignore TODO: fix noImplicitAny error here
    .reduce((o, k)=>$5c4867b67e1bccc9$export$a6cdc56e425d0d0a(o) ? o[k] : "", obj) || defaultValue;
}
function $5c4867b67e1bccc9$export$7656ccea645fe24c(obj, path) {
    return $5c4867b67e1bccc9$export$a6cdc56e425d0d0a($5c4867b67e1bccc9$export$e1a3353b722e75de(obj, path));
}

});

parcelRegister("gMl0m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c73172ea815745a6$export$2e2bcd8739ae039; });
/* eslint-disable no-underscore-dangle */ class $c73172ea815745a6$export$d7f5e52d091a66db extends Error {
    constructor(){
        super("Promise was canceled");
        this.name = "CancelError";
    }
}
var $c73172ea815745a6$export$2e2bcd8739ae039;
$c73172ea815745a6$export$2e2bcd8739ae039 = class PCancelable {
    static fn(fn) {
        return (...args)=>{
            return new PCancelable((onCancel, resolve, reject)=>{
                args.unshift(onCancel);
                // eslint-disable-next-line prefer-spread
                fn.apply(null, args).then(resolve, reject);
            });
        };
    }
    constructor(executor){
        this._pending = void 0;
        this._canceled = void 0;
        this._cancel = void 0;
        this._reject = void 0;
        this._promise = void 0;
        this._pending = true;
        this._canceled = false;
        this._promise = new Promise((resolve, reject)=>{
            this._reject = reject;
            return executor((fn)=>{
                this._cancel = fn;
            }, (val)=>{
                this._pending = false;
                resolve(val);
            }, (err)=>{
                this._pending = false;
                reject(err);
            });
        });
    }
    then(onFulfilled, onRejected) {
        return this._promise.then.call(this._promise, onFulfilled, onRejected);
    }
    catch(error) {
        return this._promise.catch.call(this._promise, error);
    }
    cancel() {
        if (!this._pending || this._canceled) return;
        if (typeof this._cancel === "function") try {
            this._cancel();
        } catch (err) {
            this._reject(err);
        }
        this._canceled = true;
        this._reject(new $c73172ea815745a6$export$d7f5e52d091a66db());
    }
    get canceled() {
        return this._canceled;
    }
};
Object.setPrototypeOf($c73172ea815745a6$export$2e2bcd8739ae039.prototype, Promise.prototype);

});


parcelRegister("gzRhZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb0ff8ef6484384e$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $a42uC = parcelRequire("a42uC");
var $fb0ff8ef6484384e$export$2e2bcd8739ae039;
$fb0ff8ef6484384e$export$2e2bcd8739ae039 = class WebItem extends (0, $9nHZC.PureComponent) {
    render() {
        const { module: { descriptor: { target: { type: type = "" } = {} } = {} } = {} } = this.props;
        // @ts-ignore TODO: fix noImplicitAny error here
        const Target = $a42uC[type && type.toLowerCase()] || $a42uC.page;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Target, this.props);
    }
};

});
parcelRegister("a42uC", function(module, exports) {

$parcel$export(module.exports, "dialog", function () { return (parcelRequire("fBqV7")).default; });
$parcel$export(module.exports, "inlinedialog", function () { return (parcelRequire("1SAZH")).default; });
$parcel$export(module.exports, "page", function () { return (parcelRequire("1K4vf")).default; });

var $fBqV7 = parcelRequire("fBqV7");

var $1SAZH = parcelRequire("1SAZH");

var $1K4vf = parcelRequire("1K4vf");

});
parcelRegister("fBqV7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f18cc46320da173c$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");
var $f18cc46320da173c$export$2e2bcd8739ae039 = ({ component: component, providers: { dialogProvider: dialogProvider }, analyticsEventHandler: analyticsEventHandler, module: mod })=>{
    if (!mod) return false;
    const { app_key: appKey, module_type: moduleType, source: { url: url }, targetHref: targetHref, principalId: principalId, descriptor: { key: moduleKey, location: location, name: { value: name = "" } = {}, target: target = {} } } = mod;
    const options = target.options || {};
    let actions = [];
    options.chrome = !(String(options.chrome) === "false");
    const externalTargetUrl = options.externalTargetUrl || url;
    if (options.chrome) actions = [
        {
            key: "cancel",
            name: "cancel",
            identifier: "cancel",
            text: "Close",
            type: "link",
            immutable: true,
            onClick: ()=>dialogProvider.close()
        }
    ];
    // @ts-ignore TODO: fix noImplicitAny error here
    const onClick = (e)=>{
        e.preventDefault();
        dialogProvider.create(Object.assign({
            key: moduleKey,
            header: options.chrome ? name : "",
            actions: actions,
            closeOnEscape: true,
            hint: "",
            ...options
        }), {
            key: moduleKey,
            addon_key: appKey,
            moduleType: moduleType,
            location: location,
            targetHref: targetHref,
            options: {}
        });
        if (analyticsEventHandler) analyticsEventHandler("bitbucket.connect.web_item_dialog.click", {
            principal_id: principalId,
            app_key: appKey,
            module_key: moduleKey,
            module_type: moduleType,
            location: location,
            description: name
        });
    };
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(component, {
        module: mod,
        externalTargetUrl: externalTargetUrl,
        provider: dialogProvider,
        onClick: onClick
    }, name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("a", {
        href: externalTargetUrl,
        title: options.tooltip,
        onClick: onClick
    }, name);
};

});

parcelRegister("1SAZH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21603b0104c2b506$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $hNste = parcelRequire("hNste");
var $21603b0104c2b506$export$2e2bcd8739ae039 = (props)=>{
    const { component: component, providers: providers, module: mod, analyticsEventHandler: analyticsEventHandler } = props;
    if (!mod) return false;
    const { app_key: appKey, module_type: moduleType, source: { url: url }, descriptor: { key: key, location: location, name: { value: name = "" } = {}, target: { options: options = {} } = {} }, principalId: principalId } = mod;
    const provider = providers.inlineDialogProvider.create(key, options);
    const { tooltip: tooltip, onHover: onHover } = options;
    const externalTargetUrl = options.externalTargetUrl || url;
    // @ts-ignore TODO: fix noImplicitAny error here
    const onClick = (e)=>{
        e.preventDefault();
        if (!onHover) {
            provider.toggle();
            if (analyticsEventHandler) analyticsEventHandler("bitbucket.connect.web_item_inline_dialog.click", {
                principal_id: principalId,
                app_key: appKey,
                module_key: key,
                module_type: moduleType,
                location: location,
                description: name
            });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", {
        style: {
            position: "relative",
            display: "inline-block"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $hNste.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        provider: provider
    }), !component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("a", {
        href: externalTargetUrl,
        title: tooltip,
        onClick: onClick
    }, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(component, {
        module: mod,
        provider: provider,
        externalTargetUrl: externalTargetUrl,
        onClick: onClick
    }, name)));
};

});
parcelRegister("hNste", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6fe6dfec363a9ab5$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $9gkf9 = parcelRequire("9gkf9");

var $5VrJZ = parcelRequire("5VrJZ");

var $eSu0s = parcelRequire("eSu0s");
var $6fe6dfec363a9ab5$export$2e2bcd8739ae039;
$6fe6dfec363a9ab5$export$2e2bcd8739ae039 = class InlineDialogIframe extends (0, $9nHZC.PureComponent) {
    constructor(...args){
        super(...args);
        this.timeout = void 0;
        this.clearTimeout = ()=>{
            if (this.timeout) {
                clearTimeout(this.timeout);
                delete this.timeout;
            }
        };
        this.onMouseEnter = ()=>{
            if (this.timeout) this.clearTimeout();
            else this.props.provider.open();
        };
        this.onMouseLeave = ()=>{
            this.clearTimeout();
            this.timeout = setTimeout(()=>{
                this.props.provider.close();
                this.clearTimeout();
            }, 200);
        };
        this.handleHideInlineDialog = ()=>{
            this.clearTimeout();
            this.props.provider.close();
        };
    }
    render() {
        const { IframeComponent: IframeComponent, children: children, connectHost: connectHost, provider: provider, module: mod, isOpen: isOpen } = this.props;
        const options = (0, $9gkf9.getObjectValue)(mod, "descriptor.target.options", {});
        const { position: position, onHover: onHover } = options;
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5VrJZ.default), {
            provider: provider,
            position: position,
            isOpen: isOpen,
            onClose: this.handleHideInlineDialog,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(IframeComponent, {
                connectHost: connectHost,
                inlineDialogOptions: options,
                module: mod,
                handleHideInlineDialog: this.handleHideInlineDialog
            })
        }, children);
        if (onHover) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", {
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        }, content);
        return content;
    }
};
$6fe6dfec363a9ab5$export$2e2bcd8739ae039.defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */ IframeComponent: (0, $eSu0s.default)
};

});
parcelRegister("5VrJZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0ea9d26adff8fdc$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $cMb4y = parcelRequire("cMb4y");

var $kfYkZ = parcelRequire("kfYkZ");
var $c0ea9d26adff8fdc$export$2e2bcd8739ae039;
$c0ea9d26adff8fdc$export$2e2bcd8739ae039 = class InlineDialog extends $9nHZC.PureComponent {
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: !!this.props.isOpen
        };
        this.toggle = ()=>this.setState({
                isOpen: !this.state.isOpen
            });
        this.open = ()=>this.setState({
                isOpen: true
            });
        this.close = ()=>this.setState({
                isOpen: false
            });
        this.isOpen = ()=>this.state.isOpen;
    }
    /* eslint react/no-unsafe: "warn" */ UNSAFE_componentWillMount() {
        this.props.provider.register(this);
    }
    componentWillUnmount() {
        this.props.provider.unregister(this);
    }
    render() {
        const { children: children, content: content, position: position, onClose: onClose = this.props.provider.close } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ $9nHZC.createElement((0, $cMb4y.default), {
            content: content,
            placement: position ? (0, $kfYkZ.translatePosition)(position) : undefined,
            isOpen: isOpen,
            onClose: onClose
        }, children);
    }
};
$c0ea9d26adff8fdc$export$2e2bcd8739ae039.defaultProps = {
    position: "bottom left"
};

});
parcelRegister("cMb4y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94d28e79ae20bbcd$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $6d13u = parcelRequire("6d13u");

var $5cScH = parcelRequire("5cScH");

var $lK4mX = parcelRequire("lK4mX");
var $4llHq = parcelRequire("4llHq");
var $fJ3zZ = parcelRequire("fJ3zZ");

var $8p2GL = parcelRequire("8p2GL");

var $gwCAL = parcelRequire("gwCAL");
var $3csGi = parcelRequire("3csGi");
var $16GBP = parcelRequire("16GBP");

var $e4FwP = parcelRequire("e4FwP");
var $94d28e79ae20bbcd$var$packageName = "@atlaskit/inline-dialog";
var $94d28e79ae20bbcd$var$packageVersion = "13.6.2";
var $94d28e79ae20bbcd$var$checkIsChildOfPortal = function checkIsChildOfPortal(node) {
    if (!node) return false;
    return node.classList && node.classList.contains("atlaskit-portal-container") || checkIsChildOfPortal(node.parentElement);
};
var $94d28e79ae20bbcd$export$513033cc22e3bc20 = /*#__PURE__*/ (0, $9nHZC.memo)(function InlineDialog(_ref) {
    var _ref$isOpen = _ref.isOpen, isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen, _ref$onContentBlur = _ref.onContentBlur, onContentBlur = _ref$onContentBlur === void 0 ? (0, $8p2GL.default) : _ref$onContentBlur, _ref$onContentClick = _ref.onContentClick, onContentClick = _ref$onContentClick === void 0 ? (0, $8p2GL.default) : _ref$onContentClick, _ref$onContentFocus = _ref.onContentFocus, onContentFocus = _ref$onContentFocus === void 0 ? (0, $8p2GL.default) : _ref$onContentFocus, _ref$onClose = _ref.onClose, onClose = _ref$onClose === void 0 ? (0, $8p2GL.default) : _ref$onClose, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, testId = _ref.testId, content = _ref.content, children = _ref.children;
    var containerRef = (0, $9nHZC.useRef)(null);
    var triggerRef = (0, $9nHZC.useRef)(null);
    // we put this into a ref to avoid handleCloseRequest having this as a dependency
    var onCloseRef = (0, $9nHZC.useRef)(onClose);
    (0, $9nHZC.useEffect)(function() {
        onCloseRef.current = onClose;
    });
    var handleCloseRequest = (0, $9nHZC.useCallback)(function(event) {
        var target = event.target;
        // checks for when target is not HTMLElement
        if (!(target instanceof HTMLElement)) return;
        // TODO: This is to handle the case where the target is no longer in the DOM.
        // This happens with react-select in datetime picker. There might be other
        // edge cases for this.
        if (!document.body.contains(target)) return;
        // handles the case where inline dialog opens portalled elements such as modal
        if ($94d28e79ae20bbcd$var$checkIsChildOfPortal(target)) return;
        // call onClose if the click originated from outside the dialog
        if (containerRef.current && !containerRef.current.contains(target)) {
            var _onCloseRef$current;
            (_onCloseRef$current = onCloseRef.current) === null || _onCloseRef$current === void 0 || _onCloseRef$current.call(onCloseRef, {
                isOpen: false,
                event: event
            });
        }
    }, []);
    var handleClick = (0, $9nHZC.useCallback)(function(event) {
        // exit if we click outside but on the trigger — it can handle the clicks itself
        if (triggerRef.current && triggerRef.current.contains(event.target)) return;
        handleCloseRequest(event);
    }, [
        handleCloseRequest
    ]);
    (0, $9nHZC.useEffect)(function() {
        if (!isOpen) return;
        var unbind = (0, $6d13u.bind)(window, {
            type: "click",
            listener: handleClick,
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        isOpen,
        handleClick
    ]);
    var handleKeyDown = (0, $9nHZC.useCallback)(function(event) {
        if (event.key === "Escape") handleCloseRequest(event);
    }, [
        handleCloseRequest
    ]);
    (0, $9nHZC.useEffect)(function() {
        if (!isOpen) return;
        var unbind = (0, $6d13u.bind)(window, {
            type: "keydown",
            listener: handleKeyDown,
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        isOpen,
        handleKeyDown
    ]);
    var popper = isOpen ? (0, $avKww.jsx)((0, $3csGi.Popper), {
        placement: placement,
        strategy: strategy
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style;
        return (0, $avKww.jsx)((0, $e4FwP.Container), {
            onBlur: onContentBlur,
            onFocus: onContentFocus,
            onClick: onContentClick,
            ref: function ref(node) {
                if (node) {
                    containerRef.current = node;
                    if (typeof _ref3 === "function") _ref3(node);
                    else _ref3.current = node;
                }
            },
            style: style,
            testId: testId
        }, content);
    }) : null;
    return (0, $avKww.jsx)((0, $gwCAL.Manager), null, (0, $avKww.jsx)((0, $16GBP.Reference), null, function(_ref4) {
        var ref = _ref4.ref;
        return (0, $avKww.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5cScH))), {
            innerRef: function innerRef(node) {
                triggerRef.current = node;
                if (typeof ref === "function") ref(node);
                else ref.current = node;
            }
        }, children);
    }), popper);
});
$94d28e79ae20bbcd$export$513033cc22e3bc20.displayName = "InlineDialog";
var $94d28e79ae20bbcd$var$createAndFireEventOnAtlaskit = (0, $lK4mX.default)("atlaskit");
var $94d28e79ae20bbcd$export$2e2bcd8739ae039 = (0, $4llHq.default)({
    componentName: "inlineDialog",
    packageName: $94d28e79ae20bbcd$var$packageName,
    packageVersion: $94d28e79ae20bbcd$var$packageVersion
})((0, $fJ3zZ.default)({
    onClose: $94d28e79ae20bbcd$var$createAndFireEventOnAtlaskit({
        action: "closed",
        actionSubject: "inlineDialog",
        attributes: {
            componentName: "inlineDialog",
            packageName: $94d28e79ae20bbcd$var$packageName,
            packageVersion: $94d28e79ae20bbcd$var$packageVersion
        }
    })
})($94d28e79ae20bbcd$export$513033cc22e3bc20));

});
parcelRegister("6d13u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $61AU3 = parcelRequire("61AU3");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $61AU3.bind;
    }
});

var $2dZG5 = parcelRequire("2dZG5");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $2dZG5.bindAll;
    }
});

});
parcelRegister("61AU3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $462f763eaf544dfd$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $462f763eaf544dfd$var$bind;

});

parcelRegister("2dZG5", function(module, exports) {
"use strict";
var $19eca39c79ea63a1$var$__assign = module.exports && module.exports.__assign || function() {
    $19eca39c79ea63a1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $19eca39c79ea63a1$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $61AU3 = parcelRequire("61AU3");
function $19eca39c79ea63a1$var$toOptions(value) {
    if (typeof value === "undefined") return undefined;
    if (typeof value === "boolean") return {
        capture: value
    };
    return value;
}
function $19eca39c79ea63a1$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $19eca39c79ea63a1$var$__assign($19eca39c79ea63a1$var$__assign({}, original), {
        options: $19eca39c79ea63a1$var$__assign($19eca39c79ea63a1$var$__assign({}, $19eca39c79ea63a1$var$toOptions(sharedOptions)), $19eca39c79ea63a1$var$toOptions(original.options))
    });
    return binding;
}
function $19eca39c79ea63a1$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $19eca39c79ea63a1$var$getBinding(original, sharedOptions);
        return (0, $61AU3.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $19eca39c79ea63a1$var$bindAll;

});


parcelRegister("5cScH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hsWN8 = parcelRequire("hsWN8");
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $3ca81e772b269ac6$var$_interopRequireDefault($hsWN8).default;
    }
});
function $3ca81e772b269ac6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("hsWN8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $cb72a7f81610b8a9$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $9nHZC = parcelRequire("9nHZC");

var $lnOmc = parcelRequire("lnOmc");
function $cb72a7f81610b8a9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cb72a7f81610b8a9$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $cb72a7f81610b8a9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $cb72a7f81610b8a9$var$NodeResolver = function(_Component) {
    $cb72a7f81610b8a9$var$_inherits(NodeResolver, _Component);
    function NodeResolver() {
        $cb72a7f81610b8a9$var$_classCallCheck(this, NodeResolver);
        return $cb72a7f81610b8a9$var$_possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
    }
    $cb72a7f81610b8a9$var$_createClass(NodeResolver, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.innerRef((0, $lnOmc.findDOMNode)(this));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.props.innerRef(null);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return NodeResolver;
}($9nHZC.Component);
module.exports.default = $cb72a7f81610b8a9$var$NodeResolver;

});


parcelRegister("lK4mX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd41487de4560b2e$export$2e2bcd8739ae039; });
var $fd41487de4560b2e$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};

});

parcelRegister("4llHq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3299f4a3f2479c86$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $cDb53 = parcelRequire("cDb53");
var $3299f4a3f2479c86$var$_excluded = [
    "analyticsContext"
];
function $3299f4a3f2479c86$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3299f4a3f2479c86$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3299f4a3f2479c86$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3299f4a3f2479c86$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3299f4a3f2479c86$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $3299f4a3f2479c86$var$_excluded);
            var analyticsData = (0, $9nHZC.useMemo)(function() {
                return $3299f4a3f2479c86$var$_objectSpread($3299f4a3f2479c86$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $cDb53.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
                ref: ref
            })));
        });
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $3299f4a3f2479c86$export$2e2bcd8739ae039 = $3299f4a3f2479c86$var$withAnalyticsContext;

});
parcelRegister("cDb53", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9321b8eb51fa9c38$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $dEQSq = parcelRequire("dEQSq");

var $8IE7c = parcelRequire("8IE7c");

var $cKYzn = parcelRequire("cKYzn");

var $8ovux = parcelRequire("8ovux");
var $9321b8eb51fa9c38$var$ExportedAnalyticsContext = function ExportedAnalyticsContext(props) {
    var _process$env;
    var isModernContextEnabledEnv = typeof $8ovux !== "undefined" && $8ovux !== null && ((_process$env = {}, _process$env === void 0) ? void 0 : _process$env["ANALYTICS_NEXT_MODERN_CONTEXT"]);
    return isModernContextEnabledEnv || (0, $dEQSq.getBooleanFF)("platform.analytics-next-use-modern-context_fqgbx") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $cKYzn.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $8IE7c.default), props);
};
var $9321b8eb51fa9c38$export$2e2bcd8739ae039 = $9321b8eb51fa9c38$var$ExportedAnalyticsContext;

});
parcelRegister("8IE7c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65918cd323f6d6f0$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");

var $kZnbM = parcelRequire("kZnbM");
function $65918cd323f6d6f0$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $65918cd323f6d6f0$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $65918cd323f6d6f0$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($65918cd323f6d6f0$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $65918cd323f6d6f0$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func
};
var $65918cd323f6d6f0$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $65918cd323f6d6f0$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(AnalyticsContext, _Component);
    var _super = $65918cd323f6d6f0$var$_createSuper(AnalyticsContext);
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsContext);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $65918cd323f6d6f0$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $65918cd323f6d6f0$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kZnbM.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsContext;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($65918cd323f6d6f0$var$AnalyticsContext, "contextTypes", $65918cd323f6d6f0$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($65918cd323f6d6f0$var$AnalyticsContext, "childContextTypes", $65918cd323f6d6f0$var$ContextTypes);
var $65918cd323f6d6f0$export$2e2bcd8739ae039 = $65918cd323f6d6f0$var$AnalyticsContext;

});

parcelRegister("cKYzn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9498c3bf7564696e$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");

var $aQNka = parcelRequire("aQNka");

var $7DOQR = parcelRequire("7DOQR");
var $9498c3bf7564696e$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $7DOQR.useTrackedRef)(data);
    var analyticsContext = (0, $aQNka.useAnalyticsContext)();
    var getAtlaskitAnalyticsContext = (0, $9nHZC.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(analyticsContext.getAtlaskitAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        analyticsContext,
        dataRef
    ]);
    var value = (0, $9nHZC.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: analyticsContext.getAtlaskitAnalyticsEventHandlers
        };
    }, [
        analyticsContext,
        getAtlaskitAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kZnbM.default).Provider, {
        value: value
    }, children);
};
var $9498c3bf7564696e$export$2e2bcd8739ae039 = $9498c3bf7564696e$var$AnalyticsContext;

});
parcelRegister("aQNka", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $7e65057b9f255f3c$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $7e65057b9f255f3c$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});

parcelRegister("7DOQR", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $59039ef7c6017af4$export$1d27a74659855e44; });

var $9nHZC = parcelRequire("9nHZC");
var $59039ef7c6017af4$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    ref.current = value;
    return ref;
};

});




parcelRegister("fJ3zZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b72dd5cbb0fd4cbf$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $fuHIJ = parcelRequire("fuHIJ");

var $jb7Fe = parcelRequire("jb7Fe");
var $b72dd5cbb0fd4cbf$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(props, ref) {
            var _usePatchedProps = (0, $jb7Fe.usePatchedProps)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $fuHIJ.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $b72dd5cbb0fd4cbf$export$2e2bcd8739ae039 = $b72dd5cbb0fd4cbf$var$withAnalyticsEvents;

});
parcelRegister("fuHIJ", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $b47b9251fe1c4ca6$export$5bf35293e545f20c; });

var $dNznA = parcelRequire("dNznA");

var $78RGi = parcelRequire("78RGi");

var $aQNka = parcelRequire("aQNka");
function $b47b9251fe1c4ca6$export$5bf35293e545f20c() {
    var analyticsContext = (0, $aQNka.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $78RGi.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("dNznA", function(module, exports) {

$parcel$export(module.exports, "useMemoOne", function () { return $a0bb4b90fd6a04fe$export$b6feb8998cd9b342; });
$parcel$export(module.exports, "useCallbackOne", function () { return $a0bb4b90fd6a04fe$export$33752cf3ee811995; });
$parcel$export(module.exports, "useMemo", function () { return $a0bb4b90fd6a04fe$export$1538c33de8887b59; });
$parcel$export(module.exports, "useCallback", function () { return $a0bb4b90fd6a04fe$export$35808ee640e87ca7; });

var $9nHZC = parcelRequire("9nHZC");
function $a0bb4b90fd6a04fe$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $a0bb4b90fd6a04fe$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $9nHZC.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $9nHZC.useRef)(true);
    var committed = (0, $9nHZC.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $a0bb4b90fd6a04fe$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $9nHZC.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $a0bb4b90fd6a04fe$export$33752cf3ee811995(callback, inputs) {
    return $a0bb4b90fd6a04fe$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $a0bb4b90fd6a04fe$export$1538c33de8887b59 = $a0bb4b90fd6a04fe$export$b6feb8998cd9b342;
var $a0bb4b90fd6a04fe$export$35808ee640e87ca7 = $a0bb4b90fd6a04fe$export$33752cf3ee811995;

});

parcelRegister("78RGi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5332ebb6381ed75c$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $jMub5 = parcelRequire("jMub5");
function $5332ebb6381ed75c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5332ebb6381ed75c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $5332ebb6381ed75c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5332ebb6381ed75c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $5332ebb6381ed75c$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $5332ebb6381ed75c$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $5332ebb6381ed75c$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $5332ebb6381ed75c$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $jMub5.default));

});
parcelRegister("h4cnL", function(module, exports) {

var $jPOeA = parcelRequire("jPOeA");
function $c6cc6a3bb531226d$var$_get() {
    return module.exports = $c6cc6a3bb531226d$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $jPOeA(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $c6cc6a3bb531226d$var$_get.apply(null, arguments);
}
module.exports = $c6cc6a3bb531226d$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jPOeA", function(module, exports) {

var $lH0U2 = parcelRequire("lH0U2");
function $e709bf36c6e758b5$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $lH0U2(t)););
    return t;
}
module.exports = $e709bf36c6e758b5$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("jMub5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e669e8adad59c95a$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
function $e669e8adad59c95a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e669e8adad59c95a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e669e8adad59c95a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e669e8adad59c95a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e669e8adad59c95a$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $e669e8adad59c95a$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $e669e8adad59c95a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $e669e8adad59c95a$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(updater) === "object") this.payload = $e669e8adad59c95a$var$_objectSpread($e669e8adad59c95a$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});



parcelRegister("jb7Fe", function(module, exports) {

$parcel$export(module.exports, "usePatchedProps", function () { return $df64fd55a5535ce0$export$9ebb5a84d17e5d18; });

var $kFnE9 = parcelRequire("kFnE9");

var $340K4 = parcelRequire("340K4");

var $9nHZC = parcelRequire("9nHZC");

var $fuHIJ = parcelRequire("fuHIJ");
function $df64fd55a5535ce0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $df64fd55a5535ce0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $df64fd55a5535ce0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $df64fd55a5535ce0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $df64fd55a5535ce0$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $fuHIJ.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $9nHZC.useRef)({});
    var patchedProps = (0, $9nHZC.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                "object",
                "function"
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $df64fd55a5535ce0$var$_objectSpread($df64fd55a5535ce0$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === "function" ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === "function") {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $df64fd55a5535ce0$var$_objectSpread($df64fd55a5535ce0$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});


parcelRegister("gwCAL", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", function () { return $c07d9210393f254a$export$3dbd3405086fec7b; });
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", function () { return $c07d9210393f254a$export$cbabb21c2529b130; });
$parcel$export(module.exports, "Manager", function () { return $c07d9210393f254a$export$d0d38e7dec7a1a61; });

var $9nHZC = parcelRequire("9nHZC");
var $c07d9210393f254a$export$3dbd3405086fec7b = $9nHZC.createContext();
var $c07d9210393f254a$export$cbabb21c2529b130 = $9nHZC.createContext();
function $c07d9210393f254a$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $9nHZC.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $9nHZC.useRef(false);
    $9nHZC.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $9nHZC.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $9nHZC.createElement($c07d9210393f254a$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $9nHZC.createElement($c07d9210393f254a$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("3csGi", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $2548bd91d36d8f94$export$badac9ada3a0bdf9; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $cjxQA = parcelRequire("cjxQA");

// Export types from PopperJS / React Popper
var $2548bd91d36d8f94$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: 5,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    },
    {
        name: "preventOverflow",
        options: {
            padding: 5,
            rootBoundary: "document"
        }
    }
];
function $2548bd91d36d8f94$var$defaultChildrenFn() {
    return null;
}
var $2548bd91d36d8f94$var$defaultOffset = [
    0,
    8
];
function $2548bd91d36d8f94$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $2548bd91d36d8f94$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $2548bd91d36d8f94$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    // Merge a new offset modifier only if new offset values passed in
    var internalModifiers = (0, $9nHZC.useMemo)(function() {
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        return [].concat($2548bd91d36d8f94$var$constantModifiers, [
            offsetModifier
        ]);
    }, [
        offsetX,
        offsetY
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $9nHZC.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $cjxQA.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("cjxQA", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $8f7183ba6c51d939$export$badac9ada3a0bdf9; });

var $9nHZC = parcelRequire("9nHZC");

var $gwCAL = parcelRequire("gwCAL");

var $fjSwp = parcelRequire("fjSwp");

var $1dOMP = parcelRequire("1dOMP");
var $8f7183ba6c51d939$var$NOOP = function NOOP() {
    return void 0;
};
var $8f7183ba6c51d939$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $8f7183ba6c51d939$var$EMPTY_MODIFIERS = [];
function $8f7183ba6c51d939$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom" : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "absolute" : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $8f7183ba6c51d939$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $9nHZC.useContext((0, $gwCAL.ManagerReferenceNodeContext));
    var _React$useState = $9nHZC.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $9nHZC.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $9nHZC.useEffect(function() {
        (0, $fjSwp.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $9nHZC.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: "arrow",
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $1dOMP.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $9nHZC.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $8f7183ba6c51d939$var$NOOP,
            update: update || $8f7183ba6c51d939$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $fjSwp.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("fjSwp", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", function () { return $b272ec44d9ecff6d$export$f52c55943429c8b6; });
$parcel$export(module.exports, "safeInvoke", function () { return $b272ec44d9ecff6d$export$3dfa7c28635fe028; });
$parcel$export(module.exports, "setRef", function () { return $b272ec44d9ecff6d$export$4bb192c7cacf928f; });
$parcel$export(module.exports, "fromEntries", function () { return $b272ec44d9ecff6d$export$5150077fc2e7c662; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $b272ec44d9ecff6d$export$700979bc83e7db82; });

var $9nHZC = parcelRequire("9nHZC");
var $b272ec44d9ecff6d$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $b272ec44d9ecff6d$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $b272ec44d9ecff6d$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $b272ec44d9ecff6d$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $b272ec44d9ecff6d$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $b272ec44d9ecff6d$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $9nHZC.useLayoutEffect : $9nHZC.useEffect;

});

parcelRegister("1dOMP", function(module, exports) {

$parcel$export(module.exports, "usePopper", function () { return $0e3e66814b881772$export$f4d5bf230a36dd6e; });

var $9nHZC = parcelRequire("9nHZC");

var $lnOmc = parcelRequire("lnOmc");

var $crFnC = parcelRequire("crFnC");

var $fIcbc = parcelRequire("fIcbc");

var $fjSwp = parcelRequire("fjSwp");
var $0e3e66814b881772$var$EMPTY_MODIFIERS = [];
var $0e3e66814b881772$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $9nHZC.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $0e3e66814b881772$var$EMPTY_MODIFIERS
    };
    var _React$useState = $9nHZC.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $9nHZC.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $lnOmc.flushSync(function() {
                    setState({
                        styles: (0, $fjSwp.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $fjSwp.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $9nHZC.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($fIcbc)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $9nHZC.useRef();
    (0, $fjSwp.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $fjSwp.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $crFnC.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("crFnC", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $90f81ad753eb7e5a$export$8f7491d57c8f97a9; });

var $cC6y0 = parcelRequire("cC6y0");

var $VQxQL = parcelRequire("VQxQL");

var $iZ5fa = parcelRequire("iZ5fa");

var $kpF2L = parcelRequire("kpF2L");

var $5r1Gv = parcelRequire("5r1Gv");

var $11VPO = parcelRequire("11VPO");

var $j7Ym7 = parcelRequire("j7Ym7");

var $5qqYD = parcelRequire("5qqYD");

var $99hTa = parcelRequire("99hTa");

var $ekTcz = parcelRequire("ekTcz");


var $90f81ad753eb7e5a$export$d34966752335dd47 = [
    (0, $VQxQL.default),
    (0, $iZ5fa.default),
    (0, $kpF2L.default),
    (0, $5r1Gv.default),
    (0, $11VPO.default),
    (0, $j7Ym7.default),
    (0, $5qqYD.default),
    (0, $99hTa.default),
    (0, $ekTcz.default)
];
var $90f81ad753eb7e5a$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $cC6y0.popperGenerator)({
    defaultModifiers: $90f81ad753eb7e5a$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("cC6y0", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $92ee1cd4d6d7725c$export$ed5e13716264f202; });

var $5yi8F = parcelRequire("5yi8F");

var $17VQS = parcelRequire("17VQS");

var $dlxwz = parcelRequire("dlxwz");

var $7aNOO = parcelRequire("7aNOO");

var $Ktt2s = parcelRequire("Ktt2s");

var $9M1ae = parcelRequire("9M1ae");

var $4uoFB = parcelRequire("4uoFB");


var $ciQff = parcelRequire("ciQff");
var $92ee1cd4d6d7725c$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $92ee1cd4d6d7725c$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $92ee1cd4d6d7725c$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $92ee1cd4d6d7725c$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $92ee1cd4d6d7725c$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $ciQff.isElement)(reference) ? (0, $dlxwz.default)(reference) : reference.contextElement ? (0, $dlxwz.default)(reference.contextElement) : [],
                    popper: (0, $dlxwz.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $Ktt2s.default)((0, $4uoFB.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$92ee1cd4d6d7725c$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $5yi8F.default)(reference, (0, $7aNOO.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $17VQS.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9M1ae.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$92ee1cd4d6d7725c$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $92ee1cd4d6d7725c$export$8f7491d57c8f97a9 = /*#__PURE__*/ $92ee1cd4d6d7725c$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("5yi8F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40ae32bb5244ea52$export$2e2bcd8739ae039; });

var $22r87 = parcelRequire("22r87");

var $j7nzI = parcelRequire("j7nzI");

var $8vLUx = parcelRequire("8vLUx");

var $ciQff = parcelRequire("ciQff");

var $bCdYX = parcelRequire("bCdYX");

var $4ozgT = parcelRequire("4ozgT");

var $cKTCO = parcelRequire("cKTCO");

var $9BEjA = parcelRequire("9BEjA");
function $40ae32bb5244ea52$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $9BEjA.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $9BEjA.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $40ae32bb5244ea52$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $ciQff.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $ciQff.isHTMLElement)(offsetParent) && $40ae32bb5244ea52$var$isElementScaled(offsetParent);
    var documentElement = (0, $4ozgT.default)(offsetParent);
    var rect = (0, $22r87.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $8vLUx.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $cKTCO.default)(documentElement)) scroll = (0, $j7nzI.default)(offsetParent);
        if ((0, $ciQff.isHTMLElement)(offsetParent)) {
            offsets = (0, $22r87.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $bCdYX.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("22r87", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17c0d02043ea84a1$export$2e2bcd8739ae039; });

var $ciQff = parcelRequire("ciQff");

var $9BEjA = parcelRequire("9BEjA");

var $3clmw = parcelRequire("3clmw");

var $4cVNL = parcelRequire("4cVNL");
function $17c0d02043ea84a1$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $ciQff.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $9BEjA.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $9BEjA.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $ciQff.isElement)(element) ? (0, $3clmw.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $4cVNL.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("ciQff", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $8f4fb13d6938c6b2$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $8f4fb13d6938c6b2$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $8f4fb13d6938c6b2$export$af51f0f06c0f328a; });

var $3clmw = parcelRequire("3clmw");
function $8f4fb13d6938c6b2$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $3clmw.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $8f4fb13d6938c6b2$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $3clmw.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $8f4fb13d6938c6b2$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $3clmw.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("3clmw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2543102fdf051fe2$export$2e2bcd8739ae039; });
function $2543102fdf051fe2$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("9BEjA", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $6fe6d77312558224$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $6fe6d77312558224$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $6fe6d77312558224$export$2077e0241d6afd3c; });
var $6fe6d77312558224$export$8960430cfd85939f = Math.max;
var $6fe6d77312558224$export$96ec731ed4dcb222 = Math.min;
var $6fe6d77312558224$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("4cVNL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31051ea30020f3ed$export$2e2bcd8739ae039; });

var $ksj4J = parcelRequire("ksj4J");
function $31051ea30020f3ed$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $ksj4J.default)());
}

});
parcelRegister("ksj4J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee45381cf2fc26b7$export$2e2bcd8739ae039; });
function $ee45381cf2fc26b7$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});



parcelRegister("j7nzI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $deb0f54bb0cda1ee$export$2e2bcd8739ae039; });

var $eJ63P = parcelRequire("eJ63P");

var $3clmw = parcelRequire("3clmw");

var $ciQff = parcelRequire("ciQff");

var $jsdQg = parcelRequire("jsdQg");
function $deb0f54bb0cda1ee$export$2e2bcd8739ae039(node) {
    if (node === (0, $3clmw.default)(node) || !(0, $ciQff.isHTMLElement)(node)) return (0, $eJ63P.default)(node);
    else return (0, $jsdQg.default)(node);
}

});
parcelRegister("eJ63P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab89f8333322909a$export$2e2bcd8739ae039; });

var $3clmw = parcelRequire("3clmw");
function $ab89f8333322909a$export$2e2bcd8739ae039(node) {
    var win = (0, $3clmw.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("jsdQg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e29b5e9419d2a9ae$export$2e2bcd8739ae039; });
function $e29b5e9419d2a9ae$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("8vLUx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63266217514be03e$export$2e2bcd8739ae039; });
function $63266217514be03e$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("bCdYX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $874e16e6860fdfe9$export$2e2bcd8739ae039; });

var $22r87 = parcelRequire("22r87");

var $4ozgT = parcelRequire("4ozgT");

var $eJ63P = parcelRequire("eJ63P");
function $874e16e6860fdfe9$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $22r87.default)((0, $4ozgT.default)(element)).left + (0, $eJ63P.default)(element).scrollLeft;
}

});
parcelRegister("4ozgT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3334c37dbc1e77a1$export$2e2bcd8739ae039; });

var $ciQff = parcelRequire("ciQff");
function $3334c37dbc1e77a1$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $ciQff.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("cKTCO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9494ede2dd2dfd40$export$2e2bcd8739ae039; });

var $EU72m = parcelRequire("EU72m");
function $9494ede2dd2dfd40$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $EU72m.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("EU72m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07af4350b6cbbe32$export$2e2bcd8739ae039; });

var $3clmw = parcelRequire("3clmw");
function $07af4350b6cbbe32$export$2e2bcd8739ae039(element) {
    return (0, $3clmw.default)(element).getComputedStyle(element);
}

});



parcelRegister("17VQS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d23520aca158a42$export$2e2bcd8739ae039; });

var $22r87 = parcelRequire("22r87");
function $0d23520aca158a42$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $22r87.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("dlxwz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b773dbfc4a0a2a5$export$2e2bcd8739ae039; });

var $haPSV = parcelRequire("haPSV");

var $5gXCL = parcelRequire("5gXCL");

var $3clmw = parcelRequire("3clmw");

var $cKTCO = parcelRequire("cKTCO");
function $9b773dbfc4a0a2a5$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $haPSV.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $3clmw.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $cKTCO.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($9b773dbfc4a0a2a5$export$2e2bcd8739ae039((0, $5gXCL.default)(target)));
}

});
parcelRegister("haPSV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c80b9e180da74bc0$export$2e2bcd8739ae039; });

var $5gXCL = parcelRequire("5gXCL");

var $cKTCO = parcelRequire("cKTCO");

var $8vLUx = parcelRequire("8vLUx");

var $ciQff = parcelRequire("ciQff");
function $c80b9e180da74bc0$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $8vLUx.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $ciQff.isHTMLElement)(node) && (0, $cKTCO.default)(node)) return node;
    return $c80b9e180da74bc0$export$2e2bcd8739ae039((0, $5gXCL.default)(node));
}

});
parcelRegister("5gXCL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d6cb28611c07b59$export$2e2bcd8739ae039; });

var $8vLUx = parcelRequire("8vLUx");

var $4ozgT = parcelRequire("4ozgT");

var $ciQff = parcelRequire("ciQff");
function $3d6cb28611c07b59$export$2e2bcd8739ae039(element) {
    if ((0, $8vLUx.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $ciQff.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $4ozgT.default)(element) // fallback
    );
}

});



parcelRegister("7aNOO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53901c82272c0140$export$2e2bcd8739ae039; });

var $3clmw = parcelRequire("3clmw");

var $8vLUx = parcelRequire("8vLUx");

var $EU72m = parcelRequire("EU72m");

var $ciQff = parcelRequire("ciQff");

var $homQp = parcelRequire("homQp");

var $5gXCL = parcelRequire("5gXCL");

var $ksj4J = parcelRequire("ksj4J");
function $53901c82272c0140$var$getTrueOffsetParent(element) {
    if (!(0, $ciQff.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $EU72m.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $53901c82272c0140$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $ksj4J.default)());
    var isIE = /Trident/i.test((0, $ksj4J.default)());
    if (isIE && (0, $ciQff.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $EU72m.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $5gXCL.default)(element);
    if ((0, $ciQff.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $ciQff.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $8vLUx.default)(currentNode)) < 0){
        var css = (0, $EU72m.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $53901c82272c0140$export$2e2bcd8739ae039(element) {
    var window = (0, $3clmw.default)(element);
    var offsetParent = $53901c82272c0140$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $homQp.default)(offsetParent) && (0, $EU72m.default)(offsetParent).position === "static")offsetParent = $53901c82272c0140$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $8vLUx.default)(offsetParent) === "html" || (0, $8vLUx.default)(offsetParent) === "body" && (0, $EU72m.default)(offsetParent).position === "static")) return window;
    return offsetParent || $53901c82272c0140$var$getContainingBlock(element) || window;
}

});
parcelRegister("homQp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca9665fba00a2255$export$2e2bcd8739ae039; });

var $8vLUx = parcelRequire("8vLUx");
function $ca9665fba00a2255$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $8vLUx.default)(element)) >= 0;
}

});


parcelRegister("Ktt2s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08bb2798df92d07e$export$2e2bcd8739ae039; });

var $j2SvU = parcelRequire("j2SvU");
function $08bb2798df92d07e$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $08bb2798df92d07e$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $08bb2798df92d07e$var$order(modifiers); // order based on phase
    return (0, $j2SvU.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("j2SvU", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $ddd87d7b0c52868e$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $ddd87d7b0c52868e$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $ddd87d7b0c52868e$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $ddd87d7b0c52868e$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $ddd87d7b0c52868e$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $ddd87d7b0c52868e$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $ddd87d7b0c52868e$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $ddd87d7b0c52868e$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $ddd87d7b0c52868e$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $ddd87d7b0c52868e$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $ddd87d7b0c52868e$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $ddd87d7b0c52868e$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $ddd87d7b0c52868e$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $ddd87d7b0c52868e$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $ddd87d7b0c52868e$export$d087d3878fdf71d5; });
var $ddd87d7b0c52868e$export$1e95b668f3b82d = "top";
var $ddd87d7b0c52868e$export$40e543e69a8b3fbb = "bottom";
var $ddd87d7b0c52868e$export$79ffe56a765070d2 = "right";
var $ddd87d7b0c52868e$export$eabcd2c8791e7bf4 = "left";
var $ddd87d7b0c52868e$export$dfb5619354ba860 = "auto";
var $ddd87d7b0c52868e$export$aec2ce47c367b8c3 = [
    $ddd87d7b0c52868e$export$1e95b668f3b82d,
    $ddd87d7b0c52868e$export$40e543e69a8b3fbb,
    $ddd87d7b0c52868e$export$79ffe56a765070d2,
    $ddd87d7b0c52868e$export$eabcd2c8791e7bf4
];
var $ddd87d7b0c52868e$export$b3571188c770cc5a = "start";
var $ddd87d7b0c52868e$export$bd5df0f255a350f8 = "end";
var $ddd87d7b0c52868e$export$390fd549c5303b4d = "clippingParents";
var $ddd87d7b0c52868e$export$d7b7311ec04a3e8f = "viewport";
var $ddd87d7b0c52868e$export$ae5ab1c730825774 = "popper";
var $ddd87d7b0c52868e$export$ca50aac9f3ba507f = "reference";
var $ddd87d7b0c52868e$export$368f9a87e87fa4e1 = /*#__PURE__*/ $ddd87d7b0c52868e$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $ddd87d7b0c52868e$export$b3571188c770cc5a,
        placement + "-" + $ddd87d7b0c52868e$export$bd5df0f255a350f8
    ]);
}, []);
var $ddd87d7b0c52868e$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($ddd87d7b0c52868e$export$aec2ce47c367b8c3, [
    $ddd87d7b0c52868e$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $ddd87d7b0c52868e$export$b3571188c770cc5a,
        placement + "-" + $ddd87d7b0c52868e$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $ddd87d7b0c52868e$export$421679a7c3d56e = "beforeRead";
var $ddd87d7b0c52868e$export$aafa59e2e03f2942 = "read";
var $ddd87d7b0c52868e$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $ddd87d7b0c52868e$export$c65e99957a05207c = "beforeMain";
var $ddd87d7b0c52868e$export$f22da7240b7add18 = "main";
var $ddd87d7b0c52868e$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $ddd87d7b0c52868e$export$8d4d2d70e7d46032 = "beforeWrite";
var $ddd87d7b0c52868e$export$68d8715fc104d294 = "write";
var $ddd87d7b0c52868e$export$70a6e5159acce2e6 = "afterWrite";
var $ddd87d7b0c52868e$export$d087d3878fdf71d5 = [
    $ddd87d7b0c52868e$export$421679a7c3d56e,
    $ddd87d7b0c52868e$export$aafa59e2e03f2942,
    $ddd87d7b0c52868e$export$6964f6c886723980,
    $ddd87d7b0c52868e$export$c65e99957a05207c,
    $ddd87d7b0c52868e$export$f22da7240b7add18,
    $ddd87d7b0c52868e$export$bab79516f2d662fe,
    $ddd87d7b0c52868e$export$8d4d2d70e7d46032,
    $ddd87d7b0c52868e$export$68d8715fc104d294,
    $ddd87d7b0c52868e$export$70a6e5159acce2e6
];

});


parcelRegister("9M1ae", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01d616b555e3871b$export$2e2bcd8739ae039; });
function $01d616b555e3871b$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("4uoFB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $344d19b5fa224fd5$export$2e2bcd8739ae039; });
function $344d19b5fa224fd5$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("VQxQL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ade1552645a48e5$export$2e2bcd8739ae039; });

var $3clmw = parcelRequire("3clmw");
var $0ade1552645a48e5$var$passive = {
    passive: true
};
function $0ade1552645a48e5$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $3clmw.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $0ade1552645a48e5$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $0ade1552645a48e5$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $0ade1552645a48e5$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $0ade1552645a48e5$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $0ade1552645a48e5$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $0ade1552645a48e5$var$effect,
    data: {}
};

});

parcelRegister("iZ5fa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd21fdc6b107ec47$export$2e2bcd8739ae039; });

var $hhfBS = parcelRequire("hhfBS");
function $dd21fdc6b107ec47$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $hhfBS.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $dd21fdc6b107ec47$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $dd21fdc6b107ec47$var$popperOffsets,
    data: {}
};

});
parcelRegister("hhfBS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9402203aa530509$export$2e2bcd8739ae039; });

var $jgdPm = parcelRequire("jgdPm");

var $4pjKo = parcelRequire("4pjKo");

var $6BKz0 = parcelRequire("6BKz0");

var $j2SvU = parcelRequire("j2SvU");
function $c9402203aa530509$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $jgdPm.default)(placement) : null;
    var variation = placement ? (0, $4pjKo.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $j2SvU.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $j2SvU.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $j2SvU.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $j2SvU.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $6BKz0.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $j2SvU.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $j2SvU.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("jgdPm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e05a3cc15057a2f4$export$2e2bcd8739ae039; });

function $e05a3cc15057a2f4$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("4pjKo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3358d0a450aa49e1$export$2e2bcd8739ae039; });
function $3358d0a450aa49e1$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});

parcelRegister("6BKz0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cfa5156a274790e$export$2e2bcd8739ae039; });
function $4cfa5156a274790e$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});



parcelRegister("kpF2L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edc5fad8938e66be$export$2e2bcd8739ae039; });

var $j2SvU = parcelRequire("j2SvU");

var $7aNOO = parcelRequire("7aNOO");

var $3clmw = parcelRequire("3clmw");

var $4ozgT = parcelRequire("4ozgT");

var $EU72m = parcelRequire("EU72m");

var $jgdPm = parcelRequire("jgdPm");

var $4pjKo = parcelRequire("4pjKo");

var $9BEjA = parcelRequire("9BEjA");
var $edc5fad8938e66be$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $edc5fad8938e66be$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $9BEjA.round)(x * dpr) / dpr || 0,
        y: (0, $9BEjA.round)(y * dpr) / dpr || 0
    };
}
function $edc5fad8938e66be$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $j2SvU.left);
    var sideY = (0, $j2SvU.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $7aNOO.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $3clmw.default)(popper)) {
            offsetParent = (0, $4ozgT.default)(popper);
            if ((0, $EU72m.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $j2SvU.top) || (placement === (0, $j2SvU.left) || placement === (0, $j2SvU.right)) && variation === (0, $j2SvU.end)) {
            sideY = (0, $j2SvU.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $j2SvU.left) || (placement === (0, $j2SvU.top) || placement === (0, $j2SvU.bottom)) && variation === (0, $j2SvU.end)) {
            sideX = (0, $j2SvU.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $edc5fad8938e66be$var$unsetSides);
    var _ref4 = roundOffsets === true ? $edc5fad8938e66be$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $3clmw.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $edc5fad8938e66be$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $jgdPm.default)(state.placement),
        variation: (0, $4pjKo.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $edc5fad8938e66be$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $edc5fad8938e66be$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $edc5fad8938e66be$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $edc5fad8938e66be$var$computeStyles,
    data: {}
};

});

parcelRegister("5r1Gv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f50c7e1ac3999d9$export$2e2bcd8739ae039; });

var $8vLUx = parcelRequire("8vLUx");

var $ciQff = parcelRequire("ciQff");
// and applies them to the HTMLElements such as popper and arrow
function $3f50c7e1ac3999d9$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $ciQff.isHTMLElement)(element) || !(0, $8vLUx.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $3f50c7e1ac3999d9$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $ciQff.isHTMLElement)(element) || !(0, $8vLUx.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $3f50c7e1ac3999d9$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $3f50c7e1ac3999d9$var$applyStyles,
    effect: $3f50c7e1ac3999d9$var$effect,
    requires: [
        "computeStyles"
    ]
};

});

parcelRegister("11VPO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c02bf359c084ded$export$2e2bcd8739ae039; });

var $jgdPm = parcelRequire("jgdPm");

var $j2SvU = parcelRequire("j2SvU");
function $0c02bf359c084ded$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $jgdPm.default)(placement);
    var invertDistance = [
        (0, $j2SvU.left),
        (0, $j2SvU.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $j2SvU.left),
        (0, $j2SvU.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $0c02bf359c084ded$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $j2SvU.placements).reduce(function(acc, placement) {
        acc[placement] = $0c02bf359c084ded$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $0c02bf359c084ded$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $0c02bf359c084ded$var$offset
};

});

parcelRegister("j7Ym7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $decd7d2faec84944$export$2e2bcd8739ae039; });

var $c2ObQ = parcelRequire("c2ObQ");

var $jgdPm = parcelRequire("jgdPm");

var $u0ugU = parcelRequire("u0ugU");

var $e8rB8 = parcelRequire("e8rB8");

var $f6gPZ = parcelRequire("f6gPZ");

var $j2SvU = parcelRequire("j2SvU");

var $4pjKo = parcelRequire("4pjKo");
function $decd7d2faec84944$var$getExpandedFallbackPlacements(placement) {
    if ((0, $jgdPm.default)(placement) === (0, $j2SvU.auto)) return [];
    var oppositePlacement = (0, $c2ObQ.default)(placement);
    return [
        (0, $u0ugU.default)(placement),
        oppositePlacement,
        (0, $u0ugU.default)(oppositePlacement)
    ];
}
function $decd7d2faec84944$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $jgdPm.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $c2ObQ.default)(preferredPlacement)
    ] : $decd7d2faec84944$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $jgdPm.default)(placement) === (0, $j2SvU.auto) ? (0, $f6gPZ.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $jgdPm.default)(placement);
        var isStartVariation = (0, $4pjKo.default)(placement) === (0, $j2SvU.start);
        var isVertical = [
            (0, $j2SvU.top),
            (0, $j2SvU.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $e8rB8.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $j2SvU.right) : (0, $j2SvU.left) : isStartVariation ? (0, $j2SvU.bottom) : (0, $j2SvU.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $c2ObQ.default)(mainVariationSide);
        var altVariationSide = (0, $c2ObQ.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $decd7d2faec84944$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $decd7d2faec84944$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("c2ObQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c4c9aa2e3ebafaf$export$2e2bcd8739ae039; });
var $8c4c9aa2e3ebafaf$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $8c4c9aa2e3ebafaf$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $8c4c9aa2e3ebafaf$var$hash[matched];
    });
}

});

parcelRegister("u0ugU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05a32e37260780ae$export$2e2bcd8739ae039; });
var $05a32e37260780ae$var$hash = {
    start: "end",
    end: "start"
};
function $05a32e37260780ae$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $05a32e37260780ae$var$hash[matched];
    });
}

});

parcelRegister("e8rB8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4a7387288894904$export$2e2bcd8739ae039; });

var $5Hijx = parcelRequire("5Hijx");

var $4ozgT = parcelRequire("4ozgT");

var $22r87 = parcelRequire("22r87");

var $hhfBS = parcelRequire("hhfBS");

var $9J48a = parcelRequire("9J48a");

var $j2SvU = parcelRequire("j2SvU");

var $ciQff = parcelRequire("ciQff");

var $3BlET = parcelRequire("3BlET");

var $8cSBW = parcelRequire("8cSBW");
function $a4a7387288894904$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $j2SvU.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $j2SvU.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $j2SvU.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $3BlET.default)(typeof padding !== "number" ? padding : (0, $8cSBW.default)(padding, (0, $j2SvU.basePlacements)));
    var altContext = elementContext === (0, $j2SvU.popper) ? (0, $j2SvU.reference) : (0, $j2SvU.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $5Hijx.default)((0, $ciQff.isElement)(element) ? element : element.contextElement || (0, $4ozgT.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $22r87.default)(state.elements.reference);
    var popperOffsets = (0, $hhfBS.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $9J48a.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $j2SvU.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $j2SvU.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $j2SvU.right),
                (0, $j2SvU.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $j2SvU.top),
                (0, $j2SvU.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("5Hijx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $425f2cb592335154$export$2e2bcd8739ae039; });

var $j2SvU = parcelRequire("j2SvU");

var $6YBkQ = parcelRequire("6YBkQ");

var $aXZll = parcelRequire("aXZll");

var $dlxwz = parcelRequire("dlxwz");

var $7aNOO = parcelRequire("7aNOO");

var $4ozgT = parcelRequire("4ozgT");

var $EU72m = parcelRequire("EU72m");

var $ciQff = parcelRequire("ciQff");

var $22r87 = parcelRequire("22r87");

var $5gXCL = parcelRequire("5gXCL");

var $4R7yD = parcelRequire("4R7yD");

var $8vLUx = parcelRequire("8vLUx");

var $9J48a = parcelRequire("9J48a");

var $9BEjA = parcelRequire("9BEjA");
function $425f2cb592335154$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $22r87.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $425f2cb592335154$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $j2SvU.viewport) ? (0, $9J48a.default)((0, $6YBkQ.default)(element, strategy)) : (0, $ciQff.isElement)(clippingParent) ? $425f2cb592335154$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $9J48a.default)((0, $aXZll.default)((0, $4ozgT.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $425f2cb592335154$var$getClippingParents(element) {
    var clippingParents = (0, $dlxwz.default)((0, $5gXCL.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $EU72m.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $ciQff.isHTMLElement)(element) ? (0, $7aNOO.default)(element) : element;
    if (!(0, $ciQff.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $ciQff.isElement)(clippingParent) && (0, $4R7yD.default)(clippingParent, clipperElement) && (0, $8vLUx.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $425f2cb592335154$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $425f2cb592335154$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $425f2cb592335154$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $9BEjA.max)(rect.top, accRect.top);
        accRect.right = (0, $9BEjA.min)(rect.right, accRect.right);
        accRect.bottom = (0, $9BEjA.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $9BEjA.max)(rect.left, accRect.left);
        return accRect;
    }, $425f2cb592335154$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("6YBkQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51454eaa5f5104e1$export$2e2bcd8739ae039; });

var $3clmw = parcelRequire("3clmw");

var $4ozgT = parcelRequire("4ozgT");

var $bCdYX = parcelRequire("bCdYX");

var $4cVNL = parcelRequire("4cVNL");
function $51454eaa5f5104e1$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $3clmw.default)(element);
    var html = (0, $4ozgT.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $4cVNL.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $bCdYX.default)(element),
        y: y
    };
}

});

parcelRegister("aXZll", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fbeff944852a84d$export$2e2bcd8739ae039; });

var $4ozgT = parcelRequire("4ozgT");

var $EU72m = parcelRequire("EU72m");

var $bCdYX = parcelRequire("bCdYX");

var $eJ63P = parcelRequire("eJ63P");

var $9BEjA = parcelRequire("9BEjA");
function $7fbeff944852a84d$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $4ozgT.default)(element);
    var winScroll = (0, $eJ63P.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $9BEjA.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $9BEjA.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $bCdYX.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $EU72m.default)(body || html).direction === "rtl") x += (0, $9BEjA.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("4R7yD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3891f977478cde9b$export$2e2bcd8739ae039; });

var $ciQff = parcelRequire("ciQff");
function $3891f977478cde9b$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $ciQff.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("9J48a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $714b855148183c8f$export$2e2bcd8739ae039; });
function $714b855148183c8f$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("3BlET", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29f5a0c30cafe967$export$2e2bcd8739ae039; });

var $evfv3 = parcelRequire("evfv3");
function $29f5a0c30cafe967$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $evfv3.default)(), paddingObject);
}

});
parcelRegister("evfv3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8effbe82c52d937$export$2e2bcd8739ae039; });
function $a8effbe82c52d937$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("8cSBW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f99ce4e3f6776dc$export$2e2bcd8739ae039; });
function $5f99ce4e3f6776dc$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("f6gPZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afe47a29462e4773$export$2e2bcd8739ae039; });

var $4pjKo = parcelRequire("4pjKo");

var $j2SvU = parcelRequire("j2SvU");

var $e8rB8 = parcelRequire("e8rB8");

var $jgdPm = parcelRequire("jgdPm");
function $afe47a29462e4773$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $j2SvU.placements) : _options$allowedAutoP;
    var variation = (0, $4pjKo.default)(placement);
    var placements = variation ? flipVariations ? (0, $j2SvU.variationPlacements) : (0, $j2SvU.variationPlacements).filter(function(placement) {
        return (0, $4pjKo.default)(placement) === variation;
    }) : (0, $j2SvU.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $e8rB8.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $jgdPm.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("5qqYD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f344e863dfcf285$export$2e2bcd8739ae039; });

var $j2SvU = parcelRequire("j2SvU");

var $jgdPm = parcelRequire("jgdPm");

var $6BKz0 = parcelRequire("6BKz0");

var $hyxKn = parcelRequire("hyxKn");

var $hllFt = parcelRequire("hllFt");

var $17VQS = parcelRequire("17VQS");

var $7aNOO = parcelRequire("7aNOO");

var $e8rB8 = parcelRequire("e8rB8");

var $4pjKo = parcelRequire("4pjKo");

var $evfv3 = parcelRequire("evfv3");

var $9BEjA = parcelRequire("9BEjA");
function $3f344e863dfcf285$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $e8rB8.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $jgdPm.default)(state.placement);
    var variation = (0, $4pjKo.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $6BKz0.default)(basePlacement);
    var altAxis = (0, $hyxKn.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $j2SvU.top) : (0, $j2SvU.left);
        var altSide = mainAxis === "y" ? (0, $j2SvU.bottom) : (0, $j2SvU.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $j2SvU.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $j2SvU.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $17VQS.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $evfv3.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $hllFt.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $7aNOO.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $hllFt.within)(tether ? (0, $9BEjA.min)(min, tetherMin) : min, offset, tether ? (0, $9BEjA.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $j2SvU.top) : (0, $j2SvU.left);
        var _altSide = mainAxis === "x" ? (0, $j2SvU.bottom) : (0, $j2SvU.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $j2SvU.top),
            (0, $j2SvU.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $hllFt.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $hllFt.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $3f344e863dfcf285$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $3f344e863dfcf285$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("hyxKn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc7fca1b9a020031$export$2e2bcd8739ae039; });
function $cc7fca1b9a020031$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});

parcelRegister("hllFt", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $ca05349baaf2063c$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $ca05349baaf2063c$export$86c8af6d3ef0b4a; });

var $9BEjA = parcelRequire("9BEjA");
function $ca05349baaf2063c$export$f28d906d67a997f3(min, value, max) {
    return (0, $9BEjA.max)(min, (0, $9BEjA.min)(value, max));
}
function $ca05349baaf2063c$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $ca05349baaf2063c$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("99hTa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a92d4aa0c8e2009$export$2e2bcd8739ae039; });

var $jgdPm = parcelRequire("jgdPm");

var $17VQS = parcelRequire("17VQS");

var $4R7yD = parcelRequire("4R7yD");

var $7aNOO = parcelRequire("7aNOO");

var $6BKz0 = parcelRequire("6BKz0");

var $hllFt = parcelRequire("hllFt");

var $3BlET = parcelRequire("3BlET");

var $8cSBW = parcelRequire("8cSBW");

var $j2SvU = parcelRequire("j2SvU");
var $6a92d4aa0c8e2009$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $3BlET.default)(typeof padding !== "number" ? padding : (0, $8cSBW.default)(padding, (0, $j2SvU.basePlacements)));
};
function $6a92d4aa0c8e2009$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $jgdPm.default)(state.placement);
    var axis = (0, $6BKz0.default)(basePlacement);
    var isVertical = [
        (0, $j2SvU.left),
        (0, $j2SvU.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $6a92d4aa0c8e2009$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $17VQS.default)(arrowElement);
    var minProp = axis === "y" ? (0, $j2SvU.top) : (0, $j2SvU.left);
    var maxProp = axis === "y" ? (0, $j2SvU.bottom) : (0, $j2SvU.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $7aNOO.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $hllFt.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $6a92d4aa0c8e2009$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $4R7yD.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $6a92d4aa0c8e2009$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $6a92d4aa0c8e2009$var$arrow,
    effect: $6a92d4aa0c8e2009$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});

parcelRegister("ekTcz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6fdc0e3359789ee$export$2e2bcd8739ae039; });

var $j2SvU = parcelRequire("j2SvU");

var $e8rB8 = parcelRequire("e8rB8");
function $a6fdc0e3359789ee$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $a6fdc0e3359789ee$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $j2SvU.top),
        (0, $j2SvU.right),
        (0, $j2SvU.bottom),
        (0, $j2SvU.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $a6fdc0e3359789ee$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $e8rB8.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $e8rB8.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $a6fdc0e3359789ee$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $a6fdc0e3359789ee$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $a6fdc0e3359789ee$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $a6fdc0e3359789ee$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $a6fdc0e3359789ee$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $a6fdc0e3359789ee$var$hide
};

});


parcelRegister("fIcbc", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $b70469af1a14c937$var$hasElementType = typeof Element !== "undefined";
var $b70469af1a14c937$var$hasMap = typeof Map === "function";
var $b70469af1a14c937$var$hasSet = typeof Set === "function";
var $b70469af1a14c937$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $b70469af1a14c937$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$b70469af1a14c937$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($b70469af1a14c937$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$b70469af1a14c937$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($b70469af1a14c937$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($b70469af1a14c937$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($b70469af1a14c937$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$b70469af1a14c937$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $b70469af1a14c937$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});




parcelRegister("16GBP", function(module, exports) {

$parcel$export(module.exports, "Reference", function () { return $0ce7674425a6c993$export$e0be378c32fb70a7; });

var $9nHZC = parcelRequire("9nHZC");

var $iNmzK = parcelRequire("iNmzK");

var $gwCAL = parcelRequire("gwCAL");

var $fjSwp = parcelRequire("fjSwp");
function $0ce7674425a6c993$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $9nHZC.useContext((0, $gwCAL.ManagerReferenceNodeSetterContext));
    var refHandler = $9nHZC.useCallback(function(node) {
        (0, $fjSwp.setRef)(innerRef, node);
        (0, $fjSwp.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $9nHZC.useEffect(function() {
        return function() {
            return (0, $fjSwp.setRef)(innerRef, null);
        };
    }, []);
    $9nHZC.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iNmzK)))(Boolean(setReferenceNode), "`Reference` should not be used outside of a `Manager` component.");
    }, [
        setReferenceNode
    ]);
    return (0, $fjSwp.unwrapArray)(children)({
        ref: refHandler
    });
}

});
parcelRegister("iNmzK", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $daee50a677ebe790$var$__DEV__ = false;
var $daee50a677ebe790$var$warning = function() {};
if ($daee50a677ebe790$var$__DEV__) {
    var $daee50a677ebe790$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $daee50a677ebe790$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $daee50a677ebe790$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $daee50a677ebe790$var$warning;

});


parcelRegister("e4FwP", function(module, exports) {

$parcel$export(module.exports, "Container", function () { return $a3f1a71517f864c9$export$42a852a2b6b56249; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $jp7ng = parcelRequire("jp7ng");

var $kD01A = parcelRequire("kD01A");
var $5LVXk = parcelRequire("5LVXk");

var $aP6k3 = parcelRequire("aP6k3");
function $a3f1a71517f864c9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a3f1a71517f864c9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a3f1a71517f864c9$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a3f1a71517f864c9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $a3f1a71517f864c9$var$themedBackground = (0, $kD01A.default)({
    light: "var(--ds-surface-overlay, ".concat((0, $jp7ng.N0), ")"),
    dark: "var(--ds-surface-overlay, ".concat((0, $jp7ng.DN50), ")")
});
var $a3f1a71517f864c9$var$themedColor = (0, $kD01A.default)({
    light: "var(--ds-text, ".concat((0, $jp7ng.N900), ")"),
    dark: "var(--ds-text, ".concat((0, $jp7ng.DN600), ")")
});
var $a3f1a71517f864c9$var$themedBoxShadow = (0, $kD01A.default)({
    light: "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat((0, $jp7ng.N50A), ", 0 0 1px ").concat((0, $jp7ng.N60A)), ")"),
    dark: "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat((0, $jp7ng.DN50A), ", 0 0 1px ").concat((0, $jp7ng.DN60A)), ")")
});
var $a3f1a71517f864c9$var$borderRadius = (0, $aP6k3.borderRadius)();
var $a3f1a71517f864c9$var$gridSize = (0, $aP6k3.gridSize)();
var $a3f1a71517f864c9$var$CSS_THEME_BACKGROUND = "--theme-background";
var $a3f1a71517f864c9$var$CSS_THEME_COLOR = "--theme-color";
var $a3f1a71517f864c9$var$CSS_THEME_BOX_SHADOW = "--theme-box-shadow";
var $a3f1a71517f864c9$var$containerStyles = (0, $avKww.css)({
    boxSizing: "content-box",
    maxWidth: "".concat($a3f1a71517f864c9$var$gridSize * 56, "px"),
    maxHeight: "".concat($a3f1a71517f864c9$var$gridSize * 56, "px"),
    padding: "var(--ds-space-200, 16px)".concat(" ", "var(--ds-space-300, 24px)"),
    zIndex: (0, $aP6k3.layers).dialog(),
    background: "var(".concat($a3f1a71517f864c9$var$CSS_THEME_BACKGROUND, ")"),
    borderRadius: "".concat($a3f1a71517f864c9$var$borderRadius, "px"),
    boxShadow: "var(".concat($a3f1a71517f864c9$var$CSS_THEME_BOX_SHADOW, ")"),
    color: "var(".concat($a3f1a71517f864c9$var$CSS_THEME_COLOR, ")"),
    "&:focus": {
        outline: "none"
    }
});
var $a3f1a71517f864c9$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var _objectSpread2;
    var children = _ref.children, onBlur = _ref.onBlur, onClick = _ref.onClick, onFocus = _ref.onFocus, style = _ref.style, testId = _ref.testId;
    var theme = (0, $5LVXk.useGlobalTheme)();
    return (0, $avKww.jsx)("div", {
        css: $a3f1a71517f864c9$var$containerStyles,
        "data-testid": testId,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        ref: ref,
        style: $a3f1a71517f864c9$var$_objectSpread((_objectSpread2 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, $a3f1a71517f864c9$var$CSS_THEME_BACKGROUND, $a3f1a71517f864c9$var$themedBackground(theme)), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, $a3f1a71517f864c9$var$CSS_THEME_COLOR, $a3f1a71517f864c9$var$themedColor(theme)), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, $a3f1a71517f864c9$var$CSS_THEME_BOX_SHADOW, $a3f1a71517f864c9$var$themedBoxShadow(theme)), _objectSpread2), style)
    }, children);
});

});


parcelRegister("kfYkZ", function(module, exports) {

$parcel$export(module.exports, "translatePosition", function () { return $c71052aa0740e125$export$458a9c11d1806c6d; });
function $c71052aa0740e125$export$458a9c11d1806c6d(position) {
    switch(position){
        case "top left":
            return "top-start";
        case "top center":
            return "top";
        case "top right":
            return "top-end";
        case "right top":
            return "right-start";
        case "right middle":
            return "right";
        case "right bottom":
            return "right-end";
        case "bottom left":
            return "bottom-start";
        case "bottom center":
            return "bottom";
        case "bottom right":
            return "bottom-end";
        case "left top":
            return "left-start";
        case "left middle":
            return "left";
        case "left bottom":
            return "left-end";
        default:
            return undefined;
    }
}

});


parcelRegister("eSu0s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20b94a790eb7f0b8$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $qh48v = parcelRequire("qh48v");

var $c2oAU = parcelRequire("c2oAU");

var $giWPX = parcelRequire("giWPX");
function $20b94a790eb7f0b8$export$2e2bcd8739ae039({ module: mod, connectHost: connectHost, handleHideInlineDialog: handleHideInlineDialog, inlineDialogOptions: inlineDialogOptions = {} }) {
    const { width: width, height: height } = inlineDialogOptions;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $qh48v.ConnectModuleIframe), {
        connectHost: connectHost,
        module: mod,
        width: width,
        height: height,
        options: {
            ...inlineDialogOptions,
            hostFrameOffset: 1,
            isInlineDialog: true
        },
        handleHideInlineDialog: handleHideInlineDialog,
        loadingComponent: (0, $c2oAU.default),
        loadingTimeoutComponent: (0, $giWPX.default),
        defaultStyles: {
            display: "block"
        }
    });
}

});
parcelRegister("qh48v", function(module, exports) {

$parcel$export(module.exports, "ConnectModuleIframe", function () { return $22bfd2d5bca91d71$export$cd42b5c0d21a24c3; });
$parcel$export(module.exports, "default", function () { return $22bfd2d5bca91d71$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $63PkP = parcelRequire("63PkP");

var $eIoiN = parcelRequire("eIoiN");

var $kXHjP = parcelRequire("kXHjP");
class $22bfd2d5bca91d71$export$cd42b5c0d21a24c3 extends (0, $9nHZC.PureComponent) {
    render() {
        const { module: m, ...props } = this.props;
        if (!m) return null;
        const { id: moduleId, app_key: appKey, module_type: moduleType, source: { url: url }, descriptor: { key: moduleKey, location: location, params: params = {} }, targetHref: targetHref, principalId: principalId } = m;
        const productContext = {
            appKey: appKey,
            moduleId: moduleId,
            moduleKey: moduleKey,
            moduleType: moduleType,
            location: location,
            targetHref: targetHref,
            principalId: principalId
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kXHjP.UrlIframe), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
            url: (0, $63PkP.applyUrlFragment)(url, moduleType, params.passLocation),
            moduleId: moduleId,
            moduleKey: moduleKey,
            appKey: appKey,
            moduleOptions: {
                ...productContext,
                productContext: productContext
            }
        }));
    }
}
var $22bfd2d5bca91d71$export$2e2bcd8739ae039 = (0, $eIoiN.default)($22bfd2d5bca91d71$export$cd42b5c0d21a24c3);

});
parcelRegister("63PkP", function(module, exports) {

$parcel$export(module.exports, "iframeEmptyContainer", function () { return $b9c5534b18cecf40$export$5cc2da531d3443fe; });
$parcel$export(module.exports, "applyUrlFragment", function () { return $b9c5534b18cecf40$export$f9ef681263ce364c; });
$parcel$export(module.exports, "getInitialOrBucketState", function () { return $b9c5534b18cecf40$export$230aeef4b9e0f6e3; });
parcelRequire("jjA7v");
var $k3eFB = parcelRequire("k3eFB");
const $b9c5534b18cecf40$export$5cc2da531d3443fe = (0, $k3eFB.ConnectIframe).defaultProps.iframeContainer;
function $b9c5534b18cecf40$export$f9ef681263ce364c(url, moduleType, passLocation) {
    if (!passLocation || moduleType !== "repoPages" || !window.location.hash) return url;
    return `${url}${window.location.hash}`;
}
const $b9c5534b18cecf40$export$93484e5d50f84920 = "__ssr_state__";
const $b9c5534b18cecf40$export$8b26fc8110ba9d33 = ()=>window[$b9c5534b18cecf40$export$93484e5d50f84920] || {};
const $b9c5534b18cecf40$var$APP_DID_SSR = Object.keys($b9c5534b18cecf40$export$8b26fc8110ba9d33()).length > 0;
const $b9c5534b18cecf40$export$642262419f51fae8 = ()=>$b9c5534b18cecf40$var$APP_DID_SSR;
const $b9c5534b18cecf40$export$230aeef4b9e0f6e3 = ()=>$b9c5534b18cecf40$export$642262419f51fae8() ? $b9c5534b18cecf40$export$8b26fc8110ba9d33().reduxStoreState : // eslint-disable-next-line no-restricted-properties
    window.__initial_state__;

});
parcelRegister("jjA7v", function(module, exports) {

$parcel$export(module.exports, "ConnectIframe", function () { return (parcelRequire("k3eFB")).ConnectIframe; });
$parcel$export(module.exports, "FlagModule", function () { return (parcelRequire("28rlc")).FlagModule; });
$parcel$export(module.exports, "DefaultInlineDialogProvider", function () { return (parcelRequire("3lIWa")).DefaultInlineDialogProvider; });
$parcel$export(module.exports, "DialogModule", function () { return (parcelRequire("6K5Jl")).DialogModule; });
$parcel$export(module.exports, "InlineDialogModule", function () { return (parcelRequire("6sO3c")).InlineDialogModule; });
$parcel$export(module.exports, "MessageModule", function () { return (parcelRequire("lveWB")).MessageModule; });

var $gs8RX = parcelRequire("gs8RX");

var $8UfVU = parcelRequire("8UfVU");

var $lB0Ed = parcelRequire("lB0Ed");

var $giHyl = parcelRequire("giHyl");

var $k3eFB = parcelRequire("k3eFB");

var $28rlc = parcelRequire("28rlc");

var $3lIWa = parcelRequire("3lIWa");

var $6K5Jl = parcelRequire("6K5Jl");

var $aPoPe = parcelRequire("aPoPe");

var $6sO3c = parcelRequire("6sO3c");

var $lveWB = parcelRequire("lveWB");

var $47qaX = parcelRequire("47qaX");

var $gj2DC = parcelRequire("gj2DC");

var $4JYRi = parcelRequire("4JYRi");

var $hPOXW = parcelRequire("hPOXW");

var $8s9JE = parcelRequire("8s9JE");

var $kXL3a = parcelRequire("kXL3a");

var $f8ZR6 = parcelRequire("f8ZR6");

var $bAjPB = parcelRequire("bAjPB");

});
parcelRegister("gs8RX", function(module, exports) {

$parcel$export(module.exports, "analytics", function () { return $bfa6241f2fe85b5b$export$71a493436f9bccb6; });

var $77ckY = parcelRequire("77ckY");

var $47qaX = parcelRequire("47qaX");
var $bfa6241f2fe85b5b$var$AnalyticsController = /** @class */ function() {
    function AnalyticsController() {
        this.loggingEnabled = false;
    }
    AnalyticsController.prototype.isLoggingEnabled = function() {
        return this.loggingEnabled;
    };
    /**
     * In the browser console, enable analytics logging by entering window._analyticsController.enableAnalyticsLogging().
     */ AnalyticsController.prototype.enableAnalyticsLogging = function() {
        console.info("Enabling analytics logging...");
        this.loggingEnabled = true;
        return "Analytics logging is now enabled. (>'-')> <('_'<) ^('_')- m/(-_-)m/ <( '-')> _( .\")> <( ._.)-`";
    };
    /**
     * In the browser console, disable analytics logging by entering window._analyticsController.disableAnalyticsLogging().
     */ AnalyticsController.prototype.disableAnalyticsLogging = function() {
        console.info("Disabling analytics logging...");
        this.loggingEnabled = false;
        return "Analytics logging is now disabled. \xaf\\_(\u30C4)_/\xaf";
    };
    return AnalyticsController;
}();
/**
 * This class serves two purposes:
 *   - It provides the ability for products to register their implementations
 *     of AnalyticsAPI for use by the connect front end code.
 *   - It provides the AnalyticsAPI implementation that connect front end code
 *     should use. This implementation delegates to the registered AnalyticsAPI
 *     implementation. This class should be used within the connect front end
 *     code as follows:
 *
 *     import analytics from '../adaptors/analytics/AnalyticsAdaptor';
 *
 *     analytics.trigger('Flags', 'close', {'type': 'warning'});
 */ var $bfa6241f2fe85b5b$var$AnalyticsAdaptor = /** @class */ function() {
    function AnalyticsAdaptor() {
        this.analyticsAPI = (0, $77ckY.default);
        this.analyticsController = new $bfa6241f2fe85b5b$var$AnalyticsController();
        window._analyticsController = this.analyticsController;
    }
    /**
     * Implementation of AnalyticsRegistry#registerAnalyticsAPI().
     */ AnalyticsAdaptor.prototype.registerAnalyticsAPI = function(analyticsAPI) {
        this.analyticsAPI = analyticsAPI;
    };
    /**
     * Implementation of AnalyticsAPI#trigger() for use by connect-module-core code.
     */ AnalyticsAdaptor.prototype.trigger = function(category, action, appKey, payload) {
        try {
            this.analyticsAPI.trigger(category, action, appKey, payload);
            if (this.analyticsController.isLoggingEnabled()) (0, $47qaX.logger).info("Analytics:", category, action, appKey, payload);
        } catch (exception) {
            (0, $47qaX.logger).warn("Exception trapped triggering analytics event", exception);
        }
    };
    AnalyticsAdaptor.prototype.markAsSafe = function() {
        var allowedStrings = [];
        for(var _i = 0; _i < arguments.length; _i++)allowedStrings[_i] = arguments[_i];
        var _a;
        if (this.analyticsAPI.markAsSafe) return (_a = this.analyticsAPI).markAsSafe.apply(_a, allowedStrings);
        else return (0, $77ckY.default).markAsSafe.apply((0, $77ckY.default), allowedStrings);
    };
    AnalyticsAdaptor.prototype.dangerouslyCreateSafeString = function(value) {
        if (this.analyticsAPI.dangerouslyCreateSafeString) return this.analyticsAPI.dangerouslyCreateSafeString(value);
        else return (0, $77ckY.default).dangerouslyCreateSafeString(value);
    };
    return AnalyticsAdaptor;
}();
var $bfa6241f2fe85b5b$export$71a493436f9bccb6 = new $bfa6241f2fe85b5b$var$AnalyticsAdaptor();

});
parcelRegister("77ckY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01563cee8cf7216c$export$2e2bcd8739ae039; });
var $01563cee8cf7216c$var$DefaultAnalyticsAPI = /** @class */ function() {
    function DefaultAnalyticsAPI() {}
    DefaultAnalyticsAPI.prototype.trigger = function(category, action, payload) {
    // Do nothing.
    };
    DefaultAnalyticsAPI.prototype.markAsSafe = function() {
        var allowedStrings = [];
        for(var _i = 0; _i < arguments.length; _i++)allowedStrings[_i] = arguments[_i];
        // Do no filtering
        return function(value) {
            return value;
        };
    };
    DefaultAnalyticsAPI.prototype.dangerouslyCreateSafeString = function(value) {
        // Do nothing
        return value;
    };
    return DefaultAnalyticsAPI;
}();
var $01563cee8cf7216c$export$2e2bcd8739ae039 = new $01563cee8cf7216c$var$DefaultAnalyticsAPI();

});

parcelRegister("47qaX", function(module, exports) {

$parcel$export(module.exports, "logger", function () { return $2ffc1ece92c577a6$export$af88d00dbe7f521; });

var $eVxH9 = parcelRequire("eVxH9");
var $2ffc1ece92c577a6$var$LoggerController = /** @class */ function() {
    function LoggerController() {
        this.debugEnabled = false;
        this.infoEnabled = true;
    }
    LoggerController.prototype.isDebugEnabled = function() {
        return this.debugEnabled;
    };
    LoggerController.prototype.isInfoEnabled = function() {
        return this.infoEnabled;
    };
    /**
     * In the browser console, enable debug by entering window._loggerController.enableDebug().
     */ LoggerController.prototype.enableDebug = function() {
        console.info("Enabling debug...");
        this.debugEnabled = true;
        return "Debug level logging is now enabled.   \u06DC(\u05E1\u05BC\u06BA\u05E1\u05BC\u064E` )/\u06DC";
    };
    /**
     * In the browser console, disable debug by entering window._loggerController.disableDebug().
     */ LoggerController.prototype.disableDebug = function() {
        console.info("Disabling debug...");
        this.debugEnabled = false;
        return "Debug level logging is now disabled. \u03B5(\xb4\u05E1\u05BC\uFE35\u05E1\u05BC`)\u0437";
    };
    /**
     * In the browser console, enable info by entering window._loggerController.enableInfo().
     */ LoggerController.prototype.enableInfo = function() {
        console.info("Enabling info...");
        this.infoEnabled = true;
        return "Info level logging is now enabled. \u3010\u30C4\u3011";
    };
    /**
     * In the browser console, disable info by entering window._loggerController.disableInfo().
     * <br/>
     * <strong>Note</strong>: disabling info will also disable debug.
     */ LoggerController.prototype.disableInfo = function() {
        console.info("Disabling info...");
        this.debugEnabled = false;
        this.infoEnabled = false;
        return "Info level logging is now disabled. (-.-)Zzz...";
    };
    return LoggerController;
}();
/**
 * This class serves two purposes:
 *   - It provides the ability for products to register their implementations
 *     of LoggerAPI for use by the connect front end code.
 *   - It provides the LoggerAPI implementation that connect front end code
 *     should use. This implementation delegates to the registered LoggerAPI
 *     implementation. This class should be used within the connect front end
 *     code as follows:
 *
 *     import logger from '../adaptors/logger/LoggerAdaptor';
 *
 *     logger.info('My message', extraStuffOfInterest, etc, ...);
 */ var $2ffc1ece92c577a6$var$LoggerAdaptor = /** @class */ function() {
    function LoggerAdaptor() {
        this.loggerAPI = (0, $eVxH9.default);
        this.loggerController = new $2ffc1ece92c577a6$var$LoggerController();
        window._loggerController = this.loggerController;
    }
    /**
     * Implementation of AnalyticsRegistry#registerAnalyticsAPI().
     */ LoggerAdaptor.prototype.registerLoggerAPI = function(loggerAPI) {
        this.loggerAPI = loggerAPI;
    };
    /**
     * Implementation of LoggerAPI#debug() for use by connect-module-core code.
     */ LoggerAdaptor.prototype.debug = function(message) {
        var optionalParams = [];
        for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
        try {
            if (this.loggerController.isDebugEnabled()) this.loggerAPI.debug.apply(this.loggerAPI, arguments);
        } catch (exception) {
        // Ignore
        }
    };
    /**
     * Implementation of LoggerAPI#info() for use by connect-module-core code.
     */ LoggerAdaptor.prototype.info = function(message) {
        var optionalParams = [];
        for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
        try {
            if (this.loggerController.isInfoEnabled()) this.loggerAPI.info.apply(this.loggerAPI, arguments);
        } catch (exception) {
        // Ignore
        }
    };
    /**
     * Implementation of LoggerAPI#warn() for use by connect-module-core code.
     */ LoggerAdaptor.prototype.warn = function(message) {
        var optionalParams = [];
        for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
        try {
            this.loggerAPI.warn.apply(this.loggerAPI, arguments);
        } catch (exception) {
            var logger_1 = console.warn || console.log;
            if (logger_1) logger_1.apply(logger_1, arguments);
        }
    };
    /**
     * Implementation of LoggerAPI#error() for use by connect-module-core code.
     */ LoggerAdaptor.prototype.error = function(message) {
        var optionalParams = [];
        for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
        try {
            this.loggerAPI.error.apply(this.loggerAPI, arguments);
        } catch (exception) {
            var logger_2 = console.error || console.log;
            if (logger_2) logger_2.apply(logger_2, arguments);
        }
    };
    return LoggerAdaptor;
}();
var $2ffc1ece92c577a6$export$af88d00dbe7f521 = new $2ffc1ece92c577a6$var$LoggerAdaptor();

});
parcelRegister("eVxH9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ade086a8c3b5b594$export$2e2bcd8739ae039; });
var $ade086a8c3b5b594$var$DefaultLoggerAPI = /** @class */ function() {
    function DefaultLoggerAPI() {}
    DefaultLoggerAPI.prototype.debug = function(message) {
        var optionalParams = [];
        for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
        console.debug.apply(console, arguments);
    };
    DefaultLoggerAPI.prototype.info = function(message) {
        var optionalParams = [];
        for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
        console.info.apply(console, arguments);
    };
    DefaultLoggerAPI.prototype.warn = function(message) {
        var optionalParams = [];
        for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
        console.warn.apply(console, arguments);
    };
    DefaultLoggerAPI.prototype.error = function(message) {
        var optionalParams = [];
        for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
        console.error.apply(console, arguments);
    };
    return DefaultLoggerAPI;
}();
var $ade086a8c3b5b594$export$2e2bcd8739ae039 = new $ade086a8c3b5b594$var$DefaultLoggerAPI();

});



parcelRegister("8UfVU", function(module, exports) {

var $l5MLt = parcelRequire("l5MLt");

var $lB0Ed = parcelRequire("lB0Ed");
/**
 * This class provides the Adaptor implementation for ACJS
 */ var $67bfe9ad0b8bc5c6$var$ACJSFrameworkAdaptor = /** @class */ function(_super) {
    $l5MLt.__extends(ACJSFrameworkAdaptor, _super);
    function ACJSFrameworkAdaptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ACJSFrameworkAdaptor.prototype.registerModuleWithHost = function(moduleName, simpleXdmDefinition) {
    // Do nothing - ACJS is already registering all core modules.
    };
    ACJSFrameworkAdaptor.prototype.getProviderByModuleName = function(moduleName) {
        return _super.prototype.getProviderByModuleName.call(this, moduleName);
    };
    return ACJSFrameworkAdaptor;
}((0, $lB0Ed.BaseFrameworkAdaptor));
var $67bfe9ad0b8bc5c6$export$8782e9f160c2e1e7 = new $67bfe9ad0b8bc5c6$var$ACJSFrameworkAdaptor();

});
parcelRegister("lB0Ed", function(module, exports) {

$parcel$export(module.exports, "BaseFrameworkAdaptor", function () { return $fb8d8e4368590f21$export$4944e39ef1fb1533; });
/**
 * This class provides common behaviour relating to the adaption of functionality to a
 * particular Connect client framework. This is necessary for an interim period during which
 * we have multiple Connect client frameworks that we need to support: ACJS and CaaS Client.
 */ var $fb8d8e4368590f21$export$4944e39ef1fb1533 = /** @class */ function() {
    function BaseFrameworkAdaptor() {
        this.moduleNamesToModules = new Map();
    }
    /**
     * This method registers a module with the Connect client framework relating to this adaptor instance.
     * @param moduleDefinition the definition of the module.
     */ BaseFrameworkAdaptor.prototype.registerModule = function(module, props) {
        var moduleRegistrationName = module.getModuleRegistrationName();
        this.moduleNamesToModules.set(moduleRegistrationName, module);
        var simpleXdmDefinitionBuilder = module.getSimpleXdmDefinitionBuilder();
        var simpleXdmDefinition = simpleXdmDefinitionBuilder.buildSimpleXdmDefinition();
        this.registerModuleWithHost(moduleRegistrationName, simpleXdmDefinition);
    };
    BaseFrameworkAdaptor.prototype.getModuleByName = function(moduleName) {
        return this.moduleNamesToModules.get(moduleName);
    };
    /**
     * This routine gets a module provider based on the module's name. The provider will only be returned if
     * the module is enabled.
     * @param moduleName the name of the module.
     * @returns {any} the module provider if found and enabled.
     */ BaseFrameworkAdaptor.prototype.getProviderByModuleName = function(moduleName) {
        var module = this.moduleNamesToModules.get(moduleName);
        if (module && module.isEnabled()) return module.getProvider();
        else return undefined;
    };
    return BaseFrameworkAdaptor;
}();

});


parcelRegister("giHyl", function(module, exports) {

var $l5MLt = parcelRequire("l5MLt");

var $lB0Ed = parcelRequire("lB0Ed");
/**
 * This class provides the Connect client framework adaptor implementation for CaaS.
 */ var $bde01c8156ee8ecc$var$CaaSFrameworkAdaptor = /** @class */ function(_super) {
    $l5MLt.__extends(CaaSFrameworkAdaptor, _super);
    function CaaSFrameworkAdaptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CaaSFrameworkAdaptor.prototype.registerModuleWithHost = function(moduleName, simpleXdmDefinition) {
    // Removing the dependency on connect-client to ensure we don't bloat out the size of
    // the code unnecessarily. The following line will be re-instated during the migration
    // to CaaS.
    //defineModule(moduleName, simpleXdmDefinition);
    };
    return CaaSFrameworkAdaptor;
}((0, $lB0Ed.BaseFrameworkAdaptor));
var $bde01c8156ee8ecc$export$6fe9107a24d38c8 = new $bde01c8156ee8ecc$var$CaaSFrameworkAdaptor();

});

parcelRegister("k3eFB", function(module, exports) {

$parcel$export(module.exports, "ConnectIframe", function () { return $e98f779a1e206438$export$8968565585c2471b; });

var $l5MLt = parcelRequire("l5MLt");

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");

var $47qaX = parcelRequire("47qaX");

var $gs8RX = parcelRequire("gs8RX");

var $iFFbM = parcelRequire("iFFbM");

var $7oQBW = parcelRequire("7oQBW");
var $e98f779a1e206438$export$62aa48085237e36f = Object.freeze({
    INIT: Symbol("init"),
    LOADED: Symbol("loaded"),
    FAILED: Symbol("failed"),
    TIMEOUT: Symbol("timeout"),
    LOADING: Symbol("loading"),
    RESOLVING: Symbol("resolving")
});
/**
 * ConnectIframe represents an add-on within a view.
 */ var $e98f779a1e206438$export$8968565585c2471b = /** @class */ function(_super) {
    $l5MLt.__extends(ConnectIframe, _super);
    function ConnectIframe(props) {
        var _this = _super.call(this, props) || this;
        _this.unmountCallbacks = [];
        _this.resize = function(width, height) {
            _this.setState({
                width: width,
                height: height
            });
        };
        _this.sizeToParent = function() {
            _this.setState({
                width: "100%",
                height: "100%"
            });
        };
        _this.registerUnmountCallback = function(callback) {
            _this.unmountCallbacks.push(callback);
        };
        _this.hideInlineDialog = function() {
            if (_this.props.connectIframeProvider.onHideInlineDialog) _this.props.connectIframeProvider.onHideInlineDialog();
        };
        _this.getId = function() {
            if (_this.iframeAttributes) return _this.iframeAttributes.id;
            else return null;
        };
        _this.getIFrameLifecycleEventManager = function() {
            return _this.iframeLifecycleEventManager;
        };
        _this.iframeEstablishedCallback = function() {
            _this.setState({
                loadingState: $e98f779a1e206438$export$62aa48085237e36f.LOADED
            });
        };
        _this.iframeFailedToLoadCallback = function() {
            _this.setState({
                loadingState: $e98f779a1e206438$export$62aa48085237e36f.FAILED
            });
        };
        _this.iframeTimeoutCallback = function() {
            _this.setState({
                loadingState: $e98f779a1e206438$export$62aa48085237e36f.TIMEOUT
            });
        };
        _this._createIFrameLifecycleManager = function() {
            _this.iframeLifecycleEventManager = new (0, $iFFbM.default)(_this);
        };
        _this._unregisterIFrameLifecycleManager = function() {
            if (_this.iframeLifecycleEventManager) _this.iframeLifecycleEventManager.unregister(_this);
        };
        _this._createExtension = function() {
            var simpleXdmExtension = _this.props.connectHost.createExtension({
                addon_key: _this.iframeContext.appKey,
                key: _this.iframeContext.moduleKey,
                url: _this.iframeContext.url,
                options: Object.assign({}, _this.iframeContext.options, {
                    resize: _this.resize.bind(_this),
                    sizeToParent: _this.sizeToParent.bind(_this),
                    registerUnmountCallback: _this.registerUnmountCallback.bind(_this),
                    _contextualOperations: {
                        hideInlineDialog: _this.hideInlineDialog.bind(_this)
                    }
                })
            });
            _this.iframeAttributes = simpleXdmExtension.iframeAttributes;
            (0, $47qaX.logger).debug("Created iframe for add-on ", _this.iframeContext.appKey, _this.iframeAttributes);
            (0, $gs8RX.analytics).trigger((0, $7oQBW.AnalyticsCategories).iframe, (0, $gs8RX.analytics).markAsSafe.apply((0, $gs8RX.analytics), (0, $7oQBW.allowedStrings))((0, $7oQBW.AnalyticsActions).create), (0, $gs8RX.analytics).dangerouslyCreateSafeString(_this.iframeContext.appKey), {});
        };
        _this._destroyExtension = function() {
            if (_this.iframeAttributes) _this.props.connectHost.destroy(_this.iframeAttributes.id);
        };
        _this._isSubIframe = function() {
            return _this.state.hostFrameOffset && _this.state.hostFrameOffset > 1;
        };
        _this._initialise = function() {
            if (_this.props.children && _this.props.connectIframeProvider.onStoreNestedIframeJSON) {
                var childComponent = _this.props.children;
                var childProps = childComponent.props;
                _this.props.connectIframeProvider.onStoreNestedIframeJSON(childProps);
            }
            if (_this._isSubIframe()) {
                _this.setState({
                    loadingState: $e98f779a1e206438$export$62aa48085237e36f.LOADING
                });
                return;
            }
            _this._createIFrameLifecycleManager();
            if (!_this.props.connectIframeProvider.resolveIframeContext) {
                _this._createExtension();
                _this.setState({
                    loadingState: $e98f779a1e206438$export$62aa48085237e36f.LOADING
                });
                return;
            }
            _this.props.connectIframeProvider.resolveIframeContext(_this.iframeContext, _this.props.connectHost).then(function(iframeContext) {
                var propsMutated = iframeContext.appKey !== _this.props.appKey || iframeContext.moduleKey !== _this.props.moduleKey;
                if (propsMutated) {
                    (0, $47qaX.logger).warn("Iframe context changed during resolution");
                    return;
                }
                _this.iframeContext = iframeContext;
                _this._createExtension();
                _this.setState({
                    loadingState: $e98f779a1e206438$export$62aa48085237e36f.LOADING
                });
            });
        };
        _this.state = {
            width: props.width,
            height: props.height,
            loadingState: $e98f779a1e206438$export$62aa48085237e36f.INIT,
            hostFrameOffset: props.options.hostFrameOffset || 1
        };
        _this.iframeContext = {
            url: props.url,
            appKey: props.appKey,
            moduleKey: props.moduleKey,
            options: props.options
        };
        return _this;
    }
    ConnectIframe.prototype.componentWillReceiveProps = function(nextProps) {
        if (this.props.appKey !== nextProps.appKey || this.props.moduleKey !== nextProps.moduleKey) {
            this._unregisterIFrameLifecycleManager();
            this._destroyExtension();
            this.setState({
                width: nextProps.width,
                height: nextProps.height,
                hostFrameOffset: nextProps.options.hostFrameOffset || 1,
                loadingState: $e98f779a1e206438$export$62aa48085237e36f.INIT
            });
        }
    };
    ConnectIframe.prototype.componentWillUnmount = function() {
        this.unmountCallbacks.forEach(function(cb) {
            return cb();
        });
        this._unregisterIFrameLifecycleManager();
        this._destroyExtension();
    };
    ConnectIframe.prototype.render = function() {
        switch(this.state.loadingState){
            case $e98f779a1e206438$export$62aa48085237e36f.LOADED:
            case $e98f779a1e206438$export$62aa48085237e36f.LOADING:
            case $e98f779a1e206438$export$62aa48085237e36f.TIMEOUT:
                var iframeStyles = void 0;
                // Ask the product for the styles to use...
                if (this.props.connectIframeProvider.buildIframeStyles) iframeStyles = this.props.connectIframeProvider.buildIframeStyles(this.state.loadingState, $e98f779a1e206438$export$62aa48085237e36f);
                // if iframeStyles is undefined and loadingState is loading/timeout, set the default style
                if (!iframeStyles && (this.state.loadingState === $e98f779a1e206438$export$62aa48085237e36f.LOADING || this.state.loadingState === $e98f779a1e206438$export$62aa48085237e36f.TIMEOUT)) iframeStyles = {
                    opacity: 0.0
                };
                return $9nHZC.createElement(this.props.iframeContainer, {
                    width: this.state.width,
                    height: this.state.height
                }, this.state.loadingState === $e98f779a1e206438$export$62aa48085237e36f.TIMEOUT ? $9nHZC.createElement(this.props.timeoutIndicator, {
                    failedCallback: this.iframeFailedToLoadCallback.bind(this)
                }) : null, this.state.loadingState === $e98f779a1e206438$export$62aa48085237e36f.LOADING ? $9nHZC.createElement(this.props.loadingIndicator, null) : null, this._isSubIframe() ? this.props.children : $9nHZC.createElement("iframe", $l5MLt.__assign({
                    frameBorder: "0",
                    width: this.state.width,
                    height: this.state.height,
                    style: iframeStyles
                }, this.iframeAttributes, {
                    referrerPolicy: "no-referrer"
                }), this.props.children));
            case $e98f779a1e206438$export$62aa48085237e36f.FAILED:
                return $9nHZC.createElement("div", {
                    style: {
                        height: this.state.height
                    }
                }, $9nHZC.createElement(this.props.failedToLoadIndicator, null));
            case $e98f779a1e206438$export$62aa48085237e36f.INIT:
            case $e98f779a1e206438$export$62aa48085237e36f.RESOLVING:
            default:
                return null;
        }
    };
    ConnectIframe.prototype.componentDidMount = function() {
        if (this.state.loadingState === $e98f779a1e206438$export$62aa48085237e36f.INIT) {
            this.setState({
                loadingState: $e98f779a1e206438$export$62aa48085237e36f.RESOLVING
            });
            this._initialise();
        }
    };
    ConnectIframe.prototype.componentDidUpdate = function() {
        if (this.state.loadingState === $e98f779a1e206438$export$62aa48085237e36f.INIT) {
            this.setState({
                loadingState: $e98f779a1e206438$export$62aa48085237e36f.RESOLVING
            });
            this._initialise();
        }
    };
    ConnectIframe.propTypes = {
        connectHost: $blCBi.object.isRequired,
        appKey: $blCBi.string.isRequired,
        moduleKey: $blCBi.string.isRequired,
        iframeContainer: $blCBi.func,
        loadingIndicator: $blCBi.func,
        failedToLoadIndicator: $blCBi.func,
        timeoutIndicator: $blCBi.func,
        url: $blCBi.string,
        width: $blCBi.string,
        height: $blCBi.string,
        options: $blCBi.object,
        connectIframeProvider: $blCBi.object
    };
    ConnectIframe.defaultProps = {
        options: {},
        connectIframeProvider: {},
        iframeContainer: function(_a) {
            var width = _a.width, height = _a.height, children = _a.children;
            return $9nHZC.createElement("div", {
                style: {
                    position: "relative",
                    width: width === "100%" ? "100%" : "auto",
                    height: height === "100%" ? "100%" : "auto"
                }
            }, children);
        },
        failedToLoadIndicator: function() {
            return null;
        },
        loadingIndicator: function() {
            return null;
        },
        timeoutIndicator: function() {
            return null;
        }
    };
    return ConnectIframe;
}($9nHZC.PureComponent);

});
parcelRegister("iFFbM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d97c01998f8b7693$export$2e2bcd8739ae039; });

var $47qaX = parcelRequire("47qaX");

var $gs8RX = parcelRequire("gs8RX");

var $7oQBW = parcelRequire("7oQBW");
/*
 * Same as in ACJS. See loading_indicator.js.
 */ var $d97c01998f8b7693$var$DEFAULT_APP_LOADING_TIMEOUT = 12000;
var $d97c01998f8b7693$var$connectIframes = [];
var $d97c01998f8b7693$var$registerHostCallbacks = true;
var $d97c01998f8b7693$var$hostIframeEstablishedCallback = function(data) {
    var connectIframe = $d97c01998f8b7693$var$connectIframes.find(function(connectIframe) {
        return data.extension.id === connectIframe.getId();
    });
    if (connectIframe) {
        var manager = connectIframe.getIFrameLifecycleEventManager();
        if (manager) manager.iframeEstablishedCallback(data);
    }
};
var $d97c01998f8b7693$var$hostIframeUnloadCallback = function(data) {
    var connectIframe = $d97c01998f8b7693$var$connectIframes.find(function(connectIframe) {
        return data.extension.id === connectIframe.getId();
    });
    if (connectIframe) {
        var manager = connectIframe.getIFrameLifecycleEventManager();
        if (manager) manager.iframeUnloadCallback(data);
    }
};
var $d97c01998f8b7693$var$IFrameLifecycleEventManager = /** @class */ function() {
    function IFrameLifecycleEventManager(connectIframe) {
        var _this = this;
        this.reset = function() {
            $d97c01998f8b7693$var$connectIframes = [];
            $d97c01998f8b7693$var$registerHostCallbacks = true;
        };
        this.unregister = function(connectIframe) {
            var index = $d97c01998f8b7693$var$connectIframes.indexOf(connectIframe);
            if (index > -1) $d97c01998f8b7693$var$connectIframes.splice(index, 1);
            _this.clearTimeoutDetectionProcessing();
        };
        this.iframeEstablishedCallback = function(data) {
            (0, $47qaX.logger).debug("Established iframe for add-on ", data.extension.addon_key, data);
            if (_this.connectIframe.props.connectIframeProvider.handleIframeLoadingComplete) _this.connectIframe.props.connectIframeProvider.handleIframeLoadingComplete(data.extension.addon_key);
            var loadTime = new Date().getTime();
            var durationToLoadMs = loadTime - _this.creationTimeMs;
            var payload = {
                hostFrameOffset: (0, $gs8RX.analytics).dangerouslyCreateSafeString((_this.connectIframe.props.options.hostFrameOffset || 1).toString()),
                durationToLoadMs: (0, $gs8RX.analytics).dangerouslyCreateSafeString(durationToLoadMs.toString())
            };
            (0, $gs8RX.analytics).trigger((0, $7oQBW.AnalyticsCategories).iframe, (0, $gs8RX.analytics).markAsSafe.apply((0, $gs8RX.analytics), (0, $7oQBW.allowedStrings))((0, $7oQBW.AnalyticsActions).established), (0, $gs8RX.analytics).dangerouslyCreateSafeString(data.extension.addon_key), payload);
            _this.connectIframe.iframeEstablishedCallback();
            _this.clearTimeoutDetectionProcessing();
        };
        this.iframeUnloadCallback = function(data) {
            (0, $47qaX.logger).debug("Unloaded iframe for add-on ", data.extension.id, data);
            if (_this.connectIframe.props.connectIframeProvider.handleIframeUnload) _this.connectIframe.props.connectIframeProvider.handleIframeUnload(data.extension.id);
            var unloadTime = new Date().getTime();
            var sessionDurationMs = unloadTime - _this.creationTimeMs;
            var payload = {
                hostFrameOffset: (0, $gs8RX.analytics).dangerouslyCreateSafeString((_this.connectIframe.props.options.hostFrameOffset || 1).toString()),
                sessionDurationMs: (0, $gs8RX.analytics).dangerouslyCreateSafeString(sessionDurationMs.toString())
            };
            (0, $gs8RX.analytics).trigger((0, $7oQBW.AnalyticsCategories).iframe, (0, $gs8RX.analytics).markAsSafe.apply((0, $gs8RX.analytics), (0, $7oQBW.allowedStrings))((0, $7oQBW.AnalyticsActions).close), (0, $gs8RX.analytics).dangerouslyCreateSafeString(data.extension.id), payload);
        };
        this.startTimeoutDetectionProcessing = function() {
            (0, $47qaX.logger).debug("Starting iframe timed out processing for add-on ", _this.connectIframe.props.appKey);
            var timeoutMilliseconds = _this.getLoadingTimeout();
            _this.timeoutHandle = window.setTimeout(function() {
                (0, $47qaX.logger).warn("Add-on iframe timed out for add-on ", _this.connectIframe.props.appKey);
                _this.timeoutHandle = 0;
                if (_this.connectIframe.props.connectIframeProvider.handleIframeLoadTimeout) _this.connectIframe.props.connectIframeProvider.handleIframeLoadTimeout(_this.connectIframe.props.appKey, _this.connectIframe.iframeFailedToLoadCallback.bind(_this));
                var payload = {
                    hostFrameOffset: (0, $gs8RX.analytics).dangerouslyCreateSafeString((_this.connectIframe.props.options.hostFrameOffset || 1).toString())
                };
                (0, $gs8RX.analytics).trigger((0, $7oQBW.AnalyticsCategories).iframe, (0, $gs8RX.analytics).markAsSafe.apply((0, $gs8RX.analytics), (0, $7oQBW.allowedStrings))((0, $7oQBW.AnalyticsActions).timeout), (0, $gs8RX.analytics).dangerouslyCreateSafeString(_this.connectIframe.props.appKey), payload);
                _this.connectIframe.iframeTimeoutCallback();
            }, timeoutMilliseconds);
        };
        this.getLoadingTimeout = function() {
            var providedTimeoutMilliseconds = _this.connectIframe.props.connectIframeProvider.getLoadingTimeoutMilliseconds ? _this.connectIframe.props.connectIframeProvider.getLoadingTimeoutMilliseconds(_this.connectIframe.props.appKey) : $d97c01998f8b7693$var$DEFAULT_APP_LOADING_TIMEOUT;
            var timeoutMilliseconds = providedTimeoutMilliseconds && providedTimeoutMilliseconds > 0 ? providedTimeoutMilliseconds : $d97c01998f8b7693$var$DEFAULT_APP_LOADING_TIMEOUT;
            return timeoutMilliseconds;
        };
        this.clearTimeoutDetectionProcessing = function() {
            if (_this.timeoutHandle) {
                (0, $47qaX.logger).debug("Clearing iframe timed out timer for add-on ", _this.connectIframe.props.appKey);
                window.clearTimeout(_this.timeoutHandle);
                _this.timeoutHandle = 0;
            }
        };
        this.creationTimeMs = new Date().getTime();
        this.connectIframe = connectIframe;
        $d97c01998f8b7693$var$connectIframes.push(connectIframe);
        if ($d97c01998f8b7693$var$registerHostCallbacks) {
            this.connectIframe.props.connectHost.onIframeEstablished($d97c01998f8b7693$var$hostIframeEstablishedCallback);
            this.connectIframe.props.connectHost.onIframeUnload($d97c01998f8b7693$var$hostIframeUnloadCallback);
            $d97c01998f8b7693$var$registerHostCallbacks = false;
        }
        this.startTimeoutDetectionProcessing();
        if (this.connectIframe.props.connectIframeProvider.handleIframeLoadingStarted) this.connectIframe.props.connectIframeProvider.handleIframeLoadingStarted(this.connectIframe.props.appKey);
    }
    return IFrameLifecycleEventManager;
}();
var $d97c01998f8b7693$export$2e2bcd8739ae039 = $d97c01998f8b7693$var$IFrameLifecycleEventManager;

});
parcelRegister("7oQBW", function(module, exports) {

$parcel$export(module.exports, "AnalyticsCategories", function () { return $563395b93a3c7d14$export$99cb2c76c1f7b090; });
$parcel$export(module.exports, "AnalyticsActions", function () { return $563395b93a3c7d14$export$9dbfb0e4698d080f; });
$parcel$export(module.exports, "allowedStrings", function () { return $563395b93a3c7d14$export$cb67e4122f7d424a; });
var $563395b93a3c7d14$export$99cb2c76c1f7b090;
(function(AnalyticsCategories) {
    AnalyticsCategories.dialog = "dialog";
    AnalyticsCategories.iframe = "iframe";
    AnalyticsCategories.inlineDialog = "inlineDialog";
})($563395b93a3c7d14$export$99cb2c76c1f7b090 || ($563395b93a3c7d14$export$99cb2c76c1f7b090 = {}));
var $563395b93a3c7d14$export$9dbfb0e4698d080f;
(function(AnalyticsActions) {
    AnalyticsActions.create = "create";
    AnalyticsActions.close = "close";
    AnalyticsActions.error = "error";
    AnalyticsActions.timeout = "timeout";
    AnalyticsActions.established = "established";
})($563395b93a3c7d14$export$9dbfb0e4698d080f || ($563395b93a3c7d14$export$9dbfb0e4698d080f = {}));
var $563395b93a3c7d14$export$cb67e4122f7d424a = [
    $563395b93a3c7d14$export$9dbfb0e4698d080f.create,
    $563395b93a3c7d14$export$9dbfb0e4698d080f.close,
    $563395b93a3c7d14$export$9dbfb0e4698d080f.error,
    $563395b93a3c7d14$export$9dbfb0e4698d080f.timeout,
    $563395b93a3c7d14$export$9dbfb0e4698d080f.established
];

});



parcelRegister("28rlc", function(module, exports) {

$parcel$export(module.exports, "FlagModule", function () { return $18e189777df2a664$export$7031eb52127e17da; });

var $l5MLt = parcelRequire("l5MLt");

var $gj2DC = parcelRequire("gj2DC");

var $j25wH = parcelRequire("j25wH");
var $18e189777df2a664$export$748372235e8d793;
(function(FlagModuleDefinitions) {
    FlagModuleDefinitions.FLAG_MODULE_NAME = "flag";
    var Props = /** @class */ function() {
        function Props(adaptor, flagProvider) {
            this.adaptor = adaptor;
            this.flagProvider = flagProvider;
        }
        return Props;
    }();
    FlagModuleDefinitions.Props = Props;
    var State = /** @class */ function() {
        function State(flagProvider) {
            this.enabled = true;
            this.registered = false;
            this.flagProvider = flagProvider;
            this.simpleXdmDefinitionBuilder = new (0, $j25wH.FlagSimpleXdmDefinitionBuilder)(flagProvider);
        }
        return State;
    }();
    FlagModuleDefinitions.State = State;
})($18e189777df2a664$export$748372235e8d793 || ($18e189777df2a664$export$748372235e8d793 = {}));
/**
 * This module provides flag related functionality.
 */ var $18e189777df2a664$export$7031eb52127e17da = /** @class */ function(_super) {
    $l5MLt.__extends(FlagModule, _super);
    function FlagModule(props) {
        return _super.call(this, props) || this;
    }
    FlagModule.prototype.componentWillMount = function() {
        if (!this.props.flagProvider) throw new Error("this.props.flagProvider is not defined");
        this.setState(new $18e189777df2a664$export$748372235e8d793.State(this.props.flagProvider));
    };
    FlagModule.prototype.getModuleRegistrationName = function() {
        return $18e189777df2a664$export$748372235e8d793.FLAG_MODULE_NAME;
    };
    FlagModule.prototype.getSimpleXdmDefinitionBuilder = function() {
        return this.state.simpleXdmDefinitionBuilder;
    };
    FlagModule.prototype.getProvider = function() {
        return this.props.flagProvider;
    };
    FlagModule.prototype.render = function() {
        return null;
    };
    return FlagModule;
}((0, $gj2DC.BaseModule));

});
parcelRegister("gj2DC", function(module, exports) {

$parcel$export(module.exports, "BaseModule", function () { return $bdf0778c3a0befb0$export$adea4f5921a64958; });

var $l5MLt = parcelRequire("l5MLt");

var $9nHZC = parcelRequire("9nHZC");

var $47qaX = parcelRequire("47qaX");
var $bdf0778c3a0befb0$export$ff885fcfc37de939;
(function(ModuleDefinitions) {
    ModuleDefinitions.MIN_REGISTRATION_NAME_LENGTH = 1;
    ModuleDefinitions.MAX_REGISTRATION_NAME_LENGTH = 50;
})($bdf0778c3a0befb0$export$ff885fcfc37de939 || ($bdf0778c3a0befb0$export$ff885fcfc37de939 = {}));
/**
 * This class provides common module behaviour and characteristics. The term 'Module' refers to
 * a set of related functionality and provides the interface between a product that requires the
 * module functionality and the framework that implements it.
 */ var $bdf0778c3a0befb0$export$adea4f5921a64958 = /** @class */ function(_super) {
    $l5MLt.__extends(BaseModule, _super);
    function BaseModule(props) {
        return _super.call(this, props) || this;
    }
    BaseModule.prototype.componentDidMount = function() {
        var props = this.props;
        var registrationName = this.getModuleRegistrationName();
        (0, $47qaX.logger).debug("Mounting module", registrationName, "...");
        this.validateRegistrationName(registrationName);
        props.adaptor.registerModule(this, props);
        var moduleState = this.state;
        moduleState.enabled = true;
        moduleState.registered = true;
        this.setState(moduleState);
    };
    BaseModule.prototype.setEnabled = function(enabled) {
        var moduleState = this.state;
        moduleState.enabled = enabled;
        this.setState(moduleState);
    };
    BaseModule.prototype.isEnabled = function() {
        return this.state.enabled;
    };
    BaseModule.prototype.componentWillUnmount = function() {
    // Do nothing - we don't unregister modules.
    };
    BaseModule.prototype.shouldComponentUpdate = function() {
        // This module hierarchy never renders anything.
        return false;
    };
    BaseModule.prototype.validateRegistrationName = function(registrationName) {
        if (!registrationName || registrationName.length < $bdf0778c3a0befb0$export$ff885fcfc37de939.MIN_REGISTRATION_NAME_LENGTH) throw new Error("The registration name is too short (< " + $bdf0778c3a0befb0$export$ff885fcfc37de939.MIN_REGISTRATION_NAME_LENGTH + " characters).");
        if (registrationName.length > $bdf0778c3a0befb0$export$ff885fcfc37de939.MAX_REGISTRATION_NAME_LENGTH) throw new Error("The registration name is too long (> " + $bdf0778c3a0befb0$export$ff885fcfc37de939.MAX_REGISTRATION_NAME_LENGTH + " characters).");
        if (!registrationName.match(/^[a-z]+$/i)) throw new Error("The registration name must only contain alphabetic characters.");
    };
    BaseModule.prototype.render = function() {
        return null;
    };
    return BaseModule;
}($9nHZC.Component);

});

parcelRegister("j25wH", function(module, exports) {

$parcel$export(module.exports, "FlagSimpleXdmDefinitionBuilder", function () { return $ddb27da25465c009$export$94f22dab2f68a598; });
var $ddb27da25465c009$export$94f22dab2f68a598 = /** @class */ function() {
    function FlagSimpleXdmDefinitionBuilder(flagProvider) {
        if (!flagProvider) throw new Error("flagProvider is not defined");
        this.flagProvider = flagProvider;
    }
    FlagSimpleXdmDefinitionBuilder.prototype.buildSimpleXdmDefinition = function() {
        var flagProvider = this.flagProvider;
        /*
         * This class is a proxy to the flag object created by the flag provider. It is
         * equivalent to the Flag class defined in atlassian-connect-js/src/modules/flag.js
         * except that it does not pull in any AUI flag implementation.
         */ var FlagProxy = /** @class */ function() {
            function FlagProxy(options, callback) {
                options.id = callback._id;
                var flagId = callback._id;
                var actions = [];
                if (typeof options.actions === "object") actions = Object.getOwnPropertyNames(options.actions).map(function(key) {
                    return {
                        actionKey: key,
                        actionText: options.actions[key],
                        executeAction: function() {
                            console.log('This needs to be implemented by broadcasting a "flag-action-invoked" event.');
                        }
                    };
                });
                var flagOptions = {
                    id: flagId,
                    title: options.title,
                    body: options.body,
                    actions: actions,
                    onClose: function() {
                        console.log('This needs to be implemented by broadcasting a "flag.close" event.');
                    },
                    close: options.close,
                    type: options.type.toLowerCase()
                };
                this.flag = flagProvider.create(flagOptions);
            }
            FlagProxy.prototype.close = function() {
                this.flag.close();
            };
            return FlagProxy;
        }();
        return {
            create: {
                constructor: FlagProxy,
                close: FlagProxy.prototype.close
            }
        };
    };
    return FlagSimpleXdmDefinitionBuilder;
}();

});


parcelRegister("3lIWa", function(module, exports) {

$parcel$export(module.exports, "DefaultInlineDialogProvider", function () { return $270630d419c0127d$export$42f4559178b41306; });

var $gs8RX = parcelRequire("gs8RX");

var $7oQBW = parcelRequire("7oQBW");

var $47qaX = parcelRequire("47qaX");
/**
 * This is the default way that products should use to implement InlineDialogProvider operations.
 */ var $270630d419c0127d$export$42f4559178b41306 = /** @class */ function() {
    function DefaultInlineDialogProvider() {}
    DefaultInlineDialogProvider.prototype.hide = function(appContext) {
        var appHasHideOperation = appContext.extension.options._contextualOperations && appContext.extension.options._contextualOperations.hideInlineDialog && typeof appContext.extension.options._contextualOperations.hideInlineDialog === "function";
        if (appHasHideOperation) {
            appContext.extension.options._contextualOperations.hideInlineDialog();
            (0, $47qaX.logger).debug("Hiding inline dialog...");
            (0, $gs8RX.analytics).trigger((0, $7oQBW.AnalyticsCategories).inlineDialog, (0, $7oQBW.AnalyticsActions).close, appContext.extension.addon_key, {});
        } else {
            (0, $47qaX.logger).warn("Attempted to hide the inline dialog for a malformed app: ", appContext);
            (0, $gs8RX.analytics).trigger((0, $7oQBW.AnalyticsCategories).inlineDialog, (0, $7oQBW.AnalyticsActions).error, appContext.extension.addon_key, {
                message: "No hideInlineDialog function"
            });
        }
    };
    return DefaultInlineDialogProvider;
}();

});

parcelRegister("6K5Jl", function(module, exports) {

$parcel$export(module.exports, "DialogModule", function () { return $4e8b7be58715e364$export$d9193a0e0fca7cd8; });

var $l5MLt = parcelRequire("l5MLt");

var $gj2DC = parcelRequire("gj2DC");

var $j4kL9 = parcelRequire("j4kL9");
var $4e8b7be58715e364$export$b2c1533e87918fe9;
(function(DialogModuleDefinitions) {
    DialogModuleDefinitions.DIALOG_MODULE_NAME = "dialog";
    var Props = /** @class */ function() {
        function Props(adaptor, dialogProvider) {
            this.adaptor = adaptor;
            this.dialogProvider = dialogProvider;
        }
        return Props;
    }();
    DialogModuleDefinitions.Props = Props;
    var State = /** @class */ function() {
        function State(dialogProvider) {
            this.enabled = true;
            this.registered = false;
            this.dialogProvider = dialogProvider;
            this.simpleXdmDefinitionBuilder = new (0, $j4kL9.DialogSimpleXdmDefinitionBuilder)(dialogProvider);
        }
        return State;
    }();
    DialogModuleDefinitions.State = State;
})($4e8b7be58715e364$export$b2c1533e87918fe9 || ($4e8b7be58715e364$export$b2c1533e87918fe9 = {}));
/**
 * This module provides dialog related functionality.
 */ var $4e8b7be58715e364$export$d9193a0e0fca7cd8 = /** @class */ function(_super) {
    $l5MLt.__extends(DialogModule, _super);
    function DialogModule(props) {
        return _super.call(this, props) || this;
    }
    DialogModule.prototype.componentWillMount = function() {
        if (!this.props.dialogProvider) throw new Error("this.props.dialogProvider is not defined");
        this.setState(new $4e8b7be58715e364$export$b2c1533e87918fe9.State(this.props.dialogProvider));
    };
    DialogModule.prototype.getModuleRegistrationName = function() {
        return $4e8b7be58715e364$export$b2c1533e87918fe9.DIALOG_MODULE_NAME;
    };
    DialogModule.prototype.getSimpleXdmDefinitionBuilder = function() {
        return this.state.simpleXdmDefinitionBuilder;
    };
    DialogModule.prototype.getProvider = function() {
        return this.props.dialogProvider;
    };
    DialogModule.prototype.render = function() {
        return null;
    };
    return DialogModule;
}((0, $gj2DC.BaseModule));

});
parcelRegister("j4kL9", function(module, exports) {

$parcel$export(module.exports, "DialogSimpleXdmDefinitionBuilder", function () { return $de1e7e77458f94b8$export$b85c05da5be2a57c; });
var $de1e7e77458f94b8$export$b85c05da5be2a57c = /** @class */ function() {
    function DialogSimpleXdmDefinitionBuilder(dialogProvider) {
        if (!dialogProvider) throw new Error("dialogProvider is not defined");
        this.dialogProvider = dialogProvider;
    }
    DialogSimpleXdmDefinitionBuilder.prototype.buildSimpleXdmDefinition = function() {
        return {
        };
    };
    return DialogSimpleXdmDefinitionBuilder;
}();

});


parcelRegister("aPoPe", function(module, exports) {

var $l5MLt = parcelRequire("l5MLt");

var $gj2DC = parcelRequire("gj2DC");

var $2Vl1R = parcelRequire("2Vl1R");
var $7e21ec9c7d5db146$export$4279eadb1f181402;
(function(DropdownModuleDefinitions) {
    DropdownModuleDefinitions.DROPDOWN_MODULE_NAME = "dropdown";
    var Props = /** @class */ function() {
        function Props(adaptor, dropdownProvider) {
            this.adaptor = adaptor;
            this.dropdownProvider = dropdownProvider;
        }
        return Props;
    }();
    DropdownModuleDefinitions.Props = Props;
    var State = /** @class */ function() {
        function State(dropdownProvider) {
            this.enabled = true;
            this.registered = false;
            this.dropdownProvider = dropdownProvider;
            this.simpleXdmDefinitionBuilder = new (0, $2Vl1R.DropdownSimpleXdmDefinitionBuilder)(dropdownProvider);
        }
        return State;
    }();
    DropdownModuleDefinitions.State = State;
})($7e21ec9c7d5db146$export$4279eadb1f181402 || ($7e21ec9c7d5db146$export$4279eadb1f181402 = {}));
/**
 * This module provides dropdown related functionality.
 */ var $7e21ec9c7d5db146$export$f4d87b4303498ba0 = /** @class */ function(_super) {
    $l5MLt.__extends(DropdownModule, _super);
    function DropdownModule(props) {
        return _super.call(this, props) || this;
    }
    DropdownModule.prototype.componentWillMount = function() {
        if (!this.props.dropdownProvider) throw new Error("this.props.dropdownProvider is not defined");
        this.setState(new $7e21ec9c7d5db146$export$4279eadb1f181402.State(this.props.dropdownProvider));
    };
    DropdownModule.prototype.getModuleRegistrationName = function() {
        return $7e21ec9c7d5db146$export$4279eadb1f181402.DROPDOWN_MODULE_NAME;
    };
    DropdownModule.prototype.getSimpleXdmDefinitionBuilder = function() {
        return this.state.simpleXdmDefinitionBuilder;
    };
    DropdownModule.prototype.getProvider = function() {
        return this.props.dropdownProvider;
    };
    DropdownModule.prototype.render = function() {
        return null;
    };
    return DropdownModule;
}((0, $gj2DC.BaseModule));

});
parcelRegister("2Vl1R", function(module, exports) {

$parcel$export(module.exports, "DropdownSimpleXdmDefinitionBuilder", function () { return $221137914a840a56$export$338fba6bed3be020; });
var $221137914a840a56$export$338fba6bed3be020 = /** @class */ function() {
    function DropdownSimpleXdmDefinitionBuilder(dropdownProvider) {
        if (!dropdownProvider) throw new Error("dropdownProvider is not defined");
        this.dropdownProvider = dropdownProvider;
    }
    DropdownSimpleXdmDefinitionBuilder.prototype.buildSimpleXdmDefinition = function() {
        return {
        };
    };
    return DropdownSimpleXdmDefinitionBuilder;
}();

});


parcelRegister("6sO3c", function(module, exports) {

$parcel$export(module.exports, "InlineDialogModule", function () { return $4b4c2e959f78fb9a$export$b1f44b14f5988e61; });

var $l5MLt = parcelRequire("l5MLt");

var $gj2DC = parcelRequire("gj2DC");

var $4nFqS = parcelRequire("4nFqS");
var $4b4c2e959f78fb9a$export$ae7b722dbdc6e5c7;
(function(InlineDialogModuleDefinitions) {
    InlineDialogModuleDefinitions.INLINE_DIALOG_MODULE_NAME = "inlineDialog";
    var Props = /** @class */ function() {
        function Props(adaptor, inlineDialogProvider) {
            this.adaptor = adaptor;
            this.inlineDialogProvider = inlineDialogProvider;
        }
        return Props;
    }();
    InlineDialogModuleDefinitions.Props = Props;
    var State = /** @class */ function() {
        function State(inlineDialogProvider) {
            this.enabled = true;
            this.registered = false;
            this.inlineDialogProvider = inlineDialogProvider;
            this.simpleXdmDefinitionBuilder = new (0, $4nFqS.InlineDialogSimpleXdmDefinitionBuilder)(inlineDialogProvider);
        }
        return State;
    }();
    InlineDialogModuleDefinitions.State = State;
})($4b4c2e959f78fb9a$export$ae7b722dbdc6e5c7 || ($4b4c2e959f78fb9a$export$ae7b722dbdc6e5c7 = {}));
/**
 * This module provides inlineDialog related functionality.
 */ var $4b4c2e959f78fb9a$export$b1f44b14f5988e61 = /** @class */ function(_super) {
    $l5MLt.__extends(InlineDialogModule, _super);
    function InlineDialogModule(props) {
        return _super.call(this, props) || this;
    }
    InlineDialogModule.prototype.componentWillMount = function() {
        if (!this.props.inlineDialogProvider) throw new Error("this.props.inlineDialogProvider is not defined");
        this.setState(new $4b4c2e959f78fb9a$export$ae7b722dbdc6e5c7.State(this.props.inlineDialogProvider));
    };
    InlineDialogModule.prototype.getModuleRegistrationName = function() {
        return $4b4c2e959f78fb9a$export$ae7b722dbdc6e5c7.INLINE_DIALOG_MODULE_NAME;
    };
    InlineDialogModule.prototype.getSimpleXdmDefinitionBuilder = function() {
        return this.state.simpleXdmDefinitionBuilder;
    };
    InlineDialogModule.prototype.getProvider = function() {
        return this.props.inlineDialogProvider;
    };
    InlineDialogModule.prototype.render = function() {
        return null;
    };
    return InlineDialogModule;
}((0, $gj2DC.BaseModule));

});
parcelRegister("4nFqS", function(module, exports) {

$parcel$export(module.exports, "InlineDialogSimpleXdmDefinitionBuilder", function () { return $330973092bde88d4$export$f57ca3ba8378bc0b; });
var $330973092bde88d4$export$f57ca3ba8378bc0b = /** @class */ function() {
    function InlineDialogSimpleXdmDefinitionBuilder(inlineDialogProvider) {
        if (!inlineDialogProvider) throw new Error("inlineDialogProvider is not defined");
        this.inlineDialogProvider = inlineDialogProvider;
    }
    InlineDialogSimpleXdmDefinitionBuilder.prototype.buildSimpleXdmDefinition = function() {
        return {
        };
    };
    return InlineDialogSimpleXdmDefinitionBuilder;
}();

});


parcelRegister("lveWB", function(module, exports) {

$parcel$export(module.exports, "MessageModule", function () { return $fa7815d14464e992$export$22578b4f731c13ad; });

var $l5MLt = parcelRequire("l5MLt");

var $gj2DC = parcelRequire("gj2DC");

var $aZ5Bh = parcelRequire("aZ5Bh");
var $fa7815d14464e992$export$8322ec4fed7b0ec;
(function(MessageModuleDefinitions) {
    MessageModuleDefinitions.MESSAGE_MODULE_NAME = "messages";
    var Props = /** @class */ function() {
        function Props(adaptor, messageProvider) {
            this.adaptor = adaptor;
            this.messageProvider = messageProvider;
        }
        return Props;
    }();
    MessageModuleDefinitions.Props = Props;
    var State = /** @class */ function() {
        function State(messageProvider) {
            this.enabled = true;
            this.registered = false;
            this.messageProvider = messageProvider;
            this.simpleXdmDefinitionBuilder = new (0, $aZ5Bh.MessageSimpleXdmDefinitionBuilder)(messageProvider);
        }
        return State;
    }();
    MessageModuleDefinitions.State = State;
})($fa7815d14464e992$export$8322ec4fed7b0ec || ($fa7815d14464e992$export$8322ec4fed7b0ec = {}));
/**
 * This module provides message related functionality.
 */ var $fa7815d14464e992$export$22578b4f731c13ad = /** @class */ function(_super) {
    $l5MLt.__extends(MessageModule, _super);
    function MessageModule(props) {
        return _super.call(this, props) || this;
    }
    MessageModule.prototype.componentWillMount = function() {
        if (!this.props.messageProvider) throw new Error("this.props.messageProvider is not defined");
        this.setState(new $fa7815d14464e992$export$8322ec4fed7b0ec.State(this.props.messageProvider));
    };
    MessageModule.prototype.getModuleRegistrationName = function() {
        return $fa7815d14464e992$export$8322ec4fed7b0ec.MESSAGE_MODULE_NAME;
    };
    MessageModule.prototype.getSimpleXdmDefinitionBuilder = function() {
        return this.state.simpleXdmDefinitionBuilder;
    };
    MessageModule.prototype.getProvider = function() {
        return this.props.messageProvider;
    };
    MessageModule.prototype.render = function() {
        return null;
    };
    return MessageModule;
}((0, $gj2DC.BaseModule));

});
parcelRegister("aZ5Bh", function(module, exports) {

$parcel$export(module.exports, "MessageSimpleXdmDefinitionBuilder", function () { return $7ff3f1faea6588e1$export$a2377c7acc103422; });
var $7ff3f1faea6588e1$export$a2377c7acc103422 = /** @class */ function() {
    function MessageSimpleXdmDefinitionBuilder(messageProvider) {
        if (!messageProvider) throw new Error("messageProvider is not defined");
        this.messageProvider = messageProvider;
    }
    MessageSimpleXdmDefinitionBuilder.prototype.buildSimpleXdmDefinition = function() {
        return {
        };
    };
    return MessageSimpleXdmDefinitionBuilder;
}();

});


parcelRegister("4JYRi", function(module, exports) {

var $f8ZR6 = parcelRequire("f8ZR6");
/**
 * This class validates an instance of DialogProvider. This is intended to be used by consumers of this library in
 * their tests to validate their implementations. Knowing products have incorporated this into their test suite will
 * allow breaking changes to be introduced in the library.
 */ var $373a92a7884f409b$export$728f00fa4551317c = /** @class */ function() {
    function DialogProviderValidator() {}
    DialogProviderValidator.validate = function(dialogProvider) {
        (0, $f8ZR6.default).checkFunctionExists("dialogProvider", dialogProvider, "create");
        (0, $f8ZR6.default).checkFunctionExists("dialogProvider", dialogProvider, "close");
        (0, $f8ZR6.default).checkFunctionExists("dialogProvider", dialogProvider, "setButtonDisabled");
        (0, $f8ZR6.default).checkFunctionExists("dialogProvider", dialogProvider, "isButtonDisabled");
        (0, $f8ZR6.default).checkFunctionExists("dialogProvider", dialogProvider, "toggleButton");
        (0, $f8ZR6.default).checkFunctionExists("dialogProvider", dialogProvider, "setButtonHidden");
        (0, $f8ZR6.default).checkFunctionExists("dialogProvider", dialogProvider, "isButtonHidden");
        (0, $f8ZR6.default).checkFunctionExists("dialogProvider", dialogProvider, "isActiveDialog");
        var actionClicked = false;
        var myAction = {
            identifier: "my-action",
            text: "Some Action",
            onClick: function() {
                actionClicked = true;
            }
        };
        var dialogCreationOptions = {
            key: "my-dialog",
            size: "medium",
            width: "100%",
            height: "50px",
            chrome: false,
            header: "My header",
            actions: [
                myAction
            ],
            closeOnEscape: true,
            hint: "this is a test"
        };
        var bogus_addon_key = "bogus_app";
        var addon_key = "foo-app";
        var dialogExtension = {
            addon_key: addon_key,
            key: "foo-key",
            options: {}
        };
        var dialog = dialogProvider.create(dialogCreationOptions, dialogExtension);
        // Allow contenet resolver promises to complete
        setTimeout(function() {
            // TODO: Fix under ACJS-735
            // ValidationUtil.checkExists('dialog', dialog);
            // ValidationUtil.checkFunctionExists('dialog', dialog, 'on');
            // Check the dialog is active...
            var isActiveAfterCreation = dialogProvider.isActiveDialog(addon_key);
            if (!isActiveAfterCreation) throw new Error("The dialog should be active");
            // Check the active status returns false for another add-on...
            var isAnotherAppsDialogActive = dialogProvider.isActiveDialog(bogus_addon_key);
            if (isAnotherAppsDialogActive) throw new Error("The dialog should not be active");
            // Check the enabled state of a button...
            if (dialogProvider.isButtonDisabled("my-action")) throw new Error("Button should be enabled by default");
            // Disable a button...
            dialogProvider.setButtonDisabled("my-action", true);
            if (!dialogProvider.isButtonDisabled("my-action")) throw new Error("Button should have been disabled.");
            // Re-enabled a button...
            dialogProvider.toggleButton("my-action");
            if (dialogProvider.isButtonDisabled("my-action")) throw new Error("Button should have been re-enabled.");
            // Check the visibility of a button...
            if (dialogProvider.isButtonHidden("my-action")) throw new Error("Button should be visible by default");
            // Hide a button...
            dialogProvider.setButtonHidden("my-action", true);
            if (!dialogProvider.isButtonHidden("my-action")) throw new Error("Button should have been hidden.");
            dialogProvider.close();
        }, 0);
    };
    return DialogProviderValidator;
}();

});
parcelRegister("f8ZR6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b06795933c51e022$export$2e2bcd8739ae039; });
var $b06795933c51e022$export$fa29912b5fdf77b5 = /** @class */ function() {
    function ValidationUtil() {}
    ValidationUtil.checkExists = function(objectName, object) {
        if (!object) throw new Error(objectName + " does not exist.");
    };
    ValidationUtil.checkPropertyExists = function(objectName, object, propertyName) {
        var objectProperty = object[propertyName];
        if (!objectProperty) throw new Error("Expected " + objectName + " to have a property: " + propertyName + ".");
        if (ValidationUtil.isFunction(objectProperty)) throw new Error(objectName + " has a property " + propertyName + ", but it is a function.");
    };
    ValidationUtil.checkFunctionExists = function(objectName, object, functionName) {
        var objectProperty = object[functionName];
        if (!objectProperty) throw new Error("Expected " + objectName + " to have a function: " + functionName + ".");
        if (!ValidationUtil.isFunction(objectProperty)) {
            var objectPropertyTypeInfo = typeof objectProperty + " (value: " + objectProperty + ")";
            throw new Error(objectName + " has a property " + functionName + ", but it is a " + objectPropertyTypeInfo + " rather than a function.");
        }
    };
    ValidationUtil.isFunction = function(object) {
        return typeof object === "function";
    };
    return ValidationUtil;
}();
var $b06795933c51e022$export$2e2bcd8739ae039 = $b06795933c51e022$export$fa29912b5fdf77b5;

});


parcelRegister("hPOXW", function(module, exports) {

var $6ntbk = parcelRequire("6ntbk");

var $f8ZR6 = parcelRequire("f8ZR6");
/**
 * This class validates an instance of FlagProvider. This is intended to be used by consumers of this library in
 * their tests to validate their implementations. Knowing products have incorporated this into their test suite will
 * allow breaking changes to be introduced in the library.
 */ var $cfbebbda6742c33f$export$a28584b2365c8dd4 = /** @class */ function() {
    function FlagProviderValidator() {}
    FlagProviderValidator.validate = function(flagProvider) {
        (0, $f8ZR6.default).checkFunctionExists("flagProvider", flagProvider, "create");
        (0, $f8ZR6.default).checkFunctionExists("flagProvider", flagProvider, "isFlagOpen");
        FlagProviderValidator.validateFlagCreationAndDeletions(flagProvider, "manual");
        FlagProviderValidator.validateFlagCreationAndDeletions(flagProvider, "auto");
        FlagProviderValidator.validateFlagCreationAndDeletions(flagProvider, "never");
    };
    FlagProviderValidator.validateFlagCreationAndDeletions = function(flagProvider, closeFlagOption) {
        var flagActions = [];
        FlagProviderValidator.validateFlagCreationAndDeletion(flagProvider, closeFlagOption, flagActions, false);
        var flagAction = new (0, $6ntbk.FlagAction)();
        flagAction.actionKey = "some-action";
        flagAction.actionText = "Some Action";
        flagAction.executeAction = function() {
            console.log("Action clicked");
        };
        flagActions.push(flagAction);
        FlagProviderValidator.validateFlagCreationAndDeletion(flagProvider, closeFlagOption, flagActions, false);
        var flagActionMissingExecuteAction = new (0, $6ntbk.FlagAction)();
        flagActionMissingExecuteAction.actionKey = "some-action";
        flagActionMissingExecuteAction.actionText = "Some Action";
        flagActions[0] = flagActionMissingExecuteAction;
        FlagProviderValidator.validateFlagCreationAndDeletion(flagProvider, closeFlagOption, flagActions, true);
    };
    FlagProviderValidator.validateFlagCreationAndDeletion = function(flagProvider, closeFlagOption, flagActions, expectValidationError) {
        var flagIdsToFlags = new Map();
        var flagId = "flag-" + new Date().getMilliseconds();
        var flagOptions = {
            id: flagId,
            title: "My Flag",
            body: "My flag content",
            type: "success",
            close: closeFlagOption,
            onClose: function(flagId) {
                flagIdsToFlags.delete(flagId);
            },
            actions: flagActions
        };
        try {
            var flag = flagProvider.create(flagOptions);
            if (expectValidationError) throw new Error("Expected a validation error, but did not get one.");
            flagIdsToFlags.set(flag.id, flag);
            (0, $f8ZR6.default).checkExists("flag", flag);
            (0, $f8ZR6.default).checkFunctionExists("flag", flag, "close");
            if (closeFlagOption !== "auto") {
                var flagOpen = flagProvider.isFlagOpen(flag.id);
                if (!flagOpen) throw new Error("Expected flag to exist.");
            }
            flag.close();
            if (flagIdsToFlags.size) throw new Error("It looks like the provider did not synchronously call back the onClose method.");
        } catch (exception) {
            if (expectValidationError) ;
            else throw new Error("Did not expect a validation error, but got one.");
        }
    };
    return FlagProviderValidator;
}();

});
parcelRegister("6ntbk", function(module, exports) {

$parcel$export(module.exports, "FlagAction", function () { return $4a4b86ecff249664$export$137131383bc80874; });
var $4a4b86ecff249664$export$137131383bc80874 = /** @class */ function() {
    function FlagAction() {}
    return FlagAction;
}();
/**
 * This interface describes the options controlling the creation of flags.
 */ var $4a4b86ecff249664$export$b7026fd91c62192e = /** @class */ function() {
    function FlagCreationOptions() {}
    return FlagCreationOptions;
}();

});


parcelRegister("8s9JE", function(module, exports) {

var $f8ZR6 = parcelRequire("f8ZR6");

var $j8x2V = parcelRequire("j8x2V");
/**
 * This class validates an instance of InlineDialogProvider. This is intended to be used by consumers of this library in
 * their tests to validate their implementations. Knowing products have incorporated this into their test suite will
 * allow breaking changes to be introduced in the library.
 */ var $62787d7af1e0fcd6$export$c73136b548ed0f6f = /** @class */ function() {
    function InlineDialogProviderValidator() {}
    InlineDialogProviderValidator.validate = function(inlineDialogProvider) {
        (0, $f8ZR6.default).checkFunctionExists("inlineDialogProvider", inlineDialogProvider, "hide");
        var appContext = (0, $j8x2V.TestAppContext).buildNewInstance();
        inlineDialogProvider.hide(appContext);
    };
    return InlineDialogProviderValidator;
}();

});
parcelRegister("j8x2V", function(module, exports) {

$parcel$export(module.exports, "TestAppContext", function () { return $dee865fb5cf81ae6$export$c2ea901ef0c0e837; });
var $dee865fb5cf81ae6$export$2d6b340a940d682f = /** @class */ function() {
    function TestContextualOperations() {
        this.inlineDialogOpen = true;
    }
    TestContextualOperations.prototype.resize = function(width, height) {
        throw new Error("Not implemented yet");
    };
    TestContextualOperations.prototype.sizeToParent = function() {
        throw new Error("Not implemented yet");
    };
    /**
     * This method hides the inline dialog that the add-on identified by this context is
     * being displayed in.
     */ TestContextualOperations.prototype.hideInlineDialog = function() {
        this.inlineDialogOpen = false;
    };
    TestContextualOperations.prototype.isInlineDialogOpen = function() {
        return this.inlineDialogOpen;
    };
    return TestContextualOperations;
}();
var $dee865fb5cf81ae6$export$f4e04f09a1f31b14 = /** @class */ function() {
    function TestAppInstance(appKey, id, key, options) {
        this.addon_key = appKey;
        this.id = id;
        this.key = key;
        this.options = options;
    }
    return TestAppInstance;
}();
var $dee865fb5cf81ae6$export$13e597eb521ea346 = /** @class */ function() {
    function TestAppOptions(autoresize, widthinpx, hostFrameOffset, _contextualOperations) {
        this.autoresize = autoresize;
        this.widthinpx = widthinpx;
        this.hostFrameOffset = hostFrameOffset;
        this._contextualOperations = _contextualOperations;
    }
    return TestAppOptions;
}();
var $dee865fb5cf81ae6$export$c2ea901ef0c0e837 = /** @class */ function() {
    function TestAppContext(extension) {
        this.extension = extension;
    }
    TestAppContext.buildNewInstance = function() {
        var contextualOperations = new $dee865fb5cf81ae6$export$2d6b340a940d682f();
        var autoresize = true;
        var widthinpx = true;
        var hostFrameOffset = 1;
        var appOptions = new $dee865fb5cf81ae6$export$13e597eb521ea346(autoresize, widthinpx, hostFrameOffset, contextualOperations);
        var randomId = new Date().getMilliseconds();
        var appKey = "foo";
        var key = "bar";
        var id = appKey + "__" + key + "__" + randomId;
        var appInstance = new $dee865fb5cf81ae6$export$f4e04f09a1f31b14(appKey, id, key, appOptions);
        var appContext = new TestAppContext(appInstance);
        return appContext;
    };
    return TestAppContext;
}();

});


parcelRegister("kXL3a", function(module, exports) {

var $f8ZR6 = parcelRequire("f8ZR6");
/**
 * This class validates an instance of MessageProvider. This is intended to be used by consumers of this library in
 * their tests to validate their implementations. Knowing products have incorporated this into their test suite will
 * allow breaking changes to be introduced in the library.
 */ var $f42dd07ca6f86038$export$4aff556677cdd09a = /** @class */ function() {
    function MessageProviderValidator() {}
    MessageProviderValidator.validate = function(messageProvider) {
        (0, $f8ZR6.default).checkFunctionExists("messageProvider", messageProvider, "clear");
        (0, $f8ZR6.default).checkFunctionExists("messageProvider", messageProvider, "onClose");
        var creationRoutineNames = [
            "generic",
            "hint",
            "info",
            "success",
            "warning",
            "error"
        ];
        creationRoutineNames.forEach(function(creationRoutineName) {
            (0, $f8ZR6.default).checkFunctionExists("messageProvider", messageProvider, creationRoutineName);
            var messageId = "message-" + new Date().getMilliseconds();
            var title = "My Message";
            var body = "My message content";
            var messageOptions = {
                id: messageId,
                closeable: true,
                fadeout: true,
                delay: 2000,
                duration: 4000
            };
            if (creationRoutineName === "generic") messageProvider.generic(title, body, messageOptions);
            else if (creationRoutineName === "hint") messageProvider.hint(title, body, messageOptions);
            else if (creationRoutineName === "info") messageProvider.info(title, body, messageOptions);
            else if (creationRoutineName === "success") messageProvider.success(title, body, messageOptions);
            else if (creationRoutineName === "warning") messageProvider.warning(title, body, messageOptions);
            else if (creationRoutineName === "error") messageProvider.error(title, body, messageOptions);
            (0, $f8ZR6.default).checkExists("messageId", messageId);
            var dummyOnCloseCalled = false;
            var onCloseCalled = false;
            messageProvider.onClose(messageId, function() {
                onCloseCalled = true;
            });
            messageProvider.onClose("dummy-message-id", function() {
                dummyOnCloseCalled = true;
            });
            messageProvider.clear(messageId);
            if (!onCloseCalled) throw new Error("Expected onClose callback to be called after calling clear.");
            if (dummyOnCloseCalled) throw new Error("Did not expect the dummy onClose callback to be called.");
        });
    };
    return MessageProviderValidator;
}();

});

parcelRegister("bAjPB", function(module, exports) {

var $cs1Mx = parcelRequire("cs1Mx");
/**
 * This class provides a mock implementation of ConnectHost.
 */ var $86f27099952f62b6$export$d34d7bcfe7ba9cee = /** @class */ function() {
    function MockConnectHost() {
        this.onIframeEstablished = jest.fn();
        this.offIframeEstablished = jest.fn();
        this.onIframeUnload = jest.fn();
        this.offIframeUnload = jest.fn();
        this.createExtension = jest.fn(function(params) {
            var val = new (0, $cs1Mx.MockSimpleXdmExtension);
            val.iframeAttributes.src = params.url;
            return val;
        });
        this.destroy = jest.fn();
        this.getContentResolver = jest.fn();
        this.hasJwt = jest.fn();
        this.isJwtExpired = jest.fn();
    }
    return MockConnectHost;
}();

});
parcelRegister("cs1Mx", function(module, exports) {

$parcel$export(module.exports, "MockSimpleXdmExtension", function () { return $91097b673872c4bb$export$1cddb33ac1c7fcc0; });

var $hCtjd = parcelRequire("hCtjd");
var $91097b673872c4bb$export$1cddb33ac1c7fcc0 = /** @class */ function() {
    function MockSimpleXdmExtension() {
        this.iframeAttributes = new (0, $hCtjd.MockConnectIframeInterface)();
        this.extension = {};
    }
    return MockSimpleXdmExtension;
}();

});
parcelRegister("hCtjd", function(module, exports) {

$parcel$export(module.exports, "MockConnectIframeInterface", function () { return $cd3cb865c758ec6d$export$72c538805177fc9d; });
var $cd3cb865c758ec6d$export$72c538805177fc9d = /** @class */ function() {
    function MockConnectIframeInterface() {
        this.id = "mock-iframe-id";
        this.src = "mock-iframe-src";
        this.name = "mock-iframe-name";
    }
    return MockConnectIframeInterface;
}();

});





parcelRegister("kXHjP", function(module, exports) {

$parcel$export(module.exports, "UrlIframe", function () { return $023a014784a7bc9d$export$928e5e17e8bfe096; });
$parcel$export(module.exports, "default", function () { return $023a014784a7bc9d$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("jjA7v");
var $k3eFB = parcelRequire("k3eFB");

var $eIoiN = parcelRequire("eIoiN");

var $9gkf9 = parcelRequire("9gkf9");

var $MTGTE = parcelRequire("MTGTE");

var $c2oAU = parcelRequire("c2oAU");

var $giWPX = parcelRequire("giWPX");

var $iiGhh = parcelRequire("iiGhh");

var $63PkP = parcelRequire("63PkP");
class $023a014784a7bc9d$export$928e5e17e8bfe096 extends (0, $9nHZC.PureComponent) {
    /* eslint-disable @typescript-eslint/no-empty-function */ /* eslint-enable @typescript-eslint/no-empty-function */ render() {
        const { moduleId: moduleId, appKey: appKey, moduleKey: moduleKey, url: url, connectHost: connectHost, width: width, height: height, options: defaultOptions, moduleOptions: moduleOptions, loadingComponent: LoadingIndicator = (0, $c2oAU.default), loadingFailedComponent: FailedIndicator = (0, $MTGTE.default), loadingTimeoutComponent: TimeoutIndicator = (0, $giWPX.default), iframeContainer: iframeContainer = (0, $63PkP.iframeEmptyContainer), loadingTimeout: // provider props
        loadingTimeout, defaultStyles: defaultStyles, handleHideInlineDialog: handleHideInlineDialog, handleIframeLoadingStarted: handleIframeLoadingStarted, handleIframeLoadingComplete: handleIframeLoadingComplete, handleIframeUnload: handleIframeUnload, buildIframeStyles: buildIframeStyles } = this.props;
        let isACJSNextEnabled = false;
        try {
            const acjsNextFeature = !!(0, $63PkP.getInitialOrBucketState)().global.features["acjs-next"];
            if (acjsNextFeature) isACJSNextEnabled = true;
        } catch (_error) {
        // TODO: BBCEEP-3380 Implement error monitoring
        }
        const options = {
            ...defaultOptions,
            ...moduleOptions,
            __featuresInternal: {
                // eslint-disable-next-line no-underscore-dangle
                ...defaultOptions === null || defaultOptions === void 0 ? void 0 : defaultOptions.__featuresInternal,
                isACJSNextEnabled: isACJSNextEnabled
            },
            sandbox: $023a014784a7bc9d$export$928e5e17e8bfe096.IFRAME_SANDBOX,
            noSub: true
        };
        const connectIframeProvider = new (0, $iiGhh.default)({
            loadingTimeout: loadingTimeout,
            defaultStyles: defaultStyles,
            handleHideInlineDialog: handleHideInlineDialog,
            handleIframeLoadingStarted: handleIframeLoadingStarted,
            handleIframeLoadingComplete: handleIframeLoadingComplete,
            handleIframeUnload: handleIframeUnload,
            buildIframeStyles: buildIframeStyles
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $k3eFB.ConnectIframe), {
            key: moduleId,
            connectHost: connectHost,
            appKey: appKey,
            moduleKey: moduleKey,
            loadingIndicator: LoadingIndicator,
            failedToLoadIndicator: FailedIndicator,
            timeoutIndicator: (timeoutIndicatorProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(TimeoutIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, timeoutIndicatorProps, {
                    publishUiEvent: this.props.publishUiEvent,
                    captureMessageWithTags: this.props.captureMessageWithTags,
                    context: {
                        url: url,
                        ...options.productContext
                    }
                })),
            url: url,
            options: {
                ...$023a014784a7bc9d$export$928e5e17e8bfe096.options,
                ...options
            },
            width: (0, $9gkf9.isNumeric)(width) ? String(width) : "",
            height: (0, $9gkf9.isNumeric)(height) ? String(height) : "",
            connectIframeProvider: connectIframeProvider,
            iframeContainer: iframeContainer
        });
    }
}
$023a014784a7bc9d$export$928e5e17e8bfe096.options = {
    autoresize: false,
    widthinpx: false,
    hostFrameOffset: 0,
    _contextualOperations: {
        resize () {},
        sizeToParent () {},
        hideInlineDialog () {}
    }
};
$023a014784a7bc9d$export$928e5e17e8bfe096.IFRAME_SANDBOX = "allow-forms allow-modals allow-popups allow-scripts allow-same-origin allow-top-navigation-by-user-activation allow-downloads";
var $023a014784a7bc9d$export$2e2bcd8739ae039 = (0, $eIoiN.default)($023a014784a7bc9d$export$928e5e17e8bfe096);

});
parcelRegister("MTGTE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06cf4bb9b2657286$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");
var $06cf4bb9b2657286$export$2e2bcd8739ae039;
$06cf4bb9b2657286$export$2e2bcd8739ae039 = class IframeFailedIndicator extends (0, $9nHZC.PureComponent) {
    render() {
        const { appKey: appKey, width: width, height: height } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
            style: {
                width: width,
                height: height
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("p", null, "Oops, the app ", appKey, " failed to load."));
    }
};

});

parcelRegister("c2oAU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $066e096fe9591a3e$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $dEKDm = parcelRequire("dEKDm");
var $066e096fe9591a3e$export$2e2bcd8739ae039;
$066e096fe9591a3e$export$2e2bcd8739ae039 = class IframeLoadingIndicator extends (0, $9nHZC.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
            style: this.props.containerStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dEKDm.default), {
            size: "large"
        }));
    }
};
$066e096fe9591a3e$export$2e2bcd8739ae039.defaultProps = {
    containerStyle: {
        position: "relative",
        height: "auto",
        width: "auto",
        minHeight: 140,
        zIndex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    }
};

});

parcelRegister("giWPX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $975052498ad68987$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $cJH1T = parcelRequire("cJH1T");

var $3THTN = parcelRequire("3THTN");

var $dEKDm = parcelRequire("dEKDm");
class $975052498ad68987$export$31dce4b3844a4cc2 extends (0, $9nHZC.PureComponent) {
    constructor(...args){
        super(...args);
        this.onRetry = ()=>{
            if (this.props.context && this.props.publishUiEvent) this.props.publishUiEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "connectTimeoutRetryButton",
                source: "addonRepositoryPage",
                attributes: this.parsedAttributes
            }, ()=>window.location.reload());
            else window.location.reload();
        };
    }
    componentDidMount() {
        if (this.props.context && this.props.captureMessageWithTags) this.props.captureMessageWithTags("CONNECT_IFRAME_TIMEOUT", {}, this.parsedAttributes);
    }
    get parsedAttributes() {
        if (!this.props.context) return {};
        const { origin: origin, pathname: pathname, search: search } = new URL(this.props.context.url);
        const urlAttributes = {
            ...(0, $cJH1T.parse)(search),
            url: `${origin}${pathname}`
        };
        delete urlAttributes.jwt;
        return {
            ...this.props.context,
            ...urlAttributes
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
            style: this.props.containerStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dEKDm.default), {
            size: "large"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
            style: {
                margin: "16px"
            }
        }, "Wait,", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3THTN.default), {
            appearance: "link",
            spacing: "none",
            onClick: this.onRetry
        }, "retry"), " ", "or", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3THTN.default), {
            appearance: "link",
            spacing: "none",
            onClick: this.props.failedCallback
        }, "cancel"), "?"));
    }
}
$975052498ad68987$export$31dce4b3844a4cc2.defaultProps = {
    containerStyle: {
        position: "relative",
        height: "auto",
        width: "auto",
        minHeight: 140,
        zIndex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    }
};
var $975052498ad68987$export$2e2bcd8739ae039 = $975052498ad68987$export$31dce4b3844a4cc2;

});
parcelRegister("cJH1T", function(module, exports) {
"use strict";

var $6UhvH = parcelRequire("6UhvH");

var $aPPJV = parcelRequire("aPPJV");

var $8I1Cr = parcelRequire("8I1Cr");
module.exports = {
    formats: $8I1Cr,
    parse: $aPPJV,
    stringify: $6UhvH
};

});
parcelRegister("6UhvH", function(module, exports) {
"use strict";

var $isihP = parcelRequire("isihP");

var $eJ7No = parcelRequire("eJ7No");

var $8I1Cr = parcelRequire("8I1Cr");
var $50758e3ada03ed26$var$has = Object.prototype.hasOwnProperty;
var $50758e3ada03ed26$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $50758e3ada03ed26$var$isArray = Array.isArray;
var $50758e3ada03ed26$var$split = String.prototype.split;
var $50758e3ada03ed26$var$push = Array.prototype.push;
var $50758e3ada03ed26$var$pushToArray = function(arr, valueOrArray) {
    $50758e3ada03ed26$var$push.apply(arr, $50758e3ada03ed26$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $50758e3ada03ed26$var$toISO = Date.prototype.toISOString;
var $50758e3ada03ed26$var$defaultFormat = $8I1Cr.default;
var $50758e3ada03ed26$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encoder: $eJ7No.encode,
    encodeValuesOnly: false,
    format: $50758e3ada03ed26$var$defaultFormat,
    formatter: $8I1Cr.formatters[$50758e3ada03ed26$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $50758e3ada03ed26$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $50758e3ada03ed26$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $50758e3ada03ed26$var$sentinel = {};
var $50758e3ada03ed26$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($50758e3ada03ed26$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($50758e3ada03ed26$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $50758e3ada03ed26$var$isArray(obj)) obj = $eJ7No.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $50758e3ada03ed26$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($50758e3ada03ed26$var$isNonNullishPrimitive(obj) || $eJ7No.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $50758e3ada03ed26$var$defaults.encoder, charset, "key", format);
            if (generateArrayPrefix === "comma" && encodeValuesOnly) {
                var valuesArray = $50758e3ada03ed26$var$split.call(String(obj), ",");
                var valuesJoined = "";
                for(var i = 0; i < valuesArray.length; ++i)valuesJoined += (i === 0 ? "" : ",") + formatter(encoder(valuesArray[i], $50758e3ada03ed26$var$defaults.encoder, charset, "value", format));
                return [
                    formatter(keyValue) + (commaRoundTrip && $50758e3ada03ed26$var$isArray(obj) && valuesArray.length === 1 ? "[]" : "") + "=" + valuesJoined
                ];
            }
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $50758e3ada03ed26$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $50758e3ada03ed26$var$isArray(obj)) // we need to join elements in
    objKeys = [
        {
            value: obj.length > 0 ? obj.join(",") || null : void 0
        }
    ];
    else if ($50758e3ada03ed26$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var adjustedPrefix = commaRoundTrip && $50758e3ada03ed26$var$isArray(obj) && obj.length === 1 ? prefix + "[]" : prefix;
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var keyPrefix = $50758e3ada03ed26$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + key : "[" + key + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $isihP();
        valueSideChannel.set($50758e3ada03ed26$var$sentinel, sideChannel);
        $50758e3ada03ed26$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $50758e3ada03ed26$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $50758e3ada03ed26$var$defaults;
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $50758e3ada03ed26$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $8I1Cr.default;
    if (typeof opts.format !== "undefined") {
        if (!$50758e3ada03ed26$var$has.call($8I1Cr.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $8I1Cr.formatters[format];
    var filter = $50758e3ada03ed26$var$defaults.filter;
    if (typeof opts.filter === "function" || $50758e3ada03ed26$var$isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $50758e3ada03ed26$var$defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === "undefined" ? $50758e3ada03ed26$var$defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $50758e3ada03ed26$var$defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === "undefined" ? $50758e3ada03ed26$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $50758e3ada03ed26$var$defaults.encode,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $50758e3ada03ed26$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $50758e3ada03ed26$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $50758e3ada03ed26$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $50758e3ada03ed26$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $50758e3ada03ed26$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $50758e3ada03ed26$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($50758e3ada03ed26$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var arrayFormat;
    if (opts && opts.arrayFormat in $50758e3ada03ed26$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && "indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = "indices";
    var generateArrayPrefix = $50758e3ada03ed26$var$arrayPrefixGenerators[arrayFormat];
    if (opts && "commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var commaRoundTrip = generateArrayPrefix === "comma" && opts && opts.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $isihP();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $50758e3ada03ed26$var$pushToArray(keys, $50758e3ada03ed26$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

});
parcelRegister("isihP", function(module, exports) {
"use strict";

var $26MBv = parcelRequire("26MBv");

var $5J0jd = parcelRequire("5J0jd");

var $f4Mi1 = parcelRequire("f4Mi1");

var $2BwJo = parcelRequire("2BwJo");
var $d6f906dbb0754fa3$var$$WeakMap = $26MBv("%WeakMap%", true);
var $d6f906dbb0754fa3$var$$Map = $26MBv("%Map%", true);
var $d6f906dbb0754fa3$var$$weakMapGet = $5J0jd("WeakMap.prototype.get", true);
var $d6f906dbb0754fa3$var$$weakMapSet = $5J0jd("WeakMap.prototype.set", true);
var $d6f906dbb0754fa3$var$$weakMapHas = $5J0jd("WeakMap.prototype.has", true);
var $d6f906dbb0754fa3$var$$mapGet = $5J0jd("Map.prototype.get", true);
var $d6f906dbb0754fa3$var$$mapSet = $5J0jd("Map.prototype.set", true);
var $d6f906dbb0754fa3$var$$mapHas = $5J0jd("Map.prototype.has", true);
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('.').listGetNode} */ var $d6f906dbb0754fa3$var$listGetNode = function(list, key) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    for(; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        // eslint-disable-next-line no-extra-parens
        curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
/** @type {import('.').listGet} */ var $d6f906dbb0754fa3$var$listGet = function(objects, key) {
    var node = $d6f906dbb0754fa3$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('.').listSet} */ var $d6f906dbb0754fa3$var$listSet = function(objects, key, value) {
    var node = $d6f906dbb0754fa3$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('.').ListNode<typeof value>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('.').listHas} */ var $d6f906dbb0754fa3$var$listHas = function(objects, key) {
    return !!$d6f906dbb0754fa3$var$listGetNode(objects, key);
};
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @type {WeakMap<object, unknown>} */ var $wm;
    /** @type {Map<object, unknown>} */ var $m;
    /** @type {import('.').RootNode<unknown>} */ var $o;
    /** @type {import('.').Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $2BwJo("Side channel does not contain " + $f4Mi1(key));
        },
        get: function(key) {
            if ($d6f906dbb0754fa3$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $d6f906dbb0754fa3$var$$weakMapGet($wm, key);
            } else if ($d6f906dbb0754fa3$var$$Map) {
                if ($m) return $d6f906dbb0754fa3$var$$mapGet($m, key);
            } else {
                if ($o) return $d6f906dbb0754fa3$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($d6f906dbb0754fa3$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $d6f906dbb0754fa3$var$$weakMapHas($wm, key);
            } else if ($d6f906dbb0754fa3$var$$Map) {
                if ($m) return $d6f906dbb0754fa3$var$$mapHas($m, key);
            } else {
                if ($o) return $d6f906dbb0754fa3$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($d6f906dbb0754fa3$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $d6f906dbb0754fa3$var$$WeakMap();
                $d6f906dbb0754fa3$var$$weakMapSet($wm, key, value);
            } else if ($d6f906dbb0754fa3$var$$Map) {
                if (!$m) $m = new $d6f906dbb0754fa3$var$$Map();
                $d6f906dbb0754fa3$var$$mapSet($m, key, value);
            } else {
                if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
                $o = {
                    key: {},
                    next: null
                };
                $d6f906dbb0754fa3$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};

});
parcelRegister("f4Mi1", function(module, exports) {
var $af9cb013bbf461d9$var$hasMap = typeof Map === "function" && Map.prototype;
var $af9cb013bbf461d9$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $af9cb013bbf461d9$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $af9cb013bbf461d9$var$mapSize = $af9cb013bbf461d9$var$hasMap && $af9cb013bbf461d9$var$mapSizeDescriptor && typeof $af9cb013bbf461d9$var$mapSizeDescriptor.get === "function" ? $af9cb013bbf461d9$var$mapSizeDescriptor.get : null;
var $af9cb013bbf461d9$var$mapForEach = $af9cb013bbf461d9$var$hasMap && Map.prototype.forEach;
var $af9cb013bbf461d9$var$hasSet = typeof Set === "function" && Set.prototype;
var $af9cb013bbf461d9$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $af9cb013bbf461d9$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $af9cb013bbf461d9$var$setSize = $af9cb013bbf461d9$var$hasSet && $af9cb013bbf461d9$var$setSizeDescriptor && typeof $af9cb013bbf461d9$var$setSizeDescriptor.get === "function" ? $af9cb013bbf461d9$var$setSizeDescriptor.get : null;
var $af9cb013bbf461d9$var$setForEach = $af9cb013bbf461d9$var$hasSet && Set.prototype.forEach;
var $af9cb013bbf461d9$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $af9cb013bbf461d9$var$weakMapHas = $af9cb013bbf461d9$var$hasWeakMap ? WeakMap.prototype.has : null;
var $af9cb013bbf461d9$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $af9cb013bbf461d9$var$weakSetHas = $af9cb013bbf461d9$var$hasWeakSet ? WeakSet.prototype.has : null;
var $af9cb013bbf461d9$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $af9cb013bbf461d9$var$weakRefDeref = $af9cb013bbf461d9$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $af9cb013bbf461d9$var$booleanValueOf = Boolean.prototype.valueOf;
var $af9cb013bbf461d9$var$objectToString = Object.prototype.toString;
var $af9cb013bbf461d9$var$functionToString = Function.prototype.toString;
var $af9cb013bbf461d9$var$$match = String.prototype.match;
var $af9cb013bbf461d9$var$$slice = String.prototype.slice;
var $af9cb013bbf461d9$var$$replace = String.prototype.replace;
var $af9cb013bbf461d9$var$$toUpperCase = String.prototype.toUpperCase;
var $af9cb013bbf461d9$var$$toLowerCase = String.prototype.toLowerCase;
var $af9cb013bbf461d9$var$$test = RegExp.prototype.test;
var $af9cb013bbf461d9$var$$concat = Array.prototype.concat;
var $af9cb013bbf461d9$var$$join = Array.prototype.join;
var $af9cb013bbf461d9$var$$arrSlice = Array.prototype.slice;
var $af9cb013bbf461d9$var$$floor = Math.floor;
var $af9cb013bbf461d9$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $af9cb013bbf461d9$var$gOPS = Object.getOwnPropertySymbols;
var $af9cb013bbf461d9$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $af9cb013bbf461d9$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $af9cb013bbf461d9$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $af9cb013bbf461d9$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $af9cb013bbf461d9$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $af9cb013bbf461d9$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $af9cb013bbf461d9$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $af9cb013bbf461d9$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$af9cb013bbf461d9$var$$floor(-num) : $af9cb013bbf461d9$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $af9cb013bbf461d9$var$$slice.call(str, intStr.length + 1);
            return $af9cb013bbf461d9$var$$replace.call(intStr, sepRegex, "$&_") + "." + $af9cb013bbf461d9$var$$replace.call($af9cb013bbf461d9$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $af9cb013bbf461d9$var$$replace.call(str, sepRegex, "$&_");
}

var $iZpK3 = parcelRequire("iZpK3");
var $af9cb013bbf461d9$var$inspectCustom = $iZpK3.custom;
var $af9cb013bbf461d9$var$inspectSymbol = $af9cb013bbf461d9$var$isSymbol($af9cb013bbf461d9$var$inspectCustom) ? $af9cb013bbf461d9$var$inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($af9cb013bbf461d9$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($af9cb013bbf461d9$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $af9cb013bbf461d9$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($af9cb013bbf461d9$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($af9cb013bbf461d9$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $af9cb013bbf461d9$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $af9cb013bbf461d9$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $af9cb013bbf461d9$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $af9cb013bbf461d9$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $af9cb013bbf461d9$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($af9cb013bbf461d9$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $af9cb013bbf461d9$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($af9cb013bbf461d9$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$af9cb013bbf461d9$var$isRegExp(obj)) {
        var name = $af9cb013bbf461d9$var$nameOf(obj);
        var keys = $af9cb013bbf461d9$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $af9cb013bbf461d9$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($af9cb013bbf461d9$var$isSymbol(obj)) {
        var symString = $af9cb013bbf461d9$var$hasShammedSymbols ? $af9cb013bbf461d9$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $af9cb013bbf461d9$var$symToString.call(obj);
        return typeof obj === "object" && !$af9cb013bbf461d9$var$hasShammedSymbols ? $af9cb013bbf461d9$var$markBoxed(symString) : symString;
    }
    if ($af9cb013bbf461d9$var$isElement(obj)) {
        var s = "<" + $af9cb013bbf461d9$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $af9cb013bbf461d9$var$wrapQuotes($af9cb013bbf461d9$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $af9cb013bbf461d9$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($af9cb013bbf461d9$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $af9cb013bbf461d9$var$arrObjKeys(obj, inspect);
        if (indent && !$af9cb013bbf461d9$var$singleLineValues(xs)) return "[" + $af9cb013bbf461d9$var$indentedJoin(xs, indent) + "]";
        return "[ " + $af9cb013bbf461d9$var$$join.call(xs, ", ") + " ]";
    }
    if ($af9cb013bbf461d9$var$isError(obj)) {
        var parts = $af9cb013bbf461d9$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$af9cb013bbf461d9$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $af9cb013bbf461d9$var$$join.call($af9cb013bbf461d9$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $af9cb013bbf461d9$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($af9cb013bbf461d9$var$inspectSymbol && typeof obj[$af9cb013bbf461d9$var$inspectSymbol] === "function" && $iZpK3) return $iZpK3(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($af9cb013bbf461d9$var$isMap(obj)) {
        var mapParts = [];
        if ($af9cb013bbf461d9$var$mapForEach) $af9cb013bbf461d9$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $af9cb013bbf461d9$var$collectionOf("Map", $af9cb013bbf461d9$var$mapSize.call(obj), mapParts, indent);
    }
    if ($af9cb013bbf461d9$var$isSet(obj)) {
        var setParts = [];
        if ($af9cb013bbf461d9$var$setForEach) $af9cb013bbf461d9$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $af9cb013bbf461d9$var$collectionOf("Set", $af9cb013bbf461d9$var$setSize.call(obj), setParts, indent);
    }
    if ($af9cb013bbf461d9$var$isWeakMap(obj)) return $af9cb013bbf461d9$var$weakCollectionOf("WeakMap");
    if ($af9cb013bbf461d9$var$isWeakSet(obj)) return $af9cb013bbf461d9$var$weakCollectionOf("WeakSet");
    if ($af9cb013bbf461d9$var$isWeakRef(obj)) return $af9cb013bbf461d9$var$weakCollectionOf("WeakRef");
    if ($af9cb013bbf461d9$var$isNumber(obj)) return $af9cb013bbf461d9$var$markBoxed(inspect(Number(obj)));
    if ($af9cb013bbf461d9$var$isBigInt(obj)) return $af9cb013bbf461d9$var$markBoxed(inspect($af9cb013bbf461d9$var$bigIntValueOf.call(obj)));
    if ($af9cb013bbf461d9$var$isBoolean(obj)) return $af9cb013bbf461d9$var$markBoxed($af9cb013bbf461d9$var$booleanValueOf.call(obj));
    if ($af9cb013bbf461d9$var$isString(obj)) return $af9cb013bbf461d9$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (obj === $parcel$global) return "{ [object globalThis] }";
    if (!$af9cb013bbf461d9$var$isDate(obj) && !$af9cb013bbf461d9$var$isRegExp(obj)) {
        var ys = $af9cb013bbf461d9$var$arrObjKeys(obj, inspect);
        var isPlainObject = $af9cb013bbf461d9$var$gPO ? $af9cb013bbf461d9$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $af9cb013bbf461d9$var$toStringTag && Object(obj) === obj && $af9cb013bbf461d9$var$toStringTag in obj ? $af9cb013bbf461d9$var$$slice.call($af9cb013bbf461d9$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $af9cb013bbf461d9$var$$join.call($af9cb013bbf461d9$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $af9cb013bbf461d9$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $af9cb013bbf461d9$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $af9cb013bbf461d9$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $af9cb013bbf461d9$var$quote(s) {
    return $af9cb013bbf461d9$var$$replace.call(String(s), /"/g, "&quot;");
}
function $af9cb013bbf461d9$var$isArray(obj) {
    return $af9cb013bbf461d9$var$toStr(obj) === "[object Array]" && (!$af9cb013bbf461d9$var$toStringTag || !(typeof obj === "object" && $af9cb013bbf461d9$var$toStringTag in obj));
}
function $af9cb013bbf461d9$var$isDate(obj) {
    return $af9cb013bbf461d9$var$toStr(obj) === "[object Date]" && (!$af9cb013bbf461d9$var$toStringTag || !(typeof obj === "object" && $af9cb013bbf461d9$var$toStringTag in obj));
}
function $af9cb013bbf461d9$var$isRegExp(obj) {
    return $af9cb013bbf461d9$var$toStr(obj) === "[object RegExp]" && (!$af9cb013bbf461d9$var$toStringTag || !(typeof obj === "object" && $af9cb013bbf461d9$var$toStringTag in obj));
}
function $af9cb013bbf461d9$var$isError(obj) {
    return $af9cb013bbf461d9$var$toStr(obj) === "[object Error]" && (!$af9cb013bbf461d9$var$toStringTag || !(typeof obj === "object" && $af9cb013bbf461d9$var$toStringTag in obj));
}
function $af9cb013bbf461d9$var$isString(obj) {
    return $af9cb013bbf461d9$var$toStr(obj) === "[object String]" && (!$af9cb013bbf461d9$var$toStringTag || !(typeof obj === "object" && $af9cb013bbf461d9$var$toStringTag in obj));
}
function $af9cb013bbf461d9$var$isNumber(obj) {
    return $af9cb013bbf461d9$var$toStr(obj) === "[object Number]" && (!$af9cb013bbf461d9$var$toStringTag || !(typeof obj === "object" && $af9cb013bbf461d9$var$toStringTag in obj));
}
function $af9cb013bbf461d9$var$isBoolean(obj) {
    return $af9cb013bbf461d9$var$toStr(obj) === "[object Boolean]" && (!$af9cb013bbf461d9$var$toStringTag || !(typeof obj === "object" && $af9cb013bbf461d9$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $af9cb013bbf461d9$var$isSymbol(obj) {
    if ($af9cb013bbf461d9$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$af9cb013bbf461d9$var$symToString) return false;
    try {
        $af9cb013bbf461d9$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $af9cb013bbf461d9$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$af9cb013bbf461d9$var$bigIntValueOf) return false;
    try {
        $af9cb013bbf461d9$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $af9cb013bbf461d9$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $af9cb013bbf461d9$var$has(obj, key) {
    return $af9cb013bbf461d9$var$hasOwn.call(obj, key);
}
function $af9cb013bbf461d9$var$toStr(obj) {
    return $af9cb013bbf461d9$var$objectToString.call(obj);
}
function $af9cb013bbf461d9$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $af9cb013bbf461d9$var$$match.call($af9cb013bbf461d9$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $af9cb013bbf461d9$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $af9cb013bbf461d9$var$isMap(x) {
    if (!$af9cb013bbf461d9$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $af9cb013bbf461d9$var$mapSize.call(x);
        try {
            $af9cb013bbf461d9$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $af9cb013bbf461d9$var$isWeakMap(x) {
    if (!$af9cb013bbf461d9$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $af9cb013bbf461d9$var$weakMapHas.call(x, $af9cb013bbf461d9$var$weakMapHas);
        try {
            $af9cb013bbf461d9$var$weakSetHas.call(x, $af9cb013bbf461d9$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $af9cb013bbf461d9$var$isWeakRef(x) {
    if (!$af9cb013bbf461d9$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $af9cb013bbf461d9$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $af9cb013bbf461d9$var$isSet(x) {
    if (!$af9cb013bbf461d9$var$setSize || !x || typeof x !== "object") return false;
    try {
        $af9cb013bbf461d9$var$setSize.call(x);
        try {
            $af9cb013bbf461d9$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $af9cb013bbf461d9$var$isWeakSet(x) {
    if (!$af9cb013bbf461d9$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $af9cb013bbf461d9$var$weakSetHas.call(x, $af9cb013bbf461d9$var$weakSetHas);
        try {
            $af9cb013bbf461d9$var$weakMapHas.call(x, $af9cb013bbf461d9$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $af9cb013bbf461d9$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $af9cb013bbf461d9$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $af9cb013bbf461d9$var$inspectString($af9cb013bbf461d9$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $af9cb013bbf461d9$var$$replace.call($af9cb013bbf461d9$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $af9cb013bbf461d9$var$lowbyte);
    return $af9cb013bbf461d9$var$wrapQuotes(s, "single", opts);
}
function $af9cb013bbf461d9$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $af9cb013bbf461d9$var$$toUpperCase.call(n.toString(16));
}
function $af9cb013bbf461d9$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $af9cb013bbf461d9$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $af9cb013bbf461d9$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $af9cb013bbf461d9$var$indentedJoin(entries, indent) : $af9cb013bbf461d9$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $af9cb013bbf461d9$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($af9cb013bbf461d9$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $af9cb013bbf461d9$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $af9cb013bbf461d9$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $af9cb013bbf461d9$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $af9cb013bbf461d9$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $af9cb013bbf461d9$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $af9cb013bbf461d9$var$arrObjKeys(obj, inspect) {
    var isArr = $af9cb013bbf461d9$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $af9cb013bbf461d9$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $af9cb013bbf461d9$var$gOPS === "function" ? $af9cb013bbf461d9$var$gOPS(obj) : [];
    var symMap;
    if ($af9cb013bbf461d9$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$af9cb013bbf461d9$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($af9cb013bbf461d9$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($af9cb013bbf461d9$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $af9cb013bbf461d9$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($af9cb013bbf461d9$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});


parcelRegister("eJ7No", function(module, exports) {
"use strict";

var $8I1Cr = parcelRequire("8I1Cr");
var $ab8b50b216d065ce$var$has = Object.prototype.hasOwnProperty;
var $ab8b50b216d065ce$var$isArray = Array.isArray;
var $ab8b50b216d065ce$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $ab8b50b216d065ce$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($ab8b50b216d065ce$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $ab8b50b216d065ce$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $ab8b50b216d065ce$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($ab8b50b216d065ce$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$ab8b50b216d065ce$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($ab8b50b216d065ce$var$isArray(target) && !$ab8b50b216d065ce$var$isArray(source)) mergeTarget = $ab8b50b216d065ce$var$arrayToObject(target, options);
    if ($ab8b50b216d065ce$var$isArray(target) && $ab8b50b216d065ce$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($ab8b50b216d065ce$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($ab8b50b216d065ce$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $ab8b50b216d065ce$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $ab8b50b216d065ce$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $ab8b50b216d065ce$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === $8I1Cr.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $ab8b50b216d065ce$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($ab8b50b216d065ce$var$hexTable[0xC0 | c >> 6] + $ab8b50b216d065ce$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($ab8b50b216d065ce$var$hexTable[0xE0 | c >> 12] + $ab8b50b216d065ce$var$hexTable[0x80 | c >> 6 & 0x3F] + $ab8b50b216d065ce$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += $ab8b50b216d065ce$var$hexTable[0xF0 | c >> 18] + $ab8b50b216d065ce$var$hexTable[0x80 | c >> 12 & 0x3F] + $ab8b50b216d065ce$var$hexTable[0x80 | c >> 6 & 0x3F] + $ab8b50b216d065ce$var$hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var $ab8b50b216d065ce$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $ab8b50b216d065ce$var$compactQueue(queue);
    return value;
};
var $ab8b50b216d065ce$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $ab8b50b216d065ce$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $ab8b50b216d065ce$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $ab8b50b216d065ce$var$maybeMap = function maybeMap(val, fn) {
    if ($ab8b50b216d065ce$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $ab8b50b216d065ce$var$arrayToObject,
    assign: $ab8b50b216d065ce$var$assign,
    combine: $ab8b50b216d065ce$var$combine,
    compact: $ab8b50b216d065ce$var$compact,
    decode: $ab8b50b216d065ce$var$decode,
    encode: $ab8b50b216d065ce$var$encode,
    isBuffer: $ab8b50b216d065ce$var$isBuffer,
    isRegExp: $ab8b50b216d065ce$var$isRegExp,
    maybeMap: $ab8b50b216d065ce$var$maybeMap,
    merge: $ab8b50b216d065ce$var$merge
};

});
parcelRegister("8I1Cr", function(module, exports) {
"use strict";
var $6573b04e8c646334$var$replace = String.prototype.replace;
var $6573b04e8c646334$var$percentTwenties = /%20/g;
var $6573b04e8c646334$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": $6573b04e8c646334$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $6573b04e8c646334$var$replace.call(value, $6573b04e8c646334$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $6573b04e8c646334$var$Format.RFC1738,
    RFC3986: $6573b04e8c646334$var$Format.RFC3986
};

});



parcelRegister("aPPJV", function(module, exports) {
"use strict";

var $eJ7No = parcelRequire("eJ7No");
var $7e36cd38464e6343$var$has = Object.prototype.hasOwnProperty;
var $7e36cd38464e6343$var$isArray = Array.isArray;
var $7e36cd38464e6343$var$defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decoder: $eJ7No.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $7e36cd38464e6343$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $7e36cd38464e6343$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $7e36cd38464e6343$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $7e36cd38464e6343$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $7e36cd38464e6343$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $7e36cd38464e6343$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $7e36cd38464e6343$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $7e36cd38464e6343$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $7e36cd38464e6343$var$defaults.decoder, charset, "key");
            val = $eJ7No.maybeMap($7e36cd38464e6343$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $7e36cd38464e6343$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $7e36cd38464e6343$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $7e36cd38464e6343$var$isArray(val) ? [
            val
        ] : val;
        if ($7e36cd38464e6343$var$has.call(obj, key)) obj[key] = $eJ7No.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var $7e36cd38464e6343$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $7e36cd38464e6343$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== "__proto__") obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $7e36cd38464e6343$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $7e36cd38464e6343$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $7e36cd38464e6343$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $7e36cd38464e6343$var$parseObject(keys, val, options, valuesParsed);
};
var $7e36cd38464e6343$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $7e36cd38464e6343$var$defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $7e36cd38464e6343$var$defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === "undefined" ? $7e36cd38464e6343$var$defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $7e36cd38464e6343$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $7e36cd38464e6343$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $7e36cd38464e6343$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $7e36cd38464e6343$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $7e36cd38464e6343$var$defaults.comma,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $7e36cd38464e6343$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $eJ7No.isRegExp(opts.delimiter) ? opts.delimiter : $7e36cd38464e6343$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $7e36cd38464e6343$var$defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $7e36cd38464e6343$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $7e36cd38464e6343$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $7e36cd38464e6343$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $7e36cd38464e6343$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $7e36cd38464e6343$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $7e36cd38464e6343$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $7e36cd38464e6343$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $eJ7No.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $eJ7No.compact(obj);
};

});


parcelRegister("3THTN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d688f944270166f$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9q1kH = parcelRequire("9q1kH");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $8p2GL = parcelRequire("8p2GL");

var $5LVXk = parcelRequire("5LVXk");

var $bEPAN = parcelRequire("bEPAN");

var $arbqi = parcelRequire("arbqi");

var $34CoA = parcelRequire("34CoA");
var $2d688f944270166f$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $2d688f944270166f$var$isFirefox = typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
/**
 * __Button__
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $2d688f944270166f$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $8p2GL.default) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $8p2GL.default) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $2d688f944270166f$var$_excluded);
    var _useGlobalTheme = (0, $5LVXk.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var isOnlySingleIcon = (0, $34CoA.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $9nHZC.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    var onMouseDown = (0, $9nHZC.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($2d688f944270166f$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $9nHZC.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($2d688f944270166f$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $9nHZC.useMemo)(function() {
        return (0, $arbqi.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $bEPAN.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$2d688f944270166f$var$Button.displayName = "Button";
var $2d688f944270166f$export$2e2bcd8739ae039 = $2d688f944270166f$var$Button;

});
parcelRegister("bEPAN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87cb73561253fc3d$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $aU14p = parcelRequire("aU14p");

var $8p2GL = parcelRequire("8p2GL");

var $grYZC = parcelRequire("grYZC");

var $dxhCu = parcelRequire("dxhCu");

var $5fUc4 = parcelRequire("5fUc4");

var $dEQSq = parcelRequire("dEQSq");

var $jp7ng = parcelRequire("jp7ng");

var $kWaTP = parcelRequire("kWaTP");

var $arbqi = parcelRequire("arbqi");

var $fhBJB = parcelRequire("fhBJB");
var $87cb73561253fc3d$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $87cb73561253fc3d$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
var $87cb73561253fc3d$var$iconBeforeSpacingFixStyle = (0, $avKww.css)({
    marginLeft: "var(--ds-space-negative-025, -2px)"
});
var $87cb73561253fc3d$var$iconAfterSpacingFixStyle = (0, $avKww.css)({
    marginRight: "var(--ds-space-negative-025, -2px)"
});
var $87cb73561253fc3d$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!(0, $dEQSq.getBooleanFF)("platform.design-system-team.icon-button-spacing-fix_o1zc5") || !children || (0, $fhBJB.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $87cb73561253fc3d$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $fhBJB.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $avKww.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $87cb73561253fc3d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $8p2GL.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $8p2GL.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(props, $87cb73561253fc3d$var$_excluded);
    var ourRef = (0, $9nHZC.useRef)();
    var setRef = (0, $9nHZC.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $grYZC.default)(ourRef, autoFocus);
    var interactionContext = (0, $9nHZC.useContext)((0, $5fUc4.default));
    var handleClick = (0, $9nHZC.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $aU14p.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "16.18.1",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $9nHZC.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $9nHZC.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    var fadeStyles = (0, $avKww.css)((0, $arbqi.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === "warning") spinnerHackCss = {
        "[data-theme] & circle": {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $jp7ng.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $jp7ng.N500), ")"), " !important")
        }
    };
    return (0, $avKww.jsx)((0, $dxhCu.default), null, (0, $avKww.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $87cb73561253fc3d$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $kWaTP.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $avKww.jsx)("span", {
        css: [
            fadeStyles,
            (0, $arbqi.getIconStyle)({
                spacing: spacing
            }),
            $87cb73561253fc3d$var$getSpacingFix(children, $87cb73561253fc3d$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, !(0, $dEQSq.getBooleanFF)("platform.design-system-team.icon-button-spacing-fix_o1zc5") && children ? (0, $avKww.jsx)("span", {
        css: [
            fadeStyles,
            (0, $arbqi.getContentStyle)({
                spacing: spacing
            })
        ]
    }, children) : null, (0, $dEQSq.getBooleanFF)("platform.design-system-team.icon-button-spacing-fix_o1zc5") && $87cb73561253fc3d$var$getChildren(children, [
        fadeStyles,
        (0, $arbqi.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $avKww.jsx)("span", {
        css: [
            fadeStyles,
            (0, $arbqi.getIconStyle)({
                spacing: spacing
            }),
            $87cb73561253fc3d$var$getSpacingFix(children, $87cb73561253fc3d$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $avKww.jsx)("span", {
        css: [
            (0, $arbqi.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});

});
parcelRegister("aU14p", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $7efff6df9c15cd7c$export$a4687b0234b40e28; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $fl2Em = parcelRequire("fl2Em");

var $kHgap = parcelRequire("kHgap");
function $7efff6df9c15cd7c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7efff6df9c15cd7c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7efff6df9c15cd7c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7efff6df9c15cd7c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7efff6df9c15cd7c$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $fl2Em.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $kHgap.useTrackedRef)(analyticsData);
    var fnRef = (0, $kHgap.useTrackedRef)(fn);
    var handler = (0, $9nHZC.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $7efff6df9c15cd7c$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("fl2Em", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $b2aadf6eb2c2222e$export$5bf35293e545f20c; });

var $dNznA = parcelRequire("dNznA");

var $koTtn = parcelRequire("koTtn");

var $iQONF = parcelRequire("iQONF");
function $b2aadf6eb2c2222e$export$5bf35293e545f20c() {
    var analyticsContext = (0, $iQONF.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $koTtn.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("koTtn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eda1144aec006e12$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $74ZtV = parcelRequire("74ZtV");
function $eda1144aec006e12$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $eda1144aec006e12$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $eda1144aec006e12$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($eda1144aec006e12$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $eda1144aec006e12$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $eda1144aec006e12$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $eda1144aec006e12$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $eda1144aec006e12$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $74ZtV.default));

});
parcelRegister("74ZtV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5278991fdca6bb03$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
function $5278991fdca6bb03$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5278991fdca6bb03$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5278991fdca6bb03$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5278991fdca6bb03$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5278991fdca6bb03$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $5278991fdca6bb03$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $5278991fdca6bb03$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $5278991fdca6bb03$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(updater) === "object") this.payload = $5278991fdca6bb03$var$_objectSpread($5278991fdca6bb03$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("iQONF", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $db947d2f06133c4b$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $db947d2f06133c4b$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});


parcelRegister("kHgap", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $f1145d3b22f1e920$export$1d27a74659855e44; });

var $9nHZC = parcelRequire("9nHZC");
var $f1145d3b22f1e920$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("grYZC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf9e7adafbb18689$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");
function $bf9e7adafbb18689$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $9nHZC.useRef)(true);
    (0, $9nHZC.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("dxhCu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9dac065b7063e696$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");
var $9dac065b7063e696$var$BORDER_WIDTH = 2;
var $9dac065b7063e696$var$baseFocusOutsideStyles = (0, $avKww.css)({
    outline: "".concat($9dac065b7063e696$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $9dac065b7063e696$var$BORDER_WIDTH
});
var $9dac065b7063e696$var$baseInsetStyles = (0, $avKww.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$9dac065b7063e696$var$BORDER_WIDTH,
    outlineStyle: "solid",
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $9dac065b7063e696$var$focusRingStyles = (0, $avKww.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $9dac065b7063e696$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $9dac065b7063e696$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $9dac065b7063e696$var$insetFocusRingStyles = (0, $avKww.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $9dac065b7063e696$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $9dac065b7063e696$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: "-1px"
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $9dac065b7063e696$var$FocusRing = /*#__PURE__*/ (0, $9nHZC.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $9dac065b7063e696$var$baseInsetStyles : $9dac065b7063e696$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $9dac065b7063e696$var$insetFocusRingStyles : $9dac065b7063e696$var$focusRingStyles;
    var focusCls = typeof focus === "undefined" ? uncontrolledStyles : focus === "on" && controlledStyles;
    return (0, $avKww.jsx)((0, $avKww.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $9nHZC.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $9nHZC.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$9dac065b7063e696$var$FocusRing.displayName = "FocusRing";
var $9dac065b7063e696$export$2e2bcd8739ae039 = $9dac065b7063e696$var$FocusRing;

});

parcelRegister("kWaTP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3e1addb45c2b680$export$2e2bcd8739ae039; });
function $f3e1addb45c2b680$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $f3e1addb45c2b680$var$tabKeyCode = 9;
function $f3e1addb45c2b680$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $f3e1addb45c2b680$var$tabKeyCode) return;
    $f3e1addb45c2b680$var$abort(event);
}
var $f3e1addb45c2b680$var$block = {
    onMouseDownCapture: $f3e1addb45c2b680$var$abort,
    onMouseUpCapture: $f3e1addb45c2b680$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $f3e1addb45c2b680$var$onKey,
    onKeyUpCapture: $f3e1addb45c2b680$var$onKey,
    onTouchStartCapture: $f3e1addb45c2b680$var$abort,
    onTouchEndCapture: $f3e1addb45c2b680$var$abort,
    onPointerDownCapture: $f3e1addb45c2b680$var$abort,
    onPointerUpCapture: $f3e1addb45c2b680$var$abort,
    onClickCapture: $f3e1addb45c2b680$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $f3e1addb45c2b680$var$abort
};
var $f3e1addb45c2b680$var$doNotBlock = {};
function $f3e1addb45c2b680$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $f3e1addb45c2b680$var$doNotBlock : $f3e1addb45c2b680$var$block;
}

});

parcelRegister("arbqi", function(module, exports) {

$parcel$export(module.exports, "getCss", function () { return $7995496762f3e724$export$955358618f994a11; });
$parcel$export(module.exports, "getIconStyle", function () { return $7995496762f3e724$export$864eea3f4ec3368f; });
$parcel$export(module.exports, "getContentStyle", function () { return $7995496762f3e724$export$7ad0316cc0dd65a; });
$parcel$export(module.exports, "getFadingCss", function () { return $7995496762f3e724$export$1b5827d324e945b1; });
$parcel$export(module.exports, "overlayCss", function () { return $7995496762f3e724$export$1a9fe1b84c876bb5; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $aP6k3 = parcelRequire("aP6k3");

var $1CWe5 = parcelRequire("1CWe5");
function $7995496762f3e724$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7995496762f3e724$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7995496762f3e724$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7995496762f3e724$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7995496762f3e724$var$gridSize = (0, $aP6k3.gridSize)();
var $7995496762f3e724$var$fontSize = (0, $aP6k3.fontSize)();
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $7995496762f3e724$var$heights = {
    default: "".concat($7995496762f3e724$var$gridSize * 4 / $7995496762f3e724$var$fontSize, "em"),
    // 32px
    compact: "".concat($7995496762f3e724$var$gridSize * 3 / $7995496762f3e724$var$fontSize, "em"),
    none: "auto"
};
var $7995496762f3e724$var$lineHeights = {
    default: $7995496762f3e724$var$heights.default,
    compact: $7995496762f3e724$var$heights.compact,
    none: "inherit"
};
var $7995496762f3e724$var$padding = {
    // 10px gutter
    default: "0 ".concat($7995496762f3e724$var$gridSize + $7995496762f3e724$var$gridSize / 4, "px"),
    compact: "0 ".concat($7995496762f3e724$var$gridSize + $7995496762f3e724$var$gridSize / 4, "px"),
    none: "0"
};
var $7995496762f3e724$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($7995496762f3e724$var$gridSize / 4, "px"),
    default: "0 ".concat($7995496762f3e724$var$gridSize / 4, "px"),
    none: "0"
};
var $7995496762f3e724$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $7995496762f3e724$var$innerMargin = {
    content: "0 ".concat($7995496762f3e724$var$gridSize / 4, "px"),
    icon: "0 ".concat($7995496762f3e724$var$gridSize / 4, "px")
};
function $7995496762f3e724$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $7995496762f3e724$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $7995496762f3e724$var$getColor({
            group: (0, $1CWe5.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($7995496762f3e724$var$getColor({
            group: (0, $1CWe5.default).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $7995496762f3e724$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $7995496762f3e724$var$getColors({
        appearance: appearance,
        key: isSelected ? "selected" : "default",
        mode: mode
    });
    return $7995496762f3e724$var$_objectSpread($7995496762f3e724$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: 500,
        // margin for button has been applied to css reset
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap"
    }, baseColors), {}, {
        cursor: "pointer",
        height: $7995496762f3e724$var$heights[spacing],
        lineHeight: $7995496762f3e724$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $7995496762f3e724$var$singleIconPadding[spacing] : $7995496762f3e724$var$padding[spacing],
        verticalAlign: $7995496762f3e724$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center",
        // Note: we cannot disable pointer events when there is an overlay.
        // That would be easy for styling, but it would start letting events through on disabled buttons
        // Disabling visited styles (just using the base colors)
        "&:visited": $7995496762f3e724$var$_objectSpread({}, baseColors),
        "&:hover": $7995496762f3e724$var$_objectSpread($7995496762f3e724$var$_objectSpread({}, $7995496762f3e724$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "hover",
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "inherit",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        // giving active styles preference by listing them after focus
        "&:active": $7995496762f3e724$var$_objectSpread($7995496762f3e724$var$_objectSpread({}, $7995496762f3e724$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $7995496762f3e724$var$_objectSpread($7995496762f3e724$var$_objectSpread({}, $7995496762f3e724$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        "&[disabled]": $7995496762f3e724$var$_objectSpread($7995496762f3e724$var$_objectSpread({}, $7995496762f3e724$var$getColors({
            appearance: appearance,
            key: "disabled",
            mode: mode
        })), {}, {
            cursor: "not-allowed",
            textDecoration: "none"
        }),
        '&[data-has-overlay="true"]': {
            cursor: "default",
            textDecoration: "none"
        },
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $7995496762f3e724$var$_objectSpread({}, $7995496762f3e724$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "default",
            mode: mode
        })),
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $7995496762f3e724$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $avKww.css)({
        display: "flex",
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        margin: spacing === "none" ? 0 : $7995496762f3e724$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: "center",
        fontSize: 0,
        lineHeight: 0,
        userSelect: "none"
    });
}
function $7995496762f3e724$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $avKww.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        margin: spacing === "none" ? 0 : $7995496762f3e724$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    });
}
function $7995496762f3e724$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $avKww.css)({
        opacity: hasOverlay ? 0 : 1,
        transition: "opacity 0.3s"
    });
}
var $7995496762f3e724$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

});
parcelRegister("1CWe5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12f6819102860441$export$2e2bcd8739ae039; });

var $jp7ng = parcelRequire("jp7ng");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $12f6819102860441$var$fadedB75 = "rgba(179, 212, 255, 0.6)";
var $12f6819102860441$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($jp7ng.N20A, ")"),
                dark: "var(--ds-background-neutral, ".concat($jp7ng.DN70, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($jp7ng.N30A, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($jp7ng.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($12f6819102860441$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($jp7ng.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($jp7ng.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($jp7ng.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.DN0, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($jp7ng.B400, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($jp7ng.B100, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($jp7ng.B300, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($jp7ng.B75, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($jp7ng.B500, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($jp7ng.B200, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($jp7ng.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($jp7ng.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.DN0, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($jp7ng.Y300, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($jp7ng.Y300, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($jp7ng.Y200, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($jp7ng.Y200, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($jp7ng.Y400, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($jp7ng.Y400, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($jp7ng.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($jp7ng.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.Y400, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.Y400, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($jp7ng.R400, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($jp7ng.R400, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($jp7ng.R300, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($jp7ng.R300, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($jp7ng.R500, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($jp7ng.R500, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($jp7ng.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($jp7ng.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.R500, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.R500, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.N20, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($jp7ng.N30A, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($jp7ng.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($12f6819102860441$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($jp7ng.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.DN0, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.N20, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($jp7ng.N500, ")"),
                dark: "var(--ds-text, ".concat($jp7ng.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($jp7ng.B400, ")"),
                dark: "var(--ds-text, ".concat($jp7ng.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jp7ng.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jp7ng.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.DN400, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($jp7ng.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($jp7ng.DN30, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jp7ng.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jp7ng.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.DN400, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($jp7ng.N800, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($jp7ng.N800, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jp7ng.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jp7ng.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.N800, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.N800, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($jp7ng.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($jp7ng.N0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jp7ng.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jp7ng.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.N0, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.N0, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($jp7ng.B400, ")"),
                dark: "var(--ds-link, ".concat($jp7ng.B100, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($jp7ng.B300, ")"),
                dark: "var(--ds-link, ".concat($jp7ng.B75, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($jp7ng.B500, ")"),
                dark: "var(--ds-link-pressed, ".concat($jp7ng.B200, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jp7ng.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jp7ng.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.N700, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.N700, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($jp7ng.N500, ")"),
                dark: "var(--ds-text, ".concat($jp7ng.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($jp7ng.B400, ")"),
                dark: "var(--ds-text, ".concat($jp7ng.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jp7ng.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jp7ng.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.DN400, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-text-subtle, ".concat($jp7ng.N200, ")"),
                dark: "var(--ds-text-subtle, ".concat($jp7ng.DN400, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($jp7ng.N90, ")"),
                dark: "var(--ds-text-subtle, ".concat($jp7ng.B50, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($jp7ng.N400, ")"),
                dark: "var(--ds-text, ".concat($jp7ng.DN300, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jp7ng.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jp7ng.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.DN400, ")")
            }
        }
    }
};
var $12f6819102860441$export$2e2bcd8739ae039 = $12f6819102860441$var$values;

});


parcelRegister("fhBJB", function(module, exports) {

$parcel$export(module.exports, "getIfVisuallyHiddenChildren", function () { return $b205b6d67327f438$export$20bbd2efb0d734c4; });

var $9nHZC = parcelRequire("9nHZC");

var $7S7GL = parcelRequire("7S7GL");
var $b205b6d67327f438$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $9nHZC.isValidElement)(children) && children.type === (0, $7S7GL.default);
};

});
parcelRegister("7S7GL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bb38a5993a30f37$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $avKww = parcelRequire("avKww");
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
var $5bb38a5993a30f37$var$visuallyHiddenStyles = (0, $avKww.css)({
    width: "1px",
    height: "1px",
    padding: "0",
    position: "absolute",
    border: "0",
    clip: "rect(1px, 1px, 1px, 1px)",
    overflow: "hidden",
    whiteSpace: "nowrap"
});
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $5bb38a5993a30f37$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return (0, $avKww.jsx)("span", {
        id: id,
        "data-testid": testId,
        css: $5bb38a5993a30f37$var$visuallyHiddenStyles,
        role: role
    }, children);
};
var $5bb38a5993a30f37$export$2e2bcd8739ae039 = $5bb38a5993a30f37$var$VisuallyHidden;

});



parcelRegister("34CoA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23cf87636c23eb9e$export$2e2bcd8739ae039; });

var $dEQSq = parcelRequire("dEQSq");

var $fhBJB = parcelRequire("fhBJB");
function $23cf87636c23eb9e$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $dEQSq.getBooleanFF)("platform.design-system-team.icon-button-spacing-fix_o1zc5") && (0, $fhBJB.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});



parcelRegister("iiGhh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6985d9b0f0d5381$export$2e2bcd8739ae039; });

var $9gkf9 = parcelRequire("9gkf9");
var $a6985d9b0f0d5381$export$2e2bcd8739ae039;
$a6985d9b0f0d5381$export$2e2bcd8739ae039 = class ConnectIframeProvider {
    constructor(props = {}){
        this.timeoutHandlers = void 0;
        this.props = void 0;
        this.timeoutHandlers = [];
        this.props = {
            loadingTimeout: 5000,
            ...props
        };
    }
    registerTimeout(timeoutHandler) {
        if (!this.timeoutHandlers.find((h)=>h === timeoutHandler)) this.timeoutHandlers.push(timeoutHandler);
    }
    unregister(timeoutHandler) {
        this.timeoutHandlers = this.timeoutHandlers.filter((h)=>h !== timeoutHandler);
    }
    // Not implimented
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onStoreNestedIframeJSON(_) {}
    onHideInlineDialog() {
        if ((0, $9gkf9.isFunction)(this.props.handleHideInlineDialog)) this.props.handleHideInlineDialog();
    }
    getLoadingTimeoutMilliseconds() {
        // In the ACJS we use an aggressive timeout value so we can test more quickly.
        return this.props.loadingTimeout || 0;
    }
    handleIframeLoadingStarted(appKey) {
        if ((0, $9gkf9.isFunction)(this.props.handleIframeLoadingStarted)) this.props.handleIframeLoadingStarted(appKey);
    }
    handleIframeLoadingComplete(appKey) {
        if ((0, $9gkf9.isFunction)(this.props.handleIframeLoadingComplete)) this.props.handleIframeLoadingComplete(appKey);
    }
    handleIframeUnload(appKey) {
        if ((0, $9gkf9.isFunction)(this.props.handleIframeLoadingComplete)) this.props.handleIframeLoadingComplete(appKey);
    }
    handleIframeLoadTimeout(appKey, cancelLoadingCallback) {
        this.timeoutHandlers.forEach((h)=>h(appKey, cancelLoadingCallback));
    }
    // eslint-disable-next-line consistent-return
    buildIframeStyles(activeLoadingState, loadingStates) {
        if ((0, $9gkf9.isFunction)(this.props.buildIframeStyles)) return this.props.buildIframeStyles(activeLoadingState, loadingStates);
        switch(activeLoadingState){
            case loadingStates.LOADED:
                return this.props.defaultStyles;
            case loadingStates.LOADING:
            case loadingStates.TIMEOUT:
                return {
                    ...this.props.defaultStyles,
                    opacity: 0,
                    display: "none",
                    visibility: "hidden"
                };
        }
    }
};

});






parcelRegister("1K4vf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dae35725d1cfb595$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");
var $dae35725d1cfb595$export$2e2bcd8739ae039 = ({ component: component, module: mod })=>{
    if (!mod) return false;
    const { source: { url: url }, descriptor: { name: { value: name = "" } = {}, target: { options: options = {} } = {} } } = mod;
    const externalTargetUrl = url;
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(component, {
        module: mod,
        externalTargetUrl: externalTargetUrl,
        // eslint-disable-next-line no-return-assign
        onClick: ()=>externalTargetUrl && (window.location.href = externalTargetUrl)
    }, name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("a", {
        href: externalTargetUrl,
        title: options.tooltip
    }, name);
};

});




parcelRegister("8yYpP", function(module, exports) {

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $6D09s = parcelRequire("6D09s");

var $eIoiN = parcelRequire("eIoiN");
var $44ef7b81933830e6$export$2e2bcd8739ae039 = (0, $eIoiN.default)(({ children: children, width: width = "100%", height: height, options: options = {}, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6D09s.ConnectIframes), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        moduleType: "webPanels"
    }), (iframes)=>{
        const iframeChildren = iframes.map(({ Component: Iframe, module: m })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Iframe, {
                width: width,
                height: height,
                options: options,
                key: m.id
            }));
        return typeof children === "function" ? children(iframeChildren) : iframeChildren;
    }));

});
parcelRegister("6D09s", function(module, exports) {

$parcel$export(module.exports, "ConnectIframes", function () { return $ad37bf7e73eb1e73$export$47fb06522cb2276e; });
$parcel$export(module.exports, "default", function () { return $ad37bf7e73eb1e73$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $eIoiN = parcelRequire("eIoiN");

var $4yK0k = parcelRequire("4yK0k");

var $qh48v = parcelRequire("qh48v");

var $MTGTE = parcelRequire("MTGTE");

var $c2oAU = parcelRequire("c2oAU");

var $giWPX = parcelRequire("giWPX");
class $ad37bf7e73eb1e73$export$47fb06522cb2276e extends (0, $9nHZC.PureComponent) {
    // @ts-ignore TODO: fix noImplicitAny error here
    render() {
        const { children: children, containerComponent: Container = $ad37bf7e73eb1e73$export$47fb06522cb2276e.defaultContainer, loadingComponent: Loading = (0, $c2oAU.default), loadingFailedComponent: LoadingFailed = (0, $MTGTE.default), loadingTimeoutComponent: LoadingTimeout = (0, $giWPX.default), ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $4yK0k.ConnectModules), props, ({ modules: modules, loading: loading, error: error })=>{
            if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(LoadingFailed, props));
            if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Loading, props));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Container, null, children && children(modules.map((mod)=>({
                    module: mod,
                    Component: (p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $qh48v.ConnectModuleIframe), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
                            loadingComponent: Loading,
                            loadingFailedComponent: LoadingFailed,
                            loadingTimeoutComponent: LoadingTimeout
                        }, p, {
                            module: mod,
                            key: mod.id
                        }))
                }))));
        });
    }
}
$ad37bf7e73eb1e73$export$47fb06522cb2276e.defaultContainer = ({ children: children })=>children;
var $ad37bf7e73eb1e73$export$2e2bcd8739ae039 = (0, $eIoiN.default)($ad37bf7e73eb1e73$export$47fb06522cb2276e);

});


parcelRegister("stBBD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d87bd56888c2ba1$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $6D09s = parcelRequire("6D09s");

var $eIoiN = parcelRequire("eIoiN");

var $6LMnI = parcelRequire("6LMnI");
class $7d87bd56888c2ba1$export$ecf89d93887df393 extends (0, $9nHZC.PureComponent) {
    render() {
        const { children: children, width: width, height: height, defaultComponent: DefaultComponent = ()=>null, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6D09s.ConnectIframes), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
            moduleType: "fileEditors"
        }), (iframes)=>{
            const p = iframes[0];
            if (p) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6LMnI.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, p, {
                width: width,
                height: height,
                key: p.module.id
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(DefaultComponent, null);
        });
    }
}
$7d87bd56888c2ba1$export$ecf89d93887df393.defaultProps = {
    width: "100%"
};
var $7d87bd56888c2ba1$export$2e2bcd8739ae039 = (0, $eIoiN.default)($7d87bd56888c2ba1$export$ecf89d93887df393);

});
parcelRegister("6LMnI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $027d29a19223304e$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("g2goG");
var $QQQjQ = parcelRequire("QQQjQ");
const $027d29a19223304e$var$getCredentials = ({ id: moduleId, app_key: appKey, module_type: moduleType, targetHref: targetHref, descriptor: { key: moduleKey, location: location } })=>({
        moduleId: moduleId,
        moduleKey: moduleKey,
        moduleType: moduleType,
        appKey: appKey,
        location: location,
        targetHref: targetHref
    });
class $027d29a19223304e$export$5fb0b1e8c2a6acaa extends (0, $9nHZC.Component) {
    constructor(...args){
        super(...args);
        this.openEditor = (props)=>{
            const { module: mod, source: source, onChange: onChange, onReset: onReset } = props;
            const credentials = $027d29a19223304e$var$getCredentials(mod);
            (0, $QQQjQ.default).editor.editorSetSource(credentials, source);
            if (typeof onChange === "function") {
                (0, $QQQjQ.default).editor.editorSetSource(credentials, source);
                (0, $QQQjQ.default).editor.editorAddListener(credentials, "change", onChange);
            }
            if (typeof onReset === "function") (0, $QQQjQ.default).editor.editorAddListener(credentials, "reset", onReset);
        };
        this.closeEditor = (props)=>{
            const { module: m } = props;
            const credentials = $027d29a19223304e$var$getCredentials(m);
            (0, $QQQjQ.default).editor.editorRemoveSource(credentials);
            (0, $QQQjQ.default).editor.editorRemoveListener(credentials, "change");
            (0, $QQQjQ.default).editor.editorRemoveListener(credentials, "reset");
        };
    }
    componentDidMount() {
        this.openEditor(this.props);
    }
    /* eslint react/no-unsafe: "warn" */ UNSAFE_componentWillReceiveProps(nextProps) {
        this.closeEditor(this.props);
        this.openEditor(nextProps);
    }
    shouldComponentUpdate(props) {
        const { module: mod, onChange: onChange, onReset: onReset, width: width, height: height } = this.props;
        return mod.id !== props.module.id || onChange !== props.onChange || onReset !== props.onReset || width !== props.width || height !== props.height;
    }
    componentWillUnmount() {
        this.closeEditor(this.props);
    }
    render() {
        const { Component: Iframe, width: width, height: height } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Iframe, {
            width: width,
            height: height
        });
    }
}
var $027d29a19223304e$export$2e2bcd8739ae039 = $027d29a19223304e$export$5fb0b1e8c2a6acaa;

});
parcelRegister("g2goG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("kNA8C")).default; });
$parcel$export(module.exports, "ConnectHost", function () { return (parcelRequire("kNA8C")).default; });
$parcel$export(module.exports, "AddonManager", function () { return (parcelRequire("QQQjQ")).default; });
$parcel$export(module.exports, "registerAnalyticsListener", function () { return (parcelRequire("5kmFR")).registerAnalyticsListener; });
$parcel$export(module.exports, "sendAnalyticsEvent", function () { return (parcelRequire("c5dog")).sendEvent; });
$parcel$export(module.exports, "replaceContentHandler", function () { return (parcelRequire("5s0M7")).replaceContentHandler; });
parcelRequire("fbSRq");

var $kNA8C = parcelRequire("kNA8C");
parcelRequire("dwTXO");
var $QQQjQ = parcelRequire("QQQjQ");

var $5kmFR = parcelRequire("5kmFR");

var $c5dog = parcelRequire("c5dog");

var $5s0M7 = parcelRequire("5s0M7");

var $3spbF = parcelRequire("3spbF");

});
parcelRegister("fbSRq", function(module, exports) {

});

parcelRegister("kNA8C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edfc41006b360d72$export$2e2bcd8739ae039; });
// @ts-ignore TODO: fix noImplicitAny error here

var $kHkiQ = parcelRequire("kHkiQ");

var $jhBUl = parcelRequire("jhBUl");

var $ffISn = parcelRequire("ffISn");

var $8TjKB = parcelRequire("8TjKB");
parcelRequire("dwTXO");
var $QQQjQ = parcelRequire("QQQjQ");

var $c5dog = parcelRequire("c5dog");

var $aLiYq = parcelRequire("aLiYq");

var $7E3lN = parcelRequire("7E3lN");

var $eeWzj = parcelRequire("eeWzj");

var $2HBs8 = parcelRequire("2HBs8");
let $edfc41006b360d72$var$isACJSNextEnabled = false;
try {
    const acjsNextFeature = !!(0, $8TjKB.getInitialOrBucketState)().global.features["acjs-next"];
    if (acjsNextFeature) $edfc41006b360d72$var$isACJSNextEnabled = true;
} catch (_error) {
// TODO: BBCEEP-3380 Implement error monitoring
}
let $edfc41006b360d72$var$ConnectHost;
if ($edfc41006b360d72$var$isACJSNextEnabled) $edfc41006b360d72$var$ConnectHost = (0, (/*@__PURE__*/$parcel$interopDefault($ffISn)));
else $edfc41006b360d72$var$ConnectHost = (0, (/*@__PURE__*/$parcel$interopDefault($kHkiQ)));
// set env from ConnectAPI
$aLiYq.getHostEnv((err, env)=>!err && (0, $QQQjQ.default).setEnv(env));
// set current user and isAuthenticated FLAG
$aLiYq.getCurrentUser((err, user)=>!err && (0, $QQQjQ.default).setCurrentUser(user));
// add ConnectAPI module to ConnectHost
$edfc41006b360d72$var$ConnectHost.defineModule("bitbucket", {
    ...$aLiYq,
    ...$eeWzj,
    ...$7E3lN // This API is for Atlassian only (site-addons)
});
// add LinkersAPI module to ConnectHost
$edfc41006b360d72$var$ConnectHost.defineModule("links", $2HBs8);
// add analytics API to connect
$edfc41006b360d72$var$ConnectHost.defineModule("analytics", $c5dog);
// add history API to connect
$edfc41006b360d72$var$ConnectHost.defineModule("history", (0, (/*@__PURE__*/$parcel$interopDefault($jhBUl))));
// register content resolver
// required, but not currently used by bitbucket-connect-js
// is used to do async data fetching before rendering an iframe
$edfc41006b360d72$var$ConnectHost.registerContentResolver.resolveByExtension(()=>{
    return {
        fail: ()=>{},
        done: ()=>{}
    };
});
// required by history API
const $edfc41006b360d72$var$globalWindow = window;
$edfc41006b360d72$var$globalWindow.connectHost = $edfc41006b360d72$var$ConnectHost;
var $edfc41006b360d72$export$2e2bcd8739ae039 = $edfc41006b360d72$var$ConnectHost;

});
parcelRegister("kHkiQ", function(module, exports) {
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        subClass.__proto__ = superClass;
    }
    var inheritsLoose = _inheritsLoose;
    var domain; // This constructor is used to store event handlers. Instantiating this is
    // faster than explicitly calling `Object.create(null)` to get a "clean" empty
    // object (tested with v8 v4.9).
    function EventHandlers() {}
    EventHandlers.prototype = Object.create(null);
    function EventEmitter() {
        EventEmitter.init.call(this);
    }
    // require('events') === require('events').EventEmitter
    EventEmitter.EventEmitter = EventEmitter;
    EventEmitter.usingDomains = false;
    EventEmitter.prototype.domain = undefined;
    EventEmitter.prototype._events = undefined;
    EventEmitter.prototype._maxListeners = undefined; // By default EventEmitters will print a warning if more than 10 listeners are
    // added to it. This is a useful default which helps finding memory leaks.
    EventEmitter.defaultMaxListeners = 10;
    EventEmitter.init = function() {
        this.domain = null;
        if (EventEmitter.usingDomains) // if there is an active domain, then attach to it.
        domain.active && domain.Domain;
        if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
            this._events = new EventHandlers();
            this._eventsCount = 0;
        }
        this._maxListeners = this._maxListeners || undefined;
    }; // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
        if (typeof n !== "number" || n < 0 || isNaN(n)) throw new TypeError('"n" argument must be a positive number');
        this._maxListeners = n;
        return this;
    };
    function $getMaxListeners(that) {
        if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
        return that._maxListeners;
    }
    EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
        return $getMaxListeners(this);
    }; // These standalone emit* functions are used to optimize calling of event
    // handlers for fast cases because emit() itself often has a variable number of
    // arguments and can be deoptimized because of that. These functions always have
    // the same number of arguments and thus do not get deoptimized, so the code
    // inside them can execute faster.
    function emitNone(handler, isFn, self) {
        if (isFn) handler.call(self);
        else {
            var len = handler.length;
            var listeners = arrayClone(handler, len);
            for(var i = 0; i < len; ++i)listeners[i].call(self);
        }
    }
    function emitOne(handler, isFn, self, arg1) {
        if (isFn) handler.call(self, arg1);
        else {
            var len = handler.length;
            var listeners = arrayClone(handler, len);
            for(var i = 0; i < len; ++i)listeners[i].call(self, arg1);
        }
    }
    function emitTwo(handler, isFn, self, arg1, arg2) {
        if (isFn) handler.call(self, arg1, arg2);
        else {
            var len = handler.length;
            var listeners = arrayClone(handler, len);
            for(var i = 0; i < len; ++i)listeners[i].call(self, arg1, arg2);
        }
    }
    function emitThree(handler, isFn, self, arg1, arg2, arg3) {
        if (isFn) handler.call(self, arg1, arg2, arg3);
        else {
            var len = handler.length;
            var listeners = arrayClone(handler, len);
            for(var i = 0; i < len; ++i)listeners[i].call(self, arg1, arg2, arg3);
        }
    }
    function emitMany(handler, isFn, self, args) {
        if (isFn) handler.apply(self, args);
        else {
            var len = handler.length;
            var listeners = arrayClone(handler, len);
            for(var i = 0; i < len; ++i)listeners[i].apply(self, args);
        }
    }
    EventEmitter.prototype.emit = function emit(type) {
        var er, handler, len, args, i, events, domain;
        var doError = type === "error";
        events = this._events;
        if (events) doError = doError && events.error == null;
        else if (!doError) return false;
        domain = this.domain; // If there is no 'error' event listener then throw.
        if (doError) {
            er = arguments[1];
            if (domain) {
                if (!er) er = new Error('Uncaught, unspecified "error" event');
                er.domainEmitter = this;
                er.domain = domain;
                er.domainThrown = false;
                domain.emit("error", er);
            } else if (er instanceof Error) throw er; // Unhandled 'error' event
            else {
                // At least give some kind of context to the user
                var err = new Error('Uncaught, unspecified "error" event. (' + er + ")");
                err.context = er;
                throw err;
            }
            return false;
        }
        handler = events[type];
        if (!handler) return false;
        var isFn = typeof handler === "function";
        len = arguments.length;
        switch(len){
            // fast cases
            case 1:
                emitNone(handler, isFn, this);
                break;
            case 2:
                emitOne(handler, isFn, this, arguments[1]);
                break;
            case 3:
                emitTwo(handler, isFn, this, arguments[1], arguments[2]);
                break;
            case 4:
                emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
                break;
            // slower
            default:
                args = new Array(len - 1);
                for(i = 1; i < len; i++)args[i - 1] = arguments[i];
                emitMany(handler, isFn, this, args);
        }
        return true;
    };
    function _addListener(target, type, listener, prepend) {
        var m;
        var events;
        var existing;
        if (typeof listener !== "function") throw new TypeError('"listener" argument must be a function');
        events = target._events;
        if (!events) {
            events = target._events = new EventHandlers();
            target._eventsCount = 0;
        } else {
            // To avoid recursion in the case that type === "newListener"! Before
            // adding it to the listeners, first emit "newListener".
            if (events.newListener) {
                target.emit("newListener", type, listener.listener ? listener.listener : listener); // Re-assign `events` because a newListener handler could have caused the
                // this._events to be assigned to a new object
                events = target._events;
            }
            existing = events[type];
        }
        if (!existing) {
            // Optimize the case of one listener. Don't need the extra array object.
            existing = events[type] = listener;
            ++target._eventsCount;
        } else {
            if (typeof existing === "function") // Adding the second element, need to change to array.
            existing = events[type] = prepend ? [
                listener,
                existing
            ] : [
                existing,
                listener
            ];
            else // If we've already got an array, just append.
            if (prepend) existing.unshift(listener);
            else existing.push(listener);
             // Check for listener leak
            if (!existing.warned) {
                m = $getMaxListeners(target);
                if (m && m > 0 && existing.length > m) {
                    existing.warned = true;
                    var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + type + " listeners added. " + "Use emitter.setMaxListeners() to increase limit");
                    w.name = "MaxListenersExceededWarning";
                    w.emitter = target;
                    w.type = type;
                    w.count = existing.length;
                    emitWarning(w);
                }
            }
        }
        return target;
    }
    function emitWarning(e) {
        typeof console.warn === "function" ? console.warn(e) : console.log(e);
    }
    EventEmitter.prototype.addListener = function addListener(type, listener) {
        return _addListener(this, type, listener, false);
    };
    EventEmitter.prototype.on = EventEmitter.prototype.addListener;
    EventEmitter.prototype.prependListener = function prependListener(type, listener) {
        return _addListener(this, type, listener, true);
    };
    function _onceWrap(target, type, listener) {
        var fired = false;
        function g() {
            target.removeListener(type, g);
            if (!fired) {
                fired = true;
                listener.apply(target, arguments);
            }
        }
        g.listener = listener;
        return g;
    }
    EventEmitter.prototype.once = function once(type, listener) {
        if (typeof listener !== "function") throw new TypeError('"listener" argument must be a function');
        this.on(type, _onceWrap(this, type, listener));
        return this;
    };
    EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
        if (typeof listener !== "function") throw new TypeError('"listener" argument must be a function');
        this.prependListener(type, _onceWrap(this, type, listener));
        return this;
    }; // emits a 'removeListener' event iff the listener was removed
    EventEmitter.prototype.removeListener = function removeListener(type, listener) {
        var list, events, position, i, originalListener;
        if (typeof listener !== "function") throw new TypeError('"listener" argument must be a function');
        events = this._events;
        if (!events) return this;
        list = events[type];
        if (!list) return this;
        if (list === listener || list.listener && list.listener === listener) {
            if (--this._eventsCount === 0) this._events = new EventHandlers();
            else {
                delete events[type];
                if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
            }
        } else if (typeof list !== "function") {
            position = -1;
            for(i = list.length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
                originalListener = list[i].listener;
                position = i;
                break;
            }
            if (position < 0) return this;
            if (list.length === 1) {
                list[0] = undefined;
                if (--this._eventsCount === 0) {
                    this._events = new EventHandlers();
                    return this;
                } else delete events[type];
            } else spliceOne(list, position);
            if (events.removeListener) this.emit("removeListener", type, originalListener || listener);
        }
        return this;
    };
    EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
        var listeners, events;
        events = this._events;
        if (!events) return this; // not listening for removeListener, no need to emit
        if (!events.removeListener) {
            if (arguments.length === 0) {
                this._events = new EventHandlers();
                this._eventsCount = 0;
            } else if (events[type]) {
                if (--this._eventsCount === 0) this._events = new EventHandlers();
                else delete events[type];
            }
            return this;
        } // emit removeListener for all listeners on all events
        if (arguments.length === 0) {
            var keys = Object.keys(events);
            for(var i = 0, key; i < keys.length; ++i){
                key = keys[i];
                if (key === "removeListener") continue;
                this.removeAllListeners(key);
            }
            this.removeAllListeners("removeListener");
            this._events = new EventHandlers();
            this._eventsCount = 0;
            return this;
        }
        listeners = events[type];
        if (typeof listeners === "function") this.removeListener(type, listeners);
        else if (listeners) // LIFO order
        do this.removeListener(type, listeners[listeners.length - 1]);
        while (listeners[0]);
        return this;
    };
    EventEmitter.prototype.listeners = function listeners(type) {
        var evlistener;
        var ret;
        var events = this._events;
        if (!events) ret = [];
        else {
            evlistener = events[type];
            if (!evlistener) ret = [];
            else if (typeof evlistener === "function") ret = [
                evlistener.listener || evlistener
            ];
            else ret = unwrapListeners(evlistener);
        }
        return ret;
    };
    EventEmitter.listenerCount = function(emitter, type) {
        if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
        else return listenerCount.call(emitter, type);
    };
    EventEmitter.prototype.listenerCount = listenerCount;
    function listenerCount(type) {
        var events = this._events;
        if (events) {
            var evlistener = events[type];
            if (typeof evlistener === "function") return 1;
            else if (evlistener) return evlistener.length;
        }
        return 0;
    }
    EventEmitter.prototype.eventNames = function eventNames() {
        return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
    }; // About 1.5x faster than the two-arg version of Array#splice().
    function spliceOne(list, index) {
        for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
        list.pop();
    }
    function arrayClone(arr, i) {
        var copy = new Array(i);
        while(i--)copy[i] = arr[i];
        return copy;
    }
    function unwrapListeners(arr) {
        var ret = new Array(arr.length);
        for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
        return ret;
    }
    var EventDispatcher = /*#__PURE__*/ function(_EventEmitter) {
        inheritsLoose(EventDispatcher, _EventEmitter);
        function EventDispatcher() {
            var _this;
            _this = _EventEmitter.call(this) || this;
            _this.setMaxListeners(20);
            return _this;
        }
        var _proto = EventDispatcher.prototype;
        _proto.dispatch = function dispatch(action) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            this.emit.apply(this, [
                "before:" + action
            ].concat(args));
            this.emit.apply(this, arguments);
            this.emit.apply(this, [
                "after:" + action
            ].concat(args));
        };
        _proto.registerOnce = function registerOnce(action, callback) {
            if (typeof action === "string") this.once(action, callback);
            else throw "ACJS: event name must be string";
        };
        _proto.register = function register(action, callback) {
            if (typeof action === "string") this.on(action, callback);
            else throw "ACJS: event name must be string";
        };
        _proto.unregister = function unregister(action, callback) {
            if (typeof action === "string") this.removeListener(action, callback);
            else throw "ACJS: event name must be string";
        };
        return EventDispatcher;
    }(EventEmitter);
    var EventDispatcher$1 = new EventDispatcher();
    /**
   * The iframe-side code exposes a jquery-like implementation via _dollar.
   * This runs on the product side to provide AJS.$ under a _dollar module to provide a consistent interface
   * to code that runs on host and iframe.
   */ var $ = window.AJS && window.AJS.$ || function() {};
    var LOG_PREFIX = "[Simple-XDM] ";
    var nativeBind = Function.prototype.bind;
    var util = {
        locationOrigin: function locationOrigin() {
            if (!window.location.origin) return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "");
            else return window.location.origin;
        },
        randomString: function randomString() {
            return Math.floor(Math.random() * 1000000000).toString(16);
        },
        isString: function isString(str) {
            return typeof str === "string" || str instanceof String;
        },
        argumentsToArray: function argumentsToArray(arrayLike) {
            return Array.prototype.slice.call(arrayLike);
        },
        argumentNames: function argumentNames(fn) {
            return fn.toString().replace(/((\/\/.*$)|(\/\*[^]*?\*\/))/mg, "") // strip comments
            .replace(/[^(]+\(([^)]*)[^]+/, "$1") // get signature
            .match(/([^\s,]+)/g) || [];
        },
        hasCallback: function hasCallback(args) {
            var length = args.length;
            return length > 0 && typeof args[length - 1] === "function";
        },
        error: function error(msg) {
            if (window.console && window.console.error) {
                var outputError = [];
                if (typeof msg === "string") {
                    outputError.push(LOG_PREFIX + msg);
                    outputError = outputError.concat(Array.prototype.slice.call(arguments, 1));
                } else {
                    outputError.push(LOG_PREFIX);
                    outputError = outputError.concat(Array.prototype.slice.call(arguments));
                }
                window.console.error.apply(null, outputError);
            }
        },
        warn: function warn(msg) {
            if (window.console) console.warn(LOG_PREFIX + msg);
        },
        log: function log(msg) {
            if (window.console) window.console.log(LOG_PREFIX + msg);
        },
        _bind: function _bind(thisp, fn) {
            if (nativeBind && fn.bind === nativeBind) return fn.bind(thisp);
            return function() {
                return fn.apply(thisp, arguments);
            };
        },
        throttle: function throttle(func, wait, context) {
            var previous = 0;
            return function() {
                var now = Date.now();
                if (now - previous > wait) {
                    previous = now;
                    func.apply(context, arguments);
                }
            };
        },
        each: function each(list, iteratee) {
            var length;
            var key;
            if (list) {
                length = list.length;
                if (length != null && typeof list !== "function") {
                    key = 0;
                    while(key < length){
                        if (iteratee.call(list[key], key, list[key]) === false) break;
                        key += 1;
                    }
                } else {
                    for(key in list)if (list.hasOwnProperty(key)) {
                        if (iteratee.call(list[key], key, list[key]) === false) break;
                    }
                }
            }
        },
        extend: function extend(dest) {
            var args = arguments;
            var srcs = [].slice.call(args, 1, args.length);
            srcs.forEach(function(source) {
                if (typeof source === "object") Object.getOwnPropertyNames(source).forEach(function(name) {
                    dest[name] = source[name];
                });
            });
            return dest;
        },
        sanitizeStructuredClone: function sanitizeStructuredClone(object) {
            var whiteList = [
                Boolean,
                String,
                Date,
                RegExp,
                Blob,
                File,
                FileList,
                ArrayBuffer
            ];
            var blackList = [
                Error,
                Node
            ];
            var warn = util.warn;
            var visitedObjects = [];
            function _clone(value) {
                if (typeof value === "function") {
                    warn("A function was detected and removed from the message.");
                    return null;
                }
                if (blackList.some(function(t) {
                    if (value instanceof t) {
                        warn(t.name + " object was detected and removed from the message.");
                        return true;
                    }
                    return false;
                })) return {};
                if (value && typeof value === "object" && whiteList.every(function(t) {
                    return !(value instanceof t);
                })) {
                    var newValue;
                    if (Array.isArray(value)) newValue = value.map(function(element) {
                        return _clone(element);
                    });
                    else {
                        if (visitedObjects.indexOf(value) > -1) {
                            warn("A circular reference was detected and removed from the message.");
                            return null;
                        }
                        visitedObjects.push(value);
                        newValue = {};
                        for(var name in value)if (value.hasOwnProperty(name)) {
                            var clonedValue = _clone(value[name]);
                            if (clonedValue !== null) newValue[name] = clonedValue;
                        }
                        visitedObjects.pop();
                    }
                    return newValue;
                }
                return value;
            }
            return _clone(object);
        },
        getOrigin: function getOrigin(url, base) {
            // everything except IE11
            if (typeof URL === "function") try {
                return new URL(url, base).origin;
            } catch (e) {}
             // ie11 + safari 10
            var doc = document.implementation.createHTMLDocument("");
            if (base) {
                var baseElement = doc.createElement("base");
                baseElement.href = base;
                doc.head.appendChild(baseElement);
            }
            var anchorElement = doc.createElement("a");
            anchorElement.href = url;
            doc.body.appendChild(anchorElement);
            var origin = anchorElement.protocol + "//" + anchorElement.hostname; //ie11, only include port if referenced in initial URL
            if (url.match(/\/\/[^/]+:[0-9]+\//)) origin += anchorElement.port ? ":" + anchorElement.port : "";
            return origin;
        }
    };
    var threshold = 0.25;
    var throttle_delay = 500;
    var targets = [];
    var observe;
    var observed = function observed(target) {
        targets = targets.filter(function(_ref) {
            var element = _ref.element, callback = _ref.callback;
            if (element === target) {
                callback();
                return false;
            }
            return true;
        });
    };
    if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window) {
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(_ref2) {
                var intersectionRatio = _ref2.intersectionRatio, target = _ref2.target;
                if (intersectionRatio > 0) {
                    observer.unobserve(target);
                    observed(target);
                }
            });
        }, {
            threshold: threshold
        });
        observe = observer.observe.bind(observer);
    } else {
        // Ponyfill for SafarIE
        var getIntersection = function getIntersection(target) {
            var docEl = document.documentElement;
            if (!docEl.contains(target) || getComputedStyle(target).display === "none") return;
            var targetRect = target.getBoundingClientRect();
            var parent = target.parentNode;
            var intersection = targetRect;
            do {
                var parentStyle = getComputedStyle(parent);
                if (parentStyle.display === "none") return;
                var parentRect = void 0;
                if (parent === document.body) parentRect = {
                    top: 0,
                    left: 0,
                    right: docEl.clientWidth,
                    bottom: docEl.clientHeight
                };
                else if (parentStyle.overflow !== "visible") parentRect = parent.getBoundingClientRect();
                if (parentRect) {
                    var top = Math.max(parentRect.top, intersection.top);
                    var left = Math.max(parentRect.left, intersection.left);
                    var right = Math.min(parentRect.right, intersection.right);
                    var bottom = Math.min(parentRect.bottom, intersection.bottom);
                    var width = right - left;
                    var height = bottom - top;
                    if (width <= 0 || height <= 0) return;
                    intersection = {
                        top: top,
                        left: left,
                        right: right,
                        bottom: bottom,
                        width: width,
                        height: height
                    };
                }
                parent = parent.parentNode;
            }while (parent !== docEl);
            if (intersection) return intersection.width * intersection.height / (targetRect.width * targetRect.height);
        };
        observe = function observe(element) {
            if (getIntersection(element) >= threshold) observed(element);
        };
        var throttled_observe = util.throttle(function() {
            targets.forEach(function(_ref3) {
                var element = _ref3.element;
                return observe(element);
            });
        }, throttle_delay);
        window.addEventListener("resize", throttled_observe);
        document.addEventListener("scroll", throttled_observe);
        if ("MutationObserver" in window) document.addEventListener("DOMContentLoaded", function() {
            new MutationObserver(throttled_observe).observe(document.body, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        });
    }
    var observe$1 = function(element, callback) {
        if (typeof callback === "function" && element instanceof Element) {
            targets.push({
                element: element,
                callback: callback
            });
            observe(element);
        }
    };
    var EVENT_NAME_PREFIX = "connect.addon.";
    /**
   * Timings beyond 20 seconds (connect's load timeout) will be clipped to an X.
   * @const
   * @type {int}
   */ var LOADING_TIME_THRESHOLD = 20000;
    /**
   * Trim extra zeros from the load time.
   * @const
   * @type {int}
   */ var LOADING_TIME_TRIMP_PRECISION = 100;
    var AnalyticsDispatcher = /*#__PURE__*/ function() {
        function AnalyticsDispatcher() {
            this._addons = {};
        }
        var _proto = AnalyticsDispatcher.prototype;
        _proto._track = function _track(name, data) {
            var w = window;
            var prefixedName = EVENT_NAME_PREFIX + name;
            data = data || {};
            data.version = w._AP && w._AP.version ? w._AP.version : undefined;
            data.userAgent = w.navigator.userAgent;
            if (!w.AJS) return false;
            if (w.AJS.Analytics) w.AJS.Analytics.triggerPrivacyPolicySafeEvent(prefixedName, data);
            else if (w.AJS.trigger) // BTF fallback
            AJS.trigger("analyticsEvent", {
                name: prefixedName,
                data: data
            });
            else return false;
            return true;
        };
        _proto._time = function _time() {
            return window.performance && window.performance.now ? window.performance.now() : new Date().getTime();
        };
        _proto.trackLoadingStarted = function trackLoadingStarted(extension) {
            if (this._addons && extension && extension.id) {
                extension.startLoading = this._time();
                this._addons[extension.id] = extension;
            } else console.error("ACJS: cannot track loading analytics", this._addons, extension);
        };
        _proto.trackLoadingEnded = function trackLoadingEnded(extension) {
            var _this = this;
            if (this._addons && extension && this._addons[extension.id]) {
                var href = extension.url;
                var iframeIsCacheable = href !== undefined && href.indexOf("xdm_e=") === -1;
                var value = this._time() - this._addons[extension.id].startLoading;
                var iframeLoadApdex = this.getIframeLoadApdex(value);
                var eventPayload = {
                    addonKey: extension.addon_key,
                    moduleKey: extension.key,
                    moduleType: extension.options ? extension.options.moduleType : undefined,
                    moduleLocation: extension.options ? extension.options.moduleLocation : undefined,
                    iframeLoadMillis: value,
                    iframeLoadApdex: iframeLoadApdex,
                    iframeIsCacheable: iframeIsCacheable,
                    value: value > LOADING_TIME_THRESHOLD ? "x" : Math.ceil(value / LOADING_TIME_TRIMP_PRECISION)
                };
                if (typeof window.requestIdleCallback === "function") window.requestIdleCallback(function() {
                    return _this._track("iframe.performance.load", eventPayload);
                }, {
                    timeout: 100
                });
                else this._track("iframe.performance.load", eventPayload);
            } else console.error("ACJS: cannot track loading end analytics", this._addons, extension);
        };
        _proto.getIframeLoadApdex = function getIframeLoadApdex(iframeLoadMilliseconds) {
            var apdexSatisfiedThresholdMilliseconds = 300;
            var iframeLoadApdex = iframeLoadMilliseconds <= apdexSatisfiedThresholdMilliseconds ? 1 : iframeLoadMilliseconds <= 4 * apdexSatisfiedThresholdMilliseconds ? 0.5 : 0;
            return iframeLoadApdex;
        };
        _proto.trackLoadingTimeout = function trackLoadingTimeout(extension) {
            var connectedStatus = window.navigator.onLine;
            if (typeof connectedStatus !== "boolean") connectedStatus = "not-supported";
            this._track("iframe.performance.timeout", {
                addonKey: extension.addon_key,
                moduleKey: extension.key,
                moduleType: extension.options ? extension.options.moduleType : undefined,
                moduleLocation: extension.options ? extension.options.moduleLocation : undefined,
                connectedStatus: connectedStatus.toString() // convert boolean to string
            }); //track an end event during a timeout so we always have complete start / end data.
            this.trackLoadingEnded(extension);
        };
        _proto.trackLoadingCancel = function trackLoadingCancel(extension) {
            this._track("iframe.performance.cancel", {
                addonKey: extension.addon_key,
                moduleKey: extension.key,
                moduleType: extension.options ? extension.options.moduleType : undefined,
                moduleLocation: extension.options ? extension.options.moduleLocation : undefined
            });
        };
        _proto.trackUseOfDeprecatedMethod = function trackUseOfDeprecatedMethod(methodUsed, extension) {
            this._track("jsapi.deprecated", {
                addonKey: extension.addon_key,
                moduleKey: extension.key,
                methodUsed: methodUsed
            });
        };
        _proto.trackMultipleDialogOpening = function trackMultipleDialogOpening(dialogType, extension) {
            this._track("jsapi.dialog.multiple", {
                addonKey: extension.addon_key,
                moduleKey: extension.key,
                dialogType: dialogType
            });
        };
        _proto.trackVisible = function trackVisible(extension) {
            this._track("iframe.is_visible", {
                addonKey: extension.addon_key,
                moduleKey: extension.key
            });
        };
        _proto.dispatch = function dispatch(name, data) {
            this._track(name, data);
        };
        _proto.trackExternal = function trackExternal(name, data) {
            this._track(name, data);
        };
        return AnalyticsDispatcher;
    }();
    var analytics = new AnalyticsDispatcher();
    if ($.fn) EventDispatcher$1.register("iframe-create", function(data) {
        analytics.trackLoadingStarted(data.extension);
    });
    EventDispatcher$1.register("iframe-bridge-start", function(data) {
        analytics.trackLoadingStarted(data.extension);
    });
    EventDispatcher$1.register("iframe-bridge-established", function(data) {
        analytics.trackLoadingEnded(data.extension);
        observe$1(document.getElementById(data.extension.id), function() {
            analytics.trackVisible(data.extension);
        });
    });
    EventDispatcher$1.register("iframe-bridge-timeout", function(data) {
        analytics.trackLoadingTimeout(data.extension);
    });
    EventDispatcher$1.register("iframe-bridge-cancelled", function(data) {
        analytics.trackLoadingCancel(data.extension);
    });
    EventDispatcher$1.register("analytics-deprecated-method-used", function(data) {
        analytics.trackUseOfDeprecatedMethod(data.methodUsed, data.extension);
    });
    EventDispatcher$1.register("iframe-destroyed", function(data) {
        delete analytics._addons[data.extension.extension_id];
    });
    EventDispatcher$1.register("analytics-external-event-track", function(data) {
        analytics.trackExternal(data.eventName, data.values);
    });
    var LoadingIndicatorActions = {
        timeout: function timeout($el, extension) {
            EventDispatcher$1.dispatch("iframe-bridge-timeout", {
                $el: $el,
                extension: extension
            });
        },
        cancelled: function cancelled($el, extension) {
            EventDispatcher$1.dispatch("iframe-bridge-cancelled", {
                $el: $el,
                extension: extension
            });
        }
    };
    var LOADING_INDICATOR_CLASS = "ap-status-indicator";
    var LOADING_STATUSES = {
        loading: '<div class="ap-loading"><div class="small-spinner"></div>Loading app...</div>',
        "load-timeout": '<div class="ap-load-timeout"><div class="small-spinner"></div>App is not responding. Wait or <a href="#" class="ap-btn-cancel">cancel</a>?</div>',
        "load-error": "App failed to load."
    };
    var LOADING_TIMEOUT = 12000;
    var LoadingIndicator = /*#__PURE__*/ function() {
        function LoadingIndicator() {
            this._stateRegistry = {};
        }
        var _proto = LoadingIndicator.prototype;
        _proto._loadingContainer = function _loadingContainer($iframeContainer) {
            return $iframeContainer.find("." + LOADING_INDICATOR_CLASS);
        };
        _proto.render = function render() {
            var container = document.createElement("div");
            container.classList.add(LOADING_INDICATOR_CLASS);
            container.innerHTML = LOADING_STATUSES.loading;
            var $container = $(container);
            this._startSpinner($container);
            return $container;
        };
        _proto._startSpinner = function _startSpinner($container) {
            // TODO: AUI or spin.js broke something. This is bad but ironically matches v3's implementation.
            setTimeout(function() {
                var spinner = $container.find(".small-spinner");
                if (spinner.length && spinner.spin) spinner.spin({
                    lines: 12,
                    length: 3,
                    width: 2,
                    radius: 3,
                    trail: 60,
                    speed: 1.5,
                    zIndex: 1
                });
            }, 10);
        };
        _proto.hide = function hide($iframeContainer, extensionId) {
            clearTimeout(this._stateRegistry[extensionId]);
            delete this._stateRegistry[extensionId];
            this._loadingContainer($iframeContainer)[0].style.display = "none";
        };
        _proto.cancelled = function cancelled($iframeContainer, extensionId) {
            var status = LOADING_STATUSES["load-error"];
            this._loadingContainer($iframeContainer).empty().text(status);
        };
        _proto._setupTimeout = function _setupTimeout($container, extension) {
            this._stateRegistry[extension.id] = setTimeout(function() {
                LoadingIndicatorActions.timeout($container, extension);
            }, LOADING_TIMEOUT);
        };
        _proto.timeout = function timeout($iframeContainer, extensionId) {
            var status = $(LOADING_STATUSES["load-timeout"]);
            var container = this._loadingContainer($iframeContainer);
            container.empty().append(status);
            this._startSpinner(container);
            $("a.ap-btn-cancel", container).click(function() {
                LoadingIndicatorActions.cancelled($iframeContainer, extensionId);
            });
            delete this._stateRegistry[extensionId];
            return container;
        };
        return LoadingIndicator;
    }();
    var LoadingComponent = new LoadingIndicator();
    EventDispatcher$1.register("iframe-create", function(data) {
        if (!data.extension.options.noDom) LoadingComponent._setupTimeout(data.$el.parents(".ap-iframe-container"), data.extension);
    });
    EventDispatcher$1.register("iframe-bridge-established", function(data) {
        if (!data.extension.options.noDom) LoadingComponent.hide(data.$el.parents(".ap-iframe-container"), data.extension.id);
    });
    EventDispatcher$1.register("iframe-bridge-timeout", function(data) {
        if (!data.extension.options.noDom) LoadingComponent.timeout(data.$el, data.extension.id);
    });
    EventDispatcher$1.register("iframe-bridge-cancelled", function(data) {
        if (!data.extension.options.noDom) LoadingComponent.cancelled(data.$el, data.extension.id);
    });
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;
    function createCommonjsModule(fn, module1) {
        return module1 = {
            exports: {}
        }, fn(module1, module1.exports), module1.exports;
    }
    var setPrototypeOf = createCommonjsModule(function(module1) {
        function _setPrototypeOf(o, p) {
            module1.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                o.__proto__ = p;
                return o;
            };
            return _setPrototypeOf(o, p);
        }
        module1.exports = _setPrototypeOf;
    });
    var construct = createCommonjsModule(function(module1) {
        function isNativeReflectConstruct() {
            if (typeof Reflect === "undefined" || !Reflect.construct) return false;
            if (Reflect.construct.sham) return false;
            if (typeof Proxy === "function") return true;
            try {
                Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
                return true;
            } catch (e) {
                return false;
            }
        }
        function _construct(Parent, args, Class) {
            if (isNativeReflectConstruct()) module1.exports = _construct = Reflect.construct;
            else module1.exports = _construct = function _construct(Parent, args, Class) {
                var a = [
                    null
                ];
                a.push.apply(a, args);
                var Constructor = Function.bind.apply(Parent, a);
                var instance = new Constructor();
                if (Class) setPrototypeOf(instance, Class.prototype);
                return instance;
            };
            return _construct.apply(null, arguments);
        }
        module1.exports = _construct;
    });
    var PostMessage = /*#__PURE__*/ function() {
        function PostMessage(data) {
            var d = data || {};
            this._registerListener(d.listenOn);
        }
        var _proto = PostMessage.prototype;
        _proto._registerListener = function _registerListener(listenOn) {
            if (!listenOn || !listenOn.addEventListener) listenOn = window;
            listenOn.addEventListener("message", util._bind(this, this._receiveMessage), false);
        };
        _proto._receiveMessage = function _receiveMessage(event) {
            var handler = this._messageHandlers[event.data.type], extensionId = event.data.eid, reg;
            if (extensionId && this._registeredExtensions) reg = this._registeredExtensions[extensionId];
            if (!handler || !this._checkOrigin(event, reg)) return false;
            handler.call(this, event, reg);
        };
        return PostMessage;
    }();
    var VALID_EVENT_TIME_MS = 30000; //30 seconds
    var XDMRPC = /*#__PURE__*/ function(_PostMessage) {
        inheritsLoose(XDMRPC, _PostMessage);
        var _proto = XDMRPC.prototype;
        _proto._padUndefinedArguments = function _padUndefinedArguments(array, length) {
            return array.length >= length ? array : array.concat(new Array(length - array.length));
        };
        function XDMRPC(config) {
            var _this;
            config = config || {};
            _this = _PostMessage.call(this, config) || this;
            _this._registeredExtensions = config.extensions || {};
            _this._registeredAPIModules = {};
            _this._registeredAPIModules._globals = {};
            _this._pendingCallbacks = {};
            _this._keycodeCallbacks = {};
            _this._clickHandler = null;
            _this._pendingEvents = {};
            _this._messageHandlers = {
                init: _this._handleInit,
                req: _this._handleRequest,
                resp: _this._handleResponse,
                broadcast: _this._handleBroadcast,
                event_query: _this._handleEventQuery,
                key_triggered: _this._handleKeyTriggered,
                addon_clicked: _this._handleAddonClick,
                get_host_offset: _this._getHostOffset,
                unload: _this._handleUnload,
                sub: _this._handleSubInit
            };
            return _this;
        }
        _proto._verifyAPI = function _verifyAPI(event, reg) {
            var untrustedTargets = event.data.targets;
            if (!untrustedTargets) return;
            var trustedSpec = this.getApiSpec();
            var tampered = false;
            function check(trusted, untrusted) {
                Object.getOwnPropertyNames(untrusted).forEach(function(name) {
                    if (typeof untrusted[name] === "object" && trusted[name]) check(trusted[name], untrusted[name]);
                    else if (untrusted[name] === "parent" && trusted[name]) tampered = true;
                });
            }
            check(trustedSpec, untrustedTargets);
            event.source.postMessage({
                type: "api_tamper",
                tampered: tampered
            }, reg.extension.url);
        };
        _proto._handleInit = function _handleInit(event, reg) {
            event.source.postMessage({
                type: "init_received"
            }, reg.extension.url);
            this._registeredExtensions[reg.extension_id].source = event.source;
            if (reg.initCallback) {
                reg.initCallback(event.data.eid);
                delete reg.initCallback;
            }
            if (event.data.targets) this._verifyAPI(event, reg);
        } // postMessage method to do registerExtension
        ;
        _proto._handleSubInit = function _handleSubInit(event, reg) {
            if (reg.extension.options.noSub) util.error("Sub-Extension requested by [" + reg.extension.addon_key + "] but feature is disabled");
            else {
                var data = event.data;
                this.registerExtension(data.ext.id, {
                    extension: data.ext
                });
                if (this._registeredRequestNotifier) this._registeredRequestNotifier.call(null, {
                    sub: data.ext,
                    type: data.type,
                    addon_key: reg.extension.addon_key,
                    key: reg.extension.key,
                    extension_id: reg.extension_id
                });
            }
        };
        _proto._getHostOffset = function _getHostOffset(event, _window) {
            var hostWindow = event.source;
            var hostFrameOffset = null;
            var windowReference = _window || window; // For testing
            if (windowReference === windowReference.top && typeof windowReference.getHostOffsetFunctionOverride === "function") hostFrameOffset = windowReference.getHostOffsetFunctionOverride(hostWindow);
            if (typeof hostFrameOffset !== "number") {
                hostFrameOffset = 0; // Find the closest frame that has the same origin as event source
                while(!this._hasSameOrigin(hostWindow)){
                    // Climb up the iframe tree 1 layer
                    hostFrameOffset++;
                    hostWindow = hostWindow.parent;
                }
            }
            event.source.postMessage({
                hostFrameOffset: hostFrameOffset
            }, event.origin);
        };
        _proto._hasSameOrigin = function _hasSameOrigin(window1) {
            if (window1 === window1.top) return true;
            try {
                // Try set & read a variable on the given window
                // If we can successfully read the value then it means the given window has the same origin
                // as the window that is currently executing the script
                var testVariableName = "test_var_" + Math.random().toString(16).substr(2);
                window1[testVariableName] = true;
                return window1[testVariableName];
            } catch (e) {}
            return false;
        };
        _proto._handleResponse = function _handleResponse(event) {
            var data = event.data;
            var pendingCallback = this._pendingCallbacks[data.mid];
            if (pendingCallback) {
                delete this._pendingCallbacks[data.mid];
                pendingCallback.apply(window, data.args);
            }
        };
        _proto.registerRequestNotifier = function registerRequestNotifier(cb) {
            this._registeredRequestNotifier = cb;
        };
        _proto._handleRequest = function _handleRequest(event, reg) {
            function sendResponse() {
                var args = util.sanitizeStructuredClone(util.argumentsToArray(arguments));
                event.source.postMessage({
                    mid: event.data.mid,
                    type: "resp",
                    forPlugin: true,
                    args: args
                }, reg.extension.url);
            }
            var data = event.data;
            var module1 = this._registeredAPIModules[data.mod];
            var extension = this.getRegisteredExtensions(reg.extension)[0];
            if (module1) {
                var fnName = data.fn;
                if (data._cls) {
                    var Cls = module1[data._cls];
                    var ns = data.mod + "-" + data._cls + "-";
                    sendResponse._id = data._id;
                    if (fnName === "constructor") {
                        if (!Cls._construct) {
                            Cls.constructor.prototype._destroy = function() {
                                delete this._context._proxies[ns + this._id];
                            };
                            Cls._construct = function() {
                                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                                var inst = construct(Cls.constructor, args);
                                var callback = args[args.length - 1];
                                inst._id = callback._id;
                                inst._context = callback._context;
                                inst._context._proxies[ns + inst._id] = inst;
                                return inst;
                            };
                        }
                        module1 = Cls;
                        fnName = "_construct";
                    } else module1 = extension._proxies[ns + data._id];
                }
                var method = module1[fnName];
                if (method) {
                    var methodArgs = data.args;
                    var padLength = method.length - 1;
                    if (fnName === "_construct") padLength = module1.constructor.length - 1;
                    sendResponse._context = extension;
                    methodArgs = this._padUndefinedArguments(methodArgs, padLength);
                    methodArgs.push(sendResponse);
                    var promiseResult = method.apply(module1, methodArgs);
                    if (method.returnsPromise) {
                        if (!(typeof promiseResult === "object" || typeof promiseResult === "function") || typeof promiseResult.then !== "function") sendResponse("Defined module method did not return a promise.");
                        else promiseResult.then(function(result) {
                            sendResponse(undefined, result);
                        }).catch(function(err) {
                            err = err instanceof Error ? err.message : err;
                            sendResponse(err);
                        });
                    }
                    if (this._registeredRequestNotifier) this._registeredRequestNotifier.call(null, {
                        module: data.mod,
                        fn: data.fn,
                        type: data.type,
                        addon_key: reg.extension.addon_key,
                        key: reg.extension.key,
                        extension_id: reg.extension_id
                    });
                }
            }
        };
        _proto._handleBroadcast = function _handleBroadcast(event, reg) {
            var event_data = event.data;
            var targetSpec = function targetSpec(r) {
                return r.extension.addon_key === reg.extension.addon_key && r.extension_id !== reg.extension_id;
            };
            this.dispatch(event_data.etyp, targetSpec, event_data.evnt, null, null);
        };
        _proto._handleKeyTriggered = function _handleKeyTriggered(event, reg) {
            var eventData = event.data;
            var keycodeEntry = this._keycodeKey(eventData.keycode, eventData.modifiers, reg.extension_id);
            var listeners = this._keycodeCallbacks[keycodeEntry];
            if (listeners) listeners.forEach(function(listener) {
                listener.call(null, {
                    addon_key: reg.extension.addon_key,
                    key: reg.extension.key,
                    extension_id: reg.extension_id,
                    keycode: eventData.keycode,
                    modifiers: eventData.modifiers
                });
            }, this);
        };
        _proto.defineAPIModule = function defineAPIModule(module1, moduleName) {
            moduleName = moduleName || "_globals";
            this._registeredAPIModules[moduleName] = util.extend({}, this._registeredAPIModules[moduleName] || {}, module1);
            return this._registeredAPIModules;
        };
        _proto.isAPIModuleDefined = function isAPIModuleDefined(moduleName) {
            return typeof this._registeredAPIModules[moduleName] !== "undefined";
        };
        _proto._pendingEventKey = function _pendingEventKey(targetSpec, time) {
            var key = targetSpec.addon_key || "global";
            if (targetSpec.key) key = key + "@@" + targetSpec.key;
            key = key + "@@" + time;
            return key;
        };
        _proto.queueEvent = function queueEvent(type, targetSpec, event, callback) {
            var loaded_frame, targets = this._findRegistrations(targetSpec);
            loaded_frame = targets.some(function(target) {
                return target.registered_events !== undefined;
            }, this);
            if (loaded_frame) this.dispatch(type, targetSpec, event, callback);
            else {
                this._cleanupInvalidEvents();
                var time = new Date().getTime();
                this._pendingEvents[this._pendingEventKey(targetSpec, time)] = {
                    type: type,
                    targetSpec: targetSpec,
                    event: event,
                    callback: callback,
                    time: time,
                    uid: util.randomString()
                };
            }
        };
        _proto._cleanupInvalidEvents = function _cleanupInvalidEvents() {
            var _this2 = this;
            var now = new Date().getTime();
            var keys = Object.keys(this._pendingEvents);
            keys.forEach(function(index) {
                var element = _this2._pendingEvents[index];
                var eventIsValid = now - element.time <= VALID_EVENT_TIME_MS;
                if (!eventIsValid) delete _this2._pendingEvents[index];
            });
        };
        _proto._handleEventQuery = function _handleEventQuery(message, extension) {
            var _this3 = this;
            var executed = {};
            var now = new Date().getTime();
            var keys = Object.keys(this._pendingEvents);
            keys.forEach(function(index) {
                var element = _this3._pendingEvents[index];
                var eventIsValid = now - element.time <= VALID_EVENT_TIME_MS;
                var isSameTarget = !element.targetSpec || _this3._findRegistrations(element.targetSpec).length !== 0;
                if (isSameTarget && element.targetSpec.key) isSameTarget = element.targetSpec.addon_key === extension.extension.addon_key && element.targetSpec.key === extension.extension.key;
                if (eventIsValid && isSameTarget) {
                    executed[index] = element;
                    element.targetSpec = element.targetSpec || {};
                    _this3.dispatch(element.type, element.targetSpec, element.event, element.callback, message.source);
                } else if (!eventIsValid) delete _this3._pendingEvents[index];
            });
            this._registeredExtensions[extension.extension_id].registered_events = message.data.args;
            return executed;
        };
        _proto._handleUnload = function _handleUnload(event, reg) {
            if (!reg) return;
            if (reg.extension_id && this._registeredExtensions[reg.extension_id]) delete this._registeredExtensions[reg.extension_id].source;
            if (reg.unloadCallback) reg.unloadCallback(event.data.eid);
        };
        _proto.dispatch = function dispatch(type, targetSpec, event, callback, source) {
            function sendEvent(reg, evnt) {
                if (reg.source && reg.source.postMessage) {
                    var mid;
                    if (callback) {
                        mid = util.randomString();
                        this._pendingCallbacks[mid] = callback;
                    }
                    reg.source.postMessage({
                        type: "evt",
                        mid: mid,
                        etyp: type,
                        evnt: evnt
                    }, reg.extension.url);
                }
            }
            var registrations = this._findRegistrations(targetSpec || {});
            registrations.forEach(function(reg) {
                if (source && !reg.source) reg.source = source;
                if (reg.source) util._bind(this, sendEvent)(reg, event);
            }, this);
        };
        _proto._findRegistrations = function _findRegistrations(targetSpec) {
            var _this4 = this;
            if (this._registeredExtensions.length === 0) {
                util.error("no registered extensions", this._registeredExtensions);
                return [];
            }
            var keys = Object.getOwnPropertyNames(targetSpec);
            var registrations = Object.getOwnPropertyNames(this._registeredExtensions).map(function(key) {
                return _this4._registeredExtensions[key];
            });
            if (targetSpec instanceof Function) return registrations.filter(targetSpec);
            else return registrations.filter(function(reg) {
                return keys.every(function(key) {
                    return reg.extension[key] === targetSpec[key];
                });
            });
        };
        _proto.registerExtension = function registerExtension(extension_id, data) {
            data._proxies = {};
            data.extension_id = extension_id;
            this._registeredExtensions[extension_id] = data;
        };
        _proto._keycodeKey = function _keycodeKey(key, modifiers, extension_id) {
            var code = key;
            if (modifiers) {
                if (typeof modifiers === "string") modifiers = [
                    modifiers
                ];
                modifiers.sort();
                modifiers.forEach(function(modifier) {
                    code += "$$" + modifier;
                }, this);
            }
            return code + "__" + extension_id;
        };
        _proto.registerKeyListener = function registerKeyListener(extension_id, key, modifiers, callback) {
            if (typeof modifiers === "string") modifiers = [
                modifiers
            ];
            var reg = this._registeredExtensions[extension_id];
            var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
            if (!this._keycodeCallbacks[keycodeEntry]) {
                this._keycodeCallbacks[keycodeEntry] = [];
                reg.source.postMessage({
                    type: "key_listen",
                    keycode: key,
                    modifiers: modifiers,
                    action: "add"
                }, reg.extension.url);
            }
            this._keycodeCallbacks[keycodeEntry].push(callback);
        };
        _proto.unregisterKeyListener = function unregisterKeyListener(extension_id, key, modifiers, callback) {
            var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
            var potentialCallbacks = this._keycodeCallbacks[keycodeEntry];
            var reg = this._registeredExtensions[extension_id];
            if (potentialCallbacks) {
                if (callback) {
                    var index = potentialCallbacks.indexOf(callback);
                    this._keycodeCallbacks[keycodeEntry].splice(index, 1);
                } else delete this._keycodeCallbacks[keycodeEntry];
                if (reg.source && reg.source.postMessage) reg.source.postMessage({
                    type: "key_listen",
                    keycode: key,
                    modifiers: modifiers,
                    action: "remove"
                }, reg.extension.url);
            }
        };
        _proto.registerClickHandler = function registerClickHandler(callback) {
            if (typeof callback !== "function") throw new Error("callback must be a function");
            if (this._clickHandler !== null) throw new Error("ClickHandler already registered");
            this._clickHandler = callback;
        };
        _proto._handleAddonClick = function _handleAddonClick(event, reg) {
            if (typeof this._clickHandler === "function") this._clickHandler({
                addon_key: reg.extension.addon_key,
                key: reg.extension.key,
                extension_id: reg.extension_id
            });
        };
        _proto.unregisterClickHandler = function unregisterClickHandler() {
            this._clickHandler = null;
        };
        _proto.getApiSpec = function getApiSpec(addonKey) {
            var _this5 = this;
            function getModuleDefinition(mod) {
                return Object.getOwnPropertyNames(mod).reduce(function(accumulator, memberName) {
                    var member = mod[memberName];
                    switch(typeof member){
                        case "function":
                            accumulator[memberName] = {
                                args: util.argumentNames(member),
                                returnsPromise: member.returnsPromise || false
                            };
                            break;
                        case "object":
                            if (member.hasOwnProperty("constructor")) accumulator[memberName] = getModuleDefinition(member);
                            break;
                    }
                    return accumulator;
                }, {});
            }
            return Object.getOwnPropertyNames(this._registeredAPIModules).reduce(function(accumulator, moduleName) {
                var module1 = _this5._registeredAPIModules[moduleName];
                if (typeof module1.addonKey === "undefined" || module1.addonKey === addonKey) accumulator[moduleName] = getModuleDefinition(module1);
                return accumulator;
            }, {});
        };
        _proto._originEqual = function _originEqual(url, origin) {
            function strCheck(str) {
                return typeof str === "string" && str.length > 0;
            }
            var urlOrigin = util.getOrigin(url); // check strings are strings and they contain something
            if (!strCheck(url) || !strCheck(origin) || !strCheck(urlOrigin)) return false;
            return origin === urlOrigin;
        } // validate origin of postMessage
        ;
        _proto._checkOrigin = function _checkOrigin(event, reg) {
            var no_source_types = [
                "init"
            ];
            var isNoSourceType = reg && !reg.source && no_source_types.indexOf(event.data.type) > -1;
            var sourceTypeMatches = reg && event.source === reg.source;
            var hasExtensionUrl = reg && this._originEqual(reg.extension.url, event.origin);
            var isValidOrigin = hasExtensionUrl && (isNoSourceType || sourceTypeMatches); // get_host_offset fires before init
            if (event.data.type === "get_host_offset" && window === window.top) isValidOrigin = true;
             // check undefined for chromium (Issue 395010)
            if (event.data.type === "unload" && (sourceTypeMatches || event.source === undefined)) isValidOrigin = true;
            return isValidOrigin;
        };
        _proto.getRegisteredExtensions = function getRegisteredExtensions(filter) {
            if (filter) return this._findRegistrations(filter);
            return this._registeredExtensions;
        };
        _proto.unregisterExtension = function unregisterExtension(filter) {
            var registrations = this._findRegistrations(filter);
            if (registrations.length !== 0) registrations.forEach(function(registration) {
                var _this6 = this;
                var keys = Object.keys(this._pendingEvents);
                keys.forEach(function(index) {
                    var element = _this6._pendingEvents[index];
                    var targetSpec = element.targetSpec || {};
                    if (targetSpec.addon_key === registration.extension.addon_key && targetSpec.key === registration.extension.key) delete _this6._pendingEvents[index];
                });
                delete this._registeredExtensions[registration.extension_id];
            }, this);
        };
        return XDMRPC;
    }(PostMessage);
    var Connect = /*#__PURE__*/ function() {
        function Connect() {
            this._xdm = new XDMRPC();
        }
        /**
     * Send a message to iframes matching the targetSpec. This message is added to
     *  a message queue for delivery to ensure the message is received if an iframe
     *  has not yet loaded
     *
     * @param type The name of the event type
     * @param targetSpec The spec to match against extensions when sending this event
     * @param event The event payload
     * @param callback A callback to be executed when the remote iframe calls its callback
     */ var _proto = Connect.prototype;
        _proto.dispatch = function dispatch(type, targetSpec, event, callback) {
            this._xdm.queueEvent(type, targetSpec, event, callback);
            return this.getExtensions(targetSpec);
        } /**
     * Send a message to iframes matching the targetSpec immediately. This message will
     *  only be sent to iframes that are already open, and will not be delivered if none
     *  are currently open.
     *
     * @param type The name of the event type
     * @param targetSpec The spec to match against extensions when sending this event
     * @param event The event payload
     */ ;
        _proto.broadcast = function broadcast(type, targetSpec, event) {
            this._xdm.dispatch(type, targetSpec, event, null, null);
            return this.getExtensions(targetSpec);
        };
        _proto._createId = function _createId(extension) {
            if (!extension.addon_key || !extension.key) throw Error("Extensions require addon_key and key");
            return extension.addon_key + "__" + extension.key + "__" + util.randomString();
        } /**
    * Creates a new iframed module, without actually creating the DOM element.
    * The iframe attributes are passed to the 'setupCallback', which is responsible for creating
    * the DOM element and returning the window reference.
    *
    * @param extension The extension definition. Example:
    *   {
    *     addon_key: 'my-addon',
    *     key: 'my-module',
    *     url: 'https://example.com/my-module',
    *     options: {
    *         autoresize: false,
    *         hostOrigin: 'https://connect-host.example.com/'
    *     }
    *   }
    *
    * @param initCallback The optional initCallback is called when the bridge between host and iframe is established.
    **/ ;
        _proto.create = function create(extension, initCallback, unloadCallback) {
            var extension_id = this.registerExtension(extension, initCallback, unloadCallback);
            var options = extension.options || {};
            var data = {
                extension_id: extension_id,
                api: this._xdm.getApiSpec(extension.addon_key),
                origin: util.locationOrigin(),
                options: options
            };
            return {
                id: extension_id,
                name: JSON.stringify(data),
                src: extension.url
            };
        };
        _proto.registerRequestNotifier = function registerRequestNotifier(callback) {
            this._xdm.registerRequestNotifier(callback);
        };
        _proto.registerExtension = function registerExtension(extension, initCallback, unloadCallback) {
            var extension_id = this._createId(extension);
            this._xdm.registerExtension(extension_id, {
                extension: extension,
                initCallback: initCallback,
                unloadCallback: unloadCallback
            });
            return extension_id;
        };
        _proto.registerKeyListener = function registerKeyListener(extension_id, key, modifiers, callback) {
            this._xdm.registerKeyListener(extension_id, key, modifiers, callback);
        };
        _proto.unregisterKeyListener = function unregisterKeyListener(extension_id, key, modifiers, callback) {
            this._xdm.unregisterKeyListener(extension_id, key, modifiers, callback);
        };
        _proto.registerClickHandler = function registerClickHandler(callback) {
            this._xdm.registerClickHandler(callback);
        };
        _proto.unregisterClickHandler = function unregisterClickHandler() {
            this._xdm.unregisterClickHandler();
        };
        _proto.defineModule = function defineModule(moduleName, module1, options) {
            this._xdm.defineAPIModule(module1, moduleName, options);
        };
        _proto.isModuleDefined = function isModuleDefined(moduleName) {
            return this._xdm.isAPIModuleDefined(moduleName);
        };
        _proto.defineGlobals = function defineGlobals(module1) {
            this._xdm.defineAPIModule(module1);
        };
        _proto.getExtensions = function getExtensions(filter) {
            return this._xdm.getRegisteredExtensions(filter);
        };
        _proto.unregisterExtension = function unregisterExtension(filter) {
            return this._xdm.unregisterExtension(filter);
        };
        _proto.returnsPromise = function returnsPromise(wrappedMethod) {
            wrappedMethod.returnsPromise = true;
        };
        return Connect;
    }();
    var host = new Connect();
    var EventActions = {
        broadcast: function broadcast(type, targetSpec, event) {
            host.dispatch(type, targetSpec, event);
            EventDispatcher$1.dispatch("event-dispatch", {
                type: type,
                targetSpec: targetSpec,
                event: event
            });
        },
        broadcastPublic: function broadcastPublic(type, event, sender) {
            EventDispatcher$1.dispatch("event-public-dispatch", {
                type: type,
                event: event,
                sender: sender
            });
            var _ref = sender.options || {}, contextJwt = _ref.contextJwt, url = _ref.url, filteredOptions = objectWithoutPropertiesLoose(_ref, [
                "contextJwt",
                "url"
            ]);
            host.dispatch(type, {}, {
                sender: {
                    addonKey: sender.addon_key,
                    key: sender.key,
                    options: util.sanitizeStructuredClone(filteredOptions)
                },
                event: event
            });
        }
    };
    /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */ /* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
        if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(val);
    }
    function shouldUseNative() {
        try {
            if (!Object.assign) return false;
             // Detect buggy property enumeration order in older V8 versions.
            // https://bugs.chromium.org/p/v8/issues/detail?id=4118
            var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
            test1[5] = "de";
            if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
             // https://bugs.chromium.org/p/v8/issues/detail?id=3056
            var test2 = {};
            for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
            var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
                return test2[n];
            });
            if (order2.join("") !== "0123456789") return false;
             // https://bugs.chromium.org/p/v8/issues/detail?id=3056
            var test3 = {};
            "abcdefghijklmnopqrst".split("").forEach(function(letter) {
                test3[letter] = letter;
            });
            if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
            return true;
        } catch (err) {
            // We don't expect any of the above to throw, but better to be safe.
            return false;
        }
    }
    var objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
        var from;
        var to = toObject(target);
        var symbols;
        for(var s = 1; s < arguments.length; s++){
            from = Object(arguments[s]);
            for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
            if (getOwnPropertySymbols) {
                symbols = getOwnPropertySymbols(from);
                for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
            }
        }
        return to;
    };
    function escapeSelector(s) {
        if (!s) throw new Error("No selector to escape");
        return s.replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, "\\$&");
    }
    function stringToDimension(value) {
        var percent = false;
        var unit = "px";
        if (typeof value === "string") {
            percent = value.indexOf("%") === value.length - 1;
            value = parseInt(value, 10);
            if (percent) unit = "%";
        }
        if (!isNaN(value)) return value + unit;
    }
    function getIframeByExtensionId(id) {
        return $("iframe#" + escapeSelector(id));
    }
    function first(arr, numb) {
        if (numb) return arr.slice(0, numb);
        return arr[0];
    }
    function last(arr) {
        return arr[arr.length - 1];
    }
    function pick(obj, keys) {
        if (typeof obj !== "object") return {};
        return Object.keys(obj).filter(function(key) {
            return keys.indexOf(key) >= 0;
        }).reduce(function(newObj, key) {
            var _extend;
            return objectAssign(newObj, (_extend = {}, _extend[key] = obj[key], _extend));
        }, {});
    }
    function debounce(fn, wait) {
        var timeout;
        return function() {
            var ctx = this;
            var args = [].slice.call(arguments);
            function later() {
                timeout = null;
                fn.apply(ctx, args);
            }
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(later, wait || 50);
        };
    }
    function isSupported(domElem, attr, value, defaultValue) {
        if (domElem && domElem[attr] && domElem[attr].supports) return domElem[attr].supports(value);
        else return defaultValue;
    }
    var Util = {
        escapeSelector: escapeSelector,
        stringToDimension: stringToDimension,
        getIframeByExtensionId: getIframeByExtensionId,
        first: first,
        last: last,
        pick: pick,
        debounce: debounce,
        isSupported: isSupported,
        extend: objectAssign
    };
    var events = {
        emit: function emit(name) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            var callback = Util.last(args);
            args = Util.first(args, -1);
            EventActions.broadcast(name, {
                addon_key: callback._context.extension.addon_key
            }, args);
        },
        emitPublic: function emitPublic(name) {
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            var callback = Util.last(args);
            var extension = callback._context.extension;
            args = Util.first(args, -1);
            EventActions.broadcastPublic(name, args, extension);
        }
    };
    var DialogExtensionActions = {
        open: function open(extension, options) {
            EventDispatcher$1.dispatch("dialog-extension-open", {
                extension: extension,
                options: options
            });
        },
        close: function close() {
            EventDispatcher$1.dispatch("dialog-close-active", {});
        },
        addUserButton: function addUserButton(options, extension) {
            EventDispatcher$1.dispatch("dialog-button-add", {
                button: {
                    text: options.text,
                    identifier: options.identifier,
                    data: {
                        userButton: true
                    }
                },
                extension: extension
            });
        }
    };
    var DialogActions = {
        close: function close(data) {
            EventDispatcher$1.dispatch("dialog-close", {
                dialog: data.dialog,
                extension: data.extension,
                customData: data.customData
            });
        },
        closeActive: function closeActive(data) {
            EventDispatcher$1.dispatch("dialog-close-active", data);
        },
        clickButton: function clickButton(identifier, $el, extension) {
            EventDispatcher$1.dispatch("dialog-button-click", {
                identifier: identifier,
                $el: $el,
                extension: extension
            });
        },
        toggleButton: function toggleButton(data) {
            EventDispatcher$1.dispatch("dialog-button-toggle", data);
        },
        toggleButtonVisibility: function toggleButtonVisibility(data) {
            EventDispatcher$1.dispatch("dialog-button-toggle-visibility", data);
        }
    };
    var DomEventActions = {
        registerKeyEvent: function registerKeyEvent(data) {
            host.registerKeyListener(data.extension_id, data.key, data.modifiers, data.callback);
            EventDispatcher$1.dispatch("dom-event-register", data);
        },
        unregisterKeyEvent: function unregisterKeyEvent(data) {
            host.unregisterKeyListener(data.extension_id, data.key, data.modifiers, data.callback);
            EventDispatcher$1.dispatch("dom-event-unregister", data);
        },
        registerWindowKeyEvent: function registerWindowKeyEvent(data) {
            window.addEventListener("keydown", function(event) {
                if (event.keyCode === data.keyCode) data.callback();
            });
        },
        registerClickHandler: function registerClickHandler(handleIframeClick) {
            host.registerClickHandler(function(data) {
                var iframe = document.getElementById(data.extension_id);
                if (iframe) handleIframeClick(iframe);
            });
        },
        unregisterClickHandler: function unregisterClickHandler() {
            host.unregisterClickHandler();
        }
    };
    var ButtonUtils = /*#__PURE__*/ function() {
        function ButtonUtils() {}
        var _proto = ButtonUtils.prototype;
        // button identifier for XDM. NOT an id attribute
        _proto.randomIdentifier = function randomIdentifier() {
            return Math.random().toString(16).substring(7);
        };
        return ButtonUtils;
    }();
    var buttonUtilsInstance = new ButtonUtils();
    var DialogUtils = /*#__PURE__*/ function() {
        function DialogUtils() {}
        var _proto = DialogUtils.prototype;
        _proto._maxDimension = function _maxDimension(val, maxPxVal) {
            var parsed = Util.stringToDimension(val);
            var parsedInt = parseInt(parsed, 10);
            var parsedMaxPxVal = parseInt(maxPxVal, 10);
            if (parsed.indexOf("%") > -1 && parsedInt >= 100 || // %
            parsedInt > parsedMaxPxVal) // px
            return "100%";
            return parsed;
        };
        _proto._closeOnEscape = function _closeOnEscape(options) {
            if (options.closeOnEscape === false) return false;
            else return true;
        };
        _proto._size = function _size(options) {
            var size = options.size;
            if (options.size === "x-large") size = "xlarge";
            if (options.size !== "maximum" && options.width === "100%" && options.height === "100%") size = "fullscreen";
            return size;
        };
        _proto._header = function _header(text) {
            var headerText = "";
            switch(typeof text){
                case "string":
                    headerText = text;
                    break;
                case "object":
                    headerText = text.value;
                    break;
            }
            return headerText;
        };
        _proto._hint = function _hint(text) {
            if (typeof text === "string") return text;
            return "";
        };
        _proto._chrome = function _chrome(options) {
            var returnval = false;
            if (typeof options.chrome === "boolean") returnval = options.chrome;
            if (options.size === "fullscreen") returnval = true;
            if (options.size === "maximum") returnval = false;
            return returnval;
        };
        _proto._width = function _width(options) {
            if (options.size) return undefined;
            if (options.width) return this._maxDimension(options.width, $(window).width());
            return "50%";
        };
        _proto._height = function _height(options) {
            if (options.size) return undefined;
            if (options.height) return this._maxDimension(options.height, $(window).height());
            return "50%";
        };
        _proto._actions = function _actions(options) {
            var sanitizedActions = [];
            options = options || {};
            if (!options.actions) sanitizedActions = [
                {
                    name: "submit",
                    identifier: "submit",
                    text: options.submitText || "Submit",
                    type: "primary",
                    disabled: true // disable submit button by default (until the dialog has loaded).
                },
                {
                    name: "cancel",
                    identifier: "cancel",
                    text: options.cancelText || "Cancel",
                    type: "link",
                    immutable: true
                }
            ];
            if (options.buttons) sanitizedActions = sanitizedActions.concat(this._buttons(options));
            return sanitizedActions;
        };
        _proto._id = function _id(str) {
            if (typeof str !== "string") str = Math.random().toString(36).substring(2, 8);
            return str;
        } // user defined action buttons
        ;
        _proto._buttons = function _buttons(options) {
            var buttons = [];
            if (options.buttons && Array.isArray(options.buttons)) options.buttons.forEach(function(button) {
                var text;
                var identifier;
                var disabled = false;
                if (button.text && typeof button.text === "string") text = button.text;
                if (button.identifier && typeof button.identifier === "string") identifier = button.identifier;
                else identifier = buttonUtilsInstance.randomIdentifier();
                if (button.disabled && button.disabled === true) disabled = true;
                buttons.push({
                    text: text,
                    identifier: identifier,
                    type: "secondary",
                    custom: true,
                    disabled: disabled
                });
            });
            return buttons;
        };
        _proto._onHide = function _onHide(options) {
            var noop = function noop() {};
            if (typeof options.onHide === "function") return options.onHide;
            else return noop;
        };
        _proto.sanitizeOptions = function sanitizeOptions(options) {
            options = options || {};
            var sanitized = {
                chrome: this._chrome(options),
                header: this._header(options.header),
                hint: this._hint(options.hint),
                width: this._width(options),
                height: this._height(options),
                $content: options.$content,
                extension: options.extension,
                actions: this._actions(options),
                id: this._id(options.id),
                size: options.size,
                closeOnEscape: this._closeOnEscape(options),
                onHide: this._onHide(options)
            };
            sanitized.size = this._size(sanitized);
            return sanitized;
        } // such a bad idea! this entire concept needs rewriting in the p2 plugin.
        ;
        _proto.moduleOptionsFromGlobal = function moduleOptionsFromGlobal(addon_key, key) {
            var defaultOptions = {
                chrome: true
            };
            if (window._AP && window._AP.dialogModules && window._AP.dialogModules[addon_key] && window._AP.dialogModules[addon_key][key]) return Util.extend({}, defaultOptions, window._AP.dialogModules[addon_key][key].options);
            return false;
        } // determines information about dialogs that are about to open and are already open
        ;
        _proto.trackMultipleDialogOpening = function trackMultipleDialogOpening(dialogExtension, options) {
            // check for dialogs that are already open
            var trackingDescription;
            var size = this._size(options);
            if ($(".ap-aui-dialog2:visible").length) {
                // am i in the confluence editor? first check for macro dialogs opened through macro browser, second is editing an existing macro
                if ($("#macro-browser-dialog").length || AJS.Confluence && AJS.Confluence.Editor && AJS.Confluence.Editor.currentEditMode) {
                    if (size === "fullscreen") trackingDescription = "connect-macro-multiple-fullscreen";
                    else trackingDescription = "connect-macro-multiple";
                } else trackingDescription = "connect-multiple";
                analytics.trackMultipleDialogOpening(trackingDescription, dialogExtension);
            }
        } // abstracts and handles a failure to find active dialog
        ;
        _proto.assertActiveDialogOrThrow = function assertActiveDialogOrThrow(dialogProvider, addon_key) {
            if (!dialogProvider.isActiveDialog(addon_key)) throw new Error("Failed to find an active dialog for: " + addon_key);
        };
        return DialogUtils;
    }();
    var dialogUtilsInstance = new DialogUtils();
    var IframeActions = {
        notifyIframeCreated: function notifyIframeCreated($el, extension) {
            EventDispatcher$1.dispatch("iframe-create", {
                $el: $el,
                extension: extension
            });
        },
        notifyBridgeEstablished: function notifyBridgeEstablished($el, extension) {
            EventDispatcher$1.dispatch("iframe-bridge-established", {
                $el: $el,
                extension: extension
            });
        },
        notifyIframeDestroyed: function notifyIframeDestroyed(filter) {
            if (typeof filter === "string") filter = {
                id: filter
            };
            var extensions = host.getExtensions(filter);
            extensions.forEach(function(extension) {
                EventDispatcher$1.dispatch("iframe-destroyed", {
                    extension: extension
                });
                host.unregisterExtension({
                    id: extension.extension_id
                });
            }, this);
        },
        notifyUnloaded: function notifyUnloaded($el, extension) {
            EventDispatcher$1.dispatch("iframe-unload", {
                $el: $el,
                extension: extension
            });
        }
    };
    var strictUriEncode = function(str) {
        return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
            return "%" + c.charCodeAt(0).toString(16).toUpperCase();
        });
    };
    function encoderForArrayFormat(opts) {
        switch(opts.arrayFormat){
            case "index":
                return function(key, value, index) {
                    return value === null ? [
                        encode(key, opts),
                        "[",
                        index,
                        "]"
                    ].join("") : [
                        encode(key, opts),
                        "[",
                        encode(index, opts),
                        "]=",
                        encode(value, opts)
                    ].join("");
                };
            case "bracket":
                return function(key, value) {
                    return value === null ? encode(key, opts) : [
                        encode(key, opts),
                        "[]=",
                        encode(value, opts)
                    ].join("");
                };
            default:
                return function(key, value) {
                    return value === null ? encode(key, opts) : [
                        encode(key, opts),
                        "=",
                        encode(value, opts)
                    ].join("");
                };
        }
    }
    function parserForArrayFormat(opts) {
        var result;
        switch(opts.arrayFormat){
            case "index":
                return function(key, value, accumulator) {
                    result = /\[(\d*)\]$/.exec(key);
                    key = key.replace(/\[\d*\]$/, "");
                    if (!result) {
                        accumulator[key] = value;
                        return;
                    }
                    if (accumulator[key] === undefined) accumulator[key] = {};
                    accumulator[key][result[1]] = value;
                };
            case "bracket":
                return function(key, value, accumulator) {
                    result = /(\[\])$/.exec(key);
                    key = key.replace(/\[\]$/, "");
                    if (!result) {
                        accumulator[key] = value;
                        return;
                    } else if (accumulator[key] === undefined) {
                        accumulator[key] = [
                            value
                        ];
                        return;
                    }
                    accumulator[key] = [].concat(accumulator[key], value);
                };
            default:
                return function(key, value, accumulator) {
                    if (accumulator[key] === undefined) {
                        accumulator[key] = value;
                        return;
                    }
                    accumulator[key] = [].concat(accumulator[key], value);
                };
        }
    }
    function encode(value, opts) {
        if (opts.encode) return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
        return value;
    }
    function keysSorter(input) {
        if (Array.isArray(input)) return input.sort();
        else if (typeof input === "object") return keysSorter(Object.keys(input)).sort(function(a, b) {
            return Number(a) - Number(b);
        }).map(function(key) {
            return input[key];
        });
        return input;
    }
    var extract = function(str) {
        return str.split("?")[1] || "";
    };
    var parse = function(str, opts) {
        opts = objectAssign({
            arrayFormat: "none"
        }, opts);
        var formatter = parserForArrayFormat(opts);
        // Create an object with no prototype
        // https://github.com/sindresorhus/query-string/issues/47
        var ret = Object.create(null);
        if (typeof str !== "string") return ret;
        str = str.trim().replace(/^(\?|#|&)/, "");
        if (!str) return ret;
        str.split("&").forEach(function(param) {
            var parts = param.replace(/\+/g, " ").split("=");
            // Firefox (pre 40) decodes `%3D` to `=`
            // https://github.com/sindresorhus/query-string/pull/37
            var key = parts.shift();
            var val = parts.length > 0 ? parts.join("=") : undefined;
            // missing `=` should be `null`:
            // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
            val = val === undefined ? null : decodeURIComponent(val);
            formatter(decodeURIComponent(key), val, ret);
        });
        return Object.keys(ret).sort().reduce(function(result, key) {
            var val = ret[key];
            if (Boolean(val) && typeof val === "object" && !Array.isArray(val)) // Sort object keys, not values
            result[key] = keysSorter(val);
            else result[key] = val;
            return result;
        }, Object.create(null));
    };
    var stringify = function(obj, opts) {
        var defaults = {
            encode: true,
            strict: true,
            arrayFormat: "none"
        };
        opts = objectAssign(defaults, opts);
        var formatter = encoderForArrayFormat(opts);
        return obj ? Object.keys(obj).sort().map(function(key) {
            var val = obj[key];
            if (val === undefined) return "";
            if (val === null) return encode(key, opts);
            if (Array.isArray(val)) {
                var result = [];
                val.slice().forEach(function(val2) {
                    if (val2 === undefined) return;
                    result.push(formatter(key, val2, result.length));
                });
                return result.join("&");
            }
            return encode(key, opts) + "=" + encode(val, opts);
        }).filter(function(x) {
            return x.length > 0;
        }).join("&") : "";
    };
    var queryString = {
        extract: extract,
        parse: parse,
        stringify: stringify
    };
    var toByteArray_1 = toByteArray;
    var lookup = [];
    var revLookup = [];
    var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
    var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    for(var i = 0, len = code.length; i < len; ++i){
        lookup[i] = code[i];
        revLookup[code.charCodeAt(i)] = i;
    } // Support decoding URL-safe base64 strings, as Node.js does.
    // See: https://en.wikipedia.org/wiki/Base64#URL_applications
    revLookup["-".charCodeAt(0)] = 62;
    revLookup["_".charCodeAt(0)] = 63;
    function getLens(b64) {
        var len = b64.length;
        if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
         // Trim off extra bytes after placeholder bytes are found
        // See: https://github.com/beatgammit/base64-js/issues/42
        var validLen = b64.indexOf("=");
        if (validLen === -1) validLen = len;
        var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
        return [
            validLen,
            placeHoldersLen
        ];
    } // base64 is 4/3 + up to two characters of the original data
    function _byteLength(b64, validLen, placeHoldersLen) {
        return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
    }
    function toByteArray(b64) {
        var tmp;
        var lens = getLens(b64);
        var validLen = lens[0];
        var placeHoldersLen = lens[1];
        var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
        var curByte = 0; // if there are placeholders, only get up to the last complete 4 chars
        var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
        for(var i = 0; i < len; i += 4){
            tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
            arr[curByte++] = tmp >> 16 & 0xFF;
            arr[curByte++] = tmp >> 8 & 0xFF;
            arr[curByte++] = tmp & 0xFF;
        }
        if (placeHoldersLen === 2) {
            tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
            arr[curByte++] = tmp & 0xFF;
        }
        if (placeHoldersLen === 1) {
            tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
            arr[curByte++] = tmp >> 8 & 0xFF;
            arr[curByte++] = tmp & 0xFF;
        }
        return arr;
    }
    var textEncoderLite = createCommonjsModule(function(module1) {
        function TextEncoderLite() {}
        function TextDecoderLite() {}
        (function() {
            // Thanks Feross et al! :-)
            function utf8ToBytes(string, units) {
                units = units || Infinity;
                var codePoint;
                var length = string.length;
                var leadSurrogate = null;
                var bytes = [];
                var i = 0;
                for(; i < length; i++){
                    codePoint = string.charCodeAt(i); // is surrogate component
                    if (codePoint > 0xD7FF && codePoint < 0xE000) {
                        // last char was a lead
                        if (leadSurrogate) {
                            // 2 leads in a row
                            if (codePoint < 0xDC00) {
                                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                leadSurrogate = codePoint;
                                continue;
                            } else {
                                // valid surrogate pair
                                codePoint = leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00 | 0x10000;
                                leadSurrogate = null;
                            }
                        } else {
                            // no lead yet
                            if (codePoint > 0xDBFF) {
                                // unexpected trail
                                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                continue;
                            } else if (i + 1 === length) {
                                // unpaired lead
                                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                                continue;
                            } else {
                                // valid lead
                                leadSurrogate = codePoint;
                                continue;
                            }
                        }
                    } else if (leadSurrogate) {
                        // valid bmp char, but last char was a lead
                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        leadSurrogate = null;
                    } // encode utf8
                    if (codePoint < 0x80) {
                        if ((units -= 1) < 0) break;
                        bytes.push(codePoint);
                    } else if (codePoint < 0x800) {
                        if ((units -= 2) < 0) break;
                        bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
                    } else if (codePoint < 0x10000) {
                        if ((units -= 3) < 0) break;
                        bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
                    } else if (codePoint < 0x200000) {
                        if ((units -= 4) < 0) break;
                        bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
                    } else throw new Error("Invalid code point");
                }
                return bytes;
            }
            function utf8Slice(buf, start, end) {
                var res = "";
                var tmp = "";
                end = Math.min(buf.length, end || Infinity);
                start = start || 0;
                for(var i = start; i < end; i++)if (buf[i] <= 0x7F) {
                    res += decodeUtf8Char(tmp) + String.fromCharCode(buf[i]);
                    tmp = "";
                } else tmp += "%" + buf[i].toString(16);
                return res + decodeUtf8Char(tmp);
            }
            function decodeUtf8Char(str) {
                try {
                    return decodeURIComponent(str);
                } catch (err) {
                    return String.fromCharCode(0xFFFD); // UTF 8 invalid char
                }
            }
            TextEncoderLite.prototype.encode = function(str) {
                var result;
                if ("undefined" === typeof Uint8Array) result = utf8ToBytes(str);
                else result = new Uint8Array(utf8ToBytes(str));
                return result;
            };
            TextDecoderLite.prototype.decode = function(bytes) {
                return utf8Slice(bytes, 0, bytes.length);
            };
        })();
        if (module1) {
            module1.exports.TextDecoderLite = TextDecoderLite;
            module1.exports.TextEncoderLite = TextEncoderLite;
        }
    });
    var textEncoderLite_1 = textEncoderLite.TextDecoderLite;
    var textEncoderLite_2 = textEncoderLite.TextEncoderLite;
    function decode(string) {
        var padding = 4 - string.length % 4;
        if (padding === 1) string += "=";
        else if (padding === 2) string += "==";
        return textEncoderLite_1.prototype.decode(toByteArray_1(string));
    }
    var JWT_SKEW = 60; // in seconds.
    function parseJwtIssuer(jwt) {
        return parseJwtClaims(jwt)["iss"];
    }
    function parseJwtClaims(jwt) {
        if (null === jwt || "" === jwt) throw "Invalid JWT: must be neither null nor empty-string.";
        var firstPeriodIndex = jwt.indexOf(".");
        var secondPeriodIndex = jwt.indexOf(".", firstPeriodIndex + 1);
        if (firstPeriodIndex < 0 || secondPeriodIndex <= firstPeriodIndex) throw 'Invalid JWT: must contain 2 period (".") characters.';
        var encodedClaims = jwt.substring(firstPeriodIndex + 1, secondPeriodIndex);
        if (null === encodedClaims || "" === encodedClaims) throw "Invalid JWT: encoded claims must be neither null nor empty-string.";
        var claimsString = decode.call(window, encodedClaims);
        return JSON.parse(claimsString);
    }
    function isJwtExpired(jwtString, skew) {
        if (skew === undefined) skew = JWT_SKEW;
        var claims = parseJwtClaims(jwtString);
        var expires = 0;
        var now = Math.floor(Date.now() / 1000); // UTC timestamp now
        if (claims && claims.exp) expires = claims.exp;
        if (expires - skew < now) return true;
        return false;
    }
    EventDispatcher$1.register("jwt-skew-set", function(data) {
        JWT_SKEW = data.skew;
    });
    var jwtUtil = {
        parseJwtIssuer: parseJwtIssuer,
        parseJwtClaims: parseJwtClaims,
        isJwtExpired: isJwtExpired
    };
    function isJwtExpired$1(urlStr) {
        var jwtStr = _getJwt(urlStr);
        return jwtUtil.isJwtExpired(jwtStr);
    }
    function _getJwt(urlStr) {
        var query = queryString.parse(queryString.extract(urlStr));
        return query["jwt"];
    }
    function hasJwt(url) {
        var jwt = _getJwt(url);
        return jwt && _getJwt(url).length !== 0;
    }
    var urlUtils = {
        hasJwt: hasJwt,
        isJwtExpired: isJwtExpired$1
    };
    var jwtActions = {
        registerContentResolver: function registerContentResolver(data) {
            EventDispatcher$1.dispatch("content-resolver-register-by-extension", data);
        },
        requestRefreshUrl: function requestRefreshUrl(data) {
            if (!data.resolver) throw Error("ACJS: No content resolver supplied");
            var promise = data.resolver.call(null, Util.extend({
                classifier: "json"
            }, data.extension));
            promise.fail(function(promiseData, error) {
                EventDispatcher$1.dispatch("jwt-url-refreshed-failed", {
                    extension: data.extension,
                    $container: data.$container,
                    errorText: error.text
                });
            });
            promise.done(function(promiseData) {
                var newExtensionConfiguration = {};
                if (typeof promiseData === "object") newExtensionConfiguration = promiseData;
                else if (typeof promiseData === "string") try {
                    newExtensionConfiguration = JSON.parse(promiseData);
                } catch (e) {
                    console.error("ACJS: invalid response from content resolver");
                }
                data.extension.url = newExtensionConfiguration.url;
                Util.extend(data.extension.options, newExtensionConfiguration.options);
                EventDispatcher$1.dispatch("jwt-url-refreshed", {
                    extension: data.extension,
                    $container: data.$container,
                    url: data.extension.url
                });
            });
            EventDispatcher$1.dispatch("jwt-url-refresh-request", {
                data: data
            });
        },
        setClockSkew: function setClockSkew(skew) {
            if (typeof skew === "number") EventDispatcher$1.dispatch("jwt-skew-set", {
                skew: skew
            });
            else console.error("ACJS: invalid JWT clock skew set");
        }
    };
    function getBooleanFeatureFlag(flagName) {
        if (AJS && AJS.DarkFeatures && AJS.DarkFeatures.isEnabled && AJS.DarkFeatures.isEnabled(flagName)) return true;
        var flagMeta = document.querySelector('meta[name="ajs-fe-feature-flags"]');
        if (!flagMeta) return false;
        var flagContent = flagMeta.getAttribute("content");
        if (!flagContent) return false;
        var flagJson = {};
        try {
            flagJson = JSON.parse(flagContent);
        } catch (err) {
            return false;
        }
        if (!flagJson[flagName] || typeof flagJson[flagName].value !== "boolean") return false;
        return flagJson[flagName].value;
    }
    var iframeUtils = {
        optionsToAttributes: function optionsToAttributes(options) {
            var sanitized = {};
            if (options && typeof options === "object") {
                if (options.width) sanitized.width = Util.stringToDimension(options.width);
                if (options.height) sanitized.height = Util.stringToDimension(options.height);
                if (typeof options.sandbox === "string") {
                    if (getBooleanFeatureFlag("com.atlassian.connect.acjs-sandbox-attr-check")) {
                        var domElem = document.createElement("iframe");
                        sanitized.sandbox = options.sandbox.split(" ").filter(function(value) {
                            return Util.isSupported(domElem, "sandbox", value, true);
                        }).join(" ");
                    } else {
                        sanitized.sandbox = options.sandbox; // No Firefox support: allow-top-navigation-by-user-activation
                        // https://bugzilla.mozilla.org/show_bug.cgi?id=1359867
                        if (window.navigator.userAgent.indexOf("Firefox") !== -1) sanitized.sandbox = sanitized.sandbox.replace("allow-top-navigation-by-user-activation", "allow-top-navigation");
                    }
                }
            }
            return sanitized;
        }
    };
    var ExtensionConfigurationOptionsStore = /*#__PURE__*/ function() {
        function ExtensionConfigurationOptionsStore() {
            this.store = {};
        }
        var _proto = ExtensionConfigurationOptionsStore.prototype;
        _proto.set = function set(obj, val) {
            if (val) {
                var toSet = {};
                toSet[obj] = val;
            } else toSet = obj;
            Util.extend(this.store, toSet);
        };
        _proto.get = function get(key) {
            if (key) return this.store[key];
            return Util.extend({}, this.store); //clone
        };
        return ExtensionConfigurationOptionsStore;
    }();
    var ExtensionConfigurationOptionsStore$1 = new ExtensionConfigurationOptionsStore();
    function createSimpleXdmExtension(extension) {
        var extensionConfig = extensionConfigSanitizer(extension);
        var systemExtensionConfigOptions = ExtensionConfigurationOptionsStore$1.get();
        extension.options = extensionConfig.options = Util.extend({}, extensionConfig.options);
        extension.options.globalOptions = systemExtensionConfigOptions;
        var iframeAttributes = host.create(extensionConfig, function() {
            if (!extension.options.noDOM) extension.$el = $(document.getElementById(extension.id));
            IframeActions.notifyBridgeEstablished(extension.$el, extension);
        }, function() {
            IframeActions.notifyUnloaded(extension.$el, extension);
        }); // HostApi destroy is relying on previous behaviour of the
        // iframe component wherein it would call simpleXDM.create(extension)
        // and then mutate the extension object with the id returned from the
        // iframeAttributes see changes made in ACJS-760 and ACJS-807
        extensionConfig.id = iframeAttributes.id;
        extension.id = iframeAttributes.id;
        Util.extend(iframeAttributes, iframeUtils.optionsToAttributes(extension.options));
        return {
            iframeAttributes: iframeAttributes,
            extension: extension
        };
    }
    function extensionConfigSanitizer(extension) {
        return {
            addon_key: extension.addon_key,
            key: extension.key,
            url: extension.url,
            options: extension.options
        };
    }
    var simpleXdmUtils = {
        createSimpleXdmExtension: createSimpleXdmExtension,
        extensionConfigSanitizer: extensionConfigSanitizer
    };
    var Iframe = /*#__PURE__*/ function() {
        function Iframe() {
            this._contentResolver = false;
        }
        var _proto = Iframe.prototype;
        _proto.setContentResolver = function setContentResolver(callback) {
            this._contentResolver = callback;
        };
        _proto.resize = function resize(width, height, $el) {
            width = Util.stringToDimension(width);
            height = Util.stringToDimension(height);
            $el.css({
                width: width,
                height: height
            });
            $el.trigger("resized", {
                width: width,
                height: height
            });
        };
        _proto.simpleXdmExtension = function simpleXdmExtension(extension, $container) {
            if (!extension.url || urlUtils.hasJwt(extension.url) && urlUtils.isJwtExpired(extension.url)) {
                if (this._contentResolver) jwtActions.requestRefreshUrl({
                    extension: extension,
                    resolver: this._contentResolver,
                    $container: $container
                });
                else console.error("JWT is expired and no content resolver was specified");
            } else this._appendExtension($container, this._simpleXdmCreate(extension));
        };
        _proto._simpleXdmCreate = function _simpleXdmCreate(extension) {
            var simpleXdmAttributes = simpleXdmUtils.createSimpleXdmExtension(extension);
            extension.id = simpleXdmAttributes.iframeAttributes.id;
            extension.$el = this.render(simpleXdmAttributes.iframeAttributes);
            return extension;
        };
        _proto._appendExtension = function _appendExtension($container, extension) {
            var existingFrame = $container.find("iframe");
            if (existingFrame.length > 0) existingFrame.destroy();
            if (extension.options.hideIframeUntilLoad) extension.$el.css({
                visibility: "hidden"
            }).load(function() {
                extension.$el.css({
                    visibility: ""
                });
            });
            $container.prepend(extension.$el);
            IframeActions.notifyIframeCreated(extension.$el, extension);
        };
        _proto._appendExtensionError = function _appendExtensionError($container, text) {
            var $error = $('<div class="connect-resolve-error"></div>');
            var $additionalText = $("<p />").text(text);
            $error.append('<p class="error">Error: The content resolver threw the following error:</p>');
            $error.append($additionalText);
            $container.prepend($error);
        };
        _proto.resolverResponse = function resolverResponse(data) {
            var simpleExtension = this._simpleXdmCreate(data.extension);
            this._appendExtension(data.$container, simpleExtension);
        };
        _proto.resolverFailResponse = function resolverFailResponse(data) {
            this._appendExtensionError(data.$container, data.errorText);
        };
        _proto.render = function render(attributes) {
            attributes = attributes || {};
            attributes.referrerpolicy = "no-referrer";
            return $("<iframe />").attr(attributes).addClass("ap-iframe");
        };
        return Iframe;
    }();
    var IframeComponent = new Iframe();
    EventDispatcher$1.register("iframe-resize", function(data) {
        IframeComponent.resize(data.width, data.height, data.$el);
    });
    EventDispatcher$1.register("content-resolver-register-by-extension", function(data) {
        IframeComponent.setContentResolver(data.callback);
    });
    EventDispatcher$1.register("jwt-url-refreshed", function(data) {
        IframeComponent.resolverResponse(data);
    });
    EventDispatcher$1.register("jwt-url-refreshed-failed", function(data) {
        IframeComponent.resolverFailResponse(data);
    });
    EventDispatcher$1.register("after:iframe-bridge-established", function(data) {
        if (!data.extension.options.noDom) data.$el[0].bridgeEstablished = true;
        else data.extension.options.bridgeEstablished = true;
    });
    var ButtonActions = {
        clicked: function clicked($el) {
            EventDispatcher$1.dispatch("button-clicked", {
                $el: $el
            });
        },
        toggle: function toggle($el, disabled) {
            EventDispatcher$1.dispatch("button-toggle", {
                $el: $el,
                disabled: disabled
            });
        },
        toggleVisibility: function toggleVisibility($el, hidden) {
            EventDispatcher$1.dispatch("button-toggle-visibility", {
                $el: $el,
                hidden: hidden
            });
        }
    };
    var BUTTON_TYPES = [
        "primary",
        "link",
        "secondary"
    ];
    var buttonId = 0;
    var Button = /*#__PURE__*/ function() {
        function Button() {
            this.AP_BUTTON_CLASS = "ap-aui-button";
        }
        var _proto = Button.prototype;
        _proto.setType = function setType($button, type) {
            if (type && BUTTON_TYPES.indexOf(type) >= 0) $button.addClass("aui-button-" + type);
            return $button;
        };
        _proto.setDisabled = function setDisabled($button, disabled) {
            if (typeof disabled !== "undefined" && !$button.data("immutable")) $button.attr("aria-disabled", disabled);
            return $button;
        };
        _proto.setHidden = function setHidden($button, hidden) {
            if (typeof hidden !== "undefined" && !$button.data("immutable")) $button.toggle(!hidden);
            return $button;
        };
        _proto._setId = function _setId($button, id) {
            if (!id) {
                id = "ap-button-" + buttonId;
                buttonId++;
            }
            $button.attr("id", id);
            return $button;
        };
        _proto._additionalClasses = function _additionalClasses($button, classes) {
            if (classes) {
                if (typeof classes !== "string") classes = classes.join(" ");
                $button.addClass(classes);
            }
            return $button;
        };
        _proto.getName = function getName($button) {
            return $($button).data("name");
        };
        _proto.getText = function getText($button) {
            return $($button).text();
        };
        _proto.getIdentifier = function getIdentifier($button) {
            return $($button).data("identifier");
        };
        _proto.isVisible = function isVisible($button) {
            return $($button).is(":visible");
        };
        _proto.isEnabled = function isEnabled($button) {
            return !($($button).attr("aria-disabled") === "true");
        };
        _proto.render = function render(options) {
            var $button = $("<button />");
            options = options || {};
            $button.addClass("aui-button " + this.AP_BUTTON_CLASS);
            $button.text(options.text);
            $button.data(options.data);
            $button.data({
                name: options.name || options.identifier,
                identifier: options.identifier || buttonUtilsInstance.randomIdentifier(),
                immutable: options.immutable || false
            });
            this._additionalClasses($button, options.additionalClasses);
            this.setType($button, options.type);
            this.setDisabled($button, options.disabled || false);
            this._setId($button, options.id);
            return $button;
        };
        return Button;
    }();
    var ButtonComponent = new Button(); // register 1 button listener globally on dom load
    $(function() {
        $("body").on("click", "." + ButtonComponent.AP_BUTTON_CLASS, function(e) {
            var $button = $(e.target).closest("." + ButtonComponent.AP_BUTTON_CLASS);
            if ($button.attr("aria-disabled") !== "true") ButtonActions.clicked($button);
        });
    });
    EventDispatcher$1.register("button-toggle", function(data) {
        ButtonComponent.setDisabled(data.$el, data.disabled);
    });
    EventDispatcher$1.register("button-toggle-visibility", function(data) {
        ButtonComponent.setHidden(data.$el, data.hidden);
    });
    var CONTAINER_CLASSES = [
        "ap-iframe-container"
    ];
    var IframeContainer = /*#__PURE__*/ function() {
        function IframeContainer() {}
        var _proto = IframeContainer.prototype;
        _proto.createExtension = function createExtension(extension, options) {
            var $container = this._renderContainer();
            if (!options || options.loadingIndicator !== false) $container.append(this._renderLoadingIndicator());
            IframeComponent.simpleXdmExtension(extension, $container);
            return $container;
        };
        _proto._renderContainer = function _renderContainer(attributes) {
            var container = $("<div />").attr(attributes || {});
            container.addClass(CONTAINER_CLASSES.join(" "));
            return container;
        };
        _proto._renderLoadingIndicator = function _renderLoadingIndicator() {
            return LoadingComponent.render();
        };
        return IframeContainer;
    }();
    var IframeContainerComponent = new IframeContainer();
    EventDispatcher$1.register("iframe-create", function(data) {
        var id = "embedded-" + data.extension.id;
        data.extension.$el.parents(".ap-iframe-container").attr("id", id);
    });
    function create(extension) {
        return IframeContainerComponent.createExtension(extension);
    }
    var ModuleActions = {
        defineCustomModule: function defineCustomModule(name, methods) {
            var data = {};
            if (!methods) data.methods = name;
            else {
                data.methods = methods;
                data.name = name;
            }
            EventDispatcher$1.dispatch("module-define-custom", data);
        }
    };
    var AnalyticsAction = {
        trackDeprecatedMethodUsed: function trackDeprecatedMethodUsed(methodUsed, extension) {
            EventDispatcher$1.dispatch("analytics-deprecated-method-used", {
                methodUsed: methodUsed,
                extension: extension
            });
        },
        trackIframeBridgeStart: function trackIframeBridgeStart(extension) {
            EventDispatcher$1.dispatch("iframe-bridge-start", {
                extension: extension
            });
        },
        trackExternalEvent: function trackExternalEvent(name, values) {
            EventDispatcher$1.dispatch("analytics-external-event-track", {
                eventName: name,
                values: values
            });
        }
    };
    function sanitizeTriggers(triggers) {
        var onTriggers;
        if (Array.isArray(triggers)) onTriggers = triggers.join(" ");
        else if (typeof triggers === "string") onTriggers = triggers.trim();
        return onTriggers;
    }
    function uniqueId() {
        return "webitem-" + Math.floor(Math.random() * 1000000000).toString(16);
    } // LEGACY: get addon key by webitem for p2
    function getExtensionKey($target) {
        var cssClass = $target.attr("class");
        var m = cssClass ? cssClass.match(/ap-plugin-key-([^\s]*)/) : null;
        return Array.isArray(m) ? m[1] : false;
    } // LEGACY: get module key by webitem for p2
    function getKey($target) {
        var cssClass = $target.attr("class");
        var m = cssClass ? cssClass.match(/ap-module-key-([^\s]*)/) : null;
        return Array.isArray(m) ? m[1] : false;
    }
    function getTargetKey($target) {
        var cssClass = $target.attr("class");
        var m = cssClass ? cssClass.match(/ap-target-key-([^\s]*)/) : null;
        return Array.isArray(m) ? m[1] : false;
    }
    function getFullKey($target) {
        return getExtensionKey($target) + "__" + getKey($target);
    }
    function getModuleOptionsByAddonAndModuleKey(type, addonKey, moduleKey) {
        var moduleType = type + "Modules";
        if (window._AP && window._AP[moduleType] && window._AP[moduleType][addonKey] && window._AP[moduleType][addonKey][moduleKey]) return Util.extend({}, window._AP[moduleType][addonKey][moduleKey].options);
    }
    function getModuleOptionsForWebitem(type, $target) {
        var addon_key = getExtensionKey($target);
        var targetKey = getTargetKey($target);
        return getModuleOptionsByAddonAndModuleKey(type, addon_key, targetKey);
    } //gets the connect config from the encoded webitem target (via the url)
    function getConfigFromTarget($target) {
        var url = $target.attr("href");
        var convertedOptions = {};
        var iframeData; // adg3 has classes outside of a tag so look for href inside the a
        if (!url) url = $target.find("a").attr("href");
        if (url) {
            var hashIndex = url.indexOf("#");
            if (hashIndex >= 0) {
                var hash = url.substring(hashIndex + 1);
                try {
                    iframeData = JSON.parse(decodeURI(hash));
                } catch (e) {
                    console.error("ACJS: cannot decode webitem anchor");
                }
                if (iframeData && window._AP && window._AP._convertConnectOptions) convertedOptions = window._AP._convertConnectOptions(iframeData);
                else console.error("ACJS: cannot convert webitem url to connect iframe options");
            } else {
                // The URL has no hash component so fall back to the old behaviour of providing:
                // add-on key, module key, dialog module options and product context (from the webitem url).
                // This may be the case for web items that were persisted prior to the new storage format whereby a hash
                // fragment is added into the URL detailing the target module info. If this info is
                // not present, the content resolver will be used to resolve the module after the web
                // item is clicked.
                // Old URL format detected. Falling back to old functionality
                var fullKey = getFullKey($target);
                var type = $target.hasClass("ap-inline-dialog") ? "inlineDialog" : "dialog";
                var options = getModuleOptionsForWebitem(type, $target);
                if (!options && window._AP && window._AP[type + "Options"]) options = Util.extend({}, window._AP[type + "Options"][fullKey]) || {};
                if (!options) {
                    options = {};
                    console.warn("no webitem " + type + "Options for " + fullKey);
                }
                options.productContext = options.productContext || {};
                var query = queryString.parse(queryString.extract(url));
                Util.extend(options.productContext, query);
                convertedOptions = {
                    addon_key: getExtensionKey($target),
                    key: getKey($target),
                    options: options
                };
            }
        }
        return convertedOptions;
    } // LEGACY - method for handling webitem options for p2
    function getOptionsForWebItem($target) {
        var fullKey = getFullKey($target);
        var type = $target.hasClass("ap-inline-dialog") ? "inlineDialog" : "dialog";
        var options = getModuleOptionsForWebitem(type, $target);
        if (!options && window._AP && window._AP[type + "Options"]) options = Util.extend({}, window._AP[type + "Options"][fullKey]) || {};
        if (!options) {
            options = {};
            console.warn("no webitem " + type + "Options for " + fullKey);
        }
        options.productContext = options.productContext || {};
        options.structuredContext = options.structuredContext || {}; // create product context from url params
        var convertedConfig = getConfigFromTarget($target);
        if (convertedConfig && convertedConfig.options) {
            Util.extend(options.productContext, convertedConfig.options.productContext);
            Util.extend(options.structuredContext, convertedConfig.options.structuredContext);
            options.contextJwt = convertedConfig.options.contextJwt;
        }
        return options;
    }
    var WebItemUtils = {
        sanitizeTriggers: sanitizeTriggers,
        uniqueId: uniqueId,
        getExtensionKey: getExtensionKey,
        getKey: getKey,
        getOptionsForWebItem: getOptionsForWebItem,
        getModuleOptionsByAddonAndModuleKey: getModuleOptionsByAddonAndModuleKey,
        getConfigFromTarget: getConfigFromTarget
    };
    var ModuleProviders = function ModuleProviders() {
        var _this = this;
        this._providers = {};
        this.registerProvider = function(name, provider) {
            _this._providers[name] = provider;
        };
        this.getProvider = function(name) {
            return _this._providers[name];
        };
    };
    var ModuleProviders$1 = new ModuleProviders();
    // This is essentially a copy of the ACJSFrameworkAdaptor/BaseFrameworkAdaptor implementation generated
    // by compiling the connect-module-core typescript implementations of the equivalent classes.
    /**
   * This class provides common behaviour relating to the adaption of functionality to a
   * particular Connect client framework. This is necessary for an interim period during which
   * we have multiple Connect client frameworks that we need to support: ACJS and CaaS Client.
   */ var ACJSFrameworkAdaptor = function() {
        function ACJSFrameworkAdaptor() {
            this.moduleNamesToModules = new Map();
        }
        /**
     * This method registers a module with the Connect client framework relating to this adaptor instance.
     * @param moduleDefinition the definition of the module.
     */ ACJSFrameworkAdaptor.prototype.registerModule = function(module1, props) {
            var moduleRegistrationName = module1.getModuleRegistrationName();
            this.moduleNamesToModules.set(moduleRegistrationName, module1); // This adaptor implementation doesn't need to register the SimpleXDM definition so the following is
        // commented out.
        //
        // var simpleXdmDefinition = module.getSimpleXdmDefinition(props);
        // this.registerModuleWithHost(moduleRegistrationName, simpleXdmDefinition);
        };
        ACJSFrameworkAdaptor.prototype.getModuleByName = function(moduleName) {
            return this.moduleNamesToModules.get(moduleName);
        };
        ACJSFrameworkAdaptor.prototype.getProviderByModuleName = function(moduleName) {
            var module1 = this.moduleNamesToModules.get(moduleName);
            if (module1 && module1.isEnabled()) return module1.getProvider();
            else return undefined;
        };
        return ACJSFrameworkAdaptor;
    }();
    var acjsFrameworkAdaptor = new ACJSFrameworkAdaptor();
    var HostApi = /*#__PURE__*/ function() {
        function HostApi() {
            var _this = this;
            this.create = function(extension) {
                return create(simpleXdmUtils.extensionConfigSanitizer(extension));
            };
            this.dialog = {
                create: function create(extension, dialogOptions) {
                    var dialogBeanOptions = WebItemUtils.getModuleOptionsByAddonAndModuleKey("dialog", extension.addon_key, extension.key);
                    var completeOptions = Util.extend({}, dialogBeanOptions || {}, dialogOptions);
                    DialogExtensionActions.open(extension, completeOptions);
                },
                close: function close(addon_key, closeData) {
                    var frameworkAdaptor = _this.getFrameworkAdaptor();
                    var dialogProvider = frameworkAdaptor.getProviderByModuleName("dialog");
                    if (dialogProvider) {
                        dialogUtilsInstance.assertActiveDialogOrThrow(dialogProvider, addon_key);
                        EventActions.broadcast("dialog.close", {
                            addon_key: addon_key
                        }, closeData);
                        dialogProvider.close();
                    } else DialogExtensionActions.close();
                }
            };
            this.registerContentResolver = {
                resolveByExtension: function resolveByExtension(callback) {
                    _this._contentResolver = callback;
                    jwtActions.registerContentResolver({
                        callback: callback
                    });
                }
            };
            this.getContentResolver = function() {
                return _this._contentResolver;
            };
            this.registerProvider = function(componentName, component) {
                ModuleProviders$1.registerProvider(componentName, component);
            };
            this.getProvider = function(componentName) {
                return ModuleProviders$1.getProvider(componentName);
            }; // We are attaching an instance of ACJSAdaptor to the host so that products are able
            // to retrieve the identical instance of ACJSAdaptor that ACJS is using.
            // The product can override the framework adaptor by calling setFrameworkAdaptor().
            this.frameworkAdaptor = acjsFrameworkAdaptor;
        }
        /**
    * creates an extension
    * returns an object with extension and iframe attributes
    * designed for use with non DOM implementations such as react.
    */ var _proto = HostApi.prototype;
        _proto.createExtension = function createExtension(extension) {
            extension.options = extension.options || {};
            extension.options.noDom = true;
            var createdExtension = simpleXdmUtils.createSimpleXdmExtension(extension);
            AnalyticsAction.trackIframeBridgeStart(createdExtension.extension);
            return createdExtension;
        } /**
     * The product is responsible for setting the framework adaptor.
     * @param frameworkAdaptor the framework adaptor to use.
     */ ;
        _proto.setFrameworkAdaptor = function setFrameworkAdaptor(frameworkAdaptor) {
            this.frameworkAdaptor = frameworkAdaptor;
        };
        _proto.getFrameworkAdaptor = function getFrameworkAdaptor() {
            return this.frameworkAdaptor;
        };
        _proto._cleanExtension = function _cleanExtension(extension) {
            return Util.pick(extension, [
                "id",
                "addon_key",
                "key",
                "options",
                "url"
            ]);
        };
        _proto.onIframeEstablished = function onIframeEstablished(callback) {
            var wrapper = function wrapper(data) {
                callback.call({}, {
                    $el: data.$el,
                    extension: this._cleanExtension(data.extension)
                });
            };
            callback._wrapper = wrapper.bind(this);
            EventDispatcher$1.register("after:iframe-bridge-established", callback._wrapper);
        };
        _proto.offIframeEstablished = function offIframeEstablished(callback) {
            if (callback._wrapper) EventDispatcher$1.unregister("after:iframe-bridge-established", callback._wrapper);
            else throw new Error("cannot unregister event dispatch listener without _wrapper reference");
        };
        _proto.onIframeUnload = function onIframeUnload(callback) {
            var _this2 = this;
            EventDispatcher$1.register("after:iframe-unload", function(data) {
                callback.call({}, {
                    $el: data.$el,
                    extension: _this2._cleanExtension(data.extension)
                });
            });
        };
        _proto.onPublicEventDispatched = function onPublicEventDispatched(callback) {
            var wrapper = function wrapper(data) {
                callback.call({}, {
                    type: data.type,
                    event: data.event,
                    extension: this._cleanExtension(data.sender)
                });
            };
            callback._wrapper = wrapper.bind(this);
            EventDispatcher$1.register("after:event-public-dispatch", callback._wrapper);
        };
        _proto.offPublicEventDispatched = function offPublicEventDispatched(callback) {
            if (callback._wrapper) EventDispatcher$1.unregister("after:event-public-dispatch", callback._wrapper);
            else throw new Error("cannot unregister event dispatch listener without _wrapper reference");
        };
        _proto.onKeyEvent = function onKeyEvent(extension_id, key, modifiers, callback) {
            DomEventActions.registerKeyEvent({
                extension_id: extension_id,
                key: key,
                modifiers: modifiers,
                callback: callback
            });
        };
        _proto.offKeyEvent = function offKeyEvent(extension_id, key, modifiers, callback) {
            DomEventActions.unregisterKeyEvent({
                extension_id: extension_id,
                key: key,
                modifiers: modifiers,
                callback: callback
            });
        };
        _proto.onFrameClick = function onFrameClick(handleIframeClick) {
            if (typeof handleIframeClick !== "function") throw new Error("handleIframeClick must be a function");
            DomEventActions.registerClickHandler(handleIframeClick);
        };
        _proto.offFrameClick = function offFrameClick() {
            DomEventActions.unregisterClickHandler();
        };
        _proto.destroy = function destroy(extension_id) {
            IframeActions.notifyIframeDestroyed({
                id: extension_id
            });
        };
        _proto.defineModule = function defineModule(name, methods) {
            ModuleActions.defineCustomModule(name, methods);
        };
        _proto.isModuleDefined = function isModuleDefined(moduleName) {
            return host.isModuleDefined(moduleName);
        };
        _proto.broadcastEvent = function broadcastEvent(type, targetSpec, event) {
            EventActions.broadcast(type, targetSpec, event);
        };
        _proto.getExtensions = function getExtensions(filter) {
            return host.getExtensions(filter);
        };
        _proto.trackDeprecatedMethodUsed = function trackDeprecatedMethodUsed(methodUsed, extension) {
            AnalyticsAction.trackDeprecatedMethodUsed(methodUsed, extension);
        };
        _proto.trackAnalyticsEvent = function trackAnalyticsEvent(name, values) {
            AnalyticsAction.trackExternalEvent(name, values);
        };
        _proto.setJwtClockSkew = function setJwtClockSkew(skew) {
            jwtActions.setClockSkew(skew);
        };
        _proto.isJwtExpired = function isJwtExpired(jwtString, tokenOnly) {
            if (tokenOnly) return jwtUtil.isJwtExpired(jwtString);
            return urlUtils.isJwtExpired(jwtString);
        };
        _proto.hasJwt = function hasJwt(url) {
            return urlUtils.hasJwt(url);
        };
        _proto.getBooleanFeatureFlag = function getBooleanFeatureFlag$1(flagName) {
            return getBooleanFeatureFlag(flagName);
        } // set configuration option system wide for all extensions
        ;
        _proto.setExtensionConfigurationOptions = function setExtensionConfigurationOptions(obj, value) {
            ExtensionConfigurationOptionsStore$1.set(obj, value);
        };
        _proto.getExtensionConfigurationOption = function getExtensionConfigurationOption(val) {
            return ExtensionConfigurationOptionsStore$1.get(val);
        };
        return HostApi;
    }();
    var HostApi$1 = new HostApi();
    var DLGID_PREFIX = "ap-dialog-";
    var DIALOG_CLASS = "ap-aui-dialog2";
    var DLGID_REGEXP = new RegExp("^" + DLGID_PREFIX + "[0-9A-Za-z]+$");
    var DIALOG_SIZES = [
        "small",
        "medium",
        "large",
        "xlarge",
        "fullscreen",
        "maximum"
    ];
    var DIALOG_BUTTON_CLASS = "ap-aui-dialog-button";
    var DIALOG_BUTTON_CUSTOM_CLASS = "ap-dialog-custom-button";
    var DIALOG_FOOTER_CLASS = "aui-dialog2-footer";
    var DIALOG_FOOTER_ACTIONS_CLASS = "aui-dialog2-footer-actions";
    var DIALOG_HEADER_ACTIONS_CLASS = "header-control-panel";
    function getActiveDialog() {
        var $el = AJS.LayerManager.global.getTopLayer();
        if ($el && DLGID_REGEXP.test($el.attr("id"))) {
            var dialog = AJS.dialog2($el);
            dialog._id = dialog.$el.attr("id").replace(DLGID_PREFIX, "");
            return dialog;
        }
    }
    function getActionBar($dialog) {
        var $actionBar = $dialog.find("." + DIALOG_HEADER_ACTIONS_CLASS);
        if (!$actionBar.length) $actionBar = $dialog.find("." + DIALOG_FOOTER_ACTIONS_CLASS);
        return $actionBar;
    }
    function getButtonByIdentifier(id, $dialog) {
        var $actionBar = getActionBar($dialog);
        return $actionBar.find(".aui-button").filter(function() {
            return ButtonComponent.getIdentifier(this) === id;
        });
    }
    var Dialog = /*#__PURE__*/ function() {
        function Dialog() {}
        var _proto = Dialog.prototype;
        _proto._renderHeaderCloseBtn = function _renderHeaderCloseBtn() {
            var $close = $("<a />").addClass("aui-dialog2-header-close");
            var $closeBtn = $("<span />").addClass("aui-icon aui-icon-small aui-iconfont-close-dialog").text("Close");
            $close.append($closeBtn);
            return $close;
        } //v3 ask DT about this DOM.
        ;
        _proto._renderFullScreenHeader = function _renderFullScreenHeader($header, options) {
            var $titleContainer = $("<div />").addClass("header-title-container aui-item expanded");
            var $title = $("<div />").append($("<span />").addClass("header-title").text(options.header || ""));
            $titleContainer.append($title);
            $header.append($titleContainer).append(this._renderHeaderActions(options.actions, options.extension));
            return $header;
        };
        _proto._renderHeader = function _renderHeader(options) {
            var $header = $("<header />").addClass("aui-dialog2-header");
            if (options.size === "fullscreen") return this._renderFullScreenHeader($header, options);
            if (options.header) {
                var $title = $("<h2 />").addClass("aui-dialog2-header-main").text(options.header);
                $header.append($title);
            }
            $header.append(this._renderHeaderCloseBtn());
            return $header;
        };
        _proto._renderHeaderActions = function _renderHeaderActions(actions, extension) {
            var $headerControls = $("<div />").addClass("aui-item " + DIALOG_HEADER_ACTIONS_CLASS);
            actions[0].additionalClasses = [
                "aui-icon",
                "aui-icon-small",
                "aui-iconfont-success"
            ];
            actions[1].additionalClasses = [
                "aui-icon",
                "aui-icon-small",
                "aui-iconfont-close-dialog"
            ];
            var $actions = this._renderActionButtons(actions, extension);
            $actions.forEach(function($action) {
                $headerControls.append($action);
            });
            return $headerControls;
        };
        _proto._renderContent = function _renderContent($content) {
            var $el = $("<div />").addClass("aui-dialog2-content");
            if ($content) $el.append($content);
            return $el;
        };
        _proto._renderFooter = function _renderFooter(options) {
            var $footer = $("<footer />").addClass(DIALOG_FOOTER_CLASS);
            if (options.size !== "fullscreen") {
                var $actions = this._renderFooterActions(options.actions, options.extension);
                $footer.append($actions);
            }
            if (options.hint) {
                var $hint = $("<div />").addClass("aui-dialog2-footer-hint").text(options.hint);
                $footer.append($hint);
            }
            return $footer;
        };
        _proto._renderActionButtons = function _renderActionButtons(actions, extension) {
            var _this = this;
            var actionButtons = [];
            [].concat(actions).forEach(function(action) {
                actionButtons.push(_this._renderDialogButton({
                    text: action.text,
                    name: action.name,
                    type: action.type,
                    additionalClasses: action.additionalClasses,
                    custom: action.custom || false,
                    identifier: action.identifier,
                    immutable: action.immutable,
                    disabled: action.disabled || false
                }, extension));
            });
            return actionButtons;
        };
        _proto._renderFooterActions = function _renderFooterActions(actions, extension) {
            var $actions = $("<div />").addClass(DIALOG_FOOTER_ACTIONS_CLASS);
            var $buttons = this._renderActionButtons(actions, extension);
            $buttons.forEach(function($button) {
                $actions.append($button);
            });
            return $actions;
        };
        _proto._renderDialogButton = function _renderDialogButton(options, extension) {
            options.additionalClasses = options.additionalClasses || [];
            options.additionalClasses.push(DIALOG_BUTTON_CLASS);
            if (options.custom) options.additionalClasses.push(DIALOG_BUTTON_CUSTOM_CLASS);
            var $button = ButtonComponent.render(options);
            $button.extension = extension;
            return $button;
        } /**
    {
      id: 'some-dialog-id',
      title: 'some header',
      hint: 'some footer hint',
      $content: $(<div />).text('my content'),
      actions: []
    }
    **/ ;
        _proto.render = function render(options) {
            var originalOptions = Util.extend({}, options);
            var sanitizedOptions = dialogUtilsInstance.sanitizeOptions(options);
            var $dialog = $("<section />").attr({
                role: "dialog",
                id: DLGID_PREFIX + sanitizedOptions.id
            });
            $dialog.attr("data-aui-modal", "true");
            $dialog.data({
                "aui-remove-on-hide": true,
                "extension": sanitizedOptions.extension
            });
            $dialog.addClass("aui-layer aui-dialog2 " + DIALOG_CLASS);
            if (DIALOG_SIZES.indexOf(sanitizedOptions.size) >= 0) $dialog.addClass("aui-dialog2-" + sanitizedOptions.size);
            if (sanitizedOptions.size === "fullscreen" || sanitizedOptions.size === "maximum") {
                if (sanitizedOptions.chrome) $dialog.addClass("ap-header-controls");
                $dialog.addClass("aui-dialog2-maximum");
            }
            $dialog.append(this._renderContent(sanitizedOptions.$content));
            if (sanitizedOptions.chrome) {
                $dialog.prepend(this._renderHeader({
                    header: sanitizedOptions.header,
                    actions: sanitizedOptions.actions,
                    size: sanitizedOptions.size
                }));
                $dialog.append(this._renderFooter({
                    extension: sanitizedOptions.extension,
                    actions: sanitizedOptions.actions,
                    hint: sanitizedOptions.hint,
                    size: sanitizedOptions.size
                }));
            } else $dialog.addClass("aui-dialog2-chromeless");
            var dialog = AJS.dialog2($dialog);
            dialog._id = sanitizedOptions.id;
            if (sanitizedOptions.size === "fullscreen") sanitizedOptions.height = sanitizedOptions.width = "100%";
            if (!sanitizedOptions.size || sanitizedOptions.size === "fullscreen") AJS.layer($dialog).changeSize(sanitizedOptions.width, sanitizedOptions.height);
            if (sanitizedOptions.onHide) dialog.on("hide", sanitizedOptions.onHide);
            dialog.show();
            dialog.$el.data("extension", sanitizedOptions.extension);
            dialog.$el.data("originalOptions", originalOptions);
            return $dialog;
        };
        _proto.setIframeDimensions = function setIframeDimensions($iframe) {
            IframeComponent.resize("100%", "100%", $iframe);
        };
        _proto.getActive = function getActive() {
            return getActiveDialog();
        };
        _proto.buttonIsEnabled = function buttonIsEnabled(identifier) {
            var dialog = getActiveDialog();
            if (dialog) {
                var $button = getButtonByIdentifier(identifier, dialog.$el);
                return ButtonComponent.isEnabled($button);
            }
        };
        _proto.buttonIsVisible = function buttonIsVisible(identifier) {
            var dialog = getActiveDialog();
            if (dialog) {
                var $button = getButtonByIdentifier(identifier, dialog.$el);
                return ButtonComponent.isVisible($button);
            }
        } /**
    * takes either a target spec or a filter function
    * returns all matching dialogs
    */ ;
        _proto.getByExtension = function getByExtension(extension) {
            var filterFunction;
            if (typeof extension === "function") filterFunction = extension;
            else {
                var keys = Object.getOwnPropertyNames(extension);
                filterFunction = function filterFunction(dialog) {
                    var dialogData = $(dialog).data("extension");
                    return keys.every(function(key) {
                        return dialogData[key] === extension[key];
                    });
                };
            }
            return $("." + DIALOG_CLASS).toArray().filter(filterFunction).map(function($el) {
                return AJS.dialog2($el);
            });
        } // add user defined button to an existing dialog
        ;
        _proto.addButton = function addButton(extension, options) {
            options.custom = true;
            var $button = this._renderDialogButton(options, extension);
            var $dialog = this.getByExtension({
                addon_key: extension.addon_key,
                key: extension.key
            })[0].$el;
            var $actionBar = getActionBar($dialog);
            $actionBar.append($button);
            return $dialog;
        };
        return Dialog;
    }();
    var DialogComponent = new Dialog();
    EventDispatcher$1.register("iframe-bridge-established", function(data) {
        if (data.extension.options.isDialog) {
            var callback;
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dialogProvider = frameworkAdaptor.getProviderByModuleName("dialog");
            if (dialogProvider) {
                callback = dialogProvider.close;
                dialogProvider.setButtonDisabled("submit", false);
            } else {
                DialogActions.toggleButton({
                    identifier: "submit",
                    enabled: true
                });
                callback = function callback() {
                    DialogActions.close({
                        dialog: getActiveDialog(),
                        extension: data.extension
                    });
                };
            }
            if (!data.extension.options.preventDialogCloseOnEscape) {
                DomEventActions.registerKeyEvent({
                    extension_id: data.extension.id,
                    key: 27,
                    callback: callback
                });
                EventDispatcher$1.registerOnce("dialog-close", function(d) {
                    DomEventActions.unregisterKeyEvent({
                        extension_id: data.extension.id,
                        key: 27
                    });
                });
            }
        }
    });
    EventDispatcher$1.register("dialog-close-active", function(data) {
        var activeDialog = getActiveDialog();
        if (activeDialog) DialogActions.close({
            customData: data.customData,
            dialog: activeDialog,
            extension: data.extension
        });
    });
    EventDispatcher$1.register("dialog-close", function(data) {
        if (data.dialog) data.dialog.hide();
    });
    EventDispatcher$1.register("dialog-button-toggle", function(data) {
        var dialog = getActiveDialog();
        if (dialog) {
            var $button = getButtonByIdentifier(data.identifier, dialog.$el);
            ButtonActions.toggle($button, !data.enabled);
        }
    });
    EventDispatcher$1.register("dialog-button-toggle-visibility", function(data) {
        var dialog = getActiveDialog();
        if (dialog) {
            var $button = getButtonByIdentifier(data.identifier, dialog.$el);
            ButtonActions.toggleVisibility($button, data.hidden);
        }
    });
    EventDispatcher$1.register("button-clicked", function(data) {
        var $button = data.$el;
        if ($button.hasClass(DIALOG_BUTTON_CLASS)) {
            var $dialog = $button.parents("." + DIALOG_CLASS);
            var $iframe = $dialog.find("iframe");
            if ($iframe.length && $iframe[0].bridgeEstablished) DialogActions.clickButton(ButtonComponent.getIdentifier($button), $button, $dialog.data("extension"));
            else DialogActions.close({
                dialog: getActiveDialog(),
                extension: $button.extension
            });
        }
    });
    if ($.fn) {
        EventDispatcher$1.register("iframe-create", function(data) {
            if (data.extension.options && data.extension.options.isDialog) DialogComponent.setIframeDimensions(data.extension.$el);
        });
        EventDispatcher$1.register("dialog-button-add", function(data) {
            DialogComponent.addButton(data.extension, data.button);
        });
        EventDispatcher$1.register("host-window-resize", Util.debounce(function() {
            $("." + DIALOG_CLASS).each(function(i, dialog) {
                var $dialog = $(dialog);
                var sanitizedOptions = dialogUtilsInstance.sanitizeOptions($dialog.data("originalOptions"));
                dialog.style.width = sanitizedOptions.width;
                dialog.style.height = sanitizedOptions.height;
            });
        }, 100));
    }
    DomEventActions.registerWindowKeyEvent({
        keyCode: 27,
        callback: function callback() {
            DialogActions.closeActive({
                customData: {},
                extension: null
            });
        }
    });
    var DialogExtension = /*#__PURE__*/ function() {
        function DialogExtension() {}
        var _proto = DialogExtension.prototype;
        _proto.render = function render(extension, dialogOptions) {
            extension.options = extension.options || {};
            dialogOptions = dialogOptions || {};
            extension.options.isDialog = true;
            extension.options.dialogId = dialogOptions.id;
            extension.options.preventDialogCloseOnEscape = dialogOptions.closeOnEscape === false;
            extension.options.hostFrameOffset = dialogOptions.hostFrameOffset;
            extension.options.hideIframeUntilLoad = true;
            var $iframeContainer = IframeContainerComponent.createExtension(extension);
            var $dialog = DialogComponent.render({
                extension: extension,
                $content: $iframeContainer,
                chrome: dialogOptions.chrome,
                width: dialogOptions.width,
                height: dialogOptions.height,
                size: dialogOptions.size,
                header: dialogOptions.header,
                hint: dialogOptions.hint,
                submitText: dialogOptions.submitText,
                cancelText: dialogOptions.cancelText,
                buttons: dialogOptions.buttons,
                onHide: dialogOptions.onHide
            });
            return $dialog;
        };
        _proto.getActiveDialog = function getActiveDialog() {
            return DialogComponent.getActive();
        };
        _proto.buttonIsEnabled = function buttonIsEnabled(identifier) {
            return DialogComponent.buttonIsEnabled(identifier);
        };
        _proto.buttonIsVisible = function buttonIsVisible(identifier) {
            return DialogComponent.buttonIsVisible(identifier);
        };
        _proto.getByExtension = function getByExtension(extension) {
            if (typeof extension === "string") extension = {
                id: extension
            };
            return DialogComponent.getByExtension(extension);
        };
        return DialogExtension;
    }();
    var DialogExtensionComponent = new DialogExtension();
    EventDispatcher$1.register("dialog-extension-open", function(data) {
        var dialogExtension = data.extension;
        var dialogOptions = dialogUtilsInstance.sanitizeOptions(data.options);
        var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
        var dialogProvider = frameworkAdaptor.getProviderByModuleName("dialog");
        if (dialogProvider) {
            // this function should move.
            var getOnClickFunction = function getOnClickFunction(action) {
                var key = dialogExtension.key;
                var addon_key = dialogExtension.addon_key;
                var eventData = {
                    button: {
                        identifier: action.identifier,
                        name: action.identifier,
                        text: action.text
                    }
                };
                if ([
                    "submit",
                    "cancel"
                ].indexOf(action.identifier) >= 0) EventActions.broadcast("dialog." + action.identifier, {
                    addon_key: addon_key,
                    key: key
                }, eventData);
                EventActions.broadcast("dialog.button.click", {
                    addon_key: addon_key,
                    key: key
                }, eventData);
            };
            dialogExtension.options.preventDialogCloseOnEscape = dialogOptions.closeOnEscape === false;
            dialogOptions.actions.map(function(action) {
                return action.onClick = getOnClickFunction.bind(null, action);
            });
            dialogProvider.create(dialogOptions, dialogExtension);
        } else DialogExtensionComponent.render(data.extension, data.options);
    });
    var _dialogs = {};
    EventDispatcher$1.register("dialog-close", function(data) {
        var dialog = data.dialog;
        if (dialog && data.extension) EventActions.broadcast("dialog.close", {
            addon_key: data.extension.addon_key
        }, data.customData);
    });
    EventDispatcher$1.register("dialog-button-click", function(data) {
        var eventData = {
            button: {
                name: ButtonComponent.getName(data.$el),
                identifier: ButtonComponent.getIdentifier(data.$el),
                text: ButtonComponent.getText(data.$el)
            }
        };
        var eventName = "dialog.button.click";
        var buttonEventFilter = {
            addon_key: data.extension.addon_key,
            key: data.extension.key
        };
        if (window.AJS && window.AJS.DarkFeatures && window.AJS.DarkFeatures.isEnabled && window.AJS.DarkFeatures.isEnabled("connect.js.dialog.idfilter")) buttonEventFilter.id = data.extension.id;
         // Old buttons, (submit and cancel) use old events
        if (!data.$el.hasClass("ap-dialog-custom-button")) EventActions.broadcast("dialog." + eventData.button.name, buttonEventFilter, eventData);
        EventActions.broadcast(eventName, buttonEventFilter, eventData);
    });
    /**
   * @class Dialog~Dialog
   * @description A dialog object that is returned when a dialog is created using the [dialog module](module-Dialog.html).
   */ var Dialog$1 = function Dialog(options, callback) {
        callback = Util.last(arguments);
        var _id = callback._id;
        var extension = callback._context.extension;
        var dialogExtension = {
            addon_key: extension.addon_key,
            key: options.key,
            options: Util.pick(extension.options, [
                "customData",
                "productContext"
            ])
        }; // ACJS-185: the following is a really bad idea but we need it
        // for compat until AP.dialog.customData has been deprecated
        dialogExtension.options.customData = options.customData; // terrible idea! - we need to remove this from p2 ASAP!
        var dialogModuleOptions = dialogUtilsInstance.moduleOptionsFromGlobal(dialogExtension.addon_key, dialogExtension.key); // There is a hostFrameOffset configuration available
        // for modals (window._AP.dialogOptions) and inline modals (window._AP.inlineDialogOptions)
        // which is taken into account during the iframe insertion (inside the dialog).
        // The change below injects hostFrameOffset value from the global module options (window._AP.dialogModules)
        // which is required for establishing a contact with a correct host (solves spa iframe problem).
        if (typeof (dialogModuleOptions || {}).hostFrameOffset === "number") dialogExtension.options.hostFrameOffset = dialogModuleOptions.hostFrameOffset;
        options = Util.extend({}, dialogModuleOptions || {}, options);
        options.id = _id;
        dialogUtilsInstance.trackMultipleDialogOpening(dialogExtension, options);
        DialogExtensionActions.open(dialogExtension, options);
        this.customData = options.customData;
        _dialogs[_id] = this;
    } /**
   * Registers a callback for a dialog event.
   * @method on
   * @memberOf Dialog~Dialog
   * @param {String} event The dialog event to listen for. Valid options are "close".
   * @param {Function} callback The function to be invoked.
   * @noDemo
   * @example
   * AP.dialog.create({
   *   key: 'my-module-key'
   * }).on("close", function() {
   *   console.log("Dialog was closed");
   * });
   */ ;
    /**
   * @class Dialog~DialogButton
   * @description A dialog button that can be controlled with JavaScript
   */ var Button$1 = /*#__PURE__*/ function() {
        function Button(identifier, callback) {
            callback = Util.last(arguments);
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dialogProvider = frameworkAdaptor.getProviderByModuleName("dialog");
            if (dialogProvider) {
                dialogUtilsInstance.assertActiveDialogOrThrow(dialogProvider, callback._context.extension.addon_key);
                this.name = identifier;
                this.identifier = identifier;
            } else {
                if (!DialogExtensionComponent.getActiveDialog()) throw new Error("Failed to find an active dialog.");
                this.name = identifier;
                this.identifier = identifier;
                this.enabled = DialogExtensionComponent.buttonIsEnabled(identifier);
                this.hidden = !DialogExtensionComponent.buttonIsVisible(identifier);
            }
        }
        /**
     * Sets the button state to enabled
     * @method enable
     * @memberOf Dialog~DialogButton
     * @noDemo
     * @example
     * AP.dialog.getButton('submit').enable();
     */ var _proto = Button.prototype;
        _proto.enable = function enable() {
            this.setState({
                enabled: true
            });
        } /**
     * Sets the button state to disabled. A disabled button cannot be clicked and emits no events.
     * @method disable
     * @memberOf Dialog~DialogButton
     * @noDemo
     * @example
     * AP.dialog.getButton('submit').disable();
     */ ;
        _proto.disable = function disable() {
            this.setState({
                enabled: false
            });
        } /**
     * Query a button for its current state.
     * @method isEnabled
     * @memberOf Dialog~DialogButton
     * @param {Function} callback function to receive the button state.
     * @noDemo
     * @example
     * AP.dialog.getButton('submit').isEnabled(function(enabled){
     *   if(enabled){
     *     //button is enabled
     *   }
     * });
     */ ;
        _proto.isEnabled = function isEnabled(callback) {
            callback = Util.last(arguments);
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dialogProvider = frameworkAdaptor.getProviderByModuleName("dialog");
            if (dialogProvider) callback(!dialogProvider.isButtonDisabled(this.identifier));
            else callback(this.enabled);
        } /**
     * Toggle the button state between enabled and disabled.
     * @method toggle
     * @memberOf Dialog~DialogButton
     * @noDemo
     * @example
     * AP.dialog.getButton('submit').toggle();
     */ ;
        _proto.toggle = function toggle() {
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dialogProvider = frameworkAdaptor.getProviderByModuleName("dialog");
            if (dialogProvider) dialogProvider.toggleButton(this.identifier);
            else this.setState({
                enabled: !this.enabled
            });
        };
        _proto.setState = function setState(state) {
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dialogProvider = frameworkAdaptor.getProviderByModuleName("dialog");
            if (dialogProvider) dialogProvider.setButtonDisabled(this.identifier, !state.enabled);
            else {
                this.enabled = state.enabled;
                DialogActions.toggleButton({
                    identifier: this.identifier,
                    enabled: this.enabled
                });
            }
        } /**
     * Trigger a callback bound to a button.
     * @method trigger
     * @memberOf Dialog~DialogButton
     * @noDemo
     * @example
     * AP.dialog.getButton('submit').bind(function(){
     *   alert('clicked!');
     * });
     * AP.dialog.getButton('submit').trigger();
     */ ;
        _proto.trigger = function trigger(callback) {
            callback = Util.last(arguments);
            if (this.enabled) DialogActions.dialogMessage({
                name: this.name,
                extension: callback._context.extension
            });
        } /**
     * Query a button for its current hidden/visible state.
     * @method isHidden
     * @memberOf Dialog~DialogButton
     * @param {Function} callback function to receive the button state.
     * @noDemo
     * @example
     * AP.dialog.getButton('submit').isHidden(function(hidden){
     *   if(hidden){
     *     //button is hidden
     *   }
     * });
     */ ;
        _proto.isHidden = function isHidden(callback) {
            callback = Util.last(arguments);
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dialogProvider = frameworkAdaptor.getProviderByModuleName("dialog");
            if (dialogProvider) callback(dialogProvider.isButtonHidden(this.identifier));
            else callback(this.hidden);
        } /**
     * Sets the button state to hidden
     * @method hide
     * @memberOf Dialog~DialogButton
     * @noDemo
     * @example
     * AP.dialog.getButton('submit').hide();
     */ ;
        _proto.hide = function hide() {
            this.setHidden(true);
        } /**
     * Sets the button state to visible
     * @method show
     * @memberOf Dialog~DialogButton
     * @noDemo
     * @example
     * AP.dialog.getButton('submit').show();
     */ ;
        _proto.show = function show() {
            this.setHidden(false);
        };
        _proto.setHidden = function setHidden(hidden) {
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dialogProvider = frameworkAdaptor.getProviderByModuleName("dialog");
            if (dialogProvider) dialogProvider.setButtonHidden(this.identifier, hidden);
            else {
                this.hidden = hidden;
                DialogActions.toggleButtonVisibility({
                    identifier: this.identifier,
                    hidden: this.hidden
                });
            }
        };
        return Button;
    }();
    function getDialogFromContext(context) {
        return _dialogs[context.extension.options.dialogId];
    }
    var CreateButton = function CreateButton(options, callback) {
        callback = Util.last(arguments);
        var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
        var dialogProvider = frameworkAdaptor.getProviderByModuleName("dialog");
        if (dialogProvider) {
            dialogUtilsInstance.assertActiveDialogOrThrow(dialogProvider, callback._context.extension.addon_key);
            dialogProvider.createButton({
                identifier: options.identifier,
                text: options.text,
                hidden: false,
                disabled: options.disabled || false,
                onClick: function onClick() {
                    EventActions.broadcast("dialog.button.click", {
                        addon_key: callback._context.extension.addon_key,
                        key: callback._context.extension.key
                    }, {
                        button: {
                            identifier: options.identifier,
                            text: options.text
                        }
                    });
                }
            });
        } else DialogExtensionActions.addUserButton({
            identifier: options.identifier,
            text: options.text
        }, callback._context.extension);
    };
    /**
   * The Dialog module provides a mechanism for launching an add-on's modules as modal dialogs from within an add-on's iframe.
   *
   * A modal dialog displays information without requiring the user to leave the current page.
   *
   * The dialog is opened over the entire window, rather than within the iframe itself.
   *
   * <h3>Styling your dialog to look like a standard Atlassian dialog</h3>
   *
   * By default the dialog iframe is undecorated. It's up to you to style the dialog.
   * <img src="/cloud/connect/images/connectdialogchromelessexample.jpeg" width="100%" />
   *
   * In order to maintain a consistent look and feel between the host application and the add-on, we encourage you to style your dialogs to match Atlassian's Design Guidelines for modal dialogs.
   *
   * To do that, you'll need to add the AUI styles to your dialog.
   *
   * For more information, read about the Atlassian User Interface [dialog component](https://docs.atlassian.com/aui/latest/docs/dialog2.html).
   * @exports Dialog
   */ var dialog = {
        /**
     * @class Dialog~DialogOptions
     * @description The options supplied to a [dialog.create()](module-Dialog.html) call.
     *
     * @property {String}        key         The module key of a dialog, or the key of a page or web-item that you want to open as a dialog.
     * @property {String}        size        Opens the dialog at a preset size: small, medium, large, x-large or fullscreen (with chrome).
     * @property {Number|String} width       if size is not set, define the width as a percentage (append a % to the number) or pixels.
     * @property {Number|String} height      if size is not set, define the height as a percentage (append a % to the number) or pixels.
     * @property {Boolean}       chrome      (optional) opens the dialog with heading and buttons.
     * @property {String}        header      (optional) text to display in the header if opening a dialog with chrome.
     * @property {String}        submitText  (optional) text for the submit button if opening a dialog with chrome.
     * @property {String}        cancelText  (optional) text for the cancel button if opening a dialog with chrome.
     * @property {Object}        customData  (optional) custom data object that can be accessed from the actual dialog iFrame.
     * @property {Boolean}       closeOnEscape (optional) if true, pressing ESC inside the dialog will close the dialog (default is true).
     * @property {Array}         buttons     (optional) an array of custom buttons to be added to the dialog if opening a dialog with chrome.
     * @property {String}        hint        (optional) Suggested actions or helpful info that will be added to the dialog if opening with chrome.
     */ /**
     * Creates a dialog for a common dialog, page or web-item module key.
     * @param {Dialog~DialogOptions} options configuration object of dialog options.
     * @method create
     * @noDemo
     * @example
     * AP.dialog.create({
     *   key: 'my-module-key',
     *   width: '500px',
     *   height: '200px',
     *   chrome: true,
     *   buttons: [
     *     {
     *       text: 'my button',
     *       identifier: 'my_unique_identifier'
     *     }
     *   ]
     * }).on("close", callbackFunc);
     *
     * @return {Dialog~Dialog} Dialog object allowing for callback registrations
     */ create: {
            constructor: Dialog$1
        },
        /**
     * Closes the currently open dialog. Optionally pass data to listeners of the `dialog.close` event.
     * This will only close a dialog that has been opened by your add-on.
     * You can register for close events using the `dialog.close` event and the [events module](../events/).
     * @param {Object} data An object to be emitted on dialog close.
     * @noDemo
     * @example
     * AP.dialog.close({foo: 'bar'});
     */ close: function close(data, callback) {
            callback = Util.last(arguments);
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dialogProvider = frameworkAdaptor.getProviderByModuleName("dialog");
            if (dialogProvider) {
                dialogUtilsInstance.assertActiveDialogOrThrow(dialogProvider, callback._context.extension.addon_key);
                EventActions.broadcast("dialog.close", {
                    addon_key: callback._context.extension.addon_key
                }, data);
                dialogProvider.close();
            } else {
                var dialogToClose;
                if (callback._context.extension.options.isDialog) dialogToClose = DialogExtensionComponent.getByExtension(callback._context.extension.id)[0];
                else dialogToClose = DialogExtensionComponent.getActiveDialog();
                DialogActions.close({
                    customData: data,
                    dialog: dialogToClose,
                    extension: callback._context.extension
                });
            }
        },
        /**
     * Passes the custom data Object to the specified callback function.
     * @noDemo
     * @name getCustomData
     * @method
     * @param {Function} callback - Callback method to be executed with the custom data.
     * @example
     * AP.dialog.getCustomData(function (customData) {
     *   console.log(customData);
     * });
     *
     */ getCustomData: function getCustomData(callback) {
            callback = Util.last(arguments);
            var dialog = getDialogFromContext(callback._context);
            if (dialog) callback(dialog.customData);
            else callback(undefined);
        },
        /**
    * Stop the dialog from closing when the submit button is clicked
    * @method disableCloseOnSubmit
    * @noDemo
    * @example
    * AP.dialog.disableCloseOnSubmit();
    * AP.events.on('dialog.button.click', function(data){
    *   if(data.button.name === 'submit') {
    *     console.log('submit button pressed');
    *   }
    * }
    */ /**
     * Returns the button that was requested (either cancel or submit). If the requested button does not exist, an empty Object will be returned instead.
     * @method getButton
     * @returns {Dialog~DialogButton}
     * @noDemo
     * @example
     * AP.dialog.getButton('submit');
     */ getButton: {
            constructor: Button$1,
            enable: Button$1.prototype.enable,
            disable: Button$1.prototype.disable,
            toggle: Button$1.prototype.toggle,
            isEnabled: Button$1.prototype.isEnabled,
            trigger: Button$1.prototype.trigger,
            hide: Button$1.prototype.hide,
            show: Button$1.prototype.show,
            isHidden: Button$1.prototype.isHidden
        },
        /**
     * Creates a dialog button that can be controlled with javascript
     * @method createButton
     * @returns {Dialog~DialogButton}
     * @noDemo
     * @example
     * AP.dialog.createButton({
     *   text: 'button text',
     *   identifier: 'button.1'
     * }).bind(function mycallback(){});
     */ createButton: {
            constructor: CreateButton
        }
    };
    EventDispatcher$1.register("iframe-resize", function(data) {
        IframeComponent.resize(data.width, data.height, data.$el);
    });
    EventDispatcher$1.register("iframe-size-to-parent", function(data) {
        var height;
        var $el = Util.getIframeByExtensionId(data.extensionId);
        height = $(window).height() - $el.offset().top - 1; //1px comes from margin given by full-size-general-page
        EventDispatcher$1.dispatch("iframe-resize", {
            width: "100%",
            height: height + "px",
            $el: $el
        });
    });
    EventDispatcher$1.register("hide-footer", function(hideFooter) {
        if (hideFooter) $("#footer").css({
            display: "none"
        });
    });
    window.addEventListener("resize", function(e) {
        EventDispatcher$1.dispatch("host-window-resize", e);
    }, true);
    var EnvActions = {
        iframeResize: function iframeResize(width, height, context) {
            var $el;
            if (context.extension_id) $el = Util.getIframeByExtensionId(context.extension_id);
            else $el = context;
            EventDispatcher$1.dispatch("iframe-resize", {
                width: width,
                height: height,
                $el: $el,
                extension: context.extension
            });
        },
        sizeToParent: function sizeToParent(extensionId, hideFooter) {
            EventDispatcher$1.dispatch("iframe-size-to-parent", {
                hideFooter: hideFooter,
                extensionId: extensionId
            });
        },
        hideFooter: function hideFooter(_hideFooter) {
            EventDispatcher$1.dispatch("hide-footer", _hideFooter);
        }
    };
    var debounce$1 = Util.debounce;
    var resizeFuncHolder = {}; // ignore resize events for iframes that use sizeToParent
    var ignoreResizeForExtension = [];
    var sizeToParentExtension = {};
    /**
   * Enables apps to resize their iframe and show or hide the iframe footer.
   * @exports iframe
   */ var env = {
        /**
     * Get the location of the current page of the host product.
     *
     * @param {Function} callback function (location) {...} The callback to pass the location to.
     * @example
     * AP.getLocation(function(location){
     *   alert(location);
     * });
     * @ignore
     */ getLocation: function getLocation(callback) {
            callback = Util.last(arguments);
            var pageLocationProvider = ModuleProviders$1.getProvider("get-location");
            if (typeof pageLocationProvider === "function") callback(pageLocationProvider());
            else callback(window.location.href);
        },
        /**
     * Resize the iframe to a width and height.
     *
     * Only content within an element with the class `ac-content` is resized automatically.
     * Content without this identifier is sized according to the `body` element, and
     * is *not* dynamically resized. The recommended DOM layout for your app is:
     *
     * ``` html
     * <div class="ac-content">
     *     <p>Hello World</p>
     *     <div id="your-id-here">
     *         <p>Addon content goes here</p>
     *     </div>
     *
     *     ...this area reserved for our resize sensor divs
     * </div>
     * ```
     *
     * The resize sensor div is added on the iframe's [load event](https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event).
     * Removing the `ac-content` element after this, prevents resizing from working correctly.
     *
     * This method cannot be used in dialogs.
     *
     * @method
     * @param {String} width   The desired width.
     * @param {String} height  The desired height.
     */ resize: function resize(width, height, callback) {
            callback = Util.last(arguments);
            var addon = ModuleProviders$1.getProvider("addon");
            if (addon) addon.resize(width, height, callback._context);
            else {
                var iframeId = callback._context.extension.id;
                var options = callback._context.extension.options;
                if (ignoreResizeForExtension.indexOf(iframeId) !== -1 || options && options.isDialog) return false;
                if (!resizeFuncHolder[iframeId]) resizeFuncHolder[iframeId] = debounce$1(function(dwidth, dheight, dcallback) {
                    EnvActions.iframeResize(dwidth, dheight, dcallback._context);
                }, 50);
                resizeFuncHolder[iframeId](width, height, callback);
            }
            return true;
        },
        /**
     * Resize the iframe so that it takes the entire page and, optionally, hide the footer.
     *
     * This method is only available for general page modules.
     *
     * @method
     * @param {boolean} hideFooter Whether the footer should be hidden.
     */ sizeToParent: debounce$1(function(hideFooter, callback) {
            callback = Util.last(arguments);
            var addon = ModuleProviders$1.getProvider("addon");
            if (addon) addon.sizeToParent(hideFooter, callback._context);
            else // sizeToParent is only available for general-pages
            if (callback._context.extension.options.isFullPage) {
                // This adds border between the iframe and the page footer as the connect addon has scrolling content and can't do this
                Util.getIframeByExtensionId(callback._context.extension_id).addClass("full-size-general-page");
                EnvActions.sizeToParent(callback._context.extension_id, hideFooter);
                sizeToParentExtension[callback._context.extension_id] = {
                    hideFooter: hideFooter
                };
            } else // This is only here to support integration testing
            // see com.atlassian.plugin.connect.test.pageobjects.RemotePage#isNotFullSize()
            Util.getIframeByExtensionId(callback._context.extension_id).addClass("full-size-general-page-fail");
        }),
        /**
    * Hide the footer.
    *
    * @method
    * @param {boolean} hideFooter Whether the footer should be hidden.
    */ hideFooter: function hideFooter(_hideFooter) {
            if (_hideFooter) EnvActions.hideFooter(_hideFooter);
        }
    };
    EventDispatcher$1.register("host-window-resize", function(data) {
        Object.getOwnPropertyNames(sizeToParentExtension).forEach(function(extensionId) {
            EnvActions.sizeToParent(extensionId, sizeToParentExtension[extensionId].hideFooter);
        });
    });
    EventDispatcher$1.register("after:iframe-unload", function(data) {
        delete resizeFuncHolder[data.extension.id];
        delete sizeToParentExtension[data.extension.id];
        if (ignoreResizeForExtension.indexOf(data.extension.id) !== -1) ignoreResizeForExtension.splice(ignoreResizeForExtension.indexOf(data.extension.id), 1);
    });
    EventDispatcher$1.register("before:iframe-size-to-parent", function(data) {
        if (ignoreResizeForExtension.indexOf(data.extensionId) === -1) ignoreResizeForExtension.push(data.extensionId);
    });
    var InlineDialogActions = {
        hide: function hide($el) {
            EventDispatcher$1.dispatch("inline-dialog-hide", {
                $el: $el
            });
        },
        refresh: function refresh($el) {
            EventDispatcher$1.dispatch("inline-dialog-refresh", {
                $el: $el
            });
        },
        hideTriggered: function hideTriggered(extension_id, $el) {
            EventDispatcher$1.dispatch("inline-dialog-hidden", {
                extension_id: extension_id,
                $el: $el
            });
        },
        close: function close() {
            EventDispatcher$1.dispatch("inline-dialog-close", {});
        },
        created: function created(data) {
            EventDispatcher$1.dispatch("inline-dialog-opened", {
                $el: data.$el,
                trigger: data.trigger,
                extension: data.extension
            });
        }
    };
    /**
   * The inline dialog is a wrapper for secondary content/controls to be displayed on user request. Consider this component as displayed in context to the triggering control with the dialog overlaying the page content.
   * An inline dialog should be preferred over a modal dialog when a connection between the action has a clear benefit versus having a lower user focus.
   *
   * Inline dialogs can be shown via a [web item target](../../modules/web-item/#target).
   *
   * For more information, read about the Atlassian User Interface [inline dialog component](https://docs.atlassian.com/aui/latest/docs/inline-dialog.html).
   * @module Inline-dialog
   */ var inlineDialog = {
        /**
     * Hide the inline dialog that contains the iframe where this method is called from.
     * @memberOf module:Inline-dialog
     * @method hide
     * @noDemo
     * @example
     * AP.inlineDialog.hide();
     */ hide: function hide(callback) {
            callback = Util.last(arguments);
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var inlineDialogProvider = frameworkAdaptor.getProviderByModuleName("inlineDialog");
            if (inlineDialogProvider) inlineDialogProvider.hide(callback._context);
            else InlineDialogActions.close();
        }
    };
    /**
  * Messages are the primary method for providing system feedback in the product user interface.
  * Messages include notifications of various kinds: alerts, confirmations, notices, warnings, info and errors.
  * For visual examples of each kind please see the [Design guide](https://docs.atlassian.com/aui/latest/docs/messages.html).
  * ### Example ###
  * ```
  * //create a message
  * var message = AP.messages.info('plain text title', 'plain text body');
  * ```
  * @deprecated after August 2017 | Please use the Flag module instead.
  * @name Messages
  * @module
  * @ignore
  */ var MESSAGE_BAR_ID = "ac-message-container";
    var MESSAGE_TYPES = [
        "generic",
        "error",
        "warning",
        "success",
        "info",
        "hint"
    ];
    var MSGID_PREFIX = "ap-message-";
    var MSGID_REGEXP = new RegExp("^" + MSGID_PREFIX + "[0-9A-fa-f]+$");
    var _messages = {};
    function validateMessageId(msgId) {
        return MSGID_REGEXP.test(msgId);
    }
    function getMessageBar() {
        var $msgBar = $("#" + MESSAGE_BAR_ID);
        if ($msgBar.length < 1) $msgBar = $('<div id="' + MESSAGE_BAR_ID + '" />').appendTo("body");
        return $msgBar;
    }
    function filterMessageOptions(options) {
        var copy = {};
        var allowed = [
            "closeable",
            "fadeout",
            "delay",
            "duration",
            "id"
        ];
        if (typeof options === "object") allowed.forEach(function(key) {
            if (key in options) copy[key] = options[key];
        });
        return copy;
    }
    var messageCloseListenerCreated = false;
    function showMessage(name, title, body, options) {
        if (!messageCloseListenerCreated) {
            createMessageCloseListener();
            messageCloseListenerCreated = true;
        }
        var $msgBar = getMessageBar();
        options = filterMessageOptions(options);
        $.extend(options, {
            title: title,
            body: AJS.escapeHtml(body)
        });
        if (MESSAGE_TYPES.indexOf(name) < 0) throw "Invalid message type. Must be: " + MESSAGE_TYPES.join(", ");
        if (validateMessageId(options.id)) {
            AJS.messages[name]($msgBar, options); // Calculate the left offset based on the content width.
            // This ensures the message always stays in the centre of the window.
            $msgBar.css("margin-left", "-" + $msgBar.innerWidth() / 2 + "px");
        }
    }
    function deprecatedShowMessage(name, title, body, options, callback) {
        var methodUsed = "AP.messages." + name;
        console.warn("DEPRECATED API - AP.messages." + name + " has been deprecated since ACJS 5.0 and will be removed in a future release. Use AP.flag.create instead.");
        AnalyticsAction.trackDeprecatedMethodUsed(methodUsed, callback._context.extension);
        var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
        var messageProvider = frameworkAdaptor.getProviderByModuleName("messages");
        if (messageProvider) {
            var messageType = name;
            var createMessage = messageProvider[messageType];
            if (!createMessage) messageProvider[messageType] = messageProvider.generic;
            createMessage(title, body, options);
        } else showMessage(name, title, body, options);
    }
    function createMessageCloseListener() {
        $(document).on("aui-message-close", function(e, $msg) {
            var _id = $msg.attr("id").replace(MSGID_PREFIX, "");
            if (_messages[_id]) {
                if ($.isFunction(_messages[_id].onCloseTrigger)) _messages[_id].onCloseTrigger();
                _messages[_id]._destroy();
            }
        });
    }
    function messageModule(messageType) {
        return {
            constructor: function constructor(title, body, options, callback) {
                callback = Util.last(arguments);
                var _id = callback._id;
                if (typeof title !== "string") title = "";
                if (typeof body !== "string") body = "";
                if (typeof options !== "object") options = {};
                options.id = MSGID_PREFIX + _id;
                deprecatedShowMessage(messageType, title, body, options, callback);
                _messages[_id] = this;
            }
        };
    }
    var messages = {
        /**
    * Close a message
    * @deprecated after August 2017 | Please use the Flag module instead.
    * @name clear
    * @method
    * @memberof module:Messages#
    * @param    {String}    id  The id that was returned when the message was created.
    * @example
    * //create a message
    * var message = AP.messages.info('title', 'body');
    * setTimeout(function(){
    *   AP.messages.clear(message);
    * }, 2000);
    */ clear: function clear(msg) {
            var id = MSGID_PREFIX + msg._id;
            if (validateMessageId(id)) {
                var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
                var messageProvider = frameworkAdaptor.getProviderByModuleName("messages");
                if (messageProvider) messageProvider.clear(id);
                else $("#" + id).closeMessage();
            }
        },
        /**
    * Trigger an event when a message is closed
    * @deprecated after August 2017 | Please use the Flag module instead.
    * @name onClose
    * @method
    * @memberof module:Messages#
    * @param    {String}    id  The id that was returned when the message was created.
    * @param    {Function}  callback  The function that is run when the event is triggered
    * @example
    * //create a message
    * var message = AP.messages.info('title', 'body');
    * AP.messages.onClose(message, function() {
    *   console.log(message, ' has been closed!');
    * });
    */ onClose: function onClose(msg, callback) {
            callback = Util.last(arguments);
            var id = msg._id;
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var messageProvider = frameworkAdaptor.getProviderByModuleName("messages");
            if (messageProvider) {
                var fullId = MSGID_PREFIX + msg._id;
                messageProvider.onClose(fullId, callback);
            } else if (_messages[id]) _messages[id].onCloseTrigger = callback;
        },
        /**
    * Show a generic message
    * @deprecated after August 2017 | Please use the Flag module instead.
    * @name generic
    * @method
    * @memberof module:Messages#
    * @param    {String}            title       Sets the title text of the message.
    * @param    {String}            body        The main content of the message.
    * @param    {Object}            options             Message Options
    * @param    {Boolean}           options.closeable   Adds a control allowing the user to close the message, removing it from the page.
    * @param    {Boolean}           options.fadeout     Toggles the fade away on the message
    * @param    {Number}            options.delay       Time to wait (in ms) before starting fadeout animation (ignored if fadeout==false)
    * @param    {Number}            options.duration    Fadeout animation duration in milliseconds (ignored if fadeout==false)
    * @returns  {String}    The id to be used when clearing the message
    * @example
    * //create a message
    * var message = AP.messages.generic('title', 'generic message example');
    */ generic: messageModule("generic"),
        /**
    * Show an error message
    * @deprecated after August 2017 | Please use the Flag module instead.
    * @name error
    * @method
    * @memberof module:Messages#
    * @param    {String}            title       Sets the title text of the message.
    * @param    {String}            body        The main content of the message.
    * @param    {Object}            options             Message Options
    * @param    {Boolean}           options.closeable   Adds a control allowing the user to close the message, removing it from the page.
    * @param    {Boolean}           options.fadeout     Toggles the fade away on the message
    * @param    {Number}            options.delay       Time to wait (in ms) before starting fadeout animation (ignored if fadeout==false)
    * @param    {Number}            options.duration    Fadeout animation duration in milliseconds (ignored if fadeout==false)
    * @returns  {String}    The id to be used when clearing the message
    * @example
    * //create a message
    * var message = AP.messages.error('title', 'error message example');
    */ error: messageModule("error"),
        /**
    * Show a warning message
    * @deprecated after August 2017 | Please use the Flag module instead.
    * @name warning
    * @method
    * @memberof module:Messages#
    * @param    {String}            title       Sets the title text of the message.
    * @param    {String}            body        The main content of the message.
    * @param    {Object}            options             Message Options
    * @param    {Boolean}           options.closeable   Adds a control allowing the user to close the message, removing it from the page.
    * @param    {Boolean}           options.fadeout     Toggles the fade away on the message
    * @param    {Number}            options.delay       Time to wait (in ms) before starting fadeout animation (ignored if fadeout==false)
    * @param    {Number}            options.duration    Fadeout animation duration in milliseconds (ignored if fadeout==false)
    * @returns  {String}    The id to be used when clearing the message
    * @example
    * //create a message
    * var message = AP.messages.warning('title', 'warning message example');
    */ warning: messageModule("warning"),
        /**
    * Show a success message
    * @deprecated after August 2017 | Please use the Flag module instead.
    * @name success
    * @method
    * @memberof module:Messages#
    * @param    {String}            title       Sets the title text of the message.
    * @param    {String}            body        The main content of the message.
    * @param    {Object}            options             Message Options
    * @param    {Boolean}           options.closeable   Adds a control allowing the user to close the message, removing it from the page.
    * @param    {Boolean}           options.fadeout     Toggles the fade away on the message
    * @param    {Number}            options.delay       Time to wait (in ms) before starting fadeout animation (ignored if fadeout==false)
    * @param    {Number}            options.duration    Fadeout animation duration in milliseconds (ignored if fadeout==false)
    * @returns  {String}    The id to be used when clearing the message
    * @example
    * //create a message
    * var message = AP.messages.success('title', 'success message example');
    */ success: messageModule("success"),
        /**
    * Show an info message
    * @deprecated after August 2017 | Please use the Flag module instead.
    * @name info
    * @method
    * @memberof module:Messages#
    * @param    {String}            title       Sets the title text of the message.
    * @param    {String}            body        The main content of the message.
    * @param    {Object}            options             Message Options
    * @param    {Boolean}           options.closeable   Adds a control allowing the user to close the message, removing it from the page.
    * @param    {Boolean}           options.fadeout     Toggles the fade away on the message
    * @param    {Number}            options.delay       Time to wait (in ms) before starting fadeout animation (ignored if fadeout==false)
    * @param    {Number}            options.duration    Fadeout animation duration in milliseconds (ignored if fadeout==false)
    * @returns  {String}    The id to be used when clearing the message
    * @example
    * //create a message
    * var message = AP.messages.info('title', 'info message example');
    */ info: messageModule("info"),
        /**
    * Show a hint message
    * @deprecated after August 2017 | Please use the Flag module instead.
    * @name hint
    * @method
    * @memberof module:Messages#
    * @param    {String}            title               Sets the title text of the message.
    * @param    {String}            body                The main content of the message.
    * @param    {Object}            options             Message Options
    * @param    {Boolean}           options.closeable   Adds a control allowing the user to close the message, removing it from the page.
    * @param    {Boolean}           options.fadeout     Toggles the fade away on the message
    * @param    {Number}            options.delay       Time to wait (in ms) before starting fadeout animation (ignored if fadeout==false)
    * @param    {Number}            options.duration    Fadeout animation duration in milliseconds (ignored if fadeout==false)
    * @returns  {String}    The id to be used when clearing the message
    * @example
    * //create a message
    * var message = AP.messages.hint('title', 'hint message example');
    */ hint: messageModule("hint")
    };
    var FlagActions = {
        // called on action click
        actionInvoked: function actionInvoked(actionId, flagId) {
            EventDispatcher$1.dispatch("flag-action-invoked", {
                id: flagId,
                actionId: actionId
            });
        },
        open: function open(flagId) {
            EventDispatcher$1.dispatch("flag-open", {
                id: flagId
            });
        },
        //called to close a flag
        close: function close(flagId) {
            EventDispatcher$1.dispatch("flag-close", {
                id: flagId
            });
        },
        //called by AUI when closed
        closed: function closed(flagId) {
            EventDispatcher$1.dispatch("flag-closed", {
                id: flagId
            });
        }
    };
    var FLAGID_PREFIX = "ap-flag-";
    var FLAG_CLASS = "ac-aui-flag";
    var FLAG_ACTION_CLASS = "ac-flag-actions";
    var Flag = /*#__PURE__*/ function() {
        function Flag() {}
        var _proto = Flag.prototype;
        _proto.cleanKey = function cleanKey(dirtyKey) {
            var cleanFlagKeyRegExp = new RegExp("^" + FLAGID_PREFIX + "(.+)$");
            var matches = dirtyKey.match(cleanFlagKeyRegExp);
            if (matches && matches[1]) return matches[1];
            return null;
        };
        _proto._toHtmlString = function _toHtmlString(str) {
            if ($.type(str) === "string") return str;
            else if ($.type(str) === "object" && str instanceof $) return str.html();
        };
        _proto._renderBody = function _renderBody(body) {
            var body = this._toHtmlString(body);
            var $body = $("<div />").html(body);
            $("<p />").addClass(FLAG_ACTION_CLASS).appendTo($body);
            return $body.html();
        };
        _proto._renderActions = function _renderActions($flag, flagId, actions) {
            var $actionContainer = $flag.find("." + FLAG_ACTION_CLASS);
            actions = actions || {};
            var $action;
            Object.getOwnPropertyNames(actions).forEach(function(key) {
                $action = $("<a />").attr("href", "#").data({
                    "key": key,
                    "flag_id": flagId
                }).text(actions[key]);
                $actionContainer.append($action);
            }, this);
            return $flag;
        };
        _proto.render = function render(options) {
            bindFlagDomEvents();
            var _id = FLAGID_PREFIX + options.id;
            var auiFlag = AJS.flag({
                type: options.type,
                title: options.title,
                body: this._renderBody(options.body),
                close: options.close
            });
            auiFlag.setAttribute("id", _id);
            var $auiFlag = $(auiFlag);
            this._renderActions($auiFlag, options.id, options.actions);
            $auiFlag.addClass(FLAG_CLASS);
            $auiFlag.close = auiFlag.close;
            return $auiFlag;
        };
        _proto.close = function close(id) {
            var f = document.getElementById(id);
            f.close();
        };
        return Flag;
    }();
    var FlagComponent = new Flag();
    var flagDomEventsBound = false;
    function bindFlagDomEvents() {
        if (flagDomEventsBound) return;
        $(document).on("aui-flag-close", function(e) {
            var _id = e.target.id;
            var cleanFlagId = FlagComponent.cleanKey(_id);
            FlagActions.closed(cleanFlagId);
        });
        $(document).on("click", "." + FLAG_ACTION_CLASS, function(e) {
            var $target = $(e.target);
            var actionKey = $target.data("key");
            var flagId = $target.data("flag_id");
            FlagActions.actionInvoked(actionKey, flagId);
        });
        flagDomEventsBound = true;
    }
    EventDispatcher$1.register("flag-close", function(data) {
        FlagComponent.close(data.id);
    });
    /**
  * Flags are the primary method for providing system feedback in the product user interface. Messages include notifications of various kinds: alerts, confirmations, notices, warnings, info and errors.
  * @module Flag
  */ var _flags = {};
    /**
  * @class Flag~Flag
  * @description A flag object created by the [AP.flag]{@link module:Flag} module.
  * @example
  * // complete flag API example:
  * var outFlagId;
  * var flag = AP.flag.create({
  *   title: 'Successfully created a flag.',
  *   body: 'This is a flag.',
  *   type: 'info',
  *   actions: {
  *     'actionOne': 'action name'
  *   }
  * }, function(identifier) {
  * // Each flag will have a unique id. Save it for later.
  *   ourFlagId = identifier;
  * });
  *
  * // listen to flag events
  * AP.events.on('flag.close', function(data) {
  * // a flag was closed. data.flagIdentifier should match ourFlagId
  *   console.log('flag id: ', data.flagIdentifier);
  * });
  * AP.events.on('flag.action', function(data) {
  * // a flag action was clicked. data.actionIdentifier will be 'actionOne'
  * // data.flagIdentifier will equal ourFlagId
  *   console.log('flag id: ', data.flagIdentifier, 'flag action id', data.actionIdentifier);
  * });
  */ var Flag$1 = /*#__PURE__*/ function() {
        function Flag(options, callback) {
            callback = Util.last(arguments);
            if (typeof options !== "object") return;
            var flagId = callback._id;
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var flagProvider = frameworkAdaptor.getProviderByModuleName("flag");
            if (flagProvider) {
                var actions = [];
                if (typeof options.actions === "object") actions = Object.getOwnPropertyNames(options.actions).map(function(key) {
                    return {
                        actionKey: key,
                        actionText: options.actions[key],
                        executeAction: FlagActions.actionInvoked.bind(null, key, flagId)
                    };
                });
                var type = options.type || "info";
                var flagOptions = {
                    id: flagId,
                    title: options.title,
                    body: options.body,
                    actions: actions,
                    onClose: FlagActions.closed,
                    close: options.close,
                    type: type.toLowerCase()
                };
                this.flag = flagProvider.create(flagOptions);
                var addonProvider = ModuleProviders$1.getProvider("addon");
                if (addonProvider && addonProvider.registerUnmountCallback) addonProvider.registerUnmountCallback(this.close.bind(this), callback._context);
            } else {
                this.flag = FlagComponent.render({
                    type: options.type,
                    title: options.title,
                    body: AJS.escapeHtml(options.body),
                    actions: options.actions,
                    close: options.close,
                    id: flagId
                });
                FlagActions.open(this.flag.attr("id"));
            }
            this.onTriggers = {};
            this.extension = callback._context.extension;
            _flags[callback._id] = this;
            callback.call(null, callback._id);
        }
        /**
    * @name close
    * @memberof Flag~Flag
    * @method
    * @description Closes the Flag.
    * @example
    * // Display a nice green flag using the Flags JavaScript API.
    * var flag = AP.flag.create({
    *   title: 'Successfully created a flag.',
    *   body: 'This is a flag.',
    *   type: 'info'
    * });
    *
    * // Close the flag.
    * flag.close()
    *
    */ var _proto = Flag.prototype;
        _proto.close = function close() {
            this.flag.close();
        };
        return Flag;
    }();
    function invokeTrigger(id, eventName, data) {
        if (_flags[id]) {
            var extension = _flags[id].extension;
            data = data || {};
            data.flagIdentifier = id;
            EventActions.broadcast(eventName, {
                extension_id: extension.extension_id
            }, data);
        }
    }
    EventDispatcher$1.register("flag-closed", function(data) {
        invokeTrigger(data.id, "flag.close");
        if (_flags[data.id]) delete _flags[data.id];
    });
    EventDispatcher$1.register("flag-action-invoked", function(data) {
        invokeTrigger(data.id, "flag.action", {
            actionIdentifier: data.actionId
        });
    });
    var flag = {
        /**
    * @name create
    * @method
    * @description Creates a new flag.
    * @param {Object} options           Options of the flag.
    * @param {String} options.title     The title text of the flag.
    * @param {String} options.body      The body text of the flag.
    * @param {String} options.type=info Sets the type of the message. Valid options are "info", "success", "warning" and "error".
    * @param {String} options.close     The closing behaviour that this flag has. Valid options are "manual", and "auto".
    * @param {Object} options.actions   Map of {actionIdentifier: 'Action link text'} to add to the flag. The actionIdentifier will be passed to a 'flag.action' event if the link is clicked.
    * @returns {Flag~Flag}
    * @example
    * // Display a nice green flag using the Flags JavaScript API.
    * var flag = AP.flag.create({
    *   title: 'Successfully created a flag.',
    *   body: 'This is a flag.',
    *   type: 'success',
    *   actions: {
    *     'actionkey': 'Click me'
    *   }
    * });
    */ create: {
            constructor: Flag$1,
            close: Flag$1.prototype.close
        }
    };
    var analytics$1 = {
        trackDeprecatedMethodUsed: function trackDeprecatedMethodUsed(methodUsed, callback) {
            callback = Util.last(arguments);
            AnalyticsAction.trackDeprecatedMethodUsed(methodUsed, callback._context.extension);
        }
    };
    var TRIGGER_PERCENTAGE = 10; //% before scroll events are fired
    var activeGeneralPageAddon;
    var lastScrollEventTriggered; //top or bottom
    EventDispatcher$1.register("iframe-bridge-established", function(data) {
        if (data.extension.options.isFullPage) {
            window.addEventListener("scroll", scrollEventHandler);
            activeGeneralPageAddon = data.extension.id;
        }
    });
    EventDispatcher$1.register("iframe-destroyed", function(extension) {
        removeScrollEvent();
    });
    EventDispatcher$1.register("iframe-unload", function(extension) {
        removeScrollEvent();
    });
    function removeScrollEvent() {
        window.removeEventListener("scroll", scrollEventHandler);
        activeGeneralPageAddon = undefined;
        lastScrollEventTriggered = undefined;
    }
    function scrollEventHandler() {
        var documentHeight = document.documentElement.scrollHeight;
        var windowHeight = window.innerHeight;
        var boundary = documentHeight * (TRIGGER_PERCENTAGE / 100);
        if (window.pageYOffset <= boundary) triggerEvent("nearTop");
        else if (windowHeight + window.pageYOffset + boundary >= documentHeight) triggerEvent("nearBottom");
        else lastScrollEventTriggered = undefined;
    }
    function triggerEvent(type) {
        if (lastScrollEventTriggered === type) return; // only once per scroll.
        EventActions.broadcast("scroll." + type, {
            id: activeGeneralPageAddon
        }, {});
        lastScrollEventTriggered = type;
    }
    var scrollPosition = {
        /**
     * Get's the scroll position relative to the browser viewport
     *
     * @param callback {Function} callback to pass the scroll position
     * @noDemo
     * @example
     * AP.scrollPosition.getPosition(function(obj) { console.log(obj); });
     */ getPosition: function getPosition(callback) {
            callback = Util.last(arguments); // scrollPosition.getPosition is only available for general-pages
            if (callback._context.extension.options.isFullPage) {
                var $el = Util.getIframeByExtensionId(callback._context.extension_id);
                var offset = $el.offset();
                var $window = $(window);
                callback({
                    scrollY: $window.scrollTop() - offset.top,
                    scrollX: $window.scrollLeft() - offset.left,
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            }
        },
        setVerticalPosition: function setVerticalPosition(y, callback) {
            callback = Util.last(arguments);
            if (callback._context.extension.options && callback._context.extension.options.isFullPage) {
                var $el = Util.getIframeByExtensionId(callback._context.extension_id);
                var offset = $el.offset();
                if (typeof y === "number") document.documentElement.scrollTop = offset.top + y;
            }
        }
    };
    var DropdownActions = {
        // called on action click
        itemSelected: function itemSelected(dropdown_id, item, extension) {
            EventDispatcher$1.dispatch("dropdown-item-selected", {
                id: dropdown_id,
                item: item,
                extension: extension
            });
        }
    };
    /**
  * DO NOT INCLUDE ME IN THE PUBLIC DOCUMENTATION
  * there is no AUI implementation of this
  */ function buildListItem(listItem) {
        var finishedListItem = {};
        if (typeof listItem === "string") finishedListItem.content = listItem;
        else if (listItem.text && typeof listItem.text === "string") {
            finishedListItem.content = listItem.text;
            if (typeof listItem.disabled === "boolean") finishedListItem.disabled = listItem.disabled;
            if (typeof listItem.itemId !== "undefined") finishedListItem.itemId = listItem.itemId;
        } else throw new Error("Unknown dropdown list item format.");
        return finishedListItem;
    }
    function moduleListToApiList(list) {
        return list.map(function(item) {
            if (item.list && Array.isArray(item.list)) {
                var returnval = {
                    heading: item.heading
                };
                returnval.items = item.list.map(function(listitem) {
                    return buildListItem(listitem);
                });
                return returnval;
            }
        });
    }
    /**
  * @class DropdownItem
  * A single item in a dropdown menu can be a string or an object
  * @param {String} itemId The id of a single dropdown item
  * @param {String} text    The text to display in the dropdown item
  */ /**
  * @module Dropdown
  * @description Dropdown menu that can go outside the iframe bounds.
  * @example
  * // create a dropdown menu with 1 section and 2 items
  * var mydropdown = {
  *   dropdownId: 'my-dropdown',
  *   list: [{
  *     heading: 'section heading',
  *     list: [
  *       {text: 'one'},
  *       {text: 'two'}
  *     ]
  *   }]
  * };
  *
  * AP.events.on('dropdown-item-selected', (data) =>{
  *   console.log('dropdown item selected', data.dropdownId, data.item);
  * });
  *
  * AP.dropdown.create(mydropdown);
  * // button is an element in our document that triggered the dropdown
  * let rect = document.querySelector('button').getBoundingClientRect();
  * AP.dropdown.showAt('my-dropdown', rect.left, rect.top, rect.width);
  *
  */ var dropdown = {
        /**
    * @name create
    * @method
    * @description Creates a new dropdown.
    * @param {Object} options             Options of the dropdown.
    * @param {String} options.dropdownId A unique identifier for the dropdown that will be referenced in events.
    * @param {String} options.list        An array containing dropdown items {Dropdown~DropdownItem}
    * @example
    * // create a dropdown menu with 1 section and 2 items
    * var mydropdown = {
    *   dropdownId: 'my-dropdown',
    *   list: [{
    *     heading: 'section heading',
    *     list: [
    *       {text: 'one'},
    *       {text: 'two'}
    *     ]
    *   }]
    * };
    *
    * AP.dropdown.create(mydropdown);
    */ create: function create(options, callback) {
            callback = Util.last(arguments);
            if (typeof options !== "object") return;
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dropdownProvider = frameworkAdaptor.getProviderByModuleName("dropdown");
            if (dropdownProvider) {
                var dropdownGroups = moduleListToApiList(options.list);
                var dropdownProviderOptions = {
                    dropdownId: options.dropdownId,
                    dropdownGroups: dropdownGroups,
                    dropdownItemNotifier: function dropdownItemNotifier(data) {
                        DropdownActions.itemSelected(data.dropdownId, data.item, callback._context.extension);
                    }
                };
                dropdownProvider.create(dropdownProviderOptions, callback._context);
                return dropdownProviderOptions;
            }
        },
        /**
    * @name showAt
    * @method
    * @description Displays a created dropdown menu.
    * @param {String} dropdownId   Id used when creating the dropdown
    * @param {String} x             x position from the edge of your iframe to display
    * @param {String} y             y position from the edge of your iframe to display
    * @param {String} width         Optionally enforce a width for the dropdown menu
    * @example
    * // create a dropdown menu with 1 section and 2 items
    * var mydropdown = {
    *   dropdownId: 'my-dropdown',
    *   list: [{
    *     list:['one', 'two']
    *   }]
    * };
    *
    * AP.dropdown.create(mydropdown);
    * // Get the button that activated the dropdown
    * let rect = document.querySelector('button').getBoundingClientRect();
    * AP.dropdown.showAt('my-dropdown', rect.left, rect.top, rect.width);
    */ showAt: function showAt(dropdownId, x, y, width) {
            var callback = Util.last(arguments);
            var rect = {
                left: 0,
                top: 0
            };
            var iframe = document.getElementById(callback._context.extension_id);
            if (iframe) rect = iframe.getBoundingClientRect();
            else console.error("ACJS: no iframe found for dropdown");
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dropdownProvider = frameworkAdaptor.getProviderByModuleName("dropdown");
            if (dropdownProvider) {
                var dropdownProviderArgs = {
                    dropdownId: dropdownId,
                    x: x,
                    y: y,
                    width: width
                };
                dropdownProvider.showAt(dropdownProviderArgs, {
                    iframeDimensions: rect,
                    onItemSelection: function onItemSelection(dropdownId, item) {
                        DropdownActions.itemSelected(dropdownId, item, callback._context.extension);
                    }
                });
            }
        },
        /**
    * @name hide
    * @method
    * @description Hide a dropdown menu
    * @param {String} dropdownId The id of the dropdown to hide
    * @example
    * AP.dropdown.create('my-dropdown');
    * AP.dropdown.hide('my-dropdown');
    */ hide: function hide(id) {
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dropdownProvider = frameworkAdaptor.getProviderByModuleName("dropdown");
            if (dropdownProvider) dropdownProvider.hide(id);
        },
        /**
    * @name itemDisable
    * @method
    * @description Disable an item in the dropdown menu
    * @param {String} dropdownId The id of the dropdown
    * @param {String} itemId     The dropdown item to disable
    * @example
    * AP.dropdown.create('my-dropdown');
    * AP.dropdown.itemDisable('my-dropdown', 'item-id');
    */ itemDisable: function itemDisable(dropdownId, itemId) {
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dropdownProvider = frameworkAdaptor.getProviderByModuleName("dropdown");
            if (dropdownProvider) dropdownProvider.itemDisable(dropdownId, itemId);
        },
        /**
    * @name itemEnable
    * @method
    * @description Hide a dropdown menu
    * @param {String} dropdownId The id of the dropdown
    * @param {String} itemId The id of the dropdown item to enable
    * @example
    * AP.dropdown.create('my-dropdown');
    * AP.dropdown.itemEnable('my-dropdown', 'item-id');
    */ itemEnable: function itemEnable(dropdownId, itemId) {
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dropdownProvider = frameworkAdaptor.getProviderByModuleName("dropdown");
            if (dropdownProvider) dropdownProvider.itemEnable(dropdownId, itemId);
        }
    };
    EventDispatcher$1.register("dropdown-item-selected", function(data) {
        EventActions.broadcast("dropdown-item-selected", {
            addon_key: data.extension.addon_key,
            key: data.extension.key
        }, {
            dropdownId: data.id,
            item: data.item
        });
    }); // friendly unload with connectHost.destroy
    EventDispatcher$1.register("iframe-destroyed", function(data) {
        var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
        var dropdownProvider = frameworkAdaptor.getProviderByModuleName("dropdown");
        if (dropdownProvider) dropdownProvider.destroyByExtension(data.extension.extension_id);
    }); // unfriendly unload by removing the iframe from the DOM
    EventDispatcher$1.register("after:iframe-unload", function(data) {
        var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
        var dropdownProvider = frameworkAdaptor.getProviderByModuleName("dropdown");
        if (dropdownProvider) dropdownProvider.destroyByExtension(data.extension.extension_id);
    });
    /**
  * Hosts are the primary method for Connect apps to interact with the page.
  * @module Host
  */ var TEXT_NODE_TYPE = 3;
    var host$1 = {
        /*
     This function could be used in Connect app for moving focus to Host app.
     As Connect App - iframe app, it can get control. When it's happen - host app events such short-cuts
     stop working. This function could help in this case.
    */ focus: function focus() {
            window.document.querySelector("a").focus({
                preventScroll: true
            });
            window.document.querySelector("a").blur();
        },
        /**
     * Gets the selected text on the page.
     * @noDemo
     * @name getSelectedText
     * @method
     * @param {Function} callback - Callback method to be executed with the selected text.
     * @example
     * AP.host.getSelectedText(function (selection) {
     *   console.log(selection);
     * });
     *
     */ getSelectedText: function getSelectedText(callback) {
            var text = "";
            var selection = window.document.getSelection();
            if (selection && selection.anchorNode && selection.anchorNode.nodeType === TEXT_NODE_TYPE) text = selection.toString();
            callback(text);
        }
    };
    var WebItem = /*#__PURE__*/ function() {
        function WebItem() {
            this._webitems = {};
            this._contentResolver = function noop() {};
        }
        var _proto = WebItem.prototype;
        _proto.setContentResolver = function setContentResolver(resolver) {
            this._contentResolver = resolver;
        };
        _proto.requestContent = function requestContent(extension) {
            if (extension.addon_key && extension.key) return this._contentResolver.call(null, Util.extend({
                classifier: "json"
            }, extension));
        } // originally i had this written nicely with Object.values but
        ;
        _proto.getWebItemsBySelector = function getWebItemsBySelector(selector) {
            var _this = this;
            var returnVal;
            var keys = Object.getOwnPropertyNames(this._webitems).some(function(key) {
                var obj = _this._webitems[key];
                if (obj.selector) {
                    if (obj.selector.trim() === selector.trim()) {
                        returnVal = obj;
                        return true;
                    }
                }
                return false;
            });
            return returnVal;
        };
        _proto.setWebItem = function setWebItem(potentialWebItem) {
            return this._webitems[potentialWebItem.name] = {
                name: potentialWebItem.name,
                selector: potentialWebItem.selector,
                triggers: potentialWebItem.triggers
            };
        };
        _proto._removeTriggers = function _removeTriggers(webitem) {
            var _this2 = this;
            var onTriggers = WebItemUtils.sanitizeTriggers(webitem.triggers);
            $(function() {
                $("body").off(onTriggers, webitem.selector, _this2._webitems[webitem.name]._on);
            });
            delete this._webitems[webitem.name]._on;
        };
        _proto._addTriggers = function _addTriggers(webitem) {
            var onTriggers = WebItemUtils.sanitizeTriggers(webitem.triggers);
            webitem._on = function(event) {
                event.preventDefault();
                var $target = $(event.target).closest(webitem.selector);
                var convertedOptions = WebItemUtils.getConfigFromTarget($target);
                var extensionUrl = convertedOptions && convertedOptions.url ? convertedOptions.url : undefined;
                var extension = {
                    addon_key: WebItemUtils.getExtensionKey($target),
                    key: WebItemUtils.getKey($target),
                    options: WebItemUtils.getOptionsForWebItem($target),
                    url: extensionUrl
                };
                WebItemActions.webitemInvoked(webitem, event, extension);
            };
            $(function() {
                $("body").on(onTriggers, webitem.selector, webitem._on);
            });
        };
        return WebItem;
    }();
    var webItemInstance = new WebItem();
    EventDispatcher$1.register("webitem-added", function(data) {
        webItemInstance._addTriggers(data.webitem);
    });
    EventDispatcher$1.register("content-resolver-register-by-extension", function(data) {
        webItemInstance.setContentResolver(data.callback);
    });
    document.addEventListener("aui-responsive-menu-item-created", function(e) {
        var oldWebItem = e.detail.originalItem.querySelector('a[class*="ap-"]');
        if (oldWebItem) {
            var newWebItem = e.detail.newItem.querySelector("a");
            var classList = [].slice.call(oldWebItem.classList);
            classList.forEach(function(cls) {
                if (/^ap-/.test(cls)) newWebItem.classList.add(cls);
            });
        }
    });
    var WebItemActions = {
        addWebItem: function addWebItem(potentialWebItem) {
            var webitem;
            var existing = webItemInstance.getWebItemsBySelector(potentialWebItem.selector);
            if (existing) return false;
            else {
                webitem = webItemInstance.setWebItem(potentialWebItem);
                EventDispatcher$1.dispatch("webitem-added", {
                    webitem: webitem
                });
            }
        },
        webitemInvoked: function webitemInvoked(webitem, event, extension) {
            EventDispatcher$1.dispatch("webitem-invoked:" + webitem.name, {
                webitem: webitem,
                event: event,
                extension: extension
            });
        }
    };
    var InlineDialogWebItemActions = {
        addExtension: function addExtension(data) {
            EventDispatcher$1.dispatch("inline-dialog-extension", {
                $el: data.$el,
                extension: data.extension
            });
        }
    };
    var InlineDialog = /*#__PURE__*/ function() {
        function InlineDialog() {}
        var _proto = InlineDialog.prototype;
        _proto.resize = function resize(data) {
            var width = Util.stringToDimension(data.width);
            var height = Util.stringToDimension(data.height);
            var $content = data.$el.find(".contents");
            if ($content.length === 1) {
                $content.css({
                    width: width,
                    height: height
                });
                InlineDialogActions.refresh(data.$el);
            }
        };
        _proto.refresh = function refresh($el) {
            $el[0].popup.reset();
        };
        _proto._getInlineDialog = function _getInlineDialog($el) {
            return AJS.InlineDialog($el);
        };
        _proto._renderContainer = function _renderContainer() {
            return $("<div />").addClass("aui-inline-dialog-contents");
        };
        _proto._displayInlineDialog = function _displayInlineDialog(data) {
            InlineDialogActions.created({
                $el: data.$el,
                trigger: data.trigger,
                extension: data.extension
            });
        };
        _proto.hideInlineDialog = function hideInlineDialog($el) {
            $el.hide();
        };
        _proto.closeInlineDialog = function closeInlineDialog() {
            $(".aui-inline-dialog").filter(function() {
                return $(this).find(".ap-iframe-container").length > 0;
            }).hide();
        };
        _proto.render = function render(data) {
            var _this = this;
            var $inlineDialog = $(document.getElementById("inline-dialog-" + data.id));
            if ($inlineDialog.length !== 0) $inlineDialog.remove();
            var $el = AJS.InlineDialog(data.bindTo, data.id, function($placeholder, trigger, showInlineDialog) {
                $placeholder.append(data.$content);
                _this._displayInlineDialog({
                    extension: data.extension,
                    $el: $placeholder,
                    trigger: trigger
                });
                showInlineDialog();
            }, data.inlineDialogOptions);
            return $el;
        };
        return InlineDialog;
    }();
    var InlineDialogComponent = new InlineDialog();
    EventDispatcher$1.register("iframe-resize", function(data) {
        var container = data.$el.parents(".aui-inline-dialog");
        if (container.length === 1) InlineDialogComponent.resize({
            width: data.width,
            height: data.height,
            $el: container
        });
    });
    EventDispatcher$1.register("inline-dialog-refresh", function(data) {
        InlineDialogComponent.refresh(data.$el);
    });
    EventDispatcher$1.register("inline-dialog-hide", function(data) {
        InlineDialogComponent.hideInlineDialog(data.$el);
    });
    EventDispatcher$1.register("inline-dialog-close", function(data) {
        InlineDialogComponent.closeInlineDialog();
    });
    var ITEM_NAME = "inline-dialog";
    var SELECTOR = ".ap-inline-dialog";
    var TRIGGERS = [
        "mouseover",
        "click"
    ];
    var WEBITEM_UID_KEY = "inline-dialog-target-uid";
    var InlineDialogWebItem = /*#__PURE__*/ function() {
        function InlineDialogWebItem() {
            this._inlineDialogWebItemSpec = {
                name: ITEM_NAME,
                selector: SELECTOR,
                triggers: TRIGGERS
            };
            this._inlineDialogWebItems = {};
        }
        var _proto = InlineDialogWebItem.prototype;
        _proto.getWebItem = function getWebItem() {
            return this._inlineDialogWebItemSpec;
        };
        _proto._createInlineDialog = function _createInlineDialog(data) {
            var $inlineDialog = InlineDialogComponent.render({
                extension: data.extension,
                id: data.id,
                bindTo: data.$target,
                $content: $("<div />"),
                inlineDialogOptions: data.extension.options
            });
            return $inlineDialog;
        };
        _proto.triggered = function triggered(data) {
            // don't trigger on hover, when hover is not specified.
            if (data.event.type !== "click" && !data.extension.options.onHover) return;
            var $target = $(data.event.currentTarget);
            var webitemId = $target.data(WEBITEM_UID_KEY);
            var $inlineDialog = this._createInlineDialog({
                id: webitemId,
                extension: data.extension,
                $target: $target,
                options: data.extension.options || {}
            });
            $inlineDialog.show();
        };
        _proto.opened = function opened(data) {
            var $existingFrame = data.$el.find("iframe");
            var isExistingFrame = $existingFrame && $existingFrame.length === 1; // existing iframe is already present and src is still valid (either no jwt or jwt has not expired).
            if (isExistingFrame) {
                var src = $existingFrame.attr("src");
                var srcPresent = src.length > 0;
                if (srcPresent) {
                    var srcHasJWT = urlUtils.hasJwt(src);
                    var srcHasValidJWT = srcHasJWT && !urlUtils.isJwtExpired(src);
                    if (srcHasValidJWT || !srcHasJWT) return false;
                }
            }
            var contentRequest = webItemInstance.requestContent(data.extension);
            if (!contentRequest) {
                console.warn("no content resolver found");
                return false;
            }
            contentRequest.then(function(content) {
                content.options = content.options || {};
                Util.extend(content.options, {
                    autoresize: true,
                    widthinpx: true
                });
                InlineDialogWebItemActions.addExtension({
                    $el: data.$el,
                    extension: content
                });
            });
            return true;
        };
        _proto.addExtension = function addExtension(data) {
            var addon = create(data.extension);
            data.$el.empty().append(addon);
        };
        _proto.createIfNotExists = function createIfNotExists(data) {
            var $target = $(data.event.currentTarget);
            var uid = $target.data(WEBITEM_UID_KEY);
            if (!uid) {
                uid = WebItemUtils.uniqueId();
                $target.data(WEBITEM_UID_KEY, uid);
            }
        };
        return InlineDialogWebItem;
    }();
    var inlineDialogInstance = new InlineDialogWebItem();
    var webitem = inlineDialogInstance.getWebItem();
    EventDispatcher$1.register("before:webitem-invoked:" + webitem.name, function(data) {
        inlineDialogInstance.createIfNotExists(data);
    });
    EventDispatcher$1.register("webitem-invoked:" + webitem.name, function(data) {
        inlineDialogInstance.triggered(data);
    });
    EventDispatcher$1.register("inline-dialog-opened", function(data) {
        inlineDialogInstance.opened(data);
    });
    EventDispatcher$1.register("inline-dialog-extension", function(data) {
        inlineDialogInstance.addExtension(data);
    });
    WebItemActions.addWebItem(webitem);
    var ITEM_NAME$1 = "dialog";
    var SELECTOR$1 = ".ap-dialog";
    var TRIGGERS$1 = [
        "click"
    ];
    var WEBITEM_UID_KEY$1 = "dialog-target-uid";
    var DEFAULT_WEBITEM_OPTIONS = {
        chrome: true
    };
    var DialogWebItem = /*#__PURE__*/ function() {
        function DialogWebItem() {
            this._dialogWebItem = {
                name: ITEM_NAME$1,
                selector: SELECTOR$1,
                triggers: TRIGGERS$1
            };
        }
        var _proto = DialogWebItem.prototype;
        _proto.getWebItem = function getWebItem() {
            return this._dialogWebItem;
        };
        _proto._dialogOptions = function _dialogOptions(options) {
            return Util.extend({}, DEFAULT_WEBITEM_OPTIONS, options || {});
        };
        _proto.triggered = function triggered(data) {
            var $target = $(data.event.currentTarget);
            var webitemId = $target.data(WEBITEM_UID_KEY$1);
            var dialogOptions = this._dialogOptions(data.extension.options);
            dialogOptions.id = webitemId;
            DialogExtensionActions.open(data.extension, dialogOptions);
        };
        _proto.createIfNotExists = function createIfNotExists(data) {
            var $target = $(data.event.currentTarget);
            var uid = $target.data(WEBITEM_UID_KEY$1);
            if (!uid) {
                uid = WebItemUtils.uniqueId();
                $target.data(WEBITEM_UID_KEY$1, uid);
            }
        };
        return DialogWebItem;
    }();
    var dialogInstance = new DialogWebItem();
    var webitem$1 = dialogInstance.getWebItem();
    EventDispatcher$1.register("webitem-invoked:" + webitem$1.name, function(data) {
        dialogInstance.triggered(data);
    });
    EventDispatcher$1.register("before:webitem-invoked:" + webitem$1.name, dialogInstance.createIfNotExists);
    WebItemActions.addWebItem(webitem$1);
    /**
   * Private namespace for host-side code.
   * @type {*|{}}
   * @private
   * @deprecated use AMD instead of global namespaces. The only thing that should be on _AP is _AP.define and _AP.require.
   */ if (!window._AP) window._AP = {};
    /*
   * Add version
   */ if (!window._AP.version) window._AP.version = "5.2.51";
    host.defineModule("messages", messages);
    host.defineModule("flag", flag);
    host.defineModule("dialog", dialog);
    host.defineModule("inlineDialog", inlineDialog);
    host.defineModule("env", env);
    host.defineModule("events", events);
    host.defineModule("_analytics", analytics$1);
    host.defineModule("scrollPosition", scrollPosition);
    host.defineModule("dropdown", dropdown);
    host.defineModule("host", host$1);
    EventDispatcher$1.register("module-define-custom", function(data) {
        host.defineModule(data.name, data.methods);
    });
    host.registerRequestNotifier(function(data) {
        var dispatchEvent = function dispatchEvent() {
            if (data.type === "req") analytics.dispatch("bridge.invokemethod", {
                module: data.module,
                fn: data.fn,
                addonKey: data.addon_key,
                moduleKey: data.key
            });
            else if (data.type === "sub") analytics.dispatch("bridge.register-sub", {
                subAddonKey: data.sub.addon_key,
                subModuleKey: data.sub.key,
                addonKey: data.addon_key,
                moduleKey: data.key
            });
        };
        if (typeof window.requestIdleCallback === "function") window.requestIdleCallback(dispatchEvent, {
            timeout: 1000
        });
        else dispatchEvent();
    });
    return HostApi$1;
});

});

parcelRegister("jhBUl", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                /**
* The History API allows your add-on to manipulate the current page URL for use in navigation. When using
* the history module only the page anchor is modified and not the entire window location.
*
* Note: This is only enabled for page modules (Admin page, General page, Configure page, User profile page).
* It cannot be used if the page module is launched as a dialog.
* ### Example ###
* ```
* // Register a function to run when state is changed.
* // You should use this to update your UI to show the state.
* AP.history.popState(function(e){
*     alert("The URL has changed from: " + e.oldURL + "to: " + e.newURL);
* });
*
* // Adds a new entry to the history and changes the url in the browser.
* AP.history.pushState("page2");
*
* // Changes the URL back and invokes any registered popState callbacks.
* AP.history.back();
* ```
* @module History
*/ "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _constants = _dereq_("./constants");
                var _models = _dereq_("./models");
                var _utils = _dereq_("./utils");
                function broadcastEvents(eventName, evt) {
                    (0, _utils.callConnectHost)(function(ch) {
                        var extensions = (0, _utils.values)(ch.getExtensions());
                        extensions.forEach(function(ext) {
                            var addonKey = ext.extension.addon_key;
                            var current = new _models.Current({
                                url: window.location.href,
                                state: evt.state
                            });
                            var route = new _models.Route(current);
                            ch.broadcastEvent(eventName, {
                                addon_key: addonKey
                            }, route.render(addonKey));
                        });
                    });
                }
                var registeredWindowListeners = false;
                function registerWindowListeners() {
                    if (registeredWindowListeners) return;
                    window.addEventListener("popstate", function(e) {
                        var evt = (0, _utils.createEvent)("ap_popstate");
                        evt.state = (0, _utils.unwrapState)(e.state);
                        window.dispatchEvent(evt);
                    });
                    window.addEventListener("ap_popstate", function(e) {
                        var evt = (0, _utils.createEvent)("ap_changestate");
                        evt.state = e.state;
                        window.dispatchEvent(evt);
                        broadcastEvents(_constants.HISTORY_POPSTATE, e);
                    });
                    window.addEventListener("ap_pushstate", function(e) {
                        broadcastEvents(_constants.HISTORY_PUSHSTATE, e);
                    });
                    window.addEventListener("ap_replacestate", function(e) {
                        broadcastEvents(_constants.HISTORY_REPLACESTATE, e);
                    });
                    window.addEventListener("ap_changestate", function(e) {
                        broadcastEvents(_constants.HISTORY_CHANGESTATE, e);
                    });
                    registeredWindowListeners = true;
                }
                function _pushState(route) {
                    var renderedState = route.state.render();
                    var renderedURL = route.url.render();
                    window.history.pushState((0, _utils.wrapState)(renderedState), renderedURL.title, renderedURL.url);
                }
                function _replaceState(route) {
                    var renderedState = route.state.render();
                    var renderedURL = route.url.render();
                    window.history.replaceState((0, _utils.wrapState)(renderedState), renderedURL.title, renderedURL.url);
                }
                exports["default"] = {
                    _registerWindowListeners: function _registerWindowListeners() {
                        registerWindowListeners();
                    },
                    /**
  * Goes back one step in the joint session history. Will invoke the popState callback.
  * @noDemo
  * @example
  * AP.history.back(); // go back by 1 entry in the browser history.
  */ back: function back(callback) {
                        callback = arguments[arguments.length - 1];
                        this.go(-1, callback);
                    },
                    /**
  * Goes back one step in the joint session history. Will invoke the popState callback.
  * @noDemo
  * @example
  * AP.history.forward(); // go forward by 1 entry in the browser history.
  */ forward: function forward(callback) {
                        callback = arguments[arguments.length - 1];
                        this.go(1, callback);
                    },
                    /**
  * Moves the page history back or forward the specified number of steps. A zero delta will reload the current page.
  * If the delta is out of range, does nothing. This call invoke the popState callback.
  * @param {Integer} delta - Number of places to move in the history
  * @noDemo
  * @example
  * AP.history.go(-2); // go back by 2 entries in the browser history.
  */ go: function go(delta) {
                        var callback = arguments[arguments.length - 1];
                        if (callback._context.extension.options.isFullPage) window.history.go(delta);
                        else (0, _utils.log)("History is only available to page modules");
                    },
                    /**
  * Retrieves the current state of the history stack and returns the value. The returned value is the same as what was set with the pushState method.
  * @return {String} The current url anchor
  * @noDemo
  * @example
  * AP.history.pushState("page5");
  * AP.history.getState(); // returns "page5";
  */ getState: function getState(type, callback) {
                        callback = arguments[arguments.length - 1];
                        var addonKey = callback._context.extension.addon_key;
                        var current = new _models.Current({
                            url: window.location.href,
                            state: (0, _utils.unwrapState)(window.history.state)
                        });
                        var route = new _models.Route(current);
                        var rendered = route.render(addonKey);
                        type = type ? typeof type === "string" ? type : "hash" : "hash";
                        if (type === "hash") callback(rendered.hash);
                        else if (type === "all") callback(rendered);
                        else throw new Error("invalid type for getState");
                    },
                    /**
  * Updates the location's anchor with the specified value and pushes the given data onto the session history.
  * Does not invoke popState callback.
  * @param {Object} newState
  * @param {String} title
  * @param {String} url - URL to add to history
  */ pushState: function pushState(newState, callback) {
                        callback = arguments[arguments.length - 1];
                        var addonKey = callback._context.extension.addon_key;
                        var current = new _models.Current({
                            url: window.location.href,
                            state: (0, _utils.unwrapState)(window.history.state)
                        });
                        var currentRoute = new _models.Route(current);
                        var change = new _models.Change(newState, addonKey);
                        var changeRoute = new _models.Route(change);
                        if (callback._context.extension.options.isFullPage) {
                            if (changeRoute.url.isURLEqual(currentRoute.url)) {
                                currentRoute.merge(changeRoute);
                                _replaceState(currentRoute);
                            } else if (changeRoute.url.isPathnameEqual(currentRoute.url)) {
                                currentRoute.merge(changeRoute);
                                _pushState(currentRoute);
                            } else _pushState(changeRoute);
                            var _event = (0, _utils.createEvent)("ap_pushstate");
                            _event.state = (0, _utils.unwrapState)(window.history.state);
                            window.dispatchEvent(_event);
                        } else (0, _utils.log)("History is only available to page modules");
                    },
                    /**
  * Updates the current entry in the session history. Updates the location's anchor with the specified value but does not change the session history. Does not invoke popState callback.
  * @param {String} url - URL to update current history value with
  */ replaceState: function replaceState(newState, callback) {
                        callback = arguments[arguments.length - 1];
                        var addonKey = callback._context.extension.addon_key;
                        var current = new _models.Current({
                            url: window.location.href,
                            state: (0, _utils.unwrapState)(window.history.state)
                        });
                        var currentRoute = new _models.Route(current);
                        var change = new _models.Change(newState, addonKey);
                        var changeRoute = new _models.Route(change);
                        if (callback._context.extension.options.isFullPage) {
                            if (changeRoute.url.isURLEqual(currentRoute.url)) {
                                currentRoute.merge(changeRoute);
                                _replaceState(currentRoute);
                            } else if (changeRoute.url.isPathnameEqual(currentRoute.url)) {
                                currentRoute.merge(changeRoute);
                                _replaceState(currentRoute);
                            } else _replaceState(changeRoute);
                            var _event2 = (0, _utils.createEvent)("ap_replacestate");
                            _event2.state = (0, _utils.unwrapState)(window.history.state);
                            window.dispatchEvent(_event2);
                        } else (0, _utils.log)("History is only available to page modules");
                    }
                };
                module1.exports = exports["default"];
            },
            {
                "./constants": 7,
                "./models": 8,
                "./utils": 9
            }
        ],
        2: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    (function(root) {
                        /** Detect free variables */ var freeExports = typeof exports == "object" && exports;
                        var freeModule = typeof module1 == "object" && module1 && module1.exports == freeExports && module1;
                        var freeGlobal = typeof global1 == "object" && global1;
                        if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) root = freeGlobal;
                        /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^ -~]/, regexSeparators = /\x2E|\u3002|\uFF0E|\uFF61/g, /** Error messages */ errors = {
                            "overflow": "Overflow: input needs wider integers to process",
                            "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                            "invalid-input": "Invalid input"
                        }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
                        /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
                            throw RangeError(errors[type]);
                        }
                        /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
                            var length = array.length;
                            while(length--)array[length] = fn(array[length]);
                            return array;
                        }
                        /**
	 * A simple `Array#map`-like wrapper to work with domain name strings.
	 * @private
	 * @param {String} domain The domain name.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
                            return map(string.split(regexSeparators), fn).join(".");
                        }
                        /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <http://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
                            var output = [], counter = 0, length = string.length, value, extra;
                            while(counter < length){
                                value = string.charCodeAt(counter++);
                                if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                                    // high surrogate, and there is a next character
                                    extra = string.charCodeAt(counter++);
                                    if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                                    else {
                                        // unmatched surrogate; only append this code unit, in case the next
                                        // code unit is the high surrogate of a surrogate pair
                                        output.push(value);
                                        counter--;
                                    }
                                } else output.push(value);
                            }
                            return output;
                        }
                        /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
                            return map(array, function(value) {
                                var output = "";
                                if (value > 0xFFFF) {
                                    value -= 0x10000;
                                    output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                                    value = 0xDC00 | value & 0x3FF;
                                }
                                output += stringFromCharCode(value);
                                return output;
                            }).join("");
                        }
                        /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
                            if (codePoint - 48 < 10) return codePoint - 22;
                            if (codePoint - 65 < 26) return codePoint - 65;
                            if (codePoint - 97 < 26) return codePoint - 97;
                            return base;
                        }
                        /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
                            //  0..25 map to ASCII a..z or A..Z
                            // 26..35 map to ASCII 0..9
                            return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
                        }
                        /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
                            var k = 0;
                            delta = firstTime ? floor(delta / damp) : delta >> 1;
                            delta += floor(delta / numPoints);
                            for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
                            return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
                        }
                        /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
                            // Don't use UCS-2
                            var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
                            // Handle the basic code points: let `basic` be the number of input code
                            // points before the last delimiter, or `0` if there is none, then copy
                            // the first basic code points to the output.
                            basic = input.lastIndexOf(delimiter);
                            if (basic < 0) basic = 0;
                            for(j = 0; j < basic; ++j){
                                // if it's not a basic code point
                                if (input.charCodeAt(j) >= 0x80) error("not-basic");
                                output.push(input.charCodeAt(j));
                            }
                            // Main decoding loop: start just after the last delimiter if any basic code
                            // points were copied; start at the beginning otherwise.
                            for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
                                // `index` is the index of the next character to be consumed.
                                // Decode a generalized variable-length integer into `delta`,
                                // which gets added to `i`. The overflow checking is easier
                                // if we increase `i` as we go, then subtract off its starting
                                // value at the end to obtain `delta`.
                                for(oldi = i, w = 1, k = base;; k += base){
                                    if (index >= inputLength) error("invalid-input");
                                    digit = basicToDigit(input.charCodeAt(index++));
                                    if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                                    i += digit * w;
                                    t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                                    if (digit < t) break;
                                    baseMinusT = base - t;
                                    if (w > floor(maxInt / baseMinusT)) error("overflow");
                                    w *= baseMinusT;
                                }
                                out = output.length + 1;
                                bias = adapt(i - oldi, out, oldi == 0);
                                // `i` was supposed to wrap around from `out` to `0`,
                                // incrementing `n` each time, so we'll fix that now:
                                if (floor(i / out) > maxInt - n) error("overflow");
                                n += floor(i / out);
                                i %= out;
                                // Insert `n` at position `i` of the output
                                output.splice(i++, 0, n);
                            }
                            return ucs2encode(output);
                        }
                        /**
	 * Converts a string of Unicode symbols to a Punycode string of ASCII-only
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
                            var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
                            // Convert the input in UCS-2 to Unicode
                            input = ucs2decode(input);
                            // Cache the length
                            inputLength = input.length;
                            // Initialize the state
                            n = initialN;
                            delta = 0;
                            bias = initialBias;
                            // Handle the basic code points
                            for(j = 0; j < inputLength; ++j){
                                currentValue = input[j];
                                if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
                            }
                            handledCPCount = basicLength = output.length;
                            // `handledCPCount` is the number of code points that have been handled;
                            // `basicLength` is the number of basic code points.
                            // Finish the basic string - if it is not empty - with a delimiter
                            if (basicLength) output.push(delimiter);
                            // Main encoding loop:
                            while(handledCPCount < inputLength){
                                // All non-basic code points < n have been handled already. Find the next
                                // larger one:
                                for(m = maxInt, j = 0; j < inputLength; ++j){
                                    currentValue = input[j];
                                    if (currentValue >= n && currentValue < m) m = currentValue;
                                }
                                // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
                                // but guard against overflow
                                handledCPCountPlusOne = handledCPCount + 1;
                                if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
                                delta += (m - n) * handledCPCountPlusOne;
                                n = m;
                                for(j = 0; j < inputLength; ++j){
                                    currentValue = input[j];
                                    if (currentValue < n && ++delta > maxInt) error("overflow");
                                    if (currentValue == n) {
                                        // Represent delta as a generalized variable-length integer
                                        for(q = delta, k = base;; k += base){
                                            t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                                            if (q < t) break;
                                            qMinusT = q - t;
                                            baseMinusT = base - t;
                                            output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                                            q = floor(qMinusT / baseMinusT);
                                        }
                                        output.push(stringFromCharCode(digitToBasic(q, 0)));
                                        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                                        delta = 0;
                                        ++handledCPCount;
                                    }
                                }
                                ++delta;
                                ++n;
                            }
                            return output.join("");
                        }
                        /**
	 * Converts a Punycode string representing a domain name to Unicode. Only the
	 * Punycoded parts of the domain name will be converted, i.e. it doesn't
	 * matter if you call it on a string that has already been converted to
	 * Unicode.
	 * @memberOf punycode
	 * @param {String} domain The Punycode domain name to convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(domain) {
                            return mapDomain(domain, function(string) {
                                return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
                            });
                        }
                        /**
	 * Converts a Unicode string representing a domain name to Punycode. Only the
	 * non-ASCII parts of the domain name will be converted, i.e. it doesn't
	 * matter if you call it with a domain that's already in ASCII.
	 * @memberOf punycode
	 * @param {String} domain The domain name to convert, as a Unicode string.
	 * @returns {String} The Punycode representation of the given domain name.
	 */ function toASCII(domain) {
                            return mapDomain(domain, function(string) {
                                return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
                            });
                        }
                        /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
                            /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.2.4",
                            /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <http://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
                                "decode": ucs2decode,
                                "encode": ucs2encode
                            },
                            "decode": decode,
                            "encode": encode,
                            "toASCII": toASCII,
                            "toUnicode": toUnicode
                        };
                        /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
                        // like the following:
                        if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
                            return punycode;
                        });
                        else if (freeExports && !freeExports.nodeType) {
                            if (freeModule) freeModule.exports = punycode;
                            else for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
                        } else root.punycode = punycode;
                    })(this);
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {}
        ],
        3: [
            function(_dereq_, module1, exports) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                var punycode = _dereq_("punycode");
                exports.parse = urlParse;
                exports.resolve = urlResolve;
                exports.resolveObject = urlResolveObject;
                exports.format = urlFormat;
                exports.Url = Url;
                function Url() {
                    this.protocol = null;
                    this.slashes = null;
                    this.auth = null;
                    this.host = null;
                    this.port = null;
                    this.hostname = null;
                    this.hash = null;
                    this.search = null;
                    this.query = null;
                    this.pathname = null;
                    this.path = null;
                    this.href = null;
                }
                // Reference: RFC 3986, RFC 1808, RFC 2396
                // define these here so at least they only have to be
                // compiled once on the first module load.
                var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // RFC 2396: characters reserved for delimiting URLs.
                // We actually just auto-escape these.
                delims = [
                    "<",
                    ">",
                    '"',
                    "`",
                    " ",
                    "\r",
                    "\n",
                    "	"
                ], // RFC 2396: characters not allowed for various reasons.
                unwise = [
                    "{",
                    "}",
                    "|",
                    "\\",
                    "^",
                    "`"
                ].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
                autoEscape = [
                    "'"
                ].concat(unwise), // Characters that are never ever allowed in a hostname.
                // Note that any invalid chars are also handled, but these
                // are the ones that are *expected* to be seen, so we fast-path
                // them.
                nonHostChars = [
                    "%",
                    "/",
                    "?",
                    ";",
                    "#"
                ].concat(autoEscape), hostEndingChars = [
                    "/",
                    "?",
                    "#"
                ], hostnameMaxLen = 255, hostnamePartPattern = /^[a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
                unsafeProtocol = {
                    "javascript": true,
                    "javascript:": true
                }, // protocols that never have a hostname.
                hostlessProtocol = {
                    "javascript": true,
                    "javascript:": true
                }, // protocols that always contain a // bit.
                slashedProtocol = {
                    "http": true,
                    "https": true,
                    "ftp": true,
                    "gopher": true,
                    "file": true,
                    "http:": true,
                    "https:": true,
                    "ftp:": true,
                    "gopher:": true,
                    "file:": true
                }, querystring = _dereq_("querystring");
                function urlParse(url, parseQueryString, slashesDenoteHost) {
                    if (url && isObject(url) && url instanceof Url) return url;
                    var u = new Url;
                    u.parse(url, parseQueryString, slashesDenoteHost);
                    return u;
                }
                Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
                    if (!isString(url)) throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
                    var rest = url;
                    // trim before proceeding.
                    // This is to support parse stuff like "  http://foo.com  \n"
                    rest = rest.trim();
                    var proto = protocolPattern.exec(rest);
                    if (proto) {
                        proto = proto[0];
                        var lowerProto = proto.toLowerCase();
                        this.protocol = lowerProto;
                        rest = rest.substr(proto.length);
                    }
                    // figure out if it's got a host
                    // user@server is *always* interpreted as a hostname, and url
                    // resolution will treat //foo/bar as host=foo,path=bar because that's
                    // how the browser resolves relative URLs.
                    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
                        var slashes = rest.substr(0, 2) === "//";
                        if (slashes && !(proto && hostlessProtocol[proto])) {
                            rest = rest.substr(2);
                            this.slashes = true;
                        }
                    }
                    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
                        // there's a hostname.
                        // the first instance of /, ?, ;, or # ends the host.
                        //
                        // If there is an @ in the hostname, then non-host chars *are* allowed
                        // to the left of the last @ sign, unless some host-ending character
                        // comes *before* the @-sign.
                        // URLs are obnoxious.
                        //
                        // ex:
                        // http://a@b@c/ => user:a@b host:c
                        // http://a@b?@c => user:a host:c path:/?@c
                        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
                        // Review our test case against browsers more comprehensively.
                        // find the first instance of any hostEndingChars
                        var hostEnd = -1;
                        for(var i = 0; i < hostEndingChars.length; i++){
                            var hec = rest.indexOf(hostEndingChars[i]);
                            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
                        }
                        // at this point, either we have an explicit point where the
                        // auth portion cannot go past, or the last @ char is the decider.
                        var auth, atSign;
                        if (hostEnd === -1) // atSign can be anywhere.
                        atSign = rest.lastIndexOf("@");
                        else // atSign must be in auth portion.
                        // http://a@b/c@d => host:b auth:a path:/c@d
                        atSign = rest.lastIndexOf("@", hostEnd);
                        // Now we have a portion which is definitely the auth.
                        // Pull that off.
                        if (atSign !== -1) {
                            auth = rest.slice(0, atSign);
                            rest = rest.slice(atSign + 1);
                            this.auth = decodeURIComponent(auth);
                        }
                        // the host is the remaining to the left of the first non-host char
                        hostEnd = -1;
                        for(var i = 0; i < nonHostChars.length; i++){
                            var hec = rest.indexOf(nonHostChars[i]);
                            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
                        }
                        // if we still have not hit it, then the entire thing is a host.
                        if (hostEnd === -1) hostEnd = rest.length;
                        this.host = rest.slice(0, hostEnd);
                        rest = rest.slice(hostEnd);
                        // pull out port.
                        this.parseHost();
                        // we've indicated that there is a hostname,
                        // so even if it's empty, it has to be present.
                        this.hostname = this.hostname || "";
                        // if hostname begins with [ and ends with ]
                        // assume that it's an IPv6 address.
                        var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
                        // validate a little.
                        if (!ipv6Hostname) {
                            var hostparts = this.hostname.split(/\./);
                            for(var i = 0, l = hostparts.length; i < l; i++){
                                var part = hostparts[i];
                                if (!part) continue;
                                if (!part.match(hostnamePartPattern)) {
                                    var newpart = "";
                                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                                    // we need this to make sure size of hostname is not
                                    // broken by replacing non-ASCII by nothing
                                    newpart += "x";
                                    else newpart += part[j];
                                    // we test again with ASCII char only
                                    if (!newpart.match(hostnamePartPattern)) {
                                        var validParts = hostparts.slice(0, i);
                                        var notHost = hostparts.slice(i + 1);
                                        var bit = part.match(hostnamePartStart);
                                        if (bit) {
                                            validParts.push(bit[1]);
                                            notHost.unshift(bit[2]);
                                        }
                                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                                        this.hostname = validParts.join(".");
                                        break;
                                    }
                                }
                            }
                        }
                        if (this.hostname.length > hostnameMaxLen) this.hostname = "";
                        else // hostnames are always lower case.
                        this.hostname = this.hostname.toLowerCase();
                        if (!ipv6Hostname) {
                            // IDNA Support: Returns a puny coded representation of "domain".
                            // It only converts the part of the domain name that
                            // has non ASCII characters. I.e. it dosent matter if
                            // you call it with a domain that already is in ASCII.
                            var domainArray = this.hostname.split(".");
                            var newOut = [];
                            for(var i = 0; i < domainArray.length; ++i){
                                var s = domainArray[i];
                                newOut.push(s.match(/[^A-Za-z0-9_-]/) ? "xn--" + punycode.encode(s) : s);
                            }
                            this.hostname = newOut.join(".");
                        }
                        var p = this.port ? ":" + this.port : "";
                        var h = this.hostname || "";
                        this.host = h + p;
                        this.href += this.host;
                        // strip [ and ] from the hostname
                        // the host field still retains them, though
                        if (ipv6Hostname) {
                            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
                            if (rest[0] !== "/") rest = "/" + rest;
                        }
                    }
                    // now rest is set to the post-host stuff.
                    // chop off any delim chars.
                    if (!unsafeProtocol[lowerProto]) // First, make 100% sure that any "autoEscape" chars get
                    // escaped, even if encodeURIComponent doesn't think they
                    // need to be.
                    for(var i = 0, l = autoEscape.length; i < l; i++){
                        var ae = autoEscape[i];
                        var esc = encodeURIComponent(ae);
                        if (esc === ae) esc = escape(ae);
                        rest = rest.split(ae).join(esc);
                    }
                    // chop off from the tail first.
                    var hash = rest.indexOf("#");
                    if (hash !== -1) {
                        // got a fragment string.
                        this.hash = rest.substr(hash);
                        rest = rest.slice(0, hash);
                    }
                    var qm = rest.indexOf("?");
                    if (qm !== -1) {
                        this.search = rest.substr(qm);
                        this.query = rest.substr(qm + 1);
                        if (parseQueryString) this.query = querystring.parse(this.query);
                        rest = rest.slice(0, qm);
                    } else if (parseQueryString) {
                        // no query string, but parseQueryString still requested
                        this.search = "";
                        this.query = {};
                    }
                    if (rest) this.pathname = rest;
                    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
                    //to support http.request
                    if (this.pathname || this.search) {
                        var p = this.pathname || "";
                        var s = this.search || "";
                        this.path = p + s;
                    }
                    // finally, reconstruct the href based on what has been validated.
                    this.href = this.format();
                    return this;
                };
                // format a parsed object into a url string
                function urlFormat(obj) {
                    // ensure it's an object, and not a string url.
                    // If it's an obj, this is a no-op.
                    // this way, you can call url_format() on strings
                    // to clean up potentially wonky urls.
                    if (isString(obj)) obj = urlParse(obj);
                    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
                    return obj.format();
                }
                Url.prototype.format = function() {
                    var auth = this.auth || "";
                    if (auth) {
                        auth = encodeURIComponent(auth);
                        auth = auth.replace(/%3A/i, ":");
                        auth += "@";
                    }
                    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
                    if (this.host) host = auth + this.host;
                    else if (this.hostname) {
                        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
                        if (this.port) host += ":" + this.port;
                    }
                    if (this.query && isObject(this.query) && Object.keys(this.query).length) query = querystring.stringify(this.query);
                    var search = this.search || query && "?" + query || "";
                    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
                    // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
                    // unless they had them to begin with.
                    if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
                        host = "//" + (host || "");
                        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
                    } else if (!host) host = "";
                    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
                    if (search && search.charAt(0) !== "?") search = "?" + search;
                    pathname = pathname.replace(/[?#]/g, function(match) {
                        return encodeURIComponent(match);
                    });
                    search = search.replace("#", "%23");
                    return protocol + host + pathname + search + hash;
                };
                function urlResolve(source, relative) {
                    return urlParse(source, false, true).resolve(relative);
                }
                Url.prototype.resolve = function(relative) {
                    return this.resolveObject(urlParse(relative, false, true)).format();
                };
                function urlResolveObject(source, relative) {
                    if (!source) return relative;
                    return urlParse(source, false, true).resolveObject(relative);
                }
                Url.prototype.resolveObject = function(relative) {
                    if (isString(relative)) {
                        var rel = new Url();
                        rel.parse(relative, false, true);
                        relative = rel;
                    }
                    var result = new Url();
                    Object.keys(this).forEach(function(k) {
                        result[k] = this[k];
                    }, this);
                    // hash is always overridden, no matter what.
                    // even href="" will remove it.
                    result.hash = relative.hash;
                    // if the relative url is empty, then there's nothing left to do here.
                    if (relative.href === "") {
                        result.href = result.format();
                        return result;
                    }
                    // hrefs like //foo/bar always cut to the protocol.
                    if (relative.slashes && !relative.protocol) {
                        // take everything except the protocol from relative
                        Object.keys(relative).forEach(function(k) {
                            if (k !== "protocol") result[k] = relative[k];
                        });
                        //urlParse appends trailing / to urls like http://www.example.com
                        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) result.path = result.pathname = "/";
                        result.href = result.format();
                        return result;
                    }
                    if (relative.protocol && relative.protocol !== result.protocol) {
                        // if it's a known url protocol, then changing
                        // the protocol does weird things
                        // first, if it's not file:, then we MUST have a host,
                        // and if there was a path
                        // to begin with, then we MUST have a path.
                        // if it is file:, then the host is dropped,
                        // because that's known to be hostless.
                        // anything else is assumed to be absolute.
                        if (!slashedProtocol[relative.protocol]) {
                            Object.keys(relative).forEach(function(k) {
                                result[k] = relative[k];
                            });
                            result.href = result.format();
                            return result;
                        }
                        result.protocol = relative.protocol;
                        if (!relative.host && !hostlessProtocol[relative.protocol]) {
                            var relPath = (relative.pathname || "").split("/");
                            while(relPath.length && !(relative.host = relPath.shift()));
                            if (!relative.host) relative.host = "";
                            if (!relative.hostname) relative.hostname = "";
                            if (relPath[0] !== "") relPath.unshift("");
                            if (relPath.length < 2) relPath.unshift("");
                            result.pathname = relPath.join("/");
                        } else result.pathname = relative.pathname;
                        result.search = relative.search;
                        result.query = relative.query;
                        result.host = relative.host || "";
                        result.auth = relative.auth;
                        result.hostname = relative.hostname || relative.host;
                        result.port = relative.port;
                        // to support http.request
                        if (result.pathname || result.search) {
                            var p = result.pathname || "";
                            var s = result.search || "";
                            result.path = p + s;
                        }
                        result.slashes = result.slashes || relative.slashes;
                        result.href = result.format();
                        return result;
                    }
                    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
                    // if the url is a non-slashed url, then relative
                    // links like ../.. should be able
                    // to crawl up to the hostname, as well.  This is strange.
                    // result.protocol has already been set by now.
                    // Later on, put the first path part into the host field.
                    if (psychotic) {
                        result.hostname = "";
                        result.port = null;
                        if (result.host) {
                            if (srcPath[0] === "") srcPath[0] = result.host;
                            else srcPath.unshift(result.host);
                        }
                        result.host = "";
                        if (relative.protocol) {
                            relative.hostname = null;
                            relative.port = null;
                            if (relative.host) {
                                if (relPath[0] === "") relPath[0] = relative.host;
                                else relPath.unshift(relative.host);
                            }
                            relative.host = null;
                        }
                        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
                    }
                    if (isRelAbs) {
                        // it's absolute.
                        result.host = relative.host || relative.host === "" ? relative.host : result.host;
                        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
                        result.search = relative.search;
                        result.query = relative.query;
                        srcPath = relPath;
                    // fall through to the dot-handling below.
                    } else if (relPath.length) {
                        // it's relative
                        // throw away the existing file, and take the new path instead.
                        if (!srcPath) srcPath = [];
                        srcPath.pop();
                        srcPath = srcPath.concat(relPath);
                        result.search = relative.search;
                        result.query = relative.query;
                    } else if (!isNullOrUndefined(relative.search)) {
                        // just pull out the search.
                        // like href='?foo'.
                        // Put this after the other two cases because it simplifies the booleans
                        if (psychotic) {
                            result.hostname = result.host = srcPath.shift();
                            //occationaly the auth can get stuck only in host
                            //this especialy happens in cases like
                            //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
                            var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
                            if (authInHost) {
                                result.auth = authInHost.shift();
                                result.host = result.hostname = authInHost.shift();
                            }
                        }
                        result.search = relative.search;
                        result.query = relative.query;
                        //to support http.request
                        if (!isNull(result.pathname) || !isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
                        result.href = result.format();
                        return result;
                    }
                    if (!srcPath.length) {
                        // no path at all.  easy.
                        // we've already handled the other stuff above.
                        result.pathname = null;
                        //to support http.request
                        if (result.search) result.path = "/" + result.search;
                        else result.path = null;
                        result.href = result.format();
                        return result;
                    }
                    // if a url ENDs in . or .., then it must get a trailing slash.
                    // however, if it ends in anything else non-slashy,
                    // then it must NOT get a trailing slash.
                    var last = srcPath.slice(-1)[0];
                    var hasTrailingSlash = (result.host || relative.host) && (last === "." || last === "..") || last === "";
                    // strip single dots, resolve double dots to parent dir
                    // if the path tries to go above the root, `up` ends up > 0
                    var up = 0;
                    for(var i = srcPath.length; i >= 0; i--){
                        last = srcPath[i];
                        if (last == ".") srcPath.splice(i, 1);
                        else if (last === "..") {
                            srcPath.splice(i, 1);
                            up++;
                        } else if (up) {
                            srcPath.splice(i, 1);
                            up--;
                        }
                    }
                    // if the path is allowed to go above the root, restore leading ..s
                    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
                    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
                    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
                    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
                    // put the host back
                    if (psychotic) {
                        result.hostname = result.host = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
                        //occationaly the auth can get stuck only in host
                        //this especialy happens in cases like
                        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
                        var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
                        if (authInHost) {
                            result.auth = authInHost.shift();
                            result.host = result.hostname = authInHost.shift();
                        }
                    }
                    mustEndAbs = mustEndAbs || result.host && srcPath.length;
                    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
                    if (!srcPath.length) {
                        result.pathname = null;
                        result.path = null;
                    } else result.pathname = srcPath.join("/");
                    //to support request.http
                    if (!isNull(result.pathname) || !isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
                    result.auth = relative.auth || result.auth;
                    result.slashes = result.slashes || relative.slashes;
                    result.href = result.format();
                    return result;
                };
                Url.prototype.parseHost = function() {
                    var host = this.host;
                    var port = portPattern.exec(host);
                    if (port) {
                        port = port[0];
                        if (port !== ":") this.port = port.substr(1);
                        host = host.substr(0, host.length - port.length);
                    }
                    if (host) this.hostname = host;
                };
                function isString(arg) {
                    return typeof arg === "string";
                }
                function isObject(arg) {
                    return typeof arg === "object" && arg !== null;
                }
                function isNull(arg) {
                    return arg === null;
                }
                function isNullOrUndefined(arg) {
                    return arg == null;
                }
            },
            {
                "punycode": 2,
                "querystring": 6
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                "use strict";
                // If obj.hasOwnProperty has been overridden, then calling
                // obj.hasOwnProperty(prop) will break.
                // See: https://github.com/joyent/node/issues/1707
                function hasOwnProperty(obj, prop) {
                    return Object.prototype.hasOwnProperty.call(obj, prop);
                }
                module1.exports = function(qs, sep, eq, options) {
                    sep = sep || "&";
                    eq = eq || "=";
                    var obj = {};
                    if (typeof qs !== "string" || qs.length === 0) return obj;
                    var regexp = /\+/g;
                    qs = qs.split(sep);
                    var maxKeys = 1000;
                    if (options && typeof options.maxKeys === "number") maxKeys = options.maxKeys;
                    var len = qs.length;
                    // maxKeys <= 0 means that we should not limit keys count
                    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
                    for(var i = 0; i < len; ++i){
                        var x = qs[i].replace(regexp, "%20"), idx = x.indexOf(eq), kstr, vstr, k, v;
                        if (idx >= 0) {
                            kstr = x.substr(0, idx);
                            vstr = x.substr(idx + 1);
                        } else {
                            kstr = x;
                            vstr = "";
                        }
                        k = decodeURIComponent(kstr);
                        v = decodeURIComponent(vstr);
                        if (!hasOwnProperty(obj, k)) obj[k] = v;
                        else if (isArray(obj[k])) obj[k].push(v);
                        else obj[k] = [
                            obj[k],
                            v
                        ];
                    }
                    return obj;
                };
                var isArray = Array.isArray || function(xs) {
                    return Object.prototype.toString.call(xs) === "[object Array]";
                };
            },
            {}
        ],
        5: [
            function(_dereq_, module1, exports) {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
                "use strict";
                var stringifyPrimitive = function(v) {
                    switch(typeof v){
                        case "string":
                            return v;
                        case "boolean":
                            return v ? "true" : "false";
                        case "number":
                            return isFinite(v) ? v : "";
                        default:
                            return "";
                    }
                };
                module1.exports = function(obj, sep, eq, name) {
                    sep = sep || "&";
                    eq = eq || "=";
                    if (obj === null) obj = undefined;
                    if (typeof obj === "object") return map(objectKeys(obj), function(k) {
                        var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
                        if (isArray(obj[k])) return map(obj[k], function(v) {
                            return ks + encodeURIComponent(stringifyPrimitive(v));
                        }).join(sep);
                        else return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
                    }).join(sep);
                    if (!name) return "";
                    return encodeURIComponent(stringifyPrimitive(name)) + eq + encodeURIComponent(stringifyPrimitive(obj));
                };
                var isArray = Array.isArray || function(xs) {
                    return Object.prototype.toString.call(xs) === "[object Array]";
                };
                function map(xs, f) {
                    if (xs.map) return xs.map(f);
                    var res = [];
                    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
                    return res;
                }
                var objectKeys = Object.keys || function(obj) {
                    var res = [];
                    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
                    return res;
                };
            },
            {}
        ],
        6: [
            function(_dereq_, module1, exports) {
                "use strict";
                exports.decode = exports.parse = _dereq_("./decode");
                exports.encode = exports.stringify = _dereq_("./encode");
            },
            {
                "./decode": 4,
                "./encode": 5
            }
        ],
        7: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var STATE_AP_KEY = "_AP";
                exports.STATE_AP_KEY = STATE_AP_KEY;
                var QUERY_KEY_PREFIX = "ac";
                exports.QUERY_KEY_PREFIX = QUERY_KEY_PREFIX;
                var QUERY_KEY_DELIMITER = ".";
                exports.QUERY_KEY_DELIMITER = QUERY_KEY_DELIMITER;
                var ANCHOR_PREFIX = "!";
                exports.ANCHOR_PREFIX = ANCHOR_PREFIX;
                var HISTORY_POPSTATE = "history_popstate";
                exports.HISTORY_POPSTATE = HISTORY_POPSTATE;
                var HISTORY_PUSHSTATE = "history_pushstate";
                exports.HISTORY_PUSHSTATE = HISTORY_PUSHSTATE;
                var HISTORY_REPLACESTATE = "history_replacestate";
                exports.HISTORY_REPLACESTATE = HISTORY_REPLACESTATE;
                var HISTORY_CHANGESTATE = "history_changestate";
                exports.HISTORY_CHANGESTATE = HISTORY_CHANGESTATE;
            },
            {}
        ],
        8: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Addon = Addon;
                exports.Addons = Addons;
                exports.Current = Current;
                exports.Change = Change;
                exports.State = State;
                exports.URL = URL;
                exports.Route = Route;
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        "default": obj
                    };
                }
                var _url = _dereq_("url");
                var _url2 = _interopRequireDefault(_url);
                var _utils = _dereq_("./utils");
                function Addon(opts) {
                    opts = opts || {};
                    if (!opts.key) throw new Error("missing key for addon");
                    this.key = opts.key;
                    this.state = opts.state;
                    this.query = opts.query || {};
                    return this;
                }
                function Addons(opts) {
                    opts = opts || {};
                    opts.models = opts.models || [];
                    if (!(opts.models instanceof Array)) opts.models = [
                        opts.models
                    ];
                    opts.models = opts.models.map(function(model) {
                        if (model instanceof Addon) return model;
                        else return new Addon(model);
                    });
                    this.models = opts.models;
                    return this;
                }
                Addons.prototype.add = function(addon) {
                    this.models.push(addon);
                };
                Addons.prototype.remove = function(addon) {
                    this.models.splice(this.models.indexOf(addon), 1);
                };
                Addons.prototype.find = function(key) {
                    return (0, _utils.find)(this.models, function(addon) {
                        return addon.key === key;
                    });
                };
                Addons.prototype.merge = function(addon) {
                    var found = this.find(addon.key);
                    if (found) this.remove(found);
                    this.add(addon);
                };
                function Current(opts) {
                    opts = opts || {};
                    if (!opts.url) throw new Error("missing url");
                    var parsed = _url2["default"].parse(opts.url);
                    var addons = new Addons();
                    var queryArr = (0, _utils.parseQuery)(parsed.query).map(_utils.stripAddonQueryPrefix);
                    var normalizedQueryAddons = (0, _utils.normalizeQueryByAddons)(queryArr);
                    var queryAddons = normalizedQueryAddons.filter(function(item) {
                        return item.key;
                    });
                    var queryGlobal = normalizedQueryAddons.filter(function(item) {
                        return !item.key;
                    });
                    queryAddons.forEach(function(item) {
                        var created = new Addon(item);
                        addons.add(created);
                    });
                    this.url = new URL({
                        url: opts.url,
                        addons: addons,
                        global: queryGlobal
                    });
                    this.state = new State(opts.state);
                    return this;
                }
                function Change(opts, addonKey) {
                    var type = typeof opts;
                    var defaults = _url2["default"].parse(window.location.href);
                    var urlObject = {};
                    var options = {};
                    if (type === "string") {
                        urlObject.protocol = defaults.protocol;
                        urlObject.slashes = defaults.slashes;
                        urlObject.hostname = defaults.hostname;
                        urlObject.pathname = defaults.pathname;
                        urlObject.port = defaults.port;
                        urlObject.search = defaults.search;
                        urlObject.query = defaults.query;
                        urlObject.hash = (0, _utils.addHash)((0, _utils.addHashPrefix)(opts));
                    } else if (type === "object") {
                        var parsed = opts.href ? _url2["default"].parse(opts.href) : defaults;
                        urlObject.protocol = defaults.protocol;
                        urlObject.slashes = defaults.slashes;
                        urlObject.hostname = defaults.hostname;
                        urlObject.port = defaults.port;
                        urlObject.pathname = parsed.pathname || defaults.pathname;
                        urlObject.search = null;
                        urlObject.query = null;
                        urlObject.hash = opts.hash ? (0, _utils.addHash)((0, _utils.addHashPrefix)(opts.hash)) : null;
                        options.state = opts.state;
                        options.query = opts.query;
                    } else throw new Error("invalid option type");
                    var addonsState = new Addons();
                    var addonsURL = new Addons();
                    if (options.state) {
                        var addonState = new Addon({
                            key: addonKey,
                            state: options.state
                        });
                        addonsState.add(addonState);
                    }
                    if (options.query) {
                        var addonURL = new Addon({
                            key: addonKey,
                            query: options.query
                        });
                        addonsURL.add(addonURL);
                    }
                    var changeState = new State({
                        addons: addonsState
                    });
                    var changeURL = new URL({
                        url: _url2["default"].format(urlObject),
                        addons: addonsURL
                    });
                    this.state = changeState;
                    this.url = changeURL;
                    return this;
                }
                function State(opts) {
                    opts = opts || {};
                    opts.addons = opts.addons || [];
                    if (!(opts.addons instanceof Addons)) opts.addons = new Addons(opts.addons);
                    this.addons = opts.addons;
                    return this;
                }
                State.prototype.merge = function(instance) {
                    var self1 = this;
                    instance.addons.models.forEach(function(addon) {
                        self1.addons.merge(addon);
                    });
                };
                State.prototype.render = function() {
                    return (0, _utils.deepCopy)(this);
                };
                function URL(opts) {
                    opts = opts || {};
                    opts.addons = opts.addons || [];
                    opts.global = opts.global || [];
                    if (!(opts.parsed instanceof _url2["default"].Url)) opts.parsed = _url2["default"].parse(opts.url);
                    if (!(opts.addons instanceof Addons)) opts.addons = new Addons(opts.addons);
                    this.parsed = opts.parsed;
                    this.addons = opts.addons;
                    this.global = opts.global; // global query parameters that are not associated with addons
                    this.title = opts.title || window.document.title;
                }
                URL.prototype.isURLEqual = function(instance) {
                    return this.render().url === instance.render().url;
                };
                URL.prototype.isPathnameEqual = function(instance) {
                    var protocolEqual = this.parsed.protocol === instance.parsed.protocol;
                    var slashesEqual = this.parsed.slashes === instance.parsed.slashes;
                    var hostnameEqual = this.parsed.hostname === instance.parsed.hostname;
                    var pathnameEqual = this.parsed.pathname === instance.parsed.pathname;
                    return protocolEqual && slashesEqual && hostnameEqual && pathnameEqual;
                };
                URL.prototype.merge = function(instance) {
                    var self1 = this;
                    self1.parsed.hash = instance.parsed.hash;
                    instance.addons.models.forEach(function(addon) {
                        self1.addons.merge(addon);
                    });
                };
                URL.prototype.render = function() {
                    var deep = (0, _utils.deepCopy)(this);
                    var urlObj = deep.parsed;
                    var addonsDenormalizedQueryAddons = (0, _utils.denormalizeQueryByAddons)(this.addons.models);
                    var globalDenormalizedQueryAddons = (0, _utils.denormalizeQueryByAddons)(this.global);
                    var allQueryParams = addonsDenormalizedQueryAddons.concat(globalDenormalizedQueryAddons);
                    var prefixedQueryArr = allQueryParams.map(_utils.addAddonQueryPrefix);
                    var formattedQuery = (0, _utils.formatQuery)(prefixedQueryArr);
                    urlObj.query = formattedQuery;
                    urlObj.search = urlObj.query ? "?" + urlObj.query : null;
                    deep.url = _url2["default"].format(urlObj);
                    return deep;
                };
                function Route(opts) {
                    opts = opts || {};
                    if (!opts.url) throw new Error("missing url option");
                    if (!(opts.url instanceof URL)) opts.url = new URL(opts.url);
                    if (!opts.state) throw new Error("missing state option");
                    if (!(opts.state instanceof State)) opts.state = new State(opts.state);
                    this.url = opts.url;
                    this.state = opts.state;
                }
                Route.prototype.merge = function(route) {
                    this.url.merge(route.url);
                    this.state.merge(route.state);
                };
                Route.prototype.render = function(addonKey) {
                    return (0, _utils.deepCopy)({
                        key: addonKey,
                        hash: (0, _utils.stripHashPrefix)((0, _utils.stripHash)(this.url.parsed.hash)),
                        query: this.url.addons.find(addonKey) ? this.url.addons.find(addonKey).query : null,
                        title: this.url.title,
                        href: this.url.parsed.href,
                        state: this.state.addons.find(addonKey) ? this.state.addons.find(addonKey).state : null
                    });
                };
            },
            {
                "./utils": 9,
                "url": 3
            }
        ],
        9: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.find = find;
                exports.values = values;
                exports.stripHash = stripHash;
                exports.stripHashPrefix = stripHashPrefix;
                exports.addHash = addHash;
                exports.addHashPrefix = addHashPrefix;
                exports.splitQueryParam = splitQueryParam;
                exports.joinQueryParam = joinQueryParam;
                exports.parseQuery = parseQuery;
                exports.formatQuery = formatQuery;
                exports.stripAddonQueryPrefix = stripAddonQueryPrefix;
                exports.addAddonQueryPrefix = addAddonQueryPrefix;
                exports.normalizeQueryByAddons = normalizeQueryByAddons;
                exports.denormalizeQueryByAddons = denormalizeQueryByAddons;
                exports.deepCopy = deepCopy;
                exports.wrapState = wrapState;
                exports.unwrapState = unwrapState;
                exports.createEvent = createEvent;
                exports.callConnectHost = callConnectHost;
                exports.log = log;
                function _defineProperty(obj, key, value) {
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                var _constants = _dereq_("./constants");
                function find(arr, iterator) {
                    for(var i = 0, l = arr.length; i < l; i += 1){
                        if (iterator(arr[i])) return arr[i];
                    }
                }
                function values(obj) {
                    var values = [];
                    if (!obj) return values;
                    for(var key in obj)values.push(obj[key]);
                    return values;
                }
                function stripHash(str) {
                    return str ? str.slice(str.search("#") + 1) : null;
                }
                function stripHashPrefix(text) {
                    if (text === undefined || text === null || text === "") return "";
                    return text.toString().replace(new RegExp("^" + _constants.ANCHOR_PREFIX), "");
                }
                function addHash(str) {
                    return "#" + str;
                }
                function addHashPrefix(text) {
                    if (text === undefined || text === null) throw "You must supply text to prefix";
                    return _constants.ANCHOR_PREFIX + stripHashPrefix(text);
                }
                function splitQueryParam(paramString) {
                    var split = paramString ? paramString.split("=") : [];
                    var key = split[0] || null;
                    var value = split[1] || null;
                    if (split.length === 2) {
                        var _key = split[0];
                        var _value = split[1];
                        return {
                            key: _key,
                            value: _value
                        };
                    } else return null;
                }
                function joinQueryParam(paramObject) {
                    if ("key" in paramObject && "value" in paramObject) return [
                        paramObject.key,
                        "=",
                        paramObject.value
                    ].join("");
                    else return null;
                }
                function parseQuery(queryString) {
                    // returns an array of objects
                    var params = queryString ? queryString.split("&") : [];
                    return params.map(function(paramString) {
                        return splitQueryParam(paramString);
                    }).filter(function(item) {
                        return item;
                    });
                }
                function formatQuery(queryArr) {
                    // returns a query string
                    var mapped = queryArr.map(function(paramObject) {
                        return joinQueryParam(paramObject);
                    }).filter(function(item) {
                        return item;
                    });
                    return mapped.length ? mapped.join("&") : null;
                }
                function stripAddonQueryPrefix(queryObject) {
                    var split = queryObject.key ? queryObject.key.split(_constants.QUERY_KEY_DELIMITER) : [];
                    var prefix = _constants.QUERY_KEY_PREFIX;
                    if (split.length >= 3) {
                        if (prefix === split[0]) {
                            // be greedy for addonKey instead of queryKey
                            var addonKey = split.slice(1, split.length - 1).join(_constants.QUERY_KEY_DELIMITER);
                            var queryKey = split.slice(split.length - 1).join(_constants.QUERY_KEY_DELIMITER);
                            return {
                                addonKey: addonKey,
                                key: queryKey,
                                value: queryObject.value
                            };
                        } else return queryObject;
                    } else return queryObject;
                }
                function addAddonQueryPrefix(queryObject) {
                    var prefix = _constants.QUERY_KEY_PREFIX;
                    if ("addonKey" in queryObject && queryObject.addonKey) {
                        var queryKey = [
                            prefix,
                            queryObject.addonKey,
                            queryObject.key
                        ].join(_constants.QUERY_KEY_DELIMITER);
                        return {
                            key: queryKey,
                            value: queryObject.value
                        };
                    } else return queryObject;
                }
                function normalizeQueryByAddons(queryArr) {
                    var addons = [];
                    queryArr.forEach(function(query) {
                        var key = query.key;
                        var value = query.value;
                        var addonKey = query.addonKey;
                        var filtered = addons.filter(function(addon) {
                            return addon.key === addonKey;
                        });
                        if (filtered && filtered.length) {
                            var found = filtered[0];
                            found.query[key] = value;
                        } else addons.push({
                            key: addonKey,
                            query: _defineProperty({}, key, value)
                        });
                    });
                    return addons;
                }
                function denormalizeQueryByAddons(addonArr) {
                    var query = [];
                    addonArr.forEach(function(addon) {
                        var addonKey = addon.key;
                        Object.keys(addon.query).forEach(function(key) {
                            var value = addon.query[key];
                            query.push({
                                addonKey: addonKey,
                                key: key,
                                value: value
                            });
                        });
                    });
                    return query;
                }
                function deepCopy(obj) {
                    return JSON.parse(JSON.stringify(obj));
                }
                function wrapState(state) {
                    var rootState = {};
                    rootState[_constants.STATE_AP_KEY] = state;
                    return rootState;
                }
                function unwrapState(state) {
                    return state && state[_constants.STATE_AP_KEY] ? state[_constants.STATE_AP_KEY] : null;
                }
                function createEvent(eventName) {
                    if (typeof Event === "function") {
                        // chrome, firefox, safari
                        var evt = new Event(eventName);
                        return evt;
                    } else {
                        var evt = document.createEvent("Event"); // ie11
                        evt.initEvent(eventName, false, false);
                        return evt;
                    }
                }
                function callConnectHost(cb) {
                    if (_dereq_ && _dereq_.amd) _dereq_([
                        "connect-host"
                    ], function(connectHost) {
                        cb(connectHost);
                    });
                    else cb(window.connectHost);
                }
                function log(toLog, type) {
                    if (!type) type = "log";
                    console[type].call(null, "Atlassian Connect JS History: ", toLog);
                }
            },
            {
                "./constants": 7
            }
        ]
    }, {}, [
        1
    ])(1);
});

});

parcelRegister("ffISn", function(module, exports) {
(function(global1, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    function _extends() {
        _extends = Object.assign ? Object.assign.bind() : function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var domain;
    // This constructor is used to store event handlers. Instantiating this is
    // faster than explicitly calling `Object.create(null)` to get a "clean" empty
    // object (tested with v8 v4.9).
    function EventHandlers() {}
    EventHandlers.prototype = Object.create(null);
    function EventEmitter() {
        EventEmitter.init.call(this);
    }
    // nodejs oddity
    // require('events') === require('events').EventEmitter
    EventEmitter.EventEmitter = EventEmitter;
    EventEmitter.usingDomains = false;
    EventEmitter.prototype.domain = undefined;
    EventEmitter.prototype._events = undefined;
    EventEmitter.prototype._maxListeners = undefined;
    // By default EventEmitters will print a warning if more than 10 listeners are
    // added to it. This is a useful default which helps finding memory leaks.
    EventEmitter.defaultMaxListeners = 10;
    EventEmitter.init = function() {
        this.domain = null;
        if (EventEmitter.usingDomains) // if there is an active domain, then attach to it.
        domain.active;
        if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
            this._events = new EventHandlers();
            this._eventsCount = 0;
        }
        this._maxListeners = this._maxListeners || undefined;
    };
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
        if (typeof n !== "number" || n < 0 || isNaN(n)) throw new TypeError('"n" argument must be a positive number');
        this._maxListeners = n;
        return this;
    };
    function $getMaxListeners(that) {
        if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
        return that._maxListeners;
    }
    EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
        return $getMaxListeners(this);
    };
    // These standalone emit* functions are used to optimize calling of event
    // handlers for fast cases because emit() itself often has a variable number of
    // arguments and can be deoptimized because of that. These functions always have
    // the same number of arguments and thus do not get deoptimized, so the code
    // inside them can execute faster.
    function emitNone(handler, isFn, self1) {
        if (isFn) handler.call(self1);
        else {
            var len = handler.length;
            var listeners = arrayClone(handler, len);
            for(var i = 0; i < len; ++i)listeners[i].call(self1);
        }
    }
    function emitOne(handler, isFn, self1, arg1) {
        if (isFn) handler.call(self1, arg1);
        else {
            var len = handler.length;
            var listeners = arrayClone(handler, len);
            for(var i = 0; i < len; ++i)listeners[i].call(self1, arg1);
        }
    }
    function emitTwo(handler, isFn, self1, arg1, arg2) {
        if (isFn) handler.call(self1, arg1, arg2);
        else {
            var len = handler.length;
            var listeners = arrayClone(handler, len);
            for(var i = 0; i < len; ++i)listeners[i].call(self1, arg1, arg2);
        }
    }
    function emitThree(handler, isFn, self1, arg1, arg2, arg3) {
        if (isFn) handler.call(self1, arg1, arg2, arg3);
        else {
            var len = handler.length;
            var listeners = arrayClone(handler, len);
            for(var i = 0; i < len; ++i)listeners[i].call(self1, arg1, arg2, arg3);
        }
    }
    function emitMany(handler, isFn, self1, args) {
        if (isFn) handler.apply(self1, args);
        else {
            var len = handler.length;
            var listeners = arrayClone(handler, len);
            for(var i = 0; i < len; ++i)listeners[i].apply(self1, args);
        }
    }
    EventEmitter.prototype.emit = function emit(type) {
        var er, handler, len, args, i, events, domain;
        var doError = type === "error";
        events = this._events;
        if (events) doError = doError && events.error == null;
        else if (!doError) return false;
        domain = this.domain;
        // If there is no 'error' event listener then throw.
        if (doError) {
            er = arguments[1];
            if (domain) {
                if (!er) er = new Error('Uncaught, unspecified "error" event');
                er.domainEmitter = this;
                er.domain = domain;
                er.domainThrown = false;
                domain.emit("error", er);
            } else if (er instanceof Error) throw er; // Unhandled 'error' event
            else {
                // At least give some kind of context to the user
                var err = new Error('Uncaught, unspecified "error" event. (' + er + ")");
                err.context = er;
                throw err;
            }
            return false;
        }
        handler = events[type];
        if (!handler) return false;
        var isFn = typeof handler === "function";
        len = arguments.length;
        switch(len){
            // fast cases
            case 1:
                emitNone(handler, isFn, this);
                break;
            case 2:
                emitOne(handler, isFn, this, arguments[1]);
                break;
            case 3:
                emitTwo(handler, isFn, this, arguments[1], arguments[2]);
                break;
            case 4:
                emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
                break;
            // slower
            default:
                args = new Array(len - 1);
                for(i = 1; i < len; i++)args[i - 1] = arguments[i];
                emitMany(handler, isFn, this, args);
        }
        return true;
    };
    function _addListener(target, type, listener, prepend) {
        var m;
        var events;
        var existing;
        if (typeof listener !== "function") throw new TypeError('"listener" argument must be a function');
        events = target._events;
        if (!events) {
            events = target._events = new EventHandlers();
            target._eventsCount = 0;
        } else {
            // To avoid recursion in the case that type === "newListener"! Before
            // adding it to the listeners, first emit "newListener".
            if (events.newListener) {
                target.emit("newListener", type, listener.listener ? listener.listener : listener);
                // Re-assign `events` because a newListener handler could have caused the
                // this._events to be assigned to a new object
                events = target._events;
            }
            existing = events[type];
        }
        if (!existing) {
            // Optimize the case of one listener. Don't need the extra array object.
            existing = events[type] = listener;
            ++target._eventsCount;
        } else {
            if (typeof existing === "function") // Adding the second element, need to change to array.
            existing = events[type] = prepend ? [
                listener,
                existing
            ] : [
                existing,
                listener
            ];
            else // If we've already got an array, just append.
            if (prepend) existing.unshift(listener);
            else existing.push(listener);
            // Check for listener leak
            if (!existing.warned) {
                m = $getMaxListeners(target);
                if (m && m > 0 && existing.length > m) {
                    existing.warned = true;
                    var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + type + " listeners added. " + "Use emitter.setMaxListeners() to increase limit");
                    w.name = "MaxListenersExceededWarning";
                    w.emitter = target;
                    w.type = type;
                    w.count = existing.length;
                    emitWarning(w);
                }
            }
        }
        return target;
    }
    function emitWarning(e) {
        typeof console.warn === "function" ? console.warn(e) : console.log(e);
    }
    EventEmitter.prototype.addListener = function addListener(type, listener) {
        return _addListener(this, type, listener, false);
    };
    EventEmitter.prototype.on = EventEmitter.prototype.addListener;
    EventEmitter.prototype.prependListener = function prependListener(type, listener) {
        return _addListener(this, type, listener, true);
    };
    function _onceWrap(target, type, listener) {
        var fired = false;
        function g() {
            target.removeListener(type, g);
            if (!fired) {
                fired = true;
                listener.apply(target, arguments);
            }
        }
        g.listener = listener;
        return g;
    }
    EventEmitter.prototype.once = function once(type, listener) {
        if (typeof listener !== "function") throw new TypeError('"listener" argument must be a function');
        this.on(type, _onceWrap(this, type, listener));
        return this;
    };
    EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
        if (typeof listener !== "function") throw new TypeError('"listener" argument must be a function');
        this.prependListener(type, _onceWrap(this, type, listener));
        return this;
    };
    // emits a 'removeListener' event iff the listener was removed
    EventEmitter.prototype.removeListener = function removeListener(type, listener) {
        var list, events, position, i, originalListener;
        if (typeof listener !== "function") throw new TypeError('"listener" argument must be a function');
        events = this._events;
        if (!events) return this;
        list = events[type];
        if (!list) return this;
        if (list === listener || list.listener && list.listener === listener) {
            if (--this._eventsCount === 0) this._events = new EventHandlers();
            else {
                delete events[type];
                if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
            }
        } else if (typeof list !== "function") {
            position = -1;
            for(i = list.length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
                originalListener = list[i].listener;
                position = i;
                break;
            }
            if (position < 0) return this;
            if (list.length === 1) {
                list[0] = undefined;
                if (--this._eventsCount === 0) {
                    this._events = new EventHandlers();
                    return this;
                } else delete events[type];
            } else spliceOne(list, position);
            if (events.removeListener) this.emit("removeListener", type, originalListener || listener);
        }
        return this;
    };
    EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
        var listeners, events;
        events = this._events;
        if (!events) return this;
        // not listening for removeListener, no need to emit
        if (!events.removeListener) {
            if (arguments.length === 0) {
                this._events = new EventHandlers();
                this._eventsCount = 0;
            } else if (events[type]) {
                if (--this._eventsCount === 0) this._events = new EventHandlers();
                else delete events[type];
            }
            return this;
        }
        // emit removeListener for all listeners on all events
        if (arguments.length === 0) {
            var keys = Object.keys(events);
            for(var i = 0, key; i < keys.length; ++i){
                key = keys[i];
                if (key === "removeListener") continue;
                this.removeAllListeners(key);
            }
            this.removeAllListeners("removeListener");
            this._events = new EventHandlers();
            this._eventsCount = 0;
            return this;
        }
        listeners = events[type];
        if (typeof listeners === "function") this.removeListener(type, listeners);
        else if (listeners) // LIFO order
        do this.removeListener(type, listeners[listeners.length - 1]);
        while (listeners[0]);
        return this;
    };
    EventEmitter.prototype.listeners = function listeners(type) {
        var evlistener;
        var ret;
        var events = this._events;
        if (!events) ret = [];
        else {
            evlistener = events[type];
            if (!evlistener) ret = [];
            else if (typeof evlistener === "function") ret = [
                evlistener.listener || evlistener
            ];
            else ret = unwrapListeners(evlistener);
        }
        return ret;
    };
    EventEmitter.listenerCount = function(emitter, type) {
        if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
        else return listenerCount.call(emitter, type);
    };
    EventEmitter.prototype.listenerCount = listenerCount;
    function listenerCount(type) {
        var events = this._events;
        if (events) {
            var evlistener = events[type];
            if (typeof evlistener === "function") return 1;
            else if (evlistener) return evlistener.length;
        }
        return 0;
    }
    EventEmitter.prototype.eventNames = function eventNames() {
        return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
    };
    // About 1.5x faster than the two-arg version of Array#splice().
    function spliceOne(list, index) {
        for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
        list.pop();
    }
    function arrayClone(arr, i) {
        var copy = new Array(i);
        while(i--)copy[i] = arr[i];
        return copy;
    }
    function unwrapListeners(arr) {
        var ret = new Array(arr.length);
        for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
        return ret;
    }
    var EventDispatcher = /*#__PURE__*/ function(_EventEmitter) {
        _inheritsLoose(EventDispatcher, _EventEmitter);
        function EventDispatcher() {
            var _this;
            _this = _EventEmitter.call(this) || this;
            _this.setMaxListeners(20);
            return _this;
        }
        var _proto = EventDispatcher.prototype;
        _proto.dispatch = function dispatch(action) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            this.emit.apply(this, [
                "before:" + action
            ].concat(args));
            this.emit.apply(this, arguments);
            this.emit.apply(this, [
                "after:" + action
            ].concat(args));
        };
        _proto.registerOnce = function registerOnce(action, callback) {
            if (typeof action === "string") this.once(action, callback);
            else throw "ACJS: event name must be string";
        };
        _proto.register = function register(action, callback) {
            if (typeof action === "string") this.on(action, callback);
            else throw "ACJS: event name must be string";
        };
        _proto.unregister = function unregister(action, callback) {
            if (typeof action === "string") this.removeListener(action, callback);
            else throw "ACJS: event name must be string";
        };
        return EventDispatcher;
    }(EventEmitter);
    var EventDispatcher$1 = new EventDispatcher();
    var LoadingIndicatorActions = {
        timeout: function timeout($el, extension) {
            EventDispatcher$1.dispatch("iframe-bridge-timeout", {
                $el: $el,
                extension: extension
            });
        },
        cancelled: function cancelled($el, extension) {
            EventDispatcher$1.dispatch("iframe-bridge-cancelled", {
                $el: $el,
                extension: extension
            });
        }
    };
    /**
   * The iframe-side code exposes a jquery-like implementation via _dollar.
   * This runs on the product side to provide AJS.$ under a _dollar module to provide a consistent interface
   * to code that runs on host and iframe.
   */ var $ = window.AJS && window.AJS.$ || function() {
        console.error("[ACJS] jQuery was not loaded before Connect. If in product frontend, make sure to load via a wrapper, eg withConnectHost()");
    };
    var LOADING_INDICATOR_CLASS = "ap-status-indicator";
    var LOADING_STATUSES = {
        loading: '<div class="ap-loading"><div class="small-spinner"></div>Loading app...</div>',
        "load-timeout": '<div class="ap-load-timeout"><div class="small-spinner"></div>App is not responding. Wait or <a href="#" class="ap-btn-cancel">cancel</a>?</div>',
        "load-error": "App failed to load."
    };
    var LOADING_TIMEOUT = 12000;
    var LoadingIndicator = /*#__PURE__*/ function() {
        function LoadingIndicator() {
            this._stateRegistry = {};
        }
        var _proto = LoadingIndicator.prototype;
        _proto._loadingContainer = function _loadingContainer($iframeContainer) {
            return $iframeContainer.find("." + LOADING_INDICATOR_CLASS);
        };
        _proto.render = function render() {
            var container = document.createElement("div");
            container.classList.add(LOADING_INDICATOR_CLASS);
            container.innerHTML = LOADING_STATUSES.loading;
            var $container = $(container);
            this._startSpinner($container);
            return $container;
        };
        _proto._startSpinner = function _startSpinner($container) {
            // TODO: AUI or spin.js broke something. This is bad but ironically matches v3's implementation.
            setTimeout(function() {
                var spinner = $container.find(".small-spinner");
                if (spinner.length && spinner.spin) spinner.spin({
                    lines: 12,
                    length: 3,
                    width: 2,
                    radius: 3,
                    trail: 60,
                    speed: 1.5,
                    zIndex: 1
                });
            }, 10);
        };
        _proto.hide = function hide($iframeContainer, extensionId) {
            this._clearTimeout(extensionId);
            this._loadingContainer($iframeContainer)[0].style.display = "none";
        };
        _proto.cancelled = function cancelled($iframeContainer, extensionId) {
            var status = LOADING_STATUSES["load-error"];
            this._loadingContainer($iframeContainer).empty().text(status);
        };
        _proto._setupTimeout = function _setupTimeout($container, extension) {
            this._stateRegistry[extension.id] = setTimeout(function() {
                LoadingIndicatorActions.timeout($container, extension);
            }, LOADING_TIMEOUT);
        };
        _proto._clearTimeout = function _clearTimeout(extensionId) {
            if (this._stateRegistry[extensionId]) {
                clearTimeout(this._stateRegistry[extensionId]);
                delete this._stateRegistry[extensionId];
            }
        };
        _proto.timeout = function timeout($iframeContainer, extensionId) {
            var status = $(LOADING_STATUSES["load-timeout"]);
            var container = this._loadingContainer($iframeContainer);
            container.empty().append(status);
            this._startSpinner(container);
            $("a.ap-btn-cancel", container).click(function() {
                LoadingIndicatorActions.cancelled($iframeContainer, extensionId);
            });
            this._clearTimeout(extensionId);
            return container;
        };
        return LoadingIndicator;
    }();
    var LoadingComponent = new LoadingIndicator();
    EventDispatcher$1.register("iframe-create", function(data) {
        if (!data.extension.options.noDom) LoadingComponent._setupTimeout(data.$el.parents(".ap-iframe-container"), data.extension);
    });
    EventDispatcher$1.register("iframe-bridge-established", function(data) {
        if (!data.extension.options.noDom) LoadingComponent.hide(data.$el.parents(".ap-iframe-container"), data.extension.id);
    });
    EventDispatcher$1.register("iframe-bridge-timeout", function(data) {
        if (!data.extension.options.noDom) LoadingComponent.timeout(data.$el, data.extension.id);
    });
    EventDispatcher$1.register("iframe-bridge-cancelled", function(data) {
        if (!data.extension.options.noDom) LoadingComponent.cancelled(data.$el, data.extension.id);
    });
    EventDispatcher$1.register("iframe-destroyed", function(data) {
        LoadingComponent._clearTimeout(data.extension.extension_id);
    });
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    function _isNativeReflectConstruct$1() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct$1()) _construct = Reflect.construct.bind();
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    var LOG_PREFIX = "[Simple-XDM] ";
    var nativeBind = Function.prototype.bind;
    var util = {
        locationOrigin: function locationOrigin() {
            if (!window.location.origin) return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "");
            else return window.location.origin;
        },
        randomString: function randomString() {
            return Math.floor(Math.random() * 1000000000).toString(16);
        },
        isString: function isString(str) {
            return typeof str === "string" || str instanceof String;
        },
        argumentsToArray: function argumentsToArray(arrayLike) {
            return Array.prototype.slice.call(arrayLike);
        },
        argumentNames: function argumentNames(fn) {
            return fn.toString().replace(/((\/\/.*$)|(\/\*[^]*?\*\/))/mg, "") // strip comments
            .replace(/[^(]+\(([^)]*)[^]+/, "$1") // get signature
            .match(/([^\s,]+)/g) || [];
        },
        hasCallback: function hasCallback(args) {
            var length = args.length;
            return length > 0 && typeof args[length - 1] === "function";
        },
        error: function error(msg) {
            if (window.console && window.console.error) {
                var outputError = [];
                if (typeof msg === "string") {
                    outputError.push(LOG_PREFIX + msg);
                    outputError = outputError.concat(Array.prototype.slice.call(arguments, 1));
                } else {
                    outputError.push(LOG_PREFIX);
                    outputError = outputError.concat(Array.prototype.slice.call(arguments));
                }
                window.console.error.apply(null, outputError);
            }
        },
        warn: function warn(msg) {
            if (window.console) console.warn(LOG_PREFIX + msg);
        },
        log: function log(msg) {
            if (window.console) window.console.log(LOG_PREFIX + msg);
        },
        _bind: function _bind(thisp, fn) {
            if (nativeBind && fn.bind === nativeBind) return fn.bind(thisp);
            return function() {
                return fn.apply(thisp, arguments);
            };
        },
        throttle: function throttle(func, wait, context) {
            var previous = 0;
            return function() {
                var now = Date.now();
                if (now - previous > wait) {
                    previous = now;
                    func.apply(context, arguments);
                }
            };
        },
        each: function each(list, iteratee) {
            var length;
            var key;
            if (list) {
                length = list.length;
                if (length != null && typeof list !== "function") {
                    key = 0;
                    while(key < length){
                        if (iteratee.call(list[key], key, list[key]) === false) break;
                        key += 1;
                    }
                } else {
                    for(key in list)if (list.hasOwnProperty(key)) {
                        if (iteratee.call(list[key], key, list[key]) === false) break;
                    }
                }
            }
        },
        extend: function extend(dest) {
            var args = arguments;
            var srcs = [].slice.call(args, 1, args.length);
            srcs.forEach(function(source) {
                if (typeof source === "object") Object.getOwnPropertyNames(source).forEach(function(name) {
                    dest[name] = source[name];
                });
            });
            return dest;
        },
        sanitizeStructuredClone: function sanitizeStructuredClone(object) {
            var whiteList = [
                Boolean,
                String,
                Date,
                RegExp,
                Blob,
                File,
                FileList,
                ArrayBuffer
            ];
            var blackList = [
                Error,
                Node
            ];
            var warn = util.warn;
            var visitedObjects = [];
            function _clone(value) {
                if (typeof value === "function") {
                    warn("A function was detected and removed from the message.");
                    return null;
                }
                if (blackList.some(function(t) {
                    if (value instanceof t) {
                        warn(t.name + " object was detected and removed from the message.");
                        return true;
                    }
                    return false;
                })) return {};
                if (value && typeof value === "object" && whiteList.every(function(t) {
                    return !(value instanceof t);
                })) {
                    var newValue;
                    if (Array.isArray(value)) newValue = value.map(function(element) {
                        return _clone(element);
                    });
                    else {
                        if (visitedObjects.indexOf(value) > -1) {
                            warn("A circular reference was detected and removed from the message.");
                            return null;
                        }
                        visitedObjects.push(value);
                        newValue = {};
                        for(var name in value)if (value.hasOwnProperty(name)) {
                            var clonedValue = _clone(value[name]);
                            if (clonedValue !== null) newValue[name] = clonedValue;
                        }
                        visitedObjects.pop();
                    }
                    return newValue;
                }
                return value;
            }
            return _clone(object);
        },
        getOrigin: function getOrigin(url, base) {
            // everything except IE11
            if (typeof URL === "function") try {
                return new URL(url, base).origin;
            } catch (e) {}
            // ie11 + safari 10
            var doc = document.implementation.createHTMLDocument("");
            if (base) {
                var baseElement = doc.createElement("base");
                baseElement.href = base;
                doc.head.appendChild(baseElement);
            }
            var anchorElement = doc.createElement("a");
            anchorElement.href = url;
            doc.body.appendChild(anchorElement);
            var origin = anchorElement.protocol + "//" + anchorElement.hostname;
            //ie11, only include port if referenced in initial URL
            if (url.match(/\/\/[^/]+:[0-9]+\//)) origin += anchorElement.port ? ":" + anchorElement.port : "";
            return origin;
        }
    };
    var PostMessage = /*#__PURE__*/ function() {
        function PostMessage(data) {
            var d = data || {};
            this._registerListener(d.listenOn);
        }
        var _proto = PostMessage.prototype;
        _proto._registerListener = function _registerListener(listenOn) {
            if (!listenOn || !listenOn.addEventListener) listenOn = window;
            listenOn.addEventListener("message", util._bind(this, this._receiveMessage), false);
        };
        _proto._receiveMessage = function _receiveMessage(event) {
            var handler = this._messageHandlers[event.data.type], extensionId = event.data.eid, reg;
            if (extensionId && this._registeredExtensions) reg = this._registeredExtensions[extensionId];
            if (!handler || !this._checkOrigin(event, reg)) return false;
            handler.call(this, event, reg);
        };
        return PostMessage;
    }();
    var VALID_EVENT_TIME_MS = 30000; //30 seconds
    var XDMRPC = /*#__PURE__*/ function(_PostMessage) {
        _inheritsLoose(XDMRPC, _PostMessage);
        var _proto = XDMRPC.prototype;
        _proto._padUndefinedArguments = function _padUndefinedArguments(array, length) {
            return array.length >= length ? array : array.concat(new Array(length - array.length));
        };
        function XDMRPC(config) {
            var _this;
            config = config || {};
            _this = _PostMessage.call(this, config) || this;
            _this._registeredExtensions = config.extensions || {};
            _this._registeredAPIModules = {};
            _this._registeredAPIModules._globals = {};
            _this._pendingCallbacks = {};
            _this._keycodeCallbacks = {};
            _this._clickHandler = null;
            _this._pendingEvents = {};
            _this._messageHandlers = {
                init: _this._handleInit,
                req: _this._handleRequest,
                resp: _this._handleResponse,
                broadcast: _this._handleBroadcast,
                event_query: _this._handleEventQuery,
                key_triggered: _this._handleKeyTriggered,
                addon_clicked: _this._handleAddonClick,
                get_host_offset: _this._getHostOffset,
                unload: _this._handleUnload
            };
            return _this;
        }
        _proto._verifyAPI = function _verifyAPI(event, reg) {
            var untrustedTargets = event.data.targets;
            if (!untrustedTargets) return;
            var trustedSpec = this.getApiSpec();
            var tampered = false;
            function check(trusted, untrusted) {
                Object.getOwnPropertyNames(untrusted).forEach(function(name) {
                    if (typeof untrusted[name] === "object" && trusted[name]) check(trusted[name], untrusted[name]);
                    else if (untrusted[name] === "parent" && trusted[name]) tampered = true;
                });
            }
            check(trustedSpec, untrustedTargets);
            event.source.postMessage({
                type: "api_tamper",
                tampered: tampered
            }, reg.extension.url);
        };
        _proto._handleInit = function _handleInit(event, reg) {
            event.source.postMessage({
                type: "init_received"
            }, reg.extension.url);
            this._registeredExtensions[reg.extension_id].source = event.source;
            if (reg.initCallback) {
                reg.initCallback(event.data.eid);
                delete reg.initCallback;
            }
            if (event.data.targets) this._verifyAPI(event, reg);
        };
        _proto._getHostOffset = function _getHostOffset(event, _window) {
            var hostWindow = event.source;
            var hostFrameOffset = null;
            var windowReference = _window || window; // For testing
            if (windowReference === windowReference.top && typeof windowReference.getHostOffsetFunctionOverride === "function") hostFrameOffset = windowReference.getHostOffsetFunctionOverride(hostWindow);
            if (typeof hostFrameOffset !== "number") {
                hostFrameOffset = 0;
                // Find the closest frame that has the same origin as event source
                while(!this._hasSameOrigin(hostWindow)){
                    // Climb up the iframe tree 1 layer
                    hostFrameOffset++;
                    hostWindow = hostWindow.parent;
                }
            }
            event.source.postMessage({
                hostFrameOffset: hostFrameOffset
            }, event.origin);
        };
        _proto._hasSameOrigin = function _hasSameOrigin(window1) {
            if (window1 === window1.top) return true;
            try {
                // Try set & read a variable on the given window
                // If we can successfully read the value then it means the given window has the same origin
                // as the window that is currently executing the script
                var testVariableName = "test_var_" + Math.random().toString(16).substr(2);
                window1[testVariableName] = true;
                return window1[testVariableName];
            } catch (e) {
            // A exception will be thrown if the windows doesn't have the same origin
            }
            return false;
        };
        _proto._handleResponse = function _handleResponse(event) {
            var data = event.data;
            var pendingCallback = this._pendingCallbacks[data.mid];
            if (pendingCallback) {
                delete this._pendingCallbacks[data.mid];
                pendingCallback.apply(window, data.args);
            }
        };
        _proto.registerRequestNotifier = function registerRequestNotifier(cb) {
            this._registeredRequestNotifier = cb;
        };
        _proto._handleRequest = function _handleRequest(event, reg) {
            function sendResponse() {
                var args = util.sanitizeStructuredClone(util.argumentsToArray(arguments));
                event.source.postMessage({
                    mid: event.data.mid,
                    type: "resp",
                    forPlugin: true,
                    args: args
                }, reg.extension.url);
            }
            var data = event.data;
            var module1 = this._registeredAPIModules[data.mod];
            var extension = this.getRegisteredExtensions(reg.extension)[0];
            if (module1) {
                var fnName = data.fn;
                if (data._cls) {
                    var Cls = module1[data._cls];
                    var ns = data.mod + "-" + data._cls + "-";
                    sendResponse._id = data._id;
                    if (fnName === "constructor") {
                        if (!Cls._construct) {
                            Cls.constructor.prototype._destroy = function() {
                                delete this._context._proxies[ns + this._id];
                            };
                            Cls._construct = function() {
                                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                                var inst = _construct(Cls.constructor, args);
                                var callback = args[args.length - 1];
                                inst._id = callback._id;
                                inst._context = callback._context;
                                inst._context._proxies[ns + inst._id] = inst;
                                return inst;
                            };
                        }
                        module1 = Cls;
                        fnName = "_construct";
                    } else module1 = extension._proxies[ns + data._id];
                }
                var method = module1[fnName];
                if (method) {
                    var methodArgs = data.args;
                    var padLength = method.length - 1;
                    if (fnName === "_construct") padLength = module1.constructor.length - 1;
                    sendResponse._context = extension;
                    methodArgs = this._padUndefinedArguments(methodArgs, padLength);
                    methodArgs.push(sendResponse);
                    var promiseResult = method.apply(module1, methodArgs);
                    if (method.returnsPromise) {
                        if (!(typeof promiseResult === "object" || typeof promiseResult === "function") || typeof promiseResult.then !== "function") sendResponse("Defined module method did not return a promise.");
                        else promiseResult.then(function(result) {
                            sendResponse(undefined, result);
                        }).catch(function(err) {
                            err = err instanceof Error ? err.message : err;
                            sendResponse(err);
                        });
                    }
                    if (this._registeredRequestNotifier) this._registeredRequestNotifier.call(null, {
                        module: data.mod,
                        fn: data.fn,
                        type: data.type,
                        addon_key: reg.extension.addon_key,
                        key: reg.extension.key,
                        extension_id: reg.extension_id
                    });
                }
            }
        };
        _proto._handleBroadcast = function _handleBroadcast(event, reg) {
            var event_data = event.data;
            var targetSpec = function targetSpec(r) {
                return r.extension.addon_key === reg.extension.addon_key && r.extension_id !== reg.extension_id;
            };
            this.dispatch(event_data.etyp, targetSpec, event_data.evnt, null, null);
        };
        _proto._handleKeyTriggered = function _handleKeyTriggered(event, reg) {
            var eventData = event.data;
            var keycodeEntry = this._keycodeKey(eventData.keycode, eventData.modifiers, reg.extension_id);
            var listeners = this._keycodeCallbacks[keycodeEntry];
            if (listeners) listeners.forEach(function(listener) {
                listener.call(null, {
                    addon_key: reg.extension.addon_key,
                    key: reg.extension.key,
                    extension_id: reg.extension_id,
                    keycode: eventData.keycode,
                    modifiers: eventData.modifiers
                });
            }, this);
        };
        _proto.defineAPIModule = function defineAPIModule(module1, moduleName) {
            moduleName = moduleName || "_globals";
            this._registeredAPIModules[moduleName] = util.extend({}, this._registeredAPIModules[moduleName] || {}, module1);
            return this._registeredAPIModules;
        };
        _proto.isAPIModuleDefined = function isAPIModuleDefined(moduleName) {
            return typeof this._registeredAPIModules[moduleName] !== "undefined";
        };
        _proto._pendingEventKey = function _pendingEventKey(targetSpec, time) {
            var key = targetSpec.addon_key || "global";
            if (targetSpec.key) key = key + "@@" + targetSpec.key;
            key = key + "@@" + time;
            return key;
        };
        _proto.queueEvent = function queueEvent(type, targetSpec, event, callback) {
            var loaded_frame, targets = this._findRegistrations(targetSpec);
            loaded_frame = targets.some(function(target) {
                return target.registered_events !== undefined;
            }, this);
            if (loaded_frame) this.dispatch(type, targetSpec, event, callback);
            else {
                this._cleanupInvalidEvents();
                var time = new Date().getTime();
                this._pendingEvents[this._pendingEventKey(targetSpec, time)] = {
                    type: type,
                    targetSpec: targetSpec,
                    event: event,
                    callback: callback,
                    time: time,
                    uid: util.randomString()
                };
            }
        };
        _proto._cleanupInvalidEvents = function _cleanupInvalidEvents() {
            var _this2 = this;
            var now = new Date().getTime();
            var keys = Object.keys(this._pendingEvents);
            keys.forEach(function(index) {
                var element = _this2._pendingEvents[index];
                var eventIsValid = now - element.time <= VALID_EVENT_TIME_MS;
                if (!eventIsValid) delete _this2._pendingEvents[index];
            });
        };
        _proto._handleEventQuery = function _handleEventQuery(message, extension) {
            var _this3 = this;
            var executed = {};
            var now = new Date().getTime();
            var keys = Object.keys(this._pendingEvents);
            keys.forEach(function(index) {
                var element = _this3._pendingEvents[index];
                var eventIsValid = now - element.time <= VALID_EVENT_TIME_MS;
                var isSameTarget = !element.targetSpec || _this3._findRegistrations(element.targetSpec).length !== 0;
                if (isSameTarget && element.targetSpec.key) isSameTarget = element.targetSpec.addon_key === extension.extension.addon_key && element.targetSpec.key === extension.extension.key;
                if (eventIsValid && isSameTarget) {
                    executed[index] = element;
                    element.targetSpec = element.targetSpec || {};
                    _this3.dispatch(element.type, element.targetSpec, element.event, element.callback, message.source);
                } else if (!eventIsValid) delete _this3._pendingEvents[index];
            });
            this._registeredExtensions[extension.extension_id].registered_events = message.data.args;
            return executed;
        };
        _proto._handleUnload = function _handleUnload(event, reg) {
            if (!reg) return;
            if (reg.extension_id && this._registeredExtensions[reg.extension_id]) delete this._registeredExtensions[reg.extension_id].source;
            if (reg.unloadCallback) reg.unloadCallback(event.data.eid);
        };
        _proto.dispatch = function dispatch(type, targetSpec, event, callback, source) {
            function sendEvent(reg, evnt) {
                if (reg.source && reg.source.postMessage) {
                    var mid;
                    if (callback) {
                        mid = util.randomString();
                        this._pendingCallbacks[mid] = callback;
                    }
                    reg.source.postMessage({
                        type: "evt",
                        mid: mid,
                        etyp: type,
                        evnt: evnt
                    }, reg.extension.url);
                }
            }
            var registrations = this._findRegistrations(targetSpec || {});
            registrations.forEach(function(reg) {
                if (source && !reg.source) reg.source = source;
                if (reg.source) util._bind(this, sendEvent)(reg, event);
            }, this);
        };
        _proto._findRegistrations = function _findRegistrations(targetSpec) {
            var _this4 = this;
            if (this._registeredExtensions.length === 0) {
                util.error("no registered extensions", this._registeredExtensions);
                return [];
            }
            var keys = Object.getOwnPropertyNames(targetSpec);
            var registrations = Object.getOwnPropertyNames(this._registeredExtensions).map(function(key) {
                return _this4._registeredExtensions[key];
            });
            if (targetSpec instanceof Function) return registrations.filter(targetSpec);
            else return registrations.filter(function(reg) {
                return keys.every(function(key) {
                    return reg.extension[key] === targetSpec[key];
                });
            });
        };
        _proto.registerExtension = function registerExtension(extension_id, data) {
            data._proxies = {};
            data.extension_id = extension_id;
            this._registeredExtensions[extension_id] = data;
        };
        _proto._keycodeKey = function _keycodeKey(key, modifiers, extension_id) {
            var code = key;
            if (modifiers) {
                if (typeof modifiers === "string") modifiers = [
                    modifiers
                ];
                modifiers.sort();
                modifiers.forEach(function(modifier) {
                    code += "$$" + modifier;
                }, this);
            }
            return code + "__" + extension_id;
        };
        _proto.registerKeyListener = function registerKeyListener(extension_id, key, modifiers, callback) {
            if (typeof modifiers === "string") modifiers = [
                modifiers
            ];
            var reg = this._registeredExtensions[extension_id];
            var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
            if (!this._keycodeCallbacks[keycodeEntry]) {
                this._keycodeCallbacks[keycodeEntry] = [];
                reg.source.postMessage({
                    type: "key_listen",
                    keycode: key,
                    modifiers: modifiers,
                    action: "add"
                }, reg.extension.url);
            }
            this._keycodeCallbacks[keycodeEntry].push(callback);
        };
        _proto.unregisterKeyListener = function unregisterKeyListener(extension_id, key, modifiers, callback) {
            var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
            var potentialCallbacks = this._keycodeCallbacks[keycodeEntry];
            var reg = this._registeredExtensions[extension_id];
            if (potentialCallbacks) {
                if (callback) {
                    var index = potentialCallbacks.indexOf(callback);
                    this._keycodeCallbacks[keycodeEntry].splice(index, 1);
                } else delete this._keycodeCallbacks[keycodeEntry];
                if (reg.source && reg.source.postMessage) reg.source.postMessage({
                    type: "key_listen",
                    keycode: key,
                    modifiers: modifiers,
                    action: "remove"
                }, reg.extension.url);
            }
        };
        _proto.registerClickHandler = function registerClickHandler(callback) {
            if (typeof callback !== "function") throw new Error("callback must be a function");
            if (this._clickHandler !== null) throw new Error("ClickHandler already registered");
            this._clickHandler = callback;
        };
        _proto._handleAddonClick = function _handleAddonClick(event, reg) {
            if (typeof this._clickHandler === "function") this._clickHandler({
                addon_key: reg.extension.addon_key,
                key: reg.extension.key,
                extension_id: reg.extension_id
            });
        };
        _proto.unregisterClickHandler = function unregisterClickHandler() {
            this._clickHandler = null;
        };
        _proto.getApiSpec = function getApiSpec(addonKey) {
            var _this5 = this;
            function getModuleDefinition(mod) {
                return Object.getOwnPropertyNames(mod).reduce(function(accumulator, memberName) {
                    var member = mod[memberName];
                    switch(typeof member){
                        case "function":
                            accumulator[memberName] = {
                                args: util.argumentNames(member),
                                returnsPromise: member.returnsPromise || false
                            };
                            break;
                        case "object":
                            if (member.hasOwnProperty("constructor")) accumulator[memberName] = getModuleDefinition(member);
                            break;
                    }
                    return accumulator;
                }, {});
            }
            return Object.getOwnPropertyNames(this._registeredAPIModules).reduce(function(accumulator, moduleName) {
                var module1 = _this5._registeredAPIModules[moduleName];
                if (typeof module1.addonKey === "undefined" || module1.addonKey === addonKey) accumulator[moduleName] = getModuleDefinition(module1);
                return accumulator;
            }, {});
        };
        _proto._originEqual = function _originEqual(url, origin) {
            function strCheck(str) {
                return typeof str === "string" && str.length > 0;
            }
            var urlOrigin = util.getOrigin(url);
            // check strings are strings and they contain something
            if (!strCheck(url) || !strCheck(origin) || !strCheck(urlOrigin)) return false;
            return origin === urlOrigin;
        };
        _proto._checkOrigin = function _checkOrigin(event, reg) {
            var no_source_types = [
                "init"
            ];
            var isNoSourceType = reg && !reg.source && no_source_types.indexOf(event.data.type) > -1;
            var sourceTypeMatches = reg && event.source === reg.source;
            var hasExtensionUrl = reg && this._originEqual(reg.extension.url, event.origin);
            var isValidOrigin = hasExtensionUrl && (isNoSourceType || sourceTypeMatches);
            // get_host_offset fires before init
            if (event.data.type === "get_host_offset" && window === window.top) isValidOrigin = true;
            // check undefined for chromium (Issue 395010)
            if (event.data.type === "unload" && (sourceTypeMatches || event.source === undefined)) isValidOrigin = true;
            return isValidOrigin;
        };
        _proto.getRegisteredExtensions = function getRegisteredExtensions(filter) {
            if (filter) return this._findRegistrations(filter);
            return this._registeredExtensions;
        };
        _proto.unregisterExtension = function unregisterExtension(filter) {
            var registrations = this._findRegistrations(filter);
            if (registrations.length !== 0) registrations.forEach(function(registration) {
                var _this6 = this;
                var keys = Object.keys(this._pendingEvents);
                keys.forEach(function(index) {
                    var element = _this6._pendingEvents[index];
                    var targetSpec = element.targetSpec || {};
                    if (targetSpec.addon_key === registration.extension.addon_key && targetSpec.key === registration.extension.key) delete _this6._pendingEvents[index];
                });
                delete this._registeredExtensions[registration.extension_id];
            }, this);
        };
        _proto.setFeatureFlagGetter = function setFeatureFlagGetter(getBooleanFeatureFlag) {
            this._getBooleanFeatureFlag = getBooleanFeatureFlag;
        };
        return XDMRPC;
    }(PostMessage);
    var Connect = /*#__PURE__*/ function() {
        function Connect() {
            this._xdm = new XDMRPC();
        }
        /**
     * Send a message to iframes matching the targetSpec. This message is added to
     *  a message queue for delivery to ensure the message is received if an iframe
     *  has not yet loaded
     *
     * @param type The name of the event type
     * @param targetSpec The spec to match against extensions when sending this event
     * @param event The event payload
     * @param callback A callback to be executed when the remote iframe calls its callback
     */ var _proto = Connect.prototype;
        _proto.dispatch = function dispatch(type, targetSpec, event, callback) {
            this._xdm.queueEvent(type, targetSpec, event, callback);
            return this.getExtensions(targetSpec);
        } /**
     * Send a message to iframes matching the targetSpec immediately. This message will
     *  only be sent to iframes that are already open, and will not be delivered if none
     *  are currently open.
     *
     * @param type The name of the event type
     * @param targetSpec The spec to match against extensions when sending this event
     * @param event The event payload
     */ ;
        _proto.broadcast = function broadcast(type, targetSpec, event) {
            this._xdm.dispatch(type, targetSpec, event, null, null);
            return this.getExtensions(targetSpec);
        };
        _proto._createId = function _createId(extension) {
            if (!extension.addon_key || !extension.key) throw Error("Extensions require addon_key and key");
            return extension.addon_key + "__" + extension.key + "__" + util.randomString();
        } /**
    * Creates a new iframed module, without actually creating the DOM element.
    * The iframe attributes are passed to the 'setupCallback', which is responsible for creating
    * the DOM element and returning the window reference.
    *
    * @param extension The extension definition. Example:
    *   {
    *     addon_key: 'my-addon',
    *     key: 'my-module',
    *     url: 'https://example.com/my-module',
    *     options: {
    *         autoresize: false,
    *         hostOrigin: 'https://connect-host.example.com/'
    *     }
    *   }
    *
    * @param initCallback The optional initCallback is called when the bridge between host and iframe is established.
    **/ ;
        _proto.create = function create(extension, initCallback, unloadCallback) {
            var extension_id = this.registerExtension(extension, initCallback, unloadCallback);
            var options = extension.options || {};
            var data = {
                extension_id: extension_id,
                api: this._xdm.getApiSpec(extension.addon_key),
                origin: util.locationOrigin(),
                options: options
            };
            return {
                id: extension_id,
                name: JSON.stringify(data),
                src: extension.url
            };
        };
        _proto.registerRequestNotifier = function registerRequestNotifier(callback) {
            this._xdm.registerRequestNotifier(callback);
        };
        _proto.registerExtension = function registerExtension(extension, initCallback, unloadCallback) {
            var extension_id = this._createId(extension);
            this._xdm.registerExtension(extension_id, {
                extension: extension,
                initCallback: initCallback,
                unloadCallback: unloadCallback
            });
            return extension_id;
        };
        _proto.registerKeyListener = function registerKeyListener(extension_id, key, modifiers, callback) {
            this._xdm.registerKeyListener(extension_id, key, modifiers, callback);
        };
        _proto.unregisterKeyListener = function unregisterKeyListener(extension_id, key, modifiers, callback) {
            this._xdm.unregisterKeyListener(extension_id, key, modifiers, callback);
        };
        _proto.registerClickHandler = function registerClickHandler(callback) {
            this._xdm.registerClickHandler(callback);
        };
        _proto.unregisterClickHandler = function unregisterClickHandler() {
            this._xdm.unregisterClickHandler();
        };
        _proto.defineModule = function defineModule(moduleName, module1, options) {
            this._xdm.defineAPIModule(module1, moduleName, options);
        };
        _proto.isModuleDefined = function isModuleDefined(moduleName) {
            return this._xdm.isAPIModuleDefined(moduleName);
        };
        _proto.defineGlobals = function defineGlobals(module1) {
            this._xdm.defineAPIModule(module1);
        };
        _proto.getExtensions = function getExtensions(filter) {
            return this._xdm.getRegisteredExtensions(filter);
        };
        _proto.unregisterExtension = function unregisterExtension(filter) {
            return this._xdm.unregisterExtension(filter);
        };
        _proto.returnsPromise = function returnsPromise(wrappedMethod) {
            wrappedMethod.returnsPromise = true;
        };
        _proto.setFeatureFlagGetter = function setFeatureFlagGetter(getBooleanFeatureFlag) {
            this._xdm.setFeatureFlagGetter(getBooleanFeatureFlag);
        };
        _proto.registerExistingExtension = function registerExistingExtension(extension_id, data) {
            return this._xdm.registerExtension(extension_id, data);
        };
        return Connect;
    }();
    var host$1 = new Connect();
    var _excluded$1 = [
        "contextJwt",
        "url"
    ];
    var EventActions = {
        targetSpecNoDialogs: function targetSpecNoDialogs(registration) {
            var _registration$extensi;
            return (registration == null || (_registration$extensi = registration.extension) == null || (_registration$extensi = _registration$extensi.options) == null ? void 0 : _registration$extensi.moduleType) !== "dialogs";
        },
        broadcast: function broadcast(type, targetSpec, event) {
            host$1.dispatch(type, targetSpec, event);
            EventDispatcher$1.dispatch("event-dispatch", {
                type: type,
                targetSpec: targetSpec,
                event: event
            });
        },
        broadcastPublic: function broadcastPublic(type, event, sender) {
            EventDispatcher$1.dispatch("event-public-dispatch", {
                type: type,
                event: event,
                sender: sender
            });
            var _ref = sender.options || {};
            _ref.contextJwt;
            _ref.url;
            var filteredOptions = _objectWithoutPropertiesLoose(_ref, _excluded$1);
            host$1.dispatch(type, {}, {
                sender: {
                    addonKey: sender.addon_key,
                    key: sender.key,
                    options: util.sanitizeStructuredClone(filteredOptions)
                },
                event: event
            });
        }
    };
    function escapeSelector(s) {
        if (!s) throw new Error("No selector to escape");
        return s.replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, "\\$&");
    }
    function stringToDimension(value) {
        var percent = false;
        var unit = "px";
        if (typeof value === "string") {
            percent = value.indexOf("%") === value.length - 1;
            value = parseInt(value, 10);
            if (percent) unit = "%";
        }
        if (!isNaN(value)) return value + unit;
    }
    function getIframeByExtensionId(id) {
        return $("iframe#" + escapeSelector(id));
    }
    function first(arr, numb) {
        if (numb) return arr.slice(0, numb);
        return arr[0];
    }
    function last(arr) {
        return arr[arr.length - 1];
    }
    function pick(obj, keys) {
        if (typeof obj !== "object") return {};
        return Object.keys(obj).filter(function(key) {
            return keys.indexOf(key) >= 0;
        }).reduce(function(newObj, key) {
            var _Object$assign;
            return Object.assign(newObj, (_Object$assign = {}, _Object$assign[key] = obj[key], _Object$assign));
        }, {});
    }
    function debounce$1(fn, wait) {
        var timeout;
        return function() {
            var ctx = this;
            var args = [].slice.call(arguments);
            function later() {
                timeout = null;
                fn.apply(ctx, args);
            }
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(later, wait || 50);
        };
    }
    function isSupported(domElem, attr, value, defaultValue) {
        if (domElem && domElem[attr] && domElem[attr].supports) return domElem[attr].supports(value);
        else return defaultValue;
    }
    function guessProductFromModuleDefined(connectHost) {
        if (connectHost.isModuleDefined("jira")) return "Jira";
        if (connectHost.isModuleDefined("confluence")) return "Confluence";
        return "";
    }
    var Util = {
        escapeSelector: escapeSelector,
        stringToDimension: stringToDimension,
        getIframeByExtensionId: getIframeByExtensionId,
        first: first,
        last: last,
        pick: pick,
        debounce: debounce$1,
        isSupported: isSupported,
        extend: Object.assign,
        guessProductFromModuleDefined: guessProductFromModuleDefined
    };
    var events = {
        emit: function emit(name) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            var callback = Util.last(args);
            args = Util.first(args, -1);
            EventActions.broadcast(name, {
                addon_key: callback._context.extension.addon_key
            }, args);
        },
        emitPublic: function emitPublic(name) {
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            var callback = Util.last(args);
            var extension = callback._context.extension;
            args = Util.first(args, -1);
            EventActions.broadcastPublic(name, args, extension);
        },
        emitToDataProvider: function emitToDataProvider() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            var callback = Util.last(args);
            callback._context.extension;
            args = Util.first(args, -1);
            EventActions.broadcast("dataProviderEvent", {
                addon_key: callback._context.extension.addon_key
            }, args);
        }
    };
    var DialogExtensionActions = {
        open: function open(extension, options) {
            EventDispatcher$1.dispatch("dialog-extension-open", {
                extension: extension,
                options: options
            });
        },
        close: function close() {
            EventDispatcher$1.dispatch("dialog-close-active", {});
        },
        addUserButton: function addUserButton(options, extension) {
            EventDispatcher$1.dispatch("dialog-button-add", {
                button: {
                    text: options.text,
                    identifier: options.identifier,
                    data: {
                        userButton: true
                    }
                },
                extension: extension
            });
        }
    };
    var DialogActions = {
        close: function close(data) {
            EventDispatcher$1.dispatch("dialog-close", {
                dialog: data.dialog,
                extension: data.extension,
                customData: data.customData
            });
        },
        closeActive: function closeActive(data) {
            EventDispatcher$1.dispatch("dialog-close-active", data);
        },
        clickButton: function clickButton(identifier, $el, extension) {
            EventDispatcher$1.dispatch("dialog-button-click", {
                identifier: identifier,
                $el: $el,
                extension: extension
            });
        },
        toggleButton: function toggleButton(data) {
            EventDispatcher$1.dispatch("dialog-button-toggle", data);
        },
        toggleButtonVisibility: function toggleButtonVisibility(data) {
            EventDispatcher$1.dispatch("dialog-button-toggle-visibility", data);
        }
    };
    var DomEventActions = {
        registerKeyEvent: function registerKeyEvent(data) {
            host$1.registerKeyListener(data.extension_id, data.key, data.modifiers, data.callback);
            EventDispatcher$1.dispatch("dom-event-register", data);
        },
        unregisterKeyEvent: function unregisterKeyEvent(data) {
            host$1.unregisterKeyListener(data.extension_id, data.key, data.modifiers, data.callback);
            EventDispatcher$1.dispatch("dom-event-unregister", data);
        },
        registerWindowKeyEvent: function registerWindowKeyEvent(data) {
            window.addEventListener("keydown", function(event) {
                if (event.keyCode === data.keyCode) data.callback();
            });
        },
        registerClickHandler: function registerClickHandler(handleIframeClick) {
            host$1.registerClickHandler(function(data) {
                var iframe = document.getElementById(data.extension_id);
                if (iframe) handleIframeClick(iframe);
            });
        },
        unregisterClickHandler: function unregisterClickHandler() {
            host$1.unregisterClickHandler();
        }
    };
    var ButtonUtils = /*#__PURE__*/ function() {
        function ButtonUtils() {}
        var _proto = ButtonUtils.prototype;
        // button identifier for XDM. NOT an id attribute
        _proto.randomIdentifier = function randomIdentifier() {
            return Math.random().toString(16).substring(7);
        };
        return ButtonUtils;
    }();
    var buttonUtilsInstance = new ButtonUtils();
    var threshold = 0.25;
    var targets = [];
    var observe;
    var observed = function observed(target) {
        targets = targets.filter(function(_ref) {
            var element = _ref.element, callback = _ref.callback;
            if (element === target) {
                callback();
                return false;
            }
            return true;
        });
    };
    if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window) {
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(_ref2) {
                var intersectionRatio = _ref2.intersectionRatio, target = _ref2.target;
                if (intersectionRatio > 0) {
                    observer.unobserve(target);
                    observed(target);
                }
            });
        }, {
            threshold: threshold
        });
        observe = observer.observe.bind(observer);
    }
    var observe$1 = function(element, callback) {
        if (typeof callback === "function" && element instanceof Element) {
            targets.push({
                element: element,
                callback: callback
            });
            observe(element);
        }
    };
    /**
   * Timings beyond 20 seconds (connect's load timeout) will be clipped to an X.
   * @const
   * @type {int}
   */ var LOADING_TIME_THRESHOLD = 20000;
    /**
   * Trim extra zeros from the load time.
   * @const
   * @type {int}
   */ var LOADING_TIME_TRIMP_PRECISION = 100;
    /**
   * @param {number} value
   * @returns {number}
   */ function bucketLoadingTime(value) {
        var bucket = value > LOADING_TIME_THRESHOLD ? LOADING_TIME_THRESHOLD : value;
        return Math.ceil(bucket / LOADING_TIME_TRIMP_PRECISION) * LOADING_TIME_TRIMP_PRECISION;
    }
    // Only send 0.1% of content resolver events
    var CONTENT_RESOLVER_SAMPLE_RATE = 0.1;
    // Only send 0.1% of invoke method events
    var INVOKE_METHOD_SAMPLE_RATE = 0.1;
    // Only send 0.1% of iframe load events
    var IFRAME_LOAD_SAMPLE_RATE = 0.1;
    var AnalyticsDispatcher = /*#__PURE__*/ function() {
        function AnalyticsDispatcher() {
            this._addons = {};
        }
        /**
     * Determines whether a sampled event should be sent based on given rate.
     * @param {int} rate Rate as an integer percentage.
     * @returns {boolean}
     */ var _proto = AnalyticsDispatcher.prototype;
        _proto._shouldSampleEvent = function _shouldSampleEvent(rate) {
            return Math.random() * 100 <= rate;
        } /**
     * Track an event via GasV3.
     *
     * Warning! Confluence does not use ac/analytics, we have to manually forward it
     * The legacy way of doing this was using individual hooks for each event. Many existing events have dedicated hooks.
     * If you are creating a new event, you can use sendExternal=true to avoid the need for a dedicated hook.
     *
     * https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/confluence/packages/confluence-connect-support/src/ConnectAnalyticsPublishSupport.js
     * @param eventType {string}
     * @param event {object}
     * @param sendExternal {boolean}
     * @private
     */ ;
        _proto._trackGasV3 = function _trackGasV3(eventType, event, sendExternal) {
            if (event.attributes) event.attributes.apVersion = window._AP && window._AP.version ? window._AP.version : undefined;
            if (sendExternal) this._forwardGasV3AnalyticsEvent(eventType, event);
            try {
                var analyticsCrossProduct = window.require("ac/analytics");
                analyticsCrossProduct.emitGasV3(eventType, event);
            } catch (e) {
                if (!window.Confluence && !window.__karma__) // this is not serious. It usually means the product is doing analytics using another mechanism
                // Confluence no longer uses ac/analytics so we should stop reporting it as an error
                console.info("Connect GasV3 catch", e);
            }
        };
        _proto._trackAndForwardGasV3 = function _trackAndForwardGasV3(eventType, event) {
            this._trackGasV3(eventType, event, true);
        };
        _proto._forwardGasV3AnalyticsEvent = function _forwardGasV3AnalyticsEvent(eventType, event) {
            EventDispatcher$1.dispatch("analytics-forward-event", eventType, event);
        };
        _proto._time = function _time() {
            return window.performance && window.performance.now ? window.performance.now() : new Date().getTime();
        };
        _proto.trackLoadingStarted = function trackLoadingStarted(extension) {
            if (this._addons && extension && extension.id) {
                extension.startLoading = this._time();
                this._addons[extension.id] = extension;
            } else console.error("ACJS: cannot track loading analytics", this._addons, extension);
        };
        _proto.trackGasV3UseOfDeprecatedMethod = function trackGasV3UseOfDeprecatedMethod(methodUsed, extension) {
            this._trackAndForwardGasV3("operational", {
                action: "deprecatedMethod",
                actionSubject: "connectAddon",
                actionSubjectId: extension.addon_key,
                attributes: {
                    moduleKey: extension.key,
                    methodUsed: methodUsed
                },
                source: extension.addon_key
            });
        };
        _proto.trackGasV3MultipleDialogOpening = function trackGasV3MultipleDialogOpening(dialogType, extension) {
            this._trackAndForwardGasV3("operational", {
                action: "multipleDialogOpened",
                actionSubject: "connectAddon",
                actionSubjectId: extension.addon_key,
                attributes: {
                    moduleKey: extension.key,
                    dialogType: dialogType
                },
                source: extension.addon_key
            });
        };
        _proto.trackIframePerformance = function trackIframePerformance(metrics, extension) {
            if (!this._shouldSampleEvent(IFRAME_LOAD_SAMPLE_RATE)) return;
            this._trackGasV3("operational", {
                source: extension.addon_key,
                action: "iframeRendered",
                actionSubject: "connectAddon",
                actionSubjectId: extension.addon_key,
                attributes: {
                    key: extension["key"],
                    pearApp: this._getPearApp(extension),
                    moduleType: this._getModuleType(extension),
                    iframeIsCacheable: this._isCacheable(extension),
                    moduleLocation: this._getModuleLocation(extension),
                    domainLookupTime: metrics.domainLookupTime,
                    connectionTime: metrics.connectionTime,
                    decodedBodySize: metrics.decodedBodySize,
                    domContentLoadedTime: metrics.domContentLoadedTime,
                    fetchTime: metrics.fetchTime
                }
            });
        };
        _proto.dispatch = function dispatch(name, data) {
            this._trackGasV3External(name, data);
        };
        _proto.trackExternal = function trackExternal(name, data) {
            this._trackGasV3External(name, data);
        };
        _proto._trackGasV3External = function _trackGasV3External(name, data) {
            this._trackAndForwardGasV3("operational", {
                action: "externalEvent",
                actionSubject: "connectAddon",
                actionSubjectId: name,
                attributes: _extends({
                    eventName: name
                }, typeof data === "object" ? data : {
                    values: data
                }),
                source: "connectAddon"
            });
        } /**
    * method called when an iframe's loading metrics gets corrupted
    * to destroy the analytics as they cannot be reliable
    * this should be called when:
    * 1. the product calls iframe creation multiple times for the same connect addon
    * 2. the iframe is moved / repainted causing a window.reload event
    * 3. user right clicks iframe and reloads it
    */ ;
        _proto._resetAnalyticsDueToUnreliable = function _resetAnalyticsDueToUnreliable(extensionId) {
            if (!extensionId) throw new Error("Cannot reset analytics due to no extension id");
            if (this._addons[extensionId]) {
                clearTimeout(this._addons[extensionId]);
                delete this._addons[extensionId];
            } else console.info("Cannot clear analytics, cache does not contain extension id");
        };
        _proto._isCacheable = function _isCacheable(extension) {
            var href = extension.url;
            return href !== undefined && href.indexOf("xdm_e=") === -1;
        };
        _proto._getModuleType = function _getModuleType(extension) {
            return extension.options ? extension.options.moduleType : undefined;
        };
        _proto._getModuleLocation = function _getModuleLocation(extension) {
            return extension.options ? extension.options.moduleLocation : undefined;
        };
        _proto._getPearApp = function _getPearApp(extension) {
            return extension.options && extension.options.pearApp === "true";
        };
        _proto.trackGasV3Visible = function trackGasV3Visible(extension) {
            if (!this._shouldSampleEvent(IFRAME_LOAD_SAMPLE_RATE)) return;
            this._trackGasV3("operational", {
                action: "iframeViewed",
                actionSubject: "connectAddon",
                actionSubjectId: extension["addon_key"],
                attributes: {
                    moduleType: this._getModuleType(extension),
                    iframeIsCacheable: this._isCacheable(extension),
                    moduleKey: extension.key,
                    moduleLocation: this._getModuleLocation(extension),
                    pearApp: this._getPearApp(extension)
                },
                source: extension.addon_key
            });
        };
        _proto.trackGasV3InvokeMethod = function trackGasV3InvokeMethod(extension, module1, method) {
            if (!this._shouldSampleEvent(INVOKE_METHOD_SAMPLE_RATE)) return;
            this._trackAndForwardGasV3("operational", {
                action: "invokeMethod",
                actionSubject: "connectAddon",
                actionSubjectId: extension["addon_key"],
                attributes: {
                    module: module1,
                    method: method,
                    moduleType: this._getModuleType(extension),
                    moduleKey: extension.key,
                    moduleLocation: this._getModuleLocation(extension),
                    pearApp: this._getPearApp(extension)
                },
                source: extension.addon_key
            });
        };
        _proto.trackGasV3ContentResolver = function trackGasV3ContentResolver(isSuccess, extra) {
            if (!this._shouldSampleEvent(CONTENT_RESOLVER_SAMPLE_RATE)) return;
            var extension = extra.extension;
            var attrs = extra.attrs;
            var action = isSuccess ? "contentResolverSucceeded" : "contentResolverFailed";
            this._trackGasV3("operational", {
                action: action,
                actionSubject: "connectAddon",
                actionSubjectId: extension["addon_key"],
                attributes: Object.assign({}, attrs, {
                    moduleType: this._getModuleType(extension),
                    moduleKey: extension.key,
                    moduleLocation: this._getModuleLocation(extension),
                    pearApp: this._getPearApp(extension)
                }),
                source: extension.addon_key
            });
        };
        _proto.trackGasV3LoadingEnded = function trackGasV3LoadingEnded(extension) {
            if (!this._shouldSampleEvent(IFRAME_LOAD_SAMPLE_RATE)) return;
            var iframeLoadMillis = this._time() - this._addons[extension.id].startLoading;
            this._trackGasV3("operational", {
                action: "iframeLoaded",
                actionSubject: "connectAddon",
                actionSubjectId: extension["addon_key"],
                attributes: {
                    moduleType: this._getModuleType(extension),
                    iframeIsCacheable: this._isCacheable(extension),
                    iframeLoadMillis: iframeLoadMillis,
                    iframeLoadBucket: bucketLoadingTime(iframeLoadMillis),
                    moduleKey: extension.key,
                    moduleLocation: this._getModuleLocation(extension),
                    pearApp: this._getPearApp(extension)
                },
                source: extension.addon_key
            });
        };
        _proto.trackGasV3LoadingTimeout = function trackGasV3LoadingTimeout(extension) {
            if (!this._shouldSampleEvent(IFRAME_LOAD_SAMPLE_RATE)) return;
            this._trackGasV3("operational", {
                action: "iframeTimeout",
                actionSubject: "connectAddon",
                actionSubjectId: extension["addon_key"],
                attributes: {
                    moduleType: this._getModuleType(extension),
                    iframeIsCacheable: this._isCacheable(extension),
                    moduleKey: extension.key,
                    moduleLocation: this._getModuleLocation(extension),
                    pearApp: this._getPearApp(extension),
                    connectedStatus: typeof window.navigator.onLine === "boolean" ? window.navigator.onLine.toString() : "not-supported"
                },
                source: extension.addon_key
            });
        } /**
     * @param {WebItemInvokedEventData} data
     */ ;
        _proto.trackGasV3InlineDialogOpened = function trackGasV3InlineDialogOpened(data) {
            var extension = data.extension;
            this._trackAndForwardGasV3("operational", {
                action: "inlineDialogOpened",
                actionSubject: "connectAddon",
                actionSubjectId: extension["addon_key"],
                attributes: {
                    moduleKey: extension.key,
                    moduleLocation: this._getModuleLocation(extension),
                    eventType: data.eventType,
                    onHoverEnabled: data.onHover
                },
                source: extension.addon_key
            });
        } /**
     * Track a dialog opened via the legacy event-handler (non-imperative) API
     */ ;
        _proto.trackGasV3LegacyDialogOpened = function trackGasV3LegacyDialogOpened(data) {
            var extension = data.extension;
            this._trackAndForwardGasV3("operational", {
                action: "legacyDialogOpened",
                actionSubject: "connectAddon",
                actionSubjectId: extension["addon_key"],
                attributes: {
                    moduleKey: extension.key,
                    moduleLocation: this._getModuleLocation(extension),
                    parentIds: data.parentIds
                },
                source: extension.addon_key
            });
        } /**
     * Tracks when the Statsig client is not initialised before the Statsig feature flag is fetched
     * Jira - https://data-portal.internal.atlassian.com/analytics/registry/67270
     * Confluence - https://data-portal.internal.atlassian.com/analytics/registry/67271
     */ ;
        _proto.trackGasV3FeatureFlagDefaultFalse = function trackGasV3FeatureFlagDefaultFalse(featureFlag) {
            this._trackAndForwardGasV3("operational", {
                action: "returned",
                actionSubject: "defaultFalseFeatureFlag",
                attributes: {
                    featureFlag: featureFlag
                },
                source: window.AP ? "Iframe" : "Host"
            });
        };
        return AnalyticsDispatcher;
    }();
    var analytics$1 = new AnalyticsDispatcher();
    if ($.fn) EventDispatcher$1.register("iframe-create", function(data) {
        analytics$1.trackLoadingStarted(data.extension);
    });
    EventDispatcher$1.register("method-invoked", function(data) {
        analytics$1.trackGasV3InvokeMethod(data.extension, data.module, data.fn);
    });
    EventDispatcher$1.register("iframe-bridge-start", function(data) {
        analytics$1.trackLoadingStarted(data.extension);
    });
    EventDispatcher$1.register("iframe-bridge-established", function(data) {
        analytics$1.trackGasV3LoadingEnded(data.extension);
        observe$1(document.getElementById(data.extension.id), function() {
            EventDispatcher$1.dispatch("iframe-visible", data.extension);
            analytics$1.trackGasV3Visible(data.extension);
        });
    });
    EventDispatcher$1.register("iframe-bridge-timeout", function(data) {
        analytics$1.trackGasV3LoadingTimeout(data.extension);
    });
    EventDispatcher$1.register("analytics-deprecated-method-used", function(data) {
        analytics$1.trackGasV3UseOfDeprecatedMethod(data.methodUsed, data.extension);
    });
    EventDispatcher$1.register("analytics-iframe-performance", function(data) {
        analytics$1.trackIframePerformance(data.metrics, data.extension);
    });
    EventDispatcher$1.register("iframe-destroyed", function(data) {
        analytics$1._resetAnalyticsDueToUnreliable(data.extension.extension_id);
    });
    EventDispatcher$1.register("analytics-external-event-track", function(data) {
        analytics$1.trackExternal(data.eventName, data.values);
    });
    EventDispatcher$1.register("analytics-content-resolver-track", function(data) {
        var success = data.success;
        var extra = data.extra;
        analytics$1.trackGasV3ContentResolver(success, extra);
    });
    EventDispatcher$1.register("analytics-inline-dialog-opened", function(data) {
        analytics$1.trackGasV3InlineDialogOpened(data);
    });
    EventDispatcher$1.register("analytics-legacy-dialog-opened", function(data) {
        analytics$1.trackGasV3LegacyDialogOpened(data);
    });
    var DialogUtils = /*#__PURE__*/ function() {
        function DialogUtils() {}
        var _proto = DialogUtils.prototype;
        _proto._maxDimension = function _maxDimension(val, maxPxVal) {
            var parsed = Util.stringToDimension(val);
            var parsedInt = parseInt(parsed, 10);
            var parsedMaxPxVal = parseInt(maxPxVal, 10);
            if (parsed.indexOf("%") > -1 && parsedInt >= 100 // %
             || parsedInt > parsedMaxPxVal) // px
            return "100%";
            return parsed;
        };
        _proto._closeOnEscape = function _closeOnEscape(options) {
            if (options.closeOnEscape === false) return false;
            else return true;
        };
        _proto._size = function _size(options) {
            var size = options.size;
            if (options.size === "x-large") size = "xlarge";
            if (options.size !== "maximum" && options.width === "100%" && options.height === "100%") size = "fullscreen";
            return size;
        };
        _proto._header = function _header(text) {
            var headerText = "";
            switch(typeof text){
                case "string":
                    headerText = text;
                    break;
                case "object":
                    headerText = text.value;
                    break;
            }
            return headerText;
        };
        _proto._hint = function _hint(text) {
            if (typeof text === "string") return text;
            return "";
        };
        _proto._chrome = function _chrome(options) {
            var returnval = false;
            if (typeof options.chrome === "boolean") returnval = options.chrome;
            if (options.size === "fullscreen") returnval = true;
            if (options.size === "maximum") returnval = false;
            return returnval;
        };
        _proto._width = function _width(options) {
            if (options.size) return undefined;
            if (options.width) return this._maxDimension(options.width, $(window).width());
            return "50%";
        };
        _proto._height = function _height(options) {
            if (options.size) return undefined;
            if (options.height) return this._maxDimension(options.height, $(window).height());
            return "50%";
        };
        _proto._actions = function _actions(options) {
            var sanitizedActions = [];
            options = options || {};
            if (!options.actions) sanitizedActions = [
                {
                    name: "submit",
                    identifier: "submit",
                    text: options.submitText || "Submit",
                    type: "primary",
                    disabled: true // disable submit button by default (until the dialog has loaded).
                },
                {
                    name: "cancel",
                    identifier: "cancel",
                    text: options.cancelText || "Cancel",
                    type: "link",
                    immutable: true
                }
            ];
            if (options.buttons) sanitizedActions = sanitizedActions.concat(this._buttons(options));
            return sanitizedActions;
        };
        _proto._id = function _id(str) {
            if (typeof str !== "string") str = Math.random().toString(36).substring(2, 8);
            return str;
        };
        _proto._buttons = function _buttons(options) {
            var buttons = [];
            if (options.buttons && Array.isArray(options.buttons)) options.buttons.forEach(function(button) {
                var text;
                var identifier;
                var disabled = false;
                if (button.text && typeof button.text === "string") text = button.text;
                if (button.identifier && typeof button.identifier === "string") identifier = button.identifier;
                else identifier = buttonUtilsInstance.randomIdentifier();
                if (button.disabled && button.disabled === true) disabled = true;
                buttons.push({
                    text: text,
                    identifier: identifier,
                    type: "secondary",
                    custom: true,
                    disabled: disabled
                });
            });
            return buttons;
        };
        _proto._onHide = function _onHide(options) {
            var noop = function noop() {};
            if (typeof options.onHide === "function") return options.onHide;
            else return noop;
        };
        _proto.sanitizeOptions = function sanitizeOptions(options) {
            options = options || {};
            var sanitized = {
                chrome: this._chrome(options),
                header: this._header(options.header),
                hint: this._hint(options.hint),
                width: this._width(options),
                height: this._height(options),
                $content: options.$content,
                extension: options.extension,
                actions: this._actions(options),
                id: this._id(options.id),
                size: options.size,
                closeOnEscape: this._closeOnEscape(options),
                onHide: this._onHide(options)
            };
            sanitized.size = this._size(sanitized);
            return sanitized;
        };
        _proto.moduleOptionsFromGlobal = function moduleOptionsFromGlobal(addon_key, key) {
            var defaultOptions = {
                chrome: true,
                hostFrameOffset: 1
            };
            if (window._AP && window._AP.dialogModules && window._AP.dialogModules[addon_key] && window._AP.dialogModules[addon_key][key]) return Util.extend({}, defaultOptions, window._AP.dialogModules[addon_key][key].options);
            return false;
        };
        _proto.trackMultipleDialogOpening = function trackMultipleDialogOpening(dialogExtension, options) {
            // check for dialogs that are already open
            var trackingDescription;
            var size = this._size(options);
            if ($(".ap-aui-dialog2:visible").length) {
                // am i in the confluence editor? first check for macro dialogs opened through macro browser, second is editing an existing macro
                if ($("#macro-browser-dialog").length || AJS.Confluence && AJS.Confluence.Editor && AJS.Confluence.Editor.currentEditMode) {
                    if (size === "fullscreen") trackingDescription = "connect-macro-multiple-fullscreen";
                    else trackingDescription = "connect-macro-multiple";
                } else trackingDescription = "connect-multiple";
                analytics$1.trackGasV3MultipleDialogOpening(trackingDescription, dialogExtension);
            }
        };
        _proto.assertActiveDialogOrThrow = function assertActiveDialogOrThrow(dialogProvider, addon_key) {
            if (!dialogProvider.isActiveDialog(addon_key)) throw new Error("Failed to find an active dialog for: " + addon_key);
        };
        return DialogUtils;
    }();
    var dialogUtilsInstance = new DialogUtils();
    var IframeActions = {
        notifyIframeCreated: function notifyIframeCreated($el, extension) {
            EventDispatcher$1.dispatch("iframe-create", {
                $el: $el,
                extension: extension
            });
        },
        notifyBridgeEstablished: function notifyBridgeEstablished($el, extension) {
            EventDispatcher$1.dispatch("iframe-bridge-established", {
                $el: $el,
                extension: extension
            });
        },
        notifyIframeDestroyed: function notifyIframeDestroyed(filter) {
            if (typeof filter === "string") filter = {
                id: filter
            };
            var extensions = host$1.getExtensions(filter);
            extensions.forEach(function(extension) {
                EventDispatcher$1.dispatch("iframe-destroyed", {
                    extension: extension
                });
                host$1.unregisterExtension({
                    id: extension.extension_id
                });
            }, this);
        },
        notifyUnloaded: function notifyUnloaded($el, extension) {
            EventDispatcher$1.dispatch("iframe-unload", {
                $el: $el,
                extension: extension
            });
        }
    };
    var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
    function getDefaultExportFromCjs(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
    }
    var queryString = {};
    var strictUriEncode = function(str) {
        return encodeURIComponent(str).replace(/[!'()*]/g, function(x) {
            return "%" + x.charCodeAt(0).toString(16).toUpperCase();
        });
    };
    var token = "%[a-f0-9]{2}";
    var singleMatcher = new RegExp("(" + token + ")|([^%]+?)", "gi");
    var multiMatcher = new RegExp("(" + token + ")+", "gi");
    function decodeComponents(components, split) {
        try {
            // Try to decode the entire string first
            return [
                decodeURIComponent(components.join(""))
            ];
        } catch (err) {
        // Do nothing
        }
        if (components.length === 1) return components;
        split = split || 1;
        // Split the array in 2 parts
        var left = components.slice(0, split);
        var right = components.slice(split);
        return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
    }
    function decode$1(input) {
        try {
            return decodeURIComponent(input);
        } catch (err) {
            var tokens = input.match(singleMatcher) || [];
            for(var i = 1; i < tokens.length; i++){
                input = decodeComponents(tokens, i).join("");
                tokens = input.match(singleMatcher) || [];
            }
            return input;
        }
    }
    function customDecodeURIComponent(input) {
        // Keep track of all the replacements and prefill the map with the `BOM`
        var replaceMap = {
            "%FE%FF": "\uFFFD\uFFFD",
            "%FF%FE": "\uFFFD\uFFFD"
        };
        var match = multiMatcher.exec(input);
        while(match){
            try {
                // Decode as big chunks as possible
                replaceMap[match[0]] = decodeURIComponent(match[0]);
            } catch (err) {
                var result = decode$1(match[0]);
                if (result !== match[0]) replaceMap[match[0]] = result;
            }
            match = multiMatcher.exec(input);
        }
        // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
        replaceMap["%C2"] = "\uFFFD";
        var entries = Object.keys(replaceMap);
        for(var i = 0; i < entries.length; i++){
            // Replace all decoded components
            var key = entries[i];
            input = input.replace(new RegExp(key, "g"), replaceMap[key]);
        }
        return input;
    }
    var decodeUriComponent = function(encodedURI) {
        if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
        try {
            encodedURI = encodedURI.replace(/\+/g, " ");
            // Try the built in decoder first
            return decodeURIComponent(encodedURI);
        } catch (err) {
            // Fallback to a more advanced decoder
            return customDecodeURIComponent(encodedURI);
        }
    };
    var splitOnFirst = function(string, separator) {
        if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
        if (separator === "") return [
            string
        ];
        var separatorIndex = string.indexOf(separator);
        if (separatorIndex === -1) return [
            string
        ];
        return [
            string.slice(0, separatorIndex),
            string.slice(separatorIndex + separator.length)
        ];
    };
    var filterObj = function(obj, predicate) {
        var ret = {};
        var keys = Object.keys(obj);
        var isArr = Array.isArray(predicate);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            var val = obj[key];
            if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
        }
        return ret;
    };
    (function(exports) {
        const strictUriEncode$1 = strictUriEncode;
        const decodeComponent = decodeUriComponent;
        const splitOnFirst$1 = splitOnFirst;
        const filterObject = filterObj;
        const isNullOrUndefined = (value)=>value === null || value === undefined;
        const encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
        function encoderForArrayFormat(options) {
            switch(options.arrayFormat){
                case "index":
                    return (key)=>(result, value)=>{
                            const index = result.length;
                            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                            if (value === null) return [
                                ...result,
                                [
                                    encode(key, options),
                                    "[",
                                    index,
                                    "]"
                                ].join("")
                            ];
                            return [
                                ...result,
                                [
                                    encode(key, options),
                                    "[",
                                    encode(index, options),
                                    "]=",
                                    encode(value, options)
                                ].join("")
                            ];
                        };
                case "bracket":
                    return (key)=>(result, value)=>{
                            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                            if (value === null) return [
                                ...result,
                                [
                                    encode(key, options),
                                    "[]"
                                ].join("")
                            ];
                            return [
                                ...result,
                                [
                                    encode(key, options),
                                    "[]=",
                                    encode(value, options)
                                ].join("")
                            ];
                        };
                case "colon-list-separator":
                    return (key)=>(result, value)=>{
                            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                            if (value === null) return [
                                ...result,
                                [
                                    encode(key, options),
                                    ":list="
                                ].join("")
                            ];
                            return [
                                ...result,
                                [
                                    encode(key, options),
                                    ":list=",
                                    encode(value, options)
                                ].join("")
                            ];
                        };
                case "comma":
                case "separator":
                case "bracket-separator":
                    {
                        const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                        return (key)=>(result, value)=>{
                                if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                                // Translate null to an empty string so that it doesn't serialize as 'null'
                                value = value === null ? "" : value;
                                if (result.length === 0) return [
                                    [
                                        encode(key, options),
                                        keyValueSep,
                                        encode(value, options)
                                    ].join("")
                                ];
                                return [
                                    [
                                        result,
                                        encode(value, options)
                                    ].join(options.arrayFormatSeparator)
                                ];
                            };
                    }
                default:
                    return (key)=>(result, value)=>{
                            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                            if (value === null) return [
                                ...result,
                                encode(key, options)
                            ];
                            return [
                                ...result,
                                [
                                    encode(key, options),
                                    "=",
                                    encode(value, options)
                                ].join("")
                            ];
                        };
            }
        }
        function parserForArrayFormat(options) {
            let result;
            switch(options.arrayFormat){
                case "index":
                    return (key, value, accumulator)=>{
                        result = /\[(\d*)\]$/.exec(key);
                        key = key.replace(/\[\d*\]$/, "");
                        if (!result) {
                            accumulator[key] = value;
                            return;
                        }
                        if (accumulator[key] === undefined) accumulator[key] = {};
                        accumulator[key][result[1]] = value;
                    };
                case "bracket":
                    return (key, value, accumulator)=>{
                        result = /(\[\])$/.exec(key);
                        key = key.replace(/\[\]$/, "");
                        if (!result) {
                            accumulator[key] = value;
                            return;
                        }
                        if (accumulator[key] === undefined) {
                            accumulator[key] = [
                                value
                            ];
                            return;
                        }
                        accumulator[key] = [].concat(accumulator[key], value);
                    };
                case "colon-list-separator":
                    return (key, value, accumulator)=>{
                        result = /(:list)$/.exec(key);
                        key = key.replace(/:list$/, "");
                        if (!result) {
                            accumulator[key] = value;
                            return;
                        }
                        if (accumulator[key] === undefined) {
                            accumulator[key] = [
                                value
                            ];
                            return;
                        }
                        accumulator[key] = [].concat(accumulator[key], value);
                    };
                case "comma":
                case "separator":
                    return (key, value, accumulator)=>{
                        const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                        const isEncodedArray = typeof value === "string" && !isArray && decode(value, options).includes(options.arrayFormatSeparator);
                        value = isEncodedArray ? decode(value, options) : value;
                        const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>decode(item, options)) : value === null ? value : decode(value, options);
                        accumulator[key] = newValue;
                    };
                case "bracket-separator":
                    return (key, value, accumulator)=>{
                        const isArray = /(\[\])$/.test(key);
                        key = key.replace(/\[\]$/, "");
                        if (!isArray) {
                            accumulator[key] = value ? decode(value, options) : value;
                            return;
                        }
                        const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>decode(item, options));
                        if (accumulator[key] === undefined) {
                            accumulator[key] = arrayValue;
                            return;
                        }
                        accumulator[key] = [].concat(accumulator[key], arrayValue);
                    };
                default:
                    return (key, value, accumulator)=>{
                        if (accumulator[key] === undefined) {
                            accumulator[key] = value;
                            return;
                        }
                        accumulator[key] = [].concat(accumulator[key], value);
                    };
            }
        }
        function validateArrayFormatSeparator(value) {
            if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
        }
        function encode(value, options) {
            if (options.encode) return options.strict ? strictUriEncode$1(value) : encodeURIComponent(value);
            return value;
        }
        function decode(value, options) {
            if (options.decode) return decodeComponent(value);
            return value;
        }
        function keysSorter(input) {
            if (Array.isArray(input)) return input.sort();
            if (typeof input === "object") return keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
            return input;
        }
        function removeHash(input) {
            const hashStart = input.indexOf("#");
            if (hashStart !== -1) input = input.slice(0, hashStart);
            return input;
        }
        function getHash(url) {
            let hash = "";
            const hashStart = url.indexOf("#");
            if (hashStart !== -1) hash = url.slice(hashStart);
            return hash;
        }
        function extract(input) {
            input = removeHash(input);
            const queryStart = input.indexOf("?");
            if (queryStart === -1) return "";
            return input.slice(queryStart + 1);
        }
        function parseValue(value, options) {
            if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
            else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
            return value;
        }
        function parse(query, options) {
            options = Object.assign({
                decode: true,
                sort: true,
                arrayFormat: "none",
                arrayFormatSeparator: ",",
                parseNumbers: false,
                parseBooleans: false
            }, options);
            validateArrayFormatSeparator(options.arrayFormatSeparator);
            const formatter = parserForArrayFormat(options);
            // Create an object with no prototype
            const ret = Object.create(null);
            if (typeof query !== "string") return ret;
            query = query.trim().replace(/^[?#&]/, "");
            if (!query) return ret;
            for (const param of query.split("&")){
                if (param === "") continue;
                let [key, value] = splitOnFirst$1(options.decode ? param.replace(/\+/g, " ") : param, "=");
                // Missing `=` should be `null`:
                // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
                value = value === undefined ? null : [
                    "comma",
                    "separator",
                    "bracket-separator"
                ].includes(options.arrayFormat) ? value : decode(value, options);
                formatter(decode(key, options), value, ret);
            }
            for (const key of Object.keys(ret)){
                const value = ret[key];
                if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = parseValue(value[k], options);
                else ret[key] = parseValue(value, options);
            }
            if (options.sort === false) return ret;
            return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
                const value = ret[key];
                if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
                result[key] = keysSorter(value);
                else result[key] = value;
                return result;
            }, Object.create(null));
        }
        exports.extract = extract;
        exports.parse = parse;
        exports.stringify = (object, options)=>{
            if (!object) return "";
            options = Object.assign({
                encode: true,
                strict: true,
                arrayFormat: "none",
                arrayFormatSeparator: ","
            }, options);
            validateArrayFormatSeparator(options.arrayFormatSeparator);
            const shouldFilter = (key)=>options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
            const formatter = encoderForArrayFormat(options);
            const objectCopy = {};
            for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
            const keys = Object.keys(objectCopy);
            if (options.sort !== false) keys.sort(options.sort);
            return keys.map((key)=>{
                const value = object[key];
                if (value === undefined) return "";
                if (value === null) return encode(key, options);
                if (Array.isArray(value)) {
                    if (value.length === 0 && options.arrayFormat === "bracket-separator") return encode(key, options) + "[]";
                    return value.reduce(formatter(key), []).join("&");
                }
                return encode(key, options) + "=" + encode(value, options);
            }).filter((x)=>x.length > 0).join("&");
        };
        exports.parseUrl = (url, options)=>{
            options = Object.assign({
                decode: true
            }, options);
            const [url_, hash] = splitOnFirst$1(url, "#");
            return Object.assign({
                url: url_.split("?")[0] || "",
                query: parse(extract(url), options)
            }, options && options.parseFragmentIdentifier && hash ? {
                fragmentIdentifier: decode(hash, options)
            } : {});
        };
        exports.stringifyUrl = (object, options)=>{
            options = Object.assign({
                encode: true,
                strict: true,
                [encodeFragmentIdentifier]: true
            }, options);
            const url = removeHash(object.url).split("?")[0] || "";
            const queryFromUrl = exports.extract(object.url);
            const parsedQueryFromUrl = exports.parse(queryFromUrl, {
                sort: false
            });
            const query = Object.assign(parsedQueryFromUrl, object.query);
            let queryString = exports.stringify(query, options);
            if (queryString) queryString = `?${queryString}`;
            let hash = getHash(object.url);
            if (object.fragmentIdentifier) hash = `#${options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
            return `${url}${queryString}${hash}`;
        };
        exports.pick = (input, filter, options)=>{
            options = Object.assign({
                parseFragmentIdentifier: true,
                [encodeFragmentIdentifier]: false
            }, options);
            const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = exports.parseUrl(input, options);
            return exports.stringifyUrl({
                url: url,
                query: filterObject(query, filter),
                fragmentIdentifier: fragmentIdentifier
            }, options);
        };
        exports.exclude = (input, filter, options)=>{
            const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
            return exports.pick(input, exclusionFilter, options);
        };
    })(queryString);
    var toByteArray_1 = toByteArray;
    var lookup = [];
    var revLookup = [];
    var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
    var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    for(var i = 0, len = code.length; i < len; ++i){
        lookup[i] = code[i];
        revLookup[code.charCodeAt(i)] = i;
    }
    // Support decoding URL-safe base64 strings, as Node.js does.
    // See: https://en.wikipedia.org/wiki/Base64#URL_applications
    revLookup["-".charCodeAt(0)] = 62;
    revLookup["_".charCodeAt(0)] = 63;
    function getLens(b64) {
        var len = b64.length;
        if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
        // Trim off extra bytes after placeholder bytes are found
        // See: https://github.com/beatgammit/base64-js/issues/42
        var validLen = b64.indexOf("=");
        if (validLen === -1) validLen = len;
        var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
        return [
            validLen,
            placeHoldersLen
        ];
    }
    function _byteLength(b64, validLen, placeHoldersLen) {
        return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
    }
    function toByteArray(b64) {
        var tmp;
        var lens = getLens(b64);
        var validLen = lens[0];
        var placeHoldersLen = lens[1];
        var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
        var curByte = 0;
        // if there are placeholders, only get up to the last complete 4 chars
        var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
        for(var i = 0; i < len; i += 4){
            tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
            arr[curByte++] = tmp >> 16 & 0xFF;
            arr[curByte++] = tmp >> 8 & 0xFF;
            arr[curByte++] = tmp & 0xFF;
        }
        if (placeHoldersLen === 2) {
            tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
            arr[curByte++] = tmp & 0xFF;
        }
        if (placeHoldersLen === 1) {
            tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
            arr[curByte++] = tmp >> 8 & 0xFF;
            arr[curByte++] = tmp & 0xFF;
        }
        return arr;
    }
    function decode(string) {
        var padding = 4 - string.length % 4;
        if (padding === 1) string += "=";
        else if (padding === 2) string += "==";
        return new TextDecoder().decode(toByteArray_1(string));
    }
    var JWT_SKEW = 60; // in seconds.
    function parseJwtIssuer(jwt) {
        return parseJwtClaims(jwt)["iss"];
    }
    function parseJwtClaims(jwt) {
        if (null === jwt || "" === jwt) throw "Invalid JWT: must be neither null nor empty-string.";
        var firstPeriodIndex = jwt.indexOf(".");
        var secondPeriodIndex = jwt.indexOf(".", firstPeriodIndex + 1);
        if (firstPeriodIndex < 0 || secondPeriodIndex <= firstPeriodIndex) throw 'Invalid JWT: must contain 2 period (".") characters.';
        var encodedClaims = jwt.substring(firstPeriodIndex + 1, secondPeriodIndex);
        if (null === encodedClaims || "" === encodedClaims) throw "Invalid JWT: encoded claims must be neither null nor empty-string.";
        var claimsString = decode.call(window, encodedClaims);
        return JSON.parse(claimsString);
    }
    function isJwtExpired$1(jwtString, skew) {
        if (skew === undefined) skew = JWT_SKEW;
        var claims = parseJwtClaims(jwtString);
        var expires = 0;
        var now = Math.floor(Date.now() / 1000); // UTC timestamp now
        if (claims && claims.exp) expires = claims.exp;
        if (expires - skew < now) return true;
        return false;
    }
    EventDispatcher$1.register("jwt-skew-set", function(data) {
        JWT_SKEW = data.skew;
    });
    var jwtUtil = {
        parseJwtIssuer: parseJwtIssuer,
        parseJwtClaims: parseJwtClaims,
        isJwtExpired: isJwtExpired$1
    };
    function isJwtExpired(urlStr) {
        var jwtStr = _getJwt(urlStr);
        return jwtUtil.isJwtExpired(jwtStr);
    }
    function _getJwt(urlStr) {
        var query = queryString.parse(queryString.extract(urlStr));
        return query["jwt"];
    }
    function hasJwt(url) {
        var jwt = _getJwt(url);
        return jwt && _getJwt(url).length !== 0;
    }
    var urlUtils = {
        hasJwt: hasJwt,
        isJwtExpired: isJwtExpired
    };
    var jwtActions = {
        registerContentResolver: function registerContentResolver(data) {
            EventDispatcher$1.dispatch("content-resolver-register-by-extension", data);
        },
        requestRefreshUrl: function requestRefreshUrl(data) {
            if (!data.resolver) throw Error("ACJS: No content resolver supplied");
            var promise = data.resolver.call(null, Util.extend({
                classifier: "json"
            }, data.extension));
            promise.fail(function(promiseData, error) {
                EventDispatcher$1.dispatch("jwt-url-refreshed-failed", {
                    extension: data.extension,
                    $container: data.$container,
                    errorText: error.text
                });
            });
            promise.done(function(promiseData) {
                var newExtensionConfiguration = {};
                if (typeof promiseData === "object") newExtensionConfiguration = promiseData;
                else if (typeof promiseData === "string") try {
                    newExtensionConfiguration = JSON.parse(promiseData);
                } catch (e) {
                    console.error("ACJS: invalid response from content resolver");
                }
                data.extension.url = newExtensionConfiguration.url;
                Util.extend(data.extension.options, newExtensionConfiguration.options);
                EventDispatcher$1.dispatch("jwt-url-refreshed", {
                    extension: data.extension,
                    $container: data.$container,
                    url: data.extension.url
                });
            });
            EventDispatcher$1.dispatch("jwt-url-refresh-request", {
                data: data
            });
        },
        setClockSkew: function setClockSkew(skew) {
            if (typeof skew === "number") EventDispatcher$1.dispatch("jwt-skew-set", {
                skew: skew
            });
            else console.error("ACJS: invalid JWT clock skew set");
        }
    };
    var iframeUtils = {
        optionsToAttributes: function optionsToAttributes(options) {
            var sanitized = {};
            if (options && typeof options === "object") {
                if (options.width) sanitized.width = Util.stringToDimension(options.width);
                if (options.height) sanitized.height = Util.stringToDimension(options.height);
                if (typeof options.sandbox === "string") {
                    var domElem = document.createElement("iframe");
                    sanitized.sandbox = options.sandbox.split(" ").filter(function(value) {
                        return Util.isSupported(domElem, "sandbox", value, true);
                    }).join(" ");
                }
            }
            return sanitized;
        }
    };
    var ExtensionConfigurationOptionsStore = /*#__PURE__*/ function() {
        function ExtensionConfigurationOptionsStore() {
            this.store = {};
        }
        var _proto = ExtensionConfigurationOptionsStore.prototype;
        _proto.set = function set(obj, val) {
            if (val) {
                var toSet = {};
                toSet[obj] = val;
            } else toSet = obj;
            Util.extend(this.store, toSet);
        };
        _proto.get = function get(key) {
            if (key) return this.store[key];
            return Util.extend({}, this.store); //clone
        };
        return ExtensionConfigurationOptionsStore;
    }();
    var ExtensionConfigurationOptionsStore$1 = new ExtensionConfigurationOptionsStore();
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArrayLimit(r, l) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != t) {
            var e, n, i, u, a = [], f = !0, o = !1;
            try {
                if (i = (t = t.call(r)).next, 0 === l) {
                    if (Object(t) !== t) return;
                    f = !1;
                } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
            } catch (r) {
                o = !0, n = r;
            } finally{
                try {
                    if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
                } finally{
                    if (o) throw n;
                }
            }
            return a;
        }
    }
    function _arrayLikeToArray$1(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _unsupportedIterableToArray$1(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest();
    }
    function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
        try {
            var info = gen[key](arg);
            var value = info.value;
        } catch (error) {
            reject(error);
            return;
        }
        if (info.done) resolve(value);
        else Promise.resolve(value).then(_next, _throw);
    }
    function _asyncToGenerator(fn) {
        return function() {
            var self1 = this, args = arguments;
            return new Promise(function(resolve, reject) {
                var gen = fn.apply(self1, args);
                function _next(value) {
                    asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                }
                function _throw(err) {
                    asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                }
                _next(undefined);
            });
        };
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _typeof$1(o) {
        "@babel/helpers - typeof";
        return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof$1(o);
    }
    function _toPrimitive(input, hint) {
        if (_typeof$1(input) !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (_typeof$1(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function _toPropertyKey(arg) {
        var key = _toPrimitive(arg, "string");
        return _typeof$1(key) === "symbol" ? key : String(key);
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function _defineProperty(obj, key, value) {
        key = _toPropertyKey(key);
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    var regeneratorRuntime$1 = {
        exports: {}
    };
    var _typeof = {
        exports: {}
    };
    (function(module1) {
        function _typeof(o) {
            "@babel/helpers - typeof";
            return module1.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                return typeof o;
            } : function(o) {
                return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
            }, module1.exports.__esModule = true, module1.exports["default"] = module1.exports, _typeof(o);
        }
        module1.exports = _typeof, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
    })(_typeof);
    (function(module1) {
        var _typeof$1 = _typeof.exports["default"];
        function _regeneratorRuntime() {
            /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ module1.exports = _regeneratorRuntime = function _regeneratorRuntime() {
                return e;
            }, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
            var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
                t[e] = r.value;
            }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
            function define(t, e, r) {
                return Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }), t[e];
            }
            try {
                define({}, "");
            } catch (t) {
                define = function define(t, e, r) {
                    return t[e] = r;
                };
            }
            function wrap(t, e, r, n) {
                var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
                return o(a, "_invoke", {
                    value: makeInvokeMethod(t, r, c)
                }), a;
            }
            function tryCatch(t, e, r) {
                try {
                    return {
                        type: "normal",
                        arg: t.call(e, r)
                    };
                } catch (t) {
                    return {
                        type: "throw",
                        arg: t
                    };
                }
            }
            e.wrap = wrap;
            var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
            function Generator() {}
            function GeneratorFunction() {}
            function GeneratorFunctionPrototype() {}
            var p = {};
            define(p, a, function() {
                return this;
            });
            var d = Object.getPrototypeOf, v = d && d(d(values([])));
            v && v !== r && n.call(v, a) && (p = v);
            var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
            function defineIteratorMethods(t) {
                [
                    "next",
                    "throw",
                    "return"
                ].forEach(function(e) {
                    define(t, e, function(t) {
                        return this._invoke(e, t);
                    });
                });
            }
            function AsyncIterator(t, e) {
                function invoke(r, o, i, a) {
                    var c = tryCatch(t[r], t, o);
                    if ("throw" !== c.type) {
                        var u = c.arg, h = u.value;
                        return h && "object" == _typeof$1(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                            invoke("next", t, i, a);
                        }, function(t) {
                            invoke("throw", t, i, a);
                        }) : e.resolve(h).then(function(t) {
                            u.value = t, i(u);
                        }, function(t) {
                            return invoke("throw", t, i, a);
                        });
                    }
                    a(c.arg);
                }
                var r;
                o(this, "_invoke", {
                    value: function value(t, n) {
                        function callInvokeWithMethodAndArg() {
                            return new e(function(e, r) {
                                invoke(t, n, e, r);
                            });
                        }
                        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
                    }
                });
            }
            function makeInvokeMethod(e, r, n) {
                var o = h;
                return function(i, a) {
                    if (o === f) throw new Error("Generator is already running");
                    if (o === s) {
                        if ("throw" === i) throw a;
                        return {
                            value: t,
                            done: !0
                        };
                    }
                    for(n.method = i, n.arg = a;;){
                        var c = n.delegate;
                        if (c) {
                            var u = maybeInvokeDelegate(c, n);
                            if (u) {
                                if (u === y) continue;
                                return u;
                            }
                        }
                        if ("next" === n.method) n.sent = n._sent = n.arg;
                        else if ("throw" === n.method) {
                            if (o === h) throw o = s, n.arg;
                            n.dispatchException(n.arg);
                        } else "return" === n.method && n.abrupt("return", n.arg);
                        o = f;
                        var p = tryCatch(e, r, n);
                        if ("normal" === p.type) {
                            if (o = n.done ? s : l, p.arg === y) continue;
                            return {
                                value: p.arg,
                                done: n.done
                            };
                        }
                        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
                    }
                };
            }
            function maybeInvokeDelegate(e, r) {
                var n = r.method, o = e.iterator[n];
                if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                var i = tryCatch(o, e.iterator, r.arg);
                if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
                var a = i.arg;
                return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
            }
            function pushTryEntry(t) {
                var e = {
                    tryLoc: t[0]
                };
                1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
            }
            function resetTryEntry(t) {
                var e = t.completion || {};
                e.type = "normal", delete e.arg, t.completion = e;
            }
            function Context(t) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], t.forEach(pushTryEntry, this), this.reset(!0);
            }
            function values(e) {
                if (e || "" === e) {
                    var r = e[a];
                    if (r) return r.call(e);
                    if ("function" == typeof e.next) return e;
                    if (!isNaN(e.length)) {
                        var o = -1, i = function next() {
                            for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                            return next.value = t, next.done = !0, next;
                        };
                        return i.next = i;
                    }
                }
                throw new TypeError(_typeof$1(e) + " is not iterable");
            }
            return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
                value: GeneratorFunctionPrototype,
                configurable: !0
            }), o(GeneratorFunctionPrototype, "constructor", {
                value: GeneratorFunction,
                configurable: !0
            }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
                var e = "function" == typeof t && t.constructor;
                return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
            }, e.mark = function(t) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
            }, e.awrap = function(t) {
                return {
                    __await: t
                };
            }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
                return this;
            }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new AsyncIterator(wrap(t, r, n, o), i);
                return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                    return t.done ? t.value : a.next();
                });
            }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
                return this;
            }), define(g, "toString", function() {
                return "[object Generator]";
            }), e.keys = function(t) {
                var e = Object(t), r = [];
                for(var n in e)r.push(n);
                return r.reverse(), function next() {
                    for(; r.length;){
                        var t = r.pop();
                        if (t in e) return next.value = t, next.done = !1, next;
                    }
                    return next.done = !0, next;
                };
            }, e.values = values, Context.prototype = {
                constructor: Context,
                reset: function reset(e) {
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
                },
                stop: function stop() {
                    this.done = !0;
                    var t = this.tryEntries[0].completion;
                    if ("throw" === t.type) throw t.arg;
                    return this.rval;
                },
                dispatchException: function dispatchException(e) {
                    if (this.done) throw e;
                    var r = this;
                    function handle(n, o) {
                        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
                    }
                    for(var o = this.tryEntries.length - 1; o >= 0; --o){
                        var i = this.tryEntries[o], a = i.completion;
                        if ("root" === i.tryLoc) return handle("end");
                        if (i.tryLoc <= this.prev) {
                            var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                            if (c && u) {
                                if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                                if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                            } else if (c) {
                                if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                            } else {
                                if (!u) throw new Error("try statement without catch or finally");
                                if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function abrupt(t, e) {
                    for(var r = this.tryEntries.length - 1; r >= 0; --r){
                        var o = this.tryEntries[r];
                        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                            var i = o;
                            break;
                        }
                    }
                    i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                    var a = i ? i.completion : {};
                    return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
                },
                complete: function complete(t, e) {
                    if ("throw" === t.type) throw t.arg;
                    return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
                },
                finish: function finish(t) {
                    for(var e = this.tryEntries.length - 1; e >= 0; --e){
                        var r = this.tryEntries[e];
                        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
                    }
                },
                "catch": function _catch(t) {
                    for(var e = this.tryEntries.length - 1; e >= 0; --e){
                        var r = this.tryEntries[e];
                        if (r.tryLoc === t) {
                            var n = r.completion;
                            if ("throw" === n.type) {
                                var o = n.arg;
                                resetTryEntry(r);
                            }
                            return o;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function delegateYield(e, r, n) {
                    return this.delegate = {
                        iterator: values(e),
                        resultName: r,
                        nextLoc: n
                    }, "next" === this.method && (this.arg = t), y;
                }
            }, e;
        }
        module1.exports = _regeneratorRuntime, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
    })(regeneratorRuntime$1);
    // TODO(Babel 8): Remove this file.
    var runtime = regeneratorRuntime$1.exports();
    var regenerator = runtime;
    // Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
    try {
        regeneratorRuntime = runtime;
    } catch (accidentalStrictMode) {
        if (typeof globalThis === "object") globalThis.regeneratorRuntime = runtime;
        else Function("r", "regeneratorRuntime = r")(runtime);
    }
    var dist = {};
    var Errors = {};
    (function(exports) {
        var __extends = commonjsGlobal && commonjsGlobal.__extends || function() {
            var _extendStatics = function extendStatics(d, b) {
                _extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
                return _extendStatics(d, b);
            };
            return function(d, b) {
                if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                _extendStatics(d, b);
                function __() {
                    this.constructor = d;
                }
                d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            };
        }();
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.StatsigSDKKeyMismatchError = exports.StatsigInvalidArgumentError = exports.StatsigUninitializedError = exports.StatsigErrorMessage = void 0;
        var StatsigErrorMessage;
        (function(StatsigErrorMessage) {
            StatsigErrorMessage["REQUIRE_ASYNC_INITIALIZE"] = "Call initialize() first.";
            StatsigErrorMessage["REQUIRE_SYNC_INITIALIZE"] = "Call and wait for initialize() to finish first.";
            StatsigErrorMessage["REQUIRE_INITIALIZE_FOR_LOG_EVENT"] = "Must initialize() before logging events.";
        })(StatsigErrorMessage = exports.StatsigErrorMessage || (exports.StatsigErrorMessage = {}));
        var StatsigUninitializedError = /** @class */ function(_super) {
            __extends(StatsigUninitializedError, _super);
            function StatsigUninitializedError(message) {
                var _this = _super.call(this, message !== null && message !== void 0 ? message : StatsigErrorMessage.REQUIRE_SYNC_INITIALIZE) || this;
                Object.setPrototypeOf(_this, StatsigUninitializedError.prototype);
                return _this;
            }
            return StatsigUninitializedError;
        }(Error);
        exports.StatsigUninitializedError = StatsigUninitializedError;
        var StatsigInvalidArgumentError = /** @class */ function(_super) {
            __extends(StatsigInvalidArgumentError, _super);
            function StatsigInvalidArgumentError(message) {
                var _this = _super.call(this, message) || this;
                Object.setPrototypeOf(_this, StatsigInvalidArgumentError.prototype);
                return _this;
            }
            return StatsigInvalidArgumentError;
        }(Error);
        exports.StatsigInvalidArgumentError = StatsigInvalidArgumentError;
        var StatsigSDKKeyMismatchError = /** @class */ function(_super) {
            __extends(StatsigSDKKeyMismatchError, _super);
            function StatsigSDKKeyMismatchError(message) {
                var _this = _super.call(this, message) || this;
                Object.setPrototypeOf(_this, StatsigSDKKeyMismatchError.prototype);
                return _this;
            }
            return StatsigSDKKeyMismatchError;
        }(Error);
        exports.StatsigSDKKeyMismatchError = StatsigSDKKeyMismatchError;
    })(Errors);
    var StatsigClient$1 = {};
    var DynamicConfig$1 = {};
    Object.defineProperty(DynamicConfig$1, "__esModule", {
        value: true
    });
    var DynamicConfig = /** @class */ function() {
        function DynamicConfig(configName, configValue, ruleID, evaluationDetails, secondaryExposures, allocatedExperimentName, onDefaultValueFallback) {
            if (secondaryExposures === void 0) secondaryExposures = [];
            if (allocatedExperimentName === void 0) allocatedExperimentName = "";
            if (onDefaultValueFallback === void 0) onDefaultValueFallback = null;
            this._onDefaultValueFallback = null;
            this.value = JSON.parse(JSON.stringify(configValue !== null && configValue !== void 0 ? configValue : {}));
            this._name = configName;
            this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : "";
            this._secondaryExposures = secondaryExposures;
            this._allocatedExperimentName = allocatedExperimentName;
            this._evaluationDetails = evaluationDetails;
            this._onDefaultValueFallback = onDefaultValueFallback;
        }
        DynamicConfig.prototype.get = function(key, defaultValue, typeGuard) {
            var _a, _b;
            var val = this.getValue(key, defaultValue);
            if (val == null) return defaultValue;
            var expectedType = Array.isArray(defaultValue) ? "array" : typeof defaultValue;
            var actualType = Array.isArray(val) ? "array" : typeof val;
            if (typeGuard) {
                if (typeGuard(val)) return val;
                (_a = this._onDefaultValueFallback) === null || _a === void 0 || _a.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
            if (defaultValue == null || expectedType === actualType) return val;
            (_b = this._onDefaultValueFallback) === null || _b === void 0 || _b.call(this, this, key, expectedType, actualType);
            return defaultValue;
        };
        DynamicConfig.prototype.getValue = function(key, defaultValue) {
            if (key == null) return this.value;
            if (defaultValue == null) defaultValue = null;
            if (this.value[key] == null) return defaultValue;
            return this.value[key];
        };
        return DynamicConfig;
    }();
    DynamicConfig$1.default = DynamicConfig;
    var ErrorBoundary = {};
    (function(exports) {
        var __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || function(thisArg, _arguments, P, generator) {
            function adopt(value) {
                return value instanceof P ? value : new P(function(resolve) {
                    resolve(value);
                });
            }
            return new (P || (P = Promise))(function(resolve, reject) {
                function fulfilled(value) {
                    try {
                        step(generator.next(value));
                    } catch (e) {
                        reject(e);
                    }
                }
                function rejected(value) {
                    try {
                        step(generator["throw"](value));
                    } catch (e) {
                        reject(e);
                    }
                }
                function step(result) {
                    result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                }
                step((generator = generator.apply(thisArg, _arguments || [])).next());
            });
        };
        var __generator = commonjsGlobal && commonjsGlobal.__generator || function(thisArg, body) {
            var _ = {
                label: 0,
                sent: function sent() {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: []
            }, f, y, t, g;
            return g = {
                next: verb(0),
                "throw": verb(1),
                "return": verb(2)
            }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                return this;
            }), g;
            function verb(n) {
                return function(v) {
                    return step([
                        n,
                        v
                    ]);
                };
            }
            function step(op) {
                if (f) throw new TypeError("Generator is already executing.");
                while(g && (g = 0, op[0] && (_ = 0)), _)try {
                    if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                    if (y = 0, t) op = [
                        op[0] & 2,
                        t.value
                    ];
                    switch(op[0]){
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return {
                                value: op[1],
                                done: false
                            };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [
                                0
                            ];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [
                        6,
                        e
                    ];
                    y = 0;
                } finally{
                    f = t = 0;
                }
                if (op[0] & 5) throw op[1];
                return {
                    value: op[0] ? op[1] : void 0,
                    done: true
                };
            }
        };
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.ExceptionEndpoint = void 0;
        var Errors_1 = Errors;
        exports.ExceptionEndpoint = "https://statsigapi.net/v1/sdk_exception";
        var ErrorBoundary = /** @class */ function() {
            function ErrorBoundary(sdkKey, options) {
                this._seen = new Set();
                this._sdkKey = sdkKey;
                this._options = options;
            }
            ErrorBoundary.prototype._setStatsigMetadata = function(statsigMetadata) {
                this._statsigMetadata = statsigMetadata;
            };
            ErrorBoundary.prototype._swallow = function(tag, task) {
                this._capture(tag, task, function() {
                    return undefined;
                });
            };
            ErrorBoundary.prototype._capture = function(tag, task, recover, getExtraData) {
                var _this = this;
                try {
                    var result = task();
                    if (result instanceof Promise) return result.catch(function(e) {
                        return _this._onCaught(tag, e, recover, getExtraData);
                    });
                    return result;
                } catch (error) {
                    return this._onCaught(tag, error, recover, getExtraData);
                }
            };
            ErrorBoundary.prototype._logError = function(tag, error, getExtraData) {
                var _this = this;
                if (this._options.disableAllLogging) return;
                try {
                    var impl = function impl() {
                        return __awaiter(_this, void 0, void 0, function() {
                            var extra, _a, unwrapped, isError, name, info, metadata, body;
                            var _b;
                            return __generator(this, function(_c) {
                                switch(_c.label){
                                    case 0:
                                        if (!(typeof getExtraData === "function")) return [
                                            3 /*break*/ ,
                                            2
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            getExtraData()
                                        ];
                                    case 1:
                                        _a = _c.sent();
                                        return [
                                            3 /*break*/ ,
                                            3
                                        ];
                                    case 2:
                                        _a = null;
                                        _c.label = 3;
                                    case 3:
                                        extra = _a;
                                        unwrapped = error !== null && error !== void 0 ? error : Error("[Statsig] Error was empty");
                                        isError = unwrapped instanceof Error;
                                        name = isError ? unwrapped.name : "No Name";
                                        if (this._seen.has(name)) return [
                                            2 /*return*/ 
                                        ];
                                        this._seen.add(name);
                                        info = isError ? unwrapped.stack : this._getDescription(unwrapped);
                                        metadata = (_b = this._statsigMetadata) !== null && _b !== void 0 ? _b : {};
                                        body = JSON.stringify({
                                            tag: tag,
                                            exception: name,
                                            info: info,
                                            statsigMetadata: metadata,
                                            extra: extra !== null && extra !== void 0 ? extra : {}
                                        });
                                        return [
                                            2 /*return*/ ,
                                            fetch(exports.ExceptionEndpoint, {
                                                method: "POST",
                                                headers: {
                                                    "STATSIG-API-KEY": this._sdkKey,
                                                    "STATSIG-SDK-TYPE": String(metadata["sdkType"]),
                                                    "STATSIG-SDK-VERSION": String(metadata["sdkVersion"]),
                                                    "Content-Type": "application/json",
                                                    "Content-Length": "".concat(body.length)
                                                },
                                                body: body
                                            })
                                        ];
                                }
                            });
                        });
                    };
                    impl().then(function() {
                    /* noop */ }).catch(function() {
                    /* noop */ });
                } catch (_error) {
                /* noop */ }
            };
            ErrorBoundary.prototype._onCaught = function(tag, error, recover, getExtraData) {
                if (error instanceof Errors_1.StatsigUninitializedError || error instanceof Errors_1.StatsigInvalidArgumentError) throw error; // Don't catch these
                console.error("[Statsig] An unexpected exception occurred.", error);
                this._logError(tag, error, getExtraData);
                return recover();
            };
            ErrorBoundary.prototype._getDescription = function(obj) {
                try {
                    return JSON.stringify(obj);
                } catch (_a) {
                    return "[Statsig] Failed to get string for error.";
                }
            };
            return ErrorBoundary;
        }();
        exports.default = ErrorBoundary;
    })(ErrorBoundary);
    var Layer$1 = {};
    Object.defineProperty(Layer$1, "__esModule", {
        value: true
    });
    var Layer = /** @class */ function() {
        function Layer(name, layerValue, ruleID, evaluationDetails, logParameterFunction, secondaryExposures, undelegatedSecondaryExposures, allocatedExperimentName, explicitParameters) {
            if (logParameterFunction === void 0) logParameterFunction = null;
            if (secondaryExposures === void 0) secondaryExposures = [];
            if (undelegatedSecondaryExposures === void 0) undelegatedSecondaryExposures = [];
            if (allocatedExperimentName === void 0) allocatedExperimentName = "";
            if (explicitParameters === void 0) explicitParameters = [];
            this._logParameterFunction = logParameterFunction;
            this._name = name;
            this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
            this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : "";
            this._evaluationDetails = evaluationDetails;
            this._secondaryExposures = secondaryExposures;
            this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
            this._allocatedExperimentName = allocatedExperimentName;
            this._explicitParameters = explicitParameters;
        }
        Layer._create = function(name, value, ruleID, evaluationDetails, logParameterFunction, secondaryExposures, undelegatedSecondaryExposures, allocatedExperimentName, explicitParameters) {
            if (logParameterFunction === void 0) logParameterFunction = null;
            if (secondaryExposures === void 0) secondaryExposures = [];
            if (undelegatedSecondaryExposures === void 0) undelegatedSecondaryExposures = [];
            if (allocatedExperimentName === void 0) allocatedExperimentName = "";
            if (explicitParameters === void 0) explicitParameters = [];
            return new Layer(name, value, ruleID, evaluationDetails, logParameterFunction, secondaryExposures, undelegatedSecondaryExposures, allocatedExperimentName, explicitParameters);
        };
        Layer.prototype.get = function(key, defaultValue, typeGuard) {
            var _this = this;
            var val = this._value[key];
            if (val == null) return defaultValue;
            var logAndReturn = function logAndReturn() {
                _this._logLayerParameterExposure(key);
                return val;
            };
            if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
            if (defaultValue == null) return logAndReturn();
            if (typeof val === typeof defaultValue && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
            return defaultValue;
        };
        Layer.prototype.getValue = function(key, defaultValue) {
            if (defaultValue == undefined) defaultValue = null;
            var val = this._value[key];
            if (val != null) this._logLayerParameterExposure(key);
            return val !== null && val !== void 0 ? val : defaultValue;
        };
        Layer.prototype._logLayerParameterExposure = function(parameterName) {
            var _a;
            (_a = this._logParameterFunction) === null || _a === void 0 || _a.call(this, this, parameterName);
        };
        return Layer;
    }();
    Layer$1.default = Layer;
    var StatsigIdentity = {};
    var Constants = {};
    Object.defineProperty(Constants, "__esModule", {
        value: true
    });
    Constants.LOCAL_STORAGE_KEYS = Constants.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY = Constants.STATSIG_STABLE_ID_KEY = Constants.INTERNAL_STORE_KEY = void 0;
    Constants.INTERNAL_STORE_KEY = "STATSIG_STORE";
    Constants.STATSIG_STABLE_ID_KEY = "STATSIG_STABLE_ID";
    Constants.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY = "STATSIG_LOGS";
    Constants.LOCAL_STORAGE_KEYS = {
        INTERNAL_STORE_KEY: true,
        STATSIG_STABLE_ID_KEY: true,
        STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY: true
    };
    var Hashing = {};
    Object.defineProperty(Hashing, "__esModule", {
        value: true
    });
    Hashing.getUserCacheKey = Hashing.getSortedObject = Hashing.djb2HashForObject = Hashing.getHashValue = Hashing.SimpleHash = void 0;
    function SimpleHash(value) {
        var hash = 0;
        for(var i = 0; i < value.length; i++){
            var character = value.charCodeAt(i);
            hash = (hash << 5) - hash + character;
            hash = hash & hash; // Convert to 32bit integer
        }
        return String(hash >>> 0);
    }
    Hashing.SimpleHash = SimpleHash;
    function getHashValue(value, hash_used) {
        if (hash_used === "none") return value;
        return SimpleHash(value);
    }
    Hashing.getHashValue = getHashValue;
    function djb2HashForObject(object) {
        return SimpleHash(JSON.stringify(getSortedObject(object)));
    }
    Hashing.djb2HashForObject = djb2HashForObject;
    function getSortedObject(object) {
        if (object == null) return null;
        var keys = Object.keys(object).sort();
        var sortedObject = {};
        keys.forEach(function(key) {
            var value = object[key];
            if (value instanceof Object) value = getSortedObject(value);
            sortedObject[key] = value;
        });
        return sortedObject;
    }
    Hashing.getSortedObject = getSortedObject;
    function getUserCacheKey(user) {
        var _a;
        var key = "userID:".concat(String((_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ""));
        var customIDs = user === null || user === void 0 ? void 0 : user.customIDs;
        if (customIDs != null) for(var _i = 0, _b = Object.entries(customIDs); _i < _b.length; _i++){
            var _c = _b[_i], type = _c[0], value = _c[1];
            key += ";".concat(type, ":").concat(value);
        }
        return SimpleHash(key);
    }
    Hashing.getUserCacheKey = getUserCacheKey;
    var StatsigLocalStorage$1 = {};
    Object.defineProperty(StatsigLocalStorage$1, "__esModule", {
        value: true
    });
    var StatsigLocalStorage = /** @class */ function() {
        function StatsigLocalStorage() {}
        StatsigLocalStorage.getItem = function(key) {
            var _a;
            try {
                if (this.isStorageAccessible()) return window.localStorage.getItem(key);
            } catch (e) {}
            return (_a = this.fallbackSessionCache[key]) !== null && _a !== void 0 ? _a : null;
        };
        StatsigLocalStorage.setItem = function(key, value) {
            try {
                if (this.isStorageAccessible()) {
                    window.localStorage.setItem(key, value);
                    return;
                }
            } catch (e) {}
            this.fallbackSessionCache[key] = value;
        };
        StatsigLocalStorage.removeItem = function(key) {
            try {
                if (this.isStorageAccessible()) {
                    window.localStorage.removeItem(key);
                    return;
                }
            } catch (e) {}
            delete this.fallbackSessionCache[key];
        };
        StatsigLocalStorage.isStorageAccessible = function(ignoreDisabledOption) {
            if (ignoreDisabledOption === void 0) ignoreDisabledOption = false;
            if (this.canAccessStorageAccessible == null) this.canAccessStorageAccessible = typeof Storage !== "undefined" && typeof window !== "undefined" && window != null && window.localStorage != null;
            var canAccess = this.canAccessStorageAccessible;
            if (ignoreDisabledOption) return canAccess;
            return !this.disabled && canAccess;
        };
        StatsigLocalStorage.disabled = false;
        StatsigLocalStorage.fallbackSessionCache = {};
        StatsigLocalStorage.canAccessStorageAccessible = null;
        return StatsigLocalStorage;
    }();
    StatsigLocalStorage$1.default = StatsigLocalStorage;
    var SDKVersion = {};
    Object.defineProperty(SDKVersion, "__esModule", {
        value: true
    });
    SDKVersion.version = void 0;
    // Generated by genversion.
    SDKVersion.version = "1.3.0";
    var __importDefault$2 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
        return mod && mod.__esModule ? mod : {
            "default": mod
        };
    };
    Object.defineProperty(StatsigIdentity, "__esModule", {
        value: true
    });
    var Constants_1$1 = Constants;
    var Hashing_1$1 = Hashing;
    var StatsigLocalStorage_1$2 = __importDefault$2(StatsigLocalStorage$1);
    var SDKVersion_1 = SDKVersion;
    var Identity = /** @class */ function() {
        function Identity(sdkKey, user, overrideStableID) {
            var _a;
            this._sdkType = "js-lite";
            this._sdkKey = sdkKey;
            this._user = user;
            this._sdkVersion = SDKVersion_1.version;
            var stableID = overrideStableID;
            stableID = (_a = stableID !== null && stableID !== void 0 ? stableID : StatsigLocalStorage_1$2.default.getItem(Constants_1$1.STATSIG_STABLE_ID_KEY)) !== null && _a !== void 0 ? _a : this._getUUID();
            this._statsigMetadata = {
                stableID: stableID,
                sdkType: this._sdkType,
                sdkVersion: this._sdkVersion
            };
        }
        Identity.prototype.saveStableID = function() {
            if (this._statsigMetadata.stableID != null) StatsigLocalStorage_1$2.default.setItem(Constants_1$1.STATSIG_STABLE_ID_KEY, this._statsigMetadata.stableID);
        };
        Identity.prototype.getUserCacheKey = function() {
            return (0, Hashing_1$1.getUserCacheKey)(this._user);
        };
        Identity.prototype._getUUID = function() {
            var uuid = "";
            for(var i = 0; i < 32; i++){
                if (i === 8 || i === 12 || i === 16 || i === 20) uuid += "-";
                var randomDigit = Math.random() * 16 | 0;
                if (i === 12) uuid += "4";
                else if (i === 16) uuid += (randomDigit & 3 | 8).toString(16);
                else uuid += randomDigit.toString(16);
            }
            return uuid;
        };
        return Identity;
    }();
    StatsigIdentity.default = Identity;
    var StatsigLogger$1 = {};
    var LogEvent = {};
    var __assign$2 = commonjsGlobal && commonjsGlobal.__assign || function() {
        __assign$2 = Object.assign || function(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign$2.apply(this, arguments);
    };
    Object.defineProperty(LogEvent, "__esModule", {
        value: true
    });
    function makeLogEvent(eventName, user, statsigMetadata, value, metadata, secondaryExposures) {
        if (value === void 0) value = null;
        if (metadata === void 0) metadata = null;
        var logUser = user;
        if (logUser === null || logUser === void 0 ? void 0 : logUser.privateAttributes) {
            logUser = __assign$2({}, user);
            delete logUser.privateAttributes;
        }
        return {
            time: Date.now(),
            eventName: eventName,
            statsigMetadata: statsigMetadata,
            user: logUser,
            value: value,
            metadata: metadata,
            secondaryExposures: secondaryExposures
        };
    }
    LogEvent.default = makeLogEvent;
    var StatsigNetwork = {};
    (function(exports) {
        var __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || function(thisArg, _arguments, P, generator) {
            function adopt(value) {
                return value instanceof P ? value : new P(function(resolve) {
                    resolve(value);
                });
            }
            return new (P || (P = Promise))(function(resolve, reject) {
                function fulfilled(value) {
                    try {
                        step(generator.next(value));
                    } catch (e) {
                        reject(e);
                    }
                }
                function rejected(value) {
                    try {
                        step(generator["throw"](value));
                    } catch (e) {
                        reject(e);
                    }
                }
                function step(result) {
                    result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                }
                step((generator = generator.apply(thisArg, _arguments || [])).next());
            });
        };
        var __generator = commonjsGlobal && commonjsGlobal.__generator || function(thisArg, body) {
            var _ = {
                label: 0,
                sent: function sent() {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: []
            }, f, y, t, g;
            return g = {
                next: verb(0),
                "throw": verb(1),
                "return": verb(2)
            }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                return this;
            }), g;
            function verb(n) {
                return function(v) {
                    return step([
                        n,
                        v
                    ]);
                };
            }
            function step(op) {
                if (f) throw new TypeError("Generator is already executing.");
                while(g && (g = 0, op[0] && (_ = 0)), _)try {
                    if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                    if (y = 0, t) op = [
                        op[0] & 2,
                        t.value
                    ];
                    switch(op[0]){
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return {
                                value: op[1],
                                done: false
                            };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [
                                0
                            ];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [
                        6,
                        e
                    ];
                    y = 0;
                } finally{
                    f = t = 0;
                }
                if (op[0] & 5) throw op[1];
                return {
                    value: op[0] ? op[1] : void 0,
                    done: true
                };
            }
        };
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.StatsigEndpoint = void 0;
        var StatsigEndpoint;
        (function(StatsigEndpoint) {
            StatsigEndpoint["Initialize"] = "initialize";
            StatsigEndpoint["Rgstr"] = "rgstr";
            StatsigEndpoint["LogEventBeacon"] = "log_event_beacon";
        })(StatsigEndpoint = exports.StatsigEndpoint || (exports.StatsigEndpoint = {}));
        var NO_CONTENT = 204;
        var StatsigNetwork = /** @class */ function() {
            function StatsigNetwork(options, identity, errorBoundary) {
                this.retryCodes = {
                    408: true,
                    500: true,
                    502: true,
                    503: true,
                    504: true,
                    522: true,
                    524: true,
                    599: true
                };
                this.canUseKeepalive = false;
                this._options = options;
                this._identity = identity;
                this._errorBoundary = errorBoundary;
                this.leakyBucket = {};
                this._init();
            }
            StatsigNetwork.prototype.fetchValues = function(user, sinceTime, timeout, previousDerivedFields) {
                var input = {
                    user: user,
                    statsigMetadata: this._identity._statsigMetadata,
                    sinceTime: sinceTime !== null && sinceTime !== void 0 ? sinceTime : undefined,
                    hash: "djb2",
                    previousDerivedFields: previousDerivedFields
                };
                return this._postWithTimeout(StatsigEndpoint.Initialize, input, timeout, // timeout for early returns
                3);
            };
            StatsigNetwork.prototype.sendLogBeacon = function(payload) {
                if (this._options.localMode) return true;
                var url = new URL(this._options.eventLoggingApi + StatsigEndpoint.LogEventBeacon);
                url.searchParams.append("k", this._identity._sdkKey);
                payload.clientTime = Date.now() + "";
                var stringPayload = null;
                try {
                    stringPayload = JSON.stringify(payload);
                } catch (_e) {
                    return false;
                }
                return navigator.sendBeacon(url.toString(), stringPayload);
            };
            StatsigNetwork.prototype.postToEndpoint = function(endpointName, body, retries, backoff, useKeepalive) {
                if (retries === void 0) retries = 0;
                if (backoff === void 0) backoff = 1000;
                if (useKeepalive === void 0) useKeepalive = false;
                return __awaiter(this, void 0, void 0, function() {
                    var api, url, counter, postBody, statsigMetadata, params;
                    var _this = this;
                    return __generator(this, function(_a) {
                        if (this._options.localMode) return [
                            2 /*return*/ ,
                            Promise.reject("no network requests in localMode")
                        ];
                        if (typeof fetch !== "function") // fetch is not defined in this environment, short circuit
                        return [
                            2 /*return*/ ,
                            Promise.reject("fetch is not defined")
                        ];
                        if (typeof window === "undefined" && !this._options.ignoreWindowUndefined) // by default, dont issue requests from the server
                        return [
                            2 /*return*/ ,
                            Promise.reject("window is not defined")
                        ];
                        api = [
                            StatsigEndpoint.Initialize
                        ].includes(endpointName) ? this._options.api : this._options.eventLoggingApi;
                        url = api + endpointName;
                        counter = this.leakyBucket[url];
                        if (counter != null && counter >= 30) return [
                            2 /*return*/ ,
                            Promise.reject(new Error("Request failed because you are making the same request too frequently."))
                        ];
                        if (counter == null) this.leakyBucket[url] = 1;
                        else this.leakyBucket[url] = counter + 1;
                        postBody = JSON.stringify(body);
                        statsigMetadata = this._identity._statsigMetadata;
                        params = {
                            method: "POST",
                            body: postBody,
                            headers: {
                                "Content-type": "application/json; charset=UTF-8",
                                "STATSIG-API-KEY": this._identity._sdkKey,
                                "STATSIG-CLIENT-TIME": Date.now() + "",
                                "STATSIG-SDK-TYPE": statsigMetadata.sdkType,
                                "STATSIG-SDK-VERSION": statsigMetadata.sdkVersion
                            }
                        };
                        if (this.canUseKeepalive && useKeepalive) params.keepalive = true;
                        return [
                            2 /*return*/ ,
                            fetch(url, params).then(function(res) {
                                return __awaiter(_this, void 0, void 0, function() {
                                    var networkResponse, text, errorText;
                                    return __generator(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                if (!res.ok) return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                                networkResponse = res;
                                                if (!(res.status === NO_CONTENT)) return [
                                                    3 /*break*/ ,
                                                    1
                                                ];
                                                networkResponse.data = {
                                                    has_updates: false,
                                                    is_no_content: true
                                                };
                                                return [
                                                    3 /*break*/ ,
                                                    3
                                                ];
                                            case 1:
                                                return [
                                                    4 /*yield*/ ,
                                                    res.text()
                                                ];
                                            case 2:
                                                text = _a.sent();
                                                networkResponse.data = JSON.parse(text);
                                                _a.label = 3;
                                            case 3:
                                                return [
                                                    2 /*return*/ ,
                                                    Promise.resolve(networkResponse)
                                                ];
                                            case 4:
                                                if (!this.retryCodes[res.status]) retries = 0;
                                                return [
                                                    4 /*yield*/ ,
                                                    res.text()
                                                ];
                                            case 5:
                                                errorText = _a.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    Promise.reject(new Error("".concat(res.status, ": ").concat(errorText)))
                                                ];
                                        }
                                    });
                                });
                            }).catch(function(e) {
                                if (retries > 0) return new Promise(function(resolve, reject) {
                                    setTimeout(function() {
                                        _this.leakyBucket[url] = Math.max(_this.leakyBucket[url] - 1, 0);
                                        _this.postToEndpoint(endpointName, body, retries - 1, backoff * 2, useKeepalive).then(resolve).catch(reject);
                                    }, backoff);
                                });
                                return Promise.reject(e);
                            }).finally(function() {
                                _this.leakyBucket[url] = Math.max(_this.leakyBucket[url] - 1, 0);
                            })
                        ];
                    });
                });
            };
            StatsigNetwork.prototype.supportsKeepalive = function() {
                return this.canUseKeepalive;
            };
            StatsigNetwork.prototype._init = function() {
                if (!this._options.disableNetworkKeepalive) try {
                    this.canUseKeepalive = "keepalive" in new Request("");
                } catch (_e) {}
            };
            StatsigNetwork.prototype._postWithTimeout = function(endpointName, body, timeout, retries, backoff) {
                var _this = this;
                if (timeout === void 0) timeout = 0;
                if (retries === void 0) retries = 0;
                if (backoff === void 0) backoff = 1000;
                var hasTimedOut = false;
                var timer = null;
                var cachedReturnValue = null;
                var eventuals = [];
                var eventually = function eventually(boundScope) {
                    return function(fn) {
                        if (hasTimedOut && cachedReturnValue) fn(cachedReturnValue);
                        else eventuals.push(fn);
                        return boundScope;
                    };
                };
                if (timeout != 0) timer = new Promise(function(resolve, reject) {
                    setTimeout(function() {
                        hasTimedOut = true;
                        reject(new Error("The initialization timeout of ".concat(timeout, "ms has been hit before the network request has completed.")));
                    }, timeout);
                });
                var fetchPromise = this.postToEndpoint(endpointName, body, retries, backoff).then(function(res) {
                    if (!res.ok) return Promise.reject(new Error("Request to ".concat(endpointName, " failed with status ").concat(res.status)));
                    if (typeof res.data !== "object") {
                        var error = new Error("Request to ".concat(endpointName, " received invalid response type. Expected 'object' but got '").concat(typeof res.data, "'"));
                        _this._errorBoundary._logError("postWithTimeoutInvalidRes", error, function() {
                            return __awaiter(_this, void 0, void 0, function() {
                                return __generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        this._getErrorData(endpointName, body, retries, backoff, res)
                                    ];
                                });
                            });
                        });
                        return Promise.reject(error);
                    }
                    var json = res.data;
                    return _this._errorBoundary._capture("postWithTimeout", function() {
                        return __awaiter(_this, void 0, void 0, function() {
                            return __generator(this, function(_a) {
                                cachedReturnValue = json;
                                if (hasTimedOut) {
                                    eventuals.forEach(function(fn) {
                                        return fn(json);
                                    });
                                    eventuals = [];
                                }
                                return [
                                    2 /*return*/ ,
                                    Promise.resolve(json)
                                ];
                            });
                        });
                    }, function() {
                        return Promise.resolve({});
                    }, function() {
                        return __awaiter(_this, void 0, void 0, function() {
                            return __generator(this, function(_a) {
                                return [
                                    2 /*return*/ ,
                                    this._getErrorData(endpointName, body, retries, backoff, res)
                                ];
                            });
                        });
                    });
                }).catch(function(e) {
                    return Promise.reject(e);
                });
                var racingPromise = timer ? Promise.race([
                    fetchPromise,
                    timer
                ]) : fetchPromise;
                racingPromise.eventually = eventually(racingPromise);
                return racingPromise;
            };
            StatsigNetwork.prototype._getErrorData = function(endpointName, body, retries, backoff, res) {
                var _a;
                return __awaiter(this, void 0, void 0, function() {
                    var headers_1;
                    return __generator(this, function(_b) {
                        try {
                            headers_1 = {};
                            ((_a = res.headers) !== null && _a !== void 0 ? _a : []).forEach(function(value, key) {
                                headers_1[key] = value;
                            });
                            return [
                                2 /*return*/ ,
                                {
                                    responseInfo: {
                                        headers: headers_1,
                                        status: res.status,
                                        statusText: res.statusText,
                                        type: res.type,
                                        url: res.url,
                                        redirected: res.redirected,
                                        bodySnippet: res.data ? JSON.stringify(res.data).slice(0, 500) : null
                                    },
                                    requestInfo: {
                                        endpointName: endpointName,
                                        bodySnippet: JSON.stringify(body).slice(0, 500),
                                        retries: retries,
                                        backoff: backoff
                                    }
                                }
                            ];
                        } catch (_e) {
                            return [
                                2 /*return*/ ,
                                {
                                    statusText: "statsig::failed to extract extra data"
                                }
                            ];
                        }
                        return [
                            2 /*return*/ 
                        ];
                    });
                });
            };
            return StatsigNetwork;
        }();
        exports.default = StatsigNetwork;
    })(StatsigNetwork);
    var __awaiter$1 = commonjsGlobal && commonjsGlobal.__awaiter || function(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
    var __generator$1 = commonjsGlobal && commonjsGlobal.__generator || function(thisArg, body) {
        var _ = {
            label: 0,
            sent: function sent() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(g && (g = 0, op[0] && (_ = 0)), _)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    };
    var __importDefault$1 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
        return mod && mod.__esModule ? mod : {
            "default": mod
        };
    };
    Object.defineProperty(StatsigLogger$1, "__esModule", {
        value: true
    });
    var LogEvent_1$1 = __importDefault$1(LogEvent);
    var StatsigNetwork_1$1 = StatsigNetwork;
    var Constants_1 = Constants;
    var StatsigLocalStorage_1$1 = __importDefault$1(StatsigLocalStorage$1);
    var INTERNAL_EVENT_PREFIX = "statsig::";
    var CONFIG_EXPOSURE_EVENT = INTERNAL_EVENT_PREFIX + "config_exposure";
    var LAYER_EXPOSURE_EVENT = INTERNAL_EVENT_PREFIX + "layer_exposure";
    var GATE_EXPOSURE_EVENT = INTERNAL_EVENT_PREFIX + "gate_exposure";
    var LOG_FAILURE_EVENT = INTERNAL_EVENT_PREFIX + "log_event_failed";
    var DEFAULT_VALUE_WARNING = INTERNAL_EVENT_PREFIX + "default_value_type_mismatch";
    var MS_RETRY_LOGS_CUTOFF = 432000000;
    var MAX_BATCHES_TO_RETRY = 100;
    var MAX_FAILED_EVENTS = 1000;
    var MAX_LOCAL_STORAGE_SIZE = 1024 * MAX_FAILED_EVENTS;
    var StatsigLogger = /** @class */ function() {
        function StatsigLogger(options, identity, network, errorBoundary) {
            var _this = this;
            this._failedLogEventCount = 0;
            this.logConfigDefaultValueFallback = function(user, message, metadata) {
                var defaultValueEvent = (0, LogEvent_1$1.default)(DEFAULT_VALUE_WARNING, user, _this._identity._statsigMetadata, message, metadata);
                _this.log(defaultValueEvent);
                _this._loggedErrors.add(message);
            };
            this._options = options;
            this._identity = identity;
            this._network = network;
            this._errorBoundary = errorBoundary;
            this._queue = [];
            this._flushInterval = null;
            this._loggedErrors = new Set();
            this._failedLogEvents = [];
            this._exposureDedupeKeys = {};
            this._failedLogEventCount = 0;
            this._init();
        }
        StatsigLogger.prototype.log = function(event) {
            if (this._options.disableAllLogging) return;
            try {
                if (!this._options.disableCurrentPageLogging && typeof window !== "undefined" && window != null && typeof window.location === "object" && typeof window.location.href === "string") {
                    // https://stackoverflow.com/questions/6257463/how-to-get-the-url-without-any-parameters-in-javascript
                    var parts = window.location.href.split(/[?#]/);
                    if ((parts === null || parts === void 0 ? void 0 : parts.length) > 0) event.statsigMetadata.currentPage = parts[0];
                }
            } catch (_e) {}
            this._queue.push(event);
            if (this._queue.length >= this._options.loggingBufferMaxSize) this.flush();
        };
        StatsigLogger.prototype.resetDedupeKeys = function() {
            this._exposureDedupeKeys = {};
        };
        StatsigLogger.prototype.logGateExposure = function(user, gateName, gateValue, ruleID, secondaryExposures, details, isManualExposure) {
            var dedupeKey = gateName + String(gateValue) + ruleID + details.reason;
            if (!this._shouldLogExposure(dedupeKey)) return;
            var metadata = {
                gate: gateName,
                gateValue: String(gateValue),
                ruleID: ruleID,
                reason: details.reason,
                time: details.time
            };
            if (isManualExposure) metadata["isManualExposure"] = "true";
            var gateExposure = (0, LogEvent_1$1.default)(GATE_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
            this.log(gateExposure);
        };
        StatsigLogger.prototype.logConfigExposure = function(user, configName, ruleID, secondaryExposures, details, isManualExposure) {
            var dedupeKey = configName + ruleID + details.reason;
            if (!this._shouldLogExposure(dedupeKey)) return;
            var metadata = {
                config: configName,
                ruleID: ruleID,
                reason: details.reason,
                time: details.time
            };
            if (isManualExposure) metadata["isManualExposure"] = "true";
            var configExposure = (0, LogEvent_1$1.default)(CONFIG_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
            this.log(configExposure);
        };
        StatsigLogger.prototype.logLayerExposure = function(user, configName, ruleID, secondaryExposures, allocatedExperiment, parameterName, isExplicitParameter, details, isManualExposure) {
            var dedupeKey = [
                configName,
                ruleID,
                allocatedExperiment,
                parameterName,
                String(isExplicitParameter),
                details.reason
            ].join("|");
            if (!this._shouldLogExposure(dedupeKey)) return;
            var metadata = {
                config: configName,
                ruleID: ruleID,
                allocatedExperiment: allocatedExperiment,
                parameterName: parameterName,
                isExplicitParameter: String(isExplicitParameter),
                reason: details.reason,
                time: details.time
            };
            if (isManualExposure) metadata["isManualExposure"] = "true";
            var configExposure = (0, LogEvent_1$1.default)(LAYER_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
            this.log(configExposure);
        };
        StatsigLogger.prototype.shutdown = function() {
            if (this._flushInterval) {
                clearInterval(this._flushInterval);
                this._flushInterval = null;
            }
            this.flush(true);
        };
        StatsigLogger.prototype.flush = function(isClosing) {
            var _this = this;
            if (isClosing === void 0) isClosing = false;
            if (this._queue.length === 0) return;
            var statsigMetadata = this._identity._statsigMetadata;
            var oldQueue = this._queue;
            this._queue = [];
            if (isClosing && !this._network.supportsKeepalive() && typeof navigator !== "undefined" && navigator != null && // @ts-ignore
            navigator.sendBeacon) {
                var beacon = this._network.sendLogBeacon({
                    events: oldQueue,
                    statsigMetadata: statsigMetadata
                });
                if (!beacon) {
                    this._queue = oldQueue.concat(this._queue);
                    if (this._queue.length > 0) {
                        this._addFailedRequest({
                            events: this._queue,
                            statsigMetadata: statsigMetadata,
                            time: Date.now()
                        });
                        this._queue = [];
                    }
                    this._saveFailedRequests();
                }
                return;
            }
            var processor = this;
            this._network.postToEndpoint(StatsigNetwork_1$1.StatsigEndpoint.Rgstr, {
                events: oldQueue,
                statsigMetadata: statsigMetadata
            }, 3 /* retries */ , 1000 /* backoff */ , isClosing /* useKeepalive */ ).then(function(response) {
                if (!response.ok) throw response;
            }).catch(function(error) {
                if (typeof error.text === "function") error.text().then(function(errorText) {
                    _this._errorBoundary._logError(LOG_FAILURE_EVENT, error, function() {
                        return __awaiter$1(_this, void 0, void 0, function() {
                            return __generator$1(this, function(_a) {
                                return [
                                    2 /*return*/ ,
                                    {
                                        eventCount: oldQueue.length,
                                        error: errorText
                                    }
                                ];
                            });
                        });
                    });
                });
                else _this._errorBoundary._logError(LOG_FAILURE_EVENT, error, function() {
                    return __awaiter$1(_this, void 0, void 0, function() {
                        return __generator$1(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                {
                                    eventCount: oldQueue.length,
                                    error: error.message
                                }
                            ];
                        });
                    });
                });
                processor._newFailedRequest(LOG_FAILURE_EVENT, oldQueue);
            }).finally(function() {
                return __awaiter$1(_this, void 0, void 0, function() {
                    return __generator$1(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!isClosing) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                if (this._queue.length > 0) {
                                    this._addFailedRequest({
                                        events: this._queue,
                                        statsigMetadata: statsigMetadata,
                                        time: Date.now()
                                    });
                                    // on app background/window blur, save unsent events as a request and clean up the queue (in case app foregrounds)
                                    this._queue = [];
                                }
                                return [
                                    4 /*yield*/ ,
                                    processor._saveFailedRequests()
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            });
        };
        StatsigLogger.prototype.sendSavedRequests = function() {
            return __awaiter$1(this, void 0, void 0, function() {
                var failedRequests, fireAndForget, requestBodies, _loop_1, this_1, _i, requestBodies_1, requestBody;
                var _this = this;
                return __generator$1(this, function(_a) {
                    fireAndForget = false;
                    failedRequests = StatsigLocalStorage_1$1.default.getItem(Constants_1.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY);
                    if (failedRequests == null) {
                        this._clearLocalStorageRequests();
                        return [
                            2 /*return*/ 
                        ];
                    }
                    if (failedRequests.length > MAX_LOCAL_STORAGE_SIZE) fireAndForget = true;
                    requestBodies = [];
                    try {
                        requestBodies = JSON.parse(failedRequests);
                        _loop_1 = function _loop_1(requestBody) {
                            if (requestBody != null && requestBody.events && Array.isArray(requestBody.events)) this_1._network.postToEndpoint(StatsigNetwork_1$1.StatsigEndpoint.Rgstr, requestBody).then(function(response) {
                                if (!response.ok) throw Error(response.status + "");
                            }).catch(function(_e) {
                                if (fireAndForget) return;
                                _this._addFailedRequest(requestBody);
                            });
                        };
                        this_1 = this;
                        for(_i = 0, requestBodies_1 = requestBodies; _i < requestBodies_1.length; _i++){
                            requestBody = requestBodies_1[_i];
                            _loop_1(requestBody);
                        }
                    } catch (_e) {} finally{
                        this._clearLocalStorageRequests();
                    }
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        StatsigLogger.prototype._init = function() {
            var _this = this;
            if (typeof window !== "undefined" && typeof window.addEventListener === "function") {
                window.addEventListener("blur", function() {
                    return _this.flush(true);
                });
                window.addEventListener("beforeunload", function() {
                    return _this.flush(true);
                });
                window.addEventListener("load", function() {
                    setTimeout(function() {
                        return _this.flush();
                    }, 100);
                    setTimeout(function() {
                        return _this.flush();
                    }, 1000);
                });
            }
            if (typeof document !== "undefined" && typeof document.addEventListener === "function") document.addEventListener("visibilitychange", function() {
                _this.flush(document.visibilityState !== "visible");
            });
            if (!this._options.ignoreWindowUndefined && (typeof window === "undefined" || window == null)) // dont set the flush interval outside of client browser environments
            return;
            if (this._options.localMode) // unnecessary interval in local mode since logs dont flush anyway
            return;
            var me = this;
            this._flushInterval = setInterval(function() {
                me.flush();
            }, this._options.loggingIntervalMillis);
            // Quick flush
            setTimeout(function() {
                return _this.flush();
            }, 100);
            setTimeout(function() {
                return _this.flush();
            }, 1000);
        };
        StatsigLogger.prototype._shouldLogExposure = function(key) {
            var lastTime = this._exposureDedupeKeys[key];
            var now = Date.now();
            if (lastTime == null) {
                this._exposureDedupeKeys[key] = now;
                return true;
            }
            if (lastTime >= now - 600000) return false;
            this._exposureDedupeKeys[key] = now;
            return true;
        };
        StatsigLogger.prototype._saveFailedRequests = function() {
            return __awaiter$1(this, void 0, void 0, function() {
                var requestsCopy;
                return __generator$1(this, function(_a) {
                    if (this._failedLogEvents.length > 0) {
                        requestsCopy = JSON.stringify(this._failedLogEvents);
                        if (requestsCopy.length > MAX_LOCAL_STORAGE_SIZE) {
                            this._clearLocalStorageRequests();
                            return [
                                2 /*return*/ 
                            ];
                        }
                        StatsigLocalStorage_1$1.default.setItem(Constants_1.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY, requestsCopy);
                    }
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        StatsigLogger.prototype._addFailedRequest = function(requestBody) {
            if (requestBody.time < Date.now() - MS_RETRY_LOGS_CUTOFF) return;
            if (this._failedLogEvents.length > MAX_BATCHES_TO_RETRY) return;
            var additionalEvents = requestBody.events.length;
            if (this._failedLogEventCount + additionalEvents > MAX_FAILED_EVENTS) return;
            this._failedLogEvents.push(requestBody);
            this._failedLogEventCount += additionalEvents;
        };
        StatsigLogger.prototype._clearLocalStorageRequests = function() {
            StatsigLocalStorage_1$1.default.removeItem(Constants_1.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY);
        };
        StatsigLogger.prototype._newFailedRequest = function(name, queue) {
            if (this._loggedErrors.has(name)) return;
            this._loggedErrors.add(name);
            this._failedLogEvents.push({
                events: queue,
                statsigMetadata: this._identity._statsigMetadata,
                time: Date.now()
            });
            this._saveFailedRequests().then(function() {});
        };
        return StatsigLogger;
    }();
    StatsigLogger$1.default = StatsigLogger;
    var StatsigSDKOptions = {};
    (function(exports) {
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.INIT_TIMEOUT_DEFAULT_MS = void 0;
        var DEFAULT_FEATURE_GATE_API = "https://featuregates.org/v1/";
        var DEFAULT_EVENT_LOGGING_API = "https://events.statsigapi.net/v1/";
        exports.INIT_TIMEOUT_DEFAULT_MS = 3000;
        var StatsigSDKOptions = /** @class */ function() {
            function StatsigSDKOptions(options) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
                if (options == null) options = {};
                var api = (_a = options.api) !== null && _a !== void 0 ? _a : DEFAULT_FEATURE_GATE_API;
                this.api = api.endsWith("/") ? api : api + "/";
                this.disableCurrentPageLogging = (_b = options.disableCurrentPageLogging) !== null && _b !== void 0 ? _b : false;
                this.environment = (_c = options.environment) !== null && _c !== void 0 ? _c : null;
                this.loggingIntervalMillis = this.normalizeNumberInput(options.loggingIntervalMillis, {
                    default: 10000,
                    min: 1000,
                    max: 60000
                });
                this.loggingBufferMaxSize = this.normalizeNumberInput(options.loggingBufferMaxSize, {
                    default: 100,
                    min: 2,
                    max: 500
                });
                this.disableNetworkKeepalive = (_d = options.disableNetworkKeepalive) !== null && _d !== void 0 ? _d : false;
                this.overrideStableID = (_e = options.overrideStableID) !== null && _e !== void 0 ? _e : null;
                this.localMode = (_f = options.localMode) !== null && _f !== void 0 ? _f : false;
                this.initTimeoutMs = options.initTimeoutMs && options.initTimeoutMs >= 0 ? options.initTimeoutMs : exports.INIT_TIMEOUT_DEFAULT_MS;
                this.disableErrorLogging = (_g = options.disableErrorLogging) !== null && _g !== void 0 ? _g : false;
                this.disableAutoMetricsLogging = (_h = options.disableAutoMetricsLogging) !== null && _h !== void 0 ? _h : false;
                this.initializeValues = (_j = options.initializeValues) !== null && _j !== void 0 ? _j : null;
                var eventLoggingApi = (_l = (_k = options.eventLoggingApi) !== null && _k !== void 0 ? _k : options.api) !== null && _l !== void 0 ? _l : DEFAULT_EVENT_LOGGING_API;
                this.eventLoggingApi = eventLoggingApi.endsWith("/") ? eventLoggingApi : eventLoggingApi + "/";
                this.disableLocalStorage = (_m = options.disableLocalStorage) !== null && _m !== void 0 ? _m : false;
                this.ignoreWindowUndefined = (_o = options === null || options === void 0 ? void 0 : options.ignoreWindowUndefined) !== null && _o !== void 0 ? _o : false;
                this.updateUserCompletionCallback = (_p = options === null || options === void 0 ? void 0 : options.updateUserCompletionCallback) !== null && _p !== void 0 ? _p : null;
                this.disableAllLogging = (_q = options === null || options === void 0 ? void 0 : options.disableAllLogging) !== null && _q !== void 0 ? _q : false;
            }
            StatsigSDKOptions.prototype.normalizeNumberInput = function(input, bounds) {
                if (input == null) return bounds.default;
                return Math.max(Math.min(input, bounds.max), bounds.min);
            };
            return StatsigSDKOptions;
        }();
        exports.default = StatsigSDKOptions;
    })(StatsigSDKOptions);
    var StatsigStore = {};
    var BootstrapValidator$1 = {};
    var __assign$1 = commonjsGlobal && commonjsGlobal.__assign || function() {
        __assign$1 = Object.assign || function(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign$1.apply(this, arguments);
    };
    Object.defineProperty(BootstrapValidator$1, "__esModule", {
        value: true
    });
    var BootstrapValidator = /** @class */ function() {
        function BootstrapValidator() {}
        BootstrapValidator.isValid = function(user, values) {
            try {
                var evaluatedKeys = values["evaluated_keys"];
                if (!evaluatedKeys || typeof evaluatedKeys !== "object") return true;
                var evaluatedKeysRecord = this.copyObject(evaluatedKeys);
                var userToCompare = user == null ? null : this.copyObject(user);
                return BootstrapValidator.validate(evaluatedKeysRecord, userToCompare) && BootstrapValidator.validate(userToCompare, evaluatedKeysRecord);
            } catch (error) {
            // This is best-effort. If we fail, return true.
            }
            return true;
        };
        BootstrapValidator.validate = function(one, two) {
            if (one == null) return two == null;
            else if (two == null) return false;
            for(var _i = 0, _a = Object.entries(one); _i < _a.length; _i++){
                var _b = _a[_i], key = _b[0], value = _b[1];
                if (key === "stableID") continue;
                if (typeof value !== typeof two[key]) return false;
                if (typeof value === "string") {
                    if (value !== two[key]) return false;
                } else if (typeof value === "object") return this.validate(value, two[key]);
                else // unexpected
                return false;
            }
            return true;
        };
        BootstrapValidator.copyObject = function(obj) {
            if (obj == null) return null;
            var copy = {};
            if (obj === null || obj === void 0 ? void 0 : obj.userID) copy["userID"] = obj === null || obj === void 0 ? void 0 : obj.userID;
            if (obj === null || obj === void 0 ? void 0 : obj.customIDs) {
                var customIDs = __assign$1({}, obj.customIDs);
                delete customIDs["stableID"];
                if (Object.keys(customIDs).length !== 0) copy["customIDs"] = customIDs;
            }
            return copy;
        };
        return BootstrapValidator;
    }();
    BootstrapValidator$1.default = BootstrapValidator;
    (function(exports) {
        var __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || function(thisArg, _arguments, P, generator) {
            function adopt(value) {
                return value instanceof P ? value : new P(function(resolve) {
                    resolve(value);
                });
            }
            return new (P || (P = Promise))(function(resolve, reject) {
                function fulfilled(value) {
                    try {
                        step(generator.next(value));
                    } catch (e) {
                        reject(e);
                    }
                }
                function rejected(value) {
                    try {
                        step(generator["throw"](value));
                    } catch (e) {
                        reject(e);
                    }
                }
                function step(result) {
                    result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                }
                step((generator = generator.apply(thisArg, _arguments || [])).next());
            });
        };
        var __generator = commonjsGlobal && commonjsGlobal.__generator || function(thisArg, body) {
            var _ = {
                label: 0,
                sent: function sent() {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: []
            }, f, y, t, g;
            return g = {
                next: verb(0),
                "throw": verb(1),
                "return": verb(2)
            }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                return this;
            }), g;
            function verb(n) {
                return function(v) {
                    return step([
                        n,
                        v
                    ]);
                };
            }
            function step(op) {
                if (f) throw new TypeError("Generator is already executing.");
                while(g && (g = 0, op[0] && (_ = 0)), _)try {
                    if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                    if (y = 0, t) op = [
                        op[0] & 2,
                        t.value
                    ];
                    switch(op[0]){
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return {
                                value: op[1],
                                done: false
                            };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [
                                0
                            ];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [
                        6,
                        e
                    ];
                    y = 0;
                } finally{
                    f = t = 0;
                }
                if (op[0] & 5) throw op[1];
                return {
                    value: op[0] ? op[1] : void 0,
                    done: true
                };
            }
        };
        var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
            return mod && mod.__esModule ? mod : {
                "default": mod
            };
        };
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.EvaluationReason = void 0;
        var DynamicConfig_1 = __importDefault(DynamicConfig$1);
        var Layer_1 = __importDefault(Layer$1);
        var BootstrapValidator_1 = __importDefault(BootstrapValidator$1);
        var Constants_1 = Constants;
        var Hashing_1 = Hashing;
        var StatsigLocalStorage_1 = __importDefault(StatsigLocalStorage$1);
        var EvaluationReason;
        (function(EvaluationReason) {
            EvaluationReason["Network"] = "Network";
            EvaluationReason["Bootstrap"] = "Bootstrap";
            EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
            EvaluationReason["Cache"] = "Cache";
            EvaluationReason["Unrecognized"] = "Unrecognized";
            EvaluationReason["Uninitialized"] = "Uninitialized";
            EvaluationReason["Error"] = "Error";
            EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
            EvaluationReason["LocalOverride"] = "LocalOverride";
        })(EvaluationReason = exports.EvaluationReason || (exports.EvaluationReason = {}));
        var MAX_USER_VALUE_CACHED = 10;
        var StatsigStore = /** @class */ function() {
            function StatsigStore(identity, onDefaultValueFallback, initializeValues) {
                this._identity = identity;
                this._onDefaultValueFallback = onDefaultValueFallback;
                this._userCacheKey = this._identity.getUserCacheKey();
                this._values = {};
                this._userValues = this._getDefaultUserCacheValues();
                this._loaded = false;
                this._reason = EvaluationReason.Uninitialized;
                if (initializeValues) this.bootstrap(initializeValues);
                else this._loadFromLocalStorage();
            }
            StatsigStore.prototype.updateUser = function() {
                this._userCacheKey = this._identity.getUserCacheKey();
                return this._setUserValueFromCache();
            };
            StatsigStore.prototype.bootstrap = function(initializeValues) {
                var _a, _b, _c;
                var key = this._identity.getUserCacheKey();
                var user = this._identity._user;
                var reason = BootstrapValidator_1.default.isValid(user, initializeValues) ? EvaluationReason.Bootstrap : EvaluationReason.InvalidBootstrap;
                // clients are going to assume that the SDK is bootstrapped after this method runs
                // if we fail to parse, we will fall back to defaults, but we dont want to throw
                // when clients try to check gates/configs/etc after this point
                this._loaded = true;
                try {
                    this._userValues.feature_gates = (_a = initializeValues.feature_gates) !== null && _a !== void 0 ? _a : {};
                    this._userValues.dynamic_configs = (_b = initializeValues.dynamic_configs) !== null && _b !== void 0 ? _b : {};
                    this._userValues.layer_configs = (_c = initializeValues.layer_configs) !== null && _c !== void 0 ? _c : {};
                    this._userValues.evaluation_time = Date.now();
                    this._userValues.time = Date.now();
                    this._values[key] = this._userValues;
                    this._reason = reason;
                } catch (_e) {
                    return;
                }
            };
            StatsigStore.prototype.isLoaded = function() {
                return this._loaded;
            };
            StatsigStore.prototype.getLastUpdateTime = function(user) {
                var userHash = (0, Hashing_1.djb2HashForObject)(user);
                if (this._userValues.user_hash == userHash) return this._userValues.time;
                return null;
            };
            StatsigStore.prototype.getPreviousDerivedFields = function(user) {
                var userHash = (0, Hashing_1.djb2HashForObject)(user);
                if (this._userValues.user_hash == userHash) return this._userValues.derived_fields;
                return undefined;
            };
            StatsigStore.prototype.setEvaluationReason = function(evalReason) {
                this._reason = evalReason;
            };
            StatsigStore.prototype.save = function(user, jsonConfigs, updateState) {
                if (updateState === void 0) updateState = true;
                return __awaiter(this, void 0, void 0, function() {
                    var requestedUserCacheKey, initResponse, userValues, _a;
                    return __generator(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                requestedUserCacheKey = (0, Hashing_1.getUserCacheKey)(user);
                                initResponse = jsonConfigs;
                                this._mergeInitializeResponseIntoUserMap(initResponse, this._values, requestedUserCacheKey, user, function(userValues) {
                                    return userValues;
                                });
                                if (updateState) {
                                    userValues = this._values[requestedUserCacheKey];
                                    if (userValues && requestedUserCacheKey && requestedUserCacheKey == this._userCacheKey) {
                                        this._userValues = userValues;
                                        this._reason = EvaluationReason.Network;
                                    }
                                }
                                _a = this;
                                return [
                                    4 /*yield*/ ,
                                    this._writeValuesToStorage(this._values)
                                ];
                            case 1:
                                _a._values = _b.sent();
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            };
            StatsigStore.prototype.checkGate = function(gateName) {
                var _a;
                var gateNameHash = (0, Hashing_1.getHashValue)(gateName, this._userValues.hash_used);
                var gateValue = {
                    name: gateName,
                    value: false,
                    rule_id: "",
                    secondary_exposures: []
                };
                var details;
                var value = (_a = this._userValues) === null || _a === void 0 ? void 0 : _a.feature_gates[gateNameHash];
                if (value) gateValue = value;
                details = this._getEvaluationDetails(value != null);
                return {
                    evaluationDetails: details,
                    gate: gateValue
                };
            };
            StatsigStore.prototype.getConfig = function(configName) {
                var _a, _b;
                var configNameHash = (0, Hashing_1.getHashValue)(configName, this._userValues.hash_used);
                var configValue;
                var details;
                if (((_a = this._userValues) === null || _a === void 0 ? void 0 : _a.dynamic_configs[configNameHash]) != null) {
                    var rawConfigValue = (_b = this._userValues) === null || _b === void 0 ? void 0 : _b.dynamic_configs[configNameHash];
                    details = this._getEvaluationDetails(true);
                    configValue = this._createDynamicConfig(configName, rawConfigValue, details);
                } else {
                    details = this._getEvaluationDetails(false);
                    configValue = new DynamicConfig_1.default(configName, {}, "", details);
                }
                return configValue;
            };
            StatsigStore.prototype.getLayer = function(logParameterFunction, layerName) {
                var _a, _b, _c;
                var latestValue = this._getLatestValue(layerName, "layer_configs");
                var details = this._getEvaluationDetails(latestValue != null);
                return Layer_1.default._create(layerName, (_a = latestValue === null || latestValue === void 0 ? void 0 : latestValue.value) !== null && _a !== void 0 ? _a : {}, (_b = latestValue === null || latestValue === void 0 ? void 0 : latestValue.rule_id) !== null && _b !== void 0 ? _b : "", details, logParameterFunction, latestValue === null || latestValue === void 0 ? void 0 : latestValue.secondary_exposures, latestValue === null || latestValue === void 0 ? void 0 : latestValue.undelegated_secondary_exposures, (_c = latestValue === null || latestValue === void 0 ? void 0 : latestValue.allocated_experiment_name) !== null && _c !== void 0 ? _c : "", latestValue === null || latestValue === void 0 ? void 0 : latestValue.explicit_parameters);
            };
            StatsigStore.prototype.getGlobalEvaluationDetails = function() {
                var _a, _b;
                return {
                    reason: (_a = this._reason) !== null && _a !== void 0 ? _a : EvaluationReason.Uninitialized,
                    time: (_b = this._userValues.evaluation_time) !== null && _b !== void 0 ? _b : 0
                };
            };
            StatsigStore.prototype._loadFromLocalStorage = function() {
                this._parseCachedValues(StatsigLocalStorage_1.default.getItem(Constants_1.INTERNAL_STORE_KEY));
                this._loaded = true;
            };
            StatsigStore.prototype._parseCachedValues = function(allValues) {
                try {
                    this._values = allValues ? JSON.parse(allValues) : this._values;
                    this._setUserValueFromCache();
                } catch (e) {
                    // Cached value corrupted, remove cache
                    this._removeFromStorage(Constants_1.INTERNAL_STORE_KEY);
                }
            };
            StatsigStore.prototype._setUserValueFromCache = function() {
                var _a;
                var cachedValues = this._values[this._userCacheKey];
                if (cachedValues == null) {
                    this._resetUserValues();
                    this._reason = EvaluationReason.Uninitialized;
                    return null;
                }
                this._userValues = cachedValues;
                this._reason = EvaluationReason.Cache;
                return (_a = cachedValues.evaluation_time) !== null && _a !== void 0 ? _a : 0;
            };
            StatsigStore.prototype._removeFromStorage = function(key) {
                StatsigLocalStorage_1.default.removeItem(key);
            };
            /**
     * Merges the provided init configs into the provided config map, according to the provided merge function
     */ StatsigStore.prototype._mergeInitializeResponseIntoUserMap = function(data, configMap, requestedUserCacheKey, user, mergeFn) {
                if (requestedUserCacheKey) {
                    var requestedUserValues = this._convertAPIDataToCacheValues(data, requestedUserCacheKey);
                    if (data.has_updates && data.time) {
                        var userHash = (0, Hashing_1.djb2HashForObject)(user);
                        requestedUserValues.user_hash = userHash;
                    }
                    configMap[requestedUserCacheKey] = mergeFn(requestedUserValues, requestedUserCacheKey);
                }
            };
            StatsigStore.prototype._getDefaultUserCacheValues = function() {
                return {
                    feature_gates: {},
                    layer_configs: {},
                    dynamic_configs: {},
                    time: 0,
                    evaluation_time: 0,
                    has_updates: false
                };
            };
            /**
     * Writes the provided values to storage, truncating down to
     * MAX_USER_VALUE_CACHED number entries.
     * @returns The truncated entry list
     */ StatsigStore.prototype._writeValuesToStorage = function(valuesToWrite) {
                return __awaiter(this, void 0, void 0, function() {
                    var filteredValues;
                    return __generator(this, function(_a) {
                        filteredValues = Object.entries(valuesToWrite).sort(function(_a, _b) {
                            var _c, _d;
                            var a = _a[1];
                            var b = _b[1];
                            if (a == null) return 1;
                            if (b == null) return -1;
                            return ((_c = b === null || b === void 0 ? void 0 : b.evaluation_time) !== null && _c !== void 0 ? _c : b === null || b === void 0 ? void 0 : b.time) - ((_d = a === null || a === void 0 ? void 0 : a.evaluation_time) !== null && _d !== void 0 ? _d : a === null || a === void 0 ? void 0 : a.time);
                        }).slice(0, MAX_USER_VALUE_CACHED);
                        valuesToWrite = Object.fromEntries(filteredValues);
                        StatsigLocalStorage_1.default.setItem(Constants_1.INTERNAL_STORE_KEY, JSON.stringify(valuesToWrite));
                        return [
                            2 /*return*/ ,
                            valuesToWrite
                        ];
                    });
                });
            };
            StatsigStore.prototype._getLatestValue = function(name, topLevelKey) {
                var _a, _b, _c, _d, _f;
                var hash = (0, Hashing_1.getHashValue)(name, this._userValues.hash_used);
                return (_c = (_b = (_a = this._userValues) === null || _a === void 0 ? void 0 : _a[topLevelKey]) === null || _b === void 0 ? void 0 : _b[hash]) !== null && _c !== void 0 ? _c : (_f = (_d = this._userValues) === null || _d === void 0 ? void 0 : _d[topLevelKey]) === null || _f === void 0 ? void 0 : _f[name];
            };
            StatsigStore.prototype._createDynamicConfig = function(name, apiConfig, details) {
                var _a, _b, _c;
                return new DynamicConfig_1.default(name, (_a = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.value) !== null && _a !== void 0 ? _a : {}, (_b = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.rule_id) !== null && _b !== void 0 ? _b : "", details, apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.secondary_exposures, (_c = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.allocated_experiment_name) !== null && _c !== void 0 ? _c : "", this._makeOnConfigDefaultValueFallback(this._identity._user));
            };
            StatsigStore.prototype._getEvaluationDetails = function(valueExists, reasonOverride) {
                var _a;
                if (valueExists) return {
                    reason: this._reason,
                    time: (_a = this._userValues.evaluation_time) !== null && _a !== void 0 ? _a : Date.now()
                };
                else return {
                    reason: reasonOverride !== null && reasonOverride !== void 0 ? reasonOverride : this._reason == EvaluationReason.Uninitialized ? EvaluationReason.Uninitialized : EvaluationReason.Unrecognized,
                    time: Date.now()
                };
            };
            StatsigStore.prototype._resetUserValues = function() {
                this._userValues = this._getDefaultUserCacheValues();
            };
            StatsigStore.prototype._convertAPIDataToCacheValues = function(data, cacheKey) {
                // Specifically pulling keys from data here to avoid pulling in unwanted keys
                return {
                    feature_gates: data.feature_gates,
                    layer_configs: data.layer_configs,
                    dynamic_configs: data.dynamic_configs,
                    time: data.time == null || isNaN(data.time) ? 0 : data.time,
                    evaluation_time: Date.now(),
                    derived_fields: data.derived_fields,
                    hash_used: data.hash_used
                };
            };
            StatsigStore.prototype._makeOnConfigDefaultValueFallback = function(user) {
                var _this = this;
                return function(config, parameter, defaultValueType, valueType) {
                    if (!_this.isLoaded()) return;
                    _this._onDefaultValueFallback(user, "Parameter ".concat(parameter, " is a value of type ").concat(valueType, ".\n          Returning requested defaultValue type ").concat(defaultValueType), {
                        name: config._name,
                        ruleID: config._ruleID,
                        parameter: parameter,
                        defaultValueType: defaultValueType,
                        valueType: valueType
                    });
                };
            };
            return StatsigStore;
        }();
        exports.default = StatsigStore;
    })(StatsigStore);
    var ResponseVerification = {};
    Object.defineProperty(ResponseVerification, "__esModule", {
        value: true
    });
    ResponseVerification.verifySDKKeyUsed = void 0;
    var Errors_1$1 = Errors;
    var Hashing_1 = Hashing;
    function verifySDKKeyUsed(json, sdkKey, errorBoundary) {
        var hashedSDKKeyUsed = json === null || json === void 0 ? void 0 : json.hashed_sdk_key_used;
        if (hashedSDKKeyUsed != null && hashedSDKKeyUsed !== (0, Hashing_1.SimpleHash)(sdkKey !== null && sdkKey !== void 0 ? sdkKey : "")) {
            errorBoundary._logError("fetchAndSaveValues", new Errors_1$1.StatsigSDKKeyMismatchError("The SDK key provided does not match the one used to generate values."));
            return false;
        }
        return true;
    }
    ResponseVerification.verifySDKKeyUsed = verifySDKKeyUsed;
    var Timing = {};
    Object.defineProperty(Timing, "__esModule", {
        value: true
    });
    Timing.difference = Timing.now = void 0;
    function now() {
        if (typeof performance === "undefined" || !performance) return Date.now();
        return performance.now() | 0;
    }
    Timing.now = now;
    function difference(time) {
        return now() - time;
    }
    Timing.difference = difference;
    var LocalOverrides = {};
    (function(exports) {
        var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
            return mod && mod.__esModule ? mod : {
                "default": mod
            };
        };
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.saveOverridesToLocalStorage = exports.loadOverridesFromLocalStorage = exports.makeEmptyOverrides = exports.STORAGE_KEY = void 0;
        var StatsigLocalStorage_1 = __importDefault(StatsigLocalStorage$1);
        exports.STORAGE_KEY = "STATSIG_JS_LITE_LOCAL_OVERRIDES";
        function makeEmptyOverrides() {
            return {
                gates: {},
                configs: {},
                layers: {}
            };
        }
        exports.makeEmptyOverrides = makeEmptyOverrides;
        function loadOverridesFromLocalStorage() {
            var raw = StatsigLocalStorage_1.default.getItem(exports.STORAGE_KEY);
            if (raw) try {
                return JSON.parse(raw);
            } catch (error) {
            // noop
            }
            return makeEmptyOverrides();
        }
        exports.loadOverridesFromLocalStorage = loadOverridesFromLocalStorage;
        function saveOverridesToLocalStorage(overrides) {
            StatsigLocalStorage_1.default.setItem(exports.STORAGE_KEY, JSON.stringify(overrides));
        }
        exports.saveOverridesToLocalStorage = saveOverridesToLocalStorage;
    })(LocalOverrides);
    var __assign = commonjsGlobal && commonjsGlobal.__assign || function() {
        __assign = Object.assign || function(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        var desc = Object.getOwnPropertyDescriptor(m, k);
        if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function get() {
                return m[k];
            }
        };
        Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
    });
    var __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
        Object.defineProperty(o, "default", {
            enumerable: true,
            value: v
        });
    } : function(o, v) {
        o["default"] = v;
    });
    var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
        }
        __setModuleDefault(result, mod);
        return result;
    };
    var __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || function(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
    var __generator = commonjsGlobal && commonjsGlobal.__generator || function(thisArg, body) {
        var _ = {
            label: 0,
            sent: function sent() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(g && (g = 0, op[0] && (_ = 0)), _)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    };
    var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
        return mod && mod.__esModule ? mod : {
            "default": mod
        };
    };
    Object.defineProperty(StatsigClient$1, "__esModule", {
        value: true
    });
    var DynamicConfig_1 = __importDefault(DynamicConfig$1);
    var ErrorBoundary_1 = __importDefault(ErrorBoundary);
    var Errors_1 = Errors;
    var Layer_1 = __importDefault(Layer$1);
    var StatsigIdentity_1 = __importDefault(StatsigIdentity);
    var StatsigLogger_1 = __importDefault(StatsigLogger$1);
    var StatsigNetwork_1 = __importDefault(StatsigNetwork);
    var StatsigSDKOptions_1 = __importDefault(StatsigSDKOptions);
    var StatsigStore_1 = __importStar(StatsigStore);
    var ResponseVerification_1 = ResponseVerification;
    var StatsigLocalStorage_1 = __importDefault(StatsigLocalStorage$1);
    var Timing_1 = Timing;
    var LogEvent_1 = __importDefault(LogEvent);
    var LocalOverrides_1 = LocalOverrides;
    var StatsigClient = /** @class */ function() {
        function StatsigClient(sdkKey, user, options) {
            var _this = this;
            this._initCalled = false;
            this._pendingInitPromise = null;
            this._sdkKey = null;
            this._logLayerParameterExposureForLayer = function(layer, parameterName, isManualExposure) {
                if (isManualExposure === void 0) isManualExposure = false;
                var allocatedExperiment = "";
                var exposures = layer._undelegatedSecondaryExposures;
                var isExplicit = layer._explicitParameters.includes(parameterName);
                if (isExplicit) {
                    allocatedExperiment = layer._allocatedExperimentName;
                    exposures = layer._secondaryExposures;
                }
                _this._logger.logLayerExposure(_this._identity._user, layer._name, layer._ruleID, exposures, allocatedExperiment, parameterName, isExplicit, layer._evaluationDetails, isManualExposure);
            };
            if ((options === null || options === void 0 ? void 0 : options.localMode) !== true && (typeof sdkKey !== "string" || !sdkKey.startsWith("client-"))) throw new Errors_1.StatsigInvalidArgumentError("Invalid key provided.  You must use a Client SDK Key from the Statsig console to initialize the sdk");
            this._sdkKey = sdkKey;
            this._startTime = (0, Timing_1.now)();
            this._options = new StatsigSDKOptions_1.default(options);
            this._errorBoundary = new ErrorBoundary_1.default(sdkKey, this._options);
            this._ready = false;
            StatsigLocalStorage_1.default.disabled = this._options.disableLocalStorage;
            this._overrides = (0, LocalOverrides_1.loadOverridesFromLocalStorage)();
            this._identity = new StatsigIdentity_1.default(sdkKey, this._normalizeUser(user !== null && user !== void 0 ? user : null), this._options.overrideStableID);
            this._network = new StatsigNetwork_1.default(this._options, this._identity, this._errorBoundary);
            this._logger = new StatsigLogger_1.default(this._options, this._identity, this._network, this._errorBoundary);
            this._store = new StatsigStore_1.default(this._identity, this._logger.logConfigDefaultValueFallback, this._options.initializeValues);
            this._errorBoundary._setStatsigMetadata(this._identity._statsigMetadata);
            if (this._options.initializeValues != null) {
                this._ready = true;
                this._initCalled = true;
                setTimeout(function() {
                    return _this._delayedSetup();
                }, 20);
            }
        }
        StatsigClient.prototype.setInitializeValues = function(initializeValues) {
            var _this = this;
            this._errorBoundary._capture("setInitializeValues", function() {
                _this._store.bootstrap(initializeValues);
                if (!_this._ready) {
                    // the sdk is usable and considered initialized when configured
                    // with initializeValues
                    _this._ready = true;
                    _this._initCalled = true;
                }
                // we wont have access to window/document/localStorage if these run on the server
                // so try to run whenever this is called
                _this._logger.sendSavedRequests();
            }, function() {
                _this._ready = true;
                _this._initCalled = true;
            });
        };
        StatsigClient.prototype.initializeAsync = function() {
            return __awaiter(this, void 0, void 0, function() {
                var _this = this;
                return __generator(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this._errorBoundary._capture("initializeAsync", function() {
                            return __awaiter(_this, void 0, void 0, function() {
                                var user;
                                var _this = this;
                                return __generator(this, function(_a) {
                                    if (this._pendingInitPromise != null) return [
                                        2 /*return*/ ,
                                        this._pendingInitPromise
                                    ];
                                    if (this._ready) return [
                                        2 /*return*/ ,
                                        Promise.resolve()
                                    ];
                                    this._initCalled = true;
                                    if (this._options.localMode) return [
                                        2 /*return*/ ,
                                        Promise.resolve()
                                    ];
                                    user = this._identity._user;
                                    this._pendingInitPromise = this._fetchAndSaveValues(user, this._options.initTimeoutMs).then(function() {
                                        return;
                                    }).catch(function(e) {
                                        _this._errorBoundary._logError("initializeAsync:fetchAndSaveValues", e);
                                        return {
                                            success: false,
                                            message: e.message
                                        };
                                    }).then(function() {
                                        return;
                                    }).finally(function() {
                                        return __awaiter(_this, void 0, void 0, function() {
                                            return __generator(this, function(_a) {
                                                this._pendingInitPromise = null;
                                                this._ready = true;
                                                this._delayedSetup();
                                                return [
                                                    2 /*return*/ 
                                                ];
                                            });
                                        });
                                    });
                                    return [
                                        2 /*return*/ ,
                                        this._pendingInitPromise
                                    ];
                                });
                            });
                        }, function() {
                            _this._ready = true;
                            _this._initCalled = true;
                            return Promise.resolve();
                        })
                    ];
                });
            });
        };
        StatsigClient.prototype.getEvaluationDetails = function() {
            var _this = this;
            return this._errorBoundary._capture("getEvaluationDetails", function() {
                return _this._store.getGlobalEvaluationDetails();
            }, function() {
                return {
                    time: Date.now(),
                    reason: StatsigStore_1.EvaluationReason.Error
                };
            });
        };
        /**
     * Checks the value of a gate for the current user
     * @param {string} gateName - the name of the gate to check
     * @returns {boolean} - value of a gate for the user. Gates are "off" (return false) by default
     * @throws Error if initialize() is not called first, or gateName is not a string
     */ StatsigClient.prototype.checkGate = function(gateName) {
            return this._checkGateImpl(gateName, "checkGate");
        };
        StatsigClient.prototype.checkGateWithExposureLoggingDisabled = function(gateName) {
            return this._checkGateImpl(gateName, "checkGateWithExposureLoggingDisabled");
        };
        StatsigClient.prototype.logGateExposure = function(gateName) {
            var _this = this;
            this._errorBoundary._swallow("logGateExposure", function() {
                _this._logGateExposureImpl(gateName);
            });
        };
        /**
     * Checks the value of a config for the current user
     * @param {string} configName - the name of the config to get
     * @returns {DynamicConfig} - value of a config for the user
     * @throws Error if initialize() is not called first, or configName is not a string
     */ StatsigClient.prototype.getConfig = function(configName) {
            return this._getConfigImpl(configName, "getConfig");
        };
        StatsigClient.prototype.getConfigWithExposureLoggingDisabled = function(configName) {
            return this._getConfigImpl(configName, "getConfigWithExposureLoggingDisabled");
        };
        StatsigClient.prototype.logConfigExposure = function(configName) {
            var _this = this;
            this._errorBoundary._swallow("logConfigExposure", function() {
                _this._logConfigExposureImpl(configName);
            });
        };
        StatsigClient.prototype.getExperiment = function(experimentName) {
            return this.getConfig(experimentName);
        };
        StatsigClient.prototype.getExperimentWithExposureLoggingDisabled = function(experimentName) {
            return this.getConfigWithExposureLoggingDisabled(experimentName);
        };
        StatsigClient.prototype.logExperimentExposure = function(experimentName) {
            this.logConfigExposure(experimentName);
        };
        StatsigClient.prototype.getLayer = function(layerName) {
            return this._getLayerImpl(layerName, "getLayer");
        };
        StatsigClient.prototype.getLayerWithExposureLoggingDisabled = function(layerName) {
            return this._getLayerImpl(layerName, "getLayerWithExposureLoggingDisabled");
        };
        StatsigClient.prototype.logLayerParameterExposure = function(layerName, parameterName) {
            var _this = this;
            this._errorBoundary._swallow("logLayerParameterExposure", function() {
                var layer = _this._getLayerFromStore(null, layerName);
                _this._logLayerParameterExposureForLayer(layer, parameterName, true);
            });
        };
        StatsigClient.prototype.logEvent = function(eventName, value, metadata) {
            var _this = this;
            if (value === void 0) value = null;
            if (metadata === void 0) metadata = null;
            this._errorBoundary._swallow("logEvent", function() {
                if (!_this._logger || !_this._identity._sdkKey) throw new Errors_1.StatsigUninitializedError(Errors_1.StatsigErrorMessage.REQUIRE_INITIALIZE_FOR_LOG_EVENT);
                if (typeof eventName !== "string" || eventName.length === 0) return;
                var event = (0, LogEvent_1.default)(eventName, _this._identity._user, _this._identity._statsigMetadata, value, metadata);
                _this._logger.log(event);
            });
        };
        StatsigClient.prototype.updateUserWithValues = function(user, values) {
            var _this = this;
            var updateStartTime = Date.now();
            var fireCompletionCallback;
            return this._errorBoundary._capture("updateUserWithValues", function() {
                if (!_this.initializeCalled()) throw new Errors_1.StatsigUninitializedError(Errors_1.StatsigErrorMessage.REQUIRE_ASYNC_INITIALIZE);
                fireCompletionCallback = function fireCompletionCallback(success, error) {
                    var cb = _this._options.updateUserCompletionCallback;
                    cb === null || cb === void 0 || cb(Date.now() - updateStartTime, success, error);
                };
                _this._identity._user = _this._normalizeUser(user);
                _this._store.bootstrap(values);
                fireCompletionCallback(true, null);
                return true;
            }, function() {
                fireCompletionCallback === null || fireCompletionCallback === void 0 || fireCompletionCallback(false, "Failed to update user. An unexpected error occured.");
                return false;
            });
        };
        StatsigClient.prototype.updateUser = function(user) {
            return __awaiter(this, void 0, void 0, function() {
                var updateStartTime, fireCompletionCallback;
                var _this = this;
                return __generator(this, function(_a) {
                    updateStartTime = Date.now();
                    return [
                        2 /*return*/ ,
                        this._errorBoundary._capture("updateUser", function() {
                            return __awaiter(_this, void 0, void 0, function() {
                                var currentUser;
                                var _this = this;
                                return __generator(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            if (!this.initializeCalled()) throw new Errors_1.StatsigUninitializedError(Errors_1.StatsigErrorMessage.REQUIRE_ASYNC_INITIALIZE);
                                            fireCompletionCallback = function fireCompletionCallback(success, error) {
                                                var cb = _this._options.updateUserCompletionCallback;
                                                cb === null || cb === void 0 || cb(Date.now() - updateStartTime, success, error);
                                            };
                                            this._identity._user = this._normalizeUser(user);
                                            this._store.updateUser();
                                            this._logger.resetDedupeKeys();
                                            if (!(this._pendingInitPromise != null)) return [
                                                3 /*break*/ ,
                                                2
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                this._pendingInitPromise
                                            ];
                                        case 1:
                                            _a.sent();
                                            _a.label = 2;
                                        case 2:
                                            if (this._options.localMode) {
                                                fireCompletionCallback(true, null);
                                                return [
                                                    2 /*return*/ ,
                                                    Promise.resolve(true)
                                                ];
                                            }
                                            currentUser = this._identity._user;
                                            this._pendingInitPromise = this._fetchAndSaveValues(currentUser).finally(function() {
                                                _this._pendingInitPromise = null;
                                            });
                                            return [
                                                2 /*return*/ ,
                                                this._pendingInitPromise.then(function() {
                                                    fireCompletionCallback(true, null);
                                                    return Promise.resolve(true);
                                                }).catch(function(error) {
                                                    fireCompletionCallback(false, "Failed to update user: ".concat(error));
                                                    return Promise.resolve(false);
                                                })
                                            ];
                                    }
                                });
                            });
                        }, function() {
                            fireCompletionCallback(false, "Failed to update user. An unexpected error occured.");
                            return Promise.resolve(false);
                        })
                    ];
                });
            });
        };
        /**
     * Informs the statsig SDK that the client is closing or shutting down
     * so the SDK can clean up internal state
     */ StatsigClient.prototype.shutdown = function() {
            var _this = this;
            this._errorBoundary._swallow("shutdown", function() {
                _this._logger.shutdown();
            });
        };
        /**
     * @returns The Statsig stable ID used for device level experiments
     */ StatsigClient.prototype.getStableID = function() {
            var _this = this;
            return this._errorBoundary._capture("getStableID", function() {
                return _this._identity._statsigMetadata.stableID;
            }, function() {
                return "";
            });
        };
        StatsigClient.prototype.initializeCalled = function() {
            return this._initCalled;
        };
        StatsigClient.prototype.overrideGate = function(gate, result) {
            this._setOverride("gates", gate, result);
        };
        StatsigClient.prototype.overrideConfig = function(config, result) {
            this._setOverride("configs", config, result);
        };
        StatsigClient.prototype.overrideLayer = function(layer, result) {
            this._setOverride("layers", layer, result);
        };
        StatsigClient.prototype.setOverrides = function(overrides) {
            var _this = this;
            this._errorBoundary._swallow("setOverrides", function() {
                _this._overrides = overrides !== null && overrides !== void 0 ? overrides : (0, LocalOverrides_1.makeEmptyOverrides)();
                (0, LocalOverrides_1.saveOverridesToLocalStorage)(_this._overrides);
            });
        };
        StatsigClient.prototype.getOverrides = function() {
            var _this = this;
            return this._errorBoundary._capture("getOverrides", function() {
                return _this._overrides;
            }, function() {
                return (0, LocalOverrides_1.makeEmptyOverrides)();
            });
        };
        // Private
        StatsigClient.prototype._delayedSetup = function() {
            var _this = this;
            this._errorBoundary._swallow("delayedSetup", function() {
                _this._identity.saveStableID();
                _this._logger.sendSavedRequests().then(function() {
                /* noop */ });
            });
        };
        StatsigClient.prototype._normalizeUser = function(user) {
            var userCopy = {};
            try {
                userCopy = JSON.parse(JSON.stringify(user));
            } catch (error) {
                throw new Errors_1.StatsigInvalidArgumentError("User object must be convertable to JSON string.");
            }
            if (this._options.environment != null) userCopy = __assign(__assign({}, userCopy), {
                statsigEnvironment: this._options.environment
            });
            return userCopy;
        };
        StatsigClient.prototype._ensureStoreLoaded = function() {
            if (!this._store.isLoaded()) throw new Errors_1.StatsigUninitializedError();
        };
        StatsigClient.prototype._getEvaluationDetailsForError = function() {
            return {
                time: Date.now(),
                reason: StatsigStore_1.EvaluationReason.Error
            };
        };
        StatsigClient.prototype._fetchAndSaveValues = function(user, timeout) {
            if (timeout === void 0) timeout = this._options.initTimeoutMs;
            return __awaiter(this, void 0, void 0, function() {
                var sinceTime, previousDerivedFields;
                var _this = this;
                return __generator(this, function(_a) {
                    sinceTime = null;
                    sinceTime = this._store.getLastUpdateTime(user);
                    previousDerivedFields = this._store.getPreviousDerivedFields(user);
                    return [
                        2 /*return*/ ,
                        this._network.fetchValues(user, sinceTime, timeout, previousDerivedFields).eventually(function(json) {
                            var _a;
                            if (!(0, ResponseVerification_1.verifySDKKeyUsed)(json, (_a = _this._sdkKey) !== null && _a !== void 0 ? _a : "", _this._errorBoundary)) return;
                            if (json === null || json === void 0 ? void 0 : json.has_updates) _this._store.save(user, json, false);
                        }).then(function(json) {
                            return __awaiter(_this, void 0, void 0, function() {
                                var _this = this;
                                return __generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        this._errorBoundary._swallow("fetchAndSaveValues", function() {
                                            return __awaiter(_this, void 0, void 0, function() {
                                                var _a;
                                                return __generator(this, function(_b) {
                                                    switch(_b.label){
                                                        case 0:
                                                            if (!(0, ResponseVerification_1.verifySDKKeyUsed)(json, (_a = this._sdkKey) !== null && _a !== void 0 ? _a : "", this._errorBoundary)) return [
                                                                2 /*return*/ 
                                                            ];
                                                            if (!(json === null || json === void 0 ? void 0 : json.has_updates)) return [
                                                                3 /*break*/ ,
                                                                2
                                                            ];
                                                            return [
                                                                4 /*yield*/ ,
                                                                this._store.save(user, json)
                                                            ];
                                                        case 1:
                                                            _b.sent();
                                                            return [
                                                                3 /*break*/ ,
                                                                3
                                                            ];
                                                        case 2:
                                                            if (json === null || json === void 0 ? void 0 : json.is_no_content) this._store.setEvaluationReason(StatsigStore_1.EvaluationReason.NetworkNotModified);
                                                            _b.label = 3;
                                                        case 3:
                                                            return [
                                                                2 /*return*/ 
                                                            ];
                                                    }
                                                });
                                            });
                                        })
                                    ];
                                });
                            });
                        })
                    ];
                });
            });
        };
        StatsigClient.prototype._checkGateImpl = function(gateName, callsite) {
            var _this = this;
            return this._errorBoundary._capture(callsite, function() {
                if (typeof _this._overrides.gates[gateName] === "boolean") return _this._overrides.gates[gateName];
                var result = _this._getGateFromStore(gateName);
                if (callsite === "checkGate") _this._logGateExposureImpl(gateName, result);
                return result.gate.value === true;
            }, function() {
                return false;
            });
        };
        StatsigClient.prototype._getGateFromStore = function(gateName) {
            this._ensureStoreLoaded();
            if (typeof gateName !== "string" || gateName.length === 0) throw new Errors_1.StatsigInvalidArgumentError("Must pass a valid string as the gateName.");
            return this._store.checkGate(gateName);
        };
        StatsigClient.prototype._logGateExposureImpl = function(gateName, fetchResult) {
            var isManualExposure = !fetchResult;
            var result = fetchResult !== null && fetchResult !== void 0 ? fetchResult : this._getGateFromStore(gateName);
            var gate = result.gate;
            this._logger.logGateExposure(this._identity._user, gateName, gate.value, gate.rule_id, gate.secondary_exposures, result.evaluationDetails, isManualExposure);
        };
        StatsigClient.prototype._getConfigImpl = function(configName, callsite) {
            var _this = this;
            return this._errorBoundary._capture(callsite, function() {
                if (_this._overrides.configs[configName]) return new DynamicConfig_1.default(configName, _this._overrides.configs[configName], "local_override", {
                    reason: StatsigStore_1.EvaluationReason.LocalOverride,
                    time: Date.now()
                });
                var result = _this._getConfigFromStore(configName);
                if (callsite === "getConfig") _this._logConfigExposureImpl(configName, result);
                return result;
            }, function() {
                return _this._getEmptyConfig(configName);
            });
        };
        StatsigClient.prototype._getConfigFromStore = function(configName) {
            this._ensureStoreLoaded();
            if (typeof configName !== "string" || configName.length === 0) throw new Errors_1.StatsigInvalidArgumentError("Must pass a valid string as the configName.");
            return this._store.getConfig(configName);
        };
        StatsigClient.prototype._logConfigExposureImpl = function(configName, config) {
            var isManualExposure = !config;
            var localConfig = config !== null && config !== void 0 ? config : this._getConfigFromStore(configName);
            this._logger.logConfigExposure(this._identity._user, configName, localConfig._ruleID, localConfig._secondaryExposures, localConfig._evaluationDetails, isManualExposure);
        };
        StatsigClient.prototype._getLayerImpl = function(layerName, callsite) {
            var _this = this;
            return this._errorBoundary._capture(callsite, function() {
                if (_this._overrides.layers[layerName]) return Layer_1.default._create(layerName, _this._overrides.layers[layerName], "local_override", {
                    reason: StatsigStore_1.EvaluationReason.LocalOverride,
                    time: Date.now()
                });
                var logFunc = callsite === "getLayer" ? _this._logLayerParameterExposureForLayer : null;
                return _this._getLayerFromStore(logFunc, layerName);
            }, function() {
                return Layer_1.default._create(layerName, {}, "", _this._getEvaluationDetailsForError());
            });
        };
        StatsigClient.prototype._getLayerFromStore = function(logParameterFunction, layerName) {
            this._ensureStoreLoaded();
            if (typeof layerName !== "string" || layerName.length === 0) throw new Errors_1.StatsigInvalidArgumentError("Must pass a valid string as the layerName.");
            return this._store.getLayer(logParameterFunction, layerName);
        };
        StatsigClient.prototype._getEmptyConfig = function(configName) {
            return new DynamicConfig_1.default(configName, {}, "", this._getEvaluationDetailsForError());
        };
        StatsigClient.prototype._setOverride = function(type, key, result) {
            if (result == null) delete this._overrides[type][key];
            else this._overrides[type][key] = result;
            this.setOverrides(this._overrides);
        };
        return StatsigClient;
    }();
    StatsigClient$1.default = StatsigClient;
    (function(exports) {
        var __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || function(thisArg, _arguments, P, generator) {
            function adopt(value) {
                return value instanceof P ? value : new P(function(resolve) {
                    resolve(value);
                });
            }
            return new (P || (P = Promise))(function(resolve, reject) {
                function fulfilled(value) {
                    try {
                        step(generator.next(value));
                    } catch (e) {
                        reject(e);
                    }
                }
                function rejected(value) {
                    try {
                        step(generator["throw"](value));
                    } catch (e) {
                        reject(e);
                    }
                }
                function step(result) {
                    result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                }
                step((generator = generator.apply(thisArg, _arguments || [])).next());
            });
        };
        var __generator = commonjsGlobal && commonjsGlobal.__generator || function(thisArg, body) {
            var _ = {
                label: 0,
                sent: function sent() {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: []
            }, f, y, t, g;
            return g = {
                next: verb(0),
                "throw": verb(1),
                "return": verb(2)
            }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                return this;
            }), g;
            function verb(n) {
                return function(v) {
                    return step([
                        n,
                        v
                    ]);
                };
            }
            function step(op) {
                if (f) throw new TypeError("Generator is already executing.");
                while(g && (g = 0, op[0] && (_ = 0)), _)try {
                    if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                    if (y = 0, t) op = [
                        op[0] & 2,
                        t.value
                    ];
                    switch(op[0]){
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return {
                                value: op[1],
                                done: false
                            };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [
                                0
                            ];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [
                        6,
                        e
                    ];
                    y = 0;
                } finally{
                    f = t = 0;
                }
                if (op[0] & 5) throw op[1];
                return {
                    value: op[0] ? op[1] : void 0,
                    done: true
                };
            }
        };
        var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
            return mod && mod.__esModule ? mod : {
                "default": mod
            };
        };
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.EvaluationReason = exports.DynamicConfig = void 0;
        var Errors_1 = Errors;
        var StatsigClient_1 = __importDefault(StatsigClient$1);
        var StatsigStore_1 = StatsigStore;
        var DynamicConfig_1 = DynamicConfig$1;
        Object.defineProperty(exports, "DynamicConfig", {
            enumerable: true,
            get: function get() {
                return __importDefault(DynamicConfig_1).default;
            }
        });
        var StatsigStore_2 = StatsigStore;
        Object.defineProperty(exports, "EvaluationReason", {
            enumerable: true,
            get: function get() {
                return StatsigStore_2.EvaluationReason;
            }
        });
        var Statsig = /** @class */ function() {
            function Statsig() {}
            Statsig.initialize = function(sdkKey, user, options) {
                var _a;
                return __awaiter(this, void 0, void 0, function() {
                    var inst;
                    return __generator(this, function(_b) {
                        inst = (_a = Statsig.instance) !== null && _a !== void 0 ? _a : new StatsigClient_1.default(sdkKey, user, options);
                        if (!Statsig.instance) Statsig.instance = inst;
                        return [
                            2 /*return*/ ,
                            inst.initializeAsync()
                        ];
                    });
                });
            };
            Statsig.setInitializeValues = function(initializeValues) {
                Statsig._getClientX().setInitializeValues(initializeValues);
            };
            // Gate
            Statsig.checkGate = function(gateName) {
                return Statsig._getClientX().checkGate(gateName);
            };
            Statsig.checkGateWithExposureLoggingDisabled = function(gateName) {
                return Statsig._getClientX().checkGateWithExposureLoggingDisabled(gateName);
            };
            Statsig.manuallyLogGateExposure = function(gateName) {
                Statsig._getClientX().logGateExposure(gateName);
            };
            // Config
            Statsig.getConfig = function(configName) {
                return Statsig._getClientX().getConfig(configName);
            };
            Statsig.getConfigWithExposureLoggingDisabled = function(configName) {
                return Statsig._getClientX().getConfigWithExposureLoggingDisabled(configName);
            };
            Statsig.manuallyLogConfigExposure = function(configName) {
                Statsig._getClientX().logConfigExposure(configName);
            };
            // Experiment
            Statsig.getExperiment = function(experimentName) {
                return Statsig._getClientX().getExperiment(experimentName);
            };
            Statsig.getExperimentWithExposureLoggingDisabled = function(experimentName) {
                return Statsig._getClientX().getExperimentWithExposureLoggingDisabled(experimentName);
            };
            Statsig.manuallyLogExperimentExposure = function(configName) {
                Statsig._getClientX().logExperimentExposure(configName);
            };
            // Layer
            Statsig.getLayer = function(layerName) {
                return Statsig._getClientX().getLayer(layerName);
            };
            Statsig.getLayerWithExposureLoggingDisabled = function(layerName) {
                return Statsig._getClientX().getLayerWithExposureLoggingDisabled(layerName);
            };
            Statsig.manuallyLogLayerParameterExposure = function(layerName, parameterName) {
                Statsig._getClientX().logLayerParameterExposure(layerName, parameterName);
            };
            Statsig.logEvent = function(eventName, value, metadata) {
                if (value === void 0) value = null;
                if (metadata === void 0) metadata = null;
                return Statsig._getClientX().logEvent(eventName, value, metadata);
            };
            Statsig.updateUser = function(user) {
                return Statsig._getClientX().updateUser(user);
            };
            Statsig.updateUserWithValues = function(user, values) {
                return Statsig._getClientX().updateUserWithValues(user, values);
            };
            Statsig.shutdown = function() {
                Statsig._getClientX().shutdown();
                Statsig.instance = null;
            };
            Statsig.overrideGate = function(gate, result) {
                Statsig._getClientX().overrideGate(gate, result);
            };
            Statsig.overrideConfig = function(config, result) {
                Statsig._getClientX().overrideConfig(config, result);
            };
            Statsig.overrideLayer = function(layer, result) {
                Statsig._getClientX().overrideLayer(layer, result);
            };
            Statsig.setOverrides = function(overrides) {
                Statsig._getClientX().setOverrides(overrides);
            };
            Statsig.getOverrides = function() {
                return Statsig._getClientX().getOverrides();
            };
            /**
     * @returns The Statsig stable ID used for device level experiments
     */ Statsig.getStableID = function() {
                return Statsig._getClientX().getStableID();
            };
            /**
     *
     * @returns The reason and time associated with the evaluation for the current set
     * of gates and configs
     */ Statsig.getEvaluationDetails = function() {
                var _a, _b;
                return (_b = (_a = Statsig.instance) === null || _a === void 0 ? void 0 : _a.getEvaluationDetails()) !== null && _b !== void 0 ? _b : {
                    reason: StatsigStore_1.EvaluationReason.Uninitialized,
                    time: 0
                };
            };
            /**
     *
     * @returns true if initialize has already been called, false otherwise
     */ Statsig.initializeCalled = function() {
                return Statsig.instance != null && Statsig.instance.initializeCalled();
            };
            Statsig._getClientX = function() {
                if (!Statsig.instance) throw new Errors_1.StatsigUninitializedError();
                return Statsig.instance;
            };
            Statsig.instance = null;
            return Statsig;
        }();
        exports.default = Statsig;
    })(dist);
    var Statsig = /*@__PURE__*/ getDefaultExportFromCjs(dist);
    /**
   * The identifiers for the user. Options are restricted to the set that is currently supported.
   */ /**
   * Base client options.
   * @interface BaseClientOptions
   * @property {FeatureGateEnvironment} environment - The environment for the client.
   * @property {string} targetApp - The target app for the client.
   * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
   * @property {PerimeterType} perimeter - The perimeter for the client.
   */ /**
   * The options for the client.
   * @interface ClientOptions
   * @extends {BaseClientOptions}
   * @property {string} apiKey - The API key for the client.
   * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
   * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
   */ /**
   * The custom attributes for the user.
   */ var FeatureGateEnvironment = /*#__PURE__*/ function(FeatureGateEnvironment) {
        FeatureGateEnvironment["Development"] = "development";
        FeatureGateEnvironment["Staging"] = "staging";
        FeatureGateEnvironment["Production"] = "production";
        return FeatureGateEnvironment;
    }({});
    var PerimeterType = /*#__PURE__*/ function(PerimeterType) {
        PerimeterType["COMMERCIAL"] = "commercial";
        PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
        return PerimeterType;
    }({});
    var CLIENT_VERSION = "4.17.0";
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        Object.defineProperty(subClass, "prototype", {
            writable: false
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
    }
    function _assertThisInitialized(self1) {
        if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self1;
    }
    function _possibleConstructorReturn(self1, call) {
        if (call && (_typeof$1(call) === "object" || typeof call === "function")) return call;
        else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
        return _assertThisInitialized(self1);
    }
    function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
    }
    function _isNativeFunction(fn) {
        try {
            return Function.toString.call(fn).indexOf("[native code]") !== -1;
        } catch (e) {
            return typeof fn === "function";
        }
    }
    function _wrapNativeSuper(Class) {
        var _cache = typeof Map === "function" ? new Map() : undefined;
        _wrapNativeSuper = function _wrapNativeSuper(Class) {
            if (Class === null || !_isNativeFunction(Class)) return Class;
            if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
            if (typeof _cache !== "undefined") {
                if (_cache.has(Class)) return _cache.get(Class);
                _cache.set(Class, Wrapper);
            }
            function Wrapper() {
                return _construct(Class, arguments, _getPrototypeOf(this).constructor);
            }
            Wrapper.prototype = Object.create(Class.prototype, {
                constructor: {
                    value: Wrapper,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
            return _setPrototypeOf(Wrapper, Class);
        };
        return _wrapNativeSuper(Class);
    }
    function _createSuper(Derived) {
        var hasNativeReflectConstruct = _isNativeReflectConstruct();
        return function _createSuperInternal() {
            var Super = _getPrototypeOf(Derived), result;
            if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
            } else result = Super.apply(this, arguments);
            return _possibleConstructorReturn(this, result);
        };
    }
    function _isNativeReflectConstruct() {
        try {
            var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        } catch (t) {}
        return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
            return !!t;
        })();
    }
    var ResponseError = /*#__PURE__*/ function(_Error) {
        _inherits(ResponseError, _Error);
        var _super = _createSuper(ResponseError);
        function ResponseError(message) {
            _classCallCheck(this, ResponseError);
            return _super.call(this, message);
        }
        return _createClass(ResponseError);
    }(/*#__PURE__*/ _wrapNativeSuper(Error));
    function ownKeys$2(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function(r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function _objectSpread$2(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? ownKeys$2(Object(t), !0).forEach(function(r) {
                _defineProperty(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function(r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    var DEFAULT_REQUEST_TIMEOUT_MS = 5000;
    var PROD_BASE_URL = "https://api.atlassian.com/flags";
    var STAGING_BASE_URL = "https://api.stg.atlassian.com/flags";
    var DEV_BASE_URL = "https://api.dev.atlassian.com/flags";
    var FEDM_STAGING_BASE_URL = "https://api.stg.atlassian-us-gov-mod.com/flags";
    var FEDM_PROD_BASE_URL = "https://api.atlassian-us-gov-mod.com/flags";
    var GATEWAY_BASE_URL = "/gateway/api/flags";
    var Fetcher = /*#__PURE__*/ function() {
        function Fetcher() {
            _classCallCheck(this, Fetcher);
        }
        _createClass(Fetcher, null, [
            {
                key: "fetchClientSdk",
                value: function() {
                    var _fetchClientSdk = _asyncToGenerator(/*#__PURE__*/ regenerator.mark(function _callee(fetcherOptions) {
                        var targetApp, url;
                        return regenerator.wrap(function _callee$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    targetApp = fetcherOptions.targetApp;
                                    url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                    _context.prev = 2;
                                    _context.next = 5;
                                    return this.fetchRequest(url, "GET", fetcherOptions);
                                case 5:
                                    return _context.abrupt("return", _context.sent);
                                case 8:
                                    _context.prev = 8;
                                    _context.t0 = _context["catch"](2);
                                    if (!(_context.t0 instanceof Error)) {
                                        _context.next = 12;
                                        break;
                                    }
                                    throw _context.t0;
                                case 12:
                                    throw Error("Failed to retrieve client sdk key");
                                case 13:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee, this, [
                            [
                                2,
                                8
                            ]
                        ]);
                    }));
                    function fetchClientSdk(_x) {
                        return _fetchClientSdk.apply(this, arguments);
                    }
                    return fetchClientSdk;
                }()
            },
            {
                key: "fetchExperimentValues",
                value: function() {
                    var _fetchExperimentValues = _asyncToGenerator(/*#__PURE__*/ regenerator.mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                        var requestBody;
                        return regenerator.wrap(function _callee2$(_context2) {
                            while(true)switch(_context2.prev = _context2.next){
                                case 0:
                                    requestBody = {
                                        identifiers: identifiers,
                                        customAttributes: customAttributes,
                                        targetApp: fetcherOptions.targetApp
                                    };
                                    _context2.prev = 1;
                                    _context2.next = 4;
                                    return this.fetchRequest("/api/v2/frontend/experimentValues", "POST", fetcherOptions, requestBody);
                                case 4:
                                    return _context2.abrupt("return", _context2.sent);
                                case 7:
                                    _context2.prev = 7;
                                    _context2.t0 = _context2["catch"](1);
                                    if (!(_context2.t0 instanceof Error)) {
                                        _context2.next = 11;
                                        break;
                                    }
                                    throw _context2.t0;
                                case 11:
                                    throw Error("Failed to retrieve experiment values");
                                case 12:
                                case "end":
                                    return _context2.stop();
                            }
                        }, _callee2, this, [
                            [
                                1,
                                7
                            ]
                        ]);
                    }));
                    function fetchExperimentValues(_x2, _x3, _x4) {
                        return _fetchExperimentValues.apply(this, arguments);
                    }
                    return fetchExperimentValues;
                }()
            },
            {
                key: "handleResponseError",
                value: function() {
                    var _handleResponseError = _asyncToGenerator(/*#__PURE__*/ regenerator.mark(function _callee3(response) {
                        var body;
                        return regenerator.wrap(function _callee3$(_context3) {
                            while(true)switch(_context3.prev = _context3.next){
                                case 0:
                                    if (response.ok) {
                                        _context3.next = 5;
                                        break;
                                    }
                                    _context3.next = 3;
                                    return response.text();
                                case 3:
                                    body = _context3.sent;
                                    throw new ResponseError("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                                case 5:
                                    if (!(response.status === 204)) {
                                        _context3.next = 7;
                                        break;
                                    }
                                    throw new ResponseError("Unexpected 204 response");
                                case 7:
                                case "end":
                                    return _context3.stop();
                            }
                        }, _callee3);
                    }));
                    function handleResponseError(_x5) {
                        return _handleResponseError.apply(this, arguments);
                    }
                    return handleResponseError;
                }()
            },
            {
                key: "extractResponseBody",
                value: function() {
                    var _extractResponseBody = _asyncToGenerator(/*#__PURE__*/ regenerator.mark(function _callee4(response) {
                        var value;
                        return regenerator.wrap(function _callee4$(_context4) {
                            while(true)switch(_context4.prev = _context4.next){
                                case 0:
                                    _context4.next = 2;
                                    return response.text();
                                case 2:
                                    value = _context4.sent;
                                    return _context4.abrupt("return", JSON.parse(value));
                                case 4:
                                case "end":
                                    return _context4.stop();
                            }
                        }, _callee4);
                    }));
                    function extractResponseBody(_x6) {
                        return _extractResponseBody.apply(this, arguments);
                    }
                    return extractResponseBody;
                }()
            },
            {
                key: "getBaseUrl",
                value: function getBaseUrl(serviceEnv) {
                    var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                    var perimeter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PerimeterType.COMMERCIAL;
                    if (useGatewayUrl) return GATEWAY_BASE_URL;
                    if (perimeter === PerimeterType.FEDRAMP_MODERATE) switch(serviceEnv){
                        case FeatureGateEnvironment.Production:
                            return FEDM_PROD_BASE_URL;
                        case FeatureGateEnvironment.Staging:
                            return FEDM_STAGING_BASE_URL;
                        default:
                            throw new Error('Invalid environment "'.concat(serviceEnv, '" for "').concat(perimeter, '" perimeter'));
                    }
                    else if (perimeter === PerimeterType.COMMERCIAL) switch(serviceEnv){
                        case FeatureGateEnvironment.Development:
                            return DEV_BASE_URL;
                        case FeatureGateEnvironment.Staging:
                            return STAGING_BASE_URL;
                        default:
                            return PROD_BASE_URL;
                    }
                    else throw new Error('Invalid perimeter "'.concat(perimeter, '"'));
                }
            },
            {
                key: "fetchRequest",
                value: function() {
                    var _fetchRequest = _asyncToGenerator(/*#__PURE__*/ regenerator.mark(function _callee5(path, method, fetcherOptions, body) {
                        var baseUrl, fetchTimeout, abortSignal, abortController, response;
                        return regenerator.wrap(function _callee5$(_context5) {
                            while(true)switch(_context5.prev = _context5.next){
                                case 0:
                                    baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
                                    fetchTimeout = fetcherOptions.fetchTimeoutMs || DEFAULT_REQUEST_TIMEOUT_MS;
                                    if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                    else if (AbortController) {
                                        abortController = new AbortController();
                                        abortSignal = abortController.signal;
                                        setTimeout(function() {
                                            return abortController.abort();
                                        }, fetchTimeout);
                                    }
                                    _context5.next = 5;
                                    return fetch("".concat(baseUrl).concat(path), _objectSpread$2({
                                        method: method,
                                        headers: {
                                            "Content-Type": "application/json",
                                            "X-Client-Name": "feature-gate-js-client",
                                            "X-Client-Version": CLIENT_VERSION,
                                            "X-API-KEY": fetcherOptions.apiKey
                                        },
                                        signal: abortSignal
                                    }, body && {
                                        body: JSON.stringify(body)
                                    }));
                                case 5:
                                    response = _context5.sent;
                                    _context5.next = 8;
                                    return this.handleResponseError(response);
                                case 8:
                                    _context5.next = 10;
                                    return this.extractResponseBody(response);
                                case 10:
                                    return _context5.abrupt("return", _context5.sent);
                                case 11:
                                case "end":
                                    return _context5.stop();
                            }
                        }, _callee5, this);
                    }));
                    function fetchRequest(_x7, _x8, _x9, _x10) {
                        return _fetchRequest.apply(this, arguments);
                    }
                    return fetchRequest;
                }()
            }
        ]);
        return Fetcher;
    }();
    var _excluded = [
        "sdkKey",
        "updateUserCompletionCallback",
        "perimeter"
    ];
    function ownKeys$1(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function(r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function _objectSpread$1(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? ownKeys$1(Object(t), !0).forEach(function(r) {
                _defineProperty(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function(r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    var DEFAULT_CLIENT_KEY = "client-default-key";
    // the default event logging api is the Atlassian proxy rather than Statsig's domain, to avoid ad blockers
    var DEFAULT_EVENT_LOGGING_API = "https://xp.atlassian.com/v1/";
    /**
   * Access the FeatureGates object via the default export.
   * ```ts
   * import FeatureGates from '@atlaskit/feature-gate-js-client';
   * ```
   */ var FeatureGates = /*#__PURE__*/ function() {
        function FeatureGates() {
            _classCallCheck(this, FeatureGates);
        }
        _createClass(FeatureGates, null, [
            {
                key: "initialize",
                value: /**
       * @description
       * This method initializes the client using a network call to fetch the bootstrap values.
       * If the client is inialized with an `analyticsWebClient`, it will send an operational event
       * to GASv3 with the following attributes:
       * - targetApp: the target app of the client
       * - clientVersion: the version of the client
       * - success: whether the initialization was successful
       * - startTime: the time when the initialization started
       * - totalTime: the total time it took to initialize the client
       * - apiKey: the api key used to initialize the client
       * @param clientOptions {ClientOptions}
       * @param identifiers {Identifiers}
       * @param customAttributes {CustomAttributes}
       * @returns {Promise<void>}
       */ function() {
                    var _initialize = _asyncToGenerator(/*#__PURE__*/ regenerator.mark(function _callee(clientOptions, identifiers, customAttributes) {
                        var startTime;
                        return regenerator.wrap(function _callee$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    if (!FeatureGates.initPromise) {
                                        _context.next = 3;
                                        break;
                                    }
                                    if (!FeatureGates.shallowEquals(clientOptions, FeatureGates.initOptions)) // eslint-disable-next-line no-console
                                    console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                    return _context.abrupt("return", FeatureGates.initPromise);
                                case 3:
                                    startTime = performance.now();
                                    FeatureGates.initOptions = clientOptions;
                                    FeatureGates.initPromise = FeatureGates.init(clientOptions, identifiers, customAttributes).then(function() {
                                        FeatureGates.initCompleted = true;
                                    }).finally(function() {
                                        var endTime = performance.now();
                                        var totalTime = endTime - startTime;
                                        FeatureGates.fireClientEvent(startTime, totalTime, "initialize", FeatureGates.initCompleted, clientOptions.apiKey);
                                    });
                                    return _context.abrupt("return", FeatureGates.initPromise);
                                case 7:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee);
                    }));
                    function initialize(_x, _x2, _x3) {
                        return _initialize.apply(this, arguments);
                    }
                    return initialize;
                }()
            },
            {
                key: "fireClientEvent",
                value: function fireClientEvent(startTime, totalTime, action, success) {
                    var _FeatureGates$initOpt;
                    var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                    (_FeatureGates$initOpt = FeatureGates.initOptions.analyticsWebClient) === null || _FeatureGates$initOpt === void 0 || _FeatureGates$initOpt.then(function(analyticsWebClient) {
                        var attributes = _objectSpread$1({
                            targetApp: FeatureGates.initOptions.targetApp,
                            clientVersion: CLIENT_VERSION,
                            success: success,
                            startTime: startTime,
                            totalTime: totalTime
                        }, apiKey && {
                            apiKey: apiKey
                        });
                        analyticsWebClient.sendOperationalEvent({
                            action: action,
                            actionSubject: "featureGatesClient",
                            attributes: attributes,
                            tags: [
                                "measurement"
                            ],
                            source: "@atlaskit/feature-gate-js-client"
                        });
                    }).catch(function(err) {
                        if (FeatureGates.initOptions.environment !== FeatureGateEnvironment.Production) // eslint-disable-next-line no-console
                        console.error("Analytics web client promise did not resolve", err);
                    });
                }
            },
            {
                key: "initializeFromValues",
                value: function() {
                    var _initializeFromValues = _asyncToGenerator(/*#__PURE__*/ regenerator.mark(function _callee2(clientOptions, identifiers, customAttributes) {
                        var initializeValues, startTime, _args2 = arguments;
                        return regenerator.wrap(function _callee2$(_context2) {
                            while(true)switch(_context2.prev = _context2.next){
                                case 0:
                                    initializeValues = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : {};
                                    if (!FeatureGates.initPromise) {
                                        _context2.next = 4;
                                        break;
                                    }
                                    if (!FeatureGates.shallowEquals(clientOptions, FeatureGates.initOptions)) // eslint-disable-next-line no-console
                                    console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                    return _context2.abrupt("return", FeatureGates.initPromise);
                                case 4:
                                    startTime = performance.now();
                                    FeatureGates.initOptions = clientOptions;
                                    FeatureGates.initPromise = FeatureGates.initFromValues(clientOptions, identifiers, customAttributes, initializeValues).then(function() {
                                        FeatureGates.initCompleted = true;
                                    }).finally(function() {
                                        var endTime = performance.now();
                                        var totalTime = endTime - startTime;
                                        FeatureGates.fireClientEvent(startTime, totalTime, "initializeFromValues", FeatureGates.initCompleted);
                                    });
                                    return _context2.abrupt("return", FeatureGates.initPromise);
                                case 8:
                                case "end":
                                    return _context2.stop();
                            }
                        }, _callee2);
                    }));
                    function initializeFromValues(_x4, _x5, _x6) {
                        return _initializeFromValues.apply(this, arguments);
                    }
                    return initializeFromValues;
                }()
            },
            {
                key: "updateUser",
                value: function() {
                    var _updateUser = _asyncToGenerator(/*#__PURE__*/ regenerator.mark(function _callee3(fetchOptions, identifiers, customAttributes) {
                        var initializeValuesProducer;
                        return regenerator.wrap(function _callee3$(_context3) {
                            while(true)switch(_context3.prev = _context3.next){
                                case 0:
                                    initializeValuesProducer = function initializeValuesProducer() {
                                        return Fetcher.fetchExperimentValues(fetchOptions, identifiers, customAttributes).then(function(_ref) {
                                            var experimentValues = _ref.experimentValues, customAttributes = _ref.customAttributes;
                                            return {
                                                experimentValues: experimentValues,
                                                customAttributesFromFetch: customAttributes
                                            };
                                        });
                                    };
                                    _context3.next = 3;
                                    return FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                                case 3:
                                case "end":
                                    return _context3.stop();
                            }
                        }, _callee3);
                    }));
                    function updateUser(_x7, _x8, _x9) {
                        return _updateUser.apply(this, arguments);
                    }
                    return updateUser;
                }()
            },
            {
                key: "updateUserWithValues",
                value: function() {
                    var _updateUserWithValues = _asyncToGenerator(/*#__PURE__*/ regenerator.mark(function _callee4(identifiers, customAttributes) {
                        var initializeValues, initializeValuesProducer, _args4 = arguments;
                        return regenerator.wrap(function _callee4$(_context4) {
                            while(true)switch(_context4.prev = _context4.next){
                                case 0:
                                    initializeValues = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
                                    initializeValuesProducer = function initializeValuesProducer() {
                                        return Promise.resolve({
                                            experimentValues: initializeValues,
                                            customAttributesFromFetch: customAttributes
                                        });
                                    };
                                    _context4.next = 4;
                                    return FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                                case 4:
                                case "end":
                                    return _context4.stop();
                            }
                        }, _callee4);
                    }));
                    function updateUserWithValues(_x10, _x11) {
                        return _updateUserWithValues.apply(this, arguments);
                    }
                    return updateUserWithValues;
                }()
            },
            {
                key: "initializeCalled",
                value: function initializeCalled() {
                    return FeatureGates.initPromise != null;
                }
            },
            {
                key: "initializeCompleted",
                value: function initializeCompleted() {
                    return FeatureGates.initCompleted;
                }
            },
            {
                key: "checkGate",
                value: function checkGate(gateName) {
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    try {
                        var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                        var evalMethod = fireGateExposure ? Statsig.checkGate.bind(Statsig) : Statsig.checkGateWithExposureLoggingDisabled.bind(Statsig);
                        return evalMethod(gateName);
                    } catch (error) {
                        // Log the first occurrence of the error
                        if (!FeatureGates.hasCheckGateErrorOccurred) {
                            // eslint-disable-next-line no-console
                            console.warn({
                                msg: "An error has occurred checking the feature gate. Only the first occurrence of this error is logged.",
                                gateName: gateName,
                                error: error
                            });
                            FeatureGates.hasCheckGateErrorOccurred = true;
                        }
                        return false;
                    }
                }
            },
            {
                key: "manuallyLogGateExposure",
                value: function manuallyLogGateExposure(gateName) {
                    Statsig.manuallyLogGateExposure(gateName);
                }
            },
            {
                key: "getExperiment",
                value: function getExperiment(experimentName) {
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    try {
                        var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                        var evalMethod = fireExperimentExposure ? Statsig.getExperiment.bind(Statsig) : Statsig.getExperimentWithExposureLoggingDisabled.bind(Statsig);
                        return evalMethod(experimentName);
                    } catch (error) {
                        // Log the first occurrence of the error
                        if (!FeatureGates.hasGetExperimentErrorOccurred) {
                            // eslint-disable-next-line no-console
                            console.warn({
                                msg: "An error has occurred getting the experiment. Only the first occurrence of this error is logged.",
                                experimentName: experimentName,
                                error: error
                            });
                            FeatureGates.hasGetExperimentErrorOccurred = true;
                        }
                        // Return a default value
                        return new dist.DynamicConfig(experimentName, {}, "", {
                            time: Date.now(),
                            reason: dist.EvaluationReason.Error
                        });
                    }
                }
            },
            {
                key: "getExperimentValue",
                value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                    var experiment = FeatureGates.getExperiment(experimentName, options);
                    try {
                        var typeGuard = options.typeGuard;
                        return experiment.get(parameterName, defaultValue, typeGuard);
                    } catch (error) {
                        // Log the first occurrence of the error
                        if (!FeatureGates.hasGetExperimentValueErrorOccurred) {
                            // eslint-disable-next-line no-console
                            console.warn({
                                msg: "An error has occurred getting the experiment value. Only the first occurrence of this error is logged.",
                                experimentName: experimentName,
                                defaultValue: defaultValue,
                                options: options,
                                error: error
                            });
                            FeatureGates.hasGetExperimentValueErrorOccurred = true;
                        }
                        return defaultValue;
                    }
                }
            },
            {
                key: "manuallyLogExperimentExposure",
                value: function manuallyLogExperimentExposure(experimentName) {
                    Statsig.manuallyLogExperimentExposure(experimentName);
                }
            },
            {
                key: "shutdownStatsig",
                value: function shutdownStatsig() {
                    Statsig.shutdown();
                }
            },
            {
                key: "overrideGate",
                value: function overrideGate(gateName, value) {
                    Statsig.overrideGate(gateName, value);
                }
            },
            {
                key: "clearGateOverride",
                value: function clearGateOverride(gateName) {
                    Statsig.overrideGate(gateName, null);
                }
            },
            {
                key: "overrideConfig",
                value: function overrideConfig(experimentName, values) {
                    Statsig.overrideConfig(experimentName, values);
                }
            },
            {
                key: "clearConfigOverride",
                value: function clearConfigOverride(experimentName) {
                    Statsig.overrideConfig(experimentName, null);
                }
            },
            {
                key: "setOverrides",
                value: function setOverrides(overrides) {
                    Statsig.setOverrides(_objectSpread$1({
                        gates: {},
                        configs: {},
                        layers: {}
                    }, overrides));
                }
            },
            {
                key: "getOverrides",
                value: function getOverrides() {
                    return Statsig.getOverrides();
                }
            },
            {
                key: "clearAllOverrides",
                value: function clearAllOverrides() {
                    Statsig.setOverrides(null);
                }
            },
            {
                key: "isCurrentUser",
                value: function isCurrentUser(identifiers, customAttributes) {
                    return FeatureGates.shallowEquals(FeatureGates.currentIdentifiers, identifiers) && FeatureGates.shallowEquals(FeatureGates.currentAttributes, customAttributes);
                }
            },
            {
                key: "init",
                value: function() {
                    var _init = _asyncToGenerator(/*#__PURE__*/ regenerator.mark(function _callee5(clientOptions, identifiers, customAttributes) {
                        var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                        return regenerator.wrap(function _callee5$(_context5) {
                            while(true)switch(_context5.prev = _context5.next){
                                case 0:
                                    fromValuesClientOptions = _objectSpread$1(_objectSpread$1({}, clientOptions), {}, {
                                        disableCurrentPageLogging: true
                                    });
                                    _context5.prev = 1;
                                    // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for the experiment
                                    // values request to be settled, and it will fall back to use default values.
                                    clientSdkKeyPromise = Fetcher.fetchClientSdk(clientOptions).then(function(value) {
                                        return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                    });
                                    experimentValuesPromise = Fetcher.fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client with experiment
                                    // values if both requests are successful. Else an error would be thrown and handled by the catch
                                    _context5.next = 6;
                                    return Promise.all([
                                        clientSdkKeyPromise,
                                        experimentValuesPromise
                                    ]);
                                case 6:
                                    _yield$Promise$all = _context5.sent;
                                    _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                                    experimentValuesResult = _yield$Promise$all2[1];
                                    experimentValues = experimentValuesResult.experimentValues;
                                    customAttributesFromResult = experimentValuesResult.customAttributes;
                                    _context5.next = 20;
                                    break;
                                case 13:
                                    _context5.prev = 13;
                                    _context5.t0 = _context5["catch"](1);
                                    if (_context5.t0 instanceof Error) // eslint-disable-next-line no-console
                                    console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context5.t0 === null || _context5.t0 === void 0 ? void 0 : _context5.t0.message));
                                    // eslint-disable-next-line no-console
                                    console.warn("Initialising Statsig client without values");
                                    _context5.next = 19;
                                    return FeatureGates.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                                case 19:
                                    throw _context5.t0;
                                case 20:
                                    _context5.next = 22;
                                    return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
                                case 22:
                                case "end":
                                    return _context5.stop();
                            }
                        }, _callee5, this, [
                            [
                                1,
                                13
                            ]
                        ]);
                    }));
                    function init(_x12, _x13, _x14) {
                        return _init.apply(this, arguments);
                    }
                    return init;
                }()
            },
            {
                key: "initFromValues",
                value: function() {
                    var _initFromValues = _asyncToGenerator(/*#__PURE__*/ regenerator.mark(function _callee6(clientOptions, identifiers, customAttributes) {
                        var initializeValues, user, sdkKey, statsigOptions, _args6 = arguments;
                        return regenerator.wrap(function _callee6$(_context6) {
                            while(true)switch(_context6.prev = _context6.next){
                                case 0:
                                    initializeValues = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : {};
                                    user = this.toStatsigUser(identifiers, customAttributes);
                                    FeatureGates.currentIdentifiers = identifiers;
                                    FeatureGates.currentAttributes = customAttributes;
                                    if (!clientOptions.sdkKey) clientOptions.sdkKey = DEFAULT_CLIENT_KEY;
                                    if (!clientOptions.eventLoggingApi) clientOptions.eventLoggingApi = DEFAULT_EVENT_LOGGING_API;
                                    if (clientOptions.perimeter === PerimeterType.FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                    clientOptions.disableAllLogging = true;
                                    sdkKey = clientOptions.sdkKey;
                                    statsigOptions = this.toStatsigOptions(clientOptions, initializeValues);
                                    _context6.prev = 9;
                                    _context6.next = 12;
                                    return Statsig.initialize(sdkKey, user, statsigOptions);
                                case 12:
                                    _context6.next = 21;
                                    break;
                                case 14:
                                    _context6.prev = 14;
                                    _context6.t0 = _context6["catch"](9);
                                    if (_context6.t0 instanceof Error) // eslint-disable-next-line no-console
                                    console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context6.t0 === null || _context6.t0 === void 0 ? void 0 : _context6.t0.message));
                                    // eslint-disable-next-line no-console
                                    console.warn("Initialising Statsig client with default sdk key and without values");
                                    _context6.next = 20;
                                    return Statsig.initialize(DEFAULT_CLIENT_KEY, user, _objectSpread$1(_objectSpread$1({}, statsigOptions), {}, {
                                        initializeValues: {}
                                    }));
                                case 20:
                                    throw _context6.t0;
                                case 21:
                                case "end":
                                    return _context6.stop();
                            }
                        }, _callee6, this, [
                            [
                                9,
                                14
                            ]
                        ]);
                    }));
                    function initFromValues(_x15, _x16, _x17) {
                        return _initFromValues.apply(this, arguments);
                    }
                    return initFromValues;
                }()
            },
            {
                key: "toStatsigUser",
                value: function toStatsigUser(identifiers, customAttributes) {
                    var user = {
                        customIDs: identifiers,
                        custom: customAttributes
                    };
                    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
                    return user;
                }
            },
            {
                key: "updateUserUsingInitializeValuesProducer",
                value: function() {
                    var _updateUserUsingInitializeValuesProducer = _asyncToGenerator(/*#__PURE__*/ regenerator.mark(function _callee7(getInitializeValues, identifiers, customAttributes) {
                        var originalInitPromise, initializeValuesPromise, updateUserPromise;
                        return regenerator.wrap(function _callee7$(_context7) {
                            while(true)switch(_context7.prev = _context7.next){
                                case 0:
                                    if (FeatureGates.initPromise) {
                                        _context7.next = 2;
                                        break;
                                    }
                                    throw new Error("The FeatureGates client must be initialized before you can update the user.");
                                case 2:
                                    if (!FeatureGates.isCurrentUser(identifiers, customAttributes)) {
                                        _context7.next = 4;
                                        break;
                                    }
                                    return _context7.abrupt("return", FeatureGates.initPromise);
                                case 4:
                                    // Wait for the current initialize/update to finish
                                    originalInitPromise = FeatureGates.initPromise;
                                    _context7.prev = 5;
                                    _context7.next = 8;
                                    return FeatureGates.initPromise;
                                case 8:
                                    _context7.next = 12;
                                    break;
                                case 10:
                                    _context7.prev = 10;
                                    _context7.t0 = _context7["catch"](5);
                                case 12:
                                    initializeValuesPromise = getInitializeValues();
                                    updateUserPromise = FeatureGates.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this point.
                                    // Any subsequent calls to await FeatureGates.initialize() or FeatureGates.updateUser() will now also await this user update.
                                    FeatureGates.initPromise = updateUserPromise.catch(function() {
                                        // If the update failed then it changed nothing, so revert back to the original promise.
                                        FeatureGates.initPromise = originalInitPromise;
                                    });
                                    return _context7.abrupt("return", updateUserPromise);
                                case 16:
                                case "end":
                                    return _context7.stop();
                            }
                        }, _callee7, null, [
                            [
                                5,
                                10
                            ]
                        ]);
                    }));
                    function updateUserUsingInitializeValuesProducer(_x18, _x19, _x20) {
                        return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                    }
                    return updateUserUsingInitializeValuesProducer;
                }()
            },
            {
                key: "updateStatsigClientUser",
                value: function() {
                    var _updateStatsigClientUser = _asyncToGenerator(/*#__PURE__*/ regenerator.mark(function _callee8(initializeValuesPromise, identifiers, customAttributes) {
                        var initializeValues, user, _FeatureGates$initOpt2, _FeatureGates$initOpt3, errMsg, success;
                        return regenerator.wrap(function _callee8$(_context8) {
                            while(true)switch(_context8.prev = _context8.next){
                                case 0:
                                    _context8.prev = 0;
                                    _context8.next = 3;
                                    return initializeValuesPromise;
                                case 3:
                                    initializeValues = _context8.sent;
                                    user = FeatureGates.toStatsigUser(identifiers, initializeValues.customAttributesFromFetch);
                                    _context8.next = 12;
                                    break;
                                case 7:
                                    _context8.prev = 7;
                                    _context8.t0 = _context8["catch"](0);
                                    // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                    // This is not necessary for the updateUserWithValues call, because the Statsig client will already invoke the callback itself.
                                    errMsg = _context8.t0 instanceof Error ? _context8.t0.message : JSON.stringify(_context8.t0);
                                    (_FeatureGates$initOpt2 = (_FeatureGates$initOpt3 = FeatureGates.initOptions).updateUserCompletionCallback) === null || _FeatureGates$initOpt2 === void 0 || _FeatureGates$initOpt2.call(_FeatureGates$initOpt3, false, errMsg);
                                    throw _context8.t0;
                                case 12:
                                    success = Statsig.updateUserWithValues(user, initializeValues.experimentValues);
                                    if (!success) {
                                        _context8.next = 18;
                                        break;
                                    }
                                    FeatureGates.currentIdentifiers = identifiers;
                                    FeatureGates.currentAttributes = customAttributes;
                                    _context8.next = 19;
                                    break;
                                case 18:
                                    throw new Error("Failed to update user. An unexpected error occured.");
                                case 19:
                                case "end":
                                    return _context8.stop();
                            }
                        }, _callee8, null, [
                            [
                                0,
                                7
                            ]
                        ]);
                    }));
                    function updateStatsigClientUser(_x21, _x22, _x23) {
                        return _updateStatsigClientUser.apply(this, arguments);
                    }
                    return updateStatsigClientUser;
                }()
            },
            {
                key: "toStatsigOptions",
                value: function toStatsigOptions(options, initializeValues) {
                    options.sdkKey;
                    options.updateUserCompletionCallback;
                    options.perimeter;
                    var restClientOptions = _objectWithoutProperties(options, _excluded);
                    return _objectSpread$1(_objectSpread$1({}, restClientOptions), {}, {
                        initializeValues: initializeValues,
                        environment: {
                            tier: options.environment
                        },
                        disableCurrentPageLogging: true
                    }, options.updateUserCompletionCallback && {
                        updateUserCompletionCallback: FeatureGates.toStatsigUpdateUserCompletionCallback(options.updateUserCompletionCallback)
                    });
                }
            },
            {
                key: "toStatsigUpdateUserCompletionCallback",
                value: function toStatsigUpdateUserCompletionCallback(callback) {
                    /**
         * The duration passed to the callback indicates how long the update took, but it is deceptive since it only times the
         * Statsig code and doesn't account for all of the extra custom work we do to obtain the bootstrap values.
         * As a result, we just suppress this parameter in our own callback rather than trying to keep it accurate.
         */ return function(_duration, success, message) {
                        callback(success, message);
                    };
                }
            },
            {
                key: "shallowEquals",
                value: function shallowEquals(objectA, objectB) {
                    if (!objectA && !objectB) return true;
                    if (!objectA || !objectB) return false;
                    var aEntries = Object.entries(objectA);
                    var bEntries = Object.entries(objectB);
                    if (aEntries.length !== bEntries.length) return false;
                    var ascendingKeyOrder = function ascendingKeyOrder(_ref2, _ref3) {
                        var _ref4 = _slicedToArray(_ref2, 1), key1 = _ref4[0];
                        var _ref5 = _slicedToArray(_ref3, 1), key2 = _ref5[0];
                        return key1.localeCompare(key2);
                    };
                    aEntries.sort(ascendingKeyOrder);
                    bEntries.sort(ascendingKeyOrder);
                    for(var i = 0; i < aEntries.length; i++){
                        var _aEntries$i = _slicedToArray(aEntries[i], 2), aValue = _aEntries$i[1];
                        var _bEntries$i = _slicedToArray(bEntries[i], 2), bValue = _bEntries$i[1];
                        if (aValue !== bValue) return false;
                    }
                    return true;
                }
            },
            {
                key: "getPackageVersion",
                value: function getPackageVersion() {
                    return CLIENT_VERSION;
                }
            }
        ]);
        return FeatureGates;
    }();
    _defineProperty(FeatureGates, "initPromise", null);
    _defineProperty(FeatureGates, "initCompleted", false);
    _defineProperty(FeatureGates, "hasGetExperimentErrorOccurred", false);
    _defineProperty(FeatureGates, "hasGetExperimentValueErrorOccurred", false);
    _defineProperty(FeatureGates, "hasCheckGateErrorOccurred", false);
    var boundFGJS = FeatureGates;
    // This makes it possible to get a reference to the FeatureGates client at runtime.
    // This is important for overriding values in Cyprus tests, as there needs to be a
    // way to get the exact instance for a window in order to mock some of its methods.
    if (typeof window !== "undefined") {
        if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = FeatureGates;
        else {
            var _boundFGJS, _boundFGJS$getPackage;
            boundFGJS = window.__FEATUREGATES_JS__;
            var boundVersion = ((_boundFGJS = boundFGJS) === null || _boundFGJS === void 0 || (_boundFGJS$getPackage = _boundFGJS.getPackageVersion) === null || _boundFGJS$getPackage === void 0 ? void 0 : _boundFGJS$getPackage.call(_boundFGJS)) || "4.10.0 or earlier";
            if (boundVersion !== CLIENT_VERSION) {
                var message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat(boundVersion, " when module version ").concat(CLIENT_VERSION, " was loading.");
                // eslint-disable-next-line no-console
                console.warn(message);
            }
        }
    }
    /**
   * @property {FeatureGates} FeatureGate default export
   */ var FeatureGates$1 = boundFGJS;
    /**
   *
   * @param {string} key Key of the meta property to get
   * @returns {string=}
   */ var getMeta = function getMeta(key) {
        var metaTag = document.querySelector("meta[name='ajs-" + key + "']");
        return metaTag === null ? undefined : metaTag.getAttribute("content") || undefined;
    };
    function getBooleanFeatureFlagOld(flagName) {
        if (AJS && AJS.DarkFeatures && AJS.DarkFeatures.isEnabled && AJS.DarkFeatures.isEnabled(flagName)) return true;
        var flagContent = window.featureFlags || getMeta("fe-feature-flags");
        if (!flagContent) return false;
        var flagJson = {};
        try {
            flagJson = typeof flagContent === "object" ? flagContent : JSON.parse(flagContent);
        } catch (err) {
            return false;
        }
        if (!flagJson[flagName] || typeof flagJson[flagName].value !== "boolean") return false;
        return flagJson[flagName].value;
    }
    function getBooleanFeatureFlagStatsig(flagName) {
        if (FeatureGates$1.initializeCompleted()) return FeatureGates$1.checkGate(flagName);
        analytics$1.trackGasV3FeatureFlagDefaultFalse(flagName);
        console.error("[ACJS] Feature flag service is not initialised. Default flag '" + flagName + "' to false");
        return false;
    }
    function shouldAllowFeatureFlagsFromStatsig() {
        return getBooleanFeatureFlagOld("com.atlassian.connect.acjs.allow-statsig-ff");
    }
    /**
   * For all new feature flags, please create them in Statsig
   * https://hello.atlassian.net/wiki/spaces/ECO/pages/3707522428
   *
   * @param {string} flagName Feature flag name
   * @param {boolean} statsig Toggle for whether to fetch the feature flag from Statsig or LaunchDarkly.
   * @returns {boolean}
   */ function getBooleanFeatureFlag(flagName, statsig) {
        if (statsig === void 0) statsig = false;
        if (statsig && shouldAllowFeatureFlagsFromStatsig()) return getBooleanFeatureFlagStatsig(flagName);
        return getBooleanFeatureFlagOld(flagName);
    }
    function isSetBlockDisplayFlagEnabled() {
        return getBooleanFeatureFlag("com.atlassian.connect.acjs.onecloud-1878-set-block-display");
    }
    var Flags = {
        getBooleanFeatureFlag: getBooleanFeatureFlag,
        isSetBlockDisplayFlagEnabled: isSetBlockDisplayFlagEnabled
    };
    function shouldUseMutationObserverWebItems() {
        return getBooleanFeatureFlag("com.atlassian.connect.acjs.use-mutationobserver-for-connect-dialog-events") || isFixInlineDialogEvents();
    }
    function isFixInlineDialogEvents() {
        return getBooleanFeatureFlag("com.atlassian.connect.acjs.fix-connect-inlinedialog-breaking-after-first-display");
    }
    var performanceModuleDefined = false;
    var ADDON_KEY_CODEBARREL = "com.codebarrel.addons.automation";
    /**
   * This is a temporary module for Code Barrel that will be removed when no longer needed.
   */ function definePerformanceModule() {
        if (performanceModuleDefined) return;
        performanceModuleDefined = true;
        function isPerformanceModuleAllowed(cb) {
            return cb._context.extension.addon_key === ADDON_KEY_CODEBARREL;
        }
        var performanceModule = {
            /**
       * @see https://developer.mozilla.org/en-US/docs/web/api/performance/timing
       * @returns {Promise<PerformanceTiming>}
       */ getPerformanceTiming: function getPerformanceTiming(cb) {
                return new Promise(function(resolve, reject) {
                    if (!isPerformanceModuleAllowed(cb)) reject(new Error("This is a restricted API"));
                    // We need to parse + stringify otherwise we get an empty object
                    resolve(JSON.parse(JSON.stringify(window.performance.timing)));
                });
            },
            /**
       * @see https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming
       * @returns {Promise<PerformanceNavigationTiming[] | void>}
       */ getPerformanceNavigationTiming: function getPerformanceNavigationTiming(cb) {
                return new Promise(function(resolve, reject) {
                    if (!isPerformanceModuleAllowed(cb)) reject(new Error("This is a restricted API"));
                    if (!window.PerformanceNavigationTiming) resolve(undefined);
                    var timing = window.performance.getEntriesByType("navigation");
                    resolve(JSON.parse(JSON.stringify(timing)));
                });
            }
        };
        host$1.returnsPromise(performanceModule.getPerformanceTiming);
        host$1.returnsPromise(performanceModule.getPerformanceNavigationTiming);
        host$1.defineModule("_performance", performanceModule);
    }
    function isAllowListedFeatureFlag(flagName) {
        return flagName.indexOf("com.atlassian.connect.acjs.iframe.") === 0 || flagName.indexOf("acjs-iframe-allowlist-") === 0;
    }
    var defined = false;
    function defineFeatureFlagModule() {
        if (defined) return;
        defined = true;
        var featureFlagModule = {
            getBooleanFeatureFlag: function getBooleanFeatureFlag$1(flagName, statsig) {
                return new Promise(function(resolve, reject) {
                    if (!isAllowListedFeatureFlag(flagName)) {
                        reject(new Error("Only allowlisted flags can be accessed from the iframe."));
                        return;
                    }
                    resolve(getBooleanFeatureFlag(flagName, statsig));
                });
            }
        };
        host$1.returnsPromise(featureFlagModule.getBooleanFeatureFlag);
        host$1.defineModule("_featureFlag", featureFlagModule);
    }
    // nowhere better to put this. Wires an extension for oldschool and new enviroments
    function createSimpleXdmExtension(extension) {
        var extensionConfig = extensionConfigSanitizer(extension);
        var systemExtensionConfigOptions = ExtensionConfigurationOptionsStore$1.get();
        extension.options = extensionConfig.options = Util.extend({}, extensionConfig.options);
        extension.options.globalOptions = systemExtensionConfigOptions;
        loadConditionalModules(extension.addon_key);
        var iframeAttributes = host$1.create(extensionConfig, function() {
            if (!extension.options.noDOM) extension.$el = $(document.getElementById(extension.id));
            IframeActions.notifyBridgeEstablished(extension.$el, extension);
        }, function() {
            IframeActions.notifyUnloaded(extension.$el, extension);
        });
        // HostApi destroy is relying on previous behaviour of the
        // iframe component wherein it would call simpleXDM.create(extension)
        // and then mutate the extension object with the id returned from the
        // iframeAttributes see changes made in ACJS-760 and ACJS-807
        extensionConfig.id = iframeAttributes.id;
        extension.id = iframeAttributes.id;
        Util.extend(iframeAttributes, iframeUtils.optionsToAttributes(extension.options));
        return {
            iframeAttributes: iframeAttributes,
            extension: extension
        };
    }
    function extensionConfigSanitizer(extension) {
        return {
            addon_key: extension.addon_key,
            key: extension.key,
            url: extension.url,
            options: extension.options
        };
    }
    function loadConditionalModules(addonKey) {
        if (addonKey === ADDON_KEY_CODEBARREL) definePerformanceModule();
        defineFeatureFlagModule();
    }
    var simpleXdmUtils = {
        createSimpleXdmExtension: createSimpleXdmExtension,
        extensionConfigSanitizer: extensionConfigSanitizer
    };
    var Iframe = /*#__PURE__*/ function() {
        function Iframe() {
            this._contentResolver = false;
        }
        var _proto = Iframe.prototype;
        _proto.setContentResolver = function setContentResolver(callback) {
            this._contentResolver = callback;
        };
        _proto.resize = function resize(width, height, $el) {
            width = Util.stringToDimension(width);
            height = Util.stringToDimension(height);
            $el.css({
                width: width,
                height: height
            });
            $el.trigger("resized", {
                width: width,
                height: height
            });
        };
        _proto.simpleXdmExtension = function simpleXdmExtension(extension, $container) {
            if (!extension.url || urlUtils.hasJwt(extension.url) && urlUtils.isJwtExpired(extension.url)) {
                if (this._contentResolver) jwtActions.requestRefreshUrl({
                    extension: extension,
                    resolver: this._contentResolver,
                    $container: $container
                });
                else console.error("JWT is expired and no content resolver was specified");
            } else this._appendExtension($container, this._simpleXdmCreate(extension));
        };
        _proto._simpleXdmCreate = function _simpleXdmCreate(extension) {
            var simpleXdmAttributes = simpleXdmUtils.createSimpleXdmExtension(extension);
            extension.id = simpleXdmAttributes.iframeAttributes.id;
            extension.$el = this.render(simpleXdmAttributes.iframeAttributes);
            return extension;
        };
        _proto._appendExtension = function _appendExtension($container, extension) {
            var existingFrame = $container.find("iframe");
            if (existingFrame.length > 0) existingFrame.destroy();
            if (extension.options.hideIframeUntilLoad) extension.$el.css({
                visibility: "hidden"
            }).load(function() {
                extension.$el.css({
                    visibility: ""
                });
            });
            $container.prepend(extension.$el);
            IframeActions.notifyIframeCreated(extension.$el, extension);
        };
        _proto._appendExtensionError = function _appendExtensionError($container, text) {
            var $error = $('<div class="connect-resolve-error"></div>');
            var $additionalText = $("<p />").text(text);
            $error.append('<p class="error">Error: The content resolver threw the following error:</p>');
            $error.append($additionalText);
            $container.prepend($error);
        };
        _proto.resolverResponse = function resolverResponse(data) {
            var simpleExtension = this._simpleXdmCreate(data.extension);
            this._appendExtension(data.$container, simpleExtension);
        };
        _proto.resolverFailResponse = function resolverFailResponse(data) {
            this._appendExtensionError(data.$container, data.errorText);
        };
        _proto.render = function render(attributes) {
            attributes = attributes || {};
            attributes.referrerpolicy = "no-referrer";
            return $("<iframe />").attr(attributes).addClass("ap-iframe");
        };
        return Iframe;
    }();
    var IframeComponent = new Iframe();
    EventDispatcher$1.register("iframe-resize", function(data) {
        IframeComponent.resize(data.width, data.height, data.$el);
    });
    EventDispatcher$1.register("content-resolver-register-by-extension", function(data) {
        IframeComponent.setContentResolver(data.callback);
    });
    EventDispatcher$1.register("jwt-url-refreshed", function(data) {
        IframeComponent.resolverResponse(data);
    });
    EventDispatcher$1.register("jwt-url-refreshed-failed", function(data) {
        IframeComponent.resolverFailResponse(data);
    });
    EventDispatcher$1.register("after:iframe-bridge-established", function(data) {
        if (!data.extension.options.noDom) data.$el[0].bridgeEstablished = true;
        else data.extension.options.bridgeEstablished = true;
    });
    var ButtonActions = {
        clicked: function clicked($el) {
            EventDispatcher$1.dispatch("button-clicked", {
                $el: $el
            });
        },
        toggle: function toggle($el, disabled) {
            EventDispatcher$1.dispatch("button-toggle", {
                $el: $el,
                disabled: disabled
            });
        },
        toggleVisibility: function toggleVisibility($el, hidden) {
            EventDispatcher$1.dispatch("button-toggle-visibility", {
                $el: $el,
                hidden: hidden
            });
        }
    };
    var BUTTON_TYPES = [
        "primary",
        "link",
        "secondary"
    ];
    var buttonId = 0;
    var Button$1 = /*#__PURE__*/ function() {
        function Button() {
            this.AP_BUTTON_CLASS = "ap-aui-button";
        }
        var _proto = Button.prototype;
        _proto.setType = function setType($button, type) {
            if (type && BUTTON_TYPES.indexOf(type) >= 0) $button.addClass("aui-button-" + type);
            return $button;
        };
        _proto.setDisabled = function setDisabled($button, disabled) {
            if (typeof disabled !== "undefined" && !$button.data("immutable")) $button.attr("aria-disabled", disabled);
            return $button;
        };
        _proto.setHidden = function setHidden($button, hidden) {
            if (typeof hidden !== "undefined" && !$button.data("immutable")) $button.toggle(!hidden);
            return $button;
        };
        _proto._setId = function _setId($button, id) {
            if (!id) {
                id = "ap-button-" + buttonId;
                buttonId++;
            }
            $button.attr("id", id);
            return $button;
        };
        _proto._additionalClasses = function _additionalClasses($button, classes) {
            if (classes) {
                if (typeof classes !== "string") classes = classes.join(" ");
                $button.addClass(classes);
            }
            return $button;
        };
        _proto.getName = function getName($button) {
            return $($button).data("name");
        };
        _proto.getText = function getText($button) {
            return $($button).text();
        };
        _proto.getIdentifier = function getIdentifier($button) {
            return $($button).data("identifier");
        };
        _proto.isVisible = function isVisible($button) {
            return $($button).is(":visible");
        };
        _proto.isEnabled = function isEnabled($button) {
            return !($($button).attr("aria-disabled") === "true");
        };
        _proto.render = function render(options) {
            var $button = $("<button />");
            options = options || {};
            $button.addClass("aui-button " + this.AP_BUTTON_CLASS);
            $button.text(options.text);
            $button.data(options.data);
            $button.data({
                name: options.name || options.identifier,
                identifier: options.identifier || buttonUtilsInstance.randomIdentifier(),
                immutable: options.immutable || false
            });
            this._additionalClasses($button, options.additionalClasses);
            this.setType($button, options.type);
            this.setDisabled($button, options.disabled || false);
            this._setId($button, options.id);
            return $button;
        };
        return Button;
    }();
    var ButtonComponent = new Button$1();
    // register 1 button listener globally on dom load
    $(function() {
        $("body").on("click", "." + ButtonComponent.AP_BUTTON_CLASS, function(e) {
            var $button = $(e.target).closest("." + ButtonComponent.AP_BUTTON_CLASS);
            if ($button.attr("aria-disabled") !== "true") ButtonActions.clicked($button);
        });
    });
    EventDispatcher$1.register("button-toggle", function(data) {
        ButtonComponent.setDisabled(data.$el, data.disabled);
    });
    EventDispatcher$1.register("button-toggle-visibility", function(data) {
        ButtonComponent.setHidden(data.$el, data.hidden);
    });
    var CONTAINER_CLASSES = [
        "ap-iframe-container"
    ];
    var IframeContainer = /*#__PURE__*/ function() {
        function IframeContainer() {}
        var _proto = IframeContainer.prototype;
        _proto.createExtension = function createExtension(extension, options) {
            var $container = this._renderContainer();
            if (!options || options.loadingIndicator !== false) $container.append(this._renderLoadingIndicator());
            IframeComponent.simpleXdmExtension(extension, $container);
            return $container;
        };
        _proto._renderContainer = function _renderContainer(attributes) {
            var container = $("<div />").attr(attributes || {});
            container.addClass(CONTAINER_CLASSES.join(" "));
            return container;
        };
        _proto._renderLoadingIndicator = function _renderLoadingIndicator() {
            return LoadingComponent.render();
        };
        return IframeContainer;
    }();
    var IframeContainerComponent = new IframeContainer();
    EventDispatcher$1.register("iframe-create", function(data) {
        var id = "embedded-" + data.extension.id;
        data.extension.$el.parents(".ap-iframe-container").attr("id", id);
    });
    function create(extension) {
        return IframeContainerComponent.createExtension(extension);
    }
    var ModuleActions = {
        defineCustomModule: function defineCustomModule(name, methods) {
            var data = {};
            if (!methods) data.methods = name;
            else {
                data.methods = methods;
                data.name = name;
            }
            EventDispatcher$1.dispatch("module-define-custom", data);
        }
    };
    var AnalyticsAction = {
        trackDeprecatedMethodUsed: function trackDeprecatedMethodUsed(methodUsed, extension) {
            EventDispatcher$1.dispatch("analytics-deprecated-method-used", {
                methodUsed: methodUsed,
                extension: extension
            });
        },
        trackIframeBridgeStart: function trackIframeBridgeStart(extension) {
            EventDispatcher$1.dispatch("iframe-bridge-start", {
                extension: extension
            });
        },
        trackExternalEvent: function trackExternalEvent(name, values) {
            EventDispatcher$1.dispatch("analytics-external-event-track", {
                eventName: name,
                values: values
            });
        },
        trackContentResolverEvent: function trackContentResolverEvent(success, extra) {
            EventDispatcher$1.dispatch("analytics-content-resolver-track", {
                success: success,
                extra: extra
            });
        },
        trackIframePerformanceMetrics: function trackIframePerformanceMetrics(metrics, extension) {
            if (metrics && Object.getOwnPropertyNames(metrics).length > 0) EventDispatcher$1.dispatch("analytics-iframe-performance", {
                metrics: metrics,
                extension: extension
            });
        }
    };
    function _createForOfIteratorHelperLoose(o, allowArrayLike) {
        var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
        if (it) return (it = it.call(o)).next.bind(it);
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            return function() {
                if (i >= o.length) return {
                    done: true
                };
                return {
                    done: false,
                    value: o[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function sanitizeTriggers(triggers) {
        var onTriggers;
        if (Array.isArray(triggers)) onTriggers = triggers.join(" ");
        else if (typeof triggers === "string") onTriggers = triggers.trim();
        return onTriggers;
    }
    function uniqueId() {
        return "webitem-" + Math.floor(Math.random() * 1000000000).toString(16);
    }
    /**
   * LEGACY: get addon key by webitem for p2
   * @param {string} cssClass
   */ function getExtensionKey(cssClass) {
        var m = cssClass ? cssClass.match(/ap-plugin-key-([^\s]*)/) : null;
        return Array.isArray(m) ? m[1] : false;
    }
    /**
   * LEGACY: get module key by webitem for p2
   * @param {string} cssClass
  */ function getKey(cssClass) {
        var m = cssClass ? cssClass.match(/ap-module-key-([^\s]*)/) : null;
        return Array.isArray(m) ? m[1] : false;
    }
    /**
   * @param cssClass
   */ function getTargetKey(cssClass) {
        var m = cssClass ? cssClass.match(/ap-target-key-([^\s]*)/) : null;
        return Array.isArray(m) ? m[1] : false;
    }
    /**
   * @param cssClass
   * @returns {string}
   */ function getFullKey(cssClass) {
        return getExtensionKey(cssClass) + "__" + getKey(cssClass);
    }
    function getModuleOptionsByAddonAndModuleKey(type, addonKey, moduleKey) {
        var moduleType = type + "Modules";
        if (window._AP && window._AP[moduleType] && window._AP[moduleType][addonKey] && window._AP[moduleType][addonKey][moduleKey]) return Util.extend({}, window._AP[moduleType][addonKey][moduleKey].options);
    }
    /**
   * @param {string} type
   * @param {string} cssClass
   */ function getModuleOptionsForWebitem(type, cssClass) {
        var addon_key = getExtensionKey(cssClass);
        var targetKey = getTargetKey(cssClass);
        return getModuleOptionsByAddonAndModuleKey(type, addon_key, targetKey);
    }
    /**
   * gets the connect config from the encoded webitem target (via the url)
   * @param {JQuery} $target
   * @param {string} cssClass
   * @param {string|undefined} href
   */ // eslint-disable-next-line complexity
    function getConfigFromTarget($target, cssClass, href) {
        var url = href || $target.attr("href");
        var convertedOptions = {};
        var iframeData;
        // adg3 has classes outside of a tag so look for href inside the a
        if (!url) url = $target.find("a").attr("href");
        if (url) {
            var hashIndex = url.indexOf("#");
            if (hashIndex >= 0) {
                var hash = url.substring(hashIndex + 1);
                try {
                    iframeData = JSON.parse(decodeURI(hash));
                } catch (e) {
                    console.error("ACJS: cannot decode webitem anchor");
                }
                if (iframeData && window._AP && window._AP._convertConnectOptions) convertedOptions = window._AP._convertConnectOptions(iframeData);
                else console.error("ACJS: cannot convert webitem url to connect iframe options");
            } else {
                // The URL has no hash component so fall back to the old behaviour of providing:
                // add-on key, module key, dialog module options and product context (from the webitem url).
                // This may be the case for web items that were persisted prior to the new storage format whereby a hash
                // fragment is added into the URL detailing the target module info. If this info is
                // not present, the content resolver will be used to resolve the module after the web
                // item is clicked.
                // Old URL format detected. Falling back to old functionality
                var fullKey = getFullKey(cssClass);
                var type = isInlineDialogTrigger(cssClass) ? "inlineDialog" : "dialog";
                var options = getModuleOptionsForWebitem(type, cssClass);
                if (!options && window._AP && window._AP[type + "Options"]) options = Util.extend({}, window._AP[type + "Options"][fullKey]) || {};
                if (!options) {
                    options = {};
                    console.warn("no webitem " + type + "Options for " + fullKey);
                }
                options.productContext = options.productContext || {};
                var query = queryString.parse(queryString.extract(url));
                Util.extend(options.productContext, query);
                convertedOptions = {
                    addon_key: getExtensionKey(cssClass),
                    key: getKey(cssClass),
                    options: options
                };
            }
        }
        return convertedOptions;
    }
    /**
   * @param {string|string[]|null} classes
   * @returns {boolean}
   */ function isInlineDialogTrigger(classes) {
        return classes ? classes.includes("ap-inline-dialog") : false;
    }
    /**
   * @param {string|string[]|null} classes
   * @returns {boolean}
   */ function isDialogTrigger(classes) {
        return classes ? classes.includes("ap-dialog") : false;
    }
    /**
   * LEGACY - method for handling webitem options for p2
   * @param {JQuery} $target
   * @param {string} cssClass
   * @param {string|undefined} href
   */ function getOptionsForWebItem($target, cssClass, href) {
        var fullKey = getFullKey(cssClass);
        var type = isInlineDialogTrigger(cssClass) ? "inlineDialog" : "dialog";
        var options = getModuleOptionsForWebitem(type, cssClass);
        if (!options && window._AP && window._AP[type + "Options"]) options = Util.extend({}, window._AP[type + "Options"][fullKey]) || {};
        if (!options) {
            options = {};
            console.warn("no webitem " + type + "Options for " + fullKey);
        }
        options.productContext = options.productContext || {};
        options.structuredContext = options.structuredContext || {};
        // create product context from url params
        var convertedConfig = getConfigFromTarget($target, cssClass, href);
        if (convertedConfig && convertedConfig.options) {
            Util.extend(options.productContext, convertedConfig.options.productContext);
            Util.extend(options.structuredContext, convertedConfig.options.structuredContext);
            options.contextJwt = convertedConfig.options.contextJwt;
        }
        return options;
    }
    /**
   * @param {HTMLElement} target
   * @param {string[]} attributeNames
   * @returns {string[]}
   */ function collectParentElementAttributes(target, attributeNames) {
        // Collect attributes from parent elements of the webitem
        var attributes = [];
        var current = target;
        var count = 0;
        while(current && current !== document.body && count++ < 1000){
            for(var _iterator = _createForOfIteratorHelperLoose(attributeNames), _step; !(_step = _iterator()).done;){
                var attributeName = _step.value;
                var attribute = current.getAttribute(attributeName);
                if (attribute) attributes.push(attribute);
            }
            current = current.parentElement;
        }
        return attributes;
    }
    var WebItemUtils = {
        sanitizeTriggers: sanitizeTriggers,
        uniqueId: uniqueId,
        getExtensionKey: getExtensionKey,
        getKey: getKey,
        getOptionsForWebItem: getOptionsForWebItem,
        getModuleOptionsByAddonAndModuleKey: getModuleOptionsByAddonAndModuleKey,
        getConfigFromTarget: getConfigFromTarget
    };
    var ModuleProviders = function ModuleProviders() {
        var _this = this;
        this._providers = {};
        this.registerProvider = function(name, provider) {
            _this._providers[name] = provider;
        };
        this.getProvider = function(name) {
            return _this._providers[name];
        };
    };
    var ModuleProviders$1 = new ModuleProviders();
    // This is essentially a copy of the ACJSFrameworkAdaptor/BaseFrameworkAdaptor implementation generated
    // by compiling the connect-module-core typescript implementations of the equivalent classes.
    /**
   * This class provides common behaviour relating to the adaption of functionality to a
   * particular Connect client framework. This is necessary for an interim period during which
   * we have multiple Connect client frameworks that we need to support: ACJS and CaaS Client.
   */ var ACJSFrameworkAdaptor = function() {
        function ACJSFrameworkAdaptor() {
            this.moduleNamesToModules = new Map();
        }
        /**
     * This method registers a module with the Connect client framework relating to this adaptor instance.
     * @param moduleDefinition the definition of the module.
     */ ACJSFrameworkAdaptor.prototype.registerModule = function(module1, props) {
            var moduleRegistrationName = module1.getModuleRegistrationName();
            this.moduleNamesToModules.set(moduleRegistrationName, module1);
        // This adaptor implementation doesn't need to register the SimpleXDM definition so the following is
        // commented out.
        //
        // var simpleXdmDefinition = module.getSimpleXdmDefinition(props);
        // this.registerModuleWithHost(moduleRegistrationName, simpleXdmDefinition);
        };
        ACJSFrameworkAdaptor.prototype.getModuleByName = function(moduleName) {
            return this.moduleNamesToModules.get(moduleName);
        };
        ACJSFrameworkAdaptor.prototype.getProviderByModuleName = function(moduleName) {
            var module1 = this.moduleNamesToModules.get(moduleName);
            if (module1 && module1.isEnabled()) return module1.getProvider();
            else return undefined;
        };
        return ACJSFrameworkAdaptor;
    }();
    var acjsFrameworkAdaptor = new ACJSFrameworkAdaptor();
    /**
   * @typedef {{$target: JQuery, eventType: 'click' | 'mouseenter', extension: Object}} WebItemInvokedEventData
   */ var WebItemActions = {
        addWebItem: function addWebItem(potentialWebItem) {
            var webitem;
            var existing = webItemInstance.getWebItemsBySelector(potentialWebItem.selector);
            if (existing) return false;
            else {
                webitem = webItemInstance.setWebItem(potentialWebItem);
                EventDispatcher$1.dispatch("webitem-added", {
                    webitem: webitem
                });
            }
        },
        /**
     * @param {boolean} isInlineDialog
     * @param {WebItemInvokedEventData} data
     */ webitemInvoked: function webitemInvoked(isInlineDialog, data) {
            var eventName = isInlineDialog ? "inline-dialog" : "dialog";
            EventDispatcher$1.dispatch("webitem-invoked:" + eventName, data);
        }
    };
    var addedTriggersSet = new WeakSet();
    var WebItem = /*#__PURE__*/ function() {
        function WebItem() {
            this._webitems = {};
            this._contentResolver = function noop() {};
        }
        var _proto = WebItem.prototype;
        _proto.setContentResolver = function setContentResolver(resolver) {
            this._contentResolver = resolver;
        };
        _proto.requestContent = function requestContent(extension) {
            if (extension.addon_key && extension.key) return this._contentResolver.call(null, Util.extend({
                classifier: "json"
            }, extension));
        };
        _proto.getWebItemsBySelector = function getWebItemsBySelector(selector) {
            var _this = this;
            var returnVal;
            Object.getOwnPropertyNames(this._webitems).some(function(key) {
                var obj = _this._webitems[key];
                if (obj.selector) {
                    if (obj.selector.trim() === selector.trim()) {
                        returnVal = obj;
                        return true;
                    }
                }
                return false;
            });
            return returnVal;
        };
        _proto.setWebItem = function setWebItem(potentialWebItem) {
            return this._webitems[potentialWebItem.name] = {
                name: potentialWebItem.name,
                selector: potentialWebItem.selector,
                triggers: potentialWebItem.triggers
            };
        };
        _proto._removeTriggers = function _removeTriggers(webitem) {
            var _this2 = this;
            var onTriggers = WebItemUtils.sanitizeTriggers(webitem.triggers);
            $(function() {
                $("body").off(onTriggers, webitem.selector, _this2._webitems[webitem.name]._on);
            });
            delete this._webitems[webitem.name]._on;
        };
        _proto._addTriggers = function _addTriggers(webitem) {
            var onTriggers = WebItemUtils.sanitizeTriggers(webitem.triggers);
            /**
       * @param event {Event}
       */ webitem._on = function(event) {
                if (event.defaultPrevented) return;
                /** @type {JQuery} */ var $target = $(event.target).closest(webitem.selector);
                if ($target.hasClass("ap-dialog-ignore")) return;
                event.preventDefault();
                _triggerWebItem($target, event.type);
            };
            $(function() {
                if (shouldUseMutationObserverWebItems()) {
                    var attachHandlers = function attachHandlers(node) {
                        if (addedTriggersSet.has(node)) return;
                        addedTriggersSet.add(node);
                        $(node).on(onTriggers, webitem._on);
                    };
                    // First, add handlers for any nodes already in the document
                    document.querySelectorAll(webitem.selector).forEach(function(node) {
                        attachHandlers(node);
                    });
                    // Next, set up a MutationObserver to add handlers for any nodes added to the document later
                    var observer = new MutationObserver(function(mutationsList, observer) {
                        mutationsList.forEach(function(mutation) {
                            if (mutation.type !== "childList") return;
                            mutation.addedNodes.forEach(function(node) {
                                if (node.nodeType !== Node.ELEMENT_NODE) return;
                                if (node.matches(webitem.selector)) // The element is being added directly
                                attachHandlers(node);
                                else // We need to check children of the added node as well, because a whole subtree can be added at once
                                node.querySelectorAll(webitem.selector).forEach(function(childNode) {
                                    attachHandlers(childNode);
                                });
                            });
                        });
                    });
                    // Start observing the target node for configured mutations
                    observer.observe(document.body, {
                        childList: true,
                        subtree: true
                    });
                } else // Add a delegated handler to the body
                $("body").on(onTriggers, webitem.selector, webitem._on);
                $("head").append('<style type="text/css">' + webitem.selector + ".ap-link-webitem {pointer-events: auto;}</style>");
            });
        };
        return WebItem;
    }();
    /**
   * @param {Element} target  The webItem trigger element, used for relatively positioning the inline dialog popup.
   * @param {string|undefined} [cssClass] The webItem's class name as returned by the Connect plugin. Will be taken from the target if not provided.
   * @param {string|undefined} [href] The webItem's href as returned by the Connect plugin. Will be taken from the target if not provided.
   * @param {'click' | 'mouseenter'} [eventType] The trigger type that we want to invoke.
   */ function triggerWebItem(target, cssClass, href, eventType) {
        eventType = eventType || "click";
        var $target = $(target);
        cssClass = cssClass || $target.attr("class");
        // ACJS would only listen for events on these specific classes.
        // However, this function could be called for any webItem, even if it is not a dialog.
        // In that case, we should just do nothing and let the default link behaviour occur.
        if (!isDialogWebItem(cssClass) || eventType === "mouseenter" && !isInlineDialogTrigger(cssClass)) return;
        _triggerWebItem($target, eventType, cssClass, href, true);
    }
    /**
   * We export this function so that consumers can check if Connect will handle the event.
   * If so, they can prevent the default behaviour.
   * @param {string|string[]|null} classes
   * @returns {boolean}
   */ function isDialogWebItem(classes) {
        return isDialogTrigger(classes) || isInlineDialogTrigger(classes);
    }
    /**
   * @private
   * @param {JQuery} $target The webItem trigger element. It is expected to have an href or data-href property, and class names representing the trigger type (ap-dialog, ap-inline-dialog, etc).
   * @param {'click' | 'mouseenter'} eventType The trigger type that we want to invoke.
   * @param {string|undefined} [cssClass] The webItem's class name as returned by the Connect plugin.
   * @param {string|undefined} [href] The webItem's href as returned by the Connect plugin.
   * @param {boolean} isModernApi Whether this was triggered via the modern imperative API, used for analytics.
   */ function _triggerWebItem($target, eventType, cssClass, href, isModernApi) {
        cssClass = cssClass || $target.attr("class");
        isModernApi = isModernApi || false;
        var convertedOptions = WebItemUtils.getConfigFromTarget($target, cssClass, href);
        var extensionUrl = convertedOptions && convertedOptions.url ? convertedOptions.url : undefined;
        var extension = {
            addon_key: WebItemUtils.getExtensionKey(cssClass),
            key: WebItemUtils.getKey(cssClass),
            options: WebItemUtils.getOptionsForWebItem($target, cssClass, href),
            url: extensionUrl
        };
        if (extension.addon_key === "com.addonengine.analytics" && !HostApi$1.isModuleDefined("analytics")) {
            console.log("ACJS-1164 Dropping event " + eventType + " for plugin " + extension.addon_key + " until AP.analytics loads...");
            return;
        }
        var isInlineDialog = isInlineDialogTrigger(cssClass);
        if (!isModernApi) EventDispatcher$1.dispatch("analytics-legacy-dialog-opened", {
            extension: extension,
            eventType: eventType,
            parentIds: collectParentElementAttributes($target.get(0), [
                "data-testid",
                "data-component-selector",
                "data-fullscreen-id"
            ])
        });
        WebItemActions.webitemInvoked(isInlineDialog, {
            $target: $target,
            eventType: eventType,
            extension: extension
        });
    }
    var webItemInstance = new WebItem();
    EventDispatcher$1.register("webitem-added", function(data) {
        webItemInstance._addTriggers(data.webitem);
    });
    EventDispatcher$1.register("content-resolver-register-by-extension", function(data) {
        webItemInstance.setContentResolver(data.callback);
    });
    document.addEventListener("aui-responsive-menu-item-created", function(e) {
        var oldWebItem = e.detail.originalItem.querySelector('a[class*="ap-"]');
        if (oldWebItem) {
            var newWebItem = e.detail.newItem.querySelector("a");
            var classList = [].slice.call(oldWebItem.classList);
            classList.forEach(function(cls) {
                if (/^ap-/.test(cls)) newWebItem.classList.add(cls);
            });
        }
    });
    var HostApi = /*#__PURE__*/ function() {
        function HostApi() {
            var _this = this;
            this.targetSpecNoDialogs = EventActions.targetSpecNoDialogs;
            this.triggerWebItem = triggerWebItem;
            this.isDialogWebItem = isDialogWebItem;
            this.create = function(extension) {
                return create(simpleXdmUtils.extensionConfigSanitizer(extension));
            };
            this.dialog = {
                create: function create(extension, dialogOptions) {
                    var dialogBeanOptions = WebItemUtils.getModuleOptionsByAddonAndModuleKey("dialog", extension.addon_key, extension.key);
                    var completeOptions = Util.extend({}, dialogBeanOptions || {}, dialogOptions);
                    DialogExtensionActions.open(extension, completeOptions);
                },
                close: function close(addon_key, closeData) {
                    var frameworkAdaptor = _this.getFrameworkAdaptor();
                    var dialogProvider = frameworkAdaptor.getProviderByModuleName("dialog");
                    if (dialogProvider) {
                        dialogUtilsInstance.assertActiveDialogOrThrow(dialogProvider, addon_key);
                        EventActions.broadcast("dialog.close", {
                            addon_key: addon_key
                        }, closeData);
                        dialogProvider.close();
                    } else DialogExtensionActions.close();
                }
            };
            this.registerContentResolver = {
                // This function is not called when a product calls resolveByExtension
                // This is just a wrapper for ACJS to be able to call the product implementation
                // Calls from the product will bypass this method and call the product implementation directly
                resolveByExtension: function resolveByExtension(callback) {
                    _this._contentResolver = callback;
                    jwtActions.registerContentResolver({
                        callback: callback
                    });
                }
            };
            this.getContentResolver = function() {
                return _this._contentResolver;
            };
            this.registerProvider = function(componentName, component) {
                ModuleProviders$1.registerProvider(componentName, component);
            };
            this.getProvider = function(componentName) {
                return ModuleProviders$1.getProvider(componentName);
            };
            // We are attaching an instance of ACJSAdaptor to the host so that products are able
            // to retrieve the identical instance of ACJSAdaptor that ACJS is using.
            // The product can override the framework adaptor by calling setFrameworkAdaptor().
            this.frameworkAdaptor = acjsFrameworkAdaptor;
        }
        /**
    * creates an extension
    * returns an object with extension and iframe attributes
    * designed for use with non DOM implementations such as react.
    */ var _proto = HostApi.prototype;
        _proto.createExtension = function createExtension(extension) {
            extension.options = extension.options || {};
            extension.options.noDom = true;
            var createdExtension = simpleXdmUtils.createSimpleXdmExtension(extension);
            AnalyticsAction.trackIframeBridgeStart(createdExtension.extension);
            return createdExtension;
        } /**
     * registers an existing extension with this host
     * Used when the extension has been created by a sub host
     */ ;
        _proto.registerExistingExtension = function registerExistingExtension(extension_id, data) {
            return host$1.registerExistingExtension(extension_id, data);
        } /**
     * The product is responsible for setting the framework adaptor.
     * @param frameworkAdaptor the framework adaptor to use.
     */ ;
        _proto.setFrameworkAdaptor = function setFrameworkAdaptor(frameworkAdaptor) {
            this.frameworkAdaptor = frameworkAdaptor;
        };
        _proto.getFrameworkAdaptor = function getFrameworkAdaptor() {
            return this.frameworkAdaptor;
        };
        _proto._cleanExtension = function _cleanExtension(extension) {
            return Util.pick(extension, [
                "id",
                "addon_key",
                "key",
                "options",
                "url"
            ]);
        };
        _proto.onIframeEstablished = function onIframeEstablished(callback) {
            var wrapper = function wrapper(data) {
                callback.call({}, {
                    $el: data.$el,
                    extension: this._cleanExtension(data.extension)
                });
            };
            callback._wrapper = wrapper.bind(this);
            EventDispatcher$1.register("after:iframe-bridge-established", callback._wrapper);
        };
        _proto.offIframeEstablished = function offIframeEstablished(callback) {
            if (callback._wrapper) EventDispatcher$1.unregister("after:iframe-bridge-established", callback._wrapper);
            else throw new Error("cannot unregister event dispatch listener without _wrapper reference");
        };
        _proto.onIframeUnload = function onIframeUnload(callback) {
            var _this2 = this;
            EventDispatcher$1.register("after:iframe-unload", function(data) {
                callback.call({}, {
                    $el: data.$el,
                    extension: _this2._cleanExtension(data.extension)
                });
            });
        };
        _proto.onPublicEventDispatched = function onPublicEventDispatched(callback) {
            var wrapper = function wrapper(data) {
                callback.call({}, {
                    type: data.type,
                    event: data.event,
                    extension: this._cleanExtension(data.sender)
                });
            };
            callback._wrapper = wrapper.bind(this);
            EventDispatcher$1.register("after:event-public-dispatch", callback._wrapper);
        };
        _proto.offPublicEventDispatched = function offPublicEventDispatched(callback) {
            if (callback._wrapper) EventDispatcher$1.unregister("after:event-public-dispatch", callback._wrapper);
            else throw new Error("cannot unregister event dispatch listener without _wrapper reference");
        };
        _proto.onKeyEvent = function onKeyEvent(extension_id, key, modifiers, callback) {
            DomEventActions.registerKeyEvent({
                extension_id: extension_id,
                key: key,
                modifiers: modifiers,
                callback: callback
            });
        };
        _proto.offKeyEvent = function offKeyEvent(extension_id, key, modifiers, callback) {
            DomEventActions.unregisterKeyEvent({
                extension_id: extension_id,
                key: key,
                modifiers: modifiers,
                callback: callback
            });
        };
        _proto.onFrameClick = function onFrameClick(handleIframeClick) {
            if (typeof handleIframeClick !== "function") throw new Error("handleIframeClick must be a function");
            DomEventActions.registerClickHandler(handleIframeClick);
        };
        _proto.offFrameClick = function offFrameClick() {
            DomEventActions.unregisterClickHandler();
        };
        _proto.destroy = function destroy(extension_id) {
            IframeActions.notifyIframeDestroyed({
                id: extension_id
            });
        };
        _proto.defineModule = function defineModule(name, methods) {
            ModuleActions.defineCustomModule(name, methods);
        };
        _proto.isModuleDefined = function isModuleDefined(moduleName) {
            return host$1.isModuleDefined(moduleName);
        };
        _proto.broadcastEvent = function broadcastEvent(type, targetSpec, event) {
            EventActions.broadcast(type, targetSpec, event);
        };
        _proto.getExtensions = function getExtensions(filter) {
            return host$1.getExtensions(filter);
        };
        _proto.trackDeprecatedMethodUsed = function trackDeprecatedMethodUsed(methodUsed, extension) {
            AnalyticsAction.trackDeprecatedMethodUsed(methodUsed, extension);
        };
        _proto.trackAnalyticsEvent = function trackAnalyticsEvent(name, values) {
            AnalyticsAction.trackExternalEvent(name, values);
        };
        _proto.trackContentResolverEvent = function trackContentResolverEvent(success, extra) {
            AnalyticsAction.trackContentResolverEvent(success, extra);
        };
        _proto.setJwtClockSkew = function setJwtClockSkew(skew) {
            jwtActions.setClockSkew(skew);
        };
        _proto.isJwtExpired = function isJwtExpired(jwtString, tokenOnly) {
            if (tokenOnly) return jwtUtil.isJwtExpired(jwtString);
            return urlUtils.isJwtExpired(jwtString);
        };
        _proto.hasJwt = function hasJwt(url) {
            return urlUtils.hasJwt(url);
        };
        _proto.getBooleanFeatureFlag = function getBooleanFeatureFlag$1(flagName, statsig) {
            return getBooleanFeatureFlag(flagName, statsig);
        };
        _proto.setExtensionConfigurationOptions = function setExtensionConfigurationOptions(obj, value) {
            ExtensionConfigurationOptionsStore$1.set(obj, value);
        };
        _proto.getExtensionConfigurationOption = function getExtensionConfigurationOption(val) {
            return ExtensionConfigurationOptionsStore$1.get(val);
        };
        _proto.onIframeTimeout = function onIframeTimeout(callback) {
            var wrapper = function wrapper(data) {
                callback.call({}, {
                    extension: this._cleanExtension(data.extension)
                });
            };
            callback._wrapper = wrapper.bind(this);
            EventDispatcher$1.register("after:iframe-bridge-timeout", callback._wrapper);
        };
        _proto.offIframeTimeout = function offIframeTimeout(callback) {
            if (callback._wrapper) EventDispatcher$1.unregister("after:iframe-bridge-timeout", callback._wrapper);
            else throw new Error("cannot unregister event dispatch listener without _wrapper reference");
        };
        _proto.onIframePerformanceTelemetry = function onIframePerformanceTelemetry(callback) {
            var wrapper = function wrapper(data) {
                callback.call({}, {
                    metrics: data.metrics,
                    extension: this._cleanExtension(data.extension)
                });
            };
            callback._wrapper = wrapper.bind(this);
            EventDispatcher$1.register("after:analytics-iframe-performance", callback._wrapper);
        };
        _proto.offIframePerformanceTelemetry = function offIframePerformanceTelemetry(callback) {
            if (callback._wrapper) EventDispatcher$1.unregister("after:analytics-iframe-performance", callback._wrapper);
            else throw new Error("cannot unregister event dispatch listener without _wrapper reference");
        };
        _proto.onIframeVisible = function onIframeVisible(callback) {
            var wrapper = function wrapper(extension) {
                callback.call({}, {
                    extension: this._cleanExtension(extension)
                });
            };
            callback._wrapper = wrapper.bind(this);
            EventDispatcher$1.register("after:iframe-visible", callback._wrapper);
        };
        _proto.offIframeVisible = function offIframeVisible(callback) {
            if (callback._wrapper) EventDispatcher$1.unregister("after:iframe-visible", callback._wrapper);
            else throw new Error("cannot unregister event dispatch listener without _wrapper reference");
        };
        _proto.onContentResolverEvent = function onContentResolverEvent(callback) {
            var wrapper = function wrapper(data) {
                callback.call({}, data);
            };
            callback._wrapper = wrapper.bind(this);
            EventDispatcher$1.register("after:analytics-content-resolver-track", callback._wrapper);
        };
        _proto.offContentResolverEvent = function offContentResolverEvent(callback) {
            if (callback._wrapper) EventDispatcher$1.unregister("after:analytics-content-resolver-track", callback._wrapper);
            else throw new Error("cannot unregister event dispatch listener without _wrapper reference");
        };
        _proto.onForwardAnalyticsEvent = function onForwardAnalyticsEvent(callback) {
            var wrapper = function wrapper(eventType, eventData) {
                callback.call({}, eventType, eventData);
            };
            callback._wrapper = wrapper.bind(this);
            EventDispatcher$1.register("after:analytics-forward-event", callback._wrapper);
        };
        return HostApi;
    }();
    var HostApi$1 = new HostApi();
    var DLGID_PREFIX = "ap-dialog-";
    var DIALOG_CLASS = "ap-aui-dialog2";
    var DLGID_REGEXP = new RegExp("^" + DLGID_PREFIX + "[0-9A-Za-z]+$");
    var DIALOG_SIZES = [
        "small",
        "medium",
        "large",
        "xlarge",
        "fullscreen",
        "maximum"
    ];
    var DIALOG_BUTTON_CLASS = "ap-aui-dialog-button";
    var DIALOG_BUTTON_CUSTOM_CLASS = "ap-dialog-custom-button";
    var DIALOG_FOOTER_CLASS = "aui-dialog2-footer";
    var DIALOG_FOOTER_ACTIONS_CLASS = "aui-dialog2-footer-actions";
    var DIALOG_HEADER_ACTIONS_CLASS = "header-control-panel";
    function getActiveDialog() {
        var $el = AJS.LayerManager.global.getTopLayer();
        if ($el && DLGID_REGEXP.test($el.attr("id"))) {
            var dialog = AJS.dialog2($el);
            dialog._id = dialog.$el.attr("id").replace(DLGID_PREFIX, "");
            return dialog;
        }
    }
    function getActionBar($dialog) {
        var $actionBar = $dialog.find("." + DIALOG_HEADER_ACTIONS_CLASS);
        if (!$actionBar.length) $actionBar = $dialog.find("." + DIALOG_FOOTER_ACTIONS_CLASS);
        return $actionBar;
    }
    function getButtonByIdentifier(id, $dialog) {
        var $actionBar = getActionBar($dialog);
        return $actionBar.find(".aui-button").filter(function() {
            return ButtonComponent.getIdentifier(this) === id;
        });
    }
    var Dialog$1 = /*#__PURE__*/ function() {
        function Dialog() {}
        var _proto = Dialog.prototype;
        _proto._renderHeaderCloseBtn = function _renderHeaderCloseBtn() {
            var $close = $("<a />").addClass("aui-dialog2-header-close");
            var $closeBtn = $("<span />").addClass("aui-icon aui-icon-small aui-iconfont-close-dialog").text("Close");
            $close.append($closeBtn);
            return $close;
        };
        _proto._renderFullScreenHeader = function _renderFullScreenHeader($header, options) {
            var $titleContainer = $("<div />").addClass("header-title-container aui-item expanded");
            var $title = $("<div />").append($("<span />").addClass("header-title").text(options.header || ""));
            $titleContainer.append($title);
            $header.append($titleContainer).append(this._renderHeaderActions(options.actions, options.extension));
            return $header;
        };
        _proto._renderHeader = function _renderHeader(options) {
            var $header = $("<header />").addClass("aui-dialog2-header");
            if (options.size === "fullscreen") return this._renderFullScreenHeader($header, options);
            if (options.header) {
                var $title = $("<h2 />").addClass("aui-dialog2-header-main").text(options.header);
                $header.append($title);
            }
            $header.append(this._renderHeaderCloseBtn());
            return $header;
        };
        _proto._renderHeaderActions = function _renderHeaderActions(actions, extension) {
            var $headerControls = $("<div />").addClass("aui-item " + DIALOG_HEADER_ACTIONS_CLASS);
            actions[0].additionalClasses = [
                "aui-icon",
                "aui-icon-small",
                "aui-iconfont-success"
            ];
            actions[1].additionalClasses = [
                "aui-icon",
                "aui-icon-small",
                "aui-iconfont-close-dialog"
            ];
            var $actions = this._renderActionButtons(actions, extension);
            $actions.forEach(function($action) {
                $headerControls.append($action);
            });
            return $headerControls;
        };
        _proto._renderContent = function _renderContent($content) {
            var $el = $("<div />").addClass("aui-dialog2-content");
            if ($content) $el.append($content);
            return $el;
        };
        _proto._renderFooter = function _renderFooter(options) {
            var $footer = $("<footer />").addClass(DIALOG_FOOTER_CLASS);
            if (options.size !== "fullscreen") {
                var $actions = this._renderFooterActions(options.actions, options.extension);
                $footer.append($actions);
            }
            if (options.hint) {
                var $hint = $("<div />").addClass("aui-dialog2-footer-hint").text(options.hint);
                $footer.append($hint);
            }
            return $footer;
        };
        _proto._renderActionButtons = function _renderActionButtons(actions, extension) {
            var _this = this;
            var actionButtons = [];
            [].concat(actions).forEach(function(action) {
                actionButtons.push(_this._renderDialogButton({
                    text: action.text,
                    name: action.name,
                    type: action.type,
                    additionalClasses: action.additionalClasses,
                    custom: action.custom || false,
                    identifier: action.identifier,
                    immutable: action.immutable,
                    disabled: action.disabled || false
                }, extension));
            });
            return actionButtons;
        };
        _proto._renderFooterActions = function _renderFooterActions(actions, extension) {
            var $actions = $("<div />").addClass(DIALOG_FOOTER_ACTIONS_CLASS);
            var $buttons = this._renderActionButtons(actions, extension);
            $buttons.forEach(function($button) {
                $actions.append($button);
            });
            return $actions;
        };
        _proto._renderDialogButton = function _renderDialogButton(options, extension) {
            options.additionalClasses = options.additionalClasses || [];
            options.additionalClasses.push(DIALOG_BUTTON_CLASS);
            if (options.custom) options.additionalClasses.push(DIALOG_BUTTON_CUSTOM_CLASS);
            var $button = ButtonComponent.render(options);
            $button.extension = extension;
            return $button;
        } /**
    {
      id: 'some-dialog-id',
      title: 'some header',
      hint: 'some footer hint',
      $content: $(<div />).text('my content'),
      actions: []
    }
    **/ ;
        _proto.render = function render(options) {
            var originalOptions = Util.extend({}, options);
            var sanitizedOptions = dialogUtilsInstance.sanitizeOptions(options);
            var $dialog = $("<section />").attr({
                role: "dialog",
                id: DLGID_PREFIX + sanitizedOptions.id
            });
            $dialog.attr("data-aui-modal", "true");
            $dialog.data({
                "aui-remove-on-hide": true,
                "extension": sanitizedOptions.extension
            });
            $dialog.addClass("aui-layer aui-dialog2 " + DIALOG_CLASS);
            if (DIALOG_SIZES.indexOf(sanitizedOptions.size) >= 0) $dialog.addClass("aui-dialog2-" + sanitizedOptions.size);
            if (sanitizedOptions.size === "fullscreen" || sanitizedOptions.size === "maximum") {
                if (sanitizedOptions.chrome) $dialog.addClass("ap-header-controls");
                $dialog.addClass("aui-dialog2-maximum");
            }
            $dialog.append(this._renderContent(sanitizedOptions.$content));
            if (sanitizedOptions.chrome) {
                $dialog.prepend(this._renderHeader({
                    header: sanitizedOptions.header,
                    actions: sanitizedOptions.actions,
                    size: sanitizedOptions.size
                }));
                $dialog.append(this._renderFooter({
                    extension: sanitizedOptions.extension,
                    actions: sanitizedOptions.actions,
                    hint: sanitizedOptions.hint,
                    size: sanitizedOptions.size
                }));
            } else $dialog.addClass("aui-dialog2-chromeless");
            var dialog = AJS.dialog2($dialog);
            dialog._id = sanitizedOptions.id;
            if (sanitizedOptions.size === "fullscreen") sanitizedOptions.height = sanitizedOptions.width = "100%";
            if (!sanitizedOptions.size || sanitizedOptions.size === "fullscreen") AJS.layer($dialog).changeSize(sanitizedOptions.width, sanitizedOptions.height);
            if (sanitizedOptions.onHide) dialog.on("hide", sanitizedOptions.onHide);
            dialog.show();
            dialog.$el.data("extension", sanitizedOptions.extension);
            dialog.$el.data("originalOptions", originalOptions);
            return $dialog;
        };
        _proto.setIframeDimensions = function setIframeDimensions($iframe) {
            IframeComponent.resize("100%", "100%", $iframe);
        };
        _proto.getActive = function getActive() {
            return getActiveDialog();
        };
        _proto.buttonIsEnabled = function buttonIsEnabled(identifier) {
            var dialog = getActiveDialog();
            if (dialog) {
                var $button = getButtonByIdentifier(identifier, dialog.$el);
                return ButtonComponent.isEnabled($button);
            }
        };
        _proto.buttonIsVisible = function buttonIsVisible(identifier) {
            var dialog = getActiveDialog();
            if (dialog) {
                var $button = getButtonByIdentifier(identifier, dialog.$el);
                return ButtonComponent.isVisible($button);
            }
        } /**
    * takes either a target spec or a filter function
    * returns all matching dialogs
    */ ;
        _proto.getByExtension = function getByExtension(extension) {
            var filterFunction;
            if (typeof extension === "function") filterFunction = extension;
            else {
                var keys = Object.getOwnPropertyNames(extension);
                filterFunction = function filterFunction(dialog) {
                    var dialogData = $(dialog).data("extension");
                    return keys.every(function(key) {
                        return dialogData[key] === extension[key];
                    });
                };
            }
            return $("." + DIALOG_CLASS).toArray().filter(filterFunction).map(function($el) {
                return AJS.dialog2($el);
            });
        };
        _proto.addButton = function addButton(extension, options) {
            options.custom = true;
            var $button = this._renderDialogButton(options, extension);
            var $dialog = this.getByExtension({
                addon_key: extension.addon_key,
                key: extension.key
            })[0].$el;
            var $actionBar = getActionBar($dialog);
            $actionBar.append($button);
            return $dialog;
        };
        return Dialog;
    }();
    var DialogComponent = new Dialog$1();
    EventDispatcher$1.register("iframe-bridge-established", function(data) {
        if (data.extension.options.isDialog) {
            var callback;
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dialogProvider = frameworkAdaptor.getProviderByModuleName("dialog");
            if (dialogProvider) {
                callback = dialogProvider.close;
                dialogProvider.setButtonDisabled("submit", false);
            } else {
                DialogActions.toggleButton({
                    identifier: "submit",
                    enabled: true
                });
                callback = function callback() {
                    DialogActions.close({
                        dialog: getActiveDialog(),
                        extension: data.extension
                    });
                };
            }
            if (!data.extension.options.preventDialogCloseOnEscape) {
                DomEventActions.registerKeyEvent({
                    extension_id: data.extension.id,
                    key: 27,
                    callback: callback
                });
                EventDispatcher$1.registerOnce("dialog-close", function(d) {
                    DomEventActions.unregisterKeyEvent({
                        extension_id: data.extension.id,
                        key: 27
                    });
                });
            }
        }
    });
    EventDispatcher$1.register("dialog-close-active", function(data) {
        var activeDialog = getActiveDialog();
        if (activeDialog) DialogActions.close({
            customData: data.customData,
            dialog: activeDialog,
            extension: data.extension
        });
    });
    EventDispatcher$1.register("dialog-close", function(data) {
        if (data.dialog) data.dialog.hide();
    });
    EventDispatcher$1.register("dialog-button-toggle", function(data) {
        var dialog = getActiveDialog();
        if (dialog) {
            var $button = getButtonByIdentifier(data.identifier, dialog.$el);
            ButtonActions.toggle($button, !data.enabled);
        }
    });
    EventDispatcher$1.register("dialog-button-toggle-visibility", function(data) {
        var dialog = getActiveDialog();
        if (dialog) {
            var $button = getButtonByIdentifier(data.identifier, dialog.$el);
            ButtonActions.toggleVisibility($button, data.hidden);
        }
    });
    EventDispatcher$1.register("button-clicked", function(data) {
        var $button = data.$el;
        if ($button.hasClass(DIALOG_BUTTON_CLASS)) {
            var $dialog = $button.parents("." + DIALOG_CLASS);
            var $iframe = $dialog.find("iframe");
            if ($iframe.length && $iframe[0].bridgeEstablished) DialogActions.clickButton(ButtonComponent.getIdentifier($button), $button, $dialog.data("extension"));
            else DialogActions.close({
                dialog: getActiveDialog(),
                extension: $button.extension
            });
        }
    });
    if ($.fn) {
        EventDispatcher$1.register("iframe-create", function(data) {
            if (data.extension.options && data.extension.options.isDialog) DialogComponent.setIframeDimensions(data.extension.$el);
        });
        EventDispatcher$1.register("dialog-button-add", function(data) {
            DialogComponent.addButton(data.extension, data.button);
        });
        EventDispatcher$1.register("host-window-resize", Util.debounce(function() {
            $("." + DIALOG_CLASS).each(function(i, dialog) {
                var $dialog = $(dialog);
                var sanitizedOptions = dialogUtilsInstance.sanitizeOptions($dialog.data("originalOptions"));
                dialog.style.width = sanitizedOptions.width;
                dialog.style.height = sanitizedOptions.height;
            });
        }, 100));
    }
    DomEventActions.registerWindowKeyEvent({
        keyCode: 27,
        callback: function callback() {
            DialogActions.closeActive({
                customData: {},
                extension: null
            });
        }
    });
    function getAccessNarrowingSpaceContext(extension) {
        var _AJS;
        if (extension != null && extension.options && (_AJS = AJS) != null && (_AJS = _AJS.Meta) != null && _AJS.get) {
            var productContext = _extends({}, extension.options.productContext || {});
            if (AJS.Meta.get("space-key")) productContext["an.spaceKey"] = AJS.Meta.get("space-key");
            return _extends({}, extension, {
                options: _extends({}, extension.options, {
                    productContext: productContext
                })
            });
        }
        return extension;
    }
    var DialogExtension = /*#__PURE__*/ function() {
        function DialogExtension() {}
        var _proto = DialogExtension.prototype;
        _proto.render = function render(extension, dialogOptions) {
            extension.options = extension.options || {};
            dialogOptions = dialogOptions || {};
            extension.options.isDialog = true;
            extension.options.dialogId = dialogOptions.id;
            extension.options.callbackExtensionId = extension.callback_extension_id;
            extension.options.preventDialogCloseOnEscape = dialogOptions.closeOnEscape === false;
            extension.options.hostFrameOffset = dialogOptions.hostFrameOffset;
            extension.options.hideIframeUntilLoad = true;
            var $iframeContainer = IframeContainerComponent.createExtension(extension);
            var $dialog = DialogComponent.render({
                extension: extension,
                $content: $iframeContainer,
                chrome: dialogOptions.chrome,
                width: dialogOptions.width,
                height: dialogOptions.height,
                size: dialogOptions.size,
                header: dialogOptions.header,
                hint: dialogOptions.hint,
                submitText: dialogOptions.submitText,
                cancelText: dialogOptions.cancelText,
                buttons: dialogOptions.buttons,
                onHide: dialogOptions.onHide
            });
            return $dialog;
        };
        _proto.getActiveDialog = function getActiveDialog() {
            return DialogComponent.getActive();
        };
        _proto.buttonIsEnabled = function buttonIsEnabled(identifier) {
            return DialogComponent.buttonIsEnabled(identifier);
        };
        _proto.buttonIsVisible = function buttonIsVisible(identifier) {
            return DialogComponent.buttonIsVisible(identifier);
        };
        _proto.getByExtension = function getByExtension(extension) {
            if (typeof extension === "string") extension = {
                id: extension
            };
            return DialogComponent.getByExtension(extension);
        };
        return DialogExtension;
    }();
    var DialogExtensionComponent = new DialogExtension();
    EventDispatcher$1.register("dialog-extension-open", function(data) {
        var dialogExtension = getAccessNarrowingSpaceContext(data.extension);
        var dialogOptions = dialogUtilsInstance.sanitizeOptions(data.options);
        var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
        var dialogProvider = frameworkAdaptor.getProviderByModuleName("dialog");
        if (dialogProvider) {
            // this function should move.
            var getOnClickFunction = function getOnClickFunction(action) {
                var key = dialogExtension.key;
                var addon_key = dialogExtension.addon_key;
                var eventData = {
                    button: {
                        identifier: action.identifier,
                        name: action.identifier,
                        text: action.text
                    }
                };
                if ([
                    "submit",
                    "cancel"
                ].indexOf(action.identifier) >= 0) EventActions.broadcast("dialog." + action.identifier, {
                    addon_key: addon_key,
                    key: key
                }, eventData);
                EventActions.broadcast("dialog.button.click", {
                    addon_key: addon_key,
                    key: key
                }, eventData);
            };
            dialogExtension.options.preventDialogCloseOnEscape = dialogOptions.closeOnEscape === false;
            dialogOptions.actions.map(function(action) {
                return action.onClick = getOnClickFunction.bind(null, action);
            });
            dialogProvider.create(dialogOptions, dialogExtension);
        } else DialogExtensionComponent.render(dialogExtension, data.options);
    });
    var _dialogs = {};
    EventDispatcher$1.register("dialog-close", function(data) {
        var dialog = data.dialog;
        if (dialog && data.extension) {
            var targetSpec = {
                addon_key: data.extension.addon_key,
                id: data.extension.options.callbackExtensionId
            };
            EventActions.broadcast("dialog.close", targetSpec, data.customData);
        }
    });
    EventDispatcher$1.register("dialog-button-click", function(data) {
        var eventData = {
            button: {
                name: ButtonComponent.getName(data.$el),
                identifier: ButtonComponent.getIdentifier(data.$el),
                text: ButtonComponent.getText(data.$el)
            }
        };
        var eventName = "dialog.button.click";
        var buttonEventFilter = {
            addon_key: data.extension.addon_key,
            key: data.extension.key
        };
        buttonEventFilter.id = data.extension.id;
        // Old buttons, (submit and cancel) use old events
        if (!data.$el.hasClass("ap-dialog-custom-button")) EventActions.broadcast("dialog." + eventData.button.name, buttonEventFilter, eventData);
        EventActions.broadcast(eventName, buttonEventFilter, eventData);
    });
    /**
   * @class Dialog~Dialog
   * @description A dialog object that is returned when a dialog is created using the [dialog module](module-Dialog.html).
   */ var Dialog = function Dialog(options, callback) {
        callback = Util.last(arguments);
        var _id = callback._id;
        var extension = callback._context.extension;
        var dialogExtension = {
            addon_key: extension.addon_key,
            key: options.key,
            options: Util.pick(extension.options, [
                "customData",
                "productContext"
            ]),
            callback_extension_id: extension.id
        };
        // ACJS-185: the following is a really bad idea but we need it
        // for compat until AP.dialog.customData has been deprecated
        dialogExtension.options.customData = options.customData;
        // terrible idea! - we need to remove this from p2 ASAP!
        var dialogModuleOptions = dialogUtilsInstance.moduleOptionsFromGlobal(dialogExtension.addon_key, dialogExtension.key);
        // There is a hostFrameOffset configuration available
        // for modals (window._AP.dialogOptions) and inline modals (window._AP.inlineDialogOptions)
        // which is taken into account during the iframe insertion (inside the dialog).
        // The change below injects hostFrameOffset value from the global module options (window._AP.dialogModules)
        // which is required for establishing a contact with a correct host (solves spa iframe problem).
        if (typeof (dialogModuleOptions || {}).hostFrameOffset === "number") dialogExtension.options.hostFrameOffset = dialogModuleOptions.hostFrameOffset;
        options = Util.extend({}, dialogModuleOptions || {}, options);
        options.id = _id;
        dialogUtilsInstance.trackMultipleDialogOpening(dialogExtension, options);
        DialogExtensionActions.open(dialogExtension, options);
        this.customData = options.customData;
        _dialogs[_id] = this;
    } /**
   * Registers a callback for a dialog event.
   * @method on
   * @memberOf Dialog~Dialog
   * @param {String} event The dialog event to listen for. Valid options are "close".
   * @param {Function} callback The function to be invoked.
   * @noDemo
   * @example
   * AP.dialog.create({
   *   key: 'my-module-key'
   * }).on("close", function() {
   *   console.log("Dialog was closed");
   * });
   */ ;
    /**
   * @class Dialog~DialogButton
   * @description A dialog button that can be controlled with JavaScript
   */ var Button = /*#__PURE__*/ function() {
        function Button(identifier, callback) {
            callback = Util.last(arguments);
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dialogProvider = frameworkAdaptor.getProviderByModuleName("dialog");
            if (dialogProvider) {
                dialogUtilsInstance.assertActiveDialogOrThrow(dialogProvider, callback._context.extension.addon_key);
                this.name = identifier;
                this.identifier = identifier;
            } else {
                if (!DialogExtensionComponent.getActiveDialog()) throw new Error("Failed to find an active dialog.");
                this.name = identifier;
                this.identifier = identifier;
                this.enabled = DialogExtensionComponent.buttonIsEnabled(identifier);
                this.hidden = !DialogExtensionComponent.buttonIsVisible(identifier);
            }
        }
        /**
     * Sets the button state to enabled
     * @method enable
     * @memberOf Dialog~DialogButton
     * @noDemo
     * @example
     * AP.dialog.getButton('submit').enable();
     */ var _proto = Button.prototype;
        _proto.enable = function enable() {
            this.setState({
                enabled: true
            });
        } /**
     * Sets the button state to disabled. A disabled button cannot be clicked and emits no events.
     * @method disable
     * @memberOf Dialog~DialogButton
     * @noDemo
     * @example
     * AP.dialog.getButton('submit').disable();
     */ ;
        _proto.disable = function disable() {
            this.setState({
                enabled: false
            });
        } /**
     * Query a button for its current state.
     * @method isEnabled
     * @memberOf Dialog~DialogButton
     * @param {Function} callback function to receive the button state.
     * @noDemo
     * @example
     * AP.dialog.getButton('submit').isEnabled(function(enabled){
     *   if(enabled){
     *     //button is enabled
     *   }
     * });
     */ ;
        _proto.isEnabled = function isEnabled(callback) {
            callback = Util.last(arguments);
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dialogProvider = frameworkAdaptor.getProviderByModuleName("dialog");
            if (dialogProvider) callback(!dialogProvider.isButtonDisabled(this.identifier));
            else callback(this.enabled);
        } /**
     * Toggle the button state between enabled and disabled.
     * @method toggle
     * @memberOf Dialog~DialogButton
     * @noDemo
     * @example
     * AP.dialog.getButton('submit').toggle();
     */ ;
        _proto.toggle = function toggle() {
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dialogProvider = frameworkAdaptor.getProviderByModuleName("dialog");
            if (dialogProvider) dialogProvider.toggleButton(this.identifier);
            else this.setState({
                enabled: !this.enabled
            });
        };
        _proto.setState = function setState(state) {
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dialogProvider = frameworkAdaptor.getProviderByModuleName("dialog");
            if (dialogProvider) dialogProvider.setButtonDisabled(this.identifier, !state.enabled);
            else {
                this.enabled = state.enabled;
                DialogActions.toggleButton({
                    identifier: this.identifier,
                    enabled: this.enabled
                });
            }
        } /**
     * Trigger a callback bound to a button.
     * @method trigger
     * @memberOf Dialog~DialogButton
     * @noDemo
     * @example
     * AP.dialog.getButton('submit').bind(function(){
     *   alert('clicked!');
     * });
     * AP.dialog.getButton('submit').trigger();
     */ ;
        _proto.trigger = function trigger(callback) {
            callback = Util.last(arguments);
            if (this.enabled) DialogActions.dialogMessage({
                name: this.name,
                extension: callback._context.extension
            });
        } /**
     * Query a button for its current hidden/visible state.
     * @method isHidden
     * @memberOf Dialog~DialogButton
     * @param {Function} callback function to receive the button state.
     * @noDemo
     * @example
     * AP.dialog.getButton('submit').isHidden(function(hidden){
     *   if(hidden){
     *     //button is hidden
     *   }
     * });
     */ ;
        _proto.isHidden = function isHidden(callback) {
            callback = Util.last(arguments);
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dialogProvider = frameworkAdaptor.getProviderByModuleName("dialog");
            if (dialogProvider) callback(dialogProvider.isButtonHidden(this.identifier));
            else callback(this.hidden);
        } /**
     * Sets the button state to hidden
     * @method hide
     * @memberOf Dialog~DialogButton
     * @noDemo
     * @example
     * AP.dialog.getButton('submit').hide();
     */ ;
        _proto.hide = function hide() {
            this.setHidden(true);
        } /**
     * Sets the button state to visible
     * @method show
     * @memberOf Dialog~DialogButton
     * @noDemo
     * @example
     * AP.dialog.getButton('submit').show();
     */ ;
        _proto.show = function show() {
            this.setHidden(false);
        };
        _proto.setHidden = function setHidden(hidden) {
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dialogProvider = frameworkAdaptor.getProviderByModuleName("dialog");
            if (dialogProvider) dialogProvider.setButtonHidden(this.identifier, hidden);
            else {
                this.hidden = hidden;
                DialogActions.toggleButtonVisibility({
                    identifier: this.identifier,
                    hidden: this.hidden
                });
            }
        };
        return Button;
    }();
    function getDialogFromContext(context) {
        return _dialogs[context.extension.options.dialogId];
    }
    var CreateButton = function CreateButton(options, callback) {
        callback = Util.last(arguments);
        var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
        var dialogProvider = frameworkAdaptor.getProviderByModuleName("dialog");
        if (dialogProvider) {
            dialogUtilsInstance.assertActiveDialogOrThrow(dialogProvider, callback._context.extension.addon_key);
            dialogProvider.createButton({
                identifier: options.identifier,
                text: options.text,
                hidden: false,
                disabled: options.disabled || false,
                onClick: function onClick() {
                    EventActions.broadcast("dialog.button.click", {
                        addon_key: callback._context.extension.addon_key,
                        key: callback._context.extension.key
                    }, {
                        button: {
                            identifier: options.identifier,
                            text: options.text
                        }
                    });
                }
            });
        } else DialogExtensionActions.addUserButton({
            identifier: options.identifier,
            text: options.text
        }, callback._context.extension);
    };
    /**
   * The Dialog module provides a mechanism for launching an add-on's modules as modal dialogs from within an add-on's iframe.
   *
   * A modal dialog displays information without requiring the user to leave the current page.
   *
   * The dialog is opened over the entire window, rather than within the iframe itself.
   *
   * <h3>Styling your dialog to look like a standard Atlassian dialog</h3>
   *
   * By default the dialog iframe is undecorated. It's up to you to style the dialog.
   * <img src="/cloud/connect/images/connectdialogchromelessexample.jpeg" width="100%" />
   *
   * In order to maintain a consistent look and feel between the host application and the add-on, we encourage you to style your dialogs to match Atlassian's Design Guidelines for modal dialogs.
   *
   * To do that, you'll need to add the AUI styles to your dialog.
   *
   * For more information, read about the Atlassian User Interface [dialog component](https://docs.atlassian.com/aui/latest/docs/dialog2.html).
   * @exports Dialog
   */ var dialog = {
        /**
     * @class Dialog~DialogOptions
     * @description The options supplied to a [dialog.create()](module-Dialog.html) call.
     *
     * @property {String}        key         The module key of a dialog, or the key of a page or web-item that you want to open as a dialog.
     * @property {String}        size        Opens the dialog at a preset size: small, medium, large, x-large or fullscreen (with chrome).
     * @property {Number|String} width       if size is not set, define the width as a percentage (append a % to the number) or pixels.
     * @property {Number|String} height      if size is not set, define the height as a percentage (append a % to the number) or pixels.
     * @property {Boolean}       chrome      (optional) opens the dialog with heading and buttons.
     * @property {String}        header      (optional) text to display in the header if opening a dialog with chrome.
     * @property {String}        submitText  (optional) text for the submit button if opening a dialog with chrome.
     * @property {String}        cancelText  (optional) text for the cancel button if opening a dialog with chrome.
     * @property {Object}        customData  (optional) custom data object that can be accessed from the actual dialog iFrame.
     * @property {Boolean}       closeOnEscape (optional) if true, pressing ESC inside the dialog will close the dialog (default is true).
     * @property {Array}         buttons     (optional) an array of custom buttons to be added to the dialog if opening a dialog with chrome.
     * @property {String}        hint        (optional) Suggested actions or helpful info that will be added to the dialog if opening with chrome.
     */ /**
     * Creates a dialog for a common dialog, page or web-item module key.
     * @param {Dialog~DialogOptions} options configuration object of dialog options.
     * @method create
     * @noDemo
     * @example
     * AP.dialog.create({
     *   key: 'my-module-key',
     *   width: '500px',
     *   height: '200px',
     *   chrome: true,
     *   buttons: [
     *     {
     *       text: 'my button',
     *       identifier: 'my_unique_identifier'
     *     }
     *   ]
     * }).on("close", callbackFunc);
     *
     * @return {Dialog~Dialog} Dialog object allowing for callback registrations
     */ create: {
            constructor: Dialog
        },
        /**
     * Closes the currently open dialog. Optionally pass data to listeners of the `dialog.close` event.
     * This will only close a dialog that has been opened by your add-on.
     * You can register for close events using the `dialog.close` event and the [events module](../events/).
     * @param {Object} data An object to be emitted on dialog close.
     * @noDemo
     * @example
     * AP.dialog.close({foo: 'bar'});
     */ close: function close(data, callback) {
            callback = Util.last(arguments);
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dialogProvider = frameworkAdaptor.getProviderByModuleName("dialog");
            if (dialogProvider) {
                dialogUtilsInstance.assertActiveDialogOrThrow(dialogProvider, callback._context.extension.addon_key);
                EventActions.broadcast("dialog.close", {
                    addon_key: callback._context.extension.addon_key
                }, data);
                dialogProvider.close();
            } else {
                var dialogToClose;
                if (callback._context.extension.options.isDialog) dialogToClose = DialogExtensionComponent.getByExtension(callback._context.extension.id)[0];
                else dialogToClose = DialogExtensionComponent.getActiveDialog();
                DialogActions.close({
                    customData: data,
                    dialog: dialogToClose,
                    extension: callback._context.extension
                });
            }
        },
        /**
     * Passes the custom data Object to the specified callback function.
     * @noDemo
     * @name getCustomData
     * @method
     * @param {Function} callback - Callback method to be executed with the custom data.
     * @example
     * AP.dialog.getCustomData(function (customData) {
     *   console.log(customData);
     * });
     *
     */ getCustomData: function getCustomData(callback) {
            callback = Util.last(arguments);
            var dialog = getDialogFromContext(callback._context);
            if (dialog) callback(dialog.customData);
            else callback(undefined);
        },
        /**
    * Stop the dialog from closing when the submit button is clicked
    * @method disableCloseOnSubmit
    * @noDemo
    * @example
    * AP.dialog.disableCloseOnSubmit();
    * AP.events.on('dialog.button.click', function(data){
    *   if(data.button.name === 'submit') {
    *     console.log('submit button pressed');
    *   }
    * }
    */ /**
     * Returns the button that was requested (either cancel or submit). If the requested button does not exist, an empty Object will be returned instead.
     * @method getButton
     * @returns {Dialog~DialogButton}
     * @noDemo
     * @example
     * AP.dialog.getButton('submit');
     */ getButton: {
            constructor: Button,
            enable: Button.prototype.enable,
            disable: Button.prototype.disable,
            toggle: Button.prototype.toggle,
            isEnabled: Button.prototype.isEnabled,
            trigger: Button.prototype.trigger,
            hide: Button.prototype.hide,
            show: Button.prototype.show,
            isHidden: Button.prototype.isHidden
        },
        /**
     * Creates a dialog button that can be controlled with javascript
     * @method createButton
     * @returns {Dialog~DialogButton}
     * @noDemo
     * @example
     * AP.dialog.createButton({
     *   text: 'button text',
     *   identifier: 'button.1'
     * }).bind(function mycallback(){});
     */ createButton: {
            constructor: CreateButton
        }
    };
    EventDispatcher$1.register("iframe-resize", function(data) {
        IframeComponent.resize(data.width, data.height, data.$el);
    });
    EventDispatcher$1.register("iframe-size-to-parent", function(data) {
        var height;
        var $el = Util.getIframeByExtensionId(data.extensionId);
        height = $(window).height() - $el.offset().top - 1 + "px"; //1px comes from margin given by full-size-general-page
        // When in unit test (env_module_spec.js), $el.get(0).name is an empty string, breaking the test. Thus doing this check.
        if ($el.get(0).name.length > 0 && JSON.parse($el.get(0).name).options.moduleType === "jiraProjectPages") height = "100%";
        EventDispatcher$1.dispatch("iframe-resize", {
            width: "100%",
            height: height,
            $el: $el
        });
    });
    EventDispatcher$1.register("hide-footer", function(hideFooter) {
        if (hideFooter) $("#footer").css({
            display: "none"
        });
    });
    window.addEventListener("resize", function(e) {
        EventDispatcher$1.dispatch("host-window-resize", e);
    }, true);
    var EnvActions = {
        iframeResize: function iframeResize(width, height, context) {
            var $el;
            if (context.extension_id) $el = Util.getIframeByExtensionId(context.extension_id);
            else $el = context;
            EventDispatcher$1.dispatch("iframe-resize", {
                width: width,
                height: height,
                $el: $el,
                extension: context.extension
            });
        },
        sizeToParent: function sizeToParent(extensionId, hideFooter) {
            EventDispatcher$1.dispatch("iframe-size-to-parent", {
                hideFooter: hideFooter,
                extensionId: extensionId
            });
        },
        hideFooter: function hideFooter(_hideFooter) {
            EventDispatcher$1.dispatch("hide-footer", _hideFooter);
        }
    };
    var debounce = Util.debounce;
    var resizeFuncHolder = {};
    // ignore resize events for iframes that use sizeToParent
    var ignoreResizeForExtension = [];
    var sizeToParentExtension = {};
    /**
   * Enables apps to resize their iframes.
   * @exports iframe
   */ var env = {
        /**
     * Get the location of the current page of the host product.
     *
     * @param {Function} callback function (location) {...} The callback to pass the location to.
     * @example
     * AP.getLocation(function(location){
     *   alert(location);
     * });
     */ getLocation: function getLocation(callback) {
            callback = Util.last(arguments);
            var pageLocationProvider = ModuleProviders$1.getProvider("get-location");
            if (typeof pageLocationProvider === "function") callback(pageLocationProvider());
            else callback(window.location.href);
        },
        /**
     * Resize the iframe to a width and height.
     *
     * Only content within an element with the class `ac-content` is resized automatically.
     * Content without this identifier is sized according to the `body` element, and
     * is *not* dynamically resized. The recommended DOM layout for your app is:
     *
     * ``` html
     * <div class="ac-content">
     *     <p>Hello World</p>
     *     <div id="your-id-here">
     *         <p>App content goes here</p>
     *     </div>
     *
     *     ...this area reserved for the resize sensor divs
     * </div>
     * ```
     *
     * The resize sensor div is added on the iframe's [load event](https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event).
     * Removing the `ac-content` element after this, prevents resizing from working correctly.
     *
     * This method cannot be used in dialogs.
     *
     * @method
     * @param {String} width   The desired width in pixels or percentage.
     * @param {String} height  The desired height in pixels or percentage.
     * @example
     * AP.resize('400','400');
     */ resize: function resize(width, height, callback) {
            callback = Util.last(arguments);
            var addon = ModuleProviders$1.getProvider("addon");
            if (addon) addon.resize(width, height, callback._context);
            else {
                var iframeId = callback._context.extension.id;
                var options = callback._context.extension.options;
                if (ignoreResizeForExtension.indexOf(iframeId) !== -1 || options && options.isDialog) return false;
                if (!resizeFuncHolder[iframeId]) resizeFuncHolder[iframeId] = debounce(function(dwidth, dheight, dcallback) {
                    EnvActions.iframeResize(dwidth, dheight, dcallback._context);
                }, 50);
                resizeFuncHolder[iframeId](width, height, callback);
            }
            return true;
        },
        /**
     * Resize the iframe so that it takes up the entire page.
     *
     * This method is only available for general page modules.
     *
     * @method
     * @example
     * AP.sizeToParent();
     */ sizeToParent: debounce(function(hideFooter, callback) {
            callback = Util.last(arguments);
            var addon = ModuleProviders$1.getProvider("addon");
            if (addon) addon.sizeToParent(hideFooter, callback._context);
            else // sizeToParent is only available for general-pages
            if (callback._context.extension.options.isFullPage) {
                // This adds border between the iframe and the page footer as the connect addon has scrolling content and can't do this
                Util.getIframeByExtensionId(callback._context.extension_id).addClass("full-size-general-page");
                if (Flags.isSetBlockDisplayFlagEnabled()) Util.getIframeByExtensionId(callback._context.extension_id).addClass("sized-to-parent");
                EnvActions.sizeToParent(callback._context.extension_id, hideFooter);
                sizeToParentExtension[callback._context.extension_id] = {
                    hideFooter: hideFooter
                };
            } else // This is only here to support integration testing
            // see com.atlassian.plugin.connect.test.pageobjects.RemotePage#isNotFullSize()
            Util.getIframeByExtensionId(callback._context.extension_id).addClass("full-size-general-page-fail");
        }),
        /**
     * Hide the footer.
     *
     * @method
     * @param {boolean} hideFooter Whether the footer should be hidden.
     * @ignore
     */ hideFooter: function hideFooter(_hideFooter) {
            if (_hideFooter) EnvActions.hideFooter(_hideFooter);
        }
    };
    var _removeIframeReferenceAfterUnloadAndDestroyed = function _removeIframeReferenceAfterUnloadAndDestroyed(extensionId) {
        delete resizeFuncHolder[extensionId];
        delete sizeToParentExtension[extensionId];
        if (ignoreResizeForExtension.indexOf(extensionId) !== -1) ignoreResizeForExtension.splice(ignoreResizeForExtension.indexOf(extensionId), 1);
    };
    EventDispatcher$1.register("host-window-resize", function(data) {
        Object.getOwnPropertyNames(sizeToParentExtension).forEach(function(extensionId) {
            EnvActions.sizeToParent(extensionId, sizeToParentExtension[extensionId].hideFooter);
        });
    });
    EventDispatcher$1.register("after:iframe-unload", function(data) {
        _removeIframeReferenceAfterUnloadAndDestroyed(data.extension.id);
    });
    EventDispatcher$1.register("after:iframe-destroyed", function(data) {
        _removeIframeReferenceAfterUnloadAndDestroyed(data.extension.extension.id);
    });
    EventDispatcher$1.register("before:iframe-size-to-parent", function(data) {
        if (ignoreResizeForExtension.indexOf(data.extensionId) === -1) ignoreResizeForExtension.push(data.extensionId);
    });
    var InlineDialogActions = {
        hide: function hide($el) {
            EventDispatcher$1.dispatch("inline-dialog-hide", {
                $el: $el
            });
        },
        refresh: function refresh($el) {
            EventDispatcher$1.dispatch("inline-dialog-refresh", {
                $el: $el
            });
        },
        hideTriggered: function hideTriggered(extension_id, $el) {
            EventDispatcher$1.dispatch("inline-dialog-hidden", {
                extension_id: extension_id,
                $el: $el
            });
        },
        close: function close() {
            EventDispatcher$1.dispatch("inline-dialog-close", {});
        },
        created: function created(data) {
            EventDispatcher$1.dispatch("inline-dialog-opened", {
                $el: data.$el,
                trigger: data.trigger,
                extension: data.extension
            });
        }
    };
    /**
   * The inline dialog is a wrapper for secondary content/controls to be displayed on user request. Consider this component as displayed in context to the triggering control with the dialog overlaying the page content.
   * An inline dialog should be preferred over a modal dialog when a connection between the action has a clear benefit versus having a lower user focus.
   *
   * Inline dialogs can be shown via a [web item target](../../modules/web-item/#target).
   *
   * For more information, read about the Atlassian User Interface [inline dialog component](https://docs.atlassian.com/aui/latest/docs/inline-dialog.html).
   * @module Inline-dialog
   */ var inlineDialog = {
        /**
     * Hide the inline dialog that contains the iframe where this method is called from.
     * @memberOf module:Inline-dialog
     * @method hide
     * @noDemo
     * @example
     * AP.inlineDialog.hide();
     */ hide: function hide(callback) {
            callback = Util.last(arguments);
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var inlineDialogProvider = frameworkAdaptor.getProviderByModuleName("inlineDialog");
            if (inlineDialogProvider) inlineDialogProvider.hide(callback._context);
            else InlineDialogActions.close();
        }
    };
    /**
  * Messages are the primary method for providing system feedback in the product user interface.
  * Messages include notifications of various kinds: alerts, confirmations, notices, warnings, info and errors.
  * For visual examples of each kind please see the [Design guide](https://docs.atlassian.com/aui/latest/docs/messages.html).
  * ### Example ###
  * ```
  * //create a message
  * var message = AP.messages.info('plain text title', 'plain text body');
  * ```
  * @deprecated after August 2017 | Please use the Flag module instead.
  * @name Messages
  * @module
  * @ignore
  */ var MESSAGE_BAR_ID = "ac-message-container";
    var MESSAGE_TYPES = [
        "generic",
        "error",
        "warning",
        "success",
        "info",
        "hint"
    ];
    var MSGID_PREFIX = "ap-message-";
    var MSGID_REGEXP = new RegExp("^" + MSGID_PREFIX + "[0-9A-fa-f]+$");
    var _messages = {};
    function validateMessageId(msgId) {
        return MSGID_REGEXP.test(msgId);
    }
    function getMessageBar() {
        var $msgBar = $("#" + MESSAGE_BAR_ID);
        if ($msgBar.length < 1) $msgBar = $('<div id="' + MESSAGE_BAR_ID + '" />').appendTo("body");
        return $msgBar;
    }
    function filterMessageOptions(options) {
        var copy = {};
        var allowed = [
            "closeable",
            "fadeout",
            "delay",
            "duration",
            "id"
        ];
        if (typeof options === "object") allowed.forEach(function(key) {
            if (key in options) copy[key] = options[key];
        });
        return copy;
    }
    var messageCloseListenerCreated = false;
    function showMessage(name, title, body, options) {
        if (!messageCloseListenerCreated) {
            createMessageCloseListener();
            messageCloseListenerCreated = true;
        }
        var $msgBar = getMessageBar();
        options = filterMessageOptions(options);
        $.extend(options, {
            title: title,
            body: AJS.escapeHtml(body)
        });
        if (MESSAGE_TYPES.indexOf(name) < 0) throw "Invalid message type. Must be: " + MESSAGE_TYPES.join(", ");
        if (validateMessageId(options.id)) {
            AJS.messages[name]($msgBar, options);
            // Calculate the left offset based on the content width.
            // This ensures the message always stays in the centre of the window.
            $msgBar.css("margin-left", "-" + $msgBar.innerWidth() / 2 + "px");
        }
    }
    function deprecatedShowMessage(name, title, body, options, callback) {
        var methodUsed = "AP.messages." + name;
        console.warn("DEPRECATED API - AP.messages." + name + " has been deprecated since ACJS 5.0 and will be removed in a future release. Use AP.flag.create instead.");
        AnalyticsAction.trackDeprecatedMethodUsed(methodUsed, callback._context.extension);
        var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
        var messageProvider = frameworkAdaptor.getProviderByModuleName("messages");
        if (messageProvider) {
            var messageType = name;
            var createMessage = messageProvider[messageType];
            if (!createMessage) messageProvider[messageType] = messageProvider.generic;
            createMessage(title, body, options);
        } else showMessage(name, title, body, options);
    }
    function createMessageCloseListener() {
        $(document).on("aui-message-close", function(e, $msg) {
            var _id = $msg.attr("id").replace(MSGID_PREFIX, "");
            if (_messages[_id]) {
                if ($.isFunction(_messages[_id].onCloseTrigger)) _messages[_id].onCloseTrigger();
                _messages[_id]._destroy();
            }
        });
    }
    function messageModule(messageType) {
        return {
            constructor: function constructor(title, body, options, callback) {
                callback = Util.last(arguments);
                var _id = callback._id;
                if (typeof title !== "string") title = "";
                if (typeof body !== "string") body = "";
                if (typeof options !== "object") options = {};
                options.id = MSGID_PREFIX + _id;
                deprecatedShowMessage(messageType, title, body, options, callback);
                _messages[_id] = this;
            }
        };
    }
    var messages = {
        /**
    * Close a message
    * @deprecated after August 2017 | Please use the Flag module instead.
    * @name clear
    * @method
    * @memberof module:Messages#
    * @param    {String}    id  The id that was returned when the message was created.
    * @example
    * //create a message
    * var message = AP.messages.info('title', 'body');
    * setTimeout(function(){
    *   AP.messages.clear(message);
    * }, 2000);
    */ clear: function clear(msg) {
            var id = MSGID_PREFIX + msg._id;
            if (validateMessageId(id)) {
                var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
                var messageProvider = frameworkAdaptor.getProviderByModuleName("messages");
                if (messageProvider) messageProvider.clear(id);
                else $("#" + id).closeMessage();
            }
        },
        /**
    * Trigger an event when a message is closed
    * @deprecated after August 2017 | Please use the Flag module instead.
    * @name onClose
    * @method
    * @memberof module:Messages#
    * @param    {String}    id  The id that was returned when the message was created.
    * @param    {Function}  callback  The function that is run when the event is triggered
    * @example
    * //create a message
    * var message = AP.messages.info('title', 'body');
    * AP.messages.onClose(message, function() {
    *   console.log(message, ' has been closed!');
    * });
    */ onClose: function onClose(msg, callback) {
            callback = Util.last(arguments);
            var id = msg._id;
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var messageProvider = frameworkAdaptor.getProviderByModuleName("messages");
            if (messageProvider) {
                var fullId = MSGID_PREFIX + msg._id;
                messageProvider.onClose(fullId, callback);
            } else if (_messages[id]) _messages[id].onCloseTrigger = callback;
        },
        /**
    * Show a generic message
    * @deprecated after August 2017 | Please use the Flag module instead.
    * @name generic
    * @method
    * @memberof module:Messages#
    * @param    {String}            title       Sets the title text of the message.
    * @param    {String}            body        The main content of the message.
    * @param    {Object}            options             Message Options
    * @param    {Boolean}           options.closeable   Adds a control allowing the user to close the message, removing it from the page.
    * @param    {Boolean}           options.fadeout     Toggles the fade away on the message
    * @param    {Number}            options.delay       Time to wait (in ms) before starting fadeout animation (ignored if fadeout==false)
    * @param    {Number}            options.duration    Fadeout animation duration in milliseconds (ignored if fadeout==false)
    * @returns  {String}    The id to be used when clearing the message
    * @example
    * //create a message
    * var message = AP.messages.generic('title', 'generic message example');
    */ generic: messageModule("generic"),
        /**
    * Show an error message
    * @deprecated after August 2017 | Please use the Flag module instead.
    * @name error
    * @method
    * @memberof module:Messages#
    * @param    {String}            title       Sets the title text of the message.
    * @param    {String}            body        The main content of the message.
    * @param    {Object}            options             Message Options
    * @param    {Boolean}           options.closeable   Adds a control allowing the user to close the message, removing it from the page.
    * @param    {Boolean}           options.fadeout     Toggles the fade away on the message
    * @param    {Number}            options.delay       Time to wait (in ms) before starting fadeout animation (ignored if fadeout==false)
    * @param    {Number}            options.duration    Fadeout animation duration in milliseconds (ignored if fadeout==false)
    * @returns  {String}    The id to be used when clearing the message
    * @example
    * //create a message
    * var message = AP.messages.error('title', 'error message example');
    */ error: messageModule("error"),
        /**
    * Show a warning message
    * @deprecated after August 2017 | Please use the Flag module instead.
    * @name warning
    * @method
    * @memberof module:Messages#
    * @param    {String}            title       Sets the title text of the message.
    * @param    {String}            body        The main content of the message.
    * @param    {Object}            options             Message Options
    * @param    {Boolean}           options.closeable   Adds a control allowing the user to close the message, removing it from the page.
    * @param    {Boolean}           options.fadeout     Toggles the fade away on the message
    * @param    {Number}            options.delay       Time to wait (in ms) before starting fadeout animation (ignored if fadeout==false)
    * @param    {Number}            options.duration    Fadeout animation duration in milliseconds (ignored if fadeout==false)
    * @returns  {String}    The id to be used when clearing the message
    * @example
    * //create a message
    * var message = AP.messages.warning('title', 'warning message example');
    */ warning: messageModule("warning"),
        /**
    * Show a success message
    * @deprecated after August 2017 | Please use the Flag module instead.
    * @name success
    * @method
    * @memberof module:Messages#
    * @param    {String}            title       Sets the title text of the message.
    * @param    {String}            body        The main content of the message.
    * @param    {Object}            options             Message Options
    * @param    {Boolean}           options.closeable   Adds a control allowing the user to close the message, removing it from the page.
    * @param    {Boolean}           options.fadeout     Toggles the fade away on the message
    * @param    {Number}            options.delay       Time to wait (in ms) before starting fadeout animation (ignored if fadeout==false)
    * @param    {Number}            options.duration    Fadeout animation duration in milliseconds (ignored if fadeout==false)
    * @returns  {String}    The id to be used when clearing the message
    * @example
    * //create a message
    * var message = AP.messages.success('title', 'success message example');
    */ success: messageModule("success"),
        /**
    * Show an info message
    * @deprecated after August 2017 | Please use the Flag module instead.
    * @name info
    * @method
    * @memberof module:Messages#
    * @param    {String}            title       Sets the title text of the message.
    * @param    {String}            body        The main content of the message.
    * @param    {Object}            options             Message Options
    * @param    {Boolean}           options.closeable   Adds a control allowing the user to close the message, removing it from the page.
    * @param    {Boolean}           options.fadeout     Toggles the fade away on the message
    * @param    {Number}            options.delay       Time to wait (in ms) before starting fadeout animation (ignored if fadeout==false)
    * @param    {Number}            options.duration    Fadeout animation duration in milliseconds (ignored if fadeout==false)
    * @returns  {String}    The id to be used when clearing the message
    * @example
    * //create a message
    * var message = AP.messages.info('title', 'info message example');
    */ info: messageModule("info"),
        /**
    * Show a hint message
    * @deprecated after August 2017 | Please use the Flag module instead.
    * @name hint
    * @method
    * @memberof module:Messages#
    * @param    {String}            title               Sets the title text of the message.
    * @param    {String}            body                The main content of the message.
    * @param    {Object}            options             Message Options
    * @param    {Boolean}           options.closeable   Adds a control allowing the user to close the message, removing it from the page.
    * @param    {Boolean}           options.fadeout     Toggles the fade away on the message
    * @param    {Number}            options.delay       Time to wait (in ms) before starting fadeout animation (ignored if fadeout==false)
    * @param    {Number}            options.duration    Fadeout animation duration in milliseconds (ignored if fadeout==false)
    * @returns  {String}    The id to be used when clearing the message
    * @example
    * //create a message
    * var message = AP.messages.hint('title', 'hint message example');
    */ hint: messageModule("hint")
    };
    var FlagActions = {
        // called on action click
        actionInvoked: function actionInvoked(actionId, flagId) {
            EventDispatcher$1.dispatch("flag-action-invoked", {
                id: flagId,
                actionId: actionId
            });
        },
        open: function open(flagId) {
            EventDispatcher$1.dispatch("flag-open", {
                id: flagId
            });
        },
        //called to close a flag
        close: function close(flagId) {
            EventDispatcher$1.dispatch("flag-close", {
                id: flagId
            });
        },
        //called by AUI when closed
        closed: function closed(flagId) {
            EventDispatcher$1.dispatch("flag-closed", {
                id: flagId
            });
        }
    };
    var FLAGID_PREFIX = "ap-flag-";
    var FLAG_CLASS = "ac-aui-flag";
    var FLAG_ACTION_CLASS = "ac-flag-actions";
    var Flag$1 = /*#__PURE__*/ function() {
        function Flag() {}
        var _proto = Flag.prototype;
        _proto.cleanKey = function cleanKey(dirtyKey) {
            var cleanFlagKeyRegExp = new RegExp("^" + FLAGID_PREFIX + "(.+)$");
            var matches = dirtyKey.match(cleanFlagKeyRegExp);
            if (matches && matches[1]) return matches[1];
            return null;
        };
        _proto._toHtmlString = function _toHtmlString(str) {
            if ($.type(str) === "string") return str;
            else if ($.type(str) === "object" && str instanceof $) return str.html();
        };
        _proto._renderBody = function _renderBody(body) {
            var body = this._toHtmlString(body);
            var $body = $("<div />").html(body);
            $("<p />").addClass(FLAG_ACTION_CLASS).appendTo($body);
            return $body.html();
        };
        _proto._renderActions = function _renderActions($flag, flagId, actions) {
            var $actionContainer = $flag.find("." + FLAG_ACTION_CLASS);
            actions = actions || {};
            var $action;
            Object.getOwnPropertyNames(actions).forEach(function(key) {
                $action = $("<a />").attr("href", "#").data({
                    "key": key,
                    "flag_id": flagId
                }).text(actions[key]);
                $actionContainer.append($action);
            }, this);
            return $flag;
        };
        _proto.render = function render(options) {
            bindFlagDomEvents();
            var _id = FLAGID_PREFIX + options.id;
            var auiFlag = AJS.flag({
                type: options.type,
                title: options.title,
                body: this._renderBody(options.body),
                close: options.close
            });
            auiFlag.setAttribute("id", _id);
            var $auiFlag = $(auiFlag);
            this._renderActions($auiFlag, options.id, options.actions);
            $auiFlag.addClass(FLAG_CLASS);
            $auiFlag.close = auiFlag.close;
            return $auiFlag;
        };
        _proto.close = function close(id) {
            var f = document.getElementById(id);
            f.close();
        };
        return Flag;
    }();
    var FlagComponent = new Flag$1();
    var flagDomEventsBound = false;
    function bindFlagDomEvents() {
        if (flagDomEventsBound) return;
        $(document).on("aui-flag-close", function(e) {
            var _id = e.target.id;
            var cleanFlagId = FlagComponent.cleanKey(_id);
            FlagActions.closed(cleanFlagId);
        });
        $(document).on("click", "." + FLAG_ACTION_CLASS, function(e) {
            var $target = $(e.target);
            var actionKey = $target.data("key");
            var flagId = $target.data("flag_id");
            FlagActions.actionInvoked(actionKey, flagId);
        });
        flagDomEventsBound = true;
    }
    EventDispatcher$1.register("flag-close", function(data) {
        FlagComponent.close(data.id);
    });
    /**
  * Flags are the primary method for providing system feedback in the product user interface. Messages include notifications of various kinds: alerts, confirmations, notices, warnings, info and errors.
  * @module Flag
  */ var _flags = {};
    /**
  * @class Flag~Flag
  * @description A flag object created by the [AP.flag]{@link module:Flag} module.
  * @example
  * // complete flag API example:
  * var outFlagId;
  * var flag = AP.flag.create({
  *   title: 'Successfully created a flag.',
  *   body: 'This is a flag.',
  *   type: 'info',
  *   actions: {
  *     'actionOne': 'action name'
  *   }
  * }, function(identifier) {
  * // Each flag will have a unique id. Save it for later.
  *   ourFlagId = identifier;
  * });
  *
  * // listen to flag events
  * AP.events.on('flag.close', function(data) {
  * // a flag was closed. data.flagIdentifier should match ourFlagId
  *   console.log('flag id: ', data.flagIdentifier);
  * });
  * AP.events.on('flag.action', function(data) {
  * // a flag action was clicked. data.actionIdentifier will be 'actionOne'
  * // data.flagIdentifier will equal ourFlagId
  *   console.log('flag id: ', data.flagIdentifier, 'flag action id', data.actionIdentifier);
  * });
  */ var Flag = /*#__PURE__*/ function() {
        function Flag(options, callback) {
            callback = Util.last(arguments);
            if (typeof options !== "object") return;
            var flagId = callback._id;
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var flagProvider = frameworkAdaptor.getProviderByModuleName("flag");
            if (flagProvider) {
                var actions = [];
                if (typeof options.actions === "object") actions = Object.getOwnPropertyNames(options.actions).map(function(key) {
                    return {
                        actionKey: key,
                        actionText: options.actions[key],
                        executeAction: FlagActions.actionInvoked.bind(null, key, flagId)
                    };
                });
                var type = options.type || "info";
                var flagOptions = {
                    id: flagId,
                    title: options.title,
                    body: options.body,
                    actions: actions,
                    onClose: FlagActions.closed,
                    close: options.close,
                    type: type.toLowerCase()
                };
                this.flag = flagProvider.create(flagOptions);
                var addonProvider = ModuleProviders$1.getProvider("addon");
                if (addonProvider && addonProvider.registerUnmountCallback) addonProvider.registerUnmountCallback(this.close.bind(this), callback._context);
            } else {
                this.flag = FlagComponent.render({
                    type: options.type,
                    title: options.title,
                    body: AJS.escapeHtml(options.body),
                    actions: options.actions,
                    close: options.close,
                    id: flagId
                });
                FlagActions.open(this.flag.attr("id"));
            }
            this.onTriggers = {};
            this.extension = callback._context.extension;
            _flags[callback._id] = this;
            callback.call(null, callback._id);
        }
        /**
    * @name close
    * @memberof Flag~Flag
    * @method
    * @description Closes the Flag.
    * @example
    * // Display a nice green flag using the Flags JavaScript API.
    * var flag = AP.flag.create({
    *   title: 'Successfully created a flag.',
    *   body: 'This is a flag.',
    *   type: 'info'
    * });
    *
    * // Close the flag.
    * flag.close()
    *
    */ var _proto = Flag.prototype;
        _proto.close = function close() {
            this.flag.close();
        };
        return Flag;
    }();
    function invokeTrigger(id, eventName, data) {
        if (_flags[id]) {
            var extension = _flags[id].extension;
            data = data || {};
            data.flagIdentifier = id;
            var targetSpec = {
                id: extension.id
            };
            EventActions.broadcast(eventName, targetSpec, data);
        }
    }
    EventDispatcher$1.register("flag-closed", function(data) {
        invokeTrigger(data.id, "flag.close");
        if (_flags[data.id]) delete _flags[data.id];
    });
    EventDispatcher$1.register("flag-action-invoked", function(data) {
        invokeTrigger(data.id, "flag.action", {
            actionIdentifier: data.actionId
        });
    });
    var flag = {
        /**
    * @name create
    * @method
    * @description Creates a new flag.
    * @param {Object} options           Options of the flag.
    * @param {String} options.title     The title text of the flag.
    * @param {String} options.body      The body text of the flag.
    * @param {String} options.type=info Sets the type of the message. Valid options are "info", "success", "warning" and "error".
    * @param {String} options.close     The closing behaviour that this flag has. Valid options are "manual", and "auto".
    * @param {Object} options.actions   Map of {actionIdentifier: 'Action link text'} to add to the flag. The actionIdentifier will be passed to a 'flag.action' event if the link is clicked.
    * @returns {Flag~Flag}
    * @example
    * // Display a nice green flag using the Flags JavaScript API.
    * var flag = AP.flag.create({
    *   title: 'Successfully created a flag.',
    *   body: 'This is a flag.',
    *   type: 'success',
    *   actions: {
    *     'actionkey': 'Click me'
    *   }
    * });
    */ create: {
            constructor: Flag,
            close: Flag.prototype.close
        }
    };
    var analytics = {
        trackDeprecatedMethodUsed: function trackDeprecatedMethodUsed(methodUsed, callback) {
            callback = Util.last(arguments);
            AnalyticsAction.trackDeprecatedMethodUsed(methodUsed, callback._context.extension);
        },
        trackIframePerformanceMetrics: function trackIframePerformanceMetrics(metrics, callback) {
            callback = Util.last(arguments);
            AnalyticsAction.trackIframePerformanceMetrics(metrics, callback._context.extension);
        }
    };
    var TRIGGER_PERCENTAGE = 10; //% before scroll events are fired
    var activeGeneralPageAddon;
    var lastScrollEventTriggered; //top or bottom
    EventDispatcher$1.register("iframe-bridge-established", function(data) {
        if (data.extension.options.isFullPage) {
            window.addEventListener("scroll", scrollEventHandler);
            activeGeneralPageAddon = data.extension.id;
        }
    });
    EventDispatcher$1.register("iframe-destroyed", function(extension) {
        removeScrollEvent();
    });
    EventDispatcher$1.register("iframe-unload", function(extension) {
        removeScrollEvent();
    });
    function removeScrollEvent() {
        window.removeEventListener("scroll", scrollEventHandler);
        activeGeneralPageAddon = undefined;
        lastScrollEventTriggered = undefined;
    }
    function scrollEventHandler() {
        var documentHeight = document.documentElement.scrollHeight;
        var windowHeight = window.innerHeight;
        var boundary = documentHeight * (TRIGGER_PERCENTAGE / 100);
        if (window.pageYOffset <= boundary) triggerEvent("nearTop");
        else if (windowHeight + window.pageYOffset + boundary >= documentHeight) triggerEvent("nearBottom");
        else lastScrollEventTriggered = undefined;
    }
    function triggerEvent(type) {
        if (lastScrollEventTriggered === type) return; // only once per scroll.
        EventActions.broadcast("scroll." + type, {
            id: activeGeneralPageAddon
        }, {});
        lastScrollEventTriggered = type;
    }
    /**
   * Enables apps to get and set the scroll position.
   * @exports Scroll-position
   */ var scrollPosition = {
        /**
     * Gets the scroll position relative to the browser viewport
     *
     * @param callback {Function} callback to pass the scroll position
     * @noDemo
     * @example
     * AP.scrollPosition.getPosition(function(obj) { console.log(obj); });
     */ getPosition: function getPosition(callback) {
            callback = Util.last(arguments);
            // scrollPosition.getPosition is only available for general-pages
            if (callback._context.extension.options.isFullPage) {
                var $el = Util.getIframeByExtensionId(callback._context.extension_id);
                var offset = $el.offset();
                var $window = $(window);
                callback({
                    scrollY: $window.scrollTop() - offset.top,
                    scrollX: $window.scrollLeft() - offset.left,
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            }
        },
        /**
     * Sets the vertical scroll position relative to the iframe
     *
     * @param y {Number} vertical offset position
     * @param callback {Function} callback to pass the scroll position
     * @noDemo
     * @example
     * AP.scrollPosition.setVerticalPosition(30, function(obj) { console.log(obj); });
     */ setVerticalPosition: function setVerticalPosition(y, callback) {
            callback = Util.last(arguments);
            if (callback._context.extension.options && callback._context.extension.options.isFullPage) {
                var $el = Util.getIframeByExtensionId(callback._context.extension_id);
                var offset = $el.offset();
                if (typeof y === "number") document.documentElement.scrollTop = offset.top + y;
            }
        }
    };
    var DropdownActions = {
        // called on action click
        itemSelected: function itemSelected(dropdown_id, item, extension) {
            EventDispatcher$1.dispatch("dropdown-item-selected", {
                id: dropdown_id,
                item: item,
                extension: extension
            });
        }
    };
    /**
  * DO NOT INCLUDE ME IN THE PUBLIC DOCUMENTATION
  * there is no AUI implementation of this
  */ function buildListItem(listItem) {
        var finishedListItem = {};
        if (typeof listItem === "string") finishedListItem.content = listItem;
        else if (listItem.text && typeof listItem.text === "string") {
            finishedListItem.content = listItem.text;
            if (typeof listItem.disabled === "boolean") finishedListItem.disabled = listItem.disabled;
            if (typeof listItem.itemId !== "undefined") finishedListItem.itemId = listItem.itemId;
        } else throw new Error("Unknown dropdown list item format.");
        return finishedListItem;
    }
    function moduleListToApiList(list) {
        return list.map(function(item) {
            if (item.list && Array.isArray(item.list)) {
                var returnval = {
                    heading: item.heading
                };
                returnval.items = item.list.map(function(listitem) {
                    return buildListItem(listitem);
                });
                return returnval;
            }
        });
    }
    /**
  * @class DropdownItem
  * A single item in a dropdown menu can be a string or an object
  * @param {String} itemId The id of a single dropdown item
  * @param {String} text    The text to display in the dropdown item
  */ /**
  * @module Dropdown
  * @description Dropdown menu that can go outside the iframe bounds.
  * @example
  * // create a dropdown menu with 1 section and 2 items
  * var mydropdown = {
  *   dropdownId: 'my-dropdown',
  *   list: [{
  *     heading: 'section heading',
  *     list: [
  *       {text: 'one'},
  *       {text: 'two'}
  *     ]
  *   }]
  * };
  *
  * AP.events.on('dropdown-item-selected', (data) =>{
  *   console.log('dropdown item selected', data.dropdownId, data.item);
  * });
  *
  * AP.dropdown.create(mydropdown);
  * // button is an element in our document that triggered the dropdown
  * let rect = document.querySelector('button').getBoundingClientRect();
  * AP.dropdown.showAt('my-dropdown', rect.left, rect.top, rect.width);
  *
  */ var dropdown = {
        /**
    * @name create
    * @method
    * @description Creates a new dropdown.
    * @param {Object} options             Options of the dropdown.
    * @param {String} options.dropdownId A unique identifier for the dropdown that will be referenced in events.
    * @param {String} options.list        An array containing dropdown items {Dropdown~DropdownItem}
    * @example
    * // create a dropdown menu with 1 section and 2 items
    * var mydropdown = {
    *   dropdownId: 'my-dropdown',
    *   list: [{
    *     heading: 'section heading',
    *     list: [
    *       {text: 'one'},
    *       {text: 'two'}
    *     ]
    *   }]
    * };
    *
    * AP.dropdown.create(mydropdown);
    */ create: function create(options, callback) {
            callback = Util.last(arguments);
            if (typeof options !== "object") return;
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dropdownProvider = frameworkAdaptor.getProviderByModuleName("dropdown");
            if (dropdownProvider) {
                var dropdownGroups = moduleListToApiList(options.list);
                var dropdownProviderOptions = {
                    dropdownId: options.dropdownId,
                    dropdownGroups: dropdownGroups,
                    dropdownItemNotifier: function dropdownItemNotifier(data) {
                        DropdownActions.itemSelected(data.dropdownId, data.item, callback._context.extension);
                    }
                };
                dropdownProvider.create(dropdownProviderOptions, callback._context);
                return dropdownProviderOptions;
            }
        },
        /**
    * @name showAt
    * @method
    * @description Displays a created dropdown menu.
    * @param {String} dropdownId   Id used when creating the dropdown
    * @param {String} x             x position from the edge of your iframe to display
    * @param {String} y             y position from the edge of your iframe to display
    * @param {String} width         Optionally enforce a width for the dropdown menu
    * @example
    * // create a dropdown menu with 1 section and 2 items
    * var mydropdown = {
    *   dropdownId: 'my-dropdown',
    *   list: [{
    *     list:['one', 'two']
    *   }]
    * };
    *
    * AP.dropdown.create(mydropdown);
    * // Get the button that activated the dropdown
    * let rect = document.querySelector('button').getBoundingClientRect();
    * AP.dropdown.showAt('my-dropdown', rect.left, rect.top, rect.width);
    */ showAt: function showAt(dropdownId, x, y, width) {
            var callback = Util.last(arguments);
            var rect = {
                left: 0,
                top: 0
            };
            var iframe = document.getElementById(callback._context.extension_id);
            if (iframe) rect = iframe.getBoundingClientRect();
            else console.error("ACJS: no iframe found for dropdown");
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dropdownProvider = frameworkAdaptor.getProviderByModuleName("dropdown");
            if (dropdownProvider) {
                var dropdownProviderArgs = {
                    dropdownId: dropdownId,
                    x: x,
                    y: y,
                    width: width
                };
                dropdownProvider.showAt(dropdownProviderArgs, {
                    iframeDimensions: rect,
                    onItemSelection: function onItemSelection(dropdownId, item) {
                        DropdownActions.itemSelected(dropdownId, item, callback._context.extension);
                    }
                });
            }
        },
        /**
    * @name hide
    * @method
    * @description Hide a dropdown menu
    * @param {String} dropdownId The id of the dropdown to hide
    * @example
    * AP.dropdown.create('my-dropdown');
    * AP.dropdown.hide('my-dropdown');
    */ hide: function hide(id) {
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dropdownProvider = frameworkAdaptor.getProviderByModuleName("dropdown");
            if (dropdownProvider) dropdownProvider.hide(id);
        },
        /**
    * @name itemDisable
    * @method
    * @description Disable an item in the dropdown menu
    * @param {String} dropdownId The id of the dropdown
    * @param {String} itemId     The dropdown item to disable
    * @example
    * AP.dropdown.create('my-dropdown');
    * AP.dropdown.itemDisable('my-dropdown', 'item-id');
    */ itemDisable: function itemDisable(dropdownId, itemId) {
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dropdownProvider = frameworkAdaptor.getProviderByModuleName("dropdown");
            if (dropdownProvider) dropdownProvider.itemDisable(dropdownId, itemId);
        },
        /**
    * @name itemEnable
    * @method
    * @description Hide a dropdown menu
    * @param {String} dropdownId The id of the dropdown
    * @param {String} itemId The id of the dropdown item to enable
    * @example
    * AP.dropdown.create('my-dropdown');
    * AP.dropdown.itemEnable('my-dropdown', 'item-id');
    */ itemEnable: function itemEnable(dropdownId, itemId) {
            var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
            var dropdownProvider = frameworkAdaptor.getProviderByModuleName("dropdown");
            if (dropdownProvider) dropdownProvider.itemEnable(dropdownId, itemId);
        }
    };
    EventDispatcher$1.register("dropdown-item-selected", function(data) {
        EventActions.broadcast("dropdown-item-selected", {
            addon_key: data.extension.addon_key,
            key: data.extension.key
        }, {
            dropdownId: data.id,
            item: data.item
        });
    });
    // friendly unload with connectHost.destroy
    EventDispatcher$1.register("iframe-destroyed", function(data) {
        var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
        var dropdownProvider = frameworkAdaptor.getProviderByModuleName("dropdown");
        if (dropdownProvider) dropdownProvider.destroyByExtension(data.extension.extension_id);
    });
    // unfriendly unload by removing the iframe from the DOM
    EventDispatcher$1.register("after:iframe-unload", function(data) {
        var frameworkAdaptor = HostApi$1.getFrameworkAdaptor();
        var dropdownProvider = frameworkAdaptor.getProviderByModuleName("dropdown");
        if (dropdownProvider) dropdownProvider.destroyByExtension(data.extension.extension_id);
    });
    function deprecateHost(fn, name, alternate, sinceVersion) {
        var called = false;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!called && typeof console !== "undefined" && console.warn) {
                called = true;
                console.warn("DEPRECATED API - " + name + " has been deprecated " + (sinceVersion ? "since ACJS " + sinceVersion : "in ACJS") + (" and will be removed in a future release. " + (alternate ? "Use " + alternate + " instead." : "No alternative will be provided.")));
                var callback = Util.last(args);
                if (callback && callback._context && callback._context.extension) analytics.trackDeprecatedMethodUsed(name, callback);
            }
            return fn.apply(void 0, args);
        };
    }
    var host = {
        /*
     This function could be used in Connect app for moving focus to Host app.
     As Connect App - iframe app, it can get control. When it's happen - host app events such short-cuts
     stop working. This function could help in this case.
    */ focus: function focus() {
            window.document.querySelector("a").focus({
                preventScroll: true
            });
            window.document.querySelector("a").blur();
        },
        getSelectedText: deprecateHost(function(callback) {
            callback("");
            return;
        }, "AP.host.getSelectedText()")
    };
    /**
   * This file contains the source of truth for themes and all associated meta data.
   */ /**
   * Themes: The internal identifier of a theme.
   * These ids are what the actual theme files/folders are called.
   * style-dictionary will attempt to locate these in the file-system.
   */ /**
   * ThemeOverrides: The internal identifier of a theme override. Which are themes that contain
   * a subset of tokens intended to override an existing theme. These ids are what the actual
   * theme files/folders are called. style-dictionary will attempt to locate these in the file-system.
   * Theme overrides are temporary and there may not be any defined at times.
   */ /**
   * Theme kinds: The type of theme.
   * Some themes are entirely focused on Color, whilst others are purely focused on spacing.
   * In the future other types may be introduced such as typography.
   */ /**
   * Theme modes: The general purpose of a theme.
   * This attr is used to apply the appropriate system-preference option
   * It may also be used as a selector for mode-specific overrides such as light/dark images.
   * The idea is there may exist many color themes, but every theme must either fit into light or dark.
   */ var themeColorModes = [
        "light",
        "dark",
        "auto"
    ];
    /**
   * Theme ids: The value that will be mounted to the DOM as a data attr
   * For example: `data-theme="light:light dark:dark spacing:spacing"
   *
   * These ids must be kebab case
   */ var themeIds = [
        "light-increased-contrast",
        "light",
        "light-future",
        "light-brand-refresh",
        "dark",
        "dark-future",
        "dark-increased-contrast",
        "dark-brand-refresh",
        "legacy-light",
        "legacy-dark",
        "spacing",
        "shape",
        "typography-adg3",
        "typography-modernized"
    ];
    var THEME_DATA_ATTRIBUTE = "data-theme";
    var COLOR_MODE_ATTRIBUTE = "data-color-mode";
    var CSS_PREFIX = "ds";
    var CURRENT_SURFACE_CSS_VAR = "--".concat(CSS_PREFIX, "-elevation-surface-current");
    var themeKinds = [
        "light",
        "dark",
        "spacing",
        "typography",
        "shape"
    ];
    var customThemeOptions = "UNSAFE_themeOptions";
    var isThemeKind = function isThemeKind(themeKind) {
        return themeKinds.find(function(kind) {
            return kind === themeKind;
        }) !== undefined;
    };
    var isThemeIds = function isThemeIds(themeId) {
        return themeIds.find(function(id) {
            return id === themeId;
        }) !== undefined;
    };
    var isColorMode = function isColorMode(modeId) {
        return [
            "light",
            "dark",
            "auto"
        ].includes(modeId);
    };
    /**
   * Converts a string that is formatted for the `data-theme` HTML attribute
   * to an object that can be passed to `setGlobalTheme`.
   *
   * @param {string} themes The themes that should be applied.
   *
   * @example
   * ```
   * themeStringToObject('dark:dark light:legacy-light spacing:spacing');
   * // returns { dark: 'dark', light: 'legacy-light', spacing: 'spacing' }
   * ```
   */ var themeStringToObject = function themeStringToObject(themeState) {
        return themeState.split(" ").map(function(theme) {
            return theme.split(/:([\s\S]*)/);
        }).reduce(function(themeObject, _ref) {
            var _ref2 = _slicedToArray(_ref, 2), kind = _ref2[0], id = _ref2[1];
            if (kind === "colorMode" && isColorMode(id)) themeObject[kind] = id;
            if (isThemeKind(kind) && isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
            themeObject[kind] = id;
            if (kind === customThemeOptions) try {
                themeObject[customThemeOptions] = JSON.parse(id);
            } catch (e) {}
            return themeObject;
        }, {});
    };
    function ownKeys(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function(r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function _objectSpread(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
                _defineProperty(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    var isThemeColorMode = function isThemeColorMode(colorMode) {
        return themeColorModes.find(function(mode) {
            return mode === colorMode;
        }) !== undefined;
    };
    var getGlobalTheme = function getGlobalTheme() {
        if (typeof document === "undefined") return {};
        var element = document.documentElement;
        var colorMode = element.getAttribute(COLOR_MODE_ATTRIBUTE) || "";
        var theme = element.getAttribute(THEME_DATA_ATTRIBUTE) || "";
        return _objectSpread(_objectSpread({}, themeStringToObject(theme)), isThemeColorMode(colorMode) && {
            colorMode: colorMode
        });
    };
    var getGlobalTheme$1 = getGlobalTheme;
    /**
   * A MutationObserver which watches the `<html>` element for changes to the theme.
   *
   * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
   *
   * @param {function} callback - A callback function which fires when the theme changes.
   *
   * @example
   * ```
   * const observer = new ThemeMutationObserver((theme) => {});
   * observer.observe();
   * ```
   */ var ThemeMutationObserver = /*#__PURE__*/ function() {
        function ThemeMutationObserver(callback) {
            _classCallCheck(this, ThemeMutationObserver);
            _defineProperty(this, "legacyObserver", null);
            this.callback = callback;
            ThemeMutationObserver.callbacks.add(callback);
        }
        _createClass(ThemeMutationObserver, [
            {
                key: "observe",
                value: function observe() {
                    if (!ThemeMutationObserver.observer) {
                        ThemeMutationObserver.observer = new MutationObserver(function() {
                            var theme = getGlobalTheme$1();
                            ThemeMutationObserver.callbacks.forEach(function(callback) {
                                return callback(theme);
                            });
                        });
                        // Observer only needs to be configured once
                        ThemeMutationObserver.observer.observe(document.documentElement, {
                            attributeFilter: [
                                THEME_DATA_ATTRIBUTE,
                                COLOR_MODE_ATTRIBUTE
                            ]
                        });
                    }
                }
            },
            {
                key: "disconnect",
                value: function disconnect() {
                    if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                    if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                        ThemeMutationObserver.observer.disconnect();
                        ThemeMutationObserver.observer = null;
                    }
                }
            }
        ]);
        return ThemeMutationObserver;
    }();
    _defineProperty(ThemeMutationObserver, "observer", null);
    _defineProperty(ThemeMutationObserver, "callbacks", new Set());
    var getPluginFeatureFlags = function getPluginFeatureFlags() {
        return {
            isLoadCdnStylesOnlyEnabled: getBooleanFeatureFlag("acjs-iframe-allowlist_load_stylesheets_from_cdn", true)
        };
    };
    var getSurfaceValue = function getSurfaceValue(extension_id) {
        var iframe = document.getElementById(extension_id);
        if (!iframe) return;
        var styles = getComputedStyle(iframe);
        var currentSurface = styles.getPropertyValue(CURRENT_SURFACE_CSS_VAR);
        var raised = styles.getPropertyValue("--ds-surface-raised");
        var overlay = styles.getPropertyValue("--ds-surface-overlay");
        if (currentSurface === raised) return "raised";
        if (currentSurface === overlay) return "overlay";
    };
    /**
   * Broadcasts the new theme to all plugins.
   * @typedef {import("@atlaskit/tokens").ThemeState} ThemeState
   * @param newTheme {ThemeState}
   */ function broadcastThemeChange(newTheme) {
        var featureFlags = getPluginFeatureFlags();
        if (ThemingModuleState.extensionIds.length) ThemingModuleState.extensionIds.forEach(function(id) {
            var surface = getSurfaceValue(id);
            host$1.broadcast("theme_changed", {
                id: id
            }, {
                newTheme: newTheme,
                featureFlags: featureFlags,
                surface: surface
            });
        });
    }
    // Exported only for testing
    var ThemingModuleState = {
        /**
     * An array containing extension ID's for each app that has enabled theming.
     * Theme change events are only sent to apps listed in this array.
     */ extensionIds: [],
        /**
     * Observer that will only trigger on changes to data-theme on the root html element.
     * Dispatches the new theme to all plugins when the theme changes.
     */ themeObserver: new ThemeMutationObserver(function(newTheme) {
            broadcastThemeChange(newTheme);
        })
    };
    // Only functions that make up the public ACJS theming API should be exported on this object.
    var ThemingModule = {
        /**
     * Starts observing theme changes and dispatches the `theme_initialized` event to the plugin.
     * This event causes the plugin to react when the host's theme changes.
     */ initializeTheming: function initializeTheming() {
            var callback = Util.last(arguments);
            var forceNoCleanup = arguments.length === 1 ? false : arguments[0];
            if (!callback || !callback._context || !callback._context.extension_id) return;
            var extension_id = callback._context.extension_id;
            if (!extension_id) return;
            var initialTheme = getGlobalTheme$1();
            var surface = getSurfaceValue(extension_id);
            var featureFlags = getPluginFeatureFlags();
            // The theme_initialized event should be broadcast even if it has previously been initialized by the plugin.
            // This is to ensure that theming works in multi-page apps after navigating to a different page.
            // The reason is that isThemingInitialized on the plugin side starts as `false` when all.js is loaded.
            // The theme_initialized event is needed to change it to `true` for any new page.
            host$1.broadcast("theme_initialized", {
                id: extension_id
            }, {
                initialTheme: initialTheme,
                featureFlags: featureFlags,
                surface: surface,
                forceNoCleanup: forceNoCleanup
            });
            if (!ThemingModuleState.extensionIds.includes(extension_id)) {
                ThemingModuleState.extensionIds.push(extension_id);
                ThemingModuleState.themeObserver.observe(document.documentElement);
            }
        },
        /**
     * This has to be part of the API so the plugin can notify us when theme loading is finished.
     * The underscore indicates it should not be called by apps directly.
     * @private
     */ _finishedInitTheming: function _finishedInitTheming() {}
    };
    /**
   * A JavaScript module which provides functions for general page modules.
   * @module Page
   */ var page = {
        /**
     * Sets the title of the document when a full page iframe is loaded.
     * @memberOf module:Page
     * @method setTitle
     * @param {String} title the title of the document to be set.
     * @example
     * AP.page.setTitle(title)
     */ setTitle: function setTitle(title, callback) {
            callback = Util.last(arguments);
            if (callback._context.extension.options && callback._context.extension.options.isFullPage) {
                var productSuffix = " - " + Util.guessProductFromModuleDefined(window.connectHost);
                document.title = title + productSuffix;
            }
        }
    };
    var InlineDialogWebItemActions = {
        addExtension: function addExtension(data) {
            EventDispatcher$1.dispatch("inline-dialog-extension", {
                $el: data.$el,
                extension: data.extension
            });
        }
    };
    var InlineDialog = /*#__PURE__*/ function() {
        function InlineDialog() {}
        var _proto = InlineDialog.prototype;
        _proto.resize = function resize(data) {
            var width = Util.stringToDimension(data.width);
            var height = Util.stringToDimension(data.height);
            var $content = data.$el.find(".contents");
            if ($content.length === 1) {
                $content.css({
                    width: width,
                    height: height
                });
                InlineDialogActions.refresh(data.$el);
            }
        };
        _proto.refresh = function refresh($el) {
            if (!$el.is(":visible")) return;
            $el[0].popup.reset();
        };
        _proto._getInlineDialog = function _getInlineDialog($el) {
            return AJS.InlineDialog($el);
        };
        _proto._renderContainer = function _renderContainer() {
            return $("<div />").addClass("aui-inline-dialog-contents");
        };
        _proto._displayInlineDialog = function _displayInlineDialog(data) {
            InlineDialogActions.created({
                $el: data.$el,
                trigger: data.trigger,
                extension: data.extension
            });
        };
        _proto.hideInlineDialog = function hideInlineDialog($el) {
            $el.hide();
        };
        _proto.closeInlineDialog = function closeInlineDialog() {
            $(".aui-inline-dialog").filter(function() {
                return $(this).find(".ap-iframe-container").length > 0;
            }).hide();
        };
        _proto.render = function render(data) {
            var _this = this;
            var $inlineDialog = $(document.getElementById("inline-dialog-" + data.id));
            if ($inlineDialog.length !== 0) $inlineDialog.remove();
            var $el = AJS.InlineDialog(data.bindTo, //assign unique id to inline Dialog
            data.id, function($placeholder, trigger, showInlineDialog) {
                $placeholder.append(data.$content);
                _this._displayInlineDialog({
                    extension: data.extension,
                    $el: $placeholder,
                    trigger: trigger
                });
                showInlineDialog();
            }, data.inlineDialogOptions);
            // Increase z-index so it shows above the Jira project sidebar
            $el.css("z-index", 1000);
            return $el;
        };
        return InlineDialog;
    }();
    var InlineDialogComponent = new InlineDialog();
    EventDispatcher$1.register("iframe-resize", function(data) {
        var container = data.$el.parents(".aui-inline-dialog");
        if (container.length === 1) InlineDialogComponent.resize({
            width: data.width,
            height: data.height,
            $el: container
        });
    });
    EventDispatcher$1.register("inline-dialog-refresh", function(data) {
        InlineDialogComponent.refresh(data.$el);
    });
    EventDispatcher$1.register("inline-dialog-hide", function(data) {
        InlineDialogComponent.hideInlineDialog(data.$el);
    });
    EventDispatcher$1.register("inline-dialog-close", function(data) {
        InlineDialogComponent.closeInlineDialog();
    });
    var ITEM_NAME$1 = "inline-dialog";
    var SELECTOR$1 = ".ap-inline-dialog";
    var WEBITEM_UID_KEY$1 = "inline-dialog-target-uid";
    var InlineDialogWebItem = /*#__PURE__*/ function() {
        function InlineDialogWebItem() {
            this._inlineDialogWebItemSpec = {
                name: ITEM_NAME$1,
                selector: SELECTOR$1,
                triggers: [
                    "mouseenter",
                    "click"
                ]
            };
            this._inlineDialogWebItems = {};
        }
        var _proto = InlineDialogWebItem.prototype;
        _proto.getWebItem = function getWebItem() {
            return this._inlineDialogWebItemSpec;
        };
        _proto._createInlineDialog = function _createInlineDialog(data) {
            var $inlineDialog = InlineDialogComponent.render({
                extension: data.extension,
                id: data.id,
                bindTo: data.$target,
                $content: $("<div />"),
                inlineDialogOptions: data.extension.options
            });
            return $inlineDialog;
        } /**
     * @param {WebItemInvokedEventData} data
     */ ;
        _proto.triggered = function triggered(data) {
            // don't trigger on hover, when hover is not specified.
            var eventType = data.eventType;
            var onHover = data.extension.options.onHover;
            if (eventType !== "click" && !onHover) return;
            var $target = data.$target;
            var webitemId = $target.data(WEBITEM_UID_KEY$1);
            EventDispatcher$1.dispatch("analytics-inline-dialog-opened", {
                extension: data.extension,
                eventType: eventType,
                onHover: onHover
            });
            if (isFixInlineDialogEvents() && eventType === "click" && !onHover) {
                if ($target.attr("data-inline-created") === "true") // Let AUI handle the click event, otherwise we would destroy and recreate the dialog
                // This will lead to the dialog being hidden immediately after it was opened
                return;
                else // We have to handle the first click event to set up the dialog
                // We set this property to ignore subsequent clicks and let AUI handle them
                $target.attr("data-inline-created", "true");
            }
            var $inlineDialog = this._createInlineDialog({
                id: webitemId,
                extension: data.extension,
                $target: $target,
                options: data.extension.options || {}
            });
            $inlineDialog.show();
        };
        _proto.opened = function opened(data) {
            var $existingFrame = data.$el.find("iframe");
            var isExistingFrame = $existingFrame && $existingFrame.length === 1;
            // existing iframe is already present and src is still valid (either no jwt or jwt has not expired).
            if (isExistingFrame) {
                var src = $existingFrame.attr("src");
                var srcPresent = src.length > 0;
                if (srcPresent) {
                    var srcHasJWT = urlUtils.hasJwt(src);
                    var srcHasValidJWT = srcHasJWT && !urlUtils.isJwtExpired(src);
                    if (srcHasValidJWT || !srcHasJWT) return false;
                }
            }
            var dialogExtension = getAccessNarrowingSpaceContext(data.extension);
            var contentRequest = webItemInstance.requestContent(dialogExtension);
            if (!contentRequest) {
                console.warn("no content resolver found");
                return false;
            }
            contentRequest.then(function(content) {
                content.options = content.options || {};
                Util.extend(content.options, {
                    autoresize: true,
                    widthinpx: true
                });
                InlineDialogWebItemActions.addExtension({
                    $el: data.$el,
                    extension: content
                });
            });
            return true;
        };
        _proto.addExtension = function addExtension(data) {
            var addon = create(data.extension);
            data.$el.empty().append(addon);
        } /**
     * @param {WebItemInvokedEventData} data
     */ ;
        _proto.createIfNotExists = function createIfNotExists(data) {
            var $target = data.$target;
            var uid = $target.data(WEBITEM_UID_KEY$1);
            if (!uid) {
                uid = WebItemUtils.uniqueId();
                $target.data(WEBITEM_UID_KEY$1, uid);
            }
        };
        return InlineDialogWebItem;
    }();
    var inlineDialogInstance = new InlineDialogWebItem();
    var webitem$1 = inlineDialogInstance.getWebItem();
    EventDispatcher$1.register("before:webitem-invoked:" + webitem$1.name, function(data) {
        inlineDialogInstance.createIfNotExists(data);
    });
    EventDispatcher$1.register("webitem-invoked:" + webitem$1.name, function(data) {
        inlineDialogInstance.triggered(data);
    });
    EventDispatcher$1.register("inline-dialog-opened", function(data) {
        inlineDialogInstance.opened(data);
    });
    EventDispatcher$1.register("inline-dialog-extension", function(data) {
        inlineDialogInstance.addExtension(data);
    });
    WebItemActions.addWebItem(webitem$1);
    var ITEM_NAME = "dialog";
    var SELECTOR = ".ap-dialog";
    var TRIGGERS = [
        "click"
    ];
    var WEBITEM_UID_KEY = "dialog-target-uid";
    var DEFAULT_WEBITEM_OPTIONS = {
        chrome: true
    };
    var DialogWebItem = /*#__PURE__*/ function() {
        function DialogWebItem() {
            this._dialogWebItem = {
                name: ITEM_NAME,
                selector: SELECTOR,
                triggers: TRIGGERS
            };
        }
        var _proto = DialogWebItem.prototype;
        _proto.getWebItem = function getWebItem() {
            return this._dialogWebItem;
        };
        _proto._dialogOptions = function _dialogOptions(options) {
            return Util.extend({}, DEFAULT_WEBITEM_OPTIONS, options || {});
        } /**
     * @param {WebItemInvokedEventData} data
     */ ;
        _proto.triggered = function triggered(data) {
            var $target = data.$target;
            var webitemId = $target.data(WEBITEM_UID_KEY);
            var dialogOptions = this._dialogOptions(data.extension.options);
            dialogOptions.id = webitemId;
            DialogExtensionActions.open(data.extension, dialogOptions);
        } /**
     * @param {WebItemInvokedEventData} data
     */ ;
        _proto.createIfNotExists = function createIfNotExists(data) {
            var $target = data.$target;
            var uid = $target.data(WEBITEM_UID_KEY);
            if (!uid) {
                uid = WebItemUtils.uniqueId();
                $target.data(WEBITEM_UID_KEY, uid);
            }
        };
        return DialogWebItem;
    }();
    var dialogInstance = new DialogWebItem();
    var webitem = dialogInstance.getWebItem();
    EventDispatcher$1.register("webitem-invoked:" + webitem.name, function(data) {
        dialogInstance.triggered(data);
    });
    EventDispatcher$1.register("before:webitem-invoked:" + webitem.name, dialogInstance.createIfNotExists);
    WebItemActions.addWebItem(webitem);
    /**
   * Private namespace for host-side code.
   * @type {*|{}}
   * @private
   * @deprecated use AMD instead of global namespaces. The only thing that should be on _AP is _AP.define and _AP.require.
   */ if (!window._AP) window._AP = {};
    /*
   * Add version
   */ if (!window._AP.version) window._AP.version = "5.3.153";
    host$1.defineModule("messages", messages);
    host$1.defineModule("flag", flag);
    host$1.defineModule("dialog", dialog);
    host$1.defineModule("inlineDialog", inlineDialog);
    host$1.defineModule("env", env);
    host$1.defineModule("events", events);
    host$1.defineModule("_analytics", analytics);
    host$1.defineModule("scrollPosition", scrollPosition);
    host$1.defineModule("dropdown", dropdown);
    host$1.defineModule("host", host);
    host$1.defineModule("theming", ThemingModule);
    host$1.defineModule("page", page);
    EventDispatcher$1.register("module-define-custom", function(data) {
        host$1.defineModule(data.name, data.methods);
    });
    host$1.registerRequestNotifier(function(data) {
        var dispatchEvent = function dispatchEvent() {
            if (data.type === "req") {
                var registeredExtension = host$1.getExtensions(function(ext) {
                    return ext.extension_id === data.extension_id;
                })[0];
                if (registeredExtension) {
                    var extension = registeredExtension.extension;
                    EventDispatcher$1.dispatch("method-invoked", _extends({}, data, {
                        extension: extension
                    }));
                }
            }
        };
        if (typeof window.requestIdleCallback === "function") window.requestIdleCallback(dispatchEvent, {
            timeout: 1000
        });
        else dispatchEvent();
    });
    host$1.setFeatureFlagGetter(getBooleanFeatureFlag);
    return HostApi$1;
});

});

parcelRegister("8TjKB", function(module, exports) {

$parcel$export(module.exports, "isString", function () { return $34db28ca07bf8dd9$export$844ec244b1367d54; });
$parcel$export(module.exports, "isFunction", function () { return $34db28ca07bf8dd9$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "getObjectValue", function () { return $34db28ca07bf8dd9$export$e1a3353b722e75de; });
$parcel$export(module.exports, "flatMerge", function () { return $34db28ca07bf8dd9$export$f08dd700bf356a7d; });
$parcel$export(module.exports, "getUrlOrigin", function () { return $34db28ca07bf8dd9$export$8f123a80d360ea8a; });
$parcel$export(module.exports, "getInitialOrBucketState", function () { return $34db28ca07bf8dd9$export$230aeef4b9e0f6e3; });
function $34db28ca07bf8dd9$export$844ec244b1367d54(str) {
    return typeof str === "string" || str instanceof String;
}
function $34db28ca07bf8dd9$export$a6cdc56e425d0d0a(obj) {
    return typeof obj === "object" && obj !== null && !Array.isArray(obj) && !(obj instanceof RegExp) && !(obj instanceof Date);
}
function $34db28ca07bf8dd9$export$43bee75e5e14138e(array) {
    return Array.isArray && Array.isArray(array) || array && typeof array.length === "number" && array.constructor === Array;
}
function $34db28ca07bf8dd9$export$f6e2535fb5126e54(fn) {
    return fn && ({}).toString.call(fn) === "[object Function]";
}
function $34db28ca07bf8dd9$export$e1a3353b722e75de(obj, path, defaultValue) {
    return $34db28ca07bf8dd9$export$844ec244b1367d54(path) && $34db28ca07bf8dd9$export$a6cdc56e425d0d0a(obj) && path.split(".")// @ts-ignore TODO: fix noImplicitAny error here
    .reduce((o, k)=>$34db28ca07bf8dd9$export$a6cdc56e425d0d0a(o) ? o[k] : "", obj) || defaultValue;
}
function $34db28ca07bf8dd9$export$7656ccea645fe24c(obj, path) {
    return $34db28ca07bf8dd9$export$a6cdc56e425d0d0a($34db28ca07bf8dd9$export$e1a3353b722e75de(obj, path));
}
function $34db28ca07bf8dd9$export$3f063810d7bf01bd(list, keyGetter) {
    const map = new Map();
    list.forEach((item)=>{
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) map.set(key, [
            item
        ]);
        else collection.push(item);
    });
    return map;
}
function $34db28ca07bf8dd9$export$f08dd700bf356a7d(a = {}, b = {}) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    const len = Math.max(aKeys.length, bKeys.length);
    const out = {};
    for(let i = 0; i < len; i++){
        if (aKeys[i] && a[aKeys[i]]) // @ts-ignore TODO: fix noImplicitAny error here
        out[aKeys[i]] = a[aKeys[i]];
        if (bKeys[i] && b[bKeys[i]]) // @ts-ignore TODO: fix noImplicitAny error here
        out[bKeys[i]] = b[bKeys[i]];
    }
    return out;
}
function $34db28ca07bf8dd9$export$8f123a80d360ea8a(url) {
    // everything except IE11
    if (typeof URL === "function") try {
        return new URL(url).origin;
    // eslint-disable-next-line no-empty
    } catch (e) {}
    // ie11 + safari 10
    const doc = document.implementation.createHTMLDocument("");
    const anchorElement = doc.createElement("a");
    anchorElement.href = url;
    doc.body.appendChild(anchorElement);
    let origin = `${anchorElement.protocol}//${anchorElement.hostname}`; // ie11, only include port if referenced in initial URL
    if (url.match(/\/\/[^/]+:[0-9]+\//)) origin += anchorElement.port ? `:${anchorElement.port}` : "";
    return origin;
}
const $34db28ca07bf8dd9$export$93484e5d50f84920 = "__ssr_state__";
const $34db28ca07bf8dd9$export$8b26fc8110ba9d33 = ()=>window[$34db28ca07bf8dd9$export$93484e5d50f84920] || {};
const $34db28ca07bf8dd9$var$APP_DID_SSR = Object.keys($34db28ca07bf8dd9$export$8b26fc8110ba9d33()).length > 0;
const $34db28ca07bf8dd9$export$642262419f51fae8 = ()=>$34db28ca07bf8dd9$var$APP_DID_SSR;
const $34db28ca07bf8dd9$export$230aeef4b9e0f6e3 = ()=>$34db28ca07bf8dd9$export$642262419f51fae8() ? $34db28ca07bf8dd9$export$8b26fc8110ba9d33().reduxStoreState : // eslint-disable-next-line no-restricted-properties
    window.__initial_state__;

});

parcelRegister("dwTXO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("QQQjQ")).default; });

var $QQQjQ = parcelRequire("QQQjQ");

});
parcelRegister("QQQjQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c441f02dfc80476a$export$2e2bcd8739ae039; });
/* eslint-disable no-underscore-dangle */ // @ts-ignore TODO: fix noImplicitAny error here

var $56wKm = parcelRequire("56wKm");

var $8TjKB = parcelRequire("8TjKB");

var $eeWzj = parcelRequire("eeWzj");

var $6VgSH = parcelRequire("6VgSH");

var $4Jv4i = parcelRequire("4Jv4i");

var $dlEaa = parcelRequire("dlEaa");

var $cR5Y3 = parcelRequire("cR5Y3");

var $2zjAG = parcelRequire("2zjAG");

var $9T9zK = parcelRequire("9T9zK");
const { errorResponse: $c441f02dfc80476a$var$errorResponse } = $6VgSH;
class $c441f02dfc80476a$export$7bfc2a4e72a0f8a0 {
    constructor(){
        this.env = {};
        this.currentUser = {};
        this.modules = new Map();
        this.targets = new Map();
        this.editor = $eeWzj;
        this.buffer = void 0;
        this._managePermissionsUrlProvider = ()=>"/";
        this._denyOAuthConsumer = null;
        this._grantOAuthConsumer = null;
        this._getOAuthScopes = void 0;
        this.handleOAuthAcceptOrDeny = (0, $cR5Y3.onEmitAcceptOrDeny);
    }
    // these are undefined and need to be set by host application
    setEnv(env) {
        this.env = env;
    }
    setCurrentUser(currentUser) {
        this.currentUser = currentUser;
    }
    addModule(mod, target, principalId) {
        const addonKey = mod.app_key;
        const moduleKey = (0, $8TjKB.getObjectValue)(mod, "descriptor.key");
        let targetHref = (0, $8TjKB.getObjectValue)(target, "links.self.href", "");
        if (!targetHref && target.type === "internal_linker_match") {
            targetHref = (0, $4Jv4i.linkerTargetSelfLink)(target, principalId);
            // eslint-disable-next-line no-param-reassign
            target = {
                ...target,
                links: {
                    self: {
                        href: targetHref
                    }
                }
            };
        }
        if (!addonKey || !moduleKey || !targetHref) return false;
        const id = `${addonKey}_${moduleKey}_${targetHref}`;
        // If the module has already been added and is not expired,
        // don't add again as we check object references to prevent rerender
        const existingModule = this.findModules({
            moduleId: id
        })[0];
        if (existingModule && !this.isModuleExpired(existingModule)) return false;
        const now = Date.now();
        if (principalId && !this.targets.has(targetHref)) this.targets.set(targetHref, {
            principalId: principalId,
            target: target
        });
        return !!this.modules.set(id, {
            ...mod,
            id: id,
            targetHref: targetHref,
            fetchedAt: now,
            tokenIssuedAt: mod.options["access-token"] ? now : 0,
            principalId: principalId
        });
    }
    removeModule(id) {
        return this.modules.delete(id);
    }
    removeModules() {
        this.targets.clear();
        this.modules.clear();
    }
    isModuleExpired(mod) {
        return mod.fetchedAt + (0, $9T9zK.TIME_CACHED) <= Date.now();
    }
    getAll() {
        return Array.from(this.modules.values());
    }
    findModules(...filters) {
        return (0, $dlEaa.getModules)(this.getAll(), ...filters);
    }
    hasExpiredModule(...filters) {
        return this.findModules(...filters).some(this.isModuleExpired);
    }
    filterModules(...filters) {
        return this.findModules(...filters).filter((m)=>!this.isModuleExpired(m));
    }
    /**
   * Gets modules from the cache if they are not expired. If some are expired, it will filter out those
   * modules and send a request to the Modules API to fetch them. After the fetch is complete, the cache
   * is updated and the original request completed.
   * @param {string} principalId - the principal account the module is installed on.
   * @param {Array} requests - an array of ConnectModuleRequest objects.
   */ async getModules(principalId, ...requests) {
        const responses = await this.fetchModules(principalId, ...requests);
        // @ts-ignore TODO: fix noImplicitAny error here
        responses.forEach(({ target: target, modules: modules })=>// @ts-ignore TODO: fix noImplicitAny error here
            modules.forEach((m)=>this.addModule(m, target, principalId)));
        return (0, $dlEaa.getModules)(this.getAll(), ...requests.reduce((a, r)=>{
            return [
                ...a,
                ...r.modules.map((c)=>(0, $dlEaa.getFilter)(c, r.target))
            ];
        }, []));
    }
    /**
   * Fetches modules directly from the modules API. If any appKey or moduleKey is contained within
   * the request object array, they will be appended as url params. The function also caches a reference
   * to the request and concatenates subsequent requests with the same url as to avoid duplicate requests.
   * @param {string} principalId - the principal account the module is installed on.
   * @param {Array} requests - an array of ConnectModuleRequest objects.
   */ // eslint-disable-next-line require-await
    async fetchModules(principalId, ...requests) {
        const params = {};
        const body = [];
        requests.forEach(({ target: target, modules: modules })=>{
            const _modules = [];
            modules.forEach(({ appKey: appKey, moduleKey: moduleKey, moduleType: moduleType, location: location })=>{
                if (appKey && (!params.app_key || !params.app_key.some((v)=>v === appKey))) {
                    params.app_key = params.app_key || [];
                    params.app_key.push(appKey);
                }
                if (moduleKey && (!params.module_key || !params.module_key.some((v)=>v === moduleKey))) {
                    params.module_key = params.module_key || [];
                    params.module_key.push(moduleKey);
                }
                if (moduleType) _modules.push(location ? `${moduleType}:${location}` : moduleType);
            });
            body.push({
                target: target,
                modules: _modules
            });
        });
        let url = `/!api/internal/connect/modules/${principalId}`;
        if (Object.keys(params).length > 0) url = `${url}?${(0, (/*@__PURE__*/$parcel$interopDefault($56wKm))).stringify(params)}`;
        return (0, $9T9zK.fetchCachedRequest)(url, body);
    }
    /**
   * Gets an authentication token from modules API reponse by moduleId. If it is expired,
   * a new token will be requested the cache will be updated.
   * @param {string} id - moduleId (combination of appKey, moduleKey & targetHref)
   * @param {boolean} forceUpdate - forces cache to get new token from API
   */ async getToken(id, forceUpdate, extensionId = "", skipFlag = false) {
        const mod = this.modules.get(id);
        if (!mod) throw $c441f02dfc80476a$var$errorResponse($6VgSH.MODULE_NOT_FOUND);
        const { app_name: appName, options: { "client-id": clientId, "user-denied": userDenied, "access-token": accessToken, "callback-url": callbackUrl, "access-token-expires-in": accessTokenExpiresIn, scopes: scopes }, tokenIssuedAt: tokenIssuedAt } = mod;
        if (!this.currentUser.isAuthenticated) {
            if (!accessToken) // If the user is not authenticated and there is no accessToken, assume public access, else throw error.
            return {
                access_token: "",
                expires_in: 0,
                scopes: "",
                token_type: "",
                unauthenticated: true
            };
            throw $c441f02dfc80476a$var$errorResponse($6VgSH.USER_NOT_AUTHENTICATED);
        }
        if (!clientId) throw $c441f02dfc80476a$var$errorResponse($6VgSH.NO_OAUTH_CONSUMER_CLIENT_ID);
        if (String(userDenied) === "true") throw $c441f02dfc80476a$var$errorResponse($6VgSH.USER_ALREADY_DENIED_ACCESS);
        let acceptOrDeny;
        const acceptOrDenyOptions = {
            moduleId: id,
            name: appName,
            scopes: scopes,
            skipFlag: skipFlag
        };
        if (!accessToken) {
            // The only reason you should hit this code path is
            // if the addon includes an oauthConsumer in the descriptor
            acceptOrDeny = await (0, $cR5Y3.onAcceptOrDenyAsync)(acceptOrDenyOptions);
            if (!acceptOrDeny.accepted) throw $c441f02dfc80476a$var$errorResponse($6VgSH.USER_DENIED_ACCESS);
        }
        const iframe = document.getElementById(extensionId);
        if (!iframe || !callbackUrl || (0, $8TjKB.getUrlOrigin)(iframe.src) !== (0, $8TjKB.getUrlOrigin)(callbackUrl)) throw $c441f02dfc80476a$var$errorResponse($6VgSH.FRAME_SRC_CONSUMER_CALLBACK_MISMATCH);
        if (accessToken && !forceUpdate) {
            const tokenExpiresIn = accessTokenExpiresIn * 1000;
            const tokenExpiresAt = tokenIssuedAt + tokenExpiresIn - 3000; // 3000ms buffer time for token expiry
            if (tokenExpiresAt > Date.now()) return {
                access_token: accessToken,
                expires_in: accessTokenExpiresIn,
                scopes: scopes,
                token_type: "bearer"
            };
        }
        const params = {
            client_id: clientId,
            grant_type: "urn:bitbucket:oauth2:session",
            redirect_uri: iframe.src,
            // This (disallow_creation) by default will be set to true. The only reason it should
            // be set to false is if the connect app is using an OAuthConsumer in their descriptor.
            // When set to false, it will give the requesting app permission (a token) so it can
            // make requests over the bridge using AP.request.
            disallow_creation: !acceptOrDeny || !acceptOrDeny.accepted
        };
        const response = await fetch((0, $2zjAG.default)("/site/oauth2/access_token", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: (0, (/*@__PURE__*/$parcel$interopDefault($56wKm))).stringify(params)
        }));
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.includes("application/json")) {
            if (!response.ok) {
                if (acceptOrDeny) this.grantOAuthConsumer(acceptOrDenyOptions, false);
                throw await response.json();
            }
            const data = await response.json();
            const _mod = this.modules.get(id);
            if (!_mod) throw $c441f02dfc80476a$var$errorResponse($6VgSH.MODULE_NOT_FOUND);
            if (acceptOrDeny) this.grantOAuthConsumer(acceptOrDenyOptions, true);
            const options = {
                ..._mod.options,
                "access-token": data.access_token,
                "access-token-expires-in": data.expires_in
            };
            this.modules.set(_mod.id, {
                ..._mod,
                options: options,
                tokenIssuedAt: Date.now()
            });
            // don't send refresh token
            const { refresh_token: _, ...res } = data;
            return res;
        }
        if (acceptOrDeny) this.grantOAuthConsumer(acceptOrDenyOptions, false);
        throw $c441f02dfc80476a$var$errorResponse($6VgSH.INVALID_RESPONSE, response.statusText);
    }
    /**
   * The following functions provide getters/setters for handling lecacy oauth
   * flows within connect apps. Ideally this would live in a seperate class called OAuth.
   * For now it has been added to the AddonManager.
   */ /**
   * Expose function to attach event hander that listens to OAuth emit event.
   */ /**
   * Setters for OAuth conusmer handlers
   */ setDenyOAuthHandler(fn) {
        this._denyOAuthConsumer = fn;
    }
    setGrantOAuthHandler(fn) {
        this._grantOAuthConsumer = fn;
    }
    /**
   * Get for OAuth conusmer handlers
   */ setOAuthScopesHandler(fn) {
        this._getOAuthScopes = fn;
    }
    getOAuthScopes(onSuccess, onError) {
        if (!(0, $8TjKB.isFunction)(this._getOAuthScopes)) throw new Error("getOAuthScopes() must be set by setOAuthScopesHandler()");
        return this._getOAuthScopes(onSuccess, onError);
    }
    /**
   * The setManagePermissionsUrlProvider is used by the UI to show a link onSuccess
   * that will take the user to manage page.
   */ setManagePermissionsUrlProvider(provider) {
        this._managePermissionsUrlProvider = provider;
    }
    getManagePermissionsUrl() {
        if (!(0, $8TjKB.isFunction)(this._managePermissionsUrlProvider)) throw new Error("managePermissionsUrlProvider() must be set by setManagePermissionsUrlProvider()");
        return this._managePermissionsUrlProvider();
    }
    /**
   * In the legacy oauth access token flow we show a dialog to allow
   * the user to approve or deny scopes. This denyOAuthConsumer() enables
   * the host to set the behaviour that is triggered when the user denies the
   * app access to their account, which at this point in time should result in a PUT
   * to the /internal/consumers/<client id>/denials API.
   */ denyOAuthConsumer(moduleId, onSuccess, onError) {
        if (!(0, $8TjKB.isFunction)(this._denyOAuthConsumer)) throw new Error("denyOAuthConsumer() must be set by setDenyOAuthHandler()");
        this._denyOAuthConsumer(moduleId, onSuccess, onError);
    }
    /**
   * In the legacy oauth access token flow we show a dialog to allow
   * the user to approve or deny scopes, and if the access token request fails
   * we need to replace that UI with the appropriate error flag,
   * which we trigger by calling grantOauthConsumer() with args to
   * indicate success or failure.
   */ grantOAuthConsumer(options, isGranted) {
        if (!(0, $8TjKB.isFunction)(this._grantOAuthConsumer)) return;
        this._grantOAuthConsumer(options, isGranted);
    }
}
var $c441f02dfc80476a$export$2e2bcd8739ae039 = new $c441f02dfc80476a$export$7bfc2a4e72a0f8a0();

});
parcelRegister("56wKm", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $3b76ea1f94494b1f$export$f9380c9a627682d3; }, function (v) { return $3b76ea1f94494b1f$export$f9380c9a627682d3 = v; });
$parcel$export(module.exports, "parse", function () { return $3b76ea1f94494b1f$export$98e6a39c04603d36; }, function (v) { return $3b76ea1f94494b1f$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $3b76ea1f94494b1f$export$fac44ee5b035f737; }, function (v) { return $3b76ea1f94494b1f$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parseUrl", function () { return $3b76ea1f94494b1f$export$7a5253c0f62e0150; }, function (v) { return $3b76ea1f94494b1f$export$7a5253c0f62e0150 = v; });
var $3b76ea1f94494b1f$export$f9380c9a627682d3;
var $3b76ea1f94494b1f$export$98e6a39c04603d36;
var $3b76ea1f94494b1f$export$fac44ee5b035f737;
var $3b76ea1f94494b1f$export$7a5253c0f62e0150;
"use strict";

var $ikss7 = parcelRequire("ikss7");

var $de9zv = parcelRequire("de9zv");

var $ao5Xc = parcelRequire("ao5Xc");
function $3b76ea1f94494b1f$var$encoderForArrayFormat(opts) {
    switch(opts.arrayFormat){
        case "index":
            return function(key, value, index) {
                return value === null ? [
                    $3b76ea1f94494b1f$var$encode(key, opts),
                    "[",
                    index,
                    "]"
                ].join("") : [
                    $3b76ea1f94494b1f$var$encode(key, opts),
                    "[",
                    $3b76ea1f94494b1f$var$encode(index, opts),
                    "]=",
                    $3b76ea1f94494b1f$var$encode(value, opts)
                ].join("");
            };
        case "bracket":
            return function(key, value) {
                return value === null ? $3b76ea1f94494b1f$var$encode(key, opts) : [
                    $3b76ea1f94494b1f$var$encode(key, opts),
                    "[]=",
                    $3b76ea1f94494b1f$var$encode(value, opts)
                ].join("");
            };
        default:
            return function(key, value) {
                return value === null ? $3b76ea1f94494b1f$var$encode(key, opts) : [
                    $3b76ea1f94494b1f$var$encode(key, opts),
                    "=",
                    $3b76ea1f94494b1f$var$encode(value, opts)
                ].join("");
            };
    }
}
function $3b76ea1f94494b1f$var$parserForArrayFormat(opts) {
    var result;
    switch(opts.arrayFormat){
        case "index":
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                } else if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $3b76ea1f94494b1f$var$encode(value, opts) {
    if (opts.encode) return opts.strict ? $ikss7(value) : encodeURIComponent(value);
    return value;
}
function $3b76ea1f94494b1f$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    else if (typeof input === "object") return $3b76ea1f94494b1f$var$keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
function $3b76ea1f94494b1f$var$extract(str) {
    var queryStart = str.indexOf("?");
    if (queryStart === -1) return "";
    return str.slice(queryStart + 1);
}
function $3b76ea1f94494b1f$var$parse(str, opts) {
    opts = $de9zv({
        arrayFormat: "none"
    }, opts);
    var formatter = $3b76ea1f94494b1f$var$parserForArrayFormat(opts);
    // Create an object with no prototype
    // https://github.com/sindresorhus/query-string/issues/47
    var ret = Object.create(null);
    if (typeof str !== "string") return ret;
    str = str.trim().replace(/^[?#&]/, "");
    if (!str) return ret;
    str.split("&").forEach(function(param) {
        var parts = param.replace(/\+/g, " ").split("=");
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join("=") : undefined;
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : $ao5Xc(val);
        formatter($ao5Xc(key), val, ret);
    });
    return Object.keys(ret).sort().reduce(function(result, key) {
        var val = ret[key];
        if (Boolean(val) && typeof val === "object" && !Array.isArray(val)) // Sort object keys, not values
        result[key] = $3b76ea1f94494b1f$var$keysSorter(val);
        else result[key] = val;
        return result;
    }, Object.create(null));
}
$3b76ea1f94494b1f$export$f9380c9a627682d3 = $3b76ea1f94494b1f$var$extract;
$3b76ea1f94494b1f$export$98e6a39c04603d36 = $3b76ea1f94494b1f$var$parse;
$3b76ea1f94494b1f$export$fac44ee5b035f737 = function(obj, opts) {
    var defaults = {
        encode: true,
        strict: true,
        arrayFormat: "none"
    };
    opts = $de9zv(defaults, opts);
    if (opts.sort === false) opts.sort = function() {};
    var formatter = $3b76ea1f94494b1f$var$encoderForArrayFormat(opts);
    return obj ? Object.keys(obj).sort(opts.sort).map(function(key) {
        var val = obj[key];
        if (val === undefined) return "";
        if (val === null) return $3b76ea1f94494b1f$var$encode(key, opts);
        if (Array.isArray(val)) {
            var result = [];
            val.slice().forEach(function(val2) {
                if (val2 === undefined) return;
                result.push(formatter(key, val2, result.length));
            });
            return result.join("&");
        }
        return $3b76ea1f94494b1f$var$encode(key, opts) + "=" + $3b76ea1f94494b1f$var$encode(val, opts);
    }).filter(function(x) {
        return x.length > 0;
    }).join("&") : "";
};
$3b76ea1f94494b1f$export$7a5253c0f62e0150 = function(str, opts) {
    return {
        url: str.split("?")[0] || "",
        query: $3b76ea1f94494b1f$var$parse($3b76ea1f94494b1f$var$extract(str), opts)
    };
};

});
parcelRegister("ikss7", function(module, exports) {
"use strict";
module.exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
};

});

parcelRegister("ao5Xc", function(module, exports) {
"use strict";
var $7900c392ca53546a$var$token = "%[a-f0-9]{2}";
var $7900c392ca53546a$var$singleMatcher = new RegExp("(" + $7900c392ca53546a$var$token + ")|([^%]+?)", "gi");
var $7900c392ca53546a$var$multiMatcher = new RegExp("(" + $7900c392ca53546a$var$token + ")+", "gi");
function $7900c392ca53546a$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $7900c392ca53546a$var$decodeComponents(left), $7900c392ca53546a$var$decodeComponents(right));
}
function $7900c392ca53546a$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($7900c392ca53546a$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $7900c392ca53546a$var$decodeComponents(tokens, i).join("");
            tokens = input.match($7900c392ca53546a$var$singleMatcher) || [];
        }
        return input;
    }
}
function $7900c392ca53546a$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    var match = $7900c392ca53546a$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $7900c392ca53546a$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $7900c392ca53546a$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $7900c392ca53546a$var$customDecodeURIComponent(encodedURI);
    }
};

});


parcelRegister("eeWzj", function(module, exports) {

$parcel$export(module.exports, "editorSetSource", function () { return $41bfbd2a3257c7a0$export$64fc9c73d65ee273; });
$parcel$export(module.exports, "editorGetSource", function () { return $41bfbd2a3257c7a0$export$46172afed619b74d; });
$parcel$export(module.exports, "editorGetOriginalSource", function () { return $41bfbd2a3257c7a0$export$7a345621a44c8fc8; });
$parcel$export(module.exports, "editorResetSource", function () { return $41bfbd2a3257c7a0$export$191614576b1b9931; });
$parcel$export(module.exports, "editorRemoveSource", function () { return $41bfbd2a3257c7a0$export$176ac6e266175314; });
$parcel$export(module.exports, "editorAddListener", function () { return $41bfbd2a3257c7a0$export$950ce9e2254f35f2; });
$parcel$export(module.exports, "editorRemoveListener", function () { return $41bfbd2a3257c7a0$export$950e11ac0fa507d8; });
$parcel$export(module.exports, "editorEmit", function () { return $41bfbd2a3257c7a0$export$9c8e6ddc2f22b0a3; });
const $41bfbd2a3257c7a0$var$sources = [];
let $41bfbd2a3257c7a0$var$listeners = [];
function $41bfbd2a3257c7a0$var$getKey({ moduleId: moduleId = "" }) {
    return moduleId;
}
function $41bfbd2a3257c7a0$export$64fc9c73d65ee273(credentials, source) {
    const data = {
        key: $41bfbd2a3257c7a0$var$getKey(credentials),
        source: source
    };
    const index = $41bfbd2a3257c7a0$var$sources.findIndex((s)=>s.key === data.key);
    if (index > -1) {
        $41bfbd2a3257c7a0$var$sources.splice(index, 1, {
            ...data,
            originalSource: $41bfbd2a3257c7a0$var$sources[index].originalSource || $41bfbd2a3257c7a0$var$sources[index].source
        });
        return;
    }
    $41bfbd2a3257c7a0$var$sources.push(data);
}
function $41bfbd2a3257c7a0$export$46172afed619b74d(credentials, cb) {
    const key = $41bfbd2a3257c7a0$var$getKey(credentials);
    const data = $41bfbd2a3257c7a0$var$sources.find((s)=>s.key === key);
    cb(null, data ? data.source : "");
}
function $41bfbd2a3257c7a0$export$7a345621a44c8fc8(credentials, cb) {
    const key = $41bfbd2a3257c7a0$var$getKey(credentials);
    const data = $41bfbd2a3257c7a0$var$sources.find((s)=>s.key === key);
    cb(null, data ? data.originalSource || data.source : "");
}
function $41bfbd2a3257c7a0$export$191614576b1b9931(credentials, cb) {
    const key = $41bfbd2a3257c7a0$var$getKey(credentials);
    const data = $41bfbd2a3257c7a0$var$sources.find((s)=>s.key === key);
    let source = "";
    if (data) {
        source = data.originalSource || data.source;
        $41bfbd2a3257c7a0$export$64fc9c73d65ee273(credentials, source);
    }
    cb(null, source);
}
function $41bfbd2a3257c7a0$export$176ac6e266175314(credentials) {
    const key = $41bfbd2a3257c7a0$var$getKey(credentials);
    const dataIndex = $41bfbd2a3257c7a0$var$sources.findIndex((s)=>s.key === key);
    if (dataIndex > -1) $41bfbd2a3257c7a0$var$sources.splice(dataIndex, 1);
}
function $41bfbd2a3257c7a0$export$950ce9e2254f35f2(credentials, event, listener) {
    const key = $41bfbd2a3257c7a0$var$getKey(credentials);
    $41bfbd2a3257c7a0$var$listeners.push({
        key: key,
        event: event,
        listener: listener
    });
}
function $41bfbd2a3257c7a0$export$950e11ac0fa507d8(credentials, event) {
    const key = $41bfbd2a3257c7a0$var$getKey(credentials);
    $41bfbd2a3257c7a0$var$listeners = $41bfbd2a3257c7a0$var$listeners.filter(({ key: k, event: e })=>!(k === key && e === event));
}
function $41bfbd2a3257c7a0$export$9c8e6ddc2f22b0a3(credentials, event, data) {
    const key = $41bfbd2a3257c7a0$var$getKey(credentials);
    $41bfbd2a3257c7a0$var$listeners.filter(({ key: k, event: e })=>k === key && e === event).forEach(({ listener: listener })=>listener(data));
}

});

parcelRegister("6VgSH", function(module, exports) {

$parcel$export(module.exports, "INVALID_RESPONSE", function () { return $7b8d024838c00274$export$a95f69ec43d8404; });
$parcel$export(module.exports, "MODULE_NOT_FOUND", function () { return $7b8d024838c00274$export$68e14b71c106b502; });
$parcel$export(module.exports, "USER_NOT_AUTHENTICATED", function () { return $7b8d024838c00274$export$c26b5d6cae63407a; });
$parcel$export(module.exports, "ACCESS_TOKEN_REQUEST_FAILED", function () { return $7b8d024838c00274$export$9e52d73b5bbaf1a5; });
$parcel$export(module.exports, "NO_OAUTH_CONSUMER_CLIENT_ID", function () { return $7b8d024838c00274$export$3171b9dbd6e4287; });
$parcel$export(module.exports, "USER_ALREADY_DENIED_ACCESS", function () { return $7b8d024838c00274$export$eaa228b7eb64976c; });
$parcel$export(module.exports, "USER_DENIED_ACCESS", function () { return $7b8d024838c00274$export$7ff3800a2498d2d1; });
$parcel$export(module.exports, "FRAME_SRC_CONSUMER_CALLBACK_MISMATCH", function () { return $7b8d024838c00274$export$9bc0d918a5e5c8de; });
$parcel$export(module.exports, "errorMessage", function () { return $7b8d024838c00274$export$493b5823483d2c4e; });
$parcel$export(module.exports, "errorResponse", function () { return $7b8d024838c00274$export$f2c942c7480d96d; });
const $7b8d024838c00274$export$a95f69ec43d8404 = "INVALID_RESPONSE";
const $7b8d024838c00274$export$68e14b71c106b502 = "MODULE_NOT_FOUND";
const $7b8d024838c00274$export$c26b5d6cae63407a = "USER_NOT_AUTHENTICATED";
const $7b8d024838c00274$export$9e52d73b5bbaf1a5 = "ACCESS_TOKEN_REQUEST_FAILED";
const $7b8d024838c00274$export$3171b9dbd6e4287 = "NO_OAUTH_CONSUMER_CLIENT_ID";
const $7b8d024838c00274$export$eaa228b7eb64976c = "USER_ALREADY_DENIED_ACCESS";
const $7b8d024838c00274$export$7ff3800a2498d2d1 = "USER_DENIED_ACCESS";
const $7b8d024838c00274$export$9bc0d918a5e5c8de = "FRAME_SRC_CONSUMER_CALLBACK_MISMATCH";
function $7b8d024838c00274$export$493b5823483d2c4e(code) {
    switch(code){
        case $7b8d024838c00274$export$a95f69ec43d8404:
            return "Invalid response";
        case $7b8d024838c00274$export$68e14b71c106b502:
            return "Module not found";
        case $7b8d024838c00274$export$c26b5d6cae63407a:
            return "User is not authenticated";
        case $7b8d024838c00274$export$9e52d73b5bbaf1a5:
            return "Request for access token failed";
        case $7b8d024838c00274$export$3171b9dbd6e4287:
            return "App does not have an OAuth consumer client ID";
        case $7b8d024838c00274$export$eaa228b7eb64976c:
            return "User has already denied access to app";
        case $7b8d024838c00274$export$7ff3800a2498d2d1:
            return "User denied access to app";
        case $7b8d024838c00274$export$9bc0d918a5e5c8de:
            return "Module URL must start with the OAuth consumer callback URL";
        default:
            return "Error";
    }
}
function $7b8d024838c00274$export$f2c942c7480d96d(code, message) {
    return {
        code: code,
        message: message || $7b8d024838c00274$export$493b5823483d2c4e(code)
    };
}

});

parcelRegister("4Jv4i", function(module, exports) {

$parcel$export(module.exports, "linkerTargetSelfLink", function () { return $6b38c3e29877c61a$export$73a58e0166ae7a31; });

var $8TjKB = parcelRequire("8TjKB");
function $6b38c3e29877c61a$export$73a58e0166ae7a31(target, principalId = "") {
    if (!target || !principalId) return "";
    const appKey = (0, $8TjKB.getObjectValue)(target, "context.key");
    const linkKey = (0, $8TjKB.getObjectValue)(target, "module.descriptor.key");
    const text = (0, $8TjKB.getObjectValue)(target, "text");
    if (!appKey || !linkKey || !text) return "";
    return `internal_linker_match:${principalId}:${appKey}:${linkKey}:${text}`;
}

});

parcelRegister("dlEaa", function(module, exports) {

$parcel$export(module.exports, "getModules", function () { return $0929d43a4bb5fd0a$export$a4064eadfbbe1f8; });
$parcel$export(module.exports, "getFilter", function () { return $0929d43a4bb5fd0a$export$61ec8404f465cd36; });

var $8TjKB = parcelRequire("8TjKB");
function $0929d43a4bb5fd0a$var$matchModule({ id: id, app_key: akey, module_type: type, descriptor: { key: key, location: loc }, targetHref: href }, { moduleType: moduleType, moduleKey: moduleKey, moduleId: moduleId, appKey: appKey, targetHref: targetHref, location: location }) {
    return (!moduleId || moduleId === id) && (!appKey || appKey === akey) && (!moduleKey || moduleKey === key) && (!targetHref || targetHref === href) && (!moduleType || (0, $8TjKB.isString)(moduleType) && moduleType.toLowerCase() === type.toLowerCase()) && (!location || location === loc);
}
function $0929d43a4bb5fd0a$export$a4064eadfbbe1f8(modules, ...filters) {
    return filters.length ? modules.filter((m)=>filters.some((f)=>$0929d43a4bb5fd0a$var$matchModule(m, f))) : [];
}
function $0929d43a4bb5fd0a$export$61ec8404f465cd36(cred, target) {
    return {
        moduleType: cred.moduleType,
        moduleKey: cred.moduleKey,
        moduleId: cred.moduleId,
        appKey: cred.appKey,
        targetHref: cred.targetHref || (0, $8TjKB.getObjectValue)(target, "links.self.href"),
        location: cred.location
    };
}

});

parcelRegister("cR5Y3", function(module, exports) {

$parcel$export(module.exports, "onAcceptOrDenyAsync", function () { return $bca4e59e462748ff$export$277dcb340d0d71f7; });
$parcel$export(module.exports, "onEmitAcceptOrDeny", function () { return $bca4e59e462748ff$export$91c9e1e2628dc38d; });

var $123dl = parcelRequire("123dl");
const $bca4e59e462748ff$var$OAUTH_ACCEPT_OR_DENY_EVENT = "oauth-accept-deny";
const $bca4e59e462748ff$var$EMIT_OAUTH_ACCEPT_OR_DENY_EVENT = "emit-oauth-accept-deny";
const $bca4e59e462748ff$var$emitter = (0, $123dl.default)();
function $bca4e59e462748ff$export$c997a17811bb569a(fn) {
    $bca4e59e462748ff$var$emitter.on($bca4e59e462748ff$var$OAUTH_ACCEPT_OR_DENY_EVENT, fn);
    return ()=>$bca4e59e462748ff$var$emitter.off($bca4e59e462748ff$var$OAUTH_ACCEPT_OR_DENY_EVENT, fn);
}
async function $bca4e59e462748ff$export$277dcb340d0d71f7(opts) {
    $bca4e59e462748ff$var$emitter.emit($bca4e59e462748ff$var$EMIT_OAUTH_ACCEPT_OR_DENY_EVENT, opts);
    return new Promise((resolve)=>{
        const unlisten = $bca4e59e462748ff$export$c997a17811bb569a((args)=>{
            unlisten();
            resolve(args);
        });
    });
}
function $bca4e59e462748ff$export$73f57eecff448cc8(moduleId) {
    $bca4e59e462748ff$var$emitter.emit($bca4e59e462748ff$var$OAUTH_ACCEPT_OR_DENY_EVENT, {
        moduleId: moduleId,
        accepted: true
    });
}
function $bca4e59e462748ff$export$6cc836f47abd2935(moduleId) {
    $bca4e59e462748ff$var$emitter.emit($bca4e59e462748ff$var$OAUTH_ACCEPT_OR_DENY_EVENT, {
        moduleId: moduleId,
        accepted: false
    });
}
function $bca4e59e462748ff$export$91c9e1e2628dc38d(fn) {
    function emitFn(options) {
        fn(options, ()=>$bca4e59e462748ff$export$73f57eecff448cc8(options.moduleId), ()=>$bca4e59e462748ff$export$6cc836f47abd2935(options.moduleId));
    }
    $bca4e59e462748ff$var$emitter.on($bca4e59e462748ff$var$EMIT_OAUTH_ACCEPT_OR_DENY_EVENT, emitFn);
    return ()=>$bca4e59e462748ff$var$emitter.off($bca4e59e462748ff$var$EMIT_OAUTH_ACCEPT_OR_DENY_EVENT, emitFn);
}

});

parcelRegister("2zjAG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af1e426bfb76ab5e$export$2e2bcd8739ae039; });

var $86hZh = parcelRequire("86hZh");
const $af1e426bfb76ab5e$export$f39f459ffe3b5b2 = "csrftoken";
const $af1e426bfb76ab5e$export$7f697e417cb7a5a8 = "X-CSRFToken";
const $af1e426bfb76ab5e$export$81350727a0ff4e2e = (url)=>/^(?!https?:)/.test(url) || url.indexOf(location.origin) === 0;
function $af1e426bfb76ab5e$var$authRequest(url, options) {
    const headers = {};
    // never send tokens cross-(sub)domain
    if ($af1e426bfb76ab5e$export$81350727a0ff4e2e(url)) headers[$af1e426bfb76ab5e$export$7f697e417cb7a5a8] = (0, $86hZh.getCookie)($af1e426bfb76ab5e$export$f39f459ffe3b5b2) || "";
    return new Request(url, {
        credentials: "same-origin",
        ...options,
        headers: {
            ...headers,
            ...options.headers
        }
    });
}
var $af1e426bfb76ab5e$export$2e2bcd8739ae039 = $af1e426bfb76ab5e$var$authRequest;

});
parcelRegister("86hZh", function(module, exports) {

$parcel$export(module.exports, "getCookie", function () { return $5e5cd634610936ad$export$4be65e66cfa2648a; });

var $1Qo9y = parcelRequire("1Qo9y");

var $lHRVb = parcelRequire("lHRVb");

var $jtYt3 = parcelRequire("jtYt3");

var $JZBNd = parcelRequire("JZBNd");
function $5e5cd634610936ad$export$4be65e66cfa2648a(key) {
    try {
        if ((0, $lHRVb.fg)("platform.moonjelly.browser-storage-controls")) (0, $jtYt3.sendPackageOperationalEvent)({
            action: "usedGetCookie",
            attributes: {
                cookieKey: key
            }
        });
        return key ? (0, (/*@__PURE__*/$parcel$interopDefault($1Qo9y))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($1Qo9y))).get();
    } catch (e) {
        (0, $JZBNd.Logger).errorWithOperationalEvent({
            action: "usedGetCookieError",
            attributes: {
                cookieKey: key
            },
            message: "Failed to use get cookie. ".concat(e.message || "")
        });
    }
}

});
parcelRegister("1Qo9y", function(module, exports) {
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

});

parcelRegister("lHRVb", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $fcd770c78080b718$export$b40ec24ac8275656; });

var $jOCle = parcelRequire("jOCle");
function $fcd770c78080b718$export$ba05d765b8392e5e(flagResolver) {
    (0, $jOCle.setBooleanResolver)(flagResolver);
}
function $fcd770c78080b718$export$470e5c2be1411c89(name) {
    return (0, $jOCle.resolveBooleanFlag)(name);
}
function $fcd770c78080b718$export$b40ec24ac8275656(name) {
    return (0, $jOCle.resolveBooleanFlag)(name);
}

});
parcelRegister("jOCle", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $e6d06da214fc0956$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $e6d06da214fc0956$export$6333b6aff9fc6275; });

var $5b5YT = parcelRequire("5b5YT");

var $8ovux = parcelRequire("8ovux");
var $e6d06da214fc0956$var$pkgName = "@atlaskit/platform-feature-flags";
var $e6d06da214fc0956$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $e6d06da214fc0956$var$hasProcessEnv = typeof $8ovux !== "undefined" && typeof $8ovux.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $e6d06da214fc0956$var$ENV_ENABLE_PLATFORM_FF = $e6d06da214fc0956$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $e6d06da214fc0956$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $e6d06da214fc0956$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $e6d06da214fc0956$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $e6d06da214fc0956$var$ENV_ENABLE_PLATFORM_FF || $e6d06da214fc0956$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $e6d06da214fc0956$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $e6d06da214fc0956$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$e6d06da214fc0956$var$globalVar[$e6d06da214fc0956$export$7e41b1b2bdee3f98] = $e6d06da214fc0956$var$globalVar[$e6d06da214fc0956$export$7e41b1b2bdee3f98] || $e6d06da214fc0956$var$DEFAULT_PFF_GLOBAL;
function $e6d06da214fc0956$export$f2b591175b3e424c(resolver) {
    $e6d06da214fc0956$var$globalVar[$e6d06da214fc0956$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $e6d06da214fc0956$export$6333b6aff9fc6275(flagKey) {
    if ($e6d06da214fc0956$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $5b5YT.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $e6d06da214fc0956$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $e6d06da214fc0956$var$globalVar[$e6d06da214fc0956$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("5b5YT", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $3c529e8d7c184ea6$export$1c9f709888824e05; });
var $3c529e8d7c184ea6$var$_ref, $3c529e8d7c184ea6$var$_process, $3c529e8d7c184ea6$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $3c529e8d7c184ea6$var$TESTS_MODE = ($3c529e8d7c184ea6$var$_ref = (globalThis === null || globalThis === void 0 || ($3c529e8d7c184ea6$var$_process = globalThis.process) === null || $3c529e8d7c184ea6$var$_process === void 0 || ($3c529e8d7c184ea6$var$_process = $3c529e8d7c184ea6$var$_process.env) === null || $3c529e8d7c184ea6$var$_process === void 0 ? void 0 : $3c529e8d7c184ea6$var$_process.JEST_WORKER_ID) !== undefined, $3c529e8d7c184ea6$var$_ref !== void 0) ? $3c529e8d7c184ea6$var$_ref : false;
var $3c529e8d7c184ea6$var$DEBUG_MODE = !$3c529e8d7c184ea6$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($3c529e8d7c184ea6$var$_process2 = globalThis.process) === null || $3c529e8d7c184ea6$var$_process2 === void 0 || ($3c529e8d7c184ea6$var$_process2 = $3c529e8d7c184ea6$var$_process2.env) === null || $3c529e8d7c184ea6$var$_process2 === void 0 ? void 0 : $3c529e8d7c184ea6$var$_process2.NODE_ENV) !== "production";
var $3c529e8d7c184ea6$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$3c529e8d7c184ea6$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("jtYt3", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsClient", function () { return $e2efa1621c8862cf$export$fde53e78fd93a54d; });
$parcel$export(module.exports, "sendPackageOperationalEvent", function () { return $e2efa1621c8862cf$export$5bfe55348e7aebc1; });
$parcel$export(module.exports, "sendUIEvent", function () { return $e2efa1621c8862cf$export$1aecf263098db667; });
$parcel$export(module.exports, "sendScreenEvent", function () { return $e2efa1621c8862cf$export$22a3b1671f38a193; });
$parcel$export(module.exports, "sendTrackEvent", function () { return $e2efa1621c8862cf$export$1ba525b8a711eaac; });

var $kFnE9 = parcelRequire("kFnE9");

var $gJmMp = parcelRequire("gJmMp");
var $7xQTz = parcelRequire("7xQTz");

var $lHRVb = parcelRequire("lHRVb");

var $eHk0O = parcelRequire("eHk0O");

var $JZBNd = parcelRequire("JZBNd");

var $bPGlO = parcelRequire("bPGlO");

var $kK2Aq = parcelRequire("kK2Aq");
function $e2efa1621c8862cf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e2efa1621c8862cf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e2efa1621c8862cf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e2efa1621c8862cf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e2efa1621c8862cf$var$getEnvironment = function getEnvironment() {
    var hostname = window.location.hostname;
    if (hostname.includes(".dev.") || hostname.includes(".stg.")) return (0, $7xQTz.envType).STAGING;
    if (hostname.includes("localhost") || hostname.includes("ngrok") || hostname.includes("atlastunnel")) return (0, $7xQTz.envType).DEV;
    return (0, $7xQTz.envType).PROD;
};
var $e2efa1621c8862cf$export$78d7c0236b4fece9 = function getProductSubPath(path) {
    var subPath = "";
    if (!path) return subPath;
    var checkPath = function checkPath(match) {
        return new RegExp("^".concat(match, "(/|$)")).test(String(path));
    };
    if (checkPath("/wiki")) subPath = "/wiki";
    if (checkPath("/jira")) subPath = "/jira";
    if (checkPath("/compass")) subPath = "/compass";
    if (checkPath("/canvas")) subPath = "/canvas";
    if (checkPath("/servicedesk") || checkPath("/jira/servicedesk")) subPath = "/servicedesk";
    return subPath;
};
var $e2efa1621c8862cf$var$getProductFromDomain = function getProductFromDomain(domain) {
    if (domain === "https://trello.com") return "trello";
    return null;
};
var $e2efa1621c8862cf$export$fce3dd735e04d566 = function getContextualPageDetails() {
    var _window$location = window.location, origin = _window$location.origin, pathname = _window$location.pathname;
    var productPath = $e2efa1621c8862cf$export$78d7c0236b4fece9(pathname);
    var domain = "".concat(origin).concat(productPath);
    var product = $e2efa1621c8862cf$var$getProductFromDomain(domain) || productPath.slice(1);
    return {
        domain: domain,
        product: product
    };
};
var $e2efa1621c8862cf$var$decorateEventAttributes = function decorateEventAttributes(attributes) {
    var _getBscGlobalState$pr, _getBscGlobalState$pr2;
    var _getContextualPageDet = $e2efa1621c8862cf$export$fce3dd735e04d566(), domain = _getContextualPageDet.domain, product = _getContextualPageDet.product;
    return $e2efa1621c8862cf$var$_objectSpread({
        featureFlagOn: (0, $lHRVb.fg)("platform.moonjelly.browser-storage-controls"),
        packageName: (0, $bPGlO.packageName),
        packageVersion: (0, $bPGlO.packageVersion),
        domain: domain,
        isInCookieBannerExperiment1: (0, $lHRVb.fg)("platform.moonjelly.browser-storage-controls-experiment-one"),
        product: (_getBscGlobalState$pr = (_getBscGlobalState$pr2 = (0, $eHk0O.getBscGlobalState)().product) === null || _getBscGlobalState$pr2 === void 0 ? void 0 : _getBscGlobalState$pr2.toLowerCase()) !== null && _getBscGlobalState$pr !== void 0 ? _getBscGlobalState$pr : product
    }, attributes && attributes);
};
var $e2efa1621c8862cf$export$fde53e78fd93a54d = function() {
    var instance;
    return function() {
        try {
            if (!instance && (0, $eHk0O.getBscGlobalState)().analyticsEnabled) instance = new (0, $gJmMp.default)({
                env: $e2efa1621c8862cf$var$getEnvironment(),
                product: "atlassianCookies"
            }, {
                // useLegacyUrl tells the analytics client to make calls directly to Global Analytics Service.
                // When set to false, the client will use a stargate proxy for the current URL to send events
                // to GAS. Said another way:
                // true => events are sent to https://api-private.stg.atlassian.com/gasv3/api/v1/batch
                // false => events are sent to <the current domain>/gasv3/api/v1/batch
                //
                // By default, this should be set to false.  If you need to validate that analytics events
                // are being transmitted correctly in local dev, you can temporarily enable it since localhost
                // won't be able to proxy to GAS via stargate.
                useLegacyUrl: false,
                disableCookiePersistence: true
            });
        } catch (e) {
            // Log  errors thrown in constructor initialization for the AnalyticsWebClient
            (0, $JZBNd.Logger).error("Failed to initialize AnalyticsWebClient. ".concat(e));
        }
        if (!(0, $eHk0O.getBscGlobalState)().analyticsEnabled) return undefined;
        // Return the instance, even if it is undefined
        return instance;
    };
}();
function $e2efa1621c8862cf$export$5bfe55348e7aebc1(properties) {
    (0, $kK2Aq.withAnalyticsEventSampling)(properties.action, function() {
        var _getAnalyticsClient;
        return (_getAnalyticsClient = $e2efa1621c8862cf$export$fde53e78fd93a54d()) === null || _getAnalyticsClient === void 0 ? void 0 : _getAnalyticsClient.sendOperationalEvent({
            source: "package",
            actionSubject: "package",
            action: properties.action,
            attributes: $e2efa1621c8862cf$var$decorateEventAttributes(properties.attributes)
        });
    });
}
function $e2efa1621c8862cf$export$1aecf263098db667(properties) {
    var _getAnalyticsClient2;
    (_getAnalyticsClient2 = $e2efa1621c8862cf$export$fde53e78fd93a54d()) === null || _getAnalyticsClient2 === void 0 || _getAnalyticsClient2.sendUIEvent($e2efa1621c8862cf$var$_objectSpread($e2efa1621c8862cf$var$_objectSpread({}, properties), {}, {
        attributes: $e2efa1621c8862cf$var$decorateEventAttributes(properties.attributes)
    }));
}
function $e2efa1621c8862cf$export$22a3b1671f38a193(properties) {
    var _getAnalyticsClient3;
    (_getAnalyticsClient3 = $e2efa1621c8862cf$export$fde53e78fd93a54d()) === null || _getAnalyticsClient3 === void 0 || _getAnalyticsClient3.sendScreenEvent($e2efa1621c8862cf$var$_objectSpread($e2efa1621c8862cf$var$_objectSpread({}, properties), {}, {
        attributes: $e2efa1621c8862cf$var$decorateEventAttributes(properties.attributes)
    }));
}
function $e2efa1621c8862cf$export$1ba525b8a711eaac(properties) {
    var _getAnalyticsClient4;
    (_getAnalyticsClient4 = $e2efa1621c8862cf$export$fde53e78fd93a54d()) === null || _getAnalyticsClient4 === void 0 || _getAnalyticsClient4.sendTrackEvent($e2efa1621c8862cf$var$_objectSpread($e2efa1621c8862cf$var$_objectSpread({}, properties), {}, {
        attributes: $e2efa1621c8862cf$var$decorateEventAttributes(properties.attributes)
    }));
}

});
parcelRegister("gJmMp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2e284ebe81c7285$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $a8tNN = parcelRequire("a8tNN");

var $7xQTz = parcelRequire("7xQTz");

var $pFZdt = parcelRequire("pFZdt");

var $fgXF6 = parcelRequire("fgXF6");

var $f3Qv5 = parcelRequire("f3Qv5");

var $lNZy1 = parcelRequire("lNZy1");

var $3Zk7X = parcelRequire("3Zk7X");

var $edjHO = parcelRequire("edjHO");

var $hvPXQ = parcelRequire("hvPXQ");

var $azvPx = parcelRequire("azvPx");

var $6liBs = parcelRequire("6liBs");

var $lBUvv = parcelRequire("lBUvv");

var $7Pc1w = parcelRequire("7Pc1w");

var $1f4xI = parcelRequire("1f4xI");

var $fIr86 = parcelRequire("fIr86");

var $2e9ci = parcelRequire("2e9ci");

var $fAdJd = parcelRequire("fAdJd");

var $5jPqv = parcelRequire("5jPqv");

var $8hcO0 = parcelRequire("8hcO0");

var $cqtUi = parcelRequire("cqtUi");
function $c2e284ebe81c7285$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c2e284ebe81c7285$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c2e284ebe81c7285$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c2e284ebe81c7285$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $c2e284ebe81c7285$export$5df9262e102d0c32 = "/gateway/api/gasv3/api/v1";
const $c2e284ebe81c7285$var$LAST_SCREEN_EVENT_STORAGE_KEY = "last.screen.event";
class $c2e284ebe81c7285$export$2e2bcd8739ae039 {
    constructor(productInfo, settings = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_useStargate", (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_endsWith", (str, suffix)=>str.indexOf(suffix, str.length - suffix.length) !== -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_changeInternalUserId", (userId, anonymousId)=>{
            this.eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this.eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this.eventProcessor.getUser().setAnonymousId(anonymousId);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_createSubproductGetter", (subproduct)=>(0, $fgXF6.default)(subproduct, "Cannot get subproduct from the callback. Proceeding without it."));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_createEmbeddedProductGetter", (embeddedProduct)=>(0, $fgXF6.default)(embeddedProduct, "Cannot get embeddedProduct from the callback. Proceeding without it."));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_getLastScreenEvent", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($c2e284ebe81c7285$var$LAST_SCREEN_EVENT_STORAGE_KEY) || "");
            } catch (err) {
                this._safeSessionStorage.removeItem($c2e284ebe81c7285$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_setLastScreenEvent", (event)=>{
            this._safeSessionStorage.setItem($c2e284ebe81c7285$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_shouldEventBeDelayed", (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf("measurement") === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this.eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_fireEvent", (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $7xQTz.eventType).UI:
                case (0, $7xQTz.eventType).OPERATIONAL:
                case (0, $7xQTz.eventType).TRACK:
                    return this.eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $7xQTz.eventType).SCREEN:
                    return this.eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $7xQTz.eventType).IDENTIFY:
                    return this.eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_fireDelayedEvent", (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    "sentWithDelay"
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_delayEvent", (identifier, builtEvent, context, userInfo, callback)=>{
            this.eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_processEvent", (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "setEmbeddedProduct", (embeddedProduct)=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clearEmbeddedProduct", ()=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "setSubproduct", (subproduct)=>{
            this._productInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        });
        /**
     * Calling this function in the intialisation of the client in product
     * captures specified 'origin tracing' URL params and fires a single origin landed event
     * <p>
     * This function expects a mapping between the keys for any URL parameters
     *  that should be captured and removed for origin tracing
     * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
     * Each handler function should return an object with two items
     * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
     * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
     *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
     * </p>
     * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
     * e.g. from a share or email
     *
     * An example calling this function using an external decoding library, with taskSessionId specified to persist
     * analyticsWebClient.setOriginTracingHandlers({
          atlOrigin: encodedOrigin => {
              const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
              return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
          },
      });
     *
     * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
     * @this {AnalyticsWebClient}
     */ (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "setOriginTracingHandlers", (originParamHandlerMapping)=>{
            const capturedOriginTraces = this.originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== "undefined") this.task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (Object.keys(capturedOriginTraces).length > 0) return this.sendOperationalEvent({
                action: "landed",
                actionSubject: "origin",
                source: "webClient",
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "setTenantInfo", (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error("Missing tenantIdType");
            if (tenantIdType !== (0, $7xQTz.tenantType).NONE && !tenantId) throw new Error("Missing tenantId");
            if (!(0, $7xQTz.isType)((0, $7xQTz.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $7xQTz.objectValues)((0, $7xQTz.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clearTenantInfo", ()=>{
            this._tenantInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "setOrgInfo", (orgId)=>{
            if (!orgId) throw new Error("Missing orgId");
            this._orgInfo = {
                orgId: orgId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clearOrgInfo", ()=>{
            this._orgInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "setWorkspaceInfo", (workspaceId)=>{
            if (!workspaceId) throw new Error("Missing workspaceId");
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clearWorkspaceInfo", ()=>{
            this._workspaceInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "setUserInfo", (userIdType, userId)=>{
            (0, $3Zk7X.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clearUserInfo", ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "setAlias", (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error("Missing aliasType");
            if (!(0, $7xQTz.isType)((0, $7xQTz.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $7xQTz.objectValues)((0, $7xQTz.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clearAlias", ()=>{
            this._aliases = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "setGroup", (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error("Missing groupType");
            if (!(0, $7xQTz.isType)((0, $7xQTz.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $7xQTz.objectValues)((0, $7xQTz.groupType))}]`);
            this._groups[groupsKeyType] = group;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clearGroup", ()=>{
            this._groups = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "getAnonymousId", ()=>this._userInfo.anonymousId);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "setUIViewedAttributes", (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error("Missing uiViewedAttributes");
            if (typeof uiViewedAttributes !== "object" || Array.isArray(uiViewedAttributes)) throw new Error("Invalid uiViewedAttributes type, should be a non array object");
            this._uiViewedAttributes = $c2e284ebe81c7285$var$_objectSpread({}, uiViewedAttributes);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "getUIViewedAttributes", ()=>{
            return this._uiViewedAttributes;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clearUIViewedAttributes", ()=>{
            this._uiViewedAttributes = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "sendIdentifyEvent", (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $7xQTz.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        });
        /**
     * @deprecated
     * please use {@link sendScreenEvent instead)
     */ (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "sendPageEvent", (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        });
        /**
     * send screen event
     * @param event The event / For retrocompatibility event name is still supported here.
     * @param callback
     * @param attributes. Deprecated, will get ignored if using an event object as first param.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "sendScreenEvent", (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === "object") {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $3Zk7X.validateScreenEvent)(screenName);
            (0, $3Zk7X.validateContainers)(screenContainers);
            const builtEvent = (0, $f3Qv5.buildScreenEvent)(this._productInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = $c2e284ebe81c7285$var$_objectSpread({
                name: screenName
            }, builtEvent);
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $8hcO0.default)(callback, builtEventWithName));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "sendTrackEvent", (event, callback)=>{
            (0, $3Zk7X.validateTrackEvent)(event);
            const builtEvent = (0, $f3Qv5.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $7xQTz.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $f3Qv5.buildActionName)(event), builtEvent, this._context, (0, $8hcO0.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "sendUIEvent", (event, callback)=>{
            (0, $3Zk7X.validateUIEvent)(event);
            const builtEvent = (0, $f3Qv5.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $7xQTz.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $f3Qv5.buildActionName)(event), builtEvent, this._context, (0, $8hcO0.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "sendOperationalEvent", (event, callback)=>{
            (0, $3Zk7X.validateOperationalEvent)(event);
            const builtEvent = (0, $f3Qv5.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $7xQTz.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $f3Qv5.buildActionName)(event), builtEvent, this._context, (0, $8hcO0.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "startUIViewedEvent", (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = new (0, $fAdJd.default)(this._productInfo, ()=>({
                    embeddedProduct: this._productInfo.embeddedProduct(),
                    subproduct: this._productInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
            this._uiViewedEvent.start();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "stopUIViewedEvent", ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "resetUIViewedTimers", ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "startApdexEvent", (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "getApdexStart", (apdexEvent)=>this._apdexEvent.getStart(apdexEvent));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "stopApdexEvent", (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        });
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "startLowPriorityEventDelay", (timeout, callback)=>{
            this.eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "stopLowPriorityEventDelay", ()=>{
            this.eventDelayQueue.stopLowPriorityEventDelay();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "onEvent", (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error("Missing analyticsData");
            if (!analyticsData.eventType) throw new Error("Missing analyticsData.eventType");
            if (analyticsData.eventType === (0, $7xQTz.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $7xQTz.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $7xQTz.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $7xQTz.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $7xQTz.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $7xQTz.objectValues)((0, $7xQTz.eventType))}]`);
        });
        if (!productInfo) throw new Error("Missing productInfo");
        if (!productInfo.env) throw new Error("Missing productInfo.env");
        if (!productInfo.product) throw new Error("Missing productInfo.product");
        if (!(0, $7xQTz.isType)((0, $7xQTz.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $7xQTz.objectValues)((0, $7xQTz.envType))}]`);
        if (productInfo.perimeter && !(0, $7xQTz.isType)((0, $7xQTz.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be an perimeterType: [${(0, $7xQTz.objectValues)((0, $7xQTz.perimeterType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $7xQTz.originType).WEB;
        else if (!(0, $7xQTz.isType)((0, $7xQTz.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $7xQTz.objectValues)((0, $7xQTz.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $7xQTz.originType).WEB ? (0, $7xQTz.platformType).WEB : (0, $7xQTz.platformType).DESKTOP;
        else (0, $3Zk7X.validatePlatform)(productInfo);
        this.logger = settings.logger || console;
        this._productInfo = $c2e284ebe81c7285$var$_objectSpread($c2e284ebe81c7285$var$_objectSpread({}, productInfo), {}, {
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        });
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        this._context = (0, $f3Qv5.buildContext)(this._productInfo);
        this._safeSessionStorage = new (0, $7Pc1w.default)();
        const _useStargate = this._useStargate(settings.useStargate);
        const apiHost = settings.apiHost || (0, $6liBs.selectHost)({
            useStargate: _useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            envOverride: productInfo.envOverride
        });
        const apiHostProtocol = settings.apiHostProtocol || "https";
        const minRetryDelay = settings.minRetryDelay || 1000;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $cqtUi.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        this.eventProcessor = new (0, $edjHO.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this.logger,
            disableCookiePersistence: disableCookiePersistence
        });
        this._userInfo = {
            anonymousId: this.eventProcessor.getUser().getAnonymousId(settings === null || settings === void 0 ? void 0 : settings.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $azvPx.default)();
        this._tabTracking = new (0, $1f4xI.default)();
        this._sessionTracking = new (0, $lBUvv.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this.task = new (0, $fIr86.default)();
        this.originTracing = new (0, $hvPXQ.default)();
        // Init Apdex
        this._apdexEvent = new (0, $pFZdt.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === "function" ? settings.historyReplaceFn : (0, $5jPqv.defaultHistoryReplaceFn);
        this.eventDelayQueue = new (0, $lNZy1.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $2e9ci.default)();
        this._pageLoadId = (0, (/*@__PURE__*/$parcel$interopDefault($a8tNN)))();
        this._workspaceInfo = {};
        this._aliases = {};
        this._groups = {};
    }
}

});
parcelRegister("a8tNN", function(module, exports) {

var $a7DrL = parcelRequire("a7DrL");

var $d7Lp4 = parcelRequire("d7Lp4");
function $7611c4d5c60a9fcb$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $a7DrL)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $d7Lp4(rnds);
}
module.exports = $7611c4d5c60a9fcb$var$v4;

});
parcelRegister("a7DrL", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $75e9282972a682da$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($75e9282972a682da$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $75e9282972a682da$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $75e9282972a682da$var$getRandomValues($75e9282972a682da$var$rnds8);
        return $75e9282972a682da$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $75e9282972a682da$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $75e9282972a682da$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $75e9282972a682da$var$rnds;
    };
}

});

parcelRegister("d7Lp4", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $98e0b32355f3dd36$var$byteToHex = [];
for(var $98e0b32355f3dd36$var$i = 0; $98e0b32355f3dd36$var$i < 256; ++$98e0b32355f3dd36$var$i)$98e0b32355f3dd36$var$byteToHex[$98e0b32355f3dd36$var$i] = ($98e0b32355f3dd36$var$i + 0x100).toString(16).substr(1);
function $98e0b32355f3dd36$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $98e0b32355f3dd36$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $98e0b32355f3dd36$var$bytesToUuid;

});


parcelRegister("7xQTz", function(module, exports) {

$parcel$export(module.exports, "envType", function () { return $57e4a559d3f9a7be$export$56ac8ebc9870b1b9; });
$parcel$export(module.exports, "eventType", function () { return $57e4a559d3f9a7be$export$4c045e605d532c98; });
$parcel$export(module.exports, "platformType", function () { return $57e4a559d3f9a7be$export$6b4f396210e539f3; });
$parcel$export(module.exports, "originType", function () { return $57e4a559d3f9a7be$export$f73e9fcd368bb695; });
$parcel$export(module.exports, "tenantType", function () { return $57e4a559d3f9a7be$export$496f06ac2a964da2; });
$parcel$export(module.exports, "userType", function () { return $57e4a559d3f9a7be$export$1827adfd178b4870; });
$parcel$export(module.exports, "apdexType", function () { return $57e4a559d3f9a7be$export$99b37380a464d794; });
$parcel$export(module.exports, "desktopPlatforms", function () { return $57e4a559d3f9a7be$export$809831be6c4c6227; });
$parcel$export(module.exports, "webPlatforms", function () { return $57e4a559d3f9a7be$export$19c579398ad213e7; });
$parcel$export(module.exports, "originTracingType", function () { return $57e4a559d3f9a7be$export$62a500c02dc63ee; });
$parcel$export(module.exports, "objectValues", function () { return $57e4a559d3f9a7be$export$ad1854f4a08c15f8; });
$parcel$export(module.exports, "isType", function () { return $57e4a559d3f9a7be$export$26b9f946b448f23e; });
$parcel$export(module.exports, "perimeterType", function () { return $57e4a559d3f9a7be$export$bdd41749d2096e4b; });
$parcel$export(module.exports, "aliasType", function () { return $57e4a559d3f9a7be$export$a8c99e46b781d936; });
$parcel$export(module.exports, "groupType", function () { return $57e4a559d3f9a7be$export$e73680b18d9b7c6e; });
$parcel$export(module.exports, "envOverrides", function () { return $57e4a559d3f9a7be$export$12b75c708da5a04b; });
// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
let $57e4a559d3f9a7be$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
let $57e4a559d3f9a7be$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
let $57e4a559d3f9a7be$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
let $57e4a559d3f9a7be$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
let $57e4a559d3f9a7be$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
let $57e4a559d3f9a7be$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["HALP"] = "halp";
    return userType;
}({});
let $57e4a559d3f9a7be$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $57e4a559d3f9a7be$export$809831be6c4c6227 = Object.freeze([
    $57e4a559d3f9a7be$export$6b4f396210e539f3.DESKTOP,
    $57e4a559d3f9a7be$export$6b4f396210e539f3.MAC,
    $57e4a559d3f9a7be$export$6b4f396210e539f3.LINUX,
    $57e4a559d3f9a7be$export$6b4f396210e539f3.WINDOWS
]);
const $57e4a559d3f9a7be$export$19c579398ad213e7 = Object.freeze([
    $57e4a559d3f9a7be$export$6b4f396210e539f3.WEB,
    $57e4a559d3f9a7be$export$6b4f396210e539f3.MOBILE_WEB
]);
let $57e4a559d3f9a7be$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $57e4a559d3f9a7be$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $57e4a559d3f9a7be$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
let $57e4a559d3f9a7be$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
let $57e4a559d3f9a7be$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
let $57e4a559d3f9a7be$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
let $57e4a559d3f9a7be$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    envOverrides["FEDRAMP_MODERATE_SANDBOX"] = "fedramp-moderate-sandbox";
    return envOverrides;
}({});

});

parcelRegister("pFZdt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04d2e787e4c33127$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $7xQTz = parcelRequire("7xQTz");

var $azvPx = parcelRequire("azvPx");

var $heWuV = parcelRequire("heWuV");
function $04d2e787e4c33127$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $04d2e787e4c33127$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $04d2e787e4c33127$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $04d2e787e4c33127$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $04d2e787e4c33127$export$2e2bcd8739ae039 {
    constructor(onEvent, pageVisibility){
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_getEventKey", ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_getEventTimingByName", (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_getApdexFields", (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return $04d2e787e4c33127$var$_objectSpread($04d2e787e4c33127$var$_objectSpread({}, apdexTimings), {}, {
                apdex: apdexScore
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_getApdexTimings", (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_getStartTime", (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $7xQTz.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_getStopTime", ()=>this._performance.getTimeOrigin() + this._performance.now());
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_cleanApdexState", (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_getVisibilityFields", (event)=>{
            let isActiveTab;
            /**
       * For initialLoad type:
       * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
       *
       * For transition type:
       * 1. active status is tracked in active events map (_isActiveEvents)
       *
       * For any type, if startTime or stopTime is specified:
       * 1. If currently active (!_isHidden)
       */ if (event.type === (0, $7xQTz.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $7xQTz.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_calculateApdex", ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_validateStartEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== "string") throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== "string") throw new Error('Invalid "taskId" in Apdex start event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_validateStopEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== "string") throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== "string") throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $7xQTz.isType)((0, $7xQTz.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== "number") throw new Error('Invalid "threshold" in Apdex stop event');
            /*
       * For a transition, if the startTime was not specified,
       * the start event should have been present.
       */ if (!event.startTime && event.type === (0, $7xQTz.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === "number" && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== "number") throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_shouldSendEvent", (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== "number") return false;
            return true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_sendEvent", (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: "ui",
                action: "readyForUser",
                actionSubject: "ui",
                attributes: $04d2e787e4c33127$var$_objectSpread($04d2e787e4c33127$var$_objectSpread({}, event.additionalAttributes), {}, {
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                })
            }, callback);
        });
        if (!onEvent) throw new Error("Missing onEvent callback");
        if (typeof onEvent !== "function") throw new Error("Invalid onEvent, must be function");
        if (!(pageVisibility instanceof (0, $azvPx.default))) throw new Error("Invalid pageVisibility, must be PageVisibility class");
        this._startedEvents = new Map();
        this._performance = new (0, $heWuV.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback("apdexEvent", (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent($04d2e787e4c33127$var$_objectSpread($04d2e787e4c33127$var$_objectSpread($04d2e787e4c33127$var$_objectSpread({}, event), apdexFields), visibilityFields), callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
}

});
parcelRegister("azvPx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b25dd1a8c4fb2e9$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");
class $7b25dd1a8c4fb2e9$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_bindEventListeners", ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_handleVisibilityChange", ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        });
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== "undefined") {
            if (typeof document.hidden !== "undefined") {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = "hidden";
                this._visibilityChange = "visibilitychange";
            } else if (typeof document.msHidden !== "undefined") {
                this._isHidden = document.msHidden;
                this._hidden = "msHidden";
                this._visibilityChange = "msvisibilitychange";
            } else if (typeof document.webkitHidden !== "undefined") {
                this._isHidden = document.webkitHidden;
                this._hidden = "webkitHidden";
                this._visibilityChange = "webkitvisibilitychange";
            }
            if (typeof document.addEventListener !== "undefined" && this._hidden !== undefined) this._bindEventListeners();
        }
    }
    addCallback(name, fn) {
        if (typeof name !== "string") throw new Error("Invalid name, must be string");
        if (typeof fn !== "function") throw new Error("Invalid callback, must be function");
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
}

});

parcelRegister("heWuV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8d11ee739861118$export$2e2bcd8739ae039; });
class $c8d11ee739861118$export$2e2bcd8739ae039 {
    constructor(){
        this._performance = window.performance;
    }
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
}

});


parcelRegister("fgXF6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1e6a148a1f0fd59$export$2e2bcd8739ae039; });
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $b1e6a148a1f0fd59$var$isFunction = (possibleFn)=>typeof possibleFn === "function";
var $b1e6a148a1f0fd59$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($b1e6a148a1f0fd59$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("f3Qv5", function(module, exports) {

$parcel$export(module.exports, "buildActionFields", function () { return $af6fdc548a1f96ce$export$655ecf7241feac42; });
$parcel$export(module.exports, "buildScreenEvent", function () { return $af6fdc548a1f96ce$export$c7d9a5f56acc4b19; });
$parcel$export(module.exports, "buildActionName", function () { return $af6fdc548a1f96ce$export$9c5623a792efc9b0; });
$parcel$export(module.exports, "buildContext", function () { return $af6fdc548a1f96ce$export$3a7fe28f9bf4f3d9; });
$parcel$export(module.exports, "buildActionEvent", function () { return $af6fdc548a1f96ce$export$7bf451af4a8e3dd9; });

var $kFnE9 = parcelRequire("kFnE9");

var $7xQTz = parcelRequire("7xQTz");

var $cGNGd = parcelRequire("cGNGd");
function $af6fdc548a1f96ce$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $af6fdc548a1f96ce$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $af6fdc548a1f96ce$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $af6fdc548a1f96ce$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $af6fdc548a1f96ce$var$libraryVersion = "4.23.0";
function $af6fdc548a1f96ce$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $af6fdc548a1f96ce$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $af6fdc548a1f96ce$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $af6fdc548a1f96ce$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $af6fdc548a1f96ce$var$buildAliases(aliases) {
    if ($af6fdc548a1f96ce$var$isNotEmptyObject(aliases)) return {
        aliases: aliases
    };
    return undefined;
}
function $af6fdc548a1f96ce$var$buildGroups(groups) {
    if ($af6fdc548a1f96ce$var$isNotEmptyObject(groups)) return {
        groups: groups
    };
    return undefined;
}
function $af6fdc548a1f96ce$var$buildEventOverrides(event) {
    if (event.anonymousId) return {
        anonymousId: event.anonymousId
    };
    return {};
}
function $af6fdc548a1f96ce$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $af6fdc548a1f96ce$var$buildProductFields(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = $af6fdc548a1f96ce$var$getProductField(productInfo.env, overrides.env);
    const product = $af6fdc548a1f96ce$var$getProductField(productInfo.product, overrides.product);
    const subproduct = $af6fdc548a1f96ce$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    const version = $af6fdc548a1f96ce$var$getProductField(productInfo.version, overrides.version);
    const origin = $af6fdc548a1f96ce$var$getProductField(productInfo.origin, overrides.origin);
    const platform = $af6fdc548a1f96ce$var$getProductField(productInfo.platform, overrides.platform);
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $af6fdc548a1f96ce$var$isNotEmptyObject(obj) {
    return (0, $cGNGd.isPlainObject)(obj) && Object.keys(obj).length > 0;
}
function $af6fdc548a1f96ce$var$buildAttributesWithName(name, attrObject) {
    return $af6fdc548a1f96ce$var$isNotEmptyObject(attrObject) ? {
        [name]: attrObject
    } : undefined;
}
function $af6fdc548a1f96ce$var$buildAttributes(attributes) {
    return $af6fdc548a1f96ce$var$buildAttributesWithName("attributes", attributes);
}
function $af6fdc548a1f96ce$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $af6fdc548a1f96ce$export$f045f238d77c002a(containers) {
    if ($af6fdc548a1f96ce$var$isNotEmptyObject(containers)) {
        const validContainers = $af6fdc548a1f96ce$export$3f5115a568819c1a(containers);
        return $af6fdc548a1f96ce$var$buildAttributesWithName("containers", validContainers);
    }
    return undefined;
}
function $af6fdc548a1f96ce$export$655ecf7241feac42(event, actionEventType) {
    return $af6fdc548a1f96ce$var$_objectSpread({
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType
    }, $af6fdc548a1f96ce$export$f045f238d77c002a(event.containers));
}
function $af6fdc548a1f96ce$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $af6fdc548a1f96ce$var$buildAttributesWithName("nonPrivacySafeAttributes", nonPrivacySafeAttributes);
}
function $af6fdc548a1f96ce$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, event, containers, aliases, groups) {
    const productFields = $af6fdc548a1f96ce$var$buildProductFields(productInfo);
    const tenantFields = $af6fdc548a1f96ce$var$buildTenantFields(tenantInfo);
    const userFields = $af6fdc548a1f96ce$var$buildUserFields(userInfo);
    const orgFields = $af6fdc548a1f96ce$var$buildOrgFields(orgInfo);
    const workspaceFields = $af6fdc548a1f96ce$var$buildWorkspaceFields(workspaceInfo);
    const overrides = {
        title: "",
        path: "",
        url: "",
        referrer: "",
        search: "",
        eventType: (0, $7xQTz.eventType).SCREEN
    };
    return $af6fdc548a1f96ce$var$_objectSpread($af6fdc548a1f96ce$var$_objectSpread($af6fdc548a1f96ce$var$_objectSpread($af6fdc548a1f96ce$var$_objectSpread($af6fdc548a1f96ce$var$_objectSpread($af6fdc548a1f96ce$var$_objectSpread($af6fdc548a1f96ce$var$_objectSpread($af6fdc548a1f96ce$var$_objectSpread($af6fdc548a1f96ce$var$_objectSpread($af6fdc548a1f96ce$var$_objectSpread($af6fdc548a1f96ce$var$_objectSpread($af6fdc548a1f96ce$var$_objectSpread({}, productFields), tenantFields), userFields), orgFields), overrides), $af6fdc548a1f96ce$var$buildAttributes(attributes)), $af6fdc548a1f96ce$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes)), $af6fdc548a1f96ce$export$f045f238d77c002a(containers)), $af6fdc548a1f96ce$var$buildEventOverrides(event)), {}, {
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields), $af6fdc548a1f96ce$var$buildAliases(aliases)), $af6fdc548a1f96ce$var$buildGroups(groups));
}
function $af6fdc548a1f96ce$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}
function $af6fdc548a1f96ce$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: "analytics.js",
                version: $af6fdc548a1f96ce$var$libraryVersion
            }
        }
    };
}
function $af6fdc548a1f96ce$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $af6fdc548a1f96ce$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, aliases, groups) {
    const productFields = $af6fdc548a1f96ce$var$buildProductFields(productInfo, $af6fdc548a1f96ce$export$e3d99b4bfec06f6e(event));
    const tenantFields = $af6fdc548a1f96ce$var$buildTenantFields(tenantInfo);
    const orgFields = $af6fdc548a1f96ce$var$buildOrgFields(orgInfo);
    const workspaceFields = $af6fdc548a1f96ce$var$buildWorkspaceFields(workspaceInfo);
    const userFields = $af6fdc548a1f96ce$var$buildUserFields(userInfo);
    const actionFields = $af6fdc548a1f96ce$export$655ecf7241feac42(event, actionEventType);
    return $af6fdc548a1f96ce$var$_objectSpread($af6fdc548a1f96ce$var$_objectSpread($af6fdc548a1f96ce$var$_objectSpread($af6fdc548a1f96ce$var$_objectSpread($af6fdc548a1f96ce$var$_objectSpread($af6fdc548a1f96ce$var$_objectSpread($af6fdc548a1f96ce$var$_objectSpread($af6fdc548a1f96ce$var$_objectSpread($af6fdc548a1f96ce$var$_objectSpread({}, productFields), tenantFields), orgFields), userFields), actionFields), $af6fdc548a1f96ce$var$buildEventOverrides(event)), {}, {
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields), $af6fdc548a1f96ce$var$buildAliases(aliases)), $af6fdc548a1f96ce$var$buildGroups(groups));
}

});
parcelRegister("cGNGd", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $93cff1abed77dade$export$53b83ca8eaab0383; });
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $93cff1abed77dade$var$isObject(val) {
    return val !== null && typeof val === "object" && Array.isArray(val) === false;
}
function $93cff1abed77dade$var$isObjectObject(o) {
    return $93cff1abed77dade$var$isObject(o) === true && Object.prototype.toString.call(o) === "[object Object]";
}
function $93cff1abed77dade$export$53b83ca8eaab0383(o) {
    if ($93cff1abed77dade$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== "function") return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($93cff1abed77dade$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!("isPrototypeOf" in prot)) return false;
    // Most likely a plain Object
    return true;
}

});


parcelRegister("lNZy1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdfdeaad73e42128$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $gPLHu = parcelRequire("gPLHu");

var $dIHUR = parcelRequire("dIHUR");

var $fSEHp = parcelRequire("fSEHp");
class $fdfdeaad73e42128$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "startLowPriorityEventDelay", (timeout = (0, $gPLHu.DEFAULT_DELAY_TIMEOUT), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $gPLHu.MAX_DELAY_TIMEOUT)) : (0, $gPLHu.MAX_DELAY_TIMEOUT);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $fSEHp.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "stopLowPriorityEventDelay", (reason = (0, $fSEHp.StopLowPriorityEventDelayReason).MANUAL)=>{
            var _this$delayCallback;
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            (_this$delayCallback = this.delayCallback) === null || _this$delayCallback === void 0 || _this$delayCallback.call(this, reason);
            this.delayCallback = undefined;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "isDelayingLowPriorityEvents", ()=>this.isDelaying);
        this.isDelaying = false;
        this.delayQueue = new (0, $dIHUR.default)(fireDelayedEvent, compressors);
    }
}

});
parcelRegister("gPLHu", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_DELAY_TIMEOUT", function () { return $c416690d97608fae$export$cf090d5281b5ae06; });
$parcel$export(module.exports, "MAX_DELAY_TIMEOUT", function () { return $c416690d97608fae$export$8575e30be0feb909; });
const $c416690d97608fae$export$cf090d5281b5ae06 = 10000;
const $c416690d97608fae$export$8575e30be0feb909 = 30000;

});

parcelRegister("dIHUR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fd1733b90397a1e$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $f3Qv5 = parcelRequire("f3Qv5");

var $gDOaN = parcelRequire("gDOaN");

var $j34XY = parcelRequire("j34XY");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $9fd1733b90397a1e$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $9fd1733b90397a1e$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $9fd1733b90397a1e$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "size", ()=>this.eventArgs.length);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "startFlush", ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn("Failed to perform compression on the delayed analytics events. " + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "cancelFlush", ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "flushNextBatch", ()=>{
            const batch = this.eventArgs.splice(0, $9fd1733b90397a1e$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $9fd1733b90397a1e$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "compressEventArgs", (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $gDOaN.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $gDOaN.equals)(group.userInfo, args.userInfo) && (0, $gDOaN.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $f3Qv5.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn("Failed to compress some analytics events. " + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        });
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $j34XY.default)(compressionRules);
    }
}

});
parcelRegister("gDOaN", function(module, exports) {

$parcel$export(module.exports, "mapKeys", function () { return $c1d735375024ae8f$export$781522908e4e76a1; });
$parcel$export(module.exports, "pick", function () { return $c1d735375024ae8f$export$357523c63a2253b9; });
$parcel$export(module.exports, "omitBy", function () { return $c1d735375024ae8f$export$d7a617dda645b4e3; });
$parcel$export(module.exports, "pickBy", function () { return $c1d735375024ae8f$export$b460b275d6c6aa0; });
$parcel$export(module.exports, "omit", function () { return $c1d735375024ae8f$export$30a06c8d3562193f; });
$parcel$export(module.exports, "equals", function () { return $c1d735375024ae8f$export$e9bab7fafb253603; });
$parcel$export(module.exports, "partition", function () { return $c1d735375024ae8f$export$b29f828819edca8d; });
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $c1d735375024ae8f$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $c1d735375024ae8f$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $c1d735375024ae8f$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $c1d735375024ae8f$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $c1d735375024ae8f$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $c1d735375024ae8f$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== "object" && typeof b !== "object") return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$c1d735375024ae8f$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $c1d735375024ae8f$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});

parcelRegister("j34XY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dde2265551aff551$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $f3Qv5 = parcelRequire("f3Qv5");

var $gDOaN = parcelRequire("gDOaN");

var $eb3vg = parcelRequire("eb3vg");
function $dde2265551aff551$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dde2265551aff551$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dde2265551aff551$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dde2265551aff551$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $dde2265551aff551$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "canCompress", (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event)));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "compress", (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "createGroups", (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $f3Qv5.buildActionFields)(event, event.eventType);
                    contextFields = (0, $gDOaN.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $gDOaN.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "compressGroup", (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>$dde2265551aff551$var$_objectSpread($dde2265551aff551$var$_objectSpread({}, actionFields), group.contextFields));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                console.warn("Failed to compress some analytics events. " + `Error: ${e.message}. Sending ${group.events.length} uncompressed events instead`);
                return group.events;
            }
        });
        if (!Array.isArray(compressionRules)) throw new Error("Event compressors must be constructed with an array of CompressionRules");
        if (!compressionRules.every((rule)=>rule instanceof (0, $eb3vg.CompressionRule))) throw new Error("Event compressors can only be constructed with instances of CompressionRule");
        this.compressionRules = compressionRules;
    }
}

});
parcelRegister("eb3vg", function(module, exports) {

$parcel$export(module.exports, "CompressionRule", function () { return $a524cf6c414ea132$export$89b3253ddfd2e6e8; });

var $kFnE9 = parcelRequire("kFnE9");

var $3Zk7X = parcelRequire("3Zk7X");

var $gDOaN = parcelRequire("gDOaN");
class $a524cf6c414ea132$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        /**
     * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
     * @param event
     * @returns {boolean}
     */ (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "canCompress", (event)=>{
            try {
                return event && (0, $3Zk7X.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        });
        /**
     * This function compresses as many events in the given collection as possible.<p>
     * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
     * appended to the end of the resulting array.
     *
     * @param events A collection of analytic events to compress
     * @returns {Array.<Object>} The action fields for the resulting compressed events
     */ (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "compress", (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $gDOaN.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error("No events were returned from the compression function");
            compressedEvents.forEach((event)=>{
                (0, $3Zk7X.validateActionEventType)(event.eventType);
                (0, $3Zk7X.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        });
        if (typeof predicate !== "function") throw new Error("Invalid predicate, must be a function that accepts an event and returns a boolean");
        if (typeof compressFn !== "function") throw new Error("Invalid compressFn, must be a function that both accepts and returns an array of events");
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

});
parcelRegister("3Zk7X", function(module, exports) {

$parcel$export(module.exports, "validateContainers", function () { return $2e76ae790480b0a4$export$e63ea5d8477971d3; });
$parcel$export(module.exports, "isActionEventType", function () { return $2e76ae790480b0a4$export$d19cebda16f7579a; });
$parcel$export(module.exports, "validateActionEventType", function () { return $2e76ae790480b0a4$export$4a8d7476662aebcc; });
$parcel$export(module.exports, "validateActionEvent", function () { return $2e76ae790480b0a4$export$e0c121325c66ed4c; });
$parcel$export(module.exports, "validateScreenEvent", function () { return $2e76ae790480b0a4$export$dc993432a592dc27; });
$parcel$export(module.exports, "validateTrackEvent", function () { return $2e76ae790480b0a4$export$8c014fd74b0c8b99; });
$parcel$export(module.exports, "validateUIEvent", function () { return $2e76ae790480b0a4$export$e5bac0930c812e90; });
$parcel$export(module.exports, "validateOperationalEvent", function () { return $2e76ae790480b0a4$export$1e561554275607ef; });
$parcel$export(module.exports, "validateIdentifyEvent", function () { return $2e76ae790480b0a4$export$c16a4e16aa4026c0; });
$parcel$export(module.exports, "validatePlatform", function () { return $2e76ae790480b0a4$export$801b46c35394d316; });

var $7xQTz = parcelRequire("7xQTz");

var $cGNGd = parcelRequire("cGNGd");
const $2e76ae790480b0a4$var$actionEventTypes = Object.freeze([
    (0, $7xQTz.eventType).OPERATIONAL,
    (0, $7xQTz.eventType).TRACK,
    (0, $7xQTz.eventType).UI
]);
function $2e76ae790480b0a4$export$df8ff30e3c960006(container) {
    if (!(0, $cGNGd.isPlainObject)(container)) throw new Error("properties.containers must be an Object");
    if (!("id" in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== "string") throw new Error("properties.containers.id must be of type String");
    if ("type" in container && typeof container.type !== "string") throw new Error("properties.containers.type must be of type String");
}
function $2e76ae790480b0a4$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error("properties.containers must be an Object");
    Object.values(containers).forEach((container)=>$2e76ae790480b0a4$export$df8ff30e3c960006(container));
}
function $2e76ae790480b0a4$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $7xQTz.eventType).OPERATIONAL:
        case (0, $7xQTz.eventType).TRACK:
        case (0, $7xQTz.eventType).UI:
            return true;
        default:
            return false;
    }
}
function $2e76ae790480b0a4$export$4a8d7476662aebcc(type) {
    if (!$2e76ae790480b0a4$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$2e76ae790480b0a4$var$actionEventTypes}]`);
    return true;
}
function $2e76ae790480b0a4$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error("Missing event");
    if (!event.source) throw new Error("Missing event.source");
    if (!event.actionSubject) throw new Error("Missing event.actionSubject");
    if (!event.action) throw new Error("Missing event.action");
    $2e76ae790480b0a4$export$e63ea5d8477971d3(event.containers);
}
function $2e76ae790480b0a4$export$dc993432a592dc27(name) {
    if (!name) throw new Error("Missing name");
}
function $2e76ae790480b0a4$export$8c014fd74b0c8b99(event) {
    $2e76ae790480b0a4$export$e0c121325c66ed4c(event);
}
function $2e76ae790480b0a4$export$39d6334da9a44984(event) {
    if (!event) throw new Error("Missing event");
    if (!event.source) throw new Error("Missing event.source");
    if (!event.actionSubject) throw new Error("Missing event.actionSubject");
}
function $2e76ae790480b0a4$export$e5bac0930c812e90(event) {
    $2e76ae790480b0a4$export$e0c121325c66ed4c(event);
}
function $2e76ae790480b0a4$export$1e561554275607ef(event) {
    $2e76ae790480b0a4$export$e0c121325c66ed4c(event);
}
function $2e76ae790480b0a4$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error("Missing userIdType");
    if (!userId) throw new Error("Missing userId");
    if (!(0, $7xQTz.isType)((0, $7xQTz.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $7xQTz.objectValues)((0, $7xQTz.userType))}]`);
}
function $2e76ae790480b0a4$export$801b46c35394d316(productInfo) {
    if (!(0, $7xQTz.isType)((0, $7xQTz.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $7xQTz.objectValues)((0, $7xQTz.platformType))}]`);
    if (productInfo.origin === (0, $7xQTz.originType).DESKTOP && !(0, $7xQTz.isType)((0, $7xQTz.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + "must be one of [mac, linux, windows]");
    if (productInfo.origin === (0, $7xQTz.originType).WEB && !(0, $7xQTz.isType)((0, $7xQTz.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});




parcelRegister("fSEHp", function(module, exports) {

$parcel$export(module.exports, "StopLowPriorityEventDelayReason", function () { return $b8fb7825f3a1c501$export$fa6e3729c21cb8f; });
let $b8fb7825f3a1c501$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("edjHO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a59190b24a218b48$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $a8tNN = parcelRequire("a8tNN");

var $6aEuj = parcelRequire("6aEuj");

var $5I2Kt = parcelRequire("5I2Kt");

var $1wFms = parcelRequire("1wFms");

var $lsYnI = parcelRequire("lsYnI");

var $7YloU = parcelRequire("7YloU");

var $4J0L1 = parcelRequire("4J0L1");

var $duMRy = parcelRequire("duMRy");

var $2fQxY = parcelRequire("2fQxY");
function $a59190b24a218b48$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a59190b24a218b48$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a59190b24a218b48$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a59190b24a218b48$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $a59190b24a218b48$export$2e2bcd8739ae039 {
    constructor(options){
        var _this$options;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "sendEvents", async (items, callback)=>{
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const metadata = $a59190b24a218b48$var$_objectSpread($a59190b24a218b48$var$_objectSpread({}, metricsPayload), {}, {
                httpRetryCount: httpRetryCount
            });
            for(let key in metadata)// @ts-ignore Some keys maybe a string, but these will never equal 0
            if (metadata[key] === 0) // @ts-ignore Save space in requests by removing metrics with no impact
            delete metadata[key];
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const unpackagedEvents = eventsWithXID.map((item)=>{
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            try {
                const response = await (0, $7YloU.sendEvents)({
                    url: this.gasv3BatchUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
            } catch (error) {
                callback(error, null);
            }
        });
        this.options = $a59190b24a218b48$var$_objectSpread($a59190b24a218b48$var$_objectSpread({}, options), {}, {
            requestTimeout: options.requestTimeout || (0, $lsYnI.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false
        });
        this.user = new (0, $duMRy.default)((_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $5I2Kt.default)();
        this.resilienceQueue = (0, $6aEuj.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.resilienceQueue.start(this.sendEvents);
    }
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $4J0L1.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = $a59190b24a218b48$var$_objectSpread($a59190b24a218b48$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $4J0L1.SegmentEventTypes).TRACK,
            properties: (0, $2fQxY.prepareEventProperties)(builtEvent),
            event: eventName
        });
        const event = $a59190b24a218b48$var$_objectSpread($a59190b24a218b48$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $4J0L1.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = $a59190b24a218b48$var$_objectSpread($a59190b24a218b48$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $4J0L1.SegmentEventTypes).PAGE,
            properties: (0, $2fQxY.prepareEventProperties)(builtEvent),
            name: eventName
        });
        const event = $a59190b24a218b48$var$_objectSpread($a59190b24a218b48$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $4J0L1.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = $a59190b24a218b48$var$_objectSpread($a59190b24a218b48$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $4J0L1.SegmentEventTypes).IDENTIFY,
            traits: (0, $2fQxY.prepareEventProperties)(builtEvent)
        });
        const event = $a59190b24a218b48$var$_objectSpread($a59190b24a218b48$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $2fQxY.prepareEventProperties)(context);
        const segmentContext = (0, $2fQxY.buildContext)(clonedContext);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, (/*@__PURE__*/$parcel$interopDefault($a8tNN)))()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                "Content-Type": "text/plain"
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $1wFms.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
}

});
parcelRegister("6aEuj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47e31548a6c1bae3$export$2e2bcd8739ae039; });

var $1KkV6 = parcelRequire("1KkV6");

var $47e31548a6c1bae3$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $1KkV6.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("1KkV6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $145a509360acb6f3$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $ck3dX = parcelRequire("ck3dX");
var $3m0Jy = parcelRequire("3m0Jy");

var $5BYa7 = parcelRequire("5BYa7");
var $SnVLc = parcelRequire("SnVLc");
var $4WtiD = parcelRequire("4WtiD");

var $5I2Kt = parcelRequire("5I2Kt");

var $1aKYG = parcelRequire("1aKYG");

var $fkSfk = parcelRequire("fkSfk");
var $lLhzi = parcelRequire("lLhzi");

var $5OSMg = parcelRequire("5OSMg");
function $145a509360acb6f3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $145a509360acb6f3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $145a509360acb6f3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $145a509360acb6f3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $145a509360acb6f3$var$ONE_MINUTE = 60000;
const $145a509360acb6f3$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $145a509360acb6f3$var$ONE_MINUTE,
    minRetryDelay: $145a509360acb6f3$var$ONE_MINUTE,
    maxRetryDelay: $145a509360acb6f3$var$ONE_MINUTE
};
const $145a509360acb6f3$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // TODO figure out this number. For indexeddb we are sharing the queue with all tabs
    maxItems: 1000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $145a509360acb6f3$export$2e2bcd8739ae039 {
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $SnVLc.default)(product, {
            logger: logger,
            maxAttempts: options === null || options === void 0 ? void 0 : options.maxAttempts,
            maxEventLimit: options === null || options === void 0 ? void 0 : options.maxItems
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $fkSfk.default)($145a509360acb6f3$var$_objectSpread($145a509360acb6f3$var$_objectSpread({}, this.options), {}, {
            waitInterval: options !== null && options !== void 0 && options.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }), this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $fkSfk.default)($145a509360acb6f3$var$_objectSpread($145a509360acb6f3$var$_objectSpread({}, $145a509360acb6f3$var$LONG_POLLING_OPTIONS), {}, {
            waitInterval: $145a509360acb6f3$var$LONG_POLLING_OPTIONS.flushWaitMs
        }), this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $5I2Kt.default)();
        this.networkStatus = new (0, $1aKYG.default)((status)=>{
            if (status === (0, $5OSMg.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $4WtiD.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $5OSMg.NetworkStatusEnum).OFFLINE) {
            done((0, $lLhzi.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $5BYa7.CallbackProcessingErrorName)) {
                done((0, $lLhzi.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $ck3dX.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $3m0Jy.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $4WtiD.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: "successful"
            };
            else return {
                status: "partial",
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $lLhzi.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error("batchFlushCallback has not been set. Call PullBatchableQueue#start first.");
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $lLhzi.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $lLhzi.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || $145a509360acb6f3$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : $145a509360acb6f3$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || $145a509360acb6f3$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || $145a509360acb6f3$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || $145a509360acb6f3$export$d219df4fe04c04a7.flushWaitMs,
            maxItems: (options === null || options === void 0 ? void 0 : options.maxItems) || $145a509360acb6f3$export$d219df4fe04c04a7.maxItems,
            maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || $145a509360acb6f3$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || $145a509360acb6f3$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || $145a509360acb6f3$export$d219df4fe04c04a7.minRetryDelay
        };
    }
}

});
parcelRegister("ck3dX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0250acd099901370$export$2e2bcd8739ae039; });

var $7Sp8F = parcelRequire("7Sp8F");

var $klJGG = parcelRequire("klJGG");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $0250acd099901370$var$validSuffixs = Object.values((0, $7Sp8F.LocalStorageKeySuffix));
var $0250acd099901370$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== "string" || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split(".")).filter((splitKeys)=>splitKeys.length === 3 && $0250acd099901370$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $7Sp8F.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $klJGG.createLocalStorageKeys)(prefix, id);
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("7Sp8F", function(module, exports) {

$parcel$export(module.exports, "LocalStorageKeySuffix", function () { return $5bc11399d0956601$export$ecfa71cbc9b28241; });
$parcel$export(module.exports, "Timers", function () { return $5bc11399d0956601$export$8bb2c1fb2b1765a9; });
let $5bc11399d0956601$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
let $5bc11399d0956601$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("klJGG", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageKeys", function () { return $ed093563ed2564f7$export$8433d54f767cbec5; });

var $7Sp8F = parcelRequire("7Sp8F");
const $ed093563ed2564f7$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $7Sp8F.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $7Sp8F.LocalStorageKeySuffix).ACK}`,
        [(0, $7Sp8F.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $7Sp8F.LocalStorageKeySuffix).QUEUE}`,
        [(0, $7Sp8F.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $7Sp8F.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $7Sp8F.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $7Sp8F.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $7Sp8F.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $7Sp8F.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("3m0Jy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2713fede065bf933$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $a8tNN = parcelRequire("a8tNN");

var $7Sp8F = parcelRequire("7Sp8F");

var $klJGG = parcelRequire("klJGG");
function $2713fede065bf933$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2713fede065bf933$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2713fede065bf933$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2713fede065bf933$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Code we need to mimic:
// https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L262-L357
// Note we do not want to run this library due to the performance, duplication and memory leak issues.
const $2713fede065bf933$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $2713fede065bf933$var$findOtherQueues = (queuePrefix)=>{
    try {
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split(".")).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $7Sp8F.LocalStorageKeySuffix).ACK) try {
                const ackTimestamp = localStorage.getItem(split.join("."));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $7Sp8F.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (error) {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch (_error) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $2713fede065bf933$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    localStorage.setItem(ack, start.toString());
    await $2713fede065bf933$var$promisedSetTimeout((0, $7Sp8F.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $7Sp8F.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error("Took to long to callback, reclaim abandonded. After reclaimStart.");
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $2713fede065bf933$var$promisedSetTimeout((0, $7Sp8F.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $7Sp8F.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error("Took to long to callback, reclaim abandonded. After reclaimEnd.");
    return $2713fede065bf933$var$reclaim(options, callback);
};
const $2713fede065bf933$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || "[]");
    const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || "{}");
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = $2713fede065bf933$var$_objectSpread($2713fede065bf933$var$_objectSpread({}, item), {}, {
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        });
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === "successful") $2713fede065bf933$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === "partial") {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            localStorage.removeItem(inProgress);
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $2713fede065bf933$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $2713fede065bf933$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $2713fede065bf933$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== "string" || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, (/*@__PURE__*/$parcel$interopDefault($a8tNN)))();
    const queuesToReclaim = $2713fede065bf933$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$2713fede065bf933$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $klJGG.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === "rejected");
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === "fulfilled").map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});

parcelRegister("5BYa7", function(module, exports) {

$parcel$export(module.exports, "CallbackProcessingErrorName", function () { return $415f136779c5bd06$export$a409c8de90e11e14; });
$parcel$export(module.exports, "default", function () { return $415f136779c5bd06$export$2e2bcd8739ae039; });
const $415f136779c5bd06$export$a409c8de90e11e14 = "CallbackProcessingError";
class $415f136779c5bd06$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === "object" && "toString" in error && typeof error.toString === "function" && error.toString();
        const messageFromString = typeof error === "string" && error;
        const message = messageFromError || messageFromString || "Argument passed to CallbackProcessingError was not an Error or string.";
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $415f136779c5bd06$export$2e2bcd8739ae039.prototype);
        this.name = $415f136779c5bd06$export$a409c8de90e11e14;
    }
}

});

parcelRegister("SnVLc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a379b61d5d467cc$export$2e2bcd8739ae039; });

var $gFiV2 = parcelRequire("gFiV2");

var $4WtiD = parcelRequire("4WtiD");

var $5BYa7 = parcelRequire("5BYa7");
var $0a379b61d5d467cc$export$2e2bcd8739ae039 = (0, $gFiV2.default);

});
parcelRegister("gFiV2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c21f269664fcf810$export$2e2bcd8739ae039; });

var $4WtiD = parcelRequire("4WtiD");

var $92CLW = parcelRequire("92CLW");
var $81ZCS = parcelRequire("81ZCS");

var $clsdc = parcelRequire("clsdc");

var $cYIEy = parcelRequire("cYIEy");

var $f8hVi = parcelRequire("f8hVi");
class $c21f269664fcf810$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $f8hVi.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== "string") throw new Error("Invalid namespace provided");
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $clsdc.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $92CLW.default))) {
                var _options$logger;
                (_options$logger = options.logger) === null || _options$logger === void 0 || _options$logger.warn("Attempted to create IndexedDbResilience but failed. Using memory instead.");
            }
        }
        return new (0, $cYIEy.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $4WtiD.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $4WtiD.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $81ZCS.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $4WtiD.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $cYIEy.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $4WtiD.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn("Unexpected error from ResilienceDb, switching to MemoryDb");
        // Dont need to catch. We are just getting events if we can
        }
    }
}

});
parcelRegister("4WtiD", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", function () { return $39934e811925873d$export$d21fbb25eb37b5bf; });
$parcel$export(module.exports, "RESILIENCE_DB_NAME", function () { return $39934e811925873d$export$8cad224051643259; });
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", function () { return $39934e811925873d$export$3d8420be07b276ab; });
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", function () { return $39934e811925873d$export$a512a65455fce2a6; });
$parcel$export(module.exports, "TIME_ADDED_INDEX", function () { return $39934e811925873d$export$89d9c1ff8ac91862; });
$parcel$export(module.exports, "RETRY_INDEX", function () { return $39934e811925873d$export$a37d385bcd713809; });
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", function () { return $39934e811925873d$export$6d8635fed0e4b14d; });
$parcel$export(module.exports, "StoreType", function () { return $39934e811925873d$export$39337ab5872e9457; });
$parcel$export(module.exports, "GuardPolicy", function () { return $39934e811925873d$export$7710d69e6f450f20; });
const $39934e811925873d$export$d21fbb25eb37b5bf = "namespace-timeAdded";
const $39934e811925873d$export$8cad224051643259 = "analytics-web-client";
const $39934e811925873d$export$3d8420be07b276ab = "analytics-resilience";
const $39934e811925873d$export$a512a65455fce2a6 = "timeToBeProcessedAfter";
const $39934e811925873d$export$89d9c1ff8ac91862 = "timeAdded";
const $39934e811925873d$export$a37d385bcd713809 = "retryAttempts";
const $39934e811925873d$export$6d8635fed0e4b14d = 15000;
let $39934e811925873d$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
let $39934e811925873d$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    GuardPolicy["IGNORE"] = "ignore";
    GuardPolicy["ABANDON"] = "abandon";
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("92CLW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $695260514c6fd594$export$2e2bcd8739ae039; });
const $695260514c6fd594$export$fc14cf6dcea0f8ed = "NoIndexedDbError";
class $695260514c6fd594$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super("window.indexeddb is undefined.");
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $695260514c6fd594$export$2e2bcd8739ae039.prototype);
        this.name = $695260514c6fd594$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("81ZCS", function(module, exports) {

$parcel$export(module.exports, "shouldIgnoreResilienceDbError", function () { return $5d8e386386829b62$export$74101021e0969375; });

var $7ypuM = parcelRequire("7ypuM");

var $5BYa7 = parcelRequire("5BYa7");

var $fMyKk = parcelRequire("fMyKk");
const $5d8e386386829b62$export$74101021e0969375 = (error)=>{
    if (error && typeof error === "object" && "name" in error) {
        const errorWithName = error;
        return typeof errorWithName.name === "string" && (errorWithName.name === (0, $7ypuM.AbandonWriteErrorName) || errorWithName.name === (0, $5BYa7.CallbackProcessingErrorName) || errorWithName.name === (0, $fMyKk.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("7ypuM", function(module, exports) {

$parcel$export(module.exports, "AbandonWriteErrorName", function () { return $57ff7c3d42439796$export$ba95206613c96b28; });
$parcel$export(module.exports, "default", function () { return $57ff7c3d42439796$export$2e2bcd8739ae039; });
const $57ff7c3d42439796$export$ba95206613c96b28 = "AbandonWriteError";
class $57ff7c3d42439796$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $57ff7c3d42439796$export$2e2bcd8739ae039.prototype);
        this.name = $57ff7c3d42439796$export$ba95206613c96b28;
    }
}

});

parcelRegister("fMyKk", function(module, exports) {

$parcel$export(module.exports, "InvalidPolicyErrorName", function () { return $b7d64a93088c9705$export$7e7aee9a953465ec; });
$parcel$export(module.exports, "default", function () { return $b7d64a93088c9705$export$2e2bcd8739ae039; });
const $b7d64a93088c9705$export$7e7aee9a953465ec = "InvalidPolicyError";
class $b7d64a93088c9705$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $b7d64a93088c9705$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("clsdc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fcd54831a3cf6ee$export$2e2bcd8739ae039; });

var $lOQkO = parcelRequire("lOQkO");

var $kFnE9 = parcelRequire("kFnE9");

var $4WtiD = parcelRequire("4WtiD");

var $eE5Iu = parcelRequire("eE5Iu");

var $5BYa7 = parcelRequire("5BYa7");
var $fMyKk = parcelRequire("fMyKk");
var $92CLW = parcelRequire("92CLW");
var $81ZCS = parcelRequire("81ZCS");

var $7OHir = parcelRequire("7OHir");

var $f8hVi = parcelRequire("f8hVi");
const $8fcd54831a3cf6ee$var$_excluded = [
    "item"
], $8fcd54831a3cf6ee$var$_excluded2 = [
    "items"
];
function $8fcd54831a3cf6ee$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8fcd54831a3cf6ee$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8fcd54831a3cf6ee$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8fcd54831a3cf6ee$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $8fcd54831a3cf6ee$export$2e2bcd8739ae039 {
    constructor(_namespace, _options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "startDB", async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== "undefined") {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn("IndexedDB timed out.");
                        reject(new (0, $92CLW.default)());
                    }, (0, $4WtiD.INDEXEDDB_TIMEOUT));
                    /*
           * The database version number can never change.
           * An upgrade transaction is limited to only one connection to the database.
           * Once this is done, we cannot open any connections with older versions of the schema.
           * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
           *
           * Due to the nature of how AWC is used (multiple tabs that are very long lived),
           * we will not be able to run version upgrades via indexeddb.
           *
           * This does not mean we cant change what is stored in the tables,
           * this limitation just prevents us from:
           *   - Creating new ObjectStores in this database connection, and
           *   - Creating new indexes on our ObjectStores
           *
           * Any upgrades we wish to run in the future will have to create a new database,
           * and migrate all the data from older databases.
           *
           * This also means any migrations we make will have to be supported until we have evidence
           * that no events are coming from old versions of the database.
           * This may take a long time.
           */ const request = window.indexedDB.open((0, $4WtiD.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error("We cannot upgrade the database. Do not do this.");
                        const db = request.result;
                        const store = db.createObjectStore((0, $4WtiD.RESILIENCE_STORE_NAME), {
                            keyPath: "id"
                        });
                        store.createIndex((0, $4WtiD.TIME_TO_PROCESS_AFTER_INDEX), (0, $4WtiD.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $4WtiD.RETRY_INDEX), (0, $4WtiD.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $4WtiD.TIME_ADDED_INDEX), (0, $4WtiD.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $4WtiD.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            "namespace",
                            "timeAdded"
                        ], {
                            unique: false
                        });
                    };
                    try {
                        await (0, $f8hVi.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn("IndexedDB failed to initialise.", error);
                        reject(new (0, $92CLW.default)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $92CLW.default)());
                }
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "addItem", async (item, options = {}, policy = (0, $4WtiD.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $f8hVi.convertToItemWrapper)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            if (policy === (0, $4WtiD.GuardPolicy).IGNORE) throw new (0, $fMyKk.default)(policy, "IndexedDbConnector#addItem");
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== "string") throw new Error("Namespace not specified");
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $81ZCS.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log("Failed to add item to table", error);
                throw new Error("Request to add item to table failed");
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "bulkAddItem", async (itemOptions, policy = (0, $4WtiD.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map((_ref)=>{
                let { item: item } = _ref, options = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $8fcd54831a3cf6ee$var$_excluded);
                return (0, $f8hVi.convertToItemWrapper)(item, namespace, options);
            });
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $81ZCS.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log("Failed to add item to table", error);
                throw new Error("Request to add item to table failed");
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "getItems", async (count = (0, $eE5Iu.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, $eE5Iu.GET_ITEM_COUNT);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            const timeIndex = objectStore.index((0, $4WtiD.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error("Failed to open cursor:", error);
                    reject("Failed to open cursor");
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = $8fcd54831a3cf6ee$var$_objectSpread({}, cursor.value);
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $eE5Iu.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $f8hVi.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $f8hVi.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $f8hVi.commitTransaction)(transaction, this.logger);
            return getResult;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "deleteItems", async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $f8hVi.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn("Failed to delete items from indexeddb.", error);
                throw error;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "getItemCount", async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction("readonly");
            const timeIndex = objectStore.index((0, $4WtiD.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $f8hVi.requestToPromise)(request);
            await (0, $f8hVi.commitTransaction)(transaction, this.logger);
            return event.target.result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "processItems", async (processFn, count = (0, $eE5Iu.GET_ITEM_COUNT))=>{
            const _await$this$getItems = await this.getItems(count), { items: items } = _await$this$getItems, partialResult = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_await$this$getItems, $8fcd54831a3cf6ee$var$_excluded2);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $5BYa7.default)(error);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "deleteItem", async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $f8hVi.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error("Failed to delete item:", id, error);
                throw error;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "getObjectStoreAndTransaction", async (mode)=>{
            const transaction = (await this.db).transaction((0, $4WtiD.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $4WtiD.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        });
        this.options = (0, $f8hVi.createOptionsWithDefaults)(_options);
        this.namespace = _namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $92CLW.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $7OHir.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    storeType() {
        return (0, $4WtiD.StoreType).INDEXEDDB;
    }
}

});
parcelRegister("eE5Iu", function(module, exports) {

$parcel$export(module.exports, "GET_ITEM_COUNT", function () { return $aa993c4a03cf340e$export$b6df3d334cec060f; });
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", function () { return $aa993c4a03cf340e$export$14ef152a03a4b6ee; });
$parcel$export(module.exports, "MAX_ATTEMPTS", function () { return $aa993c4a03cf340e$export$da9ab7b2fd5998e8; });
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", function () { return $aa993c4a03cf340e$export$1188664dfff364c8; });
const $aa993c4a03cf340e$export$b6df3d334cec060f = 7;
const $aa993c4a03cf340e$export$14ef152a03a4b6ee = 60000;
const $aa993c4a03cf340e$export$da9ab7b2fd5998e8 = 10;
const $aa993c4a03cf340e$export$1188664dfff364c8 = 5000;

});

parcelRegister("7OHir", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b0ec9b4a09f9e00$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $4WtiD = parcelRequire("4WtiD");

var $7ypuM = parcelRequire("7ypuM");

var $f8hVi = parcelRequire("f8hVi");
class $5b0ec9b4a09f9e00$export$2e2bcd8739ae039 {
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
     * This query fetches the oldest events currently stored in AWC IndexedDb object store
     * and deletes them sequentially
     */ (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "deleteOldestNEvents", async (objectStore, count)=>{
            var _target;
            const productTimeAddedIndex = objectStore.index((0, $4WtiD.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $f8hVi.requestToPromise)(getAllRequest);
            const result = event === null || event === void 0 || (_target = event.target) === null || _target === void 0 ? void 0 : _target.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn("Failed to delete items from indexeddb.", error);
                throw error;
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error("Event Limit has to be set higher than 1");
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $4WtiD.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $4WtiD.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $4WtiD.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $4WtiD.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $f8hVi.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $f8hVi.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $7ypuM.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $4WtiD.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $f8hVi.requestToPromise)(request);
        return event.target.result;
    }
}

});
parcelRegister("f8hVi", function(module, exports) {

$parcel$export(module.exports, "convertToItemWrapper", function () { return $b045818b1c88a6ae$export$aec476f33d77be11; });
$parcel$export(module.exports, "createOptionsWithDefaults", function () { return $b045818b1c88a6ae$export$ddc6718318090f71; });
$parcel$export(module.exports, "requestToPromise", function () { return $b045818b1c88a6ae$export$85ceed0783e42041; });
$parcel$export(module.exports, "commitTransaction", function () { return $b045818b1c88a6ae$export$feab8418f018df89; });
$parcel$export(module.exports, "monitorErrorsOnRequest", function () { return $b045818b1c88a6ae$export$342d941b6f724995; });

var $a8tNN = parcelRequire("a8tNN");

var $eE5Iu = parcelRequire("eE5Iu");
const $b045818b1c88a6ae$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, (/*@__PURE__*/$parcel$interopDefault($a8tNN)))(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });
const $b045818b1c88a6ae$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $eE5Iu.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $eE5Iu.EVENT_COUNT_LIMIT)
    });
const $b045818b1c88a6ae$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $b045818b1c88a6ae$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $b045818b1c88a6ae$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === "function") transaction.commit();
    } catch (error) {
        logger.error("Failed to force commit transaction:", error);
        throw error;
    }
    return $b045818b1c88a6ae$export$2a5213bce1720b42(transaction);
};
const $b045818b1c88a6ae$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn("Error thrown from request:", event);
    };
};

});



parcelRegister("cYIEy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $972db9c922e11d5d$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $4WtiD = parcelRequire("4WtiD");

var $eE5Iu = parcelRequire("eE5Iu");

var $5BYa7 = parcelRequire("5BYa7");
var $fMyKk = parcelRequire("fMyKk");

var $huTBY = parcelRequire("huTBY");

var $f8hVi = parcelRequire("f8hVi");
const $972db9c922e11d5d$var$_excluded = [
    "item"
], $972db9c922e11d5d$var$_excluded2 = [
    "items"
];
function $972db9c922e11d5d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $972db9c922e11d5d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $972db9c922e11d5d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $972db9c922e11d5d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $972db9c922e11d5d$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $f8hVi.createOptionsWithDefaults)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $huTBY.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $4WtiD.GuardPolicy).ABANDON) {
        if (policy === (0, $4WtiD.GuardPolicy).IGNORE) throw new (0, $fMyKk.default)(policy, "IndexedDbConnector#addItem");
        const storedValue = (0, $f8hVi.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $4WtiD.GuardPolicy).ABANDON) {
        const items = itemOptions.map((_ref)=>{
            let { item: item } = _ref, addOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $972db9c922e11d5d$var$_excluded);
            return (0, $f8hVi.convertToItemWrapper)(item, this.namespace, addOptions);
        });
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $4WtiD.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $eE5Iu.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $eE5Iu.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $eE5Iu.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push($972db9c922e11d5d$var$_objectSpread({}, wrappedItem));
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $eE5Iu.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const _this$synchronousGetI = this.synchronousGetItems(count), { items: items } = _this$synchronousGetI, partialGetResult = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_this$synchronousGetI, $972db9c922e11d5d$var$_excluded2);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $5BYa7.default)(error);
        }
    }
    storeType() {
        return (0, $4WtiD.StoreType).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
}

});
parcelRegister("huTBY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbd06045a6e42d1d$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $4WtiD = parcelRequire("4WtiD");

var $7ypuM = parcelRequire("7ypuM");
class $cbd06045a6e42d1d$export$2e2bcd8739ae039 {
    constructor(eventLimit, memoryItemHandlers){
        /**
     * Unlike IndexedDb, we cannot take advantage of any index. So we are,
     * treating the memory store as a sorted set when adding items.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "insertItemsToMemoryStore", (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $4WtiD.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $4WtiD.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $4WtiD.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error("Event Limit has to be set higher than 1");
        this.memoryItemHandlers = memoryItemHandlers;
    }
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $7ypuM.default)((0, $4WtiD.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
}

});




parcelRegister("5I2Kt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4283319aefe65a41$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $5OSMg = parcelRequire("5OSMg");
class $4283319aefe65a41$export$4b62ee5120ab50a8 {
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "itemsDiscardedByRetry", 0);
        // Number of events created by the product in current tab.
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "eventCount", 0);
        // Number of events discarded due to reaching queue max size.
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "itemsDiscardedByOverflow", 0);
        // Will be used in the future when we get more resilience mechanisms
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "resilienceMechanism", (0, $5OSMg.ResilienceMechanism).INDEXEDDB);
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "localstorageNumberOfQueuesPurged", 0);
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "localstorageNumberOfFullReclaims", 0);
        // Queue was found but not all events were able to be put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "localstorageNumberOfPartialReclaims", 0);
        // Reclaim failed for a queue and reclaim was abandonded.
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "localstorageNumberOfFailedReclaims", 0);
    }
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
}
let $4283319aefe65a41$var$cachedMetricsClient = null;
var $4283319aefe65a41$export$2e2bcd8739ae039 = ()=>{
    if (!$4283319aefe65a41$var$cachedMetricsClient) $4283319aefe65a41$var$cachedMetricsClient = new $4283319aefe65a41$export$4b62ee5120ab50a8();
    return $4283319aefe65a41$var$cachedMetricsClient;
};

});
parcelRegister("5OSMg", function(module, exports) {

$parcel$export(module.exports, "ResilienceMechanism", function () { return $43cc1cebf51c1578$export$c75161629e3ec34e; });
$parcel$export(module.exports, "NetworkStatusEnum", function () { return $43cc1cebf51c1578$export$ee138fa712d11b84; });
let $43cc1cebf51c1578$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
let $43cc1cebf51c1578$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});


parcelRegister("1aKYG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0dab2a676f48dc15$export$2e2bcd8739ae039; });

var $5OSMg = parcelRequire("5OSMg");
class $0dab2a676f48dc15$export$2e2bcd8739ae039 {
    constructor(networkChangeCallback){
        if (typeof window !== "undefined") {
            window.addEventListener("offline", ()=>networkChangeCallback((0, $5OSMg.NetworkStatusEnum).OFFLINE));
            window.addEventListener("online", ()=>networkChangeCallback((0, $5OSMg.NetworkStatusEnum).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $5OSMg.NetworkStatusEnum).ONLINE;
        return (0, $5OSMg.NetworkStatusEnum).OFFLINE;
    }
}

});

parcelRegister("fkSfk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2a2cd75ef102b4b$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $fh8aT = parcelRequire("fh8aT");

var $lLhzi = parcelRequire("lLhzi");
const $b2a2cd75ef102b4b$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
let $b2a2cd75ef102b4b$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $b2a2cd75ef102b4b$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "schedule", ({ immediate: immediate } = {
            immediate: false
        })=>{
            if (typeof window === "undefined") return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = $b2a2cd75ef102b4b$export$8bb92baee001fc60.IMMEDIATE;
                else if (this.queuedSchedule !== $b2a2cd75ef102b4b$export$8bb92baee001fc60.IMMEDIATE) this.queuedSchedule = $b2a2cd75ef102b4b$export$8bb92baee001fc60.WAIT;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Backoff
            } else if (this.failureCount > 0 && this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
            else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.options.waitInterval);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "stop", ()=>{
            this.clearTimeout();
            this.queuedSchedule = $b2a2cd75ef102b4b$export$8bb92baee001fc60.NONE;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "getFailureCount", ()=>this.failureCount);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "getCallbackStatus", ()=>{
            return this.callbackTimer.getCallbackStatus();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clearTimeout", ()=>{
            if (typeof window !== "undefined" && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "run", ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $lLhzi.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "done", (state)=>{
            this.operationInFlight = false;
            if (state === (0, $lLhzi.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $fh8aT.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $lLhzi.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "processQueuedSchedule", ()=>{
            if (this.queuedSchedule !== $b2a2cd75ef102b4b$export$8bb92baee001fc60.NONE) {
                const immediate = this.queuedSchedule === $b2a2cd75ef102b4b$export$8bb92baee001fc60.IMMEDIATE;
                this.queuedSchedule = $b2a2cd75ef102b4b$export$8bb92baee001fc60.NONE;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "calculateBackoff", ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage } = this.options;
            let ms = minRetryDelay * backoffFactor ** this.failureCount;
            if (backoffJitterPercentage) {
                const rand = Math.random();
                const deviation = Math.floor(rand * backoffJitterPercentage * ms);
                if (Math.floor(rand * 10) < 5) ms -= deviation;
                else ms += deviation;
            }
            return Number(Math.min(ms, maxRetryDelay).toPrecision(1));
        });
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $b2a2cd75ef102b4b$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $b2a2cd75ef102b4b$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $b2a2cd75ef102b4b$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $b2a2cd75ef102b4b$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $b2a2cd75ef102b4b$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $b2a2cd75ef102b4b$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = $b2a2cd75ef102b4b$export$8bb92baee001fc60.NONE;
        this.callbackTimer = new (0, $fh8aT.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

});
parcelRegister("fh8aT", function(module, exports) {

$parcel$export(module.exports, "CallbackStatus", function () { return $b1eec8deb7dd181b$export$ef3353088fca369c; });
$parcel$export(module.exports, "CallbackWithTimeout", function () { return $b1eec8deb7dd181b$export$590a718599f8f8b3; });

var $kFnE9 = parcelRequire("kFnE9");
let $b1eec8deb7dd181b$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
let $b1eec8deb7dd181b$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $b1eec8deb7dd181b$export$590a718599f8f8b3 {
    constructor(timeoutPeriod){
        // Milliseconds to wait
        // Tracks the settimeout; so that we can clear the timeout
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "timeoutHandle", undefined);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "callbackStatus", $b1eec8deb7dd181b$export$ef3353088fca369c.IDLE);
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error("CallbackWithTimeout requires timeout period higher than 0");
    }
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case $b1eec8deb7dd181b$export$ef3353088fca369c.IDLE:
            case $b1eec8deb7dd181b$export$ef3353088fca369c.TIMED_OUT:
            case $b1eec8deb7dd181b$export$ef3353088fca369c.COMPLETED:
                if (event === $b1eec8deb7dd181b$export$def7d978353eaa0.EXECUTE) this.callbackStatus = $b1eec8deb7dd181b$export$ef3353088fca369c.RUNNING;
                break;
            case $b1eec8deb7dd181b$export$ef3353088fca369c.RUNNING:
                switch(event){
                    case $b1eec8deb7dd181b$export$def7d978353eaa0.COMPLETE:
                        this.callbackStatus = $b1eec8deb7dd181b$export$ef3353088fca369c.COMPLETED;
                        break;
                    case $b1eec8deb7dd181b$export$def7d978353eaa0.TIMEOUT:
                        this.callbackStatus = $b1eec8deb7dd181b$export$ef3353088fca369c.TIMED_OUT;
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === "undefined") return;
        this.transitionCallbackStatus(this.callbackStatus, $b1eec8deb7dd181b$export$def7d978353eaa0.EXECUTE);
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, $b1eec8deb7dd181b$export$def7d978353eaa0.TIMEOUT);
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== $b1eec8deb7dd181b$export$ef3353088fca369c.TIMED_OUT) {
                this.transitionCallbackStatus(this.callbackStatus, $b1eec8deb7dd181b$export$def7d978353eaa0.COMPLETE);
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== "undefined" && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
}

});

parcelRegister("lLhzi", function(module, exports) {

$parcel$export(module.exports, "DoneState", function () { return $fd7b9d6f29bf0572$export$f93c40fda808dd0c; });
// Clients can optionally provide the callbackTimeoutPeriod parameter
let $fd7b9d6f29bf0572$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("1wFms", function(module, exports) {

$parcel$export(module.exports, "attachXidToMultipleEvents", function () { return $11c8dd1a573ab76e$export$c21270cab66ab290; });

var $kFnE9 = parcelRequire("kFnE9");

var $4J0L1 = parcelRequire("4J0L1");
function $11c8dd1a573ab76e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $11c8dd1a573ab76e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $11c8dd1a573ab76e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $11c8dd1a573ab76e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $11c8dd1a573ab76e$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $4J0L1.SegmentEventTypes).PAGE || item.msg.type === (0, $4J0L1.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = $11c8dd1a573ab76e$var$_objectSpread($11c8dd1a573ab76e$var$_objectSpread({}, item.msg.properties), {}, {
            xid: xid
        });
    } else if (item.msg.traits && item.msg.type === (0, $4J0L1.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = $11c8dd1a573ab76e$var$_objectSpread($11c8dd1a573ab76e$var$_objectSpread({}, item.msg.traits), {}, {
            xid: xid
        });
    }
    return item;
}
async function $11c8dd1a573ab76e$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>$11c8dd1a573ab76e$export$c9c3aaf655d6f275(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("4J0L1", function(module, exports) {

$parcel$export(module.exports, "SegmentEventTypes", function () { return $370bf3d04cf705cb$export$ddf929981dc6feb3; });
// Segment event types copied from our backend
// https://bitbucket.org/atlassian/analytics-service/src/master/api/src/main/java/com/atlassian/dataservices/analytics/service/api/segment/
let $370bf3d04cf705cb$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
let $370bf3d04cf705cb$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
let $370bf3d04cf705cb$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});

});


parcelRegister("lsYnI", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", function () { return $fa0b0cfea207d64e$export$9175ce0e1c95daf2; });
const $fa0b0cfea207d64e$export$9175ce0e1c95daf2 = 10000; // 10 seconds

});

parcelRegister("7YloU", function(module, exports) {

$parcel$export(module.exports, "sendEvents", function () { return $5cdebcbe3abf95b1$export$8e8f0180c1b41fad; });

var $kFnE9 = parcelRequire("kFnE9");

var $01mVa = parcelRequire("01mVa");
function $5cdebcbe3abf95b1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5cdebcbe3abf95b1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5cdebcbe3abf95b1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5cdebcbe3abf95b1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $5cdebcbe3abf95b1$export$8e8f0180c1b41fad = async (options)=>{
    var _createOrGetAbortCont;
    const signal = (_createOrGetAbortCont = $5cdebcbe3abf95b1$var$createOrGetAbortController(options)) === null || _createOrGetAbortCont === void 0 ? void 0 : _createOrGetAbortCont.signal;
    const corsOptions = $5cdebcbe3abf95b1$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, $5cdebcbe3abf95b1$var$_objectSpread({
        method: "POST",
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            "Content-Type": "text/plain"
        },
        body: JSON.stringify(options.batch),
        signal: signal
    }, corsOptions));
    if (response.status === 429 || response.status >= 500 && response.status < 600) throw new Error(`HTTP Error ${response.status} (${response.statusText})`);
    return response;
};
const $5cdebcbe3abf95b1$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $5cdebcbe3abf95b1$var$getCorsForUrl = (0, $01mVa.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: "cors",
        credentials: "include"
    };
});

});
parcelRegister("01mVa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0041dfc6105f6125$export$2e2bcd8739ae039; });
var $0041dfc6105f6125$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $0041dfc6105f6125$var$isEqual(first, second) {
    if (first === second) return true;
    if ($0041dfc6105f6125$var$safeIsNaN(first) && $0041dfc6105f6125$var$safeIsNaN(second)) return true;
    return false;
}
function $0041dfc6105f6125$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$0041dfc6105f6125$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $0041dfc6105f6125$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $0041dfc6105f6125$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("duMRy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d33fadac41387b1$export$2e2bcd8739ae039; });

var $1RBB8 = parcelRequire("1RBB8");

var $a8tNN = parcelRequire("a8tNN");

var $jx7M6 = parcelRequire("jx7M6");
var $132Xt = parcelRequire("132Xt");

var $5PHj7 = parcelRequire("5PHj7");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $9d33fadac41387b1$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $9d33fadac41387b1$var$SAFE = "SAFE";
const $9d33fadac41387b1$var$UNSAFE = "UNSAFE";
const $9d33fadac41387b1$var$NOT_FOUND = "NOT_FOUND";
const $9d33fadac41387b1$var$COOKIE = "COOKIE";
const $9d33fadac41387b1$var$LOCAL_STORAGE = "LOCAL_STORAGE";
class $9d33fadac41387b1$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.store = new (0, $5PHj7.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $132Xt.default)(disableCookiePersistence);
    }
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $jx7M6.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $jx7M6.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $9d33fadac41387b1$var$LOCAL_STORAGE ? this.store.getItem((0, $jx7M6.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $jx7M6.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $9d33fadac41387b1$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === "string") return {
                    type: $9d33fadac41387b1$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch (err) {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $9d33fadac41387b1$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($9d33fadac41387b1$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $1RBB8.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $9d33fadac41387b1$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $9d33fadac41387b1$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $9d33fadac41387b1$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $9d33fadac41387b1$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($9d33fadac41387b1$var$COOKIE);
        switch(cookieValue.type){
            case $9d33fadac41387b1$var$SAFE:
            case $9d33fadac41387b1$var$UNSAFE:
                this.store.setItem((0, $jx7M6.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $9d33fadac41387b1$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator = (0, (/*@__PURE__*/$parcel$interopDefault($a8tNN)))) {
        const newAnonId = customAnonymousIdGenerator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
}

});
parcelRegister("1RBB8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15b7e7dcc7479425$export$2e2bcd8739ae039; });

var $2vImn = parcelRequire("2vImn");

var $kzvKe = parcelRequire("kzvKe");

var $kYqHr = parcelRequire("kYqHr");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $15b7e7dcc7479425$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1; // Return 0 if diff is 0; return NaN if diff is NaN
    else return diff;
}
function $15b7e7dcc7479425$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $kYqHr.default)(2, arguments);
    var dateLeft = (0, $2vImn.default)(dirtyDateLeft);
    var dateRight = (0, $2vImn.default)(dirtyDateRight);
    var sign = $15b7e7dcc7479425$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $kzvKe.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference); // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($15b7e7dcc7479425$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull); // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("2vImn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d40e2f4731839b2$export$2e2bcd8739ae039; });

var $kYqHr = parcelRequire("kYqHr");
function $1d40e2f4731839b2$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $1d40e2f4731839b2$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $1d40e2f4731839b2$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $1d40e2f4731839b2$var$_typeof(obj);
}
function $1d40e2f4731839b2$export$2e2bcd8739ae039(argument) {
    (0, $kYqHr.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || $1d40e2f4731839b2$var$_typeof(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("kYqHr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f44e1f3f5141e288$export$2e2bcd8739ae039; });
function $f44e1f3f5141e288$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}

});


parcelRegister("kzvKe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef9fb35dca4597c3$export$2e2bcd8739ae039; });

var $jrQ16 = parcelRequire("jrQ16");

var $h1rDP = parcelRequire("h1rDP");

var $kYqHr = parcelRequire("kYqHr");
var $ef9fb35dca4597c3$var$MILLISECONDS_IN_DAY = 86400000;
function $ef9fb35dca4597c3$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $kYqHr.default)(2, arguments);
    var startOfDayLeft = (0, $h1rDP.default)(dirtyDateLeft);
    var startOfDayRight = (0, $h1rDP.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $jrQ16.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $jrQ16.default)(startOfDayRight); // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $ef9fb35dca4597c3$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("jrQ16", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e288e3656e0ec68f$export$2e2bcd8739ae039; });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $e288e3656e0ec68f$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("h1rDP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c647f8a9ac4b4490$export$2e2bcd8739ae039; });

var $2vImn = parcelRequire("2vImn");

var $kYqHr = parcelRequire("kYqHr");
function $c647f8a9ac4b4490$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kYqHr.default)(1, arguments);
    var date = (0, $2vImn.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("jx7M6", function(module, exports) {

$parcel$export(module.exports, "AWCCookiesKeys", function () { return $e387214bc32d46a1$export$202d555a5dbfd90c; });
$parcel$export(module.exports, "AllAnalyticsCookies", function () { return $e387214bc32d46a1$export$d4cb17942ea57c95; });
let $e387214bc32d46a1$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $e387214bc32d46a1$var$CookieSchema {
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
}
const $e387214bc32d46a1$export$d4cb17942ea57c95 = {
    [$e387214bc32d46a1$export$202d555a5dbfd90c.AWC_TLD_TEST]: new $e387214bc32d46a1$var$CookieSchema("__awc_tld_test__", {
        expires: 365,
        secure: window.location.protocol === "https:",
        path: "/"
    }),
    [$e387214bc32d46a1$export$202d555a5dbfd90c.AWC_ANALYTICS_DEBUG]: new $e387214bc32d46a1$var$CookieSchema("atlassian_analytics_debug", {
        expires: 365,
        secure: window.location.protocol === "https:",
        path: "/"
    }),
    [$e387214bc32d46a1$export$202d555a5dbfd90c.AJS_ANONYMOUS_ID]: new $e387214bc32d46a1$var$CookieSchema("ajs_anonymous_id", {
        expires: 365,
        secure: window.location.protocol === "https:",
        path: "/"
    })
};

});

parcelRegister("132Xt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c385dadd186928f$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $1Qo9y = parcelRequire("1Qo9y");

var $jx7M6 = parcelRequire("jx7M6");

var $c0CCO = parcelRequire("c0CCO");

var $GfKeH = parcelRequire("GfKeH");
function $0c385dadd186928f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0c385dadd186928f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0c385dadd186928f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0c385dadd186928f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $0c385dadd186928f$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $GfKeH.canUseCookie)(disableCookiePersistence) ? (0, (/*@__PURE__*/$parcel$interopDefault($1Qo9y))) : new (0, $c0CCO.default)();
    }
    set(name, value, options) {
        // no-op
        if (!(0, $jx7M6.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $jx7M6.AllAnalyticsCookies)[name].getKey(), value, $0c385dadd186928f$var$_objectSpread($0c385dadd186928f$var$_objectSpread({}, (0, $jx7M6.AllAnalyticsCookies)[name].getAttributes()), {}, {
            // Function is memoized so we only calculate this once per page load
            domain: (0, $GfKeH.getTld)()
        }, options));
    }
    get(name) {
        if (!(0, $jx7M6.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $jx7M6.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $jx7M6.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $jx7M6.AllAnalyticsCookies)[name].getKey(), $0c385dadd186928f$var$_objectSpread({}, options));
    }
}

});
parcelRegister("c0CCO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8be3724293329537$export$2e2bcd8739ae039; });

var $5PHj7 = parcelRequire("5PHj7");
class $8be3724293329537$export$2e2bcd8739ae039 {
    constructor(){
        this.safeStorage = new (0, $5PHj7.default)({
            useStoragePrefix: false
        });
    }
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
}

});
parcelRegister("5PHj7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43f34f22030e3271$export$2e2bcd8739ae039; });

var $d8XrT = parcelRequire("d8XrT");

var $kQKav = parcelRequire("kQKav");
class $43f34f22030e3271$export$2e2bcd8739ae039 extends (0, $kQKav.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.localStorage || (0, $d8XrT.default);
        } catch (err) {
            storageToUse = (0, $d8XrT.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("d8XrT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $991a230b08646309$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");
class $991a230b08646309$export$90e3e001bcac59c7 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_data", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "length", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "setItem", (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "getItem", (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "removeItem", (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clear", ()=>{
            this._data = {};
            this.length = 0;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "key", (index)=>Object.keys(this._data)[index]);
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$991a230b08646309$export$2e2bcd8739ae039 = new $991a230b08646309$export$90e3e001bcac59c7();

});

parcelRegister("kQKav", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2dc7a163b68537d$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $7xQTz = parcelRequire("7xQTz");

var $d8XrT = parcelRequire("d8XrT");
const $f2dc7a163b68537d$export$41c06fdd37b7e9a5 = "awc";
const $f2dc7a163b68537d$export$770aa8bc07b3de03 = "awcInMemoryStorageFallback";
function $f2dc7a163b68537d$export$48c17662a6902497(store) {
    const TEST_VALUE = "test_value";
    if (!store) return false;
    try {
        const key = "awc.storage.support";
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
function $f2dc7a163b68537d$export$6325979d1c67607f(e) {
    let quotaExceeded = false;
    if (e.code) switch(e.code){
        case 22:
            quotaExceeded = true;
            break;
        case 1014:
            // Firefox
            if (e.name === "NS_ERROR_DOM_QUOTA_REACHED") quotaExceeded = true;
            break;
        default:
            break;
    }
    else if (e.number === -2147024882) // Internet Explorer 8
    quotaExceeded = true;
    return quotaExceeded;
}
class $f2dc7a163b68537d$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "getStore", ()=>this._store);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "getItem", (key)=>this._store.getItem(this.createKey(key)));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "removeItem", (key)=>this._store.removeItem(this.createKey(key)));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "setItem", (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                if ($f2dc7a163b68537d$export$6325979d1c67607f(err)) {
                    this.swapToInMemory();
                    this._store.setItem(this.createKey(key), value);
                }
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "swapToInMemory", ()=>{
            if (this._store === (0, $d8XrT.default) || typeof window === "undefined") return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ($f2dc7a163b68537d$export$48c17662a6902497(window[$f2dc7a163b68537d$export$770aa8bc07b3de03])) inMemoryStorage = window[$f2dc7a163b68537d$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $d8XrT.default);
                if (!window[$f2dc7a163b68537d$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$f2dc7a163b68537d$export$770aa8bc07b3de03] = (0, $d8XrT.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clear", ()=>this._store.clear());
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "key", (index)=>this._store.key(index));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "getPrefix", ()=>this._prefix);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "createKey", (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        });
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($f2dc7a163b68537d$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $7xQTz.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join("-");
        if ($f2dc7a163b68537d$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

});



parcelRegister("GfKeH", function(module, exports) {

$parcel$export(module.exports, "canUseCookie", function () { return $07f022efa8cc9e9c$export$a9330601ee8f4d95; });
$parcel$export(module.exports, "getTld", function () { return $07f022efa8cc9e9c$export$de6821eed3d5f32d; });

var $1Qo9y = parcelRequire("1Qo9y");

var $01mVa = parcelRequire("01mVa");

var $jx7M6 = parcelRequire("jx7M6");
const $07f022efa8cc9e9c$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === "file:" || location.protocol === "chrome-extension:");
};
const $07f022efa8cc9e9c$export$eb80e1beaa8dacf8 = (0, $jx7M6.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $07f022efa8cc9e9c$export$19164982d36535d8 = "tld_test";
const $07f022efa8cc9e9c$export$de6821eed3d5f32d = (0, $01mVa.default)(()=>{
    if (typeof location === "undefined") return "";
    const { hostname: hostname } = location;
    const splitHostname = hostname.split(".");
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join(".")}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qo9y))).set($07f022efa8cc9e9c$export$eb80e1beaa8dacf8, $07f022efa8cc9e9c$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($1Qo9y))).get($07f022efa8cc9e9c$export$eb80e1beaa8dacf8) === $07f022efa8cc9e9c$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($1Qo9y))).remove($07f022efa8cc9e9c$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});



parcelRegister("2fQxY", function(module, exports) {

$parcel$export(module.exports, "buildContext", function () { return $1a45be36efcc1898$export$3a7fe28f9bf4f3d9; });
$parcel$export(module.exports, "prepareEventProperties", function () { return $1a45be36efcc1898$export$44d22e5fb02cc68e; });

var $kFnE9 = parcelRequire("kFnE9");

var $4CFKC = parcelRequire("4CFKC");
function $1a45be36efcc1898$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1a45be36efcc1898$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1a45be36efcc1898$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1a45be36efcc1898$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $1a45be36efcc1898$export$3a7fe28f9bf4f3d9 = (context)=>{
    return $1a45be36efcc1898$var$_objectSpread($1a45be36efcc1898$var$_objectSpread({}, context.context), {}, {
        userAgent: navigator.userAgent
    });
};
const $1a45be36efcc1898$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = $1a45be36efcc1898$export$2250ccecd1e040fd(properties);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4CFKC)))(propertiesWithoutUndefined);
};
const $1a45be36efcc1898$export$2250ccecd1e040fd = (obj)=>{
    if (obj === null || typeof obj !== "object") return obj;
    const clone = {};
    Object.keys(obj).forEach((key)=>{
        const value = $1a45be36efcc1898$var$getValueOfObject(obj, key);
        if (value !== undefined) {
            if (Array.isArray(value)) clone[key] = value.map((i)=>$1a45be36efcc1898$export$2250ccecd1e040fd(i));
            else if (typeof value === "object" && value !== null) clone[key] = $1a45be36efcc1898$export$2250ccecd1e040fd(value);
            else clone[key] = value;
        }
    });
    return clone;
};
// Using ts-ignore everywhere urked me
const $1a45be36efcc1898$var$getValueOfObject = (obj, key)=>{
    // @ts-ignore This is an object
    return obj[key];
};

});
parcelRegister("4CFKC", function(module, exports) {
"use strict";

var $4qBk0 = parcelRequire("4qBk0");
/**
 * Expose `traverse`.
 */ module.exports = $35db18e3223c6c45$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $35db18e3223c6c45$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === "object") return $35db18e3223c6c45$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $35db18e3223c6c45$var$traverseArray(input, strict);
    else if ($4qBk0.is(input, strict)) return $4qBk0.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $35db18e3223c6c45$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $35db18e3223c6c45$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $35db18e3223c6c45$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $35db18e3223c6c45$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("4qBk0", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $33968a73fa27a5b1$export$98e6a39c04603d36; }, function (v) { return $33968a73fa27a5b1$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "is", function () { return $33968a73fa27a5b1$export$226b3eccf92c9ed9; }, function (v) { return $33968a73fa27a5b1$export$226b3eccf92c9ed9 = v; });
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $33968a73fa27a5b1$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $33968a73fa27a5b1$export$226b3eccf92c9ed9;
"use strict";
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $33968a73fa27a5b1$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$33968a73fa27a5b1$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $33968a73fa27a5b1$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + "00").substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === " ") offset = new Date().getTimezoneOffset();
    else if (arr[9] !== "Z" && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === "+") offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$33968a73fa27a5b1$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== "string") return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $33968a73fa27a5b1$var$matcher.test(string);
};

});




parcelRegister("hvPXQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbfda3ee72498642$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $7xQTz = parcelRequire("7xQTz");

var $5jPqv = parcelRequire("5jPqv");
class $cbfda3ee72498642$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "handleOriginParameters", (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error("Empty parameter mapping provided");
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $7xQTz.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture and remove params from URL
            const capturedURLParams = (0, $5jPqv.default)(isCaptureParam, historyReplaceFn);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const extractedOriginID = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            return extractedOriginID;
        });
        this._originStore = {};
    }
}

});
parcelRegister("5jPqv", function(module, exports) {

$parcel$export(module.exports, "defaultHistoryReplaceFn", function () { return $3df69e52d8965215$export$600dd5bf1b049f11; });
$parcel$export(module.exports, "default", function () { return $3df69e52d8965215$export$2e2bcd8739ae039; });

var $8KNKM = parcelRequire("8KNKM");

var $gDOaN = parcelRequire("gDOaN");
const $3df69e52d8965215$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, "", newUrl);
const $3df69e52d8965215$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $3df69e52d8965215$export$600dd5bf1b049f11)=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== "" ? originalUrl.replace(fragmentHash, "") : originalUrl;
    const { url: url, query: query } = (0, $8KNKM.parseUrl)(removedFragmentURL);
    const captureParams = (0, $gDOaN.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $gDOaN.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $8KNKM.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var $3df69e52d8965215$export$2e2bcd8739ae039 = $3df69e52d8965215$var$urlParamExtractor;

});
parcelRegister("8KNKM", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $65f9369c699d26e3$export$f9380c9a627682d3; }, function (v) { return $65f9369c699d26e3$export$f9380c9a627682d3 = v; });
$parcel$export(module.exports, "parse", function () { return $65f9369c699d26e3$export$98e6a39c04603d36; }, function (v) { return $65f9369c699d26e3$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $65f9369c699d26e3$export$fac44ee5b035f737; }, function (v) { return $65f9369c699d26e3$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parseUrl", function () { return $65f9369c699d26e3$export$7a5253c0f62e0150; }, function (v) { return $65f9369c699d26e3$export$7a5253c0f62e0150 = v; });
$parcel$export(module.exports, "stringifyUrl", function () { return $65f9369c699d26e3$export$a8c1621ea79325d3; }, function (v) { return $65f9369c699d26e3$export$a8c1621ea79325d3 = v; });
$parcel$export(module.exports, "pick", function () { return $65f9369c699d26e3$export$357523c63a2253b9; }, function (v) { return $65f9369c699d26e3$export$357523c63a2253b9 = v; });
$parcel$export(module.exports, "exclude", function () { return $65f9369c699d26e3$export$44c361b8ec72ef7f; }, function (v) { return $65f9369c699d26e3$export$44c361b8ec72ef7f = v; });
var $65f9369c699d26e3$export$f9380c9a627682d3;
var $65f9369c699d26e3$export$98e6a39c04603d36;
var $65f9369c699d26e3$export$fac44ee5b035f737;
var $65f9369c699d26e3$export$7a5253c0f62e0150;
var $65f9369c699d26e3$export$a8c1621ea79325d3;
var $65f9369c699d26e3$export$357523c63a2253b9;
var $65f9369c699d26e3$export$44c361b8ec72ef7f;
"use strict";

var $gLmm0 = parcelRequire("gLmm0");

var $ao5Xc = parcelRequire("ao5Xc");

var $gqCsV = parcelRequire("gqCsV");

var $bH48Z = parcelRequire("bH48Z");
const $65f9369c699d26e3$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $65f9369c699d26e3$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $65f9369c699d26e3$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $65f9369c699d26e3$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $65f9369c699d26e3$var$encode(key, options),
                            "[",
                            $65f9369c699d26e3$var$encode(index, options),
                            "]=",
                            $65f9369c699d26e3$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $65f9369c699d26e3$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $65f9369c699d26e3$var$encode(key, options),
                            "[]=",
                            $65f9369c699d26e3$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $65f9369c699d26e3$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $65f9369c699d26e3$var$encode(key, options),
                            ":list=",
                            $65f9369c699d26e3$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $65f9369c699d26e3$var$encode(key, options),
                                keyValueSep,
                                $65f9369c699d26e3$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $65f9369c699d26e3$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $65f9369c699d26e3$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $65f9369c699d26e3$var$encode(key, options),
                            "=",
                            $65f9369c699d26e3$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $65f9369c699d26e3$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $65f9369c699d26e3$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $65f9369c699d26e3$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$65f9369c699d26e3$var$decode(item, options)) : value === null ? value : $65f9369c699d26e3$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $65f9369c699d26e3$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$65f9369c699d26e3$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $65f9369c699d26e3$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $65f9369c699d26e3$var$encode(value, options) {
    if (options.encode) return options.strict ? $gLmm0(value) : encodeURIComponent(value);
    return value;
}
function $65f9369c699d26e3$var$decode(value, options) {
    if (options.decode) return $ao5Xc(value);
    return value;
}
function $65f9369c699d26e3$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $65f9369c699d26e3$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $65f9369c699d26e3$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $65f9369c699d26e3$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $65f9369c699d26e3$var$extract(input) {
    input = $65f9369c699d26e3$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $65f9369c699d26e3$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $65f9369c699d26e3$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $65f9369c699d26e3$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $65f9369c699d26e3$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $gqCsV(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $65f9369c699d26e3$var$decode(value, options);
        formatter($65f9369c699d26e3$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $65f9369c699d26e3$var$parseValue(value[k], options);
        else ret[key] = $65f9369c699d26e3$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $65f9369c699d26e3$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$65f9369c699d26e3$export$f9380c9a627682d3 = $65f9369c699d26e3$var$extract;
$65f9369c699d26e3$export$98e6a39c04603d36 = $65f9369c699d26e3$var$parse;
$65f9369c699d26e3$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $65f9369c699d26e3$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $65f9369c699d26e3$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $65f9369c699d26e3$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $65f9369c699d26e3$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $65f9369c699d26e3$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $65f9369c699d26e3$var$encode(key, options) + "=" + $65f9369c699d26e3$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$65f9369c699d26e3$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $gqCsV(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $65f9369c699d26e3$var$parse($65f9369c699d26e3$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $65f9369c699d26e3$var$decode(hash, options)
    } : {});
};
$65f9369c699d26e3$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$65f9369c699d26e3$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $65f9369c699d26e3$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $65f9369c699d26e3$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $65f9369c699d26e3$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $65f9369c699d26e3$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $65f9369c699d26e3$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$65f9369c699d26e3$var$encodeFragmentIdentifier] ? $65f9369c699d26e3$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$65f9369c699d26e3$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$65f9369c699d26e3$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $65f9369c699d26e3$export$7a5253c0f62e0150(input, options);
    return $65f9369c699d26e3$export$a8c1621ea79325d3({
        url: url,
        query: $bH48Z(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$65f9369c699d26e3$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $65f9369c699d26e3$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("gLmm0", function(module, exports) {
"use strict";
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("gqCsV", function(module, exports) {
"use strict";
module.exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("bH48Z", function(module, exports) {
"use strict";
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});




parcelRegister("6liBs", function(module, exports) {

$parcel$export(module.exports, "selectHost", function () { return $49e3226afdf42e2d$export$18c0b81944902eae; });

var $7xQTz = parcelRequire("7xQTz");
const $49e3226afdf42e2d$var$PROD_HOST = "as.atlassian.com/api/v1";
const $49e3226afdf42e2d$var$STARGATE_PROD_HOST = "api-private.atlassian.com/gasv3/api/v1";
const $49e3226afdf42e2d$var$STAGING_HOST = "as.staging.atl-paas.net/api/v1";
const $49e3226afdf42e2d$var$STARGATE_STAGING_HOST = "api-private.stg.atlassian.com/gasv3/api/v1";
const $49e3226afdf42e2d$var$FEDRAMP_SANDBOX_HOST = "as.atlassian-fex.com/api/v1";
const $49e3226afdf42e2d$var$FEDRAMP_STAGING_HOST = "as.staging.atl-paas-us-gov-mod.net/api/v1";
const $49e3226afdf42e2d$var$FEDRAMP_PROD_HOST = "as.atlassian-us-gov-mod.com/api/v1";
const $49e3226afdf42e2d$var$STARGATE_FEDRAMP_STAGING_HOST = "api.stg.atlassian-us-gov-mod.com/gasv3/api/v1";
const $49e3226afdf42e2d$var$STARGATE_FEDRAMP_PROD_HOST = "api.atlassian-us-gov-mod.com/gasv3/api/v1";
const $49e3226afdf42e2d$var$STARGATE_FEDRAMP_SANDBOX_HOST = "api-private.atlassian-fex.com/gasv3/api/v1";
const $49e3226afdf42e2d$var$STARGATE_PROXY_PATH = "/gateway/api/gasv3/api/v1";
const $49e3226afdf42e2d$var$handleFedRampStagingSandboxDirect = (envOverride)=>{
    if (envOverride && envOverride === (0, $7xQTz.envOverrides).FEDRAMP_MODERATE_SANDBOX) return $49e3226afdf42e2d$var$FEDRAMP_SANDBOX_HOST;
    return $49e3226afdf42e2d$var$FEDRAMP_STAGING_HOST;
};
const $49e3226afdf42e2d$var$handleFedRampStagingSandboxStargate = (envOverride)=>{
    if (envOverride && envOverride === (0, $7xQTz.envOverrides).FEDRAMP_MODERATE_SANDBOX) return $49e3226afdf42e2d$var$STARGATE_FEDRAMP_SANDBOX_HOST;
    return $49e3226afdf42e2d$var$STARGATE_FEDRAMP_STAGING_HOST;
};
const $49e3226afdf42e2d$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $7xQTz.envType).LOCAL || env === (0, $7xQTz.envType).DEV) throw Error("No LOCAL or DEV environments for FedRAMP.");
    if (env === (0, $7xQTz.envType).PROD && envOverride) throw Error("Cannot override to FedRAMP Sandbox for Prod.");
    if (!useStargate) return env === (0, $7xQTz.envType).PROD ? $49e3226afdf42e2d$var$FEDRAMP_PROD_HOST : $49e3226afdf42e2d$var$handleFedRampStagingSandboxDirect(envOverride);
    if (useLegacyUrl) return env === (0, $7xQTz.envType).PROD ? $49e3226afdf42e2d$var$STARGATE_FEDRAMP_PROD_HOST : $49e3226afdf42e2d$var$handleFedRampStagingSandboxStargate(envOverride);
    /**
   * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
   * For more details, see:
   *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
   *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
   */ return window.location.host + $49e3226afdf42e2d$var$STARGATE_PROXY_PATH;
};
const $49e3226afdf42e2d$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $7xQTz.envType).PROD ? $49e3226afdf42e2d$var$PROD_HOST : $49e3226afdf42e2d$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $7xQTz.envType).PROD ? $49e3226afdf42e2d$var$STARGATE_PROD_HOST : $49e3226afdf42e2d$var$STARGATE_STAGING_HOST;
    /**
   * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
   * For more details, see:
   *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
   *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
   */ return window.location.host + $49e3226afdf42e2d$var$STARGATE_PROXY_PATH;
};
function $49e3226afdf42e2d$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, envOverride: envOverride }) {
    if (perimeter === (0, $7xQTz.perimeterType).FEDRAMP_MODERATE) return $49e3226afdf42e2d$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $49e3226afdf42e2d$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}

});

parcelRegister("lBUvv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbb8e2cd7c216aa9$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $5PHj7 = parcelRequire("5PHj7");
const $fbb8e2cd7c216aa9$var$SESSION_ID_STORAGE_KEY = "session.id";
const $fbb8e2cd7c216aa9$var$SESSION_EXPIRY_STORAGE_KEY = "session.expiry";
const $fbb8e2cd7c216aa9$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $fbb8e2cd7c216aa9$export$285f6bddd927a06d = 1800000; // 30 minutes
const $fbb8e2cd7c216aa9$export$a92e915d70316eb2 = 5000; // 5 seconds
const $fbb8e2cd7c216aa9$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $fbb8e2cd7c216aa9$export$5702a91a6f42969f = ()=>{};
class $fbb8e2cd7c216aa9$export$2e2bcd8739ae039 {
    constructor(options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_generateNewSessionId", ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($fbb8e2cd7c216aa9$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_updateSessionExpiry", ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($fbb8e2cd7c216aa9$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_debouncedUpdateSessionExpiry", (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) return _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        });
        this._sessionExpiryTime = options.sessionExpiryTime || $fbb8e2cd7c216aa9$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $fbb8e2cd7c216aa9$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $fbb8e2cd7c216aa9$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $fbb8e2cd7c216aa9$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $5PHj7.default)();
    }
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem($fbb8e2cd7c216aa9$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($fbb8e2cd7c216aa9$var$SESSION_EXPIRY_STORAGE_KEY) || "0", 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!$fbb8e2cd7c216aa9$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
}

});

parcelRegister("7Pc1w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b269f71a76712aa$export$2e2bcd8739ae039; });

var $d8XrT = parcelRequire("d8XrT");

var $kQKav = parcelRequire("kQKav");
class $5b269f71a76712aa$export$2e2bcd8739ae039 extends (0, $kQKav.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $d8XrT.default);
        } catch (err) {
            storageToUse = (0, $d8XrT.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("1f4xI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e7ab73e5478a3f6$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $a8tNN = parcelRequire("a8tNN");

var $7Pc1w = parcelRequire("7Pc1w");
const $0e7ab73e5478a3f6$var$STORAGE_KEY = "tab.id";
class $0e7ab73e5478a3f6$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_generateNewTabId", ()=>{
            const newTabId = (0, (/*@__PURE__*/$parcel$interopDefault($a8tNN)))();
            this._safeSessionStorage.setItem($0e7ab73e5478a3f6$var$STORAGE_KEY, newTabId);
            return newTabId;
        });
        this._safeSessionStorage = new (0, $7Pc1w.default)();
    }
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($0e7ab73e5478a3f6$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
}

});

parcelRegister("fIr86", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b710027905d14d8e$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $8KNKM = parcelRequire("8KNKM");

var $a8tNN = parcelRequire("a8tNN");

var $7xQTz = parcelRequire("7xQTz");

var $gDOaN = parcelRequire("gDOaN");

var $7Pc1w = parcelRequire("7Pc1w");

var $5jPqv = parcelRequire("5jPqv");
function $b710027905d14d8e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b710027905d14d8e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b710027905d14d8e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b710027905d14d8e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $b710027905d14d8e$var$STORAGE_KEY = "taskSessions";
const $b710027905d14d8e$var$INIT_KEY = "taskSessionsInit";
const $b710027905d14d8e$var$AWC_PARAM_PREFIX = "awc.";
const $b710027905d14d8e$var$TASK_SESSION_RELOAD_TIME = 3000;
class $b710027905d14d8e$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_taskSessionsNotRecentlyInitialised", (currentTimestamp)=>this._safeSessionStorage.getItem($b710027905d14d8e$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($b710027905d14d8e$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($b710027905d14d8e$var$INIT_KEY) || "0", 10) < currentTimestamp - $b710027905d14d8e$var$TASK_SESSION_RELOAD_TIME);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_removeTaskSessionPrefix", (_, taskSessionName)=>taskSessionName.split($b710027905d14d8e$var$AWC_PARAM_PREFIX)[1]);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isTaskSessionQueryParam", (_, taskSessionName)=>taskSessionName.startsWith($b710027905d14d8e$var$AWC_PARAM_PREFIX));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "getAllTaskSessions", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($b710027905d14d8e$var$STORAGE_KEY) || "");
            } catch (e) {
                return {};
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_writeToSessionStorage", (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($b710027905d14d8e$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch (e) {}
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_appendTaskSessions", (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_safelyRemoveKey", (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "createTaskSession", (taskSessionName)=>{
            const taskSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($a8tNN)))();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "createTaskSessionWithProvidedId", (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== "string") throw new TypeError("invalid taskSessionId, must be string");
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "completeTaskSession", (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "formatTaskSessionQueryString", ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $8KNKM.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $gDOaN.pick)(currentState, includedTaskSessions) : (0, $gDOaN.omit)(currentState, Object.values((0, $7xQTz.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = $b710027905d14d8e$var$_objectSpread($b710027905d14d8e$var$_objectSpread({}, (0, $gDOaN.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$b710027905d14d8e$var$AWC_PARAM_PREFIX + taskSessionName)), query);
            return `${url}?${(0, $8KNKM.stringify)(queryWithTaskSessions)}`;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "stripQueryParameters", ()=>{
            const extractedTaskSessions = (0, $gDOaN.mapKeys)((0, $5jPqv.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        });
        const _currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $7Pc1w.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(_currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($b710027905d14d8e$var$INIT_KEY, _currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}

});

parcelRegister("2e9ci", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19f405f5740b90a7$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $1Qo9y = parcelRequire("1Qo9y");

var $jx7M6 = parcelRequire("jx7M6");
const $19f405f5740b90a7$var$MAX_CACHE_SIZE = 100;
const $19f405f5740b90a7$var$COOKIE_NAME = (0, $jx7M6.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $19f405f5740b90a7$var$DEBUG_TAG = "synthetic";
const $19f405f5740b90a7$var$getDebugCookie = ()=>{
    try {
        return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($1Qo9y))).get($19f405f5740b90a7$var$COOKIE_NAME) || "false");
    } catch (error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qo9y))).remove($19f405f5740b90a7$var$COOKIE_NAME);
    }
    return false;
};
class $19f405f5740b90a7$var$TestingCache {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_bind", ()=>{
            if (typeof window === "undefined" || window.testAnalytics) return;
            window.testAnalytics = {
                eventCache: [],
                events: ()=>window.testAnalytics.eventCache,
                clear: ()=>{
                    window.testAnalytics.eventCache = [];
                    try {
                        localStorage.removeItem("awc.ui.viewed.last.sent");
                        localStorage.removeItem("awc-staging.ui.viewed.last.sent");
                        localStorage.removeItem("awc-dev.ui.viewed.last.sent");
                        localStorage.removeItem("awc-local.ui.viewed.last.sent");
                    } catch (_error) {
                    // Ignore errors from localStorage.
                    }
                }
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_cache", (event)=>{
            if (typeof window === "undefined") return;
            if (window.testAnalytics.eventCache.length >= $19f405f5740b90a7$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
            window.testAnalytics.eventCache.push(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_shouldCacheEvent", ()=>this._isDebugCookieEnabled);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "saveEvent", (event)=>{
            if (event && this._shouldCacheEvent()) {
                if (!window.testAnalytics) this._bind();
                if (event.tags instanceof Array) event.tags.push($19f405f5740b90a7$var$DEBUG_TAG);
                else event.tags = [
                    $19f405f5740b90a7$var$DEBUG_TAG
                ];
                this._cache(event);
            }
        });
        this._isDebugCookieEnabled = $19f405f5740b90a7$var$getDebugCookie();
        if (this._isDebugCookieEnabled) this._bind();
    }
}
var $19f405f5740b90a7$export$2e2bcd8739ae039 = $19f405f5740b90a7$var$TestingCache;

});

parcelRegister("fAdJd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b584ddfb45a45d68$export$2e2bcd8739ae039; });

var $lOQkO = parcelRequire("lOQkO");

var $kFnE9 = parcelRequire("kFnE9");

var $7xQTz = parcelRequire("7xQTz");

var $5PHj7 = parcelRequire("5PHj7");
const $b584ddfb45a45d68$var$_excluded = [
    "embeddedProduct"
];
function $b584ddfb45a45d68$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b584ddfb45a45d68$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b584ddfb45a45d68$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b584ddfb45a45d68$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $b584ddfb45a45d68$var$DEFAULT_DELAY = 2000; // 2 seconds
const $b584ddfb45a45d68$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $b584ddfb45a45d68$var$DEFAULT_STORAGE_KEY = "ui.viewed.last.sent";
class $b584ddfb45a45d68$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "start", ()=>{
            this._startInterval();
            this._bindEventListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "stop", ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "resetTimers", ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_bindEventListeners", ()=>{
            if (typeof window !== "undefined") {
                window.addEventListener("focus", this._focusListener);
                window.addEventListener("blur", this._blurListener);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_unbindEventListeners", ()=>{
            if (typeof window !== "undefined") {
                window.removeEventListener("focus", this._focusListener);
                window.removeEventListener("blur", this._blurListener);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_startInterval", ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleInterval, this._delay);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_stopInterval", ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_getProductKey", (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_getLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_parseLocalStorageData", ()=>{
            const data = this._safeLocalStorage.getItem(this._storageKey);
            try {
                return JSON.parse(data || "");
            } catch (error) {
                this._safeLocalStorage.removeItem(this._storageKey);
                return null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_setLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_shouldSendEvent", (productKey, tenantIdType, tenantId, userId)=>{
            if (!document.hasFocus()) return false;
            if (tenantIdType !== (0, $7xQTz.tenantType).NONE && !tenantId || !userId) return false;
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            return sinceLastSent > this._throttle;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_handleInterval", ()=>{
            const _this$_getContext = this._getContext(), { embeddedProduct: embeddedProduct } = _this$_getContext, context = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_this$_getContext, $b584ddfb45a45d68$var$_excluded);
            this._sendEvent(this._product, context);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_sendEvent", (product, context, isEmbeddedProduct = false)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            if (this._shouldSendEvent(productKey, tenantIdType, tenantId, userId)) {
                this._setLastSentTimestamp(productKey, tenantId, userId);
                const event = this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes);
                this._onEvent(event);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_createEvent", (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes)=>{
            const event = {
                product: product,
                source: "ui",
                action: "viewed",
                actionSubject: "ui",
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = $b584ddfb45a45d68$var$_objectSpread($b584ddfb45a45d68$var$_objectSpread({}, event.attributes), {}, {
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                });
            }
            if (lastScreenEvent) event.attributes = $b584ddfb45a45d68$var$_objectSpread($b584ddfb45a45d68$var$_objectSpread({}, event.attributes), {}, {
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            });
            return event;
        });
        if (!productInfo) throw new Error("Missing productInfo");
        if (!productInfo.product) throw new Error("Missing productInfo.product");
        if (!getContext) throw new Error("Missing getContext callback");
        if (typeof getContext !== "function") throw new Error("Invalid getContext, must be function");
        if (!onEvent) throw new Error("Missing onEvent callback");
        if (typeof onEvent !== "function") throw new Error("Invalid onEvent, must be function");
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $b584ddfb45a45d68$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $b584ddfb45a45d68$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $b584ddfb45a45d68$var$DEFAULT_STORAGE_KEY;
        this._safeLocalStorage = new (0, $5PHj7.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

});

parcelRegister("8hcO0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6069d82fef5db17d$export$2e2bcd8739ae039; });
function $6069d82fef5db17d$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== "function") return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("cqtUi", function(module, exports) {

$parcel$export(module.exports, "XIDPromise", function () { return $90bf1cab81b23f50$export$fbe53bbbe682bcdd; });

var $kIi3H = parcelRequire("kIi3H");
const $90bf1cab81b23f50$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === "function") {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $kIi3H.createTimeoutXid)()), (0, $kIi3H.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $kIi3H.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("kIi3H", function(module, exports) {

$parcel$export(module.exports, "XID_TIMEOUT", function () { return $f145ecccbd3e0f29$export$545bcbd53afabfa3; });
$parcel$export(module.exports, "createTimeoutXid", function () { return $f145ecccbd3e0f29$export$af4087e36d63846; });
$parcel$export(module.exports, "createUnknownXid", function () { return $f145ecccbd3e0f29$export$fa341d0c750d705b; });

var $9BOAm = parcelRequire("9BOAm");
const $f145ecccbd3e0f29$export$545bcbd53afabfa3 = 5000;
const $f145ecccbd3e0f29$export$af4087e36d63846 = ()=>[
        {
            type: (0, $9BOAm.XIDItemType).XC,
            state: "TIMEOUT"
        },
        {
            type: (0, $9BOAm.XIDItemType).UID,
            state: "TIMEOUT"
        }
    ];
const $f145ecccbd3e0f29$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $9BOAm.XIDItemType).XC,
            state: "UNKNOWN"
        },
        {
            type: (0, $9BOAm.XIDItemType).UID,
            state: "UNKNOWN"
        }
    ];

});
parcelRegister("9BOAm", function(module, exports) {

$parcel$export(module.exports, "XIDItemType", function () { return $6feecefd98af2322$export$92ca0438bcb0d396; });
let $6feecefd98af2322$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
let $6feecefd98af2322$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("eHk0O", function(module, exports) {

$parcel$export(module.exports, "getBscGlobalState", function () { return $ab349ad3016957a7$export$3b78a1ea01f5ec28; });
$parcel$export(module.exports, "initializeGlobalState", function () { return $ab349ad3016957a7$export$882c4530c58781d8; });
var $ab349ad3016957a7$var$localAnalyticsEnabled;
var $ab349ad3016957a7$var$localProduct;
var $ab349ad3016957a7$export$3b78a1ea01f5ec28 = function getBscGlobalState() {
    if ($ab349ad3016957a7$var$localAnalyticsEnabled == null) $ab349ad3016957a7$var$localAnalyticsEnabled = true;
    return {
        analyticsEnabled: $ab349ad3016957a7$var$localAnalyticsEnabled,
        product: $ab349ad3016957a7$var$localProduct
    };
};
var $ab349ad3016957a7$export$882c4530c58781d8 = function initializeGlobalState() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$analyticsEnabled = _ref.analyticsEnabled, analyticsEnabled = _ref$analyticsEnabled === void 0 ? true : _ref$analyticsEnabled, _ref$product = _ref.product, product = _ref$product === void 0 ? "NONE" : _ref$product;
    $ab349ad3016957a7$var$localAnalyticsEnabled = analyticsEnabled;
    $ab349ad3016957a7$var$localProduct = product;
};
var $ab349ad3016957a7$export$ac7c2edd09656c05 = function clearGlobalState() {
    $ab349ad3016957a7$var$localAnalyticsEnabled = undefined;
    $ab349ad3016957a7$var$localProduct = undefined;
};

});

parcelRegister("JZBNd", function(module, exports) {

$parcel$export(module.exports, "Logger", function () { return $08a3fe42b1c339f7$export$efa9a398d6368992; });

var $kFnE9 = parcelRequire("kFnE9");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $jtYt3 = parcelRequire("jtYt3");
function $08a3fe42b1c339f7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $08a3fe42b1c339f7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $08a3fe42b1c339f7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $08a3fe42b1c339f7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $08a3fe42b1c339f7$var$LOG_PREFIX = "[browser-storage-controls]";
var $08a3fe42b1c339f7$export$efa9a398d6368992 = /*#__PURE__*/ function() {
    function Logger() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, Logger);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(Logger, null, [
        {
            key: "info",
            value: function info(message, metadata) {
                console.log("".concat($08a3fe42b1c339f7$var$LOG_PREFIX, ": ").concat(message), metadata ? JSON.stringify(metadata) : "");
            }
        },
        {
            key: "error",
            value: function error(message, metadata) {
                console.error("".concat($08a3fe42b1c339f7$var$LOG_PREFIX, ": ").concat(message), metadata ? JSON.stringify(metadata) : "");
            }
        },
        {
            key: "errorWithOperationalEvent",
            value: function errorWithOperationalEvent(_ref) {
                var action = _ref.action, _ref$attributes = _ref.attributes, attributes = _ref$attributes === void 0 ? {} : _ref$attributes, message = _ref.message, metadata = _ref.metadata;
                try {
                    (0, $jtYt3.sendPackageOperationalEvent)({
                        action: action,
                        attributes: $08a3fe42b1c339f7$var$_objectSpread({
                            error: message
                        }, attributes)
                    });
                } catch (e) {
                    this.error("Failed to send operational event on error: ".concat(action, ". ").concat(e.message || ""));
                }
                this.error(message, metadata ? JSON.stringify(metadata) : "");
            }
        },
        {
            key: "warn",
            value: function warn(message, metadata) {
                console.warn("".concat($08a3fe42b1c339f7$var$LOG_PREFIX, ": ").concat(message), metadata ? JSON.stringify(metadata) : "");
            }
        }
    ]);
    return Logger;
}();

});

parcelRegister("bPGlO", function(module, exports) {

$parcel$export(module.exports, "packageName", function () { return $89d54f232283821e$export$9345d7360ffe0722; });
$parcel$export(module.exports, "packageVersion", function () { return $89d54f232283821e$export$91546b032799aa40; });
var $89d54f232283821e$export$9345d7360ffe0722 = "@atlassian/browser-storage-controls";
var $89d54f232283821e$export$91546b032799aa40 = "3.0.2";

});

parcelRegister("kK2Aq", function(module, exports) {

$parcel$export(module.exports, "withAnalyticsEventSampling", function () { return $f19a1c21d038d106$export$67b6e87f323cb6ad; });

var $4mVfk = parcelRequire("4mVfk");

var $8DpVo = parcelRequire("8DpVo");

var $4Qgcm = parcelRequire("4Qgcm");

var $91Q2o = parcelRequire("91Q2o");

var $g5A4y = parcelRequire("g5A4y");
var $f19a1c21d038d106$export$1138592b3c099377 = {
    usedGetCookie: 100000,
    usedGetCookieError: 1,
    usedSetCookie: 1000,
    usedSetCookieError: 1,
    usedSetStrictlyNecessaryCookie: 10000,
    usedSetStrictlyNecessaryCookieError: 1,
    usedDeleteCookie: 10,
    usedDeleteCookieError: 1,
    usedCheckThirdParty: 100000,
    checkThirdPartyError: 1,
    usedDocumentCookie: 100,
    usedDocumentCookieError: 1,
    initializeControlsError: 1,
    loadStorageControlsError: 1,
    updatePreferencesError: 1,
    fetchConsentPreferencesError: 1,
    saveConsentPreferencesError: 1
};
// This short-circuits finding a sampling ratio from the remote config. Useful for things like
// `loadStorageControlsError` which itself tries to log an event on error, causing an infinite
// recursion as each lookup fails, logging another event, etc.
var $f19a1c21d038d106$var$localOnlySamplingKeys = [
    "loadStorageControlsError"
];
function $f19a1c21d038d106$var$loadSamplingConfig() {
    return $f19a1c21d038d106$var$_loadSamplingConfig.apply(this, arguments);
}
function $f19a1c21d038d106$var$_loadSamplingConfig() {
    $f19a1c21d038d106$var$_loadSamplingConfig = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee() {
        var controlsData, analyticsSamplingRatioConfigs;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(0, $4Qgcm.cache).cachedSamplingConfig) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return", (0, $4Qgcm.cache).cachedSamplingConfig);
                case 2:
                    if (!(0, $91Q2o.isSSR)()) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return", undefined);
                case 4:
                    _context.next = 6;
                    return (0, $g5A4y.loadStorageControlsData)();
                case 6:
                    controlsData = _context.sent;
                    analyticsSamplingRatioConfigs = controlsData === null || controlsData === void 0 ? void 0 : controlsData.analyticsSamplingRatio;
                    (0, $4Qgcm.cache).cachedSamplingConfig = analyticsSamplingRatioConfigs;
                    return _context.abrupt("return", analyticsSamplingRatioConfigs);
                case 10:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $f19a1c21d038d106$var$_loadSamplingConfig.apply(this, arguments);
}
function $f19a1c21d038d106$export$b286f5e8716d11ad(_x) {
    return $f19a1c21d038d106$var$_getAnalyticsSamplingRatio.apply(this, arguments);
}
function $f19a1c21d038d106$var$_getAnalyticsSamplingRatio() {
    $f19a1c21d038d106$var$_getAnalyticsSamplingRatio = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee2(analyticsEventKey) {
        var remoteSamplingConfig, samplingConfig, samplingRatio;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if (!$f19a1c21d038d106$var$localOnlySamplingKeys.includes(analyticsEventKey)) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return", $f19a1c21d038d106$export$1138592b3c099377[analyticsEventKey]);
                case 2:
                    _context2.next = 4;
                    return $f19a1c21d038d106$var$loadSamplingConfig();
                case 4:
                    remoteSamplingConfig = _context2.sent;
                    samplingConfig = remoteSamplingConfig !== null && remoteSamplingConfig !== void 0 ? remoteSamplingConfig : $f19a1c21d038d106$export$1138592b3c099377;
                    samplingRatio = (samplingConfig === null || samplingConfig === void 0 ? void 0 : samplingConfig[analyticsEventKey]) !== undefined ? samplingConfig[analyticsEventKey] : $f19a1c21d038d106$export$1138592b3c099377[analyticsEventKey];
                    return _context2.abrupt("return", samplingRatio);
                case 8:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $f19a1c21d038d106$var$_getAnalyticsSamplingRatio.apply(this, arguments);
}
function $f19a1c21d038d106$export$dc2f0946255b3f89(samplingRatio, cb) {
    /* Only run if rolling the samplingRatio-sized die lands on a 0
        ________
       /\       \
      /()\   ()  \
     /    \_______\
     \    /()     /
      \()/   ()  /
       \/_____()/
   */ var shouldRun = !Math.floor(Math.random() * samplingRatio);
    shouldRun && cb();
}
function $f19a1c21d038d106$export$67b6e87f323cb6ad(_x2, _x3) {
    return $f19a1c21d038d106$var$_withAnalyticsEventSampling.apply(this, arguments);
}
function $f19a1c21d038d106$var$_withAnalyticsEventSampling() {
    $f19a1c21d038d106$var$_withAnalyticsEventSampling = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee3(analyticsEventKey, cb) {
        var ratio;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 2;
                    return $f19a1c21d038d106$export$b286f5e8716d11ad(analyticsEventKey);
                case 2:
                    ratio = _context3.sent;
                    $f19a1c21d038d106$export$dc2f0946255b3f89(ratio, cb);
                case 4:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return $f19a1c21d038d106$var$_withAnalyticsEventSampling.apply(this, arguments);
}

});
parcelRegister("4Qgcm", function(module, exports) {

$parcel$export(module.exports, "cache", function () { return $38689566820c6e8c$export$69a3209f1a06c04d; });

var $6r5MF = parcelRequire("6r5MF");
var $38689566820c6e8c$export$69a3209f1a06c04d = new (0, $6r5MF.CachedSamplingConfig)();

});
parcelRegister("6r5MF", function(module, exports) {

$parcel$export(module.exports, "CachedSamplingConfig", function () { return $4af9c0437e69afd7$export$b886edaf6623554a; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");
var $4af9c0437e69afd7$export$b886edaf6623554a = /*#__PURE__*/ function() {
    function CachedSamplingConfig() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, CachedSamplingConfig);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(CachedSamplingConfig, [
        {
            key: "cachedSamplingConfig",
            get: function get() {
                return this.cache;
            },
            set: function set(value) {
                this.cache = value;
            }
        }
    ]);
    return CachedSamplingConfig;
}();

});


parcelRegister("91Q2o", function(module, exports) {

$parcel$export(module.exports, "isSSR", function () { return $692c92a7f2a5c4f4$export$48d7c418edadb60c; });

var $gJmMp = parcelRequire("gJmMp");

var $lHRVb = parcelRequire("lHRVb");

var $JZBNd = parcelRequire("JZBNd");
var $692c92a7f2a5c4f4$export$48d7c418edadb60c = function isSSR() {
    var isMissingNecessaryBrowserUtils = typeof document === "undefined" || typeof window === "undefined" || !Document || !Document.prototype || !Object || !Object.defineProperty;
    var isMissingBooleanFF = !(0, $lHRVb.fg);
    var isMissingAnalyticsWebClient = !Boolean((0, $gJmMp.default));
    // When rendering from the server document/window may not be available
    if (isMissingNecessaryBrowserUtils) (0, $JZBNd.Logger).warn("Browser context is not available.");
    if (isMissingBooleanFF) (0, $JZBNd.Logger).warn("Platform Feature Flag library is not available");
    if (!(0, $gJmMp.default)) (0, $JZBNd.Logger).warn("analytics-web-client is not available");
    if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
    else return false;
};

});

parcelRegister("g5A4y", function(module, exports) {

$parcel$export(module.exports, "loadStorageControlsData", function () { return $bb691837803abca9$export$4dbb842f063ffea4; });

var $4mVfk = parcelRequire("4mVfk");

var $8DpVo = parcelRequire("8DpVo");

var $JZBNd = parcelRequire("JZBNd");
var $bb691837803abca9$export$ab0619f627170401 = "https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories.json";
/**
 * Cache variable for storing categorized cookies cache
 */ var $bb691837803abca9$var$localResponseCache;
/**
 * Cache variable for storing a promise that's been fired by a different invocation of loadStorageControls
 *
 * Allows for many invocations to happen simultaneously, and for only one fetch to go out
 */ var $bb691837803abca9$var$localResponsePromiseCache;
/**
 * Cache variable for storing the promise returned from the response object's json method
 *
 * Ensures we don't invoke response.json multiple times
 */ var $bb691837803abca9$var$localResponseJsonPromiseCache;
var $bb691837803abca9$export$19bc72f5ccd901a6 = function clearStorageControlsDataCache() {
    $bb691837803abca9$var$localResponseCache = undefined;
    $bb691837803abca9$var$localResponsePromiseCache = undefined;
    $bb691837803abca9$var$localResponseJsonPromiseCache = undefined;
};
/**
 * Unpacks the response promise from the categories CDN
 *
 * errors if that request was unsuccessful, returns the categories data otherwise
 *
 */ var $bb691837803abca9$var$handleCategoriesResponse = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee(responsePromise) {
        var response;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (responsePromise) {
                        _context.next = 2;
                        break;
                    }
                    throw new Error("Failed to fetch Cookies Cache! Cached promise was undefined");
                case 2:
                    _context.next = 4;
                    return responsePromise;
                case 4:
                    response = _context.sent;
                    if (response.ok) {
                        _context.next = 7;
                        break;
                    }
                    throw new Error("Failed to fetch Cookies Cache! status: ".concat(response.status));
                case 7:
                    // Checks if we've already fired the response.json() promise
                    $bb691837803abca9$var$localResponseJsonPromiseCache = $bb691837803abca9$var$localResponseJsonPromiseCache || (response === null || response === void 0 ? void 0 : response.json());
                    return _context.abrupt("return", $bb691837803abca9$var$localResponseJsonPromiseCache);
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function handleCategoriesResponse(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $bb691837803abca9$export$4dbb842f063ffea4 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee2() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if (!$bb691837803abca9$var$localResponseCache) {
                        _context2.next = 4;
                        break;
                    }
                    return _context2.abrupt("return", $bb691837803abca9$var$localResponseCache);
                case 4:
                    _context2.prev = 4;
                    if (!$bb691837803abca9$var$localResponsePromiseCache) // invoke CDN and cache the promise
                    $bb691837803abca9$var$localResponsePromiseCache = fetch($bb691837803abca9$export$ab0619f627170401);
                    // unpack response
                    _context2.next = 8;
                    return $bb691837803abca9$var$handleCategoriesResponse($bb691837803abca9$var$localResponsePromiseCache);
                case 8:
                    $bb691837803abca9$var$localResponseCache = _context2.sent;
                    return _context2.abrupt("return", $bb691837803abca9$var$localResponseCache);
                case 12:
                    _context2.prev = 12;
                    _context2.t0 = _context2["catch"](4);
                    (0, $JZBNd.Logger).errorWithOperationalEvent({
                        action: "loadStorageControlsError",
                        message: _context2.t0.message || ""
                    });
                    $bb691837803abca9$export$19bc72f5ccd901a6();
                case 16:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                4,
                12
            ]
        ]);
    }));
    return function loadStorageControlsData() {
        return _ref2.apply(this, arguments);
    };
}();

});





parcelRegister("9T9zK", function(module, exports) {

$parcel$export(module.exports, "TIME_CACHED", function () { return $e50cb00e28ad0b72$export$d83c59ed2ddb62af; });
$parcel$export(module.exports, "fetchCachedRequest", function () { return $e50cb00e28ad0b72$export$f989de8fb1dfb05c; });
// @ts-ignore TODO: fix noImplicitAny error here

var $hY6w9 = parcelRequire("hY6w9");

var $6VgSH = parcelRequire("6VgSH");

var $2G6fd = parcelRequire("2G6fd");
const { errorResponse: $e50cb00e28ad0b72$var$errorResponse } = $6VgSH;
/**
 * Private vars used by request cache
 */ // eslint-disable-next-line no-underscore-dangle
const $e50cb00e28ad0b72$var$_cache = [];
const $e50cb00e28ad0b72$export$ffa0cfb4c7474b50 = 15; // 15ms wait for other requests with same url
const $e50cb00e28ad0b72$export$d83c59ed2ddb62af = 270000; // responses timeout after 4.5 mins
function $e50cb00e28ad0b72$export$4233f751d1a95819(request) {
    return $e50cb00e28ad0b72$var$_cache.find((req)=>req.url === request.url && (0, $2G6fd.bodyMatches)(request.body, req.body));
}
function $e50cb00e28ad0b72$export$79f8410252d735ed(request) {
    const index = $e50cb00e28ad0b72$var$_cache.findIndex((req)=>req.url === request.url && (0, $2G6fd.bodyMatches)(request.body, req.body));
    if (index > -1) $e50cb00e28ad0b72$var$_cache.splice(index, 1, (0, (/*@__PURE__*/$parcel$interopDefault($hY6w9)))(request));
    else $e50cb00e28ad0b72$var$_cache.push((0, (/*@__PURE__*/$parcel$interopDefault($hY6w9)))(request));
    return request;
}
function $e50cb00e28ad0b72$export$2643936b2cd5ef3d(request) {
    const index = $e50cb00e28ad0b72$var$_cache.findIndex((req)=>req.url === request.url && (0, $2G6fd.bodyMatches)(request.body, req.body));
    if (index > -1) {
        $e50cb00e28ad0b72$var$_cache.splice(index, 1);
        return true;
    }
    return false;
}
function $e50cb00e28ad0b72$export$8dc30353b93985d6() {
    $e50cb00e28ad0b72$var$_cache.splice(0, $e50cb00e28ad0b72$var$_cache.length);
}
async function $e50cb00e28ad0b72$export$f989de8fb1dfb05c(url, body) {
    let request = $e50cb00e28ad0b72$export$4233f751d1a95819({
        url: url,
        body: body
    });
    if (request) {
        if (request.resolved && Date.now() >= (request.fetchedAt || 0) + $e50cb00e28ad0b72$export$d83c59ed2ddb62af) {
            // clear cache as expired
            $e50cb00e28ad0b72$export$2643936b2cd5ef3d(request);
            request = undefined;
        } else return request.response;
    }
    request = $e50cb00e28ad0b72$var$_cache.find((req)=>req.url === url && !req.requesting && !req.resolved);
    if (request) request.body = (0, $2G6fd.addModulesToBody)(request.body, body);
    if (!request) request = $e50cb00e28ad0b72$export$79f8410252d735ed({
        url: url,
        body: body,
        response: (async ()=>{
            await new Promise((resolve)=>setTimeout(resolve, $e50cb00e28ad0b72$export$ffa0cfb4c7474b50));
            const req = $e50cb00e28ad0b72$export$4233f751d1a95819({
                url: url,
                body: body
            });
            if (req) {
                $e50cb00e28ad0b72$export$79f8410252d735ed({
                    ...req,
                    requesting: true
                });
                const response = await (0, $2G6fd.fetchData)(req.url, req.body);
                $e50cb00e28ad0b72$export$79f8410252d735ed({
                    ...req,
                    requesting: false,
                    resolved: true,
                    fetchedAt: Date.now()
                });
                return response;
            }
            throw $e50cb00e28ad0b72$var$errorResponse($6VgSH.INVALID_RESPONSE);
        })()
    });
    if (request && request.response) return request.response;
    throw $e50cb00e28ad0b72$var$errorResponse($6VgSH.INVALID_RESPONSE);
}

});
parcelRegister("hY6w9", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */ function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
}
/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */ function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
}
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__["delete"](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) object[key] = value;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
    var result;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            if (isHostObject(value)) return object ? value : {};
            result = initCloneObject(isFunc ? {} : value);
            if (!isDeep) return copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, baseClone, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (!isArr) var props = isFull ? getAllKeys(value) : keys(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
    });
    return result;
}
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */ function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var result = new buffer.constructor(buffer.length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */ function cloneMap(map, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
    return arrayReduce(array, addMapEntry, new map.constructor);
}
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */ function cloneSet(set, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
    return arrayReduce(array, addSetEntry, new set.constructor);
}
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        assignValue(object, key, newValue === undefined ? source[key] : newValue);
    }
    return object;
}
/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, cloneFunc, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return cloneMap(object, isDeep, cloneFunc);
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return cloneSet(object, isDeep, cloneFunc);
        case symbolTag:
            return cloneSymbol(object);
    }
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, true, true);
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : "";
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = cloneDeep;

});

parcelRegister("2G6fd", function(module, exports) {

$parcel$export(module.exports, "fetchData", function () { return $7d2273577ec86a73$export$8134c072fddab6a5; });
$parcel$export(module.exports, "bodyMatches", function () { return $7d2273577ec86a73$export$be480b8516d79324; });
$parcel$export(module.exports, "addModulesToBody", function () { return $7d2273577ec86a73$export$9c586d7f821de90f; });

var $8TjKB = parcelRequire("8TjKB");

var $6VgSH = parcelRequire("6VgSH");

var $2zjAG = parcelRequire("2zjAG");
const { errorResponse: $7d2273577ec86a73$var$errorResponse } = $6VgSH;
async function $7d2273577ec86a73$export$8134c072fddab6a5(url, body) {
    const response = await fetch((0, $2zjAG.default)(url, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify(body)
    }));
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
        if (!response.ok) throw await response.json();
        const data = await response.json();
        if (!data) throw $7d2273577ec86a73$var$errorResponse($6VgSH.MODULE_NOT_FOUND);
        return data;
    }
    throw $7d2273577ec86a73$var$errorResponse($6VgSH.INVALID_RESPONSE);
}
function $7d2273577ec86a73$export$be480b8516d79324(body1, body2) {
    return body1.every(({ target: target, modules: modules })=>{
        const targetHref = (0, $8TjKB.getObjectValue)(target, "links.self.href");
        return body2.some(({ target: _target, modules: _modules })=>{
            const selfHref = (0, $8TjKB.getObjectValue)(_target, "links.self.href");
            return targetHref === selfHref && modules.every((m)=>_modules.includes(m));
        });
    });
}
function $7d2273577ec86a73$export$9c586d7f821de90f(body1, body2) {
    // eslint-disable-next-line no-param-reassign
    body1 = [
        ...body1
    ];
    body2.forEach((item)=>{
        const { target: target, modules: modules } = item;
        const targetHref = (0, $8TjKB.getObjectValue)(target, "links.self.href");
        const foundIndex = body1.findIndex(({ target: t })=>targetHref === (0, $8TjKB.getObjectValue)(t, "links.self.href"));
        if (foundIndex > -1) {
            const mods = body1[foundIndex].modules;
            body1[foundIndex].modules = [
                ...new Set(mods.concat(modules))
            ];
        } else body1.push(item);
    });
    return body1;
}

});




parcelRegister("c5dog", function(module, exports) {

$parcel$export(module.exports, "sendEvent", function () { return $45a95db79d965daa$export$7329bcdc3edcd90e; });

var $5kmFR = parcelRequire("5kmFR");
const $45a95db79d965daa$export$7329bcdc3edcd90e = (eventType, payload)=>{
    (0, $5kmFR.emitter).emit(eventType, payload);
};

});
parcelRegister("5kmFR", function(module, exports) {

$parcel$export(module.exports, "emitter", function () { return $bd1381f5ae5b669e$export$bad24218ebd77223; });
$parcel$export(module.exports, "registerAnalyticsListener", function () { return $bd1381f5ae5b669e$export$8032126a578c58b7; });

var $123dl = parcelRequire("123dl");

var $8TjKB = parcelRequire("8TjKB");
const $bd1381f5ae5b669e$export$bad24218ebd77223 = (0, $123dl.default)();
function $bd1381f5ae5b669e$export$8032126a578c58b7(event, fn) {
    if ((0, $8TjKB.isFunction)(event)) {
        // eslint-disable-next-line no-param-reassign
        fn = event;
        // eslint-disable-next-line no-param-reassign
        event = "*";
    }
    $bd1381f5ae5b669e$export$bad24218ebd77223.on(event, fn);
    return {
        unlisten: ()=>$bd1381f5ae5b669e$export$bad24218ebd77223.off(event, fn)
    };
}

});


parcelRegister("aLiYq", function(module, exports) {

$parcel$export(module.exports, "requestAccessToken", function () { return $41644fe1f2084221$export$13987b025a5be541; });
$parcel$export(module.exports, "getHostEnv", function () { return $41644fe1f2084221$export$2630462b9e1902ab; });
$parcel$export(module.exports, "getProxyEnv", function () { return $41644fe1f2084221$export$6f9c69626d91d3d1; });
$parcel$export(module.exports, "getCurrentUser", function () { return $41644fe1f2084221$export$e5432d4c8eb97ea7; });

var $8TjKB = parcelRequire("8TjKB");
parcelRequire("dwTXO");
var $QQQjQ = parcelRequire("QQQjQ");

var $6VgSH = parcelRequire("6VgSH");
function $41644fe1f2084221$export$13987b025a5be541(request, cb) {
    let moduleId;
    let forceUpdate;
    // for backwards compatability we need to handle different object types
    if ("credentials" in request) {
        // eslint-disable-next-line prefer-destructuring
        moduleId = request.credentials.moduleId;
        // eslint-disable-next-line prefer-destructuring
        forceUpdate = request.forceUpdate;
    } else // eslint-disable-next-line prefer-destructuring
    moduleId = request.moduleId;
    // atlassian connect attaches context to the callback
    // we can use that to verify moduleId's match
    if (!moduleId || moduleId !== (0, $8TjKB.getObjectValue)(// eslint-disable-next-line no-underscore-dangle
    cb._context, "extension.options.productContext.moduleId", // TODO: remove 'extension.options.moduleId' once productContext.moduleId
    // starts being used
    // eslint-disable-next-line no-underscore-dangle
    (0, $8TjKB.getObjectValue)(cb._context, "extension.options.moduleId"))) {
        cb($6VgSH.errorResponse($6VgSH.USER_DENIED_ACCESS), null);
        return;
    }
    (0, $QQQjQ.default).getToken(moduleId, forceUpdate, // eslint-disable-next-line no-underscore-dangle
    (0, $8TjKB.getObjectValue)(cb._context, "extension.id")).then((data)=>cb(null, data)).catch((error)=>cb(error, null));
}
function $41644fe1f2084221$export$2630462b9e1902ab(cb) {
    const element = document.querySelector('meta[name="bb-api-canon-url"]');
    if (!element) {
        cb('"bb-api-canon-url" element not found on page.');
        return;
    }
    cb(null, {
        baseApiUrl: element.getAttribute("content")
    });
}
function $41644fe1f2084221$export$6f9c69626d91d3d1({ moduleId: moduleId }, cb) {
    if (!moduleId) return;
    const mod = (0, $QQQjQ.default).modules.get(moduleId);
    if (!mod) {
        cb(`ConnectModule not found: ${moduleId}`);
        return;
    }
    cb(null, {
        baseApiUrl: mod.options["proxy-base-api-url"]
    });
}
function $41644fe1f2084221$export$e5432d4c8eb97ea7(cb) {
    const element = document.getElementById("bb-bootstrap");
    if (!element) return cb('"bb-bootstrap" element not found on page.');
    try {
        const currentUser = element.getAttribute("data-current-user");
        if (!currentUser) return cb('"bb-bootstrap" element not found on page.');
        return cb(null, JSON.parse(currentUser));
    } catch (error) {
        return cb(error);
    }
}

});

parcelRegister("7E3lN", function(module, exports) {

$parcel$export(module.exports, "replaceContent", function () { return $0d1c8007ef6239d2$export$e300d3272f682a59; });
parcelRequire("dwTXO");
var $QQQjQ = parcelRequire("QQQjQ");

var $5s0M7 = parcelRequire("5s0M7");
function $0d1c8007ef6239d2$export$e300d3272f682a59(moduleKey, credentials, cb) {
    if (credentials && credentials.targetHref) {
        const source = (0, $QQQjQ.default).targets.get(credentials.targetHref);
        const mods = (0, $QQQjQ.default).filterModules({
            appKey: credentials.appKey,
            moduleType: "associatedAddon",
            targetHref: credentials.targetHref
        });
        if (source && mods.length) {
            const mod = mods[0];
            (0, $QQQjQ.default).getModules(source.principalId, {
                target: source.target,
                modules: [
                    {
                        appKey: mod.descriptor.key,
                        moduleKey: moduleKey,
                        moduleType: credentials.moduleType,
                        location: credentials.location
                    }
                ]
            }).then((modules)=>(0, $5s0M7.emitter).emit((0, $5s0M7.REPLACE_CONTENT_EVENT), ...modules)).catch((error)=>cb(error));
        }
    }
}

});
parcelRegister("5s0M7", function(module, exports) {

$parcel$export(module.exports, "REPLACE_CONTENT_EVENT", function () { return $dcaa041498f19e40$export$38ef941ed5231472; });
$parcel$export(module.exports, "emitter", function () { return $dcaa041498f19e40$export$bad24218ebd77223; });
$parcel$export(module.exports, "replaceContentHandler", function () { return $dcaa041498f19e40$export$a0618779711d0700; });

var $123dl = parcelRequire("123dl");
const $dcaa041498f19e40$export$38ef941ed5231472 = "replace-content";
const $dcaa041498f19e40$export$bad24218ebd77223 = (0, $123dl.default)();
function $dcaa041498f19e40$export$a0618779711d0700(fn) {
    $dcaa041498f19e40$export$bad24218ebd77223.on($dcaa041498f19e40$export$38ef941ed5231472, fn);
    return {
        unlisten: ()=>$dcaa041498f19e40$export$bad24218ebd77223.off($dcaa041498f19e40$export$38ef941ed5231472, fn)
    };
}

});


parcelRegister("2HBs8", function(module, exports) {

$parcel$export(module.exports, "setConnectLinkMetaKey", function () { return $de99e33a33ade794$export$cecf7da5c9711fdc; });
$parcel$export(module.exports, "handleScrollEvent", function () { return $de99e33a33ade794$export$b21aa0b8664257ec; });
$parcel$export(module.exports, "handleConnectLink", function () { return $de99e33a33ade794$export$17174495e021939f; });
$parcel$export(module.exports, "createDialog", function () { return $de99e33a33ade794$export$3f449967ffb2f4b2; });
$parcel$export(module.exports, "createInlineDialog", function () { return $de99e33a33ade794$export$4bcca5425686558e; });
// @ts-ignore TODO: fix noImplicitAny error here

var $kHkiQ = parcelRequire("kHkiQ");

var $ffISn = parcelRequire("ffISn");

var $57Il5 = parcelRequire("57Il5");

var $8TjKB = parcelRequire("8TjKB");

var $3spbF = parcelRequire("3spbF");
let $de99e33a33ade794$var$isACJSNextEnabled = false;
try {
    const acjsNextFeature = !!(0, $8TjKB.getInitialOrBucketState)().global.features["acjs-next"];
    if (acjsNextFeature) $de99e33a33ade794$var$isACJSNextEnabled = true;
} catch (_error) {
// TODO: BBCEEP-3380 Implement error monitoring
}
let $de99e33a33ade794$var$ConnectHost;
if ($de99e33a33ade794$var$isACJSNextEnabled) $de99e33a33ade794$var$ConnectHost = (0, (/*@__PURE__*/$parcel$interopDefault($ffISn)));
else $de99e33a33ade794$var$ConnectHost = (0, (/*@__PURE__*/$parcel$interopDefault($kHkiQ)));
let $de99e33a33ade794$var$cmdOrCtrl = false;
function $de99e33a33ade794$export$cecf7da5c9711fdc(isSelected) {
    $de99e33a33ade794$var$cmdOrCtrl = isSelected;
}
function $de99e33a33ade794$export$b21aa0b8664257ec() {
    const inlineDialogProvider = $de99e33a33ade794$var$ConnectHost.frameworkAdaptor.getProviderByModuleName("inlineDialog");
    if (inlineDialogProvider && inlineDialogProvider.isOpen()) inlineDialogProvider.close();
}
function $de99e33a33ade794$export$17174495e021939f(linkData) {
    if (!linkData || !linkData.href || !(linkData.href.startsWith("http://") || linkData.href.startsWith("https://"))) return;
    if ($de99e33a33ade794$var$cmdOrCtrl) // Passing the opener object would allow the destination to modify Bitbucket's window object,
    // so we should not pass it through to the new window.
    window.open(linkData.href, undefined, "noopener");
    else window.location.href = linkData.href;
    $de99e33a33ade794$var$cmdOrCtrl = false;
}
function $de99e33a33ade794$export$3f449967ffb2f4b2(linkData) {
    const data = (0, $8TjKB.flatMerge)((0, $3spbF.getSharedState)(), linkData);
    if (data.href && $de99e33a33ade794$var$cmdOrCtrl) {
        $de99e33a33ade794$export$17174495e021939f(data);
        return;
    }
    const dialogProvider = $de99e33a33ade794$var$ConnectHost.frameworkAdaptor.getProviderByModuleName("dialog");
    if (dialogProvider) {
        if (dialogProvider.isOpen()) {
            const extension = dialogProvider.getActiveDialogExtension();
            if (!extension) throw new Error("Extension require to close connect dialog.");
            // close existing dialog before opening a new one
            $de99e33a33ade794$var$ConnectHost.dialog.close(extension.addon_key, extension);
            // A slight delay is needed to prevent atlassian-connect-js throwing a dialog not found exception.
            // There is no way to hook into the connect 'dialog.close' event on the host side. That would be preferred.
            setTimeout(()=>dialogProvider.createDialogFromLinker(data), 100);
            return;
        }
        dialogProvider.createDialogFromLinker(data);
    }
}
function $de99e33a33ade794$export$4bcca5425686558e(linkData) {
    const data = (0, $8TjKB.flatMerge)((0, $3spbF.getSharedState)(), linkData);
    if (data.href && $de99e33a33ade794$var$cmdOrCtrl) {
        $de99e33a33ade794$export$17174495e021939f(data);
        return;
    }
    const inlineDialogProvider = $de99e33a33ade794$var$ConnectHost.frameworkAdaptor.getProviderByModuleName("inlineDialog");
    if (inlineDialogProvider) {
        if (!data.extensionId) {
            inlineDialogProvider.createGlobal(data);
            return;
        }
        const iframe = document.getElementById(data.extensionId);
        if (!iframe) return;
        const pos = iframe.getBoundingClientRect();
        const { top: top, left: left } = data.position || {
            top: 0,
            left: 0
        };
        inlineDialogProvider.createGlobal({
            ...data,
            position: {
                ...data.position,
                top: pos.top + top,
                left: pos.left + left
            }
        });
    }
}
// This sets up linkers locally within frontbucket
// Otherwise, handlers are called over the bridge
(0, $57Il5.default)({
    links: {
        setConnectLinkMetaKey: $de99e33a33ade794$export$cecf7da5c9711fdc,
        handleConnectLink: $de99e33a33ade794$export$17174495e021939f,
        createDialog: $de99e33a33ade794$export$3f449967ffb2f4b2,
        createInlineDialog: $de99e33a33ade794$export$4bcca5425686558e
    }
}, true);

});
parcelRegister("57Il5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e74f02e4691d146b$export$2e2bcd8739ae039; });

var $c5dog = parcelRequire("c5dog");

var $abyeB = parcelRequire("abyeB");
function $e74f02e4691d146b$var$getLinkData(target, addon) {
    var _addon$options$produc;
    return {
        moduleKey: target.getAttribute("data-module-key"),
        appKey: target.getAttribute("data-app-key"),
        linkKey: target.getAttribute("data-link-key"),
        text: target.textContent,
        href: target.href,
        principalId: target.getAttribute("data-principal-uuid") || ((_addon$options$produc = addon.options.productContext) === null || _addon$options$produc === void 0 ? void 0 : _addon$options$produc.principalId) || // TODO: remove 'extension.options.moduleId' once productContext.moduleId
        // starts being used
        addon.options.principalId,
        extensionId: addon.extension_id
    };
}
function $e74f02e4691d146b$var$getBoundingClientRect(element) {
    const { top: top, right: right, bottom: bottom, left: left, width: width, height: height, x: x, y: y } = element.getBoundingClientRect();
    return {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $e74f02e4691d146b$var$sendLinkerEvent(target, type) {
    (0, $c5dog.sendEvent)("bitbucket.connect.linkers.href.event.click", {
        linker_key: target.getAttribute("data-link-key") || "",
        target_type: type
    });
}
var $e74f02e4691d146b$export$2e2bcd8739ae039 = (AP, isHost)=>{
    // @ts-ignore TODO: fix noImplicitAny error here
    let addon;
    if (isHost) addon = {
        options: {
            isInlineDialog: true
        },
        extension_id: ""
    };
    else try {
        addon = JSON.parse(window.name);
    } catch (e) {
        throw new Error("AP failed to parse window name");
    }
    if (typeof addon !== "object" || typeof addon.options !== "object" || addon.options === null) return;
    window.addEventListener("keydown", (event)=>AP.links.setConnectLinkMetaKey(event.ctrlKey || event.metaKey));
    window.addEventListener("keyup", (event)=>AP.links.setConnectLinkMetaKey(event.ctrlKey || event.metaKey));
    if (!addon.options.isInlineDialog) window.addEventListener("scroll", (0, $abyeB.throttle)(()=>AP.links.handleScrollEvent(), 300), true);
    document.addEventListener("click", (event)=>{
        const target = event.target;
        if (!target || !target.classList) return;
        if (target.classList.contains("ap-connect-link")) {
            event.preventDefault();
            $e74f02e4691d146b$var$sendLinkerEvent(target, "page");
            // @ts-ignore TODO: fix noImplicitAny error here
            AP.links.handleConnectLink($e74f02e4691d146b$var$getLinkData(target, addon));
        } else if (target.classList.contains("ap-connect-dialog")) {
            event.preventDefault();
            $e74f02e4691d146b$var$sendLinkerEvent(target, "dialog");
            // @ts-ignore TODO: fix noImplicitAny error here
            AP.links.createDialog($e74f02e4691d146b$var$getLinkData(target, addon));
        } else if (target.classList.contains("ap-connect-inline-dialog")) {
            event.preventDefault();
            event.stopPropagation(); // This is needed to prevent inlineDialog closing after open as click gets triggered in parent frame.
            $e74f02e4691d146b$var$sendLinkerEvent(target, "inlinedialog");
            AP.links.createInlineDialog({
                // @ts-ignore TODO: fix noImplicitAny error here
                ...$e74f02e4691d146b$var$getLinkData(target, addon),
                position: $e74f02e4691d146b$var$getBoundingClientRect(target)
            });
        }
    });
};

});
parcelRegister("abyeB", function(module, exports) {

$parcel$export(module.exports, "throttle", function () { return $b2cc21883287655d$export$de363e709c412c8a; });
/**
 * Debounce
 * @param {function} fn The function to debounce
 * @param {number} wait The time to wait
 */ function $b2cc21883287655d$export$61fc7d43ac8f84b0(fn, wait) {
    // @ts-ignore TODO: fix noImplicitAny error here
    let timeout;
    return function(...args) {
        // @ts-ignore TODO: fix noImplicitAny error here
        clearTimeout(timeout);
        // eslint-disable-next-line babel/no-invalid-this
        timeout = setTimeout(()=>fn.apply(this, args), wait || 1);
    };
}
function $b2cc21883287655d$export$de363e709c412c8a(fn, delay) {
    let isThrottled = false;
    // @ts-ignore TODO: fix noImplicitAny error here
    let args;
    // @ts-ignore TODO: fix noImplicitAny error here
    let context;
    function wrapper() {
        if (isThrottled) {
            // eslint-disable-next-line prefer-rest-params
            args = arguments;
            // eslint-disable-next-line babel/no-invalid-this
            context = this;
            return;
        }
        isThrottled = true;
        // eslint-disable-next-line babel/no-invalid-this, prefer-rest-params
        fn.apply(this, arguments);
        setTimeout(()=>{
            isThrottled = false;
            // @ts-ignore TODO: fix noImplicitAny error here
            if (args) {
                // @ts-ignore TODO: fix noImplicitAny error here
                wrapper.apply(context, args);
                args = context = null;
            }
        }, delay);
    }
    return wrapper;
}
function $b2cc21883287655d$export$3b3b88c3d59ef562(host, path) {
    if (path.startsWith(host)) return path;
    const cleanHost = host.replace(/\/+$/, "");
    const cleanPath = path.replace(/^\/+/, "");
    return `${cleanHost}/${cleanPath}`;
}

});


parcelRegister("3spbF", function(module, exports) {

$parcel$export(module.exports, "getSharedState", function () { return $be851b62b2c9d835$export$2fc867fd917ecb6f; });
let $be851b62b2c9d835$var$getter = ()=>({});
const $be851b62b2c9d835$export$fbe1438b9e970245 = (fn)=>$be851b62b2c9d835$var$getter = fn;
const $be851b62b2c9d835$export$2fc867fd917ecb6f = ()=>$be851b62b2c9d835$var$getter();

});






parcelRegister("5jZxZ", function(module, exports) {

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $5y4no = parcelRequire("5y4no");

var $eIoiN = parcelRequire("eIoiN");
var $c6910f803ecaadf6$export$2e2bcd8739ae039 = (0, $eIoiN.default)(({ ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5y4no.ConnectIframe), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        width: "100%",
        options: {
            autoresize: true
        },
        moduleType: "fileViews"
    })));

});
parcelRegister("5y4no", function(module, exports) {

$parcel$export(module.exports, "ConnectIframe", function () { return $17c9be8fffbaa052$export$8968565585c2471b; });
$parcel$export(module.exports, "default", function () { return $17c9be8fffbaa052$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $eIoiN = parcelRequire("eIoiN");

var $6D09s = parcelRequire("6D09s");
class $17c9be8fffbaa052$export$8968565585c2471b extends (0, $9nHZC.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6D09s.ConnectIframes), this.props, (iframes)=>{
            if (iframes.length > 0) {
                const { Component: Iframe } = iframes[0];
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Iframe, null);
            }
            return false;
        });
    }
}
var $17c9be8fffbaa052$export$2e2bcd8739ae039 = (0, $eIoiN.default)($17c9be8fffbaa052$export$8968565585c2471b);

});


parcelRegister("gNnCu", function(module, exports) {

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("g2goG");
var $kNA8C = parcelRequire("kNA8C");

var $qh48v = parcelRequire("qh48v");

var $9gkf9 = parcelRequire("9gkf9");
class $600970959ba55434$export$4a47ff79d9427031 extends (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component {
    /* eslint react/no-unsafe: "warn" */ UNSAFE_componentWillMount() {
        const { connectHost: connectHost, spi: spi, getCurrentUser: getCurrentUser } = this.props;
        if (connectHost && connectHost.defineModule) {
            connectHost.defineModule("marketplace", spi({
                cloudId: Array(40).join("x"),
                product: "bitbucket",
                environment: "staging",
                baseUrl: "",
                getAuthToken: ()=>"",
                getCurrentContext: ()=>""
            }));
            connectHost.defineModule("user", {
                // @ts-ignore TODO: fix noImplicitAny error here
                getCurrentUser: (fn)=>{
                    const currentUser = (0, $9gkf9.isFunction)(getCurrentUser) ? getCurrentUser() : "";
                    fn({
                        atlassianAccountId: (0, $9gkf9.isObject)(currentUser) ? currentUser.uuid || currentUser.username : currentUser
                    });
                }
            });
        }
    }
    componentWillUnmount() {
        const { connectHost: connectHost } = this.props;
        if (connectHost && connectHost.defineModule) connectHost.defineModule("marketplace", {});
    }
    render() {
        let { connectHost: connectHost } = this.props;
        if (!connectHost) connectHost = typeof window.connectHost !== "undefined" && window.connectHost ? window.connectHost : (0, $kNA8C.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $qh48v.ConnectModuleIframe), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, this.props, {
            connectHost: connectHost
        }));
    }
}
$600970959ba55434$export$4a47ff79d9427031.defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */ defaultStyles: {
        width: "100%",
        height: "100vh",
        border: "none"
    }
};
var $600970959ba55434$export$2e2bcd8739ae039 = $600970959ba55434$export$4a47ff79d9427031;

});

parcelRegister("4fayc", function(module, exports) {

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $eIoiN = parcelRequire("eIoiN");

var $4yK0k = parcelRequire("4yK0k");

var $hNste = parcelRequire("hNste");
var $a6b3f202439f24d4$export$2e2bcd8739ae039 = (0, $eIoiN.default)(({ children: children, providers: providers, ...props })=>/*#__PURE__*/ $9nHZC.createElement((0, $4yK0k.default), props, ({ modules: modules })=>children(modules.map((m)=>{
            const { id: id, descriptor: { target: { options: options = {} } = {} } } = m;
            const provider = providers.inlineDialogProvider.create(id, options);
            return {
                module: m,
                provider: provider,
                Component: (p)=>/*#__PURE__*/ $9nHZC.createElement((0, $hNste.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, p, {
                        module: m,
                        provider: provider,
                        key: id
                    }))
            };
        }))));

});

parcelRegister("7SwUm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae65802cf44db6e1$export$2e2bcd8739ae039; });
class $ae65802cf44db6e1$export$b0063bae72b769ca {
    constructor(){
        this.flagView = null;
        this.create = (options)=>{
            if (!this.flagView) throw new Error("FlagView not set");
            return this.flagView.create(options);
        };
        this.isFlagOpen = (flagId)=>{
            if (!this.flagView) throw new Error("FlagView not set");
            return this.flagView.isFlagOpen(flagId);
        };
        this.setView = (flagView)=>{
            this.flagView = flagView;
        };
    }
}
var $ae65802cf44db6e1$export$2e2bcd8739ae039 = new $ae65802cf44db6e1$export$b0063bae72b769ca();

});

parcelRegister("fwy1w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf1aa39c37a2822b$export$2e2bcd8739ae039; });
class $cf1aa39c37a2822b$export$a83e9a931c6e6660 {
    constructor(){
        this.messageView = null;
        this.generic = (title, body, messageCreationOptions)=>{
            if (!this.messageView) return;
            // eslint-disable-next-line consistent-return
            return this.messageView.createMessage("generic", title, body, messageCreationOptions);
        };
        this.hint = (title, body, messageCreationOptions)=>{
            if (!this.messageView) return;
            // eslint-disable-next-line consistent-return
            return this.messageView.createMessage("hint", title, body, messageCreationOptions);
        };
        this.info = (title, body, messageCreationOptions)=>{
            if (!this.messageView) return;
            // eslint-disable-next-line consistent-return
            return this.messageView.createMessage("info", title, body, messageCreationOptions);
        };
        this.success = (title, body, messageCreationOptions)=>{
            if (!this.messageView) return;
            // eslint-disable-next-line consistent-return
            return this.messageView.createMessage("success", title, body, messageCreationOptions);
        };
        this.warning = (title, body, messageCreationOptions)=>{
            if (!this.messageView) return;
            // eslint-disable-next-line consistent-return
            return this.messageView.createMessage("warning", title, body, messageCreationOptions);
        };
        this.error = (title, body, messageCreationOptions)=>{
            if (!this.messageView) return;
            // eslint-disable-next-line consistent-return
            return this.messageView.createMessage("error", title, body, messageCreationOptions);
        };
        this.clear = (messageId)=>{
            if (!this.messageView) return;
            this.messageView.closeMessage(messageId);
        };
        this.onClose = (messageId, callback)=>{
            if (!this.messageView) return;
            this.messageView.onClose(messageId, callback);
        };
        this.setView = (messageView)=>{
            this.messageView = messageView;
        };
    }
}
var $cf1aa39c37a2822b$export$2e2bcd8739ae039 = new $cf1aa39c37a2822b$export$a83e9a931c6e6660();

});

parcelRegister("9nekP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d820bab88de2ae4$export$2e2bcd8739ae039; });
class $8d820bab88de2ae4$export$7ab5cfe96fae86d3 {
    constructor(){
        this.dialogView = void 0;
        this.create = (options, extension)=>{
            if (!this.dialogView) throw new Error("Dialog view not set");
            this.dialogView.createDialog(options, extension);
            return this.dialogView;
        };
        this.createUrlIframeDialog = (options, urlIframeProps)=>{
            if (!this.dialogView) throw new Error("Dialog view not set");
            this.dialogView.createUrlIframeDialog(options, urlIframeProps);
            return this.dialogView;
        };
        this.createButton = (action)=>{
            if (this.dialogView) this.dialogView.createButton(action);
        };
        this.close = ()=>{
            if (this.dialogView) this.dialogView.close();
        };
        this.setButtonDisabled = (identifier, disabled)=>{
            if (this.dialogView) this.dialogView.setButtonDisabled(identifier, disabled);
        };
        this.setButtonHidden = (identifier, hidden)=>{
            if (this.dialogView) this.dialogView.setButtonHidden(identifier, hidden);
        };
        this.isButtonDisabled = (identifier)=>!!this.dialogView && this.dialogView.isButtonDisabled(identifier);
        this.isButtonHidden = (identifier)=>!!this.dialogView && this.dialogView.isButtonHidden(identifier);
        this.toggleButton = (identifier)=>{
            if (this.dialogView) this.dialogView.toggleButton(identifier);
        };
        this.isOpen = ()=>!!this.dialogView && this.dialogView.isOpen();
        this.isActiveDialog = (addonKey)=>!!this.dialogView && this.dialogView.isActiveDialog(addonKey);
        this.getActiveDialogExtension = ()=>this.dialogView ? this.dialogView.extension : {};
        this.setView = (dialogView)=>{
            this.dialogView = dialogView;
        };
        this.createDialogFromLinker = ({ principalId: principalId, principalType: principalType, appKey: appKey = "", moduleKey: moduleKey = "", linkKey: linkKey, text: text })=>{
            if (!this.dialogView) throw new Error("Dialog view not set");
            this.dialogView.createDialog({
                key: moduleKey
            }, {
                key: moduleKey,
                addon_key: appKey,
                appKey: appKey,
                moduleKey: moduleKey,
                linkKey: linkKey,
                text: text,
                principalId: principalId,
                principalType: principalType,
                options: {}
            });
        };
    }
}
var $8d820bab88de2ae4$export$2e2bcd8739ae039 = new $8d820bab88de2ae4$export$7ab5cfe96fae86d3();

});

parcelRegister("gX1I5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04684103d20e9013$export$2e2bcd8739ae039; });
parcelRequire("jjA7v");
var $3lIWa = parcelRequire("3lIWa");
class $04684103d20e9013$export$168cc986a71007b7 extends (0, $3lIWa.DefaultInlineDialogProvider) {
    constructor(...args){
        super(...args);
        this.globalView = void 0;
        this.views = {};
        this.toggle = (key)=>{
            const wrapper = this.views[key];
            if (wrapper) {
                if (wrapper.view.isOpen()) this.close(key);
                else this.open(key);
            }
        };
        this.open = (key)=>{
            const wrapper = this.views[key];
            if (wrapper) {
                const { view: view, options: options } = wrapper;
                if (options && options.closeOthers) Object.entries(this.views).forEach(([k, { view: _view }])=>k === key && !_view.isOpen() ? _view.open() : _view.isOpen() && _view.close());
                else view.open();
            }
        };
        this.isOpen = (key)=>{
            if (!key) return Object.keys(this.views).some((viewsKey)=>this.views[viewsKey].view.isOpen());
            const wrapper = this.views[key];
            if (wrapper) return wrapper.view.isOpen();
        };
        this.close = (key)=>{
            if (!key) {
                Object.keys(this.views).forEach(this.close);
                return;
            }
            const wrapper = this.views[key];
            if (wrapper) {
                wrapper.view.close();
                if (this.globalView) this.globalView.dispose(key);
            }
        };
        this.register = (key, view, options)=>{
            this.views[key] = {
                view: view,
                options: options
            };
        };
        this.unregister = (key)=>{
            delete this.views[key];
        };
        this.create = (key, options)=>{
            return {
                register: (view)=>this.register(key, view, options || {}),
                unregister: ()=>this.unregister(key),
                toggle: ()=>this.toggle(key),
                open: ()=>this.open(key),
                close: ()=>this.close(key)
            };
        };
        this.setView = (globalView)=>{
            this.globalView = globalView;
        };
        this.createGlobal = ({ principalId: principalId, principalType: principalType, moduleKey: moduleKey, appKey: appKey, linkKey: linkKey, text: text, position: position })=>{
            if (this.globalView) this.globalView.create(`${principalId}:${appKey}:${moduleKey}`, {
                position: position
            }, {
                key: moduleKey,
                addon_key: appKey,
                principalId: principalId,
                principalType: principalType,
                appKey: appKey,
                moduleKey: moduleKey,
                linkKey: linkKey,
                text: text
            });
        };
    }
}
var $04684103d20e9013$export$2e2bcd8739ae039 = new $04684103d20e9013$export$168cc986a71007b7();

});

parcelRegister("1WaGk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc1577fc741c828b$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");
parcelRequire("jjA7v");
var $6K5Jl = parcelRequire("6K5Jl");
var $28rlc = parcelRequire("28rlc");
var $6sO3c = parcelRequire("6sO3c");
var $lveWB = parcelRequire("lveWB");

var $77ZXp = parcelRequire("77ZXp");

var $esGU3 = parcelRequire("esGU3");

var $9nekP = parcelRequire("9nekP");

var $hgVF6 = parcelRequire("hgVF6");

var $7SwUm = parcelRequire("7SwUm");

var $14iJP = parcelRequire("14iJP");

var $gX1I5 = parcelRequire("gX1I5");

var $dBBeH = parcelRequire("dBBeH");

var $fwy1w = parcelRequire("fwy1w");
parcelRequire("5VwL8");
var $azotI = parcelRequire("azotI");
var $cc1577fc741c828b$export$2e2bcd8739ae039;
$cc1577fc741c828b$export$2e2bcd8739ae039 = class ConnectProvider extends (0, $9nHZC.Component) {
    constructor(props){
        super(props);
        this.props = void 0;
        props.connectHost.registerProvider("addon", (0, $77ZXp.default));
    }
    getChildContext() {
        const { connectHost: connectHost, addonManager: addonManager, analyticsEventHandler: analyticsEventHandler } = this.props;
        return {
            dialogProvider: (0, $9nekP.default),
            flagProvider: (0, $7SwUm.default),
            messageProvider: (0, $fwy1w.default),
            inlineDialogProvider: (0, $gX1I5.default),
            connectHost: connectHost,
            addonManager: addonManager,
            analyticsEventHandler: analyticsEventHandler
        };
    }
    componentDidMount() {
        // @ts-ignore TODO: fix noImplicitAny error here
        this.props.connectHost.onFrameClick((iframe)=>{
            // clicks inside an iframe don't register in the parent window
            // this causes popups like inline dialog not to behave as expected
            // triggering the click on the iframe element fixes this
            iframe.click();
        });
    }
    componentWillUnmount() {
        this.props.connectHost.offFrameClick();
    }
    render() {
        const { dialogProvider: dialogProvider, flagProvider: flagProvider, messageProvider: messageProvider, inlineDialogProvider: inlineDialogProvider, connectHost: connectHost, addonManager: addonManager } = this.getChildContext();
        const adaptor = connectHost.getFrameworkAdaptor();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, this.props.children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $esGU3.default), {
            connectHost: connectHost,
            dialogProvider: dialogProvider,
            addonManager: addonManager
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6K5Jl.DialogModule), {
            adaptor: adaptor,
            dialogProvider: dialogProvider
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $14iJP.default), {
            connectHost: connectHost,
            addonManager: addonManager,
            inlineDialogProvider: inlineDialogProvider
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6sO3c.InlineDialogModule), {
            adaptor: adaptor,
            inlineDialogProvider: inlineDialogProvider
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $hgVF6.default), {
            flagProvider: flagProvider
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $28rlc.FlagModule), {
            adaptor: adaptor,
            flagProvider: flagProvider
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dBBeH.default), {
            connectHost: connectHost,
            messageProvider: messageProvider
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $lveWB.MessageModule), {
            adaptor: adaptor,
            messageProvider: messageProvider
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $azotI.default), {
            addonManager: addonManager
        }));
    }
};
$cc1577fc741c828b$export$2e2bcd8739ae039.childContextTypes = {
    dialogProvider: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).object.isRequired,
    flagProvider: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).object.isRequired,
    messageProvider: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).object.isRequired,
    inlineDialogProvider: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).object.isRequired,
    connectHost: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).object.isRequired,
    addonManager: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).object.isRequired,
    analyticsEventHandler: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func
};

});
parcelRegister("77ZXp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75967fc9074d648b$export$2e2bcd8739ae039; });
const $75967fc9074d648b$var$AddonProvider = {
    // @ts-ignore TODO: fix noImplicitAny error here
    resize: (width, height, context)=>{
        context.extension.options.resize(width, height);
    },
    // @ts-ignore TODO: fix noImplicitAny error here
    sizeToParent: (hideFooter, context)=>{
        context.extension.options.sizeToParent(hideFooter);
    }
};
var $75967fc9074d648b$export$2e2bcd8739ae039 = $75967fc9074d648b$var$AddonProvider;

});

parcelRegister("esGU3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $051a16b1cc438326$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $kXHjP = parcelRequire("kXHjP");

var $2kxF1 = parcelRequire("2kxF1");

var $h8hIo = parcelRequire("h8hIo");
var $051a16b1cc438326$export$5e1f3ece84f480b;
(function(DialogActiveState) {
    DialogActiveState[DialogActiveState["NONE"] = 0] = "NONE";
    DialogActiveState[DialogActiveState["DIALOG"] = 1] = "DIALOG";
    DialogActiveState[DialogActiveState["DIALOG_LINKER"] = 2] = "DIALOG_LINKER";
    DialogActiveState[DialogActiveState["DIALOG_URL_IFRAME"] = 3] = "DIALOG_URL_IFRAME";
})($051a16b1cc438326$export$5e1f3ece84f480b || ($051a16b1cc438326$export$5e1f3ece84f480b = {}));
var $051a16b1cc438326$export$2e2bcd8739ae039;
$051a16b1cc438326$export$2e2bcd8739ae039 = class Dialog extends (0, $9nHZC.PureComponent) {
    constructor(...args){
        super(...args);
        this.props = void 0;
        this.state = {
            active: 0
        };
        this.isOpen = ()=>this.state.active !== 0;
        this.close = ()=>{
            this.setState({
                active: 0
            });
        };
        this.dismissDialog = (e)=>{
            const { extension: extension, urlIframeProps: urlIframeProps, options: options } = this.state;
            if (extension || urlIframeProps) {
                const { closeOnEscape: closeOnEscape } = extension && extension.options || options;
                if (typeof e.key !== "undefined" && e.key === "Escape" && typeof closeOnEscape !== "undefined" && closeOnEscape === false) return;
                this.props.connectHost.dialog.close(this.addon_key, extension);
            }
        };
        this.createDialog = (options, extension)=>{
            this.setState({
                active: extension.linkKey ? 2 : 1,
                options: Dialog.convertFromJSAPI({
                    ...Dialog.getDefaultCreationOptions(),
                    ...options
                }),
                extension: extension,
                urlIframeProps: undefined
            });
        };
        this.createUrlIframeDialog = (options, urlIframeProps)=>{
            this.setState({
                active: 3,
                options: Dialog.convertFromJSAPI({
                    ...Dialog.getDefaultCreationOptions(),
                    ...options
                }),
                extension: undefined,
                urlIframeProps: urlIframeProps
            });
        };
        this.createButton = (action)=>{
            const { active: active, options: options } = this.state;
            if (options && active === 1) {
                const actions = options.actions.slice();
                actions.unshift(Object.assign(action, {
                    key: action.identifier,
                    hidden: false,
                    disabled: false
                }));
                this.setState({
                    options: {
                        ...options,
                        actions: actions
                    }
                });
            }
        };
        this.setButtonDisabled = (identifier, disabled)=>{
            const { active: active, options: options } = this.state;
            if (options && active === 1) {
                const actions = options.actions.map((action)=>action.identifier === identifier ? Object.assign(action, {
                        disabled: disabled
                    }) : action);
                this.setState({
                    options: {
                        ...options,
                        actions: actions
                    }
                });
            }
        };
        this.setButtonHidden = (identifier, hidden)=>{
            const { active: active, options: options } = this.state;
            if (options && active === 1) {
                const actions = options.actions.map((action)=>action.identifier === identifier ? Object.assign(action, {
                        hidden: hidden
                    }) : action);
                this.setState({
                    options: {
                        ...options,
                        actions: actions
                    }
                });
            }
        };
        this.isButtonDisabled = (identifier)=>{
            const { active: active, options: options } = this.state;
            if (options && active === 1) {
                const action = options.actions.find((a)=>a.identifier === identifier);
                if (action) return !!action.disabled;
            }
            return false;
        };
        this.isButtonHidden = (identifier)=>{
            const { active: active, options: options } = this.state;
            if (options && active === 1) {
                const action = options.actions.find((a)=>a.identifier === identifier);
                if (action) return !!action.hidden;
            }
            return false;
        };
        this.toggleButton = (identifier)=>{
            const { active: active, options: options } = this.state;
            if (options && active === 1) {
                const actions = options.actions.map((action)=>action.identifier === identifier ? Object.assign(action, {
                        disabled: !action.disabled
                    }) : action);
                this.setState({
                    options: {
                        ...options,
                        actions: actions
                    }
                });
            }
        };
        this.isActiveDialog = (addonKey)=>{
            return this.addon_key === addonKey;
        };
        this.dialogLinkerChange = ({ options: options, extension: extension })=>{
            // NOTE: Pipelines requires a linker to open a dialog within a dialog
            // and atlassian-connect-js, which connect-js/connect-react is built on,
            // only supports one dialog. We also need to query the modules API for
            // connect data if not in cache, so we're using a HOC that renders a
            // dialog, calls the modules API and hooks into and onChange event to
            // then create a connect dialog via connectHost as to maintain state
            // with atlassian-connect-js. If we didn't use this method, then calling
            // AP.dialog.close() from within an Connect Iframe would not work.
            // We're also stubbing a default cancel footer link for when chrome === true
            this.props.connectHost.dialog.create({
                ...extension,
                options: {
                    ...extension.options
                }
            }, {
                chrome: true,
                buttons: [
                    {
                        text: "Cancel",
                        identifier: "cancel",
                        type: "link",
                        onClick: this.close
                    }
                ],
                ...options
            });
        };
    }
    static compareButtons(a, b) {
        if (a.identifier === "cancel") return 1;
        else if (a.identifier === "submit") {
            if (b.identifier === "cancel") return -1;
            return 1;
        }
        return 0;
    }
    static convertFromJSAPI(dialogCreationOptions) {
        const { width: width, height: height, size: size } = dialogCreationOptions;
        let { actions: actions = [] } = dialogCreationOptions;
        actions = actions.sort(Dialog.compareButtons);
        // @ts-ignore TODO: fix noImplicitAny error here
        actions = actions.map((action)=>({
                ...action,
                hidden: action.hidden || false
            }));
        // @ts-ignore TODO: fix noImplicitAny error here
        actions = actions.map((action)=>({
                ...action,
                hidden: action.disabled || false
            }));
        // @ts-ignore TODO: fix noImplicitAny error here
        actions = actions.map((action)=>({
                ...action,
                key: action.identifier
            }));
        return {
            ...dialogCreationOptions,
            width: width || size,
            height: height || size,
            actions: actions
        };
    }
    /* eslint react/no-unsafe: "warn" */ UNSAFE_componentWillMount() {
        this.props.dialogProvider.setView(this);
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    get addon_key() {
        const { extension: extension, urlIframeProps: urlIframeProps } = this.state;
        if (extension) return extension.addon_key;
        else if (urlIframeProps) return urlIframeProps.appKey;
        return "";
    }
    get extension() {
        return this.state.extension || {};
    }
    /**
   * @param dialogCreationOptions - for type info, see @atlassian/connect-module-core/main/modules/flag/DialogCreationOptions.
   */ render() {
        const { connectHost: connectHost, addonManager: addonManager } = this.props;
        const { active: active, extension: extension, options: options, urlIframeProps: urlIframeProps } = this.state;
        const isOpen = active !== 0;
        if (extension) {
            if (active === 2) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2kxF1.default), {
                isOpen: isOpen,
                connectHost: connectHost,
                addonManager: addonManager,
                extension: extension,
                options: options,
                onChange: this.dialogLinkerChange,
                dismissDialog: this.dismissDialog
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $h8hIo.default), {
                isOpen: isOpen,
                connectHost: connectHost,
                addonManager: addonManager,
                extension: extension,
                options: options,
                dismissDialog: this.dismissDialog
            });
        } else if (urlIframeProps) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $h8hIo.default), {
            isOpen: isOpen,
            connectHost: connectHost,
            addonManager: addonManager,
            extension: {},
            options: options,
            dismissDialog: this.dismissDialog
        }, (defaultIframeProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kXHjP.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, defaultIframeProps, urlIframeProps)));
        return null;
    }
};
$051a16b1cc438326$export$2e2bcd8739ae039.getDefaultCreationOptions = ()=>({
        key: "",
        size: "large",
        // ref: AK-1723
        width: "",
        height: "",
        chrome: true,
        header: "",
        actions: [],
        closeOnEscape: true,
        hint: ""
    });

});
parcelRegister("2kxF1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f68b53936ba66807$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $9TCOS = parcelRequire("9TCOS");

var $h8hIo = parcelRequire("h8hIo");
var $f68b53936ba66807$export$2e2bcd8739ae039 = (0, $9TCOS.default)(({ connectHost: connectHost, addonManager: addonManager, extension: extension, options: options, isOpen: isOpen, dismissDialog: dismissDialog })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $h8hIo.default), {
        connectHost: connectHost,
        addonManager: addonManager,
        extension: extension,
        options: options,
        isOpen: isOpen,
        dismissDialog: dismissDialog
    }));

});
parcelRegister("9TCOS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b85e36933f739c9$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $9gkf9 = parcelRequire("9gkf9");

var $4yK0k = parcelRequire("4yK0k");

var $3HZP8 = parcelRequire("3HZP8");
function $7b85e36933f739c9$var$extractOptions(modules, opts, addonManager) {
    let mod = {};
    let extension = {};
    let options = {};
    if (modules.length) {
        mod = modules[0];
        const { app_key: addonKey, descriptor: { key: key } = {
            key: ""
        }, targetHref: targetHref = "" } = mod;
        const target = addonManager.targets.get(targetHref);
        if (target) {
            options = {
                ...opts,
                ...(0, $9gkf9.getObjectValue)(target, "target.module.descriptor.target.options")
            };
            extension = {
                key: key,
                addon_key: addonKey,
                targetHref: targetHref
            };
        }
    }
    return {
        module: mod,
        extension: extension,
        options: options
    };
}
function $7b85e36933f739c9$export$2e2bcd8739ae039(Component) {
    return (props)=>{
        const { addonManager: addonManager, extension: extension, options: options, onChange: onChange } = props;
        const { principalId: principalId, addon_key: appKey, key: moduleKey } = extension;
        const updater = onChange && // @ts-ignore TODO: fix noImplicitAny error here
        (({ modules: modules })=>modules.length > 0 && onChange($7b85e36933f739c9$var$extractOptions(modules, options, addonManager)));
        return /*#__PURE__*/ $9nHZC.createElement((0, $4yK0k.default), {
            principalId: principalId,
            onMount: updater,
            onUpdate: updater,
            query: [
                {
                    modules: [
                        {
                            appKey: appKey,
                            moduleKey: moduleKey
                        }
                    ],
                    target: (0, $3HZP8.linkerTarget)(extension)
                }
            ]
        }, ({ modules: modules })=>{
            if (modules.length) return /*#__PURE__*/ $9nHZC.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, $7b85e36933f739c9$var$extractOptions(modules, options, addonManager), {
                query: []
            }));
            return false;
        });
    };
}

});
parcelRegister("3HZP8", function(module, exports) {

$parcel$export(module.exports, "linkerTarget", function () { return $4348430ad06ae74a$export$c06a70c19329e1f7; });
const $4348430ad06ae74a$export$73a58e0166ae7a31 = ({ principalId: principalId, appKey: appKey, linkKey: linkKey, text: text })=>`internal_linker_match:${principalId}:${appKey}:${linkKey}:${text}`;
const $4348430ad06ae74a$export$c06a70c19329e1f7 = ({ principalId: principalId = "", principalType: principalType, appKey: appKey = "", moduleKey: moduleKey = "", linkKey: linkKey = "", text: text = "" })=>({
        type: "internal_linker_match",
        text: text,
        context: {
            account: principalType && {
                type: principalType,
                uuid: principalId
            },
            principal_uuid: principalId,
            key: appKey
        },
        module: {
            descriptor: {
                key: linkKey
            }
        },
        links: {
            self: {
                href: $4348430ad06ae74a$export$73a58e0166ae7a31({
                    principalId: principalId,
                    appKey: appKey,
                    moduleKey: moduleKey,
                    linkKey: linkKey,
                    text: text
                })
            }
        }
    });

});


parcelRegister("h8hIo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e760bb30e444d62d$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $hwElN = parcelRequire("hwElN");

var $3THTN = parcelRequire("3THTN");

var $6vB7D = parcelRequire("6vB7D");

var $cGPG3 = parcelRequire("cGPG3");
var $ljrFr = parcelRequire("ljrFr");
var $2X56B = parcelRequire("2X56B");
var $DPG6Z = parcelRequire("DPG6Z");
var $3qXIy = parcelRequire("3qXIy");
var $2FnXC = parcelRequire("2FnXC");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $cBICc = parcelRequire("cBICc");

var $1fTLe = parcelRequire("1fTLe");
var $e760bb30e444d62d$export$2e2bcd8739ae039;
$e760bb30e444d62d$export$2e2bcd8739ae039 = class Dialog extends (0, $9nHZC.PureComponent) {
    constructor(...args){
        super(...args);
        this.getButtonAppearance = (key)=>{
            if (key === "submit") return "primary";
            else if (key === "cancel") return "subtle-link";
            return "default";
        };
    }
    getIframeComponent(iframeProps) {
        const { connectHost: connectHost, addonManager: addonManager, children: children } = this.props;
        if (typeof children === "function") return children(iframeProps);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $1fTLe.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, iframeProps, {
            connectHost: connectHost,
            addonManager: addonManager
        }));
    }
    render() {
        const { isOpen: isOpen, options: options, extension: extension } = this.props;
        const { hint: hint, width: width, height: height, chrome: chrome, closeOnEscape: closeOnEscape, actions: actions = [] } = options;
        // This is now permanent unless a HEIGHT enum becomes available in Atlaskit in the future
        // ie. Products now decide what small/medium/large means for a dialog height
        // ref: AK-1723
        const SIZE_ENUM = {
            values: [
                "small",
                "medium",
                "large",
                "xlarge",
                "x-large",
                "maximum",
                "fullscreen"
            ],
            sizes: {
                small: "400px",
                medium: "600px",
                large: "800px",
                xlarge: "968px",
                "x-large": "968px",
                maximum: "100%",
                fullscreen: "100%"
            }
        };
        const getSize = (v)=>// @ts-ignore TODO: fix noImplicitAny error here
            SIZE_ENUM.values.indexOf(v) === -1 ? v : SIZE_ENUM.sizes[v];
        const iframeProps = {
            extension: extension,
            height: getSize(height),
            width: "100%"
        };
        if (!chrome) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $cBICc.default), {
            isOpen: isOpen,
            shouldCloseOnEscapePress: closeOnEscape,
            onClose: this.props.dismissDialog
        }, this.getIframeComponent({
            ...iframeProps,
            width: getSize(width),
            defaultStyles: {
                pointerEvents: "auto"
            }
        }));
        const Header = options.header ? ({ onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $DPG6Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3qXIy.default), null, options.header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3THTN.default), {
                onClick: onClose,
                appearance: "link",
                spacing: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6vB7D))), {
                label: "Close Modal",
                primaryColor: (0, $h39Sh.default)("color.icon.danger", (0, $jp7ng).R400),
                size: "small"
            }))) : undefined;
        let Footer;
        if (actions.length) {
            // These hint styles were copied from .aui-dialog2-footer-hint, but products can style them differently if
            // they wish.
            const hintStyles = {
                color: (0, $h39Sh.default)("color.text", "#707070"),
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                paddingRight: "10px"
            };
            Footer = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2X56B.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
                    style: hintStyles
                }, hint), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $hwElN.default), null, actions.map((action)=>action.hidden ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3THTN.default), {
                        id: action.identifier,
                        key: action.key,
                        appearance: this.getButtonAppearance(action.key),
                        onClick: action.onClick,
                        isDisabled: action.disabled
                    }, action.text))));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2FnXC.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $cGPG3.default), {
            width: getSize(width),
            height: getSize(height),
            autoFocus: false,
            onClose: this.props.dismissDialog
        }, Header && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Header, {
            onClose: this.props.dismissDialog
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ljrFr.default), null, this.getIframeComponent(iframeProps)), Footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Footer, null)));
    }
};

});
parcelRegister("hwElN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc24b99e820c35f9$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");
var $cc24b99e820c35f9$var$buttonGroupStyles = (0, $avKww.css)({
    display: "inline-flex",
    gap: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "> *": {
        flex: "1 0 auto"
    }
});
function $cc24b99e820c35f9$export$2e2bcd8739ae039(_ref) {
    var appearance = _ref.appearance, children = _ref.children, testId = _ref.testId;
    return (0, $avKww.jsx)("div", {
        css: $cc24b99e820c35f9$var$buttonGroupStyles,
        "data-testid": testId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Children.toArray(children), function(child, idx) {
        if (!child) return null;
        return (0, $avKww.jsx)((0, $9nHZC.Fragment), {
            key: idx
        }, appearance ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).cloneElement(child, {
            appearance: appearance
        }) : child);
    }));
}

});

parcelRegister("6vB7D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4bd26f04b759f222$var$_react = $4bd26f04b759f222$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $4bd26f04b759f222$var$_close = $4bd26f04b759f222$var$_interopRequireDefault((parcelRequire("hKCfl")));
function $4bd26f04b759f222$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $4bd26f04b759f222$var$CrossIcon = (props)=>/*#__PURE__*/ $4bd26f04b759f222$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props, {
        newIcon: $4bd26f04b759f222$var$_close.default
    }));
$4bd26f04b759f222$var$CrossIcon.displayName = "CrossIcon";
var $4bd26f04b759f222$var$_default = module.exports.default = $4bd26f04b759f222$var$CrossIcon;

});
parcelRegister("heZQR", function(module, exports) {

$parcel$export(module.exports, "IconFacade", function () { return $c8d3b8eb8042b4c4$export$3cfb73f70dfca966; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $cs2gf = parcelRequire("cs2gf");

var $57VDz = parcelRequire("57VDz");
var $c8d3b8eb8042b4c4$var$_excluded = [
    "dangerouslySetGlyph"
];
var $c8d3b8eb8042b4c4$var$sizesEligibleForNewIcons = [
    "small",
    "medium"
];
var $c8d3b8eb8042b4c4$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $9nHZC.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $c8d3b8eb8042b4c4$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium and spacing will be none for small icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : "medium";
    var spacing = size === "small" ? "none" : "spacious";
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    var useNewIcon = (0, $cs2gf.fg)("platform-visual-refresh-icons-legacy-facade") && $c8d3b8eb8042b4c4$var$sizesEligibleForNewIcons.includes(size);
    if (useNewIcon && NewIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(NewIcon, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        spacing: spacing,
        color: props.primaryColor || "currentColor",
        type: props.iconType
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $57VDz.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});
var $c8d3b8eb8042b4c4$export$2e2bcd8739ae039 = $c8d3b8eb8042b4c4$export$3cfb73f70dfca966;

});
parcelRegister("cs2gf", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $9109da8b4dbb274f$export$b40ec24ac8275656; });

var $g9o0y = parcelRequire("g9o0y");
function $9109da8b4dbb274f$export$ba05d765b8392e5e(flagResolver) {
    (0, $g9o0y.setBooleanResolver)(flagResolver);
}
function $9109da8b4dbb274f$export$470e5c2be1411c89(name) {
    return (0, $g9o0y.resolveBooleanFlag)(name);
}
function $9109da8b4dbb274f$export$b40ec24ac8275656(name) {
    return (0, $g9o0y.resolveBooleanFlag)(name);
}

});
parcelRegister("g9o0y", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $bc201c15f8d773d0$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $bc201c15f8d773d0$export$6333b6aff9fc6275; });

var $6PRoY = parcelRequire("6PRoY");

var $8ovux = parcelRequire("8ovux");
var $bc201c15f8d773d0$var$pkgName = "@atlaskit/platform-feature-flags";
var $bc201c15f8d773d0$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $bc201c15f8d773d0$var$hasProcessEnv = typeof $8ovux !== "undefined" && typeof $8ovux.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $bc201c15f8d773d0$var$ENV_ENABLE_PLATFORM_FF = $bc201c15f8d773d0$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $bc201c15f8d773d0$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $bc201c15f8d773d0$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $bc201c15f8d773d0$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $bc201c15f8d773d0$var$ENV_ENABLE_PLATFORM_FF || $bc201c15f8d773d0$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $bc201c15f8d773d0$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $bc201c15f8d773d0$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$bc201c15f8d773d0$var$globalVar[$bc201c15f8d773d0$export$7e41b1b2bdee3f98] = $bc201c15f8d773d0$var$globalVar[$bc201c15f8d773d0$export$7e41b1b2bdee3f98] || $bc201c15f8d773d0$var$DEFAULT_PFF_GLOBAL;
function $bc201c15f8d773d0$export$f2b591175b3e424c(resolver) {
    $bc201c15f8d773d0$var$globalVar[$bc201c15f8d773d0$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $bc201c15f8d773d0$export$6333b6aff9fc6275(flagKey) {
    if ($bc201c15f8d773d0$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $6PRoY.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $bc201c15f8d773d0$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $bc201c15f8d773d0$var$globalVar[$bc201c15f8d773d0$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("6PRoY", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $4fa0edf84d18dc84$export$1c9f709888824e05; });
var $4fa0edf84d18dc84$var$_ref, $4fa0edf84d18dc84$var$_process, $4fa0edf84d18dc84$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $4fa0edf84d18dc84$var$TESTS_MODE = ($4fa0edf84d18dc84$var$_ref = (globalThis === null || globalThis === void 0 || ($4fa0edf84d18dc84$var$_process = globalThis.process) === null || $4fa0edf84d18dc84$var$_process === void 0 || ($4fa0edf84d18dc84$var$_process = $4fa0edf84d18dc84$var$_process.env) === null || $4fa0edf84d18dc84$var$_process === void 0 ? void 0 : $4fa0edf84d18dc84$var$_process.JEST_WORKER_ID) !== undefined, $4fa0edf84d18dc84$var$_ref !== void 0) ? $4fa0edf84d18dc84$var$_ref : false;
var $4fa0edf84d18dc84$var$DEBUG_MODE = !$4fa0edf84d18dc84$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($4fa0edf84d18dc84$var$_process2 = globalThis.process) === null || $4fa0edf84d18dc84$var$_process2 === void 0 || ($4fa0edf84d18dc84$var$_process2 = $4fa0edf84d18dc84$var$_process2.env) === null || $4fa0edf84d18dc84$var$_process2 === void 0 ? void 0 : $4fa0edf84d18dc84$var$_process2.NODE_ENV) !== "production";
var $4fa0edf84d18dc84$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$4fa0edf84d18dc84$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("57VDz", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $3bba50c08fc1aa49$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $3bba50c08fc1aa49$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $99kD4 = parcelRequire("99kD4");

var $2pv83 = parcelRequire("2pv83");
function $3bba50c08fc1aa49$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3bba50c08fc1aa49$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3bba50c08fc1aa49$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3bba50c08fc1aa49$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $3bba50c08fc1aa49$var$iconStyles = (0, $avKww.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $3bba50c08fc1aa49$var$_objectSpread($3bba50c08fc1aa49$var$_objectSpread({}, (0, $99kD4.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $3bba50c08fc1aa49$var$baseHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $3bba50c08fc1aa49$var$primaryEqualsSecondaryHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $3bba50c08fc1aa49$var$secondaryTransparentHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $3bba50c08fc1aa49$export$f04a61298a47a40f = /*#__PURE__*/ (0, $9nHZC.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $avKww.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $99kD4.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $avKww.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $3bba50c08fc1aa49$var$_objectSpread({
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $2pv83.getBackground)()
        }, UNSAFE_margin ? {
            margin: UNSAFE_margin
        } : {})
    }, glyphProps, {
        css: [
            $3bba50c08fc1aa49$var$iconStyles,
            $3bba50c08fc1aa49$var$baseHcmStyles,
            primaryColor === secondaryColor && $3bba50c08fc1aa49$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $3bba50c08fc1aa49$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $avKww.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $3bba50c08fc1aa49$export$2e2bcd8739ae039 = $3bba50c08fc1aa49$export$f04a61298a47a40f;

});
parcelRegister("99kD4", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $6a94f4de0abc4b24$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "sizeStyleMap", function () { return $6a94f4de0abc4b24$export$ef0ad74202575b64; });
$parcel$export(module.exports, "getIconSize", function () { return $6a94f4de0abc4b24$export$3eb7d6130acfda37; });

var $bQrht = parcelRequire("bQrht");

var $avKww = parcelRequire("avKww");
var $6a94f4de0abc4b24$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $6a94f4de0abc4b24$var$smallStyles = (0, $avKww.css)((0, $bQrht.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $6a94f4de0abc4b24$var$mediumStyles = (0, $avKww.css)((0, $bQrht.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $6a94f4de0abc4b24$var$largeStyles = (0, $avKww.css)((0, $bQrht.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $6a94f4de0abc4b24$var$xlargeStyles = (0, $avKww.css)((0, $bQrht.dimensions).xlarge);
var $6a94f4de0abc4b24$export$ef0ad74202575b64 = {
    small: $6a94f4de0abc4b24$var$smallStyles,
    medium: $6a94f4de0abc4b24$var$mediumStyles,
    large: $6a94f4de0abc4b24$var$largeStyles,
    xlarge: $6a94f4de0abc4b24$var$xlargeStyles
};
var $6a94f4de0abc4b24$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $bQrht.dimensions)[size];
    return undefined;
};

});
parcelRegister("bQrht", function(module, exports) {

$parcel$export(module.exports, "sizes", function () { return $89f9b67011164569$export$c647cb0ee6e282fe; });
$parcel$export(module.exports, "sizeMap", function () { return $89f9b67011164569$export$7bd66fc94c81bf84; });
$parcel$export(module.exports, "dimensions", function () { return $89f9b67011164569$export$62ad7b0c781000e9; });
var $89f9b67011164569$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $89f9b67011164569$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $89f9b67011164569$export$62ad7b0c781000e9 = {
    small: {
        width: $89f9b67011164569$export$c647cb0ee6e282fe.small,
        height: $89f9b67011164569$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $89f9b67011164569$export$c647cb0ee6e282fe.medium,
        height: $89f9b67011164569$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $89f9b67011164569$export$c647cb0ee6e282fe.large,
        height: $89f9b67011164569$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $89f9b67011164569$export$c647cb0ee6e282fe.xlarge,
        height: $89f9b67011164569$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("2pv83", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $1c1610214acbfe4f$export$18cb9425622d4e06; });
var $1c1610214acbfe4f$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});



parcelRegister("hKCfl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e1d767c2bf4320bb7e127b754b192d24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cec4667f39424af7$var$_react = $cec4667f39424af7$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $cec4667f39424af7$var$_UNSAFE_baseNew = $cec4667f39424af7$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $cec4667f39424af7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Close".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cec4667f39424af7$var$CloseIcon = (props)=>/*#__PURE__*/ $cec4667f39424af7$var$_react.default.createElement($cec4667f39424af7$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2.5 13.5 8 8m5.5-5.5L8 8m0 0L2.5 2.5M8 8l5.5 5.5"/>`
    }, props));
$cec4667f39424af7$var$CloseIcon.displayName = "CloseIcon";
var $cec4667f39424af7$var$_default = module.exports.default = $cec4667f39424af7$var$CloseIcon;

});
parcelRegister("a1YFK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("aVD1U")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("aVD1U")).Icon; });

var $aVD1U = parcelRequire("aVD1U");

});
parcelRegister("aVD1U", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $7f4d80bd67f5febc$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $7f4d80bd67f5febc$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $cs2gf = parcelRequire("cs2gf");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $7f4d80bd67f5febc$var$commonSVGStyles = (0, $avKww.css)({
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $7f4d80bd67f5febc$var$svgStyles = (0, $avKww.css)({
    color: "currentColor",
    verticalAlign: "bottom"
});
var $7f4d80bd67f5febc$var$iconStyles = (0, $avKww.css)({
    display: "inline-block",
    boxSizing: "border-box",
    flexShrink: 0,
    lineHeight: 1,
    paddingInlineEnd: "var(--ds--button--new-icon-padding-end, 0)",
    paddingInlineStart: "var(--ds--button--new-icon-padding-start, 0)"
});
var $7f4d80bd67f5febc$var$utilityIconStyles = (0, $avKww.css)({
    lineHeight: "var(--ds-space-150, 12px)"
});
var $7f4d80bd67f5febc$var$scaleStyles = (0, $avKww.css)({
    width: "inherit",
    height: "inherit"
});
/**
 * For windows high contrast mode
 */ var $7f4d80bd67f5febc$var$baseHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        color: "CanvasText",
        filter: "grayscale(1)"
    }
});
var $7f4d80bd67f5febc$var$sizeMap = {
    scale: (0, $avKww.css)({
        width: "inherit",
        height: "inherit"
    }),
    utility: (0, $avKww.css)({
        width: "var(--ds-space-150, 12px)",
        height: "var(--ds-space-150, 12px)"
    }),
    none: (0, $avKww.css)({
        width: "var(--ds-space-200, 16px)",
        height: "var(--ds-space-200, 16px)"
    }),
    spacious: (0, $avKww.css)({
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)"
    })
};
var $7f4d80bd67f5febc$var$baseSizeMap = {
    global: 16,
    utility: 12
};
var $7f4d80bd67f5febc$export$f04a61298a47a40f = /*#__PURE__*/ (0, $9nHZC.memo)(function Icon(props) {
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "var(--ds-icon, #44546F)" : _ref$color, _ref$spacing = _ref.spacing, providedSpacing = _ref$spacing === void 0 ? "none" : _ref$spacing, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, _ref$type = _ref.type, type = _ref$type === void 0 ? "global" : _ref$type, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $cs2gf.fg)("platform.design-system-team.enable-new-icons")) // parse out unnecessary props
    return (0, $avKww.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    // Utility icons don't have 'spacing' as a type, but in case it's provided, we default to 'none'
    var spacing = type === "utility" ? "none" : providedSpacing;
    var baseSize = $7f4d80bd67f5febc$var$baseSizeMap[type];
    var size = type === "utility" ? "utility" : shouldScale ? "scale" : spacing;
    var viewBoxPadding = spacing === "spacious" ? 4 : 0;
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = '\n<filter id="ds-newIconOpacityFilter">\n  <feFlood flood-color="var(--ds-icon-disabled)" />\n  <feComposite in2="SourceGraphic" operator="in" />\n</filter>\n<g filter="url(#ds-newIconOpacityFilter)">\n  '.concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $avKww.jsx)("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $7f4d80bd67f5febc$var$iconStyles,
            $7f4d80bd67f5febc$var$baseHcmStyles,
            shouldScale && $7f4d80bd67f5febc$var$scaleStyles,
            type === "utility" && $7f4d80bd67f5febc$var$utilityIconStyles
        ]
    }, (0, $avKww.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $7f4d80bd67f5febc$var$commonSVGStyles,
            $7f4d80bd67f5febc$var$svgStyles,
            $7f4d80bd67f5febc$var$sizeMap[size]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $7f4d80bd67f5febc$export$2e2bcd8739ae039 = $7f4d80bd67f5febc$export$f04a61298a47a40f;

});




parcelRegister("cGPG3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93d17e54724e7135$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $hAQRA = parcelRequire("hAQRA");

var $knkgL = parcelRequire("knkgL");

var $f7uPe = parcelRequire("f7uPe");

var $5OBDJ = parcelRequire("5OBDJ");

var $8p2GL = parcelRequire("8p2GL");

var $kEiiy = parcelRequire("kEiiy");

var $gWA00 = parcelRequire("gWA00");

var $97YIy = parcelRequire("97YIy");

var $0pN5N = parcelRequire("0pN5N");

var $04547 = parcelRequire("04547");

var $bagq3 = parcelRequire("bagq3");

var $hj909 = parcelRequire("hj909");
var $93d17e54724e7135$var$fillScreenStyles = (0, $avKww.css)({
    width: "100vw",
    height: "100vh",
    position: "fixed",
    insetBlockStart: "var(--ds-space-0, 0)",
    insetInlineStart: "var(--ds-space-0, 0)",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch"
});
var $93d17e54724e7135$var$allowlistElements = function allowlistElements(element, callback) {
    // allows focus to reach elements outside the modal if they contain the data-atlas-extension attribute
    if (element.hasAttribute("data-atlas-extension")) return false;
    // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === "function") return callback(element);
    return true;
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $93d17e54724e7135$var$ModalWrapper = function ModalWrapper(props) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, focusLockAllowlist = props.focusLockAllowlist, _props$shouldCloseOnE = props.shouldCloseOnEscapePress, shouldCloseOnEscapePress = _props$shouldCloseOnE === void 0 ? true : _props$shouldCloseOnE, _props$shouldCloseOnO = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _props$shouldCloseOnO === void 0 ? true : _props$shouldCloseOnO, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, _props$shouldReturnFo = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo === void 0 ? true : _props$shouldReturnFo, stackIndexOverride = props.stackIndex, _props$onClose = props.onClose, onClose = _props$onClose === void 0 ? (0, $8p2GL.default) : _props$onClose, _props$onStackChange = props.onStackChange, onStackChange = _props$onStackChange === void 0 ? (0, $8p2GL.default) : _props$onStackChange, isBlanketHidden = props.isBlanketHidden, children = props.children, height = props.height, width = props.width, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, label = props.label, testId = props.testId;
    var calculatedStackIndex = (0, $bagq3.default)({
        onStackChange: onStackChange
    });
    var stackIndex = stackIndexOverride || calculatedStackIndex;
    var isForeground = stackIndex === 0;
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    var autoFocusLock = typeof autoFocus === "boolean" ? autoFocus : false;
    var onCloseHandler = (0, $f7uPe.usePlatformLeafEventHandler)({
        fn: onClose,
        action: "closed",
        componentName: "modalDialog",
        packageName: "@atlaskit/modal-dialog",
        packageVersion: "12.15.3"
    });
    var onBlanketClicked = (0, $9nHZC.useCallback)(function(e) {
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    var allowListCallback = (0, $9nHZC.useCallback)(function(element) {
        return $93d17e54724e7135$var$allowlistElements(element, focusLockAllowlist);
    }, [
        focusLockAllowlist
    ]);
    (0, $hj909.default)();
    var modalDialogWithBlanket = (0, $avKww.jsx)((0, $5OBDJ.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && "".concat(testId, "--blanket")
    }, (0, $avKww.jsx)((0, $04547.default), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete
    }, children));
    var returnFocus = true;
    var onDeactivation;
    if ("boolean" === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = function onDeactivation() {
        window.setTimeout(function() {
            var _shouldReturnFocus$cu;
            (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return (0, $avKww.jsx)((0, $kEiiy.UNSAFE_LAYERING), {
        isDisabled: false
    }, (0, $avKww.jsx)((0, $97YIy.default), {
        zIndex: (0, $0pN5N.layers).modal()
    }, (0, $avKww.jsx)((0, $gWA00.default), null, function(fadeInProps) {
        return (0, $avKww.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, fadeInProps, {
            css: $93d17e54724e7135$var$fillScreenStyles,
            "aria-hidden": !isForeground
        }), (0, $avKww.jsx)((0, $hAQRA.default), {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, (0, $avKww.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($knkgL))), null), shouldScrollInViewport ? (0, $avKww.jsx)((0, $knkgL.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket));
    })));
};
var $93d17e54724e7135$export$2e2bcd8739ae039 = $93d17e54724e7135$var$ModalWrapper;

});
parcelRegister("hAQRA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cceece08397d8519$export$2e2bcd8739ae039; });

var $36K9S = parcelRequire("36K9S");

var $cceece08397d8519$export$2e2bcd8739ae039 = (0, $36K9S.default);

});
parcelRegister("36K9S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2435bcbc13998f86$export$2e2bcd8739ae039; });

var $4dya5 = parcelRequire("4dya5");

var $ii97e = parcelRequire("ii97e");

var $9nHZC = parcelRequire("9nHZC");

var $k6QWk = parcelRequire("k6QWk");

var $csjzW = parcelRequire("csjzW");
/* that would be a BREAKING CHANGE!
// delaying sidecar execution till the first usage
const RequireSideCar = (props) => {
  // eslint-disable-next-line global-require
  const SideCar = require('./Trap').default;
  return <SideCar {...props} />;
};
*/ var $2435bcbc13998f86$var$FocusLockCombination = /*#__PURE__*/ $9nHZC.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $9nHZC.createElement((0, $k6QWk.default), (0, $ii97e.default)({
        sideCar: (0, $csjzW.default),
        ref: ref
    }, props));
});
var $2435bcbc13998f86$var$_ref = (0, $k6QWk.default).propTypes || {}, $2435bcbc13998f86$var$sideCar = $2435bcbc13998f86$var$_ref.sideCar, $2435bcbc13998f86$var$propTypes = (0, $4dya5.default)($2435bcbc13998f86$var$_ref, [
    "sideCar"
]);
$2435bcbc13998f86$var$FocusLockCombination.propTypes = {};
var $2435bcbc13998f86$export$2e2bcd8739ae039 = $2435bcbc13998f86$var$FocusLockCombination;

});
parcelRegister("k6QWk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea3d6ef17ebed221$export$2e2bcd8739ae039; });

var $ii97e = parcelRequire("ii97e");

var $9nHZC = parcelRequire("9nHZC");


var $8QeE3 = parcelRequire("8QeE3");

var $bMiNj = parcelRequire("bMiNj");

var $fYED7 = parcelRequire("fYED7");

var $b5UBu = parcelRequire("b5UBu");
var $ea3d6ef17ebed221$var$emptyArray = [];
var $ea3d6ef17ebed221$var$FocusLock = /*#__PURE__*/ $9nHZC.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $9nHZC.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $9nHZC.useRef();
    var isActive = $9nHZC.useRef(false);
    var originalFocusedElement = $9nHZC.useRef(null);
    var children = props.children, disabled = props.disabled, noFocusGuards = props.noFocusGuards, persistentFocus = props.persistentFocus, crossFrame = props.crossFrame, autoFocus = props.autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $ea3d6ef17ebed221$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? "div" : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, shouldReturnFocus = props.returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState2 = $9nHZC.useState({}), id = _React$useState2[0]; // SIDE EFFECT CALLBACKS
    var onActivation = $9nHZC.useCallback(function() {
        originalFocusedElement.current = originalFocusedElement.current || document && document.activeElement;
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $9nHZC.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
    }, [
        onDeactivationCallback
    ]);
    (0, $9nHZC.useEffect)(function() {
        if (!disabled) // cleanup return focus on trap deactivation
        // sideEffect/returnFocus should happen by this time
        originalFocusedElement.current = null;
    }, []);
    var returnFocus = $9nHZC.useCallback(function(allowDefer) {
        var returnFocusTo = originalFocusedElement.current;
        if (returnFocusTo && returnFocusTo.focus) {
            var howToReturnFocus = typeof shouldReturnFocus === "function" ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === "object" ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) // React might return focus after update
                // it's safer to defer the action
                Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]); // MEDIUM CALLBACKS
    var onFocus = $9nHZC.useCallback(function(event) {
        if (isActive.current) (0, $b5UBu.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $b5UBu.mediumBlur).useMedium; // REF PROPAGATION
    // not using real refs due to race conditions
    var setObserveNode = $9nHZC.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $ii97e.default)((_extends2 = {}, _extends2[$8QeE3.FOCUS_DISABLED] = disabled && "disabled", _extends2[$8QeE3.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== "tail";
    var mergedRef = (0, $bMiNj.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    return /*#__PURE__*/ $9nHZC.createElement($9nHZC.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ // nearest focus guard
        $9nHZC.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $fYED7.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $9nHZC.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $fYED7.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $9nHZC.createElement(SideCar, {
        id: id,
        sideCar: (0, $b5UBu.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $9nHZC.createElement(Container, (0, $ii97e.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), children), hasTailingGuards && /*#__PURE__*/ $9nHZC.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $fYED7.hiddenGuard)
    }));
});
$ea3d6ef17ebed221$var$FocusLock.propTypes = {};
$ea3d6ef17ebed221$var$FocusLock.defaultProps = {
    children: undefined,
    disabled: false,
    returnFocus: false,
    focusOptions: undefined,
    noFocusGuards: false,
    autoFocus: true,
    persistentFocus: false,
    crossFrame: true,
    hasPositiveIndices: undefined,
    allowTextSelection: undefined,
    group: undefined,
    className: undefined,
    whiteList: undefined,
    shards: undefined,
    as: "div",
    lockProps: {},
    onActivation: undefined,
    onDeactivation: undefined
};
var $ea3d6ef17ebed221$export$2e2bcd8739ae039 = $ea3d6ef17ebed221$var$FocusLock;

});
parcelRegister("8QeE3", function(module, exports) {

$parcel$export(module.exports, "FOCUS_GROUP", function () { return $66fe8a47fbd14905$export$4f9a06cb7441a087; });
$parcel$export(module.exports, "FOCUS_DISABLED", function () { return $66fe8a47fbd14905$export$aeda8252e54b50f7; });
$parcel$export(module.exports, "FOCUS_ALLOW", function () { return $66fe8a47fbd14905$export$54ecf528c58f9ef6; });
$parcel$export(module.exports, "FOCUS_AUTO", function () { return $66fe8a47fbd14905$export$70e9b4a1820af101; });
$parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", function () { return $66fe8a47fbd14905$export$134ebef29fd94853; });
/**
 * defines a focus group
 */ var $66fe8a47fbd14905$export$4f9a06cb7441a087 = "data-focus-lock";
var $66fe8a47fbd14905$export$aeda8252e54b50f7 = "data-focus-lock-disabled";
var $66fe8a47fbd14905$export$54ecf528c58f9ef6 = "data-no-focus-lock";
var $66fe8a47fbd14905$export$70e9b4a1820af101 = "data-autofocus-inside";
var $66fe8a47fbd14905$export$134ebef29fd94853 = "data-no-autofocus";

});

parcelRegister("bMiNj", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", function () { return $8932c198a63a96fd$export$74665b213cb5c4cf; });

var $fMysV = parcelRequire("fMysV");

var $1fKx7 = parcelRequire("1fKx7");
function $8932c198a63a96fd$export$74665b213cb5c4cf(refs, defaultValue) {
    return (0, $1fKx7.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $fMysV.assignRef)(ref, newValue);
        });
    });
}

});
parcelRegister("fMysV", function(module, exports) {

$parcel$export(module.exports, "assignRef", function () { return $b7d612da0b0652d2$export$d734136a7b018efe; });
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $b7d612da0b0652d2$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("1fKx7", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", function () { return $0e9b49aa17bc9f34$export$25bec8c6f54ee79a; });

var $9nHZC = parcelRequire("9nHZC");
function $0e9b49aa17bc9f34$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $9nHZC.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("fYED7", function(module, exports) {

$parcel$export(module.exports, "hiddenGuard", function () { return $ba1bf9db98b17fcd$export$b8c7b07253306600; });

var $9nHZC = parcelRequire("9nHZC");

var $ba1bf9db98b17fcd$export$b8c7b07253306600 = {
    width: "1px",
    height: "0px",
    padding: 0,
    overflow: "hidden",
    position: "fixed",
    top: "1px",
    left: "1px"
};
var $ba1bf9db98b17fcd$var$InFocusGuard = function InFocusGuard(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $9nHZC.createElement($9nHZC.Fragment, null, /*#__PURE__*/ $9nHZC.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $ba1bf9db98b17fcd$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $9nHZC.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $ba1bf9db98b17fcd$export$b8c7b07253306600
    }));
};
$ba1bf9db98b17fcd$var$InFocusGuard.propTypes = {};
$ba1bf9db98b17fcd$var$InFocusGuard.defaultProps = {
    children: null
};
var $ba1bf9db98b17fcd$export$2e2bcd8739ae039 = $ba1bf9db98b17fcd$var$InFocusGuard;

});

parcelRegister("b5UBu", function(module, exports) {

$parcel$export(module.exports, "mediumFocus", function () { return $813c11a5811a0378$export$5733e022b1d538cb; });
$parcel$export(module.exports, "mediumBlur", function () { return $813c11a5811a0378$export$b3e9a9312f73723c; });
$parcel$export(module.exports, "mediumEffect", function () { return $813c11a5811a0378$export$3a1d52767cbc07b8; });
$parcel$export(module.exports, "mediumSidecar", function () { return $813c11a5811a0378$export$892cbf28e5518020; });

var $2V0Tb = parcelRequire("2V0Tb");
var $813c11a5811a0378$export$5733e022b1d538cb = (0, $2V0Tb.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $813c11a5811a0378$export$b3e9a9312f73723c = (0, $2V0Tb.createMedium)();
var $813c11a5811a0378$export$3a1d52767cbc07b8 = (0, $2V0Tb.createMedium)();
var $813c11a5811a0378$export$892cbf28e5518020 = (0, $2V0Tb.createSidecarMedium)({
    async: true // focus-lock sidecar is not required on the server
});

});
parcelRegister("2V0Tb", function(module, exports) {

$parcel$export(module.exports, "createMedium", function () { return $22019833f36a0edf$export$9ffbfcaf067b02c6; });
$parcel$export(module.exports, "createSidecarMedium", function () { return $22019833f36a0edf$export$e13ec7dd7a14088d; });

var $6iyQ6 = parcelRequire("6iyQ6");
function $22019833f36a0edf$var$ItoI(a) {
    return a;
}
function $22019833f36a0edf$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $22019833f36a0edf$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $22019833f36a0edf$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $22019833f36a0edf$var$ItoI;
    return $22019833f36a0edf$var$innerCreateMedium(defaults, middleware);
}
function $22019833f36a0edf$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $22019833f36a0edf$var$innerCreateMedium(null);
    medium.options = (0, $6iyQ6.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});
parcelRegister("6iyQ6", function(module, exports) {

$parcel$export(module.exports, "__assign", function () { return $495f72e136bd8bb2$export$18ce0697a983be9b; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $495f72e136bd8bb2$var$extendStatics = function(d, b) {
    $495f72e136bd8bb2$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $495f72e136bd8bb2$var$extendStatics(d, b);
};
function $495f72e136bd8bb2$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $495f72e136bd8bb2$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $495f72e136bd8bb2$export$18ce0697a983be9b = function() {
    $495f72e136bd8bb2$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $495f72e136bd8bb2$export$18ce0697a983be9b.apply(this, arguments);
};
function $495f72e136bd8bb2$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $495f72e136bd8bb2$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $495f72e136bd8bb2$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $495f72e136bd8bb2$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $495f72e136bd8bb2$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $495f72e136bd8bb2$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $495f72e136bd8bb2$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $495f72e136bd8bb2$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $495f72e136bd8bb2$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $495f72e136bd8bb2$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $495f72e136bd8bb2$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $495f72e136bd8bb2$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $495f72e136bd8bb2$export$45d3717a4c69092e(o, m, p);
}
function $495f72e136bd8bb2$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $495f72e136bd8bb2$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $495f72e136bd8bb2$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($495f72e136bd8bb2$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $495f72e136bd8bb2$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $495f72e136bd8bb2$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $495f72e136bd8bb2$export$10c90e4f7922046c(v) {
    return this instanceof $495f72e136bd8bb2$export$10c90e4f7922046c ? (this.v = v, this) : new $495f72e136bd8bb2$export$10c90e4f7922046c(v);
}
function $495f72e136bd8bb2$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $495f72e136bd8bb2$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $495f72e136bd8bb2$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $495f72e136bd8bb2$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $495f72e136bd8bb2$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $495f72e136bd8bb2$export$19a8beecd37a4c45 === "function" ? $495f72e136bd8bb2$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $495f72e136bd8bb2$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $495f72e136bd8bb2$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $495f72e136bd8bb2$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $495f72e136bd8bb2$export$45d3717a4c69092e(result, mod, k);
    }
    $495f72e136bd8bb2$var$__setModuleDefault(result, mod);
    return result;
}
function $495f72e136bd8bb2$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $495f72e136bd8bb2$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $495f72e136bd8bb2$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $495f72e136bd8bb2$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $495f72e136bd8bb2$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $495f72e136bd8bb2$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $495f72e136bd8bb2$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $495f72e136bd8bb2$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $495f72e136bd8bb2$export$2e2bcd8739ae039 = {
    __extends: $495f72e136bd8bb2$export$a8ba968b8961cb8a,
    __assign: $495f72e136bd8bb2$export$18ce0697a983be9b,
    __rest: $495f72e136bd8bb2$export$3c9a16f847548506,
    __decorate: $495f72e136bd8bb2$export$29e00dfd3077644b,
    __param: $495f72e136bd8bb2$export$d5ad3fd78186038f,
    __metadata: $495f72e136bd8bb2$export$f1db080c865becb9,
    __awaiter: $495f72e136bd8bb2$export$1050f835b63b671e,
    __generator: $495f72e136bd8bb2$export$67ebef60e6f28a6,
    __createBinding: $495f72e136bd8bb2$export$45d3717a4c69092e,
    __exportStar: $495f72e136bd8bb2$export$f33643c0debef087,
    __values: $495f72e136bd8bb2$export$19a8beecd37a4c45,
    __read: $495f72e136bd8bb2$export$8d051b38c9118094,
    __spread: $495f72e136bd8bb2$export$afc72e2116322959,
    __spreadArrays: $495f72e136bd8bb2$export$6388937ca91ccae8,
    __spreadArray: $495f72e136bd8bb2$export$1216008129fb82ed,
    __await: $495f72e136bd8bb2$export$10c90e4f7922046c,
    __asyncGenerator: $495f72e136bd8bb2$export$e427f37a30a4de9b,
    __asyncDelegator: $495f72e136bd8bb2$export$bbd80228419bb833,
    __asyncValues: $495f72e136bd8bb2$export$e3b29a3d6162315f,
    __makeTemplateObject: $495f72e136bd8bb2$export$4fb47efe1390b86f,
    __importStar: $495f72e136bd8bb2$export$c21735bcef00d192,
    __importDefault: $495f72e136bd8bb2$export$da59b14a69baef04,
    __classPrivateFieldGet: $495f72e136bd8bb2$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $495f72e136bd8bb2$export$d40a35129aaff81f,
    __classPrivateFieldIn: $495f72e136bd8bb2$export$81fdc39f203e4e04,
    __addDisposableResource: $495f72e136bd8bb2$export$88ac25d8e944e405,
    __disposeResources: $495f72e136bd8bb2$export$8f076105dc360e92
};

});




parcelRegister("csjzW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91174981c56ce9e5$export$2e2bcd8739ae039; });
/* eslint-disable no-mixed-operators */ 
var $9nHZC = parcelRequire("9nHZC");


var $4EEXD = parcelRequire("4EEXD");

var $fJ7cL = parcelRequire("fJ7cL");
var $4Y4i6 = parcelRequire("4Y4i6");
var $gUjMB = parcelRequire("gUjMB");
var $2Izwt = parcelRequire("2Izwt");

var $fQSmP = parcelRequire("fQSmP");

var $b5UBu = parcelRequire("b5UBu");
var $91174981c56ce9e5$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $91174981c56ce9e5$var$isFreeFocus = function isFreeFocus() {
    return $91174981c56ce9e5$var$focusOnBody() || (0, $gUjMB.focusIsHidden)();
};
var $91174981c56ce9e5$var$lastActiveTrap = null;
var $91174981c56ce9e5$var$lastActiveFocus = null;
var $91174981c56ce9e5$var$lastPortaledElement = null;
var $91174981c56ce9e5$var$focusWasOutsideWindow = false;
var $91174981c56ce9e5$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $91174981c56ce9e5$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($91174981c56ce9e5$var$lastActiveTrap.whiteList || $91174981c56ce9e5$var$defaultWhitelist)(activeElement);
};
var $91174981c56ce9e5$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $91174981c56ce9e5$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $91174981c56ce9e5$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $91174981c56ce9e5$var$lastPortaledElement && $91174981c56ce9e5$var$lastPortaledElement.portaledElement === element;
};
function $91174981c56ce9e5$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) // we will tab to the next element
            return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $91174981c56ce9e5$var$extractRef = function extractRef(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $91174981c56ce9e5$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) // with cross frame return true for any value
    return Boolean($91174981c56ce9e5$var$focusWasOutsideWindow);
     // in other case return only of focus went a while aho
    return $91174981c56ce9e5$var$focusWasOutsideWindow === "meanwhile";
};
var $91174981c56ce9e5$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement) // dive up
    ) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $91174981c56ce9e5$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $91174981c56ce9e5$var$checkInHost(activeElement, area, area);
    });
};
var $91174981c56ce9e5$var$activateTrap = function activateTrap() {
    var result = false;
    if ($91174981c56ce9e5$var$lastActiveTrap) {
        var _lastActiveTrap = $91174981c56ce9e5$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $91174981c56ce9e5$var$lastPortaledElement && $91174981c56ce9e5$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map($91174981c56ce9e5$var$extractRef).filter(Boolean));
            if (!activeElement || $91174981c56ce9e5$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $91174981c56ce9e5$var$focusWasOutside(crossFrame) || !$91174981c56ce9e5$var$isFreeFocus() || !$91174981c56ce9e5$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $4Y4i6.focusInside)(workingArea) || // check for shadow-dom contained elements
                    activeElement && $91174981c56ce9e5$var$withinHost(activeElement, workingArea) || $91174981c56ce9e5$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$91174981c56ce9e5$var$lastActiveFocus && activeElement && !autoFocus) {
                            // Check if blur() exists, which is missing on certain elements on IE
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $fJ7cL.default)(workingArea, $91174981c56ce9e5$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $91174981c56ce9e5$var$lastPortaledElement = {};
                        }
                    }
                    $91174981c56ce9e5$var$focusWasOutsideWindow = false;
                    $91174981c56ce9e5$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $2Izwt.getFocusabledIn)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    // remove old focus
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute("tabIndex");
                    });
                    $91174981c56ce9e5$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $91174981c56ce9e5$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $91174981c56ce9e5$var$onTrap = function onTrap(event) {
    if ($91174981c56ce9e5$var$activateTrap() && event) {
        // prevent scroll jump
        event.stopPropagation();
        event.preventDefault();
    }
};
var $91174981c56ce9e5$var$onBlur = function onBlur() {
    return (0, $fQSmP.deferAction)($91174981c56ce9e5$var$activateTrap);
};
var $91174981c56ce9e5$var$onFocus = function onFocus(event) {
    // detect portal
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $91174981c56ce9e5$var$recordPortal(currentNode, source);
};
var $91174981c56ce9e5$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $91174981c56ce9e5$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $9nHZC.createElement("div", {
        onBlur: $91174981c56ce9e5$var$onBlur,
        onFocus: $91174981c56ce9e5$var$onFocus
    }, children);
};
$91174981c56ce9e5$var$FocusTrap.propTypes = {};
var $91174981c56ce9e5$var$onWindowBlur = function onWindowBlur() {
    $91174981c56ce9e5$var$focusWasOutsideWindow = "just"; // using setTimeout to set  this variable after React/sidecar reaction
    (0, $fQSmP.deferAction)(function() {
        $91174981c56ce9e5$var$focusWasOutsideWindow = "meanwhile";
    });
};
var $91174981c56ce9e5$var$attachHandler = function attachHandler() {
    document.addEventListener("focusin", $91174981c56ce9e5$var$onTrap);
    document.addEventListener("focusout", $91174981c56ce9e5$var$onBlur);
    window.addEventListener("blur", $91174981c56ce9e5$var$onWindowBlur);
};
var $91174981c56ce9e5$var$detachHandler = function detachHandler() {
    document.removeEventListener("focusin", $91174981c56ce9e5$var$onTrap);
    document.removeEventListener("focusout", $91174981c56ce9e5$var$onBlur);
    window.removeEventListener("blur", $91174981c56ce9e5$var$onWindowBlur);
};
function $91174981c56ce9e5$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
function $91174981c56ce9e5$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$91174981c56ce9e5$var$lastActiveTrap) $91174981c56ce9e5$var$attachHandler();
    var lastTrap = $91174981c56ce9e5$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $91174981c56ce9e5$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation(); // return focus only of last trap was removed
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) // allow defer is no other trap is awaiting restore
        lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $91174981c56ce9e5$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation();
        $91174981c56ce9e5$var$activateTrap(true);
        (0, $fQSmP.deferAction)($91174981c56ce9e5$var$activateTrap);
    } else {
        $91174981c56ce9e5$var$detachHandler();
        $91174981c56ce9e5$var$lastActiveFocus = null;
    }
} // bind medium
(0, $b5UBu.mediumFocus).assignSyncMedium($91174981c56ce9e5$var$onFocus);
(0, $b5UBu.mediumBlur).assignMedium($91174981c56ce9e5$var$onBlur);
(0, $b5UBu.mediumEffect).assignMedium(function(cb) {
    return cb({
        moveFocusInside: (0, $fJ7cL.default),
        focusInside: (0, $4Y4i6.focusInside)
    });
});
var $91174981c56ce9e5$export$2e2bcd8739ae039 = (0, $4EEXD.default)($91174981c56ce9e5$var$reducePropsToState, $91174981c56ce9e5$var$handleStateChangeOnClient)($91174981c56ce9e5$var$FocusWatcher);

});
parcelRegister("4EEXD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $363aabd1ba8389dc$export$2e2bcd8739ae039; });

var $fXGwT = parcelRequire("fXGwT");

var $14L3Y = parcelRequire("14L3Y");

var $9nHZC = parcelRequire("9nHZC");
function $363aabd1ba8389dc$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $fXGwT.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $9nHZC.PureComponent));
        (0, $14L3Y.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $363aabd1ba8389dc$export$2e2bcd8739ae039 = $363aabd1ba8389dc$var$withSideEffect;

});
parcelRegister("14L3Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c8aabef145d3e69$export$2e2bcd8739ae039; });

var $7fhjg = parcelRequire("7fhjg");
function $0c8aabef145d3e69$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $7fhjg.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("7fhjg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54675c74005f710c$export$2e2bcd8739ae039; });

var $5fAHr = parcelRequire("5fAHr");

var $kq2le = parcelRequire("kq2le");
function $54675c74005f710c$export$2e2bcd8739ae039(t) {
    var i = (0, $kq2le.default)(t, "string");
    return "symbol" == (0, $5fAHr.default)(i) ? i : i + "";
}

});
parcelRegister("5fAHr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d2ad246a975cc12$export$2e2bcd8739ae039; });
function $3d2ad246a975cc12$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $3d2ad246a975cc12$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3d2ad246a975cc12$export$2e2bcd8739ae039(o);
}

});

parcelRegister("kq2le", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edd80d4ded3ff98b$export$2e2bcd8739ae039; });

var $5fAHr = parcelRequire("5fAHr");
function $edd80d4ded3ff98b$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $5fAHr.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $5fAHr.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("fJ7cL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b730a5badd1ba192$export$2e2bcd8739ae039; });


var $4Y4i6 = parcelRequire("4Y4i6");

var $gUjMB = parcelRequire("gUjMB");


var $2Izwt = parcelRequire("2Izwt");

var $aOE1D = parcelRequire("aOE1D");




var $b730a5badd1ba192$export$2e2bcd8739ae039 //
 = (0, $aOE1D.setFocus);

});
parcelRegister("4Y4i6", function(module, exports) {

$parcel$export(module.exports, "focusInside", function () { return $39e01823525be7c2$export$20115f8da7baa6fa; });

var $ckei5 = parcelRequire("ckei5");

var $gfEUT = parcelRequire("gfEUT");

var $7Ak1S = parcelRequire("7Ak1S");

var $cq0b6 = parcelRequire("cq0b6");
var $39e01823525be7c2$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $39e01823525be7c2$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $7Ak1S.toArray)(topNode.querySelectorAll("iframe")).some(function(node) {
        return $39e01823525be7c2$var$focusInFrame(node, activeElement);
    }));
};
var $39e01823525be7c2$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $cq0b6.getActiveElement)((0, $7Ak1S.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $gfEUT.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $ckei5.contains)(node, activeElement) || $39e01823525be7c2$var$focusInsideIframe(node, activeElement);
    });
};

});
parcelRegister("ckei5", function(module, exports) {

$parcel$export(module.exports, "filterAutoFocusable", function () { return $8f9270208febc2ae$export$2f70373d403a5d2b; });
$parcel$export(module.exports, "getTabbableNodes", function () { return $8f9270208febc2ae$export$3738e313571e2ad2; });
$parcel$export(module.exports, "getAllTabbableNodes", function () { return $8f9270208febc2ae$export$23c79be8286a3b0c; });
$parcel$export(module.exports, "parentAutofocusables", function () { return $8f9270208febc2ae$export$dc26309a71d1ce47; });
$parcel$export(module.exports, "contains", function () { return $8f9270208febc2ae$export$2344b14b097df817; });

var $7Ak1S = parcelRequire("7Ak1S");

var $gWw3B = parcelRequire("gWw3B");

var $3oObs = parcelRequire("3oObs");

var $aJKbl = parcelRequire("aJKbl");
var $8f9270208febc2ae$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $7Ak1S.toArray)(nodes).filter(function(node) {
        return (0, $gWw3B.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $gWw3B.notHiddenInput)(node);
    });
};
var $8f9270208febc2ae$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $7Ak1S.toArray)(nodes).filter(function(node) {
        return (0, $gWw3B.isAutoFocusAllowedCached)(cache, node);
    });
};
var $8f9270208febc2ae$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $3oObs.orderByTabIndex)($8f9270208febc2ae$export$6266a5cd5915dc33((0, $aJKbl.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $8f9270208febc2ae$export$23c79be8286a3b0c = function(topNodes, visibilityCache) {
    return (0, $3oObs.orderByTabIndex)($8f9270208febc2ae$export$6266a5cd5915dc33((0, $aJKbl.getFocusables)(topNodes), visibilityCache), false);
};
var $8f9270208febc2ae$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $8f9270208febc2ae$export$6266a5cd5915dc33((0, $aJKbl.getParentAutofocusables)(topNode), visibilityCache);
};
var $8f9270208febc2ae$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $8f9270208febc2ae$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $7Ak1S.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $8f9270208febc2ae$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $8f9270208febc2ae$export$2344b14b097df817(child, element);
        });
    }
};

});
parcelRegister("7Ak1S", function(module, exports) {

$parcel$export(module.exports, "toArray", function () { return $016cd45d53d9bff5$export$45b10814cc054894; });
$parcel$export(module.exports, "asArray", function () { return $016cd45d53d9bff5$export$75093a47a9fa838d; });
$parcel$export(module.exports, "getFirst", function () { return $016cd45d53d9bff5$export$bcd7afcd904dce14; });
/*
IE11 support
 */ var $016cd45d53d9bff5$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $016cd45d53d9bff5$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $016cd45d53d9bff5$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

});

parcelRegister("gWw3B", function(module, exports) {

$parcel$export(module.exports, "isVisibleCached", function () { return $c55aedf9bfd00140$export$3c9dc299685ad160; });
$parcel$export(module.exports, "isAutoFocusAllowedCached", function () { return $c55aedf9bfd00140$export$bcaa50628f6a736e; });
$parcel$export(module.exports, "getDataset", function () { return $c55aedf9bfd00140$export$698b339b0c8edae3; });
$parcel$export(module.exports, "isRadioElement", function () { return $c55aedf9bfd00140$export$9d74f6fbc6f469d0; });
$parcel$export(module.exports, "notHiddenInput", function () { return $c55aedf9bfd00140$export$8197b0ea56b3b055; });
$parcel$export(module.exports, "isGuard", function () { return $c55aedf9bfd00140$export$d94b8b58ec2f30eb; });
$parcel$export(module.exports, "isNotAGuard", function () { return $c55aedf9bfd00140$export$602e5a0d338d7750; });
$parcel$export(module.exports, "isDefined", function () { return $c55aedf9bfd00140$export$4e62c701997796c1; });

var $8QeE3 = parcelRequire("8QeE3");
var $c55aedf9bfd00140$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue("display") === "none" || computedStyle.getPropertyValue("visibility") === "hidden";
};
var $c55aedf9bfd00140$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $c55aedf9bfd00140$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $c55aedf9bfd00140$var$isVisibleUncached = function(node, checkParent) {
    return !node || $c55aedf9bfd00140$var$isTopNode(node) || !$c55aedf9bfd00140$var$isElementHidden(node) && checkParent($c55aedf9bfd00140$var$getParentNode(node));
};
var $c55aedf9bfd00140$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $c55aedf9bfd00140$var$isVisibleUncached(node, $c55aedf9bfd00140$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $c55aedf9bfd00140$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$c55aedf9bfd00140$var$isTopNode(node) ? $c55aedf9bfd00140$export$b8550e27de209d85(node) ? checkParent($c55aedf9bfd00140$var$getParentNode(node)) : false : true;
};
var $c55aedf9bfd00140$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $c55aedf9bfd00140$var$isAutoFocusAllowedUncached(node, $c55aedf9bfd00140$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $c55aedf9bfd00140$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $c55aedf9bfd00140$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === "BUTTON";
};
var $c55aedf9bfd00140$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === "INPUT";
};
var $c55aedf9bfd00140$export$9d74f6fbc6f469d0 = function(node) {
    return $c55aedf9bfd00140$export$88a6ceeed5737ba3(node) && node.type === "radio";
};
var $c55aedf9bfd00140$export$8197b0ea56b3b055 = function(node) {
    return !(($c55aedf9bfd00140$export$88a6ceeed5737ba3(node) || $c55aedf9bfd00140$export$65aad1b6bc934b11(node)) && (node.type === "hidden" || node.disabled));
};
var $c55aedf9bfd00140$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $8QeE3.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        "true",
        ""
    ].includes(attribute);
};
var $c55aedf9bfd00140$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $c55aedf9bfd00140$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $c55aedf9bfd00140$export$602e5a0d338d7750 = function(node) {
    return !$c55aedf9bfd00140$export$d94b8b58ec2f30eb(node);
};
var $c55aedf9bfd00140$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};

});

parcelRegister("3oObs", function(module, exports) {

$parcel$export(module.exports, "orderByTabIndex", function () { return $279a8a722660e81e$export$cb40ee071f0d5226; });

var $7Ak1S = parcelRequire("7Ak1S");
var $279a8a722660e81e$export$350ee6c095d98996 = function(a, b) {
    var tabDiff = a.tabIndex - b.tabIndex;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!a.tabIndex) return 1;
        if (!b.tabIndex) return -1;
    }
    return tabDiff || indexDiff;
};
var $279a8a722660e81e$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $7Ak1S.toArray)(nodes).map(function(node, index) {
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && node.tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : node.tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($279a8a722660e81e$export$350ee6c095d98996);
};

});

parcelRegister("aJKbl", function(module, exports) {

$parcel$export(module.exports, "getFocusables", function () { return $7d11ee1bd30f7eef$export$f6768025e418420e; });
$parcel$export(module.exports, "getParentAutofocusables", function () { return $7d11ee1bd30f7eef$export$853fa94d922e78b9; });

var $8QeE3 = parcelRequire("8QeE3");

var $7Ak1S = parcelRequire("7Ak1S");

var $6oLC1 = parcelRequire("6oLC1");
var $7d11ee1bd30f7eef$var$queryTabbables = (0, $6oLC1.tabbables).join(",");
var $7d11ee1bd30f7eef$var$queryGuardTabbables = "".concat($7d11ee1bd30f7eef$var$queryTabbables, ", [data-focus-guard]");
var $7d11ee1bd30f7eef$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $7Ak1S.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $7d11ee1bd30f7eef$var$queryGuardTabbables : $7d11ee1bd30f7eef$var$queryTabbables) ? [
            child
        ] : [], $7d11ee1bd30f7eef$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $7d11ee1bd30f7eef$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $7d11ee1bd30f7eef$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $7d11ee1bd30f7eef$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $7d11ee1bd30f7eef$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $7d11ee1bd30f7eef$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $7Ak1S.toArray)(parent.parentNode.querySelectorAll($7d11ee1bd30f7eef$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $7d11ee1bd30f7eef$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $8QeE3.FOCUS_AUTO), "]"));
    return (0, $7Ak1S.toArray)(parentFocus).map(function(node) {
        return $7d11ee1bd30f7eef$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRegister("6oLC1", function(module, exports) {

$parcel$export(module.exports, "tabbables", function () { return $4a89eac0744a4212$export$8555f4622e95784; });
/**
 * list of the object to be considered as focusable
 */ var $4a89eac0744a4212$export$8555f4622e95784 = [
    "button:enabled",
    "select:enabled",
    "textarea:enabled",
    "input:enabled",
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[tabindex]",
    "[contenteditable]",
    "[autofocus]"
];

});



parcelRegister("gfEUT", function(module, exports) {

$parcel$export(module.exports, "getAllAffectedNodes", function () { return $bd4dc93ea79b7f15$export$7e87c4720b9b279b; });

var $8QeE3 = parcelRequire("8QeE3");

var $7Ak1S = parcelRequire("7Ak1S");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $bd4dc93ea79b7f15$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $bd4dc93ea79b7f15$var$getTopParent = function(node) {
    return node.parentNode ? $bd4dc93ea79b7f15$var$getTopParent(node.parentNode) : node;
};
var $bd4dc93ea79b7f15$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $7Ak1S.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $8QeE3.FOCUS_GROUP));
        acc.push.apply(acc, group ? $bd4dc93ea79b7f15$var$filterNested((0, $7Ak1S.toArray)($bd4dc93ea79b7f15$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $8QeE3.FOCUS_GROUP), '="').concat(group, '"]:not([').concat((0, $8QeE3.FOCUS_DISABLED), '="disabled"])')))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

});

parcelRegister("cq0b6", function(module, exports) {

$parcel$export(module.exports, "getActiveElement", function () { return $90a80d1e72d04177$export$cd4e5573fbe2b576; });
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $gH0qx = parcelRequire("gH0qx");
var $90a80d1e72d04177$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $90a80d1e72d04177$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $gH0qx.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $90a80d1e72d04177$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};

});
parcelRegister("gH0qx", function(module, exports) {

$parcel$export(module.exports, "safeProbe", function () { return $c270fe5130f85f74$export$78d20aae35adef88; });
var $c270fe5130f85f74$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

});



parcelRegister("gUjMB", function(module, exports) {

$parcel$export(module.exports, "focusIsHidden", function () { return $c4f138c69de24c59$export$be6b21806d3fd485; });

var $8QeE3 = parcelRequire("8QeE3");

var $ckei5 = parcelRequire("ckei5");

var $7Ak1S = parcelRequire("7Ak1S");

var $cq0b6 = parcelRequire("cq0b6");
var $c4f138c69de24c59$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $cq0b6.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $7Ak1S.toArray)(inDocument.querySelectorAll("[".concat((0, $8QeE3.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $ckei5.contains)(node, activeElement);
    });
};

});

parcelRegister("2Izwt", function(module, exports) {

$parcel$export(module.exports, "getFocusabledIn", function () { return $1fab3ee7dd03972b$export$30d9c643899a8835; });

var $ckei5 = parcelRequire("ckei5");

var $gfEUT = parcelRequire("gfEUT");

var $gWw3B = parcelRequire("gWw3B");

var $eRgpi = parcelRequire("eRgpi");
var $1fab3ee7dd03972b$export$30d9c643899a8835 = function(topNode) {
    var entries = (0, $gfEUT.getAllAffectedNodes)(topNode).filter((0, $gWw3B.isNotAGuard));
    var commonParent = (0, $eRgpi.getTopCommonParent)(topNode, topNode, entries);
    var visibilityCache = new Map();
    var outerNodes = (0, $ckei5.getTabbableNodes)([
        commonParent
    ], visibilityCache, true);
    var innerElements = (0, $ckei5.getTabbableNodes)(entries, visibilityCache).filter(function(_a) {
        var node = _a.node;
        return (0, $gWw3B.isNotAGuard)(node);
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $gWw3B.isGuard)(node)
        };
    });
};
var $1fab3ee7dd03972b$export$5f246425711134ac = $1fab3ee7dd03972b$export$30d9c643899a8835;

});
parcelRegister("eRgpi", function(module, exports) {

$parcel$export(module.exports, "getTopCommonParent", function () { return $ad12be042fb87465$export$a9a7252b5f2e280e; });
$parcel$export(module.exports, "allParentAutofocusables", function () { return $ad12be042fb87465$export$8f99714c70a37db1; });

var $ckei5 = parcelRequire("ckei5");

var $7Ak1S = parcelRequire("7Ak1S");
var $ad12be042fb87465$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $ad12be042fb87465$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $ad12be042fb87465$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $ad12be042fb87465$var$getParents(nodeA);
    var parentsB = $ad12be042fb87465$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $ad12be042fb87465$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $7Ak1S.asArray)(baseActiveElement);
    var leftEntries = (0, $7Ak1S.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $ad12be042fb87465$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $ad12be042fb87465$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $ckei5.contains)(common, topCommon)) topCommon = common;
                else topCommon = $ad12be042fb87465$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $ad12be042fb87465$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $ckei5.parentAutofocusables)(node, visibilityCache));
    }, []);
};

});


parcelRegister("aOE1D", function(module, exports) {

$parcel$export(module.exports, "setFocus", function () { return $7dfd9f17cf6aac72$export$f06c444b0336b5d5; });

var $2z8Ju = parcelRequire("2z8Ju");
var $7dfd9f17cf6aac72$export$c12b3da842c43a8 = function(target, focusOptions) {
    if ("focus" in target) target.focus(focusOptions);
    if ("contentWindow" in target && target.contentWindow) target.contentWindow.focus();
};
var $7dfd9f17cf6aac72$var$guardCount = 0;
var $7dfd9f17cf6aac72$var$lockDisabled = false;
var $7dfd9f17cf6aac72$export$f06c444b0336b5d5 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $2z8Ju.getFocusMerge)(topNode, lastNode);
    if ($7dfd9f17cf6aac72$var$lockDisabled) return;
    if (focusable) {
        if ($7dfd9f17cf6aac72$var$guardCount > 2) {
            // tslint:disable-next-line:no-console
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $7dfd9f17cf6aac72$var$lockDisabled = true;
            setTimeout(function() {
                $7dfd9f17cf6aac72$var$lockDisabled = false;
            }, 1);
            return;
        }
        $7dfd9f17cf6aac72$var$guardCount++;
        $7dfd9f17cf6aac72$export$c12b3da842c43a8(focusable.node, options.focusOptions);
        $7dfd9f17cf6aac72$var$guardCount--;
    }
};

});
parcelRegister("2z8Ju", function(module, exports) {

$parcel$export(module.exports, "getFocusMerge", function () { return $1de59fc54275b980$export$82d3f62e3f171d1d; });

var $dPIwx = parcelRequire("dPIwx");

var $ckei5 = parcelRequire("ckei5");

var $gfEUT = parcelRequire("gfEUT");

var $7Ak1S = parcelRequire("7Ak1S");

var $jAUlR = parcelRequire("jAUlR");

var $cq0b6 = parcelRequire("cq0b6");

var $gWw3B = parcelRequire("gWw3B");

var $eRgpi = parcelRequire("eRgpi");
var $1de59fc54275b980$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $gWw3B.isDefined));
};
var $1de59fc54275b980$export$82d3f62e3f171d1d = function(topNode, lastNode) {
    var activeElement = (0, $cq0b6.getActiveElement)((0, $7Ak1S.asArray)(topNode).length > 0 ? document : (0, $7Ak1S.getFirst)(topNode).ownerDocument);
    var entries = (0, $gfEUT.getAllAffectedNodes)(topNode).filter((0, $gWw3B.isNotAGuard));
    var commonParent = (0, $eRgpi.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $ckei5.getAllTabbableNodes)(entries, visibilityCache);
    var innerElements = (0, $ckei5.getTabbableNodes)(entries, visibilityCache).filter(function(_a) {
        var node = _a.node;
        return (0, $gWw3B.isNotAGuard)(node);
    });
    if (!innerElements[0]) {
        innerElements = anyFocusable;
        if (!innerElements[0]) return undefined;
    }
    var outerNodes = (0, $ckei5.getAllTabbableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $1de59fc54275b980$var$reorderNodes(outerNodes, innerElements);
    var innerNodes = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $dPIwx.newFocus)(innerNodes, outerNodes, activeElement, lastNode);
    if (newId === (0, $dPIwx.NEW_FOCUS)) {
        var focusNode = (0, $jAUlR.pickAutofocus)(anyFocusable, innerNodes, (0, $eRgpi.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn("focus-lock: cannot find any node to move focus into");
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

});
parcelRegister("dPIwx", function(module, exports) {

$parcel$export(module.exports, "NEW_FOCUS", function () { return $a122934689164452$export$85710b12cf912438; });
$parcel$export(module.exports, "newFocus", function () { return $a122934689164452$export$65842178e9bb4205; });

var $lJMz0 = parcelRequire("lJMz0");

var $kyQRe = parcelRequire("kyQRe");

var $gWw3B = parcelRequire("gWw3B");
var $a122934689164452$export$85710b12cf912438 = "NEW_FOCUS";
var $a122934689164452$export$65842178e9bb4205 = function(innerNodes, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $gWw3B.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $lJMz0.correctNodes)(outerNodes);
    var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    var returnFirstNode = (0, $kyQRe.pickFocusable)(innerNodes, 0);
    var returnLastNode = (0, $kyQRe.pickFocusable)(innerNodes, cnt - 1);
    // new focus
    if (activeIndex === -1 || lastNodeInside === -1) return $a122934689164452$export$85710b12cf912438;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

});
parcelRegister("lJMz0", function(module, exports) {

$parcel$export(module.exports, "correctNode", function () { return $fd3378a59d3ebd9e$export$5261662167ad7ced; });
$parcel$export(module.exports, "correctNodes", function () { return $fd3378a59d3ebd9e$export$4a5a72a7124e45f9; });

var $gWw3B = parcelRequire("gWw3B");
var $fd3378a59d3ebd9e$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $gWw3B.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $fd3378a59d3ebd9e$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $gWw3B.isRadioElement)(node) && node.name) return $fd3378a59d3ebd9e$var$findSelectedRadio(node, nodes);
    return node;
};
var $fd3378a59d3ebd9e$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($fd3378a59d3ebd9e$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

});

parcelRegister("kyQRe", function(module, exports) {

$parcel$export(module.exports, "pickFirstFocus", function () { return $ef7ffc0c6c6b111b$export$f4e86cfa0679b9cc; });
$parcel$export(module.exports, "pickFocusable", function () { return $ef7ffc0c6c6b111b$export$e06728ee87c96122; });

var $lJMz0 = parcelRequire("lJMz0");
var $ef7ffc0c6c6b111b$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $lJMz0.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $ef7ffc0c6c6b111b$export$e06728ee87c96122 = function(nodes, index) {
    if (nodes.length > 1) return nodes.indexOf((0, $lJMz0.correctNode)(nodes[index], nodes));
    return index;
};

});


parcelRegister("jAUlR", function(module, exports) {

$parcel$export(module.exports, "pickAutofocus", function () { return $e43d175cf96d01e6$export$cfb742983e257555; });

var $ckei5 = parcelRequire("ckei5");

var $kyQRe = parcelRequire("kyQRe");

var $gWw3B = parcelRequire("gWw3B");
var $e43d175cf96d01e6$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $gWw3B.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== "false" || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $e43d175cf96d01e6$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $ckei5.filterAutoFocusable)(nodes.filter($e43d175cf96d01e6$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $kyQRe.pickFirstFocus)(autoFocusable);
    return (0, $kyQRe.pickFirstFocus)((0, $ckei5.filterAutoFocusable)(orderedNodes));
};

});




parcelRegister("fQSmP", function(module, exports) {

$parcel$export(module.exports, "deferAction", function () { return $b8a5e287884a7344$export$6523025722806278; });
function $b8a5e287884a7344$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $b8a5e287884a7344$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};

});




parcelRegister("knkgL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jV8vL = parcelRequire("jV8vL");
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $ed55adafa60b6393$var$_interopRequireDefault($jV8vL).default;
    }
});

var $jcTzs = parcelRequire("jcTzs");
Object.defineProperty(module.exports, "TouchScrollable", {
    enumerable: true,
    get: function get() {
        return $jcTzs.TouchScrollable;
    }
});
function $ed55adafa60b6393$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("jV8vL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e809f16197ed0167$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $9nHZC = parcelRequire("9nHZC");
var $e809f16197ed0167$var$_react2 = $e809f16197ed0167$var$_interopRequireDefault($9nHZC);

var $9XBEw = parcelRequire("9XBEw");

var $jcTzs = parcelRequire("jcTzs");

var $fQz7i = parcelRequire("fQz7i");
var $e809f16197ed0167$var$_withLockSheet2 = $e809f16197ed0167$var$_interopRequireDefault($fQz7i);

var $5C3s2 = parcelRequire("5C3s2");
var $e809f16197ed0167$var$_withTouchListeners2 = $e809f16197ed0167$var$_interopRequireDefault($5C3s2);

var $1QXcg = parcelRequire("1QXcg");
function $e809f16197ed0167$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e809f16197ed0167$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e809f16197ed0167$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e809f16197ed0167$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $e809f16197ed0167$var$ScrollLock = function(_PureComponent) {
    $e809f16197ed0167$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $e809f16197ed0167$var$_classCallCheck(this, ScrollLock);
        return $e809f16197ed0167$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $e809f16197ed0167$var$_createClass(ScrollLock, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$9XBEw.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children ? $e809f16197ed0167$var$_react2.default.createElement($jcTzs.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($9nHZC.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $e809f16197ed0167$var$compose = (0, $1QXcg.pipe)($e809f16197ed0167$var$_withTouchListeners2.default, $e809f16197ed0167$var$_withLockSheet2.default);
var $e809f16197ed0167$var$SheetLock = $e809f16197ed0167$var$compose($e809f16197ed0167$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $e809f16197ed0167$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $e809f16197ed0167$var$_react2.default.createElement($e809f16197ed0167$var$SheetLock, props) : props.children;
};
$e809f16197ed0167$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
module.exports.default = $e809f16197ed0167$var$LockToggle;

});
parcelRegister("jcTzs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TouchScrollable = undefined;
var $dfba3e855b843400$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $dfba3e855b843400$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $9nHZC = parcelRequire("9nHZC");

var $9XBEw = parcelRequire("9XBEw");

var $1QXcg = parcelRequire("1QXcg");
function $dfba3e855b843400$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $dfba3e855b843400$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $dfba3e855b843400$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $dfba3e855b843400$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $dfba3e855b843400$var$TouchScrollable = module.exports.TouchScrollable = function(_PureComponent) {
    $dfba3e855b843400$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $dfba3e855b843400$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $dfba3e855b843400$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $dfba3e855b843400$var$_possibleConstructorReturn(_this, _ret);
    }
    $dfba3e855b843400$var$_createClass(TouchScrollable, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$9XBEw.canUseEventListeners) return;
                this.scrollableArea.addEventListener("touchstart", $1QXcg.preventInertiaScroll, $1QXcg.listenerOptions);
                this.scrollableArea.addEventListener("touchmove", $1QXcg.allowTouchMove, $1QXcg.listenerOptions);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!$9XBEw.canUseEventListeners) return;
                this.scrollableArea.removeEventListener("touchstart", $1QXcg.preventInertiaScroll, $1QXcg.listenerOptions);
                this.scrollableArea.removeEventListener("touchmove", $1QXcg.allowTouchMove, $1QXcg.listenerOptions);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, children = _props.children, rest = $dfba3e855b843400$var$_objectWithoutProperties(_props, [
                    "children"
                ]);
                return typeof children === "function" ? children(this.getScrollableArea) : (0, $9nHZC.cloneElement)(children, $dfba3e855b843400$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($9nHZC.PureComponent);

});
parcelRegister("1QXcg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipe = module.exports.listenerOptions = undefined;
module.exports.preventTouchMove = $1598910c832c9e8b$var$preventTouchMove;
module.exports.allowTouchMove = $1598910c832c9e8b$var$allowTouchMove;
module.exports.preventInertiaScroll = $1598910c832c9e8b$var$preventInertiaScroll;
module.exports.isTouchDevice = $1598910c832c9e8b$var$isTouchDevice;
module.exports.camelToKebab = $1598910c832c9e8b$var$camelToKebab;
module.exports.parse = $1598910c832c9e8b$var$parse;
module.exports.getPadding = $1598910c832c9e8b$var$getPadding;
module.exports.getWindowHeight = $1598910c832c9e8b$var$getWindowHeight;
module.exports.getDocumentHeight = $1598910c832c9e8b$var$getDocumentHeight;
module.exports.makeStyleTag = $1598910c832c9e8b$var$makeStyleTag;
module.exports.injectStyles = $1598910c832c9e8b$var$injectStyles;
module.exports.insertStyleTag = $1598910c832c9e8b$var$insertStyleTag;

var $9XBEw = parcelRequire("9XBEw");
var $1598910c832c9e8b$var$listenerOptions = module.exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $1598910c832c9e8b$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $1598910c832c9e8b$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $1598910c832c9e8b$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $1598910c832c9e8b$var$isTouchDevice() {
    if (!$9XBEw.canUseDOM) return false;
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $1598910c832c9e8b$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function $1598910c832c9e8b$var$parse(val) {
    return isNaN(val) ? val : val + "px";
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $1598910c832c9e8b$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $1598910c832c9e8b$var$pipe = module.exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($1598910c832c9e8b$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $1598910c832c9e8b$var$getPadding() {
    if (!$9XBEw.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $1598910c832c9e8b$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($9XBEw.canUseDOM) return window.innerHeight * multiplier;
}
function $1598910c832c9e8b$var$getDocumentHeight() {
    if ($9XBEw.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $1598910c832c9e8b$var$makeStyleTag() {
    if (!$9XBEw.canUseDOM) return;
    var tag = document.createElement("style");
    tag.type = "text/css";
    tag.setAttribute("data-react-scrolllock", "");
    return tag;
}
function $1598910c832c9e8b$var$injectStyles(tag, css) {
    if (!$9XBEw.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $1598910c832c9e8b$var$insertStyleTag(tag) {
    if (!$9XBEw.canUseDOM) return;
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}

});


parcelRegister("fQz7i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b896f3c9719e2771$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $b896f3c9719e2771$var$withLockSheet;

var $9nHZC = parcelRequire("9nHZC");
var $b896f3c9719e2771$var$_react2 = $b896f3c9719e2771$var$_interopRequireDefault($9nHZC);

var $1QXcg = parcelRequire("1QXcg");
function $b896f3c9719e2771$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b896f3c9719e2771$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b896f3c9719e2771$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $b896f3c9719e2771$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $b896f3c9719e2771$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $b896f3c9719e2771$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $b896f3c9719e2771$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $b896f3c9719e2771$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $1QXcg.makeStyleTag)();
                if (!sheet) return;
                (0, $1QXcg.injectStyles)(sheet, styles);
                (0, $1QXcg.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $1QXcg.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $1QXcg.getPadding)() : null;
                var styles = "body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        " + (height ? "height: " + height + "px !important;" : "") + "\n        " + (paddingRight ? "padding-right: " + paddingRight + "px !important;" : "") + "\n      }";
                return styles;
            }, _temp), $b896f3c9719e2771$var$_possibleConstructorReturn(_this, _ret);
        }
        $b896f3c9719e2771$var$_createClass(SheetProvider, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: "removeSheet",
                value: function removeSheet() {
                    if (!this.sheet) return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: "render",
                value: function render() {
                    return $b896f3c9719e2771$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($9nHZC.PureComponent);
}

});

parcelRegister("5C3s2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $41632db8a106d771$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $41632db8a106d771$var$withTouchListeners;

var $9nHZC = parcelRequire("9nHZC");
var $41632db8a106d771$var$_react2 = $41632db8a106d771$var$_interopRequireDefault($9nHZC);

var $9XBEw = parcelRequire("9XBEw");

var $1QXcg = parcelRequire("1QXcg");
function $41632db8a106d771$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $41632db8a106d771$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $41632db8a106d771$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $41632db8a106d771$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $41632db8a106d771$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $41632db8a106d771$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $41632db8a106d771$var$_classCallCheck(this, TouchProvider);
            return $41632db8a106d771$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $41632db8a106d771$var$_createClass(TouchProvider, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (!$9XBEw.canUseDOM || !(0, $1QXcg.isTouchDevice)()) return;
                    document.addEventListener("touchmove", $1QXcg.preventTouchMove, $1QXcg.listenerOptions);
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (!$9XBEw.canUseDOM || !(0, $1QXcg.isTouchDevice)()) return;
                    document.removeEventListener("touchmove", $1QXcg.preventTouchMove, $1QXcg.listenerOptions);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $41632db8a106d771$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($9nHZC.PureComponent);
}

});



parcelRegister("f7uPe", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $b01f6bb63972e605$export$a4687b0234b40e28; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $kpnS0 = parcelRequire("kpnS0");

var $6QZL5 = parcelRequire("6QZL5");
function $b01f6bb63972e605$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b01f6bb63972e605$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b01f6bb63972e605$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b01f6bb63972e605$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b01f6bb63972e605$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $kpnS0.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $6QZL5.useTrackedRef)(analyticsData);
    var fnRef = (0, $6QZL5.useTrackedRef)(fn);
    var handler = (0, $9nHZC.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $b01f6bb63972e605$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("kpnS0", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $edb8a88528b94415$export$5bf35293e545f20c; });

var $dNznA = parcelRequire("dNznA");

var $9CfKt = parcelRequire("9CfKt");

var $l5kWH = parcelRequire("l5kWH");
function $edb8a88528b94415$export$5bf35293e545f20c() {
    var analyticsContext = (0, $l5kWH.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $9CfKt.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("9CfKt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7003e0fe6723400f$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $dhofM = parcelRequire("dhofM");
function $7003e0fe6723400f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7003e0fe6723400f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $7003e0fe6723400f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7003e0fe6723400f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $7003e0fe6723400f$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $7003e0fe6723400f$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $7003e0fe6723400f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $7003e0fe6723400f$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $dhofM.default));

});
parcelRegister("dhofM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9aafad2174178f66$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
function $9aafad2174178f66$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9aafad2174178f66$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9aafad2174178f66$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9aafad2174178f66$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9aafad2174178f66$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $9aafad2174178f66$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $9aafad2174178f66$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $9aafad2174178f66$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(updater) === "object") this.payload = $9aafad2174178f66$var$_objectSpread($9aafad2174178f66$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("l5kWH", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $f59a4ffbf142ed7f$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $f59a4ffbf142ed7f$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});


parcelRegister("6QZL5", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $4fd78153d4341a40$export$1d27a74659855e44; });

var $9nHZC = parcelRequire("9nHZC");
var $4fd78153d4341a40$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("5OBDJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43bed1c3277c2431$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $3mVFo = parcelRequire("3mVFo");

var $8p2GL = parcelRequire("8p2GL");

var $cXPDc = parcelRequire("cXPDc");

var $lT4jp = parcelRequire("lT4jp");
function $43bed1c3277c2431$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $43bed1c3277c2431$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $43bed1c3277c2431$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $43bed1c3277c2431$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $43bed1c3277c2431$var$packageName = "@atlaskit/blanket";
var $43bed1c3277c2431$var$packageVersion = "13.3.1";
var $43bed1c3277c2431$var$analyticsAttributes = {
    componentName: "blanket",
    packageName: $43bed1c3277c2431$var$packageName,
    packageVersion: $43bed1c3277c2431$var$packageVersion
};
var $43bed1c3277c2431$var$baseStyles = (0, $avKww.css)({
    position: "fixed",
    zIndex: (0, $lT4jp.layers).blanket(),
    inset: 0,
    backgroundColor: "var(--ds-blanket, ".concat((0, $cXPDc.N100A), ")"),
    overflowY: "auto",
    pointerEvents: "initial"
});
var $43bed1c3277c2431$var$shouldAllowClickThroughStyles = (0, $avKww.css)({
    pointerEvents: "none"
});
var $43bed1c3277c2431$var$invisibleStyles = (0, $avKww.css)({
    backgroundColor: "transparent"
});
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ var $43bed1c3277c2431$var$Blanket = /*#__PURE__*/ (0, $9nHZC.memo)(/*#__PURE__*/ (0, $9nHZC.forwardRef)(function Blanket(_ref, ref) {
    var _ref$shouldAllowClick = _ref.shouldAllowClickThrough, shouldAllowClickThrough = _ref$shouldAllowClick === void 0 ? false : _ref$shouldAllowClick, _ref$isTinted = _ref.isTinted, isTinted = _ref$isTinted === void 0 ? false : _ref$isTinted, _ref$onBlanketClicked = _ref.onBlanketClicked, onBlanketClicked = _ref$onBlanketClicked === void 0 ? (0, $8p2GL.default) : _ref$onBlanketClicked, testId = _ref.testId, children = _ref.children, analyticsContext = _ref.analyticsContext;
    var mouseDownTarget = (0, $9nHZC.useRef)(null);
    var onBlanketClickedWithAnalytics = (0, $3mVFo.usePlatformLeafEventHandler)($43bed1c3277c2431$var$_objectSpread({
        fn: onBlanketClicked,
        action: "clicked",
        analyticsData: analyticsContext
    }, $43bed1c3277c2431$var$analyticsAttributes));
    var blanketClickOutsideChildren = (0, $9nHZC.useCallback)(function(e) {
        return e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined;
    }, [
        onBlanketClickedWithAnalytics
    ]);
    var onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    var onMouseDown = (0, $9nHZC.useCallback)(function(e) {
        mouseDownTarget.current = e.target;
    }, []);
    return(/**
     * It is not normally acceptable to add click and key handlers to non-interactive
     * elements as this is an accessibility anti-pattern. However, because this
     * instance is to enable light dismiss functionality instead of creating an
     * inaccessible custom element, we can add role="presentation" so that there
     * are no negative impacts to assistive technologies.
     */ (0, $avKww.jsx)("div", {
        role: "presentation",
        css: [
            $43bed1c3277c2431$var$baseStyles,
            shouldAllowClickThrough && $43bed1c3277c2431$var$shouldAllowClickThroughStyles,
            !isTinted && $43bed1c3277c2431$var$invisibleStyles
        ],
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref
    }, children));
}));
$43bed1c3277c2431$var$Blanket.displayName = "Blanket";
var $43bed1c3277c2431$export$2e2bcd8739ae039 = $43bed1c3277c2431$var$Blanket;

});
parcelRegister("3mVFo", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $27402891b84ae770$export$a4687b0234b40e28; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $qSbX4 = parcelRequire("qSbX4");

var $76Ti5 = parcelRequire("76Ti5");
function $27402891b84ae770$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $27402891b84ae770$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $27402891b84ae770$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $27402891b84ae770$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $27402891b84ae770$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $qSbX4.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $76Ti5.useTrackedRef)(analyticsData);
    var fnRef = (0, $76Ti5.useTrackedRef)(fn);
    var handler = (0, $9nHZC.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $27402891b84ae770$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("qSbX4", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $050c772dec065646$export$5bf35293e545f20c; });

var $dNznA = parcelRequire("dNznA");

var $cjIPF = parcelRequire("cjIPF");

var $5kGOJ = parcelRequire("5kGOJ");
function $050c772dec065646$export$5bf35293e545f20c() {
    var analyticsContext = (0, $5kGOJ.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $cjIPF.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("cjIPF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f7a092d260883a5$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $81Anl = parcelRequire("81Anl");
function $8f7a092d260883a5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8f7a092d260883a5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $8f7a092d260883a5$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($8f7a092d260883a5$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $8f7a092d260883a5$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $8f7a092d260883a5$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $8f7a092d260883a5$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $8f7a092d260883a5$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $81Anl.default));

});
parcelRegister("81Anl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d7aa22131398084$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
function $5d7aa22131398084$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5d7aa22131398084$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5d7aa22131398084$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5d7aa22131398084$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5d7aa22131398084$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $5d7aa22131398084$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $5d7aa22131398084$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $5d7aa22131398084$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(updater) === "object") this.payload = $5d7aa22131398084$var$_objectSpread($5d7aa22131398084$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("5kGOJ", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $3e20089a0a3013be$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $3e20089a0a3013be$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});


parcelRegister("76Ti5", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $52d3fb89047f21fc$export$1d27a74659855e44; });

var $9nHZC = parcelRequire("9nHZC");
var $52d3fb89047f21fc$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("cXPDc", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $97030b9f570cd97f$export$215b7063051591f1; });
$parcel$export(module.exports, "N20A", function () { return $97030b9f570cd97f$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $97030b9f570cd97f$export$920c0d5c49070351; });
$parcel$export(module.exports, "N100A", function () { return $97030b9f570cd97f$export$486ab785e4bac3c6; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $97030b9f570cd97f$export$4b84fd0e2c617bd = "#FFEBE6";
var $97030b9f570cd97f$export$b34b069eff244586 = "#FFBDAD";
var $97030b9f570cd97f$export$be802dd0d8b57f35 = "#FF8F73";
var $97030b9f570cd97f$export$60847d42f9da92a6 = "#FF7452";
var $97030b9f570cd97f$export$4a7404f376229999 = "#FF5630";
var $97030b9f570cd97f$export$2010d0fb4295b346 = "#DE350B";
var $97030b9f570cd97f$export$2837b5a1a71d5c02 = "#BF2600";
var $97030b9f570cd97f$export$8d9596b529bbb9cf = "#FFFAE6";
var $97030b9f570cd97f$export$41060a744ab0b7ae = "#FFF0B3";
var $97030b9f570cd97f$export$1cc05bbbf340e559 = "#FFE380";
var $97030b9f570cd97f$export$5aae31392d72caaa = "#FFC400";
var $97030b9f570cd97f$export$c6930421db9fa514 = "#FFAB00";
var $97030b9f570cd97f$export$59619663aa6500fb = "#FF991F";
var $97030b9f570cd97f$export$874739ea9e379ab6 = "#FF8B00";
var $97030b9f570cd97f$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $97030b9f570cd97f$export$69a3bf21b9686c2b = "#ABF5D1";
var $97030b9f570cd97f$export$afbce1382ec95f73 = "#79F2C0";
var $97030b9f570cd97f$export$747d86715d4175de = "#57D9A3";
var $97030b9f570cd97f$export$940e1f69e873f202 = "#36B37E";
var $97030b9f570cd97f$export$a49394138f7b8e85 = "#00875A";
var $97030b9f570cd97f$export$6fa04827ac68a4fb = "#006644";
var $97030b9f570cd97f$export$226de0355ed012f8 = "#DEEBFF";
var $97030b9f570cd97f$export$8c13c2ee36917869 = "#B3D4FF";
var $97030b9f570cd97f$export$ecfc1dff386a3e7a = "#4C9AFF";
var $97030b9f570cd97f$export$215b7063051591f1 = "#2684FF";
var $97030b9f570cd97f$export$e62e8919cca44969 = "#0065FF";
var $97030b9f570cd97f$export$b3de0ae08da2ce64 = "#0052CC";
var $97030b9f570cd97f$export$a6ee3d71bc067634 = "#0747A6";
var $97030b9f570cd97f$export$363e4475840015bb = "#EAE6FF";
var $97030b9f570cd97f$export$4b0a4417ed59760f = "#C0B6F2";
var $97030b9f570cd97f$export$6011520a64d9a187 = "#998DD9";
var $97030b9f570cd97f$export$a7175d4e9206bc80 = "#8777D9";
var $97030b9f570cd97f$export$b48405b95304b5a1 = "#6554C0";
var $97030b9f570cd97f$export$c71e4279dd54a18d = "#5243AA";
var $97030b9f570cd97f$export$147899de772240ec = "#403294";
var $97030b9f570cd97f$export$2cf711fe14c66f06 = "#E6FCFF";
var $97030b9f570cd97f$export$7a8f4d33f6f9772c = "#B3F5FF";
var $97030b9f570cd97f$export$776c9c497ef08533 = "#79E2F2";
var $97030b9f570cd97f$export$69cb3ca10c1e330e = "#00C7E6";
var $97030b9f570cd97f$export$9dc1ef0f3f48059b = "#00B8D9";
var $97030b9f570cd97f$export$7c835c78b6fcdef8 = "#00A3BF";
var $97030b9f570cd97f$export$6036577f95c3877e = "#008DA6";
var $97030b9f570cd97f$export$29a4f05edc054374 = "#FFFFFF";
var $97030b9f570cd97f$export$e655ef011c4aa1a2 = "#FAFBFC";
var $97030b9f570cd97f$export$9fdfb749e33cdf97 = "#F4F5F7";
var $97030b9f570cd97f$export$3e51e8f1440314ba = "#EBECF0";
var $97030b9f570cd97f$export$1ce2d1575d444ceb = "#DFE1E6";
var $97030b9f570cd97f$export$8754fc7e6d8b3000 = "#C1C7D0";
var $97030b9f570cd97f$export$c2e91cbeada39b8b = "#B3BAC5";
var $97030b9f570cd97f$export$5f71e19f3a7ad9de = "#A5ADBA";
var $97030b9f570cd97f$export$eaa8c8a70ac22806 = "#97A0AF";
var $97030b9f570cd97f$export$7c87d337fb91a97d = "#8993A4";
var $97030b9f570cd97f$export$d6447c357493214f = "#7A869A";
var $97030b9f570cd97f$export$f563ee71e9ee74cd = "#6B778C";
var $97030b9f570cd97f$export$e2ef2124cf4024b1 = "#5E6C84";
var $97030b9f570cd97f$export$eece5f492e429f08 = "#505F79";
var $97030b9f570cd97f$export$c39c0fe0f26207ae = "#42526E";
var $97030b9f570cd97f$export$7090862dc3038a9f = "#344563";
var $97030b9f570cd97f$export$ad0bacf983b7ddaa = "#253858";
var $97030b9f570cd97f$export$7d61b15e0da132af = "#172B4D";
var $97030b9f570cd97f$export$fbda843f0a27fe96 = "#091E42";
var $97030b9f570cd97f$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $97030b9f570cd97f$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $97030b9f570cd97f$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $97030b9f570cd97f$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $97030b9f570cd97f$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $97030b9f570cd97f$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $97030b9f570cd97f$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $97030b9f570cd97f$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $97030b9f570cd97f$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $97030b9f570cd97f$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $97030b9f570cd97f$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $97030b9f570cd97f$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $97030b9f570cd97f$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $97030b9f570cd97f$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $97030b9f570cd97f$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $97030b9f570cd97f$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $97030b9f570cd97f$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $97030b9f570cd97f$export$2f6319cf7d736c2a = "#E6EDFA";
var $97030b9f570cd97f$export$95126bc8884d6634 = "#DCE5F5";
var $97030b9f570cd97f$export$8338d8c35d44ff1 = "#CED9EB";
var $97030b9f570cd97f$export$5368d76ae4fbbda7 = "#B8C7E0";
var $97030b9f570cd97f$export$9f0a771d16ec8d36 = "#ABBBD6";
var $97030b9f570cd97f$export$abcf8c38338b4aa5 = "#9FB0CC";
var $97030b9f570cd97f$export$97e81faa16a182c7 = "#8C9CB8";
var $97030b9f570cd97f$export$bfe21c59123ecf33 = "#7988A3";
var $97030b9f570cd97f$export$ee82aa2ea6a1558 = "#67758F";
var $97030b9f570cd97f$export$682927c6ed76be02 = "#56637A";
var $97030b9f570cd97f$export$91fd9994c5be9757 = "#455166";
var $97030b9f570cd97f$export$d281fbfe3cff2df6 = "#3B475C";
var $97030b9f570cd97f$export$3902c91d8b98a753 = "#313D52";
var $97030b9f570cd97f$export$8e8133c1ba5845b5 = "#283447";
var $97030b9f570cd97f$export$33ff357f6620b39 = "#202B3D";
var $97030b9f570cd97f$export$633847cf062b69e0 = "#1B2638";
var $97030b9f570cd97f$export$9776a6e503bdbf76 = "#121A29";
var $97030b9f570cd97f$export$6c813d5160dff5db = "#0E1624";
var $97030b9f570cd97f$export$3d4f271a500072a = "#0D1424";
var $97030b9f570cd97f$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $97030b9f570cd97f$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $97030b9f570cd97f$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $97030b9f570cd97f$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $97030b9f570cd97f$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $97030b9f570cd97f$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $97030b9f570cd97f$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $97030b9f570cd97f$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $97030b9f570cd97f$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $97030b9f570cd97f$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $97030b9f570cd97f$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $97030b9f570cd97f$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $97030b9f570cd97f$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $97030b9f570cd97f$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $97030b9f570cd97f$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $97030b9f570cd97f$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $97030b9f570cd97f$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";

});

parcelRegister("lT4jp", function(module, exports) {

$parcel$export(module.exports, "layers", function () { return $fef21451346e04eb$export$7be255094ccdc533; });

var $1OnrY = parcelRequire("1OnrY");

var $cXPDc = parcelRequire("cXPDc");
var $fef21451346e04eb$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $fef21451346e04eb$export$c93026a968943f95 = "light";
var $fef21451346e04eb$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $fef21451346e04eb$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $fef21451346e04eb$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $fef21451346e04eb$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $fef21451346e04eb$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $fef21451346e04eb$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $fef21451346e04eb$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $fef21451346e04eb$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $cXPDc.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $fef21451346e04eb$export$6d8204c2cb2e06b8() / 4;
    (0, $1OnrY.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $fef21451346e04eb$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $fef21451346e04eb$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $fef21451346e04eb$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $1OnrY.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $fef21451346e04eb$export$ba1d834b86d72a09 = $fef21451346e04eb$export$a1b3edb637fb4f35;
var $fef21451346e04eb$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $cXPDc.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $cXPDc.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $cXPDc.N30A), ")")
            }
        }
    };
};

});


parcelRegister("kEiiy", function(module, exports) {

$parcel$export(module.exports, "LevelContext", function () { return $f085bcb9d977a584$export$650d12d3c2ddb8fc; });
$parcel$export(module.exports, "TopLevelContext", function () { return $f085bcb9d977a584$export$48b383b280e20440; });
$parcel$export(module.exports, "UNSAFE_LAYERING", function () { return $f085bcb9d977a584$export$a183686c3f6f4ea8; });

var $9nHZC = parcelRequire("9nHZC");

var $8p2GL = parcelRequire("8p2GL");
var $f085bcb9d977a584$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $9nHZC.createContext)(0);
var $f085bcb9d977a584$export$48b383b280e20440 = /*#__PURE__*/ (0, $9nHZC.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $8p2GL.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $f085bcb9d977a584$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $9nHZC.useContext)($f085bcb9d977a584$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel;
    setTopLevel(currentLevel);
    (0, $9nHZC.useEffect)(function() {
        // avoid immediate cleanup using setTimeout when component unmount
        // this will make sure non-top layer components can get the correct top level value
        // when multiple layers trigger onClose in sequence.
        // From React 17, the useEffect cleanup functions are delayed till the commit phase is completed. In other words, the useEffect cleanup functions run asynchronously - for example, if the component is unmounting, the cleanup runs after the screen has been updated.
        // TODO revisit after we migrate to react 18. https://product-fabric.atlassian.net/browse/DSP-13139
        return function() {
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($f085bcb9d977a584$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $f085bcb9d977a584$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $9nHZC.useRef)(0);
    var value = (0, $9nHZC.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($f085bcb9d977a584$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $f085bcb9d977a584$export$a183686c3f6f4ea8 = function UNSAFE_LAYERING(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $9nHZC.useContext)($f085bcb9d977a584$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($f085bcb9d977a584$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($f085bcb9d977a584$var$LayeringProvider, null, content);
};

});

parcelRegister("gWA00", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c55dfccee4b312a3$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $6ZCxy = parcelRequire("6ZCxy");

var $htChF = parcelRequire("htChF");

var $lq4He = parcelRequire("lq4He");
function $c55dfccee4b312a3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c55dfccee4b312a3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c55dfccee4b312a3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c55dfccee4b312a3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c55dfccee4b312a3$var$directionMotions = {
    proportional: {
        bottom: "translate3d(0, calc(5% + 4px), 0)",
        left: "translate3d(calc(-5% - 4px), 0, 0)",
        right: "translate3d(calc(5% + 4px), 0, 0)",
        top: "translate3d(0, calc(-5% - 4px), 0)"
    },
    constant: {
        bottom: "translate3d(0, 4px, 0)",
        left: "translate3d(-4px, 0, 0)",
        right: "translate3d(4px, 0, 0)",
        top: "translate3d(0, -4px, 0)"
    }
};
var $c55dfccee4b312a3$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
var $c55dfccee4b312a3$export$8497679fcaaeceb = function fadeInAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: $c55dfccee4b312a3$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $c55dfccee4b312a3$var$directionMotions[distance][direction]
        }),
        "50%": {
            opacity: 1
        },
        to: {
            transform: direction !== undefined ? "none" : undefined
        }
    };
};
var $c55dfccee4b312a3$export$c9190c6659ea755b = function fadeOutAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: {
            opacity: 1,
            transform: direction !== undefined ? "translate3d(0, 0, 0)" : undefined
        },
        to: $c55dfccee4b312a3$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $c55dfccee4b312a3$var$directionMotions[distance][direction]
        })
    };
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $c55dfccee4b312a3$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $htChF.largeDurationMs) : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? "proportional" : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection && $c55dfccee4b312a3$var$invertedDirection[entranceDirection];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $lq4He.default), {
        duration: duration,
        enteringAnimation: $c55dfccee4b312a3$export$8497679fcaaeceb(entranceDirection, distance),
        exitingAnimation: $c55dfccee4b312a3$export$c9190c6659ea755b(exitDirection || invertedEntranceDirection, distance),
        animationTimingFunction: function animationTimingFunction() {
            return 0, $6ZCxy.easeInOut;
        },
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $c55dfccee4b312a3$export$2e2bcd8739ae039 = $c55dfccee4b312a3$var$FadeIn;

});
parcelRegister("6ZCxy", function(module, exports) {

$parcel$export(module.exports, "easeInOut", function () { return $517655d8d63f72f6$export$c07234257a03d5e9; });
$parcel$export(module.exports, "easeOut", function () { return $517655d8d63f72f6$export$57636bb43b1ccbb0; });
$parcel$export(module.exports, "easeIn", function () { return $517655d8d63f72f6$export$929e5a82286172a6; });
var $517655d8d63f72f6$export$c07234257a03d5e9 = "cubic-bezier(0.15,1,0.3,1)";
var $517655d8d63f72f6$export$57636bb43b1ccbb0 = "cubic-bezier(0.2,0,0,1)";
var $517655d8d63f72f6$export$929e5a82286172a6 = "cubic-bezier(0.8,0,0,0.8)";

});

parcelRegister("htChF", function(module, exports) {

$parcel$export(module.exports, "smallDurationMs", function () { return $cb92d77fc0170596$export$2023a81c8547415f; });
$parcel$export(module.exports, "mediumDurationMs", function () { return $cb92d77fc0170596$export$6fa259be09e118a7; });
$parcel$export(module.exports, "largeDurationMs", function () { return $cb92d77fc0170596$export$9424640c29bc466d; });
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $cb92d77fc0170596$export$368bacef0dacbe05 = 25;
var $cb92d77fc0170596$export$2023a81c8547415f = $cb92d77fc0170596$export$368bacef0dacbe05 * 4;
var $cb92d77fc0170596$export$6fa259be09e118a7 = $cb92d77fc0170596$export$368bacef0dacbe05 * 14;
var $cb92d77fc0170596$export$9424640c29bc466d = $cb92d77fc0170596$export$368bacef0dacbe05 * 28;

});

parcelRegister("lq4He", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f97fab48193ff8ec$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $71IJO = parcelRequire("71IJO");

var $htChF = parcelRequire("htChF");

var $3n30m = parcelRequire("3n30m");

var $JcvLo = parcelRequire("JcvLo");

var $jNlSG = parcelRequire("jNlSG");
function $f97fab48193ff8ec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f97fab48193ff8ec$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f97fab48193ff8ec$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f97fab48193ff8ec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * Used to multiply the initial duration for exiting motions.
 */ var $f97fab48193ff8ec$var$EXITING_MOTION_MULTIPLIER = 0.5;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $f97fab48193ff8ec$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, enteringAnimation = _ref.enteringAnimation, exitingAnimation = _ref.exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $htChF.largeDurationMs) : _ref$duration;
    var staggered = (0, $jNlSG.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $JcvLo.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $3n30m.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? "exiting" : "entering";
    var _useState = (0, $9nHZC.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $9nHZC.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        setTimeout(function() {
            if (state === "exiting") onExitFinished && onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion && onFinishMotion(state);
        }, isExiting ? duration * $f97fab48193ff8ec$var$EXITING_MOTION_MULTIPLIER : duration + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $avKww.ClassNames), null, function(_ref2) {
        var css = _ref2.css;
        return children({
            ref: staggered.ref,
            className: hasAnimationStyles ? css($f97fab48193ff8ec$var$_objectSpread($f97fab48193ff8ec$var$_objectSpread({}, (0, $71IJO.reduceMotionAsPerUserPreference)), {}, {
                animationDelay: "".concat(delay, "ms"),
                animationDuration: "".concat(isExiting ? duration * $f97fab48193ff8ec$var$EXITING_MOTION_MULTIPLIER : duration, "ms"),
                animationFillMode: isExiting ? "forwards" : "backwards",
                animationName: "".concat((0, $avKww.keyframes)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                isExiting ? exitingAnimation || enteringAnimation : enteringAnimation)),
                animationPlayState: paused ? "paused" : "running",
                animationTimingFunction: animationTimingFunction(state)
            })) : ""
        }, state);
    });
};
var $f97fab48193ff8ec$export$2e2bcd8739ae039 = $f97fab48193ff8ec$var$EnteringMotion;

});
parcelRegister("71IJO", function(module, exports) {

$parcel$export(module.exports, "isReducedMotion", function () { return $51db54709d2ef635$export$b7baf7667a68d87c; });
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", function () { return $51db54709d2ef635$export$f0f789643ba5a83c; });
$parcel$export(module.exports, "prefersReducedMotion", function () { return $51db54709d2ef635$export$ff7706047246b98b; });

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $1FiMp = parcelRequire("1FiMp");
var $51db54709d2ef635$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $51db54709d2ef635$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$51db54709d2ef635$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $51db54709d2ef635$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $9nHZC.useState)($51db54709d2ef635$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $9nHZC.useEffect)(function() {
        if (!$51db54709d2ef635$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $1FiMp.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $51db54709d2ef635$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $51db54709d2ef635$export$ff7706047246b98b = function prefersReducedMotion() {
    return $51db54709d2ef635$export$f0f789643ba5a83c;
};

});
parcelRegister("1FiMp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $8MqEu = parcelRequire("8MqEu");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $8MqEu.bind;
    }
});

var $gy3ak = parcelRequire("gy3ak");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $gy3ak.bindAll;
    }
});

});
parcelRegister("8MqEu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $66477afc548b547d$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $66477afc548b547d$var$bind;

});

parcelRegister("gy3ak", function(module, exports) {
"use strict";
var $c0c246edb18a1572$var$__assign = module.exports && module.exports.__assign || function() {
    $c0c246edb18a1572$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c0c246edb18a1572$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $8MqEu = parcelRequire("8MqEu");
function $c0c246edb18a1572$var$toOptions(value) {
    if (typeof value === "undefined") return undefined;
    if (typeof value === "boolean") return {
        capture: value
    };
    return value;
}
function $c0c246edb18a1572$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $c0c246edb18a1572$var$__assign($c0c246edb18a1572$var$__assign({}, original), {
        options: $c0c246edb18a1572$var$__assign($c0c246edb18a1572$var$__assign({}, $c0c246edb18a1572$var$toOptions(sharedOptions)), $c0c246edb18a1572$var$toOptions(original.options))
    });
    return binding;
}
function $c0c246edb18a1572$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $c0c246edb18a1572$var$getBinding(original, sharedOptions);
        return (0, $8MqEu.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $c0c246edb18a1572$var$bindAll;

});



parcelRegister("3n30m", function(module, exports) {

$parcel$export(module.exports, "useRequestAnimationFrame", function () { return $2745d9c197d13e21$export$1775f27e7c8051ca; });
$parcel$export(module.exports, "useSetTimeout", function () { return $2745d9c197d13e21$export$4f34107a2b00f39c; });

var $9nHZC = parcelRequire("9nHZC");
var $2745d9c197d13e21$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $2745d9c197d13e21$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $9nHZC.useRef)([]);
    (0, $9nHZC.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $2745d9c197d13e21$var$getHookDeps(opts));
    return (0, $9nHZC.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $2745d9c197d13e21$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $9nHZC.useRef)([]);
    (0, $9nHZC.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $2745d9c197d13e21$var$getHookDeps(opts));
    return (0, $9nHZC.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("JcvLo", function(module, exports) {

$parcel$export(module.exports, "useExitingPersistence", function () { return $087de891e1157ed2$export$3b6f38abbdcbd000; });
$parcel$export(module.exports, "default", function () { return $087de891e1157ed2$export$2e2bcd8739ae039; });

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $71IJO = parcelRequire("71IJO");
var $087de891e1157ed2$export$d1e013d71d2e2121 = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
var $087de891e1157ed2$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $9nHZC.createContext)($087de891e1157ed2$export$d1e013d71d2e2121);
var $087de891e1157ed2$export$e4c4c45693c3a7c = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $087de891e1157ed2$export$d1e013d71d2e2121;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($087de891e1157ed2$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
var $087de891e1157ed2$export$7032ae6d9d98bedd = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $9nHZC.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $087de891e1157ed2$export$2ccbe4ff092af328 = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $087de891e1157ed2$export$1d8c49f95a162a41(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $087de891e1157ed2$export$1d8c49f95a162a41 = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $087de891e1157ed2$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $087de891e1157ed2$var$ExitingPersistence = /*#__PURE__*/ (0, $9nHZC.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $9nHZC.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $9nHZC.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $9nHZC.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $9nHZC.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $71IJO.isReducedMotion)()) return children;
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === "boolean") return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $087de891e1157ed2$export$7032ae6d9d98bedd(previousChildren);
    var current = $087de891e1157ed2$export$7032ae6d9d98bedd(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $087de891e1157ed2$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $087de891e1157ed2$export$2ccbe4ff092af328(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $087de891e1157ed2$export$e4c4c45693c3a7c(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $087de891e1157ed2$export$e4c4c45693c3a7c(child, defaultContext);
    });
    return visibleChildren;
});
var $087de891e1157ed2$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $9nHZC.useContext)($087de891e1157ed2$export$b9c4904d7a6929e6);
};
$087de891e1157ed2$var$ExitingPersistence.displayName = "ExitingPersistence";
var $087de891e1157ed2$export$2e2bcd8739ae039 = $087de891e1157ed2$var$ExitingPersistence;

});

parcelRegister("jNlSG", function(module, exports) {

$parcel$export(module.exports, "useStaggeredEntrance", function () { return $e693910c6fbb0628$export$25c7213fc07ec080; });

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $8p2GL = parcelRequire("8p2GL");

var $54NMw = parcelRequire("54NMw");

var $eVoqq = parcelRequire("eVoqq");
var $e693910c6fbb0628$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $9nHZC.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $8p2GL.default)
    };
});
var $e693910c6fbb0628$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $eVoqq.useUniqueId)();
    var context = (0, $9nHZC.useContext)($e693910c6fbb0628$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $e693910c6fbb0628$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? "responsive" : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $9nHZC.useRef)([]);
    var indexes = [];
    var _useState = (0, $9nHZC.useState)(function() {
        if (typeof columns === "number") // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === "number") // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $54NMw.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === "responsive" && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($e693910c6fbb0628$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $e693910c6fbb0628$export$2e2bcd8739ae039 = $e693910c6fbb0628$var$StaggeredEntrance;

});
parcelRegister("54NMw", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", function () { return $3b23f115022b2d83$export$e5c5a5f917a5871c; });

var $9nHZC = parcelRequire("9nHZC");
var $3b23f115022b2d83$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $9nHZC.useEffect) : (0, $9nHZC.useLayoutEffect);

});

parcelRegister("eVoqq", function(module, exports) {

$parcel$export(module.exports, "useUniqueId", function () { return $add955ea9ab1152e$export$c485849f2e393253; });
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $9nHZC = parcelRequire("9nHZC");
function $add955ea9ab1152e$export$c485849f2e393253() {
    var identifier = (0, $9nHZC.useRef)("");
    if (!identifier.current) identifier.current = "_" + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("0pN5N", function(module, exports) {

$parcel$export(module.exports, "borderRadius", function () { return $001401b85c2fb9b8$export$7a57f79000377ca2; });
$parcel$export(module.exports, "gridSize", function () { return $001401b85c2fb9b8$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "layers", function () { return $001401b85c2fb9b8$export$7be255094ccdc533; });

var $1OnrY = parcelRequire("1OnrY");

var $krL2H = parcelRequire("krL2H");
var $001401b85c2fb9b8$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $001401b85c2fb9b8$export$c93026a968943f95 = "light";
var $001401b85c2fb9b8$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $001401b85c2fb9b8$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $001401b85c2fb9b8$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $001401b85c2fb9b8$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $001401b85c2fb9b8$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $001401b85c2fb9b8$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $001401b85c2fb9b8$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $001401b85c2fb9b8$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $krL2H.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $001401b85c2fb9b8$export$6d8204c2cb2e06b8() / 4;
    (0, $1OnrY.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $001401b85c2fb9b8$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $001401b85c2fb9b8$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $001401b85c2fb9b8$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $1OnrY.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $001401b85c2fb9b8$export$ba1d834b86d72a09 = $001401b85c2fb9b8$export$a1b3edb637fb4f35;
var $001401b85c2fb9b8$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $krL2H.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $krL2H.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $krL2H.N30A), ")")
            }
        }
    };
};

});
parcelRegister("krL2H", function(module, exports) {

$parcel$export(module.exports, "R400", function () { return $ee2ad1f2509812e8$export$2010d0fb4295b346; });
$parcel$export(module.exports, "B200", function () { return $ee2ad1f2509812e8$export$215b7063051591f1; });
$parcel$export(module.exports, "N0", function () { return $ee2ad1f2509812e8$export$29a4f05edc054374; });
$parcel$export(module.exports, "N30", function () { return $ee2ad1f2509812e8$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N900", function () { return $ee2ad1f2509812e8$export$fbda843f0a27fe96; });
$parcel$export(module.exports, "N20A", function () { return $ee2ad1f2509812e8$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $ee2ad1f2509812e8$export$920c0d5c49070351; });
$parcel$export(module.exports, "N60A", function () { return $ee2ad1f2509812e8$export$d2d3bedfb276cac0; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $ee2ad1f2509812e8$export$4b84fd0e2c617bd = "#FFEBE6";
var $ee2ad1f2509812e8$export$b34b069eff244586 = "#FFBDAD";
var $ee2ad1f2509812e8$export$be802dd0d8b57f35 = "#FF8F73";
var $ee2ad1f2509812e8$export$60847d42f9da92a6 = "#FF7452";
var $ee2ad1f2509812e8$export$4a7404f376229999 = "#FF5630";
var $ee2ad1f2509812e8$export$2010d0fb4295b346 = "#DE350B";
var $ee2ad1f2509812e8$export$2837b5a1a71d5c02 = "#BF2600";
var $ee2ad1f2509812e8$export$8d9596b529bbb9cf = "#FFFAE6";
var $ee2ad1f2509812e8$export$41060a744ab0b7ae = "#FFF0B3";
var $ee2ad1f2509812e8$export$1cc05bbbf340e559 = "#FFE380";
var $ee2ad1f2509812e8$export$5aae31392d72caaa = "#FFC400";
var $ee2ad1f2509812e8$export$c6930421db9fa514 = "#FFAB00";
var $ee2ad1f2509812e8$export$59619663aa6500fb = "#FF991F";
var $ee2ad1f2509812e8$export$874739ea9e379ab6 = "#FF8B00";
var $ee2ad1f2509812e8$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $ee2ad1f2509812e8$export$69a3bf21b9686c2b = "#ABF5D1";
var $ee2ad1f2509812e8$export$afbce1382ec95f73 = "#79F2C0";
var $ee2ad1f2509812e8$export$747d86715d4175de = "#57D9A3";
var $ee2ad1f2509812e8$export$940e1f69e873f202 = "#36B37E";
var $ee2ad1f2509812e8$export$a49394138f7b8e85 = "#00875A";
var $ee2ad1f2509812e8$export$6fa04827ac68a4fb = "#006644";
var $ee2ad1f2509812e8$export$226de0355ed012f8 = "#DEEBFF";
var $ee2ad1f2509812e8$export$8c13c2ee36917869 = "#B3D4FF";
var $ee2ad1f2509812e8$export$ecfc1dff386a3e7a = "#4C9AFF";
var $ee2ad1f2509812e8$export$215b7063051591f1 = "#2684FF";
var $ee2ad1f2509812e8$export$e62e8919cca44969 = "#0065FF";
var $ee2ad1f2509812e8$export$b3de0ae08da2ce64 = "#0052CC";
var $ee2ad1f2509812e8$export$a6ee3d71bc067634 = "#0747A6";
var $ee2ad1f2509812e8$export$363e4475840015bb = "#EAE6FF";
var $ee2ad1f2509812e8$export$4b0a4417ed59760f = "#C0B6F2";
var $ee2ad1f2509812e8$export$6011520a64d9a187 = "#998DD9";
var $ee2ad1f2509812e8$export$a7175d4e9206bc80 = "#8777D9";
var $ee2ad1f2509812e8$export$b48405b95304b5a1 = "#6554C0";
var $ee2ad1f2509812e8$export$c71e4279dd54a18d = "#5243AA";
var $ee2ad1f2509812e8$export$147899de772240ec = "#403294";
var $ee2ad1f2509812e8$export$2cf711fe14c66f06 = "#E6FCFF";
var $ee2ad1f2509812e8$export$7a8f4d33f6f9772c = "#B3F5FF";
var $ee2ad1f2509812e8$export$776c9c497ef08533 = "#79E2F2";
var $ee2ad1f2509812e8$export$69cb3ca10c1e330e = "#00C7E6";
var $ee2ad1f2509812e8$export$9dc1ef0f3f48059b = "#00B8D9";
var $ee2ad1f2509812e8$export$7c835c78b6fcdef8 = "#00A3BF";
var $ee2ad1f2509812e8$export$6036577f95c3877e = "#008DA6";
var $ee2ad1f2509812e8$export$29a4f05edc054374 = "#FFFFFF";
var $ee2ad1f2509812e8$export$e655ef011c4aa1a2 = "#FAFBFC";
var $ee2ad1f2509812e8$export$9fdfb749e33cdf97 = "#F4F5F7";
var $ee2ad1f2509812e8$export$3e51e8f1440314ba = "#EBECF0";
var $ee2ad1f2509812e8$export$1ce2d1575d444ceb = "#DFE1E6";
var $ee2ad1f2509812e8$export$8754fc7e6d8b3000 = "#C1C7D0";
var $ee2ad1f2509812e8$export$c2e91cbeada39b8b = "#B3BAC5";
var $ee2ad1f2509812e8$export$5f71e19f3a7ad9de = "#A5ADBA";
var $ee2ad1f2509812e8$export$eaa8c8a70ac22806 = "#97A0AF";
var $ee2ad1f2509812e8$export$7c87d337fb91a97d = "#8993A4";
var $ee2ad1f2509812e8$export$d6447c357493214f = "#7A869A";
var $ee2ad1f2509812e8$export$f563ee71e9ee74cd = "#6B778C";
var $ee2ad1f2509812e8$export$e2ef2124cf4024b1 = "#5E6C84";
var $ee2ad1f2509812e8$export$eece5f492e429f08 = "#505F79";
var $ee2ad1f2509812e8$export$c39c0fe0f26207ae = "#42526E";
var $ee2ad1f2509812e8$export$7090862dc3038a9f = "#344563";
var $ee2ad1f2509812e8$export$ad0bacf983b7ddaa = "#253858";
var $ee2ad1f2509812e8$export$7d61b15e0da132af = "#172B4D";
var $ee2ad1f2509812e8$export$fbda843f0a27fe96 = "#091E42";
var $ee2ad1f2509812e8$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $ee2ad1f2509812e8$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $ee2ad1f2509812e8$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $ee2ad1f2509812e8$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $ee2ad1f2509812e8$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $ee2ad1f2509812e8$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $ee2ad1f2509812e8$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $ee2ad1f2509812e8$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $ee2ad1f2509812e8$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $ee2ad1f2509812e8$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $ee2ad1f2509812e8$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $ee2ad1f2509812e8$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $ee2ad1f2509812e8$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $ee2ad1f2509812e8$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $ee2ad1f2509812e8$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $ee2ad1f2509812e8$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $ee2ad1f2509812e8$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $ee2ad1f2509812e8$export$2f6319cf7d736c2a = "#E6EDFA";
var $ee2ad1f2509812e8$export$95126bc8884d6634 = "#DCE5F5";
var $ee2ad1f2509812e8$export$8338d8c35d44ff1 = "#CED9EB";
var $ee2ad1f2509812e8$export$5368d76ae4fbbda7 = "#B8C7E0";
var $ee2ad1f2509812e8$export$9f0a771d16ec8d36 = "#ABBBD6";
var $ee2ad1f2509812e8$export$abcf8c38338b4aa5 = "#9FB0CC";
var $ee2ad1f2509812e8$export$97e81faa16a182c7 = "#8C9CB8";
var $ee2ad1f2509812e8$export$bfe21c59123ecf33 = "#7988A3";
var $ee2ad1f2509812e8$export$ee82aa2ea6a1558 = "#67758F";
var $ee2ad1f2509812e8$export$682927c6ed76be02 = "#56637A";
var $ee2ad1f2509812e8$export$91fd9994c5be9757 = "#455166";
var $ee2ad1f2509812e8$export$d281fbfe3cff2df6 = "#3B475C";
var $ee2ad1f2509812e8$export$3902c91d8b98a753 = "#313D52";
var $ee2ad1f2509812e8$export$8e8133c1ba5845b5 = "#283447";
var $ee2ad1f2509812e8$export$33ff357f6620b39 = "#202B3D";
var $ee2ad1f2509812e8$export$633847cf062b69e0 = "#1B2638";
var $ee2ad1f2509812e8$export$9776a6e503bdbf76 = "#121A29";
var $ee2ad1f2509812e8$export$6c813d5160dff5db = "#0E1624";
var $ee2ad1f2509812e8$export$3d4f271a500072a = "#0D1424";
var $ee2ad1f2509812e8$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $ee2ad1f2509812e8$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $ee2ad1f2509812e8$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $ee2ad1f2509812e8$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $ee2ad1f2509812e8$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $ee2ad1f2509812e8$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $ee2ad1f2509812e8$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $ee2ad1f2509812e8$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $ee2ad1f2509812e8$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $ee2ad1f2509812e8$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $ee2ad1f2509812e8$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $ee2ad1f2509812e8$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $ee2ad1f2509812e8$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $ee2ad1f2509812e8$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $ee2ad1f2509812e8$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $ee2ad1f2509812e8$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $ee2ad1f2509812e8$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";

});


parcelRegister("04547", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00c44db97160d813$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9q1kH = parcelRequire("9q1kH");

var $340K4 = parcelRequire("340K4");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $3aF04 = parcelRequire("3aF04");

var $12bLr = parcelRequire("12bLr");

var $grYZC = parcelRequire("grYZC");

var $dxhCu = parcelRequire("dxhCu");

var $3ybDD = parcelRequire("3ybDD");

var $gWA00 = parcelRequire("gWA00");

var $d8Om8 = parcelRequire("d8Om8");

var $fuyx6 = parcelRequire("fuyx6");

var $krL2H = parcelRequire("krL2H");

var $xbX1J = parcelRequire("xbX1J");

var $5sqB4 = parcelRequire("5sqB4");

var $jDlhj = parcelRequire("jDlhj");

var $chtuu = parcelRequire("chtuu");

var $1eMkV = parcelRequire("1eMkV");

var $8Vjue = parcelRequire("8Vjue");
var $00c44db97160d813$var$_css;
// reset pointer-events on iframe inside modal
var $00c44db97160d813$var$resetPointerEventsOnIframeStyles = (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "iframe:is([aria-modal] iframe)": {
        pointerEvents: "auto"
    }
});
var $00c44db97160d813$var$dialogStyles = (0, $avKww.css)(($00c44db97160d813$var$_css = {
    display: "flex",
    width: "100%",
    maxWidth: "100vw",
    height: "100%",
    minHeight: 0,
    maxHeight: "100vh",
    // Flex-grow set to 0 to prevent this element from filling its parent flexbox container
    flex: "0 1 auto",
    flexDirection: "column",
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $krL2H.N0), ")"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $5sqB4.textColor)
}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($00c44db97160d813$var$_css, (0, $xbX1J.CURRENT_SURFACE_CSS_VAR), "var(--ds-surface-overlay, ".concat((0, $krL2H.N0), ")")), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($00c44db97160d813$var$_css, "pointerEvents", "auto"), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($00c44db97160d813$var$_css, (0, $fuyx6.media).above.xs, {
    width: "var(--modal-dialog-width)",
    maxWidth: "inherit",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: (0, $5sqB4.borderRadius),
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 0 0 1px ".concat((0, $krL2H.N30A), ", 0 2px 1px ").concat((0, $krL2H.N30A), ", 0 0 20px -6px ").concat((0, $krL2H.N60A)), ")"),
    marginInlineEnd: "inherit",
    marginInlineStart: "inherit"
}), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($00c44db97160d813$var$_css, "& > form:only-child", {
    display: "inherit",
    maxHeight: "inherit",
    flexDirection: "inherit"
}), $00c44db97160d813$var$_css));
var $00c44db97160d813$var$viewportScrollStyles = (0, $avKww.css)((0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({
    /**
   * This ensures that the element fills the viewport on mobile
   * while also allowing it to overflow if its height is larger than
   * the viewport.
   */ minHeight: "100vh",
    maxHeight: "none"
}, (0, $fuyx6.media).above.xs, {
    minHeight: "var(--modal-dialog-height)"
}));
var $00c44db97160d813$var$bodyScrollStyles = (0, $avKww.css)((0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, (0, $fuyx6.media).above.xs, {
    height: "var(--modal-dialog-height)",
    maxHeight: "inherit"
}));
var $00c44db97160d813$var$ModalDialog = function ModalDialog(props) {
    var _props$width = props.width, width = _props$width === void 0 ? "medium" : _props$width, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, shouldCloseOnEscapePress = props.shouldCloseOnEscapePress, autoFocus = props.autoFocus, stackIndex = props.stackIndex, onClose = props.onClose, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, height = props.height, children = props.children, label = props.label, testId = props.testId;
    var id = (0, $12bLr.useId)();
    var titleId = "modal-dialog-title-".concat(id);
    (0, $grYZC.default)((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(autoFocus) === "object" ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(autoFocus) === "object");
    var _useOnMotionFinish = (0, $chtuu.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    }), _useOnMotionFinish2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useOnMotionFinish, 2), motionRef = _useOnMotionFinish2[0], onMotionFinish = _useOnMotionFinish2[1];
    var modalDialogContext = (0, $9nHZC.useMemo)(function() {
        return {
            testId: testId,
            titleId: titleId,
            onClose: onClose
        };
    }, [
        testId,
        titleId,
        onClose
    ]);
    (0, $3ybDD.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    return (0, $avKww.jsx)((0, $8Vjue.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: testId
    }, (0, $avKww.jsx)((0, $jDlhj.ModalContext).Provider, {
        value: modalDialogContext
    }, (0, $avKww.jsx)((0, $jDlhj.ScrollContext).Provider, {
        value: shouldScrollInViewport
    }, (0, $avKww.jsx)((0, $gWA00.default), {
        entranceDirection: "bottom",
        onFinish: onMotionFinish
    }, function(bottomFadeInProps) {
        return (0, $avKww.jsx)((0, $dxhCu.default), null, (0, $avKww.jsx)("section", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, bottomFadeInProps, {
            "aria-label": label,
            ref: (0, $3aF04.default)([
                bottomFadeInProps.ref,
                motionRef
            ]),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                "--modal-dialog-width": (0, $1eMkV.dialogWidth)(width),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                "--modal-dialog-height": (0, $1eMkV.dialogHeight)(height)
            },
            css: [
                $00c44db97160d813$var$dialogStyles,
                shouldScrollInViewport ? $00c44db97160d813$var$viewportScrollStyles : $00c44db97160d813$var$bodyScrollStyles
            ],
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": testId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true
        }), children, (0, $d8Om8.fg)("platform.design-system-team.iframe_gojiv") && (0, $avKww.jsx)((0, $avKww.Global), {
            styles: $00c44db97160d813$var$resetPointerEventsOnIframeStyles
        })));
    }))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$00c44db97160d813$export$2e2bcd8739ae039 = $00c44db97160d813$var$ModalDialog;

});
parcelRegister("3aF04", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24f21c05448bd5b0$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $24f21c05448bd5b0$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("12bLr", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $0c0f1a77378e551c$export$f680877a34711e37; });

var $9nHZC = parcelRequire("9nHZC");

var $9SZaS = parcelRequire("9SZaS");

var $8wqil = parcelRequire("8wqil");
var $0c0f1a77378e551c$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $0c0f1a77378e551c$var$react18UseId = ($0c0f1a77378e551c$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).useId) !== null && $0c0f1a77378e551c$var$_React$useId !== void 0 ? $0c0f1a77378e551c$var$_React$useId : undefined;
function $0c0f1a77378e551c$export$f680877a34711e37() {
    if ($0c0f1a77378e551c$var$react18UseId && (0, $8wqil.fg)("platform.design-system-team.react-18-use-id_mn8q4")) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $0c0f1a77378e551c$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $9SZaS.useUID)();
}
function $0c0f1a77378e551c$export$6ee17796e3d70de2() {
    if ($0c0f1a77378e551c$var$react18UseId && (0, $8wqil.fg)("platform.design-system-team.react-18-use-id_mn8q4")) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $0c0f1a77378e551c$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $9SZaS.useUIDSeed)();
}

});
parcelRegister("9SZaS", function(module, exports) {

$parcel$export(module.exports, "useUID", function () { return $73289c26efeb4e39$export$87d05f07e65211f1; });
$parcel$export(module.exports, "useUIDSeed", function () { return $73289c26efeb4e39$export$bb5ca5fba6fb4f1f; });

var $9nHZC = parcelRequire("9nHZC");

var $fjc5y = parcelRequire("fjc5y");
var $73289c26efeb4e39$var$generateUID = function(context) {
    var quartz = context || (0, $fjc5y.counter);
    var prefix = (0, $fjc5y.getPrefix)(quartz);
    var id = (0, $fjc5y.getId)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $73289c26efeb4e39$var$useUIDState = function() {
    // @ts-ignore
    return $9nHZC.useState($73289c26efeb4e39$var$generateUID($9nHZC.useContext((0, $fjc5y.source))));
};
var $73289c26efeb4e39$export$87d05f07e65211f1 = function() {
    var uid = $73289c26efeb4e39$var$useUIDState()[0].uid;
    return uid;
};
var $73289c26efeb4e39$export$bb5ca5fba6fb4f1f = function() {
    var gen = $73289c26efeb4e39$var$useUIDState()[0].gen;
    return gen;
};

});
parcelRegister("fjc5y", function(module, exports) {

$parcel$export(module.exports, "counter", function () { return $b25201eb57f24a83$export$e575061ef2a070eb; });
$parcel$export(module.exports, "source", function () { return $b25201eb57f24a83$export$b4d5da5f34fb77ad; });
$parcel$export(module.exports, "getId", function () { return $b25201eb57f24a83$export$218c8c3169c024d2; });
$parcel$export(module.exports, "getPrefix", function () { return $b25201eb57f24a83$export$36e24695f02d4503; });

var $9nHZC = parcelRequire("9nHZC");

var $4ul5V = parcelRequire("4ul5V");
var $b25201eb57f24a83$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = "";
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $4ul5V.generateUID)()
    };
};
var $b25201eb57f24a83$export$e575061ef2a070eb = $b25201eb57f24a83$export$1921362e86c73c88();
var $b25201eb57f24a83$export$b4d5da5f34fb77ad = $9nHZC.createContext($b25201eb57f24a83$export$1921362e86c73c88());
var $b25201eb57f24a83$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $b25201eb57f24a83$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : "";
};

});
parcelRegister("4ul5V", function(module, exports) {

$parcel$export(module.exports, "generateUID", function () { return $344a53b220019200$export$bdbb4cbb3078e58d; });
$parcel$export(module.exports, "uid", function () { return $344a53b220019200$export$e2a22331486dcca0; });
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $344a53b220019200$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === "number" || typeof item === "string") return index ? "idx-" + index : "val-" + item;
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return "uid" + map.get(item);
    };
    return uid;
};
var $344a53b220019200$export$e2a22331486dcca0 = $344a53b220019200$export$bdbb4cbb3078e58d();

});



parcelRegister("8wqil", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $6345b57baabfd8d3$export$b40ec24ac8275656; });

var $4Rbq2 = parcelRequire("4Rbq2");
function $6345b57baabfd8d3$export$ba05d765b8392e5e(flagResolver) {
    (0, $4Rbq2.setBooleanResolver)(flagResolver);
}
function $6345b57baabfd8d3$export$470e5c2be1411c89(name) {
    return (0, $4Rbq2.resolveBooleanFlag)(name);
}
function $6345b57baabfd8d3$export$b40ec24ac8275656(name) {
    return (0, $4Rbq2.resolveBooleanFlag)(name);
}

});
parcelRegister("4Rbq2", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $3894f840d67b1349$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $3894f840d67b1349$export$6333b6aff9fc6275; });

var $429yR = parcelRequire("429yR");

var $8ovux = parcelRequire("8ovux");
var $3894f840d67b1349$var$pkgName = "@atlaskit/platform-feature-flags";
var $3894f840d67b1349$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $3894f840d67b1349$var$hasProcessEnv = typeof $8ovux !== "undefined" && typeof $8ovux.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $3894f840d67b1349$var$ENV_ENABLE_PLATFORM_FF = $3894f840d67b1349$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $3894f840d67b1349$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $3894f840d67b1349$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $3894f840d67b1349$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $3894f840d67b1349$var$ENV_ENABLE_PLATFORM_FF || $3894f840d67b1349$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $3894f840d67b1349$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $3894f840d67b1349$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$3894f840d67b1349$var$globalVar[$3894f840d67b1349$export$7e41b1b2bdee3f98] = $3894f840d67b1349$var$globalVar[$3894f840d67b1349$export$7e41b1b2bdee3f98] || $3894f840d67b1349$var$DEFAULT_PFF_GLOBAL;
function $3894f840d67b1349$export$f2b591175b3e424c(resolver) {
    $3894f840d67b1349$var$globalVar[$3894f840d67b1349$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $3894f840d67b1349$export$6333b6aff9fc6275(flagKey) {
    if ($3894f840d67b1349$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $429yR.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $3894f840d67b1349$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $3894f840d67b1349$var$globalVar[$3894f840d67b1349$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("429yR", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $2efec401752dce79$export$1c9f709888824e05; });
var $2efec401752dce79$var$_ref, $2efec401752dce79$var$_process, $2efec401752dce79$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $2efec401752dce79$var$TESTS_MODE = ($2efec401752dce79$var$_ref = (globalThis === null || globalThis === void 0 || ($2efec401752dce79$var$_process = globalThis.process) === null || $2efec401752dce79$var$_process === void 0 || ($2efec401752dce79$var$_process = $2efec401752dce79$var$_process.env) === null || $2efec401752dce79$var$_process === void 0 ? void 0 : $2efec401752dce79$var$_process.JEST_WORKER_ID) !== undefined, $2efec401752dce79$var$_ref !== void 0) ? $2efec401752dce79$var$_ref : false;
var $2efec401752dce79$var$DEBUG_MODE = !$2efec401752dce79$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($2efec401752dce79$var$_process2 = globalThis.process) === null || $2efec401752dce79$var$_process2 === void 0 || ($2efec401752dce79$var$_process2 = $2efec401752dce79$var$_process2.env) === null || $2efec401752dce79$var$_process2 === void 0 ? void 0 : $2efec401752dce79$var$_process2.NODE_ENV) !== "production";
var $2efec401752dce79$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$2efec401752dce79$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("3ybDD", function(module, exports) {

$parcel$export(module.exports, "useCloseOnEscapePress", function () { return $295d932cbef38914$export$4a4bf067ea9e7886; });
$parcel$export(module.exports, "UNSAFE_useLayering", function () { return $295d932cbef38914$export$cec37b93989366d4; });

var $9nHZC = parcelRequire("9nHZC");

var $1FiMp = parcelRequire("1FiMp");

var $kEiiy = parcelRequire("kEiiy");
var $295d932cbef38914$var$ESCAPE = "Escape";
function $295d932cbef38914$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $9nHZC.useRef)(false);
    var _UNSAFE_useLayering = $295d932cbef38914$export$cec37b93989366d4(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled;
    var onKeyDown = (0, $9nHZC.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $295d932cbef38914$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $9nHZC.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $9nHZC.useEffect)(function() {
        return (0, $1FiMp.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $295d932cbef38914$export$cec37b93989366d4() {
    var currentLevel = (0, $9nHZC.useContext)((0, $kEiiy.LevelContext));
    var _useContext = (0, $9nHZC.useContext)((0, $kEiiy.TopLevelContext)), topLevelRef = _useContext.topLevelRef;
    var isLayerDisabled = (0, $9nHZC.useCallback)(function() {
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}

});

parcelRegister("d8Om8", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $9913155bbe3fa788$export$b40ec24ac8275656; });

var $3WPEB = parcelRequire("3WPEB");
function $9913155bbe3fa788$export$ba05d765b8392e5e(flagResolver) {
    (0, $3WPEB.setBooleanResolver)(flagResolver);
}
function $9913155bbe3fa788$export$470e5c2be1411c89(name) {
    return (0, $3WPEB.resolveBooleanFlag)(name);
}
function $9913155bbe3fa788$export$b40ec24ac8275656(name) {
    return (0, $3WPEB.resolveBooleanFlag)(name);
}

});
parcelRegister("3WPEB", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $2dfedb45568c8483$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $2dfedb45568c8483$export$6333b6aff9fc6275; });

var $3AJvY = parcelRequire("3AJvY");

var $8ovux = parcelRequire("8ovux");
var $2dfedb45568c8483$var$pkgName = "@atlaskit/platform-feature-flags";
var $2dfedb45568c8483$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $2dfedb45568c8483$var$hasProcessEnv = typeof $8ovux !== "undefined" && typeof $8ovux.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $2dfedb45568c8483$var$ENV_ENABLE_PLATFORM_FF = $2dfedb45568c8483$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $2dfedb45568c8483$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $2dfedb45568c8483$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $2dfedb45568c8483$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $2dfedb45568c8483$var$ENV_ENABLE_PLATFORM_FF || $2dfedb45568c8483$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $2dfedb45568c8483$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $2dfedb45568c8483$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$2dfedb45568c8483$var$globalVar[$2dfedb45568c8483$export$7e41b1b2bdee3f98] = $2dfedb45568c8483$var$globalVar[$2dfedb45568c8483$export$7e41b1b2bdee3f98] || $2dfedb45568c8483$var$DEFAULT_PFF_GLOBAL;
function $2dfedb45568c8483$export$f2b591175b3e424c(resolver) {
    $2dfedb45568c8483$var$globalVar[$2dfedb45568c8483$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $2dfedb45568c8483$export$6333b6aff9fc6275(flagKey) {
    if ($2dfedb45568c8483$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $3AJvY.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $2dfedb45568c8483$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $2dfedb45568c8483$var$globalVar[$2dfedb45568c8483$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("3AJvY", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $29d80a2e9eddfa4f$export$1c9f709888824e05; });
var $29d80a2e9eddfa4f$var$_ref, $29d80a2e9eddfa4f$var$_process, $29d80a2e9eddfa4f$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $29d80a2e9eddfa4f$var$TESTS_MODE = ($29d80a2e9eddfa4f$var$_ref = (globalThis === null || globalThis === void 0 || ($29d80a2e9eddfa4f$var$_process = globalThis.process) === null || $29d80a2e9eddfa4f$var$_process === void 0 || ($29d80a2e9eddfa4f$var$_process = $29d80a2e9eddfa4f$var$_process.env) === null || $29d80a2e9eddfa4f$var$_process === void 0 ? void 0 : $29d80a2e9eddfa4f$var$_process.JEST_WORKER_ID) !== undefined, $29d80a2e9eddfa4f$var$_ref !== void 0) ? $29d80a2e9eddfa4f$var$_ref : false;
var $29d80a2e9eddfa4f$var$DEBUG_MODE = !$29d80a2e9eddfa4f$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($29d80a2e9eddfa4f$var$_process2 = globalThis.process) === null || $29d80a2e9eddfa4f$var$_process2 === void 0 || ($29d80a2e9eddfa4f$var$_process2 = $29d80a2e9eddfa4f$var$_process2.env) === null || $29d80a2e9eddfa4f$var$_process2 === void 0 ? void 0 : $29d80a2e9eddfa4f$var$_process2.NODE_ENV) !== "production";
var $29d80a2e9eddfa4f$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$29d80a2e9eddfa4f$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("fuyx6", function(module, exports) {

$parcel$export(module.exports, "media", function () { return $b47471df6ab2f70d$export$987d49ffe1b0900f; });
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $b47471df6ab2f70d$export$987d49ffe1b0900f = {
    above: {
        xxs: "@media all",
        xs: "@media (min-width: 30rem)",
        sm: "@media (min-width: 48rem)",
        md: "@media (min-width: 64rem)",
        lg: "@media (min-width: 90rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    only: {
        xxs: "@media (min-width: 0rem) and (max-width: 29.99rem)",
        xs: "@media (min-width: 30rem) and (max-width: 47.99rem)",
        sm: "@media (min-width: 48rem) and (max-width: 63.99rem)",
        md: "@media (min-width: 64rem) and (max-width: 89.99rem)",
        lg: "@media (min-width: 90rem) and (max-width: 110.49rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    below: {
        xs: "@media not all and (min-width: 30rem)",
        sm: "@media not all and (min-width: 48rem)",
        md: "@media not all and (min-width: 64rem)",
        lg: "@media not all and (min-width: 90rem)",
        xl: "@media not all and (min-width: 110.5rem)"
    }
};
var $b47471df6ab2f70d$export$c881183ca713c214 = $b47471df6ab2f70d$export$987d49ffe1b0900f;

});

parcelRegister("xbX1J", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $063c5a6950f33366$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $063c5a6950f33366$export$a00eac3f8684bcd0; });
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", function () { return $063c5a6950f33366$export$2112803007239c61; });
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", function () { return $063c5a6950f33366$export$352e418ed5b6193a; });
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", function () { return $063c5a6950f33366$export$dddac1532e822863; });
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $063c5a6950f33366$export$9d7b58831ae93caa; });
var $063c5a6950f33366$export$4ef52930e33717cd = "data-theme";
var $063c5a6950f33366$export$a00eac3f8684bcd0 = "data-color-mode";
var $063c5a6950f33366$export$2112803007239c61 = "data-contrast-mode";
var $063c5a6950f33366$export$352e418ed5b6193a = "data-custom-theme";
var $063c5a6950f33366$export$2faeed762aac6741 = "light";
var $063c5a6950f33366$export$6f0c6fb8c80fcc92 = "ds";
var $063c5a6950f33366$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $063c5a6950f33366$export$dddac1532e822863 = "--".concat($063c5a6950f33366$export$6f0c6fb8c80fcc92, "-token-not-found");
var $063c5a6950f33366$export$9d7b58831ae93caa = "--".concat($063c5a6950f33366$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("5sqB4", function(module, exports) {

$parcel$export(module.exports, "width", function () { return $3f9432d868afbadc$export$7e3df82ee760448c; });
$parcel$export(module.exports, "gutter", function () { return $3f9432d868afbadc$export$f2b922cb4a245974; });
$parcel$export(module.exports, "borderRadius", function () { return $3f9432d868afbadc$export$7a57f79000377ca2; });
$parcel$export(module.exports, "verticalOffset", function () { return $3f9432d868afbadc$export$9212741279b5f103; });
$parcel$export(module.exports, "padding", function () { return $3f9432d868afbadc$export$6f98e8eaf0be1996; });
$parcel$export(module.exports, "keylineHeight", function () { return $3f9432d868afbadc$export$4c317248f944c2a9; });
$parcel$export(module.exports, "keylineColor", function () { return $3f9432d868afbadc$export$d901150a4cc83165; });
$parcel$export(module.exports, "textColor", function () { return $3f9432d868afbadc$export$32f78bffcd82ff28; });
$parcel$export(module.exports, "iconColor", function () { return $3f9432d868afbadc$export$3797a580396e3639; });

var $krL2H = parcelRequire("krL2H");

var $0pN5N = parcelRequire("0pN5N");
var $3f9432d868afbadc$export$7e3df82ee760448c = {
    values: [
        "small",
        "medium",
        "large",
        "x-large"
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        "x-large": 968
    },
    defaultValue: "medium"
};
var $3f9432d868afbadc$export$f2b922cb4a245974 = 60;
var $3f9432d868afbadc$var$gridSize = (0, $0pN5N.gridSize)();
var $3f9432d868afbadc$export$7a57f79000377ca2 = (0, $0pN5N.borderRadius)();
var $3f9432d868afbadc$export$9212741279b5f103 = $3f9432d868afbadc$var$gridSize * 2;
var $3f9432d868afbadc$export$6f98e8eaf0be1996 = $3f9432d868afbadc$var$gridSize * 3;
var $3f9432d868afbadc$export$4c317248f944c2a9 = 2;
var $3f9432d868afbadc$export$d901150a4cc83165 = "var(--ds-border, ".concat((0, $krL2H.N30), ")");
var $3f9432d868afbadc$export$32f78bffcd82ff28 = "var(--ds-text, ".concat((0, $krL2H.N900), ")");
var $3f9432d868afbadc$export$3797a580396e3639 = {
    danger: "var(--ds-icon-danger, ".concat((0, $krL2H.R400), ")"),
    warning: "var(--ds-icon-warning, #D97008)"
};

});

parcelRegister("jDlhj", function(module, exports) {

$parcel$export(module.exports, "ModalContext", function () { return $e4b22a4472db8b2e$export$ab57792b9b6974a6; });
$parcel$export(module.exports, "ScrollContext", function () { return $e4b22a4472db8b2e$export$dece24112a937f92; });

var $9nHZC = parcelRequire("9nHZC");
var $e4b22a4472db8b2e$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $9nHZC.createContext)(null);
var $e4b22a4472db8b2e$export$dece24112a937f92 = /*#__PURE__*/ (0, $9nHZC.createContext)(null);

});

parcelRegister("chtuu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f0df2ceb08638ae$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");
function $8f0df2ceb08638ae$export$2e2bcd8739ae039(_ref) {
    var onOpenComplete = _ref.onOpenComplete, onCloseComplete = _ref.onCloseComplete;
    var motionRef = (0, $9nHZC.useRef)(null);
    var onMotionFinish = (0, $9nHZC.useCallback)(function(state) {
        if (state === "entering" && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === "exiting" && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("1eMkV", function(module, exports) {

$parcel$export(module.exports, "dialogWidth", function () { return $0e6c97dddb58ca9e$export$a3da89b899389ed8; });
$parcel$export(module.exports, "dialogHeight", function () { return $0e6c97dddb58ca9e$export$ceba93bf0bdd16f2; });

var $5sqB4 = parcelRequire("5sqB4");
var $0e6c97dddb58ca9e$export$a3da89b899389ed8 = function dialogWidth(input) {
    if (!input) return "auto";
    var isWidthName = (0, $5sqB4.width).values.indexOf(input.toString()) !== -1;
    var widthName = isWidthName && input;
    if (widthName) return "".concat((0, $5sqB4.width).widths[widthName], "px");
    return typeof input === "number" ? "".concat(input, "px") : input;
};
var $0e6c97dddb58ca9e$export$ceba93bf0bdd16f2 = function dialogHeight(input) {
    if (!input) return "auto";
    return typeof input === "number" ? "".concat(input, "px") : input;
};

});

parcelRegister("8Vjue", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67f2c34104100b00$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $6ZCxy = parcelRequire("6ZCxy");

var $htChF = parcelRequire("htChF");

var $fuyx6 = parcelRequire("fuyx6");

var $0pN5N = parcelRequire("0pN5N");

var $5sqB4 = parcelRequire("5sqB4");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $67f2c34104100b00$var$maxWidthDimensions = "calc(100vw - ".concat((0, $5sqB4.gutter) * 2, "px)");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $67f2c34104100b00$var$maxHeightDimensions = "calc(100vh - ".concat((0, $5sqB4.gutter) * 2 - 1, "px)");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
var $67f2c34104100b00$var$positionerStyles = (0, $avKww.css)({
    display: "flex",
    width: "100%",
    maxWidth: "100%",
    height: "100%",
    position: "fixed",
    zIndex: (0, $0pN5N.layers).modal(),
    flexDirection: "column",
    insetBlockStart: 0,
    insetInlineStart: 0
});
var $67f2c34104100b00$var$viewportScrollStyles = (0, $avKww.css)((0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({
    height: "auto",
    position: "relative"
}, (0, $fuyx6.media).above.xs, {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: "".concat((0, $5sqB4.gutter), "px auto"),
    pointerEvents: "none"
}));
var $67f2c34104100b00$var$bodyScrollStyles = (0, $avKww.css)((0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, (0, $fuyx6.media).above.xs, {
    maxWidth: $67f2c34104100b00$var$maxWidthDimensions,
    maxHeight: $67f2c34104100b00$var$maxHeightDimensions,
    position: "absolute",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: "".concat((0, $5sqB4.gutter), "px"),
    insetInlineEnd: 0,
    insetInlineStart: 0,
    marginInlineEnd: "auto",
    marginInlineStart: "auto",
    pointerEvents: "none"
}));
var $67f2c34104100b00$var$stackTransitionStyles = (0, $avKww.css)({
    transitionDuration: "".concat((0, $htChF.mediumDurationMs), "ms"),
    transitionProperty: "transform",
    transitionTimingFunction: (0, $6ZCxy.easeInOut),
    /**
   * Duplicated from @atlaskit/motion/accessibility
   * because @repo/internal/styles/consistent-style-ordering
   * doesn't work well with object spreading.
   */ "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
});
var $67f2c34104100b00$var$stackTransformStyles = (0, $avKww.css)({
    transform: "translateY(var(--modal-dialog-translate-y))"
});
var $67f2c34104100b00$var$stackIdleStyles = (0, $avKww.css)({
    transform: "none"
});
var $67f2c34104100b00$var$Positioner = function Positioner(props) {
    var children = props.children, stackIndex = props.stackIndex, shouldScrollInViewport = props.shouldScrollInViewport, testId = props.testId;
    return (0, $avKww.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--modal-dialog-translate-y": "".concat(stackIndex * ((0, $5sqB4.verticalOffset) / 2), "px")
        },
        css: [
            $67f2c34104100b00$var$positionerStyles,
            $67f2c34104100b00$var$stackTransitionStyles,
            /* We only want to apply transform on modals shifting to the back of the stack. */ stackIndex > 0 ? $67f2c34104100b00$var$stackTransformStyles : $67f2c34104100b00$var$stackIdleStyles,
            shouldScrollInViewport ? $67f2c34104100b00$var$viewportScrollStyles : $67f2c34104100b00$var$bodyScrollStyles
        ],
        "data-testid": testId && "".concat(testId, "--positioner")
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$67f2c34104100b00$export$2e2bcd8739ae039 = $67f2c34104100b00$var$Positioner;

});


parcelRegister("bagq3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $820d5d69cb442ce7$export$2e2bcd8739ae039; });

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $hhqFb = parcelRequire("hhqFb");

var $iIWPw = parcelRequire("iIWPw");

var $hqkcu = parcelRequire("hqkcu");

var $JcvLo = parcelRequire("JcvLo");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ var $820d5d69cb442ce7$var$modalStackRegister = [];
function $820d5d69cb442ce7$export$2e2bcd8739ae039(_ref) {
    var onStackChange = _ref.onStackChange;
    var _useExitingPersistenc = (0, $JcvLo.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting;
    var _useStateRef = (0, $hqkcu.default)(0), _useStateRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useStateRef, 2), stackIndexRef = _useStateRef2[0], setStackIndex = _useStateRef2[1];
    var currentStackIndex = stackIndexRef.current;
    var previousStackIndex = (0, $iIWPw.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    var updateStack = (0, $hhqFb.default)(function() {
        var newStackIndex = $820d5d69cb442ce7$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $9nHZC.useEffect)(function() {
        var currentStackIndex = $820d5d69cb442ce7$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $820d5d69cb442ce7$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $820d5d69cb442ce7$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $820d5d69cb442ce7$var$modalStackRegister.forEach(function(cb) {
            return cb();
        });
    }, [
        updateStack,
        isExiting
    ]);
    (0, $9nHZC.useEffect)(function() {
        return function() {
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            var currentStackIndex = $820d5d69cb442ce7$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $820d5d69cb442ce7$var$modalStackRegister.splice(currentStackIndex, 1);
                $820d5d69cb442ce7$var$modalStackRegister.forEach(function(cb) {
                    return cb();
                });
            }
        };
    }, [
        updateStack
    ]);
    (0, $9nHZC.useEffect)(function() {
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("hhqFb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c948b4faaa2c2933$export$2e2bcd8739ae039; });

var $fvrhi = parcelRequire("fvrhi");
function $c948b4faaa2c2933$export$2e2bcd8739ae039(callback) {
    var ref = (0, $fvrhi.default)(function() {
        return callback;
    });
    return ref.current;
}

});
parcelRegister("fvrhi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b49ee91d0466a4cb$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");
var $b49ee91d0466a4cb$var$uniqueReferencedValue = {};
function $b49ee91d0466a4cb$export$2e2bcd8739ae039(initializer) {
    var ref = (0, $9nHZC.useRef)($b49ee91d0466a4cb$var$uniqueReferencedValue);
    if (ref.current === $b49ee91d0466a4cb$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});


parcelRegister("iIWPw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da19f87c9a0f965a$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");
function $da19f87c9a0f965a$export$2e2bcd8739ae039(value) {
    var ref = (0, $9nHZC.useRef)();
    (0, $9nHZC.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("hqkcu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $caf488c6b54fe4ed$export$2e2bcd8739ae039; });

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");
function $caf488c6b54fe4ed$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $9nHZC.useState)(initialState), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueRef = (0, $9nHZC.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});


parcelRegister("hj909", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c99b3188c8bba6af$export$2e2bcd8739ae039; });

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $1FiMp = parcelRequire("1FiMp");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $c99b3188c8bba6af$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $c99b3188c8bba6af$export$2e2bcd8739ae039() {
    var _useState = (0, $9nHZC.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), scrollTopOffset = _useState2[0], setScrollTopOffset = _useState2[1];
    (0, $9nHZC.useLayoutEffect)(function() {
        setScrollTopOffset($c99b3188c8bba6af$var$getScrollDistance());
    }, []);
    var onWindowScroll = (0, $9nHZC.useCallback)(function() {
        if ($c99b3188c8bba6af$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $9nHZC.useEffect)(function() {
        return (0, $1FiMp.bind)(window, {
            type: "scroll",
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});


parcelRegister("ljrFr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f840d5820937a605$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $knkgL = parcelRequire("knkgL");

var $5vrjy = parcelRequire("5vrjy");

var $bDAM5 = parcelRequire("bDAM5");

var $5sqB4 = parcelRequire("5sqB4");

var $77LL6 = parcelRequire("77LL6");
var $f840d5820937a605$var$bodyStyles = (0, $avKww.css)({
    /* This ensures the body fills the whole space between header and footer. */ flex: "1 1 auto"
});
/**
 * Adding the padding here avoids cropping the keyline on its sides.
 * The combined vertical spacing is maintained by subtracting the
 * keyline height from header and footer.
 */ var $f840d5820937a605$var$bodyScrollStyles = (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: "".concat((0, $5sqB4.keylineHeight), "px ").concat((0, $5sqB4.padding), "px")
});
/**
 * Keylines will not be shown if scrolling in viewport so we do
 * not account for them in this case.
 */ var $f840d5820937a605$var$viewportScrollStyles = (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: "0px ".concat((0, $5sqB4.padding), "px")
});
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $f840d5820937a605$var$ModalBody = function ModalBody(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $5vrjy.useModal)(), modalTestId = _useModal.testId;
    var shouldScrollInViewport = (0, $77LL6.default)();
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--body");
    return shouldScrollInViewport ? (0, $avKww.jsx)("div", {
        css: [
            $f840d5820937a605$var$bodyStyles,
            $f840d5820937a605$var$viewportScrollStyles
        ],
        "data-testid": testId
    }, children) : (0, $avKww.jsx)((0, $knkgL.TouchScrollable), null, (0, $avKww.jsx)((0, $bDAM5.default), {
        testId: userDefinedTestId || modalTestId
    }, (0, $avKww.jsx)("div", {
        css: [
            $f840d5820937a605$var$bodyStyles,
            $f840d5820937a605$var$bodyScrollStyles
        ],
        "data-testid": testId
    }, children)));
};
var $f840d5820937a605$export$2e2bcd8739ae039 = $f840d5820937a605$var$ModalBody;

});
parcelRegister("5vrjy", function(module, exports) {

$parcel$export(module.exports, "useModal", function () { return $402509185382884c$export$33ffd74ebf07f060; });

var $9nHZC = parcelRequire("9nHZC");

var $jDlhj = parcelRequire("jDlhj");
var $402509185382884c$export$33ffd74ebf07f060 = function useModal() {
    var modalContext = (0, $9nHZC.useContext)((0, $jDlhj.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});

parcelRegister("bDAM5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $878fdcdee6795547$export$2e2bcd8739ae039; });

var $9q1kH = parcelRequire("9q1kH");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $1FiMp = parcelRequire("1FiMp");

var $eipj2 = parcelRequire("eipj2");

var $3aF04 = parcelRequire("3aF04");

var $8p2GL = parcelRequire("8p2GL");

var $hhqFb = parcelRequire("hhqFb");

var $hqkcu = parcelRequire("hqkcu");

var $dxhCu = parcelRequire("dxhCu");

var $fuyx6 = parcelRequire("fuyx6");

var $5sqB4 = parcelRequire("5sqB4");
var $878fdcdee6795547$var$baseStyles = (0, $avKww.css)((0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({
    display: "inherit",
    margin: "var(--ds-space-0, 0px)",
    flex: "inherit",
    flexDirection: "inherit",
    flexGrow: 1,
    overflowX: "hidden",
    overflowY: "auto"
}, (0, $fuyx6.media).above.xs, {
    height: "unset",
    overflowY: "auto"
}));
var $878fdcdee6795547$var$topKeylineStyles = (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockStart: "".concat((0, $5sqB4.keylineHeight), "px solid ").concat((0, $5sqB4.keylineColor))
});
var $878fdcdee6795547$var$bottomKeylineStyles = (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: "".concat((0, $5sqB4.keylineHeight), "px solid ").concat((0, $5sqB4.keylineColor))
});
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ var $878fdcdee6795547$var$ScrollContainer = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(props, ref) {
    var testId = props.testId, children = props.children;
    var _useStateRef = (0, $hqkcu.default)({
        previous: false,
        next: false
    }), _useStateRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useStateRef, 2), hasSiblings = _useStateRef2[0], setSiblings = _useStateRef2[1];
    var _useState = (0, $9nHZC.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), showContentFocus = _useState2[0], setContentFocus = _useState2[1];
    var _useState3 = (0, $9nHZC.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState3, 2), showTopKeyline = _useState4[0], setTopKeyline = _useState4[1];
    var _useState5 = (0, $9nHZC.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState5, 2), showBottomKeyline = _useState6[0], setBottomKeyline = _useState6[1];
    var scrollableRef = (0, $9nHZC.useRef)(null);
    var setLazySiblings = (0, $hhqFb.default)(setSiblings);
    var setLazyContentFocus = (0, $hhqFb.default)((0, $eipj2.default)(function() {
        var target = scrollableRef.current;
        target && setContentFocus(target.scrollHeight > target.clientHeight);
    }));
    var setLazyKeylines = (0, $hhqFb.default)((0, $eipj2.default)(function() {
        var target = scrollableRef.current;
        if (target) {
            var scrollableDistance = target.scrollHeight - target.clientHeight;
            if (hasSiblings.current.previous) setTopKeyline(target.scrollTop > (0, $5sqB4.keylineHeight));
            if (hasSiblings.current.next) setBottomKeyline(target.scrollTop <= scrollableDistance - (0, $5sqB4.keylineHeight));
        }
    }));
    (0, $9nHZC.useEffect)(function() {
        var target = scrollableRef.current;
        var unbindWindowEvent = (0, $1FiMp.bind)(window, {
            type: "resize",
            listener: setLazyKeylines
        });
        var unbindTargetEvent = target ? (0, $1FiMp.bind)(target, {
            type: "scroll",
            listener: setLazyKeylines
        }) : (0, $8p2GL.default);
        setLazyContentFocus();
        setLazyKeylines();
        setLazySiblings({
            previous: Boolean(target === null || target === void 0 ? void 0 : target.previousElementSibling),
            next: Boolean(target === null || target === void 0 ? void 0 : target.nextElementSibling)
        });
        return function() {
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyContentFocus,
        setLazyKeylines,
        setLazySiblings
    ]);
    return (0, $avKww.jsx)((0, $dxhCu.default), {
        isInset: true
    }, (0, $avKww.jsx)("div", {
        // tabindex is allowed here so that keyboard users can scroll content
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? "region" : undefined,
        "aria-label": showContentFocus ? "Scrollable content" : undefined,
        "data-testid": testId && "".concat(testId, "--scrollable"),
        ref: (0, $3aF04.default)([
            ref,
            scrollableRef
        ]),
        css: [
            $878fdcdee6795547$var$baseStyles,
            showTopKeyline && $878fdcdee6795547$var$topKeylineStyles,
            showBottomKeyline && $878fdcdee6795547$var$bottomKeylineStyles
        ]
    }, children));
});
$878fdcdee6795547$var$ScrollContainer.displayName = "ScrollContainer";
var $878fdcdee6795547$export$2e2bcd8739ae039 = $878fdcdee6795547$var$ScrollContainer;

});
parcelRegister("eipj2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a68660681c48425a$export$2e2bcd8739ae039; });
var $a68660681c48425a$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $a68660681c48425a$export$2e2bcd8739ae039 = $a68660681c48425a$var$rafSchd;

});


parcelRegister("77LL6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52fe3bbe3a9d6a27$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $jDlhj = parcelRequire("jDlhj");
function $52fe3bbe3a9d6a27$export$2e2bcd8739ae039() {
    var shouldScrollInViewport = (0, $9nHZC.useContext)((0, $jDlhj.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});


parcelRegister("2X56B", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $22650d4d75b51131$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $avKww = parcelRequire("avKww");

var $5vrjy = parcelRequire("5vrjy");

var $5sqB4 = parcelRequire("5sqB4");
var $22650d4d75b51131$var$footerStyles = (0, $avKww.css)({
    display: "flex",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: (0, $5sqB4.padding),
    position: "relative",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingBlockStart: "".concat((0, $5sqB4.padding) - (0, $5sqB4.keylineHeight), "px")
});
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $22650d4d75b51131$var$ModalFooter = function ModalFooter(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $5vrjy.useModal)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--footer");
    return (0, $avKww.jsx)("div", {
        css: $22650d4d75b51131$var$footerStyles,
        "data-testid": testId
    }, children);
};
var $22650d4d75b51131$export$2e2bcd8739ae039 = $22650d4d75b51131$var$ModalFooter;

});

parcelRegister("DPG6Z", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $077bbada00d386a1$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $5vrjy = parcelRequire("5vrjy");

var $5sqB4 = parcelRequire("5sqB4");
var $077bbada00d386a1$var$headerStyles = (0, $avKww.css)({
    display: "flex",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: (0, $5sqB4.padding),
    position: "relative",
    alignItems: "center",
    justifyContent: "space-between",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingBlockEnd: "".concat((0, $5sqB4.padding) - (0, $5sqB4.keylineHeight), "px")
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $077bbada00d386a1$var$ModalHeader = function ModalHeader(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $5vrjy.useModal)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--header");
    return (0, $avKww.jsx)("div", {
        css: $077bbada00d386a1$var$headerStyles,
        "data-testid": testId
    }, children);
};
var $077bbada00d386a1$export$2e2bcd8739ae039 = $077bbada00d386a1$var$ModalHeader;

});

parcelRegister("3qXIy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $28021f7516667286$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $avKww = parcelRequire("avKww");

var $52qH0 = parcelRequire("52qH0");

var $9gEXL = parcelRequire("9gEXL");

var $5vrjy = parcelRequire("5vrjy");

var $5sqB4 = parcelRequire("5sqB4");
var $28021f7516667286$var$titleStyles = (0, $avKww.css)({
    display: "flex",
    minWidth: 0,
    margin: "var(--ds-space-0, 0px)",
    gap: "var(--ds-space-100, 8px)",
    font: 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
});
var $28021f7516667286$var$textStyles = (0, $avKww.css)({
    minWidth: 0,
    /**
   * This ensures that the element fills the whole header space
   * and its content does not overflow (since flex items don't
   * shrink past its content size by default).
   */ flex: "1 1 auto",
    wordWrap: "break-word"
});
var $28021f7516667286$var$iconStyles = (0, $avKww.css)({
    flex: "0 0 auto",
    // The following properties have been added purely to avoid a global style override in Jira breaking alignment between the icon and title text.
    // https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-legacy-frontend/jira-atlaskit-module/src/main/resources/jira-atlaskit-module/css/adg3-general-overrides.less?at=master#24
    // When the override is removed, these can be removed.
    color: "inherit",
    fontSize: "inherit",
    fontStyle: "inherit",
    fontWeight: "inherit",
    letterSpacing: "inherit",
    lineHeight: "inherit"
});
var $28021f7516667286$var$truncatedTextStyles = (0, $avKww.css)({
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $28021f7516667286$var$TitleIcon = function TitleIcon(_ref) {
    var appearance = _ref.appearance;
    var Icon = appearance === "danger" ? (0, (/*@__PURE__*/$parcel$interopDefault($52qH0))) : (0, (/*@__PURE__*/$parcel$interopDefault($9gEXL)));
    return (0, $avKww.jsx)("span", {
        css: $28021f7516667286$var$iconStyles
    }, (0, $avKww.jsx)(Icon, {
        label: appearance,
        color: (0, $5sqB4.iconColor)[appearance],
        spacing: "spacious"
    }));
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $28021f7516667286$var$ModalTitle = function ModalTitle(props) {
    var appearance = props.appearance, children = props.children, _props$isMultiline = props.isMultiline, isMultiline = _props$isMultiline === void 0 ? true : _props$isMultiline, userDefinedTestId = props.testId;
    var _useModal = (0, $5vrjy.useModal)(), titleId = _useModal.titleId, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--title");
    return (0, $avKww.jsx)("h1", {
        css: $28021f7516667286$var$titleStyles,
        "data-testid": testId
    }, appearance && (0, $avKww.jsx)($28021f7516667286$var$TitleIcon, {
        appearance: appearance
    }), (0, $avKww.jsx)("span", {
        id: titleId,
        css: [
            $28021f7516667286$var$textStyles,
            !isMultiline && $28021f7516667286$var$truncatedTextStyles
        ],
        "data-testid": testId && "".concat(testId, "-text")
    }, children));
};
var $28021f7516667286$export$2e2bcd8739ae039 = $28021f7516667286$var$ModalTitle;

});
parcelRegister("52qH0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::70549eba04ecfbbd98fd800757b66984>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3ab1d847971784ae$var$_react = $3ab1d847971784ae$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $3ab1d847971784ae$var$_error = $3ab1d847971784ae$var$_interopRequireDefault((parcelRequire("lajRB")));

var $3ab1d847971784ae$var$_error2 = $3ab1d847971784ae$var$_interopRequireDefault((parcelRequire("4dJkZ")));
function $3ab1d847971784ae$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3ab1d847971784ae$var$ErrorIcon = (props)=>/*#__PURE__*/ $3ab1d847971784ae$var$_react.default.createElement($3ab1d847971784ae$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $3ab1d847971784ae$var$_error2.default
    }, props));
$3ab1d847971784ae$var$ErrorIcon.Name = "ErrorIconMigration";
var $3ab1d847971784ae$var$_default = module.exports.default = $3ab1d847971784ae$var$ErrorIcon;

});
parcelRegister("lajRB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::796368f5d379f034b5d96a253e623668>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f689f09ec4da3d6a$var$_react = $f689f09ec4da3d6a$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $f689f09ec4da3d6a$var$_UNSAFE_baseNew = $f689f09ec4da3d6a$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $f689f09ec4da3d6a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Error".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f689f09ec4da3d6a$var$ErrorIcon = (props)=>/*#__PURE__*/ $f689f09ec4da3d6a$var$_react.default.createElement($f689f09ec4da3d6a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.982 5.983a2 2 0 0 1 0 2.828l-5.982 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM7.25 9V3.75h1.5V9zM8 12.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$f689f09ec4da3d6a$var$ErrorIcon.displayName = "ErrorIcon";
var $f689f09ec4da3d6a$var$_default = module.exports.default = $f689f09ec4da3d6a$var$ErrorIcon;

});

parcelRegister("4dJkZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $312b8b6fe6b8c807$var$_react = $312b8b6fe6b8c807$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $312b8b6fe6b8c807$var$_error = $312b8b6fe6b8c807$var$_interopRequireDefault((parcelRequire("lajRB")));
function $312b8b6fe6b8c807$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $312b8b6fe6b8c807$var$ErrorIcon = (props)=>/*#__PURE__*/ $312b8b6fe6b8c807$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $312b8b6fe6b8c807$var$_error.default
    }));
$312b8b6fe6b8c807$var$ErrorIcon.displayName = "ErrorIcon";
var $312b8b6fe6b8c807$var$_default = module.exports.default = $312b8b6fe6b8c807$var$ErrorIcon;

});


parcelRegister("9gEXL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d277a773f51897e45ed042b256e449b5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6bf56211ebb32265$var$_react = $6bf56211ebb32265$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $6bf56211ebb32265$var$_warning = $6bf56211ebb32265$var$_interopRequireDefault((parcelRequire("jjPmJ")));

var $6bf56211ebb32265$var$_warning2 = $6bf56211ebb32265$var$_interopRequireDefault((parcelRequire("9hjCt")));
function $6bf56211ebb32265$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6bf56211ebb32265$var$WarningIcon = (props)=>/*#__PURE__*/ $6bf56211ebb32265$var$_react.default.createElement($6bf56211ebb32265$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $6bf56211ebb32265$var$_warning2.default
    }, props));
$6bf56211ebb32265$var$WarningIcon.Name = "WarningIconMigration";
var $6bf56211ebb32265$var$_default = module.exports.default = $6bf56211ebb32265$var$WarningIcon;

});
parcelRegister("jjPmJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5bbc66a5bafbc3dabace12fa6936c92e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e107a2cb8866bb05$var$_react = $e107a2cb8866bb05$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $e107a2cb8866bb05$var$_UNSAFE_baseNew = $e107a2cb8866bb05$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $e107a2cb8866bb05$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e107a2cb8866bb05$var$WarningIcon = (props)=>/*#__PURE__*/ $e107a2cb8866bb05$var$_react.default.createElement($e107a2cb8866bb05$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.757-1.396 2.76-1.396 3.516 0l5.9 10.878c.723 1.332-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM7.25 9.499v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$e107a2cb8866bb05$var$WarningIcon.displayName = "WarningIcon";
var $e107a2cb8866bb05$var$_default = module.exports.default = $e107a2cb8866bb05$var$WarningIcon;

});

parcelRegister("9hjCt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6c14eb9e32e88b83$var$_react = $6c14eb9e32e88b83$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $6c14eb9e32e88b83$var$_warning = $6c14eb9e32e88b83$var$_interopRequireDefault((parcelRequire("jjPmJ")));
function $6c14eb9e32e88b83$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6c14eb9e32e88b83$var$WarningIcon = (props)=>/*#__PURE__*/ $6c14eb9e32e88b83$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $6c14eb9e32e88b83$var$_warning.default
    }));
$6c14eb9e32e88b83$var$WarningIcon.displayName = "WarningIcon";
var $6c14eb9e32e88b83$var$_default = module.exports.default = $6c14eb9e32e88b83$var$WarningIcon;

});



parcelRegister("2FnXC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f11ff287651d2a4$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $JcvLo = parcelRequire("JcvLo");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $1f11ff287651d2a4$var$ModalTransition = function ModalTransition(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $JcvLo.default), {
        appear: true
    }, props.children);
};
var $1f11ff287651d2a4$export$2e2bcd8739ae039 = $1f11ff287651d2a4$var$ModalTransition;

});

parcelRegister("h39Sh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c69a605f55e1507c$export$2e2bcd8739ae039; });



var $4QRrz = parcelRequire("4QRrz");

var $xbX1J = parcelRequire("xbX1J");

var $8ovux = parcelRequire("8ovux");
/**
 * Takes a dot-separated token name and an optional fallback, and returns the CSS custom property for the corresponding token.
 * This should be used to implement design decisions throughout your application.
 *
 * Note: With `@atlaskit/babel-plugin-tokens`, this function can be pre-compiled and a fallback value automatically inserted.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * <div
 *   css={{
 *     backgroundColor: token('elevation.surface.raised', N0),
 *     boxShadow: token('elevation.shadow.raised', `0 20px 32px -8px ${N50A}, 0 0 1px ${N60A}`),
 *     padding: token('spacing.scale.100', '8px'),
 *     fontWeight: token('font.weight.regular', '400'),
 *   }}
 * />
 * ```
 *
 */ function $c69a605f55e1507c$var$token(path, fallback) {
    var token = (0, $4QRrz.default)[path];
    typeof $8ovux;
    // if the token is not found - replacing it with variable name without any value, to avoid it being undefined which would result in invalid css
    if (!token) token = (0, $xbX1J.TOKEN_NOT_FOUND_CSS_VAR);
    var tokenCall = fallback ? "var(".concat(token, ", ").concat(fallback, ")") : "var(".concat(token, ")");
    return tokenCall;
}
var $c69a605f55e1507c$export$2e2bcd8739ae039 = $c69a605f55e1507c$var$token;

});
parcelRegister("4QRrz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $388579911b54e526$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db26fca19e3969bcba2e77bc6fe6eb89>>
 * @codegenCommand yarn build tokens
 */ var $388579911b54e526$var$tokens = {
    "color.text": "--ds-text",
    "color.text.accent.lime": "--ds-text-accent-lime",
    "color.text.accent.lime.bolder": "--ds-text-accent-lime-bolder",
    "color.text.accent.red": "--ds-text-accent-red",
    "color.text.accent.red.bolder": "--ds-text-accent-red-bolder",
    "color.text.accent.orange": "--ds-text-accent-orange",
    "color.text.accent.orange.bolder": "--ds-text-accent-orange-bolder",
    "color.text.accent.yellow": "--ds-text-accent-yellow",
    "color.text.accent.yellow.bolder": "--ds-text-accent-yellow-bolder",
    "color.text.accent.green": "--ds-text-accent-green",
    "color.text.accent.green.bolder": "--ds-text-accent-green-bolder",
    "color.text.accent.teal": "--ds-text-accent-teal",
    "color.text.accent.teal.bolder": "--ds-text-accent-teal-bolder",
    "color.text.accent.blue": "--ds-text-accent-blue",
    "color.text.accent.blue.bolder": "--ds-text-accent-blue-bolder",
    "color.text.accent.purple": "--ds-text-accent-purple",
    "color.text.accent.purple.bolder": "--ds-text-accent-purple-bolder",
    "color.text.accent.magenta": "--ds-text-accent-magenta",
    "color.text.accent.magenta.bolder": "--ds-text-accent-magenta-bolder",
    "color.text.accent.gray": "--ds-text-accent-gray",
    "color.text.accent.gray.bolder": "--ds-text-accent-gray-bolder",
    "color.text.disabled": "--ds-text-disabled",
    "color.text.inverse": "--ds-text-inverse",
    "color.text.selected": "--ds-text-selected",
    "color.text.brand": "--ds-text-brand",
    "color.text.danger": "--ds-text-danger",
    "color.text.warning": "--ds-text-warning",
    "color.text.warning.inverse": "--ds-text-warning-inverse",
    "color.text.success": "--ds-text-success",
    "color.text.discovery": "--ds-text-discovery",
    "color.text.information": "--ds-text-information",
    "color.text.subtlest": "--ds-text-subtlest",
    "color.text.subtle": "--ds-text-subtle",
    "color.link": "--ds-link",
    "color.link.pressed": "--ds-link-pressed",
    "color.link.visited": "--ds-link-visited",
    "color.link.visited.pressed": "--ds-link-visited-pressed",
    "color.icon": "--ds-icon",
    "color.icon.accent.lime": "--ds-icon-accent-lime",
    "color.icon.accent.red": "--ds-icon-accent-red",
    "color.icon.accent.orange": "--ds-icon-accent-orange",
    "color.icon.accent.yellow": "--ds-icon-accent-yellow",
    "color.icon.accent.green": "--ds-icon-accent-green",
    "color.icon.accent.teal": "--ds-icon-accent-teal",
    "color.icon.accent.blue": "--ds-icon-accent-blue",
    "color.icon.accent.purple": "--ds-icon-accent-purple",
    "color.icon.accent.magenta": "--ds-icon-accent-magenta",
    "color.icon.accent.gray": "--ds-icon-accent-gray",
    "color.icon.disabled": "--ds-icon-disabled",
    "color.icon.inverse": "--ds-icon-inverse",
    "color.icon.selected": "--ds-icon-selected",
    "color.icon.brand": "--ds-icon-brand",
    "color.icon.danger": "--ds-icon-danger",
    "color.icon.warning": "--ds-icon-warning",
    "color.icon.warning.inverse": "--ds-icon-warning-inverse",
    "color.icon.success": "--ds-icon-success",
    "color.icon.discovery": "--ds-icon-discovery",
    "color.icon.information": "--ds-icon-information",
    "color.icon.subtlest": "--ds-icon-subtlest",
    "color.icon.subtle": "--ds-icon-subtle",
    "color.border": "--ds-border",
    "color.border.accent.lime": "--ds-border-accent-lime",
    "color.border.accent.red": "--ds-border-accent-red",
    "color.border.accent.orange": "--ds-border-accent-orange",
    "color.border.accent.yellow": "--ds-border-accent-yellow",
    "color.border.accent.green": "--ds-border-accent-green",
    "color.border.accent.teal": "--ds-border-accent-teal",
    "color.border.accent.blue": "--ds-border-accent-blue",
    "color.border.accent.purple": "--ds-border-accent-purple",
    "color.border.accent.magenta": "--ds-border-accent-magenta",
    "color.border.accent.gray": "--ds-border-accent-gray",
    "color.border.disabled": "--ds-border-disabled",
    "color.border.focused": "--ds-border-focused",
    "color.border.input": "--ds-border-input",
    "color.border.inverse": "--ds-border-inverse",
    "color.border.selected": "--ds-border-selected",
    "color.border.brand": "--ds-border-brand",
    "color.border.danger": "--ds-border-danger",
    "color.border.warning": "--ds-border-warning",
    "color.border.success": "--ds-border-success",
    "color.border.discovery": "--ds-border-discovery",
    "color.border.information": "--ds-border-information",
    "color.border.bold": "--ds-border-bold",
    "color.background.accent.lime.subtlest": "--ds-background-accent-lime-subtlest",
    "color.background.accent.lime.subtlest.hovered": "--ds-background-accent-lime-subtlest-hovered",
    "color.background.accent.lime.subtlest.pressed": "--ds-background-accent-lime-subtlest-pressed",
    "color.background.accent.lime.subtler": "--ds-background-accent-lime-subtler",
    "color.background.accent.lime.subtler.hovered": "--ds-background-accent-lime-subtler-hovered",
    "color.background.accent.lime.subtler.pressed": "--ds-background-accent-lime-subtler-pressed",
    "color.background.accent.lime.subtle": "--ds-background-accent-lime-subtle",
    "color.background.accent.lime.subtle.hovered": "--ds-background-accent-lime-subtle-hovered",
    "color.background.accent.lime.subtle.pressed": "--ds-background-accent-lime-subtle-pressed",
    "color.background.accent.lime.bolder": "--ds-background-accent-lime-bolder",
    "color.background.accent.lime.bolder.hovered": "--ds-background-accent-lime-bolder-hovered",
    "color.background.accent.lime.bolder.pressed": "--ds-background-accent-lime-bolder-pressed",
    "color.background.accent.red.subtlest": "--ds-background-accent-red-subtlest",
    "color.background.accent.red.subtlest.hovered": "--ds-background-accent-red-subtlest-hovered",
    "color.background.accent.red.subtlest.pressed": "--ds-background-accent-red-subtlest-pressed",
    "color.background.accent.red.subtler": "--ds-background-accent-red-subtler",
    "color.background.accent.red.subtler.hovered": "--ds-background-accent-red-subtler-hovered",
    "color.background.accent.red.subtler.pressed": "--ds-background-accent-red-subtler-pressed",
    "color.background.accent.red.subtle": "--ds-background-accent-red-subtle",
    "color.background.accent.red.subtle.hovered": "--ds-background-accent-red-subtle-hovered",
    "color.background.accent.red.subtle.pressed": "--ds-background-accent-red-subtle-pressed",
    "color.background.accent.red.bolder": "--ds-background-accent-red-bolder",
    "color.background.accent.red.bolder.hovered": "--ds-background-accent-red-bolder-hovered",
    "color.background.accent.red.bolder.pressed": "--ds-background-accent-red-bolder-pressed",
    "color.background.accent.orange.subtlest": "--ds-background-accent-orange-subtlest",
    "color.background.accent.orange.subtlest.hovered": "--ds-background-accent-orange-subtlest-hovered",
    "color.background.accent.orange.subtlest.pressed": "--ds-background-accent-orange-subtlest-pressed",
    "color.background.accent.orange.subtler": "--ds-background-accent-orange-subtler",
    "color.background.accent.orange.subtler.hovered": "--ds-background-accent-orange-subtler-hovered",
    "color.background.accent.orange.subtler.pressed": "--ds-background-accent-orange-subtler-pressed",
    "color.background.accent.orange.subtle": "--ds-background-accent-orange-subtle",
    "color.background.accent.orange.subtle.hovered": "--ds-background-accent-orange-subtle-hovered",
    "color.background.accent.orange.subtle.pressed": "--ds-background-accent-orange-subtle-pressed",
    "color.background.accent.orange.bolder": "--ds-background-accent-orange-bolder",
    "color.background.accent.orange.bolder.hovered": "--ds-background-accent-orange-bolder-hovered",
    "color.background.accent.orange.bolder.pressed": "--ds-background-accent-orange-bolder-pressed",
    "color.background.accent.yellow.subtlest": "--ds-background-accent-yellow-subtlest",
    "color.background.accent.yellow.subtlest.hovered": "--ds-background-accent-yellow-subtlest-hovered",
    "color.background.accent.yellow.subtlest.pressed": "--ds-background-accent-yellow-subtlest-pressed",
    "color.background.accent.yellow.subtler": "--ds-background-accent-yellow-subtler",
    "color.background.accent.yellow.subtler.hovered": "--ds-background-accent-yellow-subtler-hovered",
    "color.background.accent.yellow.subtler.pressed": "--ds-background-accent-yellow-subtler-pressed",
    "color.background.accent.yellow.subtle": "--ds-background-accent-yellow-subtle",
    "color.background.accent.yellow.subtle.hovered": "--ds-background-accent-yellow-subtle-hovered",
    "color.background.accent.yellow.subtle.pressed": "--ds-background-accent-yellow-subtle-pressed",
    "color.background.accent.yellow.bolder": "--ds-background-accent-yellow-bolder",
    "color.background.accent.yellow.bolder.hovered": "--ds-background-accent-yellow-bolder-hovered",
    "color.background.accent.yellow.bolder.pressed": "--ds-background-accent-yellow-bolder-pressed",
    "color.background.accent.green.subtlest": "--ds-background-accent-green-subtlest",
    "color.background.accent.green.subtlest.hovered": "--ds-background-accent-green-subtlest-hovered",
    "color.background.accent.green.subtlest.pressed": "--ds-background-accent-green-subtlest-pressed",
    "color.background.accent.green.subtler": "--ds-background-accent-green-subtler",
    "color.background.accent.green.subtler.hovered": "--ds-background-accent-green-subtler-hovered",
    "color.background.accent.green.subtler.pressed": "--ds-background-accent-green-subtler-pressed",
    "color.background.accent.green.subtle": "--ds-background-accent-green-subtle",
    "color.background.accent.green.subtle.hovered": "--ds-background-accent-green-subtle-hovered",
    "color.background.accent.green.subtle.pressed": "--ds-background-accent-green-subtle-pressed",
    "color.background.accent.green.bolder": "--ds-background-accent-green-bolder",
    "color.background.accent.green.bolder.hovered": "--ds-background-accent-green-bolder-hovered",
    "color.background.accent.green.bolder.pressed": "--ds-background-accent-green-bolder-pressed",
    "color.background.accent.teal.subtlest": "--ds-background-accent-teal-subtlest",
    "color.background.accent.teal.subtlest.hovered": "--ds-background-accent-teal-subtlest-hovered",
    "color.background.accent.teal.subtlest.pressed": "--ds-background-accent-teal-subtlest-pressed",
    "color.background.accent.teal.subtler": "--ds-background-accent-teal-subtler",
    "color.background.accent.teal.subtler.hovered": "--ds-background-accent-teal-subtler-hovered",
    "color.background.accent.teal.subtler.pressed": "--ds-background-accent-teal-subtler-pressed",
    "color.background.accent.teal.subtle": "--ds-background-accent-teal-subtle",
    "color.background.accent.teal.subtle.hovered": "--ds-background-accent-teal-subtle-hovered",
    "color.background.accent.teal.subtle.pressed": "--ds-background-accent-teal-subtle-pressed",
    "color.background.accent.teal.bolder": "--ds-background-accent-teal-bolder",
    "color.background.accent.teal.bolder.hovered": "--ds-background-accent-teal-bolder-hovered",
    "color.background.accent.teal.bolder.pressed": "--ds-background-accent-teal-bolder-pressed",
    "color.background.accent.blue.subtlest": "--ds-background-accent-blue-subtlest",
    "color.background.accent.blue.subtlest.hovered": "--ds-background-accent-blue-subtlest-hovered",
    "color.background.accent.blue.subtlest.pressed": "--ds-background-accent-blue-subtlest-pressed",
    "color.background.accent.blue.subtler": "--ds-background-accent-blue-subtler",
    "color.background.accent.blue.subtler.hovered": "--ds-background-accent-blue-subtler-hovered",
    "color.background.accent.blue.subtler.pressed": "--ds-background-accent-blue-subtler-pressed",
    "color.background.accent.blue.subtle": "--ds-background-accent-blue-subtle",
    "color.background.accent.blue.subtle.hovered": "--ds-background-accent-blue-subtle-hovered",
    "color.background.accent.blue.subtle.pressed": "--ds-background-accent-blue-subtle-pressed",
    "color.background.accent.blue.bolder": "--ds-background-accent-blue-bolder",
    "color.background.accent.blue.bolder.hovered": "--ds-background-accent-blue-bolder-hovered",
    "color.background.accent.blue.bolder.pressed": "--ds-background-accent-blue-bolder-pressed",
    "color.background.accent.purple.subtlest": "--ds-background-accent-purple-subtlest",
    "color.background.accent.purple.subtlest.hovered": "--ds-background-accent-purple-subtlest-hovered",
    "color.background.accent.purple.subtlest.pressed": "--ds-background-accent-purple-subtlest-pressed",
    "color.background.accent.purple.subtler": "--ds-background-accent-purple-subtler",
    "color.background.accent.purple.subtler.hovered": "--ds-background-accent-purple-subtler-hovered",
    "color.background.accent.purple.subtler.pressed": "--ds-background-accent-purple-subtler-pressed",
    "color.background.accent.purple.subtle": "--ds-background-accent-purple-subtle",
    "color.background.accent.purple.subtle.hovered": "--ds-background-accent-purple-subtle-hovered",
    "color.background.accent.purple.subtle.pressed": "--ds-background-accent-purple-subtle-pressed",
    "color.background.accent.purple.bolder": "--ds-background-accent-purple-bolder",
    "color.background.accent.purple.bolder.hovered": "--ds-background-accent-purple-bolder-hovered",
    "color.background.accent.purple.bolder.pressed": "--ds-background-accent-purple-bolder-pressed",
    "color.background.accent.magenta.subtlest": "--ds-background-accent-magenta-subtlest",
    "color.background.accent.magenta.subtlest.hovered": "--ds-background-accent-magenta-subtlest-hovered",
    "color.background.accent.magenta.subtlest.pressed": "--ds-background-accent-magenta-subtlest-pressed",
    "color.background.accent.magenta.subtler": "--ds-background-accent-magenta-subtler",
    "color.background.accent.magenta.subtler.hovered": "--ds-background-accent-magenta-subtler-hovered",
    "color.background.accent.magenta.subtler.pressed": "--ds-background-accent-magenta-subtler-pressed",
    "color.background.accent.magenta.subtle": "--ds-background-accent-magenta-subtle",
    "color.background.accent.magenta.subtle.hovered": "--ds-background-accent-magenta-subtle-hovered",
    "color.background.accent.magenta.subtle.pressed": "--ds-background-accent-magenta-subtle-pressed",
    "color.background.accent.magenta.bolder": "--ds-background-accent-magenta-bolder",
    "color.background.accent.magenta.bolder.hovered": "--ds-background-accent-magenta-bolder-hovered",
    "color.background.accent.magenta.bolder.pressed": "--ds-background-accent-magenta-bolder-pressed",
    "color.background.accent.gray.subtlest": "--ds-background-accent-gray-subtlest",
    "color.background.accent.gray.subtlest.hovered": "--ds-background-accent-gray-subtlest-hovered",
    "color.background.accent.gray.subtlest.pressed": "--ds-background-accent-gray-subtlest-pressed",
    "color.background.accent.gray.subtler": "--ds-background-accent-gray-subtler",
    "color.background.accent.gray.subtler.hovered": "--ds-background-accent-gray-subtler-hovered",
    "color.background.accent.gray.subtler.pressed": "--ds-background-accent-gray-subtler-pressed",
    "color.background.accent.gray.subtle": "--ds-background-accent-gray-subtle",
    "color.background.accent.gray.subtle.hovered": "--ds-background-accent-gray-subtle-hovered",
    "color.background.accent.gray.subtle.pressed": "--ds-background-accent-gray-subtle-pressed",
    "color.background.accent.gray.bolder": "--ds-background-accent-gray-bolder",
    "color.background.accent.gray.bolder.hovered": "--ds-background-accent-gray-bolder-hovered",
    "color.background.accent.gray.bolder.pressed": "--ds-background-accent-gray-bolder-pressed",
    "color.background.disabled": "--ds-background-disabled",
    "color.background.input": "--ds-background-input",
    "color.background.input.hovered": "--ds-background-input-hovered",
    "color.background.input.pressed": "--ds-background-input-pressed",
    "color.background.inverse.subtle": "--ds-background-inverse-subtle",
    "color.background.inverse.subtle.hovered": "--ds-background-inverse-subtle-hovered",
    "color.background.inverse.subtle.pressed": "--ds-background-inverse-subtle-pressed",
    "color.background.neutral": "--ds-background-neutral",
    "color.background.neutral.hovered": "--ds-background-neutral-hovered",
    "color.background.neutral.pressed": "--ds-background-neutral-pressed",
    "color.background.neutral.subtle": "--ds-background-neutral-subtle",
    "color.background.neutral.subtle.hovered": "--ds-background-neutral-subtle-hovered",
    "color.background.neutral.subtle.pressed": "--ds-background-neutral-subtle-pressed",
    "color.background.neutral.bold": "--ds-background-neutral-bold",
    "color.background.neutral.bold.hovered": "--ds-background-neutral-bold-hovered",
    "color.background.neutral.bold.pressed": "--ds-background-neutral-bold-pressed",
    "color.background.selected": "--ds-background-selected",
    "color.background.selected.hovered": "--ds-background-selected-hovered",
    "color.background.selected.pressed": "--ds-background-selected-pressed",
    "color.background.selected.bold": "--ds-background-selected-bold",
    "color.background.selected.bold.hovered": "--ds-background-selected-bold-hovered",
    "color.background.selected.bold.pressed": "--ds-background-selected-bold-pressed",
    "color.background.brand.subtlest": "--ds-background-brand-subtlest",
    "color.background.brand.subtlest.hovered": "--ds-background-brand-subtlest-hovered",
    "color.background.brand.subtlest.pressed": "--ds-background-brand-subtlest-pressed",
    "color.background.brand.bold": "--ds-background-brand-bold",
    "color.background.brand.bold.hovered": "--ds-background-brand-bold-hovered",
    "color.background.brand.bold.pressed": "--ds-background-brand-bold-pressed",
    "color.background.brand.boldest": "--ds-background-brand-boldest",
    "color.background.brand.boldest.hovered": "--ds-background-brand-boldest-hovered",
    "color.background.brand.boldest.pressed": "--ds-background-brand-boldest-pressed",
    "color.background.danger": "--ds-background-danger",
    "color.background.danger.hovered": "--ds-background-danger-hovered",
    "color.background.danger.pressed": "--ds-background-danger-pressed",
    "color.background.danger.bold": "--ds-background-danger-bold",
    "color.background.danger.bold.hovered": "--ds-background-danger-bold-hovered",
    "color.background.danger.bold.pressed": "--ds-background-danger-bold-pressed",
    "color.background.warning": "--ds-background-warning",
    "color.background.warning.hovered": "--ds-background-warning-hovered",
    "color.background.warning.pressed": "--ds-background-warning-pressed",
    "color.background.warning.bold": "--ds-background-warning-bold",
    "color.background.warning.bold.hovered": "--ds-background-warning-bold-hovered",
    "color.background.warning.bold.pressed": "--ds-background-warning-bold-pressed",
    "color.background.success": "--ds-background-success",
    "color.background.success.hovered": "--ds-background-success-hovered",
    "color.background.success.pressed": "--ds-background-success-pressed",
    "color.background.success.bold": "--ds-background-success-bold",
    "color.background.success.bold.hovered": "--ds-background-success-bold-hovered",
    "color.background.success.bold.pressed": "--ds-background-success-bold-pressed",
    "color.background.discovery": "--ds-background-discovery",
    "color.background.discovery.hovered": "--ds-background-discovery-hovered",
    "color.background.discovery.pressed": "--ds-background-discovery-pressed",
    "color.background.discovery.bold": "--ds-background-discovery-bold",
    "color.background.discovery.bold.hovered": "--ds-background-discovery-bold-hovered",
    "color.background.discovery.bold.pressed": "--ds-background-discovery-bold-pressed",
    "color.background.information": "--ds-background-information",
    "color.background.information.hovered": "--ds-background-information-hovered",
    "color.background.information.pressed": "--ds-background-information-pressed",
    "color.background.information.bold": "--ds-background-information-bold",
    "color.background.information.bold.hovered": "--ds-background-information-bold-hovered",
    "color.background.information.bold.pressed": "--ds-background-information-bold-pressed",
    "color.blanket": "--ds-blanket",
    "color.blanket.selected": "--ds-blanket-selected",
    "color.blanket.danger": "--ds-blanket-danger",
    "color.interaction.hovered": "--ds-interaction-hovered",
    "color.interaction.pressed": "--ds-interaction-pressed",
    "color.skeleton": "--ds-skeleton",
    "color.skeleton.subtle": "--ds-skeleton-subtle",
    "color.chart.categorical.1": "--ds-chart-categorical-1",
    "color.chart.categorical.1.hovered": "--ds-chart-categorical-1-hovered",
    "color.chart.categorical.2": "--ds-chart-categorical-2",
    "color.chart.categorical.2.hovered": "--ds-chart-categorical-2-hovered",
    "color.chart.categorical.3": "--ds-chart-categorical-3",
    "color.chart.categorical.3.hovered": "--ds-chart-categorical-3-hovered",
    "color.chart.categorical.4": "--ds-chart-categorical-4",
    "color.chart.categorical.4.hovered": "--ds-chart-categorical-4-hovered",
    "color.chart.categorical.5": "--ds-chart-categorical-5",
    "color.chart.categorical.5.hovered": "--ds-chart-categorical-5-hovered",
    "color.chart.categorical.6": "--ds-chart-categorical-6",
    "color.chart.categorical.6.hovered": "--ds-chart-categorical-6-hovered",
    "color.chart.categorical.7": "--ds-chart-categorical-7",
    "color.chart.categorical.7.hovered": "--ds-chart-categorical-7-hovered",
    "color.chart.categorical.8": "--ds-chart-categorical-8",
    "color.chart.categorical.8.hovered": "--ds-chart-categorical-8-hovered",
    "color.chart.lime.bold": "--ds-chart-lime-bold",
    "color.chart.lime.bold.hovered": "--ds-chart-lime-bold-hovered",
    "color.chart.lime.bolder": "--ds-chart-lime-bolder",
    "color.chart.lime.bolder.hovered": "--ds-chart-lime-bolder-hovered",
    "color.chart.lime.boldest": "--ds-chart-lime-boldest",
    "color.chart.lime.boldest.hovered": "--ds-chart-lime-boldest-hovered",
    "color.chart.neutral": "--ds-chart-neutral",
    "color.chart.neutral.hovered": "--ds-chart-neutral-hovered",
    "color.chart.red.bold": "--ds-chart-red-bold",
    "color.chart.red.bold.hovered": "--ds-chart-red-bold-hovered",
    "color.chart.red.bolder": "--ds-chart-red-bolder",
    "color.chart.red.bolder.hovered": "--ds-chart-red-bolder-hovered",
    "color.chart.red.boldest": "--ds-chart-red-boldest",
    "color.chart.red.boldest.hovered": "--ds-chart-red-boldest-hovered",
    "color.chart.orange.bold": "--ds-chart-orange-bold",
    "color.chart.orange.bold.hovered": "--ds-chart-orange-bold-hovered",
    "color.chart.orange.bolder": "--ds-chart-orange-bolder",
    "color.chart.orange.bolder.hovered": "--ds-chart-orange-bolder-hovered",
    "color.chart.orange.boldest": "--ds-chart-orange-boldest",
    "color.chart.orange.boldest.hovered": "--ds-chart-orange-boldest-hovered",
    "color.chart.yellow.bold": "--ds-chart-yellow-bold",
    "color.chart.yellow.bold.hovered": "--ds-chart-yellow-bold-hovered",
    "color.chart.yellow.bolder": "--ds-chart-yellow-bolder",
    "color.chart.yellow.bolder.hovered": "--ds-chart-yellow-bolder-hovered",
    "color.chart.yellow.boldest": "--ds-chart-yellow-boldest",
    "color.chart.yellow.boldest.hovered": "--ds-chart-yellow-boldest-hovered",
    "color.chart.green.bold": "--ds-chart-green-bold",
    "color.chart.green.bold.hovered": "--ds-chart-green-bold-hovered",
    "color.chart.green.bolder": "--ds-chart-green-bolder",
    "color.chart.green.bolder.hovered": "--ds-chart-green-bolder-hovered",
    "color.chart.green.boldest": "--ds-chart-green-boldest",
    "color.chart.green.boldest.hovered": "--ds-chart-green-boldest-hovered",
    "color.chart.teal.bold": "--ds-chart-teal-bold",
    "color.chart.teal.bold.hovered": "--ds-chart-teal-bold-hovered",
    "color.chart.teal.bolder": "--ds-chart-teal-bolder",
    "color.chart.teal.bolder.hovered": "--ds-chart-teal-bolder-hovered",
    "color.chart.teal.boldest": "--ds-chart-teal-boldest",
    "color.chart.teal.boldest.hovered": "--ds-chart-teal-boldest-hovered",
    "color.chart.blue.bold": "--ds-chart-blue-bold",
    "color.chart.blue.bold.hovered": "--ds-chart-blue-bold-hovered",
    "color.chart.blue.bolder": "--ds-chart-blue-bolder",
    "color.chart.blue.bolder.hovered": "--ds-chart-blue-bolder-hovered",
    "color.chart.blue.boldest": "--ds-chart-blue-boldest",
    "color.chart.blue.boldest.hovered": "--ds-chart-blue-boldest-hovered",
    "color.chart.purple.bold": "--ds-chart-purple-bold",
    "color.chart.purple.bold.hovered": "--ds-chart-purple-bold-hovered",
    "color.chart.purple.bolder": "--ds-chart-purple-bolder",
    "color.chart.purple.bolder.hovered": "--ds-chart-purple-bolder-hovered",
    "color.chart.purple.boldest": "--ds-chart-purple-boldest",
    "color.chart.purple.boldest.hovered": "--ds-chart-purple-boldest-hovered",
    "color.chart.magenta.bold": "--ds-chart-magenta-bold",
    "color.chart.magenta.bold.hovered": "--ds-chart-magenta-bold-hovered",
    "color.chart.magenta.bolder": "--ds-chart-magenta-bolder",
    "color.chart.magenta.bolder.hovered": "--ds-chart-magenta-bolder-hovered",
    "color.chart.magenta.boldest": "--ds-chart-magenta-boldest",
    "color.chart.magenta.boldest.hovered": "--ds-chart-magenta-boldest-hovered",
    "color.chart.gray.bold": "--ds-chart-gray-bold",
    "color.chart.gray.bold.hovered": "--ds-chart-gray-bold-hovered",
    "color.chart.gray.bolder": "--ds-chart-gray-bolder",
    "color.chart.gray.bolder.hovered": "--ds-chart-gray-bolder-hovered",
    "color.chart.gray.boldest": "--ds-chart-gray-boldest",
    "color.chart.gray.boldest.hovered": "--ds-chart-gray-boldest-hovered",
    "color.chart.brand": "--ds-chart-brand",
    "color.chart.brand.hovered": "--ds-chart-brand-hovered",
    "color.chart.danger": "--ds-chart-danger",
    "color.chart.danger.hovered": "--ds-chart-danger-hovered",
    "color.chart.danger.bold": "--ds-chart-danger-bold",
    "color.chart.danger.bold.hovered": "--ds-chart-danger-bold-hovered",
    "color.chart.warning": "--ds-chart-warning",
    "color.chart.warning.hovered": "--ds-chart-warning-hovered",
    "color.chart.warning.bold": "--ds-chart-warning-bold",
    "color.chart.warning.bold.hovered": "--ds-chart-warning-bold-hovered",
    "color.chart.success": "--ds-chart-success",
    "color.chart.success.hovered": "--ds-chart-success-hovered",
    "color.chart.success.bold": "--ds-chart-success-bold",
    "color.chart.success.bold.hovered": "--ds-chart-success-bold-hovered",
    "color.chart.discovery": "--ds-chart-discovery",
    "color.chart.discovery.hovered": "--ds-chart-discovery-hovered",
    "color.chart.discovery.bold": "--ds-chart-discovery-bold",
    "color.chart.discovery.bold.hovered": "--ds-chart-discovery-bold-hovered",
    "color.chart.information": "--ds-chart-information",
    "color.chart.information.hovered": "--ds-chart-information-hovered",
    "color.chart.information.bold": "--ds-chart-information-bold",
    "color.chart.information.bold.hovered": "--ds-chart-information-bold-hovered",
    "elevation.surface": "--ds-surface",
    "elevation.surface.hovered": "--ds-surface-hovered",
    "elevation.surface.pressed": "--ds-surface-pressed",
    "elevation.surface.overlay": "--ds-surface-overlay",
    "elevation.surface.overlay.hovered": "--ds-surface-overlay-hovered",
    "elevation.surface.overlay.pressed": "--ds-surface-overlay-pressed",
    "elevation.surface.raised": "--ds-surface-raised",
    "elevation.surface.raised.hovered": "--ds-surface-raised-hovered",
    "elevation.surface.raised.pressed": "--ds-surface-raised-pressed",
    "elevation.surface.sunken": "--ds-surface-sunken",
    "elevation.shadow.overflow": "--ds-shadow-overflow",
    "elevation.shadow.overflow.perimeter": "--ds-shadow-overflow-perimeter",
    "elevation.shadow.overflow.spread": "--ds-shadow-overflow-spread",
    "elevation.shadow.overlay": "--ds-shadow-overlay",
    "elevation.shadow.raised": "--ds-shadow-raised",
    "opacity.disabled": "--ds-opacity-disabled",
    "opacity.loading": "--ds-opacity-loading",
    "utility.UNSAFE.textTransformUppercase": "--ds-UNSAFE-textTransformUppercase",
    "utility.UNSAFE.transparent": "--ds-UNSAFE-transparent",
    "utility.elevation.surface.current": "--ds-elevation-surface-current",
    "border.radius.050": "--ds-border-radius-050",
    "border.radius": "--ds-border-radius",
    "border.radius.100": "--ds-border-radius-100",
    "border.radius.200": "--ds-border-radius-200",
    "border.radius.300": "--ds-border-radius-300",
    "border.radius.400": "--ds-border-radius-400",
    "border.radius.circle": "--ds-border-radius-circle",
    "border.width": "--ds-border-width",
    "border.width.0": "--ds-border-width-0",
    "border.width.indicator": "--ds-border-width-indicator",
    "border.width.outline": "--ds-border-width-outline",
    "space.0": "--ds-space-0",
    "space.025": "--ds-space-025",
    "space.050": "--ds-space-050",
    "space.075": "--ds-space-075",
    "space.100": "--ds-space-100",
    "space.150": "--ds-space-150",
    "space.200": "--ds-space-200",
    "space.250": "--ds-space-250",
    "space.300": "--ds-space-300",
    "space.400": "--ds-space-400",
    "space.500": "--ds-space-500",
    "space.600": "--ds-space-600",
    "space.800": "--ds-space-800",
    "space.1000": "--ds-space-1000",
    "space.negative.025": "--ds-space-negative-025",
    "space.negative.050": "--ds-space-negative-050",
    "space.negative.075": "--ds-space-negative-075",
    "space.negative.100": "--ds-space-negative-100",
    "space.negative.150": "--ds-space-negative-150",
    "space.negative.200": "--ds-space-negative-200",
    "space.negative.250": "--ds-space-negative-250",
    "space.negative.300": "--ds-space-negative-300",
    "space.negative.400": "--ds-space-negative-400",
    "font.letterSpacing.0": "--ds-font-letterSpacing-0",
    "font.letterSpacing.100": "--ds-font-letterSpacing-100",
    "font.letterSpacing.200": "--ds-font-letterSpacing-200",
    "font.letterSpacing.300": "--ds-font-letterSpacing-300",
    "font.letterSpacing.400": "--ds-font-letterSpacing-400",
    "font.heading.xxlarge": "--ds-font-heading-xxlarge",
    "font.heading.xlarge": "--ds-font-heading-xlarge",
    "font.heading.large": "--ds-font-heading-large",
    "font.heading.medium": "--ds-font-heading-medium",
    "font.heading.small": "--ds-font-heading-small",
    "font.heading.xsmall": "--ds-font-heading-xsmall",
    "font.heading.xxsmall": "--ds-font-heading-xxsmall",
    "font.body.large": "--ds-font-body-large",
    "font.body": "--ds-font-body",
    "font.body.small": "--ds-font-body-small",
    "font.body.UNSAFE_small": "--ds-font-body-UNSAFE_small",
    "font.code": "--ds-font-code",
    "font.weight.regular": "--ds-font-weight-regular",
    "font.weight.medium": "--ds-font-weight-medium",
    "font.weight.semibold": "--ds-font-weight-semibold",
    "font.weight.bold": "--ds-font-weight-bold",
    "font.family.heading": "--ds-font-family-heading",
    "font.family.body": "--ds-font-family-body",
    "font.family.code": "--ds-font-family-code",
    "font.family.monospace": "--ds-font-family-monospace",
    "font.family.sans": "--ds-font-family-sans",
    "font.family.brand.heading": "--ds-font-family-brand-heading",
    "font.family.brand.body": "--ds-font-family-brand-body",
    "font.size.050": "--ds-font-size-050",
    "font.size.075": "--ds-font-size-075",
    "font.size.100": "--ds-font-size-100",
    "font.size.200": "--ds-font-size-200",
    "font.size.300": "--ds-font-size-300",
    "font.size.400": "--ds-font-size-400",
    "font.size.500": "--ds-font-size-500",
    "font.size.600": "--ds-font-size-600",
    "font.lineHeight.1": "--ds-font-lineHeight-1",
    "font.lineHeight.100": "--ds-font-lineHeight-100",
    "font.lineHeight.200": "--ds-font-lineHeight-200",
    "font.lineHeight.300": "--ds-font-lineHeight-300",
    "font.lineHeight.400": "--ds-font-lineHeight-400",
    "font.lineHeight.500": "--ds-font-lineHeight-500",
    "font.lineHeight.600": "--ds-font-lineHeight-600"
};
var $388579911b54e526$export$2e2bcd8739ae039 = $388579911b54e526$var$tokens;

});


parcelRegister("cBICc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b333888b044ba93e$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $5OBDJ = parcelRequire("5OBDJ");

var $e1SsV = parcelRequire("e1SsV");

var $97YIy = parcelRequire("97YIy");

var $aP6k3 = parcelRequire("aP6k3");

var $66yQZ = parcelRequire("66yQZ");
const $b333888b044ba93e$var$StyledFillScreen = ({ scrollDistance: scrollDistance, style: style, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
        style: {
            height: "100vh",
            left: 0,
            overflowY: "auto",
            position: "absolute",
            top: `${scrollDistance}px`,
            width: "100%",
            zIndex: (0, $aP6k3.layers).modal(),
            ...style
        }
    }, children);
const $b333888b044ba93e$var$Content = ({ style: style, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
        style: {
            position: "fixed",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flex: 1,
            height: "100vh",
            width: "100%",
            pointerEvents: "none",
            zIndex: (0, $aP6k3.layers).modal(),
            ...style
        },
        role: "dialog",
        tabIndex: -1
    }, children);
var $b333888b044ba93e$export$2e2bcd8739ae039;
$b333888b044ba93e$export$2e2bcd8739ae039 = class DialogChromeless extends (0, $9nHZC.Component) {
    constructor(...args){
        super(...args);
        this.componentIsMounted = void 0;
        this.escapeIsHeldDown = void 0;
        this.handleKeyUp = ()=>{
            this.escapeIsHeldDown = false;
        };
        this.handleKeyDown = (event)=>{
            const { onClose: onClose, shouldCloseOnEscapePress: shouldCloseOnEscapePress } = this.props;
            // avoid consumers accidently closing multiple modals if they hold escape.
            if (this.escapeIsHeldDown) return;
            if (event.key === "Escape") this.escapeIsHeldDown = true;
            // only the foremost modal should be interactive.
            if (!this.componentIsMounted) return;
            switch(event.key){
                case "Escape":
                    if (shouldCloseOnEscapePress) onClose(event);
                    break;
                default:
            }
        };
    }
    componentDidMount() {
        this.componentIsMounted = true;
        // @ts-ignore fix handleKeyDown return type
        document.addEventListener("keydown", this.handleKeyDown, false);
        document.addEventListener("keyup", this.handleKeyUp, false);
        document.body.style.overflow = "hidden";
    }
    componentDidUpdate() {
        if (this.props.isOpen) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "unset";
    }
    componentWillUnmount() {
        this.componentIsMounted = false;
        // @ts-ignore fix handleKeyDown return type
        document.removeEventListener("keydown", this.handleKeyDown, false);
        document.removeEventListener("keyup", this.handleKeyUp, false);
        document.body.style.overflow = "unset";
    }
    render() {
        const { isOpen: isOpen, onClose: onClose, children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $97YIy.default), {
            zIndex: (0, $aP6k3.layers).modal()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $66yQZ.Animation), {
            in: isOpen
        }, ({ fade: fade, slide: slide })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($b333888b044ba93e$var$StyledFillScreen, {
                style: fade,
                scrollDistance: 0
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $e1SsV.default), {
                enabled: isOpen,
                autoFocus: false
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($b333888b044ba93e$var$Content, {
                style: slide
            }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5OBDJ.default), {
                isTinted: true,
                onBlanketClicked: onClose
            }))));
    }
};

});
parcelRegister("e1SsV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a36b68628b3cb208$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");

var $GhaZL = parcelRequire("GhaZL");
function $a36b68628b3cb208$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a36b68628b3cb208$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $a36b68628b3cb208$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/* eslint-disable react/sort-comp */ var $a36b68628b3cb208$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(FocusLock, _Component);
    var _super = $a36b68628b3cb208$var$_createSuper(FocusLock);
    function FocusLock() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, FocusLock);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "ariaHiddenNode", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "initFromProps", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "teardownFromProps", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "initialise", function() {
            var autoFocus = _this.props.autoFocus; // set the element to hide from assistive technology
            _this.ariaHiddenNode = _this.props.ariaHiddenNode || _this.context.ariaHiddenNode; // accessible `popup` content
            if (_this.ariaHiddenNode) _this.ariaHiddenNode.setAttribute("aria-hidden", "");
            if (typeof autoFocus === "function") {
                var elem = autoFocus();
                if (elem && elem.focus) elem.focus();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "teardown", function() {
            if (_this.ariaHiddenNode) _this.ariaHiddenNode.removeAttribute("aria-hidden");
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(FocusLock, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props = this.props, enabled = _this$props.enabled, autoFocus = _this$props.autoFocus;
                if (typeof autoFocus === "function") // eslint-disable-next-line no-console
                console.warn('@atlaskit/layer-manager: Passing a function as autoFocus in FocusLock is deprecated. Please see "Auto focusing an element" in https://atlaskit.atlassian.com/packages/design-system/layer-manager');
                if (enabled) this.initialise();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!this.initFromProps && !this.teardownFromProps) this.teardown();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.props.enabled && this.props.enabled !== prevProps.enabled) {
                    this.initFromProps = true;
                    this.initialise();
                }
                if (!this.props.enabled && this.props.enabled !== prevProps.enabled) {
                    this.teardownFromProps = true;
                    this.teardown();
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, enabled = _this$props2.enabled, autoFocus = _this$props2.autoFocus, returnFocus = _this$props2.returnFocus;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $GhaZL.default), {
                    disabled: !enabled,
                    autoFocus: !!autoFocus,
                    returnFocus: returnFocus
                }, this.props.children);
            }
        }
    ]);
    return FocusLock;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($a36b68628b3cb208$export$2e2bcd8739ae039, "contextTypes", {
    /** available when invoked within @atlaskit/layer-manager */ ariaHiddenNode: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).object
});
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($a36b68628b3cb208$export$2e2bcd8739ae039, "defaultProps", {
    autoFocus: true,
    enabled: true,
    returnFocus: true
});

});
parcelRegister("GhaZL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07f13f38eefb7786$export$2e2bcd8739ae039; });

var $6ru14 = parcelRequire("6ru14");




var $07f13f38eefb7786$export$2e2bcd8739ae039 = (0, $6ru14.default);

});
parcelRegister("6ru14", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b0c8c4ed4f8b5b5$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $2mGxr = parcelRequire("2mGxr");

var $lwdaQ = parcelRequire("lwdaQ");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");


var $gcBB8 = parcelRequire("gcBB8");

var $hF8wW = parcelRequire("hF8wW");

var $l4Iz0 = parcelRequire("l4Iz0");
var $4b0c8c4ed4f8b5b5$var$RenderChildren = function RenderChildren(_ref) {
    var children = _ref.children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", null, children);
};
$4b0c8c4ed4f8b5b5$var$RenderChildren.propTypes = {};
var $4b0c8c4ed4f8b5b5$var$Fragment = (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment ? (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment : $4b0c8c4ed4f8b5b5$var$RenderChildren;
var $4b0c8c4ed4f8b5b5$var$emptyArray = [];
var $4b0c8c4ed4f8b5b5$var$FocusLock = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($2mGxr)))(FocusLock, _Component);
    function FocusLock() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _Component.call.apply(_Component, [
            this
        ].concat(args)) || this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this)), "state", {
            observed: undefined
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this)), "onActivation", function() {
            _this.originalFocusedElement = _this.originalFocusedElement || document && document.activeElement;
            if (_this.state.observed && _this.props.onActivation) _this.props.onActivation(_this.state.observed);
            _this.isActive = true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this)), "onDeactivation", function() {
            _this.isActive = false;
            if (_this.props.returnFocus && _this.originalFocusedElement && _this.originalFocusedElement.focus) {
                _this.originalFocusedElement.focus();
                _this.originalFocusedElement = null;
            }
            if (_this.props.onDeactivation) _this.props.onDeactivation(_this.state.observed);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this)), "onFocus", function(event) {
            if (_this.isActive) (0, $hF8wW.onFocus)(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this)), "onBlur", (0, $hF8wW.onBlur));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this)), "setObserveNode", function(observed) {
            if (_this.state.observed !== observed) _this.setState({
                observed: observed
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this)), "isActive", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this)), "originalFocusedElement", null);
        return _this;
    }
    var _proto = FocusLock.prototype;
    _proto.render = function render() {
        var _extends2;
        var _this$props = this.props, children = _this$props.children, disabled = _this$props.disabled, noFocusGuards = _this$props.noFocusGuards, persistentFocus = _this$props.persistentFocus, autoFocus = _this$props.autoFocus, allowTextSelection = _this$props.allowTextSelection, group = _this$props.group, className = _this$props.className, whiteList = _this$props.whiteList, _this$props$shards = _this$props.shards, shards = _this$props$shards === void 0 ? $4b0c8c4ed4f8b5b5$var$emptyArray : _this$props$shards, _this$props$as = _this$props.as, Container = _this$props$as === void 0 ? "div" : _this$props$as, _this$props$lockProps = _this$props.lockProps, containerProps = _this$props$lockProps === void 0 ? {} : _this$props$lockProps;
        var observed = this.state.observed;
        var lockProps = (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((_extends2 = {}, _extends2[(0, $gcBB8).FOCUS_DISABLED] = disabled && "disabled", _extends2[(0, $gcBB8).FOCUS_GROUP] = group, _extends2), containerProps);
        var hasLeadingGuards = noFocusGuards !== true;
        var hasTailingGuards = hasLeadingGuards && noFocusGuards !== "tail";
        return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($4b0c8c4ed4f8b5b5$var$Fragment, null, hasLeadingGuards && [
            (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
                key: "guard-first",
                "data-focus-guard": true,
                tabIndex: disabled ? -1 : 0,
                style: (0, $l4Iz0.hiddenGuard)
            }),
            (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
                key: "guard-nearest",
                "data-focus-guard": true,
                tabIndex: disabled ? -1 : 1,
                style: (0, $l4Iz0.hiddenGuard)
            })
        ], (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Container, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            ref: this.setObserveNode
        }, lockProps, {
            className: className,
            onBlur: this.onBlur,
            onFocus: this.onFocus
        }), (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $hF8wW.default), {
            observed: observed,
            disabled: disabled,
            persistentFocus: persistentFocus,
            autoFocus: autoFocus,
            whiteList: whiteList,
            shards: shards,
            onActivation: this.onActivation,
            onDeactivation: this.onDeactivation
        }), children), hasTailingGuards && (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $l4Iz0.hiddenGuard)
        }));
    };
    return FocusLock;
}((0, $9nHZC.Component));
$4b0c8c4ed4f8b5b5$var$FocusLock.propTypes = {};
$4b0c8c4ed4f8b5b5$var$FocusLock.defaultProps = {
    disabled: false,
    returnFocus: false,
    noFocusGuards: false,
    autoFocus: true,
    persistentFocus: false,
    allowTextSelection: undefined,
    group: undefined,
    className: undefined,
    whiteList: undefined,
    shards: undefined,
    as: "div",
    lockProps: {},
    onActivation: undefined,
    onDeactivation: undefined
};
var $4b0c8c4ed4f8b5b5$export$2e2bcd8739ae039 = $4b0c8c4ed4f8b5b5$var$FocusLock;

});
parcelRegister("2mGxr", function(module, exports) {

var $ivwvu = parcelRequire("ivwvu");
function $1b8ea212454a9e7d$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $ivwvu(t, o);
}
module.exports = $1b8ea212454a9e7d$var$_inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gcBB8", function(module, exports) {

$parcel$export(module.exports, "FOCUS_GROUP", function () { return $bcbaee80bb13c240$export$4f9a06cb7441a087; });
$parcel$export(module.exports, "FOCUS_DISABLED", function () { return $bcbaee80bb13c240$export$aeda8252e54b50f7; });
$parcel$export(module.exports, "FOCUS_ALLOW", function () { return $bcbaee80bb13c240$export$54ecf528c58f9ef6; });
$parcel$export(module.exports, "FOCUS_AUTO", function () { return $bcbaee80bb13c240$export$70e9b4a1820af101; });
var $bcbaee80bb13c240$export$4f9a06cb7441a087 = "data-focus-lock";
var $bcbaee80bb13c240$export$aeda8252e54b50f7 = "data-focus-lock-disabled";
var $bcbaee80bb13c240$export$54ecf528c58f9ef6 = "data-no-focus-lock";
var $bcbaee80bb13c240$export$70e9b4a1820af101 = "data-autofocus-inside";

});

parcelRegister("hF8wW", function(module, exports) {

$parcel$export(module.exports, "onBlur", function () { return $cdbce1f5440e7673$export$5e446bc31724fca4; });
$parcel$export(module.exports, "onFocus", function () { return $cdbce1f5440e7673$export$ecf9bf35ad97eb74; });
$parcel$export(module.exports, "default", function () { return $cdbce1f5440e7673$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");


var $4EEXD = parcelRequire("4EEXD");

var $gwJhT = parcelRequire("gwJhT");
var $fjmo7 = parcelRequire("fjmo7");
var $1m3Xi = parcelRequire("1m3Xi");
var $4bryd = parcelRequire("4bryd");

var $d7nEE = parcelRequire("d7nEE");
var $cdbce1f5440e7673$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $cdbce1f5440e7673$var$isFreeFocus = function isFreeFocus() {
    return $cdbce1f5440e7673$var$focusOnBody() || (0, $1m3Xi.default)();
};
var $cdbce1f5440e7673$var$lastActiveTrap = null;
var $cdbce1f5440e7673$var$lastActiveFocus = null;
var $cdbce1f5440e7673$var$lastPortaledElement = null;
var $cdbce1f5440e7673$var$focusWasOutsideWindow = false;
var $cdbce1f5440e7673$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $cdbce1f5440e7673$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($cdbce1f5440e7673$var$lastActiveTrap.whiteList || $cdbce1f5440e7673$var$defaultWhitelist)(activeElement);
};
var $cdbce1f5440e7673$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $cdbce1f5440e7673$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $cdbce1f5440e7673$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $cdbce1f5440e7673$var$lastPortaledElement && $cdbce1f5440e7673$var$lastPortaledElement.portaledElement === element;
};
function $cdbce1f5440e7673$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) // we will tab to the next element
            return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $cdbce1f5440e7673$var$extractRef = function extractRef(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $cdbce1f5440e7673$var$activateTrap = function activateTrap() {
    var result = false;
    if ($cdbce1f5440e7673$var$lastActiveTrap) {
        var _lastActiveTrap = $cdbce1f5440e7673$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards;
        var workingNode = observed || $cdbce1f5440e7673$var$lastPortaledElement && $cdbce1f5440e7673$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map($cdbce1f5440e7673$var$extractRef).filter(Boolean));
            if (!activeElement || $cdbce1f5440e7673$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $cdbce1f5440e7673$var$focusWasOutsideWindow || !$cdbce1f5440e7673$var$isFreeFocus() || !$cdbce1f5440e7673$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $fjmo7.default)(workingArea) || $cdbce1f5440e7673$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$cdbce1f5440e7673$var$lastActiveFocus && activeElement && !autoFocus) {
                            activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $gwJhT.default)(workingArea, $cdbce1f5440e7673$var$lastActiveFocus);
                            $cdbce1f5440e7673$var$lastPortaledElement = {};
                        }
                    }
                    $cdbce1f5440e7673$var$focusWasOutsideWindow = false;
                    $cdbce1f5440e7673$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $4bryd.getFocusabledIn)(workingArea);
                var focusedItem = allNodes.find(function(_ref) {
                    var node = _ref.node;
                    return node === newActiveElement;
                });
                if (focusedItem) {
                    // remove old focus
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute("tabIndex");
                    });
                    var focusedIndex = allNodes.indexOf(focusedItem);
                    $cdbce1f5440e7673$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $cdbce1f5440e7673$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $cdbce1f5440e7673$var$onTrap = function onTrap(event) {
    if ($cdbce1f5440e7673$var$activateTrap() && event) {
        // prevent scroll jump
        event.stopPropagation();
        event.preventDefault();
    }
};
var $cdbce1f5440e7673$export$5e446bc31724fca4 = function onBlur() {
    return (0, $d7nEE.deferAction)($cdbce1f5440e7673$var$activateTrap);
};
var $cdbce1f5440e7673$export$ecf9bf35ad97eb74 = function onFocus(event) {
    // detect portal
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $cdbce1f5440e7673$var$recordPortal(currentNode, source);
};
var $cdbce1f5440e7673$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $cdbce1f5440e7673$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
        onBlur: $cdbce1f5440e7673$export$5e446bc31724fca4,
        onFocus: $cdbce1f5440e7673$export$ecf9bf35ad97eb74
    }, children);
};
$cdbce1f5440e7673$var$FocusTrap.propTypes = {};
var $cdbce1f5440e7673$var$onWindowBlur = function onWindowBlur() {
    $cdbce1f5440e7673$var$focusWasOutsideWindow = true;
};
var $cdbce1f5440e7673$var$attachHandler = function attachHandler() {
    document.addEventListener("focusin", $cdbce1f5440e7673$var$onTrap, true);
    document.addEventListener("focusout", $cdbce1f5440e7673$export$5e446bc31724fca4);
    window.addEventListener("blur", $cdbce1f5440e7673$var$onWindowBlur);
};
var $cdbce1f5440e7673$var$detachHandler = function detachHandler() {
    document.removeEventListener("focusin", $cdbce1f5440e7673$var$onTrap, true);
    document.removeEventListener("focusout", $cdbce1f5440e7673$export$5e446bc31724fca4);
    window.removeEventListener("blur", $cdbce1f5440e7673$var$onWindowBlur);
};
function $cdbce1f5440e7673$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    }).slice(-1)[0];
}
function $cdbce1f5440e7673$var$handleStateChangeOnClient(trap) {
    if (trap && !$cdbce1f5440e7673$var$lastActiveTrap) $cdbce1f5440e7673$var$attachHandler();
    var lastTrap = $cdbce1f5440e7673$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.onActivation === lastTrap.onActivation;
    $cdbce1f5440e7673$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) lastTrap.onDeactivation();
    if (trap) {
        $cdbce1f5440e7673$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation();
        $cdbce1f5440e7673$var$activateTrap(true);
        (0, $d7nEE.deferAction)($cdbce1f5440e7673$var$activateTrap);
    } else {
        $cdbce1f5440e7673$var$detachHandler();
        $cdbce1f5440e7673$var$lastActiveFocus = null;
    }
}
var $cdbce1f5440e7673$export$2e2bcd8739ae039 = (0, $4EEXD.default)($cdbce1f5440e7673$var$reducePropsToState, $cdbce1f5440e7673$var$handleStateChangeOnClient)($cdbce1f5440e7673$var$FocusWatcher);

});
parcelRegister("gwJhT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c082c3aa37be7fd2$export$2e2bcd8739ae039; });


var $4bryd = parcelRequire("4bryd");

var $fjmo7 = parcelRequire("fjmo7");

var $1m3Xi = parcelRequire("1m3Xi");

var $kbEQ9 = parcelRequire("kbEQ9");

var $gcBB8 = parcelRequire("gcBB8");

var $c082c3aa37be7fd2$export$2e2bcd8739ae039 = (0, $kbEQ9.default);

});
parcelRegister("4bryd", function(module, exports) {

$parcel$export(module.exports, "getFocusabledIn", function () { return $30bd8f871e8b10d6$export$30d9c643899a8835; });
$parcel$export(module.exports, "default", function () { return $30bd8f871e8b10d6$export$2e2bcd8739ae039; });

var $5gwBa = parcelRequire("5gwBa");

var $lQ4Tw = parcelRequire("lQ4Tw");

var $lbCsy = parcelRequire("lbCsy");

var $iBVMU = parcelRequire("iBVMU");
var $30bd8f871e8b10d6$var$findAutoFocused = function findAutoFocused(autoFocusables) {
    return function(node) {
        return !!node.autofocus || node.dataset && !!node.dataset.autofocus || autoFocusables.indexOf(node) >= 0;
    };
};
var $30bd8f871e8b10d6$var$isGuard = function isGuard(node) {
    return node && node.dataset && node.dataset.focusGuard;
};
var $30bd8f871e8b10d6$var$notAGuard = function notAGuard(node) {
    return !$30bd8f871e8b10d6$var$isGuard(node);
};
var $30bd8f871e8b10d6$export$65842178e9bb4205 = function newFocus(innerNodes, outerNodes, activeElement, lastNode, autoFocused) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = $30bd8f871e8b10d6$var$isGuard(activeElement);
    // focus is inside
    if (innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = outerNodes.indexOf(activeElement);
    var lastIndex = outerNodes.indexOf(lastNode || activeIndex);
    var lastNodeInside = innerNodes.indexOf(lastNode);
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var returnFirstNode = (0, $lQ4Tw.pickFocusable)(innerNodes, 0);
    var returnLastNode = (0, $lQ4Tw.pickFocusable)(innerNodes, cnt - 1);
    // new focus
    if (activeIndex === -1 || lastNodeInside === -1) return innerNodes.indexOf(autoFocused && autoFocused.length ? (0, $lQ4Tw.default)(autoFocused) : (0, $lQ4Tw.default)(innerNodes));
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(indexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};
var $30bd8f871e8b10d6$var$getTopCommonParent = function getTopCommonParent(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $iBVMU.asArray)(baseActiveElement);
    var leftEntries = (0, $iBVMU.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = null;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = (0, $5gwBa.getCommonParent)(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = (0, $5gwBa.getCommonParent)(activeElement, subEntry);
            if (common) {
                if (!topCommon || common.contains(topCommon)) topCommon = common;
                else topCommon = (0, $5gwBa.getCommonParent)(common, topCommon);
            }
        });
    });
    return topCommon;
};
var $30bd8f871e8b10d6$var$allParentAutofocusables = function allParentAutofocusables(entries) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $5gwBa.parentAutofocusables)(node));
    }, []);
};
var $30bd8f871e8b10d6$var$reorderNodes = function reorderNodes(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter(Boolean);
};
var $30bd8f871e8b10d6$export$30d9c643899a8835 = function getFocusabledIn(topNode) {
    var entries = (0, $lbCsy.default)(topNode).filter($30bd8f871e8b10d6$var$notAGuard);
    var commonParent = $30bd8f871e8b10d6$var$getTopCommonParent(topNode, topNode, entries);
    var outerNodes = (0, $5gwBa.getTabbableNodes)([
        commonParent
    ], true);
    var innerElements = (0, $5gwBa.getTabbableNodes)(entries).filter(function(_ref) {
        var node = _ref.node;
        return $30bd8f871e8b10d6$var$notAGuard(node);
    }).map(function(_ref2) {
        var node = _ref2.node;
        return node;
    });
    return outerNodes.map(function(_ref3) {
        var node = _ref3.node, index = _ref3.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: $30bd8f871e8b10d6$var$isGuard(node)
        };
    });
};
var $30bd8f871e8b10d6$var$getFocusMerge = function getFocusMerge(topNode, lastNode) {
    var activeElement = document && document.activeElement;
    var entries = (0, $lbCsy.default)(topNode).filter($30bd8f871e8b10d6$var$notAGuard);
    var commonParent = $30bd8f871e8b10d6$var$getTopCommonParent(activeElement || topNode, topNode, entries);
    var innerElements = (0, $5gwBa.getTabbableNodes)(entries).filter(function(_ref4) {
        var node = _ref4.node;
        return $30bd8f871e8b10d6$var$notAGuard(node);
    });
    if (!innerElements[0]) {
        innerElements = (0, $5gwBa.getAllTabbableNodes)(entries).filter(function(_ref5) {
            var node = _ref5.node;
            return $30bd8f871e8b10d6$var$notAGuard(node);
        });
        if (!innerElements[0]) return undefined;
    }
    var outerNodes = (0, $5gwBa.getTabbableNodes)([
        commonParent
    ]).map(function(_ref6) {
        var node = _ref6.node;
        return node;
    });
    var orderedInnerElements = $30bd8f871e8b10d6$var$reorderNodes(outerNodes, innerElements);
    var innerNodes = orderedInnerElements.map(function(_ref7) {
        var node = _ref7.node;
        return node;
    });
    var newId = $30bd8f871e8b10d6$export$65842178e9bb4205(innerNodes, outerNodes, activeElement, lastNode, innerNodes.filter($30bd8f871e8b10d6$var$findAutoFocused($30bd8f871e8b10d6$var$allParentAutofocusables(entries))));
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};
var $30bd8f871e8b10d6$export$2e2bcd8739ae039 = $30bd8f871e8b10d6$var$getFocusMerge;

});
parcelRegister("5gwBa", function(module, exports) {

$parcel$export(module.exports, "getCommonParent", function () { return $3d57bbc0b645d102$export$a08e5f53769bce53; });
$parcel$export(module.exports, "getTabbableNodes", function () { return $3d57bbc0b645d102$export$3738e313571e2ad2; });
$parcel$export(module.exports, "getAllTabbableNodes", function () { return $3d57bbc0b645d102$export$23c79be8286a3b0c; });
$parcel$export(module.exports, "parentAutofocusables", function () { return $3d57bbc0b645d102$export$dc26309a71d1ce47; });

var $60tNr = parcelRequire("60tNr");

var $inHyx = parcelRequire("inHyx");

var $iBVMU = parcelRequire("iBVMU");
var $3d57bbc0b645d102$var$isElementHidden = function isElementHidden(computedStyle) {
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue("display") === "none" || computedStyle.getPropertyValue("visibility") === "hidden";
};
var $3d57bbc0b645d102$export$795910f5f15a9633 = function isVisible(node) {
    return !node || node === document || node.nodeType === Node.DOCUMENT_NODE || !$3d57bbc0b645d102$var$isElementHidden(window.getComputedStyle(node, null)) && isVisible(node.parentNode);
};
var $3d57bbc0b645d102$export$8197b0ea56b3b055 = function notHiddenInput(node) {
    return !((node.tagName === "INPUT" || node.tagName === "BUTTON") && (node.type === "hidden" || node.disabled));
};
var $3d57bbc0b645d102$var$getParents = function getParents(node) {
    var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    parents.push(node);
    if (node.parentNode) getParents(node.parentNode, parents);
    return parents;
};
var $3d57bbc0b645d102$export$a08e5f53769bce53 = function getCommonParent(nodea, nodeb) {
    var parentsA = $3d57bbc0b645d102$var$getParents(nodea);
    var parentsB = $3d57bbc0b645d102$var$getParents(nodeb);
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $3d57bbc0b645d102$export$6266a5cd5915dc33 = function filterFocusable(nodes) {
    return (0, $iBVMU.toArray)(nodes).filter(function(node) {
        return $3d57bbc0b645d102$export$795910f5f15a9633(node);
    }).filter(function(node) {
        return $3d57bbc0b645d102$export$8197b0ea56b3b055(node);
    });
};
var $3d57bbc0b645d102$export$3738e313571e2ad2 = function getTabbableNodes(topNodes, withGuards) {
    return (0, $60tNr.orderByTabIndex)($3d57bbc0b645d102$export$6266a5cd5915dc33((0, $inHyx.getFocusables)(topNodes, withGuards)), true, withGuards);
};
var $3d57bbc0b645d102$export$23c79be8286a3b0c = function getAllTabbableNodes(topNodes) {
    return (0, $60tNr.orderByTabIndex)($3d57bbc0b645d102$export$6266a5cd5915dc33((0, $inHyx.getFocusables)(topNodes)), false);
};
var $3d57bbc0b645d102$export$dc26309a71d1ce47 = function parentAutofocusables(topNode) {
    return $3d57bbc0b645d102$export$6266a5cd5915dc33((0, $inHyx.getParentAutofocusables)(topNode));
};

});
parcelRegister("60tNr", function(module, exports) {

$parcel$export(module.exports, "orderByTabIndex", function () { return $45f9db1f2bcf82ce$export$cb40ee071f0d5226; });

var $iBVMU = parcelRequire("iBVMU");
var $45f9db1f2bcf82ce$export$350ee6c095d98996 = function tabSort(a, b) {
    var tabDiff = a.tabIndex - b.tabIndex;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!a.tabIndex) return 1;
        if (!b.tabIndex) return -1;
    }
    return tabDiff || indexDiff;
};
var $45f9db1f2bcf82ce$export$cb40ee071f0d5226 = function orderByTabIndex(nodes, filterNegative, keepGuards) {
    return (0, $iBVMU.toArray)(nodes).map(function(node, index) {
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && node.tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : node.tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($45f9db1f2bcf82ce$export$350ee6c095d98996);
};

});
parcelRegister("iBVMU", function(module, exports) {

$parcel$export(module.exports, "toArray", function () { return $d8c8822d1d080381$export$45b10814cc054894; });
$parcel$export(module.exports, "arrayFind", function () { return $d8c8822d1d080381$export$5a4621778daea27b; });
$parcel$export(module.exports, "asArray", function () { return $d8c8822d1d080381$export$75093a47a9fa838d; });
var $d8c8822d1d080381$export$45b10814cc054894 = function toArray(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $d8c8822d1d080381$export$5a4621778daea27b = function arrayFind(array, search) {
    return array.filter(function(a) {
        return a === search;
    })[0];
};
var $d8c8822d1d080381$export$75093a47a9fa838d = function asArray(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};

});


parcelRegister("inHyx", function(module, exports) {

$parcel$export(module.exports, "getFocusables", function () { return $d61c294ee2fa3203$export$f6768025e418420e; });
$parcel$export(module.exports, "getParentAutofocusables", function () { return $d61c294ee2fa3203$export$853fa94d922e78b9; });

var $gbOpO = parcelRequire("gbOpO");

var $iBVMU = parcelRequire("iBVMU");

var $gcBB8 = parcelRequire("gcBB8");
var $d61c294ee2fa3203$var$queryTabbables = (0, $gbOpO.default).join(",");
var $d61c294ee2fa3203$var$queryGuardTabbables = $d61c294ee2fa3203$var$queryTabbables + ", [data-focus-guard]";
var $d61c294ee2fa3203$export$f6768025e418420e = function getFocusables(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        return acc.concat(// add all tabbables inside
        (0, $iBVMU.toArray)(parent.querySelectorAll(withGuards ? $d61c294ee2fa3203$var$queryGuardTabbables : $d61c294ee2fa3203$var$queryTabbables)), // add if node is tabble itself
        parent.parentNode ? (0, $iBVMU.toArray)(parent.parentNode.querySelectorAll((0, $gbOpO.default).join(","))).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $d61c294ee2fa3203$export$853fa94d922e78b9 = function getParentAutofocusables(parent) {
    var parentFocus = parent.querySelectorAll("[" + (0, $gcBB8.FOCUS_AUTO) + "]");
    return (0, $iBVMU.toArray)(parentFocus).map(function(node) {
        return $d61c294ee2fa3203$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRegister("gbOpO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc94c7db818f3bc1$export$2e2bcd8739ae039; });
var $bc94c7db818f3bc1$export$2e2bcd8739ae039 = [
    "button:enabled:not([readonly])",
    "select:enabled:not([readonly])",
    "textarea:enabled:not([readonly])",
    "input:enabled:not([readonly])",
    "a[href]",
    "area[href]",
    "iframe",
    "object",
    "embed",
    "[tabindex]",
    "[contenteditable]",
    "[autofocus]"
];

});



parcelRegister("lQ4Tw", function(module, exports) {

$parcel$export(module.exports, "pickFocusable", function () { return $fe62404156885ba7$export$e06728ee87c96122; });
$parcel$export(module.exports, "default", function () { return $fe62404156885ba7$export$2e2bcd8739ae039; });
var $fe62404156885ba7$var$isRadio = function isRadio(node) {
    return node.tagName === "INPUT" && node.type === "radio";
};
var $fe62404156885ba7$var$findSelectedRadio = function findSelectedRadio(node, nodes) {
    return nodes.filter($fe62404156885ba7$var$isRadio).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $fe62404156885ba7$var$pickFirstFocus = function pickFirstFocus(nodes) {
    if (nodes[0] && nodes.length > 1) {
        if ($fe62404156885ba7$var$isRadio(nodes[0]) && nodes[0].name) return $fe62404156885ba7$var$findSelectedRadio(nodes[0], nodes);
    }
    return nodes[0];
};
var $fe62404156885ba7$export$e06728ee87c96122 = function pickFocusable(nodes, index) {
    if (nodes.length > 1) {
        if ($fe62404156885ba7$var$isRadio(nodes[index]) && nodes[index].name) return nodes.indexOf($fe62404156885ba7$var$findSelectedRadio(nodes[index], nodes));
    }
    return index;
};
var $fe62404156885ba7$export$2e2bcd8739ae039 = $fe62404156885ba7$var$pickFirstFocus;

});

parcelRegister("lbCsy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6c87556da8d8dfc$export$2e2bcd8739ae039; });

var $gcBB8 = parcelRequire("gcBB8");

var $iBVMU = parcelRequire("iBVMU");
var $f6c87556da8d8dfc$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $f6c87556da8d8dfc$var$filterNested = function filterNested(nodes) {
    var l = nodes.length;
    for(var i = 0; i < l; i += 1){
        var _loop = function _loop(j) {
            if (i !== j) {
                if (nodes[i].contains(nodes[j])) return {
                    v: filterNested(nodes.filter(function(x) {
                        return x !== nodes[j];
                    }))
                };
            }
        };
        for(var j = 0; j < l; j += 1){
            var _ret = _loop(j);
            if ((typeof _ret === "undefined" ? "undefined" : $f6c87556da8d8dfc$var$_typeof(_ret)) === "object") return _ret.v;
        }
    }
    return nodes;
};
var $f6c87556da8d8dfc$var$getTopParent = function getTopParent(node) {
    return node.parentNode ? getTopParent(node.parentNode) : node;
};
var $f6c87556da8d8dfc$var$getAllAffectedNodes = function getAllAffectedNodes(node) {
    var nodes = (0, $iBVMU.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $gcBB8.FOCUS_GROUP));
        acc.push.apply(acc, group ? $f6c87556da8d8dfc$var$filterNested((0, $iBVMU.toArray)($f6c87556da8d8dfc$var$getTopParent(currentNode).querySelectorAll("[" + (0, $gcBB8.FOCUS_GROUP) + '="' + group + '"]:not([' + (0, $gcBB8.FOCUS_DISABLED) + '="disabled"])'))) : [
            currentNode
        ]);
        return acc;
    }, []);
};
var $f6c87556da8d8dfc$export$2e2bcd8739ae039 = $f6c87556da8d8dfc$var$getAllAffectedNodes;

});


parcelRegister("fjmo7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b259ff2713f3ab0d$export$2e2bcd8739ae039; });

var $lbCsy = parcelRequire("lbCsy");

var $iBVMU = parcelRequire("iBVMU");
var $b259ff2713f3ab0d$var$focusInFrame = function focusInFrame(frame) {
    return frame === document.activeElement;
};
var $b259ff2713f3ab0d$var$focusInsideIframe = function focusInsideIframe(topNode) {
    return !!(0, $iBVMU.arrayFind)((0, $iBVMU.toArray)(topNode.querySelectorAll("iframe")), $b259ff2713f3ab0d$var$focusInFrame);
};
var $b259ff2713f3ab0d$var$focusInside = function focusInside(topNode) {
    var activeElement = document && document.activeElement;
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $lbCsy.default)(topNode).reduce(function(result, node) {
        return result || node.contains(activeElement) || $b259ff2713f3ab0d$var$focusInsideIframe(node);
    }, false);
};
var $b259ff2713f3ab0d$export$2e2bcd8739ae039 = $b259ff2713f3ab0d$var$focusInside;

});

parcelRegister("1m3Xi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fcae9f4e015339e$export$2e2bcd8739ae039; });

var $iBVMU = parcelRequire("iBVMU");

var $gcBB8 = parcelRequire("gcBB8");
var $0fcae9f4e015339e$var$focusIsHidden = function focusIsHidden() {
    return document && (0, $iBVMU.toArray)(document.querySelectorAll("[" + (0, $gcBB8.FOCUS_ALLOW) + "]")).some(function(node) {
        return node.contains(document.activeElement);
    });
};
var $0fcae9f4e015339e$export$2e2bcd8739ae039 = $0fcae9f4e015339e$var$focusIsHidden;

});

parcelRegister("kbEQ9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb2483c0d372b635$export$2e2bcd8739ae039; });

var $4bryd = parcelRequire("4bryd");
var $eb2483c0d372b635$export$c12b3da842c43a8 = function focusOn(target) {
    target.focus();
    if (target.contentWindow) target.contentWindow.focus();
};
var $eb2483c0d372b635$var$guardCount = 0;
var $eb2483c0d372b635$var$lockDisabled = false;
var $eb2483c0d372b635$export$2e2bcd8739ae039 = function(topNode, lastNode) {
    var focusable = (0, $4bryd.default)(topNode, lastNode);
    if ($eb2483c0d372b635$var$lockDisabled) return;
    if (focusable) {
        if ($eb2483c0d372b635$var$guardCount > 2) {
            // eslint-disable-next-line no-console
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $eb2483c0d372b635$var$lockDisabled = true;
            setTimeout(function() {
                $eb2483c0d372b635$var$lockDisabled = false;
            }, 1);
            return;
        }
        $eb2483c0d372b635$var$guardCount++;
        $eb2483c0d372b635$export$c12b3da842c43a8(focusable.node);
        $eb2483c0d372b635$var$guardCount--;
    }
};

});


parcelRegister("d7nEE", function(module, exports) {

$parcel$export(module.exports, "deferAction", function () { return $98ce471bbcf4a2a1$export$6523025722806278; });
function $98ce471bbcf4a2a1$export$6523025722806278(action) {
    // Hidding setImmediate from Webpack to avoid inserting polyfill
    var setImmediate = window.setImmediate;
    if (typeof setImmediate !== "undefined") setImmediate(action);
    else setTimeout(action, 1);
}
var $98ce471bbcf4a2a1$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};

});


parcelRegister("l4Iz0", function(module, exports) {

$parcel$export(module.exports, "hiddenGuard", function () { return $f57c8a1fe3f74186$export$b8c7b07253306600; });

var $9nHZC = parcelRequire("9nHZC");

var $f57c8a1fe3f74186$export$b8c7b07253306600 = {
    width: "1px",
    height: "0px",
    padding: 0,
    overflow: "hidden",
    position: "fixed",
    top: "1px",
    left: "1px"
};
var $f57c8a1fe3f74186$var$InFocusGuard = function InFocusGuard(_ref) {
    var children = _ref.children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $f57c8a1fe3f74186$export$b8c7b07253306600
    }), children, children && (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $f57c8a1fe3f74186$export$b8c7b07253306600
    }));
};
$f57c8a1fe3f74186$var$InFocusGuard.propTypes = {};
$f57c8a1fe3f74186$var$InFocusGuard.defaultProps = {
    children: null
};
var $f57c8a1fe3f74186$export$2e2bcd8739ae039 = $f57c8a1fe3f74186$var$InFocusGuard;

});




parcelRegister("66yQZ", function(module, exports) {

$parcel$export(module.exports, "Animation", function () { return $8055714ae0d61aa3$export$c35d437ae5945fcd; });

var $9nHZC = parcelRequire("9nHZC");

var $c2OO5 = parcelRequire("c2OO5");
const $8055714ae0d61aa3$var$duration = 500;
const $8055714ae0d61aa3$var$easing = "cubic-bezier(0.23, 1, 0.32, 1)"; // easeOutQuint
const $8055714ae0d61aa3$var$verticalOffset = 16;
const $8055714ae0d61aa3$export$c35d437ae5945fcd = ({ in: hasEntered, stackIndex: stackIndex = 0, onExited: onExited, onEntered: onEntered, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $c2OO5.Transition), {
        in: hasEntered,
        timeout: $8055714ae0d61aa3$var$duration,
        onExited: onExited,
        onEntered: onEntered,
        appear: true
    }, (status)=>{
        if (status === "exited") return null;
        // Fade styles
        const fadeBase = {
            transition: `opacity ${$8055714ae0d61aa3$var$duration / 2}ms`,
            opacity: 1
        };
        const fadeTransitions = {
            entering: {
                opacity: 0
            },
            exiting: {
                opacity: 0
            }
        };
        // Slide styles
        const slideBase = {
            transition: `transform ${$8055714ae0d61aa3$var$duration}ms ${$8055714ae0d61aa3$var$easing}`,
            transform: `translate3d(0, ${$8055714ae0d61aa3$var$verticalOffset * 2}px, 0)`
        };
        const slideTransitions = {
            entered: {
                transform: stackIndex > 0 ? `translate3d(0, ${stackIndex * ($8055714ae0d61aa3$var$verticalOffset / 2)}px, 0)` : null
            },
            exiting: {
                transform: `translate3d(0, -${$8055714ae0d61aa3$var$verticalOffset * 2}px, 0)`
            }
        };
        return children({
            // @ts-ignore TODO: fix noImplicitAny error here
            fade: {
                ...fadeBase,
                ...fadeTransitions[status]
            },
            // @ts-ignore TODO: fix noImplicitAny error here
            slide: {
                ...slideBase,
                ...slideTransitions[status]
            }
        });
    });

});
parcelRegister("c2OO5", function(module, exports) {
"use strict";

var $8c4d15206eb293b0$var$_CSSTransition = $8c4d15206eb293b0$var$_interopRequireDefault((parcelRequire("aKqLS")));

var $8c4d15206eb293b0$var$_ReplaceTransition = $8c4d15206eb293b0$var$_interopRequireDefault((parcelRequire("9yK8R")));

var $8c4d15206eb293b0$var$_TransitionGroup = $8c4d15206eb293b0$var$_interopRequireDefault((parcelRequire("1YRMC")));

var $8c4d15206eb293b0$var$_Transition = $8c4d15206eb293b0$var$_interopRequireDefault((parcelRequire("84OfZ")));
function $8c4d15206eb293b0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports = {
    Transition: $8c4d15206eb293b0$var$_Transition.default,
    TransitionGroup: $8c4d15206eb293b0$var$_TransitionGroup.default,
    ReplaceTransition: $8c4d15206eb293b0$var$_ReplaceTransition.default,
    CSSTransition: $8c4d15206eb293b0$var$_CSSTransition.default
};

});
parcelRegister("aKqLS", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $7d32f771b6b5b680$var$PropTypes = $7d32f771b6b5b680$var$_interopRequireWildcard((parcelRequire("blCBi")));

var $7d32f771b6b5b680$var$_addClass = $7d32f771b6b5b680$var$_interopRequireDefault((parcelRequire("dwuWv")));

var $7d32f771b6b5b680$var$_removeClass = $7d32f771b6b5b680$var$_interopRequireDefault((parcelRequire("hBEAH")));

var $7d32f771b6b5b680$var$_react = $7d32f771b6b5b680$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $7d32f771b6b5b680$var$_Transition = $7d32f771b6b5b680$var$_interopRequireDefault((parcelRequire("84OfZ")));

function $7d32f771b6b5b680$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7d32f771b6b5b680$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $7d32f771b6b5b680$var$_extends() {
    $7d32f771b6b5b680$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7d32f771b6b5b680$var$_extends.apply(this, arguments);
}
function $7d32f771b6b5b680$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $7d32f771b6b5b680$var$addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $7d32f771b6b5b680$var$_addClass.default)(node, c);
    });
};
var $7d32f771b6b5b680$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $7d32f771b6b5b680$var$_removeClass.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */ var $7d32f771b6b5b680$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    $7d32f771b6b5b680$var$_inheritsLoose(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.onEnter = function(node, appearing) {
            var _this$getClassNames = _this.getClassNames(appearing ? "appear" : "enter"), className = _this$getClassNames.className;
            _this.removeClasses(node, "exit");
            $7d32f771b6b5b680$var$addClass(node, className);
            if (_this.props.onEnter) _this.props.onEnter(node, appearing);
        };
        _this.onEntering = function(node, appearing) {
            var _this$getClassNames2 = _this.getClassNames(appearing ? "appear" : "enter"), activeClassName = _this$getClassNames2.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onEntering) _this.props.onEntering(node, appearing);
        };
        _this.onEntered = function(node, appearing) {
            var appearClassName = _this.getClassNames("appear").doneClassName;
            var enterClassName = _this.getClassNames("enter").doneClassName;
            var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
            _this.removeClasses(node, appearing ? "appear" : "enter");
            $7d32f771b6b5b680$var$addClass(node, doneClassName);
            if (_this.props.onEntered) _this.props.onEntered(node, appearing);
        };
        _this.onExit = function(node) {
            var _this$getClassNames3 = _this.getClassNames("exit"), className = _this$getClassNames3.className;
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            $7d32f771b6b5b680$var$addClass(node, className);
            if (_this.props.onExit) _this.props.onExit(node);
        };
        _this.onExiting = function(node) {
            var _this$getClassNames4 = _this.getClassNames("exit"), activeClassName = _this$getClassNames4.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onExiting) _this.props.onExiting(node);
        };
        _this.onExited = function(node) {
            var _this$getClassNames5 = _this.getClassNames("exit"), doneClassName = _this$getClassNames5.doneClassName;
            _this.removeClasses(node, "exit");
            $7d32f771b6b5b680$var$addClass(node, doneClassName);
            if (_this.props.onExited) _this.props.onExited(node);
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var className = isStringClassNames ? prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? className + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? className + "-done" : classNames[type + "Done"];
            return {
                className: className,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$getClassNames6 = this.getClassNames(type), className = _this$getClassNames6.className, activeClassName = _this$getClassNames6.activeClassName, doneClassName = _this$getClassNames6.doneClassName;
        className && $7d32f771b6b5b680$var$removeClass(node, className);
        activeClassName && $7d32f771b6b5b680$var$removeClass(node, activeClassName);
        doneClassName && $7d32f771b6b5b680$var$removeClass(node, doneClassName);
    };
    _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (className) {
            /* eslint-disable no-unused-expressions */ node && node.scrollTop;
            /* eslint-enable no-unused-expressions */ $7d32f771b6b5b680$var$addClass(node, className);
        }
    };
    _proto.render = function render() {
        var props = $7d32f771b6b5b680$var$_extends({}, this.props);
        delete props.classNames;
        return $7d32f771b6b5b680$var$_react.default.createElement($7d32f771b6b5b680$var$_Transition.default, $7d32f771b6b5b680$var$_extends({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}($7d32f771b6b5b680$var$_react.default.Component);
$7d32f771b6b5b680$var$CSSTransition.defaultProps = {
    classNames: ""
};
$7d32f771b6b5b680$var$CSSTransition.propTypes = {};
var $7d32f771b6b5b680$var$_default = $7d32f771b6b5b680$var$CSSTransition;
module.exports.default = $7d32f771b6b5b680$var$_default;
module.exports = module.exports["default"];

});
parcelRegister("dwuWv", function(module, exports) {
"use strict";

var $gVeVI = parcelRequire("gVeVI");
module.exports.__esModule = true;
module.exports.default = $9d864410e3323244$var$addClass;

var $9d864410e3323244$var$_hasClass = $gVeVI((parcelRequire("aVmWg")));
function $9d864410e3323244$var$addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $9d864410e3323244$var$_hasClass.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}
module.exports = module.exports["default"];

});
parcelRegister("gVeVI", function(module, exports) {
function $c51d8cff09051485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $c51d8cff09051485$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("aVmWg", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $7f41056939d9f4ee$var$hasClass;
function $7f41056939d9f4ee$var$hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = module.exports["default"];

});


parcelRegister("hBEAH", function(module, exports) {
"use strict";
function $cd1560e6a5eb1f31$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
module.exports = function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $cd1560e6a5eb1f31$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $cd1560e6a5eb1f31$var$replaceClassName(element.className && element.className.baseVal || "", className));
};

});

parcelRegister("84OfZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $5e15ae661b979987$export$1e511d4a378977f5; }, function (v) { return $5e15ae661b979987$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $5e15ae661b979987$export$2e2bcd8739ae039; }, function (v) { return $5e15ae661b979987$export$2e2bcd8739ae039 = v; });
$parcel$export(module.exports, "EXITING", function () { return $5e15ae661b979987$export$4aacc83d4d59139f; }, function (v) { return $5e15ae661b979987$export$4aacc83d4d59139f = v; });
$parcel$export(module.exports, "ENTERED", function () { return $5e15ae661b979987$export$78e9e6e3e014d60a; }, function (v) { return $5e15ae661b979987$export$78e9e6e3e014d60a = v; });
$parcel$export(module.exports, "ENTERING", function () { return $5e15ae661b979987$export$df38205c966be359; }, function (v) { return $5e15ae661b979987$export$df38205c966be359 = v; });
$parcel$export(module.exports, "EXITED", function () { return $5e15ae661b979987$export$84cbff306f539230; }, function (v) { return $5e15ae661b979987$export$84cbff306f539230 = v; });
$parcel$export(module.exports, "UNMOUNTED", function () { return $5e15ae661b979987$export$bb38bb9a1161268; }, function (v) { return $5e15ae661b979987$export$bb38bb9a1161268 = v; });
var $5e15ae661b979987$export$1e511d4a378977f5;
var $5e15ae661b979987$export$2e2bcd8739ae039;
var $5e15ae661b979987$export$4aacc83d4d59139f;
var $5e15ae661b979987$export$78e9e6e3e014d60a;
var $5e15ae661b979987$export$df38205c966be359;
var $5e15ae661b979987$export$84cbff306f539230;
var $5e15ae661b979987$export$bb38bb9a1161268;
"use strict";
$5e15ae661b979987$export$1e511d4a378977f5 = true;
$5e15ae661b979987$export$2e2bcd8739ae039 = $5e15ae661b979987$export$4aacc83d4d59139f = $5e15ae661b979987$export$78e9e6e3e014d60a = $5e15ae661b979987$export$df38205c966be359 = $5e15ae661b979987$export$84cbff306f539230 = $5e15ae661b979987$export$bb38bb9a1161268 = void 0;

var $5e15ae661b979987$var$PropTypes = $5e15ae661b979987$var$_interopRequireWildcard((parcelRequire("blCBi")));

var $5e15ae661b979987$var$_react = $5e15ae661b979987$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $5e15ae661b979987$var$_reactDom = $5e15ae661b979987$var$_interopRequireDefault((parcelRequire("lnOmc")));

var $eLE6M = parcelRequire("eLE6M");

function $5e15ae661b979987$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5e15ae661b979987$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $5e15ae661b979987$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5e15ae661b979987$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $5e15ae661b979987$var$UNMOUNTED = "unmounted";
$5e15ae661b979987$export$bb38bb9a1161268 = $5e15ae661b979987$var$UNMOUNTED;
var $5e15ae661b979987$var$EXITED = "exited";
$5e15ae661b979987$export$84cbff306f539230 = $5e15ae661b979987$var$EXITED;
var $5e15ae661b979987$var$ENTERING = "entering";
$5e15ae661b979987$export$df38205c966be359 = $5e15ae661b979987$var$ENTERING;
var $5e15ae661b979987$var$ENTERED = "entered";
$5e15ae661b979987$export$78e9e6e3e014d60a = $5e15ae661b979987$var$ENTERED;
var $5e15ae661b979987$var$EXITING = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ $5e15ae661b979987$export$4aacc83d4d59139f = $5e15ae661b979987$var$EXITING;
var $5e15ae661b979987$var$Transition = /*#__PURE__*/ function(_React$Component) {
    $5e15ae661b979987$var$_inheritsLoose(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $5e15ae661b979987$var$EXITED;
                _this.appearStatus = $5e15ae661b979987$var$ENTERING;
            } else initialStatus = $5e15ae661b979987$var$ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $5e15ae661b979987$var$UNMOUNTED;
        else initialStatus = $5e15ae661b979987$var$EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    var _proto = Transition.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: null // allows for nested Transitions
        };
    };
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $5e15ae661b979987$var$UNMOUNTED) return {
            status: $5e15ae661b979987$var$EXITED
        };
        return null;
    }; // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $5e15ae661b979987$var$ENTERING && status !== $5e15ae661b979987$var$ENTERED) nextStatus = $5e15ae661b979987$var$ENTERING;
            } else if (status === $5e15ae661b979987$var$ENTERING || status === $5e15ae661b979987$var$ENTERED) nextStatus = $5e15ae661b979987$var$EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            var node = $5e15ae661b979987$var$_reactDom.default.findDOMNode(this);
            if (nextStatus === $5e15ae661b979987$var$ENTERING) this.performEnter(node, mounting);
            else this.performExit(node);
        } else if (this.props.unmountOnExit && this.state.status === $5e15ae661b979987$var$EXITED) this.setState({
            status: $5e15ae661b979987$var$UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(node, mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter) {
            this.safeSetState({
                status: $5e15ae661b979987$var$ENTERED
            }, function() {
                _this2.props.onEntered(node);
            });
            return;
        }
        this.props.onEnter(node, appearing);
        this.safeSetState({
            status: $5e15ae661b979987$var$ENTERING
        }, function() {
            _this2.props.onEntering(node, appearing);
            _this2.onTransitionEnd(node, enterTimeout, function() {
                _this2.safeSetState({
                    status: $5e15ae661b979987$var$ENTERED
                }, function() {
                    _this2.props.onEntered(node, appearing);
                });
            });
        });
    };
    _proto.performExit = function performExit(node) {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: $5e15ae661b979987$var$EXITED
            }, function() {
                _this3.props.onExited(node);
            });
            return;
        }
        this.props.onExit(node);
        this.safeSetState({
            status: $5e15ae661b979987$var$EXITING
        }, function() {
            _this3.props.onExiting(node);
            _this3.onTransitionEnd(node, timeouts.exit, function() {
                _this3.safeSetState({
                    status: $5e15ae661b979987$var$EXITED
                }, function() {
                    _this3.props.onExited(node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $5e15ae661b979987$var$UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = $5e15ae661b979987$var$_objectWithoutPropertiesLoose(_this$props, [
            "children"
        ]); // filter props for Transtition
        delete childProps.in;
        delete childProps.mountOnEnter;
        delete childProps.unmountOnExit;
        delete childProps.appear;
        delete childProps.enter;
        delete childProps.exit;
        delete childProps.timeout;
        delete childProps.addEndListener;
        delete childProps.onEnter;
        delete childProps.onEntering;
        delete childProps.onEntered;
        delete childProps.onExit;
        delete childProps.onExiting;
        delete childProps.onExited;
        if (typeof children === "function") return children(status, childProps);
        var child = $5e15ae661b979987$var$_react.default.Children.only(children);
        return $5e15ae661b979987$var$_react.default.cloneElement(child, childProps);
    };
    return Transition;
}($5e15ae661b979987$var$_react.default.Component);
$5e15ae661b979987$var$Transition.contextTypes = {
    transitionGroup: $5e15ae661b979987$var$PropTypes.object
};
$5e15ae661b979987$var$Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
};
$5e15ae661b979987$var$Transition.propTypes = {};
function $5e15ae661b979987$var$noop() {}
$5e15ae661b979987$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $5e15ae661b979987$var$noop,
    onEntering: $5e15ae661b979987$var$noop,
    onEntered: $5e15ae661b979987$var$noop,
    onExit: $5e15ae661b979987$var$noop,
    onExiting: $5e15ae661b979987$var$noop,
    onExited: $5e15ae661b979987$var$noop
};
$5e15ae661b979987$var$Transition.UNMOUNTED = 0;
$5e15ae661b979987$var$Transition.EXITED = 1;
$5e15ae661b979987$var$Transition.ENTERING = 2;
$5e15ae661b979987$var$Transition.ENTERED = 3;
$5e15ae661b979987$var$Transition.EXITING = 4;
var $5e15ae661b979987$var$_default = (0, $eLE6M.polyfill)($5e15ae661b979987$var$Transition);
$5e15ae661b979987$export$2e2bcd8739ae039 = $5e15ae661b979987$var$_default;

});
parcelRegister("eLE6M", function(module, exports) {

$parcel$export(module.exports, "polyfill", function () { return $ac049124e266f869$export$cea1c58a6db52bca; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $ac049124e266f869$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $ac049124e266f869$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $ac049124e266f869$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$ac049124e266f869$var$componentWillMount.__suppressDeprecationWarning = true;
$ac049124e266f869$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$ac049124e266f869$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $ac049124e266f869$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $ac049124e266f869$var$componentWillMount;
        prototype.componentWillReceiveProps = $ac049124e266f869$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $ac049124e266f869$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});



parcelRegister("9yK8R", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $6f5b14d5eb8ba094$var$_propTypes = $6f5b14d5eb8ba094$var$_interopRequireDefault((parcelRequire("blCBi")));

var $6f5b14d5eb8ba094$var$_react = $6f5b14d5eb8ba094$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $lnOmc = parcelRequire("lnOmc");

var $6f5b14d5eb8ba094$var$_TransitionGroup = $6f5b14d5eb8ba094$var$_interopRequireDefault((parcelRequire("1YRMC")));
function $6f5b14d5eb8ba094$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6f5b14d5eb8ba094$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6f5b14d5eb8ba094$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */ var $6f5b14d5eb8ba094$var$ReplaceTransition = /*#__PURE__*/ function(_React$Component) {
    $6f5b14d5eb8ba094$var$_inheritsLoose(ReplaceTransition, _React$Component);
    function ReplaceTransition() {
        var _this;
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(_args)) || this;
        _this.handleEnter = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _this.handleLifecycle("onEnter", 0, args);
        };
        _this.handleEntering = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            return _this.handleLifecycle("onEntering", 0, args);
        };
        _this.handleEntered = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return _this.handleLifecycle("onEntered", 0, args);
        };
        _this.handleExit = function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            return _this.handleLifecycle("onExit", 1, args);
        };
        _this.handleExiting = function() {
            for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
            return _this.handleLifecycle("onExiting", 1, args);
        };
        _this.handleExited = function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            return _this.handleLifecycle("onExited", 1, args);
        };
        return _this;
    }
    var _proto = ReplaceTransition.prototype;
    _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
        var _child$props;
        var children = this.props.children;
        var child = $6f5b14d5eb8ba094$var$_react.default.Children.toArray(children)[idx];
        if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
        if (this.props[handler]) this.props[handler]((0, $lnOmc.findDOMNode)(this));
    };
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, inProp = _this$props.in, props = $6f5b14d5eb8ba094$var$_objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in"
        ]);
        var _React$Children$toArr = $6f5b14d5eb8ba094$var$_react.default.Children.toArray(children), first = _React$Children$toArr[0], second = _React$Children$toArr[1];
        delete props.onEnter;
        delete props.onEntering;
        delete props.onEntered;
        delete props.onExit;
        delete props.onExiting;
        delete props.onExited;
        return $6f5b14d5eb8ba094$var$_react.default.createElement($6f5b14d5eb8ba094$var$_TransitionGroup.default, props, inProp ? $6f5b14d5eb8ba094$var$_react.default.cloneElement(first, {
            key: "first",
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onEntered: this.handleEntered
        }) : $6f5b14d5eb8ba094$var$_react.default.cloneElement(second, {
            key: "second",
            onEnter: this.handleExit,
            onEntering: this.handleExiting,
            onEntered: this.handleExited
        }));
    };
    return ReplaceTransition;
}($6f5b14d5eb8ba094$var$_react.default.Component);
$6f5b14d5eb8ba094$var$ReplaceTransition.propTypes = {};
var $6f5b14d5eb8ba094$var$_default = $6f5b14d5eb8ba094$var$ReplaceTransition;
module.exports.default = $6f5b14d5eb8ba094$var$_default;
module.exports = module.exports["default"];

});
parcelRegister("1YRMC", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $17151d3be45c21dc$var$_propTypes = $17151d3be45c21dc$var$_interopRequireDefault((parcelRequire("blCBi")));

var $17151d3be45c21dc$var$_react = $17151d3be45c21dc$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $eLE6M = parcelRequire("eLE6M");

var $liEFe = parcelRequire("liEFe");
function $17151d3be45c21dc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $17151d3be45c21dc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $17151d3be45c21dc$var$_extends() {
    $17151d3be45c21dc$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $17151d3be45c21dc$var$_extends.apply(this, arguments);
}
function $17151d3be45c21dc$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $17151d3be45c21dc$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var $17151d3be45c21dc$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $17151d3be45c21dc$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
var $17151d3be45c21dc$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    $17151d3be45c21dc$var$_inheritsLoose(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind($17151d3be45c21dc$var$_assertThisInitialized($17151d3be45c21dc$var$_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
        _this.state = {
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: {
                isMounting: !this.appeared
            }
        };
    };
    _proto.componentDidMount = function componentDidMount() {
        this.appeared = true;
        this.mounted = true;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $liEFe.getInitialChildMapping)(nextProps, handleExited) : (0, $liEFe.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    };
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $liEFe.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = $17151d3be45c21dc$var$_extends({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = $17151d3be45c21dc$var$_objectWithoutPropertiesLoose(_this$props, [
            "component",
            "childFactory"
        ]);
        var children = $17151d3be45c21dc$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return children;
        return $17151d3be45c21dc$var$_react.default.createElement(Component, props, children);
    };
    return TransitionGroup;
}($17151d3be45c21dc$var$_react.default.Component);
$17151d3be45c21dc$var$TransitionGroup.childContextTypes = {
    transitionGroup: $17151d3be45c21dc$var$_propTypes.default.object.isRequired
};
$17151d3be45c21dc$var$TransitionGroup.propTypes = {};
$17151d3be45c21dc$var$TransitionGroup.defaultProps = $17151d3be45c21dc$var$defaultProps;
var $17151d3be45c21dc$var$_default = (0, $eLE6M.polyfill)($17151d3be45c21dc$var$TransitionGroup);
module.exports.default = $17151d3be45c21dc$var$_default;
module.exports = module.exports["default"];

});
parcelRegister("liEFe", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $f81ad26ff6d48a0c$export$bbc8a025727ea824; }, function (v) { return $f81ad26ff6d48a0c$export$bbc8a025727ea824 = v; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $f81ad26ff6d48a0c$export$fa71e2345c31d7a2; }, function (v) { return $f81ad26ff6d48a0c$export$fa71e2345c31d7a2 = v; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $f81ad26ff6d48a0c$export$36fd1af28d383ec0; }, function (v) { return $f81ad26ff6d48a0c$export$36fd1af28d383ec0 = v; });
var $f81ad26ff6d48a0c$export$1e511d4a378977f5;
var $f81ad26ff6d48a0c$export$bbc8a025727ea824;
var $f81ad26ff6d48a0c$export$7a874f95ccf533dd;
var $f81ad26ff6d48a0c$export$fa71e2345c31d7a2;
var $f81ad26ff6d48a0c$export$36fd1af28d383ec0;
"use strict";
$f81ad26ff6d48a0c$export$1e511d4a378977f5 = true;
$f81ad26ff6d48a0c$export$bbc8a025727ea824 = $f81ad26ff6d48a0c$var$getChildMapping;
$f81ad26ff6d48a0c$export$7a874f95ccf533dd = $f81ad26ff6d48a0c$var$mergeChildMappings;
$f81ad26ff6d48a0c$export$fa71e2345c31d7a2 = $f81ad26ff6d48a0c$var$getInitialChildMapping;
$f81ad26ff6d48a0c$export$36fd1af28d383ec0 = $f81ad26ff6d48a0c$var$getNextChildMapping;

var $9nHZC = parcelRequire("9nHZC");
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ function $f81ad26ff6d48a0c$var$getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $9nHZC.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) $9nHZC.Children.map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ function $f81ad26ff6d48a0c$var$mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $f81ad26ff6d48a0c$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $f81ad26ff6d48a0c$var$getInitialChildMapping(props, onExited) {
    return $f81ad26ff6d48a0c$var$getChildMapping(props.children, function(child) {
        return (0, $9nHZC.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $f81ad26ff6d48a0c$var$getProp(child, "appear", props),
            enter: $f81ad26ff6d48a0c$var$getProp(child, "enter", props),
            exit: $f81ad26ff6d48a0c$var$getProp(child, "exit", props)
        });
    });
}
function $f81ad26ff6d48a0c$var$getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $f81ad26ff6d48a0c$var$getChildMapping(nextProps.children);
    var children = $f81ad26ff6d48a0c$var$mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $9nHZC.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $9nHZC.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $9nHZC.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $f81ad26ff6d48a0c$var$getProp(child, "exit", nextProps),
            enter: $f81ad26ff6d48a0c$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $9nHZC.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $9nHZC.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $9nHZC.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $f81ad26ff6d48a0c$var$getProp(child, "exit", nextProps),
            enter: $f81ad26ff6d48a0c$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});






parcelRegister("1fTLe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33940afee5c68c31$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $5y4no = parcelRequire("5y4no");
class $33940afee5c68c31$var$DialogIframeContainer extends (0, $9nHZC.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, this.props.children);
    }
}
class $33940afee5c68c31$export$85a9519327a4d494 extends (0, $9nHZC.PureComponent) {
    render() {
        const { connectHost: connectHost, addonManager: addonManager, extension: extension, width: width, height: height, defaultStyles: defaultStyles, iframeContainer: iframeContainer } = this.props;
        const appKey = extension.appKey || extension.addon_key;
        const moduleKey = extension.moduleKey || extension.key;
        let { targetHref: targetHref } = extension;
        if (!targetHref) {
            var _extension$options$pr;
            // once productContext starts being used, we shouldn't have to use findModules below.
            // eslint-disable-next-line prefer-destructuring
            targetHref = (_extension$options$pr = extension.options.productContext) === null || _extension$options$pr === void 0 ? void 0 : _extension$options$pr.targetHref;
        }
        if (!targetHref) {
            const addons = addonManager.findModules({
                appKey: appKey,
                moduleKey: moduleKey
            });
            if (addons.length) // eslint-disable-next-line prefer-destructuring
            targetHref = addons[0].targetHref;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5y4no.ConnectIframe), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, extension, {
            moduleKey: moduleKey,
            appKey: appKey,
            targetHref: targetHref,
            width: width,
            height: height,
            options: {
                ...extension.options,
                isDialogModule: true,
                __featuresInternal: {}
            },
            defaultStyles: defaultStyles,
            iframeContainer: iframeContainer,
            connectHost: connectHost,
            addonManager: addonManager
        }));
    }
}
$33940afee5c68c31$export$85a9519327a4d494.defaultProps = {
    defaultStyles: {
        flex: 1
    },
    iframeContainer: $33940afee5c68c31$var$DialogIframeContainer
};
var $33940afee5c68c31$export$2e2bcd8739ae039 = $33940afee5c68c31$export$85a9519327a4d494;

});




parcelRegister("hgVF6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d695b2a429d4c17f$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $4JvPI = parcelRequire("4JvPI");
var $kcqww = parcelRequire("kcqww");

var $KMOF4 = parcelRequire("KMOF4");
var $d695b2a429d4c17f$export$2e2bcd8739ae039;
$d695b2a429d4c17f$export$2e2bcd8739ae039 = class Flag extends (0, $9nHZC.PureComponent) {
    constructor(...args){
        super(...args);
        this.state = {
            flags: []
        };
        this.create = (flag)=>{
            const newFlag = flag;
            if (newFlag.close === "auto") newFlag.timeoutId = window.setTimeout(()=>{
                this.close(newFlag.id);
            }, 8000);
            this.setState({
                flags: [
                    newFlag,
                    ...this.state.flags
                ]
            });
            return {
                id: newFlag.id,
                close: ()=>this.close(newFlag.id)
            };
        };
        this.close = (flagId)=>{
            this.setState({
                flags: this.state.flags.filter((flag)=>flag.id !== flagId)
            });
        };
        this.isFlagOpen = (flagId)=>this.state.flags.some((flag)=>flag.id === flagId);
    }
    componentDidMount() {
        this.props.flagProvider.setView({
            create: this.create,
            isFlagOpen: this.isFlagOpen
        });
    }
    componentWillUnmount() {
        this.props.flagProvider.setView(null);
        this.state.flags.forEach((flag)=>clearTimeout(flag.timeoutId));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kcqww.default), {
            onDismissed: this.close
        }, this.state.flags.map((flag)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $4JvPI.default), {
                key: flag.id,
                id: flag.id,
                title: flag.title,
                description: flag.body,
                actions: flag.actions.map((0, $KMOF4.wrapAction)),
                icon: (0, $KMOF4.getIcon)(flag.type)
            })));
    }
};

});
parcelRegister("4JvPI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37240ec4200d5c95$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $5LVXk = parcelRequire("5LVXk");

var $aP6k3 = parcelRequire("aP6k3");

var $7w0fy = parcelRequire("7w0fy");

var $8p2GL = parcelRequire("8p2GL");

var $dxhCu = parcelRequire("dxhCu");

var $7eV0A = parcelRequire("7eV0A");

var $4XF6k = parcelRequire("4XF6k");

var $80G4D = parcelRequire("80G4D");

var $kcqww = parcelRequire("kcqww");

var $b5Rto = parcelRequire("b5Rto");
var $i2w52 = parcelRequire("i2w52");
var $4I3Wr = parcelRequire("4I3Wr");
var $708pv = parcelRequire("708pv");
function $37240ec4200d5c95$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $37240ec4200d5c95$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $37240ec4200d5c95$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $37240ec4200d5c95$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $37240ec4200d5c95$var$analyticsAttributes = {
    componentName: "flag",
    packageName: "@atlaskit/flag",
    packageVersion: "14.7.1"
};
var $37240ec4200d5c95$var$gridSize = (0, $aP6k3.gridSize)();
var $37240ec4200d5c95$var$doubleGridSize = $37240ec4200d5c95$var$gridSize * 2;
var $37240ec4200d5c95$var$titleGroupStyles = (0, $avKww.css)({
    display: "flex",
    alignItems: "start"
});
var $37240ec4200d5c95$var$iconTitleStyles = (0, $avKww.css)({
    display: "flex",
    paddingTop: "".concat($37240ec4200d5c95$var$gridSize / 2, "px"),
    alignItems: "start",
    flex: 1
});
var $37240ec4200d5c95$var$flagHeaderStyles = (0, $avKww.css)({
    boxSizing: "border-box",
    width: "100%",
    padding: $37240ec4200d5c95$var$doubleGridSize,
    borderRadius: (0, $aP6k3.borderRadius)()
});
var $37240ec4200d5c95$var$flagContainerStyles = (0, $avKww.css)({
    width: "100%",
    zIndex: (0, $aP6k3.layers).flag(),
    borderRadius: (0, $aP6k3.borderRadius)(),
    transition: "background-color 200ms"
});
/**
 * __Flag__
 *
 * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
 * often displayed using a flag group.
 *
 * - [Examples](https://atlassian.design/components/flag/examples)
 * - [Code](https://atlassian.design/components/flag/code)
 * - [Usage](https://atlassian.design/components/flag/usage)
 */ var $37240ec4200d5c95$var$Flag = function Flag(props) {
    var _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $7eV0A.DEFAULT_APPEARANCE) : _props$appearance, icon = props.icon, title = props.title, description = props.description, linkComponent = props.linkComponent, onMouseOver = props.onMouseOver, _props$onFocus = props.onFocus, onFocus = _props$onFocus === void 0 ? (0, $8p2GL.default) : _props$onFocus, onMouseOut = props.onMouseOut, _props$onBlur = props.onBlur, onBlur = _props$onBlur === void 0 ? (0, $8p2GL.default) : _props$onBlur, _props$onDismissed = props.onDismissed, onDismissedProp = _props$onDismissed === void 0 ? (0, $8p2GL.default) : _props$onDismissed, testId = props.testId, id = props.id, analyticsContext = props.analyticsContext;
    var _useFlagGroup = (0, $kcqww.useFlagGroup)(), onDismissedFromFlagGroup = _useFlagGroup.onDismissed, isDismissAllowed = _useFlagGroup.isDismissAllowed;
    var onDismissed = (0, $9nHZC.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var _useState = (0, $9nHZC.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), isExpanded = _useState2[0], setIsExpanded = _useState2[1];
    var onDismissedAnalytics = (0, $7w0fy.usePlatformLeafEventHandler)($37240ec4200d5c95$var$_objectSpread({
        fn: onDismissed,
        action: "dismissed",
        analyticsData: analyticsContext
    }, $37240ec4200d5c95$var$analyticsAttributes));
    var isBold = appearance !== (0, $7eV0A.DEFAULT_APPEARANCE);
    var toggleExpand = (0, $9nHZC.useCallback)(function() {
        setIsExpanded(function(previous) {
            return !previous;
        });
    }, []);
    var buttonActionCallback = (0, $9nHZC.useCallback)(function() {
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $9nHZC.useEffect)(function() {
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    var onFocusAnalytics = (0, $7w0fy.usePlatformLeafEventHandler)($37240ec4200d5c95$var$_objectSpread({
        fn: onFocus,
        action: "focused",
        analyticsData: analyticsContext
    }, $37240ec4200d5c95$var$analyticsAttributes));
    var onBlurAnalytics = (0, $7w0fy.usePlatformLeafEventHandler)($37240ec4200d5c95$var$_objectSpread({
        fn: onBlur,
        action: "blurred",
        analyticsData: analyticsContext
    }, $37240ec4200d5c95$var$analyticsAttributes));
    var autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    var boxShadowValue = "0 20px 32px -8px ".concat((0, $4XF6k.flagShadowColor));
    if (!isBold) boxShadowValue = "0 0 1px ".concat((0, $4XF6k.flagBorderColor), ", ").concat(boxShadowValue);
    var boxShadow = "var(--ds-shadow-overlay, ".concat(boxShadowValue, ")");
    var _useGlobalTheme = (0, $5LVXk.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var textColor = (0, $4XF6k.getFlagTextColor)(appearance, mode);
    var iconColor = (0, $4XF6k.getFlagIconColor)(appearance, mode);
    var isDismissable = isBold || isDismissAllowed;
    return (0, $avKww.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        style: {
            color: textColor,
            backgroundColor: (0, $4XF6k.getFlagBackgroundColor)(appearance, mode),
            boxShadow: boxShadow
        },
        css: $37240ec4200d5c95$var$flagContainerStyles,
        role: "alert",
        "data-testid": testId
    }, autoDismissProps), (0, $avKww.jsx)((0, $dxhCu.default), null, (0, $avKww.jsx)("div", {
        css: $37240ec4200d5c95$var$flagHeaderStyles // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        ,
        tabIndex: 0
    }, (0, $avKww.jsx)("div", {
        style: {
            color: iconColor
        },
        css: $37240ec4200d5c95$var$titleGroupStyles
    }, (0, $avKww.jsx)("div", {
        css: $37240ec4200d5c95$var$iconTitleStyles
    }, icon, (0, $avKww.jsx)((0, $708pv.default), {
        color: textColor
    }, title)), isDismissable ? !(isBold && !description && !actions.length) && (0, $avKww.jsx)((0, $i2w52.default), {
        testId: testId,
        appearance: appearance,
        isBold: isBold,
        isExpanded: isExpanded,
        onClick: isBold ? toggleExpand : buttonActionCallback
    }) : null), (0, $avKww.jsx)((0, $4I3Wr.default), {
        isExpanded: !isBold || isExpanded,
        testId: testId
    }, description && (0, $avKww.jsx)((0, $b5Rto.default), {
        testId: testId && "".concat(testId, "-description"),
        color: textColor,
        isBold: isBold
    }, description), (0, $avKww.jsx)((0, $80G4D.default), {
        actions: actions,
        appearance: appearance,
        linkComponent: linkComponent,
        testId: testId,
        mode: mode
    })))));
};
var $37240ec4200d5c95$export$2e2bcd8739ae039 = $37240ec4200d5c95$var$Flag;

});
parcelRegister("7w0fy", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $578bb72b698189c1$export$a4687b0234b40e28; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $c8uO1 = parcelRequire("c8uO1");

var $iLePA = parcelRequire("iLePA");
function $578bb72b698189c1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $578bb72b698189c1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $578bb72b698189c1$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $578bb72b698189c1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $578bb72b698189c1$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $c8uO1.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent; // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $iLePA.useTrackedRef)(analyticsData);
    var fnRef = (0, $iLePA.useTrackedRef)(fn);
    var handler = (0, $9nHZC.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        }); // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $578bb72b698189c1$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context); // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        createAnalyticsEvent,
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("c8uO1", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $8d5e20c2af9bc28b$export$5bf35293e545f20c; });

var $dNznA = parcelRequire("dNznA");

var $1mYbK = parcelRequire("1mYbK");

var $fBNdk = parcelRequire("fBNdk");
function $8d5e20c2af9bc28b$export$5bf35293e545f20c() {
    var analyticsContext = (0, $fBNdk.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $1mYbK.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("1mYbK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ff688b344545e52$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $iCSwM = parcelRequire("iCSwM");
function $0ff688b344545e52$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $0ff688b344545e52$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $0ff688b344545e52$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $0ff688b344545e52$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $0ff688b344545e52$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 ? void 0 : (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $0ff688b344545e52$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $0ff688b344545e52$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $iCSwM.default));

});
parcelRegister("iCSwM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8f612a8de2f9533$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
function $d8f612a8de2f9533$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d8f612a8de2f9533$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d8f612a8de2f9533$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d8f612a8de2f9533$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $d8f612a8de2f9533$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $d8f612a8de2f9533$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 ? void 0 : (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $d8f612a8de2f9533$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $d8f612a8de2f9533$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(updater) === "object") this.payload = $d8f612a8de2f9533$var$_objectSpread($d8f612a8de2f9533$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("fBNdk", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $b5d07c9a06998141$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $b5d07c9a06998141$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});


parcelRegister("iLePA", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $0386531456aa573b$export$1d27a74659855e44; });

var $9nHZC = parcelRequire("9nHZC");
var $0386531456aa573b$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    (0, $9nHZC.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
};

});


parcelRegister("7eV0A", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_APPEARANCE", function () { return $54560fe810aea190$export$d6830277b06edd6; });
var $54560fe810aea190$export$d6830277b06edd6 = "normal";

});

parcelRegister("4XF6k", function(module, exports) {

$parcel$export(module.exports, "getFlagBackgroundColor", function () { return $39cc8df459622e0d$export$1a3fa949f8fecd3c; });
$parcel$export(module.exports, "flagBorderColor", function () { return $39cc8df459622e0d$export$fffc0cee60fe5a70; });
$parcel$export(module.exports, "flagShadowColor", function () { return $39cc8df459622e0d$export$5acd8a53d2cebe75; });
$parcel$export(module.exports, "getFlagTextColor", function () { return $39cc8df459622e0d$export$1e00658f62be5348; });
$parcel$export(module.exports, "getFlagIconColor", function () { return $39cc8df459622e0d$export$4c078ac312f2523f; });
$parcel$export(module.exports, "getFlagFocusRingColor", function () { return $39cc8df459622e0d$export$189aab3d402d4f43; });
$parcel$export(module.exports, "getActionBackground", function () { return $39cc8df459622e0d$export$1c67b7858bd5491; });
$parcel$export(module.exports, "getActionColor", function () { return $39cc8df459622e0d$export$dad14efd26ada932; });

var $jp7ng = parcelRequire("jp7ng");
var $39cc8df459622e0d$var$flagBackgroundColor = {
    error: {
        light: "var(--ds-background-danger-bold, ".concat((0, $jp7ng.R400), ")"),
        dark: "var(--ds-background-danger-bold, ".concat((0, $jp7ng.R300), ")")
    },
    info: {
        light: "var(--ds-background-neutral-bold, ".concat((0, $jp7ng.N500), ")"),
        dark: "var(--ds-background-neutral-bold, ".concat((0, $jp7ng.N500), ")")
    },
    normal: {
        light: "var(--ds-surface-overlay, ".concat((0, $jp7ng.N0), ")"),
        dark: "var(--ds-surface-overlay, ".concat((0, $jp7ng.DN50), ")")
    },
    success: {
        light: "var(--ds-background-success-bold, ".concat((0, $jp7ng.G400), ")"),
        dark: "var(--ds-background-success-bold, ".concat((0, $jp7ng.G300), ")")
    },
    warning: {
        light: "var(--ds-background-warning-bold, ".concat((0, $jp7ng.Y200), ")"),
        dark: "var(--ds-background-warning-bold, ".concat((0, $jp7ng.Y300), ")")
    }
};
var $39cc8df459622e0d$export$1a3fa949f8fecd3c = function getFlagBackgroundColor(appearance, mode) {
    return $39cc8df459622e0d$var$flagBackgroundColor[appearance][mode];
}; // token set in flag.tsx instead
var $39cc8df459622e0d$export$fffc0cee60fe5a70 = (0, $jp7ng.N60A);
var $39cc8df459622e0d$export$5acd8a53d2cebe75 = (0, $jp7ng.N50A);
/* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ var $39cc8df459622e0d$var$flagIconColor = {
    error: {
        light: "var(--ds-icon-inverse, ".concat((0, $jp7ng.N0), ")"),
        dark: "var(--ds-icon-inverse, ".concat((0, $jp7ng.DN40), ")")
    },
    info: {
        light: "var(--ds-icon-inverse, ".concat((0, $jp7ng.N0), ")"),
        dark: "var(--ds-icon-inverse, ".concat((0, $jp7ng.DN600), ")")
    },
    normal: {
        light: "var(--ds-icon-subtle, ".concat((0, $jp7ng.N500), ")"),
        dark: "var(--ds-icon-subtle, ".concat((0, $jp7ng.DN600), ")")
    },
    success: {
        light: "var(--ds-icon-inverse, ".concat((0, $jp7ng.N0), ")"),
        dark: "var(--ds-icon-inverse, ".concat((0, $jp7ng.DN40), ")")
    },
    warning: {
        light: "var(--ds-icon-warning-inverse, ".concat((0, $jp7ng.N700), ")"),
        dark: "var(--ds-icon-warning-inverse, ".concat((0, $jp7ng.DN40), ")")
    }
};
var $39cc8df459622e0d$var$flagTextColor = {
    error: {
        light: "var(--ds-text-inverse, ".concat((0, $jp7ng.N0), ")"),
        dark: "var(--ds-text-inverse, ".concat((0, $jp7ng.DN40), ")")
    },
    info: {
        light: "var(--ds-text-inverse, ".concat((0, $jp7ng.N0), ")"),
        dark: "var(--ds-text-inverse, ".concat((0, $jp7ng.DN600), ")")
    },
    normal: {
        light: "var(--ds-text-subtle, ".concat((0, $jp7ng.N500), ")"),
        dark: "var(--ds-text-subtle, ".concat((0, $jp7ng.DN600), ")")
    },
    success: {
        light: "var(--ds-text-inverse, ".concat((0, $jp7ng.N0), ")"),
        dark: "var(--ds-text-inverse, ".concat((0, $jp7ng.DN40), ")")
    },
    warning: {
        light: "var(--ds-text-warning-inverse, ".concat((0, $jp7ng.N700), ")"),
        dark: "var(--ds-text-warning-inverse, ".concat((0, $jp7ng.DN40), ")")
    }
};
var $39cc8df459622e0d$export$1e00658f62be5348 = function getFlagTextColor(appearance, mode) {
    return $39cc8df459622e0d$var$flagTextColor[appearance][mode];
};
var $39cc8df459622e0d$export$4c078ac312f2523f = function getFlagIconColor(appearance, mode) {
    return $39cc8df459622e0d$var$flagIconColor[appearance][mode];
};
var $39cc8df459622e0d$var$flagFocusRingColor = {
    error: {
        light: "var(--ds-border-focused, ".concat((0, $jp7ng.N40), ")"),
        dark: "var(--ds-border-focused, ".concat((0, $jp7ng.N40), ")")
    },
    info: {
        light: "var(--ds-border-focused, ".concat((0, $jp7ng.N40), ")"),
        dark: "var(--ds-border-focused, ".concat((0, $jp7ng.N40), ")")
    },
    normal: {
        light: "var(--ds-border-focused, ".concat((0, $jp7ng.B100), ")"),
        dark: "var(--ds-border-focused, ".concat((0, $jp7ng.B100), ")")
    },
    success: {
        light: "var(--ds-border-focused, ".concat((0, $jp7ng.N40), ")"),
        dark: "var(--ds-border-focused, ".concat((0, $jp7ng.N40), ")")
    },
    warning: {
        light: "var(--ds-border-focused, ".concat((0, $jp7ng.N200), ")"),
        dark: "var(--ds-border-focused, ".concat((0, $jp7ng.N200), ")")
    }
};
var $39cc8df459622e0d$export$189aab3d402d4f43 = function getFlagFocusRingColor(appearance, mode) {
    return $39cc8df459622e0d$var$flagFocusRingColor[appearance][mode];
};
var $39cc8df459622e0d$var$lightButtonBackground = "rgba(255, 255, 255, 0.08)"; // TODO: DSP-2519 Interaction tokens should be used for hovered and pressed states
// https://product-fabric.atlassian.net/browse/DSP-2519
var $39cc8df459622e0d$var$actionBackground = {
    success: {
        light: "var(--ds-background-neutral, ".concat($39cc8df459622e0d$var$lightButtonBackground, ")"),
        dark: "var(--ds-background-neutral, ".concat((0, $jp7ng.N30A), ")")
    },
    info: {
        light: "var(--ds-background-neutral, ".concat($39cc8df459622e0d$var$lightButtonBackground, ")"),
        dark: "var(--ds-background-neutral, ".concat($39cc8df459622e0d$var$lightButtonBackground, ")")
    },
    error: {
        light: "var(--ds-background-neutral, ".concat($39cc8df459622e0d$var$lightButtonBackground, ")"),
        dark: "var(--ds-background-neutral, ".concat((0, $jp7ng.N30A), ")")
    },
    warning: {
        light: "var(--ds-background-neutral, ".concat((0, $jp7ng.N30A), ")"),
        dark: "var(--ds-background-neutral, ".concat((0, $jp7ng.N30A), ")")
    },
    normal: {
        light: "none",
        dark: "none"
    }
};
var $39cc8df459622e0d$var$actionColor = {
    success: {
        light: "var(--ds-text-inverse, ".concat((0, $jp7ng.N0), ")"),
        dark: "var(--ds-text-inverse, ".concat((0, $jp7ng.DN40), ")")
    },
    info: {
        light: "var(--ds-text-inverse, ".concat((0, $jp7ng.N0), ")"),
        dark: "var(--ds-text-inverse, ".concat((0, $jp7ng.DN600), ")")
    },
    error: {
        light: "var(--ds-text-inverse, ".concat((0, $jp7ng.N0), ")"),
        dark: "var(--ds-text-inverse, ".concat((0, $jp7ng.DN600), ")")
    },
    warning: {
        light: "var(--ds-text-warning-inverse, ".concat((0, $jp7ng.N700), ")"),
        dark: "var(--ds-text-warning-inverse, ".concat((0, $jp7ng.DN40), ")")
    },
    normal: {
        light: "var(--ds-link, ".concat((0, $jp7ng.B400), ")"),
        dark: "var(--ds-link, ".concat((0, $jp7ng.B100), ")")
    }
};
var $39cc8df459622e0d$export$1c67b7858bd5491 = function getActionBackground(appearance, mode) {
    return $39cc8df459622e0d$var$actionBackground[appearance][mode];
};
var $39cc8df459622e0d$export$dad14efd26ada932 = function getActionColor(appearance, mode) {
    return $39cc8df459622e0d$var$actionColor[appearance][mode];
};

});

parcelRegister("80G4D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d4ef5c6acd14305$export$2e2bcd8739ae039; });
/* eslint-disable @repo/internal/styles/no-nested-styles */ /** @jsx jsx */ 
var $avKww = parcelRequire("avKww");

var $EKmRU = parcelRequire("EKmRU");

var $aP6k3 = parcelRequire("aP6k3");

var $7eV0A = parcelRequire("7eV0A");

var $4XF6k = parcelRequire("4XF6k");
var $5d4ef5c6acd14305$var$gridSize = (0, $aP6k3.gridSize)();
var $5d4ef5c6acd14305$var$separatorWidth = $5d4ef5c6acd14305$var$gridSize * 2;
var $5d4ef5c6acd14305$var$defaultAppearanceTranslate = $5d4ef5c6acd14305$var$gridSize / 4;
var $5d4ef5c6acd14305$var$separatorStyles = (0, $avKww.css)({
    display: "inline-block",
    width: $5d4ef5c6acd14305$var$separatorWidth,
    textAlign: "center"
});
var $5d4ef5c6acd14305$var$actionContainerStyles = (0, $avKww.css)({
    display: "flex",
    paddingTop: $5d4ef5c6acd14305$var$gridSize,
    alignItems: "center",
    flexWrap: "wrap",
    transform: "translateX(-".concat($5d4ef5c6acd14305$var$defaultAppearanceTranslate, "px)")
});
var $5d4ef5c6acd14305$var$boldActionContainerStyles = (0, $avKww.css)({
    transform: 0
});
var $5d4ef5c6acd14305$var$buttonStyles = (0, $avKww.css)({
    "&&, a&&": {
        marginLeft: 0,
        padding: "0 ".concat($5d4ef5c6acd14305$var$gridSize, "px !important"),
        background: "var(--bg-color)",
        color: "var(--color) !important",
        fontWeight: 500
    },
    "&&:focus, a&&:focus": {
        boxShadow: "0 0 0 2px var(--focus-color)"
    },
    "&&:hover, &&:active, a&&:hover, a&&:active": {
        textDecoration: "underline"
    }
});
var $5d4ef5c6acd14305$var$appeanceNormalButtonStyles = (0, $avKww.css)({
    "&&, a&&": {
        padding: "0 !important"
    }
});
var $5d4ef5c6acd14305$var$isBoldButtonStyles = (0, $avKww.css)({
    "&&, a&&": {
        marginRight: $5d4ef5c6acd14305$var$gridSize
    }
});
var $5d4ef5c6acd14305$var$FlagActions = function FlagActions(props) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $7eV0A.DEFAULT_APPEARANCE) : _props$appearance, _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, linkComponent = props.linkComponent, mode = props.mode, testId = props.testId;
    if (!actions.length) return null;
    var isBold = appearance !== (0, $7eV0A.DEFAULT_APPEARANCE);
    return (0, $avKww.jsx)("div", {
        css: [
            $5d4ef5c6acd14305$var$actionContainerStyles,
            isBold && $5d4ef5c6acd14305$var$boldActionContainerStyles
        ],
        "data-testid": testId && "".concat(testId, "-actions")
    }, actions.map(function(action, index) {
        return [
            index && !isBold ? (0, $avKww.jsx)("div", {
                css: $5d4ef5c6acd14305$var$separatorStyles,
                key: index + 0.5
            }, "\xb7") : "",
            (0, $avKww.jsx)((0, $EKmRU.default), {
                onClick: action.onClick,
                href: action.href,
                target: action.target,
                appearance: isBold ? "default" : "link",
                component: linkComponent,
                spacing: "compact",
                testId: action.testId,
                key: index,
                style: {
                    "--color": (0, $4XF6k.getActionColor)(appearance, mode),
                    "--bg-color": (0, $4XF6k.getActionBackground)(appearance, mode),
                    "--focus-color": (0, $4XF6k.getFlagFocusRingColor)(appearance, mode)
                },
                css: [
                    $5d4ef5c6acd14305$var$buttonStyles,
                    isBold && $5d4ef5c6acd14305$var$isBoldButtonStyles,
                    appearance === "normal" && $5d4ef5c6acd14305$var$appeanceNormalButtonStyles
                ]
            }, action.content)
        ];
    }));
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $5d4ef5c6acd14305$export$2e2bcd8739ae039 = $5d4ef5c6acd14305$var$FlagActions;

});
parcelRegister("EKmRU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07a7b43ad7b4058f$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9q1kH = parcelRequire("9q1kH");

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $5LVXk = parcelRequire("5LVXk");

var $bEPAN = parcelRequire("bEPAN");

var $34CoA = parcelRequire("34CoA");

var $28Rb4 = parcelRequire("28Rb4");

var $5PCdb = parcelRequire("5PCdb");
var $07a7b43ad7b4058f$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isSelected",
    "shouldFitContainer",
    "spacing",
    "isLoading",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseDown",
    "onMouseUp",
    "onFocus",
    "onBlur",
    "theme"
];
function $07a7b43ad7b4058f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $07a7b43ad7b4058f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $07a7b43ad7b4058f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $07a7b43ad7b4058f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $07a7b43ad7b4058f$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return "disabled";
    if (isSelected && isFocus) return "focusSelected";
    if (isSelected) return "selected";
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return "active";
    if (!isLoading && isHover) return "hover";
    if (isFocus) return "focus";
    return "default";
}
var $07a7b43ad7b4058f$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var $07a7b43ad7b4058f$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $5PCdb.defaultThemeFn) : _ref2$theme, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref2, $07a7b43ad7b4058f$var$_excluded);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $07a7b43ad7b4058f$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $9nHZC.useState)($07a7b43ad7b4058f$var$initial), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $07a7b43ad7b4058f$var$_objectSpread($07a7b43ad7b4058f$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $07a7b43ad7b4058f$var$_objectSpread($07a7b43ad7b4058f$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $07a7b43ad7b4058f$var$_objectSpread($07a7b43ad7b4058f$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $07a7b43ad7b4058f$var$_objectSpread($07a7b43ad7b4058f$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $07a7b43ad7b4058f$var$_objectSpread($07a7b43ad7b4058f$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $07a7b43ad7b4058f$var$_objectSpread($07a7b43ad7b4058f$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5PCdb.default).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5LVXk.default).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5PCdb.default).Consumer, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            mode: mode,
            state: $07a7b43ad7b4058f$var$getInteractionState($07a7b43ad7b4058f$var$_objectSpread($07a7b43ad7b4058f$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $34CoA.default)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $bEPAN.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $28Rb4.default), restProps) : null,
                "aria-disabled": isLoading || undefined,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $5PCdb.getSpecifiers)(buttonStyles)
            }));
        });
    }));
}));
// Tools including enzyme rely on components having a display name
$07a7b43ad7b4058f$var$CustomThemeButton.displayName = "CustomThemeButton";
var $07a7b43ad7b4058f$export$2e2bcd8739ae039 = $07a7b43ad7b4058f$var$CustomThemeButton;

});
parcelRegister("28Rb4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18f594191ec9b4c8$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $kgQq4 = parcelRequire("kgQq4");
function $18f594191ec9b4c8$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return "inherit";
    if (isSelected) return "invert";
    if (appearance === "primary" || appearance === "danger") return "invert";
    return "inherit";
}
function $18f594191ec9b4c8$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing;
    var size = spacing === "default" ? "medium" : "small";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kgQq4.default), {
        size: size,
        label: ", Loading",
        appearance: $18f594191ec9b4c8$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});
parcelRegister("kgQq4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec1df6ada0b9a732$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $5fUc4 = parcelRequire("5fUc4");

var $gnoj6 = parcelRequire("gnoj6");

var $lk3TE = parcelRequire("lk3TE");
/**
 * Returns the appropriate circle stroke color.
 */ function $ec1df6ada0b9a732$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $gnoj6.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $gnoj6.N0), ")");
}
var $ec1df6ada0b9a732$var$rotate = (0, $avKww.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $ec1df6ada0b9a732$var$rotateStyles = (0, $avKww.css)({
    animation: "".concat($ec1df6ada0b9a732$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $ec1df6ada0b9a732$var$loadIn = (0, $avKww.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $ec1df6ada0b9a732$var$loadInStyles = (0, $avKww.css)({
    animation: "".concat($ec1df6ada0b9a732$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $ec1df6ada0b9a732$var$wrapperStyles = (0, $avKww.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $ec1df6ada0b9a732$var$circleStyles = (0, $avKww.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $ec1df6ada0b9a732$var$useLayoutEffect = typeof window === "undefined" ? (0, $9nHZC.useEffect) : (0, $9nHZC.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $ec1df6ada0b9a732$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $lk3TE.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $ec1df6ada0b9a732$var$getStrokeColor(appearance);
    var context = (0, $9nHZC.useContext)((0, $5fUc4.default));
    $ec1df6ada0b9a732$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $avKww.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $ec1df6ada0b9a732$var$wrapperStyles,
            $ec1df6ada0b9a732$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $avKww.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $ec1df6ada0b9a732$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none"
    }, (0, $avKww.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $ec1df6ada0b9a732$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $ec1df6ada0b9a732$export$2e2bcd8739ae039 = $ec1df6ada0b9a732$var$Spinner;

});
parcelRegister("gnoj6", function(module, exports) {

$parcel$export(module.exports, "N0", function () { return $0313a3b67dbb8825$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $0313a3b67dbb8825$export$c39c0fe0f26207ae; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $0313a3b67dbb8825$export$4b84fd0e2c617bd = "#FFEBE6";
var $0313a3b67dbb8825$export$b34b069eff244586 = "#FFBDAD";
var $0313a3b67dbb8825$export$be802dd0d8b57f35 = "#FF8F73";
var $0313a3b67dbb8825$export$60847d42f9da92a6 = "#FF7452";
var $0313a3b67dbb8825$export$4a7404f376229999 = "#FF5630";
var $0313a3b67dbb8825$export$2010d0fb4295b346 = "#DE350B";
var $0313a3b67dbb8825$export$2837b5a1a71d5c02 = "#BF2600";
var $0313a3b67dbb8825$export$8d9596b529bbb9cf = "#FFFAE6";
var $0313a3b67dbb8825$export$41060a744ab0b7ae = "#FFF0B3";
var $0313a3b67dbb8825$export$1cc05bbbf340e559 = "#FFE380";
var $0313a3b67dbb8825$export$5aae31392d72caaa = "#FFC400";
var $0313a3b67dbb8825$export$c6930421db9fa514 = "#FFAB00";
var $0313a3b67dbb8825$export$59619663aa6500fb = "#FF991F";
var $0313a3b67dbb8825$export$874739ea9e379ab6 = "#FF8B00";
var $0313a3b67dbb8825$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $0313a3b67dbb8825$export$69a3bf21b9686c2b = "#ABF5D1";
var $0313a3b67dbb8825$export$afbce1382ec95f73 = "#79F2C0";
var $0313a3b67dbb8825$export$747d86715d4175de = "#57D9A3";
var $0313a3b67dbb8825$export$940e1f69e873f202 = "#36B37E";
var $0313a3b67dbb8825$export$a49394138f7b8e85 = "#00875A";
var $0313a3b67dbb8825$export$6fa04827ac68a4fb = "#006644";
var $0313a3b67dbb8825$export$226de0355ed012f8 = "#DEEBFF";
var $0313a3b67dbb8825$export$8c13c2ee36917869 = "#B3D4FF";
var $0313a3b67dbb8825$export$ecfc1dff386a3e7a = "#4C9AFF";
var $0313a3b67dbb8825$export$215b7063051591f1 = "#2684FF";
var $0313a3b67dbb8825$export$e62e8919cca44969 = "#0065FF";
var $0313a3b67dbb8825$export$b3de0ae08da2ce64 = "#0052CC";
var $0313a3b67dbb8825$export$a6ee3d71bc067634 = "#0747A6";
var $0313a3b67dbb8825$export$363e4475840015bb = "#EAE6FF";
var $0313a3b67dbb8825$export$4b0a4417ed59760f = "#C0B6F2";
var $0313a3b67dbb8825$export$6011520a64d9a187 = "#998DD9";
var $0313a3b67dbb8825$export$a7175d4e9206bc80 = "#8777D9";
var $0313a3b67dbb8825$export$b48405b95304b5a1 = "#6554C0";
var $0313a3b67dbb8825$export$c71e4279dd54a18d = "#5243AA";
var $0313a3b67dbb8825$export$147899de772240ec = "#403294";
var $0313a3b67dbb8825$export$2cf711fe14c66f06 = "#E6FCFF";
var $0313a3b67dbb8825$export$7a8f4d33f6f9772c = "#B3F5FF";
var $0313a3b67dbb8825$export$776c9c497ef08533 = "#79E2F2";
var $0313a3b67dbb8825$export$69cb3ca10c1e330e = "#00C7E6";
var $0313a3b67dbb8825$export$9dc1ef0f3f48059b = "#00B8D9";
var $0313a3b67dbb8825$export$7c835c78b6fcdef8 = "#00A3BF";
var $0313a3b67dbb8825$export$6036577f95c3877e = "#008DA6";
var $0313a3b67dbb8825$export$29a4f05edc054374 = "#FFFFFF";
var $0313a3b67dbb8825$export$e655ef011c4aa1a2 = "#FAFBFC";
var $0313a3b67dbb8825$export$9fdfb749e33cdf97 = "#F4F5F7";
var $0313a3b67dbb8825$export$3e51e8f1440314ba = "#EBECF0";
var $0313a3b67dbb8825$export$1ce2d1575d444ceb = "#DFE1E6";
var $0313a3b67dbb8825$export$8754fc7e6d8b3000 = "#C1C7D0";
var $0313a3b67dbb8825$export$c2e91cbeada39b8b = "#B3BAC5";
var $0313a3b67dbb8825$export$5f71e19f3a7ad9de = "#A5ADBA";
var $0313a3b67dbb8825$export$eaa8c8a70ac22806 = "#97A0AF";
var $0313a3b67dbb8825$export$7c87d337fb91a97d = "#8993A4";
var $0313a3b67dbb8825$export$d6447c357493214f = "#7A869A";
var $0313a3b67dbb8825$export$f563ee71e9ee74cd = "#6B778C";
var $0313a3b67dbb8825$export$e2ef2124cf4024b1 = "#5E6C84";
var $0313a3b67dbb8825$export$eece5f492e429f08 = "#505F79";
var $0313a3b67dbb8825$export$c39c0fe0f26207ae = "#42526E";
var $0313a3b67dbb8825$export$7090862dc3038a9f = "#344563";
var $0313a3b67dbb8825$export$ad0bacf983b7ddaa = "#253858";
var $0313a3b67dbb8825$export$7d61b15e0da132af = "#172B4D";
var $0313a3b67dbb8825$export$fbda843f0a27fe96 = "#091E42";
var $0313a3b67dbb8825$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $0313a3b67dbb8825$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $0313a3b67dbb8825$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $0313a3b67dbb8825$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $0313a3b67dbb8825$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $0313a3b67dbb8825$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $0313a3b67dbb8825$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $0313a3b67dbb8825$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $0313a3b67dbb8825$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $0313a3b67dbb8825$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $0313a3b67dbb8825$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $0313a3b67dbb8825$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $0313a3b67dbb8825$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $0313a3b67dbb8825$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $0313a3b67dbb8825$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $0313a3b67dbb8825$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $0313a3b67dbb8825$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $0313a3b67dbb8825$export$2f6319cf7d736c2a = "#E6EDFA";
var $0313a3b67dbb8825$export$95126bc8884d6634 = "#DCE5F5";
var $0313a3b67dbb8825$export$8338d8c35d44ff1 = "#CED9EB";
var $0313a3b67dbb8825$export$5368d76ae4fbbda7 = "#B8C7E0";
var $0313a3b67dbb8825$export$9f0a771d16ec8d36 = "#ABBBD6";
var $0313a3b67dbb8825$export$abcf8c38338b4aa5 = "#9FB0CC";
var $0313a3b67dbb8825$export$97e81faa16a182c7 = "#8C9CB8";
var $0313a3b67dbb8825$export$bfe21c59123ecf33 = "#7988A3";
var $0313a3b67dbb8825$export$ee82aa2ea6a1558 = "#67758F";
var $0313a3b67dbb8825$export$682927c6ed76be02 = "#56637A";
var $0313a3b67dbb8825$export$91fd9994c5be9757 = "#455166";
var $0313a3b67dbb8825$export$d281fbfe3cff2df6 = "#3B475C";
var $0313a3b67dbb8825$export$3902c91d8b98a753 = "#313D52";
var $0313a3b67dbb8825$export$8e8133c1ba5845b5 = "#283447";
var $0313a3b67dbb8825$export$33ff357f6620b39 = "#202B3D";
var $0313a3b67dbb8825$export$633847cf062b69e0 = "#1B2638";
var $0313a3b67dbb8825$export$9776a6e503bdbf76 = "#121A29";
var $0313a3b67dbb8825$export$6c813d5160dff5db = "#0E1624";
var $0313a3b67dbb8825$export$3d4f271a500072a = "#0D1424";
var $0313a3b67dbb8825$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $0313a3b67dbb8825$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $0313a3b67dbb8825$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $0313a3b67dbb8825$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $0313a3b67dbb8825$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $0313a3b67dbb8825$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $0313a3b67dbb8825$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $0313a3b67dbb8825$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $0313a3b67dbb8825$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $0313a3b67dbb8825$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $0313a3b67dbb8825$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $0313a3b67dbb8825$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $0313a3b67dbb8825$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $0313a3b67dbb8825$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $0313a3b67dbb8825$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $0313a3b67dbb8825$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $0313a3b67dbb8825$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";

});

parcelRegister("lk3TE", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $f85e7d006cda3984$export$4e9f1640bbe7a1a8; });
var $f85e7d006cda3984$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});



parcelRegister("5PCdb", function(module, exports) {

$parcel$export(module.exports, "getSpecifiers", function () { return $43ef5b2f253dbeff$export$643db0b8d8778e; });
$parcel$export(module.exports, "defaultThemeFn", function () { return $43ef5b2f253dbeff$export$437a7f77d13d7916; });
$parcel$export(module.exports, "default", function () { return $43ef5b2f253dbeff$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $dHFxE = parcelRequire("dHFxE");

var $arbqi = parcelRequire("arbqi");
function $43ef5b2f253dbeff$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $43ef5b2f253dbeff$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $43ef5b2f253dbeff$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $43ef5b2f253dbeff$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $43ef5b2f253dbeff$var$stateToSelectorMap = {
    focus: "&:focus",
    focusSelected: "&:focus",
    hover: "&:hover",
    active: "&:active",
    disabled: "&[disabled]"
};
function $43ef5b2f253dbeff$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? "light" : _ref$mode, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $arbqi.getCss)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = "none";
    // Pulling relevant styles up to the top level
    var selector = $43ef5b2f253dbeff$var$stateToSelectorMap[state];
    if (selector) result = $43ef5b2f253dbeff$var$_objectSpread($43ef5b2f253dbeff$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $43ef5b2f253dbeff$var$_objectSpread($43ef5b2f253dbeff$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === "&::-moz-focus-inner") return;
        // Not using .startsWith for ie11
        if (key.indexOf("&") === 0) delete result[key];
    });
    return result;
}
function $43ef5b2f253dbeff$export$643db0b8d8778e(styles) {
    return {
        "&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]": styles
    };
}
function $43ef5b2f253dbeff$export$437a7f77d13d7916(current, values) {
    return current(values);
}
var $43ef5b2f253dbeff$var$Theme = (0, $dHFxE.createTheme)(function(themeProps) {
    return {
        buttonStyles: $43ef5b2f253dbeff$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$43ef5b2f253dbeff$export$2e2bcd8739ae039 = $43ef5b2f253dbeff$var$Theme;

});



parcelRegister("kcqww", function(module, exports) {

$parcel$export(module.exports, "useFlagGroup", function () { return $eb4980a83e7596c9$export$e91ea202abb66350; });
$parcel$export(module.exports, "default", function () { return $eb4980a83e7596c9$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $340K4 = parcelRequire("340K4");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $6ZCxy = parcelRequire("6ZCxy");
var $JcvLo = parcelRequire("JcvLo");
var $5FaFu = parcelRequire("5FaFu");

var $7S7GL = parcelRequire("7S7GL");

var $8p2GL = parcelRequire("8p2GL");

var $97YIy = parcelRequire("97YIy");

var $aP6k3 = parcelRequire("aP6k3");
var $eb4980a83e7596c9$var$gridSize = (0, $aP6k3.gridSize)();
var $eb4980a83e7596c9$export$1eee5ddc4f6d41c5 = $eb4980a83e7596c9$var$gridSize * 50;
var $eb4980a83e7596c9$export$a56455a41666bb2a = 400;
var $eb4980a83e7596c9$var$flagBottom = $eb4980a83e7596c9$var$gridSize * 6;
var $eb4980a83e7596c9$var$flagLeft = $eb4980a83e7596c9$var$gridSize * 10;
var $eb4980a83e7596c9$var$defaultFlagGroupContext = {
    onDismissed: (0, $8p2GL.default),
    isDismissAllowed: false
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $eb4980a83e7596c9$export$c57ba665aaa722be = /*#__PURE__*/ (0, $9nHZC.createContext)($eb4980a83e7596c9$var$defaultFlagGroupContext); // eslint-disable-next-line @repo/internal/react/require-jsdoc
function $eb4980a83e7596c9$export$e91ea202abb66350() {
    return (0, $9nHZC.useContext)($eb4980a83e7596c9$export$c57ba665aaa722be);
} // transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
var $eb4980a83e7596c9$var$baseStyles = (0, $avKww.css)({
    width: $eb4980a83e7596c9$export$1eee5ddc4f6d41c5,
    position: "absolute",
    bottom: 0,
    transition: "transform ".concat($eb4980a83e7596c9$export$a56455a41666bb2a, "ms ease-in-out"),
    "@media (max-width: 560px)": {
        width: "100vw"
    },
    ":first-of-type": {
        transform: "translate(0,0)",
        transition: "none"
    },
    ":nth-of-type(n + 2)": {
        animationDuration: "0ms",
        transform: "translateX(0) translateY(100%) translateY(".concat(2 * $eb4980a83e7596c9$var$gridSize, "px)")
    },
    ":nth-of-type(1)": {
        zIndex: 5
    },
    ":nth-of-type(2)": {
        zIndex: 4
    },
    "&:nth-of-type(n + 4)": {
        visibility: "hidden"
    }
}); // Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
var $eb4980a83e7596c9$var$dismissAllowedStyles = (0, $avKww.css)({
    // eslint-disable-next-line @repo/internal/styles/no-nested-styles
    "&& + *": {
        transform: "translate(0, 0)",
        transitionDuration: "".concat($eb4980a83e7596c9$export$a56455a41666bb2a / 2, "ms")
    }
});
var $eb4980a83e7596c9$var$flagGroupContainerStyles = (0, $avKww.css)({
    position: "fixed",
    zIndex: (0, $aP6k3.layers).flag(),
    bottom: $eb4980a83e7596c9$var$flagBottom,
    left: $eb4980a83e7596c9$var$flagLeft,
    "@media (max-width: 560px)": {
        bottom: 0,
        left: 0
    }
});
/**
 * __Flag group__
 *
 * A flag group is used to group a set of related flags, with entry and exit animations.
 *
 * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
 * - [Code](https://atlassian.design/components/flag/flag-group/code)
 */ var $eb4980a83e7596c9$var$FlagGroup = function FlagGroup(props) {
    var id = props.id, _props$label = props.label, label = _props$label === void 0 ? "Flag notifications" : _props$label, _props$labelTag = props.labelTag, LabelTag = _props$labelTag === void 0 ? "h2" : _props$labelTag, children = props.children, _props$onDismissed = props.onDismissed, onDismissed = _props$onDismissed === void 0 ? (0, $8p2GL.default) : _props$onDismissed;
    var hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    var dismissFlagContext = (0, $9nHZC.useMemo)(function() {
        return {
            onDismissed: onDismissed,
            isDismissAllowed: true
        };
    }, [
        onDismissed
    ]);
    var renderChildren = function renderChildren() {
        return children && (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(children) === "object" ? (0, $9nHZC.Children).map(children, function(flag, index) {
            var isDismissAllowed = index === 0;
            return (0, $avKww.jsx)((0, $5FaFu.default), {
                enterFrom: "left",
                fade: "inout",
                duration: $eb4980a83e7596c9$export$a56455a41666bb2a,
                animationTimingFunction: function animationTimingFunction() {
                    return 0, $6ZCxy.easeIn;
                }
            }, function(props) {
                return (0, $avKww.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
                    css: [
                        $eb4980a83e7596c9$var$baseStyles,
                        isDismissAllowed && $eb4980a83e7596c9$var$dismissAllowedStyles
                    ]
                }), (0, $avKww.jsx)($eb4980a83e7596c9$export$c57ba665aaa722be.Provider, {
                    value: isDismissAllowed ? dismissFlagContext : $eb4980a83e7596c9$var$defaultFlagGroupContext
                }, flag));
            });
        }) : false;
    };
    return (0, $avKww.jsx)((0, $97YIy.default), {
        zIndex: (0, $aP6k3.layers).flag()
    }, (0, $avKww.jsx)("div", {
        id: id,
        css: $eb4980a83e7596c9$var$flagGroupContainerStyles
    }, hasFlags ? (0, $avKww.jsx)((0, $7S7GL.default), null, (0, $avKww.jsx)(LabelTag, null, label)) : null, (0, $avKww.jsx)((0, $JcvLo.default), {
        appear: false
    }, renderChildren())));
};
var $eb4980a83e7596c9$export$2e2bcd8739ae039 = $eb4980a83e7596c9$var$FlagGroup;

});
parcelRegister("5FaFu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41f90e91ae6ccfe8$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $6ZCxy = parcelRequire("6ZCxy");

var $htChF = parcelRequire("htChF");

var $lq4He = parcelRequire("lq4He");
var $41f90e91ae6ccfe8$export$97192c8fa0d5e26b = function slideInAnimation(from, state, fade) {
    var _ref;
    var initial = state === "entering" ? "0%" : "100%";
    var end = state === "entering" ? "100%" : "0%";
    var fromMap = {
        top: "translate3d(0, -100%, 0)",
        right: "translate3d(100%, 0, 0)",
        bottom: "translate3d(0, 100%, 0)",
        left: "translate3d(-100%, 0, 0)"
    };
    var animateOpacity = fade === "inout" || fade === "in" && state === "entering" || fade === "out" && state === "exiting";
    return _ref = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref, initial, {
        transform: fromMap[from],
        opacity: animateOpacity ? 0 : 1
    }), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref, end, {
        transform: "none",
        opacity: 1
    }), _ref;
};
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions).
 */ var $41f90e91ae6ccfe8$var$SlideIn = function SlideIn(_ref2) {
    var children = _ref2.children, enterFrom = _ref2.enterFrom, exitTo = _ref2.exitTo, _ref2$fade = _ref2.fade, fade = _ref2$fade === void 0 ? "none" : _ref2$fade, _ref2$duration = _ref2.duration, duration = _ref2$duration === void 0 ? (0, $htChF.mediumDurationMs) : _ref2$duration, isPaused = _ref2.isPaused, onFinish = _ref2.onFinish, _ref2$animationTiming = _ref2.animationTimingFunction, animationTimingFunction = _ref2$animationTiming === void 0 ? function(state) {
        return state === "entering" ? (0, $6ZCxy.easeOut) : (0, $6ZCxy.easeIn);
    } : _ref2$animationTiming;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $lq4He.default), {
        duration: duration,
        enteringAnimation: $41f90e91ae6ccfe8$export$97192c8fa0d5e26b(enterFrom, "entering", fade),
        exitingAnimation: $41f90e91ae6ccfe8$export$97192c8fa0d5e26b(exitTo || enterFrom, "exiting", fade),
        animationTimingFunction: animationTimingFunction,
        isPaused: isPaused,
        onFinish: onFinish
    }, children);
};
var $41f90e91ae6ccfe8$export$2e2bcd8739ae039 = $41f90e91ae6ccfe8$var$SlideIn;

});


parcelRegister("b5Rto", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8139a3fbd92d03c9$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $avKww = parcelRequire("avKww");
var $8139a3fbd92d03c9$var$descriptionStyles = (0, $avKww.css)({
    maxHeight: 100,
    // height is defined as 5 lines maximum by design
    overflow: "auto",
    wordWrap: "break-word"
});
var $8139a3fbd92d03c9$var$Description = function Description(_ref) {
    var color = _ref.color, testId = _ref.testId, children = _ref.children, isBold = _ref.isBold;
    return (0, $avKww.jsx)("div", {
        style: {
            color: color
        },
        css: [
            $8139a3fbd92d03c9$var$descriptionStyles
        ],
        "data-testid": testId
    }, children);
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $8139a3fbd92d03c9$export$2e2bcd8739ae039 = $8139a3fbd92d03c9$var$Description;

});

parcelRegister("i2w52", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2214c60d8c81829$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $dxhCu = parcelRequire("dxhCu");

var $ejBJs = parcelRequire("ejBJs");

var $938FP = parcelRequire("938FP");

var $8rgle = parcelRequire("8rgle");

var $aP6k3 = parcelRequire("aP6k3");

var $5LVXk = parcelRequire("5LVXk");

var $4XF6k = parcelRequire("4XF6k");
var $d2214c60d8c81829$var$gridSize = (0, $aP6k3.gridSize)();
var $d2214c60d8c81829$var$borderRadius = (0, $aP6k3.borderRadius)();
var $d2214c60d8c81829$var$dismissButtonStyles = (0, $avKww.css)({
    marginLeft: $d2214c60d8c81829$var$gridSize,
    padding: 0,
    flex: "0 0 auto",
    appearance: "none",
    background: "none",
    border: "none",
    borderRadius: $d2214c60d8c81829$var$borderRadius,
    cursor: "pointer",
    lineHeight: "1",
    whiteSpace: "nowrap"
});
var $d2214c60d8c81829$var$crossIconStyles = (0, $avKww.css)({
    paddingTop: "".concat($d2214c60d8c81829$var$gridSize, "px")
});
var $d2214c60d8c81829$var$DismissButton = function DismissButton(_ref) {
    var appearance = _ref.appearance, onClick = _ref.onClick, isBold = _ref.isBold, isExpanded = _ref.isExpanded, testId = _ref.testId;
    var _useGlobalTheme = (0, $5LVXk.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($8rgle)));
    var buttonLabel = "Dismiss";
    var size = "small";
    var buttonTestId = testId && "".concat(testId, "-dismiss");
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($938FP))) : (0, (/*@__PURE__*/$parcel$interopDefault($ejBJs)));
        buttonLabel = isExpanded ? "Collapse" : "Expand";
        size = "large";
        buttonTestId = testId && "".concat(testId, "-toggle");
    }
    return (0, $avKww.jsx)((0, $dxhCu.default), null, (0, $avKww.jsx)("button", {
        style: {
            color: (0, $4XF6k.getFlagTextColor)(appearance, mode)
        },
        css: [
            $d2214c60d8c81829$var$dismissButtonStyles,
            !isBold && $d2214c60d8c81829$var$crossIconStyles
        ],
        onClick: onClick,
        "data-testid": buttonTestId,
        type: "button",
        "aria-expanded": isBold ? isExpanded : undefined
    }, (0, $avKww.jsx)(ButtonIcon, {
        label: buttonLabel,
        size: size
    })));
};
var $d2214c60d8c81829$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $9nHZC.memo)($d2214c60d8c81829$var$DismissButton);

});
parcelRegister("ejBJs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6c01bd7e7150e50$var$_react = $a6c01bd7e7150e50$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $fO6ad = parcelRequire("fO6ad");
function $a6c01bd7e7150e50$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a6c01bd7e7150e50$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $a6c01bd7e7150e50$var$_react.default.createElement($fO6ad.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M8.292 10.293a1.009 1.009 0 000 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 000-1.419.987.987 0 00-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 00-1.406 0z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$a6c01bd7e7150e50$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $a6c01bd7e7150e50$var$_default = $a6c01bd7e7150e50$var$ChevronDownIcon;
module.exports.default = $a6c01bd7e7150e50$var$_default;

});
parcelRegister("fO6ad", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $b8204e8aa22bc4a8$export$f04a61298a47a40f; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $5LVXk = parcelRequire("5LVXk");

var $bkAhl = parcelRequire("bkAhl");

var $bgi5b = parcelRequire("bgi5b");
function $b8204e8aa22bc4a8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b8204e8aa22bc4a8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b8204e8aa22bc4a8$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b8204e8aa22bc4a8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $b8204e8aa22bc4a8$var$iconStyles = (0, $avKww.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "> svg": $b8204e8aa22bc4a8$var$_objectSpread($b8204e8aa22bc4a8$var$_objectSpread({}, (0, $bgi5b.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $b8204e8aa22bc4a8$var$baseHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $b8204e8aa22bc4a8$var$primaryEqualsSecondaryHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $b8204e8aa22bc4a8$var$secondaryTransparentHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $b8204e8aa22bc4a8$export$f04a61298a47a40f = /*#__PURE__*/ (0, $9nHZC.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $avKww.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $bgi5b.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    var _useGlobalTheme = (0, $5LVXk.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $avKww.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            "--icon-secondary-color": secondaryColor || (0, $bkAhl.getBackground)(mode)
        }
    }, glyphProps, {
        css: [
            $b8204e8aa22bc4a8$var$iconStyles,
            $b8204e8aa22bc4a8$var$baseHcmStyles,
            primaryColor === secondaryColor && $b8204e8aa22bc4a8$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $b8204e8aa22bc4a8$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsualting them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $avKww.css)({
                width: dimensions.width,
                height: dimensions.height,
                "> svg": dimensions
            })
        ]
    }));
});
var $b8204e8aa22bc4a8$export$2e2bcd8739ae039 = $b8204e8aa22bc4a8$export$f04a61298a47a40f;

});
parcelRegister("bkAhl", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $83fdb42a1eb5a6b2$export$18cb9425622d4e06; });
var $83fdb42a1eb5a6b2$var$themedBackground = {
    light: "var(--ds-surface, #FFFFFF)",
    dark: "var(--ds-surface, #1B2638)"
};
var $83fdb42a1eb5a6b2$export$18cb9425622d4e06 = function getBackground() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "light";
    return $83fdb42a1eb5a6b2$var$themedBackground[mode];
};

});

parcelRegister("bgi5b", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $832f372793a100d8$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $832f372793a100d8$export$3eb7d6130acfda37; });

var $ijk3x = parcelRequire("ijk3x");

var $avKww = parcelRequire("avKww");
var $832f372793a100d8$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
var $832f372793a100d8$var$smallStyles = (0, $avKww.css)((0, $ijk3x.dimensions).small);
var $832f372793a100d8$var$mediumStyles = (0, $avKww.css)((0, $ijk3x.dimensions).medium);
var $832f372793a100d8$var$largeStyles = (0, $avKww.css)((0, $ijk3x.dimensions).large);
var $832f372793a100d8$var$xlargeStyles = (0, $avKww.css)((0, $ijk3x.dimensions).xlarge);
var $832f372793a100d8$export$ef0ad74202575b64 = {
    small: $832f372793a100d8$var$smallStyles,
    medium: $832f372793a100d8$var$mediumStyles,
    large: $832f372793a100d8$var$largeStyles,
    xlarge: $832f372793a100d8$var$xlargeStyles
};
var $832f372793a100d8$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $ijk3x.dimensions)[size];
    return undefined;
};

});
parcelRegister("ijk3x", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $d5498f147821f2e0$export$62ad7b0c781000e9; });
var $d5498f147821f2e0$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $d5498f147821f2e0$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $d5498f147821f2e0$export$62ad7b0c781000e9 = {
    small: {
        width: $d5498f147821f2e0$export$c647cb0ee6e282fe.small,
        height: $d5498f147821f2e0$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $d5498f147821f2e0$export$c647cb0ee6e282fe.medium,
        height: $d5498f147821f2e0$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $d5498f147821f2e0$export$c647cb0ee6e282fe.large,
        height: $d5498f147821f2e0$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $d5498f147821f2e0$export$c647cb0ee6e282fe.xlarge,
        height: $d5498f147821f2e0$export$c647cb0ee6e282fe.xlarge
    }
};

});




parcelRegister("938FP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $696b1f452ccc511e$var$_react = $696b1f452ccc511e$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $fO6ad = parcelRequire("fO6ad");
function $696b1f452ccc511e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $696b1f452ccc511e$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $696b1f452ccc511e$var$_react.default.createElement($fO6ad.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.221 9.322l-2.929 2.955a1.009 1.009 0 000 1.419.986.986 0 001.405 0l2.298-2.317 2.307 2.327a.989.989 0 001.407 0 1.01 1.01 0 000-1.419l-2.94-2.965A1.106 1.106 0 0011.991 9c-.279 0-.557.107-.77.322z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$696b1f452ccc511e$var$ChevronUpIcon.displayName = "ChevronUpIcon";
var $696b1f452ccc511e$var$_default = $696b1f452ccc511e$var$ChevronUpIcon;
module.exports.default = $696b1f452ccc511e$var$_default;

});

parcelRegister("8rgle", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $624d85670c8e6e3a$var$_react = $624d85670c8e6e3a$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $fO6ad = parcelRequire("fO6ad");
function $624d85670c8e6e3a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $624d85670c8e6e3a$var$CrossIcon = (props)=>/*#__PURE__*/ $624d85670c8e6e3a$var$_react.default.createElement($fO6ad.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 10.586L6.707 5.293a1 1 0 00-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 001.414 1.414L12 13.414l5.293 5.293a1 1 0 001.414-1.414L13.414 12l5.293-5.293a1 1 0 10-1.414-1.414L12 10.586z" fill="currentColor"/></svg>`
    }, props));
$624d85670c8e6e3a$var$CrossIcon.displayName = "CrossIcon";
var $624d85670c8e6e3a$var$_default = $624d85670c8e6e3a$var$CrossIcon;
module.exports.default = $624d85670c8e6e3a$var$_default;

});


parcelRegister("4I3Wr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36de5435151916af$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $avKww = parcelRequire("avKww");

var $JcvLo = parcelRequire("JcvLo");
var $gWA00 = parcelRequire("gWA00");

var $aP6k3 = parcelRequire("aP6k3");
var $36de5435151916af$var$gridSize = (0, $aP6k3.gridSize)();
var $36de5435151916af$var$paddingLeft = $36de5435151916af$var$gridSize * 5;
var $36de5435151916af$var$expanderStyles = (0, $avKww.css)({
    display: "flex",
    minWidth: 0,
    maxHeight: 0,
    padding: "0 0 0 ".concat($36de5435151916af$var$paddingLeft, "px"),
    justifyContent: "center",
    flex: "1 1 100%",
    flexDirection: "column",
    transition: "max-height 0.3s"
});
var $36de5435151916af$var$expandedStyles = (0, $avKww.css)({
    maxHeight: 150
});
var $36de5435151916af$var$Expander = function Expander(_ref) {
    var children = _ref.children, isExpanded = _ref.isExpanded, testId = _ref.testId;
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return (0, $avKww.jsx)("div", {
        "aria-hidden": !isExpanded,
        css: [
            $36de5435151916af$var$expanderStyles,
            isExpanded && $36de5435151916af$var$expandedStyles
        ],
        "data-testid": testId && "".concat(testId, "-expander")
    }, (0, $avKww.jsx)((0, $JcvLo.default), {
        appear: true
    }, isExpanded && (0, $avKww.jsx)((0, $gWA00.default), null, function(props) {
        return (0, $avKww.jsx)("div", props, children);
    })));
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $36de5435151916af$export$2e2bcd8739ae039 = $36de5435151916af$var$Expander;

});

parcelRegister("708pv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $518f0e9bf81e63fa$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $avKww = parcelRequire("avKww");
var $518f0e9bf81e63fa$var$titleStyles = (0, $avKww.css)({
    padding: "2px 0 6px 16px",
    flex: 1,
    fontWeight: 600
});
var $518f0e9bf81e63fa$var$Title = function Title(_ref) {
    var color = _ref.color, children = _ref.children;
    return (0, $avKww.jsx)("span", {
        style: {
            color: color
        },
        css: $518f0e9bf81e63fa$var$titleStyles
    }, children);
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $518f0e9bf81e63fa$export$2e2bcd8739ae039 = $518f0e9bf81e63fa$var$Title;

});


parcelRegister("KMOF4", function(module, exports) {

$parcel$export(module.exports, "getIcon", function () { return $2faeb19ada988b69$export$16b26cd5e98d9100; });
$parcel$export(module.exports, "wrapAction", function () { return $2faeb19ada988b69$export$2c6a5a1e6a1fb5cf; });

var $9nHZC = parcelRequire("9nHZC");

var $5eELe = parcelRequire("5eELe");

var $4dJkZ = parcelRequire("4dJkZ");

var $g3VDW = parcelRequire("g3VDW");

var $9hjCt = parcelRequire("9hjCt");

var $jp7ng = parcelRequire("jp7ng");
const $2faeb19ada988b69$export$6d49a893c897b0cc = (key, color)=>{
    const icons = {
        generic: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g3VDW))), {
            label: "Generic",
            primaryColor: color || (0, $jp7ng).P300
        }),
        info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g3VDW))), {
            label: "Info",
            primaryColor: color || (0, $jp7ng).P100
        }),
        hint: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g3VDW))), {
            label: "Hint",
            primaryColor: color || (0, $jp7ng).B200
        }),
        success: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5eELe))), {
            label: "Success",
            primaryColor: color || (0, $jp7ng).G300
        }),
        warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9hjCt))), {
            label: "Warning",
            primaryColor: color || (0, $jp7ng).Y300
        }),
        error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4dJkZ))), {
            label: "Error",
            primaryColor: color || (0, $jp7ng).R300
        })
    };
    return icons[key];
};
function $2faeb19ada988b69$export$16b26cd5e98d9100(key, color) {
    return $2faeb19ada988b69$export$6d49a893c897b0cc(key, color);
}
function $2faeb19ada988b69$export$2c6a5a1e6a1fb5cf(action) {
    return {
        content: action.actionText,
        onClick: ()=>action.executeAction()
    };
}

});
parcelRegister("5eELe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3cfde0c77978cf50$var$_react = $3cfde0c77978cf50$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $3cfde0c77978cf50$var$_success = $3cfde0c77978cf50$var$_interopRequireDefault((parcelRequire("3Lbz7")));
function $3cfde0c77978cf50$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3cfde0c77978cf50$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $3cfde0c77978cf50$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $3cfde0c77978cf50$var$_success.default
    }));
$3cfde0c77978cf50$var$CheckCircleIcon.displayName = "CheckCircleIcon";
var $3cfde0c77978cf50$var$_default = module.exports.default = $3cfde0c77978cf50$var$CheckCircleIcon;

});
parcelRegister("3Lbz7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a280b44c69b6de4f4f93ebdb24542b07>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2bcebb89cb6594ff$var$_react = $2bcebb89cb6594ff$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $2bcebb89cb6594ff$var$_UNSAFE_baseNew = $2bcebb89cb6594ff$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $2bcebb89cb6594ff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2bcebb89cb6594ff$var$SuccessIcon = (props)=>/*#__PURE__*/ $2bcebb89cb6594ff$var$_react.default.createElement($2bcebb89cb6594ff$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$2bcebb89cb6594ff$var$SuccessIcon.displayName = "SuccessIcon";
var $2bcebb89cb6594ff$var$_default = module.exports.default = $2bcebb89cb6594ff$var$SuccessIcon;

});


parcelRegister("g3VDW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb19a3e22f9b4a7a$var$_react = $bb19a3e22f9b4a7a$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $bb19a3e22f9b4a7a$var$_information = $bb19a3e22f9b4a7a$var$_interopRequireDefault((parcelRequire("JluUo")));
function $bb19a3e22f9b4a7a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $bb19a3e22f9b4a7a$var$InfoIcon = (props)=>/*#__PURE__*/ $bb19a3e22f9b4a7a$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $bb19a3e22f9b4a7a$var$_information.default
    }));
$bb19a3e22f9b4a7a$var$InfoIcon.displayName = "InfoIcon";
var $bb19a3e22f9b4a7a$var$_default = module.exports.default = $bb19a3e22f9b4a7a$var$InfoIcon;

});
parcelRegister("JluUo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cfc592cc61140d99cb4eaed527408acf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0884e10b6fed9309$var$_react = $0884e10b6fed9309$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $0884e10b6fed9309$var$_UNSAFE_baseNew = $0884e10b6fed9309$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $0884e10b6fed9309$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0884e10b6fed9309$var$InformationIcon = (props)=>/*#__PURE__*/ $0884e10b6fed9309$var$_react.default.createElement($0884e10b6fed9309$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$0884e10b6fed9309$var$InformationIcon.displayName = "InformationIcon";
var $0884e10b6fed9309$var$_default = module.exports.default = $0884e10b6fed9309$var$InformationIcon;

});




parcelRegister("14iJP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e50b880174e28a80$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $hNste = parcelRequire("hNste");

var $2LR1D = parcelRequire("2LR1D");

var $i5a4M = parcelRequire("i5a4M");
class $e50b880174e28a80$export$ccc6b3e6ea812cfe extends (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).PureComponent {
    constructor(...args){
        super(...args);
        this.state = {
            instances: []
        };
    }
    /* eslint react/no-unsafe: "warn" */ UNSAFE_componentWillMount() {
        this.props.inlineDialogProvider.setView(this);
    }
    dismiss() {
        this.state.instances.forEach(({ key: key })=>this.dispose(key));
    }
    create(key, props, data) {
        let { instances: instances } = this.state;
        const instance = instances.find(({ key: k })=>k === key);
        if (instance) this.dispose(key);
        else {
            if (!instances.length) {
                const dismiss = ()=>{
                    this.state.instances.forEach(({ key: _key })=>this.dispose(_key));
                    window.removeEventListener("scroll", dismiss, true);
                };
                window.addEventListener("scroll", dismiss, true);
            }
            instances = [
                ...instances,
                {
                    key: key,
                    props: props,
                    data: data
                }
            ];
            this.setState({
                instances: instances
            });
        }
    }
    dispose(key) {
        let { instances: instances } = this.state;
        instances = instances.filter(({ key: k })=>k !== key);
        this.setState({
            instances: instances
        });
    }
    render() {
        const items = this.state.instances.map(({ key: key, props: props, data: data })=>{
            const provider = this.props.inlineDialogProvider.create(key);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $hNste.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, this.props, {
                provider: provider,
                isOpen: true,
                IframeComponent: (p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2LR1D.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, p, {
                        connectHost: this.props.connectHost,
                        addonManager: this.props.addonManager,
                        extension: data,
                        options: props
                    })),
                key: key
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", {
                style: {
                    ...props.position,
                    position: "absolute",
                    pointerEvents: "none"
                }
            }));
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
            style: {
                position: "fixed",
                top: 0,
                left: 0,
                zIndex: 1000
            }
        }, items);
    }
}
var $e50b880174e28a80$export$2e2bcd8739ae039 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $i5a4M.default), {
        container: document.body
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($e50b880174e28a80$export$ccc6b3e6ea812cfe, props));
};

});
parcelRegister("2LR1D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a557b0ac63b6d65$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $9TCOS = parcelRequire("9TCOS");

var $eSu0s = parcelRequire("eSu0s");
var $8a557b0ac63b6d65$export$2e2bcd8739ae039 = (0, $9TCOS.default)(({ connectHost: connectHost, options: options, module: mod, handleHideInlineDialog: handleHideInlineDialog })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eSu0s.default), {
        connectHost: connectHost,
        module: mod,
        inlineDialogOptions: options,
        handleHideInlineDialog: handleHideInlineDialog
    });
});

});

parcelRegister("i5a4M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bc0f82ac07ebceb$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $lnOmc = parcelRequire("lnOmc");
const $7bc0f82ac07ebceb$var$UniversalPortal = ({ children: children, container: container })=>{
    const [isActive, setActive] = (0, $9nHZC.useState)(false);
    // Activate the portal after the component has mounted, and the effect
    // hook is fired for the first time. This ensures that we do not attempt
    // to render the portal during SSR.
    (0, $9nHZC.useEffect)(()=>setActive(true), []);
    if (isActive && container) return (0, (/*@__PURE__*/$parcel$interopDefault($lnOmc))).createPortal(children, container);
    else return null;
};
var $7bc0f82ac07ebceb$export$2e2bcd8739ae039 = $7bc0f82ac07ebceb$var$UniversalPortal;

});


parcelRegister("dBBeH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7ea7f8814eeb993$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $7YT1t = parcelRequire("7YT1t");
var $d7ea7f8814eeb993$export$2e2bcd8739ae039;
$d7ea7f8814eeb993$export$2e2bcd8739ae039 = class Message extends (0, $9nHZC.PureComponent) {
    constructor(...args){
        super(...args);
        this.props = void 0;
        this.state = {
            messages: [] // using an array keeps the messages ordered
        };
        this.messageIdsToCloseHandlers = {};
        this.createMessage = (type, title, body, messageCreationOptions)=>{
            const message = {
                id: messageCreationOptions.id,
                key: messageCreationOptions.id,
                type: type,
                title: title,
                body: body,
                closeable: messageCreationOptions.closeable,
                fadeout: messageCreationOptions.fadeout,
                delay: messageCreationOptions.delay,
                duration: messageCreationOptions.duration
            };
            this.setState({
                messages: this.state.messages.concat([
                    message
                ])
            });
            return message;
        };
        this.closeMessage = (messageId)=>{
            this.state.messages.forEach((message)=>{
                if (message.id === messageId) {
                    // @ts-ignore TODO: fix noImplicitAny error here
                    const closeHandler = this.messageIdsToCloseHandlers[messageId];
                    if (closeHandler) {
                        try {
                            closeHandler();
                        } catch (exception) {
                            throw new Error("Message close handler threw an exception");
                        }
                        // @ts-ignore TODO: fix noImplicitAny error here
                        delete this.messageIdsToCloseHandlers[messageId];
                    }
                }
            });
            const newMessages = this.state.messages.filter((message)=>message.id !== messageId);
            this.setState({
                messages: newMessages
            });
        };
        this.onClose = (messageId, callback)=>{
            // @ts-ignore TODO: fix noImplicitAny error here
            this.messageIdsToCloseHandlers[messageId] = callback;
        };
    }
    componentDidMount() {
        this.props.messageProvider.setView(this);
    }
    componentDidUpdate() {
        this.props.messageProvider.setView(this);
    }
    /**
   * @param messageCreationOptions - for type info, see @atlassian/connect-module-core/lib/modules/message/MessageCreationOptions.
   */ render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7YT1t.default), {
            messages: this.state.messages,
            actions: {
                dismissMessage: this.closeMessage
            }
        });
    }
};

});
parcelRegister("7YT1t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2e61d1b8aab5fd4$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $4JvPI = parcelRequire("4JvPI");
var $kcqww = parcelRequire("kcqww");

var $8yTu6 = parcelRequire("8yTu6");
var $c2e61d1b8aab5fd4$export$2e2bcd8739ae039;
$c2e61d1b8aab5fd4$export$2e2bcd8739ae039 = class Messages extends (0, $9nHZC.PureComponent) {
    constructor(...args){
        super(...args);
        this.props = void 0;
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kcqww.default), {
            onDismissed: (messageId)=>this.props.actions.dismissMessage(messageId)
        }, this.props.messages.map((message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $4JvPI.default), {
                id: message.id,
                key: message.id,
                title: message.title,
                description: message.body,
                actions: message.actions,
                icon: (0, $8yTu6.getIcon)(message.type)
            })));
    }
};

});
parcelRegister("8yTu6", function(module, exports) {

$parcel$export(module.exports, "getIcon", function () { return $1ab559c6ce4970ef$export$16b26cd5e98d9100; });

var $9nHZC = parcelRequire("9nHZC");

var $5eELe = parcelRequire("5eELe");

var $4dJkZ = parcelRequire("4dJkZ");

var $g3VDW = parcelRequire("g3VDW");

var $9hjCt = parcelRequire("9hjCt");

var $jp7ng = parcelRequire("jp7ng");
const $1ab559c6ce4970ef$export$6d49a893c897b0cc = (key, color)=>{
    const icons = {
        generic: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g3VDW))), {
            label: "Generic",
            primaryColor: color || (0, $jp7ng).P300
        }),
        info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g3VDW))), {
            label: "Info",
            primaryColor: color || (0, $jp7ng).P100
        }),
        hint: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g3VDW))), {
            label: "Hint",
            primaryColor: color || (0, $jp7ng).B200
        }),
        success: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5eELe))), {
            label: "Success",
            primaryColor: color || (0, $jp7ng).G300
        }),
        warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9hjCt))), {
            label: "Warning",
            primaryColor: color || (0, $jp7ng).Y300
        }),
        error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4dJkZ))), {
            label: "Error",
            primaryColor: color || (0, $jp7ng).R300
        })
    };
    return icons[key];
};
function $1ab559c6ce4970ef$export$16b26cd5e98d9100(key, color) {
    return $1ab559c6ce4970ef$export$6d49a893c897b0cc(key, color);
}

});



parcelRegister("5VwL8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("azotI")).default; });

var $azotI = parcelRequire("azotI");

});
parcelRegister("azotI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aace06fc77aee029$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $kcqww = parcelRequire("kcqww");

var $2FnXC = parcelRequire("2FnXC");

var $eqTCN = parcelRequire("eqTCN");

var $itccF = parcelRequire("itccF");

var $eTErM = parcelRequire("eTErM");
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $aace06fc77aee029$var$noOp = ()=>{};
const $aace06fc77aee029$var$emptyFlag = {
    moduleId: "",
    name: "",
    scopes: "",
    accept: $aace06fc77aee029$var$noOp,
    deny: $aace06fc77aee029$var$noOp
};
const $aace06fc77aee029$var$addFlagToGroup = (flags, ...flagProps)=>{
    // eslint-disable-next-line no-param-reassign
    flags = flags.slice();
    flags.unshift(flagProps.reduce((obj, props)=>typeof props === "object" ? {
            ...obj,
            ...props
        } : obj, {
        ...$aace06fc77aee029$var$emptyFlag
    }));
    return flags;
};
const $aace06fc77aee029$var$getFlagState = (...flagProps)=>(state)=>{
        return {
            flags: $aace06fc77aee029$var$addFlagToGroup(state.flags, ...flagProps)
        };
    };
class $aace06fc77aee029$export$79dd73309e90dfd0 extends $9nHZC.PureComponent {
    constructor(...args){
        super(...args);
        this.unlisten = void 0;
        this.state = {
            flags: [],
            scopes: [],
            hasError: false
        };
        this.dismissErrorFlag = ()=>this.setState({
                hasError: false
            });
        this.removeFlag = (moduleId)=>{
            let flags = this.state.flags.slice();
            flags = flags.filter(({ moduleId: id })=>moduleId !== id);
            this.setState({
                flags: flags,
                modalDialog: undefined
            });
        };
        this.onAcceptOrDeny = (moduleId, isAccepted, callback)=>{
            let flag = this.state.flags.find(({ moduleId: id })=>moduleId === id);
            const removeFlag = ()=>this.removeFlag(moduleId);
            if (!flag) // If there's no flag present, it means the "skipFlag" option was used when triggering the
            // authorisation flow. In this case we just hide the modal and then call the provided callback.
            {
                if (this.state.modalDialog) {
                    flag = this.state.modalDialog;
                    this.setState({
                        modalDialog: undefined
                    });
                }
            } else removeFlag();
            if (!isAccepted) this.props.addonManager.denyOAuthConsumer(moduleId, ()=>{
                // onSuccess
                if (flag) this.setState($aace06fc77aee029$var$getFlagState(flag, {
                    deny: removeFlag,
                    denied: true
                }));
            }, ()=>{
                // onFailed
                if (flag) this.setState($aace06fc77aee029$var$getFlagState(flag, {
                    deny: removeFlag,
                    denied: true,
                    hasError: true
                }));
            });
            callback();
        };
        this.showModalDialog = (mod)=>{
            this.setState({
                modalDialog: mod
            });
        };
    }
    componentDidMount() {
        // setup listener for auth requests
        this.unlisten = this.props.addonManager.handleOAuthAcceptOrDeny((opts, accept, deny)=>{
            this.props.addonManager.getOAuthScopes((scopes)=>{
                // If request to getScopes() is successful, show the accept/deny flag. It's also possible
                // to skip the flag and directly show the modal by supplying the "skipFlag" option.
                if (opts.skipFlag) {
                    this.setState({
                        scopes: scopes
                    });
                    this.showModalDialog({
                        ...opts,
                        accept: ()=>this.onAcceptOrDeny(opts.moduleId, true, accept),
                        deny: ()=>this.onAcceptOrDeny(opts.moduleId, false, deny)
                    });
                } else this.setState((state)=>({
                        scopes: scopes,
                        flags: $aace06fc77aee029$var$addFlagToGroup(state.flags, opts, {
                            accept: ()=>this.onAcceptOrDeny(opts.moduleId, true, accept),
                            deny: ()=>this.onAcceptOrDeny(opts.moduleId, false, deny)
                        })
                    }));
            }, ()=>{
                // If request to getScopes() fails, then call deny handler
                // and then handler the error
                this.setState({
                    hasError: true
                });
                deny();
            });
        });
        // This will be called after the user accepts the oauth request and the AddonManager.getToken() completes
        // It is called on both successful (isAccepted=true) and failed requests (isAccepted=false)
        this.props.addonManager.setGrantOAuthHandler((opts, isAccepted)=>{
            if (opts.skipFlag && isAccepted) // If skipFlag is causing the flag to be skipped and the modal shown immediately, there's
            // no need to display the "Granted" flag.
            return;
            this.setState($aace06fc77aee029$var$getFlagState(opts, {
                deny: ()=>this.removeFlag(opts.moduleId)
            }, isAccepted && {
                denied: false
            }, !isAccepted && {
                hasError: true
            }));
        });
    }
    componentWillUnmount() {
        if (typeof this.unlisten === "function") this.unlisten();
        this.props.addonManager.setGrantOAuthHandler(null);
    }
    render() {
        const { flags: flags, scopes: scopes, hasError: hasError, modalDialog: modalDialog } = this.state;
        return /*#__PURE__*/ $9nHZC.createElement($9nHZC.Fragment, null, /*#__PURE__*/ $9nHZC.createElement((0, $2FnXC.default), null, modalDialog && /*#__PURE__*/ $9nHZC.createElement((0, $eTErM.default), {
            scopes: scopes,
            module: modalDialog
        })), /*#__PURE__*/ $9nHZC.createElement((0, $kcqww.default), null, hasError ? /*#__PURE__*/ $9nHZC.createElement((0, $eqTCN.default), {
            key: "oauth-error",
            dismiss: this.dismissErrorFlag
        }) : flags.map((mod)=>/*#__PURE__*/ $9nHZC.createElement((0, $itccF.default), {
                key: mod.moduleId,
                module: mod,
                scopes: scopes,
                showModalDialog: ()=>this.showModalDialog(mod),
                managePermissionsUrl: this.props.addonManager.getManagePermissionsUrl()
            }))));
    }
}
var $aace06fc77aee029$export$2e2bcd8739ae039 = $aace06fc77aee029$export$79dd73309e90dfd0;

});
parcelRegister("eqTCN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ddab0ebe7308bb0$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $iLC97 = parcelRequire("iLC97");

var $KMOF4 = parcelRequire("KMOF4");
class $6ddab0ebe7308bb0$export$bdc0f363b754b88f extends (0, $9nHZC.Component) {
    render() {
        const { title: title, descritpion: descritpion, dismiss: dismiss } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $iLC97.default), {
            id: "oauth-error",
            title: title,
            description: descritpion,
            icon: (0, $KMOF4.getIcon)("error"),
            onDismissed: dismiss
        });
    }
}
$6ddab0ebe7308bb0$export$bdc0f363b754b88f.defaultProps = {
    title: "Server error",
    descritpion: "Unable to complete the request"
};
var $6ddab0ebe7308bb0$export$2e2bcd8739ae039 = $6ddab0ebe7308bb0$export$bdc0f363b754b88f;

});
parcelRegister("iLC97", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da9a34cae93fe21c$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $7w0fy = parcelRequire("7w0fy");

var $8p2GL = parcelRequire("8p2GL");

var $4JvPI = parcelRequire("4JvPI");

var $kcqww = parcelRequire("kcqww");
var $da9a34cae93fe21c$var$packageName = "@atlaskit/flag";
var $da9a34cae93fe21c$var$packageVersion = "14.7.1";
var $da9a34cae93fe21c$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ var $da9a34cae93fe21c$var$AutoDismissFlag = function AutoDismissFlag(props) {
    var id = props.id, analyticsContext = props.analyticsContext, _props$onDismissed = props.onDismissed, onDismissedProp = _props$onDismissed === void 0 ? (0, $8p2GL.default) : _props$onDismissed;
    var autoDismissTimer = (0, $9nHZC.useRef)(null);
    var _useFlagGroup = (0, $kcqww.useFlagGroup)(), onDismissedFromFlagGroup = _useFlagGroup.onDismissed, isDismissAllowed = _useFlagGroup.isDismissAllowed;
    var onDismissed = (0, $9nHZC.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var onDismissedAnalytics = (0, $7w0fy.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: "dismissed",
        analyticsData: analyticsContext,
        componentName: "flag",
        packageName: $da9a34cae93fe21c$var$packageName,
        packageVersion: $da9a34cae93fe21c$var$packageVersion
    });
    var isAutoDismissAllowed = isDismissAllowed && onDismissed;
    var dismissFlag = (0, $9nHZC.useCallback)(function() {
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    var stopAutoDismissTimer = (0, $9nHZC.useCallback)(function() {
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    var startAutoDismissTimer = (0, $9nHZC.useCallback)(function() {
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, $da9a34cae93fe21c$export$66c3d409977b5615 * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed
    ]);
    (0, $9nHZC.useEffect)(function() {
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $4JvPI.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    }));
};
var $da9a34cae93fe21c$export$2e2bcd8739ae039 = $da9a34cae93fe21c$var$AutoDismissFlag;

});


parcelRegister("itccF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44c6ae3dcf72fbd2$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $iLC97 = parcelRequire("iLC97");
var $4JvPI = parcelRequire("4JvPI");

var $KMOF4 = parcelRequire("KMOF4");

var $eqTCN = parcelRequire("eqTCN");
class $44c6ae3dcf72fbd2$export$d60d8bdbfe4c6270 extends (0, $9nHZC.PureComponent) {
    render() {
        const { moduleId: moduleId, name: name, deny: deny, denied: denied, hasError: hasError } = this.props.module;
        if (typeof denied === "boolean") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $iLC97.default), {
            id: moduleId,
            title: `Access ${denied ? "denied" : "granted"}`,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("p", null, "You", denied ? " denied " : " granted ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("strong", null, name), " access to your account."),
            actions: [
                {
                    content: "Manage permissions",
                    href: this.props.managePermissionsUrl,
                    target: "_blank"
                }
            ],
            icon: (0, $KMOF4.getIcon)(denied ? "error" : "success"),
            onDismissed: deny
        });
        if (hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eqTCN.default), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $4JvPI.default), {
            id: moduleId,
            title: "Access request",
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("strong", null, name), " requests access to your account. Review permissions requested to enable."),
            actions: [
                {
                    content: "Review",
                    onClick: this.props.showModalDialog
                },
                {
                    content: "Cancel",
                    onClick: deny
                }
            ],
            icon: (0, $KMOF4.getIcon)("info")
        });
    }
}
$44c6ae3dcf72fbd2$export$d60d8bdbfe4c6270.defaultProps = {
    /* eslint react/default-props-match-prop-types:warn */ module: {},
    scopes: []
};
var $44c6ae3dcf72fbd2$export$2e2bcd8739ae039 = $44c6ae3dcf72fbd2$export$d60d8bdbfe4c6270;

});

parcelRegister("eTErM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9450d171d6d84fc1$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $EKmRU = parcelRequire("EKmRU");

var $cGPG3 = parcelRequire("cGPG3");
var $ljrFr = parcelRequire("ljrFr");
var $2X56B = parcelRequire("2X56B");
var $DPG6Z = parcelRequire("DPG6Z");
var $3qXIy = parcelRequire("3qXIy");
class $9450d171d6d84fc1$export$b6a8d1e4ac6cffe5 extends (0, $9nHZC.PureComponent) {
    render() {
        const { accept: accept, deny: deny } = this.props.module;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $cGPG3.default), {
            shouldCloseOnEscapePress: false,
            shouldCloseOnOverlayClick: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $DPG6Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3qXIy.default), null, "Review permissions")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ljrFr.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($9450d171d6d84fc1$export$b6a8d1e4ac6cffe5.List, this.props)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2X56B.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $EKmRU.default), {
            onClick: accept,
            appearance: "primary"
        }, "Allow"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $EKmRU.default), {
            onClick: deny,
            appearance: "subtle"
        }, "Deny")));
    }
}
$9450d171d6d84fc1$export$b6a8d1e4ac6cffe5.ListItem = ({ name: name, description: description, icon: icon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("li", {
        key: name,
        style: {
            display: "flex"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", {
        className: `aui-icon aui-icon-small ${icon}`,
        style: {
            minWidth: "24px"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", null, description));
$9450d171d6d84fc1$export$b6a8d1e4ac6cffe5.List = ({ scopes: scopes, module: mod })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("strong", null, mod.name), " requests access to:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("ul", {
        style: {
            listStyleType: "none",
            padding: "4px 0 0 0"
        }
    }, scopes.reduce((arr, { name: name, description: description, icon: icon })=>mod.scopes.includes(name) ? [
            ...arr,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($9450d171d6d84fc1$export$b6a8d1e4ac6cffe5.ListItem, {
                key: name,
                name: name,
                description: description,
                icon: icon
            })
        ] : arr, [])));
var $9450d171d6d84fc1$export$2e2bcd8739ae039 = $9450d171d6d84fc1$export$b6a8d1e4ac6cffe5;

});






parcelRegister("3hzea", function(module, exports) {

$parcel$export(module.exports, "AnalyticsClientManager", function () { return (parcelRequire("d6ANX")).AnalyticsClientManager; });
$parcel$export(module.exports, "createAnalyticsClient", function () { return (parcelRequire("fcgZ6")).createAnalyticsClient; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("6E7t8")).default; });
$parcel$export(module.exports, "uncurlyUuid", function () { return (parcelRequire("a5HLv")).uncurlyUuid; });
$parcel$export(module.exports, "FactContext", function () { return (parcelRequire("1yXM1")).default; });

var $d6ANX = parcelRequire("d6ANX");

var $fcgZ6 = parcelRequire("fcgZ6");

var $6E7t8 = parcelRequire("6E7t8");

var $a5HLv = parcelRequire("a5HLv");

var $1yXM1 = parcelRequire("1yXM1");
parcelRequire("1Ic6A");


});
parcelRegister("d6ANX", function(module, exports) {

$parcel$export(module.exports, "AnalyticsClientManager", function () { return $8ef2bbbc96aea971$export$dda9aea13bce506a; });

var $9nHZC = parcelRequire("9nHZC");

var $7xQTz = parcelRequire("7xQTz");

var $a5HLv = parcelRequire("a5HLv");
const $8ef2bbbc96aea971$var$setUserInfo = (analyticsClient, accountId)=>{
    if (accountId) analyticsClient.setUserInfo((0, $7xQTz.userType).ATLASSIAN_ACCOUNT, accountId);
    else analyticsClient.clearUserInfo();
};
const $8ef2bbbc96aea971$var$setWorkspaceInfo = (analyticsClient, workspaceId)=>{
    if (workspaceId) {
        analyticsClient.setWorkspaceInfo(workspaceId);
        analyticsClient.setTenantInfo((0, $7xQTz.tenantType).CLOUD_ID, workspaceId);
    } else {
        analyticsClient.clearWorkspaceInfo();
        analyticsClient.setTenantInfo((0, $7xQTz.tenantType).NONE);
    }
};
const $8ef2bbbc96aea971$export$dda9aea13bce506a = (props)=>{
    const { analyticsClient: analyticsClient, accountId: accountId, workspaceId: workspaceId } = props;
    let workspaceUuid = workspaceId;
    if (workspaceUuid) // We want to support optional braces for this function. If uncurlyUuid
    // returns an empty string for no braces, assume the given string is a
    // valid UUID format.
    workspaceUuid = (0, $a5HLv.uncurlyUuid)(workspaceUuid) || workspaceUuid;
    (0, $9nHZC.useEffect)(()=>{
        analyticsClient.startUIViewedEvent();
        return ()=>{
            analyticsClient.stopUIViewedEvent();
        };
    }, [
        analyticsClient
    ]);
    (0, $9nHZC.useEffect)(()=>{
        $8ef2bbbc96aea971$var$setUserInfo(analyticsClient, accountId);
    }, [
        analyticsClient,
        accountId
    ]);
    (0, $9nHZC.useEffect)(()=>{
        $8ef2bbbc96aea971$var$setWorkspaceInfo(analyticsClient, workspaceUuid);
    }, [
        analyticsClient,
        workspaceUuid
    ]);
    return null;
};

});
parcelRegister("a5HLv", function(module, exports) {

$parcel$export(module.exports, "uncurlyUuid", function () { return $df9032847cb44d7f$export$3a1a8bfb58a690be; });
const $df9032847cb44d7f$var$uuidRe = new RegExp("^{([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})}$");
const $df9032847cb44d7f$export$3a1a8bfb58a690be = (uuid)=>{
    const match = $df9032847cb44d7f$var$uuidRe.exec(uuid);
    if (!match) return "";
    return match[1];
};

});


parcelRegister("fcgZ6", function(module, exports) {

$parcel$export(module.exports, "createAnalyticsClient", function () { return $a5d041eb430bc06a$export$3d970ca206012d6b; });

var $gJmMp = parcelRequire("gJmMp");
var $7xQTz = parcelRequire("7xQTz");

var $41npu = parcelRequire("41npu");
const $a5d041eb430bc06a$var$analyticsEnvironment = (env)=>{
    if (env === "production") return (0, $7xQTz.envType).PROD;
    else if (env === "integration") return (0, $7xQTz.envType).STAGING;
    else if (env === "development") return (0, $7xQTz.envType).DEV;
    return (0, $7xQTz.envType).LOCAL;
};
const $a5d041eb430bc06a$export$3d970ca206012d6b = ()=>{
    const { bbEnv: bbEnv, version: version, locale: locale, userAaid: userAaid, workspaceUuid: workspaceUuid } = (0, $41npu.getHtmlMetaValues)();
    const analyticsEnv = $a5d041eb430bc06a$var$analyticsEnvironment(bbEnv);
    const client = new (0, $gJmMp.default)({
        env: analyticsEnv,
        product: "bitbucket",
        subproduct: "frontbucket",
        version: version,
        origin: (0, $7xQTz.originType).WEB,
        locale: locale
    }, {
        disableCookiePersistence: true
    });
    // Set the user identifier. In the case of an anonymous user, calling
    // clearUserInfo will ensure the 'ajs_anonymous_id' cookie is set, which we
    // require on the back end
    if (userAaid && typeof userAaid === "string") client.setUserInfo((0, $7xQTz.userType).ATLASSIAN_ACCOUNT, userAaid);
    else client.clearUserInfo();
    // pass target workspace id if it's available
    if (workspaceUuid && typeof workspaceUuid === "string") {
        client.setTenantInfo((0, $7xQTz.tenantType).CLOUD_ID, workspaceUuid);
        client.setWorkspaceInfo(workspaceUuid);
    } else {
        client.setTenantInfo((0, $7xQTz.tenantType).NONE);
        client.clearWorkspaceInfo();
    }
    return client;
};

});
parcelRegister("41npu", function(module, exports) {

$parcel$export(module.exports, "getHtmlMetaValues", function () { return $26090196f225b6d3$export$882c7d05bd952b16; });
var $26090196f225b6d3$export$96584299af1a4c70;
(function(BbEnv) {
    BbEnv["Development"] = "development";
    BbEnv["Production"] = "production";
    BbEnv["Staging"] = "staging";
    BbEnv["Integration"] = "integration";
    BbEnv["Test"] = "dev-west2";
})($26090196f225b6d3$export$96584299af1a4c70 || ($26090196f225b6d3$export$96584299af1a4c70 = {})); // Infra Dev "Red" test, not testing test
function $26090196f225b6d3$var$getMetaContent(name) {
    var _document$querySelect;
    return ((_document$querySelect = document.querySelector(`meta[name="${name}"]`)) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getAttribute("content")) || null;
}
const $26090196f225b6d3$export$8fb736282730477 = ()=>{
    return $26090196f225b6d3$var$getMetaContent("bb-env") || "development";
};
const $26090196f225b6d3$export$43bd61d136745083 = ()=>{
    return $26090196f225b6d3$var$getMetaContent("bitbucket-commit-hash") || "unknown-version";
};
const $26090196f225b6d3$export$5f674beef138b660 = ()=>{
    return $26090196f225b6d3$var$getMetaContent("locale") || "en";
};
function $26090196f225b6d3$export$617d3851f9c90448() {
    const el = document.getElementById("bb-bootstrap");
    // bb-bootstrap is added to the base template for all frontbucket and core pages
    if (!el) return null;
    // `data-atlassian-id` is defined if the user is authenticated
    // (see templates/user-id.jinja in bitbucket/core repo)
    const userAaid = el.getAttribute("data-atlassian-id");
    if (!userAaid) return null;
    return userAaid;
}
function $26090196f225b6d3$export$b09dd106cfcbdd9() {
    // bb-bootstrap has basic data about the current session that's
    // avaialble in both backbucket and frontbucket pages
    const el = document.getElementById("bb-bootstrap");
    if (!el) return null;
    const workspaceUuid = el.getAttribute("data-target-workspace-uuid");
    // workspaceUuid will not be set if there's no target (ex: support admin pages)
    if (!workspaceUuid) return null;
    return workspaceUuid;
}
function $26090196f225b6d3$export$882c7d05bd952b16() {
    return {
        bbEnv: $26090196f225b6d3$export$8fb736282730477(),
        version: $26090196f225b6d3$export$43bd61d136745083(),
        locale: $26090196f225b6d3$export$5f674beef138b660(),
        userAaid: $26090196f225b6d3$export$617d3851f9c90448(),
        workspaceUuid: $26090196f225b6d3$export$b09dd106cfcbdd9()
    };
}

});


parcelRegister("6E7t8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b28b7fd23de34f2$export$2e2bcd8739ae039; });
var $2b28b7fd23de34f2$export$2e2bcd8739ae039;
$2b28b7fd23de34f2$export$2e2bcd8739ae039 = class Fact {
    constructor(data){
        this.data = void 0;
        this.name = void 0;
        this.data = data;
    }
    generateEvent() {
        const event = {
            isFact: true,
            name: this.name,
            properties: this.data,
            time: new Date().getTime()
        };
        if (window && window.location && window.location.href) event.referrer = window.location.href;
        return event;
    }
};

});

parcelRegister("1yXM1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $491ea19de478c241$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");
const $491ea19de478c241$var$context = {
    // Frontbucket should set the value here be a function that will publish a Fact.
    // Consumers that don't use the Provider should have a no-op as the method.
    publishFact: ()=>{}
};
var $491ea19de478c241$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createContext($491ea19de478c241$var$context);

});

parcelRegister("1Ic6A", function(module, exports) {

});


parcelRegister("eT61T", function(module, exports) {

$parcel$export(module.exports, "PreferenceCategory", function () { return $ad6ae11a7733f6c1$export$ba064dbfe4bb66d7; });
$parcel$export(module.exports, "ConsentPreferenceV2", function () { return $ad6ae11a7733f6c1$export$cdef20bac194f235; });
$parcel$export(module.exports, "ContextualConsentProperty", function () { return $ad6ae11a7733f6c1$export$fac80ad19b60e313; });
$parcel$export(module.exports, "PrefetchedPreferenceState", function () { return $ad6ae11a7733f6c1$export$5d6594a0bba4ab8a; });
var $ad6ae11a7733f6c1$export$ba064dbfe4bb66d7 = /*#__PURE__*/ function(PreferenceCategory) {
    PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
    PreferenceCategory["Functional"] = "FUNCTIONAL";
    PreferenceCategory["Marketing"] = "MARKETING";
    PreferenceCategory["Analytics"] = "ANALYTICS";
    PreferenceCategory["Unknown"] = "UNKNOWN";
    return PreferenceCategory;
}({});
var $ad6ae11a7733f6c1$export$cdef20bac194f235 = /*#__PURE__*/ function(ConsentPreferenceV2) {
    ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
    ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
    ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
    ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
    return ConsentPreferenceV2;
}({});
var $ad6ae11a7733f6c1$export$fac80ad19b60e313 = /*#__PURE__*/ function(ContextualConsentProperty) {
    ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
    ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
    ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    return ContextualConsentProperty;
}({});
var $ad6ae11a7733f6c1$export$5d6594a0bba4ab8a = /*#__PURE__*/ function(PrefetchedPreferenceState) {
    PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
    return PrefetchedPreferenceState;
}({});

});

parcelRegister("g5F2H", function(module, exports) {

$parcel$export(module.exports, "getPreferences", function () { return $bb6cf32d80e4c253$export$1de6a888ae076ff8; });

var $4mVfk = parcelRequire("4mVfk");

var $8DpVo = parcelRequire("8DpVo");

var $lHRVb = parcelRequire("lHRVb");

var $gT26D = parcelRequire("gT26D");

var $bLOws = parcelRequire("bLOws");

var $86hZh = parcelRequire("86hZh");

var $eR97O = parcelRequire("eR97O");
function $bb6cf32d80e4c253$export$1de6a888ae076ff8() {
    return $bb6cf32d80e4c253$var$_getPreferences.apply(this, arguments);
}
function $bb6cf32d80e4c253$var$_getPreferences() {
    $bb6cf32d80e4c253$var$_getPreferences = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee() {
        var packedPrefs, packedLocalPrefs, consentToken;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if ((0, $lHRVb.fg)("platform.moonjelly.browser-storage-controls-v2")) {
                        _context.next = 5;
                        break;
                    }
                    packedPrefs = (0, $86hZh.getCookie)((0, $gT26D.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
                    if (packedPrefs) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return", undefined);
                case 4:
                    return _context.abrupt("return", (0, $eR97O.unpackUserPreferencesCookie)(packedPrefs));
                case 5:
                    packedLocalPrefs = (0, $86hZh.getCookie)((0, $gT26D.ATLASSIAN_CONSENT_COOKIE_KEY));
                    if (packedLocalPrefs) {
                        _context.next = 11;
                        break;
                    }
                    _context.next = 9;
                    return (0, $bLOws.getConsentToken)();
                case 9:
                    consentToken = _context.sent;
                    return _context.abrupt("return", consentToken ? (0, $eR97O.unpackUserPreferencesCookie)(consentToken) : undefined);
                case 11:
                    return _context.abrupt("return", (0, $eR97O.unpackUserPreferencesCookie)(packedLocalPrefs));
                case 12:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $bb6cf32d80e4c253$var$_getPreferences.apply(this, arguments);
}

});
parcelRegister("gT26D", function(module, exports) {

$parcel$export(module.exports, "LEGACY_ATLASSIAN_GDPR_COOKIE_KEY", function () { return $c4b36a996c9fd18e$export$10d7db8e1a856fd8; });
$parcel$export(module.exports, "ATLASSIAN_CONSENT_COOKIE_KEY", function () { return $c4b36a996c9fd18e$export$435de28e5b000487; });
$parcel$export(module.exports, "ATLASSIAN_SHOW_BANNER_COOKIE_KEY", function () { return $c4b36a996c9fd18e$export$4b17acc0e875ba2a; });
$parcel$export(module.exports, "ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY", function () { return $c4b36a996c9fd18e$export$23a1e02c3c0b0d08; });
$parcel$export(module.exports, "TESTING_TOKEN_OVERRIDE_COOKIE_KEY", function () { return $c4b36a996c9fd18e$export$37073d560ecebada; });
$parcel$export(module.exports, "ACCEPT_ALL_PREFERENCES", function () { return $c4b36a996c9fd18e$export$b28b5d760fe14a21; });
$parcel$export(module.exports, "ONLY_NECESSARY_PREFERENCES", function () { return $c4b36a996c9fd18e$export$4a12f9e99971760a; });
$parcel$export(module.exports, "DEFAULT_PREFERENCES", function () { return $c4b36a996c9fd18e$export$f0fd1d13ec1d48f2; });
$parcel$export(module.exports, "V001_SCHEMA_KEY", function () { return $c4b36a996c9fd18e$export$f95182b7aa141c57; });
$parcel$export(module.exports, "V002_SCHEMA_KEY", function () { return $c4b36a996c9fd18e$export$1f25427b34f9c405; });
$parcel$export(module.exports, "V003_SCHEMA_KEY", function () { return $c4b36a996c9fd18e$export$31deaeaebce525bb; });

var $kFnE9 = parcelRequire("kFnE9");

var $eT61T = parcelRequire("eT61T");
var $c4b36a996c9fd18e$var$_ACCEPT_ALL_PREFERENC, $c4b36a996c9fd18e$var$_ONLY_NECESSARY_PREFE, $c4b36a996c9fd18e$var$_objectSpread2;
function $c4b36a996c9fd18e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c4b36a996c9fd18e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c4b36a996c9fd18e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c4b36a996c9fd18e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c4b36a996c9fd18e$export$10d7db8e1a856fd8 = "atl-gdpr-consent";
var $c4b36a996c9fd18e$export$435de28e5b000487 = "atl-bsc-consent-token";
var $c4b36a996c9fd18e$export$4b17acc0e875ba2a = "atl-bsc-show-banner";
var $c4b36a996c9fd18e$export$f57af01b64fc97b8 = "atl-bsc-current-locale";
var $c4b36a996c9fd18e$export$23a1e02c3c0b0d08 = "atl-bsc-consent-token-fallback";
var $c4b36a996c9fd18e$export$37073d560ecebada = "atl-testing-consents";
var $c4b36a996c9fd18e$export$b28b5d760fe14a21 = ($c4b36a996c9fd18e$var$_ACCEPT_ALL_PREFERENC = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($c4b36a996c9fd18e$var$_ACCEPT_ALL_PREFERENC, (0, $eT61T.PreferenceCategory).StrictlyNecessary, true), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($c4b36a996c9fd18e$var$_ACCEPT_ALL_PREFERENC, (0, $eT61T.PreferenceCategory).Functional, true), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($c4b36a996c9fd18e$var$_ACCEPT_ALL_PREFERENC, (0, $eT61T.PreferenceCategory).Marketing, true), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($c4b36a996c9fd18e$var$_ACCEPT_ALL_PREFERENC, (0, $eT61T.PreferenceCategory).Analytics, true), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($c4b36a996c9fd18e$var$_ACCEPT_ALL_PREFERENC, (0, $eT61T.PreferenceCategory).Unknown, true), $c4b36a996c9fd18e$var$_ACCEPT_ALL_PREFERENC);
var $c4b36a996c9fd18e$export$4a12f9e99971760a = ($c4b36a996c9fd18e$var$_ONLY_NECESSARY_PREFE = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($c4b36a996c9fd18e$var$_ONLY_NECESSARY_PREFE, (0, $eT61T.PreferenceCategory).StrictlyNecessary, true), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($c4b36a996c9fd18e$var$_ONLY_NECESSARY_PREFE, (0, $eT61T.PreferenceCategory).Functional, false), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($c4b36a996c9fd18e$var$_ONLY_NECESSARY_PREFE, (0, $eT61T.PreferenceCategory).Marketing, false), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($c4b36a996c9fd18e$var$_ONLY_NECESSARY_PREFE, (0, $eT61T.PreferenceCategory).Analytics, false), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($c4b36a996c9fd18e$var$_ONLY_NECESSARY_PREFE, (0, $eT61T.PreferenceCategory).Unknown, false), $c4b36a996c9fd18e$var$_ONLY_NECESSARY_PREFE);
var $c4b36a996c9fd18e$export$f0fd1d13ec1d48f2 = $c4b36a996c9fd18e$var$_objectSpread($c4b36a996c9fd18e$var$_objectSpread({}, $c4b36a996c9fd18e$export$4a12f9e99971760a), {}, ($c4b36a996c9fd18e$var$_objectSpread2 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($c4b36a996c9fd18e$var$_objectSpread2, (0, $eT61T.ContextualConsentProperty).ConsentsAreDefault, true), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($c4b36a996c9fd18e$var$_objectSpread2, (0, $eT61T.ContextualConsentProperty).UserIsAuthenticated, false), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($c4b36a996c9fd18e$var$_objectSpread2, (0, $eT61T.ContextualConsentProperty).ConsentDataUnavailable, true), $c4b36a996c9fd18e$var$_objectSpread2));
var $c4b36a996c9fd18e$export$f95182b7aa141c57 = "001";
var $c4b36a996c9fd18e$export$1f25427b34f9c405 = "002";
var $c4b36a996c9fd18e$export$31deaeaebce525bb = "003";

});

parcelRegister("bLOws", function(module, exports) {

$parcel$export(module.exports, "getConsentToken", function () { return $891b463b52cc1293$export$f1b8f2ca713fca08; });

var $4mVfk = parcelRequire("4mVfk");

var $8DpVo = parcelRequire("8DpVo");

var $gT26D = parcelRequire("gT26D");

var $86hZh = parcelRequire("86hZh");

var $2nekG = parcelRequire("2nekG");

var $bEBtq = parcelRequire("bEBtq");

var $4eEyM = parcelRequire("4eEyM");
var $891b463b52cc1293$export$f1b8f2ca713fca08 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee() {
        var fallbackConsentToken, consentData, consentToken, consentTimestamp, potentiallyOverriddenConsentToken, testingConsentOverride, hasTestingConsents;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    fallbackConsentToken = (0, $86hZh.getCookie)((0, $gT26D.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
                    _context.next = 3;
                    return (0, $4eEyM.getValidConsentData)(fallbackConsentToken);
                case 3:
                    consentData = _context.sent;
                    if (!consentData) {
                        _context.next = 15;
                        break;
                    }
                    consentToken = consentData.consentToken, consentTimestamp = consentData.consentTimestamp;
                    /*** TESTING OVERRIDES ***/ potentiallyOverriddenConsentToken = (0, $2nekG.overrideConsentTokenForLiveTesting)(consentToken);
                    testingConsentOverride = (0, $86hZh.getCookie)((0, $gT26D.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
                    hasTestingConsents = !!(testingConsentOverride || testingConsentOverride === "");
                    if (!hasTestingConsents) {
                        _context.next = 13;
                        break;
                    }
                    // If testing, set the cookies accordingly so we can test with any overridden token data.
                    (0, $bEBtq.setShouldShowBannerCookie)(potentiallyOverriddenConsentToken);
                    (0, $bEBtq.setConsentTokenCookie)(potentiallyOverriddenConsentToken);
                    // Unfortunately, if you've previously saved to ConsentHub, that data will always resolve, so to simulate ConsentHub
                    // being down, or the token data being bunk/invalid, we must set the testing token to an empty string. This will
                    // return undefined here and skip any unpacking of the token. Otherwise, it will use the overridden token value.
                    return _context.abrupt("return", potentiallyOverriddenConsentToken === "" ? undefined : potentiallyOverriddenConsentToken);
                case 13:
                    // At this point, all data should be valid and overridden for testing as needed, so set those cookies!
                    (0, $bEBtq.setRequiredConsentCookies)(potentiallyOverriddenConsentToken, consentTimestamp);
                    return _context.abrupt("return", consentToken);
                case 15:
                    return _context.abrupt("return", undefined);
                case 16:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function getConsentToken() {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("2nekG", function(module, exports) {

$parcel$export(module.exports, "overrideConsentTokenForLiveTesting", function () { return $1ba8d8e7b4bc8ad5$export$b5282052fc15e1ae; });

var $gT26D = parcelRequire("gT26D");

var $86hZh = parcelRequire("86hZh");
var $1ba8d8e7b4bc8ad5$export$b5282052fc15e1ae = function overrideConsentTokenForLiveTesting(genuineConsentToken) {
    // The existence of this cookie will make it look like fetched ConsentHub data is missing
    // You can set it to undefined yourself/empty string, or an actual default value.
    var tokenOverride = (0, $86hZh.getCookie)((0, $gT26D.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
    // Note: Clear this cookie out of your browser when you're done testing empty data sets
    // Or you'll be stuck seeing the banner and never actually consenting on the UI
    return tokenOverride || genuineConsentToken;
};

});

parcelRegister("bEBtq", function(module, exports) {

$parcel$export(module.exports, "setConsentTokenCookie", function () { return $87c07f9bd12c63c9$export$8e560d0760f733a2; });
$parcel$export(module.exports, "setConsentTokenFallbackCookie", function () { return $87c07f9bd12c63c9$export$133cd762b0f705a2; });
$parcel$export(module.exports, "setShouldShowBannerCookie", function () { return $87c07f9bd12c63c9$export$99ecece88c58d938; });
$parcel$export(module.exports, "setRequiredConsentCookies", function () { return $87c07f9bd12c63c9$export$b3365240280cb3c3; });

var $je318 = parcelRequire("je318");

var $gT26D = parcelRequire("gT26D");

var $933EP = parcelRequire("933EP");

var $4Qrev = parcelRequire("4Qrev");
var $87c07f9bd12c63c9$export$8e560d0760f733a2 = function setConsentTokenCookie(consentToken) {
    var inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $4Qrev.setStrictlyNecessaryCookie)((0, $gT26D.ATLASSIAN_CONSENT_COOKIE_KEY), consentToken, {
        expires: inTenMinutes,
        path: "/"
    });
};
var $87c07f9bd12c63c9$export$133cd762b0f705a2 = function setConsentTokenFallbackCookie(consentToken) {
    var inOneYear = new Date();
    inOneYear.setFullYear(inOneYear.getFullYear() + 1);
    (0, $4Qrev.setStrictlyNecessaryCookie)((0, $gT26D.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), consentToken, {
        expires: inOneYear,
        path: "/"
    });
};
var $87c07f9bd12c63c9$export$99ecece88c58d938 = function setShouldShowBannerCookie(consentToken, consentTimestamp) {
    // Since we have no good way to reference this as a global state object, we want to precompute and store the
    // banner visibility in a temporary, session-scope cookie (same expiry as the other cookies), which we can
    // lookup in the UI as needed
    var bannerVisibility = (0, $933EP.getBannerVisibility)({
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    });
    var shouldShowBanner = (0, $je318.getBitValueFromBool)(!!bannerVisibility);
    var inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $4Qrev.setStrictlyNecessaryCookie)((0, $gT26D.ATLASSIAN_SHOW_BANNER_COOKIE_KEY), shouldShowBanner, {
        expires: inTenMinutes,
        path: "/"
    });
};
var $87c07f9bd12c63c9$export$b3365240280cb3c3 = function setRequiredConsentCookies(consentToken, consentTimestamps) {
    $87c07f9bd12c63c9$export$8e560d0760f733a2(consentToken);
    $87c07f9bd12c63c9$export$99ecece88c58d938(consentToken, consentTimestamps);
};

});
parcelRegister("je318", function(module, exports) {

$parcel$export(module.exports, "getBitValueFromBool", function () { return $dff1aa4e7a7ee0ad$export$929f1500428a1fc8; });
$parcel$export(module.exports, "getBoolFromBitValue", function () { return $dff1aa4e7a7ee0ad$export$27647458f3cf29d2; });
var $dff1aa4e7a7ee0ad$export$929f1500428a1fc8 = function getBitValueFromBool(value) {
    return Number(value).toString();
};
var $dff1aa4e7a7ee0ad$export$27647458f3cf29d2 = function getBoolFromBitValue(bitValue) {
    if (bitValue) return !!Number(bitValue);
};

});

parcelRegister("933EP", function(module, exports) {

$parcel$export(module.exports, "getBannerVisibility", function () { return $69673b2b92121330$export$bfdb9f82a9194c1e; });

var $91Q2o = parcelRequire("91Q2o");

var $je318 = parcelRequire("je318");

var $gT26D = parcelRequire("gT26D");

var $8qM7g = parcelRequire("8qM7g");

var $86hZh = parcelRequire("86hZh");

var $eR97O = parcelRequire("eR97O");
var $69673b2b92121330$var$getUserIsAuthenticatedBit = function getUserIsAuthenticatedBit(consentToken) {
    var _checkTokenVersionVal = (0, $eR97O.checkTokenVersionValidity)(consentToken), isV002 = _checkTokenVersionVal.isV002;
    var userIsAuthenticatedBit = consentToken[8]; // V3 position
    if (isV002) {
        // Schema has changed in V3, V2 had this bit in a different position. Logged out users will have this bit set to 1
        var legacyV2ConsentDataUnavailableBit = consentToken[7];
        // We can backfill the UserIsAuthenticated bit by flipping the bit value. If ConsentHub was unavailable, that means they were logged out.
        userIsAuthenticatedBit = legacyV2ConsentDataUnavailableBit === "1" ? "0" : "1";
    }
    return userIsAuthenticatedBit;
};
var $69673b2b92121330$var$shouldShowBannerForLoggedOutDefaultToken = function shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken) {
    // Logged out + default consents + fallback: we have a discrepancy where ConsentHub is down/unavailable, or they're just logged out,
    // but the user has actually consented previously (which essentially the only way to save to the fallback to begin with)
    if (fallbackConsentToken) {
        var fallbackUserIsAuthenticatedBit = $69673b2b92121330$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        var isLoggedOutFallbackConsents = !(0, $je318.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        var fallbackTokenHasGenuineConsents = !(0, $8qM7g.checkIfTokenIsDefault)(fallbackConsentToken);
        var localOnlyUsersHasGenuineConsents = isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        // If the fallback is from a logged out consent (localOnlyConsent), they're currently
        // logged out and also saved while logged out, so don't show the banner
        if (localOnlyUsersHasGenuineConsents) return !fallbackTokenHasGenuineConsents;
        var loggedOutUserPreviouslyConsentedWhileLoggedIn = !isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        if (loggedOutUserPreviouslyConsentedWhileLoggedIn) // Or if it is from a logged in consent, and they've consented somewhere (they must have)
        // then we should not show the banner, as their consents aren't "stale", we're just in a situation
        // where the original token has expired so they get a default set, but we should hide the banner
        return false;
    }
    // Defaults consents + unauthed + missing a fallback, show the banner, as they haven't consented in the past year
    return true;
};
var $69673b2b92121330$var$shouldShowBannerForLoggedOutUser = function shouldShowBannerForLoggedOutUser(_ref) {
    var consentToken = _ref.consentToken, fallbackConsentToken = _ref.fallbackConsentToken;
    var tokenIsADefaultConsent = !!(0, $8qM7g.checkIfTokenIsDefault)(consentToken);
    // Handle default token flow
    if (tokenIsADefaultConsent) return $69673b2b92121330$var$shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    // If they're a legacy/V2 user who hasn't consented, this will have checked the V3 "is default" bit to note they've consented or not
    var localOnlyUserHasConsented = (0, $8qM7g.hasLegacyV2TokenConsentedPreviously)(consentToken) || !tokenIsADefaultConsent;
    if (localOnlyUserHasConsented) // LocalOnly users will never have a timestamp to validate against since they can't talk to ConsentHub
    // Existence of fallback consents means they've consented in the past year and do not have stale consents, do not show banner
    return fallbackConsentToken ? false : true;
    // This case should never be hit: if it's not a default, but they haven't consented... what is it? Add a catch-all "show banner"
    return true;
};
var $69673b2b92121330$var$shouldShowBannerForLoggedInDefaultToken = function shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken) {
    // Defaults + fallback + logged in, but they consented while they were previously logged out:
    if (fallbackConsentToken) {
        var fallbackUserIsAuthenticatedBit = $69673b2b92121330$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        var isLoggedOutFallbackConsents = !(0, $je318.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        var fallbackTokenHasGenuineConsents = !(0, $8qM7g.checkIfTokenIsDefault)(fallbackConsentToken);
        if (fallbackTokenHasGenuineConsents) {
            // Defaults + logged in user + consented <1yr ago, but while logged out
            if (isLoggedOutFallbackConsents) /*
            They've consented, and thus stored a fallback while logged out (fallback's CH bit is 1),
            then fetched from CH but get empty data (since they couldn't save to CH on their initial "save"), which sets authed consent defaults (bit 0)
             UX Problem:
            Since they have genuinely consented within the past year, the ideal UX would be to not show the banner...
            But if we do not re-prompt here in an effort to recapture their consents, the opportunity for them/us to actually get consents in the DB
            is infrequent (either via Account Privacy Page or once this fallback expires in a year).
             Example:
            While logged out, they consent in Trello, so we store the unauthed fallback token, then log in on Trello. If we hide the banner when the
            fallback exists, if that user later goes to Confluence's cookie domain (where they have no fallback), it would show the banner
            because they have no stored consents on CH, and no fallback in that domain, but are logged in. Repeat for every new domain...
             We could be fancy and save under the hood for them if they have a fallback, but to ensure we don't copy stale/different consents saved in a fallback
            to ConsentHub on their behalf, we should just re-prompt them for consents now that they're logged in. This way, they will actually
            persist their choices, and when loading other domains/products, there will be a Source of Truth to reference and not show the banner.
             Ultimately, this feels like the more "correct" way to handle this situation, as the cost of showing the banner again to officially capture
            consents feels lower than the potential cost of relying on fallbacks in all situations/across all domains for this user for the next whole year
             Result: Show the banner again and hope we officially recapture consents this time around
          */ return true;
            // Defaults + logged in user + consented <1yr ago, but while logged in
            // This scenario shouldn't happen, or if it does, it's in a phase where we haven't fetched preferences
            // yet, so hide the banner for now
            return false;
        }
        // Default token + default fallback (authed or unauthed) mean we've likely stored this
        // fallback from SSR's initialPreferences flow in. Fallbacks should not be saved with defaults intentionally
        // But sometimes we copy an existing token to the fallback via SSR flow, so let's treat this
        // as an bunk fallback, and show the banner as they haven't consented
        return true;
    }
    // Default consent token + logged in user + no fallback = they haven't consented in the past year, show banner
    return true;
};
var $69673b2b92121330$var$shouldShowBannerForLoggedInUser = function shouldShowBannerForLoggedInUser(_ref2) {
    var consentToken = _ref2.consentToken, consentTimestamp = _ref2.consentTimestamp, fallbackConsentToken = _ref2.fallbackConsentToken;
    // Handle default token flow
    var tokenIsADefaultConsent = !!(0, $8qM7g.checkIfTokenIsDefault)(consentToken);
    if (tokenIsADefaultConsent) return $69673b2b92121330$var$shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    if (consentTimestamp) {
        // If the user has genuine consents, and a timestamp, check if they're stale (> 1yr old), show the banner if they're stale
        var showBannerIfStale = (0, $8qM7g.checkIfConsentsAreStale)(consentTimestamp);
        return showBannerIfStale;
    }
    // Genuine consents + no timestamp— we're in a situation where we've been passed cached cookie data instead of CH response data,
    // so the only way to determine staleness is through the absence of the fallback.
    // Technically, we could assume since they've consented recently, we don't have to show the banner here but... to be safe we should
    return fallbackConsentToken ? false : true;
};
var $69673b2b92121330$export$bfdb9f82a9194c1e = function getBannerVisibility(_ref3) {
    var consentToken = _ref3.consentToken, consentTimestamp = _ref3.consentTimestamp, fallbackConsents = _ref3.fallbackConsentToken;
    // Consent tokens are either a set of defaults, or genuine (persisted to the remote, or saved in an entire local-only flow via fallbacks).
    // the deciding factor is whether or not your consents are stale/fresh, either via the existence/absence of a fallback (a.k.a consented within a year or not)
    // or if the ConsentHub response data of a user's consent has a timestamp that is older than a year
    var fallbackConsentToken = (0, $91Q2o.isSSR)() ? fallbackConsents // When coming from SSR, we don't want to invoke `getCookie` since it will error
     : fallbackConsents || (0, $86hZh.getCookie)((0, $gT26D.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    var userIsAuthenticatedBit = $69673b2b92121330$var$getUserIsAuthenticatedBit(consentToken);
    var isLoggedOutConsentToken = !(0, $je318.getBoolFromBitValue)(userIsAuthenticatedBit);
    var isBannerVisible = true; // By default, show the banner to every user
    // Unauthed/logged out user flow, should never receive a timestamp because logged out users can't communicate to ConsentHub
    if (isLoggedOutConsentToken) isBannerVisible = $69673b2b92121330$var$shouldShowBannerForLoggedOutUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken
    });
    else // Authed/logged in user flow
    isBannerVisible = $69673b2b92121330$var$shouldShowBannerForLoggedInUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken,
        consentTimestamp: consentTimestamp
    });
    return isBannerVisible;
};

});
parcelRegister("8qM7g", function(module, exports) {

$parcel$export(module.exports, "hasLegacyV2TokenConsentedPreviously", function () { return $623613478a5dd0be$export$42b0ca8aba2631e4; });
$parcel$export(module.exports, "checkIfTokenIsDefault", function () { return $623613478a5dd0be$export$497a647f0eb30ef4; });
$parcel$export(module.exports, "serializeConsents", function () { return $623613478a5dd0be$export$92ba0b2fe50f90df; });
$parcel$export(module.exports, "deserializeConsents", function () { return $623613478a5dd0be$export$bfa0c91662787fb0; });
$parcel$export(module.exports, "getConsentTimestamp", function () { return $623613478a5dd0be$export$13e4cff933f26b03; });
$parcel$export(module.exports, "checkIfConsentsAreStale", function () { return $623613478a5dd0be$export$3387347b75450ae1; });
$parcel$export(module.exports, "StatusCodeError", function () { return $623613478a5dd0be$export$a79c0ea3d7c2444a; });

var $eVDe4 = parcelRequire("eVDe4");

var $uqRmf = parcelRequire("uqRmf");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $6FnrE = parcelRequire("6FnrE");

var $b4Ivn = parcelRequire("b4Ivn");

var $kFnE9 = parcelRequire("kFnE9");

var $9q1kH = parcelRequire("9q1kH");

var $je318 = parcelRequire("je318");

var $gT26D = parcelRequire("gT26D");

var $86hZh = parcelRequire("86hZh");

var $eT61T = parcelRequire("eT61T");

var $4QdHN = parcelRequire("4QdHN");
function $623613478a5dd0be$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $623613478a5dd0be$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $623613478a5dd0be$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($623613478a5dd0be$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $623613478a5dd0be$var$isLegacyGeoTargetingV2Token = function isLegacyGeoTargetingV2Token(consentToken) {
    var version = consentToken[0] + consentToken[1] + consentToken[2];
    var isV2Schema = version === (0, $gT26D.V002_SCHEMA_KEY);
    return isV2Schema;
};
var $623613478a5dd0be$export$42b0ca8aba2631e4 = function hasLegacyV2TokenConsentedPreviously(consentToken) {
    if ($623613478a5dd0be$var$isLegacyGeoTargetingV2Token(consentToken)) {
        // If we're looking at a V2 token and they have ANY saved 'consentedUnderXX' bits,
        // we know it must be a set of valid consents instead of defaults
        var consentedUnderGDPR = consentToken[8] === "1";
        var consentedUnderCPRA = consentToken[9] === "1";
        var consentedUnderLGPD = consentToken[10] === "1";
        var consentedUnderFADP = consentToken[11] === "1";
        var hasConsentedPreviously = consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP;
        return hasConsentedPreviously;
    }
    return false;
};
var $623613478a5dd0be$export$497a647f0eb30ef4 = function checkIfTokenIsDefault(consentToken) {
    var isLegacyV2Token = $623613478a5dd0be$var$isLegacyGeoTargetingV2Token(consentToken);
    if (isLegacyV2Token) {
        var legacyTokenHasConsents = $623613478a5dd0be$export$42b0ca8aba2631e4(consentToken);
        return !legacyTokenHasConsents;
    }
    var isDefaultToken = (0, $je318.getBoolFromBitValue)(consentToken[7]);
    return isDefaultToken;
};
var $623613478a5dd0be$export$c42e1a74e60f4d73 = function getDefaultBits(consentsUnavailable) {
    var version = (0, $gT26D.V003_SCHEMA_KEY);
    // DEFAULT_PREFERENCES now has the default boolean baked into it, so we don't need to set it here
    var serializedBits = Object.entries((0, $gT26D.DEFAULT_PREFERENCES)).reduce(function(acc, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), key = _ref2[0], val = _ref2[1];
        // Skip the STRICTLY_NECESSARY as it's always allowed
        if (key === (0, $eT61T.PreferenceCategory).StrictlyNecessary) return acc;
        if (key === (0, $eT61T.ContextualConsentProperty).UserIsAuthenticated) {
            // If consents are missing when setting these defaults, the user will be logged out,
            // so pack this info into the consent token bits
            var userIsAuthed = !consentsUnavailable;
            return acc + (0, $je318.getBitValueFromBool)(userIsAuthed);
        }
        if (key === (0, $eT61T.ContextualConsentProperty).ConsentDataUnavailable) // If consents are missing when setting these defaults, the user will be logged out,
        // so pack this info into the consent token bits
        return acc + (0, $je318.getBitValueFromBool)(!!consentsUnavailable);
        return acc + (0, $je318.getBitValueFromBool)(val);
    }, "");
    return "".concat(version).concat(serializedBits);
};
var $623613478a5dd0be$export$42a0b3fb1e53e7b9 = function getSavedConsentBits(consents) {
    var _consents$find, _consents$find2, _consents$find3, _consents$find4;
    var version = (0, $gT26D.V003_SCHEMA_KEY);
    // As 'strictlyNecessaryConsent' would always be allowed, we don't store it in the cookie or use ConsentHub
    var functionalConsent = (0, $je318.getBitValueFromBool)(!!((_consents$find = consents.find(function(key) {
        return key.key === (0, $4QdHN.ConsentHubKey).Functional;
    })) !== null && _consents$find !== void 0 && _consents$find.granted));
    var analyticsConsent = (0, $je318.getBitValueFromBool)(!!((_consents$find2 = consents.find(function(key) {
        return key.key === (0, $4QdHN.ConsentHubKey).Analytics;
    })) !== null && _consents$find2 !== void 0 && _consents$find2.granted));
    var marketingConsent = (0, $je318.getBitValueFromBool)(!!((_consents$find3 = consents.find(function(key) {
        return key.key === (0, $4QdHN.ConsentHubKey).Marketing;
    })) !== null && _consents$find3 !== void 0 && _consents$find3.granted));
    var unknownConsent = (0, $je318.getBitValueFromBool)(!!((_consents$find4 = consents.find(function(key) {
        return key.key === (0, $4QdHN.ConsentHubKey).Unknown;
    })) !== null && _consents$find4 !== void 0 && _consents$find4.granted));
    // As these consents were returned from the server, ConsentHub is obviously available, they're logged in, and aren't defaults
    var isDefaultToken = 0;
    var userIsAuthenticated = 1;
    var consentHubDataUnavailable = 0;
    return [
        version,
        functionalConsent,
        analyticsConsent,
        marketingConsent,
        unknownConsent,
        isDefaultToken,
        userIsAuthenticated,
        consentHubDataUnavailable
    ].join("");
};
var $623613478a5dd0be$export$92ba0b2fe50f90df = function serializeConsents(_ref3) {
    var consents = _ref3.consents;
    if (!consents) {
        // When generating consents for an unauthenticated user, use the fallback token if it exists
        // This circumvents us setting defaults for them if their token has expired, but they have consented previously
        var existingFallbackToken = (0, $86hZh.getCookie)((0, $gT26D.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        if (existingFallbackToken) return existingFallbackToken;
        // User is unauthed, will only use local consenting, consent data will also be unavailable
        return $623613478a5dd0be$export$c42e1a74e60f4d73(true); // e.g. 0030000101
    } else if (consents.length === 0) // User is authed but has no consents in the system, so use defaults in the interim, consentData must be available
    return $623613478a5dd0be$export$c42e1a74e60f4d73(); // e.g. 0030000110
    else // User is authed and has consents in the system
    return $623613478a5dd0be$export$42a0b3fb1e53e7b9(consents); // e.g. 0030110110
};
var $623613478a5dd0be$export$bfa0c91662787fb0 = function deserializeConsents(unpackedUserPreferences, displayedTextMap) {
    var _consentKeyMap;
    var validConsentHubCookieConsents = [
        (0, $eT61T.PreferenceCategory).StrictlyNecessary,
        (0, $eT61T.PreferenceCategory).Functional,
        (0, $eT61T.PreferenceCategory).Analytics,
        (0, $eT61T.PreferenceCategory).Marketing,
        (0, $eT61T.PreferenceCategory).Unknown
    ];
    var consentKeyMap = (_consentKeyMap = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_consentKeyMap, (0, $eT61T.PreferenceCategory).StrictlyNecessary, (0, $4QdHN.ConsentHubKey).StrictlyNecessary), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_consentKeyMap, (0, $eT61T.PreferenceCategory).Functional, (0, $4QdHN.ConsentHubKey).Functional), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_consentKeyMap, (0, $eT61T.PreferenceCategory).Analytics, (0, $4QdHN.ConsentHubKey).Analytics), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_consentKeyMap, (0, $eT61T.PreferenceCategory).Marketing, (0, $4QdHN.ConsentHubKey).Marketing), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_consentKeyMap, (0, $eT61T.PreferenceCategory).Unknown, (0, $4QdHN.ConsentHubKey).Unknown), _consentKeyMap);
    var consentRecords = validConsentHubCookieConsents.map(function(consentKey) {
        var key = consentKeyMap[consentKey];
        return {
            key: key,
            granted: !!unpackedUserPreferences[consentKey],
            gatheredTs: new Date().toISOString(),
            displayedText: displayedTextMap[consentKey]
        };
    });
    return consentRecords;
};
var $623613478a5dd0be$export$13e4cff933f26b03 = function getConsentTimestamp(_ref4) {
    var consents = _ref4.consents;
    if (consents && consents.length) {
        // As consents can be updated individually, we need to find the most recent timestamp to use as "most recent consent"
        var timestamps = consents.map(function(consent) {
            return new Date(consent.updatedTs).getTime();
        });
        var maxTimestamp = Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(timestamps));
        var mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
        return mostRecentConsentTimestamp;
    }
};
var $623613478a5dd0be$export$3387347b75450ae1 = function checkIfConsentsAreStale(consentTimestamp) {
    // Privacy has determined that we should re-prompt users for consent if they haven't
    // consented in over a year regardless, because they're legally stale/expired
    var consentedOverAYearAgo = false;
    if (consentTimestamp) {
        var oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
    }
    return consentedOverAYearAgo;
};
var $623613478a5dd0be$export$a79c0ea3d7c2444a = /*#__PURE__*/ function(_Error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(StatusCodeError, _Error);
    var _super = $623613478a5dd0be$var$_createSuper(StatusCodeError);
    function StatusCodeError(message, status) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, StatusCodeError);
        _this = _super.call(this, message);
        _this.status = status;
        Object.setPrototypeOf((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), StatusCodeError.prototype);
        // Captures the stack trace (for environments that support it)
        if (Error.captureStackTrace) Error.captureStackTrace((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), StatusCodeError);
        _this.name = "StatusCodeError";
        return _this;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(StatusCodeError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6FnrE)))(Error));

});
parcelRegister("4QdHN", function(module, exports) {

$parcel$export(module.exports, "ConsentHubKey", function () { return $3866a65e3857d55b$export$31140359b1e505cf; });
// If consents are present and populated, the user is authenticated and has recorded preferences.
// If consents are present but empty, the user is authenticated and has no preferences in the system.
// If consents are not present in the DB, the user is unauthenticated and has no preferences in the system.
// currentLocale will always be present if available ("UNKNOWN" if not), regardless of auth status
// localeWhenConsented will never be relevant for unauthenticated users.
// Typical locale format: <countryCode>-<subdivisionCode> e.g. 'FR-ARA' for France, or 'US-VA' for Virginia
// There are ~30m users who do not have the modern version of their locale stored in ConsentHub (inclusive of the subdivision)
// which means we need to account for instances where we ONLY have the country code of US.
// SSR teams can look at the cached cookie result and pre-load that rather than fetching from CH
// SSR teams can look at the cached cookie result and pre-load that rather than fetching from CH
var $3866a65e3857d55b$export$31140359b1e505cf = /*#__PURE__*/ function(ConsentHubKey) {
    ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
    ConsentHubKey["Functional"] = "functionalCookies";
    ConsentHubKey["Analytics"] = "performanceCookies";
    ConsentHubKey["Marketing"] = "targetingCookies";
    ConsentHubKey["Unknown"] = "unknownCookies";
    return ConsentHubKey;
}({});

});


parcelRegister("eR97O", function(module, exports) {

$parcel$export(module.exports, "checkTokenVersionValidity", function () { return $ad0d17f484fc0ee9$export$64b31470e8522819; });
$parcel$export(module.exports, "packUserPreferences", function () { return $ad0d17f484fc0ee9$export$3199823fec979bd1; });
$parcel$export(module.exports, "unpackUserPreferencesCookie", function () { return $ad0d17f484fc0ee9$export$8d213cb390bab4fa; });
$parcel$export(module.exports, "initialPreferencesAreMissing", function () { return $ad0d17f484fc0ee9$export$67f70eb55341bd29; });
$parcel$export(module.exports, "handleInitialPreferencesData", function () { return $ad0d17f484fc0ee9$export$9dbe8b0fdea9edf3; });

var $kFnE9 = parcelRequire("kFnE9");

var $lHRVb = parcelRequire("lHRVb");

var $je318 = parcelRequire("je318");

var $gT26D = parcelRequire("gT26D");

var $8qM7g = parcelRequire("8qM7g");

var $eT61T = parcelRequire("eT61T");
function $ad0d17f484fc0ee9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ad0d17f484fc0ee9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ad0d17f484fc0ee9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ad0d17f484fc0ee9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ad0d17f484fc0ee9$export$64b31470e8522819 = function checkTokenVersionValidity(consentToken) {
    // A token can technically be bad data (alphanumeric instead of binary) but we should fail gracefully if so
    if (consentToken.length < 3) // Wrong format, no version
    return {
        isValid: false,
        isV001: false,
        isV002: false,
        isV003: false
    };
    var version = consentToken[0] + consentToken[1] + consentToken[2];
    var isV001 = version === (0, $gT26D.V001_SCHEMA_KEY) && consentToken.length === 7;
    var isV002 = version === (0, $gT26D.V002_SCHEMA_KEY) && consentToken.length === 12;
    var isV003 = version === (0, $gT26D.V003_SCHEMA_KEY) && consentToken.length === 10;
    // We support version 001, 002, 003 only
    var isSupportedVersion = [
        (0, $gT26D.V001_SCHEMA_KEY),
        (0, $gT26D.V002_SCHEMA_KEY),
        (0, $gT26D.V003_SCHEMA_KEY)
    ].includes(version);
    var isValid = isSupportedVersion && (isV001 || isV002 || isV003);
    return {
        isValid: isValid,
        isV001: isV001,
        isV002: isV002,
        isV003: isV003
    };
};
/* Schema Version 001:
---------------------------------------------------
  - Format 0000000
  - 001 (schema version 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies disabled/enabled)
*/ var $ad0d17f484fc0ee9$var$packPrefsVersion001 = function packPrefsVersion001(userPreferences) {
    var version = (0, $gT26D.V001_SCHEMA_KEY);
    return [
        version,
        (0, $je318.getBitValueFromBool)(userPreferences.FUNCTIONAL),
        (0, $je318.getBitValueFromBool)(userPreferences.ANALYTICS),
        (0, $je318.getBitValueFromBool)(userPreferences.MARKETING),
        (0, $je318.getBitValueFromBool)(userPreferences.UNKNOWN)
    ].join("");
};
var $ad0d17f484fc0ee9$var$unpackPrefsVersion001 = function unpackPrefsVersion001(userPreferencesCookie) {
    var _ref;
    if (userPreferencesCookie.length !== 7) // Wrong length for version 001
    return;
    return _ref = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref, (0, $eT61T.PreferenceCategory).StrictlyNecessary, true), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref, (0, $eT61T.PreferenceCategory).Functional, userPreferencesCookie[3] === "1"), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref, (0, $eT61T.PreferenceCategory).Analytics, userPreferencesCookie[4] === "1"), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref, (0, $eT61T.PreferenceCategory).Marketing, userPreferencesCookie[5] === "1"), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref, (0, $eT61T.PreferenceCategory).Unknown, userPreferencesCookie[6] === "1"), _ref;
};
/* Schema Version 002 ***** DEPRECATED *****
---------------------------------------------------
  - Format 000000000000
  - 002 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, consent records are unavailable from ConsentHub (logged out) - yes/no)
  - 0/1 (1 digit, consents saved while in GDPR locale (Europe) - yes/no)
  - 0/1 (1 digit, consents saved while in CPRA locale (CPRA will act as 'all USA' bucket) - yes/no)
  - 0/1 (1 digit, consents saved while in LGPD locale (Brazil) - yes/no)
  - 0/1 (1 digit, consents saved while in FADP locale (Switzerland) - yes/no)
*/ var $ad0d17f484fc0ee9$var$packPrefsVersion002 = function packPrefsVersion002(userPreferences) {
    // As we want to slowly kill off any V002 preferences, if we're provided one for some reason
    // internally convert it to a V003 preference to drop contextual GeoIP details
    var version = (0, $gT26D.V003_SCHEMA_KEY);
    var hasConsentedPreviously = userPreferences[(0, $eT61T.ConsentPreferenceV2).ConsentedUnderGDPR] || userPreferences[(0, $eT61T.ConsentPreferenceV2).ConsentedUnderCPRA] || userPreferences[(0, $eT61T.ConsentPreferenceV2).ConsentedUnderLGPD] || userPreferences[(0, $eT61T.ConsentPreferenceV2).ConsentedUnderFADP];
    var isDefaultConsentBit = !hasConsentedPreviously;
    // As we've broken out authentication insights/context from "ConsentDataUnavailable" bit in V3,
    // and it does not exist, we will backfill the value based on the previous bit state
    var existingConsentDataUnavailableBit = userPreferences[(0, $eT61T.ContextualConsentProperty).ConsentDataUnavailable];
    var userIsAuthenticatedBit = !existingConsentDataUnavailableBit;
    return [
        version,
        (0, $je318.getBitValueFromBool)(userPreferences[(0, $eT61T.PreferenceCategory).Functional]),
        (0, $je318.getBitValueFromBool)(userPreferences[(0, $eT61T.PreferenceCategory).Analytics]),
        (0, $je318.getBitValueFromBool)(userPreferences[(0, $eT61T.PreferenceCategory).Marketing]),
        (0, $je318.getBitValueFromBool)(userPreferences[(0, $eT61T.PreferenceCategory).Unknown]),
        (0, $je318.getBitValueFromBool)(isDefaultConsentBit),
        (0, $je318.getBitValueFromBool)(userIsAuthenticatedBit),
        (0, $je318.getBitValueFromBool)(existingConsentDataUnavailableBit)
    ].join("");
};
var $ad0d17f484fc0ee9$var$unpackPrefsVersion002 = function unpackPrefsVersion002(userPreferencesCookie) {
    var _objectSpread2;
    // If the provided V002 token has consented anywhere, we'll drop the contextual GeoIP bits and
    // convert it to a V003 schema
    var isADefaultConsentToken = (0, $8qM7g.checkIfTokenIsDefault)(userPreferencesCookie);
    // Backfill the value based on the previous "ConsentDataUnavailable" bit state as we've broken this contextual info out
    var consentDataUnavailable = userPreferencesCookie[7] === "1";
    var userIsDeemedAuthenticated = !consentDataUnavailable;
    return $ad0d17f484fc0ee9$var$_objectSpread($ad0d17f484fc0ee9$var$_objectSpread({}, $ad0d17f484fc0ee9$var$unpackPrefsVersion003(userPreferencesCookie)), {}, (_objectSpread2 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, (0, $eT61T.ContextualConsentProperty).ConsentsAreDefault, !!isADefaultConsentToken), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, (0, $eT61T.ContextualConsentProperty).UserIsAuthenticated, userIsDeemedAuthenticated), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, (0, $eT61T.ContextualConsentProperty).ConsentDataUnavailable, consentDataUnavailable), _objectSpread2));
};
/* Schema Version 003
---------------------------------------------------
  - Format 000000000
  - 003 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, Consent token in a default state, user has yet to consent) - no/yes)
  - 0/1 (1 digit, User is authenticated, did not 401 during save) - no/yes)
  - 0/1 (1 digit, ConsentHub records are unavailable (CH is down, errored while saving, etc) - no/yes)
*/ var $ad0d17f484fc0ee9$var$packPrefsVersion003 = function packPrefsVersion003(userPreferences) {
    var version = (0, $gT26D.V003_SCHEMA_KEY);
    return [
        version,
        (0, $je318.getBitValueFromBool)(userPreferences[(0, $eT61T.PreferenceCategory).Functional]),
        (0, $je318.getBitValueFromBool)(userPreferences[(0, $eT61T.PreferenceCategory).Analytics]),
        (0, $je318.getBitValueFromBool)(userPreferences[(0, $eT61T.PreferenceCategory).Marketing]),
        (0, $je318.getBitValueFromBool)(userPreferences[(0, $eT61T.PreferenceCategory).Unknown]),
        (0, $je318.getBitValueFromBool)(userPreferences[(0, $eT61T.ContextualConsentProperty).ConsentsAreDefault]),
        (0, $je318.getBitValueFromBool)(userPreferences[(0, $eT61T.ContextualConsentProperty).UserIsAuthenticated]),
        (0, $je318.getBitValueFromBool)(userPreferences[(0, $eT61T.ContextualConsentProperty).ConsentDataUnavailable])
    ].join("");
};
var $ad0d17f484fc0ee9$var$unpackPrefsVersion003 = function unpackPrefsVersion003(userPreferencesCookie) {
    var _ref2;
    return _ref2 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref2, (0, $eT61T.PreferenceCategory).StrictlyNecessary, true), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref2, (0, $eT61T.PreferenceCategory).Functional, userPreferencesCookie[3] === "1"), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref2, (0, $eT61T.PreferenceCategory).Analytics, userPreferencesCookie[4] === "1"), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref2, (0, $eT61T.PreferenceCategory).Marketing, userPreferencesCookie[5] === "1"), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref2, (0, $eT61T.PreferenceCategory).Unknown, userPreferencesCookie[6] === "1"), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref2, (0, $eT61T.ContextualConsentProperty).ConsentsAreDefault, userPreferencesCookie[7] === "1"), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref2, (0, $eT61T.ContextualConsentProperty).UserIsAuthenticated, userPreferencesCookie[8] === "1"), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref2, (0, $eT61T.ContextualConsentProperty).ConsentDataUnavailable, userPreferencesCookie[9] === "1"), _ref2;
};
var $ad0d17f484fc0ee9$var$V002SpecificBitKeys = [
    (0, $eT61T.ContextualConsentProperty).ConsentDataUnavailable,
    (0, $eT61T.ConsentPreferenceV2).ConsentedUnderGDPR,
    (0, $eT61T.ConsentPreferenceV2).ConsentedUnderCPRA,
    (0, $eT61T.ConsentPreferenceV2).ConsentedUnderLGPD,
    (0, $eT61T.ConsentPreferenceV2).ConsentedUnderFADP
];
var $ad0d17f484fc0ee9$var$V003SpecificBitKeys = [
    (0, $eT61T.ContextualConsentProperty).ConsentsAreDefault,
    (0, $eT61T.ContextualConsentProperty).UserIsAuthenticated,
    (0, $eT61T.ContextualConsentProperty).ConsentDataUnavailable
];
function $ad0d17f484fc0ee9$export$3199823fec979bd1(userPreferences) {
    if (!(0, $lHRVb.fg)("platform.moonjelly.browser-storage-controls-v2")) return $ad0d17f484fc0ee9$var$packPrefsVersion001(userPreferences);
    var isV002 = $ad0d17f484fc0ee9$var$V002SpecificBitKeys.every(function(key) {
        return key in userPreferences;
    });
    if (isV002) // As V002 is deprecated, if we've been provided V002 set of "legacy" prefs, internally
    // convert them to V003 to drop the unnecessary contextual details
    return $ad0d17f484fc0ee9$var$packPrefsVersion002(userPreferences);
    var isV003 = $ad0d17f484fc0ee9$var$V003SpecificBitKeys.every(function(key) {
        return key in userPreferences;
    });
    if (isV003) return $ad0d17f484fc0ee9$var$packPrefsVersion003(userPreferences);
    // Fallback to V001
    return $ad0d17f484fc0ee9$var$packPrefsVersion001(userPreferences);
}
function $ad0d17f484fc0ee9$export$8d213cb390bab4fa(userPreferencesCookie) {
    if (!(0, $lHRVb.fg)("platform.moonjelly.browser-storage-controls-v2")) {
        if (userPreferencesCookie.length < 3) // Wrong format, no version
        return;
        var version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version === (0, $gT26D.V001_SCHEMA_KEY)) return $ad0d17f484fc0ee9$var$unpackPrefsVersion001(userPreferencesCookie);
        return;
    }
    var _checkTokenVersionVal = $ad0d17f484fc0ee9$export$64b31470e8522819(userPreferencesCookie), isValid = _checkTokenVersionVal.isValid, isV001 = _checkTokenVersionVal.isV001, isV002 = _checkTokenVersionVal.isV002, isV003 = _checkTokenVersionVal.isV003;
    if (!isValid) // We support version 001, 002, 003 only
    return;
    if (isV001) return $ad0d17f484fc0ee9$var$unpackPrefsVersion001(userPreferencesCookie);
    if (isV002) // Deprecated, so this will unpack to 003 to drop the contextual GeoIP bits
    return $ad0d17f484fc0ee9$var$unpackPrefsVersion002(userPreferencesCookie);
    if (isV003) return $ad0d17f484fc0ee9$var$unpackPrefsVersion003(userPreferencesCookie);
}
var $ad0d17f484fc0ee9$export$67f70eb55341bd29 = function initialPreferencesAreMissing(initialPreferences) {
    if (!initialPreferences) return true;
    var prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
    return prefExistButAreEmpty;
};
var $ad0d17f484fc0ee9$export$9dbe8b0fdea9edf3 = function handleInitialPreferencesData(initialPreferences) {
    if (initialPreferences !== (0, $eT61T.PrefetchedPreferenceState).INTERNAL) {
        if ($ad0d17f484fc0ee9$export$67f70eb55341bd29(initialPreferences)) // Failsafe handling: Consumer failed to provide data even though they have prefetched, so we need to fetch again
        // This may occur if a consumer's prefetch requests fails, or if they fail to implement the system correctly
        return (0, $eT61T.PrefetchedPreferenceState).INTERNAL;
        // If initialPreferences is not INTERNAL on first render, we have been provided a pre-fetched
        // value, which means we don't need to make a fetch to storage or ConsentHub to get it.
        // If that preference is defined, we persist it to our local cookie set
        // If the data is a ConsentHubResponse/PrefetchedConsentCookieData, we'll need to transform it properly before consumption
        var consentToken = initialPreferences === null || initialPreferences === void 0 ? void 0 : initialPreferences.consentToken;
        if (consentToken) {
            // We already have a consent cookie that was passed in, let's not override it by setting it again
            var unpackedExistingPrefs = $ad0d17f484fc0ee9$export$8d213cb390bab4fa(consentToken);
            return unpackedExistingPrefs !== null && unpackedExistingPrefs !== void 0 ? unpackedExistingPrefs : (0, $eT61T.PrefetchedPreferenceState).INTERNAL;
        }
        var serializedPrefetchedConsentToken = (0, $8qM7g.serializeConsents)(initialPreferences);
        var unpackedPrefetchedPrefs = $ad0d17f484fc0ee9$export$8d213cb390bab4fa(serializedPrefetchedConsentToken);
        return unpackedPrefetchedPrefs || (0, $eT61T.PrefetchedPreferenceState).INTERNAL;
    }
    // If we've fallen into this, EMPTY implies we have no data at all
    // INTERNAL implies we still need to fetch new data, so trigger a refetch
    return initialPreferences;
};

});


parcelRegister("4Qrev", function(module, exports) {

$parcel$export(module.exports, "setStrictlyNecessaryCookie", function () { return $387124a65912d55b$export$93509ff9a62ee022; });

var $kFnE9 = parcelRequire("kFnE9");

var $1Qo9y = parcelRequire("1Qo9y");

var $lHRVb = parcelRequire("lHRVb");

var $jtYt3 = parcelRequire("jtYt3");

var $JZBNd = parcelRequire("JZBNd");
function $387124a65912d55b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $387124a65912d55b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $387124a65912d55b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $387124a65912d55b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $387124a65912d55b$export$93509ff9a62ee022 = function setStrictlyNecessaryCookie(key, value, attributes) {
    try {
        if ((0, $lHRVb.fg)("platform.moonjelly.browser-storage-controls")) (0, $jtYt3.sendPackageOperationalEvent)({
            action: "usedSetStrictlyNecessaryCookie",
            attributes: {
                cookieKey: key
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qo9y))).set(key, value, $387124a65912d55b$var$_objectSpread($387124a65912d55b$var$_objectSpread({}, attributes), {}, {
            "atl-set-cookie": true
        }));
    } catch (e) {
        (0, $JZBNd.Logger).errorWithOperationalEvent({
            action: "usedSetStrictlyNecessaryCookieError",
            attributes: {
                cookieKey: key
            },
            message: "Failed to use set strictly necessary cookie. ".concat(e.message || "")
        });
    }
};

});


parcelRegister("4eEyM", function(module, exports) {

$parcel$export(module.exports, "getValidConsentData", function () { return $3157ee9d9a636f66$export$c515de1cc9cebc71; });

var $4mVfk = parcelRequire("4mVfk");

var $8DpVo = parcelRequire("8DpVo");

var $kR3yl = parcelRequire("kR3yl");

var $eR97O = parcelRequire("eR97O");
var $3157ee9d9a636f66$export$c515de1cc9cebc71 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee(fallbackConsentToken) {
        var consentData, consentToken, consentTimestamp, consentHubInaccessible, _checkTokenVersionVal, isValid;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return (0, $kR3yl.fetchConsentPreferences)();
                case 2:
                    consentData = _context.sent;
                    consentToken = consentData.consentToken, consentTimestamp = consentData.consentTimestamp, consentHubInaccessible = consentData.consentHubInaccessible;
                    _checkTokenVersionVal = (0, $eR97O.checkTokenVersionValidity)(consentToken), isValid = _checkTokenVersionVal.isValid;
                    if (isValid && consentHubInaccessible) {
                        if (fallbackConsentToken) // `consentHubInaccessible`: ConsentHub request failed (e.g. service is down/bad request/etc). Attempt to use
                        // any previously set consents in the interim if we have them.
                        consentToken = fallbackConsentToken;
                        else // Temporary: Sets the default token to have true consentedUnderXXXX bits
                        // when ConsentHub is inaccessible and there is not fallback token. This
                        // will ensure the banner isn't shown when ConsentHub is down.
                        consentToken = "".concat(consentToken.slice(0, 8), "1111");
                    }
                    return _context.abrupt("return", isValid ? {
                        consentToken: consentToken,
                        consentTimestamp: consentTimestamp
                    } : undefined);
                case 7:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function getValidConsentData(_x) {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("kR3yl", function(module, exports) {

$parcel$export(module.exports, "fetchConsentPreferences", function () { return $f2eb836988a42fdd$export$86467566615ab85e; });
$parcel$export(module.exports, "saveConsentPreferences", function () { return $f2eb836988a42fdd$export$f8422650c3dec8b2; });

var $4mVfk = parcelRequire("4mVfk");

var $8DpVo = parcelRequire("8DpVo");

var $JZBNd = parcelRequire("JZBNd");

var $8qM7g = parcelRequire("8qM7g");
var $f2eb836988a42fdd$var$BASE_CONSENTS_URL = "/gateway/api/consenthub/session";
var $f2eb836988a42fdd$var$POST_CONSENTS_URL = "".concat($f2eb836988a42fdd$var$BASE_CONSENTS_URL, "/user");
var $f2eb836988a42fdd$var$GET_CONSENTS_URL = "".concat($f2eb836988a42fdd$var$POST_CONSENTS_URL, "/consents/cookies");
var $f2eb836988a42fdd$export$bd9f5bcbf9cd947c = function buildConsentPreferences(consentData) {
    if (consentData) {
        var serializedConsents = (0, $8qM7g.serializeConsents)(consentData);
        var consentTimestamp = (0, $8qM7g.getConsentTimestamp)(consentData);
        return {
            consentToken: serializedConsents,
            consentTimestamp: consentTimestamp
        };
    }
    // Without consent data (due to server failure or unauthenticated user), set defaults illustrating that absence
    return {
        consentToken: (0, $8qM7g.serializeConsents)({}),
        consentHubInaccessible: true
    };
};
var $f2eb836988a42fdd$export$86467566615ab85e = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee() {
        var origin, getFromConsentHubURL, response, consentData;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    origin = window.location.origin;
                    getFromConsentHubURL = "".concat(origin).concat($f2eb836988a42fdd$var$GET_CONSENTS_URL);
                    _context.prev = 2;
                    _context.next = 5;
                    return fetch(getFromConsentHubURL, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json"
                        }
                    });
                case 5:
                    response = _context.sent;
                    if (response.ok) {
                        _context.next = 8;
                        break;
                    }
                    throw new Error("Failed to fetch preferences from ConsentHub with status: ".concat(response.status));
                case 8:
                    _context.next = 10;
                    return response.json();
                case 10:
                    consentData = _context.sent;
                    return _context.abrupt("return", $f2eb836988a42fdd$export$bd9f5bcbf9cd947c(consentData));
                case 14:
                    _context.prev = 14;
                    _context.t0 = _context["catch"](2);
                    (0, $JZBNd.Logger).errorWithOperationalEvent({
                        action: "fetchConsentPreferencesError",
                        message: _context.t0.message || ""
                    });
                    return _context.abrupt("return", $f2eb836988a42fdd$export$bd9f5bcbf9cd947c());
                case 18:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                2,
                14
            ]
        ]);
    }));
    return function fetchConsentPreferences() {
        return _ref.apply(this, arguments);
    };
}();
var $f2eb836988a42fdd$var$buildConsentRequestBody = function buildConsentRequestBody(unpackedUserPreferences, displayedTextMap) {
    var _window$location = window.location, origin = _window$location.origin, pathname = _window$location.pathname;
    var deserializedConsents = (0, $8qM7g.deserializeConsents)(unpackedUserPreferences, displayedTextMap);
    // Type guard here so TS knows we're working with ConsentPreferenceV003
    var action = "CONSENT_DATA_UNAVAILABLE" in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? "FORM_FILL" : "UPDATE_PREFERENCES";
    var consentRequestBody = {
        action: action,
        // If there are no consents, it's a first time fill, otherwise it's an update action
        consents: deserializedConsents,
        formUrl: "".concat(origin).concat(pathname),
        locale: "UNKNOWN",
        site: "atlassian",
        source: "COOKIE_PREFERENCES"
    };
    return JSON.stringify(consentRequestBody);
};
var $f2eb836988a42fdd$export$f8422650c3dec8b2 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee2(unpackedUserPreferences, displayedTextMap) {
        var saveToConsentHubURL, response, errMsg, errWithStatusCode;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    saveToConsentHubURL = "".concat(window.location.origin).concat($f2eb836988a42fdd$var$POST_CONSENTS_URL);
                    _context2.prev = 1;
                    _context2.next = 4;
                    return fetch(saveToConsentHubURL, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: $f2eb836988a42fdd$var$buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
                    });
                case 4:
                    response = _context2.sent;
                    if (!(!response.ok || response.status !== 202 && response.status !== 200)) {
                        _context2.next = 9;
                        break;
                    }
                    errMsg = "Failed to save preferences to ConsentHub with status: ".concat(response.status);
                    errWithStatusCode = new (0, $8qM7g.StatusCodeError)(errMsg, response.status);
                    throw errWithStatusCode;
                case 9:
                    _context2.next = 15;
                    break;
                case 11:
                    _context2.prev = 11;
                    _context2.t0 = _context2["catch"](1);
                    (0, $JZBNd.Logger).errorWithOperationalEvent({
                        action: "saveConsentPreferencesError",
                        message: _context2.t0.message || ""
                    });
                    // Re-throw to any encapsulating logic, a la `setConsentToken()`
                    throw _context2.t0;
                case 15:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                1,
                11
            ]
        ]);
    }));
    return function saveConsentPreferences(_x, _x2) {
        return _ref2.apply(this, arguments);
    };
}();

});




parcelRegister("9FrJk", function(module, exports) {

$parcel$export(module.exports, "getActiveInteraction", function () { return $709d74081b488d1c$export$2b3954d2e8509985; });
$parcel$export(module.exports, "updatePageLoadInteractionName", function () { return $709d74081b488d1c$export$f6f1cf5bedf83c71; });
$parcel$export(module.exports, "addCustomData", function () { return $709d74081b488d1c$export$e4380431c2bdabee; });
$parcel$export(module.exports, "addCustomTiming", function () { return $709d74081b488d1c$export$27cacb7d7f3fe20a; });
$parcel$export(module.exports, "addMark", function () { return $709d74081b488d1c$export$728e28c22a0fba4; });
$parcel$export(module.exports, "addSpan", function () { return $709d74081b488d1c$export$2c1d6e17cfa9bbc7; });
$parcel$export(module.exports, "addSpanToAll", function () { return $709d74081b488d1c$export$943a8b2b5d6b1809; });
$parcel$export(module.exports, "addHold", function () { return $709d74081b488d1c$export$7606887303596f82; });
$parcel$export(module.exports, "addHoldByID", function () { return $709d74081b488d1c$export$10582acd678c213; });
$parcel$export(module.exports, "removeHoldByID", function () { return $709d74081b488d1c$export$4983dfbbb996f7ae; });
$parcel$export(module.exports, "getCurrentInteractionType", function () { return $709d74081b488d1c$export$2df109852219d16e; });
$parcel$export(module.exports, "addProfilerTimings", function () { return $709d74081b488d1c$export$53d6f611de951a13; });
$parcel$export(module.exports, "sinkInteractionHandler", function () { return $709d74081b488d1c$export$9e614a29a1ac213e; });
$parcel$export(module.exports, "tryComplete", function () { return $709d74081b488d1c$export$673be905888f8839; });
$parcel$export(module.exports, "abort", function () { return $709d74081b488d1c$export$5def58af4fd46132; });
$parcel$export(module.exports, "abortByNewInteraction", function () { return $709d74081b488d1c$export$c4a545284f55edf2; });
$parcel$export(module.exports, "abortAll", function () { return $709d74081b488d1c$export$614a7af2affc5dff; });
$parcel$export(module.exports, "addOnCancelCallback", function () { return $709d74081b488d1c$export$7b9261a96cfe427b; });
$parcel$export(module.exports, "addNewInteraction", function () { return $709d74081b488d1c$export$1a1ed1e1fdb2006b; });
$parcel$export(module.exports, "addApdex", function () { return $709d74081b488d1c$export$35220fd6cdd1b731; });
$parcel$export(module.exports, "addRequestInfo", function () { return $709d74081b488d1c$export$57d55b4569823d8f; });
$parcel$export(module.exports, "addSegment", function () { return $709d74081b488d1c$export$1c43f9ac826b6462; });
$parcel$export(module.exports, "removeSegment", function () { return $709d74081b488d1c$export$d0365e48b58231c3; });
parcelRequire("9q1kH");

var $kFnE9 = parcelRequire("kFnE9");

var $b4Ivn = parcelRequire("b4Ivn");

var $5m0MG = parcelRequire("5m0MG");

var $4Pw3J = parcelRequire("4Pw3J");

var $41O29 = parcelRequire("41O29");

var $4wIrX = parcelRequire("4wIrX");

var $biOnu = parcelRequire("biOnu");

var $2xpzD = parcelRequire("2xpzD");

var $gJaix = parcelRequire("gJaix");

var $fQHfi = parcelRequire("fQHfi");
function $709d74081b488d1c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $709d74081b488d1c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $709d74081b488d1c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $709d74081b488d1c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $709d74081b488d1c$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $709d74081b488d1c$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $709d74081b488d1c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $709d74081b488d1c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $709d74081b488d1c$var$_arrayLikeToArray(o, minLen);
}
function $709d74081b488d1c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $709d74081b488d1c$var$PreviousInteractionLog = {
    name: undefined,
    isAborted: undefined
};
var $709d74081b488d1c$var$interactionQueue = [];
var $709d74081b488d1c$var$segmentCache = new Map();
var $709d74081b488d1c$var$CLEANUP_TIMEOUT = 60000;
var $709d74081b488d1c$var$CLEANUP_TIMEOUT_AFTER_APDEX = 15000;
var $709d74081b488d1c$var$segmentObservers = [];
function $709d74081b488d1c$export$2b3954d2e8509985() {
    var interactionId = (0, $2xpzD.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $fQHfi.default).get(interactionId.current);
}
function $709d74081b488d1c$var$labelStackToString(labelStack, name) {
    var _stack$map;
    var stack = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(labelStack !== null && labelStack !== void 0 ? labelStack : []);
    if (name) stack.push({
        name: name
    });
    return (_stack$map = stack.map(function(l) {
        return l.name;
    })) === null || _stack$map === void 0 ? void 0 : _stack$map.join("/");
}
function $709d74081b488d1c$var$labelStackToIdString(labelStack) {
    var _labelStack$map;
    return labelStack === null || labelStack === void 0 || (_labelStack$map = labelStack.map(function(l) {
        return "segmentId" in l ? "".concat(l.name, ":").concat(l.segmentId) : "".concat(l.name);
    })) === null || _labelStack$map === void 0 ? void 0 : _labelStack$map.join("/");
}
function $709d74081b488d1c$var$addSegmentObserver(observer) {
    $709d74081b488d1c$var$segmentObservers.push(observer);
    var _iterator = $709d74081b488d1c$var$_createForOfIteratorHelper($709d74081b488d1c$var$segmentCache.values()), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var segmentInfo = _step.value;
            observer.onAdd(segmentInfo);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function $709d74081b488d1c$var$removeSegmentObserver(observer) {
    var index = $709d74081b488d1c$var$segmentObservers.findIndex(function(obs) {
        return obs === observer;
    });
    if (index !== -1) $709d74081b488d1c$var$segmentObservers.splice(index, 1);
}
function $709d74081b488d1c$export$cd7f480d6b8286c3(interactionId) {
    (0, $fQHfi.default).delete(interactionId);
}
function $709d74081b488d1c$export$f6f1cf5bedf83c71(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    var interaction = $709d74081b488d1c$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== "page_load" && interaction.type !== "transition") return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $709d74081b488d1c$export$12f2b6cb85d59904(interactionId, data) {
    var interaction = (0, $fQHfi.default).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(key) {
        interaction.metaData[key] = data[key];
    });
}
function $709d74081b488d1c$export$e4380431c2bdabee(interactionId, labelStack, data) {
    var interaction = (0, $fQHfi.default).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(i) {
        interaction.customData.push({
            labelStack: labelStack,
            data: (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, i, data[i])
        });
    });
}
function $709d74081b488d1c$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    var interaction = (0, $fQHfi.default).get(interactionId);
    if (interaction != null) {
        interaction.customTimings.push({
            labelStack: labelStack,
            data: data
        });
        var _i, _Object$entries, _Object$entries$_i, key, timingData, startTime, endTime, e;
    }
}
function $709d74081b488d1c$export$728e28c22a0fba4(interactionId, type, name, labelStack) {
    var time = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var interaction = (0, $fQHfi.default).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
}
function $709d74081b488d1c$export$c4b23cc624bd2fb(type, name, labelStack) {
    var time = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : performance.now();
    (0, $fQHfi.default).forEach(function(interaction) {
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
}
function $709d74081b488d1c$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start) {
    var end = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : performance.now();
    var size = arguments.length > 6 ? arguments[6] : undefined;
    var interaction = (0, $fQHfi.default).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        var e;
    }
}
function $709d74081b488d1c$export$943a8b2b5d6b1809(type, name, labelStack, start) {
    var end = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var size = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    (0, $fQHfi.default).forEach(function(interaction) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    var e;
}
function $709d74081b488d1c$export$9e04fe1a58571ec(moduleId, timestamp) {
    $709d74081b488d1c$export$c4b23cc624bd2fb("bundle_preload", moduleId, null, timestamp);
}
function $709d74081b488d1c$export$6f228d1fdc911d7(identifier, start, end) {
    $709d74081b488d1c$export$943a8b2b5d6b1809("bundle_load", identifier, null, start, end - start);
}
var $709d74081b488d1c$var$moduleLoadingRequests = {};
function $709d74081b488d1c$export$f5a8f10de74904da(input) {
    var result = input !== null && input !== void 0 ? input : "";
    result = result.replace(/^\.\/src\/packages\//, "");
    result = result.replace(/^\.\/node_modules\//, "");
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, "");
    return result;
}
function $709d74081b488d1c$export$7606887303596f82(interactionId, labelStack, name) {
    var interaction = (0, $fQHfi.default).get(interactionId);
    var id = (0, $5m0MG.v4)();
    if (interaction != null) {
        var start = performance.now();
        interaction.holdActive.set(id, {
            labelStack: labelStack,
            name: name,
            start: start
        });
        return function() {
            var end = performance.now();
            var e;
            var currentInteraction = (0, $fQHfi.default).get(interactionId);
            var currentHold = interaction.holdActive.get(id);
            if (currentInteraction != null && currentHold != null) {
                currentInteraction.holdInfo.push($709d74081b488d1c$var$_objectSpread($709d74081b488d1c$var$_objectSpread({}, currentHold), {}, {
                    end: end
                }));
                interaction.holdActive.delete(id);
            }
        };
    }
    return function() {};
}
function $709d74081b488d1c$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    var interaction = (0, $fQHfi.default).get(interactionId);
    if (interaction != null) {
        var start = performance.now();
        interaction.holdActive.set(id, {
            labelStack: labelStack,
            name: name,
            start: start,
            ignoreOnSubmit: ignoreOnSubmit
        });
    }
    return function() {};
}
function $709d74081b488d1c$export$4983dfbbb996f7ae(interactionId, id) {
    var interaction = (0, $fQHfi.default).get(interactionId);
    if (interaction != null) {
        var end = performance.now();
        var currentInteraction = (0, $fQHfi.default).get(interactionId);
        var currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            currentInteraction.holdInfo.push($709d74081b488d1c$var$_objectSpread($709d74081b488d1c$var$_objectSpread({}, currentHold), {}, {
                end: end
            }));
            interaction.holdActive.delete(id);
        }
    }
}
function $709d74081b488d1c$export$2df109852219d16e(interactionId) {
    var interaction = (0, $fQHfi.default).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
var $709d74081b488d1c$export$9591b52b33ccc510 = {
    onPreload: function onPreload(moduleId, _priority) {
        $709d74081b488d1c$export$9e04fe1a58571ec($709d74081b488d1c$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart: function onLoadStart(info) {
        var timeoutId = setTimeout(function() {
            delete $709d74081b488d1c$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        var request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $709d74081b488d1c$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete: function onLoadComplete(info) {
        var request = $709d74081b488d1c$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $709d74081b488d1c$var$moduleLoadingRequests[info.identifier];
            $709d74081b488d1c$export$6f228d1fdc911d7($709d74081b488d1c$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted: function placeholderFallBackMounted(id, moduleId) {
        var interactionId = (0, $2xpzD.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $709d74081b488d1c$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted: function placeholderFallBackUnmounted(id) {
        var interactionId = (0, $2xpzD.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $709d74081b488d1c$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $709d74081b488d1c$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError) {
    var interaction = (0, $fQHfi.default).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError
    });
}
function $709d74081b488d1c$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack) {
    (0, $fQHfi.default).forEach(function(interaction) {
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack
        });
    });
}
var $709d74081b488d1c$export$53d6f611de951a13 = function addProfilerTimings(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    var interaction = (0, $fQHfi.default).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
};
var $709d74081b488d1c$var$pushToQueue = function pushToQueue(id, data) {
    $709d74081b488d1c$var$interactionQueue.push({
        id: id,
        data: data
    });
};
var $709d74081b488d1c$var$handleInteraction = $709d74081b488d1c$var$pushToQueue;
function $709d74081b488d1c$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach(function(cleanUpCallback) {
        cleanUpCallback();
    });
}
var $709d74081b488d1c$var$finishInteraction = function finishInteraction(id, data) {
    var _getConfig;
    var endTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    // eslint-disable-next-line no-param-reassign
    data.end = endTime;
    try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat(data.ufoName, " [ttai]"), {
            start: data.start,
            end: data.end
        });
    } catch (e) {
    // do nothing
    }
    if (data.featureFlags) // eslint-disable-next-line no-param-reassign
    data.featureFlags.during = Object.fromEntries((0, $biOnu.currentFeatureFlagsAccessed));
    (0, $4wIrX.clearActiveTrace)();
    $709d74081b488d1c$var$callCleanUpCallbacks(data);
    if ((_getConfig = (0, $41O29.getConfig)()) !== null && _getConfig !== void 0 && (_getConfig = _getConfig.vc) !== null && _getConfig !== void 0 && _getConfig.stopVCAtInteractionFinish) data.vc = (0, $gJaix.getVCObserver)().getVCRawData();
    $709d74081b488d1c$export$cd7f480d6b8286c3(id);
    $709d74081b488d1c$var$PreviousInteractionLog.name = data.ufoName || "unknown";
    $709d74081b488d1c$var$PreviousInteractionLog.isAborted = data.abortReason != null;
    if (data.ufoName) $709d74081b488d1c$var$handleInteraction(id, data);
    var profilerTimingMap, _iterator2, _step2, _step2$value, _step2$value$, labelStack, start, end, err, e;
};
var $709d74081b488d1c$export$9e614a29a1ac213e = function sinkInteractionHandler(sinkFn) {
    if ($709d74081b488d1c$var$handleInteraction === $709d74081b488d1c$var$pushToQueue) {
        $709d74081b488d1c$var$handleInteraction = sinkFn;
        $709d74081b488d1c$var$interactionQueue.forEach(function(interaction) {
            sinkFn(interaction.id, interaction.data);
        });
        $709d74081b488d1c$var$interactionQueue.length = 0;
    }
};
function $709d74081b488d1c$export$673be905888f8839(interactionId, endTime) {
    var interaction = (0, $fQHfi.default).get(interactionId);
    if (interaction != null) {
        var noMoreHolds = interaction.holdActive.size === 0;
        if (noMoreHolds) $709d74081b488d1c$var$finishInteraction(interactionId, interaction, endTime);
    }
}
function $709d74081b488d1c$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach(function(cancelCallback) {
        cancelCallback();
    });
}
function $709d74081b488d1c$export$5def58af4fd46132(interactionId, abortReason) {
    var interaction = (0, $fQHfi.default).get(interactionId);
    if (interaction != null) {
        $709d74081b488d1c$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $709d74081b488d1c$var$finishInteraction(interactionId, interaction);
    }
}
function $709d74081b488d1c$export$c4a545284f55edf2(interactionId, interactionName) {
    var interaction = (0, $fQHfi.default).get(interactionId);
    if (interaction != null) {
        $709d74081b488d1c$var$callCancelCallbacks(interaction);
        interaction.abortReason = "new_interaction";
        interaction.abortedByInteractionName = interactionName;
        $709d74081b488d1c$var$finishInteraction(interactionId, interaction);
    }
}
function $709d74081b488d1c$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    (0, $fQHfi.default).forEach(function(interaction, interactionId) {
        var noMoreHolds = interaction.holdActive.size === 0;
        if (!noMoreHolds) {
            $709d74081b488d1c$var$callCancelCallbacks(interaction);
            // eslint-disable-next-line no-param-reassign
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) // eslint-disable-next-line no-param-reassign
            interaction.abortedByInteractionName = abortedByInteractionName;
        }
        $709d74081b488d1c$var$finishInteraction(interactionId, interaction);
    });
}
function $709d74081b488d1c$export$7b9261a96cfe427b(id, cancelCallback) {
    var interaction = (0, $fQHfi.default).get(id);
    interaction === null || interaction === void 0 || interaction.cancelCallbacks.push(cancelCallback);
}
function $709d74081b488d1c$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName) {
    var trace = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
    var previousTime = startTime;
    var timeoutTime = $709d74081b488d1c$var$CLEANUP_TIMEOUT;
    var timerID = setTimeout(function() {
        $709d74081b488d1c$export$5def58af4fd46132(interactionId, "timeout");
    }, $709d74081b488d1c$var$CLEANUP_TIMEOUT);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        var currentTime = performance.now();
        var timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        var newTimerID = setTimeout(function() {
            $709d74081b488d1c$export$5def58af4fd46132(interactionId, "timeout");
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    var addFeatureFlagsToInteraction = (0, $4Pw3J.default)((0, $41O29.getCapabilityRate)("feature_flag_access"));
    var metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $709d74081b488d1c$var$PreviousInteractionLog.name,
        isPreviousInteractionAborted: $709d74081b488d1c$var$PreviousInteractionLog.isAborted === true,
        marks: [],
        customData: [],
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdActive: new Map(),
        // measure when we execute this code
        // from this we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName !== null && routeName !== void 0 ? routeName : ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: Object.fromEntries((0, $biOnu.allFeatureFlagsAccessed)),
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace
    };
    if (addFeatureFlagsToInteraction) (0, $biOnu.currentFeatureFlagsAccessed).clear();
    (0, $fQHfi.default).set(interactionId, metrics);
    var segmentObserver = {
        onAdd: function onAdd(segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove: function onRemove() {}
    };
    $709d74081b488d1c$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(function() {
        $709d74081b488d1c$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(function() {
        clearTimeout(metrics.timerID);
    });
    var awaitBM3TTIList = (0, $41O29.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $709d74081b488d1c$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === "transition") (0, $gJaix.getVCObserver)().start({
        startTime: startTime
    });
}
function $709d74081b488d1c$export$4a759336b50e86e3(event) {
    var interaction = $709d74081b488d1c$export$2b3954d2e8509985();
    if (interaction) {
        var _event$config;
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === "page_load" || interaction.type === "transition") && ((_event$config = event.config) === null || _event$config === void 0 ? void 0 : _event$config.type) === "PAGE_LOAD") {
            interaction.changeTimeout($709d74081b488d1c$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $709d74081b488d1c$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
        }
    }
}
function $709d74081b488d1c$export$ad216cc25852d44b(apdex) {
    (0, $fQHfi.default).forEach(function(interaction, key) {
        interaction.apdex.push(apdex);
        try {
            var _apdex$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdex.key, " [bm3_tti]"), {
                start: (_apdex$startTime = apdex.startTime) !== null && _apdex$startTime !== void 0 ? _apdex$startTime : interaction.start,
                end: apdex.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === "page_load" || interaction.type === "transition") {
            interaction.changeTimeout($709d74081b488d1c$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $709d74081b488d1c$export$4983dfbbb996f7ae(key, interaction.ufoName);
        }
    });
}
function $709d74081b488d1c$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    var interaction = (0, $fQHfi.default).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            var _apdexInfo$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdexInfo.key, " [bm3_tti]"), {
                start: (_apdexInfo$startTime = apdexInfo.startTime) !== null && _apdexInfo$startTime !== void 0 ? _apdexInfo$startTime : interaction.start,
                end: apdexInfo.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === "page_load" || interaction.type === "transition") {
            interaction.changeTimeout($709d74081b488d1c$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $709d74081b488d1c$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
        }
    }
}
function $709d74081b488d1c$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    var interaction = (0, $fQHfi.default).get(interactionId);
    if (interaction != null) interaction.requestInfo.push($709d74081b488d1c$var$_objectSpread({
        labelStack: labelStack
    }, requestInfo));
}
function $709d74081b488d1c$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === "string" && typeof obj.segmentId === "string";
}
function $709d74081b488d1c$var$getSegmentCacheKey(labelStack) {
    return labelStack.map(function(l) {
        if ($709d74081b488d1c$var$isSegmentLabel(l)) return "".concat(l.name, "_").concat(l.segmentId);
        return l.name;
    }).join("|");
}
function $709d74081b488d1c$export$1c43f9ac826b6462(labelStack) {
    var key = $709d74081b488d1c$var$getSegmentCacheKey(labelStack);
    var existingSegment = $709d74081b488d1c$var$segmentCache.get(key);
    if (!existingSegment) {
        var segmentInfo = {
            labelStack: labelStack
        };
        $709d74081b488d1c$var$segmentCache.set(key, segmentInfo);
        $709d74081b488d1c$var$segmentObservers.forEach(function(observer) {
            observer.onAdd(segmentInfo);
        });
    }
}
function $709d74081b488d1c$export$d0365e48b58231c3(labelStack) {
    var key = $709d74081b488d1c$var$getSegmentCacheKey(labelStack);
    var segmentInfo = $709d74081b488d1c$var$segmentCache.get(key);
    if (segmentInfo) {
        $709d74081b488d1c$var$segmentCache.delete(JSON.stringify(labelStack));
        $709d74081b488d1c$var$segmentObservers.forEach(function(observer) {
            observer.onRemove(segmentInfo);
        });
    }
}
function $709d74081b488d1c$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    var interaction = (0, $fQHfi.default).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        var prevRedirect, _prevRedirect$time, e;
    }
}

});
parcelRegister("5m0MG", function(module, exports) {

var $6YOzL = parcelRequire("6YOzL");

var $a8tNN = parcelRequire("a8tNN");
var $3e5f9d88e8b31d34$var$uuid = $a8tNN;
$3e5f9d88e8b31d34$var$uuid.v1 = $6YOzL;
$3e5f9d88e8b31d34$var$uuid.v4 = $a8tNN;
module.exports = $3e5f9d88e8b31d34$var$uuid;

});
parcelRegister("6YOzL", function(module, exports) {

var $a7DrL = parcelRequire("a7DrL");

var $d7Lp4 = parcelRequire("d7Lp4");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $514f940196040081$var$_nodeId;
var $514f940196040081$var$_clockseq;
// Previous uuid creation time
var $514f940196040081$var$_lastMSecs = 0;
var $514f940196040081$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $514f940196040081$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $514f940196040081$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $514f940196040081$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $a7DrL();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $514f940196040081$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $514f940196040081$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $514f940196040081$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $514f940196040081$var$_lastMSecs + (nsecs - $514f940196040081$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $514f940196040081$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $514f940196040081$var$_lastMSecs = msecs;
    $514f940196040081$var$_lastNSecs = nsecs;
    $514f940196040081$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $d7Lp4(b);
}
module.exports = $514f940196040081$var$v1;

});


parcelRegister("4Pw3J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3844cb264a430e2e$export$2e2bcd8739ae039; });
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $3844cb264a430e2e$export$2e2bcd8739ae039(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}

});

parcelRegister("41O29", function(module, exports) {

$parcel$export(module.exports, "setUFOConfig", function () { return $2eee110b3498a134$export$10d6139a8fb42158; });
$parcel$export(module.exports, "getConfig", function () { return $2eee110b3498a134$export$44487a86467333c3; });
$parcel$export(module.exports, "getInteractionRate", function () { return $2eee110b3498a134$export$9466a8f085fa7d4e; });
$parcel$export(module.exports, "getCapabilityRate", function () { return $2eee110b3498a134$export$29b9ffb14861a1d; });
$parcel$export(module.exports, "getAwaitBM3TTIList", function () { return $2eee110b3498a134$export$2d311b3fd18dcab1; });
$parcel$export(module.exports, "getUfoNameOverrides", function () { return $2eee110b3498a134$export$4f4649ef27b6f5d6; });
$parcel$export(module.exports, "getDoNotAbortActivePressInteractionOnTransition", function () { return $2eee110b3498a134$export$d6dc9444bd15f70f; });
var $2eee110b3498a134$var$config;
function $2eee110b3498a134$export$10d6139a8fb42158(newConfig) {
    $2eee110b3498a134$var$config = newConfig;
}
function $2eee110b3498a134$export$44487a86467333c3() {
    return $2eee110b3498a134$var$config;
}
function $2eee110b3498a134$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$2eee110b3498a134$var$config) return 0;
        var _config = $2eee110b3498a134$var$config, killswitch = _config.killswitch, rates = _config.rates, rules = _config.rules, kind = _config.kind, autoGeneratedRate = _config.autoGeneratedRate;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(var i = 0; i < rules.length; i++){
            var rule = rules[i];
            var test = rule.test, rate = rule.rate;
            if (test != null && rate != null) {
                var regexp = new RegExp(test, "ig");
                if (regexp.test(name)) return rate;
            }
        }
        var isAutogenerated = name === null || name === void 0 ? void 0 : name.startsWith("auto-generated");
        if (isAutogenerated) {
            var _rate = autoGeneratedRate;
            if (_rate != null) return _rate;
        }
        if (kind != null) {
            var _rate2 = kind[interactionKind];
            if (_rate2 != null) return _rate2;
        }
        return 0;
    } catch (e) {
        // Fallback
        return 0;
    }
}
function $2eee110b3498a134$export$29b9ffb14861a1d(capability) {
    try {
        if (!$2eee110b3498a134$var$config) return 0;
        var _config2 = $2eee110b3498a134$var$config, capabilityRate = _config2.capability;
        if (capabilityRate != null) {
            var rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch (_unused) {
        return 0;
    }
}
var $2eee110b3498a134$var$validTypingMethods = [
    "timeout",
    "timeoutNoAlloc",
    "mutationObserver"
];
function $2eee110b3498a134$export$7e32aae12bf9b50f() {
    var defaultMethod = "timeout";
    try {
        if (!$2eee110b3498a134$var$config) return defaultMethod;
        var _config3 = $2eee110b3498a134$var$config, typingMethod = _config3.typingMethod;
        if (typingMethod != null && $2eee110b3498a134$var$validTypingMethods.find(function(m) {
            return m === typingMethod;
        })) return typingMethod;
        else return defaultMethod;
    } catch (e) {
        return defaultMethod;
    }
}
function $2eee110b3498a134$export$2d311b3fd18dcab1() {
    try {
        if (!$2eee110b3498a134$var$config) return [];
        var _config4 = $2eee110b3498a134$var$config, awaitBM3TTI = _config4.awaitBM3TTI;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch (e) {
        return [];
    }
}
function $2eee110b3498a134$export$e2ea675800536898() {
    try {
        if (!$2eee110b3498a134$var$config) return false;
        var _config5 = $2eee110b3498a134$var$config, removePageSegmentsUFOPrefixes = _config5.removePageSegmentsUFOPrefixes;
        if (removePageSegmentsUFOPrefixes != null) return removePageSegmentsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
}
function $2eee110b3498a134$export$525ba53ca98e9db() {
    try {
        if (!$2eee110b3498a134$var$config) return false;
        var _config6 = $2eee110b3498a134$var$config, removeInteractionsUFOPrefixes = _config6.removeInteractionsUFOPrefixes;
        if (removeInteractionsUFOPrefixes != null) return removeInteractionsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
}
function $2eee110b3498a134$export$4f4649ef27b6f5d6() {
    try {
        if (!$2eee110b3498a134$var$config) return undefined;
        var _config7 = $2eee110b3498a134$var$config, ufoNameOverrides = _config7.ufoNameOverrides;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch (e) {
        return undefined;
    }
}
function $2eee110b3498a134$export$3c170167645a0eff() {
    try {
        if (!$2eee110b3498a134$var$config) return undefined;
        var _config8 = $2eee110b3498a134$var$config, doNotAbortActivePressInteraction = _config8.doNotAbortActivePressInteraction;
        return doNotAbortActivePressInteraction;
    } catch (e) {
        return undefined;
    }
}
function $2eee110b3498a134$export$d6dc9444bd15f70f() {
    try {
        if (!$2eee110b3498a134$var$config) return undefined;
        var _config9 = $2eee110b3498a134$var$config, doNotAbortActivePressInteractionOnTransition = _config9.doNotAbortActivePressInteractionOnTransition;
        return doNotAbortActivePressInteractionOnTransition;
    } catch (e) {
        return undefined;
    }
}

});

parcelRegister("4wIrX", function(module, exports) {

$parcel$export(module.exports, "setActiveTrace", function () { return $34bca16ccd861882$export$a1002be327997103; });
$parcel$export(module.exports, "getActiveTrace", function () { return $34bca16ccd861882$export$b6ac780db3a3cc77; });
$parcel$export(module.exports, "clearActiveTrace", function () { return $34bca16ccd861882$export$17ab21d7be720b; });

var $5uuVH = parcelRequire("5uuVH");
var $34bca16ccd861882$var$state = {
    context: null
};
var $34bca16ccd861882$export$a1002be327997103 = function setActiveTrace(traceId, spanId, type) {
    $34bca16ccd861882$var$state.context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
};
var $34bca16ccd861882$export$b6ac780db3a3cc77 = function getActiveTrace() {
    return $34bca16ccd861882$var$state.context || undefined;
};
var $34bca16ccd861882$export$17ab21d7be720b = function clearActiveTrace() {
    $34bca16ccd861882$var$state.context = null;
};
var $34bca16ccd861882$export$6e17cce6446848f9 = function getActiveTraceHttpRequestHeaders(_url) {
    if ($34bca16ccd861882$var$state.context === null) return null;
    var _state$context = $34bca16ccd861882$var$state.context, traceId = _state$context.traceId, spanId = _state$context.spanId;
    return (0, $5uuVH.makeTraceHttpRequestHeaders)(traceId, spanId);
};

});
parcelRegister("5uuVH", function(module, exports) {

$parcel$export(module.exports, "makeTraceHttpRequestHeaders", function () { return $3ff7bf0d12455330$export$1115c5277eb10d5e; });
var $3ff7bf0d12455330$export$1115c5277eb10d5e = function makeTraceHttpRequestHeaders(traceId, spanId) {
    return {
        "X-B3-TraceId": traceId,
        "X-B3-SpanId": spanId
    };
};

});


parcelRegister("biOnu", function(module, exports) {

$parcel$export(module.exports, "allFeatureFlagsAccessed", function () { return $83a87424bcbac78f$export$5b78c989c8db2561; });
$parcel$export(module.exports, "currentFeatureFlagsAccessed", function () { return $83a87424bcbac78f$export$2a5c8df26bb89760; });

var $8Qcvi = parcelRequire("8Qcvi");
var $83a87424bcbac78f$export$5b78c989c8db2561 = new Map();
var $83a87424bcbac78f$export$2a5c8df26bb89760 = new Map();
var $83a87424bcbac78f$export$47fade9662f71000 = function addFeatureFlagAccessed(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === "function") globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    var value = (0, $8Qcvi.redactValue)(featureFlagValue);
    $83a87424bcbac78f$export$5b78c989c8db2561.set(featureFlagName, value);
    $83a87424bcbac78f$export$2a5c8df26bb89760.set(featureFlagName, value);
};

});
parcelRegister("8Qcvi", function(module, exports) {

$parcel$export(module.exports, "redactValue", function () { return $66fce10cd78c3b02$export$fcc03ee4c944962f; });

var $340K4 = parcelRequire("340K4");

var $kJRbY = parcelRequire("kJRbY");
var $66fce10cd78c3b02$var$startsAsObject = function startsAsObject(value) {
    try {
        if (value.charAt(0) === "{") return true;
    } catch (e) {
        return false;
    }
    return false;
};
var $66fce10cd78c3b02$var$isObject = function isObject(value) {
    return value && (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(value) === "object" && value.constructor === Object;
};
var $66fce10cd78c3b02$var$isString = function isString(input) {
    var result;
    try {
        result = typeof input === "string" || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
var $66fce10cd78c3b02$export$7b4abba432e57989 = function shouldRedactValue(value) {
    return $66fce10cd78c3b02$var$isString(value) && $66fce10cd78c3b02$var$startsAsObject(value) || $66fce10cd78c3b02$var$isObject(value);
};
var $66fce10cd78c3b02$export$fcc03ee4c944962f = function redactValue(featureFlagValue) {
    return $66fce10cd78c3b02$export$7b4abba432e57989(featureFlagValue) ? (0, $kJRbY.NON_BOOLEAN_VALUE) : featureFlagValue;
};

});
parcelRegister("kJRbY", function(module, exports) {

$parcel$export(module.exports, "NON_BOOLEAN_VALUE", function () { return $f191457730fe99ec$export$42f4885608027d0c; });
var $f191457730fe99ec$export$42f4885608027d0c = "non_boolean";

});



parcelRegister("2xpzD", function(module, exports) {

$parcel$export(module.exports, "DefaultInteractionID", function () { return $1d928046239bedc0$export$3109542b68df9ba1; });
$parcel$export(module.exports, "default", function () { return $1d928046239bedc0$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "getInteractionId", function () { return $1d928046239bedc0$export$37bca3107733ac1e; });

var $9nHZC = parcelRequire("9nHZC");
var $1d928046239bedc0$export$3109542b68df9ba1 = {
    current: null
};
var // We use a context to allow modals to have their own lifecycle
$1d928046239bedc0$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $9nHZC.createContext)($1d928046239bedc0$export$3109542b68df9ba1);
var $1d928046239bedc0$export$37bca3107733ac1e = function getInteractionId() {
    return $1d928046239bedc0$export$3109542b68df9ba1;
};
var $1d928046239bedc0$export$9f6000531b78127e = function useInteractionId() {
    return $1d928046239bedc0$export$3109542b68df9ba1;
};

});

parcelRegister("gJaix", function(module, exports) {

$parcel$export(module.exports, "getVCObserver", function () { return $c2d8d642e667db5a$export$b3bc47985717b49e; });

var $iX1kn = parcelRequire("iX1kn");
var $c2d8d642e667db5a$var$instance = null;
var $c2d8d642e667db5a$export$b3bc47985717b49e = function getVCObserver() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if ($c2d8d642e667db5a$var$instance === null) $c2d8d642e667db5a$var$instance = new (0, $iX1kn.VCObserver)(opts);
    return $c2d8d642e667db5a$var$instance;
};

});
parcelRegister("iX1kn", function(module, exports) {

$parcel$export(module.exports, "VCObserver", function () { return $dcbec45058fbd863$export$1f70d263701b1d01; });

var $9q1kH = parcelRequire("9q1kH");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");

var $1FiMp = parcelRequire("1FiMp");

var $jDPqq = parcelRequire("jDPqq");
function $dcbec45058fbd863$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dcbec45058fbd863$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dcbec45058fbd863$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dcbec45058fbd863$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dcbec45058fbd863$var$abortReason = {
    scroll: "scroll",
    keypress: "keypress",
    resize: "resize",
    error: "error"
};
function $dcbec45058fbd863$var$getViewportWidth() {
    var documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function $dcbec45058fbd863$var$getViewportHeight() {
    var documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
var $dcbec45058fbd863$var$UNUSED_SECTOR = 0;
var $dcbec45058fbd863$export$1f70d263701b1d01 = /*#__PURE__*/ function() {
    function VCObserver(options) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, VCObserver);
        /* abort logic */ (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "abortReason", {
            reason: null,
            info: "",
            timestamp: -1,
            blocking: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "outOfBoundaryInfo", "");
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "viewport", {
            w: 0,
            h: 0
        });
        /* heatmap */ (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "arraySize", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "componentsLog", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "active", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "totalTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "startTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_startMeasureTimestamp", -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "ssr", {
            reactRendered: -1
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "unbind", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "getAbortReasonInfo", function() {
            if (_this.abortReason.reason === null) return null;
            var info = _this.abortReason.info !== "" ? " ".concat(_this.abortReason.info) : "";
            return "".concat(_this.abortReason.reason).concat(info);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "getVCRawData", function() {
            _this.measureStart();
            if (!_this.active) {
                _this.measureStop();
                return null;
            }
            _this.stop();
            var abortReasonInfo = _this.getAbortReasonInfo();
            _this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: $dcbec45058fbd863$var$_objectSpread({}, _this.abortReason),
                heatmap: _this.ssrInclusiveHeatmap,
                oldHeatmap: _this.heatmap,
                outOfBoundaryInfo: _this.outOfBoundaryInfo,
                totalTime: Math.round(_this.totalTime + _this.observers.getTotalTime()),
                componentsLog: $dcbec45058fbd863$var$_objectSpread({}, _this.componentsLog),
                viewport: $dcbec45058fbd863$var$_objectSpread({}, _this.viewport),
                oldDomUpdatesEnabled: _this.oldDomUpdatesEnabled,
                devToolsEnabled: _this.devToolsEnabled
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "getVCResult", function(_ref) {
            var _objectSpread2;
            var start = _ref.start, stop = _ref.stop, tti = _ref.tti, prefix = _ref.prefix, ssr = _ref.ssr, vc = _ref.vc;
            var startTime = performance.now();
            // add local measurement
            var fullPrefix = prefix !== undefined && prefix !== "" ? "".concat(prefix, ":") : "";
            var rawData = vc !== undefined ? vc : _this.getVCRawData();
            if (rawData === null) return {};
            var abortReason = rawData.abortReason, abortReasonInfo = rawData.abortReasonInfo, heatmap = rawData.heatmap, oldHeatmap = rawData.oldHeatmap, outOfBoundaryInfo = rawData.outOfBoundaryInfo, totalTime = rawData.totalTime, componentsLog = rawData.componentsLog, viewport = rawData.viewport, oldDomUpdatesEnabled = rawData.oldDomUpdatesEnabled, devToolsEnabled = rawData.devToolsEnabled;
            if (abortReasonInfo !== null && abortReason.blocking) {
                var _ref2;
                // exposing data to devtools
                try {
                    if (devToolsEnabled) window.__vcNotAvailableReason = abortReasonInfo;
                } catch (e) {}
                return _ref2 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref2, "".concat(fullPrefix, "vc:state"), false), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref2, "".concat(fullPrefix, "vc:abort:reason"), abortReasonInfo), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref2, "".concat(fullPrefix, "vc:abort:timestamp"), abortReason.timestamp), _ref2;
            }
            var _VCObserver$calculate = VCObserver.calculateVC({
                heatmap: heatmap,
                addToPerformance: true,
                ssr: ssr,
                componentsLog: $dcbec45058fbd863$var$_objectSpread({}, componentsLog),
                viewport: viewport
            }), VC = _VCObserver$calculate.VC, VCBox = _VCObserver$calculate.VCBox, VCEntries = _VCObserver$calculate.VCEntries, totalPainted = _VCObserver$calculate.totalPainted;
            var ssrVC = VCObserver.calculateVC({
                heatmap: oldHeatmap,
                ssr: ssr,
                componentsLog: $dcbec45058fbd863$var$_objectSpread({}, componentsLog),
                viewport: viewport
            });
            var outOfBoundary = outOfBoundaryInfo ? (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, "".concat(fullPrefix, "vc:oob"), outOfBoundaryInfo) : {};
            var oldDomUpdates = oldDomUpdatesEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, "".concat(fullPrefix, "vc:old:dom"), ssrVC.VCBox) : {};
            var stopTime = performance.now();
            // exposing data to devtools
            try {
                if (devToolsEnabled) {
                    window.__vc = {
                        entries: VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            "75": VC["75"],
                            "80": VC["80"],
                            "85": VC["85"],
                            "90": VC["90"],
                            "95": VC["95"],
                            "98": VC["98"],
                            "99": VC["99"],
                            tti: tti,
                            ttai: stop - start
                        },
                        heatmap: heatmap
                    };
                    // Emitting a custom event to make it available in the Chrome extension
                    window.dispatchEvent(new CustomEvent("vcReady"));
                }
            } catch (e) {
            /*  do nothing */ }
            // console.log('exposed data')
            var returnValue = $dcbec45058fbd863$var$_objectSpread($dcbec45058fbd863$var$_objectSpread((_objectSpread2 = {
                "metrics:vc": VC
            }, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, "".concat(fullPrefix, "vc:state"), true), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, "".concat(fullPrefix, "vc:clean"), abortReasonInfo ? false : true), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, "".concat(fullPrefix, "vc:dom"), VCBox), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, "".concat(fullPrefix, "vc:updates"), VCEntries.rel.slice(0, 50)), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, "".concat(fullPrefix, "vc:size"), viewport), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, "".concat(fullPrefix, "vc:time"), Math.round(totalTime + (stopTime - startTime))), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, "".concat(fullPrefix, "vc:total"), totalPainted), _objectSpread2), outOfBoundary), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, "".concat(fullPrefix, "vc:old"), ssrVC.VC), oldDomUpdates);
            return returnValue;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "handleUpdate", function(rawTime, intersectionRect, targetName, element, ignored) {
            _this.measureStart();
            if (_this.abortReason.reason === null || _this.abortReason.blocking === false) {
                var time = Math.round(rawTime - _this.startTime);
                var mappedValues = _this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                _this.applyChangesToHeatMap(mappedValues, time, _this.heatmap);
                if (!ignored) _this.applyChangesToHeatMap(mappedValues, time, _this.ssrInclusiveHeatmap);
                if (!_this.componentsLog[time]) _this.componentsLog[time] = [];
                _this.componentsLog[time].push({
                    __debug__element: _this.devToolsEnabled ? element : null,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignored: ignored
                });
            }
            // devtools export
            _this.measureStop();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "mapPixelsToHeatmap", function(left, top, width, height) {
            var _this$viewport = _this.viewport, w = _this$viewport.w, h = _this$viewport.h;
            var l = Math.floor(left / w * _this.arraySize);
            var t = Math.floor(top / h * _this.arraySize);
            var r = Math.ceil((left + width) / w * _this.arraySize);
            var b = Math.ceil((top + height) / h * _this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (_this.outOfBoundaryInfo === "") {
                var outOfBoundaryInfo = "";
                if (r > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(left, " ").concat(width);
                if (b > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(top, " ").concat(height);
                _this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            var result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(_this.arraySize, r),
                b: Math.min(_this.arraySize, b)
            };
            return result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "attachAbortListeners", function() {
            _this.detachAbortListeners();
            var wheelUnbind = (0, $1FiMp.bind)(window, {
                type: "wheel",
                listener: function listener(e) {
                    _this.setAbortReason($dcbec45058fbd863$var$abortReason.scroll, e.timeStamp);
                },
                options: {
                    passive: true,
                    once: true
                }
            });
            var keyDownUnbind = (0, $1FiMp.bind)(window, {
                type: "keydown",
                listener: function listener(e) {
                    _this.setAbortReason($dcbec45058fbd863$var$abortReason.keypress, e.timeStamp);
                },
                options: {
                    once: true
                }
            });
            var resizeUnbind = (0, $1FiMp.bind)(window, {
                type: "resize",
                listener: function listener(e) {
                    if ($dcbec45058fbd863$var$getViewportWidth() !== _this.viewport.w || $dcbec45058fbd863$var$getViewportHeight() !== _this.viewport.h) {
                        var _this$unbind$resize, _this$unbind;
                        _this.setAbortReason($dcbec45058fbd863$var$abortReason.resize, e.timeStamp);
                        (_this$unbind$resize = (_this$unbind = _this.unbind).resize) === null || _this$unbind$resize === void 0 || _this$unbind$resize.call(_this$unbind);
                        delete _this.unbind.resize;
                    }
                }
            });
            _this.unbind = {
                wheel: wheelUnbind,
                keyDown: keyDownUnbind,
                resize: resizeUnbind
            };
        });
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        this.observers = new (0, $jDPqq.Observers)({
            selectorConfig: options.selectorConfig || {
                id: false,
                testId: false,
                role: false,
                className: true,
                dataVC: true
            }
        });
        this.heatmap = this.getCleanHeatmap();
        this.ssrInclusiveHeatmap = this.getCleanHeatmap();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(VCObserver, [
        {
            key: "start",
            value: function start(_ref5) {
                var startTime = _ref5.startTime;
                this.setViewportSize();
                this.resetState();
                this.startTime = startTime;
                this.active = true;
                this.attachAbortListeners();
                this.observers.subscribeResults(this.handleUpdate);
                this.observers.observe();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.observers.disconnect();
                this.detachAbortListeners();
            }
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {
                this.observers.setReactRootElement(element);
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStart(startTime);
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStop(stopTime);
            }
        },
        {
            key: "setAbortReason",
            value: function setAbortReason(abort, timestamp) {
                var info = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
                if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                    this.abortReason.reason = abort;
                    this.abortReason.info = info;
                    this.abortReason.timestamp = timestamp;
                    this.abortReason.blocking = abort !== $dcbec45058fbd863$var$abortReason.scroll;
                    if (this.abortReason.blocking) this.detachAbortListeners();
                }
            }
        },
        {
            key: "resetState",
            value: function resetState() {
                this.abortReason = {
                    reason: null,
                    info: "",
                    timestamp: -1,
                    blocking: false
                };
                this.detachAbortListeners();
                this.heatmap = this.getCleanHeatmap();
                this.ssrInclusiveHeatmap = this.getCleanHeatmap();
                this.totalTime = 0;
                this.componentsLog = {};
            }
        },
        {
            key: "getCleanHeatmap",
            value: function getCleanHeatmap() {
                var _this2 = this;
                return Array(this.arraySize).fill("").map(function() {
                    return Array(_this2.arraySize).fill($dcbec45058fbd863$var$UNUSED_SECTOR);
                });
            }
        },
        {
            key: "setViewportSize",
            value: function setViewportSize() {
                this.viewport.w = $dcbec45058fbd863$var$getViewportWidth();
                this.viewport.h = $dcbec45058fbd863$var$getViewportHeight();
            }
        },
        {
            key: "applyChangesToHeatMap",
            value: function applyChangesToHeatMap(a, time, heatmap) {
                var l = a.l, t = a.t, r = a.r, b = a.b;
                var localHeatmap = heatmap;
                for(var row = t; row < b; row++){
                    for(var col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                        try {
                            this.setAbortReason($dcbec45058fbd863$var$abortReason.error, time, "index - ".concat(row));
                        } catch (e) {
                            this.setAbortReason($dcbec45058fbd863$var$abortReason.error, time, "row error");
                        }
                        return;
                    } else localHeatmap[row][col] = time;
                }
            }
        },
        {
            key: "detachAbortListeners",
            value: function detachAbortListeners() {
                var unbindFns = Object.values(this.unbind);
                if (unbindFns.length > 0) unbindFns.forEach(function(fn) {
                    return fn();
                });
                this.unbind = {};
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ], [
        {
            key: "calculateVC",
            value: function calculateVC(_ref6) {
                var heatmap = _ref6.heatmap, _ref6$addToPerformanc = _ref6.addToPerformance, addToPerformance = _ref6$addToPerformanc === void 0 ? false : _ref6$addToPerformanc, _ref6$ssr = _ref6.ssr, ssr = _ref6$ssr === void 0 ? $dcbec45058fbd863$var$UNUSED_SECTOR : _ref6$ssr, componentsLog = _ref6.componentsLog, viewport = _ref6.viewport;
                var lastUpdate = {};
                var totalPainted = 0;
                if (ssr !== $dcbec45058fbd863$var$UNUSED_SECTOR) {
                    var _window$document;
                    var element = {
                        __debug__element: (_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.body,
                        ignored: false,
                        intersectionRect: {
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            x: 0,
                            y: 0,
                            width: viewport.w,
                            height: viewport.h,
                            toJSON: function toJSON() {
                                return {};
                            }
                        },
                        targetName: "SSR"
                    };
                    if (!componentsLog[ssr]) componentsLog[ssr] = [];
                    componentsLog[ssr].push(element);
                }
                heatmap.forEach(function(line) {
                    line.forEach(function(entry) {
                        var rounded = Math.floor(entry === $dcbec45058fbd863$var$UNUSED_SECTOR && ssr !== $dcbec45058fbd863$var$UNUSED_SECTOR ? ssr : entry);
                        totalPainted += rounded !== $dcbec45058fbd863$var$UNUSED_SECTOR ? 1 : 0;
                        if (rounded !== $dcbec45058fbd863$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
                    });
                });
                var entries = Object.entries(lastUpdate).map(function(a) {
                    return [
                        parseInt(a[0], 10),
                        a[1]
                    ];
                }).sort(function(a, b) {
                    return a[0] > b[0] ? 1 : -1;
                });
                var VC = VCObserver.makeVCReturnObj();
                var VCBox = VCObserver.makeVCReturnObj();
                entries.reduce(function() {
                    var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var v = arguments.length > 1 ? arguments[1] : undefined;
                    var VCRatio = v[1] / totalPainted + acc;
                    var time = v[0];
                    VCObserver.VCParts.forEach(function(key) {
                        var value = parseInt(key, 10);
                        if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                            var _componentsLog$time;
                            VC[key] = time;
                            VCBox[key] = (_componentsLog$time = componentsLog[time]) === null || _componentsLog$time === void 0 ? void 0 : _componentsLog$time.map(function(v) {
                                return v.targetName;
                            });
                        }
                    });
                    return VCRatio;
                }, 0);
                try {
                    if (addToPerformance) VCObserver.VCParts.forEach(function(key) {
                        var duration = VC[key];
                        if (duration !== null && duration !== undefined) performance.measure("VC".concat(key), {
                            start: 0,
                            duration: duration
                        });
                    });
                } catch (e) {
                /* empty */ }
                var VCEntries = entries.reduce(function(acc, _ref7, i) {
                    var _acc$abs, _componentsLog$timest;
                    var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref7, 2), timestamp = _ref8[0], entryPainted = _ref8[1];
                    var currentlyPainted = entryPainted + (((_acc$abs = acc.abs[i - 1]) === null || _acc$abs === void 0 ? void 0 : _acc$abs[1]) || 0);
                    var currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
                    var logEntry = (_componentsLog$timest = componentsLog[timestamp]) === null || _componentsLog$timest === void 0 ? void 0 : _componentsLog$timest.map(function(v) {
                        return v.targetName;
                    });
                    acc.abs.push([
                        timestamp,
                        currentlyPainted
                    ]);
                    acc.rel.push({
                        time: timestamp,
                        vc: currentlyPaintedRatio,
                        elements: logEntry
                    });
                    return acc;
                }, {
                    abs: [],
                    rel: []
                });
                return {
                    VC: VC,
                    VCBox: VCBox,
                    VCEntries: VCEntries,
                    totalPainted: totalPainted
                };
            }
        },
        {
            key: "makeVCReturnObj",
            value: function makeVCReturnObj() {
                var vc = {};
                VCObserver.VCParts.forEach(function(v) {
                    vc[v] = null;
                });
                return vc;
            }
        }
    ]);
    return VCObserver;
}();
/** config * */ (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($dcbec45058fbd863$export$1f70d263701b1d01, "VCParts", [
    "25",
    "50",
    "75",
    "80",
    "85",
    "90",
    "95",
    "98",
    "99"
]);

});
parcelRegister("jDPqq", function(module, exports) {

$parcel$export(module.exports, "Observers", function () { return $e4c98cd35fe720e9$export$b65d046240060e78; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");

var $hRtZL = parcelRequire("hRtZL");
function $e4c98cd35fe720e9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e4c98cd35fe720e9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e4c98cd35fe720e9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e4c98cd35fe720e9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e4c98cd35fe720e9$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
var $e4c98cd35fe720e9$export$b65d046240060e78 = /*#__PURE__*/ function() {
    function Observers(opts) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, Observers);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "observedMutations", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "elementsInView", new Set());
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "callbacks", new Set());
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "totalTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_startMeasureTimestamp", -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "ssr", {
            state: $e4c98cd35fe720e9$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "selectorConfig", {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "subscribeResults", function(cb) {
            _this.callbacks.add(cb);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "observeElement", function(node, mutation, _type, ignored) {
            var _this$intersectionObs;
            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.observe(node);
            _this.observedMutations.set(node, {
                mutation: mutation,
                ignored: ignored
            });
        });
        this.selectorConfig = $e4c98cd35fe720e9$var$_objectSpread($e4c98cd35fe720e9$var$_objectSpread({}, this.selectorConfig), opts.selectorConfig);
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        this.ssrPlaceholderHandler = new (0, $hRtZL.SSRPlaceholderHandlers)();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(Observers, [
        {
            key: "observe",
            value: function observe() {
                this.totalTime = 0;
                this.ssr = {
                    state: $e4c98cd35fe720e9$var$state.normal,
                    reactRootElement: null,
                    renderStart: -1,
                    renderStop: -1
                };
                this.mutationObserver.observe(document.body, {
                    attributeFilter: [
                        "hidden",
                        "style",
                        "src"
                    ],
                    attributeOldValue: true,
                    attributes: true,
                    childList: true,
                    subtree: true
                });
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this.mutationObserver.disconnect();
                this.intersectionObserver.disconnect();
                this.observedMutations = new Map();
                this.elementsInView = new Set();
                this.callbacks = new Set();
                this.ssr.reactRootElement = null;
                this.ssrPlaceholderHandler.clear();
            }
        },
        {
            key: "getTotalTime",
            value: function getTotalTime() {
                return this.totalTime;
            }
        },
        {
            key: "setReactRootElement",
            value: function setReactRootElement(element) {
                this.ssr.reactRootElement = element;
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStart = startTime;
                this.ssr.state = $e4c98cd35fe720e9$var$state.waitingForFirstRender;
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStop = stopTime;
            }
        },
        {
            key: "getMutationObserver",
            value: function getMutationObserver() {
                var _this2 = this;
                return new MutationObserver(function(mutations) {
                    _this2.measureStart();
                    mutations.forEach(function(mutation) {
                        // patching element if timestamp not automatically added
                        // eslint-disable-next-line no-param-reassign
                        mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                        var ignored = false;
                        if (_this2.ssr.state === $e4c98cd35fe720e9$var$state.waitingForFirstRender && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            _this2.ssr.state = $e4c98cd35fe720e9$var$state.ignoring;
                            if (_this2.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                            _this2.ssr.renderStop = mutation.timestamp + 500;
                            ignored = true;
                        }
                        if (_this2.ssr.state === $e4c98cd35fe720e9$var$state.ignoring && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            if (mutation.timestamp <= _this2.ssr.renderStop) ignored = true;
                            else _this2.ssr.state = $e4c98cd35fe720e9$var$state.normal;
                        }
                        if (mutation.type === "childList") {
                            mutation.addedNodes.forEach(function(node) {
                                if (node instanceof HTMLElement) {
                                    if (_this2.ssrPlaceholderHandler.isPlaceholder(node)) {
                                        _this2.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, "html", ignored);
                                        });
                                        return;
                                    }
                                    if (_this2.ssrPlaceholderHandler.isPlaceholderReplacement(node)) {
                                        _this2.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, "html", ignored);
                                        });
                                        return;
                                    }
                                    _this2.observeElement(node, mutation, "html", ignored);
                                }
                                if (node instanceof Text && node.parentElement != null) _this2.observeElement(node.parentElement, mutation, "text", ignored);
                            });
                            mutation.removedNodes.forEach(function(node) {
                                if (node instanceof Element) {
                                    var _this2$intersectionOb;
                                    _this2.elementsInView.delete(node);
                                    (_this2$intersectionOb = _this2.intersectionObserver) === null || _this2$intersectionOb === void 0 || _this2$intersectionOb.unobserve(node);
                                }
                            });
                        } else if (mutation.type === "attributes") mutation.addedNodes.forEach(function(node) {
                            if (node instanceof HTMLElement) _this2.observeElement(node, mutation, "attr", ignored);
                        });
                    });
                    _this2.measureStop();
                });
            }
        },
        {
            key: "getElementName",
            value: function getElementName(element) {
                try {
                    var tagName = element.localName;
                    var dataVCAttr = element.getAttribute("data-vc");
                    var dataVC = this.selectorConfig.dataVC && dataVCAttr ? '[data-vc="'.concat(dataVCAttr, '"]') : "";
                    var id = this.selectorConfig.id && element.id ? "#".concat(element.id) : "";
                    var testId = this.selectorConfig.testId ? element.getAttribute("data-testid") || element.getAttribute("data-test-id") : "";
                    testId = testId ? "[testid=".concat(testId, "]") : "";
                    var role = this.selectorConfig.role ? element.getAttribute("role") : "";
                    role = role ? "[role=".concat(role, "]") : "";
                    var classList = this.selectorConfig.className ? Array.from(element.classList).join(".") : "";
                    classList = classList === "" ? "" : ".".concat(classList);
                    var attrs = dataVC ? dataVC : [
                        id,
                        testId,
                        role
                    ].join("");
                    var idString = "";
                    if (attrs === "" && classList === "") {
                        var parent = element.parentElement ? this.getElementName(element.parentElement) : "unknown";
                        idString = "".concat(parent, " > ").concat(tagName);
                    } else idString = [
                        tagName,
                        attrs || classList
                    ].join("");
                    return idString;
                } catch (e) {
                    return "error";
                }
            }
        },
        {
            key: "getIntersectionObserver",
            value: function getIntersectionObserver() {
                var _this3 = this;
                return new IntersectionObserver(function(entries) {
                    _this3.measureStart();
                    entries.forEach(function(_ref) {
                        var isIntersecting = _ref.isIntersecting, ir = _ref.intersectionRect, target = _ref.target;
                        var data = _this3.observedMutations.get(target);
                        _this3.observedMutations.delete(target);
                        if (isIntersecting && ir.width > 0 && ir.height > 0) {
                            if (!(target instanceof HTMLElement)) return;
                            if (!(data !== null && data !== void 0 && data.mutation)) // ignore intersection report without recent mutation
                            return;
                            _this3.callbacks.forEach(function(callback) {
                                var elementName;
                                try {
                                    elementName = _this3.getElementName(target);
                                } catch (e) {
                                    elementName = "error";
                                }
                                callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.ignored);
                            });
                            _this3.elementsInView.add(target);
                        } else _this3.elementsInView.delete(target);
                    });
                    _this3.measureStop();
                });
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ]);
    return Observers;
}();

});
parcelRegister("hRtZL", function(module, exports) {

$parcel$export(module.exports, "SSRPlaceholderHandlers", function () { return $d00ea7585d833f2c$export$c0102f1a1198d10f; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
var $d00ea7585d833f2c$var$EQUALITY_THRESHOLD = 0.1;
var $d00ea7585d833f2c$export$c0102f1a1198d10f = /*#__PURE__*/ function() {
    function SSRPlaceholderHandlers() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, SSRPlaceholderHandlers);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "staticPlaceholders", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "callbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "getSizeCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "reactValidateCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "intersectionObserverCallback", function(_ref) {
            var target = _ref.target, boundingClientRect = _ref.boundingClientRect;
            _this.intersectionObserver.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            var staticKey = target.dataset.ssrPlaceholder || "";
            if (staticKey) {
                if (_this.staticPlaceholders.has(staticKey) && _this.callbacks.has(staticKey)) {
                    // validation
                    var _resolve = _this.callbacks.get(staticKey);
                    if (!_resolve) return;
                    var rect = _this.staticPlaceholders.get(staticKey);
                    var hasSameSizePosition = _this.hasSameSizePosition(rect, boundingClientRect);
                    _resolve(hasSameSizePosition);
                    _this.callbacks.delete(staticKey);
                }
            } else {
                // react component check
                var key = target.dataset.ssrPlaceholderReplace || "";
                var _resolve2 = _this.reactValidateCallbacks.get(key);
                if (!_resolve2) return;
                var _rect = _this.staticPlaceholders.get(key);
                var _hasSameSizePosition = _this.hasSameSizePosition(_rect, boundingClientRect);
                _resolve2(_hasSameSizePosition);
                _this.staticPlaceholders.delete(staticKey);
                _this.reactValidateCallbacks.delete(staticKey);
            }
        });
        this.intersectionObserver = new IntersectionObserver(function(entries) {
            return entries.forEach(_this.intersectionObserverCallback);
        });
        if (window.document) try {
            var existingElements = document.querySelectorAll("[data-ssr-placeholder]");
            existingElements.forEach(function(el) {
                var _el$dataset;
                if (el instanceof HTMLElement && el !== null && el !== void 0 && (_el$dataset = el.dataset) !== null && _el$dataset !== void 0 && _el$dataset.ssrPlaceholder) {
                    var _window$__SSR_PLACEHO;
                    var width = -1;
                    var height = -1;
                    var x = -1;
                    var y = -1;
                    var boundingClientRect = (_window$__SSR_PLACEHO = window.__SSR_PLACEHOLDERS_DIMENSIONS__) === null || _window$__SSR_PLACEHO === void 0 ? void 0 : _window$__SSR_PLACEHO[el.dataset.ssrPlaceholder];
                    if (boundingClientRect) {
                        width = boundingClientRect.width;
                        height = boundingClientRect.height;
                        x = boundingClientRect.x;
                        y = boundingClientRect.y;
                    }
                    _this.staticPlaceholders.set(el.dataset.ssrPlaceholder, {
                        width: width,
                        height: height,
                        x: x,
                        y: y
                    });
                    _this.intersectionObserver.observe(el);
                }
            });
        } catch (e) {} finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(SSRPlaceholderHandlers, [
        {
            key: "clear",
            value: function clear() {
                this.staticPlaceholders = new Map();
                this.callbacks = new Map();
                this.getSizeCallbacks = new Map();
                this.reactValidateCallbacks = new Map();
            }
        },
        {
            key: "isPlaceholder",
            value: function isPlaceholder(element) {
                return !!element.dataset.ssrPlaceholder;
            }
        },
        {
            key: "isPlaceholderReplacement",
            value: function isPlaceholderReplacement(element) {
                return !!element.dataset.ssrPlaceholderReplace;
            }
        },
        {
            key: "checkIfExistedAndSizeMatching",
            value: function checkIfExistedAndSizeMatching(el) {
                var _this2 = this;
                var id = el.dataset.ssrPlaceholder || "";
                return new Promise(function(resolve) {
                    if (!_this2.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        _this2.callbacks.set(id, resolve);
                        _this2.intersectionObserver.observe(el);
                    }
                });
            }
        },
        {
            key: "getSize",
            value: function getSize(el) {
                var _this3 = this;
                return new Promise(function(resolve) {
                    _this3.getSizeCallbacks.set(el.dataset.ssrPlaceholder || "", resolve);
                    _this3.intersectionObserver.observe(el);
                });
            }
        },
        {
            key: "validateReactComponentMatchToPlaceholder",
            value: function validateReactComponentMatchToPlaceholder(el) {
                var _this4 = this;
                var id = el.dataset.ssrPlaceholderReplace || "";
                return new Promise(function(resolve) {
                    if (!_this4.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        _this4.reactValidateCallbacks.set(id, resolve);
                        _this4.intersectionObserver.observe(el);
                    }
                });
            }
        },
        {
            key: "hasSameSizePosition",
            value: function hasSameSizePosition(rect, boundingClientRect) {
                return rect && Math.abs(rect.x - boundingClientRect.x) < $d00ea7585d833f2c$var$EQUALITY_THRESHOLD && Math.abs(rect.y - boundingClientRect.y) < $d00ea7585d833f2c$var$EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < $d00ea7585d833f2c$var$EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < $d00ea7585d833f2c$var$EQUALITY_THRESHOLD || false;
            }
        }
    ]);
    return SSRPlaceholderHandlers;
}();

});




parcelRegister("fQHfi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b89d420fd085e8c6$export$2e2bcd8739ae039; });
var $b89d420fd085e8c6$var$interactions = new Map();
var $b89d420fd085e8c6$export$2e2bcd8739ae039 = $b89d420fd085e8c6$var$interactions;

});


parcelRegister("kI8WJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f13edb43baab4d8f$export$2e2bcd8739ae039; });

var $jEU71 = parcelRequire("jEU71");
var $f13edb43baab4d8f$export$2e2bcd8739ae039 = (0, $jEU71.default);

});
parcelRegister("jEU71", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4fd477b62becfc1$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $b4Ivn = parcelRequire("b4Ivn");

var $9nHZC = parcelRequire("9nHZC");

var $wmpq0 = parcelRequire("wmpq0");

var $4Pw3J = parcelRequire("4Pw3J");

var $41O29 = parcelRequire("41O29");

var $59ZFR = parcelRequire("59ZFR");

var $2xpzD = parcelRequire("2xpzD");

var $9FrJk = parcelRequire("9FrJk");

var $hVUKx = parcelRequire("hVUKx");

var $bTFL7 = parcelRequire("bTFL7");
function $e4fd477b62becfc1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e4fd477b62becfc1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e4fd477b62becfc1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e4fd477b62becfc1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e4fd477b62becfc1$var$tryCompleteHandle;
function $e4fd477b62becfc1$export$2e2bcd8739ae039(_ref) {
    var segmentName = _ref.name, children = _ref.children;
    var parentContext = (0, $9nHZC.useContext)((0, $59ZFR.default));
    var segmentId = (0, $9nHZC.useMemo)(function() {
        return (0, $bTFL7.default)();
    }, []);
    var labelStack = (0, $9nHZC.useMemo)(function() {
        return parentContext !== null && parentContext !== void 0 && parentContext.labelStack ? [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(parentContext.labelStack), [
            {
                name: segmentName,
                segmentId: segmentId
            }
        ]) : [
            {
                name: segmentName,
                segmentId: segmentId
            }
        ];
    }, [
        parentContext,
        segmentName,
        segmentId
    ]);
    var interactionId = (0, $9nHZC.useContext)((0, $2xpzD.default));
    var interactionContext = (0, $9nHZC.useMemo)(function() {
        (0, $9FrJk.addSegment)(labelStack);
        var lastCompleteEndTime = 0;
        function complete() {
            var endTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
            if (interactionId.current) {
                if (parentContext) parentContext.complete();
                else {
                    var capturedInteractionId = interactionId.current;
                    if (endTime > lastCompleteEndTime) lastCompleteEndTime = endTime;
                    if ($e4fd477b62becfc1$var$tryCompleteHandle) {
                        var _cancelAnimationFrame;
                        (_cancelAnimationFrame = cancelAnimationFrame) === null || _cancelAnimationFrame === void 0 || _cancelAnimationFrame($e4fd477b62becfc1$var$tryCompleteHandle);
                    }
                    (0, $wmpq0.unstable_scheduleCallback)((0, $wmpq0.unstable_NormalPriority), function() {
                        if (capturedInteractionId === interactionId.current) {
                            var _document;
                            var isPageVisible = ((_document = document) === null || _document === void 0 ? void 0 : _document.visibilityState) === "visible";
                            var canDoRAF = typeof requestAnimationFrame !== "undefined";
                            if (isPageVisible && canDoRAF) $e4fd477b62becfc1$var$tryCompleteHandle = requestAnimationFrame(function() {
                                $e4fd477b62becfc1$var$tryCompleteHandle = requestAnimationFrame(function() {
                                    if (capturedInteractionId === interactionId.current) (0, $9FrJk.tryComplete)(interactionId.current, lastCompleteEndTime);
                                });
                            });
                            else (0, $9FrJk.tryComplete)(interactionId.current, lastCompleteEndTime);
                        }
                    });
                }
            }
        }
        function _internalHold(labelStack, name) {
            if (interactionId.current != null) {
                if (parentContext) return parentContext._internalHold(labelStack, name);
                else {
                    var capturedInteractionId = interactionId.current;
                    var disposeHold = (0, $9FrJk.addHold)(interactionId.current, labelStack, name);
                    return function() {
                        if (capturedInteractionId === interactionId.current) disposeHold();
                    };
                }
            }
        }
        function _internalHoldByID(labelStack, id, name, remove) {
            if (interactionId.current != null) {
                if (parentContext) {
                    parentContext._internalHoldByID(labelStack, name, id, remove);
                    return;
                }
                if (!remove) (0, $9FrJk.addHoldByID)(interactionId.current, labelStack, name, id);
                else (0, $9FrJk.removeHoldByID)(interactionId.current, id);
            }
        }
        if (parentContext) return $e4fd477b62becfc1$var$_objectSpread($e4fd477b62becfc1$var$_objectSpread({}, parentContext), {}, {
            labelStack: labelStack,
            complete: complete
        });
        return {
            labelStack: labelStack,
            hold: function hold() {
                var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "unknown";
                return this._internalHold(this.labelStack, name);
            },
            addHoldByID: function addHoldByID(labelStack, id) {
                var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "unknown";
                this._internalHoldByID(labelStack, id, name, false);
            },
            removeHoldByID: function removeHoldByID(labelStack, id) {
                var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "unknown";
                this._internalHoldByID(labelStack, id, name, true);
            },
            tracePress: function tracePress() {
                var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "unknown";
                var timestamp = arguments.length > 1 ? arguments[1] : undefined;
                if (interactionId.current != null) (0, $9FrJk.abortByNewInteraction)(interactionId.current, name);
                var rate = (0, $41O29.getInteractionRate)(name, "press");
                if ((0, $4Pw3J.default)(rate)) {
                    var startTimestamp = timestamp !== null && timestamp !== void 0 ? timestamp : performance.now();
                    var newId = (0, $bTFL7.default)();
                    interactionId.current = newId;
                    (0, $9FrJk.addNewInteraction)(newId, name, "press", startTimestamp, rate, this.labelStack, (0, $hVUKx.default).current);
                }
            },
            retainQuery: function retainQuery(info) {
                if (interactionId.current != null) (0, $9FrJk.addRequestInfo)(interactionId.current, this.labelStack, info);
            },
            addPreload: function addPreload(moduleId, timestamp) {
                if (interactionId.current != null) (0, $9FrJk.addMark)(interactionId.current, "bundle_preload", moduleId, this.labelStack, timestamp);
            },
            addLoad: function addLoad(identifier, start, end) {
                if (interactionId.current != null) {
                    var _this$labelStack = this.labelStack, _labelStack = _this$labelStack === void 0 ? [] : _this$labelStack;
                    (0, $9FrJk.addSpan)(interactionId.current, "bundle_load", identifier, _labelStack, start, end);
                }
            },
            addMark: function addMark(name, timestamp) {
                if (interactionId.current != null) {
                    var time = timestamp !== null && timestamp !== void 0 ? timestamp : performance.now();
                    (0, $9FrJk.addMark)(interactionId.current, "custom", name, this.labelStack, time);
                }
            },
            addCustomData: function addCustomData(customData) {
                if (interactionId.current != null) (0, $9FrJk.addCustomData)(interactionId.current, this.labelStack, customData);
            },
            addCustomTimings: function addCustomTimings(customTimings) {
                if (interactionId.current != null) (0, $9FrJk.addCustomTiming)(interactionId.current, this.labelStack, customTimings);
            },
            addApdex: function addApdex(apdexInfo) {
                if (interactionId.current != null) {
                    var key = apdexInfo.key, stopTime = apdexInfo.stopTime, startTime = apdexInfo.startTime;
                    (0, $9FrJk.addApdex)(interactionId.current, {
                        key: key,
                        stopTime: stopTime,
                        startTime: startTime,
                        labelStack: this.labelStack
                    });
                }
            },
            onRender: function onRender(phase, actualDuration, baseDuration, startTime, commitTime) {
                if (interactionId.current !== null) {
                    (0, $9FrJk.addProfilerTimings)(interactionId.current, this.labelStack, phase, actualDuration, baseDuration, startTime, commitTime);
                    this.complete(commitTime);
                }
            },
            _internalHold: _internalHold,
            _internalHoldByID: _internalHoldByID,
            complete: complete
        };
    }, [
        parentContext,
        labelStack,
        interactionId
    ]);
    var onRender = (0, $9nHZC.useCallback)(function(_id, phase, actualDuration, baseDuration, startTime, commitTime) {
        interactionContext.onRender(phase, actualDuration, baseDuration, startTime, commitTime);
    }, [
        interactionContext
    ]);
    (0, $9nHZC.useEffect)(function() {
        return function() {
            (0, $9FrJk.removeSegment)(labelStack);
        };
    }, [
        interactionId,
        parentContext,
        interactionContext,
        labelStack
    ]);
    var reactProfilerId = (0, $9nHZC.useMemo)(function() {
        return labelStack.map(function(l) {
            return l.name;
        }).join("/");
    }, [
        labelStack
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $59ZFR.default).Provider, {
        value: interactionContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Profiler), {
        id: reactProfilerId,
        onRender: onRender
    }, children));
}

});
parcelRegister("hVUKx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0e3c7d408e8a3e3$export$2e2bcd8739ae039; });
// The UFORouteName object is a global singleton
var $d0e3c7d408e8a3e3$var$UFORouteName = {
    current: null
};
var $d0e3c7d408e8a3e3$export$2e2bcd8739ae039 = $d0e3c7d408e8a3e3$var$UFORouteName;

});

parcelRegister("bTFL7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a95394004df9cae$export$2e2bcd8739ae039; });
function $8a95394004df9cae$export$2e2bcd8739ae039() {
    var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7;
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var result = "";
    for(var i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
    return result;
}

});



parcelRegister("fTXuo", function(module, exports) {

$parcel$export(module.exports, "BaseCrossFlowApiProvider", function () { return (parcelRequire("2ABou")).BaseCrossFlowApiProvider; });
$parcel$export(module.exports, "useCrossFlow", function () { return (parcelRequire("2ABou")).useCrossFlow; });
$parcel$export(module.exports, "withCrossFlow", function () { return (parcelRequire("2ABou")).withCrossFlow; });
$parcel$export(module.exports, "Journeys", function () { return (parcelRequire("h898w")).Journeys; });
$parcel$export(module.exports, "Reasons", function () { return (parcelRequire("h898w")).Reasons; });

var $2ABou = parcelRequire("2ABou");

var $h898w = parcelRequire("h898w");

});
parcelRegister("2ABou", function(module, exports) {

$parcel$export(module.exports, "BaseCrossFlowApiProvider", function () { return $1e2bf338137678ca$export$c0ddec072762f62a; });
$parcel$export(module.exports, "useCrossFlow", function () { return $1e2bf338137678ca$export$6e7a10fe635a0dfc; });
$parcel$export(module.exports, "withCrossFlow", function () { return $1e2bf338137678ca$export$655b6c19a0daddb8; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $6UrCK = parcelRequire("6UrCK");

var $h898w = parcelRequire("h898w");
var $1e2bf338137678ca$var$LATEST_VERSION = (0, $6UrCK.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ var $1e2bf338137678ca$var$CrossFlowContext = /*#__PURE__*/ (0, $9nHZC.createContext)(function() {
    return {
        isEnabled: false,
        reason: (0, $h898w.Reasons).NO_PROVIDER
    };
});
var $1e2bf338137678ca$export$59ce2d27e6cd8c9 = function createNegotiateApi(onOpen) {
    return function(version) {
        switch(version){
            case 0, $6UrCK.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $6UrCK.createAPIv0)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $h898w.Reasons).NO_API_SUPPORT
                };
        }
    };
};
var $1e2bf338137678ca$export$c0ddec072762f62a = function BaseCrossFlowApiProvider(_ref) {
    var onOpen = _ref.onOpen, children = _ref.children;
    var negotiateApi = (0, $9nHZC.useMemo)(function() {
        return $1e2bf338137678ca$export$59ce2d27e6cd8c9(onOpen);
    }, [
        onOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($1e2bf338137678ca$var$CrossFlowContext.Provider, {
        value: negotiateApi
    }, children);
};
var $1e2bf338137678ca$export$6e7a10fe635a0dfc = function useCrossFlow() {
    var negotiateApi = (0, $9nHZC.useContext)($1e2bf338137678ca$var$CrossFlowContext);
    return (0, $9nHZC.useMemo)(function() {
        return negotiateApi($1e2bf338137678ca$var$LATEST_VERSION);
    }, [
        negotiateApi
    ]);
};
function $1e2bf338137678ca$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    var ComponentWithCrossFlow = function ComponentWithCrossFlow(props) {
        var crossFlow = $1e2bf338137678ca$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
            crossFlow: crossFlow
        }));
    };
    ComponentWithCrossFlow.displayName = "withCrossFlow(".concat(WrappedComponent.displayName || WrappedComponent.name || "Component", ")");
    return ComponentWithCrossFlow;
}

});
parcelRegister("6UrCK", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $507d6695684d5e13$export$a4ad2735b021c132; });
$parcel$export(module.exports, "createAPIv0", function () { return $507d6695684d5e13$export$9ff7368ac93fcf2d; });
/**
 * Version 0 of public Cross Flow API
 */ var $507d6695684d5e13$export$a4ad2735b021c132 = 0;
var $507d6695684d5e13$export$9ff7368ac93fcf2d = function createAPIv0(onOpen) {
    return {
        open: function open(options) {
            return onOpen(options);
        }
    };
};

});

parcelRegister("h898w", function(module, exports) {

$parcel$export(module.exports, "Journeys", function () { return $c78a454f016f6252$export$3411873bfd520bb6; });
$parcel$export(module.exports, "Reasons", function () { return $c78a454f016f6252$export$da2d4f2f250d6f84; });
var $c78a454f016f6252$export$3411873bfd520bb6 = {
    GET_STARTED: "get-started",
    DECIDE: "decide",
    DISCOVER: "discover"
};
var $c78a454f016f6252$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: "Could not provide requested API version",
    NO_PROVIDER: "Provider not found"
}; // equivalent of `typeof Reason.NO_API_SUPPORT | typeof Reason.NO_PROVIDER | ...`

});



parcelRegister("fMSHR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7e5c64b0e3aa8d9$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $xbX1J = parcelRequire("xbX1J");

var $dBrMA = parcelRequire("dBrMA");

var $aBvWR = parcelRequire("aBvWR");
function $b7e5c64b0e3aa8d9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b7e5c64b0e3aa8d9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b7e5c64b0e3aa8d9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b7e5c64b0e3aa8d9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b7e5c64b0e3aa8d9$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $dBrMA.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $b7e5c64b0e3aa8d9$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === "undefined") return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $xbX1J.COLOR_MODE_ATTRIBUTE)) || "";
    var theme = element.getAttribute((0, $xbX1J.THEME_DATA_ATTRIBUTE)) || "";
    return $b7e5c64b0e3aa8d9$var$_objectSpread($b7e5c64b0e3aa8d9$var$_objectSpread({}, (0, $aBvWR.themeStringToObject)(theme)), $b7e5c64b0e3aa8d9$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $b7e5c64b0e3aa8d9$export$2e2bcd8739ae039 = $b7e5c64b0e3aa8d9$var$getGlobalTheme;

});
parcelRegister("dBrMA", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", function () { return $9e7448204ef979d8$export$83993de8eb66733; });
$parcel$export(module.exports, "themeIds", function () { return $9e7448204ef979d8$export$7d43e72a58e3283f; });
$parcel$export(module.exports, "themeStateDefaults", function () { return $9e7448204ef979d8$export$9aedcfa7336a207; });
$parcel$export(module.exports, "default", function () { return $9e7448204ef979d8$export$2e2bcd8739ae039; });
/**
 * This file contains the source of truth for themes and all associated meta data.
 */ /**
 * Themes: The internal identifier of a theme.
 * These ids are what the actual theme files/folders are called.
 * style-dictionary will attempt to locate these in the file-system.
 */ /**
 * ThemeOverrides: The internal identifier of a theme override. Which are themes that contain
 * a subset of tokens intended to override an existing theme. These ids are what the actual
 * theme files/folders are called. style-dictionary will attempt to locate these in the file-system.
 * Theme overrides are temporary and there may not be any defined at times.
 */ /**
 * Theme kinds: The type of theme.
 * Some themes are entirely focused on Color, whilst others are purely focused on spacing.
 * In the future other types may be introduced such as typography.
 */ /**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $9e7448204ef979d8$export$83993de8eb66733 = [
    "light",
    "dark",
    "auto"
];
var $9e7448204ef979d8$export$8ce7e340c74e86c5 = [
    "more",
    "no-preference",
    "auto"
];
var $9e7448204ef979d8$export$7d43e72a58e3283f = [
    "light-increased-contrast",
    "light",
    "light-future",
    "light-brand-refresh",
    "dark",
    "dark-future",
    "dark-increased-contrast",
    "dark-brand-refresh",
    "legacy-light",
    "legacy-dark",
    "spacing",
    "shape",
    "typography-adg3",
    "typography-modernized",
    "typography-refreshed"
];
var $9e7448204ef979d8$export$ba8a43b83ecc69f8 = [];
var $9e7448204ef979d8$export$92ba366331403db2 = [].concat($9e7448204ef979d8$export$7d43e72a58e3283f, $9e7448204ef979d8$export$ba8a43b83ecc69f8);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $9e7448204ef979d8$var$themeConfig = {
    "atlassian-light": {
        id: "light",
        displayName: "Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-light-future": {
        id: "light-future",
        displayName: "Future Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        override: "light"
    },
    "atlassian-light-increased-contrast": {
        id: "light-increased-contrast",
        displayName: "Light Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        extends: "light",
        increasesContrastFor: "light"
    },
    "atlassian-dark": {
        id: "dark",
        displayName: "Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-dark-future": {
        id: "dark-future",
        displayName: "Future Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        override: "light"
    },
    "atlassian-dark-increased-contrast": {
        id: "dark-increased-contrast",
        displayName: "Dark Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        extends: "dark",
        increasesContrastFor: "dark"
    },
    "atlassian-legacy-light": {
        id: "legacy-light",
        displayName: "Light Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-legacy-dark": {
        id: "legacy-dark",
        displayName: "Dark Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-spacing": {
        id: "spacing",
        displayName: "Atlassian Spacing",
        palette: "spacingScale",
        attributes: {
            type: "spacing"
        }
    },
    "atlassian-typography-adg3": {
        id: "typography-adg3",
        displayName: "ADG3 Typography",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-shape": {
        id: "shape",
        displayName: "Atlassian Shape",
        palette: "shapePalette",
        attributes: {
            type: "shape"
        }
    },
    "atlassian-typography-modernized": {
        id: "typography-modernized",
        displayName: "Atlassian Typography (Modernized)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-typography-refreshed": {
        id: "typography-refreshed",
        displayName: "Atlassian Typography (Refreshed)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-light-brand-refresh": {
        id: "light-brand-refresh",
        displayName: "Light theme (Brand refresh)",
        palette: "brandRefreshPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-dark-brand-refresh": {
        id: "dark-brand-refresh",
        displayName: "Dark theme (Brand refresh)",
        palette: "brandRefreshPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    }
};
var $9e7448204ef979d8$export$9aedcfa7336a207 = {
    colorMode: "auto",
    contrastMode: "auto",
    dark: "dark",
    light: "light",
    shape: undefined,
    spacing: "spacing",
    typography: undefined,
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $9e7448204ef979d8$export$2e2bcd8739ae039 = $9e7448204ef979d8$var$themeConfig;

});

parcelRegister("aBvWR", function(module, exports) {

$parcel$export(module.exports, "themeStringToObject", function () { return $7b8624618eabddf0$export$f19b488f7c0547ee; });
$parcel$export(module.exports, "themeObjectToString", function () { return $7b8624618eabddf0$export$62c37ab81302621a; });

var $340K4 = parcelRequire("340K4");

var $9q1kH = parcelRequire("9q1kH");

var $dBrMA = parcelRequire("dBrMA");
var $7b8624618eabddf0$var$themeKinds = [
    "light",
    "dark",
    "spacing",
    "typography",
    "shape"
];
var $7b8624618eabddf0$var$customThemeOptions = "UNSAFE_themeOptions";
var $7b8624618eabddf0$var$isThemeKind = function isThemeKind(themeKind) {
    return $7b8624618eabddf0$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $7b8624618eabddf0$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $dBrMA.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $7b8624618eabddf0$var$isColorMode = function isColorMode(modeId) {
    return [
        "light",
        "dark",
        "auto"
    ].includes(modeId);
};
var $7b8624618eabddf0$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(" ").map(function(theme) {
        return theme.split(/:([\s\S]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === "colorMode" && $7b8624618eabddf0$var$isColorMode(id)) themeObject[kind] = id;
        if ($7b8624618eabddf0$var$isThemeKind(kind) && $7b8624618eabddf0$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $7b8624618eabddf0$var$customThemeOptions) try {
            themeObject[$7b8624618eabddf0$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error("Invalid custom theme string");
        }
        return themeObject;
    }, {});
};
var $7b8624618eabddf0$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === "colorMode" && typeof id === "string" && $7b8624618eabddf0$var$isColorMode(id) || // custom theme state
        kind === $7b8624618eabddf0$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(id) === "object" || // other theme states
        $7b8624618eabddf0$var$isThemeKind(kind) && typeof id === "string" && $7b8624618eabddf0$var$isThemeIds(id)) return themeString + "".concat(themeString ? " " : "") + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(id) === "object" ? JSON.stringify(id) : id);
        return themeString;
    }, "");
};

});


parcelRegister("8HwYi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $655bea571ee5e602$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "DynamicConfig", function () { return (parcelRequire("iiPPB")).DynamicConfig; });
$parcel$export(module.exports, "EvaluationReason", function () { return (parcelRequire("iiPPB")).EvaluationReason; });
$parcel$export(module.exports, "FeatureGateEnvironment", function () { return (parcelRequire("2yOpU")).FeatureGateEnvironment; });
$parcel$export(module.exports, "PerimeterType", function () { return (parcelRequire("2yOpU")).PerimeterType; });

var $lOQkO = parcelRequire("lOQkO");

var $9q1kH = parcelRequire("9q1kH");

var $4mVfk = parcelRequire("4mVfk");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");

var $8DpVo = parcelRequire("8DpVo");

var $iiPPB = parcelRequire("iiPPB");

var $7l5z9 = parcelRequire("7l5z9");

var $2yOpU = parcelRequire("2yOpU");

var $l05FA = parcelRequire("l05FA");
var $655bea571ee5e602$var$_excluded = [
    "sdkKey",
    "updateUserCompletionCallback",
    "perimeter"
];
function $655bea571ee5e602$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $655bea571ee5e602$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $655bea571ee5e602$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $655bea571ee5e602$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $655bea571ee5e602$var$DEFAULT_CLIENT_KEY = "client-default-key";
// the default event logging api is the Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $655bea571ee5e602$var$DEFAULT_EVENT_LOGGING_API = "https://xp.atlassian.com/v1/";
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $655bea571ee5e602$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, FeatureGates);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(FeatureGates, null, [
        {
            key: "initialize",
            value: /**
     * @description
     * This method initializes the client using a network call to fetch the bootstrap values.
     * If the client is inialized with an `analyticsWebClient`, it will send an operational event
     * to GASv3 with the following attributes:
     * - targetApp: the target app of the client
     * - clientVersion: the version of the client
     * - success: whether the initialization was successful
     * - startTime: the time when the initialization started
     * - totalTime: the total time it took to initialize the client
     * - apiKey: the api key used to initialize the client
     * @param clientOptions {ClientOptions}
     * @param identifiers {Identifiers}
     * @param customAttributes {CustomAttributes}
     * @returns {Promise<void>}
     */ function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!FeatureGates.initPromise) {
                                    _context.next = 3;
                                    break;
                                }
                                if (!FeatureGates.shallowEquals(clientOptions, FeatureGates.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context.abrupt("return", FeatureGates.initPromise);
                            case 3:
                                startTime = performance.now();
                                FeatureGates.initOptions = clientOptions;
                                FeatureGates.initPromise = FeatureGates.init(clientOptions, identifiers, customAttributes).then(function() {
                                    FeatureGates.initCompleted = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    FeatureGates.fireClientEvent(startTime, totalTime, "initialize", FeatureGates.initCompleted, clientOptions.apiKey);
                                });
                                return _context.abrupt("return", FeatureGates.initPromise);
                            case 7:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _FeatureGates$initOpt;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_FeatureGates$initOpt = FeatureGates.initOptions.analyticsWebClient) === null || _FeatureGates$initOpt === void 0 || _FeatureGates$initOpt.then(function(analyticsWebClient) {
                    var attributes = $655bea571ee5e602$var$_objectSpread({
                        targetApp: FeatureGates.initOptions.targetApp,
                        clientVersion: (0, $l05FA.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: "featureGatesClient",
                        attributes: attributes,
                        tags: [
                            "measurement"
                        ],
                        source: "@atlaskit/feature-gate-js-client"
                    });
                }).catch(function(err) {
                    if (FeatureGates.initOptions.environment !== (0, $2yOpU.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error("Analytics web client promise did not resolve", err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee2(clientOptions, identifiers, customAttributes) {
                    var initializeValues, startTime, _args2 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                initializeValues = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : {};
                                if (!FeatureGates.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!FeatureGates.shallowEquals(clientOptions, FeatureGates.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context2.abrupt("return", FeatureGates.initPromise);
                            case 4:
                                startTime = performance.now();
                                FeatureGates.initOptions = clientOptions;
                                FeatureGates.initPromise = FeatureGates.initFromValues(clientOptions, identifiers, customAttributes, initializeValues).then(function() {
                                    FeatureGates.initCompleted = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    FeatureGates.fireClientEvent(startTime, totalTime, "initializeFromValues", FeatureGates.initCompleted);
                                });
                                return _context2.abrupt("return", FeatureGates.initPromise);
                            case 8:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                function initializeFromValues(_x4, _x5, _x6) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee3(fetchOptions, identifiers, customAttributes) {
                    var initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $7l5z9.default).fetchExperimentValues(fetchOptions, identifiers, customAttributes).then(function(_ref) {
                                        var experimentValues = _ref.experimentValues, customAttributes = _ref.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context3.next = 3;
                                return FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function updateUser(_x7, _x8, _x9) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee4(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args4 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                initializeValues = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context4.next = 4;
                                return FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function updateUserWithValues(_x10, _x11) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return FeatureGates.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return FeatureGates.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    var evalMethod = fireGateExposure ? (0, (/*@__PURE__*/$parcel$interopDefault($iiPPB))).checkGate.bind((0, (/*@__PURE__*/$parcel$interopDefault($iiPPB)))) : (0, (/*@__PURE__*/$parcel$interopDefault($iiPPB))).checkGateWithExposureLoggingDisabled.bind((0, (/*@__PURE__*/$parcel$interopDefault($iiPPB))));
                    return evalMethod(gateName);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!FeatureGates.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred checking the feature gate. Only the first occurrence of this error is logged.",
                            gateName: gateName,
                            error: error
                        });
                        FeatureGates.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                (0, (/*@__PURE__*/$parcel$interopDefault($iiPPB))).manuallyLogGateExposure(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    var evalMethod = fireExperimentExposure ? (0, (/*@__PURE__*/$parcel$interopDefault($iiPPB))).getExperiment.bind((0, (/*@__PURE__*/$parcel$interopDefault($iiPPB)))) : (0, (/*@__PURE__*/$parcel$interopDefault($iiPPB))).getExperimentWithExposureLoggingDisabled.bind((0, (/*@__PURE__*/$parcel$interopDefault($iiPPB))));
                    return evalMethod(experimentName);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!FeatureGates.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            error: error
                        });
                        FeatureGates.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $iiPPB.DynamicConfig)(experimentName, {}, "", {
                        time: Date.now(),
                        reason: (0, $iiPPB.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = FeatureGates.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!FeatureGates.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment value. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        FeatureGates.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                (0, (/*@__PURE__*/$parcel$interopDefault($iiPPB))).manuallyLogExperimentExposure(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                (0, (/*@__PURE__*/$parcel$interopDefault($iiPPB))).manuallyLogLayerParameterExposure(layerName, parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                (0, (/*@__PURE__*/$parcel$interopDefault($iiPPB))).shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                (0, (/*@__PURE__*/$parcel$interopDefault($iiPPB))).overrideGate(gateName, value);
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                (0, (/*@__PURE__*/$parcel$interopDefault($iiPPB))).overrideGate(gateName, null);
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                (0, (/*@__PURE__*/$parcel$interopDefault($iiPPB))).overrideConfig(experimentName, values);
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                (0, (/*@__PURE__*/$parcel$interopDefault($iiPPB))).overrideConfig(experimentName, null);
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                (0, (/*@__PURE__*/$parcel$interopDefault($iiPPB))).setOverrides($655bea571ee5e602$var$_objectSpread({
                    gates: {},
                    configs: {},
                    layers: {}
                }, overrides));
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($iiPPB))).getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                (0, (/*@__PURE__*/$parcel$interopDefault($iiPPB))).setOverrides(null);
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return FeatureGates.shallowEquals(FeatureGates.currentIdentifiers, identifiers) && FeatureGates.shallowEquals(FeatureGates.currentAttributes, customAttributes);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee5(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                fromValuesClientOptions = $655bea571ee5e602$var$_objectSpread($655bea571ee5e602$var$_objectSpread({}, clientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context5.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for the experiment
                                // values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $7l5z9.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $7l5z9.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client with experiment
                                // values if both requests are successful. Else an error would be thrown and handled by the catch
                                _context5.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context5.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context5.next = 20;
                                break;
                            case 13:
                                _context5.prev = 13;
                                _context5.t0 = _context5["catch"](1);
                                if (_context5.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context5.t0 === null || _context5.t0 === void 0 ? void 0 : _context5.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context5.next = 19;
                                return FeatureGates.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context5.t0;
                            case 20:
                                _context5.next = 22;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
                            case 22:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x12, _x13, _x14) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee6(clientOptions, identifiers, customAttributes) {
                    var initializeValues, user, sdkKey, statsigOptions, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : {};
                                user = this.toStatsigUser(identifiers, customAttributes);
                                FeatureGates.currentIdentifiers = identifiers;
                                FeatureGates.currentAttributes = customAttributes;
                                if (!clientOptions.sdkKey) clientOptions.sdkKey = $655bea571ee5e602$var$DEFAULT_CLIENT_KEY;
                                if (!clientOptions.eventLoggingApi) clientOptions.eventLoggingApi = $655bea571ee5e602$var$DEFAULT_EVENT_LOGGING_API;
                                if (clientOptions.perimeter === (0, $2yOpU.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                clientOptions.disableAllLogging = true;
                                sdkKey = clientOptions.sdkKey;
                                statsigOptions = this.toStatsigOptions(clientOptions, initializeValues);
                                _context6.prev = 9;
                                _context6.next = 12;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($iiPPB))).initialize(sdkKey, user, statsigOptions);
                            case 12:
                                _context6.next = 21;
                                break;
                            case 14:
                                _context6.prev = 14;
                                _context6.t0 = _context6["catch"](9);
                                if (_context6.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context6.t0 === null || _context6.t0 === void 0 ? void 0 : _context6.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                _context6.next = 20;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($iiPPB))).initialize($655bea571ee5e602$var$DEFAULT_CLIENT_KEY, user, $655bea571ee5e602$var$_objectSpread($655bea571ee5e602$var$_objectSpread({}, statsigOptions), {}, {
                                    initializeValues: {}
                                }));
                            case 20:
                                throw _context6.t0;
                            case 21:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this, [
                        [
                            9,
                            14
                        ]
                    ]);
                }));
                function initFromValues(_x15, _x16, _x17) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "toStatsigUser",
            value: function toStatsigUser(identifiers, customAttributes) {
                var user = {
                    customIDs: identifiers,
                    custom: customAttributes
                };
                if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
                return user;
            }
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee7(getInitializeValues, identifiers, customAttributes) {
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (FeatureGates.initPromise) {
                                    _context7.next = 2;
                                    break;
                                }
                                throw new Error("The FeatureGates client must be initialized before you can update the user.");
                            case 2:
                                if (!FeatureGates.isCurrentUser(identifiers, customAttributes)) {
                                    _context7.next = 4;
                                    break;
                                }
                                return _context7.abrupt("return", FeatureGates.initPromise);
                            case 4:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = FeatureGates.initPromise;
                                _context7.prev = 5;
                                _context7.next = 8;
                                return FeatureGates.initPromise;
                            case 8:
                                _context7.next = 12;
                                break;
                            case 10:
                                _context7.prev = 10;
                                _context7.t0 = _context7["catch"](5);
                            case 12:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = FeatureGates.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this point.
                                // Any subsequent calls to await FeatureGates.initialize() or FeatureGates.updateUser() will now also await this user update.
                                FeatureGates.initPromise = updateUserPromise.catch(function() {
                                    // If the update failed then it changed nothing, so revert back to the original promise.
                                    FeatureGates.initPromise = originalInitPromise;
                                });
                                return _context7.abrupt("return", updateUserPromise);
                            case 16:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, null, [
                        [
                            5,
                            10
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x18, _x19, _x20) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee8(initializeValuesPromise, identifiers, customAttributes) {
                    var initializeValues, user, _FeatureGates$initOpt2, _FeatureGates$initOpt3, errMsg, success;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                _context8.prev = 0;
                                _context8.next = 3;
                                return initializeValuesPromise;
                            case 3:
                                initializeValues = _context8.sent;
                                user = FeatureGates.toStatsigUser(identifiers, initializeValues.customAttributesFromFetch);
                                _context8.next = 12;
                                break;
                            case 7:
                                _context8.prev = 7;
                                _context8.t0 = _context8["catch"](0);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will already invoke the callback itself.
                                errMsg = _context8.t0 instanceof Error ? _context8.t0.message : JSON.stringify(_context8.t0);
                                (_FeatureGates$initOpt2 = (_FeatureGates$initOpt3 = FeatureGates.initOptions).updateUserCompletionCallback) === null || _FeatureGates$initOpt2 === void 0 || _FeatureGates$initOpt2.call(_FeatureGates$initOpt3, false, errMsg);
                                throw _context8.t0;
                            case 12:
                                success = (0, (/*@__PURE__*/$parcel$interopDefault($iiPPB))).updateUserWithValues(user, initializeValues.experimentValues);
                                if (!success) {
                                    _context8.next = 18;
                                    break;
                                }
                                FeatureGates.currentIdentifiers = identifiers;
                                FeatureGates.currentAttributes = customAttributes;
                                _context8.next = 19;
                                break;
                            case 18:
                                throw new Error("Failed to update user. An unexpected error occured.");
                            case 19:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, null, [
                        [
                            0,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x21, _x22, _x23) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "toStatsigOptions",
            value: function toStatsigOptions(options, initializeValues) {
                var sdkKey = options.sdkKey, updateUserCompletionCallback = options.updateUserCompletionCallback, perimeter = options.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(options, $655bea571ee5e602$var$_excluded);
                return $655bea571ee5e602$var$_objectSpread($655bea571ee5e602$var$_objectSpread({}, restClientOptions), {}, {
                    initializeValues: initializeValues,
                    environment: {
                        tier: options.environment
                    },
                    disableCurrentPageLogging: true
                }, options.updateUserCompletionCallback && {
                    updateUserCompletionCallback: FeatureGates.toStatsigUpdateUserCompletionCallback(options.updateUserCompletionCallback)
                });
            }
        },
        {
            key: "toStatsigUpdateUserCompletionCallback",
            value: function toStatsigUpdateUserCompletionCallback(callback) {
                /**
       * The duration passed to the callback indicates how long the update took, but it is deceptive since it only times the
       * Statsig code and doesn't account for all of the extra custom work we do to obtain the bootstrap values.
       * As a result, we just suppress this parameter in our own callback rather than trying to keep it accurate.
       */ return function(_duration, success, message) {
                    callback(success, message);
                };
            }
        },
        {
            key: "shallowEquals",
            value: function shallowEquals(objectA, objectB) {
                if (!objectA && !objectB) return true;
                if (!objectA || !objectB) return false;
                var aEntries = Object.entries(objectA);
                var bEntries = Object.entries(objectB);
                if (aEntries.length !== bEntries.length) return false;
                var ascendingKeyOrder = function ascendingKeyOrder(_ref2, _ref3) {
                    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref2, 1), key1 = _ref4[0];
                    var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref3, 1), key2 = _ref5[0];
                    return key1.localeCompare(key2);
                };
                aEntries.sort(ascendingKeyOrder);
                bEntries.sort(ascendingKeyOrder);
                for(var i = 0; i < aEntries.length; i++){
                    var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(aEntries[i], 2), aValue = _aEntries$i[1];
                    var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(bEntries[i], 2), bValue = _bEntries$i[1];
                    if (aValue !== bValue) return false;
                }
                return true;
            }
        },
        {
            key: "getPackageVersion",
            value: function getPackageVersion() {
                return 0, $l05FA.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    var evalMethod = fireLayerExposure ? (0, (/*@__PURE__*/$parcel$interopDefault($iiPPB))).getLayer.bind((0, (/*@__PURE__*/$parcel$interopDefault($iiPPB)))) : (0, (/*@__PURE__*/$parcel$interopDefault($iiPPB))).getLayerWithExposureLoggingDisabled.bind((0, (/*@__PURE__*/$parcel$interopDefault($iiPPB))));
                    return evalMethod(layerName);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!FeatureGates.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            error: error
                        });
                        FeatureGates.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $iiPPB.Layer)._create(layerName, {}, "", {
                        time: Date.now(),
                        reason: (0, $iiPPB.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = FeatureGates.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!FeatureGates.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer value. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        FeatureGates.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
    return FeatureGates;
}();
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($655bea571ee5e602$var$FeatureGates, "initPromise", null);
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($655bea571ee5e602$var$FeatureGates, "initCompleted", false);
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($655bea571ee5e602$var$FeatureGates, "hasGetExperimentErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($655bea571ee5e602$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($655bea571ee5e602$var$FeatureGates, "hasGetLayerErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($655bea571ee5e602$var$FeatureGates, "hasGetLayerValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($655bea571ee5e602$var$FeatureGates, "hasCheckGateErrorOccurred", false);
var $655bea571ee5e602$var$boundFGJS = $655bea571ee5e602$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cyprus tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== "undefined") {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $655bea571ee5e602$var$FeatureGates;
    else {
        var $655bea571ee5e602$var$_boundFGJS, $655bea571ee5e602$var$_boundFGJS$getPackage;
        $655bea571ee5e602$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $655bea571ee5e602$var$boundVersion = (($655bea571ee5e602$var$_boundFGJS = $655bea571ee5e602$var$boundFGJS) === null || $655bea571ee5e602$var$_boundFGJS === void 0 || ($655bea571ee5e602$var$_boundFGJS$getPackage = $655bea571ee5e602$var$_boundFGJS.getPackageVersion) === null || $655bea571ee5e602$var$_boundFGJS$getPackage === void 0 ? void 0 : $655bea571ee5e602$var$_boundFGJS$getPackage.call($655bea571ee5e602$var$_boundFGJS)) || "4.10.0 or earlier";
        if ($655bea571ee5e602$var$boundVersion !== (0, $l05FA.CLIENT_VERSION)) {
            var $655bea571ee5e602$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($655bea571ee5e602$var$boundVersion, " when module version ").concat((0, $l05FA.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($655bea571ee5e602$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $655bea571ee5e602$export$2e2bcd8739ae039 = $655bea571ee5e602$var$boundFGJS;

});
parcelRegister("iiPPB", function(module, exports) {
"use strict";
var $d5321d0c8c8c5f62$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d5321d0c8c8c5f62$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $d5321d0c8c8c5f62$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EvaluationReason = module.exports.Layer = module.exports.DynamicConfig = void 0;

var $9KdHO = parcelRequire("9KdHO");

var $d5321d0c8c8c5f62$var$StatsigClient_1 = $d5321d0c8c8c5f62$var$__importDefault((parcelRequire("1TKi3")));

var $6YuR1 = parcelRequire("6YuR1");

var $kcbPW = parcelRequire("kcbPW");
Object.defineProperty(module.exports, "DynamicConfig", {
    enumerable: true,
    get: function() {
        return $d5321d0c8c8c5f62$var$__importDefault($kcbPW).default;
    }
});

var $01noY = parcelRequire("01noY");
Object.defineProperty(module.exports, "Layer", {
    enumerable: true,
    get: function() {
        return $d5321d0c8c8c5f62$var$__importDefault($01noY).default;
    }
});

var $6YuR1 = parcelRequire("6YuR1");
Object.defineProperty(module.exports, "EvaluationReason", {
    enumerable: true,
    get: function() {
        return $6YuR1.EvaluationReason;
    }
});
var $d5321d0c8c8c5f62$var$Statsig = /** @class */ function() {
    function Statsig() {}
    Statsig.initialize = function(sdkKey, user, options) {
        var _a;
        return $d5321d0c8c8c5f62$var$__awaiter(this, void 0, void 0, function() {
            var inst;
            return $d5321d0c8c8c5f62$var$__generator(this, function(_b) {
                inst = (_a = Statsig.instance) !== null && _a !== void 0 ? _a : new $d5321d0c8c8c5f62$var$StatsigClient_1.default(sdkKey, user, options);
                if (!Statsig.instance) Statsig.instance = inst;
                return [
                    2 /*return*/ ,
                    inst.initializeAsync()
                ];
            });
        });
    };
    Statsig.setInitializeValues = function(initializeValues) {
        Statsig._getClientX().setInitializeValues(initializeValues);
    };
    // Gate
    Statsig.checkGate = function(gateName) {
        return Statsig._getClientX().checkGate(gateName);
    };
    Statsig.checkGateWithExposureLoggingDisabled = function(gateName) {
        return Statsig._getClientX().checkGateWithExposureLoggingDisabled(gateName);
    };
    Statsig.manuallyLogGateExposure = function(gateName) {
        Statsig._getClientX().logGateExposure(gateName);
    };
    // Config
    Statsig.getConfig = function(configName) {
        return Statsig._getClientX().getConfig(configName);
    };
    Statsig.getConfigWithExposureLoggingDisabled = function(configName) {
        return Statsig._getClientX().getConfigWithExposureLoggingDisabled(configName);
    };
    Statsig.manuallyLogConfigExposure = function(configName) {
        Statsig._getClientX().logConfigExposure(configName);
    };
    // Experiment
    Statsig.getExperiment = function(experimentName) {
        return Statsig._getClientX().getExperiment(experimentName);
    };
    Statsig.getExperimentWithExposureLoggingDisabled = function(experimentName) {
        return Statsig._getClientX().getExperimentWithExposureLoggingDisabled(experimentName);
    };
    Statsig.manuallyLogExperimentExposure = function(configName) {
        Statsig._getClientX().logExperimentExposure(configName);
    };
    // Layer
    Statsig.getLayer = function(layerName) {
        return Statsig._getClientX().getLayer(layerName);
    };
    Statsig.getLayerWithExposureLoggingDisabled = function(layerName) {
        return Statsig._getClientX().getLayerWithExposureLoggingDisabled(layerName);
    };
    Statsig.manuallyLogLayerParameterExposure = function(layerName, parameterName) {
        Statsig._getClientX().logLayerParameterExposure(layerName, parameterName);
    };
    Statsig.logEvent = function(eventName, value, metadata) {
        if (value === void 0) value = null;
        if (metadata === void 0) metadata = null;
        return Statsig._getClientX().logEvent(eventName, value, metadata);
    };
    Statsig.updateUser = function(user) {
        return Statsig._getClientX().updateUser(user);
    };
    Statsig.updateUserWithValues = function(user, values) {
        return Statsig._getClientX().updateUserWithValues(user, values);
    };
    Statsig.shutdown = function() {
        Statsig._getClientX().shutdown();
        Statsig.instance = null;
    };
    Statsig.overrideGate = function(gate, result) {
        Statsig._getClientX().overrideGate(gate, result);
    };
    Statsig.overrideConfig = function(config, result) {
        Statsig._getClientX().overrideConfig(config, result);
    };
    Statsig.overrideLayer = function(layer, result) {
        Statsig._getClientX().overrideLayer(layer, result);
    };
    Statsig.setOverrides = function(overrides) {
        Statsig._getClientX().setOverrides(overrides);
    };
    Statsig.getOverrides = function() {
        return Statsig._getClientX().getOverrides();
    };
    /**
     * @returns The Statsig stable ID used for device level experiments
     */ Statsig.getStableID = function() {
        return Statsig._getClientX().getStableID();
    };
    /**
     *
     * @returns The reason and time associated with the evaluation for the current set
     * of gates and configs
     */ Statsig.getEvaluationDetails = function() {
        var _a, _b;
        return (_b = (_a = Statsig.instance) === null || _a === void 0 ? void 0 : _a.getEvaluationDetails()) !== null && _b !== void 0 ? _b : {
            reason: $6YuR1.EvaluationReason.Uninitialized,
            time: 0
        };
    };
    /**
     *
     * @returns true if initialize has already been called, false otherwise
     */ Statsig.initializeCalled = function() {
        return Statsig.instance != null && Statsig.instance.initializeCalled();
    };
    Statsig._getClientX = function() {
        if (!Statsig.instance) throw new $9KdHO.StatsigUninitializedError();
        return Statsig.instance;
    };
    Statsig.instance = null;
    return Statsig;
}();
module.exports.default = $d5321d0c8c8c5f62$var$Statsig;

});
parcelRegister("9KdHO", function(module, exports) {
"use strict";
var $71830a97cfc78e9f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSDKKeyMismatchError = module.exports.StatsigInvalidArgumentError = module.exports.StatsigUninitializedError = module.exports.StatsigErrorMessage = void 0;
var $71830a97cfc78e9f$var$StatsigErrorMessage;
(function(StatsigErrorMessage) {
    StatsigErrorMessage["REQUIRE_ASYNC_INITIALIZE"] = "Call initialize() first.";
    StatsigErrorMessage["REQUIRE_SYNC_INITIALIZE"] = "Call and wait for initialize() to finish first.";
    StatsigErrorMessage["REQUIRE_INITIALIZE_FOR_LOG_EVENT"] = "Must initialize() before logging events.";
})($71830a97cfc78e9f$var$StatsigErrorMessage = module.exports.StatsigErrorMessage || (module.exports.StatsigErrorMessage = {}));
var $71830a97cfc78e9f$var$StatsigUninitializedError = /** @class */ function(_super) {
    $71830a97cfc78e9f$var$__extends(StatsigUninitializedError, _super);
    function StatsigUninitializedError(message) {
        var _this = _super.call(this, message !== null && message !== void 0 ? message : $71830a97cfc78e9f$var$StatsigErrorMessage.REQUIRE_SYNC_INITIALIZE) || this;
        Object.setPrototypeOf(_this, StatsigUninitializedError.prototype);
        return _this;
    }
    return StatsigUninitializedError;
}(Error);
module.exports.StatsigUninitializedError = $71830a97cfc78e9f$var$StatsigUninitializedError;
var $71830a97cfc78e9f$var$StatsigInvalidArgumentError = /** @class */ function(_super) {
    $71830a97cfc78e9f$var$__extends(StatsigInvalidArgumentError, _super);
    function StatsigInvalidArgumentError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, StatsigInvalidArgumentError.prototype);
        return _this;
    }
    return StatsigInvalidArgumentError;
}(Error);
module.exports.StatsigInvalidArgumentError = $71830a97cfc78e9f$var$StatsigInvalidArgumentError;
var $71830a97cfc78e9f$var$StatsigSDKKeyMismatchError = /** @class */ function(_super) {
    $71830a97cfc78e9f$var$__extends(StatsigSDKKeyMismatchError, _super);
    function StatsigSDKKeyMismatchError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, StatsigSDKKeyMismatchError.prototype);
        return _this;
    }
    return StatsigSDKKeyMismatchError;
}(Error);
module.exports.StatsigSDKKeyMismatchError = $71830a97cfc78e9f$var$StatsigSDKKeyMismatchError;

});

parcelRegister("1TKi3", function(module, exports) {
"use strict";
var $161ed5c64bc94b26$var$__assign = module.exports && module.exports.__assign || function() {
    $161ed5c64bc94b26$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $161ed5c64bc94b26$var$__assign.apply(this, arguments);
};
var $161ed5c64bc94b26$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $161ed5c64bc94b26$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $161ed5c64bc94b26$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $161ed5c64bc94b26$var$__createBinding(result, mod, k);
    }
    $161ed5c64bc94b26$var$__setModuleDefault(result, mod);
    return result;
};
var $161ed5c64bc94b26$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $161ed5c64bc94b26$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $161ed5c64bc94b26$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $161ed5c64bc94b26$var$DynamicConfig_1 = $161ed5c64bc94b26$var$__importDefault((parcelRequire("kcbPW")));

var $161ed5c64bc94b26$var$ErrorBoundary_1 = $161ed5c64bc94b26$var$__importDefault((parcelRequire("le2YB")));

var $9KdHO = parcelRequire("9KdHO");

var $161ed5c64bc94b26$var$Layer_1 = $161ed5c64bc94b26$var$__importDefault((parcelRequire("01noY")));

var $161ed5c64bc94b26$var$StatsigIdentity_1 = $161ed5c64bc94b26$var$__importDefault((parcelRequire("3Z7YL")));

var $161ed5c64bc94b26$var$StatsigLogger_1 = $161ed5c64bc94b26$var$__importDefault((parcelRequire("8sION")));

var $161ed5c64bc94b26$var$StatsigNetwork_1 = $161ed5c64bc94b26$var$__importDefault((parcelRequire("9Cev3")));

var $161ed5c64bc94b26$var$StatsigSDKOptions_1 = $161ed5c64bc94b26$var$__importDefault((parcelRequire("8Lbg5")));

var $161ed5c64bc94b26$var$StatsigStore_1 = $161ed5c64bc94b26$var$__importStar((parcelRequire("6YuR1")));

var $6zTBX = parcelRequire("6zTBX");

var $161ed5c64bc94b26$var$StatsigLocalStorage_1 = $161ed5c64bc94b26$var$__importDefault((parcelRequire("eK7RG")));

var $k2HtX = parcelRequire("k2HtX");

var $161ed5c64bc94b26$var$LogEvent_1 = $161ed5c64bc94b26$var$__importDefault((parcelRequire("2xtD0")));

var $e0BEy = parcelRequire("e0BEy");
var $161ed5c64bc94b26$var$StatsigClient = /** @class */ function() {
    function StatsigClient(sdkKey, user, options) {
        var _this = this;
        this._initCalled = false;
        this._pendingInitPromise = null;
        this._sdkKey = null;
        this._logLayerParameterExposureForLayer = function(layer, parameterName, isManualExposure) {
            if (isManualExposure === void 0) isManualExposure = false;
            var allocatedExperiment = "";
            var exposures = layer._undelegatedSecondaryExposures;
            var isExplicit = layer._explicitParameters.includes(parameterName);
            if (isExplicit) {
                allocatedExperiment = layer._allocatedExperimentName;
                exposures = layer._secondaryExposures;
            }
            _this._logger.logLayerExposure(_this._identity._user, layer._name, layer._ruleID, exposures, allocatedExperiment, parameterName, isExplicit, layer._evaluationDetails, isManualExposure, _this._store.getBootstrapMetadata());
        };
        if ((options === null || options === void 0 ? void 0 : options.localMode) !== true && (typeof sdkKey !== "string" || !sdkKey.startsWith("client-"))) throw new $9KdHO.StatsigInvalidArgumentError("Invalid key provided.  You must use a Client SDK Key from the Statsig console to initialize the sdk");
        this._sdkKey = sdkKey;
        this._startTime = (0, $k2HtX.now)();
        this._options = new $161ed5c64bc94b26$var$StatsigSDKOptions_1.default(options);
        this._errorBoundary = new $161ed5c64bc94b26$var$ErrorBoundary_1.default(sdkKey, this._options);
        this._ready = false;
        $161ed5c64bc94b26$var$StatsigLocalStorage_1.default.disabled = this._options.disableLocalStorage;
        this._overrides = (0, $e0BEy.loadOverridesFromLocalStorage)();
        this._identity = new $161ed5c64bc94b26$var$StatsigIdentity_1.default(sdkKey, this._normalizeUser(user !== null && user !== void 0 ? user : null), this._options.overrideStableID);
        this._network = new $161ed5c64bc94b26$var$StatsigNetwork_1.default(this._options, this._identity, this._errorBoundary);
        this._logger = new $161ed5c64bc94b26$var$StatsigLogger_1.default(this._options, this._identity, this._network, this._errorBoundary);
        this._store = new $161ed5c64bc94b26$var$StatsigStore_1.default(this._identity, this._logger.logConfigDefaultValueFallback, this._options.initializeValues);
        this._errorBoundary._setStatsigMetadata(this._identity._statsigMetadata);
        if (this._options.initializeValues != null) {
            this._ready = true;
            this._initCalled = true;
            setTimeout(function() {
                return _this._delayedSetup();
            }, 20);
        }
    }
    StatsigClient.prototype.setInitializeValues = function(initializeValues) {
        var _this = this;
        this._errorBoundary._capture("setInitializeValues", function() {
            _this._store.bootstrap(initializeValues);
            if (!_this._ready) {
                // the sdk is usable and considered initialized when configured
                // with initializeValues
                _this._ready = true;
                _this._initCalled = true;
            }
            // we wont have access to window/document/localStorage if these run on the server
            // so try to run whenever this is called
            _this._logger.sendSavedRequests();
        }, function() {
            _this._ready = true;
            _this._initCalled = true;
        });
    };
    StatsigClient.prototype.initializeAsync = function() {
        return $161ed5c64bc94b26$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $161ed5c64bc94b26$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this._errorBoundary._capture("initializeAsync", function() {
                        return $161ed5c64bc94b26$var$__awaiter(_this, void 0, void 0, function() {
                            var user;
                            var _this = this;
                            return $161ed5c64bc94b26$var$__generator(this, function(_a) {
                                if (this._pendingInitPromise != null) return [
                                    2 /*return*/ ,
                                    this._pendingInitPromise
                                ];
                                if (this._ready) return [
                                    2 /*return*/ ,
                                    Promise.resolve()
                                ];
                                this._initCalled = true;
                                if (this._options.localMode) return [
                                    2 /*return*/ ,
                                    Promise.resolve()
                                ];
                                user = this._identity._user;
                                this._pendingInitPromise = this._fetchAndSaveValues(user, this._options.initTimeoutMs).then(function() {
                                    return;
                                }).catch(function(e) {
                                    _this._errorBoundary._logError("initializeAsync:fetchAndSaveValues", e);
                                    return {
                                        success: false,
                                        message: e.message
                                    };
                                }).then(function() {
                                    return;
                                }).finally(function() {
                                    return $161ed5c64bc94b26$var$__awaiter(_this, void 0, void 0, function() {
                                        return $161ed5c64bc94b26$var$__generator(this, function(_a) {
                                            this._pendingInitPromise = null;
                                            this._ready = true;
                                            this._delayedSetup();
                                            return [
                                                2 /*return*/ 
                                            ];
                                        });
                                    });
                                });
                                return [
                                    2 /*return*/ ,
                                    this._pendingInitPromise
                                ];
                            });
                        });
                    }, function() {
                        _this._ready = true;
                        _this._initCalled = true;
                        return Promise.resolve();
                    })
                ];
            });
        });
    };
    StatsigClient.prototype.getEvaluationDetails = function() {
        var _this = this;
        return this._errorBoundary._capture("getEvaluationDetails", function() {
            return _this._store.getGlobalEvaluationDetails();
        }, function() {
            return {
                time: Date.now(),
                reason: $161ed5c64bc94b26$var$StatsigStore_1.EvaluationReason.Error
            };
        });
    };
    /**
     * Checks the value of a gate for the current user
     * @param {string} gateName - the name of the gate to check
     * @returns {boolean} - value of a gate for the user. Gates are "off" (return false) by default
     * @throws Error if initialize() is not called first, or gateName is not a string
     */ StatsigClient.prototype.checkGate = function(gateName) {
        return this._checkGateImpl(gateName, "checkGate");
    };
    StatsigClient.prototype.checkGateWithExposureLoggingDisabled = function(gateName) {
        return this._checkGateImpl(gateName, "checkGateWithExposureLoggingDisabled");
    };
    StatsigClient.prototype.logGateExposure = function(gateName) {
        var _this = this;
        this._errorBoundary._swallow("logGateExposure", function() {
            _this._logGateExposureImpl(gateName);
        });
    };
    /**
     * Checks the value of a config for the current user
     * @param {string} configName - the name of the config to get
     * @returns {DynamicConfig} - value of a config for the user
     * @throws Error if initialize() is not called first, or configName is not a string
     */ StatsigClient.prototype.getConfig = function(configName) {
        return this._getConfigImpl(configName, "getConfig");
    };
    StatsigClient.prototype.getConfigWithExposureLoggingDisabled = function(configName) {
        return this._getConfigImpl(configName, "getConfigWithExposureLoggingDisabled");
    };
    StatsigClient.prototype.logConfigExposure = function(configName) {
        var _this = this;
        this._errorBoundary._swallow("logConfigExposure", function() {
            _this._logConfigExposureImpl(configName);
        });
    };
    StatsigClient.prototype.getExperiment = function(experimentName) {
        return this.getConfig(experimentName);
    };
    StatsigClient.prototype.getExperimentWithExposureLoggingDisabled = function(experimentName) {
        return this.getConfigWithExposureLoggingDisabled(experimentName);
    };
    StatsigClient.prototype.logExperimentExposure = function(experimentName) {
        this.logConfigExposure(experimentName);
    };
    StatsigClient.prototype.getLayer = function(layerName) {
        return this._getLayerImpl(layerName, "getLayer");
    };
    StatsigClient.prototype.getLayerWithExposureLoggingDisabled = function(layerName) {
        return this._getLayerImpl(layerName, "getLayerWithExposureLoggingDisabled");
    };
    StatsigClient.prototype.logLayerParameterExposure = function(layerName, parameterName) {
        var _this = this;
        this._errorBoundary._swallow("logLayerParameterExposure", function() {
            var layer = _this._getLayerFromStore(null, layerName);
            _this._logLayerParameterExposureForLayer(layer, parameterName, true);
        });
    };
    StatsigClient.prototype.logEvent = function(eventName, value, metadata) {
        var _this = this;
        if (value === void 0) value = null;
        if (metadata === void 0) metadata = null;
        this._errorBoundary._swallow("logEvent", function() {
            if (!_this._logger || !_this._identity._sdkKey) throw new $9KdHO.StatsigUninitializedError($9KdHO.StatsigErrorMessage.REQUIRE_INITIALIZE_FOR_LOG_EVENT);
            if (typeof eventName !== "string" || eventName.length === 0) return;
            var event = (0, $161ed5c64bc94b26$var$LogEvent_1.default)(eventName, _this._identity._user, _this._identity._statsigMetadata, value, metadata);
            _this._logger.log(event);
        });
    };
    StatsigClient.prototype.updateUserWithValues = function(user, values) {
        var _this = this;
        var updateStartTime = Date.now();
        var fireCompletionCallback;
        return this._errorBoundary._capture("updateUserWithValues", function() {
            if (!_this.initializeCalled()) throw new $9KdHO.StatsigUninitializedError($9KdHO.StatsigErrorMessage.REQUIRE_ASYNC_INITIALIZE);
            fireCompletionCallback = function(success, error) {
                var cb = _this._options.updateUserCompletionCallback;
                cb === null || cb === void 0 || cb(Date.now() - updateStartTime, success, error);
            };
            _this._identity._user = _this._normalizeUser(user);
            _this._store.bootstrap(values);
            _this._logger.resetDedupeKeys();
            fireCompletionCallback(true, null);
            return true;
        }, function() {
            fireCompletionCallback === null || fireCompletionCallback === void 0 || fireCompletionCallback(false, "Failed to update user. An unexpected error occured.");
            return false;
        });
    };
    StatsigClient.prototype.updateUser = function(user) {
        return $161ed5c64bc94b26$var$__awaiter(this, void 0, void 0, function() {
            var updateStartTime, fireCompletionCallback;
            var _this = this;
            return $161ed5c64bc94b26$var$__generator(this, function(_a) {
                updateStartTime = Date.now();
                return [
                    2 /*return*/ ,
                    this._errorBoundary._capture("updateUser", function() {
                        return $161ed5c64bc94b26$var$__awaiter(_this, void 0, void 0, function() {
                            var currentUser;
                            var _this = this;
                            return $161ed5c64bc94b26$var$__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!this.initializeCalled()) throw new $9KdHO.StatsigUninitializedError($9KdHO.StatsigErrorMessage.REQUIRE_ASYNC_INITIALIZE);
                                        fireCompletionCallback = function(success, error) {
                                            var cb = _this._options.updateUserCompletionCallback;
                                            cb === null || cb === void 0 || cb(Date.now() - updateStartTime, success, error);
                                        };
                                        this._identity._user = this._normalizeUser(user);
                                        this._store.updateUser();
                                        this._logger.resetDedupeKeys();
                                        if (!(this._pendingInitPromise != null)) return [
                                            3 /*break*/ ,
                                            2
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            this._pendingInitPromise
                                        ];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2:
                                        if (this._options.localMode) {
                                            fireCompletionCallback(true, null);
                                            return [
                                                2 /*return*/ ,
                                                Promise.resolve(true)
                                            ];
                                        }
                                        currentUser = this._identity._user;
                                        this._pendingInitPromise = this._fetchAndSaveValues(currentUser).finally(function() {
                                            _this._pendingInitPromise = null;
                                        });
                                        return [
                                            2 /*return*/ ,
                                            this._pendingInitPromise.then(function() {
                                                fireCompletionCallback(true, null);
                                                return Promise.resolve(true);
                                            }).catch(function(error) {
                                                fireCompletionCallback(false, "Failed to update user: ".concat(error));
                                                return Promise.resolve(false);
                                            })
                                        ];
                                }
                            });
                        });
                    }, function() {
                        fireCompletionCallback(false, "Failed to update user. An unexpected error occured.");
                        return Promise.resolve(false);
                    })
                ];
            });
        });
    };
    /**
     * Informs the statsig SDK that the client is closing or shutting down
     * so the SDK can clean up internal state
     */ StatsigClient.prototype.shutdown = function() {
        var _this = this;
        this._errorBoundary._swallow("shutdown", function() {
            _this._logger.shutdown();
        });
    };
    /**
     * @returns The Statsig stable ID used for device level experiments
     */ StatsigClient.prototype.getStableID = function() {
        var _this = this;
        return this._errorBoundary._capture("getStableID", function() {
            return _this._identity._statsigMetadata.stableID;
        }, function() {
            return "";
        });
    };
    StatsigClient.prototype.initializeCalled = function() {
        return this._initCalled;
    };
    StatsigClient.prototype.overrideGate = function(gate, result) {
        this._setOverride("gates", gate, result);
    };
    StatsigClient.prototype.overrideConfig = function(config, result) {
        this._setOverride("configs", config, result);
    };
    StatsigClient.prototype.overrideLayer = function(layer, result) {
        this._setOverride("layers", layer, result);
    };
    StatsigClient.prototype.setOverrides = function(overrides) {
        var _this = this;
        this._errorBoundary._swallow("setOverrides", function() {
            _this._overrides = overrides !== null && overrides !== void 0 ? overrides : (0, $e0BEy.makeEmptyOverrides)();
            (0, $e0BEy.saveOverridesToLocalStorage)(_this._overrides);
        });
    };
    StatsigClient.prototype.getOverrides = function() {
        var _this = this;
        return this._errorBoundary._capture("getOverrides", function() {
            return _this._overrides;
        }, function() {
            return (0, $e0BEy.makeEmptyOverrides)();
        });
    };
    // Private
    StatsigClient.prototype._delayedSetup = function() {
        var _this = this;
        this._errorBoundary._swallow("delayedSetup", function() {
            _this._identity.saveStableID();
            _this._logger.sendSavedRequests().then(function() {
            /* noop */ });
        });
    };
    StatsigClient.prototype._normalizeUser = function(user) {
        var userCopy = {};
        try {
            userCopy = JSON.parse(JSON.stringify(user));
        } catch (error) {
            throw new $9KdHO.StatsigInvalidArgumentError("User object must be convertable to JSON string.");
        }
        if (this._options.environment != null) userCopy = $161ed5c64bc94b26$var$__assign($161ed5c64bc94b26$var$__assign({}, userCopy), {
            statsigEnvironment: this._options.environment
        });
        return userCopy;
    };
    StatsigClient.prototype._ensureStoreLoaded = function() {
        if (!this._store.isLoaded()) throw new $9KdHO.StatsigUninitializedError();
    };
    StatsigClient.prototype._getEvaluationDetailsForError = function() {
        return {
            time: Date.now(),
            reason: $161ed5c64bc94b26$var$StatsigStore_1.EvaluationReason.Error
        };
    };
    StatsigClient.prototype._fetchAndSaveValues = function(user, timeout) {
        if (timeout === void 0) timeout = this._options.initTimeoutMs;
        return $161ed5c64bc94b26$var$__awaiter(this, void 0, void 0, function() {
            var sinceTime, previousDerivedFields;
            var _this = this;
            return $161ed5c64bc94b26$var$__generator(this, function(_a) {
                sinceTime = null;
                sinceTime = this._store.getLastUpdateTime(user);
                previousDerivedFields = this._store.getPreviousDerivedFields(user);
                return [
                    2 /*return*/ ,
                    this._network.fetchValues(user, sinceTime, timeout, previousDerivedFields).eventually(function(json) {
                        var _a;
                        if (!(0, $6zTBX.verifySDKKeyUsed)(json, (_a = _this._sdkKey) !== null && _a !== void 0 ? _a : "", _this._errorBoundary)) return;
                        if (json === null || json === void 0 ? void 0 : json.has_updates) _this._store.save(user, json, false);
                    }).then(function(json) {
                        return $161ed5c64bc94b26$var$__awaiter(_this, void 0, void 0, function() {
                            var _this = this;
                            return $161ed5c64bc94b26$var$__generator(this, function(_a) {
                                return [
                                    2 /*return*/ ,
                                    this._errorBoundary._swallow("fetchAndSaveValues", function() {
                                        return $161ed5c64bc94b26$var$__awaiter(_this, void 0, void 0, function() {
                                            var _a;
                                            return $161ed5c64bc94b26$var$__generator(this, function(_b) {
                                                switch(_b.label){
                                                    case 0:
                                                        if (!(0, $6zTBX.verifySDKKeyUsed)(json, (_a = this._sdkKey) !== null && _a !== void 0 ? _a : "", this._errorBoundary)) return [
                                                            2 /*return*/ 
                                                        ];
                                                        if (!(json === null || json === void 0 ? void 0 : json.has_updates)) return [
                                                            3 /*break*/ ,
                                                            2
                                                        ];
                                                        return [
                                                            4 /*yield*/ ,
                                                            this._store.save(user, json)
                                                        ];
                                                    case 1:
                                                        _b.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            3
                                                        ];
                                                    case 2:
                                                        if (json === null || json === void 0 ? void 0 : json.is_no_content) this._store.setEvaluationReason($161ed5c64bc94b26$var$StatsigStore_1.EvaluationReason.NetworkNotModified);
                                                        _b.label = 3;
                                                    case 3:
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                }
                                            });
                                        });
                                    })
                                ];
                            });
                        });
                    })
                ];
            });
        });
    };
    StatsigClient.prototype._checkGateImpl = function(gateName, callsite) {
        var _this = this;
        return this._errorBoundary._capture(callsite, function() {
            if (typeof _this._overrides.gates[gateName] === "boolean") return _this._overrides.gates[gateName];
            var result = _this._getGateFromStore(gateName);
            if (callsite === "checkGate") _this._logGateExposureImpl(gateName, result);
            return result.gate.value === true;
        }, function() {
            return false;
        });
    };
    StatsigClient.prototype._getGateFromStore = function(gateName) {
        this._ensureStoreLoaded();
        if (typeof gateName !== "string" || gateName.length === 0) throw new $9KdHO.StatsigInvalidArgumentError("Must pass a valid string as the gateName.");
        return this._store.checkGate(gateName);
    };
    StatsigClient.prototype._logGateExposureImpl = function(gateName, fetchResult) {
        var isManualExposure = !fetchResult;
        var result = fetchResult !== null && fetchResult !== void 0 ? fetchResult : this._getGateFromStore(gateName);
        var gate = result.gate;
        this._logger.logGateExposure(this._identity._user, gateName, gate.value, gate.rule_id, gate.secondary_exposures, result.evaluationDetails, isManualExposure, this._store.getBootstrapMetadata());
    };
    StatsigClient.prototype._getConfigImpl = function(configName, callsite) {
        var _this = this;
        return this._errorBoundary._capture(callsite, function() {
            if (_this._overrides.configs[configName]) return new $161ed5c64bc94b26$var$DynamicConfig_1.default(configName, _this._overrides.configs[configName], "local_override", {
                reason: $161ed5c64bc94b26$var$StatsigStore_1.EvaluationReason.LocalOverride,
                time: Date.now()
            });
            var result = _this._getConfigFromStore(configName);
            if (callsite === "getConfig") _this._logConfigExposureImpl(configName, result);
            return result;
        }, function() {
            return _this._getEmptyConfig(configName);
        });
    };
    StatsigClient.prototype._getConfigFromStore = function(configName) {
        this._ensureStoreLoaded();
        if (typeof configName !== "string" || configName.length === 0) throw new $9KdHO.StatsigInvalidArgumentError("Must pass a valid string as the configName.");
        return this._store.getConfig(configName);
    };
    StatsigClient.prototype._logConfigExposureImpl = function(configName, config) {
        var isManualExposure = !config;
        var localConfig = config !== null && config !== void 0 ? config : this._getConfigFromStore(configName);
        this._logger.logConfigExposure(this._identity._user, configName, localConfig._ruleID, localConfig._secondaryExposures, localConfig._evaluationDetails, isManualExposure, this._store.getBootstrapMetadata());
    };
    StatsigClient.prototype._getLayerImpl = function(layerName, callsite) {
        var _this = this;
        return this._errorBoundary._capture(callsite, function() {
            if (_this._overrides.layers[layerName]) return $161ed5c64bc94b26$var$Layer_1.default._create(layerName, _this._overrides.layers[layerName], "local_override", {
                reason: $161ed5c64bc94b26$var$StatsigStore_1.EvaluationReason.LocalOverride,
                time: Date.now()
            });
            var logFunc = callsite === "getLayer" ? _this._logLayerParameterExposureForLayer : null;
            return _this._getLayerFromStore(logFunc, layerName);
        }, function() {
            return $161ed5c64bc94b26$var$Layer_1.default._create(layerName, {}, "", _this._getEvaluationDetailsForError());
        });
    };
    StatsigClient.prototype._getLayerFromStore = function(logParameterFunction, layerName) {
        this._ensureStoreLoaded();
        if (typeof layerName !== "string" || layerName.length === 0) throw new $9KdHO.StatsigInvalidArgumentError("Must pass a valid string as the layerName.");
        return this._store.getLayer(logParameterFunction, layerName);
    };
    StatsigClient.prototype._getEmptyConfig = function(configName) {
        return new $161ed5c64bc94b26$var$DynamicConfig_1.default(configName, {}, "", this._getEvaluationDetailsForError());
    };
    StatsigClient.prototype._setOverride = function(type, key, result) {
        if (result == null) delete this._overrides[type][key];
        else this._overrides[type][key] = result;
        this.setOverrides(this._overrides);
    };
    return StatsigClient;
}();
module.exports.default = $161ed5c64bc94b26$var$StatsigClient;

});
parcelRegister("kcbPW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $eb3e1c2fb9069647$var$DynamicConfig = /** @class */ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails, secondaryExposures, allocatedExperimentName, onDefaultValueFallback) {
        if (secondaryExposures === void 0) secondaryExposures = [];
        if (allocatedExperimentName === void 0) allocatedExperimentName = "";
        if (onDefaultValueFallback === void 0) onDefaultValueFallback = null;
        this._onDefaultValueFallback = null;
        this.value = JSON.parse(JSON.stringify(configValue !== null && configValue !== void 0 ? configValue : {}));
        this._name = configName;
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : "";
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    DynamicConfig.prototype.get = function(key, defaultValue, typeGuard) {
        var _a, _b;
        var val = this.getValue(key, defaultValue);
        if (val == null) return defaultValue;
        var expectedType = Array.isArray(defaultValue) ? "array" : typeof defaultValue;
        var actualType = Array.isArray(val) ? "array" : typeof val;
        if (typeGuard) {
            if (typeGuard(val)) return val;
            (_a = this._onDefaultValueFallback) === null || _a === void 0 || _a.call(this, this, key, expectedType, actualType);
            return defaultValue;
        }
        if (defaultValue == null || expectedType === actualType) return val;
        (_b = this._onDefaultValueFallback) === null || _b === void 0 || _b.call(this, this, key, expectedType, actualType);
        return defaultValue;
    };
    DynamicConfig.prototype.getValue = function(key, defaultValue) {
        if (key == null) return this.value;
        if (defaultValue == null) defaultValue = null;
        if (this.value[key] == null) return defaultValue;
        return this.value[key];
    };
    return DynamicConfig;
}();
module.exports.default = $eb3e1c2fb9069647$var$DynamicConfig;

});

parcelRegister("le2YB", function(module, exports) {
"use strict";
var $f73d36d3d1d1fe05$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f73d36d3d1d1fe05$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExceptionEndpoint = void 0;

var $9KdHO = parcelRequire("9KdHO");
module.exports.ExceptionEndpoint = "https://statsigapi.net/v1/sdk_exception";
var $f73d36d3d1d1fe05$var$ErrorBoundary = /** @class */ function() {
    function ErrorBoundary(sdkKey, options) {
        this._seen = new Set();
        this._sdkKey = sdkKey;
        this._options = options;
    }
    ErrorBoundary.prototype._setStatsigMetadata = function(statsigMetadata) {
        this._statsigMetadata = statsigMetadata;
    };
    ErrorBoundary.prototype._swallow = function(tag, task) {
        this._capture(tag, task, function() {
            return undefined;
        });
    };
    ErrorBoundary.prototype._capture = function(tag, task, recover, getExtraData) {
        var _this = this;
        try {
            var result = task();
            if (result instanceof Promise) return result.catch(function(e) {
                return _this._onCaught(tag, e, recover, getExtraData);
            });
            return result;
        } catch (error) {
            return this._onCaught(tag, error, recover, getExtraData);
        }
    };
    ErrorBoundary.prototype._logError = function(tag, error, getExtraData) {
        var _this = this;
        if (this._options.disableAllLogging) return;
        try {
            var impl = function() {
                return $f73d36d3d1d1fe05$var$__awaiter(_this, void 0, void 0, function() {
                    var extra, _a, unwrapped, isError, name, info, metadata, body;
                    var _b;
                    return $f73d36d3d1d1fe05$var$__generator(this, function(_c) {
                        switch(_c.label){
                            case 0:
                                if (!(typeof getExtraData === "function")) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    getExtraData()
                                ];
                            case 1:
                                _a = _c.sent();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                _a = null;
                                _c.label = 3;
                            case 3:
                                extra = _a;
                                unwrapped = error !== null && error !== void 0 ? error : Error("[Statsig] Error was empty");
                                isError = unwrapped instanceof Error;
                                name = isError ? unwrapped.name : "No Name";
                                if (this._seen.has(name)) return [
                                    2 /*return*/ 
                                ];
                                this._seen.add(name);
                                info = isError ? unwrapped.stack : this._getDescription(unwrapped);
                                metadata = (_b = this._statsigMetadata) !== null && _b !== void 0 ? _b : {};
                                body = JSON.stringify({
                                    tag: tag,
                                    exception: name,
                                    info: info,
                                    statsigMetadata: metadata,
                                    extra: extra !== null && extra !== void 0 ? extra : {}
                                });
                                return [
                                    2 /*return*/ ,
                                    fetch(module.exports.ExceptionEndpoint, {
                                        method: "POST",
                                        headers: {
                                            "STATSIG-API-KEY": this._sdkKey,
                                            "STATSIG-SDK-TYPE": String(metadata["sdkType"]),
                                            "STATSIG-SDK-VERSION": String(metadata["sdkVersion"]),
                                            "Content-Type": "application/json",
                                            "Content-Length": "".concat(body.length)
                                        },
                                        body: body
                                    })
                                ];
                        }
                    });
                });
            };
            impl().then(function() {
            /* noop */ }).catch(function() {
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    };
    ErrorBoundary.prototype._onCaught = function(tag, error, recover, getExtraData) {
        if (error instanceof $9KdHO.StatsigUninitializedError || error instanceof $9KdHO.StatsigInvalidArgumentError) throw error; // Don't catch these
        console.error("[Statsig] An unexpected exception occurred.", error);
        this._logError(tag, error, getExtraData);
        return recover();
    };
    ErrorBoundary.prototype._getDescription = function(obj) {
        try {
            return JSON.stringify(obj);
        } catch (_a) {
            return "[Statsig] Failed to get string for error.";
        }
    };
    return ErrorBoundary;
}();
module.exports.default = $f73d36d3d1d1fe05$var$ErrorBoundary;

});

parcelRegister("01noY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $00423f3972760054$var$Layer = /** @class */ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails, logParameterFunction, secondaryExposures, undelegatedSecondaryExposures, allocatedExperimentName, explicitParameters) {
        if (logParameterFunction === void 0) logParameterFunction = null;
        if (secondaryExposures === void 0) secondaryExposures = [];
        if (undelegatedSecondaryExposures === void 0) undelegatedSecondaryExposures = [];
        if (allocatedExperimentName === void 0) allocatedExperimentName = "";
        if (explicitParameters === void 0) explicitParameters = [];
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : "";
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    Layer._create = function(name, value, ruleID, evaluationDetails, logParameterFunction, secondaryExposures, undelegatedSecondaryExposures, allocatedExperimentName, explicitParameters) {
        if (logParameterFunction === void 0) logParameterFunction = null;
        if (secondaryExposures === void 0) secondaryExposures = [];
        if (undelegatedSecondaryExposures === void 0) undelegatedSecondaryExposures = [];
        if (allocatedExperimentName === void 0) allocatedExperimentName = "";
        if (explicitParameters === void 0) explicitParameters = [];
        return new Layer(name, value, ruleID, evaluationDetails, logParameterFunction, secondaryExposures, undelegatedSecondaryExposures, allocatedExperimentName, explicitParameters);
    };
    Layer.prototype.get = function(key, defaultValue, typeGuard) {
        var _this = this;
        var val = this._value[key];
        if (val == null) return defaultValue;
        var logAndReturn = function() {
            _this._logLayerParameterExposure(key);
            return val;
        };
        if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
        if (defaultValue == null) return logAndReturn();
        if (typeof val === typeof defaultValue && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
        return defaultValue;
    };
    Layer.prototype.getValue = function(key, defaultValue) {
        if (defaultValue == undefined) defaultValue = null;
        var val = this._value[key];
        if (val != null) this._logLayerParameterExposure(key);
        return val !== null && val !== void 0 ? val : defaultValue;
    };
    Layer.prototype._logLayerParameterExposure = function(parameterName) {
        var _a;
        (_a = this._logParameterFunction) === null || _a === void 0 || _a.call(this, this, parameterName);
    };
    return Layer;
}();
module.exports.default = $00423f3972760054$var$Layer;

});

parcelRegister("3Z7YL", function(module, exports) {
"use strict";
var $2e6d42106327439a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3Kmxx = parcelRequire("3Kmxx");

var $9PHrf = parcelRequire("9PHrf");

var $2e6d42106327439a$var$StatsigLocalStorage_1 = $2e6d42106327439a$var$__importDefault((parcelRequire("eK7RG")));

var $9dxt2 = parcelRequire("9dxt2");
var $2e6d42106327439a$var$Identity = /** @class */ function() {
    function Identity(sdkKey, user, overrideStableID) {
        var _a;
        this._sdkType = "js-lite";
        this._sdkKey = sdkKey;
        this._user = user;
        this._sdkVersion = $9dxt2.version;
        var stableID = overrideStableID;
        stableID = (_a = stableID !== null && stableID !== void 0 ? stableID : $2e6d42106327439a$var$StatsigLocalStorage_1.default.getItem($3Kmxx.STATSIG_STABLE_ID_KEY)) !== null && _a !== void 0 ? _a : this._getUUID();
        this._statsigMetadata = {
            stableID: stableID,
            sdkType: this._sdkType,
            sdkVersion: this._sdkVersion
        };
    }
    Identity.prototype.saveStableID = function() {
        if (this._statsigMetadata.stableID != null) $2e6d42106327439a$var$StatsigLocalStorage_1.default.setItem($3Kmxx.STATSIG_STABLE_ID_KEY, this._statsigMetadata.stableID);
    };
    Identity.prototype.getUserCacheKey = function() {
        return (0, $9PHrf.getUserCacheKey)(this._user);
    };
    Identity.prototype._getUUID = function() {
        var uuid = "";
        for(var i = 0; i < 32; i++){
            if (i === 8 || i === 12 || i === 16 || i === 20) uuid += "-";
            var randomDigit = Math.random() * 16 | 0;
            if (i === 12) uuid += "4";
            else if (i === 16) uuid += (randomDigit & 3 | 8).toString(16);
            else uuid += randomDigit.toString(16);
        }
        return uuid;
    };
    return Identity;
}();
module.exports.default = $2e6d42106327439a$var$Identity;

});
parcelRegister("3Kmxx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LOCAL_STORAGE_KEYS = module.exports.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY = module.exports.STATSIG_STABLE_ID_KEY = module.exports.INTERNAL_STORE_KEY = void 0;
module.exports.INTERNAL_STORE_KEY = "STATSIG_STORE";
module.exports.STATSIG_STABLE_ID_KEY = "STATSIG_STABLE_ID";
module.exports.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY = "STATSIG_LOGS";
module.exports.LOCAL_STORAGE_KEYS = {
    INTERNAL_STORE_KEY: true,
    STATSIG_STABLE_ID_KEY: true,
    STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY: true
};

});

parcelRegister("9PHrf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUserCacheKey = module.exports.getSortedObject = module.exports.djb2HashForObject = module.exports.getHashValue = module.exports.SimpleHash = void 0;
function $728a927409fb8e91$var$SimpleHash(value) {
    var hash = 0;
    for(var i = 0; i < value.length; i++){
        var character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
}
module.exports.SimpleHash = $728a927409fb8e91$var$SimpleHash;
function $728a927409fb8e91$var$getHashValue(value, hash_used) {
    if (hash_used === "none") return value;
    return $728a927409fb8e91$var$SimpleHash(value);
}
module.exports.getHashValue = $728a927409fb8e91$var$getHashValue;
function $728a927409fb8e91$var$djb2HashForObject(object) {
    return $728a927409fb8e91$var$SimpleHash(JSON.stringify($728a927409fb8e91$var$getSortedObject(object)));
}
module.exports.djb2HashForObject = $728a927409fb8e91$var$djb2HashForObject;
function $728a927409fb8e91$var$getSortedObject(object) {
    if (object == null) return null;
    var keys = Object.keys(object).sort();
    var sortedObject = {};
    keys.forEach(function(key) {
        var value = object[key];
        if (value instanceof Object) value = $728a927409fb8e91$var$getSortedObject(value);
        sortedObject[key] = value;
    });
    return sortedObject;
}
module.exports.getSortedObject = $728a927409fb8e91$var$getSortedObject;
function $728a927409fb8e91$var$getUserCacheKey(user) {
    var _a;
    var key = "userID:".concat(String((_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ""));
    var customIDs = user === null || user === void 0 ? void 0 : user.customIDs;
    if (customIDs != null) for(var _i = 0, _b = Object.entries(customIDs); _i < _b.length; _i++){
        var _c = _b[_i], type = _c[0], value = _c[1];
        key += ";".concat(type, ":").concat(value);
    }
    return $728a927409fb8e91$var$SimpleHash(key);
}
module.exports.getUserCacheKey = $728a927409fb8e91$var$getUserCacheKey;

});

parcelRegister("eK7RG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $abbb765cba8599fe$var$StatsigLocalStorage = /** @class */ function() {
    function StatsigLocalStorage() {}
    StatsigLocalStorage.getItem = function(key) {
        var _a;
        try {
            if (this.isStorageAccessible()) return window.localStorage.getItem(key);
        } catch (e) {}
        return (_a = this.fallbackSessionCache[key]) !== null && _a !== void 0 ? _a : null;
    };
    StatsigLocalStorage.setItem = function(key, value) {
        try {
            if (this.isStorageAccessible()) {
                window.localStorage.setItem(key, value);
                return;
            }
        } catch (e) {}
        this.fallbackSessionCache[key] = value;
    };
    StatsigLocalStorage.removeItem = function(key) {
        try {
            if (this.isStorageAccessible()) {
                window.localStorage.removeItem(key);
                return;
            }
        } catch (e) {}
        delete this.fallbackSessionCache[key];
    };
    StatsigLocalStorage.isStorageAccessible = function(ignoreDisabledOption) {
        if (ignoreDisabledOption === void 0) ignoreDisabledOption = false;
        if (this.canAccessStorageAccessible == null) this.canAccessStorageAccessible = typeof Storage !== "undefined" && typeof window !== "undefined" && window != null && window.localStorage != null;
        var canAccess = this.canAccessStorageAccessible;
        if (ignoreDisabledOption) return canAccess;
        return !this.disabled && canAccess;
    };
    StatsigLocalStorage.disabled = false;
    StatsigLocalStorage.fallbackSessionCache = {};
    StatsigLocalStorage.canAccessStorageAccessible = null;
    return StatsigLocalStorage;
}();
module.exports.default = $abbb765cba8599fe$var$StatsigLocalStorage;

});

parcelRegister("9dxt2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.version = void 0;
// Generated by genversion.
module.exports.version = "1.4.0";

});


parcelRegister("8sION", function(module, exports) {
"use strict";
var $6293b43a8eb778c2$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6293b43a8eb778c2$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $6293b43a8eb778c2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6293b43a8eb778c2$var$LogEvent_1 = $6293b43a8eb778c2$var$__importDefault((parcelRequire("2xtD0")));

var $9Cev3 = parcelRequire("9Cev3");

var $3Kmxx = parcelRequire("3Kmxx");

var $6293b43a8eb778c2$var$StatsigLocalStorage_1 = $6293b43a8eb778c2$var$__importDefault((parcelRequire("eK7RG")));
var $6293b43a8eb778c2$var$INTERNAL_EVENT_PREFIX = "statsig::";
var $6293b43a8eb778c2$var$CONFIG_EXPOSURE_EVENT = $6293b43a8eb778c2$var$INTERNAL_EVENT_PREFIX + "config_exposure";
var $6293b43a8eb778c2$var$LAYER_EXPOSURE_EVENT = $6293b43a8eb778c2$var$INTERNAL_EVENT_PREFIX + "layer_exposure";
var $6293b43a8eb778c2$var$GATE_EXPOSURE_EVENT = $6293b43a8eb778c2$var$INTERNAL_EVENT_PREFIX + "gate_exposure";
var $6293b43a8eb778c2$var$LOG_FAILURE_EVENT = $6293b43a8eb778c2$var$INTERNAL_EVENT_PREFIX + "log_event_failed";
var $6293b43a8eb778c2$var$DEFAULT_VALUE_WARNING = $6293b43a8eb778c2$var$INTERNAL_EVENT_PREFIX + "default_value_type_mismatch";
var $6293b43a8eb778c2$var$MS_RETRY_LOGS_CUTOFF = 432000000;
var $6293b43a8eb778c2$var$MAX_BATCHES_TO_RETRY = 100;
var $6293b43a8eb778c2$var$MAX_FAILED_EVENTS = 1000;
var $6293b43a8eb778c2$var$MAX_LOCAL_STORAGE_SIZE = 1024 * $6293b43a8eb778c2$var$MAX_FAILED_EVENTS;
var $6293b43a8eb778c2$var$StatsigLogger = /** @class */ function() {
    function StatsigLogger(options, identity, network, errorBoundary) {
        var _this = this;
        this._failedLogEventCount = 0;
        this.logConfigDefaultValueFallback = function(user, message, metadata) {
            var defaultValueEvent = (0, $6293b43a8eb778c2$var$LogEvent_1.default)($6293b43a8eb778c2$var$DEFAULT_VALUE_WARNING, user, _this._identity._statsigMetadata, message, metadata);
            _this.log(defaultValueEvent);
            _this._loggedErrors.add(message);
        };
        this._options = options;
        this._identity = identity;
        this._network = network;
        this._errorBoundary = errorBoundary;
        this._queue = [];
        this._flushInterval = null;
        this._loggedErrors = new Set();
        this._failedLogEvents = [];
        this._exposureDedupeKeys = {};
        this._failedLogEventCount = 0;
        this._init();
    }
    StatsigLogger.prototype.log = function(event) {
        if (this._options.disableAllLogging) return;
        try {
            if (!this._options.disableCurrentPageLogging && typeof window !== "undefined" && window != null && typeof window.location === "object" && typeof window.location.href === "string") {
                // https://stackoverflow.com/questions/6257463/how-to-get-the-url-without-any-parameters-in-javascript
                var parts = window.location.href.split(/[?#]/);
                if ((parts === null || parts === void 0 ? void 0 : parts.length) > 0) event.statsigMetadata.currentPage = parts[0];
            }
        } catch (_e) {}
        this._queue.push(event);
        if (this._queue.length >= this._options.loggingBufferMaxSize) this.flush();
    };
    StatsigLogger.prototype.resetDedupeKeys = function() {
        this._exposureDedupeKeys = {};
    };
    StatsigLogger.prototype.logGateExposure = function(user, gateName, gateValue, ruleID, secondaryExposures, details, isManualExposure, bootstrapMetadata) {
        var dedupeKey = gateName + String(gateValue) + ruleID + details.reason;
        if (!this._shouldLogExposure(dedupeKey)) return;
        var metadata = {
            gate: gateName,
            gateValue: String(gateValue),
            ruleID: ruleID,
            reason: details.reason,
            time: details.time
        };
        if (isManualExposure) metadata["isManualExposure"] = "true";
        if (bootstrapMetadata != null) metadata["bootstrapMetadata"] = bootstrapMetadata;
        var gateExposure = (0, $6293b43a8eb778c2$var$LogEvent_1.default)($6293b43a8eb778c2$var$GATE_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
        this.log(gateExposure);
    };
    StatsigLogger.prototype.logConfigExposure = function(user, configName, ruleID, secondaryExposures, details, isManualExposure, bootstrapMetadata) {
        var dedupeKey = configName + ruleID + details.reason;
        if (!this._shouldLogExposure(dedupeKey)) return;
        var metadata = {
            config: configName,
            ruleID: ruleID,
            reason: details.reason,
            time: details.time
        };
        if (isManualExposure) metadata["isManualExposure"] = "true";
        if (bootstrapMetadata != null) metadata["bootstrapMetadata"] = bootstrapMetadata;
        var configExposure = (0, $6293b43a8eb778c2$var$LogEvent_1.default)($6293b43a8eb778c2$var$CONFIG_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
        this.log(configExposure);
    };
    StatsigLogger.prototype.logLayerExposure = function(user, configName, ruleID, secondaryExposures, allocatedExperiment, parameterName, isExplicitParameter, details, isManualExposure, bootstrapMetadata) {
        var dedupeKey = [
            configName,
            ruleID,
            allocatedExperiment,
            parameterName,
            String(isExplicitParameter),
            details.reason
        ].join("|");
        if (!this._shouldLogExposure(dedupeKey)) return;
        var metadata = {
            config: configName,
            ruleID: ruleID,
            allocatedExperiment: allocatedExperiment,
            parameterName: parameterName,
            isExplicitParameter: String(isExplicitParameter),
            reason: details.reason,
            time: details.time
        };
        if (isManualExposure) metadata["isManualExposure"] = "true";
        if (bootstrapMetadata != null) metadata["bootstrapMetadata"] = bootstrapMetadata;
        var configExposure = (0, $6293b43a8eb778c2$var$LogEvent_1.default)($6293b43a8eb778c2$var$LAYER_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
        this.log(configExposure);
    };
    StatsigLogger.prototype.shutdown = function() {
        if (this._flushInterval) {
            clearInterval(this._flushInterval);
            this._flushInterval = null;
        }
        this.flush(true);
    };
    StatsigLogger.prototype.flush = function(isClosing) {
        var _this = this;
        if (isClosing === void 0) isClosing = false;
        if (this._queue.length === 0) return;
        var statsigMetadata = this._identity._statsigMetadata;
        var oldQueue = this._queue;
        this._queue = [];
        if (isClosing && !this._network.supportsKeepalive() && typeof navigator !== "undefined" && navigator != null && // @ts-ignore
        navigator.sendBeacon) {
            var beacon = this._network.sendLogBeacon({
                events: oldQueue,
                statsigMetadata: statsigMetadata
            });
            if (!beacon) {
                this._queue = oldQueue.concat(this._queue);
                if (this._queue.length > 0) {
                    this._addFailedRequest({
                        events: this._queue,
                        statsigMetadata: statsigMetadata,
                        time: Date.now()
                    });
                    this._queue = [];
                }
                this._saveFailedRequests();
            }
            return;
        }
        var processor = this;
        this._network.postToEndpoint($9Cev3.StatsigEndpoint.Rgstr, {
            events: oldQueue,
            statsigMetadata: statsigMetadata
        }, 3 /* retries */ , 1000 /* backoff */ , isClosing /* useKeepalive */ ).then(function(response) {
            if (!response.ok) throw response;
        }).catch(function(error) {
            if (typeof error.text === "function") error.text().then(function(errorText) {
                _this._errorBoundary._logError($6293b43a8eb778c2$var$LOG_FAILURE_EVENT, error, function() {
                    return $6293b43a8eb778c2$var$__awaiter(_this, void 0, void 0, function() {
                        return $6293b43a8eb778c2$var$__generator(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                {
                                    eventCount: oldQueue.length,
                                    error: errorText
                                }
                            ];
                        });
                    });
                });
            });
            else _this._errorBoundary._logError($6293b43a8eb778c2$var$LOG_FAILURE_EVENT, error, function() {
                return $6293b43a8eb778c2$var$__awaiter(_this, void 0, void 0, function() {
                    return $6293b43a8eb778c2$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            {
                                eventCount: oldQueue.length,
                                error: error.message
                            }
                        ];
                    });
                });
            });
            processor._newFailedRequest($6293b43a8eb778c2$var$LOG_FAILURE_EVENT, oldQueue);
        }).finally(function() {
            return $6293b43a8eb778c2$var$__awaiter(_this, void 0, void 0, function() {
                return $6293b43a8eb778c2$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!isClosing) return [
                                3 /*break*/ ,
                                2
                            ];
                            if (this._queue.length > 0) {
                                this._addFailedRequest({
                                    events: this._queue,
                                    statsigMetadata: statsigMetadata,
                                    time: Date.now()
                                });
                                // on app background/window blur, save unsent events as a request and clean up the queue (in case app foregrounds)
                                this._queue = [];
                            }
                            return [
                                4 /*yield*/ ,
                                processor._saveFailedRequests()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    StatsigLogger.prototype.sendSavedRequests = function() {
        return $6293b43a8eb778c2$var$__awaiter(this, void 0, void 0, function() {
            var failedRequests, fireAndForget, requestBodies, _loop_1, this_1, _i, requestBodies_1, requestBody;
            var _this = this;
            return $6293b43a8eb778c2$var$__generator(this, function(_a) {
                fireAndForget = false;
                failedRequests = $6293b43a8eb778c2$var$StatsigLocalStorage_1.default.getItem($3Kmxx.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY);
                if (failedRequests == null) {
                    this._clearLocalStorageRequests();
                    return [
                        2 /*return*/ 
                    ];
                }
                if (failedRequests.length > $6293b43a8eb778c2$var$MAX_LOCAL_STORAGE_SIZE) fireAndForget = true;
                requestBodies = [];
                try {
                    requestBodies = JSON.parse(failedRequests);
                    _loop_1 = function(requestBody) {
                        if (requestBody != null && requestBody.events && Array.isArray(requestBody.events)) this_1._network.postToEndpoint($9Cev3.StatsigEndpoint.Rgstr, requestBody).then(function(response) {
                            if (!response.ok) throw Error(response.status + "");
                        }).catch(function(_e) {
                            if (fireAndForget) return;
                            _this._addFailedRequest(requestBody);
                        });
                    };
                    this_1 = this;
                    for(_i = 0, requestBodies_1 = requestBodies; _i < requestBodies_1.length; _i++){
                        requestBody = requestBodies_1[_i];
                        _loop_1(requestBody);
                    }
                } catch (_e) {} finally{
                    this._clearLocalStorageRequests();
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    StatsigLogger.prototype._init = function() {
        var _this = this;
        if (typeof window !== "undefined" && typeof window.addEventListener === "function") {
            window.addEventListener("blur", function() {
                return _this.flush(true);
            });
            window.addEventListener("beforeunload", function() {
                return _this.flush(true);
            });
            window.addEventListener("load", function() {
                setTimeout(function() {
                    return _this.flush();
                }, 100);
                setTimeout(function() {
                    return _this.flush();
                }, 1000);
            });
        }
        if (typeof document !== "undefined" && typeof document.addEventListener === "function") document.addEventListener("visibilitychange", function() {
            _this.flush(document.visibilityState !== "visible");
        });
        if (!this._options.ignoreWindowUndefined && (typeof window === "undefined" || window == null)) // dont set the flush interval outside of client browser environments
        return;
        if (this._options.localMode) // unnecessary interval in local mode since logs dont flush anyway
        return;
        var me = this;
        this._flushInterval = setInterval(function() {
            me.flush();
        }, this._options.loggingIntervalMillis);
        // Quick flush
        setTimeout(function() {
            return _this.flush();
        }, 100);
        setTimeout(function() {
            return _this.flush();
        }, 1000);
    };
    StatsigLogger.prototype._shouldLogExposure = function(key) {
        var lastTime = this._exposureDedupeKeys[key];
        var now = Date.now();
        if (lastTime == null) {
            this._exposureDedupeKeys[key] = now;
            return true;
        }
        if (lastTime >= now - 600000) return false;
        this._exposureDedupeKeys[key] = now;
        return true;
    };
    StatsigLogger.prototype._saveFailedRequests = function() {
        return $6293b43a8eb778c2$var$__awaiter(this, void 0, void 0, function() {
            var requestsCopy;
            return $6293b43a8eb778c2$var$__generator(this, function(_a) {
                if (this._failedLogEvents.length > 0) {
                    requestsCopy = JSON.stringify(this._failedLogEvents);
                    if (requestsCopy.length > $6293b43a8eb778c2$var$MAX_LOCAL_STORAGE_SIZE) {
                        this._clearLocalStorageRequests();
                        return [
                            2 /*return*/ 
                        ];
                    }
                    $6293b43a8eb778c2$var$StatsigLocalStorage_1.default.setItem($3Kmxx.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY, requestsCopy);
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    StatsigLogger.prototype._addFailedRequest = function(requestBody) {
        if (requestBody.time < Date.now() - $6293b43a8eb778c2$var$MS_RETRY_LOGS_CUTOFF) return;
        if (this._failedLogEvents.length > $6293b43a8eb778c2$var$MAX_BATCHES_TO_RETRY) return;
        var additionalEvents = requestBody.events.length;
        if (this._failedLogEventCount + additionalEvents > $6293b43a8eb778c2$var$MAX_FAILED_EVENTS) return;
        this._failedLogEvents.push(requestBody);
        this._failedLogEventCount += additionalEvents;
    };
    StatsigLogger.prototype._clearLocalStorageRequests = function() {
        $6293b43a8eb778c2$var$StatsigLocalStorage_1.default.removeItem($3Kmxx.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY);
    };
    StatsigLogger.prototype._newFailedRequest = function(name, queue) {
        if (this._loggedErrors.has(name)) return;
        this._loggedErrors.add(name);
        this._failedLogEvents.push({
            events: queue,
            statsigMetadata: this._identity._statsigMetadata,
            time: Date.now()
        });
        this._saveFailedRequests().then(function() {});
    };
    return StatsigLogger;
}();
module.exports.default = $6293b43a8eb778c2$var$StatsigLogger;

});
parcelRegister("2xtD0", function(module, exports) {
"use strict";
var $1d95a55936a87a90$var$__assign = module.exports && module.exports.__assign || function() {
    $1d95a55936a87a90$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1d95a55936a87a90$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $1d95a55936a87a90$var$makeLogEvent(eventName, user, statsigMetadata, value, metadata, secondaryExposures) {
    if (value === void 0) value = null;
    if (metadata === void 0) metadata = null;
    var logUser = user;
    if (logUser === null || logUser === void 0 ? void 0 : logUser.privateAttributes) {
        logUser = $1d95a55936a87a90$var$__assign({}, user);
        delete logUser.privateAttributes;
    }
    return {
        time: Date.now(),
        eventName: eventName,
        statsigMetadata: statsigMetadata,
        user: logUser,
        value: value,
        metadata: metadata,
        secondaryExposures: secondaryExposures
    };
}
module.exports.default = $1d95a55936a87a90$var$makeLogEvent;

});

parcelRegister("9Cev3", function(module, exports) {
"use strict";
var $7002e905c1c7fcb9$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7002e905c1c7fcb9$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEndpoint = void 0;
var $7002e905c1c7fcb9$var$StatsigEndpoint;
(function(StatsigEndpoint) {
    StatsigEndpoint["Initialize"] = "initialize";
    StatsigEndpoint["Rgstr"] = "rgstr";
    StatsigEndpoint["LogEventBeacon"] = "log_event_beacon";
})($7002e905c1c7fcb9$var$StatsigEndpoint = module.exports.StatsigEndpoint || (module.exports.StatsigEndpoint = {}));
var $7002e905c1c7fcb9$var$NO_CONTENT = 204;
var $7002e905c1c7fcb9$var$StatsigNetwork = /** @class */ function() {
    function StatsigNetwork(options, identity, errorBoundary) {
        this.retryCodes = {
            408: true,
            500: true,
            502: true,
            503: true,
            504: true,
            522: true,
            524: true,
            599: true
        };
        this.canUseKeepalive = false;
        this._options = options;
        this._identity = identity;
        this._errorBoundary = errorBoundary;
        this.leakyBucket = {};
        this._init();
    }
    StatsigNetwork.prototype.fetchValues = function(user, sinceTime, timeout, previousDerivedFields) {
        var input = {
            user: user,
            statsigMetadata: this._identity._statsigMetadata,
            sinceTime: sinceTime !== null && sinceTime !== void 0 ? sinceTime : undefined,
            hash: "djb2",
            previousDerivedFields: previousDerivedFields
        };
        return this._postWithTimeout($7002e905c1c7fcb9$var$StatsigEndpoint.Initialize, input, timeout, 3);
    };
    StatsigNetwork.prototype.sendLogBeacon = function(payload) {
        if (this._options.localMode) return true;
        var url = new URL(this._options.eventLoggingApi + $7002e905c1c7fcb9$var$StatsigEndpoint.LogEventBeacon);
        url.searchParams.append("k", this._identity._sdkKey);
        payload.clientTime = Date.now() + "";
        var stringPayload = null;
        try {
            stringPayload = JSON.stringify(payload);
        } catch (_e) {
            return false;
        }
        return navigator.sendBeacon(url.toString(), stringPayload);
    };
    StatsigNetwork.prototype.postToEndpoint = function(endpointName, body, retries, backoff, useKeepalive) {
        if (retries === void 0) retries = 0;
        if (backoff === void 0) backoff = 1000;
        if (useKeepalive === void 0) useKeepalive = false;
        return $7002e905c1c7fcb9$var$__awaiter(this, void 0, void 0, function() {
            var api, url, counter, postBody, statsigMetadata, params;
            var _this = this;
            return $7002e905c1c7fcb9$var$__generator(this, function(_a) {
                if (this._options.localMode) return [
                    2 /*return*/ ,
                    Promise.reject("no network requests in localMode")
                ];
                if (typeof fetch !== "function") // fetch is not defined in this environment, short circuit
                return [
                    2 /*return*/ ,
                    Promise.reject("fetch is not defined")
                ];
                if (typeof window === "undefined" && !this._options.ignoreWindowUndefined) // by default, dont issue requests from the server
                return [
                    2 /*return*/ ,
                    Promise.reject("window is not defined")
                ];
                api = [
                    $7002e905c1c7fcb9$var$StatsigEndpoint.Initialize
                ].includes(endpointName) ? this._options.api : this._options.eventLoggingApi;
                url = api + endpointName;
                counter = this.leakyBucket[url];
                if (counter != null && counter >= 30) return [
                    2 /*return*/ ,
                    Promise.reject(new Error("Request failed because you are making the same request too frequently."))
                ];
                if (counter == null) this.leakyBucket[url] = 1;
                else this.leakyBucket[url] = counter + 1;
                postBody = JSON.stringify(body);
                statsigMetadata = this._identity._statsigMetadata;
                params = {
                    method: "POST",
                    body: postBody,
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",
                        "STATSIG-API-KEY": this._identity._sdkKey,
                        "STATSIG-CLIENT-TIME": Date.now() + "",
                        "STATSIG-SDK-TYPE": statsigMetadata.sdkType,
                        "STATSIG-SDK-VERSION": statsigMetadata.sdkVersion
                    }
                };
                if (this.canUseKeepalive && useKeepalive) params.keepalive = true;
                return [
                    2 /*return*/ ,
                    fetch(url, params).then(function(res) {
                        return $7002e905c1c7fcb9$var$__awaiter(_this, void 0, void 0, function() {
                            var networkResponse, text, errorText;
                            return $7002e905c1c7fcb9$var$__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!res.ok) return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                        networkResponse = res;
                                        if (!(res.status === $7002e905c1c7fcb9$var$NO_CONTENT)) return [
                                            3 /*break*/ ,
                                            1
                                        ];
                                        networkResponse.data = {
                                            has_updates: false,
                                            is_no_content: true
                                        };
                                        return [
                                            3 /*break*/ ,
                                            3
                                        ];
                                    case 1:
                                        return [
                                            4 /*yield*/ ,
                                            res.text()
                                        ];
                                    case 2:
                                        text = _a.sent();
                                        networkResponse.data = JSON.parse(text);
                                        _a.label = 3;
                                    case 3:
                                        return [
                                            2 /*return*/ ,
                                            Promise.resolve(networkResponse)
                                        ];
                                    case 4:
                                        if (!this.retryCodes[res.status]) retries = 0;
                                        return [
                                            4 /*yield*/ ,
                                            res.text()
                                        ];
                                    case 5:
                                        errorText = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            Promise.reject(new Error("".concat(res.status, ": ").concat(errorText)))
                                        ];
                                }
                            });
                        });
                    }).catch(function(e) {
                        if (retries > 0) return new Promise(function(resolve, reject) {
                            setTimeout(function() {
                                _this.leakyBucket[url] = Math.max(_this.leakyBucket[url] - 1, 0);
                                _this.postToEndpoint(endpointName, body, retries - 1, backoff * 2, useKeepalive).then(resolve).catch(reject);
                            }, backoff);
                        });
                        return Promise.reject(e);
                    }).finally(function() {
                        _this.leakyBucket[url] = Math.max(_this.leakyBucket[url] - 1, 0);
                    })
                ];
            });
        });
    };
    StatsigNetwork.prototype.supportsKeepalive = function() {
        return this.canUseKeepalive;
    };
    StatsigNetwork.prototype._init = function() {
        if (!this._options.disableNetworkKeepalive) try {
            this.canUseKeepalive = "keepalive" in new Request("");
        } catch (_e) {}
    };
    StatsigNetwork.prototype._postWithTimeout = function(endpointName, body, timeout, retries, backoff) {
        var _this = this;
        if (timeout === void 0) timeout = 0;
        if (retries === void 0) retries = 0;
        if (backoff === void 0) backoff = 1000;
        var hasTimedOut = false;
        var timer = null;
        var cachedReturnValue = null;
        var eventuals = [];
        var eventually = function(boundScope) {
            return function(fn) {
                if (hasTimedOut && cachedReturnValue) fn(cachedReturnValue);
                else eventuals.push(fn);
                return boundScope;
            };
        };
        if (timeout != 0) timer = new Promise(function(resolve, reject) {
            setTimeout(function() {
                hasTimedOut = true;
                reject(new Error("The initialization timeout of ".concat(timeout, "ms has been hit before the network request has completed.")));
            }, timeout);
        });
        var fetchPromise = this.postToEndpoint(endpointName, body, retries, backoff).then(function(res) {
            if (!res.ok) return Promise.reject(new Error("Request to ".concat(endpointName, " failed with status ").concat(res.status)));
            if (typeof res.data !== "object") {
                var error = new Error("Request to ".concat(endpointName, " received invalid response type. Expected 'object' but got '").concat(typeof res.data, "'"));
                _this._errorBoundary._logError("postWithTimeoutInvalidRes", error, function() {
                    return $7002e905c1c7fcb9$var$__awaiter(_this, void 0, void 0, function() {
                        return $7002e905c1c7fcb9$var$__generator(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                this._getErrorData(endpointName, body, retries, backoff, res)
                            ];
                        });
                    });
                });
                return Promise.reject(error);
            }
            var json = res.data;
            return _this._errorBoundary._capture("postWithTimeout", function() {
                return $7002e905c1c7fcb9$var$__awaiter(_this, void 0, void 0, function() {
                    return $7002e905c1c7fcb9$var$__generator(this, function(_a) {
                        cachedReturnValue = json;
                        if (hasTimedOut) {
                            eventuals.forEach(function(fn) {
                                return fn(json);
                            });
                            eventuals = [];
                        }
                        return [
                            2 /*return*/ ,
                            Promise.resolve(json)
                        ];
                    });
                });
            }, function() {
                return Promise.resolve({});
            }, function() {
                return $7002e905c1c7fcb9$var$__awaiter(_this, void 0, void 0, function() {
                    return $7002e905c1c7fcb9$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            this._getErrorData(endpointName, body, retries, backoff, res)
                        ];
                    });
                });
            });
        }).catch(function(e) {
            return Promise.reject(e);
        });
        var racingPromise = timer ? Promise.race([
            fetchPromise,
            timer
        ]) : fetchPromise;
        racingPromise.eventually = eventually(racingPromise);
        return racingPromise;
    };
    StatsigNetwork.prototype._getErrorData = function(endpointName, body, retries, backoff, res) {
        var _a;
        return $7002e905c1c7fcb9$var$__awaiter(this, void 0, void 0, function() {
            var headers_1;
            return $7002e905c1c7fcb9$var$__generator(this, function(_b) {
                try {
                    headers_1 = {};
                    ((_a = res.headers) !== null && _a !== void 0 ? _a : []).forEach(function(value, key) {
                        headers_1[key] = value;
                    });
                    return [
                        2 /*return*/ ,
                        {
                            responseInfo: {
                                headers: headers_1,
                                status: res.status,
                                statusText: res.statusText,
                                type: res.type,
                                url: res.url,
                                redirected: res.redirected,
                                bodySnippet: res.data ? JSON.stringify(res.data).slice(0, 500) : null
                            },
                            requestInfo: {
                                endpointName: endpointName,
                                bodySnippet: JSON.stringify(body).slice(0, 500),
                                retries: retries,
                                backoff: backoff
                            }
                        }
                    ];
                } catch (_e) {
                    return [
                        2 /*return*/ ,
                        {
                            statusText: "statsig::failed to extract extra data"
                        }
                    ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return StatsigNetwork;
}();
module.exports.default = $7002e905c1c7fcb9$var$StatsigNetwork;

});


parcelRegister("8Lbg5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.INIT_TIMEOUT_DEFAULT_MS = void 0;
var $660b723537db4237$var$DEFAULT_FEATURE_GATE_API = "https://featuregates.org/v1/";
var $660b723537db4237$var$DEFAULT_EVENT_LOGGING_API = "https://events.statsigapi.net/v1/";
module.exports.INIT_TIMEOUT_DEFAULT_MS = 3000;
var $660b723537db4237$var$StatsigSDKOptions = /** @class */ function() {
    function StatsigSDKOptions(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        if (options == null) options = {};
        var api = (_a = options.api) !== null && _a !== void 0 ? _a : $660b723537db4237$var$DEFAULT_FEATURE_GATE_API;
        this.api = api.endsWith("/") ? api : api + "/";
        this.disableCurrentPageLogging = (_b = options.disableCurrentPageLogging) !== null && _b !== void 0 ? _b : false;
        this.environment = (_c = options.environment) !== null && _c !== void 0 ? _c : null;
        this.loggingIntervalMillis = this.normalizeNumberInput(options.loggingIntervalMillis, {
            default: 10000,
            min: 1000,
            max: 60000
        });
        this.loggingBufferMaxSize = this.normalizeNumberInput(options.loggingBufferMaxSize, {
            default: 100,
            min: 2,
            max: 500
        });
        this.disableNetworkKeepalive = (_d = options.disableNetworkKeepalive) !== null && _d !== void 0 ? _d : false;
        this.overrideStableID = (_e = options.overrideStableID) !== null && _e !== void 0 ? _e : null;
        this.localMode = (_f = options.localMode) !== null && _f !== void 0 ? _f : false;
        this.initTimeoutMs = options.initTimeoutMs && options.initTimeoutMs >= 0 ? options.initTimeoutMs : module.exports.INIT_TIMEOUT_DEFAULT_MS;
        this.disableErrorLogging = (_g = options.disableErrorLogging) !== null && _g !== void 0 ? _g : false;
        this.disableAutoMetricsLogging = (_h = options.disableAutoMetricsLogging) !== null && _h !== void 0 ? _h : false;
        this.initializeValues = (_j = options.initializeValues) !== null && _j !== void 0 ? _j : null;
        var eventLoggingApi = (_l = (_k = options.eventLoggingApi) !== null && _k !== void 0 ? _k : options.api) !== null && _l !== void 0 ? _l : $660b723537db4237$var$DEFAULT_EVENT_LOGGING_API;
        this.eventLoggingApi = eventLoggingApi.endsWith("/") ? eventLoggingApi : eventLoggingApi + "/";
        this.disableLocalStorage = (_m = options.disableLocalStorage) !== null && _m !== void 0 ? _m : false;
        this.ignoreWindowUndefined = (_o = options === null || options === void 0 ? void 0 : options.ignoreWindowUndefined) !== null && _o !== void 0 ? _o : false;
        this.updateUserCompletionCallback = (_p = options === null || options === void 0 ? void 0 : options.updateUserCompletionCallback) !== null && _p !== void 0 ? _p : null;
        this.disableAllLogging = (_q = options === null || options === void 0 ? void 0 : options.disableAllLogging) !== null && _q !== void 0 ? _q : false;
    }
    StatsigSDKOptions.prototype.normalizeNumberInput = function(input, bounds) {
        if (input == null) return bounds.default;
        return Math.max(Math.min(input, bounds.max), bounds.min);
    };
    return StatsigSDKOptions;
}();
module.exports.default = $660b723537db4237$var$StatsigSDKOptions;

});

parcelRegister("6YuR1", function(module, exports) {
"use strict";
var $514047afbd68d67b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $514047afbd68d67b$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $514047afbd68d67b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EvaluationReason = void 0;

var $514047afbd68d67b$var$DynamicConfig_1 = $514047afbd68d67b$var$__importDefault((parcelRequire("kcbPW")));

var $514047afbd68d67b$var$Layer_1 = $514047afbd68d67b$var$__importDefault((parcelRequire("01noY")));

var $514047afbd68d67b$var$BootstrapValidator_1 = $514047afbd68d67b$var$__importDefault((parcelRequire("7SEfj")));

var $3Kmxx = parcelRequire("3Kmxx");

var $9PHrf = parcelRequire("9PHrf");

var $514047afbd68d67b$var$StatsigLocalStorage_1 = $514047afbd68d67b$var$__importDefault((parcelRequire("eK7RG")));
var $514047afbd68d67b$var$EvaluationReason;
(function(EvaluationReason) {
    EvaluationReason["Network"] = "Network";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Cache"] = "Cache";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["Error"] = "Error";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["LocalOverride"] = "LocalOverride";
})($514047afbd68d67b$var$EvaluationReason = module.exports.EvaluationReason || (module.exports.EvaluationReason = {}));
var $514047afbd68d67b$var$MAX_USER_VALUE_CACHED = 10;
var $514047afbd68d67b$var$StatsigStore = /** @class */ function() {
    function StatsigStore(identity, onDefaultValueFallback, initializeValues) {
        this._identity = identity;
        this._onDefaultValueFallback = onDefaultValueFallback;
        this._userCacheKey = this._identity.getUserCacheKey();
        this._values = {};
        this._userValues = this._getDefaultUserCacheValues();
        this._loaded = false;
        this._reason = $514047afbd68d67b$var$EvaluationReason.Uninitialized;
        if (initializeValues) this.bootstrap(initializeValues);
        else this._loadFromLocalStorage();
    }
    StatsigStore.prototype.updateUser = function() {
        this._userCacheKey = this._identity.getUserCacheKey();
        return this._setUserValueFromCache();
    };
    StatsigStore.prototype.bootstrap = function(initializeValues) {
        var _a, _b, _c, _d;
        var key = this._identity.getUserCacheKey();
        var user = this._identity._user;
        var reason = $514047afbd68d67b$var$BootstrapValidator_1.default.isValid(user, initializeValues) ? $514047afbd68d67b$var$EvaluationReason.Bootstrap : $514047afbd68d67b$var$EvaluationReason.InvalidBootstrap;
        // clients are going to assume that the SDK is bootstrapped after this method runs
        // if we fail to parse, we will fall back to defaults, but we dont want to throw
        // when clients try to check gates/configs/etc after this point
        this._loaded = true;
        try {
            this._userValues.feature_gates = (_a = initializeValues.feature_gates) !== null && _a !== void 0 ? _a : {};
            this._userValues.dynamic_configs = (_b = initializeValues.dynamic_configs) !== null && _b !== void 0 ? _b : {};
            this._userValues.layer_configs = (_c = initializeValues.layer_configs) !== null && _c !== void 0 ? _c : {};
            this._userValues.evaluation_time = Date.now();
            this._userValues.time = (_d = initializeValues.time) !== null && _d !== void 0 ? _d : Date.now();
            this._values[key] = this._userValues;
            this._reason = reason;
            var generatorSDKInfo = initializeValues.sdkInfo;
            this._userValues.bootstrapMetadata = {};
            if (generatorSDKInfo != null) this._userValues.bootstrapMetadata.generatorSDKInfo = generatorSDKInfo;
            if (initializeValues.user != null) this._userValues.bootstrapMetadata.user = initializeValues.user;
            if (initializeValues.time != null) this._userValues.bootstrapMetadata.lcut = initializeValues.time;
        } catch (_e) {
            return;
        }
    };
    StatsigStore.prototype.getBootstrapMetadata = function() {
        var _a;
        return (_a = this._userValues.bootstrapMetadata) !== null && _a !== void 0 ? _a : null;
    };
    StatsigStore.prototype.isLoaded = function() {
        return this._loaded;
    };
    StatsigStore.prototype.getLastUpdateTime = function(user) {
        var userHash = (0, $9PHrf.djb2HashForObject)(user);
        if (this._userValues.user_hash == userHash) return this._userValues.time;
        return null;
    };
    StatsigStore.prototype.getPreviousDerivedFields = function(user) {
        var userHash = (0, $9PHrf.djb2HashForObject)(user);
        if (this._userValues.user_hash == userHash) return this._userValues.derived_fields;
        return undefined;
    };
    StatsigStore.prototype.setEvaluationReason = function(evalReason) {
        this._reason = evalReason;
    };
    StatsigStore.prototype.save = function(user, jsonConfigs, updateState) {
        if (updateState === void 0) updateState = true;
        return $514047afbd68d67b$var$__awaiter(this, void 0, void 0, function() {
            var requestedUserCacheKey, initResponse, userValues, _a;
            return $514047afbd68d67b$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        requestedUserCacheKey = (0, $9PHrf.getUserCacheKey)(user);
                        initResponse = jsonConfigs;
                        this._mergeInitializeResponseIntoUserMap(initResponse, this._values, requestedUserCacheKey, user, function(userValues) {
                            return userValues;
                        });
                        if (updateState) {
                            userValues = this._values[requestedUserCacheKey];
                            if (userValues && requestedUserCacheKey && requestedUserCacheKey == this._userCacheKey) {
                                this._userValues = userValues;
                                this._reason = $514047afbd68d67b$var$EvaluationReason.Network;
                            }
                        }
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            this._writeValuesToStorage(this._values)
                        ];
                    case 1:
                        _a._values = _b.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    StatsigStore.prototype.checkGate = function(gateName) {
        var _a;
        var gateNameHash = (0, $9PHrf.getHashValue)(gateName, this._userValues.hash_used);
        var gateValue = {
            name: gateName,
            value: false,
            rule_id: "",
            secondary_exposures: []
        };
        var details;
        var value = (_a = this._userValues) === null || _a === void 0 ? void 0 : _a.feature_gates[gateNameHash];
        if (value) gateValue = value;
        details = this._getEvaluationDetails(value != null);
        return {
            evaluationDetails: details,
            gate: gateValue
        };
    };
    StatsigStore.prototype.getConfig = function(configName) {
        var _a, _b;
        var configNameHash = (0, $9PHrf.getHashValue)(configName, this._userValues.hash_used);
        var configValue;
        var details;
        if (((_a = this._userValues) === null || _a === void 0 ? void 0 : _a.dynamic_configs[configNameHash]) != null) {
            var rawConfigValue = (_b = this._userValues) === null || _b === void 0 ? void 0 : _b.dynamic_configs[configNameHash];
            details = this._getEvaluationDetails(true);
            configValue = this._createDynamicConfig(configName, rawConfigValue, details);
        } else {
            details = this._getEvaluationDetails(false);
            configValue = new $514047afbd68d67b$var$DynamicConfig_1.default(configName, {}, "", details);
        }
        return configValue;
    };
    StatsigStore.prototype.getLayer = function(logParameterFunction, layerName) {
        var _a, _b, _c;
        var latestValue = this._getLatestValue(layerName, "layer_configs");
        var details = this._getEvaluationDetails(latestValue != null);
        return $514047afbd68d67b$var$Layer_1.default._create(layerName, (_a = latestValue === null || latestValue === void 0 ? void 0 : latestValue.value) !== null && _a !== void 0 ? _a : {}, (_b = latestValue === null || latestValue === void 0 ? void 0 : latestValue.rule_id) !== null && _b !== void 0 ? _b : "", details, logParameterFunction, latestValue === null || latestValue === void 0 ? void 0 : latestValue.secondary_exposures, latestValue === null || latestValue === void 0 ? void 0 : latestValue.undelegated_secondary_exposures, (_c = latestValue === null || latestValue === void 0 ? void 0 : latestValue.allocated_experiment_name) !== null && _c !== void 0 ? _c : "", latestValue === null || latestValue === void 0 ? void 0 : latestValue.explicit_parameters);
    };
    StatsigStore.prototype.getGlobalEvaluationDetails = function() {
        var _a, _b;
        return {
            reason: (_a = this._reason) !== null && _a !== void 0 ? _a : $514047afbd68d67b$var$EvaluationReason.Uninitialized,
            time: (_b = this._userValues.evaluation_time) !== null && _b !== void 0 ? _b : 0
        };
    };
    StatsigStore.prototype._loadFromLocalStorage = function() {
        this._parseCachedValues($514047afbd68d67b$var$StatsigLocalStorage_1.default.getItem($3Kmxx.INTERNAL_STORE_KEY));
        this._loaded = true;
    };
    StatsigStore.prototype._parseCachedValues = function(allValues) {
        try {
            this._values = allValues ? JSON.parse(allValues) : this._values;
            this._setUserValueFromCache();
        } catch (e) {
            // Cached value corrupted, remove cache
            this._removeFromStorage($3Kmxx.INTERNAL_STORE_KEY);
        }
    };
    StatsigStore.prototype._setUserValueFromCache = function() {
        var _a;
        var cachedValues = this._values[this._userCacheKey];
        if (cachedValues == null) {
            this._resetUserValues();
            this._reason = $514047afbd68d67b$var$EvaluationReason.Uninitialized;
            return null;
        }
        this._userValues = cachedValues;
        this._reason = $514047afbd68d67b$var$EvaluationReason.Cache;
        return (_a = cachedValues.evaluation_time) !== null && _a !== void 0 ? _a : 0;
    };
    StatsigStore.prototype._removeFromStorage = function(key) {
        $514047afbd68d67b$var$StatsigLocalStorage_1.default.removeItem(key);
    };
    /**
     * Merges the provided init configs into the provided config map, according to the provided merge function
     */ StatsigStore.prototype._mergeInitializeResponseIntoUserMap = function(data, configMap, requestedUserCacheKey, user, mergeFn) {
        if (requestedUserCacheKey) {
            var requestedUserValues = this._convertAPIDataToCacheValues(data, requestedUserCacheKey);
            if (data.has_updates && data.time) {
                var userHash = (0, $9PHrf.djb2HashForObject)(user);
                requestedUserValues.user_hash = userHash;
            }
            configMap[requestedUserCacheKey] = mergeFn(requestedUserValues, requestedUserCacheKey);
        }
    };
    StatsigStore.prototype._getDefaultUserCacheValues = function() {
        return {
            feature_gates: {},
            layer_configs: {},
            dynamic_configs: {},
            time: 0,
            evaluation_time: 0,
            has_updates: false
        };
    };
    /**
     * Writes the provided values to storage, truncating down to
     * MAX_USER_VALUE_CACHED number entries.
     * @returns The truncated entry list
     */ StatsigStore.prototype._writeValuesToStorage = function(valuesToWrite) {
        return $514047afbd68d67b$var$__awaiter(this, void 0, void 0, function() {
            var filteredValues;
            return $514047afbd68d67b$var$__generator(this, function(_a) {
                filteredValues = Object.entries(valuesToWrite).sort(function(_a, _b) {
                    var _c, _d;
                    var a = _a[1];
                    var b = _b[1];
                    if (a == null) return 1;
                    if (b == null) return -1;
                    return ((_c = b === null || b === void 0 ? void 0 : b.evaluation_time) !== null && _c !== void 0 ? _c : b === null || b === void 0 ? void 0 : b.time) - ((_d = a === null || a === void 0 ? void 0 : a.evaluation_time) !== null && _d !== void 0 ? _d : a === null || a === void 0 ? void 0 : a.time);
                }).slice(0, $514047afbd68d67b$var$MAX_USER_VALUE_CACHED);
                valuesToWrite = Object.fromEntries(filteredValues);
                $514047afbd68d67b$var$StatsigLocalStorage_1.default.setItem($3Kmxx.INTERNAL_STORE_KEY, JSON.stringify(valuesToWrite));
                return [
                    2 /*return*/ ,
                    valuesToWrite
                ];
            });
        });
    };
    StatsigStore.prototype._getLatestValue = function(name, topLevelKey) {
        var _a, _b, _c, _d, _f;
        var hash = (0, $9PHrf.getHashValue)(name, this._userValues.hash_used);
        return (_c = (_b = (_a = this._userValues) === null || _a === void 0 ? void 0 : _a[topLevelKey]) === null || _b === void 0 ? void 0 : _b[hash]) !== null && _c !== void 0 ? _c : (_f = (_d = this._userValues) === null || _d === void 0 ? void 0 : _d[topLevelKey]) === null || _f === void 0 ? void 0 : _f[name];
    };
    StatsigStore.prototype._createDynamicConfig = function(name, apiConfig, details) {
        var _a, _b, _c;
        return new $514047afbd68d67b$var$DynamicConfig_1.default(name, (_a = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.value) !== null && _a !== void 0 ? _a : {}, (_b = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.rule_id) !== null && _b !== void 0 ? _b : "", details, apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.secondary_exposures, (_c = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.allocated_experiment_name) !== null && _c !== void 0 ? _c : "", this._makeOnConfigDefaultValueFallback(this._identity._user));
    };
    StatsigStore.prototype._getEvaluationDetails = function(valueExists, reasonOverride) {
        var _a;
        if (valueExists) return {
            reason: this._reason,
            time: (_a = this._userValues.evaluation_time) !== null && _a !== void 0 ? _a : Date.now()
        };
        else return {
            reason: reasonOverride !== null && reasonOverride !== void 0 ? reasonOverride : this._reason == $514047afbd68d67b$var$EvaluationReason.Uninitialized ? $514047afbd68d67b$var$EvaluationReason.Uninitialized : $514047afbd68d67b$var$EvaluationReason.Unrecognized,
            time: Date.now()
        };
    };
    StatsigStore.prototype._resetUserValues = function() {
        this._userValues = this._getDefaultUserCacheValues();
    };
    StatsigStore.prototype._convertAPIDataToCacheValues = function(data, cacheKey) {
        // Specifically pulling keys from data here to avoid pulling in unwanted keys
        return {
            feature_gates: data.feature_gates,
            layer_configs: data.layer_configs,
            dynamic_configs: data.dynamic_configs,
            time: data.time == null || isNaN(data.time) ? 0 : data.time,
            evaluation_time: Date.now(),
            derived_fields: data.derived_fields,
            hash_used: data.hash_used
        };
    };
    StatsigStore.prototype._makeOnConfigDefaultValueFallback = function(user) {
        var _this = this;
        return function(config, parameter, defaultValueType, valueType) {
            if (!_this.isLoaded()) return;
            _this._onDefaultValueFallback(user, "Parameter ".concat(parameter, " is a value of type ").concat(valueType, ".\n          Returning requested defaultValue type ").concat(defaultValueType), {
                name: config._name,
                ruleID: config._ruleID,
                parameter: parameter,
                defaultValueType: defaultValueType,
                valueType: valueType
            });
        };
    };
    return StatsigStore;
}();
module.exports.default = $514047afbd68d67b$var$StatsigStore;

});
parcelRegister("7SEfj", function(module, exports) {
"use strict";
var $5bcccb943b694c44$var$__assign = module.exports && module.exports.__assign || function() {
    $5bcccb943b694c44$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5bcccb943b694c44$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5bcccb943b694c44$var$BootstrapValidator = /** @class */ function() {
    function BootstrapValidator() {}
    BootstrapValidator.isValid = function(user, values) {
        try {
            var evaluatedKeys = values["evaluated_keys"];
            if (!evaluatedKeys || typeof evaluatedKeys !== "object") return true;
            var evaluatedKeysRecord = this.copyObject(evaluatedKeys);
            var userToCompare = user == null ? null : this.copyObject(user);
            return BootstrapValidator.validate(evaluatedKeysRecord, userToCompare) && BootstrapValidator.validate(userToCompare, evaluatedKeysRecord);
        } catch (error) {
        // This is best-effort. If we fail, return true.
        }
        return true;
    };
    BootstrapValidator.validate = function(one, two) {
        if (one == null) return two == null;
        else if (two == null) return false;
        for(var _i = 0, _a = Object.entries(one); _i < _a.length; _i++){
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (key === "stableID") continue;
            if (typeof value !== typeof two[key]) return false;
            if (typeof value === "string") {
                if (value !== two[key]) return false;
            } else if (typeof value === "object") return this.validate(value, two[key]);
            else // unexpected
            return false;
        }
        return true;
    };
    BootstrapValidator.copyObject = function(obj) {
        if (obj == null) return null;
        var copy = {};
        if (obj === null || obj === void 0 ? void 0 : obj.userID) copy["userID"] = obj === null || obj === void 0 ? void 0 : obj.userID;
        if (obj === null || obj === void 0 ? void 0 : obj.customIDs) {
            var customIDs = $5bcccb943b694c44$var$__assign({}, obj.customIDs);
            delete customIDs["stableID"];
            if (Object.keys(customIDs).length !== 0) copy["customIDs"] = customIDs;
        }
        return copy;
    };
    return BootstrapValidator;
}();
module.exports.default = $5bcccb943b694c44$var$BootstrapValidator;

});


parcelRegister("6zTBX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.verifySDKKeyUsed = void 0;

var $9KdHO = parcelRequire("9KdHO");

var $9PHrf = parcelRequire("9PHrf");
function $4ca1262efd5a931d$var$verifySDKKeyUsed(json, sdkKey, errorBoundary) {
    var hashedSDKKeyUsed = json === null || json === void 0 ? void 0 : json.hashed_sdk_key_used;
    if (hashedSDKKeyUsed != null && hashedSDKKeyUsed !== (0, $9PHrf.SimpleHash)(sdkKey !== null && sdkKey !== void 0 ? sdkKey : "")) {
        errorBoundary._logError("fetchAndSaveValues", new $9KdHO.StatsigSDKKeyMismatchError("The SDK key provided does not match the one used to generate values."));
        return false;
    }
    return true;
}
module.exports.verifySDKKeyUsed = $4ca1262efd5a931d$var$verifySDKKeyUsed;

});

parcelRegister("k2HtX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.difference = module.exports.now = void 0;
function $e975b93286ff0ac2$var$now() {
    if (typeof performance === "undefined" || !performance) return Date.now();
    return performance.now() | 0;
}
module.exports.now = $e975b93286ff0ac2$var$now;
function $e975b93286ff0ac2$var$difference(time) {
    return $e975b93286ff0ac2$var$now() - time;
}
module.exports.difference = $e975b93286ff0ac2$var$difference;

});

parcelRegister("e0BEy", function(module, exports) {
"use strict";
var $a32e45e80a1a4516$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.saveOverridesToLocalStorage = module.exports.loadOverridesFromLocalStorage = module.exports.makeEmptyOverrides = module.exports.STORAGE_KEY = void 0;

var $a32e45e80a1a4516$var$StatsigLocalStorage_1 = $a32e45e80a1a4516$var$__importDefault((parcelRequire("eK7RG")));
module.exports.STORAGE_KEY = "STATSIG_JS_LITE_LOCAL_OVERRIDES";
function $a32e45e80a1a4516$var$makeEmptyOverrides() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
}
module.exports.makeEmptyOverrides = $a32e45e80a1a4516$var$makeEmptyOverrides;
function $a32e45e80a1a4516$var$loadOverridesFromLocalStorage() {
    var raw = $a32e45e80a1a4516$var$StatsigLocalStorage_1.default.getItem(module.exports.STORAGE_KEY);
    if (raw) try {
        return JSON.parse(raw);
    } catch (error) {
    // noop
    }
    return $a32e45e80a1a4516$var$makeEmptyOverrides();
}
module.exports.loadOverridesFromLocalStorage = $a32e45e80a1a4516$var$loadOverridesFromLocalStorage;
function $a32e45e80a1a4516$var$saveOverridesToLocalStorage(overrides) {
    $a32e45e80a1a4516$var$StatsigLocalStorage_1.default.setItem(module.exports.STORAGE_KEY, JSON.stringify(overrides));
}
module.exports.saveOverridesToLocalStorage = $a32e45e80a1a4516$var$saveOverridesToLocalStorage;

});



parcelRegister("7l5z9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $557ecfdae7e96f06$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $4mVfk = parcelRequire("4mVfk");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $8DpVo = parcelRequire("8DpVo");

var $2yOpU = parcelRequire("2yOpU");

var $l05FA = parcelRequire("l05FA");

var $8AXZn = parcelRequire("8AXZn");
function $557ecfdae7e96f06$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $557ecfdae7e96f06$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $557ecfdae7e96f06$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $557ecfdae7e96f06$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $557ecfdae7e96f06$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $557ecfdae7e96f06$var$PROD_BASE_URL = "https://api.atlassian.com/flags";
var $557ecfdae7e96f06$var$STAGING_BASE_URL = "https://api.stg.atlassian.com/flags";
var $557ecfdae7e96f06$export$f058dbf75c3bc647 = "https://api.dev.atlassian.com/flags";
var $557ecfdae7e96f06$export$1a401a0da8da3565 = "https://api.stg.atlassian-us-gov-mod.com/flags";
var $557ecfdae7e96f06$export$18c93900db9358a4 = "https://api.atlassian-us-gov-mod.com/flags";
var $557ecfdae7e96f06$export$450bd8fb2a6d7ace = "/gateway/api/flags";
var $557ecfdae7e96f06$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, Fetcher);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, "GET", fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error("Failed to retrieve client sdk key");
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest("/api/v2/frontend/experimentValues", "POST", fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error("Failed to retrieve experiment values");
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $8AXZn.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $8AXZn.ResponseError)("Unexpected 204 response");
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $2yOpU.PerimeterType).COMMERCIAL;
                if (useGatewayUrl) return $557ecfdae7e96f06$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $2yOpU.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $2yOpU.FeatureGateEnvironment).Production:
                        return $557ecfdae7e96f06$export$18c93900db9358a4;
                    case (0, $2yOpU.FeatureGateEnvironment).Staging:
                        return $557ecfdae7e96f06$export$1a401a0da8da3565;
                    default:
                        throw new Error('Invalid environment "'.concat(serviceEnv, '" for "').concat(perimeter, '" perimeter'));
                }
                else if (perimeter === (0, $2yOpU.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $2yOpU.FeatureGateEnvironment).Development:
                        return $557ecfdae7e96f06$export$f058dbf75c3bc647;
                    case (0, $2yOpU.FeatureGateEnvironment).Staging:
                        return $557ecfdae7e96f06$var$STAGING_BASE_URL;
                    default:
                        return $557ecfdae7e96f06$var$PROD_BASE_URL;
                }
                else throw new Error('Invalid perimeter "'.concat(perimeter, '"'));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $557ecfdae7e96f06$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $557ecfdae7e96f06$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        "Content-Type": "application/json",
                                        "X-Client-Name": "feature-gate-js-client",
                                        "X-Client-Version": (0, $l05FA.CLIENT_VERSION),
                                        "X-API-KEY": fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x10) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        }
    ]);
    return Fetcher;
}();

});
parcelRegister("2yOpU", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $1dd5dd82231be5df$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $1dd5dd82231be5df$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options.
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $1dd5dd82231be5df$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $1dd5dd82231be5df$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});

});

parcelRegister("l05FA", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", function () { return $f49dfef5b1d4ee31$export$a59f8d67326bd1cb; });
var $f49dfef5b1d4ee31$export$a59f8d67326bd1cb = "4.18.0";

});

parcelRegister("8AXZn", function(module, exports) {

$parcel$export(module.exports, "ResponseError", function () { return $6420381623ea7851$export$286baf652d0b1206; });

var $eVDe4 = parcelRequire("eVDe4");

var $uqRmf = parcelRequire("uqRmf");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $6FnrE = parcelRequire("6FnrE");
function $6420381623ea7851$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6420381623ea7851$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $6420381623ea7851$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($6420381623ea7851$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $6420381623ea7851$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(ResponseError, _Error);
    var _super = $6420381623ea7851$var$_createSuper(ResponseError);
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ResponseError);
        return _super.call(this, message);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6FnrE)))(Error));

});



parcelRegister("dRHNf", function(module, exports) {

$parcel$export(module.exports, "CrossFlowExtensions", function () { return (parcelRequire("g9Er4")).CrossFlowExtensions; });
$parcel$export(module.exports, "Targets", function () { return (parcelRequire("17HSd")).Targets; });

var $g9Er4 = parcelRequire("g9Er4");

var $17HSd = parcelRequire("17HSd");

});
parcelRegister("g9Er4", function(module, exports) {

$parcel$export(module.exports, "CrossFlowExtensions", function () { return $bc2cda436c63adc8$export$a5e53d1dcbd6eb61; });

var $eVDe4 = parcelRequire("eVDe4");

var $uqRmf = parcelRequire("uqRmf");
var $bc2cda436c63adc8$export$a5e53d1dcbd6eb61 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(function CrossFlowExtensions(options) {
    (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, CrossFlowExtensions);
    Object.assign(this, options);
    Object.freeze(this);
});

});

parcelRegister("17HSd", function(module, exports) {

$parcel$export(module.exports, "Targets", function () { return $0d187a3b92f5874f$export$59a8eb9cff113544; });
/**
 * We are keeping a manual list of targets for the purposes of type safety.
 */ var $0d187a3b92f5874f$export$59a8eb9cff113544 = {
    CONFLUENCE: "confluence.ondemand",
    JIRA_CORE: "jira-core.ondemand",
    JIRA_SERVICE_DESK: "jira-servicedesk.ondemand",
    JIRA_SOFTWARE: "jira-software.ondemand",
    JIRA_PRODUCT_DISCOVERY: "jira-product-discovery",
    BITBUCKET: "bitbucket.ondemand",
    TRELLO: "trello",
    OPSGENIE: "opsgenie",
    STATUSPAGE: "statuspage",
    /**
   * @private
   * @deprecated Use ATLAS instead
   */ TEAM_CENTRAL: "townsquare",
    ATLAS: "townsquare",
    /**
   * @private
   * @deprecated
   */ AVOCADO: "avocado",
    ANALYTICS: "atlassian-analytics-free",
    COMPASS: "compass"
}; /**
 * The list of supported targets in Cross-flow.
 *
 * While TypeScript does match this to the list of Targets provided in this library,
 * in essence any string value can be used to accomodate this type through the use of
 * type casting.
 */ 

});


parcelRegister("bA7Lf", function(module, exports) {

$parcel$export(module.exports, "source", function () { return $86e913b3e8765f2c$export$b4d5da5f34fb77ad; });
$parcel$export(module.exports, "errorBoundaryAction", function () { return $86e913b3e8765f2c$export$9d8252a268f4fa72; });
$parcel$export(module.exports, "errorBoundaryActionSubject", function () { return $86e913b3e8765f2c$export$1045419caf49b395; });
$parcel$export(module.exports, "crossFlowActionSubject", function () { return $86e913b3e8765f2c$export$d54c183f56e39aa5; });
$parcel$export(module.exports, "uiInitialized", function () { return $86e913b3e8765f2c$export$e5c2c058fa8068a6; });
$parcel$export(module.exports, "openInvoked", function () { return $86e913b3e8765f2c$export$e67cdcb8867a3bd0; });
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", function () { return (parcelRequire("7Qr4H")).OPERATIONAL_EVENT_TYPE; });

var $7Qr4H = parcelRequire("7Qr4H");
var $86e913b3e8765f2c$export$b4d5da5f34fb77ad = "crossFlowProvider";
var $86e913b3e8765f2c$export$9d8252a268f4fa72 = "errorCaught";
var $86e913b3e8765f2c$export$1045419caf49b395 = "errorBoundary";
var $86e913b3e8765f2c$export$d54c183f56e39aa5 = "crossFlowSupport";
var $86e913b3e8765f2c$export$e5c2c058fa8068a6 = "uiInitialized";
var $86e913b3e8765f2c$export$e67cdcb8867a3bd0 = "openInvoked";

});

parcelRegister("cvpxy", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("dHQda")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("82YIU"))
]).then(()=>parcelRequire("jhPt4"));

});
parcelRegister("3T95l", function(module, exports) {
"use strict";

var $51a7t = parcelRequire("51a7t");
module.exports = $51a7t(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("51a7t", function(module, exports) {
"use strict";
var $3a74e542536fc660$var$cachedBundles = {};
var $3a74e542536fc660$var$cachedPreloads = {};
var $3a74e542536fc660$var$cachedPrefetches = {};
function $3a74e542536fc660$var$getCache(type) {
    switch(type){
        case "preload":
            return $3a74e542536fc660$var$cachedPreloads;
        case "prefetch":
            return $3a74e542536fc660$var$cachedPrefetches;
        default:
            return $3a74e542536fc660$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $3a74e542536fc660$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("hS1rT", function(module, exports) {

$parcel$export(module.exports, "useCrossFlow", function () { return (parcelRequire("2ABou")).useCrossFlow; });
$parcel$export(module.exports, "withCrossFlow", function () { return (parcelRequire("2ABou")).withCrossFlow; });
$parcel$export(module.exports, "Journeys", function () { return (parcelRequire("h898w")).Journeys; });
$parcel$export(module.exports, "Reasons", function () { return (parcelRequire("h898w")).Reasons; });
$parcel$export(module.exports, "Targets", function () { return (parcelRequire("17HSd")).Targets; });
$parcel$export(module.exports, "CrossFlowConsumer", function () { return (parcelRequire("5Lqa0")).CrossFlowConsumer; });
parcelRequire("fTXuo");
var $h898w = parcelRequire("h898w");
var $2ABou = parcelRequire("2ABou");
parcelRequire("dRHNf");
var $17HSd = parcelRequire("17HSd");

var $5Lqa0 = parcelRequire("5Lqa0");

});
parcelRegister("5Lqa0", function(module, exports) {

$parcel$export(module.exports, "CrossFlowConsumer", function () { return $4325a27675eae68e$export$bb23a1e8e036feea; });

var $lOQkO = parcelRequire("lOQkO");

var $4mVfk = parcelRequire("4mVfk");

var $8DpVo = parcelRequire("8DpVo");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("fTXuo");
var $2ABou = parcelRequire("2ABou");
var $4325a27675eae68e$var$_excluded = [
    "onComplete",
    "onError"
];
var $4325a27675eae68e$export$bb23a1e8e036feea = function CrossFlowConsumer(props) {
    // Using useRef here to ensure that only the initial props are used
    // and it ensures that the useEffect handler below is only run once.
    // Any subsequent changes to props have no effect.
    var propsRef = (0, $9nHZC.useRef)(props);
    var crossFlowRef = (0, $9nHZC.useRef)((0, $2ABou.useCrossFlow)());
    (0, $9nHZC.useEffect)(function() {
        var crossFlow = crossFlowRef.current;
        (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee() {
            var _propsRef$current, onComplete, onError, options, status;
            return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _propsRef$current = propsRef.current, onComplete = _propsRef$current.onComplete, onError = _propsRef$current.onError, options = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_propsRef$current, $4325a27675eae68e$var$_excluded);
                        if (!crossFlow.isEnabled) {
                            _context.next = 12;
                            break;
                        }
                        _context.prev = 2;
                        _context.next = 5;
                        return crossFlow.api.open(options);
                    case 5:
                        status = _context.sent;
                        onComplete === null || onComplete === void 0 || onComplete(status);
                        _context.next = 12;
                        break;
                    case 9:
                        _context.prev = 9;
                        _context.t0 = _context["catch"](2);
                        onError === null || onError === void 0 || onError(_context.t0);
                    case 12:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    2,
                    9
                ]
            ]);
        }))();
    }, []);
    return null;
};

});


parcelRegister("1D3HA", function(module, exports) {

$parcel$export(module.exports, "AppDataContext", function () { return $53380c4e446b451e$export$7dc2bc02137acda8; });
$parcel$export(module.exports, "useAppData", function () { return $53380c4e446b451e$export$a9d8a52df866299; });
$parcel$export(module.exports, "useAppDataFeature", function () { return $53380c4e446b451e$export$b920661d14a7f4e5; });
$parcel$export(module.exports, "AppDataProvider", function () { return $53380c4e446b451e$export$290f54627ecea6a8; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");
const $53380c4e446b451e$export$7dc2bc02137acda8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createContext({
    features: {},
    navigationIsOpen: true,
    frontbucket_environment: "local",
    frontbucket_version: "local",
    links: {
        overviewUrl: "",
        backButtonUrl: undefined
    },
    initialContext: {}
});
const $53380c4e446b451e$export$a9d8a52df866299 = ()=>{
    return (0, $9nHZC.useContext)($53380c4e446b451e$export$7dc2bc02137acda8);
};
const $53380c4e446b451e$export$b920661d14a7f4e5 = (key, defaultValue)=>{
    const appData = $53380c4e446b451e$export$a9d8a52df866299();
    return (0, $9nHZC.useMemo)(()=>{
        var _ref;
        return (_ref = appData.features[key] || defaultValue) !== null && _ref !== void 0 ? _ref : false;
    }, [
        appData,
        key,
        defaultValue
    ]);
};
const $53380c4e446b451e$export$cc011674bc3ec368 = (Component)=>(props)=>{
        const appData = $53380c4e446b451e$export$a9d8a52df866299();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
            appData: appData
        }));
    };
const $53380c4e446b451e$export$433a2fc948372a32 = (key, propKey, defaultValue)=>(Component)=>(props)=>{
            const appData = $53380c4e446b451e$export$a9d8a52df866299();
            const value = (0, $9nHZC.useMemo)(()=>{
                var _ref2;
                return (_ref2 = appData.features[key] || defaultValue) !== null && _ref2 !== void 0 ? _ref2 : false;
            }, [
                appData
            ]);
            const propsWithFeature = {
                ...props,
                [propKey || key]: value
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Component, propsWithFeature);
        };
const $53380c4e446b451e$export$290f54627ecea6a8 = ({ appData: appData = {
    navigationIsOpen: true,
    features: {},
    frontbucket_environment: "local",
    frontbucket_version: "local",
    links: {
        overviewUrl: "",
        backButtonUrl: undefined
    },
    initialContext: {}
}, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($53380c4e446b451e$export$7dc2bc02137acda8.Provider, {
        value: appData
    }, children);
};

});

parcelRegister("3wXS7", function(module, exports) {

$parcel$export(module.exports, "HiddenLoader", function () { return $ffc6eea737c49b6d$export$8ea012ed4c72b26c; });
$parcel$export(module.exports, "LoadingPage", function () { return $ffc6eea737c49b6d$export$7343d23d6bc16d75; });

var $9nHZC = parcelRequire("9nHZC");

var $dQqAn = parcelRequire("dQqAn");
parcelRequire("jyUKE");
var $jmbnP = parcelRequire("jmbnP");

var $2dDP1 = parcelRequire("2dDP1");

var $628YF = parcelRequire("628YF");
// This is an async function so any exception thrown by Sentry turns into a Promise rejection
// eslint-disable-next-line require-await
const $ffc6eea737c49b6d$var$captureError = async (error)=>{
    var _error$target;
    if (typeof error === "string") return (0, $628YF.captureMessageWithTags)(error, {
        component: "react-loadable"
    });
    if (error instanceof Error) return (0, $628YF.captureExceptionWithTags)(error, {
        component: "react-loadable"
    });
    // Parcel rejects with an error event, not an Error
    // https://github.com/parcel-bundler/parcel/issues/6052
    // This error event should be coming from a script tag, which will have a
    // "target.src" attribute. We're using optional chaining just in case, but
    // need a ts-ignore as well
    // @ts-ignore
    const src = error instanceof Event ? (_error$target = error.target) === null || _error$target === void 0 ? void 0 : _error$target.src : undefined;
    return (0, $628YF.captureMessageWithTags)(`Unknown error loading a module with react-loadable: ${src || "unknown src"}`, {
        component: "react-loadable"
    });
};
const $ffc6eea737c49b6d$var$useReactLoadableErrorState = (error)=>{
    const [sentryEventId, setSentryEventId] = (0, $9nHZC.useState)();
    (0, $9nHZC.useEffect)(()=>{
        if (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            $ffc6eea737c49b6d$var$captureError(error).then((eventId)=>{
                setSentryEventId(eventId);
            });
        }
    }, [
        error,
        setSentryEventId
    ]);
    return sentryEventId;
};
const $ffc6eea737c49b6d$export$8ea012ed4c72b26c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo((props)=>{
    // We don't need the Sentry id for anything, we just want to capture and log the errors
    $ffc6eea737c49b6d$var$useReactLoadableErrorState(props.error);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dQqAn.default), {
        name: "hidden-loader"
    });
});
const $ffc6eea737c49b6d$export$7343d23d6bc16d75 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo((props)=>{
    const { error: error } = props;
    const sentryEventId = $ffc6eea737c49b6d$var$useReactLoadableErrorState(error);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $jmbnP.GlobalErrorPage), {
        sentryEventId: sentryEventId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2dDP1.LoadingPage), null);
});

});
parcelRegister("jyUKE", function(module, exports) {

$parcel$export(module.exports, "GlobalError", function () { return (parcelRequire("jmbnP")).GlobalError; });
$parcel$export(module.exports, "GlobalErrorPage", function () { return (parcelRequire("jmbnP")).GlobalErrorPage; });
$parcel$export(module.exports, "SectionError", function () { return (parcelRequire("jfseu")).SectionError; });
$parcel$export(module.exports, "GlobalErrorBoundary", function () { return (parcelRequire("hKvmF")).GlobalErrorBoundary; });
$parcel$export(module.exports, "SectionErrorBoundary", function () { return (parcelRequire("QXGvp")).SectionErrorBoundary; });

var $jmbnP = parcelRequire("jmbnP");

var $jfseu = parcelRequire("jfseu");

var $hKvmF = parcelRequire("hKvmF");

var $QXGvp = parcelRequire("QXGvp");

});
parcelRegister("jmbnP", function(module, exports) {

$parcel$export(module.exports, "GlobalError", function () { return $17341235bf5be42b$export$dd28493542fc4ab7; });
$parcel$export(module.exports, "GlobalErrorPage", function () { return $17341235bf5be42b$export$2fdf2ad477f80626; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $9waMY = parcelRequire("9waMY");

var $5IoKr = parcelRequire("5IoKr");

var $ddBsF = parcelRequire("ddBsF");

var $gqm8H = parcelRequire("gqm8H");
const $17341235bf5be42b$export$dd28493542fc4ab7 = (0, $agjvf.injectIntl)(({ intl: intl, sentryEventId: sentryEventId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($gqm8H.Center, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($gqm8H.ErrorImage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("img", {
        alt: intl.formatMessage((0, $ddBsF.default).alertSymbol),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5IoKr)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, (0, $ddBsF.default).notice, {
        tagName: "h3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, (0, $ddBsF.default).keepsHappening, {
        values: {
            statusPageLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("a", {
                href: (0, $9waMY.default).external.statusPage,
                target: "_blank"
            }, "bitbucket.status.atlassian.com")
        },
        tagName: "p"
    })), sentryEventId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("code", null, sentryEventId))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, (0, $ddBsF.default).contactSupport, {
        tagName: "p"
    })))));
const $17341235bf5be42b$export$2fdf2ad477f80626 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($gqm8H.GlobalErrorPageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($17341235bf5be42b$export$dd28493542fc4ab7, {
        sentryEventId: props.sentryEventId || undefined
    }));
};

});
parcelRegister("9waMY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ae83fba83980da9$export$2e2bcd8739ae039; });

var $9H597 = parcelRequire("9H597");
var $2ae83fba83980da9$export$2e2bcd8739ae039 = {
    external: {
        support: "https://support.atlassian.com/bitbucket-cloud/",
        suggestOrRequireChecksBeforeMerge: "https://confluence.atlassian.com/x/EhMQMw",
        accessKeys: "https://confluence.atlassian.com/x/I4CNEQ",
        generateSshKey: "https://confluence.atlassian.com/x/X4FmKw",
        statusPage: "https://bitbucket.status.atlassian.com/",
        troubleshootSsh: "https://confluence.atlassian.com/x/64Y1E",
        repositoryAccessToUsersAndGroupsInfo: "https://confluence.atlassian.com/x/9A0zDQ",
        mergeChecks: "https://support.atlassian.com/bitbucket-cloud/docs/suggest-or-require-checks-before-a-merge/"
    },
    ui: {
        createBranch: (issueKey, issueType, issueSummary)=>{
            const query = (0, $9H597.stringify)({
                issueKey: issueKey,
                issueType: issueType,
                issueSummary: issueSummary
            });
            return `/branch/create${query}`;
        }
    }
};

});
parcelRegister("9H597", function(module, exports) {

$parcel$export(module.exports, "encodeBranchName", function () { return $2310339f16ca0c91$export$6e94117fe1e49b2d; });
$parcel$export(module.exports, "encodePath", function () { return $2310339f16ca0c91$export$20c03ce31e68a433; });
$parcel$export(module.exports, "stringify", function () { return $2310339f16ca0c91$export$fac44ee5b035f737; });
$parcel$export(module.exports, "appendParamToPath", function () { return $2310339f16ca0c91$export$8d07d687a04a2d1d; });

var $cJH1T = parcelRequire("cJH1T");
const $2310339f16ca0c91$export$6e94117fe1e49b2d = (branchName)=>// Encode `#` - Fragment Identifiers are only client-side in HTTP request URLs
    branchName.replace(/#/g, "%23");
const $2310339f16ca0c91$export$20c03ce31e68a433 = (path)=>(path || "").split("/").map(encodeURIComponent).join("/");
const $2310339f16ca0c91$export$fac44ee5b035f737 = (params, extraOptions = {})=>(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(params, {
        addQueryPrefix: true,
        skipNulls: true,
        ...extraOptions
    });
const $2310339f16ca0c91$export$8d07d687a04a2d1d = (queryParams, destUrl)=>{
    const destinationUrl = destUrl || window.location.href;
    const newUrl = new URL(destinationUrl);
    Object.keys(queryParams).forEach((item)=>newUrl.searchParams.set(item, String(queryParams[item])));
    return newUrl.href;
};

});


parcelRegister("5IoKr", function(module, exports) {

module.exports = (parcelRequire("1sJKT")).getBundleURL("ekZ4q") + "global-error-image.c1b47184.svg";

});

parcelRegister("ddBsF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $615d4ddce8c809dc$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $615d4ddce8c809dc$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    alertSymbol: {
        "id": "frontbucket.globalErrorBoundary.alertSymbol",
        "defaultMessage": "An alert symbol, indicating a general error."
    },
    contactSupport: {
        "id": "frontbucket.globalErrorBoundary.contactSupport",
        "defaultMessage": "If the problem persists, contact Support and include the code displayed above, if one is provided."
    },
    notice: {
        "id": "frontbucket.globalErrorBoundary.notice",
        "defaultMessage": "Something went wrong"
    },
    keepsHappening: {
        "id": "frontbucket.globalErrorBoundary.keepsHappening",
        "defaultMessage": "Wait a few moments, then try again. If this keeps happening, check the current operational status of Bitbucket Cloud at {statusPageLink}"
    }
});

});

parcelRegister("gqm8H", function(module, exports) {

$parcel$export(module.exports, "GlobalErrorPageWrapper", function () { return $a4ca533592797d02$export$435db93c780a785d; });
$parcel$export(module.exports, "Center", function () { return $a4ca533592797d02$export$1f54913ccc4368b1; });
$parcel$export(module.exports, "ErrorImage", function () { return $a4ca533592797d02$export$7326e6d938a8137b; });

var $2xJU3 = parcelRequire("2xJU3");

var $jp7ng = parcelRequire("jp7ng");
var $aP6k3 = parcelRequire("aP6k3");

var $h39Sh = parcelRequire("h39Sh");
const $a4ca533592797d02$export$435db93c780a785d = (0, $2xJU3.default)("div", {
    target: "embgscc0"
})("display:flex;height:100vh;justify-content:center;align-items:center;color:", (0, $h39Sh.default)("color.text.subtle", (0, $jp7ng).N500), ";");
const $a4ca533592797d02$export$1f54913ccc4368b1 = (0, $2xJU3.default)("div", {
    target: "embgscc1"
})("text-align:center;width:", (0, $aP6k3.gridSize)() * 40, "px;");
const $a4ca533592797d02$export$7326e6d938a8137b = (0, $2xJU3.default)("div", {
    target: "embgscc2"
})("width:", (0, $aP6k3.gridSize)() * 10, "px;margin:auto;");

});
parcelRegister("2xJU3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1da2453f4ee69ac0$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $3r8tv = parcelRequire("3r8tv");
parcelRequire("45CBz");
var $eDDQP = parcelRequire("eDDQP");

var $jgdi3 = parcelRequire("jgdi3");

var $lkfGR = parcelRequire("lkfGR");
var $1da2453f4ee69ac0$var$testOmitPropsOnStringTag = (0, $3r8tv.default);
var $1da2453f4ee69ac0$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme" && key !== "innerRef";
};
var $1da2453f4ee69ac0$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $1da2453f4ee69ac0$var$testOmitPropsOnStringTag : $1da2453f4ee69ac0$var$testOmitPropsOnComponent;
};
function $1da2453f4ee69ac0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1da2453f4ee69ac0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1da2453f4ee69ac0$var$ownKeys(source, true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1da2453f4ee69ac0$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $1da2453f4ee69ac0$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $1da2453f4ee69ac0$var$createStyled = function createStyled(tag, options) {
    var identifierName;
    var shouldForwardProp;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
        shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && // $FlowFixMe
            options.shouldForwardProp(propName);
        } : options.shouldForwardProp;
    }
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    var defaultShouldForwardProp = shouldForwardProp || $1da2453f4ee69ac0$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $eDDQP.w)(function(props, context, ref) {
            return (0, $9nHZC.createElement)((0, $eDDQP.T).Consumer, null, function(theme) {
                var finalTag = shouldUseAs && props.as || baseTag;
                var className = "";
                var classInterpolations = [];
                var mergedProps = props;
                if (props.theme == null) {
                    mergedProps = {};
                    for(var key in props)mergedProps[key] = props[key];
                    mergedProps.theme = theme;
                }
                if (typeof props.className === "string") className = (0, $jgdi3.getRegisteredStyles)(context.registered, classInterpolations, props.className);
                else if (props.className != null) className = props.className + " ";
                var serialized = (0, $lkfGR.serializeStyles)(styles.concat(classInterpolations), context.registered, mergedProps);
                var rules = (0, $jgdi3.insertStyles)(context, serialized, typeof finalTag === "string");
                className += context.key + "-" + serialized.name;
                if (targetClassName !== undefined) className += " " + targetClassName;
                var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $1da2453f4ee69ac0$var$getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
                var newProps = {};
                for(var _key in props){
                    if (shouldUseAs && _key === "as") continue;
                    if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
                }
                newProps.className = className;
                newProps.ref = ref || props.innerRef;
                var ele = (0, $9nHZC.createElement)(finalTag, newProps);
                return ele;
            });
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, nextOptions !== undefined ? $1da2453f4ee69ac0$var$_objectSpread({}, options || {}, {}, nextOptions) : options).apply(void 0, styles);
        };
        return Styled;
    };
};
var $1da2453f4ee69ac0$export$2e2bcd8739ae039 = $1da2453f4ee69ac0$var$createStyled;

});
parcelRegister("3r8tv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $280a77a6406e67e1$export$2e2bcd8739ae039; });

var $hZeKU = parcelRequire("hZeKU");
var $280a77a6406e67e1$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $280a77a6406e67e1$var$index = (0, $hZeKU.default)(function(prop) {
    return $280a77a6406e67e1$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $280a77a6406e67e1$export$2e2bcd8739ae039 = $280a77a6406e67e1$var$index;

});
parcelRegister("hZeKU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1839452966b51cf$export$2e2bcd8739ae039; });
function $d1839452966b51cf$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $d1839452966b51cf$export$2e2bcd8739ae039 = $d1839452966b51cf$var$memoize;

});


parcelRegister("45CBz", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $2fa59337b98eb254$export$98f03c5d19621d70; });
$parcel$export(module.exports, "keyframes", function () { return $2fa59337b98eb254$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ClassNames", function () { return $2fa59337b98eb254$export$9b9c0f9d9f3552b8; });
$parcel$export(module.exports, "jsx", function () { return $2fa59337b98eb254$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("eDDQP")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("eDDQP")).w; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("7KAwG")).default; });

var $fXGwT = parcelRequire("fXGwT");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("inEkj");

var $eDDQP = parcelRequire("eDDQP");

var $jgdi3 = parcelRequire("jgdi3");

var $aPHjT = parcelRequire("aPHjT");

var $fD7QD = parcelRequire("fD7QD");

var $7KAwG = parcelRequire("7KAwG");
var $2fa59337b98eb254$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $eDDQP.h).call(props, "css")) // $FlowFixMe
    return (0, $9nHZC.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $eDDQP.E);
    createElementArgArray[1] = (0, $eDDQP.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $9nHZC.createElement).apply(null, createElementArgArray);
};
var $2fa59337b98eb254$var$warnedAboutCssPropForGlobal = false;
var $2fa59337b98eb254$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $eDDQP.w)(function(props, cache) {
    var styles = props.styles;
    if (typeof styles === "function") return /*#__PURE__*/ (0, $9nHZC.createElement)((0, $eDDQP.T).Consumer, null, function(theme) {
        var serialized = (0, $aPHjT.serializeStyles)([
            styles(theme)
        ]);
        return /*#__PURE__*/ (0, $9nHZC.createElement)($2fa59337b98eb254$var$InnerGlobal, {
            serialized: serialized,
            cache: cache
        });
    });
    var serialized = (0, $aPHjT.serializeStyles)([
        styles
    ]);
    return /*#__PURE__*/ (0, $9nHZC.createElement)($2fa59337b98eb254$var$InnerGlobal, {
        serialized: serialized,
        cache: cache
    });
});
// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $2fa59337b98eb254$var$InnerGlobal = /*#__PURE__*/ function(_React$Component) {
    (0, $fXGwT.default)(InnerGlobal, _React$Component);
    function InnerGlobal(props, context, updater) {
        return _React$Component.call(this, props, context, updater) || this;
    }
    var _proto = InnerGlobal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.sheet = new (0, $fD7QD.StyleSheet)({
            key: this.props.cache.key + "-global",
            nonce: this.props.cache.sheet.nonce,
            container: this.props.cache.sheet.container
        }); // $FlowFixMe
        var node = document.querySelector("style[data-emotion-" + this.props.cache.key + '="' + this.props.serialized.name + '"]');
        if (node !== null) this.sheet.tags.push(node);
        if (this.props.cache.sheet.tags.length) this.sheet.before = this.props.cache.sheet.tags[0];
        this.insertStyles();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.serialized.name !== this.props.serialized.name) this.insertStyles();
    };
    _proto.insertStyles = function insertStyles$1() {
        if (this.props.serialized.next !== undefined) // insert keyframes
        (0, $jgdi3.insertStyles)(this.props.cache, this.props.serialized.next, true);
        if (this.sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
            this.sheet.before = element;
            this.sheet.flush();
        }
        this.props.cache.insert("", this.props.serialized, this.sheet, false);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.sheet.flush();
    };
    _proto.render = function render() {
        return null;
    };
    return InnerGlobal;
}((0, $9nHZC.Component));
var $2fa59337b98eb254$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = (0, $7KAwG.default).apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $2fa59337b98eb254$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $2fa59337b98eb254$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $jgdi3.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $2fa59337b98eb254$var$Noop = function Noop() {
    return null;
};
var $2fa59337b98eb254$export$9b9c0f9d9f3552b8 = (0, $eDDQP.w)(function(props, context) {
    return /*#__PURE__*/ (0, $9nHZC.createElement)((0, $eDDQP.T).Consumer, null, function(theme) {
        var hasRendered = false;
        var css = function css() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var serialized = (0, $aPHjT.serializeStyles)(args, context.registered);
            (0, $jgdi3.insertStyles)(context, serialized, false);
            return context.key + "-" + serialized.name;
        };
        var cx = function cx() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return $2fa59337b98eb254$var$merge(context.registered, css, $2fa59337b98eb254$var$classnames(args));
        };
        var content = {
            css: css,
            cx: cx,
            theme: theme
        };
        var ele = props.children(content);
        hasRendered = true;
        var possiblyStyleElement = /*#__PURE__*/ (0, $9nHZC.createElement)($2fa59337b98eb254$var$Noop, null);
        return /*#__PURE__*/ (0, $9nHZC.createElement)((0, $9nHZC.Fragment), null, possiblyStyleElement, ele);
    });
});

});
parcelRegister("inEkj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d619a8012a1d9880$export$2e2bcd8739ae039; });

var $fD7QD = parcelRequire("fD7QD");

var $iKiRq = parcelRequire("iKiRq");
parcelRequire("hhKuv");
// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var $d619a8012a1d9880$var$delimiter = "/*|*/";
var $d619a8012a1d9880$var$needle = $d619a8012a1d9880$var$delimiter + "}";
function $d619a8012a1d9880$var$toSheet(block) {
    if (block) $d619a8012a1d9880$var$Sheet.current.insert(block + "}");
}
var $d619a8012a1d9880$var$Sheet = {
    current: null
};
var $d619a8012a1d9880$var$ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    $d619a8012a1d9880$var$Sheet.current.insert(content + ";");
                    return "";
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return "";
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + $d619a8012a1d9880$var$delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    $d619a8012a1d9880$var$Sheet.current.insert(selectors[0] + content);
                    return "";
                default:
                    return content + (at === 0 ? $d619a8012a1d9880$var$delimiter : "");
            }
        case -2:
            content.split($d619a8012a1d9880$var$needle).forEach($d619a8012a1d9880$var$toSheet);
    }
};
var $d619a8012a1d9880$var$createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || "css";
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, $iKiRq.default)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(" ").forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)($d619a8012a1d9880$var$ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        $d619a8012a1d9880$var$Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, $fD7QD.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
var $d619a8012a1d9880$export$2e2bcd8739ae039 = $d619a8012a1d9880$var$createCache;

});
parcelRegister("fD7QD", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $b61095f7021d46ed$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $b61095f7021d46ed$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $b61095f7021d46ed$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    return tag;
}
var $b61095f7021d46ed$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
            var _tag = $b61095f7021d46ed$var$createStyleElement(this);
            var before;
            if (this.tags.length === 0) before = this.before;
            else before = this.tags[this.tags.length - 1].nextSibling;
            this.container.insertBefore(_tag, before);
            this.tags.push(_tag);
        }
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $b61095f7021d46ed$var$sheetForTag(tag);
            try {
                // this is a really hot path
                // we check the second character first because having "i"
                // as the second character will happen less often than
                // having "@" as the first character
                var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, // otherwise there will be an error
                // technically this means that the @import rules will
                // _usually_(not always since there could be multiple style tags)
                // be the first ones in prod and generally later in dev
                // this shouldn't really matter in the real world though
                // @import is generally only used for font faces from google fonts and etc.
                // so while this could be technically correct then it would be slower and larger
                // for a tiny bit of correctness that won't matter in the real world
                isImportRule ? 0 : sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("iKiRq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da5b2730f642ca0b$export$2e2bcd8739ae039; });
function $da5b2730f642ca0b$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\x00\x00"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\x00");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $da5b2730f642ca0b$export$2e2bcd8739ae039 = $da5b2730f642ca0b$var$stylis_min;

});

parcelRegister("hhKuv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c958165f96c642cf$export$2e2bcd8739ae039; });
var $c958165f96c642cf$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $c958165f96c642cf$export$2e2bcd8739ae039 = $c958165f96c642cf$var$weakMemoize;

});


parcelRegister("eDDQP", function(module, exports) {

$parcel$export(module.exports, "h", function () { return $aa839ecc2627b4e2$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "T", function () { return $aa839ecc2627b4e2$export$971d5caa766a69d7; });
$parcel$export(module.exports, "w", function () { return $aa839ecc2627b4e2$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "c", function () { return $aa839ecc2627b4e2$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $aa839ecc2627b4e2$export$a9c23c6ac3fc3eca; });
parcelRequire("2mGxr");

var $9nHZC = parcelRequire("9nHZC");

var $inEkj = parcelRequire("inEkj");

var $jgdi3 = parcelRequire("jgdi3");

var $aPHjT = parcelRequire("aPHjT");
var $aa839ecc2627b4e2$export$dda1d9f60106f0e9 = Object.prototype.hasOwnProperty;
var $aa839ecc2627b4e2$var$EmotionCacheContext = /*#__PURE__*/ (0, $9nHZC.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? (0, $inEkj.default)() : null);
var $aa839ecc2627b4e2$export$971d5caa766a69d7 = /*#__PURE__*/ (0, $9nHZC.createContext)({});
var $aa839ecc2627b4e2$export$e7094788287c5e9b = $aa839ecc2627b4e2$var$EmotionCacheContext.Provider;
var $aa839ecc2627b4e2$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    var render = function render(props, ref) {
        return /*#__PURE__*/ (0, $9nHZC.createElement)($aa839ecc2627b4e2$var$EmotionCacheContext.Consumer, null, function(cache) {
            return func(props, cache, ref);
        });
    }; // $FlowFixMe
    return /*#__PURE__*/ (0, $9nHZC.forwardRef)(render);
};
// thus we only need to replace what is a valid character for JS, but not for CSS
var $aa839ecc2627b4e2$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $aa839ecc2627b4e2$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $aa839ecc2627b4e2$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $aa839ecc2627b4e2$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($aa839ecc2627b4e2$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$aa839ecc2627b4e2$var$typePropName] = type; // TODO: check if this still works with all of those different JSX functions
    var error, match;
    return newProps;
};
var $aa839ecc2627b4e2$var$Noop = function Noop() {
    return null;
};
var $aa839ecc2627b4e2$var$render = function render(cache, props, theme, ref) {
    var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var type = props[$aa839ecc2627b4e2$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $jgdi3.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $aPHjT.serializeStyles)(registeredStyles);
    var labelFromStack;
    var rules = (0, $jgdi3.insertStyles)(cache, serialized, typeof type === "string");
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($aa839ecc2627b4e2$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $aa839ecc2627b4e2$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    var ele = /*#__PURE__*/ (0, $9nHZC.createElement)(type, newProps);
    var possiblyStyleElement = /*#__PURE__*/ (0, $9nHZC.createElement)($aa839ecc2627b4e2$var$Noop, null);
    return /*#__PURE__*/ (0, $9nHZC.createElement)((0, $9nHZC.Fragment), null, possiblyStyleElement, ele);
}; // eslint-disable-next-line no-undef
var $aa839ecc2627b4e2$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $aa839ecc2627b4e2$export$efccba1c4a2ef57b(function(props, cache, ref) {
    if (typeof props.css === "function") return /*#__PURE__*/ (0, $9nHZC.createElement)($aa839ecc2627b4e2$export$971d5caa766a69d7.Consumer, null, function(theme) {
        return $aa839ecc2627b4e2$var$render(cache, props, theme, ref);
    });
    return $aa839ecc2627b4e2$var$render(cache, props, null, ref);
});

});
parcelRegister("jgdi3", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $e059d2200b1b973b$export$95d99596f328fd52; });
$parcel$export(module.exports, "insertStyles", function () { return $e059d2200b1b973b$export$6f077d94b33a01aa; });
var $e059d2200b1b973b$var$isBrowser = true;
function $e059d2200b1b973b$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className]);
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $e059d2200b1b973b$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $e059d2200b1b973b$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("aPHjT", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $7e304534bcc0eb66$export$6321afa313b251b5; });

var $b07Hm = parcelRequire("b07Hm");

var $aLuOp = parcelRequire("aLuOp");

var $hZeKU = parcelRequire("hZeKU");
var $7e304534bcc0eb66$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $7e304534bcc0eb66$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $7e304534bcc0eb66$var$hyphenateRegex = /[A-Z]|^ms/g;
var $7e304534bcc0eb66$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $7e304534bcc0eb66$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $7e304534bcc0eb66$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $7e304534bcc0eb66$var$processStyleName = (0, $hZeKU.default)(function(styleName) {
    return $7e304534bcc0eb66$var$isCustomProperty(styleName) ? styleName : styleName.replace($7e304534bcc0eb66$var$hyphenateRegex, "-$&").toLowerCase();
});
var $7e304534bcc0eb66$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($7e304534bcc0eb66$var$animationRegex, function(match, p1, p2) {
                $7e304534bcc0eb66$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $7e304534bcc0eb66$var$cursor
                };
                return p1;
            });
    }
    if ((0, $aLuOp.default)[key] !== 1 && !$7e304534bcc0eb66$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $7e304534bcc0eb66$var$contentValuePattern, $7e304534bcc0eb66$var$contentValues, $7e304534bcc0eb66$var$oldProcessStyleValue, $7e304534bcc0eb66$var$msPattern, $7e304534bcc0eb66$var$hyphenPattern, $7e304534bcc0eb66$var$hyphenatedCache;
var $7e304534bcc0eb66$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $7e304534bcc0eb66$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $7e304534bcc0eb66$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $7e304534bcc0eb66$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $7e304534bcc0eb66$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $7e304534bcc0eb66$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $7e304534bcc0eb66$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $7e304534bcc0eb66$var$cursor;
                var result = interpolation(mergedProps);
                $7e304534bcc0eb66$var$cursor = previousCursor;
                return $7e304534bcc0eb66$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $7e304534bcc0eb66$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $7e304534bcc0eb66$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($7e304534bcc0eb66$var$isProcessableValue(value)) string += $7e304534bcc0eb66$var$processStyleName(_key) + ":" + $7e304534bcc0eb66$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($7e304534bcc0eb66$var$isProcessableValue(value[_i])) string += $7e304534bcc0eb66$var$processStyleName(_key) + ":" + $7e304534bcc0eb66$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $7e304534bcc0eb66$var$handleInterpolation(mergedProps, registered, value, false);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $7e304534bcc0eb66$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $7e304534bcc0eb66$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $7e304534bcc0eb66$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $7e304534bcc0eb66$var$cursor;
var $7e304534bcc0eb66$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $7e304534bcc0eb66$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $7e304534bcc0eb66$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $7e304534bcc0eb66$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $7e304534bcc0eb66$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $7e304534bcc0eb66$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $b07Hm.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $7e304534bcc0eb66$var$cursor
    };
};

});
parcelRegister("b07Hm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8025aa81a4efda56$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $8025aa81a4efda56$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $8025aa81a4efda56$export$2e2bcd8739ae039 = $8025aa81a4efda56$var$murmur2;

});

parcelRegister("aLuOp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d6631c93961f143$export$2e2bcd8739ae039; });
var $7d6631c93961f143$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $7d6631c93961f143$export$2e2bcd8739ae039 = $7d6631c93961f143$var$unitlessKeys;

});



parcelRegister("7KAwG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a4929a026361034$export$2e2bcd8739ae039; });

var $9RzhV = parcelRequire("9RzhV");
function $5a4929a026361034$var$css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $9RzhV.serializeStyles)(args);
}
var $5a4929a026361034$export$2e2bcd8739ae039 = $5a4929a026361034$var$css;

});
parcelRegister("9RzhV", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $72e46fc96e533e1b$export$6321afa313b251b5; });

var $b07Hm = parcelRequire("b07Hm");

var $1oOhs = parcelRequire("1oOhs");

var $hZeKU = parcelRequire("hZeKU");
var $72e46fc96e533e1b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $72e46fc96e533e1b$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $72e46fc96e533e1b$var$hyphenateRegex = /[A-Z]|^ms/g;
var $72e46fc96e533e1b$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $72e46fc96e533e1b$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $72e46fc96e533e1b$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $72e46fc96e533e1b$var$processStyleName = (0, $hZeKU.default)(function(styleName) {
    return $72e46fc96e533e1b$var$isCustomProperty(styleName) ? styleName : styleName.replace($72e46fc96e533e1b$var$hyphenateRegex, "-$&").toLowerCase();
});
var $72e46fc96e533e1b$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($72e46fc96e533e1b$var$animationRegex, function(match, p1, p2) {
                $72e46fc96e533e1b$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $72e46fc96e533e1b$var$cursor
                };
                return p1;
            });
    }
    if ((0, $1oOhs.default)[key] !== 1 && !$72e46fc96e533e1b$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $72e46fc96e533e1b$var$contentValuePattern, $72e46fc96e533e1b$var$contentValues, $72e46fc96e533e1b$var$oldProcessStyleValue, $72e46fc96e533e1b$var$msPattern, $72e46fc96e533e1b$var$hyphenPattern, $72e46fc96e533e1b$var$hyphenatedCache;
var $72e46fc96e533e1b$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $72e46fc96e533e1b$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $72e46fc96e533e1b$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $72e46fc96e533e1b$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $72e46fc96e533e1b$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $72e46fc96e533e1b$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $72e46fc96e533e1b$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $72e46fc96e533e1b$var$cursor;
                var result = interpolation(mergedProps);
                $72e46fc96e533e1b$var$cursor = previousCursor;
                return $72e46fc96e533e1b$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $72e46fc96e533e1b$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $72e46fc96e533e1b$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($72e46fc96e533e1b$var$isProcessableValue(value)) string += $72e46fc96e533e1b$var$processStyleName(_key) + ":" + $72e46fc96e533e1b$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($72e46fc96e533e1b$var$isProcessableValue(value[_i])) string += $72e46fc96e533e1b$var$processStyleName(_key) + ":" + $72e46fc96e533e1b$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $72e46fc96e533e1b$var$handleInterpolation(mergedProps, registered, value, false);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $72e46fc96e533e1b$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $72e46fc96e533e1b$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $72e46fc96e533e1b$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $72e46fc96e533e1b$var$cursor;
var $72e46fc96e533e1b$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $72e46fc96e533e1b$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $72e46fc96e533e1b$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $72e46fc96e533e1b$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $72e46fc96e533e1b$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $72e46fc96e533e1b$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $b07Hm.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $72e46fc96e533e1b$var$cursor
    };
};

});
parcelRegister("1oOhs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $104f08fd05655e3b$export$2e2bcd8739ae039; });
var $104f08fd05655e3b$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $104f08fd05655e3b$export$2e2bcd8739ae039 = $104f08fd05655e3b$var$unitlessKeys;

});




parcelRegister("lkfGR", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $f867a2ff3da8460c$export$6321afa313b251b5; });

var $b07Hm = parcelRequire("b07Hm");

var $n8n5X = parcelRequire("n8n5X");

var $hZeKU = parcelRequire("hZeKU");
var $f867a2ff3da8460c$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $f867a2ff3da8460c$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $f867a2ff3da8460c$var$hyphenateRegex = /[A-Z]|^ms/g;
var $f867a2ff3da8460c$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $f867a2ff3da8460c$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $f867a2ff3da8460c$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $f867a2ff3da8460c$var$processStyleName = (0, $hZeKU.default)(function(styleName) {
    return $f867a2ff3da8460c$var$isCustomProperty(styleName) ? styleName : styleName.replace($f867a2ff3da8460c$var$hyphenateRegex, "-$&").toLowerCase();
});
var $f867a2ff3da8460c$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($f867a2ff3da8460c$var$animationRegex, function(match, p1, p2) {
                $f867a2ff3da8460c$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $f867a2ff3da8460c$var$cursor
                };
                return p1;
            });
    }
    if ((0, $n8n5X.default)[key] !== 1 && !$f867a2ff3da8460c$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $f867a2ff3da8460c$var$contentValuePattern, $f867a2ff3da8460c$var$contentValues, $f867a2ff3da8460c$var$oldProcessStyleValue, $f867a2ff3da8460c$var$msPattern, $f867a2ff3da8460c$var$hyphenPattern, $f867a2ff3da8460c$var$hyphenatedCache;
var $f867a2ff3da8460c$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $f867a2ff3da8460c$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $f867a2ff3da8460c$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $f867a2ff3da8460c$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $f867a2ff3da8460c$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $f867a2ff3da8460c$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $f867a2ff3da8460c$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $f867a2ff3da8460c$var$cursor;
                var result = interpolation(mergedProps);
                $f867a2ff3da8460c$var$cursor = previousCursor;
                return $f867a2ff3da8460c$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $f867a2ff3da8460c$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $f867a2ff3da8460c$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($f867a2ff3da8460c$var$isProcessableValue(value)) string += $f867a2ff3da8460c$var$processStyleName(_key) + ":" + $f867a2ff3da8460c$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($f867a2ff3da8460c$var$isProcessableValue(value[_i])) string += $f867a2ff3da8460c$var$processStyleName(_key) + ":" + $f867a2ff3da8460c$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $f867a2ff3da8460c$var$handleInterpolation(mergedProps, registered, value, false);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $f867a2ff3da8460c$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $f867a2ff3da8460c$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $f867a2ff3da8460c$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $f867a2ff3da8460c$var$cursor;
var $f867a2ff3da8460c$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $f867a2ff3da8460c$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $f867a2ff3da8460c$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $f867a2ff3da8460c$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $f867a2ff3da8460c$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $f867a2ff3da8460c$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $b07Hm.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $f867a2ff3da8460c$var$cursor
    };
};

});
parcelRegister("n8n5X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0458a480c489219f$export$2e2bcd8739ae039; });
var $0458a480c489219f$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $0458a480c489219f$export$2e2bcd8739ae039 = $0458a480c489219f$var$unitlessKeys;

});





parcelRegister("jfseu", function(module, exports) {

$parcel$export(module.exports, "SectionError", function () { return $c8dc13b8af410695$export$1142f7f46d50535e; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $3THTN = parcelRequire("3THTN");

var $e188l = parcelRequire("e188l");

var $ieOPK = parcelRequire("ieOPK");

var $5hykE = parcelRequire("5hykE");
const $c8dc13b8af410695$export$1142f7f46d50535e = (0, $agjvf.injectIntl)(({ intl: intl, sectionHeading: sectionHeading, sentryEventId: sentryEventId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($5hykE.SectionErrorContainer, null, sectionHeading, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $e188l.default), {
        appearance: "error",
        title: intl.formatMessage((0, $ieOPK.default).title)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, (0, $ieOPK.default).keepsHappening, {
        values: {
            supportResourcesLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("a", {
                href: "https://support.atlassian.com/bitbucket-cloud/"
            }, intl.formatMessage((0, $ieOPK.default).supportResourcesLink)),
            tryAgainLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3THTN.default), {
                onClick: ()=>window.location.reload(),
                appearance: "link",
                spacing: "none"
            }, intl.formatMessage((0, $ieOPK.default).tryAgainLink))
        },
        tagName: "p"
    })), sentryEventId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, (0, $ieOPK.default).errorCode, {
        tagName: "p"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($5hykE.SentryErrorCode, null, sentryEventId))))));

});
parcelRegister("e188l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a34777d52887984d$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $7FDyB = parcelRequire("7FDyB");

var $2yEOW = parcelRequire("2yEOW");
var $kMt0P = parcelRequire("kMt0P");
var $laOK3 = parcelRequire("laOK3");
var $errhD = parcelRequire("errhD");
var $byUEt = parcelRequire("byUEt");

var $90RLC = parcelRequire("90RLC");
var $a34777d52887984d$var$sectionMessageStyles = (0, $byUEt.xcss)({
    wordBreak: "break-word",
    borderRadius: "border.radius"
});
var $a34777d52887984d$var$bleedStyles = (0, $byUEt.xcss)({
    display: "flex",
    marginBlock: "space.negative.025"
});
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ var $a34777d52887984d$var$SectionMessage = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function SectionMessage(_ref, ref) {
    var children = _ref.children, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "information" : _ref$appearance, actions = _ref.actions, title = _ref.title, icon = _ref.icon, testId = _ref.testId;
    var _getAppearanceIconSty = (0, $90RLC.getAppearanceIconStyles)(appearance, icon), primaryColor = _getAppearanceIconSty.primaryIconColor, secondaryColor = _getAppearanceIconSty.backgroundColor, Icon = _getAppearanceIconSty.Icon;
    var actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment ? actions.props.children : actions;
    var actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2yEOW.default), {
        as: "section",
        backgroundColor: $a34777d52887984d$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $a34777d52887984d$var$sectionMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kMt0P.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2yEOW.default), {
        xcss: $a34777d52887984d$var$bleedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $laOK3.default), {
        space: "space.100",
        testId: testId && "".concat(testId, "--content")
    }, !!title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7FDyB.default), {
        as: "h2",
        size: "small"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $errhD.default), null, children), actionsArray.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kMt0P.default), {
        shouldWrap: true,
        testId: testId && "".concat(testId, "--actions"),
        separator: "\xb7",
        space: "space.100",
        rowSpace: "space.0"
    }, actionsArray))));
});
var $a34777d52887984d$var$appearanceMap = {
    information: "color.background.information",
    warning: "color.background.warning",
    error: "color.background.danger",
    success: "color.background.success",
    discovery: "color.background.discovery"
};
$a34777d52887984d$var$SectionMessage.displayName = "SectionMessage";
var $a34777d52887984d$export$2e2bcd8739ae039 = $a34777d52887984d$var$SectionMessage;

});
parcelRegister("7FDyB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $595b0bf8bcb8f856$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9q1kH = parcelRequire("9q1kH");

var $avKww = parcelRequire("avKww");

var $fM2vz = parcelRequire("fM2vz");

var $bsTar = parcelRequire("bsTar");

var $8ovux = parcelRequire("8ovux");
var $595b0bf8bcb8f856$var$_excluded = [
    "level"
];
// https://atlassian.design/foundations/typography
var $595b0bf8bcb8f856$var$levelMap = {
    h900: "h1",
    h800: "h1",
    h700: "h2",
    h600: "h3",
    h500: "h4",
    h400: "h5",
    h300: "h6",
    // NB: These two levels are not covered at all by the existing @atlaskit/css-reset
    h200: "div",
    h100: "div"
};
var $595b0bf8bcb8f856$var$headingResetStyles = (0, $avKww.css)({
    color: "var(--ds-text, #172B4D)",
    marginBlock: "var(--ds-space-0, 0px)"
});
var $595b0bf8bcb8f856$var$h900Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-600, 35px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-600, 40px)"
});
var $595b0bf8bcb8f856$var$h800Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-500, 29px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-500, 32px)"
});
var $595b0bf8bcb8f856$var$h700Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-400, 24px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-400, 28px)"
});
var $595b0bf8bcb8f856$var$h600Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-300, 20px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.008em",
    lineHeight: "var(--ds-font-lineHeight-300, 24px)"
});
var $595b0bf8bcb8f856$var$h500Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-200, 16px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.006em",
    lineHeight: "var(--ds-font-lineHeight-200, 20px)"
});
var $595b0bf8bcb8f856$var$h400Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-100, 14px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.003em",
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $595b0bf8bcb8f856$var$h300Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)",
    textTransform: "uppercase"
});
var $595b0bf8bcb8f856$var$h200Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $595b0bf8bcb8f856$var$h100Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-050, 11px)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $595b0bf8bcb8f856$var$inverseStyles = (0, $avKww.css)({
    color: "var(--ds-text-inverse, #FFF)"
});
var $595b0bf8bcb8f856$var$subtlestStyles = (0, $avKww.css)({
    color: "var(--ds-text-subtlest, #6B778C)"
});
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ var $595b0bf8bcb8f856$var$OldHeading = function OldHeading(_ref) {
    var children = _ref.children, level = _ref.level, id = _ref.id, testId = _ref.testId, as = _ref.as, _ref$color = _ref.color, color = _ref$color === void 0 ? "default" : _ref$color;
    typeof $8ovux;
    var _useHeading = (0, $fM2vz.useHeading)($595b0bf8bcb8f856$var$levelMap[level]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Markup = as || inferredElement;
    var isSubtleHeading = level === "h200" || level === "h100";
    var needsAriaRole = Markup === "div" && hLevel;
    return (0, $avKww.jsx)(Markup, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $595b0bf8bcb8f856$var$headingResetStyles,
            level === "h100" && $595b0bf8bcb8f856$var$h100Styles,
            level === "h200" && $595b0bf8bcb8f856$var$h200Styles,
            level === "h300" && $595b0bf8bcb8f856$var$h300Styles,
            level === "h400" && $595b0bf8bcb8f856$var$h400Styles,
            level === "h500" && $595b0bf8bcb8f856$var$h500Styles,
            level === "h600" && $595b0bf8bcb8f856$var$h600Styles,
            level === "h700" && $595b0bf8bcb8f856$var$h700Styles,
            level === "h800" && $595b0bf8bcb8f856$var$h800Styles,
            level === "h900" && $595b0bf8bcb8f856$var$h900Styles,
            color === "inverse" && $595b0bf8bcb8f856$var$inverseStyles,
            color === "default" && isSubtleHeading && $595b0bf8bcb8f856$var$subtlestStyles
        ]
    }, children);
};
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * // New component
 * <Heading size="xxlarge">Page title</Heading>
 *
 * // Old component
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ var $595b0bf8bcb8f856$var$Heading = function Heading(_ref2) {
    var level = _ref2.level, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref2, $595b0bf8bcb8f856$var$_excluded);
    return level ? // eslint-disable-next-line jsx-a11y/heading-has-content, @repo/internal/react/no-unsafe-spread-props
    (0, $avKww.jsx)($595b0bf8bcb8f856$var$OldHeading, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        level: level
    }, props)) : // eslint-disable-next-line jsx-a11y/heading-has-content, @repo/internal/react/no-unsafe-spread-props
    (0, $avKww.jsx)((0, $bsTar.default), props);
};
var $595b0bf8bcb8f856$export$2e2bcd8739ae039 = $595b0bf8bcb8f856$var$Heading;

});
parcelRegister("fM2vz", function(module, exports) {

$parcel$export(module.exports, "useHeading", function () { return $b7bd48c64f5f0bd6$export$97a37b1befbbf9b1; });

var $9nHZC = parcelRequire("9nHZC");
// Allows support for heading levels 1-9 via aria-level
var $b7bd48c64f5f0bd6$var$HeadingLevelContext = /*#__PURE__*/ (0, $9nHZC.createContext)(0);
var $b7bd48c64f5f0bd6$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $9nHZC.useContext)($b7bd48c64f5f0bd6$var$HeadingLevelContext);
};
var $b7bd48c64f5f0bd6$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $b7bd48c64f5f0bd6$export$6a64a1e2d0bbbf75();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? "div" : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $b7bd48c64f5f0bd6$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $b7bd48c64f5f0bd6$export$6a64a1e2d0bbbf75();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($b7bd48c64f5f0bd6$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $b7bd48c64f5f0bd6$export$2e2bcd8739ae039 = $b7bd48c64f5f0bd6$var$HeadingLevelContextProvider;

});

parcelRegister("bsTar", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $858d1a5adb2e69e3$export$2e2bcd8739ae039; });

var $9q1kH = parcelRequire("9q1kH");

var $avKww = parcelRequire("avKww");

var $4lSQV = parcelRequire("4lSQV");
var $gUoZ0 = parcelRequire("gUoZ0");

var $fM2vz = parcelRequire("fM2vz");

var $8ovux = parcelRequire("8ovux");
var $858d1a5adb2e69e3$var$sizeTagMap = {
    xxlarge: "h1",
    xlarge: "h1",
    large: "h2",
    medium: "h3",
    small: "h4",
    xsmall: "h5",
    xxsmall: "h6"
};
var $858d1a5adb2e69e3$var$headingResetStyles = (0, $avKww.css)({
    letterSpacing: "normal",
    marginBlock: 0,
    textTransform: "none"
});
var $858d1a5adb2e69e3$var$useColor = function useColor(colorProp) {
    var surface = (0, $gUoZ0.useSurface)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $4lSQV.inverseColorMap).hasOwnProperty(surface)) return (0, $4lSQV.inverseColorMap)[surface];
    return colorProp || "color.text";
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $858d1a5adb2e69e3$var$Heading = function Heading(_ref) {
    var children = _ref.children, size = _ref.size, id = _ref.id, testId = _ref.testId, as = _ref.as, colorProp = _ref.color;
    typeof $8ovux;
    // Technically size can be undefined here due to how the types work.
    // Once removing the level prop this assertion can be removed since size will be a required prop.
    var _useHeading = (0, $fM2vz.useHeading)($858d1a5adb2e69e3$var$sizeTagMap[size]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === "div" && hLevel;
    var color = $858d1a5adb2e69e3$var$useColor(colorProp);
    return (0, $avKww.jsx)(Component, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $858d1a5adb2e69e3$var$headingResetStyles,
            size && $858d1a5adb2e69e3$var$headingSizeStylesMap[size],
            $858d1a5adb2e69e3$export$93e8ddd840a408f9[color]
        ]
    }, children);
};
var $858d1a5adb2e69e3$export$93e8ddd840a408f9 = {
    "color.text": (0, $avKww.css)({
        color: "var(--ds-text, #172B4D)"
    }),
    "color.text.inverse": (0, $avKww.css)({
        color: "var(--ds-text-inverse, #FFFFFF)"
    }),
    "color.text.warning.inverse": (0, $avKww.css)({
        color: "var(--ds-text-warning-inverse, #172B4D)"
    })
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df829c6c0aa19bb57c0c77dc08d12d60>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $858d1a5adb2e69e3$var$headingSizeStylesMap = {
    xxlarge: (0, $avKww.css)({
        font: 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xlarge: (0, $avKww.css)({
        font: 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    large: (0, $avKww.css)({
        font: 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    medium: (0, $avKww.css)({
        font: 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    small: (0, $avKww.css)({
        font: 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xsmall: (0, $avKww.css)({
        font: 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xxsmall: (0, $avKww.css)({
        font: 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    })
};
var /**
 * @codegenEnd
 */ $858d1a5adb2e69e3$export$2e2bcd8739ae039 = $858d1a5adb2e69e3$var$Heading;

});
parcelRegister("4lSQV", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $32b3ac2c5dc71164$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $32b3ac2c5dc71164$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $32b3ac2c5dc71164$export$632685d741f3dbbf; });
$parcel$export(module.exports, "inverseColorMap", function () { return $32b3ac2c5dc71164$export$2185ce37f9bdd963; });
$parcel$export(module.exports, "opacityMap", function () { return $32b3ac2c5dc71164$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $32b3ac2c5dc71164$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $32b3ac2c5dc71164$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $32b3ac2c5dc71164$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $32b3ac2c5dc71164$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $32b3ac2c5dc71164$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $32b3ac2c5dc71164$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $32b3ac2c5dc71164$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $32b3ac2c5dc71164$export$e615f061ca585a6c; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $32b3ac2c5dc71164$export$bf46c3f9eeafc71f; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $32b3ac2c5dc71164$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "textColorStylesMap", function () { return $32b3ac2c5dc71164$export$3a1bcba60b23d7f0; });
$parcel$export(module.exports, "fontWeightStylesMap", function () { return $32b3ac2c5dc71164$export$45f3f4fe16f9f7d5; });
$parcel$export(module.exports, "fontStylesMap", function () { return $32b3ac2c5dc71164$export$128f10c238242f83; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $32b3ac2c5dc71164$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $32b3ac2c5dc71164$export$5e65a44e5b6ecadb; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $xbX1J = parcelRequire("xbX1J");
function $32b3ac2c5dc71164$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $32b3ac2c5dc71164$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $32b3ac2c5dc71164$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $32b3ac2c5dc71164$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $32b3ac2c5dc71164$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $32b3ac2c5dc71164$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $32b3ac2c5dc71164$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $32b3ac2c5dc71164$export$632685d741f3dbbf = $32b3ac2c5dc71164$var$_objectSpread($32b3ac2c5dc71164$var$_objectSpread({}, $32b3ac2c5dc71164$export$958d0ae7f2977ae4), $32b3ac2c5dc71164$export$d2dc61f58390201c);
var $32b3ac2c5dc71164$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $32b3ac2c5dc71164$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $32b3ac2c5dc71164$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $32b3ac2c5dc71164$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $32b3ac2c5dc71164$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $32b3ac2c5dc71164$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $32b3ac2c5dc71164$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $32b3ac2c5dc71164$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $32b3ac2c5dc71164$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $32b3ac2c5dc71164$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $32b3ac2c5dc71164$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $32b3ac2c5dc71164$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $32b3ac2c5dc71164$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $32b3ac2c5dc71164$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $32b3ac2c5dc71164$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $32b3ac2c5dc71164$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $avKww.css)((0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $32b3ac2c5dc71164$export$e615f061ca585a6c = $32b3ac2c5dc71164$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $32b3ac2c5dc71164$var$getSerializedStylesMap(spacingProperty, $32b3ac2c5dc71164$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $32b3ac2c5dc71164$export$bf46c3f9eeafc71f = $32b3ac2c5dc71164$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $32b3ac2c5dc71164$var$getSerializedStylesMap(spacingProperty, $32b3ac2c5dc71164$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $32b3ac2c5dc71164$export$e7af83bafe7f9e63 = $32b3ac2c5dc71164$var$getSerializedStylesMap("backgroundColor", $32b3ac2c5dc71164$export$d1d79bf68ac056bd);
var $32b3ac2c5dc71164$export$3a1bcba60b23d7f0 = $32b3ac2c5dc71164$var$getSerializedStylesMap("color", $32b3ac2c5dc71164$export$8473307aa00d6ea1);
var $32b3ac2c5dc71164$export$45f3f4fe16f9f7d5 = $32b3ac2c5dc71164$var$getSerializedStylesMap("fontWeight", $32b3ac2c5dc71164$export$303e322c6b1ed114);
var $32b3ac2c5dc71164$export$68cc305da27dbaa4 = $32b3ac2c5dc71164$var$getSerializedStylesMap("fontFamily", $32b3ac2c5dc71164$export$3c7e9587132614b4);
var $32b3ac2c5dc71164$export$128f10c238242f83 = $32b3ac2c5dc71164$var$getSerializedStylesMap("font", $32b3ac2c5dc71164$export$6cc560b4dedf3816);
var $32b3ac2c5dc71164$export$ff257d957d48c421 = $32b3ac2c5dc71164$var$getSerializedStylesMap((0, $xbX1J.CURRENT_SURFACE_CSS_VAR), $32b3ac2c5dc71164$export$41a358c9c2356760);
var $32b3ac2c5dc71164$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $32b3ac2c5dc71164$export$41a358c9c2356760[color] !== undefined;
};

});

parcelRegister("gUoZ0", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $c4f541653edd9ad2$export$1ca2a26fecb070ae; });
$parcel$export(module.exports, "useSurface", function () { return $c4f541653edd9ad2$export$1aeb4f6b93c4540d; });

var $9nHZC = parcelRequire("9nHZC");
var $c4f541653edd9ad2$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $9nHZC.createContext)("elevation.surface");
var $c4f541653edd9ad2$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $9nHZC.useContext)($c4f541653edd9ad2$export$1ca2a26fecb070ae);
};
$c4f541653edd9ad2$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});



parcelRegister("2yEOW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1dce6bd98fa0efaa$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $4lSQV = parcelRequire("4lSQV");

var $byUEt = parcelRequire("byUEt");

var $gUoZ0 = parcelRequire("gUoZ0");
var $1dce6bd98fa0efaa$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $1dce6bd98fa0efaa$var$_excluded2 = [
    "className"
];
var $1dce6bd98fa0efaa$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $1dce6bd98fa0efaa$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(htmlAttributes, $1dce6bd98fa0efaa$var$_excluded2);
    var resolvedStyles = (0, $byUEt.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $avKww.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $1dce6bd98fa0efaa$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $4lSQV.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $4lSQV.isSurfaceColorToken)(backgroundColor) && (0, $4lSQV.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $4lSQV.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $4lSQV.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $4lSQV.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $4lSQV.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $4lSQV.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $4lSQV.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $4lSQV.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $avKww.jsx)((0, $gUoZ0.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $1dce6bd98fa0efaa$export$2e2bcd8739ae039 = $1dce6bd98fa0efaa$export$e71c4d32a2263218;
var $1dce6bd98fa0efaa$var$baseStyles = (0, $avKww.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("byUEt", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $86aed08b05f8032c$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $86aed08b05f8032c$export$f6c783d06584602c; });

var $b4Ivn = parcelRequire("b4Ivn");

var $kFnE9 = parcelRequire("kFnE9");

var $9q1kH = parcelRequire("9q1kH");

var $340K4 = parcelRequire("340K4");

var $avKww = parcelRequire("avKww");

var $4lSQV = parcelRequire("4lSQV");

var $8ovux = parcelRequire("8ovux");
function $86aed08b05f8032c$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $86aed08b05f8032c$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $86aed08b05f8032c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $86aed08b05f8032c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $86aed08b05f8032c$var$_arrayLikeToArray(o, minLen);
}
function $86aed08b05f8032c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $86aed08b05f8032c$export$9a199fbafee0014e = {
    backgroundColor: (0, $4lSQV.backgroundColorMap),
    blockSize: (0, $4lSQV.dimensionMap),
    borderBlockColor: (0, $4lSQV.borderColorMap),
    borderBlockEndColor: (0, $4lSQV.borderColorMap),
    borderBlockEndWidth: (0, $4lSQV.borderWidthMap),
    borderBlockStartColor: (0, $4lSQV.borderColorMap),
    borderBlockStartWidth: (0, $4lSQV.borderWidthMap),
    borderBlockWidth: (0, $4lSQV.borderWidthMap),
    borderBottomColor: (0, $4lSQV.borderColorMap),
    borderBottomLeftRadius: (0, $4lSQV.borderRadiusMap),
    borderBottomRightRadius: (0, $4lSQV.borderRadiusMap),
    borderBottomWidth: (0, $4lSQV.borderWidthMap),
    borderColor: (0, $4lSQV.borderColorMap),
    borderEndEndRadius: (0, $4lSQV.borderRadiusMap),
    borderEndStartRadius: (0, $4lSQV.borderRadiusMap),
    borderInlineColor: (0, $4lSQV.borderColorMap),
    borderInlineEndColor: (0, $4lSQV.borderColorMap),
    borderInlineEndWidth: (0, $4lSQV.borderWidthMap),
    borderInlineStartColor: (0, $4lSQV.borderColorMap),
    borderInlineStartWidth: (0, $4lSQV.borderWidthMap),
    borderInlineWidth: (0, $4lSQV.borderWidthMap),
    borderLeftColor: (0, $4lSQV.borderColorMap),
    borderLeftWidth: (0, $4lSQV.borderWidthMap),
    borderRadius: (0, $4lSQV.borderRadiusMap),
    borderRightColor: (0, $4lSQV.borderColorMap),
    borderRightWidth: (0, $4lSQV.borderWidthMap),
    borderStartEndRadius: (0, $4lSQV.borderRadiusMap),
    borderStartStartRadius: (0, $4lSQV.borderRadiusMap),
    borderTopColor: (0, $4lSQV.borderColorMap),
    borderTopLeftRadius: (0, $4lSQV.borderRadiusMap),
    borderTopRightRadius: (0, $4lSQV.borderRadiusMap),
    borderTopWidth: (0, $4lSQV.borderWidthMap),
    borderWidth: (0, $4lSQV.borderWidthMap),
    bottom: (0, $4lSQV.allSpaceMap),
    boxShadow: (0, $4lSQV.shadowMap),
    color: (0, $4lSQV.textColorMap),
    columnGap: (0, $4lSQV.positiveSpaceMap),
    gap: (0, $4lSQV.positiveSpaceMap),
    height: (0, $4lSQV.dimensionMap),
    inlineSize: (0, $4lSQV.dimensionMap),
    inset: (0, $4lSQV.allSpaceMap),
    insetBlock: (0, $4lSQV.allSpaceMap),
    insetBlockEnd: (0, $4lSQV.allSpaceMap),
    insetBlockStart: (0, $4lSQV.allSpaceMap),
    insetInline: (0, $4lSQV.allSpaceMap),
    insetInlineEnd: (0, $4lSQV.allSpaceMap),
    insetInlineStart: (0, $4lSQV.allSpaceMap),
    left: (0, $4lSQV.allSpaceMap),
    margin: (0, $4lSQV.allSpaceMap),
    marginBlock: (0, $4lSQV.allSpaceMap),
    marginBlockEnd: (0, $4lSQV.allSpaceMap),
    marginBlockStart: (0, $4lSQV.allSpaceMap),
    marginBottom: (0, $4lSQV.allSpaceMap),
    marginInline: (0, $4lSQV.allSpaceMap),
    marginInlineEnd: (0, $4lSQV.allSpaceMap),
    marginInlineStart: (0, $4lSQV.allSpaceMap),
    marginLeft: (0, $4lSQV.allSpaceMap),
    marginRight: (0, $4lSQV.allSpaceMap),
    marginTop: (0, $4lSQV.allSpaceMap),
    maxBlockSize: (0, $4lSQV.dimensionMap),
    maxHeight: (0, $4lSQV.dimensionMap),
    maxInlineSize: (0, $4lSQV.dimensionMap),
    maxWidth: (0, $4lSQV.dimensionMap),
    minBlockSize: (0, $4lSQV.dimensionMap),
    minHeight: (0, $4lSQV.dimensionMap),
    minInlineSize: (0, $4lSQV.dimensionMap),
    minWidth: (0, $4lSQV.dimensionMap),
    opacity: (0, $4lSQV.opacityMap),
    outlineColor: (0, $4lSQV.borderColorMap),
    outlineOffset: (0, $4lSQV.positiveSpaceMap),
    outlineWidth: (0, $4lSQV.borderWidthMap),
    padding: (0, $4lSQV.positiveSpaceMap),
    paddingBlock: (0, $4lSQV.positiveSpaceMap),
    paddingBlockEnd: (0, $4lSQV.positiveSpaceMap),
    paddingBlockStart: (0, $4lSQV.positiveSpaceMap),
    paddingBottom: (0, $4lSQV.positiveSpaceMap),
    paddingInline: (0, $4lSQV.positiveSpaceMap),
    paddingInlineEnd: (0, $4lSQV.positiveSpaceMap),
    paddingInlineStart: (0, $4lSQV.positiveSpaceMap),
    paddingLeft: (0, $4lSQV.positiveSpaceMap),
    paddingRight: (0, $4lSQV.positiveSpaceMap),
    paddingTop: (0, $4lSQV.positiveSpaceMap),
    right: (0, $4lSQV.allSpaceMap),
    rowGap: (0, $4lSQV.positiveSpaceMap),
    top: (0, $4lSQV.allSpaceMap),
    width: (0, $4lSQV.dimensionMap),
    zIndex: (0, $4lSQV.layerMap)
};
var $86aed08b05f8032c$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $86aed08b05f8032c$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $8ovux === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux.env) === "object" && false;
};
var $86aed08b05f8032c$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $86aed08b05f8032c$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $86aed08b05f8032c$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(value) === "object" && $86aed08b05f8032c$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($86aed08b05f8032c$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($86aed08b05f8032c$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $86aed08b05f8032c$export$9a199fbafee0014e)) return;
        var tokenValue = $86aed08b05f8032c$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $86aed08b05f8032c$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $86aed08b05f8032c$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, $86aed08b05f8032c$var$uniqueSymbol, (0, $avKww.css)(transformedStyles));
};
var $86aed08b05f8032c$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $86aed08b05f8032c$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$86aed08b05f8032c$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $86aed08b05f8032c$export$f6c783d06584602c(style) {
    return $86aed08b05f8032c$var$baseXcss(style);
}

});


parcelRegister("kMt0P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f20ecb9671995ab8$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $byUEt = parcelRequire("byUEt");

var $d7DPF = parcelRequire("d7DPF");
var $f20ecb9671995ab8$var$flexGrowMap = {
    hug: (0, $byUEt.xcss)({
        flexGrow: 0
    }),
    fill: (0, $byUEt.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
var $f20ecb9671995ab8$var$separatorStyles = (0, $avKww.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $f20ecb9671995ab8$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $avKww.jsx)("span", {
        css: $f20ecb9671995ab8$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $f20ecb9671995ab8$var$Inline = /*#__PURE__*/ (0, $9nHZC.memo)(/*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $avKww.jsx)($f20ecb9671995ab8$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $9nHZC.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $avKww.jsx)((0, $9nHZC.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $f20ecb9671995ab8$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $avKww.jsx)((0, $d7DPF.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$f20ecb9671995ab8$var$Inline.displayName = "Inline";
var $f20ecb9671995ab8$export$2e2bcd8739ae039 = $f20ecb9671995ab8$var$Inline;

});
parcelRegister("d7DPF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98dad3a9618369f3$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $4lSQV = parcelRequire("4lSQV");

var $byUEt = parcelRequire("byUEt");
var $98dad3a9618369f3$var$justifyContentMap = {
    start: (0, $avKww.css)({
        justifyContent: "start"
    }),
    center: (0, $avKww.css)({
        justifyContent: "center"
    }),
    end: (0, $avKww.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $avKww.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $avKww.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $avKww.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $avKww.css)({
        justifyContent: "stretch"
    })
};
var $98dad3a9618369f3$var$flexDirectionMap = {
    column: (0, $avKww.css)({
        flexDirection: "column"
    }),
    row: (0, $avKww.css)({
        flexDirection: "row"
    })
};
var $98dad3a9618369f3$var$flexWrapMap = {
    wrap: (0, $avKww.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $avKww.css)({
        flexWrap: "nowrap"
    })
};
var $98dad3a9618369f3$var$alignItemsMap = {
    start: (0, $avKww.css)({
        alignItems: "start"
    }),
    center: (0, $avKww.css)({
        alignItems: "center"
    }),
    baseline: (0, $avKww.css)({
        alignItems: "baseline"
    }),
    end: (0, $avKww.css)({
        alignItems: "end"
    }),
    stretch: (0, $avKww.css)({
        alignItems: "stretch"
    })
};
var $98dad3a9618369f3$var$baseStyles = (0, $avKww.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $98dad3a9618369f3$var$Flex = /*#__PURE__*/ (0, $9nHZC.memo)(/*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $byUEt.parseXcss)(xcss);
    return (0, $avKww.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $98dad3a9618369f3$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $4lSQV.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $4lSQV.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $4lSQV.spaceStylesMap).rowGap[rowGap],
            alignItems && $98dad3a9618369f3$var$alignItemsMap[alignItems],
            direction && $98dad3a9618369f3$var$flexDirectionMap[direction],
            justifyContent && $98dad3a9618369f3$var$justifyContentMap[justifyContent],
            wrap && $98dad3a9618369f3$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$98dad3a9618369f3$var$Flex.displayName = "Flex";
var $98dad3a9618369f3$export$2e2bcd8739ae039 = $98dad3a9618369f3$var$Flex;

});


parcelRegister("laOK3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6a1e46a43ac1b5a$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $byUEt = parcelRequire("byUEt");

var $d7DPF = parcelRequire("d7DPF");
var $f6a1e46a43ac1b5a$var$flexGrowMap = {
    hug: (0, $byUEt.xcss)({
        flexGrow: 0
    }),
    fill: (0, $byUEt.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $f6a1e46a43ac1b5a$var$Stack = /*#__PURE__*/ (0, $9nHZC.memo)(/*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $f6a1e46a43ac1b5a$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $avKww.jsx)((0, $d7DPF.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$f6a1e46a43ac1b5a$var$Stack.displayName = "Stack";
var $f6a1e46a43ac1b5a$export$2e2bcd8739ae039 = $f6a1e46a43ac1b5a$var$Stack;

});

parcelRegister("errhD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a838c03930a3048c$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $4GQn2 = parcelRequire("4GQn2");

var $4lSQV = parcelRequire("4lSQV");

var $gUoZ0 = parcelRequire("gUoZ0");
var $a838c03930a3048c$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $a838c03930a3048c$var$resetStyles = (0, $avKww.css)({
    margin: 0,
    overflowWrap: "anywhere"
});
var $a838c03930a3048c$var$strongStyles = (0, $avKww.css)({
    fontWeight: "bold"
});
var $a838c03930a3048c$var$emStyles = (0, $avKww.css)({
    fontStyle: "italic"
});
var $a838c03930a3048c$var$textAlignMap = {
    center: (0, $avKww.css)({
        textAlign: "center"
    }),
    end: (0, $avKww.css)({
        textAlign: "end"
    }),
    start: (0, $avKww.css)({
        textAlign: "start"
    })
};
var $a838c03930a3048c$var$truncationStyles = (0, $avKww.css)({
    display: "-webkit-box",
    overflow: "hidden",
    WebkitBoxOrient: "vertical"
});
var $a838c03930a3048c$var$wordBreakMap = {
    breakAll: (0, $avKww.css)({
        wordBreak: "break-all"
    })
};
var $a838c03930a3048c$var$HasTextAncestorContext = /*#__PURE__*/ (0, $9nHZC.createContext)(false);
var $a838c03930a3048c$var$useHasTextAncestor = function useHasTextAncestor() {
    return (0, $9nHZC.useContext)($a838c03930a3048c$var$HasTextAncestorContext);
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $a838c03930a3048c$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $gUoZ0.useSurface)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $4lSQV.inverseColorMap).hasOwnProperty(surface)) return (0, $4lSQV.inverseColorMap)[surface];
    if (colorProp === "inherit") return undefined;
    if (!colorProp && hasTextAncestor) return undefined;
    return colorProp || "color.text";
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $a838c03930a3048c$var$Text = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "span" : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, _ref$size = _ref.size, size = _ref$size === void 0 ? "medium" : _ref$size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $4GQn2.default)($a838c03930a3048c$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = $a838c03930a3048c$var$useHasTextAncestor();
    var color = $a838c03930a3048c$var$useColor(colorProp, hasTextAncestor);
    var component = (0, $avKww.jsx)(Component, {
        ref: ref,
        css: [
            $a838c03930a3048c$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $4lSQV.fontStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $4lSQV.textColorStylesMap)[color],
            maxLines && $a838c03930a3048c$var$truncationStyles,
            maxLines === 1 && $a838c03930a3048c$var$wordBreakMap.breakAll,
            align && $a838c03930a3048c$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $4lSQV.fontWeightStylesMap)[weight],
            Component === "em" && $a838c03930a3048c$var$emStyles,
            Component === "strong" && $a838c03930a3048c$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $avKww.jsx)($a838c03930a3048c$var$HasTextAncestorContext.Provider, {
        value: true
    }, component);
});
var $a838c03930a3048c$export$2e2bcd8739ae039 = $a838c03930a3048c$var$Text;

});
parcelRegister("4GQn2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36a3b55f158e9714$export$2e2bcd8739ae039; });
var $36a3b55f158e9714$var$isProduction = true;
var $36a3b55f158e9714$var$prefix = "Invariant failed";
function $36a3b55f158e9714$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($36a3b55f158e9714$var$isProduction) throw new Error($36a3b55f158e9714$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($36a3b55f158e9714$var$prefix, ": ").concat(provided) : $36a3b55f158e9714$var$prefix;
    throw new Error(value);
}

});


parcelRegister("90RLC", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", function () { return $68fdd229dd9afdaf$export$e9b82d2e21ac0c1f; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $5eELe = parcelRequire("5eELe");

var $4dJkZ = parcelRequire("4dJkZ");

var $g3VDW = parcelRequire("g3VDW");

var $in4xu = parcelRequire("in4xu");

var $9hjCt = parcelRequire("9hjCt");

var $8UMQB = parcelRequire("8UMQB");
function $68fdd229dd9afdaf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68fdd229dd9afdaf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68fdd229dd9afdaf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68fdd229dd9afdaf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $68fdd229dd9afdaf$export$faa35441caff5bb6 = {
    information: {
        backgroundColor: "var(--ds-background-information, ".concat((0, $8UMQB.B50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($g3VDW))),
        primaryIconColor: "var(--ds-icon-information, ".concat((0, $8UMQB.B500), ")")
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, ".concat((0, $8UMQB.Y50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9hjCt))),
        primaryIconColor: "var(--ds-icon-warning, ".concat((0, $8UMQB.Y500), ")")
    },
    error: {
        backgroundColor: "var(--ds-background-danger, ".concat((0, $8UMQB.R50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($4dJkZ))),
        primaryIconColor: "var(--ds-icon-danger, ".concat((0, $8UMQB.R500), ")")
    },
    success: {
        backgroundColor: "var(--ds-background-success, ".concat((0, $8UMQB.G50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5eELe))),
        primaryIconColor: "var(--ds-icon-success, ".concat((0, $8UMQB.G500), ")")
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, ".concat((0, $8UMQB.P50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($in4xu))),
        primaryIconColor: "var(--ds-icon-discovery, ".concat((0, $8UMQB.P500), ")")
    }
};
function $68fdd229dd9afdaf$export$e9b82d2e21ac0c1f(appearance, icon) {
    var appearanceIconStyles = $68fdd229dd9afdaf$export$faa35441caff5bb6[appearance] || $68fdd229dd9afdaf$export$faa35441caff5bb6.information;
    var AppearanceIcon = function AppearanceIcon(_ref) {
        var size = _ref.size, primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(appearanceIconStyles.Icon, {
            size: size,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            label: appearance
        });
    };
    var Icon = icon || AppearanceIcon;
    return $68fdd229dd9afdaf$var$_objectSpread($68fdd229dd9afdaf$var$_objectSpread({}, appearanceIconStyles), {}, {
        Icon: Icon
    });
}

});
parcelRegister("in4xu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d5fde55949a9e6ca$var$_react = $d5fde55949a9e6ca$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $d5fde55949a9e6ca$var$_questionCircle = $d5fde55949a9e6ca$var$_interopRequireDefault((parcelRequire("aQsPd")));
function $d5fde55949a9e6ca$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d5fde55949a9e6ca$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $d5fde55949a9e6ca$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="18" r="1" fill="inherit"/><path fill="inherit" d="M15.89 9.05a3.98 3.98 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.99.99 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05"/></g></svg>`
    }, props, {
        newIcon: $d5fde55949a9e6ca$var$_questionCircle.default
    }));
$d5fde55949a9e6ca$var$QuestionCircleIcon.displayName = "QuestionCircleIcon";
var $d5fde55949a9e6ca$var$_default = module.exports.default = $d5fde55949a9e6ca$var$QuestionCircleIcon;

});
parcelRegister("aQsPd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::44f68a28e7579c1e69613bedc98a8120>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e551ebe45350b36$var$_react = $7e551ebe45350b36$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $7e551ebe45350b36$var$_UNSAFE_baseNew = $7e551ebe45350b36$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $7e551ebe45350b36$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7e551ebe45350b36$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $7e551ebe45350b36$var$_react.default.createElement($7e551ebe45350b36$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6C6.25 5 7 4.25 8 4.25S9.75 5 9.75 6C9.75 7.5 8 7.5 8 8.75v.75M15.25 8A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Z"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$7e551ebe45350b36$var$QuestionCircleIcon.displayName = "QuestionCircleIcon";
var $7e551ebe45350b36$var$_default = module.exports.default = $7e551ebe45350b36$var$QuestionCircleIcon;

});


parcelRegister("8UMQB", function(module, exports) {

$parcel$export(module.exports, "R50", function () { return $67d971c400e41860$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R300", function () { return $67d971c400e41860$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $67d971c400e41860$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $67d971c400e41860$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y50", function () { return $67d971c400e41860$export$8d9596b529bbb9cf; });
$parcel$export(module.exports, "Y200", function () { return $67d971c400e41860$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $67d971c400e41860$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $67d971c400e41860$export$59619663aa6500fb; });
$parcel$export(module.exports, "Y500", function () { return $67d971c400e41860$export$874739ea9e379ab6; });
$parcel$export(module.exports, "G50", function () { return $67d971c400e41860$export$8a6341c32b6a3ee6; });
$parcel$export(module.exports, "G500", function () { return $67d971c400e41860$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $67d971c400e41860$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $67d971c400e41860$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $67d971c400e41860$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $67d971c400e41860$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $67d971c400e41860$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $67d971c400e41860$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $67d971c400e41860$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "P50", function () { return $67d971c400e41860$export$363e4475840015bb; });
$parcel$export(module.exports, "P500", function () { return $67d971c400e41860$export$147899de772240ec; });
$parcel$export(module.exports, "N0", function () { return $67d971c400e41860$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $67d971c400e41860$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N70", function () { return $67d971c400e41860$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N90", function () { return $67d971c400e41860$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N200", function () { return $67d971c400e41860$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N400", function () { return $67d971c400e41860$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $67d971c400e41860$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $67d971c400e41860$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $67d971c400e41860$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $67d971c400e41860$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $67d971c400e41860$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN400", function () { return $67d971c400e41860$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $67d971c400e41860$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN100", function () { return $67d971c400e41860$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN70", function () { return $67d971c400e41860$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $67d971c400e41860$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN30", function () { return $67d971c400e41860$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN0", function () { return $67d971c400e41860$export$3d4f271a500072a; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $67d971c400e41860$export$4b84fd0e2c617bd = "#FFEBE6";
var $67d971c400e41860$export$b34b069eff244586 = "#FFBDAD";
var $67d971c400e41860$export$be802dd0d8b57f35 = "#FF8F73";
var $67d971c400e41860$export$60847d42f9da92a6 = "#FF7452";
var $67d971c400e41860$export$4a7404f376229999 = "#FF5630";
var $67d971c400e41860$export$2010d0fb4295b346 = "#DE350B";
var $67d971c400e41860$export$2837b5a1a71d5c02 = "#BF2600";
var $67d971c400e41860$export$8d9596b529bbb9cf = "#FFFAE6";
var $67d971c400e41860$export$41060a744ab0b7ae = "#FFF0B3";
var $67d971c400e41860$export$1cc05bbbf340e559 = "#FFE380";
var $67d971c400e41860$export$5aae31392d72caaa = "#FFC400";
var $67d971c400e41860$export$c6930421db9fa514 = "#FFAB00";
var $67d971c400e41860$export$59619663aa6500fb = "#FF991F";
var $67d971c400e41860$export$874739ea9e379ab6 = "#FF8B00";
var $67d971c400e41860$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $67d971c400e41860$export$69a3bf21b9686c2b = "#ABF5D1";
var $67d971c400e41860$export$afbce1382ec95f73 = "#79F2C0";
var $67d971c400e41860$export$747d86715d4175de = "#57D9A3";
var $67d971c400e41860$export$940e1f69e873f202 = "#36B37E";
var $67d971c400e41860$export$a49394138f7b8e85 = "#00875A";
var $67d971c400e41860$export$6fa04827ac68a4fb = "#006644";
var $67d971c400e41860$export$226de0355ed012f8 = "#DEEBFF";
var $67d971c400e41860$export$8c13c2ee36917869 = "#B3D4FF";
var $67d971c400e41860$export$ecfc1dff386a3e7a = "#4C9AFF";
var $67d971c400e41860$export$215b7063051591f1 = "#2684FF";
var $67d971c400e41860$export$e62e8919cca44969 = "#0065FF";
var $67d971c400e41860$export$b3de0ae08da2ce64 = "#0052CC";
var $67d971c400e41860$export$a6ee3d71bc067634 = "#0747A6";
var $67d971c400e41860$export$363e4475840015bb = "#EAE6FF";
var $67d971c400e41860$export$4b0a4417ed59760f = "#C0B6F2";
var $67d971c400e41860$export$6011520a64d9a187 = "#998DD9";
var $67d971c400e41860$export$a7175d4e9206bc80 = "#8777D9";
var $67d971c400e41860$export$b48405b95304b5a1 = "#6554C0";
var $67d971c400e41860$export$c71e4279dd54a18d = "#5243AA";
var $67d971c400e41860$export$147899de772240ec = "#403294";
var $67d971c400e41860$export$2cf711fe14c66f06 = "#E6FCFF";
var $67d971c400e41860$export$7a8f4d33f6f9772c = "#B3F5FF";
var $67d971c400e41860$export$776c9c497ef08533 = "#79E2F2";
var $67d971c400e41860$export$69cb3ca10c1e330e = "#00C7E6";
var $67d971c400e41860$export$9dc1ef0f3f48059b = "#00B8D9";
var $67d971c400e41860$export$7c835c78b6fcdef8 = "#00A3BF";
var $67d971c400e41860$export$6036577f95c3877e = "#008DA6";
var $67d971c400e41860$export$29a4f05edc054374 = "#FFFFFF";
var $67d971c400e41860$export$e655ef011c4aa1a2 = "#FAFBFC";
var $67d971c400e41860$export$9fdfb749e33cdf97 = "#F4F5F7";
var $67d971c400e41860$export$3e51e8f1440314ba = "#EBECF0";
var $67d971c400e41860$export$1ce2d1575d444ceb = "#DFE1E6";
var $67d971c400e41860$export$8754fc7e6d8b3000 = "#C1C7D0";
var $67d971c400e41860$export$c2e91cbeada39b8b = "#B3BAC5";
var $67d971c400e41860$export$5f71e19f3a7ad9de = "#A5ADBA";
var $67d971c400e41860$export$eaa8c8a70ac22806 = "#97A0AF";
var $67d971c400e41860$export$7c87d337fb91a97d = "#8993A4";
var $67d971c400e41860$export$d6447c357493214f = "#7A869A";
var $67d971c400e41860$export$f563ee71e9ee74cd = "#6B778C";
var $67d971c400e41860$export$e2ef2124cf4024b1 = "#5E6C84";
var $67d971c400e41860$export$eece5f492e429f08 = "#505F79";
var $67d971c400e41860$export$c39c0fe0f26207ae = "#42526E";
var $67d971c400e41860$export$7090862dc3038a9f = "#344563";
var $67d971c400e41860$export$ad0bacf983b7ddaa = "#253858";
var $67d971c400e41860$export$7d61b15e0da132af = "#172B4D";
var $67d971c400e41860$export$fbda843f0a27fe96 = "#091E42";
var $67d971c400e41860$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $67d971c400e41860$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $67d971c400e41860$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $67d971c400e41860$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $67d971c400e41860$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $67d971c400e41860$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $67d971c400e41860$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $67d971c400e41860$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $67d971c400e41860$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $67d971c400e41860$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $67d971c400e41860$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $67d971c400e41860$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $67d971c400e41860$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $67d971c400e41860$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $67d971c400e41860$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $67d971c400e41860$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $67d971c400e41860$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $67d971c400e41860$export$2f6319cf7d736c2a = "#E6EDFA";
var $67d971c400e41860$export$95126bc8884d6634 = "#DCE5F5";
var $67d971c400e41860$export$8338d8c35d44ff1 = "#CED9EB";
var $67d971c400e41860$export$5368d76ae4fbbda7 = "#B8C7E0";
var $67d971c400e41860$export$9f0a771d16ec8d36 = "#ABBBD6";
var $67d971c400e41860$export$abcf8c38338b4aa5 = "#9FB0CC";
var $67d971c400e41860$export$97e81faa16a182c7 = "#8C9CB8";
var $67d971c400e41860$export$bfe21c59123ecf33 = "#7988A3";
var $67d971c400e41860$export$ee82aa2ea6a1558 = "#67758F";
var $67d971c400e41860$export$682927c6ed76be02 = "#56637A";
var $67d971c400e41860$export$91fd9994c5be9757 = "#455166";
var $67d971c400e41860$export$d281fbfe3cff2df6 = "#3B475C";
var $67d971c400e41860$export$3902c91d8b98a753 = "#313D52";
var $67d971c400e41860$export$8e8133c1ba5845b5 = "#283447";
var $67d971c400e41860$export$33ff357f6620b39 = "#202B3D";
var $67d971c400e41860$export$633847cf062b69e0 = "#1B2638";
var $67d971c400e41860$export$9776a6e503bdbf76 = "#121A29";
var $67d971c400e41860$export$6c813d5160dff5db = "#0E1624";
var $67d971c400e41860$export$3d4f271a500072a = "#0D1424";
var $67d971c400e41860$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $67d971c400e41860$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $67d971c400e41860$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $67d971c400e41860$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $67d971c400e41860$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $67d971c400e41860$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $67d971c400e41860$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $67d971c400e41860$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $67d971c400e41860$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $67d971c400e41860$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $67d971c400e41860$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $67d971c400e41860$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $67d971c400e41860$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $67d971c400e41860$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $67d971c400e41860$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $67d971c400e41860$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $67d971c400e41860$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";

});



parcelRegister("ieOPK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ab9b45d36f5b879$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $8ab9b45d36f5b879$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    errorCode: {
        "id": "frontbucket.sectionErrorBoundary.errorCode",
        "defaultMessage": "When contacting support, provide them with this code:"
    },
    title: {
        "id": "frontbucket.sectionErrorBoundary.title",
        "defaultMessage": "We stumbled a bit here."
    },
    keepsHappening: {
        "id": "frontbucket.sectionErrorBoundary.keepsHappening",
        "defaultMessage": "{tryAgainLink} or {supportResourcesLink} if this keeps happening."
    },
    supportResourcesLink: {
        "id": "frontbucket.sectionErrorBoundary.supportResourcesLink",
        "defaultMessage": "contact support"
    },
    tryAgainLink: {
        "id": "frontbucket.sectionErrorBoundary.tryAgainLink",
        "defaultMessage": "Reload the page"
    }
});

});

parcelRegister("5hykE", function(module, exports) {

$parcel$export(module.exports, "SectionErrorContainer", function () { return $f177921b8d6cd6f0$export$9631b4ff88bf49cd; });
$parcel$export(module.exports, "SentryErrorCode", function () { return $f177921b8d6cd6f0$export$15ec0fbd8786e59e; });

var $2xJU3 = parcelRequire("2xJU3");
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */ function $f177921b8d6cd6f0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f177921b8d6cd6f0$export$9631b4ff88bf49cd = (0, $2xJU3.default)("div", {
    target: "e1se9x0a0"
})({
    name: "13brihr",
    styles: "text-align:left;"
});
const $f177921b8d6cd6f0$export$15ec0fbd8786e59e = (0, $2xJU3.default)("code", {
    target: "e1se9x0a1"
})({
    name: "542wex",
    styles: "word-break:break-word;"
});

});


parcelRegister("hKvmF", function(module, exports) {

$parcel$export(module.exports, "GlobalErrorBoundary", function () { return $fdf17d7b0ae62851$export$f9a332dca7725cfc; });
/**
 * Based on Confluence's error boundary code:
 * https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-frontend/browse/packages/confluence-shared-components/src/ErrorBoundary/ErrorBoundaryComponent.js
 *
 * Wrap this component around pieces of functionality to limit the blast radius of an error.
 */ 
var $9nHZC = parcelRequire("9nHZC");

var $628YF = parcelRequire("628YF");

var $jmbnP = parcelRequire("jmbnP");
class $fdf17d7b0ae62851$export$f9a332dca7725cfc extends (0, $9nHZC.PureComponent) {
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false,
            sentryEventId: null
        };
    }
    // handles fallback rendering only and does not allow side-effects
    // According to `@types/react` this *is* explicitly an `any` type
    static getDerivedStateFromError(error) {
        // eslint-disable-next-line no-console
        console.error(error);
        return {
            hasError: true
        };
    }
    // recommended method for side effects
    componentDidCatch(error, errorInfo) {
        // eslint-disable-next-line no-console
        console.error(errorInfo.componentStack);
        (0, $628YF.captureExceptionWithTags)(error, {
            component: "global-error-boundary"
        }, {
            componentStack: errorInfo.componentStack
        }).then((sentryEventId)=>{
            this.setState({
                sentryEventId: sentryEventId
            });
        });
    }
    render() {
        const { hasError: hasError, sentryEventId: sentryEventId } = this.state;
        const { children: children } = this.props;
        if (!hasError) return children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $jmbnP.GlobalErrorPage), {
            sentryEventId: sentryEventId || undefined
        });
    }
}

});
parcelRegister("628YF", function(module, exports) {

$parcel$export(module.exports, "captureExceptionWithTags", function () { return $c59254bfa2a5184a$export$b5a48fae6879d6b0; });
$parcel$export(module.exports, "captureMessageWithTags", function () { return $c59254bfa2a5184a$export$23bd8655596f5aa3; });
$parcel$export(module.exports, "captureMessageForResponse", function () { return $c59254bfa2a5184a$export$7198d1c73bebcc13; });

var $3XbtU = parcelRequire("3XbtU");
const $c59254bfa2a5184a$export$b5a48fae6879d6b0 = (e, tags = {}, extras = {})=>{
    return new Promise((resolve)=>{
        $3XbtU.withScope((scope)=>{
            Object.keys(tags).forEach((key)=>{
                scope.setTag(key, tags[key]);
            });
            Object.keys(extras).forEach((field)=>{
                scope.setExtra(field, extras[field]);
            });
            const id = $3XbtU.captureException(e);
            resolve(id);
        });
    });
};
const $c59254bfa2a5184a$export$23bd8655596f5aa3 = (m, tags = {}, extras = {})=>{
    return new Promise((resolve)=>{
        $3XbtU.withScope((scope)=>{
            Object.keys(tags).forEach((key)=>{
                scope.setTag(key, tags[key]);
            });
            Object.keys(extras).forEach((field)=>{
                scope.setExtra(field, extras[field]);
            });
            const id = $3XbtU.captureException(m);
            resolve(id);
        });
    });
};
async function $c59254bfa2a5184a$export$7198d1c73bebcc13(response, message) {
    const { status: status } = response;
    // @ts-ignore TODO: fix noImplicitAny error here
    let body;
    try {
        body = await response.text();
    } catch (e) {
        body = "";
    }
    $3XbtU.withScope((scope)=>{
        // Error body is extremely useful to be able to diagnose a problem. We don't
        // want it in the message because we don't want slightly different responses
        // to break grouping.
        // @ts-ignore TODO: fix noImplicitAny error here
        scope.setExtra("response", body);
        const messageWithStatus = `${message}: status ${status}`;
        // By default, Sentry groups similar messages (e.g. when only the status changes).
        // Disable that for this, we want to group by status.
        scope.setFingerprint([
            messageWithStatus
        ]);
        // We tried captureException here to have a file path, but the exception
        // stack trace is weird because this is in an async function.
        $3XbtU.captureMessage(messageWithStatus);
    });
}

});


parcelRegister("QXGvp", function(module, exports) {

$parcel$export(module.exports, "SectionErrorBoundary", function () { return $4a0e3abd39ddd572$export$1978febaad64e1d6; });

var $9nHZC = parcelRequire("9nHZC");

var $628YF = parcelRequire("628YF");

var $jfseu = parcelRequire("jfseu");
class $4a0e3abd39ddd572$export$1978febaad64e1d6 extends (0, $9nHZC.PureComponent) {
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false,
            sentryEventId: null
        };
    }
    // According to `@types/react` this *is* explicitly an `any` type
    static getDerivedStateFromError(error) {
        // eslint-disable-next-line no-console
        console.error(error);
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        // eslint-disable-next-line no-console
        console.error(errorInfo);
        const componentTag = `${this.props.sentryComponentId}-section-error-boundary`;
        (0, $628YF.captureExceptionWithTags)(error, {
            component: componentTag
        }, {
            componentStack: errorInfo.componentStack
        }).then((sentryEventId)=>{
            this.setState({
                sentryEventId: sentryEventId
            });
        });
    }
    render() {
        const { hasError: hasError, sentryEventId: sentryEventId } = this.state;
        const { children: children, sectionHeading: sectionHeading } = this.props;
        if (!hasError) return children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $jfseu.SectionError), {
            sectionHeading: sectionHeading,
            sentryEventId: sentryEventId || undefined
        });
    }
}

});


parcelRegister("2dDP1", function(module, exports) {

$parcel$export(module.exports, "LoadingPage", function () { return $9518d5e5a53823c7$export$7343d23d6bc16d75; });

var $9nHZC = parcelRequire("9nHZC");

var $5Sf6P = parcelRequire("5Sf6P");

var $dEKDm = parcelRequire("dEKDm");

var $gJBrF = parcelRequire("gJBrF");

var $eD9vM = parcelRequire("eD9vM");
const $9518d5e5a53823c7$export$7343d23d6bc16d75 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo(({ interactionName: interactionName = "loading-page" })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5Sf6P.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $gJBrF.Content), {
        isBannerOpen: false,
        consentBannerHeight: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eD9vM.Loading, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dEKDm.default), {
        delay: 0,
        size: "large",
        interactionName: interactionName
    }))));
});

});
parcelRegister("5Sf6P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $446db7400b93d3be$export$2e2bcd8739ae039; });

var $jfvoK = parcelRequire("jfvoK");

var $a8g5d = parcelRequire("a8g5d");

var $3jRWn = parcelRequire("3jRWn");
var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$446db7400b93d3be$export$2e2bcd8739ae039 = (0, $jfvoK.default);

});
parcelRegister("jfvoK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e037c60bccd5e8ff$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $avKww = parcelRequire("avKww");

var $lEOBi = parcelRequire("lEOBi");
var $e037c60bccd5e8ff$var$bannerStyles = (0, $avKww.css)({
    width: "100%",
    position: "fixed"
});
var $e037c60bccd5e8ff$var$bannerContainerStyles = (0, $avKww.css)({
    width: "100%",
    position: "relative",
    zIndex: 3,
    flex: "1 0 auto",
    transition: "height 0.25s ease-in-out"
});
var $e037c60bccd5e8ff$var$pageContentStyles = (0, $avKww.css)({
    minWidth: 0,
    position: "relative",
    zIndex: 1,
    flex: "1 1 auto"
});
var $e037c60bccd5e8ff$var$wrapperStyles = (0, $avKww.css)({
    display: "flex",
    width: "100%",
    minHeight: "100%",
    flexDirection: "column"
});
var $e037c60bccd5e8ff$var$mainContainerStyles = (0, $avKww.css)({
    display: "flex",
    flex: "1 1 auto"
});
var $e037c60bccd5e8ff$var$navigationStyles = (0, $avKww.css)({
    position: "relative",
    zIndex: 2
});
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ var $e037c60bccd5e8ff$var$Page = function Page(_ref) {
    var _ref$isBannerOpen = _ref.isBannerOpen, isBannerOpen = _ref$isBannerOpen === void 0 ? false : _ref$isBannerOpen, _ref$bannerHeight = _ref.bannerHeight, bannerHeight = _ref$bannerHeight === void 0 ? (0, $lEOBi.defaultBannerHeight) : _ref$bannerHeight, banner = _ref.banner, navigation = _ref.navigation, children = _ref.children, testId = _ref.testId;
    return (0, $avKww.jsx)("div", {
        css: $e037c60bccd5e8ff$var$wrapperStyles,
        "data-testid": testId
    }, banner ? (0, $avKww.jsx)("div", {
        css: $e037c60bccd5e8ff$var$bannerContainerStyles,
        style: {
            height: isBannerOpen ? "".concat(bannerHeight, "px") : "0"
        },
        "aria-hidden": !isBannerOpen,
        "data-testid": testId ? "".concat(testId, "--banner-container") : undefined
    }, (0, $avKww.jsx)("div", {
        css: $e037c60bccd5e8ff$var$bannerStyles
    }, banner)) : null, (0, $avKww.jsx)("div", {
        css: $e037c60bccd5e8ff$var$mainContainerStyles
    }, (0, $avKww.jsx)("div", {
        css: $e037c60bccd5e8ff$var$navigationStyles
    }, navigation), (0, $avKww.jsx)("div", {
        css: $e037c60bccd5e8ff$var$pageContentStyles
    }, children)));
};
var $e037c60bccd5e8ff$export$2e2bcd8739ae039 = $e037c60bccd5e8ff$var$Page;

});
parcelRegister("lEOBi", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", function () { return $fc449597b6f530f7$export$74797698e12f8baa; });
$parcel$export(module.exports, "defaultGridColumnWidth", function () { return $fc449597b6f530f7$export$b8241a1616ab1b96; });
$parcel$export(module.exports, "spacingMapping", function () { return $fc449597b6f530f7$export$2a89a65a43bab52d; });
$parcel$export(module.exports, "defaultSpacing", function () { return $fc449597b6f530f7$export$8ec7372efd74b753; });
$parcel$export(module.exports, "defaultBannerHeight", function () { return $fc449597b6f530f7$export$d77f83c3d17a7b8a; });
$parcel$export(module.exports, "defaultMedium", function () { return $fc449597b6f530f7$export$f8725d21f81f3e01; });
$parcel$export(module.exports, "defaultLayout", function () { return $fc449597b6f530f7$export$2303d2bd9eeff99a; });
$parcel$export(module.exports, "varColumnsNum", function () { return $fc449597b6f530f7$export$9ddc3632bbfb8966; });
$parcel$export(module.exports, "varColumnSpan", function () { return $fc449597b6f530f7$export$8b7e31f391e6e681; });
$parcel$export(module.exports, "varGridSpacing", function () { return $fc449597b6f530f7$export$936829b4511db3e4; });
var $fc449597b6f530f7$export$3aaf3a78c909ea56 = 8;
var $fc449597b6f530f7$export$74797698e12f8baa = 12;
var $fc449597b6f530f7$export$b8241a1616ab1b96 = $fc449597b6f530f7$export$3aaf3a78c909ea56 * 10;
var $fc449597b6f530f7$export$2a89a65a43bab52d = {
    comfortable: $fc449597b6f530f7$export$3aaf3a78c909ea56 * 5,
    cosy: $fc449597b6f530f7$export$3aaf3a78c909ea56 * 2,
    compact: $fc449597b6f530f7$export$3aaf3a78c909ea56 * 0.5
};
var $fc449597b6f530f7$export$8ec7372efd74b753 = "cosy";
var $fc449597b6f530f7$export$d77f83c3d17a7b8a = 52;
var $fc449597b6f530f7$export$f8725d21f81f3e01 = 0;
var $fc449597b6f530f7$export$2303d2bd9eeff99a = "fixed";
var $fc449597b6f530f7$export$9ddc3632bbfb8966 = "--ds-columns-num";
var $fc449597b6f530f7$export$8b7e31f391e6e681 = "--ds-column-span";
var $fc449597b6f530f7$export$936829b4511db3e4 = "--ds-grid-spacing";

});


parcelRegister("a8g5d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7607207d2dab933c$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $lEOBi = parcelRequire("lEOBi");

var $4WspQ = parcelRequire("4WspQ");

var $3jRWn = parcelRequire("3jRWn");

var $cM3Yd = parcelRequire("cM3Yd");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ var $7607207d2dab933c$var$GridWrapper = function GridWrapper(_ref) {
    var _ref2, _ref3, _theme$isNestedGrid;
    var spacingProp = _ref.spacing, columnsProp = _ref.columns, layout = _ref.layout, testId = _ref.testId, children = _ref.children, theme = _ref.theme;
    /**
   * isRoot is `true` only in the default context (i.e. no ancestor Grid).
   */ var _useContext = (0, $9nHZC.useContext)((0, $cM3Yd.GridContext)), isRoot = _useContext.isRoot;
    var _useContext2 = (0, $9nHZC.useContext)((0, $3jRWn.GridColumnContext)), medium = _useContext2.medium;
    /**
   * The colspan of the current containing GridColumn provides
   * the default amount of columns in a nested grid.
   */ var defaultColumns = medium > 0 ? medium : (0, $lEOBi.defaultGridColumns);
    /**
   * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
   * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
   */ var spacing = (_ref2 = spacingProp !== null && spacingProp !== void 0 ? spacingProp : theme === null || theme === void 0 ? void 0 : theme.spacing) !== null && _ref2 !== void 0 ? _ref2 : (0, $lEOBi.defaultSpacing);
    var columns = (_ref3 = columnsProp !== null && columnsProp !== void 0 ? columnsProp : theme === null || theme === void 0 ? void 0 : theme.columns) !== null && _ref3 !== void 0 ? _ref3 : defaultColumns;
    var isNested = (_theme$isNestedGrid = theme === null || theme === void 0 ? void 0 : theme.isNestedGrid) !== null && _theme$isNestedGrid !== void 0 ? _theme$isNestedGrid : !isRoot;
    var contextValue = (0, $9nHZC.useMemo)(function() {
        return {
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        };
    }, [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $cM3Yd.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $4WspQ.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $7607207d2dab933c$export$2e2bcd8739ae039 = $7607207d2dab933c$var$GridWrapper;

});
parcelRegister("4WspQ", function(module, exports) {

$parcel$export(module.exports, "Grid", function () { return $39929f03b99272b9$export$ef2184bd89960b14; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $lEOBi = parcelRequire("lEOBi");

var $cM3Yd = parcelRequire("cM3Yd");
var $39929f03b99272b9$var$gridStyles = (0, $avKww.css)({
    display: "flex",
    margin: "0 auto",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: "0 calc(var(".concat((0, $lEOBi.varGridSpacing), ") / 2)"),
    position: "relative",
    alignItems: "flex-start",
    flexWrap: "wrap"
});
var $39929f03b99272b9$var$gridLayoutStyles = {
    fixed: (0, $avKww.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: "calc(var(".concat((0, $lEOBi.varColumnsNum), ") * ").concat((0, $lEOBi.defaultGridColumnWidth), "px)")
    }),
    fluid: (0, $avKww.css)({
        maxWidth: "100%"
    })
};
var $39929f03b99272b9$var$nestedGridStyles = (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: "0 calc(-1 * var(".concat((0, $lEOBi.varGridSpacing), "))")
});
var $39929f03b99272b9$export$ef2184bd89960b14 = function Grid(_ref) {
    var _ref2;
    var _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? (0, $lEOBi.defaultLayout) : _ref$layout, testId = _ref.testId, children = _ref.children;
    var _useContext = (0, $9nHZC.useContext)((0, $cM3Yd.GridContext)), isNested = _useContext.isNested, columns = _useContext.columns, spacing = _useContext.spacing;
    return (0, $avKww.jsx)("div", {
        css: [
            $39929f03b99272b9$var$gridStyles,
            $39929f03b99272b9$var$gridLayoutStyles[layout],
            isNested && $39929f03b99272b9$var$nestedGridStyles
        ],
        style: (_ref2 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref2, (0, $lEOBi.varColumnsNum), columns), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref2, (0, $lEOBi.varGridSpacing), "".concat((0, $lEOBi.spacingMapping)[spacing], "px")), _ref2),
        "data-testid": testId
    }, children);
};

});
parcelRegister("cM3Yd", function(module, exports) {

$parcel$export(module.exports, "GridContext", function () { return $94cd0c1c0cf40464$export$11cae3e04ab99fae; });

var $9nHZC = parcelRequire("9nHZC");

var $lEOBi = parcelRequire("lEOBi");
var $94cd0c1c0cf40464$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $9nHZC.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $lEOBi.defaultSpacing),
    columns: (0, $lEOBi.defaultGridColumns)
});

});


parcelRegister("3jRWn", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", function () { return $26acfcecbe2bd7c1$export$1229ad7112b989f5; });
$parcel$export(module.exports, "default", function () { return $26acfcecbe2bd7c1$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $lEOBi = parcelRequire("lEOBi");

var $cM3Yd = parcelRequire("cM3Yd");
var $26acfcecbe2bd7c1$var$_gridColumnWidthStyle;
/**
 * Determines the method by which column width is calculated.
 */ var $26acfcecbe2bd7c1$var$ColumnVariant = /*#__PURE__*/ function(ColumnVariant) {
    ColumnVariant["Auto"] = "auto";
    ColumnVariant["Bounded"] = "bounded";
    ColumnVariant["FullWidth"] = "fullWidth";
    return ColumnVariant;
}($26acfcecbe2bd7c1$var$ColumnVariant || {});
var $26acfcecbe2bd7c1$var$getVariant = function getVariant(_ref) {
    var medium = _ref.medium, columns = _ref.columns;
    if (medium === (0, $lEOBi.defaultMedium)) return $26acfcecbe2bd7c1$var$ColumnVariant.Auto;
    else if (medium < columns) return $26acfcecbe2bd7c1$var$ColumnVariant.Bounded;
    return $26acfcecbe2bd7c1$var$ColumnVariant.FullWidth;
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ var $26acfcecbe2bd7c1$var$availableWidth = "99.9999%";
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $26acfcecbe2bd7c1$var$singleColumnWidth = "(".concat($26acfcecbe2bd7c1$var$availableWidth, " / var(").concat((0, $lEOBi.varColumnsNum), "))");
var $26acfcecbe2bd7c1$var$gridColumnStyles = (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: "calc(".concat($26acfcecbe2bd7c1$var$singleColumnWidth, " - var(").concat((0, $lEOBi.varGridSpacing), "))"),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: "0 calc(var(".concat((0, $lEOBi.varGridSpacing), ") / 2)"),
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: "break-word"
});
var $26acfcecbe2bd7c1$var$gridColumnWidthStyles = ($26acfcecbe2bd7c1$var$_gridColumnWidthStyle = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($26acfcecbe2bd7c1$var$_gridColumnWidthStyle, $26acfcecbe2bd7c1$var$ColumnVariant.Auto, (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: "calc(100% - var(".concat((0, $lEOBi.varGridSpacing), "))"),
    flexBasis: "auto"
})), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($26acfcecbe2bd7c1$var$_gridColumnWidthStyle, $26acfcecbe2bd7c1$var$ColumnVariant.Bounded, (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: "calc(".concat($26acfcecbe2bd7c1$var$singleColumnWidth, " *  var(").concat((0, $lEOBi.varColumnSpan), ") - var(").concat((0, $lEOBi.varGridSpacing), "))"),
    flexBasis: "100%"
})), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($26acfcecbe2bd7c1$var$_gridColumnWidthStyle, $26acfcecbe2bd7c1$var$ColumnVariant.FullWidth, (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: "calc(100% - var(".concat((0, $lEOBi.varGridSpacing), "))"),
    flexBasis: "100%"
})), $26acfcecbe2bd7c1$var$_gridColumnWidthStyle);
var $26acfcecbe2bd7c1$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $9nHZC.createContext)({
    medium: (0, $lEOBi.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ var $26acfcecbe2bd7c1$var$GridColumn = function GridColumn(_ref2) {
    var _ref2$medium = _ref2.medium, medium = _ref2$medium === void 0 ? (0, $lEOBi.defaultMedium) : _ref2$medium, children = _ref2.children, testId = _ref2.testId;
    var _useContext = (0, $9nHZC.useContext)((0, $cM3Yd.GridContext)), columns = _useContext.columns;
    var contextValue = (0, $9nHZC.useMemo)(function() {
        return {
            medium: medium
        };
    }, [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ var colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ var variant = $26acfcecbe2bd7c1$var$getVariant({
        medium: medium,
        columns: columns
    });
    return (0, $avKww.jsx)($26acfcecbe2bd7c1$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, (0, $avKww.jsx)("div", {
        css: [
            $26acfcecbe2bd7c1$var$gridColumnStyles,
            $26acfcecbe2bd7c1$var$gridColumnWidthStyles[variant]
        ],
        style: (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, (0, $lEOBi.varColumnSpan), variant === $26acfcecbe2bd7c1$var$ColumnVariant.Auto ? "auto" : colSpan),
        "data-testid": testId
    }, children));
};
var $26acfcecbe2bd7c1$export$2e2bcd8739ae039 = $26acfcecbe2bd7c1$var$GridColumn;

});



parcelRegister("gJBrF", function(module, exports) {

$parcel$export(module.exports, "PageLayout", function () { return $639aec7ad3695496$export$6d1402fb58384e4f; });
$parcel$export(module.exports, "Content", function () { return $639aec7ad3695496$export$7c6e2c02157bb7d2; });

var $2xJU3 = parcelRequire("2xJU3");
parcelRequire("45CBz");
var $7KAwG = parcelRequire("7KAwG");

var $13MK1 = parcelRequire("13MK1");

var $aDsOl = parcelRequire("aDsOl");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $giIwV = parcelRequire("giIwV");
function $639aec7ad3695496$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/* In right-to-left languages, the dir(rtl) here keeps the sidebar on the right of the page content */ const $639aec7ad3695496$var$pageWithSidebarStyles = {
    name: "1gbe3q2",
    styles: "display:flex;width:100%;box-sizing:border-box;&:dir(rtl){flex-direction:row-reverse;}"
};
// eslint-disable-next-line @typescript-eslint/no-unused-expressions
(0, $13MK1.injectGlobal)`
  body {
    background-color: ${(0, $h39Sh.default)("elevation.surface", (0, $jp7ng).N0)}
  }
`;
const $639aec7ad3695496$export$6d1402fb58384e4f = (0, $2xJU3.default)("div", {
    target: "efo6slf0"
})(({ isMobileHeaderActive: isMobileHeaderActive })=>{
    // In a separate file the LayoutManager `experimental_horizontalGlobalNav` prop is applied
    // to force the nav-next component to hide itself (but remain mounted) when the mobile nav
    // is visible. Unfortunately setting the 'experimental_horizontalGlobalNav' prop causes
    // a `margin-top` to be applied, which would make sense if we were actually using the
    // horizontal nav, but since horizontal nav is not yet rolled out we negate the `margin-top`
    // here. (fd-horizontal-nav)
    return isMobileHeaderActive ? /*#__PURE__*/ (0, $7KAwG.default)({
        marginTop: `-${(0, $aDsOl.HORIZONTAL_GLOBAL_NAV_HEIGHT)}px`
    }, "") : $639aec7ad3695496$var$pageWithSidebarStyles;
}, "");
const $639aec7ad3695496$export$7c6e2c02157bb7d2 = (0, $2xJU3.default)("div", {
    target: "efo6slf1"
})("flex:1 1 0px;min-width:0;min-height:", (props)=>props.isBannerOpen ? `calc(100% - ${(0, $giIwV.BANNER_HEIGHT) + (props.consentBannerHeight || 0)}px)` : `calc(100% - ${props.consentBannerHeight || 0}px)`, ";");
const $639aec7ad3695496$export$5d17a314f64c82e7 = (0, $2xJU3.default)("div", {
    target: "efo6slf2"
})({
    name: "1n62roz",
    styles: "& >:first-of-type{width:100vw;}"
});

});
parcelRegister("13MK1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "isStyledComponent", function () { return $0c5be144d8434123$export$7ba318d8d2f06c76; });
$parcel$export(module.exports, "consolidateStreamedStyles", function () { return $0c5be144d8434123$export$953e7e0c06f2f28b; });
$parcel$export(module.exports, "css", function () { return $0c5be144d8434123$export$dbf350e5966cf602; });
$parcel$export(module.exports, "StyleSheetManager", function () { return $0c5be144d8434123$export$a473771da2f0ff7c; });
$parcel$export(module.exports, "ServerStyleSheet", function () { return $0c5be144d8434123$export$ae8c7d15c8b89a20; });
$parcel$export(module.exports, "ThemeProvider", function () { return $0c5be144d8434123$export$d8964aec282183a3; });
$parcel$export(module.exports, "withTheme", function () { return $0c5be144d8434123$export$e8748c6a27b910dc; });
$parcel$export(module.exports, "__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS", function () { return $0c5be144d8434123$export$84079c323bb0915e; });
$parcel$export(module.exports, "keyframes", function () { return $0c5be144d8434123$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "injectGlobal", function () { return $0c5be144d8434123$export$efb9f5caaa2ca0c7; });
$parcel$export(module.exports, "default", function () { return $0c5be144d8434123$export$2e2bcd8739ae039; });

var $eMALc = parcelRequire("eMALc");

var $9nHZC = parcelRequire("9nHZC");

var $2Mvug = parcelRequire("2Mvug");

var $cdu9v = parcelRequire("cdu9v");

var $blCBi = parcelRequire("blCBi");

var $k9ky0 = parcelRequire("k9ky0");

var $fAROH = parcelRequire("fAROH");

var $8ovux = parcelRequire("8ovux");
var $0c5be144d8434123$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $0c5be144d8434123$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $0c5be144d8434123$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $0c5be144d8434123$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $0c5be144d8434123$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $0c5be144d8434123$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $0c5be144d8434123$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
// 
var $0c5be144d8434123$var$isPlainObject = function(x) {
    return (typeof x === "undefined" ? "undefined" : $0c5be144d8434123$var$_typeof(x)) === "object" && x.constructor === Object;
};
// 
/**
 * Parse errors.md and turn it into a simple hash of code: message
 */ var $0c5be144d8434123$var$ERRORS = {};
/**
 * super basic version of sprintf
 */ function $0c5be144d8434123$var$format() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var a = args[0];
    var b = [];
    var c = void 0;
    for(c = 1; c < args.length; c += 1)b.push(args[c]);
    b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    });
    return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */ var $0c5be144d8434123$var$StyledComponentsError = function(_Error) {
    $0c5be144d8434123$var$inherits(StyledComponentsError, _Error);
    function StyledComponentsError(code) {
        $0c5be144d8434123$var$classCallCheck(this, StyledComponentsError);
        for(var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)interpolations[_key2 - 1] = arguments[_key2];
        var _this;
        var _this = $0c5be144d8434123$var$possibleConstructorReturn(this, _Error.call(this, "An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#" + code + " for more information. " + (interpolations ? "Additional arguments: " + interpolations.join(", ") : "")));
        return $0c5be144d8434123$var$possibleConstructorReturn(_this);
    }
    return StyledComponentsError;
}(Error);
// 
var $0c5be144d8434123$var$objToCss = function objToCss(obj, prevKey) {
    var css = Object.keys(obj).filter(function(key) {
        var chunk = obj[key];
        return chunk !== undefined && chunk !== null && chunk !== false && chunk !== "";
    }).map(function(key) {
        if ($0c5be144d8434123$var$isPlainObject(obj[key])) return objToCss(obj[key], key);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eMALc)))(key) + ": " + obj[key] + ";";
    }).join(" ");
    return prevKey ? prevKey + " {\n  " + css + "\n}" : css;
};
var $0c5be144d8434123$var$flatten = function flatten(chunks, executionContext) {
    return chunks.reduce(function(ruleSet, chunk) {
        /* Remove falsey values */ if (chunk === undefined || chunk === null || chunk === false || chunk === "") return ruleSet;
        /* Flatten ruleSet */ if (Array.isArray(chunk)) {
            ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
            return ruleSet;
        }
        /* Handle other components */ if (chunk.hasOwnProperty("styledComponentId")) {
            // $FlowFixMe not sure how to make this pass
            ruleSet.push("." + chunk.styledComponentId);
            return ruleSet;
        }
        /* Either execute or defer the function */ if (typeof chunk === "function") {
            if (executionContext) {
                var nextChunk = chunk(executionContext);
                /* Throw if a React Element was given styles */ if ((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).isValidElement(nextChunk)) {
                    var elementName = chunk.displayName || chunk.name;
                    throw new $0c5be144d8434123$var$StyledComponentsError(11, elementName);
                }
                ruleSet.push.apply(ruleSet, flatten([
                    nextChunk
                ], executionContext));
            } else ruleSet.push(chunk);
            return ruleSet;
        }
        /* Handle objects */ ruleSet.push(// $FlowFixMe have to add %checks somehow to isPlainObject
        $0c5be144d8434123$var$isPlainObject(chunk) ? $0c5be144d8434123$var$objToCss(chunk) : chunk.toString());
        return ruleSet;
    }, []);
};
// 
var $0c5be144d8434123$var$COMMENT_REGEX = /^\s*\/\/.*$/gm;
// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var $0c5be144d8434123$var$stylisSplitter = new (0, (/*@__PURE__*/$parcel$interopDefault($2Mvug)))({
    global: false,
    cascade: true,
    keyframe: false,
    prefix: false,
    compress: false,
    semicolon: true
});
var $0c5be144d8434123$var$stylis = new (0, (/*@__PURE__*/$parcel$interopDefault($2Mvug)))({
    global: false,
    cascade: true,
    keyframe: false,
    prefix: true,
    compress: false,
    semicolon: false // NOTE: This means "autocomplete missing semicolons"
});
// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture
var $0c5be144d8434123$var$parsingRules = [];
// eslint-disable-next-line consistent-return
var $0c5be144d8434123$var$returnRulesPlugin = function returnRulesPlugin(context) {
    if (context === -2) {
        var parsedRules = $0c5be144d8434123$var$parsingRules;
        $0c5be144d8434123$var$parsingRules = [];
        return parsedRules;
    }
};
var $0c5be144d8434123$var$parseRulesPlugin = (0, (/*@__PURE__*/$parcel$interopDefault($cdu9v)))(function(rule) {
    $0c5be144d8434123$var$parsingRules.push(rule);
});
$0c5be144d8434123$var$stylis.use([
    $0c5be144d8434123$var$parseRulesPlugin,
    $0c5be144d8434123$var$returnRulesPlugin
]);
$0c5be144d8434123$var$stylisSplitter.use([
    $0c5be144d8434123$var$parseRulesPlugin,
    $0c5be144d8434123$var$returnRulesPlugin
]);
var $0c5be144d8434123$var$stringifyRules = function stringifyRules(rules, selector, prefix) {
    var flatCSS = rules.join("").replace($0c5be144d8434123$var$COMMENT_REGEX, ""); // replace JS comments
    var cssStr = selector && prefix ? prefix + " " + selector + " { " + flatCSS + " }" : flatCSS;
    return $0c5be144d8434123$var$stylis(prefix || !selector ? "" : selector, cssStr);
};
var $0c5be144d8434123$var$splitByRules = function splitByRules(css) {
    return $0c5be144d8434123$var$stylisSplitter("", css);
};
// 
function $0c5be144d8434123$export$7ba318d8d2f06c76(target) /* : %checks */ {
    return(// $FlowFixMe TODO: flow for styledComponentId
    typeof target === "function" && typeof target.styledComponentId === "string");
}
// 
/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */ function $0c5be144d8434123$export$953e7e0c06f2f28b() {}
// 
/* eslint-disable no-bitwise */ /* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */ var $0c5be144d8434123$var$charsLength = 52;
/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */ var $0c5be144d8434123$var$getAlphabeticChar = function getAlphabeticChar(code) {
    return String.fromCharCode(code + (code > 25 ? 39 : 97));
};
/* input a number, usually a hash and convert it to base-52 */ var $0c5be144d8434123$var$generateAlphabeticName = function generateAlphabeticName(code) {
    var name = "";
    var x = void 0;
    /* get a char and divide by alphabet-length */ for(x = code; x > $0c5be144d8434123$var$charsLength; x = Math.floor(x / $0c5be144d8434123$var$charsLength))name = $0c5be144d8434123$var$getAlphabeticChar(x % $0c5be144d8434123$var$charsLength) + name;
    return $0c5be144d8434123$var$getAlphabeticChar(x % $0c5be144d8434123$var$charsLength) + name;
};
// 
var $0c5be144d8434123$var$interleave = function(strings, interpolations) {
    var result = [
        strings[0]
    ];
    for(var i = 0, len = interpolations.length; i < len; i += 1)result.push(interpolations[i], strings[i + 1]);
    return result;
};
// 
var $0c5be144d8434123$var$EMPTY_ARRAY = Object.freeze([]);
var $0c5be144d8434123$var$EMPTY_OBJECT = Object.freeze({});
// 
var $0c5be144d8434123$export$dbf350e5966cf602 = function(styles) {
    for(var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    if (typeof styles === "function" || $0c5be144d8434123$var$isPlainObject(styles)) // $FlowFixMe
    return $0c5be144d8434123$var$flatten($0c5be144d8434123$var$interleave($0c5be144d8434123$var$EMPTY_ARRAY, [
        styles
    ].concat(interpolations)));
    // $FlowFixMe
    return $0c5be144d8434123$var$flatten($0c5be144d8434123$var$interleave(styles, interpolations));
};
// 
var $0c5be144d8434123$var$SC_ATTR = (typeof $8ovux !== "undefined" && undefined, "data-styled-components");
var $0c5be144d8434123$var$SC_STREAM_ATTR = "data-styled-streamed";
var $0c5be144d8434123$var$CONTEXT_KEY = "__styled-components-stylesheet__";
var $0c5be144d8434123$var$IS_BROWSER = typeof window !== "undefined" && "HTMLElement" in window;
var $0c5be144d8434123$var$DISABLE_SPEEDY = false;
// 
var $0c5be144d8434123$var$SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;
var $0c5be144d8434123$var$extractComps = function(maybeCSS) {
    var css = "" + (maybeCSS || ""); // Definitely a string, and a clone
    var existingComponents = [];
    css.replace($0c5be144d8434123$var$SC_COMPONENT_ID, function(match, componentId, matchIndex) {
        existingComponents.push({
            componentId: componentId,
            matchIndex: matchIndex
        });
        return match;
    });
    return existingComponents.map(function(_ref, i) {
        var componentId = _ref.componentId, matchIndex = _ref.matchIndex;
        var nextComp = existingComponents[i + 1];
        var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
        return {
            componentId: componentId,
            cssFromDOM: cssFromDOM
        };
    });
};
// 
/* eslint-disable camelcase, no-undef */ var $0c5be144d8434123$var$getNonce = function() {
    return typeof __webpack_nonce__ !== "undefined" ? __webpack_nonce__ : null;
};
// 
// Helper to call a given function, only once
var $0c5be144d8434123$var$once = function(cb) {
    var called = false;
    return function() {
        if (!called) {
            called = true;
            cb();
        }
    };
};
// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */ /* adds a new ID:name pairing to a names dictionary */ var $0c5be144d8434123$var$addNameForId = function addNameForId(names, id, name) {
    if (name) {
        // eslint-disable-next-line no-param-reassign
        var namesForId = names[id] || (names[id] = Object.create(null));
        namesForId[name] = true;
    }
};
/* resets an ID entirely by overwriting it in the dictionary */ var $0c5be144d8434123$var$resetIdNames = function resetIdNames(names, id) {
    // eslint-disable-next-line no-param-reassign
    names[id] = Object.create(null);
};
/* factory for a names dictionary checking the existance of an ID:name pairing */ var $0c5be144d8434123$var$hasNameForId = function hasNameForId(names) {
    return function(id, name) {
        return names[id] !== undefined && names[id][name];
    };
};
/* stringifies names for the html/element output */ var $0c5be144d8434123$var$stringifyNames = function stringifyNames(names) {
    var str = "";
    // eslint-disable-next-line guard-for-in
    for(var id in names)str += Object.keys(names[id]).join(" ") + " ";
    return str.trim();
};
/* clones the nested names dictionary */ var $0c5be144d8434123$var$cloneNames = function cloneNames(names) {
    var clone = Object.create(null);
    // eslint-disable-next-line guard-for-in
    for(var id in names)clone[id] = $0c5be144d8434123$var$_extends({}, names[id]);
    return clone;
};
// 
/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */ /* retrieve a sheet for a given style tag */ var $0c5be144d8434123$var$sheetForTag = function sheetForTag(tag) {
    // $FlowFixMe
    if (tag.sheet) return tag.sheet;
    /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */ var size = document.styleSheets.length;
    for(var i = 0; i < size; i += 1){
        var sheet = document.styleSheets[i];
        // $FlowFixMe
        if (sheet.ownerNode === tag) return sheet;
    }
    /* we should always be able to find a tag */ throw new $0c5be144d8434123$var$StyledComponentsError(10);
};
/* insert a rule safely and return whether it was actually injected */ var $0c5be144d8434123$var$safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
    /* abort early if cssRule string is falsy */ if (!cssRule) return false;
    var maxIndex = sheet.cssRules.length;
    try {
        /* use insertRule and cap passed index with maxIndex (no of cssRules) */ sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
    } catch (err) {
        /* any error indicates an invalid rule */ return false;
    }
    return true;
};
/* deletes `size` rules starting from `removalIndex` */ var $0c5be144d8434123$var$deleteRules = function deleteRules(sheet, removalIndex, size) {
    var lowerBound = removalIndex - size;
    for(var i = removalIndex; i > lowerBound; i -= 1)sheet.deleteRule(i);
};
// 
/* this marker separates component styles and is important for rehydration */ var $0c5be144d8434123$var$makeTextMarker = function makeTextMarker(id) {
    return "\n/* sc-component-id: " + id + " */\n";
};
/* add up all numbers in array up until and including the index */ var $0c5be144d8434123$var$addUpUntilIndex = function addUpUntilIndex(sizes, index) {
    var totalUpToIndex = 0;
    for(var i = 0; i <= index; i += 1)totalUpToIndex += sizes[i];
    return totalUpToIndex;
};
/* create a new style tag after lastEl */ var $0c5be144d8434123$var$makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
    var el = document.createElement("style");
    el.setAttribute($0c5be144d8434123$var$SC_ATTR, "");
    var nonce = $0c5be144d8434123$var$getNonce();
    if (nonce) el.setAttribute("nonce", nonce);
    /* Work around insertRule quirk in EdgeHTML */ el.appendChild(document.createTextNode(""));
    if (target && !tagEl) /* Append to target when no previous element was passed */ target.appendChild(el);
    else {
        if (!tagEl || !target || !tagEl.parentNode) throw new $0c5be144d8434123$var$StyledComponentsError(6);
        /* Insert new style tag after the previous one */ tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
    }
    return el;
};
/* takes a css factory function and outputs an html styled tag factory */ var $0c5be144d8434123$var$wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
    return function(additionalAttrs) {
        var nonce = $0c5be144d8434123$var$getNonce();
        var attrs = [
            nonce && 'nonce="' + nonce + '"',
            $0c5be144d8434123$var$SC_ATTR + '="' + $0c5be144d8434123$var$stringifyNames(names) + '"',
            additionalAttrs
        ];
        var htmlAttr = attrs.filter(Boolean).join(" ");
        return "<style " + htmlAttr + ">" + css() + "</style>";
    };
};
/* takes a css factory function and outputs an element factory */ var $0c5be144d8434123$var$wrapAsElement = function wrapAsElement(css, names) {
    return function() {
        var _props;
        var props = (_props = {}, _props[$0c5be144d8434123$var$SC_ATTR] = $0c5be144d8434123$var$stringifyNames(names), _props);
        var nonce = $0c5be144d8434123$var$getNonce();
        if (nonce) // $FlowFixMe
        props.nonce = nonce;
        // eslint-disable-next-line react/no-danger
        return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("style", $0c5be144d8434123$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: css()
            }
        }));
    };
};
var $0c5be144d8434123$var$getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
    return function() {
        return Object.keys(markers);
    };
};
/* speedy tags utilise insertRule */ var $0c5be144d8434123$var$makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
    var names = Object.create(null);
    var markers = Object.create(null);
    var sizes = [];
    var extractImport = getImportRuleTag !== undefined;
    /* indicates whther getImportRuleTag was called */ var usedImportRuleTag = false;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        markers[id] = sizes.length;
        sizes.push(0);
        $0c5be144d8434123$var$resetIdNames(names, id);
        return markers[id];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        var sheet = $0c5be144d8434123$var$sheetForTag(el);
        var insertIndex = $0c5be144d8434123$var$addUpUntilIndex(sizes, marker);
        var injectedRules = 0;
        var importRules = [];
        var cssRulesSize = cssRules.length;
        for(var i = 0; i < cssRulesSize; i += 1){
            var cssRule = cssRules[i];
            var mayHaveImport = extractImport; /* @import rules are reordered to appear first */ 
            if (mayHaveImport && cssRule.indexOf("@import") !== -1) importRules.push(cssRule);
            else if ($0c5be144d8434123$var$safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
                mayHaveImport = false;
                injectedRules += 1;
            }
        }
        if (extractImport && importRules.length > 0) {
            usedImportRuleTag = true;
            // $FlowFixMe
            getImportRuleTag().insertRules(id + "-import", importRules);
        }
        sizes[marker] += injectedRules; /* add up no of injected rules */ 
        $0c5be144d8434123$var$addNameForId(names, id, name);
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        var size = sizes[marker];
        var sheet = $0c5be144d8434123$var$sheetForTag(el);
        var removalIndex = $0c5be144d8434123$var$addUpUntilIndex(sizes, marker);
        $0c5be144d8434123$var$deleteRules(sheet, removalIndex, size);
        sizes[marker] = 0;
        $0c5be144d8434123$var$resetIdNames(names, id);
        if (extractImport && usedImportRuleTag) // $FlowFixMe
        getImportRuleTag().removeRules(id + "-import");
    };
    var css = function css() {
        var _sheetForTag = $0c5be144d8434123$var$sheetForTag(el), cssRules = _sheetForTag.cssRules;
        var str = "";
        // eslint-disable-next-line guard-for-in
        for(var id in markers){
            str += $0c5be144d8434123$var$makeTextMarker(id);
            var marker = markers[id];
            var end = $0c5be144d8434123$var$addUpUntilIndex(sizes, marker);
            var size = sizes[marker];
            for(var i = end - size; i < end; i += 1){
                var rule = cssRules[i];
                if (rule !== undefined) str += rule.cssText;
            }
        }
        return str;
    };
    return {
        clone: function clone() {
            throw new $0c5be144d8434123$var$StyledComponentsError(5);
        },
        css: css,
        getIds: $0c5be144d8434123$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $0c5be144d8434123$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: el,
        toElement: $0c5be144d8434123$var$wrapAsElement(css, names),
        toHTML: $0c5be144d8434123$var$wrapAsHtmlTag(css, names)
    };
};
var $0c5be144d8434123$var$makeTextNode = function makeTextNode(id) {
    return document.createTextNode($0c5be144d8434123$var$makeTextMarker(id));
};
var $0c5be144d8434123$var$makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
    var names = Object.create(null);
    var markers = Object.create(null);
    var extractImport = getImportRuleTag !== undefined;
    /* indicates whther getImportRuleTag was called */ var usedImportRuleTag = false;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        markers[id] = $0c5be144d8434123$var$makeTextNode(id);
        el.appendChild(markers[id]);
        names[id] = Object.create(null);
        return markers[id];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        var importRules = [];
        var cssRulesSize = cssRules.length;
        for(var i = 0; i < cssRulesSize; i += 1){
            var rule = cssRules[i];
            var mayHaveImport = extractImport;
            if (mayHaveImport && rule.indexOf("@import") !== -1) importRules.push(rule);
            else {
                mayHaveImport = false;
                var separator = i === cssRulesSize - 1 ? "" : " ";
                marker.appendData("" + rule + separator);
            }
        }
        $0c5be144d8434123$var$addNameForId(names, id, name);
        if (extractImport && importRules.length > 0) {
            usedImportRuleTag = true;
            // $FlowFixMe
            getImportRuleTag().insertRules(id + "-import", importRules);
        }
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        /* create new empty text node and replace the current one */ var newMarker = $0c5be144d8434123$var$makeTextNode(id);
        el.replaceChild(newMarker, marker);
        markers[id] = newMarker;
        $0c5be144d8434123$var$resetIdNames(names, id);
        if (extractImport && usedImportRuleTag) // $FlowFixMe
        getImportRuleTag().removeRules(id + "-import");
    };
    var css = function css() {
        var str = "";
        // eslint-disable-next-line guard-for-in
        for(var id in markers)str += markers[id].data;
        return str;
    };
    return {
        clone: function clone() {
            throw new $0c5be144d8434123$var$StyledComponentsError(5);
        },
        css: css,
        getIds: $0c5be144d8434123$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $0c5be144d8434123$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: el,
        toElement: $0c5be144d8434123$var$wrapAsElement(css, names),
        toHTML: $0c5be144d8434123$var$wrapAsHtmlTag(css, names)
    };
};
var $0c5be144d8434123$var$makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
    var names = namesArg === undefined ? Object.create(null) : namesArg;
    var markers = markersArg === undefined ? Object.create(null) : markersArg;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        return markers[id] = [
            ""
        ];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        marker[0] += cssRules.join(" ");
        $0c5be144d8434123$var$addNameForId(names, id, name);
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        marker[0] = "";
        $0c5be144d8434123$var$resetIdNames(names, id);
    };
    var css = function css() {
        var str = "";
        // eslint-disable-next-line guard-for-in
        for(var id in markers){
            var cssForId = markers[id][0];
            if (cssForId) str += $0c5be144d8434123$var$makeTextMarker(id) + cssForId;
        }
        return str;
    };
    var clone = function clone() {
        var namesClone = $0c5be144d8434123$var$cloneNames(names);
        var markersClone = Object.create(null);
        // eslint-disable-next-line guard-for-in
        for(var id in markers)markersClone[id] = [
            markers[id][0]
        ];
        return makeServerTagInternal(namesClone, markersClone);
    };
    var tag = {
        clone: clone,
        css: css,
        getIds: $0c5be144d8434123$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $0c5be144d8434123$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: null,
        toElement: $0c5be144d8434123$var$wrapAsElement(css, names),
        toHTML: $0c5be144d8434123$var$wrapAsHtmlTag(css, names)
    };
    return tag;
};
var $0c5be144d8434123$var$makeServerTag = function makeServerTag() {
    return $0c5be144d8434123$var$makeServerTagInternal();
};
var $0c5be144d8434123$var$makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
    if ($0c5be144d8434123$var$IS_BROWSER && !forceServer) {
        var el = $0c5be144d8434123$var$makeStyleTag(target, tagEl, insertBefore);
        if ($0c5be144d8434123$var$DISABLE_SPEEDY) return $0c5be144d8434123$var$makeBrowserTag(el, getImportRuleTag);
        else return $0c5be144d8434123$var$makeSpeedyTag(el, getImportRuleTag);
    }
    return $0c5be144d8434123$var$makeServerTag();
};
/* wraps a given tag so that rehydration is performed once when necessary */ var $0c5be144d8434123$var$makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
    /* rehydration function that adds all rules to the new tag */ var rehydrate = $0c5be144d8434123$var$once(function() {
        /* add all extracted components to the new tag */ for(var i = 0, len = extracted.length; i < len; i += 1){
            var _extracted$i = extracted[i], componentId = _extracted$i.componentId, cssFromDOM = _extracted$i.cssFromDOM;
            var cssRules = $0c5be144d8434123$var$splitByRules(cssFromDOM);
            tag.insertRules(componentId, cssRules);
        }
        /* remove old HTMLStyleElements, since they have been rehydrated */ for(var _i = 0, _len = els.length; _i < _len; _i += 1){
            var el = els[_i];
            if (el.parentNode) el.parentNode.removeChild(el);
        }
    });
    if (immediateRehydration) rehydrate();
    return $0c5be144d8434123$var$_extends({}, tag, {
        /* add rehydration hook to insertion methods */ insertMarker: function insertMarker(id) {
            rehydrate();
            return tag.insertMarker(id);
        },
        insertRules: function insertRules(id, cssRules, name) {
            rehydrate();
            return tag.insertRules(id, cssRules, name);
        }
    });
};
// 
var $0c5be144d8434123$var$SPLIT_REGEX = /\s+/;
/* determine the maximum number of components before tags are sharded */ var $0c5be144d8434123$var$MAX_SIZE = void 0;
if ($0c5be144d8434123$var$IS_BROWSER) /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */ $0c5be144d8434123$var$MAX_SIZE = $0c5be144d8434123$var$DISABLE_SPEEDY ? 40 : 1000;
else /* for servers we do not need to shard at all */ $0c5be144d8434123$var$MAX_SIZE = -1;
var $0c5be144d8434123$var$sheetRunningId = 0;
var $0c5be144d8434123$var$master = void 0;
var $0c5be144d8434123$var$StyleSheet = function() {
    /* a map from ids to tags */ /* deferred rules for a given id */ /* this is used for not reinjecting rules via hasNameForId() */ /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */ /* a list of tags belonging to this StyleSheet */ /* a tag for import rules */ /* current capacity until a new tag must be created */ /* children (aka clones) of this StyleSheet inheriting all and future injections */ function StyleSheet() {
        var _this = this;
        var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $0c5be144d8434123$var$IS_BROWSER ? document.head : null;
        var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        $0c5be144d8434123$var$classCallCheck(this, StyleSheet);
        this.getImportRuleTag = function() {
            var importRuleTag = _this.importRuleTag;
            if (importRuleTag !== undefined) return importRuleTag;
            var firstTag = _this.tags[0];
            var insertBefore = true;
            return _this.importRuleTag = $0c5be144d8434123$var$makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
        };
        $0c5be144d8434123$var$sheetRunningId += 1;
        this.id = $0c5be144d8434123$var$sheetRunningId;
        this.forceServer = forceServer;
        this.target = forceServer ? null : target;
        this.tagMap = {};
        this.deferred = {};
        this.rehydratedNames = {};
        this.ignoreRehydratedNames = {};
        this.tags = [];
        this.capacity = 1;
        this.clones = [];
    }
    /* rehydrate all SSR'd style tags */ StyleSheet.prototype.rehydrate = function rehydrate() {
        if (!$0c5be144d8434123$var$IS_BROWSER || this.forceServer) return this;
        var els = [];
        var extracted = [];
        var isStreamed = false;
        /* retrieve all of our SSR style elements from the DOM */ var nodes = document.querySelectorAll("style[" + $0c5be144d8434123$var$SC_ATTR + "]");
        var nodesSize = nodes.length;
        /* abort rehydration if no previous style tags were found */ if (nodesSize === 0) return this;
        for(var i = 0; i < nodesSize; i += 1){
            // $FlowFixMe: We can trust that all elements in this query are style elements
            var el = nodes[i];
            /* check if style tag is a streamed tag */ if (!isStreamed) isStreamed = !!el.getAttribute($0c5be144d8434123$var$SC_STREAM_ATTR);
            /* retrieve all component names */ var elNames = (el.getAttribute($0c5be144d8434123$var$SC_ATTR) || "").trim().split($0c5be144d8434123$var$SPLIT_REGEX);
            var elNamesSize = elNames.length;
            for(var j = 0; j < elNamesSize; j += 1){
                var name = elNames[j];
                /* add rehydrated name to sheet to avoid readding styles */ this.rehydratedNames[name] = true;
            }
            /* extract all components and their CSS */ extracted.push.apply(extracted, $0c5be144d8434123$var$extractComps(el.textContent));
            /* store original HTMLStyleElement */ els.push(el);
        }
        /* abort rehydration if nothing was extracted */ var extractedSize = extracted.length;
        if (extractedSize === 0) return this;
        /* create a tag to be used for rehydration */ var tag = this.makeTag(null);
        var rehydrationTag = $0c5be144d8434123$var$makeRehydrationTag(tag, els, extracted, isStreamed);
        /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */ this.capacity = Math.max(1, $0c5be144d8434123$var$MAX_SIZE - extractedSize);
        this.tags.push(rehydrationTag);
        /* retrieve all component ids */ for(var _j = 0; _j < extractedSize; _j += 1)this.tagMap[extracted[_j].componentId] = rehydrationTag;
        return this;
    };
    /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */ /* reset the internal "master" instance */ StyleSheet.reset = function reset() {
        var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        $0c5be144d8434123$var$master = new StyleSheet(undefined, forceServer).rehydrate();
    };
    /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */ StyleSheet.prototype.clone = function clone() {
        var sheet = new StyleSheet(this.target, this.forceServer);
        /* add to clone array */ this.clones.push(sheet);
        /* clone all tags */ sheet.tags = this.tags.map(function(tag) {
            var ids = tag.getIds();
            var newTag = tag.clone();
            /* reconstruct tagMap */ for(var i = 0; i < ids.length; i += 1)sheet.tagMap[ids[i]] = newTag;
            return newTag;
        });
        /* clone other maps */ sheet.rehydratedNames = $0c5be144d8434123$var$_extends({}, this.rehydratedNames);
        sheet.deferred = $0c5be144d8434123$var$_extends({}, this.deferred);
        return sheet;
    };
    /* force StyleSheet to create a new tag on the next injection */ StyleSheet.prototype.sealAllTags = function sealAllTags() {
        this.capacity = 1;
        this.tags.forEach(function(tag) {
            // eslint-disable-next-line no-param-reassign
            tag.sealed = true;
        });
    };
    StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
        var lastEl = tag ? tag.styleTag : null;
        var insertBefore = false;
        return $0c5be144d8434123$var$makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
    };
    /* get a tag for a given componentId, assign the componentId to one, or shard */ StyleSheet.prototype.getTagForId = function getTagForId(id) {
        /* simply return a tag, when the componentId was already assigned one */ var prev = this.tagMap[id];
        if (prev !== undefined && !prev.sealed) return prev;
        var tag = this.tags[this.tags.length - 1];
        /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */ this.capacity -= 1;
        if (this.capacity === 0) {
            this.capacity = $0c5be144d8434123$var$MAX_SIZE;
            tag = this.makeTag(tag);
            this.tags.push(tag);
        }
        return this.tagMap[id] = tag;
    };
    /* mainly for injectGlobal to check for its id */ StyleSheet.prototype.hasId = function hasId(id) {
        return this.tagMap[id] !== undefined;
    };
    /* caching layer checking id+name to already have a corresponding tag and injected rules */ StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
        /* exception for rehydrated names which are checked separately */ if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) return true;
        var tag = this.tagMap[id];
        return tag !== undefined && tag.hasNameForId(id, name);
    };
    /* registers a componentId and registers it on its tag */ StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
        /* don't inject when the id is already registered */ if (this.tagMap[id] !== undefined) return;
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].deferredInject(id, cssRules);
        this.getTagForId(id).insertMarker(id);
        this.deferred[id] = cssRules;
    };
    /* injects rules for a given id with a name that will need to be cached */ StyleSheet.prototype.inject = function inject(id, cssRules, name) {
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].inject(id, cssRules, name);
        var tag = this.getTagForId(id);
        /* add deferred rules for component */ if (this.deferred[id] !== undefined) {
            // Combine passed cssRules with previously deferred CSS rules
            // NOTE: We cannot mutate the deferred array itself as all clones
            // do the same (see clones[i].inject)
            var rules = this.deferred[id].concat(cssRules);
            tag.insertRules(id, rules, name);
            this.deferred[id] = undefined;
        } else tag.insertRules(id, cssRules, name);
    };
    /* removes all rules for a given id, which doesn't remove its marker but resets it */ StyleSheet.prototype.remove = function remove(id) {
        var tag = this.tagMap[id];
        if (tag === undefined) return;
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].remove(id);
        /* remove all rules from the tag */ tag.removeRules(id);
        /* ignore possible rehydrated names */ this.ignoreRehydratedNames[id] = true;
        /* delete possible deferred rules */ this.deferred[id] = undefined;
    };
    StyleSheet.prototype.toHTML = function toHTML() {
        return this.tags.map(function(tag) {
            return tag.toHTML();
        }).join("");
    };
    StyleSheet.prototype.toReactElements = function toReactElements() {
        var id = this.id;
        return this.tags.map(function(tag, i) {
            var key = "sc-" + id + "-" + i;
            return (0, $9nHZC.cloneElement)(tag.toElement(), {
                key: key
            });
        });
    };
    $0c5be144d8434123$var$createClass(StyleSheet, null, [
        {
            key: "master",
            get: function get$$1() {
                return $0c5be144d8434123$var$master || ($0c5be144d8434123$var$master = new StyleSheet().rehydrate());
            }
        },
        {
            key: "instance",
            get: function get$$1() {
                return StyleSheet.master;
            }
        }
    ]);
    return StyleSheet;
}();
var $0c5be144d8434123$var$_StyleSheetManager$ch;
var $0c5be144d8434123$export$a473771da2f0ff7c = function(_Component) {
    $0c5be144d8434123$var$inherits(StyleSheetManager, _Component);
    function StyleSheetManager() {
        $0c5be144d8434123$var$classCallCheck(this, StyleSheetManager);
        return $0c5be144d8434123$var$possibleConstructorReturn(this, _Component.apply(this, arguments));
    }
    StyleSheetManager.prototype.getChildContext = function getChildContext() {
        var _ref;
        return _ref = {}, _ref[$0c5be144d8434123$var$CONTEXT_KEY] = this.sheetInstance, _ref;
    };
    StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
        if (this.props.sheet) this.sheetInstance = this.props.sheet;
        else if (this.props.target) this.sheetInstance = new $0c5be144d8434123$var$StyleSheet(this.props.target);
        else throw new $0c5be144d8434123$var$StyledComponentsError(4);
    };
    StyleSheetManager.prototype.render = function render() {
        /* eslint-disable react/prop-types */ // Flow v0.43.1 will report an error accessing the `children` property,
        // but v0.47.0 will not. It is necessary to use a type cast instead of
        // a "fixme" comment to satisfy both Flow versions.
        return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Children.only(this.props.children);
    };
    return StyleSheetManager;
}((0, $9nHZC.Component));
$0c5be144d8434123$export$a473771da2f0ff7c.childContextTypes = ($0c5be144d8434123$var$_StyleSheetManager$ch = {}, $0c5be144d8434123$var$_StyleSheetManager$ch[$0c5be144d8434123$var$CONTEXT_KEY] = (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).instanceOf($0c5be144d8434123$var$StyleSheet),
    (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).instanceOf($0c5be144d8434123$export$ae8c7d15c8b89a20)
]).isRequired, $0c5be144d8434123$var$_StyleSheetManager$ch);
// 
var $0c5be144d8434123$export$ae8c7d15c8b89a20 = function() {
    function ServerStyleSheet() {
        $0c5be144d8434123$var$classCallCheck(this, ServerStyleSheet);
        /* The master sheet might be reset, so keep a reference here */ this.masterSheet = $0c5be144d8434123$var$StyleSheet.master;
        this.instance = this.masterSheet.clone();
        this.closed = false;
    }
    ServerStyleSheet.prototype.complete = function complete() {
        if (!this.closed) {
            /* Remove closed StyleSheets from the master sheet */ var index = this.masterSheet.clones.indexOf(this.instance);
            this.masterSheet.clones.splice(index, 1);
            this.closed = true;
        }
    };
    ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
        if (this.closed) throw new $0c5be144d8434123$var$StyledComponentsError(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($0c5be144d8434123$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, children);
    };
    ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
        this.complete();
        return this.instance.toHTML();
    };
    ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
        this.complete();
        return this.instance.toReactElements();
    };
    ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
        var _this = this;
        var instance, instanceTagIndex, streamAttr, transformer;
        throw new $0c5be144d8434123$var$StyledComponentsError(3);
    };
    return ServerStyleSheet;
}();
// 
var $0c5be144d8434123$var$LIMIT = 200;
var $0c5be144d8434123$var$createWarnTooManyClasses = function(displayName) {
    var generatedClasses = {};
    var warningSeen = false;
    return function(className) {
        if (!warningSeen) {
            generatedClasses[className] = true;
            if (Object.keys(generatedClasses).length >= $0c5be144d8434123$var$LIMIT) {
                // Unable to find latestRule in test environment.
                /* eslint-disable no-console, prefer-template */ console.warn("Over " + $0c5be144d8434123$var$LIMIT + " classes were generated for component " + displayName + ". \n" + "Consider using the attrs method, together with a style object for frequently changed styles.\n" + "Example:\n" + "  const Component = styled.div.attrs({\n" + "    style: ({ background }) => ({\n" + "      background,\n" + "    }),\n" + "  })`width: 100%;`\n\n" + "  <Component />");
                warningSeen = true;
                generatedClasses = {};
            }
        }
    };
};
// 
var $0c5be144d8434123$var$determineTheme = function(props, fallbackTheme, defaultProps) {
    // Props should take precedence over ThemeProvider, which should take precedence over
    // defaultProps, but React automatically puts defaultProps on props.
    /* eslint-disable react/prop-types */ var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
    var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
    /* eslint-enable */ return theme;
};
// 
var $0c5be144d8434123$var$escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var $0c5be144d8434123$var$dashesAtEnds = /(^-|-$)/g;
/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */ function $0c5be144d8434123$var$escape(str) {
    return str// Replace all possible CSS selectors
    .replace($0c5be144d8434123$var$escapeRegex, "-")// Remove extraneous hyphens at the start and end
    .replace($0c5be144d8434123$var$dashesAtEnds, "");
}
// 
function $0c5be144d8434123$var$getComponentName(target) {
    return target.displayName || target.name || "Component";
}
// 
function $0c5be144d8434123$var$isTag(target) /* : %checks */ {
    return typeof target === "string";
}
// 
function $0c5be144d8434123$var$generateDisplayName(target) {
    return $0c5be144d8434123$var$isTag(target) ? "styled." + target : "Styled(" + $0c5be144d8434123$var$getComponentName(target) + ")";
}
// 
/* eslint-disable max-len */ /**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 * */ /*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
*/ /* eslint-enable max-len */ var $0c5be144d8434123$var$ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
/* From DOMProperty */ var $0c5be144d8434123$var$ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
var $0c5be144d8434123$var$ATTRIBUTE_NAME_CHAR = $0c5be144d8434123$var$ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
var $0c5be144d8434123$var$isCustomAttribute = RegExp.prototype.test.bind(new RegExp("^(x|data|aria)-[" + $0c5be144d8434123$var$ATTRIBUTE_NAME_CHAR + "]*$"));
var $0c5be144d8434123$var$validAttr = function(name) {
    return $0c5be144d8434123$var$ATTRIBUTE_REGEX.test(name) || $0c5be144d8434123$var$isCustomAttribute(name.toLowerCase());
};
// 
function $0c5be144d8434123$var$hasInInheritanceChain(child, parent) {
    var target = child;
    while(target){
        target = Object.getPrototypeOf(target);
        if (target && target === parent) return true;
    }
    return false;
}
// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */ var $0c5be144d8434123$var$createBroadcast = function createBroadcast(initialState) {
    var listeners = {};
    var id = 0;
    var state = initialState;
    function publish(nextState) {
        state = nextState;
        // eslint-disable-next-line guard-for-in, no-restricted-syntax
        for(var key in listeners){
            var listener = listeners[key];
            if (listener === undefined) continue;
            listener(state);
        }
    }
    function subscribe(listener) {
        var currentId = id;
        listeners[currentId] = listener;
        id += 1;
        listener(state);
        return currentId;
    }
    function unsubscribe(unsubID) {
        listeners[unsubID] = undefined;
    }
    return {
        publish: publish,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $0c5be144d8434123$var$_contextShape, $0c5be144d8434123$var$_ThemeProvider$contex;
// NOTE: DO NOT CHANGE, changing this is a semver major change!
var $0c5be144d8434123$var$CHANNEL = "__styled-components__";
var $0c5be144d8434123$var$CHANNEL_NEXT = $0c5be144d8434123$var$CHANNEL + "next__";
var $0c5be144d8434123$var$CONTEXT_CHANNEL_SHAPE = (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).shape({
    getTheme: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
    subscribe: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
    unsubscribe: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func
});
var $0c5be144d8434123$var$contextShape = ($0c5be144d8434123$var$_contextShape = {}, $0c5be144d8434123$var$_contextShape[$0c5be144d8434123$var$CHANNEL] = (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func, $0c5be144d8434123$var$_contextShape[$0c5be144d8434123$var$CHANNEL_NEXT] = $0c5be144d8434123$var$CONTEXT_CHANNEL_SHAPE, $0c5be144d8434123$var$_contextShape);
var $0c5be144d8434123$var$warnChannelDeprecated = void 0;
var $0c5be144d8434123$var$isFunction = function isFunction(test) {
    return typeof test === "function";
};
/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */ var $0c5be144d8434123$export$d8964aec282183a3 = function(_Component) {
    $0c5be144d8434123$var$inherits(ThemeProvider, _Component);
    function ThemeProvider() {
        $0c5be144d8434123$var$classCallCheck(this, ThemeProvider);
        var _this = $0c5be144d8434123$var$possibleConstructorReturn(this, _Component.call(this));
        _this.unsubscribeToOuterId = -1;
        _this.getTheme = _this.getTheme.bind(_this);
        return _this;
    }
    ThemeProvider.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
        // with the outer theme
        var outerContext = this.context[$0c5be144d8434123$var$CHANNEL_NEXT];
        if (outerContext !== undefined) this.unsubscribeToOuterId = outerContext.subscribe(function(theme) {
            _this2.outerTheme = theme;
            if (_this2.broadcast !== undefined) _this2.publish(_this2.props.theme);
        });
        this.broadcast = $0c5be144d8434123$var$createBroadcast(this.getTheme());
    };
    ThemeProvider.prototype.getChildContext = function getChildContext() {
        var _this3 = this, _babelHelpers$extends;
        return $0c5be144d8434123$var$_extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[$0c5be144d8434123$var$CHANNEL_NEXT] = {
            getTheme: this.getTheme,
            subscribe: this.broadcast.subscribe,
            unsubscribe: this.broadcast.unsubscribe
        }, _babelHelpers$extends[$0c5be144d8434123$var$CHANNEL] = function(subscriber) {
            // Patch the old `subscribe` provide via `CHANNEL` for older clients.
            var unsubscribeId = _this3.broadcast.subscribe(subscriber);
            return function() {
                return _this3.broadcast.unsubscribe(unsubscribeId);
            };
        }, _babelHelpers$extends));
    };
    ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (this.props.theme !== nextProps.theme) this.publish(nextProps.theme);
    };
    ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.unsubscribeToOuterId !== -1) this.context[$0c5be144d8434123$var$CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    };
    // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
    ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
        var theme = passedTheme || this.props.theme;
        if ($0c5be144d8434123$var$isFunction(theme)) {
            var mergedTheme = theme(this.outerTheme);
            return mergedTheme;
        }
        if (theme === null || Array.isArray(theme) || (typeof theme === "undefined" ? "undefined" : $0c5be144d8434123$var$_typeof(theme)) !== "object") throw new $0c5be144d8434123$var$StyledComponentsError(8);
        return $0c5be144d8434123$var$_extends({}, this.outerTheme, theme);
    };
    ThemeProvider.prototype.publish = function publish(theme) {
        this.broadcast.publish(this.getTheme(theme));
    };
    ThemeProvider.prototype.render = function render() {
        if (!this.props.children) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Children.only(this.props.children);
    };
    return ThemeProvider;
}((0, $9nHZC.Component));
$0c5be144d8434123$export$d8964aec282183a3.childContextTypes = $0c5be144d8434123$var$contextShape;
$0c5be144d8434123$export$d8964aec282183a3.contextTypes = ($0c5be144d8434123$var$_ThemeProvider$contex = {}, $0c5be144d8434123$var$_ThemeProvider$contex[$0c5be144d8434123$var$CHANNEL_NEXT] = $0c5be144d8434123$var$CONTEXT_CHANNEL_SHAPE, $0c5be144d8434123$var$_ThemeProvider$contex);
var $0c5be144d8434123$var$_babelHelpers$extends;
// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var $0c5be144d8434123$var$STATIC_EXECUTION_CONTEXT = {};
var $0c5be144d8434123$var$modifiedContextShape = $0c5be144d8434123$var$_extends({}, $0c5be144d8434123$var$contextShape, ($0c5be144d8434123$var$_babelHelpers$extends = {}, $0c5be144d8434123$var$_babelHelpers$extends[$0c5be144d8434123$var$CONTEXT_KEY] = (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).instanceOf($0c5be144d8434123$var$StyleSheet),
    (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).instanceOf($0c5be144d8434123$export$ae8c7d15c8b89a20)
]), $0c5be144d8434123$var$_babelHelpers$extends));
var $0c5be144d8434123$var$identifiers = {};
/* We depend on components having unique IDs */ var $0c5be144d8434123$var$generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
    var displayName = typeof _displayName !== "string" ? "sc" : $0c5be144d8434123$var$escape(_displayName);
    /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */ var nr = ($0c5be144d8434123$var$identifiers[displayName] || 0) + 1;
    $0c5be144d8434123$var$identifiers[displayName] = nr;
    var componentId = displayName + "-" + ComponentStyle.generateName(displayName + nr);
    return parentComponentId !== undefined ? parentComponentId + "-" + componentId : componentId;
};
var $0c5be144d8434123$var$warnExtendDeprecated = function warnExtendDeprecated() {};
// $FlowFixMe
var $0c5be144d8434123$var$BaseStyledComponent = function(_Component) {
    $0c5be144d8434123$var$inherits(BaseStyledComponent, _Component);
    function BaseStyledComponent() {
        var _temp, _this, _ret;
        $0c5be144d8434123$var$classCallCheck(this, BaseStyledComponent);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $0c5be144d8434123$var$possibleConstructorReturn(this, _Component.call.apply(_Component, [
            this
        ].concat(args))), _this), _this.attrs = {}, _this.state = {
            theme: null,
            generatedClassName: ""
        }, _this.unsubscribeId = -1, _temp), $0c5be144d8434123$var$possibleConstructorReturn(_this, _ret);
    }
    BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
        if (this.unsubscribeId !== -1) this.context[$0c5be144d8434123$var$CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
    };
    BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
        var attrs = this.constructor.attrs;
        var context = $0c5be144d8434123$var$_extends({}, props, {
            theme: theme
        });
        if (attrs === undefined) return context;
        this.attrs = Object.keys(attrs).reduce(function(acc, key) {
            var attr = attrs[key];
            // eslint-disable-next-line no-param-reassign
            acc[key] = typeof attr === "function" && !$0c5be144d8434123$var$hasInInheritanceChain(attr, (0, $9nHZC.Component)) ? attr(context) : attr;
            return acc;
        }, {});
        return $0c5be144d8434123$var$_extends({}, context, this.attrs);
    };
    BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
        var _constructor = this.constructor, attrs = _constructor.attrs, componentStyle = _constructor.componentStyle, warnTooManyClasses = _constructor.warnTooManyClasses;
        var styleSheet = this.context[$0c5be144d8434123$var$CONTEXT_KEY] || $0c5be144d8434123$var$StyleSheet.master;
        // statically styled-components don't need to build an execution context object,
        // and shouldn't be increasing the number of class names
        if (componentStyle.isStatic && attrs === undefined) return componentStyle.generateAndInjectStyles($0c5be144d8434123$var$STATIC_EXECUTION_CONTEXT, styleSheet);
        else {
            var executionContext = this.buildExecutionContext(theme, props);
            var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);
            return className;
        }
    };
    BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        var componentStyle = this.constructor.componentStyle;
        var styledContext = this.context[$0c5be144d8434123$var$CHANNEL_NEXT];
        // If this is a statically-styled component, we don't need to the theme
        // to generate or build styles.
        if (componentStyle.isStatic) {
            var generatedClassName = this.generateAndInjectStyles($0c5be144d8434123$var$STATIC_EXECUTION_CONTEXT, this.props);
            this.setState({
                generatedClassName: generatedClassName
            });
        // If there is a theme in the context, subscribe to the event emitter. This
        // is necessary due to pure components blocking context updates, this circumvents
        // that by updating when an event is emitted
        } else if (styledContext !== undefined) {
            var subscribe = styledContext.subscribe;
            this.unsubscribeId = subscribe(function(nextTheme) {
                // This will be called once immediately
                var theme = $0c5be144d8434123$var$determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);
                var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);
                _this2.setState({
                    theme: theme,
                    generatedClassName: generatedClassName
                });
            });
        } else {
            // eslint-disable-next-line react/prop-types
            var theme = this.props.theme || $0c5be144d8434123$var$EMPTY_OBJECT;
            var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
            this.setState({
                theme: theme,
                generatedClassName: _generatedClassName
            });
        }
    };
    BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var _this3 = this;
        // If this is a statically-styled component, we don't need to listen to
        // props changes to update styles
        var componentStyle = this.constructor.componentStyle;
        if (componentStyle.isStatic) return;
        this.setState(function(prevState) {
            var theme = $0c5be144d8434123$var$determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
            var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);
            return {
                theme: theme,
                generatedClassName: generatedClassName
            };
        });
    };
    BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unsubscribeFromContext();
    };
    BaseStyledComponent.prototype.render = function render() {
        // eslint-disable-next-line react/prop-types
        var innerRef = this.props.innerRef;
        var generatedClassName = this.state.generatedClassName;
        var _constructor2 = this.constructor, styledComponentId = _constructor2.styledComponentId, target = _constructor2.target;
        var isTargetTag = $0c5be144d8434123$var$isTag(target);
        var className = [
            // eslint-disable-next-line react/prop-types
            this.props.className,
            styledComponentId,
            this.attrs.className,
            generatedClassName
        ].filter(Boolean).join(" ");
        var baseProps = $0c5be144d8434123$var$_extends({}, this.attrs, {
            className: className
        });
        if ($0c5be144d8434123$export$7ba318d8d2f06c76(target)) baseProps.innerRef = innerRef;
        else baseProps.ref = innerRef;
        var propsForElement = baseProps;
        var key = void 0;
        for(key in this.props)// Don't pass through non HTML tags through to HTML elements
        // always omit innerRef
        if (key !== "innerRef" && key !== "className" && (!isTargetTag || $0c5be144d8434123$var$validAttr(key))) propsForElement[key] = key === "style" && key in this.attrs ? $0c5be144d8434123$var$_extends({}, this.attrs[key], this.props[key]) : this.props[key];
        return (0, $9nHZC.createElement)(target, propsForElement);
    };
    return BaseStyledComponent;
}((0, $9nHZC.Component));
var $0c5be144d8434123$var$_StyledComponent = function(ComponentStyle, constructWithOptions) {
    var createStyledComponent = function createStyledComponent(target, options, rules) {
        var _options$isClass = options.isClass, isClass = _options$isClass === undefined ? !$0c5be144d8434123$var$isTag(target) : _options$isClass, _options$displayName = options.displayName, displayName = _options$displayName === undefined ? $0c5be144d8434123$var$generateDisplayName(target) : _options$displayName, _options$componentId = options.componentId, componentId = _options$componentId === undefined ? $0c5be144d8434123$var$generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId, _options$ParentCompon = options.ParentComponent, ParentComponent = _options$ParentCompon === undefined ? $0c5be144d8434123$var$BaseStyledComponent : _options$ParentCompon, extendingRules = options.rules, attrs = options.attrs;
        var styledComponentId = options.displayName && options.componentId ? $0c5be144d8434123$var$escape(options.displayName) + "-" + options.componentId : options.componentId || componentId;
        var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);
        var StyledComponent = function(_ParentComponent) {
            $0c5be144d8434123$var$inherits(StyledComponent, _ParentComponent);
            function StyledComponent() {
                $0c5be144d8434123$var$classCallCheck(this, StyledComponent);
                return $0c5be144d8434123$var$possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
            }
            StyledComponent.withComponent = function withComponent(tag) {
                var previousComponentId = options.componentId, optionsToCopy = $0c5be144d8434123$var$objectWithoutProperties(options, [
                    "componentId"
                ]);
                var newComponentId = previousComponentId && previousComponentId + "-" + ($0c5be144d8434123$var$isTag(tag) ? tag : $0c5be144d8434123$var$escape($0c5be144d8434123$var$getComponentName(tag)));
                var newOptions = $0c5be144d8434123$var$_extends({}, optionsToCopy, {
                    componentId: newComponentId,
                    ParentComponent: StyledComponent
                });
                return createStyledComponent(tag, newOptions, rules);
            };
            $0c5be144d8434123$var$createClass(StyledComponent, null, [
                {
                    key: "extend",
                    get: function get$$1() {
                        var rulesFromOptions = options.rules, parentComponentId = options.componentId, optionsToCopy = $0c5be144d8434123$var$objectWithoutProperties(options, [
                            "rules",
                            "componentId"
                        ]);
                        var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);
                        var newOptions = $0c5be144d8434123$var$_extends({}, optionsToCopy, {
                            rules: newRules,
                            parentComponentId: parentComponentId,
                            ParentComponent: StyledComponent
                        });
                        $0c5be144d8434123$var$warnExtendDeprecated();
                        return constructWithOptions(createStyledComponent, target, newOptions);
                    }
                }
            ]);
            return StyledComponent;
        }(ParentComponent);
        StyledComponent.attrs = attrs;
        StyledComponent.componentStyle = componentStyle;
        StyledComponent.contextTypes = $0c5be144d8434123$var$modifiedContextShape;
        StyledComponent.displayName = displayName;
        StyledComponent.styledComponentId = styledComponentId;
        StyledComponent.target = target;
        if (isClass) (0, (/*@__PURE__*/$parcel$interopDefault($k9ky0)))(StyledComponent, target, {
            // all SC-specific things should not be hoisted
            attrs: true,
            componentStyle: true,
            displayName: true,
            extend: true,
            styledComponentId: true,
            target: true,
            warnTooManyClasses: true,
            withComponent: true
        });
        return StyledComponent;
    };
    return createStyledComponent;
};
// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $0c5be144d8434123$var$murmurhash(str) {
    var l = str.length | 0, h = l | 0, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return h >>> 0;
}
// 
var $0c5be144d8434123$var$areStylesCacheable = $0c5be144d8434123$var$IS_BROWSER;
var $0c5be144d8434123$var$isStaticRules = function isStaticRules(rules, attrs) {
    for(var i = 0, len = rules.length; i < len; i += 1){
        var rule = rules[i];
        // recursive case
        if (Array.isArray(rule) && !isStaticRules(rule)) return false;
        else if (typeof rule === "function" && !$0c5be144d8434123$export$7ba318d8d2f06c76(rule)) // functions are allowed to be static if they're just being
        // used to get the classname of a nested styled component
        return false;
    }
    if (attrs !== undefined) // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for(var key in attrs){
        if (typeof attrs[key] === "function") return false;
    }
    return true;
};
var $0c5be144d8434123$var$isHMREnabled = (0, null) && false;
/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */ var $0c5be144d8434123$var$_ComponentStyle = function(nameGenerator, flatten, stringifyRules) {
    /* combines hashStr (murmurhash) and nameGenerator for convenience */ var generateRuleHash = function generateRuleHash(str) {
        return nameGenerator($0c5be144d8434123$var$murmurhash(str));
    };
    var ComponentStyle = function() {
        function ComponentStyle(rules, attrs, componentId) {
            $0c5be144d8434123$var$classCallCheck(this, ComponentStyle);
            this.rules = rules;
            this.isStatic = !$0c5be144d8434123$var$isHMREnabled && $0c5be144d8434123$var$isStaticRules(rules, attrs);
            this.componentId = componentId;
            if (!$0c5be144d8434123$var$StyleSheet.master.hasId(componentId)) {
                var placeholder = [];
                $0c5be144d8434123$var$StyleSheet.master.deferredInject(componentId, placeholder);
            }
        }
        /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */ ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
            var isStatic = this.isStatic, componentId = this.componentId, lastClassName = this.lastClassName;
            if ($0c5be144d8434123$var$areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) return lastClassName;
            var flatCSS = flatten(this.rules, executionContext);
            var name = generateRuleHash(this.componentId + flatCSS.join(""));
            if (!styleSheet.hasNameForId(componentId, name)) styleSheet.inject(this.componentId, stringifyRules(flatCSS, "." + name), name);
            this.lastClassName = name;
            return name;
        };
        ComponentStyle.generateName = function generateName(str) {
            return generateRuleHash(str);
        };
        return ComponentStyle;
    }();
    return ComponentStyle;
};
// 
// Thanks to ReactDOMFactories for this handy list!
var $0c5be144d8434123$var$domElements = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    // SVG
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
// 
var $0c5be144d8434123$var$_styled = function(styledComponent, constructWithOptions) {
    var styled = function styled(tag) {
        return constructWithOptions(styledComponent, tag);
    };
    // Shorthands for all valid HTML Elements
    $0c5be144d8434123$var$domElements.forEach(function(domElement) {
        styled[domElement] = styled(domElement);
    });
    return styled;
};
// 
var $0c5be144d8434123$var$replaceWhitespace = function replaceWhitespace(str) {
    return str.replace(/\s|\\n/g, "");
};
var $0c5be144d8434123$var$_keyframes = function(nameGenerator, stringifyRules, css) {
    return function() {
        var styleSheet = $0c5be144d8434123$var$StyleSheet.master;
        var rules = css.apply(undefined, arguments);
        var name = nameGenerator($0c5be144d8434123$var$murmurhash($0c5be144d8434123$var$replaceWhitespace(JSON.stringify(rules))));
        var id = "sc-keyframes-" + name;
        if (!styleSheet.hasNameForId(id, name)) styleSheet.inject(id, stringifyRules(rules, name, "@keyframes"), name);
        return name;
    };
};
// 
var $0c5be144d8434123$var$_injectGlobal = function(stringifyRules, css) {
    var injectGlobal = function injectGlobal() {
        var styleSheet = $0c5be144d8434123$var$StyleSheet.master;
        var rules = css.apply(undefined, arguments);
        var hash = $0c5be144d8434123$var$murmurhash(JSON.stringify(rules));
        var id = "sc-global-" + hash;
        if (!styleSheet.hasId(id)) styleSheet.inject(id, stringifyRules(rules));
    };
    return injectGlobal;
};
// 
var $0c5be144d8434123$var$_constructWithOptions = function(css) {
    var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $0c5be144d8434123$var$EMPTY_OBJECT;
        if (!(0, $fAROH.isValidElementType)(tag)) throw new $0c5be144d8434123$var$StyledComponentsError(1, String(tag));
        /* This is callable directly as a template function */ // $FlowFixMe: Not typed to avoid destructuring arguments
        var templateFunction = function templateFunction() {
            return componentConstructor(tag, options, css.apply(undefined, arguments));
        };
        /* If config methods are called, wrap up a new template function and merge options */ templateFunction.withConfig = function(config) {
            return constructWithOptions(componentConstructor, tag, $0c5be144d8434123$var$_extends({}, options, config));
        };
        templateFunction.attrs = function(attrs) {
            return constructWithOptions(componentConstructor, tag, $0c5be144d8434123$var$_extends({}, options, {
                attrs: $0c5be144d8434123$var$_extends({}, options.attrs || $0c5be144d8434123$var$EMPTY_OBJECT, attrs)
            }));
        };
        return templateFunction;
    };
    return constructWithOptions;
};
// 
var $0c5be144d8434123$export$e8748c6a27b910dc = function(Component$$1) {
    var isStatelessFunctionalComponent = typeof Component$$1 === "function" && // $FlowFixMe TODO: flow for prototype
    !(Component$$1.prototype && "isReactComponent" in Component$$1.prototype);
    // NOTE: We can't pass a ref to a stateless functional component
    var shouldSetInnerRef = $0c5be144d8434123$export$7ba318d8d2f06c76(Component$$1) || isStatelessFunctionalComponent;
    var WithTheme = function(_React$Component) {
        $0c5be144d8434123$var$inherits(WithTheme, _React$Component);
        function WithTheme() {
            var _temp, _this, _ret;
            $0c5be144d8434123$var$classCallCheck(this, WithTheme);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $0c5be144d8434123$var$possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
                this
            ].concat(args))), _this), _this.state = $0c5be144d8434123$var$EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), $0c5be144d8434123$var$possibleConstructorReturn(_this, _ret);
        }
        // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping
        WithTheme.prototype.componentWillMount = function componentWillMount() {
            var _this2 = this;
            var defaultProps = this.constructor.defaultProps;
            var styledContext = this.context[$0c5be144d8434123$var$CHANNEL_NEXT];
            var themeProp = $0c5be144d8434123$var$determineTheme(this.props, undefined, defaultProps);
            if (styledContext === undefined && themeProp !== undefined) this.setState({
                theme: themeProp
            });
            else {
                var subscribe = styledContext.subscribe;
                this.unsubscribeId = subscribe(function(nextTheme) {
                    var theme = $0c5be144d8434123$var$determineTheme(_this2.props, nextTheme, defaultProps);
                    _this2.setState({
                        theme: theme
                    });
                });
            }
        };
        WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var defaultProps = this.constructor.defaultProps;
            this.setState(function(oldState) {
                var theme = $0c5be144d8434123$var$determineTheme(nextProps, oldState.theme, defaultProps);
                return {
                    theme: theme
                };
            });
        };
        WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
            if (this.unsubscribeId !== -1) this.context[$0c5be144d8434123$var$CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
        };
        WithTheme.prototype.render = function render() {
            var props = $0c5be144d8434123$var$_extends({
                theme: this.state.theme
            }, this.props);
            if (!shouldSetInnerRef) {
                props.ref = props.innerRef;
                delete props.innerRef;
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Component$$1, props);
        };
        return WithTheme;
    }((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component);
    WithTheme.contextTypes = $0c5be144d8434123$var$contextShape;
    WithTheme.displayName = "WithTheme(" + $0c5be144d8434123$var$getComponentName(Component$$1) + ")";
    WithTheme.styledComponentId = "withTheme";
    return (0, (/*@__PURE__*/$parcel$interopDefault($k9ky0)))(WithTheme, Component$$1);
};
// 
/* eslint-disable */ var $0c5be144d8434123$export$84079c323bb0915e = {
    StyleSheet: $0c5be144d8434123$var$StyleSheet
};
/* Instantiate singletons */ var $0c5be144d8434123$var$ComponentStyle = $0c5be144d8434123$var$_ComponentStyle($0c5be144d8434123$var$generateAlphabeticName, $0c5be144d8434123$var$flatten, $0c5be144d8434123$var$stringifyRules);
var $0c5be144d8434123$var$constructWithOptions = $0c5be144d8434123$var$_constructWithOptions($0c5be144d8434123$export$dbf350e5966cf602);
var $0c5be144d8434123$var$StyledComponent = $0c5be144d8434123$var$_StyledComponent($0c5be144d8434123$var$ComponentStyle, $0c5be144d8434123$var$constructWithOptions);
/* Instantiate exported singletons */ var $0c5be144d8434123$export$d25ddfdf17c3ad3e = $0c5be144d8434123$var$_keyframes($0c5be144d8434123$var$generateAlphabeticName, $0c5be144d8434123$var$stringifyRules, $0c5be144d8434123$export$dbf350e5966cf602);
var $0c5be144d8434123$export$efb9f5caaa2ca0c7 = $0c5be144d8434123$var$_injectGlobal($0c5be144d8434123$var$stringifyRules, $0c5be144d8434123$export$dbf350e5966cf602);
var $0c5be144d8434123$var$styled = $0c5be144d8434123$var$_styled($0c5be144d8434123$var$StyledComponent, $0c5be144d8434123$var$constructWithOptions);
var $0c5be144d8434123$export$2e2bcd8739ae039 = $0c5be144d8434123$var$styled;

});
parcelRegister("eMALc", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ "use strict";

var $eexG5 = parcelRequire("eexG5");
var $ac3210348c3dd7b2$var$msPattern = /^ms-/;
/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */ function $ac3210348c3dd7b2$var$hyphenateStyleName(string) {
    return $eexG5(string).replace($ac3210348c3dd7b2$var$msPattern, "-ms-");
}
module.exports = $ac3210348c3dd7b2$var$hyphenateStyleName;

});
parcelRegister("eexG5", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ var $a5cc7f3099c43255$var$_uppercasePattern = /([A-Z])/g;
/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */ function $a5cc7f3099c43255$var$hyphenate(string) {
    return string.replace($a5cc7f3099c43255$var$_uppercasePattern, "-$1").toLowerCase();
}
module.exports = $a5cc7f3099c43255$var$hyphenate;

});


parcelRegister("2Mvug", function(module, exports) {
/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */ (function(factory) {
    module.exports = factory(null);
})(/** @param {*=} options */ function factory(options) {
    "use strict";
    /**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */ var nullptn = /^\0+/g /* matches leading null characters */ ;
    var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */ ;
    var colonptn = /: */g /* splits animation rules */ ;
    var cursorptn = /zoo|gra/ /* assert cursor varient */ ;
    var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */ ;
    var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */ ;
    var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */ ;
    var elementptn = / *[\0] */g /* selector elements */ ;
    var selectorptn = /,\r+?/g /* splits selectors */ ;
    var andptn = /([\t\r\n ])*\f?&/g /* match & */ ;
    var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */ ;
    var invalidptn = /\W+/g /* removes invalid characters from keyframes */ ;
    var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */ ;
    var plcholdrptn = /::(place)/g /* match ::placeholder varient */ ;
    var readonlyptn = /:(read-only)/g /* match :read-only varient */ ;
    var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */ ;
    var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */ ;
    var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */ ;
    var whiteptn = /\s{2,}/g /* matches repeating whitespace */ ;
    var pseudoptn = /([^\(])(:+) */g /* pseudo element */ ;
    var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */ ;
    var gradientptn = /([\w-]+t\()/g /* match *gradient property */ ;
    var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */ ;
    var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */ ;
    var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */ ;
    var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */ ;
    var trimptn = /[ \t]+$/ /* match tail whitspace */ ;
    var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */ ;
    var imgsrcptn = /([^-])(image-set\()/;
    /* vendors */ var webkit = "-webkit-";
    var moz = "-moz-";
    var ms = "-ms-";
    /* character codes */ var SEMICOLON = 59 /* ; */ ;
    var CLOSEBRACES = 125 /* } */ ;
    var OPENBRACES = 123 /* { */ ;
    var OPENPARENTHESES = 40 /* ( */ ;
    var CLOSEPARENTHESES = 41 /* ) */ ;
    var OPENBRACKET = 91 /* [ */ ;
    var CLOSEBRACKET = 93 /* ] */ ;
    var NEWLINE = 10 /* \n */ ;
    var CARRIAGE = 13 /* \r */ ;
    var TAB = 9 /* \t */ ;
    var AT = 64 /* @ */ ;
    var SPACE = 32 /*   */ ;
    var AND = 38 /* & */ ;
    var DASH = 45 /* - */ ;
    var UNDERSCORE = 95 /* _ */ ;
    var STAR = 42 /* * */ ;
    var COMMA = 44 /* , */ ;
    var COLON = 58 /* : */ ;
    var SINGLEQUOTE = 39 /* ' */ ;
    var DOUBLEQUOTE = 34 /* " */ ;
    var FOWARDSLASH = 47 /* / */ ;
    var GREATERTHAN = 62 /* > */ ;
    var PLUS = 43 /* + */ ;
    var TILDE = 126 /* ~ */ ;
    var NULL = 0 /* \0 */ ;
    var FORMFEED = 12 /* \f */ ;
    var VERTICALTAB = 11 /* \v */ ;
    /* special identifiers */ var KEYFRAME = 107 /* k */ ;
    var MEDIA = 109 /* m */ ;
    var SUPPORTS = 115 /* s */ ;
    var PLACEHOLDER = 112 /* p */ ;
    var READONLY = 111 /* o */ ;
    var IMPORT = 105 /* <at>i */ ;
    var CHARSET = 99 /* <at>c */ ;
    var DOCUMENT = 100 /* <at>d */ ;
    var PAGE = 112 /* <at>p */ ;
    var column = 1 /* current column */ ;
    var line = 1 /* current line numebr */ ;
    var pattern = 0 /* :pattern */ ;
    var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */ ;
    var prefix = 1 /* vendor prefix */ ;
    var escape = 1 /* escape :global() pattern */ ;
    var compress = 0 /* compress output */ ;
    var semicolon = 0 /* no/semicolon option */ ;
    var preserve = 0 /* preserve empty selectors */ ;
    /* empty reference */ var array = [];
    /* plugins */ var plugins = [];
    var plugged = 0;
    var should = null;
    /* plugin context */ var POSTS = -2;
    var PREPS = -1;
    var UNKWN = 0;
    var PROPS = 1;
    var BLCKS = 2;
    var ATRUL = 3;
    /* plugin newline context */ var unkwn = 0;
    /* keyframe animation */ var keyed = 1;
    var key = "";
    /* selector namespace */ var nscopealt = "";
    var nscope = "";
    /**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */ function compile(parent, current, body, id, depth) {
        var bracket = 0 /* brackets [] */ ;
        var comment = 0 /* comments /* // or /* */ ;
        var parentheses = 0 /* functions () */ ;
        var quote = 0 /* quotes '', "" */ ;
        var first = 0 /* first character code */ ;
        var second = 0 /* second character code */ ;
        var code = 0 /* current character code */ ;
        var tail = 0 /* previous character code */ ;
        var trail = 0 /* character before previous code */ ;
        var peak = 0 /* previous non-whitespace code */ ;
        var counter = 0 /* count sequence termination */ ;
        var context = 0 /* track current context */ ;
        var atrule = 0 /* track @at-rule context */ ;
        var pseudo = 0 /* track pseudo token index */ ;
        var caret = 0 /* current character index */ ;
        var format = 0 /* control character formating context */ ;
        var insert = 0 /* auto semicolon insertion */ ;
        var invert = 0 /* inverted selector pattern */ ;
        var length = 0 /* generic length address */ ;
        var eof = body.length /* end of file(length) */ ;
        var eol = eof - 1 /* end of file(characters) */ ;
        var char = "" /* current character */ ;
        var chars = "" /* current buffer of characters */ ;
        var child = "" /* next buffer of characters */ ;
        var out = "" /* compiled body */ ;
        var children = "" /* compiled children */ ;
        var flat = "" /* compiled leafs */ ;
        var selector /* generic selector address */ ;
        var result /* generic address */ ;
        // ...build body
        while(caret < eof){
            code = body.charCodeAt(caret);
            // eof varient
            if (caret === eol) // last character + noop context, add synthetic padding for noop context to terminate
            {
                if (comment + quote + parentheses + bracket !== 0) {
                    if (comment !== 0) code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH;
                    quote = parentheses = bracket = 0;
                    eof++;
                    eol++;
                }
            }
            if (comment + quote + parentheses + bracket === 0) {
                // eof varient
                if (caret === eol) {
                    if (format > 0) chars = chars.replace(formatptn, "");
                    if (chars.trim().length > 0) {
                        switch(code){
                            case SPACE:
                            case TAB:
                            case SEMICOLON:
                            case CARRIAGE:
                            case NEWLINE:
                                break;
                            default:
                                chars += body.charAt(caret);
                        }
                        code = SEMICOLON;
                    }
                }
                // auto semicolon insertion
                if (insert === 1) switch(code){
                    // false flags
                    case OPENBRACES:
                    case CLOSEBRACES:
                    case SEMICOLON:
                    case DOUBLEQUOTE:
                    case SINGLEQUOTE:
                    case OPENPARENTHESES:
                    case CLOSEPARENTHESES:
                    case COMMA:
                        insert = 0;
                    // ignore
                    case TAB:
                    case CARRIAGE:
                    case NEWLINE:
                    case SPACE:
                        break;
                    // valid
                    default:
                        insert = 0;
                        length = caret;
                        first = code;
                        caret--;
                        code = SEMICOLON;
                        while(length < eof)switch(body.charCodeAt(length++)){
                            case NEWLINE:
                            case CARRIAGE:
                            case SEMICOLON:
                                ++caret;
                                code = first;
                                length = eof;
                                break;
                            case COLON:
                                if (format > 0) {
                                    ++caret;
                                    code = first;
                                }
                            case OPENBRACES:
                                length = eof;
                        }
                }
                // token varient
                switch(code){
                    case OPENBRACES:
                        chars = chars.trim();
                        first = chars.charCodeAt(0);
                        counter = 1;
                        length = ++caret;
                        while(caret < eof){
                            switch(code = body.charCodeAt(caret)){
                                case OPENBRACES:
                                    counter++;
                                    break;
                                case CLOSEBRACES:
                                    counter--;
                                    break;
                                case FOWARDSLASH:
                                    switch(second = body.charCodeAt(caret + 1)){
                                        // /*, //
                                        case STAR:
                                        case FOWARDSLASH:
                                            caret = delimited(second, caret, eol, body);
                                    }
                                    break;
                                // given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
                                case OPENBRACKET:
                                    code++;
                                // given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
                                case OPENPARENTHESES:
                                    code++;
                                // quote tail delimiter is identical to the head delimiter hence noop,
                                // fallthrough clauses have been shifted to the correct tail delimiter
                                case DOUBLEQUOTE:
                                case SINGLEQUOTE:
                                    while(caret++ < eol){
                                        if (body.charCodeAt(caret) === code) break;
                                    }
                            }
                            if (counter === 0) break;
                            caret++;
                        }
                        child = body.substring(length, caret);
                        if (first === NULL) first = (chars = chars.replace(nullptn, "").trim()).charCodeAt(0);
                        switch(first){
                            // @at-rule
                            case AT:
                                if (format > 0) chars = chars.replace(formatptn, "");
                                second = chars.charCodeAt(1);
                                switch(second){
                                    case DOCUMENT:
                                    case MEDIA:
                                    case SUPPORTS:
                                    case DASH:
                                        selector = current;
                                        break;
                                    default:
                                        selector = array;
                                }
                                child = compile(current, selector, child, second, depth + 1);
                                length = child.length;
                                // preserve empty @at-rule
                                if (preserve > 0 && length === 0) length = chars.length;
                                // execute plugins, @at-rule context
                                if (plugged > 0) {
                                    selector = select(array, chars, invert);
                                    result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id);
                                    chars = selector.join("");
                                    if (result !== void 0) {
                                        if ((length = (child = result.trim()).length) === 0) {
                                            second = 0;
                                            child = "";
                                        }
                                    }
                                }
                                if (length > 0) switch(second){
                                    case SUPPORTS:
                                        chars = chars.replace(supportsptn, supports);
                                    case DOCUMENT:
                                    case MEDIA:
                                    case DASH:
                                        child = chars + "{" + child + "}";
                                        break;
                                    case KEYFRAME:
                                        chars = chars.replace(keyframeptn, "$1 $2" + (keyed > 0 ? key : ""));
                                        child = chars + "{" + child + "}";
                                        if (prefix === 1 || prefix === 2 && vendor("@" + child, 3)) child = "@" + webkit + child + "@" + child;
                                        else child = "@" + child;
                                        break;
                                    default:
                                        child = chars + child;
                                        if (id === PAGE) child = (out += child, "");
                                }
                                else child = "";
                                break;
                            // selector
                            default:
                                child = compile(current, select(current, chars, invert), child, id, depth + 1);
                        }
                        children += child;
                        // reset
                        context = 0;
                        insert = 0;
                        pseudo = 0;
                        format = 0;
                        invert = 0;
                        atrule = 0;
                        chars = "";
                        child = "";
                        code = body.charCodeAt(++caret);
                        break;
                    case CLOSEBRACES:
                    case SEMICOLON:
                        chars = (format > 0 ? chars.replace(formatptn, "") : chars).trim();
                        if ((length = chars.length) > 1) {
                            // monkey-patch missing colon
                            if (pseudo === 0) {
                                first = chars.charCodeAt(0);
                                // first character is a letter or dash, buffer has a space character
                                if (first === DASH || first > 96 && first < 123) length = (chars = chars.replace(" ", ":")).length;
                            }
                            // execute plugins, property context
                            if (plugged > 0) {
                                if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
                                    if ((length = (chars = result.trim()).length) === 0) chars = "\x00\x00";
                                }
                            }
                            first = chars.charCodeAt(0);
                            second = chars.charCodeAt(1);
                            switch(first){
                                case NULL:
                                    break;
                                case AT:
                                    if (second === IMPORT || second === CHARSET) {
                                        flat += chars + body.charAt(caret);
                                        break;
                                    }
                                default:
                                    if (chars.charCodeAt(length - 1) === COLON) break;
                                    out += property(chars, first, second, chars.charCodeAt(2));
                            }
                        }
                        // reset
                        context = 0;
                        insert = 0;
                        pseudo = 0;
                        format = 0;
                        invert = 0;
                        chars = "";
                        code = body.charCodeAt(++caret);
                        break;
                }
            }
            // parse characters
            switch(code){
                case CARRIAGE:
                case NEWLINE:
                    // auto insert semicolon
                    if (comment + quote + parentheses + bracket + semicolon === 0) // valid non-whitespace characters that
                    // may precede a newline
                    switch(peak){
                        case CLOSEPARENTHESES:
                        case SINGLEQUOTE:
                        case DOUBLEQUOTE:
                        case AT:
                        case TILDE:
                        case GREATERTHAN:
                        case STAR:
                        case PLUS:
                        case FOWARDSLASH:
                        case DASH:
                        case COLON:
                        case COMMA:
                        case SEMICOLON:
                        case OPENBRACES:
                        case CLOSEBRACES:
                            break;
                        default:
                            // current buffer has a colon
                            if (pseudo > 0) insert = 1;
                    }
                    // terminate line comment
                    if (comment === FOWARDSLASH) comment = 0;
                    else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
                        format = 1;
                        chars += "\x00";
                    }
                    // execute plugins, newline context
                    if (plugged * unkwn > 0) proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id);
                    // next line, reset column position
                    column = 1;
                    line++;
                    break;
                case SEMICOLON:
                case CLOSEBRACES:
                    if (comment + quote + parentheses + bracket === 0) {
                        column++;
                        break;
                    }
                default:
                    // increment column position
                    column++;
                    // current character
                    char = body.charAt(caret);
                    // remove comments, escape functions, strings, attributes and prepare selectors
                    switch(code){
                        case TAB:
                        case SPACE:
                            if (quote + bracket + comment === 0) switch(tail){
                                case COMMA:
                                case COLON:
                                case TAB:
                                case SPACE:
                                    char = "";
                                    break;
                                default:
                                    if (code !== SPACE) char = " ";
                            }
                            break;
                        // escape breaking control characters
                        case NULL:
                            char = "\\0";
                            break;
                        case FORMFEED:
                            char = "\\f";
                            break;
                        case VERTICALTAB:
                            char = "\\v";
                            break;
                        // &
                        case AND:
                            // inverted selector pattern i.e html &
                            if (quote + comment + bracket === 0 && cascade > 0) {
                                invert = 1;
                                format = 1;
                                char = "\f" + char;
                            }
                            break;
                        // ::p<l>aceholder, l
                        // :read-on<l>y, l
                        case 108:
                            if (quote + comment + bracket + pattern === 0 && pseudo > 0) switch(caret - pseudo){
                                // ::placeholder
                                case 2:
                                    if (tail === PLACEHOLDER && body.charCodeAt(caret - 3) === COLON) pattern = tail;
                                // :read-only
                                case 8:
                                    if (trail === READONLY) pattern = trail;
                            }
                            break;
                        // :<pattern>
                        case COLON:
                            if (quote + comment + bracket === 0) pseudo = caret;
                            break;
                        // selectors
                        case COMMA:
                            if (comment + parentheses + quote + bracket === 0) {
                                format = 1;
                                char += "\r";
                            }
                            break;
                        // quotes
                        case DOUBLEQUOTE:
                        case SINGLEQUOTE:
                            if (comment === 0) quote = quote === code ? 0 : quote === 0 ? code : quote;
                            break;
                        // attributes
                        case OPENBRACKET:
                            if (quote + comment + parentheses === 0) bracket++;
                            break;
                        case CLOSEBRACKET:
                            if (quote + comment + parentheses === 0) bracket--;
                            break;
                        // functions
                        case CLOSEPARENTHESES:
                            if (quote + comment + bracket === 0) parentheses--;
                            break;
                        case OPENPARENTHESES:
                            if (quote + comment + bracket === 0) {
                                if (context === 0) switch(tail * 2 + trail * 3){
                                    // :matches
                                    case 533:
                                        break;
                                    // :global, :not, :nth-child etc...
                                    default:
                                        counter = 0;
                                        context = 1;
                                }
                                parentheses++;
                            }
                            break;
                        case AT:
                            if (comment + parentheses + quote + bracket + pseudo + atrule === 0) atrule = 1;
                            break;
                        // block/line comments
                        case STAR:
                        case FOWARDSLASH:
                            if (quote + bracket + parentheses > 0) break;
                            switch(comment){
                                // initialize line/block comment context
                                case 0:
                                    switch(code * 2 + body.charCodeAt(caret + 1) * 3){
                                        // //
                                        case 235:
                                            comment = FOWARDSLASH;
                                            break;
                                        // /*
                                        case 220:
                                            length = caret;
                                            comment = STAR;
                                            break;
                                    }
                                    break;
                                // end block comment context
                                case STAR:
                                    if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
                                        // /*<!> ... */, !
                                        if (body.charCodeAt(length + 2) === 33) out += body.substring(length, caret + 1);
                                        char = "";
                                        comment = 0;
                                    }
                            }
                    }
                    // ignore comment blocks
                    if (comment === 0) {
                        // aggressive isolation mode, divide each individual selector
                        // including selectors in :not function but excluding selectors in :global function
                        if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) switch(code){
                            case COMMA:
                            case TILDE:
                            case GREATERTHAN:
                            case PLUS:
                            case CLOSEPARENTHESES:
                            case OPENPARENTHESES:
                                if (context === 0) {
                                    // outside of an isolated context i.e nth-child(<...>)
                                    switch(tail){
                                        case TAB:
                                        case SPACE:
                                        case NEWLINE:
                                        case CARRIAGE:
                                            char = char + "\x00";
                                            break;
                                        default:
                                            char = "\x00" + char + (code === COMMA ? "" : "\x00");
                                    }
                                    format = 1;
                                } else // within an isolated context, sleep untill it's terminated
                                switch(code){
                                    case OPENPARENTHESES:
                                        // :globa<l>(
                                        if (pseudo + 7 === caret && tail === 108) pseudo = 0;
                                        context = ++counter;
                                        break;
                                    case CLOSEPARENTHESES:
                                        if ((context = --counter) === 0) {
                                            format = 1;
                                            char += "\x00";
                                        }
                                        break;
                                }
                                break;
                            case TAB:
                            case SPACE:
                                switch(tail){
                                    case NULL:
                                    case OPENBRACES:
                                    case CLOSEBRACES:
                                    case SEMICOLON:
                                    case COMMA:
                                    case FORMFEED:
                                    case TAB:
                                    case SPACE:
                                    case NEWLINE:
                                    case CARRIAGE:
                                        break;
                                    default:
                                        // ignore in isolated contexts
                                        if (context === 0) {
                                            format = 1;
                                            char += "\x00";
                                        }
                                }
                        }
                        // concat buffer of characters
                        chars += char;
                        // previous non-whitespace character code
                        if (code !== SPACE && code !== TAB) peak = code;
                    }
            }
            // tail character codes
            trail = tail;
            tail = code;
            // visit every character
            caret++;
        }
        length = out.length;
        // preserve empty selector
        if (preserve > 0) {
            if (length === 0 && children.length === 0 && current[0].length === 0 === false) {
                if (id !== MEDIA || current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0]) length = current.join(",").length + 2;
            }
        }
        if (length > 0) {
            // cascade isolation mode?
            selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current;
            // execute plugins, block context
            if (plugged > 0) {
                result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id);
                if (result !== void 0 && (out = result).length === 0) return flat + out + children;
            }
            out = selector.join(",") + "{" + out + "}";
            if (prefix * pattern !== 0) {
                if (prefix === 2 && !vendor(out, 2)) pattern = 0;
                switch(pattern){
                    // ::read-only
                    case READONLY:
                        out = out.replace(readonlyptn, ":" + moz + "$1") + out;
                        break;
                    // ::placeholder
                    case PLACEHOLDER:
                        out = out.replace(plcholdrptn, "::" + webkit + "input-$1") + out.replace(plcholdrptn, "::" + moz + "$1") + out.replace(plcholdrptn, ":" + ms + "input-$1") + out;
                        break;
                }
                pattern = 0;
            }
        }
        return flat + out + children;
    }
    /**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */ function select(parent, current, invert) {
        var selectors = current.trim().split(selectorptn);
        var out = selectors;
        var length = selectors.length;
        var l = parent.length;
        switch(l){
            // 0-1 parent selectors
            case 0:
            case 1:
                for(var i = 0, selector = l === 0 ? "" : parent[0] + " "; i < length; ++i)out[i] = scope(selector, out[i], invert, l).trim();
                break;
            // >2 parent selectors, nested
            default:
                for(var i = 0, j = 0, out = []; i < length; ++i)for(var k = 0; k < l; ++k)out[j++] = scope(parent[k] + " ", selectors[i], invert, l).trim();
        }
        return out;
    }
    /**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */ function scope(parent, current, invert, level) {
        var selector = current;
        var code = selector.charCodeAt(0);
        // trim leading whitespace
        if (code < 33) code = (selector = selector.trim()).charCodeAt(0);
        switch(code){
            // &
            case AND:
                switch(cascade + level){
                    case 0:
                    case 1:
                        if (parent.trim().length === 0) break;
                    default:
                        return selector.replace(andptn, "$1" + parent.trim());
                }
                break;
            // :
            case COLON:
                switch(selector.charCodeAt(1)){
                    // g in :global
                    case 103:
                        if (escape > 0 && cascade > 0) return selector.replace(escapeptn, "$1").replace(andptn, "$1" + nscope);
                        break;
                    default:
                        // :hover
                        return parent.trim() + selector.replace(andptn, "$1" + parent.trim());
                }
            default:
                // html &
                if (invert * cascade > 0 && selector.indexOf("\f") > 0) return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? "" : "$1") + parent.trim());
        }
        return parent + selector;
    }
    /**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */ function property(input, first, second, third) {
        var index = 0;
        var out = input + ";";
        var hash = first * 2 + second * 3 + third * 4;
        var cache;
        // animation: a, n, i characters
        if (hash === 944) return animation(out);
        else if (prefix === 0 || prefix === 2 && !vendor(out, 1)) return out;
        // vendor prefix
        switch(hash){
            // text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
            case 1015:
                // text-shadow/text-align/text-transform, a
                return out.charCodeAt(10) === 97 ? webkit + out + out : out;
            // filter/fill f, i, l
            case 951:
                // filter, t
                return out.charCodeAt(3) === 116 ? webkit + out + out : out;
            // color/column, c, o, l
            case 963:
                // column, n
                return out.charCodeAt(5) === 110 ? webkit + out + out : out;
            // box-decoration-break, b, o, x
            case 1009:
                if (out.charCodeAt(4) !== 100) break;
            // mask, m, a, s
            // clip-path, c, l, i
            case 969:
            case 942:
                return webkit + out + out;
            // appearance: a, p, p
            case 978:
                return webkit + out + moz + out + out;
            // hyphens: h, y, p
            // user-select: u, s, e
            case 1019:
            case 983:
                return webkit + out + moz + out + ms + out + out;
            // background/backface-visibility, b, a, c
            case 883:
                // backface-visibility, -
                if (out.charCodeAt(8) === DASH) return webkit + out + out;
                // image-set(...)
                if (out.indexOf("image-set(", 11) > 0) return out.replace(imgsrcptn, "$1" + webkit + "$2") + out;
                return out;
            // flex: f, l, e
            case 932:
                if (out.charCodeAt(4) === DASH) switch(out.charCodeAt(5)){
                    // flex-grow, g
                    case 103:
                        return webkit + "box-" + out.replace("-grow", "") + webkit + out + ms + out.replace("grow", "positive") + out;
                    // flex-shrink, s
                    case 115:
                        return webkit + out + ms + out.replace("shrink", "negative") + out;
                    // flex-basis, b
                    case 98:
                        return webkit + out + ms + out.replace("basis", "preferred-size") + out;
                }
                return webkit + out + ms + out + out;
            // order: o, r, d
            case 964:
                return webkit + out + ms + "flex" + "-" + out + out;
            // justify-items/justify-content, j, u, s
            case 1023:
                // justify-content, c
                if (out.charCodeAt(8) !== 99) break;
                cache = out.substring(out.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return webkit + "box-pack" + cache + webkit + out + ms + "flex-pack" + cache + out;
            // cursor, c, u, r
            case 1005:
                return cursorptn.test(out) ? out.replace(colonptn, ":" + webkit) + out.replace(colonptn, ":" + moz) + out : out;
            // writing-mode, w, r, i
            case 1000:
                cache = out.substring(13).trim();
                index = cache.indexOf("-") + 1;
                switch(cache.charCodeAt(0) + cache.charCodeAt(index)){
                    // vertical-lr
                    case 226:
                        cache = out.replace(writingptn, "tb");
                        break;
                    // vertical-rl
                    case 232:
                        cache = out.replace(writingptn, "tb-rl");
                        break;
                    // horizontal-tb
                    case 220:
                        cache = out.replace(writingptn, "lr");
                        break;
                    default:
                        return out;
                }
                return webkit + out + ms + cache + out;
            // position: sticky
            case 1017:
                if (out.indexOf("sticky", 9) === -1) return out;
            // display(flex/inline-flex/inline-box): d, i, s
            case 975:
                index = (out = input).length - 10;
                cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(":", 7) + 1).trim();
                switch(hash = cache.charCodeAt(0) + (cache.charCodeAt(7) | 0)){
                    // inline-
                    case 203:
                        // inline-box
                        if (cache.charCodeAt(8) < 111) break;
                    // inline-box/sticky
                    case 115:
                        out = out.replace(cache, webkit + cache) + ";" + out;
                        break;
                    // inline-flex
                    // flex
                    case 207:
                    case 102:
                        out = out.replace(cache, webkit + (hash > 102 ? "inline-" : "") + "box") + ";" + out.replace(cache, webkit + cache) + ";" + out.replace(cache, ms + cache + "box") + ";" + out;
                }
                return out + ";";
            // align-items, align-center, align-self: a, l, i, -
            case 938:
                if (out.charCodeAt(5) === DASH) switch(out.charCodeAt(6)){
                    // align-items, i
                    case 105:
                        cache = out.replace("-items", "");
                        return webkit + out + webkit + "box-" + cache + ms + "flex-" + cache + out;
                    // align-self, s
                    case 115:
                        return webkit + out + ms + "flex-item-" + out.replace(selfptn, "") + out;
                    // align-content
                    default:
                        return webkit + out + ms + "flex-line-pack" + out.replace("align-content", "").replace(selfptn, "") + out;
                }
                break;
            // min/max
            case 973:
            case 989:
                // min-/max- height/width/block-size/inline-size
                if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) break;
            // height/width: min-content / width: max-content
            case 931:
            case 953:
                if (dimensionptn.test(input) === true) {
                    // stretch
                    if ((cache = input.substring(input.indexOf(":") + 1)).charCodeAt(0) === 115) return property(input.replace("stretch", "fill-available"), first, second, third).replace(":fill-available", ":stretch");
                    else return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace("fill-", "")) + out;
                }
                break;
            // transform, transition: t, r, a
            case 962:
                out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : "") + out;
                // transitions
                if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf("transform", 10) > 0) return out.substring(0, out.indexOf(";", 27) + 1).replace(transformptn, "$1" + webkit + "$2") + out;
                break;
        }
        return out;
    }
    /**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */ function vendor(content, context) {
        var index = content.indexOf(context === 1 ? ":" : "{");
        var key = content.substring(0, context !== 3 ? index : 10);
        var value = content.substring(index + 1, content.length - 1);
        return should(context !== 2 ? key : key.replace(pseudofmt, "$1"), value, context);
    }
    /**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */ function supports(match, group) {
        var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2));
        return out !== group + ";" ? out.replace(propertyptn, " or ($1)").substring(4) : "(" + group + ")";
    }
    /**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */ function animation(input) {
        var length = input.length;
        var index = input.indexOf(":", 9) + 1;
        var declare = input.substring(0, index).trim();
        var out = input.substring(index, length - 1).trim();
        switch(input.charCodeAt(9) * keyed){
            case 0:
                break;
            // animation-*, -
            case DASH:
                // animation-name, n
                if (input.charCodeAt(10) !== 110) break;
            // animation/animation-name
            default:
                // split in case of multiple animations
                var list = out.split((out = "", animationptn));
                for(var i = 0, index = 0, length = list.length; i < length; index = 0, ++i){
                    var value = list[i];
                    var items = value.split(propertiesptn);
                    while(value = items[index]){
                        var peak = value.charCodeAt(0);
                        if (keyed === 1 && (// letters
                        peak > AT && peak < 90 || peak > 96 && peak < 123 || peak === UNDERSCORE || // dash but not in sequence i.e --
                        peak === DASH && value.charCodeAt(1) !== DASH)) // not a number/function
                        switch(isNaN(parseFloat(value)) + (value.indexOf("(") !== -1)){
                            case 1:
                                switch(value){
                                    // not a valid reserved keyword
                                    case "infinite":
                                    case "alternate":
                                    case "backwards":
                                    case "running":
                                    case "normal":
                                    case "forwards":
                                    case "both":
                                    case "none":
                                    case "linear":
                                    case "ease":
                                    case "ease-in":
                                    case "ease-out":
                                    case "ease-in-out":
                                    case "paused":
                                    case "reverse":
                                    case "alternate-reverse":
                                    case "inherit":
                                    case "initial":
                                    case "unset":
                                    case "step-start":
                                    case "step-end":
                                        break;
                                    default:
                                        value += key;
                                }
                        }
                        items[index++] = value;
                    }
                    out += (i === 0 ? "" : ",") + items.join(" ");
                }
        }
        out = declare + out + ";";
        if (prefix === 1 || prefix === 2 && vendor(out, 1)) return webkit + out + out;
        return out;
    }
    /**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */ function isolate(current) {
        for(var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i){
            // split individual elements in a selector i.e h1 h2 === [h1, h2]
            var elements = current[i].split(elementptn);
            var out = "";
            for(var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j){
                // empty element
                if ((size = (element = elements[j]).length) === 0 && l > 1) continue;
                tail = out.charCodeAt(out.length - 1);
                code = element.charCodeAt(0);
                padding = "";
                if (j !== 0) // determine if we need padding
                switch(tail){
                    case STAR:
                    case TILDE:
                    case GREATERTHAN:
                    case PLUS:
                    case SPACE:
                    case OPENPARENTHESES:
                        break;
                    default:
                        padding = " ";
                }
                switch(code){
                    case AND:
                        element = padding + nscopealt;
                    case TILDE:
                    case GREATERTHAN:
                    case PLUS:
                    case SPACE:
                    case CLOSEPARENTHESES:
                    case OPENPARENTHESES:
                        break;
                    case OPENBRACKET:
                        element = padding + element + nscopealt;
                        break;
                    case COLON:
                        switch(element.charCodeAt(1) * 2 + element.charCodeAt(2) * 3){
                            // :global
                            case 530:
                                if (escape > 0) {
                                    element = padding + element.substring(8, size - 1);
                                    break;
                                }
                            // :hover, :nth-child(), ...
                            default:
                                if (j < 1 || elements[j - 1].length < 1) element = padding + nscopealt + element;
                        }
                        break;
                    case COMMA:
                        padding = "";
                    default:
                        if (size > 1 && element.indexOf(":") > 0) element = padding + element.replace(pseudoptn, "$1" + nscopealt + "$2");
                        else element = padding + element + nscopealt;
                }
                out += element;
            }
            selector[i] = out.replace(formatptn, "").trim();
        }
        return selector;
    }
    /**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */ function proxy(context, content, selectors, parents, line, column, length, id, depth, at) {
        for(var i = 0, out = content, next; i < plugged; ++i)switch(next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)){
            case void 0:
            case false:
            case true:
            case null:
                break;
            default:
                out = next;
        }
        if (out !== content) return out;
    }
    /**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */ function delimited(code, index, length, body) {
        for(var i = index + 1; i < length; ++i)switch(body.charCodeAt(i)){
            // /*
            case FOWARDSLASH:
                if (code === STAR) {
                    if (body.charCodeAt(i - 1) === STAR && index + 2 !== i) return i + 1;
                }
                break;
            // //
            case NEWLINE:
                if (code === FOWARDSLASH) return i + 1;
        }
        return i;
    }
    /**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */ function match(type, index, length, body) {
        for(var i = index + 1; i < length; ++i)switch(body.charCodeAt(i)){
            case type:
                return i;
        }
        return i;
    }
    /**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */ function minify(output) {
        return output.replace(formatptn, "").replace(beforeptn, "").replace(afterptn, "$1").replace(tailptn, "$1").replace(whiteptn, " ");
    }
    /**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */ function use(plugin) {
        switch(plugin){
            case void 0:
            case null:
                plugged = plugins.length = 0;
                break;
            default:
                if (typeof plugin === "function") plugins[plugged++] = plugin;
                else if (typeof plugin === "object") for(var i = 0, length = plugin.length; i < length; ++i)use(plugin[i]);
                else unkwn = !!plugin | 0;
        }
        return use;
    }
    /**
	 * Set
	 *
	 * @param {*} options
	 */ function set(options) {
        for(var name in options){
            var value = options[name];
            switch(name){
                case "keyframe":
                    keyed = value | 0;
                    break;
                case "global":
                    escape = value | 0;
                    break;
                case "cascade":
                    cascade = value | 0;
                    break;
                case "compress":
                    compress = value | 0;
                    break;
                case "semicolon":
                    semicolon = value | 0;
                    break;
                case "preserve":
                    preserve = value | 0;
                    break;
                case "prefix":
                    should = null;
                    if (!value) prefix = 0;
                    else if (typeof value !== "function") prefix = 1;
                    else {
                        prefix = 2;
                        should = value;
                    }
            }
        }
        return set;
    }
    /**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */ function stylis(selector, input) {
        if (this !== void 0 && this.constructor === stylis) return factory(selector);
        // setup
        var ns = selector;
        var code = ns.charCodeAt(0);
        // trim leading whitespace
        if (code < 33) code = (ns = ns.trim()).charCodeAt(0);
        // keyframe/animation namespace
        if (keyed > 0) key = ns.replace(invalidptn, code === OPENBRACKET ? "" : "-");
        // reset, used to assert if a plugin is moneky-patching the return value
        code = 1;
        // cascade/isolate
        if (cascade === 1) nscope = ns;
        else nscopealt = ns;
        var selectors = [
            nscope
        ];
        var result;
        // execute plugins, pre-process context
        if (plugged > 0) {
            result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0);
            if (result !== void 0 && typeof result === "string") input = result;
        }
        // build
        var output = compile(array, selectors, input, 0, 0);
        // execute plugins, post-process context
        if (plugged > 0) {
            result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0);
            // bypass minification
            if (result !== void 0 && typeof (output = result) !== "string") code = 0;
        }
        // reset
        key = "";
        nscope = "";
        nscopealt = "";
        pattern = 0;
        line = 1;
        column = 1;
        return compress * code === 0 ? output : minify(output);
    }
    stylis["use"] = use;
    stylis["set"] = set;
    if (options !== void 0) set(options);
    return stylis;
});

});

parcelRegister("cdu9v", function(module, exports) {
(function(factory) {
    module.exports = factory();
})(function() {
    "use strict";
    return function(insertRule) {
        var delimiter = "/*|*/";
        var needle = delimiter + "}";
        function toSheet(block) {
            if (block) try {
                insertRule(block + "}");
            } catch (e) {}
        }
        return function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
            switch(context){
                // property
                case 1:
                    // @import
                    if (depth === 0 && content.charCodeAt(0) === 64) return insertRule(content + ";"), "";
                    break;
                // selector
                case 2:
                    if (ns === 0) return content + delimiter;
                    break;
                // at-rule
                case 3:
                    switch(ns){
                        // @font-face, @page
                        case 102:
                        case 112:
                            return insertRule(selectors[0] + content), "";
                        default:
                            return content + (at === 0 ? delimiter : "");
                    }
                case -2:
                    content.split(needle).forEach(toSheet);
            }
        };
    };
});

});

parcelRegister("k9ky0", function(module, exports) {
"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $eab49632d3eb40e8$var$REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $eab49632d3eb40e8$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $eab49632d3eb40e8$var$defineProperty = Object.defineProperty;
var $eab49632d3eb40e8$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $eab49632d3eb40e8$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $eab49632d3eb40e8$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $eab49632d3eb40e8$var$getPrototypeOf = Object.getPrototypeOf;
var $eab49632d3eb40e8$var$objectPrototype = $eab49632d3eb40e8$var$getPrototypeOf && $eab49632d3eb40e8$var$getPrototypeOf(Object);
function $eab49632d3eb40e8$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        if ($eab49632d3eb40e8$var$objectPrototype) {
            var inheritedComponent = $eab49632d3eb40e8$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $eab49632d3eb40e8$var$objectPrototype) $eab49632d3eb40e8$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $eab49632d3eb40e8$var$getOwnPropertyNames(sourceComponent);
        if ($eab49632d3eb40e8$var$getOwnPropertySymbols) keys = keys.concat($eab49632d3eb40e8$var$getOwnPropertySymbols(sourceComponent));
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$eab49632d3eb40e8$var$REACT_STATICS[key] && !$eab49632d3eb40e8$var$KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = $eab49632d3eb40e8$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $eab49632d3eb40e8$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
        return targetComponent;
    }
    return targetComponent;
}
module.exports = $eab49632d3eb40e8$var$hoistNonReactStatics;

});


parcelRegister("aDsOl", function(module, exports) {

$parcel$export(module.exports, "HORIZONTAL_GLOBAL_NAV_HEIGHT", function () { return $7be3e52456b9dfda$export$30fa7cc5f2690a43; });
$parcel$export(module.exports, "PRODUCT_HOME_BREAKPOINT", function () { return $7be3e52456b9dfda$export$4033a111ca79977d; });
$parcel$export(module.exports, "CREATE_BREAKPOINT", function () { return $7be3e52456b9dfda$export$24ec62cee78b7042; });
$parcel$export(module.exports, "varSearchFocusBorderColor", function () { return $7be3e52456b9dfda$export$d8bde68ac946124f; });
$parcel$export(module.exports, "varSearchHoverBackgroundColor", function () { return $7be3e52456b9dfda$export$73e44f54603a0964; });
$parcel$export(module.exports, "varSearchBackgroundColor", function () { return $7be3e52456b9dfda$export$13f8aa8f663f4c99; });
$parcel$export(module.exports, "varSearchColor", function () { return $7be3e52456b9dfda$export$d81606c1fc5119bc; });
$parcel$export(module.exports, "varSearchBorderColor", function () { return $7be3e52456b9dfda$export$65f656ad520ea71; });
var $7be3e52456b9dfda$export$30fa7cc5f2690a43 = 56;
var $7be3e52456b9dfda$export$4033a111ca79977d = 1280;
var $7be3e52456b9dfda$export$24ec62cee78b7042 = 1130;
var $7be3e52456b9dfda$export$d8bde68ac946124f = "--ds--ans--fbc";
var $7be3e52456b9dfda$export$73e44f54603a0964 = "--ds--ans--hbgc";
var $7be3e52456b9dfda$export$13f8aa8f663f4c99 = "--ds--ans--bgc";
var $7be3e52456b9dfda$export$d81606c1fc5119bc = "--ds--ans--c";
var $7be3e52456b9dfda$export$65f656ad520ea71 = "--ds--ans--bc";

});

parcelRegister("giIwV", function(module, exports) {

$parcel$export(module.exports, "BANNER_HEIGHT", function () { return $c48f0234a24cf93d$export$ed7cc0d417ee89e; });
const $c48f0234a24cf93d$export$ed7cc0d417ee89e = 48;

});


parcelRegister("eD9vM", function(module, exports) {

$parcel$export(module.exports, "Loading", function () { return $c2a65e24af39ffdf$export$669f6ea7d267feaf; });

var $2xJU3 = parcelRequire("2xJU3");
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */ function $c2a65e24af39ffdf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c2a65e24af39ffdf$export$669f6ea7d267feaf = (0, $2xJU3.default)("div", {
    target: "eyk79z30"
})({
    name: "wgyj6o",
    styles: "align-items:center;display:flex;height:60vh;justify-content:center;"
});

});



parcelRegister("eWrF8", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("e0Fn7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fDD7i")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7xLkx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3op3S"))
]).then(()=>parcelRequire("2QZwm"));

});

parcelRegister("aXXtM", function(module, exports) {

$parcel$export(module.exports, "createSelector", function () { return $7fbd8d6a62e9ec76$export$595d22ed68ca2841; }, function (v) { return $7fbd8d6a62e9ec76$export$595d22ed68ca2841 = v; });
var $7fbd8d6a62e9ec76$export$1e511d4a378977f5;
var $7fbd8d6a62e9ec76$export$281bff7f05488aa2;
var $7fbd8d6a62e9ec76$export$5943f4447f6ef248;
var $7fbd8d6a62e9ec76$export$75979cfcd91bf38f;
var $7fbd8d6a62e9ec76$export$595d22ed68ca2841;
"use strict";
$7fbd8d6a62e9ec76$export$1e511d4a378977f5 = true;
$7fbd8d6a62e9ec76$export$281bff7f05488aa2 = $7fbd8d6a62e9ec76$var$defaultMemoize;
$7fbd8d6a62e9ec76$export$5943f4447f6ef248 = $7fbd8d6a62e9ec76$var$createSelectorCreator;
$7fbd8d6a62e9ec76$export$75979cfcd91bf38f = $7fbd8d6a62e9ec76$var$createStructuredSelector;
function $7fbd8d6a62e9ec76$var$defaultEqualityCheck(a, b) {
    return a === b;
}
function $7fbd8d6a62e9ec76$var$areArgumentsShallowlyEqual(equalityCheck, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false;
    // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
    var length = prev.length;
    for(var i = 0; i < length; i++){
        if (!equalityCheck(prev[i], next[i])) return false;
    }
    return true;
}
function $7fbd8d6a62e9ec76$var$defaultMemoize(func) {
    var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $7fbd8d6a62e9ec76$var$defaultEqualityCheck;
    var lastArgs = null;
    var lastResult = null;
    // we reference arguments instead of spreading them for performance reasons
    return function() {
        if (!$7fbd8d6a62e9ec76$var$areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) // apply arguments instead of spreading for performance.
        lastResult = func.apply(null, arguments);
        lastArgs = arguments;
        return lastResult;
    };
}
function $7fbd8d6a62e9ec76$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep;
        }).join(", ");
        throw new Error("Selector creators expect all input-selectors to be functions, " + ("instead received the following types: [" + dependencyTypes + "]"));
    }
    return dependencies;
}
function $7fbd8d6a62e9ec76$var$createSelectorCreator(memoize) {
    for(var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptions[_key - 1] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var recomputations = 0;
        var resultFunc = funcs.pop();
        var dependencies = $7fbd8d6a62e9ec76$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(undefined, [
            function() {
                recomputations++;
                // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(memoizeOptions));
        // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = $7fbd8d6a62e9ec76$var$defaultMemoize(function() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            params.push(dependencies[i].apply(null, arguments));
            // apply arguments instead of spreading for performance.
            return memoizedResultFunc.apply(null, params);
        });
        selector.resultFunc = resultFunc;
        selector.recomputations = function() {
            return recomputations;
        };
        selector.resetRecomputations = function() {
            return recomputations = 0;
        };
        return selector;
    };
}
var $7fbd8d6a62e9ec76$var$createSelector = $7fbd8d6a62e9ec76$export$595d22ed68ca2841 = $7fbd8d6a62e9ec76$var$createSelectorCreator($7fbd8d6a62e9ec76$var$defaultMemoize);
function $7fbd8d6a62e9ec76$var$createStructuredSelector(selectors) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $7fbd8d6a62e9ec76$var$createSelector;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    return selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
}

});

parcelRegister("g2R3c", function(module, exports) {

$parcel$export(module.exports, "getCurrentUserKey", function () { return $b9d7b1c2fa559157$export$164b55ab56d379a1; });
$parcel$export(module.exports, "getTargetUserKey", function () { return $b9d7b1c2fa559157$export$5788723c230cbf7; });
$parcel$export(module.exports, "getCurrentUser", function () { return $b9d7b1c2fa559157$export$e5432d4c8eb97ea7; });
$parcel$export(module.exports, "getTargetUser", function () { return $b9d7b1c2fa559157$export$e0108fae0a246890; });
$parcel$export(module.exports, "getCurrentUserDefaultCloneProtocol", function () { return $b9d7b1c2fa559157$export$f01bb494a04ac70c; });
$parcel$export(module.exports, "getCurrentUserIsAnonymous", function () { return $b9d7b1c2fa559157$export$4bca8aa9e161b17c; });
$parcel$export(module.exports, "getCurrentUserAccountId", function () { return $b9d7b1c2fa559157$export$4635f55bc9feebdb; });
$parcel$export(module.exports, "getCurrentUserUuid", function () { return $b9d7b1c2fa559157$export$e29e27895f701b9c; });
$parcel$export(module.exports, "getAccountIdFromUuid", function () { return $b9d7b1c2fa559157$export$c97dcae906cf96af; });

var $ga67g = parcelRequire("ga67g");

var $cQrjH = parcelRequire("cQrjH");

var $aXXtM = parcelRequire("aXXtM");

var $8saZD = parcelRequire("8saZD");

var $7qdXF = parcelRequire("7qdXF");
const $b9d7b1c2fa559157$export$164b55ab56d379a1 = (0, $aXXtM.createSelector)((0, $7qdXF.getGlobal), (state)=>state.currentUser);
const $b9d7b1c2fa559157$export$5788723c230cbf7 = (0, $aXXtM.createSelector)((0, $7qdXF.getGlobal), (state)=>state.targetUser);
const $b9d7b1c2fa559157$export$e5432d4c8eb97ea7 = (0, $aXXtM.createSelector)($b9d7b1c2fa559157$export$164b55ab56d379a1, (0, $7qdXF.getEntities), (key, entities)=>(0, $ga67g.denormalize)(key, (0, $8saZD.user), entities));
const $b9d7b1c2fa559157$export$e0108fae0a246890 = (0, $aXXtM.createSelector)($b9d7b1c2fa559157$export$5788723c230cbf7, (0, $7qdXF.getEntities), (key, entities)=>(0, $ga67g.denormalize)(key, (0, $8saZD.user), entities));
const $b9d7b1c2fa559157$export$f01bb494a04ac70c = (0, $aXXtM.createSelector)($b9d7b1c2fa559157$export$e5432d4c8eb97ea7, (user)=>user && user.extra && user.extra.has_ssh_key ? "ssh" : "https");
const $b9d7b1c2fa559157$export$4bca8aa9e161b17c = (0, $aXXtM.createSelector)((0, $7qdXF.getGlobal), (state)=>!state.currentUser);
const $b9d7b1c2fa559157$export$4635f55bc9feebdb = (0, $aXXtM.createSelector)($b9d7b1c2fa559157$export$e5432d4c8eb97ea7, (user)=>user === null || user === void 0 ? void 0 : user.account_id);
const $b9d7b1c2fa559157$export$e29e27895f701b9c = (0, $aXXtM.createSelector)($b9d7b1c2fa559157$export$e5432d4c8eb97ea7, (user)=>user === null || user === void 0 ? void 0 : user.uuid);
const $b9d7b1c2fa559157$export$1a94f2baee67b735 = (0, $cQrjH.default)((state)=>(0, $7qdXF.getEntities)(state), (_state, uuids)=>uuids, (entities, uuids)=>{
    const idMap = new Map();
    uuids.forEach((uuid)=>{
        if (uuid) {
            const denormalizedUser = (0, $ga67g.denormalize)(uuid, (0, $8saZD.user), entities);
            if (denormalizedUser) idMap.set(uuid, denormalizedUser.account_id);
        }
    });
    return idMap;
})((_state, uuids)=>uuids.join("-"));
const $b9d7b1c2fa559157$export$c97dcae906cf96af = (0, $cQrjH.default)((state)=>(0, $7qdXF.getEntities)(state), (_state, uuid)=>uuid, (entities, uuid)=>{
    let userAaid = null;
    if (uuid) {
        const denormalizedUser = (0, $ga67g.denormalize)(uuid, (0, $8saZD.user), entities);
        if (denormalizedUser) userAaid = denormalizedUser.account_id;
    }
    return userAaid;
})((_state, userAaid)=>userAaid);

});
parcelRegister("ga67g", function(module, exports) {

$parcel$export(module.exports, "schema", function () { return schema; });
$parcel$export(module.exports, "normalize", function () { return normalize$1; });
$parcel$export(module.exports, "denormalize", function () { return denormalize$1; });
/**
 * Helpers to enable Immutable compatibility *without* bringing in
 * the 'immutable' package as a dependency.
 */ /**
 * Check if an object is immutable by checking if it has a key specific
 * to the immutable library.
 *
 * @param  {any} object
 * @return {bool}
 */ function isImmutable(object) {
    return !!(object && typeof object.hasOwnProperty === "function" && (object.hasOwnProperty("__ownerID") || // Immutable.Map
    object._map && object._map.hasOwnProperty("__ownerID"))); // Immutable.Record
}
/**
 * Denormalize an immutable entity.
 *
 * @param  {Schema} schema
 * @param  {Immutable.Map|Immutable.Record} input
 * @param  {function} unvisit
 * @param  {function} getDenormalizedEntity
 * @return {Immutable.Map|Immutable.Record}
 */ function denormalizeImmutable(schema, input, unvisit) {
    return Object.keys(schema).reduce(function(object, key) {
        // Immutable maps cast keys to strings on write so we need to ensure
        // we're accessing them using string keys.
        var stringKey = "" + key;
        if (object.has(stringKey)) return object.set(stringKey, unvisit(object.get(stringKey), schema[stringKey]));
        else return object;
    }, input);
}
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var getDefaultGetId = function getDefaultGetId(idAttribute) {
    return function(input) {
        return isImmutable(input) ? input.get(idAttribute) : input[idAttribute];
    };
};
var EntitySchema = function() {
    function EntitySchema(key) {
        var definition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        classCallCheck(this, EntitySchema);
        if (!key || typeof key !== "string") throw new Error("Expected a string key for Entity, but found " + key + ".");
        var _options$idAttribute = options.idAttribute, idAttribute = _options$idAttribute === undefined ? "id" : _options$idAttribute, _options$mergeStrateg = options.mergeStrategy, mergeStrategy = _options$mergeStrateg === undefined ? function(entityA, entityB) {
            return _extends({}, entityA, entityB);
        } : _options$mergeStrateg, _options$processStrat = options.processStrategy, processStrategy = _options$processStrat === undefined ? function(input) {
            return _extends({}, input);
        } : _options$processStrat;
        this._key = key;
        this._getId = typeof idAttribute === "function" ? idAttribute : getDefaultGetId(idAttribute);
        this._idAttribute = idAttribute;
        this._mergeStrategy = mergeStrategy;
        this._processStrategy = processStrategy;
        this.define(definition);
    }
    EntitySchema.prototype.define = function define(definition) {
        this.schema = Object.keys(definition).reduce(function(entitySchema, key) {
            var _babelHelpers$extends;
            var schema = definition[key];
            return _extends({}, entitySchema, (_babelHelpers$extends = {}, _babelHelpers$extends[key] = schema, _babelHelpers$extends));
        }, this.schema || {});
    };
    EntitySchema.prototype.getId = function getId(input, parent, key) {
        return this._getId(input, parent, key);
    };
    EntitySchema.prototype.merge = function merge(entityA, entityB) {
        return this._mergeStrategy(entityA, entityB);
    };
    EntitySchema.prototype.normalize = function normalize(input, parent, key, visit, addEntity) {
        var _this = this;
        var processedEntity = this._processStrategy(input, parent, key);
        Object.keys(this.schema).forEach(function(key) {
            if (processedEntity.hasOwnProperty(key) && _typeof(processedEntity[key]) === "object") {
                var schema = _this.schema[key];
                processedEntity[key] = visit(processedEntity[key], processedEntity, key, schema, addEntity);
            }
        });
        addEntity(this, processedEntity, input, parent, key);
        return this.getId(input, parent, key);
    };
    EntitySchema.prototype.denormalize = function denormalize(entity, unvisit) {
        var _this2 = this;
        if (isImmutable(entity)) return denormalizeImmutable(this.schema, entity, unvisit);
        Object.keys(this.schema).forEach(function(key) {
            if (entity.hasOwnProperty(key)) {
                var schema = _this2.schema[key];
                entity[key] = unvisit(entity[key], schema);
            }
        });
        return entity;
    };
    createClass(EntitySchema, [
        {
            key: "key",
            get: function get$$1() {
                return this._key;
            }
        },
        {
            key: "idAttribute",
            get: function get$$1() {
                return this._idAttribute;
            }
        }
    ]);
    return EntitySchema;
}();
var PolymorphicSchema = function() {
    function PolymorphicSchema(definition, schemaAttribute) {
        classCallCheck(this, PolymorphicSchema);
        if (schemaAttribute) this._schemaAttribute = typeof schemaAttribute === "string" ? function(input) {
            return input[schemaAttribute];
        } : schemaAttribute;
        this.define(definition);
    }
    PolymorphicSchema.prototype.define = function define(definition) {
        this.schema = definition;
    };
    PolymorphicSchema.prototype.getSchemaAttribute = function getSchemaAttribute(input, parent, key) {
        return !this.isSingleSchema && this._schemaAttribute(input, parent, key);
    };
    PolymorphicSchema.prototype.inferSchema = function inferSchema(input, parent, key) {
        if (this.isSingleSchema) return this.schema;
        var attr = this.getSchemaAttribute(input, parent, key);
        return this.schema[attr];
    };
    PolymorphicSchema.prototype.normalizeValue = function normalizeValue(value, parent, key, visit, addEntity) {
        var schema = this.inferSchema(value, parent, key);
        if (!schema) return value;
        var normalizedValue = visit(value, parent, key, schema, addEntity);
        return this.isSingleSchema || normalizedValue === undefined || normalizedValue === null ? normalizedValue : {
            id: normalizedValue,
            schema: this.getSchemaAttribute(value, parent, key)
        };
    };
    PolymorphicSchema.prototype.denormalizeValue = function denormalizeValue(value, unvisit) {
        var schemaKey = isImmutable(value) ? value.get("schema") : value.schema;
        if (!this.isSingleSchema && !schemaKey) return value;
        var id = isImmutable(value) ? value.get("id") : value.id;
        var schema = this.isSingleSchema ? this.schema : this.schema[schemaKey];
        return unvisit(id || value, schema);
    };
    createClass(PolymorphicSchema, [
        {
            key: "isSingleSchema",
            get: function get$$1() {
                return !this._schemaAttribute;
            }
        }
    ]);
    return PolymorphicSchema;
}();
var UnionSchema = function(_PolymorphicSchema) {
    inherits(UnionSchema, _PolymorphicSchema);
    function UnionSchema(definition, schemaAttribute) {
        classCallCheck(this, UnionSchema);
        if (!schemaAttribute) throw new Error('Expected option "schemaAttribute" not found on UnionSchema.');
        return possibleConstructorReturn(this, _PolymorphicSchema.call(this, definition, schemaAttribute));
    }
    UnionSchema.prototype.normalize = function normalize(input, parent, key, visit, addEntity) {
        return this.normalizeValue(input, parent, key, visit, addEntity);
    };
    UnionSchema.prototype.denormalize = function denormalize(input, unvisit) {
        return this.denormalizeValue(input, unvisit);
    };
    return UnionSchema;
}(PolymorphicSchema);
var ValuesSchema = function(_PolymorphicSchema) {
    inherits(ValuesSchema, _PolymorphicSchema);
    function ValuesSchema() {
        classCallCheck(this, ValuesSchema);
        return possibleConstructorReturn(this, _PolymorphicSchema.apply(this, arguments));
    }
    ValuesSchema.prototype.normalize = function normalize(input, parent, key, visit, addEntity) {
        var _this2 = this;
        return Object.keys(input).reduce(function(output, key, index) {
            var _babelHelpers$extends;
            var value = input[key];
            return value !== undefined && value !== null ? _extends({}, output, (_babelHelpers$extends = {}, _babelHelpers$extends[key] = _this2.normalizeValue(value, input, key, visit, addEntity), _babelHelpers$extends)) : output;
        }, {});
    };
    ValuesSchema.prototype.denormalize = function denormalize(input, unvisit) {
        var _this3 = this;
        return Object.keys(input).reduce(function(output, key) {
            var _babelHelpers$extends2;
            var entityOrId = input[key];
            return _extends({}, output, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[key] = _this3.denormalizeValue(entityOrId, unvisit), _babelHelpers$extends2));
        }, {});
    };
    return ValuesSchema;
}(PolymorphicSchema);
var validateSchema = function validateSchema(definition) {
    var isArray = Array.isArray(definition);
    if (isArray && definition.length > 1) throw new Error("Expected schema definition to be a single schema, but found " + definition.length + ".");
    return definition[0];
};
var getValues = function getValues(input) {
    return Array.isArray(input) ? input : Object.keys(input).map(function(key) {
        return input[key];
    });
};
var normalize = function normalize(schema, input, parent, key, visit, addEntity) {
    schema = validateSchema(schema);
    var values = getValues(input);
    // Special case: Arrays pass *their* parent on to their children, since there
    // is not any special information that can be gathered from themselves directly
    return values.map(function(value, index) {
        return visit(value, parent, key, schema, addEntity);
    });
};
var denormalize = function denormalize(schema, input, unvisit) {
    schema = validateSchema(schema);
    return input && input.map ? input.map(function(entityOrId) {
        return unvisit(entityOrId, schema);
    }) : input;
};
var ArraySchema = function(_PolymorphicSchema) {
    inherits(ArraySchema, _PolymorphicSchema);
    function ArraySchema() {
        classCallCheck(this, ArraySchema);
        return possibleConstructorReturn(this, _PolymorphicSchema.apply(this, arguments));
    }
    ArraySchema.prototype.normalize = function normalize(input, parent, key, visit, addEntity) {
        var _this2 = this;
        var values = getValues(input);
        return values.map(function(value, index) {
            return _this2.normalizeValue(value, parent, key, visit, addEntity);
        }).filter(function(value) {
            return value !== undefined && value !== null;
        });
    };
    ArraySchema.prototype.denormalize = function denormalize(input, unvisit) {
        var _this3 = this;
        return input && input.map ? input.map(function(value) {
            return _this3.denormalizeValue(value, unvisit);
        }) : input;
    };
    return ArraySchema;
}(PolymorphicSchema);
var _normalize = function _normalize(schema, input, parent, key, visit, addEntity) {
    var object = _extends({}, input);
    Object.keys(schema).forEach(function(key) {
        var localSchema = schema[key];
        var value = visit(input[key], input, key, localSchema, addEntity);
        if (value === undefined || value === null) delete object[key];
        else object[key] = value;
    });
    return object;
};
var _denormalize = function _denormalize(schema, input, unvisit) {
    if (isImmutable(input)) return denormalizeImmutable(schema, input, unvisit);
    var object = _extends({}, input);
    Object.keys(schema).forEach(function(key) {
        if (object[key]) object[key] = unvisit(object[key], schema[key]);
    });
    return object;
};
var ObjectSchema = function() {
    function ObjectSchema(definition) {
        classCallCheck(this, ObjectSchema);
        this.define(definition);
    }
    ObjectSchema.prototype.define = function define(definition) {
        this.schema = Object.keys(definition).reduce(function(entitySchema, key) {
            var _babelHelpers$extends;
            var schema = definition[key];
            return _extends({}, entitySchema, (_babelHelpers$extends = {}, _babelHelpers$extends[key] = schema, _babelHelpers$extends));
        }, this.schema || {});
    };
    ObjectSchema.prototype.normalize = function normalize() {
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _normalize.apply(undefined, [
            this.schema
        ].concat(args));
    };
    ObjectSchema.prototype.denormalize = function denormalize() {
        for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return _denormalize.apply(undefined, [
            this.schema
        ].concat(args));
    };
    return ObjectSchema;
}();
var visit = function visit(value, parent, key, schema, addEntity) {
    if ((typeof value === "undefined" ? "undefined" : _typeof(value)) !== "object" || !value) return value;
    if ((typeof schema === "undefined" ? "undefined" : _typeof(schema)) === "object" && (!schema.normalize || typeof schema.normalize !== "function")) {
        var method = Array.isArray(schema) ? normalize : _normalize;
        return method(schema, value, parent, key, visit, addEntity);
    }
    return schema.normalize(value, parent, key, visit, addEntity);
};
var addEntities = function addEntities(entities) {
    return function(schema, processedEntity, value, parent, key) {
        var schemaKey = schema.key;
        var id = schema.getId(value, parent, key);
        if (!(schemaKey in entities)) entities[schemaKey] = {};
        var existingEntity = entities[schemaKey][id];
        if (existingEntity) entities[schemaKey][id] = schema.merge(existingEntity, processedEntity);
        else entities[schemaKey][id] = processedEntity;
    };
};
var schema = {
    Array: ArraySchema,
    Entity: EntitySchema,
    Object: ObjectSchema,
    Union: UnionSchema,
    Values: ValuesSchema
};
var normalize$1 = function normalize$$1(input, schema) {
    if (!input || (typeof input === "undefined" ? "undefined" : _typeof(input)) !== "object") throw new Error('Unexpected input given to normalize. Expected type to be "object", found "' + (typeof input === "undefined" ? "undefined" : _typeof(input)) + '".');
    var entities = {};
    var addEntity = addEntities(entities);
    var result = visit(input, input, null, schema, addEntity);
    return {
        entities: entities,
        result: result
    };
};
var unvisitEntity = function unvisitEntity(id, schema, unvisit, getEntity, cache) {
    var entity = getEntity(id, schema);
    if ((typeof entity === "undefined" ? "undefined" : _typeof(entity)) !== "object" || entity === null) return entity;
    if (!cache[schema.key]) cache[schema.key] = {};
    if (!cache[schema.key][id]) {
        // Ensure we don't mutate it non-immutable objects
        var entityCopy = isImmutable(entity) ? entity : _extends({}, entity);
        // Need to set this first so that if it is referenced further within the
        // denormalization the reference will already exist.
        cache[schema.key][id] = entityCopy;
        cache[schema.key][id] = schema.denormalize(entityCopy, unvisit);
    }
    return cache[schema.key][id];
};
var getUnvisit = function getUnvisit(entities) {
    var cache = {};
    var getEntity = getEntities(entities);
    return function unvisit(input, schema) {
        if ((typeof schema === "undefined" ? "undefined" : _typeof(schema)) === "object" && (!schema.denormalize || typeof schema.denormalize !== "function")) {
            var method = Array.isArray(schema) ? denormalize : _denormalize;
            return method(schema, input, unvisit);
        }
        if (input === undefined || input === null) return input;
        if (schema instanceof EntitySchema) return unvisitEntity(input, schema, unvisit, getEntity, cache);
        return schema.denormalize(input, unvisit);
    };
};
var getEntities = function getEntities(entities) {
    var isImmutable$$1 = isImmutable(entities);
    return function(entityOrId, schema) {
        var schemaKey = schema.key;
        if ((typeof entityOrId === "undefined" ? "undefined" : _typeof(entityOrId)) === "object") return entityOrId;
        return isImmutable$$1 ? entities.getIn([
            schemaKey,
            entityOrId.toString()
        ]) : entities[schemaKey][entityOrId];
    };
};
var denormalize$1 = function denormalize$$1(input, schema, entities) {
    if (typeof input !== "undefined") return getUnvisit(entities)(input, schema);
};

});

parcelRegister("cQrjH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $959f87e4cc0e4456$export$2e2bcd8739ae039; });

var $aXXtM = parcelRequire("aXXtM");
var $959f87e4cc0e4456$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $959f87e4cc0e4456$export$e3c847ff6ed51142 = function() {
    function FlatCacheObject() {
        $959f87e4cc0e4456$var$classCallCheck(this, FlatCacheObject);
        this._cache = {};
    }
    FlatCacheObject.prototype.set = function set$$1(key, selectorFn) {
        this._cache[key] = selectorFn;
    };
    FlatCacheObject.prototype.get = function get$$1(key) {
        return this._cache[key];
    };
    FlatCacheObject.prototype.remove = function remove(key) {
        delete this._cache[key];
    };
    FlatCacheObject.prototype.clear = function clear() {
        this._cache = {};
    };
    return FlatCacheObject;
}();
var $959f87e4cc0e4456$export$dce2b352e6efea38 = function() {
    function FifoCacheObject() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, cacheSize = _ref.cacheSize;
        $959f87e4cc0e4456$var$classCallCheck(this, FifoCacheObject);
        if (cacheSize === undefined) throw new Error("Missing the required property `cacheSize`.");
        if (!Number.isInteger(cacheSize) || cacheSize <= 0) throw new Error("The `cacheSize` property must be a positive integer value.");
        this._cache = {};
        this._cacheOrdering = [];
        this._cacheSize = cacheSize;
    }
    FifoCacheObject.prototype.set = function set$$1(key, selectorFn) {
        this._cache[key] = selectorFn;
        this._cacheOrdering.push(key);
        if (this._cacheOrdering.length > this._cacheSize) {
            var earliest = this._cacheOrdering[0];
            this.remove(earliest);
        }
    };
    FifoCacheObject.prototype.get = function get$$1(key) {
        return this._cache[key];
    };
    FifoCacheObject.prototype.remove = function remove(key) {
        var index = this._cacheOrdering.indexOf(key);
        if (index > -1) this._cacheOrdering.splice(index, 1);
        delete this._cache[key];
    };
    FifoCacheObject.prototype.clear = function clear() {
        this._cache = {};
        this._cacheOrdering = [];
    };
    return FifoCacheObject;
}();
var $959f87e4cc0e4456$export$5b4aa23d53de630d = function() {
    function LruCacheObject() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, cacheSize = _ref.cacheSize;
        $959f87e4cc0e4456$var$classCallCheck(this, LruCacheObject);
        if (cacheSize === undefined) throw new Error("Missing the required property `cacheSize`.");
        if (!Number.isInteger(cacheSize) || cacheSize <= 0) throw new Error("The `cacheSize` property must be a positive integer value.");
        this._cache = {};
        this._cacheOrdering = [];
        this._cacheSize = cacheSize;
    }
    LruCacheObject.prototype.set = function set$$1(key, selectorFn) {
        this._cache[key] = selectorFn;
        this._registerCacheHit(key);
        if (this._cacheOrdering.length > this._cacheSize) {
            var earliest = this._cacheOrdering[0];
            this.remove(earliest);
        }
    };
    LruCacheObject.prototype.get = function get$$1(key) {
        this._registerCacheHit(key);
        return this._cache[key];
    };
    LruCacheObject.prototype.remove = function remove(key) {
        this._deleteCacheHit(key);
        delete this._cache[key];
    };
    LruCacheObject.prototype.clear = function clear() {
        this._cache = {};
        this._cacheOrdering = [];
    };
    LruCacheObject.prototype._registerCacheHit = function _registerCacheHit(key) {
        this._deleteCacheHit(key);
        this._cacheOrdering.push(key);
    };
    LruCacheObject.prototype._deleteCacheHit = function _deleteCacheHit(key) {
        var index = this._cacheOrdering.indexOf(key);
        if (index > -1) this._cacheOrdering.splice(index, 1);
    };
    return LruCacheObject;
}();
function $959f87e4cc0e4456$var$createCachedSelector() {
    for(var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    var defaultCacheCreator = $959f87e4cc0e4456$export$e3c847ff6ed51142;
    return function(resolver) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var cache = void 0;
        var selectorCreator = void 0;
        // Allow "options" to be provided as a "selectorCreator" for backward compatibility
        // @TODO Remove "options" as a function in next breaking release
        if (typeof options === "function") {
            console.warn('[re-reselect] Deprecation warning: "selectorCreator" argument is discouraged and will be removed in the upcoming major release. Please use "options.selectorCreator" instead.');
            cache = new defaultCacheCreator();
            selectorCreator = options;
        } else {
            cache = options.cacheObject || new defaultCacheCreator();
            selectorCreator = options.selectorCreator || (0, $aXXtM.createSelector);
        }
        var selector = function selector() {
            // Application receives this function
            var cacheKey = resolver.apply(undefined, arguments);
            if (typeof cacheKey === "string" || typeof cacheKey === "number") {
                var cacheResponse = cache.get(cacheKey);
                if (cacheResponse === undefined) {
                    cacheResponse = selectorCreator.apply(undefined, funcs);
                    cache.set(cacheKey, cacheResponse);
                }
                return cacheResponse.apply(undefined, arguments);
            }
            return undefined;
        };
        // Further selector methods
        selector.getMatchingSelector = function() {
            var cacheKey = resolver.apply(undefined, arguments);
            // @NOTE It might update cache hit count in LRU-like caches
            return cache.get(cacheKey);
        };
        selector.removeMatchingSelector = function() {
            var cacheKey = resolver.apply(undefined, arguments);
            cache.remove(cacheKey);
        };
        selector.clearCache = function() {
            cache.clear();
        };
        selector.resultFunc = funcs[funcs.length - 1];
        return selector;
    };
}
var $959f87e4cc0e4456$export$2e2bcd8739ae039 = $959f87e4cc0e4456$var$createCachedSelector;

});

parcelRegister("8saZD", function(module, exports) {

$parcel$export(module.exports, "user", function () { return $9c9a6a2e6ae9acdf$export$ddb906a32562356c; });

var $ga67g = parcelRequire("ga67g");
const $9c9a6a2e6ae9acdf$export$ddb906a32562356c = new (0, $ga67g.schema).Entity("users", {}, {
    idAttribute: "uuid"
});

});

parcelRegister("7qdXF", function(module, exports) {

$parcel$export(module.exports, "getDashboard", function () { return $42e088f88da9eec9$export$f3fe8eb89c757086; });
$parcel$export(module.exports, "getEntities", function () { return $42e088f88da9eec9$export$e2e3f9f64b249105; });
$parcel$export(module.exports, "getGlobal", function () { return $42e088f88da9eec9$export$a4e55266d2135a7f; });
$parcel$export(module.exports, "getRecentlyViewedRepositoriesKeys", function () { return $42e088f88da9eec9$export$99484a1affa93746; });
$parcel$export(module.exports, "getRepository", function () { return $42e088f88da9eec9$export$feac2a21aec844b7; });
$parcel$export(module.exports, "getPipelines", function () { return $42e088f88da9eec9$export$1bd86c056cec054; });
$parcel$export(module.exports, "getProject", function () { return $42e088f88da9eec9$export$637b60a42bb03f06; });
$parcel$export(module.exports, "getRecentlyViewedWorkspacesKeys", function () { return $42e088f88da9eec9$export$27428a7a1827c25d; });
$parcel$export(module.exports, "getProfile", function () { return $42e088f88da9eec9$export$85d699ca8330b9a9; });
$parcel$export(module.exports, "getSearch", function () { return $42e088f88da9eec9$export$786f9a4bc80cc6b0; });
$parcel$export(module.exports, "getJiraSlice", function () { return $42e088f88da9eec9$export$6c398af8d48a8742; });
$parcel$export(module.exports, "getWorkspacePlanSlice", function () { return $42e088f88da9eec9$export$81f4de84614bef8b; });
const $42e088f88da9eec9$export$f3fe8eb89c757086 = (state)=>state.dashboard;
const $42e088f88da9eec9$export$e2e3f9f64b249105 = (state)=>state.entities;
const $42e088f88da9eec9$export$a4e55266d2135a7f = (state)=>{
    var _state$global;
    return (_state$global = state.global) !== null && _state$global !== void 0 ? _state$global : {};
};
const $42e088f88da9eec9$export$b5f81ebf3f545f7c = (state)=>state.keyboardShortcuts;
const $42e088f88da9eec9$export$99484a1affa93746 = (state)=>state.recentlyViewedRepositories;
const $42e088f88da9eec9$export$feac2a21aec844b7 = (state)=>state.repository;
const $42e088f88da9eec9$export$1bd86c056cec054 = (state)=>state.pipelines;
const $42e088f88da9eec9$export$637b60a42bb03f06 = (state)=>state.project;
const $42e088f88da9eec9$export$27428a7a1827c25d = (state)=>state.recentlyViewedWorkspaces;
const $42e088f88da9eec9$export$85d699ca8330b9a9 = (state)=>state.profile;
const $42e088f88da9eec9$export$786f9a4bc80cc6b0 = (state)=>state.search;
const $42e088f88da9eec9$export$6c398af8d48a8742 = (state)=>state.jira;
const $42e088f88da9eec9$export$81f4de84614bef8b = (state)=>state.workspacePlan;

});


parcelRegister("1gtcM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a526116467a80fda$export$2e2bcd8739ae039; });

var $cJH1T = parcelRequire("cJH1T");
parcelRequire("3hzea");
var $a5HLv = parcelRequire("a5HLv");
const $a526116467a80fda$var$urls = {
    api: {
        v10: {},
        v20: {},
        gateway: {
            repoSearch: ()=>"/gateway/api/xpsearch-aggregator",
            aisAvailableProducts: ()=>"/gateway/api/ais/available-products"
        },
        internal: {
            compassBannerEmailNotification: (workspaceSlug)=>`/!api/internal/workspaces/${workspaceSlug}/compass-banner-email-notification`,
            getCompassCloudIdForWorkspace: (workspaceSlug)=>`/!api/internal/workspaces/${workspaceSlug}/compass/workspace-connection`
        }
    },
    external: {
        apiDocumentation: ()=>"https://confluence.atlassian.com/x/IYBGDQ",
        blog: ()=>"https://blog.bitbucket.org",
        documentation: ()=>"https://confluence.atlassian.com/display/BITBUCKET",
        gettingGitRight: ()=>"https://www.atlassian.com/git",
        privacyPolicy: ()=>"https://www.atlassian.com/legal/privacy-policy",
        atlassianResearchGroup: ()=>"https://www.atlassian.com/research-group",
        status: ()=>"https://status.bitbucket.org",
        termsOfService: ()=>"https://www.atlassian.com/legal/customer-agreement",
        noticeOfCollectionInternal: ()=>"https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942",
        noticeOfCollectionExternal: ()=>"https://www.atlassian.com/legal/privacy-policy#additional-disclosures-for-ca-residents",
        tutorials: ()=>"https://confluence.atlassian.com/x/Q4sFLQ",
        atlassianAccountSync: (aaLoginUrl, destinationUrl, destinationAccountEmail, confirmationRequired = false)=>`${aaLoginUrl}?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
                application: "bitbucket",
                continue: destinationUrl,
                login_hint: destinationAccountEmail,
                ...!confirmationRequired && {
                    prompt: "none"
                }
            })}`
    },
    ui: {
        integrations: (workspaceSlug)=>workspaceSlug ? `/${workspaceSlug}/workspace/settings/addon-directory/` : `/account/admin/addon-directory/`,
        labs: ()=>`/account/settings/features/`,
        login: ()=>"/account/signin/",
        plans: ()=>"/plans",
        root: ()=>"/",
        settings: ()=>`/account/settings/`,
        signup: ()=>"/account/signup/",
        support: ()=>"/support",
        allWorkspaces: ()=>"/account/workspaces/",
        search: (query)=>query ? `/search?q=${query}` : "/search",
        repositories: (search)=>`/dashboard/repositories${search ? `?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
                search: search
            })}` : ""}`,
        adminHub: (adminHubBaseUrl, orgId, workspaceUuid, path)=>{
            const workspaceAri = `ari:cloud:bitbucket::workspace/${(0, $a5HLv.uncurlyUuid)(workspaceUuid)}`;
            const params = {
                product: workspaceAri,
                referrerName: "Bitbucket"
            };
            return `${adminHubBaseUrl}/o/${orgId}/${path}?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(params)}`;
        }
    }
};
var $a526116467a80fda$export$2e2bcd8739ae039 = $a526116467a80fda$var$urls;

});

parcelRegister("ltQcg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7d7a9bcc5a19b57$export$2e2bcd8739ae039; });

var $dkkN8 = parcelRequire("dkkN8");
var $f7d7a9bcc5a19b57$export$2e2bcd8739ae039 = (payload)=>{
    return {
        type: (0, $dkkN8.TOGGLE_KB_SHORTCUT_MENU),
        payload: payload
    };
};

});
parcelRegister("dkkN8", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_CREATE_DRAWER", function () { return $ab7743962ef2ed96$export$2bd7c1ca681e7758; });
$parcel$export(module.exports, "TOGGLE_KB_SHORTCUT_MENU", function () { return $ab7743962ef2ed96$export$e2f0f019472b60f7; });
$parcel$export(module.exports, "TOGGLE_NAVIGATION_INIT", function () { return $ab7743962ef2ed96$export$fb670df394fc5d1d; });
$parcel$export(module.exports, "TOGGLE_MOBILE_HEADER", function () { return $ab7743962ef2ed96$export$433b9cc46bba1fca; });
$parcel$export(module.exports, "TOGGLE_SEARCH_DRAWER", function () { return $ab7743962ef2ed96$export$79411180978176bb; });
$parcel$export(module.exports, "TOGGLE_ATLASSIAN_SWITCHER", function () { return $ab7743962ef2ed96$export$352b2f7eed30fe25; });
$parcel$export(module.exports, "TOGGLE_FEEDBACK_BUTTON", function () { return $ab7743962ef2ed96$export$7556b0fb2abfd087; });
$parcel$export(module.exports, "UPDATE_MOBILE_HEADER_STATE", function () { return $ab7743962ef2ed96$export$e5ce62f5852118d; });
$parcel$export(module.exports, "UPDATE_NAVIGATION_STATE", function () { return $ab7743962ef2ed96$export$9dc296ba22f11086; });
$parcel$export(module.exports, "TOGGLE_UP_TO_SMALL_BREAKPOINT", function () { return $ab7743962ef2ed96$export$d20ffd2cd65fc99c; });
$parcel$export(module.exports, "TOGGLE_MARKETING_CONSENT_NEEDED", function () { return $ab7743962ef2ed96$export$c88fbc43eb7da75c; });
$parcel$export(module.exports, "LoadGlobal", function () { return $ab7743962ef2ed96$export$86f9fae80378a460; });
$parcel$export(module.exports, "SEARCH", function () { return $ab7743962ef2ed96$export$a6b9aaee40d49fd0; });
$parcel$export(module.exports, "SEARCH_DRAWER_INIT", function () { return $ab7743962ef2ed96$export$b53066af35e5f01; });
$parcel$export(module.exports, "SCROLL_TO", function () { return $ab7743962ef2ed96$export$46be339ac4e24819; });
$parcel$export(module.exports, "NETWORK_OFFLINE", function () { return $ab7743962ef2ed96$export$6b2c2d66e546ecf; });
$parcel$export(module.exports, "NETWORK_ONLINE", function () { return $ab7743962ef2ed96$export$983db4126576cea3; });
$parcel$export(module.exports, "OVERRIDE_FEATURE", function () { return $ab7743962ef2ed96$export$7a03b6c599d0d3e2; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
const $ab7743962ef2ed96$export$2bd7c1ca681e7758 = "global/TOGGLE_CREATE_DRAWER";
const $ab7743962ef2ed96$export$e2f0f019472b60f7 = "global/TOGGLE_KB_SHORTCUT_MENU";
const $ab7743962ef2ed96$export$fb670df394fc5d1d = "global/TOGGLE_NAVIGATION_INIT";
const $ab7743962ef2ed96$export$e76efbdc964da8e = "global/TOGGLE_NAVIGATION";
const $ab7743962ef2ed96$export$433b9cc46bba1fca = "global/TOGGLE_MOBILE_HEADER";
const $ab7743962ef2ed96$export$79411180978176bb = "global/TOGGLE_SEARCH_DRAWER";
const $ab7743962ef2ed96$export$352b2f7eed30fe25 = "global/TOGGLE_ATLASSIAN_SWITCHER";
const $ab7743962ef2ed96$export$7556b0fb2abfd087 = "global/TOGGLE_FEEDBACK_BUTTON";
const $ab7743962ef2ed96$export$e5ce62f5852118d = "global/UPDATE_MOBILE_HEADER_STATE";
const $ab7743962ef2ed96$export$9dc296ba22f11086 = "global/UPDATE_NAVIGATION_STATE";
const $ab7743962ef2ed96$export$d20ffd2cd65fc99c = "global/TOGGLE_UP_TO_SMALL_BREAKPOINT";
const $ab7743962ef2ed96$export$c88fbc43eb7da75c = "global/TOGGLE_MARKETING_CONSENT_NEEDED";
const $ab7743962ef2ed96$export$86f9fae80378a460 = (0, $2MctD.createAsyncAction)("global/LOAD");
const $ab7743962ef2ed96$export$a6b9aaee40d49fd0 = "global/SEARCH";
const $ab7743962ef2ed96$export$b53066af35e5f01 = "global/SEARCH_DRAWER_INIT";
const $ab7743962ef2ed96$export$46be339ac4e24819 = "global/SCROLL_TO";
const $ab7743962ef2ed96$export$6b2c2d66e546ecf = "global/NETWORK_OFFLINE";
const $ab7743962ef2ed96$export$983db4126576cea3 = "global/NETWORK_ONLINE";
const $ab7743962ef2ed96$export$7a03b6c599d0d3e2 = "global/OVERRIDE_FEATURE";

});
parcelRegister("5YpaN", function(module, exports) {

$parcel$export(module.exports, "createAsyncAction", function () { return (parcelRequire("2MctD")).createAsyncAction; });
$parcel$export(module.exports, "createBoolAction", function () { return (parcelRequire("2MctD")).createBoolAction; });
$parcel$export(module.exports, "createAsyncActionE", function () { return (parcelRequire("2MctD")).createAsyncActionE; });
$parcel$export(module.exports, "fetchAction", function () { return (parcelRequire("fICwP")).fetchAction; });
$parcel$export(module.exports, "hydrateAction", function () { return (parcelRequire("fICwP")).hydrateAction; });
$parcel$export(module.exports, "fetchData", function () { return (parcelRequire("kTw57")).fetchData; });
$parcel$export(module.exports, "fetchDataFromResource", function () { return (parcelRequire("8NQo6")).fetchDataFromResource; });

var $2MctD = parcelRequire("2MctD");

var $fICwP = parcelRequire("fICwP");

var $kTw57 = parcelRequire("kTw57");

var $8NQo6 = parcelRequire("8NQo6");

});
parcelRegister("2MctD", function(module, exports) {

$parcel$export(module.exports, "createAsyncAction", function () { return $536dd2fc4486ec56$export$3a80f7e4c1c7e6a8; });
$parcel$export(module.exports, "createBoolAction", function () { return $536dd2fc4486ec56$export$586f84a3aaf3fb63; });
$parcel$export(module.exports, "createAsyncActionE", function () { return $536dd2fc4486ec56$export$ed502c7884e9336d; });
function $536dd2fc4486ec56$export$3a80f7e4c1c7e6a8(action) {
    return {
        REQUEST: `${action}_REQUEST`,
        SUCCESS: `${action}_SUCCESS`,
        ERROR: `${action}_ERROR`
    };
}
function $536dd2fc4486ec56$export$586f84a3aaf3fb63(action) {
    return {
        TRUE: `${action}_TRUE`,
        FALSE: `${action}_FALSE`
    };
}
function $536dd2fc4486ec56$export$ed502c7884e9336d(action) {
    return {
        BEGIN: `${action}_BEGIN`,
        END: `${action}_END`
    };
}

});

parcelRegister("fICwP", function(module, exports) {

$parcel$export(module.exports, "fetchAction", function () { return $04b53b4aacfd0726$export$610f9aa15df8dc65; });
$parcel$export(module.exports, "hydrateAction", function () { return $04b53b4aacfd0726$export$a887225446d85ba6; });
function $04b53b4aacfd0726$export$610f9aa15df8dc65(action, meta) {
    return {
        type: action.REQUEST,
        meta: {
            ...meta,
            asyncAction: action
        }
    };
}
function $04b53b4aacfd0726$export$a887225446d85ba6(action, stateKey, meta) {
    return {
        type: action.REQUEST,
        meta: {
            ...meta,
            asyncAction: action,
            stateKey: stateKey
        }
    };
}

});

parcelRegister("kTw57", function(module, exports) {

$parcel$export(module.exports, "fetchData", function () { return $bdb168556853c7fb$export$8134c072fddab6a5; });

var $k2cPS = parcelRequire("k2cPS");
const $bdb168556853c7fb$export$8134c072fddab6a5 = (action, payloadTransformer)=>{
    return async (dispatch)=>{
        const { asyncAction: asyncAction, csrftoken: csrftoken, fetchOptions: fetchOptions = {}, url: url } = action.meta;
        const { responseType: responseType = "json", errorType: errorType = "json", ...otherFetchOptions } = fetchOptions;
        const requestOptions = {
            headers: responseType === "json" ? (0, $k2cPS.jsonHeaders) : {},
            ...otherFetchOptions
        };
        try {
            const response = await fetch((0, $k2cPS.default)(url, requestOptions, csrftoken));
            if (!response.ok) {
                let error;
                try {
                    error = await response[errorType]();
                } catch (e) {
                    error = response.status;
                }
                const getErrorText = errorType === "json" && error.error ? (json)=>json.error.message : (text)=>text;
                const e = new Error(getErrorText(error));
                // @ts-ignore
                e.status = response.status;
                throw e;
            }
            const payload = await response[responseType]();
            return dispatch({
                ...action,
                type: asyncAction.SUCCESS,
                payload: payloadTransformer ? payloadTransformer(payload) : payload
            });
        } catch (error) {
            return dispatch({
                type: asyncAction.ERROR,
                payload: error.message,
                error: true,
                meta: {
                    ...action.meta,
                    status: error.status
                }
            });
        }
    };
};

});
parcelRegister("k2cPS", function(module, exports) {

$parcel$export(module.exports, "jsonHeaders", function () { return $bf7eacb908ddf1e5$export$dd23d116120d45cc; });
$parcel$export(module.exports, "default", function () { return $bf7eacb908ddf1e5$export$2e2bcd8739ae039; });

var $86hZh = parcelRequire("86hZh");
const $bf7eacb908ddf1e5$export$f39f459ffe3b5b2 = "csrftoken";
const $bf7eacb908ddf1e5$export$7f697e417cb7a5a8 = "X-CSRFToken";
const $bf7eacb908ddf1e5$export$81350727a0ff4e2e = (url)=>/^(?!https?:)/.test(url) || url.indexOf(window.location.origin) === 0;
const $bf7eacb908ddf1e5$export$dd23d116120d45cc = {
    Accept: "application/json",
    "Content-Type": "application/json"
};
const $bf7eacb908ddf1e5$var$getRequestHeaders = (url, csrftoken)=>{
    const headers = {
        // Required for Django's request.is_ajax to work properly in some of our legacy views
        "X-Requested-With": "XMLHttpRequest",
        // Used by RequestMetaMiddleware to identify API requests originating from Frontbucket, for use
        // in analytic events (facts)
        "X-Bitbucket-Frontend": "frontbucket"
    };
    // never send tokens cross-(sub)domain
    if ($bf7eacb908ddf1e5$export$81350727a0ff4e2e(url)) headers[$bf7eacb908ddf1e5$export$7f697e417cb7a5a8] = csrftoken;
    return headers;
};
function $bf7eacb908ddf1e5$export$2e2bcd8739ae039(url, options = {}, csrftoken = (0, $86hZh.getCookie)($bf7eacb908ddf1e5$export$f39f459ffe3b5b2) || "") {
    const headers = $bf7eacb908ddf1e5$var$getRequestHeaders(url, csrftoken);
    return new Request(url, {
        credentials: "same-origin",
        ...options,
        headers: {
            ...headers,
            ...options.headers || {}
        }
    });
}

});


parcelRegister("8NQo6", function(module, exports) {

$parcel$export(module.exports, "fetchDataFromResource", function () { return $017fcb0b45a0f5dd$export$42ed7e0195fb0ceb; });

var $kTw57 = parcelRequire("kTw57");
const $017fcb0b45a0f5dd$export$42ed7e0195fb0ceb = (action)=>{
    return (dispatch)=>{
        // Add this flag to `meta` to tell `fetch-action-saga` not to process the `fetch` call
        // because we can't `await` the results of a saga from outside of it or some other
        // saga/generator context
        action.meta.isRouterResource = true;
        // We still want to dispatch `MyFetchAction.REQUEST` so other reducers or sagas can process it
        dispatch(action);
        // Make the API request and dispatch `.SUCCESS` or `.ERROR` events and return the Promise
        // to the caller so it can `await` if necessary
        // @ts-ignore our types for redux need some work : /
        return dispatch((0, $kTw57.fetchData)(action));
    };
};

});




parcelRegister("33dmM", function(module, exports) {

$parcel$export(module.exports, "keyboardShortcutDialogMessages", function () { return $fbccbf859b127274$export$b62b5f24d3cd64b9; });

var $agjvf = parcelRequire("agjvf");
const $fbccbf859b127274$export$b62b5f24d3cd64b9 = (0, $agjvf.defineMessages)({
    closeButton: {
        "id": "frontbucket.components.keyboardShortcutMenu.closeButton",
        "defaultMessage": "Close"
    },
    heading: {
        "id": "frontbucket.components.keyboardShortcutMenu.heading",
        "defaultMessage": "Keyboard shortcuts"
    },
    shiftKey: {
        "id": "frontbucket.components.keyboardShortcutMenu.shiftKey",
        "defaultMessage": "Shift"
    }
});

});

parcelRegister("dCs3M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ea4971370f5f969$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $56gVi = parcelRequire("56gVi");

var $5b2Wc = parcelRequire("5b2Wc");
var $9ea4971370f5f969$var$flexGrowMap = {
    hug: (0, $56gVi.xcss)({
        flexGrow: 0
    }),
    fill: (0, $56gVi.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
var $9ea4971370f5f969$var$separatorStyles = (0, $avKww.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $9ea4971370f5f969$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $avKww.jsx)("span", {
        css: $9ea4971370f5f969$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $9ea4971370f5f969$var$Inline = /*#__PURE__*/ (0, $9nHZC.memo)(/*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $avKww.jsx)($9ea4971370f5f969$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $9nHZC.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $avKww.jsx)((0, $9nHZC.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $9ea4971370f5f969$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $avKww.jsx)((0, $5b2Wc.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$9ea4971370f5f969$var$Inline.displayName = "Inline";
var $9ea4971370f5f969$export$2e2bcd8739ae039 = $9ea4971370f5f969$var$Inline;

});
parcelRegister("56gVi", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $3b6aa3deae7c8b6c$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $3b6aa3deae7c8b6c$export$f6c783d06584602c; });

var $b4Ivn = parcelRequire("b4Ivn");

var $kFnE9 = parcelRequire("kFnE9");

var $9q1kH = parcelRequire("9q1kH");

var $340K4 = parcelRequire("340K4");

var $avKww = parcelRequire("avKww");

var $7A2nl = parcelRequire("7A2nl");

var $8ovux = parcelRequire("8ovux");
function $3b6aa3deae7c8b6c$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $3b6aa3deae7c8b6c$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $3b6aa3deae7c8b6c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3b6aa3deae7c8b6c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3b6aa3deae7c8b6c$var$_arrayLikeToArray(o, minLen);
}
function $3b6aa3deae7c8b6c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $3b6aa3deae7c8b6c$export$9a199fbafee0014e = {
    backgroundColor: (0, $7A2nl.backgroundColorMap),
    blockSize: (0, $7A2nl.dimensionMap),
    borderBlockColor: (0, $7A2nl.borderColorMap),
    borderBlockEndColor: (0, $7A2nl.borderColorMap),
    borderBlockEndWidth: (0, $7A2nl.borderWidthMap),
    borderBlockStartColor: (0, $7A2nl.borderColorMap),
    borderBlockStartWidth: (0, $7A2nl.borderWidthMap),
    borderBlockWidth: (0, $7A2nl.borderWidthMap),
    borderBottomColor: (0, $7A2nl.borderColorMap),
    borderBottomLeftRadius: (0, $7A2nl.borderRadiusMap),
    borderBottomRightRadius: (0, $7A2nl.borderRadiusMap),
    borderBottomWidth: (0, $7A2nl.borderWidthMap),
    borderColor: (0, $7A2nl.borderColorMap),
    borderEndEndRadius: (0, $7A2nl.borderRadiusMap),
    borderEndStartRadius: (0, $7A2nl.borderRadiusMap),
    borderInlineColor: (0, $7A2nl.borderColorMap),
    borderInlineEndColor: (0, $7A2nl.borderColorMap),
    borderInlineEndWidth: (0, $7A2nl.borderWidthMap),
    borderInlineStartColor: (0, $7A2nl.borderColorMap),
    borderInlineStartWidth: (0, $7A2nl.borderWidthMap),
    borderInlineWidth: (0, $7A2nl.borderWidthMap),
    borderLeftColor: (0, $7A2nl.borderColorMap),
    borderLeftWidth: (0, $7A2nl.borderWidthMap),
    borderRadius: (0, $7A2nl.borderRadiusMap),
    borderRightColor: (0, $7A2nl.borderColorMap),
    borderRightWidth: (0, $7A2nl.borderWidthMap),
    borderStartEndRadius: (0, $7A2nl.borderRadiusMap),
    borderStartStartRadius: (0, $7A2nl.borderRadiusMap),
    borderTopColor: (0, $7A2nl.borderColorMap),
    borderTopLeftRadius: (0, $7A2nl.borderRadiusMap),
    borderTopRightRadius: (0, $7A2nl.borderRadiusMap),
    borderTopWidth: (0, $7A2nl.borderWidthMap),
    borderWidth: (0, $7A2nl.borderWidthMap),
    bottom: (0, $7A2nl.allSpaceMap),
    boxShadow: (0, $7A2nl.shadowMap),
    color: (0, $7A2nl.textColorMap),
    columnGap: (0, $7A2nl.positiveSpaceMap),
    gap: (0, $7A2nl.positiveSpaceMap),
    height: (0, $7A2nl.dimensionMap),
    inlineSize: (0, $7A2nl.dimensionMap),
    inset: (0, $7A2nl.allSpaceMap),
    insetBlock: (0, $7A2nl.allSpaceMap),
    insetBlockEnd: (0, $7A2nl.allSpaceMap),
    insetBlockStart: (0, $7A2nl.allSpaceMap),
    insetInline: (0, $7A2nl.allSpaceMap),
    insetInlineEnd: (0, $7A2nl.allSpaceMap),
    insetInlineStart: (0, $7A2nl.allSpaceMap),
    left: (0, $7A2nl.allSpaceMap),
    margin: (0, $7A2nl.allSpaceMap),
    marginBlock: (0, $7A2nl.allSpaceMap),
    marginBlockEnd: (0, $7A2nl.allSpaceMap),
    marginBlockStart: (0, $7A2nl.allSpaceMap),
    marginBottom: (0, $7A2nl.allSpaceMap),
    marginInline: (0, $7A2nl.allSpaceMap),
    marginInlineEnd: (0, $7A2nl.allSpaceMap),
    marginInlineStart: (0, $7A2nl.allSpaceMap),
    marginLeft: (0, $7A2nl.allSpaceMap),
    marginRight: (0, $7A2nl.allSpaceMap),
    marginTop: (0, $7A2nl.allSpaceMap),
    maxBlockSize: (0, $7A2nl.dimensionMap),
    maxHeight: (0, $7A2nl.dimensionMap),
    maxInlineSize: (0, $7A2nl.dimensionMap),
    maxWidth: (0, $7A2nl.dimensionMap),
    minBlockSize: (0, $7A2nl.dimensionMap),
    minHeight: (0, $7A2nl.dimensionMap),
    minInlineSize: (0, $7A2nl.dimensionMap),
    minWidth: (0, $7A2nl.dimensionMap),
    opacity: (0, $7A2nl.opacityMap),
    outlineColor: (0, $7A2nl.borderColorMap),
    outlineOffset: (0, $7A2nl.positiveSpaceMap),
    outlineWidth: (0, $7A2nl.borderWidthMap),
    padding: (0, $7A2nl.positiveSpaceMap),
    paddingBlock: (0, $7A2nl.positiveSpaceMap),
    paddingBlockEnd: (0, $7A2nl.positiveSpaceMap),
    paddingBlockStart: (0, $7A2nl.positiveSpaceMap),
    paddingBottom: (0, $7A2nl.positiveSpaceMap),
    paddingInline: (0, $7A2nl.positiveSpaceMap),
    paddingInlineEnd: (0, $7A2nl.positiveSpaceMap),
    paddingInlineStart: (0, $7A2nl.positiveSpaceMap),
    paddingLeft: (0, $7A2nl.positiveSpaceMap),
    paddingRight: (0, $7A2nl.positiveSpaceMap),
    paddingTop: (0, $7A2nl.positiveSpaceMap),
    right: (0, $7A2nl.allSpaceMap),
    rowGap: (0, $7A2nl.positiveSpaceMap),
    top: (0, $7A2nl.allSpaceMap),
    width: (0, $7A2nl.dimensionMap),
    zIndex: (0, $7A2nl.layerMap)
};
var $3b6aa3deae7c8b6c$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $3b6aa3deae7c8b6c$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $8ovux === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux.env) === "object" && false;
};
var $3b6aa3deae7c8b6c$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $3b6aa3deae7c8b6c$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $3b6aa3deae7c8b6c$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(value) === "object" && $3b6aa3deae7c8b6c$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($3b6aa3deae7c8b6c$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($3b6aa3deae7c8b6c$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $3b6aa3deae7c8b6c$export$9a199fbafee0014e)) return;
        var tokenValue = $3b6aa3deae7c8b6c$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $3b6aa3deae7c8b6c$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $3b6aa3deae7c8b6c$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, $3b6aa3deae7c8b6c$var$uniqueSymbol, (0, $avKww.css)(transformedStyles));
};
var $3b6aa3deae7c8b6c$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $3b6aa3deae7c8b6c$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$3b6aa3deae7c8b6c$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $3b6aa3deae7c8b6c$export$f6c783d06584602c(style) {
    return $3b6aa3deae7c8b6c$var$baseXcss(style);
}

});
parcelRegister("7A2nl", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $584dbce811c934b4$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $584dbce811c934b4$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $584dbce811c934b4$export$632685d741f3dbbf; });
$parcel$export(module.exports, "inverseColorMap", function () { return $584dbce811c934b4$export$2185ce37f9bdd963; });
$parcel$export(module.exports, "opacityMap", function () { return $584dbce811c934b4$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $584dbce811c934b4$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $584dbce811c934b4$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $584dbce811c934b4$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $584dbce811c934b4$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $584dbce811c934b4$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $584dbce811c934b4$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $584dbce811c934b4$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $584dbce811c934b4$export$e615f061ca585a6c; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $584dbce811c934b4$export$bf46c3f9eeafc71f; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $584dbce811c934b4$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "textColorStylesMap", function () { return $584dbce811c934b4$export$3a1bcba60b23d7f0; });
$parcel$export(module.exports, "fontWeightStylesMap", function () { return $584dbce811c934b4$export$45f3f4fe16f9f7d5; });
$parcel$export(module.exports, "fontStylesMap", function () { return $584dbce811c934b4$export$128f10c238242f83; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $584dbce811c934b4$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $584dbce811c934b4$export$5e65a44e5b6ecadb; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $xbX1J = parcelRequire("xbX1J");
function $584dbce811c934b4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $584dbce811c934b4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $584dbce811c934b4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $584dbce811c934b4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $584dbce811c934b4$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $584dbce811c934b4$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $584dbce811c934b4$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $584dbce811c934b4$export$632685d741f3dbbf = $584dbce811c934b4$var$_objectSpread($584dbce811c934b4$var$_objectSpread({}, $584dbce811c934b4$export$958d0ae7f2977ae4), $584dbce811c934b4$export$d2dc61f58390201c);
var $584dbce811c934b4$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $584dbce811c934b4$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $584dbce811c934b4$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $584dbce811c934b4$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $584dbce811c934b4$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $584dbce811c934b4$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $584dbce811c934b4$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $584dbce811c934b4$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $584dbce811c934b4$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $584dbce811c934b4$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $584dbce811c934b4$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $584dbce811c934b4$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $584dbce811c934b4$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $584dbce811c934b4$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $584dbce811c934b4$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $584dbce811c934b4$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $avKww.css)((0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $584dbce811c934b4$export$e615f061ca585a6c = $584dbce811c934b4$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $584dbce811c934b4$var$getSerializedStylesMap(spacingProperty, $584dbce811c934b4$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $584dbce811c934b4$export$bf46c3f9eeafc71f = $584dbce811c934b4$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $584dbce811c934b4$var$getSerializedStylesMap(spacingProperty, $584dbce811c934b4$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $584dbce811c934b4$export$e7af83bafe7f9e63 = $584dbce811c934b4$var$getSerializedStylesMap("backgroundColor", $584dbce811c934b4$export$d1d79bf68ac056bd);
var $584dbce811c934b4$export$3a1bcba60b23d7f0 = $584dbce811c934b4$var$getSerializedStylesMap("color", $584dbce811c934b4$export$8473307aa00d6ea1);
var $584dbce811c934b4$export$45f3f4fe16f9f7d5 = $584dbce811c934b4$var$getSerializedStylesMap("fontWeight", $584dbce811c934b4$export$303e322c6b1ed114);
var $584dbce811c934b4$export$68cc305da27dbaa4 = $584dbce811c934b4$var$getSerializedStylesMap("fontFamily", $584dbce811c934b4$export$3c7e9587132614b4);
var $584dbce811c934b4$export$128f10c238242f83 = $584dbce811c934b4$var$getSerializedStylesMap("font", $584dbce811c934b4$export$6cc560b4dedf3816);
var $584dbce811c934b4$export$ff257d957d48c421 = $584dbce811c934b4$var$getSerializedStylesMap((0, $xbX1J.CURRENT_SURFACE_CSS_VAR), $584dbce811c934b4$export$41a358c9c2356760);
var $584dbce811c934b4$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $584dbce811c934b4$export$41a358c9c2356760[color] !== undefined;
};

});


parcelRegister("5b2Wc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c5042307be8416e$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $7A2nl = parcelRequire("7A2nl");

var $56gVi = parcelRequire("56gVi");
var $3c5042307be8416e$var$justifyContentMap = {
    start: (0, $avKww.css)({
        justifyContent: "start"
    }),
    center: (0, $avKww.css)({
        justifyContent: "center"
    }),
    end: (0, $avKww.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $avKww.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $avKww.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $avKww.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $avKww.css)({
        justifyContent: "stretch"
    })
};
var $3c5042307be8416e$var$flexDirectionMap = {
    column: (0, $avKww.css)({
        flexDirection: "column"
    }),
    row: (0, $avKww.css)({
        flexDirection: "row"
    })
};
var $3c5042307be8416e$var$flexWrapMap = {
    wrap: (0, $avKww.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $avKww.css)({
        flexWrap: "nowrap"
    })
};
var $3c5042307be8416e$var$alignItemsMap = {
    start: (0, $avKww.css)({
        alignItems: "start"
    }),
    center: (0, $avKww.css)({
        alignItems: "center"
    }),
    baseline: (0, $avKww.css)({
        alignItems: "baseline"
    }),
    end: (0, $avKww.css)({
        alignItems: "end"
    }),
    stretch: (0, $avKww.css)({
        alignItems: "stretch"
    })
};
var $3c5042307be8416e$var$baseStyles = (0, $avKww.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $3c5042307be8416e$var$Flex = /*#__PURE__*/ (0, $9nHZC.memo)(/*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $56gVi.parseXcss)(xcss);
    return (0, $avKww.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $3c5042307be8416e$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $7A2nl.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $7A2nl.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $7A2nl.spaceStylesMap).rowGap[rowGap],
            alignItems && $3c5042307be8416e$var$alignItemsMap[alignItems],
            direction && $3c5042307be8416e$var$flexDirectionMap[direction],
            justifyContent && $3c5042307be8416e$var$justifyContentMap[justifyContent],
            wrap && $3c5042307be8416e$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$3c5042307be8416e$var$Flex.displayName = "Flex";
var $3c5042307be8416e$export$2e2bcd8739ae039 = $3c5042307be8416e$var$Flex;

});


parcelRegister("2c6bL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $199180bbcd2cda6e$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $4GQn2 = parcelRequire("4GQn2");

var $7A2nl = parcelRequire("7A2nl");

var $3aLQX = parcelRequire("3aLQX");
var $199180bbcd2cda6e$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $199180bbcd2cda6e$var$resetStyles = (0, $avKww.css)({
    margin: 0,
    overflowWrap: "anywhere"
});
var $199180bbcd2cda6e$var$strongStyles = (0, $avKww.css)({
    fontWeight: "bold"
});
var $199180bbcd2cda6e$var$emStyles = (0, $avKww.css)({
    fontStyle: "italic"
});
var $199180bbcd2cda6e$var$textAlignMap = {
    center: (0, $avKww.css)({
        textAlign: "center"
    }),
    end: (0, $avKww.css)({
        textAlign: "end"
    }),
    start: (0, $avKww.css)({
        textAlign: "start"
    })
};
var $199180bbcd2cda6e$var$truncationStyles = (0, $avKww.css)({
    display: "-webkit-box",
    overflow: "hidden",
    WebkitBoxOrient: "vertical"
});
var $199180bbcd2cda6e$var$wordBreakMap = {
    breakAll: (0, $avKww.css)({
        wordBreak: "break-all"
    })
};
var $199180bbcd2cda6e$var$HasTextAncestorContext = /*#__PURE__*/ (0, $9nHZC.createContext)(false);
var $199180bbcd2cda6e$var$useHasTextAncestor = function useHasTextAncestor() {
    return (0, $9nHZC.useContext)($199180bbcd2cda6e$var$HasTextAncestorContext);
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $199180bbcd2cda6e$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $3aLQX.useSurface)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $7A2nl.inverseColorMap).hasOwnProperty(surface)) return (0, $7A2nl.inverseColorMap)[surface];
    if (colorProp === "inherit") return undefined;
    if (!colorProp && hasTextAncestor) return undefined;
    return colorProp || "color.text";
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $199180bbcd2cda6e$var$Text = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "span" : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, _ref$size = _ref.size, size = _ref$size === void 0 ? "medium" : _ref$size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $4GQn2.default)($199180bbcd2cda6e$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = $199180bbcd2cda6e$var$useHasTextAncestor();
    var color = $199180bbcd2cda6e$var$useColor(colorProp, hasTextAncestor);
    var component = (0, $avKww.jsx)(Component, {
        ref: ref,
        css: [
            $199180bbcd2cda6e$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7A2nl.fontStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $7A2nl.textColorStylesMap)[color],
            maxLines && $199180bbcd2cda6e$var$truncationStyles,
            maxLines === 1 && $199180bbcd2cda6e$var$wordBreakMap.breakAll,
            align && $199180bbcd2cda6e$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $7A2nl.fontWeightStylesMap)[weight],
            Component === "em" && $199180bbcd2cda6e$var$emStyles,
            Component === "strong" && $199180bbcd2cda6e$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $avKww.jsx)($199180bbcd2cda6e$var$HasTextAncestorContext.Provider, {
        value: true
    }, component);
});
var $199180bbcd2cda6e$export$2e2bcd8739ae039 = $199180bbcd2cda6e$var$Text;

});
parcelRegister("3aLQX", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $24f76ce45f924378$export$1ca2a26fecb070ae; });
$parcel$export(module.exports, "useSurface", function () { return $24f76ce45f924378$export$1aeb4f6b93c4540d; });

var $9nHZC = parcelRequire("9nHZC");
var $24f76ce45f924378$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $9nHZC.createContext)("elevation.surface");
var $24f76ce45f924378$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $9nHZC.useContext)($24f76ce45f924378$export$1ca2a26fecb070ae);
};
$24f76ce45f924378$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("ci5gC", function(module, exports) {

$parcel$export(module.exports, "ModalHeader", function () { return $a907d2573b551ed8$export$f50a68e3694789ee; });
$parcel$export(module.exports, "default", function () { return $a907d2573b551ed8$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ModalTransition", function () { return (parcelRequire("2FnXC")).default; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $EKmRU = parcelRequire("EKmRU");

var $cGPG3 = parcelRequire("cGPG3");
var $ljrFr = parcelRequire("ljrFr");
var $2X56B = parcelRequire("2X56B");
var $DPG6Z = parcelRequire("DPG6Z");
var $3qXIy = parcelRequire("3qXIy");
var $2FnXC = parcelRequire("2FnXC");
const $a907d2573b551ed8$var$defaultContainer = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, children);
const $a907d2573b551ed8$export$f50a68e3694789ee = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $DPG6Z.default), props);
const $a907d2573b551ed8$export$519437715052e656 = ({ actions: actions = [], appearance: appearance, ...props })=>{
    const end = actions.length - 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2X56B.default), props, actions.map(({ text: text, ...btnProps }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $EKmRU.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, btnProps, {
            autoFocus: index === end,
            appearance: index !== end ? "subtle" : appearance || "primary",
            key: index
        }), text)));
};
function $a907d2573b551ed8$export$2e2bcd8739ae039({ actions: actions, appearance: appearance, components: components = {}, body: body, footer: footer, header: header, heading: heading, isHeadingMultiline: isHeadingMultiline, scrollBehavior: scrollBehavior, testId: testId, children: children, ...props }) {
    const { Header: Header = header !== null && header !== void 0 ? header : $a907d2573b551ed8$export$f50a68e3694789ee, Footer: Footer = footer !== null && footer !== void 0 ? footer : $a907d2573b551ed8$export$519437715052e656, Body: Body = body !== null && body !== void 0 ? body : (0, $ljrFr.default), Container: Container = $a907d2573b551ed8$var$defaultContainer } = components;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $cGPG3.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        shouldScrollInViewport: scrollBehavior === "outside",
        testId: testId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Header, {
        testId: testId
    }, heading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3qXIy.default), {
        appearance: appearance,
        isMultiline: isHeadingMultiline,
        testId: testId
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Body, {
        testId: testId
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Footer, {
        actions: actions,
        appearance: appearance,
        testId: testId
    })));
}

});

parcelRegister("1JlAz", function(module, exports) {

$parcel$export(module.exports, "useStatsdMeasuredRender", function () { return $c863876d9d532e2b$export$da0441038a6383b9; });
$parcel$export(module.exports, "withStatsd", function () { return $c863876d9d532e2b$export$f20de7a85a17d5ce; });

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("dGzLf");
var $1ED64 = parcelRequire("1ED64");
var $aAre5 = parcelRequire("aAre5");

var $jrVBy = parcelRequire("jrVBy");
const $c863876d9d532e2b$var$displayName = (c)=>c.displayName || c.name || "Component";
const $c863876d9d532e2b$export$da0441038a6383b9 = (metricName, options = {})=>{
    (0, $9nHZC.useEffect)(()=>{
        (0, $jrVBy.sendPageLoadMetric)(metricName, options);
    // `sendPageLoadMetric` is only meant to be called on the initial mount of the component
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
const $c863876d9d532e2b$var$useStatsdMeasuredRenderWithFeatureFlags = (metricName, options = {})=>{
    const { customEndEvent: customEndEvent, customStartEvent: customStartEvent, featureFlagSelectors: featureFlagSelectors = [] } = options;
    // Using `shallowEqual` here is *very* important, otherwise this will force
    // the consuming component (usually page-level) to re-render on every change
    // to the redux store
    const featureFlagMap = (0, $aAre5.useSelector)((state)=>featureFlagSelectors.reduce((acc, { name: name, selector: selector })=>({
                ...acc,
                [name]: selector(state)
            }), {}), (0, $1ED64.default));
    const tags = Object.keys(featureFlagMap).map((flagName)=>`${flagName}:${featureFlagMap[flagName]}`);
    $c863876d9d532e2b$export$da0441038a6383b9(metricName, {
        customEndEvent: customEndEvent,
        customStartEvent: customStartEvent,
        tags: tags
    });
};
const $c863876d9d532e2b$export$f20de7a85a17d5ce = (metricName, options = {})=>(Comp)=>{
        function WithStatsd(props) {
            $c863876d9d532e2b$var$useStatsdMeasuredRenderWithFeatureFlags(metricName, options);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Comp, props);
        }
        WithStatsd.displayName = `withStatsd(${$c863876d9d532e2b$var$displayName(Comp)})`;
        WithStatsd.WrappedComponent = Comp;
        return WithStatsd;
    };

});
parcelRegister("jrVBy", function(module, exports) {

$parcel$export(module.exports, "sendPageLoadMetric", function () { return $5c6f6be2255e8f30$export$950fdfad6b762a65; });

var $31lGp = parcelRequire("31lGp");

var $M3cyx = parcelRequire("M3cyx");

var $1ZBmx = parcelRequire("1ZBmx");

var $f3oaj = parcelRequire("f3oaj");

var $3Dg4T = parcelRequire("3Dg4T");

var $aUw1x = parcelRequire("aUw1x");
function $5c6f6be2255e8f30$export$950fdfad6b762a65(metricName, options = {}) {
    const { customEndEvent: customEndEvent, customStartEvent: customStartEvent, tags: extraTags = [] } = options;
    if (!(0, $aUw1x.shouldSendMetrics)()) return;
    const loadType = (0, $3Dg4T.getPageLoadType)();
    const duration = (0, $f3oaj.getPageLoadDuration)(metricName, customStartEvent, customEndEvent);
    if (!duration || !loadType) return;
    const tags = [
        "source:frontbucket",
        `loadType:${loadType}`,
        `appWasServerSideRendered:${(0, $1ZBmx.appWasServerSideRendered)()}`,
        ...extraTags
    ];
    if (loadType === "full_page") tags.push(`view_name:${(0, $31lGp.default)}`);
    (0, $M3cyx.statsdApiClient).histogram({
        [metricName]: duration
    }, {
        tags: tags
    });
}

});
parcelRegister("31lGp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $752f6a733b81648a$export$2e2bcd8739ae039; });
const $752f6a733b81648a$var$meta = document.head ? document.head.querySelector("meta[name=bb-view-name]") : undefined;
var $752f6a733b81648a$export$2e2bcd8739ae039 = $752f6a733b81648a$var$meta ? $752f6a733b81648a$var$meta.content : "";

});

parcelRegister("M3cyx", function(module, exports) {

$parcel$export(module.exports, "statsdApiClient", function () { return $331b124e6c1e050c$export$a01478d561e38286; });
parcelRequire("k5QC7");
var $dxTmL = parcelRequire("dxTmL");

var $kvnVB = parcelRequire("kvnVB");

var $628YF = parcelRequire("628YF");
const $331b124e6c1e050c$var$onError = (e)=>{
    (0, $628YF.captureExceptionWithTags)(e, {
        component: "metrics"
    });
};
const $331b124e6c1e050c$var$request = {
    url: `${(0, $kvnVB.settings)().API_CANON_URL}/internal/metrics/statsd/`,
    init: {
        headers: {
            "Content-Type": "application/json"
        }
    }
};
const $331b124e6c1e050c$export$a01478d561e38286 = new (0, $dxTmL.default)($331b124e6c1e050c$var$request, {
    onError: $331b124e6c1e050c$var$onError
});

});
parcelRegister("k5QC7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("dxTmL")).default; });

var $dkt0q = parcelRequire("dkt0q");

var $dxTmL = parcelRequire("dxTmL");

});
parcelRegister("dkt0q", function(module, exports) {

});

parcelRegister("dxTmL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fd69b7d1dfb75f7$export$2e2bcd8739ae039; });

var $ausL7 = parcelRequire("ausL7");
function $5fd69b7d1dfb75f7$var$extractSampleRate(options = {}) {
    return typeof options.sampleRate === "number" ? options.sampleRate : 1;
}
function $5fd69b7d1dfb75f7$var$normalizeCounterData(data) {
    if (typeof data === "string") return {
        [data]: 1
    };
    else if (Array.isArray(data)) return data.reduce((acc, v)=>({
            ...acc,
            [v]: 1
        }), {});
    return data;
}
/**
 * This simulates the same sampling that datadog's statsd agent performs,
 * while obviating the need to send all metrics to the server, only to
 * have them filtered out by the sample rate, i.e. no-ops.
 * See: https://github.com/DataDog/dd-agent/blob/331c507f164ec7bd256a32beb3889d4fafb0ba7e/aggregator.py#L205
 */ function $5fd69b7d1dfb75f7$var$amplifySamples(data, sampleRate) {
    const amplifiedData = {};
    Object.keys(data).forEach((k)=>{
        // @ts-ignore TODO: fix noImplicitAny error here
        amplifiedData[k] = data[k] * Math.floor(1 / sampleRate);
    });
    return amplifiedData;
}
var $5fd69b7d1dfb75f7$export$2e2bcd8739ae039;
$5fd69b7d1dfb75f7$export$2e2bcd8739ae039 = class StatsdApiClient {
    constructor(authRequest, options = {}){
        this.authRequest = void 0;
        this.options = void 0;
        this.addToApiBatch = (0, $ausL7.default)(this.post.bind(this), {
            timeout: 1000
        });
        this.authRequest = authRequest;
        this.options = options;
    }
    post(data) {
        if (this.authRequest) fetch(this.authRequest.url, {
            method: "POST",
            body: JSON.stringify(data),
            ...this.authRequest.init
        }).then((response)=>response.ok ? Promise.resolve() : Promise.reject()).catch((e)=>{
            // Only handle exceptions for now (continue ignoring non-2XX responses)
            if (e && this.options.onError) this.options.onError(e);
        });
    }
    sendMetric(metric, data, options = {}) {
        const sampleRate = $5fd69b7d1dfb75f7$var$extractSampleRate(options);
        const include = Math.random() < sampleRate;
        if (include) {
            const payload = {
                data: data,
                metric: metric,
                tags: options.tags || []
            };
            if (options.eager) this.post(payload);
            else // This simulates the same sampling that datadog's statsd agent performs,
            // while obviating the need to send all metrics to the server, only to
            // have them filtered out by the sample rate, i.e. no-ops.
            // See: https://github.com/DataDog/dd-agent/blob/331c507f164ec7bd256a32beb3889d4fafb0ba7e/aggregator.py#L205
            this.addToApiBatch(payload);
        }
        return include;
    }
    event(title, text, options) {
        return this.sendMetric("event", {
            title: title,
            text: text
        }, options);
    }
    increment(data, options) {
        const amplifiedData = $5fd69b7d1dfb75f7$var$amplifySamples($5fd69b7d1dfb75f7$var$normalizeCounterData(data), $5fd69b7d1dfb75f7$var$extractSampleRate(options));
        return this.sendMetric("increment", amplifiedData, options);
    }
    decrement(data, options) {
        const amplifiedData = $5fd69b7d1dfb75f7$var$amplifySamples($5fd69b7d1dfb75f7$var$normalizeCounterData(data), $5fd69b7d1dfb75f7$var$extractSampleRate(options));
        return this.sendMetric("decrement", amplifiedData, options);
    }
    gauge(data, options) {
        return this.sendMetric("gauge", data, options);
    }
    histogram(data, options) {
        return this.sendMetric("histogram", data, options);
    }
    set(data, options) {
        return this.sendMetric("set", data, options);
    }
};

});
parcelRegister("ausL7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d76d1869d336696$export$2e2bcd8739ae039; });
/* Stores a set of items that can be processed simultaneously after a set timeout.
 *
 * Example:
 *
 * // Create the batch, which returns the function to add items
 * const addToBatch = timedBatch(function processItems(items) {
 *  items.forEach(item => doSomethingWithItem(item));
 * }, { timeout: 5000 });
 *
 * // Add things to the batch. After the timeout (5000ms), these items will be
 * // passed to the callback as an array ([4, 2] in this example)
 * addToBatch(4);
 * addToBatch(2);
 *
 * If we call `addToBatch` again after that timeout, a new batch will be
 * created and only those new items will be processed.
 */ function $9d76d1869d336696$export$2e2bcd8739ae039(callback, options = {}) {
    // @ts-ignore TODO: fix noImplicitAny error here
    let batchTimeout;
    const batch = [];
    const timeout = options.timeout || 1000;
    // @ts-ignore TODO: fix noImplicitAny error here
    return function addToBatch(item) {
        batch.push(item);
        // @ts-ignore TODO: fix noImplicitAny error here
        clearTimeout(batchTimeout);
        batchTimeout = setTimeout(()=>{
            callback(batch.slice());
            // clear the existing items
            batch.length = 0;
        }, timeout);
    };
}

});



parcelRegister("kvnVB", function(module, exports) {

$parcel$export(module.exports, "settings", function () { return $4a8b96c0bd1df481$export$a5a6e0b888b2c992; });
const $4a8b96c0bd1df481$export$a5a6e0b888b2c992 = ()=>window.__settings__ || {};

});


parcelRegister("f3oaj", function(module, exports) {

$parcel$export(module.exports, "getPageLoadDuration", function () { return $d1b9a37ae3d9cdb1$export$aef45036d9602c1c; });

var $3XbtU = parcelRequire("3XbtU");

var $3Dg4T = parcelRequire("3Dg4T");

var $aUw1x = parcelRequire("aUw1x");
// One minute max
const $d1b9a37ae3d9cdb1$var$METRICS_MAX_TIME = 60000;
function $d1b9a37ae3d9cdb1$export$aef45036d9602c1c(metricName, customStartEvent, customEndEvent) {
    let startEvent;
    if (!(0, $aUw1x.shouldSendMetrics)()) return null;
    // Set the end time for the current metric immediately
    const { performance: performance } = window;
    performance.mark("ENDTIME");
    // For ease of reading in Dev Tools performance profiling
    const metricNameUppercase = metricName.toUpperCase();
    const loadType = (0, $3Dg4T.getPageLoadType)();
    if (!loadType) return null;
    // Determine where to measure from
    if (customStartEvent) startEvent = customStartEvent;
    else if (loadType === "client_side_routing") startEvent = "ROUTECHANGE";
    else startEvent = "requestStart";
    const endEvent = customEndEvent || "ENDTIME";
    performance.measure(metricNameUppercase, startEvent, endEvent);
    const measures = performance.getEntriesByName(metricNameUppercase, "measure");
    performance.clearMarks("ENDTIME");
    performance.clearMeasures(metricNameUppercase);
    // There should only ever be one measure matching
    // the metricNameUppercase name.  If there's not
    // exactly one, something's gone wrong so don't
    // send a metric.
    if (measures.length !== 1) {
        $3XbtU.withScope((scope)=>{
            scope.setTag("metricName", metricName);
            scope.setTag("loadType", loadType);
            $3XbtU.captureMessage("METRIC_MEASURE_MISSING");
        });
        return null;
    }
    const { duration: duration } = measures[0];
    // Exclude outliers
    if (Number.isNaN(duration) || duration < 0 || duration > $d1b9a37ae3d9cdb1$var$METRICS_MAX_TIME) {
        $3XbtU.withScope((scope)=>{
            scope.setTag(metricName, `${duration}`);
            scope.setTag("METRICS_MAX_TIME", `${$d1b9a37ae3d9cdb1$var$METRICS_MAX_TIME}`);
            $3XbtU.captureMessage("METRIC_OUTLIER");
        });
        return null;
    }
    return duration;
}

});
parcelRegister("3Dg4T", function(module, exports) {

$parcel$export(module.exports, "getPageLoadType", function () { return $81e16bdf482f7213$export$6abfc139961d0791; });

var $aUw1x = parcelRequire("aUw1x");
function $81e16bdf482f7213$export$6abfc139961d0791() {
    if (!(0, $aUw1x.shouldSendMetrics)()) return null;
    // Existence of a ROUTECHANGE event means it was a SPA transition
    const { performance: performance } = window;
    const marks = performance.getEntriesByName("ROUTECHANGE", "mark");
    // No ROUTECHANGE exists: it's a whole page load
    if (marks.length === 0) return "full_page";
    else if (marks.length === 1) return "client_side_routing";
    // Multiple ROUTECHANGE events exist: somethings's gone wrong.
    // Prevent pollution of analytics by blocking sending of the metrics.
    return null;
}

});
parcelRegister("aUw1x", function(module, exports) {

$parcel$export(module.exports, "shouldSendMetrics", function () { return $64540c3e053f4401$export$3d43d2794cf41683; });
/**
 * Note: The flag 'window.performance.okayToSendMetrics' is
 * set inside 'performance-timing-init.jinja' in Backbucket.
 */ function $64540c3e053f4401$export$3d43d2794cf41683() {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { performance: performance } = window;
    // Guard for old browsers, e.g. Safari <= v10, to avoid polluting Sentry with errors
    if (typeof performance.mark !== "function") return false;
    // Block sending a metric if tab has been backgrounded
    if (document.hidden || !performance.okayToSendMetrics) return false;
    return true;
}

});





parcelRegister("lM4y8", function(module, exports) {
$parcel$export(module.exports, "createResource", function () { return (parcelRequire("3kfkg")).createResource; });
$parcel$export(module.exports, "createRouterContext", function () { return (parcelRequire("kjtme")).createRouterContext; });
$parcel$export(module.exports, "createRouterSelector", function () { return (parcelRequire("4uXmK")).createRouterSelector; });
$parcel$export(module.exports, "Link", function () { return (parcelRequire("iPZCM")).default; });
$parcel$export(module.exports, "matchRoute", function () { return (parcelRequire("aF7fC")).default; });
$parcel$export(module.exports, "Redirect", function () { return (parcelRequire("jQl2W")).Redirect; });
$parcel$export(module.exports, "RouteComponent", function () { return (parcelRequire("cpagJ")).RouteComponent; });
$parcel$export(module.exports, "Router", function () { return (parcelRequire("e4G5V")).Router; });
$parcel$export(module.exports, "StaticRouter", function () { return (parcelRequire("cJdeW")).StaticRouter; });
$parcel$export(module.exports, "usePathParam", function () { return (parcelRequire("b7V6F")).usePathParam; });
$parcel$export(module.exports, "useQueryParam", function () { return (parcelRequire("b7V6F")).useQueryParam; });
$parcel$export(module.exports, "useRouter", function () { return (parcelRequire("b7V6F")).useRouter; });
$parcel$export(module.exports, "useRouterActions", function () { return (parcelRequire("b7V6F")).useRouterActions; });
$parcel$export(module.exports, "withRouter", function () { return (parcelRequire("gp8oT")).withRouter; });
$parcel$export(module.exports, "useResource", function () { return (parcelRequire("fM82h")).useResource; });
parcelRequire("7hcP7");parcelRequire("fM82h");

});
parcelRegister("7hcP7", function(module, exports) {

$parcel$export(module.exports, "Router", function () { return (parcelRequire("e4G5V")).Router; });
$parcel$export(module.exports, "StaticRouter", function () { return (parcelRequire("cJdeW")).StaticRouter; });
$parcel$export(module.exports, "Redirect", function () { return (parcelRequire("jQl2W")).Redirect; });
$parcel$export(module.exports, "withRouter", function () { return (parcelRequire("gp8oT")).withRouter; });
$parcel$export(module.exports, "useResource", function () { return (parcelRequire("2kz4a")).useResource; });
$parcel$export(module.exports, "useRouter", function () { return (parcelRequire("b7V6F")).useRouter; });
$parcel$export(module.exports, "useQueryParam", function () { return (parcelRequire("b7V6F")).useQueryParam; });
$parcel$export(module.exports, "usePathParam", function () { return (parcelRequire("b7V6F")).usePathParam; });
$parcel$export(module.exports, "createResource", function () { return (parcelRequire("3kfkg")).createResource; });
$parcel$export(module.exports, "useRouterActions", function () { return (parcelRequire("b7V6F")).useRouterActions; });
$parcel$export(module.exports, "createRouterSelector", function () { return (parcelRequire("4uXmK")).createRouterSelector; });
$parcel$export(module.exports, "RouteComponent", function () { return (parcelRequire("cpagJ")).RouteComponent; });
$parcel$export(module.exports, "Link", function () { return (parcelRequire("iPZCM")).default; });
$parcel$export(module.exports, "matchRoute", function () { return (parcelRequire("aF7fC")).default; });
$parcel$export(module.exports, "createRouterContext", function () { return (parcelRequire("kjtme")).createRouterContext; });

parcelRequire("3G5l7");
var $3kfkg = parcelRequire("3kfkg");
var $4uXmK = parcelRequire("4uXmK");
var $jQl2W = parcelRequire("jQl2W");
var $e4G5V = parcelRequire("e4G5V");
var $cJdeW = parcelRequire("cJdeW");
var $b7V6F = parcelRequire("b7V6F");
var $2kz4a = parcelRequire("2kz4a");
var $gp8oT = parcelRequire("gp8oT");
parcelRequire("5pvjw");
var $iPZCM = parcelRequire("iPZCM");
var $cpagJ = parcelRequire("cpagJ");
parcelRequire("1CNor");
var $kjtme = parcelRequire("kjtme");
var $aF7fC = parcelRequire("aF7fC");

});
parcelRegister("3G5l7", function(module, exports) {

$parcel$export(module.exports, "RouterSubscriber", function () { return (parcelRequire("scNmP")).RouterSubscriber; });
$parcel$export(module.exports, "Router", function () { return (parcelRequire("e4G5V")).Router; });
$parcel$export(module.exports, "StaticRouter", function () { return (parcelRequire("cJdeW")).StaticRouter; });
$parcel$export(module.exports, "Redirect", function () { return (parcelRequire("jQl2W")).Redirect; });
$parcel$export(module.exports, "withRouter", function () { return (parcelRequire("gp8oT")).withRouter; });
$parcel$export(module.exports, "useResource", function () { return (parcelRequire("2kz4a")).useResource; });
$parcel$export(module.exports, "useRouter", function () { return (parcelRequire("b7V6F")).useRouter; });
$parcel$export(module.exports, "useRouterActions", function () { return (parcelRequire("b7V6F")).useRouterActions; });
$parcel$export(module.exports, "useQueryParam", function () { return (parcelRequire("b7V6F")).useQueryParam; });
$parcel$export(module.exports, "usePathParam", function () { return (parcelRequire("b7V6F")).usePathParam; });
$parcel$export(module.exports, "createResource", function () { return (parcelRequire("3kfkg")).createResource; });
$parcel$export(module.exports, "createRouterSelector", function () { return (parcelRequire("4uXmK")).createRouterSelector; });
parcelRequire("1pGYT");
var $scNmP = parcelRequire("scNmP");

var $e4G5V = parcelRequire("e4G5V");

var $9jUAu = parcelRequire("9jUAu");

var $cJdeW = parcelRequire("cJdeW");

var $3YX7r = parcelRequire("3YX7r");

var $jQl2W = parcelRequire("jQl2W");

var $gp8oT = parcelRequire("gp8oT");
parcelRequire("ix8QB");
var $b7V6F = parcelRequire("b7V6F");
var $2kz4a = parcelRequire("2kz4a");

var $2DxmN = parcelRequire("2DxmN");

var $3kfkg = parcelRequire("3kfkg");

var $4uXmK = parcelRequire("4uXmK");

});
parcelRegister("1pGYT", function(module, exports) {

$parcel$export(module.exports, "RouterSubscriber", function () { return (parcelRequire("scNmP")).RouterSubscriber; });

var $iukYo = parcelRequire("iukYo");

var $scNmP = parcelRequire("scNmP");

});
parcelRegister("iukYo", function(module, exports) {

var $9nHZC = parcelRequire("9nHZC");

var $2kz4a = parcelRequire("2kz4a");
const $d75b4c250ff5e94e$export$fee1a6213543bd78 = ({ children: children, resource: resource, options: options })=>{
    const result = (0, $2kz4a.useResource)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, children(result));
};

});
parcelRegister("2kz4a", function(module, exports) {

$parcel$export(module.exports, "useResource", function () { return $1b28a6777bc3234c$export$9f6abfd74295843b; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $2DxmN = parcelRequire("2DxmN");

var $4uXmK = parcelRequire("4uXmK");

var $kdlrL = parcelRequire("kdlrL");
const $1b28a6777bc3234c$export$9f6abfd74295843b = (resource, options)=>{
    const [, actions] = (0, $2DxmN.useResourceActions)();
    const [, { getContext: getRouterContext }] = (0, $4uXmK.useRouterStoreStatic)(); // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $9nHZC.useMemo)(()=>(0, $kdlrL.createHook)((0, $4uXmK.RouterStore), {
            selector: ({ match: match, query: query, route: route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    const key = useKey(options == null ? void 0 : options.routerContext)[0];
    const [slice] = (0, $2DxmN.useResourceStore)({
        type: resource.type,
        key: key
    }); // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $9nHZC.useMemo)(()=>(options == null ? void 0 : options.routerContext) || getRouterContext(), [
        key
    ]);
    const update = (0, $9nHZC.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $9nHZC.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $9nHZC.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $9nHZC.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, slice), {}, {
        update: update,
        key: key,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    });
};

});
parcelRegister("2DxmN", function(module, exports) {

$parcel$export(module.exports, "getResourceStore", function () { return $1eb91b36deeb3381$export$6f6057d42352becb; });
$parcel$export(module.exports, "useResourceStore", function () { return $1eb91b36deeb3381$export$ac3608e0bb357c7; });
$parcel$export(module.exports, "useResourceActions", function () { return $1eb91b36deeb3381$export$aad2d56ed8b14bdf; });

var $fPPqr = parcelRequire("fPPqr");

var $j7eBO = parcelRequire("j7eBO");

var $fweAh = parcelRequire("fweAh");
var $kdlrL = parcelRequire("kdlrL");
var $cCv48 = parcelRequire("cCv48");
var $ahpbA = parcelRequire("ahpbA");
var $4xrnn = parcelRequire("4xrnn");

var $e8OEr = parcelRequire("e8OEr");
parcelRequire("cqlBF");
var $4DpPD = parcelRequire("4DpPD");
var $7aukZ = parcelRequire("7aukZ");
var $dB8KX = parcelRequire("dB8KX");
var $kWLNy = parcelRequire("kWLNy");
var $i9PIm = parcelRequire("i9PIm");
var $3ux2f = parcelRequire("3ux2f");
var $hJOjf = parcelRequire("hJOjf");
var $bEaAs = parcelRequire("bEaAs");
var $agkyk = parcelRequire("agkyk");
var $hqj5k = parcelRequire("hqj5k");
var $b00bj = parcelRequire("b00bj");
var $23quS = parcelRequire("23quS");
const $1eb91b36deeb3381$var$PREFETCH_MAX_AGE = 10000;
const $1eb91b36deeb3381$export$3f1be494d407b77a = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   */ clearResource: (resource, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $7aukZ.deleteResourceState)(type, key));
                dispatch((0, $4DpPD.executeForDependents)(resource, (dependentResource)=>$1eb91b36deeb3381$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $7aukZ.deleteResourceState)(type));
        },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState = getState(), { context: context } = _getState, resourceStoreState = (0, (/*@__PURE__*/$parcel$interopDefault($j7eBO)))(_getState, [
                "context"
            ]);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $e8OEr.getSliceForResource)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true // promise: existing value retained
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, prevSlice), changes), {}, {
                expiresAt: (0, $3ux2f.getExpiresAt)(maxAge),
                accessedAt: (0, $i9PIm.getAccessedAt)()
            });
            dispatch((0, $7aukZ.setResourceState)(type, key, newSlice)); // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $4DpPD.executeForDependents)(resource, (dependentResource)=>$1eb91b36deeb3381$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   */ getResource: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState2 = getState(), { context: context } = _getState2, resourceStoreState = (0, (/*@__PURE__*/$parcel$interopDefault($j7eBO)))(_getState2, [
                "context"
            ]);
            const key = getKey(routerStoreContext, context);
            let cached = (0, $e8OEr.getSliceForResource)(resourceStoreState, {
                type: type,
                key: key
            });
            if ((0, $hJOjf.shouldUseCache)(cached)) {
                if ((0, $hJOjf.isFromSsr)(cached)) {
                    const withResolvedPromise = (0, $bEaAs.setSsrDataPromise)(cached);
                    cached = (0, $3ux2f.setExpiresAt)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $i9PIm.getAccessedAt)();
                dispatch((0, $7aukZ.setResourceState)(type, key, cached));
                return cached;
            }
            return dispatch($1eb91b36deeb3381$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
   * Request a single resource and update the resource cache.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, getData: getData, maxAge: maxAge } = resource;
            const { prefetch: prefetch, timeout: timeout } = options;
            const _getState3 = getState(), { context: context } = _getState3, resourceStoreState = (0, (/*@__PURE__*/$parcel$interopDefault($j7eBO)))(_getState3, [
                "context"
            ]);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $e8OEr.getSliceForResource)(resourceStoreState, {
                type: type,
                key: key
            }); // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $23quS.validateLRUCache)(resource, key)); // hard errors in dependencies or getData are converted into softer async error
            let promiseOrData;
            try {
                promiseOrData = getData((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, routerStoreContext), {}, {
                    isPrefetch: !!prefetch,
                    dependencies: dispatch((0, $4DpPD.getDependencies)(resource, routerStoreContext))
                }), context);
            } catch (error) {
                promiseOrData = Promise.reject(error);
            }
            let resolvedSlice;
            if (promiseOrData === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // ensure the promise includes any timeout error
                const timeoutGuard = timeout ? (0, $kWLNy.generateTimeGuard)(timeout) : null;
                const promise = timeout ? Promise.race([
                    promiseOrData,
                    timeoutGuard == null ? void 0 : timeoutGuard.promise
                ]).then((maybeData)=>{
                    if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $agkyk.TimeoutError)(type);
                    (timeoutGuard == null ? void 0 : timeoutGuard.timerId) && clearTimeout(timeoutGuard.timerId);
                    return maybeData;
                }) : (0, $hqj5k.toPromise)(promiseOrData); // enter loading state
                dispatch((0, $7aukZ.setResourceState)(type, key, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, prevSlice), {}, {
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    promise: promise,
                    accessedAt: (0, $i9PIm.getAccessedAt)(),
                    // prevent resource from being cleaned prematurely and trigger more network requests.
                    expiresAt: options.prefetch ? (0, $3ux2f.getExpiresAt)($1eb91b36deeb3381$var$PREFETCH_MAX_AGE) : prevSlice.expiresAt
                }))); // trigger dependent resources to also load
                dispatch((0, $4DpPD.executeForDependents)(resource, (dependentResource)=>$1eb91b36deeb3381$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options))); // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    const data = await promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        // any existing error is cleared
                        loading: false,
                        promise: promise
                    };
                } catch (error) {
                    if (error instanceof (0, $agkyk.TimeoutError)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        // this condition cannot recover so must only be present in static/server router
                        promise: null // special case for timeout
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: false,
                        promise: promise
                    };
                }
            }
            const finalSlice = (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, (0, $e8OEr.getSliceForResource)(getState(), {
                type: type,
                key: key
            })), resolvedSlice), {}, {
                accessedAt: (0, $i9PIm.getAccessedAt)(),
                expiresAt: (0, $3ux2f.getExpiresAt)(options.prefetch && maxAge < $1eb91b36deeb3381$var$PREFETCH_MAX_AGE ? $1eb91b36deeb3381$var$PREFETCH_MAX_AGE : maxAge)
            });
            if (dispatch((0, $7aukZ.getResourceState)(type, key))) dispatch((0, $7aukZ.setResourceState)(type, key, finalSlice));
            return finalSlice;
        }
};
const $1eb91b36deeb3381$export$e324594224ef24da = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   * Execute such that dependencies on current route will be cleared.
   */ clearResource: (resource, routerStoreContext)=>(0, $4DpPD.actionWithDependencies)(routerStoreContext == null ? void 0 : routerStoreContext.route.resources, resource, $1eb91b36deeb3381$export$3f1be494d407b77a.clearResource(resource, routerStoreContext != null ? routerStoreContext : null)),
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   * Execute such that dependencies on current route will be updated.
   */ updateResourceState: (resource, routerStoreContext, ...args)=>(0, $4DpPD.actionWithDependencies)(routerStoreContext.route.resources, resource, $1eb91b36deeb3381$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, ...args)),
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   * Execute such that dependencies on current route will be updated.
   */ getResource: (resource, routerStoreContext, ...args)=>(0, $4DpPD.actionWithDependencies)(routerStoreContext.route.resources, resource, $1eb91b36deeb3381$export$3f1be494d407b77a.getResource(resource, routerStoreContext, ...args)),
    /**
   * Request a single resource and update the resource cache.
   * Execute such that dependencies on current route will be updated.
   */ getResourceFromRemote: (resource, routerStoreContext, ...args)=>(0, $4DpPD.actionWithDependencies)(routerStoreContext.route.resources, resource, $1eb91b36deeb3381$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, ...args)),
    /**
   * Request all resources.
   */ requestAllResources: (routerStoreContext, options)=>({ dispatch: dispatch })=>{
            const { route: route } = routerStoreContext || {};
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($1eb91b36deeb3381$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options || {})));
        },
    /**
   * Cleans expired resources and resets them back to their initial state.
   * We need to do this when transitioning into a route.
   */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $7aukZ.getResourceState)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $7aukZ.deleteResourceState)(type, key));
            });
        },
    /**
   * Requests a specific set of resources.
   */ requestResources: (resources, routerStoreContext, options)=>{
        var _routerStoreContext$r;
        const predicate = options.isStatic ? ({ isBrowserOnly: isBrowserOnly })=>!isBrowserOnly : ()=>true;
        return (0, $4DpPD.mapActionWithDependencies)((_routerStoreContext$r = routerStoreContext.route.resources) == null ? void 0 : _routerStoreContext$r.filter(predicate), resources.filter(predicate), (resource)=>$1eb91b36deeb3381$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
   * Hydrates the store with state.
   * Will not override pre-hydrated state.
   */ hydrate: ({ resourceData: resourceData, resourceContext: resourceContext })=>({ getState: getState, setState: setState })=>{
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $b00bj.transformData)(getNextStateValue(data, resourceData), (_ref)=>{
                let { error: error, expiresAt: expiresAt, loading: loading } = _ref, rest = (0, (/*@__PURE__*/$parcel$interopDefault($j7eBO)))(_ref, [
                    "error",
                    "expiresAt",
                    "loading"
                ]);
                const deserializedError = !error ? null : (0, $dB8KX.deserializeError)(error);
                const isTimeoutError = (deserializedError == null ? void 0 : deserializedError.name) === "TimeoutError";
                return (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest), {}, {
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                });
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
   * Gets the store's context
   */ getContext: ()=>({ getState: getState })=>getState().context,
    /**
   * Returns safe, portable and rehydratable data.
   */ getSafeData: ()=>({ getState: getState })=>(0, $b00bj.transformData)(getState().data, ({ data: data, key: key, error: error, loading: loading })=>({
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $dB8KX.serializeError)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $agkyk.TimeoutError) ? loading : false
                }))
};
const $1eb91b36deeb3381$export$94f50dade551bd01 = (0, $cCv48.createStore)({
    initialState: {
        data: {},
        context: {},
        executing: null
    },
    actions: $1eb91b36deeb3381$export$e324594224ef24da,
    name: "router-resources"
});
const $1eb91b36deeb3381$export$cc90fb9c37c5589d = (0, $fweAh.createContainer)($1eb91b36deeb3381$export$94f50dade551bd01, {
    displayName: "ResourceContainer"
});
const $1eb91b36deeb3381$export$303d1e2fcdeb1c96 = (0, $ahpbA.createSubscriber)($1eb91b36deeb3381$export$94f50dade551bd01, {
    selector: null
});
const $1eb91b36deeb3381$export$fee1a6213543bd78 = (0, $ahpbA.createSubscriber)($1eb91b36deeb3381$export$94f50dade551bd01, {
    displayName: "ResourceSelectorSubscriber",
    selector: (state, props)=>(0, $e8OEr.getSliceForResource)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $1eb91b36deeb3381$export$6f6057d42352becb = ()=>(0, $4xrnn.defaultRegistry).getStore($1eb91b36deeb3381$export$94f50dade551bd01);
const $1eb91b36deeb3381$export$ac3608e0bb357c7 = (0, $kdlrL.createHook)($1eb91b36deeb3381$export$94f50dade551bd01, {
    selector: (0, $e8OEr.getSliceForResource)
});
const $1eb91b36deeb3381$export$e59f52df235ac7b3 = (0, $kdlrL.createHook)($1eb91b36deeb3381$export$94f50dade551bd01, {
    selector: (0, $e8OEr.getResourceStoreContext)
});
const $1eb91b36deeb3381$export$aad2d56ed8b14bdf = (0, $kdlrL.createHook)($1eb91b36deeb3381$export$94f50dade551bd01, {
    selector: null
});

});
parcelRegister("fweAh", function(module, exports) {

$parcel$export(module.exports, "createContainer", function () { return $b4c52849e5e8fdc3$export$26ae5ca175b4ec5a; });

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");

var $50o9p = parcelRequire("50o9p");

var $9x1Bu = parcelRequire("9x1Bu");
var $4xrnn = parcelRequire("4xrnn");

var $jTyEF = parcelRequire("jTyEF");
const $b4c52849e5e8fdc3$var$_excluded = [
    "children",
    "scope",
    "isGlobal"
];
function $b4c52849e5e8fdc3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $b4c52849e5e8fdc3$var$noop = ()=>()=>{};
class $b4c52849e5e8fdc3$export$2e2bcd8739ae039 extends (0, $9nHZC.Component) {
    static getDerivedStateFromProps(nextProps, prevState) {
        const { scope: scope } = nextProps;
        const hasScopeChanged = scope !== prevState.scope;
        let nextState = null;
        if (hasScopeChanged) {
            const actions = prevState.bindContainerActions(scope);
            nextState = {
                scope: scope,
                scopedActions: actions
            };
        } // We trigger the action here so subscribers get new values ASAP
        prevState.triggerContainerAction(nextProps);
        return nextState;
    }
    constructor(_props, context){
        super(_props, context);
        this.registry = new (0, $4xrnn.StoreRegistry)("__local__");
        this.scopedHooks = {};
        this.bindContainerActions = (scope)=>{
            const { storeType: storeType, hooks: hooks } = this.constructor;
            const { api: api } = this.state; // we explicitly pass scope as it might be changed
            const { storeState: storeState } = api.getStore(storeType, scope);
            const actions = (0, $9x1Bu.bindActions)(storeType.actions, storeState, this.getContainerProps);
            this.scopedHooks = (0, $9x1Bu.bindActions)(hooks, storeState, this.getContainerProps, actions); // make sure we also reset actionProps
            this.actionProps = null;
            return actions;
        };
        this.triggerContainerAction = (nextProps)=>{
            const nextActionProps = this.filterActionProps(nextProps);
            const prevActionProps = this.actionProps;
            if ((0, $jTyEF.default)(prevActionProps, nextActionProps)) return; // store restProps on instance so we can diff and use fresh props
            // in actions even before react sets them in this.props
            this.actionProps = nextActionProps;
            if (this.scopedHooks.onInit) {
                this.scopedHooks.onInit();
                this.scopedHooks.onInit = null;
            } else this.scopedHooks.onUpdate();
        };
        this.filterActionProps = (props)=>{
            // eslint-disable-next-line no-unused-vars
            const restProps = $b4c52849e5e8fdc3$var$_objectWithoutPropertiesLoose(props, $b4c52849e5e8fdc3$var$_excluded);
            return restProps;
        };
        this.getContainerProps = ()=>this.actionProps;
        const { globalRegistry: // These fallbacks are needed only to make enzyme shallow work
        // as it does not fully support provider-less Context enzyme#1553
        globalRegistry = (0, $4xrnn.defaultRegistry), getStore: _getStore = (0, $4xrnn.defaultRegistry).getStore } = this.context;
        this.state = {
            api: {
                globalRegistry: globalRegistry,
                getStore: (Store, scope)=>this.getScopedStore(Store, scope) || _getStore(Store)
            },
            // stored to make them available in getDerivedStateFromProps
            // as js context there is null https://github.com/facebook/react/issues/12612
            bindContainerActions: this.bindContainerActions,
            triggerContainerAction: this.triggerContainerAction,
            scope: _props.scope
        };
        this.state.scopedActions = this.bindContainerActions(_props.scope);
    }
    componentDidUpdate(prevProps) {
        if (this.props.scope !== prevProps.scope) {
            // Trigger a forced update on all subscribers
            // as render might have been blocked
            this.triggerScopeChange(prevProps.scope); // Check if instance has still subscribers, if not delete
            this.deleteScopedStore(prevProps.scope);
        }
    }
    componentWillUnmount() {
        // schedule on next tick as this is called by React before useEffect cleanup
        // so if we run immediately listeners will still be there and run
        Promise.resolve().then(()=>{
            this.scopedHooks.onCleanup(); // Check if scope has still subscribers, if not delete
            this.deleteScopedStore();
        });
    }
    getRegistry() {
        const isLocal = !this.props.scope && !this.props.isGlobal;
        return isLocal ? this.registry : this.state.api.globalRegistry;
    }
    getScopedStore(Store, scopeId) {
        if (scopeId === void 0) scopeId = this.props.scope;
        const { storeType: storeType } = this.constructor;
        if (Store !== storeType) return null;
        const { storeState: storeState } = this.getRegistry().getStore(Store, scopeId); // instead of returning global bound actions
        // we return the ones with the countainer props binding
        return {
            storeState: storeState,
            actions: this.state.scopedActions
        };
    }
    triggerScopeChange(prevScopeId) {
        const { storeType: storeType } = this.constructor;
        const previous = this.getScopedStore(storeType, prevScopeId); // When called, subscribers that have already re-rendered with the new
        // scope are no longer subscribed to the old one, so we "force update"
        // the remaining.
        // This is sub-optimal as if there are other containers with the same
        // old scope id we will re-render those too, but better than using context
        // as that will re-render all children even if pure/memo
        previous.storeState.notify();
    }
    deleteScopedStore(scopeId) {
        if (scopeId === void 0) scopeId = this.props.scope;
        const { storeType: storeType } = this.constructor;
        const { storeState: storeState } = this.getScopedStore(storeType, scopeId);
        if (scopeId != null && !storeState.listeners().length) this.getRegistry().deleteStore(storeType, scopeId);
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $50o9p.Context).Provider, {
            value: this.state.api
        }, children);
    }
}
$b4c52849e5e8fdc3$export$2e2bcd8739ae039.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).node,
    scope: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).string,
    isGlobal: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).bool
};
$b4c52849e5e8fdc3$export$2e2bcd8739ae039.storeType = null;
$b4c52849e5e8fdc3$export$2e2bcd8739ae039.hooks = null;
$b4c52849e5e8fdc3$export$2e2bcd8739ae039.contextType = (0, $50o9p.Context);
function $b4c52849e5e8fdc3$export$26ae5ca175b4ec5a(Store, _temp) {
    var _class;
    let { onInit: onInit = $b4c52849e5e8fdc3$var$noop, onUpdate: onUpdate = $b4c52849e5e8fdc3$var$noop, onCleanup: onCleanup = $b4c52849e5e8fdc3$var$noop, displayName: displayName = "" } = _temp === void 0 ? {} : _temp;
    return _class = class extends $b4c52849e5e8fdc3$export$2e2bcd8739ae039 {
    }, _class.storeType = Store, _class.displayName = displayName || `Container(${Store.key.split("__")[0]})`, _class.hooks = {
        onInit: onInit,
        onUpdate: onUpdate,
        onCleanup: onCleanup
    }, _class;
}

});
parcelRegister("50o9p", function(module, exports) {

$parcel$export(module.exports, "Context", function () { return $3a4fafb2e7a87d9a$export$841858b892ce1f4c; });

var $9nHZC = parcelRequire("9nHZC");

var $4xrnn = parcelRequire("4xrnn");
const $3a4fafb2e7a87d9a$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createContext({
    globalRegistry: (0, $4xrnn.defaultRegistry),
    getStore: (0, $4xrnn.defaultRegistry).getStore
}, ()=>0);

});
parcelRegister("4xrnn", function(module, exports) {

$parcel$export(module.exports, "StoreRegistry", function () { return $34df7ac9da127f70$export$acb47f32da33501e; });
$parcel$export(module.exports, "defaultRegistry", function () { return $34df7ac9da127f70$export$9d726ae4880b1060; });

var $9x1Bu = parcelRequire("9x1Bu");

var $7fMkZ = parcelRequire("7fMkZ");
const $34df7ac9da127f70$export$e4d628ba0054221b = "__global__";
class $34df7ac9da127f70$export$acb47f32da33501e {
    constructor(defaultScope){
        var _this = this;
        if (defaultScope === void 0) defaultScope = $34df7ac9da127f70$export$e4d628ba0054221b;
        this.stores = new Map();
        this.initStore = (key, Store)=>{
            const { initialState: initialState, actions: actions } = Store;
            const storeState = (0, $7fMkZ.default)(key, initialState);
            const boundActions = (0, $9x1Bu.bindActions)(actions, storeState);
            const store = {
                storeState: storeState,
                actions: boundActions
            };
            this.stores.set(key, store);
            return store;
        };
        this.getStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.get(key) || _this.initStore(key, Store);
        };
        this.deleteStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            _this.stores.delete(key);
        };
        this.generateKey = (Store, scopeId)=>`${Store.key}@${scopeId}`;
        this.defaultScope = defaultScope;
    }
}
const $34df7ac9da127f70$export$9d726ae4880b1060 = new $34df7ac9da127f70$export$acb47f32da33501e();

});
parcelRegister("9x1Bu", function(module, exports) {

$parcel$export(module.exports, "bindActions", function () { return $6f08708ec9e36131$export$5ee1d46cd0883a22; });

var $ip2d0 = parcelRequire("ip2d0");
const $6f08708ec9e36131$var$namedMutator = (storeState, actionName)=>function() {
        storeState.mutator.actionName = actionName;
        return storeState.mutator(...arguments);
    };
const $6f08708ec9e36131$var$warnings = new WeakMap();
const $6f08708ec9e36131$export$5f944353e69b9bf3 = function bindAction(storeState, actionFn, actionKey, getContainerProps, boundActions) {
    if (getContainerProps === void 0) getContainerProps = ()=>{};
    if (boundActions === void 0) boundActions = {};
    // Setting mutator name so we can log action name for better debuggability
    const dispatch = function dispatch(thunkFn, actionName) {
        if (actionName === void 0) actionName = `${actionKey}.dispatch`;
        return thunkFn({
            setState: (0, $ip2d0.default).devtools ? $6f08708ec9e36131$var$namedMutator(storeState, actionName) : storeState.mutator,
            getState: storeState.getState,
            get actions () {
                if (!$6f08708ec9e36131$var$warnings.has(actionFn)) $6f08708ec9e36131$var$warnings.set(actionFn, console.warn(`react-sweet-state 'actions' property has been deprecated and will be removed in the next mayor. ` + `Please check action '${actionName}' of Store '${storeState.key}' and use 'dispatch' instead`));
                return boundActions;
            },
            dispatch: dispatch
        }, getContainerProps());
    };
    return function() {
        return dispatch(actionFn(...arguments), actionKey);
    };
};
const $6f08708ec9e36131$export$5ee1d46cd0883a22 = function bindActions(actions, storeState, getContainerProps, boundActions) {
    if (getContainerProps === void 0) getContainerProps = ()=>({});
    if (boundActions === void 0) boundActions = null;
    return Object.keys(actions).reduce((acc, k)=>{
        acc[k] = $6f08708ec9e36131$export$5f944353e69b9bf3(storeState, actions[k], k, getContainerProps, boundActions || acc);
        return acc;
    }, {});
};

});
parcelRegister("ip2d0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d65c466b898904e3$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");
const $d65c466b898904e3$var$defaultMutator = (prevState, partialState)=>{
    // Merge the partial state and the previous state.
    return Object.assign({}, prevState, partialState);
};
const $d65c466b898904e3$var$defaults = {
    batchUpdates: "useSyncExternalStore" in (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))),
    devtools: false,
    middlewares: new Set(),
    mutator: $d65c466b898904e3$var$defaultMutator
};
var $d65c466b898904e3$export$2e2bcd8739ae039 = $d65c466b898904e3$var$defaults;

});


parcelRegister("7fMkZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $547f6dee43ac9e5d$export$2e2bcd8739ae039; });

var $a5ZjX = parcelRequire("a5ZjX");

var $fNOfL = parcelRequire("fNOfL");

var $ip2d0 = parcelRequire("ip2d0");

var $8zho8 = parcelRequire("8zho8");
function $547f6dee43ac9e5d$var$createStoreState(key, initialState) {
    let listeners = [];
    let currentState = initialState;
    const storeState = {
        key: key,
        getState () {
            return currentState;
        },
        setState (nextState) {
            currentState = nextState; // Instead of notifying all hooks immediately, we wait next tick
            // so multiple actions affecting the same store gets combined
            (0, $8zho8.default)(storeState.notify);
        },
        resetState () {
            storeState.setState(initialState);
        },
        notify () {
            for(let i = 0; i < listeners.length; i++)listeners[i](storeState.getState());
        },
        subscribe (listener) {
            listeners = listeners.concat(listener);
            return function unsubscribe() {
                listeners = listeners.filter((fn)=>fn !== listener);
            };
        },
        listeners () {
            return listeners;
        }
    };
    storeState.mutator = (0, $a5ZjX.default)(storeState, (0, $ip2d0.default).middlewares);
    return storeState;
}
var $547f6dee43ac9e5d$export$2e2bcd8739ae039 = (0, $fNOfL.default)($547f6dee43ac9e5d$var$createStoreState);

});
parcelRegister("a5ZjX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7599f00b5398583e$export$2e2bcd8739ae039; });

var $ip2d0 = parcelRequire("ip2d0");

var $guX99 = parcelRequire("guX99");
const $7599f00b5398583e$var$applyMiddleware = (storeState, middlewares)=>Array.from(middlewares).concat((0, $guX99.default)).reduceRight((next, mw)=>mw(storeState)(next), (0, $ip2d0.default).mutator);
var $7599f00b5398583e$export$2e2bcd8739ae039 = $7599f00b5398583e$var$applyMiddleware;

});
parcelRegister("guX99", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c02d53fb5293672f$export$2e2bcd8739ae039; });

var $jTyEF = parcelRequire("jTyEF");
const $c02d53fb5293672f$var$updateMiddleware = (storeState)=>(next)=>(arg)=>{
            let output;
            const state = storeState.getState();
            const nextState = next(state, arg, (out)=>{
                output = out;
            });
            if (!(0, $jTyEF.default)(nextState, state)) storeState.setState(nextState);
            return output;
        };
var $c02d53fb5293672f$export$2e2bcd8739ae039 = $c02d53fb5293672f$var$updateMiddleware;

});
parcelRegister("jTyEF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7be091ae2246395$export$2e2bcd8739ae039; });
// Mostly copied from fbjs/packages/fbjs/src/core/shallowEqual.js
// enhanced with keys cache as might get called multiple times with same args
const $e7be091ae2246395$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $e7be091ae2246395$var$CACHE = new WeakMap();
function $e7be091ae2246395$export$2e2bcd8739ae039(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    if (Array.isArray(objA) && Array.isArray(objB)) {
        // do array comparison
        if (objA.length !== objB.length) return false;
        for(let i = 0; i < objA.length; i++){
            if (objA[i] !== objB[i]) return false;
        }
        return true;
    } else {
        // Handle Date, RegExp, String, Number, ... and complex objects
        const strA = "" + objA;
        const strB = "" + objB;
        if (strA !== strB || strA[0] === "[" && strA !== "[object Object]") return false;
         // do object comparison
        let keysA;
        if ($e7be091ae2246395$var$CACHE.has(objA)) keysA = $e7be091ae2246395$var$CACHE.get(objA);
        else {
            keysA = Object.keys(objA);
            $e7be091ae2246395$var$CACHE.set(objA, keysA);
        }
        let keysB;
        if ($e7be091ae2246395$var$CACHE.has(objB)) keysB = $e7be091ae2246395$var$CACHE.get(objB);
        else {
            keysB = Object.keys(objB);
            $e7be091ae2246395$var$CACHE.set(objB, keysB);
        }
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(let i = 0; i < keysA.length; i++){
            if (!$e7be091ae2246395$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
        }
        return true;
    }
}

});



parcelRegister("fNOfL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b81269db528d9827$export$2e2bcd8739ae039; });

var $ip2d0 = parcelRequire("ip2d0");
const $b81269db528d9827$var$connectDevTools = (storeState, config)=>{
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(Object.assign({
        name: `Store ${storeState.key}`,
        serialize: true
    }, config));
    devTools.init(storeState.getState());
    devTools.subscribe((message)=>{
        if (message.type === "DISPATCH") switch(message.payload.type){
            case "RESET":
                storeState.resetState();
                devTools.init(storeState.getState());
                return;
            case "COMMIT":
                devTools.init(storeState.getState());
                return;
            case "ROLLBACK":
                storeState.setState(JSON.parse(message.state));
                devTools.init(storeState.getState());
                return;
            case "JUMP_TO_STATE":
            case "JUMP_TO_ACTION":
                storeState.setState(JSON.parse(message.state));
                return;
        }
        else if (message.type === "ACTION") {
            let action = JSON.parse(message.payload);
            storeState.setState(action.payload);
        }
    });
    return devTools;
};
const $b81269db528d9827$var$withDevtools = (createStoreState)=>function() {
        const storeState = createStoreState(...arguments);
        if ((0, $ip2d0.default).devtools && window && window.__REDUX_DEVTOOLS_EXTENSION__) {
            const origMutator = storeState.mutator;
            let devTools;
            const devtoolMutator = (arg)=>{
                const result = origMutator(arg);
                try {
                    if (!devTools) {
                        const config = typeof (0, $ip2d0.default).devtools === "function" ? (0, $ip2d0.default).devtools(storeState) : {};
                        devTools = $b81269db528d9827$var$connectDevTools(storeState, config);
                    }
                    devTools.send({
                        type: storeState.mutator.actionName,
                        payload: arg
                    }, storeState.getState(), {}, storeState.key);
                } catch (err) {
                /* ignore devtools errors */ }
                return result;
            };
            storeState.mutator = devtoolMutator;
        }
        return storeState;
    };
var $b81269db528d9827$export$2e2bcd8739ae039 = $b81269db528d9827$var$withDevtools;

});

parcelRegister("8zho8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63cf148b51e8091e$export$2e2bcd8739ae039; });

var $ip2d0 = parcelRequire("ip2d0");

var $3TDoD = parcelRequire("3TDoD");

var $auh8s = parcelRequire("auh8s");
const $63cf148b51e8091e$var$QUEUE = [];
let $63cf148b51e8091e$var$scheduled;
function $63cf148b51e8091e$export$2e2bcd8739ae039(fn) {
    // if we are in node/tests or feature disabled, make updates sync batched
    if (!(0, $ip2d0.default).batchUpdates || !(0, $auh8s.default).scheduling()) return (0, $3TDoD.batch)(()=>fn()); // Add to queue if not already there
    // so we avoid multiple notifications to same store listeners
    if (!$63cf148b51e8091e$var$QUEUE.includes(fn)) $63cf148b51e8091e$var$QUEUE.push(fn); // if something already started schedule, skip
    if ($63cf148b51e8091e$var$scheduled) return;
    $63cf148b51e8091e$var$scheduled = (0, $3TDoD.batch)(()=>{
        let queueFn;
        while(queueFn = $63cf148b51e8091e$var$QUEUE.shift())queueFn();
        $63cf148b51e8091e$var$scheduled = null;
    });
}

});
parcelRegister("3TDoD", function(module, exports) {

$parcel$export(module.exports, "batch", function () { return $2d65116cf02c2884$export$712ea50be43a7858; });
/* eslint-disable import/no-unresolved */ 
var $lnOmc = parcelRequire("lnOmc");

var $wmpq0 = parcelRequire("wmpq0");

var $ip2d0 = parcelRequire("ip2d0");

var $auh8s = parcelRequire("auh8s");
let $2d65116cf02c2884$var$isInsideBatchedSchedule = false;
function $2d65116cf02c2884$export$712ea50be43a7858(fn) {
    // if we are in node/tests or nested schedule
    if (!(0, $ip2d0.default).batchUpdates || !(0, $auh8s.default).scheduling() || $2d65116cf02c2884$var$isInsideBatchedSchedule) return (0, $lnOmc.unstable_batchedUpdates)(fn);
    $2d65116cf02c2884$var$isInsideBatchedSchedule = true; // Use ImmediatePriority as it has -1ms timeout
    // https://github.com/facebook/react/blob/main/packages/scheduler/src/forks/Scheduler.js#L65
    return (0, $wmpq0.unstable_scheduleCallback)((0, $wmpq0.unstable_ImmediatePriority), function scheduleBatchedUpdates() {
        (0, $lnOmc.unstable_batchedUpdates)(fn);
        $2d65116cf02c2884$var$isInsideBatchedSchedule = false;
    });
}

});
parcelRegister("auh8s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a29ff7871cb3043$export$2e2bcd8739ae039; });
const $7a29ff7871cb3043$var$supports = {
    scheduling () {
        return typeof window !== "undefined" && typeof MessageChannel === "function";
    }
};
var $7a29ff7871cb3043$export$2e2bcd8739ae039 = $7a29ff7871cb3043$var$supports;

});







parcelRegister("kdlrL", function(module, exports) {

$parcel$export(module.exports, "createHook", function () { return $eb75a870e47b81ac$export$e7f733c8fc2b8a24; });
$parcel$export(module.exports, "createActionsHook", function () { return $eb75a870e47b81ac$export$7c643e1d6648e418; });
$parcel$export(module.exports, "createStateHook", function () { return $eb75a870e47b81ac$export$6e4e5611de132e85; });

var $9nHZC = parcelRequire("9nHZC");

var $1LFiK = parcelRequire("1LFiK");

var $50o9p = parcelRequire("50o9p");

var $7sVVW = parcelRequire("7sVVW");
const $eb75a870e47b81ac$var$EMPTY_SELECTOR = ()=>undefined;
const $eb75a870e47b81ac$var$DEFAULT_SELECTOR = (state)=>state;
function $eb75a870e47b81ac$export$e7f733c8fc2b8a24(Store, _temp) {
    let { selector: selector } = _temp === void 0 ? {} : _temp;
    return function useSweetState(propsArg) {
        const { getStore: getStore } = (0, $9nHZC.useContext)((0, $50o9p.Context));
        const { storeState: storeState, actions: actions } = getStore(Store);
        const hasPropsArg = propsArg !== undefined;
        const propsArgRef = (0, $9nHZC.useRef)(propsArg);
        propsArgRef.current = propsArg;
        const stateSelector = (0, $9nHZC.useMemo)(()=>selector ? (0, $7sVVW.getSelectorInstance)(selector, storeState, hasPropsArg) : selector === null ? $eb75a870e47b81ac$var$EMPTY_SELECTOR : $eb75a870e47b81ac$var$DEFAULT_SELECTOR, [
            hasPropsArg,
            storeState
        ]);
        const getSnapshot = (0, $9nHZC.useCallback)(()=>{
            const state = getStore(Store).storeState.getState();
            return stateSelector(state, propsArgRef.current);
        }, [
            getStore,
            stateSelector
        ]);
        const currentState = (0, $1LFiK.useSyncExternalStore)(storeState.subscribe, getSnapshot, getSnapshot);
        return [
            currentState,
            actions
        ];
    };
}
function $eb75a870e47b81ac$export$7c643e1d6648e418(Store) {
    const useHook = $eb75a870e47b81ac$export$e7f733c8fc2b8a24(Store, {
        selector: null
    });
    return function useSweetStateActions() {
        return useHook()[1];
    };
}
function $eb75a870e47b81ac$export$6e4e5611de132e85(Store, _temp2) {
    let { selector: selector } = _temp2 === void 0 ? {} : _temp2;
    const useHook = $eb75a870e47b81ac$export$e7f733c8fc2b8a24(Store, {
        selector: selector
    });
    return function useSweetStateState(propsArg) {
        return useHook(propsArg)[0];
    };
}

});
parcelRegister("1LFiK", function(module, exports) {
"use strict";

module.exports = (parcelRequire("40tWA"));

});
parcelRegister("40tWA", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $2eae63be3ce2d16d$export$306c0aa65ff9ec16; }, function (v) { return $2eae63be3ce2d16d$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2eae63be3ce2d16d$export$306c0aa65ff9ec16;
"use strict";

var $9nHZC = parcelRequire("9nHZC");
function $2eae63be3ce2d16d$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $2eae63be3ce2d16d$var$k = "function" === typeof Object.is ? Object.is : $2eae63be3ce2d16d$var$h, $2eae63be3ce2d16d$var$l = $9nHZC.useState, $2eae63be3ce2d16d$var$m = $9nHZC.useEffect, $2eae63be3ce2d16d$var$n = $9nHZC.useLayoutEffect, $2eae63be3ce2d16d$var$p = $9nHZC.useDebugValue;
function $2eae63be3ce2d16d$var$q(a, b) {
    var d = b(), f = $2eae63be3ce2d16d$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $2eae63be3ce2d16d$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $2eae63be3ce2d16d$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $2eae63be3ce2d16d$var$m(function() {
        $2eae63be3ce2d16d$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $2eae63be3ce2d16d$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $2eae63be3ce2d16d$var$p(d);
    return d;
}
function $2eae63be3ce2d16d$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$2eae63be3ce2d16d$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $2eae63be3ce2d16d$var$t(a, b) {
    return b();
}
var $2eae63be3ce2d16d$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $2eae63be3ce2d16d$var$t : $2eae63be3ce2d16d$var$q;
$2eae63be3ce2d16d$export$306c0aa65ff9ec16 = void 0 !== $9nHZC.useSyncExternalStore ? $9nHZC.useSyncExternalStore : $2eae63be3ce2d16d$var$u;

});


parcelRegister("7sVVW", function(module, exports) {

$parcel$export(module.exports, "createSelector", function () { return $56f8165408729df7$export$595d22ed68ca2841; });
$parcel$export(module.exports, "getSelectorInstance", function () { return $56f8165408729df7$export$38d24f3c60944dd5; });

var $elamJ = parcelRequire("elamJ");
function $56f8165408729df7$export$595d22ed68ca2841() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    const resultFunc = funcs.pop();
    const dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    const memoizedResultFunc = (0, $elamJ.default)(function() {
        return resultFunc.apply(null, arguments);
    }); // this memoisation is optimised for 2 arguments (state, props)
    const selector = (0, $elamJ.default)(function() {
        // calculate all dependencies results
        const params = [];
        for(let i = 0; i < dependencies.length; i++)params.push(dependencies[i].apply(null, arguments));
         // then call the final func with all them as arguments
        return memoizedResultFunc.apply(null, params);
    }, true); // expose so we can create per scope selectors
    // API compatible with reselect@^4
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    return selector;
}
function $56f8165408729df7$export$d2c200d79fc82f8c(selector) {
    const isReselector = typeof selector.resultFunc === "function" && Array.isArray(selector.dependencies);
    const dependencies = isReselector ? selector.dependencies : [
        (s)=>s,
        (_, p)=>p
    ];
    const resultFunc = isReselector ? selector.resultFunc : selector;
    return $56f8165408729df7$export$595d22ed68ca2841(dependencies, resultFunc);
}
const $56f8165408729df7$var$cache = new WeakMap();
function $56f8165408729df7$export$38d24f3c60944dd5(selector, storeState, hasProps) {
    if (!hasProps) {
        if (!$56f8165408729df7$var$cache.has(storeState)) $56f8165408729df7$var$cache.set(storeState, new WeakMap());
        const scopeSelectors = $56f8165408729df7$var$cache.get(storeState);
        if (!scopeSelectors.has(selector)) scopeSelectors.set(selector, $56f8165408729df7$export$d2c200d79fc82f8c(selector));
        return scopeSelectors.get(selector);
    }
    return $56f8165408729df7$export$d2c200d79fc82f8c(selector);
}

});
parcelRegister("elamJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a70b1143e2acd5f4$export$2e2bcd8739ae039; });

var $jTyEF = parcelRequire("jTyEF");
function $a70b1143e2acd5f4$var$exactEqual(objA, objB) {
    return objA === objB;
}
function $a70b1143e2acd5f4$var$areArgumentsEqual(propsMode, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false; // If propsMode and 2 arguments, means it is an input selector
    // and we check for shallow equality on 2nd one to optimise props
    if (propsMode && prev.length === 2) return prev[0] === next[0] && (0, $jTyEF.default)(prev[1], next[1]);
    for(let i = 0; i < prev.length; i++){
        if (!$a70b1143e2acd5f4$var$exactEqual(prev[i], next[i])) return false;
    }
    return true;
}
function $a70b1143e2acd5f4$export$2e2bcd8739ae039(resultFn, propsMode) {
    if (propsMode === void 0) propsMode = false;
    let lastArgs = [];
    let lastResult;
    let calledOnce = false;
    const result = function result() {
        if (calledOnce && $a70b1143e2acd5f4$var$areArgumentsEqual(propsMode, arguments, lastArgs)) return lastResult;
        const nextResult = resultFn.apply(this, arguments);
        if (!propsMode && (0, $jTyEF.default)(nextResult, lastResult)) return lastResult;
        lastResult = nextResult;
        calledOnce = true;
        lastArgs = arguments;
        return lastResult;
    };
    return result;
}

});



parcelRegister("cCv48", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $930121a117a537cf$export$f51a9068ac82ea43; });

var $4G6wI = parcelRequire("4G6wI");
function $930121a117a537cf$var$createKey(initialState, actions, name) {
    const src = !name ? Object.keys(actions).reduce((acc, k)=>acc + actions[k].toString(), "") : "";
    return [
        name,
        (0, $4G6wI.default)(src + JSON.stringify(initialState))
    ].filter(Boolean).join("__");
}
function $930121a117a537cf$export$f51a9068ac82ea43(_ref) {
    let { name: name = "", initialState: initialState, actions: actions } = _ref;
    let key;
    return {
        get key () {
            // lazy evaluate key on first access
            return key || (key = $930121a117a537cf$var$createKey(initialState, actions, name));
        },
        initialState: initialState,
        actions: actions
    };
}

});
parcelRegister("4G6wI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $368025bfce2a933c$export$2e2bcd8739ae039; });
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $368025bfce2a933c$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});


parcelRegister("ahpbA", function(module, exports) {

$parcel$export(module.exports, "createSubscriber", function () { return $77bf074b2d9b9c23$export$48f338a7e080595c; });

var $kdlrL = parcelRequire("kdlrL");
const $77bf074b2d9b9c23$var$_excluded = [
    "children"
];
function $77bf074b2d9b9c23$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $77bf074b2d9b9c23$var$hasAdditionalProps(props) {
    for(let i in props)return true;
    return false;
}
function $77bf074b2d9b9c23$export$48f338a7e080595c(Store, _temp) {
    let { selector: selector, displayName: displayName = "" } = _temp === void 0 ? {} : _temp;
    const useStore = (0, $kdlrL.createHook)(Store, {
        selector: selector
    });
    const Subscriber = function Subscriber(_ref) {
        let { children: children } = _ref, rest = $77bf074b2d9b9c23$var$_objectWithoutPropertiesLoose(_ref, $77bf074b2d9b9c23$var$_excluded);
        const api = useStore($77bf074b2d9b9c23$var$hasAdditionalProps(rest) ? rest : undefined);
        return children(...api);
    };
    Subscriber.displayName = displayName || `Subscriber(${Store.key.split("__")[0]})`;
    return Subscriber;
}

});

parcelRegister("e8OEr", function(module, exports) {

$parcel$export(module.exports, "getSliceForResource", function () { return $02a825961b1d3419$export$c9ed509724feb827; });
$parcel$export(module.exports, "getResourceStoreContext", function () { return $02a825961b1d3419$export$6a0b1779210de0ee; });

var $fPPqr = parcelRequire("fPPqr");
parcelRequire("cqlBF");
var $7ivYH = parcelRequire("7ivYH");
const $02a825961b1d3419$export$c9ed509724feb827 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    return slice ? (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, slice) : (0, $7ivYH.getDefaultStateSlice)();
};
const $02a825961b1d3419$export$6a0b1779210de0ee = (state)=>state.context;

});
parcelRegister("cqlBF", function(module, exports) {

$parcel$export(module.exports, "shouldUseCache", function () { return (parcelRequire("hJOjf")).shouldUseCache; });
$parcel$export(module.exports, "isFromSsr", function () { return (parcelRequire("hJOjf")).isFromSsr; });
$parcel$export(module.exports, "getDefaultStateSlice", function () { return (parcelRequire("7ivYH")).getDefaultStateSlice; });
$parcel$export(module.exports, "getExpiresAt", function () { return (parcelRequire("3ux2f")).getExpiresAt; });
$parcel$export(module.exports, "setExpiresAt", function () { return (parcelRequire("3ux2f")).setExpiresAt; });
$parcel$export(module.exports, "getAccessedAt", function () { return (parcelRequire("i9PIm")).getAccessedAt; });
$parcel$export(module.exports, "getResourcesForNextLocation", function () { return (parcelRequire("W67ZN")).getResourcesForNextLocation; });
$parcel$export(module.exports, "generateTimeGuard", function () { return (parcelRequire("kWLNy")).generateTimeGuard; });
$parcel$export(module.exports, "serializeError", function () { return (parcelRequire("dB8KX")).serializeError; });
$parcel$export(module.exports, "deserializeError", function () { return (parcelRequire("dB8KX")).deserializeError; });
$parcel$export(module.exports, "transformData", function () { return (parcelRequire("b00bj")).transformData; });
$parcel$export(module.exports, "TimeoutError", function () { return (parcelRequire("agkyk")).TimeoutError; });
$parcel$export(module.exports, "setSsrDataPromise", function () { return (parcelRequire("bEaAs")).setSsrDataPromise; });
$parcel$export(module.exports, "validateLRUCache", function () { return (parcelRequire("23quS")).validateLRUCache; });
$parcel$export(module.exports, "deleteResourceState", function () { return (parcelRequire("7aukZ")).deleteResourceState; });
$parcel$export(module.exports, "getResourceState", function () { return (parcelRequire("7aukZ")).getResourceState; });
$parcel$export(module.exports, "setResourceState", function () { return (parcelRequire("7aukZ")).setResourceState; });
$parcel$export(module.exports, "actionWithDependencies", function () { return (parcelRequire("4DpPD")).actionWithDependencies; });
$parcel$export(module.exports, "mapActionWithDependencies", function () { return (parcelRequire("4DpPD")).mapActionWithDependencies; });
$parcel$export(module.exports, "executeForDependents", function () { return (parcelRequire("4DpPD")).executeForDependents; });
$parcel$export(module.exports, "getDependencies", function () { return (parcelRequire("4DpPD")).getDependencies; });
$parcel$export(module.exports, "toPromise", function () { return (parcelRequire("hqj5k")).toPromise; });

var $hJOjf = parcelRequire("hJOjf");

var $7ivYH = parcelRequire("7ivYH");

var $3ux2f = parcelRequire("3ux2f");

var $i9PIm = parcelRequire("i9PIm");

var $4GoJg = parcelRequire("4GoJg");

var $W67ZN = parcelRequire("W67ZN");

var $kWLNy = parcelRequire("kWLNy");

var $dB8KX = parcelRequire("dB8KX");

var $b00bj = parcelRequire("b00bj");

var $iEV4O = parcelRequire("iEV4O");

var $agkyk = parcelRequire("agkyk");

var $bEaAs = parcelRequire("bEaAs");

var $23quS = parcelRequire("23quS");

var $7aukZ = parcelRequire("7aukZ");

var $4DpPD = parcelRequire("4DpPD");

var $hqj5k = parcelRequire("hqj5k");

});
parcelRegister("hJOjf", function(module, exports) {

$parcel$export(module.exports, "isFromSsr", function () { return $ce9daa0af75840aa$export$b25d2963b8a3488a; });
$parcel$export(module.exports, "shouldUseCache", function () { return $ce9daa0af75840aa$export$399de8c43d0ece3c; });
const $ce9daa0af75840aa$export$b25d2963b8a3488a = ({ expiresAt: expiresAt })=>expiresAt === null;
const $ce9daa0af75840aa$var$isFresh = (resource)=>{
    if ($ce9daa0af75840aa$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $ce9daa0af75840aa$export$399de8c43d0ece3c = (resource)=>{
    var _resource$error;
    if ((resource == null ? void 0 : (_resource$error = resource.error) == null ? void 0 : _resource$error.name) === "TimeoutError") return false;
    if (resource.loading) return true;
    if ($ce9daa0af75840aa$var$isFresh(resource)) return true;
    return false;
};

});

parcelRegister("7ivYH", function(module, exports) {

$parcel$export(module.exports, "getDefaultStateSlice", function () { return $550304fcf423d88f$export$fa8e33c3301e2e94; });

var $fPPqr = parcelRequire("fPPqr");

var $8hQ51 = parcelRequire("8hQ51");

var $3ux2f = parcelRequire("3ux2f");

var $i9PIm = parcelRequire("i9PIm");
const $550304fcf423d88f$export$fa8e33c3301e2e94 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, (0, $8hQ51.BASE_DEFAULT_STATE_SLICE)), {}, {
        expiresAt: (0, $3ux2f.getExpiresAt)((0, $8hQ51.DEFAULT_RESOURCE_MAX_AGE)),
        accessedAt: (0, $i9PIm.getAccessedAt)()
    });

});
parcelRegister("8hQ51", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RESOURCE_MAX_AGE", function () { return $60884f49084255cf$export$12c1dc38ea1692da; });
$parcel$export(module.exports, "DEFAULT_CACHE_MAX_LIMIT", function () { return $60884f49084255cf$export$881d135f98d8d7d0; });
$parcel$export(module.exports, "DEFAULT_RESOURCE_BROWSER_ONLY", function () { return $60884f49084255cf$export$9ab5bdcb8a1d6c34; });
$parcel$export(module.exports, "BASE_DEFAULT_STATE_SLICE", function () { return $60884f49084255cf$export$2df85a734ff5ed27; });
const $60884f49084255cf$export$12c1dc38ea1692da = 0;
const $60884f49084255cf$export$881d135f98d8d7d0 = 100;
const $60884f49084255cf$export$9ab5bdcb8a1d6c34 = false;
const $60884f49084255cf$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};

});

parcelRegister("3ux2f", function(module, exports) {

$parcel$export(module.exports, "getExpiresAt", function () { return $28adcc8e661dad7b$export$b65d7ba7fbf150f1; });
$parcel$export(module.exports, "setExpiresAt", function () { return $28adcc8e661dad7b$export$18d1d420fd588368; });

var $fPPqr = parcelRequire("fPPqr");
const $28adcc8e661dad7b$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $28adcc8e661dad7b$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, slice), {}, {
        expiresAt: $28adcc8e661dad7b$export$b65d7ba7fbf150f1(maxAge)
    }) : slice;

});

parcelRegister("i9PIm", function(module, exports) {

$parcel$export(module.exports, "getAccessedAt", function () { return $d3812ead925dd9bb$export$9ccb639b7a119f61; });
const $d3812ead925dd9bb$export$9ccb639b7a119f61 = ()=>Date.now();

});


parcelRegister("4GoJg", function(module, exports) {

$parcel$export(module.exports, "getResourceIdentifier", function () { return $368e4455adec2941$export$c616b176adf9ad4a; });
$parcel$export(module.exports, "getResourceIdentifiers", function () { return $368e4455adec2941$export$cd7fbe7e979df558; });
const $368e4455adec2941$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $368e4455adec2941$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$368e4455adec2941$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));

});

parcelRegister("W67ZN", function(module, exports) {

$parcel$export(module.exports, "getResourcesForNextLocation", function () { return $0aea2bc7b1cacba1$export$7cbbc763e2f3d65d; });

var $4GoJg = parcelRequire("4GoJg");

var $iEV4O = parcelRequire("iEV4O");
const $0aea2bc7b1cacba1$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $iEV4O.routeHasResources)(nextRoute)) return [];
    if ((0, $iEV4O.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $4GoJg.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $4GoJg.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};

});
parcelRegister("iEV4O", function(module, exports) {

$parcel$export(module.exports, "routeHasResources", function () { return $d9583ca1503e1f08$export$740886389191c640; });
$parcel$export(module.exports, "routeHasChanged", function () { return $d9583ca1503e1f08$export$221027ff1aa38f82; });
const $d9583ca1503e1f08$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $d9583ca1503e1f08$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;

});


parcelRegister("kWLNy", function(module, exports) {

$parcel$export(module.exports, "generateTimeGuard", function () { return $f3fe4d2e1560daf4$export$58634b3a58ae66b7; });
const $f3fe4d2e1560daf4$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};

});

parcelRegister("dB8KX", function(module, exports) {

$parcel$export(module.exports, "serializeError", function () { return $9e6585e98d45c512$export$46ff38bc6bdea8fb; });
$parcel$export(module.exports, "deserializeError", function () { return $9e6585e98d45c512$export$64cddc1e268e9046; });
// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $9e6585e98d45c512$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = "NonError";
        if (Error.captureStackTrace) Error.captureStackTrace(this, $9e6585e98d45c512$var$NonError);
    }
}
const $9e6585e98d45c512$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
const $9e6585e98d45c512$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === "function") continue;
        if (!value || typeof value !== "object") {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $9e6585e98d45c512$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = "[Circular]";
    }
    for (const property of $9e6585e98d45c512$var$commonProperties)if (typeof from[property] === "string") to[property] = from[property];
    return to;
}; // const serializeError = <ErrorType = any>(value: ErrorType) => {
const $9e6585e98d45c512$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === "object" && value !== null) return $9e6585e98d45c512$var$destroyCircular(value, []);
     // People sometimes throw things besides Error objects…
    if (typeof value === "function") // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || "anonymous"}]`;
    return value;
};
const $9e6585e98d45c512$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $9e6585e98d45c512$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $9e6585e98d45c512$var$NonError(value);
};

});

parcelRegister("b00bj", function(module, exports) {

$parcel$export(module.exports, "transformData", function () { return $801fd5d1b6be1ce3$export$3ceb62baab058c6b; });
const $801fd5d1b6be1ce3$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});

});

parcelRegister("agkyk", function(module, exports) {

$parcel$export(module.exports, "TimeoutError", function () { return $778b575da7ce8c57$export$66d311bf29d5c89c; });
class $778b575da7ce8c57$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super("Resource timed out: " + message);
        this.name = "TimeoutError";
    }
}

});

parcelRegister("bEaAs", function(module, exports) {

$parcel$export(module.exports, "setSsrDataPromise", function () { return $87aba4792afcebf4$export$2e4da1b414980956; });

var $fPPqr = parcelRequire("fPPqr");
const $87aba4792afcebf4$export$2e4da1b414980956 = (slice)=>slice.promise === null ? (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, slice), {}, {
        promise: Promise.resolve(slice.data)
    }) : slice;

});

parcelRegister("23quS", function(module, exports) {

$parcel$export(module.exports, "validateLRUCache", function () { return $17f06a51cb272870$export$89440b7623c2c75c; });

var $7aukZ = parcelRequire("7aukZ");
const $17f06a51cb272870$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $17f06a51cb272870$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $17f06a51cb272870$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $17f06a51cb272870$export$89440b7623c2c75c = (resource, key)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $17f06a51cb272870$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $7aukZ.deleteResourceState)(type, keyTobeDeleted));
    };

});
parcelRegister("7aukZ", function(module, exports) {

$parcel$export(module.exports, "setResourceState", function () { return $5380ffff899f776d$export$704f800f263b050e; });
$parcel$export(module.exports, "getResourceState", function () { return $5380ffff899f776d$export$5fc90c33b03fffb; });
$parcel$export(module.exports, "deleteResourceState", function () { return $5380ffff899f776d$export$d40f35dc5952864b; });

var $j7eBO = parcelRequire("j7eBO");

var $fPPqr = parcelRequire("fPPqr");
function $5380ffff899f776d$var$_toPropertyKey(arg) {
    var key = $5380ffff899f776d$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $5380ffff899f776d$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
const $5380ffff899f776d$export$704f800f263b050e = (type, key, state)=>({ setState: setState, getState: getState })=>{
        const { data: data } = getState();
        setState({
            data: (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, data), {}, {
                [type]: (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, data[type] || {}), {}, {
                    [key]: state
                })
            })
        });
    };
const $5380ffff899f776d$export$5fc90c33b03fffb = (type, key)=>({ getState: getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType == null ? void 0 : resourceDataForType[key];
    };
const $5380ffff899f776d$export$d40f35dc5952864b = (type, key)=>({ getState: getState, setState: setState })=>{
        const { data: data } = getState();
        const { [type]: resourceForType } = data, remainingData = (0, (/*@__PURE__*/$parcel$interopDefault($j7eBO)))(data, [
            type
        ].map($5380ffff899f776d$var$_toPropertyKey));
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const remainingForType = (0, (/*@__PURE__*/$parcel$interopDefault($j7eBO)))(resourceForType, [
                key
            ].map($5380ffff899f776d$var$_toPropertyKey));
            setState({
                data: (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, remainingData), {}, {
                    [type]: remainingForType
                })
            });
        }
    };

});


parcelRegister("4DpPD", function(module, exports) {

$parcel$export(module.exports, "actionWithDependencies", function () { return $35fed795d72ca903$export$5f7e1fd85734e71e; });
$parcel$export(module.exports, "mapActionWithDependencies", function () { return $35fed795d72ca903$export$f71a65c89c987a02; });
$parcel$export(module.exports, "executeForDependents", function () { return $35fed795d72ca903$export$7d1ffac63c68405d; });
$parcel$export(module.exports, "getDependencies", function () { return $35fed795d72ca903$export$75915f81f2a6540a; });

var $e8OEr = parcelRequire("e8OEr");
var $35fed795d72ca903$var$_Object$fromEntries;
const $35fed795d72ca903$var$fromEntries = ($35fed795d72ca903$var$_Object$fromEntries = Object.fromEntries) != null ? $35fed795d72ca903$var$_Object$fromEntries : (entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        })));
const $35fed795d72ca903$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $35fed795d72ca903$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = "ResourceDependencyError";
    }
}
const $35fed795d72ca903$export$12600f2e0e7fb2cc = (routeResources, tuples)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _routeResources$some;
        if (getState().executing) throw new Error("execution is already in progress");
         // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = (_routeResources$some = routeResources == null ? void 0 : routeResources.some(({ depends: depends })=>depends == null ? void 0 : depends.length)) != null ? _routeResources$some : false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
         // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources == null ? void 0 : routeResources.some($35fed795d72ca903$var$matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
         // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        const [dependentTypes] = routeResources.reduce((acc, { type: type, depends: depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!(depends == null ? void 0 : depends.some((dependency)=>executableTypes.includes(dependency)));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type: type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i); // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type: type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
         // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        const dependentAndDependencyTypes = routeResources.filter(({ type: type })=>dependentTypes.includes(type)).reduce((acc, { type: type, depends: depends })=>depends ? [
                ...acc,
                ...depends,
                type
            ] : [
                ...acc,
                type
            ], []).filter((v, i, a)=>a.indexOf(v) === i); // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        const executingTuples = routeResources.filter(({ type: type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>{
            var _tuples$find;
            return (_tuples$find = tuples.find($35fed795d72ca903$var$matchType(resource))) != null ? _tuples$find : [
                resource,
                null
            ];
        });
        setState({
            executing: executingTuples
        }); // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            var _getState$executing;
            const latestTuple = (_getState$executing = getState().executing) == null ? void 0 : _getState$executing[i];
            const [{ type: latestType }, maybeAction] = latestTuple != null ? latestTuple : [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error("execution reached an inconsistent state");
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        }); // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex($35fed795d72ca903$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $35fed795d72ca903$export$5f7e1fd85734e71e = (routeResources, resource, action)=>({ dispatch: dispatch })=>dispatch($35fed795d72ca903$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const $35fed795d72ca903$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$35fed795d72ca903$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $35fed795d72ca903$export$7d1ffac63c68405d = (resource, actionCreator)=>({ getState: getState, setState: setState })=>{
        var _tuples$findIndex;
        const { executing: tuples } = getState(); // find the given resource in the currently executing tuples
        const indexForResource = (_tuples$findIndex = tuples == null ? void 0 : tuples.findIndex($35fed795d72ca903$var$matchType(resource))) != null ? _tuples$findIndex : -1;
        if (indexForResource < 0) return;
         // find dependent resources following given resource and revise their action
        const executing = tuples.map((tuple, i)=>{
            var _tupleResource$depend;
            const [tupleResource] = tuple;
            return i > indexForResource && ((_tupleResource$depend = tupleResource.depends) == null ? void 0 : _tupleResource$depend.includes(resource.type)) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $35fed795d72ca903$export$75915f81f2a6540a = (resource, routerStoreContext)=>({ getState: getState })=>{
        var _tuples$findIndex2;
        const { type: type, depends: depends } = resource; // optimise the case of no dependencies
        if (!(depends == null ? void 0 : depends.length)) return {};
        const { executing: tuples, data: data, context: resourceStoreContext } = getState(); // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = (_tuples$findIndex2 = tuples == null ? void 0 : tuples.findIndex($35fed795d72ca903$var$matchType(resource))) != null ? _tuples$findIndex2 : -1;
        if (indexForResource < 0) throw new $35fed795d72ca903$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
         // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map((dependency)=>[
                dependency,
                tuples.findIndex($35fed795d72ca903$var$matchType({
                    type: dependency
                }))
            ]); // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new $35fed795d72ca903$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $35fed795d72ca903$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $35fed795d72ca903$var$fromEntries(dependencyIndexTuples.map(([dependency, index])=>{
            const [{ getKey: getKey }] = tuples[index];
            return [
                dependency,
                (0, $e8OEr.getSliceForResource)({
                    data: data
                }, {
                    type: dependency,
                    key: getKey(routerStoreContext, resourceStoreContext)
                })
            ];
        }));
    };

});

parcelRegister("hqj5k", function(module, exports) {

$parcel$export(module.exports, "toPromise", function () { return $caf3ab3b0d445708$export$4dbaaf6c79705e6c; });
const $caf3ab3b0d445708$export$4dbaaf6c79705e6c = (candidate)=>candidate instanceof Promise ? candidate : Promise.resolve(candidate);

});




parcelRegister("4uXmK", function(module, exports) {

$parcel$export(module.exports, "RouterStore", function () { return $34680393ffccbb07$export$1cf0ecab63b1963c; });
$parcel$export(module.exports, "RouterContainer", function () { return $34680393ffccbb07$export$d6b817abe7a77ea5; });
$parcel$export(module.exports, "RouterSubscriber", function () { return $34680393ffccbb07$export$672d721d310ff5f0; });
$parcel$export(module.exports, "RouterActionsSubscriber", function () { return $34680393ffccbb07$export$afda200b5577e7bf; });
$parcel$export(module.exports, "useRouterStore", function () { return $34680393ffccbb07$export$9569010eab09ae9e; });
$parcel$export(module.exports, "useRouterStoreStatic", function () { return $34680393ffccbb07$export$dce62b3e98a54741; });
$parcel$export(module.exports, "createRouterSelector", function () { return $34680393ffccbb07$export$95ab46bba7ea7a22; });
$parcel$export(module.exports, "getRouterStore", function () { return $34680393ffccbb07$export$5ccad187366c8494; });
$parcel$export(module.exports, "getRouterState", function () { return $34680393ffccbb07$export$ebf37f7e180b13a9; });

var $fPPqr = parcelRequire("fPPqr");

var $j7eBO = parcelRequire("j7eBO");

var $3TDoD = parcelRequire("3TDoD");
var $fweAh = parcelRequire("fweAh");
var $kdlrL = parcelRequire("kdlrL");
var $cCv48 = parcelRequire("cCv48");
var $ahpbA = parcelRequire("ahpbA");
var $4xrnn = parcelRequire("4xrnn");

var $7wvDE = parcelRequire("7wvDE");

var $4nzjx = parcelRequire("4nzjx");
parcelRequire("1CNor");
var $kjtme = parcelRequire("kjtme");
var $fdjhe = parcelRequire("fdjhe");
var $3iYiT = parcelRequire("3iYiT");
var $gCPwG = parcelRequire("gCPwG");
var $aF7fC = parcelRequire("aF7fC");

var $2DxmN = parcelRequire("2DxmN");
parcelRequire("cqlBF");
var $W67ZN = parcelRequire("W67ZN");
parcelRequire("dp7nP");
var $eR0w1 = parcelRequire("eR0w1");
const $34680393ffccbb07$export$36d128238e6b60f5 = {
    history: (0, $4nzjx.DEFAULT_HISTORY),
    location: (0, $4nzjx.DEFAULT_HISTORY).location,
    query: {},
    routes: [],
    route: (0, $4nzjx.DEFAULT_ROUTE),
    match: (0, $4nzjx.DEFAULT_MATCH),
    action: (0, $4nzjx.DEFAULT_ACTION),
    unlisten: null,
    basePath: "",
    isStatic: false,
    onPrefetch: undefined
};
const $34680393ffccbb07$var$actions = {
    /**
   * Bootstraps the store with initial data.
   *
   */ bootstrapStore: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { resourceContext: resourceContext, resourceData: resourceData, basePath: basePath = "", routes: routes, initialRoute: initialRoute } = props, initialProps = (0, (/*@__PURE__*/$parcel$interopDefault($j7eBO)))(props, [
                "resourceContext",
                "resourceData",
                "basePath",
                "routes",
                "initialRoute"
            ]);
            const { history: history, isStatic: isStatic } = initialProps;
            const routerContext = (0, $kjtme.findRouterContext)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, initialProps), routerContext), {}, {
                basePath: basePath,
                routes: routes,
                location: history.location,
                action: history.action
            }));
            (0, $2DxmN.getResourceStore)().actions.hydrate({
                resourceContext: resourceContext,
                resourceData: resourceData
            });
            if (!isStatic) dispatch($34680393ffccbb07$var$actions.listen());
        },
    /**
   * Duplicate method that uses isServerEnvironment instead of removed isStatic prop
   * internally. We can remove this when UniversalRouter replaces Router completely.
   */ bootstrapStoreUniversal: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { resourceContext: resourceContext, resourceData: resourceData, basePath: basePath = "" } = props, initialProps = (0, (/*@__PURE__*/$parcel$interopDefault($j7eBO)))(props, [
                "resourceContext",
                "resourceData",
                "basePath"
            ]);
            const { history: history, routes: routes } = initialProps;
            const routerContext = (0, $kjtme.findRouterContext)(routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, initialProps), routerContext), {}, {
                basePath: basePath,
                location: history.location,
                action: history.action
            }));
            (0, $2DxmN.getResourceStore)().actions.hydrate({
                resourceContext: resourceContext,
                resourceData: resourceData
            });
            if (!(0, $gCPwG.isServerEnvironment)()) dispatch($34680393ffccbb07$var$actions.listen());
        },
    /**
   * Uses the resource store to request resources for the route.
   * Must be dispatched after setting state with the new route context.
   *
   */ requestRouteResources: (options = {})=>({ getState: getState })=>{
            const { route: route, match: match, query: query } = getState();
            return (0, $2DxmN.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, options);
        },
    prefetchNextRouteResources: (path, nextContext)=>({ getState: getState })=>{
            const { routes: routes, basePath: basePath, onPrefetch: onPrefetch, route: route, match: match, query: query } = getState();
            const { cleanExpiredResources: cleanExpiredResources, requestResources: requestResources, getContext: getResourceStoreContext } = (0, $2DxmN.getResourceStore)().actions;
            if (!nextContext && !(0, $eR0w1.isExternalAbsolutePath)(path)) {
                const location = (0, $7wvDE.parsePath)((0, $eR0w1.getRelativePath)(path, basePath));
                nextContext = (0, $kjtme.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            const nextResources = (0, $W67ZN.getResourcesForNextLocation)({
                route: route,
                match: match,
                query: query
            }, nextLocationContext, getResourceStoreContext());
            (0, $3TDoD.batch)(()=>{
                cleanExpiredResources(nextResources, nextLocationContext);
                requestResources(nextResources, nextLocationContext, {
                    prefetch: true
                });
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        },
    /**
   * Starts listening to browser history and sets the unlisten function in state.
   * Will request route resources on route change.
   *
   */ listen: ()=>({ getState: getState, setState: setState })=>{
            const { history: history } = getState();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery } = getState();
                const { cleanExpiredResources: cleanExpiredResources, requestResources: requestResources, getContext: getResourceStoreContext } = (0, $2DxmN.getResourceStore)().actions;
                const nextContext = (0, $kjtme.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
                const nextLocationContext = {
                    route: nextContext.route,
                    match: nextContext.match,
                    query: nextContext.query
                };
                const nextResources = (0, $W67ZN.getResourcesForNextLocation)({
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                }, nextLocationContext, getResourceStoreContext());
                /* Explicitly batch update
       * as we need resources cleaned + route changed + resource fetch started together
       * If we do not batch, React might be re-render when route changes but resource
       * fetching has not started yet, making the app render with data null */ (0, $3TDoD.batch)(()=>{
                    cleanExpiredResources(nextResources, nextLocationContext);
                    setState((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, nextContext), {}, {
                        location: location,
                        action: action
                    }));
                    requestResources(nextResources, nextLocationContext, {});
                });
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $eR0w1.isExternalAbsolutePath)(path)) window.location.assign(path);
            else history.push((0, $eR0w1.getRelativePath)(path, basePath));
        },
    pushTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $fdjhe.generateLocationFromPath)(route.path, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, attributes), {}, {
                basePath: basePath
            }));
            (0, $aF7fC.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.push(location);
        },
    replace: (path)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $eR0w1.isExternalAbsolutePath)(path)) window.location.replace(path);
            else history.replace((0, $eR0w1.getRelativePath)(path, basePath));
        },
    replaceTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $fdjhe.generateLocationFromPath)(route.path, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, attributes), {}, {
                basePath: basePath
            }));
            (0, $aF7fC.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.replace(location);
        },
    goBack: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            history.goBack();
        },
    goForward: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            history.goForward();
        },
    registerBlock: (blocker)=>({ getState: getState })=>{
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState: getState })=>{
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>({ getState: getState })=>{
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = "push")=>({ getState: getState })=>{
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, existingQueryParams), params); // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $eR0w1.updateQueryParams)(location, existingQueryParams);
            const updatedPath = (0, $eR0w1.updateQueryParams)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = "push")=>({ getState: getState })=>{
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, existingPathParams), params);
            const updatedPath = (0, $3iYiT.default)(pathWithBasePath, updatedPathParams);
            const updatedLocation = (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, location), {}, {
                pathname: updatedPath
            });
            const existingRelativePath = (0, $eR0w1.getRelativeURLFromLocation)(location);
            const updatedRelativePath = (0, $eR0w1.getRelativeURLFromLocation)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        }
};
const $34680393ffccbb07$export$1cf0ecab63b1963c = (0, $cCv48.createStore)({
    initialState: $34680393ffccbb07$export$36d128238e6b60f5,
    actions: $34680393ffccbb07$var$actions,
    name: "router"
});
const $34680393ffccbb07$export$d6b817abe7a77ea5 = (0, $fweAh.createContainer)($34680393ffccbb07$export$1cf0ecab63b1963c, {
    displayName: "RouterContainer",
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($34680393ffccbb07$var$actions.bootstrapStore(props));
            !props.isStatic && dispatch($34680393ffccbb07$var$actions.requestRouteResources());
        },
    onCleanup: ()=>()=>{}
});
const $34680393ffccbb07$export$b33f9392316de69d = (0, $fweAh.createContainer)($34680393ffccbb07$export$1cf0ecab63b1963c, {
    displayName: "UniversalRouterContainer",
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($34680393ffccbb07$var$actions.bootstrapStoreUniversal(props));
            !(0, $gCPwG.isServerEnvironment)() && dispatch($34680393ffccbb07$var$actions.requestRouteResources());
        },
    onCleanup: ()=>()=>{}
});
const $34680393ffccbb07$export$672d721d310ff5f0 = (0, $ahpbA.createSubscriber)($34680393ffccbb07$export$1cf0ecab63b1963c, {
    displayName: "BaseRouterSubscriber"
});
const $34680393ffccbb07$export$afda200b5577e7bf = (0, $ahpbA.createSubscriber)($34680393ffccbb07$export$1cf0ecab63b1963c, {
    displayName: "RouterActionsSubscriber",
    selector: null
});
const $34680393ffccbb07$export$2e249c5b0c1716a7 = (0, $ahpbA.createSubscriber)($34680393ffccbb07$export$1cf0ecab63b1963c, {
    selector: (state)=>Boolean(state.route && state.route.resources)
});
const $34680393ffccbb07$export$9569010eab09ae9e = (0, $kdlrL.createHook)($34680393ffccbb07$export$1cf0ecab63b1963c);
const $34680393ffccbb07$export$dce62b3e98a54741 = (0, $kdlrL.createHook)($34680393ffccbb07$export$1cf0ecab63b1963c, {
    selector: null
});
function $34680393ffccbb07$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $kdlrL.createHook)($34680393ffccbb07$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector(...args) {
        return useHook(...args)[0];
    };
}
const $34680393ffccbb07$export$5ccad187366c8494 = ()=>(0, $4xrnn.defaultRegistry).getStore($34680393ffccbb07$export$1cf0ecab63b1963c); // @ts-ignore accessing private store property
const $34680393ffccbb07$export$ebf37f7e180b13a9 = ()=>$34680393ffccbb07$export$5ccad187366c8494().storeState.getState();

});
parcelRegister("7wvDE", function(module, exports) {

$parcel$export(module.exports, "parsePath", function () { return $57a410525c35b89e$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createPath", function () { return $57a410525c35b89e$export$fe53371bee54353d; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $57a410525c35b89e$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $57a410525c35b89e$export$2b76ad033c6e6d08; });

var $ii97e = parcelRequire("ii97e");

var $avOaJ = parcelRequire("avOaJ");

var $6BKHa = parcelRequire("6BKHa");


var $4GQn2 = parcelRequire("4GQn2");
function $57a410525c35b89e$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $57a410525c35b89e$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $57a410525c35b89e$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function $57a410525c35b89e$var$stripBasename(path, prefix) {
    return $57a410525c35b89e$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $57a410525c35b89e$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $57a410525c35b89e$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $57a410525c35b89e$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $57a410525c35b89e$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $57a410525c35b89e$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $ii97e.default)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $avOaJ.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $57a410525c35b89e$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $6BKHa.default)(a.state, b.state);
}
function $57a410525c35b89e$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $57a410525c35b89e$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $57a410525c35b89e$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $57a410525c35b89e$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $57a410525c35b89e$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $57a410525c35b89e$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $57a410525c35b89e$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var $57a410525c35b89e$var$PopStateEvent = "popstate";
var $57a410525c35b89e$var$HashChangeEvent = "hashchange";
function $57a410525c35b89e$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $57a410525c35b89e$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$57a410525c35b89e$var$canUseDOM && (0, $4GQn2.default)(false);
    var globalHistory = window.history;
    var canUseHistory = $57a410525c35b89e$var$supportsHistory();
    var needsHashChangeListener = !$57a410525c35b89e$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $57a410525c35b89e$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $57a410525c35b89e$var$stripTrailingSlash($57a410525c35b89e$var$addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $57a410525c35b89e$var$stripBasename(path, basename);
        return $57a410525c35b89e$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $57a410525c35b89e$var$createTransitionManager();
    function setState(nextState) {
        (0, $ii97e.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($57a410525c35b89e$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($57a410525c35b89e$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($57a410525c35b89e$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $57a410525c35b89e$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $57a410525c35b89e$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $57a410525c35b89e$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($57a410525c35b89e$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($57a410525c35b89e$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($57a410525c35b89e$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($57a410525c35b89e$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $57a410525c35b89e$var$HashChangeEvent$1 = "hashchange";
var $57a410525c35b89e$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $57a410525c35b89e$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $57a410525c35b89e$var$stripLeadingSlash,
        decodePath: $57a410525c35b89e$var$addLeadingSlash
    },
    slash: {
        encodePath: $57a410525c35b89e$var$addLeadingSlash,
        decodePath: $57a410525c35b89e$var$addLeadingSlash
    }
};
function $57a410525c35b89e$var$stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $57a410525c35b89e$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $57a410525c35b89e$var$pushHashPath(path) {
    window.location.hash = path;
}
function $57a410525c35b89e$var$replaceHashPath(path) {
    window.location.replace($57a410525c35b89e$var$stripHash(window.location.href) + "#" + path);
}
function $57a410525c35b89e$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$57a410525c35b89e$var$canUseDOM && (0, $4GQn2.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $57a410525c35b89e$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $57a410525c35b89e$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $57a410525c35b89e$var$stripTrailingSlash($57a410525c35b89e$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $57a410525c35b89e$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($57a410525c35b89e$var$getHashPath());
        if (basename) path = $57a410525c35b89e$var$stripBasename(path, basename);
        return $57a410525c35b89e$export$90c043f1c57770b8(path);
    }
    var transitionManager = $57a410525c35b89e$var$createTransitionManager();
    function setState(nextState) {
        (0, $ii97e.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $57a410525c35b89e$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $57a410525c35b89e$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $57a410525c35b89e$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($57a410525c35b89e$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($57a410525c35b89e$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $57a410525c35b89e$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $57a410525c35b89e$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $57a410525c35b89e$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = $57a410525c35b89e$var$stripHash(window.location.href);
        return href + "#" + encodePath(basename + $57a410525c35b89e$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $57a410525c35b89e$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $57a410525c35b89e$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $57a410525c35b89e$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $57a410525c35b89e$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($57a410525c35b89e$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $57a410525c35b89e$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $57a410525c35b89e$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $57a410525c35b89e$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $57a410525c35b89e$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($57a410525c35b89e$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($57a410525c35b89e$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($57a410525c35b89e$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $57a410525c35b89e$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $57a410525c35b89e$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $57a410525c35b89e$var$createTransitionManager();
    function setState(nextState) {
        (0, $ii97e.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $57a410525c35b89e$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $57a410525c35b89e$export$90c043f1c57770b8(entry, undefined, createKey()) : $57a410525c35b89e$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $57a410525c35b89e$export$fe53371bee54353d;
    function push(path, state) {
        var action = "PUSH";
        var location = $57a410525c35b89e$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $57a410525c35b89e$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $57a410525c35b89e$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

});
parcelRegister("avOaJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a73b7c440eb0974$export$2e2bcd8739ae039; });
function $7a73b7c440eb0974$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $7a73b7c440eb0974$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $7a73b7c440eb0974$var$resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $7a73b7c440eb0974$var$isAbsolute(to);
    var isFromAbs = from && $7a73b7c440eb0974$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $7a73b7c440eb0974$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $7a73b7c440eb0974$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $7a73b7c440eb0974$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $7a73b7c440eb0974$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$7a73b7c440eb0974$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $7a73b7c440eb0974$export$2e2bcd8739ae039 = $7a73b7c440eb0974$var$resolvePathname;

});

parcelRegister("6BKHa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cfa6b7995548e60$export$2e2bcd8739ae039; });
function $4cfa6b7995548e60$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $4cfa6b7995548e60$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $4cfa6b7995548e60$var$valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = $4cfa6b7995548e60$var$valueOf(a);
        var bValue = $4cfa6b7995548e60$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $4cfa6b7995548e60$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $4cfa6b7995548e60$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $4cfa6b7995548e60$export$2e2bcd8739ae039 = $4cfa6b7995548e60$var$valueEqual;

});


parcelRegister("4nzjx", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_MATCH", function () { return $3304b40c27daa0b1$export$2de13e891a662beb; });
$parcel$export(module.exports, "DEFAULT_ROUTE", function () { return $3304b40c27daa0b1$export$4eadc79233226325; });
$parcel$export(module.exports, "DEFAULT_HISTORY", function () { return $3304b40c27daa0b1$export$39607c9878cf5148; });
$parcel$export(module.exports, "DEFAULT_ACTION", function () { return $3304b40c27daa0b1$export$fa440ddf675c8a93; });

var $98jTI = parcelRequire("98jTI");

var $kNGNu = parcelRequire("kNGNu");
const $3304b40c27daa0b1$export$7c22f8f9552f689e = {
    pathname: "",
    search: "",
    hash: ""
};
const $3304b40c27daa0b1$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: "",
    url: "",
    query: {}
};
const $3304b40c27daa0b1$export$4eadc79233226325 = {
    path: "",
    component: ()=>null,
    name: ""
};
const $3304b40c27daa0b1$export$39607c9878cf5148 = (0, $kNGNu.createLegacyHistory)();
const $3304b40c27daa0b1$export$1515254c8c90bebb = {
    location: $3304b40c27daa0b1$export$7c22f8f9552f689e,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($98jTI))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($98jTI))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($98jTI))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($98jTI))),
    listen: (0, (/*@__PURE__*/$parcel$interopDefault($98jTI))),
    block: (0, (/*@__PURE__*/$parcel$interopDefault($98jTI))),
    createHref: (0, (/*@__PURE__*/$parcel$interopDefault($98jTI)))
};
const $3304b40c27daa0b1$export$fa440ddf675c8a93 = "POP";

});
parcelRegister("98jTI", function(module, exports) {
/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize include="noop" exports="npm" -o ./foo`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * A no-operation function that returns `undefined` regardless of the
 * arguments it receives.
 *
 * @static
 * @memberOf _
 * @category Util
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.noop(object) === undefined;
 * // => true
 */ function $6a644baa337de134$var$noop() {
// No operation performed.
}
module.exports = $6a644baa337de134$var$noop;

});

parcelRegister("kNGNu", function(module, exports) {

$parcel$export(module.exports, "createLegacyHistory", function () { return $f24994e2f31f2f0e$export$883c3f3b6c000133; });

var $fPPqr = parcelRequire("fPPqr");

var $7wvDE = parcelRequire("7wvDE");

var $dcoYY = parcelRequire("dcoYY");

var $98jTI = parcelRequire("98jTI");
const $f24994e2f31f2f0e$var$hasWindow = ()=>typeof window !== "undefined";
const $f24994e2f31f2f0e$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($98jTI))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($98jTI))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($98jTI))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($98jTI))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($98jTI))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($98jTI)))
};
const $f24994e2f31f2f0e$var$getLocation = ()=>{
    // todo - don't force non-optional search and hash
    const { pathname: pathname = "", search: search = "", hash: hash = "" } = $f24994e2f31f2f0e$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $f24994e2f31f2f0e$var$createLegacyListener = (updateExposedLocation)=>{
    const node = document.querySelector("#content");
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ]; // note: window.history.length is capped at 50 entries
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        const currentHref = window.location.href;
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return "POP";
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return "POP";
            }
            historyStack[historyStack.length - 1] = currentHref;
            return "REPLACE";
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        prevHistoryLength = window.history.length;
        return "PUSH";
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($dcoYY)))(()=>{
        if (prevHref !== window.location.href) {
            const newLocation = $f24994e2f31f2f0e$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $f24994e2f31f2f0e$export$883c3f3b6c000133 = ()=>{
    let currentLocation = $f24994e2f31f2f0e$var$getLocation();
    let currentAction = "PUSH";
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        get location () {
            return currentLocation;
        },
        get length () {
            return $f24994e2f31f2f0e$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        }
    }, $f24994e2f31f2f0e$var$hasWindow() ? {
        push: (path)=>window.location.assign(path),
        replace: (path)=>window.history.replaceState({}, document.title, path),
        goBack: ()=>window.history.back(),
        goForward: ()=>window.history.forward(),
        listen: $f24994e2f31f2f0e$var$createLegacyListener(updateExposedLocation),
        block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($98jTI))),
        createHref: (location)=>(0, $7wvDE.createPath)(location)
    } : $f24994e2f31f2f0e$var$methodsPlaceholders);
};

});
parcelRegister("dcoYY", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $99bfc6588f633c34$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $99bfc6588f633c34$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $99bfc6588f633c34$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $99bfc6588f633c34$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $99bfc6588f633c34$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $99bfc6588f633c34$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $99bfc6588f633c34$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $99bfc6588f633c34$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $99bfc6588f633c34$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $99bfc6588f633c34$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $99bfc6588f633c34$var$root = $99bfc6588f633c34$var$freeGlobal || $99bfc6588f633c34$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $99bfc6588f633c34$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $99bfc6588f633c34$var$objectToString = $99bfc6588f633c34$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $99bfc6588f633c34$var$nativeMax = Math.max, $99bfc6588f633c34$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $99bfc6588f633c34$var$now = function() {
    return $99bfc6588f633c34$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $99bfc6588f633c34$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($99bfc6588f633c34$var$FUNC_ERROR_TEXT);
    wait = $99bfc6588f633c34$var$toNumber(wait) || 0;
    if ($99bfc6588f633c34$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $99bfc6588f633c34$var$nativeMax($99bfc6588f633c34$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $99bfc6588f633c34$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $99bfc6588f633c34$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($99bfc6588f633c34$var$now());
    }
    function debounced() {
        var time = $99bfc6588f633c34$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $99bfc6588f633c34$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $99bfc6588f633c34$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $99bfc6588f633c34$var$isSymbol(value) {
    return typeof value == "symbol" || $99bfc6588f633c34$var$isObjectLike(value) && $99bfc6588f633c34$var$objectToString.call(value) == $99bfc6588f633c34$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $99bfc6588f633c34$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($99bfc6588f633c34$var$isSymbol(value)) return $99bfc6588f633c34$var$NAN;
    if ($99bfc6588f633c34$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $99bfc6588f633c34$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($99bfc6588f633c34$var$reTrim, "");
    var isBinary = $99bfc6588f633c34$var$reIsBinary.test(value);
    return isBinary || $99bfc6588f633c34$var$reIsOctal.test(value) ? $99bfc6588f633c34$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $99bfc6588f633c34$var$reIsBadHex.test(value) ? $99bfc6588f633c34$var$NAN : +value;
}
module.exports = $99bfc6588f633c34$var$debounce;

});



parcelRegister("1CNor", function(module, exports) {

$parcel$export(module.exports, "matchRoute", function () { return (parcelRequire("aF7fC")).default; });
$parcel$export(module.exports, "warmupMatchRouteCache", function () { return (parcelRequire("aF7fC")).warmupMatchRouteCache; });
$parcel$export(module.exports, "generatePath", function () { return (parcelRequire("3iYiT")).default; });
$parcel$export(module.exports, "generateLocationFromPath", function () { return (parcelRequire("fdjhe")).generateLocationFromPath; });
$parcel$export(module.exports, "isServerEnvironment", function () { return (parcelRequire("gCPwG")).isServerEnvironment; });
$parcel$export(module.exports, "findRouterContext", function () { return (parcelRequire("kjtme")).findRouterContext; });
$parcel$export(module.exports, "createRouterContext", function () { return (parcelRequire("kjtme")).createRouterContext; });

var $aF7fC = parcelRequire("aF7fC");

var $3iYiT = parcelRequire("3iYiT");

var $fdjhe = parcelRequire("fdjhe");

var $kNGNu = parcelRequire("kNGNu");

var $gCPwG = parcelRequire("gCPwG");

var $kjtme = parcelRequire("kjtme");

});
parcelRegister("aF7fC", function(module, exports) {

$parcel$export(module.exports, "warmupMatchRouteCache", function () { return $7c335b9ee7581800$export$4e76f1d455ef7c95; });
$parcel$export(module.exports, "default", function () { return $7c335b9ee7581800$export$2e2bcd8739ae039; });

var $i0bJB = parcelRequire("i0bJB");

var $cF6yY = parcelRequire("cF6yY");

var $hSADK = parcelRequire("hSADK");
/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $7c335b9ee7581800$var$matchRoute = (routes, pathname, queryParams = {}, basePath = "")=>{
    const queryParamObject = typeof queryParams === "string" ? (0, $i0bJB.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $hSADK.matchRouteCache).get(pathname, queryParamObject, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $cF6yY.default)(routes[i], pathname, queryParamObject, basePath);
        if (matchedRoute) {
            (0, $hSADK.matchRouteCache).set(pathname, queryParamObject, basePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $7c335b9ee7581800$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = "")=>$7c335b9ee7581800$var$matchRoute(routes, pathname, queryParams, basePath);
const $7c335b9ee7581800$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = "")=>{
    $7c335b9ee7581800$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $7c335b9ee7581800$export$2e2bcd8739ae039 = (routes, pathname, queryParams, basePath = "")=>$7c335b9ee7581800$var$matchRoute(routes, pathname, queryParams, basePath);

});
parcelRegister("i0bJB", function(module, exports) {
"use strict";

var $7aLdv = parcelRequire("7aLdv");

var $6efvs = parcelRequire("6efvs");
var $d1b15452eda8e358$var$controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, $d1b15452eda8e358$var$CRHTLF = /[\n\r\t]/g, $d1b15452eda8e358$var$slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, $d1b15452eda8e358$var$port = /:\d+$/, $d1b15452eda8e358$var$protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, $d1b15452eda8e358$var$windowsDriveLetter = /^[a-zA-Z]:/;
/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */ function $d1b15452eda8e358$var$trimLeft(str) {
    return (str ? str : "").toString().replace($d1b15452eda8e358$var$controlOrWhitespace, "");
}
/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */ var $d1b15452eda8e358$var$rules = [
    [
        "#",
        "hash"
    ],
    [
        "?",
        "query"
    ],
    function sanitize(address, url) {
        return $d1b15452eda8e358$var$isSpecial(url.protocol) ? address.replace(/\\/g, "/") : address;
    },
    [
        "/",
        "pathname"
    ],
    [
        "@",
        "auth",
        1
    ],
    [
        NaN,
        "host",
        undefined,
        1,
        1
    ],
    [
        /:(\d*)$/,
        "port",
        undefined,
        1
    ],
    [
        NaN,
        "hostname",
        undefined,
        1,
        1
    ] // Set left over.
];
/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */ var $d1b15452eda8e358$var$ignore = {
    hash: 1,
    query: 1
};
/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */ function $d1b15452eda8e358$var$lolcation(loc) {
    var globalVar;
    if (typeof window !== "undefined") globalVar = window;
    else if (typeof $parcel$global !== "undefined") globalVar = $parcel$global;
    else if (typeof self !== "undefined") globalVar = self;
    else globalVar = {};
    var location = globalVar.location || {};
    loc = loc || location;
    var finaldestination = {}, type = typeof loc, key;
    if ("blob:" === loc.protocol) finaldestination = new $d1b15452eda8e358$var$Url(unescape(loc.pathname), {});
    else if ("string" === type) {
        finaldestination = new $d1b15452eda8e358$var$Url(loc, {});
        for(key in $d1b15452eda8e358$var$ignore)delete finaldestination[key];
    } else if ("object" === type) {
        for(key in loc){
            if (key in $d1b15452eda8e358$var$ignore) continue;
            finaldestination[key] = loc[key];
        }
        if (finaldestination.slashes === undefined) finaldestination.slashes = $d1b15452eda8e358$var$slashes.test(loc.href);
    }
    return finaldestination;
}
/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */ function $d1b15452eda8e358$var$isSpecial(scheme) {
    return scheme === "file:" || scheme === "ftp:" || scheme === "http:" || scheme === "https:" || scheme === "ws:" || scheme === "wss:";
}
/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */ /**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */ function $d1b15452eda8e358$var$extractProtocol(address, location) {
    address = $d1b15452eda8e358$var$trimLeft(address);
    address = address.replace($d1b15452eda8e358$var$CRHTLF, "");
    location = location || {};
    var match = $d1b15452eda8e358$var$protocolre.exec(address);
    var protocol = match[1] ? match[1].toLowerCase() : "";
    var forwardSlashes = !!match[2];
    var otherSlashes = !!match[3];
    var slashesCount = 0;
    var rest;
    if (forwardSlashes) {
        if (otherSlashes) {
            rest = match[2] + match[3] + match[4];
            slashesCount = match[2].length + match[3].length;
        } else {
            rest = match[2] + match[4];
            slashesCount = match[2].length;
        }
    } else if (otherSlashes) {
        rest = match[3] + match[4];
        slashesCount = match[3].length;
    } else rest = match[4];
    if (protocol === "file:") {
        if (slashesCount >= 2) rest = rest.slice(2);
    } else if ($d1b15452eda8e358$var$isSpecial(protocol)) rest = match[4];
    else if (protocol) {
        if (forwardSlashes) rest = rest.slice(2);
    } else if (slashesCount >= 2 && $d1b15452eda8e358$var$isSpecial(location.protocol)) rest = match[4];
    return {
        protocol: protocol,
        slashes: forwardSlashes || $d1b15452eda8e358$var$isSpecial(protocol),
        slashesCount: slashesCount,
        rest: rest
    };
}
/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */ function $d1b15452eda8e358$var$resolve(relative, base) {
    if (relative === "") return base;
    var path = (base || "/").split("/").slice(0, -1).concat(relative.split("/")), i = path.length, last = path[i - 1], unshift = false, up = 0;
    while(i--){
        if (path[i] === ".") path.splice(i, 1);
        else if (path[i] === "..") {
            path.splice(i, 1);
            up++;
        } else if (up) {
            if (i === 0) unshift = true;
            path.splice(i, 1);
            up--;
        }
    }
    if (unshift) path.unshift("");
    if (last === "." || last === "..") path.push("");
    return path.join("/");
}
/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */ function $d1b15452eda8e358$var$Url(address, location, parser) {
    address = $d1b15452eda8e358$var$trimLeft(address);
    address = address.replace($d1b15452eda8e358$var$CRHTLF, "");
    if (!(this instanceof $d1b15452eda8e358$var$Url)) return new $d1b15452eda8e358$var$Url(address, location, parser);
    var relative, extracted, parse, instruction, index, key, instructions = $d1b15452eda8e358$var$rules.slice(), type = typeof location, url = this, i = 0;
    //
    // The following if statements allows this module two have compatibility with
    // 2 different API:
    //
    // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
    //    where the boolean indicates that the query string should also be parsed.
    //
    // 2. The `URL` interface of the browser which accepts a URL, object as
    //    arguments. The supplied object will be used as default values / fall-back
    //    for relative paths.
    //
    if ("object" !== type && "string" !== type) {
        parser = location;
        location = null;
    }
    if (parser && "function" !== typeof parser) parser = $6efvs.parse;
    location = $d1b15452eda8e358$var$lolcation(location);
    //
    // Extract protocol information before running the instructions.
    //
    extracted = $d1b15452eda8e358$var$extractProtocol(address || "", location);
    relative = !extracted.protocol && !extracted.slashes;
    url.slashes = extracted.slashes || relative && location.slashes;
    url.protocol = extracted.protocol || location.protocol || "";
    address = extracted.rest;
    //
    // When the authority component is absent the URL starts with a path
    // component.
    //
    if (extracted.protocol === "file:" && (extracted.slashesCount !== 2 || $d1b15452eda8e358$var$windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !$d1b15452eda8e358$var$isSpecial(url.protocol))) instructions[3] = [
        /(.*)/,
        "pathname"
    ];
    for(; i < instructions.length; i++){
        instruction = instructions[i];
        if (typeof instruction === "function") {
            address = instruction(address, url);
            continue;
        }
        parse = instruction[0];
        key = instruction[1];
        if (parse !== parse) url[key] = address;
        else if ("string" === typeof parse) {
            index = parse === "@" ? address.lastIndexOf(parse) : address.indexOf(parse);
            if (~index) {
                if ("number" === typeof instruction[2]) {
                    url[key] = address.slice(0, index);
                    address = address.slice(index + instruction[2]);
                } else {
                    url[key] = address.slice(index);
                    address = address.slice(0, index);
                }
            }
        } else if (index = parse.exec(address)) {
            url[key] = index[1];
            address = address.slice(0, index.index);
        }
        url[key] = url[key] || (relative && instruction[3] ? location[key] || "" : "");
        //
        // Hostname, host and protocol should be lowercased so they can be used to
        // create a proper `origin`.
        //
        if (instruction[4]) url[key] = url[key].toLowerCase();
    }
    //
    // Also parse the supplied query string in to an object. If we're supplied
    // with a custom parser as function use that instead of the default build-in
    // parser.
    //
    if (parser) url.query = parser(url.query);
    //
    // If the URL is relative, resolve the pathname against the base URL.
    //
    if (relative && location.slashes && url.pathname.charAt(0) !== "/" && (url.pathname !== "" || location.pathname !== "")) url.pathname = $d1b15452eda8e358$var$resolve(url.pathname, location.pathname);
    //
    // Default to a / for pathname if none exists. This normalizes the URL
    // to always have a /
    //
    if (url.pathname.charAt(0) !== "/" && $d1b15452eda8e358$var$isSpecial(url.protocol)) url.pathname = "/" + url.pathname;
    //
    // We should not add port numbers if they are already the default port number
    // for a given protocol. As the host also contains the port number we're going
    // override it with the hostname which contains no port number.
    //
    if (!$7aLdv(url.port, url.protocol)) {
        url.host = url.hostname;
        url.port = "";
    }
    //
    // Parse down the `auth` for the username and password.
    //
    url.username = url.password = "";
    if (url.auth) {
        index = url.auth.indexOf(":");
        if (~index) {
            url.username = url.auth.slice(0, index);
            url.username = encodeURIComponent(decodeURIComponent(url.username));
            url.password = url.auth.slice(index + 1);
            url.password = encodeURIComponent(decodeURIComponent(url.password));
        } else url.username = encodeURIComponent(decodeURIComponent(url.auth));
        url.auth = url.password ? url.username + ":" + url.password : url.username;
    }
    url.origin = url.protocol !== "file:" && $d1b15452eda8e358$var$isSpecial(url.protocol) && url.host ? url.protocol + "//" + url.host : "null";
    //
    // The href is just the compiled result.
    //
    url.href = url.toString();
}
/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */ function $d1b15452eda8e358$var$set(part, value, fn) {
    var url = this;
    switch(part){
        case "query":
            if ("string" === typeof value && value.length) value = (fn || $6efvs.parse)(value);
            url[part] = value;
            break;
        case "port":
            url[part] = value;
            if (!$7aLdv(value, url.protocol)) {
                url.host = url.hostname;
                url[part] = "";
            } else if (value) url.host = url.hostname + ":" + value;
            break;
        case "hostname":
            url[part] = value;
            if (url.port) value += ":" + url.port;
            url.host = value;
            break;
        case "host":
            url[part] = value;
            if ($d1b15452eda8e358$var$port.test(value)) {
                value = value.split(":");
                url.port = value.pop();
                url.hostname = value.join(":");
            } else {
                url.hostname = value;
                url.port = "";
            }
            break;
        case "protocol":
            url.protocol = value.toLowerCase();
            url.slashes = !fn;
            break;
        case "pathname":
        case "hash":
            if (value) {
                var char = part === "pathname" ? "/" : "#";
                url[part] = value.charAt(0) !== char ? char + value : value;
            } else url[part] = value;
            break;
        case "username":
        case "password":
            url[part] = encodeURIComponent(value);
            break;
        case "auth":
            var index = value.indexOf(":");
            if (~index) {
                url.username = value.slice(0, index);
                url.username = encodeURIComponent(decodeURIComponent(url.username));
                url.password = value.slice(index + 1);
                url.password = encodeURIComponent(decodeURIComponent(url.password));
            } else url.username = encodeURIComponent(decodeURIComponent(value));
    }
    for(var i = 0; i < $d1b15452eda8e358$var$rules.length; i++){
        var ins = $d1b15452eda8e358$var$rules[i];
        if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
    }
    url.auth = url.password ? url.username + ":" + url.password : url.username;
    url.origin = url.protocol !== "file:" && $d1b15452eda8e358$var$isSpecial(url.protocol) && url.host ? url.protocol + "//" + url.host : "null";
    url.href = url.toString();
    return url;
}
/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */ function $d1b15452eda8e358$var$toString(stringify) {
    if (!stringify || "function" !== typeof stringify) stringify = $6efvs.stringify;
    var query, url = this, host = url.host, protocol = url.protocol;
    if (protocol && protocol.charAt(protocol.length - 1) !== ":") protocol += ":";
    var result = protocol + (url.protocol && url.slashes || $d1b15452eda8e358$var$isSpecial(url.protocol) ? "//" : "");
    if (url.username) {
        result += url.username;
        if (url.password) result += ":" + url.password;
        result += "@";
    } else if (url.password) {
        result += ":" + url.password;
        result += "@";
    } else if (url.protocol !== "file:" && $d1b15452eda8e358$var$isSpecial(url.protocol) && !host && url.pathname !== "/") //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += "@";
    //
    // Trailing colon is removed from `url.host` when it is parsed. If it still
    // ends with a colon, then add back the trailing colon that was removed. This
    // prevents an invalid URL from being transformed into a valid one.
    //
    if (host[host.length - 1] === ":" || $d1b15452eda8e358$var$port.test(url.hostname) && !url.port) host += ":";
    result += host + url.pathname;
    query = "object" === typeof url.query ? stringify(url.query) : url.query;
    if (query) result += "?" !== query.charAt(0) ? "?" + query : query;
    if (url.hash) result += url.hash;
    return result;
}
$d1b15452eda8e358$var$Url.prototype = {
    set: $d1b15452eda8e358$var$set,
    toString: $d1b15452eda8e358$var$toString
};
//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
$d1b15452eda8e358$var$Url.extractProtocol = $d1b15452eda8e358$var$extractProtocol;
$d1b15452eda8e358$var$Url.location = $d1b15452eda8e358$var$lolcation;
$d1b15452eda8e358$var$Url.trimLeft = $d1b15452eda8e358$var$trimLeft;
$d1b15452eda8e358$var$Url.qs = $6efvs;
module.exports = $d1b15452eda8e358$var$Url;

});
parcelRegister("7aLdv", function(module, exports) {
"use strict";
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ module.exports = function required(port, protocol) {
    protocol = protocol.split(":")[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case "http":
        case "ws":
            return port !== 80;
        case "https":
        case "wss":
            return port !== 443;
        case "ftp":
            return port !== 21;
        case "gopher":
            return port !== 70;
        case "file":
            return false;
    }
    return port !== 0;
};

});

parcelRegister("6efvs", function(module, exports) {

$parcel$export(module.exports, "stringify", function () { return $4890141b1bd02fb2$export$fac44ee5b035f737; }, function (v) { return $4890141b1bd02fb2$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parse", function () { return $4890141b1bd02fb2$export$98e6a39c04603d36; }, function (v) { return $4890141b1bd02fb2$export$98e6a39c04603d36 = v; });
//
// Expose the module.
//
var $4890141b1bd02fb2$export$fac44ee5b035f737;
var $4890141b1bd02fb2$export$98e6a39c04603d36;
"use strict";
var $4890141b1bd02fb2$var$has = Object.prototype.hasOwnProperty, $4890141b1bd02fb2$var$undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $4890141b1bd02fb2$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, " "));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function $4890141b1bd02fb2$var$encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function $4890141b1bd02fb2$var$querystring(query) {
    var parser = /([^=?&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = $4890141b1bd02fb2$var$decode(part[1]), value = $4890141b1bd02fb2$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function $4890141b1bd02fb2$var$querystringify(obj, prefix) {
    prefix = prefix || "";
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ("string" !== typeof prefix) prefix = "?";
    for(key in obj)if ($4890141b1bd02fb2$var$has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === $4890141b1bd02fb2$var$undef || isNaN(value))) value = "";
        key = encodeURIComponent(key);
        value = encodeURIComponent(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + "=" + value);
    }
    return pairs.length ? prefix + pairs.join("&") : "";
}
$4890141b1bd02fb2$export$fac44ee5b035f737 = $4890141b1bd02fb2$var$querystringify;
$4890141b1bd02fb2$export$98e6a39c04603d36 = $4890141b1bd02fb2$var$querystring;

});


parcelRegister("cF6yY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $937e67ab6b438280$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $1ifhQ = parcelRequire("1ifhQ");

var $jIqQv = parcelRequire("jIqQv");
/* This should match what react-router does to compute a root match. */ const $937e67ab6b438280$var$computeRootMatch = (pathname)=>({
        path: "/",
        url: "/",
        params: {},
        isExact: pathname === "/",
        query: {}
    });
function $937e67ab6b438280$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $1ifhQ.default)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $937e67ab6b438280$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $jIqQv.default)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, pathMatch), {}, {
        query: {}
    });
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $937e67ab6b438280$export$2e2bcd8739ae039 = $937e67ab6b438280$var$execRouteMatching;

});
parcelRegister("1ifhQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f135488cf8e8eed$export$2e2bcd8739ae039; });
// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

var $2lTNZ = parcelRequire("2lTNZ");
const $0f135488cf8e8eed$var$cache = {};
const $0f135488cf8e8eed$var$cacheLimit = 10000;
let $0f135488cf8e8eed$var$cacheCount = 0;
function $0f135488cf8e8eed$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $0f135488cf8e8eed$var$cache[cacheKey] || ($0f135488cf8e8eed$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, (/*@__PURE__*/$parcel$interopDefault($2lTNZ)))(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($0f135488cf8e8eed$var$cacheCount < $0f135488cf8e8eed$var$cacheLimit) {
        pathCache[path] = result;
        $0f135488cf8e8eed$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $0f135488cf8e8eed$var$matchPath(pathname, options = {}) {
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = "" } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== "") return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $0f135488cf8e8eed$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            isExact: // the matched portion of the URL
            isExact,
            // whether or not we matched exactly
            params: keys.reduce((memo, key, index)=>{
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $0f135488cf8e8eed$export$2e2bcd8739ae039 = $0f135488cf8e8eed$var$matchPath;

});
parcelRegister("2lTNZ", function(module, exports) {

var $7uZFz = parcelRequire("7uZFz");
/**
 * Expose `pathToRegexp`.
 */ module.exports = $1b68d4b0aff43560$var$pathToRegexp;
module.exports.parse = $1b68d4b0aff43560$var$parse;
module.exports.compile = $1b68d4b0aff43560$var$compile;
module.exports.tokensToFunction = $1b68d4b0aff43560$var$tokensToFunction;
module.exports.tokensToRegExp = $1b68d4b0aff43560$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $1b68d4b0aff43560$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $1b68d4b0aff43560$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $1b68d4b0aff43560$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $1b68d4b0aff43560$var$escapeGroup(pattern) : asterisk ? ".*" : "[^" + $1b68d4b0aff43560$var$escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $1b68d4b0aff43560$var$compile(str, options) {
    return $1b68d4b0aff43560$var$tokensToFunction($1b68d4b0aff43560$var$parse(str, options));
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $1b68d4b0aff43560$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $1b68d4b0aff43560$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $1b68d4b0aff43560$var$tokensToFunction(tokens) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$");
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $1b68d4b0aff43560$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($7uZFz(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $1b68d4b0aff43560$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $1b68d4b0aff43560$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $1b68d4b0aff43560$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $1b68d4b0aff43560$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $1b68d4b0aff43560$var$flags(options) {
    return options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $1b68d4b0aff43560$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $1b68d4b0aff43560$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $1b68d4b0aff43560$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($1b68d4b0aff43560$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $1b68d4b0aff43560$var$flags(options));
    return $1b68d4b0aff43560$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $1b68d4b0aff43560$var$stringToRegexp(path, keys, options) {
    return $1b68d4b0aff43560$var$tokensToRegExp($1b68d4b0aff43560$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $1b68d4b0aff43560$var$tokensToRegExp(tokens, keys, options) {
    if (!$7uZFz(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $1b68d4b0aff43560$var$escapeString(token);
        else {
            var prefix = $1b68d4b0aff43560$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $1b68d4b0aff43560$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $1b68d4b0aff43560$var$attachKeys(new RegExp("^" + route, $1b68d4b0aff43560$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $1b68d4b0aff43560$var$pathToRegexp(path, keys, options) {
    if (!$7uZFz(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $1b68d4b0aff43560$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($7uZFz(path)) return $1b68d4b0aff43560$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $1b68d4b0aff43560$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

});
parcelRegister("7uZFz", function(module, exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};

});



parcelRegister("jIqQv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5a6f3696947cbe3$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");
/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $e5a6f3696947cbe3$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split("=");
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes("!=")) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split("|").map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes("?")) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || "";
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith("(")) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || "");
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, pathMatch), {}, {
        query: queryMatch
    }) : null;
}
var $e5a6f3696947cbe3$export$2e2bcd8739ae039 = $e5a6f3696947cbe3$var$matchQuery;

});


parcelRegister("hSADK", function(module, exports) {

$parcel$export(module.exports, "matchRouteCache", function () { return $d043e6c7a08186af$export$f594abf16a5ad948; });
const $d043e6c7a08186af$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $d043e6c7a08186af$var$MAX_CACHE_SIZE = 1000;
function $d043e6c7a08186af$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
     // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!$d043e6c7a08186af$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $d043e6c7a08186af$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($d043e6c7a08186af$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $d043e6c7a08186af$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $d043e6c7a08186af$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};

});


parcelRegister("3iYiT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2681d495f556e965$export$2e2bcd8739ae039; });

var $2lTNZ = parcelRequire("2lTNZ");
const $2681d495f556e965$var$generatePath = (pattern = "/", params)=>pattern === "/" ? pattern : (0, (/*@__PURE__*/$parcel$interopDefault($2lTNZ))).compile(pattern)(params);
var $2681d495f556e965$export$2e2bcd8739ae039 = $2681d495f556e965$var$generatePath;

});

parcelRegister("fdjhe", function(module, exports) {

$parcel$export(module.exports, "generateLocationFromPath", function () { return $b13705e92124aec2$export$37e0729cc751960b; });

var $2lTNZ = parcelRequire("2lTNZ");

var $i0bJB = parcelRequire("i0bJB");
function $b13705e92124aec2$export$37e0729cc751960b(pattern = "/", options = {}) {
    const { params: params = {}, query: query = {}, basePath: basePath = "" } = options; // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $i0bJB.qs).stringify(query, true);
    const pathname = pattern === "/" ? pattern : (0, (/*@__PURE__*/$parcel$interopDefault($2lTNZ))).compile(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ""
    };
}

});

parcelRegister("gCPwG", function(module, exports) {

$parcel$export(module.exports, "isServerEnvironment", function () { return $c1a829f5bab6fe6f$export$455cc18296abe008; });
/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $8ovux = parcelRequire("8ovux");
const $c1a829f5bab6fe6f$var$isJsDomEnvironment = ()=>window.name === "nodejs" || navigator.userAgent.includes("Node.js") || navigator.userAgent.includes("jsdom");
const $c1a829f5bab6fe6f$export$455cc18296abe008 = ()=>{
    if (typeof $8ovux !== "undefined" && $8ovux.versions != null && $8ovux.versions.node != null) return true;
    if ($c1a829f5bab6fe6f$var$isJsDomEnvironment()) return true;
    return false;
};

});

parcelRegister("kjtme", function(module, exports) {

$parcel$export(module.exports, "createRouterContext", function () { return $ec9c5ace5560fe22$export$faed15f35ddc6f99; });
$parcel$export(module.exports, "findRouterContext", function () { return $ec9c5ace5560fe22$export$a0bd0313cbeabd49; });

var $i0bJB = parcelRequire("i0bJB");

var $4nzjx = parcelRequire("4nzjx");

var $aF7fC = parcelRequire("aF7fC");

var $3iYiT = parcelRequire("3iYiT");
const $ec9c5ace5560fe22$export$faed15f35ddc6f99 = (route, options = {})=>{
    const { params: params = {}, query: query = {}, basePath: basePath = "" } = options;
    const pathname = (0, $3iYiT.default)(route.path, params);
    const matchedRoute = (0, $aF7fC.default)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $4nzjx.DEFAULT_MATCH),
        query: query
    };
};
const $ec9c5ace5560fe22$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = "" } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $i0bJB.qs).parse(search);
    const matchedRoute = (0, $aF7fC.default)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $4nzjx.DEFAULT_ROUTE),
        match: matchedRoute ? matchedRoute.match : (0, $4nzjx.DEFAULT_MATCH)
    };
};

});


parcelRegister("dp7nP", function(module, exports) {

$parcel$export(module.exports, "isExternalAbsolutePath", function () { return (parcelRequire("eR0w1")).isExternalAbsolutePath; });
$parcel$export(module.exports, "getRelativePath", function () { return (parcelRequire("eR0w1")).getRelativePath; });
$parcel$export(module.exports, "updateQueryParams", function () { return (parcelRequire("eR0w1")).updateQueryParams; });
$parcel$export(module.exports, "getRelativeURLFromLocation", function () { return (parcelRequire("eR0w1")).getRelativeURLFromLocation; });

var $eR0w1 = parcelRequire("eR0w1");

});
parcelRegister("eR0w1", function(module, exports) {

$parcel$export(module.exports, "isExternalAbsolutePath", function () { return $ad066a4bd6e6ad40$export$2fa6dede99f181e5; });
$parcel$export(module.exports, "getRelativePath", function () { return $ad066a4bd6e6ad40$export$ae9fda833d91ed65; });
$parcel$export(module.exports, "updateQueryParams", function () { return $ad066a4bd6e6ad40$export$92377f461a797888; });
$parcel$export(module.exports, "getRelativeURLFromLocation", function () { return $ad066a4bd6e6ad40$export$9ae1c7c875ef309d; });

var $i0bJB = parcelRequire("i0bJB");
const $ad066a4bd6e6ad40$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
const $ad066a4bd6e6ad40$var$addLeadingSlash = (path)=>path.charAt(0) === "/" ? path : "/" + path;
const $ad066a4bd6e6ad40$export$b8ce2e8154d1dff1 = (path, prefix = "")=>{
    if (prefix) {
        prefix = $ad066a4bd6e6ad40$var$stripTrailingSlash(prefix);
        prefix = $ad066a4bd6e6ad40$var$addLeadingSlash(prefix);
        path = $ad066a4bd6e6ad40$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $ad066a4bd6e6ad40$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp("^([a-z]+://|//)", "i");
    return regex.test(path);
};
const $ad066a4bd6e6ad40$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== "string" || !$ad066a4bd6e6ad40$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($i0bJB)))(path).hostname;
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($i0bJB)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $ad066a4bd6e6ad40$export$ae9fda833d91ed65 = (path, prefix = "")=>{
    if (typeof path !== "string") return path;
    if (!$ad066a4bd6e6ad40$export$e83e3719fc818ee5(path)) {
        path = $ad066a4bd6e6ad40$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($i0bJB)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $ad066a4bd6e6ad40$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $i0bJB.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $ad066a4bd6e6ad40$export$9ae1c7c875ef309d = (location)=>{
    return `${location.pathname}${location.search}${location.hash}`;
};

});





parcelRegister("scNmP", function(module, exports) {

$parcel$export(module.exports, "RouterSubscriber", function () { return $054c8a823748fa55$export$672d721d310ff5f0; });

var $j7eBO = parcelRequire("j7eBO");

var $9nHZC = parcelRequire("9nHZC");

var $4uXmK = parcelRequire("4uXmK");
const $054c8a823748fa55$export$672d721d310ff5f0 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $4uXmK.RouterSubscriber), null, (state, _ref)=>{
        let { listen: listen } = _ref, actions = (0, (/*@__PURE__*/$parcel$interopDefault($j7eBO)))(_ref, [
            "listen"
        ]);
        if (!state.unlisten && !state.isStatic) listen();
        return children(state, actions);
    });

});


parcelRegister("e4G5V", function(module, exports) {

$parcel$export(module.exports, "Router", function () { return $a3f2178534055a0d$export$55185c17a0fcbe46; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $4nzjx = parcelRequire("4nzjx");

var $4uXmK = parcelRequire("4uXmK");
class $a3f2178534055a0d$export$55185c17a0fcbe46 extends (0, $9nHZC.Component) {
    constructor(...args){
        super(...args);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "unlistenHistory", null);
    }
    componentDidMount() {
        if (!this.props.isStatic) {
            const state = (0, $4uXmK.getRouterState)();
            this.unlistenHistory = state.unlisten;
        }
    }
    /**
   * Ensures that the router store stops listening to history when the Router
   * is unmounted.
   */ componentWillUnmount() {
        if (this.unlistenHistory) this.unlistenHistory();
    }
    render() {
        const { children: children, routes: routes, history: history, initialRoute: initialRoute, isStatic: isStatic, isGlobal: isGlobal, basePath: basePath, resourceContext: resourceContext, resourceData: resourceData, onPrefetch: onPrefetch } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $4uXmK.RouterContainer), {
            basePath: basePath,
            routes: routes,
            history: history,
            initialRoute: initialRoute,
            isStatic: isStatic,
            resourceContext: resourceContext,
            resourceData: resourceData,
            onPrefetch: onPrefetch,
            isGlobal: isGlobal
        }, children);
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($a3f2178534055a0d$export$55185c17a0fcbe46, "defaultProps", {
    isStatic: false,
    isGlobal: true,
    history: (0, $4nzjx.DEFAULT_HISTORY)
});

});

parcelRegister("9jUAu", function(module, exports) {

$parcel$export(module.exports, "MemoryRouter", function () { return $6c91c884b9b7e6e4$export$ae46f04cfaffe093; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $7wvDE = parcelRequire("7wvDE");

var $e4G5V = parcelRequire("e4G5V");
const $6c91c884b9b7e6e4$var$getRouterProps = (memoryRouterProps)=>{
    const { isStatic: isStatic = false, isGlobal: isGlobal = true, basePath: basePath, routes: routes, resourceData: resourceData, resourceContext: resourceContext } = memoryRouterProps;
    let routerProps = {
        basePath: basePath,
        routes: routes,
        isStatic: isStatic,
        isGlobal: isGlobal
    };
    if (resourceData) routerProps = (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, routerProps), {}, {
        resourceData: resourceData
    });
    if (resourceContext) routerProps = (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, routerProps), {}, {
        resourceContext: resourceContext
    });
    return routerProps;
};
const $6c91c884b9b7e6e4$export$ae46f04cfaffe093 = (props)=>{
    const { location: location, children: children } = props;
    const config = {};
    if (location) config.initialEntries = [
        location
    ];
    const history = (0, $7wvDE.createMemoryHistory)(config);
    const routerProps = $6c91c884b9b7e6e4$var$getRouterProps(props);
    return(/*#__PURE__*/ // @ts-ignore suppress history will be overwritten warning
    (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $e4G5V.Router), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        history: history
    }, routerProps), children));
};

});

parcelRegister("cJdeW", function(module, exports) {

$parcel$export(module.exports, "StaticRouter", function () { return $9443f52f0a7458ae$export$cac06da4d76d935b; });

var $fPPqr = parcelRequire("fPPqr");

var $j7eBO = parcelRequire("j7eBO");

var $9nHZC = parcelRequire("9nHZC");

var $7wvDE = parcelRequire("7wvDE");
parcelRequire("9pXlG");
var $9JUE3 = parcelRequire("9JUE3");

var $9jUAu = parcelRequire("9jUAu");

var $2DxmN = parcelRequire("2DxmN");

var $4uXmK = parcelRequire("4uXmK");
const $9443f52f0a7458ae$export$cac06da4d76d935b = ({ location: location, routes: routes, children: children, basePath: basePath })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9jUAu.MemoryRouter), {
        location: location,
        routes: routes,
        basePath: basePath,
        isStatic: true
    }, children);
/**
 * The entry point for requesting resource data on the server.
 * Pass the result data into the router as a prop in order to hydrate it.
 * TODO: return type (see imports)
 */ $9443f52f0a7458ae$export$cac06da4d76d935b.requestResources = async (props)=>{
    const { bootstrapStore: bootstrapStore, requestRouteResources: requestRouteResources } = (0, $4uXmK.getRouterStore)().actions;
    const { location: location, timeout: timeout } = props, bootstrapProps = (0, (/*@__PURE__*/$parcel$interopDefault($j7eBO)))(props, [
        "location",
        "timeout"
    ]);
    const initialEntries = [
        location
    ];
    const overrides = {
        history: (0, $7wvDE.createMemoryHistory)({
            initialEntries: initialEntries
        }),
        location: (0, $9JUE3.createLocation)(location),
        isStatic: true
    };
    bootstrapStore((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, bootstrapProps), overrides));
    await requestRouteResources({
        timeout: timeout,
        isStatic: true
    });
    return (0, $2DxmN.getResourceStore)().actions.getSafeData();
};
$9443f52f0a7458ae$export$cac06da4d76d935b.addResourcesListener = (fn)=>(0, $2DxmN.getResourceStore)().storeState.subscribe(fn);

});
parcelRegister("9pXlG", function(module, exports) {

$parcel$export(module.exports, "createLocation", function () { return (parcelRequire("9JUE3")).createLocation; });

var $9JUE3 = parcelRequire("9JUE3");

});
parcelRegister("9JUE3", function(module, exports) {

$parcel$export(module.exports, "createLocation", function () { return $7174418e0a0bbf8d$export$90c043f1c57770b8; });

var $dN0Mt = parcelRequire("dN0Mt");

var $lpn4B = parcelRequire("lpn4B");
function $7174418e0a0bbf8d$export$90c043f1c57770b8(path = "") {
    const location = (0, $lpn4B.parsePath)(path);
    location.pathname = (0, $dN0Mt.decodePath)(location.pathname);
    return location;
}

});
parcelRegister("dN0Mt", function(module, exports) {

$parcel$export(module.exports, "decodePath", function () { return $a0a075043876849b$export$cd27bea214d030c2; });
class $a0a075043876849b$var$DecodeUriError extends URIError {
    constructor(path){
        super(`Pathname ${path} could not be decoded. This is likely caused by an invalid percent-encoding.`);
    }
}
function $a0a075043876849b$export$cd27bea214d030c2(path) {
    try {
        return decodeURI(path);
    } catch (e) {
        if (e instanceof URIError) throw new $a0a075043876849b$var$DecodeUriError(path);
        else throw e;
    }
}

});

parcelRegister("lpn4B", function(module, exports) {

$parcel$export(module.exports, "parsePath", function () { return $0405a476382e39b5$export$8ccf933b0513f8d0; });

var $i0bJB = parcelRequire("i0bJB");
function $0405a476382e39b5$export$8ccf933b0513f8d0(path) {
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($i0bJB)))(path, "ws://a.a");
    const isAbsolute = path.startsWith("/");
    const pathname = isAbsolute || url.pathname === "/" ? url.pathname : url.pathname.slice(1);
    return {
        pathname: pathname,
        search: url.query,
        hash: url.hash
    };
}

});




parcelRegister("3YX7r", function(module, exports) {

var $j7eBO = parcelRequire("j7eBO");

var $9nHZC = parcelRequire("9nHZC");

var $4uXmK = parcelRequire("4uXmK");
const $2e64d579b5affa3c$export$b371fa9cf762ad06 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $4uXmK.RouterActionsSubscriber), null, (__, _ref)=>{
        let actions = (0, (/*@__PURE__*/$parcel$interopDefault($j7eBO)))(_ref, [
            "bootstrapStore",
            "listen",
            "requestRouteResources"
        ]);
        return children(actions);
    });
$2e64d579b5affa3c$export$b371fa9cf762ad06.displayName = "RouterActions";

});

parcelRegister("jQl2W", function(module, exports) {

$parcel$export(module.exports, "Redirect", function () { return $e723330e8011de68$export$2d8d895a0a0f636e; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $7wvDE = parcelRequire("7wvDE");

var $scNmP = parcelRequire("scNmP");
parcelRequire("1CNor");
var $fdjhe = parcelRequire("fdjhe");
class $e723330e8011de68$var$Redirector extends (0, $9nHZC.Component) {
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = typeof to === "object" ? "path" in to ? (0, $7wvDE.createPath)((0, $fdjhe.generateLocationFromPath)(to.path, routeAttributes)) : (0, $7wvDE.createPath)(to) : to;
        const currentPath = (0, $7wvDE.createPath)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($e723330e8011de68$var$Redirector, "defaultProps", {
    push: false
});
const $e723330e8011de68$export$2d8d895a0a0f636e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $scNmP.RouterSubscriber), null, ({ location: location }, actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($e723330e8011de68$var$Redirector, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            actions: actions,
            location: location
        }, props)));

});

parcelRegister("gp8oT", function(module, exports) {

$parcel$export(module.exports, "withRouter", function () { return $0314fdec9addd647$export$369b6b2b30582e8e; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $scNmP = parcelRequire("scNmP");
const $0314fdec9addd647$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = "UNDEFINED";
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $0314fdec9addd647$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $0314fdec9addd647$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $scNmP.RouterSubscriber), null, ({ route: route, location: location, query: query, match: match, action: action, history: history }, { push: push, replace: replace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
                route: route,
                location: location,
                query: query,
                match: match,
                action: action,
                history: history,
                push: push,
                replace: replace
            })));
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};

});

parcelRegister("ix8QB", function(module, exports) {

$parcel$export(module.exports, "useResource", function () { return (parcelRequire("2kz4a")).useResource; });
$parcel$export(module.exports, "useRouter", function () { return (parcelRequire("b7V6F")).useRouter; });
$parcel$export(module.exports, "useRouterActions", function () { return (parcelRequire("b7V6F")).useRouterActions; });
$parcel$export(module.exports, "useQueryParam", function () { return (parcelRequire("b7V6F")).useQueryParam; });
$parcel$export(module.exports, "usePathParam", function () { return (parcelRequire("b7V6F")).usePathParam; });

var $2kz4a = parcelRequire("2kz4a");

var $b7V6F = parcelRequire("b7V6F");

});
parcelRegister("b7V6F", function(module, exports) {

$parcel$export(module.exports, "useRouter", function () { return $819ca557c1b8a86c$export$9a302a45f65d0572; });
$parcel$export(module.exports, "useRouterActions", function () { return $819ca557c1b8a86c$export$402e82ff1b20594b; });
$parcel$export(module.exports, "useQueryParam", function () { return $819ca557c1b8a86c$export$ae316f0eeb712a36; });
$parcel$export(module.exports, "usePathParam", function () { return $819ca557c1b8a86c$export$8c8591dcd57728e6; });

var $9nHZC = parcelRequire("9nHZC");

var $kdlrL = parcelRequire("kdlrL");

var $4uXmK = parcelRequire("4uXmK");
const $819ca557c1b8a86c$export$9a302a45f65d0572 = ()=>{
    const [entireState, allActions] = (0, $4uXmK.useRouterStore)();
    return [
        entireState,
        allActions
    ];
};
const $819ca557c1b8a86c$export$402e82ff1b20594b = ()=>{
    const [, allActions] = (0, $4uXmK.useRouterStoreStatic)();
    return allActions;
};
const $819ca557c1b8a86c$var$createQueryParamHook = (0, $kdlrL.createHook)((0, $4uXmK.RouterStore), {
    selector: ({ query: query }, { paramKey: paramKey })=>query[paramKey]
});
const $819ca557c1b8a86c$var$createPathParamHook = (0, $kdlrL.createHook)((0, $4uXmK.RouterStore), {
    selector: ({ match: { params: params } }, { paramKey: paramKey })=>params[paramKey]
});
const $819ca557c1b8a86c$export$ae316f0eeb712a36 = (paramKey)=>{
    const [paramVal, routerActions] = $819ca557c1b8a86c$var$createQueryParamHook({
        paramKey: paramKey
    });
    const setQueryParam = (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).useCallback((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};
const $819ca557c1b8a86c$export$8c8591dcd57728e6 = (paramKey)=>{
    const [paramVal, routerActions] = $819ca557c1b8a86c$var$createPathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).useCallback((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};

});


parcelRegister("3kfkg", function(module, exports) {

$parcel$export(module.exports, "createResource", function () { return $26bf20c50f234c14$export$edd172c6c83c39cc; });

var $8hQ51 = parcelRequire("8hQ51");
/**
 * Utility method to created async versions of getData functions
 *
 */ const $26bf20c50f234c14$var$handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const $26bf20c50f234c14$export$edd172c6c83c39cc = (arg)=>{
    var _getData, _arg$depends;
    return {
        type: arg.type,
        getKey: arg.getKey,
        getData: (_getData = arg.getData) != null ? _getData : $26bf20c50f234c14$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === "number" ? arg.maxAge : (0, $8hQ51.DEFAULT_RESOURCE_MAX_AGE),
        maxCache: typeof arg.maxCache === "number" ? arg.maxCache : (0, $8hQ51.DEFAULT_CACHE_MAX_LIMIT),
        isBrowserOnly: typeof arg.isBrowserOnly === "boolean" ? arg.isBrowserOnly : (0, $8hQ51.DEFAULT_RESOURCE_BROWSER_ONLY),
        depends: (_arg$depends = arg.depends) != null ? _arg$depends : null
    };
};

});


parcelRegister("5pvjw", function(module, exports) {

$parcel$export(module.exports, "Link", function () { return (parcelRequire("iPZCM")).default; });
$parcel$export(module.exports, "RouteComponent", function () { return (parcelRequire("cpagJ")).RouteComponent; });

var $iPZCM = parcelRequire("iPZCM");

var $cpagJ = parcelRequire("cpagJ");

});
parcelRegister("iPZCM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db6ccabf253a02d4$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $j7eBO = parcelRequire("j7eBO");

var $7wvDE = parcelRequire("7wvDE");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("1CNor");
var $kjtme = parcelRequire("kjtme");
var $fdjhe = parcelRequire("fdjhe");

var $4uXmK = parcelRequire("4uXmK");
parcelRequire("faZK3");
var $7wpar = parcelRequire("7wpar");
var $7Idgq = parcelRequire("7Idgq");
const $db6ccabf253a02d4$var$PREFETCH_DELAY = 300;
const $db6ccabf253a02d4$var$Link = (0, $9nHZC.forwardRef)((_ref, ref)=>{
    let { children: children, target: target = "_self", replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, type: linkType = "a", params: params, query: query, prefetch: prefetch = false } = _ref, rest = (0, (/*@__PURE__*/$parcel$interopDefault($j7eBO)))(_ref, [
        "children",
        "target",
        "replace",
        "href",
        "to",
        "onClick",
        "onMouseEnter",
        "onMouseLeave",
        "type",
        "params",
        "query",
        "prefetch"
    ]);
    const routerActions = (0, $4uXmK.useRouterStoreStatic)()[1];
    const prefetchRef = (0, $9nHZC.useRef)();
    const validLinkType = (0, $7wpar.getValidLinkType)(linkType);
    const [route, setRoute] = (0, $9nHZC.useState)(()=>{
        if (to && typeof to !== "string") {
            if ("then" in to) to.then((r)=>setRoute("default" in r ? r.default : r));
            else return to;
        }
    });
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = href != null ? href : typeof to !== "string" ? route && (0, $7wvDE.createPath)((0, $fdjhe.generateLocationFromPath)(route.path, routeAttributes)) || "" : to;
    const triggerPrefetch = (0, $9nHZC.useCallback)(()=>{
        prefetchRef.current = undefined; // ignore if async route not ready yet
        if (typeof to !== "string" && !route) return;
        const context = typeof to !== "string" && route ? (0, $kjtme.createRouterContext)(route, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchNextRouteResources(linkDestination, context); // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        linkDestination,
        routerActions
    ]);
    (0, $9nHZC.useEffect)(()=>{
        let timeout;
        if (prefetch === "mount") timeout = setTimeout(triggerPrefetch, $db6ccabf253a02d4$var$PREFETCH_DELAY);
        return ()=>clearTimeout(timeout);
    }, [
        prefetch,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $7Idgq.handleNavigation)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: route && [
                route,
                {
                    params: params,
                    query: query
                }
            ]
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === "hover") prefetchRef.current = setTimeout(triggerPrefetch, $db6ccabf253a02d4$var$PREFETCH_DELAY);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === "hover" && prefetchRef.current) {
            clearTimeout(prefetchRef.current);
            prefetchRef.current = undefined;
        }
        onMouseLeave && onMouseLeave(e);
    };
    return (0, $9nHZC.createElement)(validLinkType, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest), {}, {
        href: linkDestination,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        ref: ref
    }), children);
});
$db6ccabf253a02d4$var$Link.displayName = "Link";
var $db6ccabf253a02d4$export$2e2bcd8739ae039 = $db6ccabf253a02d4$var$Link;

});
parcelRegister("faZK3", function(module, exports) {

$parcel$export(module.exports, "getValidLinkType", function () { return (parcelRequire("7wpar")).getValidLinkType; });
$parcel$export(module.exports, "handleNavigation", function () { return (parcelRequire("7Idgq")).handleNavigation; });

var $7wpar = parcelRequire("7wpar");

var $7Idgq = parcelRequire("7Idgq");

});
parcelRegister("7wpar", function(module, exports) {

$parcel$export(module.exports, "getValidLinkType", function () { return $579f0b46dda2fcc0$export$855ece989b15eb57; });
const $579f0b46dda2fcc0$var$VALID_LINK_TYPES = [
    "a",
    "button"
];
const $579f0b46dda2fcc0$export$855ece989b15eb57 = (type)=>$579f0b46dda2fcc0$var$VALID_LINK_TYPES.includes(type) ? type : "a";

});

parcelRegister("7Idgq", function(module, exports) {

$parcel$export(module.exports, "handleNavigation", function () { return $59d6ee63ff482b5b$export$706ad1af8096e280; });

var $ev91x = parcelRequire("ev91x");
const $59d6ee63ff482b5b$export$706ad1af8096e280 = (event, { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to })=>{
    if ((0, $ev91x.isKeyboardEvent)(event) && event.keyCode !== 13) return;
    onClick && onClick(event);
    if (!event.defaultPrevented && ((0, $ev91x.isKeyboardEvent)(event) && event.keyCode === 13 || event.button === 0) && (!target || target === "_self") && // let browser handle "target=_blank" etc.
    !(0, $ev91x.isModifiedEvent)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href);
        }
    }
};

});
parcelRegister("ev91x", function(module, exports) {

$parcel$export(module.exports, "isModifiedEvent", function () { return $a8eaf5e25ac6745d$export$642c6f14f6d4bbd5; });
$parcel$export(module.exports, "isKeyboardEvent", function () { return $a8eaf5e25ac6745d$export$130b789831072f4c; });
const $a8eaf5e25ac6745d$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $a8eaf5e25ac6745d$export$130b789831072f4c = (event)=>[
        "keypress",
        "keydown",
        "keyup"
    ].includes(event.type);

});




parcelRegister("cpagJ", function(module, exports) {

$parcel$export(module.exports, "RouteComponent", function () { return $907fc900f29dfc9f$export$7903e4b73fc7d6c3; });

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("3G5l7");
var $scNmP = parcelRequire("scNmP");
const $907fc900f29dfc9f$export$7903e4b73fc7d6c3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $scNmP.RouterSubscriber), null, ({ route: route, location: location, query: query, match: match, action: action })=>!route ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(route.component, {
            route: route,
            location: location,
            query: query,
            match: match,
            action: action
        }));

});



parcelRegister("fM82h", function(module, exports) {

$parcel$export(module.exports, "useResource", function () { return $b7c19277562ace60$export$9f6abfd74295843b; });

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("7hcP7");
var $2kz4a = parcelRequire("2kz4a");

var $59ZFR = parcelRequire("59ZFR");
function $b7c19277562ace60$export$9f6abfd74295843b() {
    var ufoContext = (0, $59ZFR.useInteractionContext)();
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var returnValues = (0, $2kz4a.useResource).apply(void 0, args);
    var operationName = args[0].type;
    var isLoading = returnValues === null || returnValues === void 0 ? void 0 : returnValues.loading;
    (0, $9nHZC.useLayoutEffect)(function() {
        if (isLoading) return ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.hold(operationName);
    }, [
        isLoading,
        operationName,
        ufoContext
    ]);
    return returnValues;
}

});


parcelRegister("dObIf", function(module, exports) {

$parcel$export(module.exports, "startLighthouseObserver", function () { return $a0d907bf4e923b78$export$5ecf2aafafee3e0; });
$parcel$export(module.exports, "getLighthouseMetrics", function () { return $a0d907bf4e923b78$export$b46cecdf698e4bb5; });

var $h8yP9 = parcelRequire("h8yP9");

var $cKfo8 = parcelRequire("cKfo8");

var $58q1Z = parcelRequire("58q1Z");

var $gjpom = parcelRequire("gjpom");

var $hs92s = parcelRequire("hs92s");
function $a0d907bf4e923b78$export$5ecf2aafafee3e0() {
    (0, $hs92s.startLSObserver)();
    (0, $hs92s.startLTObserver)();
}
var $a0d907bf4e923b78$export$b46cecdf698e4bb5 = function getLighthouseMetrics(_ref) {
    var start = _ref.start, stop = _ref.stop;
    var tbt = (0, $58q1Z.getTBT)(start, stop, (0, $gjpom.EntriesBuffer)[(0, $cKfo8.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    var cls = (0, $h8yP9.getCLS)(start, stop, (0, $gjpom.EntriesBuffer)[(0, $cKfo8.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        "metric:tbt": Math.round(tbt.total),
        "metric:tbt:observed": Math.round(tbt.observed),
        "metric:cls": cls
    };
};

});
parcelRegister("h8yP9", function(module, exports) {

$parcel$export(module.exports, "getCLS", function () { return $c79e32537a5245f8$export$fc6227831ee7c7; });
function $c79e32537a5245f8$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $c79e32537a5245f8$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $c79e32537a5245f8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c79e32537a5245f8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c79e32537a5245f8$var$_arrayLikeToArray(o, minLen);
}
function $c79e32537a5245f8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $c79e32537a5245f8$export$fc6227831ee7c7 = function getCLS(start, stop, buffer) {
    var layoutShifts = buffer.getAll().filter(function(entry) {
        return entry.startTime >= start && entry.startTime <= stop;
    });
    var sessionWindows = [];
    var currentWindow = null;
    // Group layout shifts into session windows
    var _iterator = $c79e32537a5245f8$var$_createForOfIteratorHelper(layoutShifts), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var shift = _step.value;
            var startTime = shift.startTime;
            var endTime = shift.startTime + shift.duration;
            var score = shift.value;
            if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
                // Start a new session window
                currentWindow = {
                    startTime: startTime,
                    endTime: endTime,
                    score: score
                };
                sessionWindows.push(currentWindow);
            } else {
                // Add layout shift to current session window
                currentWindow.endTime = endTime;
                currentWindow.score += score;
            }
        }
    // Find session window with highest cumulative score
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var maxScore = sessionWindows.reduce(function(max, sessionWindow) {
        return sessionWindow.score > max ? sessionWindow.score : max;
    }, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
};

});

parcelRegister("cKfo8", function(module, exports) {

$parcel$export(module.exports, "PerformanceObserverEntryTypes", function () { return $9475b7ae39c7f055$export$a4def92db6fc8e17; });
var $9475b7ae39c7f055$export$a4def92db6fc8e17 = {
    LayoutShift: "layout-shift",
    LongTask: "longtask"
};

});

parcelRegister("58q1Z", function(module, exports) {

$parcel$export(module.exports, "getTBT", function () { return $3bd1e4519117f9d4$export$2d6e933b35bd3407; });
var $3bd1e4519117f9d4$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
var $3bd1e4519117f9d4$export$2d6e933b35bd3407 = function getTBT(start, stop, buffer) {
    return buffer.getAll().filter(function(entry) {
        return entry.startTime <= stop && entry.duration > $3bd1e4519117f9d4$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop);
    }).reduce(function(tbt, entry) {
        var longTaskStop = entry.startTime + entry.duration;
        var intersectStart = Math.max(entry.startTime + $3bd1e4519117f9d4$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        var intersectStop = Math.min(longTaskStop, stop);
        var longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $3bd1e4519117f9d4$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });
};

});

parcelRegister("gjpom", function(module, exports) {

$parcel$export(module.exports, "EntriesBuffer", function () { return $be021e01fa235a48$export$f7dc16cbd16f7bbe; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");

var $cKfo8 = parcelRequire("cKfo8");
var $be021e01fa235a48$var$_EntriesBuffer;
var $be021e01fa235a48$export$2c6e86519c9e8188 = /*#__PURE__*/ function() {
    function BufferWithMaxLength() {
        var maxLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, BufferWithMaxLength);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "buffer", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "full", false);
        this.maxLength = maxLength;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(BufferWithMaxLength, [
        {
            key: "push",
            value: function push(item) {
                if (this.full || this.maxLength === this.buffer.length) {
                    this.full = true;
                    this.buffer.shift();
                }
                this.buffer.push(item);
            }
        },
        {
            key: "getAll",
            value: function getAll() {
                return this.buffer;
            }
        }
    ]);
    return BufferWithMaxLength;
}();
var $be021e01fa235a48$export$f7dc16cbd16f7bbe = ($be021e01fa235a48$var$_EntriesBuffer = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($be021e01fa235a48$var$_EntriesBuffer, (0, $cKfo8.PerformanceObserverEntryTypes).LongTask, new $be021e01fa235a48$export$2c6e86519c9e8188()), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($be021e01fa235a48$var$_EntriesBuffer, (0, $cKfo8.PerformanceObserverEntryTypes).LayoutShift, new $be021e01fa235a48$export$2c6e86519c9e8188()), $be021e01fa235a48$var$_EntriesBuffer);

});

parcelRegister("hs92s", function(module, exports) {

$parcel$export(module.exports, "startLSObserver", function () { return $cb4c100d9d1c5abe$export$768ccc3ab7bac3ea; });
$parcel$export(module.exports, "startLTObserver", function () { return $cb4c100d9d1c5abe$export$54fb8b6aaf70ec9c; });

var $cKfo8 = parcelRequire("cKfo8");

var $gjpom = parcelRequire("gjpom");
var $cb4c100d9d1c5abe$var$pe = null;
var $cb4c100d9d1c5abe$var$getObserver = function getObserver() {
    if ($cb4c100d9d1c5abe$var$pe !== null) return $cb4c100d9d1c5abe$var$pe;
    $cb4c100d9d1c5abe$var$pe = new PerformanceObserver(function(list) {
        list.getEntries().forEach(function(entry) {
            if (entry.entryType === (0, $cKfo8.PerformanceObserverEntryTypes).LayoutShift) (0, $gjpom.EntriesBuffer)[(0, $cKfo8.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $cKfo8.PerformanceObserverEntryTypes).LongTask) (0, $gjpom.EntriesBuffer)[(0, $cKfo8.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    });
    return $cb4c100d9d1c5abe$var$pe;
};
var $cb4c100d9d1c5abe$export$768ccc3ab7bac3ea = function startLSObserver() {
    $cb4c100d9d1c5abe$var$getObserver().observe({
        type: (0, $cKfo8.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
};
var $cb4c100d9d1c5abe$export$54fb8b6aaf70ec9c = function startLTObserver() {
    $cb4c100d9d1c5abe$var$getObserver().observe({
        type: (0, $cKfo8.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
};

});


parcelRegister("hDvgZ", function(module, exports) {

$parcel$export(module.exports, "initTTVC", function () { return $cd6e565c1c7208ad$export$86bcaecd2fb4e67a; });
$parcel$export(module.exports, "getLastVisibleChangeTimestamp", function () { return $cd6e565c1c7208ad$export$c86ad43a55bd354b; });
$parcel$export(module.exports, "cancelTTVC", function () { return $cd6e565c1c7208ad$export$42e7ba3cdfd3867d; });

var $1FiMp = parcelRequire("1FiMp");

var $Qfq3Z = parcelRequire("Qfq3Z");

var $8abPV = parcelRequire("8abPV");

var $cgbr3 = parcelRequire("cgbr3");

var $7NZ8A = parcelRequire("7NZ8A");
var $cd6e565c1c7208ad$var$calculator;
var $cd6e565c1c7208ad$var$whenActivated = function whenActivated(callback) {
    if (document.prerendering) (0, $1FiMp.bind)(window, {
        type: "prerenderingchange",
        listener: callback,
        options: {
            capture: true
        }
    });
    else callback();
};
var $cd6e565c1c7208ad$export$86bcaecd2fb4e67a = function initTTVC(options) {
    // apply options
    (0, $Qfq3Z.setConfig)(options);
    (0, $8abPV.Logger).info("init()");
    $cd6e565c1c7208ad$var$calculator = (0, $7NZ8A.getVisuallyCompleteCalculator)();
    $cd6e565c1c7208ad$var$whenActivated(function() {
        $cd6e565c1c7208ad$var$calculator.start();
        // restart measurement for SPA navigation
        (0, $1FiMp.bind)(window, {
            type: "locationchange",
            listener: function listener(event) {
                return void $cd6e565c1c7208ad$var$calculator.start(event.timeStamp);
            }
        });
        // restart measurement on back/forward cache page restoration
        (0, $1FiMp.bind)(window, {
            type: "pageshow",
            listener: function listener(event) {
                // abort if this is the initial pageload
                if (!event.persisted) return;
                $cd6e565c1c7208ad$var$calculator.start(event.timeStamp, true);
            }
        });
    });
};
var $cd6e565c1c7208ad$export$412a2c372c050ade = function onTTVC(successCallback, errorCallback) {
    var _calculator;
    return (_calculator = $cd6e565c1c7208ad$var$calculator) === null || _calculator === void 0 ? void 0 : _calculator.onTTVC(successCallback, errorCallback);
};
var $cd6e565c1c7208ad$export$17a3d6a590b12a1f = function startTTVC() {
    var _calculator2;
    return (_calculator2 = $cd6e565c1c7208ad$var$calculator) === null || _calculator2 === void 0 ? void 0 : _calculator2.start(performance.now());
};
var $cd6e565c1c7208ad$export$c86ad43a55bd354b = function getLastVisibleChangeTimestamp() {
    var _calculator3;
    return (_calculator3 = $cd6e565c1c7208ad$var$calculator) === null || _calculator3 === void 0 ? void 0 : _calculator3.getLastVisibleChangeTimestamp();
};
var $cd6e565c1c7208ad$export$42e7ba3cdfd3867d = function cancelTTVC(eventType) {
    var _calculator4;
    return (_calculator4 = $cd6e565c1c7208ad$var$calculator) === null || _calculator4 === void 0 ? void 0 : _calculator4.cancel(eventType);
};
var $cd6e565c1c7208ad$export$10f1999b2127f137 = function incrementAjaxCount() {
    var networkIdleObservable = (0, $cgbr3.getNetworkIdleObservable)();
    networkIdleObservable.incrementAjaxCount();
};
var $cd6e565c1c7208ad$export$7921fe926596c495 = function decrementAjaxCount() {
    var networkIdleObservable = (0, $cgbr3.getNetworkIdleObservable)();
    networkIdleObservable.decrementAjaxCount();
};

});
parcelRegister("Qfq3Z", function(module, exports) {

$parcel$export(module.exports, "CONFIG", function () { return $09d0d1690badd9ca$export$1630b5343357e8b5; });
$parcel$export(module.exports, "setConfig", function () { return $09d0d1690badd9ca$export$940a7873bb071df8; });
/** ttvc configuration values set during initialization */ var $09d0d1690badd9ca$export$1630b5343357e8b5 = {
    /** Decide whether to log debug messages. */ DEBUG: false,
    /** A duration in ms to wait before declaring the page completely idle. */ IDLE_TIMEOUT: 200,
    /**
   * A duration in ms to wait before assuming that a single network request
   * was not instrumented correctly.
   *
   * If NETWORK_TIMEOUT is set to 0, disable this feature.
   */ NETWORK_TIMEOUT: 60000
};
var $09d0d1690badd9ca$export$940a7873bb071df8 = function setConfig(options) {
    if (options !== null && options !== void 0 && options.debug) $09d0d1690badd9ca$export$1630b5343357e8b5.DEBUG = options.debug;
    if (options !== null && options !== void 0 && options.idleTimeout) $09d0d1690badd9ca$export$1630b5343357e8b5.IDLE_TIMEOUT = options.idleTimeout;
    if (options !== null && options !== void 0 && options.networkTimeout) $09d0d1690badd9ca$export$1630b5343357e8b5.NETWORK_TIMEOUT = options.networkTimeout;
};

});

parcelRegister("8abPV", function(module, exports) {

$parcel$export(module.exports, "Logger", function () { return $5f1870649c2bcd35$export$efa9a398d6368992; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $Qfq3Z = parcelRequire("Qfq3Z");
var $5f1870649c2bcd35$export$efa9a398d6368992 = /*#__PURE__*/ function() {
    function Logger() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, Logger);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(Logger, null, [
        {
            key: "format",
            value: function format() {
                for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
                return [
                    "[ttvc]"
                ].concat(messages, [
                    "::",
                    performance.now()
                ]);
            }
        },
        {
            key: "debug",
            value: function debug() {
                var _console;
                if (!(0, $Qfq3Z.CONFIG).DEBUG) return;
                // eslint-disable-next-line no-console
                (_console = console).debug.apply(_console, (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(this.format.apply(this, arguments)));
            }
        },
        {
            key: "info",
            value: function info() {
                var _console2;
                if (!(0, $Qfq3Z.CONFIG).DEBUG) return;
                // eslint-disable-next-line no-console
                (_console2 = console).info.apply(_console2, (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(this.format.apply(this, arguments)));
            }
        },
        {
            key: "warn",
            value: function warn() {
                var _console3;
                if (!(0, $Qfq3Z.CONFIG).DEBUG) return;
                // eslint-disable-next-line no-console
                (_console3 = console).warn.apply(_console3, (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(this.format.apply(this, arguments)));
            }
        }
    ]);
    return Logger;
}();

});

parcelRegister("cgbr3", function(module, exports) {

$parcel$export(module.exports, "getNetworkIdleObservable", function () { return $8ecfd976eeafbafc$export$9f9afd45036ba033; });

var $eVDe4 = parcelRequire("eVDe4");

var $uqRmf = parcelRequire("uqRmf");

var $kFnE9 = parcelRequire("kFnE9");

var $1FiMp = parcelRequire("1FiMp");

var $Qfq3Z = parcelRequire("Qfq3Z");

var $8abPV = parcelRequire("8abPV");
/**
 * Alerts subscribers to the presence or absence of pending AJAX requests
 *
 * Use `increment` and `decrement` public methods to instrument your AJAX
 * requests.
 */ var $8ecfd976eeafbafc$var$AjaxIdleObservable = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(function AjaxIdleObservable() {
    var _this = this;
    (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AjaxIdleObservable);
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "pendingRequests", 0);
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "subscribers", new Set());
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "didNetworkTimeOut", false);
    // time out if ajax request never resolves
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "next", function(message) {
        (0, $8abPV.Logger).debug("AjaxIdleObservable.next()", message);
        _this.subscribers.forEach(function(subscriber) {
            return subscriber(message);
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "startCleanupTimeout", function() {
        if ((0, $Qfq3Z.CONFIG).NETWORK_TIMEOUT === 0) return;
        _this.abortCleanupTimeout();
        var cleanup = function cleanup() {
            (0, $8abPV.Logger).warn("AjaxIdleObservable", "::", "Timed out waiting for requests to resolve.", "Make sure that incrementAjaxCount() is always matched with decrementAjaxCount().", "::", "pendingRequests =", _this.pendingRequests);
            _this.didNetworkTimeOut = true;
            _this.pendingRequests = 0;
            _this.next("IDLE");
        };
        _this.cleanupTimeout = window.setTimeout(cleanup, (0, $Qfq3Z.CONFIG).NETWORK_TIMEOUT);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "abortCleanupTimeout", function() {
        window.clearTimeout(_this.cleanupTimeout);
        _this.cleanupTimeout = undefined;
    });
    /** call this whenever an instrumented AJAX request is triggered */ (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "increment", function() {
        _this.startCleanupTimeout();
        if (_this.pendingRequests === 0) _this.next("BUSY");
        _this.pendingRequests += 1;
    });
    /** call this whenever an instrumented AJAX request is resolved */ (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "decrement", function() {
        _this.abortCleanupTimeout();
        if (_this.pendingRequests === 1) _this.next("IDLE");
        else _this.startCleanupTimeout();
        _this.pendingRequests = Math.max(_this.pendingRequests - 1, 0);
        if (_this.pendingRequests < 10) (0, $8abPV.Logger).debug("AjaxIdleObservable.decrement()", "::", "pendingRequests =", _this.pendingRequests);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "subscribe", function(subscriber) {
        _this.subscribers.add(subscriber);
        var unsubscribe = function unsubscribe() {
            _this.subscribers.delete(subscriber);
        };
        return unsubscribe;
    });
});
/** Alerts subscribers to the presence or absence of pending resources */ var $8ecfd976eeafbafc$var$ResourceLoadingIdleObservable = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(// time out if resource never resolves
function ResourceLoadingIdleObservable() {
    var _this2 = this, _window;
    (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ResourceLoadingIdleObservable);
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "pendingResources", new Set());
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "subscribers", new Set());
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "didNetworkTimeOut", false);
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "next", function(message) {
        (0, $8abPV.Logger).debug("ResourceLoadingIdleObservable.next()", message);
        _this2.subscribers.forEach(function(subscriber) {
            return subscriber(message);
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "startCleanupTimeout", function() {
        if ((0, $Qfq3Z.CONFIG).NETWORK_TIMEOUT === 0) return;
        _this2.abortCleanupTimeout();
        var cleanup = function cleanup() {
            (0, $8abPV.Logger).warn("ResourceLoadingIdleObservable", "::", "Timed out waiting for resources to resolve.", "Consider filing a bug report if this continues to occur.", "::", "pendingResources =", _this2.pendingResources);
            _this2.didNetworkTimeOut = true;
            _this2.pendingResources = new Set();
            _this2.next("IDLE");
        };
        _this2.cleanupTimeout = window.setTimeout(cleanup, (0, $Qfq3Z.CONFIG).NETWORK_TIMEOUT);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "abortCleanupTimeout", function() {
        window.clearTimeout(_this2.cleanupTimeout);
        _this2.cleanupTimeout = undefined;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "add", function(element) {
        // ignore elements without resources to load
        if (element instanceof HTMLImageElement && !element.src || element instanceof HTMLImageElement && element.complete || element instanceof HTMLLinkElement && !element.href || element instanceof HTMLScriptElement && !element.src || element instanceof HTMLIFrameElement && !element.src) return;
        _this2.startCleanupTimeout();
        if (_this2.pendingResources.size === 0) _this2.next("BUSY");
        _this2.pendingResources.add(element);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "remove", function(element) {
        _this2.abortCleanupTimeout();
        _this2.pendingResources.delete(element);
        if (_this2.pendingResources.size === 0) _this2.next("IDLE");
        else _this2.startCleanupTimeout();
        if (_this2.pendingResources.size < 10) (0, $8abPV.Logger).debug("ResourceLoadingIdleObservable.remove()", "::", "pendingResources =", _this2.pendingResources);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "subscribe", function(subscriber) {
        _this2.subscribers.add(subscriber);
        var unsubscribe = function unsubscribe() {
            _this2.subscribers.delete(subscriber);
        };
        return unsubscribe;
    });
    // watch out for SSR
    if (typeof window !== "undefined" && (_window = window) !== null && _window !== void 0 && _window.MutationObserver) (0, $1FiMp.bind)(window, {
        type: "load",
        listener: function listener() {
            // watch for added or updated script tags
            var o = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    mutation.addedNodes.forEach(function(node) {
                        if (node instanceof HTMLScriptElement || node instanceof HTMLLinkElement || node instanceof HTMLImageElement || node instanceof HTMLIFrameElement) _this2.add(node);
                        else if (node.hasChildNodes() && node instanceof HTMLElement) // images may be mounted within large subtrees, this is less
                        // common with link/script elements
                        node.querySelectorAll("img").forEach(_this2.add);
                    });
                });
            });
            // watch for new tags added anywhere in the document
            o.observe(window.document.documentElement, {
                childList: true,
                subtree: true
            });
            // as resources load, remove them from pendingResources
            [
                "load",
                "error"
            ].forEach(function(eventType) {
                (0, $1FiMp.bind)(window, {
                    type: eventType,
                    listener: function listener(event) {
                        if (event.target instanceof HTMLScriptElement || event.target instanceof HTMLLinkElement || event.target instanceof HTMLImageElement || event.target instanceof HTMLIFrameElement) _this2.remove(event.target);
                    },
                    options: {
                        capture: true
                    }
                });
            });
        }
    });
});
var $8ecfd976eeafbafc$export$daa8a0ee3e297bc8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(function NetworkIdleObservable() {
    var _this3 = this;
    (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, NetworkIdleObservable);
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "ajaxIdleObservable", new $8ecfd976eeafbafc$var$AjaxIdleObservable());
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "resourceLoadingIdleObservable", new $8ecfd976eeafbafc$var$ResourceLoadingIdleObservable());
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "subscribers", new Set());
    // idle state
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "ajaxIdle", true);
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "scriptLoadingIdle", true);
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "handleUpdate", function(source) {
        return function(message) {
            var wasIdle = _this3.ajaxIdle && _this3.scriptLoadingIdle;
            // update state
            if (source === "AJAX") _this3.ajaxIdle = message === "IDLE";
            if (source === "RESOURCE_LOADING") _this3.scriptLoadingIdle = message === "IDLE";
            // if this is a change, notify subscribers
            var isIdle = _this3.ajaxIdle && _this3.scriptLoadingIdle;
            if (wasIdle !== isIdle) _this3.next(isIdle ? "IDLE" : "BUSY");
        };
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "next", function(message) {
        (0, $8abPV.Logger).debug("NetworkIdleObservable.next()", message);
        _this3.subscribers.forEach(function(subscriber) {
            return subscriber(message);
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "incrementAjaxCount", function() {
        return _this3.ajaxIdleObservable.increment();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "decrementAjaxCount", function() {
        return _this3.ajaxIdleObservable.decrement();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "isIdle", function() {
        return _this3.ajaxIdle && _this3.scriptLoadingIdle;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "didNetworkTimeOut", function() {
        return _this3.ajaxIdleObservable.didNetworkTimeOut || _this3.resourceLoadingIdleObservable.didNetworkTimeOut;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "resetDidNetworkTimeOut", function() {
        _this3.ajaxIdleObservable.didNetworkTimeOut = false;
        _this3.resourceLoadingIdleObservable.didNetworkTimeOut = false;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "subscribe", function(subscriber) {
        _this3.subscribers.add(subscriber);
        var unsubscribe = function unsubscribe() {
            _this3.subscribers.delete(subscriber);
        };
        return unsubscribe;
    });
    this.ajaxIdleObservable.subscribe(this.handleUpdate("AJAX"));
    this.resourceLoadingIdleObservable.subscribe(this.handleUpdate("RESOURCE_LOADING"));
});
// expose observable as a singleton
var $8ecfd976eeafbafc$var$networkIdleObservable;
var $8ecfd976eeafbafc$export$9f9afd45036ba033 = function getNetworkIdleObservable() {
    if (!$8ecfd976eeafbafc$var$networkIdleObservable) $8ecfd976eeafbafc$var$networkIdleObservable = new $8ecfd976eeafbafc$export$daa8a0ee3e297bc8();
    return $8ecfd976eeafbafc$var$networkIdleObservable;
};

});

parcelRegister("7NZ8A", function(module, exports) {

$parcel$export(module.exports, "getVisuallyCompleteCalculator", function () { return $5aec88a221175e00$export$90e17c8c7646069e; });

var $4mVfk = parcelRequire("4mVfk");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");

var $8DpVo = parcelRequire("8DpVo");

var $1FiMp = parcelRequire("1FiMp");

var $du6ye = parcelRequire("du6ye");

var $aDY2p = parcelRequire("aDY2p");

var $8abPV = parcelRequire("8abPV");

var $cvD12 = parcelRequire("cvD12");

var $2JvL6 = parcelRequire("2JvL6");

var $bS6Dj = parcelRequire("bS6Dj");
var $5aec88a221175e00$export$cbce095b92028433 = {
    NEW_NAVIGATION: "NEW_NAVIGATION",
    VISIBILITY_CHANGE: "VISIBILITY_CHANGE",
    USER_INTERACTION: "USER_INTERACTION",
    MANUAL_CANCELLATION: "MANUAL_CANCELLATION"
};
/**
 * Core of the TTVC calculation that ties viewport observers and network monitoring
 * into a singleton that facilitates communication of TTVC metric measurement and error
 * information to subscribers.
 */ var $5aec88a221175e00$var$VisuallyCompleteCalculator = /*#__PURE__*/ function() {
    function VisuallyCompleteCalculator() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, VisuallyCompleteCalculator);
        // configuration
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "debug", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "idleTimeout", 200);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "lastImageLoadTimestamp", -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "navigationCount", 0);
        // only one measurement should be active at a time
        // subscribers
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "successSubscribers", new Set());
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "errorSubscribers", new Set());
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "unbindFunctions", []);
        /** subscribe to Visually Complete metrics */ (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "onTTVC", function(successSubscriber, errorSubscriber) {
            // register subscriber callbacks
            _this.successSubscribers.add(successSubscriber);
            if (errorSubscriber) _this.errorSubscribers.add(errorSubscriber);
            // return an unsubscribe function
            return function() {
                _this.successSubscribers.delete(successSubscriber);
                if (errorSubscriber) _this.errorSubscribers.delete(errorSubscriber);
            };
        });
        if (!VisuallyCompleteCalculator.isSupportedEnvironment()) throw new Error("VisuallyCompleteCalculator: This browser/runtime is not supported.");
        this.inViewportMutationObserver = new (0, $aDY2p.InViewportMutationObserver)(function(mutation) {
            var _mutation$timestamp, _this$lastMutation$ti, _this$lastMutation;
            if (((_mutation$timestamp = mutation.timestamp) !== null && _mutation$timestamp !== void 0 ? _mutation$timestamp : 0) >= ((_this$lastMutation$ti = (_this$lastMutation = _this.lastMutation) === null || _this$lastMutation === void 0 ? void 0 : _this$lastMutation.timestamp) !== null && _this$lastMutation$ti !== void 0 ? _this$lastMutation$ti : 0)) _this.lastMutation = mutation;
        });
        this.inViewportImageObserver = new (0, $du6ye.InViewportImageObserver)(function(timestamp, img) {
            if (timestamp >= _this.lastImageLoadTimestamp) {
                _this.lastImageLoadTimestamp = timestamp;
                _this.lastImageLoadTarget = img;
            }
        });
    }
    /**
   * expose a method to abort the current TTVC measurement
   * @param eventType - type of event that triggered cancellation (note that cancellationReason will be set to "MANUAL_CANCELLATION" regardless of this value).
   */ (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(VisuallyCompleteCalculator, [
        {
            key: "cancel",
            value: function cancel(eventType) {
                (0, $8abPV.Logger).info("VisuallyCompleteCalculator.cancel()", "::", "index =", this.activeMeasurementIndex);
                if (this.activeMeasurementIndex) this.error({
                    start: (0, $cvD12.getActivationStart)(),
                    end: performance.now(),
                    cancellationReason: $5aec88a221175e00$export$cbce095b92028433.MANUAL_CANCELLATION,
                    eventType: eventType,
                    navigationType: (0, $cvD12.getNavigationType)(),
                    lastVisibleChange: this.getLastVisibleChange()
                });
                this.activeMeasurementIndex = undefined;
            }
        },
        {
            key: "start",
            value: function() {
                var _start2 = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee() {
                    var _this2 = this;
                    var _start, isBfCacheRestore, navigationIndex, navigationType, activationStart, cancel, cancelOnInteraction, cancelOnNavigation, cancelOnVisibilityChange, pageHideUnbind, visibilityChangeUnbind, didNetworkTimeOut, _this$lastMutation$ti2, _this$lastMutation2, end, _args = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _start = _args.length > 0 && _args[0] !== undefined ? _args[0] : 0;
                                isBfCacheRestore = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
                                navigationIndex = this.navigationCount += 1;
                                this.activeMeasurementIndex = navigationIndex;
                                (0, $8abPV.Logger).info("VisuallyCompleteCalculator.start()", "::", "index =", navigationIndex);
                                navigationType = isBfCacheRestore ? "back_forward" : _start > 0 ? "script" : (0, $cvD12.getNavigationType)();
                                activationStart = (0, $cvD12.getActivationStart)();
                                if (activationStart > _start) {
                                    _start = activationStart;
                                    navigationType = "prerender";
                                }
                                // setup
                                cancel = function cancel(e, cancellationReason) {
                                    if (_this2.activeMeasurementIndex === navigationIndex) {
                                        _this2.activeMeasurementIndex = undefined;
                                        _this2.error({
                                            start: _start,
                                            end: performance.now(),
                                            cancellationReason: cancellationReason,
                                            eventType: e.type,
                                            eventTarget: e.target || undefined,
                                            navigationType: navigationType,
                                            lastVisibleChange: _this2.getLastVisibleChange()
                                        });
                                    }
                                };
                                cancelOnInteraction = function cancelOnInteraction(e) {
                                    return cancel(e, $5aec88a221175e00$export$cbce095b92028433.USER_INTERACTION);
                                };
                                cancelOnNavigation = function cancelOnNavigation(e) {
                                    return cancel(e, $5aec88a221175e00$export$cbce095b92028433.NEW_NAVIGATION);
                                };
                                cancelOnVisibilityChange = function cancelOnVisibilityChange(e) {
                                    return cancel(e, $5aec88a221175e00$export$cbce095b92028433.VISIBILITY_CHANGE);
                                };
                                this.inViewportImageObserver.observe();
                                this.inViewportMutationObserver.observe(document.documentElement);
                                pageHideUnbind = (0, $1FiMp.bind)(window, {
                                    type: "pagehide",
                                    listener: cancelOnNavigation
                                });
                                visibilityChangeUnbind = (0, $1FiMp.bind)(window, {
                                    type: "visibilitychange",
                                    listener: cancelOnVisibilityChange
                                });
                                this.unbindFunctions.push(pageHideUnbind);
                                this.unbindFunctions.push(visibilityChangeUnbind);
                                // attach user interaction listeners next tick (we don't want to pick up the SPA navigation click)
                                window.setTimeout(function() {
                                    var clickUnbind = (0, $1FiMp.bind)(window, {
                                        type: "click",
                                        listener: cancelOnInteraction
                                    });
                                    var keydownUnbind = (0, $1FiMp.bind)(window, {
                                        type: "keydown",
                                        listener: cancelOnInteraction
                                    });
                                    _this2.unbindFunctions.push(clickUnbind);
                                    _this2.unbindFunctions.push(keydownUnbind);
                                }, 0);
                                // wait for page to be definitely DONE
                                // - wait for window.on("load")
                                _context.next = 21;
                                return (0, $bS6Dj.waitForPageLoad)();
                            case 21:
                                _context.next = 23;
                                return new Promise((0, $2JvL6.requestAllIdleCallback));
                            case 23:
                                didNetworkTimeOut = _context.sent;
                                // if this navigation's measurement hasn't been cancelled, record it.
                                if (navigationIndex === this.activeMeasurementIndex) {
                                    // identify timestamp of last visible change
                                    end = Math.max(_start, this.lastImageLoadTimestamp, (_this$lastMutation$ti2 = (_this$lastMutation2 = this.lastMutation) === null || _this$lastMutation2 === void 0 ? void 0 : _this$lastMutation2.timestamp) !== null && _this$lastMutation$ti2 !== void 0 ? _this$lastMutation$ti2 : 0); // report result to subscribers
                                    this.next({
                                        start: _start,
                                        end: end,
                                        duration: end - _start,
                                        detail: {
                                            navigationType: navigationType,
                                            didNetworkTimeOut: didNetworkTimeOut,
                                            lastVisibleChange: this.getLastVisibleChange()
                                        }
                                    });
                                } else {
                                    (0, $8abPV.Logger).debug("VisuallyCompleteCalculator: Measurement discarded", "::", "index =", navigationIndex);
                                    if (this.activeMeasurementIndex) this.error({
                                        start: _start,
                                        end: performance.now(),
                                        cancellationReason: $5aec88a221175e00$export$cbce095b92028433.NEW_NAVIGATION,
                                        navigationType: navigationType,
                                        lastVisibleChange: this.getLastVisibleChange()
                                    });
                                }
                                // cleanup
                                this.unbindFunctions.forEach(function(unbind) {
                                    unbind();
                                });
                                this.unbindFunctions = [];
                                // only disconnect observers if this is the most recent navigation
                                if (navigationIndex === this.navigationCount) {
                                    this.inViewportImageObserver.disconnect();
                                    this.inViewportMutationObserver.disconnect();
                                }
                            case 28:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function start() {
                    return _start2.apply(this, arguments);
                }
                return start;
            }()
        },
        {
            key: "next",
            value: function next(measurement) {
                var _this$lastMutation$ti3, _this$lastMutation3;
                if (measurement.end > Number.MAX_SAFE_INTEGER) {
                    (0, $8abPV.Logger).warn("VisuallyCompleteCalculator.next()", "::", "This browser reported a time larger than MAX_SAFE_INTEGER. We are ignoring it.", "::", measurement);
                    return;
                }
                (0, $8abPV.Logger).debug("VisuallyCompleteCalculator.next()", "::", "lastImageLoadTimestamp =", this.lastImageLoadTimestamp, "lastMutationTimestamp =", (_this$lastMutation$ti3 = (_this$lastMutation3 = this.lastMutation) === null || _this$lastMutation3 === void 0 ? void 0 : _this$lastMutation3.timestamp) !== null && _this$lastMutation$ti3 !== void 0 ? _this$lastMutation$ti3 : 0, "::", "index =", this.activeMeasurementIndex);
                (0, $8abPV.Logger).info("TTVC:", measurement, "::", "index =", this.activeMeasurementIndex);
                this.successSubscribers.forEach(function(subscriber) {
                    return subscriber(measurement);
                });
            }
        },
        {
            key: "error",
            value: function(_error) {
                function error(_x) {
                    return _error.apply(this, arguments);
                }
                error.toString = function() {
                    return _error.toString();
                };
                return error;
            }(function(error) {
                (0, $8abPV.Logger).debug("VisuallyCompleteCalculator.error()", "::", "cancellationReason =", error.cancellationReason, "::", "eventType =", error.eventType || "none", "::", "index =", this.activeMeasurementIndex);
                this.errorSubscribers.forEach(function(subscriber) {
                    return subscriber(error);
                });
            })
        },
        {
            key: "getLastVisibleChange",
            value: function getLastVisibleChange() {
                var _this$lastMutation$ti4, _this$lastMutation4;
                return this.lastImageLoadTimestamp > ((_this$lastMutation$ti4 = (_this$lastMutation4 = this.lastMutation) === null || _this$lastMutation4 === void 0 ? void 0 : _this$lastMutation4.timestamp) !== null && _this$lastMutation$ti4 !== void 0 ? _this$lastMutation$ti4 : 0) ? this.lastImageLoadTarget : this.lastMutation;
            }
        },
        {
            key: "getLastVisibleChangeTimestamp",
            value: function getLastVisibleChangeTimestamp() {
                var _this$lastMutation$ti5, _this$lastMutation5, _this$lastMutation$ti6, _this$lastMutation6;
                return this.lastImageLoadTimestamp > ((_this$lastMutation$ti5 = (_this$lastMutation5 = this.lastMutation) === null || _this$lastMutation5 === void 0 ? void 0 : _this$lastMutation5.timestamp) !== null && _this$lastMutation$ti5 !== void 0 ? _this$lastMutation$ti5 : 0) ? this.lastImageLoadTimestamp : (_this$lastMutation$ti6 = (_this$lastMutation6 = this.lastMutation) === null || _this$lastMutation6 === void 0 ? void 0 : _this$lastMutation6.timestamp) !== null && _this$lastMutation$ti6 !== void 0 ? _this$lastMutation$ti6 : 0;
            }
        }
    ], [
        {
            key: "isSupportedEnvironment",
            value: /**
     * Determine whether the calculator should run in the current environment
     */ function isSupportedEnvironment() {
                var _window$performance;
                return window !== undefined && "MutationObserver" in window && "IntersectionObserver" in window && typeof document.querySelectorAll === "function" && ((_window$performance = window.performance) === null || _window$performance === void 0 ? void 0 : _window$performance.timing);
            }
        }
    ]);
    return VisuallyCompleteCalculator;
}();
// export calculator singleton
var $5aec88a221175e00$var$calculator;
var $5aec88a221175e00$export$90e17c8c7646069e = function getVisuallyCompleteCalculator() {
    if (!$5aec88a221175e00$var$calculator) $5aec88a221175e00$var$calculator = new $5aec88a221175e00$var$VisuallyCompleteCalculator();
    return $5aec88a221175e00$var$calculator;
};

});
parcelRegister("du6ye", function(module, exports) {

$parcel$export(module.exports, "InViewportImageObserver", function () { return $9d1328a30ec32914$export$6523501d77d964c6; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");

var $1FiMp = parcelRequire("1FiMp");

var $8abPV = parcelRequire("8abPV");
var $9d1328a30ec32914$var$unbindFunctions = [];
var $9d1328a30ec32914$export$6523501d77d964c6 = /*#__PURE__*/ function() {
    function InViewportImageObserver(callback) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, InViewportImageObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "imageLoadTimes", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "lastImageLoadTimestamp", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "intersectionObserverCallback", function(entries) {
            entries.forEach(function(entry) {
                var img = entry.target;
                var timestamp = _this.imageLoadTimes.get(img);
                if (entry.isIntersecting && timestamp != null) {
                    (0, $8abPV.Logger).info("InViewportImageObserver.callback()", "::", "timestamp =", timestamp);
                    _this.callback(timestamp, img);
                }
                _this.intersectionObserver.unobserve(img);
                _this.imageLoadTimes.delete(img);
            });
        });
        // Error events on the `window` can be a `string` (legacy).
        // The built in TS DOM types don't have a (correct) narrower
        // type for the `Document`.
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "handleLoadOrErrorEvent", function(event) {
            if (typeof event !== "string" && (event.target instanceof HTMLImageElement || event.target instanceof HTMLIFrameElement)) {
                (0, $8abPV.Logger).debug("InViewportImageObserver.handleLoadOrErrorEvent()", "::", "event =", event);
                _this.imageLoadTimes.set(event.target, event.timeStamp);
                _this.intersectionObserver.observe(event.target);
            }
        });
        this.callback = callback;
        this.intersectionObserver = new IntersectionObserver(this.intersectionObserverCallback);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(InViewportImageObserver, [
        {
            key: "observe",
            value: /** Start observing loading images. */ function observe() {
                (0, $8abPV.Logger).info("InViewportImageObserver.observe()");
                var loadUnbindFn = (0, $1FiMp.bind)(document, {
                    type: "load",
                    listener: this.handleLoadOrErrorEvent,
                    options: {
                        capture: true
                    }
                });
                var errorUnbindFn = (0, $1FiMp.bind)(document, {
                    type: "error",
                    listener: this.handleLoadOrErrorEvent,
                    options: {
                        capture: true
                    }
                });
                $9d1328a30ec32914$var$unbindFunctions.push(loadUnbindFn);
                $9d1328a30ec32914$var$unbindFunctions.push(errorUnbindFn);
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                (0, $8abPV.Logger).info("InViewportImageObserver.disconnect()");
                this.lastImageLoadTimestamp = 0;
                this.imageLoadTimes.clear();
                this.intersectionObserver.disconnect();
                $9d1328a30ec32914$var$unbindFunctions.forEach(function(unbind) {
                    unbind();
                });
                $9d1328a30ec32914$var$unbindFunctions = [];
            }
        }
    ]);
    return InViewportImageObserver;
}();

});

parcelRegister("aDY2p", function(module, exports) {

$parcel$export(module.exports, "InViewportMutationObserver", function () { return $7bfc1e2ddf9c2ec0$export$87e7c22ab525ab82; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");

var $8abPV = parcelRequire("8abPV");
var $7bfc1e2ddf9c2ec0$export$87e7c22ab525ab82 = /*#__PURE__*/ function() {
    function InViewportMutationObserver(callback) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, InViewportMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "mutationObserverConfig", {
            attributeFilter: [
                "hidden",
                "style",
                "src"
            ],
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "mutations", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "mutationObserverCallback", function(mutations) {
            (0, $8abPV.Logger).debug("InViewportMutationObserver.mutationObserverCallback()", "::", "mutations =", mutations);
            mutations.forEach(function(mutation) {
                mutation.timestamp = performance.now();
                var target = null;
                if (mutation.target instanceof Element) target = mutation.target;
                if (mutation.target instanceof Text) target = mutation.target.parentElement;
                if (!target) return;
                switch(mutation.type){
                    case "childList":
                        mutation.addedNodes.forEach(function(node) {
                            if (node instanceof HTMLElement) {
                                _this.intersectionObserver.observe(node);
                                _this.mutations.set(node, mutation);
                            }
                            if (node instanceof Text && node.parentElement != null) {
                                _this.intersectionObserver.observe(node.parentElement);
                                _this.mutations.set(node.parentElement, mutation);
                            }
                        });
                        break;
                    case "attributes":
                    default:
                        _this.intersectionObserver.observe(target);
                        _this.mutations.set(target, mutation);
                }
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "intersectionObserverCallback", function(entries) {
            (0, $8abPV.Logger).debug("InViewportMutationObserver.intersectionObserverCallback()", "::", "entries =", entries);
            entries.forEach(function(entry) {
                var mutation = _this.mutations.get(entry.target);
                if (entry.isIntersecting && mutation != null) {
                    (0, $8abPV.Logger).info("InViewportMutationObserver.callback()", "::", "mutation =", mutation);
                    _this.callback(mutation);
                }
                _this.mutations.delete(entry.target);
                _this.intersectionObserver.unobserve(entry.target);
            });
        });
        this.callback = callback;
        this.mutationObserver = new MutationObserver(this.mutationObserverCallback);
        this.intersectionObserver = new IntersectionObserver(this.intersectionObserverCallback);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(InViewportMutationObserver, [
        {
            key: "observe",
            value: function observe(target) {
                (0, $8abPV.Logger).info("InViewportMutationObserver.observe()", "::", "target =", target);
                this.mutationObserver.observe(target, this.mutationObserverConfig);
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                (0, $8abPV.Logger).info("InViewportMutationObserver.disconnect()");
                this.mutationObserver.disconnect();
                this.intersectionObserver.disconnect();
            }
        }
    ]);
    return InViewportMutationObserver;
}();

});

parcelRegister("cvD12", function(module, exports) {

$parcel$export(module.exports, "getNavigationType", function () { return $91b6a4ffe35e50d5$export$5ce4dcef8b4f05c6; });
$parcel$export(module.exports, "getActivationStart", function () { return $91b6a4ffe35e50d5$export$d3e828b3c7b5b845; });
// http://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigation/type
var $91b6a4ffe35e50d5$var$getDeprecatedNavigationType = function getDeprecatedNavigationType() {
    var type = window.performance.navigation.type;
    return type === 2 ? "back_forward" : type === 1 ? "reload" : "navigate";
};
var $91b6a4ffe35e50d5$export$5ce4dcef8b4f05c6 = function getNavigationType() {
    var _window$performance$g;
    return ((_window$performance$g = window.performance.getEntriesByType("navigation")[0]) === null || _window$performance$g === void 0 ? void 0 : _window$performance$g.type) || $91b6a4ffe35e50d5$var$getDeprecatedNavigationType();
};
var $91b6a4ffe35e50d5$export$d3e828b3c7b5b845 = function getActivationStart() {
    var _window$performance$g2;
    return ((_window$performance$g2 = window.performance.getEntriesByType("navigation")[0]) === null || _window$performance$g2 === void 0 ? void 0 : _window$performance$g2.activationStart) || 0;
};

});

parcelRegister("2JvL6", function(module, exports) {

$parcel$export(module.exports, "requestAllIdleCallback", function () { return $1fd86b62461b473d$export$739522c5f515da6e; });

var $Qfq3Z = parcelRequire("Qfq3Z");

var $8abPV = parcelRequire("8abPV");

var $cgbr3 = parcelRequire("cgbr3");

var $hFDSU = parcelRequire("hFDSU");
function $1fd86b62461b473d$export$739522c5f515da6e(callback) {
    var networkIdleObservable = (0, $cgbr3.getNetworkIdleObservable)();
    // state
    var networkIdle = networkIdleObservable.isIdle();
    var timeout;
    var handleNetworkChange = function handleNetworkChange(message) {
        networkIdle = message === "IDLE";
        if (networkIdle) (0, $hFDSU.requestIdleCallback)(handleCpuIdle);
        else {
            window.clearTimeout(timeout);
            timeout = undefined;
        }
    };
    var handleCpuIdle = function handleCpuIdle() {
        (0, $8abPV.Logger).debug("requestAllIdleCallback.handleCpuIdle()");
        if (networkIdle && !timeout) handleAllIdle();
    };
    var handleAllIdle = function handleAllIdle() {
        timeout = window.setTimeout(function() {
            // Did we have to clear a "hung" request from observable state?
            var didNetworkTimeOut = networkIdleObservable.didNetworkTimeOut();
            networkIdleObservable.resetDidNetworkTimeOut();
            (0, $8abPV.Logger).info("requestAllIdleCallback: ALL IDLE");
            callback(didNetworkTimeOut);
            unsubscribe();
        }, (0, $Qfq3Z.CONFIG).IDLE_TIMEOUT);
    };
    var unsubscribe = networkIdleObservable.subscribe(handleNetworkChange);
    // base case
    if (networkIdle) handleNetworkChange("IDLE");
}

});
parcelRegister("hFDSU", function(module, exports) {

$parcel$export(module.exports, "requestIdleCallback", function () { return $cdd5343d3c93ea9d$export$9288a5d956b3efbe; });
/**
 * Request a callback when we are confident that any synchronous CPU work has
 * been flushed from the task queue.
 */ var $cdd5343d3c93ea9d$export$9288a5d956b3efbe = function requestIdleCallback(callback) {
    var _window$requestIdleCa;
    // if browser supports it, wait until CPU is idle
    // eslint-disable-next-line compat/compat
    var requestCallback = (_window$requestIdleCa = window.requestIdleCallback) !== null && _window$requestIdleCa !== void 0 ? _window$requestIdleCa : window.setTimeout;
    requestCallback(function() {
        // wait *two* animation frames, to ensure the page has a chance to flush
        // pending changes to the DOM
        window.requestAnimationFrame(function() {
            return window.requestAnimationFrame(callback);
        });
    });
};

});


parcelRegister("bS6Dj", function(module, exports) {

$parcel$export(module.exports, "waitForPageLoad", function () { return $8a49e2115f477383$export$96626fdeaeb544ce; });

var $1FiMp = parcelRequire("1FiMp");
var $8a49e2115f477383$export$96626fdeaeb544ce = function waitForPageLoad() {
    if (document.readyState === "complete") return Promise.resolve();
    return new Promise(function(resolve) {
        var unbind = (0, $1FiMp.bind)(window, {
            type: "load",
            listener: function listener() {
                resolve();
                unbind();
            }
        });
    });
};

});



parcelRegister("8B4n6", function(module, exports) {

$parcel$export(module.exports, "setupHiddenTimingCapture", function () { return $64252b8b68296d43$export$554cefe0f0373da4; });
$parcel$export(module.exports, "getPageVisibilityState", function () { return $64252b8b68296d43$export$768b2008623433e1; });

var $1FiMp = parcelRequire("1FiMp");
var $64252b8b68296d43$var$timings = [];
var $64252b8b68296d43$var$wasHiddenFlag;
var $64252b8b68296d43$var$setupFlag = false;
function $64252b8b68296d43$var$isPageHidden() {
    if ("visibilityState" in document) return document.visibilityState === "hidden";
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
var $64252b8b68296d43$var$SIZE = 50;
var $64252b8b68296d43$var$insertIndex = 0;
function $64252b8b68296d43$var$pushHidden(isPageHiddenFlag, time) {
    $64252b8b68296d43$var$timings[$64252b8b68296d43$var$insertIndex] = {
        time: time !== null && time !== void 0 ? time : performance.now(),
        hidden: isPageHiddenFlag
    };
    $64252b8b68296d43$var$insertIndex = ($64252b8b68296d43$var$insertIndex + 1) % $64252b8b68296d43$var$SIZE;
    $64252b8b68296d43$var$wasHiddenFlag = isPageHiddenFlag;
}
function $64252b8b68296d43$var$handleChange() {
    var isPageHiddenFlag = $64252b8b68296d43$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$64252b8b68296d43$var$wasHiddenFlag) $64252b8b68296d43$var$pushHidden(isPageHiddenFlag);
        $64252b8b68296d43$var$wasHiddenFlag = true;
    } else {
        if ($64252b8b68296d43$var$wasHiddenFlag) $64252b8b68296d43$var$pushHidden(isPageHiddenFlag);
        $64252b8b68296d43$var$wasHiddenFlag = false;
    }
}
function $64252b8b68296d43$var$setup() {
    (0, $1FiMp.bind)(window, {
        type: "pageshow",
        listener: $64252b8b68296d43$var$handleChange
    });
    (0, $1FiMp.bind)(window, {
        type: "pagehide",
        listener: $64252b8b68296d43$var$handleChange
    });
    (0, $1FiMp.bind)(document, {
        type: "visibilitychange",
        listener: $64252b8b68296d43$var$handleChange
    });
}
function $64252b8b68296d43$export$554cefe0f0373da4() {
    if (!$64252b8b68296d43$var$setupFlag) {
        var isPageHiddenFlag = $64252b8b68296d43$var$isPageHidden();
        $64252b8b68296d43$var$pushHidden(isPageHiddenFlag, 0);
        $64252b8b68296d43$var$setup();
        $64252b8b68296d43$var$setupFlag = true;
    }
}
function $64252b8b68296d43$export$768b2008623433e1(start, end) {
    // Desirable default value is visible
    if ($64252b8b68296d43$var$timings.length === 0) return "visible";
    var currentSize = $64252b8b68296d43$var$timings.length;
    var hiddenState = "mixed";
    var startIdx = $64252b8b68296d43$var$insertIndex;
    var endIdx = $64252b8b68296d43$var$insertIndex;
    // currentSize is capped at SIZE.
    for(var i = 0; i < currentSize; i++){
        var tmpIdx = ($64252b8b68296d43$var$insertIndex + i) % currentSize;
        if ($64252b8b68296d43$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($64252b8b68296d43$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    if (endIdx - startIdx === 0) {
        if ($64252b8b68296d43$var$timings[startIdx].hidden) hiddenState = "hidden";
        else hiddenState = "visible";
    }
    return hiddenState;
}

});

parcelRegister("fcJSo", function(module, exports) {

$parcel$export(module.exports, "getVCObserver", function () { return $b11b9018018ad46b$export$b3bc47985717b49e; });

var $9tErd = parcelRequire("9tErd");
var $b11b9018018ad46b$var$instance = null;
var $b11b9018018ad46b$export$b3bc47985717b49e = function getVCObserver() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if ($b11b9018018ad46b$var$instance === null) $b11b9018018ad46b$var$instance = new (0, $9tErd.VCObserver)(opts);
    return $b11b9018018ad46b$var$instance;
};

});
parcelRegister("9tErd", function(module, exports) {

$parcel$export(module.exports, "VCObserver", function () { return $6e66309e3f5f600c$export$1f70d263701b1d01; });

var $9q1kH = parcelRequire("9q1kH");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");

var $1FiMp = parcelRequire("1FiMp");

var $l6pQ9 = parcelRequire("l6pQ9");

var $fQcaz = parcelRequire("fQcaz");
function $6e66309e3f5f600c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6e66309e3f5f600c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6e66309e3f5f600c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6e66309e3f5f600c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6e66309e3f5f600c$var$abortReason = {
    scroll: "scroll",
    keypress: "keypress",
    resize: "resize",
    error: "error"
};
function $6e66309e3f5f600c$var$getViewportWidth() {
    var documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function $6e66309e3f5f600c$var$getViewportHeight() {
    var documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
var $6e66309e3f5f600c$var$UNUSED_SECTOR = 0;
var $6e66309e3f5f600c$export$1f70d263701b1d01 = /*#__PURE__*/ function() {
    function VCObserver(options) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, VCObserver);
        /* abort logic */ (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "abortReason", {
            reason: null,
            info: "",
            timestamp: -1,
            blocking: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "outOfBoundaryInfo", "");
        /** config * */ (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "VCParts", [
            "25",
            "50",
            "75",
            "80",
            "85",
            "90",
            "95",
            "98",
            "99"
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "viewport", {
            w: 0,
            h: 0
        });
        /* heatmap */ (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "arraySize", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "componentsLog", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "active", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "totalTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "startTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_startMeasureTimestamp", -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "ssr", {
            reactRendered: -1
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "unbind", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "getAbortReason", function() {
            if (_this.abortReason.reason === null) return null;
            var info = _this.abortReason.info !== "" ? " ".concat(_this.abortReason.info) : "";
            return "".concat(_this.abortReason.reason).concat(info);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "getVCResult", function(_ref) {
            var _objectSpread2;
            var start = _ref.start, stop = _ref.stop, tti = _ref.tti, prefix = _ref.prefix, ssr = _ref.ssr;
            _this.measureStart();
            if (!_this.active) {
                _this.measureStop();
                return {};
            }
            var fullPrefix = prefix !== undefined && prefix !== "" ? "".concat(prefix, ":") : "";
            _this.stop();
            var abortReason = _this.getAbortReason();
            if (abortReason !== null && _this.abortReason.blocking) {
                var _ref2;
                // exposing data to devtools
                try {
                    if (_this.devToolsEnabled) window.__vcNotAvailableReason = abortReason;
                } catch (e) {}
                return _ref2 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref2, "".concat(fullPrefix, "vc:state"), false), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref2, "".concat(fullPrefix, "vc:abort:reason"), abortReason), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref2, "".concat(fullPrefix, "vc:abort:timestamp"), _this.abortReason.timestamp), _ref2;
            }
            var _this$calculateVC = _this.calculateVC({
                heatmap: _this.ssrInclusiveHeatmap,
                addToPerformance: true,
                ssr: ssr
            }), VC = _this$calculateVC.VC, VCBox = _this$calculateVC.VCBox, VCEntries = _this$calculateVC.VCEntries, totalPainted = _this$calculateVC.totalPainted;
            var ssrVC = _this.calculateVC({
                heatmap: _this.heatmap,
                ssr: ssr
            });
            var outOfBoundary = _this.outOfBoundaryInfo ? (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, "".concat(fullPrefix, "vc:oob"), _this.outOfBoundaryInfo) : {};
            var oldDomUpdates = _this.oldDomUpdatesEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, "".concat(fullPrefix, "vc:old:dom"), ssrVC.VCBox) : {};
            _this.measureStop();
            // exposing data to devtools
            try {
                if (_this.devToolsEnabled) window.__vc = {
                    entries: VCEntries.rel,
                    log: _this.componentsLog,
                    metrics: {
                        "75": VC["75"],
                        "80": VC["80"],
                        "85": VC["85"],
                        "90": VC["90"],
                        "95": VC["95"],
                        "98": VC["98"],
                        "99": VC["99"],
                        tti: tti,
                        ttai: stop - start
                    },
                    heatmap: _this.heatmap
                };
            } catch (e) {
            /*  do nothing */ }
            // console.log('exposed data')
            var returnValue = $6e66309e3f5f600c$var$_objectSpread($6e66309e3f5f600c$var$_objectSpread((_objectSpread2 = {
                "metrics:vc": VC
            }, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, "".concat(fullPrefix, "vc:state"), true), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, "".concat(fullPrefix, "vc:clean"), abortReason ? false : true), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, "".concat(fullPrefix, "vc:dom"), VCBox), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, "".concat(fullPrefix, "vc:updates"), VCEntries.rel.slice(0, 50)), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, "".concat(fullPrefix, "vc:size"), $6e66309e3f5f600c$var$_objectSpread({}, _this.viewport)), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, "".concat(fullPrefix, "vc:time"), Math.round(_this.totalTime + _this.observers.getTotalTime())), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, "".concat(fullPrefix, "vc:total"), totalPainted), _objectSpread2), outOfBoundary), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, "".concat(fullPrefix, "vc:old"), ssrVC.VC), oldDomUpdates);
            return returnValue;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "handleUpdate", function(rawTime, intersectionRect, targetName, element, ignored) {
            _this.measureStart();
            if (_this.abortReason.reason === null || _this.abortReason.blocking === false) {
                var time = Math.round(rawTime - _this.startTime);
                var mappedValues = _this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                _this.applyChangesToHeatMap(mappedValues, time, _this.heatmap);
                if (!ignored) _this.applyChangesToHeatMap(mappedValues, time, _this.ssrInclusiveHeatmap);
                // console.log('handleUpdate', ignored, time, element === this.ssr.element, (intersectionRect.width * intersectionRect.height) / (this.viewport.w*this.viewport.h), element);
                if (!_this.componentsLog[time]) _this.componentsLog[time] = [];
                _this.componentsLog[time].push({
                    element: element,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignored: ignored
                });
            }
            // devtools export
            _this.measureStop();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "mapPixelsToHeatmap", function(left, top, width, height) {
            var _this$viewport = _this.viewport, w = _this$viewport.w, h = _this$viewport.h;
            var l = Math.floor(left / w * _this.arraySize);
            var t = Math.floor(top / h * _this.arraySize);
            var r = Math.ceil((left + width) / w * _this.arraySize);
            var b = Math.ceil((top + height) / h * _this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (_this.outOfBoundaryInfo === "") {
                var outOfBoundaryInfo = "";
                if (r > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(left, " ").concat(width);
                if (b > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(top, " ").concat(height);
                _this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            var result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(_this.arraySize, r),
                b: Math.min(_this.arraySize, b)
            };
            return result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "attachAbortListeners", function() {
            _this.detachAbortListeners();
            var wheelUnbind = (0, $1FiMp.bind)(window, {
                type: "wheel",
                listener: function listener(e) {
                    _this.setAbortReason($6e66309e3f5f600c$var$abortReason.scroll, e.timeStamp);
                },
                options: {
                    passive: true,
                    once: true
                }
            });
            var keyDownUnbind = (0, $1FiMp.bind)(window, {
                type: "keydown",
                listener: function listener(e) {
                    _this.setAbortReason($6e66309e3f5f600c$var$abortReason.keypress, e.timeStamp);
                },
                options: {
                    once: true
                }
            });
            var resizeUnbind = (0, $1FiMp.bind)(window, {
                type: "resize",
                listener: function listener(e) {
                    if ($6e66309e3f5f600c$var$getViewportWidth() !== _this.viewport.w || $6e66309e3f5f600c$var$getViewportHeight() !== _this.viewport.h) {
                        var _this$unbind$resize, _this$unbind;
                        _this.setAbortReason($6e66309e3f5f600c$var$abortReason.resize, e.timeStamp);
                        (_this$unbind$resize = (_this$unbind = _this.unbind).resize) === null || _this$unbind$resize === void 0 || _this$unbind$resize.call(_this$unbind);
                        delete _this.unbind.resize;
                    }
                }
            });
            _this.unbind = {
                wheel: wheelUnbind,
                keyDown: keyDownUnbind,
                resize: resizeUnbind
            };
        });
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        this.observers = new (0, $fQcaz.Observers)({
            selectorConfig: options.selectorConfig || {
                id: false,
                testId: false,
                role: false,
                className: true,
                dataVC: true
            }
        });
        this.heatmap = this.getCleanHeatmap();
        this.ssrInclusiveHeatmap = this.getCleanHeatmap();
        if (options.devToolsEnabled) (0, $l6pQ9.initDevTools)();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(VCObserver, [
        {
            key: "start",
            value: function start(_ref5) {
                var startTime = _ref5.startTime;
                this.setViewportSize();
                this.resetState();
                this.startTime = startTime;
                this.active = true;
                this.attachAbortListeners();
                this.observers.subscribeResults(this.handleUpdate);
                this.observers.observe();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.observers.disconnect();
                this.detachAbortListeners();
            }
        },
        {
            key: "calculateVC",
            value: function calculateVC(_ref6) {
                var _this2 = this;
                var heatmap = _ref6.heatmap, _ref6$addToPerformanc = _ref6.addToPerformance, addToPerformance = _ref6$addToPerformanc === void 0 ? false : _ref6$addToPerformanc, _ref6$ssr = _ref6.ssr, ssr = _ref6$ssr === void 0 ? $6e66309e3f5f600c$var$UNUSED_SECTOR : _ref6$ssr;
                var lastUpdate = {};
                var totalPainted = 0;
                var componentsLog = $6e66309e3f5f600c$var$_objectSpread({}, this.componentsLog);
                if (ssr !== $6e66309e3f5f600c$var$UNUSED_SECTOR) {
                    var _window$document;
                    var element = {
                        element: (_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.body,
                        ignored: false,
                        intersectionRect: {
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            x: 0,
                            y: 0,
                            width: this.viewport.w,
                            height: this.viewport.h,
                            toJSON: function toJSON() {
                                return {};
                            }
                        },
                        targetName: "SSR"
                    };
                    if (!componentsLog[ssr]) componentsLog[ssr] = [];
                    componentsLog[ssr].push(element);
                }
                heatmap.forEach(function(line) {
                    line.forEach(function(entry) {
                        var rounded = Math.floor(entry === $6e66309e3f5f600c$var$UNUSED_SECTOR && ssr !== $6e66309e3f5f600c$var$UNUSED_SECTOR ? ssr : entry);
                        totalPainted += rounded !== $6e66309e3f5f600c$var$UNUSED_SECTOR ? 1 : 0;
                        if (rounded !== $6e66309e3f5f600c$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
                    });
                });
                var entries = Object.entries(lastUpdate).map(function(a) {
                    return [
                        parseInt(a[0], 10),
                        a[1]
                    ];
                }).sort(function(a, b) {
                    return a[0] > b[0] ? 1 : -1;
                });
                var VC = this.makeVCReturnObj();
                var VCBox = this.makeVCReturnObj();
                entries.reduce(function() {
                    var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var v = arguments.length > 1 ? arguments[1] : undefined;
                    var VCRatio = v[1] / totalPainted + acc;
                    var time = v[0];
                    _this2.VCParts.forEach(function(key) {
                        var value = parseInt(key, 10);
                        if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                            var _componentsLog$time;
                            VC[key] = time;
                            VCBox[key] = (_componentsLog$time = componentsLog[time]) === null || _componentsLog$time === void 0 ? void 0 : _componentsLog$time.map(function(v) {
                                return v.targetName;
                            });
                        }
                    });
                    return VCRatio;
                }, 0);
                try {
                    if (addToPerformance) this.VCParts.forEach(function(key) {
                        var duration = VC[key];
                        if (duration !== null && duration !== undefined) performance.measure("VC".concat(key), {
                            start: 0,
                            duration: duration
                        });
                    });
                } catch (e) {
                /* empty */ }
                var VCEntries = entries.reduce(function(acc, _ref7, i) {
                    var _acc$abs, _componentsLog$timest;
                    var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref7, 2), timestamp = _ref8[0], entryPainted = _ref8[1];
                    var currentlyPainted = entryPainted + (((_acc$abs = acc.abs[i - 1]) === null || _acc$abs === void 0 ? void 0 : _acc$abs[1]) || 0);
                    var currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
                    var logEntry = (_componentsLog$timest = componentsLog[timestamp]) === null || _componentsLog$timest === void 0 ? void 0 : _componentsLog$timest.map(function(v) {
                        return v.targetName;
                    });
                    acc.abs.push([
                        timestamp,
                        currentlyPainted
                    ]);
                    acc.rel.push({
                        time: timestamp,
                        vc: currentlyPaintedRatio,
                        elements: logEntry
                    });
                    return acc;
                }, {
                    abs: [],
                    rel: []
                });
                return {
                    VC: VC,
                    VCBox: VCBox,
                    VCEntries: VCEntries,
                    totalPainted: totalPainted
                };
            }
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {
                this.observers.setReactRootElement(element);
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStart(startTime);
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStop(stopTime);
            }
        },
        {
            key: "setAbortReason",
            value: function setAbortReason(abort, timestamp) {
                var info = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
                if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                    this.abortReason.reason = abort;
                    this.abortReason.info = info;
                    this.abortReason.timestamp = timestamp;
                    this.abortReason.blocking = abort !== $6e66309e3f5f600c$var$abortReason.scroll;
                    if (this.abortReason.blocking) this.detachAbortListeners();
                }
            }
        },
        {
            key: "resetState",
            value: function resetState() {
                this.abortReason = {
                    reason: null,
                    info: "",
                    timestamp: -1,
                    blocking: false
                };
                this.detachAbortListeners();
                this.heatmap = this.getCleanHeatmap();
                this.ssrInclusiveHeatmap = this.getCleanHeatmap();
                this.totalTime = 0;
                this.componentsLog = {};
            }
        },
        {
            key: "getCleanHeatmap",
            value: function getCleanHeatmap() {
                var _this3 = this;
                return Array(this.arraySize).fill("").map(function() {
                    return Array(_this3.arraySize).fill($6e66309e3f5f600c$var$UNUSED_SECTOR);
                });
            }
        },
        {
            key: "setViewportSize",
            value: function setViewportSize() {
                this.viewport.w = $6e66309e3f5f600c$var$getViewportWidth();
                this.viewport.h = $6e66309e3f5f600c$var$getViewportHeight();
            }
        },
        {
            key: "applyChangesToHeatMap",
            value: function applyChangesToHeatMap(a, time, heatmap) {
                var l = a.l, t = a.t, r = a.r, b = a.b;
                var localHeatmap = heatmap;
                for(var row = t; row < b; row++){
                    for(var col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                        try {
                            this.setAbortReason($6e66309e3f5f600c$var$abortReason.error, time, "index - ".concat(row));
                        } catch (e) {
                            this.setAbortReason($6e66309e3f5f600c$var$abortReason.error, time, "row error");
                        }
                        return;
                    } else localHeatmap[row][col] = time;
                }
            }
        },
        {
            key: "makeVCReturnObj",
            value: function makeVCReturnObj() {
                var vc = {};
                this.VCParts.forEach(function(v) {
                    vc[v] = null;
                });
                return vc;
            }
        },
        {
            key: "detachAbortListeners",
            value: function detachAbortListeners() {
                var unbindFns = Object.values(this.unbind);
                if (unbindFns.length > 0) unbindFns.forEach(function(fn) {
                    return fn();
                });
                this.unbind = {};
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ]);
    return VCObserver;
}();

});
parcelRegister("l6pQ9", function(module, exports) {

$parcel$export(module.exports, "initDevTools", function () { return $f5ce33cd7cd777b4$export$93f430585c3f6d11; });

var $f5ce33cd7cd777b4$export$93f430585c3f6d11 = function initDevTools() {
    window.VCDevTools = function(opts) {
        return (parcelRequire("3V2JZ")).then(function(_ref) {
            var startVCDevTools = _ref.startVCDevTools;
            return startVCDevTools === null || startVCDevTools === void 0 ? void 0 : startVCDevTools(opts);
        });
    };
};

});
parcelRegister("3V2JZ", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5tP4L")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5tg7m")),
    (parcelRequire("8iLLr"))((parcelRequire("7kEWw")).resolve("l3ERW")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("if9Mh"))
]).then(()=>parcelRequire("80Dxc"));

});
parcelRegister("8iLLr", function(module, exports) {
"use strict";

var $51a7t = parcelRequire("51a7t");
module.exports = $51a7t(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});



parcelRegister("fQcaz", function(module, exports) {

$parcel$export(module.exports, "Observers", function () { return $b88526edd57273b4$export$b65d046240060e78; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");

var $dknPx = parcelRequire("dknPx");
function $b88526edd57273b4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b88526edd57273b4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b88526edd57273b4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b88526edd57273b4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b88526edd57273b4$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
var $b88526edd57273b4$export$b65d046240060e78 = /*#__PURE__*/ function() {
    function Observers(opts) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, Observers);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "observedMutations", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "elementsInView", new Set());
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "callbacks", new Set());
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "totalTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_startMeasureTimestamp", -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "ssr", {
            state: $b88526edd57273b4$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "selectorConfig", {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "subscribeResults", function(cb) {
            _this.callbacks.add(cb);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "observeElement", function(node, mutation, _type, ignored) {
            var _this$intersectionObs;
            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.observe(node);
            _this.observedMutations.set(node, {
                mutation: mutation,
                ignored: ignored
            });
        });
        this.selectorConfig = $b88526edd57273b4$var$_objectSpread($b88526edd57273b4$var$_objectSpread({}, this.selectorConfig), opts.selectorConfig);
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        this.ssrPlaceholderHandler = new (0, $dknPx.SSRPlaceholderHandlers)();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(Observers, [
        {
            key: "observe",
            value: function observe() {
                this.totalTime = 0;
                this.ssr = {
                    state: $b88526edd57273b4$var$state.normal,
                    reactRootElement: null,
                    renderStart: -1,
                    renderStop: -1
                };
                this.mutationObserver.observe(document.body, {
                    attributeFilter: [
                        "hidden",
                        "style",
                        "src"
                    ],
                    attributeOldValue: true,
                    attributes: true,
                    childList: true,
                    subtree: true
                });
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this.mutationObserver.disconnect();
                this.intersectionObserver.disconnect();
                this.observedMutations = new Map();
                this.elementsInView = new Set();
                this.callbacks = new Set();
                this.ssr.reactRootElement = null;
                this.ssrPlaceholderHandler.clear();
            }
        },
        {
            key: "getTotalTime",
            value: function getTotalTime() {
                return this.totalTime;
            }
        },
        {
            key: "setReactRootElement",
            value: function setReactRootElement(element) {
                this.ssr.reactRootElement = element;
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStart = startTime;
                this.ssr.state = $b88526edd57273b4$var$state.waitingForFirstRender;
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStop = stopTime;
            }
        },
        {
            key: "getMutationObserver",
            value: function getMutationObserver() {
                var _this2 = this;
                return new MutationObserver(function(mutations) {
                    _this2.measureStart();
                    mutations.forEach(function(mutation) {
                        // patching element if timestamp not automatically added
                        // eslint-disable-next-line no-param-reassign
                        mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                        var ignored = false;
                        if (_this2.ssr.state === $b88526edd57273b4$var$state.waitingForFirstRender && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            _this2.ssr.state = $b88526edd57273b4$var$state.ignoring;
                            if (_this2.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                            _this2.ssr.renderStop = mutation.timestamp + 500;
                            ignored = true;
                        }
                        if (_this2.ssr.state === $b88526edd57273b4$var$state.ignoring && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            if (mutation.timestamp <= _this2.ssr.renderStop) ignored = true;
                            else _this2.ssr.state = $b88526edd57273b4$var$state.normal;
                        }
                        if (mutation.type === "childList") {
                            mutation.addedNodes.forEach(function(node) {
                                if (node instanceof HTMLElement) {
                                    if (_this2.ssrPlaceholderHandler.isPlaceholder(node)) {
                                        _this2.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, "html", ignored);
                                        });
                                        return;
                                    }
                                    if (_this2.ssrPlaceholderHandler.isPlaceholderReplacement(node)) {
                                        _this2.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, "html", ignored);
                                        });
                                        return;
                                    }
                                    _this2.observeElement(node, mutation, "html", ignored);
                                }
                                if (node instanceof Text && node.parentElement != null) _this2.observeElement(node.parentElement, mutation, "text", ignored);
                            });
                            mutation.removedNodes.forEach(function(node) {
                                if (node instanceof Element) {
                                    var _this2$intersectionOb;
                                    _this2.elementsInView.delete(node);
                                    (_this2$intersectionOb = _this2.intersectionObserver) === null || _this2$intersectionOb === void 0 || _this2$intersectionOb.unobserve(node);
                                }
                            });
                        } else if (mutation.type === "attributes") mutation.addedNodes.forEach(function(node) {
                            if (node instanceof HTMLElement) _this2.observeElement(node, mutation, "attr", ignored);
                        });
                    });
                    _this2.measureStop();
                });
            }
        },
        {
            key: "getElementName",
            value: function getElementName(element) {
                try {
                    var tagName = element.localName;
                    var dataVCAttr = element.getAttribute("data-vc");
                    var dataVC = this.selectorConfig.dataVC && dataVCAttr ? '[data-vc="'.concat(dataVCAttr, '"]') : "";
                    var id = this.selectorConfig.id && element.id ? "#".concat(element.id) : "";
                    var testId = this.selectorConfig.testId ? element.getAttribute("data-testid") || element.getAttribute("data-test-id") : "";
                    testId = testId ? "[testid=".concat(testId, "]") : "";
                    var role = this.selectorConfig.role ? element.getAttribute("role") : "";
                    role = role ? "[role=".concat(role, "]") : "";
                    var classList = this.selectorConfig.className ? Array.from(element.classList).join(".") : "";
                    classList = classList === "" ? "" : ".".concat(classList);
                    var attrs = dataVC ? dataVC : [
                        id,
                        testId,
                        role
                    ].join("");
                    var idString = "";
                    if (attrs === "" && classList === "") {
                        var parent = element.parentElement ? this.getElementName(element.parentElement) : "unknown";
                        idString = "".concat(parent, " > ").concat(tagName);
                    } else idString = [
                        tagName,
                        attrs || classList
                    ].join("");
                    return idString;
                } catch (e) {
                    return "error";
                }
            }
        },
        {
            key: "getIntersectionObserver",
            value: function getIntersectionObserver() {
                var _this3 = this;
                return new IntersectionObserver(function(entries) {
                    _this3.measureStart();
                    entries.forEach(function(_ref) {
                        var isIntersecting = _ref.isIntersecting, ir = _ref.intersectionRect, target = _ref.target;
                        var data = _this3.observedMutations.get(target);
                        _this3.observedMutations.delete(target);
                        if (isIntersecting && ir.width > 0 && ir.height > 0) {
                            if (!(target instanceof HTMLElement)) return;
                            if (!(data !== null && data !== void 0 && data.mutation)) // ignore intersection report without recent mutation
                            return;
                            _this3.callbacks.forEach(function(callback) {
                                var elementName;
                                try {
                                    elementName = _this3.getElementName(target);
                                } catch (e) {
                                    elementName = "error";
                                }
                                callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.ignored);
                            });
                            _this3.elementsInView.add(target);
                        } else _this3.elementsInView.delete(target);
                    });
                    _this3.measureStop();
                });
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ]);
    return Observers;
}();

});
parcelRegister("dknPx", function(module, exports) {

$parcel$export(module.exports, "SSRPlaceholderHandlers", function () { return $9b3fa0d0bd02f54f$export$c0102f1a1198d10f; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
var $9b3fa0d0bd02f54f$export$c0102f1a1198d10f = /*#__PURE__*/ function() {
    function SSRPlaceholderHandlers() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, SSRPlaceholderHandlers);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "staticPlaceholders", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "callbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "getSizeCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "reactValidateCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "intersectionObserverCallback", function(_ref) {
            var target = _ref.target, boundingClientRect = _ref.boundingClientRect;
            _this.intersectionObserver.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            var staticKey = target.dataset.ssrPlaceholder || "";
            if (staticKey) {
                if (_this.staticPlaceholders.has(staticKey) && _this.callbacks.has(staticKey)) {
                    // validation
                    var _resolve = _this.callbacks.get(staticKey);
                    if (!_resolve) return;
                    var rect = _this.staticPlaceholders.get(staticKey);
                    var hasSameSizePosition = rect && rect.x === boundingClientRect.x && rect.y === boundingClientRect.y && rect.width === boundingClientRect.width && rect.height === boundingClientRect.height || false;
                    _resolve(hasSameSizePosition);
                    _this.callbacks.delete(staticKey);
                } else // initial check
                _this.setSizeOfStaticElement(target, boundingClientRect);
            } else {
                // react component check
                var key = target.dataset.ssrPlaceholderReplace || "";
                var _resolve2 = _this.reactValidateCallbacks.get(key);
                if (!_resolve2) return;
                var _rect = _this.staticPlaceholders.get(key);
                var _hasSameSizePosition = _rect && _rect.x === boundingClientRect.x && _rect.y === boundingClientRect.y && _rect.width === boundingClientRect.width && _rect.height === boundingClientRect.height || false;
                _resolve2(_hasSameSizePosition);
                _this.staticPlaceholders.delete(staticKey);
                _this.reactValidateCallbacks.delete(staticKey);
            }
        });
        this.intersectionObserver = new IntersectionObserver(function(entries) {
            return entries.forEach(_this.intersectionObserverCallback);
        });
        if (window.document) try {
            var existingElements = document.querySelectorAll("[data-ssr-placeholder]");
            existingElements.forEach(function(el) {
                var _el$dataset;
                if (el instanceof HTMLElement && el !== null && el !== void 0 && (_el$dataset = el.dataset) !== null && _el$dataset !== void 0 && _el$dataset.ssrPlaceholder) {
                    _this.staticPlaceholders.set(el.dataset.ssrPlaceholder, {
                        width: -1,
                        height: -1,
                        x: -1,
                        y: -1
                    });
                    _this.intersectionObserver.observe(el);
                }
            });
        } catch (e) {}
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(SSRPlaceholderHandlers, [
        {
            key: "clear",
            value: function clear() {
                this.staticPlaceholders = new Map();
                this.callbacks = new Map();
                this.getSizeCallbacks = new Map();
                this.reactValidateCallbacks = new Map();
            }
        },
        {
            key: "isPlaceholder",
            value: function isPlaceholder(element) {
                return !!element.dataset.ssrPlaceholder;
            }
        },
        {
            key: "isPlaceholderReplacement",
            value: function isPlaceholderReplacement(element) {
                return !!element.dataset.ssrPlaceholderReplace;
            }
        },
        {
            key: "checkIfExistedAndSizeMatching",
            value: function checkIfExistedAndSizeMatching(el) {
                var _this2 = this;
                var id = el.dataset.ssrPlaceholder || "";
                return new Promise(function(resolve) {
                    if (!_this2.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        _this2.callbacks.set(id, resolve);
                        _this2.intersectionObserver.observe(el);
                    }
                });
            }
        },
        {
            key: "getSize",
            value: function getSize(el) {
                var _this3 = this;
                return new Promise(function(resolve) {
                    _this3.getSizeCallbacks.set(el.dataset.ssrPlaceholder || "", resolve);
                    _this3.intersectionObserver.observe(el);
                });
            }
        },
        {
            key: "setSizeOfStaticElement",
            value: function setSizeOfStaticElement(el, boundingClientRect) {
                var key = el.dataset.ssrPlaceholder || "";
                var entry = this.staticPlaceholders.get(key);
                if (!entry) return;
                this.staticPlaceholders.set(key, {
                    x: boundingClientRect.x,
                    y: boundingClientRect.y,
                    width: boundingClientRect.width,
                    height: boundingClientRect.height
                });
            }
        },
        {
            key: "validateReactComponentMatchToPlaceholder",
            value: function validateReactComponentMatchToPlaceholder(el) {
                var _this4 = this;
                var id = el.dataset.ssrPlaceholderReplace || "";
                return new Promise(function(resolve) {
                    if (!_this4.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        _this4.reactValidateCallbacks.set(id, resolve);
                        _this4.intersectionObserver.observe(el);
                    }
                });
            }
        }
    ]);
    return SSRPlaceholderHandlers;
}();

});




parcelRegister("80e8L", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9ImEi")).then(()=>parcelRequire("i3LCS"));

});

parcelRegister("keeLf", function(module, exports) {

$parcel$export(module.exports, "configure", function () { return $eba090b681f47642$export$8d21e34596265fa2; });
$parcel$export(module.exports, "getConfig", function () { return $eba090b681f47642$export$44487a86467333c3; });

var $9q1kH = parcelRequire("9q1kH");

var $lvZs8 = parcelRequire("lvZs8");
function $eba090b681f47642$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $eba090b681f47642$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $eba090b681f47642$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $eba090b681f47642$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $eba090b681f47642$var$_arrayLikeToArray(o, minLen);
}
function $eba090b681f47642$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $eba090b681f47642$var$defaultAllowedParams = [
    "operationName",
    "operation",
    "q"
];
var $eba090b681f47642$var$getAllowedParams = function getAllowedParams() {
    var config = (0, $lvZs8.getConfig)();
    return (config === null || config === void 0 ? void 0 : config.allowedResourcesParams) || $eba090b681f47642$var$defaultAllowedParams;
};
var $eba090b681f47642$var$handleQueryParams = function handleQueryParams(urlString) {
    try {
        if (typeof urlString !== "string") return urlString;
        var url = new URL(urlString);
        var params = new URLSearchParams(url.search);
        var allowedParams = $eba090b681f47642$var$getAllowedParams();
        var _iterator = $eba090b681f47642$var$_createForOfIteratorHelper(params), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_step.value, 1), key = _step$value[0];
                if (!allowedParams.includes(key)) url.searchParams.delete(key);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return url.toString();
    } catch (e) {
        return urlString;
    }
};
var $eba090b681f47642$var$config = {
    mapResources: function mapResources(url) {
        return url;
    },
    sanitiseEndpoints: function sanitiseEndpoints(url) {
        return $eba090b681f47642$var$handleQueryParams(url);
    }
};
function $eba090b681f47642$export$8d21e34596265fa2(resourceTimingConfig) {
    var newConfig = {
        mapResources: resourceTimingConfig.mapResources,
        sanitiseEndpoints: function sanitiseEndpoints(url) {
            var sanitised = resourceTimingConfig.sanitiseEndpoints(url);
            if (sanitised) return $eba090b681f47642$var$handleQueryParams(sanitised);
            return sanitised;
        }
    };
    $eba090b681f47642$var$config = newConfig;
}
var $eba090b681f47642$export$44487a86467333c3 = function getConfig() {
    return $eba090b681f47642$var$config;
};

});
parcelRegister("lvZs8", function(module, exports) {

$parcel$export(module.exports, "getConfig", function () { return $fa9c297a05ac8ae2$export$44487a86467333c3; });
var $fa9c297a05ac8ae2$var$config;
function $fa9c297a05ac8ae2$export$10d6139a8fb42158(newConfig) {
    $fa9c297a05ac8ae2$var$config = newConfig;
}
function $fa9c297a05ac8ae2$export$44487a86467333c3() {
    return $fa9c297a05ac8ae2$var$config;
}
function $fa9c297a05ac8ae2$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$fa9c297a05ac8ae2$var$config) return 0;
        var _config = $fa9c297a05ac8ae2$var$config, killswitch = _config.killswitch, rates = _config.rates, rules = _config.rules, kind = _config.kind, autoGeneratedRate = _config.autoGeneratedRate;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(var i = 0; i < rules.length; i++){
            var rule = rules[i];
            var test = rule.test, rate = rule.rate;
            if (test != null && rate != null) {
                var regexp = new RegExp(test, "ig");
                if (regexp.test(name)) return rate;
            }
        }
        var isAutogenerated = name === null || name === void 0 ? void 0 : name.startsWith("auto-generated");
        if (isAutogenerated) {
            var _rate = autoGeneratedRate;
            if (_rate != null) return _rate;
        }
        if (kind != null) {
            var _rate2 = kind[interactionKind];
            if (_rate2 != null) return _rate2;
        }
        return 0;
    } catch (e) {
        // Fallback
        return 0;
    }
}
function $fa9c297a05ac8ae2$export$29b9ffb14861a1d(capability) {
    try {
        if (!$fa9c297a05ac8ae2$var$config) return 0;
        var _config2 = $fa9c297a05ac8ae2$var$config, capabilityRate = _config2.capability;
        if (capabilityRate != null) {
            var rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch (_unused) {
        return 0;
    }
}
var $fa9c297a05ac8ae2$var$validTypingMethods = [
    "timeout",
    "timeoutNoAlloc",
    "mutationObserver"
];
function $fa9c297a05ac8ae2$export$7e32aae12bf9b50f() {
    var defaultMethod = "timeout";
    try {
        if (!$fa9c297a05ac8ae2$var$config) return defaultMethod;
        var _config3 = $fa9c297a05ac8ae2$var$config, typingMethod = _config3.typingMethod;
        if (typingMethod != null && $fa9c297a05ac8ae2$var$validTypingMethods.find(function(m) {
            return m === typingMethod;
        })) return typingMethod;
        else return defaultMethod;
    } catch (e) {
        return defaultMethod;
    }
}
function $fa9c297a05ac8ae2$export$2d311b3fd18dcab1() {
    try {
        if (!$fa9c297a05ac8ae2$var$config) return [];
        var _config4 = $fa9c297a05ac8ae2$var$config, awaitBM3TTI = _config4.awaitBM3TTI;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch (e) {
        return [];
    }
}
function $fa9c297a05ac8ae2$export$e2ea675800536898() {
    try {
        if (!$fa9c297a05ac8ae2$var$config) return false;
        var _config5 = $fa9c297a05ac8ae2$var$config, removePageSegmentsUFOPrefixes = _config5.removePageSegmentsUFOPrefixes;
        if (removePageSegmentsUFOPrefixes != null) return removePageSegmentsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
}
function $fa9c297a05ac8ae2$export$525ba53ca98e9db() {
    try {
        if (!$fa9c297a05ac8ae2$var$config) return false;
        var _config6 = $fa9c297a05ac8ae2$var$config, removeInteractionsUFOPrefixes = _config6.removeInteractionsUFOPrefixes;
        if (removeInteractionsUFOPrefixes != null) return removeInteractionsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
}
function $fa9c297a05ac8ae2$export$4f4649ef27b6f5d6() {
    try {
        if (!$fa9c297a05ac8ae2$var$config) return undefined;
        var _config7 = $fa9c297a05ac8ae2$var$config, ufoNameOverrides = _config7.ufoNameOverrides;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch (e) {
        return undefined;
    }
}
function $fa9c297a05ac8ae2$export$3c170167645a0eff() {
    try {
        if (!$fa9c297a05ac8ae2$var$config) return undefined;
        var _config8 = $fa9c297a05ac8ae2$var$config, doNotAbortActivePressInteraction = _config8.doNotAbortActivePressInteraction;
        return doNotAbortActivePressInteraction;
    } catch (e) {
        return undefined;
    }
}
function $fa9c297a05ac8ae2$export$d6dc9444bd15f70f() {
    try {
        if (!$fa9c297a05ac8ae2$var$config) return undefined;
        var _config9 = $fa9c297a05ac8ae2$var$config, doNotAbortActivePressInteractionOnTransition = _config9.doNotAbortActivePressInteractionOnTransition;
        return doNotAbortActivePressInteractionOnTransition;
    } catch (e) {
        return undefined;
    }
}

});


parcelRegister("j1bBw", function(module, exports) {
$parcel$export(module.exports, "Link", function () { return (parcelRequire("kh0W2")).default; });
$parcel$export(module.exports, "Router", function () { return (parcelRequire("9A93V")).default; });
$parcel$export(module.exports, "getRouteFeaturesFromAppData", function () { return (parcelRequire("e5hNf")).getRouteFeaturesFromAppData; });

$parcel$export(module.exports, "getRoutes", function () { return (parcelRequire("kjZQW")).getRoutes; });
$parcel$export(module.exports, "history", function () { return (parcelRequire("677Fr")).default; });

var $kjZQW = parcelRequire("kjZQW");

var $677Fr = parcelRequire("677Fr");
parcelRequire("3hjiH");
parcelRequire("ilJwJ");

});
parcelRegister("kjZQW", function(module, exports) {

$parcel$export(module.exports, "getRoutes", function () { return $4f21f4dbc1b05710$export$2f7745f2f5ab3897; });

var $7ovNJ = parcelRequire("7ovNJ");

var $3kGxm = parcelRequire("3kGxm");

var $1cZwc = parcelRequire("1cZwc");

var $gBMfe = parcelRequire("gBMfe");

var $aTvGV = parcelRequire("aTvGV");

var $8egek = parcelRequire("8egek");
const $4f21f4dbc1b05710$var$getRouteConfig = (features)=>{
    return {
        ...(0, $3kGxm.getGlobalRoutesConfig)(),
        ...(0, $8egek.getWorkspaceRoutesConfig)(features),
        ...(0, $aTvGV.getRepositoryRoutesConfig)(),
        ...(0, $gBMfe.getProjectRoutesConfig)()
    };
};
const $4f21f4dbc1b05710$export$2f7745f2f5ab3897 = (0, $7ovNJ.default)((features)=>{
    const supportedPaths = (0, $1cZwc.getSupportedPaths)(features);
    const config = $4f21f4dbc1b05710$var$getRouteConfig(features);
    const routes = supportedPaths.map((supportedPath)=>{
        return {
            ...supportedPath,
            ...config[supportedPath.name]
        };
    });
    return routes;
});

});
parcelRegister("7ovNJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $562371580c64406e$export$2e2bcd8739ae039; });
var $562371580c64406e$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $562371580c64406e$var$isEqual(first, second) {
    if (first === second) return true;
    if ($562371580c64406e$var$safeIsNaN(first) && $562371580c64406e$var$safeIsNaN(second)) return true;
    return false;
}
function $562371580c64406e$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$562371580c64406e$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $562371580c64406e$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $562371580c64406e$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $562371580c64406e$export$2e2bcd8739ae039 = $562371580c64406e$var$memoizeOne;

});

parcelRegister("3kGxm", function(module, exports) {

$parcel$export(module.exports, "getGlobalRoutesConfig", function () { return $84ba6692a6331367$export$b80ed863cfcb7540; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

var $bT38u = parcelRequire("bT38u");

var $bi9uE = parcelRequire("bi9uE");

var $16OKL = parcelRequire("16OKL");

var $c3LR1 = parcelRequire("c3LR1");

var $7IfQd = parcelRequire("7IfQd");

const $84ba6692a6331367$var$Search = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("cXfWF")),
    modules: [
        "src/sections/search/containers/page"
    ],
    webpack: ()=>[
            undefined("src/sections/search/containers/page")
        ]
});

const $84ba6692a6331367$var$AccountWorkspacesEmptyState = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("2h0Vs")),
    modules: [
        "src/sections/account/components/workspaces/empty-state"
    ],
    webpack: ()=>[
            undefined("src/sections/account/components/workspaces/empty-state")
        ]
});

const $84ba6692a6331367$var$GlobalCreateBranchPage = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("hkEkw")),
    modules: [
        "src/sections/create-branch/containers/global-page"
    ],
    webpack: ()=>[
            undefined("src/sections/create-branch/containers/global-page")
        ]
});

const $84ba6692a6331367$var$DashboardLayout = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("eA0nD")),
    modules: [
        "src/sections/dashboard/dashboard-route"
    ],
    webpack: ()=>[
            undefined("src/sections/dashboard/dashboard-route")
        ]
});

const $84ba6692a6331367$var$AttributionsPage = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("aAQHu")),
    modules: [
        "src/sections/global/components/attributions/page"
    ],
    webpack: ()=>[
            undefined("src/sections/global/components/attributions/page")
        ]
});
const $84ba6692a6331367$export$b80ed863cfcb7540 = ()=>{
    return {
        [(0, $7IfQd.ROUTE_NAME).GLOBAL_SEARCH]: {
            // @ts-ignore: requires RouteContext type on component
            component: $84ba6692a6331367$var$Search,
            resources: [
                (0, $bT38u.loadGlobalResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).GLOBAL_ACCOUNT_PLAN_SELECTOR]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $bi9uE.PlanSelectorLoadable),
            resources: [
                (0, $bT38u.loadGlobalResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).GLOBAL_ACCOUNT_PAYMENT]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $bi9uE.AccountPaymentLoadable),
            resources: [
                (0, $bT38u.loadGlobalResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).GLOBAL_BRANCH_CREATE]: {
            component: $84ba6692a6331367$var$GlobalCreateBranchPage,
            resources: [
                (0, $bT38u.loadGlobalResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).GLOBAL_ACCOUNT_WORKSPACES]: {
            // @ts-ignore: requires RouteContext type on component
            component: $84ba6692a6331367$var$AccountWorkspacesEmptyState,
            resources: [
                (0, $bT38u.loadGlobalResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).GLOBAL_ATTRIBUTIONS_PAGE]: {
            // @ts-ignore: requires RouteContext type on component
            component: $84ba6692a6331367$var$AttributionsPage,
            layout: $84ba6692a6331367$var$DashboardLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $16OKL.dashboardNavigationResource),
                (0, $c3LR1.default)
            ]
        }
    };
};

});
parcelRegister("bT38u", function(module, exports) {

$parcel$export(module.exports, "loadGlobalResource", function () { return $e5678303d7ffc1a0$export$d9421d0172a9c342; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");
parcelRequire("5YpaN");
var $fICwP = parcelRequire("fICwP");

var $8saZD = parcelRequire("8saZD");

var $fE4bV = parcelRequire("fE4bV");

var $dkkN8 = parcelRequire("dkkN8");

var $3AVQ1 = parcelRequire("3AVQ1");
const $e5678303d7ffc1a0$export$d9421d0172a9c342 = (0, $3kfkg.createResource)({
    type: "global",
    getKey: ()=>"global",
    maxAge: Infinity,
    getData: async (_routerStoreContext, { reduxStore: reduxStore, csrftoken: csrftoken })=>{
        const { dispatch: dispatch } = reduxStore;
        const action = (0, $fICwP.hydrateAction)((0, $dkkN8.LoadGlobal), (0, $3AVQ1.stateKey), {
            url: $3AVQ1.url,
            isRouterResource: true,
            csrftoken: csrftoken,
            schema: {
                currentUser: (0, $8saZD.user),
                targetUser: (0, $8saZD.user)
            }
        });
        // check the initialstate before requesting anything
        const hydrateAction = (0, $fE4bV.getHydrateAction)(action, (0, $3AVQ1.stateKey));
        const result = await dispatch(hydrateAction);
        if ((result === null || result === void 0 ? void 0 : result.type) === (0, $dkkN8.LoadGlobal).ERROR) return null;
        return {
            status: "success"
        };
    }
});

});
parcelRegister("fE4bV", function(module, exports) {

$parcel$export(module.exports, "getHydrateAction", function () { return $5d4e8e5e97688e84$export$b3471a965f5862c6; });
$parcel$export(module.exports, "default", function () { return $5d4e8e5e97688e84$export$2e2bcd8739ae039; });

var $lIZwG = parcelRequire("lIZwG");

var $lj5Bi = parcelRequire("lj5Bi");

var $3AVQ1 = parcelRequire("3AVQ1");

var $3nrvH = parcelRequire("3nrvH");
// @ts-ignore TODO: fix noImplicitAny error here
function $5d4e8e5e97688e84$var$deleteFromState(location) {
    if (!location) return;
    const parts = location.split(".");
    const position = parts.pop();
    const parentLocation = parts.join(".");
    const pathToDelete = parentLocation ? (0, $lIZwG.default)((0, $lj5Bi.default), parentLocation) : (0, $lj5Bi.default);
    delete pathToDelete[position];
}
const $5d4e8e5e97688e84$export$b3471a965f5862c6 = (action, stateKey)=>{
    const { asyncAction: asyncAction } = action.meta;
    const domPayload = (0, $3nrvH.getStateFromKey)((0, $lj5Bi.default), stateKey);
    const domState = domPayload.data;
    if (!domState) return null;
    $5d4e8e5e97688e84$var$deleteFromState(domPayload.location);
    return {
        ...action,
        type: asyncAction.SUCCESS,
        payload: domState
    };
};
// @ts-ignore TODO: fix noImplicitAny error here
const $5d4e8e5e97688e84$var$getGlobalAction = (_action, payload)=>{
    if (!payload.global) return null;
    const global = (0, $3AVQ1.default)();
    return {
        ...global,
        type: global.meta.asyncAction.SUCCESS,
        payload: payload.global
    };
};
var // All destructured elements are unused.
// @ts-ignore
$5d4e8e5e97688e84$export$2e2bcd8739ae039 = ()=>({ // @ts-ignore TODO: fix noImplicitAny error here
    dispatch: _dispatch, // @ts-ignore TODO: fix noImplicitAny error here
    getState: _getState })=>// @ts-ignore TODO: fix noImplicitAny error here
        (next)=>// @ts-ignore TODO: fix noImplicitAny error here
            (action)=>{
                if (!action.meta) return next(action);
                const { stateKey: stateKey, asyncAction: asyncAction } = action.meta;
                // Only handle async actions with a stateKey
                if (!stateKey || !asyncAction) return next(action);
                if (action.type === asyncAction.REQUEST && !action.meta.isRouterResource) {
                    const hydrateAction = $5d4e8e5e97688e84$export$b3471a965f5862c6(action, stateKey);
                    // If we have hydrated data, exit early with that action
                    if (hydrateAction) return next(hydrateAction);
                    // We are requesting data with a state key, add the proper `state` query
                    // parameter to the request
                    action.meta.url = (0, $3nrvH.urlWithState)(action.meta.url, stateKey);
                    return next(action);
                }
                if (action.type === asyncAction.SUCCESS) {
                    const { payload: payload = {} } = action;
                    const globalAction = $5d4e8e5e97688e84$var$getGlobalAction(action, payload);
                    if (globalAction) // If there is global data, dispatch the global action
                    // (Don't return here, we want to dispatch 2 actions)
                    next(globalAction);
                    // Extract the payload from the stateKey, if it exists.
                    // We only expect data to be structured like that for `?state=section`
                    // requests; in other cases we just pass the entire payload through
                    const nextPayload = (0, $3nrvH.getStateFromKey)(payload, stateKey).data || payload;
                    return next({
                        ...action,
                        payload: nextPayload
                    });
                }
                return next(action);
            };

});
parcelRegister("lIZwG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd0d6ed30b9bc015$export$2e2bcd8739ae039; });

var $fVuMG = parcelRequire("fVuMG");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $fd0d6ed30b9bc015$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : (0, $fVuMG.default)(object, path);
    return result === undefined ? defaultValue : result;
}
var $fd0d6ed30b9bc015$export$2e2bcd8739ae039 = $fd0d6ed30b9bc015$var$get;

});
parcelRegister("fVuMG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9840ef7aab8c9b6$export$2e2bcd8739ae039; });

var $8AUEA = parcelRequire("8AUEA");

var $bZfWj = parcelRequire("bZfWj");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $b9840ef7aab8c9b6$var$baseGet(object, path) {
    path = (0, $8AUEA.default)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, $bZfWj.default)(path[index++])];
    return index && index == length ? object : undefined;
}
var $b9840ef7aab8c9b6$export$2e2bcd8739ae039 = $b9840ef7aab8c9b6$var$baseGet;

});
parcelRegister("8AUEA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $641da1bb52f10bd5$export$2e2bcd8739ae039; });

var $dEaOb = parcelRequire("dEaOb");

var $i4K6A = parcelRequire("i4K6A");

var $cRcUC = parcelRequire("cRcUC");

var $aV88P = parcelRequire("aV88P");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $641da1bb52f10bd5$var$castPath(value, object) {
    if ((0, $dEaOb.default)(value)) return value;
    return (0, $i4K6A.default)(value, object) ? [
        value
    ] : (0, $cRcUC.default)((0, $aV88P.default)(value));
}
var $641da1bb52f10bd5$export$2e2bcd8739ae039 = $641da1bb52f10bd5$var$castPath;

});
parcelRegister("dEaOb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ef7651906fbf879$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $9ef7651906fbf879$var$isArray = Array.isArray;
var $9ef7651906fbf879$export$2e2bcd8739ae039 = $9ef7651906fbf879$var$isArray;

});

parcelRegister("i4K6A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d28c5d45172ecc75$export$2e2bcd8739ae039; });

var $dEaOb = parcelRequire("dEaOb");

var $7Wqa8 = parcelRequire("7Wqa8");
/** Used to match property names within property paths. */ var $d28c5d45172ecc75$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $d28c5d45172ecc75$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $d28c5d45172ecc75$var$isKey(value, object) {
    if ((0, $dEaOb.default)(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || (0, $7Wqa8.default)(value)) return true;
    return $d28c5d45172ecc75$var$reIsPlainProp.test(value) || !$d28c5d45172ecc75$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
var $d28c5d45172ecc75$export$2e2bcd8739ae039 = $d28c5d45172ecc75$var$isKey;

});
parcelRegister("7Wqa8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c823e821dfe312a$export$2e2bcd8739ae039; });

var $9mt1a = parcelRequire("9mt1a");

var $bqTHd = parcelRequire("bqTHd");
/** `Object#toString` result references. */ var $5c823e821dfe312a$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $5c823e821dfe312a$var$isSymbol(value) {
    return typeof value == "symbol" || (0, $bqTHd.default)(value) && (0, $9mt1a.default)(value) == $5c823e821dfe312a$var$symbolTag;
}
var $5c823e821dfe312a$export$2e2bcd8739ae039 = $5c823e821dfe312a$var$isSymbol;

});


parcelRegister("cRcUC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95c4735c92286028$export$2e2bcd8739ae039; });

var $gujV1 = parcelRequire("gujV1");
/** Used to match property names within property paths. */ var $95c4735c92286028$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $95c4735c92286028$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $95c4735c92286028$var$stringToPath = (0, $gujV1.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($95c4735c92286028$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($95c4735c92286028$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
var $95c4735c92286028$export$2e2bcd8739ae039 = $95c4735c92286028$var$stringToPath;

});
parcelRegister("gujV1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c00ee61bf002d324$export$2e2bcd8739ae039; });

var $fLzne = parcelRequire("fLzne");
/** Used as the maximum memoize cache size. */ var $c00ee61bf002d324$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $c00ee61bf002d324$var$memoizeCapped(func) {
    var result = (0, $fLzne.default)(func, function(key) {
        if (cache.size === $c00ee61bf002d324$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $c00ee61bf002d324$export$2e2bcd8739ae039 = $c00ee61bf002d324$var$memoizeCapped;

});
parcelRegister("fLzne", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7a6af488fb1678d$export$2e2bcd8739ae039; });

var $fXABU = parcelRequire("fXABU");
/** Error message constants. */ var $b7a6af488fb1678d$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $b7a6af488fb1678d$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($b7a6af488fb1678d$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($b7a6af488fb1678d$var$memoize.Cache || (0, $fXABU.default));
    return memoized;
}
// Expose `MapCache`.
$b7a6af488fb1678d$var$memoize.Cache = (0, $fXABU.default);
var $b7a6af488fb1678d$export$2e2bcd8739ae039 = $b7a6af488fb1678d$var$memoize;

});
parcelRegister("fXABU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9e8c3c27c6c6913$export$2e2bcd8739ae039; });

var $lq8Og = parcelRequire("lq8Og");

var $fR30C = parcelRequire("fR30C");

var $1JEWD = parcelRequire("1JEWD");

var $jubAu = parcelRequire("jubAu");

var $1dc0B = parcelRequire("1dc0B");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $b9e8c3c27c6c6913$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$b9e8c3c27c6c6913$var$MapCache.prototype.clear = (0, $lq8Og.default);
$b9e8c3c27c6c6913$var$MapCache.prototype["delete"] = (0, $fR30C.default);
$b9e8c3c27c6c6913$var$MapCache.prototype.get = (0, $1JEWD.default);
$b9e8c3c27c6c6913$var$MapCache.prototype.has = (0, $jubAu.default);
$b9e8c3c27c6c6913$var$MapCache.prototype.set = (0, $1dc0B.default);
var $b9e8c3c27c6c6913$export$2e2bcd8739ae039 = $b9e8c3c27c6c6913$var$MapCache;

});
parcelRegister("lq8Og", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f982dc16c90722d3$export$2e2bcd8739ae039; });

var $1v2We = parcelRequire("1v2We");

var $3lavE = parcelRequire("3lavE");

var $ahUDe = parcelRequire("ahUDe");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $f982dc16c90722d3$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, $1v2We.default),
        "map": new ((0, $ahUDe.default) || (0, $3lavE.default)),
        "string": new (0, $1v2We.default)
    };
}
var $f982dc16c90722d3$export$2e2bcd8739ae039 = $f982dc16c90722d3$var$mapCacheClear;

});
parcelRegister("1v2We", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $117af725bd623f53$export$2e2bcd8739ae039; });

var $c6NZ2 = parcelRequire("c6NZ2");

var $bkCAR = parcelRequire("bkCAR");

var $bVrMb = parcelRequire("bVrMb");

var $4UF7u = parcelRequire("4UF7u");

var $IZfpr = parcelRequire("IZfpr");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $117af725bd623f53$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$117af725bd623f53$var$Hash.prototype.clear = (0, $c6NZ2.default);
$117af725bd623f53$var$Hash.prototype["delete"] = (0, $bkCAR.default);
$117af725bd623f53$var$Hash.prototype.get = (0, $bVrMb.default);
$117af725bd623f53$var$Hash.prototype.has = (0, $4UF7u.default);
$117af725bd623f53$var$Hash.prototype.set = (0, $IZfpr.default);
var $117af725bd623f53$export$2e2bcd8739ae039 = $117af725bd623f53$var$Hash;

});
parcelRegister("c6NZ2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d0cd13b0c99d8ed$export$2e2bcd8739ae039; });

var $kPuQg = parcelRequire("kPuQg");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $8d0cd13b0c99d8ed$var$hashClear() {
    this.__data__ = (0, $kPuQg.default) ? (0, $kPuQg.default)(null) : {};
    this.size = 0;
}
var $8d0cd13b0c99d8ed$export$2e2bcd8739ae039 = $8d0cd13b0c99d8ed$var$hashClear;

});
parcelRegister("kPuQg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2a07e9e6dc01313$export$2e2bcd8739ae039; });

var $iCjVJ = parcelRequire("iCjVJ");
/* Built-in method references that are verified to be native. */ var $f2a07e9e6dc01313$var$nativeCreate = (0, $iCjVJ.default)(Object, "create");
var $f2a07e9e6dc01313$export$2e2bcd8739ae039 = $f2a07e9e6dc01313$var$nativeCreate;

});
parcelRegister("iCjVJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8db3c4cf7ed1b20$export$2e2bcd8739ae039; });

var $TGahh = parcelRequire("TGahh");

var $fAcf4 = parcelRequire("fAcf4");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $d8db3c4cf7ed1b20$var$getNative(object, key) {
    var value = (0, $fAcf4.default)(object, key);
    return (0, $TGahh.default)(value) ? value : undefined;
}
var $d8db3c4cf7ed1b20$export$2e2bcd8739ae039 = $d8db3c4cf7ed1b20$var$getNative;

});
parcelRegister("TGahh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a75d836d57d32ae$export$2e2bcd8739ae039; });

var $EmE07 = parcelRequire("EmE07");

var $7RifF = parcelRequire("7RifF");

var $bmzpf = parcelRequire("bmzpf");

var $5H93l = parcelRequire("5H93l");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $0a75d836d57d32ae$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $0a75d836d57d32ae$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $0a75d836d57d32ae$var$funcProto = Function.prototype, $0a75d836d57d32ae$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $0a75d836d57d32ae$var$funcToString = $0a75d836d57d32ae$var$funcProto.toString;
/** Used to check objects for own properties. */ var $0a75d836d57d32ae$var$hasOwnProperty = $0a75d836d57d32ae$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $0a75d836d57d32ae$var$reIsNative = RegExp("^" + $0a75d836d57d32ae$var$funcToString.call($0a75d836d57d32ae$var$hasOwnProperty).replace($0a75d836d57d32ae$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $0a75d836d57d32ae$var$baseIsNative(value) {
    if (!(0, $bmzpf.default)(value) || (0, $7RifF.default)(value)) return false;
    var pattern = (0, $EmE07.default)(value) ? $0a75d836d57d32ae$var$reIsNative : $0a75d836d57d32ae$var$reIsHostCtor;
    return pattern.test((0, $5H93l.default)(value));
}
var $0a75d836d57d32ae$export$2e2bcd8739ae039 = $0a75d836d57d32ae$var$baseIsNative;

});
parcelRegister("EmE07", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07954d3418dd0867$export$2e2bcd8739ae039; });

var $9mt1a = parcelRequire("9mt1a");

var $bmzpf = parcelRequire("bmzpf");
/** `Object#toString` result references. */ var $07954d3418dd0867$var$asyncTag = "[object AsyncFunction]", $07954d3418dd0867$var$funcTag = "[object Function]", $07954d3418dd0867$var$genTag = "[object GeneratorFunction]", $07954d3418dd0867$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $07954d3418dd0867$var$isFunction(value) {
    if (!(0, $bmzpf.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $9mt1a.default)(value);
    return tag == $07954d3418dd0867$var$funcTag || tag == $07954d3418dd0867$var$genTag || tag == $07954d3418dd0867$var$asyncTag || tag == $07954d3418dd0867$var$proxyTag;
}
var $07954d3418dd0867$export$2e2bcd8739ae039 = $07954d3418dd0867$var$isFunction;

});
parcelRegister("bmzpf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $845d36b588cadcc2$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $845d36b588cadcc2$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $845d36b588cadcc2$export$2e2bcd8739ae039 = $845d36b588cadcc2$var$isObject;

});


parcelRegister("7RifF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b8ba40f92bee7b5$export$2e2bcd8739ae039; });

var $a3XlL = parcelRequire("a3XlL");
/** Used to detect methods masquerading as native. */ var $5b8ba40f92bee7b5$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $a3XlL.default) && (0, $a3XlL.default).keys && (0, $a3XlL.default).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5b8ba40f92bee7b5$var$isMasked(func) {
    return !!$5b8ba40f92bee7b5$var$maskSrcKey && $5b8ba40f92bee7b5$var$maskSrcKey in func;
}
var $5b8ba40f92bee7b5$export$2e2bcd8739ae039 = $5b8ba40f92bee7b5$var$isMasked;

});
parcelRegister("a3XlL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $753838db20ab1a8d$export$2e2bcd8739ae039; });

var $8kDqY = parcelRequire("8kDqY");
/** Used to detect overreaching core-js shims. */ var $753838db20ab1a8d$var$coreJsData = (0, $8kDqY.default)["__core-js_shared__"];
var $753838db20ab1a8d$export$2e2bcd8739ae039 = $753838db20ab1a8d$var$coreJsData;

});


parcelRegister("5H93l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4257fda6bfc803ac$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $4257fda6bfc803ac$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $4257fda6bfc803ac$var$funcToString = $4257fda6bfc803ac$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $4257fda6bfc803ac$var$toSource(func) {
    if (func != null) {
        try {
            return $4257fda6bfc803ac$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
var $4257fda6bfc803ac$export$2e2bcd8739ae039 = $4257fda6bfc803ac$var$toSource;

});


parcelRegister("fAcf4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b583b6d6c52cb094$export$2e2bcd8739ae039; });
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $b583b6d6c52cb094$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $b583b6d6c52cb094$export$2e2bcd8739ae039 = $b583b6d6c52cb094$var$getValue;

});




parcelRegister("bkCAR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83ff7fd23fe5d0bd$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $83ff7fd23fe5d0bd$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $83ff7fd23fe5d0bd$export$2e2bcd8739ae039 = $83ff7fd23fe5d0bd$var$hashDelete;

});

parcelRegister("bVrMb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8aea905b6f5d4fb5$export$2e2bcd8739ae039; });

var $kPuQg = parcelRequire("kPuQg");
/** Used to stand-in for `undefined` hash values. */ var $8aea905b6f5d4fb5$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $8aea905b6f5d4fb5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8aea905b6f5d4fb5$var$hasOwnProperty = $8aea905b6f5d4fb5$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $8aea905b6f5d4fb5$var$hashGet(key) {
    var data = this.__data__;
    if (0, $kPuQg.default) {
        var result = data[key];
        return result === $8aea905b6f5d4fb5$var$HASH_UNDEFINED ? undefined : result;
    }
    return $8aea905b6f5d4fb5$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $8aea905b6f5d4fb5$export$2e2bcd8739ae039 = $8aea905b6f5d4fb5$var$hashGet;

});

parcelRegister("4UF7u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $393c49ef6321614b$export$2e2bcd8739ae039; });

var $kPuQg = parcelRequire("kPuQg");
/** Used for built-in method references. */ var $393c49ef6321614b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $393c49ef6321614b$var$hasOwnProperty = $393c49ef6321614b$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $393c49ef6321614b$var$hashHas(key) {
    var data = this.__data__;
    return (0, $kPuQg.default) ? data[key] !== undefined : $393c49ef6321614b$var$hasOwnProperty.call(data, key);
}
var $393c49ef6321614b$export$2e2bcd8739ae039 = $393c49ef6321614b$var$hashHas;

});

parcelRegister("IZfpr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08739ea9281cd695$export$2e2bcd8739ae039; });

var $kPuQg = parcelRequire("kPuQg");
/** Used to stand-in for `undefined` hash values. */ var $08739ea9281cd695$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $08739ea9281cd695$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $kPuQg.default) && value === undefined ? $08739ea9281cd695$var$HASH_UNDEFINED : value;
    return this;
}
var $08739ea9281cd695$export$2e2bcd8739ae039 = $08739ea9281cd695$var$hashSet;

});


parcelRegister("3lavE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26eb7c3d851bbeac$export$2e2bcd8739ae039; });

var $iXq1D = parcelRequire("iXq1D");

var $kk9EI = parcelRequire("kk9EI");

var $la9wG = parcelRequire("la9wG");

var $aSoSX = parcelRequire("aSoSX");

var $iKdCh = parcelRequire("iKdCh");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $26eb7c3d851bbeac$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$26eb7c3d851bbeac$var$ListCache.prototype.clear = (0, $iXq1D.default);
$26eb7c3d851bbeac$var$ListCache.prototype["delete"] = (0, $kk9EI.default);
$26eb7c3d851bbeac$var$ListCache.prototype.get = (0, $la9wG.default);
$26eb7c3d851bbeac$var$ListCache.prototype.has = (0, $aSoSX.default);
$26eb7c3d851bbeac$var$ListCache.prototype.set = (0, $iKdCh.default);
var $26eb7c3d851bbeac$export$2e2bcd8739ae039 = $26eb7c3d851bbeac$var$ListCache;

});
parcelRegister("iXq1D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcd1ecc7ff82938b$export$2e2bcd8739ae039; });
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $dcd1ecc7ff82938b$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $dcd1ecc7ff82938b$export$2e2bcd8739ae039 = $dcd1ecc7ff82938b$var$listCacheClear;

});

parcelRegister("kk9EI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecbd2a51967b1316$export$2e2bcd8739ae039; });

var $20aQE = parcelRequire("20aQE");
/** Used for built-in method references. */ var $ecbd2a51967b1316$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $ecbd2a51967b1316$var$splice = $ecbd2a51967b1316$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ecbd2a51967b1316$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $20aQE.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $ecbd2a51967b1316$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $ecbd2a51967b1316$export$2e2bcd8739ae039 = $ecbd2a51967b1316$var$listCacheDelete;

});
parcelRegister("20aQE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1753ff1b153063ce$export$2e2bcd8739ae039; });

var $i9zf9 = parcelRequire("i9zf9");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $1753ff1b153063ce$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $i9zf9.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $1753ff1b153063ce$export$2e2bcd8739ae039 = $1753ff1b153063ce$var$assocIndexOf;

});
parcelRegister("i9zf9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d37467ddd197a793$export$2e2bcd8739ae039; });
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $d37467ddd197a793$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $d37467ddd197a793$export$2e2bcd8739ae039 = $d37467ddd197a793$var$eq;

});



parcelRegister("la9wG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f681ebdc60845665$export$2e2bcd8739ae039; });

var $20aQE = parcelRequire("20aQE");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f681ebdc60845665$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $20aQE.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $f681ebdc60845665$export$2e2bcd8739ae039 = $f681ebdc60845665$var$listCacheGet;

});

parcelRegister("aSoSX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7eb24047202715c3$export$2e2bcd8739ae039; });

var $20aQE = parcelRequire("20aQE");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7eb24047202715c3$var$listCacheHas(key) {
    return (0, $20aQE.default)(this.__data__, key) > -1;
}
var $7eb24047202715c3$export$2e2bcd8739ae039 = $7eb24047202715c3$var$listCacheHas;

});

parcelRegister("iKdCh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da5715ca9e702d49$export$2e2bcd8739ae039; });

var $20aQE = parcelRequire("20aQE");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $da5715ca9e702d49$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $20aQE.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $da5715ca9e702d49$export$2e2bcd8739ae039 = $da5715ca9e702d49$var$listCacheSet;

});


parcelRegister("ahUDe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77d76bd26c75e7a0$export$2e2bcd8739ae039; });

var $iCjVJ = parcelRequire("iCjVJ");

var $8kDqY = parcelRequire("8kDqY");
/* Built-in method references that are verified to be native. */ var $77d76bd26c75e7a0$var$Map = (0, $iCjVJ.default)((0, $8kDqY.default), "Map");
var $77d76bd26c75e7a0$export$2e2bcd8739ae039 = $77d76bd26c75e7a0$var$Map;

});


parcelRegister("fR30C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8ae23bfe0519cd1$export$2e2bcd8739ae039; });

var $134Yg = parcelRequire("134Yg");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b8ae23bfe0519cd1$var$mapCacheDelete(key) {
    var result = (0, $134Yg.default)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $b8ae23bfe0519cd1$export$2e2bcd8739ae039 = $b8ae23bfe0519cd1$var$mapCacheDelete;

});
parcelRegister("134Yg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c39ed6883e9e150$export$2e2bcd8739ae039; });

var $jBRh8 = parcelRequire("jBRh8");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $0c39ed6883e9e150$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $jBRh8.default)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var $0c39ed6883e9e150$export$2e2bcd8739ae039 = $0c39ed6883e9e150$var$getMapData;

});
parcelRegister("jBRh8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e46acc64758274c1$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $e46acc64758274c1$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var $e46acc64758274c1$export$2e2bcd8739ae039 = $e46acc64758274c1$var$isKeyable;

});



parcelRegister("1JEWD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1439c1323b178b63$export$2e2bcd8739ae039; });

var $134Yg = parcelRequire("134Yg");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $1439c1323b178b63$var$mapCacheGet(key) {
    return (0, $134Yg.default)(this, key).get(key);
}
var $1439c1323b178b63$export$2e2bcd8739ae039 = $1439c1323b178b63$var$mapCacheGet;

});

parcelRegister("jubAu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2f9ceb46c55261a$export$2e2bcd8739ae039; });

var $134Yg = parcelRequire("134Yg");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e2f9ceb46c55261a$var$mapCacheHas(key) {
    return (0, $134Yg.default)(this, key).has(key);
}
var $e2f9ceb46c55261a$export$2e2bcd8739ae039 = $e2f9ceb46c55261a$var$mapCacheHas;

});

parcelRegister("1dc0B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e20520ad81eca21$export$2e2bcd8739ae039; });

var $134Yg = parcelRequire("134Yg");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $0e20520ad81eca21$var$mapCacheSet(key, value) {
    var data = (0, $134Yg.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $0e20520ad81eca21$export$2e2bcd8739ae039 = $0e20520ad81eca21$var$mapCacheSet;

});





parcelRegister("aV88P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f358af4bc9346e5$export$2e2bcd8739ae039; });

var $8f8gg = parcelRequire("8f8gg");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $7f358af4bc9346e5$var$toString(value) {
    return value == null ? "" : (0, $8f8gg.default)(value);
}
var $7f358af4bc9346e5$export$2e2bcd8739ae039 = $7f358af4bc9346e5$var$toString;

});
parcelRegister("8f8gg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $600621f330778a75$export$2e2bcd8739ae039; });

var $jici1 = parcelRequire("jici1");

var $6t2MQ = parcelRequire("6t2MQ");

var $dEaOb = parcelRequire("dEaOb");

var $7Wqa8 = parcelRequire("7Wqa8");
/** Used as references for various `Number` constants. */ var $600621f330778a75$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $600621f330778a75$var$symbolProto = (0, $jici1.default) ? (0, $jici1.default).prototype : undefined, $600621f330778a75$var$symbolToString = $600621f330778a75$var$symbolProto ? $600621f330778a75$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $600621f330778a75$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ((0, $dEaOb.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $6t2MQ.default)(value, $600621f330778a75$var$baseToString) + "";
    if ((0, $7Wqa8.default)(value)) return $600621f330778a75$var$symbolToString ? $600621f330778a75$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$600621f330778a75$var$INFINITY ? "-0" : result;
}
var $600621f330778a75$export$2e2bcd8739ae039 = $600621f330778a75$var$baseToString;

});
parcelRegister("6t2MQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b579ce461dec0e0$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $4b579ce461dec0e0$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $4b579ce461dec0e0$export$2e2bcd8739ae039 = $4b579ce461dec0e0$var$arrayMap;

});




parcelRegister("bZfWj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ba1c172732dacde$export$2e2bcd8739ae039; });

var $7Wqa8 = parcelRequire("7Wqa8");
/** Used as references for various `Number` constants. */ var $8ba1c172732dacde$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $8ba1c172732dacde$var$toKey(value) {
    if (typeof value == "string" || (0, $7Wqa8.default)(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$8ba1c172732dacde$var$INFINITY ? "-0" : result;
}
var $8ba1c172732dacde$export$2e2bcd8739ae039 = $8ba1c172732dacde$var$toKey;

});



parcelRegister("lj5Bi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d40cb830e5dbd68$export$2e2bcd8739ae039; });
const $7d40cb830e5dbd68$var$state = JSON.parse(// eslint-disable-next-line no-restricted-properties
JSON.stringify(window.__initial_state__ || {}));
var $7d40cb830e5dbd68$export$2e2bcd8739ae039 = $7d40cb830e5dbd68$var$state;

});

parcelRegister("3AVQ1", function(module, exports) {

$parcel$export(module.exports, "stateKey", function () { return $a3888df10ca4dd49$export$77b371d6becc8882; });
$parcel$export(module.exports, "url", function () { return $a3888df10ca4dd49$export$128fa18b7194ef; });
$parcel$export(module.exports, "default", function () { return $a3888df10ca4dd49$export$2e2bcd8739ae039; });
parcelRequire("5YpaN");
var $fICwP = parcelRequire("fICwP");

var $8saZD = parcelRequire("8saZD");

var $dkkN8 = parcelRequire("dkkN8");
const $a3888df10ca4dd49$export$77b371d6becc8882 = [
    "global",
    "section.global"
];
const $a3888df10ca4dd49$export$128fa18b7194ef = "/";
var $a3888df10ca4dd49$export$2e2bcd8739ae039 = ()=>(0, $fICwP.hydrateAction)((0, $dkkN8.LoadGlobal), $a3888df10ca4dd49$export$77b371d6becc8882, {
        url: $a3888df10ca4dd49$export$128fa18b7194ef,
        schema: {
            currentUser: (0, $8saZD.user),
            targetUser: (0, $8saZD.user)
        }
    });

});

parcelRegister("3nrvH", function(module, exports) {

$parcel$export(module.exports, "getStateFromKey", function () { return $9b942133041b48d1$export$2bda2827a2082ca9; });
$parcel$export(module.exports, "urlWithState", function () { return $9b942133041b48d1$export$f45e89c6d927891b; });

var $gqmqe = parcelRequire("gqmqe");

var $lIZwG = parcelRequire("lIZwG");

var $cJH1T = parcelRequire("cJH1T");
function $9b942133041b48d1$export$2bda2827a2082ca9(state, stateKey) {
    const location = Array.isArray(stateKey) ? stateKey.find((sl)=>(0, $lIZwG.default)(state, sl)) : stateKey;
    return {
        data: (0, $lIZwG.default)(state, location || ""),
        location: location
    };
}
function $9b942133041b48d1$export$cc3129d50a01aa39(stateKey) {
    // Test if this key belongs to global/section state
    const sectionRegex = /^section\./;
    if (Array.isArray(stateKey)) return stateKey.some((key)=>sectionRegex.test(key));
    return sectionRegex.test(stateKey);
}
function $9b942133041b48d1$export$f45e89c6d927891b(url, stateKey) {
    // Add `state=view` or `state=section` query parameter to the URL without
    // clobbering existing query params
    const urlObj = (0, (/*@__PURE__*/$parcel$interopDefault($gqmqe))).parse(url);
    const search = (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).parse(urlObj.query || "");
    search.state = $9b942133041b48d1$export$cc3129d50a01aa39(stateKey) ? "section" : "view";
    return (0, (/*@__PURE__*/$parcel$interopDefault($gqmqe))).format({
        ...urlObj,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(search)
    });
}

});
parcelRegister("gqmqe", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";

var $geUa1 = parcelRequire("geUa1");

var $70ba7 = parcelRequire("70ba7");
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    "'"
].concat(unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat(autoEscape), hostEndingChars = [
    "/",
    "?",
    "#"
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that never have a hostname.
hostlessProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that always contain a // bit.
slashedProtocol = {
    "http": true,
    "https": true,
    "ftp": true,
    "gopher": true,
    "file": true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};

var $bN068 = parcelRequire("bN068");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && $70ba7.isObject(url) && url instanceof Url) return url;
    var u = new Url;
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (!$70ba7.isString(url)) throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://code.google.com/p/chromium/issues/detail?id=25916
    var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $bN068.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf("@", hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || "";
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) // IDNA Support: Returns a punycoded representation of "domain".
        // It only converts parts of the domain name that
        // have non-ASCII characters, i.e. it doesn't matter if
        // you call it with a domain that already is ASCII-only.
        this.hostname = $geUa1.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    // now rest is set to the post-host stuff.
    // chop off any delim chars.
    if (!unsafeProtocol[lowerProto]) // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $bN068.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    //to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    // ensure it's an object, and not a string url.
    // If it's an obj, this is a no-op.
    // this way, you can call url_format() on strings
    // to clean up potentially wonky urls.
    if ($70ba7.isString(obj)) obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && $70ba7.isObject(this.query) && Object.keys(this.query).length) query = $bN068.stringify(this.query);
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
    // unless they had them to begin with.
    if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if ($70ba7.isString(relative)) {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    // hash is always overridden, no matter what.
    // even href="" will remove it.
    result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        //urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) result.path = result.pathname = "/";
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        // if it's a known url protocol, then changing
        // the protocol does weird things
        // first, if it's not file:, then we MUST have a host,
        // and if there was a path
        // to begin with, then we MUST have a path.
        // if it is file:, then the host is dropped,
        // because that's known to be hostless.
        // anything else is assumed to be absolute.
        if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    // if the url is a non-slashed url, then relative
    // links like ../.. should be able
    // to crawl up to the hostname, as well.  This is strange.
    // result.protocol has already been set by now.
    // Later on, put the first path part into the host field.
    if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        // it's relative
        // throw away the existing file, and take the new path instead.
        if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (!$70ba7.isNullOrUndefined(relative.search)) {
        // just pull out the search.
        // like href='?foo'.
        // Put this after the other two cases because it simplifies the booleans
        if (psychotic) {
            result.hostname = result.host = srcPath.shift();
            //occationaly the auth can get stuck only in host
            //this especially happens in cases like
            //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
            var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.host = result.hostname = authInHost.shift();
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        //to support http.request
        if (!$70ba7.isNull(result.pathname) || !$70ba7.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        // no path at all.  easy.
        // we've already handled the other stuff above.
        result.pathname = null;
        //to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    // if a url ENDs in . or .., then it must get a trailing slash.
    // however, if it ends in anything else non-slashy,
    // then it must NOT get a trailing slash.
    var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    // strip single dots, resolve double dots to parent dir
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = result.host = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        //occationaly the auth can get stuck only in host
        //this especially happens in cases like
        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
        var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.host = result.hostname = authInHost.shift();
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (!srcPath.length) {
        result.pathname = null;
        result.path = null;
    } else result.pathname = srcPath.join("/");
    //to support request.http
    if (!$70ba7.isNull(result.pathname) || !$70ba7.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};

});
parcelRegister("geUa1", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.3.2",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) freeModule.exports = punycode;
        else for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else root.punycode = punycode;
})(this);

});

parcelRegister("70ba7", function(module, exports) {
"use strict";
module.exports = {
    isString: function(arg) {
        return typeof arg === "string";
    },
    isObject: function(arg) {
        return typeof arg === "object" && arg !== null;
    },
    isNull: function(arg) {
        return arg === null;
    },
    isNullOrUndefined: function(arg) {
        return arg == null;
    }
};

});

parcelRegister("bN068", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $895458bd31af3233$export$98e6a39c04603d36; }, function (v) { return $895458bd31af3233$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $895458bd31af3233$export$fac44ee5b035f737; }, function (v) { return $895458bd31af3233$export$fac44ee5b035f737 = v; });
var $895458bd31af3233$export$2f872c0f2117be69;
var $895458bd31af3233$export$98e6a39c04603d36;
var $895458bd31af3233$export$c564cdbbe6da493;
var $895458bd31af3233$export$fac44ee5b035f737;
"use strict";

$895458bd31af3233$export$2f872c0f2117be69 = $895458bd31af3233$export$98e6a39c04603d36 = (parcelRequire("fVbpu"));

$895458bd31af3233$export$c564cdbbe6da493 = $895458bd31af3233$export$fac44ee5b035f737 = (parcelRequire("935pc"));

});
parcelRegister("fVbpu", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $b97507b5008afbb1$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || "&";
    eq = eq || "=";
    var obj = {};
    if (typeof qs !== "string" || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === "number") maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, "%20"), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = "";
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$b97507b5008afbb1$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($b97507b5008afbb1$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $b97507b5008afbb1$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === "[object Array]";
};

});

parcelRegister("935pc", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $6968964b4d9ce16b$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case "string":
            return v;
        case "boolean":
            return v ? "true" : "false";
        case "number":
            return isFinite(v) ? v : "";
        default:
            return "";
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || "&";
    eq = eq || "=";
    if (obj === null) obj = undefined;
    if (typeof obj === "object") return $6968964b4d9ce16b$var$map($6968964b4d9ce16b$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($6968964b4d9ce16b$var$stringifyPrimitive(k)) + eq;
        if ($6968964b4d9ce16b$var$isArray(obj[k])) return $6968964b4d9ce16b$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($6968964b4d9ce16b$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($6968964b4d9ce16b$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return "";
    return encodeURIComponent($6968964b4d9ce16b$var$stringifyPrimitive(name)) + eq + encodeURIComponent($6968964b4d9ce16b$var$stringifyPrimitive(obj));
};
var $6968964b4d9ce16b$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === "[object Array]";
};
function $6968964b4d9ce16b$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $6968964b4d9ce16b$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});






parcelRegister("bi9uE", function(module, exports) {

$parcel$export(module.exports, "AccountPaymentLoadable", function () { return $3a1a568d39fd64c0$export$bad86b1b6a39f4b4; });
$parcel$export(module.exports, "PlanSelectorLoadable", function () { return $3a1a568d39fd64c0$export$80cb11729a3d0d21; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $3a1a568d39fd64c0$export$bad86b1b6a39f4b4 = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("3sI67")),
    modules: [
        "./components/payment"
    ],
    webpack: ()=>[
            undefined("./components/payment")
        ]
});

const $3a1a568d39fd64c0$export$80cb11729a3d0d21 = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("cxZ9E")),
    modules: [
        "./containers/plan-selector"
    ],
    webpack: ()=>[
            undefined("./containers/plan-selector")
        ]
});

});
parcelRegister("3sI67", function(module, exports) {


















module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvUP")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6qh0x")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kjN9y")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9r5Qy")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("e0Fn7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fDD7i")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7xLkx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3op3S")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("lphpO"))
]).then(()=>parcelRequire("lqop5"));

});

parcelRegister("cxZ9E", function(module, exports) {




















module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvUP")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6qh0x")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kjN9y")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("apPbw")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9r5Qy")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("e0Fn7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fDD7i")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7xLkx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3op3S")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("h77Cr"))
]).then(()=>parcelRequire("6aslM"));

});


parcelRegister("16OKL", function(module, exports) {

$parcel$export(module.exports, "dashboardNavigationResource", function () { return $9baa8b0c2f0d99c0$export$c060cc4935010611; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $6OwE2 = parcelRequire("6OwE2");

var $k2cPS = parcelRequire("k2cPS");
const $9baa8b0c2f0d99c0$export$c060cc4935010611 = (0, $3kfkg.createResource)({
    type: "DASHBOARD_NAVIGATION",
    getKey: ({ match: match })=>`dashboard:${match.params.workspaceSlug}`,
    maxAge: 20000,
    getData: async (_routerStoreContext, { csrftoken: csrftoken })=>{
        const requestUrl = (0, $6OwE2.default).api.internal.navigation();
        const response = await fetch((0, $k2cPS.default)(requestUrl, {
            headers: (0, $k2cPS.jsonHeaders)
        }, csrftoken));
        if (!response.ok) throw new Error(`Error fetching dashboard navigation data (${response.status}): ${response.statusText}`);
        const navigationData = await response.json();
        return navigationData;
    }
});

});
parcelRegister("6OwE2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73444abf544d25db$export$2e2bcd8739ae039; });

var $9H597 = parcelRequire("9H597");
var $73444abf544d25db$export$2e2bcd8739ae039 = {
    api: {
        internal: {
            dashboardRepositories: (queryParams)=>{
                const url = `/!api/internal/dashboard/repositories`;
                return `${url}${(0, $9H597.stringify)(queryParams || {})}`;
            },
            navigation: ()=>{
                return `/!api/internal/menu/dashboard`;
            },
            repositoryOwners: (query)=>{
                const url = `/!api/internal/dashboard/repository-owners`;
                return `${url}${(0, $9H597.stringify)({
                    query: query
                })}`;
            },
            repositoryBuildStatuses: ()=>{
                return `/!api/internal/repository-statuses`;
            },
            repositoryProjects: (queryParams)=>{
                const url = `/!api/internal/dashboard/repository-projects`;
                return `${url}${(0, $9H597.stringify)(queryParams || {})}`;
            },
            overviewViewState: ()=>{
                return `/!api/internal/dashboard/overview-view-state`;
            }
        },
        v20: {
            profileRepositories: (uuid, queryParams)=>{
                const url = `/!api/2.0/repositories/${uuid}`;
                return `${url}${(0, $9H597.stringify)(queryParams || {})}`;
            },
            filterUserWorkspaces: (search)=>{
                const url = "/!api/2.0/workspaces";
                const query = {
                    q: `name~"${search}"`
                };
                return `${url}${search ? (0, $9H597.stringify)(query) : null}`;
            }
        }
    },
    ui: {
        root: ()=>"/",
        overview: ()=>"/dashboard/overview",
        repositories: (search)=>{
            const url = `/dashboard/repositories`;
            return `${url}${(0, $9H597.stringify)({
                search: search
            })}`;
        }
    }
};

});


parcelRegister("c3LR1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $630479328795b0a6$export$2e2bcd8739ae039; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");
const $630479328795b0a6$var$fetchPackages = async (source)=>{
    try {
        const response = await fetch(`https://bbc-object-storage--frontbucket.us-east-1.prod.public.atl-paas.net/licenses/${source}.json`);
        return response.json();
    } catch  {
        // eslint-disable-next-line no-console
        console.error(`${source} licenses not found`);
        return [];
    }
};
var $630479328795b0a6$export$2e2bcd8739ae039 = (0, $3kfkg.createResource)({
    type: "global",
    getKey: ()=>"attributions",
    maxAge: 30000,
    getData: async ()=>{
        const corePackages = await $630479328795b0a6$var$fetchPackages("core");
        const frontbucketPackages = await $630479328795b0a6$var$fetchPackages("frontbucket");
        // We want to show the latest version for each package. There may be a more
        // efficient way to do this but since we're only working with a few hundred
        // items we'll aim to make this as clear as possible
        const packageToVersions = {};
        const addPackage = (pkg)=>{
            const packages = packageToVersions[pkg.name];
            if (!packages) {
                packageToVersions[pkg.name] = [
                    pkg
                ];
                return;
            }
            // if the license is different from any others, add it
            const packageWithMatchingLicense = packages.find((p)=>pkg.licenseFile === p.licenseFile);
            if (!packageWithMatchingLicense) {
                packages.push(pkg);
                // if any of the duplicates don't have a license, remove them
                if (packages.length > 1) packageToVersions[pkg.name] = packages.filter((p)=>p.licenseFile);
                return;
            }
            // if this version is older than the one we've already recorded, skip it
            if (packageWithMatchingLicense.version > pkg.version) return;
            // replace the older version with the newest version
            const index = packages.indexOf(packageWithMatchingLicense);
            packages.splice(index, 1, pkg);
        };
        corePackages.forEach(addPackage);
        frontbucketPackages.forEach(addPackage);
        const packageList = Object.values(packageToVersions).flatMap((p)=>p);
        packageList.sort((a, b)=>a.name.localeCompare(b.name));
        return packageList;
    }
});

});

parcelRegister("7IfQd", function(module, exports) {

$parcel$export(module.exports, "ROUTE_NAME", function () { return $2193460d71a23175$export$62a7cb2c640d0240; });
var $2193460d71a23175$export$62a7cb2c640d0240;
(function(ROUTE_NAME) {
    ROUTE_NAME["ROOT"] = "ROOT";
    ROUTE_NAME["GLOBAL_SEARCH"] = "GLOBAL_SEARCH";
    ROUTE_NAME["GLOBAL_ACCOUNT_PLAN_SELECTOR"] = "GLOBAL_ACCOUNT_PLAN_SELECTOR";
    ROUTE_NAME["GLOBAL_ACCOUNT_PAYMENT"] = "GLOBAL_ACCOUNT_PAYMENT";
    ROUTE_NAME["GLOBAL_BRANCH_CREATE"] = "GLOBAL_BRANCH_CREATE";
    ROUTE_NAME["GLOBAL_ACCOUNT_WORKSPACES"] = "GLOBAL_ACCOUNT_WORKSPACES";
    ROUTE_NAME["GLOBAL_ATTRIBUTIONS_PAGE"] = "GLOBAL_ATTRIBUTIONS_PAGE";
    ROUTE_NAME["PROFILE_REPOSITORIES"] = "PROFILE_REPOSITORIES";
    ROUTE_NAME["PROJECT_REPOSITORIES"] = "PROJECT_REPOSITORIES";
    ROUTE_NAME["PROJECT_SETTINGS_DETAILS"] = "PROJECT_SETTINGS_DETAILS";
    ROUTE_NAME["PROJECT_SETTINGS_ACCESS_KEYS"] = "PROJECT_SETTINGS_ACCESS_KEYS";
    ROUTE_NAME["PROJECT_SETTINGS_PERMISSIONS"] = "PROJECT_SETTINGS_PERMISSIONS";
    ROUTE_NAME["PROJECT_SETTINGS_DEFAULT_REVIEWERS"] = "PROJECT_SETTINGS_DEFAULT_REVIEWERS";
    ROUTE_NAME["REPOSITORY_ADMIN_DEFAULT_REVIEW_GROUPS"] = "REPOSITORY_ADMIN_DEFAULT_REVIEW_GROUPS";
    ROUTE_NAME["PROJECT_SETTINGS_BRANCHING_MODEL"] = "PROJECT_SETTINGS_BRANCHING_MODEL";
    ROUTE_NAME["PROJECT_SETTINGS_MERGE_STRATEGIES"] = "PROJECT_SETTINGS_MERGE_STRATEGIES";
    ROUTE_NAME["PROJECT_SETTINGS_BRANCH_RESTRICTIONS"] = "PROJECT_SETTINGS_BRANCH_RESTRICTIONS";
    ROUTE_NAME["PROJECT_SETTINGS_ACCESS_TOKENS"] = "PROJECT_SETTINGS_ACCESS_TOKENS";
    ROUTE_NAME["REPOSITORY_REDIRECT"] = "REPOSITORY_REDIRECT";
    ROUTE_NAME["REPOSITORY_SOURCE"] = "REPOSITORY_SOURCE";
    ROUTE_NAME["REPOSITORY_SOURCE_DIFF"] = "REPOSITORY_SOURCE_DIFF";
    ROUTE_NAME["REPOSITORY_COMMITS"] = "REPOSITORY_COMMITS";
    ROUTE_NAME["REPOSITORY_COMMIT"] = "REPOSITORY_COMMIT";
    ROUTE_NAME["REPOSITORY_COMMITS_HISTORY"] = "REPOSITORY_COMMITS_HISTORY";
    ROUTE_NAME["REPOSITORY_CONNECT_PAGE"] = "REPOSITORY_CONNECT_PAGE";
    ROUTE_NAME["REPOSITORY_FORGE_PAGE"] = "REPOSITORY_FORGE_PAGE";
    ROUTE_NAME["REPOSITORY_FILE_HISTORY"] = "REPOSITORY_FILE_HISTORY";
    ROUTE_NAME["REPOSITORY_JIRA_VIEW"] = "REPOSITORY_JIRA_VIEW";
    ROUTE_NAME["REPOSITORY_CODE_REVIEW"] = "REPOSITORY_CODE_REVIEW";
    ROUTE_NAME["REPOSITORY_CREATE_PR"] = "REPOSITORY_CREATE_PR";
    ROUTE_NAME["REPOSITORY_BRANCH_CREATE"] = "REPOSITORY_BRANCH_CREATE";
    ROUTE_NAME["REPOSITORY_BRANCH_DETAIL"] = "REPOSITORY_BRANCH_DETAIL";
    ROUTE_NAME["REPOSITORY_BRANCHES_LIST"] = "REPOSITORY_BRANCHES_LIST";
    ROUTE_NAME["REPOSITORY_PULL_REQUESTS"] = "REPOSITORY_PULL_REQUESTS";
    ROUTE_NAME["REPOSITORY_COLD_STORAGE"] = "REPOSITORY_COLD_STORAGE";
    ROUTE_NAME["REPOSITORY_SECURITY"] = "REPOSITORY_SECURITY";
    ROUTE_NAME["REPOSITORY_SECURITY_LEARN_MORE"] = "REPOSITORY_SECURITY_LEARN_MORE";
    ROUTE_NAME["REPOSITORY_DEPLOYMENTS"] = "REPOSITORY_DEPLOYMENTS";
    ROUTE_NAME["REPOSITORY_PIPELINES"] = "REPOSITORY_PIPELINES";
    ROUTE_NAME["REPOSITORY_PIPELINES_RESULT"] = "REPOSITORY_PIPELINES_RESULT";
    ROUTE_NAME["REPOSITORY_TEST_MANAGEMENT"] = "REPOSITORY_TEST_MANAGEMENT";
    ROUTE_NAME["REPOSITORY_TEST_EXECUTION"] = "REPOSITORY_TEST_EXECUTION";
    ROUTE_NAME["REPOSITORY_ADMIN_DETAIL"] = "REPOSITORY_ADMIN_DETAIL";
    ROUTE_NAME["REPOSITORY_ADMIN_PERMISSIONS"] = "REPOSITORY_ADMIN_PERMISSIONS";
    ROUTE_NAME["REPOSITORY_ADMIN_ACCESS_KEYS"] = "REPOSITORY_ADMIN_ACCESS_KEYS";
    ROUTE_NAME["REPOSITORY_ADMIN_COMMITTERS"] = "REPOSITORY_ADMIN_COMMITTERS";
    ROUTE_NAME["REPOSITORY_ADMIN_COMPLIANCE"] = "REPOSITORY_ADMIN_COMPLIANCE";
    ROUTE_NAME["REPOSITORY_ADMIN_BRANCH_RESTRICTIONS"] = "REPOSITORY_ADMIN_BRANCH_RESTRICTIONS";
    ROUTE_NAME["REPOSITORY_ADMIN_BRANCHING_MODEL"] = "REPOSITORY_ADMIN_BRANCHING_MODEL";
    ROUTE_NAME["REPOSITORY_ADMIN_MERGE_CHECKS"] = "REPOSITORY_ADMIN_MERGE_CHECKS";
    ROUTE_NAME["REPOSITORY_ADMIN_MERGE_STRATEGIES"] = "REPOSITORY_ADMIN_MERGE_STRATEGIES";
    ROUTE_NAME["REPOSITORY_ADMIN_DEFAULT_REVIEWERS"] = "REPOSITORY_ADMIN_DEFAULT_REVIEWERS";
    ROUTE_NAME["REPOSITORY_ADMIN_ACCESS_TOKENS"] = "REPOSITORY_ADMIN_ACCESS_TOKENS";
    ROUTE_NAME["REPOSITORY_ADMIN_ISSUES_MIGRATION"] = "REPOSITORY_ADMIN_ISSUES_MIGRATION";
    ROUTE_NAME["REPOSITORY_ADMIN_CONNECT_IFRAME"] = "REPOSITORY_ADMIN_CONNECT_IFRAME";
    ROUTE_NAME["REPOSITORY_ADMIN_IFRAME"] = "REPOSITORY_ADMIN_IFRAME";
    ROUTE_NAME["REPOSITORY_ADMIN_FORGE_PAGE"] = "REPOSITORY_ADMIN_FORGE_PAGE";
    ROUTE_NAME["REPOSITORY_ADMIN_WEBHOOKS_ROOT"] = "REPOSITORY_ADMIN_WEBHOOKS_ROOT";
    ROUTE_NAME["REPOSITORY_ADMIN_CREATE_WEBHOOK"] = "REPOSITORY_ADMIN_CREATE_WEBHOOK";
    ROUTE_NAME["REPOSITORY_ADMIN_EDIT_WEBHOOK"] = "REPOSITORY_ADMIN_EDIT_WEBHOOK";
    ROUTE_NAME["REPOSITORY_ADMIN_VIEW_WEBHOOK"] = "REPOSITORY_ADMIN_VIEW_WEBHOOK";
    ROUTE_NAME["REPOSITORY_ADMIN_VIEW_WEBHOOK_EVENT"] = "REPOSITORY_ADMIN_VIEW_WEBHOOK_EVENT";
    ROUTE_NAME["REPOSITORY_ADMIN_PIPELINES_REDIRECT_SETTINGS"] = "REPOSITORY_ADMIN_PIPELINES_REDIRECT_SETTINGS";
    ROUTE_NAME["REPOSITORY_ADMIN_PIPELINES_REDIRECT_RUNNERS"] = "REPOSITORY_ADMIN_PIPELINES_REDIRECT_RUNNERS";
    ROUTE_NAME["REPOSITORY_ADMIN_PIPELINES_REDIRECT_DEPLOYMENTS"] = "REPOSITORY_ADMIN_PIPELINES_REDIRECT_DEPLOYMENTS";
    ROUTE_NAME["REPOSITORY_ADMIN_PIPELINES_SETTINGS"] = "REPOSITORY_ADMIN_PIPELINES_SETTINGS";
    ROUTE_NAME["REPOSITORY_ADMIN_PIPELINES_OPENID"] = "REPOSITORY_ADMIN_PIPELINES_OPENID";
    ROUTE_NAME["REPOSITORY_ADMIN_PIPELINES_SSH_KEYS"] = "REPOSITORY_ADMIN_PIPELINES_SSH_KEYS";
    ROUTE_NAME["REPOSITORY_ADMIN_PIPELINES_RUNNERS"] = "REPOSITORY_ADMIN_PIPELINES_RUNNERS";
    ROUTE_NAME["REPOSITORY_ADMIN_PIPELINES_DYNAMIC_PIPELINES"] = "REPOSITORY_ADMIN_PIPELINES_DYNAMIC_PIPELINES";
    ROUTE_NAME["REPOSITORY_ADMIN_PIPELINES_DEPLOYMENTS"] = "REPOSITORY_ADMIN_PIPELINES_DEPLOYMENTS";
    ROUTE_NAME["REPOSITORY_ADMIN_PIPELINES_VARIABLES"] = "REPOSITORY_ADMIN_PIPELINES_VARIABLES";
    ROUTE_NAME["WORKSPACE_CREATE"] = "WORKSPACE_CREATE";
    ROUTE_NAME["WORKSPACE_PULL_REQUESTS"] = "WORKSPACE_PULL_REQUESTS";
    ROUTE_NAME["WORKSPACE_SEARCH"] = "WORKSPACE_SEARCH";
    ROUTE_NAME["WORKSPACE_PROJECTS"] = "WORKSPACE_PROJECTS";
    ROUTE_NAME["WORKSPACE_REPOSITORIES"] = "WORKSPACE_REPOSITORIES";
    ROUTE_NAME["WORKSPACE_ROOT"] = "WORKSPACE_ROOT";
    ROUTE_NAME["WORKSPACE_SETTINGS_CONNECT_ADMIN"] = "WORKSPACE_SETTINGS_CONNECT_ADMIN";
    ROUTE_NAME["WORKSPACE_SETTINGS_CONNECT_CONFIGURE"] = "WORKSPACE_SETTINGS_CONNECT_CONFIGURE";
    ROUTE_NAME["WORKSPACE_SETTINGS_IFRAME"] = "WORKSPACE_SETTINGS_IFRAME";
    ROUTE_NAME["WORKSPACE_SETTINGS_GROUP"] = "WORKSPACE_SETTINGS_GROUP";
    ROUTE_NAME["WORKSPACE_SETTINGS_GROUPS"] = "WORKSPACE_SETTINGS_GROUPS";
    ROUTE_NAME["WORKSPACE_SETTINGS_ROOT"] = "WORKSPACE_SETTINGS_ROOT";
    ROUTE_NAME["WORKSPACE_SETTINGS_USER_DIRECTORY"] = "WORKSPACE_SETTINGS_USER_DIRECTORY";
    ROUTE_NAME["WORKSPACE_SETTINGS_ATLASSIAN_INTELLIGENCE"] = "WORKSPACE_SETTINGS_ATLASSIAN_INTELLIGENCE";
    ROUTE_NAME["WORKSPACE_SETTINGS_COMPASS"] = "WORKSPACE_SETTINGS_COMPASS";
    ROUTE_NAME["WORKSPACE_SETTINGS_MERGE_CHECKS"] = "WORKSPACE_SETTINGS_MERGE_CHECKS";
    ROUTE_NAME["WORKSPACE_SETTINGS_PERMISSIONS"] = "WORKSPACE_SETTINGS_PERMISSIONS";
    ROUTE_NAME["WORKSPACE_SETTINGS_ACCESS_TOKENS"] = "WORKSPACE_SETTINGS_ACCESS_TOKENS";
    ROUTE_NAME["WORKSPACE_SETTINGS_PIPELINES_REDIRECT_SETTINGS"] = "WORKSPACE_SETTINGS_PIPELINES_REDIRECT_SETTINGS";
    ROUTE_NAME["WORKSPACE_SETTINGS_PIPELINES_REDIRECT_RUNNERS"] = "WORKSPACE_SETTINGS_PIPELINES_REDIRECT_RUNNERS";
    ROUTE_NAME["WORKSPACE_SETTINGS_PIPELINES_RUNNERS"] = "WORKSPACE_SETTINGS_PIPELINES_RUNNERS";
    ROUTE_NAME["WORKSPACE_SETTINGS_PIPELINES_VARIABLES"] = "WORKSPACE_SETTINGS_PIPELINES_VARIABLES";
    ROUTE_NAME["WORKSPACE_SETTINGS_PIPELINES_DYNAMIC_PIPELINES"] = "WORKSPACE_SETTINGS_PIPELINES_DYNAMIC_PIPELINES";
    ROUTE_NAME["WORKSPACE_SETTINGS_FORGE_PAGE"] = "WORKSPACE_SETTINGS_FORGE_PAGE";
    ROUTE_NAME["WORKSPACE_OVERVIEW"] = "WORKSPACE_OVERVIEW";
})($2193460d71a23175$export$62a7cb2c640d0240 || ($2193460d71a23175$export$62a7cb2c640d0240 = {}));

});

parcelRegister("cXfWF", function(module, exports) {
































module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6XRs7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("i5DDp")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("dx5v1")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("aNQri")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvUP")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6qh0x")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kjN9y")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("eEZpb")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5chan")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2Ju5h")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("e0Fn7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fDD7i")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7xLkx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3op3S")),
    (parcelRequire("8iLLr"))((parcelRequire("7kEWw")).resolve("gQqOh")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("aBBp0"))
]).then(()=>parcelRequire("jCovg"));

});

parcelRegister("2h0Vs", function(module, exports) {


































module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jokVj")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("a0pdz")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("4lXxI")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8FZFT")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("lHmBe")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("gSn8f")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvUP")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6qh0x")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kjN9y")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c3BIL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvz8")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("e0Fn7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fDD7i")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7xLkx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3op3S")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3FKL4"))
]).then(()=>parcelRequire("4MjuO"));

});

parcelRegister("hkEkw", function(module, exports) {
















module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvUP")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6qh0x")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kjN9y")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("e0Fn7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fDD7i")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7xLkx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3op3S")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("d6TmC"))
]).then(()=>parcelRequire("7NZwG"));

});

parcelRegister("eA0nD", function(module, exports) {


































module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jokVj")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("a0pdz")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("4lXxI")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8FZFT")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("lHmBe")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("gSn8f")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvUP")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6qh0x")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kjN9y")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c3BIL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvz8")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("e0Fn7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fDD7i")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7xLkx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3op3S")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("j3iYS"))
]).then(()=>parcelRequire("eh67D"));

});

parcelRegister("aAQHu", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6zh6R")).then(()=>parcelRequire("acBBk"));

});


parcelRegister("1cZwc", function(module, exports) {

$parcel$export(module.exports, "getSupportedPaths", function () { return $b8f34fb97f48d746$export$e1831da75619bae2; });

var $a5n90 = parcelRequire("a5n90");

var $bJweY = parcelRequire("bJweY");

var $6l91A = parcelRequire("6l91A");

var $4J0BW = parcelRequire("4J0BW");
const $b8f34fb97f48d746$export$e1831da75619bae2 = (features)=>{
    return [
        ...(0, $a5n90.getSupportedPaths)(),
        ...(0, $4J0BW.getSupportedPaths)(features),
        ...(0, $bJweY.getSupportedPaths)(),
        ...(0, $6l91A.getSupportedPaths)(features)
    ];
};

});
parcelRegister("a5n90", function(module, exports) {

$parcel$export(module.exports, "getSupportedPaths", function () { return $a08c23ed55ab70be$export$e1831da75619bae2; });

var $7IfQd = parcelRequire("7IfQd");
const $a08c23ed55ab70be$export$e1831da75619bae2 = ()=>[
        {
            name: (0, $7IfQd.ROUTE_NAME).GLOBAL_SEARCH,
            path: "/search"
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).GLOBAL_ACCOUNT_WORKSPACES,
            path: "/account/workspaces"
        },
        ...[
            "/account/user/:uuid/plans",
            "/:workspaceSlug/workspace/settings/plans",
            "/workspaces/plans"
        ].map((path)=>({
                name: (0, $7IfQd.ROUTE_NAME).GLOBAL_ACCOUNT_PLAN_SELECTOR,
                path: path
            })),
        ...[
            "/account/user/:uuid/payment",
            "/account/user/:uuid/billing-details"
        ].map((path)=>({
                name: (0, $7IfQd.ROUTE_NAME).GLOBAL_ACCOUNT_PAYMENT,
                path: path
            })),
        {
            name: (0, $7IfQd.ROUTE_NAME).GLOBAL_BRANCH_CREATE,
            path: "/branch/create"
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).GLOBAL_ATTRIBUTIONS_PAGE,
            path: "/site/attributions"
        }
    ];

});

parcelRegister("bJweY", function(module, exports) {

$parcel$export(module.exports, "getSupportedPaths", function () { return $513fea1271660f5c$export$e1831da75619bae2; });

var $7IfQd = parcelRequire("7IfQd");
const $513fea1271660f5c$export$e1831da75619bae2 = ()=>{
    const paths = [
        {
            name: (0, $7IfQd.ROUTE_NAME).PROJECT_SETTINGS_ACCESS_KEYS,
            path: "/:workspaceSlug/workspace/projects/:projectKey/settings/access-keys",
            exact: true
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).PROJECT_REPOSITORIES,
            path: "/:workspaceSlug/workspace/projects/:projectKey",
            exact: true
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).PROJECT_SETTINGS_DETAILS,
            path: "/:workspaceSlug/workspace/projects/:projectKey/settings/",
            exact: true
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).PROJECT_SETTINGS_DEFAULT_REVIEWERS,
            path: "/:workspaceSlug/workspace/projects/:projectKey/settings/pullrequests/reviewers",
            exact: false
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).PROJECT_SETTINGS_BRANCHING_MODEL,
            path: "/:workspaceSlug/workspace/projects/:projectKey/settings/branching-model",
            exact: false
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).PROJECT_SETTINGS_MERGE_STRATEGIES,
            path: "/:workspaceSlug/workspace/projects/:projectKey/settings/merge-strategies",
            exact: false
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).PROJECT_SETTINGS_ACCESS_TOKENS,
            path: "/:workspaceSlug/workspace/projects/:projectKey/settings/access-tokens",
            exact: true
        }
    ];
    paths.push({
        name: (0, $7IfQd.ROUTE_NAME).PROJECT_SETTINGS_PERMISSIONS,
        path: "/:workspaceSlug/workspace/projects/:projectKey/settings/permissions",
        exact: true
    });
    paths.push({
        name: (0, $7IfQd.ROUTE_NAME).PROJECT_SETTINGS_BRANCH_RESTRICTIONS,
        path: "/:workspaceSlug/workspace/projects/:projectKey/settings/branch-restrictions",
        exact: false
    });
    return paths;
};

});

parcelRegister("6l91A", function(module, exports) {

$parcel$export(module.exports, "getSupportedPaths", function () { return $301f94a573448d39$export$e1831da75619bae2; });

var $dGpbb = parcelRequire("dGpbb");

var $cNPHM = parcelRequire("cNPHM");

var $7IfQd = parcelRequire("7IfQd");
// passes `repositoryFullSlug` param
const $301f94a573448d39$var$repoPath = (path)=>`/${0, $cNPHM.REPO_FULL_SLUG_REGEX}/${path}`;
const $301f94a573448d39$export$e1831da75619bae2 = (features)=>{
    const { isRepoAdminAliasesEnabled: isRepoAdminAliasesEnabled, isRepoAdminComplianceEnabled: isRepoAdminComplianceEnabled, isPipelinesTestManagementEnabled: isPipelinesTestManagementEnabled } = features;
    const paths = [
        {
            name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_CREATE_WEBHOOK,
            path: (0, $dGpbb.legacyPath)("admin/webhooks/new"),
            exact: true
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_EDIT_WEBHOOK,
            path: (0, $dGpbb.legacyPath)("admin/webhooks/:webhookUuid/edit"),
            exact: true
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_VIEW_WEBHOOK_EVENT,
            path: (0, $dGpbb.legacyPath)("admin/webhooks/:webhookUuid/event/:eventId"),
            exact: true
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_VIEW_WEBHOOK,
            path: (0, $dGpbb.legacyPath)("admin/webhooks/:webhookUuid"),
            exact: true
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_WEBHOOKS_ROOT,
            path: (0, $dGpbb.legacyPath)("admin/webhooks"),
            exact: false
        }
    ];
    paths.push({
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_CREATE_PR,
        path: (0, $dGpbb.legacyPath)("pull-requests/new"),
        exact: false
    });
    paths.push({
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_CODE_REVIEW,
        path: (0, $dGpbb.legacyPath)("pull-requests/:pullRequestId/:tab(overview|diff|commits)?"),
        exact: false
    });
    paths.push({
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_BRANCH_DETAIL,
        path: (0, $dGpbb.legacyPath)("branch/:ref+"),
        exact: false
    });
    // settings pages
    paths.push({
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_DETAIL,
        path: (0, $dGpbb.legacyPath)("admin"),
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_PERMISSIONS,
        path: (0, $dGpbb.legacyPath)("admin/permissions"),
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_ACCESS_KEYS,
        path: (0, $dGpbb.legacyPath)("admin/access-keys"),
        exact: true
    });
    if (isRepoAdminAliasesEnabled) paths.push({
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_COMMITTERS,
        path: (0, $dGpbb.legacyPath)("admin/committers"),
        exact: true
    });
    if (isRepoAdminComplianceEnabled) paths.push({
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_COMPLIANCE,
        path: (0, $dGpbb.legacyPath)("admin/compliance"),
        exact: true
    });
    paths.push({
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_ACCESS_TOKENS,
        path: (0, $dGpbb.legacyPath)("admin/access-tokens"),
        exact: true
    });
    paths.push({
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_PIPELINES_REDIRECT_SETTINGS,
        path: (0, $dGpbb.legacyPath)("admin/addon/admin/:appKey(pipelines)/:moduleKey(settings|openid-connect|ssh-keys|integrations|repository-variables)"),
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_PIPELINES_REDIRECT_RUNNERS,
        path: (0, $dGpbb.legacyPath)("admin/addon/admin/:appKey(pipelines)/:moduleKey(runners)"),
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_PIPELINES_REDIRECT_DEPLOYMENTS,
        path: (0, $dGpbb.legacyPath)("admin/addon/admin/:appKey(pipelines)/:moduleKey(deployment-settings)"),
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_PIPELINES_SETTINGS,
        path: (0, $dGpbb.legacyPath)("admin/pipelines/:path(settings)"),
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_PIPELINES_OPENID,
        path: (0, $dGpbb.legacyPath)("admin/pipelines/:path(openid-connect)"),
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_PIPELINES_SSH_KEYS,
        path: (0, $dGpbb.legacyPath)("admin/pipelines/:path(ssh-keys)"),
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_PIPELINES_RUNNERS,
        path: (0, $dGpbb.legacyPath)("admin/pipelines/:path(runners)"),
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_PIPELINES_DEPLOYMENTS,
        path: (0, $dGpbb.legacyPath)("admin/pipelines/:path(deployment-settings)"),
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_PIPELINES_VARIABLES,
        path: (0, $dGpbb.legacyPath)("admin/pipelines/:path(repository-variables)"),
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_PIPELINES_DYNAMIC_PIPELINES,
        path: (0, $dGpbb.legacyPath)("admin/pipelines/:path(dynamic-pipelines)"),
        exact: true
    });
    paths.push({
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_FORGE_PAGE,
        path: (0, $dGpbb.legacyPath)("admin/forge/:appId/:moduleKey"),
        exact: true
    });
    paths.push({
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_BRANCH_RESTRICTIONS,
        path: (0, $dGpbb.legacyPath)("admin/branch-permissions"),
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_BRANCH_RESTRICTIONS,
        path: (0, $dGpbb.legacyPath)("admin/branch-restrictions"),
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_BRANCHING_MODEL,
        path: (0, $dGpbb.legacyPath)("admin/branching-model"),
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_MERGE_CHECKS,
        path: (0, $dGpbb.legacyPath)("admin/merge-checks"),
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_MERGE_STRATEGIES,
        path: (0, $dGpbb.legacyPath)("admin/merge-strategies"),
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_DEFAULT_REVIEWERS,
        path: (0, $dGpbb.legacyPath)("admin/pullrequests/reviewers"),
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_DEFAULT_REVIEW_GROUPS,
        path: (0, $dGpbb.legacyPath)("admin/pullrequests/default-review-groups"),
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_ISSUES_MIGRATION,
        path: (0, $dGpbb.legacyPath)("admin/issues/jira-migration"),
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_CONNECT_IFRAME,
        path: (0, $dGpbb.legacyPath)("admin/addon/admin/:appKey/:moduleKey"),
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_CONNECT_IFRAME,
        path: (0, $dGpbb.legacyPath)("admin/addon/admin/:appKey/:moduleKey")
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_IFRAME,
        path: (0, $dGpbb.legacyPath)("admin/:path*")
    });
    // repo pages
    paths.push({
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_SOURCE,
        path: (0, $dGpbb.legacyPath)("src/:refOrHash?/:path*")
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_SOURCE_DIFF,
        path: $301f94a573448d39$var$repoPath("diff/:path+")
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_BRANCH_CREATE,
        path: (0, $dGpbb.legacyPath)("branch")
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_BRANCHES_LIST,
        path: (0, $dGpbb.legacyPath)("branches")
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_PULL_REQUESTS,
        path: (0, $dGpbb.legacyPath)("pull-requests")
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_COLD_STORAGE,
        path: (0, $dGpbb.legacyPath)("cold-storage")
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_SECURITY,
        path: (0, $dGpbb.legacyPath)("security"),
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_SECURITY_LEARN_MORE,
        path: (0, $dGpbb.legacyPath)("security/learn-more")
    }, ...[
        $301f94a573448d39$var$repoPath("commits"),
        $301f94a573448d39$var$repoPath("commits/all"),
        $301f94a573448d39$var$repoPath("commits/(branch|tag)/:refName(.*)")
    ].map((path)=>({
            name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_COMMITS,
            path: path,
            exact: true
        })), {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_COMMITS_HISTORY,
        path: $301f94a573448d39$var$repoPath("commits/history")
    });
    // commit page
    paths.push({
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_COMMIT,
        path: (0, $dGpbb.legacyPath)("commits/:ref+"),
        exact: false
    });
    paths.push(...[
        $301f94a573448d39$var$repoPath("deployments/environments/:environmentUuid/:deploymentUuid"),
        $301f94a573448d39$var$repoPath("deployments/environments/:environmentUuid"),
        $301f94a573448d39$var$repoPath("deployments/:deploymentUuid"),
        $301f94a573448d39$var$repoPath("deployments")
    ].map((path)=>({
            name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_DEPLOYMENTS,
            path: path
        })));
    paths.push(...[
        $301f94a573448d39$var$repoPath("pipelines"),
        $301f94a573448d39$var$repoPath("pipelines/filters/:filters"),
        $301f94a573448d39$var$repoPath("pipelines/results")
    ].map((path)=>({
            name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_PIPELINES,
            exact: true,
            path: path
        })));
    paths.push(...[
        $301f94a573448d39$var$repoPath("pipelines/results/:pipelineUuid"),
        $301f94a573448d39$var$repoPath("pipelines/results/:pipelineUuid/steps/:stepUuid"),
        $301f94a573448d39$var$repoPath("pipelines/results/:pipelineUuid/from-email")
    ].map((path)=>({
            name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_PIPELINES_RESULT,
            exact: true,
            path: path
        })));
    paths.push(...[
        $301f94a573448d39$var$repoPath("pipelines/results/filters/:filters"),
        $301f94a573448d39$var$repoPath("pipelines/results/branch/:branch/page/:page/filters/:filters"),
        $301f94a573448d39$var$repoPath("pipelines/results/page/:page/filters/:filters"),
        $301f94a573448d39$var$repoPath("pipelines/results/branch/:branch/page/:page"),
        $301f94a573448d39$var$repoPath("pipelines/results/page/:page/")
    ].map((path)=>({
            name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_PIPELINES,
            path: path
        })));
    paths.push(...[
        $301f94a573448d39$var$repoPath("pipelines/results/:pipelineUuid/steps/:stepUuid/trigger/:trigger"),
        $301f94a573448d39$var$repoPath("pipelines/results/:pipelineUuid/steps/:stepUuid/services/:serviceUuid"),
        $301f94a573448d39$var$repoPath("pipelines/results/:pipelineUuid/steps/:stepUuid/(.*)")
    ].map((path)=>({
            name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_PIPELINES_RESULT,
            path: path
        })));
    if (isPipelinesTestManagementEnabled) {
        paths.push(...[
            $301f94a573448d39$var$repoPath("test-cases")
        ].map((path)=>({
                name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_TEST_MANAGEMENT,
                exact: true,
                path: path
            })));
        paths.push(...[
            $301f94a573448d39$var$repoPath("test-cases/:testUuid")
        ].map((path)=>({
                name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_TEST_EXECUTION,
                exact: true,
                path: path
            })));
    }
    paths.push({
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_FORGE_PAGE,
        path: (0, $dGpbb.legacyPath)("forge/:appId/:moduleKey")
    });
    paths.push(...[
        (0, $dGpbb.legacyPath)("history/:path+"),
        (0, $dGpbb.legacyPath)("history-node/:refOrHash/:path+")
    ].map((path)=>({
            name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_FILE_HISTORY,
            path: path
        })), {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_CONNECT_PAGE,
        path: (0, $dGpbb.legacyPath)("addon/:appKey/:moduleKey")
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_JIRA_VIEW,
        path: (0, $dGpbb.legacyPath)("jira")
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_SOURCE,
        path: (0, $dGpbb.legacyPath)("admin")
    }, {
        name: (0, $7IfQd.ROUTE_NAME).REPOSITORY_REDIRECT,
        path: `/${(0, $cNPHM.REPO_FULL_SLUG_REGEX)}`
    });
    return paths;
};

});
parcelRegister("dGpbb", function(module, exports) {

$parcel$export(module.exports, "legacyPath", function () { return $d5d352731dbfb626$export$da935da072af1faf; });
// passes `repositoryOwner` and `repositorySlug` params and returns path
const $d5d352731dbfb626$export$da935da072af1faf = (path)=>`/:repositoryOwner/:repositorySlug/${path}`;

});

parcelRegister("cNPHM", function(module, exports) {

$parcel$export(module.exports, "REPO_FULL_SLUG_REGEX", function () { return $f9e5b43fe457558a$export$b45759e4d65401f5; });
// To be safe we are capturing anything as slugs. At a minimum, it
// should match the to_slug function in bitbucket core.
// https://staging.bb-inf.net/bitbucket/bitbucket/src/5fced6/apps/common/util.py#util.py-173:221
const $f9e5b43fe457558a$export$b45759e4d65401f5 = ":repositoryFullSlug([^/]+/[^/]+)";

});


parcelRegister("4J0BW", function(module, exports) {

$parcel$export(module.exports, "getSupportedPaths", function () { return $4e4d2fe88c7311f2$export$e1831da75619bae2; });

var $7IfQd = parcelRequire("7IfQd");
const $4e4d2fe88c7311f2$export$e1831da75619bae2 = (_features)=>{
    const paths = [
        {
            name: (0, $7IfQd.ROUTE_NAME).ROOT,
            path: "/",
            exact: true
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_OVERVIEW,
            path: "/:workspaceSlug/workspace/overview",
            exact: true
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_CREATE,
            path: "/workspace/create"
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_ROOT,
            path: "/:workspaceSlug",
            exact: true
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).PROFILE_REPOSITORIES,
            path: "/:workspaceSlug/profile/repositories",
            exact: false
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_REPOSITORIES,
            path: "/:workspaceSlug/workspace/repositories",
            exact: false
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_ROOT,
            path: "/:workspaceSlug/workspace/settings",
            exact: true
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_PERMISSIONS,
            path: "/:workspaceSlug/workspace/settings/permissions",
            exact: true
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_GROUP,
            path: "/:workspaceSlug/workspace/settings/groups/:groupSlug",
            exact: false
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_GROUPS,
            path: "/:workspaceSlug/workspace/settings/groups",
            exact: true
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_USER_DIRECTORY,
            path: "/:workspaceSlug/workspace/settings/user-directory",
            exact: false
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_ATLASSIAN_INTELLIGENCE,
            path: "/:workspaceSlug/workspace/settings/atlassian-intelligence",
            exact: false
        },
        {
            // this is currently gated behind the feature flag workspace-admin-compass-pageß
            name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_COMPASS,
            path: "/:workspaceSlug/workspace/settings/compass",
            exact: false
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_MERGE_CHECKS,
            path: "/:workspaceSlug/workspace/settings/merge-checks",
            exact: false
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_PIPELINES_REDIRECT_SETTINGS,
            path: "/:workspaceSlug/workspace/settings/addon/admin/:appKey(pipelines)/:moduleKey(account-variables)",
            exact: true
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_PIPELINES_REDIRECT_RUNNERS,
            path: "/:workspaceSlug/workspace/settings/addon/admin/:appKey(pipelines)/:moduleKey(account-runners)",
            exact: true
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_CONNECT_ADMIN,
            path: "/:workspaceSlug/workspace/settings/addon/admin/:appKey/:moduleKey",
            exact: false
        },
        {
            name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_CONNECT_CONFIGURE,
            path: "/:workspaceSlug/workspace/settings/addon/configure/:appKey/:moduleKey",
            exact: false
        }
    ];
    paths.push({
        name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_FORGE_PAGE,
        path: "/:workspaceSlug/workspace/settings/forge/:appId/:moduleKey",
        exact: true
    });
    paths.push({
        name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_ACCESS_TOKENS,
        path: "/:workspaceSlug/workspace/settings/access-tokens",
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_PIPELINES_VARIABLES,
        path: "/:workspaceSlug/workspace/settings/pipelines/:path(account-variables)",
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_PIPELINES_RUNNERS,
        path: "/:workspaceSlug/workspace/settings/pipelines/:path(account-runners)",
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_PIPELINES_RUNNERS,
        path: "/:workspaceSlug/workspace/settings/pipelines/runners",
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_PIPELINES_DYNAMIC_PIPELINES,
        path: "/:workspaceSlug/workspace/settings/pipelines/dynamic-pipelines",
        exact: true
    }, {
        name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_IFRAME,
        path: "/:workspaceSlug/workspace/settings/:any",
        exact: false
    }, // this is behind `workspace-view` FF on BE
    {
        name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_SEARCH,
        path: "/:workspaceSlug/workspace/search",
        exact: false
    }, {
        name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_PULL_REQUESTS,
        path: "/:workspaceSlug/workspace/pull-requests",
        exact: false
    }, {
        name: (0, $7IfQd.ROUTE_NAME).WORKSPACE_PROJECTS,
        path: "/:workspaceSlug/workspace/projects",
        exact: true
    });
    return paths;
};

});


parcelRegister("gBMfe", function(module, exports) {

$parcel$export(module.exports, "getProjectRoutesConfig", function () { return $43140e0bcab65445$export$285edd6ee0662a50; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

var $bT38u = parcelRequire("bT38u");

var $aH4uQ = parcelRequire("aH4uQ");

var $aVUUB = parcelRequire("aVUUB");

var $4kYkM = parcelRequire("4kYkM");

var $4r7hX = parcelRequire("4r7hX");

var $bWaf1 = parcelRequire("bWaf1");

var $8tLfV = parcelRequire("8tLfV");

var $5ihco = parcelRequire("5ihco");

var $dkV4b = parcelRequire("dkV4b");

var $9gckH = parcelRequire("9gckH");

var $7u2vV = parcelRequire("7u2vV");

var $89xm9 = parcelRequire("89xm9");

var $7sB53 = parcelRequire("7sB53");

var $7IfQd = parcelRequire("7IfQd");

const $43140e0bcab65445$var$ProjectLayout = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("blHue")),
    modules: [
        "src/sections/project/layout"
    ],
    webpack: ()=>[
            undefined("src/sections/project/layout")
        ]
});
const $43140e0bcab65445$export$285edd6ee0662a50 = ()=>{
    return {
        [(0, $7IfQd.ROUTE_NAME).PROJECT_REPOSITORIES]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $89xm9.ProjectRepositoriesLoadable),
            layout: $43140e0bcab65445$var$ProjectLayout,
            // workspaceNavigationResource is required for create links
            // in ./src/sections/project/sections/repositories/project-repositories-empty.tsx
            // XXX this should get switched to use the project nav resource instead
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $7sB53.workspaceNavigationResource),
                (0, $aH4uQ.projectNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).PROJECT_SETTINGS_DETAILS]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $5ihco.ProjectSettingsDetailsLoadable),
            layout: $43140e0bcab65445$var$ProjectLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $aH4uQ.projectNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).PROJECT_SETTINGS_DEFAULT_REVIEWERS]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $8tLfV.ProjectSettingsDefaultReviewersLoadable),
            layout: $43140e0bcab65445$var$ProjectLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $aH4uQ.projectNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).PROJECT_SETTINGS_BRANCHING_MODEL]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $bWaf1.ProjectSettingsBranchingModelLoadable),
            layout: $43140e0bcab65445$var$ProjectLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $aH4uQ.projectNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).PROJECT_SETTINGS_ACCESS_KEYS]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $aVUUB.ProjectSettingsAccessKeysLoadable),
            layout: $43140e0bcab65445$var$ProjectLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $aH4uQ.projectNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).PROJECT_SETTINGS_MERGE_STRATEGIES]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $dkV4b.ProjectSettingsMergeStrategiesLoadable),
            layout: $43140e0bcab65445$var$ProjectLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $aH4uQ.projectNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).PROJECT_SETTINGS_BRANCH_RESTRICTIONS]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $4r7hX.ProjectSettingsBranchRestrictionsLoadable),
            layout: $43140e0bcab65445$var$ProjectLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $aH4uQ.projectNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).PROJECT_SETTINGS_PERMISSIONS]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $9gckH.ProjectSettingsPermissionsLoadable),
            layout: $43140e0bcab65445$var$ProjectLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $7u2vV.loadProjectSettingsPermissionsResource),
                (0, $aH4uQ.projectNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).PROJECT_SETTINGS_ACCESS_TOKENS]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $4kYkM.ProjectSettingsAccessTokensLoadable),
            layout: $43140e0bcab65445$var$ProjectLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $aH4uQ.projectNavigationResource)
            ]
        }
    };
};

});
parcelRegister("aH4uQ", function(module, exports) {

$parcel$export(module.exports, "projectNavigationResource", function () { return $51e69b20c1d3fa22$export$5a13b2d1aef23a05; });

var $cJH1T = parcelRequire("cJH1T");
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $cuiOU = parcelRequire("cuiOU");

var $k2cPS = parcelRequire("k2cPS");
const $51e69b20c1d3fa22$export$5a13b2d1aef23a05 = (0, $3kfkg.createResource)({
    type: "PROJECT_NAVIGATION",
    getKey: ({ match: match })=>{
        const { workspaceSlug: workspaceSlug, projectKey: projectKey } = match.params;
        return `project:${workspaceSlug}/${projectKey}`;
    },
    maxAge: 600000,
    // 10 minute
    getData: async ({ match: match })=>{
        const { workspaceSlug: workspaceSlug, projectKey: projectKey } = match.params;
        if (!workspaceSlug || !projectKey) throw new Error("workspace and project are required");
        const url = (0, $cuiOU.default).api.internal.navigation(workspaceSlug, projectKey);
        // TODO once we start using this for actual navigation data, include menuItems below
        const query = (0, $cJH1T.stringify)({
            fields: "-menuItems"
        });
        const response = await fetch((0, $k2cPS.default)(`${url}?${query}`, {
            headers: (0, $k2cPS.jsonHeaders)
        }));
        if (!response.ok) throw new Error(`Error fetching project navigation data (${response.status}): ${response.statusText}`);
        return response.json();
    }
});

});
parcelRegister("cuiOU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc220c95914f09db$export$2e2bcd8739ae039; });

var $cJH1T = parcelRequire("cJH1T");
const $fc220c95914f09db$var$urls = {
    api: {
        v20: {
            defaultReviewers: (workspaceSlug, projectKey, options)=>{
                const url = `/!api/2.0/workspaces/${workspaceSlug}/projects/${projectKey}/default-reviewers/`;
                return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(options, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
            },
            defaultReviewer: (workspaceSlug, projectKey, selectedUser)=>`/!api/2.0/workspaces/${workspaceSlug}/projects/${projectKey}/default-reviewers/${selectedUser}`,
            deployKeys: (workspaceSlug, projectKey, options)=>{
                const url = `/!api/2.0/workspaces/${workspaceSlug}/projects/${projectKey}/deploy-keys/`;
                if (options) return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(options, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
                return url;
            },
            branchingModel: (workspaceSlug, projectKey)=>`/!api/2.0/workspaces/${workspaceSlug}/projects/${projectKey}/branching-model`,
            branchingModelSettings: (workspaceSlug, projectKey)=>`/!api/2.0/workspaces/${workspaceSlug}/projects/${projectKey}/branching-model/settings`
        },
        internal: {
            branchRestrictionsByBranch: (workspaceSlug, projectKey)=>`/!api/internal/workspaces/${workspaceSlug}/projects/${projectKey}/branch-restrictions/group-by-branch/`,
            branchRestrictionsByPattern: (workspaceSlug, projectKey, pattern)=>`/!api/internal/workspaces/${workspaceSlug}/projects/${projectKey}/branch-restrictions/by-pattern/${pattern}`,
            branchRestrictionsByBranchType: (workspaceSlug, projectKey, branchType)=>`/!api/internal/workspaces/${workspaceSlug}/projects/${projectKey}/branch-restrictions/by-branch-type/${branchType}`,
            mergeStrategy: (workspaceSlug, projectKey)=>`/!api/internal/workspaces/${workspaceSlug}/projects/${projectKey}/merge-strategy`,
            repositories: (workspaceSlug, projectKey, options)=>{
                const url = `/!api/internal/workspaces/${workspaceSlug}/projects/${projectKey}/repositories`;
                return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(options, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
            },
            addRepositories: (workspaceSlug, projectKey, options)=>{
                const url = `/!api/internal/workspaces/${workspaceSlug}/projects/${projectKey}/add-repositories`;
                return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
                    ...options,
                    search: undefined,
                    q: (options === null || options === void 0 ? void 0 : options.search) && `name~"${options.search}"`
                }, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
            },
            addDefaultReviewers: (workspaceSlug, projectKey, options)=>{
                const url = `/!api/internal/workspaces/${workspaceSlug}/projects/${projectKey}/add-default-reviewers/`;
                return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(options, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
            },
            users: (workspaceSlug, projectKey, options)=>{
                const url = `/!api/internal/workspaces/${workspaceSlug}/projects/${projectKey}/users/`;
                if (options) return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(options, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
                return url;
            },
            groupPrivilegesToAdd: (workspaceSlug, projectKey, search)=>{
                const url = `/!api/internal/workspaces/${workspaceSlug}/projects/${projectKey}/group-privileges-to-add`;
                if (search) return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
                    search: search
                }, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
                return url;
            },
            inheritedPermissions: (workspaceSlug, projectKey, options)=>{
                const url = `/!api/internal/inherited-project-privileges/${workspaceSlug}/${projectKey}/`;
                if (options) return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(options, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
                return url;
            },
            accessCheck: (workspaceSlug, projectKey)=>`/!api/internal/workspaces/${workspaceSlug}/projects/${projectKey}/access-check`,
            projectWriters: (workspaceSlug, projectKey, options)=>{
                const url = `/!api/internal/workspaces/${workspaceSlug}/projects/${projectKey}/project-writers`;
                return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(options, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
            },
            projectWriterGroups: (workspaceSlug, projectKey, options)=>{
                const url = `/!api/internal/workspaces/${workspaceSlug}/projects/${projectKey}/project-writer-groups`;
                return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(options, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
            },
            accessTokens: (workspaceSlug, projectKey)=>`/!api/internal/workspaces/${workspaceSlug}/projects/${projectKey}/access-tokens`,
            invitations: (workspaceSlug, projectKey)=>`/!api/internal/invitations/projects/${workspaceSlug}/${projectKey}`,
            navigation: (workspaceSlug, projectKey)=>`/!api/internal/menu/project/${workspaceSlug}/${projectKey}`
        }
    },
    ui: {
        landing: (workspaceSlug, projectKey)=>`/${workspaceSlug}/workspace/projects/${projectKey}`,
        admin: (workspaceSlug, projectKey)=>`${$fc220c95914f09db$var$urls.ui.landing(workspaceSlug, projectKey)}/settings`,
        defaultReviewers: (workspaceSlug, projectKey)=>`${$fc220c95914f09db$var$urls.ui.landing(workspaceSlug, projectKey)}/settings/pullrequests/reviewers`,
        settings: (workspaceSlug, projectKey, pageKey)=>`${$fc220c95914f09db$var$urls.ui.landing(workspaceSlug, projectKey)}/settings/${pageKey}`,
        permissions: (workspaceSlug, projectKey)=>`${$fc220c95914f09db$var$urls.ui.landing(workspaceSlug, projectKey)}/settings/permissions`,
        branchingModel: (workspaceSlug, projectKey)=>`${$fc220c95914f09db$var$urls.ui.landing(workspaceSlug, projectKey)}/settings/branching-model`,
        branchRestrictions: (workspaceSlug, projectKey)=>`${$fc220c95914f09db$var$urls.ui.landing(workspaceSlug, projectKey)}/settings/branch-restrictions`
    }
};
var $fc220c95914f09db$export$2e2bcd8739ae039 = $fc220c95914f09db$var$urls;

});


parcelRegister("aVUUB", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsAccessKeysLoadable", function () { return $108de664a5ae0b73$export$6f2cc2f5c4d2a678; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

var $8HNfd = parcelRequire("8HNfd");

const $108de664a5ae0b73$export$c04258a9cac66c2b = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("4hM8O")),
    modules: [
        "./access-keys"
    ],
    webpack: ()=>[
            undefined("./access-keys")
        ]
});

const $108de664a5ae0b73$export$6f2cc2f5c4d2a678 = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("aCLXw")),
    modules: [
        "./access-keys-legacy"
    ],
    webpack: ()=>[
            undefined("./access-keys-legacy")
        ]
});

});
parcelRegister("8HNfd", function(module, exports) {

$parcel$export(module.exports, "fetchSshKeys", function () { return $21536cb16e038c8f$export$704e33fea2358855; });
$parcel$export(module.exports, "loadProjectSettingsAccessKeysResource", function () { return $21536cb16e038c8f$export$ba0b210fb9bdc18; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $7Me5Z = parcelRequire("7Me5Z");

var $cuiOU = parcelRequire("cuiOU");

var $jzmnA = parcelRequire("jzmnA");
const $21536cb16e038c8f$export$704e33fea2358855 = (workspaceSlug, projectKey)=>(options)=>(0, $jzmnA.httpRequest)().get((0, $cuiOU.default).api.v20.deployKeys(workspaceSlug, projectKey, {
            ...options
        }));
const $21536cb16e038c8f$export$ba0b210fb9bdc18 = (0, $3kfkg.createResource)({
    type: "projectAdminAccessKeys",
    getKey: ({ match: match })=>{
        const { workspaceSlug: workspaceSlug, projectKey: projectKey } = match.params;
        return (0, $cuiOU.default).ui.settings(workspaceSlug, projectKey, "access-keys");
    },
    maxAge: 60000,
    // cache for 1 minute so navigating between pages is fast
    getData: ({ match: match })=>{
        const { workspaceSlug: workspaceSlug, projectKey: projectKey } = match.params;
        if (!workspaceSlug || !projectKey) throw new Error("Could not fetch, workspaceSlug/projectKey URL param was not available");
        const { pagelen: pagelen = (0, $7Me5Z.DEFAULT_ROWS_PER_PAGE), page: page = 1, sort: sort } = match.query;
        return $21536cb16e038c8f$export$704e33fea2358855(workspaceSlug, projectKey)({
            pagelen: ~~pagelen,
            page: ~~page,
            sort: sort
        });
    }
});

});
parcelRegister("7Me5Z", function(module, exports) {

$parcel$export(module.exports, "DEBOUNCE_DELAY", function () { return $9a66be876badd42a$export$1ec3328eed0aedd9; });
$parcel$export(module.exports, "DEFAULT_ROWS_PER_PAGE", function () { return $9a66be876badd42a$export$4b16a5150ec17ac0; });
$parcel$export(module.exports, "DEFAULT_ROWS_PER_PAGE_MODAL", function () { return $9a66be876badd42a$export$49fb5451f211aa70; });
$parcel$export(module.exports, "BULK_SELECTION_LIMIT", function () { return $9a66be876badd42a$export$81a88ed305997a6d; });
const $9a66be876badd42a$export$1ec3328eed0aedd9 = 300;
const $9a66be876badd42a$export$4b16a5150ec17ac0 = 20;
const $9a66be876badd42a$export$49fb5451f211aa70 = 10;
const $9a66be876badd42a$export$81a88ed305997a6d = 10;

});

parcelRegister("jzmnA", function(module, exports) {

$parcel$export(module.exports, "request", function () { return $d82cca7def5639ce$export$b5fe3f66a567bec0; });
$parcel$export(module.exports, "createHttpRequest", function () { return $d82cca7def5639ce$export$58d47321b4325073; });
$parcel$export(module.exports, "httpRequest", function () { return $d82cca7def5639ce$export$46f383001bf60e04; });
$parcel$export(module.exports, "createAPI", function () { return $d82cca7def5639ce$export$3d7ea1c6d57f2840; });

var $k2cPS = parcelRequire("k2cPS");

var $hpfPp = parcelRequire("hpfPp");
const $d82cca7def5639ce$export$b5fe3f66a567bec0 = async (url, { method: method = "GET", body: body, ...options } = {})=>{
    const { bodyPreformatter: bodyPreformatter, customResponseHandler: customResponseHandler, throwErrorType: throwErrorType = "json", errorTransformer: errorTransformer, successTransformer: successTransformer, successCustomHandler: successCustomHandler, headers: headers } = options || {};
    let bodyToUse = body;
    if (bodyPreformatter) bodyToUse = bodyPreformatter(body);
    else if (typeof body === "object") bodyToUse = JSON.stringify(body);
    if ([
        "POST",
        "PUT"
    ].includes(method) && !body) bodyToUse = JSON.stringify({});
    const response = await fetch((0, $k2cPS.default)(url, {
        method: method,
        headers: headers || (0, $k2cPS.jsonHeaders),
        body: bodyToUse
    }));
    if (customResponseHandler) return customResponseHandler(response);
    if (!response.ok) {
        if (response.status === 500) throw 0, $hpfPp.InternalServerError;
        if (throwErrorType === "none") {
            if (errorTransformer) throw errorTransformer(response);
        }
        if (throwErrorType === "json") {
            const errorResult = await response.json() || {};
            if (errorTransformer) throw errorTransformer(errorResult);
            else {
                errorResult.status = response.status;
                throw errorResult;
            }
        }
        if (throwErrorType === "text") {
            const errorText = await response.text();
            throw errorText;
        }
        if (throwErrorType === "errorObject") {
            const errorText = await response.text();
            const errorResult = new (0, $hpfPp.default)(response.status, errorText);
            throw errorResult;
        }
    }
    if (method !== "DELETE") {
        if (successCustomHandler) return successCustomHandler(response);
        const result = await response.json();
        if (successTransformer) return successTransformer(result);
        return result;
    }
    return undefined;
};
const $d82cca7def5639ce$export$58d47321b4325073 = (method, options)=>/**
 * @param url endpoint url
 * @param body data to be send
 *
 * @template T data model
 *
 * Usage example:
 * ```typescript
 * TODO: add examples here
 * ```
 *
 * @returns Promise<T | T[] | undefined>
 */ (url, body)=>$d82cca7def5639ce$export$b5fe3f66a567bec0(url, {
            ...options,
            method: method,
            body: body
        });
const $d82cca7def5639ce$export$46f383001bf60e04 = (options)=>({
        get: $d82cca7def5639ce$export$58d47321b4325073("GET", options),
        post: $d82cca7def5639ce$export$58d47321b4325073("POST", options),
        put: $d82cca7def5639ce$export$58d47321b4325073("PUT", options),
        delete: $d82cca7def5639ce$export$58d47321b4325073("DELETE", options)
    });
const $d82cca7def5639ce$export$3d7ea1c6d57f2840 = (endpointUrl, options)=>{
    let commonOptions = {};
    if (options) {
        const { headers: headers, bodyPreformatter: bodyPreformatter, throwErrorType: throwErrorType, customResponseHandler: customResponseHandler, errorTransformer: errorTransformer, successTransformer: successTransformer, successCustomHandler: successCustomHandler } = options;
        commonOptions = {
            headers: headers,
            bodyPreformatter: bodyPreformatter,
            throwErrorType: throwErrorType,
            customResponseHandler: customResponseHandler,
            errorTransformer: errorTransformer,
            successTransformer: successTransformer,
            successCustomHandler: successCustomHandler
        };
    }
    return {
        getAll: ()=>$d82cca7def5639ce$export$46f383001bf60e04({
                ...commonOptions,
                ...options === null || options === void 0 ? void 0 : options.getAll
            }).get(endpointUrl),
        get: (id)=>$d82cca7def5639ce$export$46f383001bf60e04({
                ...commonOptions,
                ...options === null || options === void 0 ? void 0 : options.get
            }).get(`${endpointUrl}${id || ""}`),
        post: (data)=>$d82cca7def5639ce$export$46f383001bf60e04({
                ...commonOptions,
                ...options === null || options === void 0 ? void 0 : options.post
            }).post(endpointUrl, data),
        put: (data)=>$d82cca7def5639ce$export$46f383001bf60e04({
                ...commonOptions,
                ...options === null || options === void 0 ? void 0 : options.put
            }).put(`${endpointUrl}${data.id}`, data),
        delete: (id, data)=>$d82cca7def5639ce$export$46f383001bf60e04({
                ...commonOptions,
                ...options === null || options === void 0 ? void 0 : options.delete
            }).delete(`${endpointUrl}${id}`, data)
    };
};

});
parcelRegister("hpfPp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b4f00b16a0cf26c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "InternalServerError", function () { return $7b4f00b16a0cf26c$export$2004b0625b599107; });
// Babel doesn't work well with extending built-in classes like `Error`.
// Instead, we create a custom error using prototypal JS, though TypeScript
// doesn't like this as much
function $7b4f00b16a0cf26c$export$2e2bcd8739ae039(status, message) {
    const instance = Reflect.construct(Error, [
        message
    ]);
    instance.status = status;
    Reflect.setPrototypeOf(instance, Reflect.getPrototypeOf(this));
    return instance;
}
$7b4f00b16a0cf26c$export$2e2bcd8739ae039.prototype = Object.create(Error.prototype, {
    constructor: {
        value: Error,
        enumerable: false,
        writable: true,
        configurable: true
    }
});
const $7b4f00b16a0cf26c$export$2004b0625b599107 = new $7b4f00b16a0cf26c$export$2e2bcd8739ae039(500, "Internal Server Error");
const $7b4f00b16a0cf26c$export$99341f548497676e = new $7b4f00b16a0cf26c$export$2e2bcd8739ae039(400, "Bad Request");

});



parcelRegister("4hM8O", function(module, exports) {














module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6SfDR")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6cSLd")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("1kPIJ")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6XRs7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c7qp4")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("4a5xy"))
]).then(()=>parcelRequire("ll3wn"));

});

parcelRegister("aCLXw", function(module, exports) {














module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6SfDR")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6cSLd")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("1kPIJ")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6XRs7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c7qp4")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7Ep3f"))
]).then(()=>parcelRequire("NoHwJ"));

});


parcelRegister("4kYkM", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsAccessTokensLoadable", function () { return $fc8c049f10f4a19a$export$f56807ea0b431e7; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $fc8c049f10f4a19a$export$f56807ea0b431e7 = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("hjWHU")),
    modules: [
        "./access-tokens"
    ],
    webpack: ()=>[
            undefined("./access-tokens")
        ]
});

});
parcelRegister("hjWHU", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2H5Nx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("eWB8F")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c7qp4")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("69yuI"))
]).then(()=>parcelRequire("1Sa7s"));

});


parcelRegister("4r7hX", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsBranchRestrictionsLoadable", function () { return $a2e199998fd07faf$export$90ee41192a52504; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $a2e199998fd07faf$export$90ee41192a52504 = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("2umag")),
    modules: [
        "./branch-restrictions"
    ],
    webpack: ()=>[
            undefined("./branch-restrictions")
        ]
});

});
parcelRegister("2umag", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kBzNL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fVUDo")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("hCFmN")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9uabR")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("g4iR0"))
]).then(()=>parcelRequire("lcRct"));

});


parcelRegister("bWaf1", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsBranchingModelLoadable", function () { return $7a64b60b63c452d1$export$6d43f7df4eea38a8; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $7a64b60b63c452d1$export$6d43f7df4eea38a8 = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("8j5oq")),
    modules: [
        "./branching-model"
    ],
    webpack: ()=>[
            undefined("./branching-model")
        ]
});

});
parcelRegister("8j5oq", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("567XC")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kBzNL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("4vqEE"))
]).then(()=>parcelRequire("bIzIG"));

});


parcelRegister("8tLfV", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsDefaultReviewersLoadable", function () { return $2153a4fca7d501bc$export$7f021b1702cfe745; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $2153a4fca7d501bc$export$7f021b1702cfe745 = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("jrixE")),
    modules: [
        "./default-reviewers"
    ],
    webpack: ()=>[
            undefined("./default-reviewers")
        ]
});

});
parcelRegister("jrixE", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3IMuw")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("hKTti"))
]).then(()=>parcelRequire("1R1DT"));

});


parcelRegister("5ihco", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsDetailsLoadable", function () { return $12c5b452927072f4$export$f1b8b570f5a3d9ff; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $12c5b452927072f4$export$f1b8b570f5a3d9ff = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("d5BvT")),
    modules: [
        "./project-details-page"
    ],
    webpack: ()=>[
            undefined("./project-details-page")
        ]
});

});
parcelRegister("d5BvT", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9cz44")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kBzNL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("1QkO4")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9uabR")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("haDM0"))
]).then(()=>parcelRequire("dPp6l"));

});


parcelRegister("dkV4b", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsMergeStrategiesLoadable", function () { return $2ee3b760da174ee2$export$fc00ed4adee2cf4f; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $2ee3b760da174ee2$export$fc00ed4adee2cf4f = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("ejQq7")),
    modules: [
        "./merge-strategies"
    ],
    webpack: ()=>[
            undefined("./merge-strategies")
        ]
});

});
parcelRegister("ejQq7", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kBzNL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9uabR")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5QFiP"))
]).then(()=>parcelRequire("4eVwM"));

});


parcelRegister("9gckH", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsPermissionsLoadable", function () { return $faae183c190438f4$export$1882fd93372daa8f; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $faae183c190438f4$export$1882fd93372daa8f = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("hFJ9Z")),
    modules: [
        "./permissions"
    ],
    webpack: ()=>[
            undefined("./permissions")
        ]
});

});
parcelRegister("hFJ9Z", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6FBBc")).then(()=>parcelRequire("3BBuU"));

});


parcelRegister("7u2vV", function(module, exports) {

$parcel$export(module.exports, "fetchPermissions", function () { return $529beb6b2816a533$export$4f24ecba11982e9d; });
$parcel$export(module.exports, "loadProjectSettingsPermissionsResource", function () { return $529beb6b2816a533$export$557a3b225d1a6960; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");
parcelRequire("DVpDa");
var $5sg28 = parcelRequire("5sg28");
var $hCBEg = parcelRequire("hCBEg");

var $cuiOU = parcelRequire("cuiOU");

var $jzmnA = parcelRequire("jzmnA");

var $1LLhT = parcelRequire("1LLhT");
const $529beb6b2816a533$export$4f24ecba11982e9d = (workspaceSlug, projectKey, { page: page = 1, accessLevel: accessLevel, permission: permission, principalName: principalName } = {})=>{
    return (0, $jzmnA.request)((0, $cuiOU.default).api.internal.inheritedPermissions(workspaceSlug, projectKey, {
        page: page,
        q: (0, $5sg28.buildBBQL)({
            accessLevel: accessLevel,
            permission: permission,
            principalName: principalName
        })
    }), {
        successTransformer: ({ values: values = [], page: pagenum, pagelen: pagelen, size: size })=>{
            return {
                permissions: new Map([
                    [
                        pagenum,
                        values.map((0, $hCBEg.mapInheritedUserAndGroupPrivilege))
                    ]
                ]),
                page: pagenum,
                limit: pagelen,
                total: size
            };
        }
    });
};
const $529beb6b2816a533$export$557a3b225d1a6960 = (0, $3kfkg.createResource)({
    type: "projectAdminPermissions",
    getKey: ({ match: match })=>{
        const { workspaceSlug: workspaceSlug, projectKey: projectKey } = match.params;
        return (0, $cuiOU.default).ui.permissions(workspaceSlug, projectKey);
    },
    maxAge: 60000,
    // cache for 1 minute so navigating between pages is fast
    getData: async ({ match: match })=>{
        const { workspaceSlug: workspaceSlug, projectKey: projectKey } = match.params;
        const [permissions, isWorkspaceAdmin] = await Promise.all([
            $529beb6b2816a533$export$4f24ecba11982e9d(workspaceSlug, projectKey),
            (0, $1LLhT.hasWorkspaceAdminStatus)(workspaceSlug)
        ]);
        return {
            ...permissions,
            adminLevel: (0, $hCBEg.getAdminLevel)(isWorkspaceAdmin, true)
        };
    }
});

});
parcelRegister("DVpDa", function(module, exports) {
$parcel$export(module.exports, "makeWithPermissions", function () { return (parcelRequire("4HDjC")).makeWithPermissions; });
$parcel$export(module.exports, "PermissionsContainer", function () { return (parcelRequire("4HDjC")).PermissionsContainer; });
$parcel$export(module.exports, "useActions", function () { return (parcelRequire("4HDjC")).useActions; });
$parcel$export(module.exports, "useIsOrgAdmin", function () { return (parcelRequire("4HDjC")).useIsOrgAdmin; });
$parcel$export(module.exports, "useIsSumEnabled", function () { return (parcelRequire("4HDjC")).useIsSumEnabled; });
$parcel$export(module.exports, "usePermissionsContext", function () { return (parcelRequire("4HDjC")).usePermissionsContext; });
$parcel$export(module.exports, "useWorkspaceOrgId", function () { return (parcelRequire("4HDjC")).useWorkspaceOrgId; });
$parcel$export(module.exports, "LoadingState", function () { return (parcelRequire("cM1QH")).LoadingState; });
$parcel$export(module.exports, "getAdminLevel", function () { return (parcelRequire("hCBEg")).getAdminLevel; });
$parcel$export(module.exports, "mapInheritedUserAndGroupPrivilege", function () { return (parcelRequire("hCBEg")).mapInheritedUserAndGroupPrivilege; });
$parcel$export(module.exports, "transformEntityToFlat", function () { return (parcelRequire("hCBEg")).transformEntityToFlat; });
$parcel$export(module.exports, "transformWorkspaceGroup", function () { return (parcelRequire("hCBEg")).transformWorkspaceGroup; });
$parcel$export(module.exports, "AccessMode", function () { return (parcelRequire("1g8Pl")).AccessMode; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("5uIQW")).default; });
$parcel$export(module.exports, "PermissionsActions", function () { return (parcelRequire("8OHIZ")).PermissionsActions; });
$parcel$export(module.exports, "buildBBQL", function () { return (parcelRequire("5sg28")).buildBBQL; });

var $5uIQW = parcelRequire("5uIQW");

var $8OHIZ = parcelRequire("8OHIZ");

var $5sg28 = parcelRequire("5sg28");
parcelRequire("4HDjC");
parcelRequire("cM1QH");
parcelRequire("hCBEg");
parcelRequire("1g8Pl");

});
parcelRegister("5uIQW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee78107cbf34a43d$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $bxEHe = parcelRequire("bxEHe");

var $f9pRZ = parcelRequire("f9pRZ");

var $1D6WP = parcelRequire("1D6WP");

var $jajUg = parcelRequire("jajUg");

var $dqY9c = parcelRequire("dqY9c");

var $iuBF6 = parcelRequire("iuBF6");

var $fXsLf = parcelRequire("fXsLf");

var $gYZ8r = parcelRequire("gYZ8r");

var $1oM5j = parcelRequire("1oM5j");

var $cM1QH = parcelRequire("cM1QH");

var $e2Cxb = parcelRequire("e2Cxb");

var $4HDjC = parcelRequire("4HDjC");

var $7qzbC = parcelRequire("7qzbC");

var $6cjyK = parcelRequire("6cjyK");

var $iReEB = parcelRequire("iReEB");

var $g3p9t = parcelRequire("g3p9t");

var $hCBEg = parcelRequire("hCBEg");
const $ee78107cbf34a43d$var$messages = (0, $agjvf.defineMessages)({
    resultsEmptyMessage: {
        "id": "frontbucket.settings.permissions.resultsEmptyMessage",
        "defaultMessage": "No results were found matching your search"
    }
});
const $ee78107cbf34a43d$var$Permissions = ({ api: api, heading: heading, showAccessLevel: showAccessLevel = true })=>{
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    const { publishScreenEvent: publishScreenEvent, publishButtonClickEvent: publishButtonClickEvent } = (0, $f9pRZ.useAnalytics)();
    const [{ permissions: permissions }] = (0, $4HDjC.usePermissions)();
    const [{ loadingState: loadingState }] = (0, $4HDjC.useLoadingState)();
    const [{ checkedRows: checkedRows }] = (0, $4HDjC.useCheckedRows)();
    const [{ context: context }] = (0, $4HDjC.usePermissionsContext)();
    const [{ limit: limit, page: page, total: total, privilegeFilter: privilegeFilter, accessLevelFilter: accessLevelFilter, searchTerm: searchTerm }] = (0, $4HDjC.useFilters)();
    const defaultSearchTermRef = (0, $9nHZC.useRef)(searchTerm);
    const getPermissions = (0, $4HDjC.useGetPermissions)(api.getPermissions);
    const checkedCount = checkedRows.length;
    const permissionsCurrentPage = permissions.get(page) || [];
    const isLoading = loadingState === (0, $cM1QH.LoadingState).LOADING;
    const checkedCountCurrentPage = permissionsCurrentPage.reduce((index, row)=>row && (0, $hCBEg.includesPermission)(checkedRows, row) ? index + 1 : index, 0);
    const { groupSlug: groupSlug, repositorySlug: repoSlug, projectKey: projectKey, ...params } = (0, $dqY9c.useParams)();
    const workspaceSlug = params.workspaceSlug || params.repositoryOwner || "";
    const { header: head, actions: actions } = (0, $iReEB.useTableHeader)({
        checkedCount: checkedCount,
        checkedCountCurrentPage: checkedCountCurrentPage,
        limit: limit,
        isDisabled: isLoading,
        showAccessLevel: showAccessLevel
    });
    const rows = (0, $g3p9t.useTableRows)({
        api: api,
        permissions: permissionsCurrentPage,
        checkedRows: checkedRows,
        workspaceSlug: workspaceSlug,
        showAccessLevel: showAccessLevel
    });
    (0, $9nHZC.useEffect)(publishScreenEvent, [
        publishScreenEvent
    ]);
    const [invitationsCount, setInvitationsCount] = (0, $9nHZC.useState)(0);
    const refreshInvitations = (0, $9nHZC.useCallback)(()=>setInvitationsCount((n)=>n + 1), [
        setInvitationsCount
    ]);
    (0, $9nHZC.useEffect)(()=>{
        const root = document.getElementById("root");
        if (root) (0, $bxEHe.default)(root, {
            duration: (0, $1D6WP.SCROLL_TO_DURATION)
        });
    }, [
        page
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, heading, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $iuBF6.InvitationsPanel), {
        groupSlug: groupSlug,
        projectKey: projectKey,
        repoSlug: repoSlug,
        workspaceSlug: workspaceSlug,
        refreshCount: invitationsCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6cjyK.PermissionsTableContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6cjyK.TextFieldSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7qzbC.default), {
        api: api,
        defaultValue: defaultSearchTermRef.current
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fXsLf.default), {
        value: privilegeFilter,
        onChange: (privilege)=>{
            getPermissions(1, {
                privilegeFilter: privilege
            });
            publishButtonClickEvent("PrivilegeFilter", {
                privilege: privilege
            });
        },
        isDisabled: isLoading,
        showOptionDescription: false,
        allowEmptyChoice: true,
        testId: "privilegesFilterDropdown",
        context: context,
        isFilter: true
    }), showAccessLevel && context !== "workspace" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $gYZ8r.default), {
        value: accessLevelFilter,
        onChange: (accessLevel)=>{
            getPermissions(1, {
                accessLevelFilter: accessLevel
            });
            publishButtonClickEvent("AccessLevelFilter", {
                accessLevel: accessLevel
            });
        },
        isProjectContext: context === "project",
        isDisabled: isLoading,
        allowEmptyChoice: true
    })), actions, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $e2Cxb.default), {
        head: head,
        rows: rows,
        limit: limit,
        total: total,
        page: page,
        isLoading: isLoading,
        isDisabled: isLoading,
        onPageChange: (nextPage)=>getPermissions(nextPage)
    }), total <= 0 && loadingState !== (0, $cM1QH.LoadingState).LOADING && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("p", null, formatMessage($ee78107cbf34a43d$var$messages.resultsEmptyMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $1oM5j.default), {
        api: api,
        refreshInvitations: refreshInvitations
    }));
};
var $ee78107cbf34a43d$export$2e2bcd8739ae039 = $ee78107cbf34a43d$var$Permissions;

});
parcelRegister("bxEHe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8672583532d1979d$export$2e2bcd8739ae039; });

var $4L1qp = parcelRequire("4L1qp");
var $8672583532d1979d$var$memoizedNow;
var $8672583532d1979d$var$now = function now() {
    if (!$8672583532d1979d$var$memoizedNow) $8672583532d1979d$var$memoizedNow = "performance" in window ? performance.now.bind(performance) : Date.now;
    return $8672583532d1979d$var$memoizedNow();
};
function $8672583532d1979d$var$step(context) {
    var time = $8672583532d1979d$var$now();
    var elapsed = Math.min((time - context.startTime) / context.duration, 1);
    var value = context.ease(elapsed);
    var currentX = context.startX + (context.x - context.startX) * value;
    var currentY = context.startY + (context.y - context.startY) * value;
    context.method(currentX, currentY);
    if (currentX !== context.x || currentY !== context.y) requestAnimationFrame(function() {
        return $8672583532d1979d$var$step(context);
    });
    else context.cb();
}
function $8672583532d1979d$var$smoothScroll(el, x, y, duration, ease, cb) {
    if (duration === void 0) duration = 600;
    if (ease === void 0) ease = function ease(t) {
        return 1 + --t * t * t * t * t;
    };
    var scrollable;
    var startX;
    var startY;
    var method;
    scrollable = el;
    startX = el.scrollLeft;
    startY = el.scrollTop;
    method = function method(x, y) {
        el.scrollLeft = x;
        el.scrollTop = y;
    };
    $8672583532d1979d$var$step({
        scrollable: scrollable,
        method: method,
        startTime: $8672583532d1979d$var$now(),
        startX: startX,
        startY: startY,
        x: x,
        y: y,
        duration: duration,
        ease: ease,
        cb: cb
    });
}
var $8672583532d1979d$var$shouldSmoothScroll = function shouldSmoothScroll(options) {
    return options && !options.behavior || options.behavior === "smooth";
};
function $8672583532d1979d$var$scroll(target, options) {
    var overrides = options || {};
    if ($8672583532d1979d$var$shouldSmoothScroll(overrides)) return (0, $4L1qp.default)(target, {
        block: overrides.block,
        inline: overrides.inline,
        scrollMode: overrides.scrollMode,
        boundary: overrides.boundary,
        behavior: function behavior(actions) {
            return Promise.all(actions.reduce(function(results, _ref) {
                var el = _ref.el, left = _ref.left, top = _ref.top;
                var startLeft = el.scrollLeft;
                var startTop = el.scrollTop;
                if (startLeft === left && startTop === top) return results;
                return results.concat([
                    new Promise(function(resolve) {
                        return $8672583532d1979d$var$smoothScroll(el, left, top, overrides.duration, overrides.ease, function() {
                            return resolve({
                                el: el,
                                left: [
                                    startLeft,
                                    left
                                ],
                                top: [
                                    startTop,
                                    top
                                ]
                            });
                        });
                    })
                ]);
            }, []));
        }
    });
    return Promise.resolve((0, $4L1qp.default)(target, options));
}
var $8672583532d1979d$var$smoothScrollIntoView = $8672583532d1979d$var$scroll;
var $8672583532d1979d$export$2e2bcd8739ae039 = $8672583532d1979d$var$smoothScrollIntoView;

});
parcelRegister("4L1qp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $376ca8315b08dc17$export$2e2bcd8739ae039; });

var $bnper = parcelRequire("bnper");
function $376ca8315b08dc17$var$isOptionsObject(options) {
    return options === Object(options) && Object.keys(options).length !== 0;
}
function $376ca8315b08dc17$var$defaultBehavior(actions, behavior) {
    if (behavior === void 0) behavior = "auto";
    var canSmoothScroll = "scrollBehavior" in document.body.style;
    actions.forEach(function(_ref) {
        var el = _ref.el, top = _ref.top, left = _ref.left;
        if (el.scroll && canSmoothScroll) el.scroll({
            top: top,
            left: left,
            behavior: behavior
        });
        else {
            el.scrollTop = top;
            el.scrollLeft = left;
        }
    });
}
function $376ca8315b08dc17$var$getOptions(options) {
    if (options === false) return {
        block: "end",
        inline: "nearest"
    };
    if ($376ca8315b08dc17$var$isOptionsObject(options)) return options;
    return {
        block: "start",
        inline: "nearest"
    };
}
function $376ca8315b08dc17$var$scrollIntoView(target, options) {
    var targetIsDetached = !target.ownerDocument.documentElement.contains(target);
    if ($376ca8315b08dc17$var$isOptionsObject(options) && typeof options.behavior === "function") return options.behavior(targetIsDetached ? [] : (0, $bnper.default)(target, options));
    if (targetIsDetached) return;
    var computeOptions = $376ca8315b08dc17$var$getOptions(options);
    return $376ca8315b08dc17$var$defaultBehavior((0, $bnper.default)(target, computeOptions), computeOptions.behavior);
}
var $376ca8315b08dc17$export$2e2bcd8739ae039 = $376ca8315b08dc17$var$scrollIntoView;

});
parcelRegister("bnper", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84856a3d7962b5f5$export$2e2bcd8739ae039; });
function $84856a3d7962b5f5$var$isElement(el) {
    return el != null && typeof el === "object" && el.nodeType === 1;
}
function $84856a3d7962b5f5$var$canOverflow(overflow, skipOverflowHiddenElements) {
    if (skipOverflowHiddenElements && overflow === "hidden") return false;
    return overflow !== "visible" && overflow !== "clip";
}
function $84856a3d7962b5f5$var$isScrollable(el, skipOverflowHiddenElements) {
    if (el.clientHeight < el.scrollHeight || el.clientWidth < el.scrollWidth) {
        var style = getComputedStyle(el, null);
        return $84856a3d7962b5f5$var$canOverflow(style.overflowY, skipOverflowHiddenElements) || $84856a3d7962b5f5$var$canOverflow(style.overflowX, skipOverflowHiddenElements);
    }
    return false;
}
function $84856a3d7962b5f5$var$alignNearest(scrollingEdgeStart, scrollingEdgeEnd, scrollingSize, scrollingBorderStart, scrollingBorderEnd, elementEdgeStart, elementEdgeEnd, elementSize) {
    if (elementEdgeStart < scrollingEdgeStart && elementEdgeEnd > scrollingEdgeEnd || elementEdgeStart > scrollingEdgeStart && elementEdgeEnd < scrollingEdgeEnd) return 0;
    if (elementEdgeStart <= scrollingEdgeStart && elementSize <= scrollingSize || elementEdgeEnd >= scrollingEdgeEnd && elementSize >= scrollingSize) return elementEdgeStart - scrollingEdgeStart - scrollingBorderStart;
    if (elementEdgeEnd > scrollingEdgeEnd && elementSize < scrollingSize || elementEdgeStart < scrollingEdgeStart && elementSize > scrollingSize) return elementEdgeEnd - scrollingEdgeEnd + scrollingBorderEnd;
    return 0;
}
var $84856a3d7962b5f5$export$2e2bcd8739ae039 = function(target, options) {
    var scrollMode = options.scrollMode, block = options.block, inline = options.inline, boundary = options.boundary, skipOverflowHiddenElements = options.skipOverflowHiddenElements;
    var checkBoundary = typeof boundary === "function" ? boundary : function(node) {
        return node !== boundary;
    };
    if (!$84856a3d7962b5f5$var$isElement(target)) throw new TypeError("Invalid target");
    var scrollingElement = document.scrollingElement || document.documentElement;
    var frames = [];
    var cursor = target;
    while($84856a3d7962b5f5$var$isElement(cursor) && checkBoundary(cursor)){
        cursor = cursor.parentNode;
        if (cursor === scrollingElement) {
            frames.push(cursor);
            break;
        }
        if (cursor === document.body && $84856a3d7962b5f5$var$isScrollable(cursor) && !$84856a3d7962b5f5$var$isScrollable(document.documentElement)) continue;
        if ($84856a3d7962b5f5$var$isScrollable(cursor, skipOverflowHiddenElements)) frames.push(cursor);
    }
    var viewportWidth = window.visualViewport ? visualViewport.width : innerWidth;
    var viewportHeight = window.visualViewport ? visualViewport.height : innerHeight;
    var viewportX = window.scrollX || pageXOffset;
    var viewportY = window.scrollY || pageYOffset;
    var _target$getBoundingCl = target.getBoundingClientRect(), targetHeight = _target$getBoundingCl.height, targetWidth = _target$getBoundingCl.width, targetTop = _target$getBoundingCl.top, targetRight = _target$getBoundingCl.right, targetBottom = _target$getBoundingCl.bottom, targetLeft = _target$getBoundingCl.left;
    var targetBlock = block === "start" || block === "nearest" ? targetTop : block === "end" ? targetBottom : targetTop + targetHeight / 2;
    var targetInline = inline === "center" ? targetLeft + targetWidth / 2 : inline === "end" ? targetRight : targetLeft;
    var computations = [];
    for(var index = 0; index < frames.length; index++){
        var frame = frames[index];
        var _frame$getBoundingCli = frame.getBoundingClientRect(), _height = _frame$getBoundingCli.height, _width = _frame$getBoundingCli.width, _top = _frame$getBoundingCli.top, right = _frame$getBoundingCli.right, bottom = _frame$getBoundingCli.bottom, _left = _frame$getBoundingCli.left;
        if (scrollMode === "if-needed" && targetTop >= 0 && targetLeft >= 0 && targetBottom <= viewportHeight && targetRight <= viewportWidth && targetTop >= _top && targetBottom <= bottom && targetLeft >= _left && targetRight <= right) return computations;
        var frameStyle = getComputedStyle(frame);
        var borderLeft = parseInt(frameStyle.borderLeftWidth, 10);
        var borderTop = parseInt(frameStyle.borderTopWidth, 10);
        var borderRight = parseInt(frameStyle.borderRightWidth, 10);
        var borderBottom = parseInt(frameStyle.borderBottomWidth, 10);
        var blockScroll = 0;
        var inlineScroll = 0;
        var scrollbarWidth = "offsetWidth" in frame ? frame.offsetWidth - frame.clientWidth - borderLeft - borderRight : 0;
        var scrollbarHeight = "offsetHeight" in frame ? frame.offsetHeight - frame.clientHeight - borderTop - borderBottom : 0;
        if (scrollingElement === frame) {
            if (block === "start") blockScroll = targetBlock;
            else if (block === "end") blockScroll = targetBlock - viewportHeight;
            else if (block === "nearest") blockScroll = $84856a3d7962b5f5$var$alignNearest(viewportY, viewportY + viewportHeight, viewportHeight, borderTop, borderBottom, viewportY + targetBlock, viewportY + targetBlock + targetHeight, targetHeight);
            else blockScroll = targetBlock - viewportHeight / 2;
            if (inline === "start") inlineScroll = targetInline;
            else if (inline === "center") inlineScroll = targetInline - viewportWidth / 2;
            else if (inline === "end") inlineScroll = targetInline - viewportWidth;
            else inlineScroll = $84856a3d7962b5f5$var$alignNearest(viewportX, viewportX + viewportWidth, viewportWidth, borderLeft, borderRight, viewportX + targetInline, viewportX + targetInline + targetWidth, targetWidth);
            blockScroll = Math.max(0, blockScroll + viewportY);
            inlineScroll = Math.max(0, inlineScroll + viewportX);
        } else {
            if (block === "start") blockScroll = targetBlock - _top - borderTop;
            else if (block === "end") blockScroll = targetBlock - bottom + borderBottom + scrollbarHeight;
            else if (block === "nearest") blockScroll = $84856a3d7962b5f5$var$alignNearest(_top, bottom, _height, borderTop, borderBottom + scrollbarHeight, targetBlock, targetBlock + targetHeight, targetHeight);
            else blockScroll = targetBlock - (_top + _height / 2) + scrollbarHeight / 2;
            if (inline === "start") inlineScroll = targetInline - _left - borderLeft;
            else if (inline === "center") inlineScroll = targetInline - (_left + _width / 2) + scrollbarWidth / 2;
            else if (inline === "end") inlineScroll = targetInline - right + borderRight + scrollbarWidth;
            else inlineScroll = $84856a3d7962b5f5$var$alignNearest(_left, right, _width, borderLeft, borderRight + scrollbarWidth, targetInline, targetInline + targetWidth, targetWidth);
            var scrollLeft = frame.scrollLeft, scrollTop = frame.scrollTop;
            blockScroll = Math.max(0, Math.min(scrollTop + blockScroll, frame.scrollHeight - _height + scrollbarHeight));
            inlineScroll = Math.max(0, Math.min(scrollLeft + inlineScroll, frame.scrollWidth - _width + scrollbarWidth));
            targetBlock += scrollTop - blockScroll;
            targetInline += scrollLeft - inlineScroll;
        }
        computations.push({
            el: frame,
            top: blockScroll,
            left: inlineScroll
        });
    }
    return computations;
};

});



parcelRegister("f9pRZ", function(module, exports) {

$parcel$export(module.exports, "AnalyticsProvider", function () { return $ae222382ca47debf$export$1b581a2ec13e37f1; });
$parcel$export(module.exports, "withAnalytics", function () { return $ae222382ca47debf$export$af9baadf0e4f6e13; });
$parcel$export(module.exports, "useAnalyticsContext", function () { return $ae222382ca47debf$export$d1f587f82ad51c4; });
$parcel$export(module.exports, "useAnalytics", function () { return $ae222382ca47debf$export$e955abb82869dc84; });

var $9nHZC = parcelRequire("9nHZC");

var $3x3Fz = parcelRequire("3x3Fz");
parcelRequire("dGzLf");
var $aAre5 = parcelRequire("aAre5");

var $3yhbh = parcelRequire("3yhbh");

var $aanBq = parcelRequire("aanBq");

var $5utbt = parcelRequire("5utbt");

var $6aoKW = parcelRequire("6aoKW");

var $628YF = parcelRequire("628YF");
const $ae222382ca47debf$var$AnalyticsContext = /*#__PURE__*/ (0, $9nHZC.createContext)({});
const $ae222382ca47debf$export$1b581a2ec13e37f1 = ({ data: data, children: children })=>{
    const dataRef = (0, $9nHZC.useRef)(data);
    (0, $9nHZC.useEffect)(()=>{
        if (!(0, $3x3Fz.default)(dataRef.current, data)) dataRef.current = data;
    }, [
        data
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($ae222382ca47debf$var$AnalyticsContext.Provider, {
        value: dataRef.current
    }, children);
};
const $ae222382ca47debf$export$af9baadf0e4f6e13 = (Component, analyticsProps)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($ae222382ca47debf$export$1b581a2ec13e37f1, {
            data: analyticsProps
        }, /*#__PURE__*/ // @ts-ignore
        (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Component, props));
const $ae222382ca47debf$export$d1f587f82ad51c4 = (initPropsOverride)=>{
    const analytics = (0, $9nHZC.useContext)($ae222382ca47debf$var$AnalyticsContext);
    return initPropsOverride || analytics || {};
};
const $ae222382ca47debf$var$emptyAttributes = {};
const $ae222382ca47debf$export$e955abb82869dc84 = (initPropsOverride)=>{
    var _ref;
    const { source: source, actionSubject: defaultActionSubject = "unknown", namespaces: namespaces, attributes: unmemoizedInitialAttributes = $ae222382ca47debf$var$emptyAttributes } = $ae222382ca47debf$export$d1f587f82ad51c4(initPropsOverride);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const initialAttributes = (0, $9nHZC.useMemo)(()=>unmemoizedInitialAttributes, []);
    const repositoryUuid = (0, $aAre5.useSelector)((0, $aanBq.getCurrentRepositoryUuid));
    const repoProjectUuid = (0, $aAre5.useSelector)((0, $aanBq.getCurrentRepositoryProjectUuid));
    const currentProjectUuid = (0, $aAre5.useSelector)((0, $3yhbh.getCurrentProjectUuid));
    const projectUuid = repoProjectUuid !== null && repoProjectUuid !== void 0 ? repoProjectUuid : currentProjectUuid;
    const currentWorkspaceUuid = (0, $aAre5.useSelector)((0, $5utbt.getCurrentWorkspaceUUID));
    const repoWorkspaceUuid = (0, $aAre5.useSelector)((0, $aanBq.getCurrentRepositoryWorkspaceUUID));
    const projectWorkspaceUuid = (0, $aAre5.useSelector)((0, $3yhbh.getCurrentProjectWorkspaceUuid));
    // TODO: Revist this and `isReady` and possible remove analytics regarding users without workspaces
    // We're implicitly determining that the user has access to a workspace via nav items
    const hasWorkspace = (0, $aAre5.useSelector)((state)=>{
        var _state$global, _state$global$horizon, _state$global$horizon2;
        return ((_state$global = state.global) === null || _state$global === void 0 ? void 0 : (_state$global$horizon = _state$global.horizontalNavigationItems) === null || _state$global$horizon === void 0 ? void 0 : (_state$global$horizon2 = _state$global$horizon.mainItems) === null || _state$global$horizon2 === void 0 ? void 0 : _state$global$horizon2.length) > 0;
    });
    const workspaceUuid = (_ref = currentWorkspaceUuid !== null && currentWorkspaceUuid !== void 0 ? currentWorkspaceUuid : repoWorkspaceUuid) !== null && _ref !== void 0 ? _ref : projectWorkspaceUuid;
    const defaultActionSubjectId = repositoryUuid || projectUuid || workspaceUuid;
    const isReady = (0, $9nHZC.useMemo)(()=>!hasWorkspace || !!workspaceUuid, [
        workspaceUuid,
        hasWorkspace
    ]);
    const uuidAttributes = (0, $9nHZC.useMemo)(()=>({
            workspaceUuid: workspaceUuid,
            ...projectUuid && {
                projectUuid: projectUuid
            },
            ...repositoryUuid && {
                repositoryUuid: repositoryUuid
            }
        }), [
        workspaceUuid,
        projectUuid,
        repositoryUuid
    ]);
    const wrapExceptions = (0, $9nHZC.useCallback)((func)=>{
        try {
            func();
        } catch (e) {
            (0, $628YF.captureExceptionWithTags)(e, {
                component: "analytics"
            });
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }, []);
    const extractNamespaces = (0, $9nHZC.useCallback)((attributes)=>{
        var _attributes$namespace;
        return (attributes === null || attributes === void 0 ? void 0 : (_attributes$namespace = attributes.namespaces) === null || _attributes$namespace === void 0 ? void 0 : _attributes$namespace.join(".")) || (namespaces === null || namespaces === void 0 ? void 0 : namespaces.join("."));
    }, [
        namespaces
    ]);
    const eventContainers = (0, $9nHZC.useMemo)(()=>({
            ...workspaceUuid && {
                workspace: {
                    id: workspaceUuid
                }
            },
            ...projectUuid && {
                project: {
                    id: projectUuid
                }
            },
            ...repositoryUuid && {
                repository: {
                    id: repositoryUuid
                }
            }
        }), [
        workspaceUuid,
        projectUuid,
        repositoryUuid
    ]);
    const publishTrackEvent = (0, $9nHZC.useCallback)(({ action: action, actionSubject: actionSubject = defaultActionSubject, actionSubjectId: actionSubjectId = defaultActionSubjectId, source: sourceOverride, attributes: attributes })=>{
        wrapExceptions(()=>{
            if (isReady && source !== null && source !== void 0 && source.length && actionSubjectId !== null && actionSubjectId !== void 0 && actionSubjectId.length) {
                const finalSource = sourceOverride || source;
                const finalNamespaces = extractNamespaces(attributes);
                (0, $6aoKW.publishTrackEvent)({
                    action: action,
                    actionSubject: actionSubject,
                    actionSubjectId: actionSubjectId,
                    containers: eventContainers,
                    source: finalSource,
                    attributes: {
                        ...uuidAttributes,
                        ...initialAttributes,
                        ...attributes,
                        namespaces: finalNamespaces || finalSource
                    }
                });
            }
        });
    }, [
        eventContainers,
        defaultActionSubject,
        defaultActionSubjectId,
        initialAttributes,
        isReady,
        extractNamespaces,
        source,
        uuidAttributes,
        wrapExceptions
    ]);
    const publishClickEvent = (0, $9nHZC.useCallback)(({ actionSubject: actionSubject, attributes: attributes, name: name })=>{
        wrapExceptions(()=>{
            if (isReady && source !== null && source !== void 0 && source.length) {
                const finalNamespaces = extractNamespaces(attributes);
                (0, $6aoKW.publishUiEvent)({
                    actionSubject: actionSubject,
                    action: "clicked",
                    actionSubjectId: name.charCodeAt(0) > 64 && name.charCodeAt(0) < 91 // only prepend source if name is capitalized
                     ? `${source}${name}` : name,
                    containers: eventContainers,
                    source: source,
                    attributes: {
                        ...uuidAttributes,
                        ...initialAttributes,
                        ...attributes,
                        namespaces: finalNamespaces || source
                    }
                });
            }
        });
    }, [
        eventContainers,
        initialAttributes,
        isReady,
        extractNamespaces,
        source,
        uuidAttributes,
        wrapExceptions
    ]);
    const publishLinkClickEvent = (0, $9nHZC.useCallback)((name, attributes)=>publishClickEvent({
            actionSubject: "link",
            attributes: attributes,
            name: name
        }), [
        publishClickEvent
    ]);
    const publishToggleClickEvent = (0, $9nHZC.useCallback)((name, attributes)=>publishClickEvent({
            actionSubject: "toggle",
            attributes: attributes,
            name: name
        }), [
        publishClickEvent
    ]);
    const publishButtonClickEvent = (0, $9nHZC.useCallback)((name, attributes)=>publishClickEvent({
            actionSubject: "button",
            attributes: attributes,
            name: name
        }), [
        publishClickEvent
    ]);
    const publishOptionClickEvent = (0, $9nHZC.useCallback)((name, attributes)=>publishClickEvent({
            actionSubject: "option",
            attributes: attributes,
            name: name
        }), [
        publishClickEvent
    ]);
    const publishBreadcrumbClickEvent = (0, $9nHZC.useCallback)((name, attributes = {})=>publishClickEvent({
            actionSubject: "breadcrumbItem",
            attributes: attributes,
            name: name
        }), [
        publishClickEvent
    ]);
    const publishScreenEvent = (0, $9nHZC.useCallback)(({ attributes: attributes } = {})=>{
        wrapExceptions(()=>{
            if (isReady && source !== null && source !== void 0 && source.length) {
                const finalNamespaces = extractNamespaces(attributes);
                (0, $6aoKW.publishFullScreenEvent)({
                    name: source,
                    containers: eventContainers,
                    attributes: {
                        ...uuidAttributes,
                        ...initialAttributes,
                        ...attributes,
                        namespaces: finalNamespaces || source
                    }
                });
            }
        });
    }, [
        eventContainers,
        extractNamespaces,
        initialAttributes,
        isReady,
        source,
        uuidAttributes,
        wrapExceptions
    ]);
    const getNamespacesWithParent = (0, $9nHZC.useCallback)((childSource)=>{
        let parentNamespaces = [];
        if (namespaces !== null && namespaces !== void 0 && namespaces.length) parentNamespaces = namespaces;
        else if (source) parentNamespaces = [
            source
        ];
        return [
            ...parentNamespaces,
            childSource
        ];
    }, [
        namespaces,
        source
    ]);
    return {
        publishClickEvent: publishClickEvent,
        publishLinkClickEvent: publishLinkClickEvent,
        publishButtonClickEvent: publishButtonClickEvent,
        publishBreadcrumbClickEvent: publishBreadcrumbClickEvent,
        publishOptionClickEvent: publishOptionClickEvent,
        publishToggleClickEvent: publishToggleClickEvent,
        publishTrackEvent: publishTrackEvent,
        publishScreenEvent: publishScreenEvent,
        getNamespacesWithParent: getNamespacesWithParent
    };
};

});
parcelRegister("3x3Fz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29274cdfbdfc126c$export$2e2bcd8739ae039; });

var $7bH8v = parcelRequire("7bH8v");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $29274cdfbdfc126c$var$isEqual(value, other) {
    return (0, $7bH8v.default)(value, other);
}
var $29274cdfbdfc126c$export$2e2bcd8739ae039 = $29274cdfbdfc126c$var$isEqual;

});
parcelRegister("7bH8v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53bb056ea3031aa6$export$2e2bcd8739ae039; });

var $fNGtI = parcelRequire("fNGtI");

var $bqTHd = parcelRequire("bqTHd");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $53bb056ea3031aa6$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $bqTHd.default)(value) && !(0, $bqTHd.default)(other)) return value !== value && other !== other;
    return (0, $fNGtI.default)(value, other, bitmask, customizer, $53bb056ea3031aa6$var$baseIsEqual, stack);
}
var $53bb056ea3031aa6$export$2e2bcd8739ae039 = $53bb056ea3031aa6$var$baseIsEqual;

});
parcelRegister("fNGtI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b80c61f064ef5de3$export$2e2bcd8739ae039; });

var $9FAVP = parcelRequire("9FAVP");

var $2wQFC = parcelRequire("2wQFC");

var $l8VQ2 = parcelRequire("l8VQ2");

var $kDPBp = parcelRequire("kDPBp");

var $jFSoh = parcelRequire("jFSoh");

var $dEaOb = parcelRequire("dEaOb");

var $3CsZM = parcelRequire("3CsZM");

var $gsxmc = parcelRequire("gsxmc");
/** Used to compose bitmasks for value comparisons. */ var $b80c61f064ef5de3$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $b80c61f064ef5de3$var$argsTag = "[object Arguments]", $b80c61f064ef5de3$var$arrayTag = "[object Array]", $b80c61f064ef5de3$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $b80c61f064ef5de3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b80c61f064ef5de3$var$hasOwnProperty = $b80c61f064ef5de3$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $b80c61f064ef5de3$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $dEaOb.default)(object), othIsArr = (0, $dEaOb.default)(other), objTag = objIsArr ? $b80c61f064ef5de3$var$arrayTag : (0, $jFSoh.default)(object), othTag = othIsArr ? $b80c61f064ef5de3$var$arrayTag : (0, $jFSoh.default)(other);
    objTag = objTag == $b80c61f064ef5de3$var$argsTag ? $b80c61f064ef5de3$var$objectTag : objTag;
    othTag = othTag == $b80c61f064ef5de3$var$argsTag ? $b80c61f064ef5de3$var$objectTag : othTag;
    var objIsObj = objTag == $b80c61f064ef5de3$var$objectTag, othIsObj = othTag == $b80c61f064ef5de3$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $3CsZM.default)(object)) {
        if (!(0, $3CsZM.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $9FAVP.default));
        return objIsArr || (0, $gsxmc.default)(object) ? (0, $2wQFC.default)(object, other, bitmask, customizer, equalFunc, stack) : (0, $l8VQ2.default)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $b80c61f064ef5de3$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $b80c61f064ef5de3$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $b80c61f064ef5de3$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $9FAVP.default));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $9FAVP.default));
    return (0, $kDPBp.default)(object, other, bitmask, customizer, equalFunc, stack);
}
var $b80c61f064ef5de3$export$2e2bcd8739ae039 = $b80c61f064ef5de3$var$baseIsEqualDeep;

});
parcelRegister("9FAVP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70a497440afc7697$export$2e2bcd8739ae039; });

var $3lavE = parcelRequire("3lavE");

var $fQOhE = parcelRequire("fQOhE");

var $4itD9 = parcelRequire("4itD9");

var $8u4W3 = parcelRequire("8u4W3");

var $5Ppou = parcelRequire("5Ppou");

var $aKjlq = parcelRequire("aKjlq");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $70a497440afc7697$var$Stack(entries) {
    var data = this.__data__ = new (0, $3lavE.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$70a497440afc7697$var$Stack.prototype.clear = (0, $fQOhE.default);
$70a497440afc7697$var$Stack.prototype["delete"] = (0, $4itD9.default);
$70a497440afc7697$var$Stack.prototype.get = (0, $8u4W3.default);
$70a497440afc7697$var$Stack.prototype.has = (0, $5Ppou.default);
$70a497440afc7697$var$Stack.prototype.set = (0, $aKjlq.default);
var $70a497440afc7697$export$2e2bcd8739ae039 = $70a497440afc7697$var$Stack;

});
parcelRegister("fQOhE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8a2b7a1107ac769$export$2e2bcd8739ae039; });

var $3lavE = parcelRequire("3lavE");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $b8a2b7a1107ac769$var$stackClear() {
    this.__data__ = new (0, $3lavE.default);
    this.size = 0;
}
var $b8a2b7a1107ac769$export$2e2bcd8739ae039 = $b8a2b7a1107ac769$var$stackClear;

});

parcelRegister("4itD9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $320fd3e035605c21$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $320fd3e035605c21$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
var $320fd3e035605c21$export$2e2bcd8739ae039 = $320fd3e035605c21$var$stackDelete;

});

parcelRegister("8u4W3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62d4f424cdde0c55$export$2e2bcd8739ae039; });
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $62d4f424cdde0c55$var$stackGet(key) {
    return this.__data__.get(key);
}
var $62d4f424cdde0c55$export$2e2bcd8739ae039 = $62d4f424cdde0c55$var$stackGet;

});

parcelRegister("5Ppou", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43e569e4de402613$export$2e2bcd8739ae039; });
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $43e569e4de402613$var$stackHas(key) {
    return this.__data__.has(key);
}
var $43e569e4de402613$export$2e2bcd8739ae039 = $43e569e4de402613$var$stackHas;

});

parcelRegister("aKjlq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d2d34b53fffcfb5$export$2e2bcd8739ae039; });

var $3lavE = parcelRequire("3lavE");

var $ahUDe = parcelRequire("ahUDe");

var $fXABU = parcelRequire("fXABU");
/** Used as the size to enable large array optimizations. */ var $7d2d34b53fffcfb5$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $7d2d34b53fffcfb5$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $3lavE.default)) {
        var pairs = data.__data__;
        if (!(0, $ahUDe.default) || pairs.length < $7d2d34b53fffcfb5$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $fXABU.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $7d2d34b53fffcfb5$export$2e2bcd8739ae039 = $7d2d34b53fffcfb5$var$stackSet;

});


parcelRegister("2wQFC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d776d2376b719c4$export$2e2bcd8739ae039; });

var $fJMvm = parcelRequire("fJMvm");

var $cIsQR = parcelRequire("cIsQR");

var $4I1X7 = parcelRequire("4I1X7");
/** Used to compose bitmasks for value comparisons. */ var $1d776d2376b719c4$var$COMPARE_PARTIAL_FLAG = 1, $1d776d2376b719c4$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1d776d2376b719c4$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1d776d2376b719c4$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1d776d2376b719c4$var$COMPARE_UNORDERED_FLAG ? new (0, $fJMvm.default) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $cIsQR.default)(other, function(othValue, othIndex) {
                if (!(0, $4I1X7.default)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
var $1d776d2376b719c4$export$2e2bcd8739ae039 = $1d776d2376b719c4$var$equalArrays;

});
parcelRegister("fJMvm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b750af0d3ef186f8$export$2e2bcd8739ae039; });

var $fXABU = parcelRequire("fXABU");

var $12itM = parcelRequire("12itM");

var $lUlT7 = parcelRequire("lUlT7");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $b750af0d3ef186f8$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $fXABU.default);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$b750af0d3ef186f8$var$SetCache.prototype.add = $b750af0d3ef186f8$var$SetCache.prototype.push = (0, $12itM.default);
$b750af0d3ef186f8$var$SetCache.prototype.has = (0, $lUlT7.default);
var $b750af0d3ef186f8$export$2e2bcd8739ae039 = $b750af0d3ef186f8$var$SetCache;

});
parcelRegister("12itM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c144ff030213f27$export$2e2bcd8739ae039; });
/** Used to stand-in for `undefined` hash values. */ var $0c144ff030213f27$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $0c144ff030213f27$var$setCacheAdd(value) {
    this.__data__.set(value, $0c144ff030213f27$var$HASH_UNDEFINED);
    return this;
}
var $0c144ff030213f27$export$2e2bcd8739ae039 = $0c144ff030213f27$var$setCacheAdd;

});

parcelRegister("lUlT7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff2fce73c9e6a8f5$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $ff2fce73c9e6a8f5$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $ff2fce73c9e6a8f5$export$2e2bcd8739ae039 = $ff2fce73c9e6a8f5$var$setCacheHas;

});


parcelRegister("cIsQR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $941ff970e23b7e3d$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $941ff970e23b7e3d$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $941ff970e23b7e3d$export$2e2bcd8739ae039 = $941ff970e23b7e3d$var$arraySome;

});

parcelRegister("4I1X7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36dcc9318e63be79$export$2e2bcd8739ae039; });
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $36dcc9318e63be79$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $36dcc9318e63be79$export$2e2bcd8739ae039 = $36dcc9318e63be79$var$cacheHas;

});


parcelRegister("l8VQ2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f64735ca9742090d$export$2e2bcd8739ae039; });

var $jici1 = parcelRequire("jici1");

var $lqrK9 = parcelRequire("lqrK9");

var $i9zf9 = parcelRequire("i9zf9");

var $2wQFC = parcelRequire("2wQFC");

var $k24d7 = parcelRequire("k24d7");

var $bkWf6 = parcelRequire("bkWf6");
/** Used to compose bitmasks for value comparisons. */ var $f64735ca9742090d$var$COMPARE_PARTIAL_FLAG = 1, $f64735ca9742090d$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $f64735ca9742090d$var$boolTag = "[object Boolean]", $f64735ca9742090d$var$dateTag = "[object Date]", $f64735ca9742090d$var$errorTag = "[object Error]", $f64735ca9742090d$var$mapTag = "[object Map]", $f64735ca9742090d$var$numberTag = "[object Number]", $f64735ca9742090d$var$regexpTag = "[object RegExp]", $f64735ca9742090d$var$setTag = "[object Set]", $f64735ca9742090d$var$stringTag = "[object String]", $f64735ca9742090d$var$symbolTag = "[object Symbol]";
var $f64735ca9742090d$var$arrayBufferTag = "[object ArrayBuffer]", $f64735ca9742090d$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $f64735ca9742090d$var$symbolProto = (0, $jici1.default) ? (0, $jici1.default).prototype : undefined, $f64735ca9742090d$var$symbolValueOf = $f64735ca9742090d$var$symbolProto ? $f64735ca9742090d$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $f64735ca9742090d$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $f64735ca9742090d$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $f64735ca9742090d$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $lqrK9.default)(object), new (0, $lqrK9.default)(other))) return false;
            return true;
        case $f64735ca9742090d$var$boolTag:
        case $f64735ca9742090d$var$dateTag:
        case $f64735ca9742090d$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $i9zf9.default)(+object, +other);
        case $f64735ca9742090d$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $f64735ca9742090d$var$regexpTag:
        case $f64735ca9742090d$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $f64735ca9742090d$var$mapTag:
            var convert = (0, $k24d7.default);
        case $f64735ca9742090d$var$setTag:
            var isPartial = bitmask & $f64735ca9742090d$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $bkWf6.default));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $f64735ca9742090d$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $2wQFC.default)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $f64735ca9742090d$var$symbolTag:
            if ($f64735ca9742090d$var$symbolValueOf) return $f64735ca9742090d$var$symbolValueOf.call(object) == $f64735ca9742090d$var$symbolValueOf.call(other);
    }
    return false;
}
var $f64735ca9742090d$export$2e2bcd8739ae039 = $f64735ca9742090d$var$equalByTag;

});
parcelRegister("lqrK9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9918bf24cf70677$export$2e2bcd8739ae039; });

var $8kDqY = parcelRequire("8kDqY");
/** Built-in value references. */ var $f9918bf24cf70677$var$Uint8Array = (0, $8kDqY.default).Uint8Array;
var $f9918bf24cf70677$export$2e2bcd8739ae039 = $f9918bf24cf70677$var$Uint8Array;

});

parcelRegister("k24d7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e95742b046979a42$export$2e2bcd8739ae039; });
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $e95742b046979a42$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $e95742b046979a42$export$2e2bcd8739ae039 = $e95742b046979a42$var$mapToArray;

});

parcelRegister("bkWf6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $840ebdbaf45bbf23$export$2e2bcd8739ae039; });
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $840ebdbaf45bbf23$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $840ebdbaf45bbf23$export$2e2bcd8739ae039 = $840ebdbaf45bbf23$var$setToArray;

});


parcelRegister("kDPBp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f06f7a57edbed55b$export$2e2bcd8739ae039; });

var $8EJgn = parcelRequire("8EJgn");
/** Used to compose bitmasks for value comparisons. */ var $f06f7a57edbed55b$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $f06f7a57edbed55b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f06f7a57edbed55b$var$hasOwnProperty = $f06f7a57edbed55b$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $f06f7a57edbed55b$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $f06f7a57edbed55b$var$COMPARE_PARTIAL_FLAG, objProps = (0, $8EJgn.default)(object), objLength = objProps.length, othProps = (0, $8EJgn.default)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $f06f7a57edbed55b$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
var $f06f7a57edbed55b$export$2e2bcd8739ae039 = $f06f7a57edbed55b$var$equalObjects;

});
parcelRegister("8EJgn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64d52b75afccbafd$export$2e2bcd8739ae039; });

var $9ZbiF = parcelRequire("9ZbiF");

var $3i0FT = parcelRequire("3i0FT");

var $d3taP = parcelRequire("d3taP");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $64d52b75afccbafd$var$getAllKeys(object) {
    return (0, $9ZbiF.default)(object, (0, $d3taP.default), (0, $3i0FT.default));
}
var $64d52b75afccbafd$export$2e2bcd8739ae039 = $64d52b75afccbafd$var$getAllKeys;

});
parcelRegister("9ZbiF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74529381abc8ccdb$export$2e2bcd8739ae039; });

var $j5Xkb = parcelRequire("j5Xkb");

var $dEaOb = parcelRequire("dEaOb");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $74529381abc8ccdb$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $dEaOb.default)(object) ? result : (0, $j5Xkb.default)(result, symbolsFunc(object));
}
var $74529381abc8ccdb$export$2e2bcd8739ae039 = $74529381abc8ccdb$var$baseGetAllKeys;

});
parcelRegister("j5Xkb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de6c8094e05c82b0$export$2e2bcd8739ae039; });
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $de6c8094e05c82b0$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $de6c8094e05c82b0$export$2e2bcd8739ae039 = $de6c8094e05c82b0$var$arrayPush;

});


parcelRegister("3i0FT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26539386391ee9de$export$2e2bcd8739ae039; });

var $hEdQf = parcelRequire("hEdQf");

var $adstn = parcelRequire("adstn");
/** Used for built-in method references. */ var $26539386391ee9de$var$objectProto = Object.prototype;
/** Built-in value references. */ var $26539386391ee9de$var$propertyIsEnumerable = $26539386391ee9de$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $26539386391ee9de$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $26539386391ee9de$var$getSymbols = !$26539386391ee9de$var$nativeGetSymbols ? (0, $adstn.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $hEdQf.default)($26539386391ee9de$var$nativeGetSymbols(object), function(symbol) {
        return $26539386391ee9de$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $26539386391ee9de$export$2e2bcd8739ae039 = $26539386391ee9de$var$getSymbols;

});
parcelRegister("hEdQf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd90e8c764c363b9$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $cd90e8c764c363b9$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $cd90e8c764c363b9$export$2e2bcd8739ae039 = $cd90e8c764c363b9$var$arrayFilter;

});

parcelRegister("adstn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77013460447d8949$export$2e2bcd8739ae039; });
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $77013460447d8949$var$stubArray() {
    return [];
}
var $77013460447d8949$export$2e2bcd8739ae039 = $77013460447d8949$var$stubArray;

});


parcelRegister("d3taP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98122f6e9f33131f$export$2e2bcd8739ae039; });

var $K4pmn = parcelRequire("K4pmn");

var $iaY3b = parcelRequire("iaY3b");

var $l3LBL = parcelRequire("l3LBL");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $98122f6e9f33131f$var$keys(object) {
    return (0, $l3LBL.default)(object) ? (0, $K4pmn.default)(object) : (0, $iaY3b.default)(object);
}
var $98122f6e9f33131f$export$2e2bcd8739ae039 = $98122f6e9f33131f$var$keys;

});
parcelRegister("K4pmn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08a7b755f3b56ed8$export$2e2bcd8739ae039; });

var $7prKW = parcelRequire("7prKW");

var $01Qmm = parcelRequire("01Qmm");

var $dEaOb = parcelRequire("dEaOb");

var $3CsZM = parcelRequire("3CsZM");

var $2CjdF = parcelRequire("2CjdF");

var $gsxmc = parcelRequire("gsxmc");
/** Used for built-in method references. */ var $08a7b755f3b56ed8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $08a7b755f3b56ed8$var$hasOwnProperty = $08a7b755f3b56ed8$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $08a7b755f3b56ed8$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $dEaOb.default)(value), isArg = !isArr && (0, $01Qmm.default)(value), isBuff = !isArr && !isArg && (0, $3CsZM.default)(value), isType = !isArr && !isArg && !isBuff && (0, $gsxmc.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $7prKW.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $08a7b755f3b56ed8$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    (0, $2CjdF.default)(key, length)))) result.push(key);
    return result;
}
var $08a7b755f3b56ed8$export$2e2bcd8739ae039 = $08a7b755f3b56ed8$var$arrayLikeKeys;

});
parcelRegister("7prKW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $565065fa215133f5$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $565065fa215133f5$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $565065fa215133f5$export$2e2bcd8739ae039 = $565065fa215133f5$var$baseTimes;

});

parcelRegister("01Qmm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0058b5a685a2ad83$export$2e2bcd8739ae039; });

var $dDW7Q = parcelRequire("dDW7Q");

var $bqTHd = parcelRequire("bqTHd");
/** Used for built-in method references. */ var $0058b5a685a2ad83$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0058b5a685a2ad83$var$hasOwnProperty = $0058b5a685a2ad83$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $0058b5a685a2ad83$var$propertyIsEnumerable = $0058b5a685a2ad83$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $0058b5a685a2ad83$var$isArguments = (0, $dDW7Q.default)(function() {
    return arguments;
}()) ? (0, $dDW7Q.default) : function(value) {
    return (0, $bqTHd.default)(value) && $0058b5a685a2ad83$var$hasOwnProperty.call(value, "callee") && !$0058b5a685a2ad83$var$propertyIsEnumerable.call(value, "callee");
};
var $0058b5a685a2ad83$export$2e2bcd8739ae039 = $0058b5a685a2ad83$var$isArguments;

});
parcelRegister("dDW7Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9eec01650fc1d194$export$2e2bcd8739ae039; });

var $9mt1a = parcelRequire("9mt1a");

var $bqTHd = parcelRequire("bqTHd");
/** `Object#toString` result references. */ var $9eec01650fc1d194$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $9eec01650fc1d194$var$baseIsArguments(value) {
    return (0, $bqTHd.default)(value) && (0, $9mt1a.default)(value) == $9eec01650fc1d194$var$argsTag;
}
var $9eec01650fc1d194$export$2e2bcd8739ae039 = $9eec01650fc1d194$var$baseIsArguments;

});


parcelRegister("3CsZM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a2b6993e10f4d36$export$2e2bcd8739ae039; });

var $8kDqY = parcelRequire("8kDqY");

var $56IXY = parcelRequire("56IXY");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $8kDqY.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $56IXY.default);
var $2a2b6993e10f4d36$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("56IXY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b8064a3c6cffce1$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $3b8064a3c6cffce1$var$stubFalse() {
    return false;
}
var $3b8064a3c6cffce1$export$2e2bcd8739ae039 = $3b8064a3c6cffce1$var$stubFalse;

});


parcelRegister("2CjdF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e7e09f21ddaf495$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $1e7e09f21ddaf495$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $1e7e09f21ddaf495$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $1e7e09f21ddaf495$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $1e7e09f21ddaf495$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $1e7e09f21ddaf495$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $1e7e09f21ddaf495$export$2e2bcd8739ae039 = $1e7e09f21ddaf495$var$isIndex;

});

parcelRegister("gsxmc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfb922e03088c476$export$2e2bcd8739ae039; });

var $fTYT9 = parcelRequire("fTYT9");

var $3TlFX = parcelRequire("3TlFX");

var $53WMN = parcelRequire("53WMN");
/* Node.js helper references. */ var $bfb922e03088c476$var$nodeIsTypedArray = (0, $53WMN.default) && (0, $53WMN.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $bfb922e03088c476$var$isTypedArray = $bfb922e03088c476$var$nodeIsTypedArray ? (0, $3TlFX.default)($bfb922e03088c476$var$nodeIsTypedArray) : (0, $fTYT9.default);
var $bfb922e03088c476$export$2e2bcd8739ae039 = $bfb922e03088c476$var$isTypedArray;

});
parcelRegister("fTYT9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b93b394326c29caf$export$2e2bcd8739ae039; });

var $9mt1a = parcelRequire("9mt1a");

var $4xcMZ = parcelRequire("4xcMZ");

var $bqTHd = parcelRequire("bqTHd");
/** `Object#toString` result references. */ var $b93b394326c29caf$var$argsTag = "[object Arguments]", $b93b394326c29caf$var$arrayTag = "[object Array]", $b93b394326c29caf$var$boolTag = "[object Boolean]", $b93b394326c29caf$var$dateTag = "[object Date]", $b93b394326c29caf$var$errorTag = "[object Error]", $b93b394326c29caf$var$funcTag = "[object Function]", $b93b394326c29caf$var$mapTag = "[object Map]", $b93b394326c29caf$var$numberTag = "[object Number]", $b93b394326c29caf$var$objectTag = "[object Object]", $b93b394326c29caf$var$regexpTag = "[object RegExp]", $b93b394326c29caf$var$setTag = "[object Set]", $b93b394326c29caf$var$stringTag = "[object String]", $b93b394326c29caf$var$weakMapTag = "[object WeakMap]";
var $b93b394326c29caf$var$arrayBufferTag = "[object ArrayBuffer]", $b93b394326c29caf$var$dataViewTag = "[object DataView]", $b93b394326c29caf$var$float32Tag = "[object Float32Array]", $b93b394326c29caf$var$float64Tag = "[object Float64Array]", $b93b394326c29caf$var$int8Tag = "[object Int8Array]", $b93b394326c29caf$var$int16Tag = "[object Int16Array]", $b93b394326c29caf$var$int32Tag = "[object Int32Array]", $b93b394326c29caf$var$uint8Tag = "[object Uint8Array]", $b93b394326c29caf$var$uint8ClampedTag = "[object Uint8ClampedArray]", $b93b394326c29caf$var$uint16Tag = "[object Uint16Array]", $b93b394326c29caf$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $b93b394326c29caf$var$typedArrayTags = {};
$b93b394326c29caf$var$typedArrayTags[$b93b394326c29caf$var$float32Tag] = $b93b394326c29caf$var$typedArrayTags[$b93b394326c29caf$var$float64Tag] = $b93b394326c29caf$var$typedArrayTags[$b93b394326c29caf$var$int8Tag] = $b93b394326c29caf$var$typedArrayTags[$b93b394326c29caf$var$int16Tag] = $b93b394326c29caf$var$typedArrayTags[$b93b394326c29caf$var$int32Tag] = $b93b394326c29caf$var$typedArrayTags[$b93b394326c29caf$var$uint8Tag] = $b93b394326c29caf$var$typedArrayTags[$b93b394326c29caf$var$uint8ClampedTag] = $b93b394326c29caf$var$typedArrayTags[$b93b394326c29caf$var$uint16Tag] = $b93b394326c29caf$var$typedArrayTags[$b93b394326c29caf$var$uint32Tag] = true;
$b93b394326c29caf$var$typedArrayTags[$b93b394326c29caf$var$argsTag] = $b93b394326c29caf$var$typedArrayTags[$b93b394326c29caf$var$arrayTag] = $b93b394326c29caf$var$typedArrayTags[$b93b394326c29caf$var$arrayBufferTag] = $b93b394326c29caf$var$typedArrayTags[$b93b394326c29caf$var$boolTag] = $b93b394326c29caf$var$typedArrayTags[$b93b394326c29caf$var$dataViewTag] = $b93b394326c29caf$var$typedArrayTags[$b93b394326c29caf$var$dateTag] = $b93b394326c29caf$var$typedArrayTags[$b93b394326c29caf$var$errorTag] = $b93b394326c29caf$var$typedArrayTags[$b93b394326c29caf$var$funcTag] = $b93b394326c29caf$var$typedArrayTags[$b93b394326c29caf$var$mapTag] = $b93b394326c29caf$var$typedArrayTags[$b93b394326c29caf$var$numberTag] = $b93b394326c29caf$var$typedArrayTags[$b93b394326c29caf$var$objectTag] = $b93b394326c29caf$var$typedArrayTags[$b93b394326c29caf$var$regexpTag] = $b93b394326c29caf$var$typedArrayTags[$b93b394326c29caf$var$setTag] = $b93b394326c29caf$var$typedArrayTags[$b93b394326c29caf$var$stringTag] = $b93b394326c29caf$var$typedArrayTags[$b93b394326c29caf$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $b93b394326c29caf$var$baseIsTypedArray(value) {
    return (0, $bqTHd.default)(value) && (0, $4xcMZ.default)(value.length) && !!$b93b394326c29caf$var$typedArrayTags[(0, $9mt1a.default)(value)];
}
var $b93b394326c29caf$export$2e2bcd8739ae039 = $b93b394326c29caf$var$baseIsTypedArray;

});
parcelRegister("4xcMZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34d42a21002082d7$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $34d42a21002082d7$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $34d42a21002082d7$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $34d42a21002082d7$var$MAX_SAFE_INTEGER;
}
var $34d42a21002082d7$export$2e2bcd8739ae039 = $34d42a21002082d7$var$isLength;

});


parcelRegister("3TlFX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d57527e98895a5b$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $2d57527e98895a5b$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $2d57527e98895a5b$export$2e2bcd8739ae039 = $2d57527e98895a5b$var$baseUnary;

});

parcelRegister("53WMN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3afad53876e52e21$export$2e2bcd8739ae039; });

var $7jSBg = parcelRequire("7jSBg");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $7jSBg.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
var $3afad53876e52e21$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("iaY3b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3b7bdefc5008dd3$export$2e2bcd8739ae039; });

var $lt0RS = parcelRequire("lt0RS");

var $2SgCO = parcelRequire("2SgCO");
/** Used for built-in method references. */ var $d3b7bdefc5008dd3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d3b7bdefc5008dd3$var$hasOwnProperty = $d3b7bdefc5008dd3$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $d3b7bdefc5008dd3$var$baseKeys(object) {
    if (!(0, $lt0RS.default)(object)) return (0, $2SgCO.default)(object);
    var result = [];
    for(var key in Object(object))if ($d3b7bdefc5008dd3$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
var $d3b7bdefc5008dd3$export$2e2bcd8739ae039 = $d3b7bdefc5008dd3$var$baseKeys;

});
parcelRegister("lt0RS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa0cfac4a5c7c3d6$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $fa0cfac4a5c7c3d6$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $fa0cfac4a5c7c3d6$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $fa0cfac4a5c7c3d6$var$objectProto;
    return value === proto;
}
var $fa0cfac4a5c7c3d6$export$2e2bcd8739ae039 = $fa0cfac4a5c7c3d6$var$isPrototype;

});

parcelRegister("2SgCO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $217d8546c86f6850$export$2e2bcd8739ae039; });

var $4q1BL = parcelRequire("4q1BL");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $217d8546c86f6850$var$nativeKeys = (0, $4q1BL.default)(Object.keys, Object);
var $217d8546c86f6850$export$2e2bcd8739ae039 = $217d8546c86f6850$var$nativeKeys;

});


parcelRegister("l3LBL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f54ecec66657f5c1$export$2e2bcd8739ae039; });

var $EmE07 = parcelRequire("EmE07");

var $4xcMZ = parcelRequire("4xcMZ");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $f54ecec66657f5c1$var$isArrayLike(value) {
    return value != null && (0, $4xcMZ.default)(value.length) && !(0, $EmE07.default)(value);
}
var $f54ecec66657f5c1$export$2e2bcd8739ae039 = $f54ecec66657f5c1$var$isArrayLike;

});




parcelRegister("jFSoh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e52c097c16988c22$export$2e2bcd8739ae039; });

var $7uVO5 = parcelRequire("7uVO5");

var $ahUDe = parcelRequire("ahUDe");

var $7ZIYa = parcelRequire("7ZIYa");

var $66wjI = parcelRequire("66wjI");

var $20fBH = parcelRequire("20fBH");

var $9mt1a = parcelRequire("9mt1a");

var $5H93l = parcelRequire("5H93l");
/** `Object#toString` result references. */ var $e52c097c16988c22$var$mapTag = "[object Map]", $e52c097c16988c22$var$objectTag = "[object Object]", $e52c097c16988c22$var$promiseTag = "[object Promise]", $e52c097c16988c22$var$setTag = "[object Set]", $e52c097c16988c22$var$weakMapTag = "[object WeakMap]";
var $e52c097c16988c22$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $e52c097c16988c22$var$dataViewCtorString = (0, $5H93l.default)((0, $7uVO5.default)), $e52c097c16988c22$var$mapCtorString = (0, $5H93l.default)((0, $ahUDe.default)), $e52c097c16988c22$var$promiseCtorString = (0, $5H93l.default)((0, $7ZIYa.default)), $e52c097c16988c22$var$setCtorString = (0, $5H93l.default)((0, $66wjI.default)), $e52c097c16988c22$var$weakMapCtorString = (0, $5H93l.default)((0, $20fBH.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $e52c097c16988c22$var$getTag = (0, $9mt1a.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $7uVO5.default) && $e52c097c16988c22$var$getTag(new (0, $7uVO5.default)(new ArrayBuffer(1))) != $e52c097c16988c22$var$dataViewTag || (0, $ahUDe.default) && $e52c097c16988c22$var$getTag(new (0, $ahUDe.default)) != $e52c097c16988c22$var$mapTag || (0, $7ZIYa.default) && $e52c097c16988c22$var$getTag((0, $7ZIYa.default).resolve()) != $e52c097c16988c22$var$promiseTag || (0, $66wjI.default) && $e52c097c16988c22$var$getTag(new (0, $66wjI.default)) != $e52c097c16988c22$var$setTag || (0, $20fBH.default) && $e52c097c16988c22$var$getTag(new (0, $20fBH.default)) != $e52c097c16988c22$var$weakMapTag) $e52c097c16988c22$var$getTag = function(value) {
    var result = (0, $9mt1a.default)(value), Ctor = result == $e52c097c16988c22$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $5H93l.default)(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $e52c097c16988c22$var$dataViewCtorString:
            return $e52c097c16988c22$var$dataViewTag;
        case $e52c097c16988c22$var$mapCtorString:
            return $e52c097c16988c22$var$mapTag;
        case $e52c097c16988c22$var$promiseCtorString:
            return $e52c097c16988c22$var$promiseTag;
        case $e52c097c16988c22$var$setCtorString:
            return $e52c097c16988c22$var$setTag;
        case $e52c097c16988c22$var$weakMapCtorString:
            return $e52c097c16988c22$var$weakMapTag;
    }
    return result;
};
var $e52c097c16988c22$export$2e2bcd8739ae039 = $e52c097c16988c22$var$getTag;

});
parcelRegister("7uVO5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57582d0039d152b8$export$2e2bcd8739ae039; });

var $iCjVJ = parcelRequire("iCjVJ");

var $8kDqY = parcelRequire("8kDqY");
/* Built-in method references that are verified to be native. */ var $57582d0039d152b8$var$DataView = (0, $iCjVJ.default)((0, $8kDqY.default), "DataView");
var $57582d0039d152b8$export$2e2bcd8739ae039 = $57582d0039d152b8$var$DataView;

});

parcelRegister("7ZIYa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d211ce4143820bc$export$2e2bcd8739ae039; });

var $iCjVJ = parcelRequire("iCjVJ");

var $8kDqY = parcelRequire("8kDqY");
/* Built-in method references that are verified to be native. */ var $5d211ce4143820bc$var$Promise = (0, $iCjVJ.default)((0, $8kDqY.default), "Promise");
var $5d211ce4143820bc$export$2e2bcd8739ae039 = $5d211ce4143820bc$var$Promise;

});

parcelRegister("66wjI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $471c5f123fb8b5c4$export$2e2bcd8739ae039; });

var $iCjVJ = parcelRequire("iCjVJ");

var $8kDqY = parcelRequire("8kDqY");
/* Built-in method references that are verified to be native. */ var $471c5f123fb8b5c4$var$Set = (0, $iCjVJ.default)((0, $8kDqY.default), "Set");
var $471c5f123fb8b5c4$export$2e2bcd8739ae039 = $471c5f123fb8b5c4$var$Set;

});

parcelRegister("20fBH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1757b0145c59af75$export$2e2bcd8739ae039; });

var $iCjVJ = parcelRequire("iCjVJ");

var $8kDqY = parcelRequire("8kDqY");
/* Built-in method references that are verified to be native. */ var $1757b0145c59af75$var$WeakMap = (0, $iCjVJ.default)((0, $8kDqY.default), "WeakMap");
var $1757b0145c59af75$export$2e2bcd8739ae039 = $1757b0145c59af75$var$WeakMap;

});





parcelRegister("3yhbh", function(module, exports) {

$parcel$export(module.exports, "getCurrentProject", function () { return $578dfb1865448eec$export$e1bf094f1cd3bec8; });
$parcel$export(module.exports, "getCurrentProjectKey", function () { return $578dfb1865448eec$export$327c9d9fb55ff015; });
$parcel$export(module.exports, "getCurrentProjectUuid", function () { return $578dfb1865448eec$export$e3c00b20d77a8dca; });
$parcel$export(module.exports, "getCurrentProjectWorkspace", function () { return $578dfb1865448eec$export$bf6ea790759ee971; });
$parcel$export(module.exports, "getCurrentProjectWorkspaceSlug", function () { return $578dfb1865448eec$export$144a4543df070715; });
$parcel$export(module.exports, "getCurrentProjectWorkspaceUuid", function () { return $578dfb1865448eec$export$3d7a29974c02e22b; });
$parcel$export(module.exports, "getIsCurrentProjectPrivate", function () { return $578dfb1865448eec$export$3d3236d61b36755e; });
$parcel$export(module.exports, "getCurrentProjectLinkData", function () { return $578dfb1865448eec$export$ac5d20bc3cc38009; });
$parcel$export(module.exports, "getMenuItems", function () { return $578dfb1865448eec$export$91d66573ef213493; });
$parcel$export(module.exports, "getSelectedMenuItem", function () { return $578dfb1865448eec$export$d680deecfd3214a7; });

var $ga67g = parcelRequire("ga67g");

var $cQrjH = parcelRequire("cQrjH");

var $aXXtM = parcelRequire("aXXtM");

var $iaicX = parcelRequire("iaicX");

var $48ZQ3 = parcelRequire("48ZQ3");

var $7qdXF = parcelRequire("7qdXF");
const $578dfb1865448eec$export$fdb8ab1d7076de4a = (0, $aXXtM.createSelector)((0, $7qdXF.getProject), (project)=>{
    var _project$section;
    return project === null || project === void 0 ? void 0 : (_project$section = project.section) === null || _project$section === void 0 ? void 0 : _project$section.currentProject;
});
const $578dfb1865448eec$export$e1bf094f1cd3bec8 = (0, $aXXtM.createSelector)($578dfb1865448eec$export$fdb8ab1d7076de4a, (0, $7qdXF.getEntities), (key, entities)=>(0, $ga67g.denormalize)(key, (0, $48ZQ3.project), entities));
const $578dfb1865448eec$export$327c9d9fb55ff015 = (0, $aXXtM.createSelector)($578dfb1865448eec$export$e1bf094f1cd3bec8, (project)=>project === null || project === void 0 ? void 0 : project.key);
const $578dfb1865448eec$export$e3c00b20d77a8dca = (0, $aXXtM.createSelector)($578dfb1865448eec$export$e1bf094f1cd3bec8, (project)=>project === null || project === void 0 ? void 0 : project.uuid);
const $578dfb1865448eec$export$bf6ea790759ee971 = (0, $aXXtM.createSelector)($578dfb1865448eec$export$e1bf094f1cd3bec8, (project)=>project === null || project === void 0 ? void 0 : project.workspace);
const $578dfb1865448eec$export$144a4543df070715 = (0, $aXXtM.createSelector)($578dfb1865448eec$export$e1bf094f1cd3bec8, (project)=>{
    var _project$workspace;
    return project === null || project === void 0 ? void 0 : (_project$workspace = project.workspace) === null || _project$workspace === void 0 ? void 0 : _project$workspace.slug;
});
const $578dfb1865448eec$export$3d7a29974c02e22b = (0, $aXXtM.createSelector)($578dfb1865448eec$export$e1bf094f1cd3bec8, (project)=>{
    var _project$workspace2;
    return project === null || project === void 0 ? void 0 : (_project$workspace2 = project.workspace) === null || _project$workspace2 === void 0 ? void 0 : _project$workspace2.uuid;
});
const $578dfb1865448eec$export$3d3236d61b36755e = (0, $aXXtM.createSelector)($578dfb1865448eec$export$e1bf094f1cd3bec8, (project)=>project === null || project === void 0 ? void 0 : project.is_private);
const $578dfb1865448eec$export$ac5d20bc3cc38009 = (0, $aXXtM.createSelector)($578dfb1865448eec$export$e1bf094f1cd3bec8, (currentProject)=>currentProject ? {
        name: currentProject.name,
        links: currentProject.links
    } : {});
const $578dfb1865448eec$export$91d66573ef213493 = (0, $aXXtM.createSelector)((0, $7qdXF.getProject), (project)=>project.section.menuItems);
const $578dfb1865448eec$export$d680deecfd3214a7 = (0, $cQrjH.default)($578dfb1865448eec$export$91d66573ef213493, (_state, pathname, matchUrl)=>({
        pathname: pathname,
        matchUrl: matchUrl
    }), (menuItems, match)=>{
    const { pathname: pathname, matchUrl: matchUrl } = match;
    return (0, $iaicX.findNestedMenuItem)(menuItems, (item)=>{
        const projectSubpath = pathname.slice(matchUrl.length);
        const prefixes = item.matching_url_prefixes || [];
        const itemUrl = item.url.replace(/\/$/, "");
        return pathname === itemUrl || prefixes.some((prefix)=>projectSubpath.startsWith(prefix) || // match if subpath starts with prefix
            pathname.startsWith(itemUrl) && projectSubpath && prefix === "*" || // match if subpath has length and prefix is *
            pathname === prefix // accept override if entire path matches prefix (e.g /some-workspace-name)
        );
    });
})((_state, pathname, matchUrl)=>`${matchUrl}:${pathname}`);

});
parcelRegister("iaicX", function(module, exports) {

$parcel$export(module.exports, "ROOT_MENU_ID", function () { return $6beff06985c86042$export$604d80710850845e; });
$parcel$export(module.exports, "MENU_ITEM_GROUP_TYPE", function () { return $6beff06985c86042$export$98a96b4ad2f58a64; });
$parcel$export(module.exports, "FORGE_MENU_ITEM_TYPE", function () { return $6beff06985c86042$export$861c2f8bb796aa4d; });
$parcel$export(module.exports, "isNestedMenu", function () { return $6beff06985c86042$export$7c9910a169320d71; });
$parcel$export(module.exports, "getFirstMenuItem", function () { return $6beff06985c86042$export$4a775d801a53a1a; });
$parcel$export(module.exports, "createNestedMenu", function () { return $6beff06985c86042$export$9ac620455322921f; });
$parcel$export(module.exports, "findNestedMenuItem", function () { return $6beff06985c86042$export$856cb7d9eb56993e; });
$parcel$export(module.exports, "mapNestedMenuItems", function () { return $6beff06985c86042$export$56eb35f981585ae7; });
$parcel$export(module.exports, "findNestedMenuItemParent", function () { return $6beff06985c86042$export$d769d5fa81033a23; });
$parcel$export(module.exports, "addMenuItemsById", function () { return $6beff06985c86042$export$8f06d55e7fee2caf; });

var $fapR5 = parcelRequire("fapR5");
const $6beff06985c86042$export$604d80710850845e = "__root__"; // Used to create an ID for the menuItems array
const $6beff06985c86042$export$98a96b4ad2f58a64 = "menu_item_group";
const $6beff06985c86042$export$861c2f8bb796aa4d = "forge_menu_item";
const $6beff06985c86042$export$7c9910a169320d71 = (menuItems)=>menuItems[0] && menuItems[0].id === $6beff06985c86042$export$604d80710850845e;
const $6beff06985c86042$var$hasChildren = (item)=>{
    return Array.isArray(item.children) && item.children.length > 0;
};
const $6beff06985c86042$export$4a775d801a53a1a = (menuItem)=>{
    if (menuItem.type === $6beff06985c86042$export$98a96b4ad2f58a64 || $6beff06985c86042$var$hasChildren(menuItem)) return $6beff06985c86042$export$4a775d801a53a1a(menuItem.children[0]);
    else return menuItem;
};
function $6beff06985c86042$export$4ec505c8a841e317(origMenuItem) {
    // we make a deep clone of input menu items to avoid having refs to the same obj
    // in the nested menu item tree, because that could cause inconsistent behaviour
    // on SSR pages vs client side only pages.
    const menuItem = (0, $fapR5.default)(origMenuItem);
    // @ts-ignore TODO: fix noImplicitAny error here
    const createMenu = (menuItems, mainMenuItem)=>menuItems.reduce((items, item)=>{
            if ($6beff06985c86042$var$hasChildren(item)) {
                if (item.type === $6beff06985c86042$export$98a96b4ad2f58a64) return items.concat(createMenu(item.children, mainMenuItem));
                return items.concat($6beff06985c86042$export$4ec505c8a841e317({
                    ...item,
                    parentId: mainMenuItem.id
                }));
            }
            return items;
        }, []);
    if (!menuItem.children || !$6beff06985c86042$var$hasChildren(menuItem)) return [
        menuItem
    ];
    return [
        menuItem,
        ...createMenu(menuItem.children, menuItem)
    ];
}
function $6beff06985c86042$export$9ac620455322921f(menuItems = []) {
    if ($6beff06985c86042$export$7c9910a169320d71(menuItems)) // already a nested menu
    return menuItems;
    return $6beff06985c86042$export$4ec505c8a841e317({
        id: $6beff06985c86042$export$604d80710850845e,
        children: menuItems
    });
}
function $6beff06985c86042$export$856cb7d9eb56993e(menuItems, predicate) {
    let items = menuItems;
    if ($6beff06985c86042$export$7c9910a169320d71(items)) // only need to search root menu
    items = items[0].children;
    for (const item of items){
        if (item.type !== $6beff06985c86042$export$98a96b4ad2f58a64 && !$6beff06985c86042$var$hasChildren(item) && predicate(item)) return item;
        if ($6beff06985c86042$var$hasChildren(item)) {
            const result = $6beff06985c86042$export$856cb7d9eb56993e(item.children, predicate);
            if (result) return result;
        }
    }
    return undefined;
}
function $6beff06985c86042$export$56eb35f981585ae7(menuItems, newItem) {
    return menuItems.map(({ ...item })=>{
        if ($6beff06985c86042$var$hasChildren(item)) item.children = $6beff06985c86042$export$56eb35f981585ae7(item.children, newItem);
        if (item.type === $6beff06985c86042$export$98a96b4ad2f58a64) return item;
        return newItem(item);
    });
}
function $6beff06985c86042$export$d769d5fa81033a23(menuItems, menuItem) {
    for(let i = menuItems.length - 1; i >= 0; i--){
        const menu = menuItems[i];
        if (menu.type !== $6beff06985c86042$export$98a96b4ad2f58a64 && $6beff06985c86042$var$hasChildren(menu) && $6beff06985c86042$export$856cb7d9eb56993e(menu.children, (item)=>item.id === menuItem.id)) return menu;
    }
    return undefined;
}
/**
 * Find the menu item node(s) that has the provided `id`
 * @param menuItems a nested list of menu items we are looking through
 * @param id the id we are looking for
 * @returns MenuItem(s) with the provided `id` or empty list if the menu item could not be found
 */ function $6beff06985c86042$var$findMenuItemsById(menuItems, id) {
    const allMatching = [];
    for (const item of menuItems){
        if (item.type !== $6beff06985c86042$export$98a96b4ad2f58a64 && item.id === id) allMatching.push(item);
        if ($6beff06985c86042$var$hasChildren(item)) {
            const found = $6beff06985c86042$var$findMenuItemsById(item.children, id);
            allMatching.push(...found);
        }
    }
    return allMatching;
}
function $6beff06985c86042$export$8f06d55e7fee2caf(currMenuItems, id, menuItemsToAdd) {
    const newMenuItems = (0, $fapR5.default)(currMenuItems);
    const matchingMenuItems = $6beff06985c86042$var$findMenuItemsById(newMenuItems, id);
    matchingMenuItems.forEach((menuItem)=>menuItem.children.push(...menuItemsToAdd));
    return newMenuItems;
}

});
parcelRegister("fapR5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0abd88170f74c34$export$2e2bcd8739ae039; });

var $5Ng8I = parcelRequire("5Ng8I");
/** Used to compose bitmasks for cloning. */ var $b0abd88170f74c34$var$CLONE_DEEP_FLAG = 1, $b0abd88170f74c34$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $b0abd88170f74c34$var$cloneDeep(value) {
    return (0, $5Ng8I.default)(value, $b0abd88170f74c34$var$CLONE_DEEP_FLAG | $b0abd88170f74c34$var$CLONE_SYMBOLS_FLAG);
}
var $b0abd88170f74c34$export$2e2bcd8739ae039 = $b0abd88170f74c34$var$cloneDeep;

});
parcelRegister("5Ng8I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $437e0c5ba35e8a70$export$2e2bcd8739ae039; });

var $9FAVP = parcelRequire("9FAVP");

var $63mvu = parcelRequire("63mvu");

var $lS6Qg = parcelRequire("lS6Qg");

var $ldg8R = parcelRequire("ldg8R");

var $4hU0v = parcelRequire("4hU0v");

var $7MC22 = parcelRequire("7MC22");

var $17hbZ = parcelRequire("17hbZ");

var $3GM9T = parcelRequire("3GM9T");

var $iktFo = parcelRequire("iktFo");

var $8EJgn = parcelRequire("8EJgn");

var $kksWN = parcelRequire("kksWN");

var $jFSoh = parcelRequire("jFSoh");

var $1OCEH = parcelRequire("1OCEH");

var $4dowY = parcelRequire("4dowY");

var $fU3gg = parcelRequire("fU3gg");

var $dEaOb = parcelRequire("dEaOb");

var $3CsZM = parcelRequire("3CsZM");

var $2OzUi = parcelRequire("2OzUi");

var $bmzpf = parcelRequire("bmzpf");

var $enVhu = parcelRequire("enVhu");

var $d3taP = parcelRequire("d3taP");

var $a8rEz = parcelRequire("a8rEz");
/** Used to compose bitmasks for cloning. */ var $437e0c5ba35e8a70$var$CLONE_DEEP_FLAG = 1, $437e0c5ba35e8a70$var$CLONE_FLAT_FLAG = 2, $437e0c5ba35e8a70$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $437e0c5ba35e8a70$var$argsTag = "[object Arguments]", $437e0c5ba35e8a70$var$arrayTag = "[object Array]", $437e0c5ba35e8a70$var$boolTag = "[object Boolean]", $437e0c5ba35e8a70$var$dateTag = "[object Date]", $437e0c5ba35e8a70$var$errorTag = "[object Error]", $437e0c5ba35e8a70$var$funcTag = "[object Function]", $437e0c5ba35e8a70$var$genTag = "[object GeneratorFunction]", $437e0c5ba35e8a70$var$mapTag = "[object Map]", $437e0c5ba35e8a70$var$numberTag = "[object Number]", $437e0c5ba35e8a70$var$objectTag = "[object Object]", $437e0c5ba35e8a70$var$regexpTag = "[object RegExp]", $437e0c5ba35e8a70$var$setTag = "[object Set]", $437e0c5ba35e8a70$var$stringTag = "[object String]", $437e0c5ba35e8a70$var$symbolTag = "[object Symbol]", $437e0c5ba35e8a70$var$weakMapTag = "[object WeakMap]";
var $437e0c5ba35e8a70$var$arrayBufferTag = "[object ArrayBuffer]", $437e0c5ba35e8a70$var$dataViewTag = "[object DataView]", $437e0c5ba35e8a70$var$float32Tag = "[object Float32Array]", $437e0c5ba35e8a70$var$float64Tag = "[object Float64Array]", $437e0c5ba35e8a70$var$int8Tag = "[object Int8Array]", $437e0c5ba35e8a70$var$int16Tag = "[object Int16Array]", $437e0c5ba35e8a70$var$int32Tag = "[object Int32Array]", $437e0c5ba35e8a70$var$uint8Tag = "[object Uint8Array]", $437e0c5ba35e8a70$var$uint8ClampedTag = "[object Uint8ClampedArray]", $437e0c5ba35e8a70$var$uint16Tag = "[object Uint16Array]", $437e0c5ba35e8a70$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $437e0c5ba35e8a70$var$cloneableTags = {};
$437e0c5ba35e8a70$var$cloneableTags[$437e0c5ba35e8a70$var$argsTag] = $437e0c5ba35e8a70$var$cloneableTags[$437e0c5ba35e8a70$var$arrayTag] = $437e0c5ba35e8a70$var$cloneableTags[$437e0c5ba35e8a70$var$arrayBufferTag] = $437e0c5ba35e8a70$var$cloneableTags[$437e0c5ba35e8a70$var$dataViewTag] = $437e0c5ba35e8a70$var$cloneableTags[$437e0c5ba35e8a70$var$boolTag] = $437e0c5ba35e8a70$var$cloneableTags[$437e0c5ba35e8a70$var$dateTag] = $437e0c5ba35e8a70$var$cloneableTags[$437e0c5ba35e8a70$var$float32Tag] = $437e0c5ba35e8a70$var$cloneableTags[$437e0c5ba35e8a70$var$float64Tag] = $437e0c5ba35e8a70$var$cloneableTags[$437e0c5ba35e8a70$var$int8Tag] = $437e0c5ba35e8a70$var$cloneableTags[$437e0c5ba35e8a70$var$int16Tag] = $437e0c5ba35e8a70$var$cloneableTags[$437e0c5ba35e8a70$var$int32Tag] = $437e0c5ba35e8a70$var$cloneableTags[$437e0c5ba35e8a70$var$mapTag] = $437e0c5ba35e8a70$var$cloneableTags[$437e0c5ba35e8a70$var$numberTag] = $437e0c5ba35e8a70$var$cloneableTags[$437e0c5ba35e8a70$var$objectTag] = $437e0c5ba35e8a70$var$cloneableTags[$437e0c5ba35e8a70$var$regexpTag] = $437e0c5ba35e8a70$var$cloneableTags[$437e0c5ba35e8a70$var$setTag] = $437e0c5ba35e8a70$var$cloneableTags[$437e0c5ba35e8a70$var$stringTag] = $437e0c5ba35e8a70$var$cloneableTags[$437e0c5ba35e8a70$var$symbolTag] = $437e0c5ba35e8a70$var$cloneableTags[$437e0c5ba35e8a70$var$uint8Tag] = $437e0c5ba35e8a70$var$cloneableTags[$437e0c5ba35e8a70$var$uint8ClampedTag] = $437e0c5ba35e8a70$var$cloneableTags[$437e0c5ba35e8a70$var$uint16Tag] = $437e0c5ba35e8a70$var$cloneableTags[$437e0c5ba35e8a70$var$uint32Tag] = true;
$437e0c5ba35e8a70$var$cloneableTags[$437e0c5ba35e8a70$var$errorTag] = $437e0c5ba35e8a70$var$cloneableTags[$437e0c5ba35e8a70$var$funcTag] = $437e0c5ba35e8a70$var$cloneableTags[$437e0c5ba35e8a70$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $437e0c5ba35e8a70$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $437e0c5ba35e8a70$var$CLONE_DEEP_FLAG, isFlat = bitmask & $437e0c5ba35e8a70$var$CLONE_FLAT_FLAG, isFull = bitmask & $437e0c5ba35e8a70$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $bmzpf.default)(value)) return value;
    var isArr = (0, $dEaOb.default)(value);
    if (isArr) {
        result = (0, $1OCEH.default)(value);
        if (!isDeep) return (0, $17hbZ.default)(value, result);
    } else {
        var tag = (0, $jFSoh.default)(value), isFunc = tag == $437e0c5ba35e8a70$var$funcTag || tag == $437e0c5ba35e8a70$var$genTag;
        if ((0, $3CsZM.default)(value)) return (0, $7MC22.default)(value, isDeep);
        if (tag == $437e0c5ba35e8a70$var$objectTag || tag == $437e0c5ba35e8a70$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $fU3gg.default)(value);
            if (!isDeep) return isFlat ? (0, $iktFo.default)(value, (0, $4hU0v.default)(result, value)) : (0, $3GM9T.default)(value, (0, $ldg8R.default)(result, value));
        } else {
            if (!$437e0c5ba35e8a70$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $4dowY.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $9FAVP.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $enVhu.default)(value)) value.forEach(function(subValue) {
        result.add($437e0c5ba35e8a70$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $2OzUi.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $437e0c5ba35e8a70$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $kksWN.default) : (0, $8EJgn.default) : isFlat ? (0, $a8rEz.default) : (0, $d3taP.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $63mvu.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $lS6Qg.default)(result, key, $437e0c5ba35e8a70$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $437e0c5ba35e8a70$export$2e2bcd8739ae039 = $437e0c5ba35e8a70$var$baseClone;

});
parcelRegister("63mvu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46847b4b5802aa3c$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $46847b4b5802aa3c$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $46847b4b5802aa3c$export$2e2bcd8739ae039 = $46847b4b5802aa3c$var$arrayEach;

});

parcelRegister("lS6Qg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fec3f2cfe2c56c83$export$2e2bcd8739ae039; });

var $6x2Ar = parcelRequire("6x2Ar");

var $i9zf9 = parcelRequire("i9zf9");
/** Used for built-in method references. */ var $fec3f2cfe2c56c83$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fec3f2cfe2c56c83$var$hasOwnProperty = $fec3f2cfe2c56c83$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $fec3f2cfe2c56c83$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($fec3f2cfe2c56c83$var$hasOwnProperty.call(object, key) && (0, $i9zf9.default)(objValue, value)) || value === undefined && !(key in object)) (0, $6x2Ar.default)(object, key, value);
}
var $fec3f2cfe2c56c83$export$2e2bcd8739ae039 = $fec3f2cfe2c56c83$var$assignValue;

});
parcelRegister("6x2Ar", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c17d4d6ac0d6e5a$export$2e2bcd8739ae039; });

var $2BD2c = parcelRequire("2BD2c");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $4c17d4d6ac0d6e5a$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && (0, $2BD2c.default)) (0, $2BD2c.default)(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
var $4c17d4d6ac0d6e5a$export$2e2bcd8739ae039 = $4c17d4d6ac0d6e5a$var$baseAssignValue;

});
parcelRegister("2BD2c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e5d50ec38814d38$export$2e2bcd8739ae039; });

var $iCjVJ = parcelRequire("iCjVJ");
var $1e5d50ec38814d38$var$defineProperty = function() {
    try {
        var func = (0, $iCjVJ.default)(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
var $1e5d50ec38814d38$export$2e2bcd8739ae039 = $1e5d50ec38814d38$var$defineProperty;

});



parcelRegister("ldg8R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f717554d7c883fc8$export$2e2bcd8739ae039; });

var $bSXSS = parcelRequire("bSXSS");

var $d3taP = parcelRequire("d3taP");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $f717554d7c883fc8$var$baseAssign(object, source) {
    return object && (0, $bSXSS.default)(source, (0, $d3taP.default)(source), object);
}
var $f717554d7c883fc8$export$2e2bcd8739ae039 = $f717554d7c883fc8$var$baseAssign;

});
parcelRegister("bSXSS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a73309205032483$export$2e2bcd8739ae039; });

var $lS6Qg = parcelRequire("lS6Qg");

var $6x2Ar = parcelRequire("6x2Ar");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $8a73309205032483$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $6x2Ar.default)(object, key, newValue);
        else (0, $lS6Qg.default)(object, key, newValue);
    }
    return object;
}
var $8a73309205032483$export$2e2bcd8739ae039 = $8a73309205032483$var$copyObject;

});


parcelRegister("4hU0v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31f431ca9e2ea632$export$2e2bcd8739ae039; });

var $bSXSS = parcelRequire("bSXSS");

var $a8rEz = parcelRequire("a8rEz");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $31f431ca9e2ea632$var$baseAssignIn(object, source) {
    return object && (0, $bSXSS.default)(source, (0, $a8rEz.default)(source), object);
}
var $31f431ca9e2ea632$export$2e2bcd8739ae039 = $31f431ca9e2ea632$var$baseAssignIn;

});
parcelRegister("a8rEz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76101a202b81e573$export$2e2bcd8739ae039; });

var $K4pmn = parcelRequire("K4pmn");

var $oXiee = parcelRequire("oXiee");

var $l3LBL = parcelRequire("l3LBL");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $76101a202b81e573$var$keysIn(object) {
    return (0, $l3LBL.default)(object) ? (0, $K4pmn.default)(object, true) : (0, $oXiee.default)(object);
}
var $76101a202b81e573$export$2e2bcd8739ae039 = $76101a202b81e573$var$keysIn;

});
parcelRegister("oXiee", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04b03c5ca68f1d41$export$2e2bcd8739ae039; });

var $bmzpf = parcelRequire("bmzpf");

var $lt0RS = parcelRequire("lt0RS");

var $370uq = parcelRequire("370uq");
/** Used for built-in method references. */ var $04b03c5ca68f1d41$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $04b03c5ca68f1d41$var$hasOwnProperty = $04b03c5ca68f1d41$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $04b03c5ca68f1d41$var$baseKeysIn(object) {
    if (!(0, $bmzpf.default)(object)) return (0, $370uq.default)(object);
    var isProto = (0, $lt0RS.default)(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$04b03c5ca68f1d41$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $04b03c5ca68f1d41$export$2e2bcd8739ae039 = $04b03c5ca68f1d41$var$baseKeysIn;

});
parcelRegister("370uq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $244267d1336970d9$export$2e2bcd8739ae039; });
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $244267d1336970d9$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $244267d1336970d9$export$2e2bcd8739ae039 = $244267d1336970d9$var$nativeKeysIn;

});




parcelRegister("7MC22", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5aaa8470b47521c0$export$2e2bcd8739ae039; });

var $8kDqY = parcelRequire("8kDqY");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $8kDqY.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $5aaa8470b47521c0$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("17hbZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d03c7f28ce56feb$export$2e2bcd8739ae039; });
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $0d03c7f28ce56feb$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $0d03c7f28ce56feb$export$2e2bcd8739ae039 = $0d03c7f28ce56feb$var$copyArray;

});

parcelRegister("3GM9T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2afaa6a57bc70a32$export$2e2bcd8739ae039; });

var $bSXSS = parcelRequire("bSXSS");

var $3i0FT = parcelRequire("3i0FT");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $2afaa6a57bc70a32$var$copySymbols(source, object) {
    return (0, $bSXSS.default)(source, (0, $3i0FT.default)(source), object);
}
var $2afaa6a57bc70a32$export$2e2bcd8739ae039 = $2afaa6a57bc70a32$var$copySymbols;

});

parcelRegister("iktFo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5811b68ec28a561$export$2e2bcd8739ae039; });

var $bSXSS = parcelRequire("bSXSS");

var $exgTy = parcelRequire("exgTy");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $d5811b68ec28a561$var$copySymbolsIn(source, object) {
    return (0, $bSXSS.default)(source, (0, $exgTy.default)(source), object);
}
var $d5811b68ec28a561$export$2e2bcd8739ae039 = $d5811b68ec28a561$var$copySymbolsIn;

});
parcelRegister("exgTy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a95140c5a8e934b5$export$2e2bcd8739ae039; });

var $j5Xkb = parcelRequire("j5Xkb");

var $j8Kvr = parcelRequire("j8Kvr");

var $3i0FT = parcelRequire("3i0FT");

var $adstn = parcelRequire("adstn");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a95140c5a8e934b5$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $a95140c5a8e934b5$var$getSymbolsIn = !$a95140c5a8e934b5$var$nativeGetSymbols ? (0, $adstn.default) : function(object) {
    var result = [];
    while(object){
        (0, $j5Xkb.default)(result, (0, $3i0FT.default)(object));
        object = (0, $j8Kvr.default)(object);
    }
    return result;
};
var $a95140c5a8e934b5$export$2e2bcd8739ae039 = $a95140c5a8e934b5$var$getSymbolsIn;

});


parcelRegister("kksWN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eccc2142a494b0f5$export$2e2bcd8739ae039; });

var $9ZbiF = parcelRequire("9ZbiF");

var $exgTy = parcelRequire("exgTy");

var $a8rEz = parcelRequire("a8rEz");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $eccc2142a494b0f5$var$getAllKeysIn(object) {
    return (0, $9ZbiF.default)(object, (0, $a8rEz.default), (0, $exgTy.default));
}
var $eccc2142a494b0f5$export$2e2bcd8739ae039 = $eccc2142a494b0f5$var$getAllKeysIn;

});

parcelRegister("1OCEH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1528721df825b139$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $1528721df825b139$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1528721df825b139$var$hasOwnProperty = $1528721df825b139$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $1528721df825b139$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $1528721df825b139$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $1528721df825b139$export$2e2bcd8739ae039 = $1528721df825b139$var$initCloneArray;

});

parcelRegister("4dowY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $311b67a73d32b080$export$2e2bcd8739ae039; });

var $58kot = parcelRequire("58kot");

var $jI5T6 = parcelRequire("jI5T6");

var $47L8M = parcelRequire("47L8M");

var $8mf0Z = parcelRequire("8mf0Z");

var $8akCi = parcelRequire("8akCi");
/** `Object#toString` result references. */ var $311b67a73d32b080$var$boolTag = "[object Boolean]", $311b67a73d32b080$var$dateTag = "[object Date]", $311b67a73d32b080$var$mapTag = "[object Map]", $311b67a73d32b080$var$numberTag = "[object Number]", $311b67a73d32b080$var$regexpTag = "[object RegExp]", $311b67a73d32b080$var$setTag = "[object Set]", $311b67a73d32b080$var$stringTag = "[object String]", $311b67a73d32b080$var$symbolTag = "[object Symbol]";
var $311b67a73d32b080$var$arrayBufferTag = "[object ArrayBuffer]", $311b67a73d32b080$var$dataViewTag = "[object DataView]", $311b67a73d32b080$var$float32Tag = "[object Float32Array]", $311b67a73d32b080$var$float64Tag = "[object Float64Array]", $311b67a73d32b080$var$int8Tag = "[object Int8Array]", $311b67a73d32b080$var$int16Tag = "[object Int16Array]", $311b67a73d32b080$var$int32Tag = "[object Int32Array]", $311b67a73d32b080$var$uint8Tag = "[object Uint8Array]", $311b67a73d32b080$var$uint8ClampedTag = "[object Uint8ClampedArray]", $311b67a73d32b080$var$uint16Tag = "[object Uint16Array]", $311b67a73d32b080$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $311b67a73d32b080$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $311b67a73d32b080$var$arrayBufferTag:
            return (0, $58kot.default)(object);
        case $311b67a73d32b080$var$boolTag:
        case $311b67a73d32b080$var$dateTag:
            return new Ctor(+object);
        case $311b67a73d32b080$var$dataViewTag:
            return (0, $jI5T6.default)(object, isDeep);
        case $311b67a73d32b080$var$float32Tag:
        case $311b67a73d32b080$var$float64Tag:
        case $311b67a73d32b080$var$int8Tag:
        case $311b67a73d32b080$var$int16Tag:
        case $311b67a73d32b080$var$int32Tag:
        case $311b67a73d32b080$var$uint8Tag:
        case $311b67a73d32b080$var$uint8ClampedTag:
        case $311b67a73d32b080$var$uint16Tag:
        case $311b67a73d32b080$var$uint32Tag:
            return (0, $8akCi.default)(object, isDeep);
        case $311b67a73d32b080$var$mapTag:
            return new Ctor;
        case $311b67a73d32b080$var$numberTag:
        case $311b67a73d32b080$var$stringTag:
            return new Ctor(object);
        case $311b67a73d32b080$var$regexpTag:
            return (0, $47L8M.default)(object);
        case $311b67a73d32b080$var$setTag:
            return new Ctor;
        case $311b67a73d32b080$var$symbolTag:
            return (0, $8mf0Z.default)(object);
    }
}
var $311b67a73d32b080$export$2e2bcd8739ae039 = $311b67a73d32b080$var$initCloneByTag;

});
parcelRegister("58kot", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bcd84dd95ace257$export$2e2bcd8739ae039; });

var $lqrK9 = parcelRequire("lqrK9");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $3bcd84dd95ace257$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $lqrK9.default)(result).set(new (0, $lqrK9.default)(arrayBuffer));
    return result;
}
var $3bcd84dd95ace257$export$2e2bcd8739ae039 = $3bcd84dd95ace257$var$cloneArrayBuffer;

});

parcelRegister("jI5T6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e596b18e63a0ead9$export$2e2bcd8739ae039; });

var $58kot = parcelRequire("58kot");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $e596b18e63a0ead9$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $58kot.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $e596b18e63a0ead9$export$2e2bcd8739ae039 = $e596b18e63a0ead9$var$cloneDataView;

});

parcelRegister("47L8M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $300c620851140d24$export$2e2bcd8739ae039; });
/** Used to match `RegExp` flags from their coerced string values. */ var $300c620851140d24$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $300c620851140d24$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $300c620851140d24$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $300c620851140d24$export$2e2bcd8739ae039 = $300c620851140d24$var$cloneRegExp;

});

parcelRegister("8mf0Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $615c06714c71a9e3$export$2e2bcd8739ae039; });

var $jici1 = parcelRequire("jici1");
/** Used to convert symbols to primitives and strings. */ var $615c06714c71a9e3$var$symbolProto = (0, $jici1.default) ? (0, $jici1.default).prototype : undefined, $615c06714c71a9e3$var$symbolValueOf = $615c06714c71a9e3$var$symbolProto ? $615c06714c71a9e3$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $615c06714c71a9e3$var$cloneSymbol(symbol) {
    return $615c06714c71a9e3$var$symbolValueOf ? Object($615c06714c71a9e3$var$symbolValueOf.call(symbol)) : {};
}
var $615c06714c71a9e3$export$2e2bcd8739ae039 = $615c06714c71a9e3$var$cloneSymbol;

});

parcelRegister("8akCi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f1f3ff63841bff1$export$2e2bcd8739ae039; });

var $58kot = parcelRequire("58kot");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $5f1f3ff63841bff1$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $58kot.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $5f1f3ff63841bff1$export$2e2bcd8739ae039 = $5f1f3ff63841bff1$var$cloneTypedArray;

});


parcelRegister("fU3gg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b93e9da0fc019010$export$2e2bcd8739ae039; });

var $53bQM = parcelRequire("53bQM");

var $j8Kvr = parcelRequire("j8Kvr");

var $lt0RS = parcelRequire("lt0RS");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $b93e9da0fc019010$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !(0, $lt0RS.default)(object) ? (0, $53bQM.default)((0, $j8Kvr.default)(object)) : {};
}
var $b93e9da0fc019010$export$2e2bcd8739ae039 = $b93e9da0fc019010$var$initCloneObject;

});
parcelRegister("53bQM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ad66cc232ffa188$export$2e2bcd8739ae039; });

var $bmzpf = parcelRequire("bmzpf");
/** Built-in value references. */ var $3ad66cc232ffa188$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $3ad66cc232ffa188$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $bmzpf.default)(proto)) return {};
        if ($3ad66cc232ffa188$var$objectCreate) return $3ad66cc232ffa188$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $3ad66cc232ffa188$export$2e2bcd8739ae039 = $3ad66cc232ffa188$var$baseCreate;

});


parcelRegister("2OzUi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20cc1aa641703bab$export$2e2bcd8739ae039; });

var $lliko = parcelRequire("lliko");

var $3TlFX = parcelRequire("3TlFX");

var $53WMN = parcelRequire("53WMN");
/* Node.js helper references. */ var $20cc1aa641703bab$var$nodeIsMap = (0, $53WMN.default) && (0, $53WMN.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $20cc1aa641703bab$var$isMap = $20cc1aa641703bab$var$nodeIsMap ? (0, $3TlFX.default)($20cc1aa641703bab$var$nodeIsMap) : (0, $lliko.default);
var $20cc1aa641703bab$export$2e2bcd8739ae039 = $20cc1aa641703bab$var$isMap;

});
parcelRegister("lliko", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f899c6b469e14f51$export$2e2bcd8739ae039; });

var $jFSoh = parcelRequire("jFSoh");

var $bqTHd = parcelRequire("bqTHd");
/** `Object#toString` result references. */ var $f899c6b469e14f51$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $f899c6b469e14f51$var$baseIsMap(value) {
    return (0, $bqTHd.default)(value) && (0, $jFSoh.default)(value) == $f899c6b469e14f51$var$mapTag;
}
var $f899c6b469e14f51$export$2e2bcd8739ae039 = $f899c6b469e14f51$var$baseIsMap;

});


parcelRegister("enVhu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a78fa57cab5a623a$export$2e2bcd8739ae039; });

var $87OHO = parcelRequire("87OHO");

var $3TlFX = parcelRequire("3TlFX");

var $53WMN = parcelRequire("53WMN");
/* Node.js helper references. */ var $a78fa57cab5a623a$var$nodeIsSet = (0, $53WMN.default) && (0, $53WMN.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $a78fa57cab5a623a$var$isSet = $a78fa57cab5a623a$var$nodeIsSet ? (0, $3TlFX.default)($a78fa57cab5a623a$var$nodeIsSet) : (0, $87OHO.default);
var $a78fa57cab5a623a$export$2e2bcd8739ae039 = $a78fa57cab5a623a$var$isSet;

});
parcelRegister("87OHO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ea64f3d12d0a152$export$2e2bcd8739ae039; });

var $jFSoh = parcelRequire("jFSoh");

var $bqTHd = parcelRequire("bqTHd");
/** `Object#toString` result references. */ var $5ea64f3d12d0a152$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $5ea64f3d12d0a152$var$baseIsSet(value) {
    return (0, $bqTHd.default)(value) && (0, $jFSoh.default)(value) == $5ea64f3d12d0a152$var$setTag;
}
var $5ea64f3d12d0a152$export$2e2bcd8739ae039 = $5ea64f3d12d0a152$var$baseIsSet;

});





parcelRegister("48ZQ3", function(module, exports) {

$parcel$export(module.exports, "project", function () { return $c84965b5626b540b$export$ab03b6763ed7026f; });
$parcel$export(module.exports, "repository", function () { return $c84965b5626b540b$export$69a68d0c8baaec49; });

var $ga67g = parcelRequire("ga67g");

var $8saZD = parcelRequire("8saZD");
const $c84965b5626b540b$export$ab03b6763ed7026f = new (0, $ga67g.schema).Entity("projects", {}, {
    idAttribute: "uuid"
});
const $c84965b5626b540b$export$69a68d0c8baaec49 = new (0, $ga67g.schema).Entity("repositories", {
    owner: (0, $8saZD.user),
    project: $c84965b5626b540b$export$ab03b6763ed7026f
}, {
    idAttribute: "uuid"
});

});


parcelRegister("aanBq", function(module, exports) {

$parcel$export(module.exports, "getCurrentRepository", function () { return $9808fd595be1c7e8$export$73f7c7b8f179c0cb; });
$parcel$export(module.exports, "getCurrentRepositorySshCloneLink", function () { return $9808fd595be1c7e8$export$27e57f61bd594483; });
$parcel$export(module.exports, "getRepositoryBranchingModel", function () { return $9808fd595be1c7e8$export$5f8670998867f1ec; });
$parcel$export(module.exports, "getCurrentRepositoryMainBranchName", function () { return $9808fd595be1c7e8$export$c2474d9ec2144e70; });
$parcel$export(module.exports, "getRepositoryMainBranch", function () { return $9808fd595be1c7e8$export$91aef7de11970811; });
$parcel$export(module.exports, "getMenuItems", function () { return $9808fd595be1c7e8$export$91d66573ef213493; });
$parcel$export(module.exports, "getSizeLimits", function () { return $9808fd595be1c7e8$export$91e81f0c9b7cf42; });
$parcel$export(module.exports, "getRepositoryOverrideSettings", function () { return $9808fd595be1c7e8$export$f9e839995841dbb3; });
$parcel$export(module.exports, "getCurrentRepositoryFullSlug", function () { return $9808fd595be1c7e8$export$a95e635d689e347a; });
$parcel$export(module.exports, "getCurrentRepositoryOwnerName", function () { return $9808fd595be1c7e8$export$2eba187fbf522f62; });
$parcel$export(module.exports, "getCurrentRepositoryOwner", function () { return $9808fd595be1c7e8$export$aa4aff2e23e3365; });
$parcel$export(module.exports, "getCurrentRepositoryProjectUuid", function () { return $9808fd595be1c7e8$export$bbf76c627b9f6655; });
$parcel$export(module.exports, "getCurrentRepositoryProjectKey", function () { return $9808fd595be1c7e8$export$57ff9c1f70d0966a; });
$parcel$export(module.exports, "getCurrentRepositorySlug", function () { return $9808fd595be1c7e8$export$d3767c4404b8ca3c; });
$parcel$export(module.exports, "getCurrentRepositoryUuid", function () { return $9808fd595be1c7e8$export$5685e4709262c6c1; });
$parcel$export(module.exports, "getRecentlyViewedRepositories", function () { return $9808fd595be1c7e8$export$8cc34d52f227ca1a; });
$parcel$export(module.exports, "getRecentlyViewedRepositoryCount", function () { return $9808fd595be1c7e8$export$c3195f992ba57348; });
$parcel$export(module.exports, "getCurrentRepoWorkspaceSlug", function () { return $9808fd595be1c7e8$export$c8501e7d80104467; });
$parcel$export(module.exports, "getRepositoryDetails", function () { return $9808fd595be1c7e8$export$1a307f8a8e68c062; });
$parcel$export(module.exports, "getIsPipelinesEnabledLoadingState", function () { return $9808fd595be1c7e8$export$fcbfb8d2a6b16a58; });
$parcel$export(module.exports, "getIsPipelinesEnabled", function () { return $9808fd595be1c7e8$export$4c4caf979a30e20e; });
$parcel$export(module.exports, "getIsPipelinesPremium", function () { return $9808fd595be1c7e8$export$934fee9369695d78; });
$parcel$export(module.exports, "getRepositoryGrantedAccess", function () { return $9808fd595be1c7e8$export$e338918b6e4af385; });
$parcel$export(module.exports, "getRepositoryAccessLevel", function () { return $9808fd595be1c7e8$export$d2c176e85dda69b8; });
$parcel$export(module.exports, "getIsRepositoryWorkspaceAdmin", function () { return $9808fd595be1c7e8$export$56a430ab4552b16b; });
$parcel$export(module.exports, "getRepositoryMirrors", function () { return $9808fd595be1c7e8$export$a2231f77bc361af1; });
$parcel$export(module.exports, "getRepositorySourceTreeHasXcode", function () { return $9808fd595be1c7e8$export$6be39d2496611097; });
$parcel$export(module.exports, "isSyncDialogOpen", function () { return $9808fd595be1c7e8$export$9f354182e3f93b3b; });
$parcel$export(module.exports, "getSelectedMenuItem", function () { return $9808fd595be1c7e8$export$d680deecfd3214a7; });
$parcel$export(module.exports, "getRepoSettingsData", function () { return $9808fd595be1c7e8$export$c03121a8a7ddc44c; });
$parcel$export(module.exports, "getRepositoryAvatar", function () { return $9808fd595be1c7e8$export$b2f8110ea721a842; });
$parcel$export(module.exports, "getXferStatus", function () { return $9808fd595be1c7e8$export$1af8727e3aef4efb; });
$parcel$export(module.exports, "getCurrentRepositoryForkCount", function () { return $9808fd595be1c7e8$export$981bb257293c140b; });
$parcel$export(module.exports, "getCurrentRepositoryName", function () { return $9808fd595be1c7e8$export$88ebc33e72488844; });
$parcel$export(module.exports, "getCurrentRepositoryWorkspace", function () { return $9808fd595be1c7e8$export$65252a50e382c8ac; });
$parcel$export(module.exports, "getCurrentRepositoryWorkspaceUUID", function () { return $9808fd595be1c7e8$export$300b0e41db1f3ab0; });
$parcel$export(module.exports, "getIsCurrentRepositoryPrivate", function () { return $9808fd595be1c7e8$export$89f80ef81c25fb71; });
$parcel$export(module.exports, "getCurrentRepositoryLinkData", function () { return $9808fd595be1c7e8$export$7599ec95ee6fffd2; });

var $lIZwG = parcelRequire("lIZwG");

var $ga67g = parcelRequire("ga67g");

var $ekw8F = parcelRequire("ekw8F");

var $cQrjH = parcelRequire("cQrjH");

var $aXXtM = parcelRequire("aXXtM");

var $iaicX = parcelRequire("iaicX");

var $iHsg5 = parcelRequire("iHsg5");

var $48ZQ3 = parcelRequire("48ZQ3");

var $cNPHM = parcelRequire("cNPHM");

var $7qdXF = parcelRequire("7qdXF");
const $9808fd595be1c7e8$var$getCurrentRepositoryKey = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (repository)=>repository && repository.section && repository.section.currentRepository);
const $9808fd595be1c7e8$export$73f7c7b8f179c0cb = (0, $aXXtM.createSelector)($9808fd595be1c7e8$var$getCurrentRepositoryKey, (0, $7qdXF.getEntities), (key, entities)=>(0, $ga67g.denormalize)(key, (0, $48ZQ3.repository), entities));
const $9808fd595be1c7e8$export$27e57f61bd594483 = (0, $aXXtM.createSelector)($9808fd595be1c7e8$export$73f7c7b8f179c0cb, (repo)=>{
    if (!repo) return null;
    return repo.links.clone[1].href;
});
const $9808fd595be1c7e8$export$5f8670998867f1ec = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (repository)=>repository.branches.branchList.branchingModel);
const $9808fd595be1c7e8$export$c2474d9ec2144e70 = (0, $aXXtM.createSelector)($9808fd595be1c7e8$export$73f7c7b8f179c0cb, (currentRepository)=>currentRepository && currentRepository.mainbranch ? currentRepository.mainbranch.name : undefined);
const $9808fd595be1c7e8$export$91aef7de11970811 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (repository)=>repository.details.mainBranch);
const $9808fd595be1c7e8$export$91d66573ef213493 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (repository)=>repository.section.menuItems);
const $9808fd595be1c7e8$export$91e81f0c9b7cf42 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (repository)=>repository.section.sizeLimits);
const $9808fd595be1c7e8$export$f9e839995841dbb3 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (repository)=>{
    var _repository$section;
    return (repository === null || repository === void 0 ? void 0 : (_repository$section = repository.section) === null || _repository$section === void 0 ? void 0 : _repository$section.overrideSettings) || {};
});
const $9808fd595be1c7e8$export$a95e635d689e347a = (0, $aXXtM.createSelector)($9808fd595be1c7e8$export$73f7c7b8f179c0cb, (currentRepository)=>currentRepository ? currentRepository.full_name : null);
const $9808fd595be1c7e8$export$2eba187fbf522f62 = (0, $aXXtM.createSelector)($9808fd595be1c7e8$export$73f7c7b8f179c0cb, (currentRepository)=>currentRepository ? currentRepository.full_name.split("/")[0] : "");
const $9808fd595be1c7e8$export$aa4aff2e23e3365 = (0, $aXXtM.createSelector)($9808fd595be1c7e8$export$73f7c7b8f179c0cb, (currentRepository)=>currentRepository ? currentRepository.owner : null);
const $9808fd595be1c7e8$export$bbf76c627b9f6655 = (0, $aXXtM.createSelector)($9808fd595be1c7e8$export$73f7c7b8f179c0cb, (currentRepository)=>{
    var _currentRepository$pr;
    return (currentRepository === null || currentRepository === void 0 ? void 0 : (_currentRepository$pr = currentRepository.project) === null || _currentRepository$pr === void 0 ? void 0 : _currentRepository$pr.uuid) || null;
});
const $9808fd595be1c7e8$export$57ff9c1f70d0966a = (0, $aXXtM.createSelector)($9808fd595be1c7e8$export$73f7c7b8f179c0cb, (currentRepository)=>{
    var _currentRepository$pr2;
    return (currentRepository === null || currentRepository === void 0 ? void 0 : (_currentRepository$pr2 = currentRepository.project) === null || _currentRepository$pr2 === void 0 ? void 0 : _currentRepository$pr2.key) || null;
});
const $9808fd595be1c7e8$export$d3767c4404b8ca3c = (0, $aXXtM.createSelector)($9808fd595be1c7e8$export$73f7c7b8f179c0cb, (currentRepository)=>currentRepository ? currentRepository.full_name.split("/")[1] : null);
const $9808fd595be1c7e8$export$5685e4709262c6c1 = (0, $aXXtM.createSelector)($9808fd595be1c7e8$export$73f7c7b8f179c0cb, (currentRepository)=>currentRepository ? currentRepository.uuid : null);
const $9808fd595be1c7e8$export$8cc34d52f227ca1a = (0, $aXXtM.createSelector)((0, $7qdXF.getRecentlyViewedRepositoriesKeys), (0, $7qdXF.getEntities), (keys, entities)=>// We might have some UUIDs in redux that map to a model that's pending fetching or that
    // no longer exists, so we filter those results out (that denormalize to `undefined`)
    // @ts-ignore TODO: fix noImplicitAny error here
    (0, $ga67g.denormalize)(keys, [
        (0, $48ZQ3.repository)
    ], entities).filter((entity)=>!!entity));
const $9808fd595be1c7e8$export$c3195f992ba57348 = (0, $aXXtM.createSelector)((0, $7qdXF.getRecentlyViewedRepositoriesKeys), (keys)=>keys.length);
const $9808fd595be1c7e8$export$c8501e7d80104467 = (0, $aXXtM.createSelector)($9808fd595be1c7e8$export$73f7c7b8f179c0cb, (repository)=>{
    var _repository$workspace;
    return repository === null || repository === void 0 ? void 0 : (_repository$workspace = repository.workspace) === null || _repository$workspace === void 0 ? void 0 : _repository$workspace.slug;
});
const $9808fd595be1c7e8$export$1a307f8a8e68c062 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (0, $7qdXF.getEntities), (currentRepository, entities)=>({
        accessLevel: currentRepository.details.accessLevel,
        branchCount: currentRepository.details.branchCount,
        commitsBehindParent: currentRepository.details.commitsBehindParent,
        forkCount: currentRepository.details.forkCount,
        grantedAccess: currentRepository.details.grantedAccess,
        hasError: currentRepository.details.hasError,
        isAccountAdmin: currentRepository.details.isAccountAdmin,
        isLoading: currentRepository.details.isLoading,
        isReadOnly: currentRepository.details.isReadOnly,
        language: currentRepository.details.language,
        lastUpdated: currentRepository.details.lastUpdated,
        openPullRequestCount: currentRepository.details.openPullRequestCount,
        parent: (0, $ga67g.denormalize)(currentRepository.details.parent, (0, $48ZQ3.repository), entities),
        size: currentRepository.details.size,
        watcherCount: currentRepository.details.watcherCount,
        landingPage: currentRepository.details.landingPage,
        analyticsKey: currentRepository.details.analyticsKey,
        lfsHasLimits: currentRepository.details.lfsHasLimits,
        lfsUsage: currentRepository.details.lfsUsage,
        lfsRemaining: currentRepository.details.lfsRemaining,
        xferStatus: currentRepository.details.xferStatus,
        isPipelinesEnabledLoadingState: currentRepository.details.isPipelinesEnabledLoadingState,
        isPipelinesEnabled: currentRepository.details.isPipelinesEnabled,
        isPipelinesPremium: currentRepository.details.isPipelinesPremium,
        pushFileSizeLimitDisabled: currentRepository.details.pushFileSizeLimitDisabled
    }));
const $9808fd595be1c7e8$export$fcbfb8d2a6b16a58 = (0, $aXXtM.createSelector)($9808fd595be1c7e8$export$1a307f8a8e68c062, (repositoryDetails)=>repositoryDetails ? repositoryDetails.isPipelinesEnabledLoadingState : // Default to "loaded" if we don't have a repo available, otherwise
    // the API request URL won't be able to be constructed.
    (0, $iHsg5.PipelinesEnabledLoadingState).Loaded);
const $9808fd595be1c7e8$export$4c4caf979a30e20e = (0, $aXXtM.createSelector)($9808fd595be1c7e8$export$1a307f8a8e68c062, (repositoryDetails)=>repositoryDetails ? repositoryDetails.isPipelinesEnabled : false);
const $9808fd595be1c7e8$export$934fee9369695d78 = (0, $aXXtM.createSelector)($9808fd595be1c7e8$export$1a307f8a8e68c062, (repositoryDetails)=>repositoryDetails ? repositoryDetails.isPipelinesPremium : false);
const $9808fd595be1c7e8$export$e338918b6e4af385 = (0, $aXXtM.createSelector)($9808fd595be1c7e8$export$1a307f8a8e68c062, (repositoryDetails)=>repositoryDetails ? repositoryDetails.grantedAccess : undefined);
const $9808fd595be1c7e8$export$d2c176e85dda69b8 = (0, $aXXtM.createSelector)($9808fd595be1c7e8$export$1a307f8a8e68c062, (repositoryDetails)=>repositoryDetails ? repositoryDetails.accessLevel : undefined);
const $9808fd595be1c7e8$export$56a430ab4552b16b = (0, $aXXtM.createSelector)($9808fd595be1c7e8$export$1a307f8a8e68c062, (repositoryDetails)=>!!(repositoryDetails !== null && repositoryDetails !== void 0 && repositoryDetails.isAccountAdmin));
const $9808fd595be1c7e8$export$a2231f77bc361af1 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (repository)=>repository.section.mirrors);
const $9808fd595be1c7e8$export$6be39d2496611097 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (repository)=>(0, $lIZwG.default)(repository, "source.section.fileTree.tree.contents", []).some(// @ts-ignore TODO: fix noImplicitAny error here
    ({ type: type, name: name })=>type === "directory" && (name.endsWith(".xcodeproj") || name.endsWith(".xcworkspace"))));
const $9808fd595be1c7e8$export$9f354182e3f93b3b = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (repository)=>repository.section.isSyncDialogOpen);
const $9808fd595be1c7e8$var$repoSettingsPathRegex = new RegExp(/^\/[^/]+\/[^/]+\/admin($|\/)/);
const $9808fd595be1c7e8$export$e8f740173c5aa396 = (0, $aXXtM.createSelector)((pathname)=>({
        pathname: pathname
    }), ({ pathname: pathname })=>$9808fd595be1c7e8$var$repoSettingsPathRegex.test(pathname));
const $9808fd595be1c7e8$export$d680deecfd3214a7 = (0, $cQrjH.default)($9808fd595be1c7e8$export$91d66573ef213493, (_state, pathname, matchUrl)=>({
        pathname: pathname,
        matchUrl: matchUrl
    }), (menuItems, { pathname: pathname })=>(0, $iaicX.findNestedMenuItem)(menuItems, (item)=>{
        const prefixes = item.matching_url_prefixes || [];
        const itemUrl = item.url.replace(/\/$/, "");
        // compare the paths after the repoSubpath because repo URLs can be UUIDs or slugs
        const repoPathBase = (0, $ekw8F.pathToRegexp)(`/${(0, $cNPHM.REPO_FULL_SLUG_REGEX)}`, [], {
            end: false
        });
        const normalizedPathname = pathname.replace(repoPathBase, "");
        const normalizedItemUrl = itemUrl.replace(repoPathBase, "");
        const pathNameWithoutTrailingSlash = pathname.replace(/\/$/, "");
        if (item.type === (0, $iaicX.FORGE_MENU_ITEM_TYPE)) // Forge menu item urls are constructed by bitbucket backend
        // (see https://bitbucket.org/bitbucket/core/src/0fec99b2b692b306adfa1033bc224348f6aa5795/apps/forge/menus.py#lines-45),
        // and we expect the path name and item url to be an exact match.
        return pathNameWithoutTrailingSlash === itemUrl;
        else if ($9808fd595be1c7e8$var$repoSettingsPathRegex.test(pathname)) // This conditional checks if the current path is under the admin (settings) section of the repo path structure.
        // The pathname and item url comparison is exact because some of the settings menu item urls are subpaths of the others.
        // It also checks the menu item "matching_url_prefixes" for any menu items which need to be
        // highlighted in the UI for more than one route. e.g. /admin/webhooks and /admin/webhooks/new
        return pathNameWithoutTrailingSlash === itemUrl || pathNameWithoutTrailingSlash.startsWith(itemUrl) && prefixes.some((prefix)=>normalizedPathname.startsWith(prefix));
        else return normalizedPathname.indexOf(normalizedItemUrl) === 0 || prefixes.some((prefix)=>normalizedPathname.startsWith(prefix));
    }))((_state, pathname, matchUrl)=>`${matchUrl}:${pathname}`);
const $9808fd595be1c7e8$export$c03121a8a7ddc44c = (0, $aXXtM.createSelector)($9808fd595be1c7e8$export$73f7c7b8f179c0cb, $9808fd595be1c7e8$export$1a307f8a8e68c062, (currentRepository, details)=>currentRepository ? {
        uuid: currentRepository.uuid,
        name: currentRepository.name,
        slug: currentRepository.slug,
        fullName: currentRepository.full_name,
        project: currentRepository.project,
        description: currentRepository.description,
        isPrivate: currentRepository.is_private,
        forkPolicy: currentRepository.fork_policy,
        language: currentRepository.language,
        mainbranch: currentRepository.mainbranch,
        website: currentRepository.website,
        landingPage: details.landingPage,
        analyticsKey: details.analyticsKey,
        lfsHasLimits: details.lfsHasLimits,
        lfsUsage: details.lfsUsage,
        lfsRemaining: details.lfsRemaining,
        size: details.size,
        pushFileSizeLimitDisabled: details.pushFileSizeLimitDisabled
    } : null);
const $9808fd595be1c7e8$export$b2f8110ea721a842 = (0, $aXXtM.createSelector)($9808fd595be1c7e8$export$73f7c7b8f179c0cb, (currentRepository)=>currentRepository === null || currentRepository === void 0 ? void 0 : currentRepository.links.avatar.href);
const $9808fd595be1c7e8$export$1af8727e3aef4efb = (0, $aXXtM.createSelector)($9808fd595be1c7e8$export$1a307f8a8e68c062, ({ xferStatus: xferStatus })=>xferStatus);
const $9808fd595be1c7e8$export$981bb257293c140b = (0, $aXXtM.createSelector)($9808fd595be1c7e8$export$1a307f8a8e68c062, ({ forkCount: forkCount })=>forkCount);
const $9808fd595be1c7e8$export$88ebc33e72488844 = (0, $aXXtM.createSelector)($9808fd595be1c7e8$export$73f7c7b8f179c0cb, (repo)=>repo === null || repo === void 0 ? void 0 : repo.name);
const $9808fd595be1c7e8$export$65252a50e382c8ac = (0, $aXXtM.createSelector)($9808fd595be1c7e8$export$73f7c7b8f179c0cb, (currentRepository)=>(currentRepository === null || currentRepository === void 0 ? void 0 : currentRepository.workspace) || null);
const $9808fd595be1c7e8$export$300b0e41db1f3ab0 = (0, $aXXtM.createSelector)($9808fd595be1c7e8$export$65252a50e382c8ac, (currentWorkspace)=>(currentWorkspace === null || currentWorkspace === void 0 ? void 0 : currentWorkspace.uuid) || null);
const $9808fd595be1c7e8$export$89f80ef81c25fb71 = (0, $aXXtM.createSelector)($9808fd595be1c7e8$export$73f7c7b8f179c0cb, (currentRepository)=>currentRepository === null || currentRepository === void 0 ? void 0 : currentRepository.is_private);
const $9808fd595be1c7e8$export$7599ec95ee6fffd2 = (0, $aXXtM.createSelector)($9808fd595be1c7e8$export$73f7c7b8f179c0cb, (currentRepository)=>currentRepository ? {
        name: currentRepository.name,
        links: currentRepository.links,
        landingPage: currentRepository.landing_page,
        fullName: currentRepository.full_name
    } : {});

});
parcelRegister("ekw8F", function(module, exports) {

$parcel$export(module.exports, "pathToRegexp", function () { return $a6ebdd07c3c7252b$export$71304158c7e35877; });
/**
 * Tokenize input string.
 */ function $a6ebdd07c3c7252b$var$lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError('Pattern cannot start with "?" at '.concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $a6ebdd07c3c7252b$export$98e6a39c04603d36(str, options) {
    if (options === void 0) options = {};
    var tokens = $a6ebdd07c3c7252b$var$lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a;
    var defaultPattern = "[^".concat($a6ebdd07c3c7252b$var$escapeString(options.delimiter || "/#?"), "]+?");
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || defaultPattern,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? defaultPattern : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $a6ebdd07c3c7252b$export$ef7acd7185315e22(str, options) {
    return $a6ebdd07c3c7252b$export$5b9bad9e403cf3d9($a6ebdd07c3c7252b$export$98e6a39c04603d36(str, options), options);
}
function $a6ebdd07c3c7252b$export$5b9bad9e403cf3d9(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = $a6ebdd07c3c7252b$var$flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError('Expected "'.concat(token.name, '" to not repeat, but got an array'));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError('Expected "'.concat(token.name, '" to not be empty'));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError('Expected all "'.concat(token.name, '" to match "').concat(token.pattern, '", but got "').concat(segment, '"'));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError('Expected "'.concat(token.name, '" to match "').concat(token.pattern, '", but got "').concat(segment, '"'));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError('Expected "'.concat(token.name, '" to be ').concat(typeOfMessage));
        }
        return path;
    };
}
function $a6ebdd07c3c7252b$export$4659b591c19bdf3d(str, options) {
    var keys = [];
    var re = $a6ebdd07c3c7252b$export$71304158c7e35877(str, keys, options);
    return $a6ebdd07c3c7252b$export$968e97c88708237a(re, keys, options);
}
function $a6ebdd07c3c7252b$export$968e97c88708237a(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $a6ebdd07c3c7252b$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $a6ebdd07c3c7252b$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $a6ebdd07c3c7252b$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $a6ebdd07c3c7252b$var$arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return $a6ebdd07c3c7252b$export$71304158c7e35877(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), $a6ebdd07c3c7252b$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $a6ebdd07c3c7252b$var$stringToRegexp(path, keys, options) {
    return $a6ebdd07c3c7252b$export$9a9303716def6456($a6ebdd07c3c7252b$export$98e6a39c04603d36(path, options), keys, options);
}
function $a6ebdd07c3c7252b$export$9a9303716def6456(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat($a6ebdd07c3c7252b$var$escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat($a6ebdd07c3c7252b$var$escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += $a6ebdd07c3c7252b$var$escapeString(encode(token));
        else {
            var prefix = $a6ebdd07c3c7252b$var$escapeString(encode(token.prefix));
            var suffix = $a6ebdd07c3c7252b$var$escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else if (token.modifier === "+" || token.modifier === "*") route += "((?:".concat(token.pattern, ")").concat(token.modifier, ")");
                else route += "(".concat(token.pattern, ")").concat(token.modifier);
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, $a6ebdd07c3c7252b$var$flags(options));
}
function $a6ebdd07c3c7252b$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $a6ebdd07c3c7252b$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $a6ebdd07c3c7252b$var$arrayToRegexp(path, keys, options);
    return $a6ebdd07c3c7252b$var$stringToRegexp(path, keys, options);
}

});

parcelRegister("iHsg5", function(module, exports) {

$parcel$export(module.exports, "initialStateSourceRepository", function () { return $a297d19cfc41f94a$export$e6a268b4c5af7694; });
$parcel$export(module.exports, "PipelinesEnabledLoadingState", function () { return $a297d19cfc41f94a$export$af447f164bddf9be; });
$parcel$export(module.exports, "default", function () { return $a297d19cfc41f94a$export$2e2bcd8739ae039; });

var $gsXeO = parcelRequire("gsXeO");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");
const $a297d19cfc41f94a$export$e6a268b4c5af7694 = {
    accessLevel: undefined
};
var $a297d19cfc41f94a$export$af447f164bddf9be;
(function(PipelinesEnabledLoadingState) {
    PipelinesEnabledLoadingState["NotLoaded"] = "NOT_LOADED";
    PipelinesEnabledLoadingState["Loading"] = "LOADING";
    PipelinesEnabledLoadingState["Error"] = "ERROR";
    PipelinesEnabledLoadingState["Loaded"] = "LOADED";
})($a297d19cfc41f94a$export$af447f164bddf9be || ($a297d19cfc41f94a$export$af447f164bddf9be = {}));
const $a297d19cfc41f94a$var$initialState = {
    hasError: false,
    isLoading: false,
    isWatching: false,
    isPipelinesEnabledLoadingState: "NOT_LOADED",
    isPipelinesEnabled: false,
    isPipelinesPremium: false
};
const $a297d19cfc41f94a$var$resultToDetails = (result)=>({
        accessLevel: result.access_level,
        branchCount: result.branches,
        commitsBehindParent: result.commits_behind_parent,
        forkCount: result.forks,
        grantedAccess: result.granted_access,
        lastUpdated: result.last_updated,
        language: result.language ? result.language.label : undefined,
        openPullRequestCount: result.pullrequests.open,
        parent: result.parent,
        isAccountAdmin: result.is_account_admin,
        isReadOnly: result.read_only,
        isWatching: result.is_watching,
        size: result.size,
        watcherCount: result.watchers,
        analyticsKey: result.analytics_key,
        landingPage: result.landing_page,
        lfsUsage: result.lfs_usage,
        lfsHasLimits: result.lfs_has_limits,
        lfsRemaining: result.lfs_remaining,
        xferStatus: result.xfer_status,
        pushFileSizeLimitDisabled: result.push_file_size_limit_disabled
    });
var $a297d19cfc41f94a$export$2e2bcd8739ae039 = (0, $gsXeO.default)($a297d19cfc41f94a$var$initialState, {
    [(0, $jJd6W.FetchRepositoryDetails).REQUEST] (state) {
        return {
            ...state,
            hasError: false,
            isLoading: true
        };
    },
    [(0, $jJd6W.FetchRepositoryDetails).SUCCESS] (state, action) {
        const { result: result } = action.payload;
        const details = $a297d19cfc41f94a$var$resultToDetails(result);
        return {
            ...state,
            ...details,
            hasError: false,
            isLoading: false
        };
    },
    [(0, $jJd6W.FetchRepositoryDetails).ERROR] (state) {
        return {
            ...state,
            hasError: true,
            isLoading: false
        };
    },
    [(0, $jJd6W.FetchRepositoryMainBranch).SUCCESS] (state, action) {
        const mainBranch = action.payload;
        return {
            ...state,
            mainBranch: mainBranch
        };
    },
    [(0, $jJd6W.FETCH_IS_PIPELINES_ENABLED).REQUEST] (state) {
        return {
            ...state,
            isPipelinesEnabled: false,
            isPipelinesPremium: false,
            isPipelinesEnabledLoadingState: "LOADING"
        };
    },
    [(0, $jJd6W.FETCH_IS_PIPELINES_ENABLED).ERROR] (state) {
        return {
            ...state,
            isPipelinesEnabled: false,
            isPipelinesPremium: false,
            isPipelinesEnabledLoadingState: "ERROR"
        };
    },
    [(0, $jJd6W.FETCH_IS_PIPELINES_ENABLED).SUCCESS] (state, action) {
        return {
            ...state,
            isPipelinesEnabled: action.payload.isPipelinesEnabled,
            isPipelinesPremium: action.payload.isPipelinesPremium,
            isPipelinesEnabledLoadingState: "LOADED"
        };
    },
    [(0, $jJd6W.TOGGLE_REPOSITORY_WATCH).SUCCESS] (state, action) {
        return {
            ...state,
            ...action.payload
        };
    },
    [(0, $jJd6W.UPDATE_REPO_DETAILS)] (state, action) {
        return {
            ...state,
            ...$a297d19cfc41f94a$var$resultToDetails(action.payload)
        };
    },
    [(0, $jJd6W.UPDATE_TRANSFER_STATUS)] (state, action) {
        return {
            ...state,
            xferStatus: action.payload
        };
    }
});

});
parcelRegister("gsXeO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35497e0279c58d1c$export$2e2bcd8739ae039; });
const $35497e0279c58d1c$var$createReducer = (initialState, handlers)=>(state = initialState, action)=>{
        if (handlers[action.type]) return handlers[action.type](state, action);
        return state;
    };
var $35497e0279c58d1c$export$2e2bcd8739ae039 = $35497e0279c58d1c$var$createReducer;

});

parcelRegister("gKeEi", function(module, exports) {
$parcel$export(module.exports, "FETCH_FORGE_REPO_MENU_ITEMS", function () { return (parcelRequire("jJd6W")).FETCH_FORGE_REPO_MENU_ITEMS; });
$parcel$export(module.exports, "FETCH_IS_PIPELINES_ENABLED", function () { return (parcelRequire("jJd6W")).FETCH_IS_PIPELINES_ENABLED; });
$parcel$export(module.exports, "FetchRepositoryDetails", function () { return (parcelRequire("jJd6W")).FetchRepositoryDetails; });
$parcel$export(module.exports, "FetchRepositoryMainBranch", function () { return (parcelRequire("jJd6W")).FetchRepositoryMainBranch; });
$parcel$export(module.exports, "FetchRepositorySubscriptions", function () { return (parcelRequire("jJd6W")).FetchRepositorySubscriptions; });
$parcel$export(module.exports, "FetchSourceRepositoryDetails", function () { return (parcelRequire("jJd6W")).FetchSourceRepositoryDetails; });
$parcel$export(module.exports, "FetchUserEmails", function () { return (parcelRequire("jJd6W")).FetchUserEmails; });
$parcel$export(module.exports, "LoadRepositoryPage", function () { return (parcelRequire("jJd6W")).LoadRepositoryPage; });
$parcel$export(module.exports, "TOGGLE_CLONE_DIALOG", function () { return (parcelRequire("jJd6W")).TOGGLE_CLONE_DIALOG; });
$parcel$export(module.exports, "TOGGLE_REPOSITORY_WATCH", function () { return (parcelRequire("jJd6W")).TOGGLE_REPOSITORY_WATCH; });
$parcel$export(module.exports, "TOGGLE_SYNC_DIALOG", function () { return (parcelRequire("jJd6W")).TOGGLE_SYNC_DIALOG; });
$parcel$export(module.exports, "UNLOAD_REPOSITORY", function () { return (parcelRequire("jJd6W")).UNLOAD_REPOSITORY; });
$parcel$export(module.exports, "UPDATE_MENU_ITEM_URLS_REPO_NAME", function () { return (parcelRequire("jJd6W")).UPDATE_MENU_ITEM_URLS_REPO_NAME; });
$parcel$export(module.exports, "UPDATE_MENU_ITEMS", function () { return (parcelRequire("jJd6W")).UPDATE_MENU_ITEMS; });
$parcel$export(module.exports, "UPDATE_REPO_DETAILS", function () { return (parcelRequire("jJd6W")).UPDATE_REPO_DETAILS; });
$parcel$export(module.exports, "UPDATE_REPOSITORY_ENTITY", function () { return (parcelRequire("jJd6W")).UPDATE_REPOSITORY_ENTITY; });
$parcel$export(module.exports, "UPDATE_REPOSITORY_SECTION_MENU_ITEMS", function () { return (parcelRequire("jJd6W")).UPDATE_REPOSITORY_SECTION_MENU_ITEMS; });
$parcel$export(module.exports, "UPDATE_REPOSITORY_SECTION_OVERRIDE_SETTINGS", function () { return (parcelRequire("jJd6W")).UPDATE_REPOSITORY_SECTION_OVERRIDE_SETTINGS; });
$parcel$export(module.exports, "UPDATE_TRANSFER_STATUS", function () { return (parcelRequire("jJd6W")).UPDATE_TRANSFER_STATUS; });

$parcel$export(module.exports, "fetchRepositorySubscriptions", function () { return (parcelRequire("cbYE7")).default; });

var $cbYE7 = parcelRequire("cbYE7");
parcelRequire("jJd6W");

});
parcelRegister("cbYE7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $265463be8d9a7c12$export$2e2bcd8739ae039; });
parcelRequire("5YpaN");
var $fICwP = parcelRequire("fICwP");

var $kZnTB = parcelRequire("kZnTB");

var $jJd6W = parcelRequire("jJd6W");
var $265463be8d9a7c12$export$2e2bcd8739ae039 = (repositoryFullSlug, updatedSubscriptionSettings)=>{
    if (updatedSubscriptionSettings) return (0, $fICwP.fetchAction)((0, $jJd6W.FetchRepositorySubscriptions), {
        url: (0, $kZnTB.default).xhr.watchPrefs(repositoryFullSlug),
        fetchOptions: {
            body: JSON.stringify(updatedSubscriptionSettings),
            method: "POST"
        }
    });
    return (0, $fICwP.fetchAction)((0, $jJd6W.FetchRepositorySubscriptions), {
        url: (0, $kZnTB.default).xhr.watchPrefs(repositoryFullSlug)
    });
};

});
parcelRegister("kZnTB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd8bdb9c47591395$export$2e2bcd8739ae039; });

var $cJH1T = parcelRequire("cJH1T");

var $kvnVB = parcelRequire("kvnVB");

var $964rM = parcelRequire("964rM");
function $dd8bdb9c47591395$var$projectsUrlNameQ(url, name) {
    // public and internal projects APIs both support the same
    // "name" search functionality
    let url_with_params = `${url}`;
    if (name) {
        const q = `name ~ "${(0, $964rM.default)(name)}"`;
        url_with_params = `${url_with_params}?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
            q: q,
            sort: "name"
        }, {
            skipNulls: true
        })}`;
    }
    return url_with_params;
}
const $dd8bdb9c47591395$var$urls = {
    api: {
        internal: {
            compare: (repositoryFullSlug)=>`/${repositoryFullSlug}/compare`,
            commitAnnotated: (slug, hash)=>`/!api/internal/repositories/${slug}/changeset/${hash}/annotated_refs`,
            details: (repositoryFullSlug)=>`/!api/internal/repositories/${repositoryFullSlug}/details`,
            onlineEditorCommit: (owner, slug)=>`/!api/internal/repositories/${owner}/${slug}/oecommits/`,
            toggleWatch: (repositoryFullSlug)=>`/${repositoryFullSlug}/follow`,
            branchList: (owner, slug)=>`/!api/internal/repositories/${owner}/${slug}/branch-list/`,
            branchRestrictionsByBranch: (owner, slug)=>`/!api/internal/repositories/${owner}/${slug}/branch-restrictions/group-by-branch/`,
            pullRequestAuthors: (repositoryFullSlug, options)=>{
                const url = `/!api/internal/repositories/${repositoryFullSlug}/pr-authors/`;
                if (options.query || options.status) return `${url}?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
                    pr_status: options.status,
                    user_search: options.query
                }, {
                    skipNulls: true
                })}`;
                return url;
            },
            defaultCommitMsg: (repositoryFullSlug, mergeStrategy, sourceBranchName, destinationBranchName)=>`/!api/internal/repositories/${repositoryFullSlug}/compare/default-commit-msg/${mergeStrategy}/${sourceBranchName}%0D${destinationBranchName}`,
            branchRestrictions: (owner, slug, branch)=>`/!api/internal/repositories/${owner}/${slug}/branch-restrictions/branch-summary/${branch}`,
            branchRestrictionsByPattern: (owner, slug, pattern)=>`/!api/internal/repositories/${owner}/${slug}/branch-restrictions/by-pattern/${pattern}`,
            branchRestrictionsByBranchType: (owner, slug, branchType)=>`/!api/internal/repositories/${owner}/${slug}/branch-restrictions/by-branch-type/${branchType}`,
            bulkDeleteBranches: (repositoryFullSlug)=>`/!api/internal/repositories/${repositoryFullSlug}/branches-delete`,
            repoSettingsDetails: (workspace, repoUuid)=>`/!api/internal/repositories/${workspace}/${repoUuid}/repo-settings-details`,
            repositoryAvatar: (workspace, repoUuid)=>`/${workspace}/${repoUuid}/admin/logo`,
            userPrivileges: (owner, slug)=>`/!api/internal/privileges/${owner}/${slug}/`,
            repoAiDesc: (fullSlug, sourceHash, destHash)=>`/!api/internal/repositories/${fullSlug}/ai-description/${fullSlug}:${sourceHash}%0D${destHash}`,
            users: (owner, slug, options)=>{
                const url = `/!api/internal/repositories/${owner}/${slug}/users/`;
                if (options) return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(options, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
                return url;
            },
            groupPrivilegesToAdd: (workspaceSlug, repoSlug, search)=>{
                const url = `/!api/internal/_group-privileges-to-add/${workspaceSlug}/${repoSlug}/`;
                if (search) return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
                    search: search
                }, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
                return url;
            },
            inheritedPermissions: (workspaceSlug, repositorySlug, options)=>{
                const url = `/!api/internal/inherited-repo-privileges/${workspaceSlug}/${repositorySlug}/`;
                if (options) return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(options, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
                return url;
            },
            mergeStrategy: (repositoryOwner, repoSlug)=>`/!api/internal/repositories/${repositoryOwner}/${repoSlug}/merge-strategy`,
            repoWriters: (repositoryOwner, repoSlug, options)=>{
                const url = `/!api/internal/repositories/${repositoryOwner}/${repoSlug}/repo-writers`;
                return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(options, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
            },
            repoWriterGroups: (repositoryOwner, repoSlug, options)=>{
                const url = `/!api/internal/repositories/${repositoryOwner}/${repoSlug}/repo-writer-groups`;
                return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(options, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
            },
            addDefaultReviewers: (workspace, repoSlug, options)=>{
                const url = `/!api/internal/repositories/${workspace}/${repoSlug}/add-default-reviewers`;
                return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(options, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
            },
            defaultReviewGroups: (repoOwner, repoSlug)=>`/!api/internal/repositories/${repoOwner}/${repoSlug}/default-review-groups`,
            accessTokens: (repoOwner, repoSlug)=>`/!api/internal/repositories/${repoOwner}/${repoSlug}/access-tokens`,
            recommendedReviewers: (workspace_slug, repo_slug)=>`/!api/internal/repositories/${workspace_slug}/${repo_slug}/recommended-reviewers`,
            defaultMessages: (sourceRepoFullSlug, sourceBranchName, destRepoFullSlug, destBranchName)=>`/!api/internal/repositories/${sourceRepoFullSlug}/pullrequests/default-messages/${sourceRepoFullSlug}:${encodeURIComponent(sourceBranchName)}%0D${destRepoFullSlug}:${encodeURIComponent(destBranchName)}`,
            createPullRequestData: (repoOwner, repoSlug, sourceBranch, destRepo, destBranch)=>{
                let destQuery;
                if (destRepo && destBranch) destQuery = `${destRepo}:${destBranch}`;
                else if (destBranch) destQuery = `${destBranch}`;
                const sourceQuery = sourceBranch ? `${sourceBranch}` : null;
                const query = (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
                    source: sourceQuery,
                    dest: destQuery
                }, {
                    skipNulls: true,
                    addQueryPrefix: true
                });
                return `/!api/internal/repositories/${repoOwner}/${repoSlug}/pullrequests/create-pr-data${query}`;
            },
            codeowners: (repoOwner, repoSlug, sourceHash, destHash)=>{
                const source = encodeURIComponent(sourceHash || "");
                const dest = encodeURIComponent(destHash || "");
                return `/!api/internal/repositories/${repoOwner}/${repoSlug}/codeowners/${source}..${dest}`;
            },
            projects: (workspace, name, permission)=>{
                const url = `/!api/internal/workspaces/${workspace}/projects/`;
                let url_with_params = $dd8bdb9c47591395$var$projectsUrlNameQ(url, name);
                if (permission) {
                    const sep = name ? "&" : "?";
                    url_with_params = `${url_with_params}${sep}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
                        permission: "create-repo"
                    }, {
                        skipNulls: true
                    })}`;
                }
                return url_with_params;
            },
            mergeChecks: (workspaceSlug, repoSlug)=>`/!api/internal/repositories/${workspaceSlug}/${repoSlug}/checks-config`,
            customMergeChecks: (workspaceSlug, repoSlug)=>`/!api/internal/repositories/${workspaceSlug}/${repoSlug}/checks-config/v2`,
            prBatchCycleMetrics: (workspaceSlug, repoUuids)=>`/!api/internal/workspaces/${workspaceSlug}/stats/pr-cycle-time?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
                    repository_uuids: repoUuids
                }, {
                    indices: false
                })}`
        },
        v10: {
            groups: (owner)=>`/!api/1.0/groups/${owner}/`,
            branchTags: (workspaceSlug, repoSlug)=>`/!api/1.0/repositories/${workspaceSlug}/${repoSlug}/branches-tags`
        },
        v20: {
            email: ()=>"/!api/2.0/user/emails",
            branches: (owner, slug)=>`${$dd8bdb9c47591395$var$urls.api.v20.refs(owner, slug)}/branches`,
            findBranchNames: (owner, slug, params)=>{
                /*
        NameFilter is used to exclude branches to work around pagination
        sometimes hiding an exact match (currently our api won't sort by the
        closest match). We can make separate calls (an exact match and the rest)
        and then merge the results.
        */ const { name: name, nameFilter: nameFilter } = params || {};
                const url = `${$dd8bdb9c47591395$var$urls.api.v20.refs(owner, slug)}/branches?fields=values.name`;
                let q;
                if (!name && nameFilter !== "ONLY") return url;
                const branchName = !name ? "" : (0, $964rM.default)(name);
                if (nameFilter === "ONLY") q = `name = "${branchName}"`;
                else if (nameFilter === "SKIP") q = `name != "${branchName}" AND name ~ "${branchName}"`;
                else q = `name ~ "${branchName}"`;
                return `${url}&${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
                    q: q
                })}`;
            },
            branch: (owner, slug, branchName)=>`${$dd8bdb9c47591395$var$urls.api.v20.refs(owner, slug)}/branches/${branchName}`,
            branchAbs: (owner, slug, branchName)=>`${(0, $kvnVB.settings)().CANON_URL}${$dd8bdb9c47591395$var$urls.api.v20.branch(owner, slug, branchName)}`,
            branchingModel: (owner, slug)=>`/!api/2.0/repositories/${owner}/${slug}/effective-branching-model`,
            branchingModelSettings: (owner, slug)=>`/!api/2.0/repositories/${owner}/${slug}/branching-model/settings`,
            commits: (owner, slug)=>`${$dd8bdb9c47591395$var$urls.api.v20.repository(owner, slug)}/commits`,
            commit: (owner, slug, hash)=>`${$dd8bdb9c47591395$var$urls.api.v20.repository(owner, slug)}/commit/${hash}`,
            defaultReviewer: (owner, slug, userUuid)=>`${$dd8bdb9c47591395$var$urls.api.v20.repository(owner, slug)}/default-reviewers/${userUuid}`,
            defaultReviewers: (owner, slug, options)=>{
                const url = `${$dd8bdb9c47591395$var$urls.api.v20.repository(owner, slug)}/effective-default-reviewers`;
                return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(options, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
            },
            forks: (owner, slug)=>`/!api/2.0/repositories/${owner}/${slug}/forks`,
            refs: (owner, slug, options)=>{
                const url = `${$dd8bdb9c47591395$var$urls.api.v20.repository(owner, slug)}/refs`;
                if (options) return `${url}?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(options, {
                    skipNulls: true
                })}`;
                return url;
            },
            repositories: ()=>`/!api/2.0/repositories`,
            repository: (owner, slug)=>`/!api/2.0/repositories/${owner}/${slug}`,
            repositoryByUuid: (uuid)=>$dd8bdb9c47591395$var$urls.api.v20.repository("{}", uuid),
            repositoryAbs: (owner, slug)=>`${(0, $kvnVB.settings)().CANON_URL}${$dd8bdb9c47591395$var$urls.api.v20.repository(owner, slug)}`,
            tags: (owner, slug)=>`${$dd8bdb9c47591395$var$urls.api.v20.refs(owner, slug)}/tags`,
            pullRequests: (owner, slug)=>`/!api/2.0/repositories/${owner}/${slug}/pullrequests/`,
            pullRequestExistsUrl: (sourceRepoFullSlug, sourceBranch, destRepoFullSlug, destBranch)=>{
                // BBQL check for PR page to check if duplicate PR already exists
                const bbqlQuery = `source.branch.name="${(0, $964rM.default)(sourceBranch)}" AND source.repository.full_name="${(0, $964rM.default)(sourceRepoFullSlug)}" AND destination.repository.full_name="${(0, $964rM.default)(destRepoFullSlug)}" AND destination.branch.name="${(0, $964rM.default)(destBranch)}" AND state="OPEN"`;
                const bbql = encodeURIComponent(bbqlQuery);
                return `/!api/2.0/repositories/${sourceRepoFullSlug}/pullrequests/?fields=values.links.html.href&q=${bbql}`;
            },
            watchers: (owner, slug)=>`/!api/2.0/repositories/${owner}/${slug}/watchers`,
            deployKeys: (owner, slug, options)=>{
                const url = `/!api/2.0/repositories/${owner}/${slug}/deploy-keys/`;
                if (options) return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(options, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
                return url;
            },
            project: (workspace, projectKey)=>`/!api/2.0/workspaces/${workspace}/projects/${projectKey}`,
            projects: (workspace, name)=>{
                const url = `/!api/2.0/workspaces/${workspace}/projects/`;
                return $dd8bdb9c47591395$var$projectsUrlNameQ(url, name);
            }
        }
    },
    external: {
        emptyStateLearnMore: "https://confluence.atlassian.com/x/Ep1IN",
        excludedFilesLearnMore: "https://confluence.atlassian.com/x/j41LOQ",
        reduceRepositorySize: "https://confluence.atlassian.com/x/xgMvEw",
        updateMirrorPushUrl: "https://confluence.atlassian.com/x/jGP5MQ",
        referenceIssuesLearnMore: "https://confluence.atlassian.com/x/JR9QLg",
        usernameAliasesDocumentation: "https://confluence.atlassian.com/x/xYE-E",
        learnMoreAboutModifyingUrlsLink: "https://confluence.atlassian.com/x/hneeOQ#ChangeaworkspaceID-update_URLUpdatetheURLinyourconfigurationfile",
        bitbucketStatusPage: "https://status.bitbucket.org",
        branchingModelDocumentation: "https://confluence.atlassian.com/x/TwlODQ",
        branchRestrictionsDocumentation: "https://confluence.atlassian.com/x/z40AFw"
    },
    ui: {
        admin: (owner, slug)=>`${$dd8bdb9c47591395$var$urls.ui.repository(owner, slug)}/admin`,
        adminPage: (owner, slug, page)=>`${$dd8bdb9c47591395$var$urls.ui.repository(owner, slug)}/admin/${page}`,
        accessCheck: (owner, slug)=>`${$dd8bdb9c47591395$var$urls.ui.repository(owner, slug)}/admin/access-check`,
        branches: (owner, slug)=>`${$dd8bdb9c47591395$var$urls.ui.repository(owner, slug)}/branches`,
        branch: (owner, slug, branchName)=>`${$dd8bdb9c47591395$var$urls.ui.repository(owner, slug)}/branch/${branchName}`,
        compare: (owner, slug)=>`${$dd8bdb9c47591395$var$urls.ui.repository(owner, slug)}/branches/compare`,
        branchingModel: (owner, slug)=>`${$dd8bdb9c47591395$var$urls.ui.repository(owner, slug)}/admin/branching-model`,
        branchPermissions: (owner, slug)=>`${$dd8bdb9c47591395$var$urls.ui.repository(owner, slug)}/admin/branch-permissions`,
        defaultReviewers: (owner, slug)=>`${$dd8bdb9c47591395$var$urls.ui.repository(owner, slug)}/admin/pullrequests/reviewers/`,
        commits: (repositoryName, opts)=>{
            const url = `/${repositoryName}/commits`;
            if (!opts) return url;
            return `${url}/${opts.kind}/${opts.refName}`;
        },
        create: (params)=>{
            if (params) return `/repo/create?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(params, {
                skipNulls: true
            })}`;
            return "/repo/create";
        },
        excludedFiles: (repositoryName)=>`/${repositoryName}/admin/pullrequests/excluded-files/`,
        fork: (owner, slug)=>`${$dd8bdb9c47591395$var$urls.ui.repository(owner, slug)}/fork`,
        import: (params)=>{
            if (params) return `/repo/import?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(params, {
                skipNulls: true
            })}`;
            return "/repo/import";
        },
        notifications: "/account/settings/notifications/",
        pipelines: (owner, slug)=>`${$dd8bdb9c47591395$var$urls.ui.repository(owner, slug)}/pipelines/?from=bitbucketBuildCard`,
        pullRequests: (owner, slug)=>`${$dd8bdb9c47591395$var$urls.ui.repository(owner, slug)}/pull-requests`,
        pullRequestsTargetingBranch: (owner, slug, targetBranch)=>`${$dd8bdb9c47591395$var$urls.ui.repository(owner, slug)}/pull-requests?state=OPEN&at=${encodeURIComponent(targetBranch)}`,
        createPullRequest: (owner, slug, sourceBranch, destRepo, destBranch)=>{
            const url = `${$dd8bdb9c47591395$var$urls.ui.repository(owner, slug)}/pull-requests/new`;
            const sourceQuery = (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
                source: sourceBranch
            }, {
                skipNulls: true,
                addQueryPrefix: true
            });
            // PR create spec is slug:hash:spec
            if (destRepo && destBranch) {
                const destQuery = (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
                    dest: `${destRepo}::${destBranch}`
                });
                return `${url}${sourceQuery}&${destQuery}`;
            } else return `${url}${sourceQuery}`;
        },
        repository: (owner, slug)=>`/${owner}/${slug}`,
        smartMirroring: (uuid)=>`/account/user/${uuid}/mirroring/`,
        getLFSpath: (fullSlug)=>`/${fullSlug}/admin/lfs/file-management/`,
        getRepoDetailsUrl: (fullSlug)=>`/${fullSlug}/admin`,
        transferRepo: (fullSlug)=>`/${fullSlug}/admin/transfer`,
        deleteRepo: (fullSlug)=>`/${fullSlug}/delete`,
        settingsGroups: (slug)=>`/${slug}/workspace/settings/groups`,
        members: (slug)=>`/${slug}/workspace/members/`,
        customMergeChecks: (workspaceSlug, repositorySlug)=>`/${workspaceSlug}/${repositorySlug}/admin/merge-checks`
    },
    xhr: {
        watchPrefs: (repositoryFullSlug)=>`/xhr/watch-prefs/${repositoryFullSlug}`,
        userMention: (query)=>`/xhr/user-mention?term=${query}`,
        reviewerPermissions: (owner, slug)=>`/${owner}/${slug}/pull-requests/xhr/reviewer-permissions/`
    }
};
var $dd8bdb9c47591395$export$2e2bcd8739ae039 = $dd8bdb9c47591395$var$urls;

});
parcelRegister("964rM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5af7f222eae4090c$export$2e2bcd8739ae039; });
/**
 * BBQL values cannot contain unescaped double quotes
 *
 * @param {string} str
 * @returns {string}
 */ function $5af7f222eae4090c$export$2e2bcd8739ae039(str) {
    return str.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
}

});


parcelRegister("jJd6W", function(module, exports) {

$parcel$export(module.exports, "FetchRepositoryDetails", function () { return $1b0b394ab1b8dada$export$e46934c325801af6; });
$parcel$export(module.exports, "FetchSourceRepositoryDetails", function () { return $1b0b394ab1b8dada$export$8435359890dcf4d5; });
$parcel$export(module.exports, "FetchRepositorySubscriptions", function () { return $1b0b394ab1b8dada$export$b9caf19f1dfeacc9; });
$parcel$export(module.exports, "FetchRepositoryMainBranch", function () { return $1b0b394ab1b8dada$export$29a846e7711f45; });
$parcel$export(module.exports, "LoadRepositoryPage", function () { return $1b0b394ab1b8dada$export$67fd8d6d0808675e; });
$parcel$export(module.exports, "TOGGLE_CLONE_DIALOG", function () { return $1b0b394ab1b8dada$export$709f20b4017d4f86; });
$parcel$export(module.exports, "TOGGLE_REPOSITORY_WATCH", function () { return $1b0b394ab1b8dada$export$4c24efff24486258; });
$parcel$export(module.exports, "FETCH_IS_PIPELINES_ENABLED", function () { return $1b0b394ab1b8dada$export$567f68432cedccab; });
$parcel$export(module.exports, "TOGGLE_SYNC_DIALOG", function () { return $1b0b394ab1b8dada$export$b053635f28454968; });
$parcel$export(module.exports, "UNLOAD_REPOSITORY", function () { return $1b0b394ab1b8dada$export$1b72074958797b26; });
$parcel$export(module.exports, "UPDATE_MENU_ITEMS", function () { return $1b0b394ab1b8dada$export$5cf07cd12fc8a743; });
$parcel$export(module.exports, "FETCH_FORGE_REPO_MENU_ITEMS", function () { return $1b0b394ab1b8dada$export$357eaeb902988434; });
$parcel$export(module.exports, "UPDATE_MENU_ITEM_URLS_REPO_NAME", function () { return $1b0b394ab1b8dada$export$ba848f1f38011e4d; });
$parcel$export(module.exports, "UPDATE_REPOSITORY_SECTION_MENU_ITEMS", function () { return $1b0b394ab1b8dada$export$8709dc93c471f2d4; });
$parcel$export(module.exports, "UPDATE_REPOSITORY_SECTION_OVERRIDE_SETTINGS", function () { return $1b0b394ab1b8dada$export$88679827d20e393e; });
$parcel$export(module.exports, "UPDATE_REPOSITORY_ENTITY", function () { return $1b0b394ab1b8dada$export$fc63f20af9edf0bf; });
$parcel$export(module.exports, "UPDATE_TRANSFER_STATUS", function () { return $1b0b394ab1b8dada$export$601754e1fef92a39; });
$parcel$export(module.exports, "FetchUserEmails", function () { return $1b0b394ab1b8dada$export$27b647ad3587a03b; });
$parcel$export(module.exports, "UPDATE_REPO_DETAILS", function () { return $1b0b394ab1b8dada$export$3c349ff92d4ac4e7; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
const $1b0b394ab1b8dada$export$e46934c325801af6 = (0, $2MctD.createAsyncAction)("repository/FETCH_REPOSITORY_DETAILS");
const $1b0b394ab1b8dada$export$8435359890dcf4d5 = (0, $2MctD.createAsyncAction)("repository/FETCH_SOURCE_REPOSITORY_DETAILS");
const $1b0b394ab1b8dada$export$b9caf19f1dfeacc9 = (0, $2MctD.createAsyncAction)("repository/FETCH_REPOSITORY_SUBSCRIPTIONS");
const $1b0b394ab1b8dada$export$29a846e7711f45 = (0, $2MctD.createAsyncAction)("repository/FETCH_REPOSITORY_MAIN_BRANCH");
const $1b0b394ab1b8dada$export$67fd8d6d0808675e = (0, $2MctD.createAsyncAction)("repository/LOAD_REPOSITORY_PAGE");
const $1b0b394ab1b8dada$export$709f20b4017d4f86 = "repository/TOGGLE_CLONE_DIALOG";
const $1b0b394ab1b8dada$export$4c24efff24486258 = (0, $2MctD.createAsyncAction)("source/TOGGLE_REPOSITORY_WATCH");
const $1b0b394ab1b8dada$export$567f68432cedccab = (0, $2MctD.createAsyncAction)("repository/FETCH_IS_PIPELINES_ENABLED");
const $1b0b394ab1b8dada$export$b053635f28454968 = "repository/TOGGLE_SYNC_DIALOG";
const $1b0b394ab1b8dada$export$1b72074958797b26 = "repository/UNLOAD_REPOSITORY";
const $1b0b394ab1b8dada$export$5cf07cd12fc8a743 = "repository/UPDATE_MENU_ITEMS";
const $1b0b394ab1b8dada$export$357eaeb902988434 = (0, $2MctD.createAsyncAction)("repository/FETCH_FORGE_REPO_MENU_ITEMS");
const $1b0b394ab1b8dada$export$ba848f1f38011e4d = "repository/UPDATE_MENU_ITEM_URLS_REPO_NAME";
const $1b0b394ab1b8dada$export$8709dc93c471f2d4 = "repository/UPDATE_REPOSITORY_SECTION_MENU_ITEMS";
const $1b0b394ab1b8dada$export$88679827d20e393e = "repository/UPDATE_REPOSITORY_SECTION_OVERRIDE_SETTINGS";
const $1b0b394ab1b8dada$export$fc63f20af9edf0bf = "repository/UPDATE_REPOSITORY_ENTITY";
const $1b0b394ab1b8dada$export$601754e1fef92a39 = "repository/UPDATE_TRANSFER_STATUS";
const $1b0b394ab1b8dada$export$27b647ad3587a03b = (0, $2MctD.createAsyncAction)("FETCH_USER_EMAILS");
const $1b0b394ab1b8dada$export$3c349ff92d4ac4e7 = "repository/UPDATE_REPO_DETAILS";

});





parcelRegister("5utbt", function(module, exports) {

$parcel$export(module.exports, "getRecentlyViewedWorkspacesKeys", function () { return $eeb03a9fc819c1a0$export$27428a7a1827c25d; });
$parcel$export(module.exports, "getCurrentWorkspace", function () { return $eeb03a9fc819c1a0$export$2e21ae02c36d8af0; });
$parcel$export(module.exports, "getCurrentWorkspaceSlug", function () { return $eeb03a9fc819c1a0$export$672c55154c3f2f68; });
$parcel$export(module.exports, "getCurrentWorkspaceUUID", function () { return $eeb03a9fc819c1a0$export$27d4787431004f79; });
$parcel$export(module.exports, "getCurrentWorkspaceExtraAttributes", function () { return $eeb03a9fc819c1a0$export$9057f901f2edb1f1; });
$parcel$export(module.exports, "getWorkspacePlanRequestStatus", function () { return $eeb03a9fc819c1a0$export$44eb6b73478aaa81; });
$parcel$export(module.exports, "getWorkspacePlan", function () { return $eeb03a9fc819c1a0$export$1287d48f0263b568; });

var $aXXtM = parcelRequire("aXXtM");

var $3yhbh = parcelRequire("3yhbh");

var $aanBq = parcelRequire("aanBq");

var $7qdXF = parcelRequire("7qdXF");
const $eeb03a9fc819c1a0$export$27428a7a1827c25d = (0, $aXXtM.createSelector)((0, $7qdXF.getRecentlyViewedWorkspacesKeys), (recentlyWorkspacesKeys)=>recentlyWorkspacesKeys);
const $eeb03a9fc819c1a0$export$2e21ae02c36d8af0 = (0, $aXXtM.createSelector)((0, $7qdXF.getProfile), (profile)=>{
    var _profile$section;
    return profile === null || profile === void 0 ? void 0 : (_profile$section = profile.section) === null || _profile$section === void 0 ? void 0 : _profile$section.currentWorkspace;
});
const $eeb03a9fc819c1a0$export$672c55154c3f2f68 = (0, $aXXtM.createSelector)($eeb03a9fc819c1a0$export$2e21ae02c36d8af0, (currentWorkspace)=>currentWorkspace === null || currentWorkspace === void 0 ? void 0 : currentWorkspace.slug);
const $eeb03a9fc819c1a0$export$27d4787431004f79 = (0, $aXXtM.createSelector)($eeb03a9fc819c1a0$export$2e21ae02c36d8af0, (0, $3yhbh.getCurrentProject), (0, $aanBq.getCurrentRepository), (currentWorkspace, currentProject, currentRepository)=>{
    var _currentProject$works, _currentRepository$wo;
    return (currentWorkspace === null || currentWorkspace === void 0 ? void 0 : currentWorkspace.uuid) || (currentProject === null || currentProject === void 0 ? void 0 : (_currentProject$works = currentProject.workspace) === null || _currentProject$works === void 0 ? void 0 : _currentProject$works.uuid) || (currentRepository === null || currentRepository === void 0 ? void 0 : (_currentRepository$wo = currentRepository.workspace) === null || _currentRepository$wo === void 0 ? void 0 : _currentRepository$wo.uuid);
});
const $eeb03a9fc819c1a0$export$91d66573ef213493 = (0, $aXXtM.createSelector)((0, $7qdXF.getProfile), (profile)=>profile.section.menuItems);
const $eeb03a9fc819c1a0$export$9057f901f2edb1f1 = (0, $aXXtM.createSelector)($eeb03a9fc819c1a0$export$2e21ae02c36d8af0, (currentWorkspace)=>{
    var _currentWorkspace$ext, _currentWorkspace$ext2, _currentWorkspace$ext3;
    return {
        adminStatus: currentWorkspace === null || currentWorkspace === void 0 ? void 0 : (_currentWorkspace$ext = currentWorkspace.extra) === null || _currentWorkspace$ext === void 0 ? void 0 : _currentWorkspace$ext.admin_status,
        hasPremium: currentWorkspace === null || currentWorkspace === void 0 ? void 0 : (_currentWorkspace$ext2 = currentWorkspace.extra) === null || _currentWorkspace$ext2 === void 0 ? void 0 : _currentWorkspace$ext2.has_premium,
        isPaid: currentWorkspace === null || currentWorkspace === void 0 ? void 0 : (_currentWorkspace$ext3 = currentWorkspace.extra) === null || _currentWorkspace$ext3 === void 0 ? void 0 : _currentWorkspace$ext3.is_paid
    };
});
const $eeb03a9fc819c1a0$export$44eb6b73478aaa81 = (0, $aXXtM.createSelector)((0, $7qdXF.getWorkspacePlanSlice), (workspacePlanSlice)=>{
    return {
        isFetchWorkspacePlanLoading: workspacePlanSlice ? workspacePlanSlice.isFetchWorkspacePlanLoading : true,
        isFetchWorkspacePlanError: workspacePlanSlice ? workspacePlanSlice.isFetchWorkspacePlanError : false
    };
});
const $eeb03a9fc819c1a0$export$1287d48f0263b568 = (0, $aXXtM.createSelector)((0, $7qdXF.getWorkspacePlanSlice), (workspacePlanSlice)=>{
    return {
        isWorkspacePaid: workspacePlanSlice ? workspacePlanSlice.isWorkspacePaid : false,
        isWorkspacePremium: workspacePlanSlice ? workspacePlanSlice.isWorkspacePremium : false
    };
});

});

parcelRegister("6aoKW", function(module, exports) {

$parcel$export(module.exports, "publishFact", function () { return $59c59ce8d024006c$export$3cce9d98656a43e4; });
$parcel$export(module.exports, "publishScreenEvent", function () { return $59c59ce8d024006c$export$b11a844101b0179b; });
$parcel$export(module.exports, "publishFullScreenEvent", function () { return $59c59ce8d024006c$export$af9e29ed60b8f2ad; });
$parcel$export(module.exports, "publishTrackEvent", function () { return $59c59ce8d024006c$export$851e63229e319aa0; });
$parcel$export(module.exports, "publishUiEvent", function () { return $59c59ce8d024006c$export$18c41512004c0599; });
$parcel$export(module.exports, "publishOperationalEvent", function () { return $59c59ce8d024006c$export$39e9f77169f0d895; });

var $41npu = parcelRequire("41npu");

var $k2cPS = parcelRequire("k2cPS");

var $628YF = parcelRequire("628YF");

var $bBcuy = parcelRequire("bBcuy");

var $fCCZL = parcelRequire("fCCZL");
const $59c59ce8d024006c$var$BATCH_PUBLISH_INTERVAL_MILLIS = 5000;
const $59c59ce8d024006c$var$MAX_BATCH_PUBLISH_INTERVAL_MILLIS = 300000;
const $59c59ce8d024006c$var$STORAGE_KEY = "bitbucket-analytics";
function $59c59ce8d024006c$var$pollWithBackoffOnFailure(fn, interval) {
    const onSuccess = ()=>$59c59ce8d024006c$var$pollWithBackoffOnFailure(fn, $59c59ce8d024006c$var$BATCH_PUBLISH_INTERVAL_MILLIS);
    const onError = ()=>$59c59ce8d024006c$var$pollWithBackoffOnFailure(fn, Math.min($59c59ce8d024006c$var$MAX_BATCH_PUBLISH_INTERVAL_MILLIS, interval * 2));
    setTimeout(()=>fn().then(onSuccess, onError), interval);
}
function $59c59ce8d024006c$var$generateEventId() {
    const timestamp = new Date().getTime();
    const random = Math.floor(Math.random() * 1000 + 1);
    return `${timestamp}_${random}`;
}
function $59c59ce8d024006c$var$prepareEventData(events) {
    const currentTime = new Date().getTime();
    const { workspaceUuid: workspaceUuid } = (0, $41npu.getHtmlMetaValues)();
    return events.map((ev)=>({
            name: ev.name,
            properties: ev.properties,
            referrer: ev.referrer,
            timeDelta: ev.time - currentTime,
            tenantId: workspaceUuid
        }));
}
function $59c59ce8d024006c$var$getStoredEvents() {
    try {
        const events = sessionStorage && sessionStorage.getItem($59c59ce8d024006c$var$STORAGE_KEY);
        return events ? JSON.parse(events) : {};
    } catch (error) {
        // likely to be a security error thrown when trying to access sessionStorage (BBCDEV-3311)
        // if this fails it's not a big deal, so let's just carry on
        return {};
    }
}
function $59c59ce8d024006c$var$setStoredEvents(events) {
    try {
        sessionStorage.setItem($59c59ce8d024006c$var$STORAGE_KEY, JSON.stringify(events));
    } catch (e) {
    // Error setting item in session storage
    }
}
function $59c59ce8d024006c$var$storeEvent(event) {
    const eventsDict = $59c59ce8d024006c$var$getStoredEvents();
    eventsDict[$59c59ce8d024006c$var$generateEventId()] = event;
    $59c59ce8d024006c$var$setStoredEvents(eventsDict);
}
function $59c59ce8d024006c$var$publishEvents() {
    const eventsDict = $59c59ce8d024006c$var$getStoredEvents();
    if (Object.keys(eventsDict).length > 0) {
        $59c59ce8d024006c$var$setStoredEvents({}); // flush the storage
        // @ts-ignore TODO: fix noImplicitAny error here
        const errorHandler = (e, events)=>()=>{
                // We only care about capturing exceptions, not Promise rejections due to non-2XX responses
                if (e) (0, $628YF.captureExceptionWithTags)(e, {
                    component: "analytics"
                });
                events.forEach($59c59ce8d024006c$var$storeEvent);
                return Promise.reject();
            };
        const facts = Object.values(eventsDict).filter((event)=>event.isFact);
        const publishFacts = facts.length ? fetch((0, $k2cPS.default)((0, $fCCZL.default).api.internal.events(), {
            method: "POST",
            body: JSON.stringify({
                events: $59c59ce8d024006c$var$prepareEventData(facts)
            }),
            headers: {
                "Content-Type": "application/json"
            }
        })).then((response)=>response.ok ? Promise.resolve() : Promise.reject()).catch((e)=>errorHandler(e, facts)) : Promise.resolve();
        return publishFacts;
    }
    return Promise.resolve();
}
const $59c59ce8d024006c$export$3cce9d98656a43e4 = (fact)=>{
    $59c59ce8d024006c$var$storeEvent(fact.generateEvent());
};
const $59c59ce8d024006c$var$hydrateAnalyticsEventAttributes = (attributes)=>({
        ...attributes,
        frontbucketView: true
    });
/** Screen Events: when a user looks at a screen */ const $59c59ce8d024006c$export$b11a844101b0179b = (event, attributes)=>{
    try {
        (0, $bBcuy.analyticsClient)().sendScreenEvent({
            name: event,
            attributes: $59c59ce8d024006c$var$hydrateAnalyticsEventAttributes(attributes)
        });
    } catch (e) {
        // Log exception to Sentry and continue execution.
        (0, $628YF.captureExceptionWithTags)(e, {
            component: "analytics"
        });
    }
};
/** Full Screen Events: adds additional context to ScreenEvents */ const $59c59ce8d024006c$export$af9e29ed60b8f2ad = (event)=>{
    try {
        (0, $bBcuy.analyticsClient)().sendScreenEvent({
            ...event,
            attributes: $59c59ce8d024006c$var$hydrateAnalyticsEventAttributes(event.attributes)
        });
    } catch (e) {
        // Log exception to Sentry and continue execution.
        (0, $628YF.captureExceptionWithTags)(e, {
            component: "analytics"
        });
    }
};
/** Track Events: when a user performs a product action (created issue, deleted project) */ const $59c59ce8d024006c$export$851e63229e319aa0 = (event)=>{
    try {
        (0, $bBcuy.analyticsClient)().sendTrackEvent({
            ...event,
            attributes: $59c59ce8d024006c$var$hydrateAnalyticsEventAttributes(event.attributes)
        });
    } catch (e) {
        // Log exception to Sentry and continue execution.
        (0, $628YF.captureExceptionWithTags)(e, {
            component: "analytics"
        });
    }
};
/** UI Events: when a user interacts with the UI (clicks a button, selects an option in a dropdown) */ const $59c59ce8d024006c$export$18c41512004c0599 = (event, onEventSent)=>{
    try {
        const eventWithAttributes = {
            ...event,
            attributes: $59c59ce8d024006c$var$hydrateAnalyticsEventAttributes(event.attributes)
        };
        if (onEventSent) (0, $bBcuy.analyticsClient)().sendUIEvent(eventWithAttributes, onEventSent);
        else (0, $bBcuy.analyticsClient)().sendUIEvent(eventWithAttributes);
    } catch (e) {
        // Log exception to Sentry and continue execution.
        (0, $628YF.captureExceptionWithTags)(e, {
            component: "analytics"
        });
    }
};
const $59c59ce8d024006c$export$39e9f77169f0d895 = (event)=>{
    try {
        (0, $bBcuy.analyticsClient)().sendOperationalEvent({
            ...event,
            attributes: $59c59ce8d024006c$var$hydrateAnalyticsEventAttributes(event.attributes)
        });
    } catch (e) {
        // Log exception to Sentry and continue execution.
        (0, $628YF.captureExceptionWithTags)(e, {
            component: "analytics"
        });
    }
};
$59c59ce8d024006c$var$pollWithBackoffOnFailure($59c59ce8d024006c$var$publishEvents, $59c59ce8d024006c$var$BATCH_PUBLISH_INTERVAL_MILLIS);

});
parcelRegister("bBcuy", function(module, exports) {

$parcel$export(module.exports, "analyticsClient", function () { return $14a8ab10459780c3$export$f1caacacb426dc27; });
parcelRequire("3hzea");
var $fcgZ6 = parcelRequire("fcgZ6");
let $14a8ab10459780c3$var$globalAnalyticsClient;
const $14a8ab10459780c3$export$5021d68a48726232 = ()=>{
    return (0, $fcgZ6.createAnalyticsClient)();
};
const $14a8ab10459780c3$export$f1caacacb426dc27 = ()=>{
    if (!$14a8ab10459780c3$var$globalAnalyticsClient) $14a8ab10459780c3$var$globalAnalyticsClient = $14a8ab10459780c3$export$5021d68a48726232();
    return $14a8ab10459780c3$var$globalAnalyticsClient;
};

});

parcelRegister("fCCZL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34fb8d102d4b5aa4$export$2e2bcd8739ae039; });
var $34fb8d102d4b5aa4$export$2e2bcd8739ae039 = {
    api: {
        internal: {
            events: ()=>"/!api/internal/analytics/events"
        }
    }
};

});



parcelRegister("1D6WP", function(module, exports) {

$parcel$export(module.exports, "SCROLL_TO_DURATION", function () { return $c23dbeb333b86bd7$export$c7ddca13cbeae5da; });
$parcel$export(module.exports, "SCROLL_TO_TOP_DURATION", function () { return $c23dbeb333b86bd7$export$a34850322f3cf8ce; });
$parcel$export(module.exports, "PERMALINK_DELAY", function () { return $c23dbeb333b86bd7$export$1d4a9527ba02f383; });
$parcel$export(module.exports, "COMMENT_PERMALINK_SCROLL_OFFSET", function () { return $c23dbeb333b86bd7$export$4bbd56333fb4a9a4; });
$parcel$export(module.exports, "LINE_PERMALINK_SCROLL_OFFSET", function () { return $c23dbeb333b86bd7$export$63b8d21e961632a3; });
$parcel$export(module.exports, "SIDEBAR_EXPANDER_SCROLL_OFFSET", function () { return $c23dbeb333b86bd7$export$53af6cc97403a5e4; });

var $aP6k3 = parcelRequire("aP6k3");
const $c23dbeb333b86bd7$export$c7ddca13cbeae5da = 600;
const $c23dbeb333b86bd7$export$a34850322f3cf8ce = 1500;
const $c23dbeb333b86bd7$export$1d4a9527ba02f383 = $c23dbeb333b86bd7$export$c7ddca13cbeae5da + 100;
const $c23dbeb333b86bd7$export$4bbd56333fb4a9a4 = (0, $aP6k3.gridSize)() * 2;
const $c23dbeb333b86bd7$export$63b8d21e961632a3 = (0, $aP6k3.gridSize)() / 2;
const $c23dbeb333b86bd7$export$53af6cc97403a5e4 = 2 * ((0, $aP6k3.gridSize)() * 4);

});

parcelRegister("jajUg", function(module, exports) {

$parcel$export(module.exports, "InjectIntlContext", function () { return $cdb4ee6c6fb6c209$export$2c51da908944edf3; });
$parcel$export(module.exports, "useIntl", function () { return $cdb4ee6c6fb6c209$export$5aebe9a147f4d146; });

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");
const $cdb4ee6c6fb6c209$export$9073ae457aa4b186 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createContext({});
const $cdb4ee6c6fb6c209$export$2c51da908944edf3 = (0, $agjvf.injectIntl)(({ intl: intl, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($cdb4ee6c6fb6c209$export$9073ae457aa4b186.Provider, {
        value: intl
    }, children);
});
const $cdb4ee6c6fb6c209$export$5aebe9a147f4d146 = ()=>{
    return (0, $9nHZC.useContext)($cdb4ee6c6fb6c209$export$9073ae457aa4b186);
};

});

parcelRegister("dqY9c", function(module, exports) {

$parcel$export(module.exports, "useHistory__UNSAFE", function () { return $fec18bcd1ed4b2e6$export$3b8abbd648135279; });
$parcel$export(module.exports, "useLocation", function () { return $fec18bcd1ed4b2e6$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useMatch", function () { return $fec18bcd1ed4b2e6$export$6c330e8992e8a295; });
$parcel$export(module.exports, "useParams", function () { return $fec18bcd1ed4b2e6$export$99eaa27ddbbb95ef; });
parcelRequire("lM4y8");
var $b7V6F = parcelRequire("b7V6F");
const $fec18bcd1ed4b2e6$export$3b8abbd648135279 = ()=>{
    const [routerState] = (0, $b7V6F.useRouter)();
    // @ts-ignore history is intentionally untyped
    return routerState.history;
};
const $fec18bcd1ed4b2e6$export$45d76561a5302f2b = ()=>{
    const [{ location: location }] = (0, $b7V6F.useRouter)();
    return location;
};
const $fec18bcd1ed4b2e6$export$6c330e8992e8a295 = ()=>{
    const [{ match: match }] = (0, $b7V6F.useRouter)();
    return match;
};
const $fec18bcd1ed4b2e6$export$99eaa27ddbbb95ef = ()=>{
    const match = $fec18bcd1ed4b2e6$export$6c330e8992e8a295();
    return match.params;
};

});

parcelRegister("iuBF6", function(module, exports) {

$parcel$export(module.exports, "InvitationsPanel", function () { return $60b688d113d93262$export$9028cbe446de855; });

var $9nHZC = parcelRequire("9nHZC");

var $3XbtU = parcelRequire("3XbtU");

var $inFLm = parcelRequire("inFLm");

var $97xxA = parcelRequire("97xxA");

var $gulLc = parcelRequire("gulLc");

var $7doh5 = parcelRequire("7doh5");
parcelRequire("jn0KA");
var $d6OwB = parcelRequire("d6OwB");
parcelRequire("l8rpz");
var $eQRm3 = parcelRequire("eQRm3");

var $oyaJz = parcelRequire("oyaJz");

var $dyEnO = parcelRequire("dyEnO");

var $jajUg = parcelRequire("jajUg");

var $1IvI9 = parcelRequire("1IvI9");
parcelRequire("DVpDa");
var $4HDjC = parcelRequire("4HDjC");

var $aYcqR = parcelRequire("aYcqR");

var $kxoZJ = parcelRequire("kxoZJ");

var $3OyMe = parcelRequire("3OyMe");
const $60b688d113d93262$var$EMAIL_HEADER_WIDTH = 54;
const $60b688d113d93262$var$ACTIONS_HEADER_WIDTH = 23;
const $60b688d113d93262$var$INVITATIONS_PAGE_SIZE = 10;
const $60b688d113d93262$export$60a2cd0cf4aa9cf0 = ({ workspaceSlug: workspaceSlug, groupSlug: groupSlug, projectKey: projectKey, repoSlug: repoSlug, refreshCount: refreshCount = 0 })=>{
    const intl = (0, $jajUg.useIntl)();
    const { showErrorFlag: showErrorFlag } = (0, $dyEnO.useFlag)({
        enableForPdvs: true
    });
    const [invitations, setInvitations] = (0, $9nHZC.useState)([]);
    const [{ resent: resent, resendInProgress: resendInProgress, cancelInProgress: cancelInProgress }, setInviteState] = (0, $1IvI9.useObjectState)({
        cancelInProgress: null,
        resendInProgress: null,
        resent: {}
    });
    const handleError = (0, $9nHZC.useCallback)((e)=>{
        var _e$error;
        $3XbtU.captureException(e);
        showErrorFlag((e === null || e === void 0 ? void 0 : e.message) || (e === null || e === void 0 ? void 0 : (_e$error = e.error) === null || _e$error === void 0 ? void 0 : _e$error.message));
    }, [
        showErrorFlag
    ]);
    (0, $9nHZC.useEffect)(()=>{
        if (groupSlug) (0, $3OyMe.getWorkspaceInvitations)(workspaceSlug).then((invites)=>{
            const groupInvites = invites.filter((invite)=>{
                var _invite$groups;
                return (_invite$groups = invite.groups) === null || _invite$groups === void 0 ? void 0 : _invite$groups.some((groupId)=>groupId.split("/")[1] === groupSlug);
            });
            setInvitations(groupInvites);
        }).catch((e)=>{
            handleError(e);
        });
        else if (projectKey) (0, $3OyMe.getProjectInvitations)(workspaceSlug, projectKey).then((projectInvites)=>{
            setInvitations(projectInvites);
        }).catch((e)=>{
            handleError(e);
        });
        else if (repoSlug) (0, $3OyMe.getRepositoryInvitations)(workspaceSlug, repoSlug).then((repoInvites)=>{
            setInvitations(repoInvites);
        }).catch((e)=>{
            handleError(e);
        });
    }, [
        workspaceSlug,
        groupSlug,
        projectKey,
        repoSlug,
        refreshCount,
        handleError
    ]);
    const onResendInvite = (0, $9nHZC.useCallback)((invite)=>{
        setInviteState({
            resendInProgress: invite.email
        });
        if (groupSlug) (0, $3OyMe.sendWorkspaceInvitation)(workspaceSlug, {
            email: invite.email,
            group_slug: groupSlug
        }).then(()=>setInviteState({
                resent: {
                    ...resent,
                    [invite.email]: true
                }
            })).catch((e)=>handleError(e)).finally(()=>setInviteState({
                resendInProgress: null
            }));
        else if (projectKey) (0, $3OyMe.sendProjectInvitation)(workspaceSlug, projectKey, {
            email: invite.email,
            permission: invite.permission
        }).then(()=>setInviteState({
                resent: {
                    ...resent,
                    [invite.email]: true
                }
            })).catch((e)=>handleError(e)).finally(()=>setInviteState({
                resendInProgress: null
            }));
        else if (repoSlug) (0, $3OyMe.sendRepoInvitation)(workspaceSlug, repoSlug, {
            email: invite.email,
            permission: invite.permission
        }).then(()=>setInviteState({
                resent: {
                    ...resent,
                    [invite.email]: true
                }
            })).catch((e)=>handleError(e)).finally(()=>setInviteState({
                resendInProgress: null
            }));
    }, [
        resent,
        workspaceSlug,
        groupSlug,
        projectKey,
        repoSlug,
        setInviteState,
        handleError
    ]);
    const onDeleteInvite = (0, $9nHZC.useCallback)((invite)=>{
        setInviteState({
            cancelInProgress: invite.email
        });
        if (groupSlug) (0, $3OyMe.deleteWorkspaceInvitation)(workspaceSlug, {
            email: invite.email,
            group_slug: groupSlug
        }).then(()=>{
            setInvitations(invitations.filter((inv)=>inv.email !== invite.email));
        }).catch((e)=>handleError(e)).finally(()=>setInviteState({
                cancelInProgress: null
            }));
        else if (projectKey) (0, $3OyMe.deleteProjectInvitation)(workspaceSlug, projectKey, invite).then(()=>{
            setInvitations(invitations.filter((inv)=>inv.email !== invite.email));
        }).catch((e)=>handleError(e)).finally(()=>setInviteState({
                cancelInProgress: null
            }));
        else if (repoSlug) (0, $3OyMe.deleteRepoInvitation)(workspaceSlug, repoSlug, invite).then(()=>{
            setInvitations(invitations.filter((inv)=>inv.email !== invite.email));
        }).catch((e)=>handleError(e)).finally(()=>setInviteState({
                cancelInProgress: null
            }));
    }, [
        workspaceSlug,
        groupSlug,
        projectKey,
        repoSlug,
        invitations,
        setInvitations,
        setInviteState,
        handleError
    ]);
    const getInvitationRows = ()=>invitations.map((invite)=>({
                key: `row-${invite.email}`,
                cells: [
                    {
                        key: `_email-address-${invite.email}`,
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $oyaJz.default), {
                            avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $inFLm.default), {
                                size: "medium"
                            }),
                            name: invite.email,
                            additionalInfo: (0, $eQRm3.relativeDateString)(invite.utc_sent_on, intl)
                        })
                    },
                    {
                        key: `row-${invite.email}-resend-link`,
                        content: resent !== null && resent !== void 0 && resent[invite.email] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kxoZJ.LozengeContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7doh5.default), {
                            appearance: "success"
                        }, intl.formatMessage((0, $aYcqR.default).invitationSent))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $97xxA.default), {
                            appearance: "link",
                            isLoading: resendInProgress === invite.email,
                            onClick: ()=>onResendInvite(invite)
                        }, intl.formatMessage((0, $aYcqR.default).resendInvitation))
                    },
                    {
                        key: `row-${invite.email}-cancel-link`,
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $97xxA.default), {
                            appearance: "link",
                            spacing: "none",
                            isLoading: cancelInProgress === invite.email,
                            onClick: ()=>onDeleteInvite(invite)
                        }, intl.formatMessage((0, $aYcqR.default).cancelInvitation))
                    }
                ]
            }));
    if (!invitations.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kxoZJ.PanelWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $d6OwB.default), {
        header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kxoZJ.PanelHeader), null, intl.formatMessage((0, $aYcqR.default).invitationsTableHeader, {
            count: invitations.length
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $gulLc.default), {
        defaultSortKey: "invitation-email",
        defaultSortOrder: "ASC",
        rowsPerPage: invitations.length > $60b688d113d93262$var$INVITATIONS_PAGE_SIZE ? $60b688d113d93262$var$INVITATIONS_PAGE_SIZE : undefined,
        head: {
            cells: [
                {
                    key: "invitation-email",
                    isSortable: true,
                    content: intl.formatMessage((0, $aYcqR.default).emailAddress),
                    width: $60b688d113d93262$var$EMAIL_HEADER_WIDTH
                },
                {
                    key: "actions-resend",
                    content: "",
                    width: $60b688d113d93262$var$ACTIONS_HEADER_WIDTH
                },
                {
                    key: "actions-cancel",
                    content: intl.formatMessage((0, $aYcqR.default).actions),
                    width: $60b688d113d93262$var$ACTIONS_HEADER_WIDTH
                }
            ]
        },
        rows: getInvitationRows()
    })));
};
const $60b688d113d93262$export$9028cbe446de855 = (props)=>{
    const [isSumEnabled] = (0, $4HDjC.useIsSumEnabled)();
    if (isSumEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($60b688d113d93262$export$60a2cd0cf4aa9cf0, props);
};

});
parcelRegister("inFLm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d61ac538cc344f3e$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $hlgjl = parcelRequire("hlgjl");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $9SZaS = parcelRequire("9SZaS");

var $hARkN = parcelRequire("hARkN");

var $dxhCu = parcelRequire("dxhCu");

var $kOrqi = parcelRequire("kOrqi");

var $grUzM = parcelRequire("grUzM");

var $jv8ev = parcelRequire("jv8ev");

var $6eWbL = parcelRequire("6eWbL");

var $ggAkA = parcelRequire("ggAkA");

var $gIyCP = parcelRequire("gIyCP");

var $37gUH = parcelRequire("37gUH");

var $bAcrn = parcelRequire("bAcrn");
var $d61ac538cc344f3e$var$_templateObject;
function $d61ac538cc344f3e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d61ac538cc344f3e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d61ac538cc344f3e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d61ac538cc344f3e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d61ac538cc344f3e$var$packageName = "@atlaskit/avatar";
var $d61ac538cc344f3e$var$packageVersion = "21.15.0";
var $d61ac538cc344f3e$var$getTestId = function getTestId(testId, children) {
    return !children ? {
        "data-testid": "".concat(testId, "--inner")
    } : {
        testId: "".concat(testId, "--inner")
    };
};
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $d61ac538cc344f3e$var$getStyles = function getStyles(css, _ref) {
    var size = _ref.size, radius = _ref.radius, appearance = _ref.appearance, _ref$borderColor = _ref.borderColor, borderColor = _ref$borderColor === void 0 ? (0, $kOrqi.fg)("platform-component-visual-refresh") ? "var(--ds-surface, #FFFFFF)" : "var(--ds-surface-overlay, ".concat((0, $grUzM.N0), ")") : _ref$borderColor, stackIndex = _ref.stackIndex, isInteractive = _ref.isInteractive, isDisabled = _ref.isDisabled;
    return css($d61ac538cc344f3e$var$_templateObject || ($d61ac538cc344f3e$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
        "\n		height: ",
        "px;\n		width: ",
        "px;\n		align-items: stretch;\n		background-color: ",
        ";\n		border-radius: ",
        ";\n		box-sizing: content-box;\n		cursor: inherit;\n		display: flex;\n		flex-direction: column;\n		justify-content: center;\n		outline: none;\n		overflow: hidden;\n		position: static;\n		transform: translateZ(0);\n		transition:\n			transform 200ms,\n			opacity 200ms;\n		box-shadow: 0 0 0 ",
        "px ",
        ";\n		border: none;\n		margin: ",
        ";\n		padding: ",
        ";\n\n		&::-moz-focus-inner {\n			border: 0;\n			margin: ",
        ";\n			padding: ",
        ";\n		}\n\n		&::after {\n			background-color: transparent;\n			inset: 0px;\n\n			/* Added border-radius style to fix hover issue in safari */\n			border-radius: ",
        ";\n			content: ' ';\n			opacity: 0;\n			pointer-events: none;\n			position: absolute;\n			transition: opacity 200ms;\n			width: 100%;\n		}\n\n		:focus {\n			box-shadow: none;\n		}\n\n		",
        "\n\n		",
        "\n\n    ",
        "\n	"
    ])), size, size, borderColor, appearance === "circle" ? "50%" : "".concat(radius, "px"), (0, $6eWbL.BORDER_WIDTH), borderColor, "var(--ds-space-025, 2px)", "var(--ds-space-0, 0px)", "var(--ds-space-0, 0px)", "var(--ds-space-0, 0px)", appearance === "circle" ? "50%" : "".concat(radius, "px"), stackIndex && "position: relative;", isInteractive && "\n      cursor: pointer;\n\n      :hover {\n        &::after {\n          background-color: ".concat("var(--ds-interaction-hovered, ".concat((0, $grUzM.N70A), ")"), ";\n          opacity: 1;\n        }\n      }\n\n      :active {\n        &::after {\n          background-color: ", "var(--ds-interaction-pressed, ".concat((0, $grUzM.N70A), ")"), ";\n          opacity: 1;\n        }\n      }\n\n      :active {\n        transform: scale(", (0, $6eWbL.ACTIVE_SCALE_FACTOR), ");\n      }\n\n      @media screen and (forced-colors: active) {\n        &:focus-visible {\n          outline: 1px solid\n        }\n      }\n    "), isDisabled && "\n        cursor: not-allowed;\n\n        &::after {\n          opacity: ".concat("var(--ds-opacity-disabled, 0.7)", ";\n          pointer-events: none;\n          background-color: ", "var(--ds-surface, ".concat((0, $grUzM.N0), ")"), ";\n        }\n      "));
};
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ var $d61ac538cc344f3e$var$Avatar = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref2, ref) {
    var _ref3;
    var analyticsContext = _ref2.analyticsContext, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "circle" : _ref2$appearance, label = _ref2.label, borderColor = _ref2.borderColor, children = _ref2.children, href = _ref2.href, isDisabled = _ref2.isDisabled, name = _ref2.name, onClick = _ref2.onClick, presence = _ref2.presence, sizeProp = _ref2.size, src = _ref2.src, stackIndex = _ref2.stackIndex, status = _ref2.status, target = _ref2.target, testId = _ref2.testId, _ref2$as = _ref2.as, AvatarContainer = _ref2$as === void 0 ? "div" : _ref2$as;
    var _useAnalyticsEvents = (0, $hARkN.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var context = (0, $ggAkA.useAvatarContext)();
    var size = (_ref3 = sizeProp !== null && sizeProp !== void 0 ? sizeProp : context === null || context === void 0 ? void 0 : context.size) !== null && _ref3 !== void 0 ? _ref3 : "medium";
    var customPresenceNode = /*#__PURE__*/ (0, $9nHZC.isValidElement)(presence) ? presence : null;
    var customStatusNode = /*#__PURE__*/ (0, $9nHZC.isValidElement)(status) ? status : null;
    var isValidIconSize = size !== "xxlarge" && size !== "xsmall";
    var lastAnalytics = (0, $9nHZC.useRef)(analyticsContext);
    var uuid = (0, $9SZaS.useUIDSeed)()("avatar");
    (0, $9nHZC.useEffect)(function() {
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    var onClickHandler = (0, $9nHZC.useCallback)(function(event) {
        if (isDisabled || typeof onClick !== "function") return;
        var analyticsEvent = createAnalyticsEvent({
            action: "clicked",
            actionSubject: "avatar",
            attributes: {
                componentName: "avatar",
                packageName: $d61ac538cc344f3e$var$packageName,
                packageVersion: $d61ac538cc344f3e$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ var context = $d61ac538cc344f3e$var$_objectSpread({
            componentName: "avatar",
            packageName: $d61ac538cc344f3e$var$packageName,
            packageVersion: $d61ac538cc344f3e$var$packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    var componentProps = function componentProps() {
        if (isDisabled) return {
            disabled: true
        };
        // return only relevant props for either anchor or button elements
        return $d61ac538cc344f3e$var$_objectSpread($d61ac538cc344f3e$var$_objectSpread({}, href && (0, $bAcrn.getLinkProps)(href, target)), onClick && !href ? (0, $bAcrn.getButtonProps)(onClickHandler) : {
            onClick: onClick
        });
    };
    var isPresence = isValidIconSize && presence && !status;
    var isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    var defaultLabel = [
        name,
        isStatus && !customStatusNode && "(".concat(status, ")"),
        isPresence && !customPresenceNode && "(".concat(presence, ")")
    ].filter(Boolean).join(" ");
    var isInteractive = onClick || href || isDisabled;
    var containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return (0, $avKww.jsx)(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? "img" : undefined,
        "aria-labelledby": containerShouldBeImage ? "".concat(uuid, "-label") : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: "inline-block",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: "relative",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            outline: 0,
            zIndex: stackIndex
        }
    }, (0, $avKww.jsx)((0, $avKww.ClassNames), null, function(_ref4) {
        var css = _ref4.css;
        var props = $d61ac538cc344f3e$var$_objectSpread($d61ac538cc344f3e$var$_objectSpread($d61ac538cc344f3e$var$_objectSpread($d61ac538cc344f3e$var$_objectSpread({
            className: $d61ac538cc344f3e$var$getStyles(css, {
                size: (0, $6eWbL.AVATAR_SIZES)[size],
                radius: (0, $6eWbL.AVATAR_RADIUS)[size],
                appearance: appearance,
                borderColor: borderColor,
                stackIndex: stackIndex,
                isInteractive: Boolean(href || onClick) && !isDisabled,
                isDisabled: isDisabled
            })
        }, componentProps()), testId && $d61ac538cc344f3e$var$getTestId(testId, children)), (isInteractive || children) && {
            "aria-label": label || defaultLabel
        }), {}, {
            children: (0, $avKww.jsx)((0, $jv8ev.default), {
                alt: !containerShouldBeImage && src ? name : undefined,
                appearance: appearance,
                size: size,
                src: src,
                testId: testId
            }),
            ref: ref
        });
        if (children) return children(props);
        var element = (0, $bAcrn.getCustomElement)(isDisabled, href, onClick);
        return element === "a" || element === "button" ? (0, $avKww.jsx)((0, $dxhCu.default), null, /*#__PURE__*/ (0, $9nHZC.createElement)(element, props)) : /*#__PURE__*/ (0, $9nHZC.createElement)(element, props);
    }), isPresence && (0, $avKww.jsx)((0, $gIyCP.PresenceWrapper), {
        appearance: appearance,
        size: size,
        presence: typeof presence === "string" ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && (0, $avKww.jsx)((0, $37gUH.StatusWrapper), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: typeof status === "string" ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? (0, $avKww.jsx)("span", {
        "data-testid": testId && "".concat(testId, "--label"),
        id: "".concat(uuid, "-label"),
        hidden: true
    }, defaultLabel) : undefined);
});
$d61ac538cc344f3e$var$Avatar.displayName = "Avatar";
var $d61ac538cc344f3e$export$2e2bcd8739ae039 = $d61ac538cc344f3e$var$Avatar;

});
parcelRegister("hlgjl", function(module, exports) {
function $ca010ce2af22ac0e$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
module.exports = $ca010ce2af22ac0e$var$_taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hARkN", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $ccef2b8e6d5591d4$export$5bf35293e545f20c; });

var $dNznA = parcelRequire("dNznA");

var $h0I7p = parcelRequire("h0I7p");

var $esbyl = parcelRequire("esbyl");
function $ccef2b8e6d5591d4$export$5bf35293e545f20c() {
    var analyticsContext = (0, $esbyl.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $h0I7p.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("h0I7p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c624a8c8b24c6393$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $eGO9T = parcelRequire("eGO9T");
function $c624a8c8b24c6393$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c624a8c8b24c6393$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $c624a8c8b24c6393$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c624a8c8b24c6393$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $c624a8c8b24c6393$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $c624a8c8b24c6393$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $c624a8c8b24c6393$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $c624a8c8b24c6393$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $eGO9T.default));

});
parcelRegister("eGO9T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab1be564de311e42$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
function $ab1be564de311e42$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ab1be564de311e42$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ab1be564de311e42$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ab1be564de311e42$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ab1be564de311e42$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $ab1be564de311e42$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $ab1be564de311e42$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $ab1be564de311e42$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(updater) === "object") this.payload = $ab1be564de311e42$var$_objectSpread($ab1be564de311e42$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("esbyl", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $a85ca46682482aa3$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $a85ca46682482aa3$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});


parcelRegister("kOrqi", function(module, exports) {

$parcel$export(module.exports, "getBooleanFF", function () { return $f26dbfd0d12f9d06$export$470e5c2be1411c89; });
$parcel$export(module.exports, "fg", function () { return $f26dbfd0d12f9d06$export$b40ec24ac8275656; });

var $bL83T = parcelRequire("bL83T");
function $f26dbfd0d12f9d06$export$ba05d765b8392e5e(flagResolver) {
    (0, $bL83T.setBooleanResolver)(flagResolver);
}
function $f26dbfd0d12f9d06$export$470e5c2be1411c89(name) {
    return (0, $bL83T.resolveBooleanFlag)(name);
}
function $f26dbfd0d12f9d06$export$b40ec24ac8275656(name) {
    return (0, $bL83T.resolveBooleanFlag)(name);
}

});
parcelRegister("bL83T", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $88fa566c0965a447$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $88fa566c0965a447$export$6333b6aff9fc6275; });

var $djgoF = parcelRequire("djgoF");

var $8ovux = parcelRequire("8ovux");
var $88fa566c0965a447$var$pkgName = "@atlaskit/platform-feature-flags";
var $88fa566c0965a447$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $88fa566c0965a447$var$hasProcessEnv = typeof $8ovux !== "undefined" && typeof $8ovux.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $88fa566c0965a447$var$ENV_ENABLE_PLATFORM_FF = $88fa566c0965a447$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $88fa566c0965a447$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $88fa566c0965a447$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $88fa566c0965a447$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $88fa566c0965a447$var$ENV_ENABLE_PLATFORM_FF || $88fa566c0965a447$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $88fa566c0965a447$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $88fa566c0965a447$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$88fa566c0965a447$var$globalVar[$88fa566c0965a447$export$7e41b1b2bdee3f98] = $88fa566c0965a447$var$globalVar[$88fa566c0965a447$export$7e41b1b2bdee3f98] || $88fa566c0965a447$var$DEFAULT_PFF_GLOBAL;
function $88fa566c0965a447$export$f2b591175b3e424c(resolver) {
    $88fa566c0965a447$var$globalVar[$88fa566c0965a447$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $88fa566c0965a447$export$6333b6aff9fc6275(flagKey) {
    if ($88fa566c0965a447$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $djgoF.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $88fa566c0965a447$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $88fa566c0965a447$var$globalVar[$88fa566c0965a447$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("djgoF", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $9b09c4c50031ad9f$export$1c9f709888824e05; });
var $9b09c4c50031ad9f$var$_ref, $9b09c4c50031ad9f$var$_process, $9b09c4c50031ad9f$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $9b09c4c50031ad9f$var$TESTS_MODE = ($9b09c4c50031ad9f$var$_ref = (globalThis === null || globalThis === void 0 || ($9b09c4c50031ad9f$var$_process = globalThis.process) === null || $9b09c4c50031ad9f$var$_process === void 0 || ($9b09c4c50031ad9f$var$_process = $9b09c4c50031ad9f$var$_process.env) === null || $9b09c4c50031ad9f$var$_process === void 0 ? void 0 : $9b09c4c50031ad9f$var$_process.JEST_WORKER_ID) !== undefined, $9b09c4c50031ad9f$var$_ref !== void 0) ? $9b09c4c50031ad9f$var$_ref : false;
var $9b09c4c50031ad9f$var$DEBUG_MODE = !$9b09c4c50031ad9f$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($9b09c4c50031ad9f$var$_process2 = globalThis.process) === null || $9b09c4c50031ad9f$var$_process2 === void 0 || ($9b09c4c50031ad9f$var$_process2 = $9b09c4c50031ad9f$var$_process2.env) === null || $9b09c4c50031ad9f$var$_process2 === void 0 ? void 0 : $9b09c4c50031ad9f$var$_process2.NODE_ENV) !== "production";
var $9b09c4c50031ad9f$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$9b09c4c50031ad9f$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("grUzM", function(module, exports) {

$parcel$export(module.exports, "R300", function () { return $bf9b0dcb85421d39$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $bf9b0dcb85421d39$export$2010d0fb4295b346; });
$parcel$export(module.exports, "G300", function () { return $bf9b0dcb85421d39$export$940e1f69e873f202; });
$parcel$export(module.exports, "G400", function () { return $bf9b0dcb85421d39$export$a49394138f7b8e85; });
$parcel$export(module.exports, "B50", function () { return $bf9b0dcb85421d39$export$226de0355ed012f8; });
$parcel$export(module.exports, "B200", function () { return $bf9b0dcb85421d39$export$215b7063051591f1; });
$parcel$export(module.exports, "P300", function () { return $bf9b0dcb85421d39$export$b48405b95304b5a1; });
$parcel$export(module.exports, "N0", function () { return $bf9b0dcb85421d39$export$29a4f05edc054374; });
$parcel$export(module.exports, "N30", function () { return $bf9b0dcb85421d39$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N40", function () { return $bf9b0dcb85421d39$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N90", function () { return $bf9b0dcb85421d39$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N200", function () { return $bf9b0dcb85421d39$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N500", function () { return $bf9b0dcb85421d39$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N20A", function () { return $bf9b0dcb85421d39$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $bf9b0dcb85421d39$export$920c0d5c49070351; });
$parcel$export(module.exports, "N70A", function () { return $bf9b0dcb85421d39$export$6e5e7499ff054f6d; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $bf9b0dcb85421d39$export$4b84fd0e2c617bd = "#FFEBE6";
var $bf9b0dcb85421d39$export$b34b069eff244586 = "#FFBDAD";
var $bf9b0dcb85421d39$export$be802dd0d8b57f35 = "#FF8F73";
var $bf9b0dcb85421d39$export$60847d42f9da92a6 = "#FF7452";
var $bf9b0dcb85421d39$export$4a7404f376229999 = "#FF5630";
var $bf9b0dcb85421d39$export$2010d0fb4295b346 = "#DE350B";
var $bf9b0dcb85421d39$export$2837b5a1a71d5c02 = "#BF2600";
var $bf9b0dcb85421d39$export$8d9596b529bbb9cf = "#FFFAE6";
var $bf9b0dcb85421d39$export$41060a744ab0b7ae = "#FFF0B3";
var $bf9b0dcb85421d39$export$1cc05bbbf340e559 = "#FFE380";
var $bf9b0dcb85421d39$export$5aae31392d72caaa = "#FFC400";
var $bf9b0dcb85421d39$export$c6930421db9fa514 = "#FFAB00";
var $bf9b0dcb85421d39$export$59619663aa6500fb = "#FF991F";
var $bf9b0dcb85421d39$export$874739ea9e379ab6 = "#FF8B00";
var $bf9b0dcb85421d39$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $bf9b0dcb85421d39$export$69a3bf21b9686c2b = "#ABF5D1";
var $bf9b0dcb85421d39$export$afbce1382ec95f73 = "#79F2C0";
var $bf9b0dcb85421d39$export$747d86715d4175de = "#57D9A3";
var $bf9b0dcb85421d39$export$940e1f69e873f202 = "#36B37E";
var $bf9b0dcb85421d39$export$a49394138f7b8e85 = "#00875A";
var $bf9b0dcb85421d39$export$6fa04827ac68a4fb = "#006644";
var $bf9b0dcb85421d39$export$226de0355ed012f8 = "#DEEBFF";
var $bf9b0dcb85421d39$export$8c13c2ee36917869 = "#B3D4FF";
var $bf9b0dcb85421d39$export$ecfc1dff386a3e7a = "#4C9AFF";
var $bf9b0dcb85421d39$export$215b7063051591f1 = "#2684FF";
var $bf9b0dcb85421d39$export$e62e8919cca44969 = "#0065FF";
var $bf9b0dcb85421d39$export$b3de0ae08da2ce64 = "#0052CC";
var $bf9b0dcb85421d39$export$a6ee3d71bc067634 = "#0747A6";
var $bf9b0dcb85421d39$export$363e4475840015bb = "#EAE6FF";
var $bf9b0dcb85421d39$export$4b0a4417ed59760f = "#C0B6F2";
var $bf9b0dcb85421d39$export$6011520a64d9a187 = "#998DD9";
var $bf9b0dcb85421d39$export$a7175d4e9206bc80 = "#8777D9";
var $bf9b0dcb85421d39$export$b48405b95304b5a1 = "#6554C0";
var $bf9b0dcb85421d39$export$c71e4279dd54a18d = "#5243AA";
var $bf9b0dcb85421d39$export$147899de772240ec = "#403294";
var $bf9b0dcb85421d39$export$2cf711fe14c66f06 = "#E6FCFF";
var $bf9b0dcb85421d39$export$7a8f4d33f6f9772c = "#B3F5FF";
var $bf9b0dcb85421d39$export$776c9c497ef08533 = "#79E2F2";
var $bf9b0dcb85421d39$export$69cb3ca10c1e330e = "#00C7E6";
var $bf9b0dcb85421d39$export$9dc1ef0f3f48059b = "#00B8D9";
var $bf9b0dcb85421d39$export$7c835c78b6fcdef8 = "#00A3BF";
var $bf9b0dcb85421d39$export$6036577f95c3877e = "#008DA6";
var $bf9b0dcb85421d39$export$29a4f05edc054374 = "#FFFFFF";
var $bf9b0dcb85421d39$export$e655ef011c4aa1a2 = "#FAFBFC";
var $bf9b0dcb85421d39$export$9fdfb749e33cdf97 = "#F4F5F7";
var $bf9b0dcb85421d39$export$3e51e8f1440314ba = "#EBECF0";
var $bf9b0dcb85421d39$export$1ce2d1575d444ceb = "#DFE1E6";
var $bf9b0dcb85421d39$export$8754fc7e6d8b3000 = "#C1C7D0";
var $bf9b0dcb85421d39$export$c2e91cbeada39b8b = "#B3BAC5";
var $bf9b0dcb85421d39$export$5f71e19f3a7ad9de = "#A5ADBA";
var $bf9b0dcb85421d39$export$eaa8c8a70ac22806 = "#97A0AF";
var $bf9b0dcb85421d39$export$7c87d337fb91a97d = "#8993A4";
var $bf9b0dcb85421d39$export$d6447c357493214f = "#7A869A";
var $bf9b0dcb85421d39$export$f563ee71e9ee74cd = "#6B778C";
var $bf9b0dcb85421d39$export$e2ef2124cf4024b1 = "#5E6C84";
var $bf9b0dcb85421d39$export$eece5f492e429f08 = "#505F79";
var $bf9b0dcb85421d39$export$c39c0fe0f26207ae = "#42526E";
var $bf9b0dcb85421d39$export$7090862dc3038a9f = "#344563";
var $bf9b0dcb85421d39$export$ad0bacf983b7ddaa = "#253858";
var $bf9b0dcb85421d39$export$7d61b15e0da132af = "#172B4D";
var $bf9b0dcb85421d39$export$fbda843f0a27fe96 = "#091E42";
var $bf9b0dcb85421d39$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $bf9b0dcb85421d39$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $bf9b0dcb85421d39$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $bf9b0dcb85421d39$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $bf9b0dcb85421d39$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $bf9b0dcb85421d39$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $bf9b0dcb85421d39$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $bf9b0dcb85421d39$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $bf9b0dcb85421d39$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $bf9b0dcb85421d39$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $bf9b0dcb85421d39$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $bf9b0dcb85421d39$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $bf9b0dcb85421d39$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $bf9b0dcb85421d39$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $bf9b0dcb85421d39$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $bf9b0dcb85421d39$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $bf9b0dcb85421d39$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $bf9b0dcb85421d39$export$2f6319cf7d736c2a = "#E6EDFA";
var $bf9b0dcb85421d39$export$95126bc8884d6634 = "#DCE5F5";
var $bf9b0dcb85421d39$export$8338d8c35d44ff1 = "#CED9EB";
var $bf9b0dcb85421d39$export$5368d76ae4fbbda7 = "#B8C7E0";
var $bf9b0dcb85421d39$export$9f0a771d16ec8d36 = "#ABBBD6";
var $bf9b0dcb85421d39$export$abcf8c38338b4aa5 = "#9FB0CC";
var $bf9b0dcb85421d39$export$97e81faa16a182c7 = "#8C9CB8";
var $bf9b0dcb85421d39$export$bfe21c59123ecf33 = "#7988A3";
var $bf9b0dcb85421d39$export$ee82aa2ea6a1558 = "#67758F";
var $bf9b0dcb85421d39$export$682927c6ed76be02 = "#56637A";
var $bf9b0dcb85421d39$export$91fd9994c5be9757 = "#455166";
var $bf9b0dcb85421d39$export$d281fbfe3cff2df6 = "#3B475C";
var $bf9b0dcb85421d39$export$3902c91d8b98a753 = "#313D52";
var $bf9b0dcb85421d39$export$8e8133c1ba5845b5 = "#283447";
var $bf9b0dcb85421d39$export$33ff357f6620b39 = "#202B3D";
var $bf9b0dcb85421d39$export$633847cf062b69e0 = "#1B2638";
var $bf9b0dcb85421d39$export$9776a6e503bdbf76 = "#121A29";
var $bf9b0dcb85421d39$export$6c813d5160dff5db = "#0E1624";
var $bf9b0dcb85421d39$export$3d4f271a500072a = "#0D1424";
var $bf9b0dcb85421d39$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $bf9b0dcb85421d39$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $bf9b0dcb85421d39$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $bf9b0dcb85421d39$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $bf9b0dcb85421d39$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $bf9b0dcb85421d39$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $bf9b0dcb85421d39$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $bf9b0dcb85421d39$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $bf9b0dcb85421d39$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $bf9b0dcb85421d39$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $bf9b0dcb85421d39$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $bf9b0dcb85421d39$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $bf9b0dcb85421d39$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $bf9b0dcb85421d39$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $bf9b0dcb85421d39$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $bf9b0dcb85421d39$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $bf9b0dcb85421d39$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";

});

parcelRegister("jv8ev", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3274c781516a384$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $j5L6m = parcelRequire("j5L6m");

var $k6S6m = parcelRequire("k6S6m");

var $5fnaU = parcelRequire("5fnaU");

var $acpho = parcelRequire("acpho");

var $kOrqi = parcelRequire("kOrqi");

var $grUzM = parcelRequire("grUzM");

var $6eWbL = parcelRequire("6eWbL");
function $e3274c781516a384$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e3274c781516a384$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e3274c781516a384$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e3274c781516a384$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e3274c781516a384$var$avatarDefaultIconStyles = (0, $avKww.css)({
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "var(--ds-icon-subtle, ".concat((0, $grUzM.N90), ")")
});
var $e3274c781516a384$var$avatarDefaultIconVisualRefreshStyles = (0, $avKww.css)({
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
});
var $e3274c781516a384$var$nestedAvatarStyles = Object.entries((0, $6eWbL.AVATAR_SIZES)).reduce(function(styles, _ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), key = _ref2[0], size = _ref2[1];
    return $e3274c781516a384$var$_objectSpread($e3274c781516a384$var$_objectSpread({}, styles), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, key, (0, $avKww.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "& svg": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: "".concat(size, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: "".concat(size, "px")
        }
    })));
}, {});
var $e3274c781516a384$var$avatarImageStyles = (0, $avKww.css)({
    display: "flex",
    width: "100%",
    height: "100%",
    flex: "1 1 100%"
});
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ var $e3274c781516a384$var$AvatarImage = function AvatarImage(_ref3) {
    var _ref3$alt = _ref3.alt, alt = _ref3$alt === void 0 ? "" : _ref3$alt, src = _ref3.src, appearance = _ref3.appearance, size = _ref3.size, testId = _ref3.testId;
    var _useState = (0, $9nHZC.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    var borderRadius = appearance === "circle" ? "50%" : "".concat((0, $6eWbL.AVATAR_RADIUS)[size], "px");
    var isHidden = !alt ? true : undefined;
    // If src changes, reset state
    (0, $9nHZC.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return (0, $avKww.jsx)("span", {
        css: [
            (0, $kOrqi.fg)("platform-component-visual-refresh") ? $e3274c781516a384$var$avatarDefaultIconVisualRefreshStyles : $e3274c781516a384$var$avatarDefaultIconStyles,
            $e3274c781516a384$var$nestedAvatarStyles[size]
        ]
    }, appearance === "circle" ? (0, $kOrqi.fg)("platform-component-visual-refresh") ? (0, $avKww.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($j5L6m))), {
        label: alt,
        color: "var(--ds-icon-subtle, #626F86)",
        testId: testId && "".concat(testId, "--person"),
        spacing: "spacious"
    }) : (0, $avKww.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5fnaU))), {
        label: alt,
        primaryColor: "var(--ds-icon-inverse, ".concat((0, $grUzM.N0), ")"),
        secondaryColor: "var(--ds-icon-subtle, ".concat((0, $grUzM.N90), ")"),
        testId: testId && "".concat(testId, "--person"),
        "aria-hidden": isHidden
    }) : (0, $kOrqi.fg)("platform-component-visual-refresh") ? (0, $avKww.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k6S6m))), {
        label: alt,
        color: "var(--ds-icon-subtle, #626F86)",
        testId: testId && "".concat(testId, "--ship"),
        spacing: "spacious"
    }) : (0, $avKww.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acpho))), {
        label: alt,
        primaryColor: "var(--ds-icon-inverse, ".concat((0, $grUzM.N0), ")"),
        secondaryColor: "var(--ds-icon-subtle, ".concat((0, $grUzM.N90), ")"),
        testId: testId && "".concat(testId, "--ship"),
        "aria-hidden": isHidden
    }));
    return (0, $avKww.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && "".concat(testId, "--image"),
        css: $e3274c781516a384$var$avatarImageStyles,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: borderRadius
        },
        onError: function onError() {
            return setHasImageErrored(true);
        },
        "aria-hidden": isHidden,
        "data-vc": testId ? "".concat(testId, "--image") : "avatar-image"
    });
};
var $e3274c781516a384$export$2e2bcd8739ae039 = $e3274c781516a384$var$AvatarImage;

});
parcelRegister("j5L6m", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::112dba5b505c6a9c25d6aa59e6867dde>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de6305553e6ab436$var$_react = $de6305553e6ab436$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $de6305553e6ab436$var$_UNSAFE_baseNew = $de6305553e6ab436$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $de6305553e6ab436$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $de6305553e6ab436$var$PersonIcon = (props)=>/*#__PURE__*/ $de6305553e6ab436$var$_react.default.createElement($de6305553e6ab436$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 15v-2.25a3 3 0 0 0-3-3h-4.5a3 3 0 0 0-3 3V15m8.5-11a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
    }, props));
$de6305553e6ab436$var$PersonIcon.displayName = "PersonIcon";
var $de6305553e6ab436$var$_default = module.exports.default = $de6305553e6ab436$var$PersonIcon;

});

parcelRegister("k6S6m", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d0402f1ef768e7347d258c7ff3a4357a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ea3e55a344daf706$var$_react = $ea3e55a344daf706$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $ea3e55a344daf706$var$_UNSAFE_baseNew = $ea3e55a344daf706$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $ea3e55a344daf706$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ea3e55a344daf706$var$ReleaseIcon = (props)=>/*#__PURE__*/ $ea3e55a344daf706$var$_react.default.createElement($ea3e55a344daf706$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M.75 7.75V7a.75.75 0 0 0-.75.75zm14.5 0 .646.382A.75.75 0 0 0 15.25 7zm-12.5-3V4a.75.75 0 0 0-.75.75zm6.25 0 .648-.378A.75.75 0 0 0 9 4zm-4.25-2V2H4v.75zm1.5 0H7V2h-.75zm6.113 9.886.646.382zm2.241-5.268-2.887 4.886 1.292.764 2.887-4.886zM11.287 12.5H2V14h9.287zM1.5 12V7.75H0V12zM.75 8.5h2V7h-2zm2.75-.75v-3H2v3zm-.75.75h8V7h-8zm8 0h4.5V7h-4.5zM8.352 5.128l1.75 3 1.296-.756-1.75-3zM2.75 5.5h2V4h-2zm2.75-.75v-2H4v2zM4.75 3.5h1.5V2h-1.5zm0 2h1.5V4h-1.5zm1.5 0H9V4H6.25zM5.5 2.75v2H7v-2zM2 12.5a.5.5 0 0 1-.5-.5H0a2 2 0 0 0 2 2zm9.717-.246a.5.5 0 0 1-.43.246V14a2 2 0 0 0 1.722-.982z"/>`
    }, props));
$ea3e55a344daf706$var$ReleaseIcon.displayName = "ReleaseIcon";
var $ea3e55a344daf706$var$_default = module.exports.default = $ea3e55a344daf706$var$ReleaseIcon;

});

parcelRegister("5fnaU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d20548c2c60acff$var$_react = $3d20548c2c60acff$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $3d20548c2c60acff$var$_person = $3d20548c2c60acff$var$_interopRequireDefault((parcelRequire("j5L6m")));
function $3d20548c2c60acff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3d20548c2c60acff$var$PersonIcon = (props)=>/*#__PURE__*/ $3d20548c2c60acff$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $3d20548c2c60acff$var$_person.default
    }));
$3d20548c2c60acff$var$PersonIcon.displayName = "PersonIcon";
var $3d20548c2c60acff$var$_default = module.exports.default = $3d20548c2c60acff$var$PersonIcon;

});

parcelRegister("acpho", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76cea2626d8a7edd$var$_react = $76cea2626d8a7edd$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $76cea2626d8a7edd$var$_release = $76cea2626d8a7edd$var$_interopRequireDefault((parcelRequire("k6S6m")));
function $76cea2626d8a7edd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $76cea2626d8a7edd$var$ShipIcon = (props)=>/*#__PURE__*/ $76cea2626d8a7edd$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 12h8v-2H6zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4z"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6zm4 0V7H7.999c.005 0 .002.003.002.005V8h2z"/><path fill-rule="nonzero" d="M4.5 17h13.994l1.002-3H4.14zm-2.495-4.012A.862.862 0 0 1 2.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.15 1.15 0 0 1-1.118-.988z"/></g></svg>`
    }, props, {
        newIcon: $76cea2626d8a7edd$var$_release.default
    }));
$76cea2626d8a7edd$var$ShipIcon.displayName = "ShipIcon";
var $76cea2626d8a7edd$var$_default = module.exports.default = $76cea2626d8a7edd$var$ShipIcon;

});

parcelRegister("6eWbL", function(module, exports) {

$parcel$export(module.exports, "AVATAR_SIZES", function () { return $48b12ff1213b9cc3$export$9a270941bcff7e77; });
$parcel$export(module.exports, "AVATAR_RADIUS", function () { return $48b12ff1213b9cc3$export$e6da6efe4d1a5c9b; });
$parcel$export(module.exports, "BORDER_WIDTH", function () { return $48b12ff1213b9cc3$export$e2bd4c1faded7921; });
$parcel$export(module.exports, "ACTIVE_SCALE_FACTOR", function () { return $48b12ff1213b9cc3$export$89a980dfdf90df51; });
$parcel$export(module.exports, "CSS_VAR_AVATAR_BGCOLOR", function () { return $48b12ff1213b9cc3$export$3c061e31594ebabe; });
$parcel$export(module.exports, "ICON_SIZES", function () { return $48b12ff1213b9cc3$export$fdc820179f1f9be4; });
$parcel$export(module.exports, "ICON_OFFSET", function () { return $48b12ff1213b9cc3$export$382610e783aa2ae8; });
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match, @atlaskit/design-system/no-deprecated-imports

var $PIT0N = parcelRequire("PIT0N");
var $48b12ff1213b9cc3$export$9a270941bcff7e77 = {
    xsmall: (0, $PIT0N.gridSize)() * 2,
    small: (0, $PIT0N.gridSize)() * 3,
    medium: (0, $PIT0N.gridSize)() * 4,
    large: (0, $PIT0N.gridSize)() * 5,
    xlarge: (0, $PIT0N.gridSize)() * 12,
    xxlarge: (0, $PIT0N.gridSize)() * 16
};
var $48b12ff1213b9cc3$export$e6da6efe4d1a5c9b = {
    xsmall: 2,
    small: 2,
    medium: 3,
    large: 3,
    xlarge: 6,
    xxlarge: 12
};
var $48b12ff1213b9cc3$export$e2bd4c1faded7921 = 2;
var $48b12ff1213b9cc3$export$89a980dfdf90df51 = 0.9;
var $48b12ff1213b9cc3$export$3c061e31594ebabe = "--avatar-background-color";
var $48b12ff1213b9cc3$export$fdc820179f1f9be4 = {
    small: 12,
    medium: 14,
    large: 15,
    xlarge: 18
};
var $48b12ff1213b9cc3$export$382610e783aa2ae8 = {
    small: 0,
    medium: 0,
    large: 1,
    xlarge: 7
};

});
parcelRegister("PIT0N", function(module, exports) {

$parcel$export(module.exports, "borderRadius", function () { return $09b795045a3c095c$export$7a57f79000377ca2; });
$parcel$export(module.exports, "gridSize", function () { return $09b795045a3c095c$export$6d8204c2cb2e06b8; });

var $1OnrY = parcelRequire("1OnrY");

var $grUzM = parcelRequire("grUzM");
var $09b795045a3c095c$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $09b795045a3c095c$export$c93026a968943f95 = "light";
var $09b795045a3c095c$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $09b795045a3c095c$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $09b795045a3c095c$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $09b795045a3c095c$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $09b795045a3c095c$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $09b795045a3c095c$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $09b795045a3c095c$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $09b795045a3c095c$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $grUzM.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $09b795045a3c095c$export$6d8204c2cb2e06b8() / 4;
    (0, $1OnrY.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $09b795045a3c095c$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $09b795045a3c095c$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $09b795045a3c095c$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $1OnrY.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $09b795045a3c095c$export$ba1d834b86d72a09 = $09b795045a3c095c$export$a1b3edb637fb4f35;
var $09b795045a3c095c$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $grUzM.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $grUzM.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $grUzM.N30A), ")")
            }
        }
    };
};

});



parcelRegister("ggAkA", function(module, exports) {

$parcel$export(module.exports, "AvatarContext", function () { return $bd7a528bcc356e7c$export$a20dad690e1279e2; });
$parcel$export(module.exports, "useAvatarContext", function () { return $bd7a528bcc356e7c$export$b50b87a1c4086b23; });

var $9nHZC = parcelRequire("9nHZC");
var $bd7a528bcc356e7c$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $9nHZC.createContext)(undefined);
var $bd7a528bcc356e7c$export$b50b87a1c4086b23 = function useAvatarContext() {
    return (0, $9nHZC.useContext)($bd7a528bcc356e7c$export$a20dad690e1279e2);
};

});

parcelRegister("gIyCP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2bb9d43cc5c4dc2$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "PresenceWrapper", function () { return $c2bb9d43cc5c4dc2$export$972c5e90200fa0ef; });
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $9nHZC = parcelRequire("9nHZC");

var $grUzM = parcelRequire("grUzM");

var $6eWbL = parcelRequire("6eWbL");

var $lRlVO = parcelRequire("lRlVO");
var $c2bb9d43cc5c4dc2$var$BusyIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $grUzM.R300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $grUzM.N0), ")"),
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
var $c2bb9d43cc5c4dc2$var$FocusIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
    fill: "var(--ds-icon-discovery, ".concat((0, $grUzM.P300), ")"),
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
var $c2bb9d43cc5c4dc2$var$OfflineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
    fill: "var(--ds-text-subtlest, ".concat((0, $grUzM.N200), ")"),
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $grUzM.N40), ")"),
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
var $c2bb9d43cc5c4dc2$var$OnlineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $grUzM.G300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
});
function $c2bb9d43cc5c4dc2$var$getPresence(presence) {
    switch(presence){
        case "busy":
            return $c2bb9d43cc5c4dc2$var$BusyIndicator;
        case "focus":
            return $c2bb9d43cc5c4dc2$var$FocusIndicator;
        case "offline":
            return $c2bb9d43cc5c4dc2$var$OfflineIndicator;
        case "online":
            return $c2bb9d43cc5c4dc2$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ var $c2bb9d43cc5c4dc2$var$AvatarPresence = function AvatarPresence(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, presence = _ref.presence;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $lRlVO.default), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $c2bb9d43cc5c4dc2$var$getPresence(presence)) : children);
};
var $c2bb9d43cc5c4dc2$export$2e2bcd8739ae039 = $c2bb9d43cc5c4dc2$var$AvatarPresence;
var $c2bb9d43cc5c4dc2$export$972c5e90200fa0ef = function PresenceWrapper(_ref2) {
    var size = _ref2.size, appearance = _ref2.appearance, children = _ref2.children, borderColor = _ref2.borderColor, presence = _ref2.presence, testId = _ref2.testId;
    var position = appearance === "square" ? -4 : (0, $6eWbL.ICON_OFFSET)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--presence"),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            pointerEvents: "none",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: "absolute",
            bottom: "".concat(position, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            height: "".concat((0, $6eWbL.ICON_SIZES)[size], "px"),
            right: "".concat(position, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: "".concat((0, $6eWbL.ICON_SIZES)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($c2bb9d43cc5c4dc2$var$AvatarPresence, {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};

});
parcelRegister("lRlVO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe9f8f51680068de$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $avKww = parcelRequire("avKww");

var $grUzM = parcelRequire("grUzM");

var $6eWbL = parcelRequire("6eWbL");
var $fe9f8f51680068de$var$iconWrapperStyles = (0, $avKww.css)({
    display: "flex",
    boxSizing: "border-box",
    width: "100%",
    height: "100%",
    alignItems: "center",
    alignContent: "center",
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    overflow: "hidden"
});
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ var $fe9f8f51680068de$var$IconWrapper = function IconWrapper(_ref) {
    var _ref$bgColor = _ref.bgColor, bgColor = _ref$bgColor === void 0 ? "var(--ds-surface-overlay, ".concat((0, $grUzM.N0), ")") : _ref$bgColor, children = _ref.children;
    return (0, $avKww.jsx)("span", {
        css: $fe9f8f51680068de$var$iconWrapperStyles,
        role: "presentation",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            border: "".concat((0, $6eWbL.BORDER_WIDTH), "px solid ").concat(bgColor),
            backgroundColor: bgColor
        }
    }, children);
};
var $fe9f8f51680068de$export$2e2bcd8739ae039 = $fe9f8f51680068de$var$IconWrapper;

});


parcelRegister("37gUH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $244f253b5a5d3d62$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "StatusWrapper", function () { return $244f253b5a5d3d62$export$8045894f255f9726; });
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $9nHZC = parcelRequire("9nHZC");

var $grUzM = parcelRequire("grUzM");

var $6eWbL = parcelRequire("6eWbL");

var $lRlVO = parcelRequire("lRlVO");
var $244f253b5a5d3d62$var$ApprovedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $grUzM.G400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $grUzM.N0), ")"),
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
var $244f253b5a5d3d62$var$DeclinedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $grUzM.R400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $grUzM.N0), ")"),
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
var $244f253b5a5d3d62$var$LockedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("circle", {
    fill: "var(--ds-text-subtlest, ".concat((0, $grUzM.N40), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $grUzM.N500), ")"),
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
function $244f253b5a5d3d62$var$getStatus(status) {
    switch(status){
        case "approved":
            return $244f253b5a5d3d62$var$ApprovedIndicator;
        case "declined":
            return $244f253b5a5d3d62$var$DeclinedIndicator;
        case "locked":
            return $244f253b5a5d3d62$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ var $244f253b5a5d3d62$var$AvatarStatus = function AvatarStatus(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, status = _ref.status;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $lRlVO.default), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $244f253b5a5d3d62$var$getStatus(status)) : children);
};
var $244f253b5a5d3d62$export$2e2bcd8739ae039 = $244f253b5a5d3d62$var$AvatarStatus;
var $244f253b5a5d3d62$export$8045894f255f9726 = function StatusWrapper(_ref2) {
    var size = _ref2.size, status = _ref2.status, appearance = _ref2.appearance, borderColor = _ref2.borderColor, children = _ref2.children, testId = _ref2.testId;
    var position = appearance === "square" ? 0 : (0, $6eWbL.ICON_OFFSET)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--status"),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: "absolute",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            height: "".concat((0, $6eWbL.ICON_SIZES)[size], "px"),
            right: "".concat(position, "px"),
            top: "".concat(position, "px"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: "".concat((0, $6eWbL.ICON_SIZES)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($244f253b5a5d3d62$var$AvatarStatus, {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};

});

parcelRegister("bAcrn", function(module, exports) {

$parcel$export(module.exports, "getLinkProps", function () { return $86ecb4f10589cb2d$export$60113ebe1cf0ecf; });
$parcel$export(module.exports, "getButtonProps", function () { return $86ecb4f10589cb2d$export$cca6f1bef43616d3; });
$parcel$export(module.exports, "getCustomElement", function () { return $86ecb4f10589cb2d$export$83ee468102cdf04c; });
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match
var $86ecb4f10589cb2d$export$60113ebe1cf0ecf = function getLinkProps(href, target) {
    return {
        href: href,
        rel: target === "_blank" ? "noopener noreferrer" : null,
        target: target
    };
};
var $86ecb4f10589cb2d$export$cca6f1bef43616d3 = function getButtonProps(onClick) {
    return {
        type: "button",
        onClick: onClick
    };
};
var $86ecb4f10589cb2d$export$83ee468102cdf04c = function getCustomElement(isDisabled, href, onClick) {
    if (href && !isDisabled) return "a";
    if (onClick || isDisabled) return "button";
    return "span";
};

});


parcelRegister("97xxA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a3ec903c2614d45$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $3THTN = parcelRequire("3THTN");

var $28Rb4 = parcelRequire("28Rb4");
var $6a3ec903c2614d45$var$_excluded = [
    "appearance",
    "isDisabled",
    "isSelected",
    "isLoading",
    "spacing"
];
/**
 * __Loading button__
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ var $6a3ec903c2614d45$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function LoadingButton(_ref, ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, spacing = _ref.spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $6a3ec903c2614d45$var$_excluded);
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3THTN.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
        ref: ref,
        appearance: appearance,
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $28Rb4.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    }));
});
// Tools including enzyme rely on components having a display name
$6a3ec903c2614d45$var$LoadingButton.displayName = "LoadingButton";
var $6a3ec903c2614d45$export$2e2bcd8739ae039 = $6a3ec903c2614d45$var$LoadingButton;

});

parcelRegister("gulLc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c01053d3bcd4396b$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $8p2GL = parcelRequire("8p2GL");

var $ju3lq = parcelRequire("ju3lq");

var $gIheT = parcelRequire("gIheT");
function $c01053d3bcd4396b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c01053d3bcd4396b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $c01053d3bcd4396b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c01053d3bcd4396b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
/**
 * __Dynamic Table__
 *
 * A table displays rows of data with built-in pagination, sorting, and re-ordering functionality.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/dynamic-table)
 * - [Code](https://bitbucket.org/atlassian/atlassian-frontend/packages/design-system/dynamic-table)
 *
 * @example
 * ```jsx
 * import DynamicTable from '@atlaskit/dynamic-table';
 *
 * export default function TableUncontrolled() {
 *  return (
 *   <DynamicTable
 *    head={head}
 *    rows={rows}
 *    rowsPerPage={10}
 *    defaultPage={1}
 *    loadingSpinnerSize="large"
 *    isLoading={false}
 *   />
 *  );
 * }
 * ```
 */ var $c01053d3bcd4396b$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(DynamicTable, _React$Component);
    var _super = $c01053d3bcd4396b$var$_createSuper(DynamicTable);
    function DynamicTable() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, DynamicTable);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "state", {
            page: _this.props.defaultPage,
            sortKey: _this.props.defaultSortKey,
            sortOrder: _this.props.defaultSortOrder,
            rows: _this.props.rows
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onSetPageHandler", function(page, analyticsEvent) {
            var onSetPage = _this.props.onSetPage;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                _this.setState({
                    page: page
                });
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onSortHandler", function(_ref, analyticsEvent) {
            var key = _ref.key, item = _ref.item, sortOrder = _ref.sortOrder;
            var onSort = _this.props.onSort;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                _this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onRankEndIfExistsHandler", function(params) {
            if (_this.props.onRankEnd) _this.props.onRankEnd(params);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onRankEndHandler", function(params) {
            var destination = params.destination;
            var _this$state = _this.state, rows = _this$state.rows, page = _this$state.page;
            var rowsPerPage = _this.props.rowsPerPage;
            if (!destination || !rows) {
                _this.onRankEndIfExistsHandler(params);
                return;
            }
            var reordered = (0, $ju3lq.reorderRows)(params, rows, page, rowsPerPage);
            _this.setState({
                rows: reordered
            });
            _this.onRankEndIfExistsHandler(params);
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(DynamicTable, [
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(newProps) {
                var sortKey = newProps.sortKey || this.state.sortKey;
                var sortOrder = newProps.sortOrder || this.state.sortOrder;
                var page = newProps.page || this.state.page;
                this.setState({
                    page: page,
                    sortKey: sortKey,
                    sortOrder: sortOrder,
                    rows: newProps.rows
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$state2 = this.state, page = _this$state2.page, sortKey = _this$state2.sortKey, sortOrder = _this$state2.sortOrder, rows = _this$state2.rows;
                var _this$props = this.props, caption = _this$props.caption, emptyView = _this$props.emptyView, head = _this$props.head, highlightedRowIndex = _this$props.highlightedRowIndex, loadingSpinnerSize = _this$props.loadingSpinnerSize, isLoading = _this$props.isLoading, loadingLabel = _this$props.loadingLabel, isFixedSize = _this$props.isFixedSize, isRankable = _this$props.isRankable, isRankingDisabled = _this$props.isRankingDisabled, rowsPerPage = _this$props.rowsPerPage, paginationi18n = _this$props.paginationi18n, onRankStart = _this$props.onRankStart, onPageRowsUpdate = _this$props.onPageRowsUpdate, testId = _this$props.testId, label = _this$props.label;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $gIheT.default), {
                    paginationi18n: paginationi18n,
                    caption: caption,
                    emptyView: emptyView,
                    head: head,
                    highlightedRowIndex: highlightedRowIndex,
                    loadingSpinnerSize: loadingSpinnerSize,
                    isLoading: isLoading,
                    loadingLabel: loadingLabel,
                    isFixedSize: isFixedSize,
                    onSetPage: this.onSetPageHandler,
                    onSort: this.onSortHandler,
                    page: page,
                    rows: rows,
                    rowsPerPage: rowsPerPage,
                    sortKey: sortKey,
                    sortOrder: sortOrder,
                    isRankable: isRankable,
                    isRankingDisabled: isRankingDisabled,
                    onRankEnd: this.onRankEndHandler,
                    onRankStart: onRankStart,
                    onPageRowsUpdate: onPageRowsUpdate,
                    testId: testId,
                    label: label
                });
            }
        }
    ]);
    return DynamicTable;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component);
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($c01053d3bcd4396b$export$2e2bcd8739ae039, "defaultProps", {
    defaultPage: 1,
    isLoading: false,
    isFixedSize: false,
    isRankable: false,
    onSetPage: (0, $8p2GL.default),
    onSort: (0, $8p2GL.default),
    rowsPerPage: Infinity
});

});
parcelRegister("ju3lq", function(module, exports) {

$parcel$export(module.exports, "getPageRows", function () { return $e2f369d97b48814e$export$3987dc24b734dcab; });
$parcel$export(module.exports, "assertIsSortable", function () { return $e2f369d97b48814e$export$5eb35a4771ec4090; });
$parcel$export(module.exports, "validateSortKey", function () { return $e2f369d97b48814e$export$9133f5a8bfe8a200; });
$parcel$export(module.exports, "inlineStylesIfRanking", function () { return $e2f369d97b48814e$export$a601f1775e10043f; });
$parcel$export(module.exports, "reorderRows", function () { return $e2f369d97b48814e$export$c476bbe5da59992d; });

var $9q1kH = parcelRequire("9q1kH");
var $e2f369d97b48814e$export$3987dc24b734dcab = function getPageRows(allRows, pageNumber, rowsPerPage) {
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
var $e2f369d97b48814e$export$5eb35a4771ec4090 = function assertIsSortable(head) {
    if (!head || !head.cells) return;
    head.cells.forEach(function(cell) {
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
var $e2f369d97b48814e$export$9133f5a8bfe8a200 = function validateSortKey(sortKey, head) {
    if (!sortKey) return;
    var headHasKey = head && head.cells.map(function(cell) {
        return cell.key;
    }).includes(sortKey);
    if (!headHasKey) try {
        throw Error("Cell with ".concat(sortKey, " key not found in head."));
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
var $e2f369d97b48814e$export$a601f1775e10043f = function inlineStylesIfRanking(isRanking, width, height) {
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
var $e2f369d97b48814e$export$92bcb1ed38b134a1 = function computeIndex(index, page, rowsPerPage) {
    var itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
var $e2f369d97b48814e$export$c476bbe5da59992d = function reorderRows(rankEnd, rows) {
    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var rowsPerPage = arguments.length > 3 ? arguments[3] : undefined;
    var destination = rankEnd.destination, sourceIndex = rankEnd.sourceIndex;
    if (!destination) return rows;
    var fromIndex = $e2f369d97b48814e$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    var toIndex = $e2f369d97b48814e$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    var reordered = rows.slice();
    var _reordered$splice = reordered.splice(fromIndex, 1), _reordered$splice2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_reordered$splice, 1), removed = _reordered$splice2[0];
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("gIheT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2ae20bea3317862$export$2e2bcd8739ae039; });

var $9q1kH = parcelRequire("9q1kH");

var $lOQkO = parcelRequire("lOQkO");

var $fPPqr = parcelRequire("fPPqr");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $fknEE = parcelRequire("fknEE");
var $6clZv = parcelRequire("6clZv");
var $7zph4 = parcelRequire("7zph4");

var $8p2GL = parcelRequire("8p2GL");

var $f0z3w = parcelRequire("f0z3w");

var $ju3lq = parcelRequire("ju3lq");

var $htrHJ = parcelRequire("htrHJ");

var $ifVPK = parcelRequire("ifVPK");

var $3KYhA = parcelRequire("3KYhA");

var $gLPm3 = parcelRequire("gLPm3");

var $8wcFl = parcelRequire("8wcFl");

var $i5hOJ = parcelRequire("i5hOJ");

var $6TveR = parcelRequire("6TveR");

var $84iBi = parcelRequire("84iBi");
var $c2ae20bea3317862$var$_excluded = [
    "isRankable",
    "isRanking",
    "onRankStart",
    "onRankEnd",
    "isRankingDisabled"
];
function $c2ae20bea3317862$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c2ae20bea3317862$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $c2ae20bea3317862$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c2ae20bea3317862$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $c2ae20bea3317862$var$packageName = "@atlaskit/dynamic-table";
var $c2ae20bea3317862$var$packageVersion = "14.20.2";
function $c2ae20bea3317862$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $f0z3w.DESC:
            return 0, $f0z3w.ASC;
        case 0, $f0z3w.ASC:
            return 0, $f0z3w.DESC;
        default:
            return currentSortOrder;
    }
}
var $c2ae20bea3317862$export$613134f68684a686 = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(DynamicTable, _React$Component);
    var _super = $c2ae20bea3317862$var$_createSuper(DynamicTable);
    function DynamicTable() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, DynamicTable);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "tableBody", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createRef());
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "state", {
            isRanking: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onSortHandler", function(item) {
            return function() {
                var _this$props = _this.props, sortKey = _this$props.sortKey, sortOrder = _this$props.sortOrder, onSort = _this$props.onSort, isRankable = _this$props.isRankable;
                var key = item.key;
                if (!key) return;
                if (onSort && isRankable && key === sortKey && sortOrder === (0, $f0z3w.DESC)) {
                    onSort({
                        key: null,
                        sortOrder: null,
                        item: item
                    });
                    return;
                }
                var sortOrderFormatted = key !== sortKey ? (0, $f0z3w.ASC) : $c2ae20bea3317862$var$toggleSortOrder(sortOrder);
                if (onSort) onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrderFormatted
                });
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onSetPageHandler", function(page, event) {
            var onSetPage = _this.props.onSetPage;
            if (onSetPage) onSetPage(page, event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onRankStartHandler", function(params) {
            _this.setState({
                isRanking: true
            });
            if (_this.props.onRankStart) _this.props.onRankStart(params);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onRankEndHandler", function(params) {
            _this.setState({
                isRanking: false
            });
            if (_this.props.onRankEnd) _this.props.onRankEnd(params);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getSpinnerSize", function() {
            var _this$props2 = _this.props, page = _this$props2.page, rows = _this$props2.rows, rowsPerPage = _this$props2.rowsPerPage, loadingSpinnerSize = _this$props2.loadingSpinnerSize;
            if (loadingSpinnerSize) return loadingSpinnerSize;
            return (0, $ju3lq.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $f0z3w.LARGE) : (0, $f0z3w.SMALL);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "renderEmptyBody", function() {
            var _this$props3 = _this.props, emptyView = _this$props3.emptyView, isLoading = _this$props3.isLoading, testId = _this$props3.testId;
            if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ifVPK.EmptyViewWithFixedHeight), {
                testId: testId
            });
            return emptyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ifVPK.EmptyViewContainer), {
                testId: testId
            }, emptyView);
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(DynamicTable, [
        {
            key: "UNSAFE_componentWillMount",
            value: function UNSAFE_componentWillMount() {
                (0, $ju3lq.validateSortKey)(this.props.sortKey, this.props.head);
                (0, $ju3lq.assertIsSortable)(this.props.head);
            }
        },
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $ju3lq.validateSortKey)(nextProps.sortKey, nextProps.head);
                if (this.props.head !== nextProps.head) (0, $ju3lq.assertIsSortable)(nextProps.head);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props4 = this.props, caption = _this$props4.caption, head = _this$props4.head, highlightedRowIndex = _this$props4.highlightedRowIndex, isFixedSize = _this$props4.isFixedSize, page = _this$props4.page, rows = _this$props4.rows, rowsPerPage = _this$props4.rowsPerPage, sortKey = _this$props4.sortKey, sortOrder = _this$props4.sortOrder, isLoading = _this$props4.isLoading, loadingLabel = _this$props4.loadingLabel, isRankable = _this$props4.isRankable, isRankingDisabled = _this$props4.isRankingDisabled, paginationi18n = _this$props4.paginationi18n, onPageRowsUpdate = _this$props4.onPageRowsUpdate, testId = _this$props4.testId, passedDownTotalRows = _this$props4.totalRows, label = _this$props4.label;
                var rowsLength = rows && rows.length;
                var totalPages;
                // set a flag to denote the dynamic table might get only one page of data
                // for paginated data
                var isTotalPagesControlledExternally = false;
                if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
                    /**
         * If total number of rows / records have been passed down as prop
         * Then table is being fed paginated data from server or other sources
         * In this case, we want to respect information passed down by server or external source
         * Rather than relying on our computation based on number of rows
         */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
                    isTotalPagesControlledExternally = true;
                } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
                totalPages = totalPages < 1 ? 1 : totalPages;
                var getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
                var bodyProps = {
                    highlightedRowIndex: highlightedRowIndex,
                    rows: rows,
                    head: head,
                    sortKey: sortKey,
                    sortOrder: sortOrder,
                    rowsPerPage: rowsPerPage,
                    page: getPageNumber,
                    isFixedSize: isFixedSize || false,
                    onPageRowsUpdate: onPageRowsUpdate,
                    isTotalPagesControlledExternally: isTotalPagesControlledExternally,
                    ref: this.tableBody,
                    testId: testId
                };
                var rowsExist = !!rowsLength;
                var spinnerSize = this.getSpinnerSize();
                var emptyBody = this.renderEmptyBody();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $i5hOJ.default), {
                    isLoading: isLoading && rowsExist,
                    spinnerSize: spinnerSize,
                    targetRef: function targetRef() {
                        return _this2.tableBody.current;
                    },
                    testId: testId,
                    loadingLabel: loadingLabel
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $htrHJ.Table), {
                    isFixedSize: isFixedSize,
                    "aria-label": label,
                    hasDataRow: rowsExist,
                    testId: testId,
                    isLoading: isLoading
                }, !!caption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $htrHJ.Caption), null, caption), head && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $84iBi.default), {
                    head: head,
                    onSort: this.onSortHandler,
                    sortKey: sortKey,
                    sortOrder: sortOrder,
                    isRanking: this.state.isRanking,
                    isRankable: isRankable,
                    testId: testId
                }), rowsExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($c2ae20bea3317862$var$TableBody, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, bodyProps, {
                    isRankable: this.props.isRankable,
                    isRanking: this.state.isRanking,
                    onRankStart: this.onRankStartHandler,
                    onRankEnd: this.onRankEndHandler,
                    isRankingDisabled: isRankingDisabled || isLoading || false
                })))), totalPages <= 1 ? null : /*#__PURE__*/ // only show pagination if there's MORE than 1 page
                (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $htrHJ.PaginationWrapper), {
                    testId: testId
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6TveR.default), {
                    value: getPageNumber,
                    onChange: this.onSetPageHandler,
                    total: totalPages,
                    i18n: paginationi18n,
                    isDisabled: isLoading,
                    testId: testId
                })), !rowsExist && emptyBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $8wcFl.default), {
                    isLoading: isLoading,
                    spinnerSize: (0, $f0z3w.LARGE),
                    testId: testId,
                    loadingLabel: loadingLabel
                }, emptyBody));
            }
        }
    ]);
    return DynamicTable;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component);
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($c2ae20bea3317862$export$613134f68684a686, "defaultProps", {
    isLoading: false,
    isFixedSize: false,
    rowsPerPage: Infinity,
    onSetPage: (0, $8p2GL.default),
    onSort: (0, $8p2GL.default),
    page: 1,
    isRankable: false,
    isRankingDisabled: false,
    onRankStart: (0, $8p2GL.default),
    onRankEnd: (0, $8p2GL.default),
    paginationi18n: {
        prev: "Previous",
        next: "Next",
        label: "Pagination",
        pageLabel: "Page"
    }
});

var $c2ae20bea3317862$var$RankableTableBody = /*#__PURE__*/ (0, $9nHZC.lazy)(function() {
    return (parcelRequire("gm7iU"));
});
var $c2ae20bea3317862$var$TableBody = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function TableBody(_ref, ref) {
    var _ref$isRankable = _ref.isRankable, isRankable = _ref$isRankable === void 0 ? false : _ref$isRankable, isRanking = _ref.isRanking, onRankStart = _ref.onRankStart, onRankEnd = _ref.onRankEnd, isRankingDisabled = _ref.isRankingDisabled, bodyProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $c2ae20bea3317862$var$_excluded);
    var canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ var _useState = (0, $9nHZC.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), canRenderRankable = _useState2[0], setCanRenderRankable = _useState2[1];
    (0, $9nHZC.useEffect)(function() {
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    var nonRankableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3KYhA.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        ref: ref
    }, bodyProps));
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $gLPm3.ErrorBoundary), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Suspense), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($c2ae20bea3317862$var$RankableTableBody, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        ref: ref
    }, bodyProps, {
        isRanking: isRanking,
        onRankStart: onRankStart,
        onRankEnd: onRankEnd,
        isRankingDisabled: isRankingDisabled
    })))) : nonRankableBody;
});
var $c2ae20bea3317862$var$createAndFireEventOnAtlaskit = (0, $fknEE.default)("atlaskit");
/**
 * __Dynamic table stateless__
 *
 * A stateless table that requires consumers to manage the sorting, drag and drop, and pagination.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/dynamic-table)
 * - [Code](https://bitbucket.org/atlassian/atlassian-frontend/packages/design-system/dynamic-table)
 */ var $c2ae20bea3317862$var$DynamicTableStateless = (0, $6clZv.default)({
    componentName: "dynamicTable",
    packageName: $c2ae20bea3317862$var$packageName,
    packageVersion: $c2ae20bea3317862$var$packageVersion
})((0, $7zph4.default)({
    onSort: $c2ae20bea3317862$var$createAndFireEventOnAtlaskit({
        action: "sorted",
        actionSubject: "dynamicTable",
        attributes: {
            componentName: "dynamicTable",
            packageName: $c2ae20bea3317862$var$packageName,
            packageVersion: $c2ae20bea3317862$var$packageVersion
        }
    }),
    onRankEnd: $c2ae20bea3317862$var$createAndFireEventOnAtlaskit({
        action: "ranked",
        actionSubject: "dynamicTable",
        attributes: {
            componentName: "dynamicTable",
            packageName: $c2ae20bea3317862$var$packageName,
            packageVersion: $c2ae20bea3317862$var$packageVersion
        }
    })
})($c2ae20bea3317862$export$613134f68684a686));
var $c2ae20bea3317862$export$2e2bcd8739ae039 = $c2ae20bea3317862$var$DynamicTableStateless;

});
parcelRegister("fknEE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b28b1294905f1164$export$2e2bcd8739ae039; });
var $b28b1294905f1164$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};

});

parcelRegister("6clZv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4834ec07e09b42c8$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $jtWo4 = parcelRequire("jtWo4");
var $4834ec07e09b42c8$var$_excluded = [
    "analyticsContext"
];
function $4834ec07e09b42c8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4834ec07e09b42c8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4834ec07e09b42c8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4834ec07e09b42c8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4834ec07e09b42c8$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $4834ec07e09b42c8$var$_excluded);
            var analyticsData = (0, $9nHZC.useMemo)(function() {
                return $4834ec07e09b42c8$var$_objectSpread($4834ec07e09b42c8$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $jtWo4.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
                ref: ref
            })));
        });
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $4834ec07e09b42c8$export$2e2bcd8739ae039 = $4834ec07e09b42c8$var$withAnalyticsContext;

});
parcelRegister("jtWo4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03a900117eb16dc8$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $iSfAL = parcelRequire("iSfAL");

var $9DSYC = parcelRequire("9DSYC");

var $doMII = parcelRequire("doMII");

var $ez7Le = parcelRequire("ez7Le");
var $03a900117eb16dc8$var$ExportedAnalyticsContext = function ExportedAnalyticsContext(props) {
    var isModernContext = (0, $9DSYC.default) || (0, $iSfAL.fg)("platform.analytics-next-use-modern-context_fqgbx");
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ez7Le.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $doMII.default), props);
};
var $03a900117eb16dc8$export$2e2bcd8739ae039 = $03a900117eb16dc8$var$ExportedAnalyticsContext;

});
parcelRegister("iSfAL", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $dbd95d60d05e25bf$export$b40ec24ac8275656; });

var $i4VpX = parcelRequire("i4VpX");
function $dbd95d60d05e25bf$export$ba05d765b8392e5e(flagResolver) {
    (0, $i4VpX.setBooleanResolver)(flagResolver);
}
function $dbd95d60d05e25bf$export$470e5c2be1411c89(name) {
    return (0, $i4VpX.resolveBooleanFlag)(name);
}
function $dbd95d60d05e25bf$export$b40ec24ac8275656(name) {
    return (0, $i4VpX.resolveBooleanFlag)(name);
}

});
parcelRegister("i4VpX", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $d29523a4f8a7a35c$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $d29523a4f8a7a35c$export$6333b6aff9fc6275; });

var $94zHu = parcelRequire("94zHu");

var $8ovux = parcelRequire("8ovux");
var $d29523a4f8a7a35c$var$pkgName = "@atlaskit/platform-feature-flags";
var $d29523a4f8a7a35c$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $d29523a4f8a7a35c$var$hasProcessEnv = typeof $8ovux !== "undefined" && typeof $8ovux.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $d29523a4f8a7a35c$var$ENV_ENABLE_PLATFORM_FF = $d29523a4f8a7a35c$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $d29523a4f8a7a35c$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $d29523a4f8a7a35c$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $d29523a4f8a7a35c$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $d29523a4f8a7a35c$var$ENV_ENABLE_PLATFORM_FF || $d29523a4f8a7a35c$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $d29523a4f8a7a35c$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $d29523a4f8a7a35c$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$d29523a4f8a7a35c$var$globalVar[$d29523a4f8a7a35c$export$7e41b1b2bdee3f98] = $d29523a4f8a7a35c$var$globalVar[$d29523a4f8a7a35c$export$7e41b1b2bdee3f98] || $d29523a4f8a7a35c$var$DEFAULT_PFF_GLOBAL;
function $d29523a4f8a7a35c$export$f2b591175b3e424c(resolver) {
    $d29523a4f8a7a35c$var$globalVar[$d29523a4f8a7a35c$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $d29523a4f8a7a35c$export$6333b6aff9fc6275(flagKey) {
    if ($d29523a4f8a7a35c$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $94zHu.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $d29523a4f8a7a35c$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $d29523a4f8a7a35c$var$globalVar[$d29523a4f8a7a35c$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("94zHu", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $69b02e2397fde27a$export$1c9f709888824e05; });
var $69b02e2397fde27a$var$_ref, $69b02e2397fde27a$var$_process, $69b02e2397fde27a$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $69b02e2397fde27a$var$TESTS_MODE = ($69b02e2397fde27a$var$_ref = (globalThis === null || globalThis === void 0 || ($69b02e2397fde27a$var$_process = globalThis.process) === null || $69b02e2397fde27a$var$_process === void 0 || ($69b02e2397fde27a$var$_process = $69b02e2397fde27a$var$_process.env) === null || $69b02e2397fde27a$var$_process === void 0 ? void 0 : $69b02e2397fde27a$var$_process.JEST_WORKER_ID) !== undefined, $69b02e2397fde27a$var$_ref !== void 0) ? $69b02e2397fde27a$var$_ref : false;
var $69b02e2397fde27a$var$DEBUG_MODE = !$69b02e2397fde27a$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($69b02e2397fde27a$var$_process2 = globalThis.process) === null || $69b02e2397fde27a$var$_process2 === void 0 || ($69b02e2397fde27a$var$_process2 = $69b02e2397fde27a$var$_process2.env) === null || $69b02e2397fde27a$var$_process2 === void 0 ? void 0 : $69b02e2397fde27a$var$_process2.NODE_ENV) !== "production";
var $69b02e2397fde27a$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$69b02e2397fde27a$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("9DSYC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $705266d02f391f93$export$2e2bcd8739ae039; });

var $8ovux = parcelRequire("8ovux");
var $705266d02f391f93$var$_process$env;
var $705266d02f391f93$export$2e2bcd8739ae039 = typeof $8ovux !== "undefined" && $8ovux !== null && (($705266d02f391f93$var$_process$env = {}, $705266d02f391f93$var$_process$env === void 0) ? void 0 : $705266d02f391f93$var$_process$env["ANALYTICS_NEXT_MODERN_CONTEXT"]);

});

parcelRegister("doMII", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c134f195a0c7600$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");

var $kZnbM = parcelRequire("kZnbM");
function $9c134f195a0c7600$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $9c134f195a0c7600$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $9c134f195a0c7600$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9c134f195a0c7600$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $9c134f195a0c7600$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func
};
var $9c134f195a0c7600$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $9c134f195a0c7600$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(AnalyticsContext, _Component);
    var _super = $9c134f195a0c7600$var$_createSuper(AnalyticsContext);
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsContext);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $9c134f195a0c7600$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $9c134f195a0c7600$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kZnbM.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsContext;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($9c134f195a0c7600$var$AnalyticsContext, "contextTypes", $9c134f195a0c7600$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($9c134f195a0c7600$var$AnalyticsContext, "childContextTypes", $9c134f195a0c7600$var$ContextTypes);
var $9c134f195a0c7600$export$2e2bcd8739ae039 = $9c134f195a0c7600$var$AnalyticsContext;

});

parcelRegister("ez7Le", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9aa5ab55bd471f0$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");

var $3uZqD = parcelRequire("3uZqD");

var $iZkfn = parcelRequire("iZkfn");
var $a9aa5ab55bd471f0$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $iZkfn.useTrackedRef)(data);
    var _useAnalyticsContext = (0, $3uZqD.useAnalyticsContext)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $9nHZC.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $9nHZC.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kZnbM.default).Provider, {
        value: value
    }, children);
};
var $a9aa5ab55bd471f0$export$2e2bcd8739ae039 = $a9aa5ab55bd471f0$var$AnalyticsContext;

});
parcelRegister("3uZqD", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $28c3d2dd15345439$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $28c3d2dd15345439$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});

parcelRegister("iZkfn", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $dd2da120fd1f8a96$export$1d27a74659855e44; });

var $9nHZC = parcelRequire("9nHZC");
var $dd2da120fd1f8a96$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    ref.current = value;
    return ref;
};

});




parcelRegister("7zph4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $582f683902ab2905$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $eEs4z = parcelRequire("eEs4z");

var $fXnAT = parcelRequire("fXnAT");
var $582f683902ab2905$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(props, ref) {
            var _usePatchedProps = (0, $fXnAT.usePatchedProps)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $eEs4z.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $582f683902ab2905$export$2e2bcd8739ae039 = $582f683902ab2905$var$withAnalyticsEvents;

});
parcelRegister("eEs4z", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $aaaa93c230c4ac76$export$5bf35293e545f20c; });

var $dNznA = parcelRequire("dNznA");

var $62AR6 = parcelRequire("62AR6");

var $3uZqD = parcelRequire("3uZqD");
function $aaaa93c230c4ac76$export$5bf35293e545f20c() {
    var analyticsContext = (0, $3uZqD.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $62AR6.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("62AR6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $465f84bacecad48e$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $fcicV = parcelRequire("fcicV");
function $465f84bacecad48e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $465f84bacecad48e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $465f84bacecad48e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($465f84bacecad48e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $465f84bacecad48e$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $465f84bacecad48e$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $465f84bacecad48e$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $465f84bacecad48e$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $fcicV.default));

});
parcelRegister("fcicV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b10619a52b5cb731$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
function $b10619a52b5cb731$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b10619a52b5cb731$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b10619a52b5cb731$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b10619a52b5cb731$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b10619a52b5cb731$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $b10619a52b5cb731$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $b10619a52b5cb731$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $b10619a52b5cb731$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(updater) === "object") this.payload = $b10619a52b5cb731$var$_objectSpread($b10619a52b5cb731$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});



parcelRegister("fXnAT", function(module, exports) {

$parcel$export(module.exports, "usePatchedProps", function () { return $b9deaafec178eea6$export$9ebb5a84d17e5d18; });

var $kFnE9 = parcelRequire("kFnE9");

var $340K4 = parcelRequire("340K4");

var $9nHZC = parcelRequire("9nHZC");

var $eEs4z = parcelRequire("eEs4z");
function $b9deaafec178eea6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b9deaafec178eea6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b9deaafec178eea6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b9deaafec178eea6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b9deaafec178eea6$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $eEs4z.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $9nHZC.useRef)({});
    var patchedProps = (0, $9nHZC.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                "object",
                "function"
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $b9deaafec178eea6$var$_objectSpread($b9deaafec178eea6$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === "function" ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === "function") {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $b9deaafec178eea6$var$_objectSpread($b9deaafec178eea6$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});


parcelRegister("f0z3w", function(module, exports) {

$parcel$export(module.exports, "ASC", function () { return $aed20c6fd49b1556$export$1dee026a19752d6b; });
$parcel$export(module.exports, "DESC", function () { return $aed20c6fd49b1556$export$b6abcf7fa1d94f65; });
$parcel$export(module.exports, "SMALL", function () { return $aed20c6fd49b1556$export$71dd4c8ecd45e95f; });
$parcel$export(module.exports, "LARGE", function () { return $aed20c6fd49b1556$export$7b93a10c0fefe3e3; });
$parcel$export(module.exports, "LOADING_CONTENTS_OPACITY", function () { return $aed20c6fd49b1556$export$3843c586a90b9cbf; });
var $aed20c6fd49b1556$export$1dee026a19752d6b = "ASC";
var $aed20c6fd49b1556$export$b6abcf7fa1d94f65 = "DESC";
var $aed20c6fd49b1556$export$71dd4c8ecd45e95f = "small";
var $aed20c6fd49b1556$export$7b93a10c0fefe3e3 = "large";
var $aed20c6fd49b1556$export$3843c586a90b9cbf = 0.22;

});

parcelRegister("htrHJ", function(module, exports) {

$parcel$export(module.exports, "tableRowCSSVars", function () { return $cb8aa2988c47191c$export$3b9ea2c10c245fdb; });
$parcel$export(module.exports, "Table", function () { return $cb8aa2988c47191c$export$54ec01a60f47d33d; });
$parcel$export(module.exports, "Caption", function () { return $cb8aa2988c47191c$export$32fbfacc5d962e0c; });
$parcel$export(module.exports, "PaginationWrapper", function () { return $cb8aa2988c47191c$export$3e5e12dc01f20a43; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $aPzaW = parcelRequire("aPzaW");
var $cb8aa2988c47191c$var$_excluded = [
    "isFixedSize",
    "hasDataRow",
    "children",
    "testId",
    "isLoading"
];
var $cb8aa2988c47191c$export$3b9ea2c10c245fdb = {
    CSS_VAR_HOVER_BACKGROUND: "--local-dynamic-table-hover-bg",
    CSS_VAR_HIGHLIGHTED_BACKGROUND: "--local-dynamic-table-highlighted-bg",
    CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: "--local-dynamic-table-hover-highlighted-bg",
    CSS_VAR_ROW_FOCUS_OUTLINE: "--local-dynamic-table-row-focus-outline"
};
var $cb8aa2988c47191c$var$fixedSizeTableStyles = (0, $avKww.css)({
    tableLayout: "fixed"
});
var $cb8aa2988c47191c$var$tableStyles = (0, $avKww.css)({
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: "0px"
});
var $cb8aa2988c47191c$var$bodyBorder = (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: "2px solid ".concat((0, $aPzaW.tableBorder).borderColor)
});
var $cb8aa2988c47191c$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var _ref2;
    var isFixedSize = _ref.isFixedSize, hasDataRow = _ref.hasDataRow, children = _ref.children, testId = _ref.testId, isLoading = _ref.isLoading, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $cb8aa2988c47191c$var$_excluded);
    return (0, $avKww.jsx)("table", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        inert: isLoading ? "" : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: (_ref2 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref2, $cb8aa2988c47191c$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_BACKGROUND, (0, $aPzaW.row).hoverBackground), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref2, $cb8aa2988c47191c$export$3b9ea2c10c245fdb.CSS_VAR_HIGHLIGHTED_BACKGROUND, (0, $aPzaW.row).highlightedBackground), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref2, $cb8aa2988c47191c$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND, (0, $aPzaW.row).hoverHighlightedBackground), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref2, $cb8aa2988c47191c$export$3b9ea2c10c245fdb.CSS_VAR_ROW_FOCUS_OUTLINE, (0, $aPzaW.row).focusOutline), _ref2),
        css: [
            $cb8aa2988c47191c$var$tableStyles,
            isFixedSize && $cb8aa2988c47191c$var$fixedSizeTableStyles,
            hasDataRow && $cb8aa2988c47191c$var$bodyBorder
        ],
        ref: ref
    }, rest, {
        "data-testid": testId && "".concat(testId, "--table")
    }), children);
});
var $cb8aa2988c47191c$var$captionStyles = (0, $avKww.css)({
    font: 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    marginBlockEnd: "var(--ds-space-100, 8px)",
    marginBlockStart: "var(--ds-space-300, 24px)",
    willChange: "transform"
});
var $cb8aa2988c47191c$export$32fbfacc5d962e0c = function Caption(_ref3) {
    var children = _ref3.children;
    return (0, $avKww.jsx)("caption", {
        css: $cb8aa2988c47191c$var$captionStyles
    }, children);
};
var $cb8aa2988c47191c$var$paginationWrapperStyles = (0, $avKww.css)({
    display: "flex",
    justifyContent: "center"
});
var $cb8aa2988c47191c$export$3e5e12dc01f20a43 = function PaginationWrapper(_ref4) {
    var children = _ref4.children, testId = _ref4.testId;
    return (0, $avKww.jsx)("div", {
        css: $cb8aa2988c47191c$var$paginationWrapperStyles,
        "data-testid": testId && "".concat(testId, "--pagination--container")
    }, children);
};

});
parcelRegister("aPzaW", function(module, exports) {

$parcel$export(module.exports, "MSThemeColors", function () { return $7e29f3ee3ad71cff$export$34af08ce45c78352; });
$parcel$export(module.exports, "arrow", function () { return $7e29f3ee3ad71cff$export$f2120bbfa5450bd2; });
$parcel$export(module.exports, "row", function () { return $7e29f3ee3ad71cff$export$120ff0929b202a6d; });
$parcel$export(module.exports, "head", function () { return $7e29f3ee3ad71cff$export$5fd5031fecdacec3; });
$parcel$export(module.exports, "tableBorder", function () { return $7e29f3ee3ad71cff$export$38d703b73e2cf64d; });

var $kRIB6 = parcelRequire("kRIB6");
var $7e29f3ee3ad71cff$export$34af08ce45c78352 = {
    Background: "Canvas",
    Text: "CanvasText",
    SelectedBackground: "Highlight",
    SelectedText: "HighlightText"
};
var $7e29f3ee3ad71cff$export$f2120bbfa5450bd2 = {
    defaultColor: "var(--ds-icon-disabled, ".concat($kRIB6.N40, ")"),
    selectedColor: "var(--ds-icon-subtle, ".concat($kRIB6.N300, ")")
};
var $7e29f3ee3ad71cff$export$120ff0929b202a6d = {
    focusOutline: "var(--ds-border-focused, ".concat($kRIB6.B100, ")"),
    highlightedBackground: "var(--ds-background-selected, ".concat($kRIB6.B50, ")"),
    hoverBackground: "var(--ds-background-neutral-subtle-hovered, ".concat($kRIB6.N10, ")"),
    hoverHighlightedBackground: "var(--ds-background-selected-hovered, ".concat($kRIB6.B75, ")")
};
var $7e29f3ee3ad71cff$export$5fd5031fecdacec3 = {
    textColor: "var(--ds-text-subtlest, ".concat($kRIB6.N300, ")")
};
var $7e29f3ee3ad71cff$export$38d703b73e2cf64d = {
    borderColor: "var(--ds-border, ".concat($kRIB6.N40, ")")
};

});
parcelRegister("kRIB6", function(module, exports) {

$parcel$export(module.exports, "B50", function () { return $f30b5a0680f78546$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $f30b5a0680f78546$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $f30b5a0680f78546$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "N0", function () { return $f30b5a0680f78546$export$29a4f05edc054374; });
$parcel$export(module.exports, "N10", function () { return $f30b5a0680f78546$export$e655ef011c4aa1a2; });
$parcel$export(module.exports, "N20", function () { return $f30b5a0680f78546$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N40", function () { return $f30b5a0680f78546$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N300", function () { return $f30b5a0680f78546$export$e2ef2124cf4024b1; });
$parcel$export(module.exports, "N500", function () { return $f30b5a0680f78546$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N30A", function () { return $f30b5a0680f78546$export$920c0d5c49070351; });
$parcel$export(module.exports, "N50A", function () { return $f30b5a0680f78546$export$7d3359664e8bb0e5; });
$parcel$export(module.exports, "N60A", function () { return $f30b5a0680f78546$export$d2d3bedfb276cac0; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $f30b5a0680f78546$export$4b84fd0e2c617bd = "#FFEBE6";
var $f30b5a0680f78546$export$b34b069eff244586 = "#FFBDAD";
var $f30b5a0680f78546$export$be802dd0d8b57f35 = "#FF8F73";
var $f30b5a0680f78546$export$60847d42f9da92a6 = "#FF7452";
var $f30b5a0680f78546$export$4a7404f376229999 = "#FF5630";
var $f30b5a0680f78546$export$2010d0fb4295b346 = "#DE350B";
var $f30b5a0680f78546$export$2837b5a1a71d5c02 = "#BF2600";
var $f30b5a0680f78546$export$8d9596b529bbb9cf = "#FFFAE6";
var $f30b5a0680f78546$export$41060a744ab0b7ae = "#FFF0B3";
var $f30b5a0680f78546$export$1cc05bbbf340e559 = "#FFE380";
var $f30b5a0680f78546$export$5aae31392d72caaa = "#FFC400";
var $f30b5a0680f78546$export$c6930421db9fa514 = "#FFAB00";
var $f30b5a0680f78546$export$59619663aa6500fb = "#FF991F";
var $f30b5a0680f78546$export$874739ea9e379ab6 = "#FF8B00";
var $f30b5a0680f78546$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $f30b5a0680f78546$export$69a3bf21b9686c2b = "#ABF5D1";
var $f30b5a0680f78546$export$afbce1382ec95f73 = "#79F2C0";
var $f30b5a0680f78546$export$747d86715d4175de = "#57D9A3";
var $f30b5a0680f78546$export$940e1f69e873f202 = "#36B37E";
var $f30b5a0680f78546$export$a49394138f7b8e85 = "#00875A";
var $f30b5a0680f78546$export$6fa04827ac68a4fb = "#006644";
var $f30b5a0680f78546$export$226de0355ed012f8 = "#DEEBFF";
var $f30b5a0680f78546$export$8c13c2ee36917869 = "#B3D4FF";
var $f30b5a0680f78546$export$ecfc1dff386a3e7a = "#4C9AFF";
var $f30b5a0680f78546$export$215b7063051591f1 = "#2684FF";
var $f30b5a0680f78546$export$e62e8919cca44969 = "#0065FF";
var $f30b5a0680f78546$export$b3de0ae08da2ce64 = "#0052CC";
var $f30b5a0680f78546$export$a6ee3d71bc067634 = "#0747A6";
var $f30b5a0680f78546$export$363e4475840015bb = "#EAE6FF";
var $f30b5a0680f78546$export$4b0a4417ed59760f = "#C0B6F2";
var $f30b5a0680f78546$export$6011520a64d9a187 = "#998DD9";
var $f30b5a0680f78546$export$a7175d4e9206bc80 = "#8777D9";
var $f30b5a0680f78546$export$b48405b95304b5a1 = "#6554C0";
var $f30b5a0680f78546$export$c71e4279dd54a18d = "#5243AA";
var $f30b5a0680f78546$export$147899de772240ec = "#403294";
var $f30b5a0680f78546$export$2cf711fe14c66f06 = "#E6FCFF";
var $f30b5a0680f78546$export$7a8f4d33f6f9772c = "#B3F5FF";
var $f30b5a0680f78546$export$776c9c497ef08533 = "#79E2F2";
var $f30b5a0680f78546$export$69cb3ca10c1e330e = "#00C7E6";
var $f30b5a0680f78546$export$9dc1ef0f3f48059b = "#00B8D9";
var $f30b5a0680f78546$export$7c835c78b6fcdef8 = "#00A3BF";
var $f30b5a0680f78546$export$6036577f95c3877e = "#008DA6";
var $f30b5a0680f78546$export$29a4f05edc054374 = "#FFFFFF";
var $f30b5a0680f78546$export$e655ef011c4aa1a2 = "#FAFBFC";
var $f30b5a0680f78546$export$9fdfb749e33cdf97 = "#F4F5F7";
var $f30b5a0680f78546$export$3e51e8f1440314ba = "#EBECF0";
var $f30b5a0680f78546$export$1ce2d1575d444ceb = "#DFE1E6";
var $f30b5a0680f78546$export$8754fc7e6d8b3000 = "#C1C7D0";
var $f30b5a0680f78546$export$c2e91cbeada39b8b = "#B3BAC5";
var $f30b5a0680f78546$export$5f71e19f3a7ad9de = "#A5ADBA";
var $f30b5a0680f78546$export$eaa8c8a70ac22806 = "#97A0AF";
var $f30b5a0680f78546$export$7c87d337fb91a97d = "#8993A4";
var $f30b5a0680f78546$export$d6447c357493214f = "#7A869A";
var $f30b5a0680f78546$export$f563ee71e9ee74cd = "#6B778C";
var $f30b5a0680f78546$export$e2ef2124cf4024b1 = "#5E6C84";
var $f30b5a0680f78546$export$eece5f492e429f08 = "#505F79";
var $f30b5a0680f78546$export$c39c0fe0f26207ae = "#42526E";
var $f30b5a0680f78546$export$7090862dc3038a9f = "#344563";
var $f30b5a0680f78546$export$ad0bacf983b7ddaa = "#253858";
var $f30b5a0680f78546$export$7d61b15e0da132af = "#172B4D";
var $f30b5a0680f78546$export$fbda843f0a27fe96 = "#091E42";
var $f30b5a0680f78546$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $f30b5a0680f78546$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $f30b5a0680f78546$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $f30b5a0680f78546$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $f30b5a0680f78546$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $f30b5a0680f78546$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $f30b5a0680f78546$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $f30b5a0680f78546$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $f30b5a0680f78546$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $f30b5a0680f78546$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $f30b5a0680f78546$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $f30b5a0680f78546$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $f30b5a0680f78546$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $f30b5a0680f78546$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $f30b5a0680f78546$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $f30b5a0680f78546$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $f30b5a0680f78546$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $f30b5a0680f78546$export$2f6319cf7d736c2a = "#E6EDFA";
var $f30b5a0680f78546$export$95126bc8884d6634 = "#DCE5F5";
var $f30b5a0680f78546$export$8338d8c35d44ff1 = "#CED9EB";
var $f30b5a0680f78546$export$5368d76ae4fbbda7 = "#B8C7E0";
var $f30b5a0680f78546$export$9f0a771d16ec8d36 = "#ABBBD6";
var $f30b5a0680f78546$export$abcf8c38338b4aa5 = "#9FB0CC";
var $f30b5a0680f78546$export$97e81faa16a182c7 = "#8C9CB8";
var $f30b5a0680f78546$export$bfe21c59123ecf33 = "#7988A3";
var $f30b5a0680f78546$export$ee82aa2ea6a1558 = "#67758F";
var $f30b5a0680f78546$export$682927c6ed76be02 = "#56637A";
var $f30b5a0680f78546$export$91fd9994c5be9757 = "#455166";
var $f30b5a0680f78546$export$d281fbfe3cff2df6 = "#3B475C";
var $f30b5a0680f78546$export$3902c91d8b98a753 = "#313D52";
var $f30b5a0680f78546$export$8e8133c1ba5845b5 = "#283447";
var $f30b5a0680f78546$export$33ff357f6620b39 = "#202B3D";
var $f30b5a0680f78546$export$633847cf062b69e0 = "#1B2638";
var $f30b5a0680f78546$export$9776a6e503bdbf76 = "#121A29";
var $f30b5a0680f78546$export$6c813d5160dff5db = "#0E1624";
var $f30b5a0680f78546$export$3d4f271a500072a = "#0D1424";
var $f30b5a0680f78546$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $f30b5a0680f78546$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $f30b5a0680f78546$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $f30b5a0680f78546$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $f30b5a0680f78546$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $f30b5a0680f78546$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $f30b5a0680f78546$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $f30b5a0680f78546$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $f30b5a0680f78546$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $f30b5a0680f78546$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $f30b5a0680f78546$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $f30b5a0680f78546$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $f30b5a0680f78546$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $f30b5a0680f78546$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $f30b5a0680f78546$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $f30b5a0680f78546$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $f30b5a0680f78546$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";

});



parcelRegister("ifVPK", function(module, exports) {

$parcel$export(module.exports, "EmptyViewWithFixedHeight", function () { return $d4a67d49460fabd7$export$8f45b9407d4090d7; });
$parcel$export(module.exports, "EmptyViewContainer", function () { return $d4a67d49460fabd7$export$381ea436de119582; });
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $avKww = parcelRequire("avKww");
var $d4a67d49460fabd7$var$fixedHeightStyles = (0, $avKww.css)({
    height: "9rem"
});
var $d4a67d49460fabd7$export$8f45b9407d4090d7 = function EmptyViewWithFixedHeight(_ref) {
    var children = _ref.children, testId = _ref.testId;
    return (0, $avKww.jsx)("div", {
        css: $d4a67d49460fabd7$var$fixedHeightStyles,
        "data-testid": testId && "".concat(testId, "--empty-view-with-fixed-height")
    }, children);
};
var $d4a67d49460fabd7$var$emptyViewContainerStyles = (0, $avKww.css)({
    width: "50%",
    margin: "auto",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    padding: "10px",
    textAlign: "center"
});
var $d4a67d49460fabd7$export$381ea436de119582 = function EmptyViewContainer(props) {
    var children = props.children, testId = props.testId;
    return (0, $avKww.jsx)("div", {
        css: $d4a67d49460fabd7$var$emptyViewContainerStyles,
        "data-testid": testId && "".concat(testId, "--empty-view-container")
    }, children);
};

});

parcelRegister("3KYhA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2bc46dd49b379da5$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $9nHZC = parcelRequire("9nHZC");

var $7T4QH = parcelRequire("7T4QH");

var $fIMMB = parcelRequire("fIMMB");
function $2bc46dd49b379da5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2bc46dd49b379da5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $2bc46dd49b379da5$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2bc46dd49b379da5$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $2bc46dd49b379da5$var$BodyComponent = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(BodyComponent, _React$Component);
    var _super = $2bc46dd49b379da5$var$_createSuper(BodyComponent);
    function BodyComponent() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, BodyComponent);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(BodyComponent, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, pageRows = _this$props.pageRows, head = _this$props.head, isFixedSize = _this$props.isFixedSize, highlightedRowIndex = _this$props.highlightedRowIndex, testId = _this$props.testId, forwardedRef = _this$props.forwardedRef;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("tbody", {
                    "data-testid": testId && "".concat(testId, "--body"),
                    ref: forwardedRef
                }, pageRows.map(function(row, rowIndex) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fIMMB.default), {
                        head: head,
                        isFixedSize: isFixedSize,
                        key: row.key || rowIndex,
                        row: row,
                        isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === "number" ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                        testId: testId
                    });
                }));
            }
        }
    ]);
    return BodyComponent;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component);
var $2bc46dd49b379da5$var$Body = (0, $7T4QH.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($2bc46dd49b379da5$var$BodyComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        forwardedRef: ref
    }));
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2bc46dd49b379da5$export$2e2bcd8739ae039 = $2bc46dd49b379da5$var$Body;

});
parcelRegister("7T4QH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5be16e5a2053c1be$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $340K4 = parcelRequire("340K4");

var $9nHZC = parcelRequire("9nHZC");

var $f0z3w = parcelRequire("f0z3w");

var $ju3lq = parcelRequire("ju3lq");
var $5be16e5a2053c1be$var$_excluded = [
    "rows",
    "head",
    "sortKey",
    "sortOrder",
    "rowsPerPage",
    "page",
    "forwardedRef"
];
function $5be16e5a2053c1be$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5be16e5a2053c1be$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5be16e5a2053c1be$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5be16e5a2053c1be$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5be16e5a2053c1be$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5be16e5a2053c1be$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $5be16e5a2053c1be$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5be16e5a2053c1be$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $5be16e5a2053c1be$var$getSortingCellValue = function getSortingCellValue(cells, head, sortKey) {
    for(var i = 0; i < cells.length; i++){
        var _head$cells$i;
        if (head.cells[i] && ((_head$cells$i = head.cells[i]) === null || _head$cells$i === void 0 ? void 0 : _head$cells$i.key) === sortKey) {
            var _cells$i;
            return (_cells$i = cells[i]) === null || _cells$i === void 0 ? void 0 : _cells$i.key;
        }
    }
    return undefined;
};
// sort all rows based on sort key and order
var $5be16e5a2053c1be$var$getSortedRows = function getSortedRows(head, rows, sortKey, sortOrder) {
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    var modifier = sortOrder === (0, $f0z3w.ASC) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    var collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: "accent"
    });
    // Get copy of rows to avoid sorting prop in place
    var sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort(function(a, b) {
        var valA = $5be16e5a2053c1be$var$getSortingCellValue(a.cells, head, sortKey);
        var valB = $5be16e5a2053c1be$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(valA) !== (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(valB)) {
            // numbers are always grouped higher in the sort
            if (typeof valA === "number") return -1;
            if (typeof valB === "number") return 1;
            // strings are grouped next
            if (typeof valA === "string") return -1;
            if (typeof valB === "string") return 1;
        }
        if (typeof valA === "string" && typeof valB === "string") return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $5be16e5a2053c1be$export$2e2bcd8739ae039(WrappedComponent) {
    var WithSortedPageRows = /*#__PURE__*/ function(_React$Component) {
        (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(WithSortedPageRows, _React$Component);
        var _super = $5be16e5a2053c1be$var$_createSuper(WithSortedPageRows);
        function WithSortedPageRows() {
            var _this;
            (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, WithSortedPageRows);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "state", {
                pageRows: []
            });
            return _this;
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(WithSortedPageRows, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(_prevProps, prevState) {
                    if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$props = this.props, rows = _this$props.rows, head = _this$props.head, sortKey = _this$props.sortKey, sortOrder = _this$props.sortOrder, rowsPerPage = _this$props.rowsPerPage, page = _this$props.page, forwardedRef = _this$props.forwardedRef, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_this$props, $5be16e5a2053c1be$var$_excluded);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                        pageRows: this.state.pageRows,
                        head: head
                    }, restProps, {
                        ref: forwardedRef
                    }));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(props, state) {
                    var rows = props.rows, head = props.head, sortKey = props.sortKey, sortOrder = props.sortOrder, page = props.page, rowsPerPage = props.rowsPerPage, isTotalPagesControlledExternally = props.isTotalPagesControlledExternally;
                    (0, $ju3lq.validateSortKey)(sortKey, head);
                    var sortedRows;
                    var pageRows;
                    if (isTotalPagesControlledExternally) {
                        sortedRows = rows;
                        pageRows = rows;
                    } else {
                        sortedRows = $5be16e5a2053c1be$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                        pageRows = (0, $ju3lq.getPageRows)(sortedRows, page, rowsPerPage);
                    }
                    return $5be16e5a2053c1be$var$_objectSpread($5be16e5a2053c1be$var$_objectSpread({}, state), {}, {
                        pageRows: pageRows
                    });
                }
            }
        ]);
        return WithSortedPageRows;
    }((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WithSortedPageRows, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
            forwardedRef: ref
        }));
    });
}

});

parcelRegister("fIMMB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b720ce57bbc7e850$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $gk7VE = parcelRequire("gk7VE");

var $2mzjw = parcelRequire("2mzjw");
var $b720ce57bbc7e850$var$_excluded = [
    "cells"
], $b720ce57bbc7e850$var$_excluded2 = [
    "content",
    "testId"
];
var $b720ce57bbc7e850$var$Row = function Row(_ref) {
    var row = _ref.row, head = _ref.head, testId = _ref.testId, isFixedSize = _ref.isFixedSize, isHighlighted = _ref.isHighlighted;
    var cells = row.cells, restRowProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(row, $b720ce57bbc7e850$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2mzjw.TableBodyRow), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, restRowProps, {
        isHighlighted: isHighlighted
    }, isHighlighted ? {
        "data-ts--dynamic-table--table-row--highlighted": true
    } : null, {
        testId: row.testId || testId && "".concat(testId, "--row-").concat(restRowProps.key)
    }), cells.map(function(cell, cellIndex) {
        var content = cell.content, cellTestId = cell.testId, restCellProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(cell, $b720ce57bbc7e850$var$_excluded2);
        var _ref2 = (head || {
            cells: []
        }).cells[cellIndex] || {}, shouldTruncate = _ref2.shouldTruncate, width = _ref2.width;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $gk7VE.TableBodyCell), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            "data-testid": cellTestId || testId && "".concat(testId, "--cell-").concat(cellIndex)
        }, restCellProps, {
            isFixedSize: isFixedSize,
            key: cellIndex // eslint-disable-line react/no-array-index-key
            ,
            shouldTruncate: shouldTruncate,
            width: width
        }), content);
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b720ce57bbc7e850$export$2e2bcd8739ae039 = $b720ce57bbc7e850$var$Row;

});
parcelRegister("gk7VE", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", function () { return $be24aa151c150e67$export$948e91fcef170792; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $avKww = parcelRequire("avKww");

var $TDWFG = parcelRequire("TDWFG");
var $be24aa151c150e67$var$_excluded = [
    "width",
    "isFixedSize",
    "shouldTruncate",
    "innerRef"
];
var $be24aa151c150e67$export$948e91fcef170792 = function TableBodyCell(_ref) {
    var width = _ref.width, isFixedSize = _ref.isFixedSize, shouldTruncate = _ref.shouldTruncate, innerRef = _ref.innerRef, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $be24aa151c150e67$var$_excluded);
    return (0, $avKww.jsx)("td", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $TDWFG.getTruncationStyleVars)({
            width: width
        }),
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $TDWFG.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $TDWFG.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && (0, $TDWFG.overflowTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $TDWFG.cellStyles)
        ],
        ref: innerRef
    }, props));
};

});
parcelRegister("TDWFG", function(module, exports) {

$parcel$export(module.exports, "truncationWidthStyles", function () { return $0a741f79d273e4b8$export$708a733455f59a29; });
$parcel$export(module.exports, "fixedSizeTruncateStyles", function () { return $0a741f79d273e4b8$export$616c93ee022c8812; });
$parcel$export(module.exports, "overflowTruncateStyles", function () { return $0a741f79d273e4b8$export$7f2cd17defa265d8; });
$parcel$export(module.exports, "getTruncationStyleVars", function () { return $0a741f79d273e4b8$export$5e6497a652ae30b5; });
$parcel$export(module.exports, "cellStyles", function () { return $0a741f79d273e4b8$export$f7913df521f684e2; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");
var $0a741f79d273e4b8$var$CSS_VAR_WIDTH = "--local-dynamic-table-width";
var $0a741f79d273e4b8$export$708a733455f59a29 = (0, $avKww.css)({
    width: "var(".concat($0a741f79d273e4b8$var$CSS_VAR_WIDTH, ")")
});
var $0a741f79d273e4b8$export$616c93ee022c8812 = (0, $avKww.css)({
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $0a741f79d273e4b8$export$7f2cd17defa265d8 = (0, $avKww.css)({
    overflow: "hidden"
});
var $0a741f79d273e4b8$export$5e6497a652ae30b5 = function getTruncationStyleVars(_ref) {
    var width = _ref.width;
    return typeof width !== "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, $0a741f79d273e4b8$var$CSS_VAR_WIDTH, "".concat(width, "%")) : undefined;
};
var $0a741f79d273e4b8$export$f7913df521f684e2 = (0, $avKww.css)({
    padding: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-100, 8px)"),
    border: "none",
    textAlign: "left",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&:first-of-type": {
        paddingInlineStart: "var(--ds-space-0, 0px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&:last-child": {
        paddingInlineEnd: "var(--ds-space-0, 0px)"
    }
});

});


parcelRegister("2mzjw", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", function () { return $1b890771e5328739$export$45f39d9c38b886d5; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $htrHJ = parcelRequire("htrHJ");
var $1b890771e5328739$var$_excluded = [
    "isHighlighted",
    "children",
    "style",
    "testId"
];
var $1b890771e5328739$var$rowStyles = (0, $avKww.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    "&:focus-visible": {
        outline: "2px solid ".concat("var(--ds-border-focused, ".concat("var(".concat((0, $htrHJ.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND, ")"), ")")),
        outlineOffset: "-2px"
    }
});
var $1b890771e5328739$var$rowBackgroundStyles = (0, $avKww.css)({
    "&:hover": {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, ".concat("var(".concat((0, $htrHJ.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND, ")"), ")")
    }
});
var $1b890771e5328739$var$rowHighlightedBackgroundStyles = (0, $avKww.css)({
    backgroundColor: "var(--ds-background-selected, ".concat("var(".concat((0, $htrHJ.tableRowCSSVars).CSS_VAR_HIGHLIGHTED_BACKGROUND, ")"), ")"),
    "&:hover": {
        backgroundColor: "var(--ds-background-selected-hovered, ".concat("var(".concat((0, $htrHJ.tableRowCSSVars).CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND, ")"), ")")
    }
});
var $1b890771e5328739$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var isHighlighted = _ref.isHighlighted, children = _ref.children, style = _ref.style, testId = _ref.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $1b890771e5328739$var$_excluded);
    return (0, $avKww.jsx)("tr", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        css: [
            $1b890771e5328739$var$rowStyles,
            isHighlighted ? $1b890771e5328739$var$rowHighlightedBackgroundStyles : $1b890771e5328739$var$rowBackgroundStyles
        ]
    }, rest, {
        ref: ref,
        "data-testid": testId
    }), children);
});

});



parcelRegister("gLPm3", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", function () { return $c358df143b8fe27d$export$e926676385687eaf; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $9nHZC = parcelRequire("9nHZC");
function $c358df143b8fe27d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c358df143b8fe27d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $c358df143b8fe27d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c358df143b8fe27d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $c358df143b8fe27d$export$e926676385687eaf = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(ErrorBoundary, _React$Component);
    var _super = $c358df143b8fe27d$var$_createSuper(ErrorBoundary);
    function ErrorBoundary(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ErrorBoundary);
        _this = _super.call(this, props);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ErrorBoundary, [
        {
            key: "render",
            value: function render() {
                if (this.state.hasError) // You can render any custom fallback UI
                return this.props.fallback;
                return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError() {
                // Update state so the next render will show the fallback UI.
                return {
                    hasError: true
                };
            }
        }
    ]);
    return ErrorBoundary;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component);

});

parcelRegister("8wcFl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $633b23143be1c07c$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $aGzJT = parcelRequire("aGzJT");

var $f0z3w = parcelRequire("f0z3w");

var $f3jrK = parcelRequire("f3jrK");
function $633b23143be1c07c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $633b23143be1c07c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $633b23143be1c07c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($633b23143be1c07c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $633b23143be1c07c$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(LoadingContainer, _React$Component);
    var _super = $633b23143be1c07c$var$_createSuper(LoadingContainer);
    function LoadingContainer() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, LoadingContainer);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(LoadingContainer, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, children = _this$props.children, isLoading = _this$props.isLoading, spinnerSize = _this$props.spinnerSize, contentsOpacity = _this$props.contentsOpacity, testId = _this$props.testId, loadingLabel = _this$props.loadingLabel;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $f3jrK.Container), {
                    testId: testId
                }, !isLoading ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $f3jrK.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId
                }, children), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $f3jrK.SpinnerContainer), {
                    testId: testId
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aGzJT.default), {
                    size: spinnerSize,
                    testId: testId && "".concat(testId, "--loadingSpinner"),
                    label: loadingLabel
                })));
            }
        }
    ]);
    return LoadingContainer;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component);
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($633b23143be1c07c$export$2e2bcd8739ae039, "defaultProps", {
    isLoading: true,
    spinnerSize: (0, $f0z3w.LARGE),
    contentsOpacity: (0, $f0z3w.LOADING_CONTENTS_OPACITY),
    loadingLabel: "Loading table"
});

});
parcelRegister("aGzJT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c798cb274deb09c$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $5fUc4 = parcelRequire("5fUc4");

var $kRIB6 = parcelRequire("kRIB6");

var $f3xvg = parcelRequire("f3xvg");
/**
 * Returns the appropriate circle stroke color.
 */ function $7c798cb274deb09c$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $kRIB6.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $kRIB6.N0), ")");
}
var $7c798cb274deb09c$var$rotate = (0, $avKww.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $7c798cb274deb09c$var$rotateStyles = (0, $avKww.css)({
    animation: "".concat($7c798cb274deb09c$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $7c798cb274deb09c$var$loadIn = (0, $avKww.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $7c798cb274deb09c$var$loadInStyles = (0, $avKww.css)({
    animation: "".concat($7c798cb274deb09c$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $7c798cb274deb09c$var$wrapperStyles = (0, $avKww.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $7c798cb274deb09c$var$circleStyles = (0, $avKww.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $7c798cb274deb09c$var$useLayoutEffect = typeof window === "undefined" ? (0, $9nHZC.useEffect) : (0, $9nHZC.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $7c798cb274deb09c$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $f3xvg.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $7c798cb274deb09c$var$getStrokeColor(appearance);
    var context = (0, $9nHZC.useContext)((0, $5fUc4.default));
    $7c798cb274deb09c$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $avKww.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $7c798cb274deb09c$var$wrapperStyles,
            $7c798cb274deb09c$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $avKww.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $7c798cb274deb09c$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none"
    }, (0, $avKww.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $7c798cb274deb09c$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $7c798cb274deb09c$export$2e2bcd8739ae039 = $7c798cb274deb09c$var$Spinner;

});
parcelRegister("f3xvg", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $af611fda76bdeca4$export$4e9f1640bbe7a1a8; });
var $af611fda76bdeca4$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("f3jrK", function(module, exports) {

$parcel$export(module.exports, "Container", function () { return $af5638873b5ef14d$export$42a852a2b6b56249; });
$parcel$export(module.exports, "ContentsContainer", function () { return $af5638873b5ef14d$export$67c29eae8ae2137a; });
$parcel$export(module.exports, "SpinnerContainer", function () { return $af5638873b5ef14d$export$a5e06607a5ac6158; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");
var $af5638873b5ef14d$export$c335a80381ec61f5 = "--contents-opacity";
var $af5638873b5ef14d$var$containerStyles = (0, $avKww.css)({
    position: "relative"
});
var $af5638873b5ef14d$export$42a852a2b6b56249 = function Container(_ref) {
    var children = _ref.children, testId = _ref.testId;
    return (0, $avKww.jsx)("div", {
        css: $af5638873b5ef14d$var$containerStyles,
        "data-testid": testId && "".concat(testId, "--container")
    }, children);
};
var $af5638873b5ef14d$var$contentsContainerStyles = (0, $avKww.css)({
    opacity: "var(".concat($af5638873b5ef14d$export$c335a80381ec61f5, ")"),
    pointerEvents: "none"
});
var $af5638873b5ef14d$export$67c29eae8ae2137a = function ContentsContainer(_ref2) {
    var children = _ref2.children, contentsOpacity = _ref2.contentsOpacity, testId = _ref2.testId;
    return (0, $avKww.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, $af5638873b5ef14d$export$c335a80381ec61f5, contentsOpacity),
        css: [
            $af5638873b5ef14d$var$contentsContainerStyles
        ],
        "data-testid": testId && "".concat(testId, "--contents--container")
    }, children);
};
var $af5638873b5ef14d$var$spinnerContainerStyles = (0, $avKww.css)({
    display: "flex",
    position: "absolute",
    inset: 0,
    alignItems: "center",
    justifyContent: "center"
});
var $af5638873b5ef14d$export$a5e06607a5ac6158 = function SpinnerContainer(_ref4) {
    var children = _ref4.children, testId = _ref4.testId;
    return (0, $avKww.jsx)("div", {
        css: $af5638873b5ef14d$var$spinnerContainerStyles,
        "data-testid": testId && "".concat(testId, "--spinner--container")
    }, children);
};

});


parcelRegister("i5hOJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2a683c15d3c1236$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $aGzJT = parcelRequire("aGzJT");

var $f0z3w = parcelRequire("f0z3w");

var $hL564 = parcelRequire("hL564");
function $d2a683c15d3c1236$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d2a683c15d3c1236$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $d2a683c15d3c1236$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d2a683c15d3c1236$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $d2a683c15d3c1236$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(LoadingContainerAdvanced, _React$Component);
    var _super = $d2a683c15d3c1236$var$_createSuper(LoadingContainerAdvanced);
    function LoadingContainerAdvanced() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, LoadingContainerAdvanced);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "spinnerRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createRef());
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "containerRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createRef());
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "componentDidMount", function() {
            if (_this.props.isLoading && _this.hasTargetNode()) {
                _this.attachListeners();
                _this.updateTargetAppearance();
                _this.updateSpinnerPosition();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "UNSAFE_componentWillReceiveProps", function(nextProps) {
            if (!nextProps.isLoading || !_this.hasTargetNode(nextProps)) _this.detachListeners();
            else if (!_this.props.isLoading) _this.attachListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "componentDidUpdate", function() {
            if (_this.hasTargetNode()) {
                _this.updateTargetAppearance();
                if (_this.props.isLoading) _this.updateSpinnerPosition();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "componentWillUnmount", function() {
            _this.detachListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getTargetNode", function() {
            var nextProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
            var targetRef = nextProps.targetRef;
            var target = targetRef === null || targetRef === void 0 ? void 0 : targetRef();
            return target || _this.containerRef.current;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "hasTargetNode", function(nextProps) {
            return !!_this.getTargetNode(nextProps);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "isVerticallyVisible", function(elementRect, viewportHeight) {
            var top = elementRect.top, bottom = elementRect.bottom;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "isFullyVerticallyVisible", function(elementRect, viewportHeight) {
            var top = elementRect.top, bottom = elementRect.bottom;
            return top >= 0 && bottom <= viewportHeight;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleResize", function() {
            _this.updateSpinnerPosition();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleScroll", function() {
            _this.updateSpinnerPosition();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "translateSpinner", function(spinnerNode, transformY, isFixed) {
            spinnerNode.style.position = isFixed ? "fixed" : "";
            spinnerNode.style.transform = transformY !== 0 ? "translate3d(0, ".concat(transformY, "px, 0)") : "";
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "updateTargetAppearance", function() {
            var targetNode = _this.getTargetNode();
            var _this$props = _this.props, isLoading = _this$props.isLoading, contentsOpacity = _this$props.contentsOpacity;
            if (targetNode && targetNode.style && (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(targetNode.style) === "object") {
                targetNode.style.pointerEvents = isLoading ? "none" : "";
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : "";
            }
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(LoadingContainerAdvanced, [
        {
            key: "attachListeners",
            value: function attachListeners() {
                window.addEventListener("scroll", this.handleScroll);
                window.addEventListener("resize", this.handleResize);
            }
        },
        {
            key: "detachListeners",
            value: function detachListeners() {
                window.removeEventListener("scroll", this.handleScroll);
                window.removeEventListener("resize", this.handleResize);
            }
        },
        {
            key: "updateSpinnerPosition",
            value: function updateSpinnerPosition() {
                var _this$spinnerRef, _this$containerRef;
                var viewportHeight = window.innerHeight;
                var targetNode = this.getTargetNode();
                var spinnerNode = (_this$spinnerRef = this.spinnerRef) === null || _this$spinnerRef === void 0 ? void 0 : _this$spinnerRef.current;
                if (!targetNode || typeof targetNode.getBoundingClientRect !== "function" || !spinnerNode) return;
                var targetRect = targetNode.getBoundingClientRect();
                var spinnerRect = spinnerNode.getBoundingClientRect();
                var spinnerHeight = spinnerRect.height;
                var isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
                var top = targetRect.top, bottom = targetRect.bottom, height = targetRect.height;
                if (isInViewport) {
                    // The spinner may follow the element only if there is enough space:
                    // Let's say the element can fit at least three spinners (vertically)
                    var canFollow = height >= spinnerHeight * 3;
                    if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                        if (top >= 0) {
                            // Only the head of the element is visible
                            var viewportSpaceTakenByElement = viewportHeight - top;
                            var diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                            var y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                            this.translateSpinner(spinnerNode, y, true);
                        } else if (top < 0 && bottom > viewportHeight) {
                            // The element takes all viewport, nor its head nor tail are visible
                            var _y = viewportHeight / 2 - spinnerHeight / 2;
                            this.translateSpinner(spinnerNode, _y, true);
                        } else {
                            // Only the tail of the element is visible
                            var _diff = bottom / 2 - spinnerHeight / 2;
                            var _y2 = _diff < spinnerHeight ? _diff - (spinnerHeight - _diff) : _diff;
                            this.translateSpinner(spinnerNode, _y2, true);
                        }
                        return;
                    }
                } else {
                    // If both the element and the spinner are off screen - quit
                    if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
                }
                // Three options here:
                // 1) the element is fully visible
                // 2) the element is too small for the spinner to follow
                // 3) the spinner might still be visible while the element isn't
                var containerNode = (_this$containerRef = this.containerRef) === null || _this$containerRef === void 0 ? void 0 : _this$containerRef.current;
                if (containerNode && typeof containerNode.getBoundingClientRect === "function") {
                    var thisTop = containerNode.getBoundingClientRect().top;
                    var _y3 = (top - thisTop) / 2;
                    this.translateSpinner(spinnerNode, _y3, false);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, children = _this$props2.children, isLoading = _this$props2.isLoading, spinnerSize = _this$props2.spinnerSize, testId = _this$props2.testId, loadingLabel = _this$props2.loadingLabel;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $hL564.Container), {
                    testId: testId && "".concat(testId, "--loading--container--advanced"),
                    ref: this.containerRef
                }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $hL564.SpinnerBackdrop), {
                    testId: testId
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $hL564.SpinnerContainer), {
                    ref: this.spinnerRef
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aGzJT.default), {
                    size: spinnerSize,
                    testId: testId && "".concat(testId, "--loadingSpinner"),
                    label: loadingLabel
                }))));
            }
        }
    ]);
    return LoadingContainerAdvanced;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component);
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($d2a683c15d3c1236$export$2e2bcd8739ae039, "defaultProps", {
    isLoading: true,
    spinnerSize: (0, $f0z3w.LARGE),
    contentsOpacity: "var(--ds-opacity-loading, ".concat("".concat((0, $f0z3w.LOADING_CONTENTS_OPACITY)), ")"),
    loadingLabel: "Loading table"
});

});
parcelRegister("hL564", function(module, exports) {

$parcel$export(module.exports, "Container", function () { return $cedac793e5876f79$export$42a852a2b6b56249; });
$parcel$export(module.exports, "SpinnerBackdrop", function () { return $cedac793e5876f79$export$aa207050321b0c53; });
$parcel$export(module.exports, "SpinnerContainer", function () { return $cedac793e5876f79$export$a5e06607a5ac6158; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");
var $cedac793e5876f79$var$_excluded = [
    "children",
    "testId"
];
var $cedac793e5876f79$var$containerStyles = (0, $avKww.css)({
    position: "relative",
    marginBlockEnd: "var(--ds-space-300, 24px)"
});
var $cedac793e5876f79$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(props, ref) {
    var children = props.children, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(props, $cedac793e5876f79$var$_excluded);
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, $avKww.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        css: $cedac793e5876f79$var$containerStyles
    }, rest, {
        "data-testid": testId,
        ref: ref
    }), children));
});
var $cedac793e5876f79$var$spinnerBackdropStyles = (0, $avKww.css)({
    display: "flex",
    position: "absolute",
    inset: 0,
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none"
});
var $cedac793e5876f79$export$aa207050321b0c53 = function SpinnerBackdrop(_ref) {
    var children = _ref.children, testId = _ref.testId;
    return (0, $avKww.jsx)("div", {
        css: $cedac793e5876f79$var$spinnerBackdropStyles,
        "data-testid": testId && "".concat(testId, "--spinner-backdrop")
    }, children);
};
var $cedac793e5876f79$var$spinnerContainerStyles = (0, $avKww.css)({
    position: "relative",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    insetBlockStart: 0
});
var $cedac793e5876f79$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref2, ref) {
    var children = _ref2.children;
    return (0, $avKww.jsx)("div", {
        css: $cedac793e5876f79$var$spinnerContainerStyles,
        ref: ref
    }, children);
});

});


parcelRegister("6TveR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50501c763ae1f6c9$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $5roBI = parcelRequire("5roBI");
function $50501c763ae1f6c9$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $50501c763ae1f6c9$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $50501c763ae1f6c9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($50501c763ae1f6c9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $50501c763ae1f6c9$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(ManagedPagination, _React$Component);
    var _super = $50501c763ae1f6c9$var$_createSuper(ManagedPagination);
    function ManagedPagination() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ManagedPagination);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onChange", function(_event, newValue, analyticsEvent) {
            _this.props.onChange(newValue, analyticsEvent);
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ManagedPagination, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, total = _this$props.total, _this$props$value = _this$props.value, value = _this$props$value === void 0 ? 1 : _this$props$value, i18n = _this$props.i18n, testId = _this$props.testId, isDisabled = _this$props.isDisabled;
                var pages = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(Array(total)).map(function(_, index) {
                    return index + 1;
                });
                // Pagination accepts array now thus selectedIndex starts with 0
                // So, we are substracting value by one thus not breaking dynamic table
                var selectedIndex = value - 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5roBI.default), {
                    selectedIndex: selectedIndex,
                    isDisabled: isDisabled,
                    label: i18n === null || i18n === void 0 ? void 0 : i18n.label,
                    nextLabel: i18n === null || i18n === void 0 ? void 0 : i18n.next,
                    previousLabel: i18n === null || i18n === void 0 ? void 0 : i18n.prev,
                    pageLabel: i18n === null || i18n === void 0 ? void 0 : i18n.pageLabel,
                    onChange: this.onChange,
                    pages: pages,
                    testId: testId && "".concat(testId, "--pagination")
                });
            }
        }
    ]);
    return ManagedPagination;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component);

});
parcelRegister("5roBI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f628fe3598b99f0$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $kaQ2A = parcelRequire("kaQ2A");

var $8p2GL = parcelRequire("8p2GL");

var $84iaW = parcelRequire("84iaW");

var $dIdir = parcelRequire("dIdir");

var $lxm1S = parcelRequire("lxm1S");

var $7iakf = parcelRequire("7iakf");
var $bvh2U = parcelRequire("bvh2U");
var $aBFov = parcelRequire("aBFov");

var $hfblc = parcelRequire("hfblc");

var $253bx = parcelRequire("253bx");

var $kc8UR = parcelRequire("kc8UR");

var $c0Ylm = parcelRequire("c0Ylm");

var $ksWXC = parcelRequire("ksWXC");
function $3f628fe3598b99f0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3f628fe3598b99f0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3f628fe3598b99f0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3f628fe3598b99f0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3f628fe3598b99f0$var$analyticsAttributes = {
    componentName: "pagination",
    packageName: "@atlaskit/pagination",
    packageVersion: "14.8.1"
};
var $3f628fe3598b99f0$var$paginationMenuStyles = (0, $aBFov.xcss)({
    padding: "space.0",
    margin: "space.0"
});
var $3f628fe3598b99f0$var$paginationMenuItemStyles = (0, $aBFov.xcss)({
    marginBlockStart: "space.0"
});
function $3f628fe3598b99f0$var$InnerPagination(_ref, ref) {
    var _ref$components = _ref.components, components = _ref$components === void 0 ? (0, $c0Ylm.emptyObject) : _ref$components, _ref$defaultSelectedI = _ref.defaultSelectedIndex, defaultSelectedIndex = _ref$defaultSelectedI === void 0 ? 0 : _ref$defaultSelectedI, selectedIndex = _ref.selectedIndex, _ref$label = _ref.label, label = _ref$label === void 0 ? "pagination" : _ref$label, _ref$pageLabel = _ref.pageLabel, pageLabel = _ref$pageLabel === void 0 ? "page" : _ref$pageLabel, _ref$previousLabel = _ref.previousLabel, previousLabel = _ref$previousLabel === void 0 ? "previous" : _ref$previousLabel, _ref$nextLabel = _ref.nextLabel, nextLabel = _ref$nextLabel === void 0 ? "next" : _ref$nextLabel, _ref$style = _ref.style, style = _ref$style === void 0 ? (0, $c0Ylm.emptyObject) : _ref$style, _ref$max = _ref.max, max = _ref$max === void 0 ? 7 : _ref$max, _ref$onChange = _ref.onChange, onChange = _ref$onChange === void 0 ? (0, $8p2GL.default) : _ref$onChange, pages = _ref.pages, getPageLabel = _ref.getPageLabel, _ref$renderEllipsis = _ref.renderEllipsis, renderEllipsis = _ref$renderEllipsis === void 0 ? (0, $kc8UR.default) : _ref$renderEllipsis, analyticsContext = _ref.analyticsContext, testId = _ref.testId, isDisabled = _ref.isDisabled;
    var _useControlled = (0, $84iaW.default)(selectedIndex, function() {
        return defaultSelectedIndex || 0;
    }), _useControlled2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useControlled, 2), selectedIndexValue = _useControlled2[0], setSelectedIndexValue = _useControlled2[1];
    var onChangeWithAnalytics = (0, $kaQ2A.usePlatformLeafEventHandler)($3f628fe3598b99f0$var$_objectSpread({
        fn: function fn(value, analyticsEvent) {
            var event = value.event, selectedPageIndex = value.selectedPageIndex;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: "changed",
        actionSubject: "pageNumber",
        analyticsData: analyticsContext
    }, $3f628fe3598b99f0$var$analyticsAttributes));
    var transform = function transform(page, currPageIndex, testId) {
        var selectedPage = pages[selectedIndexValue];
        var pageIndexLabel = "".concat(pageLabel, " ").concat(getPageLabel ? getPageLabel(page, currPageIndex) : page);
        var isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $bvh2U.default), {
            as: "li",
            xcss: $3f628fe3598b99f0$var$paginationMenuItemStyles,
            key: "page-".concat(getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $253bx.default), {
            component: components.Page,
            onClick: function onClick(event) {
                return onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: currPageIndex
                });
            },
            "aria-current": isCurrentPage ? "page" : undefined,
            "aria-label": pageIndexLabel,
            isSelected: isCurrentPage,
            isDisabled: isDisabled,
            page: page,
            testId: testId && "".concat(testId, "--").concat(isCurrentPage ? "current-" : "", "page-").concat(currPageIndex)
        }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
    };
    return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7iakf.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $bvh2U.default), {
        space: "space.0",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $hfblc.default), {
        key: "left-navigator",
        component: components.Previous,
        onClick: function onClick(event) {
            return onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue - 1
            });
        },
        isDisabled: isDisabled || selectedIndexValue === 0,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dIdir))), {
            label: ""
        }),
        "aria-label": previousLabel,
        testId: testId && "".concat(testId, "--left-navigator")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $bvh2U.default), {
        space: "space.0",
        alignBlock: "baseline",
        as: "ul",
        xcss: $3f628fe3598b99f0$var$paginationMenuStyles
    }, (0, $ksWXC.default)(pages, selectedIndexValue, {
        max: max,
        ellipsis: renderEllipsis,
        transform: transform
    }, testId)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $hfblc.default), {
        key: "right-navigator",
        component: components.Next,
        onClick: function onClick(event) {
            return onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue + 1
            });
        },
        isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lxm1S))), {
            label: ""
        }),
        "aria-label": nextLabel,
        testId: testId && "".concat(testId, "--right-navigator")
    }))));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ var $3f628fe3598b99f0$var$Pagination = /*#__PURE__*/ (0, $9nHZC.memo)(/*#__PURE__*/ (0, $9nHZC.forwardRef)($3f628fe3598b99f0$var$InnerPagination));
var $3f628fe3598b99f0$export$2e2bcd8739ae039 = $3f628fe3598b99f0$var$Pagination;

});
parcelRegister("kaQ2A", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $eafd1c0a223eeb7c$export$a4687b0234b40e28; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $2p5Xc = parcelRequire("2p5Xc");

var $4zDYf = parcelRequire("4zDYf");
function $eafd1c0a223eeb7c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eafd1c0a223eeb7c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eafd1c0a223eeb7c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eafd1c0a223eeb7c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $eafd1c0a223eeb7c$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $2p5Xc.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $4zDYf.useTrackedRef)(analyticsData);
    var fnRef = (0, $4zDYf.useTrackedRef)(fn);
    var handler = (0, $9nHZC.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $eafd1c0a223eeb7c$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("2p5Xc", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $1c0288e5402c06f8$export$5bf35293e545f20c; });

var $dNznA = parcelRequire("dNznA");

var $2PmPj = parcelRequire("2PmPj");

var $kO71o = parcelRequire("kO71o");
function $1c0288e5402c06f8$export$5bf35293e545f20c() {
    var analyticsContext = (0, $kO71o.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $2PmPj.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("2PmPj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20f20d12261203ff$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $3T8N8 = parcelRequire("3T8N8");
function $20f20d12261203ff$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $20f20d12261203ff$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $20f20d12261203ff$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($20f20d12261203ff$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $20f20d12261203ff$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $20f20d12261203ff$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $20f20d12261203ff$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $20f20d12261203ff$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $3T8N8.default));

});
parcelRegister("3T8N8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d4d53fb205e87f4$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
function $2d4d53fb205e87f4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2d4d53fb205e87f4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2d4d53fb205e87f4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2d4d53fb205e87f4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2d4d53fb205e87f4$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $2d4d53fb205e87f4$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $2d4d53fb205e87f4$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $2d4d53fb205e87f4$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(updater) === "object") this.payload = $2d4d53fb205e87f4$var$_objectSpread($2d4d53fb205e87f4$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("kO71o", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $f25dec75c9a07520$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $f25dec75c9a07520$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});


parcelRegister("4zDYf", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $35496fafaebf4e8c$export$1d27a74659855e44; });

var $9nHZC = parcelRequire("9nHZC");
var $35496fafaebf4e8c$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("84iaW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $018413cd5a1d11bb$export$2e2bcd8739ae039; });

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");
function $018413cd5a1d11bb$export$2e2bcd8739ae039(propValue) {
    var getDefaultPropValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
        return propValue;
    };
    var isControlled = propValue !== undefined;
    var _useState = (0, $9nHZC.useState)(getDefaultPropValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), valueState = _useState2[0], setValue = _useState2[1];
    var isControlledRef = (0, $9nHZC.useRef)(isControlled);
    (0, $9nHZC.useEffect)(function() {
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var value = isControlled ? propValue : valueState;
    var setValueIfUncontrolled = (0, $9nHZC.useCallback)(function(newValue) {
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("dIdir", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9fb9b2d6ae339047$var$_react = $9fb9b2d6ae339047$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $9fb9b2d6ae339047$var$_chevronLeft = $9fb9b2d6ae339047$var$_interopRequireDefault((parcelRequire("aSXXi")));
function $9fb9b2d6ae339047$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9fb9b2d6ae339047$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $9fb9b2d6ae339047$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $9fb9b2d6ae339047$var$_chevronLeft.default,
        iconType: "utility"
    }));
$9fb9b2d6ae339047$var$ChevronLeftLargeIcon.displayName = "ChevronLeftLargeIcon";
var $9fb9b2d6ae339047$var$_default = module.exports.default = $9fb9b2d6ae339047$var$ChevronLeftLargeIcon;

});
parcelRegister("aSXXi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db781ab5297a2cc1540c99d75921a718>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ecd746c5cbdd160$var$_react = $7ecd746c5cbdd160$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $7ecd746c5cbdd160$var$_UNSAFE_baseNew = $7ecd746c5cbdd160$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $7ecd746c5cbdd160$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7ecd746c5cbdd160$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $7ecd746c5cbdd160$var$_react.default.createElement($7ecd746c5cbdd160$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: "utility"
    }, props));
$7ecd746c5cbdd160$var$ChevronLeftIcon.displayName = "ChevronLeftIcon";
var $7ecd746c5cbdd160$var$_default = module.exports.default = $7ecd746c5cbdd160$var$ChevronLeftIcon;

});


parcelRegister("lxm1S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $faddc49d72acd96c$var$_react = $faddc49d72acd96c$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $faddc49d72acd96c$var$_chevronRight = $faddc49d72acd96c$var$_interopRequireDefault((parcelRequire("8zVHJ")));
function $faddc49d72acd96c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $faddc49d72acd96c$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $faddc49d72acd96c$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $faddc49d72acd96c$var$_chevronRight.default,
        iconType: "utility"
    }));
$faddc49d72acd96c$var$ChevronRightLargeIcon.displayName = "ChevronRightLargeIcon";
var $faddc49d72acd96c$var$_default = module.exports.default = $faddc49d72acd96c$var$ChevronRightLargeIcon;

});
parcelRegister("8zVHJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::06cd0b36f2db8d427e1038f3037e7be1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $63ee5a831840b897$var$_react = $63ee5a831840b897$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $63ee5a831840b897$var$_UNSAFE_baseNew = $63ee5a831840b897$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $63ee5a831840b897$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronRight".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $63ee5a831840b897$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $63ee5a831840b897$var$_react.default.createElement($63ee5a831840b897$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.5 10.5 9 6 4.5 1.5"/>`,
        type: "utility"
    }, props));
$63ee5a831840b897$var$ChevronRightIcon.displayName = "ChevronRightIcon";
var $63ee5a831840b897$var$_default = module.exports.default = $63ee5a831840b897$var$ChevronRightIcon;

});


parcelRegister("7iakf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54f2394f429ccf9c$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $4x0Le = parcelRequire("4x0Le");

var $aBFov = parcelRequire("aBFov");

var $je0pP = parcelRequire("je0pP");
var $54f2394f429ccf9c$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $54f2394f429ccf9c$var$_excluded2 = [
    "className"
];
var $54f2394f429ccf9c$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $54f2394f429ccf9c$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(htmlAttributes, $54f2394f429ccf9c$var$_excluded2);
    var resolvedStyles = (0, $aBFov.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $avKww.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $54f2394f429ccf9c$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $4x0Le.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $4x0Le.isSurfaceColorToken)(backgroundColor) && (0, $4x0Le.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $4x0Le.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $4x0Le.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $4x0Le.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $4x0Le.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $4x0Le.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $4x0Le.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $4x0Le.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $avKww.jsx)((0, $je0pP.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $54f2394f429ccf9c$export$2e2bcd8739ae039 = $54f2394f429ccf9c$export$e71c4d32a2263218;
var $54f2394f429ccf9c$var$baseStyles = (0, $avKww.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("4x0Le", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $34cad592f380845a$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $34cad592f380845a$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $34cad592f380845a$export$632685d741f3dbbf; });
$parcel$export(module.exports, "inverseColorMap", function () { return $34cad592f380845a$export$2185ce37f9bdd963; });
$parcel$export(module.exports, "opacityMap", function () { return $34cad592f380845a$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $34cad592f380845a$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $34cad592f380845a$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $34cad592f380845a$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $34cad592f380845a$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $34cad592f380845a$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $34cad592f380845a$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $34cad592f380845a$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $34cad592f380845a$export$e615f061ca585a6c; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $34cad592f380845a$export$bf46c3f9eeafc71f; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $34cad592f380845a$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "textColorStylesMap", function () { return $34cad592f380845a$export$3a1bcba60b23d7f0; });
$parcel$export(module.exports, "fontWeightStylesMap", function () { return $34cad592f380845a$export$45f3f4fe16f9f7d5; });
$parcel$export(module.exports, "fontStylesMap", function () { return $34cad592f380845a$export$128f10c238242f83; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $34cad592f380845a$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $34cad592f380845a$export$5e65a44e5b6ecadb; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $xbX1J = parcelRequire("xbX1J");
function $34cad592f380845a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $34cad592f380845a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $34cad592f380845a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $34cad592f380845a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $34cad592f380845a$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $34cad592f380845a$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $34cad592f380845a$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $34cad592f380845a$export$632685d741f3dbbf = $34cad592f380845a$var$_objectSpread($34cad592f380845a$var$_objectSpread({}, $34cad592f380845a$export$958d0ae7f2977ae4), $34cad592f380845a$export$d2dc61f58390201c);
var $34cad592f380845a$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $34cad592f380845a$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $34cad592f380845a$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $34cad592f380845a$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $34cad592f380845a$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $34cad592f380845a$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $34cad592f380845a$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $34cad592f380845a$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $34cad592f380845a$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $34cad592f380845a$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $34cad592f380845a$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $34cad592f380845a$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $34cad592f380845a$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $34cad592f380845a$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $34cad592f380845a$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $34cad592f380845a$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $avKww.css)((0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $34cad592f380845a$export$e615f061ca585a6c = $34cad592f380845a$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $34cad592f380845a$var$getSerializedStylesMap(spacingProperty, $34cad592f380845a$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $34cad592f380845a$export$bf46c3f9eeafc71f = $34cad592f380845a$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $34cad592f380845a$var$getSerializedStylesMap(spacingProperty, $34cad592f380845a$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $34cad592f380845a$export$e7af83bafe7f9e63 = $34cad592f380845a$var$getSerializedStylesMap("backgroundColor", $34cad592f380845a$export$d1d79bf68ac056bd);
var $34cad592f380845a$export$3a1bcba60b23d7f0 = $34cad592f380845a$var$getSerializedStylesMap("color", $34cad592f380845a$export$8473307aa00d6ea1);
var $34cad592f380845a$export$45f3f4fe16f9f7d5 = $34cad592f380845a$var$getSerializedStylesMap("fontWeight", $34cad592f380845a$export$303e322c6b1ed114);
var $34cad592f380845a$export$68cc305da27dbaa4 = $34cad592f380845a$var$getSerializedStylesMap("fontFamily", $34cad592f380845a$export$3c7e9587132614b4);
var $34cad592f380845a$export$128f10c238242f83 = $34cad592f380845a$var$getSerializedStylesMap("font", $34cad592f380845a$export$6cc560b4dedf3816);
var $34cad592f380845a$export$ff257d957d48c421 = $34cad592f380845a$var$getSerializedStylesMap((0, $xbX1J.CURRENT_SURFACE_CSS_VAR), $34cad592f380845a$export$41a358c9c2356760);
var $34cad592f380845a$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $34cad592f380845a$export$41a358c9c2356760[color] !== undefined;
};

});

parcelRegister("aBFov", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $7b8d7822341483c5$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $7b8d7822341483c5$export$f6c783d06584602c; });

var $b4Ivn = parcelRequire("b4Ivn");

var $kFnE9 = parcelRequire("kFnE9");

var $9q1kH = parcelRequire("9q1kH");

var $340K4 = parcelRequire("340K4");

var $avKww = parcelRequire("avKww");

var $4x0Le = parcelRequire("4x0Le");

var $8ovux = parcelRequire("8ovux");
function $7b8d7822341483c5$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $7b8d7822341483c5$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $7b8d7822341483c5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7b8d7822341483c5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7b8d7822341483c5$var$_arrayLikeToArray(o, minLen);
}
function $7b8d7822341483c5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $7b8d7822341483c5$export$9a199fbafee0014e = {
    backgroundColor: (0, $4x0Le.backgroundColorMap),
    blockSize: (0, $4x0Le.dimensionMap),
    borderBlockColor: (0, $4x0Le.borderColorMap),
    borderBlockEndColor: (0, $4x0Le.borderColorMap),
    borderBlockEndWidth: (0, $4x0Le.borderWidthMap),
    borderBlockStartColor: (0, $4x0Le.borderColorMap),
    borderBlockStartWidth: (0, $4x0Le.borderWidthMap),
    borderBlockWidth: (0, $4x0Le.borderWidthMap),
    borderBottomColor: (0, $4x0Le.borderColorMap),
    borderBottomLeftRadius: (0, $4x0Le.borderRadiusMap),
    borderBottomRightRadius: (0, $4x0Le.borderRadiusMap),
    borderBottomWidth: (0, $4x0Le.borderWidthMap),
    borderColor: (0, $4x0Le.borderColorMap),
    borderEndEndRadius: (0, $4x0Le.borderRadiusMap),
    borderEndStartRadius: (0, $4x0Le.borderRadiusMap),
    borderInlineColor: (0, $4x0Le.borderColorMap),
    borderInlineEndColor: (0, $4x0Le.borderColorMap),
    borderInlineEndWidth: (0, $4x0Le.borderWidthMap),
    borderInlineStartColor: (0, $4x0Le.borderColorMap),
    borderInlineStartWidth: (0, $4x0Le.borderWidthMap),
    borderInlineWidth: (0, $4x0Le.borderWidthMap),
    borderLeftColor: (0, $4x0Le.borderColorMap),
    borderLeftWidth: (0, $4x0Le.borderWidthMap),
    borderRadius: (0, $4x0Le.borderRadiusMap),
    borderRightColor: (0, $4x0Le.borderColorMap),
    borderRightWidth: (0, $4x0Le.borderWidthMap),
    borderStartEndRadius: (0, $4x0Le.borderRadiusMap),
    borderStartStartRadius: (0, $4x0Le.borderRadiusMap),
    borderTopColor: (0, $4x0Le.borderColorMap),
    borderTopLeftRadius: (0, $4x0Le.borderRadiusMap),
    borderTopRightRadius: (0, $4x0Le.borderRadiusMap),
    borderTopWidth: (0, $4x0Le.borderWidthMap),
    borderWidth: (0, $4x0Le.borderWidthMap),
    bottom: (0, $4x0Le.allSpaceMap),
    boxShadow: (0, $4x0Le.shadowMap),
    color: (0, $4x0Le.textColorMap),
    columnGap: (0, $4x0Le.positiveSpaceMap),
    gap: (0, $4x0Le.positiveSpaceMap),
    height: (0, $4x0Le.dimensionMap),
    inlineSize: (0, $4x0Le.dimensionMap),
    inset: (0, $4x0Le.allSpaceMap),
    insetBlock: (0, $4x0Le.allSpaceMap),
    insetBlockEnd: (0, $4x0Le.allSpaceMap),
    insetBlockStart: (0, $4x0Le.allSpaceMap),
    insetInline: (0, $4x0Le.allSpaceMap),
    insetInlineEnd: (0, $4x0Le.allSpaceMap),
    insetInlineStart: (0, $4x0Le.allSpaceMap),
    left: (0, $4x0Le.allSpaceMap),
    margin: (0, $4x0Le.allSpaceMap),
    marginBlock: (0, $4x0Le.allSpaceMap),
    marginBlockEnd: (0, $4x0Le.allSpaceMap),
    marginBlockStart: (0, $4x0Le.allSpaceMap),
    marginBottom: (0, $4x0Le.allSpaceMap),
    marginInline: (0, $4x0Le.allSpaceMap),
    marginInlineEnd: (0, $4x0Le.allSpaceMap),
    marginInlineStart: (0, $4x0Le.allSpaceMap),
    marginLeft: (0, $4x0Le.allSpaceMap),
    marginRight: (0, $4x0Le.allSpaceMap),
    marginTop: (0, $4x0Le.allSpaceMap),
    maxBlockSize: (0, $4x0Le.dimensionMap),
    maxHeight: (0, $4x0Le.dimensionMap),
    maxInlineSize: (0, $4x0Le.dimensionMap),
    maxWidth: (0, $4x0Le.dimensionMap),
    minBlockSize: (0, $4x0Le.dimensionMap),
    minHeight: (0, $4x0Le.dimensionMap),
    minInlineSize: (0, $4x0Le.dimensionMap),
    minWidth: (0, $4x0Le.dimensionMap),
    opacity: (0, $4x0Le.opacityMap),
    outlineColor: (0, $4x0Le.borderColorMap),
    outlineOffset: (0, $4x0Le.positiveSpaceMap),
    outlineWidth: (0, $4x0Le.borderWidthMap),
    padding: (0, $4x0Le.positiveSpaceMap),
    paddingBlock: (0, $4x0Le.positiveSpaceMap),
    paddingBlockEnd: (0, $4x0Le.positiveSpaceMap),
    paddingBlockStart: (0, $4x0Le.positiveSpaceMap),
    paddingBottom: (0, $4x0Le.positiveSpaceMap),
    paddingInline: (0, $4x0Le.positiveSpaceMap),
    paddingInlineEnd: (0, $4x0Le.positiveSpaceMap),
    paddingInlineStart: (0, $4x0Le.positiveSpaceMap),
    paddingLeft: (0, $4x0Le.positiveSpaceMap),
    paddingRight: (0, $4x0Le.positiveSpaceMap),
    paddingTop: (0, $4x0Le.positiveSpaceMap),
    right: (0, $4x0Le.allSpaceMap),
    rowGap: (0, $4x0Le.positiveSpaceMap),
    top: (0, $4x0Le.allSpaceMap),
    width: (0, $4x0Le.dimensionMap),
    zIndex: (0, $4x0Le.layerMap)
};
var $7b8d7822341483c5$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $7b8d7822341483c5$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $8ovux === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux.env) === "object" && false;
};
var $7b8d7822341483c5$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $7b8d7822341483c5$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $7b8d7822341483c5$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(value) === "object" && $7b8d7822341483c5$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($7b8d7822341483c5$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($7b8d7822341483c5$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $7b8d7822341483c5$export$9a199fbafee0014e)) return;
        var tokenValue = $7b8d7822341483c5$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $7b8d7822341483c5$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $7b8d7822341483c5$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, $7b8d7822341483c5$var$uniqueSymbol, (0, $avKww.css)(transformedStyles));
};
var $7b8d7822341483c5$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $7b8d7822341483c5$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$7b8d7822341483c5$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $7b8d7822341483c5$export$f6c783d06584602c(style) {
    return $7b8d7822341483c5$var$baseXcss(style);
}

});

parcelRegister("je0pP", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $dfefa5a1af2c53c1$export$1ca2a26fecb070ae; });
$parcel$export(module.exports, "useSurface", function () { return $dfefa5a1af2c53c1$export$1aeb4f6b93c4540d; });

var $9nHZC = parcelRequire("9nHZC");
var $dfefa5a1af2c53c1$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $9nHZC.createContext)("elevation.surface");
var $dfefa5a1af2c53c1$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $9nHZC.useContext)($dfefa5a1af2c53c1$export$1ca2a26fecb070ae);
};
$dfefa5a1af2c53c1$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("bvh2U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85ffcfef6594f948$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $aBFov = parcelRequire("aBFov");

var $cg9t8 = parcelRequire("cg9t8");
var $85ffcfef6594f948$var$flexGrowMap = {
    hug: (0, $aBFov.xcss)({
        flexGrow: 0
    }),
    fill: (0, $aBFov.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
var $85ffcfef6594f948$var$separatorStyles = (0, $avKww.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $85ffcfef6594f948$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $avKww.jsx)("span", {
        css: $85ffcfef6594f948$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $85ffcfef6594f948$var$Inline = /*#__PURE__*/ (0, $9nHZC.memo)(/*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $avKww.jsx)($85ffcfef6594f948$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $9nHZC.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $avKww.jsx)((0, $9nHZC.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $85ffcfef6594f948$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $avKww.jsx)((0, $cg9t8.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$85ffcfef6594f948$var$Inline.displayName = "Inline";
var $85ffcfef6594f948$export$2e2bcd8739ae039 = $85ffcfef6594f948$var$Inline;

});
parcelRegister("cg9t8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ece52fb5d15bbfe$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $4x0Le = parcelRequire("4x0Le");

var $aBFov = parcelRequire("aBFov");
var $8ece52fb5d15bbfe$var$justifyContentMap = {
    start: (0, $avKww.css)({
        justifyContent: "start"
    }),
    center: (0, $avKww.css)({
        justifyContent: "center"
    }),
    end: (0, $avKww.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $avKww.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $avKww.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $avKww.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $avKww.css)({
        justifyContent: "stretch"
    })
};
var $8ece52fb5d15bbfe$var$flexDirectionMap = {
    column: (0, $avKww.css)({
        flexDirection: "column"
    }),
    row: (0, $avKww.css)({
        flexDirection: "row"
    })
};
var $8ece52fb5d15bbfe$var$flexWrapMap = {
    wrap: (0, $avKww.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $avKww.css)({
        flexWrap: "nowrap"
    })
};
var $8ece52fb5d15bbfe$var$alignItemsMap = {
    start: (0, $avKww.css)({
        alignItems: "start"
    }),
    center: (0, $avKww.css)({
        alignItems: "center"
    }),
    baseline: (0, $avKww.css)({
        alignItems: "baseline"
    }),
    end: (0, $avKww.css)({
        alignItems: "end"
    }),
    stretch: (0, $avKww.css)({
        alignItems: "stretch"
    })
};
var $8ece52fb5d15bbfe$var$baseStyles = (0, $avKww.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $8ece52fb5d15bbfe$var$Flex = /*#__PURE__*/ (0, $9nHZC.memo)(/*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $aBFov.parseXcss)(xcss);
    return (0, $avKww.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $8ece52fb5d15bbfe$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $4x0Le.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $4x0Le.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $4x0Le.spaceStylesMap).rowGap[rowGap],
            alignItems && $8ece52fb5d15bbfe$var$alignItemsMap[alignItems],
            direction && $8ece52fb5d15bbfe$var$flexDirectionMap[direction],
            justifyContent && $8ece52fb5d15bbfe$var$justifyContentMap[justifyContent],
            wrap && $8ece52fb5d15bbfe$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$8ece52fb5d15bbfe$var$Flex.displayName = "Flex";
var $8ece52fb5d15bbfe$export$2e2bcd8739ae039 = $8ece52fb5d15bbfe$var$Flex;

});


parcelRegister("hfblc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8dca2709a3fea96$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $akRnX = parcelRequire("akRnX");
function $c8dca2709a3fea96$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $akRnX.default), {
        "aria-label": props["aria-label"],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});
parcelRegister("akRnX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78652ee3f5a27248$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9q1kH = parcelRequire("9q1kH");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $8p2GL = parcelRequire("8p2GL");

var $lNNvR = parcelRequire("lNNvR");

var $41uoz = parcelRequire("41uoz");

var $7j1gn = parcelRequire("7j1gn");

var $5mdQd = parcelRequire("5mdQd");
var $78652ee3f5a27248$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $78652ee3f5a27248$var$isFirefox = typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $78652ee3f5a27248$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $8p2GL.default) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $8p2GL.default) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $78652ee3f5a27248$var$_excluded);
    var _useGlobalTheme = (0, $lNNvR.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var isOnlySingleIcon = (0, $5mdQd.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $9nHZC.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    var onMouseDown = (0, $9nHZC.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($78652ee3f5a27248$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $9nHZC.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($78652ee3f5a27248$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $9nHZC.useMemo)(function() {
        return (0, $7j1gn.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $41uoz.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$78652ee3f5a27248$var$Button.displayName = "Button";
var $78652ee3f5a27248$export$2e2bcd8739ae039 = $78652ee3f5a27248$var$Button;

});
parcelRegister("lNNvR", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", function () { return $fdf494d3cefc521d$export$7692396083754928; });

var $2IyqN = parcelRequire("2IyqN");
// Create default global light theme
var $fdf494d3cefc521d$var$_createTheme = (0, $2IyqN.createTheme)(function() {
    return {
        mode: "light"
    };
}), $fdf494d3cefc521d$var$Provider = $fdf494d3cefc521d$var$_createTheme.Provider, $fdf494d3cefc521d$var$Consumer = $fdf494d3cefc521d$var$_createTheme.Consumer, $fdf494d3cefc521d$export$7692396083754928 = $fdf494d3cefc521d$var$_createTheme.useTheme;
var $fdf494d3cefc521d$var$Theme = {
    Provider: $fdf494d3cefc521d$var$Provider,
    Consumer: $fdf494d3cefc521d$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fdf494d3cefc521d$export$2e2bcd8739ae039 = $fdf494d3cefc521d$var$Theme;

});
parcelRegister("2IyqN", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $1faa66208d5a3632$export$25d302a5b900a763; });

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");
var $1faa66208d5a3632$var$_excluded = [
    "children"
];
function $1faa66208d5a3632$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $9nHZC.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $9nHZC.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(props, $1faa66208d5a3632$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $9nHZC.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $9nHZC.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("41uoz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2eded548c4153ac1$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $kaQ2A = parcelRequire("kaQ2A");

var $8p2GL = parcelRequire("8p2GL");

var $grYZC = parcelRequire("grYZC");

var $dxhCu = parcelRequire("dxhCu");

var $5fUc4 = parcelRequire("5fUc4");

var $lsfop = parcelRequire("lsfop");

var $aQa1F = parcelRequire("aQa1F");

var $7j1gn = parcelRequire("7j1gn");

var $h28Qk = parcelRequire("h28Qk");
var $2eded548c4153ac1$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $2eded548c4153ac1$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform.design-system-team.enable-new-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $2eded548c4153ac1$var$iconBeforeSpacingFixStyle = (0, $avKww.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $2eded548c4153ac1$var$iconAfterSpacingFixStyle = (0, $avKww.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $2eded548c4153ac1$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $h28Qk.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $2eded548c4153ac1$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $h28Qk.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $avKww.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $2eded548c4153ac1$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $8p2GL.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $8p2GL.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(props, $2eded548c4153ac1$var$_excluded);
    var ourRef = (0, $9nHZC.useRef)();
    var setRef = (0, $9nHZC.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $grYZC.default)(ourRef, autoFocus);
    var interactionContext = (0, $9nHZC.useContext)((0, $5fUc4.default));
    var handleClick = (0, $9nHZC.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $kaQ2A.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "20.1.0",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $9nHZC.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $9nHZC.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $avKww.css)((0, $7j1gn.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === "warning") spinnerHackCss = {
        "[data-theme] & circle": {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $lsfop.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $lsfop.N500), ")"), " !important")
        }
    };
    return (0, $avKww.jsx)((0, $dxhCu.default), null, (0, $avKww.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $2eded548c4153ac1$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $aQa1F.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $avKww.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $7j1gn.getIconStyle)({
                spacing: spacing
            }),
            $2eded548c4153ac1$var$getSpacingFix(children, $2eded548c4153ac1$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $2eded548c4153ac1$var$getChildren(children, [
        fadeStyles,
        (0, $7j1gn.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $avKww.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $7j1gn.getIconStyle)({
                spacing: spacing
            }),
            $2eded548c4153ac1$var$getSpacingFix(children, $2eded548c4153ac1$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $avKww.jsx)("span", {
        css: [
            (0, $7j1gn.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2eded548c4153ac1$export$2e2bcd8739ae039 = $2eded548c4153ac1$var$ButtonBase;

});
parcelRegister("lsfop", function(module, exports) {

$parcel$export(module.exports, "R300", function () { return $f9e827275de1050e$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $f9e827275de1050e$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $f9e827275de1050e$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y200", function () { return $f9e827275de1050e$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $f9e827275de1050e$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $f9e827275de1050e$export$59619663aa6500fb; });
$parcel$export(module.exports, "B50", function () { return $f9e827275de1050e$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $f9e827275de1050e$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $f9e827275de1050e$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $f9e827275de1050e$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $f9e827275de1050e$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $f9e827275de1050e$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $f9e827275de1050e$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "N0", function () { return $f9e827275de1050e$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $f9e827275de1050e$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N70", function () { return $f9e827275de1050e$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N90", function () { return $f9e827275de1050e$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N200", function () { return $f9e827275de1050e$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N400", function () { return $f9e827275de1050e$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $f9e827275de1050e$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $f9e827275de1050e$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $f9e827275de1050e$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $f9e827275de1050e$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $f9e827275de1050e$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN400", function () { return $f9e827275de1050e$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $f9e827275de1050e$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN100", function () { return $f9e827275de1050e$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN70", function () { return $f9e827275de1050e$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $f9e827275de1050e$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN30", function () { return $f9e827275de1050e$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN0", function () { return $f9e827275de1050e$export$3d4f271a500072a; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $f9e827275de1050e$export$4b84fd0e2c617bd = "#FFEBE6";
var $f9e827275de1050e$export$b34b069eff244586 = "#FFBDAD";
var $f9e827275de1050e$export$be802dd0d8b57f35 = "#FF8F73";
var $f9e827275de1050e$export$60847d42f9da92a6 = "#FF7452";
var $f9e827275de1050e$export$4a7404f376229999 = "#FF5630";
var $f9e827275de1050e$export$2010d0fb4295b346 = "#DE350B";
var $f9e827275de1050e$export$2837b5a1a71d5c02 = "#BF2600";
var $f9e827275de1050e$export$8d9596b529bbb9cf = "#FFFAE6";
var $f9e827275de1050e$export$41060a744ab0b7ae = "#FFF0B3";
var $f9e827275de1050e$export$1cc05bbbf340e559 = "#FFE380";
var $f9e827275de1050e$export$5aae31392d72caaa = "#FFC400";
var $f9e827275de1050e$export$c6930421db9fa514 = "#FFAB00";
var $f9e827275de1050e$export$59619663aa6500fb = "#FF991F";
var $f9e827275de1050e$export$874739ea9e379ab6 = "#FF8B00";
var $f9e827275de1050e$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $f9e827275de1050e$export$69a3bf21b9686c2b = "#ABF5D1";
var $f9e827275de1050e$export$afbce1382ec95f73 = "#79F2C0";
var $f9e827275de1050e$export$747d86715d4175de = "#57D9A3";
var $f9e827275de1050e$export$940e1f69e873f202 = "#36B37E";
var $f9e827275de1050e$export$a49394138f7b8e85 = "#00875A";
var $f9e827275de1050e$export$6fa04827ac68a4fb = "#006644";
var $f9e827275de1050e$export$226de0355ed012f8 = "#DEEBFF";
var $f9e827275de1050e$export$8c13c2ee36917869 = "#B3D4FF";
var $f9e827275de1050e$export$ecfc1dff386a3e7a = "#4C9AFF";
var $f9e827275de1050e$export$215b7063051591f1 = "#2684FF";
var $f9e827275de1050e$export$e62e8919cca44969 = "#0065FF";
var $f9e827275de1050e$export$b3de0ae08da2ce64 = "#0052CC";
var $f9e827275de1050e$export$a6ee3d71bc067634 = "#0747A6";
var $f9e827275de1050e$export$363e4475840015bb = "#EAE6FF";
var $f9e827275de1050e$export$4b0a4417ed59760f = "#C0B6F2";
var $f9e827275de1050e$export$6011520a64d9a187 = "#998DD9";
var $f9e827275de1050e$export$a7175d4e9206bc80 = "#8777D9";
var $f9e827275de1050e$export$b48405b95304b5a1 = "#6554C0";
var $f9e827275de1050e$export$c71e4279dd54a18d = "#5243AA";
var $f9e827275de1050e$export$147899de772240ec = "#403294";
var $f9e827275de1050e$export$2cf711fe14c66f06 = "#E6FCFF";
var $f9e827275de1050e$export$7a8f4d33f6f9772c = "#B3F5FF";
var $f9e827275de1050e$export$776c9c497ef08533 = "#79E2F2";
var $f9e827275de1050e$export$69cb3ca10c1e330e = "#00C7E6";
var $f9e827275de1050e$export$9dc1ef0f3f48059b = "#00B8D9";
var $f9e827275de1050e$export$7c835c78b6fcdef8 = "#00A3BF";
var $f9e827275de1050e$export$6036577f95c3877e = "#008DA6";
var $f9e827275de1050e$export$29a4f05edc054374 = "#FFFFFF";
var $f9e827275de1050e$export$e655ef011c4aa1a2 = "#FAFBFC";
var $f9e827275de1050e$export$9fdfb749e33cdf97 = "#F4F5F7";
var $f9e827275de1050e$export$3e51e8f1440314ba = "#EBECF0";
var $f9e827275de1050e$export$1ce2d1575d444ceb = "#DFE1E6";
var $f9e827275de1050e$export$8754fc7e6d8b3000 = "#C1C7D0";
var $f9e827275de1050e$export$c2e91cbeada39b8b = "#B3BAC5";
var $f9e827275de1050e$export$5f71e19f3a7ad9de = "#A5ADBA";
var $f9e827275de1050e$export$eaa8c8a70ac22806 = "#97A0AF";
var $f9e827275de1050e$export$7c87d337fb91a97d = "#8993A4";
var $f9e827275de1050e$export$d6447c357493214f = "#7A869A";
var $f9e827275de1050e$export$f563ee71e9ee74cd = "#6B778C";
var $f9e827275de1050e$export$e2ef2124cf4024b1 = "#5E6C84";
var $f9e827275de1050e$export$eece5f492e429f08 = "#505F79";
var $f9e827275de1050e$export$c39c0fe0f26207ae = "#42526E";
var $f9e827275de1050e$export$7090862dc3038a9f = "#344563";
var $f9e827275de1050e$export$ad0bacf983b7ddaa = "#253858";
var $f9e827275de1050e$export$7d61b15e0da132af = "#172B4D";
var $f9e827275de1050e$export$fbda843f0a27fe96 = "#091E42";
var $f9e827275de1050e$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $f9e827275de1050e$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $f9e827275de1050e$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $f9e827275de1050e$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $f9e827275de1050e$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $f9e827275de1050e$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $f9e827275de1050e$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $f9e827275de1050e$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $f9e827275de1050e$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $f9e827275de1050e$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $f9e827275de1050e$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $f9e827275de1050e$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $f9e827275de1050e$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $f9e827275de1050e$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $f9e827275de1050e$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $f9e827275de1050e$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $f9e827275de1050e$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $f9e827275de1050e$export$2f6319cf7d736c2a = "#E6EDFA";
var $f9e827275de1050e$export$95126bc8884d6634 = "#DCE5F5";
var $f9e827275de1050e$export$8338d8c35d44ff1 = "#CED9EB";
var $f9e827275de1050e$export$5368d76ae4fbbda7 = "#B8C7E0";
var $f9e827275de1050e$export$9f0a771d16ec8d36 = "#ABBBD6";
var $f9e827275de1050e$export$abcf8c38338b4aa5 = "#9FB0CC";
var $f9e827275de1050e$export$97e81faa16a182c7 = "#8C9CB8";
var $f9e827275de1050e$export$bfe21c59123ecf33 = "#7988A3";
var $f9e827275de1050e$export$ee82aa2ea6a1558 = "#67758F";
var $f9e827275de1050e$export$682927c6ed76be02 = "#56637A";
var $f9e827275de1050e$export$91fd9994c5be9757 = "#455166";
var $f9e827275de1050e$export$d281fbfe3cff2df6 = "#3B475C";
var $f9e827275de1050e$export$3902c91d8b98a753 = "#313D52";
var $f9e827275de1050e$export$8e8133c1ba5845b5 = "#283447";
var $f9e827275de1050e$export$33ff357f6620b39 = "#202B3D";
var $f9e827275de1050e$export$633847cf062b69e0 = "#1B2638";
var $f9e827275de1050e$export$9776a6e503bdbf76 = "#121A29";
var $f9e827275de1050e$export$6c813d5160dff5db = "#0E1624";
var $f9e827275de1050e$export$3d4f271a500072a = "#0D1424";
var $f9e827275de1050e$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $f9e827275de1050e$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $f9e827275de1050e$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $f9e827275de1050e$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $f9e827275de1050e$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $f9e827275de1050e$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $f9e827275de1050e$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $f9e827275de1050e$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $f9e827275de1050e$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $f9e827275de1050e$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $f9e827275de1050e$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $f9e827275de1050e$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $f9e827275de1050e$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $f9e827275de1050e$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $f9e827275de1050e$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $f9e827275de1050e$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $f9e827275de1050e$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";

});

parcelRegister("aQa1F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e4689a0f3c9c658$export$2e2bcd8739ae039; });
function $7e4689a0f3c9c658$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $7e4689a0f3c9c658$var$tabKeyCode = 9;
function $7e4689a0f3c9c658$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $7e4689a0f3c9c658$var$tabKeyCode) return;
    $7e4689a0f3c9c658$var$abort(event);
}
var $7e4689a0f3c9c658$var$block = {
    onMouseDownCapture: $7e4689a0f3c9c658$var$abort,
    onMouseUpCapture: $7e4689a0f3c9c658$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $7e4689a0f3c9c658$var$onKey,
    onKeyUpCapture: $7e4689a0f3c9c658$var$onKey,
    onTouchStartCapture: $7e4689a0f3c9c658$var$abort,
    onTouchEndCapture: $7e4689a0f3c9c658$var$abort,
    onPointerDownCapture: $7e4689a0f3c9c658$var$abort,
    onPointerUpCapture: $7e4689a0f3c9c658$var$abort,
    onClickCapture: $7e4689a0f3c9c658$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $7e4689a0f3c9c658$var$abort
};
var $7e4689a0f3c9c658$var$doNotBlock = {};
function $7e4689a0f3c9c658$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $7e4689a0f3c9c658$var$doNotBlock : $7e4689a0f3c9c658$var$block;
}

});

parcelRegister("7j1gn", function(module, exports) {

$parcel$export(module.exports, "getCss", function () { return $551b499402c94b61$export$955358618f994a11; });
$parcel$export(module.exports, "getIconStyle", function () { return $551b499402c94b61$export$864eea3f4ec3368f; });
$parcel$export(module.exports, "getContentStyle", function () { return $551b499402c94b61$export$7ad0316cc0dd65a; });
$parcel$export(module.exports, "getFadingCss", function () { return $551b499402c94b61$export$1b5827d324e945b1; });
$parcel$export(module.exports, "overlayCss", function () { return $551b499402c94b61$export$1a9fe1b84c876bb5; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $kuoDo = parcelRequire("kuoDo");

var $9a4cG = parcelRequire("9a4cG");

var $3FM7V = parcelRequire("3FM7V");
function $551b499402c94b61$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $551b499402c94b61$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $551b499402c94b61$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $551b499402c94b61$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $551b499402c94b61$var$gridSize = (0, $9a4cG.gridSize)();
var $551b499402c94b61$var$HAS_DISABLED_BACKGROUND = [
    "default",
    "primary",
    "danger",
    "warning"
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $551b499402c94b61$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: "auto"
};
var $551b499402c94b61$var$lineHeights = {
    default: $551b499402c94b61$var$heights.default,
    compact: $551b499402c94b61$var$heights.compact,
    none: "inherit"
};
var $551b499402c94b61$var$padding = {
    // 10px gutter
    default: "0 ".concat($551b499402c94b61$var$gridSize + $551b499402c94b61$var$gridSize / 4, "px"),
    compact: "0 ".concat($551b499402c94b61$var$gridSize + $551b499402c94b61$var$gridSize / 4, "px"),
    none: "0"
};
var $551b499402c94b61$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($551b499402c94b61$var$gridSize / 4, "px"),
    default: "0 ".concat($551b499402c94b61$var$gridSize / 4, "px"),
    none: "0"
};
var $551b499402c94b61$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $551b499402c94b61$var$innerMargin = {
    content: "0 ".concat($551b499402c94b61$var$gridSize / 4, "px"),
    icon: "0 ".concat($551b499402c94b61$var$gridSize / 4, "px")
};
var $551b499402c94b61$var$defaultAfterStyles = {
    borderRadius: "inherit",
    inset: "var(--ds-space-0, 0px)",
    borderStyle: "solid",
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: "none",
    position: "absolute"
};
var $551b499402c94b61$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #172B4D)",
    "&:not([disabled])::after": $551b499402c94b61$var$_objectSpread($551b499402c94b61$var$_objectSpread({}, $551b499402c94b61$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #091E4224)"
    }),
    "&:hover": {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $551b499402c94b61$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #0C66E4)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
    },
    "&:active": {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #0C66E4)"
    }
};
var $551b499402c94b61$var$linkStyles = {
    background: "transparent",
    color: "var(--ds-link, #0C66E4)",
    "&:hover": {
        color: "var(--ds-link, #0C66E4)",
        textDecoration: "underline"
    },
    "&:active": {
        color: "var(--ds-link-pressed, #0055CC)",
        textDecoration: "underline"
    }
};
var $551b499402c94b61$var$subtleStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "transparent"
    }
};
var $551b499402c94b61$var$subtleLinkStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "transparent",
        color: "var(--ds-text-subtle, #44546F)",
        textDecoration: "underline"
    },
    "&:active": {
        background: "transparent",
        color: "var(--ds-text, #172B4D)",
        textDecoration: "underline"
    }
};
var $551b499402c94b61$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #F5CD47)",
    color: "var(--ds-text-warning-inverse, #172B4D)",
    "&:hover": {
        background: "var(--ds-background-warning-bold-hovered, #E2B203)"
    },
    "&:active": {
        background: "var(--ds-background-warning-bold-pressed, #CF9F02)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #F5CD47)"
    }
};
var $551b499402c94b61$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    "&:active": {
        background: "var(--ds-background-danger-bold-pressed, #5D1F1A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $551b499402c94b61$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "var(--ds-text-selected, #0C66E4)",
    "&:not([disabled])::after": $551b499402c94b61$var$_objectSpread($551b499402c94b61$var$_objectSpread({}, $551b499402c94b61$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #0C66E4)"
    })
};
var $551b499402c94b61$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: "default",
        textDecoration: "none"
    }
};
function $551b499402c94b61$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $551b499402c94b61$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $551b499402c94b61$var$getColor({
            group: (0, $3FM7V.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($551b499402c94b61$var$getColor({
            group: (0, $3FM7V.default).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $551b499402c94b61$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $551b499402c94b61$var$getColors({
        appearance: appearance,
        key: isSelected ? "selected" : "default",
        mode: mode
    });
    return $551b499402c94b61$var$_objectSpread($551b499402c94b61$var$_objectSpread($551b499402c94b61$var$_objectSpread($551b499402c94b61$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: 500,
        // margin for button has been applied to css reset
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap"
    }, !(0, $kuoDo.fg)("platform-component-visual-refresh") && baseColors), {}, {
        cursor: "pointer",
        height: $551b499402c94b61$var$heights[spacing],
        lineHeight: $551b499402c94b61$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $551b499402c94b61$var$singleIconPadding[spacing] : $551b499402c94b61$var$padding[spacing],
        verticalAlign: $551b499402c94b61$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center"
    }, !(0, $kuoDo.fg)("platform-component-visual-refresh") && $551b499402c94b61$var$_objectSpread($551b499402c94b61$var$_objectSpread({
        // Disabling visited styles (just using the base colors)
        "&:visited": $551b499402c94b61$var$_objectSpread({}, baseColors),
        "&:hover": $551b499402c94b61$var$_objectSpread($551b499402c94b61$var$_objectSpread({}, $551b499402c94b61$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "hover",
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "inherit",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        // giving active styles preference by listing them after focus
        "&:active": $551b499402c94b61$var$_objectSpread($551b499402c94b61$var$_objectSpread({}, $551b499402c94b61$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $551b499402c94b61$var$_objectSpread($551b499402c94b61$var$_objectSpread({}, $551b499402c94b61$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        "&[disabled]": $551b499402c94b61$var$_objectSpread($551b499402c94b61$var$_objectSpread({}, $551b499402c94b61$var$getColors({
            appearance: appearance,
            key: "disabled",
            mode: mode
        })), {}, {
            cursor: "not-allowed",
            textDecoration: "none"
        })
    }, $551b499402c94b61$var$hasOverlayStyles), {}, {
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $551b499402c94b61$var$_objectSpread({}, $551b499402c94b61$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "default",
            mode: mode
        }))
    })), (0, $kuoDo.fg)("platform-component-visual-refresh") && (isSelected ? $551b499402c94b61$var$selectedStyles : $551b499402c94b61$var$_objectSpread($551b499402c94b61$var$_objectSpread($551b499402c94b61$var$_objectSpread($551b499402c94b61$var$_objectSpread($551b499402c94b61$var$_objectSpread($551b499402c94b61$var$_objectSpread($551b499402c94b61$var$_objectSpread($551b499402c94b61$var$_objectSpread({}, appearance === "default" && $551b499402c94b61$var$defaultStyles), appearance === "primary" && $551b499402c94b61$var$primaryStyles), appearance === "link" && $551b499402c94b61$var$linkStyles), appearance === "subtle" && $551b499402c94b61$var$subtleStyles), appearance === "subtle-link" && $551b499402c94b61$var$subtleLinkStyles), appearance === "warning" && $551b499402c94b61$var$warningStyles), appearance === "danger" && $551b499402c94b61$var$dangerStyles), {}, {
        "&[disabled]": {
            color: "var(--ds-text-disabled, #091E424F)",
            backgroundColor: $551b499402c94b61$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent",
            cursor: "not-allowed",
            textDecoration: "none",
            "&:hovered": {
                backgroundColor: $551b499402c94b61$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            },
            "&:active": {
                backgroundColor: $551b499402c94b61$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            }
        }
    }, $551b499402c94b61$var$hasOverlayStyles))), {}, {
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $551b499402c94b61$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $avKww.css)({
        display: "flex",
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $551b499402c94b61$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: "center",
        fontSize: 0,
        lineHeight: 0,
        userSelect: "none"
    });
}
function $551b499402c94b61$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $avKww.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $551b499402c94b61$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    });
}
function $551b499402c94b61$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $avKww.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: "opacity 0.3s"
    });
}
var $551b499402c94b61$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

});
parcelRegister("kuoDo", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $eea9b7dbf1a6a9d3$export$b40ec24ac8275656; });

var $gUSeD = parcelRequire("gUSeD");
function $eea9b7dbf1a6a9d3$export$ba05d765b8392e5e(flagResolver) {
    (0, $gUSeD.setBooleanResolver)(flagResolver);
}
function $eea9b7dbf1a6a9d3$export$470e5c2be1411c89(name) {
    return (0, $gUSeD.resolveBooleanFlag)(name);
}
function $eea9b7dbf1a6a9d3$export$b40ec24ac8275656(name) {
    return (0, $gUSeD.resolveBooleanFlag)(name);
}

});
parcelRegister("gUSeD", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $c50bf241f7fef2aa$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $c50bf241f7fef2aa$export$6333b6aff9fc6275; });

var $1OVBk = parcelRequire("1OVBk");

var $8ovux = parcelRequire("8ovux");
var $c50bf241f7fef2aa$var$pkgName = "@atlaskit/platform-feature-flags";
var $c50bf241f7fef2aa$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $c50bf241f7fef2aa$var$hasProcessEnv = typeof $8ovux !== "undefined" && typeof $8ovux.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $c50bf241f7fef2aa$var$ENV_ENABLE_PLATFORM_FF = $c50bf241f7fef2aa$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $c50bf241f7fef2aa$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $c50bf241f7fef2aa$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $c50bf241f7fef2aa$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $c50bf241f7fef2aa$var$ENV_ENABLE_PLATFORM_FF || $c50bf241f7fef2aa$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $c50bf241f7fef2aa$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $c50bf241f7fef2aa$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$c50bf241f7fef2aa$var$globalVar[$c50bf241f7fef2aa$export$7e41b1b2bdee3f98] = $c50bf241f7fef2aa$var$globalVar[$c50bf241f7fef2aa$export$7e41b1b2bdee3f98] || $c50bf241f7fef2aa$var$DEFAULT_PFF_GLOBAL;
function $c50bf241f7fef2aa$export$f2b591175b3e424c(resolver) {
    $c50bf241f7fef2aa$var$globalVar[$c50bf241f7fef2aa$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $c50bf241f7fef2aa$export$6333b6aff9fc6275(flagKey) {
    if ($c50bf241f7fef2aa$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $1OVBk.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $c50bf241f7fef2aa$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $c50bf241f7fef2aa$var$globalVar[$c50bf241f7fef2aa$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("1OVBk", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $1537244fc02f4697$export$1c9f709888824e05; });
var $1537244fc02f4697$var$_ref, $1537244fc02f4697$var$_process, $1537244fc02f4697$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $1537244fc02f4697$var$TESTS_MODE = ($1537244fc02f4697$var$_ref = (globalThis === null || globalThis === void 0 || ($1537244fc02f4697$var$_process = globalThis.process) === null || $1537244fc02f4697$var$_process === void 0 || ($1537244fc02f4697$var$_process = $1537244fc02f4697$var$_process.env) === null || $1537244fc02f4697$var$_process === void 0 ? void 0 : $1537244fc02f4697$var$_process.JEST_WORKER_ID) !== undefined, $1537244fc02f4697$var$_ref !== void 0) ? $1537244fc02f4697$var$_ref : false;
var $1537244fc02f4697$var$DEBUG_MODE = !$1537244fc02f4697$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($1537244fc02f4697$var$_process2 = globalThis.process) === null || $1537244fc02f4697$var$_process2 === void 0 || ($1537244fc02f4697$var$_process2 = $1537244fc02f4697$var$_process2.env) === null || $1537244fc02f4697$var$_process2 === void 0 ? void 0 : $1537244fc02f4697$var$_process2.NODE_ENV) !== "production";
var $1537244fc02f4697$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$1537244fc02f4697$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("9a4cG", function(module, exports) {

$parcel$export(module.exports, "gridSize", function () { return $6ab84efe6f4c85bf$export$6d8204c2cb2e06b8; });

var $1OnrY = parcelRequire("1OnrY");

var $lsfop = parcelRequire("lsfop");
var $6ab84efe6f4c85bf$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $6ab84efe6f4c85bf$export$c93026a968943f95 = "light";
var $6ab84efe6f4c85bf$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $6ab84efe6f4c85bf$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $6ab84efe6f4c85bf$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $6ab84efe6f4c85bf$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $6ab84efe6f4c85bf$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $6ab84efe6f4c85bf$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $6ab84efe6f4c85bf$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $6ab84efe6f4c85bf$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $lsfop.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $6ab84efe6f4c85bf$export$6d8204c2cb2e06b8() / 4;
    (0, $1OnrY.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $6ab84efe6f4c85bf$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $6ab84efe6f4c85bf$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $6ab84efe6f4c85bf$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $1OnrY.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $6ab84efe6f4c85bf$export$ba1d834b86d72a09 = $6ab84efe6f4c85bf$export$a1b3edb637fb4f35;
var $6ab84efe6f4c85bf$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $lsfop.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $lsfop.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $lsfop.N30A), ")")
            }
        }
    };
};

});

parcelRegister("3FM7V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2aca886f16e4159e$export$2e2bcd8739ae039; });

var $lsfop = parcelRequire("lsfop");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $2aca886f16e4159e$var$fadedB75 = "rgba(179, 212, 255, 0.6)";
var $2aca886f16e4159e$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($lsfop.N20A, ")"),
                dark: "var(--ds-background-neutral, ".concat($lsfop.DN70, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($lsfop.N30A, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($lsfop.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($2aca886f16e4159e$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($lsfop.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($lsfop.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($lsfop.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($lsfop.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($lsfop.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($lsfop.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($lsfop.DN0, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($lsfop.B400, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($lsfop.B100, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($lsfop.B300, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($lsfop.B75, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($lsfop.B500, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($lsfop.B200, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($lsfop.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($lsfop.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($lsfop.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($lsfop.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($lsfop.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($lsfop.DN0, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($lsfop.Y300, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($lsfop.Y300, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($lsfop.Y200, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($lsfop.Y200, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($lsfop.Y400, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($lsfop.Y400, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($lsfop.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($lsfop.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($lsfop.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($lsfop.Y400, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($lsfop.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($lsfop.Y400, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($lsfop.R400, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($lsfop.R400, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($lsfop.R300, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($lsfop.R300, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($lsfop.R500, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($lsfop.R500, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($lsfop.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($lsfop.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($lsfop.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($lsfop.R500, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($lsfop.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($lsfop.R500, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($lsfop.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($lsfop.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($lsfop.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($lsfop.N20, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($lsfop.N30A, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($lsfop.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($2aca886f16e4159e$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($lsfop.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($lsfop.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($lsfop.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($lsfop.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($lsfop.DN0, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($lsfop.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($lsfop.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($lsfop.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($lsfop.N20, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($lsfop.N500, ")"),
                dark: "var(--ds-text, ".concat($lsfop.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($lsfop.B400, ")"),
                dark: "var(--ds-text, ".concat($lsfop.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($lsfop.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($lsfop.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($lsfop.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($lsfop.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($lsfop.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($lsfop.DN400, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($lsfop.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($lsfop.DN30, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($lsfop.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($lsfop.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($lsfop.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($lsfop.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($lsfop.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($lsfop.DN400, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($lsfop.N800, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($lsfop.N800, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($lsfop.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($lsfop.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($lsfop.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($lsfop.N800, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($lsfop.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($lsfop.N800, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($lsfop.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($lsfop.N0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($lsfop.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($lsfop.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($lsfop.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($lsfop.N0, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($lsfop.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($lsfop.N0, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($lsfop.B400, ")"),
                dark: "var(--ds-link, ".concat($lsfop.B100, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($lsfop.B300, ")"),
                dark: "var(--ds-link, ".concat($lsfop.B75, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($lsfop.B500, ")"),
                dark: "var(--ds-link-pressed, ".concat($lsfop.B200, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($lsfop.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($lsfop.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($lsfop.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($lsfop.N700, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($lsfop.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($lsfop.N700, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($lsfop.N500, ")"),
                dark: "var(--ds-text, ".concat($lsfop.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($lsfop.B400, ")"),
                dark: "var(--ds-text, ".concat($lsfop.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($lsfop.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($lsfop.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($lsfop.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($lsfop.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($lsfop.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($lsfop.DN400, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-text-subtle, ".concat($lsfop.N200, ")"),
                dark: "var(--ds-text-subtle, ".concat($lsfop.DN400, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($lsfop.N90, ")"),
                dark: "var(--ds-text-subtle, ".concat($lsfop.B50, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($lsfop.N400, ")"),
                dark: "var(--ds-text, ".concat($lsfop.DN300, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($lsfop.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($lsfop.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($lsfop.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($lsfop.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($lsfop.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($lsfop.DN400, ")")
            }
        }
    }
};
var $2aca886f16e4159e$export$2e2bcd8739ae039 = $2aca886f16e4159e$var$values;

});


parcelRegister("h28Qk", function(module, exports) {

$parcel$export(module.exports, "getIfVisuallyHiddenChildren", function () { return $c6697b95a4694be1$export$20bbd2efb0d734c4; });

var $9nHZC = parcelRequire("9nHZC");

var $7S7GL = parcelRequire("7S7GL");
var $c6697b95a4694be1$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $9nHZC.isValidElement)(children) && children.type === (0, $7S7GL.default);
};

});


parcelRegister("5mdQd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e69be646eac5cb3$export$2e2bcd8739ae039; });

var $h28Qk = parcelRequire("h28Qk");
function $3e69be646eac5cb3$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $h28Qk.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});



parcelRegister("253bx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $183e84e26743fa24$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $akRnX = parcelRequire("akRnX");
function $183e84e26743fa24$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $akRnX.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        appearance: "subtle"
    }));
}

});

parcelRegister("kc8UR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb3bd831b6adc511$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $7iakf = parcelRequire("7iakf");
var $ubket = parcelRequire("ubket");
var $aBFov = parcelRequire("aBFov");

var $7S7GL = parcelRequire("7S7GL");
var $eb3bd831b6adc511$var$containerStyles = (0, $aBFov.xcss)({
    display: "flex",
    position: "relative"
});
function $eb3bd831b6adc511$export$2e2bcd8739ae039(_ref) {
    var key = _ref.key, testId = _ref.testId, from = _ref.from, to = _ref.to;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7iakf.default), {
        as: "li",
        testId: testId,
        key: key,
        xcss: $eb3bd831b6adc511$var$containerStyles,
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ubket.default), {
        testId: testId && "".concat(testId, "-text")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7S7GL.default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
}

});
parcelRegister("ubket", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05ab966e7b6ebe9b$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $4GQn2 = parcelRequire("4GQn2");

var $4x0Le = parcelRequire("4x0Le");

var $je0pP = parcelRequire("je0pP");
var $05ab966e7b6ebe9b$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $05ab966e7b6ebe9b$var$resetStyles = (0, $avKww.css)({
    margin: 0,
    overflowWrap: "anywhere"
});
var $05ab966e7b6ebe9b$var$strongStyles = (0, $avKww.css)({
    fontWeight: "bold"
});
var $05ab966e7b6ebe9b$var$emStyles = (0, $avKww.css)({
    fontStyle: "italic"
});
var $05ab966e7b6ebe9b$var$textAlignMap = {
    center: (0, $avKww.css)({
        textAlign: "center"
    }),
    end: (0, $avKww.css)({
        textAlign: "end"
    }),
    start: (0, $avKww.css)({
        textAlign: "start"
    })
};
var $05ab966e7b6ebe9b$var$truncationStyles = (0, $avKww.css)({
    display: "-webkit-box",
    overflow: "hidden",
    WebkitBoxOrient: "vertical"
});
var $05ab966e7b6ebe9b$var$wordBreakMap = {
    breakAll: (0, $avKww.css)({
        wordBreak: "break-all"
    })
};
var $05ab966e7b6ebe9b$var$HasTextAncestorContext = /*#__PURE__*/ (0, $9nHZC.createContext)(false);
var $05ab966e7b6ebe9b$var$useHasTextAncestor = function useHasTextAncestor() {
    return (0, $9nHZC.useContext)($05ab966e7b6ebe9b$var$HasTextAncestorContext);
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $05ab966e7b6ebe9b$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $je0pP.useSurface)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $4x0Le.inverseColorMap).hasOwnProperty(surface)) return (0, $4x0Le.inverseColorMap)[surface];
    if (colorProp === "inherit") return undefined;
    if (!colorProp && hasTextAncestor) return undefined;
    return colorProp || "color.text";
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $05ab966e7b6ebe9b$var$Text = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "span" : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, _ref$size = _ref.size, size = _ref$size === void 0 ? "medium" : _ref$size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $4GQn2.default)($05ab966e7b6ebe9b$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = $05ab966e7b6ebe9b$var$useHasTextAncestor();
    var color = $05ab966e7b6ebe9b$var$useColor(colorProp, hasTextAncestor);
    var component = (0, $avKww.jsx)(Component, {
        ref: ref,
        css: [
            $05ab966e7b6ebe9b$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $4x0Le.fontStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $4x0Le.textColorStylesMap)[color],
            maxLines && $05ab966e7b6ebe9b$var$truncationStyles,
            maxLines === 1 && $05ab966e7b6ebe9b$var$wordBreakMap.breakAll,
            align && $05ab966e7b6ebe9b$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $4x0Le.fontWeightStylesMap)[weight],
            Component === "em" && $05ab966e7b6ebe9b$var$emStyles,
            Component === "strong" && $05ab966e7b6ebe9b$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $avKww.jsx)($05ab966e7b6ebe9b$var$HasTextAncestorContext.Provider, {
        value: true
    }, component);
});
var $05ab966e7b6ebe9b$export$2e2bcd8739ae039 = $05ab966e7b6ebe9b$var$Text;

});


parcelRegister("c0Ylm", function(module, exports) {

$parcel$export(module.exports, "emptyObject", function () { return $8bf44b18b2fd21af$export$3f860eba1218f8d3; });
var $8bf44b18b2fd21af$export$3f860eba1218f8d3 = {};

});

parcelRegister("ksWXC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee6428873dd2c850$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $cfHu5 = parcelRequire("cfHu5");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
var $ee6428873dd2c850$var$collapseRange = function collapseRange(pages, current, _ref, testId) {
    var max = _ref.max, ellipsis = _ref.ellipsis, transform = _ref.transform;
    var total = pages.length;
    // only need ellipsis if we have more pages than we can display
    var needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    var hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    var hasEndEllipsis = needEllipsis && current < total - max + 3;
    var getPageComponents = (0, $cfHu5.default)(function() {
        var startIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var lastIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : total;
        return pages.slice(startIndex, lastIndex).map(function(page, index) {
            return transform(page, startIndex + index, testId);
        });
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        var _pageCount = max - 2;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(getPageComponents(0, 1)), [
            ellipsis({
                key: "ellipsis-1",
                testId: testId && "".concat(testId, "-ellipsis"),
                from: 2,
                to: total - _pageCount
            })
        ], (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(getPageComponents(total - _pageCount)));
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        var _pageCount2 = max - 2;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(getPageComponents(0, _pageCount2)), [
            ellipsis({
                key: "ellipsis-1",
                testId: testId && "".concat(testId, "-ellipsis"),
                from: _pageCount2 + 1,
                to: total - 1
            })
        ], (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(getPageComponents(total - 1)));
    }
    // we have both start and end ellipsis
    var pageCount = max - 4;
    return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(getPageComponents(0, 1)), [
        ellipsis({
            key: "ellipsis-1",
            testId: testId && "".concat(testId, "-ellipsis"),
            from: 2,
            to: current - Math.floor(pageCount / 2)
        })
    ], (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1)), [
        ellipsis({
            key: "ellipsis-2",
            testId: testId && "".concat(testId, "-ellipsis"),
            from: current + 3,
            to: total - 1
        })
    ], (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(getPageComponents(total - 1)));
};
var $ee6428873dd2c850$export$2e2bcd8739ae039 = $ee6428873dd2c850$var$collapseRange;

});
parcelRegister("cfHu5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8eb89dd44b416e30$export$2e2bcd8739ae039; });
var $8eb89dd44b416e30$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $8eb89dd44b416e30$var$isEqual(first, second) {
    if (first === second) return true;
    if ($8eb89dd44b416e30$var$safeIsNaN(first) && $8eb89dd44b416e30$var$safeIsNaN(second)) return true;
    return false;
}
function $8eb89dd44b416e30$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$8eb89dd44b416e30$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $8eb89dd44b416e30$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $8eb89dd44b416e30$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});




parcelRegister("84iBi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5dfd20272d7a530e$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $9nHZC = parcelRequire("9nHZC");

var $ju3lq = parcelRequire("ju3lq");

var $aaF9X = parcelRequire("aaF9X");

var $2iGt4 = parcelRequire("2iGt4");

var $7AcW8 = parcelRequire("7AcW8");
var $5dfd20272d7a530e$var$_excluded = [
    "cells"
], $5dfd20272d7a530e$var$_excluded2 = [
    "colSpan",
    "content",
    "isSortable",
    "key",
    "shouldTruncate",
    "testId",
    "width"
];
function $5dfd20272d7a530e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5dfd20272d7a530e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $5dfd20272d7a530e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5dfd20272d7a530e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $5dfd20272d7a530e$var$TableHead = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(TableHead, _React$Component);
    var _super = $5dfd20272d7a530e$var$_createSuper(TableHead);
    function TableHead() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, TableHead);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(TableHead, [
        {
            key: "UNSAFE_componentWillMount",
            value: function UNSAFE_componentWillMount() {
                (0, $ju3lq.validateSortKey)(this.props.sortKey, this.props.head);
            }
        },
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $ju3lq.validateSortKey)(nextProps.sortKey, nextProps.head);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, head = _this$props.head, sortKey = _this$props.sortKey, sortOrder = _this$props.sortOrder, isFixedSize = _this$props.isFixedSize, onSort = _this$props.onSort, isRanking = _this$props.isRanking, isRankable = _this$props.isRankable, testId = _this$props.testId;
                if (!head) return null;
                var HeadCellComponent = isRankable ? (0, $2iGt4.default) : (0, $7AcW8.default);
                // TODO: Remove `rest` props and use only what is explicitly in the API.
                // Some tests use this to pass in onClick and other stuff within the `head`
                // variable here, but considering it's not in the API, it should probably
                // be removed.
                var cells = head.cells, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(head, $5dfd20272d7a530e$var$_excluded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aaF9X.Head), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
                    isRanking: isRanking,
                    testId: testId && "".concat(testId, "--head")
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("tr", null, cells.map(function(cell, index) {
                    var colSpan = cell.colSpan, content = cell.content, isSortable = cell.isSortable, key = cell.key, shouldTruncate = cell.shouldTruncate, cellTestId = cell.testId, width = cell.width, restCellProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(cell, $5dfd20272d7a530e$var$_excluded2);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(HeadCellComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        key: key || index,
                        onClick: isSortable ? onSort(cell) : undefined,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width
                    }, restCellProps));
                })));
            }
        }
    ]);
    return TableHead;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $5dfd20272d7a530e$export$2e2bcd8739ae039 = $5dfd20272d7a530e$var$TableHead;

});
parcelRegister("aaF9X", function(module, exports) {

$parcel$export(module.exports, "Head", function () { return $767ac3fb64404055$export$e93312b7773dfcac; });
$parcel$export(module.exports, "HeadCell", function () { return $767ac3fb64404055$export$4e8024263ace498b; });

var $kFnE9 = parcelRequire("kFnE9");

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $kRIB6 = parcelRequire("kRIB6");

var $f0z3w = parcelRequire("f0z3w");

var $aPzaW = parcelRequire("aPzaW");

var $TDWFG = parcelRequire("TDWFG");
var $767ac3fb64404055$var$_excluded = [
    "isRanking",
    "testId"
], $767ac3fb64404055$var$_excluded2 = [
    "width",
    "children",
    "isSortable",
    "sortOrder",
    "isFixedSize",
    "shouldTruncate",
    "onClick",
    "style",
    "testId"
];
function $767ac3fb64404055$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $767ac3fb64404055$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $767ac3fb64404055$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $767ac3fb64404055$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $767ac3fb64404055$var$CSS_VAR_TEXT_COLOR = "--local-dynamic-table-text-color";
var $767ac3fb64404055$var$rankingStyles = (0, $avKww.css)({
    display: "block"
});
var $767ac3fb64404055$var$headStyles = (0, $avKww.css)({
    borderBlockEnd: "none"
});
var $767ac3fb64404055$export$e93312b7773dfcac = function Head(_ref) {
    var isRanking = _ref.isRanking, testId = _ref.testId, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $767ac3fb64404055$var$_excluded);
    return (0, $avKww.jsx)("thead", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        css: [
            $767ac3fb64404055$var$headStyles,
            isRanking && $767ac3fb64404055$var$rankingStyles
        ],
        "data-testid": testId
    }, props));
};
var $767ac3fb64404055$var$headCellBaseStyles = (0, $avKww.css)({
    boxSizing: "border-box",
    position: "relative",
    border: "none",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: "2px solid ".concat((0, $aPzaW.tableBorder).borderColor),
    color: "var(--ds-text-subtlest, ".concat("var(".concat($767ac3fb64404055$var$CSS_VAR_TEXT_COLOR, ")"), ")"),
    font: 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    textAlign: "left",
    verticalAlign: "top",
    "&:focus-visible": {
        outline: "solid 2px ".concat("var(--ds-border-focused, ".concat((0, $kRIB6.B100), ")"))
    }
});
var $767ac3fb64404055$var$onClickStyles = (0, $avKww.css)({
    "&:hover": {
        backgroundColor: "var(--ds-background-neutral-hovered, ".concat((0, $kRIB6.N30A), ")"),
        cursor: "pointer"
    }
});
var $767ac3fb64404055$var$baseStyles = (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "& > button": {
        padding: "var(--ds-space-0, 0)",
        position: "relative",
        appearance: "none",
        background: "none",
        border: "none",
        color: "inherit",
        cursor: "inherit",
        fontSize: "inherit",
        fontWeight: "inherit",
        "&::before, &::after": {
            display: "block",
            width: 0,
            height: 0,
            position: "absolute",
            border: "3px solid transparent",
            content: '""',
            insetInlineEnd: "var(--ds-space-negative-100, -8px)"
        },
        "&::before": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: "3px solid ".concat((0, $aPzaW.arrow).defaultColor),
            insetBlockEnd: "var(--ds-space-100, 8px)"
        },
        "&::after": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: "3px solid ".concat((0, $aPzaW.arrow).defaultColor),
            insetBlockEnd: 0
        }
    },
    "@media (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "& > button": {
            "&::before, &::after": {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                border: "3px solid ".concat((0, $aPzaW.MSThemeColors).Background)
            },
            "&::before": {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: "3px solid ".concat((0, $aPzaW.MSThemeColors).Text)
            },
            "&::after": {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: "3px solid ".concat((0, $aPzaW.MSThemeColors).Text)
            }
        }
    }
});
var $767ac3fb64404055$var$ascendingStyles = (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "& > button": {
        "&::before": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: "3px solid ".concat((0, $aPzaW.arrow).selectedColor)
        }
    },
    "@media (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "& > button": {
            "&::before": {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: "3px solid ".concat((0, $aPzaW.MSThemeColors).SelectedBackground)
            }
        }
    }
});
var $767ac3fb64404055$var$descendingStyles = (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "& > button": {
        "&::after": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: "3px solid ".concat((0, $aPzaW.arrow).selectedColor)
        }
    },
    "@media (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "& > button": {
            "&::after": {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: "3px solid ".concat((0, $aPzaW.MSThemeColors).SelectedBackground)
            }
        }
    }
});
var $767ac3fb64404055$export$4e8024263ace498b = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref2, ref) {
    var width = _ref2.width, children = _ref2.children, isSortable = _ref2.isSortable, sortOrder = _ref2.sortOrder, isFixedSize = _ref2.isFixedSize, shouldTruncate = _ref2.shouldTruncate, onClick = _ref2.onClick, style = _ref2.style, testId = _ref2.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref2, $767ac3fb64404055$var$_excluded2);
    var mergedStyles = $767ac3fb64404055$var$_objectSpread($767ac3fb64404055$var$_objectSpread($767ac3fb64404055$var$_objectSpread({}, style), width && (0, $TDWFG.getTruncationStyleVars)({
        width: width
    })), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, $767ac3fb64404055$var$CSS_VAR_TEXT_COLOR, (0, $aPzaW.head).textColor));
    var isASC = sortOrder === (0, $f0z3w.ASC);
    var isDESC = sortOrder === (0, $f0z3w.DESC);
    var getFormattedSortOrder = function getFormattedSortOrder() {
        if (isASC) return "ascending";
        else if (isDESC) return "descending";
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    var Component = children ? "th" : "td";
    return (0, $avKww.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        "aria-sort": getFormattedSortOrder(),
        style: mergedStyles,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $TDWFG.cellStyles),
            $767ac3fb64404055$var$headCellBaseStyles,
            onClick && $767ac3fb64404055$var$onClickStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $TDWFG.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $TDWFG.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && (0, $TDWFG.overflowTruncateStyles),
            isSortable && $767ac3fb64404055$var$baseStyles,
            isASC && $767ac3fb64404055$var$ascendingStyles,
            isDESC && $767ac3fb64404055$var$descendingStyles
        ],
        onClick: onClick,
        ref: ref,
        "data-testid": testId
    }, rest), children);
});

});

parcelRegister("2iGt4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ace3472e76fcdf6$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $9nHZC = parcelRequire("9nHZC");

var $bNWDv = parcelRequire("bNWDv");

var $ju3lq = parcelRequire("ju3lq");

var $7AcW8 = parcelRequire("7AcW8");
var $1ace3472e76fcdf6$var$_excluded = [
    "isRanking",
    "refHeight",
    "refWidth"
];
function $1ace3472e76fcdf6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1ace3472e76fcdf6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $1ace3472e76fcdf6$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1ace3472e76fcdf6$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $1ace3472e76fcdf6$var$RankableTableHeadCellComponent = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(RankableTableHeadCellComponent, _React$Component);
    var _super = $1ace3472e76fcdf6$var$_createSuper(RankableTableHeadCellComponent);
    function RankableTableHeadCellComponent() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, RankableTableHeadCellComponent);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(RankableTableHeadCellComponent, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, isRanking = _this$props.isRanking, refHeight = _this$props.refHeight, refWidth = _this$props.refWidth, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_this$props, $1ace3472e76fcdf6$var$_excluded);
                var inlineStyles = (0, $ju3lq.inlineStylesIfRanking)(isRanking, refWidth);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7AcW8.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                    inlineStyles: inlineStyles
                }, restProps));
            }
        }
    ]);
    return RankableTableHeadCellComponent;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component);
var $1ace3472e76fcdf6$var$RankableTableHeadCell = (0, $bNWDv.default)($1ace3472e76fcdf6$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1ace3472e76fcdf6$export$2e2bcd8739ae039 = $1ace3472e76fcdf6$var$RankableTableHeadCell;

});
parcelRegister("bNWDv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8981c13c2c6b1f19$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");
function $8981c13c2c6b1f19$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8981c13c2c6b1f19$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $8981c13c2c6b1f19$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($8981c13c2c6b1f19$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $8981c13c2c6b1f19$export$2e2bcd8739ae039(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(WithDimensions, _React$Component);
        var _super = $8981c13c2c6b1f19$var$_createSuper(WithDimensions);
        function WithDimensions() {
            var _this;
            (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, WithDimensions);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "state", {
                refWidth: 0,
                refHeight: 0
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "innerRef", function(ref) {
                if (ref && !_this.props.isRanking) _this.ref = ref;
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "updateDimensions", function() {
                if (!_this.ref) return;
                var clientRect = _this.ref.getBoundingClientRect();
                var width = clientRect.width;
                var height = clientRect.height;
                if (width !== _this.state.refWidth || height !== _this.state.refHeight) _this.setState({
                    refWidth: width,
                    refHeight: height
                });
            });
            return _this;
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(WithDimensions, [
            {
                key: "UNSAFE_componentWillReceiveProps",
                value: function UNSAFE_componentWillReceiveProps(nextProps) {
                    var wasRanking = this.props.isRanking;
                    var willRanking = nextProps.isRanking;
                    if (willRanking && !wasRanking) this.updateDimensions();
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$state = this.state, refWidth = _this$state.refWidth, refHeight = _this$state.refHeight;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                        refWidth: refWidth,
                        refHeight: refHeight,
                        innerRef: this.innerRef
                    }, this.props));
                }
            }
        ]);
        return WithDimensions;
    }((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component);
}

});

parcelRegister("7AcW8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5855ee201a1562e5$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $aaF9X = parcelRequire("aaF9X");
var $5855ee201a1562e5$var$_excluded = [
    "content",
    "inlineStyles",
    "testId",
    "isRanking",
    "innerRef",
    "isSortable",
    "onClick"
];
var $5855ee201a1562e5$var$TableHeadCell = function TableHeadCell(_ref) {
    var content = _ref.content, inlineStyles = _ref.inlineStyles, testId = _ref.testId, isRanking = _ref.isRanking, innerRef = _ref.innerRef, isSortable = _ref.isSortable, onClick = _ref.onClick, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $5855ee201a1562e5$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aaF9X.HeadCell), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        style: inlineStyles,
        testId: testId && "".concat(testId, "--head--cell"),
        ref: typeof innerRef !== "string" ? innerRef : null // string refs must be discarded as LegacyRefs are not compatible with FC forwardRefs
    }, rest, {
        onClick: onClick,
        isSortable: isSortable
    }), isSortable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("button", {
        type: "button",
        "aria-roledescription": "Sort button"
    }, content) : content);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5855ee201a1562e5$export$2e2bcd8739ae039 = $5855ee201a1562e5$var$TableHeadCell;

});



parcelRegister("gm7iU", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("1fE2F")).then(()=>parcelRequire("gGjK6"));

});



parcelRegister("7doh5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $540c93b59fadbf91$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $k4V2x = parcelRequire("k4V2x");

var $k1aiE = parcelRequire("k1aiE");
var $kq9Vd = parcelRequire("kq9Vd");
var $540c93b59fadbf91$var$baseStylesOld = (0, $kq9Vd.xcss)({
    display: "inline-flex",
    borderRadius: "border.radius",
    blockSize: "min-content",
    position: "static",
    overflow: "hidden"
});
var $540c93b59fadbf91$var$styles = {
    container: (0, $avKww.css)({
        display: "inline-flex",
        boxSizing: "border-box",
        position: "static",
        blockSize: "min-content",
        borderRadius: "3px",
        overflow: "hidden",
        paddingInline: "var(--ds-space-050, 4px)"
    }),
    background: {
        bold: {
            default: (0, $avKww.css)({
                backgroundColor: "#DDDEE1"
            }),
            inprogress: (0, $avKww.css)({
                backgroundColor: "#8FB8F6"
            }),
            moved: (0, $avKww.css)({
                backgroundColor: "#F9C84E"
            }),
            new: (0, $avKww.css)({
                backgroundColor: "#D8A0F7"
            }),
            removed: (0, $avKww.css)({
                backgroundColor: "#FD9891"
            }),
            success: (0, $avKww.css)({
                backgroundColor: "#B3DF72"
            })
        },
        subtle: {
            default: (0, $avKww.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            inprogress: (0, $avKww.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            moved: (0, $avKww.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            new: (0, $avKww.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            removed: (0, $avKww.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            success: (0, $avKww.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            })
        }
    },
    border: {
        subtle: {
            default: (0, $avKww.css)({
                border: "1px solid #B7B9BE"
            }),
            inprogress: (0, $avKww.css)({
                border: "1px solid #669DF1"
            }),
            moved: (0, $avKww.css)({
                border: "1px solid #FCA700"
            }),
            new: (0, $avKww.css)({
                border: "1px solid #C97CF4"
            }),
            removed: (0, $avKww.css)({
                border: "1px solid #F87168"
            }),
            success: (0, $avKww.css)({
                border: "1px solid #94C748"
            })
        }
    },
    text: {
        subtle: (0, $avKww.css)({
            color: "var(--ds-text, #172B4D)"
        }),
        bold: (0, $avKww.css)({
            color: "#292A2E"
        })
    }
};
var $540c93b59fadbf91$var$textStyles = (0, $avKww.css)({
    fontFamily: 'ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
    fontSize: "11px",
    fontStyle: "normal",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    lineHeight: "16px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textTransform: "uppercase",
    whiteSpace: "nowrap"
});
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $540c93b59fadbf91$var$Lozenge = /*#__PURE__*/ (0, $9nHZC.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? "bold" : "subtle";
    var appearanceType = appearance in $540c93b59fadbf91$var$styles.background[appearanceStyle] ? appearance : "default";
    var maxWidthValue = typeof maxWidth === "string" ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === "string" && /%$/.test(maxWidth);
    if ((0, $k4V2x.fg)("platform-component-visual-refresh")) return (0, $avKww.jsx)("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : "100%"
        },
        css: [
            $540c93b59fadbf91$var$styles.container,
            $540c93b59fadbf91$var$styles.background[appearanceStyle][appearanceType],
            appearanceStyle === "subtle" && $540c93b59fadbf91$var$styles.border.subtle[appearanceType]
        ],
        "data-testid": testId
    }, (0, $avKww.jsx)("span", {
        css: [
            $540c93b59fadbf91$var$textStyles,
            $540c93b59fadbf91$var$styles.text[appearanceStyle]
        ],
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? "100%" : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text")
    }, children));
    var appearanceTypeOld = appearance in $540c93b59fadbf91$var$backgroundColorsOld[appearanceStyle] ? appearance : "default";
    return (0, $avKww.jsx)((0, $k1aiE.default), {
        as: "span",
        backgroundColor: $540c93b59fadbf91$var$backgroundColorsOld[appearanceStyle][appearanceTypeOld],
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : "100%"
        },
        paddingInline: "space.050",
        xcss: $540c93b59fadbf91$var$baseStylesOld,
        testId: testId
    }, (0, $avKww.jsx)("span", {
        css: [
            $540c93b59fadbf91$var$textStyles,
            $540c93b59fadbf91$var$textColorsOld[appearanceStyle][appearanceType]
        ],
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? "100%" : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text")
    }, children));
});
$540c93b59fadbf91$var$Lozenge.displayName = "Lozenge";
var $540c93b59fadbf91$export$2e2bcd8739ae039 = $540c93b59fadbf91$var$Lozenge;
var $540c93b59fadbf91$var$backgroundColorsOld = {
    bold: {
        default: "color.background.neutral.bold",
        inprogress: "color.background.information.bold",
        moved: "color.background.warning.bold",
        new: "color.background.discovery.bold",
        removed: "color.background.danger.bold",
        success: "color.background.success.bold"
    },
    subtle: {
        default: "color.background.neutral",
        inprogress: "color.background.information",
        moved: "color.background.warning",
        new: "color.background.discovery",
        removed: "color.background.danger",
        success: "color.background.success"
    }
};
var $540c93b59fadbf91$var$textColorsOld = {
    bold: {
        default: (0, $avKww.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        inprogress: (0, $avKww.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        moved: (0, $avKww.css)({
            color: "var(--ds-text-warning-inverse, #172B4D)"
        }),
        new: (0, $avKww.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        removed: (0, $avKww.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        success: (0, $avKww.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        })
    },
    subtle: {
        default: (0, $avKww.css)({
            color: "var(--ds-text-subtle, #42526E)"
        }),
        inprogress: (0, $avKww.css)({
            color: "var(--ds-text-information, #0052CC)"
        }),
        moved: (0, $avKww.css)({
            color: "var(--ds-text-warning, #974F0C)"
        }),
        new: (0, $avKww.css)({
            color: "var(--ds-text-discovery, #403294)"
        }),
        removed: (0, $avKww.css)({
            color: "var(--ds-text-danger, #DE350B)"
        }),
        success: (0, $avKww.css)({
            color: "var(--ds-text-success, #006644)"
        })
    }
};

});
parcelRegister("k4V2x", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $e9e06d5283a12e0a$export$b40ec24ac8275656; });

var $jICiF = parcelRequire("jICiF");
function $e9e06d5283a12e0a$export$ba05d765b8392e5e(flagResolver) {
    (0, $jICiF.setBooleanResolver)(flagResolver);
}
function $e9e06d5283a12e0a$export$470e5c2be1411c89(name) {
    return (0, $jICiF.resolveBooleanFlag)(name);
}
function $e9e06d5283a12e0a$export$b40ec24ac8275656(name) {
    return (0, $jICiF.resolveBooleanFlag)(name);
}

});
parcelRegister("jICiF", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $e5afd5f52b743e1c$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $e5afd5f52b743e1c$export$6333b6aff9fc6275; });

var $14jeN = parcelRequire("14jeN");

var $8ovux = parcelRequire("8ovux");
var $e5afd5f52b743e1c$var$pkgName = "@atlaskit/platform-feature-flags";
var $e5afd5f52b743e1c$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $e5afd5f52b743e1c$var$hasProcessEnv = typeof $8ovux !== "undefined" && typeof $8ovux.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $e5afd5f52b743e1c$var$ENV_ENABLE_PLATFORM_FF = $e5afd5f52b743e1c$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $e5afd5f52b743e1c$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $e5afd5f52b743e1c$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $e5afd5f52b743e1c$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $e5afd5f52b743e1c$var$ENV_ENABLE_PLATFORM_FF || $e5afd5f52b743e1c$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $e5afd5f52b743e1c$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $e5afd5f52b743e1c$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$e5afd5f52b743e1c$var$globalVar[$e5afd5f52b743e1c$export$7e41b1b2bdee3f98] = $e5afd5f52b743e1c$var$globalVar[$e5afd5f52b743e1c$export$7e41b1b2bdee3f98] || $e5afd5f52b743e1c$var$DEFAULT_PFF_GLOBAL;
function $e5afd5f52b743e1c$export$f2b591175b3e424c(resolver) {
    $e5afd5f52b743e1c$var$globalVar[$e5afd5f52b743e1c$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $e5afd5f52b743e1c$export$6333b6aff9fc6275(flagKey) {
    if ($e5afd5f52b743e1c$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $14jeN.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $e5afd5f52b743e1c$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $e5afd5f52b743e1c$var$globalVar[$e5afd5f52b743e1c$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("14jeN", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $0c751657910429af$export$1c9f709888824e05; });
var $0c751657910429af$var$_ref, $0c751657910429af$var$_process, $0c751657910429af$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $0c751657910429af$var$TESTS_MODE = ($0c751657910429af$var$_ref = (globalThis === null || globalThis === void 0 || ($0c751657910429af$var$_process = globalThis.process) === null || $0c751657910429af$var$_process === void 0 || ($0c751657910429af$var$_process = $0c751657910429af$var$_process.env) === null || $0c751657910429af$var$_process === void 0 ? void 0 : $0c751657910429af$var$_process.JEST_WORKER_ID) !== undefined, $0c751657910429af$var$_ref !== void 0) ? $0c751657910429af$var$_ref : false;
var $0c751657910429af$var$DEBUG_MODE = !$0c751657910429af$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($0c751657910429af$var$_process2 = globalThis.process) === null || $0c751657910429af$var$_process2 === void 0 || ($0c751657910429af$var$_process2 = $0c751657910429af$var$_process2.env) === null || $0c751657910429af$var$_process2 === void 0 ? void 0 : $0c751657910429af$var$_process2.NODE_ENV) !== "production";
var $0c751657910429af$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$0c751657910429af$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("k1aiE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e92be3f6f4bb496b$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $bbjhA = parcelRequire("bbjhA");

var $kq9Vd = parcelRequire("kq9Vd");

var $jIgiQ = parcelRequire("jIgiQ");
var $e92be3f6f4bb496b$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $e92be3f6f4bb496b$var$_excluded2 = [
    "className"
];
var $e92be3f6f4bb496b$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $e92be3f6f4bb496b$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(htmlAttributes, $e92be3f6f4bb496b$var$_excluded2);
    var resolvedStyles = (0, $kq9Vd.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $avKww.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $e92be3f6f4bb496b$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $bbjhA.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bbjhA.isSurfaceColorToken)(backgroundColor) && (0, $bbjhA.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $bbjhA.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $bbjhA.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $bbjhA.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $bbjhA.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $bbjhA.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $bbjhA.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $bbjhA.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $avKww.jsx)((0, $jIgiQ.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $e92be3f6f4bb496b$export$2e2bcd8739ae039 = $e92be3f6f4bb496b$export$e71c4d32a2263218;
var $e92be3f6f4bb496b$var$baseStyles = (0, $avKww.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("bbjhA", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $823fadf2f775bfc2$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $823fadf2f775bfc2$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $823fadf2f775bfc2$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $823fadf2f775bfc2$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $823fadf2f775bfc2$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $823fadf2f775bfc2$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $823fadf2f775bfc2$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $823fadf2f775bfc2$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $823fadf2f775bfc2$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $823fadf2f775bfc2$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $823fadf2f775bfc2$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $823fadf2f775bfc2$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $823fadf2f775bfc2$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $823fadf2f775bfc2$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $823fadf2f775bfc2$export$5e65a44e5b6ecadb; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $xbX1J = parcelRequire("xbX1J");
function $823fadf2f775bfc2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $823fadf2f775bfc2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $823fadf2f775bfc2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $823fadf2f775bfc2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $823fadf2f775bfc2$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $823fadf2f775bfc2$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $823fadf2f775bfc2$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $823fadf2f775bfc2$export$632685d741f3dbbf = $823fadf2f775bfc2$var$_objectSpread($823fadf2f775bfc2$var$_objectSpread({}, $823fadf2f775bfc2$export$958d0ae7f2977ae4), $823fadf2f775bfc2$export$d2dc61f58390201c);
var $823fadf2f775bfc2$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $823fadf2f775bfc2$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $823fadf2f775bfc2$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $823fadf2f775bfc2$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $823fadf2f775bfc2$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $823fadf2f775bfc2$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $823fadf2f775bfc2$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $823fadf2f775bfc2$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $823fadf2f775bfc2$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $823fadf2f775bfc2$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $823fadf2f775bfc2$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $823fadf2f775bfc2$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $823fadf2f775bfc2$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $823fadf2f775bfc2$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $823fadf2f775bfc2$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $823fadf2f775bfc2$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $avKww.css)((0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $823fadf2f775bfc2$export$e615f061ca585a6c = $823fadf2f775bfc2$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $823fadf2f775bfc2$var$getSerializedStylesMap(spacingProperty, $823fadf2f775bfc2$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $823fadf2f775bfc2$export$bf46c3f9eeafc71f = $823fadf2f775bfc2$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $823fadf2f775bfc2$var$getSerializedStylesMap(spacingProperty, $823fadf2f775bfc2$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $823fadf2f775bfc2$export$e7af83bafe7f9e63 = $823fadf2f775bfc2$var$getSerializedStylesMap("backgroundColor", $823fadf2f775bfc2$export$d1d79bf68ac056bd);
var $823fadf2f775bfc2$export$3a1bcba60b23d7f0 = $823fadf2f775bfc2$var$getSerializedStylesMap("color", $823fadf2f775bfc2$export$8473307aa00d6ea1);
var $823fadf2f775bfc2$export$45f3f4fe16f9f7d5 = $823fadf2f775bfc2$var$getSerializedStylesMap("fontWeight", $823fadf2f775bfc2$export$303e322c6b1ed114);
var $823fadf2f775bfc2$export$68cc305da27dbaa4 = $823fadf2f775bfc2$var$getSerializedStylesMap("fontFamily", $823fadf2f775bfc2$export$3c7e9587132614b4);
var $823fadf2f775bfc2$export$128f10c238242f83 = $823fadf2f775bfc2$var$getSerializedStylesMap("font", $823fadf2f775bfc2$export$6cc560b4dedf3816);
var $823fadf2f775bfc2$export$ff257d957d48c421 = $823fadf2f775bfc2$var$getSerializedStylesMap((0, $xbX1J.CURRENT_SURFACE_CSS_VAR), $823fadf2f775bfc2$export$41a358c9c2356760);
var $823fadf2f775bfc2$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $823fadf2f775bfc2$export$41a358c9c2356760[color] !== undefined;
};

});

parcelRegister("kq9Vd", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $edddeea64395f052$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $edddeea64395f052$export$f6c783d06584602c; });

var $b4Ivn = parcelRequire("b4Ivn");

var $kFnE9 = parcelRequire("kFnE9");

var $9q1kH = parcelRequire("9q1kH");

var $340K4 = parcelRequire("340K4");

var $avKww = parcelRequire("avKww");

var $bbjhA = parcelRequire("bbjhA");

var $8ovux = parcelRequire("8ovux");
function $edddeea64395f052$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $edddeea64395f052$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $edddeea64395f052$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $edddeea64395f052$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $edddeea64395f052$var$_arrayLikeToArray(o, minLen);
}
function $edddeea64395f052$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $edddeea64395f052$export$9a199fbafee0014e = {
    backgroundColor: (0, $bbjhA.backgroundColorMap),
    blockSize: (0, $bbjhA.dimensionMap),
    borderBlockColor: (0, $bbjhA.borderColorMap),
    borderBlockEndColor: (0, $bbjhA.borderColorMap),
    borderBlockEndWidth: (0, $bbjhA.borderWidthMap),
    borderBlockStartColor: (0, $bbjhA.borderColorMap),
    borderBlockStartWidth: (0, $bbjhA.borderWidthMap),
    borderBlockWidth: (0, $bbjhA.borderWidthMap),
    borderBottomColor: (0, $bbjhA.borderColorMap),
    borderBottomLeftRadius: (0, $bbjhA.borderRadiusMap),
    borderBottomRightRadius: (0, $bbjhA.borderRadiusMap),
    borderBottomWidth: (0, $bbjhA.borderWidthMap),
    borderColor: (0, $bbjhA.borderColorMap),
    borderEndEndRadius: (0, $bbjhA.borderRadiusMap),
    borderEndStartRadius: (0, $bbjhA.borderRadiusMap),
    borderInlineColor: (0, $bbjhA.borderColorMap),
    borderInlineEndColor: (0, $bbjhA.borderColorMap),
    borderInlineEndWidth: (0, $bbjhA.borderWidthMap),
    borderInlineStartColor: (0, $bbjhA.borderColorMap),
    borderInlineStartWidth: (0, $bbjhA.borderWidthMap),
    borderInlineWidth: (0, $bbjhA.borderWidthMap),
    borderLeftColor: (0, $bbjhA.borderColorMap),
    borderLeftWidth: (0, $bbjhA.borderWidthMap),
    borderRadius: (0, $bbjhA.borderRadiusMap),
    borderRightColor: (0, $bbjhA.borderColorMap),
    borderRightWidth: (0, $bbjhA.borderWidthMap),
    borderStartEndRadius: (0, $bbjhA.borderRadiusMap),
    borderStartStartRadius: (0, $bbjhA.borderRadiusMap),
    borderTopColor: (0, $bbjhA.borderColorMap),
    borderTopLeftRadius: (0, $bbjhA.borderRadiusMap),
    borderTopRightRadius: (0, $bbjhA.borderRadiusMap),
    borderTopWidth: (0, $bbjhA.borderWidthMap),
    borderWidth: (0, $bbjhA.borderWidthMap),
    bottom: (0, $bbjhA.allSpaceMap),
    boxShadow: (0, $bbjhA.shadowMap),
    color: (0, $bbjhA.textColorMap),
    columnGap: (0, $bbjhA.positiveSpaceMap),
    gap: (0, $bbjhA.positiveSpaceMap),
    height: (0, $bbjhA.dimensionMap),
    inlineSize: (0, $bbjhA.dimensionMap),
    inset: (0, $bbjhA.allSpaceMap),
    insetBlock: (0, $bbjhA.allSpaceMap),
    insetBlockEnd: (0, $bbjhA.allSpaceMap),
    insetBlockStart: (0, $bbjhA.allSpaceMap),
    insetInline: (0, $bbjhA.allSpaceMap),
    insetInlineEnd: (0, $bbjhA.allSpaceMap),
    insetInlineStart: (0, $bbjhA.allSpaceMap),
    left: (0, $bbjhA.allSpaceMap),
    margin: (0, $bbjhA.allSpaceMap),
    marginBlock: (0, $bbjhA.allSpaceMap),
    marginBlockEnd: (0, $bbjhA.allSpaceMap),
    marginBlockStart: (0, $bbjhA.allSpaceMap),
    marginBottom: (0, $bbjhA.allSpaceMap),
    marginInline: (0, $bbjhA.allSpaceMap),
    marginInlineEnd: (0, $bbjhA.allSpaceMap),
    marginInlineStart: (0, $bbjhA.allSpaceMap),
    marginLeft: (0, $bbjhA.allSpaceMap),
    marginRight: (0, $bbjhA.allSpaceMap),
    marginTop: (0, $bbjhA.allSpaceMap),
    maxBlockSize: (0, $bbjhA.dimensionMap),
    maxHeight: (0, $bbjhA.dimensionMap),
    maxInlineSize: (0, $bbjhA.dimensionMap),
    maxWidth: (0, $bbjhA.dimensionMap),
    minBlockSize: (0, $bbjhA.dimensionMap),
    minHeight: (0, $bbjhA.dimensionMap),
    minInlineSize: (0, $bbjhA.dimensionMap),
    minWidth: (0, $bbjhA.dimensionMap),
    opacity: (0, $bbjhA.opacityMap),
    outlineColor: (0, $bbjhA.borderColorMap),
    outlineOffset: (0, $bbjhA.positiveSpaceMap),
    outlineWidth: (0, $bbjhA.borderWidthMap),
    padding: (0, $bbjhA.positiveSpaceMap),
    paddingBlock: (0, $bbjhA.positiveSpaceMap),
    paddingBlockEnd: (0, $bbjhA.positiveSpaceMap),
    paddingBlockStart: (0, $bbjhA.positiveSpaceMap),
    paddingBottom: (0, $bbjhA.positiveSpaceMap),
    paddingInline: (0, $bbjhA.positiveSpaceMap),
    paddingInlineEnd: (0, $bbjhA.positiveSpaceMap),
    paddingInlineStart: (0, $bbjhA.positiveSpaceMap),
    paddingLeft: (0, $bbjhA.positiveSpaceMap),
    paddingRight: (0, $bbjhA.positiveSpaceMap),
    paddingTop: (0, $bbjhA.positiveSpaceMap),
    right: (0, $bbjhA.allSpaceMap),
    rowGap: (0, $bbjhA.positiveSpaceMap),
    top: (0, $bbjhA.allSpaceMap),
    width: (0, $bbjhA.dimensionMap),
    zIndex: (0, $bbjhA.layerMap)
};
var $edddeea64395f052$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $edddeea64395f052$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $8ovux === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux.env) === "object" && false;
};
var $edddeea64395f052$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $edddeea64395f052$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $edddeea64395f052$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(value) === "object" && $edddeea64395f052$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($edddeea64395f052$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($edddeea64395f052$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $edddeea64395f052$export$9a199fbafee0014e)) return;
        var tokenValue = $edddeea64395f052$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $edddeea64395f052$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $edddeea64395f052$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, $edddeea64395f052$var$uniqueSymbol, (0, $avKww.css)(transformedStyles));
};
var $edddeea64395f052$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $edddeea64395f052$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$edddeea64395f052$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $edddeea64395f052$export$f6c783d06584602c(style) {
    return $edddeea64395f052$var$baseXcss(style);
}

});

parcelRegister("jIgiQ", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $e59ec5d034e2f75a$export$1ca2a26fecb070ae; });

var $9nHZC = parcelRequire("9nHZC");
var $e59ec5d034e2f75a$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $9nHZC.createContext)("elevation.surface");
var $e59ec5d034e2f75a$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $9nHZC.useContext)($e59ec5d034e2f75a$export$1ca2a26fecb070ae);
};
$e59ec5d034e2f75a$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});



parcelRegister("jn0KA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("d6OwB")).default; });
$parcel$export(module.exports, "PanelStateless", function () { return (parcelRequire("aJH6p")).default; });
parcelRequire("4RnCl");
var $d6OwB = parcelRequire("d6OwB");
var $aJH6p = parcelRequire("aJH6p");

});
parcelRegister("4RnCl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("d6OwB")).default; });
$parcel$export(module.exports, "PanelStateless", function () { return (parcelRequire("aJH6p")).default; });

var $d6OwB = parcelRequire("d6OwB");

var $aJH6p = parcelRequire("aJH6p");

});
parcelRegister("d6OwB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98b307177f1ad280$export$2e2bcd8739ae039; });

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $aJH6p = parcelRequire("aJH6p");
var $98b307177f1ad280$var$PanelState = function PanelState(_ref) {
    var _ref$isDefaultExpande = _ref.isDefaultExpanded, isDefaultExpanded = _ref$isDefaultExpande === void 0 ? false : _ref$isDefaultExpande, children = _ref.children, header = _ref.header;
    var _useState = (0, $9nHZC.useState)(isDefaultExpanded), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), isExpanded = _useState2[0], setisExpanded = _useState2[1];
    var handleChange = function handleChange() {
        setisExpanded(!isExpanded);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aJH6p.default), {
        header: header,
        isExpanded: isExpanded,
        onChange: handleChange
    }, children);
};
var $98b307177f1ad280$export$2e2bcd8739ae039 = $98b307177f1ad280$var$PanelState;

});
parcelRegister("aJH6p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d0f8a995cc635f8$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $dMdA2 = parcelRequire("dMdA2");

var $dLdNR = parcelRequire("dLdNR");
var $b7ZcK = parcelRequire("b7ZcK");

var $6jfYS = parcelRequire("6jfYS");

var $dWDB7 = parcelRequire("dWDB7");

var $9nixN = parcelRequire("9nixN");

var $dptzI = parcelRequire("dptzI");
var $7d0f8a995cc635f8$var$i18n = (0, $dLdNR.defineMessages)({
    collapse: {
        id: "bitbucket.panel-collapse.message",
        defaultMessage: "collapse",
        description: "Label on the panel to signal that the user can collapse the panel."
    },
    expand: {
        id: "bitbucket.panel-expand.message",
        defaultMessage: "expand",
        description: "Label on the panel to signal that the user can expand the panel."
    }
});
var $7d0f8a995cc635f8$var$PanelStateless = function PanelStateless(_ref) {
    var children = _ref.children, header = _ref.header, _ref$isExpanded = _ref.isExpanded, isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded, onChange = _ref.onChange;
    var intl = (0, $b7ZcK.default)();
    var i18nExpandText = intl.formatMessage($7d0f8a995cc635f8$var$i18n.expand);
    var i18nCollapseText = intl.formatMessage($7d0f8a995cc635f8$var$i18n.collapse);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($dptzI.PanelWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($dptzI.PanelHeader, {
        onClick: function onClick() {
            return onChange(!isExpanded);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($dptzI.ButtonWrapper, {
        isHidden: isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6jfYS.default), {
        appearance: "subtle",
        "aria-expanded": isExpanded,
        spacing: "none",
        iconBefore: isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dWDB7))), {
            label: i18nCollapseText
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nixN))), {
            label: i18nExpandText
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", null, header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dMdA2))), {
        duration: 200,
        easing: "linear",
        height: isExpanded ? "auto" : 0,
        className: "panel-content"
    }, children));
};
var $7d0f8a995cc635f8$export$2e2bcd8739ae039 = $7d0f8a995cc635f8$var$PanelStateless;

});
parcelRegister("dMdA2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a07a4ad006b04764$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $a07a4ad006b04764$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $a07a4ad006b04764$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $9nHZC = parcelRequire("9nHZC");
var $a07a4ad006b04764$var$_react2 = $a07a4ad006b04764$var$_interopRequireDefault($9nHZC);

var $blCBi = parcelRequire("blCBi");
var $a07a4ad006b04764$var$_propTypes2 = $a07a4ad006b04764$var$_interopRequireDefault($blCBi);

var $iigdU = parcelRequire("iigdU");
var $a07a4ad006b04764$var$_classnames2 = $a07a4ad006b04764$var$_interopRequireDefault($iigdU);
function $a07a4ad006b04764$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a07a4ad006b04764$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a07a4ad006b04764$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a07a4ad006b04764$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a07a4ad006b04764$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $a07a4ad006b04764$var$ANIMATION_STATE_CLASSES = {
    animating: "rah-animating",
    animatingUp: "rah-animating--up",
    animatingDown: "rah-animating--down",
    animatingToHeightZero: "rah-animating--to-height-zero",
    animatingToHeightAuto: "rah-animating--to-height-auto",
    animatingToHeightSpecific: "rah-animating--to-height-specific",
    static: "rah-static",
    staticHeightZero: "rah-static--height-zero",
    staticHeightAuto: "rah-static--height-auto",
    staticHeightSpecific: "rah-static--height-specific"
};
var $a07a4ad006b04764$var$PROPS_TO_OMIT = [
    "animateOpacity",
    "animationStateClasses",
    "applyInlineTransitions",
    "children",
    "contentClassName",
    "delay",
    "duration",
    "easing",
    "height",
    "onAnimationEnd",
    "onAnimationStart"
];
function $a07a4ad006b04764$var$omit(obj) {
    for(var _len = arguments.length, keys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)keys[_key - 1] = arguments[_key];
    if (!keys.length) return obj;
    var res = {};
    var objectKeys = Object.keys(obj);
    for(var i = 0; i < objectKeys.length; i++){
        var key = objectKeys[i];
        if (keys.indexOf(key) === -1) res[key] = obj[key];
    }
    return res;
}
// Start animation helper using nested requestAnimationFrames
function $a07a4ad006b04764$var$startAnimationHelper(callback) {
    var requestAnimationFrameIDs = [];
    requestAnimationFrameIDs[0] = requestAnimationFrame(function() {
        requestAnimationFrameIDs[1] = requestAnimationFrame(function() {
            callback();
        });
    });
    return requestAnimationFrameIDs;
}
function $a07a4ad006b04764$var$cancelAnimationFrames(requestAnimationFrameIDs) {
    requestAnimationFrameIDs.forEach(function(id) {
        return cancelAnimationFrame(id);
    });
}
function $a07a4ad006b04764$var$isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function $a07a4ad006b04764$var$isPercentage(height) {
    // Percentage height
    return typeof height === "string" && height.search("%") === height.length - 1 && $a07a4ad006b04764$var$isNumber(height.substr(0, height.length - 1));
}
function $a07a4ad006b04764$var$runCallback(callback, params) {
    if (callback && typeof callback === "function") callback(params);
}
var $a07a4ad006b04764$var$AnimateHeight = function(_React$Component) {
    $a07a4ad006b04764$var$_inherits(AnimateHeight, _React$Component);
    function AnimateHeight(props) {
        $a07a4ad006b04764$var$_classCallCheck(this, AnimateHeight);
        var _this = $a07a4ad006b04764$var$_possibleConstructorReturn(this, (AnimateHeight.__proto__ || Object.getPrototypeOf(AnimateHeight)).call(this, props));
        _this.animationFrameIDs = [];
        var height = "auto";
        var overflow = "visible";
        if ($a07a4ad006b04764$var$isNumber(props.height)) {
            // If value is string "0" make sure we convert it to number 0
            height = props.height < 0 || props.height === "0" ? 0 : props.height;
            overflow = "hidden";
        } else if ($a07a4ad006b04764$var$isPercentage(props.height)) {
            // If value is string "0%" make sure we convert it to number 0
            height = props.height === "0%" ? 0 : props.height;
            overflow = "hidden";
        }
        _this.animationStateClasses = $a07a4ad006b04764$var$_extends({}, $a07a4ad006b04764$var$ANIMATION_STATE_CLASSES, props.animationStateClasses);
        var animationStateClasses = _this.getStaticStateClasses(height);
        _this.state = {
            animationStateClasses: animationStateClasses,
            height: height,
            overflow: overflow,
            shouldUseTransitions: false
        };
        return _this;
    }
    $a07a4ad006b04764$var$_createClass(AnimateHeight, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var height = this.state.height;
                // Hide content if height is 0 (to prevent tabbing into it)
                // Check for contentElement is added cause this would fail in tests (react-test-renderer)
                // Read more here: https://github.com/Stanko/react-animate-height/issues/17
                if (this.contentElement && this.contentElement.style) this.hideContent(height);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this2 = this;
                var _props = this.props, delay = _props.delay, duration = _props.duration, height = _props.height, onAnimationEnd = _props.onAnimationEnd, onAnimationStart = _props.onAnimationStart;
                // Check if 'height' prop has changed
                if (this.contentElement && height !== prevProps.height) {
                    var _cx;
                    // Remove display: none from the content div
                    // if it was hidden to prevent tabbing into it
                    this.showContent(prevState.height);
                    // Cache content height
                    this.contentElement.style.overflow = "hidden";
                    var contentHeight = this.contentElement.offsetHeight;
                    this.contentElement.style.overflow = "";
                    // set total animation time
                    var totalDuration = duration + delay;
                    var newHeight = null;
                    var timeoutState = {
                        height: null,
                        overflow: "hidden"
                    };
                    var isCurrentHeightAuto = prevState.height === "auto";
                    if ($a07a4ad006b04764$var$isNumber(height)) {
                        // If value is string "0" make sure we convert it to number 0
                        newHeight = height < 0 || height === "0" ? 0 : height;
                        timeoutState.height = newHeight;
                    } else if ($a07a4ad006b04764$var$isPercentage(height)) {
                        // If value is string "0%" make sure we convert it to number 0
                        newHeight = height === "0%" ? 0 : height;
                        timeoutState.height = newHeight;
                    } else {
                        // If not, animate to content height
                        // and then reset to auto
                        newHeight = contentHeight; // TODO solve contentHeight = 0
                        timeoutState.height = "auto";
                        timeoutState.overflow = null;
                    }
                    if (isCurrentHeightAuto) {
                        // This is the height to be animated to
                        timeoutState.height = newHeight;
                        // If previous height was 'auto'
                        // set starting height explicitly to be able to use transition
                        newHeight = contentHeight;
                    }
                    // Animation classes
                    var animationStateClasses = (0, $a07a4ad006b04764$var$_classnames2.default)((_cx = {}, $a07a4ad006b04764$var$_defineProperty(_cx, this.animationStateClasses.animating, true), $a07a4ad006b04764$var$_defineProperty(_cx, this.animationStateClasses.animatingUp, prevProps.height === "auto" || height < prevProps.height), $a07a4ad006b04764$var$_defineProperty(_cx, this.animationStateClasses.animatingDown, height === "auto" || height > prevProps.height), $a07a4ad006b04764$var$_defineProperty(_cx, this.animationStateClasses.animatingToHeightZero, timeoutState.height === 0), $a07a4ad006b04764$var$_defineProperty(_cx, this.animationStateClasses.animatingToHeightAuto, timeoutState.height === "auto"), $a07a4ad006b04764$var$_defineProperty(_cx, this.animationStateClasses.animatingToHeightSpecific, timeoutState.height > 0), _cx));
                    // Animation classes to be put after animation is complete
                    var timeoutAnimationStateClasses = this.getStaticStateClasses(timeoutState.height);
                    // Set starting height and animating classes
                    // We are safe to call set state as it will not trigger infinite loop
                    // because of the "height !== prevProps.height" check
                    this.setState({
                        animationStateClasses: animationStateClasses,
                        height: newHeight,
                        overflow: "hidden",
                        // When animating from 'auto' we first need to set fixed height
                        // that change should be animated
                        shouldUseTransitions: !isCurrentHeightAuto
                    });
                    // Clear timeouts
                    clearTimeout(this.timeoutID);
                    clearTimeout(this.animationClassesTimeoutID);
                    if (isCurrentHeightAuto) {
                        // When animating from 'auto' we use a short timeout to start animation
                        // after setting fixed height above
                        timeoutState.shouldUseTransitions = true;
                        $a07a4ad006b04764$var$cancelAnimationFrames(this.animationFrameIDs);
                        this.animationFrameIDs = $a07a4ad006b04764$var$startAnimationHelper(function() {
                            _this2.setState(timeoutState);
                            // ANIMATION STARTS, run a callback if it exists
                            $a07a4ad006b04764$var$runCallback(onAnimationStart, {
                                newHeight: timeoutState.height
                            });
                        });
                        // Set static classes and remove transitions when animation ends
                        this.animationClassesTimeoutID = setTimeout(function() {
                            _this2.setState({
                                animationStateClasses: timeoutAnimationStateClasses,
                                shouldUseTransitions: false
                            });
                            // ANIMATION ENDS
                            // Hide content if height is 0 (to prevent tabbing into it)
                            _this2.hideContent(timeoutState.height);
                            // Run a callback if it exists
                            $a07a4ad006b04764$var$runCallback(onAnimationEnd, {
                                newHeight: timeoutState.height
                            });
                        }, totalDuration);
                    } else {
                        // ANIMATION STARTS, run a callback if it exists
                        $a07a4ad006b04764$var$runCallback(onAnimationStart, {
                            newHeight: newHeight
                        });
                        // Set end height, classes and remove transitions when animation is complete
                        this.timeoutID = setTimeout(function() {
                            timeoutState.animationStateClasses = timeoutAnimationStateClasses;
                            timeoutState.shouldUseTransitions = false;
                            _this2.setState(timeoutState);
                            // ANIMATION ENDS
                            // If height is auto, don't hide the content
                            // (case when element is empty, therefore height is 0)
                            if (height !== "auto") // Hide content if height is 0 (to prevent tabbing into it)
                            _this2.hideContent(newHeight); // TODO solve newHeight = 0
                            // Run a callback if it exists
                            $a07a4ad006b04764$var$runCallback(onAnimationEnd, {
                                newHeight: newHeight
                            });
                        }, totalDuration);
                    }
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                $a07a4ad006b04764$var$cancelAnimationFrames(this.animationFrameIDs);
                clearTimeout(this.timeoutID);
                clearTimeout(this.animationClassesTimeoutID);
                this.timeoutID = null;
                this.animationClassesTimeoutID = null;
                this.animationStateClasses = null;
            }
        },
        {
            key: "showContent",
            value: function showContent(height) {
                if (height === 0) this.contentElement.style.display = "";
            }
        },
        {
            key: "hideContent",
            value: function hideContent(newHeight) {
                if (newHeight === 0) this.contentElement.style.display = "none";
            }
        },
        {
            key: "getStaticStateClasses",
            value: function getStaticStateClasses(height) {
                var _cx2;
                return (0, $a07a4ad006b04764$var$_classnames2.default)((_cx2 = {}, $a07a4ad006b04764$var$_defineProperty(_cx2, this.animationStateClasses.static, true), $a07a4ad006b04764$var$_defineProperty(_cx2, this.animationStateClasses.staticHeightZero, height === 0), $a07a4ad006b04764$var$_defineProperty(_cx2, this.animationStateClasses.staticHeightSpecific, height > 0), $a07a4ad006b04764$var$_defineProperty(_cx2, this.animationStateClasses.staticHeightAuto, height === "auto"), _cx2));
            }
        },
        {
            key: "render",
            value: function render() {
                var _cx3, _this3 = this;
                var _props2 = this.props, animateOpacity = _props2.animateOpacity, applyInlineTransitions = _props2.applyInlineTransitions, children = _props2.children, className = _props2.className, contentClassName = _props2.contentClassName, delay = _props2.delay, duration = _props2.duration, easing = _props2.easing, id = _props2.id, style = _props2.style;
                var _state = this.state, height = _state.height, overflow = _state.overflow, animationStateClasses = _state.animationStateClasses, shouldUseTransitions = _state.shouldUseTransitions;
                var componentStyle = $a07a4ad006b04764$var$_extends({}, style, {
                    height: height,
                    overflow: overflow || style.overflow
                });
                if (shouldUseTransitions && applyInlineTransitions) {
                    componentStyle.transition = "height " + duration + "ms " + easing + " " + delay + "ms";
                    // Include transition passed through styles
                    if (style.transition) componentStyle.transition = style.transition + ", " + componentStyle.transition;
                    // Add webkit vendor prefix still used by opera, blackberry...
                    componentStyle.WebkitTransition = componentStyle.transition;
                }
                var contentStyle = {};
                if (animateOpacity) {
                    contentStyle.transition = "opacity " + duration + "ms " + easing + " " + delay + "ms";
                    // Add webkit vendor prefix still used by opera, blackberry...
                    contentStyle.WebkitTransition = contentStyle.transition;
                    if (height === 0) contentStyle.opacity = 0;
                }
                var componentClasses = (0, $a07a4ad006b04764$var$_classnames2.default)((_cx3 = {}, $a07a4ad006b04764$var$_defineProperty(_cx3, animationStateClasses, true), $a07a4ad006b04764$var$_defineProperty(_cx3, className, className), _cx3));
                // Check if user passed aria-hidden prop
                var hasAriaHiddenProp = typeof this.props["aria-hidden"] !== "undefined";
                var ariaHidden = hasAriaHiddenProp ? this.props["aria-hidden"] : height === 0;
                return $a07a4ad006b04764$var$_react2.default.createElement("div", $a07a4ad006b04764$var$_extends({}, $a07a4ad006b04764$var$omit.apply(undefined, [
                    this.props
                ].concat($a07a4ad006b04764$var$PROPS_TO_OMIT)), {
                    "aria-hidden": ariaHidden,
                    className: componentClasses,
                    id: id,
                    style: componentStyle
                }), $a07a4ad006b04764$var$_react2.default.createElement("div", {
                    className: contentClassName,
                    style: contentStyle,
                    ref: function ref(el) {
                        return _this3.contentElement = el;
                    }
                }, children));
            }
        }
    ]);
    return AnimateHeight;
}($a07a4ad006b04764$var$_react2.default.Component);
var $a07a4ad006b04764$var$heightPropType = function heightPropType(props, propName, componentName) {
    var value = props[propName];
    if (typeof value === "number" && value >= 0 || $a07a4ad006b04764$var$isPercentage(value) || value === "auto") return null;
    return new TypeError('value "' + value + '" of type "' + (typeof value === "undefined" ? "undefined" : $a07a4ad006b04764$var$_typeof(value)) + '" is invalid type for ' + propName + " in " + componentName + ". " + 'It needs to be a positive number, string "auto" or percentage string (e.g. "15%").');
};
$a07a4ad006b04764$var$AnimateHeight.propTypes = {
    "aria-hidden": $a07a4ad006b04764$var$_propTypes2.default.bool,
    animateOpacity: $a07a4ad006b04764$var$_propTypes2.default.bool,
    animationStateClasses: $a07a4ad006b04764$var$_propTypes2.default.object,
    applyInlineTransitions: $a07a4ad006b04764$var$_propTypes2.default.bool,
    children: $a07a4ad006b04764$var$_propTypes2.default.any.isRequired,
    className: $a07a4ad006b04764$var$_propTypes2.default.string,
    contentClassName: $a07a4ad006b04764$var$_propTypes2.default.string,
    delay: $a07a4ad006b04764$var$_propTypes2.default.number,
    duration: $a07a4ad006b04764$var$_propTypes2.default.number,
    easing: $a07a4ad006b04764$var$_propTypes2.default.string,
    height: $a07a4ad006b04764$var$heightPropType,
    id: $a07a4ad006b04764$var$_propTypes2.default.string,
    onAnimationEnd: $a07a4ad006b04764$var$_propTypes2.default.func,
    onAnimationStart: $a07a4ad006b04764$var$_propTypes2.default.func,
    style: $a07a4ad006b04764$var$_propTypes2.default.object
};
$a07a4ad006b04764$var$AnimateHeight.defaultProps = {
    animateOpacity: false,
    animationStateClasses: $a07a4ad006b04764$var$ANIMATION_STATE_CLASSES,
    applyInlineTransitions: true,
    duration: 250,
    delay: 0,
    easing: "ease",
    style: {}
};
module.exports.default = $a07a4ad006b04764$var$AnimateHeight;

});
parcelRegister("iigdU", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});


parcelRegister("dLdNR", function(module, exports) {

$parcel$export(module.exports, "defineMessages", function () { return $a04a5f2f33d66cad$export$1adfeb024f5185b; });
$parcel$export(module.exports, "defineMessage", function () { return $a04a5f2f33d66cad$export$747d244ee58120dd; });
$parcel$export(module.exports, "FormattedDate", function () { return $a04a5f2f33d66cad$export$40ae3194919d16b; });
$parcel$export(module.exports, "FormattedTime", function () { return $a04a5f2f33d66cad$export$5b390a54f8a846f7; });
$parcel$export(module.exports, "FormattedNumber", function () { return $a04a5f2f33d66cad$export$db80edc1e6b2f63d; });
$parcel$export(module.exports, "FormattedList", function () { return $a04a5f2f33d66cad$export$f52b44e459e6e71d; });
$parcel$export(module.exports, "FormattedDisplayName", function () { return $a04a5f2f33d66cad$export$c2336ea5aaab92fa; });
$parcel$export(module.exports, "FormattedDateParts", function () { return $a04a5f2f33d66cad$export$7fdc7d2c91ce149b; });
$parcel$export(module.exports, "FormattedTimeParts", function () { return $a04a5f2f33d66cad$export$ec35873761676c2a; });
$parcel$export(module.exports, "FormattedDateTimeRange", function () { return (parcelRequire("juEMQ")).default; });
$parcel$export(module.exports, "FormattedMessage", function () { return (parcelRequire("eygjM")).default; });
$parcel$export(module.exports, "FormattedPlural", function () { return (parcelRequire("15SAX")).default; });
$parcel$export(module.exports, "FormattedRelativeTime", function () { return (parcelRequire("fs8Ul")).default; });
$parcel$export(module.exports, "IntlContext", function () { return (parcelRequire("h1pNM")).Context; });
$parcel$export(module.exports, "IntlProvider", function () { return (parcelRequire("huxZk")).default; });
$parcel$export(module.exports, "RawIntlProvider", function () { return (parcelRequire("h1pNM")).Provider; });
$parcel$export(module.exports, "createIntl", function () { return (parcelRequire("huxZk")).createIntl; });
$parcel$export(module.exports, "injectIntl", function () { return (parcelRequire("h1pNM")).default; });
$parcel$export(module.exports, "useIntl", function () { return (parcelRequire("b7ZcK")).default; });
$parcel$export(module.exports, "createIntlCache", function () { return (parcelRequire("5Nrk0")).createIntlCache; });
$parcel$export(module.exports, "UnsupportedFormatterError", function () { return (parcelRequire("043Q6")).UnsupportedFormatterError; });
$parcel$export(module.exports, "InvalidConfigError", function () { return (parcelRequire("043Q6")).InvalidConfigError; });
$parcel$export(module.exports, "MissingDataError", function () { return (parcelRequire("043Q6")).MissingDataError; });
$parcel$export(module.exports, "MessageFormatError", function () { return (parcelRequire("043Q6")).MessageFormatError; });
$parcel$export(module.exports, "MissingTranslationError", function () { return (parcelRequire("043Q6")).MissingTranslationError; });
$parcel$export(module.exports, "ReactIntlErrorCode", function () { return (parcelRequire("043Q6")).IntlErrorCode; });
$parcel$export(module.exports, "ReactIntlError", function () { return (parcelRequire("043Q6")).IntlError; });
$parcel$export(module.exports, "FormattedNumberParts", function () { return (parcelRequire("ew3i0")).FormattedNumberParts; });
$parcel$export(module.exports, "FormattedListParts", function () { return (parcelRequire("ew3i0")).FormattedListParts; });

var $ew3i0 = parcelRequire("ew3i0");

var $h1pNM = parcelRequire("h1pNM");

var $b7ZcK = parcelRequire("b7ZcK");

var $huxZk = parcelRequire("huxZk");

var $fs8Ul = parcelRequire("fs8Ul");

var $15SAX = parcelRequire("15SAX");

var $eygjM = parcelRequire("eygjM");

var $juEMQ = parcelRequire("juEMQ");

var $5Nrk0 = parcelRequire("5Nrk0");
var $043Q6 = parcelRequire("043Q6");
function $a04a5f2f33d66cad$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $a04a5f2f33d66cad$export$747d244ee58120dd(msg) {
    return msg;
}
var $a04a5f2f33d66cad$export$40ae3194919d16b = (0, $ew3i0.createFormattedComponent)("formatDate");
var $a04a5f2f33d66cad$export$5b390a54f8a846f7 = (0, $ew3i0.createFormattedComponent)("formatTime");
var $a04a5f2f33d66cad$export$db80edc1e6b2f63d = (0, $ew3i0.createFormattedComponent)("formatNumber");
var $a04a5f2f33d66cad$export$f52b44e459e6e71d = (0, $ew3i0.createFormattedComponent)("formatList");
var $a04a5f2f33d66cad$export$c2336ea5aaab92fa = (0, $ew3i0.createFormattedComponent)("formatDisplayName");
var $a04a5f2f33d66cad$export$7fdc7d2c91ce149b = (0, $ew3i0.createFormattedDateTimePartsComponent)("formatDate");
var $a04a5f2f33d66cad$export$ec35873761676c2a = (0, $ew3i0.createFormattedDateTimePartsComponent)("formatTime");

});
parcelRegister("ew3i0", function(module, exports) {

$parcel$export(module.exports, "FormattedNumberParts", function () { return $a9169b0ba8347a33$export$54d4989ed3eea1ea; });
$parcel$export(module.exports, "FormattedListParts", function () { return $a9169b0ba8347a33$export$5ac259c7da6d2188; });
$parcel$export(module.exports, "createFormattedDateTimePartsComponent", function () { return $a9169b0ba8347a33$export$7448277f6036d2ab; });
$parcel$export(module.exports, "createFormattedComponent", function () { return $a9169b0ba8347a33$export$b37e14176d001dec; });

var $jGOup = parcelRequire("jGOup");

var $9nHZC = parcelRequire("9nHZC");

var $b7ZcK = parcelRequire("b7ZcK");
var $a9169b0ba8347a33$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($a9169b0ba8347a33$var$DisplayName || ($a9169b0ba8347a33$var$DisplayName = {}));
var $a9169b0ba8347a33$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($a9169b0ba8347a33$var$DisplayNameParts || ($a9169b0ba8347a33$var$DisplayNameParts = {}));
var $a9169b0ba8347a33$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $b7ZcK.default)();
    var value = props.value, children = props.children, formatProps = (0, $jGOup.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$a9169b0ba8347a33$export$54d4989ed3eea1ea.displayName = "FormattedNumberParts";
var $a9169b0ba8347a33$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $b7ZcK.default)();
    var value = props.value, children = props.children, formatProps = (0, $jGOup.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$a9169b0ba8347a33$export$54d4989ed3eea1ea.displayName = "FormattedNumberParts";
function $a9169b0ba8347a33$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $b7ZcK.default)();
        var value = props.value, children = props.children, formatProps = (0, $jGOup.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === "string" ? new Date(value || 0) : value;
        var formattedParts = name === "formatDate" ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $a9169b0ba8347a33$var$DisplayNameParts[name];
    return ComponentParts;
}
function $a9169b0ba8347a33$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $b7ZcK.default)();
        var value = props.value, children = props.children, formatProps = (0, $jGOup.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === "function") return children(formattedValue);
        var Text = intl.textComponent || $9nHZC.Fragment;
        return $9nHZC.createElement(Text, null, formattedValue);
    };
    Component.displayName = $a9169b0ba8347a33$var$DisplayName[name];
    return Component;
}

});
parcelRegister("b7ZcK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $819fd323ef60cc38$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $h1pNM = parcelRequire("h1pNM");

var $gyaUL = parcelRequire("gyaUL");
function $819fd323ef60cc38$export$2e2bcd8739ae039() {
    var intl = $9nHZC.useContext((0, $h1pNM.Context));
    (0, $gyaUL.invariantIntlContext)(intl);
    return intl;
}

});


parcelRegister("fs8Ul", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b400616fd25f691f$export$2e2bcd8739ae039; });

var $jGOup = parcelRequire("jGOup");

var $9nHZC = parcelRequire("9nHZC");

var $4kRXG = parcelRequire("4kRXG");

var $b7ZcK = parcelRequire("b7ZcK");
var $b400616fd25f691f$var$MINUTE = 60;
var $b400616fd25f691f$var$HOUR = 3600;
var $b400616fd25f691f$var$DAY = 86400;
function $b400616fd25f691f$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $b400616fd25f691f$var$MINUTE) return "second";
    if (absValue < $b400616fd25f691f$var$HOUR) return "minute";
    if (absValue < $b400616fd25f691f$var$DAY) return "hour";
    return "day";
}
function $b400616fd25f691f$var$getDurationInSeconds(unit) {
    switch(unit){
        case "second":
            return 1;
        case "minute":
            return $b400616fd25f691f$var$MINUTE;
        case "hour":
            return $b400616fd25f691f$var$HOUR;
        default:
            return $b400616fd25f691f$var$DAY;
    }
}
function $b400616fd25f691f$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case "second":
            return value;
        case "minute":
            return value * $b400616fd25f691f$var$MINUTE;
        default:
            return value * $b400616fd25f691f$var$HOUR;
    }
}
var $b400616fd25f691f$var$INCREMENTABLE_UNITS = [
    "second",
    "minute",
    "hour"
];
function $b400616fd25f691f$var$canIncrement(unit) {
    if (unit === void 0) unit = "second";
    return $b400616fd25f691f$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $b400616fd25f691f$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $b7ZcK.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, $jGOup.__rest)(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === "function") return children(formattedRelativeTime);
    if (Text) return $9nHZC.createElement(Text, null, formattedRelativeTime);
    return $9nHZC.createElement($9nHZC.Fragment, null, formattedRelativeTime);
};
var $b400616fd25f691f$var$FormattedRelativeTime = function(_a) {
    var value = _a.value, unit = _a.unit, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, $jGOup.__rest)(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $4kRXG.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $b400616fd25f691f$var$canIncrement(unit)), "Cannot schedule update with unit longer than hour");
    var _b = $9nHZC.useState(), prevUnit = _b[0], setPrevUnit = _b[1];
    var _c = $9nHZC.useState(0), prevValue = _c[0], setPrevValue = _c[1];
    var _d = $9nHZC.useState(0), currentValueInSeconds = _d[0], setCurrentValueInSeconds = _d[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($b400616fd25f691f$var$canIncrement(unit) ? $b400616fd25f691f$var$valueToSeconds(value, unit) : 0);
    }
    $9nHZC.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$b400616fd25f691f$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $b400616fd25f691f$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === "day") return clearUpdateTimer;
        var unitDuration = $b400616fd25f691f$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($b400616fd25f691f$var$canIncrement(unit) && typeof currentValueInSeconds === "number" && updateIntervalInSeconds) {
        currentUnit = $b400616fd25f691f$var$selectUnit(currentValueInSeconds);
        var unitDuration = $b400616fd25f691f$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $9nHZC.createElement($b400616fd25f691f$var$SimpleFormattedRelativeTime, (0, $jGOup.__assign)({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$b400616fd25f691f$var$FormattedRelativeTime.displayName = "FormattedRelativeTime";
$b400616fd25f691f$var$FormattedRelativeTime.defaultProps = {
    value: 0,
    unit: "second"
};
var $b400616fd25f691f$export$2e2bcd8739ae039 = $b400616fd25f691f$var$FormattedRelativeTime;

});

parcelRegister("15SAX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cc09b8331513452$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $9nHZC = parcelRequire("9nHZC");

var $b7ZcK = parcelRequire("b7ZcK");
var $0cc09b8331513452$var$FormattedPlural = function(props) {
    var _a = (0, $b7ZcK.default)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
    var value = props.value, other = props.other, children = props.children;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === "function") return children(formattedPlural);
    if (Text) return $9nHZC.createElement(Text, null, formattedPlural);
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
$0cc09b8331513452$var$FormattedPlural.defaultProps = {
    type: "cardinal"
};
$0cc09b8331513452$var$FormattedPlural.displayName = "FormattedPlural";
var $0cc09b8331513452$export$2e2bcd8739ae039 = $0cc09b8331513452$var$FormattedPlural;

});

parcelRegister("eygjM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a980e6107dc48305$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $jGOup = parcelRequire("jGOup");

var $9nHZC = parcelRequire("9nHZC");

var $b7ZcK = parcelRequire("b7ZcK");

var $gyaUL = parcelRequire("gyaUL");
function $a980e6107dc48305$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $jGOup.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $jGOup.__rest)(nextProps, [
        "values"
    ]);
    return (0, $gyaUL.shallowEqual)(nextValues, values) && (0, $gyaUL.shallowEqual)(otherProps, nextOtherProps);
}
function $a980e6107dc48305$var$FormattedMessage(props) {
    var intl = (0, $b7ZcK.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $9nHZC.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === "function") return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $9nHZC.createElement(Component, null, $9nHZC.Children.toArray(nodes));
    return $9nHZC.createElement($9nHZC.Fragment, null, nodes);
}
$a980e6107dc48305$var$FormattedMessage.displayName = "FormattedMessage";
var $a980e6107dc48305$var$MemoizedFormattedMessage = $9nHZC.memo($a980e6107dc48305$var$FormattedMessage, $a980e6107dc48305$var$areEqual);
$a980e6107dc48305$var$MemoizedFormattedMessage.displayName = "MemoizedFormattedMessage";
var $a980e6107dc48305$export$2e2bcd8739ae039 = $a980e6107dc48305$var$MemoizedFormattedMessage;

});

parcelRegister("juEMQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3107515fd248092$export$2e2bcd8739ae039; });

var $jGOup = parcelRequire("jGOup");

var $9nHZC = parcelRequire("9nHZC");

var $b7ZcK = parcelRequire("b7ZcK");
var $e3107515fd248092$var$FormattedDateTimeRange = function(props) {
    var intl = (0, $b7ZcK.default)();
    var from = props.from, to = props.to, children = props.children, formatProps = (0, $jGOup.__rest)(props, [
        "from",
        "to",
        "children"
    ]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === "function") return children(formattedValue);
    var Text = intl.textComponent || $9nHZC.Fragment;
    return $9nHZC.createElement(Text, null, formattedValue);
};
$e3107515fd248092$var$FormattedDateTimeRange.displayName = "FormattedDateTimeRange";
var $e3107515fd248092$export$2e2bcd8739ae039 = $e3107515fd248092$var$FormattedDateTimeRange;

});


parcelRegister("6jfYS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4980e9e1da399d63$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9q1kH = parcelRequire("9q1kH");

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $5LVXk = parcelRequire("5LVXk");

var $6rVbu = parcelRequire("6rVbu");

var $93qL0 = parcelRequire("93qL0");

var $5HSFY = parcelRequire("5HSFY");

var $hrQPh = parcelRequire("hrQPh");
var $4980e9e1da399d63$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isSelected",
    "shouldFitContainer",
    "spacing",
    "isLoading",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseDown",
    "onMouseUp",
    "onFocus",
    "onBlur",
    "theme"
];
function $4980e9e1da399d63$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4980e9e1da399d63$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4980e9e1da399d63$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4980e9e1da399d63$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4980e9e1da399d63$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return "disabled";
    if (isSelected && isFocus) return "focusSelected";
    if (isSelected) return "selected";
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return "active";
    if (!isLoading && isHover) return "hover";
    if (isFocus) return "focus";
    return "default";
}
var $4980e9e1da399d63$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var $4980e9e1da399d63$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $hrQPh.defaultThemeFn) : _ref2$theme, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref2, $4980e9e1da399d63$var$_excluded);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $4980e9e1da399d63$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $9nHZC.useState)($4980e9e1da399d63$var$initial), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $4980e9e1da399d63$var$_objectSpread($4980e9e1da399d63$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $4980e9e1da399d63$var$_objectSpread($4980e9e1da399d63$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $4980e9e1da399d63$var$_objectSpread($4980e9e1da399d63$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $4980e9e1da399d63$var$_objectSpread($4980e9e1da399d63$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $4980e9e1da399d63$var$_objectSpread($4980e9e1da399d63$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $4980e9e1da399d63$var$_objectSpread($4980e9e1da399d63$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $hrQPh.default).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5LVXk.default).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $hrQPh.default).Consumer, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            mode: mode,
            state: $4980e9e1da399d63$var$getInteractionState($4980e9e1da399d63$var$_objectSpread($4980e9e1da399d63$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $93qL0.default)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6rVbu.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5HSFY.default), restProps) : null,
                "aria-disabled": isLoading || restProps["aria-disabled"],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $hrQPh.getSpecifiers)(buttonStyles)
            }));
        });
    }));
}));
// Tools including enzyme rely on components having a display name
$4980e9e1da399d63$var$CustomThemeButton.displayName = "CustomThemeButton";
var $4980e9e1da399d63$export$2e2bcd8739ae039 = $4980e9e1da399d63$var$CustomThemeButton;

});
parcelRegister("6rVbu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b219f548150023f$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $cBNAA = parcelRequire("cBNAA");

var $8p2GL = parcelRequire("8p2GL");

var $grYZC = parcelRequire("grYZC");

var $dxhCu = parcelRequire("dxhCu");

var $5fUc4 = parcelRequire("5fUc4");

var $jp7ng = parcelRequire("jp7ng");

var $7U8Ej = parcelRequire("7U8Ej");

var $cEXMm = parcelRequire("cEXMm");

var $7hIvy = parcelRequire("7hIvy");
var $4b219f548150023f$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $4b219f548150023f$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform.design-system-team.enable-new-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $4b219f548150023f$var$iconBeforeSpacingFixStyle = (0, $avKww.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $4b219f548150023f$var$iconAfterSpacingFixStyle = (0, $avKww.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $4b219f548150023f$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $7hIvy.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $4b219f548150023f$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $7hIvy.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $avKww.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $4b219f548150023f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $8p2GL.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $8p2GL.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(props, $4b219f548150023f$var$_excluded);
    var ourRef = (0, $9nHZC.useRef)();
    var setRef = (0, $9nHZC.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $grYZC.default)(ourRef, autoFocus);
    var interactionContext = (0, $9nHZC.useContext)((0, $5fUc4.default));
    var handleClick = (0, $9nHZC.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $cBNAA.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "17.23.0",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $9nHZC.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $9nHZC.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $avKww.css)((0, $cEXMm.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === "warning") spinnerHackCss = {
        "[data-theme] & circle": {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $jp7ng.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $jp7ng.N500), ")"), " !important")
        }
    };
    return (0, $avKww.jsx)((0, $dxhCu.default), null, (0, $avKww.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $4b219f548150023f$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $7U8Ej.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $avKww.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $cEXMm.getIconStyle)({
                spacing: spacing
            }),
            $4b219f548150023f$var$getSpacingFix(children, $4b219f548150023f$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $4b219f548150023f$var$getChildren(children, [
        fadeStyles,
        (0, $cEXMm.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $avKww.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $cEXMm.getIconStyle)({
                spacing: spacing
            }),
            $4b219f548150023f$var$getSpacingFix(children, $4b219f548150023f$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $avKww.jsx)("span", {
        css: [
            (0, $cEXMm.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});

});
parcelRegister("cBNAA", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $92df681b00e67bfd$export$a4687b0234b40e28; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $bVWR1 = parcelRequire("bVWR1");

var $cQac9 = parcelRequire("cQac9");
function $92df681b00e67bfd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $92df681b00e67bfd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $92df681b00e67bfd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $92df681b00e67bfd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $92df681b00e67bfd$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $bVWR1.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $cQac9.useTrackedRef)(analyticsData);
    var fnRef = (0, $cQac9.useTrackedRef)(fn);
    var handler = (0, $9nHZC.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $92df681b00e67bfd$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("bVWR1", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $8b02abce4926ee5a$export$5bf35293e545f20c; });

var $dNznA = parcelRequire("dNznA");

var $iH7J3 = parcelRequire("iH7J3");

var $5cB1s = parcelRequire("5cB1s");
function $8b02abce4926ee5a$export$5bf35293e545f20c() {
    var analyticsContext = (0, $5cB1s.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $iH7J3.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("iH7J3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9c23c486e19be8c$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $dTDWU = parcelRequire("dTDWU");
function $d9c23c486e19be8c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d9c23c486e19be8c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $d9c23c486e19be8c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d9c23c486e19be8c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $d9c23c486e19be8c$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $d9c23c486e19be8c$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $d9c23c486e19be8c$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $d9c23c486e19be8c$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $dTDWU.default));

});
parcelRegister("dTDWU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1df66766bb34b1e$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
function $a1df66766bb34b1e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a1df66766bb34b1e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a1df66766bb34b1e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a1df66766bb34b1e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a1df66766bb34b1e$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $a1df66766bb34b1e$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $a1df66766bb34b1e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $a1df66766bb34b1e$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(updater) === "object") this.payload = $a1df66766bb34b1e$var$_objectSpread($a1df66766bb34b1e$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("5cB1s", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $3c9aca9d6a920ab5$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $3c9aca9d6a920ab5$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});


parcelRegister("cQac9", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $95923fe6ab3dfc61$export$1d27a74659855e44; });

var $9nHZC = parcelRequire("9nHZC");
var $95923fe6ab3dfc61$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("7U8Ej", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c1478e4954ffc2c$export$2e2bcd8739ae039; });
function $5c1478e4954ffc2c$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $5c1478e4954ffc2c$var$tabKeyCode = 9;
function $5c1478e4954ffc2c$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $5c1478e4954ffc2c$var$tabKeyCode) return;
    $5c1478e4954ffc2c$var$abort(event);
}
var $5c1478e4954ffc2c$var$block = {
    onMouseDownCapture: $5c1478e4954ffc2c$var$abort,
    onMouseUpCapture: $5c1478e4954ffc2c$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $5c1478e4954ffc2c$var$onKey,
    onKeyUpCapture: $5c1478e4954ffc2c$var$onKey,
    onTouchStartCapture: $5c1478e4954ffc2c$var$abort,
    onTouchEndCapture: $5c1478e4954ffc2c$var$abort,
    onPointerDownCapture: $5c1478e4954ffc2c$var$abort,
    onPointerUpCapture: $5c1478e4954ffc2c$var$abort,
    onClickCapture: $5c1478e4954ffc2c$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $5c1478e4954ffc2c$var$abort
};
var $5c1478e4954ffc2c$var$doNotBlock = {};
function $5c1478e4954ffc2c$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $5c1478e4954ffc2c$var$doNotBlock : $5c1478e4954ffc2c$var$block;
}

});

parcelRegister("cEXMm", function(module, exports) {

$parcel$export(module.exports, "getCss", function () { return $93779758d9f99d93$export$955358618f994a11; });
$parcel$export(module.exports, "getIconStyle", function () { return $93779758d9f99d93$export$864eea3f4ec3368f; });
$parcel$export(module.exports, "getContentStyle", function () { return $93779758d9f99d93$export$7ad0316cc0dd65a; });
$parcel$export(module.exports, "getFadingCss", function () { return $93779758d9f99d93$export$1b5827d324e945b1; });
$parcel$export(module.exports, "overlayCss", function () { return $93779758d9f99d93$export$1a9fe1b84c876bb5; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $aP6k3 = parcelRequire("aP6k3");

var $5KF2K = parcelRequire("5KF2K");
function $93779758d9f99d93$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $93779758d9f99d93$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $93779758d9f99d93$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $93779758d9f99d93$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $93779758d9f99d93$var$gridSize = (0, $aP6k3.gridSize)();
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $93779758d9f99d93$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: "auto"
};
var $93779758d9f99d93$var$lineHeights = {
    default: $93779758d9f99d93$var$heights.default,
    compact: $93779758d9f99d93$var$heights.compact,
    none: "inherit"
};
var $93779758d9f99d93$var$padding = {
    // 10px gutter
    default: "0 ".concat($93779758d9f99d93$var$gridSize + $93779758d9f99d93$var$gridSize / 4, "px"),
    compact: "0 ".concat($93779758d9f99d93$var$gridSize + $93779758d9f99d93$var$gridSize / 4, "px"),
    none: "0"
};
var $93779758d9f99d93$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($93779758d9f99d93$var$gridSize / 4, "px"),
    default: "0 ".concat($93779758d9f99d93$var$gridSize / 4, "px"),
    none: "0"
};
var $93779758d9f99d93$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $93779758d9f99d93$var$innerMargin = {
    content: "0 ".concat($93779758d9f99d93$var$gridSize / 4, "px"),
    icon: "0 ".concat($93779758d9f99d93$var$gridSize / 4, "px")
};
function $93779758d9f99d93$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $93779758d9f99d93$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $93779758d9f99d93$var$getColor({
            group: (0, $5KF2K.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($93779758d9f99d93$var$getColor({
            group: (0, $5KF2K.default).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $93779758d9f99d93$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $93779758d9f99d93$var$getColors({
        appearance: appearance,
        key: isSelected ? "selected" : "default",
        mode: mode
    });
    return $93779758d9f99d93$var$_objectSpread($93779758d9f99d93$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: 500,
        // margin for button has been applied to css reset
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap"
    }, baseColors), {}, {
        cursor: "pointer",
        height: $93779758d9f99d93$var$heights[spacing],
        lineHeight: $93779758d9f99d93$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $93779758d9f99d93$var$singleIconPadding[spacing] : $93779758d9f99d93$var$padding[spacing],
        verticalAlign: $93779758d9f99d93$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center",
        // Note: we cannot disable pointer events when there is an overlay.
        // That would be easy for styling, but it would start letting events through on disabled buttons
        // Disabling visited styles (just using the base colors)
        "&:visited": $93779758d9f99d93$var$_objectSpread({}, baseColors),
        "&:hover": $93779758d9f99d93$var$_objectSpread($93779758d9f99d93$var$_objectSpread({}, $93779758d9f99d93$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "hover",
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "inherit",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        // giving active styles preference by listing them after focus
        "&:active": $93779758d9f99d93$var$_objectSpread($93779758d9f99d93$var$_objectSpread({}, $93779758d9f99d93$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $93779758d9f99d93$var$_objectSpread($93779758d9f99d93$var$_objectSpread({}, $93779758d9f99d93$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        "&[disabled]": $93779758d9f99d93$var$_objectSpread($93779758d9f99d93$var$_objectSpread({}, $93779758d9f99d93$var$getColors({
            appearance: appearance,
            key: "disabled",
            mode: mode
        })), {}, {
            cursor: "not-allowed",
            textDecoration: "none"
        }),
        '&[data-has-overlay="true"]': {
            cursor: "default",
            textDecoration: "none"
        },
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $93779758d9f99d93$var$_objectSpread({}, $93779758d9f99d93$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "default",
            mode: mode
        })),
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $93779758d9f99d93$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $avKww.css)({
        display: "flex",
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $93779758d9f99d93$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: "center",
        fontSize: 0,
        lineHeight: 0,
        userSelect: "none"
    });
}
function $93779758d9f99d93$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $avKww.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $93779758d9f99d93$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    });
}
function $93779758d9f99d93$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $avKww.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: "opacity 0.3s"
    });
}
var $93779758d9f99d93$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

});
parcelRegister("5KF2K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $430115fd5cea37c5$export$2e2bcd8739ae039; });

var $jp7ng = parcelRequire("jp7ng");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $430115fd5cea37c5$var$fadedB75 = "rgba(179, 212, 255, 0.6)";
var $430115fd5cea37c5$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($jp7ng.N20A, ")"),
                dark: "var(--ds-background-neutral, ".concat($jp7ng.DN70, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($jp7ng.N30A, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($jp7ng.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($430115fd5cea37c5$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($jp7ng.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($jp7ng.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($jp7ng.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.DN0, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($jp7ng.B400, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($jp7ng.B100, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($jp7ng.B300, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($jp7ng.B75, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($jp7ng.B500, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($jp7ng.B200, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($jp7ng.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($jp7ng.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.DN0, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($jp7ng.Y300, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($jp7ng.Y300, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($jp7ng.Y200, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($jp7ng.Y200, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($jp7ng.Y400, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($jp7ng.Y400, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($jp7ng.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($jp7ng.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.Y400, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.Y400, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($jp7ng.R400, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($jp7ng.R400, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($jp7ng.R300, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($jp7ng.R300, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($jp7ng.R500, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($jp7ng.R500, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($jp7ng.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($jp7ng.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.R500, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.R500, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.N20, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($jp7ng.N30A, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($jp7ng.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($430115fd5cea37c5$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($jp7ng.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.DN0, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.N20, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($jp7ng.N500, ")"),
                dark: "var(--ds-text, ".concat($jp7ng.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($jp7ng.B400, ")"),
                dark: "var(--ds-text, ".concat($jp7ng.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jp7ng.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jp7ng.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.DN400, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($jp7ng.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($jp7ng.DN30, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jp7ng.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jp7ng.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.DN400, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($jp7ng.N800, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($jp7ng.N800, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jp7ng.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jp7ng.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.N800, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.N800, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($jp7ng.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($jp7ng.N0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jp7ng.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jp7ng.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.N0, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.N0, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($jp7ng.B400, ")"),
                dark: "var(--ds-link, ".concat($jp7ng.B100, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($jp7ng.B300, ")"),
                dark: "var(--ds-link, ".concat($jp7ng.B75, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($jp7ng.B500, ")"),
                dark: "var(--ds-link-pressed, ".concat($jp7ng.B200, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jp7ng.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jp7ng.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.N700, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.N700, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($jp7ng.N500, ")"),
                dark: "var(--ds-text, ".concat($jp7ng.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($jp7ng.B400, ")"),
                dark: "var(--ds-text, ".concat($jp7ng.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jp7ng.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jp7ng.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.DN400, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-text-subtle, ".concat($jp7ng.N200, ")"),
                dark: "var(--ds-text-subtle, ".concat($jp7ng.DN400, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($jp7ng.N90, ")"),
                dark: "var(--ds-text-subtle, ".concat($jp7ng.B50, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($jp7ng.N400, ")"),
                dark: "var(--ds-text, ".concat($jp7ng.DN300, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jp7ng.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jp7ng.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.DN400, ")")
            }
        }
    }
};
var $430115fd5cea37c5$export$2e2bcd8739ae039 = $430115fd5cea37c5$var$values;

});


parcelRegister("7hIvy", function(module, exports) {

$parcel$export(module.exports, "getIfVisuallyHiddenChildren", function () { return $54dca54e986a17ec$export$20bbd2efb0d734c4; });

var $9nHZC = parcelRequire("9nHZC");

var $7S7GL = parcelRequire("7S7GL");
var $54dca54e986a17ec$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $9nHZC.isValidElement)(children) && children.type === (0, $7S7GL.default);
};

});


parcelRegister("93qL0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6979264f0d29f484$export$2e2bcd8739ae039; });

var $7hIvy = parcelRequire("7hIvy");
function $6979264f0d29f484$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $7hIvy.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});

parcelRegister("5HSFY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $427b616bff693959$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $2iqR9 = parcelRequire("2iqR9");
function $427b616bff693959$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return "inherit";
    if (isSelected) return "invert";
    if (appearance === "primary" || appearance === "danger") return "invert";
    return "inherit";
}
function $427b616bff693959$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing;
    var size = spacing === "default" ? "medium" : "small";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2iqR9.default), {
        size: size,
        label: ", Loading",
        appearance: $427b616bff693959$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});
parcelRegister("2iqR9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ac2184c7eae6a88$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $5fUc4 = parcelRequire("5fUc4");

var $6F2I3 = parcelRequire("6F2I3");

var $hEM88 = parcelRequire("hEM88");
/**
 * Returns the appropriate circle stroke color.
 */ function $1ac2184c7eae6a88$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $6F2I3.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $6F2I3.N0), ")");
}
var $1ac2184c7eae6a88$var$rotate = (0, $avKww.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $1ac2184c7eae6a88$var$rotateStyles = (0, $avKww.css)({
    animation: "".concat($1ac2184c7eae6a88$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $1ac2184c7eae6a88$var$loadIn = (0, $avKww.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $1ac2184c7eae6a88$var$loadInStyles = (0, $avKww.css)({
    animation: "".concat($1ac2184c7eae6a88$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $1ac2184c7eae6a88$var$wrapperStyles = (0, $avKww.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $1ac2184c7eae6a88$var$circleStyles = (0, $avKww.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $1ac2184c7eae6a88$var$useLayoutEffect = typeof window === "undefined" ? (0, $9nHZC.useEffect) : (0, $9nHZC.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $1ac2184c7eae6a88$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $hEM88.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $1ac2184c7eae6a88$var$getStrokeColor(appearance);
    var context = (0, $9nHZC.useContext)((0, $5fUc4.default));
    $1ac2184c7eae6a88$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $avKww.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $1ac2184c7eae6a88$var$wrapperStyles,
            $1ac2184c7eae6a88$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $avKww.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $1ac2184c7eae6a88$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none"
    }, (0, $avKww.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $1ac2184c7eae6a88$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $1ac2184c7eae6a88$export$2e2bcd8739ae039 = $1ac2184c7eae6a88$var$Spinner;

});
parcelRegister("6F2I3", function(module, exports) {

$parcel$export(module.exports, "N0", function () { return $4d98ac75f9b9a4e3$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $4d98ac75f9b9a4e3$export$c39c0fe0f26207ae; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $4d98ac75f9b9a4e3$export$4b84fd0e2c617bd = "#FFEBE6";
var $4d98ac75f9b9a4e3$export$b34b069eff244586 = "#FFBDAD";
var $4d98ac75f9b9a4e3$export$be802dd0d8b57f35 = "#FF8F73";
var $4d98ac75f9b9a4e3$export$60847d42f9da92a6 = "#FF7452";
var $4d98ac75f9b9a4e3$export$4a7404f376229999 = "#FF5630";
var $4d98ac75f9b9a4e3$export$2010d0fb4295b346 = "#DE350B";
var $4d98ac75f9b9a4e3$export$2837b5a1a71d5c02 = "#BF2600";
var $4d98ac75f9b9a4e3$export$8d9596b529bbb9cf = "#FFFAE6";
var $4d98ac75f9b9a4e3$export$41060a744ab0b7ae = "#FFF0B3";
var $4d98ac75f9b9a4e3$export$1cc05bbbf340e559 = "#FFE380";
var $4d98ac75f9b9a4e3$export$5aae31392d72caaa = "#FFC400";
var $4d98ac75f9b9a4e3$export$c6930421db9fa514 = "#FFAB00";
var $4d98ac75f9b9a4e3$export$59619663aa6500fb = "#FF991F";
var $4d98ac75f9b9a4e3$export$874739ea9e379ab6 = "#FF8B00";
var $4d98ac75f9b9a4e3$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $4d98ac75f9b9a4e3$export$69a3bf21b9686c2b = "#ABF5D1";
var $4d98ac75f9b9a4e3$export$afbce1382ec95f73 = "#79F2C0";
var $4d98ac75f9b9a4e3$export$747d86715d4175de = "#57D9A3";
var $4d98ac75f9b9a4e3$export$940e1f69e873f202 = "#36B37E";
var $4d98ac75f9b9a4e3$export$a49394138f7b8e85 = "#00875A";
var $4d98ac75f9b9a4e3$export$6fa04827ac68a4fb = "#006644";
var $4d98ac75f9b9a4e3$export$226de0355ed012f8 = "#DEEBFF";
var $4d98ac75f9b9a4e3$export$8c13c2ee36917869 = "#B3D4FF";
var $4d98ac75f9b9a4e3$export$ecfc1dff386a3e7a = "#4C9AFF";
var $4d98ac75f9b9a4e3$export$215b7063051591f1 = "#2684FF";
var $4d98ac75f9b9a4e3$export$e62e8919cca44969 = "#0065FF";
var $4d98ac75f9b9a4e3$export$b3de0ae08da2ce64 = "#0052CC";
var $4d98ac75f9b9a4e3$export$a6ee3d71bc067634 = "#0747A6";
var $4d98ac75f9b9a4e3$export$363e4475840015bb = "#EAE6FF";
var $4d98ac75f9b9a4e3$export$4b0a4417ed59760f = "#C0B6F2";
var $4d98ac75f9b9a4e3$export$6011520a64d9a187 = "#998DD9";
var $4d98ac75f9b9a4e3$export$a7175d4e9206bc80 = "#8777D9";
var $4d98ac75f9b9a4e3$export$b48405b95304b5a1 = "#6554C0";
var $4d98ac75f9b9a4e3$export$c71e4279dd54a18d = "#5243AA";
var $4d98ac75f9b9a4e3$export$147899de772240ec = "#403294";
var $4d98ac75f9b9a4e3$export$2cf711fe14c66f06 = "#E6FCFF";
var $4d98ac75f9b9a4e3$export$7a8f4d33f6f9772c = "#B3F5FF";
var $4d98ac75f9b9a4e3$export$776c9c497ef08533 = "#79E2F2";
var $4d98ac75f9b9a4e3$export$69cb3ca10c1e330e = "#00C7E6";
var $4d98ac75f9b9a4e3$export$9dc1ef0f3f48059b = "#00B8D9";
var $4d98ac75f9b9a4e3$export$7c835c78b6fcdef8 = "#00A3BF";
var $4d98ac75f9b9a4e3$export$6036577f95c3877e = "#008DA6";
var $4d98ac75f9b9a4e3$export$29a4f05edc054374 = "#FFFFFF";
var $4d98ac75f9b9a4e3$export$e655ef011c4aa1a2 = "#FAFBFC";
var $4d98ac75f9b9a4e3$export$9fdfb749e33cdf97 = "#F4F5F7";
var $4d98ac75f9b9a4e3$export$3e51e8f1440314ba = "#EBECF0";
var $4d98ac75f9b9a4e3$export$1ce2d1575d444ceb = "#DFE1E6";
var $4d98ac75f9b9a4e3$export$8754fc7e6d8b3000 = "#C1C7D0";
var $4d98ac75f9b9a4e3$export$c2e91cbeada39b8b = "#B3BAC5";
var $4d98ac75f9b9a4e3$export$5f71e19f3a7ad9de = "#A5ADBA";
var $4d98ac75f9b9a4e3$export$eaa8c8a70ac22806 = "#97A0AF";
var $4d98ac75f9b9a4e3$export$7c87d337fb91a97d = "#8993A4";
var $4d98ac75f9b9a4e3$export$d6447c357493214f = "#7A869A";
var $4d98ac75f9b9a4e3$export$f563ee71e9ee74cd = "#6B778C";
var $4d98ac75f9b9a4e3$export$e2ef2124cf4024b1 = "#5E6C84";
var $4d98ac75f9b9a4e3$export$eece5f492e429f08 = "#505F79";
var $4d98ac75f9b9a4e3$export$c39c0fe0f26207ae = "#42526E";
var $4d98ac75f9b9a4e3$export$7090862dc3038a9f = "#344563";
var $4d98ac75f9b9a4e3$export$ad0bacf983b7ddaa = "#253858";
var $4d98ac75f9b9a4e3$export$7d61b15e0da132af = "#172B4D";
var $4d98ac75f9b9a4e3$export$fbda843f0a27fe96 = "#091E42";
var $4d98ac75f9b9a4e3$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $4d98ac75f9b9a4e3$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $4d98ac75f9b9a4e3$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $4d98ac75f9b9a4e3$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $4d98ac75f9b9a4e3$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $4d98ac75f9b9a4e3$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $4d98ac75f9b9a4e3$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $4d98ac75f9b9a4e3$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $4d98ac75f9b9a4e3$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $4d98ac75f9b9a4e3$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $4d98ac75f9b9a4e3$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $4d98ac75f9b9a4e3$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $4d98ac75f9b9a4e3$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $4d98ac75f9b9a4e3$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $4d98ac75f9b9a4e3$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $4d98ac75f9b9a4e3$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $4d98ac75f9b9a4e3$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $4d98ac75f9b9a4e3$export$2f6319cf7d736c2a = "#E6EDFA";
var $4d98ac75f9b9a4e3$export$95126bc8884d6634 = "#DCE5F5";
var $4d98ac75f9b9a4e3$export$8338d8c35d44ff1 = "#CED9EB";
var $4d98ac75f9b9a4e3$export$5368d76ae4fbbda7 = "#B8C7E0";
var $4d98ac75f9b9a4e3$export$9f0a771d16ec8d36 = "#ABBBD6";
var $4d98ac75f9b9a4e3$export$abcf8c38338b4aa5 = "#9FB0CC";
var $4d98ac75f9b9a4e3$export$97e81faa16a182c7 = "#8C9CB8";
var $4d98ac75f9b9a4e3$export$bfe21c59123ecf33 = "#7988A3";
var $4d98ac75f9b9a4e3$export$ee82aa2ea6a1558 = "#67758F";
var $4d98ac75f9b9a4e3$export$682927c6ed76be02 = "#56637A";
var $4d98ac75f9b9a4e3$export$91fd9994c5be9757 = "#455166";
var $4d98ac75f9b9a4e3$export$d281fbfe3cff2df6 = "#3B475C";
var $4d98ac75f9b9a4e3$export$3902c91d8b98a753 = "#313D52";
var $4d98ac75f9b9a4e3$export$8e8133c1ba5845b5 = "#283447";
var $4d98ac75f9b9a4e3$export$33ff357f6620b39 = "#202B3D";
var $4d98ac75f9b9a4e3$export$633847cf062b69e0 = "#1B2638";
var $4d98ac75f9b9a4e3$export$9776a6e503bdbf76 = "#121A29";
var $4d98ac75f9b9a4e3$export$6c813d5160dff5db = "#0E1624";
var $4d98ac75f9b9a4e3$export$3d4f271a500072a = "#0D1424";
var $4d98ac75f9b9a4e3$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $4d98ac75f9b9a4e3$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $4d98ac75f9b9a4e3$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $4d98ac75f9b9a4e3$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $4d98ac75f9b9a4e3$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $4d98ac75f9b9a4e3$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $4d98ac75f9b9a4e3$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $4d98ac75f9b9a4e3$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $4d98ac75f9b9a4e3$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $4d98ac75f9b9a4e3$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $4d98ac75f9b9a4e3$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $4d98ac75f9b9a4e3$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $4d98ac75f9b9a4e3$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $4d98ac75f9b9a4e3$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $4d98ac75f9b9a4e3$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $4d98ac75f9b9a4e3$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $4d98ac75f9b9a4e3$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";

});

parcelRegister("hEM88", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $cdab81c3d071b3ec$export$4e9f1640bbe7a1a8; });
var $cdab81c3d071b3ec$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});



parcelRegister("hrQPh", function(module, exports) {

$parcel$export(module.exports, "getSpecifiers", function () { return $cb3def748927c3c5$export$643db0b8d8778e; });
$parcel$export(module.exports, "defaultThemeFn", function () { return $cb3def748927c3c5$export$437a7f77d13d7916; });
$parcel$export(module.exports, "default", function () { return $cb3def748927c3c5$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $dHFxE = parcelRequire("dHFxE");

var $cEXMm = parcelRequire("cEXMm");
function $cb3def748927c3c5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cb3def748927c3c5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cb3def748927c3c5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cb3def748927c3c5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cb3def748927c3c5$var$stateToSelectorMap = {
    focus: "&:focus",
    focusSelected: "&:focus",
    hover: "&:hover",
    active: "&:active",
    disabled: "&[disabled]"
};
function $cb3def748927c3c5$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? "light" : _ref$mode, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $cEXMm.getCss)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = "none";
    // Pulling relevant styles up to the top level
    var selector = $cb3def748927c3c5$var$stateToSelectorMap[state];
    if (selector) result = $cb3def748927c3c5$var$_objectSpread($cb3def748927c3c5$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $cb3def748927c3c5$var$_objectSpread($cb3def748927c3c5$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === "&::-moz-focus-inner") return;
        // Not using .startsWith for ie11
        if (key.indexOf("&") === 0) delete result[key];
    });
    return result;
}
function $cb3def748927c3c5$export$643db0b8d8778e(styles) {
    return {
        "&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]": styles
    };
}
function $cb3def748927c3c5$export$437a7f77d13d7916(current, values) {
    return current(values);
}
var $cb3def748927c3c5$var$Theme = (0, $dHFxE.createTheme)(function(themeProps) {
    return {
        buttonStyles: $cb3def748927c3c5$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cb3def748927c3c5$export$2e2bcd8739ae039 = $cb3def748927c3c5$var$Theme;

});


parcelRegister("dWDB7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a26f686822ffcb57$var$_react = $a26f686822ffcb57$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $a26f686822ffcb57$var$_chevronDown = $a26f686822ffcb57$var$_interopRequireDefault((parcelRequire("408Sl")));
function $a26f686822ffcb57$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a26f686822ffcb57$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $a26f686822ffcb57$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $a26f686822ffcb57$var$_chevronDown.default,
        iconType: "utility"
    }));
$a26f686822ffcb57$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $a26f686822ffcb57$var$_default = module.exports.default = $a26f686822ffcb57$var$ChevronDownIcon;

});
parcelRegister("408Sl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3eb2993a427b2667a5277a7a906fec96>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e9e0bfcb4a1c4e0$var$_react = $2e9e0bfcb4a1c4e0$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $2e9e0bfcb4a1c4e0$var$_UNSAFE_baseNew = $2e9e0bfcb4a1c4e0$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $2e9e0bfcb4a1c4e0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2e9e0bfcb4a1c4e0$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $2e9e0bfcb4a1c4e0$var$_react.default.createElement($2e9e0bfcb4a1c4e0$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 4.5 8.25 6.75 6 9 3.75 6.75 1.5 4.5"/>`,
        type: "utility"
    }, props));
$2e9e0bfcb4a1c4e0$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $2e9e0bfcb4a1c4e0$var$_default = module.exports.default = $2e9e0bfcb4a1c4e0$var$ChevronDownIcon;

});


parcelRegister("9nixN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d34a580b7cb0a9c$var$_react = $6d34a580b7cb0a9c$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $6d34a580b7cb0a9c$var$_chevronRight = $6d34a580b7cb0a9c$var$_interopRequireDefault((parcelRequire("8zVHJ")));
function $6d34a580b7cb0a9c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6d34a580b7cb0a9c$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $6d34a580b7cb0a9c$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M10.294 9.698a.99.99 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .99.99 0 0 1 0-1.407l2.318-2.297z"/></svg>`
    }, props, {
        newIcon: $6d34a580b7cb0a9c$var$_chevronRight.default,
        iconType: "utility"
    }));
$6d34a580b7cb0a9c$var$ChevronRightIcon.displayName = "ChevronRightIcon";
var $6d34a580b7cb0a9c$var$_default = module.exports.default = $6d34a580b7cb0a9c$var$ChevronRightIcon;

});

parcelRegister("dptzI", function(module, exports) {

$parcel$export(module.exports, "PanelWrapper", function () { return $9c348d224f31cf97$export$f537a9b13aef4d02; });
$parcel$export(module.exports, "ButtonWrapper", function () { return $9c348d224f31cf97$export$d53c836cccbb0d90; });
$parcel$export(module.exports, "PanelHeader", function () { return $9c348d224f31cf97$export$968713404ca1c9aa; });

var $hlgjl = parcelRequire("hlgjl");

var $bkLEO = parcelRequire("bkLEO");

var $13MK1 = parcelRequire("13MK1");

var $jp7ng = parcelRequire("jp7ng");
var $9c348d224f31cf97$var$_templateObject, $9c348d224f31cf97$var$_templateObject2, $9c348d224f31cf97$var$_templateObject3, $9c348d224f31cf97$var$_templateObject4;
var $9c348d224f31cf97$var$transition = (0, $13MK1.css)($9c348d224f31cf97$var$_templateObject || ($9c348d224f31cf97$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n  transition: all 200ms ease-in-out;\n"
])));
var $9c348d224f31cf97$export$f537a9b13aef4d02 = (0, $13MK1.default).div($9c348d224f31cf97$var$_templateObject2 || ($9c348d224f31cf97$var$_templateObject2 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n  margin: 0 auto ",
    ";\n"
])), "var(--ds-space-200, 16px)");
var $9c348d224f31cf97$export$d53c836cccbb0d90 = (0, $13MK1.default).div($9c348d224f31cf97$var$_templateObject3 || ($9c348d224f31cf97$var$_templateObject3 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n  left: 0;\n  line-height: 0;\n  opacity: ",
    ";\n  position: absolute;\n  ",
    ";\n\n  /* IE 11 needs these vertical positioning rules - the flexbox\n  behavior for absolute-positioned children is not up to spec.\n  https://googlechrome.github.io/samples/css-flexbox-abspos/ */\n  top: 50%;\n  transform: translateY(-50%);\n\n  button {\n    pointer-events: none;\n  }\n"
])), function(_ref) {
    var isHidden = _ref.isHidden;
    return isHidden ? 0 : 1;
}, $9c348d224f31cf97$var$transition);
var $9c348d224f31cf97$export$968713404ca1c9aa = (0, $bkLEO.withFocusWithin)((0, $13MK1.default).div($9c348d224f31cf97$var$_templateObject4 || ($9c348d224f31cf97$var$_templateObject4 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n  align-items: center;\n  background-color: ",
    ";\n  border-radius: ",
    ";\n  display: flex;\n  left: ",
    ";\n  margin-bottom: ",
    ";\n  margin-top: ",
    ";\n  padding: ",
    " ",
    "\n    ",
    " ",
    ";\n  position: relative;\n  ",
    ";\n  width: 100%;\n\n  ",
    " {\n    opacity: ",
    ";\n  }\n\n  &:hover {\n    background-color: ",
    ";\n    cursor: pointer;\n\n    ",
    " {\n      opacity: 1;\n    }\n  }\n"
])), function(props) {
    return props.isFocused && "var(--ds-surface-hovered, ".concat((0, $jp7ng).N20, ")");
}, "var(--ds-border-radius-100, 3px)", "var(--ds-space-negative-300, -24px)", "var(--ds-space-100, 8px)", "var(--ds-space-200, 16px)", "var(--ds-space-025, 2px)", "var(--ds-space-0, 0px)", "var(--ds-space-025, 2px)", "var(--ds-space-300, 24px)", $9c348d224f31cf97$var$transition, $9c348d224f31cf97$export$d53c836cccbb0d90, function(props) {
    return props.isFocused && 1;
}, "var(--ds-surface-hovered, ".concat((0, $jp7ng).N20, ")"), $9c348d224f31cf97$export$d53c836cccbb0d90));

});
parcelRegister("bkLEO", function(module, exports) {

$parcel$export(module.exports, "withFocusWithin", function () { return $840687b6c0fa319b$export$8f948f5f95d79771; });

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");
var $840687b6c0fa319b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $840687b6c0fa319b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $840687b6c0fa319b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $840687b6c0fa319b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $840687b6c0fa319b$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $840687b6c0fa319b$export$8f948f5f95d79771(Component) {
    var WrappedComponent = function WrappedComponent(_ref) {
        var onFocus = _ref.onFocus, onBlur = _ref.onBlur, props = $840687b6c0fa319b$var$_objectWithoutProperties(_ref, [
            "onFocus",
            "onBlur"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($840687b6c0fa319b$export$82877d664acccfa5, {
            onFocus: onFocus,
            onBlur: onBlur
        }, function(_ref2) {
            var getFocusProps = _ref2.getFocusProps, isFocused = _ref2.isFocused;
            return typeof Component === "string" ? (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Component, getFocusProps(props)) : (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Component, $840687b6c0fa319b$var$_extends({}, getFocusProps(props), {
                isFocused: isFocused
            }));
        });
    };
    WrappedComponent.displayName = "WithFocusWithin(" + (Component.displayName || Component.name || "Component") + ")";
    return WrappedComponent;
}
var $840687b6c0fa319b$export$82877d664acccfa5 = function(_React$Component) {
    $840687b6c0fa319b$var$_inherits(FocusWithin, _React$Component);
    function FocusWithin() {
        var _temp, _this, _ret;
        $840687b6c0fa319b$var$_classCallCheck(this, FocusWithin);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $840687b6c0fa319b$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), $840687b6c0fa319b$var$_initialiseProps.call(_this), _temp), $840687b6c0fa319b$var$_possibleConstructorReturn(_this, _ret);
    }
    // delay by one turn of the event loop, used to consolidate timing between
    // FocusWithin events and native events
    // track mouse activity within the FocusWithin container, which allows clicking inside it
    // whenever a mousedown occurs we save the current container element, and if on mouseup
    // we are outside the container, we emit the blur event appropriately
    // mouseups can still occur outside the container with actual DOM focus remaining within
    // so we do not emit blurs for those
    FocusWithin.prototype.componentDidMount = function componentDidMount() {
        document.addEventListener("mouseup", this.onDocumentMouseUp);
    };
    FocusWithin.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
        var _this2 = this;
        if (prevState.isFocused && !this.state.isFocused) this.delay(function() {
            if (_this2.isUnmounted) return;
            _this2.setState({
                isBlurring: false
            });
            // check if the focus manager is actually blurred for times
            // when document click causes a consective blur -> focus
            if (!_this2.state.isFocused) _this2.props.onBlur({
                __isFocusWithinEvent: true
            });
        });
        // check if the focus manager was focused from the outside
        // and not from another child element
        // delay onfocus emission to be on the same timing as blur events
        if (!this.state.isBlurring && !prevState.isFocused && this.state.isFocused) this.delay(this.props.onFocus, {
            __isFocusWithinEvent: true
        });
    };
    FocusWithin.prototype.componentWillUnmount = function componentWillUnmount() {
        this.isUnmounted = true;
        document.removeEventListener("mouseup", this.onDocumentMouseUp);
    };
    FocusWithin.prototype.render = function render() {
        return this.props.children ? this.props.children({
            focusProps: this.getFocusProps(),
            getFocusProps: this.getFocusProps,
            // stabilize isFocused so that it only changes corresponding to its event emissions
            isFocused: this.state.isFocused || this.state.isBlurring
        }) : null;
    };
    return FocusWithin;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component);
$840687b6c0fa319b$export$82877d664acccfa5.propTypes = {
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
    onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func
};
$840687b6c0fa319b$export$82877d664acccfa5.defaultProps = {
    onBlur: function onBlur() {},
    onFocus: function onFocus() {}
};
$840687b6c0fa319b$export$82877d664acccfa5.wrapComponent = $840687b6c0fa319b$export$8f948f5f95d79771;
var $840687b6c0fa319b$var$_initialiseProps = function _initialiseProps() {
    var _this3 = this;
    this.state = {
        isBlurring: false,
        isFocused: false
    };
    this.delay = function(cb) {
        for(var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return setTimeout(function() {
            if (_this3.isUnmounted) return;
            cb.apply(undefined, args);
        });
    };
    this.setFocusState = function(isFocused, isFocusWithinEvent) {
        var setStateCb = function setStateCb() {
            if (_this3.isUnmounted) return;
            _this3.setState(function(state) {
                return state.isFocused === isFocused ? state : !isFocused ? {
                    isFocused: isFocused,
                    isBlurring: true
                } : {
                    isFocused: isFocused
                };
            });
        };
        // delay processing native events for one turn of the event loop
        // to have it be on the same timing as FocusWithin events
        if (isFocusWithinEvent) setStateCb();
        else _this3.delay(setStateCb);
    };
    this.onDocumentMouseUp = function(event) {
        var container = _this3.mouseDownWithinTarget;
        var mouseUpWithinTarget = container && container.contains(event.target);
        var activeElementWithinTarget = container && container.contains(document.activeElement);
        if (!activeElementWithinTarget && !mouseUpWithinTarget) _this3.setFocusState(false, _this3.lastBlurEvent ? _this3.lastBlurEvent.__isFocusWithinEvent : true);
        _this3.mouseDownWithinTarget = null;
        _this3.lastBlurEvent = null;
    };
    this.getFocusProps = function() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _onFocus = _ref3.onFocus, _onBlur = _ref3.onBlur, _onMouseDown = _ref3.onMouseDown, props = $840687b6c0fa319b$var$_objectWithoutProperties(_ref3, [
            "onFocus",
            "onBlur",
            "onMouseDown"
        ]);
        return $840687b6c0fa319b$var$_extends({}, props, {
            onFocus: function onFocus(event) {
                var propagationStopped = _onFocus && _onFocus(event) === false;
                if (propagationStopped || event && event.focusWithinDefaultPrevented) return;
                _this3.setFocusState(true, event && event.__isFocusWithinEvent);
            },
            onBlur: function onBlur(event) {
                var propagationStopped = _onBlur && _onBlur(event) === false;
                if (propagationStopped || event && event.focusWithinDefaultPrevented) return;
                // if blur event happens right after a mousedown of an element inside the FocusWithin container
                // we don't emit the blur event immediately and check if we should emit it later after the mouseup occurs
                if (_this3.mouseDownWithinTarget) {
                    event.persist && event.persist();
                    _this3.lastBlurEvent = event;
                    return;
                }
                _this3.setFocusState(false, event && event.__isFocusWithinEvent);
            },
            onMouseDown: function onMouseDown(event) {
                var propagationStopped = _onMouseDown && _onMouseDown(event) === false;
                if (propagationStopped || event && event.focusWithinDefaultPrevented) return;
                _this3.mouseDownWithinTarget = event.currentTarget;
            }
        });
    };
};
var $840687b6c0fa319b$export$2e2bcd8739ae039 = $840687b6c0fa319b$export$82877d664acccfa5;

});






parcelRegister("l8rpz", function(module, exports) {

$parcel$export(module.exports, "RelativeDate", function () { return (parcelRequire("eQRm3")).default; });
$parcel$export(module.exports, "relativeDateString", function () { return (parcelRequire("eQRm3")).relativeDateString; });
$parcel$export(module.exports, "ISODate", function () { return (parcelRequire("3oLk8")).default; });
$parcel$export(module.exports, "oneDay", function () { return (parcelRequire("dUPSr")).oneDay; });

var $eQRm3 = parcelRequire("eQRm3");

var $3oLk8 = parcelRequire("3oLk8");

var $dUPSr = parcelRequire("dUPSr");

});
parcelRegister("eQRm3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69da091b3b28d2da$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "relativeDateString", function () { return $69da091b3b28d2da$export$74c9d4c712fdbc91; });

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $dUPSr = parcelRequire("dUPSr");

var $3oLk8 = parcelRequire("3oLk8");
class $69da091b3b28d2da$var$RelativeDate extends (0, $9nHZC.PureComponent) {
    render() {
        const { intl: intl } = this.props;
        const date = (0, $dUPSr.getNonFuture)(this.props.date);
        return (0, $dUPSr.differenceInDays)(date) > 7 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3oLk8.default), {
            date: date
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", {
            title: intl.formatDate(date, (0, $dUPSr.localeFormat))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedRelative), {
            value: date
        }));
    }
}
var $69da091b3b28d2da$export$2e2bcd8739ae039 = (0, $agjvf.injectIntl)($69da091b3b28d2da$var$RelativeDate);
function $69da091b3b28d2da$export$74c9d4c712fdbc91(date, intl) {
    if (!date) return "";
    const adjustedDate = (0, $dUPSr.getNonFuture)(date);
    return (0, $dUPSr.differenceInDays)(adjustedDate) > 7 ? (0, $3oLk8.ISODateString)(adjustedDate) : intl.formatRelative(adjustedDate);
}

});
parcelRegister("dUPSr", function(module, exports) {

$parcel$export(module.exports, "oneDay", function () { return $a80b4066739468e1$export$9137ac55187b996d; });
$parcel$export(module.exports, "getNonFuture", function () { return $a80b4066739468e1$export$a923e19694f17aec; });
$parcel$export(module.exports, "differenceInDays", function () { return $a80b4066739468e1$export$86415ebf4eb36b8c; });
$parcel$export(module.exports, "getISODate", function () { return $a80b4066739468e1$export$710a62793fa7376f; });
$parcel$export(module.exports, "localeFormat", function () { return $a80b4066739468e1$export$44c27b4a4876713; });
const $a80b4066739468e1$var$HYPHEN_MINUS = "-";
const $a80b4066739468e1$export$9137ac55187b996d = 86400000;
const $a80b4066739468e1$export$dd66cdeda7f0ab14 = (timeStamp)=>{
    if (timeStamp instanceof Date) return timeStamp;
    if (typeof timeStamp === "number") return new Date(timeStamp);
    return new Date(timeStamp.toString());
};
const $a80b4066739468e1$export$a923e19694f17aec = (timeStamp)=>{
    const date = $a80b4066739468e1$export$dd66cdeda7f0ab14(timeStamp);
    const now = new Date();
    if (date > now) return now;
    return date;
};
const $a80b4066739468e1$export$86415ebf4eb36b8c = (timeStamp, relativeTo = Date.now())=>{
    // convert the Date returned by convertToDate to a number for arithmitic
    const difference = relativeTo - Number($a80b4066739468e1$export$dd66cdeda7f0ab14(timeStamp));
    return difference / $a80b4066739468e1$export$9137ac55187b996d;
};
const $a80b4066739468e1$var$addPadding = (paddingToAdd)=>paddingToAdd < 10 ? `0${paddingToAdd}` : `${paddingToAdd}`;
const $a80b4066739468e1$export$710a62793fa7376f = (dt)=>[
        $a80b4066739468e1$var$addPadding(dt.getFullYear()),
        $a80b4066739468e1$var$addPadding(dt.getMonth() + 1),
        $a80b4066739468e1$var$addPadding(dt.getDate())
    ].join($a80b4066739468e1$var$HYPHEN_MINUS);
const $a80b4066739468e1$export$44c27b4a4876713 = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    timeZoneName: "short"
};

});

parcelRegister("3oLk8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01e2ef87b0c6246b$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ISODateString", function () { return $01e2ef87b0c6246b$export$3f33f969a95d6fb8; });

var $9nHZC = parcelRequire("9nHZC");

var $2vImn = parcelRequire("2vImn");

var $agjvf = parcelRequire("agjvf");

var $dUPSr = parcelRequire("dUPSr");
// @ts-ignore TODO: fix noImplicitAny error here
const $01e2ef87b0c6246b$var$isNaN = (obj)=>obj !== obj; // eslint-disable-line no-self-compare
var $01e2ef87b0c6246b$export$2e2bcd8739ae039 = (0, $agjvf.injectIntl)(class ISODate extends (0, $9nHZC.PureComponent) {
    render() {
        const { intl: intl, date: date } = this.props;
        const dt = typeof date === "string" ? (0, $2vImn.default)(new Date(date)) : date;
        // check if valid Date
        if ($01e2ef87b0c6246b$var$isNaN(dt.getTime())) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("time", {
            dateTime: String((0, $dUPSr.getISODate)(dt)),
            title: intl.formatDate(dt, (0, $dUPSr.localeFormat))
        }, (0, $dUPSr.getISODate)(dt));
    }
});
function $01e2ef87b0c6246b$export$3f33f969a95d6fb8(date) {
    const dt = typeof date === "string" ? (0, $2vImn.default)(new Date(date)) : date;
    if ($01e2ef87b0c6246b$var$isNaN(dt.getTime())) return "";
    return (0, $dUPSr.getISODate)(dt);
}

});



parcelRegister("oyaJz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $974f5e48c686c8bc$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $aP6k3 = parcelRequire("aP6k3");

var $E0drA = parcelRequire("E0drA");
const $974f5e48c686c8bc$var$NameCell = /*#__PURE__*/ (0, $9nHZC.memo)(({ avatar: avatar, name: name, additionalInfo: additionalInfo, padding: padding = (0, $aP6k3.gridSize)() / 2 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $E0drA.NameCellContainer), {
        padding: padding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $E0drA.NameCellAvatar), null, avatar), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $E0drA.NameCellText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", null, name), additionalInfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("small", null, additionalInfo)))));
var $974f5e48c686c8bc$export$2e2bcd8739ae039 = $974f5e48c686c8bc$var$NameCell;

});
parcelRegister("E0drA", function(module, exports) {

$parcel$export(module.exports, "NameCellContainer", function () { return $4aea65557520efb2$export$daa2910b26841f4a; });
$parcel$export(module.exports, "NameCellAvatar", function () { return $4aea65557520efb2$export$394fe38cf09d7a67; });
$parcel$export(module.exports, "NameCellText", function () { return $4aea65557520efb2$export$4eb30684bae33fc3; });

var $2xJU3 = parcelRequire("2xJU3");

var $aP6k3 = parcelRequire("aP6k3");
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */ function $4aea65557520efb2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4aea65557520efb2$export$daa2910b26841f4a = (0, $2xJU3.default)("div", {
    target: "etd0pfc0"
})("display:flex;padding:", (props)=>props.padding, "px;align-items:center;&:hover,&:focus{cursor:default;}");
const $4aea65557520efb2$export$394fe38cf09d7a67 = (0, $2xJU3.default)("div", {
    target: "etd0pfc1"
})("margin-right:", (0, $aP6k3.gridSize)(), "px;");
const $4aea65557520efb2$export$4eb30684bae33fc3 = (0, $2xJU3.default)("div", {
    target: "etd0pfc2"
})({
    name: "zg1vud",
    styles: "display:flex;flex-direction:column;justify-content:center;"
});

});


parcelRegister("dyEnO", function(module, exports) {

$parcel$export(module.exports, "useFlag", function () { return $447001650a3c64df$export$983b9b54330812cb; });

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("dGzLf");
var $eeHDY = parcelRequire("eeHDY");
parcelRequire("hw8PW");
var $7JtYi = parcelRequire("7JtYi");
var $hw8PW = parcelRequire("hw8PW");

var $2kKDW = parcelRequire("2kKDW");

var $h3kk7 = parcelRequire("h3kk7");

var $2oo57 = parcelRequire("2oo57");
const $447001650a3c64df$var$extractTextContent = (description)=>{
    if (typeof description === "string" || "msg" in description) return description;
    return {
        msg: description
    };
};
/**
 *  Show a predefined flag with the given type, description, title, and coloredAppearance
 * @param type - The type of flag: error | info | normal | success | warning
 * @param description - The message in the body of the flag
 * @param title - [optional] The title at the top of the flag
 * @param coloredAppearance - [optional] Whether the flag should have a colored appearance based on its' type
 */ const $447001650a3c64df$var$showPredefinedFlag = (type, description, title, coloredAppearance)=>(0, $2kKDW.showFlag)({
        id: `flags-hook-${type}`,
        title: title ? $447001650a3c64df$var$extractTextContent(title) : {
            msg: (0, $2oo57.default)[type]
        },
        description: $447001650a3c64df$var$extractTextContent(description),
        iconType: type,
        coloredAppearance: coloredAppearance,
        autoDismiss: true
    });
const $447001650a3c64df$export$983b9b54330812cb = ({ enableForPdvs: enableForPdvs = false } = {})=>{
    const dispatch = (0, $eeHDY.useDispatch)();
    const storageKey = `is-pdv-bot`;
    const [data, setData] = (0, $9nHZC.useState)(null);
    (0, $9nHZC.useEffect)(()=>{
        const fetchData = async ()=>{
            const result = await (0, $h3kk7.default).get(storageKey);
            setData(result);
        };
        fetchData();
    }, [
        storageKey
    ]);
    const dispatchWrapper = (0, $9nHZC.useCallback)((fn)=>(...args)=>{
            if (!enableForPdvs && data === 1) return;
            dispatch(fn(...args));
        }, [
        dispatch,
        data,
        enableForPdvs
    ]);
    const isDefaultDisableFlagsForPdvsEnabled = (0, $hw8PW.useFeature)((0, $7JtYi.FeatureKeys).isDefaultDisableFlagsForPdvsEnabled, false);
    const flagActions = (0, $9nHZC.useMemo)(()=>{
        if (isDefaultDisableFlagsForPdvsEnabled) return {
            dismissFlag: dispatchWrapper((flagId)=>(0, $2kKDW.dismissFlag)(flagId)),
            showFlag: dispatchWrapper((flag)=>(0, $2kKDW.showFlag)(flag)),
            showFlagComponent: dispatchWrapper((id)=>(0, $2kKDW.showFlagComponent)(id)),
            showErrorFlag: dispatchWrapper((description, title, coloredAppearance)=>$447001650a3c64df$var$showPredefinedFlag("error", description, title, coloredAppearance)),
            showInfoFlag: dispatchWrapper((description, title, coloredAppearance)=>$447001650a3c64df$var$showPredefinedFlag("info", description, title, coloredAppearance)),
            showNormalFlag: dispatchWrapper((description, title, coloredAppearance)=>$447001650a3c64df$var$showPredefinedFlag("normal", description, title, coloredAppearance)),
            showSuccessFlag: dispatchWrapper((description, title, coloredAppearance)=>$447001650a3c64df$var$showPredefinedFlag("success", description, title, coloredAppearance)),
            showWarningFlag: dispatchWrapper((description, title, coloredAppearance)=>$447001650a3c64df$var$showPredefinedFlag("warning", description, title, coloredAppearance))
        };
        else return {
            dismissFlag: (flagId)=>dispatch((0, $2kKDW.dismissFlag)(flagId)),
            showFlag: (flag)=>dispatch((0, $2kKDW.showFlag)(flag)),
            showFlagComponent: (id)=>dispatch((0, $2kKDW.showFlagComponent)(id)),
            showErrorFlag: (description, title, coloredAppearance)=>dispatch($447001650a3c64df$var$showPredefinedFlag("error", description, title, coloredAppearance)),
            showInfoFlag: (description, title, coloredAppearance)=>dispatch($447001650a3c64df$var$showPredefinedFlag("info", description, title, coloredAppearance)),
            showNormalFlag: (description, title, coloredAppearance)=>dispatch($447001650a3c64df$var$showPredefinedFlag("normal", description, title, coloredAppearance)),
            showSuccessFlag: (description, title, coloredAppearance)=>dispatch($447001650a3c64df$var$showPredefinedFlag("success", description, title, coloredAppearance)),
            showWarningFlag: (description, title, coloredAppearance)=>dispatch($447001650a3c64df$var$showPredefinedFlag("warning", description, title, coloredAppearance))
        };
    }, [
        dispatchWrapper,
        isDefaultDisableFlagsForPdvsEnabled,
        dispatch
    ]);
    return flagActions;
};

});
parcelRegister("2kKDW", function(module, exports) {

$parcel$export(module.exports, "dismissFlag", function () { return $0a9065cf30196cfc$export$900a08a292ad23cd; });
$parcel$export(module.exports, "showFlag", function () { return $0a9065cf30196cfc$export$e12b2cc6b75b006b; });
$parcel$export(module.exports, "showFlagComponent", function () { return $0a9065cf30196cfc$export$c8ee44c0447f4707; });
$parcel$export(module.exports, "reducer", function () { return $0a9065cf30196cfc$export$1650419e431d3ba3; });
const $0a9065cf30196cfc$export$1eb56620df104bf = "flags/DISMISS_FLAG";
const $0a9065cf30196cfc$export$73323a432c922a0b = "flags/SHOW_FLAG";
const $0a9065cf30196cfc$export$900a08a292ad23cd = (flagId)=>({
        type: $0a9065cf30196cfc$export$1eb56620df104bf,
        payload: {
            id: flagId
        }
    });
const $0a9065cf30196cfc$export$499f84f972ea2582 = (flagId)=>({
        type: $0a9065cf30196cfc$export$1eb56620df104bf,
        payload: {
            id: flagId,
            updateSeenState: false
        }
    });
const $0a9065cf30196cfc$export$e12b2cc6b75b006b = (flag)=>({
        type: $0a9065cf30196cfc$export$73323a432c922a0b,
        payload: {
            flag: {
                ...flag,
                type: "simple"
            }
        }
    });
const $0a9065cf30196cfc$export$c8ee44c0447f4707 = (id, flag)=>({
        type: $0a9065cf30196cfc$export$73323a432c922a0b,
        payload: {
            flag: {
                ...flag,
                type: "component",
                id: id
            }
        }
    });
// Reducer
const $0a9065cf30196cfc$var$initialState = [];
const $0a9065cf30196cfc$export$1650419e431d3ba3 = (state = $0a9065cf30196cfc$var$initialState, action)=>{
    switch(action.type){
        case "global/LOAD_SUCCESS":
            {
                const serverFlags = action.payload.result.flags || [];
                const flags = state.slice();
                // @ts-ignore TODO: fix noImplicitAny error here
                serverFlags.forEach((flag)=>{
                    const flagIndex = flags.findIndex((f)=>f.id === flag.id);
                    const flagExists = flagIndex !== -1;
                    // If the flag from the server does not exist, add it
                    if (!flagExists) flags.push(flag);
                    // If the flag to be added already exists, update its content
                    if (flagExists) flags[flagIndex] = flag;
                });
                return flags;
            }
        case $0a9065cf30196cfc$export$73323a432c922a0b:
            {
                const { flag: flag } = action.payload;
                const flags = state.slice();
                const flagIndex = flags.findIndex((f)=>f.id === flag.id);
                const flagExists = flagIndex !== -1;
                // If the flag to be added does not exist, add it
                if (!flagExists) flags.unshift(flag);
                // If the flag to be added already exists, update its content
                if (flagExists) flags[flagIndex] = flag;
                return flags;
            }
        case $0a9065cf30196cfc$export$1eb56620df104bf:
            {
                const { id: id } = action.payload;
                const flags = state.slice();
                const flagIndex = flags.findIndex((f)=>f.id === id);
                const flagExists = flagIndex !== -1;
                // If the flag to be removed doesn't exist, exit early and ignore the action
                if (!flagExists) return state;
                // If the flag to be removed exists, remove it
                if (flagExists) flags.splice(flagIndex, 1);
                return flags;
            }
        default:
            return state;
    }
};

});

parcelRegister("h3kk7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae40887f46361780$export$2e2bcd8739ae039; });
// @ts-ignore TODO: fix noImplicitAny error here

var $4roBt = parcelRequire("4roBt");

var $lc9PU = parcelRequire("lc9PU");

var $djvZK = parcelRequire("djvZK");

var $cNjxz = parcelRequire("cNjxz");
// memoryStorage is a fallback if for some reason localStorage doesn't work (e.g. in some browser's private mode).
// Without the fallback, "this.storage is undefined" can happen when we try to use the store.
const $ae40887f46361780$var$storages = [
    (0, (/*@__PURE__*/$parcel$interopDefault($djvZK))),
    (0, (/*@__PURE__*/$parcel$interopDefault($cNjxz)))
];
// @ts-ignore TODO: fix noImplicitAny error here
const $ae40887f46361780$var$plugins = [
    (0, (/*@__PURE__*/$parcel$interopDefault($4roBt)))
];
var // @ts-ignore TODO: fix noImplicitAny error here
$ae40887f46361780$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($lc9PU))).createStore($ae40887f46361780$var$storages, $ae40887f46361780$var$plugins);

});
parcelRegister("4roBt", function(module, exports) {
var $33bcc4c5da34cb63$var$namespace = "expire_mixin";
module.exports = $33bcc4c5da34cb63$var$expirePlugin;
function $33bcc4c5da34cb63$var$expirePlugin() {
    var expirations = this.createStore(this.storage, null, this._namespacePrefix + $33bcc4c5da34cb63$var$namespace);
    return {
        set: expire_set,
        get: expire_get,
        remove: expire_remove,
        getExpiration: getExpiration,
        removeExpiredKeys: removeExpiredKeys
    };
    function expire_set(super_fn, key, val, expiration) {
        if (!this.hasNamespace($33bcc4c5da34cb63$var$namespace)) expirations.set(key, expiration);
        return super_fn();
    }
    function expire_get(super_fn, key) {
        if (!this.hasNamespace($33bcc4c5da34cb63$var$namespace)) _checkExpiration.call(this, key);
        return super_fn();
    }
    function expire_remove(super_fn, key) {
        if (!this.hasNamespace($33bcc4c5da34cb63$var$namespace)) expirations.remove(key);
        return super_fn();
    }
    function getExpiration(_, key) {
        return expirations.get(key);
    }
    function removeExpiredKeys(_) {
        var keys = [];
        this.each(function(val, key) {
            keys.push(key);
        });
        for(var i = 0; i < keys.length; i++)_checkExpiration.call(this, keys[i]);
    }
    function _checkExpiration(key) {
        var expiration = expirations.get(key, Number.MAX_VALUE);
        if (expiration <= new Date().getTime()) {
            this.raw.remove(key);
            expirations.remove(key);
        }
    }
}

});

parcelRegister("lc9PU", function(module, exports) {

var $kW2yi = parcelRequire("kW2yi");
var $f6e259420e0f2eb7$var$slice = $kW2yi.slice;
var $f6e259420e0f2eb7$var$pluck = $kW2yi.pluck;
var $f6e259420e0f2eb7$var$each = $kW2yi.each;
var $f6e259420e0f2eb7$var$bind = $kW2yi.bind;
var $f6e259420e0f2eb7$var$create = $kW2yi.create;
var $f6e259420e0f2eb7$var$isList = $kW2yi.isList;
var $f6e259420e0f2eb7$var$isFunction = $kW2yi.isFunction;
var $f6e259420e0f2eb7$var$isObject = $kW2yi.isObject;
module.exports = {
    createStore: $f6e259420e0f2eb7$var$createStore
};
var $f6e259420e0f2eb7$var$storeAPI = {
    version: "2.0.12",
    enabled: false,
    // get returns the value of the given key. If that value
    // is undefined, it returns optionalDefaultValue instead.
    get: function(key, optionalDefaultValue) {
        var data = this.storage.read(this._namespacePrefix + key);
        return this._deserialize(data, optionalDefaultValue);
    },
    // set will store the given value at key and returns value.
    // Calling set with value === undefined is equivalent to calling remove.
    set: function(key, value) {
        if (value === undefined) return this.remove(key);
        this.storage.write(this._namespacePrefix + key, this._serialize(value));
        return value;
    },
    // remove deletes the key and value stored at the given key.
    remove: function(key) {
        this.storage.remove(this._namespacePrefix + key);
    },
    // each will call the given callback once for each key-value pair
    // in this store.
    each: function(callback) {
        var self = this;
        this.storage.each(function(val, namespacedKey) {
            callback.call(self, self._deserialize(val), (namespacedKey || "").replace(self._namespaceRegexp, ""));
        });
    },
    // clearAll will remove all the stored key-value pairs in this store.
    clearAll: function() {
        this.storage.clearAll();
    },
    // additional functionality that can't live in plugins
    // ---------------------------------------------------
    // hasNamespace returns true if this store instance has the given namespace.
    hasNamespace: function(namespace) {
        return this._namespacePrefix == "__storejs_" + namespace + "_";
    },
    // createStore creates a store.js instance with the first
    // functioning storage in the list of storage candidates,
    // and applies the the given mixins to the instance.
    createStore: function() {
        return $f6e259420e0f2eb7$var$createStore.apply(this, arguments);
    },
    addPlugin: function(plugin) {
        this._addPlugin(plugin);
    },
    namespace: function(namespace) {
        return $f6e259420e0f2eb7$var$createStore(this.storage, this.plugins, namespace);
    }
};
function $f6e259420e0f2eb7$var$_warn() {
    var _console = typeof console == "undefined" ? null : console;
    if (!_console) return;
    var fn = _console.warn ? _console.warn : _console.log;
    fn.apply(_console, arguments);
}
function $f6e259420e0f2eb7$var$createStore(storages, plugins, namespace) {
    if (!namespace) namespace = "";
    if (storages && !$f6e259420e0f2eb7$var$isList(storages)) storages = [
        storages
    ];
    if (plugins && !$f6e259420e0f2eb7$var$isList(plugins)) plugins = [
        plugins
    ];
    var namespacePrefix = namespace ? "__storejs_" + namespace + "_" : "";
    var namespaceRegexp = namespace ? new RegExp("^" + namespacePrefix) : null;
    var legalNamespaces = /^[a-zA-Z0-9_\-]*$/ // alpha-numeric + underscore and dash
    ;
    if (!legalNamespaces.test(namespace)) throw new Error("store.js namespaces can only have alphanumerics + underscores and dashes");
    var _privateStoreProps = {
        _namespacePrefix: namespacePrefix,
        _namespaceRegexp: namespaceRegexp,
        _testStorage: function(storage) {
            try {
                var testStr = "__storejs__test__";
                storage.write(testStr, testStr);
                var ok = storage.read(testStr) === testStr;
                storage.remove(testStr);
                return ok;
            } catch (e) {
                return false;
            }
        },
        _assignPluginFnProp: function(pluginFnProp, propName) {
            var oldFn = this[propName];
            this[propName] = function pluginFn() {
                var args = $f6e259420e0f2eb7$var$slice(arguments, 0);
                var self = this;
                // super_fn calls the old function which was overwritten by
                // this mixin.
                function super_fn() {
                    if (!oldFn) return;
                    $f6e259420e0f2eb7$var$each(arguments, function(arg, i) {
                        args[i] = arg;
                    });
                    return oldFn.apply(self, args);
                }
                // Give mixing function access to super_fn by prefixing all mixin function
                // arguments with super_fn.
                var newFnArgs = [
                    super_fn
                ].concat(args);
                return pluginFnProp.apply(self, newFnArgs);
            };
        },
        _serialize: function(obj) {
            return JSON.stringify(obj);
        },
        _deserialize: function(strVal, defaultVal) {
            if (!strVal) return defaultVal;
            // It is possible that a raw string value has been previously stored
            // in a storage without using store.js, meaning it will be a raw
            // string value instead of a JSON serialized string. By defaulting
            // to the raw string value in case of a JSON parse error, we allow
            // for past stored values to be forwards-compatible with store.js
            var val = "";
            try {
                val = JSON.parse(strVal);
            } catch (e) {
                val = strVal;
            }
            return val !== undefined ? val : defaultVal;
        },
        _addStorage: function(storage) {
            if (this.enabled) return;
            if (this._testStorage(storage)) {
                this.storage = storage;
                this.enabled = true;
            }
        },
        _addPlugin: function(plugin) {
            var self = this;
            // If the plugin is an array, then add all plugins in the array.
            // This allows for a plugin to depend on other plugins.
            if ($f6e259420e0f2eb7$var$isList(plugin)) {
                $f6e259420e0f2eb7$var$each(plugin, function(plugin) {
                    self._addPlugin(plugin);
                });
                return;
            }
            // Keep track of all plugins we've seen so far, so that we
            // don't add any of them twice.
            var seenPlugin = $f6e259420e0f2eb7$var$pluck(this.plugins, function(seenPlugin) {
                return plugin === seenPlugin;
            });
            if (seenPlugin) return;
            this.plugins.push(plugin);
            // Check that the plugin is properly formed
            if (!$f6e259420e0f2eb7$var$isFunction(plugin)) throw new Error("Plugins must be function values that return objects");
            var pluginProperties = plugin.call(this);
            if (!$f6e259420e0f2eb7$var$isObject(pluginProperties)) throw new Error("Plugins must return an object of function properties");
            // Add the plugin function properties to this store instance.
            $f6e259420e0f2eb7$var$each(pluginProperties, function(pluginFnProp, propName) {
                if (!$f6e259420e0f2eb7$var$isFunction(pluginFnProp)) throw new Error("Bad plugin property: " + propName + " from plugin " + plugin.name + ". Plugins should only return functions.");
                self._assignPluginFnProp(pluginFnProp, propName);
            });
        },
        // Put deprecated properties in the private API, so as to not expose it to accidential
        // discovery through inspection of the store object.
        // Deprecated: addStorage
        addStorage: function(storage) {
            $f6e259420e0f2eb7$var$_warn("store.addStorage(storage) is deprecated. Use createStore([storages])");
            this._addStorage(storage);
        }
    };
    var store = $f6e259420e0f2eb7$var$create(_privateStoreProps, $f6e259420e0f2eb7$var$storeAPI, {
        plugins: []
    });
    store.raw = {};
    $f6e259420e0f2eb7$var$each(store, function(prop, propName) {
        if ($f6e259420e0f2eb7$var$isFunction(prop)) store.raw[propName] = $f6e259420e0f2eb7$var$bind(store, prop);
    });
    $f6e259420e0f2eb7$var$each(storages, function(storage) {
        store._addStorage(storage);
    });
    $f6e259420e0f2eb7$var$each(plugins, function(plugin) {
        store._addPlugin(plugin);
    });
    return store;
}

});
parcelRegister("kW2yi", function(module, exports) {
var $f3db3440b0fadc69$var$assign = $f3db3440b0fadc69$var$make_assign();
var $f3db3440b0fadc69$var$create = $f3db3440b0fadc69$var$make_create();
var $f3db3440b0fadc69$var$trim = $f3db3440b0fadc69$var$make_trim();
var $f3db3440b0fadc69$var$Global = typeof window !== "undefined" ? window : $parcel$global;
module.exports = {
    assign: $f3db3440b0fadc69$var$assign,
    create: $f3db3440b0fadc69$var$create,
    trim: $f3db3440b0fadc69$var$trim,
    bind: $f3db3440b0fadc69$var$bind,
    slice: $f3db3440b0fadc69$var$slice,
    each: $f3db3440b0fadc69$var$each,
    map: $f3db3440b0fadc69$var$map,
    pluck: $f3db3440b0fadc69$var$pluck,
    isList: $f3db3440b0fadc69$var$isList,
    isFunction: $f3db3440b0fadc69$var$isFunction,
    isObject: $f3db3440b0fadc69$var$isObject,
    Global: $f3db3440b0fadc69$var$Global
};
function $f3db3440b0fadc69$var$make_assign() {
    if (Object.assign) return Object.assign;
    else return function shimAssign(obj, props1, props2, etc) {
        for(var i = 1; i < arguments.length; i++)$f3db3440b0fadc69$var$each(Object(arguments[i]), function(val, key) {
            obj[key] = val;
        });
        return obj;
    };
}
function $f3db3440b0fadc69$var$make_create() {
    if (Object.create) return function create(obj, assignProps1, assignProps2, etc) {
        var assignArgsList = $f3db3440b0fadc69$var$slice(arguments, 1);
        return $f3db3440b0fadc69$var$assign.apply(this, [
            Object.create(obj)
        ].concat(assignArgsList));
    };
    else {
        function F() {} // eslint-disable-line no-inner-declarations
        return function create(obj, assignProps1, assignProps2, etc) {
            var assignArgsList = $f3db3440b0fadc69$var$slice(arguments, 1);
            F.prototype = obj;
            return $f3db3440b0fadc69$var$assign.apply(this, [
                new F()
            ].concat(assignArgsList));
        };
    }
}
function $f3db3440b0fadc69$var$make_trim() {
    if (String.prototype.trim) return function trim(str) {
        return String.prototype.trim.call(str);
    };
    else return function trim(str) {
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
    };
}
function $f3db3440b0fadc69$var$bind(obj, fn) {
    return function() {
        return fn.apply(obj, Array.prototype.slice.call(arguments, 0));
    };
}
function $f3db3440b0fadc69$var$slice(arr, index) {
    return Array.prototype.slice.call(arr, index || 0);
}
function $f3db3440b0fadc69$var$each(obj, fn) {
    $f3db3440b0fadc69$var$pluck(obj, function(val, key) {
        fn(val, key);
        return false;
    });
}
function $f3db3440b0fadc69$var$map(obj, fn) {
    var res = $f3db3440b0fadc69$var$isList(obj) ? [] : {};
    $f3db3440b0fadc69$var$pluck(obj, function(v, k) {
        res[k] = fn(v, k);
        return false;
    });
    return res;
}
function $f3db3440b0fadc69$var$pluck(obj, fn) {
    if ($f3db3440b0fadc69$var$isList(obj)) for(var i = 0; i < obj.length; i++){
        if (fn(obj[i], i)) return obj[i];
    }
    else {
        for(var key in obj)if (obj.hasOwnProperty(key)) {
            if (fn(obj[key], key)) return obj[key];
        }
    }
}
function $f3db3440b0fadc69$var$isList(val) {
    return val != null && typeof val != "function" && typeof val.length == "number";
}
function $f3db3440b0fadc69$var$isFunction(val) {
    return val && ({}).toString.call(val) === "[object Function]";
}
function $f3db3440b0fadc69$var$isObject(val) {
    return val && ({}).toString.call(val) === "[object Object]";
}

});


parcelRegister("djvZK", function(module, exports) {

var $kW2yi = parcelRequire("kW2yi");
var $9b15de37ac83ed5c$var$Global = $kW2yi.Global;
module.exports = {
    name: "localStorage",
    read: $9b15de37ac83ed5c$var$read,
    write: $9b15de37ac83ed5c$var$write,
    each: $9b15de37ac83ed5c$var$each,
    remove: $9b15de37ac83ed5c$var$remove,
    clearAll: $9b15de37ac83ed5c$var$clearAll
};
function $9b15de37ac83ed5c$var$localStorage() {
    return $9b15de37ac83ed5c$var$Global.localStorage;
}
function $9b15de37ac83ed5c$var$read(key) {
    return $9b15de37ac83ed5c$var$localStorage().getItem(key);
}
function $9b15de37ac83ed5c$var$write(key, data) {
    return $9b15de37ac83ed5c$var$localStorage().setItem(key, data);
}
function $9b15de37ac83ed5c$var$each(fn) {
    for(var i = $9b15de37ac83ed5c$var$localStorage().length - 1; i >= 0; i--){
        var key = $9b15de37ac83ed5c$var$localStorage().key(i);
        fn($9b15de37ac83ed5c$var$read(key), key);
    }
}
function $9b15de37ac83ed5c$var$remove(key) {
    return $9b15de37ac83ed5c$var$localStorage().removeItem(key);
}
function $9b15de37ac83ed5c$var$clearAll() {
    return $9b15de37ac83ed5c$var$localStorage().clear();
}

});

parcelRegister("cNjxz", function(module, exports) {
// memoryStorage is a useful last fallback to ensure that the store
// is functions (meaning store.get(), store.set(), etc will all function).
// However, stored values will not persist when the browser navigates to
// a new page or reloads the current page.
module.exports = {
    name: "memoryStorage",
    read: $950937f2d886e580$var$read,
    write: $950937f2d886e580$var$write,
    each: $950937f2d886e580$var$each,
    remove: $950937f2d886e580$var$remove,
    clearAll: $950937f2d886e580$var$clearAll
};
var $950937f2d886e580$var$memoryStorage = {};
function $950937f2d886e580$var$read(key) {
    return $950937f2d886e580$var$memoryStorage[key];
}
function $950937f2d886e580$var$write(key, data) {
    $950937f2d886e580$var$memoryStorage[key] = data;
}
function $950937f2d886e580$var$each(callback) {
    for(var key in $950937f2d886e580$var$memoryStorage)if ($950937f2d886e580$var$memoryStorage.hasOwnProperty(key)) callback($950937f2d886e580$var$memoryStorage[key], key);
}
function $950937f2d886e580$var$remove(key) {
    delete $950937f2d886e580$var$memoryStorage[key];
}
function $950937f2d886e580$var$clearAll(key) {
    $950937f2d886e580$var$memoryStorage = {};
}

});


parcelRegister("2oo57", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac1f6232e98e23c6$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $ac1f6232e98e23c6$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    success: {
        "id": "frontbucket.hooks.flag.success",
        "defaultMessage": "Success"
    },
    error: {
        "id": "frontbucket.hooks.flag.error",
        "defaultMessage": "Error"
    },
    info: {
        "id": "frontbucket.hooks.flag.info",
        "defaultMessage": "Important information"
    },
    warning: {
        "id": "frontbucket.hooks.flag.warning",
        "defaultMessage": "Warning"
    },
    normal: {
        "id": "frontbucket.hooks.flag.normal",
        "defaultMessage": "Attention"
    }
});

});


parcelRegister("1IvI9", function(module, exports) {

$parcel$export(module.exports, "useObjectState", function () { return $b3d9da576d1f69fe$export$64bcfd5faff4adc3; });

var $9nHZC = parcelRequire("9nHZC");
const $b3d9da576d1f69fe$export$64bcfd5faff4adc3 = (initialState)=>{
    const isMounted = (0, $9nHZC.useRef)(false);
    const [state, setState] = (0, $9nHZC.useState)(initialState);
    (0, $9nHZC.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    const setNextState = (0, $9nHZC.useCallback)((nextState)=>{
        if (isMounted.current) setState((prevState)=>{
            const futureState = typeof nextState === "function" ? nextState(prevState) : nextState;
            if (prevState === futureState) return prevState;
            return Object.assign({}, prevState, futureState);
        });
    }, []);
    return [
        state,
        setNextState
    ];
};

});

parcelRegister("aYcqR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5a821515abe9c61$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $c5a821515abe9c61$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    emailAddress: {
        "id": "frontbucket.workspace.settings.invitations.table.column.emailAddress",
        "defaultMessage": "Email address"
    },
    actions: {
        "id": "frontbucket.workspace.settings.invitations.table.column.actions",
        "defaultMessage": "Actions"
    },
    invitationsTableHeader: {
        "id": "frontbucket.workspace.settings.invitations.table.actions.invitationsTableHeader",
        "defaultMessage": "{count, plural, one {{count} invitation} other {{count} invitations}} pending"
    },
    resendInvitation: {
        "id": "frontbucket.workspace.settings.invitations.table.actions.resendInvitation",
        "defaultMessage": "Resend invitation"
    },
    invitationSent: {
        "id": "frontbucket.workspace.settings.invitations.table.actions.invitationSent",
        "defaultMessage": "invitation sent"
    },
    cancelInvitation: {
        "id": "frontbucket.workspace.settings.invitations.table.actions.cancelInvitation",
        "defaultMessage": "Cancel invitation"
    }
});

});

parcelRegister("kxoZJ", function(module, exports) {

$parcel$export(module.exports, "PanelWrapper", function () { return $a5e061cc349c4f80$export$f537a9b13aef4d02; });
$parcel$export(module.exports, "PanelHeader", function () { return $a5e061cc349c4f80$export$968713404ca1c9aa; });
$parcel$export(module.exports, "LozengeContainer", function () { return $a5e061cc349c4f80$export$d5aa9dc8584e2976; });

var $2xJU3 = parcelRequire("2xJU3");

var $jp7ng = parcelRequire("jp7ng");
var $aP6k3 = parcelRequire("aP6k3");

var $h39Sh = parcelRequire("h39Sh");
const $a5e061cc349c4f80$export$f537a9b13aef4d02 = (0, $2xJU3.default)("div", {
    target: "ea59m7z0"
})("margin-top:-", (0, $aP6k3.gridSize)() * 2, "px;padding-left:", (0, $aP6k3.gridSize)() * 2.5, "px;button{svg{color:", (0, $h39Sh.default)("color.text.information", (0, $jp7ng).B400), ";}}> div{margin:0 auto ", (0, $aP6k3.gridSize)(), "px;}table{margin-top:", (0, $aP6k3.gridSize)(), "px;}");
const $a5e061cc349c4f80$export$968713404ca1c9aa = (0, $2xJU3.default)("span", {
    target: "ea59m7z1"
})("color:", (0, $h39Sh.default)("color.text.information", (0, $jp7ng).B400), ";");
const $a5e061cc349c4f80$export$d5aa9dc8584e2976 = (0, $2xJU3.default)("span", {
    target: "ea59m7z2"
})("padding-left:", (0, $aP6k3.gridSize)(), "px;");

});

parcelRegister("3OyMe", function(module, exports) {

$parcel$export(module.exports, "getWorkspaceInvitations", function () { return $a73b7e082a7f0553$export$a97649b4ecde7a4b; });
$parcel$export(module.exports, "getProjectInvitations", function () { return $a73b7e082a7f0553$export$870cabad131a3a7b; });
$parcel$export(module.exports, "getRepositoryInvitations", function () { return $a73b7e082a7f0553$export$3219c4e5c51413b0; });
$parcel$export(module.exports, "sendWorkspaceInvitation", function () { return $a73b7e082a7f0553$export$5ae75e2497f98120; });
$parcel$export(module.exports, "sendProjectInvitation", function () { return $a73b7e082a7f0553$export$a682b01522e5b019; });
$parcel$export(module.exports, "sendRepoInvitation", function () { return $a73b7e082a7f0553$export$11cd7e293d5567; });
$parcel$export(module.exports, "deleteWorkspaceInvitation", function () { return $a73b7e082a7f0553$export$83725ad12e3dd263; });
$parcel$export(module.exports, "deleteProjectInvitation", function () { return $a73b7e082a7f0553$export$78adde5b0204ec3b; });
$parcel$export(module.exports, "deleteRepoInvitation", function () { return $a73b7e082a7f0553$export$d831d8759f752097; });

var $cuiOU = parcelRequire("cuiOU");

var $5WlOY = parcelRequire("5WlOY");

var $ksfVj = parcelRequire("ksfVj");

var $jzmnA = parcelRequire("jzmnA");
const $a73b7e082a7f0553$export$a97649b4ecde7a4b = (workspaceSlug)=>(0, $jzmnA.httpRequest)().get((0, $ksfVj.default).api.v10.invitations(workspaceSlug));
const $a73b7e082a7f0553$export$870cabad131a3a7b = (workspaceSlug, projectKey)=>(0, $jzmnA.httpRequest)({
        successTransformer: (data)=>data.values
    }).get((0, $cuiOU.default).api.internal.invitations(workspaceSlug, projectKey));
const $a73b7e082a7f0553$export$3219c4e5c51413b0 = (workspaceSlug, repoSlug)=>(0, $jzmnA.httpRequest)({
        successTransformer: (data)=>data.values
    }).get((0, $5WlOY.default).api.internal.invitations(workspaceSlug, repoSlug));
const $a73b7e082a7f0553$export$ac9c4c21768c6eaf = (workspaceSlug, repoSlug)=>(0, $jzmnA.httpRequest)().get((0, $5WlOY.default).api.v10.invitations(workspaceSlug, repoSlug));
const $a73b7e082a7f0553$export$5ae75e2497f98120 = (workspaceSlug, body)=>(0, $jzmnA.httpRequest)({
        successCustomHandler: ()=>null // this method returns "OK" on success.
    }).put((0, $ksfVj.default).api.v10.invitations(workspaceSlug), body);
const $a73b7e082a7f0553$export$a682b01522e5b019 = (workspaceSlug, projectKey, body)=>(0, $jzmnA.httpRequest)({
        successCustomHandler: ()=>null
    }).put((0, $cuiOU.default).api.internal.invitations(workspaceSlug, projectKey), body);
const $a73b7e082a7f0553$export$11cd7e293d5567 = (workspaceSlug, repoSlug, body)=>(0, $jzmnA.httpRequest)({
        successCustomHandler: ()=>null
    }).put((0, $5WlOY.default).api.internal.invitations(workspaceSlug, repoSlug), body);
const $a73b7e082a7f0553$export$3db022a79d0f859c = (workspaceSlug, repoSlug, body)=>(0, $jzmnA.httpRequest)({
        successCustomHandler: ()=>null
    }).post((0, $5WlOY.default).api.v10.invitations(workspaceSlug, repoSlug), body);
const $a73b7e082a7f0553$export$83725ad12e3dd263 = (workspaceSlug, body)=>(0, $jzmnA.httpRequest)().delete((0, $ksfVj.default).api.v10.invitations(workspaceSlug), body);
const $a73b7e082a7f0553$export$78adde5b0204ec3b = (workspaceSlug, projectKey, body)=>(0, $jzmnA.httpRequest)().delete((0, $cuiOU.default).api.internal.invitations(workspaceSlug, projectKey), body);
const $a73b7e082a7f0553$export$d831d8759f752097 = (workspaceSlug, repoSlug, body)=>(0, $jzmnA.httpRequest)().delete((0, $5WlOY.default).api.internal.invitations(workspaceSlug, repoSlug), body);
const $a73b7e082a7f0553$export$6a6e46b87f44bd58 = (workspaceSlug, repoSlug, body)=>(0, $jzmnA.httpRequest)().delete((0, $5WlOY.default).api.v10.invitations(workspaceSlug, repoSlug), body);

});
parcelRegister("5WlOY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efcc02932c941650$export$2e2bcd8739ae039; });
const $efcc02932c941650$var$urls = {
    api: {
        v10: {
            // v1 invitations URL can be removed once we remove UserAndGroupAccess
            // settings page and replace it with RepositoryPermissions settings page
            invitations: (workspaceSlug, repoSlug)=>`/!api/1.0/invitations/${workspaceSlug}/${repoSlug}`
        },
        internal: {
            navigation: (repositoryFullSlug)=>`/!api/internal/menu/repository/${repositoryFullSlug}`,
            invitations: (workspaceSlug, repoSlug)=>`/!api/internal/invitations/repositories/${workspaceSlug}/${repoSlug}`
        }
    }
};
var $efcc02932c941650$export$2e2bcd8739ae039 = $efcc02932c941650$var$urls;

});

parcelRegister("ksfVj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79249ea90b1aaa98$export$2e2bcd8739ae039; });

var $cJH1T = parcelRequire("cJH1T");

var $4lBFs = parcelRequire("4lBFs");

var $964rM = parcelRequire("964rM");
const $79249ea90b1aaa98$var$urls = {
    api: {
        internal: {
            create: `/!api/internal/workspaces/`,
            compass_banner_email_notification: (workspaceSlug)=>`/!api/internal/workspaces/${workspaceSlug}/compass-banner-email-notification`,
            RUD: (workspaceSlug)=>`/!api/internal/workspaces/${workspaceSlug}/`,
            changeAvatar: (slug)=>`/!api/internal/workspaces/${slug}/avatar`,
            getUserGroupAccess: (workspaceSlug, userUuid, options)=>{
                const url = `/!api/internal/workspaces/${workspaceSlug}/access/${userUuid}/groups`;
                return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(options, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
            },
            getUserRepoAccess: (workspaceSlug, userUuid, options)=>{
                const url = `/!api/internal/workspaces/${workspaceSlug}/access/${userUuid}/repos`;
                return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(options, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
            },
            inheritedPermissions: (workspaceSlug, options)=>{
                const url = `/!api/internal/inherited-workspace-privileges/${workspaceSlug}/`;
                if (options) return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(options, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
                return url;
            },
            defaultGroup: (workspaceSlug)=>`/!api/internal/workspaces/${workspaceSlug}/default-group`,
            groups: (workspaceSlug)=>`/!api/internal/workspaces/${workspaceSlug}/groups/`,
            group: (workspaceSlug, groupSlug)=>`/!api/internal/workspaces/${workspaceSlug}/groups/${groupSlug}`,
            atlassianIntelligence: (workspaceSlug)=>`/!api/internal/workspaces/${workspaceSlug}/atlassian-intelligence/`,
            mergeChecksActivation: (workspaceSlug)=>`/!api/internal/checks/workspaces/${workspaceSlug}/activate/`,
            plan: (workspaceSlug)=>`/!api/internal/workspaces/${workspaceSlug}/plan`,
            members: (workspaceSlug, options)=>{
                const { exclude_group: exclude_group, page: page, search: search, repoUuid: repoUuid, usersOnPlan: usersOnPlan } = options || {};
                const url = `/!api/internal/workspaces/${workspaceSlug}/members`;
                return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
                    exclude_group: exclude_group || undefined,
                    page: page || undefined,
                    search: search || undefined,
                    repo_id: repoUuid || undefined,
                    on_plan: usersOnPlan || undefined
                }, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
            },
            groupRepositoryPrivileges: (workspaceSlug, groupSlug, privacy, options)=>{
                let url = `/!api/internal/group-repo-privileges/${workspaceSlug}/${groupSlug}`;
                url = `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(options, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
                if (privacy) {
                    if (privacy === (0, $4lBFs.Privacy).public) url = `${url}&q=is_private=False`;
                    else url = `${url}&q=is_private=True`;
                }
                return url;
            },
            groupResourcePermissions: (workspaceSlug, groupSlug, privacy, options)=>{
                let url = `/!api/internal/group-resource-permissions/${workspaceSlug}/${groupSlug}`;
                url = `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(options, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
                if (privacy) {
                    if (privacy === (0, $4lBFs.Privacy).public) url = `${url}&q=is_private=False`;
                    else url = `${url}&q=is_private=True`;
                }
                return url;
            },
            groupMembers: (workspaceSlug, groupSlug, userUuid, options)=>{
                const url = `/!api/internal/workspaces/${workspaceSlug}/groups/${groupSlug}/members/${userUuid || ""}`;
                return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(options, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
            },
            groupsIndex: (workspaceSlug, options)=>{
                const url = `/!api/internal/workspaces/${workspaceSlug}/groups`;
                return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(options || {}, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
            },
            navigation: (workspaceSlug)=>`/!api/internal/menu/workspace/${workspaceSlug}`,
            forgeMenuItems: (workspaceSlug)=>`/!api/internal/workspaces/${workspaceSlug}/forge/menu-items/`,
            overviewViewState: (workspaceSlug)=>`/!api/internal/workspaces/${workspaceSlug}/overview-view-state`,
            pullRequests: (workspaceSlug)=>`/!api/internal/workspaces/${workspaceSlug}/pullrequests`,
            pullRequestBuildStatuses: (workspaceSlug)=>`/!api/internal/workspaces/${workspaceSlug}/commits/statuses`,
            userList: (workspaceSlug)=>`/!api/internal/workspaces/${workspaceSlug}/user-list`,
            userRepoPrivileges: (repoFullName, userUuid)=>`/!api/internal/privileges/${repoFullName}/${userUuid}/`,
            workspaceAccess: (workspaceSlug, userUuid)=>`/!api/internal/workspaces/${workspaceSlug}/access/${userUuid}`,
            getCompassCloudIdsForWorkspace: (workspaceSlug)=>{
                return `/!api/internal/workspaces/${workspaceSlug}/compass/workspace-connection`;
            },
            getCompassCloudIdsForRepository: (workspaceSlug, repositorySlug)=>{
                return `/!api/internal/repositories/${workspaceSlug}/${repositorySlug}/compass/workspace-connection`;
            }
        },
        v10: {
            groups: (workspaceSlug, groupSlug)=>`/!api/1.0/groups/${workspaceSlug}/${groupSlug}`,
            invitations: (workspaceSlug)=>`/!api/1.0/users/${workspaceSlug}/invitations`
        },
        v20: {
            get: (uuid)=>`/!api/2.0/workspaces${uuid ? `/${uuid}` : ""}`,
            projects: (workspaceSlugOrUuid, name)=>{
                const url = `/!api/2.0/workspaces/${workspaceSlugOrUuid}/projects`;
                if (name) {
                    const q = `name ~ "${(0, $964rM.default)(name)}"`;
                    return `${url}?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
                        q: q,
                        sort: "name"
                    }, {
                        skipNulls: true
                    })}`;
                }
                return url;
            },
            project: (workspaceSlugOrUuid, key)=>{
                const url = `/!api/2.0/workspaces/${workspaceSlugOrUuid}/projects/${key}`;
                return url;
            },
            repositories: (workspaceSlugOrUuid, options)=>{
                const { pagelen: pagelen, name: name, sort: sort } = options || {};
                const url = `/!api/2.0/repositories/${workspaceSlugOrUuid}`;
                const q = name ? `name~"${(0, $964rM.default)(name)}"` : null;
                return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
                    pagelen: pagelen,
                    q: q,
                    sort: sort || "name"
                }, {
                    skipNulls: true,
                    addQueryPrefix: true
                })}`;
            },
            members: (uuid)=>`/!api/2.0/workspaces/${uuid}/members`
        }
    },
    ui: {
        landing: (slug)=>`/${slug}`,
        overview: (slug)=>`/${slug}/workspace/overview`,
        getLinkToRepos: (slug)=>`/${slug}/workspace/repositories`,
        getLinkToGroup: (workspaceSlug, groupSlug, options)=>{
            const url = `/${workspaceSlug}/workspace/settings/groups/${groupSlug}`;
            return `${url}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(options, {
                skipNulls: true,
                addQueryPrefix: true
            })}`;
        },
        projectCreate: (workspaceSlug)=>`/account/projects/create${workspaceSlug ? `?workspace=${workspaceSlug}` : ""}`,
        permissions: (workspaceSlug)=>`/${workspaceSlug}/workspace/settings/permissions`,
        mergeChecks: (workspaceSlug)=>`/${workspaceSlug}/workspace/settings/merge-checks`
    },
    external: {
        contactUsLink: "https://support.atlassian.com/bitbucket-cloud/",
        changeWorkspaceIdDocsLink: "https://confluence.atlassian.com/x/hneeOQ",
        contactSupportLink: "https://support.atlassian.com/contact/#/?inquiry_category=technical_issues",
        troubleshootWorkspaceInvites: "https://support.atlassian.com/bitbucket-cloud/docs/grant-access-to-a-workspace/#Troubleshooting-member-invitations",
        deprecationNoticeLink: "https://community.atlassian.com/t5/Bitbucket-articles/Reminder-Deprecation-of-Legacy-Permissions/ba-p/2483614"
    },
    xhr: {
        addMemberToGroup: (workspaceSlug)=>`/${workspaceSlug}/workspace/settings/groups/xhr/add-member/`
    }
};
var $79249ea90b1aaa98$export$2e2bcd8739ae039 = $79249ea90b1aaa98$var$urls;

});
parcelRegister("4lBFs", function(module, exports) {

$parcel$export(module.exports, "Privacy", function () { return $859baa02f71f3a36$export$c5c352a5595119a5; });
$parcel$export(module.exports, "default", function () { return $859baa02f71f3a36$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $5WD8l = parcelRequire("5WD8l");
var $c83ir = parcelRequire("c83ir");
var $kMn2f = parcelRequire("kMn2f");

var $jajUg = parcelRequire("jajUg");

var $8Ipe5 = parcelRequire("8Ipe5");

var $6OIRF = parcelRequire("6OIRF");
var $859baa02f71f3a36$export$c5c352a5595119a5;
(function(Privacy) {
    Privacy["public"] = "public";
    Privacy["private"] = "private";
})($859baa02f71f3a36$export$c5c352a5595119a5 || ($859baa02f71f3a36$export$c5c352a5595119a5 = {}));
const $859baa02f71f3a36$var$PrivacyDropdown = ({ value: value, onChange: onChange, allowEmptyChoice: allowEmptyChoice })=>{
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    const getTriggerMessage = ()=>{
        if (value !== null) return formatMessage((0, $8Ipe5.default)[value]);
        return formatMessage((0, $8Ipe5.default).privacy);
    };
    const getItem = (choice, label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $c83ir.default), {
            onClick: ()=>onChange(choice),
            isDisabled: value === choice
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6OIRF.DropdownItemContent), null, formatMessage(label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5WD8l.default), {
        testId: "privacyDropdown",
        boundariesElement: "scrollParent",
        triggerType: "button",
        trigger: getTriggerMessage(),
        triggerButtonProps: {
            shouldFitContainer: true,
            className: "triggerButton"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kMn2f.default), null, allowEmptyChoice && getItem(null, (0, $8Ipe5.default).all), getItem("public", (0, $8Ipe5.default).public), getItem("private", (0, $8Ipe5.default).private)));
};
var $859baa02f71f3a36$export$2e2bcd8739ae039 = $859baa02f71f3a36$var$PrivacyDropdown;

});
parcelRegister("5WD8l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4540b9a0fcfe1b43$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $2zXPQ = parcelRequire("2zXPQ");
function $4540b9a0fcfe1b43$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $4540b9a0fcfe1b43$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $4540b9a0fcfe1b43$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $4540b9a0fcfe1b43$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(DropdownMenu, _Component);
    var _super = $4540b9a0fcfe1b43$var$_createSuper(DropdownMenu);
    function DropdownMenu() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, DropdownMenu);
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(_args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "state", {
            isOpen: _this.props.defaultOpen,
            items: (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.props.items)
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "findActivatedGroup", function(item) {
            return _this.state.items.filter(function(group) {
                return group.items.indexOf(item) > -1;
            })[0];
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleItemActivation", function(attrs) {
            var activatedItem = attrs.item;
            var activatedGroup = _this.findActivatedGroup(activatedItem);
            var items = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.state.items);
            switch(activatedItem.type){
                case "checkbox":
                    activatedItem.isChecked = !activatedItem.isChecked;
                    _this.props.onItemActivated({
                        item: activatedItem
                    });
                    _this.setState({
                        items: items
                    });
                    break;
                case "radio":
                    activatedGroup.items.forEach(function(i) {
                        if (i === activatedItem) i.isChecked = true; // eslint-disable-line no-param-reassign
                        else i.isChecked = false; // eslint-disable-line no-param-reassign
                    });
                    _this.props.onItemActivated({
                        item: activatedItem
                    });
                    _this.setState({
                        items: items
                    });
                    break;
                case "link":
                default:
                    _this.props.onItemActivated({
                        item: activatedItem
                    });
                    _this.close();
                    break;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleOpenChange", function(attrs) {
            var _this$props;
            if (_this.state.isOpen === attrs.isOpen) return;
            _this.setState({
                isOpen: attrs.isOpen
            });
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            (_this$props = _this.props).onOpenChange.apply(_this$props, [
                attrs
            ].concat(args));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "close", function() {
            var _this$props2;
            if (_this.state.isOpen === false) return;
            _this.setState({
                isOpen: false
            });
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            (_this$props2 = _this.props).onOpenChange.apply(_this$props2, [
                {
                    isOpen: false
                }
            ].concat(args));
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(DropdownMenu, [
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                if (nextProps.items !== this.state.items) this.setState({
                    items: (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(nextProps.items)
                });
                if (nextProps.isOpen !== this.props.isOpen) this.setState({
                    isOpen: nextProps.isOpen
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var isOpen = this.state.isOpen;
                var _this$props3 = this.props, appearance = _this$props3.appearance, boundariesElement = _this$props3.boundariesElement, children = _this$props3.children, isLoading = _this$props3.isLoading, items = _this$props3.items, position = _this$props3.position, isMenuFixed = _this$props3.isMenuFixed, shouldAllowMultilineItems = _this$props3.shouldAllowMultilineItems, shouldFitContainer = _this$props3.shouldFitContainer, shouldFlip = _this$props3.shouldFlip, testId = _this$props3.testId, trigger = _this$props3.trigger, triggerButtonProps = _this$props3.triggerButtonProps, triggerType = _this$props3.triggerType, onPositioned = _this$props3.onPositioned;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2zXPQ.default), {
                    appearance: appearance,
                    boundariesElement: boundariesElement,
                    isOpen: isOpen,
                    isLoading: isLoading,
                    items: items,
                    onItemActivated: this.handleItemActivation,
                    onOpenChange: this.handleOpenChange,
                    position: position,
                    isMenuFixed: isMenuFixed,
                    shouldAllowMultilineItems: shouldAllowMultilineItems,
                    shouldFitContainer: shouldFitContainer,
                    shouldFlip: shouldFlip,
                    trigger: trigger,
                    triggerButtonProps: triggerButtonProps,
                    triggerType: triggerType,
                    onPositioned: onPositioned,
                    testId: testId
                }, children);
            }
        }
    ]);
    return DropdownMenu;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($4540b9a0fcfe1b43$export$2e2bcd8739ae039, "defaultProps", {
    appearance: "default",
    boundariesElement: "viewport",
    defaultOpen: false,
    isLoading: false,
    isOpen: false,
    items: [],
    onItemActivated: function onItemActivated() {},
    onOpenChange: function onOpenChange() {},
    position: "bottom left",
    isMenuFixed: false,
    shouldAllowMultilineItems: false,
    shouldFitContainer: false,
    shouldFlip: true,
    triggerType: "default",
    onPositioned: function onPositioned() {}
});

});
parcelRegister("2zXPQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e0d43aebfe3f582$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $lnOmc = parcelRequire("lnOmc");

var $4ul5V = parcelRequire("4ul5V");

var $i6SUA = parcelRequire("i6SUA");
var $afi1d = parcelRequire("afi1d");
var $wUCuM = parcelRequire("wUCuM");

var $3tGZG = parcelRequire("3tGZG");

var $iYKuS = parcelRequire("iYKuS");
var $je2eW = parcelRequire("je2eW");
var $ikiOd = parcelRequire("ikiOd");

var $22itD = parcelRequire("22itD");

var $jN3sS = parcelRequire("jN3sS");

var $5HKOT = parcelRequire("5HKOT");

var $9ntM7 = parcelRequire("9ntM7");

var $7wfzX = parcelRequire("7wfzX");

var $eaCZv = parcelRequire("eaCZv");
function $1e0d43aebfe3f582$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1e0d43aebfe3f582$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $1e0d43aebfe3f582$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $1e0d43aebfe3f582$var$packageName = "@atlaskit/dropdown-menu";
var $1e0d43aebfe3f582$var$packageVersion = "10.1.3";
var $1e0d43aebfe3f582$export$f1295a2aa2fb4b27 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(DropdownMenuStateless, _Component);
    var _super = $1e0d43aebfe3f582$var$_createSuper(DropdownMenuStateless);
    function DropdownMenuStateless() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, DropdownMenuStateless);
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(_args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "dropdownListPositioned", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "state", {
            id: (0, $4ul5V.uid)({
                id: _this.constructor.name
            }),
            autoFocusDropdownItems: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "componentDidMount", function() {
            if (_this.isUsingDeprecatedAPI()) {
                if (_this.domItemsList) _this.focusFirstItem();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "componentDidUpdate", function(prevProp) {
            if (_this.isUsingDeprecatedAPI() && _this.props.isOpen && !prevProp.isOpen) _this.focusFirstItem();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getNextFocusable", function(indexItem, available) {
            if (!_this.domItemsList) return null;
            var currentItem = typeof indexItem !== "number" ? -1 : indexItem;
            var latestAvailable = typeof available !== "number" ? currentItem : available;
            if (currentItem < _this.domItemsList.length - 1) {
                currentItem++;
                if (_this.domItemsList[currentItem].getAttribute("aria-hidden") !== "true") return currentItem;
                return _this.getNextFocusable(currentItem, latestAvailable);
            }
            return latestAvailable;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getPrevFocusable", function(indexItem, available) {
            if (!_this.domItemsList) return null;
            var currentItem = typeof indexItem !== "number" ? -1 : indexItem;
            var latestAvailable = typeof available !== "number" ? currentItem : available;
            if (currentItem && currentItem > 0) {
                currentItem--;
                if (_this.domItemsList[currentItem].getAttribute("aria-hidden") !== "true") return currentItem;
                return _this.getPrevFocusable(currentItem, latestAvailable);
            }
            return latestAvailable || currentItem;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "focusFirstItem", function() {
            if (_this.sourceOfIsOpen === "keydown") _this.focusItem(_this.getNextFocusable());
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "focusNextItem", function() {
            _this.focusItem(_this.getNextFocusable(_this.focusedItem));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "focusPreviousItem", function() {
            _this.focusItem(_this.getPrevFocusable(_this.focusedItem));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "focusItem", function(index) {
            if (!_this.domItemsList || !index) return;
            _this.focusedItem = index;
            _this.domItemsList[_this.focusedItem].focus();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "isTargetChildItem", function(target) {
            if (!target) return false;
            var isDroplistItem = target.getAttribute("data-role") === "droplistItem"; // eslint-disable-next-line react/no-find-dom-node
            var thisDom = (0, $lnOmc.findDOMNode)((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this));
            return isDroplistItem && thisDom ? thisDom.contains(target) : false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleKeyboardInteractionForClosed", function(event) {
            if (_this.props.isOpen) return;
            switch(event.key){
                case 0, $5HKOT.KEY_DOWN:
                case 0, $5HKOT.KEY_SPACE:
                case 0, $5HKOT.KEY_ENTER:
                    event.preventDefault();
                    _this.open({
                        event: event,
                        source: "keydown"
                    });
                    break;
                default:
                    break;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleKeyboardInteractionsDeprecated", function(event) {
            if (_this.props.isOpen) {
                if (_this.isTargetChildItem(event.target)) switch(event.key){
                    case "ArrowUp":
                        event.preventDefault();
                        _this.focusPreviousItem();
                        break;
                    case "ArrowDown":
                        event.preventDefault();
                        _this.focusNextItem();
                        break;
                    case "Tab":
                        event.preventDefault();
                        _this.close({
                            event: event
                        });
                        break;
                    default:
                        break;
                }
                else if (event.key === "ArrowDown") {
                    _this.sourceOfIsOpen = "keydown";
                    _this.focusFirstItem();
                } else if (event.key === "Tab") _this.close({
                    event: event
                });
            } else switch(event.key){
                case 0, $5HKOT.KEY_DOWN:
                case 0, $5HKOT.KEY_SPACE:
                case 0, $5HKOT.KEY_ENTER:
                    event.preventDefault();
                    _this.open({
                        event: event,
                        source: "keydown"
                    });
                    break;
                default:
                    break;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "domMenuContainer", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "isUsingDeprecatedAPI", function() {
            return Boolean(_this.props.items.length);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleOpenChange", function(args) {
            _this.props.onOpenChange(args);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "triggerContent", function() {
            var _this$props = _this.props, children = _this$props.children, trigger = _this$props.trigger, isOpen = _this$props.isOpen, triggerButtonProps = _this$props.triggerButtonProps, triggerType = _this$props.triggerType, testId = _this$props.testId;
            var insideTriggerContent = _this.isUsingDeprecatedAPI() ? children : trigger;
            if (triggerType !== "button") return insideTriggerContent;
             // we probably don't need to object copying
            // ts doesn't like destructuring copy - so converting to object.assign
            var triggerProps = Object.assign({}, triggerButtonProps);
            var defaultButtonProps = {
                "aria-controls": _this.state.id,
                "aria-expanded": isOpen,
                "aria-haspopup": true,
                isSelected: isOpen
            };
            if (!triggerProps.iconAfter && !triggerProps.iconBefore) triggerProps.iconAfter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($22itD))), {
                size: "medium",
                label: ""
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3tGZG.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, defaultButtonProps, triggerProps, {
                testId: testId && "".concat(testId, "--trigger")
            }), insideTriggerContent);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "open", function(attrs) {
            _this.sourceOfIsOpen = attrs.source;
            _this.props.onOpenChange({
                isOpen: true,
                event: attrs.event
            }); // Dropdown opened via keyboard gets auto focussed
            _this.setState({
                autoFocusDropdownItems: _this.sourceOfIsOpen === "keydown"
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "close", function(attrs) {
            _this.sourceOfIsOpen = null;
            _this.props.onOpenChange({
                isOpen: false,
                event: attrs.event
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "toggle", function(attrs) {
            if (attrs.source === "keydown") return;
            if (_this.props.isOpen) _this.close(attrs);
            else _this.open(attrs);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "renderTrigger", function() {
            var triggerContent = _this.triggerContent();
            return _this.isUsingDeprecatedAPI() ? triggerContent : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
                ref: function ref(_ref) {
                    _this.triggerContainer = _ref;
                }
            }, triggerContent);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "renderItems", function(items) {
            return items.map(function(item, itemIndex) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ikiOd.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, item, {
                    key: itemIndex,
                    onActivate: function onActivate(_ref2) {
                        var event = _ref2.event;
                        _this.props.onItemActivated({
                            item: item,
                            event: event
                        });
                    }
                }), item.content);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "renderGroups", function(groups) {
            return groups.map(function(group, groupIndex) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $je2eW.default), {
                    heading: group.heading,
                    elemAfter: group.elemAfter,
                    key: groupIndex
                }, _this.renderItems(group.items));
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "renderDeprecated", function() {
            var _this$props2 = _this.props, items = _this$props2.items, shouldFitContainer = _this$props2.shouldFitContainer;
            var id = _this.state.id;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
                id: id,
                ref: function ref(_ref3) {
                    _this.domMenuContainer = _ref3;
                    _this.domItemsList = _ref3 ? _ref3.querySelectorAll('[data-role="droplistItem"]') : null;
                },
                role: "menu",
                style: shouldFitContainer ? undefined : {
                    maxWidth: 300
                }
            }, _this.renderGroups(items));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onDroplistPositioned", function() {
            _this.dropdownListPositioned = true; // Trigger render so item focus manager can auto focus for keyboard trigger
            _this.setState({
                autoFocusDropdownItems: _this.sourceOfIsOpen === "keydown"
            });
            if (_this.props.onPositioned) _this.props.onPositioned();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "renderDropdownItems", function() {
            if (_this.sourceOfIsOpen === "keydown" && _this.dropdownListPositioned) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7wfzX.default), {
                autoFocus: _this.state.autoFocusDropdownItems,
                close: _this.close
            }, _this.props.children);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, _this.props.children);
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(DropdownMenuStateless, [
        {
            key: "handleClickDeprecated",
            value: function handleClickDeprecated(event) {
                var menuContainer = this.domMenuContainer;
                if (!menuContainer || menuContainer && !menuContainer.contains(event.target)) this.toggle({
                    source: "click",
                    event: event
                });
            }
        },
        {
            key: "handleClick",
            value: function handleClick(event) {
                // For any clicks we don't want autofocus
                this.setState({
                    autoFocusDropdownItems: false
                });
                if (this.isUsingDeprecatedAPI()) {
                    this.handleClickDeprecated(event);
                    return;
                }
                if (this.triggerContainer && this.triggerContainer.contains(event.target) && event.target.disabled !== true) {
                    var isOpen = this.props.isOpen;
                    this.sourceOfIsOpen = "mouse";
                    this.props.onOpenChange({
                        isOpen: !isOpen,
                        event: event
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, appearance = _this$props3.appearance, boundariesElement = _this$props3.boundariesElement, isLoading = _this$props3.isLoading, isOpen = _this$props3.isOpen, onOpenChange = _this$props3.onOpenChange, position = _this$props3.position, isMenuFixed = _this$props3.isMenuFixed, shouldAllowMultilineItems = _this$props3.shouldAllowMultilineItems, shouldFitContainer = _this$props3.shouldFitContainer, shouldFlip = _this$props3.shouldFlip, testId = _this$props3.testId;
                var id = this.state.id;
                var isDeprecated = this.isUsingDeprecatedAPI();
                var deprecatedProps = isDeprecated ? {
                    onKeyDown: this.handleKeyboardInteractionsDeprecated,
                    shouldAllowMultilineItems: shouldAllowMultilineItems
                } : {
                    onKeyDown: this.handleKeyboardInteractionForClosed
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eaCZv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $iYKuS.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                    appearance: appearance,
                    boundariesElement: boundariesElement,
                    isLoading: isLoading,
                    isOpen: isOpen,
                    onClick: function onClick(e) {
                        return _this2.handleClick(e);
                    },
                    onOpenChange: this.handleOpenChange,
                    position: position,
                    isMenuFixed: isMenuFixed,
                    shouldFitContainer: shouldFitContainer,
                    shouldFlip: shouldFlip,
                    trigger: this.renderTrigger(),
                    onPositioned: this.onDroplistPositioned
                }, deprecatedProps, {
                    analyticsContext: {
                        componentName: "dropdownMenu",
                        packageName: $1e0d43aebfe3f582$var$packageName,
                        packageVersion: $1e0d43aebfe3f582$var$packageVersion
                    },
                    testId: testId
                }), isDeprecated ? this.renderDeprecated() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $jN3sS.default), {
                    id: id,
                    role: "menu",
                    shouldFitContainer: shouldFitContainer
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9ntM7.default), {
                    onItemClicked: function onItemClicked(event) {
                        return onOpenChange({
                            isOpen: false,
                            event: event
                        });
                    }
                }, this.renderDropdownItems()))));
            }
        }
    ]);
    return DropdownMenuStateless;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($1e0d43aebfe3f582$export$f1295a2aa2fb4b27, "defaultProps", {
    appearance: "default",
    boundariesElement: "viewport",
    isLoading: false,
    isOpen: false,
    items: [],
    onItemActivated: function onItemActivated() {},
    onOpenChange: function onOpenChange() {},
    position: "bottom left",
    isMenuFixed: false,
    shouldAllowMultilineItems: false,
    shouldFitContainer: false,
    shouldFlip: true,
    triggerType: "default",
    onPositioned: function onPositioned() {}
});
var $1e0d43aebfe3f582$var$createAndFireEventOnAtlaskit = (0, $i6SUA.default)("atlaskit");
var $1e0d43aebfe3f582$export$2e2bcd8739ae039 = (0, $afi1d.default)({
    componentName: "dropdownMenu",
    packageName: $1e0d43aebfe3f582$var$packageName,
    packageVersion: $1e0d43aebfe3f582$var$packageVersion
})((0, $wUCuM.default)({
    onOpenChange: $1e0d43aebfe3f582$var$createAndFireEventOnAtlaskit({
        action: "toggled",
        actionSubject: "dropdownMenu",
        attributes: {
            componentName: "dropdownMenu",
            packageName: $1e0d43aebfe3f582$var$packageName,
            packageVersion: $1e0d43aebfe3f582$var$packageVersion
        }
    })
})($1e0d43aebfe3f582$export$f1295a2aa2fb4b27));

});
parcelRegister("i6SUA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2f361df0b32ca0f$export$2e2bcd8739ae039; });
var $d2f361df0b32ca0f$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};

});

parcelRegister("afi1d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7759483523b2329c$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $cSXGr = parcelRequire("cSXGr");
var $7759483523b2329c$var$_excluded = [
    "analyticsContext"
];
function $7759483523b2329c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7759483523b2329c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7759483523b2329c$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7759483523b2329c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $7759483523b2329c$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $7759483523b2329c$var$_excluded);
            var analyticsData = (0, $9nHZC.useMemo)(function() {
                return $7759483523b2329c$var$_objectSpread($7759483523b2329c$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $cSXGr.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
                ref: ref
            })));
        }); // @ts-ignore
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $7759483523b2329c$export$2e2bcd8739ae039 = $7759483523b2329c$var$withAnalyticsContext;

});
parcelRegister("cSXGr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9618d31a2967dc67$export$2e2bcd8739ae039; });

var $8Xr81 = parcelRequire("8Xr81");

var $8PO5y = parcelRequire("8PO5y");

var $8ovux = parcelRequire("8ovux");
var $9618d31a2967dc67$var$_process$env;
var $9618d31a2967dc67$var$ExportedAnalyticsContext;
if (typeof $8ovux !== "undefined" && $8ovux !== null && ($9618d31a2967dc67$var$_process$env = {}, true) && $9618d31a2967dc67$var$_process$env !== void 0 && $9618d31a2967dc67$var$_process$env["ANALYTICS_NEXT_MODERN_CONTEXT"]) $9618d31a2967dc67$var$ExportedAnalyticsContext = (0, $8PO5y.default);
else $9618d31a2967dc67$var$ExportedAnalyticsContext = (0, $8Xr81.default);
var $9618d31a2967dc67$export$2e2bcd8739ae039 = $9618d31a2967dc67$var$ExportedAnalyticsContext;

});
parcelRegister("8Xr81", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6858e0875ce247d6$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");

var $kZnbM = parcelRequire("kZnbM");
function $6858e0875ce247d6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6858e0875ce247d6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $6858e0875ce247d6$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $6858e0875ce247d6$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func
};
var $6858e0875ce247d6$var$noop = function noop() {
    return [];
}; // eslint-disable-next-line @repo/internal/react/no-class-components
var $6858e0875ce247d6$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(AnalyticsContext, _Component);
    var _super = $6858e0875ce247d6$var$_createSuper(AnalyticsContext);
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsContext);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $6858e0875ce247d6$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $6858e0875ce247d6$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kZnbM.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsContext;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($6858e0875ce247d6$var$AnalyticsContext, "contextTypes", $6858e0875ce247d6$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($6858e0875ce247d6$var$AnalyticsContext, "childContextTypes", $6858e0875ce247d6$var$ContextTypes);
var $6858e0875ce247d6$export$2e2bcd8739ae039 = $6858e0875ce247d6$var$AnalyticsContext;

});

parcelRegister("8PO5y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66e9f0b45d6a54e9$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");

var $jw3XC = parcelRequire("jw3XC");

var $gb9Dg = parcelRequire("gb9Dg");
var $66e9f0b45d6a54e9$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $gb9Dg.useTrackedRef)(data);
    var analyticsContext = (0, $jw3XC.useAnalyticsContext)();
    var getAtlaskitAnalyticsContext = (0, $9nHZC.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(analyticsContext.getAtlaskitAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        analyticsContext,
        dataRef
    ]);
    var value = (0, $9nHZC.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: analyticsContext.getAtlaskitAnalyticsEventHandlers
        };
    }, [
        analyticsContext,
        getAtlaskitAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kZnbM.default).Provider, {
        value: value
    }, children);
};
var $66e9f0b45d6a54e9$export$2e2bcd8739ae039 = $66e9f0b45d6a54e9$var$AnalyticsContext;

});
parcelRegister("jw3XC", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $e35413f7a0988579$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $e35413f7a0988579$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});

parcelRegister("gb9Dg", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $bc7525319fc91afb$export$1d27a74659855e44; });

var $9nHZC = parcelRequire("9nHZC");
var $bc7525319fc91afb$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    (0, $9nHZC.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
};

});




parcelRegister("wUCuM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $062ee8ce2b984a0a$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $79g9z = parcelRequire("79g9z");

var $agpVt = parcelRequire("agpVt");
var $062ee8ce2b984a0a$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(props, ref) {
            var _usePatchedProps = (0, $agpVt.usePatchedProps)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $79g9z.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        }); // @ts-ignore
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $062ee8ce2b984a0a$export$2e2bcd8739ae039 = $062ee8ce2b984a0a$var$withAnalyticsEvents;

});
parcelRegister("79g9z", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $5345e764a67e5a7c$export$5bf35293e545f20c; });

var $dNznA = parcelRequire("dNznA");

var $4MQ0x = parcelRequire("4MQ0x");

var $jw3XC = parcelRequire("jw3XC");
function $5345e764a67e5a7c$export$5bf35293e545f20c() {
    var analyticsContext = (0, $jw3XC.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $4MQ0x.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("4MQ0x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37c3fcc4be1d4dd8$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $4WeYK = parcelRequire("4WeYK");
function $37c3fcc4be1d4dd8$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $37c3fcc4be1d4dd8$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $37c3fcc4be1d4dd8$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $37c3fcc4be1d4dd8$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $37c3fcc4be1d4dd8$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 ? void 0 : (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $37c3fcc4be1d4dd8$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $37c3fcc4be1d4dd8$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $4WeYK.default));

});
parcelRegister("4WeYK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $398832b337506b6b$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
function $398832b337506b6b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $398832b337506b6b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $398832b337506b6b$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $398832b337506b6b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $398832b337506b6b$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $398832b337506b6b$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 ? void 0 : (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $398832b337506b6b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $398832b337506b6b$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(updater) === "object") this.payload = $398832b337506b6b$var$_objectSpread($398832b337506b6b$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});



parcelRegister("agpVt", function(module, exports) {

$parcel$export(module.exports, "usePatchedProps", function () { return $778f825c70c26177$export$9ebb5a84d17e5d18; });

var $kFnE9 = parcelRequire("kFnE9");

var $340K4 = parcelRequire("340K4");

var $9nHZC = parcelRequire("9nHZC");

var $79g9z = parcelRequire("79g9z");
function $778f825c70c26177$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $778f825c70c26177$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $778f825c70c26177$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $778f825c70c26177$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $778f825c70c26177$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $79g9z.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $9nHZC.useRef)({});
    var patchedProps = (0, $9nHZC.useMemo)(function() {
        var cache = handlerCache.current; // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                "object",
                "function"
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $778f825c70c26177$var$_objectSpread($778f825c70c26177$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === "function" ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === "function") {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $778f825c70c26177$var$_objectSpread($778f825c70c26177$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});


parcelRegister("3tGZG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28856e3412cda5c7$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9q1kH = parcelRequire("9q1kH");

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $dc3eH = parcelRequire("dc3eH");

var $e3JY8 = parcelRequire("e3JY8");

var $lALvD = parcelRequire("lALvD");

var $4NDZB = parcelRequire("4NDZB");

var $c8UwA = parcelRequire("c8UwA");
function $28856e3412cda5c7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $28856e3412cda5c7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $28856e3412cda5c7$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $28856e3412cda5c7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $28856e3412cda5c7$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return "disabled";
    if (isSelected && isFocus) return "focusSelected";
    if (isSelected) return "selected";
     // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return "active";
    if (!isLoading && isHover) return "hover";
    if (isFocus) return "focus";
    return "default";
}
var $28856e3412cda5c7$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
var $28856e3412cda5c7$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $c8UwA.defaultThemeFn) : _ref2$theme, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref2, [
        "appearance",
        "autoFocus",
        "isDisabled",
        "isSelected",
        "shouldFitContainer",
        "spacing",
        "isLoading",
        "onMouseEnter",
        "onMouseLeave",
        "onMouseDown",
        "onMouseUp",
        "onFocus",
        "onBlur",
        "theme"
    ]);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $28856e3412cda5c7$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $9nHZC.useState)($28856e3412cda5c7$var$initial), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $28856e3412cda5c7$var$_objectSpread($28856e3412cda5c7$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $28856e3412cda5c7$var$_objectSpread($28856e3412cda5c7$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $28856e3412cda5c7$var$_objectSpread($28856e3412cda5c7$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $28856e3412cda5c7$var$_objectSpread($28856e3412cda5c7$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $28856e3412cda5c7$var$_objectSpread($28856e3412cda5c7$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $28856e3412cda5c7$var$_objectSpread($28856e3412cda5c7$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $c8UwA.default).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dc3eH.default).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $c8UwA.default).Consumer, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            mode: mode,
            state: $28856e3412cda5c7$var$getInteractionState($28856e3412cda5c7$var$_objectSpread($28856e3412cda5c7$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $lALvD.default)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $e3JY8.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $4NDZB.default), restProps) : null,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $c8UwA.getSpecifiers)(buttonStyles)
            }));
        });
    }));
})); // Tools including enzyme rely on components having a display name
$28856e3412cda5c7$var$CustomThemeButton.displayName = "CustomThemeButton";
var $28856e3412cda5c7$export$2e2bcd8739ae039 = $28856e3412cda5c7$var$CustomThemeButton;

});
parcelRegister("dc3eH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99aee7f2dbd0fdca$export$2e2bcd8739ae039; });

var $eTATz = parcelRequire("eTATz");
// Create default global light theme
var $99aee7f2dbd0fdca$var$_createTheme = (0, $eTATz.createTheme)(function() {
    return {
        mode: "light"
    };
}), $99aee7f2dbd0fdca$var$Provider = $99aee7f2dbd0fdca$var$_createTheme.Provider, $99aee7f2dbd0fdca$var$Consumer = $99aee7f2dbd0fdca$var$_createTheme.Consumer, $99aee7f2dbd0fdca$var$useTheme = $99aee7f2dbd0fdca$var$_createTheme.useTheme;
var $99aee7f2dbd0fdca$export$7692396083754928 = function useGlobalTheme() {
    return $99aee7f2dbd0fdca$var$useTheme();
};
var $99aee7f2dbd0fdca$export$2e2bcd8739ae039 = {
    Provider: $99aee7f2dbd0fdca$var$Provider,
    Consumer: $99aee7f2dbd0fdca$var$Consumer
};

});
parcelRegister("eTATz", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $ad82d25f9f4937e6$export$25d302a5b900a763; });

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");
function $ad82d25f9f4937e6$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   **/ var ThemeContext = /*#__PURE__*/ (0, $9nHZC.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $9nHZC.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    } // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(props, [
            "children"
        ]); // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps); // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $9nHZC.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $9nHZC.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("e3JY8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3c500f4ce4e6b98$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $45CBz = parcelRequire("45CBz");

var $jF1YF = parcelRequire("jF1YF");

var $027jC = parcelRequire("027jC");

var $7ptyu = parcelRequire("7ptyu");

var $4oi81 = parcelRequire("4oi81");
function $a3c500f4ce4e6b98$var$noop() {} // Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $a3c500f4ce4e6b98$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
var $a3c500f4ce4e6b98$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function ButtonBase(props, ref) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, buttonCss = props.buttonCss, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$shouldFitConta = props.shouldFitContainer, shouldFitContainer = _props$shouldFitConta === void 0 ? false : _props$shouldFitConta, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, iconBefore = props.iconBefore, iconAfter = props.iconAfter, children = props.children, className = props.className, href = props.href, overlay = props.overlay, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? $a3c500f4ce4e6b98$var$noop : _props$onMouseDown, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? $a3c500f4ce4e6b98$var$noop : _props$onClick, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, testId = props.testId, analyticsContext = props.analyticsContext, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(props, [
        "appearance",
        "buttonCss",
        "spacing",
        "autoFocus",
        "isDisabled",
        "shouldFitContainer",
        "isSelected",
        "iconBefore",
        "iconAfter",
        "children",
        "className",
        "href",
        "overlay",
        "tabIndex",
        "type",
        "onMouseDown",
        "onClick",
        "component",
        "testId",
        "analyticsContext"
    ]);
    var ourRef = (0, $9nHZC.useRef)();
    var setRef = (0, $9nHZC.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        } // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]); // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $027jC.default)(ourRef, autoFocus);
    var onClick = (0, $jF1YF.usePlatformLeafEventHandler)({
        fn: providedOnClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "15.1.7",
        analyticsData: analyticsContext
    }); // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $9nHZC.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]); // Lose focus when becoming disabled (standard button behaviour)
    (0, $9nHZC.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]); // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    var fadeCss = (0, $4oi81.getFadingCss)({
        hasOverlay: hasOverlay
    });
    var isInteractive = !isDisabled && !hasOverlay;
    return (0, $45CBz.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
        css: [
            buttonCss,
            isInteractive ? null : $a3c500f4ce4e6b98$var$noPointerEventsOnChildrenCss
        ],
        className: className,
        ref: setRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        disabled: isDisabled,
        href: isInteractive ? href : undefined // using undefined so that the property doesn't exist when false
        ,
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        type: type // Adding a tab index so element is always focusable, even when not a <button> or <a>
        ,
        tabIndex: isDisabled ? -1 : tabIndex
    }, (0, $7ptyu.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $45CBz.jsx)("span", {
        css: [
            fadeCss,
            (0, $4oi81.getIconStyle)({
                spacing: spacing
            })
        ]
    }, iconBefore) : null, children ? (0, $45CBz.jsx)("span", {
        css: [
            fadeCss,
            (0, $4oi81.getContentStyle)({
                spacing: spacing
            })
        ]
    }, children) : null, iconAfter ? (0, $45CBz.jsx)("span", {
        css: [
            fadeCss,
            (0, $4oi81.getIconStyle)({
                spacing: spacing
            })
        ]
    }, iconAfter) : null, overlay ? (0, $45CBz.jsx)("span", {
        css: (0, $4oi81.overlayCss)
    }, overlay) : null);
});

});
parcelRegister("jF1YF", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $e503615f0dc37654$export$a4687b0234b40e28; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $79g9z = parcelRequire("79g9z");

var $gb9Dg = parcelRequire("gb9Dg");
function $e503615f0dc37654$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e503615f0dc37654$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e503615f0dc37654$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e503615f0dc37654$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e503615f0dc37654$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $79g9z.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent; // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $gb9Dg.useTrackedRef)(analyticsData);
    var fnRef = (0, $gb9Dg.useTrackedRef)(fn);
    var handler = (0, $9nHZC.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        }); // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $e503615f0dc37654$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context); // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        createAnalyticsEvent,
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("027jC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0065dcbc9ebb8b64$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");
function $0065dcbc9ebb8b64$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $9nHZC.useRef)(true);
    (0, $9nHZC.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("7ptyu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5651cb4270928153$export$2e2bcd8739ae039; });
function $5651cb4270928153$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $5651cb4270928153$var$tabKeyCode = 9;
function $5651cb4270928153$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $5651cb4270928153$var$tabKeyCode) return;
    $5651cb4270928153$var$abort(event);
}
var $5651cb4270928153$var$block = {
    onMouseDownCapture: $5651cb4270928153$var$abort,
    onMouseUpCapture: $5651cb4270928153$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $5651cb4270928153$var$onKey,
    onKeyUpCapture: $5651cb4270928153$var$onKey,
    onTouchStartCapture: $5651cb4270928153$var$abort,
    onTouchEndCapture: $5651cb4270928153$var$abort,
    onPointerDownCapture: $5651cb4270928153$var$abort,
    onPointerUpCapture: $5651cb4270928153$var$abort,
    onClickCapture: $5651cb4270928153$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $5651cb4270928153$var$abort
};
var $5651cb4270928153$var$doNotBlock = {};
function $5651cb4270928153$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $5651cb4270928153$var$doNotBlock : $5651cb4270928153$var$block;
}

});

parcelRegister("4oi81", function(module, exports) {

$parcel$export(module.exports, "getCss", function () { return $33277737a3d0b665$export$955358618f994a11; });
$parcel$export(module.exports, "getIconStyle", function () { return $33277737a3d0b665$export$864eea3f4ec3368f; });
$parcel$export(module.exports, "getContentStyle", function () { return $33277737a3d0b665$export$7ad0316cc0dd65a; });
$parcel$export(module.exports, "getFadingCss", function () { return $33277737a3d0b665$export$1b5827d324e945b1; });
$parcel$export(module.exports, "overlayCss", function () { return $33277737a3d0b665$export$1a9fe1b84c876bb5; });

var $kFnE9 = parcelRequire("kFnE9");

var $ebJZ3 = parcelRequire("ebJZ3");

var $2wyt9 = parcelRequire("2wyt9");
function $33277737a3d0b665$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $33277737a3d0b665$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $33277737a3d0b665$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $33277737a3d0b665$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $33277737a3d0b665$var$borderRadius = (0, $ebJZ3.borderRadius)();
var $33277737a3d0b665$var$gridSize = (0, $ebJZ3.gridSize)();
var $33277737a3d0b665$var$fontSize = (0, $ebJZ3.fontSize)(); // ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $33277737a3d0b665$var$heights = {
    default: "".concat($33277737a3d0b665$var$gridSize * 4 / $33277737a3d0b665$var$fontSize, "em"),
    // 32px
    compact: "".concat($33277737a3d0b665$var$gridSize * 3 / $33277737a3d0b665$var$fontSize, "em"),
    none: "auto"
};
var $33277737a3d0b665$var$lineHeights = {
    default: $33277737a3d0b665$var$heights.default,
    compact: $33277737a3d0b665$var$heights.compact,
    none: "inherit"
};
var $33277737a3d0b665$var$padding = {
    // 10px gutter
    default: "0 ".concat($33277737a3d0b665$var$gridSize + $33277737a3d0b665$var$gridSize / 4, "px"),
    compact: "0 ".concat($33277737a3d0b665$var$gridSize + $33277737a3d0b665$var$gridSize / 4, "px"),
    none: "0"
};
var $33277737a3d0b665$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($33277737a3d0b665$var$gridSize / 4, "px"),
    default: "0 ".concat($33277737a3d0b665$var$gridSize / 4, "px"),
    none: "0"
};
var $33277737a3d0b665$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $33277737a3d0b665$var$innerMargin = {
    content: "0 ".concat($33277737a3d0b665$var$gridSize / 4, "px"),
    icon: "0 ".concat($33277737a3d0b665$var$gridSize / 4, "px")
};
function $33277737a3d0b665$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $33277737a3d0b665$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $33277737a3d0b665$var$getColor({
            group: (0, $2wyt9.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($33277737a3d0b665$var$getColor({
            group: (0, $2wyt9.default).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $33277737a3d0b665$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $33277737a3d0b665$var$getColors({
        appearance: appearance,
        key: isSelected ? "selected" : "default",
        mode: mode
    });
    return $33277737a3d0b665$var$_objectSpread($33277737a3d0b665$var$_objectSpread({
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: $33277737a3d0b665$var$borderRadius,
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: 500,
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap"
    }, baseColors), {}, {
        cursor: "pointer",
        height: $33277737a3d0b665$var$heights[spacing],
        lineHeight: $33277737a3d0b665$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $33277737a3d0b665$var$singleIconPadding[spacing] : $33277737a3d0b665$var$padding[spacing],
        verticalAlign: $33277737a3d0b665$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center",
        // Note: we cannot disable pointer events when there is an overlay.
        // That would be easy for styling, but it would start letting events through on disabled buttons
        // Disabling visited styles (just using the base colors)
        "&:visited": $33277737a3d0b665$var$_objectSpread({}, baseColors),
        "&:hover": $33277737a3d0b665$var$_objectSpread($33277737a3d0b665$var$_objectSpread({}, $33277737a3d0b665$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "hover",
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "inherit",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        "&:focus": $33277737a3d0b665$var$_objectSpread($33277737a3d0b665$var$_objectSpread({}, $33277737a3d0b665$var$getColors({
            appearance: appearance,
            key: isSelected ? "focusSelected" : "focus",
            mode: mode
        })), {}, {
            boxShadow: "0 0 0 2px ".concat((0, $2wyt9.default).boxShadowColor[appearance].focus[mode]),
            // background, box-shadow
            transitionDuration: "0s, 0.2s",
            // disabling browser focus outline
            outline: "none"
        }),
        // giving active styles preference by listing them after focus
        "&:active": $33277737a3d0b665$var$_objectSpread($33277737a3d0b665$var$_objectSpread({}, $33277737a3d0b665$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $33277737a3d0b665$var$_objectSpread($33277737a3d0b665$var$_objectSpread({}, $33277737a3d0b665$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pesudo classes so we are overriding :disabled here
        "&[disabled]": $33277737a3d0b665$var$_objectSpread($33277737a3d0b665$var$_objectSpread({}, $33277737a3d0b665$var$getColors({
            appearance: appearance,
            key: "disabled",
            mode: mode
        })), {}, {
            cursor: "not-allowed",
            textDecoration: "none"
        }),
        '&[data-has-overlay="true"]': {
            cursor: "default",
            textDecoration: "none"
        },
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $33277737a3d0b665$var$_objectSpread({}, $33277737a3d0b665$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "default",
            mode: mode
        })),
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
} // inline-flex child
function $33277737a3d0b665$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return {
        alignSelf: "center",
        display: "flex",
        // icon size cannot grow and shrink
        flexGrow: 0,
        flexShrink: 0,
        lineHeight: 0,
        fontSize: 0,
        userSelect: "none",
        margin: spacing === "none" ? 0 : $33277737a3d0b665$var$innerMargin.icon
    };
} // inline-flex child
function $33277737a3d0b665$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return {
        margin: spacing === "none" ? 0 : $33277737a3d0b665$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    };
}
function $33277737a3d0b665$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return {
        transition: "opacity 0.3s",
        opacity: hasOverlay ? 0 : 1
    };
}
var $33277737a3d0b665$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

});
parcelRegister("ebJZ3", function(module, exports) {

$parcel$export(module.exports, "borderRadius", function () { return $a545c3319a7e5a87$export$7a57f79000377ca2; });
$parcel$export(module.exports, "gridSize", function () { return $a545c3319a7e5a87$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "fontSize", function () { return $a545c3319a7e5a87$export$85e3c3ca0c6fb93; });

var $kTMVZ = parcelRequire("kTMVZ");

var $ijEQN = parcelRequire("ijEQN");
var $a545c3319a7e5a87$export$521f2c0e5c12a14d = "__FLATTENED__";
var $a545c3319a7e5a87$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $a545c3319a7e5a87$export$c93026a968943f95 = "light";
var $a545c3319a7e5a87$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $a545c3319a7e5a87$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $a545c3319a7e5a87$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $a545c3319a7e5a87$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $a545c3319a7e5a87$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $a545c3319a7e5a87$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $a545c3319a7e5a87$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $a545c3319a7e5a87$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $ijEQN.B100);
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a545c3319a7e5a87$export$6d8204c2cb2e06b8() / 4;
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $a545c3319a7e5a87$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $a545c3319a7e5a87$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 800;
    }
};
var $a545c3319a7e5a87$export$a1b3edb637fb4f35 = function visuallyHidden() {
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $a545c3319a7e5a87$export$ba1d834b86d72a09 = $a545c3319a7e5a87$export$a1b3edb637fb4f35;
var $a545c3319a7e5a87$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: (0, $kTMVZ.default)("color.background.subtleNeutral.resting", (0, $ijEQN.skeleton)()),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: (0, $kTMVZ.default)("color.background.subtleNeutral.resting", (0, $ijEQN.skeleton)())
            },
            to: {
                backgroundColor: (0, $kTMVZ.default)("color.background.subtleNeutral.hover", (0, $ijEQN.N30A))
            }
        }
    };
};

});
parcelRegister("kTMVZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f36ee70f74e9011e$export$2e2bcd8739ae039; });

var $k8H4b = parcelRequire("k8H4b");
function $f36ee70f74e9011e$var$token(path, fallback) {
    var token = (0, $k8H4b.default)[path];
    var tokenCall = fallback ? "var(".concat(token, ", ").concat(fallback, ")") : "var(".concat(token, ")");
    return tokenCall;
}
var $f36ee70f74e9011e$export$2e2bcd8739ae039 = $f36ee70f74e9011e$var$token;

});
parcelRegister("k8H4b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea95f61f5135b98c$export$2e2bcd8739ae039; });
// THIS IS AN AUTO-GENERATED FILE DO NOT MODIFY DIRECTLY
// Re-generate by running `yarn build tokens`.
var $ea95f61f5135b98c$var$tokens = {
    "color.accent.boldBlue": "--accent-boldBlue",
    "color.accent.boldGreen": "--accent-boldGreen",
    "color.accent.boldOrange": "--accent-boldOrange",
    "color.accent.boldPurple": "--accent-boldPurple",
    "color.accent.boldRed": "--accent-boldRed",
    "color.accent.boldTeal": "--accent-boldTeal",
    "color.accent.subtleBlue": "--accent-subtleBlue",
    "color.accent.subtleGreen": "--accent-subtleGreen",
    "color.accent.subtleMagenta": "--accent-subtleMagenta",
    "color.accent.subtleOrange": "--accent-subtleOrange",
    "color.accent.subtlePurple": "--accent-subtlePurple",
    "color.accent.subtleRed": "--accent-subtleRed",
    "color.accent.subtleTeal": "--accent-subtleTeal",
    "color.background.sunken": "--background-sunken",
    "color.background.default": "--background-default",
    "color.background.card": "--background-card",
    "color.background.overlay": "--background-overlay",
    "color.background.selected.resting": "--background-selected-resting",
    "color.background.selected.hover": "--background-selected-hover",
    "color.background.selected.pressed": "--background-selected-pressed",
    "color.background.blanket": "--background-blanket",
    "color.background.disabled": "--background-disabled",
    "color.background.boldBrand.resting": "--background-boldBrand-resting",
    "color.background.boldBrand.hover": "--background-boldBrand-hover",
    "color.background.boldBrand.pressed": "--background-boldBrand-pressed",
    "color.background.subtleBrand.resting": "--background-subtleBrand-resting",
    "color.background.subtleBrand.hover": "--background-subtleBrand-hover",
    "color.background.subtleBrand.pressed": "--background-subtleBrand-pressed",
    "color.background.boldDanger.resting": "--background-boldDanger-resting",
    "color.background.boldDanger.hover": "--background-boldDanger-hover",
    "color.background.boldDanger.pressed": "--background-boldDanger-pressed",
    "color.background.subtleDanger.resting": "--background-subtleDanger-resting",
    "color.background.subtleDanger.hover": "--background-subtleDanger-hover",
    "color.background.subtleDanger.pressed": "--background-subtleDanger-pressed",
    "color.background.boldWarning.resting": "--background-boldWarning-resting",
    "color.background.boldWarning.hover": "--background-boldWarning-hover",
    "color.background.boldWarning.pressed": "--background-boldWarning-pressed",
    "color.background.subtleWarning.resting": "--background-subtleWarning-resting",
    "color.background.subtleWarning.hover": "--background-subtleWarning-hover",
    "color.background.subtleWarning.pressed": "--background-subtleWarning-pressed",
    "color.background.boldSuccess.resting": "--background-boldSuccess-resting",
    "color.background.boldSuccess.hover": "--background-boldSuccess-hover",
    "color.background.boldSuccess.pressed": "--background-boldSuccess-pressed",
    "color.background.subtleSuccess.resting": "--background-subtleSuccess-resting",
    "color.background.subtleSuccess.hover": "--background-subtleSuccess-hover",
    "color.background.subtleSuccess.pressed": "--background-subtleSuccess-pressed",
    "color.background.boldDiscovery.resting": "--background-boldDiscovery-resting",
    "color.background.boldDiscovery.hover": "--background-boldDiscovery-hover",
    "color.background.boldDiscovery.pressed": "--background-boldDiscovery-pressed",
    "color.background.subtleDiscovery.resting": "--background-subtleDiscovery-resting",
    "color.background.subtleDiscovery.hover": "--background-subtleDiscovery-hover",
    "color.background.subtleDiscovery.pressed": "--background-subtleDiscovery-pressed",
    "color.background.boldNeutral.resting": "--background-boldNeutral-resting",
    "color.background.boldNeutral.hover": "--background-boldNeutral-hover",
    "color.background.boldNeutral.pressed": "--background-boldNeutral-pressed",
    "color.background.transparentNeutral.hover": "--background-transparentNeutral-hover",
    "color.background.transparentNeutral.pressed": "--background-transparentNeutral-pressed",
    "color.background.subtleNeutral.resting": "--background-subtleNeutral-resting",
    "color.background.subtleNeutral.hover": "--background-subtleNeutral-hover",
    "color.background.subtleNeutral.pressed": "--background-subtleNeutral-pressed",
    "color.background.subtleBorderedNeutral.resting": "--background-subtleBorderedNeutral-resting",
    "color.background.subtleBorderedNeutral.pressed": "--background-subtleBorderedNeutral-pressed",
    "color.border.focus": "--border-focus",
    "color.border.neutral": "--border-neutral",
    "color.iconBorder.brand": "--iconBorder-brand",
    "color.iconBorder.danger": "--iconBorder-danger",
    "color.iconBorder.warning": "--iconBorder-warning",
    "color.iconBorder.success": "--iconBorder-success",
    "color.iconBorder.discovery": "--iconBorder-discovery",
    "color.overlay.hover": "--overlay-hover",
    "color.overlay.pressed": "--overlay-pressed",
    "color.text.selected": "--text-selected",
    "color.text.highEmphasis": "--text-highEmphasis",
    "color.text.mediumEmphasis": "--text-mediumEmphasis",
    "color.text.lowEmphasis": "--text-lowEmphasis",
    "color.text.onBold": "--text-onBold",
    "color.text.onBoldWarning": "--text-onBoldWarning",
    "color.text.link.resting": "--text-link-resting",
    "color.text.link.pressed": "--text-link-pressed",
    "color.text.brand": "--text-brand",
    "color.text.warning": "--text-warning",
    "color.text.danger": "--text-danger",
    "color.text.success": "--text-success",
    "color.text.discovery": "--text-discovery",
    "color.text.disabled": "--text-disabled",
    "shadow.card": "--card",
    "shadow.overlay": "--overlay",
    "utility.UNSAFE_util.transparent": "--UNSAFE_util-transparent"
};
var $ea95f61f5135b98c$export$2e2bcd8739ae039 = $ea95f61f5135b98c$var$tokens;

});


parcelRegister("ijEQN", function(module, exports) {

$parcel$export(module.exports, "R100", function () { return $d559b0654aafb1d9$export$be802dd0d8b57f35; });
$parcel$export(module.exports, "R300", function () { return $d559b0654aafb1d9$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $d559b0654aafb1d9$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $d559b0654aafb1d9$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y200", function () { return $d559b0654aafb1d9$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $d559b0654aafb1d9$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $d559b0654aafb1d9$export$59619663aa6500fb; });
$parcel$export(module.exports, "Y500", function () { return $d559b0654aafb1d9$export$874739ea9e379ab6; });
$parcel$export(module.exports, "B50", function () { return $d559b0654aafb1d9$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $d559b0654aafb1d9$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $d559b0654aafb1d9$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $d559b0654aafb1d9$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $d559b0654aafb1d9$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $d559b0654aafb1d9$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $d559b0654aafb1d9$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "N0", function () { return $d559b0654aafb1d9$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $d559b0654aafb1d9$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N40", function () { return $d559b0654aafb1d9$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N70", function () { return $d559b0654aafb1d9$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N90", function () { return $d559b0654aafb1d9$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N200", function () { return $d559b0654aafb1d9$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N400", function () { return $d559b0654aafb1d9$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $d559b0654aafb1d9$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $d559b0654aafb1d9$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $d559b0654aafb1d9$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $d559b0654aafb1d9$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $d559b0654aafb1d9$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN400", function () { return $d559b0654aafb1d9$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $d559b0654aafb1d9$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN100", function () { return $d559b0654aafb1d9$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN70", function () { return $d559b0654aafb1d9$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $d559b0654aafb1d9$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN30", function () { return $d559b0654aafb1d9$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN0", function () { return $d559b0654aafb1d9$export$3d4f271a500072a; });
$parcel$export(module.exports, "skeleton", function () { return $d559b0654aafb1d9$export$2a0674ff2eb10214; });

var $1oZW9 = parcelRequire("1oZW9");
var $d559b0654aafb1d9$export$4b84fd0e2c617bd = "#FFEBE6";
var $d559b0654aafb1d9$export$b34b069eff244586 = "#FFBDAD";
var $d559b0654aafb1d9$export$be802dd0d8b57f35 = "#FF8F73";
var $d559b0654aafb1d9$export$60847d42f9da92a6 = "#FF7452";
var $d559b0654aafb1d9$export$4a7404f376229999 = "#FF5630";
var $d559b0654aafb1d9$export$2010d0fb4295b346 = "#DE350B";
var $d559b0654aafb1d9$export$2837b5a1a71d5c02 = "#BF2600"; // Yellows
var $d559b0654aafb1d9$export$8d9596b529bbb9cf = "#FFFAE6";
var $d559b0654aafb1d9$export$41060a744ab0b7ae = "#FFF0B3";
var $d559b0654aafb1d9$export$1cc05bbbf340e559 = "#FFE380";
var $d559b0654aafb1d9$export$5aae31392d72caaa = "#FFC400";
var $d559b0654aafb1d9$export$c6930421db9fa514 = "#FFAB00";
var $d559b0654aafb1d9$export$59619663aa6500fb = "#FF991F";
var $d559b0654aafb1d9$export$874739ea9e379ab6 = "#FF8B00"; // Greens
var $d559b0654aafb1d9$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $d559b0654aafb1d9$export$69a3bf21b9686c2b = "#ABF5D1";
var $d559b0654aafb1d9$export$afbce1382ec95f73 = "#79F2C0";
var $d559b0654aafb1d9$export$747d86715d4175de = "#57D9A3";
var $d559b0654aafb1d9$export$940e1f69e873f202 = "#36B37E";
var $d559b0654aafb1d9$export$a49394138f7b8e85 = "#00875A";
var $d559b0654aafb1d9$export$6fa04827ac68a4fb = "#006644"; // Blues
var $d559b0654aafb1d9$export$226de0355ed012f8 = "#DEEBFF";
var $d559b0654aafb1d9$export$8c13c2ee36917869 = "#B3D4FF";
var $d559b0654aafb1d9$export$ecfc1dff386a3e7a = "#4C9AFF";
var $d559b0654aafb1d9$export$215b7063051591f1 = "#2684FF";
var $d559b0654aafb1d9$export$e62e8919cca44969 = "#0065FF";
var $d559b0654aafb1d9$export$b3de0ae08da2ce64 = "#0052CC";
var $d559b0654aafb1d9$export$a6ee3d71bc067634 = "#0747A6"; // Purples
var $d559b0654aafb1d9$export$363e4475840015bb = "#EAE6FF";
var $d559b0654aafb1d9$export$4b0a4417ed59760f = "#C0B6F2";
var $d559b0654aafb1d9$export$6011520a64d9a187 = "#998DD9";
var $d559b0654aafb1d9$export$a7175d4e9206bc80 = "#8777D9";
var $d559b0654aafb1d9$export$b48405b95304b5a1 = "#6554C0";
var $d559b0654aafb1d9$export$c71e4279dd54a18d = "#5243AA";
var $d559b0654aafb1d9$export$147899de772240ec = "#403294"; // Teals
var $d559b0654aafb1d9$export$2cf711fe14c66f06 = "#E6FCFF";
var $d559b0654aafb1d9$export$7a8f4d33f6f9772c = "#B3F5FF";
var $d559b0654aafb1d9$export$776c9c497ef08533 = "#79E2F2";
var $d559b0654aafb1d9$export$69cb3ca10c1e330e = "#00C7E6";
var $d559b0654aafb1d9$export$9dc1ef0f3f48059b = "#00B8D9";
var $d559b0654aafb1d9$export$7c835c78b6fcdef8 = "#00A3BF";
var $d559b0654aafb1d9$export$6036577f95c3877e = "#008DA6"; // Neutrals
var $d559b0654aafb1d9$export$29a4f05edc054374 = "#FFFFFF";
var $d559b0654aafb1d9$export$e655ef011c4aa1a2 = "#FAFBFC";
var $d559b0654aafb1d9$export$9fdfb749e33cdf97 = "#F4F5F7";
var $d559b0654aafb1d9$export$3e51e8f1440314ba = "#EBECF0";
var $d559b0654aafb1d9$export$1ce2d1575d444ceb = "#DFE1E6";
var $d559b0654aafb1d9$export$8754fc7e6d8b3000 = "#C1C7D0";
var $d559b0654aafb1d9$export$c2e91cbeada39b8b = "#B3BAC5";
var $d559b0654aafb1d9$export$5f71e19f3a7ad9de = "#A5ADBA";
var $d559b0654aafb1d9$export$eaa8c8a70ac22806 = "#97A0AF";
var $d559b0654aafb1d9$export$7c87d337fb91a97d = "#8993A4";
var $d559b0654aafb1d9$export$d6447c357493214f = "#7A869A";
var $d559b0654aafb1d9$export$f563ee71e9ee74cd = "#6B778C";
var $d559b0654aafb1d9$export$e2ef2124cf4024b1 = "#5E6C84";
var $d559b0654aafb1d9$export$eece5f492e429f08 = "#505F79";
var $d559b0654aafb1d9$export$c39c0fe0f26207ae = "#42526E";
var $d559b0654aafb1d9$export$7090862dc3038a9f = "#344563";
var $d559b0654aafb1d9$export$ad0bacf983b7ddaa = "#253858";
var $d559b0654aafb1d9$export$7d61b15e0da132af = "#172B4D"; // ATTENTION: update the tints if you update this
var $d559b0654aafb1d9$export$fbda843f0a27fe96 = "#091E42"; // Each tint is made of N900 and an alpha channel
var $d559b0654aafb1d9$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $d559b0654aafb1d9$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $d559b0654aafb1d9$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $d559b0654aafb1d9$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $d559b0654aafb1d9$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $d559b0654aafb1d9$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $d559b0654aafb1d9$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $d559b0654aafb1d9$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $d559b0654aafb1d9$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $d559b0654aafb1d9$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $d559b0654aafb1d9$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $d559b0654aafb1d9$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $d559b0654aafb1d9$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $d559b0654aafb1d9$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $d559b0654aafb1d9$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $d559b0654aafb1d9$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $d559b0654aafb1d9$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)"; // Dark Mode Neutrals
var $d559b0654aafb1d9$export$2f6319cf7d736c2a = "#E6EDFA";
var $d559b0654aafb1d9$export$95126bc8884d6634 = "#DCE5F5";
var $d559b0654aafb1d9$export$8338d8c35d44ff1 = "#CED9EB";
var $d559b0654aafb1d9$export$5368d76ae4fbbda7 = "#B8C7E0";
var $d559b0654aafb1d9$export$9f0a771d16ec8d36 = "#ABBBD6";
var $d559b0654aafb1d9$export$abcf8c38338b4aa5 = "#9FB0CC";
var $d559b0654aafb1d9$export$97e81faa16a182c7 = "#8C9CB8";
var $d559b0654aafb1d9$export$bfe21c59123ecf33 = "#7988A3";
var $d559b0654aafb1d9$export$ee82aa2ea6a1558 = "#67758F";
var $d559b0654aafb1d9$export$682927c6ed76be02 = "#56637A";
var $d559b0654aafb1d9$export$91fd9994c5be9757 = "#455166";
var $d559b0654aafb1d9$export$d281fbfe3cff2df6 = "#3B475C";
var $d559b0654aafb1d9$export$3902c91d8b98a753 = "#313D52";
var $d559b0654aafb1d9$export$8e8133c1ba5845b5 = "#283447";
var $d559b0654aafb1d9$export$33ff357f6620b39 = "#202B3D";
var $d559b0654aafb1d9$export$633847cf062b69e0 = "#1B2638";
var $d559b0654aafb1d9$export$9776a6e503bdbf76 = "#121A29";
var $d559b0654aafb1d9$export$6c813d5160dff5db = "#0E1624"; // ATTENTION: update the tints if you update this
var $d559b0654aafb1d9$export$3d4f271a500072a = "#0D1424"; // Each dark tint is made of DN0 and an alpha channel
var $d559b0654aafb1d9$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $d559b0654aafb1d9$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $d559b0654aafb1d9$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $d559b0654aafb1d9$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $d559b0654aafb1d9$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $d559b0654aafb1d9$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $d559b0654aafb1d9$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $d559b0654aafb1d9$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $d559b0654aafb1d9$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $d559b0654aafb1d9$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $d559b0654aafb1d9$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $d559b0654aafb1d9$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $d559b0654aafb1d9$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $d559b0654aafb1d9$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $d559b0654aafb1d9$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $d559b0654aafb1d9$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $d559b0654aafb1d9$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)"; // Themed colors
var $d559b0654aafb1d9$export$8ce1fd94bee2f412 = (0, $1oZW9.default)({
    light: $d559b0654aafb1d9$export$29a4f05edc054374,
    dark: $d559b0654aafb1d9$export$633847cf062b69e0
});
var $d559b0654aafb1d9$export$b861914ea877b580 = (0, $1oZW9.default)({
    light: $d559b0654aafb1d9$export$226de0355ed012f8,
    dark: $d559b0654aafb1d9$export$8c13c2ee36917869
});
var $d559b0654aafb1d9$export$3f1b020df94387af = (0, $1oZW9.default)({
    light: $d559b0654aafb1d9$export$3e51e8f1440314ba,
    dark: $d559b0654aafb1d9$export$d281fbfe3cff2df6
});
var $d559b0654aafb1d9$export$c0183dbab98ca63e = (0, $1oZW9.default)({
    light: $d559b0654aafb1d9$export$29a4f05edc054374,
    dark: $d559b0654aafb1d9$export$8e8133c1ba5845b5
});
var $d559b0654aafb1d9$export$6f093cfa640b7166 = (0, $1oZW9.default)({
    light: $d559b0654aafb1d9$export$fbda843f0a27fe96,
    dark: $d559b0654aafb1d9$export$5368d76ae4fbbda7
});
var $d559b0654aafb1d9$export$42f8e9c698766e7a = (0, $1oZW9.default)({
    light: $d559b0654aafb1d9$export$7d61b15e0da132af,
    dark: $d559b0654aafb1d9$export$5368d76ae4fbbda7
});
var $d559b0654aafb1d9$export$c2d157ca1c34b6e3 = (0, $1oZW9.default)({
    light: $d559b0654aafb1d9$export$b3de0ae08da2ce64,
    dark: $d559b0654aafb1d9$export$b3de0ae08da2ce64
});
var $d559b0654aafb1d9$export$1905ba28d7cf066f = (0, $1oZW9.default)({
    light: $d559b0654aafb1d9$export$f563ee71e9ee74cd,
    dark: $d559b0654aafb1d9$export$97e81faa16a182c7
});
var $d559b0654aafb1d9$export$bd9002130d306d39 = (0, $1oZW9.default)({
    light: $d559b0654aafb1d9$export$d6447c357493214f,
    dark: $d559b0654aafb1d9$export$bfe21c59123ecf33
});
var $d559b0654aafb1d9$export$46e4a324ac90507f = (0, $1oZW9.default)({
    light: $d559b0654aafb1d9$export$7d61b15e0da132af,
    dark: $d559b0654aafb1d9$export$5368d76ae4fbbda7
});
var $d559b0654aafb1d9$export$79f3f2b82beb0d36 = (0, $1oZW9.default)({
    light: $d559b0654aafb1d9$export$f563ee71e9ee74cd,
    dark: $d559b0654aafb1d9$export$97e81faa16a182c7
});
var $d559b0654aafb1d9$export$7bb0d5c671655cc4 = (0, $1oZW9.default)({
    light: $d559b0654aafb1d9$export$9fdfb749e33cdf97,
    dark: $d559b0654aafb1d9$export$8e8133c1ba5845b5
});
var $d559b0654aafb1d9$export$9c30223ca0a664fb = (0, $1oZW9.default)({
    light: $d559b0654aafb1d9$export$b3de0ae08da2ce64,
    dark: $d559b0654aafb1d9$export$ecfc1dff386a3e7a
});
var $d559b0654aafb1d9$export$7ed258b0728b004b = (0, $1oZW9.default)({
    light: $d559b0654aafb1d9$export$e62e8919cca44969,
    dark: $d559b0654aafb1d9$export$215b7063051591f1
});
var $d559b0654aafb1d9$export$dfa920d8decc8a59 = (0, $1oZW9.default)({
    light: $d559b0654aafb1d9$export$a6ee3d71bc067634,
    dark: $d559b0654aafb1d9$export$ecfc1dff386a3e7a
});
var $d559b0654aafb1d9$export$6069e6ad5c78f632 = (0, $1oZW9.default)({
    light: $d559b0654aafb1d9$export$ecfc1dff386a3e7a,
    dark: $d559b0654aafb1d9$export$215b7063051591f1
});
var $d559b0654aafb1d9$export$9ad721cf3b3debe0 = (0, $1oZW9.default)({
    light: $d559b0654aafb1d9$export$b3de0ae08da2ce64,
    dark: $d559b0654aafb1d9$export$ecfc1dff386a3e7a
});
var $d559b0654aafb1d9$export$2aa0182783e7e9de = (0, $1oZW9.default)({
    light: $d559b0654aafb1d9$export$b3de0ae08da2ce64,
    dark: $d559b0654aafb1d9$export$ecfc1dff386a3e7a
});
var $d559b0654aafb1d9$export$8bf7dff220b82b4a = (0, $1oZW9.default)({
    light: $d559b0654aafb1d9$export$9dc1ef0f3f48059b,
    dark: $d559b0654aafb1d9$export$69cb3ca10c1e330e
});
var $d559b0654aafb1d9$export$e13cce2a2d16a9d4 = (0, $1oZW9.default)({
    light: $d559b0654aafb1d9$export$b48405b95304b5a1,
    dark: $d559b0654aafb1d9$export$6011520a64d9a187
});
var $d559b0654aafb1d9$export$a90204d1394caf30 = (0, $1oZW9.default)({
    light: $d559b0654aafb1d9$export$4a7404f376229999,
    dark: $d559b0654aafb1d9$export$4a7404f376229999
});
var $d559b0654aafb1d9$export$594c5a8758200c32 = (0, $1oZW9.default)({
    light: $d559b0654aafb1d9$export$c6930421db9fa514,
    dark: $d559b0654aafb1d9$export$c6930421db9fa514
});
var $d559b0654aafb1d9$export$955a2ebd2fb142ae = (0, $1oZW9.default)({
    light: $d559b0654aafb1d9$export$940e1f69e873f202,
    dark: $d559b0654aafb1d9$export$940e1f69e873f202
});
var $d559b0654aafb1d9$export$2a0674ff2eb10214 = function skeleton() {
    return $d559b0654aafb1d9$export$8d43898f60b96a82;
};

});
parcelRegister("1oZW9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $105813b1c74f6da2$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $dNsKU = parcelRequire("dNsKU");
// Unpack custom variants, and get correct value for the current theme
function $105813b1c74f6da2$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $dNsKU.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $105813b1c74f6da2$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $105813b1c74f6da2$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $dNsKU.default)(props); // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("dNsKU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0b62834b299bc8c$export$2e2bcd8739ae039; });
// ideally this would be fetched from ../constants but that causes a
// circular dep loop. This will be refactored as part of a breaking
// change in the future.
var $a0b62834b299bc8c$var$DEFAULT_THEME_MODE = "light";
var $a0b62834b299bc8c$var$THEME_MODES = [
    "light",
    "dark"
]; // Resolves the different types of theme objects in the current API
function $a0b62834b299bc8c$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ("__ATLASKIT_THEME__" in props.theme) return props.theme.__ATLASKIT_THEME__;
        else if ("mode" in props.theme && $a0b62834b299bc8c$var$THEME_MODES.includes(props.theme.mode)) return props.theme;
    } // If format not supported (or no theme provided), return standard theme
    return {
        mode: $a0b62834b299bc8c$var$DEFAULT_THEME_MODE
    };
}

});




parcelRegister("2wyt9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d694ecf44cb7251$export$2e2bcd8739ae039; });

var $ijEQN = parcelRequire("ijEQN");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $1d694ecf44cb7251$var$fadedB75 = "rgba(179, 212, 255, 0.6)";
var $1d694ecf44cb7251$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: $ijEQN.N20A,
                dark: $ijEQN.DN70
            },
            hover: {
                light: $ijEQN.N30A,
                dark: $ijEQN.DN60
            },
            active: {
                light: $1d694ecf44cb7251$var$fadedB75,
                dark: $ijEQN.B75
            },
            disabled: {
                light: $ijEQN.N20A,
                dark: $ijEQN.DN70
            },
            selected: {
                light: $ijEQN.N700,
                dark: $ijEQN.DN0
            },
            focusSelected: {
                light: $ijEQN.N700,
                dark: $ijEQN.DN0
            }
        },
        primary: {
            default: {
                light: $ijEQN.B400,
                dark: $ijEQN.B100
            },
            hover: {
                light: $ijEQN.B300,
                dark: $ijEQN.B75
            },
            active: {
                light: $ijEQN.B500,
                dark: $ijEQN.B200
            },
            disabled: {
                light: $ijEQN.N20A,
                dark: $ijEQN.DN70
            },
            selected: {
                light: $ijEQN.N700,
                dark: $ijEQN.DN0
            },
            focusSelected: {
                light: $ijEQN.N700,
                dark: $ijEQN.DN0
            }
        },
        warning: {
            default: {
                light: $ijEQN.Y300,
                dark: $ijEQN.Y300
            },
            hover: {
                light: $ijEQN.Y200,
                dark: $ijEQN.Y200
            },
            active: {
                light: $ijEQN.Y400,
                dark: $ijEQN.Y400
            },
            disabled: {
                light: $ijEQN.N20A,
                dark: $ijEQN.DN70
            },
            selected: {
                light: $ijEQN.Y400,
                dark: $ijEQN.Y400
            },
            focusSelected: {
                light: $ijEQN.Y400,
                dark: $ijEQN.Y400
            }
        },
        danger: {
            default: {
                light: $ijEQN.R400,
                dark: $ijEQN.R400
            },
            hover: {
                light: $ijEQN.R300,
                dark: $ijEQN.R300
            },
            active: {
                light: $ijEQN.R500,
                dark: $ijEQN.R500
            },
            disabled: {
                light: $ijEQN.N20A,
                dark: $ijEQN.DN70
            },
            selected: {
                light: $ijEQN.R500,
                dark: $ijEQN.R500
            },
            focusSelected: {
                light: $ijEQN.R500,
                dark: $ijEQN.R500
            }
        },
        link: {
            default: {
                light: "none",
                dark: "none"
            },
            selected: {
                light: $ijEQN.N700,
                dark: $ijEQN.N20
            },
            focusSelected: {
                light: $ijEQN.N700,
                dark: $ijEQN.N20
            }
        },
        subtle: {
            default: {
                light: "none",
                dark: "none"
            },
            hover: {
                light: $ijEQN.N30A,
                dark: $ijEQN.DN60
            },
            active: {
                light: $1d694ecf44cb7251$var$fadedB75,
                dark: $ijEQN.B75
            },
            disabled: {
                light: "none",
                dark: "none"
            },
            selected: {
                light: $ijEQN.N700,
                dark: $ijEQN.DN0
            },
            focusSelected: {
                light: $ijEQN.N700,
                dark: $ijEQN.DN0
            }
        },
        "subtle-link": {
            default: {
                light: "none",
                dark: "none"
            },
            selected: {
                light: $ijEQN.N700,
                dark: $ijEQN.N20
            },
            focusSelected: {
                light: $ijEQN.N700,
                dark: $ijEQN.N20
            }
        }
    },
    boxShadowColor: {
        default: {
            focus: {
                light: $ijEQN.B100,
                dark: $ijEQN.B75
            },
            focusSelected: {
                light: $ijEQN.B100,
                dark: $ijEQN.B75
            }
        },
        primary: {
            focus: {
                light: $ijEQN.B100,
                dark: $ijEQN.B75
            },
            focusSelected: {
                light: $ijEQN.B100,
                dark: $ijEQN.B75
            }
        },
        warning: {
            focus: {
                light: $ijEQN.Y500,
                dark: $ijEQN.Y500
            },
            focusSelected: {
                light: $ijEQN.Y500,
                dark: $ijEQN.Y500
            }
        },
        danger: {
            focus: {
                light: $ijEQN.R100,
                dark: $ijEQN.R100
            },
            focusSelected: {
                light: $ijEQN.R100,
                dark: $ijEQN.R100
            }
        },
        link: {
            focus: {
                light: $ijEQN.B100,
                dark: $ijEQN.B75
            },
            focusSelected: {
                light: $ijEQN.B100,
                dark: $ijEQN.B75
            }
        },
        subtle: {
            focus: {
                light: $ijEQN.B100,
                dark: $ijEQN.B75
            },
            focusSelected: {
                light: $ijEQN.B100,
                dark: $ijEQN.B75
            }
        },
        "subtle-link": {
            focus: {
                light: $ijEQN.B100,
                dark: $ijEQN.B75
            },
            focusSelected: {
                light: $ijEQN.B100,
                dark: $ijEQN.B75
            }
        }
    },
    color: {
        default: {
            default: {
                light: $ijEQN.N500,
                dark: $ijEQN.DN400
            },
            active: {
                light: $ijEQN.B400,
                dark: $ijEQN.B400
            },
            disabled: {
                light: $ijEQN.N70,
                dark: $ijEQN.DN30
            },
            selected: {
                light: $ijEQN.N20,
                dark: $ijEQN.DN400
            },
            focusSelected: {
                light: $ijEQN.N20,
                dark: $ijEQN.DN400
            }
        },
        primary: {
            default: {
                light: $ijEQN.N0,
                dark: $ijEQN.DN30
            },
            disabled: {
                light: $ijEQN.N70,
                dark: $ijEQN.DN30
            },
            selected: {
                light: $ijEQN.N20,
                dark: $ijEQN.DN400
            },
            focusSelected: {
                light: $ijEQN.N20,
                dark: $ijEQN.DN400
            }
        },
        warning: {
            default: {
                light: $ijEQN.N800,
                dark: $ijEQN.N800
            },
            disabled: {
                light: $ijEQN.N70,
                dark: $ijEQN.DN30
            },
            selected: {
                light: $ijEQN.N800,
                dark: $ijEQN.N800
            },
            focusSelected: {
                light: $ijEQN.N800,
                dark: $ijEQN.N800
            }
        },
        danger: {
            default: {
                light: $ijEQN.N0,
                dark: $ijEQN.N0
            },
            disabled: {
                light: $ijEQN.N70,
                dark: $ijEQN.DN30
            },
            selected: {
                light: $ijEQN.N0,
                dark: $ijEQN.N0
            },
            focusSelected: {
                light: $ijEQN.N0,
                dark: $ijEQN.N0
            }
        },
        link: {
            default: {
                light: $ijEQN.B400,
                dark: $ijEQN.B100
            },
            hover: {
                light: $ijEQN.B300,
                dark: $ijEQN.B75
            },
            active: {
                light: $ijEQN.B500,
                dark: $ijEQN.B200
            },
            disabled: {
                light: $ijEQN.N70,
                dark: $ijEQN.DN100
            },
            selected: {
                light: $ijEQN.N20,
                dark: $ijEQN.N700
            },
            focusSelected: {
                light: $ijEQN.N20,
                dark: $ijEQN.N700
            }
        },
        subtle: {
            default: {
                light: $ijEQN.N500,
                dark: $ijEQN.DN400
            },
            active: {
                light: $ijEQN.B400,
                dark: $ijEQN.B400
            },
            disabled: {
                light: $ijEQN.N70,
                dark: $ijEQN.DN100
            },
            selected: {
                light: $ijEQN.N20,
                dark: $ijEQN.DN400
            },
            focusSelected: {
                light: $ijEQN.N20,
                dark: $ijEQN.DN400
            }
        },
        "subtle-link": {
            default: {
                light: $ijEQN.N200,
                dark: $ijEQN.DN400
            },
            hover: {
                light: $ijEQN.N90,
                dark: $ijEQN.B50
            },
            active: {
                light: $ijEQN.N400,
                dark: $ijEQN.DN300
            },
            disabled: {
                light: $ijEQN.N70,
                dark: $ijEQN.DN100
            },
            selected: {
                light: $ijEQN.N20,
                dark: $ijEQN.DN400
            },
            focusSelected: {
                light: $ijEQN.N20,
                dark: $ijEQN.DN400
            }
        }
    }
};
var $1d694ecf44cb7251$export$2e2bcd8739ae039 = $1d694ecf44cb7251$var$values;

});



parcelRegister("lALvD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb81d016b01d8cd2$export$2e2bcd8739ae039; });
function $fb81d016b01d8cd2$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});

parcelRegister("4NDZB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37eac2b5a3e5000e$export$2e2bcd8739ae039; });

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $dEKDm = parcelRequire("dEKDm");
function $37eac2b5a3e5000e$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return "inherit";
    if (isSelected) return "invert";
    if (appearance === "primary" || appearance === "danger") return "invert";
    return "inherit";
}
function $37eac2b5a3e5000e$export$2e2bcd8739ae039(_ref2) {
    var _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref2, [
        "spacing"
    ]);
    var size = spacing === "default" ? "medium" : "small";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dEKDm.default), {
        size: size,
        appearance: $37eac2b5a3e5000e$var$getSpinnerAppearance(rest)
    });
}

});

parcelRegister("c8UwA", function(module, exports) {

$parcel$export(module.exports, "getSpecifiers", function () { return $8d7213fb6ff7bda3$export$643db0b8d8778e; });
$parcel$export(module.exports, "defaultThemeFn", function () { return $8d7213fb6ff7bda3$export$437a7f77d13d7916; });
$parcel$export(module.exports, "default", function () { return $8d7213fb6ff7bda3$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $eTATz = parcelRequire("eTATz");

var $4oi81 = parcelRequire("4oi81");
function $8d7213fb6ff7bda3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8d7213fb6ff7bda3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $8d7213fb6ff7bda3$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $8d7213fb6ff7bda3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $8d7213fb6ff7bda3$var$stateToSelectorMap = {
    focus: "&:focus",
    focusSelected: "&:focus",
    hover: "&:hover",
    active: "&:active",
    disabled: "&[disabled]"
}; // Mapping the new clean css back to the legacy theme format.
function $8d7213fb6ff7bda3$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? "light" : _ref$mode, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $4oi81.getCss)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    }); // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pesduo states at a time
    result.outline = "none"; // Pulling relevant styles up to the top level
    var selector = $8d7213fb6ff7bda3$var$stateToSelectorMap[state];
    if (selector) result = $8d7213fb6ff7bda3$var$_objectSpread($8d7213fb6ff7bda3$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $8d7213fb6ff7bda3$var$_objectSpread($8d7213fb6ff7bda3$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
     // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === "&::-moz-focus-inner") return;
         // Not using .startsWith for ie11
        if (key.indexOf("&") === 0) delete result[key];
    });
    return result;
} // This styling approach works by generating a 'style' and applying with maximum specificity
function $8d7213fb6ff7bda3$export$643db0b8d8778e(styles) {
    return {
        "&, &:hover, &:active, &:focus, &:visited, &:disabled, &[disabled]": styles
    };
}
function $8d7213fb6ff7bda3$export$437a7f77d13d7916(current, values) {
    return current(values);
}
var $8d7213fb6ff7bda3$var$Theme = (0, $eTATz.createTheme)(function(themeProps) {
    return {
        buttonStyles: $8d7213fb6ff7bda3$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var $8d7213fb6ff7bda3$export$2e2bcd8739ae039 = $8d7213fb6ff7bda3$var$Theme;

});


parcelRegister("iYKuS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd11e5f3349c7c7a$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");

var $13MK1 = parcelRequire("13MK1");

var $2GEmJ = parcelRequire("2GEmJ");
var $aGitN = parcelRequire("aGitN");
var $kaBIb = parcelRequire("kaBIb");

var $8GDLw = parcelRequire("8GDLw");

var $dEKDm = parcelRequire("dEKDm");

var $eNY11 = parcelRequire("eNY11");

var $dR75f = parcelRequire("dR75f");

var $kRKEY = parcelRequire("kRKEY");

var $4afMH = parcelRequire("4afMH");
var $dd11e5f3349c7c7a$var$halfFocusRing = 1;
var $dd11e5f3349c7c7a$var$dropOffset = "0, ".concat((0, $eNY11.gridSize)(), "px");
var $dd11e5f3349c7c7a$export$829cf44cbfb2eea1 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(Droplist, _Component);
    function Droplist() {
        var _getPrototypeOf2;
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, Droplist);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, (_getPrototypeOf2 = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Droplist)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "componentDidMount", function() {
            _this.setContentWidth(); // We use a captured event here to avoid a radio or checkbox dropdown item firing its
            // click event first, which would cause a re-render of the element and prevent Droplist
            // from detecting the actual source of this original click event.
            document.addEventListener("click", _this.handleClickOutside, true);
            document.addEventListener("keydown", _this.handleEsc);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "componentDidUpdate", function() {
            if (_this.props.isOpen) _this.setContentWidth();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "componentWillUnmount", function() {
            document.removeEventListener("click", _this.handleClickOutside, true);
            document.removeEventListener("keydown", _this.handleEsc);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "setContentWidth", function() {
            var _assertThisInitialize = (0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), dropContentRef = _assertThisInitialize.dropContentRef, triggerRef = _assertThisInitialize.triggerRef;
            var shouldFitContainer = _this.props.shouldFitContainer; // We need to manually set the content width to match the trigger width
            // if props.shouldFitContainer is true
            if (shouldFitContainer && dropContentRef && triggerRef) dropContentRef.style.width = "".concat(triggerRef.offsetWidth - $dd11e5f3349c7c7a$var$halfFocusRing * 2, "px");
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleEsc", function(event) {
            if ((event.key === "Escape" || event.key === "Esc") && _this.props.isOpen) _this.close(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleClickOutside", function(event) {
            if (_this.props.isOpen) {
                if (event.target instanceof Node) {
                    // Rather than check for the target within the entire Droplist, we specify the trigger/content.
                    // This aids with future effort in scroll-locking Droplist when isMenuFixed is enabled; the scroll
                    // blanket which stretches to the viewport should not stop 'close' from being triggered.
                    var withinTrigger = _this.triggerRef && _this.triggerRef.contains(event.target);
                    var withinContent = _this.dropContentRef && _this.dropContentRef.contains(event.target);
                    if (!withinTrigger && !withinContent) _this.close(event);
                }
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "close", function(event) {
            if (_this.props.onOpenChange) _this.props.onOpenChange({
                isOpen: false,
                event: event
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleContentRef", function(ref) {
            _this.dropContentRef = ref; // If the dropdown has just been opened, we focus on the containing element so the
            // user can tab to the first dropdown item. We will only receive this ref if isOpen
            // is true or null, so no need to check for truthiness here.
            if (ref) ref.focus();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleTriggerRef", function(ref) {
            _this.triggerRef = ref;
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(Droplist, [
        {
            key: "getChildContext",
            value: function getChildContext() {
                return {
                    shouldAllowMultilineItems: this.props.shouldAllowMultilineItems
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, appearance = _this$props.appearance, boundariesElement = _this$props.boundariesElement, children = _this$props.children, isLoading = _this$props.isLoading, isOpen = _this$props.isOpen, maxHeight = _this$props.maxHeight, onClick = _this$props.onClick, onKeyDown = _this$props.onKeyDown, position = _this$props.position, isMenuFixed = _this$props.isMenuFixed, shouldFitContainer = _this$props.shouldFitContainer, shouldFlip = _this$props.shouldFlip, trigger = _this$props.trigger, onPositioned = _this$props.onPositioned, testId = _this$props.testId;
                var layerContent = isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dR75f.Content), {
                    "data-role": "droplistContent",
                    "data-testid": testId && "".concat(testId, "--content"),
                    isTall: appearance === "tall",
                    innerRef: this.handleContentRef,
                    maxHeight: maxHeight
                }, isLoading ? (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dR75f.SpinnerContainer), null, (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dEKDm.default), {
                    size: "small"
                })) : (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $13MK1.ThemeProvider), {
                    theme: (0, $kRKEY.default)
                }, (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", null, children))) : null;
                return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dR75f.default), {
                    fit: shouldFitContainer,
                    onClick: onClick,
                    onKeyDown: onKeyDown
                }, (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $8GDLw.default), {
                    autoFlip: shouldFlip,
                    boundariesElement: boundariesElement,
                    content: layerContent,
                    offset: $dd11e5f3349c7c7a$var$dropOffset,
                    position: position,
                    isAlwaysFixed: isOpen && isMenuFixed,
                    onPositioned: onPositioned
                }, (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dR75f.Trigger), {
                    fit: shouldFitContainer,
                    innerRef: this.handleTriggerRef
                }, trigger)));
            }
        }
    ]);
    return Droplist;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($dd11e5f3349c7c7a$export$829cf44cbfb2eea1, "defaultProps", {
    appearance: "default",
    boundariesElement: "viewport",
    children: null,
    isLoading: false,
    isOpen: false,
    onClick: function onClick() {},
    onKeyDown: function onKeyDown() {},
    onOpenChange: function onOpenChange() {},
    position: "bottom left",
    isMenuFixed: false,
    shouldAllowMultilineItems: false,
    shouldFitContainer: false,
    shouldFlip: true,
    trigger: null,
    onPositioned: function onPositioned() {}
});
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($dd11e5f3349c7c7a$export$829cf44cbfb2eea1, "childContextTypes", {
    shouldAllowMultilineItems: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).bool
});
var $dd11e5f3349c7c7a$var$createAndFireEventOnAtlaskit = (0, $2GEmJ.default)("atlaskit");
var $dd11e5f3349c7c7a$export$2e2bcd8739ae039 = (0, $aGitN.default)({
    componentName: "droplist",
    packageName: (0, $4afMH.name),
    packageVersion: (0, $4afMH.version)
})((0, $kaBIb.default)({
    onOpenChange: $dd11e5f3349c7c7a$var$createAndFireEventOnAtlaskit({
        action: "toggled",
        actionSubject: "droplist",
        attributes: {
            componentName: "droplist",
            packageName: (0, $4afMH.name),
            packageVersion: (0, $4afMH.version)
        }
    })
})($dd11e5f3349c7c7a$export$829cf44cbfb2eea1));

});
parcelRegister("2GEmJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f4ed0cb75ad10c8$export$2e2bcd8739ae039; });
var $1f4ed0cb75ad10c8$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};

});

parcelRegister("aGitN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c6c2948ca54fe35$export$2e2bcd8739ae039; });

var $5Rl6H = parcelRequire("5Rl6H");

var $9nHZC = parcelRequire("9nHZC");

var $9Umis = parcelRequire("9Umis");
var $7c6c2948ca54fe35$var$withAnalyticsContext = function(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = (0, $9nHZC.forwardRef)(function(_a, ref) {
            var analyticsContext = _a.analyticsContext, rest = (0, $5Rl6H.__rest)(_a, [
                "analyticsContext"
            ]);
            var analyticsData = (0, $9nHZC.useMemo)(function() {
                return (0, $5Rl6H.__assign)((0, $5Rl6H.__assign)({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9Umis.default), {
                data: analyticsData
            }, (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedComponent, (0, $5Rl6H.__assign)({}, rest, {
                ref: ref
            })));
        });
        // @ts-ignore
        WithAnalyticsContext.displayName = "WithAnalyticsContext(" + // @ts-ignore disneyName doesn't exist on type
        (WrappedComponent.displayName || WrappedComponent.name) + ")";
        return WithAnalyticsContext;
    };
};
var $7c6c2948ca54fe35$export$2e2bcd8739ae039 = $7c6c2948ca54fe35$var$withAnalyticsContext;

});
parcelRegister("5Rl6H", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $4442466e24ba8fb5$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $4442466e24ba8fb5$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $4442466e24ba8fb5$export$3c9a16f847548506; });
$parcel$export(module.exports, "__spread", function () { return $4442466e24ba8fb5$export$afc72e2116322959; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $4442466e24ba8fb5$var$extendStatics = function(d, b) {
    $4442466e24ba8fb5$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $4442466e24ba8fb5$var$extendStatics(d, b);
};
function $4442466e24ba8fb5$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $4442466e24ba8fb5$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $4442466e24ba8fb5$export$18ce0697a983be9b = function() {
    $4442466e24ba8fb5$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4442466e24ba8fb5$export$18ce0697a983be9b.apply(this, arguments);
};
function $4442466e24ba8fb5$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $4442466e24ba8fb5$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $4442466e24ba8fb5$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $4442466e24ba8fb5$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $4442466e24ba8fb5$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $4442466e24ba8fb5$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $4442466e24ba8fb5$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $4442466e24ba8fb5$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $4442466e24ba8fb5$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $4442466e24ba8fb5$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $4442466e24ba8fb5$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $4442466e24ba8fb5$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $4442466e24ba8fb5$export$45d3717a4c69092e(o, m, p);
}
function $4442466e24ba8fb5$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $4442466e24ba8fb5$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $4442466e24ba8fb5$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($4442466e24ba8fb5$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $4442466e24ba8fb5$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $4442466e24ba8fb5$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $4442466e24ba8fb5$export$10c90e4f7922046c(v) {
    return this instanceof $4442466e24ba8fb5$export$10c90e4f7922046c ? (this.v = v, this) : new $4442466e24ba8fb5$export$10c90e4f7922046c(v);
}
function $4442466e24ba8fb5$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $4442466e24ba8fb5$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $4442466e24ba8fb5$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $4442466e24ba8fb5$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $4442466e24ba8fb5$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $4442466e24ba8fb5$export$19a8beecd37a4c45 === "function" ? $4442466e24ba8fb5$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $4442466e24ba8fb5$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $4442466e24ba8fb5$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $4442466e24ba8fb5$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4442466e24ba8fb5$export$45d3717a4c69092e(result, mod, k);
    }
    $4442466e24ba8fb5$var$__setModuleDefault(result, mod);
    return result;
}
function $4442466e24ba8fb5$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $4442466e24ba8fb5$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $4442466e24ba8fb5$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $4442466e24ba8fb5$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $4442466e24ba8fb5$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $4442466e24ba8fb5$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $4442466e24ba8fb5$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $4442466e24ba8fb5$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $4442466e24ba8fb5$export$2e2bcd8739ae039 = {
    __extends: $4442466e24ba8fb5$export$a8ba968b8961cb8a,
    __assign: $4442466e24ba8fb5$export$18ce0697a983be9b,
    __rest: $4442466e24ba8fb5$export$3c9a16f847548506,
    __decorate: $4442466e24ba8fb5$export$29e00dfd3077644b,
    __param: $4442466e24ba8fb5$export$d5ad3fd78186038f,
    __metadata: $4442466e24ba8fb5$export$f1db080c865becb9,
    __awaiter: $4442466e24ba8fb5$export$1050f835b63b671e,
    __generator: $4442466e24ba8fb5$export$67ebef60e6f28a6,
    __createBinding: $4442466e24ba8fb5$export$45d3717a4c69092e,
    __exportStar: $4442466e24ba8fb5$export$f33643c0debef087,
    __values: $4442466e24ba8fb5$export$19a8beecd37a4c45,
    __read: $4442466e24ba8fb5$export$8d051b38c9118094,
    __spread: $4442466e24ba8fb5$export$afc72e2116322959,
    __spreadArrays: $4442466e24ba8fb5$export$6388937ca91ccae8,
    __spreadArray: $4442466e24ba8fb5$export$1216008129fb82ed,
    __await: $4442466e24ba8fb5$export$10c90e4f7922046c,
    __asyncGenerator: $4442466e24ba8fb5$export$e427f37a30a4de9b,
    __asyncDelegator: $4442466e24ba8fb5$export$bbd80228419bb833,
    __asyncValues: $4442466e24ba8fb5$export$e3b29a3d6162315f,
    __makeTemplateObject: $4442466e24ba8fb5$export$4fb47efe1390b86f,
    __importStar: $4442466e24ba8fb5$export$c21735bcef00d192,
    __importDefault: $4442466e24ba8fb5$export$da59b14a69baef04,
    __classPrivateFieldGet: $4442466e24ba8fb5$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $4442466e24ba8fb5$export$d40a35129aaff81f,
    __classPrivateFieldIn: $4442466e24ba8fb5$export$81fdc39f203e4e04,
    __addDisposableResource: $4442466e24ba8fb5$export$88ac25d8e944e405,
    __disposeResources: $4442466e24ba8fb5$export$8f076105dc360e92
};

});

parcelRegister("9Umis", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $736aa3abe9625532$export$2e2bcd8739ae039; });

var $abOVt = parcelRequire("abOVt");

var $736aa3abe9625532$var$ExportedAnalyticsContext;
$736aa3abe9625532$var$ExportedAnalyticsContext = (0, $abOVt.default);
var $736aa3abe9625532$export$2e2bcd8739ae039 = $736aa3abe9625532$var$ExportedAnalyticsContext;

});
parcelRegister("abOVt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76b26f53de9dce55$export$2e2bcd8739ae039; });

var $5Rl6H = parcelRequire("5Rl6H");

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");

var $kZnbM = parcelRequire("kZnbM");
var $76b26f53de9dce55$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func
};
var $76b26f53de9dce55$var$noop = function() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $76b26f53de9dce55$var$AnalyticsContext = /** @class */ function(_super) {
    (0, $5Rl6H.__extends)(AnalyticsContext, _super);
    function AnalyticsContext(props) {
        var _this = _super.call(this, props) || this;
        _this.getChildContext = function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        };
        _this.getAnalyticsContext = function() {
            var data = _this.props.data;
            var _a = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _a === void 0 ? $76b26f53de9dce55$var$noop : _a;
            return (0, $5Rl6H.__spread)(getAtlaskitAnalyticsContext(), [
                data
            ]);
        };
        _this.getAnalyticsEventHandlers = function() {
            var _a = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _a === void 0 ? $76b26f53de9dce55$var$noop : _a;
            return getAtlaskitAnalyticsEventHandlers();
        };
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    AnalyticsContext.prototype.render = function() {
        var children = this.props.children;
        return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kZnbM.default).Provider, {
            value: this.contextValue
        }, children);
    };
    AnalyticsContext.contextTypes = $76b26f53de9dce55$var$ContextTypes;
    AnalyticsContext.childContextTypes = $76b26f53de9dce55$var$ContextTypes;
    return AnalyticsContext;
}((0, $9nHZC.Component));
var $76b26f53de9dce55$export$2e2bcd8739ae039 = $76b26f53de9dce55$var$AnalyticsContext;

});



parcelRegister("kaBIb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eaf1fe955e5e3718$export$2e2bcd8739ae039; });

var $5Rl6H = parcelRequire("5Rl6H");

var $9nHZC = parcelRequire("9nHZC");

var $e9td0 = parcelRequire("e9td0");

var $izVDI = parcelRequire("izVDI");
var $eaf1fe955e5e3718$var$withAnalyticsEvents = function(createEventMap) {
    if (createEventMap === void 0) createEventMap = {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = (0, $9nHZC.forwardRef)(function(props, ref) {
            var patchedEventProps = (0, $izVDI.usePatchedProps)(createEventMap, props).patchedEventProps;
            var createAnalyticsEvent = (0, $e9td0.useAnalyticsEvents)().createAnalyticsEvent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedComponent, (0, $5Rl6H.__assign)({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        // @ts-ignore
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(" + // @ts-ignore disneyName doesn't exist on type
        (WrappedComponent.displayName || WrappedComponent.name) + ")";
        return WithAnalyticsEvents;
    };
};
var $eaf1fe955e5e3718$export$2e2bcd8739ae039 = $eaf1fe955e5e3718$var$withAnalyticsEvents;

});
parcelRegister("e9td0", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $a4d89030700580b3$export$5bf35293e545f20c; });

var $dNznA = parcelRequire("dNznA");

var $611bh = parcelRequire("611bh");

var $dHS3c = parcelRequire("dHS3c");
function $a4d89030700580b3$export$5bf35293e545f20c() {
    var analyticsContext = (0, $dHS3c.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $611bh.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("611bh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4613c091c3e6ca2f$export$2e2bcd8739ae039; });

var $5Rl6H = parcelRequire("5Rl6H");

var $7l6FV = parcelRequire("7l6FV");
var $4613c091c3e6ca2f$var$UIAnalyticsEvent = /** @class */ function(_super) {
    (0, $5Rl6H.__extends)(UIAnalyticsEvent, _super);
    function UIAnalyticsEvent(props) {
        var _this = _super.call(this, props) || this;
        _this.clone = function() {
            if (_this.hasFired) return null;
            var context = (0, $5Rl6H.__spread)(_this.context);
            var handlers = (0, $5Rl6H.__spread)(_this.handlers);
            /**
             * A hacky "deep clone" of the object. This is limited in that it wont
             * support functions, regexs, Maps, Sets, etc, but none of those need to
             * be represented in our payload.
             */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        };
        _this.fire = function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        };
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    UIAnalyticsEvent.prototype.update = function(updater) {
        if (this.hasFired) return this;
        return _super.prototype.update.call(this, updater);
    };
    return UIAnalyticsEvent;
}((0, $7l6FV.default));
var $4613c091c3e6ca2f$export$2e2bcd8739ae039 = $4613c091c3e6ca2f$var$UIAnalyticsEvent;

});
parcelRegister("7l6FV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $557fac1bd542c59d$export$2e2bcd8739ae039; });

var $5Rl6H = parcelRequire("5Rl6H");
var $557fac1bd542c59d$var$AnalyticsEvent = /** @class */ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        this.clone = function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = (0, $5Rl6H.__assign)({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        };
        this.payload = props.payload;
    }
    AnalyticsEvent.prototype.update = function(updater) {
        if (typeof updater === "function") this.payload = updater(this.payload);
        if (typeof updater === "object") this.payload = (0, $5Rl6H.__assign)((0, $5Rl6H.__assign)({}, this.payload), updater);
        return this;
    };
    return AnalyticsEvent;
}();
var $557fac1bd542c59d$export$2e2bcd8739ae039 = $557fac1bd542c59d$var$AnalyticsEvent;

});


parcelRegister("dHS3c", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $02933ed5f51b1b13$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $02933ed5f51b1b13$export$d1f587f82ad51c4 = function() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});


parcelRegister("izVDI", function(module, exports) {

$parcel$export(module.exports, "usePatchedProps", function () { return $d86834e96ddf949c$export$9ebb5a84d17e5d18; });

var $5Rl6H = parcelRequire("5Rl6H");

var $9nHZC = parcelRequire("9nHZC");

var $e9td0 = parcelRequire("e9td0");
function $d86834e96ddf949c$export$9ebb5a84d17e5d18(createEventMap, wrappedComponentProps) {
    if (createEventMap === void 0) createEventMap = {};
    var createAnalyticsEvent = (0, $e9td0.useAnalyticsEvents)().createAnalyticsEvent;
    var patchedProps = (0, $9nHZC.useMemo)(function() {
        return Object.keys(createEventMap).reduce(function(p, k) {
            var _a;
            var eventCreator = createEventMap[k];
            if (![
                "object",
                "function"
            ].includes(typeof eventCreator)) return p;
            var propValue = wrappedComponentProps[k];
            var wrappedCallback = function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var analyticsEvent = typeof eventCreator === "function" ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === "function") propValue.apply(void 0, (0, $5Rl6H.__spread)(args, [
                    analyticsEvent
                ]));
            };
            return wrappedCallback ? (0, $5Rl6H.__assign)((0, $5Rl6H.__assign)({}, p), (_a = {}, _a[k] = wrappedCallback, _a)) : p;
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});


parcelRegister("8GDLw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65311796a3b0af4d$export$2e2bcd8739ae039; });

var $gQ7Yy = parcelRequire("gQ7Yy");

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $13MK1 = parcelRequire("13MK1");

var $i5NQ5 = parcelRequire("i5NQ5");

var $3QoZZ = parcelRequire("3QoZZ");

var $a8UI6 = parcelRequire("a8UI6");

var $8AbYI = parcelRequire("8AbYI");

var $kiyEg = parcelRequire("kiyEg");
// without affecting child layout of the actual target since children of fixed position elements can't use percentage
// heights/widths.
var $65311796a3b0af4d$var$FixedTarget = (0, $13MK1.default).div.withConfig({
    displayName: "Layer__FixedTarget",
    componentId: "qunuuz-0"
})([
    "\n  ",
    ";\n"
], function(_ref) {
    var fixedOffset = _ref.fixedOffset, targetRef = _ref.targetRef;
    if (fixedOffset && targetRef) {
        var actualTarget = targetRef.firstChild;
        var rect = actualTarget.getBoundingClientRect();
        return "\n        position: fixed;\n        top: ".concat(fixedOffset.top, "px;\n        left: ").concat(fixedOffset.left, "px;\n        height: ").concat(rect.height, "px;\n        width: ").concat(rect.width, "px;\n        z-index: -1;\n      ");
    }
    return "display: none;";
});
var $65311796a3b0af4d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(Layer, _Component);
    // working with extract-react-types
    function Layer(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, Layer);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Layer).call(this, props));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "popper", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "targetRef", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "contentRef", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fixedRef", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "extractStyles", function(state) {
            if (state) {
                var popperHeight = state.offsets.popper.height;
                var left = Math.round(state.offsets.popper.left); // The offset position is sometimes an object and sometimes just a string...
                var cssPosition = (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(state.offsets.popper.position) === "object" ? state.offsets.popper.position.position : state.offsets.popper.position;
                var top = _this.fixPositionTopUnderflow(state.offsets.popper.top, cssPosition);
                var originalHeight = _this.state.originalHeight || popperHeight;
                var maxHeight = _this.calculateMaxHeight(originalHeight, popperHeight, top, cssPosition);
                _this.setState({
                    // position: fixed or absolute
                    cssPosition: cssPosition,
                    hasExtractedStyles: true,
                    transform: "translate3d(".concat(left, "px, ").concat(top, "px, 0px)"),
                    // state.flipped is either true or undefined
                    flipped: !!state.flipped,
                    actualPosition: state.position,
                    originalPosition: state.originalPosition,
                    originalHeight: originalHeight,
                    maxHeight: maxHeight
                });
            }
        });
        _this.state = {
            hasExtractedStyles: false,
            position: null,
            transform: null,
            flipped: false,
            actualPosition: null,
            // We set these default offsets to prevent a flash of popper content in the wrong position
            // which can cause incorrect height calculations. Popper will calculate these values
            offsets: {
                popper: {
                    left: -9999,
                    top: -9999
                }
            },
            originalPosition: null,
            // fix Safari parent width: https://product-fabric.atlassian.net/browse/ED-1784
            cssPosition: "absolute",
            originalHeight: null,
            maxHeight: null,
            fixedOffset: null
        };
        _this.extractStyles = (0, $i5NQ5.default)(_this.extractStyles.bind((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this)));
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(Layer, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.applyPopper(this.props);
                this.calculateFixedOffset(this.props);
            }
        },
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                this.applyPopper(nextProps);
                this.calculateFixedOffset(nextProps);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this$props = this.props, onFlippedChange = _this$props.onFlippedChange, onPositioned = _this$props.onPositioned;
                var _this$state = this.state, flipped = _this$state.flipped, actualPosition = _this$state.actualPosition, originalPosition = _this$state.originalPosition, hasExtractedStyles = _this$state.hasExtractedStyles;
                if (prevState.flipped !== flipped && onFlippedChange) onFlippedChange({
                    flipped: flipped,
                    actualPosition: actualPosition,
                    originalPosition: originalPosition
                });
                 // This flag is set the first time the position is calculated from Popper and applied to the content
                if (!prevState.hasExtractedStyles && hasExtractedStyles && onPositioned) onPositioned();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.extractStyles.cancel();
                if (this.popper) this.popper.destroy();
            }
        },
        {
            key: "calculateMaxHeight",
            value: function calculateMaxHeight(originalHeight, currentHeight, positionTop, cssPosition) {
                var DocumentElementClientHeight = 0;
                if (document.documentElement) DocumentElementClientHeight = document.documentElement.clientHeight;
                if (cssPosition !== "fixed" || this.props.boundariesElement !== "viewport") return null;
                var viewportHeight = Math.max(DocumentElementClientHeight, window.innerHeight || 0);
                return viewportHeight < originalHeight && currentHeight + positionTop >= viewportHeight - 50 ? viewportHeight - 12 : null;
            }
        },
        {
            key: "calculateFixedOffset",
            value: function calculateFixedOffset(props) {
                var isAlwaysFixed = props.isAlwaysFixed;
                if (isAlwaysFixed && this.targetRef) {
                    var actualTarget = this.targetRef.firstChild;
                    this.setState({
                        fixedOffset: {
                            top: actualTarget.getBoundingClientRect().top,
                            left: actualTarget.getBoundingClientRect().left
                        }
                    });
                } else if (!isAlwaysFixed && this.state.fixedOffset !== null) this.setState({
                    fixedOffset: null
                });
            }
        },
        {
            key: "fixPositionTopUnderflow",
            value: function fixPositionTopUnderflow(popperTop, cssPosition) {
                return popperTop >= 0 || cssPosition !== "fixed" ? Math.round(popperTop) : 0;
            }
        },
        {
            key: "applyPopper",
            value: function applyPopper(props) {
                if (!this.fixedRef || !this.targetRef || !this.contentRef) return;
                if (this.popper) this.popper.destroy();
                 // "new Popper(...)" operation is very expensive when called on virtual DOM.
                // This condition reduces the number of calls so we can run our tests faster
                // (time was reduced from 100s to 13s).
                if (!props.content) return;
                 // we wrap our target in a div so that we can safely get a reference to it, but we pass the
                // actual target to popper
                var actualTarget = props.isAlwaysFixed ? this.fixedRef : this.targetRef.firstChild;
                var popperOpts = {
                    placement: (0, $8AbYI.positionPropToPopperPosition)(props.position),
                    onCreate: this.extractStyles,
                    onUpdate: this.extractStyles,
                    modifiers: {
                        applyStyle: {
                            enabled: false
                        },
                        hide: {
                            enabled: false
                        },
                        offset: {
                            enabled: true,
                            offset: this.props.offset
                        },
                        flip: {
                            enabled: !!this.props.autoFlip,
                            flipVariations: true,
                            boundariesElement: this.props.boundariesElement,
                            padding: 0 // leave 0 pixels between popper and the boundariesElement
                        },
                        preventOverflow: {
                            enabled: !!this.props.autoFlip,
                            escapeWithReference: !(this.props.boundariesElement === "scrollParent")
                        }
                    },
                    positionFixed: props.isAlwaysFixed
                };
                var flipBehavior = (0, $8AbYI.getFlipBehavior)(props);
                if (flipBehavior) popperOpts.modifiers.flip.behavior = flipBehavior;
                this.popper = new (0, $3QoZZ.default)(actualTarget, this.contentRef, popperOpts);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, zIndex = _this$props2.zIndex, lockScroll = _this$props2.lockScroll;
                var _this$state2 = this.state, cssPosition = _this$state2.cssPosition, transform = _this$state2.transform, hasExtractedStyles = _this$state2.hasExtractedStyles, maxHeight = _this$state2.maxHeight, fixedOffset = _this$state2.fixedOffset;
                var opacity = hasExtractedStyles ? {} : {
                    opacity: 0
                };
                return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
                    ref: function ref(_ref2) {
                        _this2.targetRef = _ref2;
                    }
                }, this.props.children), (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($65311796a3b0af4d$var$FixedTarget, {
                    targetRef: this.targetRef,
                    fixedOffset: fixedOffset
                }, (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
                    style: {
                        height: "100%",
                        width: "100%"
                    },
                    ref: function ref(_ref3) {
                        _this2.fixedRef = _ref3;
                    }
                })), lockScroll && (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $a8UI6.default), null), (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kiyEg.default), {
                    maxHeight: maxHeight
                }, (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
                    ref: function ref(_ref4) {
                        _this2.contentRef = _ref4;
                    },
                    style: (0, (/*@__PURE__*/$parcel$interopDefault($gQ7Yy)))({
                        top: 0,
                        left: 0,
                        position: cssPosition,
                        transform: transform,
                        zIndex: zIndex
                    }, opacity)
                }, this.props.content)));
            }
        }
    ]);
    return Layer;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($65311796a3b0af4d$export$2e2bcd8739ae039, "defaultProps", {
    autoFlip: true,
    boundariesElement: "viewport",
    children: null,
    content: null,
    offset: "0, 0",
    onFlippedChange: function onFlippedChange() {},
    position: "right middle",
    zIndex: 400,
    lockScroll: false,
    isAlwaysFixed: false,
    onPositioned: function onPositioned() {}
});

});
parcelRegister("gQ7Yy", function(module, exports) {

var $kFnE9 = parcelRequire("kFnE9");
function $0329ee3383d4abc8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), o.forEach(function(r) {
            $kFnE9(e, r, t[r]);
        });
    }
    return e;
}
module.exports = $0329ee3383d4abc8$var$_objectSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("i5NQ5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2bf5a9c280a85e5$export$2e2bcd8739ae039; });
var $d2bf5a9c280a85e5$export$2e2bcd8739ae039 = function(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return frameId;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(undefined, lastArgs);
        });
        return frameId;
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    var resultFn = wrapperFn;
    return resultFn;
};

});

parcelRegister("3QoZZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cc99eadad534da0$export$2e2bcd8739ae039; });
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $2cc99eadad534da0$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && typeof navigator !== "undefined";
var $2cc99eadad534da0$var$timeoutDuration = function() {
    var longerTimeoutBrowsers = [
        "Edge",
        "Trident",
        "Firefox"
    ];
    for(var i = 0; i < longerTimeoutBrowsers.length; i += 1){
        if ($2cc99eadad534da0$var$isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) return 1;
    }
    return 0;
}();
function $2cc99eadad534da0$var$microtaskDebounce(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        window.Promise.resolve().then(function() {
            called = false;
            fn();
        });
    };
}
function $2cc99eadad534da0$var$taskDebounce(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function() {
                scheduled = false;
                fn();
            }, $2cc99eadad534da0$var$timeoutDuration);
        }
    };
}
var $2cc99eadad534da0$var$supportsMicroTasks = $2cc99eadad534da0$var$isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/ var $2cc99eadad534da0$var$debounce = $2cc99eadad534da0$var$supportsMicroTasks ? $2cc99eadad534da0$var$microtaskDebounce : $2cc99eadad534da0$var$taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */ function $2cc99eadad534da0$var$isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === "[object Function]";
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */ function $2cc99eadad534da0$var$getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) return [];
    // NOTE: 1 DOM access here
    var window1 = element.ownerDocument.defaultView;
    var css = window1.getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */ function $2cc99eadad534da0$var$getParentNode(element) {
    if (element.nodeName === "HTML") return element;
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */ function $2cc99eadad534da0$var$getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) return document.body;
    switch(element.nodeName){
        case "HTML":
        case "BODY":
            return element.ownerDocument.body;
        case "#document":
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = $2cc99eadad534da0$var$getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
    return $2cc99eadad534da0$var$getScrollParent($2cc99eadad534da0$var$getParentNode(element));
}
/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */ function $2cc99eadad534da0$var$getReferenceNode(reference) {
    return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var $2cc99eadad534da0$var$isIE11 = $2cc99eadad534da0$var$isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var $2cc99eadad534da0$var$isIE10 = $2cc99eadad534da0$var$isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */ function $2cc99eadad534da0$var$isIE(version) {
    if (version === 11) return $2cc99eadad534da0$var$isIE11;
    if (version === 10) return $2cc99eadad534da0$var$isIE10;
    return $2cc99eadad534da0$var$isIE11 || $2cc99eadad534da0$var$isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */ function $2cc99eadad534da0$var$getOffsetParent(element) {
    if (!element) return document.documentElement;
    var noOffsetParent = $2cc99eadad534da0$var$isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null;
    // Skip hidden elements which don't have an offsetParent
    while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === "BODY" || nodeName === "HTML") return element ? element.ownerDocument.documentElement : document.documentElement;
    // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if ([
        "TH",
        "TD",
        "TABLE"
    ].indexOf(offsetParent.nodeName) !== -1 && $2cc99eadad534da0$var$getStyleComputedProperty(offsetParent, "position") === "static") return $2cc99eadad534da0$var$getOffsetParent(offsetParent);
    return offsetParent;
}
function $2cc99eadad534da0$var$isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === "BODY") return false;
    return nodeName === "HTML" || $2cc99eadad534da0$var$getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */ function $2cc99eadad534da0$var$getRoot(node) {
    if (node.parentNode !== null) return $2cc99eadad534da0$var$getRoot(node.parentNode);
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */ function $2cc99eadad534da0$var$findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if ($2cc99eadad534da0$var$isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
        return $2cc99eadad534da0$var$getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = $2cc99eadad534da0$var$getRoot(element1);
    if (element1root.host) return $2cc99eadad534da0$var$findCommonOffsetParent(element1root.host, element2);
    else return $2cc99eadad534da0$var$findCommonOffsetParent(element1, $2cc99eadad534da0$var$getRoot(element2).host);
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */ function $2cc99eadad534da0$var$getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "top";
    var upperSide = side === "top" ? "scrollTop" : "scrollLeft";
    var nodeName = element.nodeName;
    if (nodeName === "BODY" || nodeName === "HTML") {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */ function $2cc99eadad534da0$var$includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = $2cc99eadad534da0$var$getScroll(element, "top");
    var scrollLeft = $2cc99eadad534da0$var$getScroll(element, "left");
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */ function $2cc99eadad534da0$var$getBordersSize(styles, axis) {
    var sideA = axis === "x" ? "Left" : "Top";
    var sideB = sideA === "Left" ? "Right" : "Bottom";
    return parseFloat(styles["border" + sideA + "Width"]) + parseFloat(styles["border" + sideB + "Width"]);
}
function $2cc99eadad534da0$var$getSize(axis, body, html, computedStyle) {
    return Math.max(body["offset" + axis], body["scroll" + axis], html["client" + axis], html["offset" + axis], html["scroll" + axis], $2cc99eadad534da0$var$isIE(10) ? parseInt(html["offset" + axis]) + parseInt(computedStyle["margin" + (axis === "Height" ? "Top" : "Left")]) + parseInt(computedStyle["margin" + (axis === "Height" ? "Bottom" : "Right")]) : 0);
}
function $2cc99eadad534da0$var$getWindowSizes(document1) {
    var body = document1.body;
    var html = document1.documentElement;
    var computedStyle = $2cc99eadad534da0$var$isIE(10) && getComputedStyle(html);
    return {
        height: $2cc99eadad534da0$var$getSize("Height", body, html, computedStyle),
        width: $2cc99eadad534da0$var$getSize("Width", body, html, computedStyle)
    };
}
var $2cc99eadad534da0$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $2cc99eadad534da0$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $2cc99eadad534da0$var$defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $2cc99eadad534da0$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */ function $2cc99eadad534da0$var$getClientRect(offsets) {
    return $2cc99eadad534da0$var$_extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */ function $2cc99eadad534da0$var$getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if ($2cc99eadad534da0$var$isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = $2cc99eadad534da0$var$getScroll(element, "top");
            var scrollLeft = $2cc99eadad534da0$var$getScroll(element, "left");
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        } else rect = element.getBoundingClientRect();
    } catch (e) {}
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === "HTML" ? $2cc99eadad534da0$var$getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.width;
    var height = sizes.height || element.clientHeight || result.height;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = $2cc99eadad534da0$var$getStyleComputedProperty(element);
        horizScrollbar -= $2cc99eadad534da0$var$getBordersSize(styles, "x");
        vertScrollbar -= $2cc99eadad534da0$var$getBordersSize(styles, "y");
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return $2cc99eadad534da0$var$getClientRect(result);
}
function $2cc99eadad534da0$var$getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = $2cc99eadad534da0$var$isIE(10);
    var isHTML = parent.nodeName === "HTML";
    var childrenRect = $2cc99eadad534da0$var$getBoundingClientRect(children);
    var parentRect = $2cc99eadad534da0$var$getBoundingClientRect(parent);
    var scrollParent = $2cc99eadad534da0$var$getScrollParent(children);
    var styles = $2cc99eadad534da0$var$getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = $2cc99eadad534da0$var$getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop);
        var marginLeft = parseFloat(styles.marginLeft);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== "BODY") offsets = $2cc99eadad534da0$var$includeScroll(offsets, parent);
    return offsets;
}
function $2cc99eadad534da0$var$getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = $2cc99eadad534da0$var$getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? $2cc99eadad534da0$var$getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? $2cc99eadad534da0$var$getScroll(html, "left") : 0;
    var offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return $2cc99eadad534da0$var$getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */ function $2cc99eadad534da0$var$isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === "BODY" || nodeName === "HTML") return false;
    if ($2cc99eadad534da0$var$getStyleComputedProperty(element, "position") === "fixed") return true;
    var parentNode = $2cc99eadad534da0$var$getParentNode(element);
    if (!parentNode) return false;
    return $2cc99eadad534da0$var$isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */ function $2cc99eadad534da0$var$getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || $2cc99eadad534da0$var$isIE()) return document.documentElement;
    var el = element.parentElement;
    while(el && $2cc99eadad534da0$var$getStyleComputedProperty(el, "transform") === "none")el = el.parentElement;
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */ function $2cc99eadad534da0$var$getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = {
        top: 0,
        left: 0
    };
    var offsetParent = fixedPosition ? $2cc99eadad534da0$var$getFixedPositionOffsetParent(popper) : $2cc99eadad534da0$var$findCommonOffsetParent(popper, $2cc99eadad534da0$var$getReferenceNode(reference));
    // Handle viewport case
    if (boundariesElement === "viewport") boundaries = $2cc99eadad534da0$var$getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === "scrollParent") {
            boundariesNode = $2cc99eadad534da0$var$getScrollParent($2cc99eadad534da0$var$getParentNode(reference));
            if (boundariesNode.nodeName === "BODY") boundariesNode = popper.ownerDocument.documentElement;
        } else if (boundariesElement === "window") boundariesNode = popper.ownerDocument.documentElement;
        else boundariesNode = boundariesElement;
        var offsets = $2cc99eadad534da0$var$getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === "HTML" && !$2cc99eadad534da0$var$isFixed(offsetParent)) {
            var _getWindowSizes = $2cc99eadad534da0$var$getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        } else // for all the other DOM elements, this one is good
        boundaries = offsets;
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === "number";
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function $2cc99eadad534da0$var$getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2cc99eadad534da0$var$computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf("auto") === -1) return placement;
    var boundaries = $2cc99eadad534da0$var$getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function(key) {
        return $2cc99eadad534da0$var$_extends({
            key: key
        }, rects[key], {
            area: $2cc99eadad534da0$var$getArea(rects[key])
        });
    }).sort(function(a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function(_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split("-")[1];
    return computedPlacement + (variation ? "-" + variation : "");
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */ function $2cc99eadad534da0$var$getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? $2cc99eadad534da0$var$getFixedPositionOffsetParent(popper) : $2cc99eadad534da0$var$findCommonOffsetParent(popper, $2cc99eadad534da0$var$getReferenceNode(reference));
    return $2cc99eadad534da0$var$getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */ function $2cc99eadad534da0$var$getOuterSizes(element) {
    var window1 = element.ownerDocument.defaultView;
    var styles = window1.getComputedStyle(element);
    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */ function $2cc99eadad534da0$var$getOppositePlacement(placement) {
    var hash = {
        left: "right",
        right: "left",
        bottom: "top",
        top: "bottom"
    };
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */ function $2cc99eadad534da0$var$getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split("-")[0];
    // Get popper node sizes
    var popperRect = $2cc99eadad534da0$var$getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = [
        "right",
        "left"
    ].indexOf(placement) !== -1;
    var mainSide = isHoriz ? "top" : "left";
    var secondarySide = isHoriz ? "left" : "top";
    var measurement = isHoriz ? "height" : "width";
    var secondaryMeasurement = !isHoriz ? "height" : "width";
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    else popperOffsets[secondarySide] = referenceOffsets[$2cc99eadad534da0$var$getOppositePlacement(secondarySide)];
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $2cc99eadad534da0$var$find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) return arr.find(check);
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $2cc99eadad534da0$var$findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
        return cur[prop] === value;
    });
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = $2cc99eadad534da0$var$find(arr, function(obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */ function $2cc99eadad534da0$var$runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, $2cc99eadad534da0$var$findIndex(modifiers, "name", ends));
    modifiersToRun.forEach(function(modifier) {
        if (modifier["function"]) // eslint-disable-line dot-notation
        console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
        var fn = modifier["function"] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && $2cc99eadad534da0$var$isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = $2cc99eadad534da0$var$getClientRect(data.offsets.popper);
            data.offsets.reference = $2cc99eadad534da0$var$getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */ function $2cc99eadad534da0$var$update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) return;
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = $2cc99eadad534da0$var$getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = $2cc99eadad534da0$var$computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = $2cc99eadad534da0$var$getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute";
    // run the modifiers
    data = $2cc99eadad534da0$var$runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    } else this.options.onUpdate(data);
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */ function $2cc99eadad534da0$var$isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function(_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */ function $2cc99eadad534da0$var$getSupportedPropertyName(property) {
    var prefixes = [
        false,
        "ms",
        "Webkit",
        "Moz",
        "O"
    ];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for(var i = 0; i < prefixes.length; i++){
        var prefix = prefixes[i];
        var toCheck = prefix ? "" + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== "undefined") return toCheck;
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */ function $2cc99eadad534da0$var$destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if ($2cc99eadad534da0$var$isModifierEnabled(this.modifiers, "applyStyle")) {
        this.popper.removeAttribute("x-placement");
        this.popper.style.position = "";
        this.popper.style.top = "";
        this.popper.style.left = "";
        this.popper.style.right = "";
        this.popper.style.bottom = "";
        this.popper.style.willChange = "";
        this.popper.style[$2cc99eadad534da0$var$getSupportedPropertyName("transform")] = "";
    }
    this.disableEventListeners();
    // remove the popper if user explicitly asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */ function $2cc99eadad534da0$var$getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function $2cc99eadad534da0$var$attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === "BODY";
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, {
        passive: true
    });
    if (!isBody) $2cc99eadad534da0$var$attachToScrollParents($2cc99eadad534da0$var$getScrollParent(target.parentNode), event, callback, scrollParents);
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $2cc99eadad534da0$var$setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    $2cc99eadad534da0$var$getWindow(reference).addEventListener("resize", state.updateBound, {
        passive: true
    });
    // Scroll event listener on scroll parents
    var scrollElement = $2cc99eadad534da0$var$getScrollParent(reference);
    $2cc99eadad534da0$var$attachToScrollParents(scrollElement, "scroll", state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */ function $2cc99eadad534da0$var$enableEventListeners() {
    if (!this.state.eventsEnabled) this.state = $2cc99eadad534da0$var$setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $2cc99eadad534da0$var$removeEventListeners(reference, state) {
    // Remove resize event listener on window
    $2cc99eadad534da0$var$getWindow(reference).removeEventListener("resize", state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function(target) {
        target.removeEventListener("scroll", state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */ function $2cc99eadad534da0$var$disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = $2cc99eadad534da0$var$removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */ function $2cc99eadad534da0$var$isNumeric(n) {
    return n !== "" && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $2cc99eadad534da0$var$setStyles(element, styles) {
    Object.keys(styles).forEach(function(prop) {
        var unit = "";
        // add unit if the value is numeric and is one of the following
        if ([
            "width",
            "height",
            "top",
            "right",
            "bottom",
            "left"
        ].indexOf(prop) !== -1 && $2cc99eadad534da0$var$isNumeric(styles[prop])) unit = "px";
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $2cc99eadad534da0$var$setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function(prop) {
        var value = attributes[prop];
        if (value !== false) element.setAttribute(prop, attributes[prop]);
        else element.removeAttribute(prop);
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */ function $2cc99eadad534da0$var$applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    $2cc99eadad534da0$var$setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    $2cc99eadad534da0$var$setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) $2cc99eadad534da0$var$setStyles(data.arrowElement, data.arrowStyles);
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */ function $2cc99eadad534da0$var$applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = $2cc99eadad534da0$var$getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = $2cc99eadad534da0$var$computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute("x-placement", placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    $2cc99eadad534da0$var$setStyles(popper, {
        position: options.positionFixed ? "fixed" : "absolute"
    });
    return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */ function $2cc99eadad534da0$var$getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var round = Math.round, floor = Math.floor;
    var noRound = function noRound(v) {
        return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = [
        "left",
        "right"
    ].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf("-") !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
    };
}
var $2cc99eadad534da0$var$isFirefox = $2cc99eadad534da0$var$isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2cc99eadad534da0$var$computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = $2cc99eadad534da0$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === "applyStyle";
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = $2cc99eadad534da0$var$getOffsetParent(data.instance.popper);
    var offsetParentRect = $2cc99eadad534da0$var$getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    var offsets = $2cc99eadad534da0$var$getRoundedOffsets(data, window.devicePixelRatio < 2 || !$2cc99eadad534da0$var$isFirefox);
    var sideA = x === "bottom" ? "top" : "bottom";
    var sideB = y === "right" ? "left" : "right";
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = $2cc99eadad534da0$var$getSupportedPropertyName("transform");
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === "bottom") {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === "HTML") top = -offsetParent.clientHeight + offsets.bottom;
        else top = -offsetParentRect.height + offsets.bottom;
    } else top = offsets.top;
    if (sideB === "right") {
        if (offsetParent.nodeName === "HTML") left = -offsetParent.clientWidth + offsets.right;
        else left = -offsetParentRect.width + offsets.right;
    } else left = offsets.left;
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = "translate3d(" + left + "px, " + top + "px, 0)";
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = "transform";
    } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === "bottom" ? -1 : 1;
        var invertLeft = sideB === "right" ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ", " + sideB;
    }
    // Attributes
    var attributes = {
        "x-placement": data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = $2cc99eadad534da0$var$_extends({}, attributes, data.attributes);
    data.styles = $2cc99eadad534da0$var$_extends({}, styles, data.styles);
    data.arrowStyles = $2cc99eadad534da0$var$_extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */ function $2cc99eadad534da0$var$isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = $2cc99eadad534da0$var$find(modifiers, function(_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function(modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = "`" + requestingName + "`";
        var requested = "`" + requestedName + "`";
        console.warn(requested + " modifier is required by " + _requesting + " modifier in order to work, be sure to include it before " + _requesting + "!");
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2cc99eadad534da0$var$arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!$2cc99eadad534da0$var$isModifierRequired(data.instance.modifiers, "arrow", "keepTogether")) return data;
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) return data;
    } else // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
        console.warn("WARNING: `arrow.element` must be child of its popper element!");
        return data;
    }
    var placement = data.placement.split("-")[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = [
        "left",
        "right"
    ].indexOf(placement) !== -1;
    var len = isVertical ? "height" : "width";
    var sideCapitalized = isVertical ? "Top" : "Left";
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? "left" : "top";
    var opSide = isVertical ? "bottom" : "right";
    var arrowElementSize = $2cc99eadad534da0$var$getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    data.offsets.popper = $2cc99eadad534da0$var$getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = $2cc99eadad534da0$var$getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css["margin" + sideCapitalized]);
    var popperBorderSide = parseFloat(css["border" + sideCapitalized + "Width"]);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, $2cc99eadad534da0$var$defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), $2cc99eadad534da0$var$defineProperty(_data$offsets$arrow, altSide, ""), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */ function $2cc99eadad534da0$var$getOppositeVariation(variation) {
    if (variation === "end") return "start";
    else if (variation === "start") return "end";
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */ var $2cc99eadad534da0$var$placements = [
    "auto-start",
    "auto",
    "auto-end",
    "top-start",
    "top",
    "top-end",
    "right-start",
    "right",
    "right-end",
    "bottom-end",
    "bottom",
    "bottom-start",
    "left-end",
    "left",
    "left-start"
];
// Get rid of `auto` `auto-start` and `auto-end`
var $2cc99eadad534da0$var$validPlacements = $2cc99eadad534da0$var$placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */ function $2cc99eadad534da0$var$clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = $2cc99eadad534da0$var$validPlacements.indexOf(placement);
    var arr = $2cc99eadad534da0$var$validPlacements.slice(index + 1).concat($2cc99eadad534da0$var$validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var $2cc99eadad534da0$var$BEHAVIORS = {
    FLIP: "flip",
    CLOCKWISE: "clockwise",
    COUNTERCLOCKWISE: "counterclockwise"
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2cc99eadad534da0$var$flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if ($2cc99eadad534da0$var$isModifierEnabled(data.instance.modifiers, "inner")) return data;
    if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
    var boundaries = $2cc99eadad534da0$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split("-")[0];
    var placementOpposite = $2cc99eadad534da0$var$getOppositePlacement(placement);
    var variation = data.placement.split("-")[1] || "";
    var flipOrder = [];
    switch(options.behavior){
        case $2cc99eadad534da0$var$BEHAVIORS.FLIP:
            flipOrder = [
                placement,
                placementOpposite
            ];
            break;
        case $2cc99eadad534da0$var$BEHAVIORS.CLOCKWISE:
            flipOrder = $2cc99eadad534da0$var$clockwise(placement);
            break;
        case $2cc99eadad534da0$var$BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = $2cc99eadad534da0$var$clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function(step, index) {
        if (placement !== step || flipOrder.length === index + 1) return data;
        placement = data.placement.split("-")[0];
        placementOpposite = $2cc99eadad534da0$var$getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === "left" && floor(popperOffsets.right) > floor(refOffsets.left) || placement === "right" && floor(popperOffsets.left) < floor(refOffsets.right) || placement === "top" && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === "bottom" && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === "left" && overflowsLeft || placement === "right" && overflowsRight || placement === "top" && overflowsTop || placement === "bottom" && overflowsBottom;
        // flip the variation if required
        var isVertical = [
            "top",
            "bottom"
        ].indexOf(placement) !== -1;
        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === "start" && overflowsLeft || isVertical && variation === "end" && overflowsRight || !isVertical && variation === "start" && overflowsTop || !isVertical && variation === "end" && overflowsBottom);
        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === "start" && overflowsRight || isVertical && variation === "end" && overflowsLeft || !isVertical && variation === "start" && overflowsBottom || !isVertical && variation === "end" && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
            if (flippedVariation) variation = $2cc99eadad534da0$var$getOppositeVariation(variation);
            data.placement = placement + (variation ? "-" + variation : "");
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = $2cc99eadad534da0$var$_extends({}, data.offsets.popper, $2cc99eadad534da0$var$getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = $2cc99eadad534da0$var$runModifiers(data.instance.modifiers, data, "flip");
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2cc99eadad534da0$var$keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split("-")[0];
    var floor = Math.floor;
    var isVertical = [
        "top",
        "bottom"
    ].indexOf(placement) !== -1;
    var side = isVertical ? "right" : "bottom";
    var opSide = isVertical ? "left" : "top";
    var measurement = isVertical ? "width" : "height";
    if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */ function $2cc99eadad534da0$var$toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) return str;
    if (unit.indexOf("%") === 0) {
        var element = void 0;
        switch(unit){
            case "%p":
                element = popperOffsets;
                break;
            case "%":
            case "%r":
            default:
                element = referenceOffsets;
        }
        var rect = $2cc99eadad534da0$var$getClientRect(element);
        return rect[measurement] / 100 * value;
    } else if (unit === "vh" || unit === "vw") {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === "vh") size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        return size / 100 * value;
    } else // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */ function $2cc99eadad534da0$var$parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [
        0,
        0
    ];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = [
        "right",
        "left"
    ].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function(frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf($2cc99eadad534da0$var$find(fragments, function(frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(",") === -1) console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [
        fragments.slice(0, divider).concat([
            fragments[divider].split(splitRegex)[0]
        ]),
        [
            fragments[divider].split(splitRegex)[1]
        ].concat(fragments.slice(divider + 1))
    ] : [
        fragments
    ];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function(op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? "height" : "width";
        var mergeWithPrevious = false;
        return op// This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function(a, b) {
            if (a[a.length - 1] === "" && [
                "+",
                "-"
            ].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            } else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            } else return a.concat(b);
        }, [])// Here we convert the string values into number values (in px)
        .map(function(str) {
            return $2cc99eadad534da0$var$toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function(op, index) {
        op.forEach(function(frag, index2) {
            if ($2cc99eadad534da0$var$isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === "-" ? -1 : 1);
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */ function $2cc99eadad534da0$var$offset(data, _ref) {
    var offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split("-")[0];
    var offsets = void 0;
    if ($2cc99eadad534da0$var$isNumeric(+offset)) offsets = [
        +offset,
        0
    ];
    else offsets = $2cc99eadad534da0$var$parseOffset(offset, popper, reference, basePlacement);
    if (basePlacement === "left") {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    } else if (basePlacement === "right") {
        popper.top += offsets[0];
        popper.left += offsets[1];
    } else if (basePlacement === "top") {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    } else if (basePlacement === "bottom") {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2cc99eadad534da0$var$preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || $2cc99eadad534da0$var$getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) boundariesElement = $2cc99eadad534da0$var$getOffsetParent(boundariesElement);
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = $2cc99eadad534da0$var$getSupportedPropertyName("transform");
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = "";
    popperStyles.left = "";
    popperStyles[transformProp] = "";
    var boundaries = $2cc99eadad534da0$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
            return $2cc99eadad534da0$var$defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === "right" ? "left" : "top";
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === "right" ? popper.width : popper.height));
            return $2cc99eadad534da0$var$defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function(placement) {
        var side = [
            "left",
            "top"
        ].indexOf(placement) !== -1 ? "primary" : "secondary";
        popper = $2cc99eadad534da0$var$_extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2cc99eadad534da0$var$shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split("-")[0];
    var shiftvariation = placement.split("-")[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = [
            "bottom",
            "top"
        ].indexOf(basePlacement) !== -1;
        var side = isVertical ? "left" : "top";
        var measurement = isVertical ? "width" : "height";
        var shiftOffsets = {
            start: $2cc99eadad534da0$var$defineProperty({}, side, reference[side]),
            end: $2cc99eadad534da0$var$defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = $2cc99eadad534da0$var$_extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2cc99eadad534da0$var$hide(data) {
    if (!$2cc99eadad534da0$var$isModifierRequired(data.instance.modifiers, "hide", "preventOverflow")) return data;
    var refRect = data.offsets.reference;
    var bound = $2cc99eadad534da0$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === "preventOverflow";
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) return data;
        data.hide = true;
        data.attributes["x-out-of-boundaries"] = "";
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) return data;
        data.hide = false;
        data.attributes["x-out-of-boundaries"] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $2cc99eadad534da0$var$inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split("-")[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = [
        "left",
        "right"
    ].indexOf(basePlacement) !== -1;
    var subtractLength = [
        "top",
        "left"
    ].indexOf(basePlacement) === -1;
    popper[isHoriz ? "left" : "top"] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? "width" : "height"] : 0);
    data.placement = $2cc99eadad534da0$var$getOppositePlacement(placement);
    data.offsets.popper = $2cc99eadad534da0$var$getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */ /**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */ var $2cc99eadad534da0$var$modifiers = {
    /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */ shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2cc99eadad534da0$var$shift
    },
    /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */ offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2cc99eadad534da0$var$offset,
        /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */ offset: 0
    },
    /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */ preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2cc99eadad534da0$var$preventOverflow,
        /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */ priority: [
            "left",
            "right",
            "top",
            "bottom"
        ],
        /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */ boundariesElement: "scrollParent"
    },
    /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */ keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2cc99eadad534da0$var$keepTogether
    },
    /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */ arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2cc99eadad534da0$var$arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: "[x-arrow]"
    },
    /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */ flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2cc99eadad534da0$var$flip,
        /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */ behavior: "flip",
        /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */ boundariesElement: "viewport",
        /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariations: false,
        /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariationsByContent: false
    },
    /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */ inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
        /** @prop {ModifierFn} */ fn: $2cc99eadad534da0$var$inner
    },
    /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */ hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2cc99eadad534da0$var$hide
    },
    /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */ computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2cc99eadad534da0$var$computeStyle,
        /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: true,
        /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */ x: "bottom",
        /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */ y: "right"
    },
    /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */ applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $2cc99eadad534da0$var$applyStyle,
        /** @prop {Function} */ onLoad: $2cc99eadad534da0$var$applyStyleOnLoad,
        /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */ /**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */ var $2cc99eadad534da0$var$Defaults = {
    /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */ placement: "bottom",
    /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */ positionFixed: false,
    /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */ eventsEnabled: true,
    /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */ removeOnDestroy: false,
    /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */ onCreate: function onCreate() {},
    /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */ onUpdate: function onUpdate() {},
    /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */ modifiers: $2cc99eadad534da0$var$modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */ /**
 * @callback onUpdate
 * @param {dataObject} data
 */ // Utils
// Methods
var $2cc99eadad534da0$var$Popper = function() {
    /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */ function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $2cc99eadad534da0$var$classCallCheck(this, Popper);
        this.scheduleUpdate = function() {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = $2cc99eadad534da0$var$debounce(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = $2cc99eadad534da0$var$_extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys($2cc99eadad534da0$var$_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
            _this.options.modifiers[name] = $2cc99eadad534da0$var$_extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
            return $2cc99eadad534da0$var$_extends({
                name: name
            }, _this.options.modifiers[name]);
        })// sort the modifiers by order
        .sort(function(a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function(modifierOptions) {
            if (modifierOptions.enabled && $2cc99eadad534da0$var$isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    $2cc99eadad534da0$var$createClass(Popper, [
        {
            key: "update",
            value: function update$$1() {
                return $2cc99eadad534da0$var$update.call(this);
            }
        },
        {
            key: "destroy",
            value: function destroy$$1() {
                return $2cc99eadad534da0$var$destroy.call(this);
            }
        },
        {
            key: "enableEventListeners",
            value: function enableEventListeners$$1() {
                return $2cc99eadad534da0$var$enableEventListeners.call(this);
            }
        },
        {
            key: "disableEventListeners",
            value: function disableEventListeners$$1() {
                return $2cc99eadad534da0$var$disableEventListeners.call(this);
            }
        }
    ]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */ $2cc99eadad534da0$var$Popper.Utils = (typeof window !== "undefined" ? window : $parcel$global).PopperUtils;
$2cc99eadad534da0$var$Popper.placements = $2cc99eadad534da0$var$placements;
$2cc99eadad534da0$var$Popper.Defaults = $2cc99eadad534da0$var$Defaults;
var $2cc99eadad534da0$export$2e2bcd8739ae039 = $2cc99eadad534da0$var$Popper;

});

parcelRegister("a8UI6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7626a4377f87a38b$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $13MK1 = parcelRequire("13MK1");

var $knkgL = parcelRequire("knkgL");
var $7626a4377f87a38b$var$Blanket = (0, $13MK1.default).div.withConfig({
    displayName: "ScrollBlock__Blanket",
    componentId: "sc-1xiww8k-0"
})([
    "\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: transparent;\n"
]);
function $7626a4377f87a38b$export$2e2bcd8739ae039() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($7626a4377f87a38b$var$Blanket, null, (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($knkgL))), null));
}

});

parcelRegister("8AbYI", function(module, exports) {

$parcel$export(module.exports, "getFlipBehavior", function () { return $63fafa2294c15dfb$export$196d47ad22c03526; });
$parcel$export(module.exports, "positionPropToPopperPosition", function () { return $63fafa2294c15dfb$export$9e6a7c92c66a7cdd; });
var $63fafa2294c15dfb$var$positionMap = {
    "top left": {
        position: "top-start",
        animation: "top"
    },
    "top center": {
        position: "top",
        animation: "top"
    },
    "top right": {
        position: "top-end",
        animation: "top"
    },
    "right top": {
        position: "right-start",
        animation: "right"
    },
    "right middle": {
        position: "right",
        animation: "right"
    },
    "right bottom": {
        position: "right-end",
        animation: "right"
    },
    "bottom left": {
        position: "bottom-start",
        animation: "bottom"
    },
    "bottom center": {
        position: "bottom",
        animation: "bottom"
    },
    "bottom right": {
        position: "bottom-end",
        animation: "bottom"
    },
    "left top": {
        position: "left-start",
        animation: "left"
    },
    "left middle": {
        position: "left",
        animation: "left"
    },
    "left bottom": {
        position: "left-end",
        animation: "left"
    }
};
var $63fafa2294c15dfb$export$f6c90e9517ee2ce0 = {
    values: [
        "top left",
        "top center",
        "top right",
        "right top",
        "right middle",
        "right bottom",
        "bottom left",
        "bottom center",
        "bottom right",
        "left top",
        "left middle",
        "left bottom"
    ],
    default: "right middle"
};
function $63fafa2294c15dfb$var$positionToPopper(position) {
    return position && $63fafa2294c15dfb$var$positionMap[position] ? $63fafa2294c15dfb$var$positionMap[position].position : null;
}
function $63fafa2294c15dfb$export$196d47ad22c03526(props) {
    return props.position && Array.isArray(props.autoFlip) ? [
        props.position.split(" ")[0]
    ].concat(props.autoFlip) : null;
}
function $63fafa2294c15dfb$export$9e6a7c92c66a7cdd(position) {
    return $63fafa2294c15dfb$var$positionToPopper(position) || $63fafa2294c15dfb$var$positionMap[$63fafa2294c15dfb$export$f6c90e9517ee2ce0.default].position;
}

});

parcelRegister("kiyEg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec705d841fb62aa3$export$2e2bcd8739ae039; });

var $13MK1 = parcelRequire("13MK1");
var $ec705d841fb62aa3$export$2e2bcd8739ae039 = (0, $13MK1.default).div.withConfig({
    displayName: "styledContentContainer",
    componentId: "p0j3f7-0"
})([
    "\n  [data-role='droplistContent'] {\n    ",
    ";\n  }\n"
], function(_ref) {
    var maxHeight = _ref.maxHeight;
    return maxHeight ? "max-height: ".concat(maxHeight, "px") : "";
});

});


parcelRegister("eNY11", function(module, exports) {

$parcel$export(module.exports, "borderRadius", function () { return $ac74321f6af801e2$export$7a57f79000377ca2; });
$parcel$export(module.exports, "gridSize", function () { return $ac74321f6af801e2$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "fontSize", function () { return $ac74321f6af801e2$export$85e3c3ca0c6fb93; });

var $4pgIc = parcelRequire("4pgIc");

var $13MK1 = parcelRequire("13MK1");

var $6qb7n = parcelRequire("6qb7n");
var $ac74321f6af801e2$export$521f2c0e5c12a14d = "__FLATTENED__";
var $ac74321f6af801e2$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $ac74321f6af801e2$export$c93026a968943f95 = "light";
var $ac74321f6af801e2$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $ac74321f6af801e2$export$7a57f79000377ca2 = function() {
    return 3;
};
var $ac74321f6af801e2$export$6d8204c2cb2e06b8 = function() {
    return 8;
};
var $ac74321f6af801e2$export$85e3c3ca0c6fb93 = function() {
    return 14;
};
var $ac74321f6af801e2$export$6746fe0d9c9fab54 = function() {
    return 11;
};
var $ac74321f6af801e2$export$a5975749f0374264 = function() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $ac74321f6af801e2$export$356129969ee49c55 = function() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $ac74321f6af801e2$export$8e24544ddba725ee = function(color, outlineWidth) {
    if (color === void 0) color = (0, $6qb7n.B100);
    if (outlineWidth === void 0) outlineWidth = $ac74321f6af801e2$export$6d8204c2cb2e06b8() / 4;
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px " + outlineWidth + "px " + color + ";\n  }\n";
};
var $ac74321f6af801e2$export$c0dd343266bc3261 = function() {
    return "\n  box-shadow: none;\n";
};
var $ac74321f6af801e2$export$7be255094ccdc533 = {
    card: function() {
        return 100;
    },
    dialog: function() {
        return 300;
    },
    navigation: function() {
        return 200;
    },
    layer: function() {
        return 400;
    },
    blanket: function() {
        return 500;
    },
    modal: function() {
        return 510;
    },
    flag: function() {
        return 600;
    },
    spotlight: function() {
        return 700;
    },
    tooltip: function() {
        return 800;
    }
};
var $ac74321f6af801e2$export$a1b3edb637fb4f35 = function() {
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $ac74321f6af801e2$export$ba1d834b86d72a09 = function() {
    return (0, $13MK1.css)($ac74321f6af801e2$var$templateObject_1 || ($ac74321f6af801e2$var$templateObject_1 = (0, $4pgIc.__makeTemplateObject)([
        "\n  border: 0 !important;\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  height: 1px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  position: absolute !important;\n  width: 1px !important;\n  white-space: nowrap !important;\n"
    ], [
        "\n  border: 0 !important;\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  height: 1px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  position: absolute !important;\n  width: 1px !important;\n  white-space: nowrap !important;\n"
    ])));
};
var $ac74321f6af801e2$export$e497e856b4f89fcd = function() {
    return {
        css: {
            backgroundColor: (0, $6qb7n.skeleton)(),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: (0, $6qb7n.skeleton)()
            },
            to: {
                backgroundColor: (0, $6qb7n.N30A)
            }
        }
    };
};
var $ac74321f6af801e2$var$templateObject_1;

});
parcelRegister("4pgIc", function(module, exports) {

$parcel$export(module.exports, "__makeTemplateObject", function () { return $335675e1dbd9fbb8$export$4fb47efe1390b86f; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $335675e1dbd9fbb8$var$extendStatics = function(d, b) {
    $335675e1dbd9fbb8$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $335675e1dbd9fbb8$var$extendStatics(d, b);
};
function $335675e1dbd9fbb8$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $335675e1dbd9fbb8$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $335675e1dbd9fbb8$export$18ce0697a983be9b = function() {
    $335675e1dbd9fbb8$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $335675e1dbd9fbb8$export$18ce0697a983be9b.apply(this, arguments);
};
function $335675e1dbd9fbb8$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $335675e1dbd9fbb8$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $335675e1dbd9fbb8$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $335675e1dbd9fbb8$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $335675e1dbd9fbb8$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $335675e1dbd9fbb8$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $335675e1dbd9fbb8$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $335675e1dbd9fbb8$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $335675e1dbd9fbb8$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $335675e1dbd9fbb8$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $335675e1dbd9fbb8$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $335675e1dbd9fbb8$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $335675e1dbd9fbb8$export$45d3717a4c69092e(o, m, p);
}
function $335675e1dbd9fbb8$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $335675e1dbd9fbb8$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $335675e1dbd9fbb8$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($335675e1dbd9fbb8$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $335675e1dbd9fbb8$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $335675e1dbd9fbb8$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $335675e1dbd9fbb8$export$10c90e4f7922046c(v) {
    return this instanceof $335675e1dbd9fbb8$export$10c90e4f7922046c ? (this.v = v, this) : new $335675e1dbd9fbb8$export$10c90e4f7922046c(v);
}
function $335675e1dbd9fbb8$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $335675e1dbd9fbb8$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $335675e1dbd9fbb8$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $335675e1dbd9fbb8$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $335675e1dbd9fbb8$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $335675e1dbd9fbb8$export$19a8beecd37a4c45 === "function" ? $335675e1dbd9fbb8$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $335675e1dbd9fbb8$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $335675e1dbd9fbb8$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $335675e1dbd9fbb8$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $335675e1dbd9fbb8$export$45d3717a4c69092e(result, mod, k);
    }
    $335675e1dbd9fbb8$var$__setModuleDefault(result, mod);
    return result;
}
function $335675e1dbd9fbb8$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $335675e1dbd9fbb8$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $335675e1dbd9fbb8$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $335675e1dbd9fbb8$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $335675e1dbd9fbb8$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $335675e1dbd9fbb8$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $335675e1dbd9fbb8$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $335675e1dbd9fbb8$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $335675e1dbd9fbb8$export$2e2bcd8739ae039 = {
    __extends: $335675e1dbd9fbb8$export$a8ba968b8961cb8a,
    __assign: $335675e1dbd9fbb8$export$18ce0697a983be9b,
    __rest: $335675e1dbd9fbb8$export$3c9a16f847548506,
    __decorate: $335675e1dbd9fbb8$export$29e00dfd3077644b,
    __param: $335675e1dbd9fbb8$export$d5ad3fd78186038f,
    __metadata: $335675e1dbd9fbb8$export$f1db080c865becb9,
    __awaiter: $335675e1dbd9fbb8$export$1050f835b63b671e,
    __generator: $335675e1dbd9fbb8$export$67ebef60e6f28a6,
    __createBinding: $335675e1dbd9fbb8$export$45d3717a4c69092e,
    __exportStar: $335675e1dbd9fbb8$export$f33643c0debef087,
    __values: $335675e1dbd9fbb8$export$19a8beecd37a4c45,
    __read: $335675e1dbd9fbb8$export$8d051b38c9118094,
    __spread: $335675e1dbd9fbb8$export$afc72e2116322959,
    __spreadArrays: $335675e1dbd9fbb8$export$6388937ca91ccae8,
    __spreadArray: $335675e1dbd9fbb8$export$1216008129fb82ed,
    __await: $335675e1dbd9fbb8$export$10c90e4f7922046c,
    __asyncGenerator: $335675e1dbd9fbb8$export$e427f37a30a4de9b,
    __asyncDelegator: $335675e1dbd9fbb8$export$bbd80228419bb833,
    __asyncValues: $335675e1dbd9fbb8$export$e3b29a3d6162315f,
    __makeTemplateObject: $335675e1dbd9fbb8$export$4fb47efe1390b86f,
    __importStar: $335675e1dbd9fbb8$export$c21735bcef00d192,
    __importDefault: $335675e1dbd9fbb8$export$da59b14a69baef04,
    __classPrivateFieldGet: $335675e1dbd9fbb8$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $335675e1dbd9fbb8$export$d40a35129aaff81f,
    __classPrivateFieldIn: $335675e1dbd9fbb8$export$81fdc39f203e4e04,
    __addDisposableResource: $335675e1dbd9fbb8$export$88ac25d8e944e405,
    __disposeResources: $335675e1dbd9fbb8$export$8f076105dc360e92
};

});

parcelRegister("6qb7n", function(module, exports) {

$parcel$export(module.exports, "B75", function () { return $4acdcb98ec92833d$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $4acdcb98ec92833d$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $4acdcb98ec92833d$export$215b7063051591f1; });
$parcel$export(module.exports, "B400", function () { return $4acdcb98ec92833d$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N0", function () { return $4acdcb98ec92833d$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $4acdcb98ec92833d$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N40", function () { return $4acdcb98ec92833d$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N50", function () { return $4acdcb98ec92833d$export$8754fc7e6d8b3000; });
$parcel$export(module.exports, "N70", function () { return $4acdcb98ec92833d$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N200", function () { return $4acdcb98ec92833d$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N300", function () { return $4acdcb98ec92833d$export$e2ef2124cf4024b1; });
$parcel$export(module.exports, "N600", function () { return $4acdcb98ec92833d$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N800", function () { return $4acdcb98ec92833d$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N30A", function () { return $4acdcb98ec92833d$export$920c0d5c49070351; });
$parcel$export(module.exports, "N50A", function () { return $4acdcb98ec92833d$export$7d3359664e8bb0e5; });
$parcel$export(module.exports, "N60A", function () { return $4acdcb98ec92833d$export$d2d3bedfb276cac0; });
$parcel$export(module.exports, "DN600", function () { return $4acdcb98ec92833d$export$5368d76ae4fbbda7; });
$parcel$export(module.exports, "DN300", function () { return $4acdcb98ec92833d$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN80", function () { return $4acdcb98ec92833d$export$91fd9994c5be9757; });
$parcel$export(module.exports, "DN70", function () { return $4acdcb98ec92833d$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $4acdcb98ec92833d$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN50", function () { return $4acdcb98ec92833d$export$8e8133c1ba5845b5; });
$parcel$export(module.exports, "DN30", function () { return $4acdcb98ec92833d$export$633847cf062b69e0; });
$parcel$export(module.exports, "backgroundOnLayer", function () { return $4acdcb98ec92833d$export$c0183dbab98ca63e; });
$parcel$export(module.exports, "subtleText", function () { return $4acdcb98ec92833d$export$1905ba28d7cf066f; });
$parcel$export(module.exports, "skeleton", function () { return $4acdcb98ec92833d$export$2a0674ff2eb10214; });

var $kRQKu = parcelRequire("kRQKu");
var $4acdcb98ec92833d$export$4b84fd0e2c617bd = "#FFEBE6";
var $4acdcb98ec92833d$export$b34b069eff244586 = "#FFBDAD";
var $4acdcb98ec92833d$export$be802dd0d8b57f35 = "#FF8F73";
var $4acdcb98ec92833d$export$60847d42f9da92a6 = "#FF7452";
var $4acdcb98ec92833d$export$4a7404f376229999 = "#FF5630";
var $4acdcb98ec92833d$export$2010d0fb4295b346 = "#DE350B";
var $4acdcb98ec92833d$export$2837b5a1a71d5c02 = "#BF2600";
var $4acdcb98ec92833d$export$8d9596b529bbb9cf = "#FFFAE6";
var $4acdcb98ec92833d$export$41060a744ab0b7ae = "#FFF0B3";
var $4acdcb98ec92833d$export$1cc05bbbf340e559 = "#FFE380";
var $4acdcb98ec92833d$export$5aae31392d72caaa = "#FFC400";
var $4acdcb98ec92833d$export$c6930421db9fa514 = "#FFAB00";
var $4acdcb98ec92833d$export$59619663aa6500fb = "#FF991F";
var $4acdcb98ec92833d$export$874739ea9e379ab6 = "#FF8B00";
var $4acdcb98ec92833d$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $4acdcb98ec92833d$export$69a3bf21b9686c2b = "#ABF5D1";
var $4acdcb98ec92833d$export$afbce1382ec95f73 = "#79F2C0";
var $4acdcb98ec92833d$export$747d86715d4175de = "#57D9A3";
var $4acdcb98ec92833d$export$940e1f69e873f202 = "#36B37E";
var $4acdcb98ec92833d$export$a49394138f7b8e85 = "#00875A";
var $4acdcb98ec92833d$export$6fa04827ac68a4fb = "#006644";
var $4acdcb98ec92833d$export$226de0355ed012f8 = "#DEEBFF";
var $4acdcb98ec92833d$export$8c13c2ee36917869 = "#B3D4FF";
var $4acdcb98ec92833d$export$ecfc1dff386a3e7a = "#4C9AFF";
var $4acdcb98ec92833d$export$215b7063051591f1 = "#2684FF";
var $4acdcb98ec92833d$export$e62e8919cca44969 = "#0065FF";
var $4acdcb98ec92833d$export$b3de0ae08da2ce64 = "#0052CC";
var $4acdcb98ec92833d$export$a6ee3d71bc067634 = "#0747A6";
var $4acdcb98ec92833d$export$363e4475840015bb = "#EAE6FF";
var $4acdcb98ec92833d$export$4b0a4417ed59760f = "#C0B6F2";
var $4acdcb98ec92833d$export$6011520a64d9a187 = "#998DD9";
var $4acdcb98ec92833d$export$a7175d4e9206bc80 = "#8777D9";
var $4acdcb98ec92833d$export$b48405b95304b5a1 = "#6554C0";
var $4acdcb98ec92833d$export$c71e4279dd54a18d = "#5243AA";
var $4acdcb98ec92833d$export$147899de772240ec = "#403294";
var $4acdcb98ec92833d$export$2cf711fe14c66f06 = "#E6FCFF";
var $4acdcb98ec92833d$export$7a8f4d33f6f9772c = "#B3F5FF";
var $4acdcb98ec92833d$export$776c9c497ef08533 = "#79E2F2";
var $4acdcb98ec92833d$export$69cb3ca10c1e330e = "#00C7E6";
var $4acdcb98ec92833d$export$9dc1ef0f3f48059b = "#00B8D9";
var $4acdcb98ec92833d$export$7c835c78b6fcdef8 = "#00A3BF";
var $4acdcb98ec92833d$export$6036577f95c3877e = "#008DA6";
var $4acdcb98ec92833d$export$29a4f05edc054374 = "#FFFFFF";
var $4acdcb98ec92833d$export$e655ef011c4aa1a2 = "#FAFBFC";
var $4acdcb98ec92833d$export$9fdfb749e33cdf97 = "#F4F5F7";
var $4acdcb98ec92833d$export$3e51e8f1440314ba = "#EBECF0";
var $4acdcb98ec92833d$export$1ce2d1575d444ceb = "#DFE1E6";
var $4acdcb98ec92833d$export$8754fc7e6d8b3000 = "#C1C7D0";
var $4acdcb98ec92833d$export$c2e91cbeada39b8b = "#B3BAC5";
var $4acdcb98ec92833d$export$5f71e19f3a7ad9de = "#A5ADBA";
var $4acdcb98ec92833d$export$eaa8c8a70ac22806 = "#97A0AF";
var $4acdcb98ec92833d$export$7c87d337fb91a97d = "#8993A4";
var $4acdcb98ec92833d$export$d6447c357493214f = "#7A869A";
var $4acdcb98ec92833d$export$f563ee71e9ee74cd = "#6B778C";
var $4acdcb98ec92833d$export$e2ef2124cf4024b1 = "#5E6C84";
var $4acdcb98ec92833d$export$eece5f492e429f08 = "#505F79";
var $4acdcb98ec92833d$export$c39c0fe0f26207ae = "#42526E";
var $4acdcb98ec92833d$export$7090862dc3038a9f = "#344563";
var $4acdcb98ec92833d$export$ad0bacf983b7ddaa = "#253858";
var $4acdcb98ec92833d$export$7d61b15e0da132af = "#172B4D";
var $4acdcb98ec92833d$export$fbda843f0a27fe96 = "#091E42";
var $4acdcb98ec92833d$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $4acdcb98ec92833d$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $4acdcb98ec92833d$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $4acdcb98ec92833d$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $4acdcb98ec92833d$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $4acdcb98ec92833d$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $4acdcb98ec92833d$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $4acdcb98ec92833d$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $4acdcb98ec92833d$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $4acdcb98ec92833d$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $4acdcb98ec92833d$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $4acdcb98ec92833d$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $4acdcb98ec92833d$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $4acdcb98ec92833d$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $4acdcb98ec92833d$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $4acdcb98ec92833d$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $4acdcb98ec92833d$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $4acdcb98ec92833d$export$2f6319cf7d736c2a = "#E6EDFA";
var $4acdcb98ec92833d$export$95126bc8884d6634 = "#DCE5F5";
var $4acdcb98ec92833d$export$8338d8c35d44ff1 = "#CED9EB";
var $4acdcb98ec92833d$export$5368d76ae4fbbda7 = "#B8C7E0";
var $4acdcb98ec92833d$export$9f0a771d16ec8d36 = "#ABBBD6";
var $4acdcb98ec92833d$export$abcf8c38338b4aa5 = "#9FB0CC";
var $4acdcb98ec92833d$export$97e81faa16a182c7 = "#8C9CB8";
var $4acdcb98ec92833d$export$bfe21c59123ecf33 = "#7988A3";
var $4acdcb98ec92833d$export$ee82aa2ea6a1558 = "#67758F";
var $4acdcb98ec92833d$export$682927c6ed76be02 = "#56637A";
var $4acdcb98ec92833d$export$91fd9994c5be9757 = "#455166";
var $4acdcb98ec92833d$export$d281fbfe3cff2df6 = "#3B475C";
var $4acdcb98ec92833d$export$3902c91d8b98a753 = "#313D52";
var $4acdcb98ec92833d$export$8e8133c1ba5845b5 = "#283447";
var $4acdcb98ec92833d$export$33ff357f6620b39 = "#202B3D";
var $4acdcb98ec92833d$export$633847cf062b69e0 = "#1B2638";
var $4acdcb98ec92833d$export$9776a6e503bdbf76 = "#121A29";
var $4acdcb98ec92833d$export$6c813d5160dff5db = "#0E1624";
var $4acdcb98ec92833d$export$3d4f271a500072a = "#0D1424";
var $4acdcb98ec92833d$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $4acdcb98ec92833d$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $4acdcb98ec92833d$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $4acdcb98ec92833d$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $4acdcb98ec92833d$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $4acdcb98ec92833d$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $4acdcb98ec92833d$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $4acdcb98ec92833d$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $4acdcb98ec92833d$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $4acdcb98ec92833d$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $4acdcb98ec92833d$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $4acdcb98ec92833d$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $4acdcb98ec92833d$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $4acdcb98ec92833d$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $4acdcb98ec92833d$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $4acdcb98ec92833d$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $4acdcb98ec92833d$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $4acdcb98ec92833d$export$8ce1fd94bee2f412 = (0, $kRQKu.default)({
    light: $4acdcb98ec92833d$export$29a4f05edc054374,
    dark: $4acdcb98ec92833d$export$633847cf062b69e0
});
var $4acdcb98ec92833d$export$b861914ea877b580 = (0, $kRQKu.default)({
    light: $4acdcb98ec92833d$export$226de0355ed012f8,
    dark: $4acdcb98ec92833d$export$8c13c2ee36917869
});
var $4acdcb98ec92833d$export$3f1b020df94387af = (0, $kRQKu.default)({
    light: $4acdcb98ec92833d$export$3e51e8f1440314ba,
    dark: $4acdcb98ec92833d$export$d281fbfe3cff2df6
});
var $4acdcb98ec92833d$export$c0183dbab98ca63e = (0, $kRQKu.default)({
    light: $4acdcb98ec92833d$export$29a4f05edc054374,
    dark: $4acdcb98ec92833d$export$8e8133c1ba5845b5
});
var $4acdcb98ec92833d$export$6f093cfa640b7166 = (0, $kRQKu.default)({
    light: $4acdcb98ec92833d$export$fbda843f0a27fe96,
    dark: $4acdcb98ec92833d$export$5368d76ae4fbbda7
});
var $4acdcb98ec92833d$export$42f8e9c698766e7a = (0, $kRQKu.default)({
    light: $4acdcb98ec92833d$export$7d61b15e0da132af,
    dark: $4acdcb98ec92833d$export$5368d76ae4fbbda7
});
var $4acdcb98ec92833d$export$c2d157ca1c34b6e3 = (0, $kRQKu.default)({
    light: $4acdcb98ec92833d$export$b3de0ae08da2ce64,
    dark: $4acdcb98ec92833d$export$b3de0ae08da2ce64
});
var $4acdcb98ec92833d$export$1905ba28d7cf066f = (0, $kRQKu.default)({
    light: $4acdcb98ec92833d$export$f563ee71e9ee74cd,
    dark: $4acdcb98ec92833d$export$97e81faa16a182c7
});
var $4acdcb98ec92833d$export$bd9002130d306d39 = (0, $kRQKu.default)({
    light: $4acdcb98ec92833d$export$d6447c357493214f,
    dark: $4acdcb98ec92833d$export$bfe21c59123ecf33
});
var $4acdcb98ec92833d$export$46e4a324ac90507f = (0, $kRQKu.default)({
    light: $4acdcb98ec92833d$export$7d61b15e0da132af,
    dark: $4acdcb98ec92833d$export$5368d76ae4fbbda7
});
var $4acdcb98ec92833d$export$79f3f2b82beb0d36 = (0, $kRQKu.default)({
    light: $4acdcb98ec92833d$export$f563ee71e9ee74cd,
    dark: $4acdcb98ec92833d$export$97e81faa16a182c7
});
var $4acdcb98ec92833d$export$7bb0d5c671655cc4 = (0, $kRQKu.default)({
    light: $4acdcb98ec92833d$export$9fdfb749e33cdf97,
    dark: $4acdcb98ec92833d$export$8e8133c1ba5845b5
});
var $4acdcb98ec92833d$export$9c30223ca0a664fb = (0, $kRQKu.default)({
    light: $4acdcb98ec92833d$export$b3de0ae08da2ce64,
    dark: $4acdcb98ec92833d$export$ecfc1dff386a3e7a
});
var $4acdcb98ec92833d$export$7ed258b0728b004b = (0, $kRQKu.default)({
    light: $4acdcb98ec92833d$export$e62e8919cca44969,
    dark: $4acdcb98ec92833d$export$215b7063051591f1
});
var $4acdcb98ec92833d$export$dfa920d8decc8a59 = (0, $kRQKu.default)({
    light: $4acdcb98ec92833d$export$a6ee3d71bc067634,
    dark: $4acdcb98ec92833d$export$ecfc1dff386a3e7a
});
var $4acdcb98ec92833d$export$6069e6ad5c78f632 = (0, $kRQKu.default)({
    light: $4acdcb98ec92833d$export$ecfc1dff386a3e7a,
    dark: $4acdcb98ec92833d$export$215b7063051591f1
});
var $4acdcb98ec92833d$export$9ad721cf3b3debe0 = (0, $kRQKu.default)({
    light: $4acdcb98ec92833d$export$b3de0ae08da2ce64,
    dark: $4acdcb98ec92833d$export$ecfc1dff386a3e7a
});
var $4acdcb98ec92833d$export$2aa0182783e7e9de = (0, $kRQKu.default)({
    light: $4acdcb98ec92833d$export$b3de0ae08da2ce64,
    dark: $4acdcb98ec92833d$export$ecfc1dff386a3e7a
});
var $4acdcb98ec92833d$export$8bf7dff220b82b4a = (0, $kRQKu.default)({
    light: $4acdcb98ec92833d$export$9dc1ef0f3f48059b,
    dark: $4acdcb98ec92833d$export$69cb3ca10c1e330e
});
var $4acdcb98ec92833d$export$e13cce2a2d16a9d4 = (0, $kRQKu.default)({
    light: $4acdcb98ec92833d$export$b48405b95304b5a1,
    dark: $4acdcb98ec92833d$export$6011520a64d9a187
});
var $4acdcb98ec92833d$export$a90204d1394caf30 = (0, $kRQKu.default)({
    light: $4acdcb98ec92833d$export$4a7404f376229999,
    dark: $4acdcb98ec92833d$export$4a7404f376229999
});
var $4acdcb98ec92833d$export$594c5a8758200c32 = (0, $kRQKu.default)({
    light: $4acdcb98ec92833d$export$c6930421db9fa514,
    dark: $4acdcb98ec92833d$export$c6930421db9fa514
});
var $4acdcb98ec92833d$export$955a2ebd2fb142ae = (0, $kRQKu.default)({
    light: $4acdcb98ec92833d$export$940e1f69e873f202,
    dark: $4acdcb98ec92833d$export$940e1f69e873f202
});
var $4acdcb98ec92833d$export$2a0674ff2eb10214 = function() {
    return $4acdcb98ec92833d$export$8d43898f60b96a82;
};

});
parcelRegister("kRQKu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f311acb78bc10d7d$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $cqlHm = parcelRequire("cqlHm");
// Unpack custom variants, and get correct value for the current theme
function $f311acb78bc10d7d$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $cqlHm.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $f311acb78bc10d7d$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $f311acb78bc10d7d$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $cqlHm.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("cqlHm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90b8be9b39efde2c$export$2e2bcd8739ae039; });
// ideally this would be fetched from ../constants but that causes a
// circular dep loop. This will be refactored as part of a breaking
// change in the future.
var $90b8be9b39efde2c$var$DEFAULT_THEME_MODE = "light";
var $90b8be9b39efde2c$var$THEME_MODES = [
    "light",
    "dark"
];
function $90b8be9b39efde2c$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ("__ATLASKIT_THEME__" in props.theme) return props.theme.__ATLASKIT_THEME__;
        else if ("mode" in props.theme && $90b8be9b39efde2c$var$THEME_MODES.includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: $90b8be9b39efde2c$var$DEFAULT_THEME_MODE
    };
}

});




parcelRegister("dR75f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a165b84525aafe22$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Content", function () { return $a165b84525aafe22$export$7c6e2c02157bb7d2; });
$parcel$export(module.exports, "SpinnerContainer", function () { return $a165b84525aafe22$export$a5e06607a5ac6158; });
$parcel$export(module.exports, "Trigger", function () { return $a165b84525aafe22$export$41fb9f06171c75f4; });

var $13MK1 = parcelRequire("13MK1");

var $6qb7n = parcelRequire("6qb7n");

var $eNY11 = parcelRequire("eNY11");

var $dM68a = parcelRequire("dM68a");
/* When dropdown contains more than 9 elements (droplist items, droplist groups),
 * it should have scroll and cut off half of the 10th item to indicate that there are more
 * items then are seen. This was previously calculated by mapping over children, but with
 * the current composed API it is simpler to just assume 9 items. */ var $a165b84525aafe22$var$getMaxHeight = function getMaxHeight(_ref) {
    var isTall = _ref.isTall, maxHeight = _ref.maxHeight;
    if (maxHeight) return "".concat(maxHeight, "px");
    var heightWithoutPadding = 17;
    var verticalPadding = (0, $eNY11.gridSize)();
    var height = heightWithoutPadding + verticalPadding * 2;
    var defaultMaxHeight = 9.5 * height + verticalPadding / 2;
    return isTall ? "90vh" : "".concat(defaultMaxHeight, "px");
};
var $a165b84525aafe22$export$2e2bcd8739ae039 = (0, $13MK1.default).div.withConfig({
    displayName: "Droplist",
    componentId: "sc-1z05y4v-0"
})([
    "\n  display: inline-flex;\n\n  ",
    ";\n"
], function(props) {
    return props.fit && "\n    display: block;\n    flex: 1 1 auto;\n  ";
});
var $a165b84525aafe22$var$backgroundColor = (0, $6qb7n.backgroundOnLayer);
var $a165b84525aafe22$var$boxShadow = (0, $13MK1.css)([
    "\n  box-shadow: 0 ",
    "px ",
    "px -",
    "px\n      ",
    ",\n    0 0 1px ",
    ";\n"
], (0, $dM68a.divide)((0, $eNY11.gridSize), 2), (0, $eNY11.gridSize), (0, $dM68a.divide)((0, $eNY11.gridSize), 4), (0, $6qb7n.N50A), (0, $6qb7n.N60A));
var $a165b84525aafe22$export$7c6e2c02157bb7d2 = (0, $13MK1.default).div.withConfig({
    displayName: "Droplist__Content",
    componentId: "sc-1z05y4v-1"
})([
    "\n  background: ",
    ";\n  border-radius: ",
    "px;\n  ",
    ";\n  box-sizing: border-box;\n  overflow: auto;\n  padding: ",
    "px 0;\n  max-height: ",
    ";\n"
], $a165b84525aafe22$var$backgroundColor, (0, $eNY11.borderRadius), $a165b84525aafe22$var$boxShadow, (0, $dM68a.divide)((0, $eNY11.gridSize), 2), $a165b84525aafe22$var$getMaxHeight);
var $a165b84525aafe22$export$a5e06607a5ac6158 = (0, $13MK1.default).div.withConfig({
    displayName: "Droplist__SpinnerContainer",
    componentId: "sc-1z05y4v-2"
})([
    "\n  display: flex;\n  justify-content: center;\n  min-width: ",
    "px;\n  padding: ",
    "px;\n"
], (0, $dM68a.multiply)((0, $eNY11.gridSize), 20), (0, $dM68a.multiply)((0, $eNY11.gridSize), 2.5));
var $a165b84525aafe22$export$41fb9f06171c75f4 = (0, $13MK1.default).div.withConfig({
    displayName: "Droplist__Trigger",
    componentId: "sc-1z05y4v-3"
})([
    "\n  display: inline-flex;\n  transition-duration: 0.2s;\n  transition: box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38);\n\n  ",
    ";\n"
], function(props) {
    return props.fit && "\n    box-sizing: border-box;\n    display: block;\n  ";
});

});
parcelRegister("dM68a", function(module, exports) {

$parcel$export(module.exports, "multiply", function () { return $a074837eacf5e60b$export$2060d2db72cce88f; });
$parcel$export(module.exports, "divide", function () { return $a074837eacf5e60b$export$cd007d971a5a2143; });
// If a generic is used here, props can be inferred never and passed up (even with defaults)
function $a074837eacf5e60b$export$e16d8520af44a096(fn, addend) {
    return function(props) {
        return fn(props) + addend;
    };
}
function $a074837eacf5e60b$export$4e2d2ead65e5f7e3(fn, subtrahend) {
    return function(props) {
        return fn(props) - subtrahend;
    };
}
function $a074837eacf5e60b$export$2060d2db72cce88f(fn, factor) {
    return function(props) {
        return fn(props) * factor;
    };
}
function $a074837eacf5e60b$export$cd007d971a5a2143(fn, divisor) {
    return function(props) {
        return fn(props) / divisor;
    };
}

});


parcelRegister("kRKEY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f30cf38b7e19552f$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $dBRTS = parcelRequire("dBRTS");

var $6qb7n = parcelRequire("6qb7n");

var $kRQKu = parcelRequire("kRQKu");

var $eNY11 = parcelRequire("eNY11");

var $dM68a = parcelRequire("dM68a");
var $f30cf38b7e19552f$var$dropdownPadding = {
    bottom: (0, $eNY11.gridSize),
    left: (0, $dM68a.multiply)((0, $eNY11.gridSize), 1.5),
    right: (0, $dM68a.multiply)((0, $eNY11.gridSize), 1.5),
    top: (0, $eNY11.gridSize)
};
var $f30cf38b7e19552f$var$droplistItemTheme = {
    padding: {
        default: $f30cf38b7e19552f$var$dropdownPadding,
        compact: $f30cf38b7e19552f$var$dropdownPadding
    },
    borderRadius: function borderRadius() {
        return 0;
    },
    default: {
        background: (0, $kRQKu.default)({
            light: $6qb7n.N0,
            dark: $6qb7n.DN50
        }),
        text: (0, $kRQKu.default)({
            light: $6qb7n.N800,
            dark: $6qb7n.DN600
        }),
        secondaryText: (0, $kRQKu.default)({
            light: $6qb7n.N200,
            dark: $6qb7n.DN300
        })
    },
    hover: {
        background: (0, $kRQKu.default)({
            light: $6qb7n.N20,
            dark: $6qb7n.DN70
        }),
        text: (0, $kRQKu.default)({
            light: $6qb7n.N800,
            dark: $6qb7n.DN600
        }),
        secondaryText: (0, $kRQKu.default)({
            light: $6qb7n.N200,
            dark: $6qb7n.DN300
        })
    },
    active: {
        background: (0, $kRQKu.default)({
            light: $6qb7n.B75,
            dark: $6qb7n.B75
        }),
        text: (0, $kRQKu.default)({
            light: $6qb7n.N800,
            dark: $6qb7n.B400
        }),
        secondaryText: (0, $kRQKu.default)({
            light: $6qb7n.N200,
            dark: $6qb7n.DN300
        })
    },
    selected: {
        background: "transparent",
        text: (0, $kRQKu.default)({
            light: $6qb7n.N800,
            dark: $6qb7n.DN600
        }),
        secondaryText: (0, $kRQKu.default)({
            light: $6qb7n.N200,
            dark: $6qb7n.DN300
        })
    },
    disabled: {
        background: "transparent",
        text: (0, $kRQKu.default)({
            light: $6qb7n.N70,
            dark: $6qb7n.DN80
        }),
        secondaryText: (0, $kRQKu.default)({
            light: $6qb7n.N50,
            dark: $6qb7n.DN70
        })
    },
    focus: {
        outline: (0, $kRQKu.default)({
            light: $6qb7n.B100,
            dark: $6qb7n.B75
        })
    }
};
var $f30cf38b7e19552f$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, (0, $dBRTS.themeNamespace), $f30cf38b7e19552f$var$droplistItemTheme);

});
parcelRegister("dBRTS", function(module, exports) {

$parcel$export(module.exports, "themeNamespace", function () { return $9e888a859abcd1b4$export$100d79e3a6cb7a22; });
$parcel$export(module.exports, "compactSmallFontSize", function () { return $9e888a859abcd1b4$export$36676057bbc37533; });
$parcel$export(module.exports, "compactLineHeight", function () { return $9e888a859abcd1b4$export$bec6d154da062eb7; });
$parcel$export(module.exports, "gridSize", function () { return $9e888a859abcd1b4$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "getThemeStyle", function () { return $9e888a859abcd1b4$export$9c32960124ce6c37; });

var $gR2AX = parcelRequire("gR2AX");

var $dLPiE = parcelRequire("dLPiE");
var $9e888a859abcd1b4$export$100d79e3a6cb7a22 = "@atlaskit-shared-theme/item"; // Used for Group titles and Item descriptions
var $9e888a859abcd1b4$export$36676057bbc37533 = 10;
var $9e888a859abcd1b4$export$bec6d154da062eb7 = 1.2;
var $9e888a859abcd1b4$export$6d8204c2cb2e06b8 = (0, $gR2AX.gridSize)();
var $9e888a859abcd1b4$export$164de7ab8df77ef0 = {
    afterItemSpacing: {
        compact: (0, $gR2AX.gridSize)(),
        default: (0, $gR2AX.gridSize)()
    },
    beforeItemSpacing: {
        compact: (0, $gR2AX.gridSize)(),
        default: (0, $gR2AX.gridSize)()
    },
    borderRadius: (0, $gR2AX.borderRadius)(),
    focus: {
        outline: $dLPiE.B100
    },
    height: {
        compact: 0,
        default: 0
    },
    width: {
        compact: "auto",
        default: "auto"
    },
    padding: {
        default: {
            bottom: (0, $gR2AX.gridSize)() / 2,
            left: (0, $gR2AX.gridSize)() / 2,
            right: (0, $gR2AX.gridSize)() / 2,
            top: (0, $gR2AX.gridSize)() / 2
        },
        compact: {
            bottom: (0, $gR2AX.gridSize)(),
            left: (0, $gR2AX.gridSize)(),
            right: (0, $gR2AX.gridSize)(),
            top: (0, $gR2AX.gridSize)()
        }
    },
    default: {
        background: $dLPiE.background,
        text: $dLPiE.text,
        secondaryText: $dLPiE.N200
    },
    selected: {
        background: $dLPiE.backgroundActive,
        text: $dLPiE.N500,
        secondaryText: $dLPiE.N200
    },
    active: {
        background: $dLPiE.backgroundActive,
        text: $dLPiE.textActive,
        secondaryText: $dLPiE.N200
    },
    hover: {
        background: $dLPiE.backgroundHover,
        text: $dLPiE.textHover,
        secondaryText: $dLPiE.N200
    },
    disabled: {
        background: $dLPiE.N0,
        text: $dLPiE.N200,
        secondaryText: $dLPiE.N200
    },
    // same as hover in this case
    dragging: {
        background: $dLPiE.N20,
        text: $dLPiE.N800,
        secondaryText: $dLPiE.N200
    }
};
var $9e888a859abcd1b4$var$isValidCssValue = function isValidCssValue(value) {
    return value !== undefined && value !== null && value !== "";
}; // Returns the theme that contains the requested theme key(s), preferring the user-supplied
var $9e888a859abcd1b4$export$82cee1bbcb7d1252 = function themeWithKeys(maybeTheme, key, parentKey) {
    if (parentKey) return maybeTheme && maybeTheme[parentKey] && $9e888a859abcd1b4$var$isValidCssValue(maybeTheme[parentKey][key]) ? maybeTheme : $9e888a859abcd1b4$export$164de7ab8df77ef0;
    return maybeTheme && $9e888a859abcd1b4$var$isValidCssValue(maybeTheme[key]) ? maybeTheme : $9e888a859abcd1b4$export$164de7ab8df77ef0;
}; // Returns the theme value for the requested key(s), falling back to the default theme if the
var $9e888a859abcd1b4$export$9c32960124ce6c37 = function getThemeStyle(maybeTheme, key, parentKey) {
    var theme = $9e888a859abcd1b4$export$82cee1bbcb7d1252(maybeTheme, key, parentKey);
    return parentKey ? theme[parentKey][key] : theme[key];
};

});
parcelRegister("gR2AX", function(module, exports) {

$parcel$export(module.exports, "borderRadius", function () { return $c4539be2bc51f2d5$export$7a57f79000377ca2; });
$parcel$export(module.exports, "gridSize", function () { return $c4539be2bc51f2d5$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "fontSize", function () { return $c4539be2bc51f2d5$export$85e3c3ca0c6fb93; });
$parcel$export(module.exports, "fontSizeSmall", function () { return $c4539be2bc51f2d5$export$6746fe0d9c9fab54; });

var $9eh8e = parcelRequire("9eh8e");

var $13MK1 = parcelRequire("13MK1");

var $dLPiE = parcelRequire("dLPiE");
var $c4539be2bc51f2d5$export$521f2c0e5c12a14d = "__FLATTENED__";
var $c4539be2bc51f2d5$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $c4539be2bc51f2d5$export$c93026a968943f95 = "light";
var $c4539be2bc51f2d5$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $c4539be2bc51f2d5$export$7a57f79000377ca2 = function() {
    return 3;
};
var $c4539be2bc51f2d5$export$6d8204c2cb2e06b8 = function() {
    return 8;
};
var $c4539be2bc51f2d5$export$85e3c3ca0c6fb93 = function() {
    return 14;
};
var $c4539be2bc51f2d5$export$6746fe0d9c9fab54 = function() {
    return 11;
};
var $c4539be2bc51f2d5$export$a5975749f0374264 = function() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $c4539be2bc51f2d5$export$356129969ee49c55 = function() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $c4539be2bc51f2d5$export$8e24544ddba725ee = function(color, outlineWidth) {
    if (color === void 0) color = (0, $dLPiE.B100);
    if (outlineWidth === void 0) outlineWidth = $c4539be2bc51f2d5$export$6d8204c2cb2e06b8() / 4;
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px " + outlineWidth + "px " + color + ";\n  }\n";
};
var $c4539be2bc51f2d5$export$c0dd343266bc3261 = function() {
    return "\n  box-shadow: none;\n";
};
var $c4539be2bc51f2d5$export$7be255094ccdc533 = {
    card: function() {
        return 100;
    },
    dialog: function() {
        return 300;
    },
    navigation: function() {
        return 200;
    },
    layer: function() {
        return 400;
    },
    blanket: function() {
        return 500;
    },
    modal: function() {
        return 510;
    },
    flag: function() {
        return 600;
    },
    spotlight: function() {
        return 700;
    },
    tooltip: function() {
        return 800;
    }
};
var $c4539be2bc51f2d5$export$a1b3edb637fb4f35 = function() {
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $c4539be2bc51f2d5$export$ba1d834b86d72a09 = function() {
    return (0, $13MK1.css)($c4539be2bc51f2d5$var$templateObject_1 || ($c4539be2bc51f2d5$var$templateObject_1 = (0, $9eh8e.__makeTemplateObject)([
        "\n  border: 0 !important;\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  height: 1px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  position: absolute !important;\n  width: 1px !important;\n  white-space: nowrap !important;\n"
    ], [
        "\n  border: 0 !important;\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  height: 1px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  position: absolute !important;\n  width: 1px !important;\n  white-space: nowrap !important;\n"
    ])));
};
var $c4539be2bc51f2d5$export$e497e856b4f89fcd = function() {
    return {
        css: {
            backgroundColor: (0, $dLPiE.skeleton)(),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: (0, $dLPiE.skeleton)()
            },
            to: {
                backgroundColor: (0, $dLPiE.N30A)
            }
        }
    };
};
var $c4539be2bc51f2d5$var$templateObject_1;

});
parcelRegister("9eh8e", function(module, exports) {

$parcel$export(module.exports, "__makeTemplateObject", function () { return $6b82b5e03618e5cf$export$4fb47efe1390b86f; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $6b82b5e03618e5cf$var$extendStatics = function(d, b) {
    $6b82b5e03618e5cf$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $6b82b5e03618e5cf$var$extendStatics(d, b);
};
function $6b82b5e03618e5cf$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $6b82b5e03618e5cf$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $6b82b5e03618e5cf$export$18ce0697a983be9b = function() {
    $6b82b5e03618e5cf$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6b82b5e03618e5cf$export$18ce0697a983be9b.apply(this, arguments);
};
function $6b82b5e03618e5cf$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $6b82b5e03618e5cf$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $6b82b5e03618e5cf$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $6b82b5e03618e5cf$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $6b82b5e03618e5cf$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $6b82b5e03618e5cf$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $6b82b5e03618e5cf$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $6b82b5e03618e5cf$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $6b82b5e03618e5cf$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $6b82b5e03618e5cf$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $6b82b5e03618e5cf$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $6b82b5e03618e5cf$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $6b82b5e03618e5cf$export$45d3717a4c69092e(o, m, p);
}
function $6b82b5e03618e5cf$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $6b82b5e03618e5cf$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $6b82b5e03618e5cf$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($6b82b5e03618e5cf$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $6b82b5e03618e5cf$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $6b82b5e03618e5cf$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $6b82b5e03618e5cf$export$10c90e4f7922046c(v) {
    return this instanceof $6b82b5e03618e5cf$export$10c90e4f7922046c ? (this.v = v, this) : new $6b82b5e03618e5cf$export$10c90e4f7922046c(v);
}
function $6b82b5e03618e5cf$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $6b82b5e03618e5cf$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $6b82b5e03618e5cf$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $6b82b5e03618e5cf$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $6b82b5e03618e5cf$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $6b82b5e03618e5cf$export$19a8beecd37a4c45 === "function" ? $6b82b5e03618e5cf$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $6b82b5e03618e5cf$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $6b82b5e03618e5cf$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $6b82b5e03618e5cf$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $6b82b5e03618e5cf$export$45d3717a4c69092e(result, mod, k);
    }
    $6b82b5e03618e5cf$var$__setModuleDefault(result, mod);
    return result;
}
function $6b82b5e03618e5cf$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $6b82b5e03618e5cf$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $6b82b5e03618e5cf$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $6b82b5e03618e5cf$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $6b82b5e03618e5cf$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $6b82b5e03618e5cf$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $6b82b5e03618e5cf$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $6b82b5e03618e5cf$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $6b82b5e03618e5cf$export$2e2bcd8739ae039 = {
    __extends: $6b82b5e03618e5cf$export$a8ba968b8961cb8a,
    __assign: $6b82b5e03618e5cf$export$18ce0697a983be9b,
    __rest: $6b82b5e03618e5cf$export$3c9a16f847548506,
    __decorate: $6b82b5e03618e5cf$export$29e00dfd3077644b,
    __param: $6b82b5e03618e5cf$export$d5ad3fd78186038f,
    __metadata: $6b82b5e03618e5cf$export$f1db080c865becb9,
    __awaiter: $6b82b5e03618e5cf$export$1050f835b63b671e,
    __generator: $6b82b5e03618e5cf$export$67ebef60e6f28a6,
    __createBinding: $6b82b5e03618e5cf$export$45d3717a4c69092e,
    __exportStar: $6b82b5e03618e5cf$export$f33643c0debef087,
    __values: $6b82b5e03618e5cf$export$19a8beecd37a4c45,
    __read: $6b82b5e03618e5cf$export$8d051b38c9118094,
    __spread: $6b82b5e03618e5cf$export$afc72e2116322959,
    __spreadArrays: $6b82b5e03618e5cf$export$6388937ca91ccae8,
    __spreadArray: $6b82b5e03618e5cf$export$1216008129fb82ed,
    __await: $6b82b5e03618e5cf$export$10c90e4f7922046c,
    __asyncGenerator: $6b82b5e03618e5cf$export$e427f37a30a4de9b,
    __asyncDelegator: $6b82b5e03618e5cf$export$bbd80228419bb833,
    __asyncValues: $6b82b5e03618e5cf$export$e3b29a3d6162315f,
    __makeTemplateObject: $6b82b5e03618e5cf$export$4fb47efe1390b86f,
    __importStar: $6b82b5e03618e5cf$export$c21735bcef00d192,
    __importDefault: $6b82b5e03618e5cf$export$da59b14a69baef04,
    __classPrivateFieldGet: $6b82b5e03618e5cf$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $6b82b5e03618e5cf$export$d40a35129aaff81f,
    __classPrivateFieldIn: $6b82b5e03618e5cf$export$81fdc39f203e4e04,
    __addDisposableResource: $6b82b5e03618e5cf$export$88ac25d8e944e405,
    __disposeResources: $6b82b5e03618e5cf$export$8f076105dc360e92
};

});

parcelRegister("dLPiE", function(module, exports) {

$parcel$export(module.exports, "B100", function () { return $a0677534b1587403$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "N0", function () { return $a0677534b1587403$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $a0677534b1587403$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N200", function () { return $a0677534b1587403$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N500", function () { return $a0677534b1587403$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N800", function () { return $a0677534b1587403$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N30A", function () { return $a0677534b1587403$export$920c0d5c49070351; });
$parcel$export(module.exports, "N60A", function () { return $a0677534b1587403$export$d2d3bedfb276cac0; });
$parcel$export(module.exports, "background", function () { return $a0677534b1587403$export$8ce1fd94bee2f412; });
$parcel$export(module.exports, "backgroundActive", function () { return $a0677534b1587403$export$b861914ea877b580; });
$parcel$export(module.exports, "backgroundHover", function () { return $a0677534b1587403$export$3f1b020df94387af; });
$parcel$export(module.exports, "text", function () { return $a0677534b1587403$export$6f093cfa640b7166; });
$parcel$export(module.exports, "textHover", function () { return $a0677534b1587403$export$42f8e9c698766e7a; });
$parcel$export(module.exports, "textActive", function () { return $a0677534b1587403$export$c2d157ca1c34b6e3; });
$parcel$export(module.exports, "skeleton", function () { return $a0677534b1587403$export$2a0674ff2eb10214; });

var $lTJmB = parcelRequire("lTJmB");
var $a0677534b1587403$export$4b84fd0e2c617bd = "#FFEBE6";
var $a0677534b1587403$export$b34b069eff244586 = "#FFBDAD";
var $a0677534b1587403$export$be802dd0d8b57f35 = "#FF8F73";
var $a0677534b1587403$export$60847d42f9da92a6 = "#FF7452";
var $a0677534b1587403$export$4a7404f376229999 = "#FF5630";
var $a0677534b1587403$export$2010d0fb4295b346 = "#DE350B";
var $a0677534b1587403$export$2837b5a1a71d5c02 = "#BF2600";
var $a0677534b1587403$export$8d9596b529bbb9cf = "#FFFAE6";
var $a0677534b1587403$export$41060a744ab0b7ae = "#FFF0B3";
var $a0677534b1587403$export$1cc05bbbf340e559 = "#FFE380";
var $a0677534b1587403$export$5aae31392d72caaa = "#FFC400";
var $a0677534b1587403$export$c6930421db9fa514 = "#FFAB00";
var $a0677534b1587403$export$59619663aa6500fb = "#FF991F";
var $a0677534b1587403$export$874739ea9e379ab6 = "#FF8B00";
var $a0677534b1587403$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $a0677534b1587403$export$69a3bf21b9686c2b = "#ABF5D1";
var $a0677534b1587403$export$afbce1382ec95f73 = "#79F2C0";
var $a0677534b1587403$export$747d86715d4175de = "#57D9A3";
var $a0677534b1587403$export$940e1f69e873f202 = "#36B37E";
var $a0677534b1587403$export$a49394138f7b8e85 = "#00875A";
var $a0677534b1587403$export$6fa04827ac68a4fb = "#006644";
var $a0677534b1587403$export$226de0355ed012f8 = "#DEEBFF";
var $a0677534b1587403$export$8c13c2ee36917869 = "#B3D4FF";
var $a0677534b1587403$export$ecfc1dff386a3e7a = "#4C9AFF";
var $a0677534b1587403$export$215b7063051591f1 = "#2684FF";
var $a0677534b1587403$export$e62e8919cca44969 = "#0065FF";
var $a0677534b1587403$export$b3de0ae08da2ce64 = "#0052CC";
var $a0677534b1587403$export$a6ee3d71bc067634 = "#0747A6";
var $a0677534b1587403$export$363e4475840015bb = "#EAE6FF";
var $a0677534b1587403$export$4b0a4417ed59760f = "#C0B6F2";
var $a0677534b1587403$export$6011520a64d9a187 = "#998DD9";
var $a0677534b1587403$export$a7175d4e9206bc80 = "#8777D9";
var $a0677534b1587403$export$b48405b95304b5a1 = "#6554C0";
var $a0677534b1587403$export$c71e4279dd54a18d = "#5243AA";
var $a0677534b1587403$export$147899de772240ec = "#403294";
var $a0677534b1587403$export$2cf711fe14c66f06 = "#E6FCFF";
var $a0677534b1587403$export$7a8f4d33f6f9772c = "#B3F5FF";
var $a0677534b1587403$export$776c9c497ef08533 = "#79E2F2";
var $a0677534b1587403$export$69cb3ca10c1e330e = "#00C7E6";
var $a0677534b1587403$export$9dc1ef0f3f48059b = "#00B8D9";
var $a0677534b1587403$export$7c835c78b6fcdef8 = "#00A3BF";
var $a0677534b1587403$export$6036577f95c3877e = "#008DA6";
var $a0677534b1587403$export$29a4f05edc054374 = "#FFFFFF";
var $a0677534b1587403$export$e655ef011c4aa1a2 = "#FAFBFC";
var $a0677534b1587403$export$9fdfb749e33cdf97 = "#F4F5F7";
var $a0677534b1587403$export$3e51e8f1440314ba = "#EBECF0";
var $a0677534b1587403$export$1ce2d1575d444ceb = "#DFE1E6";
var $a0677534b1587403$export$8754fc7e6d8b3000 = "#C1C7D0";
var $a0677534b1587403$export$c2e91cbeada39b8b = "#B3BAC5";
var $a0677534b1587403$export$5f71e19f3a7ad9de = "#A5ADBA";
var $a0677534b1587403$export$eaa8c8a70ac22806 = "#97A0AF";
var $a0677534b1587403$export$7c87d337fb91a97d = "#8993A4";
var $a0677534b1587403$export$d6447c357493214f = "#7A869A";
var $a0677534b1587403$export$f563ee71e9ee74cd = "#6B778C";
var $a0677534b1587403$export$e2ef2124cf4024b1 = "#5E6C84";
var $a0677534b1587403$export$eece5f492e429f08 = "#505F79";
var $a0677534b1587403$export$c39c0fe0f26207ae = "#42526E";
var $a0677534b1587403$export$7090862dc3038a9f = "#344563";
var $a0677534b1587403$export$ad0bacf983b7ddaa = "#253858";
var $a0677534b1587403$export$7d61b15e0da132af = "#172B4D";
var $a0677534b1587403$export$fbda843f0a27fe96 = "#091E42";
var $a0677534b1587403$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $a0677534b1587403$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $a0677534b1587403$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $a0677534b1587403$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $a0677534b1587403$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $a0677534b1587403$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $a0677534b1587403$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $a0677534b1587403$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $a0677534b1587403$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $a0677534b1587403$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $a0677534b1587403$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $a0677534b1587403$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $a0677534b1587403$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $a0677534b1587403$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $a0677534b1587403$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $a0677534b1587403$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $a0677534b1587403$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $a0677534b1587403$export$2f6319cf7d736c2a = "#E6EDFA";
var $a0677534b1587403$export$95126bc8884d6634 = "#DCE5F5";
var $a0677534b1587403$export$8338d8c35d44ff1 = "#CED9EB";
var $a0677534b1587403$export$5368d76ae4fbbda7 = "#B8C7E0";
var $a0677534b1587403$export$9f0a771d16ec8d36 = "#ABBBD6";
var $a0677534b1587403$export$abcf8c38338b4aa5 = "#9FB0CC";
var $a0677534b1587403$export$97e81faa16a182c7 = "#8C9CB8";
var $a0677534b1587403$export$bfe21c59123ecf33 = "#7988A3";
var $a0677534b1587403$export$ee82aa2ea6a1558 = "#67758F";
var $a0677534b1587403$export$682927c6ed76be02 = "#56637A";
var $a0677534b1587403$export$91fd9994c5be9757 = "#455166";
var $a0677534b1587403$export$d281fbfe3cff2df6 = "#3B475C";
var $a0677534b1587403$export$3902c91d8b98a753 = "#313D52";
var $a0677534b1587403$export$8e8133c1ba5845b5 = "#283447";
var $a0677534b1587403$export$33ff357f6620b39 = "#202B3D";
var $a0677534b1587403$export$633847cf062b69e0 = "#1B2638";
var $a0677534b1587403$export$9776a6e503bdbf76 = "#121A29";
var $a0677534b1587403$export$6c813d5160dff5db = "#0E1624";
var $a0677534b1587403$export$3d4f271a500072a = "#0D1424";
var $a0677534b1587403$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $a0677534b1587403$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $a0677534b1587403$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $a0677534b1587403$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $a0677534b1587403$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $a0677534b1587403$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $a0677534b1587403$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $a0677534b1587403$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $a0677534b1587403$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $a0677534b1587403$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $a0677534b1587403$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $a0677534b1587403$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $a0677534b1587403$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $a0677534b1587403$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $a0677534b1587403$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $a0677534b1587403$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $a0677534b1587403$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $a0677534b1587403$export$8ce1fd94bee2f412 = (0, $lTJmB.default)({
    light: $a0677534b1587403$export$29a4f05edc054374,
    dark: $a0677534b1587403$export$633847cf062b69e0
});
var $a0677534b1587403$export$b861914ea877b580 = (0, $lTJmB.default)({
    light: $a0677534b1587403$export$226de0355ed012f8,
    dark: $a0677534b1587403$export$8c13c2ee36917869
});
var $a0677534b1587403$export$3f1b020df94387af = (0, $lTJmB.default)({
    light: $a0677534b1587403$export$3e51e8f1440314ba,
    dark: $a0677534b1587403$export$d281fbfe3cff2df6
});
var $a0677534b1587403$export$c0183dbab98ca63e = (0, $lTJmB.default)({
    light: $a0677534b1587403$export$29a4f05edc054374,
    dark: $a0677534b1587403$export$8e8133c1ba5845b5
});
var $a0677534b1587403$export$6f093cfa640b7166 = (0, $lTJmB.default)({
    light: $a0677534b1587403$export$fbda843f0a27fe96,
    dark: $a0677534b1587403$export$5368d76ae4fbbda7
});
var $a0677534b1587403$export$42f8e9c698766e7a = (0, $lTJmB.default)({
    light: $a0677534b1587403$export$7d61b15e0da132af,
    dark: $a0677534b1587403$export$5368d76ae4fbbda7
});
var $a0677534b1587403$export$c2d157ca1c34b6e3 = (0, $lTJmB.default)({
    light: $a0677534b1587403$export$b3de0ae08da2ce64,
    dark: $a0677534b1587403$export$b3de0ae08da2ce64
});
var $a0677534b1587403$export$1905ba28d7cf066f = (0, $lTJmB.default)({
    light: $a0677534b1587403$export$f563ee71e9ee74cd,
    dark: $a0677534b1587403$export$97e81faa16a182c7
});
var $a0677534b1587403$export$bd9002130d306d39 = (0, $lTJmB.default)({
    light: $a0677534b1587403$export$d6447c357493214f,
    dark: $a0677534b1587403$export$bfe21c59123ecf33
});
var $a0677534b1587403$export$46e4a324ac90507f = (0, $lTJmB.default)({
    light: $a0677534b1587403$export$7d61b15e0da132af,
    dark: $a0677534b1587403$export$5368d76ae4fbbda7
});
var $a0677534b1587403$export$79f3f2b82beb0d36 = (0, $lTJmB.default)({
    light: $a0677534b1587403$export$f563ee71e9ee74cd,
    dark: $a0677534b1587403$export$97e81faa16a182c7
});
var $a0677534b1587403$export$7bb0d5c671655cc4 = (0, $lTJmB.default)({
    light: $a0677534b1587403$export$9fdfb749e33cdf97,
    dark: $a0677534b1587403$export$8e8133c1ba5845b5
});
var $a0677534b1587403$export$9c30223ca0a664fb = (0, $lTJmB.default)({
    light: $a0677534b1587403$export$b3de0ae08da2ce64,
    dark: $a0677534b1587403$export$ecfc1dff386a3e7a
});
var $a0677534b1587403$export$7ed258b0728b004b = (0, $lTJmB.default)({
    light: $a0677534b1587403$export$e62e8919cca44969,
    dark: $a0677534b1587403$export$215b7063051591f1
});
var $a0677534b1587403$export$dfa920d8decc8a59 = (0, $lTJmB.default)({
    light: $a0677534b1587403$export$a6ee3d71bc067634,
    dark: $a0677534b1587403$export$ecfc1dff386a3e7a
});
var $a0677534b1587403$export$6069e6ad5c78f632 = (0, $lTJmB.default)({
    light: $a0677534b1587403$export$ecfc1dff386a3e7a,
    dark: $a0677534b1587403$export$215b7063051591f1
});
var $a0677534b1587403$export$9ad721cf3b3debe0 = (0, $lTJmB.default)({
    light: $a0677534b1587403$export$b3de0ae08da2ce64,
    dark: $a0677534b1587403$export$ecfc1dff386a3e7a
});
var $a0677534b1587403$export$2aa0182783e7e9de = (0, $lTJmB.default)({
    light: $a0677534b1587403$export$b3de0ae08da2ce64,
    dark: $a0677534b1587403$export$ecfc1dff386a3e7a
});
var $a0677534b1587403$export$8bf7dff220b82b4a = (0, $lTJmB.default)({
    light: $a0677534b1587403$export$9dc1ef0f3f48059b,
    dark: $a0677534b1587403$export$69cb3ca10c1e330e
});
var $a0677534b1587403$export$e13cce2a2d16a9d4 = (0, $lTJmB.default)({
    light: $a0677534b1587403$export$b48405b95304b5a1,
    dark: $a0677534b1587403$export$6011520a64d9a187
});
var $a0677534b1587403$export$a90204d1394caf30 = (0, $lTJmB.default)({
    light: $a0677534b1587403$export$4a7404f376229999,
    dark: $a0677534b1587403$export$4a7404f376229999
});
var $a0677534b1587403$export$594c5a8758200c32 = (0, $lTJmB.default)({
    light: $a0677534b1587403$export$c6930421db9fa514,
    dark: $a0677534b1587403$export$c6930421db9fa514
});
var $a0677534b1587403$export$955a2ebd2fb142ae = (0, $lTJmB.default)({
    light: $a0677534b1587403$export$940e1f69e873f202,
    dark: $a0677534b1587403$export$940e1f69e873f202
});
var $a0677534b1587403$export$2a0674ff2eb10214 = function() {
    return $a0677534b1587403$export$8d43898f60b96a82;
};

});
parcelRegister("lTJmB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff11ec4a71e7331f$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $cgyyU = parcelRequire("cgyyU");
// Unpack custom variants, and get correct value for the current theme
function $ff11ec4a71e7331f$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $cgyyU.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $ff11ec4a71e7331f$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $ff11ec4a71e7331f$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $cgyyU.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("cgyyU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ee1c9f62e8202eb$export$2e2bcd8739ae039; });
// ideally this would be fetched from ../constants but that causes a
// circular dep loop. This will be refactored as part of a breaking
// change in the future.
var $8ee1c9f62e8202eb$var$DEFAULT_THEME_MODE = "light";
var $8ee1c9f62e8202eb$var$THEME_MODES = [
    "light",
    "dark"
];
function $8ee1c9f62e8202eb$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ("__ATLASKIT_THEME__" in props.theme) return props.theme.__ATLASKIT_THEME__;
        else if ("mode" in props.theme && $8ee1c9f62e8202eb$var$THEME_MODES.includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: $8ee1c9f62e8202eb$var$DEFAULT_THEME_MODE
    };
}

});






parcelRegister("4afMH", function(module, exports) {
module.exports = JSON.parse('{"name":"@atlaskit/droplist","version":"11.0.0","sideEffects":false}');

});


parcelRegister("je2eW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dff10fefe5cad30a$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $ekTUg = parcelRequire("ekTUg");
var $dff10fefe5cad30a$var$DroplistGroup = /*#__PURE__*/ function(_PureComponent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(DroplistGroup, _PureComponent);
    function DroplistGroup() {
        var _getPrototypeOf2;
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, DroplistGroup);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, (_getPrototypeOf2 = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(DroplistGroup)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "state", {
            ariaLabel: _this.props.heading
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "componentDidMount", function() {
            if (_this.props.heading || _this.props.elemAfter) _this.setState({
                ariaLabel: _this.getAriaLabel()
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "componentDidUpdate", function() {
            if (_this.props.heading || _this.props.elemAfter) // eslint-disable-next-line react/no-did-update-set-state
            _this.setState({
                ariaLabel: _this.getAriaLabel()
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getAriaLabel", function() {
            var _this$props = _this.props, elemAfter = _this$props.elemAfter, heading = _this$props.heading;
            var afterText = elemAfter && typeof elemAfter === "string" ? elemAfter : _this.headingElement && _this.headingElement.textContent;
            return "".concat(heading || "", " ").concat(afterText || "");
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(DroplistGroup, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, children = _this$props2.children, elemAfter = _this$props2.elemAfter, heading = _this$props2.heading;
                var ariaLabel = this.state.ariaLabel;
                return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ekTUg.default), {
                    "aria-label": ariaLabel,
                    role: "group"
                }, heading ? (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ekTUg.Heading), {
                    "aria-hidden": "true",
                    "data-role": "droplistGroupHeading"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ekTUg.HeadingText), null, heading), elemAfter ? (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ekTUg.HeadingAfter), {
                    innerRef: function innerRef(r) {
                        _this2.headingElement = r;
                    }
                }, elemAfter) : null) : null, children);
            }
        }
    ]);
    return DroplistGroup;
}((0, $9nHZC.PureComponent));
$dff10fefe5cad30a$var$DroplistGroup.displayName = "Group";
var $dff10fefe5cad30a$export$2e2bcd8739ae039 = $dff10fefe5cad30a$var$DroplistGroup;

});
parcelRegister("ekTUg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6fe4ccfbaa95234$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Heading", function () { return $a6fe4ccfbaa95234$export$a8a3e93435678ff9; });
$parcel$export(module.exports, "HeadingAfter", function () { return $a6fe4ccfbaa95234$export$5194c609aa15d6c4; });
$parcel$export(module.exports, "HeadingText", function () { return $a6fe4ccfbaa95234$export$a426786f4dd1b1c6; });

var $13MK1 = parcelRequire("13MK1");

var $6qb7n = parcelRequire("6qb7n");

var $kRQKu = parcelRequire("kRQKu");

var $eNY11 = parcelRequire("eNY11");

var $dM68a = parcelRequire("dM68a");
var $a6fe4ccfbaa95234$export$2e2bcd8739ae039 = (0, $13MK1.default).div.withConfig({
    displayName: "Group",
    componentId: "sc-1q26u8b-0"
})([
    "\n  box-sizing: border-box;\n  display: block;\n  margin-top: ",
    "px;\n\n  &:first-child {\n    margin-top: 0;\n  }\n"
], (0, $eNY11.gridSize));
var $a6fe4ccfbaa95234$export$a8a3e93435678ff9 = (0, $13MK1.default).div.withConfig({
    displayName: "Group__Heading",
    componentId: "sc-1q26u8b-1"
})([
    "\n  align-items: baseline;\n  color: ",
    ";\n  display: flex;\n  flex: 1 1 auto;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 1;\n  margin: 0;\n  padding: ",
    "px ",
    "px;\n"
], (0, $kRQKu.default)({
    light: (0, $6qb7n.N300),
    dark: (0, $6qb7n.DN300)
}), (0, $eNY11.gridSize), (0, $dM68a.multiply)((0, $eNY11.gridSize), 1.5));
var $a6fe4ccfbaa95234$export$5194c609aa15d6c4 = (0, $13MK1.default).div.withConfig({
    displayName: "Group__HeadingAfter",
    componentId: "sc-1q26u8b-2"
})([
    "\n  flex: 0 0 auto;\n"
]);
var $a6fe4ccfbaa95234$export$a426786f4dd1b1c6 = (0, $13MK1.default).div.withConfig({
    displayName: "Group__HeadingText",
    componentId: "sc-1q26u8b-3"
})([
    "\n  flex: 1 1 auto;\n  font-size: 12px;\n  text-transform: uppercase;\n"
]);

});


parcelRegister("ikiOd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d578af546aef3fbe$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");

var $2GEmJ = parcelRequire("2GEmJ");
var $aGitN = parcelRequire("aGitN");
var $kaBIb = parcelRequire("kaBIb");

var $2XL9e = parcelRequire("2XL9e");

var $3ED2j = parcelRequire("3ED2j");

var $a7iuM = parcelRequire("a7iuM");

var $i2BCF = parcelRequire("i2BCF");

var $7Vui1 = parcelRequire("7Vui1");

var $4afMH = parcelRequire("4afMH");

var $djmeL = parcelRequire("djmeL");
var $d578af546aef3fbe$var$inputTypes = {
    checkbox: (0, (/*@__PURE__*/$parcel$interopDefault($2XL9e))),
    radio: (0, (/*@__PURE__*/$parcel$interopDefault($3ED2j)))
};
var $d578af546aef3fbe$export$f98bc0baa0d5ce5a = /*#__PURE__*/ function(_PureComponent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(Item, _PureComponent);
    function Item() {
        var _getPrototypeOf2;
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, Item);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, (_getPrototypeOf2 = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Item)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "state", {
            isHovered: false,
            isPressed: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "componentDidMount", function() {
            return document.addEventListener("mouseup", _this.handleMouseUp);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "componentWillUnmount", function() {
            return document.removeEventListener("mouseup", _this.handleMouseUp);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "guardedActivate", function(event) {
            var _this$props = _this.props, isDisabled = _this$props.isDisabled, onActivate = _this$props.onActivate;
            if (!isDisabled && onActivate) onActivate({
                item: (0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this),
                event: event
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleClick", function(event) {
            return _this.guardedActivate(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleKeyPress", function(event) {
            var keyIsValid = [
                "Enter",
                " "
            ].indexOf(event.key) > -1;
            if (keyIsValid) _this.guardedActivate(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleMouseDown", function() {
            return _this.setState({
                isPressed: true
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleMouseUp", function() {
            return _this.setState({
                isPressed: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleMouseOut", function() {
            return _this.setState({
                isHovered: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleMouseOver", function() {
            return _this.setState({
                isHovered: true
            });
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(Item, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var _this$state = this.state, isHovered = _this$state.isHovered, isPressed = _this$state.isPressed;
                var type = props.type || "";
                var hasInput = [
                    "checkbox",
                    "radio"
                ].indexOf(type) > -1;
                var Input = $d578af546aef3fbe$var$inputTypes[type];
                var appearanceProps = {
                    isActive: props.type === "link" && props.isActive || props.type === "option" && props.isSelected,
                    isChecked: [
                        "checkbox",
                        "radio"
                    ].indexOf(type) > -1 && props.isChecked,
                    isDisabled: props.isDisabled,
                    isFocused: props.isFocused,
                    isHidden: props.isHidden,
                    isHovered: isHovered,
                    isPressed: isPressed,
                    isSelected: type === "option" && props.isSelected,
                    isPrimary: props.appearance === "primary"
                };
                var element = (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $djmeL.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, appearanceProps, {
                    handleClick: this.handleClick,
                    handleKeyPress: this.handleKeyPress,
                    handleMouseOut: this.handleMouseOut,
                    handleMouseOver: this.handleMouseOver,
                    handleMouseUp: this.handleMouseUp,
                    handleMouseDown: this.handleMouseDown,
                    href: props.href,
                    target: props.target,
                    title: props.title,
                    type: props.type
                }), hasInput && (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $i2BCF.InputWrapper), appearanceProps, (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Input, {
                    label: "",
                    primaryColor: (0, $7Vui1.getInputBackground)(appearanceProps),
                    secondaryColor: (0, $7Vui1.getInputFill)(appearanceProps),
                    size: "medium"
                })), !!props.elemBefore && (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $i2BCF.Before), null, props.elemBefore), (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $i2BCF.ContentWrapper), null, (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $i2BCF.Content), {
                    allowMultiline: this.context.shouldAllowMultilineItems
                }, props.children), !!props.description && (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $i2BCF.Description), null, props.description)), !!props.elemAfter && (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $i2BCF.After), null, props.elemAfter));
                return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", {
                    role: "presentation"
                }, props.tooltipDescription ? (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $a7iuM.default), {
                    content: props.tooltipDescription,
                    position: props.tooltipPosition
                }, element) : element);
            }
        }
    ]);
    return Item;
}((0, $9nHZC.PureComponent));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($d578af546aef3fbe$export$f98bc0baa0d5ce5a, "defaultProps", {
    appearance: "default",
    children: null,
    description: "",
    elemAfter: null,
    elemBefore: null,
    href: null,
    isActive: false,
    isChecked: false,
    isDisabled: false,
    isFocused: false,
    isHidden: false,
    isSelected: false,
    itemContext: "menu",
    onActivate: function onActivate() {},
    target: null,
    title: null,
    tooltipDescription: null,
    tooltipPosition: "right",
    type: "link"
});
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($d578af546aef3fbe$export$f98bc0baa0d5ce5a, "contextTypes", {
    shouldAllowMultilineItems: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).bool
});
var $d578af546aef3fbe$var$createAndFireEventOnAtlaskit = (0, $2GEmJ.default)("atlaskit");
var $d578af546aef3fbe$export$2e2bcd8739ae039 = (0, $aGitN.default)({
    componentName: "droplistItem",
    packageName: (0, $4afMH.name),
    packageVersion: (0, $4afMH.version)
})((0, $kaBIb.default)({
    onActivate: $d578af546aef3fbe$var$createAndFireEventOnAtlaskit({
        action: "selected",
        actionSubject: "droplistItem",
        attributes: {
            componentName: "droplistItem",
            packageName: (0, $4afMH.name),
            packageVersion: (0, $4afMH.version)
        }
    })
})($d578af546aef3fbe$export$f98bc0baa0d5ce5a));

});
parcelRegister("2XL9e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2285aa06f42ce4b0$var$_react = $2285aa06f42ce4b0$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $flr13 = parcelRequire("flr13");
function $2285aa06f42ce4b0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2285aa06f42ce4b0$var$CheckboxIcon = (props)=>/*#__PURE__*/ $2285aa06f42ce4b0$var$_react.default.createElement($flr13.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect fill="currentColor" x="6" y="6" width="12" height="12" rx="2"/><path d="M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z" fill="inherit"/></g></svg>`
    }, props));
$2285aa06f42ce4b0$var$CheckboxIcon.displayName = "CheckboxIcon";
var $2285aa06f42ce4b0$var$_default = $2285aa06f42ce4b0$var$CheckboxIcon;
module.exports.default = $2285aa06f42ce4b0$var$_default;

});
parcelRegister("flr13", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $b2bdc5f9f88cafe9$export$f04a61298a47a40f; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $iIMPG = parcelRequire("iIMPG");

var $gWhOR = parcelRequire("gWhOR");

var $8YSC4 = parcelRequire("8YSC4");
function $b2bdc5f9f88cafe9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b2bdc5f9f88cafe9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b2bdc5f9f88cafe9$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b2bdc5f9f88cafe9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $b2bdc5f9f88cafe9$var$iconStyles = (0, $avKww.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "> svg": $b2bdc5f9f88cafe9$var$_objectSpread($b2bdc5f9f88cafe9$var$_objectSpread({}, (0, $8YSC4.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $b2bdc5f9f88cafe9$var$baseHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $b2bdc5f9f88cafe9$var$primaryEqualsSecondaryHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $b2bdc5f9f88cafe9$var$secondaryTransparentHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $b2bdc5f9f88cafe9$export$f04a61298a47a40f = /*#__PURE__*/ (0, $9nHZC.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $avKww.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $8YSC4.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    var _useGlobalTheme = (0, $iIMPG.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $avKww.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            "--icon-secondary-color": secondaryColor || (0, $gWhOR.getBackground)(mode)
        }
    }, glyphProps, {
        css: [
            $b2bdc5f9f88cafe9$var$iconStyles,
            $b2bdc5f9f88cafe9$var$baseHcmStyles,
            primaryColor === secondaryColor && $b2bdc5f9f88cafe9$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $b2bdc5f9f88cafe9$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsualting them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $avKww.css)({
                width: dimensions.width,
                height: dimensions.height,
                "> svg": dimensions
            })
        ]
    }));
});
var $b2bdc5f9f88cafe9$export$2e2bcd8739ae039 = $b2bdc5f9f88cafe9$export$f04a61298a47a40f;

});
parcelRegister("iIMPG", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", function () { return $da1237334caf55af$export$7692396083754928; });

var $2dRfy = parcelRequire("2dRfy");
// Create default global light theme
var $da1237334caf55af$var$_createTheme = (0, $2dRfy.createTheme)(function() {
    return {
        mode: "light"
    };
}), $da1237334caf55af$var$Provider = $da1237334caf55af$var$_createTheme.Provider, $da1237334caf55af$var$Consumer = $da1237334caf55af$var$_createTheme.Consumer, $da1237334caf55af$export$7692396083754928 = $da1237334caf55af$var$_createTheme.useTheme;
var $da1237334caf55af$var$Theme = {
    Provider: $da1237334caf55af$var$Provider,
    Consumer: $da1237334caf55af$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$da1237334caf55af$export$2e2bcd8739ae039 = $da1237334caf55af$var$Theme;

});
parcelRegister("2dRfy", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $19e619f7e4267552$export$25d302a5b900a763; });

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");
var $19e619f7e4267552$var$_excluded = [
    "children"
];
function $19e619f7e4267552$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $9nHZC.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $9nHZC.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(props, $19e619f7e4267552$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $9nHZC.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $9nHZC.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("gWhOR", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $c54fe2abceaf2f1d$export$18cb9425622d4e06; });
var $c54fe2abceaf2f1d$var$themedBackground = {
    light: "var(--ds-surface, #FFFFFF)",
    dark: "var(--ds-surface, #1B2638)"
};
var $c54fe2abceaf2f1d$export$18cb9425622d4e06 = function getBackground() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "light";
    return $c54fe2abceaf2f1d$var$themedBackground[mode];
};

});

parcelRegister("8YSC4", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $689e4a50ac148552$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $689e4a50ac148552$export$3eb7d6130acfda37; });

var $9mp1w = parcelRequire("9mp1w");

var $avKww = parcelRequire("avKww");
var $689e4a50ac148552$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
var $689e4a50ac148552$var$smallStyles = (0, $avKww.css)((0, $9mp1w.dimensions).small);
var $689e4a50ac148552$var$mediumStyles = (0, $avKww.css)((0, $9mp1w.dimensions).medium);
var $689e4a50ac148552$var$largeStyles = (0, $avKww.css)((0, $9mp1w.dimensions).large);
var $689e4a50ac148552$var$xlargeStyles = (0, $avKww.css)((0, $9mp1w.dimensions).xlarge);
var $689e4a50ac148552$export$ef0ad74202575b64 = {
    small: $689e4a50ac148552$var$smallStyles,
    medium: $689e4a50ac148552$var$mediumStyles,
    large: $689e4a50ac148552$var$largeStyles,
    xlarge: $689e4a50ac148552$var$xlargeStyles
};
var $689e4a50ac148552$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $9mp1w.dimensions)[size];
    return undefined;
};

});
parcelRegister("9mp1w", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $6d099447573b36e4$export$62ad7b0c781000e9; });
var $6d099447573b36e4$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $6d099447573b36e4$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $6d099447573b36e4$export$62ad7b0c781000e9 = {
    small: {
        width: $6d099447573b36e4$export$c647cb0ee6e282fe.small,
        height: $6d099447573b36e4$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $6d099447573b36e4$export$c647cb0ee6e282fe.medium,
        height: $6d099447573b36e4$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $6d099447573b36e4$export$c647cb0ee6e282fe.large,
        height: $6d099447573b36e4$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $6d099447573b36e4$export$c647cb0ee6e282fe.xlarge,
        height: $6d099447573b36e4$export$c647cb0ee6e282fe.xlarge
    }
};

});




parcelRegister("3ED2j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2a9363537bbcc402$var$_react = $2a9363537bbcc402$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $flr13 = parcelRequire("flr13");
function $2a9363537bbcc402$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2a9363537bbcc402$var$RadioIcon = (props)=>/*#__PURE__*/ $2a9363537bbcc402$var$_react.default.createElement($flr13.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="6"/><circle fill="inherit" cx="12" cy="12" r="2"/></g></svg>`
    }, props));
$2a9363537bbcc402$var$RadioIcon.displayName = "RadioIcon";
var $2a9363537bbcc402$var$_default = $2a9363537bbcc402$var$RadioIcon;
module.exports.default = $2a9363537bbcc402$var$_default;

});

parcelRegister("a7iuM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75d8e7a24683c013$export$2e2bcd8739ae039; });
/* eslint-disable react/require-default-props */ 
var $4KY13 = parcelRequire("4KY13");

var $9nHZC = parcelRequire("9nHZC");

var $akN0d = parcelRequire("akN0d");

var $5cScH = parcelRequire("5cScH");

var $2GEmJ = parcelRequire("2GEmJ");
var $aGitN = parcelRequire("aGitN");
var $kaBIb = parcelRequire("kaBIb");

var $8J5wH = parcelRequire("8J5wH");

var $97YIy = parcelRequire("97YIy");

var $dwTAS = parcelRequire("dwTAS");

var $k9KMZ = parcelRequire("k9KMZ");

var $1NwBY = parcelRequire("1NwBY");

var $ial0q = parcelRequire("ial0q");

var $fP2Al = parcelRequire("fP2Al");
var $75d8e7a24683c013$var$SCROLL_OPTIONS = {
    capture: true,
    passive: true
};
function $75d8e7a24683c013$var$getMousePosition(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}
var $75d8e7a24683c013$var$pendingHide;
var $75d8e7a24683c013$var$showTooltip = function(fn, defaultDelay) {
    var isHidePending = $75d8e7a24683c013$var$pendingHide && $75d8e7a24683c013$var$pendingHide.pending();
    if (isHidePending) $75d8e7a24683c013$var$pendingHide.flush();
    var pendingShow = (0, (/*@__PURE__*/$parcel$interopDefault($akN0d)))(function() {
        return fn(isHidePending);
    }, isHidePending ? 0 : defaultDelay);
    return pendingShow.cancel;
};
var $75d8e7a24683c013$var$hideTooltip = function(fn, defaultDelay) {
    $75d8e7a24683c013$var$pendingHide = (0, (/*@__PURE__*/$parcel$interopDefault($akN0d)))(function(flushed) {
        return fn(flushed);
    }, defaultDelay);
    return $75d8e7a24683c013$var$pendingHide.cancel;
};
var $75d8e7a24683c013$export$73d99c547016bc7d = /** @class */ function(_super) {
    (0, $4KY13.__extends)(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wrapperRef = null;
        _this.targetRef = null;
        _this.cancelPendingSetState = function() {};
        _this.userInteraction = "mouse";
        _this.state = {
            immediatelyHide: false,
            immediatelyShow: false,
            isVisible: false,
            renderTooltip: false
        };
        _this.handleWindowScroll = function() {
            if (_this.state.isVisible) {
                _this.cancelPendingSetState();
                _this.setState({
                    isVisible: false,
                    immediatelyHide: true
                });
            }
        };
        _this.handleMouseClick = function() {
            if (_this.props.hideTooltipOnClick) {
                _this.cancelPendingSetState();
                _this.setState({
                    isVisible: false,
                    immediatelyHide: true
                });
            }
        };
        _this.handleMouseDown = function() {
            if (_this.props.hideTooltipOnMouseDown) {
                _this.cancelPendingSetState();
                _this.setState({
                    isVisible: false,
                    immediatelyHide: true
                });
            }
        };
        _this.handleMouseOver = function(e) {
            if (e.target === _this.wrapperRef) return;
            _this.userInteraction = "mouse";
            // In the case where a tooltip is newly rendered but immediately becomes hovered,
            // we need to set the coordinates in the mouseOver event.
            if (!_this.fakeMouseElement) _this.fakeMouseElement = $75d8e7a24683c013$var$getMousePosition({
                left: e.clientX,
                top: e.clientY
            });
            _this.handleShowTooltip();
        };
        _this.handleFocus = function() {
            _this.userInteraction = "keyboard";
            // We need to fake the mouse dimensions even on focus because the code path currently assumes
            // fake mouse element needs to exist before showing the tooltip.
            if (!_this.fakeMouseElement) _this.fakeMouseElement = $75d8e7a24683c013$var$getMousePosition({
                left: 0,
                top: 0
            });
            _this.handleShowTooltip();
        };
        _this.handleShowTooltip = function() {
            _this.cancelPendingSetState();
            if (Boolean(_this.props.content) && !_this.state.isVisible) _this.cancelPendingSetState = $75d8e7a24683c013$var$showTooltip(function(immediatelyShow) {
                _this.setState({
                    isVisible: true,
                    renderTooltip: true,
                    immediatelyShow: immediatelyShow
                });
            }, _this.props.delay || 0);
        };
        _this.handleHideTooltip = function(e) {
            if (e.target === _this.wrapperRef) return;
            _this.cancelPendingSetState();
            if (_this.state.isVisible) _this.cancelPendingSetState = $75d8e7a24683c013$var$hideTooltip(function(immediatelyHide) {
                _this.setState({
                    isVisible: false,
                    immediatelyHide: immediatelyHide
                });
            }, _this.props.delay || 0);
        };
        // Update mouse coordinates, used when position is 'mouse'.
        // We are not debouncing/throttling this function because we aren't causing any
        // re-renders or performaing any intensive calculations, we're just updating a value.
        // React also doesn't play nice debounced DOM event handlers because they pool their
        // SyntheticEvent objects. Need to use event.persist as a workaround - https://stackoverflow.com/a/24679479/893630
        _this.handleMouseMove = function(event) {
            if (!_this.state.renderTooltip) _this.fakeMouseElement = $75d8e7a24683c013$var$getMousePosition({
                left: event.clientX,
                top: event.clientY
            });
        };
        return _this;
    }
    Tooltip.prototype.componentWillUnmount = function() {
        this.cancelPendingSetState();
        this.removeScrollListener();
    };
    Tooltip.prototype.componentDidUpdate = function(_prevProps, prevState) {
        if (!prevState.isVisible && this.state.isVisible) {
            if (this.props.onShow) this.props.onShow();
            window.addEventListener("scroll", this.handleWindowScroll, $75d8e7a24683c013$var$SCROLL_OPTIONS);
        } else if (prevState.isVisible && !this.state.isVisible) {
            if (this.props.onHide) this.props.onHide();
            this.removeScrollListener();
        }
    };
    Tooltip.prototype.removeScrollListener = function() {
        window.removeEventListener("scroll", this.handleWindowScroll, $75d8e7a24683c013$var$SCROLL_OPTIONS);
    };
    Tooltip.prototype.shouldPositionTooltipNearMouse = function() {
        var position = this.props.position;
        return position === "mouse" && this.userInteraction === "mouse";
    };
    Tooltip.prototype.render = function() {
        var _this = this;
        var _a = this.props, children = _a.children, position = _a.position, mousePosition = _a.mousePosition, content = _a.content, truncate = _a.truncate, TooltipContainer = _a.component, TargetContainer = _a.tag, testId = _a.testId;
        var _b = this.state, isVisible = _b.isVisible, renderTooltip = _b.renderTooltip, immediatelyShow = _b.immediatelyShow, immediatelyHide = _b.immediatelyHide;
        var tooltipPosition = position === "mouse" ? mousePosition : position;
        return /* eslint-disable jsx-a11y/mouse-events-have-key-events */ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, TargetContainer && (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(TargetContainer, {
            onClick: this.handleMouseClick,
            onMouseOver: this.handleMouseOver,
            onMouseOut: this.handleHideTooltip,
            onMouseMove: this.handleMouseMove,
            onMouseDown: this.handleMouseDown,
            onFocus: this.handleFocus,
            onBlur: this.handleHideTooltip,
            ref: function(wrapperRef) {
                _this.wrapperRef = wrapperRef;
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5cScH))), {
            innerRef: function(ref) {
                _this.targetRef = ref;
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Children.only(children))), renderTooltip && this.targetRef && this.fakeMouseElement ? (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $97YIy.default), {
            zIndex: (0, $dwTAS.layers).tooltip()
        }, (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $8J5wH.Popper), {
            placement: tooltipPosition,
            referenceElement: // https://github.com/FezVrasta/react-popper#usage-without-a-reference-htmlelement
            // We are using a popper technique to pass in a faked element when we use mouse.
            this.shouldPositionTooltipNearMouse() ? this.fakeMouseElement : this.targetRef
        }, function(_a) {
            var ref = _a.ref, style = _a.style;
            return TooltipContainer && (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ial0q.default), {
                immediatelyShow: immediatelyShow,
                immediatelyHide: immediatelyHide,
                onExited: function() {
                    return _this.setState({
                        renderTooltip: false
                    });
                },
                in: isVisible
            }, function(getAnimationStyles) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(TooltipContainer, {
                    // innerRef can't be null so shortcircuit to undefined if it is.
                    innerRef: ref || undefined,
                    className: "Tooltip",
                    style: (0, $4KY13.__assign)((0, $4KY13.__assign)({}, getAnimationStyles()), style),
                    truncate: truncate || false,
                    "data-placement": tooltipPosition,
                    "data-testid": testId
                }, content);
            });
        })) : null);
    };
    Tooltip.defaultProps = {
        component: (0, $k9KMZ.Tooltip),
        delay: 300,
        mousePosition: "bottom",
        position: "bottom",
        tag: "div"
    };
    return Tooltip;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component);
var $75d8e7a24683c013$var$createAndFireEventOnAtlaskit = (0, $2GEmJ.default)("atlaskit");
var $75d8e7a24683c013$export$2e2bcd8739ae039 = (0, $aGitN.default)({
    componentName: "tooltip",
    packageName: (0, $1NwBY.name),
    packageVersion: (0, $1NwBY.version)
})((0, $kaBIb.default)({
    onHide: (0, $fP2Al.unhoveredPayload),
    onShow: $75d8e7a24683c013$var$createAndFireEventOnAtlaskit((0, $4KY13.__assign)({}, (0, $fP2Al.hoveredPayload)))
})($75d8e7a24683c013$export$73d99c547016bc7d));

});
parcelRegister("4KY13", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $376a0337cf9c095c$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $376a0337cf9c095c$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__makeTemplateObject", function () { return $376a0337cf9c095c$export$4fb47efe1390b86f; });
$parcel$export(module.exports, "__importDefault", function () { return $376a0337cf9c095c$export$da59b14a69baef04; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $376a0337cf9c095c$var$extendStatics = function(d, b) {
    $376a0337cf9c095c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $376a0337cf9c095c$var$extendStatics(d, b);
};
function $376a0337cf9c095c$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $376a0337cf9c095c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $376a0337cf9c095c$export$18ce0697a983be9b = function() {
    $376a0337cf9c095c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $376a0337cf9c095c$export$18ce0697a983be9b.apply(this, arguments);
};
function $376a0337cf9c095c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $376a0337cf9c095c$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $376a0337cf9c095c$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $376a0337cf9c095c$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $376a0337cf9c095c$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $376a0337cf9c095c$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $376a0337cf9c095c$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $376a0337cf9c095c$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $376a0337cf9c095c$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $376a0337cf9c095c$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $376a0337cf9c095c$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $376a0337cf9c095c$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $376a0337cf9c095c$export$45d3717a4c69092e(o, m, p);
}
function $376a0337cf9c095c$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $376a0337cf9c095c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $376a0337cf9c095c$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($376a0337cf9c095c$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $376a0337cf9c095c$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $376a0337cf9c095c$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $376a0337cf9c095c$export$10c90e4f7922046c(v) {
    return this instanceof $376a0337cf9c095c$export$10c90e4f7922046c ? (this.v = v, this) : new $376a0337cf9c095c$export$10c90e4f7922046c(v);
}
function $376a0337cf9c095c$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $376a0337cf9c095c$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $376a0337cf9c095c$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $376a0337cf9c095c$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $376a0337cf9c095c$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $376a0337cf9c095c$export$19a8beecd37a4c45 === "function" ? $376a0337cf9c095c$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $376a0337cf9c095c$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $376a0337cf9c095c$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $376a0337cf9c095c$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $376a0337cf9c095c$export$45d3717a4c69092e(result, mod, k);
    }
    $376a0337cf9c095c$var$__setModuleDefault(result, mod);
    return result;
}
function $376a0337cf9c095c$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $376a0337cf9c095c$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $376a0337cf9c095c$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $376a0337cf9c095c$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $376a0337cf9c095c$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $376a0337cf9c095c$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $376a0337cf9c095c$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $376a0337cf9c095c$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $376a0337cf9c095c$export$2e2bcd8739ae039 = {
    __extends: $376a0337cf9c095c$export$a8ba968b8961cb8a,
    __assign: $376a0337cf9c095c$export$18ce0697a983be9b,
    __rest: $376a0337cf9c095c$export$3c9a16f847548506,
    __decorate: $376a0337cf9c095c$export$29e00dfd3077644b,
    __param: $376a0337cf9c095c$export$d5ad3fd78186038f,
    __metadata: $376a0337cf9c095c$export$f1db080c865becb9,
    __awaiter: $376a0337cf9c095c$export$1050f835b63b671e,
    __generator: $376a0337cf9c095c$export$67ebef60e6f28a6,
    __createBinding: $376a0337cf9c095c$export$45d3717a4c69092e,
    __exportStar: $376a0337cf9c095c$export$f33643c0debef087,
    __values: $376a0337cf9c095c$export$19a8beecd37a4c45,
    __read: $376a0337cf9c095c$export$8d051b38c9118094,
    __spread: $376a0337cf9c095c$export$afc72e2116322959,
    __spreadArrays: $376a0337cf9c095c$export$6388937ca91ccae8,
    __spreadArray: $376a0337cf9c095c$export$1216008129fb82ed,
    __await: $376a0337cf9c095c$export$10c90e4f7922046c,
    __asyncGenerator: $376a0337cf9c095c$export$e427f37a30a4de9b,
    __asyncDelegator: $376a0337cf9c095c$export$bbd80228419bb833,
    __asyncValues: $376a0337cf9c095c$export$e3b29a3d6162315f,
    __makeTemplateObject: $376a0337cf9c095c$export$4fb47efe1390b86f,
    __importStar: $376a0337cf9c095c$export$c21735bcef00d192,
    __importDefault: $376a0337cf9c095c$export$da59b14a69baef04,
    __classPrivateFieldGet: $376a0337cf9c095c$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $376a0337cf9c095c$export$d40a35129aaff81f,
    __classPrivateFieldIn: $376a0337cf9c095c$export$81fdc39f203e4e04,
    __addDisposableResource: $376a0337cf9c095c$export$88ac25d8e944e405,
    __disposeResources: $376a0337cf9c095c$export$8f076105dc360e92
};

});

parcelRegister("akN0d", function(module, exports) {
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    // a timeout function that can be flushed and cancelled
    var flushable = function flushable(onComplete, delay) {
        var timeoutId = setTimeout(function() {
            timeoutId = null;
            onComplete(false);
        }, delay);
        var clearTimer = function clearTimer() {
            if (timeoutId) {
                clearTimeout(timeoutId);
                timeoutId = null;
            }
        };
        return {
            cancel: clearTimer,
            flush: function flush() {
                if (!timeoutId) return;
                clearTimer();
                onComplete(true);
            },
            pending: function pending() {
                return Boolean(timeoutId);
            }
        };
    };
    return flushable;
});

});

parcelRegister("8J5wH", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $65a6d0253ddd8088$export$badac9ada3a0bdf9; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $cjxQA = parcelRequire("cjxQA");

// Export types from PopperJS / React Popper
var $65a6d0253ddd8088$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: 5,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    },
    {
        name: "preventOverflow",
        options: {
            padding: 5,
            rootBoundary: "document"
        }
    }
];
function $65a6d0253ddd8088$var$defaultChildrenFn() {
    return null;
}
var $65a6d0253ddd8088$var$defaultOffset = [
    0,
    8
];
function $65a6d0253ddd8088$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $65a6d0253ddd8088$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $65a6d0253ddd8088$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    // Merge a new offset modifier only if new offset values passed in
    var internalModifiers = (0, $9nHZC.useMemo)(function() {
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        return [].concat($65a6d0253ddd8088$var$constantModifiers, [
            offsetModifier
        ]);
    }, [
        offsetX,
        offsetY
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $9nHZC.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $cjxQA.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});

parcelRegister("dwTAS", function(module, exports) {

$parcel$export(module.exports, "borderRadius", function () { return $9d996346a04d5a1b$export$7a57f79000377ca2; });
$parcel$export(module.exports, "layers", function () { return $9d996346a04d5a1b$export$7be255094ccdc533; });

var $4KY13 = parcelRequire("4KY13");

var $13MK1 = parcelRequire("13MK1");

var $hP8SH = parcelRequire("hP8SH");
var $9d996346a04d5a1b$export$521f2c0e5c12a14d = "__FLATTENED__";
var $9d996346a04d5a1b$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $9d996346a04d5a1b$export$c93026a968943f95 = "light";
var $9d996346a04d5a1b$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $9d996346a04d5a1b$export$7a57f79000377ca2 = function() {
    return 3;
};
var $9d996346a04d5a1b$export$6d8204c2cb2e06b8 = function() {
    return 8;
};
var $9d996346a04d5a1b$export$85e3c3ca0c6fb93 = function() {
    return 14;
};
var $9d996346a04d5a1b$export$6746fe0d9c9fab54 = function() {
    return 11;
};
var $9d996346a04d5a1b$export$a5975749f0374264 = function() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $9d996346a04d5a1b$export$356129969ee49c55 = function() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $9d996346a04d5a1b$export$8e24544ddba725ee = function(color, outlineWidth) {
    if (color === void 0) color = (0, $hP8SH.B100);
    if (outlineWidth === void 0) outlineWidth = $9d996346a04d5a1b$export$6d8204c2cb2e06b8() / 4;
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px " + outlineWidth + "px " + color + ";\n  }\n";
};
var $9d996346a04d5a1b$export$c0dd343266bc3261 = function() {
    return "\n  box-shadow: none;\n";
};
var $9d996346a04d5a1b$export$7be255094ccdc533 = {
    card: function() {
        return 100;
    },
    dialog: function() {
        return 300;
    },
    navigation: function() {
        return 200;
    },
    layer: function() {
        return 400;
    },
    blanket: function() {
        return 500;
    },
    modal: function() {
        return 510;
    },
    flag: function() {
        return 600;
    },
    spotlight: function() {
        return 700;
    },
    tooltip: function() {
        return 800;
    }
};
var $9d996346a04d5a1b$export$a1b3edb637fb4f35 = function() {
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $9d996346a04d5a1b$export$ba1d834b86d72a09 = function() {
    return (0, $13MK1.css)($9d996346a04d5a1b$var$templateObject_1 || ($9d996346a04d5a1b$var$templateObject_1 = (0, $4KY13.__makeTemplateObject)([
        "\n  border: 0 !important;\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  height: 1px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  position: absolute !important;\n  width: 1px !important;\n  white-space: nowrap !important;\n"
    ], [
        "\n  border: 0 !important;\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  height: 1px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  position: absolute !important;\n  width: 1px !important;\n  white-space: nowrap !important;\n"
    ])));
};
var $9d996346a04d5a1b$export$e497e856b4f89fcd = function() {
    return {
        css: {
            backgroundColor: (0, $hP8SH.skeleton)(),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: (0, $hP8SH.skeleton)()
            },
            to: {
                backgroundColor: (0, $hP8SH.N30A)
            }
        }
    };
};
var $9d996346a04d5a1b$var$templateObject_1;

});
parcelRegister("hP8SH", function(module, exports) {

$parcel$export(module.exports, "B100", function () { return $cf9e16b76262b379$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "N0", function () { return $cf9e16b76262b379$export$29a4f05edc054374; });
$parcel$export(module.exports, "N800", function () { return $cf9e16b76262b379$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N30A", function () { return $cf9e16b76262b379$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN600", function () { return $cf9e16b76262b379$export$5368d76ae4fbbda7; });
$parcel$export(module.exports, "DN0", function () { return $cf9e16b76262b379$export$3d4f271a500072a; });
$parcel$export(module.exports, "skeleton", function () { return $cf9e16b76262b379$export$2a0674ff2eb10214; });

var $eam2o = parcelRequire("eam2o");
var $cf9e16b76262b379$export$4b84fd0e2c617bd = "#FFEBE6";
var $cf9e16b76262b379$export$b34b069eff244586 = "#FFBDAD";
var $cf9e16b76262b379$export$be802dd0d8b57f35 = "#FF8F73";
var $cf9e16b76262b379$export$60847d42f9da92a6 = "#FF7452";
var $cf9e16b76262b379$export$4a7404f376229999 = "#FF5630";
var $cf9e16b76262b379$export$2010d0fb4295b346 = "#DE350B";
var $cf9e16b76262b379$export$2837b5a1a71d5c02 = "#BF2600";
var $cf9e16b76262b379$export$8d9596b529bbb9cf = "#FFFAE6";
var $cf9e16b76262b379$export$41060a744ab0b7ae = "#FFF0B3";
var $cf9e16b76262b379$export$1cc05bbbf340e559 = "#FFE380";
var $cf9e16b76262b379$export$5aae31392d72caaa = "#FFC400";
var $cf9e16b76262b379$export$c6930421db9fa514 = "#FFAB00";
var $cf9e16b76262b379$export$59619663aa6500fb = "#FF991F";
var $cf9e16b76262b379$export$874739ea9e379ab6 = "#FF8B00";
var $cf9e16b76262b379$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $cf9e16b76262b379$export$69a3bf21b9686c2b = "#ABF5D1";
var $cf9e16b76262b379$export$afbce1382ec95f73 = "#79F2C0";
var $cf9e16b76262b379$export$747d86715d4175de = "#57D9A3";
var $cf9e16b76262b379$export$940e1f69e873f202 = "#36B37E";
var $cf9e16b76262b379$export$a49394138f7b8e85 = "#00875A";
var $cf9e16b76262b379$export$6fa04827ac68a4fb = "#006644";
var $cf9e16b76262b379$export$226de0355ed012f8 = "#DEEBFF";
var $cf9e16b76262b379$export$8c13c2ee36917869 = "#B3D4FF";
var $cf9e16b76262b379$export$ecfc1dff386a3e7a = "#4C9AFF";
var $cf9e16b76262b379$export$215b7063051591f1 = "#2684FF";
var $cf9e16b76262b379$export$e62e8919cca44969 = "#0065FF";
var $cf9e16b76262b379$export$b3de0ae08da2ce64 = "#0052CC";
var $cf9e16b76262b379$export$a6ee3d71bc067634 = "#0747A6";
var $cf9e16b76262b379$export$363e4475840015bb = "#EAE6FF";
var $cf9e16b76262b379$export$4b0a4417ed59760f = "#C0B6F2";
var $cf9e16b76262b379$export$6011520a64d9a187 = "#998DD9";
var $cf9e16b76262b379$export$a7175d4e9206bc80 = "#8777D9";
var $cf9e16b76262b379$export$b48405b95304b5a1 = "#6554C0";
var $cf9e16b76262b379$export$c71e4279dd54a18d = "#5243AA";
var $cf9e16b76262b379$export$147899de772240ec = "#403294";
var $cf9e16b76262b379$export$2cf711fe14c66f06 = "#E6FCFF";
var $cf9e16b76262b379$export$7a8f4d33f6f9772c = "#B3F5FF";
var $cf9e16b76262b379$export$776c9c497ef08533 = "#79E2F2";
var $cf9e16b76262b379$export$69cb3ca10c1e330e = "#00C7E6";
var $cf9e16b76262b379$export$9dc1ef0f3f48059b = "#00B8D9";
var $cf9e16b76262b379$export$7c835c78b6fcdef8 = "#00A3BF";
var $cf9e16b76262b379$export$6036577f95c3877e = "#008DA6";
var $cf9e16b76262b379$export$29a4f05edc054374 = "#FFFFFF";
var $cf9e16b76262b379$export$e655ef011c4aa1a2 = "#FAFBFC";
var $cf9e16b76262b379$export$9fdfb749e33cdf97 = "#F4F5F7";
var $cf9e16b76262b379$export$3e51e8f1440314ba = "#EBECF0";
var $cf9e16b76262b379$export$1ce2d1575d444ceb = "#DFE1E6";
var $cf9e16b76262b379$export$8754fc7e6d8b3000 = "#C1C7D0";
var $cf9e16b76262b379$export$c2e91cbeada39b8b = "#B3BAC5";
var $cf9e16b76262b379$export$5f71e19f3a7ad9de = "#A5ADBA";
var $cf9e16b76262b379$export$eaa8c8a70ac22806 = "#97A0AF";
var $cf9e16b76262b379$export$7c87d337fb91a97d = "#8993A4";
var $cf9e16b76262b379$export$d6447c357493214f = "#7A869A";
var $cf9e16b76262b379$export$f563ee71e9ee74cd = "#6B778C";
var $cf9e16b76262b379$export$e2ef2124cf4024b1 = "#5E6C84";
var $cf9e16b76262b379$export$eece5f492e429f08 = "#505F79";
var $cf9e16b76262b379$export$c39c0fe0f26207ae = "#42526E";
var $cf9e16b76262b379$export$7090862dc3038a9f = "#344563";
var $cf9e16b76262b379$export$ad0bacf983b7ddaa = "#253858";
var $cf9e16b76262b379$export$7d61b15e0da132af = "#172B4D";
var $cf9e16b76262b379$export$fbda843f0a27fe96 = "#091E42";
var $cf9e16b76262b379$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $cf9e16b76262b379$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $cf9e16b76262b379$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $cf9e16b76262b379$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $cf9e16b76262b379$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $cf9e16b76262b379$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $cf9e16b76262b379$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $cf9e16b76262b379$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $cf9e16b76262b379$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $cf9e16b76262b379$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $cf9e16b76262b379$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $cf9e16b76262b379$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $cf9e16b76262b379$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $cf9e16b76262b379$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $cf9e16b76262b379$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $cf9e16b76262b379$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $cf9e16b76262b379$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $cf9e16b76262b379$export$2f6319cf7d736c2a = "#E6EDFA";
var $cf9e16b76262b379$export$95126bc8884d6634 = "#DCE5F5";
var $cf9e16b76262b379$export$8338d8c35d44ff1 = "#CED9EB";
var $cf9e16b76262b379$export$5368d76ae4fbbda7 = "#B8C7E0";
var $cf9e16b76262b379$export$9f0a771d16ec8d36 = "#ABBBD6";
var $cf9e16b76262b379$export$abcf8c38338b4aa5 = "#9FB0CC";
var $cf9e16b76262b379$export$97e81faa16a182c7 = "#8C9CB8";
var $cf9e16b76262b379$export$bfe21c59123ecf33 = "#7988A3";
var $cf9e16b76262b379$export$ee82aa2ea6a1558 = "#67758F";
var $cf9e16b76262b379$export$682927c6ed76be02 = "#56637A";
var $cf9e16b76262b379$export$91fd9994c5be9757 = "#455166";
var $cf9e16b76262b379$export$d281fbfe3cff2df6 = "#3B475C";
var $cf9e16b76262b379$export$3902c91d8b98a753 = "#313D52";
var $cf9e16b76262b379$export$8e8133c1ba5845b5 = "#283447";
var $cf9e16b76262b379$export$33ff357f6620b39 = "#202B3D";
var $cf9e16b76262b379$export$633847cf062b69e0 = "#1B2638";
var $cf9e16b76262b379$export$9776a6e503bdbf76 = "#121A29";
var $cf9e16b76262b379$export$6c813d5160dff5db = "#0E1624";
var $cf9e16b76262b379$export$3d4f271a500072a = "#0D1424";
var $cf9e16b76262b379$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $cf9e16b76262b379$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $cf9e16b76262b379$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $cf9e16b76262b379$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $cf9e16b76262b379$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $cf9e16b76262b379$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $cf9e16b76262b379$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $cf9e16b76262b379$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $cf9e16b76262b379$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $cf9e16b76262b379$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $cf9e16b76262b379$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $cf9e16b76262b379$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $cf9e16b76262b379$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $cf9e16b76262b379$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $cf9e16b76262b379$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $cf9e16b76262b379$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $cf9e16b76262b379$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $cf9e16b76262b379$export$8ce1fd94bee2f412 = (0, $eam2o.default)({
    light: $cf9e16b76262b379$export$29a4f05edc054374,
    dark: $cf9e16b76262b379$export$633847cf062b69e0
});
var $cf9e16b76262b379$export$b861914ea877b580 = (0, $eam2o.default)({
    light: $cf9e16b76262b379$export$226de0355ed012f8,
    dark: $cf9e16b76262b379$export$8c13c2ee36917869
});
var $cf9e16b76262b379$export$3f1b020df94387af = (0, $eam2o.default)({
    light: $cf9e16b76262b379$export$3e51e8f1440314ba,
    dark: $cf9e16b76262b379$export$d281fbfe3cff2df6
});
var $cf9e16b76262b379$export$c0183dbab98ca63e = (0, $eam2o.default)({
    light: $cf9e16b76262b379$export$29a4f05edc054374,
    dark: $cf9e16b76262b379$export$8e8133c1ba5845b5
});
var $cf9e16b76262b379$export$6f093cfa640b7166 = (0, $eam2o.default)({
    light: $cf9e16b76262b379$export$fbda843f0a27fe96,
    dark: $cf9e16b76262b379$export$5368d76ae4fbbda7
});
var $cf9e16b76262b379$export$42f8e9c698766e7a = (0, $eam2o.default)({
    light: $cf9e16b76262b379$export$7d61b15e0da132af,
    dark: $cf9e16b76262b379$export$5368d76ae4fbbda7
});
var $cf9e16b76262b379$export$c2d157ca1c34b6e3 = (0, $eam2o.default)({
    light: $cf9e16b76262b379$export$b3de0ae08da2ce64,
    dark: $cf9e16b76262b379$export$b3de0ae08da2ce64
});
var $cf9e16b76262b379$export$1905ba28d7cf066f = (0, $eam2o.default)({
    light: $cf9e16b76262b379$export$f563ee71e9ee74cd,
    dark: $cf9e16b76262b379$export$97e81faa16a182c7
});
var $cf9e16b76262b379$export$bd9002130d306d39 = (0, $eam2o.default)({
    light: $cf9e16b76262b379$export$d6447c357493214f,
    dark: $cf9e16b76262b379$export$bfe21c59123ecf33
});
var $cf9e16b76262b379$export$46e4a324ac90507f = (0, $eam2o.default)({
    light: $cf9e16b76262b379$export$7d61b15e0da132af,
    dark: $cf9e16b76262b379$export$5368d76ae4fbbda7
});
var $cf9e16b76262b379$export$79f3f2b82beb0d36 = (0, $eam2o.default)({
    light: $cf9e16b76262b379$export$f563ee71e9ee74cd,
    dark: $cf9e16b76262b379$export$97e81faa16a182c7
});
var $cf9e16b76262b379$export$7bb0d5c671655cc4 = (0, $eam2o.default)({
    light: $cf9e16b76262b379$export$9fdfb749e33cdf97,
    dark: $cf9e16b76262b379$export$8e8133c1ba5845b5
});
var $cf9e16b76262b379$export$9c30223ca0a664fb = (0, $eam2o.default)({
    light: $cf9e16b76262b379$export$b3de0ae08da2ce64,
    dark: $cf9e16b76262b379$export$ecfc1dff386a3e7a
});
var $cf9e16b76262b379$export$7ed258b0728b004b = (0, $eam2o.default)({
    light: $cf9e16b76262b379$export$e62e8919cca44969,
    dark: $cf9e16b76262b379$export$215b7063051591f1
});
var $cf9e16b76262b379$export$dfa920d8decc8a59 = (0, $eam2o.default)({
    light: $cf9e16b76262b379$export$a6ee3d71bc067634,
    dark: $cf9e16b76262b379$export$ecfc1dff386a3e7a
});
var $cf9e16b76262b379$export$6069e6ad5c78f632 = (0, $eam2o.default)({
    light: $cf9e16b76262b379$export$ecfc1dff386a3e7a,
    dark: $cf9e16b76262b379$export$215b7063051591f1
});
var $cf9e16b76262b379$export$9ad721cf3b3debe0 = (0, $eam2o.default)({
    light: $cf9e16b76262b379$export$b3de0ae08da2ce64,
    dark: $cf9e16b76262b379$export$ecfc1dff386a3e7a
});
var $cf9e16b76262b379$export$2aa0182783e7e9de = (0, $eam2o.default)({
    light: $cf9e16b76262b379$export$b3de0ae08da2ce64,
    dark: $cf9e16b76262b379$export$ecfc1dff386a3e7a
});
var $cf9e16b76262b379$export$8bf7dff220b82b4a = (0, $eam2o.default)({
    light: $cf9e16b76262b379$export$9dc1ef0f3f48059b,
    dark: $cf9e16b76262b379$export$69cb3ca10c1e330e
});
var $cf9e16b76262b379$export$e13cce2a2d16a9d4 = (0, $eam2o.default)({
    light: $cf9e16b76262b379$export$b48405b95304b5a1,
    dark: $cf9e16b76262b379$export$6011520a64d9a187
});
var $cf9e16b76262b379$export$a90204d1394caf30 = (0, $eam2o.default)({
    light: $cf9e16b76262b379$export$4a7404f376229999,
    dark: $cf9e16b76262b379$export$4a7404f376229999
});
var $cf9e16b76262b379$export$594c5a8758200c32 = (0, $eam2o.default)({
    light: $cf9e16b76262b379$export$c6930421db9fa514,
    dark: $cf9e16b76262b379$export$c6930421db9fa514
});
var $cf9e16b76262b379$export$955a2ebd2fb142ae = (0, $eam2o.default)({
    light: $cf9e16b76262b379$export$940e1f69e873f202,
    dark: $cf9e16b76262b379$export$940e1f69e873f202
});
var $cf9e16b76262b379$export$2a0674ff2eb10214 = function() {
    return $cf9e16b76262b379$export$8d43898f60b96a82;
};

});
parcelRegister("eam2o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a503181434084d72$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $9de3w = parcelRequire("9de3w");
// Unpack custom variants, and get correct value for the current theme
function $a503181434084d72$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $9de3w.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $a503181434084d72$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $a503181434084d72$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $9de3w.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("9de3w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b503b244e317326$export$2e2bcd8739ae039; });
// ideally this would be fetched from ../constants but that causes a
// circular dep loop. This will be refactored as part of a breaking
// change in the future.
var $6b503b244e317326$var$DEFAULT_THEME_MODE = "light";
var $6b503b244e317326$var$THEME_MODES = [
    "light",
    "dark"
];
function $6b503b244e317326$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ("__ATLASKIT_THEME__" in props.theme) return props.theme.__ATLASKIT_THEME__;
        else if ("mode" in props.theme && $6b503b244e317326$var$THEME_MODES.includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: $6b503b244e317326$var$DEFAULT_THEME_MODE
    };
}

});




parcelRegister("k9KMZ", function(module, exports) {

$parcel$export(module.exports, "Tooltip", function () { return $eac8f140c16676b7$export$28c660c63b792dea; });

var $4KY13 = parcelRequire("4KY13");

var $13MK1 = parcelRequire("13MK1");

var $hP8SH = parcelRequire("hP8SH");

var $eam2o = parcelRequire("eam2o");

var $dwTAS = parcelRequire("dwTAS");
var $eac8f140c16676b7$var$backgroundColor = (0, $eam2o.default)({
    light: (0, $hP8SH.N800),
    dark: (0, $hP8SH.DN0)
});
var $eac8f140c16676b7$var$textColor = (0, $eam2o.default)({
    light: (0, $hP8SH.N0),
    dark: (0, $hP8SH.DN600)
});
var $eac8f140c16676b7$export$7aa271ff2f1f5646 = (0, $13MK1.default).div($eac8f140c16676b7$var$templateObject_1 || ($eac8f140c16676b7$var$templateObject_1 = (0, $4KY13.__makeTemplateObject)([
    "\n  z-index: ",
    ";\n  pointer-events: none;\n  position: fixed;\n"
], [
    "\n  z-index: ",
    ";\n  pointer-events: none;\n  position: fixed;\n"
])), (0, $dwTAS.layers).tooltip);
var $eac8f140c16676b7$export$28c660c63b792dea = (0, $13MK1.default)($eac8f140c16676b7$export$7aa271ff2f1f5646)($eac8f140c16676b7$var$templateObject_2 || ($eac8f140c16676b7$var$templateObject_2 = (0, $4KY13.__makeTemplateObject)([
    "\n  background-color: ",
    ";\n  border-radius: ",
    "px;\n  box-sizing: border-box;\n  color: ",
    ";\n  font-size: 12px;\n  left: 0;\n  line-height: 1.3;\n  max-width: 240px;\n  padding: 2px 6px;\n  top: 0;\n  /* Edge does not support overflow-wrap */\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n\n  ",
    "\n"
], [
    "\n  background-color: ",
    ";\n  border-radius: ",
    "px;\n  box-sizing: border-box;\n  color: ",
    ";\n  font-size: 12px;\n  left: 0;\n  line-height: 1.3;\n  max-width: 240px;\n  padding: 2px 6px;\n  top: 0;\n  /* Edge does not support overflow-wrap */\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n\n  ",
    "\n"
])), $eac8f140c16676b7$var$backgroundColor, (0, $dwTAS.borderRadius), $eac8f140c16676b7$var$textColor, function(_a) {
    var truncate = _a.truncate;
    return truncate && "\n      max-width: 420px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    ";
});
var $eac8f140c16676b7$export$a51f2b8e6ae258ea = (0, $13MK1.default).div($eac8f140c16676b7$var$templateObject_3 || ($eac8f140c16676b7$var$templateObject_3 = (0, $4KY13.__makeTemplateObject)([
    "\n  display: inline-block;\n"
], [
    "\n  display: inline-block;\n"
])));
var $eac8f140c16676b7$var$templateObject_1, $eac8f140c16676b7$var$templateObject_2, $eac8f140c16676b7$var$templateObject_3;

});

parcelRegister("1NwBY", function(module, exports) {
module.exports = JSON.parse('{"name":"@atlaskit/tooltip","version":"16.0.4","sideEffects":false}');

});

parcelRegister("ial0q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d39974848f096750$export$2e2bcd8739ae039; });

var $4KY13 = parcelRequire("4KY13");

var $9nHZC = parcelRequire("9nHZC");

var $3Jogu = parcelRequire("3Jogu");
var $d39974848f096750$var$ENTER_DURATION = 120;
var $d39974848f096750$var$EXIT_DURATION = 80;
var $d39974848f096750$var$easing = "cubic-bezier(0.23, 1, 0.32, 1)"; // easeOutQuint
var $d39974848f096750$var$defaultStyle = function(timeout) {
    return {
        transition: "transform " + timeout.enter + "ms " + $d39974848f096750$var$easing + ", opacity " + timeout.enter + "ms linear",
        opacity: 0
    };
};
var $d39974848f096750$var$transitionStyle = function(state) {
    var transitions = {
        entering: {},
        entered: {
            opacity: 1
        },
        exiting: {
            opacity: 0
        }
    };
    return transitions[state];
};
var $d39974848f096750$var$getStyle = function(timeout, state) {
    return function() {
        return (0, $4KY13.__assign)((0, $4KY13.__assign)({}, $d39974848f096750$var$defaultStyle(timeout)), $d39974848f096750$var$transitionStyle(state));
    };
};
var $d39974848f096750$var$Animation = function(_a) {
    var children = _a.children, immediatelyHide = _a.immediatelyHide, immediatelyShow = _a.immediatelyShow, onExited = _a.onExited, inProp = _a.in;
    var timeout = {
        enter: immediatelyShow ? 0 : $d39974848f096750$var$ENTER_DURATION,
        exit: immediatelyHide ? 0 : $d39974848f096750$var$EXIT_DURATION
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3Jogu.default), {
        timeout: timeout,
        in: inProp,
        onExited: onExited,
        unmountOnExit: true,
        appear: true
    }, function(state) {
        return children($d39974848f096750$var$getStyle(timeout, state));
    });
};
var $d39974848f096750$export$2e2bcd8739ae039 = $d39974848f096750$var$Animation;

});

parcelRegister("fP2Al", function(module, exports) {

$parcel$export(module.exports, "hoveredPayload", function () { return $b84d9fcadaee7858$export$ca3cbe1c4b36b888; });
$parcel$export(module.exports, "unhoveredPayload", function () { return $b84d9fcadaee7858$export$60aeadc0155a40c3; });

var $1NwBY = parcelRequire("1NwBY");
var $b84d9fcadaee7858$export$ca3cbe1c4b36b888 = {
    action: "displayed",
    actionSubject: "tooltip",
    attributes: {
        componentName: "tooltip",
        packageName: (0, $1NwBY.name),
        packageVersion: (0, $1NwBY.version)
    }
};
var $b84d9fcadaee7858$export$60aeadc0155a40c3 = {
    action: "hidden",
    actionSubject: "tooltip",
    attributes: {
        componentName: "tooltip",
        packageName: (0, $1NwBY.name),
        packageVersion: (0, $1NwBY.version)
    }
};

});


parcelRegister("i2BCF", function(module, exports) {

$parcel$export(module.exports, "Anchor", function () { return $d22598fee53b5473$export$b688253958b8dfe7; });
$parcel$export(module.exports, "Span", function () { return $d22598fee53b5473$export$5f1714a13ed34c01; });
$parcel$export(module.exports, "InputWrapper", function () { return $d22598fee53b5473$export$fb9f58ebe9de6283; });
$parcel$export(module.exports, "Before", function () { return $d22598fee53b5473$export$22cfc08db27bf1de; });
$parcel$export(module.exports, "After", function () { return $d22598fee53b5473$export$aad7b411ef70196e; });
$parcel$export(module.exports, "ContentWrapper", function () { return $d22598fee53b5473$export$6ce170286acaa8d3; });
$parcel$export(module.exports, "Content", function () { return $d22598fee53b5473$export$7c6e2c02157bb7d2; });
$parcel$export(module.exports, "Description", function () { return $d22598fee53b5473$export$393edc798c47379d; });

var $13MK1 = parcelRequire("13MK1");

var $6qb7n = parcelRequire("6qb7n");

var $kRQKu = parcelRequire("kRQKu");

var $eNY11 = parcelRequire("eNY11");

var $dM68a = parcelRequire("dM68a");
var $d22598fee53b5473$var$activeBackgroundColor = (0, $kRQKu.default)({
    light: $6qb7n.B75,
    dark: $6qb7n.DN30
});
var $d22598fee53b5473$var$hoverBackgroundColor = (0, $kRQKu.default)({
    light: $6qb7n.N20,
    dark: $6qb7n.DN60
});
var $d22598fee53b5473$var$selectedBackgroundColor = (0, $kRQKu.default)({
    light: $6qb7n.N0,
    dark: $6qb7n.DN30
});
var $d22598fee53b5473$var$activePrimaryTextColor = (0, $kRQKu.default)({
    light: $6qb7n.N800,
    dark: $6qb7n.DN300
});
var $d22598fee53b5473$var$defaultPrimaryTextColor = (0, $kRQKu.default)({
    light: $6qb7n.N800,
    dark: $6qb7n.DN600
});
var $d22598fee53b5473$var$disabledPrimaryTextColor = (0, $kRQKu.default)({
    light: $6qb7n.N70,
    dark: $6qb7n.DN70
});
var $d22598fee53b5473$var$primaryPrimaryTextColor = (0, $kRQKu.default)({
    light: $6qb7n.B400,
    dark: $6qb7n.B400
});
var $d22598fee53b5473$var$selectedPrimaryTextColor = (0, $kRQKu.default)({
    light: $6qb7n.N800,
    dark: $6qb7n.N800
});
var $d22598fee53b5473$var$focusedStyles = (0, $13MK1.css)([
    "\n  box-shadow: 0 0 0 2px ",
    "\n    inset;\n  outline: none;\n  outline-offset: 0;\n  position: relative; /* prevents bgcolor of a hovered element from obfuscating focus ring of a focused sibling element */\n"
], (0, $kRQKu.default)({
    light: $6qb7n.B100,
    dark: $6qb7n.B75
}));
var $d22598fee53b5473$var$activeStyles = (0, $13MK1.css)([
    "\n  &,\n  &:hover {\n    background-color: ",
    ";\n    color: ",
    ";\n  }\n"
], $d22598fee53b5473$var$selectedBackgroundColor, $d22598fee53b5473$var$selectedPrimaryTextColor);
var $d22598fee53b5473$var$primaryStyles = (0, $13MK1.css)([
    "\n  color: ",
    ";\n"
], $d22598fee53b5473$var$primaryPrimaryTextColor);
var $d22598fee53b5473$var$sharedStyles = function sharedStyles(props) {
    return (0, $13MK1.css)([
        "\n  align-items: center;\n  box-sizing: border-box;\n  color: ",
        ";\n  cursor: ",
        ";\n  display: ",
        ";\n  flex-wrap: nowrap;\n  font-size: ",
        "px;\n  font-weight: normal;\n  padding: 0 ",
        "px;\n  text-decoration: none;\n\n  &:hover {\n    background-color: ",
        ";\n    color: ",
        ";\n    text-decoration: none;\n\n    ",
        ";\n  }\n  &:active {\n    background-color: ",
        ";\n    color: ",
        ";\n\n    ",
        ";\n  }\n  &:focus {\n    ",
        ";\n  }\n\n  ",
        " ",
        " ",
        ";\n"
    ], props.isDisabled ? $d22598fee53b5473$var$disabledPrimaryTextColor : $d22598fee53b5473$var$defaultPrimaryTextColor, props.isDisabled ? "not-allowed" : "pointer", props.isHidden ? "none" : "flex", (0, $eNY11.fontSize), (0, $dM68a.multiply)((0, $eNY11.gridSize), 1.5), !props.isDisabled && $d22598fee53b5473$var$hoverBackgroundColor, props.isDisabled ? $d22598fee53b5473$var$disabledPrimaryTextColor : $d22598fee53b5473$var$defaultPrimaryTextColor, props.isPrimary && $d22598fee53b5473$var$primaryStyles, !props.isDisabled && $d22598fee53b5473$var$activeBackgroundColor, !props.isDisabled && $d22598fee53b5473$var$activePrimaryTextColor, props.isPrimary && $d22598fee53b5473$var$primaryStyles, $d22598fee53b5473$var$focusedStyles, props.isFocused && $d22598fee53b5473$var$focusedStyles, props.isActive && $d22598fee53b5473$var$activeStyles, props.isPrimary && $d22598fee53b5473$var$primaryStyles);
};
var $d22598fee53b5473$export$b688253958b8dfe7 = (0, $13MK1.default).a.withConfig({
    displayName: "Item__Anchor",
    componentId: "aiqnor-0"
})([
    "\n  ",
    ";\n"
], function(props) {
    return $d22598fee53b5473$var$sharedStyles(props);
});
var $d22598fee53b5473$export$5f1714a13ed34c01 = (0, $13MK1.default).span.withConfig({
    displayName: "Item__Span",
    componentId: "aiqnor-1"
})([
    "\n  ",
    ";\n"
], function(props) {
    return $d22598fee53b5473$var$sharedStyles(props);
}); // Checkbox/Radio wrapper -- sits left of the children
var $d22598fee53b5473$export$fb9f58ebe9de6283 = (0, $13MK1.default).span.withConfig({
    displayName: "Item__InputWrapper",
    componentId: "aiqnor-2"
})([
    "\n  display: flex;\n  margin: 0 2px;\n"
]); // Elements injected before/after the children
var $d22598fee53b5473$export$22cfc08db27bf1de = (0, $13MK1.default).span.withConfig({
    displayName: "Item__Before",
    componentId: "aiqnor-3"
})([
    "\n  display: flex;\n"
]);
var $d22598fee53b5473$export$aad7b411ef70196e = (0, $13MK1.default).span.withConfig({
    displayName: "Item__After",
    componentId: "aiqnor-4"
})([
    "\n  align-items: center;\n  display: flex;\n"
]); // Alignment and layout for the children
var $d22598fee53b5473$export$6ce170286acaa8d3 = (0, $13MK1.default).span.withConfig({
    displayName: "Item__ContentWrapper",
    componentId: "aiqnor-5"
})([
    "\n  display: flex;\n  flex-direction: column;\n  margin: 0 ",
    "px;\n  padding: ",
    "px 0;\n  overflow: hidden;\n\n  &:first-child {\n    margin: 0;\n  }\n"
], (0, $eNY11.gridSize), (0, $eNY11.gridSize));
var $d22598fee53b5473$export$7c6e2c02157bb7d2 = (0, $13MK1.default).span.withConfig({
    displayName: "Item__Content",
    componentId: "aiqnor-6"
})([
    "\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  ",
    ";\n"
], function(props) {
    return props.allowMultiline && (0, $13MK1.css)([
        "\n      white-space: normal;\n    "
    ]);
}); // Description is a block element below the children, like a subtitle
var $d22598fee53b5473$export$393edc798c47379d = (0, $13MK1.default).span.withConfig({
    displayName: "Item__Description",
    componentId: "aiqnor-7"
})([
    "\n  color: ",
    ";\n  flex: 1 1 auto;\n  font-size: 12px;\n  line-height: 16 / 12;\n  margin-top: ",
    "px;\n"
], $6qb7n.subtleText, (0, $dM68a.divide)((0, $eNY11.gridSize), 2)); // NOTE: Exposed as a named export for this package
var $d22598fee53b5473$export$2f7dd73b133adfb7 = (0, $13MK1.default).span.withConfig({
    displayName: "Item__SecondaryText",
    componentId: "aiqnor-8"
})([
    "\n  color: ",
    ";\n"
], $6qb7n.subtleText);

});

parcelRegister("7Vui1", function(module, exports) {

$parcel$export(module.exports, "getInputBackground", function () { return $5c555a2f95f90237$export$c2f30c53cafe7abf; });
$parcel$export(module.exports, "getInputFill", function () { return $5c555a2f95f90237$export$7900f0dacdf6083e; });

var $6qb7n = parcelRequire("6qb7n");
function $5c555a2f95f90237$export$c2f30c53cafe7abf(_ref) {
    var isChecked = _ref.isChecked, isDisabled = _ref.isDisabled, isHovered = _ref.isHovered, isPressed = _ref.isPressed;
    var background = $6qb7n.N40;
    if (isHovered) background = $6qb7n.N50;
    if (isPressed) background = $6qb7n.B200;
    if (isChecked) background = $6qb7n.B400;
    if (isDisabled) background = $6qb7n.N20;
    if (isChecked && isDisabled) background = $6qb7n.N600;
    return background;
}
function $5c555a2f95f90237$export$7900f0dacdf6083e(appearanceProps) {
    return appearanceProps.isChecked ? $6qb7n.N0 : "transparent";
}

});

parcelRegister("djmeL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b0e4c88cce6b8ca$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $gQ7Yy = parcelRequire("gQ7Yy");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $i2BCF = parcelRequire("i2BCF");
var $9b0e4c88cce6b8ca$export$e4d62e05ba7dd6c0 = function supportsVoiceOver() {
    return /Mac OS X/.test(navigator.userAgent);
};
var $9b0e4c88cce6b8ca$export$e8d5ef18492f0c2d = function getAriaRoles() {
    return {
        checkbox: $9b0e4c88cce6b8ca$export$e4d62e05ba7dd6c0() ? "checkbox" : "menuitemcheckbox",
        link: "menuitem",
        option: "option",
        radio: $9b0e4c88cce6b8ca$export$e4d62e05ba7dd6c0() ? "radio" : "menuitemradio"
    };
};
var $9b0e4c88cce6b8ca$export$f7197c7be79d3e25 = {
    default: "link",
    values: [
        "link",
        "radio",
        "checkbox",
        "option"
    ]
};
var $9b0e4c88cce6b8ca$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_PureComponent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(Element, _PureComponent);
    function Element() {
        var _getPrototypeOf2;
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, Element);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, (_getPrototypeOf2 = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Element)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleMouseDown", function(e) {
            e.preventDefault();
            _this.props.handleMouseDown();
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(Element, [
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var isActive = props.isActive, isChecked = props.isChecked, isDisabled = props.isDisabled, isFocused = props.isFocused, isHidden = props.isHidden, isSelected = props.isSelected, isPrimary = props.isPrimary;
                var type = this.props.type || "";
                var appearanceProps = {
                    isActive: isActive,
                    isChecked: isChecked,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isHidden: isHidden,
                    isSelected: isSelected,
                    isPrimary: isPrimary
                };
                var ariaProps = {
                    "aria-checked": !!isChecked,
                    "aria-disabled": !!isDisabled,
                    "aria-hidden": !!isHidden,
                    "aria-selected": !!isSelected
                };
                var ariaRoles = $9b0e4c88cce6b8ca$export$e8d5ef18492f0c2d();
                var commonProps = {
                    "data-role": "droplistItem",
                    onClick: props.handleClick,
                    onKeyPress: props.handleKeyPress,
                    onMouseDown: this.handleMouseDown,
                    onMouseOut: props.handleMouseOut,
                    onMouseOver: props.handleMouseOver,
                    onMouseUp: props.handleMouseUp,
                    role: ariaRoles[type],
                    title: props.title,
                    tabIndex: props.type === "option" ? null : 0
                };
                var testingProps = {};
                var consolidatedProps = (0, (/*@__PURE__*/$parcel$interopDefault($gQ7Yy)))({}, appearanceProps, ariaProps, commonProps, testingProps);
                if (props.href && !isDisabled) return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $i2BCF.Anchor), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                    href: props.href,
                    target: props.target
                }, consolidatedProps), props.children);
                return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $i2BCF.Span), consolidatedProps, props.children);
            }
        }
    ]);
    return Element;
}((0, $9nHZC.PureComponent));

});


parcelRegister("22itD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17ba19cea0551f8e$var$_react = $17ba19cea0551f8e$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $d20pL = parcelRequire("d20pL");
function $17ba19cea0551f8e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $17ba19cea0551f8e$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $17ba19cea0551f8e$var$_react.default.createElement($d20pL.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M8.292 10.293a1.009 1.009 0 000 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 000-1.419.987.987 0 00-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 00-1.406 0z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$17ba19cea0551f8e$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $17ba19cea0551f8e$var$_default = $17ba19cea0551f8e$var$ChevronDownIcon;
module.exports.default = $17ba19cea0551f8e$var$_default;

});
parcelRegister("d20pL", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $97cbc899638fd77b$export$f04a61298a47a40f; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $941gy = parcelRequire("941gy");

var $7yGiG = parcelRequire("7yGiG");

var $7BobP = parcelRequire("7BobP");
function $97cbc899638fd77b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $97cbc899638fd77b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $97cbc899638fd77b$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $97cbc899638fd77b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $97cbc899638fd77b$var$iconStyles = (0, $avKww.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "> svg": $97cbc899638fd77b$var$_objectSpread($97cbc899638fd77b$var$_objectSpread({}, (0, $7BobP.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $97cbc899638fd77b$var$baseHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $97cbc899638fd77b$var$primaryEqualsSecondaryHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $97cbc899638fd77b$var$secondaryTransparentHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $97cbc899638fd77b$export$f04a61298a47a40f = /*#__PURE__*/ (0, $9nHZC.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $avKww.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $7BobP.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    var _useGlobalTheme = (0, $941gy.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $avKww.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            "--icon-secondary-color": secondaryColor || (0, $7yGiG.getBackground)(mode)
        }
    }, glyphProps, {
        css: [
            $97cbc899638fd77b$var$iconStyles,
            $97cbc899638fd77b$var$baseHcmStyles,
            primaryColor === secondaryColor && $97cbc899638fd77b$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $97cbc899638fd77b$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsualting them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $avKww.css)({
                width: dimensions.width,
                height: dimensions.height,
                "> svg": dimensions
            })
        ]
    }));
});
var $97cbc899638fd77b$export$2e2bcd8739ae039 = $97cbc899638fd77b$export$f04a61298a47a40f;

});
parcelRegister("941gy", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", function () { return $6995782eee6cd6f5$export$7692396083754928; });

var $isr2M = parcelRequire("isr2M");
// Create default global light theme
var $6995782eee6cd6f5$var$_createTheme = (0, $isr2M.createTheme)(function() {
    return {
        mode: "light"
    };
}), $6995782eee6cd6f5$var$Provider = $6995782eee6cd6f5$var$_createTheme.Provider, $6995782eee6cd6f5$var$Consumer = $6995782eee6cd6f5$var$_createTheme.Consumer, $6995782eee6cd6f5$export$7692396083754928 = $6995782eee6cd6f5$var$_createTheme.useTheme;
var $6995782eee6cd6f5$var$Theme = {
    Provider: $6995782eee6cd6f5$var$Provider,
    Consumer: $6995782eee6cd6f5$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6995782eee6cd6f5$export$2e2bcd8739ae039 = $6995782eee6cd6f5$var$Theme;

});
parcelRegister("isr2M", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $d6ffd1dfe3b88985$export$25d302a5b900a763; });

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");
var $d6ffd1dfe3b88985$var$_excluded = [
    "children"
];
function $d6ffd1dfe3b88985$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $9nHZC.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $9nHZC.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(props, $d6ffd1dfe3b88985$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $9nHZC.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $9nHZC.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("7yGiG", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $580c85537f9a36d3$export$18cb9425622d4e06; });
var $580c85537f9a36d3$var$themedBackground = {
    light: "var(--ds-surface, #FFFFFF)",
    dark: "var(--ds-surface, #1B2638)"
};
var $580c85537f9a36d3$export$18cb9425622d4e06 = function getBackground() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "light";
    return $580c85537f9a36d3$var$themedBackground[mode];
};

});

parcelRegister("7BobP", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $588ec0b533494de1$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $588ec0b533494de1$export$3eb7d6130acfda37; });

var $u5eOW = parcelRequire("u5eOW");

var $avKww = parcelRequire("avKww");
var $588ec0b533494de1$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
var $588ec0b533494de1$var$smallStyles = (0, $avKww.css)((0, $u5eOW.dimensions).small);
var $588ec0b533494de1$var$mediumStyles = (0, $avKww.css)((0, $u5eOW.dimensions).medium);
var $588ec0b533494de1$var$largeStyles = (0, $avKww.css)((0, $u5eOW.dimensions).large);
var $588ec0b533494de1$var$xlargeStyles = (0, $avKww.css)((0, $u5eOW.dimensions).xlarge);
var $588ec0b533494de1$export$ef0ad74202575b64 = {
    small: $588ec0b533494de1$var$smallStyles,
    medium: $588ec0b533494de1$var$mediumStyles,
    large: $588ec0b533494de1$var$largeStyles,
    xlarge: $588ec0b533494de1$var$xlargeStyles
};
var $588ec0b533494de1$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $u5eOW.dimensions)[size];
    return undefined;
};

});
parcelRegister("u5eOW", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $05a6dd9f5dc9155b$export$62ad7b0c781000e9; });
var $05a6dd9f5dc9155b$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $05a6dd9f5dc9155b$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $05a6dd9f5dc9155b$export$62ad7b0c781000e9 = {
    small: {
        width: $05a6dd9f5dc9155b$export$c647cb0ee6e282fe.small,
        height: $05a6dd9f5dc9155b$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $05a6dd9f5dc9155b$export$c647cb0ee6e282fe.medium,
        height: $05a6dd9f5dc9155b$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $05a6dd9f5dc9155b$export$c647cb0ee6e282fe.large,
        height: $05a6dd9f5dc9155b$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $05a6dd9f5dc9155b$export$c647cb0ee6e282fe.xlarge,
        height: $05a6dd9f5dc9155b$export$c647cb0ee6e282fe.xlarge
    }
};

});




parcelRegister("jN3sS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e68547efe9603b53$export$2e2bcd8739ae039; });

var $hlgjl = parcelRequire("hlgjl");

var $13MK1 = parcelRequire("13MK1");
function $e68547efe9603b53$var$_templateObject() {
    var data = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
        "\n  ",
        ";\n"
    ]);
    $e68547efe9603b53$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $e68547efe9603b53$export$2e2bcd8739ae039 = (0, $13MK1.default).div($e68547efe9603b53$var$_templateObject(), function(_ref) {
    var shouldFitContainer = _ref.shouldFitContainer;
    return shouldFitContainer ? "" : "max-width: 300px;";
});

});

parcelRegister("5HKOT", function(module, exports) {

$parcel$export(module.exports, "KEY_UP", function () { return $4275495bcae11293$export$390330c10ff2b9a1; });
$parcel$export(module.exports, "KEY_DOWN", function () { return $4275495bcae11293$export$a80636c6f41931fe; });
$parcel$export(module.exports, "KEY_SPACE", function () { return $4275495bcae11293$export$e51a3576c045c8d5; });
$parcel$export(module.exports, "KEY_ENTER", function () { return $4275495bcae11293$export$8152f929a25a0ff4; });
$parcel$export(module.exports, "KEY_TAB", function () { return $4275495bcae11293$export$10f6869ed0a7d75b; });
var $4275495bcae11293$export$390330c10ff2b9a1 = "ArrowUp";
var $4275495bcae11293$export$a80636c6f41931fe = "ArrowDown";
var $4275495bcae11293$export$e51a3576c045c8d5 = " ";
var $4275495bcae11293$export$8152f929a25a0ff4 = "Enter";
var $4275495bcae11293$export$10f6869ed0a7d75b = "Tab";
var $4275495bcae11293$export$f0fcadf25a56f096 = "Escape";

});

parcelRegister("9ntM7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d3d5bbf34436e56$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");

var $aILvF = parcelRequire("aILvF");
function $6d3d5bbf34436e56$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6d3d5bbf34436e56$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $6d3d5bbf34436e56$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $6d3d5bbf34436e56$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(DropdownItemClickManager, _Component);
    var _super = $6d3d5bbf34436e56$var$_createSuper(DropdownItemClickManager);
    function DropdownItemClickManager() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, DropdownItemClickManager);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleItemClicked", function(event) {
            _this.props.onItemClicked(event);
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(DropdownItemClickManager, [
        {
            key: "getChildContext",
            value: function getChildContext() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, (0, $aILvF.clickManagerContext), {
                    itemClicked: this.handleItemClicked
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DropdownItemClickManager;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($6d3d5bbf34436e56$export$2e2bcd8739ae039, "childContextTypes", (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, (0, $aILvF.clickManagerContext), (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).object));

});
parcelRegister("aILvF", function(module, exports) {

$parcel$export(module.exports, "focusManagerContext", function () { return $7ce2dddf95c4d56c$export$87323e074b98556d; });
$parcel$export(module.exports, "selectionCacheContext", function () { return $7ce2dddf95c4d56c$export$f4b104b2c6ac1221; });
$parcel$export(module.exports, "selectionManagerContext", function () { return $7ce2dddf95c4d56c$export$3d81059a1e042a43; });
$parcel$export(module.exports, "clickManagerContext", function () { return $7ce2dddf95c4d56c$export$2c0ea96a64772db8; });
var $7ce2dddf95c4d56c$var$prefix = function prefix(key) {
    return "@atlaskit-private-do-not-use/dropdown-menu:".concat(key);
};
var $7ce2dddf95c4d56c$export$87323e074b98556d = $7ce2dddf95c4d56c$var$prefix("focus-manager");
var $7ce2dddf95c4d56c$export$f4b104b2c6ac1221 = $7ce2dddf95c4d56c$var$prefix("selection-cache");
var $7ce2dddf95c4d56c$export$3d81059a1e042a43 = $7ce2dddf95c4d56c$var$prefix("selection-manager");
var $7ce2dddf95c4d56c$export$2c0ea96a64772db8 = $7ce2dddf95c4d56c$var$prefix("click-manager");

});


parcelRegister("7wfzX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0169abcb4302ecbf$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");

var $aILvF = parcelRequire("aILvF");

var $5HKOT = parcelRequire("5HKOT");
function $0169abcb4302ecbf$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $0169abcb4302ecbf$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $0169abcb4302ecbf$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $0169abcb4302ecbf$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(DropdownItemFocusManager, _Component);
    var _super = $0169abcb4302ecbf$var$_createSuper(DropdownItemFocusManager);
    function DropdownItemFocusManager() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, DropdownItemFocusManager);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "registeredItems", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleItemRegistered", function(itemId, itemNode) {
            _this.registeredItems.push({
                itemId: itemId,
                itemNode: itemNode
            });
            if (_this.props.autoFocus && _this.registeredItems.length === 1) {
                _this.focusedItemId = itemId;
                itemNode.focus();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleItemDeregistered", function(itemId) {
            _this.registeredItems = _this.registeredItems.filter(function(item) {
                return item.itemId !== itemId;
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleItemFocused", function(itemId) {
            _this.focusedItemId = itemId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleItemUpdated", function(itemId, itemNode) {
            var matchingIndex = -1;
            for(var i = 0; i < _this.registeredItems.length; i++)if (_this.registeredItems[i].itemId === itemId) {
                matchingIndex = i;
                break;
            }
            if (matchingIndex === -1) {
                _this.handleItemRegistered(itemId, itemNode);
                return;
            }
            _this.registeredItems[matchingIndex].itemNode = itemNode;
            if (_this.focusedItemIndex() === matchingIndex) itemNode.focus();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "focusedItemIndex", function() {
            var _assertThisInitialize = (0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), focusedItemId = _assertThisInitialize.focusedItemId, registeredItems = _assertThisInitialize.registeredItems;
            for(var i = 0; i < registeredItems.length; i++){
                if (registeredItems[i].itemId === focusedItemId) return i;
            }
            return -1;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleKeyboard", function(event) {
            var key = event.key, shiftKey = event.shiftKey;
            var focusedItemIndex = _this.focusedItemIndex();
            if (key === (0, $5HKOT.KEY_UP) || key === (0, $5HKOT.KEY_DOWN)) {
                // We prevent default here to avoid page scrolling when up/down
                // pressed while dropdown is focused.
                event.preventDefault();
                if (focusedItemIndex < 0) return;
                var nextItemIndex = key === (0, $5HKOT.KEY_UP) ? Math.max(0, focusedItemIndex - 1) : Math.min(_this.registeredItems.length - 1, focusedItemIndex + 1);
                _this.registeredItems[nextItemIndex].itemNode.focus();
            }
            if (key === (0, $5HKOT.KEY_TAB)) {
                if (!shiftKey && focusedItemIndex === _this.registeredItems.length - 1) {
                    if (_this.props.close) _this.props.close({
                        event: event,
                        source: "keydown"
                    });
                }
                if (shiftKey && focusedItemIndex === 0) {
                    if (_this.props.close) _this.props.close({
                        event: event,
                        source: "keydown"
                    });
                }
            }
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(DropdownItemFocusManager, [
        {
            key: "getChildContext",
            value: function getChildContext() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, (0, $aILvF.focusManagerContext), {
                    itemFocused: this.handleItemFocused,
                    registerItem: this.handleItemRegistered,
                    deregisterItem: this.handleItemDeregistered,
                    updateItem: this.handleItemUpdated
                });
            }
        },
        {
            key: "render",
            value: function render() {
                // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
                    onKeyDown: this.handleKeyboard
                }, this.props.children);
            }
        }
    ]);
    return DropdownItemFocusManager;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($0169abcb4302ecbf$export$2e2bcd8739ae039, "childContextTypes", (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, (0, $aILvF.focusManagerContext), (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).object));

});

parcelRegister("eaCZv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5103eaf1d263828$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $9TIxa = parcelRequire("9TIxa");

var $blCBi = parcelRequire("blCBi");

var $aILvF = parcelRequire("aILvF");
function $a5103eaf1d263828$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a5103eaf1d263828$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $a5103eaf1d263828$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $a5103eaf1d263828$var$isItemInList = function isItemInList(itemList, itemId, groupId) {
    return Boolean((0, (/*@__PURE__*/$parcel$interopDefault($9TIxa)))(itemList, function(item) {
        return item.id === itemId && item.groupId === groupId;
    }));
};
var $a5103eaf1d263828$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(DropdownItemSelectionCache, _Component);
    var _super = $a5103eaf1d263828$var$_createSuper(DropdownItemSelectionCache);
    function DropdownItemSelectionCache() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, DropdownItemSelectionCache);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "state", {
            lastCacheUpdate: 0
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "selectedItems", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "alreadyDefaultedItems", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleItemSelectionsChanged", function(groupId, newGroupSelections) {
            var newSelectedItems = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.selectedItems.filter(function(item) {
                return item.groupId !== groupId;
            })), (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(newGroupSelections));
            _this.selectedItems = newSelectedItems; // We store selectedItems in an instance variable (this.selectedItems) instead of state,
            // because if multiple children update the cache at the same time it causes unexpected
            // behaviour due to the asynchronous behaviour of setState. So we need to trigger setState
            // with a different value to cause the children to be updated with their new selection values.
            _this.setState({
                lastCacheUpdate: Date.now()
            });
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(DropdownItemSelectionCache, [
        {
            key: "getChildContext",
            // eslint-disable-line react/sort-comp
            value: function getChildContext() {
                var _this2 = this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, (0, $aILvF.selectionCacheContext), {
                    // This function returns true/false describing whether the supplied navigation item
                    // (which must have a unique item and group ID) is currently selected - this is used
                    // by radio and checkbox dropdown items to retreive their 'selected' state when they
                    // re-mount, which happens when the dropdown is closed and then re-opened.
                    isItemSelected: function isItemSelected(groupId, itemId) {
                        return $a5103eaf1d263828$var$isItemInList(_this2.selectedItems, itemId, groupId);
                    },
                    itemsInGroup: function itemsInGroup(groupId) {
                        return _this2.selectedItems.filter(function(item) {
                            return item.groupId === groupId;
                        });
                    },
                    itemSelectionsChanged: this.handleItemSelectionsChanged,
                    hasItemAlreadyHadDefaultSelectedApplied: function hasItemAlreadyHadDefaultSelectedApplied(groupId, itemId) {
                        return $a5103eaf1d263828$var$isItemInList(_this2.alreadyDefaultedItems, itemId, groupId);
                    },
                    markItemAsDefaultApplied: function markItemAsDefaultApplied(groupId, itemId) {
                        _this2.alreadyDefaultedItems.push({
                            id: itemId,
                            groupId: groupId
                        });
                    }
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", null, this.props.children);
            }
        }
    ]);
    return DropdownItemSelectionCache;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($a5103eaf1d263828$export$2e2bcd8739ae039, "childContextTypes", (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, (0, $aILvF.selectionCacheContext), (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).shape({
    isItemSelected: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
    itemsInGroup: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
    itemSelectionsChanged: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func
})));

});
parcelRegister("9TIxa", function(module, exports) {
"use strict";
function $734bcb9e6d265b54$var$find(array, predicate, context) {
    if (typeof Array.prototype.find === "function") return array.find(predicate, context);
    context = context || this;
    var length = array.length;
    var i;
    if (typeof predicate !== "function") throw new TypeError(predicate + " is not a function");
    for(i = 0; i < length; i++){
        if (predicate.call(context, array[i], i, array)) return array[i];
    }
}
module.exports = $734bcb9e6d265b54$var$find;

});




parcelRegister("c83ir", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d48ca0524812aa4$export$2e2bcd8739ae039; });

var $lLrRh = parcelRequire("lLrRh");
var $ig4CX = parcelRequire("ig4CX");
var $eqlB5 = parcelRequire("eqlB5");
var // We need to type this with the above type - currently this component is has "any" for its props.
$8d48ca0524812aa4$export$2e2bcd8739ae039 = (0, $ig4CX.default)((0, $eqlB5.default)((0, $lLrRh.default)));

});
parcelRegister("lLrRh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd8398d96ed8e094$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $01nMI = parcelRequire("01nMI");

var $lvmhy = parcelRequire("lvmhy");
var $fd8398d96ed8e094$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(Item, _Component);
    function Item(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, Item);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Item).call(this, props)); // The type of element rendered at the root of render() can vary based on the `href`
        // and `linkComponent` props provided. We generate this component here to avoid re-
        // generating the component inside render(). This is for performance reasons, and also
        // allows us to avoid generating a new `ref` for the root element each render().
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "setRef", function(ref) {
            _this.ref = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "href", function() {
            return _this.props.isDisabled ? null : _this.props.href;
        });
        _this.rootComponent = (0, $01nMI.default)({
            href: _this.href(),
            linkComponent: props.linkComponent
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(Item, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.ref && this.props.autoFocus) this.ref.focus();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, _onClick = _this$props.onClick, _onKeyDown = _this$props.onKeyDown, isCompact = _this$props.isCompact, isDisabled = _this$props.isDisabled, isDragging = _this$props.isDragging, isHidden = _this$props.isHidden, isSelected = _this$props.isSelected, onMouseEnter = _this$props.onMouseEnter, onMouseLeave = _this$props.onMouseLeave, role = _this$props.role, dnd = _this$props.dnd, otherProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_this$props, [
                    "onClick",
                    "onKeyDown",
                    "isCompact",
                    "isDisabled",
                    "isDragging",
                    "isHidden",
                    "isSelected",
                    "onMouseEnter",
                    "onMouseLeave",
                    "role",
                    "dnd"
                ]);
                var Root = this.rootComponent;
                var dragHandleProps = dnd && dnd.dragHandleProps || null;
                var patchedEventHandlers = {
                    onClick: function onClick(event) {
                        // rbd will use event.preventDefault() to block clicks that are used
                        // as a part of the drag and drop lifecycle.
                        if (event.defaultPrevented) return;
                        if (!isDisabled && _onClick) _onClick(event);
                    },
                    onMouseDown: function onMouseDown(event) {
                        // rbd 11.x support
                        if (dragHandleProps && dragHandleProps.onMouseDown) dragHandleProps.onMouseDown(event);
                         // We want to prevent the item from getting focus when clicked
                        event.preventDefault();
                    },
                    onKeyDown: function onKeyDown(event) {
                        // swallowing keyboard events on the element while dragging
                        // rbd should already be doing this - but we are being really clear here
                        if (isDragging) return;
                         // rbd 11.x support
                        if (dragHandleProps && dragHandleProps.onKeyDown) dragHandleProps.onKeyDown(event);
                         // if default is prevented - do not fire other handlers
                        // this can happen if the event is used for drag and drop by rbd
                        if (event.defaultPrevented) return;
                         // swallowing event if disabled
                        if (isDisabled) return;
                        if (!_onKeyDown) return;
                        _onKeyDown(event);
                    }
                };
                var patchedInnerRef = function patchedInnerRef(ref) {
                    _this2.setRef(ref); // give rbd the inner ref too
                    if (dnd && dnd.innerRef) dnd.innerRef(ref);
                };
                return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Root, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                    "aria-disabled": isDisabled,
                    href: this.href(),
                    isCompact: isCompact,
                    isDisabled: isDisabled,
                    isDragging: isDragging,
                    isHidden: isHidden,
                    isSelected: isSelected,
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    role: role,
                    tabIndex: isDisabled || isHidden || this.props.href ? null : 0,
                    target: this.props.target,
                    title: this.props.title,
                    innerRef: patchedInnerRef
                }, dnd && dnd.draggableProps, dragHandleProps, patchedEventHandlers, otherProps), !!this.props.elemBefore && (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $lvmhy.Before), {
                    isCompact: isCompact
                }, this.props.elemBefore), (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $lvmhy.ContentWrapper), null, (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $lvmhy.Content), {
                    allowMultiline: this.props.shouldAllowMultiline
                }, this.props.children), !!this.props.description && (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $lvmhy.Description), {
                    isCompact: this.props.isCompact,
                    isDisabled: this.props.isDisabled
                }, this.props.description)), !!this.props.elemAfter && (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $lvmhy.After), {
                    isCompact: isCompact
                }, this.props.elemAfter));
            }
        }
    ]);
    return Item;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($fd8398d96ed8e094$export$2e2bcd8739ae039, "defaultProps", {
    autoFocus: false,
    description: "",
    isCompact: false,
    isDisabled: false,
    isHidden: false,
    role: "button",
    shouldAllowMultiline: false
});

});
parcelRegister("01nMI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00428b424f2e334d$export$2e2bcd8739ae039; });

var $13MK1 = parcelRequire("13MK1");

var $dLPiE = parcelRequire("dLPiE");

var $dBRTS = parcelRequire("dBRTS");
var $00428b424f2e334d$var$getItemState = function getItemState(stateName) {
    return function(_ref) {
        var theme = _ref.theme;
        var stateStyles = (0, $dBRTS.getThemeStyle)(theme[0, $dBRTS.themeNamespace], stateName);
        return (0, $13MK1.css)([
            "\n    background-color: ",
            ";\n    color: ",
            ";\n    fill: ",
            ";\n    text-decoration: none;\n\n    &:focus {\n      color: ",
            ";\n    }\n  "
        ], stateStyles.background, stateStyles.text, stateStyles.background, stateStyles.text);
    };
};
var $00428b424f2e334d$var$getPadding = function getPadding(_ref2) {
    var isCompact = _ref2.isCompact, theme = _ref2.theme, description = _ref2.description;
    var paddingKey = isCompact ? "compact" : "default";
    var _getThemeStyle = (0, $dBRTS.getThemeStyle)(theme[0, $dBRTS.themeNamespace], paddingKey, "padding"), _getThemeStyle$bottom = _getThemeStyle.bottom, bottom = _getThemeStyle$bottom === void 0 ? 0 : _getThemeStyle$bottom, _getThemeStyle$left = _getThemeStyle.left, left = _getThemeStyle$left === void 0 ? 0 : _getThemeStyle$left, _getThemeStyle$right = _getThemeStyle.right, right = _getThemeStyle$right === void 0 ? 0 : _getThemeStyle$right, _getThemeStyle$top = _getThemeStyle.top, top = _getThemeStyle$top === void 0 ? 0 : _getThemeStyle$top;
    var adjustedTop = typeof top === "function" ? top() : top;
    var adjustedBottom = typeof bottom === "function" ? bottom() : bottom; // Subtract the 1px padding-bottom added to the content and description elements
    // to maintain original height
    adjustedTop = Math.max(description ? adjustedTop - 1 : adjustedTop, 0);
    adjustedBottom = Math.max(adjustedBottom - 1, 0);
    return (0, $13MK1.css)([
        "\n    padding: ",
        "px ",
        "px ",
        "px ",
        "px;\n  "
    ], adjustedTop, right, adjustedBottom, left);
};
var $00428b424f2e334d$var$getHeightStyles = function getHeightStyles(_ref3) {
    var isCompact = _ref3.isCompact, theme = _ref3.theme;
    var heightKey = isCompact ? "compact" : "default";
    var height = (0, $dBRTS.getThemeStyle)(theme[0, $dBRTS.themeNamespace], heightKey, "height");
    return height ? (0, $13MK1.css)([
        "\n        height: ",
        "px;\n      "
    ], height) : "";
};
var $00428b424f2e334d$var$getWidthStyles = function getWidthStyles(_ref4) {
    var isCompact = _ref4.isCompact, theme = _ref4.theme;
    var widthKey = isCompact ? "compact" : "default";
    var width = (0, $dBRTS.getThemeStyle)(theme[0, $dBRTS.themeNamespace], widthKey, "width");
    if (!width) return "";
    return typeof width === "number" ? (0, $13MK1.css)([
        "\n        width: ",
        "px;\n      "
    ], width) : (0, $13MK1.css)([
        "\n        width: ",
        ";\n      "
    ], width);
}; // This function is responsible for drawing any focus styles for the element
var $00428b424f2e334d$var$getInteractiveStyles = function getInteractiveStyles(_ref5) {
    var theme = _ref5.theme, isDisabled = _ref5.isDisabled, isDragging = _ref5.isDragging, isSelected = _ref5.isSelected;
    if (isDragging) return (0, $13MK1.css)([
        "\n      ",
        " box-shadow: 0 4px 8px -2px ",
        ",\n        0 0 1px ",
        ";\n    "
    ], $00428b424f2e334d$var$getItemState("dragging"), (0, $dLPiE.N60A), (0, $dLPiE.N60A));
    var standardFocus = (0, $13MK1.css)([
        "\n    &:focus {\n      box-shadow: 0 0 0 2px\n        ",
        " inset;\n      text-decoration: none;\n    }\n  "
    ], (0, $dBRTS.getThemeStyle)(theme[0, $dBRTS.themeNamespace], "outline", "focus"));
    if (isDisabled) return (0, $13MK1.css)([
        "\n      cursor: not-allowed;\n      ",
        " ",
        ";\n    "
    ], $00428b424f2e334d$var$getItemState("disabled"), standardFocus);
    if (isSelected) return (0, $13MK1.css)([
        "\n      ",
        " &:hover {\n        ",
        ";\n      }\n\n      &:active {\n        ",
        ";\n      }\n\n      ",
        ";\n    "
    ], $00428b424f2e334d$var$getItemState("selected"), $00428b424f2e334d$var$getItemState("hover"), $00428b424f2e334d$var$getItemState("active"), standardFocus);
    return (0, $13MK1.css)([
        "\n    &:hover {\n      ",
        ";\n    }\n\n    &:active {\n      ",
        ";\n    }\n\n    ",
        ";\n  "
    ], $00428b424f2e334d$var$getItemState("hover"), $00428b424f2e334d$var$getItemState("active"), standardFocus);
}; // This is the main item style. It is defined as a basic style variable so it can
var $00428b424f2e334d$export$9bef42d378bf045f = function ItemBase(_ref6) {
    var theme = _ref6.theme;
    return (0, $13MK1.css)([
        "\n  && {\n    align-items: center;\n    border-radius: ",
        "px;\n    box-sizing: border-box;\n    cursor: pointer;\n    display: ",
        ";\n    flex: none;\n    ",
        " ",
        " ",
        " ",
        " ",
        " &:focus {\n      /* focus shadow drawn by getInteractiveStyles */\n\n      outline: none;\n      /* relative position prevents bgcolor of a hovered element from\n      obfuscating focus ring of a focused sibling element */\n      position: relative;\n    }\n  }\n"
    ], (0, $dBRTS.getThemeStyle)(theme[0, $dBRTS.themeNamespace], "borderRadius"), function(_ref7) {
        var isHidden = _ref7.isHidden;
        return isHidden ? "none" : "flex";
    }, $00428b424f2e334d$var$getItemState("default"), $00428b424f2e334d$var$getPadding, $00428b424f2e334d$var$getInteractiveStyles, $00428b424f2e334d$var$getHeightStyles, $00428b424f2e334d$var$getWidthStyles);
}; // Given some optional link-related props, returns the relevant styled
// component. For links, it styles the linkComponent if provided, otherwise
// falling back to a styled <a> tag. If no href is present, a styled <span>
// is returned. When we upgrade to styled-components@2.x we will be able to
// simplify this by taking advantage of the withComponent() functionality.
var $00428b424f2e334d$var$styledRootElement = function styledRootElement(_ref8) {
    var href = _ref8.href, linkComponent = _ref8.linkComponent;
    if (linkComponent) return (0, $13MK1.default)(linkComponent).withConfig({
        displayName: "Item",
        componentId: "z6qfkt-0"
    })([
        "\n      ",
        ";\n    "
    ], $00428b424f2e334d$export$9bef42d378bf045f);
    if (href) return (0, $13MK1.default).a.withConfig({
        displayName: "Item",
        componentId: "z6qfkt-1"
    })([
        "\n      ",
        ";\n    "
    ], $00428b424f2e334d$export$9bef42d378bf045f);
    return (0, $13MK1.default).span.withConfig({
        displayName: "Item",
        componentId: "z6qfkt-2"
    })([
        "\n    ",
        ";\n  "
    ], $00428b424f2e334d$export$9bef42d378bf045f);
};
var $00428b424f2e334d$export$2e2bcd8739ae039 = $00428b424f2e334d$var$styledRootElement;

});

parcelRegister("lvmhy", function(module, exports) {

$parcel$export(module.exports, "Before", function () { return $fa7dc6fea0936867$export$22cfc08db27bf1de; });
$parcel$export(module.exports, "After", function () { return $fa7dc6fea0936867$export$aad7b411ef70196e; });
$parcel$export(module.exports, "ContentWrapper", function () { return $fa7dc6fea0936867$export$6ce170286acaa8d3; });
$parcel$export(module.exports, "Content", function () { return $fa7dc6fea0936867$export$7c6e2c02157bb7d2; });
$parcel$export(module.exports, "Description", function () { return $fa7dc6fea0936867$export$393edc798c47379d; });

var $13MK1 = parcelRequire("13MK1");

var $gR2AX = parcelRequire("gR2AX");

var $dBRTS = parcelRequire("dBRTS");
var $fa7dc6fea0936867$export$fb9f58ebe9de6283 = (0, $13MK1.default).span.withConfig({
    displayName: "ItemParts__InputWrapper",
    componentId: "sc-14xek3m-0"
})([
    "\n  display: flex;\n  margin: 0 2px;\n"
]); // Elements injected before/after the children
var $fa7dc6fea0936867$var$BeforeAfterBase = (0, $13MK1.default).span.withConfig({
    displayName: "ItemParts__BeforeAfterBase",
    componentId: "sc-14xek3m-1"
})([
    "\n  align-items: center;\n  display: flex;\n  flex-shrink: 0;\n  /* Fix windows line-height issue */\n  padding-bottom: 1px;\n"
]);
var $fa7dc6fea0936867$var$getBeforeSpacing = function getBeforeSpacing(_ref) {
    var isCompact = _ref.isCompact, theme = _ref.theme;
    var spaceKey = isCompact ? "compact" : "default";
    var space = (0, $dBRTS.getThemeStyle)(theme[0, $dBRTS.themeNamespace], spaceKey, "beforeItemSpacing");
    return (0, $13MK1.css)([
        "\n    margin-right: ",
        "px;\n  "
    ], space);
};
var $fa7dc6fea0936867$export$22cfc08db27bf1de = (0, $13MK1.default)($fa7dc6fea0936867$var$BeforeAfterBase).withConfig({
    displayName: "ItemParts__Before",
    componentId: "sc-14xek3m-2"
})([
    "\n  ",
    ";\n"
], $fa7dc6fea0936867$var$getBeforeSpacing);
var $fa7dc6fea0936867$var$getAfterSpacing = function getAfterSpacing(_ref2) {
    var isCompact = _ref2.isCompact, theme = _ref2.theme;
    var spaceKey = isCompact ? "compact" : "default";
    var space = (0, $dBRTS.getThemeStyle)(theme[0, $dBRTS.themeNamespace], spaceKey, "afterItemSpacing");
    return (0, $13MK1.css)([
        "\n    margin-left: ",
        "px;\n  "
    ], space);
};
var $fa7dc6fea0936867$export$aad7b411ef70196e = (0, $13MK1.default)($fa7dc6fea0936867$var$BeforeAfterBase).withConfig({
    displayName: "ItemParts__After",
    componentId: "sc-14xek3m-3"
})([
    "\n  ",
    ";\n"
], $fa7dc6fea0936867$var$getAfterSpacing); // Alignment and layout for the children
var $fa7dc6fea0936867$export$6ce170286acaa8d3 = (0, $13MK1.default).span.withConfig({
    displayName: "ItemParts__ContentWrapper",
    componentId: "sc-14xek3m-4"
})([
    "\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  margin: 0;\n  overflow: hidden;\n\n  &:first-child {\n    margin: 0;\n  }\n"
]);
var $fa7dc6fea0936867$export$7c6e2c02157bb7d2 = (0, $13MK1.default).span.withConfig({
    displayName: "ItemParts__Content",
    componentId: "sc-14xek3m-5"
})([
    "\n  display: block;\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: ",
    ";\n  line-height: ",
    ";\n  /* Fix windows line-height issue */\n  padding-bottom: 1px;\n"
], function(_ref3) {
    var allowMultiline = _ref3.allowMultiline;
    return allowMultiline ? "normal" : "nowrap";
}, 16 / (0, $gR2AX.fontSize)());
var $fa7dc6fea0936867$var$getColorStyle = function getColorStyle(_ref4) {
    var isDisabled = _ref4.isDisabled, theme = _ref4.theme;
    if (isDisabled) return (0, $13MK1.css)([
        "\n      color: ",
        ";\n    "
    ], (0, $dBRTS.getThemeStyle)(theme[0, $dBRTS.themeNamespace], "secondaryText", "disabled"));
    return (0, $13MK1.css)([
        "\n    color: ",
        ";\n\n    /* This detects hover on the grandparent. Saves us having to maintain isHovered\n       state in the grandparent. */\n    *:hover > * > & {\n      color: ",
        ";\n    }\n\n    *:active > * > & {\n      color: ",
        ";\n    }\n  "
    ], (0, $dBRTS.getThemeStyle)(theme[0, $dBRTS.themeNamespace], "secondaryText", "default"), function() {
        return (0, $dBRTS.getThemeStyle)(theme[0, $dBRTS.themeNamespace], "secondaryText", "hover");
    }, function() {
        return (0, $dBRTS.getThemeStyle)(theme[0, $dBRTS.themeNamespace], "secondaryText", "active");
    });
};
var $fa7dc6fea0936867$var$getDescriptionFontStyles = function getDescriptionFontStyles(_ref5) {
    var isCompact = _ref5.isCompact;
    var descriptionFontSize = isCompact ? (0, $dBRTS.compactSmallFontSize) : (0, $gR2AX.fontSizeSmall)();
    var lineHeight = isCompact ? (0, $dBRTS.compactLineHeight) : 14 / descriptionFontSize;
    return (0, $13MK1.css)([
        "\n    font-size: ",
        "px;\n    line-height: ",
        ";\n    /* Fix windows line-height issue */\n    padding-bottom: 1px;\n  "
    ], descriptionFontSize, lineHeight);
}; // Description is a block element below the children, like a subtitle
var $fa7dc6fea0936867$export$393edc798c47379d = (0, $13MK1.default).span.withConfig({
    displayName: "ItemParts__Description",
    componentId: "sc-14xek3m-6"
})([
    "\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  ",
    " ",
    ";\n"
], $fa7dc6fea0936867$var$getColorStyle, $fa7dc6fea0936867$var$getDescriptionFontStyles);

});


parcelRegister("ig4CX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4ad4f86b8b8b9af$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");

var $ek5mu = parcelRequire("ek5mu");

var $8dlyD = parcelRequire("8dlyD");

var $kIBZj = parcelRequire("kIBZj");
var $d4ad4f86b8b8b9af$var$withItemClick = function withItemClick(WrappedItem) {
    var _class, _temp;
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(WithItemClick, _Component);
        function WithItemClick() {
            var _getPrototypeOf2;
            var _this;
            (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, WithItemClick);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, (_getPrototypeOf2 = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(WithItemClick)).call.apply(_getPrototypeOf2, [
                this
            ].concat(args)));
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "callContextFn", (0, $8dlyD.default)((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), (0, $kIBZj.clickManagerContext)));
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "shouldCloseAfterClick", function() {
                return !_this.props.isDisabled && !_this.props.href;
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleClick", function(event) {
                _this.props.onClick(event);
                if (_this.shouldCloseAfterClick()) _this.callContextFn("itemClicked");
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleKeyDown", function(event) {
                if (_this.props.onKeyDown) _this.props.onKeyDown(event);
                else if (event.key === "Space" || event.key === "Enter") _this.handleClick(event);
            });
            return _this;
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(WithItemClick, [
            {
                key: "render",
                value: function render() {
                    var _this$props = this.props, children = _this$props.children, otherProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_this$props, [
                        "children"
                    ]);
                    return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedItem, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
                        onClick: this.handleClick,
                        onKeyDown: this.handleKeyDown
                    }), children);
                }
            }
        ]);
        return WithItemClick;
    }((0, $9nHZC.Component)), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_class, "displayName", "WithItemClick(".concat((0, $ek5mu.default)(WrappedItem), ")")), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_class, "defaultProps", {
        onClick: function onClick() {}
    }), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_class, "contextTypes", (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, (0, $kIBZj.clickManagerContext), (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).object)), _temp;
};
var $d4ad4f86b8b8b9af$export$2e2bcd8739ae039 = $d4ad4f86b8b8b9af$var$withItemClick;

});
parcelRegister("ek5mu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6d717b0fc84067e$export$2e2bcd8739ae039; });
// from https://facebook.github.io/react/docs/higher-order-components.html
var $a6d717b0fc84067e$var$getDisplayName = function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || "Component";
};
var $a6d717b0fc84067e$export$2e2bcd8739ae039 = $a6d717b0fc84067e$var$getDisplayName;

});

parcelRegister("8dlyD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fb0428be1a75c04$export$2e2bcd8739ae039; });
// There are cases where the context is not available, such as when a dropdown item is used
// inside @atlaskit/navigation. For this reason we have this helper function which safely calls
// the context functions if they are available.
var $5fb0428be1a75c04$export$2e2bcd8739ae039 = function(instance, contextKey) {
    return function(fnToCall) {
        var _instance$context$con;
        if (!instance.context[contextKey]) return null;
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return (_instance$context$con = instance.context[contextKey])[fnToCall].apply(_instance$context$con, args);
    };
};

});

parcelRegister("kIBZj", function(module, exports) {

$parcel$export(module.exports, "focusManagerContext", function () { return $f155624f638fc11e$export$87323e074b98556d; });
$parcel$export(module.exports, "clickManagerContext", function () { return $f155624f638fc11e$export$2c0ea96a64772db8; });
var $f155624f638fc11e$var$prefix = function prefix(key) {
    return "@atlaskit-private-do-not-use/dropdown-menu:".concat(key);
};
var $f155624f638fc11e$export$87323e074b98556d = $f155624f638fc11e$var$prefix("focus-manager");
var $f155624f638fc11e$export$f4b104b2c6ac1221 = $f155624f638fc11e$var$prefix("selection-cache");
var $f155624f638fc11e$export$3d81059a1e042a43 = $f155624f638fc11e$var$prefix("selection-manager");
var $f155624f638fc11e$export$2c0ea96a64772db8 = $f155624f638fc11e$var$prefix("click-manager");

});


parcelRegister("eqlB5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8043f22f2c56c42$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");

var $lnOmc = parcelRequire("lnOmc");

var $5m0MG = parcelRequire("5m0MG");

var $ek5mu = parcelRequire("ek5mu");

var $8dlyD = parcelRequire("8dlyD");

var $kIBZj = parcelRequire("kIBZj");
var $a8043f22f2c56c42$var$withItemFocus = function withItemFocus(WrappedComponent) {
    var _class, _temp;
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(WithItemFocus, _Component);
        function WithItemFocus() {
            var _getPrototypeOf2;
            var _this;
            (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, WithItemFocus);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, (_getPrototypeOf2 = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(WithItemFocus)).call.apply(_getPrototypeOf2, [
                this
            ].concat(args)));
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "contextId", void 0);
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "callContextFn", (0, $8dlyD.default)((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), (0, $kIBZj.focusManagerContext)));
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "isFocusable", function() {
                return !_this.props.isDisabled && !_this.props.isHidden;
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleFocus", function() {
                if (_this.isFocusable()) _this.callContextFn("itemFocused", _this.contextId);
            });
            return _this;
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(WithItemFocus, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (!this.isFocusable()) return;
                    this.contextId = (0, (/*@__PURE__*/$parcel$interopDefault($5m0MG)))();
                    this.callContextFn("registerItem", this.contextId, (0, (/*@__PURE__*/$parcel$interopDefault($lnOmc))).findDOMNode(this) // eslint-disable-line react/no-find-dom-node
                    );
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate() {
                    if (!this.isFocusable()) return;
                    this.callContextFn("updateItem", this.contextId, (0, (/*@__PURE__*/$parcel$interopDefault($lnOmc))).findDOMNode(this) // eslint-disable-line react/no-find-dom-node
                    );
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (this.isFocusable()) this.callContextFn("deregisterItem", this.contextId);
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$props = this.props, children = _this$props.children, otherProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_this$props, [
                        "children"
                    ]);
                    return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                        onFocus: this.handleFocus,
                        role: "menuitem"
                    }, otherProps), children);
                }
            }
        ]);
        return WithItemFocus;
    }((0, $9nHZC.Component)), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_class, "displayName", "WithItemFocus(".concat((0, $ek5mu.default)(WrappedComponent), ")")), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_class, "contextTypes", (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, (0, $kIBZj.focusManagerContext), (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).object)), _temp;
};
var $a8043f22f2c56c42$export$2e2bcd8739ae039 = $a8043f22f2c56c42$var$withItemFocus;

});


parcelRegister("kMn2f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f20a28ad3f0c8c07$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $9nHZC = parcelRequire("9nHZC");

var $i0pBv = parcelRequire("i0pBv");
function $f20a28ad3f0c8c07$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f20a28ad3f0c8c07$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $f20a28ad3f0c8c07$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $f20a28ad3f0c8c07$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(DropdownItemGroup, _Component);
    var _super = $f20a28ad3f0c8c07$var$_createSuper(DropdownItemGroup);
    function DropdownItemGroup() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, DropdownItemGroup);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(DropdownItemGroup, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, children = _this$props.children, elemAfter = _this$props.elemAfter, title = _this$props.title;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $i0pBv.default), {
                    elemAfter: elemAfter,
                    title: title,
                    role: "menu"
                }, children);
            }
        }
    ]);
    return DropdownItemGroup;
}((0, $9nHZC.Component));

});
parcelRegister("i0pBv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1bc167a96b01a8b$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $3BD5g = parcelRequire("3BD5g");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $1czRa = parcelRequire("1czRa");

var $1BEt8 = parcelRequire("1BEt8");
var $d1bc167a96b01a8b$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(ItemGroup, _Component);
    function ItemGroup() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ItemGroup);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(ItemGroup).apply(this, arguments));
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ItemGroup, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, children = _this$props.children, elemAfter = _this$props.elemAfter, isCompact = _this$props.isCompact, title = _this$props.title, label = _this$props.label, innerRef = _this$props.innerRef, role = _this$props.role;
                var ariaLabel = function() {
                    if (label) return (0, (/*@__PURE__*/$parcel$interopDefault($1czRa)))(label);
                    if (title) return (0, (/*@__PURE__*/$parcel$interopDefault($1czRa)))(title);
                    return "";
                }();
                return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
                    "aria-label": ariaLabel,
                    role: role,
                    ref: innerRef
                }, title ? (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $1BEt8.GroupTitle), {
                    "aria-hidden": "true",
                    isCompact: isCompact
                }, (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $1BEt8.GroupTitleText), null, title), elemAfter ? (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $1BEt8.GroupTitleAfter), {
                    innerRef: function innerRef(r) {
                        _this.headingAfterElement = r;
                    }
                }, elemAfter) : null) : null, children);
            }
        }
    ]);
    return ItemGroup;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($d1bc167a96b01a8b$export$2e2bcd8739ae039, "defaultProps", {
    role: "group"
});

});
parcelRegister("1czRa", function(module, exports) {
"use strict";
function $0e02b9c8bf6c76d1$var$getText(rootChild) {
    var res = "";
    var rr = function rr(child) {
        if (typeof child === "string" || typeof child === "number") res += child;
        else if (Array.isArray(child)) child.forEach(function(c) {
            return rr(c);
        });
        else if (child && child.props) {
            var children = child.props.children;
            if (Array.isArray(children)) children.forEach(function(c) {
                return rr(c);
            });
            else rr(children);
        }
    };
    rr(rootChild);
    return res;
}
module.exports = $0e02b9c8bf6c76d1$var$getText;

});

parcelRegister("1BEt8", function(module, exports) {

$parcel$export(module.exports, "GroupTitle", function () { return $12b8a37443c5456a$export$161318b2ba42cf2b; });
$parcel$export(module.exports, "GroupTitleAfter", function () { return $12b8a37443c5456a$export$49a19cb569f8975; });
$parcel$export(module.exports, "GroupTitleText", function () { return $12b8a37443c5456a$export$c44392ea8eebe774; });

var $13MK1 = parcelRequire("13MK1");

var $gR2AX = parcelRequire("gR2AX");

var $dBRTS = parcelRequire("dBRTS");
var $12b8a37443c5456a$var$getPadding = function getPadding(_ref) {
    var isCompact = _ref.isCompact, theme = _ref.theme;
    var paddingType = isCompact ? "compact" : "default";
    var _getThemeStyle = (0, $dBRTS.getThemeStyle)(theme[0, $dBRTS.themeNamespace], paddingType, "padding"), _getThemeStyle$bottom = _getThemeStyle.bottom, bottom = _getThemeStyle$bottom === void 0 ? 0 : _getThemeStyle$bottom, _getThemeStyle$left = _getThemeStyle.left, left = _getThemeStyle$left === void 0 ? 0 : _getThemeStyle$left, _getThemeStyle$right = _getThemeStyle.right, right = _getThemeStyle$right === void 0 ? 0 : _getThemeStyle$right, _getThemeStyle$top = _getThemeStyle.top, top = _getThemeStyle$top === void 0 ? 0 : _getThemeStyle$top;
    return (0, $13MK1.css)([
        "\n    padding: ",
        "px ",
        "px ",
        "px ",
        "px;\n  "
    ], top, right, bottom, left);
}; // eslint-disable-next-line import/prefer-default-export
var $12b8a37443c5456a$export$161318b2ba42cf2b = (0, $13MK1.default).div.withConfig({
    displayName: "ItemGroup__GroupTitle",
    componentId: "ofbfv9-0"
})([
    "\n  align-items: center;\n  color: ",
    ";\n  display: flex;\n  flex: 1 1 auto;\n  ",
    ";\n"
], function(_ref2) {
    var theme = _ref2.theme;
    return (0, $dBRTS.getThemeStyle)(theme[0, $dBRTS.themeNamespace], "secondaryText", "default");
}, $12b8a37443c5456a$var$getPadding);
$12b8a37443c5456a$export$161318b2ba42cf2b.displayName = "ItemGroupTitle";
var $12b8a37443c5456a$export$49a19cb569f8975 = (0, $13MK1.default).div.withConfig({
    displayName: "ItemGroup__GroupTitleAfter",
    componentId: "ofbfv9-1"
})([
    "\n  flex: 0 0 auto;\n  margin-right: -",
    "px;\n"
], (0, $dBRTS.gridSize) / 2);
$12b8a37443c5456a$export$49a19cb569f8975.displayName = "ItemGroupTitleAfter";
var $12b8a37443c5456a$export$c44392ea8eebe774 = (0, $13MK1.default).div.withConfig({
    displayName: "ItemGroup__GroupTitleText",
    componentId: "ofbfv9-2"
})([
    "\n  flex: 1 1 auto;\n  font-size: ",
    "px;\n  line-height: 1;\n  text-transform: uppercase;\n  /* Required for children to truncate */\n  min-width: 0;\n"
], (0, $gR2AX.fontSizeSmall));
$12b8a37443c5456a$export$c44392ea8eebe774.displayName = "ItemGroupTitleText";

});



parcelRegister("8Ipe5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $949097279208368c$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $949097279208368c$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    no: {
        "id": "frontbucket.workspace.settings.group.none",
        "defaultMessage": "No"
    },
    workspacePermissions: {
        "id": "frontbucket.workspace.settings.group.workspacePermissions",
        "defaultMessage": "Workspace permissions"
    },
    defaultAccessGroupPrefix: {
        "id": "frontbucket.workspace.settings.group.defaultAccessGroupPrefix",
        "defaultMessage": "This group is set as your"
    },
    defaultAccessGroup: {
        "id": "frontbucket.workspace.settings.group.defaultAccessGroup",
        "defaultMessage": "default group"
    },
    canAdminister: {
        "id": "frontbucket.workspace.settings.group.canAdminister",
        "defaultMessage": "Can administer all workspace and repository settings"
    },
    canAdministerWithProject: {
        "id": "frontbucket.workspace.settings.group.canAdministerWithProject",
        "defaultMessage": "Can administer all workspace, project and repository settings"
    },
    canCreateProjects: {
        "id": "frontbucket.workspace.settings.group.canCreateProjects",
        "defaultMessage": "Can create projects for this workspace"
    },
    canCreateRepositories: {
        "id": "frontbucket.workspace.settings.group.canCreateRepositories",
        "defaultMessage": "Can create repositories for this workspace"
    },
    assignAccess: {
        "id": "frontbucket.workspace.settings.group.assignAccess",
        "defaultMessage": "User will be assigned {permissionLevel} access on all future repositories"
    },
    enabled: {
        "id": "frontbucket.workspace.settings.group.access.enabled",
        "defaultMessage": "Enabled"
    },
    disabled: {
        "id": "frontbucket.workspace.settings.group.access.disabled",
        "defaultMessage": "Disabled"
    },
    usersTab: {
        "id": "frontbucket.workspace.settings.group.tab.users",
        "defaultMessage": "Users"
    },
    repositoriesTab: {
        "id": "frontbucket.workspace.settings.group.tab.repositories",
        "defaultMessage": "Repositories"
    },
    projectsAndRepositoriesTab: {
        "id": "frontbucket.workspace.settings.group.tab.projectsAndRepositories",
        "defaultMessage": "Projects & Repositories"
    },
    write: {
        "id": "frontbucket.workspace.settings.group.write",
        "defaultMessage": "Write"
    },
    read: {
        "id": "frontbucket.workspace.settings.group.read",
        "defaultMessage": "Read"
    },
    admin: {
        "id": "frontbucket.workspace.settings.group.admin",
        "defaultMessage": "Admin"
    },
    private: {
        "id": "frontbucket.workspace.settings.group.private",
        "defaultMessage": "Private"
    },
    public: {
        "id": "frontbucket.workspace.settings.group.public",
        "defaultMessage": "Public"
    },
    privacy: {
        "id": "frontbucket.workspace.settings.group.privacy",
        "defaultMessage": "Privacy"
    },
    all: {
        "id": "frontbucket.workspace.settings.group.all",
        "defaultMessage": "All"
    },
    removeRepoModalMessage: {
        "id": "frontbucket.workspace.settings.group.removeRepoModalMessage",
        "defaultMessage": "You are about to remove {repoName} from the current group."
    },
    removeRepoHeader: {
        "id": "frontbucket.workspace.settings.group.removeRepoHeader",
        "defaultMessage": "Remove repository"
    },
    addRepoButtonLabel: {
        "id": "frontbucket.workspace.settings.group.addRepoButtonLabel",
        "defaultMessage": "Add repository"
    },
    addMembersButtonLabel: {
        "id": "frontbucket.workspace.settings.group.addMembersButtonLabel",
        "defaultMessage": "Add members"
    },
    success: {
        "id": "frontbucket.workspace.settings.groups.success",
        "defaultMessage": "Success"
    },
    error: {
        "id": "frontbucket.workspace.settings.groups.error",
        "defaultMessage": "Error"
    },
    successAddReposToGroupBody: {
        "id": "frontbucket.workspace.settings.groups.successAddReposToGroupBody",
        "defaultMessage": "Access to {repoNames}{overflowCount, plural, =0 {} one {, and 1 other repository} other {, and {overflowCount} other repositories}} granted to {groupName}"
    },
    successRemoveRepos: {
        "id": "frontbucket.workspace.settings.group.successRemoveRepos",
        "defaultMessage": "Access to {repoNames}{overflowCount, plural, =0 {} one {, and 1 other repository} other {, and {overflowCount} other repositories}} removed from {groupName}"
    },
    successChangeRepoPrivileges: {
        "id": "frontbucket.workspace.settings.group.successChangeRepoPrivileges",
        "defaultMessage": "Access to {repoNames}{overflowCount, plural, =0 {} one {, and 1 other repository} other {, and {overflowCount} other repositories}} updated for {groupName}"
    },
    groupsBreadcrumb: {
        "id": "frontbucket.workspace.settings.group.groupsBreadcrumb",
        "defaultMessage": "User groups"
    },
    successEditGroup: {
        "id": "frontbucket.workspace.settings.group.successEditGroup",
        "defaultMessage": 'Successfully changed the workspace permissions for the "{groupName}" group'
    },
    edit: {
        "id": "frontbucket.workspace.settings.group.edit",
        "defaultMessage": "Edit"
    },
    removeAccessContent: {
        "id": "frontbucket.workspace.settings.group.bulkRemoveReposModal.removeAccessContent",
        "defaultMessage": "You are about to remove group access to {count, plural, one {{countMarkup} repository} other {{countMarkup} repositories}}."
    },
    invitationsSent: {
        "id": "frontbucket.workspace.settings.group.notification.invitationsSent",
        "defaultMessage": "{count, plural, one {Invitation} other {Invitations}} sent"
    },
    invitationsSentDescription: {
        "id": "frontbucket.workspace.settings.group.notification.invitationsSentDescription",
        "defaultMessage": "{count} {count, plural, one {user was} other {users were}} invited to the current group."
    },
    memberAdded: {
        "id": "frontbucket.workspace.settings.group.notification.memberAdded",
        "defaultMessage": "Workspace {count, plural, one {member} other {members}} added"
    },
    memberAddedDescription: {
        "id": "frontbucket.workspace.settings.group.notification.memberAddedDescription",
        "defaultMessage": "{count} {count, plural, one {member was} other {members were}} added to the current group."
    },
    inviteFailedErrorHeader: {
        "id": "frontbucket.workspace.settings.group.notification.inviteFailedErrorHeader",
        "defaultMessage": "Invitation error"
    },
    inviteFailedErrorBody: {
        "id": "frontbucket.workspace.settings.group.notification.inviteFailedErrorBody",
        "defaultMessage": "The following {count, plural, one {user} other {users}} could not be invited: {entity}. Try again."
    }
});

});

parcelRegister("6OIRF", function(module, exports) {

$parcel$export(module.exports, "ReadViewContainer", function () { return $ef6a8f0fc3b5573b$export$ebb3489b83262b26; });
$parcel$export(module.exports, "EditViewContainer", function () { return $ef6a8f0fc3b5573b$export$c9faab454dc7ff1f; });
$parcel$export(module.exports, "ButtonGroupContainer", function () { return $ef6a8f0fc3b5573b$export$ac88c09275a93df9; });
$parcel$export(module.exports, "WorkspaceInfoSection", function () { return $ef6a8f0fc3b5573b$export$e5001ad37b71f8e1; });
$parcel$export(module.exports, "EditGroupButtonContainer", function () { return $ef6a8f0fc3b5573b$export$b0fbffff2f9ab10a; });
$parcel$export(module.exports, "WorkspaceInfoHeader", function () { return $ef6a8f0fc3b5573b$export$5638fc42d754d73; });
$parcel$export(module.exports, "DropdownItemContent", function () { return $ef6a8f0fc3b5573b$export$6fc77960e7e15faf; });

var $2xJU3 = parcelRequire("2xJU3");

var $jp7ng = parcelRequire("jp7ng");
var $aP6k3 = parcelRequire("aP6k3");
var $dCDrX = parcelRequire("dCDrX");
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */ function $ef6a8f0fc3b5573b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ef6a8f0fc3b5573b$var$groupHeaderFontSize = (0, $aP6k3.gridSize)() * 3;
const $ef6a8f0fc3b5573b$var$groupHeaderLineHeight = (0, $aP6k3.gridSize)() * 3.5;
const $ef6a8f0fc3b5573b$export$ebb3489b83262b26 = (0, $2xJU3.default)("div", {
    target: "e1qn30je0"
})("letter-spacing:normal;line-height:", $ef6a8f0fc3b5573b$var$groupHeaderLineHeight, "px;padding:", (0, $aP6k3.gridSize)() - 2, "px ", (0, $aP6k3.gridSize)() - 2, "px;word-break:break-word;&:hover,&:focus{cursor:pointer;}");
const $ef6a8f0fc3b5573b$export$c9faab454dc7ff1f = (0, $2xJU3.default)("div", {
    target: "e1qn30je1"
})("& textarea{font-weight:500;font-size:", $ef6a8f0fc3b5573b$var$groupHeaderFontSize, "px;line-height:", $ef6a8f0fc3b5573b$var$groupHeaderLineHeight, "px;height:", (props)=>props.scrollHeight || $ef6a8f0fc3b5573b$var$groupHeaderLineHeight, "px !important;word-break:break-word;}");
const $ef6a8f0fc3b5573b$export$ac88c09275a93df9 = (0, $2xJU3.default)("div", {
    target: "e1qn30je2"
})("margin-top:", (0, $aP6k3.gridSize)(), "px;");
const $ef6a8f0fc3b5573b$export$e5001ad37b71f8e1 = (0, $2xJU3.default)("div", {
    target: "e1qn30je3"
})("box-shadow:0 3px 5px ", (0, $jp7ng).N50A, ",0 0 1px ", (0, $jp7ng).N60A, ";border-radius:", (0, $aP6k3.gridSize)() / 2, "px;padding:", (0, $aP6k3.gridSize)() * 2.5, "px;margin-bottom:", (0, $aP6k3.gridSize)() * 5, "px;display:flex;justify-content:space-between;");
const $ef6a8f0fc3b5573b$export$b0fbffff2f9ab10a = (0, $2xJU3.default)("div", {
    target: "e1qn30je4"
})({
    name: "1v3870x",
    styles: "display:flex;flex-direction:column-reverse;"
});
const $ef6a8f0fc3b5573b$export$5638fc42d754d73 = (0, $2xJU3.default)("h3", {
    target: "e1qn30je5"
})((0, $dCDrX).h400, "");
const $ef6a8f0fc3b5573b$export$6fc77960e7e15faf = (0, $2xJU3.default)("div", {
    target: "e1qn30je6"
})("min-width:", (0, $aP6k3.gridSize)() * 20, "px;");

});
parcelRegister("dCDrX", function(module, exports) {

$parcel$export(module.exports, "fontFallback", function () { return $9ead6ce487a1c873$export$2a99220fb32ec798; });
$parcel$export(module.exports, "headingSizes", function () { return $9ead6ce487a1c873$export$bc02e067df412c3b; });
$parcel$export(module.exports, "h900", function () { return $9ead6ce487a1c873$export$bdb8f897727a9c67; });
$parcel$export(module.exports, "h800", function () { return $9ead6ce487a1c873$export$3953fb6fbd158d23; });
$parcel$export(module.exports, "h700", function () { return $9ead6ce487a1c873$export$e4f993a313607daa; });
$parcel$export(module.exports, "h600", function () { return $9ead6ce487a1c873$export$1e8b2acea3fb3119; });
$parcel$export(module.exports, "h500", function () { return $9ead6ce487a1c873$export$85aa43a9b9f06707; });
$parcel$export(module.exports, "h400", function () { return $9ead6ce487a1c873$export$fcb7764b80bd908f; });
$parcel$export(module.exports, "h300", function () { return $9ead6ce487a1c873$export$a0e59c3bbc05e815; });
$parcel$export(module.exports, "h200", function () { return $9ead6ce487a1c873$export$7ccf32eb2150ac7e; });
$parcel$export(module.exports, "h100", function () { return $9ead6ce487a1c873$export$dfc0e69214efdc3c; });

var $kFnE9 = parcelRequire("kFnE9");

var $jp7ng = parcelRequire("jp7ng");

var $aP6k3 = parcelRequire("aP6k3");
function $9ead6ce487a1c873$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9ead6ce487a1c873$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9ead6ce487a1c873$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9ead6ce487a1c873$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9ead6ce487a1c873$export$2a99220fb32ec798 = {
    heading: {
        xxlarge: 'normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xlarge: 'normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        large: 'normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xsmall: 'normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xxsmall: 'normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    },
    body: {
        large: 'normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        UNSAFE_small: 'normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    }
};
var $9ead6ce487a1c873$var$baseHeading = function baseHeading(size, lineHeight) {
    return {
        fontSize: "".concat(size / 14, "em"),
        fontStyle: "inherit",
        lineHeight: lineHeight / size
    };
};
var $9ead6ce487a1c873$export$bc02e067df412c3b = {
    h900: {
        size: 35,
        lineHeight: 40
    },
    h800: {
        size: 29,
        lineHeight: 32
    },
    h700: {
        size: 24,
        lineHeight: 28
    },
    h600: {
        size: 20,
        lineHeight: 24
    },
    h500: {
        size: 16,
        lineHeight: 20
    },
    h400: {
        size: 14,
        lineHeight: 16
    },
    h300: {
        size: 12,
        lineHeight: 16
    },
    h200: {
        size: 12,
        lineHeight: 16
    },
    h100: {
        size: 11,
        lineHeight: 16
    }
};
var $9ead6ce487a1c873$export$bdb8f897727a9c67 = function h900() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $9ead6ce487a1c873$var$_objectSpread($9ead6ce487a1c873$var$_objectSpread({}, $9ead6ce487a1c873$var$baseHeading($9ead6ce487a1c873$export$bc02e067df412c3b.h900.size, $9ead6ce487a1c873$export$bc02e067df412c3b.h900.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $jp7ng.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $aP6k3.gridSize)() * 6.5, "px")
    });
};
var $9ead6ce487a1c873$export$3953fb6fbd158d23 = function h800() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $9ead6ce487a1c873$var$_objectSpread($9ead6ce487a1c873$var$_objectSpread({}, $9ead6ce487a1c873$var$baseHeading($9ead6ce487a1c873$export$bc02e067df412c3b.h800.size, $9ead6ce487a1c873$export$bc02e067df412c3b.h800.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $jp7ng.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $aP6k3.gridSize)() * 5, "px")
    });
};
var $9ead6ce487a1c873$export$e4f993a313607daa = function h700() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $9ead6ce487a1c873$var$_objectSpread($9ead6ce487a1c873$var$_objectSpread({}, $9ead6ce487a1c873$var$baseHeading($9ead6ce487a1c873$export$bc02e067df412c3b.h700.size, $9ead6ce487a1c873$export$bc02e067df412c3b.h700.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $jp7ng.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $aP6k3.gridSize)() * 5, "px")
    });
};
var $9ead6ce487a1c873$export$1e8b2acea3fb3119 = function h600() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $9ead6ce487a1c873$var$_objectSpread($9ead6ce487a1c873$var$_objectSpread({}, $9ead6ce487a1c873$var$baseHeading($9ead6ce487a1c873$export$bc02e067df412c3b.h600.size, $9ead6ce487a1c873$export$bc02e067df412c3b.h600.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $jp7ng.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.008em",
        marginTop: "".concat((0, $aP6k3.gridSize)() * 3.5, "px")
    });
};
var $9ead6ce487a1c873$export$85aa43a9b9f06707 = function h500() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $9ead6ce487a1c873$var$_objectSpread($9ead6ce487a1c873$var$_objectSpread({}, $9ead6ce487a1c873$var$baseHeading($9ead6ce487a1c873$export$bc02e067df412c3b.h500.size, $9ead6ce487a1c873$export$bc02e067df412c3b.h500.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $jp7ng.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.006em",
        marginTop: "".concat((0, $aP6k3.gridSize)() * 3, "px")
    });
};
var $9ead6ce487a1c873$export$fcb7764b80bd908f = function h400() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $9ead6ce487a1c873$var$_objectSpread($9ead6ce487a1c873$var$_objectSpread({}, $9ead6ce487a1c873$var$baseHeading($9ead6ce487a1c873$export$bc02e067df412c3b.h400.size, $9ead6ce487a1c873$export$bc02e067df412c3b.h400.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $jp7ng.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.003em",
        marginTop: "".concat((0, $aP6k3.gridSize)() * 2, "px")
    });
};
var $9ead6ce487a1c873$export$a0e59c3bbc05e815 = function h300() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $9ead6ce487a1c873$var$_objectSpread($9ead6ce487a1c873$var$_objectSpread({}, $9ead6ce487a1c873$var$baseHeading($9ead6ce487a1c873$export$bc02e067df412c3b.h300.size, $9ead6ce487a1c873$export$bc02e067df412c3b.h300.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $jp7ng.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $aP6k3.gridSize)() * 2.5, "px"),
        textTransform: "uppercase"
    });
};
var $9ead6ce487a1c873$export$7ccf32eb2150ac7e = function h200() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $9ead6ce487a1c873$var$_objectSpread($9ead6ce487a1c873$var$_objectSpread({}, $9ead6ce487a1c873$var$baseHeading($9ead6ce487a1c873$export$bc02e067df412c3b.h200.size, $9ead6ce487a1c873$export$bc02e067df412c3b.h200.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $jp7ng.subtleHeading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $aP6k3.gridSize)() * 2, "px")
    });
};
var $9ead6ce487a1c873$export$dfc0e69214efdc3c = function h100() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $9ead6ce487a1c873$var$_objectSpread($9ead6ce487a1c873$var$_objectSpread({}, $9ead6ce487a1c873$var$baseHeading($9ead6ce487a1c873$export$bc02e067df412c3b.h100.size, $9ead6ce487a1c873$export$bc02e067df412c3b.h100.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $jp7ng.subtleHeading)(props), ")"),
        fontWeight: "var(--ds-font-weight-bold, 700)",
        marginTop: "".concat((0, $aP6k3.gridSize)() * 2, "px")
    });
};

});






parcelRegister("fXsLf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $561372b35b6d6343$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $5WD8l = parcelRequire("5WD8l");
var $c83ir = parcelRequire("c83ir");
var $kMn2f = parcelRequire("kMn2f");
parcelRequire("fequ0");
var $7bBwl = parcelRequire("7bBwl");

var $jajUg = parcelRequire("jajUg");

var $kkVLF = parcelRequire("kkVLF");

var $9aPI5 = parcelRequire("9aPI5");

var $7q4Mr = parcelRequire("7q4Mr");
const $561372b35b6d6343$var$PrivilegesDropdown = ({ value: value, onChange: onChange, isDisabled: isDisabled, allowEmptyChoice: allowEmptyChoice = false, includeNoneOption: includeNoneOption = false, showOptionDescription: showOptionDescription = true, showValueDescription: showValueDescription = false, emptyValueLabel: emptyValueLabel = "allPermissions", customEmptyValueLabel: customEmptyValueLabel, fitContainer: fitContainer = false, testId: testId = "privilegesDropdown", context: context = "repository", isFilter: isFilter = false, selectedPrivilege: selectedPrivilege = null })=>{
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    const privileges = [
        ...(0, $7q4Mr.privilegeOptions)[context][isFilter ? "filter" : "default"]
    ];
    if (includeNoneOption) privileges.unshift((0, $7bBwl.PrivilegeOptions).none);
    const getName = (permission)=>{
        if (permission) return formatMessage((0, $7q4Mr.getPermissionName)(permission));
        if (customEmptyValueLabel) return customEmptyValueLabel;
        if (emptyValueLabel === "allPermissions") return formatMessage($kkVLF.default.allPermissions);
        return formatMessage($kkVLF.default.none);
    };
    const getTrigger = ()=>{
        const label = getName(value);
        if (!isFilter && value && showValueDescription) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $c83ir.default), {
            className: "itemTrigger",
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9aPI5.PermissionDescription), null, formatMessage((0, $7q4Mr.getDescription)(value, context)))
        }, label);
        return label;
    };
    const nonePrivilegeOption = (0, $7bBwl.PrivilegeOptions).none;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9aPI5.DropMenuContainer), {
        showValueDescription: showValueDescription,
        allowEmptyChoice: allowEmptyChoice,
        fitContainer: fitContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5WD8l.default), {
        testId: testId,
        boundariesElement: "viewport",
        shouldFitContainer: !showOptionDescription || fitContainer,
        trigger: getTrigger(),
        triggerType: "button",
        triggerButtonProps: {
            isDisabled: isDisabled,
            shouldFitContainer: true,
            className: "triggerButton"
        }
    }, !selectedPrivilege && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kMn2f.default), null, allowEmptyChoice && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $c83ir.default), {
        onClick: ()=>onChange(null),
        isDisabled: !value || value === (0, $7bBwl.PrivilegeOptions).none
    }, formatMessage($kkVLF.default.allPrivilegesMenuItem)), privileges.map((privilege)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $c83ir.default), {
            key: privilege,
            isDisabled: privilege === value,
            onClick: ()=>onChange(privilege),
            description: !isFilter && showOptionDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9aPI5.PermissionDescription), null, formatMessage((0, $7q4Mr.getDescription)(privilege, context)))
        }, getName(privilege)))), selectedPrivilege && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kMn2f.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $c83ir.default), {
        key: nonePrivilegeOption,
        isDisabled: value === nonePrivilegeOption,
        onClick: ()=>onChange(nonePrivilegeOption),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9aPI5.PermissionDescription), null, formatMessage($kkVLF.repository.none))
    }, getName(nonePrivilegeOption)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $c83ir.default), {
        key: selectedPrivilege,
        isDisabled: value === selectedPrivilege,
        onClick: ()=>onChange(selectedPrivilege),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9aPI5.PermissionDescription), null, formatMessage((0, $7q4Mr.getDescription)(selectedPrivilege, context)))
    }, getName(selectedPrivilege)))));
};
var $561372b35b6d6343$export$2e2bcd8739ae039 = $561372b35b6d6343$var$PrivilegesDropdown;

});
parcelRegister("fequ0", function(module, exports) {

$parcel$export(module.exports, "ParticipantStateTypes", function () { return (parcelRequire("axaTk")).ParticipantStateTypes; });
$parcel$export(module.exports, "HttpMethods", function () { return (parcelRequire("6vWKR")).HttpMethods; });
$parcel$export(module.exports, "AccountPrivilege", function () { return (parcelRequire("7bBwl")).AccountPrivilege; });
$parcel$export(module.exports, "Privilege", function () { return (parcelRequire("7bBwl")).Privilege; });
$parcel$export(module.exports, "PrivilegeOptions", function () { return (parcelRequire("7bBwl")).PrivilegeOptions; });

var $allaN = parcelRequire("allaN");

var $gR1Dg = parcelRequire("gR1Dg");

var $2E7F9 = parcelRequire("2E7F9");

var $04ISR = parcelRequire("04ISR");

var $bA2oR = parcelRequire("bA2oR");

var $4o9ih = parcelRequire("4o9ih");

var $eW9pV = parcelRequire("eW9pV");

var $axaTk = parcelRequire("axaTk");

var $4Brvz = parcelRequire("4Brvz");

var $4TZt2 = parcelRequire("4TZt2");

var $028Qq = parcelRequire("028Qq");

var $fzGuF = parcelRequire("fzGuF");

var $bN4Ne = parcelRequire("bN4Ne");

var $6vWKR = parcelRequire("6vWKR");

var $jtxAC = parcelRequire("jtxAC");

var $kVN52 = parcelRequire("kVN52");

var $epWRD = parcelRequire("epWRD");

var $7bBwl = parcelRequire("7bBwl");
parcelRequire("5Lw3U");
var $l1aVB = parcelRequire("l1aVB");
var $1nkYg = parcelRequire("1nkYg");
parcelRequire("8CRTq");
var $5VEDG = parcelRequire("5VEDG");
var $fpyAr = parcelRequire("fpyAr");
var $8EDtO = parcelRequire("8EDtO");
var $jPNbC = parcelRequire("jPNbC");
var $e4Sy7 = parcelRequire("e4Sy7");

});
parcelRegister("allaN", function(module, exports) {

});

parcelRegister("gR1Dg", function(module, exports) {

});

parcelRegister("2E7F9", function(module, exports) {

});

parcelRegister("04ISR", function(module, exports) {

});

parcelRegister("bA2oR", function(module, exports) {

});

parcelRegister("4o9ih", function(module, exports) {

});

parcelRegister("eW9pV", function(module, exports) {

});

parcelRegister("axaTk", function(module, exports) {

$parcel$export(module.exports, "ParticipantStateTypes", function () { return $a1805417a3dc77fe$export$24b5635e34482a19; });
$parcel$export(module.exports, "DiffType", function () { return $a1805417a3dc77fe$export$ff2b1aa476090d9e; });
var $a1805417a3dc77fe$export$24b5635e34482a19;
(function(ParticipantStateTypes) {
    ParticipantStateTypes["approved"] = "approved";
    ParticipantStateTypes["changesRequested"] = "changes_requested";
})($a1805417a3dc77fe$export$24b5635e34482a19 || ($a1805417a3dc77fe$export$24b5635e34482a19 = {}));
var $a1805417a3dc77fe$export$ff2b1aa476090d9e;
(function(DiffType) {
    DiffType[DiffType["PREVIEW_MERGE_DIFF"] = 1] = "PREVIEW_MERGE_DIFF";
    DiffType[DiffType["TOPIC_DIFF"] = 2] = "TOPIC_DIFF";
})($a1805417a3dc77fe$export$ff2b1aa476090d9e || ($a1805417a3dc77fe$export$ff2b1aa476090d9e = {}));

});

parcelRegister("4Brvz", function(module, exports) {

});

parcelRegister("4TZt2", function(module, exports) {

});

parcelRegister("028Qq", function(module, exports) {

});

parcelRegister("fzGuF", function(module, exports) {

});

parcelRegister("bN4Ne", function(module, exports) {

});

parcelRegister("6vWKR", function(module, exports) {

$parcel$export(module.exports, "HttpMethods", function () { return $cfa9c695329db12d$export$99de5debf61fc084; });
var $cfa9c695329db12d$export$99de5debf61fc084;
(function(HttpMethods) {
    HttpMethods["get"] = "GET";
    HttpMethods["head"] = "HEAD";
    HttpMethods["post"] = "POST";
    HttpMethods["put"] = "PUT";
    HttpMethods["delete"] = "DELETE";
    HttpMethods["connect"] = "CONNECT";
    HttpMethods["options"] = "OPTIONS";
    HttpMethods["trace"] = "TRACE";
    HttpMethods["patch"] = "PATCH";
})($cfa9c695329db12d$export$99de5debf61fc084 || ($cfa9c695329db12d$export$99de5debf61fc084 = {}));

});

parcelRegister("jtxAC", function(module, exports) {

});

parcelRegister("kVN52", function(module, exports) {

});

parcelRegister("epWRD", function(module, exports) {

});

parcelRegister("7bBwl", function(module, exports) {

$parcel$export(module.exports, "Privilege", function () { return $a03fdb743cb92159$export$36148acc062aaa10; });
$parcel$export(module.exports, "PrivilegeOptions", function () { return $a03fdb743cb92159$export$78d4d8ee34b19cdf; });
$parcel$export(module.exports, "AccountPrivilege", function () { return $a03fdb743cb92159$export$41027d9a70a7d067; });
var $a03fdb743cb92159$export$78d4d8ee34b19cdf;
(function(BBPrivilegeOptions) {
    BBPrivilegeOptions["none"] = "none";
    BBPrivilegeOptions["read"] = "read";
    BBPrivilegeOptions["write"] = "write";
    BBPrivilegeOptions["create-repo"] = "create-repo";
    BBPrivilegeOptions["create-project"] = "create-project";
    BBPrivilegeOptions["admin"] = "admin";
})($a03fdb743cb92159$export$78d4d8ee34b19cdf || ($a03fdb743cb92159$export$78d4d8ee34b19cdf = {}));
var $a03fdb743cb92159$export$36148acc062aaa10;
(function(BBPrivilege) {
    BBPrivilege["read"] = "read";
    BBPrivilege["write"] = "write";
    BBPrivilege["create-repo"] = "create-repo";
    BBPrivilege["create-project"] = "create-project";
    BBPrivilege["admin"] = "admin";
})($a03fdb743cb92159$export$36148acc062aaa10 || ($a03fdb743cb92159$export$36148acc062aaa10 = {}));
var $a03fdb743cb92159$export$41027d9a70a7d067;
(function(BBAccountPrivilege) {
    BBAccountPrivilege["admin"] = "admin";
    BBAccountPrivilege["create-project"] = "create-project";
    BBAccountPrivilege["collaborator"] = "collaborator";
    BBAccountPrivilege["member"] = "member";
})($a03fdb743cb92159$export$41027d9a70a7d067 || ($a03fdb743cb92159$export$41027d9a70a7d067 = {}));

});

parcelRegister("5Lw3U", function(module, exports) {

var $l1aVB = parcelRequire("l1aVB");

var $1nkYg = parcelRequire("1nkYg");

});
parcelRegister("l1aVB", function(module, exports) {

});

parcelRegister("1nkYg", function(module, exports) {

});


parcelRegister("8CRTq", function(module, exports) {

var $5VEDG = parcelRequire("5VEDG");

var $fpyAr = parcelRequire("fpyAr");

var $jPNbC = parcelRequire("jPNbC");

var $e4Sy7 = parcelRequire("e4Sy7");

var $8EDtO = parcelRequire("8EDtO");

});
parcelRegister("5VEDG", function(module, exports) {

});

parcelRegister("fpyAr", function(module, exports) {

});

parcelRegister("jPNbC", function(module, exports) {

});

parcelRegister("e4Sy7", function(module, exports) {

});

parcelRegister("8EDtO", function(module, exports) {

});



parcelRegister("kkVLF", function(module, exports) {

$parcel$export(module.exports, "repository", function () { return $b380f95928aa4d6d$export$69a68d0c8baaec49; });
$parcel$export(module.exports, "project", function () { return $b380f95928aa4d6d$export$ab03b6763ed7026f; });
$parcel$export(module.exports, "workspace", function () { return $b380f95928aa4d6d$export$ed275788a758bd76; });
$parcel$export(module.exports, "default", function () { return $b380f95928aa4d6d$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
const $b380f95928aa4d6d$export$69a68d0c8baaec49 = (0, $agjvf.defineMessages)({
    read: {
        "id": "frontbucket.components.settings.privileges-dropdown.repository.permission.read-description",
        "defaultMessage": "Can view, clone, and fork repositories."
    },
    write: {
        "id": "frontbucket.components.settings.privileges-dropdown.repository.permission.write-description",
        "defaultMessage": "Can push code, create and merge pull requests."
    },
    admin: {
        "id": "frontbucket.components.settings.privileges-dropdown.repository.permission.admin-description",
        "defaultMessage": "Can manage repository settings and users, delete repositories, and also inherits all Write permissions."
    },
    none: {
        "id": "frontbucket.components.settings.privileges-dropdown.repository.permission.none-description",
        "defaultMessage": "Denied access to repositories."
    }
});
const $b380f95928aa4d6d$export$ab03b6763ed7026f = (0, $agjvf.defineMessages)({
    read: {
        "id": "frontbucket.components.settings.privileges-dropdown.project.permission.read-description",
        "defaultMessage": "Can clone, browse and fork any repository within the project. Can create and contribute to pull requests targeting any of these repositories."
    },
    write: {
        "id": "frontbucket.components.settings.privileges-dropdown.project.permission.write-description",
        "defaultMessage": "Can push to any repository within the project and merge pull requests targeting these repositories which don't have other restrictions. All activities permitted by the Read permission are granted to the Write users as well."
    },
    "create-repo": {
        "id": "frontbucket.components.settings.privileges-dropdown.project.permission.create-repo-description",
        "defaultMessage": "Can create repositories and are assigned Admin access to the created repositories. All activities permitted by the Write permission are granted to Create users as well."
    },
    admin: {
        "id": "frontbucket.components.settings.privileges-dropdown.project.permission.admin-description",
        "defaultMessage": "Can administer the project and create new repositories. Administrators have complete access to all repositories in the project."
    },
    none: {
        "id": "frontbucket.components.settings.privileges-dropdown.project.permission.none-description",
        "defaultMessage": "Denied access to projects."
    }
});
const $b380f95928aa4d6d$export$ed275788a758bd76 = (0, $agjvf.defineMessages)({
    "create-project": {
        "id": "frontbucket.components.settings.privileges-dropdown.workspace.permission.create-project-description",
        "defaultMessage": "Can create projects in this workspace."
    },
    admin: {
        "id": "frontbucket.components.settings.privileges-dropdown.workspace.permission.admin-description",
        "defaultMessage": "Can administer the workspace and create new projects. Administrators have complete access to all projects and repositories in the workspace."
    }
});
var $b380f95928aa4d6d$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    write: {
        "id": "frontbucket.components.settings.privileges-dropdown.permission.write",
        "defaultMessage": "Write"
    },
    read: {
        "id": "frontbucket.components.settings.privileges-dropdown.permission.read",
        "defaultMessage": "Read"
    },
    "create-repo": {
        "id": "frontbucket.components.settings.privileges-dropdown.permission.create-repo",
        "defaultMessage": "Create"
    },
    "create-project": {
        "id": "frontbucket.components.settings.privileges-dropdown.permission.create-project",
        "defaultMessage": "Create"
    },
    admin: {
        "id": "frontbucket.components.settings.privileges-dropdown.permission.admin",
        "defaultMessage": "Admin"
    },
    none: {
        "id": "frontbucket.components.settings.privileges-dropdown.permission.none",
        "defaultMessage": "None"
    },
    allPermissions: {
        "id": "frontbucket.components.settings.privileges-dropdown.permission.allPermissions",
        "defaultMessage": "Permissions"
    },
    allPrivilegesMenuItem: {
        "id": "frontbucket.components.settings.privileges-dropdown.permission.allPrivilegesMenuItem",
        "defaultMessage": "All"
    }
});

});

parcelRegister("9aPI5", function(module, exports) {

$parcel$export(module.exports, "DropMenuContainer", function () { return $0a85addee849fdd8$export$af9845808676c3bb; });
$parcel$export(module.exports, "PermissionDescription", function () { return $0a85addee849fdd8$export$3f9a29cf1e0228c2; });

var $2xJU3 = parcelRequire("2xJU3");

var $aP6k3 = parcelRequire("aP6k3");
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */ function $0a85addee849fdd8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0a85addee849fdd8$export$af9845808676c3bb = (0, $2xJU3.default)("div", {
    target: "e1l1ooug0"
})("margin-left:", ({ shiftLeft: shiftLeft })=>shiftLeft ? (0, $aP6k3.gridSize)() * 2 : 0, "px;margin-right:", ({ shiftRight: shiftRight })=>shiftRight ? (0, $aP6k3.gridSize)() * 2 : 0, "px;& .triggerButton{text-align:left;align-items:center;min-width:", ({ showValueDescription: showValueDescription, allowEmptyChoice: allowEmptyChoice })=>{
    let multiplier = 13;
    if (allowEmptyChoice) multiplier = 18;
    else if (showValueDescription) multiplier = 45;
    return (0, $aP6k3.gridSize)() * multiplier;
}, "px;max-width:", ({ fitContainer: fitContainer })=>fitContainer ? "100%" : `${(0, $aP6k3.gridSize)() * 45}px`, ";height:auto;min-height:", ({ showValueDescription: showValueDescription })=>showValueDescription ? (0, $aP6k3.gridSize)() * 8 : 0, "px;&[disabled],:hover,:focus{align-items:center;text-align:left;height:auto;}}& .itemTrigger{background-color:transparent;text-align:left;color:inherit;:hover,:focus{background-color:transparent;color:inherit;}}");
const $0a85addee849fdd8$export$3f9a29cf1e0228c2 = (0, $2xJU3.default)("p", {
    target: "e1l1ooug1"
})({
    name: "1vw5a1r",
    styles: "white-space:break-spaces;"
});

});

parcelRegister("7q4Mr", function(module, exports) {

$parcel$export(module.exports, "privilegeOptions", function () { return $e2c29fed8b86ac0d$export$b9b976cf1c7f1dbe; });
$parcel$export(module.exports, "getDescription", function () { return $e2c29fed8b86ac0d$export$67580b1c13935958; });
$parcel$export(module.exports, "getPermissionName", function () { return $e2c29fed8b86ac0d$export$c6adeb625aaa4d59; });

var $3XbtU = parcelRequire("3XbtU");
parcelRequire("fequ0");
var $7bBwl = parcelRequire("7bBwl");

var $kkVLF = parcelRequire("kkVLF");
const $e2c29fed8b86ac0d$var$defaultOptions = [
    (0, $7bBwl.PrivilegeOptions).read,
    (0, $7bBwl.PrivilegeOptions).write,
    (0, $7bBwl.PrivilegeOptions).admin
];
const $e2c29fed8b86ac0d$var$defaultOptionsWithCreateRepo = [
    (0, $7bBwl.PrivilegeOptions).read,
    (0, $7bBwl.PrivilegeOptions).write,
    (0, $7bBwl.PrivilegeOptions)["create-repo"],
    (0, $7bBwl.PrivilegeOptions).admin
];
const $e2c29fed8b86ac0d$var$defaultWorkspaceOptions = [
    (0, $7bBwl.PrivilegeOptions)["create-project"]
];
const $e2c29fed8b86ac0d$var$filterWorkspaceOptions = [
    (0, $7bBwl.PrivilegeOptions)["create-project"],
    (0, $7bBwl.PrivilegeOptions).admin
];
const $e2c29fed8b86ac0d$export$b9b976cf1c7f1dbe = {
    repository: {
        default: $e2c29fed8b86ac0d$var$defaultOptions,
        filter: $e2c29fed8b86ac0d$var$defaultOptionsWithCreateRepo
    },
    project: {
        default: $e2c29fed8b86ac0d$var$defaultOptionsWithCreateRepo,
        filter: $e2c29fed8b86ac0d$var$defaultOptionsWithCreateRepo
    },
    workspace: {
        default: $e2c29fed8b86ac0d$var$defaultWorkspaceOptions,
        filter: $e2c29fed8b86ac0d$var$filterWorkspaceOptions
    }
};
const $e2c29fed8b86ac0d$export$67580b1c13935958 = (permission, context)=>{
    if (context === "workspace" && (permission === (0, $7bBwl.PrivilegeOptions).admin || permission === (0, $7bBwl.PrivilegeOptions)["create-project"])) return $kkVLF.workspace[permission];
    if (context === "project" && permission !== (0, $7bBwl.PrivilegeOptions)["create-project"]) return $kkVLF.project[permission];
    if (context === "repository" && permission !== (0, $7bBwl.PrivilegeOptions)["create-project"] && permission !== (0, $7bBwl.PrivilegeOptions)["create-repo"]) return $kkVLF.repository[permission];
    // should never reach here
    const err = new Error("<PrivilegeDropdown/>: incorrect privilege/context passed to getDescription()");
    $3XbtU.captureMessage(err.message);
    throw err;
};
const $e2c29fed8b86ac0d$export$c6adeb625aaa4d59 = (permission)=>{
    return $kkVLF.default[permission];
};

});


parcelRegister("gYZ8r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec059e43ccb3e6cf$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $5WD8l = parcelRequire("5WD8l");
var $c83ir = parcelRequire("c83ir");
var $kMn2f = parcelRequire("kMn2f");

var $9aPI5 = parcelRequire("9aPI5");

var $jajUg = parcelRequire("jajUg");

var $cM1QH = parcelRequire("cM1QH");

var $bOfxz = parcelRequire("bOfxz");
const $ec059e43ccb3e6cf$var$AccessLevelDropdown = ({ value: value, onChange: onChange, isDisabled: isDisabled, allowEmptyChoice: allowEmptyChoice = false, isProjectContext: isProjectContext = false })=>{
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    let accessLevels = Object.values((0, $cM1QH.AccessLevel));
    if (isProjectContext) accessLevels = [
        (0, $cM1QH.AccessLevel).workspace,
        (0, $cM1QH.AccessLevel).project
    ];
    const getTriggerLabel = ()=>{
        if (value) return formatMessage((0, $bOfxz.default)[value]);
        return formatMessage((0, $bOfxz.default).allAccessLevels);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9aPI5.DropMenuContainer), {
        showValueDescription: false,
        allowEmptyChoice: allowEmptyChoice,
        fitContainer: true,
        shiftLeft: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5WD8l.default), {
        testId: "accessLevelDropdown",
        boundariesElement: "viewport",
        shouldFitContainer: true,
        trigger: getTriggerLabel(),
        triggerType: "button",
        triggerButtonProps: {
            isDisabled: isDisabled,
            shouldFitContainer: true,
            className: "triggerButton"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kMn2f.default), null, allowEmptyChoice && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $c83ir.default), {
        onClick: ()=>onChange(null),
        isDisabled: !value
    }, formatMessage((0, $bOfxz.default).allAccessLevelsMenuItem)), accessLevels.map((accessLevel)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $c83ir.default), {
            key: accessLevel,
            isDisabled: accessLevel === value,
            onClick: ()=>onChange(accessLevel)
        }, formatMessage((0, $bOfxz.default)[accessLevel]))))));
};
var $ec059e43ccb3e6cf$export$2e2bcd8739ae039 = $ec059e43ccb3e6cf$var$AccessLevelDropdown;

});
parcelRegister("cM1QH", function(module, exports) {

$parcel$export(module.exports, "LoadingState", function () { return $ef8e39d7cd196afa$export$62aa48085237e36f; });
$parcel$export(module.exports, "AccessLevel", function () { return $ef8e39d7cd196afa$export$2fad4038535569b7; });
$parcel$export(module.exports, "INVITE_FAILED_ERROR", function () { return $ef8e39d7cd196afa$export$49a7ad0f5585a793; });
$parcel$export(module.exports, "NON_ADMIN_RESTRICTION_ERROR", function () { return $ef8e39d7cd196afa$export$1659597d457e2b51; });
$parcel$export(module.exports, "DOMAIN_RESTRICTION_ERROR", function () { return $ef8e39d7cd196afa$export$3924e3514a5c9333; });
$parcel$export(module.exports, "BAD_REQUEST_ERROR", function () { return $ef8e39d7cd196afa$export$cadd4331b8752cfb; });
const $ef8e39d7cd196afa$export$62aa48085237e36f = {
    IDLE: "IDLE",
    LOADING: "LOADING",
    MODAL_LOADING: "MODAL_LOADING",
    PRIVILEGE_UPDATING: "PRIVILEGE_UPDATING",
    ERROR: "ERROR"
};
const $ef8e39d7cd196afa$export$2fad4038535569b7 = {
    workspace: "workspace",
    project: "project",
    repository: "repository"
};
const $ef8e39d7cd196afa$export$49a7ad0f5585a793 = "INVITE_FAILED_ERROR";
const $ef8e39d7cd196afa$export$1659597d457e2b51 = "NON_ADMIN_RESTRICTION_ERROR";
const $ef8e39d7cd196afa$export$3924e3514a5c9333 = "DOMAIN_RESTRICTION_ERROR ";
const $ef8e39d7cd196afa$export$cadd4331b8752cfb = "BAD_REQUEST_ERROR";

});

parcelRegister("bOfxz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f86f0dc9f36befd8$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $f86f0dc9f36befd8$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    description: {
        "id": "frontbucket.settings.permissions.description",
        "defaultMessage": "Add users or groups and provide them the permissions they need to collaborate on code across the entire project."
    },
    addUsersOrGroupsBtn: {
        "id": "frontbucket.settings.permissions.add-users-or-groups-btn",
        "defaultMessage": "Add users or groups"
    },
    accessGrantedTitle: {
        "id": "frontbucket.settings.permissions.notification.accessGrantedTitle",
        "defaultMessage": "Access granted"
    },
    accessGrantedDescription: {
        "id": "frontbucket.settings.permissions.notification.accessGrantedDescription",
        "defaultMessage": '"{entity}" {count, plural, one {was} other {were}} successfully added.'
    },
    accessRemovedTitle: {
        "id": "frontbucket.settings.permissions.notification.accessRemovedTitle",
        "defaultMessage": "Access removed"
    },
    accessRemovedDescription: {
        "id": "frontbucket.settings.permissions.notification.accessRemovedDescription",
        "defaultMessage": '"{entity}" {count, plural, one {was} other {were}} successfully removed.'
    },
    accessChangedTitle: {
        "id": "frontbucket.settings.permissions.notification.accessChangedTitle",
        "defaultMessage": "Access changed"
    },
    accessChangedDescription: {
        "id": "frontbucket.settings.permissions.notification.accessChangedDescription",
        "defaultMessage": 'Access for "{entity}" {count, plural, one {was} other {were}} successfully changed.'
    },
    // access level dropdown i18n
    project: {
        "id": "frontbucket.settings.permissions.access-level-dropdown.project",
        "defaultMessage": "Project"
    },
    repository: {
        "id": "frontbucket.settings.permissions.access-level-dropdown.repository",
        "defaultMessage": "Repository"
    },
    workspace: {
        "id": "frontbucket.settings.permissions.access-level-dropdown.workspace",
        "defaultMessage": "Workspace"
    },
    allAccessLevels: {
        "id": "frontbucket.settings.permissions.access-level-dropdown.allAccessLevels",
        "defaultMessage": "Access level"
    },
    allAccessLevelsMenuItem: {
        "id": "frontbucket.settings.permissions.access-level-dropdown.allAccessLevelsMenuItem",
        "defaultMessage": "All"
    },
    // errors
    inviteFailedErrorHeader: {
        "id": "frontbucket.settings.permissions.notification.inviteFailedErrorHeader",
        "defaultMessage": "Issue adding new {count, plural, one {user} other {users}}"
    },
    inviteFailedErrorBody: {
        "id": "frontbucket.settings.permissions.notification.inviteFailedErrorBody",
        "defaultMessage": "The following {count, plural, one {user} other {users}} could not be added by email: {entity}. Try again."
    },
    badRequestErrorHeader: {
        "id": "frontbucket.settings.permissions.notification.badRequestErrorHeader",
        "defaultMessage": "Issue adding existing {count, plural, one {user or group} other {users or groups}}"
    },
    badRequestErrorBody: {
        "id": "frontbucket.settings.permissions.notification.badRequestErrorBody",
        "defaultMessage": "All the users and groups that you selected could not be added because of an issue with {entity}. Remove the {count, plural, one {user or group} other {users or groups}} and try again."
    },
    unknownErrorHeader: {
        "id": "frontbucket.settings.permissions.notification.unknownAddUserErrorHeader",
        "defaultMessage": "Something went wrong"
    },
    unknownAddUserErrorBody: {
        "id": "frontbucket.settings.permissions.notification.unknownAddUserErrorBody",
        "defaultMessage": "{entity} {count, plural, one {was} other {were}} not added. Wait a few moments, then try again."
    },
    userNotAddedHeader: {
        "id": "frontbucket.settings.permissions.notification.userNotAddedHeader",
        "defaultMessage": '"{entity}" was not added'
    },
    invitationsSentDescription: {
        "id": "frontbucket.settings.permissions.notification.invitationsSentDescription",
        "defaultMessage": "{entity} {count, plural, one {was} other {were}} invited."
    },
    invitationsSent: {
        "id": "frontbucket.settings.permissions.notification.invitationsSent",
        "defaultMessage": "Invitations sent"
    },
    personalWorkspaceException: {
        "id": "frontbucket.settings.permissions.notification.personalWorkspaceException",
        "defaultMessage": "As an admin of this workspace, {entity} already has implicit admin access to this repository."
    }
});

});


parcelRegister("1oM5j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b67e6628cad736c3$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");
parcelRequire("dGzLf");
var $aAre5 = parcelRequire("aAre5");

var $2FnXC = parcelRequire("2FnXC");

var $g2R3c = parcelRequire("g2R3c");

var $cM1QH = parcelRequire("cM1QH");

var $7k723 = parcelRequire("7k723");

var $4HDjC = parcelRequire("4HDjC");

var $hCBEg = parcelRequire("hCBEg");
const $b67e6628cad736c3$var$messages = (0, $agjvf.defineMessages)({
    removeAccessContent: {
        "id": "frontbucket.settings.permissions.modals.removeAccessContent",
        "defaultMessage": "You are about to remove access for {entityName}."
    },
    areYouSure: {
        "id": "frontbucket.settings.permissions.modals.areYouSure",
        "defaultMessage": "Are you sure?"
    },
    removeOwnAccessWarning: {
        "id": "frontbucket.settings.permissions.modals.removeOwnAccessWarning",
        "defaultMessage": "You might be revoking your own admin access to this {contextType}."
    },
    removeOwnAccessWarningQuestion: {
        "id": "frontbucket.settings.permissions.modals.removeOwnAccessWarningQuestion",
        "defaultMessage": "Are you sure? You might be revoking your own admin access to this {contextType}."
    },
    workspace: {
        "id": "frontbucket.settings.permissions.modals.workspace",
        "defaultMessage": "workspace"
    },
    project: {
        "id": "frontbucket.settings.permissions.modals.project",
        "defaultMessage": "project"
    },
    repository: {
        "id": "frontbucket.settings.permissions.modals.repository",
        "defaultMessage": "repository"
    }
});
const $b67e6628cad736c3$var$ActiveModal = ({ api: api, refreshInvitations: refreshInvitations })=>{
    const [{ loadingState: loadingState }] = (0, $4HDjC.useLoadingState)();
    const [{ checkedRows: checkedRows }] = (0, $4HDjC.useCheckedRows)();
    const [{ activeModal: activeModal }] = (0, $4HDjC.useActiveModal)();
    const [{ context: context }] = (0, $4HDjC.usePermissionsContext)();
    const { setActiveModal: setActiveModal } = (0, $4HDjC.useActions)();
    const clearActiveModal = ()=>setActiveModal();
    const updateAccess = (0, $4HDjC.useUpdateAccess)(api);
    const removeAccess = (0, $4HDjC.useRemoveAccess)(api);
    const searchUsersAndGroups = (0, $4HDjC.useSearchUsersAndGroups)(api.searchUsersAndGroups);
    const addUsersAndGroups = (0, $4HDjC.useAddUsersAndGroups)(api, refreshInvitations);
    const currentUser = (0, $aAre5.useSelector)((0, $g2R3c.getCurrentUser));
    const isLoading = loadingState === (0, $cM1QH.LoadingState).MODAL_LOADING;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2FnXC.default), null, (0, $7k723.isModalType)("AddAccessModal", activeModal) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7k723.default).AddAccessModal, {
        isLoading: isLoading,
        onAdd: addUsersAndGroups,
        onClose: clearActiveModal,
        searchUsersAndGroups: searchUsersAndGroups,
        context: context
    }), (0, $7k723.isModalType)("BulkChangePrivilegesModal", activeModal) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7k723.default).BulkChangePrivilegesModal, {
        isLoading: isLoading,
        onBulkChange: async (privilege)=>{
            await updateAccess(privilege, checkedRows);
            setActiveModal();
        },
        onClose: clearActiveModal,
        itemNames: checkedRows.map((p)=>p.name),
        removeOwnAccessWarning: (0, $hCBEg.bulkShowRemoveOwnAccessWarning)(checkedRows, currentUser) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            tagName: "p"
        }, $b67e6628cad736c3$var$messages.removeOwnAccessWarningQuestion, {
            values: {
                contextType: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), $b67e6628cad736c3$var$messages[context])
            }
        })),
        context: context
    }), (0, $7k723.isModalType)("RemoveAccessModal", activeModal) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7k723.default).RemoveAccessModal, {
        isLoading: isLoading,
        onRemove: async ()=>{
            await removeAccess(...activeModal.props ? [
                activeModal.props
            ] : checkedRows);
            setActiveModal();
        },
        onClose: clearActiveModal,
        removeMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, (0, $hCBEg.bulkShowRemoveOwnAccessWarning)(activeModal.props ? [
            activeModal.props
        ] : checkedRows, currentUser) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            tagName: "p"
        }, $b67e6628cad736c3$var$messages.removeOwnAccessWarningQuestion, {
            values: {
                contextType: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), $b67e6628cad736c3$var$messages[context])
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            tagName: "p"
        }, $b67e6628cad736c3$var$messages.removeAccessContent, {
            values: {
                entityName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("b", null, activeModal.props ? activeModal.props.name : `"${checkedRows.map((entity)=>entity.name).join('", "')}"`)
            }
        })))
    }), (0, $7k723.isModalType)("RemoveOwnAccessWarning", activeModal) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7k723.default).RemoveOwnAccessWarning, {
        isLoading: isLoading,
        onConfirm: ()=>{
            if (activeModal.props[0] && activeModal.props[1]) updateAccess(activeModal.props[1], [
                activeModal.props[0]
            ]);
        },
        onCancel: clearActiveModal,
        header: $b67e6628cad736c3$var$messages.areYouSure,
        body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            tagName: "p"
        }, $b67e6628cad736c3$var$messages.removeOwnAccessWarning, {
            values: {
                contextType: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), $b67e6628cad736c3$var$messages[context])
            }
        }))
    }), (0, $7k723.isModalType)("PartialInvitationMessageModal", activeModal) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7k723.default).PartialInvitationMessageModal, {
        onClose: ()=>{
            clearActiveModal();
        },
        emails: activeModal.props
    }));
};
var $b67e6628cad736c3$export$2e2bcd8739ae039 = $b67e6628cad736c3$var$ActiveModal;

});
parcelRegister("7k723", function(module, exports) {

$parcel$export(module.exports, "isModalType", function () { return $6c151de13ca13e92$export$e25ebf548aeba0bd; });
$parcel$export(module.exports, "default", function () { return $6c151de13ca13e92$export$2e2bcd8739ae039; });

var $1HXgZ = parcelRequire("1HXgZ");

var $kGJQI = parcelRequire("kGJQI");

var $iO6JL = parcelRequire("iO6JL");

var $g8zgV = parcelRequire("g8zgV");

var $7ARA3 = parcelRequire("7ARA3");
const $6c151de13ca13e92$var$modals = {
    RemoveAccessModal: $kGJQI.default,
    AddAccessModal: $iO6JL.default,
    BulkChangePrivilegesModal: $g8zgV.default,
    RemoveOwnAccessWarning: (0, $1HXgZ.WarningModal),
    PartialInvitationMessageModal: $7ARA3.default
};
const $6c151de13ca13e92$export$e25ebf548aeba0bd = (type, modal)=>(modal === null || modal === void 0 ? void 0 : modal.type) === type;
var $6c151de13ca13e92$export$2e2bcd8739ae039 = $6c151de13ca13e92$var$modals;

});
parcelRegister("1HXgZ", function(module, exports) {

$parcel$export(module.exports, "WarningModal", function () { return $f2537c94ba45f73e$export$d69de51d0f6180c8; });
$parcel$export(module.exports, "RemoveModal", function () { return $f2537c94ba45f73e$export$5a5d118b9e96c9dd; });
$parcel$export(module.exports, "DeleteModal", function () { return $f2537c94ba45f73e$export$73392e09138fecd6; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $298N9 = parcelRequire("298N9");
const $f2537c94ba45f73e$export$d69de51d0f6180c8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $298N9.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        appearance: "warning"
    }));
const $f2537c94ba45f73e$export$bbcaa464f85abeef = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $298N9.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        appearance: "danger"
    }));
const $f2537c94ba45f73e$export$5a5d118b9e96c9dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $298N9.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        appearance: "warning",
        buttonText: {
            confirm: "remove"
        }
    }));
const $f2537c94ba45f73e$export$73392e09138fecd6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $298N9.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        appearance: "danger",
        buttonText: {
            confirm: "delete"
        }
    }));

});
parcelRegister("298N9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77cea647cc166009$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $ci5gC = parcelRequire("ci5gC");

var $jajUg = parcelRequire("jajUg");

var $fAeK3 = parcelRequire("fAeK3");

var $3SeXk = parcelRequire("3SeXk");
const $77cea647cc166009$var$ConfirmationModal = ({ onShow: onShow, onCancel: onCancel, onConfirm: onConfirm, isLoading: isLoading = false, isDisabled: isDisabled = false, header: header, body: body, appearance: appearance, customButtonText: customButtonText, buttonText: buttonText = {} })=>{
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    (0, $9nHZC.useEffect)(()=>{
        if (typeof onShow === "function") onShow();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const getModalText = (text)=>typeof text === "string" ? text : formatMessage(text);
    const getButtonText = (button)=>{
        let text = button === (0, $3SeXk.ActionButton).confirm ? (0, $fAeK3.default).confirm : (0, $fAeK3.default).close;
        if (buttonText && button in buttonText) text = (0, $fAeK3.default)[buttonText[button]];
        else if (customButtonText) text = customButtonText[button];
        return getModalText(text);
    };
    const actions = [
        {
            text: getButtonText((0, $3SeXk.ActionButton).cancel),
            onClick: onCancel,
            appearance: "subtle"
        },
        {
            text: getButtonText((0, $3SeXk.ActionButton).confirm),
            onClick: onConfirm,
            appearance: appearance || "primary",
            autoFocus: true,
            isLoading: isLoading,
            isDisabled: isDisabled
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ci5gC.default), {
        actions: actions,
        heading: getModalText(header),
        width: "small",
        onClose: onCancel,
        appearance: appearance
    }, body);
};
var $77cea647cc166009$export$2e2bcd8739ae039 = $77cea647cc166009$var$ConfirmationModal;

});
parcelRegister("fAeK3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $791ac8dfb76601fa$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $791ac8dfb76601fa$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    remove: {
        "id": "frontbucket.components.settings.modals.remove-modal.remove",
        "defaultMessage": "Remove"
    },
    delete: {
        "id": "frontbucket.components.settings.modals.remove-modal.delete",
        "defaultMessage": "Delete"
    },
    confirm: {
        "id": "frontbucket.components.settings.modals.remove-modal.confirm",
        "defaultMessage": "Confirm"
    },
    cancel: {
        "id": "frontbucket.components.settings.modals.remove-modal.cancel",
        "defaultMessage": "Cancel"
    },
    close: {
        "id": "frontbucket.components.settings.modals.remove-modal.close",
        "defaultMessage": "Close"
    }
});

});

parcelRegister("3SeXk", function(module, exports) {

$parcel$export(module.exports, "ActionButton", function () { return $6bc7b57910d85ad4$export$cfc7921d29ef7b80; });
var $6bc7b57910d85ad4$export$cfc7921d29ef7b80;
(function(ActionButton) {
    ActionButton["cancel"] = "cancel";
    ActionButton["confirm"] = "confirm";
})($6bc7b57910d85ad4$export$cfc7921d29ef7b80 || ($6bc7b57910d85ad4$export$cfc7921d29ef7b80 = {}));
var $6bc7b57910d85ad4$export$40bdb27f2137fcf;
(function(Appearance) {
    Appearance["danger"] = "danger";
    Appearance["warning"] = "warning";
})($6bc7b57910d85ad4$export$40bdb27f2137fcf || ($6bc7b57910d85ad4$export$40bdb27f2137fcf = {}));
var $6bc7b57910d85ad4$export$3606f03e783b24a8;
(function(CancelButtonText) {
    CancelButtonText["cancel"] = "cancel";
    CancelButtonText["close"] = "close";
})($6bc7b57910d85ad4$export$3606f03e783b24a8 || ($6bc7b57910d85ad4$export$3606f03e783b24a8 = {}));
var $6bc7b57910d85ad4$export$600daf1592dd9002;
(function(ConfirmButtonText) {
    ConfirmButtonText["confirm"] = "confirm";
    ConfirmButtonText["remove"] = "remove";
    ConfirmButtonText["delete"] = "delete";
})($6bc7b57910d85ad4$export$600daf1592dd9002 || ($6bc7b57910d85ad4$export$600daf1592dd9002 = {}));

});



parcelRegister("kGJQI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ee2f4ef92374d35$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $ci5gC = parcelRequire("ci5gC");

var $jajUg = parcelRequire("jajUg");

var $hKOh0 = parcelRequire("hKOh0");
const $6ee2f4ef92374d35$var$RemoveAccessModal = ({ onClose: onClose, onRemove: onRemove, isLoading: isLoading, removeMessage: removeMessage, heading: heading })=>{
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    const actions = [
        {
            text: formatMessage((0, $hKOh0.default).cancel),
            onClick: onClose,
            appearance: "subtle"
        },
        {
            text: formatMessage((0, $hKOh0.default).remove),
            onClick: onRemove,
            appearance: "warning",
            autoFocus: true,
            isLoading: isLoading,
            testId: "remove-access-modal--remove-btn"
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ci5gC.default), {
        actions: actions,
        heading: heading || formatMessage((0, $hKOh0.default).removeAccessHeader),
        width: "small",
        onClose: onClose,
        appearance: "warning"
    }, removeMessage);
};
var $6ee2f4ef92374d35$export$2e2bcd8739ae039 = $6ee2f4ef92374d35$var$RemoveAccessModal;

});
parcelRegister("hKOh0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f20d1518bb7221b8$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $f20d1518bb7221b8$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    removeAccessHeader: {
        "id": "frontbucket.removeAccessModal.removeAccessHeader",
        "defaultMessage": "Remove access"
    },
    cancel: {
        "id": "frontbucket.removeAccessModal.cancel",
        "defaultMessage": "Cancel"
    },
    remove: {
        "id": "frontbucket.removeAccessModal.remove",
        "defaultMessage": "Remove"
    }
});

});


parcelRegister("iO6JL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2624dbbc9ca6d30$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $kcdk1 = parcelRequire("kcdk1");

var $bgd70 = parcelRequire("bgd70");
var $2HsK2 = parcelRequire("2HsK2");

var $ci5gC = parcelRequire("ci5gC");

var $hNmd9 = parcelRequire("hNmd9");

var $fXsLf = parcelRequire("fXsLf");

var $3eLm0 = parcelRequire("3eLm0");
parcelRequire("fequ0");
var $7bBwl = parcelRequire("7bBwl");

var $jajUg = parcelRequire("jajUg");

var $fRg1j = parcelRequire("fRg1j");

var $cM1QH = parcelRequire("cM1QH");

var $4HDjC = parcelRequire("4HDjC");

var $1g8Pl = parcelRequire("1g8Pl");

var $arRaZ = parcelRequire("arRaZ");

var $lbYi2 = parcelRequire("lbYi2");
const $a2624dbbc9ca6d30$var$MAX_INVITATIONS = 10;
const $a2624dbbc9ca6d30$var$MAX_PRINCIPALS = 10;
const $a2624dbbc9ca6d30$var$AddAccessModal = ({ onClose: onClose, onAdd: onAdd, searchUsersAndGroups: searchUsersAndGroups, isLoading: isLoading, context: context })=>{
    const [selectedOptions, setSelectedOptions] = (0, $9nHZC.useState)([]);
    const [privilegeToAdd, setPrivilegeToAdd] = (0, $9nHZC.useState)(context === "workspace" ? (0, $7bBwl.Privilege)["create-project"] : (0, $7bBwl.Privilege).read);
    const [inputValue, setInputValue] = (0, $9nHZC.useState)("");
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    const [isSumEnabled] = (0, $4HDjC.useIsSumEnabled)();
    const isOverEmailLimit = selectedOptions.filter((opt)=>!!opt.isNew).length > $a2624dbbc9ca6d30$var$MAX_INVITATIONS;
    const isOverPrincipalLimit = selectedOptions.filter((opt)=>!opt.isNew).length > $a2624dbbc9ca6d30$var$MAX_PRINCIPALS;
    const noOptionsMessage = ({ inputValue: input })=>input ? formatMessage(isSumEnabled ? (0, $arRaZ.default).noWorkspaceMembersFound : (0, $arRaZ.default).noResults) : formatMessage(context === "workspace" ? (0, $arRaZ.default).beginTypingGroup : (0, $arRaZ.default).beginTyping);
    const newValueToOption = (0, $9nHZC.useCallback)((input)=>({
            id: input,
            name: input,
            mode: (0, $1g8Pl.AccessMode).users,
            avatar: "",
            isNew: true,
            hasAccess: false
        }), []);
    const onInputChange = (0, $9nHZC.useCallback)((input, { action: action })=>{
        if (isSumEnabled) {
            setInputValue(input);
            return;
        }
        if (input.includes(",")) {
            const commaSeparatedInput = input.split(",").map((str)=>str.trim());
            const newEmails = commaSeparatedInput.filter((str)=>(0, $fRg1j.isValidEmail)(str));
            const nonEmails = commaSeparatedInput.filter((str)=>!(0, $fRg1j.isValidEmail)(str)).filter((str)=>!!str.length);
            if (newEmails.length) {
                setSelectedOptions((prevOptions)=>[
                        ...prevOptions,
                        ...newEmails.map(newValueToOption)
                    ]);
                setInputValue(nonEmails.join(" "));
            } else setInputValue(input);
        } else if (action !== "input-blur" && action !== "menu-close") setInputValue(input);
        else {
            const trimmedEmailInput = inputValue.trim();
            if ((0, $fRg1j.isValidEmail)(trimmedEmailInput)) {
                setSelectedOptions((prevOptions)=>[
                        ...prevOptions.filter((ent)=>ent.id !== trimmedEmailInput),
                        // ^input-blur and menu-close are often fired one right after the other, before inputValue state is updated
                        newValueToOption(trimmedEmailInput)
                    ]);
                setInputValue(input);
            }
        }
    }, [
        inputValue,
        newValueToOption,
        isSumEnabled
    ]);
    const changeOption = (options)=>options !== null && options !== void 0 && options.length ? setSelectedOptions([
            ...options
        ]) : setSelectedOptions([]);
    const addPrivileges = ()=>onAdd(selectedOptions, privilegeToAdd);
    const getOptionValue = (option)=>option.id;
    const getOptionLabel = (option)=>option.name;
    const isOptionDisabled = (option)=>{
        var _option$hasAccess;
        return (_option$hasAccess = option.hasAccess) !== null && _option$hasAccess !== void 0 ? _option$hasAccess : false;
    };
    const getMessageForAccessLevel = (accessLevelType)=>{
        switch(accessLevelType){
            case (0, $cM1QH.AccessLevel).repository:
                return formatMessage((0, $arRaZ.default).hasRepoAccessLozenge);
            case (0, $cM1QH.AccessLevel).project:
                return formatMessage((0, $arRaZ.default).hasProjectAccessLozenge);
            case (0, $cM1QH.AccessLevel).workspace:
                return formatMessage((0, $arRaZ.default).hasWorkspaceAccessLozenge);
        }
        return "";
    };
    const hasAccessMessage = getMessageForAccessLevel(context);
    const actions = [
        {
            text: formatMessage((0, $arRaZ.default).cancel),
            onClick: onClose,
            appearance: "subtle"
        },
        {
            text: formatMessage((0, $arRaZ.default).confirm),
            onClick: addPrivileges,
            appearance: "primary",
            autoFocus: true,
            isDisabled: !selectedOptions.length || isOverEmailLimit || isOverPrincipalLimit,
            isLoading: isLoading
        }
    ];
    const selectSharedProps = {
        value: selectedOptions,
        isMulti: true,
        loadOptions: searchUsersAndGroups,
        onChange: changeOption,
        getOptionValue: getOptionValue,
        getOptionLabel: getOptionLabel,
        formatOptionLabel: (0, $hNmd9.formatOptionLabel)(hasAccessMessage),
        isOptionDisabled: isOptionDisabled,
        inputValue: inputValue,
        onInputChange: onInputChange,
        styles: {
            ...(0, $3eLm0.modalSelectStyles),
            container: (base)=>({
                    ...base,
                    maxWidth: "100%"
                })
        },
        noOptionsMessage: noOptionsMessage,
        components: {
            DropdownIndicator: null
        },
        classNamePrefix: "add-access-select"
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ci5gC.default), {
        actions: actions,
        heading: formatMessage(context === "workspace" ? (0, $arRaZ.default).addWorkspaceAccessHeader : (0, $arRaZ.default).addAccessHeader),
        width: "medium",
        onClose: onClose,
        scrollBehavior: "outside"
    }, isSumEnabled || context === "workspace" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, context === "workspace" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $lbYi2.DescriptionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("p", null, formatMessage((0, $arRaZ.default).createProjectDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2HsK2.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, selectSharedProps, {
        placeholder: formatMessage(context === "workspace" ? (0, $arRaZ.default).addMembersWorkspacePlaceholder : (0, $arRaZ.default).addMembersByNamePlaceholder)
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $bgd70.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, selectSharedProps, {
        allowCreateWhileLoading: true,
        isValidNewOption: (0, $fRg1j.isValidEmail),
        getNewOptionData: newValueToOption,
        placeholder: formatMessage((0, $arRaZ.default).addMembersPlaceholder)
    })), isOverEmailLimit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kcdk1.ErrorMessage), null, formatMessage((0, $arRaZ.default).emailInputMaxedOutError, {
        max: $a2624dbbc9ca6d30$var$MAX_INVITATIONS
    })), isOverPrincipalLimit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kcdk1.ErrorMessage), null, formatMessage((0, $arRaZ.default).entitiesMaxedOutError, {
        max: $a2624dbbc9ca6d30$var$MAX_PRINCIPALS
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("br", null), context !== "workspace" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fXsLf.default), {
        fitContainer: true,
        showValueDescription: true,
        showOptionDescription: true,
        value: privilegeToAdd,
        onChange: setPrivilegeToAdd,
        context: context
    }));
};
var $a2624dbbc9ca6d30$export$2e2bcd8739ae039 = $a2624dbbc9ca6d30$var$AddAccessModal;

});
parcelRegister("kcdk1", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", function () { return $eb3f4318df30bc54$export$8fbe3c7d0ed2c683; });
$parcel$export(module.exports, "ErrorMessage", function () { return $eb3f4318df30bc54$export$915e9e7bd4f0f96d; });
$parcel$export(module.exports, "ValidMessage", function () { return $eb3f4318df30bc54$export$5505afb209a532c8; });
/** @jsx jsx */ 
var $avKww = parcelRequire("avKww");

var $4PoCH = parcelRequire("4PoCH");

var $a8F0d = parcelRequire("a8F0d");

var $jp7ng = parcelRequire("jp7ng");

var $5LVXk = parcelRequire("5LVXk");

var $aP6k3 = parcelRequire("aP6k3");

var $dCDrX = parcelRequire("dCDrX");

var $hkHbL = parcelRequire("hkHbL");
/**
 * API for the internal `<Message />` component. This is not public API.
 */ /**
 * Public API of the various message components.
 */ var $eb3f4318df30bc54$var$fontFamily = (0, $aP6k3.fontFamily)();
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $eb3f4318df30bc54$var$lightH200Styles = (0, $avKww.css)((0, $dCDrX.h200)({
    theme: {
        mode: "light"
    }
}));
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $eb3f4318df30bc54$var$darkH200Styles = (0, $avKww.css)((0, $dCDrX.h200)({
    theme: {
        mode: "dark"
    }
}));
var $eb3f4318df30bc54$var$messageStyles = (0, $avKww.css)({
    display: "flex",
    marginTop: "var(--ds-space-050, 4px)",
    justifyContent: "baseline",
    fontFamily: "".concat($eb3f4318df30bc54$var$fontFamily),
    fontWeight: "normal"
});
var $eb3f4318df30bc54$var$messageAppearanceStyles = {
    default: (0, $avKww.css)({
        color: "var(--ds-text-subtlest, ".concat((0, $jp7ng.N200), ")")
    }),
    error: (0, $avKww.css)({
        color: "var(--ds-text-danger, #AE2A19)"
    }),
    valid: (0, $avKww.css)({
        color: "var(--ds-text-success, #216E4E)"
    })
};
var $eb3f4318df30bc54$var$iconWrapperStyles = (0, $avKww.css)({
    display: "flex"
});
var $eb3f4318df30bc54$var$IconWrapper = function IconWrapper(_ref) {
    var children = _ref.children;
    return (0, $avKww.jsx)("span", {
        css: $eb3f4318df30bc54$var$iconWrapperStyles
    }, children);
};
var $eb3f4318df30bc54$var$messageIcons = {
    error: (0, $avKww.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a8F0d))), {
        size: "small",
        label: "error"
    }),
    valid: (0, $avKww.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4PoCH))), {
        size: "small",
        label: "success"
    })
};
var $eb3f4318df30bc54$var$Message = function Message(_ref2) {
    var children = _ref2.children, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, fieldId = _ref2.fieldId, testId = _ref2.testId;
    var _useGlobalTheme = (0, $5LVXk.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var icon = $eb3f4318df30bc54$var$messageIcons[appearance];
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ var content = typeof children === "string" ? children : (0, $avKww.jsx)("span", null, children);
    return (0, $avKww.jsx)("div", {
        css: [
            mode === "light" ? $eb3f4318df30bc54$var$lightH200Styles : $eb3f4318df30bc54$var$darkH200Styles,
            $eb3f4318df30bc54$var$messageStyles,
            $eb3f4318df30bc54$var$messageAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        id: fieldId,
        "aria-live": "polite"
    }, icon && (0, $avKww.jsx)($eb3f4318df30bc54$var$IconWrapper, null, icon), content);
};
var $eb3f4318df30bc54$export$8fbe3c7d0ed2c683 = function HelperMessage(_ref3) {
    var children = _ref3.children, testId = _ref3.testId;
    return (0, $avKww.jsx)((0, $hkHbL.FieldId).Consumer, null, function(fieldId) {
        return (0, $avKww.jsx)($eb3f4318df30bc54$var$Message, {
            fieldId: fieldId ? "".concat(fieldId, "-helper") : undefined,
            testId: testId
        }, children);
    });
};
var $eb3f4318df30bc54$export$915e9e7bd4f0f96d = function ErrorMessage(_ref4) {
    var children = _ref4.children, testId = _ref4.testId;
    return (0, $avKww.jsx)((0, $hkHbL.FieldId).Consumer, null, function(fieldId) {
        return (0, $avKww.jsx)($eb3f4318df30bc54$var$Message, {
            appearance: "error",
            fieldId: fieldId ? "".concat(fieldId, "-error") : undefined,
            testId: testId
        }, children);
    });
};
var $eb3f4318df30bc54$export$5505afb209a532c8 = function ValidMessage(_ref5) {
    var children = _ref5.children, testId = _ref5.testId;
    return (0, $avKww.jsx)((0, $hkHbL.FieldId).Consumer, null, function(fieldId) {
        return (0, $avKww.jsx)($eb3f4318df30bc54$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? "".concat(fieldId, "-valid") : undefined,
            testId: testId
        }, children);
    });
};

});
parcelRegister("4PoCH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $383f068480f846b4$var$_react = $383f068480f846b4$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $cjvpy = parcelRequire("cjvpy");
function $383f068480f846b4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $383f068480f846b4$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $383f068480f846b4$var$_react.default.createElement($cjvpy.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 20a8 8 0 110-16 8 8 0 010 16zm1.364-10.964l-2.152 4.11-1.543-1.39a1 1 0 10-1.338 1.487l2.5 2.25a1 1 0 001.555-.279l2.75-5.25a1 1 0 00-1.772-.928z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$383f068480f846b4$var$EditorSuccessIcon.displayName = "EditorSuccessIcon";
var $383f068480f846b4$var$_default = $383f068480f846b4$var$EditorSuccessIcon;
module.exports.default = $383f068480f846b4$var$_default;

});
parcelRegister("cjvpy", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $02504084168d3855$export$f04a61298a47a40f; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $5LVXk = parcelRequire("5LVXk");

var $jpcp7 = parcelRequire("jpcp7");

var $cDZpP = parcelRequire("cDZpP");
function $02504084168d3855$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $02504084168d3855$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $02504084168d3855$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $02504084168d3855$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $02504084168d3855$var$iconStyles = (0, $avKww.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "> svg": $02504084168d3855$var$_objectSpread($02504084168d3855$var$_objectSpread({}, (0, $cDZpP.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $02504084168d3855$var$baseHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $02504084168d3855$var$primaryEqualsSecondaryHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $02504084168d3855$var$secondaryTransparentHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $02504084168d3855$export$f04a61298a47a40f = /*#__PURE__*/ (0, $9nHZC.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $avKww.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $cDZpP.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    var _useGlobalTheme = (0, $5LVXk.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $avKww.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            "--icon-secondary-color": secondaryColor || (0, $jpcp7.getBackground)(mode)
        }
    }, glyphProps, {
        css: [
            $02504084168d3855$var$iconStyles,
            $02504084168d3855$var$baseHcmStyles,
            primaryColor === secondaryColor && $02504084168d3855$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $02504084168d3855$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsualting them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $avKww.css)({
                width: dimensions.width,
                height: dimensions.height,
                "> svg": dimensions
            })
        ]
    }));
});
var $02504084168d3855$export$2e2bcd8739ae039 = $02504084168d3855$export$f04a61298a47a40f;

});
parcelRegister("jpcp7", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $e209f957da7027d2$export$18cb9425622d4e06; });
var $e209f957da7027d2$var$themedBackground = {
    light: "var(--ds-surface, #FFFFFF)",
    dark: "var(--ds-surface, #1B2638)"
};
var $e209f957da7027d2$export$18cb9425622d4e06 = function getBackground() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "light";
    return $e209f957da7027d2$var$themedBackground[mode];
};

});

parcelRegister("cDZpP", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $9348c46ca4f7367b$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $9348c46ca4f7367b$export$3eb7d6130acfda37; });

var $97e6E = parcelRequire("97e6E");

var $avKww = parcelRequire("avKww");
var $9348c46ca4f7367b$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
var $9348c46ca4f7367b$var$smallStyles = (0, $avKww.css)((0, $97e6E.dimensions).small);
var $9348c46ca4f7367b$var$mediumStyles = (0, $avKww.css)((0, $97e6E.dimensions).medium);
var $9348c46ca4f7367b$var$largeStyles = (0, $avKww.css)((0, $97e6E.dimensions).large);
var $9348c46ca4f7367b$var$xlargeStyles = (0, $avKww.css)((0, $97e6E.dimensions).xlarge);
var $9348c46ca4f7367b$export$ef0ad74202575b64 = {
    small: $9348c46ca4f7367b$var$smallStyles,
    medium: $9348c46ca4f7367b$var$mediumStyles,
    large: $9348c46ca4f7367b$var$largeStyles,
    xlarge: $9348c46ca4f7367b$var$xlargeStyles
};
var $9348c46ca4f7367b$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $97e6E.dimensions)[size];
    return undefined;
};

});
parcelRegister("97e6E", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $6a2fb5bcf7cdaa3c$export$62ad7b0c781000e9; });
var $6a2fb5bcf7cdaa3c$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $6a2fb5bcf7cdaa3c$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $6a2fb5bcf7cdaa3c$export$62ad7b0c781000e9 = {
    small: {
        width: $6a2fb5bcf7cdaa3c$export$c647cb0ee6e282fe.small,
        height: $6a2fb5bcf7cdaa3c$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $6a2fb5bcf7cdaa3c$export$c647cb0ee6e282fe.medium,
        height: $6a2fb5bcf7cdaa3c$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $6a2fb5bcf7cdaa3c$export$c647cb0ee6e282fe.large,
        height: $6a2fb5bcf7cdaa3c$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $6a2fb5bcf7cdaa3c$export$c647cb0ee6e282fe.xlarge,
        height: $6a2fb5bcf7cdaa3c$export$c647cb0ee6e282fe.xlarge
    }
};

});




parcelRegister("a8F0d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $761a74f523722133$var$_react = $761a74f523722133$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $cjvpy = parcelRequire("cjvpy");
function $761a74f523722133$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $761a74f523722133$var$ErrorIcon = (props)=>/*#__PURE__*/ $761a74f523722133$var$_react.default.createElement($cjvpy.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M13.416 4.417a2.002 2.002 0 00-2.832 0l-6.168 6.167a2.002 2.002 0 000 2.833l6.168 6.167a2.002 2.002 0 002.832 0l6.168-6.167a2.002 2.002 0 000-2.833l-6.168-6.167z" fill="currentColor"/><path d="M12 14a1 1 0 01-1-1V8a1 1 0 012 0v5a1 1 0 01-1 1m0 3a1 1 0 010-2 1 1 0 010 2" fill="inherit"/></g></svg>`
    }, props));
$761a74f523722133$var$ErrorIcon.displayName = "ErrorIcon";
var $761a74f523722133$var$_default = $761a74f523722133$var$ErrorIcon;
module.exports.default = $761a74f523722133$var$_default;

});

parcelRegister("hkHbL", function(module, exports) {

$parcel$export(module.exports, "FieldId", function () { return $c9e5ce5442bb3524$export$3c4232819458a302; });

var $9nHZC = parcelRequire("9nHZC");
var $c9e5ce5442bb3524$export$3c4232819458a302 = /*#__PURE__*/ (0, $9nHZC.createContext)(undefined);

});


parcelRegister("bgd70", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $832b5c1f42e49f9f$export$2e2bcd8739ae039; });

var $5aS1W = parcelRequire("5aS1W");

var $i04lD = parcelRequire("i04lD");
var $832b5c1f42e49f9f$export$2e2bcd8739ae039 = (0, $i04lD.default)((0, $5aS1W.default));

});
parcelRegister("5aS1W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c47cc328d9670e8$export$2e2bcd8739ae039; });

var $ii97e = parcelRequire("ii97e");

var $9nHZC = parcelRequire("9nHZC");

var $bpHvF = parcelRequire("bpHvF");

var $9IkcK = parcelRequire("9IkcK");

var $kIN0M = parcelRequire("kIN0M");

var $fMDCD = parcelRequire("fMDCD");
parcelRequire("aHkQz");
parcelRequire("uqRmf");
parcelRequire("eVDe4");
parcelRequire("3BD5g");
parcelRequire("d7Kxt");
parcelRequire("b4Ivn");


parcelRequire("9q1kH");
parcelRequire("lOQkO");
parcelRequire("340K4");
parcelRequire("hlgjl");
parcelRequire("kFnE9");
parcelRequire("lnOmc");

parcelRequire("05GjO");

var $3c47cc328d9670e8$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(props, ref) {
    var stateManagerProps = (0, $9IkcK.u)(props);
    var creatableProps = (0, $kIN0M.u)(stateManagerProps);
    var selectProps = (0, $fMDCD.u)(creatableProps);
    return /*#__PURE__*/ $9nHZC.createElement((0, $bpHvF.S), (0, $ii97e.default)({
        ref: ref
    }, selectProps));
});
var $3c47cc328d9670e8$export$2e2bcd8739ae039 = $3c47cc328d9670e8$var$AsyncCreatableSelect;

});
parcelRegister("bpHvF", function(module, exports) {

$parcel$export(module.exports, "c", function () { return $84f3c7a2d361ff8a$export$db3b6bfb95261072; });
$parcel$export(module.exports, "b", function () { return $84f3c7a2d361ff8a$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "g", function () { return $84f3c7a2d361ff8a$export$39b482c5e57630a8; });
$parcel$export(module.exports, "m", function () { return $84f3c7a2d361ff8a$export$953cecd6e717a553; });
$parcel$export(module.exports, "S", function () { return $84f3c7a2d361ff8a$export$25ce5a424b770e84; });

var $ii97e = parcelRequire("ii97e");

var $6PTxo = parcelRequire("6PTxo");

var $hApcg = parcelRequire("hApcg");

var $8xKDr = parcelRequire("8xKDr");

var $7J13m = parcelRequire("7J13m");

var $ftIQZ = parcelRequire("ftIQZ");

var $8i6ZY = parcelRequire("8i6ZY");

var $9nHZC = parcelRequire("9nHZC");

var $dUfie = parcelRequire("dUfie");

var $avKww = parcelRequire("avKww");

var $aLjj6 = parcelRequire("aLjj6");

var $hwJZV = parcelRequire("hwJZV");
function $84f3c7a2d361ff8a$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $84f3c7a2d361ff8a$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $84f3c7a2d361ff8a$var$A11yText = function A11yText(props) {
    return (0, $avKww.jsx)("span", (0, $ii97e.default)({
        css: $84f3c7a2d361ff8a$var$_ref
    }, props));
};
var $84f3c7a2d361ff8a$var$A11yText$1 = $84f3c7a2d361ff8a$var$A11yText;
var $84f3c7a2d361ff8a$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case "menu":
                return "Use Up and Down to choose options".concat(isDisabled ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
            case "input":
                return "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "");
            case "value":
                return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
            default:
                return "";
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return "option ".concat(label, ", deselected.");
            case "clear":
                return "All selected options have been cleared.";
            case "initial-input-focus":
                return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
            case "select-option":
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return "";
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
        };
        if (context === "value" && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === "menu") {
            var disabled = isDisabled ? " disabled" : "";
            var status = "".concat(isSelected ? "selected" : "focused").concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return "";
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
    }
};
var $84f3c7a2d361ff8a$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps["aria-label"];
    var ariaLive = selectProps["aria-live"];
    // Update aria live message configuration when prop changes
    var messages = (0, $9nHZC.useMemo)(function() {
        return (0, $6PTxo.default)((0, $6PTxo.default)({}, $84f3c7a2d361ff8a$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $9nHZC.useMemo)(function() {
        var message = "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : "";
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $6PTxo.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $9nHZC.useMemo)(function() {
        var focusMsg = "";
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? "menu" : "value",
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $9nHZC.useMemo)(function() {
        var resultsMsg = "";
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $9nHZC.useMemo)(function() {
        var guidanceMsg = "";
        if (messages.guidance) {
            var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
            guidanceMsg = messages.guidance({
                "aria-label": ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $avKww.jsx)((0, $9nHZC.Fragment), null, (0, $avKww.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $avKww.jsx)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    return (0, $avKww.jsx)((0, $9nHZC.Fragment), null, (0, $avKww.jsx)($84f3c7a2d361ff8a$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $avKww.jsx)($84f3c7a2d361ff8a$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $84f3c7a2d361ff8a$var$LiveRegion$1 = $84f3c7a2d361ff8a$var$LiveRegion;
var $84f3c7a2d361ff8a$var$diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $84f3c7a2d361ff8a$var$anyDiacritic = new RegExp("[" + $84f3c7a2d361ff8a$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $84f3c7a2d361ff8a$var$diacriticToBase = {};
for(var $84f3c7a2d361ff8a$var$i = 0; $84f3c7a2d361ff8a$var$i < $84f3c7a2d361ff8a$var$diacritics.length; $84f3c7a2d361ff8a$var$i++){
    var $84f3c7a2d361ff8a$var$diacritic = $84f3c7a2d361ff8a$var$diacritics[$84f3c7a2d361ff8a$var$i];
    for(var $84f3c7a2d361ff8a$var$j = 0; $84f3c7a2d361ff8a$var$j < $84f3c7a2d361ff8a$var$diacritic.letters.length; $84f3c7a2d361ff8a$var$j++)$84f3c7a2d361ff8a$var$diacriticToBase[$84f3c7a2d361ff8a$var$diacritic.letters[$84f3c7a2d361ff8a$var$j]] = $84f3c7a2d361ff8a$var$diacritic.base;
}
var $84f3c7a2d361ff8a$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($84f3c7a2d361ff8a$var$anyDiacritic, function(match) {
        return $84f3c7a2d361ff8a$var$diacriticToBase[match];
    });
};
var $84f3c7a2d361ff8a$var$memoizedStripDiacriticsForInput = (0, $aLjj6.default)($84f3c7a2d361ff8a$var$stripDiacritics);
var $84f3c7a2d361ff8a$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $84f3c7a2d361ff8a$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $84f3c7a2d361ff8a$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $6PTxo.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $84f3c7a2d361ff8a$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $84f3c7a2d361ff8a$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $84f3c7a2d361ff8a$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $84f3c7a2d361ff8a$var$memoizedStripDiacriticsForInput(input);
            candidate = $84f3c7a2d361ff8a$var$stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $84f3c7a2d361ff8a$var$_excluded = [
    "innerRef"
];
function $84f3c7a2d361ff8a$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $hwJZV.default)(_ref, $84f3c7a2d361ff8a$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $dUfie.r)(props, "onExited", "in", "enter", "exit", "appear");
    return (0, $avKww.jsx)("input", (0, $ii97e.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $avKww.css)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: "transparent",
            fontSize: "inherit",
            gridArea: "1 / 1 / 2 / 3",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(.01)"
        }, "", "")
    }));
}
var $84f3c7a2d361ff8a$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $84f3c7a2d361ff8a$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $9nHZC.useRef)(false);
    var isTop = (0, $9nHZC.useRef)(false);
    var touchStart = (0, $9nHZC.useRef)(0);
    var scrollTarget = (0, $9nHZC.useRef)(null);
    var handleEventDelta = (0, $9nHZC.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $84f3c7a2d361ff8a$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $9nHZC.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $9nHZC.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $9nHZC.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $9nHZC.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $dUfie.s) ? {
            passive: false
        } : false;
        el.addEventListener("wheel", onWheel, notPassive);
        el.addEventListener("touchstart", onTouchStart, notPassive);
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $9nHZC.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener("wheel", onWheel, false);
        el.removeEventListener("touchstart", onTouchStart, false);
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $9nHZC.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $84f3c7a2d361ff8a$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $84f3c7a2d361ff8a$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $84f3c7a2d361ff8a$var$preventTouchMove(e) {
    e.preventDefault();
}
function $84f3c7a2d361ff8a$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $84f3c7a2d361ff8a$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $84f3c7a2d361ff8a$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var $84f3c7a2d361ff8a$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $84f3c7a2d361ff8a$var$activeScrollLocks = 0;
var $84f3c7a2d361ff8a$var$listenerOptions = {
    capture: false,
    passive: false
};
function $84f3c7a2d361ff8a$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $9nHZC.useRef)({});
    var scrollTarget = (0, $9nHZC.useRef)(null);
    var addScrollLock = (0, $9nHZC.useCallback)(function(touchScrollTarget) {
        if (!$84f3c7a2d361ff8a$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $84f3c7a2d361ff8a$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $84f3c7a2d361ff8a$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($84f3c7a2d361ff8a$var$LOCK_STYLES).forEach(function(key) {
                var val = $84f3c7a2d361ff8a$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $84f3c7a2d361ff8a$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener("touchmove", $84f3c7a2d361ff8a$var$preventTouchMove, $84f3c7a2d361ff8a$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener("touchstart", $84f3c7a2d361ff8a$var$preventInertiaScroll, $84f3c7a2d361ff8a$var$listenerOptions);
                touchScrollTarget.addEventListener("touchmove", $84f3c7a2d361ff8a$var$allowTouchMove, $84f3c7a2d361ff8a$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $84f3c7a2d361ff8a$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $9nHZC.useCallback)(function(touchScrollTarget) {
        if (!$84f3c7a2d361ff8a$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $84f3c7a2d361ff8a$var$activeScrollLocks = Math.max($84f3c7a2d361ff8a$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $84f3c7a2d361ff8a$var$activeScrollLocks < 1) $84f3c7a2d361ff8a$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $84f3c7a2d361ff8a$var$isTouchDevice()) {
            target.removeEventListener("touchmove", $84f3c7a2d361ff8a$var$preventTouchMove, $84f3c7a2d361ff8a$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener("touchstart", $84f3c7a2d361ff8a$var$preventInertiaScroll, $84f3c7a2d361ff8a$var$listenerOptions);
                touchScrollTarget.removeEventListener("touchmove", $84f3c7a2d361ff8a$var$allowTouchMove, $84f3c7a2d361ff8a$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $9nHZC.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $84f3c7a2d361ff8a$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $84f3c7a2d361ff8a$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $84f3c7a2d361ff8a$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $84f3c7a2d361ff8a$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $84f3c7a2d361ff8a$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $84f3c7a2d361ff8a$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $avKww.jsx)((0, $9nHZC.Fragment), null, lockEnabled && (0, $avKww.jsx)("div", {
        onClick: $84f3c7a2d361ff8a$var$blurSelectInput,
        css: $84f3c7a2d361ff8a$var$_ref2$1
    }), children(targetRef));
}
function $84f3c7a2d361ff8a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $84f3c7a2d361ff8a$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $84f3c7a2d361ff8a$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $avKww.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $84f3c7a2d361ff8a$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $84f3c7a2d361ff8a$var$RequiredInput$1 = $84f3c7a2d361ff8a$var$RequiredInput;
var $84f3c7a2d361ff8a$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $84f3c7a2d361ff8a$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $84f3c7a2d361ff8a$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $84f3c7a2d361ff8a$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $84f3c7a2d361ff8a$var$defaultStyles = {
    clearIndicator: (0, $dUfie.a),
    container: (0, $dUfie.b),
    control: (0, $dUfie.d),
    dropdownIndicator: (0, $dUfie.e),
    group: (0, $dUfie.g),
    groupHeading: (0, $dUfie.f),
    indicatorsContainer: (0, $dUfie.i),
    indicatorSeparator: (0, $dUfie.h),
    input: (0, $dUfie.j),
    loadingIndicator: (0, $dUfie.l),
    loadingMessage: (0, $dUfie.k),
    menu: (0, $dUfie.m),
    menuList: (0, $dUfie.n),
    menuPortal: (0, $dUfie.o),
    multiValue: (0, $dUfie.p),
    multiValueLabel: (0, $dUfie.q),
    multiValueRemove: (0, $dUfie.t),
    noOptionsMessage: (0, $dUfie.u),
    option: (0, $dUfie.v),
    placeholder: (0, $dUfie.w),
    singleValue: (0, $dUfie.x),
    valueContainer: (0, $dUfie.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $84f3c7a2d361ff8a$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $6PTxo.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $84f3c7a2d361ff8a$var$colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var $84f3c7a2d361ff8a$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $84f3c7a2d361ff8a$var$baseUnit = 4;
// The minimum height of the control
var $84f3c7a2d361ff8a$var$controlHeight = 38;
// The amount of space between the control and menu */
var $84f3c7a2d361ff8a$var$menuGutter = $84f3c7a2d361ff8a$var$baseUnit * 2;
var $84f3c7a2d361ff8a$var$spacing = {
    baseUnit: $84f3c7a2d361ff8a$var$baseUnit,
    controlHeight: $84f3c7a2d361ff8a$var$controlHeight,
    menuGutter: $84f3c7a2d361ff8a$var$menuGutter
};
var $84f3c7a2d361ff8a$export$4368d992c4eafac0 = {
    borderRadius: $84f3c7a2d361ff8a$var$borderRadius,
    colors: $84f3c7a2d361ff8a$var$colors,
    spacing: $84f3c7a2d361ff8a$var$spacing
};
var $84f3c7a2d361ff8a$export$407448d2b89b1813 = {
    "aria-live": "polite",
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $dUfie.z)(),
    captureMenuScroll: !(0, $dUfie.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $84f3c7a2d361ff8a$export$db3b6bfb95261072(),
    formatGroupLabel: $84f3c7a2d361ff8a$var$formatGroupLabel,
    getOptionLabel: $84f3c7a2d361ff8a$export$8b22cf2602fb60ce,
    getOptionValue: $84f3c7a2d361ff8a$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $84f3c7a2d361ff8a$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $dUfie.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $84f3c7a2d361ff8a$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $84f3c7a2d361ff8a$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $84f3c7a2d361ff8a$var$_isOptionSelected(props, option, selectValue);
    var label = $84f3c7a2d361ff8a$var$getOptionLabel(props, option);
    var value = $84f3c7a2d361ff8a$var$getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $84f3c7a2d361ff8a$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $84f3c7a2d361ff8a$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $84f3c7a2d361ff8a$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $84f3c7a2d361ff8a$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $84f3c7a2d361ff8a$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $dUfie.K));
}
function $84f3c7a2d361ff8a$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $8i6ZY.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $84f3c7a2d361ff8a$var$buildFocusableOptions(props, selectValue) {
    return $84f3c7a2d361ff8a$var$buildFocusableOptionsFromCategorizedOptions($84f3c7a2d361ff8a$var$buildCategorizedOptions(props, selectValue));
}
function $84f3c7a2d361ff8a$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$84f3c7a2d361ff8a$var$shouldHideSelectedOptions(props) || !isSelected) && $84f3c7a2d361ff8a$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $84f3c7a2d361ff8a$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $84f3c7a2d361ff8a$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $84f3c7a2d361ff8a$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $84f3c7a2d361ff8a$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $84f3c7a2d361ff8a$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function $84f3c7a2d361ff8a$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = $84f3c7a2d361ff8a$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $84f3c7a2d361ff8a$var$getOptionValue(props, i) === candidate;
    });
}
function $84f3c7a2d361ff8a$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $84f3c7a2d361ff8a$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $84f3c7a2d361ff8a$var$instanceId = 1;
var $84f3c7a2d361ff8a$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $7J13m.default)(Select, _Component);
    var _super = (0, $ftIQZ.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $hApcg.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = "";
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $dUfie.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $dUfie.B)([].concat((0, $8i6ZY.default)(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, $dUfie.C)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, $dUfie.C)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $dUfie.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $dUfie.D)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $dUfie.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $dUfie.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $84f3c7a2d361ff8a$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $84f3c7a2d361ff8a$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $84f3c7a2d361ff8a$var$defaultStyles[key](props, unstyled);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $dUfie.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $84f3c7a2d361ff8a$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $84f3c7a2d361ff8a$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $6PTxo.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $dUfie.G)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $84f3c7a2d361ff8a$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = "react-select-" + (_this.props.instanceId || ++$84f3c7a2d361ff8a$var$instanceId);
        _this.state.selectValue = (0, $dUfie.H)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $8xKDr.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $dUfie.I)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $dUfie.I)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $84f3c7a2d361ff8a$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme($84f3c7a2d361ff8a$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $6PTxo.default)((0, $6PTxo.default)({}, $84f3c7a2d361ff8a$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $84f3c7a2d361ff8a$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $84f3c7a2d361ff8a$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $84f3c7a2d361ff8a$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input");
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $6PTxo.default)((0, $6PTxo.default)((0, $6PTxo.default)({
                    "aria-autocomplete": "list",
                    "aria-expanded": menuIsOpen,
                    "aria-haspopup": true,
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-invalid": this.props["aria-invalid"],
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"],
                    "aria-required": required,
                    role: "combobox"
                }, menuIsOpen && {
                    "aria-controls": this.getElementId("listbox"),
                    "aria-owns": this.getElementId("listbox")
                }), !isSearchable && {
                    "aria-readonly": true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
                    "aria-describedby": this.getElementId("live-region")
                } : {
                    "aria-describedby": this.getElementId("placeholder")
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $9nHZC.createElement($84f3c7a2d361ff8a$var$DummyInput, (0, $ii97e.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $dUfie.J),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $9nHZC.createElement(Input, (0, $ii97e.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $9nHZC.createElement(Placeholder, (0, $ii97e.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId("placeholder")
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $9nHZC.createElement(MultiValue, (0, $ii97e.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $9nHZC.createElement(SingleValue, (0, $ii97e.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $9nHZC.createElement(ClearIndicator, (0, $ii97e.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $9nHZC.createElement(LoadingIndicator, (0, $ii97e.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $9nHZC.createElement(IndicatorSeparator, (0, $ii97e.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $9nHZC.createElement(DropdownIndicator, (0, $ii97e.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $9nHZC.createElement(Option, (0, $ii97e.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === "group") {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $9nHZC.createElement(Group, (0, $ii97e.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === "option") return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $9nHZC.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $9nHZC.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $9nHZC.createElement((0, $dUfie.M), (0, $ii97e.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $9nHZC.createElement(Menu, (0, $ii97e.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId("listbox")
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $9nHZC.createElement($84f3c7a2d361ff8a$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $9nHZC.createElement(MenuList, (0, $ii97e.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ $9nHZC.createElement(MenuPortal, (0, $ii97e.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $9nHZC.createElement($84f3c7a2d361ff8a$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $9nHZC.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $9nHZC.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $9nHZC.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $9nHZC.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ $9nHZC.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $9nHZC.createElement($84f3c7a2d361ff8a$var$LiveRegion$1, (0, $ii97e.default)({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $9nHZC.createElement(SelectContainer, (0, $ii97e.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $9nHZC.createElement(Control, (0, $ii97e.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $9nHZC.createElement(ValueContainer, (0, $ii97e.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $9nHZC.createElement(IndicatorsContainer, (0, $ii97e.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $dUfie.H)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $84f3c7a2d361ff8a$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $84f3c7a2d361ff8a$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $84f3c7a2d361ff8a$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $dUfie.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return (0, $6PTxo.default)((0, $6PTxo.default)((0, $6PTxo.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $9nHZC.Component));
$84f3c7a2d361ff8a$export$25ce5a424b770e84.defaultProps = $84f3c7a2d361ff8a$export$407448d2b89b1813;

});
parcelRegister("6PTxo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fa29619d9a12cbe$export$2e2bcd8739ae039; });

var $14L3Y = parcelRequire("14L3Y");
function $4fa29619d9a12cbe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4fa29619d9a12cbe$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4fa29619d9a12cbe$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $14L3Y.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4fa29619d9a12cbe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("hApcg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccd958041413cd85$export$2e2bcd8739ae039; });
function $ccd958041413cd85$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("8xKDr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6385948d6de3fb68$export$2e2bcd8739ae039; });

var $7fhjg = parcelRequire("7fhjg");
function $6385948d6de3fb68$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $7fhjg.default)(o.key), o);
    }
}
function $6385948d6de3fb68$export$2e2bcd8739ae039(e, r, t) {
    return r && $6385948d6de3fb68$var$_defineProperties(e.prototype, r), t && $6385948d6de3fb68$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("7J13m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59fd8d89aeb97d9e$export$2e2bcd8739ae039; });

var $beNtY = parcelRequire("beNtY");
function $59fd8d89aeb97d9e$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $beNtY.default)(t, e);
}

});

parcelRegister("ftIQZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b44c5b75ca874e9f$export$2e2bcd8739ae039; });

var $c2N0i = parcelRequire("c2N0i");

var $t2aQU = parcelRequire("t2aQU");

var $hMJ1r = parcelRequire("hMJ1r");
function $b44c5b75ca874e9f$export$2e2bcd8739ae039(t) {
    var r = (0, $t2aQU.default)();
    return function() {
        var e, o = (0, $c2N0i.default)(t);
        if (r) {
            var s = (0, $c2N0i.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $hMJ1r.default)(this, e);
    };
}

});
parcelRegister("c2N0i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c4baf10df3d3040$export$2e2bcd8739ae039; });
function $8c4baf10df3d3040$export$2e2bcd8739ae039(t) {
    return $8c4baf10df3d3040$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $8c4baf10df3d3040$export$2e2bcd8739ae039(t);
}

});

parcelRegister("t2aQU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $057465445825208e$export$2e2bcd8739ae039; });
function $057465445825208e$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($057465445825208e$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("hMJ1r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf29d7d8a1f6233c$export$2e2bcd8739ae039; });

var $5fAHr = parcelRequire("5fAHr");

var $gHe8f = parcelRequire("gHe8f");
function $cf29d7d8a1f6233c$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $5fAHr.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $gHe8f.default)(t);
}

});
parcelRegister("gHe8f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c27b9fd22a5ac410$export$2e2bcd8739ae039; });
function $c27b9fd22a5ac410$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});



parcelRegister("8i6ZY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60956eed18f99ab1$export$2e2bcd8739ae039; });

var $8HuWA = parcelRequire("8HuWA");

var $laJKT = parcelRequire("laJKT");

var $jMlro = parcelRequire("jMlro");

var $8jzqk = parcelRequire("8jzqk");
function $60956eed18f99ab1$export$2e2bcd8739ae039(r) {
    return (0, $8HuWA.default)(r) || (0, $laJKT.default)(r) || (0, $jMlro.default)(r) || (0, $8jzqk.default)();
}

});
parcelRegister("8HuWA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $655a57b0c96b20e8$export$2e2bcd8739ae039; });

var $kbc4z = parcelRequire("kbc4z");
function $655a57b0c96b20e8$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $kbc4z.default)(r);
}

});
parcelRegister("kbc4z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb0e331ffcb97c43$export$2e2bcd8739ae039; });
function $eb0e331ffcb97c43$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("laJKT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f69e0631234d9b9e$export$2e2bcd8739ae039; });
function $f69e0631234d9b9e$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("jMlro", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e66321bceeec80df$export$2e2bcd8739ae039; });

var $kbc4z = parcelRequire("kbc4z");
function $e66321bceeec80df$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $kbc4z.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $kbc4z.default)(r, a) : void 0;
    }
}

});

parcelRegister("8jzqk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60db937c3c019b6f$export$2e2bcd8739ae039; });
function $60db937c3c019b6f$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("dUfie", function(module, exports) {

$parcel$export(module.exports, "J", function () { return $a1fc5e316d6c8f08$export$b4171a6734a65d42; });
$parcel$export(module.exports, "E", function () { return $a1fc5e316d6c8f08$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "H", function () { return $a1fc5e316d6c8f08$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "L", function () { return $a1fc5e316d6c8f08$export$61196ced6d74a310; });
$parcel$export(module.exports, "G", function () { return $a1fc5e316d6c8f08$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "I", function () { return $a1fc5e316d6c8f08$export$9bb611d729802a56; });
$parcel$export(module.exports, "z", function () { return $a1fc5e316d6c8f08$export$df995fae86a55f06; });
$parcel$export(module.exports, "A", function () { return $a1fc5e316d6c8f08$export$ebd11618f299a286; });
$parcel$export(module.exports, "s", function () { return $a1fc5e316d6c8f08$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "K", function () { return $a1fc5e316d6c8f08$export$3466f893ebf79586; });
$parcel$export(module.exports, "D", function () { return $a1fc5e316d6c8f08$export$96f57966bedc81b4; });
$parcel$export(module.exports, "C", function () { return $a1fc5e316d6c8f08$export$e7094788287c5e9b; });
$parcel$export(module.exports, "B", function () { return $a1fc5e316d6c8f08$export$ef35774e6d314e91; });
$parcel$export(module.exports, "r", function () { return $a1fc5e316d6c8f08$export$43caf9889c228507; });
$parcel$export(module.exports, "m", function () { return $a1fc5e316d6c8f08$export$953cecd6e717a553; });
$parcel$export(module.exports, "M", function () { return $a1fc5e316d6c8f08$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "n", function () { return $a1fc5e316d6c8f08$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "u", function () { return $a1fc5e316d6c8f08$export$3b14a55fb2447963; });
$parcel$export(module.exports, "k", function () { return $a1fc5e316d6c8f08$export$342063e11d6c3cad; });
$parcel$export(module.exports, "o", function () { return $a1fc5e316d6c8f08$export$ae1af26003f05816; });
$parcel$export(module.exports, "b", function () { return $a1fc5e316d6c8f08$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "y", function () { return $a1fc5e316d6c8f08$export$4a5767248b18ef41; });
$parcel$export(module.exports, "i", function () { return $a1fc5e316d6c8f08$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "e", function () { return $a1fc5e316d6c8f08$export$f1e1789686576879; });
$parcel$export(module.exports, "a", function () { return $a1fc5e316d6c8f08$export$407448d2b89b1813; });
$parcel$export(module.exports, "h", function () { return $a1fc5e316d6c8f08$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "l", function () { return $a1fc5e316d6c8f08$export$882b5998b3b9117c; });
$parcel$export(module.exports, "d", function () { return $a1fc5e316d6c8f08$export$4368d992c4eafac0; });
$parcel$export(module.exports, "g", function () { return $a1fc5e316d6c8f08$export$39b482c5e57630a8; });
$parcel$export(module.exports, "f", function () { return $a1fc5e316d6c8f08$export$2d1720544b23b823; });
$parcel$export(module.exports, "j", function () { return $a1fc5e316d6c8f08$export$35e795649ee09318; });
$parcel$export(module.exports, "p", function () { return $a1fc5e316d6c8f08$export$ffb5f4729a158638; });
$parcel$export(module.exports, "q", function () { return $a1fc5e316d6c8f08$export$9e5f44173e64f162; });
$parcel$export(module.exports, "t", function () { return $a1fc5e316d6c8f08$export$625550452a3fa3ec; });
$parcel$export(module.exports, "v", function () { return $a1fc5e316d6c8f08$export$90a7f3efeed30595; });
$parcel$export(module.exports, "w", function () { return $a1fc5e316d6c8f08$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "x", function () { return $a1fc5e316d6c8f08$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "c", function () { return $a1fc5e316d6c8f08$export$db3b6bfb95261072; });
$parcel$export(module.exports, "F", function () { return $a1fc5e316d6c8f08$export$d66501df72047452; });

var $6PTxo = parcelRequire("6PTxo");

var $ii97e = parcelRequire("ii97e");

var $avKww = parcelRequire("avKww");

var $gUHnA = parcelRequire("gUHnA");

var $hwJZV = parcelRequire("hwJZV");

var $5fAHr = parcelRequire("5fAHr");

var $kR9Sl = parcelRequire("kR9Sl");

var $14L3Y = parcelRequire("14L3Y");

var $9nHZC = parcelRequire("9nHZC");

var $lnOmc = parcelRequire("lnOmc");

var $hB0aJ = parcelRequire("hB0aJ");

var $05GjO = parcelRequire("05GjO");
var $a1fc5e316d6c8f08$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $a1fc5e316d6c8f08$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $a1fc5e316d6c8f08$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $a1fc5e316d6c8f08$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($a1fc5e316d6c8f08$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
}
// ==============================
// Clean Value
// ==============================
var $a1fc5e316d6c8f08$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($a1fc5e316d6c8f08$var$isArray(value)) return value.filter(Boolean);
    if ((0, $5fAHr.default)(value) === "object" && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $a1fc5e316d6c8f08$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $hwJZV.default)(props, $a1fc5e316d6c8f08$var$_excluded$4);
    return (0, $6PTxo.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $a1fc5e316d6c8f08$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $a1fc5e316d6c8f08$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === "string") return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $a1fc5e316d6c8f08$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $a1fc5e316d6c8f08$var$normalizedHeight(el) {
    if ($a1fc5e316d6c8f08$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $a1fc5e316d6c8f08$var$getScrollTop(el) {
    if ($a1fc5e316d6c8f08$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $a1fc5e316d6c8f08$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($a1fc5e316d6c8f08$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $a1fc5e316d6c8f08$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $a1fc5e316d6c8f08$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $a1fc5e316d6c8f08$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $a1fc5e316d6c8f08$export$b4171a6734a65d42;
    var start = $a1fc5e316d6c8f08$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $a1fc5e316d6c8f08$var$easeOutCubic(currentTime, start, change, duration);
        $a1fc5e316d6c8f08$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $a1fc5e316d6c8f08$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $a1fc5e316d6c8f08$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $a1fc5e316d6c8f08$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $a1fc5e316d6c8f08$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $a1fc5e316d6c8f08$export$df995fae86a55f06() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $a1fc5e316d6c8f08$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $a1fc5e316d6c8f08$var$passiveOptionAccessed = false;
var $a1fc5e316d6c8f08$var$options = {
    get passive () {
        return $a1fc5e316d6c8f08$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $a1fc5e316d6c8f08$var$w = typeof window !== "undefined" ? window : {};
if ($a1fc5e316d6c8f08$var$w.addEventListener && $a1fc5e316d6c8f08$var$w.removeEventListener) {
    $a1fc5e316d6c8f08$var$w.addEventListener("p", $a1fc5e316d6c8f08$export$b4171a6734a65d42, $a1fc5e316d6c8f08$var$options);
    $a1fc5e316d6c8f08$var$w.removeEventListener("p", $a1fc5e316d6c8f08$export$b4171a6734a65d42, false);
}
var $a1fc5e316d6c8f08$export$2408f22a0fab9ae5 = $a1fc5e316d6c8f08$var$passiveOptionAccessed;
function $a1fc5e316d6c8f08$export$3466f893ebf79586(item) {
    return item != null;
}
function $a1fc5e316d6c8f08$var$isArray(arg) {
    return Array.isArray(arg);
}
function $a1fc5e316d6c8f08$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $a1fc5e316d6c8f08$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $a1fc5e316d6c8f08$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $a1fc5e316d6c8f08$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $gUHnA.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $gUHnA.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $a1fc5e316d6c8f08$var$_excluded$3 = [
    "children",
    "innerProps"
], $a1fc5e316d6c8f08$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $a1fc5e316d6c8f08$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $a1fc5e316d6c8f08$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $a1fc5e316d6c8f08$var$normalizedHeight(scrollParent);
    var scrollTop = $a1fc5e316d6c8f08$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $a1fc5e316d6c8f08$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $a1fc5e316d6c8f08$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === "bottom") {
                if (shouldScroll) $a1fc5e316d6c8f08$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $a1fc5e316d6c8f08$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $a1fc5e316d6c8f08$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $a1fc5e316d6c8f08$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var $a1fc5e316d6c8f08$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $a1fc5e316d6c8f08$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $6PTxo.default)((_objectSpread2 = {
        label: "menu"
    }, (0, $14L3Y.default)(_objectSpread2, $a1fc5e316d6c8f08$var$alignToControl(placement), "100%"), (0, $14L3Y.default)(_objectSpread2, "position", "absolute"), (0, $14L3Y.default)(_objectSpread2, "width", "100%"), (0, $14L3Y.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $a1fc5e316d6c8f08$var$PortalPlacementContext = /*#__PURE__*/ (0, $9nHZC.createContext)(null);
// NOTE: internal only
var $a1fc5e316d6c8f08$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $9nHZC.useContext)($a1fc5e316d6c8f08$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $9nHZC.useRef)(null);
    var _useState = (0, $9nHZC.useState)(maxMenuHeight), _useState2 = (0, $gUHnA.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $9nHZC.useState)(null), _useState4 = (0, $gUHnA.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $05GjO.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === "fixed";
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $a1fc5e316d6c8f08$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $6PTxo.default)((0, $6PTxo.default)({}, props), {}, {
            placement: placement || $a1fc5e316d6c8f08$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $a1fc5e316d6c8f08$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $avKww.jsx)("div", (0, $ii97e.default)({}, $a1fc5e316d6c8f08$var$getStyleProps(props, "menu", {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $a1fc5e316d6c8f08$var$Menu$1 = $a1fc5e316d6c8f08$var$Menu;
// ==============================
// Menu List
// ==============================
var $a1fc5e316d6c8f08$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $6PTxo.default)({
        maxHeight: maxHeight,
        overflowY: "auto",
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $a1fc5e316d6c8f08$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $avKww.jsx)("div", (0, $ii97e.default)({}, $a1fc5e316d6c8f08$var$getStyleProps(props, "menuList", {
        "menu-list": true,
        "menu-list--is-multi": isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $a1fc5e316d6c8f08$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $6PTxo.default)({
        textAlign: "center"
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $a1fc5e316d6c8f08$export$3b14a55fb2447963 = $a1fc5e316d6c8f08$var$noticeCSS;
var $a1fc5e316d6c8f08$export$342063e11d6c3cad = $a1fc5e316d6c8f08$var$noticeCSS;
var $a1fc5e316d6c8f08$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? "No options" : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $hwJZV.default)(_ref6, $a1fc5e316d6c8f08$var$_excluded$3);
    return (0, $avKww.jsx)("div", (0, $ii97e.default)({}, $a1fc5e316d6c8f08$var$getStyleProps((0, $6PTxo.default)((0, $6PTxo.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "noOptionsMessage", {
        "menu-notice": true,
        "menu-notice--no-options": true
    }), innerProps), children);
};
var $a1fc5e316d6c8f08$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? "Loading..." : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $hwJZV.default)(_ref7, $a1fc5e316d6c8f08$var$_excluded2$1);
    return (0, $avKww.jsx)("div", (0, $ii97e.default)({}, $a1fc5e316d6c8f08$var$getStyleProps((0, $6PTxo.default)((0, $6PTxo.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "loadingMessage", {
        "menu-notice": true,
        "menu-notice--loading": true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $a1fc5e316d6c8f08$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $a1fc5e316d6c8f08$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $9nHZC.useRef)(null);
    var cleanupRef = (0, $9nHZC.useRef)(null);
    var _useState5 = (0, $9nHZC.useState)($a1fc5e316d6c8f08$var$coercePlacement(menuPlacement)), _useState6 = (0, $gUHnA.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $9nHZC.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $9nHZC.useState)(null), _useState8 = (0, $gUHnA.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $9nHZC.useCallback)(function() {
        if (!controlElement) return;
        var rect = $a1fc5e316d6c8f08$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $05GjO.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $9nHZC.useCallback)(function() {
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $hB0aJ.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: "ResizeObserver" in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $05GjO.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $9nHZC.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $avKww.jsx)("div", (0, $ii97e.default)({
        ref: setMenuPortalElement
    }, $a1fc5e316d6c8f08$var$getStyleProps((0, $6PTxo.default)((0, $6PTxo.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), "menuPortal", {
        "menu-portal": true
    }), innerProps), children);
    return (0, $avKww.jsx)($a1fc5e316d6c8f08$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $lnOmc.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $a1fc5e316d6c8f08$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : undefined,
        pointerEvents: isDisabled ? "none" : undefined,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var $a1fc5e316d6c8f08$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $avKww.jsx)("div", (0, $ii97e.default)({}, $a1fc5e316d6c8f08$var$getStyleProps(props, "container", {
        "--is-disabled": isDisabled,
        "--is-rtl": isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $a1fc5e316d6c8f08$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $6PTxo.default)({
        alignItems: "center",
        display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
        flex: 1,
        flexWrap: "wrap",
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $a1fc5e316d6c8f08$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $avKww.jsx)("div", (0, $ii97e.default)({}, $a1fc5e316d6c8f08$var$getStyleProps(props, "valueContainer", {
        "value-container": true,
        "value-container--is-multi": isMulti,
        "value-container--has-value": hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $a1fc5e316d6c8f08$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var $a1fc5e316d6c8f08$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $avKww.jsx)("div", (0, $ii97e.default)({}, $a1fc5e316d6c8f08$var$getStyleProps(props, "indicatorsContainer", {
        indicators: true
    }), innerProps), children);
};
var $a1fc5e316d6c8f08$var$_templateObject;
var $a1fc5e316d6c8f08$var$_excluded$2 = [
    "size"
], $a1fc5e316d6c8f08$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $a1fc5e316d6c8f08$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $a1fc5e316d6c8f08$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $a1fc5e316d6c8f08$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $hwJZV.default)(_ref, $a1fc5e316d6c8f08$var$_excluded$2);
    return (0, $avKww.jsx)("svg", (0, $ii97e.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $a1fc5e316d6c8f08$var$_ref2
    }, props));
};
var $a1fc5e316d6c8f08$var$CrossIcon = function CrossIcon(props) {
    return (0, $avKww.jsx)($a1fc5e316d6c8f08$var$Svg, (0, $ii97e.default)({
        size: 20
    }, props), (0, $avKww.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $a1fc5e316d6c8f08$var$DownChevron = function DownChevron(props) {
    return (0, $avKww.jsx)($a1fc5e316d6c8f08$var$Svg, (0, $ii97e.default)({
        size: 20
    }, props), (0, $avKww.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $a1fc5e316d6c8f08$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $6PTxo.default)({
        label: "indicatorContainer",
        display: "flex",
        transition: "color 150ms"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $a1fc5e316d6c8f08$export$f1e1789686576879 = $a1fc5e316d6c8f08$var$baseCSS;
var $a1fc5e316d6c8f08$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $avKww.jsx)("div", (0, $ii97e.default)({}, $a1fc5e316d6c8f08$var$getStyleProps(props, "dropdownIndicator", {
        indicator: true,
        "dropdown-indicator": true
    }), innerProps), children || (0, $avKww.jsx)($a1fc5e316d6c8f08$var$DownChevron, null));
};
var $a1fc5e316d6c8f08$export$407448d2b89b1813 = $a1fc5e316d6c8f08$var$baseCSS;
var $a1fc5e316d6c8f08$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $avKww.jsx)("div", (0, $ii97e.default)({}, $a1fc5e316d6c8f08$var$getStyleProps(props, "clearIndicator", {
        indicator: true,
        "clear-indicator": true
    }), innerProps), children || (0, $avKww.jsx)($a1fc5e316d6c8f08$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $a1fc5e316d6c8f08$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $6PTxo.default)({
        label: "indicatorSeparator",
        alignSelf: "stretch",
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $a1fc5e316d6c8f08$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $avKww.jsx)("span", (0, $ii97e.default)({}, innerProps, $a1fc5e316d6c8f08$var$getStyleProps(props, "indicatorSeparator", {
        "indicator-separator": true
    })));
};
// ==============================
// Loading
// ==============================
var $a1fc5e316d6c8f08$var$loadingDotAnimations = (0, $avKww.keyframes)($a1fc5e316d6c8f08$var$_templateObject || ($a1fc5e316d6c8f08$var$_templateObject = (0, $kR9Sl.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $a1fc5e316d6c8f08$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $6PTxo.default)({
        label: "loadingIndicator",
        display: "flex",
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $a1fc5e316d6c8f08$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $avKww.jsx)("span", {
        css: /*#__PURE__*/ (0, $avKww.css)({
            animation: "".concat($a1fc5e316d6c8f08$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : undefined,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, "", "")
    });
};
var $a1fc5e316d6c8f08$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $hwJZV.default)(_ref7, $a1fc5e316d6c8f08$var$_excluded2);
    return (0, $avKww.jsx)("div", (0, $ii97e.default)({}, $a1fc5e316d6c8f08$var$getStyleProps((0, $6PTxo.default)((0, $6PTxo.default)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), "loadingIndicator", {
        indicator: true,
        "loading-indicator": true
    }), innerProps), (0, $avKww.jsx)($a1fc5e316d6c8f08$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $avKww.jsx)($a1fc5e316d6c8f08$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $avKww.jsx)($a1fc5e316d6c8f08$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $a1fc5e316d6c8f08$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $6PTxo.default)({
        label: "control",
        alignItems: "center",
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms"
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $a1fc5e316d6c8f08$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $avKww.jsx)("div", (0, $ii97e.default)({
        ref: innerRef
    }, $a1fc5e316d6c8f08$var$getStyleProps(props, "control", {
        control: true,
        "control--is-disabled": isDisabled,
        "control--is-focused": isFocused,
        "control--menu-is-open": menuIsOpen
    }), innerProps), children);
};
var $a1fc5e316d6c8f08$var$Control$1 = $a1fc5e316d6c8f08$var$Control;
var $a1fc5e316d6c8f08$var$_excluded$1 = [
    "data"
];
var $a1fc5e316d6c8f08$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $a1fc5e316d6c8f08$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $avKww.jsx)("div", (0, $ii97e.default)({}, $a1fc5e316d6c8f08$var$getStyleProps(props, "group", {
        group: true
    }), innerProps), (0, $avKww.jsx)(Heading, (0, $ii97e.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $avKww.jsx)("div", null, children));
};
var $a1fc5e316d6c8f08$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $6PTxo.default)({
        label: "group",
        cursor: "default",
        display: "block"
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: "75%",
        fontWeight: 500,
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    });
};
var $a1fc5e316d6c8f08$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $a1fc5e316d6c8f08$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $hwJZV.default)(_cleanCommonProps, $a1fc5e316d6c8f08$var$_excluded$1);
    return (0, $avKww.jsx)("div", (0, $ii97e.default)({}, $a1fc5e316d6c8f08$var$getStyleProps(props, "groupHeading", {
        "group-heading": true
    }), innerProps));
};
var $a1fc5e316d6c8f08$var$Group$1 = $a1fc5e316d6c8f08$var$Group;
var $a1fc5e316d6c8f08$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $a1fc5e316d6c8f08$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $6PTxo.default)((0, $6PTxo.default)({
        visibility: isDisabled ? "hidden" : "visible",
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? "translateZ(0)" : ""
    }, $a1fc5e316d6c8f08$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $a1fc5e316d6c8f08$var$spacingStyle = {
    gridArea: "1 / 2",
    font: "inherit",
    minWidth: "2px",
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $a1fc5e316d6c8f08$var$containerStyle = {
    flex: "1 1 auto",
    display: "inline-grid",
    gridArea: "1 / 1 / 2 / 3",
    gridTemplateColumns: "0 min-content",
    "&:after": (0, $6PTxo.default)({
        content: 'attr(data-value) " "',
        visibility: "hidden",
        whiteSpace: "pre"
    }, $a1fc5e316d6c8f08$var$spacingStyle)
};
var $a1fc5e316d6c8f08$var$inputStyle = function inputStyle(isHidden) {
    return (0, $6PTxo.default)({
        label: "input",
        color: "inherit",
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: "100%"
    }, $a1fc5e316d6c8f08$var$spacingStyle);
};
var $a1fc5e316d6c8f08$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $a1fc5e316d6c8f08$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $hwJZV.default)(_cleanCommonProps, $a1fc5e316d6c8f08$var$_excluded);
    return (0, $avKww.jsx)("div", (0, $ii97e.default)({}, $a1fc5e316d6c8f08$var$getStyleProps(props, "input", {
        "input-container": true
    }), {
        "data-value": value || ""
    }), (0, $avKww.jsx)("input", (0, $ii97e.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $a1fc5e316d6c8f08$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $a1fc5e316d6c8f08$var$Input$1 = $a1fc5e316d6c8f08$var$Input;
var $a1fc5e316d6c8f08$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $6PTxo.default)({
        label: "multiValue",
        display: "flex",
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $a1fc5e316d6c8f08$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $6PTxo.default)({
        overflow: "hidden",
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? "ellipsis" : undefined,
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        padding: 3,
        paddingLeft: 6
    });
};
var $a1fc5e316d6c8f08$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $6PTxo.default)({
        alignItems: "center",
        display: "flex"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $a1fc5e316d6c8f08$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $avKww.jsx)("div", innerProps, children);
};
var $a1fc5e316d6c8f08$var$MultiValueContainer = $a1fc5e316d6c8f08$var$MultiValueGeneric;
var $a1fc5e316d6c8f08$var$MultiValueLabel = $a1fc5e316d6c8f08$var$MultiValueGeneric;
function $a1fc5e316d6c8f08$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $avKww.jsx)("div", (0, $ii97e.default)({
        role: "button"
    }, innerProps), children || (0, $avKww.jsx)($a1fc5e316d6c8f08$var$CrossIcon, {
        size: 14
    }));
}
var $a1fc5e316d6c8f08$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $avKww.jsx)(Container, {
        data: data,
        innerProps: (0, $6PTxo.default)((0, $6PTxo.default)({}, $a1fc5e316d6c8f08$var$getStyleProps(props, "multiValue", {
            "multi-value": true,
            "multi-value--is-disabled": isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $avKww.jsx)(Label, {
        data: data,
        innerProps: (0, $6PTxo.default)({}, $a1fc5e316d6c8f08$var$getStyleProps(props, "multiValueLabel", {
            "multi-value__label": true
        })),
        selectProps: selectProps
    }, children), (0, $avKww.jsx)(Remove, {
        data: data,
        innerProps: (0, $6PTxo.default)((0, $6PTxo.default)({}, $a1fc5e316d6c8f08$var$getStyleProps(props, "multiValueRemove", {
            "multi-value__remove": true
        })), {}, {
            "aria-label": "Remove ".concat(children || "option")
        }, removeProps),
        selectProps: selectProps
    }));
};
var $a1fc5e316d6c8f08$var$MultiValue$1 = $a1fc5e316d6c8f08$var$MultiValue;
var $a1fc5e316d6c8f08$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $6PTxo.default)({
        label: "option",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $a1fc5e316d6c8f08$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $avKww.jsx)("div", (0, $ii97e.default)({}, $a1fc5e316d6c8f08$var$getStyleProps(props, "option", {
        option: true,
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected": isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $a1fc5e316d6c8f08$var$Option$1 = $a1fc5e316d6c8f08$var$Option;
var $a1fc5e316d6c8f08$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $6PTxo.default)({
        label: "placeholder",
        gridArea: "1 / 1 / 2 / 3"
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $a1fc5e316d6c8f08$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $avKww.jsx)("div", (0, $ii97e.default)({}, $a1fc5e316d6c8f08$var$getStyleProps(props, "placeholder", {
        placeholder: true
    }), innerProps), children);
};
var $a1fc5e316d6c8f08$var$Placeholder$1 = $a1fc5e316d6c8f08$var$Placeholder;
var $a1fc5e316d6c8f08$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $6PTxo.default)({
        label: "singleValue",
        gridArea: "1 / 1 / 2 / 3",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $a1fc5e316d6c8f08$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $avKww.jsx)("div", (0, $ii97e.default)({}, $a1fc5e316d6c8f08$var$getStyleProps(props, "singleValue", {
        "single-value": true,
        "single-value--is-disabled": isDisabled
    }), innerProps), children);
};
var $a1fc5e316d6c8f08$var$SingleValue$1 = $a1fc5e316d6c8f08$var$SingleValue;
var $a1fc5e316d6c8f08$export$db3b6bfb95261072 = {
    ClearIndicator: $a1fc5e316d6c8f08$var$ClearIndicator,
    Control: $a1fc5e316d6c8f08$var$Control$1,
    DropdownIndicator: $a1fc5e316d6c8f08$var$DropdownIndicator,
    DownChevron: $a1fc5e316d6c8f08$var$DownChevron,
    CrossIcon: $a1fc5e316d6c8f08$var$CrossIcon,
    Group: $a1fc5e316d6c8f08$var$Group$1,
    GroupHeading: $a1fc5e316d6c8f08$var$GroupHeading,
    IndicatorsContainer: $a1fc5e316d6c8f08$var$IndicatorsContainer,
    IndicatorSeparator: $a1fc5e316d6c8f08$var$IndicatorSeparator,
    Input: $a1fc5e316d6c8f08$var$Input$1,
    LoadingIndicator: $a1fc5e316d6c8f08$var$LoadingIndicator,
    Menu: $a1fc5e316d6c8f08$var$Menu$1,
    MenuList: $a1fc5e316d6c8f08$var$MenuList,
    MenuPortal: $a1fc5e316d6c8f08$var$MenuPortal,
    LoadingMessage: $a1fc5e316d6c8f08$var$LoadingMessage,
    NoOptionsMessage: $a1fc5e316d6c8f08$var$NoOptionsMessage,
    MultiValue: $a1fc5e316d6c8f08$var$MultiValue$1,
    MultiValueContainer: $a1fc5e316d6c8f08$var$MultiValueContainer,
    MultiValueLabel: $a1fc5e316d6c8f08$var$MultiValueLabel,
    MultiValueRemove: $a1fc5e316d6c8f08$var$MultiValueRemove,
    Option: $a1fc5e316d6c8f08$var$Option$1,
    Placeholder: $a1fc5e316d6c8f08$var$Placeholder$1,
    SelectContainer: $a1fc5e316d6c8f08$var$SelectContainer,
    SingleValue: $a1fc5e316d6c8f08$var$SingleValue$1,
    ValueContainer: $a1fc5e316d6c8f08$var$ValueContainer
};
var $a1fc5e316d6c8f08$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $6PTxo.default)((0, $6PTxo.default)({}, $a1fc5e316d6c8f08$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("gUHnA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c503869329d00681$export$2e2bcd8739ae039; });

var $7eCWA = parcelRequire("7eCWA");

var $aTkmB = parcelRequire("aTkmB");

var $jMlro = parcelRequire("jMlro");

var $4lPlV = parcelRequire("4lPlV");
function $c503869329d00681$export$2e2bcd8739ae039(r, e) {
    return (0, $7eCWA.default)(r) || (0, $aTkmB.default)(r, e) || (0, $jMlro.default)(r, e) || (0, $4lPlV.default)();
}

});
parcelRegister("7eCWA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54480cadce813947$export$2e2bcd8739ae039; });
function $54480cadce813947$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("aTkmB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7eded63d4fe0c4e5$export$2e2bcd8739ae039; });
function $7eded63d4fe0c4e5$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("4lPlV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32b0f5213fb43e8f$export$2e2bcd8739ae039; });
function $32b0f5213fb43e8f$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("hwJZV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc291b067095a3af$export$2e2bcd8739ae039; });

var $4dya5 = parcelRequire("4dya5");
function $cc291b067095a3af$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $4dya5.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});

parcelRegister("kR9Sl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2f06afacdf19252$export$2e2bcd8739ae039; });
function $f2f06afacdf19252$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("hB0aJ", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", function () { return $ccf6069112e566eb$export$deee3a793edee05f; });

var $7t26c = parcelRequire("7t26c");
function $ccf6069112e566eb$var$getWindow(node) {
    var _node$ownerDocument;
    return ((_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $ccf6069112e566eb$var$getComputedStyle$1(element) {
    return $ccf6069112e566eb$var$getWindow(element).getComputedStyle(element);
}
function $ccf6069112e566eb$var$getNodeName(node) {
    return $ccf6069112e566eb$var$isNode(node) ? (node.nodeName || "").toLowerCase() : "";
}
let $ccf6069112e566eb$var$uaString;
function $ccf6069112e566eb$var$getUAString() {
    if ($ccf6069112e566eb$var$uaString) return $ccf6069112e566eb$var$uaString;
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) {
        $ccf6069112e566eb$var$uaString = uaData.brands.map((item)=>item.brand + "/" + item.version).join(" ");
        return $ccf6069112e566eb$var$uaString;
    }
    return navigator.userAgent;
}
function $ccf6069112e566eb$var$isHTMLElement(value) {
    return value instanceof $ccf6069112e566eb$var$getWindow(value).HTMLElement;
}
function $ccf6069112e566eb$var$isElement(value) {
    return value instanceof $ccf6069112e566eb$var$getWindow(value).Element;
}
function $ccf6069112e566eb$var$isNode(value) {
    return value instanceof $ccf6069112e566eb$var$getWindow(value).Node;
}
function $ccf6069112e566eb$var$isShadowRoot(node) {
    // Browsers without `ShadowRoot` support
    if (typeof ShadowRoot === "undefined") return false;
    const OwnElement = $ccf6069112e566eb$var$getWindow(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}
function $ccf6069112e566eb$var$isOverflowElement(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $ccf6069112e566eb$var$getComputedStyle$1(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $ccf6069112e566eb$var$isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($ccf6069112e566eb$var$getNodeName(element));
}
function $ccf6069112e566eb$var$isContainingBlock(element) {
    // TODO: Try and use feature detection here instead
    const isFirefox = /firefox/i.test($ccf6069112e566eb$var$getUAString());
    const css = $ccf6069112e566eb$var$getComputedStyle$1(element);
    const backdropFilter = css.backdropFilter || css.WebkitBackdropFilter;
    // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (backdropFilter ? backdropFilter !== "none" : false) || isFirefox && css.willChange === "filter" || isFirefox && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective"
    ].some((value)=>css.willChange.includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some(// TS 4.1 compat
    (value)=>{
        const contain = css.contain;
        return contain != null ? contain.includes(value) : false;
    });
}
function $ccf6069112e566eb$var$isLayoutViewport() {
    // Not Safari
    return !/^((?!chrome|android).)*safari/i.test($ccf6069112e566eb$var$getUAString());
// Feature detection for this fails in various ways
// • Always-visible scrollbar or not
// • Width of <html>, etc.
// const vV = win.visualViewport;
// return vV ? Math.abs(win.innerWidth / vV.scale - vV.width) < 0.5 : true;
}
function $ccf6069112e566eb$var$isLastTraversableNode(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($ccf6069112e566eb$var$getNodeName(node));
}
const $ccf6069112e566eb$var$min = Math.min;
const $ccf6069112e566eb$var$max = Math.max;
const $ccf6069112e566eb$var$round = Math.round;
function $ccf6069112e566eb$var$getCssDimensions(element) {
    const css = $ccf6069112e566eb$var$getComputedStyle$1(element);
    let width = parseFloat(css.width);
    let height = parseFloat(css.height);
    const offsetWidth = element.offsetWidth;
    const offsetHeight = element.offsetHeight;
    const shouldFallback = $ccf6069112e566eb$var$round(width) !== offsetWidth || $ccf6069112e566eb$var$round(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        fallback: shouldFallback
    };
}
function $ccf6069112e566eb$var$unwrapElement(element) {
    return !$ccf6069112e566eb$var$isElement(element) ? element.contextElement : element;
}
const $ccf6069112e566eb$var$FALLBACK_SCALE = {
    x: 1,
    y: 1
};
function $ccf6069112e566eb$var$getScale(element) {
    const domElement = $ccf6069112e566eb$var$unwrapElement(element);
    if (!$ccf6069112e566eb$var$isHTMLElement(domElement)) return $ccf6069112e566eb$var$FALLBACK_SCALE;
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, fallback: fallback } = $ccf6069112e566eb$var$getCssDimensions(domElement);
    let x = (fallback ? $ccf6069112e566eb$var$round(rect.width) : rect.width) / width;
    let y = (fallback ? $ccf6069112e566eb$var$round(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
function $ccf6069112e566eb$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    var _win$visualViewport, _win$visualViewport2;
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $ccf6069112e566eb$var$unwrapElement(element);
    let scale = $ccf6069112e566eb$var$FALLBACK_SCALE;
    if (includeScale) {
        if (offsetParent) {
            if ($ccf6069112e566eb$var$isElement(offsetParent)) scale = $ccf6069112e566eb$var$getScale(offsetParent);
        } else scale = $ccf6069112e566eb$var$getScale(element);
    }
    const win = domElement ? $ccf6069112e566eb$var$getWindow(domElement) : window;
    const addVisualOffsets = !$ccf6069112e566eb$var$isLayoutViewport() && isFixedStrategy;
    let x = (clientRect.left + (addVisualOffsets ? ((_win$visualViewport = win.visualViewport) == null ? void 0 : _win$visualViewport.offsetLeft) || 0 : 0)) / scale.x;
    let y = (clientRect.top + (addVisualOffsets ? ((_win$visualViewport2 = win.visualViewport) == null ? void 0 : _win$visualViewport2.offsetTop) || 0 : 0)) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = $ccf6069112e566eb$var$getWindow(domElement);
        const offsetWin = offsetParent && $ccf6069112e566eb$var$isElement(offsetParent) ? $ccf6069112e566eb$var$getWindow(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = $ccf6069112e566eb$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = getComputedStyle(currentIFrame);
            iframeRect.x += (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            iframeRect.y += (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += iframeRect.x;
            y += iframeRect.y;
            currentIFrame = $ccf6069112e566eb$var$getWindow(currentIFrame).frameElement;
        }
    }
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}
function $ccf6069112e566eb$var$getDocumentElement(node) {
    return (($ccf6069112e566eb$var$isNode(node) ? node.ownerDocument : node.document) || window.document).documentElement;
}
function $ccf6069112e566eb$var$getNodeScroll(element) {
    if ($ccf6069112e566eb$var$isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $ccf6069112e566eb$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $ccf6069112e566eb$var$getBoundingClientRect($ccf6069112e566eb$var$getDocumentElement(element)).left + $ccf6069112e566eb$var$getNodeScroll(element).scrollLeft;
}
function $ccf6069112e566eb$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = $ccf6069112e566eb$var$isHTMLElement(offsetParent);
    const documentElement = $ccf6069112e566eb$var$getDocumentElement(offsetParent);
    const rect = $ccf6069112e566eb$var$getBoundingClientRect(element, true, strategy === "fixed", offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ($ccf6069112e566eb$var$getNodeName(offsetParent) !== "body" || $ccf6069112e566eb$var$isOverflowElement(documentElement)) scroll = $ccf6069112e566eb$var$getNodeScroll(offsetParent);
        if ($ccf6069112e566eb$var$isHTMLElement(offsetParent)) {
            const offsetRect = $ccf6069112e566eb$var$getBoundingClientRect(offsetParent, true);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $ccf6069112e566eb$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $ccf6069112e566eb$var$getParentNode(node) {
    if ($ccf6069112e566eb$var$getNodeName(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node
    node.assignedSlot || // DOM Element detected
    node.parentNode || // ShadowRoot detected
    ($ccf6069112e566eb$var$isShadowRoot(node) ? node.host : null) || // Fallback
    $ccf6069112e566eb$var$getDocumentElement(node);
    return $ccf6069112e566eb$var$isShadowRoot(result) ? result.host : result;
}
function $ccf6069112e566eb$var$getTrueOffsetParent(element) {
    if (!$ccf6069112e566eb$var$isHTMLElement(element) || $ccf6069112e566eb$var$getComputedStyle$1(element).position === "fixed") return null;
    return element.offsetParent;
}
function $ccf6069112e566eb$var$getContainingBlock(element) {
    let currentNode = $ccf6069112e566eb$var$getParentNode(element);
    while($ccf6069112e566eb$var$isHTMLElement(currentNode) && !$ccf6069112e566eb$var$isLastTraversableNode(currentNode)){
        if ($ccf6069112e566eb$var$isContainingBlock(currentNode)) return currentNode;
        else currentNode = $ccf6069112e566eb$var$getParentNode(currentNode);
    }
    return null;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $ccf6069112e566eb$var$getOffsetParent(element) {
    const window1 = $ccf6069112e566eb$var$getWindow(element);
    let offsetParent = $ccf6069112e566eb$var$getTrueOffsetParent(element);
    while(offsetParent && $ccf6069112e566eb$var$isTableElement(offsetParent) && $ccf6069112e566eb$var$getComputedStyle$1(offsetParent).position === "static")offsetParent = $ccf6069112e566eb$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ($ccf6069112e566eb$var$getNodeName(offsetParent) === "html" || $ccf6069112e566eb$var$getNodeName(offsetParent) === "body" && $ccf6069112e566eb$var$getComputedStyle$1(offsetParent).position === "static" && !$ccf6069112e566eb$var$isContainingBlock(offsetParent))) return window1;
    return offsetParent || $ccf6069112e566eb$var$getContainingBlock(element) || window1;
}
function $ccf6069112e566eb$var$getDimensions(element) {
    return $ccf6069112e566eb$var$getCssDimensions(element);
}
function $ccf6069112e566eb$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isOffsetParentAnElement = $ccf6069112e566eb$var$isHTMLElement(offsetParent);
    const documentElement = $ccf6069112e566eb$var$getDocumentElement(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = {
        x: 1,
        y: 1
    };
    const offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ($ccf6069112e566eb$var$getNodeName(offsetParent) !== "body" || $ccf6069112e566eb$var$isOverflowElement(documentElement)) scroll = $ccf6069112e566eb$var$getNodeScroll(offsetParent);
        if ($ccf6069112e566eb$var$isHTMLElement(offsetParent)) {
            const offsetRect = $ccf6069112e566eb$var$getBoundingClientRect(offsetParent);
            scale = $ccf6069112e566eb$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    // This doesn't appear to need to be negated.
    // else if (documentElement) {
    //   offsets.x = getWindowScrollBarX(documentElement);
    // }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $ccf6069112e566eb$var$getViewportRect(element, strategy) {
    const win = $ccf6069112e566eb$var$getWindow(element);
    const html = $ccf6069112e566eb$var$getDocumentElement(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const layoutViewport = $ccf6069112e566eb$var$isLayoutViewport();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable
function $ccf6069112e566eb$var$getDocumentRect(element) {
    var _element$ownerDocumen;
    const html = $ccf6069112e566eb$var$getDocumentElement(element);
    const scroll = $ccf6069112e566eb$var$getNodeScroll(element);
    const body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    const width = $ccf6069112e566eb$var$max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    const height = $ccf6069112e566eb$var$max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    let x = -scroll.scrollLeft + $ccf6069112e566eb$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ($ccf6069112e566eb$var$getComputedStyle$1(body || html).direction === "rtl") x += $ccf6069112e566eb$var$max(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $ccf6069112e566eb$var$getNearestOverflowAncestor(node) {
    const parentNode = $ccf6069112e566eb$var$getParentNode(node);
    if ($ccf6069112e566eb$var$isLastTraversableNode(parentNode)) // @ts-ignore assume body is always available
    return node.ownerDocument.body;
    if ($ccf6069112e566eb$var$isHTMLElement(parentNode) && $ccf6069112e566eb$var$isOverflowElement(parentNode)) return parentNode;
    return $ccf6069112e566eb$var$getNearestOverflowAncestor(parentNode);
}
function $ccf6069112e566eb$export$3b57c1601291186b(node, list) {
    var _node$ownerDocument;
    if (list === void 0) list = [];
    const scrollableAncestor = $ccf6069112e566eb$var$getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.body);
    const win = $ccf6069112e566eb$var$getWindow(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $ccf6069112e566eb$var$isOverflowElement(scrollableAncestor) ? scrollableAncestor : []);
    return list.concat(scrollableAncestor, $ccf6069112e566eb$export$3b57c1601291186b(scrollableAncestor));
}
// Returns the inner client rect, subtracting scrollbars if present
function $ccf6069112e566eb$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $ccf6069112e566eb$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = $ccf6069112e566eb$var$isHTMLElement(element) ? $ccf6069112e566eb$var$getScale(element) : {
        x: 1,
        y: 1
    };
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y,
        width: width,
        height: height
    };
}
function $ccf6069112e566eb$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    if (clippingAncestor === "viewport") return (0, $7t26c.rectToClientRect)($ccf6069112e566eb$var$getViewportRect(element, strategy));
    if ($ccf6069112e566eb$var$isElement(clippingAncestor)) return $ccf6069112e566eb$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    return (0, $7t26c.rectToClientRect)($ccf6069112e566eb$var$getDocumentRect($ccf6069112e566eb$var$getDocumentElement(element)));
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $ccf6069112e566eb$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = $ccf6069112e566eb$export$3b57c1601291186b(element).filter((el)=>$ccf6069112e566eb$var$isElement(el) && $ccf6069112e566eb$var$getNodeName(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = $ccf6069112e566eb$var$getComputedStyle$1(element).position === "fixed";
    let currentNode = elementIsFixed ? $ccf6069112e566eb$var$getParentNode(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while($ccf6069112e566eb$var$isElement(currentNode) && !$ccf6069112e566eb$var$isLastTraversableNode(currentNode)){
        const computedStyle = $ccf6069112e566eb$var$getComputedStyle$1(currentNode);
        const containingBlock = $ccf6069112e566eb$var$isContainingBlock(currentNode);
        const shouldDropCurrentNode = elementIsFixed ? !containingBlock && !currentContainingBlockComputedStyle : !containingBlock && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position);
        if (shouldDropCurrentNode) // Drop non-containing blocks
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = $ccf6069112e566eb$var$getParentNode(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors
function $ccf6069112e566eb$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $ccf6069112e566eb$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $ccf6069112e566eb$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = $ccf6069112e566eb$var$max(rect.top, accRect.top);
        accRect.right = $ccf6069112e566eb$var$min(rect.right, accRect.right);
        accRect.bottom = $ccf6069112e566eb$var$min(rect.bottom, accRect.bottom);
        accRect.left = $ccf6069112e566eb$var$max(rect.left, accRect.left);
        return accRect;
    }, $ccf6069112e566eb$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
const $ccf6069112e566eb$export$722a64dea1b767dc = {
    getClippingRect: $ccf6069112e566eb$var$getClippingRect,
    convertOffsetParentRelativeRectToViewportRelativeRect: $ccf6069112e566eb$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    isElement: $ccf6069112e566eb$var$isElement,
    getDimensions: $ccf6069112e566eb$var$getDimensions,
    getOffsetParent: $ccf6069112e566eb$var$getOffsetParent,
    getDocumentElement: $ccf6069112e566eb$var$getDocumentElement,
    getScale: $ccf6069112e566eb$var$getScale,
    async getElementRects (_ref) {
        let { reference: reference, floating: floating, strategy: strategy } = _ref;
        const getOffsetParentFn = this.getOffsetParent || $ccf6069112e566eb$var$getOffsetParent;
        const getDimensionsFn = this.getDimensions;
        return {
            reference: $ccf6069112e566eb$var$getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
            floating: {
                x: 0,
                y: 0,
                ...await getDimensionsFn(floating)
            }
        };
    },
    getClientRects: (element)=>Array.from(element.getClientRects()),
    isRTL: (element)=>$ccf6069112e566eb$var$getComputedStyle$1(element).direction === "rtl"
};
/**
 * Automatically updates the position of the floating element when necessary.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $ccf6069112e566eb$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: _ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = true, animationFrame: animationFrame = false } = options;
    const ancestorScroll = _ancestorScroll && !animationFrame;
    const ancestors = ancestorScroll || ancestorResize ? [
        ...$ccf6069112e566eb$var$isElement(reference) ? $ccf6069112e566eb$export$3b57c1601291186b(reference) : reference.contextElement ? $ccf6069112e566eb$export$3b57c1601291186b(reference.contextElement) : [],
        ...$ccf6069112e566eb$export$3b57c1601291186b(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    let observer = null;
    if (elementResize) {
        let initialUpdate = true;
        observer = new ResizeObserver(()=>{
            if (!initialUpdate) update();
            initialUpdate = false;
        });
        $ccf6069112e566eb$var$isElement(reference) && !animationFrame && observer.observe(reference);
        if (!$ccf6069112e566eb$var$isElement(reference) && reference.contextElement && !animationFrame) observer.observe(reference.contextElement);
        observer.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $ccf6069112e566eb$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $ccf6069112e566eb$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _observer;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        (_observer = observer) == null || _observer.disconnect();
        observer = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const $ccf6069112e566eb$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $ccf6069112e566eb$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $7t26c.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("7t26c", function(module, exports) {

$parcel$export(module.exports, "computePosition", function () { return $56fcdea36e6966f4$export$48a53dcb22e581d0; });
$parcel$export(module.exports, "rectToClientRect", function () { return $56fcdea36e6966f4$export$ee05aea0aeecbad4; });
function $56fcdea36e6966f4$var$getAlignment(placement) {
    return placement.split("-")[1];
}
function $56fcdea36e6966f4$var$getLengthFromAxis(axis) {
    return axis === "y" ? "height" : "width";
}
function $56fcdea36e6966f4$var$getSide(placement) {
    return placement.split("-")[0];
}
function $56fcdea36e6966f4$var$getMainAxisFromPlacement(placement) {
    return [
        "top",
        "bottom"
    ].includes($56fcdea36e6966f4$var$getSide(placement)) ? "x" : "y";
}
function $56fcdea36e6966f4$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const mainAxis = $56fcdea36e6966f4$var$getMainAxisFromPlacement(placement);
    const length = $56fcdea36e6966f4$var$getLengthFromAxis(mainAxis);
    const commonAlign = reference[length] / 2 - floating[length] / 2;
    const side = $56fcdea36e6966f4$var$getSide(placement);
    const isVertical = mainAxis === "x";
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch($56fcdea36e6966f4$var$getAlignment(placement)){
        case "start":
            coords[mainAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[mainAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $56fcdea36e6966f4$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    var _ref;
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $56fcdea36e6966f4$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $56fcdea36e6966f4$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
function $56fcdea36e6966f4$var$expandPaddingObject(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $56fcdea36e6966f4$var$getSideObjectFromPadding(padding) {
    return typeof padding !== "number" ? $56fcdea36e6966f4$var$expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $56fcdea36e6966f4$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $56fcdea36e6966f4$export$37b6bde19b108ecc(middlewareArguments, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = middlewareArguments;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = options;
    const paddingObject = $56fcdea36e6966f4$var$getSideObjectFromPadding(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = $56fcdea36e6966f4$export$ee05aea0aeecbad4(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = $56fcdea36e6966f4$export$ee05aea0aeecbad4(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
const $56fcdea36e6966f4$var$min = Math.min;
const $56fcdea36e6966f4$var$max = Math.max;
function $56fcdea36e6966f4$var$within(min$1, value, max$1) {
    return $56fcdea36e6966f4$var$max(min$1, $56fcdea36e6966f4$var$min(value, max$1));
}
/**
 * Positions an inner element of the floating element such that it is centered
 * to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $56fcdea36e6966f4$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (middlewareArguments) {
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = options || {};
            const { x: x, y: y, placement: placement, rects: rects, platform: platform } = middlewareArguments;
            if (element == null) return {};
            const paddingObject = $56fcdea36e6966f4$var$getSideObjectFromPadding(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = $56fcdea36e6966f4$var$getMainAxisFromPlacement(placement);
            const length = $56fcdea36e6966f4$var$getLengthFromAxis(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const minProp = axis === "y" ? "top" : "left";
            const maxProp = axis === "y" ? "bottom" : "right";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
            if (clientSize === 0) clientSize = rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min = paddingObject[minProp];
            const max = clientSize - arrowDimensions[length] - paddingObject[maxProp];
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = $56fcdea36e6966f4$var$within(min, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. This stops `shift()` from taking action, but can
            // be worked around by calling it again after the `arrow()` if desired.
            const shouldAddOffset = $56fcdea36e6966f4$var$getAlignment(placement) != null && center != offset && rects.reference[length] / 2 - (center < min ? paddingObject[minProp] : paddingObject[maxProp]) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min ? min - center : max - center : 0;
            return {
                [axis]: coords[axis] - alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset
                }
            };
        }
    });
const $56fcdea36e6966f4$var$sides = [
    "top",
    "right",
    "bottom",
    "left"
];
const $56fcdea36e6966f4$var$allPlacements = /*#__PURE__*/ $56fcdea36e6966f4$var$sides.reduce((acc, side)=>acc.concat(side, side + "-start", side + "-end"), []);
const $56fcdea36e6966f4$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $56fcdea36e6966f4$var$getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$56fcdea36e6966f4$var$oppositeSideMap[side]);
}
function $56fcdea36e6966f4$var$getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $56fcdea36e6966f4$var$getAlignment(placement);
    const mainAxis = $56fcdea36e6966f4$var$getMainAxisFromPlacement(placement);
    const length = $56fcdea36e6966f4$var$getLengthFromAxis(mainAxis);
    let mainAlignmentSide = mainAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $56fcdea36e6966f4$var$getOppositePlacement(mainAlignmentSide);
    return {
        main: mainAlignmentSide,
        cross: $56fcdea36e6966f4$var$getOppositePlacement(mainAlignmentSide)
    };
}
const $56fcdea36e6966f4$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $56fcdea36e6966f4$var$getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, (alignment)=>$56fcdea36e6966f4$var$oppositeAlignmentMap[alignment]);
}
function $56fcdea36e6966f4$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>$56fcdea36e6966f4$var$getAlignment(placement) === alignment),
        ...allowedPlacements.filter((placement)=>$56fcdea36e6966f4$var$getAlignment(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>$56fcdea36e6966f4$var$getSide(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return $56fcdea36e6966f4$var$getAlignment(placement) === alignment || (autoAlignment ? $56fcdea36e6966f4$var$getOppositeAlignmentPlacement(placement) !== placement : false);
        return true;
    });
}
/**
 * Automatically chooses the `placement` which has the most space available.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $56fcdea36e6966f4$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (middlewareArguments) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsSortedByLe;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = middlewareArguments;
            const { alignment: alignment, allowedPlacements: allowedPlacements = $56fcdea36e6966f4$var$allPlacements, autoAlignment: autoAlignment = true, ...detectOverflowOptions } = options;
            const placements = alignment !== undefined || allowedPlacements === $56fcdea36e6966f4$var$allPlacements ? $56fcdea36e6966f4$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $56fcdea36e6966f4$export$37b6bde19b108ecc(middlewareArguments, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements[currentIndex];
            if (currentPlacement == null) return {};
            const { main: main, cross: cross } = $56fcdea36e6966f4$var$getAlignmentSides(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements[0]
                }
            };
            const currentOverflows = [
                overflow[$56fcdea36e6966f4$var$getSide(currentPlacement)],
                overflow[main],
                overflow[cross]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByLeastOverflow = allOverflows.slice().sort((a, b)=>a.overflows[0] - b.overflows[0]);
            const placementThatFitsOnAllSides = (_placementsSortedByLe = placementsSortedByLeastOverflow.find((_ref)=>{
                let { overflows: overflows } = _ref;
                return overflows.every((overflow)=>overflow <= 0);
            })) == null ? void 0 : _placementsSortedByLe.placement;
            const resetPlacement = placementThatFitsOnAllSides || placementsSortedByLeastOverflow[0].placement;
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
function $56fcdea36e6966f4$var$getExpandedPlacements(placement) {
    const oppositePlacement = $56fcdea36e6966f4$var$getOppositePlacement(placement);
    return [
        $56fcdea36e6966f4$var$getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        $56fcdea36e6966f4$var$getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function $56fcdea36e6966f4$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $56fcdea36e6966f4$var$getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    const alignment = $56fcdea36e6966f4$var$getAlignment(placement);
    let list = $56fcdea36e6966f4$var$getSideList($56fcdea36e6966f4$var$getSide(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($56fcdea36e6966f4$var$getOppositeAlignmentPlacement));
    }
    return list;
}
/**
 * Changes the placement of the floating element to one that will fit if the
 * initially specified `placement` does not.
 * @see https://floating-ui.com/docs/flip
 */ const $56fcdea36e6966f4$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (middlewareArguments) {
            var _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = middlewareArguments;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = options;
            const side = $56fcdea36e6966f4$var$getSide(placement);
            const isBasePlacement = $56fcdea36e6966f4$var$getSide(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                $56fcdea36e6966f4$var$getOppositePlacement(initialPlacement)
            ] : $56fcdea36e6966f4$var$getExpandedPlacements(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...$56fcdea36e6966f4$var$getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $56fcdea36e6966f4$export$37b6bde19b108ecc(middlewareArguments, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const { main: main, cross: cross } = $56fcdea36e6966f4$var$getAlignmentSides(placement, rects, rtl);
                overflows.push(overflow[main], overflow[cross]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                let resetPlacement = "bottom";
                switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0].placement;
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $56fcdea36e6966f4$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $56fcdea36e6966f4$var$isAnySideFullyClipped(overflow) {
    return $56fcdea36e6966f4$var$sides.some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $56fcdea36e6966f4$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (middlewareArguments) {
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = options;
            const { rects: rects } = middlewareArguments;
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $56fcdea36e6966f4$export$37b6bde19b108ecc(middlewareArguments, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $56fcdea36e6966f4$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $56fcdea36e6966f4$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $56fcdea36e6966f4$export$37b6bde19b108ecc(middlewareArguments, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $56fcdea36e6966f4$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $56fcdea36e6966f4$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $56fcdea36e6966f4$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (middlewareArguments) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = middlewareArguments;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = options;
            const fallback = $56fcdea36e6966f4$export$ee05aea0aeecbad4(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
                rect: rects.reference,
                offsetParent: await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating)),
                strategy: strategy
            }) : rects.reference);
            const clientRects = await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || [];
            const paddingObject = $56fcdea36e6966f4$var$getSideObjectFromPadding(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ($56fcdea36e6966f4$var$getMainAxisFromPlacement(placement) === "x") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = $56fcdea36e6966f4$var$getSide(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = $56fcdea36e6966f4$var$getSide(placement) === "left";
                    const maxRight = $56fcdea36e6966f4$var$max(...clientRects.map((rect)=>rect.right));
                    const minLeft = $56fcdea36e6966f4$var$min(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
async function $56fcdea36e6966f4$var$convertValueToCoords(middlewareArguments, value) {
    const { placement: placement, platform: platform, elements: elements } = middlewareArguments;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = $56fcdea36e6966f4$var$getSide(placement);
    const alignment = $56fcdea36e6966f4$var$getAlignment(placement);
    const isVertical = $56fcdea36e6966f4$var$getMainAxisFromPlacement(placement) === "x";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = typeof value === "function" ? value(middlewareArguments) : value;
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Displaces the floating element from its reference element.
 * @see https://floating-ui.com/docs/offset
 */ const $56fcdea36e6966f4$export$cc800923e997bb8 = function(value) {
    if (value === void 0) value = 0;
    return {
        name: "offset",
        options: value,
        async fn (middlewareArguments) {
            const { x: x, y: y } = middlewareArguments;
            const diffCoords = await $56fcdea36e6966f4$var$convertValueToCoords(middlewareArguments, value);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
function $56fcdea36e6966f4$var$getCrossAxis(axis) {
    return axis === "x" ? "y" : "x";
}
/**
 * Shifts the floating element in order to keep it in view when it will overflow
 * a clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $56fcdea36e6966f4$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (middlewareArguments) {
            const { x: x, y: y, placement: placement } = middlewareArguments;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = options;
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $56fcdea36e6966f4$export$37b6bde19b108ecc(middlewareArguments, detectOverflowOptions);
            const mainAxis = $56fcdea36e6966f4$var$getMainAxisFromPlacement($56fcdea36e6966f4$var$getSide(placement));
            const crossAxis = $56fcdea36e6966f4$var$getCrossAxis(mainAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = $56fcdea36e6966f4$var$within(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = $56fcdea36e6966f4$var$within(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...middlewareArguments,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $56fcdea36e6966f4$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (middlewareArguments) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = middlewareArguments;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = options;
            const coords = {
                x: x,
                y: y
            };
            const mainAxis = $56fcdea36e6966f4$var$getMainAxisFromPlacement(placement);
            const crossAxis = $56fcdea36e6966f4$var$getCrossAxis(mainAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = typeof offset === "function" ? offset(middlewareArguments) : offset;
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes($56fcdea36e6966f4$var$getSide(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data to change the size of the floating element. For instance,
 * prevent it from overflowing its clipping boundary or match the width of the
 * reference element.
 * @see https://floating-ui.com/docs/size
 */ const $56fcdea36e6966f4$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (middlewareArguments) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = middlewareArguments;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = options;
            const overflow = await $56fcdea36e6966f4$export$37b6bde19b108ecc(middlewareArguments, detectOverflowOptions);
            const side = $56fcdea36e6966f4$var$getSide(placement);
            const alignment = $56fcdea36e6966f4$var$getAlignment(placement);
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const xMin = $56fcdea36e6966f4$var$max(overflow.left, 0);
            const xMax = $56fcdea36e6966f4$var$max(overflow.right, 0);
            const yMin = $56fcdea36e6966f4$var$max(overflow.top, 0);
            const yMax = $56fcdea36e6966f4$var$max(overflow.bottom, 0);
            const dimensions = {
                availableHeight: rects.floating.height - ([
                    "left",
                    "right"
                ].includes(placement) ? 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : $56fcdea36e6966f4$var$max(overflow.top, overflow.bottom)) : overflow[heightSide]),
                availableWidth: rects.floating.width - ([
                    "top",
                    "bottom"
                ].includes(placement) ? 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : $56fcdea36e6966f4$var$max(overflow.left, overflow.right)) : overflow[widthSide])
            };
            await apply({
                ...middlewareArguments,
                ...dimensions
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (rects.floating.width !== nextDimensions.width || rects.floating.height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});


parcelRegister("05GjO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00046870dd6cdcbb$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");
var $00046870dd6cdcbb$var$index = (0, $9nHZC.useLayoutEffect);
var $00046870dd6cdcbb$export$2e2bcd8739ae039 = $00046870dd6cdcbb$var$index;

});


parcelRegister("aLjj6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d5d45225a27172d$export$2e2bcd8739ae039; });
var $7d5d45225a27172d$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $7d5d45225a27172d$var$isEqual(first, second) {
    if (first === second) return true;
    if ($7d5d45225a27172d$var$safeIsNaN(first) && $7d5d45225a27172d$var$safeIsNaN(second)) return true;
    return false;
}
function $7d5d45225a27172d$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$7d5d45225a27172d$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $7d5d45225a27172d$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $7d5d45225a27172d$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("9IkcK", function(module, exports) {

$parcel$export(module.exports, "u", function () { return $7127e54fd390e204$export$3b14a55fb2447963; });

var $14L3Y = parcelRequire("14L3Y");

var $6PTxo = parcelRequire("6PTxo");

var $gUHnA = parcelRequire("gUHnA");

var $hwJZV = parcelRequire("hwJZV");

var $9nHZC = parcelRequire("9nHZC");

var $dUfie = parcelRequire("dUfie");
var $7127e54fd390e204$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $7127e54fd390e204$export$3b14a55fb2447963(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions;
    _ref.options;
    var _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, $hwJZV.default)(_ref, $7127e54fd390e204$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $9nHZC.useRef)(undefined);
    var mounted = (0, $9nHZC.useRef)(false);
    var _useState = (0, $9nHZC.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, $gUHnA.default)(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $9nHZC.useState)(typeof propsInputValue !== "undefined" ? propsInputValue : ""), _useState4 = (0, $gUHnA.default)(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $9nHZC.useState)(propsDefaultOptions === true), _useState6 = (0, $gUHnA.default)(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $9nHZC.useState)(undefined), _useState8 = (0, $gUHnA.default)(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $9nHZC.useState)([]), _useState10 = (0, $gUHnA.default)(_useState9, 2), loadedOptions = _useState10[0], setLoadedOptions = _useState10[1];
    var _useState11 = (0, $9nHZC.useState)(false), _useState12 = (0, $gUHnA.default)(_useState11, 2), passEmptyOptions = _useState12[0], setPassEmptyOptions = _useState12[1];
    var _useState13 = (0, $9nHZC.useState)({}), _useState14 = (0, $gUHnA.default)(_useState13, 2), optionsCache = _useState14[0], setOptionsCache = _useState14[1];
    var _useState15 = (0, $9nHZC.useState)(undefined), _useState16 = (0, $gUHnA.default)(_useState15, 2), prevDefaultOptions = _useState16[0], setPrevDefaultOptions = _useState16[1];
    var _useState17 = (0, $9nHZC.useState)(undefined), _useState18 = (0, $gUHnA.default)(_useState17, 2), prevCacheOptions = _useState18[0], setPrevCacheOptions = _useState18[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $9nHZC.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $9nHZC.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === "function") loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $9nHZC.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $9nHZC.useCallback)(function(newValue, actionMeta) {
        var inputValue = (0, $dUfie.L)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue("");
            setLoadedInputValue("");
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? (0, $6PTxo.default)((0, $6PTxo.default)({}, optionsCache), {}, (0, $14L3Y.default)({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return (0, $6PTxo.default)((0, $6PTxo.default)({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}

});

parcelRegister("kIN0M", function(module, exports) {

$parcel$export(module.exports, "u", function () { return $f15def6226eac7fb$export$3b14a55fb2447963; });

var $6PTxo = parcelRequire("6PTxo");

var $gUHnA = parcelRequire("gUHnA");

var $hwJZV = parcelRequire("hwJZV");

var $9nHZC = parcelRequire("9nHZC");
var $f15def6226eac7fb$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $f15def6226eac7fb$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $hwJZV.default)(_ref, $f15def6226eac7fb$var$_excluded);
    var _useState = (0, $9nHZC.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $gUHnA.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $9nHZC.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $gUHnA.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $9nHZC.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $gUHnA.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $9nHZC.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $9nHZC.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $9nHZC.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $9nHZC.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $6PTxo.default)((0, $6PTxo.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});

parcelRegister("fMDCD", function(module, exports) {

$parcel$export(module.exports, "u", function () { return $b7da12d6e16a2f0e$export$3b14a55fb2447963; });

var $6PTxo = parcelRequire("6PTxo");

var $8i6ZY = parcelRequire("8i6ZY");

var $hwJZV = parcelRequire("hwJZV");

var $9nHZC = parcelRequire("9nHZC");

var $dUfie = parcelRequire("dUfie");

var $bpHvF = parcelRequire("bpHvF");
var $b7da12d6e16a2f0e$var$_excluded = [
    "allowCreateWhileLoading",
    "createOptionPosition",
    "formatCreateLabel",
    "isValidNewOption",
    "getNewOptionData",
    "onCreateOption",
    "options",
    "onChange"
];
var $b7da12d6e16a2f0e$var$compareOption = function compareOption() {
    var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var option = arguments.length > 1 ? arguments[1] : undefined;
    var accessors = arguments.length > 2 ? arguments[2] : undefined;
    var candidate = String(inputValue).toLowerCase();
    var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
var $b7da12d6e16a2f0e$var$builtins = {
    formatCreateLabel: function formatCreateLabel(inputValue) {
        return 'Create "'.concat(inputValue, '"');
    },
    isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
        return !(!inputValue || selectValue.some(function(option) {
            return $b7da12d6e16a2f0e$var$compareOption(inputValue, option, accessors);
        }) || selectOptions.some(function(option) {
            return $b7da12d6e16a2f0e$var$compareOption(inputValue, option, accessors);
        }));
    },
    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
        return {
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        };
    }
};
function $b7da12d6e16a2f0e$export$3b14a55fb2447963(_ref) {
    var _ref$allowCreateWhile = _ref.allowCreateWhileLoading, allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile, _ref$createOptionPosi = _ref.createOptionPosition, createOptionPosition = _ref$createOptionPosi === void 0 ? "last" : _ref$createOptionPosi, _ref$formatCreateLabe = _ref.formatCreateLabel, formatCreateLabel = _ref$formatCreateLabe === void 0 ? $b7da12d6e16a2f0e$var$builtins.formatCreateLabel : _ref$formatCreateLabe, _ref$isValidNewOption = _ref.isValidNewOption, isValidNewOption = _ref$isValidNewOption === void 0 ? $b7da12d6e16a2f0e$var$builtins.isValidNewOption : _ref$isValidNewOption, _ref$getNewOptionData = _ref.getNewOptionData, getNewOptionData = _ref$getNewOptionData === void 0 ? $b7da12d6e16a2f0e$var$builtins.getNewOptionData : _ref$getNewOptionData, onCreateOption = _ref.onCreateOption, _ref$options = _ref.options, propsOptions = _ref$options === void 0 ? [] : _ref$options, propsOnChange = _ref.onChange, restSelectProps = (0, $hwJZV.default)(_ref, $b7da12d6e16a2f0e$var$_excluded);
    var _restSelectProps$getO = restSelectProps.getOptionValue, getOptionValue$1 = _restSelectProps$getO === void 0 ? (0, $bpHvF.g) : _restSelectProps$getO, _restSelectProps$getO2 = restSelectProps.getOptionLabel, getOptionLabel$1 = _restSelectProps$getO2 === void 0 ? (0, $bpHvF.b) : _restSelectProps$getO2, inputValue = restSelectProps.inputValue, isLoading = restSelectProps.isLoading, isMulti = restSelectProps.isMulti, value = restSelectProps.value, name = restSelectProps.name;
    var newOption = (0, $9nHZC.useMemo)(function() {
        return isValidNewOption(inputValue, (0, $dUfie.H)(value), propsOptions, {
            getOptionValue: getOptionValue$1,
            getOptionLabel: getOptionLabel$1
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined;
    }, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel$1,
        getOptionValue$1,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    var options = (0, $9nHZC.useMemo)(function() {
        return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === "first" ? [
            newOption
        ].concat((0, $8i6ZY.default)(propsOptions)) : [].concat((0, $8i6ZY.default)(propsOptions), [
            newOption
        ]) : propsOptions;
    }, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    var onChange = (0, $9nHZC.useCallback)(function(newValue, actionMeta) {
        if (actionMeta.action !== "select-option") return propsOnChange(newValue, actionMeta);
        var valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                var newOptionData = getNewOptionData(inputValue, inputValue);
                var newActionMeta = {
                    action: "create-option",
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $dUfie.D)(isMulti, [].concat((0, $8i6ZY.default)((0, $dUfie.H)(value)), [
                    newOptionData
                ]), newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return (0, $6PTxo.default)((0, $6PTxo.default)({}, restSelectProps), {}, {
        options: options,
        onChange: onChange
    });
}

});

parcelRegister("aHkQz", function(module, exports) {

var $kFnE9 = parcelRequire("kFnE9");
function $7c9e1748529c522d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7c9e1748529c522d$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7c9e1748529c522d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $kFnE9(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7c9e1748529c522d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $7c9e1748529c522d$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("d7Kxt", function(module, exports) {

var $lH0U2 = parcelRequire("lH0U2");

var $ajVGk = parcelRequire("ajVGk");

var $ck3YL = parcelRequire("ck3YL");
function $98e0077323c719e3$var$_createSuper(t) {
    var r = $ajVGk();
    return function() {
        var e, o = $lH0U2(t);
        if (r) {
            var s = $lH0U2(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return $ck3YL(this, e);
    };
}
module.exports = $98e0077323c719e3$var$_createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("i04lD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1ab9981418bc0d7$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $bpHvF = parcelRequire("bpHvF");

var $5PuRn = parcelRequire("5PuRn");

var $fIcbc = parcelRequire("fIcbc");

var $gskq0 = parcelRequire("gskq0");

var $73aTe = parcelRequire("73aTe");
var $a4s08 = parcelRequire("a4s08");

var $db14O = parcelRequire("db14O");

var $jkxw3 = parcelRequire("jkxw3");
var $d1ab9981418bc0d7$var$_excluded = [
    "styles",
    "validationState",
    "isInvalid",
    "spacing",
    "isMulti",
    "appearance",
    "ariaLiveMessages"
];
function $d1ab9981418bc0d7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d1ab9981418bc0d7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d1ab9981418bc0d7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d1ab9981418bc0d7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d1ab9981418bc0d7$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d1ab9981418bc0d7$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $d1ab9981418bc0d7$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d1ab9981418bc0d7$export$2e2bcd8739ae039(WrappedComponent) {
    var _class;
    return _class = /*#__PURE__*/ function(_Component) {
        (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(AtlaskitSelect, _Component);
        var _super = $d1ab9981418bc0d7$var$_createSuper(AtlaskitSelect);
        function AtlaskitSelect(props) {
            var _this;
            (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AtlaskitSelect);
            _this = _super.call(this, props);
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "components", {});
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "select", null);
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "cacheComponents", function(components) {
                _this.components = $d1ab9981418bc0d7$var$_objectSpread({
                    ClearIndicator: (0, $73aTe.ClearIndicator) ? (0, $73aTe.ClearIndicator) : undefined,
                    DropdownIndicator: (0, $73aTe.DropdownIndicator),
                    LoadingIndicator: (0, $73aTe.LoadingIndicator),
                    MultiValueRemove: (0, $a4s08.MultiValueRemove),
                    IndicatorSeparator: (0, $a4s08.IndicatorSeparator)
                }, components);
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onSelectRef", function(ref) {
                _this.select = ref;
            });
            _this.cacheComponents = (0, $5PuRn.default)(_this.cacheComponents, (0, (/*@__PURE__*/$parcel$interopDefault($fIcbc)))).bind((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this));
            _this.cacheComponents(props.components || {});
            return _this;
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AtlaskitSelect, [
            {
                key: "UNSAFE_componentWillReceiveProps",
                value: function UNSAFE_componentWillReceiveProps(nextProps) {
                    this.cacheComponents(nextProps.components);
                }
            },
            {
                key: "focus",
                value: function focus() {
                    if (this.select) this.select.focus();
                }
            },
            {
                key: "blur",
                value: function blur() {
                    if (this.select) this.select.blur();
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$props = this.props, styles = _this$props.styles, validationState = _this$props.validationState, isInvalid = _this$props.isInvalid, spacing = _this$props.spacing, isMulti = _this$props.isMulti, appearance = _this$props.appearance, ariaLiveMessages = _this$props.ariaLiveMessages, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_this$props, $d1ab9981418bc0d7$var$_excluded);
                    var isCompact = spacing === "compact";
                    // props must be spread first to stop `components` being overridden
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                        ref: this.onSelectRef,
                        isMulti: isMulti,
                        "aria-live": "assertive",
                        ariaLiveMessages: (0, $jkxw3.isOptionsGrouped)(this.props.options) ? $d1ab9981418bc0d7$var$_objectSpread({
                            onFocus: (0, $jkxw3.onFocus)
                        }, ariaLiveMessages) : $d1ab9981418bc0d7$var$_objectSpread({}, ariaLiveMessages)
                    }, props, {
                        components: this.components,
                        styles: (0, $bpHvF.m)((0, $db14O.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
                        typeof isInvalid !== "undefined" ? isInvalid ? "error" : "default" : validationState, isCompact, this.props.appearance || "default"), styles)
                    }));
                }
            }
        ]);
        return AtlaskitSelect;
    }((0, $9nHZC.Component)), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_class, "defaultProps", {
        validationState: "default",
        // TODO: uncomment the next line when cleaning up validationState prop so it has a default value
        // isInvalid: false,
        spacing: "default",
        onClickPreventDefault: true,
        tabSelectsValue: false,
        components: {
            Input: (0, $gskq0.Input)
        },
        styles: {}
    }), _class;
}

});
parcelRegister("5PuRn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43e9a752bbd56f67$export$2e2bcd8739ae039; });
var $43e9a752bbd56f67$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $43e9a752bbd56f67$var$isEqual(first, second) {
    if (first === second) return true;
    if ($43e9a752bbd56f67$var$safeIsNaN(first) && $43e9a752bbd56f67$var$safeIsNaN(second)) return true;
    return false;
}
function $43e9a752bbd56f67$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$43e9a752bbd56f67$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $43e9a752bbd56f67$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $43e9a752bbd56f67$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});

parcelRegister("gskq0", function(module, exports) {

$parcel$export(module.exports, "Input", function () { return $bfaf19880baf9a13$export$f5b8910cec6cf069; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $dUfie = parcelRequire("dUfie");
var $bfaf19880baf9a13$export$f5b8910cec6cf069 = function Input(props) {
    var passed_describedby = props.selectProps["aria-describedby"];
    var describedby = props["aria-describedby"] + (passed_describedby ? " " + passed_describedby : "");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dUfie.c).Input, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        "aria-describedby": describedby
    }));
};

});

parcelRegister("73aTe", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", function () { return $522142b2a9240f13$export$ecf9cf59142dd54a; });
$parcel$export(module.exports, "DropdownIndicator", function () { return $522142b2a9240f13$export$ec98719d3db7f2e4; });
$parcel$export(module.exports, "LoadingIndicator", function () { return $522142b2a9240f13$export$7c20be4c1d342248; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $dUfie = parcelRequire("dUfie");

var $dEKDm = parcelRequire("dEKDm");

var $cXQdn = parcelRequire("cXQdn");

var $9ksjb = parcelRequire("9ksjb");
function $522142b2a9240f13$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $522142b2a9240f13$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $522142b2a9240f13$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $522142b2a9240f13$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $522142b2a9240f13$var$iconContainerStyles = (0, $avKww.css)({
    all: "unset",
    outline: "revert",
    display: "flex",
    alignItems: "center"
});
var $522142b2a9240f13$export$ecf9cf59142dd54a = function ClearIndicator(props) {
    return (0, $avKww.jsx)((0, $dUfie.c).ClearIndicator, $522142b2a9240f13$var$_objectSpread($522142b2a9240f13$var$_objectSpread({}, props), {}, {
        innerProps: $522142b2a9240f13$var$_objectSpread($522142b2a9240f13$var$_objectSpread({}, props.innerProps), {}, {
            "aria-hidden": "false"
        })
    }), (0, $avKww.jsx)("button", {
        css: $522142b2a9240f13$var$iconContainerStyles,
        type: "button",
        tabIndex: -1
    }, (0, $avKww.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cXQdn))), {
        size: "small",
        label: "clear"
    })));
};
var $522142b2a9240f13$export$ec98719d3db7f2e4 = function DropdownIndicator(props) {
    return (0, $avKww.jsx)((0, $dUfie.c).DropdownIndicator, props, (0, $avKww.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9ksjb))), {
        label: "open"
    }));
};
var $522142b2a9240f13$export$7c20be4c1d342248 = function LoadingIndicator(props) {
    var loadingStyles = (0, $avKww.css)(props.getStyles("loadingIndicator", props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    (0, $avKww.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        css: loadingStyles
    }, props.innerProps), (0, $avKww.jsx)((0, $dEKDm.default), {
        size: "small"
    })));
};

});
parcelRegister("cXQdn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $97037f7d1a1197ef$var$_react = $97037f7d1a1197ef$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $bNByA = parcelRequire("bNByA");
function $97037f7d1a1197ef$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $97037f7d1a1197ef$var$SelectClearIcon = (props)=>/*#__PURE__*/ $97037f7d1a1197ef$var$_react.default.createElement($bNByA.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="9"/><path d="M16.155 14.493a1.174 1.174 0 11-1.662 1.663L12 13.662l-2.494 2.494a1.172 1.172 0 01-1.662 0 1.176 1.176 0 010-1.663L10.337 12 7.844 9.507a1.176 1.176 0 011.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 111.662 1.662L13.662 12l2.493 2.493z" fill="inherit"/></g></svg>`
    }, props));
$97037f7d1a1197ef$var$SelectClearIcon.displayName = "SelectClearIcon";
var $97037f7d1a1197ef$var$_default = $97037f7d1a1197ef$var$SelectClearIcon;
module.exports.default = $97037f7d1a1197ef$var$_default;

});
parcelRegister("bNByA", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $89716756f2debb13$export$f04a61298a47a40f; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $5LVXk = parcelRequire("5LVXk");

var $5uH7Z = parcelRequire("5uH7Z");

var $fLJ2x = parcelRequire("fLJ2x");
function $89716756f2debb13$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $89716756f2debb13$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $89716756f2debb13$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $89716756f2debb13$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $89716756f2debb13$var$iconStyles = (0, $avKww.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "> svg": $89716756f2debb13$var$_objectSpread($89716756f2debb13$var$_objectSpread({}, (0, $fLJ2x.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $89716756f2debb13$var$baseHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $89716756f2debb13$var$primaryEqualsSecondaryHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $89716756f2debb13$var$secondaryTransparentHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $89716756f2debb13$export$f04a61298a47a40f = /*#__PURE__*/ (0, $9nHZC.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $avKww.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $fLJ2x.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    var _useGlobalTheme = (0, $5LVXk.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $avKww.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            "--icon-secondary-color": secondaryColor || (0, $5uH7Z.getBackground)(mode)
        }
    }, glyphProps, {
        css: [
            $89716756f2debb13$var$iconStyles,
            $89716756f2debb13$var$baseHcmStyles,
            primaryColor === secondaryColor && $89716756f2debb13$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $89716756f2debb13$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsualting them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $avKww.css)({
                width: dimensions.width,
                height: dimensions.height,
                "> svg": dimensions
            })
        ]
    }));
});
var $89716756f2debb13$export$2e2bcd8739ae039 = $89716756f2debb13$export$f04a61298a47a40f;

});
parcelRegister("5uH7Z", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $4001356682f43e77$export$18cb9425622d4e06; });
var $4001356682f43e77$var$themedBackground = {
    light: "var(--ds-surface, #FFFFFF)",
    dark: "var(--ds-surface, #1B2638)"
};
var $4001356682f43e77$export$18cb9425622d4e06 = function getBackground() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "light";
    return $4001356682f43e77$var$themedBackground[mode];
};

});

parcelRegister("fLJ2x", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $b7ae2eca591f2245$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $b7ae2eca591f2245$export$3eb7d6130acfda37; });

var $efgfA = parcelRequire("efgfA");

var $avKww = parcelRequire("avKww");
var $b7ae2eca591f2245$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
var $b7ae2eca591f2245$var$smallStyles = (0, $avKww.css)((0, $efgfA.dimensions).small);
var $b7ae2eca591f2245$var$mediumStyles = (0, $avKww.css)((0, $efgfA.dimensions).medium);
var $b7ae2eca591f2245$var$largeStyles = (0, $avKww.css)((0, $efgfA.dimensions).large);
var $b7ae2eca591f2245$var$xlargeStyles = (0, $avKww.css)((0, $efgfA.dimensions).xlarge);
var $b7ae2eca591f2245$export$ef0ad74202575b64 = {
    small: $b7ae2eca591f2245$var$smallStyles,
    medium: $b7ae2eca591f2245$var$mediumStyles,
    large: $b7ae2eca591f2245$var$largeStyles,
    xlarge: $b7ae2eca591f2245$var$xlargeStyles
};
var $b7ae2eca591f2245$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $efgfA.dimensions)[size];
    return undefined;
};

});
parcelRegister("efgfA", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $a5ef126831302114$export$62ad7b0c781000e9; });
var $a5ef126831302114$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $a5ef126831302114$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $a5ef126831302114$export$62ad7b0c781000e9 = {
    small: {
        width: $a5ef126831302114$export$c647cb0ee6e282fe.small,
        height: $a5ef126831302114$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $a5ef126831302114$export$c647cb0ee6e282fe.medium,
        height: $a5ef126831302114$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $a5ef126831302114$export$c647cb0ee6e282fe.large,
        height: $a5ef126831302114$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $a5ef126831302114$export$c647cb0ee6e282fe.xlarge,
        height: $a5ef126831302114$export$c647cb0ee6e282fe.xlarge
    }
};

});




parcelRegister("9ksjb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6cabf0c70b1a3500$var$_react = $6cabf0c70b1a3500$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $bNByA = parcelRequire("bNByA");
function $6cabf0c70b1a3500$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6cabf0c70b1a3500$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $6cabf0c70b1a3500$var$_react.default.createElement($bNByA.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M8.292 10.293a1.009 1.009 0 000 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 000-1.419.987.987 0 00-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 00-1.406 0z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$6cabf0c70b1a3500$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $6cabf0c70b1a3500$var$_default = $6cabf0c70b1a3500$var$ChevronDownIcon;
module.exports.default = $6cabf0c70b1a3500$var$_default;

});


parcelRegister("a4s08", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", function () { return $754fff8d46d97a35$export$8e1fd1a40e7a2f4a; });
$parcel$export(module.exports, "IndicatorSeparator", function () { return $754fff8d46d97a35$export$bd638c2ba7915668; });
/** @jsx jsx */ 
var $avKww = parcelRequire("avKww");

var $cXQdn = parcelRequire("cXQdn");

var $dUfie = parcelRequire("dUfie");

var $73aTe = parcelRequire("73aTe");
var $754fff8d46d97a35$var$disabledStyles = (0, $avKww.css)({
    display: "none"
});
var $754fff8d46d97a35$var$enabledStyles = (0, $avKww.css)({
    display: "inherit"
});
var $754fff8d46d97a35$export$8e1fd1a40e7a2f4a = function MultiValueRemove(props) {
    var isDisabled = props.selectProps.isDisabled;
    return (0, $avKww.jsx)((0, $dUfie.c).MultiValueRemove, props, (0, $avKww.jsx)("div", {
        css: isDisabled ? $754fff8d46d97a35$var$disabledStyles : $754fff8d46d97a35$var$enabledStyles,
        "data-testid": isDisabled ? "hide-clear-icon" : "show-clear-icon"
    }, (0, $avKww.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cXQdn))), {
        label: "Clear",
        size: "small",
        primaryColor: "transparent",
        secondaryColor: "inherit"
    })));
};
var $754fff8d46d97a35$export$bd638c2ba7915668 = null;

});

parcelRegister("db14O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $997d2341e726882e$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $aP6k3 = parcelRequire("aP6k3");

var $dEQSq = parcelRequire("dEQSq");

var $jp7ng = parcelRequire("jp7ng");
function $997d2341e726882e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $997d2341e726882e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $997d2341e726882e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $997d2341e726882e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $997d2341e726882e$var$BORDER_WIDTH = 2;
var $997d2341e726882e$var$ICON_PADDING = 2;
var $997d2341e726882e$var$paddingExcludingBorder = (0, $aP6k3.gridSize)() - $997d2341e726882e$var$BORDER_WIDTH;
function $997d2341e726882e$export$2e2bcd8739ae039(validationState) {
    var isCompact = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var appearance = arguments.length > 2 ? arguments[2] : undefined;
    return {
        container: function container(css, _ref) {
            var isDisabled = _ref.isDisabled;
            return $997d2341e726882e$var$_objectSpread($997d2341e726882e$var$_objectSpread({}, css), {}, {
                fontFamily: "var(--ds-font-family-sans, ".concat((0, $aP6k3.fontFamily)(), ")"),
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: "all",
                cursor: isDisabled ? "not-allowed" : css.cursor
            });
        },
        input: function input(css) {
            return $997d2341e726882e$var$_objectSpread($997d2341e726882e$var$_objectSpread({}, css), {}, {
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            });
        },
        control: function control(css, _ref2) {
            var isFocused = _ref2.isFocused, isDisabled = _ref2.isDisabled;
            var borderColor = isFocused ? "var(--ds-border-focused, ".concat((0, $jp7ng.B100), ")") : "var(--ds-border-input, ".concat((0, $dEQSq.getBooleanFF)("platform.design-system-team.border-checkbox_nyoiu") ? (0, $jp7ng.N100) : (0, $jp7ng.N20), ")");
            var backgroundColor = isFocused ? "var(--ds-background-input-pressed, ".concat((0, $jp7ng.N0), ")") : "var(--ds-background-input, ".concat((0, $jp7ng.N20), ")");
            var backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, ".concat((0, $jp7ng.N0), ")") : "var(--ds-background-input-hovered, ".concat((0, $jp7ng.N30), ")");
            if (isDisabled) {
                backgroundColor = "var(--ds-background-disabled, ".concat((0, $jp7ng.N20), ")");
                borderColor = "var(--ds-background-disabled, ".concat((0, $jp7ng.N20), ")");
            }
            if (validationState === "error") borderColor = "var(--ds-border-danger, ".concat((0, $jp7ng.R400), ")");
            if (validationState === "success") borderColor = "var(--ds-border-success, ".concat((0, $jp7ng.G400), ")");
            var borderColorHover = isFocused ? "var(--ds-border-focused, ".concat((0, $jp7ng.B100), ")") : "var(--ds-border-input, ".concat((0, $dEQSq.getBooleanFF)("platform.design-system-team.border-checkbox_nyoiu") ? (0, $jp7ng.N100) : (0, $jp7ng.N30), ")");
            if (validationState === "error") borderColorHover = "var(--ds-border-danger, ".concat((0, $jp7ng.R400), ")");
            if (validationState === "success") borderColorHover = "var(--ds-border-success, ".concat((0, $jp7ng.G400), ")");
            var transitionDuration = "200ms";
            if (appearance === "subtle") {
                borderColor = isFocused ? "var(--ds-border-focused, ".concat((0, $jp7ng.B100), ")") : "transparent";
                backgroundColor = isFocused ? "var(--ds-surface, ".concat((0, $jp7ng.N0), ")") : "transparent";
                backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, ".concat((0, $jp7ng.N0), ")") : "var(--ds-background-input-hovered, ".concat((0, $jp7ng.N30), ")");
            }
            if (appearance === "none") {
                borderColor = "transparent";
                backgroundColor = "transparent";
                backgroundColorHover = "transparent";
                borderColorHover = "transparent";
            }
            return $997d2341e726882e$var$_objectSpread($997d2341e726882e$var$_objectSpread($997d2341e726882e$var$_objectSpread({}, css), {}, {
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? "none" : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: "solid",
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: (0, $dEQSq.getBooleanFF)("platform.design-system-team.border-checkbox_nyoiu") ? "var(--ds-border-width, 1px)" : "var(--ds-border-width-outline, 2px)",
                boxShadow: "none"
            }, (0, $dEQSq.getBooleanFF)("platform.design-system-team.border-checkbox_nyoiu") && {
                "&:focus-within": {
                    boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", borderColor)
                }
            }), {}, {
                minHeight: isCompact ? (0, $aP6k3.gridSize)() * 4 : (0, $aP6k3.gridSize)() * 5,
                padding: 0,
                transition: "background-color ".concat(transitionDuration, " ease-in-out,\n        border-color ").concat(transitionDuration, " ease-in-out"),
                "::-webkit-scrollbar": {
                    height: (0, $aP6k3.gridSize)(),
                    width: (0, $aP6k3.gridSize)()
                },
                "::-webkit-scrollbar-corner": {
                    display: "none"
                },
                ":hover": {
                    "::-webkit-scrollbar-thumb": {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: "rgba(0,0,0,0.2)"
                    },
                    cursor: "pointer",
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                "::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: "rgba(0,0,0,0.4)"
                }
            });
        },
        valueContainer: function valueContainer(css) {
            return $997d2341e726882e$var$_objectSpread($997d2341e726882e$var$_objectSpread({}, css), {}, {
                paddingLeft: $997d2341e726882e$var$paddingExcludingBorder,
                paddingRight: $997d2341e726882e$var$paddingExcludingBorder,
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            });
        },
        clearIndicator: function clearIndicator(css) {
            return $997d2341e726882e$var$_objectSpread($997d2341e726882e$var$_objectSpread({}, css), {}, {
                color: "var(--ds-text-subtlest, ".concat((0, $jp7ng.N70), ")"),
                paddingLeft: $997d2341e726882e$var$ICON_PADDING,
                paddingRight: $997d2341e726882e$var$ICON_PADDING,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ":hover": {
                    color: "var(--ds-text-subtle, ".concat((0, $jp7ng.N500), ")")
                }
            });
        },
        loadingIndicator: function loadingIndicator(css) {
            return $997d2341e726882e$var$_objectSpread($997d2341e726882e$var$_objectSpread({}, css), {}, {
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            });
        },
        dropdownIndicator: function dropdownIndicator(css, _ref3) {
            var isDisabled = _ref3.isDisabled;
            var color = "var(--ds-text-subtle, ".concat((0, $jp7ng.N500), ")");
            if (isDisabled) color = "var(--ds-text-disabled, ".concat((0, $jp7ng.N70), ")");
            return $997d2341e726882e$var$_objectSpread($997d2341e726882e$var$_objectSpread({}, css), {}, {
                color: color,
                paddingLeft: $997d2341e726882e$var$ICON_PADDING,
                paddingRight: $997d2341e726882e$var$ICON_PADDING,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ":hover": {
                    color: "var(--ds-text-subtle, ".concat((0, $jp7ng.N200), ")")
                }
            });
        },
        indicatorsContainer: function indicatorsContainer(css) {
            return $997d2341e726882e$var$_objectSpread($997d2341e726882e$var$_objectSpread({}, css), {}, {
                paddingRight: $997d2341e726882e$var$paddingExcludingBorder - $997d2341e726882e$var$ICON_PADDING
            });
        },
        option: function option(css, _ref4) {
            var isFocused = _ref4.isFocused, isSelected = _ref4.isSelected, isDisabled = _ref4.isDisabled;
            var color = "var(--ds-text, ".concat((0, $jp7ng.N800), ")");
            if (isDisabled) color = "var(--ds-text-disabled, ".concat((0, $jp7ng.N70), ")");
            else if (isSelected) color = "var(--ds-text-selected, ".concat((0, $jp7ng.B400), ")");
            var boxShadow;
            var backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = "var(--ds-background-selected-hovered, ".concat((0, $jp7ng.B50), ")");
            else if (isSelected) backgroundColor = "var(--ds-background-selected, ".concat((0, $jp7ng.B50), ")");
            else if (isFocused) backgroundColor = "var(--ds-background-neutral-subtle-hovered, ".concat((0, $jp7ng.N20), ")");
            if (!isDisabled && (isFocused || isSelected)) boxShadow = "inset 2px 0px 0px ".concat("var(--ds-border-selected, ".concat((0, $jp7ng.B400), ")"));
            var cursor = isDisabled ? "not-allowed" : css.cursor;
            return $997d2341e726882e$var$_objectSpread($997d2341e726882e$var$_objectSpread({}, css), {}, {
                padding: "6px 12px",
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ":active": {
                    backgroundColor: !isDisabled ? isSelected ? "var(--ds-background-selected-pressed, ".concat((0, $jp7ng.N20), ")") : "var(--ds-background-neutral-subtle-pressed, ".concat((0, $jp7ng.N30), ")") : undefined
                },
                "@media screen and (-ms-high-contrast: active)": {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? "2px solid transparent" : ""
                }
            });
        },
        placeholder: function placeholder(css, _ref5) {
            var isDisabled = _ref5.isDisabled;
            return $997d2341e726882e$var$_objectSpread($997d2341e726882e$var$_objectSpread({}, css), {}, {
                color: isDisabled ? "var(--ds-text-disabled, ".concat((0, $jp7ng.N300), ")") : "var(--ds-text-subtlest, ".concat((0, $jp7ng.N200), ")")
            });
        },
        singleValue: function singleValue(css, _ref6) {
            var isDisabled = _ref6.isDisabled;
            return $997d2341e726882e$var$_objectSpread($997d2341e726882e$var$_objectSpread({}, css), {}, {
                color: isDisabled ? "var(--ds-text-disabled, ".concat((0, $jp7ng.N70), ")") : "var(--ds-text, ".concat((0, $jp7ng.N800), ")"),
                lineHeight: "var(--ds-font-lineHeight-100, 16px)" // 16px
            });
        },
        menu: function menu(css) {
            return $997d2341e726882e$var$_objectSpread($997d2341e726882e$var$_objectSpread({}, css), {}, {
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            });
        },
        menuList: function menuList(css) {
            return $997d2341e726882e$var$_objectSpread($997d2341e726882e$var$_objectSpread({}, css), {}, {
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            });
        },
        multiValue: function multiValue(css, _ref7) {
            var isDisabled = _ref7.isDisabled, isFocused = _ref7.isFocused;
            var backgroundColor;
            var color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = "var(--ds-background-neutral, ".concat((0, $jp7ng.N40), ")");
                color = "var(--ds-text-disabled, ".concat((0, $jp7ng.N70), ")");
            } else if (isFocused) {
                backgroundColor = "var(--ds-background-selected, ".concat((0, $jp7ng.N40), ")");
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = "var(--ds-background-neutral, ".concat((0, $jp7ng.N40), ")");
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return $997d2341e726882e$var$_objectSpread($997d2341e726882e$var$_objectSpread({}, css), {}, {
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? "0 0 0 2px ".concat("var(--ds-surface, transparent)", ", 0 0 0 4px ", "var(--ds-border-focused, transparent)") : "none",
                maxWidth: "100%",
                "@media screen and (-ms-high-contrast: active)": {
                    border: isFocused ? "1px solid transparent" : "none"
                },
                color: color
            });
        },
        multiValueLabel: function multiValueLabel(css, _ref8) {
            var isDisabled = _ref8.isDisabled;
            return $997d2341e726882e$var$_objectSpread($997d2341e726882e$var$_objectSpread({}, css), {}, {
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? "var(--ds-text-disabled, ".concat((0, $jp7ng.N70), ")") : "inherit",
                paddingRight: "var(--ds-space-025, 2px)"
            });
        },
        multiValueRemove: function multiValueRemove(css, _ref9) {
            var isFocused = _ref9.isFocused;
            return $997d2341e726882e$var$_objectSpread($997d2341e726882e$var$_objectSpread({}, css), {}, {
                backgroundColor: isFocused ? "var(--ds-UNSAFE-transparent, ".concat((0, $jp7ng.R75), ")") : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: "0px 2px 2px 0px",
                // DSP-6470 we should style like Tag once we have the :has selector
                ":hover": {
                    backgroundColor: "var(--ds-background-danger-hovered, ".concat((0, $jp7ng.R75), ")"),
                    fill: "var(--ds-text-danger, #000)"
                },
                ":active": {
                    backgroundColor: "var(--ds-background-danger-pressed, ".concat((0, $jp7ng.R75), ")"),
                    fill: "var(--ds-text-danger, #000)"
                }
            });
        },
        groupHeading: function groupHeading(css) {
            return $997d2341e726882e$var$_objectSpread($997d2341e726882e$var$_objectSpread({}, css), {}, {
                color: "var(--ds-text-subtle, ".concat((0, $jp7ng.N200), ")")
            });
        }
    };
}

});

parcelRegister("jkxw3", function(module, exports) {

$parcel$export(module.exports, "onFocus", function () { return $e129e228b252dec6$export$ecf9bf35ad97eb74; });
$parcel$export(module.exports, "isOptionsGrouped", function () { return $e129e228b252dec6$export$d2756249f53f9f8; });
// Used for overwriting ariaLiveMessages builtin onFocus method.
// Returns custom built string while focusing each group option. This string is used for screen reader announcement.
function $e129e228b252dec6$export$ecf9bf35ad97eb74(props) {
    var _groupData$options$fi;
    var focused = props.focused, options = props.options;
    var isOptionFocused = function isOptionFocused(option) {
        return option === focused;
    };
    var groupData = options === null || options === void 0 ? void 0 : options.find(function(option) {
        var _option$options;
        return (_option$options = option.options) === null || _option$options === void 0 ? void 0 : _option$options.some(isOptionFocused);
    });
    var groupOptionIndex = (_groupData$options$fi = groupData === null || groupData === void 0 ? void 0 : groupData.options.findIndex(isOptionFocused)) !== null && _groupData$options$fi !== void 0 ? _groupData$options$fi : 0;
    return "Option ".concat(focused.label, ", ").concat(groupData === null || groupData === void 0 ? void 0 : groupData.label, " group, item ").concat(groupOptionIndex + 1, " out of ").concat(groupData === null || groupData === void 0 ? void 0 : groupData.options.length, ". All in all ");
}
var $e129e228b252dec6$export$d2756249f53f9f8 = function isOptionsGrouped(arr) {
    return arr === null || arr === void 0 ? void 0 : arr.every(function(obj) {
        return obj.hasOwnProperty("options");
    });
};

});



parcelRegister("2HsK2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f75e46139ae1836$export$2e2bcd8739ae039; });

var $iAT08 = parcelRequire("iAT08");

var $i04lD = parcelRequire("i04lD");
var $1f75e46139ae1836$export$2e2bcd8739ae039 = (0, $i04lD.default)((0, $iAT08.default));

});
parcelRegister("iAT08", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d89640de5e9d7828$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "useAsync", function () { return (parcelRequire("9IkcK")).u; });

var $ii97e = parcelRequire("ii97e");

var $9nHZC = parcelRequire("9nHZC");

var $bpHvF = parcelRequire("bpHvF");

var $kIN0M = parcelRequire("kIN0M");

var $9IkcK = parcelRequire("9IkcK");
parcelRequire("aHkQz");
parcelRequire("uqRmf");
parcelRequire("eVDe4");
parcelRequire("3BD5g");
parcelRequire("d7Kxt");
parcelRequire("b4Ivn");


parcelRequire("9q1kH");
parcelRequire("lOQkO");
parcelRequire("340K4");
parcelRequire("hlgjl");
parcelRequire("kFnE9");
parcelRequire("lnOmc");

parcelRequire("05GjO");

var $d89640de5e9d7828$var$AsyncSelect = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(props, ref) {
    var stateManagedProps = (0, $9IkcK.u)(props);
    var selectProps = (0, $kIN0M.u)(stateManagedProps);
    return /*#__PURE__*/ $9nHZC.createElement((0, $bpHvF.S), (0, $ii97e.default)({
        ref: ref
    }, selectProps));
});
var $d89640de5e9d7828$export$2e2bcd8739ae039 = $d89640de5e9d7828$var$AsyncSelect;

});


parcelRegister("hNmd9", function(module, exports) {

$parcel$export(module.exports, "formatOptionLabel", function () { return $cdccb23f986ca814$export$322216d90ffb8d0e; });

var $9nHZC = parcelRequire("9nHZC");

var $inFLm = parcelRequire("inFLm");

var $erAxb = parcelRequire("erAxb");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $1g8Pl = parcelRequire("1g8Pl");

var $3eLm0 = parcelRequire("3eLm0");
const $cdccb23f986ca814$var$formatUserOption = (option, context, message)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3eLm0.SearchResultOption), {
        role: "option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3eLm0.OptionAvatar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $inFLm.default), {
        name: "userAvatar",
        size: context === "value" ? "xsmall" : "small",
        src: option.avatar
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3eLm0.OptionName), null, option.name), option.hasAccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3eLm0.HasAccessInfo), null, message));
};
const $cdccb23f986ca814$var$formatGroupOption = (option, context, message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3eLm0.SearchGroupOption), {
        role: "option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3eLm0.OptionAvatar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($erAxb))), {
        label: "",
        primaryColor: (0, $h39Sh.default)("color.icon.inverse", (0, $jp7ng).N0),
        size: context === "value" ? "small" : "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3eLm0.OptionName), null, option.name), option.hasAccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3eLm0.HasAccessInfo), null, message));
const $cdccb23f986ca814$export$322216d90ffb8d0e = (message)=>(option, { context: context })=>{
        if (option.isNew) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", null, option.name);
        return option.mode === (0, $1g8Pl.AccessMode).users ? $cdccb23f986ca814$var$formatUserOption(option, context, message) : $cdccb23f986ca814$var$formatGroupOption(option, context, message);
    };

});
parcelRegister("erAxb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a83fed3eed991e4f$var$_react = $a83fed3eed991e4f$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $a83fed3eed991e4f$var$_peopleGroup = $a83fed3eed991e4f$var$_interopRequireDefault((parcelRequire("jPVaQ")));
function $a83fed3eed991e4f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a83fed3eed991e4f$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $a83fed3eed991e4f$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M8.13 10H4a2 2 0 0 0-2 2v3.73c0 1.31 1.87 2.05 4 2.23V15a3 3 0 0 1 3-3h.35a4 4 0 0 1-1.23-2m7.75 0H20c1.11 0 2 .89 2 2v3.73c0 1.31-1.87 2.05-4 2.23V15a3 3 0 0 0-3-3h-.35a4 4 0 0 0 1.23-2M9.97 5.55a3 3 0 1 0-1.96 3.27 4 4 0 0 1 1.96-3.27M16 8.83a3 3 0 1 0-1.96-3.28A4 4 0 0 1 16 8.83"/><path d="M7 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><circle cx="12" cy="9" r="3"/></g></svg>`
    }, props, {
        newIcon: $a83fed3eed991e4f$var$_peopleGroup.default
    }));
$a83fed3eed991e4f$var$PeopleGroupIcon.displayName = "PeopleGroupIcon";
var $a83fed3eed991e4f$var$_default = module.exports.default = $a83fed3eed991e4f$var$PeopleGroupIcon;

});
parcelRegister("jPVaQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d023b088c8fc09a18395a1c7dedb3043>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e70f214f4c987214$var$_react = $e70f214f4c987214$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $e70f214f4c987214$var$_UNSAFE_baseNew = $e70f214f4c987214$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $e70f214f4c987214$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e70f214f4c987214$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $e70f214f4c987214$var$_react.default.createElement($e70f214f4c987214$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5 9.75H2.625C1.59 9.75.75 10.59.75 11.625V13m14.5 1v-1.5a2.75 2.75 0 0 0-2.75-2.75h-3a2.75 2.75 0 0 0-2.75 2.75V14m7-9.5a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0Zm-8 1a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"/>`
    }, props));
$e70f214f4c987214$var$PeopleGroupIcon.displayName = "PeopleGroupIcon";
var $e70f214f4c987214$var$_default = module.exports.default = $e70f214f4c987214$var$PeopleGroupIcon;

});


parcelRegister("1g8Pl", function(module, exports) {

$parcel$export(module.exports, "AccessMode", function () { return $145c0cd2cf59c5ad$export$f9d1facf3279202a; });
var $145c0cd2cf59c5ad$export$f9d1facf3279202a;
(function(AccessMode) {
    AccessMode["users"] = "users";
    AccessMode["groups"] = "groups";
})($145c0cd2cf59c5ad$export$f9d1facf3279202a || ($145c0cd2cf59c5ad$export$f9d1facf3279202a = {}));
var $145c0cd2cf59c5ad$export$31620c1545276811;
(function(ModalDialogAction) {
    ModalDialogAction["add"] = "add";
    ModalDialogAction["remove"] = "remove";
    ModalDialogAction["bulkDelete"] = "bulkDelete";
    ModalDialogAction["bulkEdit"] = "bulkEdit";
    ModalDialogAction["removeOwnAccessWarning"] = "removeOwnAccessWarning";
})($145c0cd2cf59c5ad$export$31620c1545276811 || ($145c0cd2cf59c5ad$export$31620c1545276811 = {}));

});

parcelRegister("3eLm0", function(module, exports) {

$parcel$export(module.exports, "ModalContainer", function () { return $afc44da6216447ed$export$c9554889b3e706cd; });
$parcel$export(module.exports, "ModalContainerNext", function () { return $afc44da6216447ed$export$1efc5bfe43549d3d; });
$parcel$export(module.exports, "FormContainer", function () { return $afc44da6216447ed$export$f06621d9ad29af97; });
$parcel$export(module.exports, "SelectLabel", function () { return $afc44da6216447ed$export$f67338d29bd972f8; });
$parcel$export(module.exports, "NoticeContainer", function () { return $afc44da6216447ed$export$82d443d3728a3cbe; });
$parcel$export(module.exports, "SearchResultOption", function () { return $afc44da6216447ed$export$236f19ce87e8bca3; });
$parcel$export(module.exports, "OptionAvatar", function () { return $afc44da6216447ed$export$67de656c3cc789d1; });
$parcel$export(module.exports, "OptionName", function () { return $afc44da6216447ed$export$70bb3d2793b2c20e; });
$parcel$export(module.exports, "SearchGroupOption", function () { return $afc44da6216447ed$export$4d4a7b489508589d; });
$parcel$export(module.exports, "HasAccessInfo", function () { return $afc44da6216447ed$export$f8649da53832022; });
$parcel$export(module.exports, "SelectDropdownContainer", function () { return $afc44da6216447ed$export$d7463910c9474d25; });
$parcel$export(module.exports, "getModalSelectStyles", function () { return $afc44da6216447ed$export$49d875433005e0c4; });
$parcel$export(module.exports, "modalSelectStyles", function () { return $afc44da6216447ed$export$2b97591397c937f2; });

var $2xJU3 = parcelRequire("2xJU3");

var $jp7ng = parcelRequire("jp7ng");
var $aP6k3 = parcelRequire("aP6k3");
var $dCDrX = parcelRequire("dCDrX");

var $h39Sh = parcelRequire("h39Sh");
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */ function $afc44da6216447ed$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $afc44da6216447ed$export$c9554889b3e706cd = (0, $2xJU3.default)("div", {
    target: "e1jvo7z00"
})({
    name: "1osiah8",
    styles: "overflow-x:visible !important;overflow-y:visible !important;"
});
const $afc44da6216447ed$export$1efc5bfe43549d3d = (0, $2xJU3.default)("div", {
    target: "e1jvo7z01"
})("overflow-x:visible !important;overflow-y:visible !important;padding:", (0, $h39Sh.default)("space.025", "2px"), " ", (0, $h39Sh.default)("space.300", "24px"), ";");
const $afc44da6216447ed$export$f06621d9ad29af97 = (0, $2xJU3.default)("div", {
    target: "e1jvo7z02"
})("max-width:", (0, $aP6k3.gridSize)() * 52.5, "px;");
const $afc44da6216447ed$export$f67338d29bd972f8 = (0, $2xJU3.default)("div", {
    target: "e1jvo7z03"
})((0, $dCDrX).h200(), ";display:inline-block;margin-top:", (0, $aP6k3.gridSize)() * 3.5, "px;margin-bottom:", (0, $h39Sh.default)("space.050", "4px"), ";");
const $afc44da6216447ed$export$82d443d3728a3cbe = (0, $2xJU3.default)("p", {
    target: "e1jvo7z04"
})("margin:", (0, $h39Sh.default)("space.200", "16px"), " 0;");
const $afc44da6216447ed$export$236f19ce87e8bca3 = (0, $2xJU3.default)("div", {
    target: "e1jvo7z05"
})({
    name: "70qvj9",
    styles: "display:flex;align-items:center;"
});
const $afc44da6216447ed$export$67de656c3cc789d1 = (0, $2xJU3.default)("div", {
    target: "e1jvo7z06"
})("margin-top:1px;margin-right:", (0, $h39Sh.default)("space.100", "8px"), ";");
const $afc44da6216447ed$export$70bb3d2793b2c20e = (0, $2xJU3.default)("span", {
    target: "e1jvo7z07"
})("margin-right:", (0, $h39Sh.default)("space.100", "8px"), ";");
const $afc44da6216447ed$export$4d4a7b489508589d = /*#__PURE__*/ (0, $2xJU3.default)($afc44da6216447ed$export$236f19ce87e8bca3, {
    target: "e1jvo7z08"
})("padding:1px 0;& > div{background:", (0, $h39Sh.default)("color.background.accent.gray.subtler", (0, $jp7ng).N50), ";border-radius:50%;border:", (0, $h39Sh.default)("space.025", "2px"), " solid ", (0, $h39Sh.default)("color.border.inverse", (0, $jp7ng).N0), ";display:flex;align-items:center;justify-content:center;}");
const $afc44da6216447ed$export$f8649da53832022 = (0, $2xJU3.default)("span", {
    target: "e1jvo7z09"
})("margin-left:auto;color:", (0, $h39Sh.default)("color.text.subtlest", "gray"), ";font-size:", (0, $aP6k3.fontSizeSmall)(), "px;");
const $afc44da6216447ed$export$d7463910c9474d25 = (0, $2xJU3.default)("div", {
    target: "e1jvo7z010"
})("margin-top:", ({ topMarginFactor: topMarginFactor = 2 })=>(0, $aP6k3.gridSize)() * topMarginFactor, "px;width:", (0, $aP6k3.gridSize)() * 45, "px;");
function $afc44da6216447ed$export$49d875433005e0c4(options) {
    const { marginLeft: marginLeft, maxWidth: maxWidth, paddingBottom: paddingBottom } = options;
    const modalSelectStyles = {
        container: (base)=>({
                ...base,
                maxWidth: maxWidth || (0, $aP6k3.gridSize)() * 52.5,
                marginLeft: marginLeft || 0,
                paddingBottom: paddingBottom || 0
            }),
        menuPortal: (base)=>({
                ...base,
                zIndex: 9999
            }),
        control: (base)=>({
                ...base,
                backgroundColor: (0, $h39Sh.default)("color.background.accent.gray.subtlest", (0, $jp7ng).N10)
            }),
        multiValueRemove: (base, state)=>({
                ...base,
                ...state.data.isFixed ? {
                    display: "none"
                } : {},
                ":hover": {
                    backgroundColor: (0, $h39Sh.default)("color.background.accent.gray.subtlest.hovered", (0, $jp7ng).N20)
                }
            }),
        multiValue: (base, state)=>({
                ...base,
                alignItems: "center",
                height: (0, $h39Sh.default)("space.300", "24px"),
                backgroundColor: state.data.isFixed ? (0, $h39Sh.default)("color.background.accent.gray.subtlest.hovered", "gray") : (0, $h39Sh.default)("color.background.accent.gray.subtlest", (0, $jp7ng).N20),
                paddingRight: state.data.isFixed ? 11 : base.paddingRight,
                paddingLeft: state.data.isFixed ? 7 : base.paddingLeft
            }),
        multiValueLabel: (base, state)=>({
                ...base,
                color: state.data.isFixed ? (0, $h39Sh.default)("color.text.inverse", "white") : base.color
            })
    };
    return modalSelectStyles;
}
const $afc44da6216447ed$export$2b97591397c937f2 = $afc44da6216447ed$export$49d875433005e0c4({
    maxWidth: (0, $aP6k3.gridSize)() * 52.5
});

});


parcelRegister("fRg1j", function(module, exports) {

$parcel$export(module.exports, "isValidEmail", function () { return $d08d49399f00a8d3$export$371e338370561054; });
const $d08d49399f00a8d3$export$371e338370561054 = (input)=>{
    const re = /* eslint-disable-next-line no-useless-escape */ /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(input);
};

});

parcelRegister("4HDjC", function(module, exports) {

$parcel$export(module.exports, "PermissionsContainer", function () { return $9d65a6a16d55b04e$export$485a62f3e7e4b669; });
$parcel$export(module.exports, "makeWithPermissions", function () { return $9d65a6a16d55b04e$export$7d6c1de5aaae7de8; });
$parcel$export(module.exports, "useActions", function () { return $9d65a6a16d55b04e$export$bc923229a7fa61e7; });
$parcel$export(module.exports, "usePermissions", function () { return $9d65a6a16d55b04e$export$dde803638a7db51f; });
$parcel$export(module.exports, "useIsSumEnabled", function () { return $9d65a6a16d55b04e$export$80965ba4e40da89a; });
$parcel$export(module.exports, "useIsOrgAdmin", function () { return $9d65a6a16d55b04e$export$8ed42372757d8b2a; });
$parcel$export(module.exports, "useWorkspaceOrgId", function () { return $9d65a6a16d55b04e$export$7554f12086742dc2; });
$parcel$export(module.exports, "useFilters", function () { return $9d65a6a16d55b04e$export$973ca22476b0e05f; });
$parcel$export(module.exports, "useLoadingState", function () { return $9d65a6a16d55b04e$export$30e29c90a67638af; });
$parcel$export(module.exports, "useActivePermission", function () { return $9d65a6a16d55b04e$export$d33efabb02ba2972; });
$parcel$export(module.exports, "useCheckedRows", function () { return $9d65a6a16d55b04e$export$a77f76bc99d745c9; });
$parcel$export(module.exports, "useActiveModal", function () { return $9d65a6a16d55b04e$export$2b12490b667dd1de; });
$parcel$export(module.exports, "usePermissionsContext", function () { return $9d65a6a16d55b04e$export$bf9c56d8ad550a48; });
$parcel$export(module.exports, "useAdminLevel", function () { return $9d65a6a16d55b04e$export$b70b00995beef30e; });
$parcel$export(module.exports, "useRemoveAccess", function () { return $9d65a6a16d55b04e$export$67f165ebf16b508b; });
$parcel$export(module.exports, "useUpdateAccess", function () { return $9d65a6a16d55b04e$export$16fa95b18c1dcd7e; });
$parcel$export(module.exports, "useSearchUsersAndGroups", function () { return $9d65a6a16d55b04e$export$3b70bb77cd073d2e; });
$parcel$export(module.exports, "useAddUsersAndGroups", function () { return $9d65a6a16d55b04e$export$51f571acbf0f5344; });
$parcel$export(module.exports, "useGetPermissions", function () { return $9d65a6a16d55b04e$export$e12ad7e4988aacd; });

var $9nHZC = parcelRequire("9nHZC");

var $3XbtU = parcelRequire("3XbtU");

var $kdlrL = parcelRequire("kdlrL");
var $fweAh = parcelRequire("fweAh");
var $cCv48 = parcelRequire("cCv48");

var $f9pRZ = parcelRequire("f9pRZ");

var $2u4M7 = parcelRequire("2u4M7");

var $7Me5Z = parcelRequire("7Me5Z");

var $dyEnO = parcelRequire("dyEnO");

var $jajUg = parcelRequire("jajUg");

var $b9duc = parcelRequire("b9duc");

var $cM1QH = parcelRequire("cM1QH");

var $bOfxz = parcelRequire("bOfxz");

var $1g8Pl = parcelRequire("1g8Pl");

var $hCBEg = parcelRequire("hCBEg");
// actions
const $9d65a6a16d55b04e$var$setStoreState = (state)=>({ setState: setState, getState: getState })=>{
        setState(typeof state === "function" ? state(getState()) : state);
    };
const $9d65a6a16d55b04e$var$setActiveModal = (type, props)=>({ setState: setState })=>{
        setState({
            activeModal: type ? {
                type: type,
                props: props
            } : undefined
        });
    };
const $9d65a6a16d55b04e$var$setIsChecked = (permission, isChecked)=>({ setState: setState, getState: getState })=>{
        const s = getState();
        const checked = isChecked === undefined ? (0, $hCBEg.includesPermission)(s.checkedRows, permission) : isChecked;
        setState({
            ...s,
            checkedRows: checked ? s.checkedRows.filter((p)=>(0, $hCBEg.getPermissionId)(permission) !== (0, $hCBEg.getPermissionId)(p)) : [
                ...s.checkedRows,
                permission
            ]
        });
    };
const $9d65a6a16d55b04e$var$selectAll = (shouldSelectAll)=>({ setState: setState, getState: getState })=>{
        const s = getState();
        setState({
            checkedRows: (0, $hCBEg.selectAllPermissions)(s.permissions, s.checkedRows, s.page, s.context, shouldSelectAll)
        });
    };
const $9d65a6a16d55b04e$export$5469c988647fcb7b = ({ level: level, privilege: privilege })=>({ getState: getState })=>(0, $hCBEg.isPermissionEditable)(getState().context, level, privilege);
// store
const $9d65a6a16d55b04e$var$initialState = {
    loadingState: (0, $cM1QH.LoadingState).IDLE,
    context: "project",
    permissions: new Map(),
    privilegeFilter: null,
    accessLevelFilter: null,
    checkedRows: [],
    limit: 20,
    page: 1,
    total: 0
};
const $9d65a6a16d55b04e$var$PermissionsStore = (0, $cCv48.createStore)({
    initialState: $9d65a6a16d55b04e$var$initialState,
    actions: {
        setState: $9d65a6a16d55b04e$var$setStoreState,
        setActiveModal: $9d65a6a16d55b04e$var$setActiveModal,
        setIsChecked: $9d65a6a16d55b04e$var$setIsChecked,
        selectAll: $9d65a6a16d55b04e$var$selectAll,
        isEditable: $9d65a6a16d55b04e$export$5469c988647fcb7b
    }
});
const $9d65a6a16d55b04e$export$485a62f3e7e4b669 = (0, $fweAh.createContainer)($9d65a6a16d55b04e$var$PermissionsStore, {
    onInit: ()=>({ setState: setState }, { value: value })=>{
            setState({
                ...value
            });
        },
    onUpdate: ()=>({ setState: setState }, { value: value })=>{
            setState({
                ...value
            });
        },
    onCleanup: ()=>({ getState: getState }, { onCleanup: onCleanup })=>{
            if (typeof onCleanup === "function") onCleanup(getState());
        }
});
const $9d65a6a16d55b04e$export$7d6c1de5aaae7de8 = (Container)=>(Component, value)=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Container, {
                Component: Component,
                value: value
            });
const $9d65a6a16d55b04e$export$bc923229a7fa61e7 = (0, $kdlrL.createActionsHook)($9d65a6a16d55b04e$var$PermissionsStore);
const $9d65a6a16d55b04e$export$dde803638a7db51f = (0, $kdlrL.createHook)($9d65a6a16d55b04e$var$PermissionsStore, {
    selector: ({ permissions: permissions })=>({
            permissions: permissions
        })
});
const $9d65a6a16d55b04e$export$2da7aef02c1d55c6 = (0, $kdlrL.createHook)($9d65a6a16d55b04e$var$PermissionsStore, {
    selector: ({ context: context }, { level: level, privilege: privilege })=>(0, $hCBEg.isPermissionEditable)(context, level, privilege)
});
const $9d65a6a16d55b04e$export$80965ba4e40da89a = (0, $kdlrL.createHook)($9d65a6a16d55b04e$var$PermissionsStore, {
    selector: ({ sumEnabled: sumEnabled })=>!!sumEnabled
});
const $9d65a6a16d55b04e$export$8ed42372757d8b2a = (0, $kdlrL.createHook)($9d65a6a16d55b04e$var$PermissionsStore, {
    selector: ({ orgAdmin: orgAdmin })=>!!orgAdmin
});
const $9d65a6a16d55b04e$export$7554f12086742dc2 = (0, $kdlrL.createHook)($9d65a6a16d55b04e$var$PermissionsStore, {
    selector: ({ workspaceOrgId: workspaceOrgId })=>workspaceOrgId
});
const $9d65a6a16d55b04e$export$973ca22476b0e05f = (0, $kdlrL.createHook)($9d65a6a16d55b04e$var$PermissionsStore, {
    selector: ({ limit: limit, page: page, total: total, privilegeFilter: privilegeFilter, accessLevelFilter: accessLevelFilter, searchTerm: searchTerm })=>({
            limit: limit,
            page: page,
            total: total,
            privilegeFilter: privilegeFilter,
            accessLevelFilter: accessLevelFilter,
            searchTerm: searchTerm
        })
});
const $9d65a6a16d55b04e$export$30e29c90a67638af = (0, $kdlrL.createHook)($9d65a6a16d55b04e$var$PermissionsStore, {
    selector: ({ loadingState: loadingState })=>({
            loadingState: loadingState
        })
});
const $9d65a6a16d55b04e$export$d33efabb02ba2972 = (0, $kdlrL.createHook)($9d65a6a16d55b04e$var$PermissionsStore, {
    selector: ({ activePermission: activePermission })=>({
            activePermission: activePermission
        })
});
const $9d65a6a16d55b04e$export$a77f76bc99d745c9 = (0, $kdlrL.createHook)($9d65a6a16d55b04e$var$PermissionsStore, {
    selector: ({ checkedRows: checkedRows })=>({
            checkedRows: checkedRows
        })
});
const $9d65a6a16d55b04e$export$2b12490b667dd1de = (0, $kdlrL.createHook)($9d65a6a16d55b04e$var$PermissionsStore, {
    selector: ({ activeModal: activeModal })=>({
            activeModal: activeModal
        })
});
const $9d65a6a16d55b04e$export$bf9c56d8ad550a48 = (0, $kdlrL.createHook)($9d65a6a16d55b04e$var$PermissionsStore, {
    selector: ({ context: context })=>({
            context: context
        })
});
const $9d65a6a16d55b04e$export$b70b00995beef30e = (0, $kdlrL.createHook)($9d65a6a16d55b04e$var$PermissionsStore, {
    selector: ({ adminLevel: adminLevel })=>({
            adminLevel: adminLevel,
            isWorkspaceAdmin: adminLevel === "workspace",
            isProjectAdmin: adminLevel === "project",
            isRepoAdmin: adminLevel === "repository"
        })
});
const $9d65a6a16d55b04e$export$7ab84fea33af0d21 = ()=>{
    const { showFlag: showFlag, showErrorFlag: showErrorFlag } = (0, $dyEnO.useFlag)({
        enableForPdvs: true
    });
    const { setState: setState } = $9d65a6a16d55b04e$export$bc923229a7fa61e7();
    return (0, $9nHZC.useCallback)((e)=>{
        var _e$error;
        setState({
            loadingState: (0, $cM1QH.LoadingState).ERROR
        });
        if (Array.isArray(e)) {
            e.forEach(({ id: id, description: description, title: title })=>{
                showFlag({
                    id: id,
                    iconType: "error",
                    description: description,
                    title: title
                });
            });
            return;
        }
        (0, $3XbtU.captureException)(e);
        showErrorFlag((e === null || e === void 0 ? void 0 : e.message) || (e === null || e === void 0 ? void 0 : (_e$error = e.error) === null || _e$error === void 0 ? void 0 : _e$error.message));
    }, [
        showErrorFlag,
        showFlag,
        setState
    ]);
};
const $9d65a6a16d55b04e$export$cb1776d555e7f736 = (accessCheck)=>{
    return async function userAccessCheck() {
        try {
            await accessCheck();
        } catch (errorResponse) {
            if (errorResponse.status === 403) window.location.reload();
        }
    };
};
const $9d65a6a16d55b04e$export$a567c87a42afbf7b = (createInvitation, refreshInvitations)=>{
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    const { showFlag: showFlag } = (0, $dyEnO.useFlag)({
        enableForPdvs: true
    });
    const { setState: setState } = $9d65a6a16d55b04e$export$bc923229a7fa61e7();
    const handleError = $9d65a6a16d55b04e$export$7ab84fea33af0d21();
    return (0, $9nHZC.useCallback)(async (usersByEmail, privilege)=>{
        const notUpdated = [];
        const successfullyAdded = [];
        const successfullyInvited = [];
        if (!usersByEmail.length) return {
            hasEmailInviteError: false,
            successfullyAdded: successfullyAdded
        };
        try {
            const inviteStatuses = await createInvitation({
                emails: usersByEmail.map(({ name: name })=>name),
                permission: privilege
            });
            if (!inviteStatuses) throw new Error((0, $cM1QH.INVITE_FAILED_ERROR));
            Object.entries(inviteStatuses).forEach(([email, { status: status, error: error }])=>{
                const user = usersByEmail.find(({ name: name })=>name === email);
                if (status === (0, $2u4M7.CreateInvitationStatus).invited) successfullyInvited.push(user);
                else if (status === (0, $2u4M7.CreateInvitationStatus).added) successfullyAdded.push(user);
                else if (error !== null && error !== void 0 && error.includes("NON_ADMIN_RESTRICTION")) notUpdated.push({
                    id: user.id,
                    errorMessage: (0, $cM1QH.NON_ADMIN_RESTRICTION_ERROR),
                    name: user.name
                });
                else if (error !== null && error !== void 0 && error.includes("DOMAIN_RESTRICTION")) notUpdated.push({
                    id: user.id,
                    errorMessage: (0, $cM1QH.DOMAIN_RESTRICTION_ERROR),
                    name: user.name
                });
                else notUpdated.push({
                    id: user.id,
                    errorMessage: (0, $cM1QH.INVITE_FAILED_ERROR),
                    name: user.name
                });
            });
        } catch (e) {
            (0, $3XbtU.captureException)(e);
            // if createInvitation() fails, add all users invites to notUpdated
            // This is mostly for backwards compatibility so not to refactor this
            // code too much. Ideally we would improve this flow.
            usersByEmail.forEach(({ id: id, name: name })=>{
                notUpdated.push({
                    id: id,
                    errorMessage: (0, $cM1QH.INVITE_FAILED_ERROR),
                    name: name
                });
            });
        }
        // only show the flag if all invitations were successful
        if (successfullyInvited.length && !notUpdated.length) {
            refreshInvitations();
            showFlag({
                id: "invites-success-flag",
                iconType: "success",
                description: formatMessage((0, $bOfxz.default).invitationsSentDescription, {
                    entity: successfullyInvited.map((entity)=>entity.name).join(", "),
                    count: successfullyInvited.length
                }),
                title: formatMessage((0, $bOfxz.default).invitationsSent)
            });
        }
        if (notUpdated.length) {
            const errors = (0, $hCBEg.getAddUsersErrors)(notUpdated, formatMessage);
            const nonAdminErrors = errors.reduce((arr, { id: id, description: description })=>id === "non-admin-failure" ? arr.concat(description) : arr, []);
            const domainErrors = errors.reduce((arr, { id: id, description: description })=>id === "domain-restriction-failure" ? arr.concat(description) : arr, []);
            if (nonAdminErrors.length || domainErrors.length) setState({
                activeModal: {
                    type: "PartialInvitationMessageModal",
                    props: {
                        successfullyAdded: successfullyAdded.map((entity)=>entity.name),
                        successfullyInvited: successfullyInvited.map((entity)=>entity.name),
                        nonAdminErrors: nonAdminErrors,
                        domainErrors: domainErrors
                    }
                }
            });
            else handleError(errors);
            return {
                hasEmailInviteError: true,
                successfullyAdded: successfullyAdded
            };
        }
        return {
            hasEmailInviteError: false,
            successfullyAdded: successfullyAdded
        };
    }, [
        setState,
        formatMessage,
        handleError,
        showFlag,
        createInvitation,
        refreshInvitations
    ]);
};
const $9d65a6a16d55b04e$export$67f165ebf16b508b = (api)=>{
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    const { publishTrackEvent: publishTrackEvent } = (0, $f9pRZ.useAnalytics)();
    const { showSuccessFlag: showSuccessFlag } = (0, $dyEnO.useFlag)({
        enableForPdvs: true
    });
    const { setState: setState } = $9d65a6a16d55b04e$export$bc923229a7fa61e7();
    const handleError = $9d65a6a16d55b04e$export$7ab84fea33af0d21();
    const accessCheck = $9d65a6a16d55b04e$export$cb1776d555e7f736(api.accessCheck);
    return async (...permissions)=>{
        setState({
            loadingState: (0, $cM1QH.LoadingState).MODAL_LOADING
        });
        try {
            await api.updateAccess({
                privilege: "none",
                principals: (Array.isArray(permissions) ? permissions : [
                    permissions
                ]).map(({ id: id, mode: mode })=>mode === (0, $1g8Pl.AccessMode).users ? {
                        account_id: id
                    } : {
                        slug: id.split("/")[1]
                    })
            });
            setState((s)=>{
                const nextPerms = (0, $hCBEg.resetPermissions)(s.permissions, s.limit, (p)=>!!p && !(0, $hCBEg.includesPermission)(permissions, p));
                return {
                    loadingState: (0, $cM1QH.LoadingState).IDLE,
                    permissions: nextPerms,
                    checkedRows: s.checkedRows.filter((p)=>!(0, $hCBEg.includesPermission)(permissions, p)),
                    page: Math.max(Math.min(s.page, nextPerms.size), 1),
                    total: Math.max(s.total - permissions.length, 0)
                };
            });
            showSuccessFlag(formatMessage((0, $bOfxz.default).accessRemovedDescription, {
                entity: permissions.map((item)=>item.name).join('", "'),
                count: permissions.length
            }), (0, $bOfxz.default).accessRemovedTitle);
            publishTrackEvent({
                action: "removeUserOrGroupPrivileges",
                attributes: {
                    users: permissions.filter((item)=>item.mode === (0, $1g8Pl.AccessMode).users).length,
                    groups: permissions.filter((item)=>item.mode === (0, $1g8Pl.AccessMode).groups).length
                }
            });
            accessCheck();
        } catch (e) {
            handleError(e);
        }
    };
};
const $9d65a6a16d55b04e$export$16fa95b18c1dcd7e = (api)=>{
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    const { publishTrackEvent: publishTrackEvent } = (0, $f9pRZ.useAnalytics)();
    const { showSuccessFlag: showSuccessFlag } = (0, $dyEnO.useFlag)({
        enableForPdvs: true
    });
    const { setState: setState } = $9d65a6a16d55b04e$export$bc923229a7fa61e7();
    const handleError = $9d65a6a16d55b04e$export$7ab84fea33af0d21();
    const accessCheck = $9d65a6a16d55b04e$export$cb1776d555e7f736(api.accessCheck);
    return async (privilege, permissions)=>{
        setState({
            loadingState: Array.isArray(permissions) ? (0, $cM1QH.LoadingState).MODAL_LOADING : (0, $cM1QH.LoadingState).PRIVILEGE_UPDATING,
            activePermission: Array.isArray(permissions) ? undefined : permissions
        });
        try {
            await api.updateAccess({
                privilege: privilege,
                principals: [].concat(permissions).map(({ id: id, mode: mode })=>mode === (0, $1g8Pl.AccessMode).users ? {
                        account_id: id
                    } : {
                        slug: id.split("/")[1]
                    })
            });
            setState((s)=>({
                    loadingState: (0, $cM1QH.LoadingState).IDLE,
                    permissions: (0, $hCBEg.getSetAllPermissions)(s.permissions, (perms)=>perms.map((p)=>!!p && (Array.isArray(permissions) && (0, $hCBEg.includesPermission)(permissions, p) || permissions === p) ? {
                                ...p,
                                privilege: privilege
                            } : p)),
                    activePermission: undefined,
                    activeModal: undefined
                }));
            const updateCount = Array.isArray(permissions) ? permissions.length : 1;
            showSuccessFlag(formatMessage((0, $bOfxz.default).accessChangedDescription, {
                entity: Array.isArray(permissions) ? permissions.map((item)=>item.name).join('", "') : permissions.name,
                count: updateCount
            }), (0, $bOfxz.default).accessChangedTitle);
            const perms = [].concat(permissions);
            publishTrackEvent({
                action: "updateUserOrGroupPrivileges",
                attributes: {
                    users: perms.filter((item)=>item.mode === (0, $1g8Pl.AccessMode).users).length,
                    groups: perms.filter((item)=>item.mode === (0, $1g8Pl.AccessMode).groups).length,
                    privilege: privilege
                }
            });
            accessCheck();
        } catch (e) {
            handleError(e);
        }
    };
};
const $9d65a6a16d55b04e$export$3b70bb77cd073d2e = (searchUsersAndGroups)=>{
    const handleError = $9d65a6a16d55b04e$export$7ab84fea33af0d21();
    return (0, $9nHZC.useMemo)(()=>(0, $b9duc.debounceSyncPromise)(async (searchTerm)=>{
            try {
                return (await searchUsersAndGroups(searchTerm)).filter((v)=>!!v).sort((a, b)=>a.name.localeCompare(b.name));
            } catch (e) {
                handleError(e);
                return [];
            }
        }, (0, $7Me5Z.DEBOUNCE_DELAY)), [
        searchUsersAndGroups,
        handleError
    ]);
};
const $9d65a6a16d55b04e$export$51f571acbf0f5344 = (api, refreshInvitations)=>{
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    const { publishTrackEvent: publishTrackEvent } = (0, $f9pRZ.useAnalytics)();
    const { showSuccessFlag: showSuccessFlag } = (0, $dyEnO.useFlag)({
        enableForPdvs: true
    });
    const { setState: setState } = $9d65a6a16d55b04e$export$bc923229a7fa61e7();
    const handleError = $9d65a6a16d55b04e$export$7ab84fea33af0d21();
    const [{ accessLevelFilter: accessLevelFilter, privilegeFilter: privilegeFilter, searchTerm: searchTerm, page: page }] = $9d65a6a16d55b04e$export$973ca22476b0e05f();
    const { addAccess: addAccess, getPermissions: getPermissions, createInvitation: createInvitation } = api;
    const addUsersByEmail = $9d65a6a16d55b04e$export$a567c87a42afbf7b(createInvitation, refreshInvitations);
    return (0, $9nHZC.useCallback)(async (list, privilege)=>{
        setState({
            loadingState: (0, $cM1QH.LoadingState).MODAL_LOADING
        });
        const principals = list.filter((entity)=>!entity.isNew);
        const usersByEmail = list.filter((entity)=>!!entity.isNew);
        let addedPrincipals = [];
        let hasPrincipalAddError = false;
        const { hasEmailInviteError: hasEmailInviteError, successfullyAdded: addedByEmail } = await addUsersByEmail(usersByEmail, privilege);
        if (principals.length) try {
            await addAccess({
                principals: principals.map((entity)=>entity.mode === (0, $1g8Pl.AccessMode).users ? {
                        account_id: entity.id
                    } : {
                        slug: entity.id.split("/")[1]
                    }),
                privilege: privilege
            });
            addedPrincipals = principals;
        } catch (e) {
            hasPrincipalAddError = true;
            if (e.status === 400 || e.status === 422) {
                let problemEntities;
                // Surface special error in case of personal workspace owner
                if (e.status === 422) problemEntities = list.filter((entity)=>{
                    var _e$error2, _e$error2$fields, _e$error2$fields$acco;
                    return e === null || e === void 0 ? void 0 : (_e$error2 = e.error) === null || _e$error2 === void 0 ? void 0 : (_e$error2$fields = _e$error2.fields) === null || _e$error2$fields === void 0 ? void 0 : (_e$error2$fields$acco = _e$error2$fields.account_id) === null || _e$error2$fields$acco === void 0 ? void 0 : _e$error2$fields$acco.includes(entity.id);
                }).map((entity)=>({
                        id: entity.id,
                        name: entity.name,
                        errorMessage: formatMessage((0, $bOfxz.default).personalWorkspaceException, {
                            entity: entity.name
                        })
                    }));
                else problemEntities = list.filter((entity)=>{
                    var _e$error3, _e$error3$fields, _e$error3$fields$acco;
                    return e === null || e === void 0 ? void 0 : (_e$error3 = e.error) === null || _e$error3 === void 0 ? void 0 : (_e$error3$fields = _e$error3.fields) === null || _e$error3$fields === void 0 ? void 0 : (_e$error3$fields$acco = _e$error3$fields.account_id) === null || _e$error3$fields$acco === void 0 ? void 0 : _e$error3$fields$acco.includes(entity.id);
                }).map((entity)=>({
                        id: entity.id,
                        name: entity.name,
                        errorMessage: (0, $cM1QH.BAD_REQUEST_ERROR)
                    }));
                const errors = (0, $hCBEg.getAddUsersErrors)(problemEntities, formatMessage);
                handleError(errors.length ? errors : e);
            } else handleError(e);
        }
        if (addedPrincipals.length || addedByEmail.length) {
            try {
                const state = await getPermissions({
                    page: page,
                    principalName: searchTerm,
                    accessLevel: accessLevelFilter || undefined,
                    permission: privilegeFilter === "none" || !privilegeFilter ? undefined : privilegeFilter
                });
                setState({
                    ...state,
                    activeModal: undefined,
                    activePermission: undefined,
                    loadingState: (0, $cM1QH.LoadingState).IDLE
                });
            } catch (e) {
                handleError(e);
            }
            const addCount = principals.length + addedByEmail.length;
            showSuccessFlag(formatMessage((0, $bOfxz.default).accessGrantedDescription, {
                entity: (0, $hCBEg.extractNamesFromList)([
                    ...addedByEmail,
                    ...principals
                ]),
                count: addCount
            }), (0, $bOfxz.default).accessGrantedTitle);
            const perms = [
                ...principals,
                ...addedByEmail
            ];
            publishTrackEvent({
                action: "addUsersAndGroups",
                attributes: {
                    users: perms.filter((item)=>item.mode === (0, $1g8Pl.AccessMode).users).length,
                    groups: perms.filter((item)=>item.mode === (0, $1g8Pl.AccessMode).groups).length,
                    privilege: privilege
                }
            });
        } else setState((s)=>({
                loadingState: (0, $cM1QH.LoadingState).IDLE,
                // keep the modal open if there are any errors.
                activeModal: hasEmailInviteError || hasPrincipalAddError ? s.activeModal : undefined
            }));
    }, [
        addUsersByEmail,
        addAccess,
        getPermissions,
        formatMessage,
        showSuccessFlag,
        publishTrackEvent,
        handleError,
        setState,
        accessLevelFilter,
        privilegeFilter,
        searchTerm,
        page
    ]);
};
const $9d65a6a16d55b04e$export$e12ad7e4988aacd = (getPermissions)=>{
    const { setState: setState } = $9d65a6a16d55b04e$export$bc923229a7fa61e7();
    const handleError = $9d65a6a16d55b04e$export$7ab84fea33af0d21();
    const nonceRef = (0, $9nHZC.useRef)();
    const [{ permissions: permissions }] = $9d65a6a16d55b04e$export$dde803638a7db51f();
    const [filters] = $9d65a6a16d55b04e$export$973ca22476b0e05f();
    const permissionsRef = (0, $9nHZC.useRef)(permissions);
    const filtersRef = (0, $9nHZC.useRef)(filters);
    const previousTotalRef = (0, $9nHZC.useRef)(filters.total);
    const previousPrivilegeFilter = (0, $9nHZC.useRef)(filters.privilegeFilter);
    const previousAccessLevelFilter = (0, $9nHZC.useRef)(filters.accessLevelFilter);
    const previousSearchTerm = (0, $9nHZC.useRef)(filters.searchTerm);
    // using refs here so we can memoize the callback
    // the callback is used by a search debounce function
    // memoizing maintains the debounce timeline
    permissionsRef.current = permissions;
    filtersRef.current = filters;
    const totalUnchanged = (0, $9nHZC.useCallback)((total = filtersRef.current.total)=>previousTotalRef.current === 0 || previousTotalRef.current === total, [
        previousTotalRef,
        filtersRef
    ]);
    return (0, $9nHZC.useCallback)(async (page, { searchTerm: searchTerm = filtersRef.current.searchTerm, privilegeFilter: privilegeFilter = filtersRef.current.privilegeFilter, accessLevelFilter: accessLevelFilter = filtersRef.current.accessLevelFilter } = {})=>{
        const filtersChanged = ()=>previousPrivilegeFilter.current !== privilegeFilter || previousAccessLevelFilter.current !== accessLevelFilter || previousSearchTerm.current !== searchTerm;
        if (totalUnchanged() && permissionsRef.current.has(page) && !filtersChanged()) {
            setState({
                page: page
            });
            return;
        }
        previousPrivilegeFilter.current = privilegeFilter;
        previousAccessLevelFilter.current = accessLevelFilter;
        previousSearchTerm.current = searchTerm;
        previousTotalRef.current = filtersRef.current.total;
        setState({
            loadingState: (0, $cM1QH.LoadingState).LOADING,
            accessLevelFilter: accessLevelFilter,
            privilegeFilter: privilegeFilter,
            searchTerm: searchTerm
        });
        try {
            const nonce = (0, $hCBEg.createNonce)();
            nonceRef.current = nonce;
            const state = await getPermissions({
                page: page,
                principalName: searchTerm,
                accessLevel: accessLevelFilter || undefined,
                permission: privilegeFilter === "none" || !privilegeFilter ? undefined : privilegeFilter
            });
            // ensure we update only last request
            if (nonce === nonceRef.current) setState({
                ...state,
                permissions: (0, $hCBEg.getSetPermissions)(permissionsRef.current, page, ()=>(state === null || state === void 0 ? void 0 : state.permissions.get(page)) || [], !totalUnchanged(state === null || state === void 0 ? void 0 : state.total) || filtersChanged()),
                loadingState: (0, $cM1QH.LoadingState).IDLE
            });
        } catch (e) {
            handleError(e);
        }
    }, [
        setState,
        handleError,
        nonceRef,
        permissionsRef,
        filtersRef,
        getPermissions,
        previousPrivilegeFilter,
        previousAccessLevelFilter,
        previousSearchTerm,
        previousTotalRef,
        totalUnchanged
    ]);
};

});
parcelRegister("2u4M7", function(module, exports) {

$parcel$export(module.exports, "CreateInvitationStatus", function () { return $74ae65b31387c765$export$3c57d815ecbd04e3; });
var $74ae65b31387c765$export$3c57d815ecbd04e3;
(function(CreateInvitationStatus) {
    CreateInvitationStatus["invited"] = "invited";
    CreateInvitationStatus["resent"] = "resent";
    CreateInvitationStatus["added"] = "added";
    CreateInvitationStatus["error"] = "error";
})($74ae65b31387c765$export$3c57d815ecbd04e3 || ($74ae65b31387c765$export$3c57d815ecbd04e3 = {}));

});

parcelRegister("b9duc", function(module, exports) {

$parcel$export(module.exports, "delay", function () { return $533761eb0a779881$export$1391212d75b2ee65; });
$parcel$export(module.exports, "debounceSyncPromise", function () { return $533761eb0a779881$export$9eabba63e02d4507; });
function $533761eb0a779881$export$1391212d75b2ee65(fn, wait) {
    return new Promise((resolve, reject)=>{
        window.setTimeout(()=>{
            fn().then(resolve, reject);
        }, wait);
    });
}
function $533761eb0a779881$export$45ee3b73b8783988(fn, wait) {
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        return new Promise((resolve)=>{
            timer = window.setTimeout(()=>resolve(fn(...args)), wait);
        });
    };
}
function $533761eb0a779881$export$cf4020829400e956(fn) {
    let promise = Promise.resolve();
    return (...args)=>{
        promise = promise.then(()=>fn(...args));
        return promise;
    };
}
const $533761eb0a779881$export$9eabba63e02d4507 = (fn, wait)=>$533761eb0a779881$export$45ee3b73b8783988($533761eb0a779881$export$cf4020829400e956(fn), wait);

});

parcelRegister("hCBEg", function(module, exports) {

$parcel$export(module.exports, "getPermissionId", function () { return $403cf00c5246bc73$export$d9b1cc4150bd9c7d; });
$parcel$export(module.exports, "includesPermission", function () { return $403cf00c5246bc73$export$bb7682c3d0438597; });
$parcel$export(module.exports, "getSetPermissions", function () { return $403cf00c5246bc73$export$5cbc4c68cacaf418; });
$parcel$export(module.exports, "getSetAllPermissions", function () { return $403cf00c5246bc73$export$e6f5ee5e20ee5e4f; });
$parcel$export(module.exports, "resetPermissions", function () { return $403cf00c5246bc73$export$29263772f01328f1; });
$parcel$export(module.exports, "createNonce", function () { return $403cf00c5246bc73$export$59fc3d26f2247247; });
$parcel$export(module.exports, "isPermissionEditable", function () { return $403cf00c5246bc73$export$411b85e8a85b7ba8; });
$parcel$export(module.exports, "getAdminLevel", function () { return $403cf00c5246bc73$export$dc2607b62b2e2d67; });
$parcel$export(module.exports, "selectAllPermissions", function () { return $403cf00c5246bc73$export$644661034c5294a1; });
$parcel$export(module.exports, "transformWorkspaceGroup", function () { return $403cf00c5246bc73$export$fab9201a176f90f0; });
$parcel$export(module.exports, "transformEntityToFlat", function () { return $403cf00c5246bc73$export$bac6127af030b3d0; });
$parcel$export(module.exports, "extractNamesFromList", function () { return $403cf00c5246bc73$export$7a9aaa6ebabdd822; });
$parcel$export(module.exports, "mapInheritedUserAndGroupPrivilege", function () { return $403cf00c5246bc73$export$81cea78e97b043bd; });
$parcel$export(module.exports, "getAddUsersErrors", function () { return $403cf00c5246bc73$export$b820d74adbc60c09; });
$parcel$export(module.exports, "showRemoveOwnAccessWarning", function () { return $403cf00c5246bc73$export$4157f1588b169a5d; });
$parcel$export(module.exports, "bulkShowRemoveOwnAccessWarning", function () { return $403cf00c5246bc73$export$4ccc9c34ad5ab97e; });

var $hkfCW = parcelRequire("hkfCW");
var $7RHHu = parcelRequire("7RHHu");
parcelRequire("fequ0");
var $7bBwl = parcelRequire("7bBwl");

var $cM1QH = parcelRequire("cM1QH");

var $bOfxz = parcelRequire("bOfxz");

var $1g8Pl = parcelRequire("1g8Pl");
const $403cf00c5246bc73$export$d9b1cc4150bd9c7d = ({ id: id, name: name, level: level, privilege: privilege })=>`${id}-${name}-${level === "workspace" ? `${level}-${privilege}` : level}`;
const $403cf00c5246bc73$export$bb7682c3d0438597 = (permissions, permission)=>permissions.some((perm)=>$403cf00c5246bc73$export$d9b1cc4150bd9c7d(perm) === $403cf00c5246bc73$export$d9b1cc4150bd9c7d(permission));
const $403cf00c5246bc73$export$5cbc4c68cacaf418 = (permissions, page, setter, reset = false)=>new Map(reset ? [] : permissions).set(page, setter(permissions.get(page) || []));
const $403cf00c5246bc73$export$e6f5ee5e20ee5e4f = (permissions, setter)=>{
    const perms = new Map(permissions);
    perms.forEach((value, key)=>{
        perms.set(key, setter(value));
    });
    return perms;
};
const $403cf00c5246bc73$export$aafd712b16ccb3b1 = (permissions)=>(0, $7RHHu.default)([
        ...permissions.entries()
    ].sort((a, b)=>a[0] - b[0]).map((p)=>p[1]));
const $403cf00c5246bc73$export$29263772f01328f1 = (permissions, limit, filter)=>{
    const perms = $403cf00c5246bc73$export$aafd712b16ccb3b1(permissions);
    return new Map((0, $hkfCW.default)(filter ? perms.filter(filter) : perms, limit).map((p, i)=>[
            i + 1,
            p
        ]));
};
const $403cf00c5246bc73$export$59fc3d26f2247247 = (length = 10, radix = 32)=>Math.random().toString(radix).substring(2, length);
const $403cf00c5246bc73$export$411b85e8a85b7ba8 = (context, level, privilege)=>context === "workspace" && privilege === "create-project" || context === "project" && level === "project" || level === "repository";
const $403cf00c5246bc73$export$dc2607b62b2e2d67 = (isWorkspaceAdmin, isProjectAdmin, isRepoAdmin)=>{
    if (isWorkspaceAdmin) return "workspace";
    if (isProjectAdmin) return "project";
    if (isRepoAdmin) return "repository";
    return undefined;
};
const $403cf00c5246bc73$export$644661034c5294a1 = (permissions, checkedRows, page, context, shouldSelectAll)=>{
    const currentPage = permissions.get(page) || [];
    const rest = checkedRows.filter((p)=>!$403cf00c5246bc73$export$bb7682c3d0438597(currentPage, p));
    const visible = currentPage.reduce((rows, row)=>{
        if (!!shouldSelectAll && $403cf00c5246bc73$export$411b85e8a85b7ba8(context, row.level, row.privilege)) return [
            ...rows,
            row
        ];
        return rows;
    }, []);
    return [
        ...rest,
        ...visible
    ];
};
const $403cf00c5246bc73$export$88dcd5c1adae8021 = (user)=>({
        id: user.mention_id,
        name: user.display_name,
        avatar: user.avatar_url,
        mode: (0, $1g8Pl.AccessMode).users,
        hasAccess: user.has_access
    });
const $403cf00c5246bc73$export$353ce3977502d37d = (group)=>({
        id: `${group.owner.uuid}/${group.slug}`,
        name: group.name,
        mode: (0, $1g8Pl.AccessMode).groups,
        avatar: "",
        hasAccess: group.has_access
    });
const $403cf00c5246bc73$export$fab9201a176f90f0 = (group)=>({
        id: `${group.owner.uuid}/${group.slug}`,
        name: group.name,
        mode: (0, $1g8Pl.AccessMode).groups,
        avatar: "",
        hasAccess: group.has_access
    });
const $403cf00c5246bc73$export$bac6127af030b3d0 = (mode)=>(entity)=>mode === (0, $1g8Pl.AccessMode).users ? $403cf00c5246bc73$export$88dcd5c1adae8021(entity) : $403cf00c5246bc73$export$353ce3977502d37d(entity);
const $403cf00c5246bc73$export$88591d99ee84b80 = (userPrivilege, level)=>({
        level: level,
        mode: (0, $1g8Pl.AccessMode).users,
        avatar: userPrivilege.user.avatar,
        id: userPrivilege.user.account_id,
        name: userPrivilege.user.display_name,
        privilege: userPrivilege.privilege,
        nickname: userPrivilege.user.nickname,
        count: 0,
        slug: ""
    });
const $403cf00c5246bc73$export$9fd72df732d6d18b = (groupPrivilege, level)=>({
        level: level,
        mode: (0, $1g8Pl.AccessMode).groups,
        count: groupPrivilege.group.members.length,
        id: `${groupPrivilege.group.owner.uuid}/${groupPrivilege.group.slug}`,
        name: groupPrivilege.group.name,
        privilege: groupPrivilege.privilege,
        nickname: "",
        avatar: "",
        slug: groupPrivilege.group.slug
    });
const $403cf00c5246bc73$export$9aaa892213e02550 = (mode)=>(entity, level)=>mode === (0, $1g8Pl.AccessMode).users ? $403cf00c5246bc73$export$88591d99ee84b80(entity, level) : $403cf00c5246bc73$export$9fd72df732d6d18b(entity, level);
const $403cf00c5246bc73$export$7a9aaa6ebabdd822 = (list)=>list.map((entity)=>entity.name).join(", ");
const $403cf00c5246bc73$export$81cea78e97b043bd = ({ principal: principal, principal_name: principal_name, permission: permission, access_level: access_level, members_count: members_count = 0 })=>{
    var _principal$links;
    return principal.type === "user" ? {
        mode: (0, $1g8Pl.AccessMode).users,
        avatar: (_principal$links = principal.links) === null || _principal$links === void 0 ? void 0 : _principal$links.avatar.href,
        id: principal.account_id || principal.uuid,
        name: principal_name,
        privilege: permission,
        nickname: principal.nickname,
        count: members_count,
        slug: "",
        level: access_level,
        is_active: principal.is_active
    } : {
        mode: (0, $1g8Pl.AccessMode).groups,
        count: members_count,
        id: `${principal.owner.uuid}/${principal.slug}`,
        name: principal_name,
        privilege: permission,
        nickname: principal.name,
        avatar: "",
        slug: principal.slug,
        level: access_level,
        group_link: principal.links.html.href
    };
};
/**
 * Extracts the names and IDs of entities that failed to update from a
 * NotUpdatedItems array.
 *
 * Joins the names into a comma-separated string and IDs into a
 * double-hyphen-separated string.
 *
 * @param errors - The array of entities that failed to update
 * @returns An object containing the joined entity names and IDs
 */ function $403cf00c5246bc73$var$getEntityNamesAndIds(errors) {
    const entityNames = [];
    const entityIds = [];
    errors.forEach(({ name: name, id: id })=>{
        entityNames.push(`${name}`);
        if (id) entityIds.push(id);
    });
    return {
        entityNames: entityNames.join('", "'),
        entityIds: entityIds.join("--")
    };
}
const $403cf00c5246bc73$export$b820d74adbc60c09 = (items, formatMessage)=>{
    const errors = [];
    items.filter(({ errorMessage: errorMessage })=>errorMessage === (0, $cM1QH.NON_ADMIN_RESTRICTION_ERROR)).forEach(({ name: email })=>{
        errors.push({
            id: "non-admin-failure",
            description: email,
            title: email
        });
    });
    items.filter(({ errorMessage: errorMessage })=>errorMessage === (0, $cM1QH.DOMAIN_RESTRICTION_ERROR)).forEach(({ name: email })=>{
        errors.push({
            id: "domain-restriction-failure",
            description: email,
            title: email
        });
    });
    const inviteFailedErrors = items.filter(({ errorMessage: errorMessage })=>errorMessage === (0, $cM1QH.INVITE_FAILED_ERROR));
    const inviteFailuresLength = inviteFailedErrors.length;
    if (inviteFailuresLength) {
        const { entityNames: entityNames } = $403cf00c5246bc73$var$getEntityNamesAndIds(inviteFailedErrors);
        // bulkInviteTimestamp is used for unique flag IDs
        const bulkInviteTimestamp = Date.now();
        errors.push({
            id: `invite-failure-${bulkInviteTimestamp}`,
            description: formatMessage((0, $bOfxz.default).inviteFailedErrorBody, {
                entity: `"${entityNames}"`,
                count: inviteFailuresLength
            }),
            title: formatMessage((0, $bOfxz.default).inviteFailedErrorHeader, {
                count: inviteFailuresLength
            })
        });
    }
    const badRequestErrors = items.filter(({ errorMessage: errorMessage })=>errorMessage === (0, $cM1QH.BAD_REQUEST_ERROR));
    const badRequestsLength = badRequestErrors.length;
    if (badRequestsLength) {
        const { entityNames: entityNames, entityIds: entityIds } = $403cf00c5246bc73$var$getEntityNamesAndIds(badRequestErrors);
        errors.push({
            id: `bad-request-${entityIds}`,
            description: formatMessage((0, $bOfxz.default).badRequestErrorBody, {
                entity: `"${entityNames}"`,
                count: badRequestsLength
            }),
            title: formatMessage((0, $bOfxz.default).badRequestErrorHeader, {
                count: badRequestsLength
            })
        });
    }
    const unknownErrors = items.filter(({ errorMessage: errorMessage })=>!errorMessage);
    if (unknownErrors.length) {
        const { entityNames: entityNames, entityIds: entityIds } = $403cf00c5246bc73$var$getEntityNamesAndIds(unknownErrors);
        errors.push({
            id: `${(0, $bOfxz.default).unknownAddUserErrorBody.id}-${entityIds}`,
            description: formatMessage((0, $bOfxz.default).unknownAddUserErrorBody, {
                entity: `"${entityNames}"`,
                count: unknownErrors.length
            }),
            title: formatMessage((0, $bOfxz.default).unknownErrorHeader)
        });
    }
    const otherErrors = items.filter(({ errorMessage: errorMessage })=>errorMessage && errorMessage !== (0, $cM1QH.BAD_REQUEST_ERROR) && errorMessage !== (0, $cM1QH.NON_ADMIN_RESTRICTION_ERROR) && errorMessage !== (0, $cM1QH.DOMAIN_RESTRICTION_ERROR) && errorMessage !== (0, $cM1QH.INVITE_FAILED_ERROR));
    otherErrors.forEach(({ errorMessage: errorMessage, id: id, name: name })=>{
        errors.push({
            id: `${(0, $bOfxz.default).userNotAddedHeader.id}-${id}`,
            description: errorMessage,
            title: formatMessage((0, $bOfxz.default).userNotAddedHeader, {
                entity: name
            })
        });
    });
    return errors;
};
const $403cf00c5246bc73$var$getEntityById = (list, id)=>{
    if (!id) return null;
    return list.find((p)=>p.id === id) || null;
};
const $403cf00c5246bc73$export$4157f1588b169a5d = (privileges, mode, entityId, currentUser)=>{
    if (mode === (0, $1g8Pl.AccessMode).users) {
        var _getEntityById;
        return ((_getEntityById = $403cf00c5246bc73$var$getEntityById(privileges, entityId)) === null || _getEntityById === void 0 ? void 0 : _getEntityById.privilege) === (0, $7bBwl.Privilege).admin && entityId === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.account_id);
    } else if (mode === (0, $1g8Pl.AccessMode).groups) {
        const entity = $403cf00c5246bc73$var$getEntityById(privileges, entityId);
        return entity && entity.count > 0 && entity.privilege === (0, $7bBwl.Privilege).admin;
    }
    return false;
};
const $403cf00c5246bc73$export$4ccc9c34ad5ab97e = (checkedEntities, currentUser)=>checkedEntities.some((entity)=>$403cf00c5246bc73$export$4157f1588b169a5d(checkedEntities, entity.mode, entity.id, currentUser));

});
parcelRegister("hkfCW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9d06d2456f93768$export$2e2bcd8739ae039; });

var $6pCwL = parcelRequire("6pCwL");

var $gjAj0 = parcelRequire("gjAj0");

var $1W9wP = parcelRequire("1W9wP");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c9d06d2456f93768$var$nativeCeil = Math.ceil, $c9d06d2456f93768$var$nativeMax = Math.max;
/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */ function $c9d06d2456f93768$var$chunk(array, size, guard) {
    if (guard ? (0, $gjAj0.default)(array, size, guard) : size === undefined) size = 1;
    else size = $c9d06d2456f93768$var$nativeMax((0, $1W9wP.default)(size), 0);
    var length = array == null ? 0 : array.length;
    if (!length || size < 1) return [];
    var index = 0, resIndex = 0, result = Array($c9d06d2456f93768$var$nativeCeil(length / size));
    while(index < length)result[resIndex++] = (0, $6pCwL.default)(array, index, index += size);
    return result;
}
var $c9d06d2456f93768$export$2e2bcd8739ae039 = $c9d06d2456f93768$var$chunk;

});
parcelRegister("6pCwL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ab2f69fae445ccc$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $4ab2f69fae445ccc$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
var $4ab2f69fae445ccc$export$2e2bcd8739ae039 = $4ab2f69fae445ccc$var$baseSlice;

});

parcelRegister("gjAj0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be0a9532edd11f19$export$2e2bcd8739ae039; });

var $i9zf9 = parcelRequire("i9zf9");

var $l3LBL = parcelRequire("l3LBL");

var $2CjdF = parcelRequire("2CjdF");

var $bmzpf = parcelRequire("bmzpf");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $be0a9532edd11f19$var$isIterateeCall(value, index, object) {
    if (!(0, $bmzpf.default)(object)) return false;
    var type = typeof index;
    if (type == "number" ? (0, $l3LBL.default)(object) && (0, $2CjdF.default)(index, object.length) : type == "string" && index in object) return (0, $i9zf9.default)(object[index], value);
    return false;
}
var $be0a9532edd11f19$export$2e2bcd8739ae039 = $be0a9532edd11f19$var$isIterateeCall;

});

parcelRegister("1W9wP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1692995fb66c901c$export$2e2bcd8739ae039; });

var $7llIE = parcelRequire("7llIE");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $1692995fb66c901c$var$toInteger(value) {
    var result = (0, $7llIE.default)(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
var $1692995fb66c901c$export$2e2bcd8739ae039 = $1692995fb66c901c$var$toInteger;

});
parcelRegister("7llIE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $558b579235381a59$export$2e2bcd8739ae039; });

var $jkkPC = parcelRequire("jkkPC");
/** Used as references for various `Number` constants. */ var $558b579235381a59$var$INFINITY = 1 / 0, $558b579235381a59$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $558b579235381a59$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = (0, $jkkPC.default)(value);
    if (value === $558b579235381a59$var$INFINITY || value === -$558b579235381a59$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $558b579235381a59$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
var $558b579235381a59$export$2e2bcd8739ae039 = $558b579235381a59$var$toFinite;

});
parcelRegister("jkkPC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1200b484fb38d54$export$2e2bcd8739ae039; });

var $bDIEc = parcelRequire("bDIEc");

var $bmzpf = parcelRequire("bmzpf");

var $7Wqa8 = parcelRequire("7Wqa8");
/** Used as references for various `Number` constants. */ var $e1200b484fb38d54$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $e1200b484fb38d54$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $e1200b484fb38d54$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $e1200b484fb38d54$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $e1200b484fb38d54$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $e1200b484fb38d54$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ((0, $7Wqa8.default)(value)) return $e1200b484fb38d54$var$NAN;
    if ((0, $bmzpf.default)(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = (0, $bmzpf.default)(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = (0, $bDIEc.default)(value);
    var isBinary = $e1200b484fb38d54$var$reIsBinary.test(value);
    return isBinary || $e1200b484fb38d54$var$reIsOctal.test(value) ? $e1200b484fb38d54$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $e1200b484fb38d54$var$reIsBadHex.test(value) ? $e1200b484fb38d54$var$NAN : +value;
}
var $e1200b484fb38d54$export$2e2bcd8739ae039 = $e1200b484fb38d54$var$toNumber;

});
parcelRegister("bDIEc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8795f8497d6565fa$export$2e2bcd8739ae039; });

var $54prI = parcelRequire("54prI");
/** Used to match leading whitespace. */ var $8795f8497d6565fa$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $8795f8497d6565fa$var$baseTrim(string) {
    return string ? string.slice(0, (0, $54prI.default)(string) + 1).replace($8795f8497d6565fa$var$reTrimStart, "") : string;
}
var $8795f8497d6565fa$export$2e2bcd8739ae039 = $8795f8497d6565fa$var$baseTrim;

});
parcelRegister("54prI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b11108bd882a579$export$2e2bcd8739ae039; });
/** Used to match a single whitespace character. */ var $3b11108bd882a579$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $3b11108bd882a579$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $3b11108bd882a579$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $3b11108bd882a579$export$2e2bcd8739ae039 = $3b11108bd882a579$var$trimmedEndIndex;

});






parcelRegister("7RHHu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b9f61a0590b1a8f$export$2e2bcd8739ae039; });

var $KcLis = parcelRequire("KcLis");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $5b9f61a0590b1a8f$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? (0, $KcLis.default)(array, 1) : [];
}
var $5b9f61a0590b1a8f$export$2e2bcd8739ae039 = $5b9f61a0590b1a8f$var$flatten;

});
parcelRegister("KcLis", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08ae323ad1f355b2$export$2e2bcd8739ae039; });

var $j5Xkb = parcelRequire("j5Xkb");

var $idgpF = parcelRequire("idgpF");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $08ae323ad1f355b2$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = (0, $idgpF.default));
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $08ae323ad1f355b2$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else (0, $j5Xkb.default)(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
var $08ae323ad1f355b2$export$2e2bcd8739ae039 = $08ae323ad1f355b2$var$baseFlatten;

});
parcelRegister("idgpF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4262c316785e89d$export$2e2bcd8739ae039; });

var $jici1 = parcelRequire("jici1");

var $01Qmm = parcelRequire("01Qmm");

var $dEaOb = parcelRequire("dEaOb");
/** Built-in value references. */ var $d4262c316785e89d$var$spreadableSymbol = (0, $jici1.default) ? (0, $jici1.default).isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $d4262c316785e89d$var$isFlattenable(value) {
    return (0, $dEaOb.default)(value) || (0, $01Qmm.default)(value) || !!($d4262c316785e89d$var$spreadableSymbol && value && value[$d4262c316785e89d$var$spreadableSymbol]);
}
var $d4262c316785e89d$export$2e2bcd8739ae039 = $d4262c316785e89d$var$isFlattenable;

});





parcelRegister("arRaZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $899bdc83eec0e072$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $899bdc83eec0e072$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    removeAccessHeader: {
        "id": "frontbucket.settings.permissions.modals.removeAccessHeader",
        "defaultMessage": "Remove access"
    },
    user: {
        "id": "frontbucket.settings.permissions.modals.user",
        "defaultMessage": "user"
    },
    group: {
        "id": "frontbucket.settings.permissions.modals.group",
        "defaultMessage": "group"
    },
    cancel: {
        "id": "frontbucket.settings.permissions.modals.cancel",
        "defaultMessage": "Cancel"
    },
    remove: {
        "id": "frontbucket.settings.permissions.modals.remove",
        "defaultMessage": "Remove"
    },
    addAccessHeader: {
        "id": "frontbucket.settings.permissions.modals.addAccessHeader",
        "defaultMessage": "Add users or groups"
    },
    addWorkspaceAccessHeader: {
        "id": "frontbucket.settings.permissions.modals.addWorkspaceAccessHeader",
        "defaultMessage": "Add workspace permissions"
    },
    confirm: {
        "id": "frontbucket.settings.permissions.modals.confirm",
        "defaultMessage": "Confirm"
    },
    addMembersPlaceholder: {
        "id": "frontbucket.settings.permissions.modals.addMembersPlaceholder",
        "defaultMessage": "Add a group or user by name or email address"
    },
    addMembersByNamePlaceholder: {
        "id": "frontbucket.settings.permissions.modals.addMembersByNamePlaceholder",
        "defaultMessage": "Add a group or user by name"
    },
    addMembersWorkspacePlaceholder: {
        "id": "frontbucket.settings.permissions.modals.addMembersWorkspacePlaceholder",
        "defaultMessage": "Add a group by name"
    },
    bulkEditPrivilegesButton: {
        "id": "frontbucket.settings.permissions.modals.bulkEditPrivilegesButton",
        "defaultMessage": "Confirm"
    },
    bulkEditPrivilegesHeader: {
        "id": "frontbucket.settings.permissions.modals.bulkEditPrivilegesHeader",
        "defaultMessage": "Edit permissions of {count, plural, one {{count} item} other {{count} items}}"
    },
    bulkEditPrivilegesBody: {
        "id": "frontbucket.settings.permissions.modals.bulkEditPrivilegesBody",
        "defaultMessage": "You are about to change access for: {items}."
    },
    selectPermission: {
        "id": "frontbucket.settings.permissions.modals.selectPermission",
        "defaultMessage": "Select permission"
    },
    emailInputMaxedOutError: {
        "id": "frontbucket.settings.permissions.modals.emailInputMaxedOutError",
        "defaultMessage": "Reduce the number of email addresses to no more than {max}."
    },
    entitiesMaxedOutError: {
        "id": "frontbucket.settings.permissions.modals.entitiesMaxedOutError",
        "defaultMessage": "Reduce the number of users and groups to no more than {max}."
    },
    noResults: {
        "id": "frontbucket.settings.permissions.modals.noResults",
        "defaultMessage": "No results found. Type a user\u2019s email address to invite."
    },
    noWorkspaceMembersFound: {
        "id": "frontbucket.settings.permissions.modals.noWorkspaceMembersFound",
        "defaultMessage": "No matching workspace members found."
    },
    beginTyping: {
        "id": "frontbucket.settings.permissions.modals.beginTyping",
        "defaultMessage": "Begin typing to search for a user or group"
    },
    beginTypingGroup: {
        "id": "frontbucket.settings.permissions.modals.beginTypingGroup",
        "defaultMessage": "Begin typing to search for a group"
    },
    createProjectDescription: {
        "id": "frontbucket.settings.permissions.modals.createProjectDescription",
        "defaultMessage": 'Groups are assigned Create permission, which allows users to create projects and have Admin access to those projects. All activities permitted by the "Write" permission are allowed as well.'
    },
    partialInvitationsModalHeader: {
        "id": "frontbucket.settings.permissions.modals.partialInvitationsModalHeader",
        "defaultMessage": "Workspace disallowed {count, plural, one {an invitation} other {some invitations}}"
    },
    close: {
        "id": "frontbucket.settings.permissions.modals.close",
        "defaultMessage": "Close"
    },
    successfulAdditions: {
        "id": "frontbucket.settings.permissions.modals.successfulAdditions",
        "defaultMessage": "The following {count, plural, one {user} other {users}} were successfully given permission to the repository:"
    },
    successfulInvitations: {
        "id": "frontbucket.settings.permissions.modals.successfulInvitations",
        "defaultMessage": "We sent {count, plural, one {an invitation} other {invitations}} to the following {count, plural, one {email} other {emails}}:"
    },
    nonAdminErrorMessage: {
        "id": "frontbucket.settings.permissions.modals.nonAdminErrorMessage",
        "defaultMessage": "The following email {count, plural, one {address was} other {addresses were}} not sent {count, plural, one {an invitation} other {invitations}} because this workspace only allows workspace administrators to send invitations to users who are not workspace members:"
    },
    domainErrorMessage: {
        "id": "frontbucket.settings.permissions.modals.domainErrorMessage",
        "defaultMessage": "The following email {count, plural, one {address was} other {addresses were}} not sent {count, plural, one {an invitation} other {invitations}} because {count, plural, one {it has a domain} other {they include domains}} not allowed for the workspace:"
    },
    hasRepoAccessLozenge: {
        "id": "frontbucket.settings.permissions.hasRepoAccessLozenge",
        "defaultMessage": "Already has repository access"
    },
    hasProjectAccessLozenge: {
        "id": "frontbucket.settings.permissions.hasProjectAccessLozenge",
        "defaultMessage": "Already has project access"
    },
    hasWorkspaceAccessLozenge: {
        "id": "frontbucket.settings.permissions.hasWorkspaceAccessLozenge",
        "defaultMessage": "Already has workspace access"
    }
});

});

parcelRegister("lbYi2", function(module, exports) {

$parcel$export(module.exports, "DescriptionContainer", function () { return $cef9f0d4406bed74$export$31dea26885d599bc; });

var $2xJU3 = parcelRequire("2xJU3");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $3eLm0 = parcelRequire("3eLm0");
const $cef9f0d4406bed74$export$4d4a7b489508589d = /*#__PURE__*/ (0, $2xJU3.default)((0, $3eLm0.SearchResultOption), {
    target: "eusx28y0"
})("padding:1px 0;& > div{background:", (0, $h39Sh.default)("color.background.accent.gray.subtler", (0, $jp7ng).N50), ";border-radius:50%;border:", (0, $h39Sh.default)("space.025", "2px"), " solid ", (0, $h39Sh.default)("color.border.inverse", (0, $jp7ng).N0), ";display:flex;align-items:center;justify-content:center;}");
const $cef9f0d4406bed74$export$31dea26885d599bc = (0, $2xJU3.default)("div", {
    target: "eusx28y1"
})("margin-bottom:", (0, $h39Sh.default)("space.300", "24px"), ";color:#", (0, $h39Sh.default)("color.text.accent.gray.bolder", (0, $jp7ng).N500), ";");

});


parcelRegister("g8zgV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f0f916df4320f83$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $ci5gC = parcelRequire("ci5gC");

var $fXsLf = parcelRequire("fXsLf");

var $3eLm0 = parcelRequire("3eLm0");

var $jajUg = parcelRequire("jajUg");

var $arRaZ = parcelRequire("arRaZ");
const $7f0f916df4320f83$var$BulkChangePrivilegesModal = ({ onClose: onClose, onBulkChange: onBulkChange, isLoading: isLoading, itemNames: itemNames, removeOwnAccessWarning: removeOwnAccessWarning, context: context })=>{
    const [newPrivilege, setNewPrivilege] = (0, $9nHZC.useState)(null);
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    const actions = [
        {
            text: formatMessage((0, $arRaZ.default).cancel),
            onClick: onClose,
            appearance: "subtle"
        },
        {
            text: formatMessage((0, $arRaZ.default).bulkEditPrivilegesButton),
            onClick: ()=>onBulkChange(newPrivilege),
            appearance: "warning",
            isDisabled: !newPrivilege,
            isLoading: isLoading
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ci5gC.default), {
        actions: actions,
        heading: formatMessage((0, $arRaZ.default).bulkEditPrivilegesHeader, {
            count: itemNames.length
        }),
        width: "medium",
        onClose: onClose,
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3eLm0.FormContainer), null, removeOwnAccessWarning, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        tagName: "p"
    }, (0, $arRaZ.default).bulkEditPrivilegesBody, {
        values: {
            items: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("b", null, `"${itemNames.join('", "')}"`)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3eLm0.SelectDropdownContainer), {
        topMarginFactor: 3
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fXsLf.default), {
        fitContainer: true,
        showValueDescription: true,
        showOptionDescription: true,
        customEmptyValueLabel: formatMessage((0, $arRaZ.default).selectPermission),
        onChange: (privilege)=>setNewPrivilege(privilege),
        value: newPrivilege,
        context: context
    }))));
};
var $7f0f916df4320f83$export$2e2bcd8739ae039 = $7f0f916df4320f83$var$BulkChangePrivilegesModal;

});

parcelRegister("7ARA3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39ff81c7b58e4e9f$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $ci5gC = parcelRequire("ci5gC");

var $jajUg = parcelRequire("jajUg");

var $arRaZ = parcelRequire("arRaZ");
const $39ff81c7b58e4e9f$var$PartialInvitationMessageModal = ({ onClose: onClose, emails: emails })=>{
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    const actions = [
        {
            text: formatMessage((0, $arRaZ.default).close),
            onClick: onClose,
            autoFocus: true,
            testId: "partial-invitation-message-modal--close-btn"
        }
    ];
    const { successfullyAdded: successfullyAdded, successfullyInvited: successfullyInvited, nonAdminErrors: nonAdminErrors, domainErrors: domainErrors } = emails;
    const listUsers = (message, listedEmails)=>{
        const emailList = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("ul", null, listedEmails.map((email)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("li", {
                key: `partial-invite-${email}`
            }, email);
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("p", null, formatMessage(message, {
            count: listedEmails.length
        })), emailList, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("br", null));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ci5gC.default), {
        actions: actions,
        heading: formatMessage((0, $arRaZ.default).partialInvitationsModalHeader, {
            count: nonAdminErrors.length + domainErrors.length
        }),
        width: "medium",
        onClose: onClose
    }, !!(successfullyAdded !== null && successfullyAdded !== void 0 && successfullyAdded.length) && listUsers((0, $arRaZ.default).successfulAdditions, successfullyAdded), !!(successfullyInvited !== null && successfullyInvited !== void 0 && successfullyInvited.length) && listUsers((0, $arRaZ.default).successfulInvitations, successfullyInvited), !!(nonAdminErrors !== null && nonAdminErrors !== void 0 && nonAdminErrors.length) && listUsers((0, $arRaZ.default).nonAdminErrorMessage, nonAdminErrors), !!(domainErrors !== null && domainErrors !== void 0 && domainErrors.length) && listUsers((0, $arRaZ.default).domainErrorMessage, domainErrors));
};
var $39ff81c7b58e4e9f$export$2e2bcd8739ae039 = $39ff81c7b58e4e9f$var$PartialInvitationMessageModal;

});



parcelRegister("e2Cxb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c976a46086ec96e8$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $gIheT = parcelRequire("gIheT");

var $5roBI = parcelRequire("5roBI");

var $6cjyK = parcelRequire("6cjyK");
const $c976a46086ec96e8$var$PaginatedTable = ({ total: total, limit: limit, page: page, onRowsChange: onRowsChange, onPageChange: onPageChange, isDisabled: isDisabled, ...props })=>{
    const pageCount = Math.ceil(total / limit);
    const selectedIndex = Math.max(0, Math.min(pageCount - 1, page - 1));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6cjyK.DetailsTableWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $gIheT.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        loadingSpinnerSize: "large"
    }))), total > limit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6cjyK.DetailsTableFooter), {
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6cjyK.DetailsTablePaginationWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5roBI.default), {
        pages: Array.from({
            length: pageCount
        }, (_, i)=>i + 1),
        selectedIndex: selectedIndex,
        onChange: (_, nextPage)=>onPageChange && onPageChange(nextPage)
    }))));
};
var $c976a46086ec96e8$export$2e2bcd8739ae039 = $c976a46086ec96e8$var$PaginatedTable;

});
parcelRegister("6cjyK", function(module, exports) {

$parcel$export(module.exports, "PermissionsTableContainer", function () { return $bdecd480b5779fc4$export$1d25ad6c15024a7; });
$parcel$export(module.exports, "HeaderCheckbox", function () { return $bdecd480b5779fc4$export$b90186699a454308; });
$parcel$export(module.exports, "GroupAvatarContainer", function () { return $bdecd480b5779fc4$export$425f7246a523e6f0; });
$parcel$export(module.exports, "TextFieldSection", function () { return $bdecd480b5779fc4$export$8b1c71a2225e457b; });
$parcel$export(module.exports, "BulkActionsHeader", function () { return $bdecd480b5779fc4$export$4380700b011ee8f7; });
$parcel$export(module.exports, "DetailsTableWrapper", function () { return $bdecd480b5779fc4$export$b10c5b2b7b6fa05f; });
$parcel$export(module.exports, "DetailsTableFooter", function () { return $bdecd480b5779fc4$export$2afc9df8749a4b3d; });
$parcel$export(module.exports, "DetailsTablePaginationWrapper", function () { return $bdecd480b5779fc4$export$a502f5ba14d2b3c0; });
$parcel$export(module.exports, "PrivilegesDropdownText", function () { return $bdecd480b5779fc4$export$c4b9ef3faed98f0a; });
$parcel$export(module.exports, "PrivilegeWithIcon", function () { return $bdecd480b5779fc4$export$47bb670b933dc846; });

var $2xJU3 = parcelRequire("2xJU3");

var $jp7ng = parcelRequire("jp7ng");
var $aP6k3 = parcelRequire("aP6k3");

var $h39Sh = parcelRequire("h39Sh");
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */ function $bdecd480b5779fc4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bdecd480b5779fc4$export$1d25ad6c15024a7 = (0, $2xJU3.default)("div", {
    target: "eqqj07y0"
})("& th{line-height:", (0, $h39Sh.default)("space.300", "24px"), ";}");
const $bdecd480b5779fc4$export$b90186699a454308 = (0, $2xJU3.default)("span", {
    target: "eqqj07y1"
})({
    name: "1170n61",
    styles: "vertical-align:bottom;"
});
const $bdecd480b5779fc4$export$425f7246a523e6f0 = (0, $2xJU3.default)("div", {
    target: "eqqj07y2"
})("background:", (0, $h39Sh.default)("color.background.accent.gray.subtler", (0, $jp7ng).N50), ";border-radius:50%;border:", (0, $h39Sh.default)("space.025", "2px"), " solid ", (0, $h39Sh.default)("color.border.inverse", (0, $jp7ng).N0), ";display:flex;align-items:center;justify-content:center;");
const $bdecd480b5779fc4$export$8b1c71a2225e457b = (0, $2xJU3.default)("div", {
    target: "eqqj07y3"
})("margin-bottom:", (0, $h39Sh.default)("space.200", "16px"), ";margin-top:", (0, $h39Sh.default)("space.150", "12px"), ";display:flex;align-items:center;& > div:nth-of-type(1){margin-right:", (0, $h39Sh.default)("space.200", "16px"), ";}");
const $bdecd480b5779fc4$export$4380700b011ee8f7 = (0, $2xJU3.default)("div", {
    target: "eqqj07y4"
})("display:flex;align-items:center;color:", (0, $h39Sh.default)("color.text.subtle", (0, $jp7ng).N800), ";font-size:", (0, $aP6k3.fontSize)(), ";& button:nth-of-type(2),& button:nth-of-type(3){margin-left:", (0, $h39Sh.default)("space.150", "12px"), ";}");
const $bdecd480b5779fc4$export$b10c5b2b7b6fa05f = (0, $2xJU3.default)("div", {
    target: "eqqj07y5"
})("tbody{border-bottom:", (0, $h39Sh.default)("space.025", "2px"), " solid ", (0, $h39Sh.default)("color.border", (0, $jp7ng).N40), ";> tr{height:", (0, $h39Sh.default)("space.500", "40px"), ";}}");
const $bdecd480b5779fc4$export$2afc9df8749a4b3d = (0, $2xJU3.default)("div", {
    target: "eqqj07y6"
})("display:flex;justify-content:space-between;padding-bottom:", (0, $h39Sh.default)("space.200", "16px"), ";margin-bottom:", (0, $h39Sh.default)("space.800", "64px"), ";pointer-events:", ({ isDisabled: isDisabled })=>isDisabled ? "none" : "auto", ";opacity:", ({ isDisabled: isDisabled })=>isDisabled ? "0.5" : "1", ";");
const $bdecd480b5779fc4$export$a502f5ba14d2b3c0 = (0, $2xJU3.default)("div", {
    target: "eqqj07y7"
})({
    name: "t508yj",
    styles: "flex:1;display:flex;justify-content:center;"
});
const $bdecd480b5779fc4$export$c4b9ef3faed98f0a = (0, $2xJU3.default)("span", {
    target: "eqqj07y8"
})("display:inline-flex;padding:0 ", (0, $h39Sh.default)("space.150", "12px"), ";align-items:center;cursor:default;");
const $bdecd480b5779fc4$export$47bb670b933dc846 = (0, $2xJU3.default)("div", {
    target: "eqqj07y9"
})({
    name: "ariu3h",
    styles: "display:inline-flex;align-items:center;[role='img']{line-height:inherit;}"
});

});


parcelRegister("7qzbC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1bd54c3826b54c6$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $62zzi = parcelRequire("62zzi");

var $agjvf = parcelRequire("agjvf");

var $aiYSe = parcelRequire("aiYSe");

var $3izMR = parcelRequire("3izMR");

var $7Me5Z = parcelRequire("7Me5Z");

var $jajUg = parcelRequire("jajUg");

var $144kQ = parcelRequire("144kQ");

var $4HDjC = parcelRequire("4HDjC");
const $b1bd54c3826b54c6$var$messages = (0, $agjvf.defineMessages)({
    searchPlaceholder: {
        "id": "frontbucket.settings.permissions.searchPlaceholder",
        "defaultMessage": "Search"
    }
});
const $b1bd54c3826b54c6$var$SearchField = ({ api: api, defaultValue: defaultValue })=>{
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    const getPermissions = (0, $4HDjC.useGetPermissions)(api.getPermissions);
    const debouncedGetPermissions = (0, $9nHZC.useMemo)(()=>(0, $62zzi.default)(getPermissions, (0, $7Me5Z.DEBOUNCE_DELAY), {
            trailing: true
        }), [
        getPermissions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $144kQ.SearchFieldContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3izMR.default), {
        testId: "filterQuery",
        "aria-label": formatMessage($b1bd54c3826b54c6$var$messages.searchPlaceholder),
        placeholder: formatMessage($b1bd54c3826b54c6$var$messages.searchPlaceholder),
        onChange: (e)=>{
            debouncedGetPermissions(1, {
                searchTerm: e.target.value
            });
        },
        defaultValue: defaultValue,
        elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $144kQ.SearchIconContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aiYSe))), {
            label: "filterQuery",
            size: "small"
        }))
    }));
};
var $b1bd54c3826b54c6$export$2e2bcd8739ae039 = $b1bd54c3826b54c6$var$SearchField;

});
parcelRegister("62zzi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $465e851d0035a0b6$export$2e2bcd8739ae039; });

var $bmzpf = parcelRequire("bmzpf");

var $c8nwW = parcelRequire("c8nwW");

var $jkkPC = parcelRequire("jkkPC");
/** Error message constants. */ var $465e851d0035a0b6$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $465e851d0035a0b6$var$nativeMax = Math.max, $465e851d0035a0b6$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $465e851d0035a0b6$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($465e851d0035a0b6$var$FUNC_ERROR_TEXT);
    wait = (0, $jkkPC.default)(wait) || 0;
    if ((0, $bmzpf.default)(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $465e851d0035a0b6$var$nativeMax((0, $jkkPC.default)(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $465e851d0035a0b6$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, $c8nwW.default)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, $c8nwW.default)());
    }
    function debounced() {
        var time = (0, $c8nwW.default)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $465e851d0035a0b6$export$2e2bcd8739ae039 = $465e851d0035a0b6$var$debounce;

});
parcelRegister("c8nwW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d587c08fa6bcc51$export$2e2bcd8739ae039; });

var $8kDqY = parcelRequire("8kDqY");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $8d587c08fa6bcc51$var$now = function() {
    return (0, $8kDqY.default).Date.now();
};
var $8d587c08fa6bcc51$export$2e2bcd8739ae039 = $8d587c08fa6bcc51$var$now;

});


parcelRegister("aiYSe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $780ace157d0cd135$var$_react = $780ace157d0cd135$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $780ace157d0cd135$var$_search = $780ace157d0cd135$var$_interopRequireDefault((parcelRequire("e3sce")));
function $780ace157d0cd135$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $780ace157d0cd135$var$SearchIcon = (props)=>/*#__PURE__*/ $780ace157d0cd135$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11"/></svg>`
    }, props, {
        newIcon: $780ace157d0cd135$var$_search.default
    }));
$780ace157d0cd135$var$SearchIcon.displayName = "SearchIcon";
var $780ace157d0cd135$var$_default = module.exports.default = $780ace157d0cd135$var$SearchIcon;

});
parcelRegister("e3sce", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::49c8200fa9e4063bbe4d6edda30f0b3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a3b737b6ae097887$var$_react = $a3b737b6ae097887$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $a3b737b6ae097887$var$_UNSAFE_baseNew = $a3b737b6ae097887$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $a3b737b6ae097887$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a3b737b6ae097887$var$SearchIcon = (props)=>/*#__PURE__*/ $a3b737b6ae097887$var$_react.default.createElement($a3b737b6ae097887$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m14.5 14.5-3.788-3.788m0 0a5.25 5.25 0 1 0-7.425-7.425 5.25 5.25 0 0 0 7.425 7.425Z"/>`
    }, props));
$a3b737b6ae097887$var$SearchIcon.displayName = "SearchIcon";
var $a3b737b6ae097887$var$_default = module.exports.default = $a3b737b6ae097887$var$SearchIcon;

});


parcelRegister("3izMR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $266ed020126f5d81$export$2e2bcd8739ae039; });

var $l5MLt = parcelRequire("l5MLt");

var $9nHZC = parcelRequire("9nHZC");

var $2GEmJ = parcelRequire("2GEmJ");
var $aGitN = parcelRequire("aGitN");
var $kaBIb = parcelRequire("kaBIb");

var $lJJgk = parcelRequire("lJJgk");

var $3HkGY = parcelRequire("3HkGY");

var $cg2AB = parcelRequire("cg2AB");

var $lRW8b = parcelRequire("lRW8b");
var $266ed020126f5d81$var$Textfield = /** @class */ function(_super) {
    (0, $l5MLt.__extends)(Textfield, _super);
    function Textfield() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isFocused: false,
            isHovered: false
        };
        _this.input = null;
        _this.handleOnFocus = function(event) {
            _this.setState({
                isFocused: true
            });
            if (_this.props.onFocus) _this.props.onFocus(event);
        };
        _this.handleOnBlur = function(event) {
            _this.setState({
                isFocused: false
            });
            if (_this.props.onBlur) _this.props.onBlur(event);
        };
        _this.handleOnMouseDown = function(event) {
            /** Running e.preventDefault() on the INPUT prevents double click behaviour */ // Sadly we needed this cast as the target type is being correctly set
            var target = event.target;
            if (target.tagName !== "INPUT") event.preventDefault();
            if (_this.input && !_this.props.isDisabled && document.activeElement !== _this.input) _this.input.focus();
            if (_this.props.onMouseDown) _this.props.onMouseDown(event);
        };
        _this.onMouseEnter = function() {
            if (!_this.props.isDisabled) _this.setState({
                isHovered: true
            });
        };
        _this.onMouseLeave = function() {
            if (!_this.props.isDisabled) _this.setState({
                isHovered: false
            });
        };
        // we want to keep a copy of the ref as well as pass it along
        _this.setInputRef = function(input) {
            _this.input = input;
            var forwardedRef = _this.props.forwardedRef;
            if (!forwardedRef) return;
            if (typeof forwardedRef === "object") // This is a blunder on the part of @types/react
            // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31065
            // .current should be assignable
            // @ts-ignore
            forwardedRef.current = input;
            if (typeof forwardedRef === "function") forwardedRef(input);
        };
        return _this;
    }
    Textfield.prototype.render = function() {
        var _this = this;
        var _a = this.state, isFocused = _a.isFocused, isHovered = _a.isHovered;
        var _b = this.props, // Sadly need to pull these out.
        // It is injected by the HOC and we don't want to pass it onto the HTML input
        // @ts-ignore: not passed onto input
        createAnalyticsEvent = _b.createAnalyticsEvent, // @ts-ignore: not passed onto input
        forwardedRef = _b.forwardedRef, appearance = _b.appearance, isCompact = _b.isCompact, isDisabled = _b.isDisabled, isInvalid = _b.isInvalid, isRequired = _b.isRequired, isReadOnly = _b.isReadOnly, isMonospaced = _b.isMonospaced, theme = _b.theme, width = _b.width, elemAfterInput = _b.elemAfterInput, elemBeforeInput = _b.elemBeforeInput, testId = _b.testId, otherProps = (0, $l5MLt.__rest)(_b, [
            "createAnalyticsEvent",
            "forwardedRef",
            "appearance",
            "isCompact",
            "isDisabled",
            "isInvalid",
            "isRequired",
            "isReadOnly",
            "isMonospaced",
            "theme",
            "width",
            "elemAfterInput",
            "elemBeforeInput",
            "testId"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3HkGY.Theme).Provider, {
            value: theme
        }, (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $lJJgk.default).Consumer, null, function(_a) {
            var mode = _a.mode;
            return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3HkGY.Theme).Consumer, {
                appearance: appearance,
                mode: mode,
                width: width,
                isDisabled: isDisabled,
                isCompact: isCompact,
                isMonospaced: isMonospaced,
                isFocused: isFocused,
                isHovered: isHovered,
                isInvalid: isInvalid
            }, function(tokens) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $lRW8b.default), (0, $l5MLt.__assign)({}, otherProps, {
                    isDisabled: isDisabled,
                    isReadOnly: isReadOnly,
                    isRequired: isRequired,
                    theme: tokens,
                    onBlur: _this.handleOnBlur,
                    onFocus: _this.handleOnFocus,
                    onMouseEnter: _this.onMouseEnter,
                    onMouseLeave: _this.onMouseLeave,
                    onMouseDown: _this.handleOnMouseDown,
                    elemAfterInput: elemAfterInput,
                    elemBeforeInput: elemBeforeInput,
                    innerRef: _this.setInputRef,
                    testId: testId
                }));
            });
        }));
    };
    Textfield.defaultProps = {
        appearance: "standard",
        isCompact: false,
        isMonospaced: false,
        isInvalid: false,
        isRequired: false,
        isReadOnly: false,
        isDisabled: false
    };
    return Textfield;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component);
var $266ed020126f5d81$export$96fbef82278040bb = (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function(props, ref) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($266ed020126f5d81$var$Textfield, (0, $l5MLt.__assign)({}, props, {
        forwardedRef: ref
    }));
});
var $266ed020126f5d81$var$createAndFireEventOnAtlaskit = (0, $2GEmJ.default)("atlaskit");
var $266ed020126f5d81$export$2e2bcd8739ae039 = (0, $aGitN.default)({
    componentName: "textField",
    packageName: (0, $cg2AB.name),
    packageVersion: (0, $cg2AB.version)
})((0, $kaBIb.default)({
    onBlur: $266ed020126f5d81$var$createAndFireEventOnAtlaskit({
        action: "blurred",
        actionSubject: "textField",
        attributes: {
            componentName: "textField",
            packageName: (0, $cg2AB.name),
            packageVersion: (0, $cg2AB.version)
        }
    }),
    onFocus: $266ed020126f5d81$var$createAndFireEventOnAtlaskit({
        action: "focused",
        actionSubject: "textField",
        attributes: {
            componentName: "textField",
            packageName: (0, $cg2AB.name),
            packageVersion: (0, $cg2AB.version)
        }
    })
})($266ed020126f5d81$export$96fbef82278040bb));

});
parcelRegister("lJJgk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd30e91b905ce010$export$2e2bcd8739ae039; });

var $7fdI4 = parcelRequire("7fdI4");
var // Create default global light theme
$fd30e91b905ce010$export$2e2bcd8739ae039 = (0, $7fdI4.createTheme)(function() {
    return {
        mode: "light"
    };
});

});
parcelRegister("7fdI4", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $5464919ff78d7227$export$25d302a5b900a763; });

var $ephVG = parcelRequire("ephVG");

var $9nHZC = parcelRequire("9nHZC");
function $5464919ff78d7227$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function(getTokens, props) {
        return getTokens(props);
    };
    /* Internally, Theme uses React Context, with internal providers and consumers.
       The React Context passes only a function that gets props, and turns them into tokens. This
          function gets mixed as more Providers with their own themes are added. This mixed function
          is ultimately picked up by Consumers, which implement a context consumer internally to fetch
          the theme. */ var ThemeContext = (0, $9nHZC.createContext)(defaultGetTokens);
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $ephVG.__rest)(props, [
            "children"
        ]);
        var theme = (0, $9nHZC.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = themeFn(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, children(tokens));
    }
    /* The Theme Provider takes regular nodes as its child, but also takes a *theme function*
       - The theme function takes a set of props, as well as a function (getTokens) that can
          turn props into tokens.
       - The getTokens function isn't called immediately - instead the props are passed
          through a mix of parent theming functions
       Children of this provider will receive this mixed theme
    */ function Provider(props) {
        var themeFn = (0, $9nHZC.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $9nHZC.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider
    };
}

});
parcelRegister("ephVG", function(module, exports) {

$parcel$export(module.exports, "__rest", function () { return $a7d14ee0d3a681b8$export$3c9a16f847548506; });
$parcel$export(module.exports, "__makeTemplateObject", function () { return $a7d14ee0d3a681b8$export$4fb47efe1390b86f; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $a7d14ee0d3a681b8$var$extendStatics = function(d, b) {
    $a7d14ee0d3a681b8$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a7d14ee0d3a681b8$var$extendStatics(d, b);
};
function $a7d14ee0d3a681b8$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a7d14ee0d3a681b8$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a7d14ee0d3a681b8$export$18ce0697a983be9b = function() {
    $a7d14ee0d3a681b8$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a7d14ee0d3a681b8$export$18ce0697a983be9b.apply(this, arguments);
};
function $a7d14ee0d3a681b8$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a7d14ee0d3a681b8$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a7d14ee0d3a681b8$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a7d14ee0d3a681b8$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $a7d14ee0d3a681b8$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $a7d14ee0d3a681b8$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $a7d14ee0d3a681b8$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $a7d14ee0d3a681b8$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a7d14ee0d3a681b8$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a7d14ee0d3a681b8$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $a7d14ee0d3a681b8$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $a7d14ee0d3a681b8$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $a7d14ee0d3a681b8$export$45d3717a4c69092e(o, m, p);
}
function $a7d14ee0d3a681b8$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a7d14ee0d3a681b8$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a7d14ee0d3a681b8$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a7d14ee0d3a681b8$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a7d14ee0d3a681b8$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a7d14ee0d3a681b8$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $a7d14ee0d3a681b8$export$10c90e4f7922046c(v) {
    return this instanceof $a7d14ee0d3a681b8$export$10c90e4f7922046c ? (this.v = v, this) : new $a7d14ee0d3a681b8$export$10c90e4f7922046c(v);
}
function $a7d14ee0d3a681b8$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a7d14ee0d3a681b8$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a7d14ee0d3a681b8$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a7d14ee0d3a681b8$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $a7d14ee0d3a681b8$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a7d14ee0d3a681b8$export$19a8beecd37a4c45 === "function" ? $a7d14ee0d3a681b8$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a7d14ee0d3a681b8$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $a7d14ee0d3a681b8$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $a7d14ee0d3a681b8$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a7d14ee0d3a681b8$export$45d3717a4c69092e(result, mod, k);
    }
    $a7d14ee0d3a681b8$var$__setModuleDefault(result, mod);
    return result;
}
function $a7d14ee0d3a681b8$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a7d14ee0d3a681b8$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $a7d14ee0d3a681b8$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $a7d14ee0d3a681b8$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $a7d14ee0d3a681b8$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $a7d14ee0d3a681b8$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $a7d14ee0d3a681b8$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $a7d14ee0d3a681b8$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $a7d14ee0d3a681b8$export$2e2bcd8739ae039 = {
    __extends: $a7d14ee0d3a681b8$export$a8ba968b8961cb8a,
    __assign: $a7d14ee0d3a681b8$export$18ce0697a983be9b,
    __rest: $a7d14ee0d3a681b8$export$3c9a16f847548506,
    __decorate: $a7d14ee0d3a681b8$export$29e00dfd3077644b,
    __param: $a7d14ee0d3a681b8$export$d5ad3fd78186038f,
    __metadata: $a7d14ee0d3a681b8$export$f1db080c865becb9,
    __awaiter: $a7d14ee0d3a681b8$export$1050f835b63b671e,
    __generator: $a7d14ee0d3a681b8$export$67ebef60e6f28a6,
    __createBinding: $a7d14ee0d3a681b8$export$45d3717a4c69092e,
    __exportStar: $a7d14ee0d3a681b8$export$f33643c0debef087,
    __values: $a7d14ee0d3a681b8$export$19a8beecd37a4c45,
    __read: $a7d14ee0d3a681b8$export$8d051b38c9118094,
    __spread: $a7d14ee0d3a681b8$export$afc72e2116322959,
    __spreadArrays: $a7d14ee0d3a681b8$export$6388937ca91ccae8,
    __spreadArray: $a7d14ee0d3a681b8$export$1216008129fb82ed,
    __await: $a7d14ee0d3a681b8$export$10c90e4f7922046c,
    __asyncGenerator: $a7d14ee0d3a681b8$export$e427f37a30a4de9b,
    __asyncDelegator: $a7d14ee0d3a681b8$export$bbd80228419bb833,
    __asyncValues: $a7d14ee0d3a681b8$export$e3b29a3d6162315f,
    __makeTemplateObject: $a7d14ee0d3a681b8$export$4fb47efe1390b86f,
    __importStar: $a7d14ee0d3a681b8$export$c21735bcef00d192,
    __importDefault: $a7d14ee0d3a681b8$export$da59b14a69baef04,
    __classPrivateFieldGet: $a7d14ee0d3a681b8$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $a7d14ee0d3a681b8$export$d40a35129aaff81f,
    __classPrivateFieldIn: $a7d14ee0d3a681b8$export$81fdc39f203e4e04,
    __addDisposableResource: $a7d14ee0d3a681b8$export$88ac25d8e944e405,
    __disposeResources: $a7d14ee0d3a681b8$export$8f076105dc360e92
};

});



parcelRegister("3HkGY", function(module, exports) {

$parcel$export(module.exports, "Theme", function () { return $2b1570437eaea540$export$14faa19a0f3bbeb2; });

var $l5MLt = parcelRequire("l5MLt");

var $7fdI4 = parcelRequire("7fdI4");

var $am60Z = parcelRequire("am60Z");

var $4dHqe = parcelRequire("4dHqe");
var $2b1570437eaea540$var$disabledRules = {
    light: {
        backgroundColor: $4dHqe.defaultBackgroundColor.light,
        backgroundColorFocus: $4dHqe.disabledBackgroundColor.light,
        backgroundColorHover: $4dHqe.disabledBackgroundColor.light,
        borderColor: $4dHqe.defaultBackgroundColor.light,
        borderColorFocus: $4dHqe.defaultBorderColorFocus.light,
        textColor: $4dHqe.disabledTextColor.light
    },
    dark: {
        backgroundColor: $4dHqe.defaultBackgroundColor.dark,
        backgroundColorFocus: $4dHqe.disabledBackgroundColor.dark,
        backgroundColorHover: $4dHqe.disabledBackgroundColor.dark,
        borderColor: $4dHqe.defaultBackgroundColor.dark,
        borderColorFocus: $4dHqe.defaultBorderColorFocus.dark,
        textColor: $4dHqe.disabledTextColor.dark
    }
};
var $2b1570437eaea540$var$invalidRules = {
    light: {
        backgroundColor: $4dHqe.defaultBackgroundColor.light,
        backgroundColorFocus: $4dHqe.defaultBackgroundColorFocus.light,
        backgroundColorHover: $4dHqe.defaultBackgroundColorHover.light,
        borderColor: $4dHqe.invalidBorderColor.light,
        borderColorFocus: $4dHqe.defaultBorderColorFocus.light
    },
    dark: {
        backgroundColor: $4dHqe.defaultBackgroundColor.dark,
        backgroundColorFocus: $4dHqe.defaultBackgroundColorFocus.dark,
        backgroundColorHover: $4dHqe.defaultBackgroundColorHover.dark,
        borderColor: $4dHqe.invalidBorderColor.dark,
        borderColorFocus: $4dHqe.defaultBorderColorFocus.dark
    }
};
var $2b1570437eaea540$var$backgroundColor = {
    standard: $4dHqe.defaultBackgroundColor,
    subtle: $4dHqe.transparent,
    none: $4dHqe.transparent
};
var $2b1570437eaea540$var$backgroundColorFocus = {
    standard: $4dHqe.defaultBackgroundColorFocus,
    subtle: $4dHqe.defaultBackgroundColorFocus,
    none: $4dHqe.transparent
};
var $2b1570437eaea540$var$backgroundColorHover = {
    standard: $4dHqe.defaultBackgroundColorHover,
    subtle: $4dHqe.defaultBackgroundColorHover,
    none: $4dHqe.transparent
};
var $2b1570437eaea540$var$borderColor = {
    standard: $4dHqe.defaultBorderColor,
    subtle: $4dHqe.transparent,
    none: $4dHqe.transparent
};
var $2b1570437eaea540$var$borderColorFocus = {
    standard: $4dHqe.defaultBorderColorFocus,
    subtle: $4dHqe.defaultBorderColorFocus,
    none: $4dHqe.transparent
};
var $2b1570437eaea540$var$getContainerBackgroundColor = function(_a) {
    var appearance = _a.appearance, isFocused = _a.isFocused, isHovered = _a.isHovered, isDisabled = _a.isDisabled, isInvalid = _a.isInvalid, mode = _a.mode;
    if (isDisabled) {
        // switch on focus then switch on hover
        if (isFocused) return {
            backgroundColor: $2b1570437eaea540$var$disabledRules[mode].backgroundColorFocus
        };
        if (isHovered) return {
            backgroundColor: $2b1570437eaea540$var$disabledRules[mode].backgroundColorHover
        };
        return {
            backgroundColor: $2b1570437eaea540$var$disabledRules[mode].backgroundColor
        };
    }
    if (isInvalid) {
        // switch on focus then switch on hover
        if (isFocused) return {
            backgroundColor: $2b1570437eaea540$var$invalidRules[mode].backgroundColorFocus
        };
        if (isHovered) return {
            backgroundColor: $2b1570437eaea540$var$invalidRules[mode].backgroundColorHover
        };
        return {
            backgroundColor: $2b1570437eaea540$var$invalidRules[mode].backgroundColor
        };
    }
    // switch on appearance then focus then switch on hover
    if (isFocused) return {
        backgroundColor: $2b1570437eaea540$var$backgroundColorFocus[appearance][mode]
    };
    if (isHovered) return {
        backgroundColor: $2b1570437eaea540$var$backgroundColorHover[appearance][mode]
    };
    return {
        backgroundColor: $2b1570437eaea540$var$backgroundColor[appearance][mode]
    };
};
var $2b1570437eaea540$var$getContainerBorderColor = function(_a) {
    var appearance = _a.appearance, isFocused = _a.isFocused, isDisabled = _a.isDisabled, isInvalid = _a.isInvalid, mode = _a.mode;
    if (isDisabled) {
        // switch on focus then switch on hover
        if (isFocused) return {
            borderColor: $2b1570437eaea540$var$disabledRules[mode].borderColorFocus
        };
        return {
            borderColor: $2b1570437eaea540$var$disabledRules[mode].borderColor
        };
    }
    if (isInvalid) {
        // switch on focus then switch on hover
        if (isFocused) return {
            borderColor: $2b1570437eaea540$var$invalidRules[mode].borderColorFocus
        };
        return {
            borderColor: $2b1570437eaea540$var$invalidRules[mode].borderColor
        };
    }
    // switch on appearance then focus then switch on hover
    if (isFocused) return {
        borderColor: $2b1570437eaea540$var$borderColorFocus[appearance][mode]
    };
    return {
        borderColor: $2b1570437eaea540$var$borderColor[appearance][mode]
    };
};
var $2b1570437eaea540$var$getPlaceholderColor = function(_a) {
    var isDisabled = _a.isDisabled, mode = _a.mode;
    return isDisabled ? $2b1570437eaea540$var$disabledRules[mode].textColor : $4dHqe.placeholderTextColor[mode];
};
// can't group these placeholder styles into one block because browsers drop
// entire style blocks when any single selector fails to parse
var $2b1570437eaea540$var$getPlaceholderStyle = function(props) {
    return {
        "&::-webkit-input-placeholder": {
            /* WebKit, Blink, Edge */ color: $2b1570437eaea540$var$getPlaceholderColor(props)
        },
        "&::-moz-placeholder": {
            /* Mozilla Firefox 19+ */ color: $2b1570437eaea540$var$getPlaceholderColor(props),
            opacity: 1
        },
        "&::-ms-input-placeholder": {
            /* Microsoft Edge */ color: $2b1570437eaea540$var$getPlaceholderColor(props)
        },
        "&:-ms-input-placeholder": {
            /* Internet Explorer 10-11 */ color: $2b1570437eaea540$var$getPlaceholderColor(props)
        }
    };
};
var $2b1570437eaea540$var$getMaxWidth = function(_a) {
    var width = _a.width;
    if (!width) return "100%";
    switch(width){
        case "xsmall":
            return "80px";
        case "small":
            return "160px";
        case "medium":
            return "240px";
        case "large":
            return "320px";
        case "xlarge":
            return "480px";
        default:
            return width + "px";
    }
};
var $2b1570437eaea540$export$14faa19a0f3bbeb2 = (0, $7fdI4.createTheme)(function(props) {
    return {
        container: (0, $l5MLt.__assign)((0, $l5MLt.__assign)((0, $l5MLt.__assign)({
            alignItems: "center"
        }, $2b1570437eaea540$var$getContainerBackgroundColor(props)), $2b1570437eaea540$var$getContainerBorderColor(props)), {
            borderRadius: "3px",
            borderWidth: "2px",
            borderStyle: props.appearance === "none" ? "none" : "solid",
            boxSizing: "border-box",
            color: props.isDisabled ? $2b1570437eaea540$var$disabledRules[props.mode].textColor : $4dHqe.textColor[props.mode],
            cursor: props.isDisabled ? "not-allowed" : "text",
            display: "flex",
            flex: "1 1 100%",
            fontSize: (0, $am60Z.fontSize)() + "px",
            justifyContent: "space-between",
            maxWidth: $2b1570437eaea540$var$getMaxWidth(props),
            overflow: "hidden",
            transition: "background-color 0.2s ease-in-out, border-color 0.2s ease-in-out",
            wordWrap: "break-word",
            verticalAlign: "top",
            pointerEvents: "auto"
        }),
        input: (0, $l5MLt.__assign)({
            backgroundColor: "transparent",
            border: 0,
            boxSizing: "border-box",
            color: "inherit",
            cursor: "inherit",
            fontFamily: props.isMonospaced ? (0, $am60Z.codeFontFamily)() : "inherit",
            fontSize: (0, $am60Z.fontSize)() + "px",
            minWidth: "0",
            outline: "none",
            padding: (props.isCompact ? (0, $am60Z.gridSize)() / 2 : (0, $am60Z.gridSize)()) + "px " + ((0, $am60Z.gridSize)() - 2) + "px",
            width: "100%",
            height: (props.isCompact ? (0, $am60Z.gridSize)() * 3.5 : (0, $am60Z.gridSize)() * 4.5) / (0, $am60Z.fontSize)() + "em",
            lineHeight: (0, $am60Z.gridSize)() * 2.5 / (0, $am60Z.fontSize)(),
            "&[disabled]": {
                // Safari puts on some difficult to remove styles, mainly for disabled inputs
                // but we want full control so need to override them in all cases
                WebkitTextFillColor: "unset",
                WebkitOpacity: 1
            },
            "&::-ms-clear": {
                display: "none"
            },
            "&:invalid": {
                boxShadow: "none"
            }
        }, $2b1570437eaea540$var$getPlaceholderStyle(props))
    };
});
var $2b1570437eaea540$export$8c52b1fd9e189b5 = {
    backgroundColor: $2b1570437eaea540$var$backgroundColor,
    backgroundColorFocus: $2b1570437eaea540$var$backgroundColorFocus,
    backgroundColorHover: $2b1570437eaea540$var$backgroundColorHover,
    borderColor: $2b1570437eaea540$var$borderColor,
    borderColorFocus: $2b1570437eaea540$var$borderColorFocus,
    placeholderTextColor: $4dHqe.placeholderTextColor,
    textColor: $4dHqe.textColor,
    invalidRules: $2b1570437eaea540$var$invalidRules,
    disabledRules: $2b1570437eaea540$var$disabledRules
};

});
parcelRegister("am60Z", function(module, exports) {

$parcel$export(module.exports, "gridSize", function () { return $78a09fe1a215020a$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "fontSize", function () { return $78a09fe1a215020a$export$85e3c3ca0c6fb93; });
$parcel$export(module.exports, "codeFontFamily", function () { return $78a09fe1a215020a$export$356129969ee49c55; });

var $ephVG = parcelRequire("ephVG");

var $13MK1 = parcelRequire("13MK1");

var $7OtEo = parcelRequire("7OtEo");
var $78a09fe1a215020a$export$521f2c0e5c12a14d = "__FLATTENED__";
var $78a09fe1a215020a$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $78a09fe1a215020a$export$c93026a968943f95 = "light";
var $78a09fe1a215020a$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $78a09fe1a215020a$export$7a57f79000377ca2 = function() {
    return 3;
};
var $78a09fe1a215020a$export$6d8204c2cb2e06b8 = function() {
    return 8;
};
var $78a09fe1a215020a$export$85e3c3ca0c6fb93 = function() {
    return 14;
};
var $78a09fe1a215020a$export$6746fe0d9c9fab54 = function() {
    return 11;
};
var $78a09fe1a215020a$export$a5975749f0374264 = function() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $78a09fe1a215020a$export$356129969ee49c55 = function() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $78a09fe1a215020a$export$8e24544ddba725ee = function(color, outlineWidth) {
    if (color === void 0) color = (0, $7OtEo.B100);
    if (outlineWidth === void 0) outlineWidth = $78a09fe1a215020a$export$6d8204c2cb2e06b8() / 4;
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px " + outlineWidth + "px " + color + ";\n  }\n";
};
var $78a09fe1a215020a$export$c0dd343266bc3261 = function() {
    return "\n  box-shadow: none;\n";
};
var $78a09fe1a215020a$export$7be255094ccdc533 = {
    card: function() {
        return 100;
    },
    dialog: function() {
        return 300;
    },
    navigation: function() {
        return 200;
    },
    layer: function() {
        return 400;
    },
    blanket: function() {
        return 500;
    },
    modal: function() {
        return 510;
    },
    flag: function() {
        return 600;
    },
    spotlight: function() {
        return 700;
    },
    tooltip: function() {
        return 800;
    }
};
var $78a09fe1a215020a$export$a1b3edb637fb4f35 = function() {
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $78a09fe1a215020a$export$ba1d834b86d72a09 = function() {
    return (0, $13MK1.css)($78a09fe1a215020a$var$templateObject_1 || ($78a09fe1a215020a$var$templateObject_1 = (0, $ephVG.__makeTemplateObject)([
        "\n  border: 0 !important;\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  height: 1px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  position: absolute !important;\n  width: 1px !important;\n  white-space: nowrap !important;\n"
    ], [
        "\n  border: 0 !important;\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  height: 1px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  position: absolute !important;\n  width: 1px !important;\n  white-space: nowrap !important;\n"
    ])));
};
var $78a09fe1a215020a$export$e497e856b4f89fcd = function() {
    return {
        css: {
            backgroundColor: (0, $7OtEo.skeleton)(),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: (0, $7OtEo.skeleton)()
            },
            to: {
                backgroundColor: (0, $7OtEo.N30A)
            }
        }
    };
};
var $78a09fe1a215020a$var$templateObject_1;

});
parcelRegister("7OtEo", function(module, exports) {

$parcel$export(module.exports, "R400", function () { return $5b0433e9a769a53a$export$2010d0fb4295b346; });
$parcel$export(module.exports, "B75", function () { return $5b0433e9a769a53a$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $5b0433e9a769a53a$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "N0", function () { return $5b0433e9a769a53a$export$29a4f05edc054374; });
$parcel$export(module.exports, "N10", function () { return $5b0433e9a769a53a$export$e655ef011c4aa1a2; });
$parcel$export(module.exports, "N20", function () { return $5b0433e9a769a53a$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $5b0433e9a769a53a$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N40", function () { return $5b0433e9a769a53a$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N70", function () { return $5b0433e9a769a53a$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N100", function () { return $5b0433e9a769a53a$export$d6447c357493214f; });
$parcel$export(module.exports, "N900", function () { return $5b0433e9a769a53a$export$fbda843f0a27fe96; });
$parcel$export(module.exports, "N30A", function () { return $5b0433e9a769a53a$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN600", function () { return $5b0433e9a769a53a$export$5368d76ae4fbbda7; });
$parcel$export(module.exports, "DN90", function () { return $5b0433e9a769a53a$export$682927c6ed76be02; });
$parcel$export(module.exports, "DN40", function () { return $5b0433e9a769a53a$export$33ff357f6620b39; });
$parcel$export(module.exports, "DN30", function () { return $5b0433e9a769a53a$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN20", function () { return $5b0433e9a769a53a$export$9776a6e503bdbf76; });
$parcel$export(module.exports, "DN10", function () { return $5b0433e9a769a53a$export$6c813d5160dff5db; });
$parcel$export(module.exports, "skeleton", function () { return $5b0433e9a769a53a$export$2a0674ff2eb10214; });

var $2pWXB = parcelRequire("2pWXB");
var $5b0433e9a769a53a$export$4b84fd0e2c617bd = "#FFEBE6";
var $5b0433e9a769a53a$export$b34b069eff244586 = "#FFBDAD";
var $5b0433e9a769a53a$export$be802dd0d8b57f35 = "#FF8F73";
var $5b0433e9a769a53a$export$60847d42f9da92a6 = "#FF7452";
var $5b0433e9a769a53a$export$4a7404f376229999 = "#FF5630";
var $5b0433e9a769a53a$export$2010d0fb4295b346 = "#DE350B";
var $5b0433e9a769a53a$export$2837b5a1a71d5c02 = "#BF2600";
var $5b0433e9a769a53a$export$8d9596b529bbb9cf = "#FFFAE6";
var $5b0433e9a769a53a$export$41060a744ab0b7ae = "#FFF0B3";
var $5b0433e9a769a53a$export$1cc05bbbf340e559 = "#FFE380";
var $5b0433e9a769a53a$export$5aae31392d72caaa = "#FFC400";
var $5b0433e9a769a53a$export$c6930421db9fa514 = "#FFAB00";
var $5b0433e9a769a53a$export$59619663aa6500fb = "#FF991F";
var $5b0433e9a769a53a$export$874739ea9e379ab6 = "#FF8B00";
var $5b0433e9a769a53a$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $5b0433e9a769a53a$export$69a3bf21b9686c2b = "#ABF5D1";
var $5b0433e9a769a53a$export$afbce1382ec95f73 = "#79F2C0";
var $5b0433e9a769a53a$export$747d86715d4175de = "#57D9A3";
var $5b0433e9a769a53a$export$940e1f69e873f202 = "#36B37E";
var $5b0433e9a769a53a$export$a49394138f7b8e85 = "#00875A";
var $5b0433e9a769a53a$export$6fa04827ac68a4fb = "#006644";
var $5b0433e9a769a53a$export$226de0355ed012f8 = "#DEEBFF";
var $5b0433e9a769a53a$export$8c13c2ee36917869 = "#B3D4FF";
var $5b0433e9a769a53a$export$ecfc1dff386a3e7a = "#4C9AFF";
var $5b0433e9a769a53a$export$215b7063051591f1 = "#2684FF";
var $5b0433e9a769a53a$export$e62e8919cca44969 = "#0065FF";
var $5b0433e9a769a53a$export$b3de0ae08da2ce64 = "#0052CC";
var $5b0433e9a769a53a$export$a6ee3d71bc067634 = "#0747A6";
var $5b0433e9a769a53a$export$363e4475840015bb = "#EAE6FF";
var $5b0433e9a769a53a$export$4b0a4417ed59760f = "#C0B6F2";
var $5b0433e9a769a53a$export$6011520a64d9a187 = "#998DD9";
var $5b0433e9a769a53a$export$a7175d4e9206bc80 = "#8777D9";
var $5b0433e9a769a53a$export$b48405b95304b5a1 = "#6554C0";
var $5b0433e9a769a53a$export$c71e4279dd54a18d = "#5243AA";
var $5b0433e9a769a53a$export$147899de772240ec = "#403294";
var $5b0433e9a769a53a$export$2cf711fe14c66f06 = "#E6FCFF";
var $5b0433e9a769a53a$export$7a8f4d33f6f9772c = "#B3F5FF";
var $5b0433e9a769a53a$export$776c9c497ef08533 = "#79E2F2";
var $5b0433e9a769a53a$export$69cb3ca10c1e330e = "#00C7E6";
var $5b0433e9a769a53a$export$9dc1ef0f3f48059b = "#00B8D9";
var $5b0433e9a769a53a$export$7c835c78b6fcdef8 = "#00A3BF";
var $5b0433e9a769a53a$export$6036577f95c3877e = "#008DA6";
var $5b0433e9a769a53a$export$29a4f05edc054374 = "#FFFFFF";
var $5b0433e9a769a53a$export$e655ef011c4aa1a2 = "#FAFBFC";
var $5b0433e9a769a53a$export$9fdfb749e33cdf97 = "#F4F5F7";
var $5b0433e9a769a53a$export$3e51e8f1440314ba = "#EBECF0";
var $5b0433e9a769a53a$export$1ce2d1575d444ceb = "#DFE1E6";
var $5b0433e9a769a53a$export$8754fc7e6d8b3000 = "#C1C7D0";
var $5b0433e9a769a53a$export$c2e91cbeada39b8b = "#B3BAC5";
var $5b0433e9a769a53a$export$5f71e19f3a7ad9de = "#A5ADBA";
var $5b0433e9a769a53a$export$eaa8c8a70ac22806 = "#97A0AF";
var $5b0433e9a769a53a$export$7c87d337fb91a97d = "#8993A4";
var $5b0433e9a769a53a$export$d6447c357493214f = "#7A869A";
var $5b0433e9a769a53a$export$f563ee71e9ee74cd = "#6B778C";
var $5b0433e9a769a53a$export$e2ef2124cf4024b1 = "#5E6C84";
var $5b0433e9a769a53a$export$eece5f492e429f08 = "#505F79";
var $5b0433e9a769a53a$export$c39c0fe0f26207ae = "#42526E";
var $5b0433e9a769a53a$export$7090862dc3038a9f = "#344563";
var $5b0433e9a769a53a$export$ad0bacf983b7ddaa = "#253858";
var $5b0433e9a769a53a$export$7d61b15e0da132af = "#172B4D";
var $5b0433e9a769a53a$export$fbda843f0a27fe96 = "#091E42";
var $5b0433e9a769a53a$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $5b0433e9a769a53a$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $5b0433e9a769a53a$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $5b0433e9a769a53a$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $5b0433e9a769a53a$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $5b0433e9a769a53a$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $5b0433e9a769a53a$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $5b0433e9a769a53a$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $5b0433e9a769a53a$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $5b0433e9a769a53a$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $5b0433e9a769a53a$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $5b0433e9a769a53a$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $5b0433e9a769a53a$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $5b0433e9a769a53a$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $5b0433e9a769a53a$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $5b0433e9a769a53a$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $5b0433e9a769a53a$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $5b0433e9a769a53a$export$2f6319cf7d736c2a = "#E6EDFA";
var $5b0433e9a769a53a$export$95126bc8884d6634 = "#DCE5F5";
var $5b0433e9a769a53a$export$8338d8c35d44ff1 = "#CED9EB";
var $5b0433e9a769a53a$export$5368d76ae4fbbda7 = "#B8C7E0";
var $5b0433e9a769a53a$export$9f0a771d16ec8d36 = "#ABBBD6";
var $5b0433e9a769a53a$export$abcf8c38338b4aa5 = "#9FB0CC";
var $5b0433e9a769a53a$export$97e81faa16a182c7 = "#8C9CB8";
var $5b0433e9a769a53a$export$bfe21c59123ecf33 = "#7988A3";
var $5b0433e9a769a53a$export$ee82aa2ea6a1558 = "#67758F";
var $5b0433e9a769a53a$export$682927c6ed76be02 = "#56637A";
var $5b0433e9a769a53a$export$91fd9994c5be9757 = "#455166";
var $5b0433e9a769a53a$export$d281fbfe3cff2df6 = "#3B475C";
var $5b0433e9a769a53a$export$3902c91d8b98a753 = "#313D52";
var $5b0433e9a769a53a$export$8e8133c1ba5845b5 = "#283447";
var $5b0433e9a769a53a$export$33ff357f6620b39 = "#202B3D";
var $5b0433e9a769a53a$export$633847cf062b69e0 = "#1B2638";
var $5b0433e9a769a53a$export$9776a6e503bdbf76 = "#121A29";
var $5b0433e9a769a53a$export$6c813d5160dff5db = "#0E1624";
var $5b0433e9a769a53a$export$3d4f271a500072a = "#0D1424";
var $5b0433e9a769a53a$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $5b0433e9a769a53a$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $5b0433e9a769a53a$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $5b0433e9a769a53a$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $5b0433e9a769a53a$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $5b0433e9a769a53a$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $5b0433e9a769a53a$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $5b0433e9a769a53a$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $5b0433e9a769a53a$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $5b0433e9a769a53a$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $5b0433e9a769a53a$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $5b0433e9a769a53a$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $5b0433e9a769a53a$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $5b0433e9a769a53a$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $5b0433e9a769a53a$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $5b0433e9a769a53a$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $5b0433e9a769a53a$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $5b0433e9a769a53a$export$8ce1fd94bee2f412 = (0, $2pWXB.default)({
    light: $5b0433e9a769a53a$export$29a4f05edc054374,
    dark: $5b0433e9a769a53a$export$633847cf062b69e0
});
var $5b0433e9a769a53a$export$b861914ea877b580 = (0, $2pWXB.default)({
    light: $5b0433e9a769a53a$export$226de0355ed012f8,
    dark: $5b0433e9a769a53a$export$8c13c2ee36917869
});
var $5b0433e9a769a53a$export$3f1b020df94387af = (0, $2pWXB.default)({
    light: $5b0433e9a769a53a$export$3e51e8f1440314ba,
    dark: $5b0433e9a769a53a$export$d281fbfe3cff2df6
});
var $5b0433e9a769a53a$export$c0183dbab98ca63e = (0, $2pWXB.default)({
    light: $5b0433e9a769a53a$export$29a4f05edc054374,
    dark: $5b0433e9a769a53a$export$8e8133c1ba5845b5
});
var $5b0433e9a769a53a$export$6f093cfa640b7166 = (0, $2pWXB.default)({
    light: $5b0433e9a769a53a$export$fbda843f0a27fe96,
    dark: $5b0433e9a769a53a$export$5368d76ae4fbbda7
});
var $5b0433e9a769a53a$export$42f8e9c698766e7a = (0, $2pWXB.default)({
    light: $5b0433e9a769a53a$export$7d61b15e0da132af,
    dark: $5b0433e9a769a53a$export$5368d76ae4fbbda7
});
var $5b0433e9a769a53a$export$c2d157ca1c34b6e3 = (0, $2pWXB.default)({
    light: $5b0433e9a769a53a$export$b3de0ae08da2ce64,
    dark: $5b0433e9a769a53a$export$b3de0ae08da2ce64
});
var $5b0433e9a769a53a$export$1905ba28d7cf066f = (0, $2pWXB.default)({
    light: $5b0433e9a769a53a$export$f563ee71e9ee74cd,
    dark: $5b0433e9a769a53a$export$97e81faa16a182c7
});
var $5b0433e9a769a53a$export$bd9002130d306d39 = (0, $2pWXB.default)({
    light: $5b0433e9a769a53a$export$d6447c357493214f,
    dark: $5b0433e9a769a53a$export$bfe21c59123ecf33
});
var $5b0433e9a769a53a$export$46e4a324ac90507f = (0, $2pWXB.default)({
    light: $5b0433e9a769a53a$export$7d61b15e0da132af,
    dark: $5b0433e9a769a53a$export$5368d76ae4fbbda7
});
var $5b0433e9a769a53a$export$79f3f2b82beb0d36 = (0, $2pWXB.default)({
    light: $5b0433e9a769a53a$export$f563ee71e9ee74cd,
    dark: $5b0433e9a769a53a$export$97e81faa16a182c7
});
var $5b0433e9a769a53a$export$7bb0d5c671655cc4 = (0, $2pWXB.default)({
    light: $5b0433e9a769a53a$export$9fdfb749e33cdf97,
    dark: $5b0433e9a769a53a$export$8e8133c1ba5845b5
});
var $5b0433e9a769a53a$export$9c30223ca0a664fb = (0, $2pWXB.default)({
    light: $5b0433e9a769a53a$export$b3de0ae08da2ce64,
    dark: $5b0433e9a769a53a$export$ecfc1dff386a3e7a
});
var $5b0433e9a769a53a$export$7ed258b0728b004b = (0, $2pWXB.default)({
    light: $5b0433e9a769a53a$export$e62e8919cca44969,
    dark: $5b0433e9a769a53a$export$215b7063051591f1
});
var $5b0433e9a769a53a$export$dfa920d8decc8a59 = (0, $2pWXB.default)({
    light: $5b0433e9a769a53a$export$a6ee3d71bc067634,
    dark: $5b0433e9a769a53a$export$ecfc1dff386a3e7a
});
var $5b0433e9a769a53a$export$6069e6ad5c78f632 = (0, $2pWXB.default)({
    light: $5b0433e9a769a53a$export$ecfc1dff386a3e7a,
    dark: $5b0433e9a769a53a$export$215b7063051591f1
});
var $5b0433e9a769a53a$export$9ad721cf3b3debe0 = (0, $2pWXB.default)({
    light: $5b0433e9a769a53a$export$b3de0ae08da2ce64,
    dark: $5b0433e9a769a53a$export$ecfc1dff386a3e7a
});
var $5b0433e9a769a53a$export$2aa0182783e7e9de = (0, $2pWXB.default)({
    light: $5b0433e9a769a53a$export$b3de0ae08da2ce64,
    dark: $5b0433e9a769a53a$export$ecfc1dff386a3e7a
});
var $5b0433e9a769a53a$export$8bf7dff220b82b4a = (0, $2pWXB.default)({
    light: $5b0433e9a769a53a$export$9dc1ef0f3f48059b,
    dark: $5b0433e9a769a53a$export$69cb3ca10c1e330e
});
var $5b0433e9a769a53a$export$e13cce2a2d16a9d4 = (0, $2pWXB.default)({
    light: $5b0433e9a769a53a$export$b48405b95304b5a1,
    dark: $5b0433e9a769a53a$export$6011520a64d9a187
});
var $5b0433e9a769a53a$export$a90204d1394caf30 = (0, $2pWXB.default)({
    light: $5b0433e9a769a53a$export$4a7404f376229999,
    dark: $5b0433e9a769a53a$export$4a7404f376229999
});
var $5b0433e9a769a53a$export$594c5a8758200c32 = (0, $2pWXB.default)({
    light: $5b0433e9a769a53a$export$c6930421db9fa514,
    dark: $5b0433e9a769a53a$export$c6930421db9fa514
});
var $5b0433e9a769a53a$export$955a2ebd2fb142ae = (0, $2pWXB.default)({
    light: $5b0433e9a769a53a$export$940e1f69e873f202,
    dark: $5b0433e9a769a53a$export$940e1f69e873f202
});
var $5b0433e9a769a53a$export$2a0674ff2eb10214 = function() {
    return $5b0433e9a769a53a$export$8d43898f60b96a82;
};

});
parcelRegister("2pWXB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c2ba6e0f99552f0$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $fNgUF = parcelRequire("fNgUF");
// Unpack custom variants, and get correct value for the current theme
function $1c2ba6e0f99552f0$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $fNgUF.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $1c2ba6e0f99552f0$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $1c2ba6e0f99552f0$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $fNgUF.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("fNgUF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7f88d3005960bb9$export$2e2bcd8739ae039; });
// ideally this would be fetched from ../constants but that causes a
// circular dep loop. This will be refactored as part of a breaking
// change in the future.
var $b7f88d3005960bb9$var$DEFAULT_THEME_MODE = "light";
var $b7f88d3005960bb9$var$THEME_MODES = [
    "light",
    "dark"
];
function $b7f88d3005960bb9$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ("__ATLASKIT_THEME__" in props.theme) return props.theme.__ATLASKIT_THEME__;
        else if ("mode" in props.theme && $b7f88d3005960bb9$var$THEME_MODES.includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: $b7f88d3005960bb9$var$DEFAULT_THEME_MODE
    };
}

});




parcelRegister("4dHqe", function(module, exports) {

$parcel$export(module.exports, "disabledBackgroundColor", function () { return $312a0f0e84b34768$export$425be610a1df3a3d; });
$parcel$export(module.exports, "invalidBorderColor", function () { return $312a0f0e84b34768$export$7f333bbf7ddab792; });
$parcel$export(module.exports, "defaultBackgroundColor", function () { return $312a0f0e84b34768$export$b13414ee9ac9cae6; });
$parcel$export(module.exports, "defaultBackgroundColorFocus", function () { return $312a0f0e84b34768$export$21287e4b7f134f09; });
$parcel$export(module.exports, "defaultBackgroundColorHover", function () { return $312a0f0e84b34768$export$bca15982c103d57b; });
$parcel$export(module.exports, "defaultBorderColor", function () { return $312a0f0e84b34768$export$dafd83031c202ca8; });
$parcel$export(module.exports, "defaultBorderColorFocus", function () { return $312a0f0e84b34768$export$e8320c09dc1e4012; });
$parcel$export(module.exports, "transparent", function () { return $312a0f0e84b34768$export$f4d082c200a4b4b8; });
$parcel$export(module.exports, "textColor", function () { return $312a0f0e84b34768$export$32f78bffcd82ff28; });
$parcel$export(module.exports, "disabledTextColor", function () { return $312a0f0e84b34768$export$eb4a7d363eec53c8; });
$parcel$export(module.exports, "placeholderTextColor", function () { return $312a0f0e84b34768$export$5e076b2557ef7bbb; });

var $7OtEo = parcelRequire("7OtEo");
var $312a0f0e84b34768$export$425be610a1df3a3d = {
    light: $7OtEo.N20,
    dark: $7OtEo.DN20
};
var $312a0f0e84b34768$export$7f333bbf7ddab792 = {
    light: $7OtEo.R400,
    dark: $7OtEo.R400
};
var $312a0f0e84b34768$export$b13414ee9ac9cae6 = {
    light: $7OtEo.N10,
    dark: $7OtEo.DN10
};
var $312a0f0e84b34768$export$21287e4b7f134f09 = {
    light: $7OtEo.N0,
    dark: $7OtEo.DN10
};
var $312a0f0e84b34768$export$bca15982c103d57b = {
    light: $7OtEo.N30,
    dark: $7OtEo.DN30
};
var $312a0f0e84b34768$export$dafd83031c202ca8 = {
    light: $7OtEo.N40,
    dark: $7OtEo.DN40
};
var $312a0f0e84b34768$export$e8320c09dc1e4012 = {
    light: $7OtEo.B100,
    dark: $7OtEo.B75
};
var $312a0f0e84b34768$export$f4d082c200a4b4b8 = {
    light: "transparent",
    dark: "transparent"
};
var $312a0f0e84b34768$export$32f78bffcd82ff28 = {
    light: $7OtEo.N900,
    dark: $7OtEo.DN600
};
var $312a0f0e84b34768$export$eb4a7d363eec53c8 = {
    light: $7OtEo.N70,
    dark: $7OtEo.DN90
};
var $312a0f0e84b34768$export$5e076b2557ef7bbb = {
    light: $7OtEo.N100,
    dark: $7OtEo.DN90
};

});


parcelRegister("cg2AB", function(module, exports) {
module.exports = JSON.parse('{"name":"@atlaskit/textfield","version":"4.0.0","sideEffects":false}');

});

parcelRegister("lRW8b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $febba3d1dad945c0$export$2e2bcd8739ae039; });

var $l5MLt = parcelRequire("l5MLt");

var $45CBz = parcelRequire("45CBz");
function $febba3d1dad945c0$var$warnIfClash(ours, theirs) {
    var ourKeys = Object.keys(ours);
    var theirKeys = Object.keys(theirs);
    ourKeys.forEach(function(key) {
        if (theirKeys.includes(key)) // eslint-disable-next-line no-console
        console.warn('\n          FieldText:\n          You are attempting to add prop "' + key + '" to the input field.\n          It is clashing with one of our supplied props.\n          Please try to control this prop through our public API\n        ');
    });
}
function $febba3d1dad945c0$export$2e2bcd8739ae039(_a) {
    var elemAfterInput = _a.elemAfterInput, elemBeforeInput = _a.elemBeforeInput, isDisabled = _a.isDisabled, isReadOnly = _a.isReadOnly, isRequired = _a.isRequired, onMouseDown = _a.onMouseDown, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onBlur = _a.onBlur, onFocus = _a.onFocus, theme = _a.theme, innerRef = _a.innerRef, testId = _a.testId, theirInputProps = (0, $l5MLt.__rest)(_a, [
        "elemAfterInput",
        "elemBeforeInput",
        "isDisabled",
        "isReadOnly",
        "isRequired",
        "onMouseDown",
        "onMouseEnter",
        "onMouseLeave",
        "onBlur",
        "onFocus",
        "theme",
        "innerRef",
        "testId"
    ]);
    var ourInputProps = {
        onFocus: onFocus,
        onBlur: onBlur,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired
    };
    var inputProps = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, theirInputProps), ourInputProps);
    var containerProps = {
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    };
    return (0, $45CBz.jsx)("div", (0, $l5MLt.__assign)({}, containerProps, {
        css: theme.container
    }), elemBeforeInput, (0, $45CBz.jsx)("input", (0, $l5MLt.__assign)({}, inputProps, {
        css: theme.input,
        ref: innerRef,
        "data-testid": testId
    })), elemAfterInput);
}

});


parcelRegister("144kQ", function(module, exports) {

$parcel$export(module.exports, "SearchFieldContainer", function () { return $6f10f98ec9d2940c$export$5435f108542317e7; });
$parcel$export(module.exports, "SearchIconContainer", function () { return $6f10f98ec9d2940c$export$aa9b8a8b3f16c3eb; });

var $2xJU3 = parcelRequire("2xJU3");

var $jp7ng = parcelRequire("jp7ng");
var $aP6k3 = parcelRequire("aP6k3");

var $h39Sh = parcelRequire("h39Sh");
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */ function $6f10f98ec9d2940c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6f10f98ec9d2940c$export$5435f108542317e7 = (0, $2xJU3.default)("div", {
    target: "e1byy5k70"
})("width:", (props)=>props.widthGridMultiplier ? (0, $aP6k3.gridSize)() * props.widthGridMultiplier : (0, $aP6k3.gridSize)() * 30, "px;& > div{height:", (0, $aP6k3.gridSize)() * 4, "px;&:focus,&:hover{height:", (0, $aP6k3.gridSize)() * 4, "px;}}");
const $6f10f98ec9d2940c$export$aa9b8a8b3f16c3eb = (0, $2xJU3.default)("span", {
    target: "e1byy5k71"
})("padding-right:", (0, $aP6k3.gridSize)(), "px;padding-top:", (0, $aP6k3.gridSize)() / 4, "px;");
const $6f10f98ec9d2940c$export$b90186699a454308 = (0, $2xJU3.default)("span", {
    target: "e1byy5k72"
})({
    name: "1170n61",
    styles: "vertical-align:bottom;"
});
const $6f10f98ec9d2940c$export$4380700b011ee8f7 = (0, $2xJU3.default)("div", {
    target: "e1byy5k73"
})("color:", (0, $h39Sh.default)("color.text", (0, $jp7ng).N800), ";font-size:", (0, $aP6k3.fontSize)(), "px;& button:nth-of-type(2),& button:nth-of-type(3){margin-left:", (0, $aP6k3.gridSize)() * 1.5, "px;}");

});


parcelRegister("iReEB", function(module, exports) {

$parcel$export(module.exports, "useTableHeader", function () { return $5f07fdb7fb6ac66f$export$7fbbd6f6958548dc; });

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $5oo0Y = parcelRequire("5oo0Y");

var $f9pRZ = parcelRequire("f9pRZ");

var $jajUg = parcelRequire("jajUg");

var $9yLYl = parcelRequire("9yLYl");

var $4HDjC = parcelRequire("4HDjC");

var $6cjyK = parcelRequire("6cjyK");
const $5f07fdb7fb6ac66f$export$defe85febe8b728c = (0, $agjvf.defineMessages)({
    nameHeader: {
        "id": "frontbucket.settings.permissions.table.nameHeader",
        "defaultMessage": "Name"
    },
    permissionHeader: {
        "id": "frontbucket.settings.permissions.table.permissionHeader",
        "defaultMessage": "Permission"
    },
    accessLevelHeader: {
        "id": "frontbucket.settings.permissions.table.accessLevelHeader",
        "defaultMessage": "Access level"
    },
    actionsHeader: {
        "id": "frontbucket.settings.permissions.table.actionsHeader",
        "defaultMessage": "Actions"
    }
});
const $5f07fdb7fb6ac66f$export$7fbbd6f6958548dc = ({ checkedCount: checkedCount, checkedCountCurrentPage: checkedCountCurrentPage, limit: limit, isDisabled: isDisabled, showAccessLevel: showAccessLevel })=>{
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    const { publishClickEvent: publishClickEvent } = (0, $f9pRZ.useAnalytics)();
    const { selectAll: selectAll } = (0, $4HDjC.useActions)();
    const isChecked = checkedCountCurrentPage > 0;
    const checkbox = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6cjyK.HeaderCheckbox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5oo0Y.default), {
        isChecked: isChecked,
        isIndeterminate: checkedCountCurrentPage < limit,
        onChange: ()=>{
            selectAll(!isChecked);
            publishClickEvent({
                name: "SelectAll",
                actionSubject: "checkbox"
            });
        },
        isDisabled: isDisabled,
        testId: "bulk-checkbox"
    }));
    return {
        actions: checkedCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9yLYl.BulkActions), {
            checkedCount: checkedCount
        }, checkbox),
        header: {
            cells: [
                {
                    key: "checkbox",
                    content: checkedCount <= 0 && checkbox,
                    width: 3
                },
                {
                    key: "name",
                    content: checkedCount <= 0 && formatMessage($5f07fdb7fb6ac66f$export$defe85febe8b728c.nameHeader),
                    width: showAccessLevel ? 32 : 52
                },
                {
                    key: "permission",
                    content: checkedCount <= 0 && formatMessage($5f07fdb7fb6ac66f$export$defe85febe8b728c.permissionHeader),
                    width: 20
                },
                ...showAccessLevel ? [
                    {
                        key: "level",
                        content: checkedCount <= 0 && formatMessage($5f07fdb7fb6ac66f$export$defe85febe8b728c.accessLevelHeader),
                        width: 20
                    }
                ] : [],
                {
                    key: "actions",
                    content: checkedCount <= 0 && formatMessage($5f07fdb7fb6ac66f$export$defe85febe8b728c.actionsHeader),
                    width: 15
                }
            ]
        }
    };
};

});
parcelRegister("5oo0Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ed1d276849d7567$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9q1kH = parcelRequire("9q1kH");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $jztdj = parcelRequire("jztdj");

var $3aF04 = parcelRequire("3aF04");

var $dEQSq = parcelRequire("dEQSq");

var $do6pT = parcelRequire("do6pT");
var $jHuxR = parcelRequire("jHuxR");
var $2SELS = parcelRequire("2SELS");
var $edBub = parcelRequire("edBub");
var $3ed1d276849d7567$var$_excluded = [
    "isChecked",
    "isDisabled",
    "isInvalid",
    "defaultChecked",
    "isIndeterminate",
    "size",
    "onChange",
    "analyticsContext",
    "label",
    "name",
    "value",
    "isRequired",
    "testId"
];
/* eslint-disable @atlaskit/design-system/no-nested-styles */ var $3ed1d276849d7567$var$checkboxStyles = (0, $avKww.css)({
    width: "100%",
    height: "100%",
    margin: "var(--ds-space-0, 0px)",
    appearance: "none",
    border: "none",
    gridArea: "1 / 1 / 2 / 2",
    opacity: 0,
    outline: "none",
    "& + svg": {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ "--checkbox-background-color": "var(--local-background)",
        "--checkbox-border-color": "var(--local-border)",
        "--checkbox-tick-color": "var(--local-tick-rest)",
        color: "var(--checkbox-background-color)",
        fill: "var(--checkbox-tick-color)",
        gridArea: "1 / 1 / 2 / 2",
        pointerEvents: "none",
        transition: "color 0.2s ease-in-out, fill 0.2s ease-in-out",
        "rect:first-of-type": {
            stroke: "var(--checkbox-border-color)",
            strokeWidth: (0, $dEQSq.getBooleanFF)("platform.design-system-team.update-border-radio-checkbox_7askv") ? "var(--ds-border-width, 1px)" : 2,
            transition: "stroke 0.2s ease-in-out"
        }
    },
    "&&:focus + svg, &&:checked:focus + svg": {
        "--checkbox-border-color": "var(--local-border-focus)"
    },
    "&:hover + svg": {
        "--checkbox-background-color": "var(--local-background-hover)",
        "--checkbox-border-color": "var(--local-border-hover)"
    },
    "&:checked:hover + svg": {
        "--checkbox-background-color": "var(--local-background-checked-hover)",
        "--checkbox-border-color": "var(--local-border-checked-hover)"
    },
    "&:checked + svg": {
        "--checkbox-background-color": "var(--local-background-checked)",
        "--checkbox-border-color": "var(--local-border-checked)",
        "--checkbox-tick-color": "var(--local-tick-checked)"
    },
    "&[data-invalid] + svg": {
        "--checkbox-border-color": "var(--local-border-invalid)"
    },
    "&:checked[data-invalid] + svg": {
        "--checkbox-border-color": "var(--local-border-checked-invalid)"
    },
    "&:active + svg": {
        "--checkbox-background-color": "var(--local-background-active)",
        "--checkbox-border-color": "var(--local-border-active)"
    },
    "&:checked:active + svg": {
        "--checkbox-background-color": "var(--local-background-active)",
        "--checkbox-border-color": "var(--local-border-active)",
        "--checkbox-tick-color": "var(--local-tick-active)"
    },
    "&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg": {
        "--checkbox-background-color": "var(--local-background-disabled)",
        "--checkbox-border-color": "var(--local-border-disabled)",
        cursor: "not-allowed",
        pointerEvents: "none"
    },
    "&:disabled:checked + svg": {
        "--checkbox-tick-color": "var(--local-tick-disabled)"
    },
    "@media screen and (forced-colors: active)": {
        "& + svg": {
            "--checkbox-background-color": "Canvas",
            "--checkbox-border-color": "CanvasText",
            "--checkbox-tick-color": "CanvasText"
        },
        "&:checked + svg, &:checked:hover + svg": {
            "--checkbox-background-color": "Canvas",
            "--checkbox-border-color": "CanvasText",
            "--checkbox-tick-color": "CanvasText"
        },
        "&:focus + svg rect:first-of-type": {
            stroke: "Highlight"
        },
        "&[data-invalid] + svg": {
            "--checkbox-border-color": "Highlight"
        },
        "&:checked[data-invalid] + svg": {
            "--checkbox-border-color": "Highlight"
        },
        "&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg": {
            "--checkbox-background-color": "Canvas",
            "--checkbox-border-color": "GrayText",
            "--checkbox-tick-color": "GrayText"
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ var $3ed1d276849d7567$var$Checkbox = /*#__PURE__*/ (0, $9nHZC.memo)(/*#__PURE__*/ (0, $9nHZC.forwardRef)(function Checkbox(props, ref) {
    var isCheckedProp = props.isChecked, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$defaultChecked = props.defaultChecked, defaultChecked = _props$defaultChecked === void 0 ? false : _props$defaultChecked, _props$isIndeterminat = props.isIndeterminate, isIndeterminate = _props$isIndeterminat === void 0 ? false : _props$isIndeterminat, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, onChangeProps = props.onChange, analyticsContext = props.analyticsContext, label = props.label, name = props.name, value = props.value, isRequired = props.isRequired, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(props, $3ed1d276849d7567$var$_excluded);
    var _useState = (0, $9nHZC.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), isCheckedState = _useState2[0], setIsCheckedState = _useState2[1];
    var onChange = (0, $9nHZC.useCallback)(function(e, analyticsEvent) {
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    var onChangeAnalytics = (0, $jztdj.usePlatformLeafEventHandler)({
        fn: onChange,
        action: "changed",
        analyticsData: analyticsContext,
        componentName: "checkbox",
        packageName: "@atlaskit/checkbox",
        packageVersion: "12.6.11"
    });
    var internalRef = (0, $9nHZC.useRef)(null);
    var mergedRefs = (0, $3aF04.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    var isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    return (0, $avKww.jsx)((0, $jHuxR.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? "".concat(rest.id, "-label") : undefined,
        testId: testId && "".concat(testId, "--checkbox-label")
    }, (0, $avKww.jsx)("input", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $3ed1d276849d7567$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-checked": isIndeterminate ? "mixed" : isChecked,
        "aria-invalid": isInvalid ? "true" : undefined,
        "data-testid": testId && "".concat(testId, "--hidden-checkbox"),
        "data-invalid": isInvalid ? "true" : undefined
    })), (0, $avKww.jsx)((0, $do6pT.default), {
        size: size,
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && (0, $avKww.jsx)((0, $2SELS.default), null, label, isRequired && (0, $avKww.jsx)((0, $edBub.default), null)));
}));
$3ed1d276849d7567$var$Checkbox.displayName = "Checkbox";
var $3ed1d276849d7567$export$2e2bcd8739ae039 = $3ed1d276849d7567$var$Checkbox;

});
parcelRegister("jztdj", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $e3f7f26d7815a43f$export$a4687b0234b40e28; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $20kdq = parcelRequire("20kdq");

var $jfkfr = parcelRequire("jfkfr");
function $e3f7f26d7815a43f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e3f7f26d7815a43f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e3f7f26d7815a43f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e3f7f26d7815a43f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e3f7f26d7815a43f$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $20kdq.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $jfkfr.useTrackedRef)(analyticsData);
    var fnRef = (0, $jfkfr.useTrackedRef)(fn);
    var handler = (0, $9nHZC.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $e3f7f26d7815a43f$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("20kdq", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $175b4343e1a5ddbb$export$5bf35293e545f20c; });

var $dNznA = parcelRequire("dNznA");

var $a04bY = parcelRequire("a04bY");

var $bXIFh = parcelRequire("bXIFh");
function $175b4343e1a5ddbb$export$5bf35293e545f20c() {
    var analyticsContext = (0, $bXIFh.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $a04bY.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("a04bY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $747d27ec17cba5ac$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $2ejQj = parcelRequire("2ejQj");
function $747d27ec17cba5ac$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $747d27ec17cba5ac$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $747d27ec17cba5ac$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($747d27ec17cba5ac$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $747d27ec17cba5ac$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $747d27ec17cba5ac$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $747d27ec17cba5ac$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $747d27ec17cba5ac$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $2ejQj.default));

});
parcelRegister("2ejQj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19fc47eff1e7130b$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
function $19fc47eff1e7130b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $19fc47eff1e7130b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $19fc47eff1e7130b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $19fc47eff1e7130b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $19fc47eff1e7130b$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $19fc47eff1e7130b$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $19fc47eff1e7130b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $19fc47eff1e7130b$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(updater) === "object") this.payload = $19fc47eff1e7130b$var$_objectSpread($19fc47eff1e7130b$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("bXIFh", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $8b57d9e5fbb26a89$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $8b57d9e5fbb26a89$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});


parcelRegister("jfkfr", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $e02f1fdad70ae7d4$export$1d27a74659855e44; });

var $9nHZC = parcelRequire("9nHZC");
var $e02f1fdad70ae7d4$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("do6pT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9bf27e714520ced2$export$2e2bcd8739ae039; });
/**  @jsx jsx */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $cWOtC = parcelRequire("cWOtC");
function $9bf27e714520ced2$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return (0, $avKww.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return (0, $avKww.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ var $9bf27e714520ced2$var$CheckboxIcon = /*#__PURE__*/ (0, $9nHZC.memo)(function(_ref) {
    var size = _ref.size, isIndeterminate = _ref.isIndeterminate, isChecked = _ref.isChecked;
    var icon = (0, $9nHZC.useMemo)(function() {
        return $9bf27e714520ced2$var$getIcon(isIndeterminate, isChecked);
    }, [
        isIndeterminate,
        isChecked
    ]);
    return (0, $avKww.jsx)((0, $cWOtC.default), {
        label: "",
        size: size,
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, (0, $avKww.jsx)("g", {
        fillRule: "evenodd"
    }, (0, $avKww.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $9bf27e714520ced2$export$2e2bcd8739ae039 = $9bf27e714520ced2$var$CheckboxIcon;

});
parcelRegister("cWOtC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96d20e6fa8d63bd9$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $5LVXk = parcelRequire("5LVXk");

var $kbYzM = parcelRequire("kbYzM");

var $c3vsL = parcelRequire("c3vsL");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $96d20e6fa8d63bd9$var$svgStyles = (0, $avKww.css)((0, $c3vsL.commonSVGStyles));
/**
 * __SVG__
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
 */ var $96d20e6fa8d63bd9$var$SVG = /*#__PURE__*/ (0, $9nHZC.memo)(function SVG(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? "medium" : _ref$size, label = _ref.label, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, testId = _ref.testId, children = _ref.children;
    var _useGlobalTheme = (0, $5LVXk.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $avKww.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor || (0, $kbYzM.getBackground)(mode)
        },
        css: [
            $96d20e6fa8d63bd9$var$svgStyles,
            (0, $c3vsL.sizeStyleMap)[size]
        ],
        "data-testid": testId,
        "aria-label": label || undefined,
        role: label ? "img" : "presentation"
    }, children);
});
var $96d20e6fa8d63bd9$export$2e2bcd8739ae039 = $96d20e6fa8d63bd9$var$SVG;

});
parcelRegister("kbYzM", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $eb33d2e5a4e48423$export$18cb9425622d4e06; });
var $eb33d2e5a4e48423$var$themedBackground = {
    light: "var(--ds-surface, #FFFFFF)",
    dark: "var(--ds-surface, #1B2638)"
};
var $eb33d2e5a4e48423$export$18cb9425622d4e06 = function getBackground() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "light";
    return $eb33d2e5a4e48423$var$themedBackground[mode];
};

});

parcelRegister("c3vsL", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $8c6e2bb4e9df6a02$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "sizeStyleMap", function () { return $8c6e2bb4e9df6a02$export$ef0ad74202575b64; });

var $gMeo6 = parcelRequire("gMeo6");

var $avKww = parcelRequire("avKww");
var $8c6e2bb4e9df6a02$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
var $8c6e2bb4e9df6a02$var$smallStyles = (0, $avKww.css)((0, $gMeo6.dimensions).small);
var $8c6e2bb4e9df6a02$var$mediumStyles = (0, $avKww.css)((0, $gMeo6.dimensions).medium);
var $8c6e2bb4e9df6a02$var$largeStyles = (0, $avKww.css)((0, $gMeo6.dimensions).large);
var $8c6e2bb4e9df6a02$var$xlargeStyles = (0, $avKww.css)((0, $gMeo6.dimensions).xlarge);
var $8c6e2bb4e9df6a02$export$ef0ad74202575b64 = {
    small: $8c6e2bb4e9df6a02$var$smallStyles,
    medium: $8c6e2bb4e9df6a02$var$mediumStyles,
    large: $8c6e2bb4e9df6a02$var$largeStyles,
    xlarge: $8c6e2bb4e9df6a02$var$xlargeStyles
};
var $8c6e2bb4e9df6a02$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $gMeo6.dimensions)[size];
    return undefined;
};

});
parcelRegister("gMeo6", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $c36c4a266096cc44$export$62ad7b0c781000e9; });
var $c36c4a266096cc44$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $c36c4a266096cc44$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $c36c4a266096cc44$export$62ad7b0c781000e9 = {
    small: {
        width: $c36c4a266096cc44$export$c647cb0ee6e282fe.small,
        height: $c36c4a266096cc44$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $c36c4a266096cc44$export$c647cb0ee6e282fe.medium,
        height: $c36c4a266096cc44$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $c36c4a266096cc44$export$c647cb0ee6e282fe.large,
        height: $c36c4a266096cc44$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $c36c4a266096cc44$export$c647cb0ee6e282fe.xlarge,
        height: $c36c4a266096cc44$export$c647cb0ee6e282fe.xlarge
    }
};

});




parcelRegister("jHuxR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e579ba1c8b5d6711$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $avKww = parcelRequire("avKww");

var $jp7ng = parcelRequire("jp7ng");

var $5LVXk = parcelRequire("5LVXk");

var $gvCxQ = parcelRequire("gvCxQ");

var $gNKua = parcelRequire("gNKua");
var $e579ba1c8b5d6711$var$labelStyles = (0, $avKww.css)({
    display: "grid",
    gridAutoColumns: "1fr",
    gridAutoRows: "min-content",
    color: "var(--ds-text, ".concat((0, $jp7ng.N900), ")"),
    cursor: "default",
    fontFamily: "var(--ds-font-family-sans, ".concat((0, $gvCxQ.fontFamily), ")")
});
var $e579ba1c8b5d6711$var$textLabelLayoutStyles = (0, $avKww.css)({
    gap: "var(--ds-space-0, 0px)".concat(" ", "var(--ds-space-050, 4px)"),
    gridTemplateColumns: "min-content auto"
});
var $e579ba1c8b5d6711$var$disabledStyles = (0, $avKww.css)({
    color: "var(--ds-text-disabled, ".concat((0, $jp7ng.N80), ")"),
    cursor: "not-allowed"
});
var $e579ba1c8b5d6711$var$themeStyles = {
    light: (0, $avKww.css)({
        /**
     * Background
     */ "--local-background": (0, $gNKua.default).light.boxColor.rest,
        "--local-background-active": (0, $gNKua.default).light.boxColor.active,
        "--local-background-checked": (0, $gNKua.default).light.boxColor.checked,
        "--local-background-checked-hover": (0, $gNKua.default).light.boxColor.hoveredAndChecked,
        "--local-background-disabled": (0, $gNKua.default).light.boxColor.disabled,
        "--local-background-hover": (0, $gNKua.default).light.boxColor.hovered,
        /**
     * Border
     */ "--local-border": (0, $gNKua.default).light.borderColor.rest,
        "--local-border-active": (0, $gNKua.default).light.borderColor.active,
        "--local-border-checked": (0, $gNKua.default).light.borderColor.checked,
        "--local-border-checked-hover": (0, $gNKua.default).light.borderColor.hoveredAndChecked,
        "--local-border-checked-invalid": (0, $gNKua.default).light.borderColor.invalidAndChecked,
        "--local-border-disabled": (0, $gNKua.default).light.borderColor.disabled,
        "--local-border-focus": (0, $gNKua.default).light.borderColor.focused,
        "--local-border-hover": (0, $gNKua.default).light.borderColor.hovered,
        "--local-border-invalid": (0, $gNKua.default).light.borderColor.invalid,
        /**
     * Tick
     */ "--local-tick-active": (0, $gNKua.default).light.tickColor.activeAndChecked,
        "--local-tick-checked": (0, $gNKua.default).light.tickColor.checked,
        "--local-tick-disabled": (0, $gNKua.default).light.tickColor.disabledAndChecked,
        "--local-tick-rest": "transparent"
    }),
    dark: (0, $avKww.css)({
        /**
     * Background
     */ "--local-background": (0, $gNKua.default).dark.boxColor.rest,
        "--local-background-active": (0, $gNKua.default).dark.boxColor.active,
        "--local-background-checked": (0, $gNKua.default).dark.boxColor.checked,
        "--local-background-checked-hover": (0, $gNKua.default).dark.boxColor.hoveredAndChecked,
        "--local-background-disabled": (0, $gNKua.default).dark.boxColor.disabled,
        "--local-background-hover": (0, $gNKua.default).dark.boxColor.hovered,
        /**
     * Border
     */ "--local-border": (0, $gNKua.default).dark.borderColor.rest,
        "--local-border-active": (0, $gNKua.default).dark.borderColor.active,
        "--local-border-checked": (0, $gNKua.default).dark.borderColor.checked,
        "--local-border-checked-hover": (0, $gNKua.default).dark.borderColor.hoveredAndChecked,
        "--local-border-checked-invalid": (0, $gNKua.default).dark.borderColor.invalidAndChecked,
        "--local-border-disabled": (0, $gNKua.default).dark.borderColor.disabled,
        "--local-border-focus": (0, $gNKua.default).dark.borderColor.focused,
        "--local-border-hover": (0, $gNKua.default).dark.borderColor.hovered,
        "--local-border-invalid": (0, $gNKua.default).dark.borderColor.invalid,
        /**
     * Tick
     */ "--local-tick-active": (0, $gNKua.default).dark.tickColor.activeAndChecked,
        "--local-tick-checked": (0, $gNKua.default).dark.tickColor.checked,
        "--local-tick-disabled": (0, $gNKua.default).dark.tickColor.disabledAndChecked,
        "--local-tick-rest": "transparent"
    })
};
function $e579ba1c8b5d6711$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, testId = _ref.testId, label = _ref.label, id = _ref.id;
    var _useGlobalTheme = (0, $5LVXk.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $avKww.jsx)("label", {
        css: [
            $e579ba1c8b5d6711$var$labelStyles,
            label && $e579ba1c8b5d6711$var$textLabelLayoutStyles,
            isDisabled && $e579ba1c8b5d6711$var$disabledStyles,
            mode === "light" && $e579ba1c8b5d6711$var$themeStyles.light,
            mode === "dark" && $e579ba1c8b5d6711$var$themeStyles.dark
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});
parcelRegister("gvCxQ", function(module, exports) {

$parcel$export(module.exports, "fontFamily", function () { return $c04d70ceeec1b63a$export$a5975749f0374264; });

var $aP6k3 = parcelRequire("aP6k3");
var $c04d70ceeec1b63a$export$a5975749f0374264 = (0, $aP6k3.fontFamily)();

});

parcelRegister("gNKua", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3b54807b5033e74$export$2e2bcd8739ae039; });

var $dEQSq = parcelRequire("dEQSq");

var $jp7ng = parcelRequire("jp7ng");
var $c3b54807b5033e74$var$theme = {
    light: {
        borderColor: {
            rest: (0, $dEQSq.getBooleanFF)("platform.design-system-team.update-border-radio-checkbox_7askv") ? "var(--ds-border-bold, ".concat((0, $jp7ng.N100), ")") : "var(--ds-border-input, ".concat((0, $jp7ng.N40), ")"),
            hovered: (0, $dEQSq.getBooleanFF)("platform.design-system-team.update-border-radio-checkbox_7askv") ? "var(--ds-border-bold, ".concat((0, $jp7ng.N100), ")") : "var(--ds-border-input, ".concat((0, $jp7ng.N40), ")"),
            disabled: "var(--ds-background-disabled, ".concat((0, $jp7ng.N20), ")"),
            checked: "var(--ds-background-selected-bold, ".concat((0, $jp7ng.B400), ")"),
            active: "var(--ds-border, ".concat((0, $jp7ng.B50), ")"),
            invalid: "var(--ds-border-danger, ".concat((0, $jp7ng.R300), ")"),
            invalidAndChecked: "var(--ds-border-danger, ".concat((0, $jp7ng.R300), ")"),
            focused: "var(--ds-border-focused, ".concat((0, $jp7ng.B200), ")"),
            hoveredAndChecked: "var(--ds-background-selected-bold-hovered, ".concat((0, $jp7ng.B300), ")")
        },
        boxColor: {
            rest: "var(--ds-background-input, ".concat((0, $jp7ng.N10), ")"),
            hovered: "var(--ds-background-input-hovered, ".concat((0, $jp7ng.N30), ")"),
            disabled: "var(--ds-background-disabled, ".concat((0, $jp7ng.N20), ")"),
            active: "var(--ds-background-input-pressed, ".concat((0, $jp7ng.B50), ")"),
            hoveredAndChecked: "var(--ds-background-selected-bold-hovered, ".concat((0, $jp7ng.B300), ")"),
            checked: "var(--ds-background-selected-bold, ".concat((0, $jp7ng.B400), ")")
        },
        tickColor: {
            disabledAndChecked: "var(--ds-icon-disabled, ".concat((0, $jp7ng.N70), ")"),
            activeAndChecked: "var(--ds-icon-inverse, ".concat((0, $jp7ng.B400), ")"),
            checked: "var(--ds-icon-inverse, ".concat((0, $jp7ng.N10), ")")
        }
    },
    dark: {
        borderColor: {
            rest: (0, $dEQSq.getBooleanFF)("platform.design-system-team.update-border-radio-checkbox_7askv") ? "var(--ds-border-bold, ".concat((0, $jp7ng.DN200), ")") : "var(--ds-border-input, ".concat((0, $jp7ng.DN80), ")"),
            hovered: "var(--ds-border-input, ".concat((0, $jp7ng.DN200), ")"),
            disabled: "var(--ds-background-disabled, ".concat((0, $jp7ng.DN10), ")"),
            checked: "var(--ds-background-selected-bold, ".concat((0, $jp7ng.B400), ")"),
            active: "var(--ds-border, ".concat((0, $jp7ng.B200), ")"),
            invalid: "var(--ds-border-danger, ".concat((0, $jp7ng.R300), ")"),
            invalidAndChecked: "var(--ds-border-danger, ".concat((0, $jp7ng.R300), ")"),
            focused: "var(--ds-border-focused, ".concat((0, $jp7ng.B75), ")"),
            hoveredAndChecked: "var(--ds-background-selected-bold-hovered, ".concat((0, $jp7ng.B75), ")")
        },
        boxColor: {
            rest: "var(--ds-background-input, ".concat((0, $jp7ng.DN10), ")"),
            hovered: "var(--ds-background-input-hovered, ".concat((0, $jp7ng.DN30), ")"),
            disabled: "var(--ds-background-disabled, ".concat((0, $jp7ng.DN10), ")"),
            active: "var(--ds-background-input-pressed, ".concat((0, $jp7ng.B200), ")"),
            hoveredAndChecked: "var(--ds-background-selected-bold-hovered, ".concat((0, $jp7ng.B75), ")"),
            checked: "var(--ds-background-selected-bold, ".concat((0, $jp7ng.B400), ")")
        },
        tickColor: {
            disabledAndChecked: "var(--ds-icon-disabled, ".concat((0, $jp7ng.DN90), ")"),
            activeAndChecked: "var(--ds-icon-inverse, ".concat((0, $jp7ng.DN10), ")"),
            checked: "var(--ds-icon-inverse, ".concat((0, $jp7ng.DN10), ")")
        }
    }
};
var $c3b54807b5033e74$export$2e2bcd8739ae039 = $c3b54807b5033e74$var$theme;

});


parcelRegister("2SELS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2190403d7dcfa66d$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $avKww = parcelRequire("avKww");
var $2190403d7dcfa66d$var$labelTextStyles = (0, $avKww.css)({
    alignSelf: "center",
    gridArea: "1 / 2 / 2 / 3"
});
function $2190403d7dcfa66d$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return (0, $avKww.jsx)("span", {
        css: $2190403d7dcfa66d$var$labelTextStyles
    }, children);
}

});

parcelRegister("edBub", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a59f5b7db40ffef9$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $avKww = parcelRequire("avKww");

var $jp7ng = parcelRequire("jp7ng");
var $a59f5b7db40ffef9$var$requiredIndicatorStyles = (0, $avKww.css)({
    paddingLeft: "var(--ds-space-025, 2px)",
    color: "var(--ds-text-danger, ".concat((0, $jp7ng.R500), ")")
});
function $a59f5b7db40ffef9$export$2e2bcd8739ae039() {
    return (0, $avKww.jsx)("span", {
        css: $a59f5b7db40ffef9$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});


parcelRegister("9yLYl", function(module, exports) {

$parcel$export(module.exports, "BulkActions", function () { return $22f9eba5f9ba89b1$export$9cf433a293bbef79; });

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $3THTN = parcelRequire("3THTN");

var $kcdk1 = parcelRequire("kcdk1");

var $f9pRZ = parcelRequire("f9pRZ");

var $7Me5Z = parcelRequire("7Me5Z");

var $jajUg = parcelRequire("jajUg");

var $4HDjC = parcelRequire("4HDjC");

var $6cjyK = parcelRequire("6cjyK");
const $22f9eba5f9ba89b1$var$messages = (0, $agjvf.defineMessages)({
    selectedItemsText: {
        "id": "frontbucket.settings.permissions.selectedItemsLabel",
        "defaultMessage": "{count} {count, plural, one {item} other {items}} selected"
    },
    selectedItemsMaxedOutError: {
        "id": "frontbucket.settings.permissions.selectedItemsMaxedOutError",
        "defaultMessage": "Reduce the number of selected items to no more than {max}."
    },
    clearAll: {
        "id": "frontbucket.settings.permissions.link.clearAll",
        "defaultMessage": "clear all"
    },
    editPermissionsButton: {
        "id": "frontbucket.settings.permissions.editPermissionsButton",
        "defaultMessage": "Edit permissions"
    },
    remove: {
        "id": "frontbucket.settings.permissions.actions.remove",
        "defaultMessage": "Remove"
    }
});
const $22f9eba5f9ba89b1$export$9cf433a293bbef79 = ({ checkedCount: checkedCount, children: children })=>{
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    const { publishButtonClickEvent: publishButtonClickEvent } = (0, $f9pRZ.useAnalytics)();
    const { setState: setState, setActiveModal: setActiveModal } = (0, $4HDjC.useActions)();
    const [{ context: context }] = (0, $4HDjC.usePermissionsContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6cjyK.BulkActionsHeader), null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("strong", null, formatMessage($22f9eba5f9ba89b1$var$messages.selectedItemsText, {
        count: checkedCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3THTN.default), {
        appearance: "subtle-link",
        onClick: ()=>{
            setState({
                checkedRows: []
            });
            publishButtonClickEvent("ClearAll");
        },
        spacing: "compact",
        testId: "bulk-action--clear-all"
    }, formatMessage($22f9eba5f9ba89b1$var$messages.clearAll)), context !== "workspace" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3THTN.default), {
        onClick: ()=>{
            setActiveModal("BulkChangePrivilegesModal");
            publishButtonClickEvent("BulkEdit");
        },
        spacing: "compact",
        isDisabled: checkedCount > (0, $7Me5Z.BULK_SELECTION_LIMIT),
        testId: "bulk-action--edit"
    }, formatMessage($22f9eba5f9ba89b1$var$messages.editPermissionsButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3THTN.default), {
        onClick: ()=>{
            setActiveModal("RemoveAccessModal");
            publishButtonClickEvent("BulkRemove");
        },
        spacing: "compact",
        isDisabled: checkedCount > (0, $7Me5Z.BULK_SELECTION_LIMIT),
        testId: "bulk-action--remove"
    }, formatMessage($22f9eba5f9ba89b1$var$messages.remove)), checkedCount > (0, $7Me5Z.BULK_SELECTION_LIMIT) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kcdk1.ErrorMessage), null, formatMessage($22f9eba5f9ba89b1$var$messages.selectedItemsMaxedOutError, {
        max: (0, $7Me5Z.BULK_SELECTION_LIMIT)
    })));
};

});


parcelRegister("g3p9t", function(module, exports) {

$parcel$export(module.exports, "useTableRows", function () { return $419d571f8186accb$export$a190e1af00082b41; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");
parcelRequire("dGzLf");
var $aAre5 = parcelRequire("aAre5");

var $3THTN = parcelRequire("3THTN");

var $5oo0Y = parcelRequire("5oo0Y");

var $fi8IW = parcelRequire("fi8IW");

var $a7iuM = parcelRequire("a7iuM");

var $f9pRZ = parcelRequire("f9pRZ");
parcelRequire("fequ0");
var $7bBwl = parcelRequire("7bBwl");

var $jajUg = parcelRequire("jajUg");

var $g2R3c = parcelRequire("g2R3c");
parcelRequire("DVpDa");
var $4HDjC = parcelRequire("4HDjC");

var $fXsLf = parcelRequire("fXsLf");

var $7q4Mr = parcelRequire("7q4Mr");

var $1YjBi = parcelRequire("1YjBi");

var $cM1QH = parcelRequire("cM1QH");

var $4HDjC = parcelRequire("4HDjC");

var $bOfxz = parcelRequire("bOfxz");

var $6cjyK = parcelRequire("6cjyK");

var $hCBEg = parcelRequire("hCBEg");
const $419d571f8186accb$var$messages = (0, $agjvf.defineMessages)({
    nameHeader: {
        "id": "frontbucket.settings.permissions.table.nameHeader",
        "defaultMessage": "Name"
    },
    permissionHeader: {
        "id": "frontbucket.settings.permissions.table.permissionHeader",
        "defaultMessage": "Permission"
    },
    actionsHeader: {
        "id": "frontbucket.settings.permissions.table.actionsHeader",
        "defaultMessage": "Actions"
    },
    remove: {
        "id": "frontbucket.settings.permissions.remove",
        "defaultMessage": "Remove"
    },
    noAccessProjectPermission: {
        "id": "frontbucket.settings.permissions.noAccessProjectPermission",
        "defaultMessage": "This permission is inherited from the project."
    },
    noAccessWorkspacePermission: {
        "id": "frontbucket.settings.permissions.noAccessWorkspacePermission",
        "defaultMessage": "This permission is inherited from the workspace."
    },
    noAccessWorkspacePermissionOrgLevel: {
        "id": "frontbucket.settings.permissions.noAccessWorkspacePermissionOrgLevel",
        "defaultMessage": "This permission is managed in Atlassian Administration."
    },
    createPermissionInfoLabel: {
        "id": "frontbucket.settings.permissions.createPermissionInfoLabel",
        "defaultMessage": "create permission details"
    },
    createRepoPermissionDescription: {
        "id": "frontbucket.settings.permissions.createRepoPermissionInfo",
        "defaultMessage": 'Can create repositories and are assigned Admin access to those repositories. All activities permitted by the "Write" permission are granted as well.'
    },
    createProjectPermissionDescription: {
        "id": "frontbucket.settings.permissions.createProjectPermissionInfo",
        "defaultMessage": 'Can create projects and are assigned Admin access to those created projects. All activities permitted by the "Write" permission are allowed as well.'
    }
});
const $419d571f8186accb$export$a190e1af00082b41 = ({ api: api, permissions: permissions, checkedRows: checkedRows, workspaceSlug: workspaceSlug, showAccessLevel: showAccessLevel })=>{
    const [isSumEnabled] = (0, $4HDjC.useIsSumEnabled)();
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    const { publishButtonClickEvent: publishButtonClickEvent } = (0, $f9pRZ.useAnalytics)();
    const [{ loadingState: loadingState }] = (0, $4HDjC.useLoadingState)();
    const [{ activePermission: activePermission }] = (0, $4HDjC.useActivePermission)();
    const [{ isWorkspaceAdmin: isWorkspaceAdmin }] = (0, $4HDjC.useAdminLevel)();
    const [{ context: context }] = (0, $4HDjC.usePermissionsContext)();
    const { setIsChecked: setIsChecked, setActiveModal: setActiveModal, isEditable: isEditable } = (0, $4HDjC.useActions)();
    const updateAccess = (0, $4HDjC.useUpdateAccess)(api);
    const currentUser = (0, $aAre5.useSelector)((0, $g2R3c.getCurrentUser));
    function getNoAccessWorkspacePermissionMessage() {
        return isSumEnabled ? $419d571f8186accb$var$messages.noAccessWorkspacePermissionOrgLevel : $419d571f8186accb$var$messages.noAccessWorkspacePermission;
    }
    return permissions.map((row)=>{
        const { id: id, name: name, level: level } = row;
        const canEdit = isEditable({
            level: level,
            privilege: row.privilege
        });
        const key = (0, $hCBEg.getPermissionId)(row);
        return {
            key: key,
            cells: [
                {
                    key: `${key}-checkbox`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5oo0Y.default), {
                        onChange: ()=>setIsChecked(row),
                        isChecked: (0, $hCBEg.includesPermission)(checkedRows, row),
                        isDisabled: !canEdit,
                        testId: `${key}-checkbox`
                    })
                },
                {
                    key: `${key}-name-${name.toLocaleLowerCase()}`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $1YjBi.AvatarItem), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, row, {
                        isWorkspaceAdmin: isWorkspaceAdmin,
                        workspaceSlug: workspaceSlug
                    }))
                },
                {
                    key: `${key}-permission`,
                    content: canEdit && context !== "workspace" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fXsLf.default), {
                        isDisabled: activePermission === row && loadingState === (0, $cM1QH.LoadingState).PRIVILEGE_UPDATING,
                        value: row.privilege,
                        onChange: (privilege)=>{
                            if ((0, $hCBEg.showRemoveOwnAccessWarning)(permissions, row.mode, id, currentUser)) setActiveModal("RemoveOwnAccessWarning", [
                                row,
                                privilege
                            ]);
                            else updateAccess(privilege, row);
                            publishButtonClickEvent("PrivilegeDropdown", {
                                privilege: privilege
                            });
                        },
                        context: context
                    }) : (()=>{
                        let privilege;
                        if (row.level === "workspace" && row.privilege === "create-project") // no tooltip while hovering permission name for create-project
                        privilege = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6cjyK.PrivilegesDropdownText), null, formatMessage((0, $7q4Mr.getPermissionName)(row.privilege)));
                        else // including check to see if workspace is sum-enabled or not
                        privilege = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $a7iuM.default), {
                            testId: "checksum-tooltip",
                            content: formatMessage(row.level === "workspace" ? getNoAccessWorkspacePermissionMessage() : $419d571f8186accb$var$messages.noAccessProjectPermission),
                            position: "right"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6cjyK.PrivilegesDropdownText), null, formatMessage((0, $7q4Mr.getPermissionName)(row.privilege))));
                        if (row.privilege === (0, $7bBwl.Privilege)["create-repo"] || row.privilege === (0, $7bBwl.Privilege)["create-project"]) // info icon tooltip for create-repo and create-project permissions
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6cjyK.PrivilegeWithIcon), null, privilege, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $a7iuM.default), {
                            content: formatMessage(row.privilege === (0, $7bBwl.Privilege)["create-repo"] ? $419d571f8186accb$var$messages.createRepoPermissionDescription : $419d571f8186accb$var$messages.createProjectPermissionDescription),
                            position: "right"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fi8IW))), {
                            label: formatMessage($419d571f8186accb$var$messages.createPermissionInfoLabel)
                        })));
                        return privilege;
                    })()
                },
                ...showAccessLevel ? [
                    {
                        key: `${key}-access-level`,
                        content: formatMessage((0, $bOfxz.default)[level])
                    }
                ] : [],
                {
                    key: `${key}-actions`,
                    content: canEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3THTN.default), {
                        appearance: "link",
                        onClick: ()=>{
                            setActiveModal("RemoveAccessModal", row);
                            publishButtonClickEvent("RemoveAction");
                        },
                        testId: `${key}-remove-btn`
                    }, formatMessage($419d571f8186accb$var$messages.remove))
                }
            ]
        };
    });
};

});
parcelRegister("fi8IW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b21f4dd485e8caaa$var$_react = $b21f4dd485e8caaa$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $b21f4dd485e8caaa$var$_information = $b21f4dd485e8caaa$var$_interopRequireDefault((parcelRequire("JluUo")));
function $b21f4dd485e8caaa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b21f4dd485e8caaa$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $b21f4dd485e8caaa$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $b21f4dd485e8caaa$var$_information.default
    }));
$b21f4dd485e8caaa$var$EditorPanelIcon.displayName = "EditorPanelIcon";
var $b21f4dd485e8caaa$var$_default = module.exports.default = $b21f4dd485e8caaa$var$EditorPanelIcon;

});

parcelRegister("1YjBi", function(module, exports) {

$parcel$export(module.exports, "AvatarItem", function () { return $fca70b41c669a6a6$export$15f08c141eda7939; });

var $2xJU3 = parcelRequire("2xJU3");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $inFLm = parcelRequire("inFLm");

var $erAxb = parcelRequire("erAxb");

var $7doh5 = parcelRequire("7doh5");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $gjey0 = parcelRequire("gjey0");

var $oyaJz = parcelRequire("oyaJz");

var $jajUg = parcelRequire("jajUg");

var $4x9W6 = parcelRequire("4x9W6");

var $4HDjC = parcelRequire("4HDjC");

var $6cjyK = parcelRequire("6cjyK");
const $fca70b41c669a6a6$export$defe85febe8b728c = (0, $agjvf.defineMessages)({
    membersCount: {
        "id": "frontbucket.settings.permissions.membersCount",
        "defaultMessage": "{count} {count, plural, one {member} other {members}}"
    },
    deactivatedUserLozenge: {
        "id": "frontbucket.settings.permissions.deactivatedUserLozenge",
        "defaultMessage": "Deactivated"
    }
});
const $fca70b41c669a6a6$var$GroupLink = /*#__PURE__*/ (0, $2xJU3.default)((0, $gjey0.default), {
    target: "exuu6sq0"
})((0, $4x9W6.link), ";");
const $fca70b41c669a6a6$export$15f08c141eda7939 = ({ name: name, avatar: avatar, count: count, nickname: nickname = "", is_active: isActive, isWorkspaceAdmin: isWorkspaceAdmin, group_link: groupLink })=>{
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    const [isSumEnabled] = (0, $4HDjC.useIsSumEnabled)();
    const [isOrgAdmin] = (0, $4HDjC.useIsOrgAdmin)();
    if (avatar && !count) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $oyaJz.default), {
        avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $inFLm.default), {
            src: avatar,
            size: "medium"
        }),
        name: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", null, name, !isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7doh5.default), null, formatMessage($fca70b41c669a6a6$export$defe85febe8b728c.deactivatedUserLozenge)))),
        additionalInfo: nickname
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $oyaJz.default), {
        avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6cjyK.GroupAvatarContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($erAxb))), {
            label: "groupAvatar",
            primaryColor: (0, $h39Sh.default)("color.icon.inverse", (0, $jp7ng).N0),
            size: "large"
        })),
        name: /* if the ‘check for workspace admin’ request fails the link is rendered, 
    but if the user clicks it they’ll see a 403 page saying they don’t have 
    access to the page. In that case, my thinking is that it’s better to let 
    some users through to a 403 than to intermittently hide functionality from 
    an admin user with no way for the user to know why. Instead this guarantees 
    the admin user’s experience won’t be broken, but on request failure may 
    allow a non-admin user to see a 403 page. */ groupLink && (isSumEnabled && isOrgAdmin || isWorkspaceAdmin || isWorkspaceAdmin === undefined) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($fca70b41c669a6a6$var$GroupLink, {
            to: groupLink
        }, name) : name,
        additionalInfo: formatMessage($fca70b41c669a6a6$export$defe85febe8b728c.membersCount, {
            count: count
        })
    });
};

});
parcelRegister("gjey0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed5d4f85ab0bb110$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("3hjiH");
var $kh0W2 = parcelRequire("kh0W2");

var $kvnVB = parcelRequire("kvnVB");
var $ed5d4f85ab0bb110$export$2e2bcd8739ae039;
$ed5d4f85ab0bb110$export$2e2bcd8739ae039 = class RelativeLink extends (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).PureComponent {
    render() {
        const { to: to, children: children, className: className, qaId: qaId, ...rest } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kh0W2.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            className: className,
            "data-qa": qaId,
            to: to.replace((0, $kvnVB.settings)().CANON_URL, "")
        }, rest), children);
    }
};

});
parcelRegister("3hjiH", function(module, exports) {

$parcel$export(module.exports, "Redirect", function () { return (parcelRequire("jQl2W")).Redirect; });
$parcel$export(module.exports, "Link", function () { return (parcelRequire("kh0W2")).default; });
$parcel$export(module.exports, "Router", function () { return (parcelRequire("9A93V")).default; });
parcelRequire("lM4y8");
var $jQl2W = parcelRequire("jQl2W");

var $kh0W2 = parcelRequire("kh0W2");

var $9A93V = parcelRequire("9A93V");

});
parcelRegister("kh0W2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $478eafccd62f59cb$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("lM4y8");
var $iPZCM = parcelRequire("iPZCM");
const $478eafccd62f59cb$var$Link = (props)=>{
    const { innerRef: innerRef, ...resourceRouterProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $iPZCM.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        ref: innerRef
    }, resourceRouterProps, {
        // Override type="button"; explicitly force anchor links with react-resource-router
        // https://github.com/atlassian-labs/react-resource-router/blob/master/src/ui/link/utils/get-valid-link-type.tsx#L6
        type: "a"
    }));
};
var $478eafccd62f59cb$export$2e2bcd8739ae039 = $478eafccd62f59cb$var$Link;

});

parcelRegister("9A93V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22bc5a38934f2119$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("lM4y8");
var $e4G5V = parcelRequire("e4G5V");
var $cJdeW = parcelRequire("cJdeW");

var $bGAE6 = parcelRequire("bGAE6");
const $22bc5a38934f2119$var$Router = ({ history: history, routes: routes, children: children, isSsr: isSsr, location: location, ...rest })=>{
    if (isSsr) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $cJdeW.StaticRouter), {
        routes: routes,
        location: location
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $e4G5V.Router), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        history: history,
        routes: routes,
        resourceData: (0, $bGAE6.getResourceStoreSsrState)()
    }, rest), children);
};
$22bc5a38934f2119$var$Router.defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */ isStatic: false,
    // eslint-disable-next-line
    transitionBlocker: async ()=>true
};
var $22bc5a38934f2119$export$2e2bcd8739ae039 = $22bc5a38934f2119$var$Router;

});
parcelRegister("bGAE6", function(module, exports) {

$parcel$export(module.exports, "getResourceStoreSsrState", function () { return $e36b8d4d79ffa08b$export$f353535a2c2fa8cf; });
$parcel$export(module.exports, "getReduxStoreSsrState", function () { return $e36b8d4d79ffa08b$export$c3a0c7a5cb813946; });

var $1ZBmx = parcelRequire("1ZBmx");
const $e36b8d4d79ffa08b$var$getHydratableState = (key)=>(0, $1ZBmx.canHydrateFromSsr)() ? (0, $1ZBmx.getSsrState)()[key] : undefined;
const $e36b8d4d79ffa08b$export$f353535a2c2fa8cf = ()=>$e36b8d4d79ffa08b$var$getHydratableState("resourceStoreState");
const $e36b8d4d79ffa08b$export$c3a0c7a5cb813946 = ()=>$e36b8d4d79ffa08b$var$getHydratableState("reduxStoreState");

});




parcelRegister("4x9W6", function(module, exports) {

$parcel$export(module.exports, "overflowEllipsis", function () { return $f5b78150cd3b7fab$export$5055846ad3e68b48; });
$parcel$export(module.exports, "link", function () { return $f5b78150cd3b7fab$export$9c30223ca0a664fb; });
$parcel$export(module.exports, "subtleLink", function () { return $f5b78150cd3b7fab$export$85dd97219e86b91c; });
$parcel$export(module.exports, "fixedFlexItem", function () { return $f5b78150cd3b7fab$export$d0cf6c859014b5a5; });
parcelRequire("45CBz");
var $7KAwG = parcelRequire("7KAwG");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");
function $f5b78150cd3b7fab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f5b78150cd3b7fab$export$5055846ad3e68b48 = (maxWidth = "inherit")=>`
  overflow: hidden;
  max-width: ${maxWidth};
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const $f5b78150cd3b7fab$export$9c30223ca0a664fb = /*#__PURE__*/ (0, $7KAwG.default)({
    "&, &:hover, &:focus": {
        color: (0, $h39Sh.default)("color.text", (0, $jp7ng).N800)
    }
}, "");
const $f5b78150cd3b7fab$export$85dd97219e86b91c = /*#__PURE__*/ (0, $7KAwG.default)({
    "&, &:hover, &:focus": {
        color: (0, $h39Sh.default)("color.text.subtlest", (0, $jp7ng).N300)
    }
}, "");
const $f5b78150cd3b7fab$export$d0cf6c859014b5a5 = {
    name: "5j8kp",
    styles: "display:flex;flex-shrink:0;flex-grow:0;"
};

});




parcelRegister("8OHIZ", function(module, exports) {

$parcel$export(module.exports, "PermissionsActions", function () { return $7cfb341f6d1b48ba$export$7e34a90f0c919490; });

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $3THTN = parcelRequire("3THTN");

var $f9pRZ = parcelRequire("f9pRZ");

var $jajUg = parcelRequire("jajUg");

var $4HDjC = parcelRequire("4HDjC");
const $7cfb341f6d1b48ba$var$messages = (0, $agjvf.defineMessages)({
    addUsersOrGroupsBtn: {
        "id": "frontbucket.settings.permissions.add-users-or-groups-btn",
        "defaultMessage": "Add users or groups"
    }
});
const $7cfb341f6d1b48ba$export$7e34a90f0c919490 = ()=>{
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    const { publishButtonClickEvent: publishButtonClickEvent } = (0, $f9pRZ.useAnalytics)();
    const { setActiveModal: setActiveModal } = (0, $4HDjC.useActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3THTN.default), {
        testId: "addPrivilegeButton",
        onClick: ()=>{
            setActiveModal("AddAccessModal");
            publishButtonClickEvent("AddUsersOrGroups");
        }
    }, formatMessage($7cfb341f6d1b48ba$var$messages.addUsersOrGroupsBtn));
};

});

parcelRegister("5sg28", function(module, exports) {

$parcel$export(module.exports, "buildBBQL", function () { return $a95b19664316307e$export$3540dbfe03183902; });

var $964rM = parcelRequire("964rM");
const $a95b19664316307e$export$3540dbfe03183902 = (filters = {})=>{
    const queries = [];
    if (filters.accessLevel) queries.push(`access_level="${(0, $964rM.default)(filters.accessLevel)}"`);
    if (filters.permission) queries.push(`permission="${(0, $964rM.default)(filters.permission)}"`);
    if (filters.principalName) queries.push(`principal_name~"${(0, $964rM.default)(filters.principalName)}"`);
    return queries.join(" AND ");
};

});


parcelRegister("1LLhT", function(module, exports) {

$parcel$export(module.exports, "hasWorkspaceAdminStatus", function () { return $d990ca0065f33ba2$export$857ca010e00e9414; });

var $03mTx = parcelRequire("03mTx");
async function $d990ca0065f33ba2$export$857ca010e00e9414(workspaceSlug) {
    try {
        const resp = await fetch(`/!api/2.0/user/permissions/workspaces?fields=values.permission&q=workspace.slug=${encodeURIComponent(`"${workspaceSlug}"`)}`);
        if (resp.ok) {
            var _values$;
            const { values: values } = await resp.json();
            return ((_values$ = values[0]) === null || _values$ === void 0 ? void 0 : _values$.permission) === (0, $03mTx.WorkspacePermission).Owner;
        }
    } catch (e) {
        // no need to log error, just return undefined as workspace admin status unknown
        return undefined;
    }
    // by default return undefined as workspace admin status unknown
    return undefined;
}

});
parcelRegister("03mTx", function(module, exports) {

$parcel$export(module.exports, "WorkspacePermission", function () { return $4c7760ab9ef6b0e6$export$1de48cbc0e14077c; });
var $4c7760ab9ef6b0e6$export$1de48cbc0e14077c;
(function(WorkspacePermission) {
    WorkspacePermission["Member"] = "member";
    WorkspacePermission["Collaborator"] = "collaborator";
    WorkspacePermission["Owner"] = "owner";
})($4c7760ab9ef6b0e6$export$1de48cbc0e14077c || ($4c7760ab9ef6b0e6$export$1de48cbc0e14077c = {}));

});



parcelRegister("89xm9", function(module, exports) {

$parcel$export(module.exports, "ProjectRepositoriesLoadable", function () { return $f1855344a2c50b8c$export$11268b1cbdcaa67d; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $f1855344a2c50b8c$export$11268b1cbdcaa67d = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("dLNZ7")),
    modules: [
        "./project-repositories-layout"
    ],
    webpack: ()=>[
            undefined("./project-repositories-layout")
        ]
});

});
parcelRegister("dLNZ7", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("N6nXV")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5ctRf"))
]).then(()=>parcelRequire("1pUN4"));

});


parcelRegister("7sB53", function(module, exports) {

$parcel$export(module.exports, "workspaceNavigationResource", function () { return $0cde1820bc672f7d$export$7ae5e4f65e02cbff; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $ksfVj = parcelRequire("ksfVj");

var $k2cPS = parcelRequire("k2cPS");
const $0cde1820bc672f7d$export$7ae5e4f65e02cbff = (0, $3kfkg.createResource)({
    type: "WORKSPACE_NAVIGATION",
    getKey: ({ match: match })=>`workspace:${match.params.workspaceSlug}`,
    maxAge: 600000,
    // 10 minute
    getData: async ({ match: match })=>{
        const { workspaceSlug: workspaceSlug } = match.params;
        if (!workspaceSlug) throw new Error("This resource can only be used on routes that contain a workspaceSlug in the path");
        const url = (0, $ksfVj.default).api.internal.navigation(workspaceSlug);
        const response = await fetch((0, $k2cPS.default)(url, {
            headers: (0, $k2cPS.jsonHeaders)
        }));
        if (!response.ok) throw new Error(`Error fetching workspace navigation data (${response.status}): ${response.statusText}`);
        return response.json();
    }
});

});

parcelRegister("blHue", function(module, exports) {




































module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jokVj")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("a0pdz")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("4lXxI")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8FZFT")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("lHmBe")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("gSn8f")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvUP")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6qh0x")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kjN9y")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c3BIL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvz8")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("e0Fn7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fDD7i")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7xLkx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3op3S")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("ic2sg")),
    (parcelRequire("18jdD"))((parcelRequire("1sJKT")).getBundleURL("ekZ4q") + "project-navigation-next.c8bfe255.js", "script", false)
]).then(()=>parcelRequire("1zZPd"));

});
parcelRegister("18jdD", function(module, exports) {
"use strict";

var $51a7t = parcelRequire("51a7t");
module.exports = $51a7t(function(bundle, priority, isModule) {
    var link = document.createElement("link");
    link.charset = "utf-8";
    link.rel = isModule ? "modulepreload" : "preload";
    link.href = bundle;
    if (priority) link.as = priority;
    document.getElementsByTagName("head")[0].appendChild(link);
    return Promise.resolve();
}, "preload");

});



parcelRegister("aTvGV", function(module, exports) {

$parcel$export(module.exports, "getRepositoryRoutesConfig", function () { return $6f5d5ec4525eaacc$export$b49179c6b8a23af2; });

var $8shKB = parcelRequire("8shKB");

var $iRIkP = parcelRequire("iRIkP");

var $jkXYv = parcelRequire("jkXYv");

var $3f1Aw = parcelRequire("3f1Aw");

var $apEkQ = parcelRequire("apEkQ");

var $QAYVs = parcelRequire("QAYVs");

var $awFy5 = parcelRequire("awFy5");

var $jpBVz = parcelRequire("jpBVz");

var $5rTsd = parcelRequire("5rTsd");

var $aV0k9 = parcelRequire("aV0k9");

var $Wsnex = parcelRequire("Wsnex");

var $kndtw = parcelRequire("kndtw");

var $32AKt = parcelRequire("32AKt");

var $jELvD = parcelRequire("jELvD");

var $3iBXH = parcelRequire("3iBXH");

var $3agw6 = parcelRequire("3agw6");

var $3QVWH = parcelRequire("3QVWH");

var $4pqRO = parcelRequire("4pqRO");

var $3wXS7 = parcelRequire("3wXS7");

var $aIRDc = parcelRequire("aIRDc");

var $bT38u = parcelRequire("bT38u");

var $iOXsw = parcelRequire("iOXsw");

var $5Hpkc = parcelRequire("5Hpkc");

var $h91BB = parcelRequire("h91BB");

var $2ppog = parcelRequire("2ppog");

var $3qRfc = parcelRequire("3qRfc");

var $a5zrX = parcelRequire("a5zrX");

var $k5krn = parcelRequire("k5krn");

var $8weAu = parcelRequire("8weAu");

var $gq9I5 = parcelRequire("gq9I5");

var $amI74 = parcelRequire("amI74");

var $gP97l = parcelRequire("gP97l");

var $5k8TG = parcelRequire("5k8TG");

var $ekNC5 = parcelRequire("ekNC5");

var $9Ue31 = parcelRequire("9Ue31");

var $SUJHq = parcelRequire("SUJHq");

var $dQi9S = parcelRequire("dQi9S");

var $e1tSr = parcelRequire("e1tSr");

var $4Uhvl = parcelRequire("4Uhvl");

var $17McB = parcelRequire("17McB");

var $ccRPo = parcelRequire("ccRPo");

var $1zb3u = parcelRequire("1zb3u");

var $9KBU4 = parcelRequire("9KBU4");

var $4kLie = parcelRequire("4kLie");

var $1uV8K = parcelRequire("1uV8K");

var $jAOzz = parcelRequire("jAOzz");

var $hqdnb = parcelRequire("hqdnb");

var $kysKv = parcelRequire("kysKv");

var $iDAZb = parcelRequire("iDAZb");

var $1yRHp = parcelRequire("1yRHp");

var $kUD1u = parcelRequire("kUD1u");

var $cHvpw = parcelRequire("cHvpw");

var $c1CiF = parcelRequire("c1CiF");

var $7DpkT = parcelRequire("7DpkT");

var $6egPG = parcelRequire("6egPG");

var $6l8Gn = parcelRequire("6l8Gn");

var $4WNDe = parcelRequire("4WNDe");

var $2KpP3 = parcelRequire("2KpP3");

var $hIwXT = parcelRequire("hIwXT");

var $7IfQd = parcelRequire("7IfQd");

const $6f5d5ec4525eaacc$var$RepositoryLayout = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("hm2h4")),
    modules: [
        "src/sections/repository/layout"
    ],
    webpack: ()=>[
            undefined("src/sections/repository/layout")
        ]
});

const $6f5d5ec4525eaacc$var$RepositoryRedirect = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("7oafM")),
    modules: [
        "src/sections/repository/repository-redirect"
    ],
    webpack: ()=>[
            undefined("src/sections/repository/repository-redirect")
        ]
});

const $6f5d5ec4525eaacc$var$SourceDiffLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("gcojQ")),
    modules: [
        "src/sections/repository/sections/source/containers/source-diff"
    ],
    webpack: ()=>[
            undefined("src/sections/repository/sections/source/containers/source-diff")
        ]
});

const $6f5d5ec4525eaacc$var$FileHistoryLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("iphj0")),
    modules: [
        "src/sections/repository/sections/source/containers/file-history-wrapped"
    ],
    webpack: ()=>[
            undefined("src/sections/repository/sections/source/containers/file-history-wrapped")
        ]
});

const $6f5d5ec4525eaacc$var$RepositoryHistoryRedirect = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("al1PW")),
    modules: [
        "src/sections/repository/sections/commit-list/history-redirect"
    ],
    webpack: ()=>[
            undefined("src/sections/repository/sections/commit-list/history-redirect")
        ]
});

const $6f5d5ec4525eaacc$var$SourceBrowser = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("6pgK1")),
    modules: [
        "src/sections/repository/sections/source/containers/source-browser-resource-router"
    ],
    webpack: ()=>[
            undefined("src/sections/repository/sections/source/containers/source-browser-resource-router")
        ]
});

const $6f5d5ec4525eaacc$var$CommitPage = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("GxHC8")),
    modules: [
        "src/sections/repository/sections/commit/route"
    ],
    webpack: ()=>[
            undefined("src/sections/repository/sections/commit/route")
        ]
});

const $6f5d5ec4525eaacc$var$CreatePullRequest = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("73vEv")),
    modules: [
        "src/sections/repository/sections/create-pull-request/route"
    ],
    webpack: ()=>[
            undefined("src/sections/repository/sections/create-pull-request/route")
        ]
});

const $6f5d5ec4525eaacc$var$PullRequest = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("jNY5D")),
    modules: [
        "src/sections/repository/sections/pull-request/containers/page"
    ],
    webpack: ()=>[
            undefined("src/sections/repository/sections/pull-request/containers/page")
        ]
});

const $6f5d5ec4525eaacc$var$ConnectPageLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>Promise.resolve((parcelRequire("i90RT"))),
    modules: [
        "src/sections/repository/containers/connect-page"
    ],
    webpack: ()=>[
            undefined("src/sections/repository/containers/connect-page")
        ]
});

const $6f5d5ec4525eaacc$var$ForgePageLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("eNsia")),
    modules: [
        "src/forge/repo-main-menu-page/repo-main-menu-page"
    ],
    webpack: ()=>[
            undefined("src/forge/repo-main-menu-page/repo-main-menu-page")
        ]
});

const $6f5d5ec4525eaacc$var$SettingsForgePageLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("fS8dn")),
    modules: [
        "src/forge/repo-settings-menu-page/repo-settings-menu-page"
    ],
    webpack: ()=>[
            undefined("src/forge/repo-settings-menu-page/repo-settings-menu-page")
        ]
});

const $6f5d5ec4525eaacc$var$JiraViewLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("cyStG")),
    modules: [
        "src/sections/repository/sections/jira"
    ],
    webpack: ()=>[
            undefined("src/sections/repository/sections/jira")
        ]
});

const $6f5d5ec4525eaacc$var$loadableWebhooksPage = (pageName)=>()=>(parcelRequire("2D7R6")).then((pages)=>pages[pageName]);
const $6f5d5ec4525eaacc$var$WebhooksLandingPage = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: $6f5d5ec4525eaacc$var$loadableWebhooksPage("WebhooksLandingPage")
});
const $6f5d5ec4525eaacc$var$AddWebhookPage = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: $6f5d5ec4525eaacc$var$loadableWebhooksPage("AddWebhookPage")
});
const $6f5d5ec4525eaacc$var$EditWebhookPage = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: $6f5d5ec4525eaacc$var$loadableWebhooksPage("EditWebhookPage")
});
const $6f5d5ec4525eaacc$var$ViewWebhookPage = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: $6f5d5ec4525eaacc$var$loadableWebhooksPage("ViewWebhookDetailsPage")
});
const $6f5d5ec4525eaacc$var$ViewWebhookEventPage = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: $6f5d5ec4525eaacc$var$loadableWebhooksPage("ViewWebhookEventPage")
});

const $6f5d5ec4525eaacc$var$RepoDetailsSettingsPage = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("gkC80")),
    modules: [
        "src/sections/repository/sections/admin/components/settings-pages/details"
    ],
    webpack: ()=>[
            undefined("src/sections/repository/sections/admin/components/settings-pages/details")
        ]
});

const $6f5d5ec4525eaacc$var$RepoComplianceSettingsPage = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("k9YSQ")),
    modules: [
        "src/sections/repository/sections/admin/components/settings-pages/compliance"
    ],
    webpack: ()=>[
            undefined("src/sections/repository/sections/admin/components/settings-pages/compliance")
        ]
});

const $6f5d5ec4525eaacc$var$RepoUsernameAliasesSettingsPage = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("kQgAG")),
    modules: [
        "src/sections/repository/sections/admin/components/settings-pages/username-aliases"
    ],
    webpack: ()=>[
            undefined("src/sections/repository/sections/admin/components/settings-pages/username-aliases")
        ]
});

const $6f5d5ec4525eaacc$var$BranchDetailPage = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("5vgPi")),
    modules: [
        "src/sections/repository/sections/branch/route"
    ],
    webpack: ()=>[
            undefined("src/sections/repository/sections/branch/route")
        ]
});

const $6f5d5ec4525eaacc$var$PipelinesRepoAdminRedirectDeploymentsSettingsLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("fG54d")),
    modules: [
        "src/sections/repository/sections/admin/components/settings-pages/pipelines/redirect/to-frontbucket-deployments"
    ],
    webpack: ()=>[
            undefined("src/sections/repository/sections/admin/components/settings-pages/pipelines/redirect/to-frontbucket-deployments")
        ]
});

const $6f5d5ec4525eaacc$var$PipelinesRepoAdminRedirectRunnersSettingsLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("1on5U")),
    modules: [
        "src/sections/repository/sections/admin/components/settings-pages/pipelines/redirect/to-frontbucket-runners"
    ],
    webpack: ()=>[
            undefined("src/sections/repository/sections/admin/components/settings-pages/pipelines/redirect/to-frontbucket-runners")
        ]
});

const $6f5d5ec4525eaacc$var$PipelinesRepoAdminRedirectSettingsLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("fG54d")),
    modules: [
        "src/sections/repository/sections/admin/components/settings-pages/pipelines/redirect/to-frontbucket-deployments"
    ],
    webpack: ()=>[
            undefined("src/sections/repository/sections/admin/components/settings-pages/pipelines/redirect/to-frontbucket-deployments")
        ]
});
const $6f5d5ec4525eaacc$export$b49179c6b8a23af2 = ()=>{
    return {
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_CREATE_PR]: {
            // @ts-ignore: requires RouteContext type on component
            component: $6f5d5ec4525eaacc$var$CreatePullRequest,
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $6l8Gn.loadBranchesResource),
                (0, $h91BB.loadRepositoryDetailsResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_CODE_REVIEW]: {
            // @ts-ignore: requires RouteContext type on component
            component: $6f5d5ec4525eaacc$var$PullRequest,
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $iOXsw.loadNudgedReviewersResource),
                (0, $5Hpkc.loadPullRequestResource),
                (0, $h91BB.loadRepositoryDetailsResource),
                (0, $2KpP3.loadForgeMergeChecksResultsResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_BRANCH_DETAIL]: {
            // @ts-ignore: requires RouteContext type on component
            component: $6f5d5ec4525eaacc$var$BranchDetailPage,
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $h91BB.loadRepositoryDetailsResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_SOURCE]: {
            // @ts-ignore: requires RouteContext type on component
            component: $6f5d5ec4525eaacc$var$SourceBrowser,
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $h91BB.loadRepositoryDetailsResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_BRANCH_CREATE]: {
            component: (0, $a5zrX.default),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_COMMITS]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $7DpkT.default),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_COMMIT]: {
            // @ts-ignore: requires RouteContext type on component
            component: $6f5d5ec4525eaacc$var$CommitPage,
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $6egPG.loadCommitResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_SOURCE_DIFF]: {
            // @ts-ignore: requires RouteContext type on component
            component: $6f5d5ec4525eaacc$var$SourceDiffLoadable,
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_FILE_HISTORY]: {
            // @ts-ignore: requires RouteContext type on component
            component: $6f5d5ec4525eaacc$var$FileHistoryLoadable,
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_COMMITS_HISTORY]: {
            // @ts-ignore: requires RouteContext type on component
            component: $6f5d5ec4525eaacc$var$RepositoryHistoryRedirect,
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_CONNECT_PAGE]: {
            component: $6f5d5ec4525eaacc$var$ConnectPageLoadable,
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_FORGE_PAGE]: {
            component: $6f5d5ec4525eaacc$var$ForgePageLoadable,
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_JIRA_VIEW]: {
            // @ts-ignore: requires RouteContext type on component
            component: $6f5d5ec4525eaacc$var$JiraViewLoadable,
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $h91BB.loadRepositoryDetailsResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_BRANCHES_LIST]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $cHvpw.default),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $h91BB.loadRepositoryDetailsResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_PULL_REQUESTS]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $4WNDe.default),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $h91BB.loadRepositoryDetailsResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_COLD_STORAGE]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $c1CiF.default),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_SECURITY]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $hIwXT.RepoSecurityLandingPageLoadable),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_SECURITY_LEARN_MORE]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $hIwXT.RepoSecurityLearnMoreLoadable),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_DEPLOYMENTS]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $iRIkP.default),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource),
                (0, $jpBVz.loadDeploymentDashboardResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_PIPELINES]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $jkXYv.default),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $3qRfc.loadRepositoryResourcePipelines),
                (0, $3iBXH.loadPipelinesResource),
                (0, $32AKt.loadPipelineDefinitionsResource),
                (0, $kndtw.loadPipelineCreatorsResource),
                (0, $k5krn.repositoryNavigationResource),
                (0, $jpBVz.loadDeploymentDashboardResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_PIPELINES_RESULT]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $jkXYv.default),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $3qRfc.loadRepositoryResourcePipelines),
                (0, $awFy5.loadCurrentPipelineResource),
                (0, $4pqRO.loadStepsResource),
                (0, $jELvD.loadPipelineRunsResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_TEST_MANAGEMENT]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $3f1Aw.TestManagementLoadable),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_TEST_EXECUTION]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $apEkQ.TestExecutionLoadable),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        // Jira migration repo admin routes
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_ISSUES_MIGRATION]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $kUD1u.default),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        // Webhooks repo admin routes
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_WEBHOOKS_ROOT]: {
            // @ts-ignore: requires RouteContext type on component
            component: $6f5d5ec4525eaacc$var$WebhooksLandingPage,
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $hqdnb.loadRepositoryWebhooksResource),
                (0, $kysKv.loadWorkspaceWebhooksResource),
                (0, $jAOzz.loadConnectWebhooksResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_CREATE_WEBHOOK]: {
            // @ts-ignore: requires RouteContext type on component
            component: $6f5d5ec4525eaacc$var$AddWebhookPage,
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $hqdnb.loadRepositoryWebhooksResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_EDIT_WEBHOOK]: {
            // @ts-ignore: requires RouteContext type on component
            component: $6f5d5ec4525eaacc$var$EditWebhookPage,
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $hqdnb.loadRepositoryWebhooksResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_VIEW_WEBHOOK]: {
            // @ts-ignore: requires RouteContext type on component
            component: $6f5d5ec4525eaacc$var$ViewWebhookPage,
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                // Users can view Repo/Workspace/Connect hook details so we request all 3 types here, but
                // they should already be cached from the visit to the landing page.
                (0, $hqdnb.loadRepositoryWebhooksResource),
                (0, $kysKv.loadWorkspaceWebhooksResource),
                (0, $jAOzz.loadConnectWebhooksResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_VIEW_WEBHOOK_EVENT]: {
            // @ts-ignore: requires RouteContext type on component
            component: $6f5d5ec4525eaacc$var$ViewWebhookEventPage,
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                // Users can view Repo/Workspace/Connect hook details so we request all 3 types here, but
                // they should already be cached from the visit to the landing page.
                (0, $hqdnb.loadRepositoryWebhooksResource),
                (0, $kysKv.loadWorkspaceWebhooksResource),
                (0, $jAOzz.loadConnectWebhooksResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        // Repo admin routes
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_DETAIL]: {
            // @ts-ignore: requires RouteContext type on component
            component: $6f5d5ec4525eaacc$var$RepoDetailsSettingsPage,
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $h91BB.loadRepositoryDetailsResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_PERMISSIONS]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $dQi9S.RepoSettingsPermissionsLoadable),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $e1tSr.loadRepositorySettingsPermissionsResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_ACCESS_KEYS]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $8weAu.RepoSettingsAccessKeysLoadable),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_COMMITTERS]: {
            // @ts-ignore: requires RouteContext type on component
            component: $6f5d5ec4525eaacc$var$RepoUsernameAliasesSettingsPage,
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_COMPLIANCE]: {
            // @ts-ignore: requires RouteContext type on component
            component: $6f5d5ec4525eaacc$var$RepoComplianceSettingsPage,
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_BRANCH_RESTRICTIONS]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $amI74.BranchRestrictionsLoadable),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_BRANCHING_MODEL]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $gP97l.BranchingModelLoadable),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_MERGE_CHECKS]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $9Ue31.MergeChecksLoadable),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $aIRDc.customMergeChecksConfigRouteResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_MERGE_STRATEGIES]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $SUJHq.RepoSettingsMergeStrategiesLoadable),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_DEFAULT_REVIEWERS]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $ekNC5.DefaultReviewersLoadable),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_DEFAULT_REVIEW_GROUPS]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $5k8TG.DefaultReviewGroupsLoadable),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_ACCESS_TOKENS]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $gq9I5.AccessTokensLoadable),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_PIPELINES_REDIRECT_SETTINGS]: {
            // @ts-ignore: requires RouteContext type on component
            component: $6f5d5ec4525eaacc$var$PipelinesRepoAdminRedirectSettingsLoadable,
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_PIPELINES_REDIRECT_RUNNERS]: {
            // @ts-ignore: requires RouteContext type on component
            component: $6f5d5ec4525eaacc$var$PipelinesRepoAdminRedirectRunnersSettingsLoadable,
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_PIPELINES_REDIRECT_DEPLOYMENTS]: {
            // @ts-ignore: requires RouteContext type on component
            component: $6f5d5ec4525eaacc$var$PipelinesRepoAdminRedirectDeploymentsSettingsLoadable,
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource),
                (0, $jpBVz.loadDeploymentDashboardResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_PIPELINES_SETTINGS]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $9KBU4.default),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $3QVWH.loadShadowRepositoryConfigurationResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_PIPELINES_OPENID]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $ccRPo.default),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource),
                (0, $jpBVz.loadDeploymentDashboardResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_PIPELINES_SSH_KEYS]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $4kLie.default),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $aV0k9.loadPipelinesRepositoryKeyPairResource),
                (0, $Wsnex.loadPipelinesRepositoryKnownHostsResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_PIPELINES_RUNNERS]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $1zb3u.default),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $3agw6.loadPipelinesWorkspaceRunnersResource),
                (0, $3agw6.loadPipelinesRepositoryRunnersResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_PIPELINES_DEPLOYMENTS]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $4Uhvl.default),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $QAYVs.loadPipelinesRepositoryAssociationSummaryResource),
                (0, $k5krn.repositoryNavigationResource),
                (0, $jpBVz.loadDeploymentDashboardResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_PIPELINES_VARIABLES]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $1uV8K.default),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_PIPELINES_DYNAMIC_PIPELINES]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $17McB.default),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $5rTsd.loadRepositoryDynamicPipelinesResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_CONNECT_IFRAME]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $iDAZb.default),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_IFRAME]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $1yRHp.default),
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_ADMIN_FORGE_PAGE]: {
            // @ts-ignore: requires RouteContext type on component
            component: $6f5d5ec4525eaacc$var$SettingsForgePageLoadable,
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $2ppog.loadRepositoryResource),
                (0, $k5krn.repositoryNavigationResource)
            ]
        },
        // Redirect if no other match
        [(0, $7IfQd.ROUTE_NAME).REPOSITORY_REDIRECT]: {
            // @ts-ignore: requires RouteContext type on component
            component: $6f5d5ec4525eaacc$var$RepositoryRedirect,
            layout: $6f5d5ec4525eaacc$var$RepositoryLayout,
            resources: [
                (0, $bT38u.loadGlobalResource)
            ]
        }
    };
};

});
parcelRegister("iRIkP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $413f916fe35eb634$export$2e2bcd8739ae039; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

var $413f916fe35eb634$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("3vW7p")),
    modules: [
        "./routes"
    ],
    webpack: ()=>[
            undefined("./routes")
        ]
});

});
parcelRegister("3vW7p", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("aMKTe")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("apPbw")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5DZC4"))
]).then(()=>parcelRequire("bBgZo"));

});


parcelRegister("jkXYv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac7529fedd2aa559$export$2e2bcd8739ae039; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

var $ac7529fedd2aa559$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("bxYMp")),
    modules: [
        "./routes"
    ],
    webpack: ()=>[
            undefined("./routes")
        ]
});

});
parcelRegister("bxYMp", function(module, exports) {






























module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("hss6y")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("HOeIP")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("k7j7T")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jDJuC")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("cFFKC")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jkg4B")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3vzef")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kBzNL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8FZFT")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6XRs7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6qh0x")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("iQZT4")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3ECa9")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5YdNQ")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("aaPJ5"))
]).then(()=>parcelRequire("4nAD2"));

});


parcelRegister("3f1Aw", function(module, exports) {

$parcel$export(module.exports, "TestManagementLoadable", function () { return $acbd1f534f609575$export$dc339733e90064ff; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $acbd1f534f609575$export$dc339733e90064ff = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("jqHAm")),
    modules: [
        "./test-management-page"
    ],
    webpack: ()=>[
            undefined("./test-management-page")
        ]
});

});
parcelRegister("jqHAm", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8JOMf")).then(()=>parcelRequire("anF07"));

});


parcelRegister("apEkQ", function(module, exports) {

$parcel$export(module.exports, "TestExecutionLoadable", function () { return $b054fcd345124aa9$export$2a76da6d1a6fcafd; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $b054fcd345124aa9$export$2a76da6d1a6fcafd = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("1mSjr")),
    modules: [
        "./test-execution-page"
    ],
    webpack: ()=>[
            undefined("./test-execution-page")
        ]
});

});
parcelRegister("1mSjr", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("iv1DM")).then(()=>parcelRequire("1DxbR"));

});


parcelRegister("QAYVs", function(module, exports) {

$parcel$export(module.exports, "loadPipelinesRepositoryAssociationSummaryResource", function () { return $9f5eafce2d3b9602$export$b219e3864994550b; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $fEutT = parcelRequire("fEutT");

var $k2cPS = parcelRequire("k2cPS");
function $9f5eafce2d3b9602$export$e355a57b5f857cac(params) {
    const { repositoryFullSlug: repositoryFullSlug = `${params.repositoryOwner}/${params.repositorySlug}` } = params;
    return `${(0, $fEutT.default)("/!api/internal")}/repositories/${repositoryFullSlug}/pipelines_config/associations/summary`;
}
const $9f5eafce2d3b9602$export$b219e3864994550b = (0, $3kfkg.createResource)({
    type: "pipelinesRepositoryAssociationSummary",
    getKey: ({ match: match })=>$9f5eafce2d3b9602$export$e355a57b5f857cac(match.params),
    maxAge: 60000,
    getData: async ({ match: match })=>{
        const data = await (await fetch((0, $k2cPS.default)($9f5eafce2d3b9602$export$e355a57b5f857cac(match.params)))).json();
        return data;
    }
});

});
parcelRegister("fEutT", function(module, exports) {

$parcel$export(module.exports, "PipelinesEnvEnum", function () { return $6f0157da3969d22d$export$7fb2a9b37c4bbd03; });
$parcel$export(module.exports, "getEnv", function () { return $6f0157da3969d22d$export$4bd44a2aa29d3d6e; });
$parcel$export(module.exports, "getEnvKey", function () { return $6f0157da3969d22d$export$ad30f942537ca53a; });
$parcel$export(module.exports, "getAddonKey", function () { return $6f0157da3969d22d$export$b6ff28888e5083c4; });
$parcel$export(module.exports, "getWebSocketUrl", function () { return $6f0157da3969d22d$export$fe1e824dabb60307; });
$parcel$export(module.exports, "default", function () { return $6f0157da3969d22d$export$2e2bcd8739ae039; });

var $cJH1T = parcelRequire("cJH1T");

var $86hZh = parcelRequire("86hZh");
var $6f0157da3969d22d$export$7fb2a9b37c4bbd03;
(function(PipelinesEnvEnum) {
    PipelinesEnvEnum["PRODUCTION"] = "";
    PipelinesEnvEnum["STAGING"] = "stg-west";
    PipelinesEnvEnum["DDEV"] = "ddev";
})($6f0157da3969d22d$export$7fb2a9b37c4bbd03 || ($6f0157da3969d22d$export$7fb2a9b37c4bbd03 = {}));
const $6f0157da3969d22d$export$4bd44a2aa29d3d6e = ()=>{
    var _getCookie, _ref;
    const envFallback = (_getCookie = (0, $86hZh.getCookie)("bbc-frontbucket-pipelines-env")) !== null && _getCookie !== void 0 ? _getCookie : "";
    return (_ref = (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).parse(location.search, {
        ignoreQueryPrefix: true
    }).env) !== null && _ref !== void 0 ? _ref : envFallback;
};
const $6f0157da3969d22d$export$ad30f942537ca53a = ()=>{
    const env = $6f0157da3969d22d$export$4bd44a2aa29d3d6e();
    if (env === "stg-west") return "STAGING";
    else if (env === "ddev") return "DDEV";
    return `PRODUCTION`;
};
const $6f0157da3969d22d$export$b6ff28888e5083c4 = ()=>{
    const env = $6f0157da3969d22d$export$4bd44a2aa29d3d6e();
    if (env === "stg-west") return `pipelines-stg-west`;
    else if (env === "ddev") return `pipelines-ddev`;
    return `pipelines`;
};
const $6f0157da3969d22d$export$fe1e824dabb60307 = ()=>{
    const env = $6f0157da3969d22d$export$4bd44a2aa29d3d6e();
    if (env === "stg-west") return `wss://bitbucketci-ws-service.stg.services.atlassian.com/ws`;
    else if (env === "ddev") return `wss://bitbucketci-ws-service.dev.services.atlassian.com/ws`;
    return `wss://bitbucketci-ws-service.services.atlassian.com/ws`;
};
function $6f0157da3969d22d$export$2e2bcd8739ae039(apiPrefix = "/!api/2.0", apiKey = "pipelines", // some environment APIs are inconsistent
fixInternal = false) {
    const env = $6f0157da3969d22d$export$4bd44a2aa29d3d6e();
    const internalPipelielinesApiPart = apiPrefix === "/!api/2.0" ? "" : fixInternal ? "" : "/internal";
    if (env === "stg-west") return `/!api/internal/${apiKey}/stg-west${internalPipelielinesApiPart}`;
    else if (env === "ddev") return `/!api/internal/${apiKey}/ddev${internalPipelielinesApiPart}`;
    return apiPrefix;
}

});


parcelRegister("awFy5", function(module, exports) {

$parcel$export(module.exports, "loadCurrentPipelineResource", function () { return $388e4a9000484449$export$7983043226f70338; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");
parcelRequire("hw8PW");
var $7JtYi = parcelRequire("7JtYi");

var $jPcDa = parcelRequire("jPcDa");

var $5E3NZ = parcelRequire("5E3NZ");

var $6t17p = parcelRequire("6t17p");
const $388e4a9000484449$export$94df0e59ebebf4a7 = (params)=>{
    return (0, $5E3NZ.getPipelineUrl)(params.repositoryFullSlug, params.pipelineUuid);
};
const $388e4a9000484449$export$7983043226f70338 = (0, $3kfkg.createResource)({
    type: "currentPipeline",
    getKey: ({ match: { params: params } })=>$388e4a9000484449$export$94df0e59ebebf4a7(params),
    maxAge: 0,
    getData: async ({ match: { params: params } }, { reduxStore: reduxStore, appData: appData })=>{
        if (!(appData !== null && appData !== void 0 && appData.features[(0, $7JtYi.FeatureKeys).isPipelinesPageLoadOptimisationEnabled])) return null;
        const { dispatch: dispatch, getState: getState } = reduxStore;
        if ((0, $6t17p.hasFetchedPipeline)(getState())) return {
            status: "success"
        };
        dispatch((0, $jPcDa.clearCurrentPipeline)());
        const data = await (0, $6t17p.fetchData)($388e4a9000484449$export$94df0e59ebebf4a7(params), "current_pipeline_resource_exception");
        dispatch((0, $jPcDa.setCurrentPipeline)(data));
        return {
            status: "success"
        };
    }
});

});
parcelRegister("jPcDa", function(module, exports) {

$parcel$export(module.exports, "WEBSOCKET_RECONNECT", function () { return $c0b73a0cc7c0566e$export$504846c72887f1ad; });
$parcel$export(module.exports, "WEBSOCKET_SUBSCRIBE", function () { return $c0b73a0cc7c0566e$export$e3863897eac4cc1a; });
$parcel$export(module.exports, "WEBSOCKET_UNSUBSCRIBE", function () { return $c0b73a0cc7c0566e$export$731a8033616af6f5; });
$parcel$export(module.exports, "CLEAR_BUILD_CONFIGURATION", function () { return $c0b73a0cc7c0566e$export$7d5fd0e285579edd; });
$parcel$export(module.exports, "CLEAR_CURRENT_PIPELINE", function () { return $c0b73a0cc7c0566e$export$e663d6c5b37a6525; });
$parcel$export(module.exports, "CLEAR_STEPS", function () { return $c0b73a0cc7c0566e$export$a0593eb0c8e3fd78; });
$parcel$export(module.exports, "SET_STEPS_FOR_PREVIOUS_RUN", function () { return $c0b73a0cc7c0566e$export$4fb5d58203fb3359; });
$parcel$export(module.exports, "VERIFY_PIPELINES_INSTALLATION", function () { return $c0b73a0cc7c0566e$export$3b41b51af7d8e20b; });
$parcel$export(module.exports, "REMOVE_PIPELINES_DATA", function () { return $c0b73a0cc7c0566e$export$54662c3acfe93366; });
$parcel$export(module.exports, "SET_REPOSITORY", function () { return $c0b73a0cc7c0566e$export$1ca77e7ac38e266e; });
$parcel$export(module.exports, "SET_VALIDATOR", function () { return $c0b73a0cc7c0566e$export$f9e4e24543d03426; });
$parcel$export(module.exports, "PIPELINE_UPDATED", function () { return $c0b73a0cc7c0566e$export$2fabaed856b9cb05; });
$parcel$export(module.exports, "STEP_UPDATED", function () { return $c0b73a0cc7c0566e$export$7a990bfbf86336f1; });
$parcel$export(module.exports, "LOG_UPDATED", function () { return $c0b73a0cc7c0566e$export$4dbffb5192fe6ba; });
$parcel$export(module.exports, "METRIC_UPDATED", function () { return $c0b73a0cc7c0566e$export$c5d8523c0d71906; });
$parcel$export(module.exports, "REPORT_UPDATED", function () { return $c0b73a0cc7c0566e$export$333baa8290272f1e; });
$parcel$export(module.exports, "EXPAND_COMMAND", function () { return $c0b73a0cc7c0566e$export$a2cd45616106ed7; });
$parcel$export(module.exports, "COLLAPSE_COMMAND", function () { return $c0b73a0cc7c0566e$export$3903cfacb5dd60dd; });
$parcel$export(module.exports, "RESET_DOWNLOADED_COMMANDS", function () { return $c0b73a0cc7c0566e$export$4c20d45a3b777f49; });
$parcel$export(module.exports, "COLLAPSE_ALL_COMMANDS", function () { return $c0b73a0cc7c0566e$export$2f2c180681540ef1; });
$parcel$export(module.exports, "EXPAND_TEST_CASE", function () { return $c0b73a0cc7c0566e$export$7da06c13253a634; });
$parcel$export(module.exports, "COLLAPSE_TEST_CASE", function () { return $c0b73a0cc7c0566e$export$fc4f7e35465bcd8f; });
$parcel$export(module.exports, "REQUEST_ALLOWANCE", function () { return $c0b73a0cc7c0566e$export$8b97a580373e1ef8; });
$parcel$export(module.exports, "REQUEST_CHECK_SUITES", function () { return $c0b73a0cc7c0566e$export$80dc6724332959cf; });
$parcel$export(module.exports, "REQUEST_CHECK_SUITE", function () { return $c0b73a0cc7c0566e$export$dadb49cea709e9d4; });
$parcel$export(module.exports, "REQUEST_CHECK_RUNS", function () { return $c0b73a0cc7c0566e$export$f5789c7593d1c1a2; });
$parcel$export(module.exports, "REQUEST_CHECK_RUN", function () { return $c0b73a0cc7c0566e$export$88f1293eadf0e904; });
$parcel$export(module.exports, "REQUEST_CHECKS_DEPLOYMENTS", function () { return $c0b73a0cc7c0566e$export$36c930300bc954ef; });
$parcel$export(module.exports, "CHECK_RUN_UPDATED", function () { return $c0b73a0cc7c0566e$export$102f2abe7e173221; });
$parcel$export(module.exports, "REQUEST_CACHES", function () { return $c0b73a0cc7c0566e$export$21c47a2efec2f2f9; });
$parcel$export(module.exports, "REQUEST_COMMIT_PULL_REQUESTS", function () { return $c0b73a0cc7c0566e$export$5a762efb6bfb9b45; });
$parcel$export(module.exports, "REQUEST_DELETE_CACHE", function () { return $c0b73a0cc7c0566e$export$9f163148381a6e3; });
$parcel$export(module.exports, "REQUEST_DELETE_CACHES", function () { return $c0b73a0cc7c0566e$export$fafc4e997c44f381; });
$parcel$export(module.exports, "REQUEST_SCHEDULES", function () { return $c0b73a0cc7c0566e$export$9e5550874654ea78; });
$parcel$export(module.exports, "REQUEST_DELETE_SCHEDULE", function () { return $c0b73a0cc7c0566e$export$34c13be368978e66; });
$parcel$export(module.exports, "REQUEST_CREATE_SCHEDULE", function () { return $c0b73a0cc7c0566e$export$47921b69a67c28cd; });
$parcel$export(module.exports, "REQUEST_TOGGLE_SCHEDULE", function () { return $c0b73a0cc7c0566e$export$971576d27efadcbd; });
$parcel$export(module.exports, "REQUEST_BUILD_CONFIGURATION", function () { return $c0b73a0cc7c0566e$export$812f1fdb8007cc14; });
$parcel$export(module.exports, "REQUEST_UPDATE_FAILURE_REASON", function () { return $c0b73a0cc7c0566e$export$28fdf2f0f4422da1; });
$parcel$export(module.exports, "RESET_UPDATE_FAILURE_REASON", function () { return $c0b73a0cc7c0566e$export$5a7a5d07ab5a9d60; });
$parcel$export(module.exports, "REQUEST_REPOSITORY_USER_IS_MEMBER", function () { return $c0b73a0cc7c0566e$export$5cc379d49ab47e3b; });
$parcel$export(module.exports, "REQUEST_REPOSITORY_BRANCH_RESTRICTIONS", function () { return $c0b73a0cc7c0566e$export$63124c6761a273d0; });
$parcel$export(module.exports, "REQUEST_STEP_BRANCH_RESTRICTIONS", function () { return $c0b73a0cc7c0566e$export$d431a2fdf61f7042; });
$parcel$export(module.exports, "REQUEST_REPOSITORY_FILES", function () { return $c0b73a0cc7c0566e$export$564a46acfbcb1b4c; });
$parcel$export(module.exports, "REQUEST_ENABLE_PIPELINES", function () { return $c0b73a0cc7c0566e$export$6235a45291435874; });
$parcel$export(module.exports, "REQUEST_DISABLE_PIPELINES", function () { return $c0b73a0cc7c0566e$export$190550f12bf2f985; });
$parcel$export(module.exports, "REQUEST_COMMIT_CONFIGURATION", function () { return $c0b73a0cc7c0566e$export$4808a37b53558a79; });
$parcel$export(module.exports, "REQUEST_OFFICIAL_TEMPLATES", function () { return $c0b73a0cc7c0566e$export$9576b2db92b8e68c; });
$parcel$export(module.exports, "REQUEST_PIPELINES", function () { return $c0b73a0cc7c0566e$export$ebcb0ffc8f8a07d9; });
$parcel$export(module.exports, "REQUEST_UPDATE_PIPELINE", function () { return $c0b73a0cc7c0566e$export$f1b1b123ad793104; });
$parcel$export(module.exports, "REQUEST_PIPELINE_CREATORS", function () { return $c0b73a0cc7c0566e$export$5e1dc9e515d70975; });
$parcel$export(module.exports, "REQUEST_PIPELINE_DEFINITIONS", function () { return $c0b73a0cc7c0566e$export$709a1e7f2738b1ff; });
$parcel$export(module.exports, "REQUEST_CURRENT_PIPELINE", function () { return $c0b73a0cc7c0566e$export$b47aae010da129f3; });
$parcel$export(module.exports, "REQUEST_CREATE_PIPELINE", function () { return $c0b73a0cc7c0566e$export$795fd4f0e52d4531; });
$parcel$export(module.exports, "REQUEST_STOP_PIPELINE", function () { return $c0b73a0cc7c0566e$export$e2cb7b931897ea66; });
$parcel$export(module.exports, "REQUEST_STEPS", function () { return $c0b73a0cc7c0566e$export$e26c578000b947bf; });
$parcel$export(module.exports, "REQUEST_STEP_LOG_RANGE", function () { return $c0b73a0cc7c0566e$export$1414a901249b7812; });
$parcel$export(module.exports, "REQUEST_RERUN_STEPS", function () { return $c0b73a0cc7c0566e$export$a375ff931341b029; });
$parcel$export(module.exports, "REQUEST_ARTIFACTS", function () { return $c0b73a0cc7c0566e$export$a573b098a1165da4; });
$parcel$export(module.exports, "REQUEST_REPORT", function () { return $c0b73a0cc7c0566e$export$7453fe102fefd270; });
$parcel$export(module.exports, "REQUEST_REPORTS", function () { return $c0b73a0cc7c0566e$export$2ce88e7dc6f25f6e; });
$parcel$export(module.exports, "REQUEST_ANNOTATIONS", function () { return $c0b73a0cc7c0566e$export$e3d279dbcd9562b9; });
$parcel$export(module.exports, "REQUEST_FAILED_TEST_CASES", function () { return $c0b73a0cc7c0566e$export$214e82a8b2657097; });
$parcel$export(module.exports, "REQUEST_TEST_CASE_REASON", function () { return $c0b73a0cc7c0566e$export$f53fa9daa5211550; });
$parcel$export(module.exports, "REQUEST_METRICS", function () { return $c0b73a0cc7c0566e$export$d4a7c6fcb43f2c8c; });
$parcel$export(module.exports, "REQUEST_FLAT_NESTED_LOGS", function () { return $c0b73a0cc7c0566e$export$292bdf16c16bcaf1; });
$parcel$export(module.exports, "REQUEST_LOG", function () { return $c0b73a0cc7c0566e$export$b99f0852bcae030a; });
$parcel$export(module.exports, "REQUEST_LOG_THROTTLED", function () { return $c0b73a0cc7c0566e$export$63c60d8ed47cc0f7; });
$parcel$export(module.exports, "REQUEST_SERVICE_LOG", function () { return $c0b73a0cc7c0566e$export$49cb756ab02d81ed; });
$parcel$export(module.exports, "REQUEST_DELETE_LOG", function () { return $c0b73a0cc7c0566e$export$6155f64bbccbeb7d; });
$parcel$export(module.exports, "REQUEST_START_STEP", function () { return $c0b73a0cc7c0566e$export$85e8461f45ef68f3; });
$parcel$export(module.exports, "REQUEST_STEP_PROMOTION", function () { return $c0b73a0cc7c0566e$export$141dacb430cee3d5; });
$parcel$export(module.exports, "REQUEST_STEP_REDEPLOYMENT", function () { return $c0b73a0cc7c0566e$export$b23aef13949607a9; });
$parcel$export(module.exports, "REQUEST_REDEPLOY_STEP", function () { return $c0b73a0cc7c0566e$export$7590e0dc00451dbd; });
$parcel$export(module.exports, "REQUEST_RESUME_STAGE_REDEPLOY", function () { return $c0b73a0cc7c0566e$export$d88d71b5aaa40e08; });
$parcel$export(module.exports, "SEARCH_LOG", function () { return $c0b73a0cc7c0566e$export$f4a1470b918165f4; });
$parcel$export(module.exports, "DOWNLOAD_ALL_COMMANDS", function () { return $c0b73a0cc7c0566e$export$47624df283787e67; });
$parcel$export(module.exports, "REQUEST_LOG_RANGES", function () { return $c0b73a0cc7c0566e$export$22d6a9d39075a1a6; });
$parcel$export(module.exports, "SEARCH_LOG_NEXT_LINE", function () { return $c0b73a0cc7c0566e$export$4a369b774b6d5702; });
$parcel$export(module.exports, "SEARCH_LOG_PREV_LINE", function () { return $c0b73a0cc7c0566e$export$c1ae1221c1d0a938; });
$parcel$export(module.exports, "ENABLE_LOG_SEARCH", function () { return $c0b73a0cc7c0566e$export$e23ed044d8a0a67a; });
$parcel$export(module.exports, "DISABLE_LOG_SEARCH", function () { return $c0b73a0cc7c0566e$export$16777d39f64587ef; });
$parcel$export(module.exports, "SET_STEP", function () { return $c0b73a0cc7c0566e$export$b514c71ea96a3c03; });
$parcel$export(module.exports, "SET_STEPS", function () { return $c0b73a0cc7c0566e$export$4289e785c33c17b3; });
$parcel$export(module.exports, "SET_PIPELINES", function () { return $c0b73a0cc7c0566e$export$1ef5f49e224a2a5d; });
$parcel$export(module.exports, "SET_CURRENT_PIPELINE", function () { return $c0b73a0cc7c0566e$export$f11ac21d7822f75e; });
$parcel$export(module.exports, "SET_PIPELINE_DEFINITIONS", function () { return $c0b73a0cc7c0566e$export$4797593b85e47e15; });
$parcel$export(module.exports, "SET_PIPELINE_CREATORS", function () { return $c0b73a0cc7c0566e$export$ce19ac381489ef78; });
$parcel$export(module.exports, "webSocketSubscribe", function () { return $c0b73a0cc7c0566e$export$1ccd672879977bb8; });
$parcel$export(module.exports, "webSocketUnsubscribe", function () { return $c0b73a0cc7c0566e$export$238bacf81e671130; });
$parcel$export(module.exports, "requestAllowance", function () { return $c0b73a0cc7c0566e$export$8cb43410d0d060fd; });
$parcel$export(module.exports, "requestCaches", function () { return $c0b73a0cc7c0566e$export$85765dcc0d3b6ae; });
$parcel$export(module.exports, "requestDeleteCache", function () { return $c0b73a0cc7c0566e$export$268d2ec953de313d; });
$parcel$export(module.exports, "requestDeleteCaches", function () { return $c0b73a0cc7c0566e$export$bf3198a7777a196; });
$parcel$export(module.exports, "requestSchedules", function () { return $c0b73a0cc7c0566e$export$65c34839a5d955e4; });
$parcel$export(module.exports, "requestCreateSchedule", function () { return $c0b73a0cc7c0566e$export$7096a23b3f2f6c2d; });
$parcel$export(module.exports, "requestToggleSchedule", function () { return $c0b73a0cc7c0566e$export$2ba70b48cfe1ed8a; });
$parcel$export(module.exports, "requestDeleteSchedule", function () { return $c0b73a0cc7c0566e$export$b0b001b90467d0a0; });
$parcel$export(module.exports, "clearBuildConfiguration", function () { return $c0b73a0cc7c0566e$export$54ee96d5527ea647; });
$parcel$export(module.exports, "requestBuildConfiguration", function () { return $c0b73a0cc7c0566e$export$e67bfda15bd49513; });
$parcel$export(module.exports, "resetUpdateFailureReason", function () { return $c0b73a0cc7c0566e$export$ee66a396b7dbb084; });
$parcel$export(module.exports, "requestRepositoryUserIsMember", function () { return $c0b73a0cc7c0566e$export$d1acd1afff8640bb; });
$parcel$export(module.exports, "requestRepositoryBranchRestrictions", function () { return $c0b73a0cc7c0566e$export$70cf97458c73dbc4; });
$parcel$export(module.exports, "requestEnablePipelines", function () { return $c0b73a0cc7c0566e$export$c108d3e184d7b841; });
$parcel$export(module.exports, "requestDisablePipelines", function () { return $c0b73a0cc7c0566e$export$c490563cb9d8b550; });
$parcel$export(module.exports, "requestCommitConfiguration", function () { return $c0b73a0cc7c0566e$export$42acf49d388e0a85; });
$parcel$export(module.exports, "requestOfficialTemplates", function () { return $c0b73a0cc7c0566e$export$6c706657698f740e; });
$parcel$export(module.exports, "setValidator", function () { return $c0b73a0cc7c0566e$export$636d763ed7be9e97; });
$parcel$export(module.exports, "removePipelinesData", function () { return $c0b73a0cc7c0566e$export$1d03b200316a8566; });
$parcel$export(module.exports, "requestPipelines", function () { return $c0b73a0cc7c0566e$export$936cd9d733ef7153; });
$parcel$export(module.exports, "setPipelines", function () { return $c0b73a0cc7c0566e$export$1dab8a68fe055d79; });
$parcel$export(module.exports, "setCurrentPipeline", function () { return $c0b73a0cc7c0566e$export$e6f7e1f1afca025a; });
$parcel$export(module.exports, "setSteps", function () { return $c0b73a0cc7c0566e$export$815b561b81f36a46; });
$parcel$export(module.exports, "setPipelineDefinitions", function () { return $c0b73a0cc7c0566e$export$3a815b62c1f0c846; });
$parcel$export(module.exports, "setPipelineCreators", function () { return $c0b73a0cc7c0566e$export$c2e33bb79ee0392e; });
$parcel$export(module.exports, "requestPipelineCreators", function () { return $c0b73a0cc7c0566e$export$786862e2d9b9c406; });
$parcel$export(module.exports, "requestPipelineDefinitions", function () { return $c0b73a0cc7c0566e$export$1dce38eb47b057a3; });
$parcel$export(module.exports, "requestCurrentPipeline", function () { return $c0b73a0cc7c0566e$export$eef22a481e9d8956; });
$parcel$export(module.exports, "clearCurrentPipeline", function () { return $c0b73a0cc7c0566e$export$8f3f2103bdd914c1; });
$parcel$export(module.exports, "clearSteps", function () { return $c0b73a0cc7c0566e$export$68b648724266a57b; });
$parcel$export(module.exports, "setStepForPreviousRun", function () { return $c0b73a0cc7c0566e$export$c2fe3af698417fb1; });
$parcel$export(module.exports, "requestCreatePipeline", function () { return $c0b73a0cc7c0566e$export$fada609d5614eadc; });
$parcel$export(module.exports, "requestStopPipeline", function () { return $c0b73a0cc7c0566e$export$37878b564e6b9bc8; });
$parcel$export(module.exports, "requestSteps", function () { return $c0b73a0cc7c0566e$export$9aa8d2621521c3b2; });
$parcel$export(module.exports, "requestLogRange", function () { return $c0b73a0cc7c0566e$export$4319b30292efb1ec; });
$parcel$export(module.exports, "requestReports", function () { return $c0b73a0cc7c0566e$export$938aa0673cfd35f3; });
$parcel$export(module.exports, "requestArtifacts", function () { return $c0b73a0cc7c0566e$export$199020e509755ca2; });
$parcel$export(module.exports, "requestLog", function () { return $c0b73a0cc7c0566e$export$1c1276d455e5a49b; });
$parcel$export(module.exports, "requestLogThrottled", function () { return $c0b73a0cc7c0566e$export$a360fca0ea0bb0fc; });
$parcel$export(module.exports, "requestServiceLog", function () { return $c0b73a0cc7c0566e$export$e0289668880e48a0; });
$parcel$export(module.exports, "expandCommand", function () { return $c0b73a0cc7c0566e$export$6d6a6b39f6cca97c; });
$parcel$export(module.exports, "collapseCommand", function () { return $c0b73a0cc7c0566e$export$e4209487a2886304; });
$parcel$export(module.exports, "resetDownloadedCommands", function () { return $c0b73a0cc7c0566e$export$5d8825e3b2af549f; });
$parcel$export(module.exports, "requestDeleteLog", function () { return $c0b73a0cc7c0566e$export$7a4dbd58a2f51247; });
$parcel$export(module.exports, "searchInLog", function () { return $c0b73a0cc7c0566e$export$6d1d81584e16f8ea; });
$parcel$export(module.exports, "searchLogNextLine", function () { return $c0b73a0cc7c0566e$export$88651ef540a2aed3; });
$parcel$export(module.exports, "searchLogPrevLine", function () { return $c0b73a0cc7c0566e$export$cf9778f64fb783a6; });
$parcel$export(module.exports, "enableLogSearch", function () { return $c0b73a0cc7c0566e$export$401dc2f8957b2e79; });
$parcel$export(module.exports, "disableLogSearch", function () { return $c0b73a0cc7c0566e$export$25eae5505ede64cd; });
$parcel$export(module.exports, "requestFailedTestCases", function () { return $c0b73a0cc7c0566e$export$d7a2cf89475296d0; });
$parcel$export(module.exports, "requestTestCaseReason", function () { return $c0b73a0cc7c0566e$export$12ecc8d8aa6a9768; });
$parcel$export(module.exports, "expandTestCase", function () { return $c0b73a0cc7c0566e$export$4eedb1a782387664; });
$parcel$export(module.exports, "collapseTestCase", function () { return $c0b73a0cc7c0566e$export$3249f2ad32b14728; });
$parcel$export(module.exports, "requestAnnotations", function () { return $c0b73a0cc7c0566e$export$7931bf8458e5702c; });
$parcel$export(module.exports, "requestRepositoryFiles", function () { return $c0b73a0cc7c0566e$export$fdcdbe1aa1516fda; });
$parcel$export(module.exports, "requestCheckSuites", function () { return $c0b73a0cc7c0566e$export$f54e993f9d9c2a62; });
$parcel$export(module.exports, "requestCommitPullRequests", function () { return $c0b73a0cc7c0566e$export$fa694790f542ac6b; });
$parcel$export(module.exports, "setStep", function () { return $c0b73a0cc7c0566e$export$5305615f76bbd5b5; });
$parcel$export(module.exports, "requestMetrics", function () { return $c0b73a0cc7c0566e$export$478fa6bb88e2fe4d; });
$parcel$export(module.exports, "requestStartStep", function () { return $c0b73a0cc7c0566e$export$47872fdea68f0a25; });
$parcel$export(module.exports, "requestRedeployStep", function () { return $c0b73a0cc7c0566e$export$b9a7109768ba64b5; });
$parcel$export(module.exports, "requestResumeStageRedeploy", function () { return $c0b73a0cc7c0566e$export$4bd2cf618b1108a2; });
$parcel$export(module.exports, "requestStepPromotion", function () { return $c0b73a0cc7c0566e$export$c99fd8ef0e32d504; });
$parcel$export(module.exports, "requestStepRedeployment", function () { return $c0b73a0cc7c0566e$export$92224b63fd67fa9e; });
$parcel$export(module.exports, "requestRerunSteps", function () { return $c0b73a0cc7c0566e$export$d5cb4e30e3f66fc5; });
$parcel$export(module.exports, "getJsdChecksDeployments", function () { return $c0b73a0cc7c0566e$export$5c82ca0f8f7a171b; });
$parcel$export(module.exports, "verifyPipelinesInstallation", function () { return $c0b73a0cc7c0566e$export$787001d061902688; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");

var $i3LMs = parcelRequire("i3LMs");

var $IQU41 = parcelRequire("IQU41");
const $c0b73a0cc7c0566e$export$504846c72887f1ad = (0, $IQU41.prefixed)("WEBSOCKET_RECONNECT");
const $c0b73a0cc7c0566e$export$e3863897eac4cc1a = (0, $IQU41.prefixed)("WEBSOCKET_SUBSCRIBE");
const $c0b73a0cc7c0566e$export$731a8033616af6f5 = (0, $IQU41.prefixed)("WEBSOCKET_UNSUBSCRIBE");
const $c0b73a0cc7c0566e$export$7d5fd0e285579edd = "CLEAR_BUILD_CONFIGURATION";
const $c0b73a0cc7c0566e$export$e663d6c5b37a6525 = "CLEAR_CURRENT_PIPELINE";
const $c0b73a0cc7c0566e$export$a0593eb0c8e3fd78 = "CLEAR_STEPS";
const $c0b73a0cc7c0566e$export$4fb5d58203fb3359 = "SET_STEPS_FOR_PREVIOUS_RUN";
const $c0b73a0cc7c0566e$export$3b41b51af7d8e20b = "VERIFY_PIPELINES_INSTALLATION";
const $c0b73a0cc7c0566e$export$54662c3acfe93366 = "REMOVE_PIPELINES_DATA";
const $c0b73a0cc7c0566e$export$1ca77e7ac38e266e = (0, $IQU41.prefixed)("SET_REPOSITORY");
const $c0b73a0cc7c0566e$export$f9e4e24543d03426 = (0, $IQU41.prefixed)("SET_VALIDATOR");
const $c0b73a0cc7c0566e$export$2fabaed856b9cb05 = "PIPELINE_UPDATED";
const $c0b73a0cc7c0566e$export$7a990bfbf86336f1 = "STEP_UPDATED";
const $c0b73a0cc7c0566e$export$4dbffb5192fe6ba = "LOG_UPDATED";
const $c0b73a0cc7c0566e$export$c5d8523c0d71906 = "METRIC_UPDATED";
const $c0b73a0cc7c0566e$export$333baa8290272f1e = "REPORT_UPDATED";
const $c0b73a0cc7c0566e$export$a2cd45616106ed7 = "EXPAND_COMMAND";
const $c0b73a0cc7c0566e$export$3903cfacb5dd60dd = "COLLAPSE_COMMAND";
const $c0b73a0cc7c0566e$export$4c20d45a3b777f49 = "RESET_DOWNLOADED_COMMANDS";
const $c0b73a0cc7c0566e$export$2f2c180681540ef1 = "COLLAPSE_ALL_COMMANDS";
const $c0b73a0cc7c0566e$export$7da06c13253a634 = "EXPAND_TEST_CASE";
const $c0b73a0cc7c0566e$export$fc4f7e35465bcd8f = "COLLAPSE_TEST_CASE";
const $c0b73a0cc7c0566e$export$8b97a580373e1ef8 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_ALLOWANCE"));
const $c0b73a0cc7c0566e$export$80dc6724332959cf = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_CHECK_SUITES"));
const $c0b73a0cc7c0566e$export$dadb49cea709e9d4 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_CHECK_SUITE"));
const $c0b73a0cc7c0566e$export$f5789c7593d1c1a2 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_CHECK_RUNS"));
const $c0b73a0cc7c0566e$export$88f1293eadf0e904 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_CHECK_RUN"));
const $c0b73a0cc7c0566e$export$36c930300bc954ef = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_CHECKS_DEPLOYMENTS"));
const $c0b73a0cc7c0566e$export$102f2abe7e173221 = "CHECK_RUN_UPDATED";
const $c0b73a0cc7c0566e$export$21c47a2efec2f2f9 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_CACHES"));
const $c0b73a0cc7c0566e$export$5a762efb6bfb9b45 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_COMMIT_PULL_REQUESTS"));
const $c0b73a0cc7c0566e$export$9f163148381a6e3 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_DELETE_CACHE"));
const $c0b73a0cc7c0566e$export$fafc4e997c44f381 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_DELETE_CACHES"));
const $c0b73a0cc7c0566e$export$9e5550874654ea78 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_SCHEDULES"));
const $c0b73a0cc7c0566e$export$34c13be368978e66 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_DELETE_SCHEDULE"));
const $c0b73a0cc7c0566e$export$47921b69a67c28cd = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_CREATE_SCHEDULE"));
const $c0b73a0cc7c0566e$export$971576d27efadcbd = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_TOGGLE_SCHEDULE"));
const $c0b73a0cc7c0566e$export$812f1fdb8007cc14 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_BUILD_CONFIGURATION"));
const $c0b73a0cc7c0566e$export$28fdf2f0f4422da1 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_UPDATE_FAILURE_REASON"));
const $c0b73a0cc7c0566e$export$5a7a5d07ab5a9d60 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("RESET_UPDATE_FAILURE_REASON"));
const $c0b73a0cc7c0566e$export$5cc379d49ab47e3b = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_REPOSITORY_USER_IS_MEMBER"));
const $c0b73a0cc7c0566e$export$63124c6761a273d0 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_REPOSITORY_BRANCH_RESTRICTIONS"));
const $c0b73a0cc7c0566e$export$d431a2fdf61f7042 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_STEP_BRANCH_RESTRICTIONS"));
const $c0b73a0cc7c0566e$export$564a46acfbcb1b4c = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_REPOSITORY_FILES"));
const $c0b73a0cc7c0566e$export$6235a45291435874 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_ENABLE_PIPELINES"));
const $c0b73a0cc7c0566e$export$190550f12bf2f985 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_DISABLE_PIPELINES"));
const $c0b73a0cc7c0566e$export$4808a37b53558a79 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_COMMIT_CONFIGURATION"));
const $c0b73a0cc7c0566e$export$9576b2db92b8e68c = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_OFFICIAL_TEMPLATES"));
const $c0b73a0cc7c0566e$export$ebcb0ffc8f8a07d9 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_PIPELINES"));
const $c0b73a0cc7c0566e$export$f1b1b123ad793104 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_UPDATE_PIPELINE"));
const $c0b73a0cc7c0566e$export$5e1dc9e515d70975 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_PIPELINE_CREATORS"));
const $c0b73a0cc7c0566e$export$709a1e7f2738b1ff = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_PIPELINE_DEFINITIONS"));
const $c0b73a0cc7c0566e$export$b47aae010da129f3 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_CURRENT_PIPELINE"));
const $c0b73a0cc7c0566e$export$795fd4f0e52d4531 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_CREATE_PIPELINE"));
const $c0b73a0cc7c0566e$export$e2cb7b931897ea66 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_STOP_PIPELINE"));
const $c0b73a0cc7c0566e$export$e26c578000b947bf = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_STEPS"));
const $c0b73a0cc7c0566e$export$1414a901249b7812 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_STEP_LOG_RANGE"));
const $c0b73a0cc7c0566e$export$a375ff931341b029 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_RERUN_STEPS"));
const $c0b73a0cc7c0566e$export$a573b098a1165da4 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_ARTIFACTS"));
const $c0b73a0cc7c0566e$export$7453fe102fefd270 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_REPORT"));
const $c0b73a0cc7c0566e$export$2ce88e7dc6f25f6e = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_REPORTS"));
const $c0b73a0cc7c0566e$export$e3d279dbcd9562b9 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_ANNOTATIONS"));
const $c0b73a0cc7c0566e$export$214e82a8b2657097 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_FAILED_TEST_CASES"));
const $c0b73a0cc7c0566e$export$f53fa9daa5211550 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_TEST_CASE_REASON"));
const $c0b73a0cc7c0566e$export$d4a7c6fcb43f2c8c = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_METRICS"));
const $c0b73a0cc7c0566e$export$292bdf16c16bcaf1 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_FLAT_NESTED_LOGS"));
const $c0b73a0cc7c0566e$export$b99f0852bcae030a = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_LOG"));
const $c0b73a0cc7c0566e$export$63c60d8ed47cc0f7 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_LOG_THROTTLED"));
const $c0b73a0cc7c0566e$export$49cb756ab02d81ed = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_SERVICE_LOG"));
const $c0b73a0cc7c0566e$export$6155f64bbccbeb7d = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_DELETE_LOG"));
const $c0b73a0cc7c0566e$export$85e8461f45ef68f3 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_START_STEP"));
const $c0b73a0cc7c0566e$export$141dacb430cee3d5 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_STEP_PROMOTION"));
const $c0b73a0cc7c0566e$export$b23aef13949607a9 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_STEP_REDEPLOYMENT"));
const $c0b73a0cc7c0566e$export$7590e0dc00451dbd = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_REDEPLOY_STEP"));
const $c0b73a0cc7c0566e$export$d88d71b5aaa40e08 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_RESUME_STAGE_REDEPLOY"));
const $c0b73a0cc7c0566e$export$f4a1470b918165f4 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("SEARCH_LOG"));
const $c0b73a0cc7c0566e$export$47624df283787e67 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("DOWNLOAD_ALL_COMMANDS"));
const $c0b73a0cc7c0566e$export$22d6a9d39075a1a6 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_LOG_RANGES"));
const $c0b73a0cc7c0566e$export$4a369b774b6d5702 = "SEARCH_LOG_NEXT_LINE";
const $c0b73a0cc7c0566e$export$c1ae1221c1d0a938 = "SEARCH_LOG_PREV_LINE";
const $c0b73a0cc7c0566e$export$e23ed044d8a0a67a = "ENABLE_LOG_SEARCH";
const $c0b73a0cc7c0566e$export$16777d39f64587ef = "DISABLE_LOG_SEARCH";
const $c0b73a0cc7c0566e$export$b514c71ea96a3c03 = "SET_STEP";
const $c0b73a0cc7c0566e$export$4289e785c33c17b3 = "SET_STEPS";
const $c0b73a0cc7c0566e$export$1ef5f49e224a2a5d = "SET_PIPELINES";
const $c0b73a0cc7c0566e$export$f11ac21d7822f75e = "SET_CURRENT_PIPELINE";
const $c0b73a0cc7c0566e$export$4797593b85e47e15 = "SET_PIPELINE_DEFINITIONS";
const $c0b73a0cc7c0566e$export$ce19ac381489ef78 = "SET_PIPELINE_CREATORS";
const $c0b73a0cc7c0566e$export$1ccd672879977bb8 = (event, criteria)=>({
        type: $c0b73a0cc7c0566e$export$e3863897eac4cc1a,
        payload: {
            event: event,
            criteria: criteria
        }
    });
const $c0b73a0cc7c0566e$export$238bacf81e671130 = (event, criteria)=>({
        type: $c0b73a0cc7c0566e$export$731a8033616af6f5,
        payload: {
            event: event,
            criteria: criteria
        }
    });
const $c0b73a0cc7c0566e$export$8cb43410d0d060fd = (accountUuid)=>{
    return {
        type: $c0b73a0cc7c0566e$export$8b97a580373e1ef8.REQUEST,
        meta: {
            accountUuid: accountUuid
        }
    };
};
const $c0b73a0cc7c0566e$export$85765dcc0d3b6ae = ()=>{
    return {
        type: $c0b73a0cc7c0566e$export$21c47a2efec2f2f9.REQUEST
    };
};
const $c0b73a0cc7c0566e$export$268d2ec953de313d = (cache, cacheUuid)=>{
    return {
        type: $c0b73a0cc7c0566e$export$9f163148381a6e3.REQUEST,
        meta: {
            cache: cache,
            cacheUuid: cacheUuid
        }
    };
};
const $c0b73a0cc7c0566e$export$bf3198a7777a196 = (cache)=>{
    return {
        type: $c0b73a0cc7c0566e$export$fafc4e997c44f381.REQUEST,
        meta: {
            cache: cache
        }
    };
};
const $c0b73a0cc7c0566e$export$65c34839a5d955e4 = ()=>{
    return {
        type: $c0b73a0cc7c0566e$export$9e5550874654ea78.REQUEST,
        meta: {}
    };
};
const $c0b73a0cc7c0566e$export$7096a23b3f2f6c2d = (schedule)=>{
    return {
        type: $c0b73a0cc7c0566e$export$47921b69a67c28cd.REQUEST,
        meta: {
            schedule: schedule
        }
    };
};
const $c0b73a0cc7c0566e$export$2ba70b48cfe1ed8a = (schedule)=>{
    return {
        type: $c0b73a0cc7c0566e$export$971576d27efadcbd.REQUEST,
        meta: {
            schedule: schedule
        }
    };
};
const $c0b73a0cc7c0566e$export$b0b001b90467d0a0 = (schedule)=>{
    return {
        type: $c0b73a0cc7c0566e$export$34c13be368978e66.REQUEST,
        meta: {
            schedule: schedule
        }
    };
};
const $c0b73a0cc7c0566e$export$54ee96d5527ea647 = ()=>{
    return {
        type: $c0b73a0cc7c0566e$export$7d5fd0e285579edd,
        meta: {}
    };
};
const $c0b73a0cc7c0566e$export$e67bfda15bd49513 = (ref)=>{
    return {
        type: $c0b73a0cc7c0566e$export$812f1fdb8007cc14.REQUEST,
        meta: {
            ref: ref
        }
    };
};
const $c0b73a0cc7c0566e$export$4cf3bc537a937092 = (repositoryUuid, pipelineUuid, stepUuid, failureReason)=>{
    return {
        type: $c0b73a0cc7c0566e$export$28fdf2f0f4422da1.REQUEST,
        meta: {
            repositoryUuid: repositoryUuid,
            pipelineUuid: pipelineUuid,
            stepUuid: stepUuid,
            failureReason: failureReason
        }
    };
};
const $c0b73a0cc7c0566e$export$ee66a396b7dbb084 = ()=>{
    return {
        type: $c0b73a0cc7c0566e$export$5a7a5d07ab5a9d60.REQUEST,
        meta: {}
    };
};
const $c0b73a0cc7c0566e$export$d1acd1afff8640bb = (role = "admin")=>{
    return {
        type: $c0b73a0cc7c0566e$export$5cc379d49ab47e3b.REQUEST,
        meta: {
            role: role
        }
    };
};
const $c0b73a0cc7c0566e$export$70cf97458c73dbc4 = (userUuid)=>{
    return {
        type: $c0b73a0cc7c0566e$export$63124c6761a273d0.REQUEST,
        meta: {
            userUuid: userUuid
        }
    };
};
const $c0b73a0cc7c0566e$export$c108d3e184d7b841 = ()=>{
    return {
        type: $c0b73a0cc7c0566e$export$6235a45291435874.REQUEST
    };
};
const $c0b73a0cc7c0566e$export$c490563cb9d8b550 = ()=>{
    return {
        type: $c0b73a0cc7c0566e$export$190550f12bf2f985.REQUEST
    };
};
const $c0b73a0cc7c0566e$export$42acf49d388e0a85 = (configuration, commitMessage)=>{
    return {
        type: $c0b73a0cc7c0566e$export$4808a37b53558a79.REQUEST,
        meta: {
            configuration: configuration,
            commitMessage: commitMessage
        }
    };
};
const $c0b73a0cc7c0566e$export$6c706657698f740e = ()=>{
    return {
        type: $c0b73a0cc7c0566e$export$9576b2db92b8e68c.REQUEST,
        meta: {}
    };
};
const $c0b73a0cc7c0566e$export$636d763ed7be9e97 = (payload)=>{
    return {
        type: $c0b73a0cc7c0566e$export$f9e4e24543d03426,
        payload: payload
    };
};
const $c0b73a0cc7c0566e$export$1d03b200316a8566 = ()=>{
    return {
        type: $c0b73a0cc7c0566e$export$54662c3acfe93366
    };
};
const $c0b73a0cc7c0566e$export$936cd9d733ef7153 = (queryParams)=>{
    return {
        type: $c0b73a0cc7c0566e$export$ebcb0ffc8f8a07d9.REQUEST,
        meta: {
            queryParams: queryParams
        }
    };
};
const $c0b73a0cc7c0566e$export$1dab8a68fe055d79 = (payload)=>{
    return {
        type: $c0b73a0cc7c0566e$export$1ef5f49e224a2a5d,
        payload: payload
    };
};
const $c0b73a0cc7c0566e$export$e6f7e1f1afca025a = (payload)=>{
    return {
        type: $c0b73a0cc7c0566e$export$f11ac21d7822f75e,
        payload: payload
    };
};
const $c0b73a0cc7c0566e$export$815b561b81f36a46 = (payload, stepUuid, pipelineRunUuid)=>{
    return {
        type: $c0b73a0cc7c0566e$export$4289e785c33c17b3,
        payload: payload,
        meta: {
            stepUuid: stepUuid,
            pipelineRunUuid: pipelineRunUuid
        }
    };
};
const $c0b73a0cc7c0566e$export$3a815b62c1f0c846 = (payload)=>{
    return {
        type: $c0b73a0cc7c0566e$export$4797593b85e47e15,
        payload: payload
    };
};
const $c0b73a0cc7c0566e$export$c2e33bb79ee0392e = (payload)=>{
    return {
        type: $c0b73a0cc7c0566e$export$ce19ac381489ef78,
        payload: payload
    };
};
const $c0b73a0cc7c0566e$export$786862e2d9b9c406 = ()=>{
    return {
        type: $c0b73a0cc7c0566e$export$5e1dc9e515d70975.REQUEST
    };
};
const $c0b73a0cc7c0566e$export$1dce38eb47b057a3 = (ref)=>{
    return {
        type: $c0b73a0cc7c0566e$export$709a1e7f2738b1ff.REQUEST,
        meta: {
            ref: ref
        }
    };
};
const $c0b73a0cc7c0566e$export$eef22a481e9d8956 = (pipelineUuid)=>{
    return {
        type: $c0b73a0cc7c0566e$export$b47aae010da129f3.REQUEST,
        meta: {
            pipelineUuid: pipelineUuid
        }
    };
};
const $c0b73a0cc7c0566e$export$8f3f2103bdd914c1 = ()=>{
    return {
        type: $c0b73a0cc7c0566e$export$e663d6c5b37a6525
    };
};
const $c0b73a0cc7c0566e$export$68b648724266a57b = ()=>{
    return {
        type: $c0b73a0cc7c0566e$export$a0593eb0c8e3fd78
    };
};
const $c0b73a0cc7c0566e$export$c2fe3af698417fb1 = ()=>{
    return {
        type: $c0b73a0cc7c0566e$export$4fb5d58203fb3359
    };
};
const $c0b73a0cc7c0566e$export$fada609d5614eadc = (targetPipeline)=>{
    return {
        type: $c0b73a0cc7c0566e$export$795fd4f0e52d4531.REQUEST,
        meta: {
            targetPipeline: targetPipeline
        }
    };
};
const $c0b73a0cc7c0566e$export$37878b564e6b9bc8 = (pipelineUuid)=>{
    return {
        type: $c0b73a0cc7c0566e$export$e2cb7b931897ea66.REQUEST,
        meta: {
            pipelineUuid: pipelineUuid
        }
    };
};
const $c0b73a0cc7c0566e$export$9aa8d2621521c3b2 = (stepUuid, pipelineRunUuid)=>{
    return {
        type: $c0b73a0cc7c0566e$export$e26c578000b947bf.REQUEST,
        meta: {
            stepUuid: stepUuid,
            pipelineRunUuid: pipelineRunUuid
        }
    };
};
const $c0b73a0cc7c0566e$export$4319b30292efb1ec = (stepUuid, pipelineUuid, callback)=>{
    return {
        type: $c0b73a0cc7c0566e$export$1414a901249b7812.REQUEST,
        pipelineUuid: pipelineUuid,
        meta: {
            callback: callback,
            stepUuid: stepUuid
        }
    };
};
const $c0b73a0cc7c0566e$export$938aa0673cfd35f3 = ()=>{
    return {
        type: $c0b73a0cc7c0566e$export$2ce88e7dc6f25f6e.REQUEST,
        meta: {}
    };
};
const $c0b73a0cc7c0566e$export$199020e509755ca2 = (pipelineUuid, stepUuid)=>{
    return {
        type: $c0b73a0cc7c0566e$export$a573b098a1165da4.REQUEST,
        meta: {
            pipelineUuid: pipelineUuid,
            stepUuid: stepUuid
        }
    };
};
const $c0b73a0cc7c0566e$export$1c1276d455e5a49b = (pipelineUuid, stepUuid, range = {
    rangeStart: 0,
    rangeEnd: (0, $i3LMs.MAX_LOG_CHUNK_SIZE)
}, meta = {})=>{
    return {
        type: $c0b73a0cc7c0566e$export$b99f0852bcae030a.REQUEST,
        meta: {
            pipelineUuid: pipelineUuid,
            stepUuid: stepUuid,
            range: range,
            requestCounter: meta.requestCounter || 0,
            ...meta
        }
    };
};
const $c0b73a0cc7c0566e$export$a360fca0ea0bb0fc = (pipelineUuid, stepUuid, range = {
    rangeStart: 0,
    rangeEnd: (0, $i3LMs.MAX_LOG_CHUNK_SIZE)
}, meta = {})=>{
    return {
        type: $c0b73a0cc7c0566e$export$63c60d8ed47cc0f7.REQUEST,
        meta: {
            pipelineUuid: pipelineUuid,
            stepUuid: stepUuid,
            range: range,
            requestCounter: meta.requestCounter || 0,
            ...meta
        }
    };
};
const $c0b73a0cc7c0566e$export$e0289668880e48a0 = (pipelineUuid, stepUuid, serviceUuid, meta = {})=>{
    return {
        type: $c0b73a0cc7c0566e$export$49cb756ab02d81ed.REQUEST,
        meta: {
            pipelineUuid: pipelineUuid,
            stepUuid: stepUuid,
            serviceUuid: serviceUuid,
            ...meta
        }
    };
};
const $c0b73a0cc7c0566e$export$6d6a6b39f6cca97c = (stepUuid, index)=>{
    return {
        type: $c0b73a0cc7c0566e$export$a2cd45616106ed7,
        meta: {
            stepUuid: stepUuid,
            index: index
        }
    };
};
const $c0b73a0cc7c0566e$export$e4209487a2886304 = (stepUuid, index)=>{
    return {
        type: $c0b73a0cc7c0566e$export$3903cfacb5dd60dd,
        meta: {
            stepUuid: stepUuid,
            index: index
        }
    };
};
const $c0b73a0cc7c0566e$export$5d8825e3b2af549f = ()=>{
    return {
        type: $c0b73a0cc7c0566e$export$4c20d45a3b777f49
    };
};
const $c0b73a0cc7c0566e$export$7a4dbd58a2f51247 = (serviceUuid)=>({
        type: $c0b73a0cc7c0566e$export$6155f64bbccbeb7d.REQUEST,
        meta: {
            serviceUuid: serviceUuid
        }
    });
const $c0b73a0cc7c0566e$export$6d1d81584e16f8ea = (search)=>({
        type: $c0b73a0cc7c0566e$export$f4a1470b918165f4.REQUEST,
        meta: search
    });
const $c0b73a0cc7c0566e$export$88651ef540a2aed3 = ()=>({
        type: $c0b73a0cc7c0566e$export$4a369b774b6d5702
    });
const $c0b73a0cc7c0566e$export$cf9778f64fb783a6 = ()=>({
        type: $c0b73a0cc7c0566e$export$c1ae1221c1d0a938
    });
const $c0b73a0cc7c0566e$export$85408e42f645773 = ()=>({
        type: $c0b73a0cc7c0566e$export$47624df283787e67.REQUEST
    });
const $c0b73a0cc7c0566e$export$401dc2f8957b2e79 = ()=>({
        type: $c0b73a0cc7c0566e$export$e23ed044d8a0a67a
    });
const $c0b73a0cc7c0566e$export$25eae5505ede64cd = ()=>({
        type: $c0b73a0cc7c0566e$export$16777d39f64587ef
    });
const $c0b73a0cc7c0566e$export$d7a2cf89475296d0 = (pipelineUuid, stepUuid)=>({
        type: $c0b73a0cc7c0566e$export$214e82a8b2657097.REQUEST,
        meta: {
            pipelineUuid: pipelineUuid,
            stepUuid: stepUuid
        }
    });
const $c0b73a0cc7c0566e$export$12ecc8d8aa6a9768 = (pipelineUuid, stepUuid, testCaseUuid)=>({
        type: $c0b73a0cc7c0566e$export$f53fa9daa5211550.REQUEST,
        meta: {
            pipelineUuid: pipelineUuid,
            stepUuid: stepUuid,
            testCaseUuid: testCaseUuid
        }
    });
const $c0b73a0cc7c0566e$export$4eedb1a782387664 = (testCaseUuid)=>{
    return {
        type: $c0b73a0cc7c0566e$export$7da06c13253a634,
        meta: {
            testCaseUuid: testCaseUuid
        }
    };
};
const $c0b73a0cc7c0566e$export$3249f2ad32b14728 = (testCaseUuid)=>{
    return {
        type: $c0b73a0cc7c0566e$export$fc4f7e35465bcd8f,
        meta: {
            testCaseUuid: testCaseUuid
        }
    };
};
const $c0b73a0cc7c0566e$export$7931bf8458e5702c = (reportUuid)=>({
        type: $c0b73a0cc7c0566e$export$e3d279dbcd9562b9.REQUEST,
        meta: {
            reportUuid: reportUuid
        }
    });
const $c0b73a0cc7c0566e$export$fdcdbe1aa1516fda = (revision)=>({
        type: $c0b73a0cc7c0566e$export$564a46acfbcb1b4c.REQUEST,
        meta: {
            revision: revision
        }
    });
const $c0b73a0cc7c0566e$export$f54e993f9d9c2a62 = (revision)=>({
        type: $c0b73a0cc7c0566e$export$80dc6724332959cf.REQUEST,
        meta: {
            revision: revision
        }
    });
const $c0b73a0cc7c0566e$export$fa694790f542ac6b = (revision)=>({
        type: $c0b73a0cc7c0566e$export$5a762efb6bfb9b45.REQUEST,
        meta: {
            revision: revision
        }
    });
const $c0b73a0cc7c0566e$export$5305615f76bbd5b5 = (stepUuid)=>({
        type: $c0b73a0cc7c0566e$export$b514c71ea96a3c03,
        payload: stepUuid
    });
const $c0b73a0cc7c0566e$export$478fa6bb88e2fe4d = (pipelineUuid, stepUuid)=>({
        type: $c0b73a0cc7c0566e$export$d4a7c6fcb43f2c8c.REQUEST,
        meta: {
            pipelineUuid: pipelineUuid,
            stepUuid: stepUuid
        }
    });
const $c0b73a0cc7c0566e$export$47872fdea68f0a25 = (pipelineUuid, stepUuid, stageIndex)=>({
        type: $c0b73a0cc7c0566e$export$85e8461f45ef68f3.REQUEST,
        meta: {
            pipelineUuid: pipelineUuid,
            stepUuid: stepUuid,
            stageIndex: stageIndex
        }
    });
const $c0b73a0cc7c0566e$export$b9a7109768ba64b5 = (pipelineUuid, stepUuid, stageIndex)=>({
        type: $c0b73a0cc7c0566e$export$7590e0dc00451dbd.REQUEST,
        meta: {
            pipelineUuid: pipelineUuid,
            stepUuid: stepUuid,
            stageIndex: stageIndex
        }
    });
const $c0b73a0cc7c0566e$export$4bd2cf618b1108a2 = (pipelineUuid, stageIndex)=>({
        type: $c0b73a0cc7c0566e$export$d88d71b5aaa40e08.REQUEST,
        meta: {
            pipelineUuid: pipelineUuid,
            stageIndex: stageIndex
        }
    });
const $c0b73a0cc7c0566e$export$c99fd8ef0e32d504 = (key, environmentUuid, pipelineUuid, stepUuid, isRerunnableStep)=>({
        type: $c0b73a0cc7c0566e$export$141dacb430cee3d5.REQUEST,
        meta: {
            key: key,
            environmentUuid: environmentUuid,
            isRerunnableStep: isRerunnableStep,
            pipelineUuid: pipelineUuid,
            stepUuid: stepUuid
        }
    });
const $c0b73a0cc7c0566e$export$92224b63fd67fa9e = (key, environmentUuid, pipelineUuid, stepUuid)=>({
        type: $c0b73a0cc7c0566e$export$b23aef13949607a9.REQUEST,
        meta: {
            key: key,
            environmentUuid: environmentUuid,
            pipelineUuid: pipelineUuid,
            stepUuid: stepUuid
        }
    });
const $c0b73a0cc7c0566e$export$d5cb4e30e3f66fc5 = (stepUuid)=>({
        type: $c0b73a0cc7c0566e$export$a375ff931341b029.REQUEST,
        meta: {
            stepUuid: stepUuid
        }
    });
const $c0b73a0cc7c0566e$export$5c82ca0f8f7a171b = (deploymentUuids)=>({
        type: $c0b73a0cc7c0566e$export$36c930300bc954ef.REQUEST,
        meta: {
            deploymentUuids: deploymentUuids
        }
    });
const $c0b73a0cc7c0566e$export$787001d061902688 = ()=>({
        type: $c0b73a0cc7c0566e$export$3b41b51af7d8e20b
    });

});
parcelRegister("i3LMs", function(module, exports) {

$parcel$export(module.exports, "DeploymentsWebsocketEvents", function () { return $7d50d9c8f6faef01$export$ebefe4b23fa30ad2; });
$parcel$export(module.exports, "PipelinesWebsocketEvent", function () { return $7d50d9c8f6faef01$export$2c141de7c8dfba2; });
$parcel$export(module.exports, "MetricUsageStatusType", function () { return $7d50d9c8f6faef01$export$708ae93bb3cd3125; });
$parcel$export(module.exports, "PipelineFillState", function () { return $7d50d9c8f6faef01$export$745951e5b87042d2; });
$parcel$export(module.exports, "PipelinesWebsocketHookEvent", function () { return $7d50d9c8f6faef01$export$e3cb727504d06390; });
$parcel$export(module.exports, "PipelinesWebsocketEvents", function () { return $7d50d9c8f6faef01$export$14689c11e5f6b5e8; });
$parcel$export(module.exports, "MetricWebsocketEvent", function () { return $7d50d9c8f6faef01$export$914c24b2d7fe131e; });
$parcel$export(module.exports, "MAX_ENV_FREE_PLAN", function () { return $7d50d9c8f6faef01$export$3395dae9d0234dc; });
$parcel$export(module.exports, "MAX_ENV_PAID_PLAN", function () { return $7d50d9c8f6faef01$export$146b9e000c059d54; });
$parcel$export(module.exports, "MAX_ENV_PREMIUM_PLAN", function () { return $7d50d9c8f6faef01$export$c9df1fd93466203c; });
$parcel$export(module.exports, "PIPELINES_SENTRY_PRIMARY_TAG", function () { return $7d50d9c8f6faef01$export$14881eba9532b83; });
$parcel$export(module.exports, "BRANCH_RESTRICTIONS_PAGE_SIZE", function () { return $7d50d9c8f6faef01$export$ef0240f3ee21c80d; });
$parcel$export(module.exports, "VARIABLES_PAGELEN", function () { return $7d50d9c8f6faef01$export$94ca5f25b7ff70f1; });
$parcel$export(module.exports, "PIPELINE_PAGE_SIZE", function () { return $7d50d9c8f6faef01$export$41834200cd926536; });
$parcel$export(module.exports, "PIPELINE_CREATORS_PAGE_SIZE", function () { return $7d50d9c8f6faef01$export$93c58b7fa134a008; });
$parcel$export(module.exports, "SCHEDULES_PAGE_SIZE", function () { return $7d50d9c8f6faef01$export$4d462783a000f64e; });
$parcel$export(module.exports, "QUERY_BRANCHES_PAGE_SIZE", function () { return $7d50d9c8f6faef01$export$ab52939910a7dd7b; });
$parcel$export(module.exports, "PIPELINE_DEFINITIONS_PAGE_SIZE", function () { return $7d50d9c8f6faef01$export$1a78fd37a5e5f27f; });
$parcel$export(module.exports, "ALLOWANCE_LIMIT", function () { return $7d50d9c8f6faef01$export$8497d1e9999a5e3c; });
$parcel$export(module.exports, "METRICS_WARNING_LIMIT", function () { return $7d50d9c8f6faef01$export$1901fafe129f402; });
$parcel$export(module.exports, "STEPS_PAGE_SIZE", function () { return $7d50d9c8f6faef01$export$d429368c18d8ecab; });
$parcel$export(module.exports, "PIPELINE_RUNS_PAGE_SIZE", function () { return $7d50d9c8f6faef01$export$1c26740fe1253f08; });
$parcel$export(module.exports, "TEST_REPORTS_PAGE_SIZE", function () { return $7d50d9c8f6faef01$export$5d783bf9ab2211ea; });
$parcel$export(module.exports, "ANNOTATIONS_PAGE_SIZE", function () { return $7d50d9c8f6faef01$export$4abae7f57507544c; });
$parcel$export(module.exports, "METRICS_OOM_FAILURE_TRESHOLD_IN_MB", function () { return $7d50d9c8f6faef01$export$8ab4b11a71d72835; });
$parcel$export(module.exports, "METRICS_USAGE_ERROR_LIMIT", function () { return $7d50d9c8f6faef01$export$834f89987965a996; });
$parcel$export(module.exports, "MAX_LOG_CHUNK_SIZE", function () { return $7d50d9c8f6faef01$export$c98f5c3d565c2467; });
$parcel$export(module.exports, "MAX_WORKER_TIMEOUT_LIMIT", function () { return $7d50d9c8f6faef01$export$4bdcbc1adf0bf8b6; });
$parcel$export(module.exports, "FREE_REPORTS_LIMIT", function () { return $7d50d9c8f6faef01$export$ad6e12b7c9f38e6b; });
$parcel$export(module.exports, "DELAY_LOG_UPDATED", function () { return $7d50d9c8f6faef01$export$50efbc1c7b60d4fe; });
$parcel$export(module.exports, "DELAY_PIPELINE_UPDATED", function () { return $7d50d9c8f6faef01$export$3d54293ae52c936d; });
$parcel$export(module.exports, "DELAY_STEP_UPDATED", function () { return $7d50d9c8f6faef01$export$5c065ebad35d2c23; });
$parcel$export(module.exports, "KNOWN_HOSTS_PAGELEN", function () { return $7d50d9c8f6faef01$export$7929ff33f0e5bcd4; });
$parcel$export(module.exports, "RUNNERS_PAGELEN", function () { return $7d50d9c8f6faef01$export$292b6bf44e9a3b18; });
$parcel$export(module.exports, "RUNNERS_WS_DEBOUNCE", function () { return $7d50d9c8f6faef01$export$dbc9251da0eb5266; });
$parcel$export(module.exports, "SELECTED_BRANCH_REGEX", function () { return $7d50d9c8f6faef01$export$292f6612e6e52d8d; });
$parcel$export(module.exports, "PIPELINES_ONBOARDED_KEY", function () { return $7d50d9c8f6faef01$export$9d36dd9cf4ff94ac; });
$parcel$export(module.exports, "DEPLOYMENTS_ONBOARDED_KEY", function () { return $7d50d9c8f6faef01$export$8042d1c568263a13; });
$parcel$export(module.exports, "VIEW_BUILD_DOCTOR", function () { return $7d50d9c8f6faef01$export$9dd44a055d4935d8; });
$parcel$export(module.exports, "ALLOWANCE_DISMISSED_KEY", function () { return $7d50d9c8f6faef01$export$de40f1e79df7383d; });
$parcel$export(module.exports, "STREAMING_REQUEST_INTERVAL", function () { return $7d50d9c8f6faef01$export$4e2428475a925e4f; });
$parcel$export(module.exports, "DOCS_OIDC", function () { return $7d50d9c8f6faef01$export$f28a07dce01f98ad; });
$parcel$export(module.exports, "DOCS_SSH_KEYS", function () { return $7d50d9c8f6faef01$export$813e8d630bc5d4ab; });
$parcel$export(module.exports, "DOCS_ACCOUNT_VARIABLE", function () { return $7d50d9c8f6faef01$export$8a4c7bac6e601acf; });
$parcel$export(module.exports, "DOCS_DEPLOYMENTS", function () { return $7d50d9c8f6faef01$export$1dc76202e3ebf620; });
$parcel$export(module.exports, "DOCS_RUNNERS", function () { return $7d50d9c8f6faef01$export$34ec651e5bc041d2; });
$parcel$export(module.exports, "CHANGELOG_URL", function () { return $7d50d9c8f6faef01$export$4e76f57ef6781ff7; });
$parcel$export(module.exports, "TRUNCATION_OFFSET", function () { return $7d50d9c8f6faef01$export$a538acef69ec700c; });
$parcel$export(module.exports, "MAX_UNTRUNCATED_LENGTH", function () { return $7d50d9c8f6faef01$export$8e4eb331eb92dcc7; });
$parcel$export(module.exports, "ALLOWANCE_THRESHOLD", function () { return $7d50d9c8f6faef01$export$dd7a143acda5a66f; });
$parcel$export(module.exports, "SYNC_STATUS", function () { return $7d50d9c8f6faef01$export$5935eefdaddb9915; });
$parcel$export(module.exports, "DEFAULT_TEMPLATES_URL", function () { return $7d50d9c8f6faef01$export$880baf5c9f64ca38; });
$parcel$export(module.exports, "ADDON_KEY_PREFIX", function () { return $7d50d9c8f6faef01$export$380213ba5118290e; });
$parcel$export(module.exports, "ORIGIN", function () { return $7d50d9c8f6faef01$export$ccee77ec32a436d7; });
$parcel$export(module.exports, "YML_FILE_NAME", function () { return $7d50d9c8f6faef01$export$225a4b1c145af505; });
$parcel$export(module.exports, "DOCS_ALPHA_URL", function () { return $7d50d9c8f6faef01$export$9164af77ad9978cc; });
$parcel$export(module.exports, "FEEDBACK_EMAIL", function () { return $7d50d9c8f6faef01$export$bfab8edbb0ca55a5; });
$parcel$export(module.exports, "DOCS_YML_URL", function () { return $7d50d9c8f6faef01$export$2d168c0dc533a435; });
$parcel$export(module.exports, "DOCS_YML_DOCKER_URL", function () { return $7d50d9c8f6faef01$export$1dae5d8c4438c108; });
$parcel$export(module.exports, "TIME_LIMIT_EXCEEDED_STEP_URL", function () { return $7d50d9c8f6faef01$export$d3f8d8d708779e85; });
$parcel$export(module.exports, "MEMORY_LIMIT_EXCEEDED_STEP_URL", function () { return $7d50d9c8f6faef01$export$1a0fbf2502109e09; });
$parcel$export(module.exports, "ALLOWED_PLAN_URL", function () { return $7d50d9c8f6faef01$export$87f0f2b24aa00b76; });
$parcel$export(module.exports, "MEMORY_LIMIT_URL", function () { return $7d50d9c8f6faef01$export$66c0a309cd14157b; });
$parcel$export(module.exports, "DOCS_SERVICE_CONTAINERS", function () { return $7d50d9c8f6faef01$export$17e923d953f793cc; });
$parcel$export(module.exports, "DOCS_SERVICE_CONTAINERS_MEMORY", function () { return $7d50d9c8f6faef01$export$e08e34188f86f0ce; });
$parcel$export(module.exports, "SUPPORT_PORTAL", function () { return $7d50d9c8f6faef01$export$10353e676ee56f8b; });
$parcel$export(module.exports, "DOCS_CONFIGURE_CLONE_DEPTH", function () { return $7d50d9c8f6faef01$export$fed2b19653ebef5f; });
$parcel$export(module.exports, "DOCS_SETUP_DEPLOYMENT_GATING", function () { return $7d50d9c8f6faef01$export$74780518bf6a2c40; });
$parcel$export(module.exports, "SERVICE_CONTAINERS", function () { return $7d50d9c8f6faef01$export$1e6141eab3dbc39c; });
$parcel$export(module.exports, "DOCS_DEPLOYMENT_CONCURRENCY", function () { return $7d50d9c8f6faef01$export$24f59c9a728dc75a; });
$parcel$export(module.exports, "DOCS_DEPENDENCY_CACHES_URL", function () { return $7d50d9c8f6faef01$export$ed5c0abc30f03a65; });
$parcel$export(module.exports, "VALIDATOR_URL", function () { return $7d50d9c8f6faef01$export$8aaae21b0ddf8f1a; });
$parcel$export(module.exports, "HOSTNAME_PORT_INBOUND_REGEX", function () { return $7d50d9c8f6faef01$export$d39db57e7ebba3ea; });
$parcel$export(module.exports, "HOSTNAME_PORT_OUTBOUND_REGEX", function () { return $7d50d9c8f6faef01$export$73b73a37cc59864a; });
$parcel$export(module.exports, "LOG_LINE_WRAP_KEY", function () { return $7d50d9c8f6faef01$export$2c0af453b5b3282d; });
$parcel$export(module.exports, "EMPTY_STEP", function () { return $7d50d9c8f6faef01$export$f4581137ec09127b; });
$parcel$export(module.exports, "LOG_VIEW_UPDATED_BG_COLOR", function () { return $7d50d9c8f6faef01$export$5db9fe82d207da71; });
$parcel$export(module.exports, "UPDATED_SELECTED_COMMAND_COLOR", function () { return $7d50d9c8f6faef01$export$46eef912e3833a11; });
$parcel$export(module.exports, "UPDATED_SELECTED_COMMAND_BG_COLOR", function () { return $7d50d9c8f6faef01$export$adee3691811a24c1; });
$parcel$export(module.exports, "LOG_VIEW_LINE_TEXT_COLOR", function () { return $7d50d9c8f6faef01$export$8a383881dac5af39; });
$parcel$export(module.exports, "LOG_VIEW_TEXT_COLOR_LIGHTER", function () { return $7d50d9c8f6faef01$export$ad34a090b4ab11d; });
$parcel$export(module.exports, "LOG_VIEW_ICON_COLOR", function () { return $7d50d9c8f6faef01$export$7fd60b7e5a82431a; });
$parcel$export(module.exports, "LOG_VIEW_BACKGROUND_COLOR", function () { return $7d50d9c8f6faef01$export$172f412142e978a3; });
$parcel$export(module.exports, "LOG_VIEW_HEADING_COLOR", function () { return $7d50d9c8f6faef01$export$2170f54fc46aa066; });
$parcel$export(module.exports, "LOG_VIEW_DISABLED_BUTTON_COLOR", function () { return $7d50d9c8f6faef01$export$8dd2c106c8b63c14; });
$parcel$export(module.exports, "BITBUCKET_PIPELINES_FEATURE_FLAG_KEYS", function () { return $7d50d9c8f6faef01$export$af3117f6e6800cc5; });
$parcel$export(module.exports, "PERMISSION_DENIED", function () { return $7d50d9c8f6faef01$export$ce765b82bfe75c09; });

var $jp7ng = parcelRequire("jp7ng");
var $7d50d9c8f6faef01$export$6679fb42dec7ff07;
(function(DeploymentsWebsocketEvent) {
    DeploymentsWebsocketEvent["DeploymentsUpdated"] = "deployment_updated";
    DeploymentsWebsocketEvent["EnvironmentsUpdated"] = "environment_updated";
    DeploymentsWebsocketEvent["EnvironmentsLockUpdated"] = "environment_lock_updated";
    DeploymentsWebsocketEvent["EnvironmentDashboardUpdated"] = "environment_dashboard_updated";
})($7d50d9c8f6faef01$export$6679fb42dec7ff07 || ($7d50d9c8f6faef01$export$6679fb42dec7ff07 = {}));
const $7d50d9c8f6faef01$export$ebefe4b23fa30ad2 = Object.values($7d50d9c8f6faef01$export$6679fb42dec7ff07).filter((value)=>typeof value === "string");
var $7d50d9c8f6faef01$export$2c141de7c8dfba2;
(function(PipelinesWebsocketEvent) {
    PipelinesWebsocketEvent["PipelineUpdated"] = "pipeline_updated";
    PipelinesWebsocketEvent["CheckRunUpdated"] = "check_run_updated";
    PipelinesWebsocketEvent["StepUpdated"] = "step_updated";
    PipelinesWebsocketEvent["ReportUpdated"] = "report_updated";
    PipelinesWebsocketEvent["LogUpdated"] = "log_updated";
})($7d50d9c8f6faef01$export$2c141de7c8dfba2 || ($7d50d9c8f6faef01$export$2c141de7c8dfba2 = {}));
var $7d50d9c8f6faef01$export$708ae93bb3cd3125;
(function(MetricUsageStatusType) {
    MetricUsageStatusType["Warning"] = "Warning";
    MetricUsageStatusType["Error"] = "Error";
    MetricUsageStatusType["Unknown"] = "Unknown";
})($7d50d9c8f6faef01$export$708ae93bb3cd3125 || ($7d50d9c8f6faef01$export$708ae93bb3cd3125 = {}));
var $7d50d9c8f6faef01$export$745951e5b87042d2;
(function(PipelineFillState) {
    PipelineFillState["Success"] = "SUCCESS";
    PipelineFillState["Skipped"] = "SKIPPED";
    PipelineFillState["Failure"] = "FAILURE";
    PipelineFillState["Other"] = "OTHER";
})($7d50d9c8f6faef01$export$745951e5b87042d2 || ($7d50d9c8f6faef01$export$745951e5b87042d2 = {}));
var $7d50d9c8f6faef01$export$e3cb727504d06390;
(function(PipelinesWebsocketHookEvent) {
    PipelinesWebsocketHookEvent["LogUpdated"] = "log_updated";
    PipelinesWebsocketHookEvent["RunnerUpdated"] = "runner_updated";
})($7d50d9c8f6faef01$export$e3cb727504d06390 || ($7d50d9c8f6faef01$export$e3cb727504d06390 = {}));
var $7d50d9c8f6faef01$export$402bd0c667a9b13a;
(function(EnvironmentWebSocketEvent) {
    EnvironmentWebSocketEvent["EnvironmentsUpdated"] = "environment_updated";
    EnvironmentWebSocketEvent["EnvironmentsLockUpdated"] = "environment_lock_updated";
})($7d50d9c8f6faef01$export$402bd0c667a9b13a || ($7d50d9c8f6faef01$export$402bd0c667a9b13a = {}));
const $7d50d9c8f6faef01$export$14689c11e5f6b5e8 = Object.values($7d50d9c8f6faef01$export$2c141de7c8dfba2).filter((value)=>typeof value === "string");
const $7d50d9c8f6faef01$export$2c0b3039f2af0170 = Object.values($7d50d9c8f6faef01$export$402bd0c667a9b13a).filter((value)=>typeof value === "string");
var $7d50d9c8f6faef01$export$914c24b2d7fe131e;
(function(MetricWebsocketEvent) {
    MetricWebsocketEvent["MetricUpdated"] = "metric_updated";
})($7d50d9c8f6faef01$export$914c24b2d7fe131e || ($7d50d9c8f6faef01$export$914c24b2d7fe131e = {}));
const $7d50d9c8f6faef01$export$3395dae9d0234dc = 10;
const $7d50d9c8f6faef01$export$146b9e000c059d54 = 100;
const $7d50d9c8f6faef01$export$c9df1fd93466203c = 100;
const $7d50d9c8f6faef01$export$14881eba9532b83 = "pipelines";
const $7d50d9c8f6faef01$export$ef0240f3ee21c80d = 100;
const $7d50d9c8f6faef01$export$94ca5f25b7ff70f1 = 100;
const $7d50d9c8f6faef01$export$41834200cd926536 = 20;
const $7d50d9c8f6faef01$export$93c58b7fa134a008 = 100;
const $7d50d9c8f6faef01$export$4d462783a000f64e = 50;
const $7d50d9c8f6faef01$export$ab52939910a7dd7b = 100;
const $7d50d9c8f6faef01$export$1a78fd37a5e5f27f = 100;
const $7d50d9c8f6faef01$export$8497d1e9999a5e3c = 100;
const $7d50d9c8f6faef01$export$1901fafe129f402 = 90;
const $7d50d9c8f6faef01$export$d429368c18d8ecab = 100;
const $7d50d9c8f6faef01$export$1c26740fe1253f08 = 10;
const $7d50d9c8f6faef01$export$5d783bf9ab2211ea = 100;
const $7d50d9c8f6faef01$export$4abae7f57507544c = 100;
const $7d50d9c8f6faef01$export$8ab4b11a71d72835 = 10;
const $7d50d9c8f6faef01$export$834f89987965a996 = 99;
const $7d50d9c8f6faef01$export$c98f5c3d565c2467 = 1000000;
const $7d50d9c8f6faef01$export$4bdcbc1adf0bf8b6 = 500000;
const $7d50d9c8f6faef01$export$ad6e12b7c9f38e6b = 3;
const $7d50d9c8f6faef01$export$50efbc1c7b60d4fe = 500;
const $7d50d9c8f6faef01$export$3d54293ae52c936d = 500;
const $7d50d9c8f6faef01$export$5c065ebad35d2c23 = 500;
const $7d50d9c8f6faef01$export$7929ff33f0e5bcd4 = 100;
const $7d50d9c8f6faef01$export$292b6bf44e9a3b18 = 10;
const $7d50d9c8f6faef01$export$dbc9251da0eb5266 = 5000;
const $7d50d9c8f6faef01$export$292f6612e6e52d8d = /results\/branch\/(.*)\/page\/.*/;
const $7d50d9c8f6faef01$export$9d36dd9cf4ff94ac = "pipelines-onboarded";
const $7d50d9c8f6faef01$export$8042d1c568263a13 = "deployments-onboarded";
const $7d50d9c8f6faef01$export$a52e8aa97eb42115 = "step-viewer-fullscreen";
const $7d50d9c8f6faef01$export$9dd44a055d4935d8 = "pipelines_view_build_doctor";
const $7d50d9c8f6faef01$export$de40f1e79df7383d = "allowance-dismissed";
const $7d50d9c8f6faef01$export$4e2428475a925e4f = 1000;
const $7d50d9c8f6faef01$export$f28a07dce01f98ad = "https://support.atlassian.com/bitbucket-cloud/docs/integrate-pipelines-with-resource-servers-using-oidc/";
const $7d50d9c8f6faef01$export$813e8d630bc5d4ab = "https://support.atlassian.com/bitbucket-cloud/docs/using-ssh-keys-in-bitbucket-pipelines/";
const $7d50d9c8f6faef01$export$8a4c7bac6e601acf = "https://support.atlassian.com/bitbucket-cloud/docs/variables-and-secrets/";
const $7d50d9c8f6faef01$export$1dc76202e3ebf620 = "https://support.atlassian.com/bitbucket-cloud/docs/set-up-and-monitor-bitbucket-deployments/";
const $7d50d9c8f6faef01$export$34ec651e5bc041d2 = "https://support.atlassian.com/bitbucket-cloud/docs/runners/";
const $7d50d9c8f6faef01$export$4e76f57ef6781ff7 = `${$7d50d9c8f6faef01$export$34ec651e5bc041d2}#Runner-Changelog`;
const $7d50d9c8f6faef01$export$a538acef69ec700c = 6;
const $7d50d9c8f6faef01$export$8e4eb331eb92dcc7 = 15;
const $7d50d9c8f6faef01$export$dd7a143acda5a66f = 80;
const $7d50d9c8f6faef01$export$5935eefdaddb9915 = {
    PARSING: "PARSING",
    PENDING: "PENDING",
    IN_PROGRESS: "IN_PROGRESS"
};
const $7d50d9c8f6faef01$export$880baf5c9f64ca38 = "https://api.bitbucket.org/2.0/repositories/bitbucketpipelines/official-templates/src/master/templates.prod.json";
const $7d50d9c8f6faef01$export$380213ba5118290e = "pipelines-";
const $7d50d9c8f6faef01$export$ccee77ec32a436d7 = "https://bitbucket.org";
const $7d50d9c8f6faef01$export$225a4b1c145af505 = "bitbucket-pipelines.yml";
const $7d50d9c8f6faef01$export$9164af77ad9978cc = "https://confluence.atlassian.com/x/jW5LN";
const $7d50d9c8f6faef01$export$bfab8edbb0ca55a5 = "pipelines-feedback@atlassian.com";
const $7d50d9c8f6faef01$export$2d168c0dc533a435 = "https://confluence.atlassian.com/x/noU5Lw";
const $7d50d9c8f6faef01$export$1dae5d8c4438c108 = "https://confluence.atlassian.com/x/kYU5Lw";
const $7d50d9c8f6faef01$export$d3f8d8d708779e85 = "https://confluence.atlassian.com/bbkb/troubleshooting-bitbucket-pipelines-1141505226.html#TroubleshootingBitbucketPipelines-scenario4";
const $7d50d9c8f6faef01$export$1a0fbf2502109e09 = "https://confluence.atlassian.com/bbkb/troubleshooting-bitbucket-pipelines-1141505226.html#TroubleshootingBitbucketPipelines-scenario12";
const $7d50d9c8f6faef01$export$87f0f2b24aa00b76 = "https://support.atlassian.com/bitbucket-cloud/docs/limitations-of-bitbucket-pipelines/";
const $7d50d9c8f6faef01$export$66c0a309cd14157b = "https://support.atlassian.com/bitbucket-cloud/docs/databases-and-service-containers/#Service-memory-limits";
const $7d50d9c8f6faef01$export$17e923d953f793cc = "https://confluence.atlassian.com/x/gC8kN";
const $7d50d9c8f6faef01$export$e08e34188f86f0ce = "https://confluence.atlassian.com/x/gC8kN#UseservicesanddatabasesinBitbucketPipelines-Servicememorylimits";
const $7d50d9c8f6faef01$export$10353e676ee56f8b = "https://getsupport.atlassian.com/servicedesk/customer/portal/11";
const $7d50d9c8f6faef01$export$fed2b19653ebef5f = "https://confluence.atlassian.com/bitbucket/configure-bitbucket-pipelines-yml-792298910.html#Configurebitbucket-pipelines.yml-ci_depth";
const $7d50d9c8f6faef01$export$74780518bf6a2c40 = "https://support.atlassian.com/jira-service-management-cloud/docs/set-up-deployment-gating/";
const $7d50d9c8f6faef01$export$1e6141eab3dbc39c = "https://support.atlassian.com/bitbucket-cloud/docs/databases-and-service-containers/";
const $7d50d9c8f6faef01$export$24f59c9a728dc75a = "https://confluence.atlassian.com/x/3RJsO";
const $7d50d9c8f6faef01$export$ed5c0abc30f03a65 = "https://confluence.atlassian.com/x/bA1hNQ";
const $7d50d9c8f6faef01$export$76ae222c76f85f08 = "https://confluence.atlassian.com/x/rqadNw";
const $7d50d9c8f6faef01$export$8aaae21b0ddf8f1a = "https://bitbucket-pipelines.prod.public.atl-paas.net/validator";
const $7d50d9c8f6faef01$export$d39db57e7ebba3ea = "\\[(.+)\\]:(\\d+)";
const $7d50d9c8f6faef01$export$73b73a37cc59864a = "(.+):(\\d+)";
const $7d50d9c8f6faef01$export$2c0af453b5b3282d = "pipelines_log_line_wrapped";
const $7d50d9c8f6faef01$export$f4581137ec09127b = "{}";
const $7d50d9c8f6faef01$export$2c8e7dc259979c99 = (0, $jp7ng).DN900;
const $7d50d9c8f6faef01$export$5db9fe82d207da71 = "#161A1D"; // elevation.surface.sunken in dark mode
const $7d50d9c8f6faef01$export$46eef912e3833a11 = "#579DFF";
const $7d50d9c8f6faef01$export$adee3691811a24c1 = "rgb(32,42,64)";
const $7d50d9c8f6faef01$export$8a383881dac5af39 = (0, $jp7ng).DN800;
const $7d50d9c8f6faef01$export$ad34a090b4ab11d = (0, $jp7ng).DN200;
const $7d50d9c8f6faef01$export$7fd60b7e5a82431a = (0, $jp7ng).N40;
const $7d50d9c8f6faef01$export$172f412142e978a3 = (0, $jp7ng).DN30;
const $7d50d9c8f6faef01$export$2170f54fc46aa066 = (0, $jp7ng).DN600;
const $7d50d9c8f6faef01$export$8dd2c106c8b63c14 = (0, $jp7ng).DN100;
const $7d50d9c8f6faef01$export$af3117f6e6800cc5 = {
    LOG_V2: "use.v2.logs.backend"
};
const $7d50d9c8f6faef01$export$ce765b82bfe75c09 = "PERMISSION_DENIED";

});

parcelRegister("IQU41", function(module, exports) {

$parcel$export(module.exports, "prefixed", function () { return $9c7f8ba266acd5ba$export$302158222cd49bab; });
$parcel$export(module.exports, "SET_ACCOUNT_META", function () { return $9c7f8ba266acd5ba$export$9aa336f2722e7282; });
$parcel$export(module.exports, "setAccountMeta", function () { return $9c7f8ba266acd5ba$export$1782ffe70c3d9f48; });
const $9c7f8ba266acd5ba$export$302158222cd49bab = (action)=>`pipelines/${action}`;
const $9c7f8ba266acd5ba$export$9aa336f2722e7282 = "SET_ACCOUNT_META";
function $9c7f8ba266acd5ba$export$1782ffe70c3d9f48(payload) {
    return {
        type: $9c7f8ba266acd5ba$export$9aa336f2722e7282,
        payload: payload
    };
}

});


parcelRegister("5E3NZ", function(module, exports) {

$parcel$export(module.exports, "getPipelineUrl", function () { return $de3c3a7c2c6d654f$export$700fedf947c46b35; });
$parcel$export(module.exports, "getPipelineTarget", function () { return $de3c3a7c2c6d654f$export$3cbc121bb246fb5c; });
$parcel$export(module.exports, "getPipelinesUrl", function () { return $de3c3a7c2c6d654f$export$d62733b9d491cf62; });
$parcel$export(module.exports, "getPipelineDefinitionsUrl", function () { return $de3c3a7c2c6d654f$export$92d1a33ad5150886; });
$parcel$export(module.exports, "default", function () { return $de3c3a7c2c6d654f$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ // eslint-disable-next-line frontbucket-patterns/no-new-sagas

var $cJH1T = parcelRequire("cJH1T");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");
parcelRequire("e9n2v");
var $k412P = parcelRequire("k412P");
var $4EUxB = parcelRequire("4EUxB");

var $aanBq = parcelRequire("aanBq");

var $k2cPS = parcelRequire("k2cPS");

var $i3LMs = parcelRequire("i3LMs");

var $fEutT = parcelRequire("fEutT");

var $QgM08 = parcelRequire("QgM08");

var $jPcDa = parcelRequire("jPcDa");

var $8K6h8 = parcelRequire("8K6h8");
const $de3c3a7c2c6d654f$export$cb74d528797ed399 = (owner = "", queryParams = {})=>{
    return `${(0, $fEutT.default)("/!api/2.0")}/repositories/${owner}?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(queryParams)}`;
};
const $de3c3a7c2c6d654f$export$700fedf947c46b35 = (repositoryFullSlug, pipelineRef, queryParams = {})=>{
    const allQueryParams = {
        fields: "+target.commit.message,+target.commit.summary.html,+target.*,+*",
        ...queryParams
    };
    return `${(0, $fEutT.default)()}/repositories/${repositoryFullSlug}/pipelines/${pipelineRef ? `${pipelineRef}?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(allQueryParams, {
        allowDots: true
    })}` : ""}`;
};
const $de3c3a7c2c6d654f$export$3cbc121bb246fb5c = (pipeline)=>{
    const isRefPipeline = !!pipeline.refName;
    const isCustomPipeline = !!pipeline.customName;
    const commit = {
        message: pipeline.message,
        hash: pipeline.revision,
        type: "commit"
    };
    const type = isRefPipeline ? "pipeline_ref_target" : "pipeline_commit_target";
    const refName = isRefPipeline ? {
        ref_name: pipeline.refName
    } : null;
    const refType = isRefPipeline ? {
        ref_type: pipeline.refType
    } : null;
    let selector = {};
    if (isCustomPipeline) selector = {
        selector: {
            type: "custom",
            pattern: pipeline.selectorPattern
        }
    };
    else if (pipeline.isManual && !pipeline.isPullRequestPipeline) // support for default custom pipelines
    selector = {
        selector: {
            type: pipeline.selectorType,
            pattern: pipeline.selectorPattern
        }
    };
    else if (pipeline.selectorType === "pull-requests") return {
        target: pipeline.target
    };
    return {
        target: {
            commit: new (0, $4EUxB.Commit)(commit),
            type: type,
            ...refName,
            ...refType,
            ...selector
        }
    };
};
const $de3c3a7c2c6d654f$export$4e12abcfb512f9d8 = (repositoryFullSlug, pipelineRef)=>{
    return `${(0, $fEutT.default)("/!api/2.0")}/repositories/${repositoryFullSlug}/pipelines/${pipelineRef}/stopPipeline`;
};
const $de3c3a7c2c6d654f$export$d62733b9d491cf62 = (repositoryFullSlug, queryParams = {})=>{
    const allQueryParams = {
        page: 1,
        pagelen: (0, $i3LMs.PIPELINE_PAGE_SIZE),
        sort: "-created_on",
        fields: "+values.target.commit.message,+values.target.selector.type+values.target.selector.pattern+values.target.commit.summary.html,+values.target.*,+values.*,+page,+size",
        ...queryParams
    };
    return `${(0, $fEutT.default)("/!api/2.0")}/repositories/${repositoryFullSlug}/pipelines/?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(allQueryParams, {
        allowDots: true,
        arrayFormat: "repeat"
    })}`;
};
const $de3c3a7c2c6d654f$export$92d1a33ad5150886 = (repositoryFullSlug, ref, queryParams = {})=>{
    const allQueryParams = {
        page: 1,
        pagelen: (0, $i3LMs.PIPELINE_DEFINITIONS_PAGE_SIZE),
        revision: ref,
        ...queryParams
    };
    return `${(0, $fEutT.default)("/!api/internal", "pipelines", true)}/repositories/${repositoryFullSlug}/pipeline_definitions?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(allQueryParams)}`;
};
const $de3c3a7c2c6d654f$export$56c2d363dfcc10c9 = (repositoryFullSlug, revision)=>{
    return `${(0, $fEutT.default)("/!api/2.0")}/repositories/${repositoryFullSlug}/commit/${revision}/pullrequests`;
};
function* $de3c3a7c2c6d654f$export$f75980b38299f7c9(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        var _action$meta;
        const url = $de3c3a7c2c6d654f$export$d62733b9d491cf62(full_name, (_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : _action$meta.queryParams);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_PIPELINES).SUCCESS,
            meta: action.meta,
            payload: data
        });
    } catch (e) {
        if (!(0, $QgM08.isIgnoredErrorForSentry)(e)) (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_PIPELINES).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_PIPELINES).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $de3c3a7c2c6d654f$export$37be7c2a03172bd8(action) {
    const pipelineUuid = action === null || action === void 0 ? void 0 : action.pipelineUuid;
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const pipeline = yield (0, $5NpoY.a3)((0, $8K6h8.getCurrentPipeline));
    if (pipeline.uuid && pipeline.uuid !== pipelineUuid) return;
    const branchMatches = location.pathname.match((0, $i3LMs.SELECTED_BRANCH_REGEX));
    const selectedBranch = branchMatches && branchMatches[1] ? new (0, $k412P.Branch)({
        name: branchMatches[1]
    }) : undefined;
    try {
        const url = $de3c3a7c2c6d654f$export$700fedf947c46b35(full_name, action === null || action === void 0 ? void 0 : action.pipelineUuid);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_UPDATE_PIPELINE).SUCCESS,
            meta: {
                pipelineUuid: pipelineUuid
            },
            payload: {
                selectedBranch: decodeURIComponent((selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.name) || ""),
                data: data
            }
        });
    } catch (e) {
        if (!(0, $QgM08.isIgnoredErrorForSentry)(e)) (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_UPDATE_PIPELINE).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_UPDATE_PIPELINE).ERROR,
            meta: {
                pipelineUuid: pipelineUuid
            },
            payload: e
        });
    }
}
function* $de3c3a7c2c6d654f$export$847eeb7e9ec9ef37() {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = $de3c3a7c2c6d654f$export$d62733b9d491cf62(full_name, {
            pagelen: (0, $i3LMs.PIPELINE_CREATORS_PAGE_SIZE),
            fields: "-values.*,+values.creator,+values.trigger"
        });
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_PIPELINE_CREATORS).SUCCESS,
            payload: data
        });
    } catch (e) {
        if (!(0, $QgM08.isIgnoredErrorForSentry)(e)) (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_PIPELINE_CREATORS).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_PIPELINE_CREATORS).ERROR,
            payload: e
        });
    }
}
function* $de3c3a7c2c6d654f$export$28d3511563b15c4e(action) {
    try {
        const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
        let items = [];
        let morePagesAvailable = true;
        let currentPage = 0;
        while(morePagesAvailable){
            currentPage++;
            try {
                const url = $de3c3a7c2c6d654f$export$92d1a33ad5150886(full_name, action.meta.ref, {
                    pagelen: (0, $i3LMs.PIPELINE_DEFINITIONS_PAGE_SIZE),
                    page: currentPage
                });
                const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
                if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
                const data = yield (0, $5NpoY.P)([
                    res,
                    "json"
                ]);
                const { values: values, size: size } = data;
                items = items.concat(values);
                morePagesAvailable = size > currentPage * (0, $i3LMs.PIPELINE_DEFINITIONS_PAGE_SIZE);
            } catch (ignore) {
                morePagesAvailable = false;
            }
        }
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_PIPELINE_DEFINITIONS).SUCCESS,
            meta: action.meta,
            payload: {
                values: items
            }
        });
    } catch (e) {
        if (!(0, $QgM08.isIgnoredErrorForSentry)(e)) (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_PIPELINE_DEFINITIONS).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_PIPELINE_DEFINITIONS).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $de3c3a7c2c6d654f$export$1458bb478792afa5(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const { uuid: uuid } = yield (0, $5NpoY.a3)((0, $8K6h8.getCurrentPipeline));
    try {
        const url = $de3c3a7c2c6d654f$export$700fedf947c46b35(full_name, action.meta.pipelineUuid || uuid);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_CURRENT_PIPELINE).SUCCESS,
            meta: action.meta,
            payload: data
        });
    } catch (e) {
        if (!(0, $QgM08.isIgnoredErrorForSentry)(e)) (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_CURRENT_PIPELINE).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_CURRENT_PIPELINE).ERROR,
            payload: e
        });
    }
}
function* $de3c3a7c2c6d654f$export$9c34b6f6e93264fc(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = $de3c3a7c2c6d654f$export$700fedf947c46b35(full_name);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "POST",
            headers: (0, $k2cPS.jsonHeaders),
            body: JSON.stringify(action.meta.targetPipeline)
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_CREATE_PIPELINE).SUCCESS,
            meta: action.meta,
            payload: data
        });
    } catch (e) {
        if (!(0, $QgM08.isIgnoredErrorForSentry)(e)) (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_CREATE_PIPELINE).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_CREATE_PIPELINE).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $de3c3a7c2c6d654f$export$aa8a14349a823d85(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = $de3c3a7c2c6d654f$export$4e12abcfb512f9d8(full_name, action.meta.pipelineUuid);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "POST",
            headers: (0, $k2cPS.jsonHeaders)
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_STOP_PIPELINE).SUCCESS,
            meta: action.meta
        });
    } catch (e) {
        if (!(0, $QgM08.isIgnoredErrorForSentry)(e)) (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_STOP_PIPELINE).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_STOP_PIPELINE).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $de3c3a7c2c6d654f$export$ddc4a3ea40de26cf(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = $de3c3a7c2c6d654f$export$56c2d363dfcc10c9(full_name, action.meta.revision);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_COMMIT_PULL_REQUESTS).SUCCESS,
            meta: action.meta,
            payload: data
        });
    } catch (e) {
        if (!(0, $QgM08.isIgnoredErrorForSentry)(e)) (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_COMMIT_PULL_REQUESTS).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_COMMIT_PULL_REQUESTS).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $de3c3a7c2c6d654f$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_START_STEP).SUCCESS, $de3c3a7c2c6d654f$export$1458bb478792afa5),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_RESUME_STAGE_REDEPLOY).SUCCESS, $de3c3a7c2c6d654f$export$1458bb478792afa5),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_CURRENT_PIPELINE).REQUEST, $de3c3a7c2c6d654f$export$1458bb478792afa5),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_PIPELINES).REQUEST, $de3c3a7c2c6d654f$export$f75980b38299f7c9),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_CREATE_PIPELINE).REQUEST, $de3c3a7c2c6d654f$export$9c34b6f6e93264fc),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_STOP_PIPELINE).REQUEST, $de3c3a7c2c6d654f$export$aa8a14349a823d85),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_PIPELINE_CREATORS).REQUEST, $de3c3a7c2c6d654f$export$847eeb7e9ec9ef37),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_COMMIT_PULL_REQUESTS).REQUEST, $de3c3a7c2c6d654f$export$ddc4a3ea40de26cf),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_PIPELINE_DEFINITIONS).REQUEST, $de3c3a7c2c6d654f$export$28d3511563b15c4e),
        (0, $jeUNF.debounce)((0, $i3LMs.DELAY_PIPELINE_UPDATED), (0, $jPcDa.PIPELINE_UPDATED), $de3c3a7c2c6d654f$export$37be7c2a03172bd8)
    ]);
}

});
parcelRegister("fJWTD", function(module, exports) {
$parcel$export(module.exports, "actionChannel", function () { return (parcelRequire("5NpoY")).Q; });
$parcel$export(module.exports, "all", function () { return (parcelRequire("5NpoY"))._; });
$parcel$export(module.exports, "call", function () { return (parcelRequire("5NpoY")).P; });
$parcel$export(module.exports, "cancel", function () { return (parcelRequire("5NpoY")).O; });
$parcel$export(module.exports, "cancelled", function () { return (parcelRequire("5NpoY")).a4; });
$parcel$export(module.exports, "debounce", function () { return (parcelRequire("jeUNF")).debounce; });
$parcel$export(module.exports, "delay", function () { return (parcelRequire("5NpoY")).S; });
$parcel$export(module.exports, "fork", function () { return (parcelRequire("5NpoY")).N; });
$parcel$export(module.exports, "getContext", function () { return (parcelRequire("5NpoY")).a6; });
$parcel$export(module.exports, "put", function () { return (parcelRequire("5NpoY")).Y; });
$parcel$export(module.exports, "race", function () { return (parcelRequire("5NpoY")).T; });
$parcel$export(module.exports, "select", function () { return (parcelRequire("5NpoY")).a3; });
$parcel$export(module.exports, "spawn", function () { return (parcelRequire("5NpoY")).a1; });
$parcel$export(module.exports, "take", function () { return (parcelRequire("5NpoY")).M; });
$parcel$export(module.exports, "takeEvery", function () { return (parcelRequire("jeUNF")).takeEvery; });
$parcel$export(module.exports, "takeLatest", function () { return (parcelRequire("jeUNF")).takeLatest; });
$parcel$export(module.exports, "takeLeading", function () { return (parcelRequire("jeUNF")).takeLeading; });
parcelRequire("jeUNF");

});
parcelRegister("jeUNF", function(module, exports) {

$parcel$export(module.exports, "takeEvery", function () { return $e01b6270b5ac6cf3$export$4e24be1e1c9d5c69; });
$parcel$export(module.exports, "takeLatest", function () { return $e01b6270b5ac6cf3$export$ca010cea618a298a; });
$parcel$export(module.exports, "takeLeading", function () { return $e01b6270b5ac6cf3$export$ab18f80dcccecca4; });
$parcel$export(module.exports, "debounce", function () { return $e01b6270b5ac6cf3$export$61fc7d43ac8f84b0; });
$parcel$export(module.exports, "take", function () { return (parcelRequire("5NpoY")).M; });
$parcel$export(module.exports, "put", function () { return (parcelRequire("5NpoY")).Y; });
$parcel$export(module.exports, "all", function () { return (parcelRequire("5NpoY"))._; });
$parcel$export(module.exports, "race", function () { return (parcelRequire("5NpoY")).T; });
$parcel$export(module.exports, "call", function () { return (parcelRequire("5NpoY")).P; });
$parcel$export(module.exports, "fork", function () { return (parcelRequire("5NpoY")).N; });
$parcel$export(module.exports, "spawn", function () { return (parcelRequire("5NpoY")).a1; });
$parcel$export(module.exports, "cancel", function () { return (parcelRequire("5NpoY")).O; });
$parcel$export(module.exports, "select", function () { return (parcelRequire("5NpoY")).a3; });
$parcel$export(module.exports, "actionChannel", function () { return (parcelRequire("5NpoY")).Q; });
$parcel$export(module.exports, "cancelled", function () { return (parcelRequire("5NpoY")).a4; });
$parcel$export(module.exports, "getContext", function () { return (parcelRequire("5NpoY")).a6; });
$parcel$export(module.exports, "delay", function () { return (parcelRequire("5NpoY")).S; });
parcelRequire("fQGsC");
parcelRequire("ii97e");

var $f1e9n = parcelRequire("f1e9n");

var $5NpoY = parcelRequire("5NpoY");
parcelRequire("7v88c");
var $e01b6270b5ac6cf3$var$done = function done(value) {
    return {
        done: true,
        value: value
    };
};
var $e01b6270b5ac6cf3$var$qEnd = {};
function $e01b6270b5ac6cf3$var$safeName(patternOrChannel) {
    if ((0, $f1e9n.channel)(patternOrChannel)) return "channel";
    if ((0, $f1e9n.stringableFunc)(patternOrChannel)) return String(patternOrChannel);
    if ((0, $f1e9n.func)(patternOrChannel)) return patternOrChannel.name;
    return String(patternOrChannel);
}
function $e01b6270b5ac6cf3$var$fsmIterator(fsm, startState, name) {
    var stateUpdater, errorState, effect, nextState = startState;
    function next(arg, error) {
        if (nextState === $e01b6270b5ac6cf3$var$qEnd) return $e01b6270b5ac6cf3$var$done(arg);
        if (error && !errorState) {
            nextState = $e01b6270b5ac6cf3$var$qEnd;
            throw error;
        } else {
            stateUpdater && stateUpdater(arg);
            var currentState = error ? fsm[errorState](error) : fsm[nextState]();
            nextState = currentState.nextState;
            effect = currentState.effect;
            stateUpdater = currentState.stateUpdater;
            errorState = currentState.errorState;
            return nextState === $e01b6270b5ac6cf3$var$qEnd ? $e01b6270b5ac6cf3$var$done(arg) : effect;
        }
    }
    return (0, $5NpoY.B)(next, function(error) {
        return next(null, error);
    }, name);
}
function $e01b6270b5ac6cf3$var$takeEvery(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $5NpoY.M)(patternOrChannel)
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $5NpoY.N).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var action, setAction = function setAction(ac) {
        return action = ac;
    };
    return $e01b6270b5ac6cf3$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: "q1",
                effect: yFork(action)
            };
        }
    }, "q1", "takeEvery(" + $e01b6270b5ac6cf3$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $e01b6270b5ac6cf3$var$takeLatest(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $5NpoY.M)(patternOrChannel)
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $5NpoY.N).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yCancel = function yCancel(task) {
        return {
            done: false,
            value: (0, $5NpoY.O)(task)
        };
    };
    var task, action;
    var setTask = function setTask(t) {
        return task = t;
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    return $e01b6270b5ac6cf3$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return task ? {
                nextState: "q3",
                effect: yCancel(task)
            } : {
                nextState: "q1",
                effect: yFork(action),
                stateUpdater: setTask
            };
        },
        q3: function q3() {
            return {
                nextState: "q1",
                effect: yFork(action),
                stateUpdater: setTask
            };
        }
    }, "q1", "takeLatest(" + $e01b6270b5ac6cf3$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $e01b6270b5ac6cf3$var$takeLeading(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $5NpoY.M)(patternOrChannel)
    };
    var yCall = function yCall(ac) {
        return {
            done: false,
            value: (0, $5NpoY.P).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var action;
    var setAction = function setAction(ac) {
        return action = ac;
    };
    return $e01b6270b5ac6cf3$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: "q1",
                effect: yCall(action)
            };
        }
    }, "q1", "takeLeading(" + $e01b6270b5ac6cf3$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $e01b6270b5ac6cf3$var$throttle(delayLength, pattern, worker) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var action, channel$$1;
    var yActionChannel = {
        done: false,
        value: (0, $5NpoY.Q)(pattern, (0, $5NpoY.R)(1))
    };
    var yTake = function yTake() {
        return {
            done: false,
            value: (0, $5NpoY.M)(channel$$1)
        };
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $5NpoY.N).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yDelay = {
        done: false,
        value: (0, $5NpoY.S)(delayLength)
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    var setChannel = function setChannel(ch) {
        return channel$$1 = ch;
    };
    return $e01b6270b5ac6cf3$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yActionChannel,
                stateUpdater: setChannel
            };
        },
        q2: function q2() {
            return {
                nextState: "q3",
                effect: yTake(),
                stateUpdater: setAction
            };
        },
        q3: function q3() {
            return {
                nextState: "q4",
                effect: yFork(action)
            };
        },
        q4: function q4() {
            return {
                nextState: "q2",
                effect: yDelay
            };
        }
    }, "q1", "throttle(" + $e01b6270b5ac6cf3$var$safeName(pattern) + ", " + worker.name + ")");
}
function $e01b6270b5ac6cf3$var$retry(maxTries, delayLength, fn) {
    var counter = maxTries;
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var yCall = {
        done: false,
        value: (0, $5NpoY.P).apply(void 0, [
            fn
        ].concat(args))
    };
    var yDelay = {
        done: false,
        value: (0, $5NpoY.S)(delayLength)
    };
    return $e01b6270b5ac6cf3$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yCall,
                errorState: "q10"
            };
        },
        q2: function q2() {
            return {
                nextState: $e01b6270b5ac6cf3$var$qEnd
            };
        },
        q10: function q10(error) {
            counter -= 1;
            if (counter <= 0) throw error;
            return {
                nextState: "q1",
                effect: yDelay
            };
        }
    }, "q1", "retry(" + fn.name + ")");
}
function $e01b6270b5ac6cf3$var$debounceHelper(delayLength, patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var action, raceOutput;
    var yTake = {
        done: false,
        value: (0, $5NpoY.M)(patternOrChannel)
    };
    var yRace = {
        done: false,
        value: (0, $5NpoY.T)({
            action: (0, $5NpoY.M)(patternOrChannel),
            debounce: (0, $5NpoY.S)(delayLength)
        })
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $5NpoY.N).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yNoop = function yNoop(value) {
        return {
            done: false,
            value: value
        };
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    var setRaceOutput = function setRaceOutput(ro) {
        return raceOutput = ro;
    };
    return $e01b6270b5ac6cf3$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: "q3",
                effect: yRace,
                stateUpdater: setRaceOutput
            };
        },
        q3: function q3() {
            return raceOutput.debounce ? {
                nextState: "q1",
                effect: yFork(action)
            } : {
                nextState: "q2",
                effect: yNoop(raceOutput.action),
                stateUpdater: setAction
            };
        }
    }, "q1", "debounce(" + $e01b6270b5ac6cf3$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
var $e01b6270b5ac6cf3$var$validateTakeEffect = function validateTakeEffect(fn, patternOrChannel, worker) {
    (0, $5NpoY.c)(patternOrChannel, (0, $f1e9n.notUndef), fn.name + " requires a pattern or channel");
    (0, $5NpoY.c)(worker, (0, $f1e9n.notUndef), fn.name + " requires a saga parameter");
};
function $e01b6270b5ac6cf3$export$4e24be1e1c9d5c69(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    return (0, $5NpoY.N).apply(void 0, [
        $e01b6270b5ac6cf3$var$takeEvery,
        patternOrChannel,
        worker
    ].concat(args));
}
function $e01b6270b5ac6cf3$export$ca010cea618a298a(patternOrChannel, worker) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
    return (0, $5NpoY.N).apply(void 0, [
        $e01b6270b5ac6cf3$var$takeLatest,
        patternOrChannel,
        worker
    ].concat(args));
}
function $e01b6270b5ac6cf3$export$ab18f80dcccecca4(patternOrChannel, worker) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)args[_key3 - 2] = arguments[_key3];
    return (0, $5NpoY.N).apply(void 0, [
        $e01b6270b5ac6cf3$var$takeLeading,
        patternOrChannel,
        worker
    ].concat(args));
}
function $e01b6270b5ac6cf3$export$de363e709c412c8a(ms, pattern, worker) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++)args[_key4 - 3] = arguments[_key4];
    return (0, $5NpoY.N).apply(void 0, [
        $e01b6270b5ac6cf3$var$throttle,
        ms,
        pattern,
        worker
    ].concat(args));
}
function $e01b6270b5ac6cf3$export$9369b12211e1fce4(maxTries, delayLength, worker) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 3 ? _len5 - 3 : 0), _key5 = 3; _key5 < _len5; _key5++)args[_key5 - 3] = arguments[_key5];
    return (0, $5NpoY.P).apply(void 0, [
        $e01b6270b5ac6cf3$var$retry,
        maxTries,
        delayLength,
        worker
    ].concat(args));
}
function $e01b6270b5ac6cf3$export$61fc7d43ac8f84b0(delayLength, pattern, worker) {
    for(var _len6 = arguments.length, args = new Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++)args[_key6 - 3] = arguments[_key6];
    return (0, $5NpoY.N).apply(void 0, [
        $e01b6270b5ac6cf3$var$debounceHelper,
        delayLength,
        pattern,
        worker
    ].concat(args));
}

});
parcelRegister("fQGsC", function(module, exports) {

$parcel$export(module.exports, "CANCEL", function () { return $b89ca627aaa3aaad$export$2b10f4b30fb65583; });
$parcel$export(module.exports, "CHANNEL_END_TYPE", function () { return $b89ca627aaa3aaad$export$3281fbb3edc9dee3; });
$parcel$export(module.exports, "IO", function () { return $b89ca627aaa3aaad$export$8f8422ac5947a789; });
$parcel$export(module.exports, "MATCH", function () { return $b89ca627aaa3aaad$export$5a1a83be8f503735; });
$parcel$export(module.exports, "MULTICAST", function () { return $b89ca627aaa3aaad$export$9074c4e62c4e51bb; });
$parcel$export(module.exports, "SAGA_ACTION", function () { return $b89ca627aaa3aaad$export$7d963e45ecdffba1; });
$parcel$export(module.exports, "SELF_CANCELLATION", function () { return $b89ca627aaa3aaad$export$3f4d38f8b89bfda7; });
$parcel$export(module.exports, "TASK", function () { return $b89ca627aaa3aaad$export$9355e489ad16f98e; });
$parcel$export(module.exports, "TASK_CANCEL", function () { return $b89ca627aaa3aaad$export$a47f788ef0b36709; });
$parcel$export(module.exports, "TERMINATE", function () { return $b89ca627aaa3aaad$export$d966e43d90bf4c05; });
$parcel$export(module.exports, "SAGA_LOCATION", function () { return $b89ca627aaa3aaad$export$bdae2c4f4f03305d; });
var $b89ca627aaa3aaad$var$createSymbol = function createSymbol(name) {
    return "@@redux-saga/" + name;
};
var $b89ca627aaa3aaad$export$2b10f4b30fb65583 = /*#__PURE__*/ $b89ca627aaa3aaad$var$createSymbol("CANCEL_PROMISE");
var $b89ca627aaa3aaad$export$3281fbb3edc9dee3 = /*#__PURE__*/ $b89ca627aaa3aaad$var$createSymbol("CHANNEL_END");
var $b89ca627aaa3aaad$export$8f8422ac5947a789 = /*#__PURE__*/ $b89ca627aaa3aaad$var$createSymbol("IO");
var $b89ca627aaa3aaad$export$5a1a83be8f503735 = /*#__PURE__*/ $b89ca627aaa3aaad$var$createSymbol("MATCH");
var $b89ca627aaa3aaad$export$9074c4e62c4e51bb = /*#__PURE__*/ $b89ca627aaa3aaad$var$createSymbol("MULTICAST");
var $b89ca627aaa3aaad$export$7d963e45ecdffba1 = /*#__PURE__*/ $b89ca627aaa3aaad$var$createSymbol("SAGA_ACTION");
var $b89ca627aaa3aaad$export$3f4d38f8b89bfda7 = /*#__PURE__*/ $b89ca627aaa3aaad$var$createSymbol("SELF_CANCELLATION");
var $b89ca627aaa3aaad$export$9355e489ad16f98e = /*#__PURE__*/ $b89ca627aaa3aaad$var$createSymbol("TASK");
var $b89ca627aaa3aaad$export$a47f788ef0b36709 = /*#__PURE__*/ $b89ca627aaa3aaad$var$createSymbol("TASK_CANCEL");
var $b89ca627aaa3aaad$export$d966e43d90bf4c05 = /*#__PURE__*/ $b89ca627aaa3aaad$var$createSymbol("TERMINATE");
var $b89ca627aaa3aaad$export$bdae2c4f4f03305d = /*#__PURE__*/ $b89ca627aaa3aaad$var$createSymbol("LOCATION");

});

parcelRegister("f1e9n", function(module, exports) {

$parcel$export(module.exports, "undef", function () { return $aef1ecf4b4621855$export$c7b6444af1f098df; });
$parcel$export(module.exports, "notUndef", function () { return $aef1ecf4b4621855$export$1352885233577768; });
$parcel$export(module.exports, "func", function () { return $aef1ecf4b4621855$export$86951950244e2001; });
$parcel$export(module.exports, "string", function () { return $aef1ecf4b4621855$export$22b082955e083ec3; });
$parcel$export(module.exports, "array", function () { return $aef1ecf4b4621855$export$2f23118c22fb2630; });
$parcel$export(module.exports, "object", function () { return $aef1ecf4b4621855$export$be5493f9613cbbe; });
$parcel$export(module.exports, "promise", function () { return $aef1ecf4b4621855$export$c957ef27a0ebfd4; });
$parcel$export(module.exports, "iterator", function () { return $aef1ecf4b4621855$export$6f58e2338da23f4d; });
$parcel$export(module.exports, "pattern", function () { return $aef1ecf4b4621855$export$24f82734ea047e6f; });
$parcel$export(module.exports, "symbol", function () { return $aef1ecf4b4621855$export$8f701197936bc2a6; });
$parcel$export(module.exports, "channel", function () { return $aef1ecf4b4621855$export$1f95fbd68d964d36; });
$parcel$export(module.exports, "stringableFunc", function () { return $aef1ecf4b4621855$export$32b5e46230afa379; });
$parcel$export(module.exports, "multicast", function () { return $aef1ecf4b4621855$export$1364843af8d5a963; });

var $fQGsC = parcelRequire("fQGsC");
var $aef1ecf4b4621855$export$c7b6444af1f098df = function undef(v) {
    return v === null || v === undefined;
};
var $aef1ecf4b4621855$export$1352885233577768 = function notUndef(v) {
    return v !== null && v !== undefined;
};
var $aef1ecf4b4621855$export$86951950244e2001 = function func(f) {
    return typeof f === "function";
};
var $aef1ecf4b4621855$export$98e628dec113755e = function number(n) {
    return typeof n === "number";
};
var $aef1ecf4b4621855$export$22b082955e083ec3 = function string(s) {
    return typeof s === "string";
};
var $aef1ecf4b4621855$export$2f23118c22fb2630 = Array.isArray;
var $aef1ecf4b4621855$export$be5493f9613cbbe = function object(obj) {
    return obj && !$aef1ecf4b4621855$export$2f23118c22fb2630(obj) && typeof obj === "object";
};
var $aef1ecf4b4621855$export$c957ef27a0ebfd4 = function promise(p) {
    return p && $aef1ecf4b4621855$export$86951950244e2001(p.then);
};
var $aef1ecf4b4621855$export$6f58e2338da23f4d = function iterator(it) {
    return it && $aef1ecf4b4621855$export$86951950244e2001(it.next) && $aef1ecf4b4621855$export$86951950244e2001(it.throw);
};
var $aef1ecf4b4621855$export$8e2ddbe84aff549 = function iterable(it) {
    return it && $aef1ecf4b4621855$export$86951950244e2001(Symbol) ? $aef1ecf4b4621855$export$86951950244e2001(it[Symbol.iterator]) : $aef1ecf4b4621855$export$2f23118c22fb2630(it);
};
var $aef1ecf4b4621855$export$94e939b87ca64fb4 = function task(t) {
    return t && t[0, $fQGsC.TASK];
};
var $aef1ecf4b4621855$export$2ce8c19c8dfba715 = function sagaAction(a) {
    return Boolean(a && a[0, $fQGsC.SAGA_ACTION]);
};
var $aef1ecf4b4621855$export$5ab46cbf6120b33a = function observable(ob) {
    return ob && $aef1ecf4b4621855$export$86951950244e2001(ob.subscribe);
};
var $aef1ecf4b4621855$export$ab1029bcae9ddb4a = function buffer(buf) {
    return buf && $aef1ecf4b4621855$export$86951950244e2001(buf.isEmpty) && $aef1ecf4b4621855$export$86951950244e2001(buf.take) && $aef1ecf4b4621855$export$86951950244e2001(buf.put);
};
var $aef1ecf4b4621855$export$24f82734ea047e6f = function pattern(pat) {
    return pat && ($aef1ecf4b4621855$export$22b082955e083ec3(pat) || $aef1ecf4b4621855$export$8f701197936bc2a6(pat) || $aef1ecf4b4621855$export$86951950244e2001(pat) || $aef1ecf4b4621855$export$2f23118c22fb2630(pat) && pat.every(pattern));
};
var $aef1ecf4b4621855$export$1f95fbd68d964d36 = function channel(ch) {
    return ch && $aef1ecf4b4621855$export$86951950244e2001(ch.take) && $aef1ecf4b4621855$export$86951950244e2001(ch.close);
};
var $aef1ecf4b4621855$export$32b5e46230afa379 = function stringableFunc(f) {
    return $aef1ecf4b4621855$export$86951950244e2001(f) && f.hasOwnProperty("toString");
};
var $aef1ecf4b4621855$export$8f701197936bc2a6 = function symbol(sym) {
    return Boolean(sym) && typeof Symbol === "function" && sym.constructor === Symbol && sym !== Symbol.prototype;
};
var $aef1ecf4b4621855$export$1364843af8d5a963 = function multicast(ch) {
    return $aef1ecf4b4621855$export$1f95fbd68d964d36(ch) && ch[0, $fQGsC.MULTICAST];
};
var $aef1ecf4b4621855$export$dc573d8a6576cdb3 = function effect(eff) {
    return eff && eff[0, $fQGsC.IO];
};

});

parcelRegister("5NpoY", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $43853ba405cad054$export$407448d2b89b1813; });
$parcel$export(module.exports, "x", function () { return $43853ba405cad054$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "L", function () { return $43853ba405cad054$export$61196ced6d74a310; });
$parcel$export(module.exports, "c", function () { return $43853ba405cad054$export$db3b6bfb95261072; });
$parcel$export(module.exports, "A", function () { return $43853ba405cad054$export$ebd11618f299a286; });
$parcel$export(module.exports, "D", function () { return $43853ba405cad054$export$96f57966bedc81b4; });
$parcel$export(module.exports, "f", function () { return $43853ba405cad054$export$2d1720544b23b823; });
$parcel$export(module.exports, "e", function () { return $43853ba405cad054$export$f1e1789686576879; });
$parcel$export(module.exports, "B", function () { return $43853ba405cad054$export$ef35774e6d314e91; });
$parcel$export(module.exports, "J", function () { return $43853ba405cad054$export$b4171a6734a65d42; });
$parcel$export(module.exports, "g", function () { return $43853ba405cad054$export$39b482c5e57630a8; });
$parcel$export(module.exports, "z", function () { return $43853ba405cad054$export$df995fae86a55f06; });
$parcel$export(module.exports, "K", function () { return $43853ba405cad054$export$3466f893ebf79586; });
$parcel$export(module.exports, "I", function () { return $43853ba405cad054$export$9bb611d729802a56; });
$parcel$export(module.exports, "H", function () { return $43853ba405cad054$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "C", function () { return $43853ba405cad054$export$e7094788287c5e9b; });
$parcel$export(module.exports, "y", function () { return $43853ba405cad054$export$4a5767248b18ef41; });
$parcel$export(module.exports, "w", function () { return $43853ba405cad054$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "E", function () { return $43853ba405cad054$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "d", function () { return $43853ba405cad054$export$4368d992c4eafac0; });
$parcel$export(module.exports, "R", function () { return $43853ba405cad054$export$db202ddc8be9136; });
$parcel$export(module.exports, "b", function () { return $43853ba405cad054$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "h", function () { return $43853ba405cad054$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "i", function () { return $43853ba405cad054$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "j", function () { return $43853ba405cad054$export$35e795649ee09318; });
$parcel$export(module.exports, "k", function () { return $43853ba405cad054$export$342063e11d6c3cad; });
$parcel$export(module.exports, "l", function () { return $43853ba405cad054$export$882b5998b3b9117c; });
$parcel$export(module.exports, "m", function () { return $43853ba405cad054$export$953cecd6e717a553; });
$parcel$export(module.exports, "n", function () { return $43853ba405cad054$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "o", function () { return $43853ba405cad054$export$ae1af26003f05816; });
$parcel$export(module.exports, "p", function () { return $43853ba405cad054$export$ffb5f4729a158638; });
$parcel$export(module.exports, "q", function () { return $43853ba405cad054$export$9e5f44173e64f162; });
$parcel$export(module.exports, "r", function () { return $43853ba405cad054$export$43caf9889c228507; });
$parcel$export(module.exports, "s", function () { return $43853ba405cad054$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "t", function () { return $43853ba405cad054$export$625550452a3fa3ec; });
$parcel$export(module.exports, "u", function () { return $43853ba405cad054$export$3b14a55fb2447963; });
$parcel$export(module.exports, "v", function () { return $43853ba405cad054$export$90a7f3efeed30595; });
$parcel$export(module.exports, "M", function () { return $43853ba405cad054$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "Y", function () { return $43853ba405cad054$export$8743009a87fcb00f; });
$parcel$export(module.exports, "_", function () { return $43853ba405cad054$export$71511d61b312f219; });
$parcel$export(module.exports, "T", function () { return $43853ba405cad054$export$971d5caa766a69d7; });
$parcel$export(module.exports, "S", function () { return $43853ba405cad054$export$25ce5a424b770e84; });
$parcel$export(module.exports, "P", function () { return $43853ba405cad054$export$56c0d5a1e737357d; });
$parcel$export(module.exports, "N", function () { return $43853ba405cad054$export$a07804094c3ecf2d; });
$parcel$export(module.exports, "a1", function () { return $43853ba405cad054$export$3c2fa207a37baaea; });
$parcel$export(module.exports, "O", function () { return $43853ba405cad054$export$c4ce752e73470fba; });
$parcel$export(module.exports, "a3", function () { return $43853ba405cad054$export$6559d589eb85fbb6; });
$parcel$export(module.exports, "Q", function () { return $43853ba405cad054$export$3722cfe417b6ed86; });
$parcel$export(module.exports, "a4", function () { return $43853ba405cad054$export$efca4cbe5dd06740; });
$parcel$export(module.exports, "a6", function () { return $43853ba405cad054$export$2e2af4578d910ddf; });

var $fQGsC = parcelRequire("fQGsC");

var $ii97e = parcelRequire("ii97e");

var $f1e9n = parcelRequire("f1e9n");

var $7v88c = parcelRequire("7v88c");
var $43853ba405cad054$var$konst = function konst(v) {
    return function() {
        return v;
    };
};
var $43853ba405cad054$export$407448d2b89b1813 = /*#__PURE__*/ $43853ba405cad054$var$konst(true);
var $43853ba405cad054$export$d141bba7fdc215a3 = function noop() {};
var $43853ba405cad054$export$61196ced6d74a310 = function identity(v) {
    return v;
};
var $43853ba405cad054$var$hasSymbol = typeof Symbol === "function";
var $43853ba405cad054$export$2329c99376c9d0a4 = $43853ba405cad054$var$hasSymbol && Symbol.asyncIterator ? Symbol.asyncIterator : "@@asyncIterator";
function $43853ba405cad054$export$db3b6bfb95261072(value, predicate, error) {
    if (!predicate(value)) throw new Error(error);
}
var $43853ba405cad054$export$ebd11618f299a286 = function assignWithSymbols(target, source) {
    (0, $ii97e.default)(target, source);
    if (Object.getOwnPropertySymbols) Object.getOwnPropertySymbols(source).forEach(function(s) {
        target[s] = source[s];
    });
};
var $43853ba405cad054$export$96f57966bedc81b4 = function flatMap(mapper, arr) {
    var _ref;
    return (_ref = []).concat.apply(_ref, arr.map(mapper));
};
function $43853ba405cad054$export$2d1720544b23b823(array$$1, item) {
    var index = array$$1.indexOf(item);
    if (index >= 0) array$$1.splice(index, 1);
}
function $43853ba405cad054$export$f1e1789686576879(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        fn();
    };
}
var $43853ba405cad054$var$kThrow = function kThrow(err) {
    throw err;
};
var $43853ba405cad054$var$kReturn = function kReturn(value) {
    return {
        value: value,
        done: true
    };
};
function $43853ba405cad054$export$ef35774e6d314e91(next, thro, name) {
    if (thro === void 0) thro = $43853ba405cad054$var$kThrow;
    if (name === void 0) name = "iterator";
    var iterator = {
        meta: {
            name: name
        },
        next: next,
        throw: thro,
        return: $43853ba405cad054$var$kReturn,
        isSagaIterator: true
    };
    if (typeof Symbol !== "undefined") iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $43853ba405cad054$export$b4171a6734a65d42(error, _ref2) {
    var sagaStack = _ref2.sagaStack;
    /*eslint-disable no-console*/ console.error(error);
    console.error(sagaStack);
}
var $43853ba405cad054$export$39b482c5e57630a8 = function internalErr(err) {
    return new Error("\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project's github repo.\n  Error: " + err + "\n");
};
var $43853ba405cad054$export$d66501df72047452 = function createSetContextWarning(ctx, props) {
    return (ctx ? ctx + "." : "") + "setContext(props): argument " + props + " is not a plain object";
};
var $43853ba405cad054$var$FROZEN_ACTION_ERROR = "You can't put (a.k.a. dispatch from saga) frozen actions.\nWe have to define a special non-enumerable property on those actions for scheduling purposes.\nOtherwise you wouldn't be able to communicate properly between sagas & other subscribers (action ordering would become far less predictable).\nIf you are using redux and you care about this behaviour (frozen actions),\nthen you might want to switch to freezing actions in a middleware rather than in action creator.\nExample implementation:\n\nconst freezeActions = store => next => action => next(Object.freeze(action))\n"; // creates empty, but not-holey array
var $43853ba405cad054$export$df995fae86a55f06 = function createEmptyArray(n) {
    return Array.apply(null, new Array(n));
};
var $43853ba405cad054$export$3466f893ebf79586 = function wrapSagaDispatch(dispatch) {
    return function(action) {
        return dispatch(Object.defineProperty(action, (0, $fQGsC.SAGA_ACTION), {
            value: true
        }));
    };
};
var $43853ba405cad054$export$9bb611d729802a56 = function shouldTerminate(res) {
    return res === (0, $fQGsC.TERMINATE);
};
var $43853ba405cad054$export$7f8ddf7c7c20b3cd = function shouldCancel(res) {
    return res === (0, $fQGsC.TASK_CANCEL);
};
var $43853ba405cad054$export$e7094788287c5e9b = function shouldComplete(res) {
    return $43853ba405cad054$export$9bb611d729802a56(res) || $43853ba405cad054$export$7f8ddf7c7c20b3cd(res);
};
function $43853ba405cad054$export$4a5767248b18ef41(shape, parentCallback) {
    var keys = Object.keys(shape);
    var totalCount = keys.length;
    var completedCount = 0;
    var completed;
    var results = (0, $f1e9n.array)(shape) ? $43853ba405cad054$export$df995fae86a55f06(totalCount) : {};
    var childCallbacks = {};
    function checkEnd() {
        if (completedCount === totalCount) {
            completed = true;
            parentCallback(results);
        }
    }
    keys.forEach(function(key) {
        var chCbAtKey = function chCbAtKey(res, isErr) {
            if (completed) return;
            if (isErr || $43853ba405cad054$export$e7094788287c5e9b(res)) {
                parentCallback.cancel();
                parentCallback(res, isErr);
            } else {
                results[key] = res;
                completedCount++;
                checkEnd();
            }
        };
        chCbAtKey.cancel = $43853ba405cad054$export$d141bba7fdc215a3;
        childCallbacks[key] = chCbAtKey;
    });
    parentCallback.cancel = function() {
        if (!completed) {
            completed = true;
            keys.forEach(function(key) {
                return childCallbacks[key].cancel();
            });
        }
    };
    return childCallbacks;
}
function $43853ba405cad054$export$efccba1c4a2ef57b(fn) {
    return {
        name: fn.name || "anonymous",
        location: $43853ba405cad054$export$a9c23c6ac3fc3eca(fn)
    };
}
function $43853ba405cad054$export$a9c23c6ac3fc3eca(instrumented) {
    return instrumented[0, $fQGsC.SAGA_LOCATION];
}
var $43853ba405cad054$var$BUFFER_OVERFLOW = "Channel's Buffer overflow!";
var $43853ba405cad054$var$ON_OVERFLOW_THROW = 1;
var $43853ba405cad054$var$ON_OVERFLOW_DROP = 2;
var $43853ba405cad054$var$ON_OVERFLOW_SLIDE = 3;
var $43853ba405cad054$var$ON_OVERFLOW_EXPAND = 4;
var $43853ba405cad054$var$zeroBuffer = {
    isEmpty: $43853ba405cad054$export$407448d2b89b1813,
    put: $43853ba405cad054$export$d141bba7fdc215a3,
    take: $43853ba405cad054$export$d141bba7fdc215a3
};
function $43853ba405cad054$var$ringBuffer(limit, overflowAction) {
    if (limit === void 0) limit = 10;
    var arr = new Array(limit);
    var length = 0;
    var pushIndex = 0;
    var popIndex = 0;
    var push = function push(it) {
        arr[pushIndex] = it;
        pushIndex = (pushIndex + 1) % limit;
        length++;
    };
    var take = function take() {
        if (length != 0) {
            var it = arr[popIndex];
            arr[popIndex] = null;
            length--;
            popIndex = (popIndex + 1) % limit;
            return it;
        }
    };
    var flush = function flush() {
        var items = [];
        while(length)items.push(take());
        return items;
    };
    return {
        isEmpty: function isEmpty() {
            return length == 0;
        },
        put: function put(it) {
            if (length < limit) push(it);
            else {
                var doubledLimit;
                switch(overflowAction){
                    case $43853ba405cad054$var$ON_OVERFLOW_THROW:
                        throw new Error($43853ba405cad054$var$BUFFER_OVERFLOW);
                    case $43853ba405cad054$var$ON_OVERFLOW_SLIDE:
                        arr[pushIndex] = it;
                        pushIndex = (pushIndex + 1) % limit;
                        popIndex = pushIndex;
                        break;
                    case $43853ba405cad054$var$ON_OVERFLOW_EXPAND:
                        doubledLimit = 2 * limit;
                        arr = flush();
                        length = arr.length;
                        pushIndex = arr.length;
                        popIndex = 0;
                        arr.length = doubledLimit;
                        limit = doubledLimit;
                        push(it);
                        break;
                    default:
                }
            }
        },
        take: take,
        flush: flush
    };
}
var $43853ba405cad054$export$4368d992c4eafac0 = function none() {
    return $43853ba405cad054$var$zeroBuffer;
};
var $43853ba405cad054$var$fixed = function fixed(limit) {
    return $43853ba405cad054$var$ringBuffer(limit, $43853ba405cad054$var$ON_OVERFLOW_THROW);
};
var $43853ba405cad054$var$dropping = function dropping(limit) {
    return $43853ba405cad054$var$ringBuffer(limit, $43853ba405cad054$var$ON_OVERFLOW_DROP);
};
var $43853ba405cad054$export$db202ddc8be9136 = function sliding(limit) {
    return $43853ba405cad054$var$ringBuffer(limit, $43853ba405cad054$var$ON_OVERFLOW_SLIDE);
};
var $43853ba405cad054$export$8b22cf2602fb60ce = function expanding(initialSize) {
    return $43853ba405cad054$var$ringBuffer(initialSize, $43853ba405cad054$var$ON_OVERFLOW_EXPAND);
};
var $43853ba405cad054$export$3a6d5c9ae78a2c08 = /*#__PURE__*/ Object.freeze({
    none: $43853ba405cad054$export$4368d992c4eafac0,
    fixed: $43853ba405cad054$var$fixed,
    dropping: $43853ba405cad054$var$dropping,
    sliding: $43853ba405cad054$export$db202ddc8be9136,
    expanding: $43853ba405cad054$export$8b22cf2602fb60ce
});
var $43853ba405cad054$export$dda1d9f60106f0e9 = "TAKE";
var $43853ba405cad054$export$23f2a1d2818174ef = "PUT";
var $43853ba405cad054$export$35e795649ee09318 = "ALL";
var $43853ba405cad054$export$342063e11d6c3cad = "RACE";
var $43853ba405cad054$export$882b5998b3b9117c = "CALL";
var $43853ba405cad054$export$953cecd6e717a553 = "CPS";
var $43853ba405cad054$export$7ccc53e8f1e7dfc5 = "FORK";
var $43853ba405cad054$export$ae1af26003f05816 = "JOIN";
var $43853ba405cad054$export$ffb5f4729a158638 = "CANCEL";
var $43853ba405cad054$export$9e5f44173e64f162 = "SELECT";
var $43853ba405cad054$export$43caf9889c228507 = "ACTION_CHANNEL";
var $43853ba405cad054$export$2408f22a0fab9ae5 = "CANCELLED";
var $43853ba405cad054$export$625550452a3fa3ec = "FLUSH";
var $43853ba405cad054$export$3b14a55fb2447963 = "GET_CONTEXT";
var $43853ba405cad054$export$90a7f3efeed30595 = "SET_CONTEXT";
var $43853ba405cad054$export$71cec2538cb2c617 = /*#__PURE__*/ Object.freeze({
    TAKE: $43853ba405cad054$export$dda1d9f60106f0e9,
    PUT: $43853ba405cad054$export$23f2a1d2818174ef,
    ALL: $43853ba405cad054$export$35e795649ee09318,
    RACE: $43853ba405cad054$export$342063e11d6c3cad,
    CALL: $43853ba405cad054$export$882b5998b3b9117c,
    CPS: $43853ba405cad054$export$953cecd6e717a553,
    FORK: $43853ba405cad054$export$7ccc53e8f1e7dfc5,
    JOIN: $43853ba405cad054$export$ae1af26003f05816,
    CANCEL: $43853ba405cad054$export$ffb5f4729a158638,
    SELECT: $43853ba405cad054$export$9e5f44173e64f162,
    ACTION_CHANNEL: $43853ba405cad054$export$43caf9889c228507,
    CANCELLED: $43853ba405cad054$export$2408f22a0fab9ae5,
    FLUSH: $43853ba405cad054$export$625550452a3fa3ec,
    GET_CONTEXT: $43853ba405cad054$export$3b14a55fb2447963,
    SET_CONTEXT: $43853ba405cad054$export$90a7f3efeed30595
});
var $43853ba405cad054$var$TEST_HINT = "\n(HINT: if you are getting this errors in tests, consider using createMockTask from @redux-saga/testing-utils)";
var $43853ba405cad054$var$makeEffect = function makeEffect(type, payload) {
    var _ref;
    return _ref = {}, _ref[0, $fQGsC.IO] = true, _ref.combinator = false, _ref.type = type, _ref.payload = payload, _ref;
};
var $43853ba405cad054$var$isForkEffect = function isForkEffect(eff) {
    return eff && eff[0, $fQGsC.IO] && eff.type === $43853ba405cad054$export$7ccc53e8f1e7dfc5;
};
var $43853ba405cad054$export$e7c866399fa523f5 = function detach(eff) {
    return $43853ba405cad054$var$makeEffect($43853ba405cad054$export$7ccc53e8f1e7dfc5, (0, $ii97e.default)({}, eff.payload, {
        detached: true
    }));
};
function $43853ba405cad054$export$3a1a48c8f6ef640e(patternOrChannel, multicastPattern) {
    if (patternOrChannel === void 0) patternOrChannel = "*";
    if ((0, $f1e9n.pattern)(patternOrChannel)) return $43853ba405cad054$var$makeEffect($43853ba405cad054$export$dda1d9f60106f0e9, {
        pattern: patternOrChannel
    });
    if ((0, $f1e9n.multicast)(patternOrChannel) && (0, $f1e9n.notUndef)(multicastPattern) && (0, $f1e9n.pattern)(multicastPattern)) return $43853ba405cad054$var$makeEffect($43853ba405cad054$export$dda1d9f60106f0e9, {
        channel: patternOrChannel,
        pattern: multicastPattern
    });
    if ((0, $f1e9n.channel)(patternOrChannel)) return $43853ba405cad054$var$makeEffect($43853ba405cad054$export$dda1d9f60106f0e9, {
        channel: patternOrChannel
    });
}
var $43853ba405cad054$export$78acf4525d8a74c4 = function takeMaybe() {
    var eff = $43853ba405cad054$export$3a1a48c8f6ef640e.apply(void 0, arguments);
    eff.payload.maybe = true;
    return eff;
};
function $43853ba405cad054$export$8743009a87fcb00f(channel$$1, action) {
    if ((0, $f1e9n.undef)(action)) {
        action = channel$$1; // `undefined` instead of `null` to make default parameter work
        channel$$1 = undefined;
    }
    return $43853ba405cad054$var$makeEffect($43853ba405cad054$export$23f2a1d2818174ef, {
        channel: channel$$1,
        action: action
    });
}
var $43853ba405cad054$export$dc98b0b04f4c7758 = function putResolve() {
    var eff = $43853ba405cad054$export$8743009a87fcb00f.apply(void 0, arguments);
    eff.payload.resolve = true;
    return eff;
};
function $43853ba405cad054$export$71511d61b312f219(effects) {
    var eff = $43853ba405cad054$var$makeEffect($43853ba405cad054$export$35e795649ee09318, effects);
    eff.combinator = true;
    return eff;
}
function $43853ba405cad054$export$971d5caa766a69d7(effects) {
    var eff = $43853ba405cad054$var$makeEffect($43853ba405cad054$export$342063e11d6c3cad, effects);
    eff.combinator = true;
    return eff;
} // this match getFnCallDescriptor logic
var $43853ba405cad054$var$validateFnDescriptor = function validateFnDescriptor(effectName, fnDescriptor) {
    $43853ba405cad054$export$db3b6bfb95261072(fnDescriptor, (0, $f1e9n.notUndef), effectName + ": argument fn is undefined or null");
    if ((0, $f1e9n.func)(fnDescriptor)) return;
    var context = null;
    var fn;
    if ((0, $f1e9n.array)(fnDescriptor)) {
        context = fnDescriptor[0];
        fn = fnDescriptor[1];
        $43853ba405cad054$export$db3b6bfb95261072(fn, (0, $f1e9n.notUndef), effectName + ": argument of type [context, fn] has undefined or null `fn`");
    } else if ((0, $f1e9n.object)(fnDescriptor)) {
        context = fnDescriptor.context;
        fn = fnDescriptor.fn;
        $43853ba405cad054$export$db3b6bfb95261072(fn, (0, $f1e9n.notUndef), effectName + ": argument of type {context, fn} has undefined or null `fn`");
    } else {
        $43853ba405cad054$export$db3b6bfb95261072(fnDescriptor, (0, $f1e9n.func), effectName + ": argument fn is not function");
        return;
    }
    if (context && (0, $f1e9n.string)(fn)) {
        $43853ba405cad054$export$db3b6bfb95261072(context[fn], (0, $f1e9n.func), effectName + ': context arguments has no such method - "' + fn + '"');
        return;
    }
    $43853ba405cad054$export$db3b6bfb95261072(fn, (0, $f1e9n.func), effectName + ": unpacked fn argument (from [context, fn] or {context, fn}) is not a function");
};
function $43853ba405cad054$var$getFnCallDescriptor(fnDescriptor, args) {
    var context = null;
    var fn;
    if ((0, $f1e9n.func)(fnDescriptor)) fn = fnDescriptor;
    else {
        if ((0, $f1e9n.array)(fnDescriptor)) {
            context = fnDescriptor[0];
            fn = fnDescriptor[1];
        } else {
            context = fnDescriptor.context;
            fn = fnDescriptor.fn;
        }
        if (context && (0, $f1e9n.string)(fn) && (0, $f1e9n.func)(context[fn])) fn = context[fn];
    }
    return {
        context: context,
        fn: fn,
        args: args
    };
}
var $43853ba405cad054$var$isNotDelayEffect = function isNotDelayEffect(fn) {
    return fn !== $43853ba405cad054$export$25ce5a424b770e84;
};
function $43853ba405cad054$export$56c0d5a1e737357d(fnDescriptor) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    return $43853ba405cad054$var$makeEffect($43853ba405cad054$export$882b5998b3b9117c, $43853ba405cad054$var$getFnCallDescriptor(fnDescriptor, args));
}
function $43853ba405cad054$export$3d8c2f653ac9d0b9(context, fn, args) {
    if (args === void 0) args = [];
    var fnDescriptor = [
        context,
        fn
    ];
    return $43853ba405cad054$var$makeEffect($43853ba405cad054$export$882b5998b3b9117c, $43853ba405cad054$var$getFnCallDescriptor([
        context,
        fn
    ], args));
}
function $43853ba405cad054$export$34aec0b863436764(fnDescriptor) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    return $43853ba405cad054$var$makeEffect($43853ba405cad054$export$953cecd6e717a553, $43853ba405cad054$var$getFnCallDescriptor(fnDescriptor, args));
}
function $43853ba405cad054$export$a07804094c3ecf2d(fnDescriptor) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $43853ba405cad054$var$makeEffect($43853ba405cad054$export$7ccc53e8f1e7dfc5, $43853ba405cad054$var$getFnCallDescriptor(fnDescriptor, args));
}
function $43853ba405cad054$export$3c2fa207a37baaea(fnDescriptor) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    return $43853ba405cad054$export$e7c866399fa523f5($43853ba405cad054$export$a07804094c3ecf2d.apply(void 0, [
        fnDescriptor
    ].concat(args)));
}
function $43853ba405cad054$export$ce26c07117d59d6a(taskOrTasks) {
    return $43853ba405cad054$var$makeEffect($43853ba405cad054$export$ae1af26003f05816, taskOrTasks);
}
function $43853ba405cad054$export$c4ce752e73470fba(taskOrTasks) {
    if (taskOrTasks === void 0) taskOrTasks = (0, $fQGsC.SELF_CANCELLATION);
    return $43853ba405cad054$var$makeEffect($43853ba405cad054$export$ffb5f4729a158638, taskOrTasks);
}
function $43853ba405cad054$export$6559d589eb85fbb6(selector) {
    if (selector === void 0) selector = $43853ba405cad054$export$61196ced6d74a310;
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $43853ba405cad054$var$makeEffect($43853ba405cad054$export$9e5f44173e64f162, {
        selector: selector,
        args: args
    });
}
/**
  channel(pattern, [buffer])    => creates a proxy channel for store actions
**/ function $43853ba405cad054$export$3722cfe417b6ed86(pattern$$1, buffer$$1) {
    return $43853ba405cad054$var$makeEffect($43853ba405cad054$export$43caf9889c228507, {
        pattern: pattern$$1,
        buffer: buffer$$1
    });
}
function $43853ba405cad054$export$efca4cbe5dd06740() {
    return $43853ba405cad054$var$makeEffect($43853ba405cad054$export$2408f22a0fab9ae5, {});
}
function $43853ba405cad054$export$a8550f7dbe79f93a(channel$$1) {
    return $43853ba405cad054$var$makeEffect($43853ba405cad054$export$625550452a3fa3ec, channel$$1);
}
function $43853ba405cad054$export$2e2af4578d910ddf(prop) {
    return $43853ba405cad054$var$makeEffect($43853ba405cad054$export$3b14a55fb2447963, prop);
}
function $43853ba405cad054$export$a93c5207d687da10(props) {
    return $43853ba405cad054$var$makeEffect($43853ba405cad054$export$90a7f3efeed30595, props);
}
var $43853ba405cad054$export$25ce5a424b770e84 = /*#__PURE__*/ $43853ba405cad054$export$56c0d5a1e737357d.bind(null, (0, $7v88c.default));

});
parcelRegister("7v88c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5761bc59552cdc09$export$2e2bcd8739ae039; });

var $fQGsC = parcelRequire("fQGsC");
function $5761bc59552cdc09$var$delayP(ms, val) {
    if (val === void 0) val = true;
    var timeoutId;
    var promise = new Promise(function(resolve) {
        timeoutId = setTimeout(resolve, ms, val);
    });
    promise[0, $fQGsC.CANCEL] = function() {
        clearTimeout(timeoutId);
    };
    return promise;
}
var $5761bc59552cdc09$export$2e2bcd8739ae039 = $5761bc59552cdc09$var$delayP;

});




parcelRegister("e9n2v", function(module, exports) {
$parcel$export(module.exports, "AfterScriptCommand", function () { return (parcelRequire("ienSH")).AfterScriptCommand; });
$parcel$export(module.exports, "Command", function () { return (parcelRequire("ienSH")).Command; });
$parcel$export(module.exports, "CommandToggleOption", function () { return (parcelRequire("ienSH")).CommandToggleOption; });
$parcel$export(module.exports, "ExecutionPhase", function () { return (parcelRequire("ienSH")).ExecutionPhase; });
$parcel$export(module.exports, "LogRange", function () { return (parcelRequire("ienSH")).LogRange; });
$parcel$export(module.exports, "RunnerDetailsCommand", function () { return (parcelRequire("ienSH")).RunnerDetailsCommand; });
$parcel$export(module.exports, "ScriptCommand", function () { return (parcelRequire("ienSH")).ScriptCommand; });
$parcel$export(module.exports, "SetupCommand", function () { return (parcelRequire("ienSH")).SetupCommand; });
$parcel$export(module.exports, "TeardownCommand", function () { return (parcelRequire("ienSH")).TeardownCommand; });
$parcel$export(module.exports, "LogRequestType", function () { return (parcelRequire("iB5Tp")).LogRequestType; });
$parcel$export(module.exports, "Step", function () { return (parcelRequire("gPp1Y")).Step; });
$parcel$export(module.exports, "StepStatus", function () { return (parcelRequire("gPp1Y")).StepStatus; });
$parcel$export(module.exports, "TestCase", function () { return (parcelRequire("e8xZi")).TestCase; });
$parcel$export(module.exports, "TestCaseReason", function () { return (parcelRequire("e8xZi")).TestCaseReason; });
$parcel$export(module.exports, "TestCaseReasonError", function () { return (parcelRequire("e8xZi")).TestCaseReasonError; });

$parcel$export(module.exports, "Account", function () { return (parcelRequire("bAYsY")).Account; });
$parcel$export(module.exports, "Allowance", function () { return (parcelRequire("lB68V")).Allowance; });
$parcel$export(module.exports, "Annotation", function () { return (parcelRequire("4nYUB")).Annotation; });
$parcel$export(module.exports, "Artifact", function () { return (parcelRequire("arCf2")).Artifact; });
$parcel$export(module.exports, "Branch", function () { return (parcelRequire("k412P")).Branch; });
$parcel$export(module.exports, "BuildConfiguration", function () { return (parcelRequire("04RLv")).BuildConfiguration; });
$parcel$export(module.exports, "Capabilities", function () { return (parcelRequire("3ikki")).Capabilities; });
$parcel$export(module.exports, "Cache", function () { return (parcelRequire("elUoI")).Cache; });
$parcel$export(module.exports, "CacheVersion", function () { return (parcelRequire("elUoI")).CacheVersion; });
$parcel$export(module.exports, "Commit", function () { return (parcelRequire("4EUxB")).Commit; });
$parcel$export(module.exports, "Checks", function () { return (parcelRequire("faK9I")).Checks; });
$parcel$export(module.exports, "CheckRun", function () { return (parcelRequire("faK9I")).CheckRun; });
$parcel$export(module.exports, "CheckSuite", function () { return (parcelRequire("faK9I")).CheckSuite; });
$parcel$export(module.exports, "Deployment", function () { return (parcelRequire("goDEr")).Deployment; });
$parcel$export(module.exports, "Environment", function () { return (parcelRequire("eRckJ")).Environment; });
$parcel$export(module.exports, "Issue", function () { return (parcelRequire("his0q")).Issue; });
$parcel$export(module.exports, "KeyPair", function () { return (parcelRequire("a63fp")).KeyPair; });
$parcel$export(module.exports, "KnownHost", function () { return (parcelRequire("j15SL")).KnownHost; });
$parcel$export(module.exports, "Metric", function () { return (parcelRequire("7tNBI")).Metric; });
$parcel$export(module.exports, "OfficialTemplate", function () { return (parcelRequire("7gE4v")).OfficialTemplate; });
$parcel$export(module.exports, "Pipeline", function () { return (parcelRequire("gB1lx")).Pipeline; });
$parcel$export(module.exports, "PipelineDefinition", function () { return (parcelRequire("h5CwE")).PipelineDefinition; });
$parcel$export(module.exports, "PipelineError", function () { return (parcelRequire("2Od6r")).PipelineError; });
$parcel$export(module.exports, "PublicKey", function () { return (parcelRequire("25ELF")).PublicKey; });
$parcel$export(module.exports, "PullRequest", function () { return (parcelRequire("f7wkq")).PullRequest; });
$parcel$export(module.exports, "HaltedReason", function () { return (parcelRequire("l188y")).HaltedReason; });
$parcel$export(module.exports, "Repository", function () { return (parcelRequire("6WfB6")).Repository; });
$parcel$export(module.exports, "RepositoryAssociationSummary", function () { return (parcelRequire("9NSQN")).RepositoryAssociationSummary; });
$parcel$export(module.exports, "Report", function () { return (parcelRequire("akm6L")).Report; });
$parcel$export(module.exports, "Runner", function () { return (parcelRequire("4FRgq")).Runner; });
$parcel$export(module.exports, "Schedule", function () { return (parcelRequire("d0InP")).Schedule; });
$parcel$export(module.exports, "Tasks", function () { return (parcelRequire("xJcp7")).Tasks; });
$parcel$export(module.exports, "SearchLog", function () { return (parcelRequire("8qMkI")).SearchLog; });
$parcel$export(module.exports, "Stage", function () { return (parcelRequire("k2NX9")).Stage; });
$parcel$export(module.exports, "StepGroup", function () { return (parcelRequire("hwD0l")).StepGroup; });
$parcel$export(module.exports, "StepGroupType", function () { return (parcelRequire("hwD0l")).StepGroupType; });
$parcel$export(module.exports, "User", function () { return (parcelRequire("7Re2y")).User; });
$parcel$export(module.exports, "Validator", function () { return (parcelRequire("6vGsr")).Validator; });
$parcel$export(module.exports, "EditorEnum", function () { return (parcelRequire("6vGsr")).EditorEnum; });
$parcel$export(module.exports, "Variable", function () { return (parcelRequire("iUiPN")).Variable; });
$parcel$export(module.exports, "SYSTEM_LABELS", function () { return (parcelRequire("4FRgq")).SYSTEM_LABELS; });
$parcel$export(module.exports, "SELF_HOSTED_LABEL", function () { return (parcelRequire("4FRgq")).SELF_HOSTED_LABEL; });
$parcel$export(module.exports, "RUNNER_LABEL_REGEXP", function () { return (parcelRequire("4FRgq")).RUNNER_LABEL_REGEXP; });
$parcel$export(module.exports, "RESERVED_NAMESPACE_REGEXP", function () { return (parcelRequire("4FRgq")).RESERVED_NAMESPACE_REGEXP; });
$parcel$export(module.exports, "MAX_LENGTH_OF_LABEL", function () { return (parcelRequire("4FRgq")).MAX_LENGTH_OF_LABEL; });
$parcel$export(module.exports, "MAX_NUMBER_OF_CUSTOM_LABELS", function () { return (parcelRequire("4FRgq")).MAX_NUMBER_OF_CUSTOM_LABELS; });

var $bAYsY = parcelRequire("bAYsY");

var $lB68V = parcelRequire("lB68V");

var $4nYUB = parcelRequire("4nYUB");

var $arCf2 = parcelRequire("arCf2");

var $jNVLF = parcelRequire("jNVLF");

var $k412P = parcelRequire("k412P");

var $04RLv = parcelRequire("04RLv");

var $3ikki = parcelRequire("3ikki");

var $elUoI = parcelRequire("elUoI");

var $4EUxB = parcelRequire("4EUxB");

var $faK9I = parcelRequire("faK9I");

var $4C3IP = parcelRequire("4C3IP");

var $goDEr = parcelRequire("goDEr");

var $fAdbN = parcelRequire("fAdbN");

var $eRckJ = parcelRequire("eRckJ");

var $his0q = parcelRequire("his0q");

var $a63fp = parcelRequire("a63fp");

var $j15SL = parcelRequire("j15SL");

var $7tNBI = parcelRequire("7tNBI");

var $G9jLU = parcelRequire("G9jLU");

var $7gE4v = parcelRequire("7gE4v");

var $gB1lx = parcelRequire("gB1lx");
parcelRequire("kSxPl");

var $h5CwE = parcelRequire("h5CwE");

var $2Od6r = parcelRequire("2Od6r");

var $dfUfA = parcelRequire("dfUfA");

var $25ELF = parcelRequire("25ELF");

var $f7wkq = parcelRequire("f7wkq");

var $gHCUN = parcelRequire("gHCUN");

var $l188y = parcelRequire("l188y");

var $buhnP = parcelRequire("buhnP");

var $6WfB6 = parcelRequire("6WfB6");

var $9NSQN = parcelRequire("9NSQN");

var $akm6L = parcelRequire("akm6L");

var $f1t5L = parcelRequire("f1t5L");

var $4FRgq = parcelRequire("4FRgq");

var $d0InP = parcelRequire("d0InP");
parcelRequire("ienSH");
parcelRequire("iB5Tp");

var $xJcp7 = parcelRequire("xJcp7");

var $eejIt = parcelRequire("eejIt");

var $8qMkI = parcelRequire("8qMkI");
parcelRequire("gPp1Y");
parcelRequire("1Lyl8");
parcelRequire("h88sh");

var $k2NX9 = parcelRequire("k2NX9");
parcelRequire("e8xZi");

var $hwD0l = parcelRequire("hwD0l");

var $7Re2y = parcelRequire("7Re2y");

var $6vGsr = parcelRequire("6vGsr");

var $iUiPN = parcelRequire("iUiPN");

});
parcelRegister("bAYsY", function(module, exports) {

$parcel$export(module.exports, "Account", function () { return $ca7f957f8811bb2a$export$1ed4b10e4aba04a7; });

var $gC76L = parcelRequire("gC76L");
class $ca7f957f8811bb2a$export$1ed4b10e4aba04a7 extends (0, $gC76L.ModelBase) {
    constructor(props = {}){
        super(props);
        this.uuid = "";
        this.addonKey = "";
        this.userUuid = "";
        this.accountId = "";
        this.userEmail = "";
        this.userHas2FaEnabled = false;
        this.hasFetchedUser = false;
        this.name = "";
        this.avatarSrc = "";
        Object.assign(this, props);
        Object.freeze(this);
    }
}

});
parcelRegister("gC76L", function(module, exports) {

$parcel$export(module.exports, "ModelBase", function () { return $1a1bba1d58adc3e3$export$517322bf62bf0607; });
class $1a1bba1d58adc3e3$export$517322bf62bf0607 {
    constructor(props = {}){
        this.props = {};
        Object.assign(this, {
            props: props
        });
    }
    toJS() {
        return this.props;
    }
}

});


parcelRegister("lB68V", function(module, exports) {

$parcel$export(module.exports, "Allowance", function () { return $b6e8384957c6e8d9$export$322bbe27bf813045; });

var $gC76L = parcelRequire("gC76L");
class $b6e8384957c6e8d9$export$322bbe27bf813045 extends (0, $gC76L.ModelBase) {
    constructor(props = {}){
        super(props);
        this.startDate = "";
        this.endDate = "";
        this.totalUsage = -1;
        this.quota = -1;
        this.percentageUsed = -1;
        this.hasFetched = false;
        this.hasPermissionToView = false;
        this.isTrusted = true;
        this.isErrored = false;
        Object.assign(this, props);
        Object.freeze(this);
    }
}

});

parcelRegister("4nYUB", function(module, exports) {

$parcel$export(module.exports, "Annotation", function () { return $3a99a6bf25d4f274$export$9279461326b8700a; });

var $gC76L = parcelRequire("gC76L");
var $3a99a6bf25d4f274$export$f50c3066a53a6f2c;
(function(AnnotationType) {
    AnnotationType["Vulnerability"] = "VULNERABILITY";
    AnnotationType["CodeSmell"] = "CODE_SMELL";
    AnnotationType["Bug"] = "BUG";
    AnnotationType["Unknown"] = "UNKNOWN";
})($3a99a6bf25d4f274$export$f50c3066a53a6f2c || ($3a99a6bf25d4f274$export$f50c3066a53a6f2c = {}));
var $3a99a6bf25d4f274$export$eaa77df703962b4;
(function(AnnotationResult) {
    AnnotationResult["Passed"] = "PASSED";
    AnnotationResult["Failed"] = "FAILED";
    AnnotationResult["Skipped"] = "SKIPPED";
    AnnotationResult["Ignored"] = "IGNORED";
    AnnotationResult["Unknown"] = "UNKNOWN";
})($3a99a6bf25d4f274$export$eaa77df703962b4 || ($3a99a6bf25d4f274$export$eaa77df703962b4 = {}));
var $3a99a6bf25d4f274$export$189ec91da9a6b59d;
(function(AnnotationSeverity) {
    AnnotationSeverity["Low"] = "LOW";
    AnnotationSeverity["Medium"] = "MEDIUM";
    AnnotationSeverity["High"] = "HIGH";
    AnnotationSeverity["Critical"] = "CRITICAL";
    AnnotationSeverity["Unknown"] = "UNKNOWN";
})($3a99a6bf25d4f274$export$189ec91da9a6b59d || ($3a99a6bf25d4f274$export$189ec91da9a6b59d = {}));
class $3a99a6bf25d4f274$export$9279461326b8700a extends (0, $gC76L.ModelBase) {
    constructor(props = {}){
        super(props);
        this.uuid = "";
        this.annotation_type = null;
        this.type = "";
        this.external_id = "";
        this.summary = "";
        this.details = "";
        this.path = "";
        this.line = -1;
        this.result = null;
        this.severity = null;
        this.link = "";
        this.created_on = "";
        this.updated_on = "";
        Object.assign(this, props);
        Object.freeze(this);
    }
}

});

parcelRegister("arCf2", function(module, exports) {

$parcel$export(module.exports, "Artifact", function () { return $dc461781c5199256$export$f509bf4c05b38d1a; });
var $dc461781c5199256$export$d5f3ec63cad061d9;
(function(StorageType) {
    StorageType["Media"] = "MEDIA";
    StorageType["S3"] = "S3";
    StorageType["External"] = "EXTERNAL";
})($dc461781c5199256$export$d5f3ec63cad061d9 || ($dc461781c5199256$export$d5f3ec63cad061d9 = {}));
class $dc461781c5199256$export$f509bf4c05b38d1a {
    constructor(props = {}){
        this.artifact_content_url = "";
        this.created_on = "";
        this.file_size_bytes = 0;
        this.path = "";
        this.step_uuid = "";
        this.uuid = "";
        this.storageType = null;
        Object.assign(this, props);
        Object.freeze(this);
    }
    get isExternalStorage() {
        return this.storageType === "EXTERNAL";
    }
}

});

parcelRegister("jNVLF", function(module, exports) {
class $46ff16d17a621631$export$da423d5c8ff19e85 {
    constructor(props = {}){
        this.body = "";
        this.title = "";
        this.type = "normal";
        this.actions = void 0;
        Object.assign(this, props);
        Object.freeze(this);
    }
}

});

parcelRegister("k412P", function(module, exports) {

$parcel$export(module.exports, "Branch", function () { return $2fc7126652fca58d$export$aecb2ddcb55c95be; });
class $2fc7126652fca58d$export$b2e089eb3692b073 {
    constructor(props = {}){
        this.commits = "";
        this.html = "";
        this.self = "";
        Object.assign(this, props);
        Object.freeze(this);
    }
}
class $2fc7126652fca58d$export$aecb2ddcb55c95be {
    constructor(props = {}){
        this.default_merge_strategy = "";
        this.links = new $2fc7126652fca58d$export$b2e089eb3692b073();
        this.merge_strategies = [];
        this.name = "";
        this.type = "";
        this.target = void 0;
        Object.assign(this, {
            ...props,
            links: new $2fc7126652fca58d$export$b2e089eb3692b073(props.links)
        });
        Object.freeze(this);
    }
}
class $2fc7126652fca58d$export$bec84148410bc670 {
    constructor(props = {}){
        var _props$list;
        this.list = [];
        this.page = 0;
        Object.assign(this, {
            ...props,
            list: (_props$list = props.list) === null || _props$list === void 0 ? void 0 : _props$list.map((branch)=>new $2fc7126652fca58d$export$aecb2ddcb55c95be(branch))
        });
        Object.freeze(this);
    }
}

});

parcelRegister("04RLv", function(module, exports) {

$parcel$export(module.exports, "BuildConfiguration", function () { return $05f6c267257379d5$export$aebca2b586201079; });

var $gC76L = parcelRequire("gC76L");
class $05f6c267257379d5$export$aebca2b586201079 extends (0, $gC76L.ModelBase) {
    constructor(props = {}){
        super(props);
        this.hasFetchedRawYmlFile = false;
        this.hasYmlFile = true;
        this.isCommiting = false;
        this.isCommitingError = null;
        this.matchingLineNumber = 1;
        this.yml = "";
        Object.assign(this, props);
        Object.freeze(this);
    }
}

});

parcelRegister("3ikki", function(module, exports) {

$parcel$export(module.exports, "Capabilities", function () { return $5fe0d93829c09ee5$export$991fe453de1a0a4c; });

var $gC76L = parcelRequire("gC76L");
const $5fe0d93829c09ee5$export$1bc78a811a8e4287 = 10;
const $5fe0d93829c09ee5$export$a61c090f7bba737f = 50;
class $5fe0d93829c09ee5$export$991fe453de1a0a4c extends (0, $gC76L.ModelBase) {
    constructor(props = {}){
        super(props);
        this.hasFetchedCapabilities = false;
        this.fetchCapabilitiesFailed = false;
        this.fetchCapabilitiesError = null;
        this.pipelinesEnabled = false;
        this.pipelinesEnabledError = null;
        this.allowancePercentageUsed = 0;
        this.hasMinutesLeft = false;
        this.limited = false;
        this.isPremium = false;
        this.isPaid = false;
        Object.assign(this, props);
        Object.freeze(this);
    }
    get isPaidOrPremium() {
        return this.isPaid || this.isPremium;
    }
    get allowedEnvironments() {
        return this.isPaidOrPremium ? $5fe0d93829c09ee5$export$a61c090f7bba737f : $5fe0d93829c09ee5$export$1bc78a811a8e4287;
    }
}

});

parcelRegister("elUoI", function(module, exports) {

$parcel$export(module.exports, "CacheVersion", function () { return $7a880bd10ed552f7$export$8989a45e501d4492; });
$parcel$export(module.exports, "Cache", function () { return $7a880bd10ed552f7$export$94affb487e701bf2; });
class $7a880bd10ed552f7$export$8989a45e501d4492 {
    constructor(props = {}){
        this.uuid = "";
        this.file_size_bytes = 0;
        this.created_on = "";
        this.key_hash = "";
        Object.assign(this, props);
        Object.freeze(this);
    }
}
class $7a880bd10ed552f7$export$94affb487e701bf2 {
    constructor(props = {}){
        this.name = "";
        this.path = "";
        this.pipeline_uuid = "";
        this.versions = [];
        Object.assign(this, props);
        Object.freeze(this);
    }
}

});

parcelRegister("4EUxB", function(module, exports) {

$parcel$export(module.exports, "Commit", function () { return $d4bee9fffe3274f4$export$1c786c7361c2bcb9; });

var $kOiOG = parcelRequire("kOiOG");

var $fb7JV = parcelRequire("fb7JV");

var $7Re2y = parcelRequire("7Re2y");
class $d4bee9fffe3274f4$export$1c786c7361c2bcb9 {
    // flattened props
    constructor(props = {}){
        this.author = undefined;
        this.parents = undefined;
        this.summary = undefined;
        this.date = "";
        this.hash = "";
        this.message = "";
        this["author.user"] = new (0, $7Re2y.User)();
        this["links.html.href"] = "";
        this["links.self.href"] = "";
        this["parents.0.hash"] = "";
        this["summary.html"] = "";
        Object.assign(this, {
            ...(0, $fb7JV.pick)((0, $kOiOG.flatten)(props), Object.keys(this)),
            ...props.author && props.author.user ? {
                "author.user": new (0, $7Re2y.User)(props.author.user)
            } : {}
        });
        Object.freeze(this);
    }
    get shortHash() {
        return this.hash.substr(0, 7);
    }
    get parentHash() {
        return this["parents.0.hash"];
    }
    get url() {
        return this["links.html.href"];
    }
}

});
parcelRegister("kOiOG", function(module, exports) {

$parcel$export(module.exports, "flatten", function () { return $9b91534c81f52852$export$bffa455ba8c619a6; });
function $9b91534c81f52852$export$bffa455ba8c619a6(ob, prefix = false, res = null) {
    const result = res || {};
    if (prefix && typeof ob === "object" && ob !== null && Object.keys(ob).length === 0) {
        result[prefix] = Array.isArray(ob) ? [] : {};
        return result;
    }
    const prefixValue = prefix ? `${prefix}.` : "";
    for(const i in ob)if (Object.prototype.hasOwnProperty.call(ob, i)) {
        if (typeof ob[i] === "object" && ob[i] !== null) $9b91534c81f52852$export$bffa455ba8c619a6(ob[i], prefixValue + i, result);
        else result[prefixValue + i] = ob[i];
    }
    return result;
}
function $9b91534c81f52852$export$4315a2af848d75d7(ob) {
    const result = {};
    for(const i in ob)if (Object.prototype.hasOwnProperty.call(ob, i)) {
        const keys = i.match(/^\.+[^.]*|[^.]*\.+$|(?:\.{2,}|[^.])+(?:\.+$)?/g);
        if (keys) keys.reduce((r, e, j)=>{
            const value = r[e];
            if (value) return value;
            else {
                const newValue = isNaN(Number(keys[j + 1])) ? keys.length - 1 === j ? ob[i] : {} : [];
                r[e] = newValue;
                return newValue;
            }
        }, result);
    }
    return result;
}

});

parcelRegister("fb7JV", function(module, exports) {

$parcel$export(module.exports, "pick", function () { return $d7ba40a5deabd6f7$export$357523c63a2253b9; });
// https://www.30secondsofcode.org/js/s/pick
const $d7ba40a5deabd6f7$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>{
        if (curr in obj) acc[curr] = obj[curr];
        return acc;
    }, {});

});

parcelRegister("7Re2y", function(module, exports) {

$parcel$export(module.exports, "User", function () { return $57a86344baf37abc$export$1f44aaf2ec115b54; });

var $kOiOG = parcelRequire("kOiOG");

var $fb7JV = parcelRequire("fb7JV");
class $57a86344baf37abc$export$1f44aaf2ec115b54 {
    constructor(props = {}){
        this.class_type = "User";
        this["links.avatar.href"] = "";
        this["links.html.href"] = "";
        this["links.self.href"] = "";
        this.display_name = "";
        this.username = "";
        this.links = undefined;
        this.uuid = "";
        this.has_2fa_enabled = false;
        Object.assign(this, {
            ...(0, $fb7JV.pick)((0, $kOiOG.flatten)(props), Object.keys(this))
        });
        Object.freeze(this);
    }
    get avatarUrl() {
        return this["links.avatar.href"];
    }
    get accountUrl() {
        return this["links.html.href"];
    }
    get displayName() {
        return this.display_name;
    }
    get has2FaEnabled() {
        return this.has_2fa_enabled;
    }
}

});


parcelRegister("faK9I", function(module, exports) {

$parcel$export(module.exports, "CheckRun", function () { return $50fb15344b5a31ed$export$be926807b95bf0d0; });
$parcel$export(module.exports, "CheckSuite", function () { return $50fb15344b5a31ed$export$3f0706d3b0531ee6; });
$parcel$export(module.exports, "Checks", function () { return $50fb15344b5a31ed$export$e9b38990dca3b63b; });

var $kOiOG = parcelRequire("kOiOG");

var $fb7JV = parcelRequire("fb7JV");

var $gC76L = parcelRequire("gC76L");
class $50fb15344b5a31ed$export$be926807b95bf0d0 extends (0, $gC76L.ModelBase) {
    // flattened properties
    constructor(props = {}){
        super(props);
        this.uuid = "";
        this.commit_hash = "";
        this.check_run_type = "";
        this.check_suite = {};
        this.url = {};
        this["check_suite.uuid"] = "";
        this["url.text"] = "";
        this["url.href"] = "";
        Object.assign(this, {
            ...(0, $fb7JV.pick)((0, $kOiOG.flatten)(props), Object.keys(this))
        });
        Object.freeze(this);
    }
    get isJsdGatingCheckRun() {
        return this.check_run_type === "JSD_CHANGE_GATING";
    }
}
class $50fb15344b5a31ed$export$3f0706d3b0531ee6 extends (0, $gC76L.ModelBase) {
    // flattened properties
    constructor(props = {}){
        super(props);
        this.uuid = "";
        this.check_runs = [];
        this.triggerer = {};
        this["triggerer.type"] = "";
        this["triggerer.uuid"] = "";
        Object.assign(this, {
            ...(0, $fb7JV.pick)((0, $kOiOG.flatten)(props), Object.keys(this)),
            check_runs: props.check_runs // preserve array
        });
        Object.freeze(this);
    }
    get isDeploymentCheckSuite() {
        return this["triggerer.type"] === "DEPLOYMENT";
    }
}
class $50fb15344b5a31ed$export$e9b38990dca3b63b extends (0, $gC76L.ModelBase) {
    constructor(props = {}){
        super(props);
        this.check_runs = {};
        this.check_suites = {};
        if (Object.values(props).length === 0) Object.assign(this, props);
        else {
            const check_runs = Object.keys(props.check_runs || {}).reduce((runs, key)=>{
                var _props$check_runs;
                runs[key] = new $50fb15344b5a31ed$export$be926807b95bf0d0((_props$check_runs = props.check_runs) === null || _props$check_runs === void 0 ? void 0 : _props$check_runs[key]);
                return runs;
            }, {});
            const check_suites = Object.keys(props.check_suites || {}).reduce((runs, key)=>{
                var _props$check_suites;
                runs[key] = new $50fb15344b5a31ed$export$3f0706d3b0531ee6((_props$check_suites = props.check_suites) === null || _props$check_suites === void 0 ? void 0 : _props$check_suites[key]);
                return runs;
            }, {});
            Object.assign(this, {
                check_runs: check_runs,
                check_suites: check_suites
            });
        }
        Object.freeze(this);
    }
    get deploymentCheckSuites() {
        return Object.values(this.check_suites).filter((checkSuite)=>!!(checkSuite !== null && checkSuite !== void 0 && checkSuite.isDeploymentCheckSuite));
    }
    get jsdGatingCheckRuns() {
        return Object.values(this.check_runs).filter((checkRun)=>!!(checkRun !== null && checkRun !== void 0 && checkRun.isJsdGatingCheckRun));
    }
}

});

parcelRegister("4C3IP", function(module, exports) {

$parcel$export(module.exports, "Deployable", function () { return $cffae55e23e96209$export$e888bfdffd763607; });

var $kOiOG = parcelRequire("kOiOG");

var $fb7JV = parcelRequire("fb7JV");

var $4EUxB = parcelRequire("4EUxB");
class $cffae55e23e96209$export$e888bfdffd763607 {
    constructor(props = {}){
        this.class_type = "Deployable";
        this.commit = new (0, $4EUxB.Commit)();
        this.created_on = "";
        this.key = "";
        this.name = "";
        this.url = "";
        this.uuid = "";
        Object.assign(this, {
            ...(0, $fb7JV.pick)((0, $kOiOG.flatten)(props), Object.keys(this)),
            commit: new (0, $4EUxB.Commit)(props.commit)
        });
        Object.freeze(this);
    }
}

});

parcelRegister("goDEr", function(module, exports) {

$parcel$export(module.exports, "Deployment", function () { return $5ea6d0c3f9f93620$export$4c71438264bb2277; });
/* eslint-disable @typescript-eslint/no-use-before-define */ 
var $kOiOG = parcelRequire("kOiOG");

var $fb7JV = parcelRequire("fb7JV");

var $4C3IP = parcelRequire("4C3IP");

var $gPp1Y = parcelRequire("gPp1Y");

var $7Re2y = parcelRequire("7Re2y");
const $5ea6d0c3f9f93620$var$DeploymentStatus = {
    "": {
        icon: "",
        text: "",
        lozengeAppearance: "default"
    },
    FAILED: {
        icon: "failed",
        text: "Failed",
        lozengeAppearance: "removed"
    },
    IN_PROGRESS: {
        icon: "building",
        text: "In progress",
        lozengeAppearance: "inprogress"
    },
    STOPPED: {
        icon: "stopped",
        text: "Stopped",
        lozengeAppearance: "moved"
    },
    PAUSED: {
        icon: "paused",
        text: "Paused",
        lozengeAppearance: "success"
    },
    SUCCESSFUL: {
        icon: "success",
        text: "Successful",
        lozengeAppearance: "success"
    },
    REDEPLOY: {
        icon: "redeploy",
        text: "Redeployment",
        lozengeAppearance: "success"
    },
    FAILED_REDEPLOY: {
        icon: "failedRedeploy",
        text: "Failed redeployment",
        lozengeAppearance: "removed"
    },
    RERUN: {
        icon: "rerun",
        text: "Rerun",
        lozengeAppearance: "success"
    },
    UNDEPLOYED: {
        icon: "success",
        text: "Undeployed",
        lozengeAppearance: "default"
    }
};
class $5ea6d0c3f9f93620$export$a12a01ce2571070a {
    // circular dep
    // flattened props
    constructor(props = {}){
        this.class_type = "DeploymentState";
        this.completed_on = "";
        this.deployer = new (0, $7Re2y.User)();
        this.last_successful_deployment = null;
        this.name = "";
        this.started_on = "";
        this.status = "";
        this.triggerUrl = "";
        this.url = "";
        this.step = new (0, $gPp1Y.Step)();
        this["status.name"] = "";
        Object.assign(this, {
            ...(0, $fb7JV.pick)((0, $kOiOG.flatten)(props), Object.keys(this)),
            step: new (0, $gPp1Y.Step)(props.step),
            deployer: props.deployer ? new (0, $7Re2y.User)(props.deployer) : null,
            last_successful_deployment: props.last_successful_deployment ? new $5ea6d0c3f9f93620$export$4c71438264bb2277(props.last_successful_deployment) : null
        });
        Object.freeze(this);
    }
    get statusIcon() {
        return $5ea6d0c3f9f93620$var$DeploymentStatus[this.parsedStatus].icon;
    }
    get statusText() {
        return $5ea6d0c3f9f93620$var$DeploymentStatus[this.parsedStatus].text;
    }
    get statusLozengeAppearance() {
        return $5ea6d0c3f9f93620$var$DeploymentStatus[this.parsedStatus].lozengeAppearance;
    }
    get parsedStatus() {
        const stateName = this.name;
        const statusName = this["status.name"] || this.status;
        let statusType = "";
        if (stateName === "PENDING") {
            if (statusName === "PARTIAL_FAILED") statusType = "FAILED";
            else if (statusName === "PARTIAL_STOPPED") statusType = "STOPPED";
            else if (statusName === "PARTIAL_PAUSED") statusType = "PAUSED";
            else statusType = "UNDEPLOYED";
        } else if (stateName === "UNDEPLOYED") statusType = "UNDEPLOYED";
        else if (stateName === "IN_PROGRESS") statusType = "IN_PROGRESS";
        else if (stateName === "COMPLETED") {
            var _this$step, _this$step3, _this$step4;
            if ([
                "SUCCESSFUL",
                "FAILED",
                "STOPPED"
            ].includes(statusName)) statusType = statusName;
            if ((_this$step = this.step) !== null && _this$step !== void 0 && _this$step.isRedeploy) {
                var _this$step2;
                statusType = (_this$step2 = this.step) !== null && _this$step2 !== void 0 && _this$step2.isSuccessful ? "REDEPLOY" : "FAILED_REDEPLOY";
            } else if (Number((_this$step3 = this.step) === null || _this$step3 === void 0 ? void 0 : _this$step3.run_number) > 1 && (_this$step4 = this.step) !== null && _this$step4 !== void 0 && _this$step4.isSuccessful) statusType = "RERUN";
        }
        return statusType;
    }
}
class $5ea6d0c3f9f93620$export$4c71438264bb2277 {
    // circular dep
    // flattened props
    constructor(props = {}){
        var _props$deployable, _props$state, _props$step;
        this.class_type = "Deployment";
        this.deployable = new (0, $4C3IP.Deployable)();
        this.state = null;
        this.step = new (0, $gPp1Y.Step)();
        this.uuid = "";
        this.environment = undefined;
        this["environment.name"] = "";
        this["environment.uuid"] = "";
        Object.assign(this, {
            ...(0, $fb7JV.pick)((0, $kOiOG.flatten)(props), Object.keys(this)),
            deployable: ((_props$deployable = props.deployable) === null || _props$deployable === void 0 ? void 0 : _props$deployable.class_type) === "Deployable" ? props.deployable : new (0, $4C3IP.Deployable)(props.deployable),
            state: ((_props$state = props.state) === null || _props$state === void 0 ? void 0 : _props$state.class_type) === "DeploymentState" ? props.state : new $5ea6d0c3f9f93620$export$a12a01ce2571070a({
                ...props.state,
                // copy props
                step: Object.assign({}, props.step)
            }),
            step: ((_props$step = props.step) === null || _props$step === void 0 ? void 0 : _props$step.class_type) === "Step" ? props.step : new (0, $gPp1Y.Step)(props.step)
        });
        Object.freeze(this);
    }
    get environmentUuid() {
        return this["environment.uuid"];
    }
    get environmentName() {
        return this["environment.name"];
    }
}

});
parcelRegister("gPp1Y", function(module, exports) {

$parcel$export(module.exports, "StepStatus", function () { return $6a0bd6c107394151$export$d57f9812c5f15784; });
$parcel$export(module.exports, "Step", function () { return $6a0bd6c107394151$export$fd55ce593607084a; });

var $h39Sh = parcelRequire("h39Sh");

var $i3LMs = parcelRequire("i3LMs");

var $7s3ZE = parcelRequire("7s3ZE");

var $kOiOG = parcelRequire("kOiOG");

var $fb7JV = parcelRequire("fb7JV");

var $arCf2 = parcelRequire("arCf2");

var $l188y = parcelRequire("l188y");

var $f1t5L = parcelRequire("f1t5L");

var $eejIt = parcelRequire("eejIt");

var $k2NX9 = parcelRequire("k2NX9");

var $buhnP = parcelRequire("buhnP");

var $e8xZi = parcelRequire("e8xZi");

var $7Re2y = parcelRequire("7Re2y");
const $6a0bd6c107394151$export$d57f9812c5f15784 = {
    UNKNOWN: {
        text: "",
        color: ""
    },
    PENDING: {
        text: "",
        color: (0, $h39Sh.default)("color.icon.selected", "#0065FF")
    },
    PAUSED: {
        text: "Waiting",
        color: (0, $h39Sh.default)("color.background.accent.gray.subtler", "#C1C7D0")
    },
    HALTED: {
        text: "Halted",
        color: (0, $h39Sh.default)("color.icon.warning", "#FF8B00")
    },
    READY: {
        text: "Queued",
        color: (0, $h39Sh.default)("color.icon.selected", "#0065FF")
    },
    STARTING_AGENT: {
        text: "Assigned to runner",
        color: (0, $h39Sh.default)("color.icon.selected", "#0065FF")
    },
    CLONING: {
        text: "Cloning",
        color: (0, $h39Sh.default)("color.icon.selected", "#0065FF")
    },
    COMPLETING_LOGS: {
        text: "Completing logs",
        color: (0, $h39Sh.default)("color.icon.selected", "#0065FF")
    },
    DOWNLOADING_ARTIFACTS: {
        text: "Downloading artifacts",
        color: (0, $h39Sh.default)("color.icon.selected", "#0065FF")
    },
    DOWNLOADING_CACHES: {
        text: "Downloading caches",
        color: (0, $h39Sh.default)("color.icon.selected", "#0065FF")
    },
    PULLING_IMAGES: {
        text: "Pulling images",
        color: (0, $h39Sh.default)("color.icon.selected", "#0065FF")
    },
    PARSING_TEST_RESULTS: {
        text: "Parsing test results",
        color: (0, $h39Sh.default)("color.icon.selected", "#0065FF")
    },
    RUNNING: {
        text: "Running",
        color: (0, $h39Sh.default)("color.icon.information", "#0065FF")
    },
    UPLOADING_ARTIFACTS: {
        text: "Uploading artifacts",
        color: (0, $h39Sh.default)("color.icon.selected", "#0065FF")
    },
    UPLOADING_CACHES: {
        text: "Uploading caches",
        color: (0, $h39Sh.default)("color.icon.selected", "#0065FF")
    },
    ERROR: {
        text: "Error",
        color: (0, $h39Sh.default)("color.icon.danger", "#FF5630")
    },
    SYSTEM_ERROR: {
        text: "System error",
        color: (0, $h39Sh.default)("color.icon.danger", "#FF5630")
    },
    USER_ERROR: {
        text: "Configuration error",
        color: (0, $h39Sh.default)("color.icon.danger", "#FF5630")
    },
    FAILED: {
        text: "Failed",
        color: (0, $h39Sh.default)("color.icon.danger", "#FF5630")
    },
    NOT_RUN: {
        text: "Not run",
        color: (0, $h39Sh.default)("color.background.accent.gray.subtler.hovered", "#A5ADBA")
    },
    STOPPED: {
        text: "Stopped",
        color: (0, $h39Sh.default)("color.icon.subtle", "#7A869A")
    },
    SKIPPED: {
        text: "Skipped",
        color: (0, $h39Sh.default)("color.icon.accent.yellow", "#FFAB00")
    },
    SUCCESSFUL: {
        text: "Successful",
        color: (0, $h39Sh.default)("color.icon.success", "#36B27E")
    }
};
class $6a0bd6c107394151$var$StepStatusContainer {
    constructor(props = {}){
        this.statusType = "UNKNOWN";
        this.reason = null;
        Object.assign(this, {
            ...props,
            statusType: props !== null && props !== void 0 && props.statusType && Object.keys($6a0bd6c107394151$export$d57f9812c5f15784).includes(props.statusType) ? props.statusType : "UNKNOWN"
        });
        Object.freeze(this);
    }
}
class $6a0bd6c107394151$export$fd55ce593607084a {
    // flattened properties
    constructor(props = {}){
        var _props$state$result;
        this.class_type = "Step";
        this.artifacts = [];
        this.build_seconds_used = 0;
        this.completed_on = "";
        this.duration_in_seconds = 0;
        this.error = null;
        this.is_artifacts_download_enabled = true;
        this.log_byte_count = 0;
        this.name = "";
        this.run_number = 0;
        this.runs_on = [];
        this.services = [];
        this.size = 0;
        this.started_on = "";
        this.state = undefined;
        this.statusContainer = new $6a0bd6c107394151$var$StepStatusContainer();
        this.stepSize = 1;
        this.environment = undefined;
        this.test_report = undefined;
        this.trigger = undefined;
        this.type = "";
        this.uuid = "";
        this.stage = undefined;
        this.feature_flags = [];
        this["environment.name"] = "";
        this["environment.uuid"] = "";
        this["image.name"] = "";
        this["parallel_group.group_name"] = null;
        this["resource_limits.cpu_limit_in_millicores"] = 0;
        this["resource_limits.memory_limit_in_megabytes"] = 0;
        this["test_report.result"] = {};
        this["trigger.triggerer"] = new (0, $7Re2y.User)();
        this["trigger.type"] = "";
        const statusName = (0, $7s3ZE.convertStepStatus)(props.state);
        const hasError = statusName === "ERROR" || statusName === "FAILED" || statusName === "SYSTEM_ERROR" || statusName === "STOPPED";
        let reason = null;
        if (statusName === "HALTED" && props.state.stage) reason = new (0, $l188y.HaltedReason)(props.state.stage.reason);
        if (statusName === "STOPPED" && (_props$state$result = props.state.result) !== null && _props$state$result !== void 0 && _props$state$result.reason) reason = new (0, $buhnP.StoppedReason)(props.state.result.reason);
        const statusContainer = new $6a0bd6c107394151$var$StepStatusContainer({
            statusType: statusName,
            reason: reason
        });
        const getTestReport = ()=>{
            var _props$test_report;
            if (props["test_report.result"]) return props["test_report.result"];
            if ((_props$test_report = props.test_report) !== null && _props$test_report !== void 0 && _props$test_report.result) return new (0, $e8xZi.TestReportResult)(props.test_report.result);
            return new (0, $e8xZi.TestReportResult)();
        };
        Object.assign(this, {
            ...(0, $fb7JV.pick)((0, $kOiOG.flatten)(props), Object.keys(this)),
            state: props.state,
            ...props.stage ? {
                stage: new (0, $k2NX9.Stage)(props.stage)
            } : {},
            ...props.feature_flags ? {
                feature_flags: props.feature_flags
            } : {},
            runs_on: props.runs_on != null ? Array.isArray(props.runs_on) ? props.runs_on : [
                props.runs_on
            ] : [],
            artifacts: Array.isArray(props.artifacts) ? props.artifacts.map((artifact)=>new (0, $arCf2.Artifact)(artifact)) : [],
            services: Array.isArray(props.services) ? props.services.map((service)=>new (0, $eejIt.Service)(service)) : [],
            statusContainer: statusContainer,
            error: hasError && props.state.result && new (0, $f1t5L.ResponseError)(props.state.result.error),
            stepSize: props.size || 1,
            "trigger.triggerer": new (0, $7Re2y.User)(props.trigger != null ? props.trigger.triggerer : {}),
            "test_report.result": getTestReport()
        });
        Object.freeze(this);
    }
    get status() {
        return this.statusContainer.statusType;
    }
    get statusIcon() {
        if (this.isRedeployed) return "REDEPLOY";
        return this.status;
    }
    get statusText() {
        var _this$statusContainer;
        if (this.statusContainer.statusType === "STARTING_AGENT") return `Assigned to ${this.runnerType} runner`;
        const stoppedReasonText = (_this$statusContainer = this.statusContainer.reason) === null || _this$statusContainer === void 0 ? void 0 : _this$statusContainer.stoppedReasonText;
        if (this.statusContainer.statusType === "STOPPED" && stoppedReasonText) return stoppedReasonText;
        return $6a0bd6c107394151$export$d57f9812c5f15784[this.statusContainer.statusType].text;
    }
    get statusColor() {
        return $6a0bd6c107394151$export$d57f9812c5f15784[this.statusContainer.statusType].color;
    }
    get statusReason() {
        return this.statusContainer.reason;
    }
    get isNotStarted() {
        return this.statusContainer.statusType === "PAUSED" || this.statusContainer.statusType === "PENDING" || this.statusContainer.statusType === "HALTED";
    }
    get willNotRun() {
        return this.statusContainer.statusType === "NOT_RUN";
    }
    get isReady() {
        return this.statusContainer.statusType === "READY" || this.statusContainer.statusType === "STARTING_AGENT";
    }
    get isSuccessful() {
        return this.statusContainer.statusType === "SUCCESSFUL";
    }
    get isFailed() {
        return this.statusContainer.statusType === "FAILED";
    }
    get isStopped() {
        return this.statusContainer.statusType === "STOPPED";
    }
    get isSkipped() {
        return this.statusContainer.statusType === "SKIPPED";
    }
    get isPaused() {
        return this.statusContainer.statusType === "PAUSED";
    }
    get isHalted() {
        return this.statusContainer.statusType === "HALTED";
    }
    get isPending() {
        return this.statusContainer.statusType === "PENDING";
    }
    get hasError() {
        return this.statusContainer.statusType === "ERROR" || this.statusContainer.statusType === "FAILED" || this.statusContainer.statusType === "SYSTEM_ERROR";
    }
    get hasExecuted() {
        return !!this.statusContainer.statusType && (this.statusContainer.statusType === "CLONING" || this.statusContainer.statusType === "DOWNLOADING_ARTIFACTS" || this.statusContainer.statusType === "DOWNLOADING_CACHES" || this.statusContainer.statusType === "PULLING_IMAGES" || this.statusContainer.statusType === "RUNNING" || this.statusContainer.statusType === "UPLOADING_ARTIFACTS" || this.statusContainer.statusType === "UPLOADING_CACHES" || this.statusContainer.statusType === "COMPLETING_LOGS" || this.statusContainer.statusType === "PARSING_TEST_RESULTS" || this.statusContainer.statusType === "SYSTEM_ERROR" || this.statusContainer.statusType === "USER_ERROR" || this.statusContainer.statusType === "ERROR" || this.statusContainer.statusType === "FAILED" || this.statusContainer.statusType === "STOPPED" || this.statusContainer.statusType === "SUCCESSFUL");
    }
    get isSyncing() {
        // verbose but type checked
        return !this.statusContainer.statusType || this.statusContainer.statusType === "PENDING" || this.statusContainer.statusType === "READY" || this.statusContainer.statusType === "STARTING_AGENT" || this.statusContainer.statusType === "DOWNLOADING_ARTIFACTS" || this.statusContainer.statusType === "DOWNLOADING_CACHES" || this.statusContainer.statusType === "UPLOADING_ARTIFACTS" || this.statusContainer.statusType === "UPLOADING_CACHES" || this.statusContainer.statusType === "COMPLETING_LOGS" || this.statusContainer.statusType === "PULLING_IMAGES" || this.statusContainer.statusType === "PARSING_TEST_RESULTS" || this.statusContainer.statusType === "CLONING" || this.statusContainer.statusType === "RUNNING";
    }
    get isComplete() {
        return this.isSuccessful || this.isFailed || this.willNotRun || this.isStopped || this.isSkipped || this.hasError;
    }
    get imageName() {
        return this["image.name"];
    }
    get isManual() {
        return this["trigger.type"] === "pipeline_step_trigger_manual";
    }
    get isRedeploy() {
        return this["trigger.type"] === "pipeline_step_trigger_redeploy";
    }
    get isRedeployed() {
        return this.isComplete && this.isRedeploy;
    }
    get redeployStatus() {
        if (!this.isRedeployed) return "";
        if (!this.isSuccessful) return {
            statusIcon: "failedRedeploy",
            statusText: "Failed redeployment"
        };
        return {
            statusIcon: "redeploy",
            statusText: "Successful redeployment"
        };
    }
    get rerunStatus() {
        if (this.run_number <= 1 || !this.isSuccessful) return "";
        return {
            statusIcon: "successRerun",
            statusText: "Successful rerun"
        };
    }
    get testReportResult() {
        return this["test_report.result"];
    }
    get environmentUuid() {
        return this["environment.uuid"];
    }
    get environmentName() {
        return this["environment.name"];
    }
    get memoryLimitInMegabytes() {
        return this["resource_limits.memory_limit_in_megabytes"];
    }
    get cpuLimitInMilicores() {
        return this["resource_limits.cpu_limit_in_millicores"];
    }
    get totalMemoryLimitInMegabytes() {
        const sumServicesMemory = this.customServices.reduce((sum, service)=>sum + service.memoryLimitInMegabytes, 0);
        return this["resource_limits.memory_limit_in_megabytes"] + sumServicesMemory;
    }
    get featureFlags() {
        return this.feature_flags;
    }
    get customServices() {
        return this.services.filter((service)=>!(service.origin === "SYSTEM" && service.name === "auth-proxy"));
    }
    get hasEnvironment() {
        return !!this["environment.uuid"];
    }
    get isDeployable() {
        return (this.isManual || this.isHalted) && this.isNotStarted && this.hasEnvironment;
    }
    get isRedeployable() {
        return this.hasEnvironment && (this.isSuccessful || this.isRedeployed);
    }
    get isRerunnable() {
        return this.hasExecuted && !this.isSuccessful;
    }
    get hasTestReportWithPassedTestCases() {
        const passedTestsCases = this.testReportResult.number_of_successful_test_cases;
        return this.isComplete && passedTestsCases > 0;
    }
    get hasTestReportWithFailedTestCases() {
        const failedTestsCases = this.testReportResult.number_of_failed_test_cases + this.testReportResult.number_of_error_test_cases;
        return this.isComplete && failedTestsCases > 0;
    }
    get hasArtifacts() {
        return this.isComplete && this.artifacts.length > 0;
    }
    get hasServices() {
        return !!(!this.uuid || this.uuid && this.services.filter((service)=>!(service.origin === "SYSTEM" && service.name === "auth-proxy")).length > 0);
    }
    /** The formatted displayable rerun count __text__, not a number. E.g. "2 times" */ get rerunCount() {
        return `${this.run_number - 1} ${this.run_number === 2 ? "time" : "times"}`;
    }
    get isParallel() {
        return !!this["parallel_group.group_name"];
    }
    get isInStage() {
        return !!this.stage;
    }
    get triggerer() {
        var _this$triggerTrigger;
        return (_this$triggerTrigger = this["trigger.triggerer"]) !== null && _this$triggerTrigger !== void 0 && _this$triggerTrigger.uuid ? this["trigger.triggerer"] : null;
    }
    get wasExecutedOnSelfHostedRunner() {
        return this.runs_on.length !== 0;
    }
    get runnerType() {
        return this.runs_on.length !== 0 ? "self-hosted" : "cloud";
    }
    get isPartOfMultiStepDeployment() {
        var _this$stage;
        return ((_this$stage = this.stage) === null || _this$stage === void 0 ? void 0 : _this$stage.is_deployment_stage) || false;
    }
    get logV2Enabled() {
        var _find;
        return !!((_find = (this.featureFlags || []).find((ff)=>ff.name === (0, $i3LMs.BITBUCKET_PIPELINES_FEATURE_FLAG_KEYS).LOG_V2)) !== null && _find !== void 0 && _find.value);
    }
}

});
parcelRegister("7s3ZE", function(module, exports) {

$parcel$export(module.exports, "convertPipelineStatus", function () { return $b14b36d3bd56969b$export$188537878cb52b50; });
$parcel$export(module.exports, "convertStepStatus", function () { return $b14b36d3bd56969b$export$2eda4d63f900f850; });
function $b14b36d3bd56969b$export$188537878cb52b50(state) {
    return $b14b36d3bd56969b$var$convertStatus(state, false);
}
function $b14b36d3bd56969b$export$2eda4d63f900f850(state) {
    return $b14b36d3bd56969b$var$convertStatus(state, true);
}
function $b14b36d3bd56969b$var$convertStatus(state, usePendingStage) {
    if (!state || !state.name) return "";
    if (state.name === "IN_PROGRESS" && state.stage) return state.stage.name;
    if (state.name === "PENDING" && usePendingStage && state.stage) return state.stage.name;
    if (state.name === "COMPLETED" && state.result) {
        if (state.result.name === "ERROR") return "SYSTEM_ERROR";
        return state.result.name;
    }
    return state.name;
}

});

parcelRegister("l188y", function(module, exports) {

$parcel$export(module.exports, "HaltedReason", function () { return $1e8f56f24613cba9$export$a6372e069862f843; });

var $gHCUN = parcelRequire("gHCUN");

var $7Re2y = parcelRequire("7Re2y");
class $1e8f56f24613cba9$export$a6372e069862f843 extends (0, $gHCUN.Reason) {
    constructor(props = {}){
        super(props);
        this.actor = new (0, $7Re2y.User)();
        this.pipeline_uuid = "";
        this.step_uuid = "";
        Object.assign(this, {
            ...props,
            actor: new (0, $7Re2y.User)(props.actor)
        });
        Object.freeze(this);
    }
    get pipelineUuid() {
        return this.pipeline_uuid;
    }
    get stepUuid() {
        return this.step_uuid;
    }
    get warningText() {
        if (this.isDeploymentGateChecksRequiredReason) return "Change request pending";
        return null;
    }
}

});
parcelRegister("gHCUN", function(module, exports) {

$parcel$export(module.exports, "Reason", function () { return $1cd615ee3edf09a1$export$fe867595c4640fb1; });
class $1cd615ee3edf09a1$export$fe867595c4640fb1 {
    constructor(props = {}){
        this.type = "";
        Object.assign(this, {
            ...props
        });
    }
    get isAllowanceExceededReason() {
        return this.type === "pipeline_step_halted_reason_allowance_exceeded";
    }
    get isDeploymentConcurrencyReason() {
        return this.type === "pipeline_step_halted_reason_concurrent_deployment";
    }
    get isUserHasNoDeploymentPermissionsReason() {
        return this.type === "pipeline_step_halted_reason_user_has_no_environment_permissions";
    }
    get isBranchHasNoDeploymentPermissionsReason() {
        return this.type === "pipeline_step_halted_reason_branch_blocked_deployment";
    }
    get isDeploymentGateChecksRequiredReason() {
        return this.type === "pipeline_step_halted_reason_deployment_gated_checks_required";
    }
    get isDeploymentGateFailedReason() {
        return this.type === "deployment_gate_failed_halted_reason";
    }
    get isFailFastStoppedReason() {
        return this.type === "pipeline_step_stopped_reason_fail_fast";
    }
}

});


parcelRegister("f1t5L", function(module, exports) {

$parcel$export(module.exports, "ResponseError", function () { return $98c51a705c3156ca$export$286baf652d0b1206; });
class $98c51a705c3156ca$export$286baf652d0b1206 {
    constructor(props = {}){
        this.arguments = {};
        this.key = "";
        this.message = "";
        this.name = "";
        this.type = "";
        Object.assign(this, props);
        Object.freeze(this);
    }
}

});

parcelRegister("eejIt", function(module, exports) {

$parcel$export(module.exports, "Service", function () { return $8b58a27d5bf6a1d3$export$8b2af884909d32a5; });

var $kOiOG = parcelRequire("kOiOG");

var $fb7JV = parcelRequire("fb7JV");
class $8b58a27d5bf6a1d3$export$8b2af884909d32a5 {
    // flattened props
    constructor(props = {}){
        this.name = "";
        this.origin = "";
        this.uuid = "";
        this["image.name"] = "";
        this["resource_limits.memory_limit_in_megabytes"] = 0;
        this["resource_limits.cpu_limit_in_millicores"] = 0;
        Object.assign(this, {
            ...(0, $fb7JV.pick)((0, $kOiOG.flatten)(props), Object.keys(this))
        });
        Object.freeze(this);
    }
    get imageName() {
        return this["image.name"];
    }
    get memoryLimitInMegabytes() {
        return this["resource_limits.memory_limit_in_megabytes"];
    }
    get cpuLimitInMilicores() {
        return this["resource_limits.cpu_limit_in_millicores"];
    }
}

});

parcelRegister("k2NX9", function(module, exports) {

$parcel$export(module.exports, "Stage", function () { return $c5afe1620a40bb55$export$208cd1682bd0e4b6; });

var $h39Sh = parcelRequire("h39Sh");

var $7s3ZE = parcelRequire("7s3ZE");
const $c5afe1620a40bb55$export$baf535cd03b1e40a = {
    "": {
        text: "",
        color: ""
    },
    UNKNOWN: {
        text: "",
        color: ""
    },
    PENDING: {
        text: "",
        color: (0, $h39Sh.default)("color.icon.selected", "#0065FF")
    },
    PAUSED: {
        text: "Waiting",
        color: (0, $h39Sh.default)("color.background.accent.gray.subtler", "#C1C7D0")
    },
    HALTED: {
        text: "Halted",
        color: (0, $h39Sh.default)("color.icon.warning", "#FF8B00")
    },
    READY: {
        text: "Queued",
        color: (0, $h39Sh.default)("color.icon.selected", "#0065FF")
    },
    RUNNING: {
        text: "Running",
        color: (0, $h39Sh.default)("color.icon.information", "#0065FF")
    },
    ERROR: {
        text: "Error",
        color: (0, $h39Sh.default)("color.icon.danger", "#FF5630")
    },
    SYSTEM_ERROR: {
        text: "Error",
        color: (0, $h39Sh.default)("color.icon.danger", "#FF5630")
    },
    FAILED: {
        text: "Failed",
        color: (0, $h39Sh.default)("color.icon.danger", "#FF5630")
    },
    NOT_RUN: {
        text: "Not run",
        color: (0, $h39Sh.default)("color.background.accent.gray.subtler.hovered", "#A5ADBA")
    },
    STOPPED: {
        text: "Stopped",
        color: (0, $h39Sh.default)("color.icon.subtle", "#7A869A")
    },
    SKIPPED: {
        text: "Skipped",
        color: (0, $h39Sh.default)("color.icon.accent.yellow", "#FFAB00")
    },
    SUCCESSFUL: {
        text: "Successful",
        color: (0, $h39Sh.default)("color.icon.success", "#36B27E")
    }
};
class $c5afe1620a40bb55$export$208cd1682bd0e4b6 {
    constructor(props = {}){
        this.index = 0;
        this.name = "";
        this.build_seconds_used = 0;
        this.completed_on = "";
        this.duration_in_seconds = 0;
        this.is_deployment_stage = false;
        this.is_redeploy = false;
        this.started_on = "";
        this.state = {};
        this.status = undefined;
        this.expired = false;
        Object.assign(this, {
            ...props,
            status: (0, $7s3ZE.convertStepStatus)(props.state),
            name: props.name || `Stage ${(props.index || 0) + 1}`
        });
        Object.freeze(this);
    }
    get isInProgress() {
        return this.status === "RUNNING" || this.status === "READY";
    }
    get isSuccessful() {
        return this.status === "SUCCESSFUL";
    }
    get isSkipped() {
        return this.status === "SKIPPED";
    }
    get isFailed() {
        return this.status === "FAILED";
    }
    get willNotRun() {
        return this.status === "NOT_RUN";
    }
    get isStopped() {
        return this.status === "STOPPED";
    }
    get isPaused() {
        return this.status === "PAUSED";
    }
    get isHalted() {
        return this.status === "HALTED";
    }
    get isPending() {
        return this.status === "PENDING";
    }
    get hasError() {
        return this.status === "ERROR" || this.status === "FAILED" || this.status === "SYSTEM_ERROR";
    }
    get isComplete() {
        return this.isSuccessful || this.willNotRun || this.isStopped || this.isSkipped || this.hasError;
    }
    get isUnfinished() {
        return this.hasError || this.isStopped || this.isHalted;
    }
    get statusIcon() {
        if (this.is_redeploy && this.isComplete) return "REDEPLOY";
        return this.status || "";
    }
    get statusText() {
        return this.status ? $c5afe1620a40bb55$export$baf535cd03b1e40a[this.status].text : "";
    }
    get statusColor() {
        return this.status ? $c5afe1620a40bb55$export$baf535cd03b1e40a[this.status].color : "";
    }
}

});

parcelRegister("buhnP", function(module, exports) {

$parcel$export(module.exports, "StoppedReason", function () { return $45ea266d549c3f93$export$ae291272757e1656; });

var $gHCUN = parcelRequire("gHCUN");
class $45ea266d549c3f93$export$ae291272757e1656 extends (0, $gHCUN.Reason) {
    constructor(props = {}){
        super(props);
        Object.assign(this, {
            ...props
        });
        Object.freeze(this);
    }
    get stoppedReasonText() {
        if (this.isFailFastStoppedReason) return "Stopped when a parallel step failed (fail-fast is enabled)";
        return null;
    }
}

});

parcelRegister("e8xZi", function(module, exports) {

$parcel$export(module.exports, "TestReportResult", function () { return $c3491ab0e78673f0$export$32137d953911663f; });
$parcel$export(module.exports, "TestCaseReason", function () { return $c3491ab0e78673f0$export$b5f5c899ba1dc5b3; });
$parcel$export(module.exports, "TestCaseReasonError", function () { return $c3491ab0e78673f0$export$3b7ce3fa354a163f; });
$parcel$export(module.exports, "TestCase", function () { return $c3491ab0e78673f0$export$935a225196c5b724; });

var $cPXrv = parcelRequire("cPXrv");

var $kOiOG = parcelRequire("kOiOG");

var $fb7JV = parcelRequire("fb7JV");
class $c3491ab0e78673f0$export$32137d953911663f {
    constructor(props = {}){
        this.step_uuid = "";
        this.number_of_error_test_cases = 0;
        this.number_of_failed_test_cases = 0;
        this.number_of_skipped_test_cases = 0;
        this.number_of_successful_test_cases = 0;
        this.number_of_test_cases = 0;
        Object.assign(this, props);
        Object.freeze(this);
    }
}
class $c3491ab0e78673f0$export$b5f5c899ba1dc5b3 {
    constructor(props = {}){
        this.uuid = "";
        this.message = "";
        this.stack_trace = "";
        Object.assign(this, props);
        Object.freeze(this);
    }
    get logLines() {
        const logLines = [];
        if (this.message) {
            logLines.push(...this.message.split("\n"));
            // add extra empty line between message and stack trace
            logLines.push("");
        }
        if (this.stack_trace) {
            logLines.push(...this.stack_trace.split("\n"));
            // add extra empty line for proper rendering of truncated logs
            logLines.push("");
        }
        return logLines;
    }
}
class $c3491ab0e78673f0$export$3b7ce3fa354a163f {
    constructor(props = {}){
        this.error = undefined;
        this["error.key"] = "";
        this["error.message"] = 0;
        Object.assign(this, {
            ...(0, $fb7JV.pick)((0, $kOiOG.flatten)(props), Object.keys(this))
        });
        Object.freeze(this);
    }
}
class $c3491ab0e78673f0$export$935a225196c5b724 {
    constructor(props = {}){
        this.uuid = "";
        this.class_name = "";
        this.name = "";
        this.package_name = "";
        this.suite_name = "";
        this.status = "";
        this.duration = "";
        Object.assign(this, {
            ...props,
            duration: props.duration ? (0, $cPXrv.default)(props.duration) : null
        });
        Object.freeze(this);
    }
}

});
parcelRegister("cPXrv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea6ce0ea0f532077$export$2e2bcd8739ae039; });
const $ea6ce0ea0f532077$var$durationRegExp = /P(?:(\d+(?:\.\d+)?)Y)?(?:(\d+(?:\.\d+)?)M)?(?:(\d+(?:\.\d+)?)W)?(?:(\d+(?:\.\d+)?)D)?(?:T(?:(\d+(?:\.\d+)?)H)?(?:(\d+(?:\.\d+)?)M)?(?:(\d+(?:\.\d+)?)S)?)?/u;
function $ea6ce0ea0f532077$export$2e2bcd8739ae039(duration = "") {
    if (typeof duration !== "string") return 0;
    const [, years = 0, months = 0, weeks = 0, days = 0, hours = 0, minutes = 0, seconds = 0] = $ea6ce0ea0f532077$var$durationRegExp.exec(duration) || [];
    return years * 31536000 + months * 2592000 + weeks * 604800 + days * 86400 + hours * 3600 + minutes * 60 + Number(seconds);
}

});




parcelRegister("fAdbN", function(module, exports) {
class $309c32e0d71cb40a$export$657d1492c069fc3e {
    constructor(props = {}){
        this.key = "";
        this.name = "";
        this.logMatches = "";
        this.links = [];
        this.onStatus = "";
        this.description = "";
        Object.assign(this, props);
        Object.freeze(this);
    }
}

});

parcelRegister("eRckJ", function(module, exports) {

$parcel$export(module.exports, "Environment", function () { return $562b321aef55ae0b$export$7dc6752a22ab011a; });

var $kOiOG = parcelRequire("kOiOG");

var $fb7JV = parcelRequire("fb7JV");

var $goDEr = parcelRequire("goDEr");

var $G9jLU = parcelRequire("G9jLU");

var $gC76L = parcelRequire("gC76L");
class $562b321aef55ae0b$export$7dc6752a22ab011a extends (0, $gC76L.ModelBase) {
    // flattened props
    constructor(props = {}){
        var _environment_type;
        super(props);
        this.branchRestrictions = [];
        this.deployment_gate_enabled = false;
        this.latest_deployment = undefined;
        this.latest_successful_deployment = undefined;
        this.lock = new (0, $G9jLU.OpenLock)();
        this.name = "";
        this.next_promotion = new (0, $goDEr.Deployment)();
        this.rank = 0;
        this.slug = "";
        this.type = "";
        this.uuid = "";
        this.environment_type = undefined;
        this.restrictions = undefined;
        this["environment_type.name"] = "";
        this["next_promotion.release.source_branch"] = "";
        this["restrictions.admin_only"] = false;
        Object.assign(this, {
            ...(0, $fb7JV.pick)((0, $kOiOG.flatten)(props), Object.keys(this)),
            ...props.branchRestrictions ? {
                branchRestrictions: props.branchRestrictions
            } : {},
            ...props.latest_deployment ? {
                latest_deployment: new (0, $goDEr.Deployment)(props.latest_deployment)
            } : {},
            ...props.latest_successful_deployment ? {
                latest_successful_deployment: new (0, $goDEr.Deployment)(props.latest_successful_deployment)
            } : {},
            ...props.lock ? props.lock.name === "CLOSED" ? {
                lock: new (0, $G9jLU.ClosedLock)(props.lock)
            } : {
                lock: new (0, $G9jLU.OpenLock)(props.lock)
            } : {},
            next_promotion: new (0, $goDEr.Deployment)(props.next_promotion),
            type: ((props === null || props === void 0 ? void 0 : (_environment_type = props.environment_type) === null || _environment_type === void 0 ? void 0 : _environment_type.name) || "").toLowerCase()
        });
        Object.freeze(this);
    }
    get isLocked() {
        return !this.lock || this.lock.name === "CLOSED";
    }
    get hasDeployment() {
        return !!this.latest_deployment || !!this.latest_successful_deployment;
    }
    get hasAdminOnlyRestriction() {
        return this["restrictions.admin_only"];
    }
    get sourceBranch() {
        return this["next_promotion.release.source_branch"];
    }
    get nextPromotion() {
        return this.next_promotion.uuid ? this.next_promotion : undefined;
    }
    get environmentType() {
        return this["environment_type.name"].toLowerCase();
    }
}

});
parcelRegister("G9jLU", function(module, exports) {

$parcel$export(module.exports, "OpenLock", function () { return $583e7b5cfecb3a43$export$5becfc352b495196; });
$parcel$export(module.exports, "ClosedLock", function () { return $583e7b5cfecb3a43$export$e99a11ba60e1f463; });
class $583e7b5cfecb3a43$export$d8f256c626bb3acc {
    constructor(props = {}){
        this.pipeline_uuid = "";
        this.step_uuid = "";
        this.type = "";
        Object.assign(this, props);
        Object.freeze(this);
    }
}
class $583e7b5cfecb3a43$export$5becfc352b495196 {
    constructor(props = {}){
        this.name = "OPEN";
        Object.assign(this, props);
        Object.freeze(this);
    }
}
class $583e7b5cfecb3a43$export$e99a11ba60e1f463 {
    constructor(props = {}){
        this.name = "";
        this.owner = null;
        const owner = props.owner ? new $583e7b5cfecb3a43$export$d8f256c626bb3acc(props.owner) : null;
        Object.assign(this, {
            ...props,
            owner: owner
        });
        Object.freeze(this);
    }
}

});


parcelRegister("his0q", function(module, exports) {

$parcel$export(module.exports, "Issue", function () { return $a5f9dac0a3cb55eb$export$c175600e334513b4; });

var $kOiOG = parcelRequire("kOiOG");

var $fb7JV = parcelRequire("fb7JV");

var $7Re2y = parcelRequire("7Re2y");
var $a5f9dac0a3cb55eb$var$StatusCategoryToAppearenceMap;
(function(StatusCategoryToAppearenceMap) {
    StatusCategoryToAppearenceMap["TODO"] = "default";
    StatusCategoryToAppearenceMap["DONE"] = "success";
    StatusCategoryToAppearenceMap["IN_PROGRESS"] = "inprogress";
})($a5f9dac0a3cb55eb$var$StatusCategoryToAppearenceMap || ($a5f9dac0a3cb55eb$var$StatusCategoryToAppearenceMap = {}));
class $a5f9dac0a3cb55eb$export$c175600e334513b4 {
    // flattened props
    constructor(props = {}){
        this.key = "";
        this.id = "";
        this.self = "";
        this.fields = void 0;
        this["fields.summary"] = "";
        this["fields.assignee.account-id"] = "";
        this["fields.assignee.display_name"] = "";
        this["fields.assignee.avatar_url"] = "";
        this["fields.status.name"] = "";
        this["fields.status.status_category.name"] = "";
        this["fields.priority.name"] = "";
        this["fields.priority.icon_url"] = "";
        this["fields.issue_type.name"] = "";
        this["fields.issue_type.icon_url"] = "";
        this["rendered_key.html"] = "";
        Object.assign(this, {
            ...(0, $fb7JV.pick)((0, $kOiOG.flatten)(props), Object.keys(this))
        });
        Object.freeze(this);
    }
    get origin() {
        return new URL(this.self).origin;
    }
    get link() {
        return `${this.origin}/browse/${this.key}`;
    }
    get renderedLink() {
        return this["rendered_key.html"].includes("<a") ? this["rendered_key.html"] : `<a href=${this.link} target="_blank">${this.key}</a>`;
    }
    get assignee() {
        return new (0, $7Re2y.User)({
            display_name: this["fields.assignee.display_name"],
            links: {
                avatar: {
                    href: this.assigneeUrl
                },
                ...this.accountUrl ? {
                    html: {
                        href: this.accountUrl
                    }
                } : {}
            }
        });
    }
    get assigneeUrl() {
        return this["fields.assignee.avatar_url"];
    }
    get accountUrl() {
        return `${this.origin}/people/${this["fields.assignee.account-id"]}`;
    }
    get typeIconUrl() {
        return this["fields.issue_type.icon_url"];
    }
    get priorityUrl() {
        return this["fields.priority.icon_url"];
    }
    get summary() {
        return this["fields.summary"];
    }
    get statusCategory() {
        return this["fields.status.status_category.name"];
    }
    get statusApperance() {
        return $a5f9dac0a3cb55eb$var$StatusCategoryToAppearenceMap[this.statusCategory.toUpperCase()];
    }
    get statusName() {
        return this["fields.status.name"];
    }
}

});

parcelRegister("a63fp", function(module, exports) {

$parcel$export(module.exports, "KeyPair", function () { return $82076c07992818eb$export$fe6d1b0debb52693; });
class $82076c07992818eb$var$KeyPairError {
    constructor(props = {}){
        this.detail = "";
        this.message = "";
        this.data = {};
        Object.assign(this, props);
        Object.freeze(this);
    }
}
class $82076c07992818eb$export$fe6d1b0debb52693 {
    constructor(props = {}){
        this.private_key = "";
        this.public_key = "";
        this.error = void 0;
        Object.assign(this, {
            ...props,
            error: props.error ? new $82076c07992818eb$var$KeyPairError(props.error) : undefined
        });
        Object.freeze(this);
    }
}

});

parcelRegister("j15SL", function(module, exports) {

$parcel$export(module.exports, "KnownHost", function () { return $8a1aabdd703776b4$export$45681f3cde78978e; });

var $25ELF = parcelRequire("25ELF");
class $8a1aabdd703776b4$var$KnownHostError {
    constructor(props = {}){
        this.detail = "";
        this.message = "";
        this.data = {};
        Object.assign(this, props);
        Object.freeze(this);
    }
}
class $8a1aabdd703776b4$export$45681f3cde78978e {
    constructor(props = {}){
        this.uuid = "";
        this.hostname = "";
        this.public_key = new (0, $25ELF.PublicKey)();
        this.isSyncing = false;
        this.error = void 0;
        Object.assign(this, {
            ...props,
            public_key: new (0, $25ELF.PublicKey)(props.public_key),
            error: props.error ? new $8a1aabdd703776b4$var$KnownHostError(props.error) : undefined
        });
        Object.freeze(this);
    }
}

});
parcelRegister("25ELF", function(module, exports) {

$parcel$export(module.exports, "PublicKey", function () { return $0ce6a22c92803358$export$ca8b6604d6ce14de; });
class $0ce6a22c92803358$var$PublicKeyError {
    constructor(props = {}){
        this.detail = "";
        this.message = "";
        this.data = {};
        Object.assign(this, props);
        Object.freeze(this);
    }
}
class $0ce6a22c92803358$export$ca8b6604d6ce14de {
    constructor(props = {}){
        this.key = "";
        this.key_type = "";
        this.md5_fingerprint = "";
        this.sha256_fingerprint = "";
        this.type = "";
        this.error = void 0;
        Object.assign(this, {
            ...props,
            error: props.error ? new $0ce6a22c92803358$var$PublicKeyError(props.error) : undefined
        });
        Object.freeze(this);
    }
}

});


parcelRegister("7tNBI", function(module, exports) {

$parcel$export(module.exports, "Metric", function () { return $67ca016dd5100beb$export$efdd3e096bc27746; });

var $gC76L = parcelRequire("gC76L");
class $67ca016dd5100beb$export$efdd3e096bc27746 extends (0, $gC76L.ModelBase) {
    constructor(props = {}){
        var _props$step;
        super(props);
        this.uuid = "";
        this.sample_time = "";
        this.metric_type = "";
        this.value = {};
        this.step = {};
        this["step.uuid"] = void 0;
        Object.assign(this, {
            "step.uuid": (_props$step = props.step) === null || _props$step === void 0 ? void 0 : _props$step.uuid,
            ...props
        });
        Object.freeze(this);
    }
}

});

parcelRegister("7gE4v", function(module, exports) {

$parcel$export(module.exports, "OfficialTemplate", function () { return $0498ba33632a9553$export$59eea7690bdf4eaf; });
class $0498ba33632a9553$export$59eea7690bdf4eaf {
    constructor(props = {}){
        this.name = "";
        this.description = "";
        this.logo = "";
        this.yml = "";
        this.id = 0;
        this.weight = 1;
        this.language = "";
        Object.assign(this, props);
        Object.freeze(this);
    }
}

});

parcelRegister("gB1lx", function(module, exports) {

$parcel$export(module.exports, "Pipeline", function () { return $cc49987f1275dd06$export$abd47b564b6c9ce2; });

var $h39Sh = parcelRequire("h39Sh");

var $7s3ZE = parcelRequire("7s3ZE");

var $ezNSb = parcelRequire("ezNSb");

var $kOiOG = parcelRequire("kOiOG");

var $fb7JV = parcelRequire("fb7JV");

var $4EUxB = parcelRequire("4EUxB");

var $gC76L = parcelRequire("gC76L");

var $2Od6r = parcelRequire("2Od6r");

var $f7wkq = parcelRequire("f7wkq");

var $7Re2y = parcelRequire("7Re2y");
const $cc49987f1275dd06$export$c1b0a21d8083f822 = {
    PENDING: {
        text: "Pending",
        color: (0, $h39Sh.default)("color.icon.selected", "#0065FF")
    },
    PARSING: {
        text: "Pending",
        color: (0, $h39Sh.default)("color.icon.selected", "#0065FF")
    },
    PAUSED: {
        text: "Paused",
        color: (0, $h39Sh.default)("color.icon.subtle", "#7A869A")
    },
    HALTED: {
        text: "Halted",
        color: (0, $h39Sh.default)("color.icon.warning", "#FF8B00")
    },
    RUNNING: {
        text: "Running",
        color: (0, $h39Sh.default)("color.icon.information", "#36B27E")
    },
    IN_PROGRESS: {
        text: "Running",
        color: (0, $h39Sh.default)("color.icon.information", "#0065FF")
    },
    ERROR: {
        text: "Error",
        color: (0, $h39Sh.default)("color.icon.danger", "#FF5630")
    },
    USER_ERROR: {
        text: "Configuration error",
        color: (0, $h39Sh.default)("color.icon.danger", "#FF5630")
    },
    SYSTEM_ERROR: {
        text: "Error",
        color: (0, $h39Sh.default)("color.icon.danger", "#FF5630")
    },
    FAILED: {
        text: "Failed",
        color: (0, $h39Sh.default)("color.icon.danger", "#FF5630")
    },
    STOPPED: {
        text: "Stopped",
        color: (0, $h39Sh.default)("color.icon.subtle", "#7A869A")
    },
    SUCCESSFUL: {
        text: "Successful",
        color: (0, $h39Sh.default)("color.icon.success", "#36B27E")
    }
};
const $cc49987f1275dd06$export$5935eefdaddb9915 = {
    PARSING: "PARSING",
    PENDING: "PENDING",
    IN_PROGRESS: "IN_PROGRESS"
};
class $cc49987f1275dd06$export$abd47b564b6c9ce2 extends (0, $gC76L.ModelBase) {
    // flattened properties
    constructor(props = {}){
        var _props$state, _props$state$result, _props$creator;
        super(props);
        this.uuid = "";
        this.status = "";
        this.error = null;
        this.isStopping = false;
        this.isCreating = false;
        this.expired = false;
        this.has_variables = false;
        this.build_seconds_used = 0;
        this.duration_in_seconds = 0;
        this.build_number = 0;
        this.completed_on = "";
        this.created_on = "";
        this.creator = new (0, $7Re2y.User)();
        this.run_number = 0;
        this.runUuid = "";
        this.target = {};
        this.trigger = {};
        this.state = {
            type: "",
            name: ""
        };
        this.terminatedBy = "";
        this.configuration_sources = [
            {
                source: "",
                uri: ""
            }
        ];
        this["trigger.type"] = "";
        this["target.commit"] = new (0, $4EUxB.Commit)();
        this["target.pullrequest"] = new (0, $f7wkq.PullRequest)();
        this["target.ref_name"] = "";
        this["target.ref_type"] = "";
        this["target.selector.type"] = "default";
        this["target.selector.pattern"] = "";
        this["target.source"] = "";
        this["labels.atlassian-shadowed.commit"] = "";
        this["labels.atlassian-shadowed.committer"] = "";
        this["labels.atlassian-shadowed.project"] = "";
        this["labels.atlassian-shadowed.repository"] = "";
        let status = (0, $7s3ZE.convertPipelineStatus)(props.state);
        const terminatedBy = (0, $ezNSb.convertTerminatedBy)(props.state);
        let { error: error } = props;
        if (status === "RUNNING") status = "IN_PROGRESS";
        if ([
            "ERROR",
            "FAILED",
            "SYSTEM_ERROR"
        ].indexOf(status) !== -1 && props !== null && props !== void 0 && (_props$state = props.state) !== null && _props$state !== void 0 && (_props$state$result = _props$state.result) !== null && _props$state$result !== void 0 && _props$state$result.error) {
            var _props$state2, _props$state2$result;
            status = "USER_ERROR";
            error = new (0, $2Od6r.PipelineError)(props === null || props === void 0 ? void 0 : (_props$state2 = props.state) === null || _props$state2 === void 0 ? void 0 : (_props$state2$result = _props$state2.result) === null || _props$state2$result === void 0 ? void 0 : _props$state2$result.error);
        }
        Object.assign(this, {
            ...(0, $fb7JV.pick)((0, $kOiOG.flatten)(props), Object.keys(this)),
            ...props.configuration_sources ? {
                configuration_sources: props.configuration_sources
            } : {},
            ...props.state ? {
                state: props.state
            } : {},
            ...props.target ? {
                target: props.target
            } : {},
            ...props.target && props.target.commit ? {
                "target.commit": new (0, $4EUxB.Commit)(props.target.commit)
            } : {},
            ...props.target && props.target.type === "pipeline_pullrequest_target" ? {
                "target.pullrequest": new (0, $f7wkq.PullRequest)(props.target.pullrequest)
            } : {},
            creator: ((_props$creator = props.creator) === null || _props$creator === void 0 ? void 0 : _props$creator.class_type) === "User" ? props.creator : new (0, $7Re2y.User)(props.creator),
            status: status,
            terminatedBy: terminatedBy,
            error: error
        });
        Object.freeze(this);
    }
    get isScheduled() {
        return this.triggerType === "pipeline_trigger_schedule";
    }
    get isManual() {
        return this.triggerType === "pipeline_trigger_manual";
    }
    get isSkipped() {
        return this.status === "SKIPPED" || this.status === "HALTED";
    }
    get isHalted() {
        return this.status === "HALTED";
    }
    get isStopped() {
        return this.status === "STOPPED";
    }
    get isParsing() {
        return this.status === "PARSING";
    }
    get isComplete() {
        return [
            "SUCCESSFUL",
            "FAILED",
            "ERROR",
            "PAUSED",
            "HALTED",
            "USER_ERROR",
            "SYSTEM_ERROR",
            "STOPPED",
            "SKIPPED"
        ].indexOf(this.status) !== -1;
    }
    get isFailed() {
        return [
            "ERROR",
            "FAILED",
            "SYSTEM_ERROR",
            "USER_ERROR"
        ].indexOf(this.status) !== -1;
    }
    get canRerunSteps() {
        return this.isComplete && this.status !== "SUCCESSFUL" && this.status !== "PAUSED" && this.status !== "HALTED" && !this.expired;
    }
    get canRerunPipeline() {
        return !this.has_variables;
    }
    get isRunning() {
        return !!$cc49987f1275dd06$export$5935eefdaddb9915[this.status];
    }
    get triggerType() {
        return this["trigger.type"];
    }
    get commit() {
        return this["target.commit"];
    }
    get pullrequest() {
        return this["target.pullrequest"];
    }
    get revision() {
        return this["target.commit"].hash;
    }
    get message() {
        return this["target.commit"].message || "Commit message unavailable";
    }
    get buildNumber() {
        return this.build_number;
    }
    get configurationSources() {
        return this.configuration_sources;
    }
    get creationDate() {
        return this.created_on;
    }
    get completionDate() {
        return this.completed_on;
    }
    get buildSecondsUsed() {
        return Number(this.build_seconds_used || 0);
    }
    get durationInSeconds() {
        return Number(this.duration_in_seconds || 0);
    }
    get refName() {
        return this["target.ref_name"];
    }
    get refType() {
        return this["target.ref_type"] || "";
    }
    get selectorPattern() {
        return this["target.selector.pattern"];
    }
    get selectorType() {
        return this["target.selector.type"] || "";
    }
    get sourceBranch() {
        if (this.isBranchPipeline) return this.refName;
        if (this.isPullRequestPipeline) return this["target.source"];
        return "";
    }
    get isBranchPipeline() {
        return this.refType === "branch" || this.refType === "named_branch";
    }
    get isPullRequestPipeline() {
        return this.pullrequest.type === "pullrequest";
    }
    get customName() {
        return this.selectorType.toLowerCase() === "custom" ? `custom: ${this.selectorPattern}` : "";
    }
    get statusIcon() {
        return this.status === "PENDING" || this.status === "PARSING" ? "IN_PROGRESS" : this.status;
    }
    get statusText() {
        return this.status ? $cc49987f1275dd06$export$c1b0a21d8083f822[this.status].text : "";
    }
    get statusColor() {
        return this.status ? $cc49987f1275dd06$export$c1b0a21d8083f822[this.status].color : "";
    }
    get shadowedCommit() {
        return this["labels.atlassian-shadowed.commit"];
    }
    get shadowedCommitter() {
        return this["labels.atlassian-shadowed.committer"];
    }
    get shadowedProject() {
        return this["labels.atlassian-shadowed.project"];
    }
    get shadowedRepository() {
        return this["labels.atlassian-shadowed.repository"];
    }
}

});
parcelRegister("ezNSb", function(module, exports) {

$parcel$export(module.exports, "convertTerminatedBy", function () { return $e87327b8eaf8b19f$export$475f8be17d610961; });
function $e87327b8eaf8b19f$export$475f8be17d610961(state) {
    if (!state || !state.name) return "";
    if (state.name === "COMPLETED") {
        var _state$result;
        if (((_state$result = state.result) === null || _state$result === void 0 ? void 0 : _state$result.name) === "STOPPED") {
            var _state$result$termina;
            return ((_state$result$termina = state.result.terminator) === null || _state$result$termina === void 0 ? void 0 : _state$result$termina.display_name) || "";
        }
    }
    return "";
}

});

parcelRegister("2Od6r", function(module, exports) {

$parcel$export(module.exports, "PipelineError", function () { return $bf16517fd52ca93c$export$25a8c4faf1b32a25; });
class $bf16517fd52ca93c$export$25a8c4faf1b32a25 {
    constructor(props = {}){
        this.key = "";
        this.message = "";
        this.name = "";
        this.type = "";
        this.arguments = {};
        Object.assign(this, props);
        Object.freeze(this);
    }
}

});

parcelRegister("f7wkq", function(module, exports) {

$parcel$export(module.exports, "PullRequest", function () { return $24bea8d09414ef58$export$ae56a64bd5d10d2b; });

var $kOiOG = parcelRequire("kOiOG");

var $fb7JV = parcelRequire("fb7JV");

var $4EUxB = parcelRequire("4EUxB");

var $7Re2y = parcelRequire("7Re2y");
var $24bea8d09414ef58$var$StateCategoryToAppearenceMap;
(function(StateCategoryToAppearenceMap) {
    StateCategoryToAppearenceMap["OPEN"] = "inprogress";
    StateCategoryToAppearenceMap["MERGED"] = "success";
    StateCategoryToAppearenceMap["DECLINED"] = "removed";
})($24bea8d09414ef58$var$StateCategoryToAppearenceMap || ($24bea8d09414ef58$var$StateCategoryToAppearenceMap = {}));
class $24bea8d09414ef58$export$ae56a64bd5d10d2b {
    // flattened props
    constructor(props = {}){
        this.author = new (0, $7Re2y.User)();
        this.created_on = "";
        this.updated_on = "";
        this.id = "";
        this.merge_commit = new (0, $4EUxB.Commit)();
        this.source = {};
        this.destination = {};
        this.state = "OPEN";
        this.title = "";
        this.type = "";
        this["links.html.href"] = "";
        this["links.self.href"] = "";
        this["destination.branch.name"] = "";
        this["source.branch.name"] = "";
        this["source.commit"] = new (0, $4EUxB.Commit)();
        Object.assign(this, {
            ...(0, $fb7JV.pick)((0, $kOiOG.flatten)(props), Object.keys(this)),
            author: new (0, $7Re2y.User)(props.author || {}),
            merge_commit: new (0, $4EUxB.Commit)(props.merge_commit || {}),
            ...props.source && props.source.commit ? {
                "source.commit": new (0, $4EUxB.Commit)(props.source.commit)
            } : {}
        });
        Object.freeze(this);
    }
    get destinationBranch() {
        return this["destination.branch.name"];
    }
    get url() {
        return this["links.html.href"];
    }
    get mergeCommit() {
        return this.merge_commit;
    }
    get sourceBranch() {
        return this["source.branch.name"];
    }
    get sourceCommit() {
        return this["source.commit"];
    }
    get stateApperance() {
        return $24bea8d09414ef58$var$StateCategoryToAppearenceMap[this.state];
    }
}

});


parcelRegister("kSxPl", function(module, exports) {

});

parcelRegister("h5CwE", function(module, exports) {

$parcel$export(module.exports, "PipelineDefinition", function () { return $ea59362fc7092cf1$export$bfd078482f16f939; });
class $ea59362fc7092cf1$export$c867a5c9595a1350 {
    constructor(props = {}){
        this.name = "";
        Object.assign(this, props);
        Object.freeze(this);
    }
}
class $ea59362fc7092cf1$export$bfd078482f16f939 {
    constructor(props = {}){
        var _props$variables;
        this.type = "";
        this.pattern = "";
        this.variables = [];
        this.error = void 0;
        Object.assign(this, {
            ...props,
            variables: (_props$variables = props.variables) === null || _props$variables === void 0 ? void 0 : _props$variables.map((v)=>new $ea59362fc7092cf1$export$c867a5c9595a1350(v))
        });
        Object.freeze(this);
    }
}

});

parcelRegister("dfUfA", function(module, exports) {
class $03258110e904b186$export$2b8020cba8e4d3e3 {
    constructor(props = {}){
        this.changes = void 0;
        this.environment = void 0;
        Object.assign(this, props);
        Object.freeze(this);
    }
}

});

parcelRegister("6WfB6", function(module, exports) {

$parcel$export(module.exports, "Repository", function () { return $053893aeab79dc63$export$b340a19a1bcc0afd; });

var $gC76L = parcelRequire("gC76L");
class $053893aeab79dc63$export$b340a19a1bcc0afd extends (0, $gC76L.ModelBase) {
    constructor(props = {}){
        super(props);
        this.uuid = "";
        this.path = "";
        this.enabled = false;
        this.canWrite = false;
        this.canWriteMainBranch = false;
        this.userIsAdmin = false;
        this.language = "";
        this.displayName = "";
        this.mainbranch = "";
        this.scm = "";
        this.link = "";
        this.projectName = "";
        this.projectKey = "";
        this.hasFetched = false;
        this.hasFetchedUserIsAdmin = false;
        this.hasFetchedCanWriteMainBranch = false;
        this.files = [];
        this.apiBaseUrl = "";
        this.name = "";
        Object.assign(this, props);
        Object.freeze(this);
    }
}

});

parcelRegister("9NSQN", function(module, exports) {

$parcel$export(module.exports, "RepositoryAssociationSummary", function () { return $ca384c719415ed53$export$8494d4f2965a8036; });
class $ca384c719415ed53$export$8494d4f2965a8036 {
    constructor(props = {}){
        this.repositoryUuid = "";
        this.hasChangeManagementProjectAssociation = false;
        this.hasFetched = false;
        Object.assign(this, props);
        Object.freeze(this);
    }
}

});

parcelRegister("akm6L", function(module, exports) {

$parcel$export(module.exports, "Report", function () { return $b216d797b0b24332$export$33aa3110c4070c17; });

var $gC76L = parcelRequire("gC76L");
var $b216d797b0b24332$export$65fc24b08801c838;
(function(ResultType) {
    ResultType["Passed"] = "PASSED";
    ResultType["Failed"] = "FAILED";
    ResultType["Pending"] = "PENDING";
    ResultType["Unknown"] = "UNKNOWN";
})($b216d797b0b24332$export$65fc24b08801c838 || ($b216d797b0b24332$export$65fc24b08801c838 = {}));
var $b216d797b0b24332$export$59adc39451e8173b;
(function(ReportType) {
    ReportType["Security"] = "SECURITY";
    ReportType["Coverage"] = "COVERAGE";
    ReportType["Test"] = "TEST";
    ReportType["Bug"] = "BUG";
    ReportType["Unknown"] = "UNKNOWN";
})($b216d797b0b24332$export$59adc39451e8173b || ($b216d797b0b24332$export$59adc39451e8173b = {}));
class $b216d797b0b24332$export$33aa3110c4070c17 extends (0, $gC76L.ModelBase) {
    constructor(props = {}){
        super(props);
        this.uuid = "";
        this.report_type = "UNKNOWN";
        this.type = "";
        this.title = "";
        this.details = "";
        this.result = "UNKNOWN";
        this.reporter = "";
        this.link = "";
        this.external_id = "";
        this.logo_url = "";
        this.data = [];
        this.created_on = "";
        this.updated_on = "";
        Object.assign(this, props);
        Object.freeze(this);
    }
}

});

parcelRegister("4FRgq", function(module, exports) {

$parcel$export(module.exports, "SELF_HOSTED_LABEL", function () { return $2da5ff557b36045b$export$78b4eb07ba8f7eaf; });
$parcel$export(module.exports, "SYSTEM_LABELS", function () { return $2da5ff557b36045b$export$9ae0d9ab1f88d2d1; });
$parcel$export(module.exports, "RUNNER_LABEL_REGEXP", function () { return $2da5ff557b36045b$export$c9a6ca95a64f8199; });
$parcel$export(module.exports, "RESERVED_NAMESPACE_REGEXP", function () { return $2da5ff557b36045b$export$4009e2078171670; });
$parcel$export(module.exports, "MAX_LENGTH_OF_LABEL", function () { return $2da5ff557b36045b$export$3c17ced99ce3fca2; });
$parcel$export(module.exports, "MAX_NUMBER_OF_CUSTOM_LABELS", function () { return $2da5ff557b36045b$export$b7c53654e059c323; });
$parcel$export(module.exports, "Runner", function () { return $2da5ff557b36045b$export$571ad3bcba5a0c45; });
const $2da5ff557b36045b$export$78b4eb07ba8f7eaf = "self.hosted";
const $2da5ff557b36045b$export$9ae0d9ab1f88d2d1 = [
    "linux",
    "windows",
    "macos",
    "macos.tart",
    "linux.shell",
    "linux.arm64"
];
const $2da5ff557b36045b$export$c9a6ca95a64f8199 = new RegExp("^[a-z0-9]+(\\.?[a-z0-9])*$");
const $2da5ff557b36045b$export$4009e2078171670 = new RegExp("^(bitbucket.|atlassian.|linux.|windows.|macos.).*");
const $2da5ff557b36045b$export$3c17ced99ce3fca2 = 50;
const $2da5ff557b36045b$export$b7c53654e059c323 = 10;
class $2da5ff557b36045b$var$OAuthClient {
    constructor(props = {}){
        this.audience = "";
        this.id = "";
        this.token_endpoint = "";
        this.secret = void 0;
        Object.assign(this, props);
        Object.freeze(this);
    }
}
class $2da5ff557b36045b$var$RunnerState {
    constructor(props = {}){
        this.status = "UNREGISTERED";
        this.updated_on = "";
        this.version = void 0;
        this.step = void 0;
        this.error = void 0;
        Object.assign(this, props);
        Object.freeze(this);
    }
}
class $2da5ff557b36045b$var$RunnerError {
    constructor(props = {}){
        this.key = "";
        this.message = "";
        this.name = "";
        this.type = "";
        this.arguments = "";
        Object.assign(this, props);
        Object.freeze(this);
    }
}
class $2da5ff557b36045b$export$571ad3bcba5a0c45 {
    constructor(props = {}){
        this.uuid = "";
        this.name = "";
        this.labels = [];
        this.oauth_client = new $2da5ff557b36045b$var$OAuthClient();
        this.state = new $2da5ff557b36045b$var$RunnerState();
        this.error = void 0;
        this.type = "REPOSITORY";
        this.created_on = "";
        this.updated_on = "";
        Object.assign(this, {
            ...props,
            oauth_client: new $2da5ff557b36045b$var$OAuthClient(props.oauth_client),
            state: new $2da5ff557b36045b$var$RunnerState(props.state),
            error: props.error ? new $2da5ff557b36045b$var$RunnerError(props.error) : undefined
        });
        Object.freeze(this);
    }
}

});

parcelRegister("d0InP", function(module, exports) {

$parcel$export(module.exports, "Schedule", function () { return $2d50b8cdb504c3b4$export$a74e4df6c6355a42; });

var $kOiOG = parcelRequire("kOiOG");

var $fb7JV = parcelRequire("fb7JV");

var $gC76L = parcelRequire("gC76L");
class $2d50b8cdb504c3b4$var$Execution extends (0, $gC76L.ModelBase) {
    constructor(props = {}){
        super(props);
        this.pipelineUuid = "";
        this.type = "";
        this.error = {};
        this["error.type"] = "";
        this["error.key"] = "";
        this["error.message"] = "";
        Object.assign(this, {
            ...(0, $fb7JV.pick)((0, $kOiOG.flatten)(props), Object.keys(this))
        });
        Object.freeze(this);
    }
}
class $2d50b8cdb504c3b4$export$a74e4df6c6355a42 extends (0, $gC76L.ModelBase) {
    constructor(props = {}){
        super(props);
        this.uuid = "";
        this.enabled = false;
        this.cron_pattern = "";
        this.created_on = "";
        this.updated_on = "";
        this.executions = [];
        this.target = {};
        this["target.ref_name"] = "";
        this["target.ref_type"] = "branch";
        this["target.selector.type"] = "";
        this["target.selector.pattern"] = "";
        Object.assign(this, {
            ...(0, $fb7JV.pick)((0, $kOiOG.flatten)(props), Object.keys(this)),
            executions: Array.isArray(props.executions) ? props.executions.map((execution)=>new $2d50b8cdb504c3b4$var$Execution(execution)) : []
        });
        Object.freeze(this);
    }
}

});

parcelRegister("ienSH", function(module, exports) {

$parcel$export(module.exports, "ExecutionPhase", function () { return $86216b3bebf6496a$export$5814ecad787a9c42; });
$parcel$export(module.exports, "LogRange", function () { return $86216b3bebf6496a$export$9ad0c05bd07cc00d; });
$parcel$export(module.exports, "Command", function () { return $86216b3bebf6496a$export$cc7e12c76513e857; });
$parcel$export(module.exports, "ScriptCommand", function () { return $86216b3bebf6496a$export$1011edb7a48a7b0e; });
$parcel$export(module.exports, "SetupCommand", function () { return $86216b3bebf6496a$export$94a364d5386efdcc; });
$parcel$export(module.exports, "AfterScriptCommand", function () { return $86216b3bebf6496a$export$a7f5c44933437748; });
$parcel$export(module.exports, "TeardownCommand", function () { return $86216b3bebf6496a$export$6884e468caa75174; });
$parcel$export(module.exports, "RunnerDetailsCommand", function () { return $86216b3bebf6496a$export$fe30f2c32a642594; });
$parcel$export(module.exports, "CommandToggleOption", function () { return $86216b3bebf6496a$export$4bbbefaa7959c72c; });

var $cPXrv = parcelRequire("cPXrv");
var $86216b3bebf6496a$export$5814ecad787a9c42;
(function(ExecutionPhase) {
    ExecutionPhase[ExecutionPhase["RUNNER_DETAILS"] = 0] = "RUNNER_DETAILS";
    ExecutionPhase[ExecutionPhase["SETUP"] = 1] = "SETUP";
    ExecutionPhase[ExecutionPhase["MAIN"] = 2] = "MAIN";
    ExecutionPhase[ExecutionPhase["AFTER_MAIN"] = 3] = "AFTER_MAIN";
    ExecutionPhase[ExecutionPhase["TEARDOWN"] = 4] = "TEARDOWN";
})($86216b3bebf6496a$export$5814ecad787a9c42 || ($86216b3bebf6496a$export$5814ecad787a9c42 = {}));
const $86216b3bebf6496a$var$getCommandsDuration = (commands)=>{
    return (commands || []).filter((command)=>command.execution_duration).reduce((prev, current)=>prev + current.execution_duration, 0);
};
class $86216b3bebf6496a$export$9ad0c05bd07cc00d {
    constructor(props = {}){
        this.byte_count = 0;
        this.first_byte_position = 0;
        this.last_byte_position = 0;
        Object.assign(this, props);
        Object.freeze(this);
    }
}
class $86216b3bebf6496a$export$cc7e12c76513e857 {
    constructor(props = {}){
        var _props$command;
        this.command_string = "";
        this.log_range = new $86216b3bebf6496a$export$9ad0c05bd07cc00d();
        this.execution_duration = null;
        this.command = null;
        this.index = -1;
        Object.assign(this, {
            ...props,
            log_range: new $86216b3bebf6496a$export$9ad0c05bd07cc00d(props.log_range),
            index: props.index,
            execution_duration: props.execution_duration ? (0, $cPXrv.default)(props.execution_duration) : (_props$command = props.command) !== null && _props$command !== void 0 && _props$command.execution_duration ? (0, $cPXrv.default)(props.command.execution_duration) : null
        });
        Object.freeze(this);
    }
    toLegacyModel() {
        return {
            command: this.command_string,
            name: this.command_string,
            execution_duration: this.execution_duration,
            log_range: this.log_range,
            index: this.index
        };
    }
}
class $86216b3bebf6496a$export$1011edb7a48a7b0e {
    constructor(props = {}){
        this.command = "";
        this.log_range = new $86216b3bebf6496a$export$9ad0c05bd07cc00d();
        this.execution_duration = null;
        this.name = "";
        this.execution_phase = 2;
        this.index = -1;
        Object.assign(this, {
            ...props,
            log_range: new $86216b3bebf6496a$export$9ad0c05bd07cc00d(props.log_range)
        });
        Object.freeze(this);
    }
}
class $86216b3bebf6496a$export$94a364d5386efdcc extends $86216b3bebf6496a$export$1011edb7a48a7b0e {
    constructor(commands = [], logRange, index){
        super({
            command: "Build setup",
            name: "Build setup",
            log_range: new $86216b3bebf6496a$export$9ad0c05bd07cc00d(logRange),
            execution_duration: $86216b3bebf6496a$var$getCommandsDuration(commands),
            execution_phase: 1,
            index: index
        });
    }
}
class $86216b3bebf6496a$export$a7f5c44933437748 {
    constructor(props = {}){
        this.command = "";
        this.log_range = new $86216b3bebf6496a$export$9ad0c05bd07cc00d();
        this.execution_duration = null;
        this.name = "";
        this.execution_phase = 3;
        this.index = -1;
        Object.assign(this, {
            ...props,
            log_range: new $86216b3bebf6496a$export$9ad0c05bd07cc00d(props.log_range)
        });
        Object.freeze(this);
    }
}
class $86216b3bebf6496a$export$6884e468caa75174 extends $86216b3bebf6496a$export$1011edb7a48a7b0e {
    constructor(commands = [], logRange, index){
        super({
            command: "Build teardown",
            name: "Build teardown",
            log_range: new $86216b3bebf6496a$export$9ad0c05bd07cc00d(logRange),
            execution_duration: $86216b3bebf6496a$var$getCommandsDuration(commands),
            execution_phase: 4,
            index: index
        });
    }
}
class $86216b3bebf6496a$export$fe30f2c32a642594 extends $86216b3bebf6496a$export$1011edb7a48a7b0e {
    constructor(commands = [], logRange, index){
        super({
            command: "Runner details",
            name: "Runner",
            log_range: new $86216b3bebf6496a$export$9ad0c05bd07cc00d(logRange),
            execution_duration: $86216b3bebf6496a$var$getCommandsDuration(commands),
            execution_phase: 0,
            index: index
        });
    }
}
var $86216b3bebf6496a$export$4bbbefaa7959c72c;
(function(CommandToggleOption) {
    CommandToggleOption["DOWNLOADED"] = "downloadedCommands";
    CommandToggleOption["EXPANDED"] = "expandedCommands";
})($86216b3bebf6496a$export$4bbbefaa7959c72c || ($86216b3bebf6496a$export$4bbbefaa7959c72c = {}));

});

parcelRegister("iB5Tp", function(module, exports) {

$parcel$export(module.exports, "LogRequestType", function () { return $45e1d2d6b40faa1c$export$b0496eb8e3e9ffdc; });
var $45e1d2d6b40faa1c$export$b0496eb8e3e9ffdc;
(function(LogRequestType) {
    // this is to get the rest of logs for a command when it's not yet fetched but next streaming command already started
    LogRequestType["PREV_COMMAND_LOG"] = "command log";
    // current streaming request
    LogRequestType["STREAMING"] = "streaming";
    // clicks on command
    LogRequestType["CLICK"] = "command click";
    // on load to open commands automatically
    LogRequestType["ON_LOAD"] = "on load";
    // search or download
    LogRequestType["SEARCH_DOWNLOAD"] = "search & download";
})($45e1d2d6b40faa1c$export$b0496eb8e3e9ffdc || ($45e1d2d6b40faa1c$export$b0496eb8e3e9ffdc = {}));

});

parcelRegister("xJcp7", function(module, exports) {

$parcel$export(module.exports, "Tasks", function () { return $9392dbd49ceb6a26$export$77bc526bfccc9372; });
parcelRequire("e9n2v");
var $ienSH = parcelRequire("ienSH");
class $9392dbd49ceb6a26$export$2dea7024bcdd7731 {
    constructor(props){
        this.commands = [];
        this.log_range = new (0, $ienSH.LogRange)();
        Object.assign(this, {
            ...props,
            commands: Array.isArray(props.commands) ? props.commands.map((command)=>new (0, $ienSH.Command)({
                    ...command,
                    log_range: props.log_range
                })) : []
        });
        Object.freeze(this);
    }
}
class $9392dbd49ceb6a26$export$9ed6c8b828d77ceb {
    constructor(props){
        this.RUNNER_DETAILS = [];
        this.SETUP = [];
        this.MAIN = [];
        this.AFTER_MAIN = [];
        this.TEARDOWN = [];
        Object.assign(this, {
            ...Array.isArray(props.RUNNER_DETAILS) ? {
                RUNNER_DETAILS: props.RUNNER_DETAILS.map((task)=>new $9392dbd49ceb6a26$export$2dea7024bcdd7731(task))
            } : {},
            ...Array.isArray(props.SETUP) ? {
                SETUP: props.SETUP.map((task)=>new $9392dbd49ceb6a26$export$2dea7024bcdd7731(task))
            } : {},
            ...Array.isArray(props.MAIN) ? {
                MAIN: props.MAIN.map((task)=>new $9392dbd49ceb6a26$export$2dea7024bcdd7731(task))
            } : {},
            ...Array.isArray(props.AFTER_MAIN) ? {
                AFTER_MAIN: props.AFTER_MAIN.map((task)=>new $9392dbd49ceb6a26$export$2dea7024bcdd7731(task))
            } : {},
            ...Array.isArray(props.TEARDOWN) ? {
                TEARDOWN: props.TEARDOWN.map((task)=>new $9392dbd49ceb6a26$export$2dea7024bcdd7731(task))
            } : {}
        });
        Object.freeze(this);
    }
}
class $9392dbd49ceb6a26$export$77bc526bfccc9372 {
    constructor(props){
        this.execution_phases = void 0;
        Object.assign(this, {
            ...props,
            ...props.execution_phases ? {
                execution_phases: new $9392dbd49ceb6a26$export$9ed6c8b828d77ceb(props.execution_phases)
            } : {}
        });
        Object.freeze(this);
    }
    get runnerDetailsCommand() {
        const tasks = this.execution_phases.RUNNER_DETAILS;
        if (!(tasks && tasks.length)) return undefined;
        if (Object.keys(tasks).length > 0) return new (0, $ienSH.RunnerDetailsCommand)(this.legacyScriptCommands(tasks), tasks[0].log_range);
        return undefined;
    }
    get setupCommand() {
        const tasks = this.execution_phases.SETUP;
        // Setup should have one task.
        const logRange = tasks[0] === undefined ? new (0, $ienSH.LogRange)() : tasks[0].log_range;
        return new (0, $ienSH.SetupCommand)(this.legacyScriptCommands(tasks), logRange);
    }
    get mainCommands() {
        return this.legacyScriptCommands(this.execution_phases.MAIN);
    }
    get afterMainCommands() {
        return this.legacyAfterScriptCommands(this.execution_phases.AFTER_MAIN);
    }
    get teardownCommand() {
        const tasks = this.execution_phases.TEARDOWN;
        // Teardown should have one task.
        const logRange = tasks[0] === undefined ? new (0, $ienSH.LogRange)() : tasks[0].log_range;
        return new (0, $ienSH.TeardownCommand)(this.legacyScriptCommands(tasks), logRange);
    }
    convertToCommands() {
        return [
            this.runnerDetailsCommand,
            this.setupCommand,
            ...this.mainCommands,
            ...this.afterMainCommands,
            this.teardownCommand
        ].filter((command)=>!!command).map((command, index)=>{
            if (command instanceof (0, $ienSH.RunnerDetailsCommand)) return new (0, $ienSH.RunnerDetailsCommand)([
                command
            ], command.log_range, index);
            else if (command instanceof (0, $ienSH.SetupCommand)) return new (0, $ienSH.SetupCommand)([
                command
            ], command.log_range, index);
            else if (command instanceof (0, $ienSH.TeardownCommand)) return new (0, $ienSH.TeardownCommand)([
                command
            ], command.log_range, index);
            else if (command instanceof (0, $ienSH.AfterScriptCommand)) return new (0, $ienSH.AfterScriptCommand)({
                ...command,
                index: index
            });
            else return new (0, $ienSH.ScriptCommand)({
                ...command,
                index: index
            });
        });
    }
    legacyScriptCommands(tasks) {
        return tasks.flatMap((task)=>task === null || task === void 0 ? void 0 : task.commands).map((command)=>new (0, $ienSH.ScriptCommand)(command.toLegacyModel()));
    }
    legacyAfterScriptCommands(tasks) {
        return tasks.flatMap((task)=>task === null || task === void 0 ? void 0 : task.commands).map((command)=>new (0, $ienSH.AfterScriptCommand)(command.toLegacyModel()));
    }
}

});

parcelRegister("8qMkI", function(module, exports) {

$parcel$export(module.exports, "SearchLog", function () { return $49fbce78fcc08c02$export$f2b301e7c4c54858; });
class $49fbce78fcc08c02$export$f2b301e7c4c54858 {
    constructor(props = {}){
        this.matchedLines = [];
        this.currentLineIndex = -1;
        this.isEnabled = false;
        this.isErrored = false;
        this.search = "";
        Object.assign(this, props);
        Object.freeze(this);
    }
}

});

parcelRegister("1Lyl8", function(module, exports) {

});

parcelRegister("h88sh", function(module, exports) {

});

parcelRegister("hwD0l", function(module, exports) {

$parcel$export(module.exports, "StepGroupType", function () { return $7976c6add59288d0$export$167d469e2c94ff0d; });
$parcel$export(module.exports, "StepGroup", function () { return $7976c6add59288d0$export$b679efb6569841d9; });
var $7976c6add59288d0$export$167d469e2c94ff0d;
(function(StepGroupType) {
    StepGroupType[StepGroupType["SINGLE"] = 0] = "SINGLE";
    StepGroupType[StepGroupType["PARALLEL"] = 1] = "PARALLEL";
    StepGroupType[StepGroupType["STAGE"] = 2] = "STAGE";
})($7976c6add59288d0$export$167d469e2c94ff0d || ($7976c6add59288d0$export$167d469e2c94ff0d = {}));
class $7976c6add59288d0$export$b679efb6569841d9 {
    constructor(props = {}){
        this.key = "";
        this.steps = [];
        this.type = 0;
        Object.assign(this, props);
        Object.freeze(this);
    }
}

});

parcelRegister("6vGsr", function(module, exports) {

$parcel$export(module.exports, "EditorEnum", function () { return $f551b1d3763d8d7e$export$68731a872674c5e8; });
$parcel$export(module.exports, "Validator", function () { return $f551b1d3763d8d7e$export$9eeb22c0bba4ed5e; });
var $f551b1d3763d8d7e$export$68731a872674c5e8;
(function(EditorEnum) {
    EditorEnum["DeploymentsOnboarding"] = "deployments_onboarding";
    EditorEnum["PipelinesOnboarding"] = "pipelines_onboarding";
    EditorEnum["PipelinesOnboardingEnable"] = "pipelines_onboarding_enable";
    EditorEnum["Source"] = "source";
})($f551b1d3763d8d7e$export$68731a872674c5e8 || ($f551b1d3763d8d7e$export$68731a872674c5e8 = {}));
class $f551b1d3763d8d7e$export$9eeb22c0bba4ed5e {
    constructor(props = {}){
        this.isValid = false;
        this.code = "";
        this.template = "";
        this.currentEditor = null;
        Object.assign(this, props);
        Object.freeze(this);
    }
}

});

parcelRegister("iUiPN", function(module, exports) {

$parcel$export(module.exports, "Variable", function () { return $be69505e94c2e7f0$export$c867a5c9595a1350; });

var $gC76L = parcelRequire("gC76L");
class $be69505e94c2e7f0$export$c867a5c9595a1350 extends (0, $gC76L.ModelBase) {
    constructor(props = {}){
        super(props);
        this.uuid = "";
        this.key = "";
        this.value = "";
        this.secured = false;
        this.isSyncing = false;
        this.error = null;
        Object.assign(this, props);
        Object.freeze(this);
    }
}

});


parcelRegister("QgM08", function(module, exports) {

$parcel$export(module.exports, "createErrorMessage", function () { return $72a3cb1879df4e41$export$a2b2d8b55704c18e; });
$parcel$export(module.exports, "capturePipelinesExceptionWithTags", function () { return $72a3cb1879df4e41$export$fa29e2575ecd90b8; });
$parcel$export(module.exports, "isIgnoredErrorForSentry", function () { return $72a3cb1879df4e41$export$b177e05f60d1620; });

var $628YF = parcelRequire("628YF");

var $i3LMs = parcelRequire("i3LMs");
const $72a3cb1879df4e41$var$SKIP_FLAG = "__skip__";
const $72a3cb1879df4e41$export$7206bd037e9f9369 = "Response undefined";
const $72a3cb1879df4e41$export$75a3b26199cf91a3 = "Response content undefined";
const $72a3cb1879df4e41$var$extracMessageFromJSON = (json, defaultMessage = $72a3cb1879df4e41$export$75a3b26199cf91a3)=>{
    var _json$error;
    // our server seems returning a inconsistent data structure for errors ATM
    // It uses {error: {meesage: string}} and {message: string} interchangably
    if ((_json$error = json.error) !== null && _json$error !== void 0 && _json$error.message || json.message) {
        var _json$error2;
        return ((_json$error2 = json.error) === null || _json$error2 === void 0 ? void 0 : _json$error2.message) || json.message;
    }
    if (JSON.stringify(json) !== "{}") return JSON.stringify(json);
    return defaultMessage;
};
const $72a3cb1879df4e41$export$a2b2d8b55704c18e = async (res)=>{
    if (!res) return $72a3cb1879df4e41$export$7206bd037e9f9369;
    try {
        // try catch is needed to avoid calling .json() on an empty response, i.e. new Resposne() or new Response('')
        // which will throw an Unexpected end of JSON input error to Sentry
        let errorMessage = `${res.status}: ${res.statusText}`;
        const resClone = res.clone(); // using clone here to avoid calling `.json` or `.text` directly to cause a `Already Read` error
        const contentType = resClone.headers.get("Content-Type") || "";
        if (contentType.includes("application/json")) {
            const json = await resClone.json();
            errorMessage = $72a3cb1879df4e41$var$extracMessageFromJSON(json);
        } else {
            const text = await resClone.text();
            if (!text || !text.length) return $72a3cb1879df4e41$export$75a3b26199cf91a3;
            errorMessage = text || errorMessage;
        }
        return errorMessage;
    } catch (error) {
        return error.toString();
    }
};
const $72a3cb1879df4e41$export$fa29e2575ecd90b8 = (e, tags, extras)=>{
    var _e$message;
    if ((e === null || e === void 0 ? void 0 : (_e$message = e.message) === null || _e$message === void 0 ? void 0 : _e$message.toLowerCase()) === $72a3cb1879df4e41$var$SKIP_FLAG) return;
    const mergedTags = {
        ...tags,
        app: (0, $i3LMs.PIPELINES_SENTRY_PRIMARY_TAG)
    };
    (0, $628YF.captureExceptionWithTags)(e, mergedTags, extras);
};
const $72a3cb1879df4e41$var$defaultSkipMessages = [
    // resource not found
    "Resource not found",
    "Not found",
    // enable two-step verifications
    "To access this team, enable two-step verification.",
    "To access this user, enable two-step verification.",
    "To access this repository, enable two-step verification.",
    // whitelist ip address
    "To access this repository, an admin must whitelist your IP.",
    "To access this user, an admin must whitelist your IP.",
    "To access this team, an admin must whitelist your IP.",
    // access limits
    "You may not have access to this repository or it no longer exists in this workspace",
    // gateway errors
    "<html> <head><title>504 Gateway Time-out</title>",
    "<html> <head><title>502 Bad Gateway</title>"
];
const $72a3cb1879df4e41$export$b177e05f60d1620 = (e, messagesToSkip = [])=>{
    const skipMessages = [
        ...$72a3cb1879df4e41$var$defaultSkipMessages,
        ...messagesToSkip
    ].map((message)=>message.toLowerCase());
    if (!(e !== null && e !== void 0 && e.message)) return false;
    return skipMessages.includes(e.message.toLowerCase()) || skipMessages.some((message)=>e.message.toLowerCase().startsWith(message));
};

});

parcelRegister("8K6h8", function(module, exports) {

$parcel$export(module.exports, "getWebsocketSubscriptions", function () { return $a9bbbf0abab21f69$export$1c58a127de45506b; });
$parcel$export(module.exports, "getAccount", function () { return $a9bbbf0abab21f69$export$4f9234baf34abd0; });
$parcel$export(module.exports, "getAllowance", function () { return $a9bbbf0abab21f69$export$64c885348b2f1759; });
$parcel$export(module.exports, "getCaches", function () { return $a9bbbf0abab21f69$export$1a68308a4689c504; });
$parcel$export(module.exports, "getSchedules", function () { return $a9bbbf0abab21f69$export$db731c12fd4796f8; });
$parcel$export(module.exports, "getScheduleStatus", function () { return $a9bbbf0abab21f69$export$53c9fcc425ee5ffe; });
$parcel$export(module.exports, "getCapabilities", function () { return $a9bbbf0abab21f69$export$80a6dbd652bdbd9e; });
$parcel$export(module.exports, "getJsdChecks", function () { return $a9bbbf0abab21f69$export$c452fbbd0e2da871; });
$parcel$export(module.exports, "getCheckSuite", function () { return $a9bbbf0abab21f69$export$e176aa4bad41e3a9; });
$parcel$export(module.exports, "getRepository", function () { return $a9bbbf0abab21f69$export$feac2a21aec844b7; });
$parcel$export(module.exports, "getPipelineDefinitions", function () { return $a9bbbf0abab21f69$export$1432fa6fe5c5097f; });
$parcel$export(module.exports, "getSearchLog", function () { return $a9bbbf0abab21f69$export$9ef5078e4ced4a18; });
$parcel$export(module.exports, "getIsFetchingSearchLog", function () { return $a9bbbf0abab21f69$export$68ebaf089a8fbe9e; });
$parcel$export(module.exports, "getIsSearchingLog", function () { return $a9bbbf0abab21f69$export$a2a18447a5c886dc; });
$parcel$export(module.exports, "getIsDeletingLog", function () { return $a9bbbf0abab21f69$export$4756d761cde0354d; });
$parcel$export(module.exports, "getPipelines", function () { return $a9bbbf0abab21f69$export$1bd86c056cec054; });
$parcel$export(module.exports, "getPipelinesSize", function () { return $a9bbbf0abab21f69$export$96ebba4347b3369f; });
$parcel$export(module.exports, "getCurrentPipeline", function () { return $a9bbbf0abab21f69$export$779e33800fe36f98; });
$parcel$export(module.exports, "getIsLoadingCurrentPipeline", function () { return $a9bbbf0abab21f69$export$88cd0a76f0284a21; });
$parcel$export(module.exports, "getDynamicPipelinesConfiguration", function () { return $a9bbbf0abab21f69$export$94aa76c774514415; });
$parcel$export(module.exports, "getPipelineCreators", function () { return $a9bbbf0abab21f69$export$6d981156adfb7d0c; });
$parcel$export(module.exports, "getCurrentStepUuid", function () { return $a9bbbf0abab21f69$export$300277564f59c56a; });
$parcel$export(module.exports, "getFetchedStepBranchRestrictionsMap", function () { return $a9bbbf0abab21f69$export$658b23ccbe549fa4; });
$parcel$export(module.exports, "getIsFetchingStepBranchRestrictionsMap", function () { return $a9bbbf0abab21f69$export$18736c5c42c3e926; });
$parcel$export(module.exports, "getCurrentStep", function () { return $a9bbbf0abab21f69$export$613fded3c60df0c1; });
$parcel$export(module.exports, "getCommandsForCurrentStep", function () { return $a9bbbf0abab21f69$export$7c357f23b6ac13e5; });
$parcel$export(module.exports, "getExpandedCommands", function () { return $a9bbbf0abab21f69$export$dd7509b9b3a53d6f; });
$parcel$export(module.exports, "getStepGroups", function () { return $a9bbbf0abab21f69$export$6c90cdd3ff0dd47f; });
$parcel$export(module.exports, "getStepsMap", function () { return $a9bbbf0abab21f69$export$64866adc4b1786c3; });
$parcel$export(module.exports, "getIsLoadingSteps", function () { return $a9bbbf0abab21f69$export$39e6214f6f530fd9; });
$parcel$export(module.exports, "getStepsEnvironments", function () { return $a9bbbf0abab21f69$export$de875f97f0a44dc6; });
$parcel$export(module.exports, "getRunningManualStep", function () { return $a9bbbf0abab21f69$export$84becaaae15e7c29; });
$parcel$export(module.exports, "getStageActionInProgress", function () { return $a9bbbf0abab21f69$export$6df5d5c45b7900e6; });
$parcel$export(module.exports, "getIsFetchingStepRerun", function () { return $a9bbbf0abab21f69$export$92c0ff49dc5e24e6; });
$parcel$export(module.exports, "getRerunnableStepWithEnvironment", function () { return $a9bbbf0abab21f69$export$ff905560497913c3; });
$parcel$export(module.exports, "getHasAdvancedFeatures", function () { return $a9bbbf0abab21f69$export$18d3493109ace51a; });
$parcel$export(module.exports, "getArtifactsForCurrentStep", function () { return $a9bbbf0abab21f69$export$299ede9a6001fc94; });
$parcel$export(module.exports, "getCommitPullRequests", function () { return $a9bbbf0abab21f69$export$3c88cc7730e5fde3; });
$parcel$export(module.exports, "getReports", function () { return $a9bbbf0abab21f69$export$9dc937f1c1abf620; });
$parcel$export(module.exports, "getAnnotations", function () { return $a9bbbf0abab21f69$export$ef1244b182aaad16; });
$parcel$export(module.exports, "getIsFetchingReports", function () { return $a9bbbf0abab21f69$export$9f7290a228c004f2; });
$parcel$export(module.exports, "getIsFetchingAnnotations", function () { return $a9bbbf0abab21f69$export$816f3271eba56708; });
$parcel$export(module.exports, "getIsFetchingArtifactsForCurrentStep", function () { return $a9bbbf0abab21f69$export$5b587e016b018791; });
$parcel$export(module.exports, "getStepLogForCurrentStep", function () { return $a9bbbf0abab21f69$export$542567682a9f11a6; });
$parcel$export(module.exports, "getFullLogForCurrentStep", function () { return $a9bbbf0abab21f69$export$90ce9158a13365f7; });
$parcel$export(module.exports, "getFullLogErrorForCurrentStep", function () { return $a9bbbf0abab21f69$export$aa420eff6f342287; });
$parcel$export(module.exports, "getInfiniteLog", function () { return $a9bbbf0abab21f69$export$3fb4a76714ca85bd; });
$parcel$export(module.exports, "getExpandedInfiniteLog", function () { return $a9bbbf0abab21f69$export$1208c0fe20b7a8d1; });
$parcel$export(module.exports, "getExpandedInfiniteLogV2", function () { return $a9bbbf0abab21f69$export$c81434cb3861cbd; });
$parcel$export(module.exports, "getIsCommandDownloaded", function () { return $a9bbbf0abab21f69$export$142e99d57c981904; });
$parcel$export(module.exports, "getIsCommandExpanded", function () { return $a9bbbf0abab21f69$export$c058670d9789fed3; });
$parcel$export(module.exports, "getIsCommandErrored", function () { return $a9bbbf0abab21f69$export$4ba00871dce7de5d; });
$parcel$export(module.exports, "getIsCommandFailed", function () { return $a9bbbf0abab21f69$export$c2570e1ae6834905; });
$parcel$export(module.exports, "getStreamingCommands", function () { return $a9bbbf0abab21f69$export$3d0ae289c1f4e1c5; });
$parcel$export(module.exports, "getStatusOfFailureUpdate", function () { return $a9bbbf0abab21f69$export$ff08b8b89f7bdc73; });
$parcel$export(module.exports, "getIsCommandStreaming", function () { return $a9bbbf0abab21f69$export$4c8b28e1f7edbb9a; });
$parcel$export(module.exports, "getIsFetchingLog", function () { return $a9bbbf0abab21f69$export$b2a7e76edcf99b25; });
$parcel$export(module.exports, "getServiceLog", function () { return $a9bbbf0abab21f69$export$8f12134bcd879d07; });
$parcel$export(module.exports, "getServiceLogErrorForCurrentStep", function () { return $a9bbbf0abab21f69$export$daddc6c30303365c; });
$parcel$export(module.exports, "getValidator", function () { return $a9bbbf0abab21f69$export$be56ab521bea75bf; });
$parcel$export(module.exports, "getBuildConfiguration", function () { return $a9bbbf0abab21f69$export$2a19cfb8ab424702; });
$parcel$export(module.exports, "getVariables", function () { return $a9bbbf0abab21f69$export$a39eddd73bba62c1; });
$parcel$export(module.exports, "getVariablesFetchedStatus", function () { return $a9bbbf0abab21f69$export$4546ffa32575c0b; });
$parcel$export(module.exports, "getIsFetchingVariables", function () { return $a9bbbf0abab21f69$export$2b6ac0d7908c6703; });
$parcel$export(module.exports, "getVariablesPage", function () { return $a9bbbf0abab21f69$export$6dd14031e1764dae; });
$parcel$export(module.exports, "getVariablesHasNextPage", function () { return $a9bbbf0abab21f69$export$bb1b31498a657104; });
$parcel$export(module.exports, "getEnvironmentVariables", function () { return $a9bbbf0abab21f69$export$f1c776cb49b942a7; });
$parcel$export(module.exports, "getEnvironmentVariablesFetchState", function () { return $a9bbbf0abab21f69$export$503ec2006e4f049f; });
$parcel$export(module.exports, "getEnvironmentVariablesPage", function () { return $a9bbbf0abab21f69$export$99eb4ba42b80aa54; });
$parcel$export(module.exports, "getEnvironmentVariablesHasNextPage", function () { return $a9bbbf0abab21f69$export$b02e9be308edea8; });
$parcel$export(module.exports, "getIsLoadingPipelines", function () { return $a9bbbf0abab21f69$export$76283ef2fb1d0bee; });
$parcel$export(module.exports, "getMemoryLimits", function () { return $a9bbbf0abab21f69$export$9dcb6e650f76fc17; });
$parcel$export(module.exports, "getCpuLimits", function () { return $a9bbbf0abab21f69$export$b8c02c1e708844ab; });
$parcel$export(module.exports, "getIsFetchingMetrics", function () { return $a9bbbf0abab21f69$export$295d05d0016d4157; });
$parcel$export(module.exports, "getMemoryMetrics", function () { return $a9bbbf0abab21f69$export$500422125b861bab; });
$parcel$export(module.exports, "getCpuMetrics", function () { return $a9bbbf0abab21f69$export$c04781ed4787bbb; });
$parcel$export(module.exports, "getMaxMemoryPercentage", function () { return $a9bbbf0abab21f69$export$901bc7665d054a91; });
$parcel$export(module.exports, "getContainerStates", function () { return $a9bbbf0abab21f69$export$9a7d64a22ec4b6c5; });
$parcel$export(module.exports, "getExpandedTestCaseMap", function () { return $a9bbbf0abab21f69$export$8be0ed3098589556; });
$parcel$export(module.exports, "getIsFetchingFailedTestCases", function () { return $a9bbbf0abab21f69$export$ca6dabb3daff3fa2; });
$parcel$export(module.exports, "getIsFetchingTestReasonMap", function () { return $a9bbbf0abab21f69$export$3361b72276af4ca2; });
$parcel$export(module.exports, "getFailedTestCases", function () { return $a9bbbf0abab21f69$export$acb394624f4efdbc; });
$parcel$export(module.exports, "getTestCaseReasonMap", function () { return $a9bbbf0abab21f69$export$ab96d903e8b2b235; });
$parcel$export(module.exports, "getTestCaseErrorMap", function () { return $a9bbbf0abab21f69$export$9bb5643a5602bc5c; });
$parcel$export(module.exports, "getIsFetchingCaches", function () { return $a9bbbf0abab21f69$export$37e27bf8ff5a63a8; });
$parcel$export(module.exports, "getIsFetchingSchedules", function () { return $a9bbbf0abab21f69$export$7049a8765a89d1c1; });
$parcel$export(module.exports, "getStepDeploymentPreview", function () { return $a9bbbf0abab21f69$export$27c93e2ff6ea9c9; });
$parcel$export(module.exports, "getStepRedeployment", function () { return $a9bbbf0abab21f69$export$74cfee117ba649fc; });
$parcel$export(module.exports, "getHasOnboardedPipelines", function () { return $a9bbbf0abab21f69$export$ebffb984ee4c30c2; });

var $aXXtM = parcelRequire("aXXtM");
parcelRequire("e9n2v");
var $goDEr = parcelRequire("goDEr");
var $ienSH = parcelRequire("ienSH");
var $gPp1Y = parcelRequire("gPp1Y");
var $hwD0l = parcelRequire("hwD0l");

var $FFxTU = parcelRequire("FFxTU");

var $90kWr = parcelRequire("90kWr");

var $aanBq = parcelRequire("aanBq");

var $7qdXF = parcelRequire("7qdXF");

var $h3kk7 = parcelRequire("h3kk7");

var $i3LMs = parcelRequire("i3LMs");
const $a9bbbf0abab21f69$export$1c58a127de45506b = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), ({ deployments: deployments })=>deployments.websocket);
const $a9bbbf0abab21f69$export$4f9234baf34abd0 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>pipelines.account);
const $a9bbbf0abab21f69$export$64c885348b2f1759 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>pipelines.allowance);
const $a9bbbf0abab21f69$export$1a68308a4689c504 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>pipelines.caches.list);
const $a9bbbf0abab21f69$export$db731c12fd4796f8 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>pipelines.schedules.list);
const $a9bbbf0abab21f69$export$53c9fcc425ee5ffe = (0, $aXXtM.createSelector)([
    (0, $7qdXF.getPipelines)
], (pipelines)=>pipelines.schedules.createdStatus);
const $a9bbbf0abab21f69$export$80a6dbd652bdbd9e = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>pipelines.capabilities);
const $a9bbbf0abab21f69$export$c452fbbd0e2da871 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>pipelines.jsdChecks);
const $a9bbbf0abab21f69$export$e176aa4bad41e3a9 = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$c452fbbd0e2da871, (jsdChecks)=>(checkSuiteId)=>jsdChecks.checks.check_suites[checkSuiteId]);
const $a9bbbf0abab21f69$export$feac2a21aec844b7 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>pipelines.repository);
const $a9bbbf0abab21f69$export$1432fa6fe5c5097f = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>pipelines.definitions);
const $a9bbbf0abab21f69$export$29ce6c7518aa120 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>pipelines.log);
const $a9bbbf0abab21f69$export$9ef5078e4ced4a18 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>pipelines.searchLog.searchLog);
const $a9bbbf0abab21f69$export$68ebaf089a8fbe9e = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>pipelines.searchLog.fetchedStatus === (0, $90kWr.LoadingStatus).Fetching);
const $a9bbbf0abab21f69$export$a2a18447a5c886dc = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>pipelines.searchLog.searchedStatus === (0, $90kWr.LoadingStatus).Fetching);
const $a9bbbf0abab21f69$export$4756d761cde0354d = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$29ce6c7518aa120, (pipelines)=>pipelines.fetchedStatus.DELETE_LOG === (0, $90kWr.LoadingStatus).Fetching);
const $a9bbbf0abab21f69$export$1bd86c056cec054 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    return pipelines.pipelines.list;
});
const $a9bbbf0abab21f69$export$96ebba4347b3369f = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    return pipelines.pipelines.size;
});
const $a9bbbf0abab21f69$export$4614a1350c25bcbf = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    return pipelines.pipelines.page;
});
const $a9bbbf0abab21f69$export$779e33800fe36f98 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    return pipelines.currentPipeline.pipeline;
});
const $a9bbbf0abab21f69$export$88cd0a76f0284a21 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (state)=>{
    const { fetchedStatus: fetchedStatus } = state.currentPipeline;
    return fetchedStatus === (0, $90kWr.LoadingStatus).Before || fetchedStatus === (0, $90kWr.LoadingStatus).Fetching;
});
const $a9bbbf0abab21f69$export$94aa76c774514415 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    const configurationSources = pipelines.currentPipeline.pipeline.configuration_sources;
    const lastConfigurationSource = configurationSources[configurationSources.length - 1];
    if (lastConfigurationSource.source && [
        "DYNAMIC_REPOSITORY",
        "DYNAMIC_WORKSPACE"
    ].includes(lastConfigurationSource.source)) return lastConfigurationSource;
    return {
        uri: undefined,
        source: undefined
    };
});
const $a9bbbf0abab21f69$export$6d981156adfb7d0c = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (0, $FFxTU.getCurrentUserAsPipelinesUser), (pipelines, currentUser)=>{
    if (currentUser != null && pipelines.pipelines.creators.length > 0) return [
        currentUser,
        ...pipelines.pipelines.creators.filter((c)=>c.uuid !== currentUser.uuid)
    ];
    else return pipelines.pipelines.creators;
});
const $a9bbbf0abab21f69$export$300277564f59c56a = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    return pipelines.steps.currentStepUuid;
});
const $a9bbbf0abab21f69$export$658b23ccbe549fa4 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    return pipelines.steps.fetchedBranchRestrictions;
});
const $a9bbbf0abab21f69$export$18736c5c42c3e926 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    return Object.keys(pipelines.steps.fetchedBranchRestrictions).reduce((reducer, key)=>{
        reducer[key] = pipelines.steps.fetchedBranchRestrictions[key] === (0, $90kWr.LoadingStatus).Fetching;
        return reducer;
    }, {});
});
const $a9bbbf0abab21f69$export$9e8c183033ae8e8 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    return pipelines.testReport;
});
const $a9bbbf0abab21f69$export$613fded3c60df0c1 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    if (!pipelines.steps.map || !(pipelines.steps.map instanceof Map)) return new (0, $gPp1Y.Step)();
    return pipelines.steps.map.get(pipelines.steps.currentStepUuid) || new (0, $gPp1Y.Step)();
});
const $a9bbbf0abab21f69$export$ac9680dffe0dce26 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    return pipelines.steps.commands;
});
const $a9bbbf0abab21f69$export$7c357f23b6ac13e5 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    return pipelines.steps.commands[pipelines.steps.currentStepUuid] || [];
});
const $a9bbbf0abab21f69$export$dd7509b9b3a53d6f = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>pipelines.steps.expandedCommands || {});
const $a9bbbf0abab21f69$export$ffc532e95200bbed = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>pipelines.steps.expandedCommands[pipelines.steps.currentStepUuid] || []);
const $a9bbbf0abab21f69$export$21f19681183d5ca0 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>pipelines.steps.downloadedCommands[pipelines.steps.currentStepUuid] || []);
const $a9bbbf0abab21f69$export$e9b5c06e3c850e00 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>pipelines.steps.erroredCommands[pipelines.steps.currentStepUuid] || []);
const $a9bbbf0abab21f69$export$7999c56c295d200b = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    return pipelines.steps.streamingCommands[pipelines.steps.currentStepUuid] || [];
});
const $a9bbbf0abab21f69$export$6c90cdd3ff0dd47f = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    // console.log('get Step Groups')
    // console.log(pipelines)
    // problem is this goes from [StepGroup] with steps: Array(2)
    // to [StepGroup, StepGroup] with steps: Array[1]
    return pipelines.steps.groups;
});
const $a9bbbf0abab21f69$export$64866adc4b1786c3 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    // @ts-ignore use es2019 lib
    return Object.fromEntries(pipelines.steps.map);
});
const $a9bbbf0abab21f69$export$39e6214f6f530fd9 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (state)=>{
    const { fetchedStatus: fetchedStatus } = state.steps;
    return fetchedStatus === (0, $90kWr.LoadingStatus).Before || fetchedStatus === (0, $90kWr.LoadingStatus).Fetching;
});
const $a9bbbf0abab21f69$export$de875f97f0a44dc6 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    return pipelines.steps.environments;
});
const $a9bbbf0abab21f69$export$84becaaae15e7c29 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    return pipelines.steps.runningManualStep;
});
const $a9bbbf0abab21f69$export$6df5d5c45b7900e6 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    return pipelines.steps.stageActionInProgress;
});
const $a9bbbf0abab21f69$export$92c0ff49dc5e24e6 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    return pipelines.steps.fetchedStepRerunStatus === (0, $90kWr.LoadingStatus).Fetching;
});
const $a9bbbf0abab21f69$export$ff905560497913c3 = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$64866adc4b1786c3, (stepsMap)=>Object.values(stepsMap).filter((step)=>step.isRerunnable && step.hasEnvironment)[0]);
const $a9bbbf0abab21f69$export$e5de6dd31f3364ba = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$64866adc4b1786c3, (stepsMap)=>Object.values(stepsMap).some((step)=>step.isRedeployed && step.isRerunnable));
const $a9bbbf0abab21f69$export$18d3493109ace51a = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$64866adc4b1786c3, $a9bbbf0abab21f69$export$779e33800fe36f98, $a9bbbf0abab21f69$export$6c90cdd3ff0dd47f, (stepsMap, pipeline, groups)=>{
    const steps = Object.values(stepsMap);
    const hasRerun = pipeline.run_number > 1;
    const has2xStep = steps.some((step)=>step.stepSize > 1);
    const hasParallelGroup = groups && groups.some((group)=>group.type === (0, $hwD0l.StepGroupType).PARALLEL);
    return steps.length > 0 && (has2xStep || hasParallelGroup || hasRerun) && pipeline.isComplete;
});
const $a9bbbf0abab21f69$export$299ede9a6001fc94 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    return pipelines.artifacts.map[pipelines.steps.currentStepUuid] || [];
});
const $a9bbbf0abab21f69$export$3c88cc7730e5fde3 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    return pipelines.commitPullRequests;
});
const $a9bbbf0abab21f69$export$9dc937f1c1abf620 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), $a9bbbf0abab21f69$export$80a6dbd652bdbd9e, (pipelines, capabilities)=>{
    return (pipelines.reports.list || []).map((report, index)=>{
        var _report$toJS;
        return {
            ...report === null || report === void 0 ? void 0 : (_report$toJS = report.toJS) === null || _report$toJS === void 0 ? void 0 : _report$toJS.call(report),
            is_locked: !capabilities.isPaidOrPremium && index + 1 > (0, $i3LMs.FREE_REPORTS_LIMIT)
        };
    });
});
const $a9bbbf0abab21f69$export$ef1244b182aaad16 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    return pipelines.reports.annotations || [];
});
const $a9bbbf0abab21f69$export$9f7290a228c004f2 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    return pipelines.reports.fetchedStatus === (0, $90kWr.LoadingStatus).Fetching;
});
const $a9bbbf0abab21f69$export$816f3271eba56708 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    return pipelines.reports.fetchedAnnotationStatus === (0, $90kWr.LoadingStatus).Fetching;
});
const $a9bbbf0abab21f69$export$5b587e016b018791 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    return pipelines.artifacts.fetchedStatus[pipelines.steps.currentStepUuid] === (0, $90kWr.LoadingStatus).Fetching;
});
const $a9bbbf0abab21f69$export$542567682a9f11a6 = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$300277564f59c56a, $a9bbbf0abab21f69$export$29ce6c7518aa120, (stepUuid, log)=>log.stepLogs[stepUuid] || new Map());
const $a9bbbf0abab21f69$export$fb46371568a67361 = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$300277564f59c56a, $a9bbbf0abab21f69$export$29ce6c7518aa120, (stepUuid, log)=>log.commands[stepUuid] || []);
const $a9bbbf0abab21f69$export$d2e5814ffa1d801e = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$300277564f59c56a, $a9bbbf0abab21f69$export$29ce6c7518aa120, (stepUuid, log)=>log.commandsV2[stepUuid] || []);
const $a9bbbf0abab21f69$export$d8a672b5c4761204 = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$fb46371568a67361, (logCommands)=>logCommands[logCommands.length - 1]);
const $a9bbbf0abab21f69$export$90ce9158a13365f7 = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$300277564f59c56a, $a9bbbf0abab21f69$export$29ce6c7518aa120, (stepUuid, log)=>log.fullLog[stepUuid]);
const $a9bbbf0abab21f69$export$aa420eff6f342287 = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$300277564f59c56a, $a9bbbf0abab21f69$export$29ce6c7518aa120, (stepUuid, log)=>log.fullLogError[stepUuid]);
const $a9bbbf0abab21f69$export$3fb4a76714ca85bd = (incrementalRequestEnabled = false)=>(0, $aXXtM.createSelector)(incrementalRequestEnabled ? $a9bbbf0abab21f69$export$d2e5814ffa1d801e : $a9bbbf0abab21f69$export$fb46371568a67361, $a9bbbf0abab21f69$export$7c357f23b6ac13e5, $a9bbbf0abab21f69$export$ffc532e95200bbed, $a9bbbf0abab21f69$export$21f19681183d5ca0, (logCommands, commands, expandedCommands, downloadedCommands)=>{
        return commands.map((command, index)=>{
            const logForCommand = logCommands[index] || [];
            const expandedLog = logForCommand[logForCommand.length - 1] !== "" ? logForCommand.concat("") : logForCommand;
            const isExpanded = expandedCommands[index];
            const isDownloaded = downloadedCommands[index];
            return isExpanded && isDownloaded ? [
                command,
                ...expandedLog
            ] : [
                command
            ];
        }).flat();
    });
const $a9bbbf0abab21f69$export$1208c0fe20b7a8d1 = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$fb46371568a67361, $a9bbbf0abab21f69$export$7c357f23b6ac13e5, $a9bbbf0abab21f69$export$21f19681183d5ca0, (logCommands, commands, downloadedCommands)=>commands.map((command, index)=>{
        const logForCommand = logCommands[index] || [];
        const expandedLog = logForCommand[logForCommand.length - 1] !== "" ? logForCommand.concat("") : logForCommand;
        const isDownloaded = downloadedCommands[index];
        return isDownloaded ? [
            command,
            ...expandedLog
        ] : [
            command
        ];
    }).flat());
const $a9bbbf0abab21f69$export$c81434cb3861cbd = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$d2e5814ffa1d801e, $a9bbbf0abab21f69$export$7c357f23b6ac13e5, $a9bbbf0abab21f69$export$21f19681183d5ca0, (logCommands, commands, downloadedCommands)=>commands.map((command, index)=>{
        const logForCommand = logCommands[index] || [];
        const expandedLog = logForCommand[logForCommand.length - 1] !== "" ? logForCommand.concat("") : logForCommand;
        const isDownloaded = downloadedCommands[index];
        return isDownloaded ? [
            command,
            ...expandedLog
        ] : [
            command
        ];
    }).flat());
const $a9bbbf0abab21f69$export$142e99d57c981904 = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$21f19681183d5ca0, (downloadedCommands)=>(command)=>!!downloadedCommands[command.index]);
const $a9bbbf0abab21f69$export$c058670d9789fed3 = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$ffc532e95200bbed, (expandedCommands)=>(command)=>!!expandedCommands[command.index]);
const $a9bbbf0abab21f69$export$4ba00871dce7de5d = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$e9b5c06e3c850e00, (erroredCommands)=>(command)=>!!erroredCommands[command.index]);
const $a9bbbf0abab21f69$export$81d46cbe2a5cce6e = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$613fded3c60df0c1, $a9bbbf0abab21f69$export$7c357f23b6ac13e5, (step, commands)=>{
    if (!step.isFailed) return undefined;
    const filteredCommands = commands.filter((cmd)=>cmd.execution_phase === (0, $ienSH.ExecutionPhase).MAIN && cmd.log_range.byte_count > 0);
    return filteredCommands[filteredCommands.length - 1];
});
const $a9bbbf0abab21f69$export$c2570e1ae6834905 = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$81d46cbe2a5cce6e, (failedCommand)=>(command)=>failedCommand === command);
const $a9bbbf0abab21f69$export$3d0ae289c1f4e1c5 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    const streamdingCmds = {};
    const { steps: steps } = pipelines;
    for(const stepUuid in steps.streamingCommands)if (Object.prototype.hasOwnProperty.call(steps.streamingCommands, stepUuid)) {
        const activeCmdArr = steps.streamingCommands[stepUuid];
        streamdingCmds[stepUuid] = activeCmdArr && activeCmdArr.length ? activeCmdArr.lastIndexOf(true) : undefined;
    }
    return streamdingCmds;
});
const $a9bbbf0abab21f69$export$ff08b8b89f7bdc73 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    const { steps: steps } = pipelines;
    return steps.failureReasonUpdated;
});
const $a9bbbf0abab21f69$export$4c8b28e1f7edbb9a = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$7999c56c295d200b, (streamingCommands)=>(command)=>!!streamingCommands[command.index]);
const $a9bbbf0abab21f69$export$215258e47dcbeb23 = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$7999c56c295d200b, (streamingCommands)=>streamingCommands.some((x)=>x !== undefined));
const $a9bbbf0abab21f69$export$b2a7e76edcf99b25 = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$29ce6c7518aa120, (log)=>Object.keys(log.fetchedStatus).reduce((reducer, key)=>{
        reducer[key] = log.fetchedStatus[key] === (0, $90kWr.LoadingStatus).Fetching;
        return reducer;
    }, {}));
const $a9bbbf0abab21f69$export$8f12134bcd879d07 = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$29ce6c7518aa120, (log)=>log.serviceLog || {});
const $a9bbbf0abab21f69$export$daddc6c30303365c = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$300277564f59c56a, $a9bbbf0abab21f69$export$29ce6c7518aa120, (stepUuid, log)=>log.serviceLogError[stepUuid]);
const $a9bbbf0abab21f69$export$be56ab521bea75bf = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>pipelines.validator);
const $a9bbbf0abab21f69$export$2a19cfb8ab424702 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>pipelines.buildConfiguration);
const $a9bbbf0abab21f69$export$a39eddd73bba62c1 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    return Object.values(Object.fromEntries(pipelines.variables.map));
});
const $a9bbbf0abab21f69$export$4546ffa32575c0b = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>pipelines.variables.fetchedStatus);
const $a9bbbf0abab21f69$export$2b6ac0d7908c6703 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>pipelines.variables.fetchedStatus === (0, $90kWr.LoadingStatus).Fetching);
const $a9bbbf0abab21f69$export$6dd14031e1764dae = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>pipelines.variables.page);
const $a9bbbf0abab21f69$export$bb1b31498a657104 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>Boolean(pipelines.variables.loadMore));
const $a9bbbf0abab21f69$export$f1c776cb49b942a7 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>Object.keys(pipelines.environmentVariables.map).reduce((reducer, environmentUuid)=>{
        reducer[environmentUuid] = Object.values(Object.fromEntries(pipelines.environmentVariables.map[environmentUuid].map));
        return reducer;
    }, {}));
const $a9bbbf0abab21f69$export$503ec2006e4f049f = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>Object.keys(pipelines.environmentVariables.map).reduce((reducer, environmentUuid)=>{
        reducer[environmentUuid] = pipelines.environmentVariables.map[environmentUuid].fetchedStatus;
        return reducer;
    }, {}));
const $a9bbbf0abab21f69$export$99eb4ba42b80aa54 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>Object.keys(pipelines.environmentVariables.map).reduce((reducer, environmentUuid)=>{
        reducer[environmentUuid] = pipelines.environmentVariables.map[environmentUuid].page;
        return reducer;
    }, {}));
const $a9bbbf0abab21f69$export$b02e9be308edea8 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>Object.keys(pipelines.environmentVariables.map).reduce((reducer, environmentUuid)=>{
        reducer[environmentUuid] = pipelines.environmentVariables.map[environmentUuid].loadMore;
        return reducer;
    }, {}));
const $a9bbbf0abab21f69$export$76283ef2fb1d0bee = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (state)=>{
    const { fetchedStatus: fetchedStatus } = state.pipelines;
    return fetchedStatus === (0, $90kWr.LoadingStatus).Before || fetchedStatus === (0, $90kWr.LoadingStatus).Fetching;
});
const $a9bbbf0abab21f69$export$9dcb6e650f76fc17 = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$613fded3c60df0c1, (step)=>{
    return {
        build: step.memoryLimitInMegabytes,
        ...step.customServices.reduce((reducer, service)=>({
                [service.name]: service.memoryLimitInMegabytes,
                ...reducer
            }), {})
    };
});
const $a9bbbf0abab21f69$export$b8c02c1e708844ab = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$613fded3c60df0c1, (step)=>{
    return {
        build: step.cpuLimitInMilicores,
        ...step.customServices.reduce((reducer, service)=>({
                [service.name]: service.cpuLimitInMilicores,
                ...reducer
            }), {})
    };
});
const $a9bbbf0abab21f69$export$4c527c96df2f0f53 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipeline)=>{
    return pipeline.metrics;
});
const $a9bbbf0abab21f69$export$295d05d0016d4157 = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$4c527c96df2f0f53, (metrics)=>metrics.fetchedStatus === (0, $90kWr.LoadingStatus).Fetching);
const $a9bbbf0abab21f69$export$2f28dd589ab624a = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$613fded3c60df0c1, $a9bbbf0abab21f69$export$4c527c96df2f0f53, (step, metrics)=>metrics.metrics[step.uuid] || {
        MEMORY: {},
        CPU: {},
        MEMORY_PERCENTAGE: {}
    });
const $a9bbbf0abab21f69$export$500422125b861bab = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$613fded3c60df0c1, $a9bbbf0abab21f69$export$2f28dd589ab624a, (step, stepMetrics)=>{
    return Object.values(stepMetrics.MEMORY).map((metric)=>{
        return {
            timestamp: metric.sample_time,
            values: Object.keys(metric.value).reduce((reducer, serviceUuid)=>{
                const service = step.customServices.find((s)=>(s === null || s === void 0 ? void 0 : s.uuid) === serviceUuid);
                if (service !== null && service !== void 0 && service.name) reducer[service.name] = metric.value[service.uuid] + (0, $i3LMs.METRICS_OOM_FAILURE_TRESHOLD_IN_MB) > service.memoryLimitInMegabytes ? service.memoryLimitInMegabytes : metric.value[service.uuid];
                return reducer;
            }, {
                build: metric.value.build + (0, $i3LMs.METRICS_OOM_FAILURE_TRESHOLD_IN_MB) > step.memoryLimitInMegabytes ? step.memoryLimitInMegabytes : metric.value.build
            })
        };
    });
});
const $a9bbbf0abab21f69$export$c04781ed4787bbb = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$613fded3c60df0c1, $a9bbbf0abab21f69$export$2f28dd589ab624a, (step, stepMetrics)=>{
    return Object.values(stepMetrics.CPU).map((metric)=>({
            timestamp: metric.sample_time,
            values: Object.keys(metric.value).reduce((reducer, serviceUuid)=>{
                const service = step.customServices.find((s)=>(s === null || s === void 0 ? void 0 : s.uuid) === serviceUuid);
                if (service !== null && service !== void 0 && service.name) reducer[service.name] = metric.value[service.uuid] >= service.cpuLimitInMilicores ? service.cpuLimitInMilicores : metric.value[service.uuid];
                return reducer;
            }, {
                build: metric.value.build >= step.cpuLimitInMilicores ? step.cpuLimitInMilicores : metric.value.build
            })
        }));
});
const $a9bbbf0abab21f69$export$901bc7665d054a91 = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$613fded3c60df0c1, $a9bbbf0abab21f69$export$2f28dd589ab624a, (step, stepMetrics)=>{
    const percentages = Object.values(stepMetrics.MEMORY_PERCENTAGE).map((metric)=>{
        return {
            values: Object.keys(metric.value).reduce((reducer, serviceUuid)=>{
                const service = step.customServices.find((s)=>(s === null || s === void 0 ? void 0 : s.uuid) === serviceUuid);
                if (service !== null && service !== void 0 && service.name) reducer[service.name] = metric.value[service.uuid];
                return reducer;
            }, {
                build: metric.value.build
            })
        };
    });
    const maxVals = {};
    percentages.forEach((element)=>{
        Object.keys(element.values).forEach((service)=>{
            maxVals[service] = element.values[service] === undefined || element.values[service] < maxVals[service] ? maxVals[service] : element.values[service];
        });
    });
    return maxVals;
});
const $a9bbbf0abab21f69$export$9a7d64a22ec4b6c5 = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$901bc7665d054a91, (maxMemoryPercentage)=>{
    return Object.keys(maxMemoryPercentage).reduce((reducer, container)=>{
        if (maxMemoryPercentage[container] >= (0, $i3LMs.METRICS_USAGE_ERROR_LIMIT)) reducer[container] = "error";
        else if (maxMemoryPercentage[container] >= (0, $i3LMs.METRICS_WARNING_LIMIT)) reducer[container] = "warning";
        return reducer;
    }, {});
});
const $a9bbbf0abab21f69$export$8be0ed3098589556 = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$9e8c183033ae8e8, (testReport)=>testReport.expandedTestCaseMap);
const $a9bbbf0abab21f69$export$ca6dabb3daff3fa2 = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$9e8c183033ae8e8, (testReport)=>testReport.fetchingFailedTestCases);
const $a9bbbf0abab21f69$export$3361b72276af4ca2 = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$9e8c183033ae8e8, (testReport)=>testReport.fetchingTestReasonMap);
const $a9bbbf0abab21f69$export$acb394624f4efdbc = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$300277564f59c56a, $a9bbbf0abab21f69$export$9e8c183033ae8e8, (stepUuid, testReport)=>testReport.failedTestCases[stepUuid] || []);
const $a9bbbf0abab21f69$export$ab96d903e8b2b235 = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$9e8c183033ae8e8, (testReport)=>testReport.testCaseReasonMap);
const $a9bbbf0abab21f69$export$9bb5643a5602bc5c = (0, $aXXtM.createSelector)($a9bbbf0abab21f69$export$9e8c183033ae8e8, (testReport)=>testReport.testCaseErrorMap);
const $a9bbbf0abab21f69$export$37e27bf8ff5a63a8 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>pipelines.caches.fetchedStatus === (0, $90kWr.LoadingStatus).Fetching);
const $a9bbbf0abab21f69$export$7049a8765a89d1c1 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>pipelines.schedules.fetchedStatus === (0, $90kWr.LoadingStatus).Fetching);
const $a9bbbf0abab21f69$export$27c93e2ff6ea9c9 = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    var _previousDeployment$d, _deployment$deployabl, _previousDeployment$d2, _deployment$deployabl2;
    const { environment: environment, deployment: deployment } = pipelines.stepPreview;
    const previousDeployment = environment.latest_successful_deployment || new (0, $goDEr.Deployment)();
    const previousCommit = previousDeployment === null || previousDeployment === void 0 ? void 0 : (_previousDeployment$d = previousDeployment.deployable) === null || _previousDeployment$d === void 0 ? void 0 : _previousDeployment$d.commit;
    const currentCommit = deployment === null || deployment === void 0 ? void 0 : (_deployment$deployabl = deployment.deployable) === null || _deployment$deployabl === void 0 ? void 0 : _deployment$deployabl.commit;
    const isRollback = new Date((previousCommit === null || previousCommit === void 0 ? void 0 : previousCommit.date) || "").getTime() > new Date((currentCommit === null || currentCommit === void 0 ? void 0 : currentCommit.date) || "").getTime();
    const createdOn = isRollback ? (previousDeployment === null || previousDeployment === void 0 ? void 0 : (_previousDeployment$d2 = previousDeployment.deployable) === null || _previousDeployment$d2 === void 0 ? void 0 : _previousDeployment$d2.created_on) || "" : (deployment === null || deployment === void 0 ? void 0 : (_deployment$deployabl2 = deployment.deployable) === null || _deployment$deployabl2 === void 0 ? void 0 : _deployment$deployabl2.created_on) || "";
    return {
        deployment: deployment,
        environment: environment,
        previousDeployment: previousDeployment,
        revisionFrom: !(previousCommit !== null && previousCommit !== void 0 && previousCommit.hash) && currentCommit !== null && currentCommit !== void 0 && currentCommit.parentHash ? currentCommit.parentHash : (previousCommit === null || previousCommit === void 0 ? void 0 : previousCommit.hash) || "",
        revisionTo: (currentCommit === null || currentCommit === void 0 ? void 0 : currentCommit.hash) || "",
        createdOn: createdOn,
        isRollback: isRollback
    };
});
const $a9bbbf0abab21f69$export$74cfee117ba649fc = (0, $aXXtM.createSelector)((0, $7qdXF.getPipelines), (pipelines)=>{
    const { deployment: deployment, environment: environment, lastSuccessfulDeployment: previousDeployment } = pipelines.stepRedeployment;
    const previousCommit = previousDeployment.deployable.commit;
    const currentCommit = deployment.deployable.commit;
    const isRollback = new Date((previousCommit === null || previousCommit === void 0 ? void 0 : previousCommit.date) || "").getTime() > new Date((currentCommit === null || currentCommit === void 0 ? void 0 : currentCommit.date) || "").getTime();
    const createdOn = isRollback ? previousDeployment.deployable.created_on || "" : deployment.deployable.created_on || "";
    return {
        deployment: deployment,
        environment: environment,
        previousDeployment: previousDeployment,
        revisionFrom: !(previousCommit !== null && previousCommit !== void 0 && previousCommit.hash) && currentCommit !== null && currentCommit !== void 0 && currentCommit.parentHash ? currentCommit.parentHash : (previousCommit === null || previousCommit === void 0 ? void 0 : previousCommit.hash) || "",
        revisionTo: (currentCommit === null || currentCommit === void 0 ? void 0 : currentCommit.hash) || "",
        createdOn: createdOn,
        isRollback: isRollback
    };
});
const $a9bbbf0abab21f69$export$ebffb984ee4c30c2 = (0, $aXXtM.createSelector)((0, $aanBq.getCurrentRepository), $a9bbbf0abab21f69$export$1bd86c056cec054, (repository, pipelines)=>{
    const key = `${(0, $i3LMs.PIPELINES_ONBOARDED_KEY)}-${repository === null || repository === void 0 ? void 0 : repository.uuid}`;
    if ((0, $h3kk7.default).get(key)) return true;
    else if (pipelines.length > 0) {
        (0, $h3kk7.default).set(`${(0, $i3LMs.PIPELINES_ONBOARDED_KEY)}-${repository === null || repository === void 0 ? void 0 : repository.uuid}`, true);
        return true;
    }
    return false;
});

});
parcelRegister("FFxTU", function(module, exports) {

$parcel$export(module.exports, "getCurrentUserAsPipelinesUser", function () { return $074ec83434c3f1b1$export$99e967cffe997a74; });

var $aXXtM = parcelRequire("aXXtM");
parcelRequire("e9n2v");
var $7Re2y = parcelRequire("7Re2y");

var $g2R3c = parcelRequire("g2R3c");
const $074ec83434c3f1b1$export$99e967cffe997a74 = (0, $aXXtM.createSelector)((0, $g2R3c.getCurrentUser), (currentUser)=>{
    if (currentUser != null) return new (0, $7Re2y.User)({
        display_name: currentUser.display_name,
        username: currentUser.username,
        links: currentUser.links,
        uuid: currentUser.uuid,
        has_2fa_enabled: !!currentUser.has_2fa_enabled
    });
    else return null;
});

});

parcelRegister("90kWr", function(module, exports) {

$parcel$export(module.exports, "LoadingStatus", function () { return $fc6583439788c680$export$19d37de7e9a4af59; });
var $fc6583439788c680$export$19d37de7e9a4af59;
(function(LoadingStatus) {
    LoadingStatus["Before"] = "BEFORE";
    LoadingStatus["Fetching"] = "FETCHING";
    LoadingStatus["Success"] = "SUCCESS";
    LoadingStatus["Failed"] = "FAILED";
    LoadingStatus["Forbidden"] = "FORBIDDEN";
})($fc6583439788c680$export$19d37de7e9a4af59 || ($fc6583439788c680$export$19d37de7e9a4af59 = {}));

});



parcelRegister("6t17p", function(module, exports) {

$parcel$export(module.exports, "fetchData", function () { return $64a8ef388de8951e$export$8134c072fddab6a5; });
$parcel$export(module.exports, "hasFetchedPipeline", function () { return $64a8ef388de8951e$export$3ef37c16b05b9023; });
$parcel$export(module.exports, "hasFetchedSteps", function () { return $64a8ef388de8951e$export$d2cb6c5b153db6e9; });

var $8K6h8 = parcelRequire("8K6h8");

var $QgM08 = parcelRequire("QgM08");

var $k2cPS = parcelRequire("k2cPS");
async function $64a8ef388de8951e$export$8134c072fddab6a5(url, exceptionSegment, options = {}) {
    try {
        const req = (0, $k2cPS.default)(url, options);
        const resp = await fetch(req);
        if (!resp.ok) throw new Error(await (0, $QgM08.createErrorMessage)(resp));
        const data = await resp.json();
        return data;
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: exceptionSegment
        });
        throw e;
    }
}
const $64a8ef388de8951e$export$3ef37c16b05b9023 = (state)=>{
    return !!(0, $8K6h8.getCurrentPipeline)(state).uuid;
};
const $64a8ef388de8951e$export$d2cb6c5b153db6e9 = (state)=>{
    return !!(0, $8K6h8.getCurrentStepUuid)(state);
};

});


parcelRegister("jpBVz", function(module, exports) {

$parcel$export(module.exports, "loadDeploymentDashboardResource", function () { return $5d9e1b6efa35569f$export$3de47e2750aa7b17; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");
parcelRequire("hw8PW");
var $7JtYi = parcelRequire("7JtYi");

var $7Ic5Q = parcelRequire("7Ic5Q");

var $jjTWw = parcelRequire("jjTWw");

var $k2cPS = parcelRequire("k2cPS");

var $6t17p = parcelRequire("6t17p");
const $5d9e1b6efa35569f$var$DEPLOYMENT_SETTINGS_URL = "/admin/pipelines/deployment-settings";
const $5d9e1b6efa35569f$var$OPENID_URL = "/admin/pipelines/openid-connect";
const $5d9e1b6efa35569f$var$getRepositoryFullSlug = (params)=>{
    return params.repositoryFullSlug || `${params.repositoryOwner}/${params.repositorySlug}`;
};
const $5d9e1b6efa35569f$export$94df0e59ebebf4a7 = (params, url)=>{
    const repoFullSlug = $5d9e1b6efa35569f$var$getRepositoryFullSlug(params);
    const includeHidden = url.includes($5d9e1b6efa35569f$var$DEPLOYMENT_SETTINGS_URL) || url.includes($5d9e1b6efa35569f$var$OPENID_URL);
    return (0, $jjTWw.getDeploymentDashboardUrl)(repoFullSlug, {
        includeHidden: includeHidden
    });
};
const $5d9e1b6efa35569f$export$3de47e2750aa7b17 = (0, $3kfkg.createResource)({
    type: "deployment-dashboard",
    getKey: ({ match: { params: params, url: url } })=>$5d9e1b6efa35569f$export$94df0e59ebebf4a7(params, url),
    maxAge: 0,
    getData: async ({ match: { params: params, url: url } }, { reduxStore: reduxStore, appData: appData })=>{
        if (!(appData !== null && appData !== void 0 && appData.features[(0, $7JtYi.FeatureKeys).isPipelinesPageLoadOptimisationEnabled])) return null;
        const { dispatch: dispatch } = reduxStore;
        const data = await (0, $6t17p.fetchData)($5d9e1b6efa35569f$export$94df0e59ebebf4a7(params, url), "deployment_dashboard_resource_exception");
        dispatch((0, $7Ic5Q.setDeploymentDashboard)(data));
        const branchRestrictions = await (0, $6t17p.fetchData)((0, $jjTWw.getBranchRestrictionsUrl)($5d9e1b6efa35569f$var$getRepositoryFullSlug(params)), "branch_restrictions_resource_exception", {
            method: "POST",
            headers: (0, $k2cPS.jsonHeaders),
            body: JSON.stringify({
                environmentUuids: (0, $jjTWw.getEnvironmentUuids)(data.groupings)
            })
        });
        dispatch((0, $7Ic5Q.setBranchRestrictions)(branchRestrictions));
        return {
            status: "success"
        };
    }
});

});
parcelRegister("7Ic5Q", function(module, exports) {

$parcel$export(module.exports, "REQUEST_DEPLOYMENT_CHANGES", function () { return $69a5628a484c53c1$export$8870a745222fa7a1; });
$parcel$export(module.exports, "REQUEST_DEPLOYMENT_COMMITS", function () { return $69a5628a484c53c1$export$4ba5e13e97ee3ac0; });
$parcel$export(module.exports, "REQUEST_DEPLOYMENT_DASHBOARD", function () { return $69a5628a484c53c1$export$97145242d2b2d21; });
$parcel$export(module.exports, "REQUEST_DEPLOYMENT_PULL_REQUESTS", function () { return $69a5628a484c53c1$export$73361d3b71ad8b52; });
$parcel$export(module.exports, "REQUEST_DEPLOYMENT_SUMMARY", function () { return $69a5628a484c53c1$export$7bdf5927f04391ec; });
$parcel$export(module.exports, "REQUEST_ENVIRONMENT_HISTORY", function () { return $69a5628a484c53c1$export$fff910d67c09d9fd; });
$parcel$export(module.exports, "REQUEST_BRANCH_RESTRICTIONS", function () { return $69a5628a484c53c1$export$70ecc1a343665e68; });
$parcel$export(module.exports, "REQUEST_CREATE_BRANCH_RESTRICTION", function () { return $69a5628a484c53c1$export$ad3f76d560ce460f; });
$parcel$export(module.exports, "REQUEST_DELETE_BRANCH_RESTRICTION", function () { return $69a5628a484c53c1$export$8af8a442455e55df; });
$parcel$export(module.exports, "REQUEST_REDEPLOYMENT", function () { return $69a5628a484c53c1$export$2e5088266be927f5; });
$parcel$export(module.exports, "REQUEST_CREATE_ENVIRONMENT", function () { return $69a5628a484c53c1$export$5b2d9ebf4c14e068; });
$parcel$export(module.exports, "REQUEST_UPDATE_ENVIRONMENT", function () { return $69a5628a484c53c1$export$9f0158ee7b8e6bbb; });
$parcel$export(module.exports, "REQUEST_DELETE_ENVIRONMENT", function () { return $69a5628a484c53c1$export$31575961f3260409; });
$parcel$export(module.exports, "REQUEST_REORDER_ENVIRONMENTS", function () { return $69a5628a484c53c1$export$9c136987b9aa543e; });
$parcel$export(module.exports, "REMOVE_DEPLOYMENT_DATA", function () { return $69a5628a484c53c1$export$ba6c5a90a6208454; });
$parcel$export(module.exports, "SET_DEPLOYMENT_PREVIEW", function () { return $69a5628a484c53c1$export$85076027a11fad87; });
$parcel$export(module.exports, "ENVIRONMENT_UPDATED", function () { return $69a5628a484c53c1$export$7db9511461f8501; });
$parcel$export(module.exports, "ENVIRONMENT_LOCK_UPDATED", function () { return $69a5628a484c53c1$export$341a086f4a59ff1; });
$parcel$export(module.exports, "ENVIRONMENT_DASHBOARD_UPDATED", function () { return $69a5628a484c53c1$export$f44a3f5eaa5cb65a; });
$parcel$export(module.exports, "SET_DEPLOYMENT_DASHBOARD", function () { return $69a5628a484c53c1$export$20a3e0804ab47d56; });
$parcel$export(module.exports, "SET_BRANCH_RESTRICTIONS", function () { return $69a5628a484c53c1$export$bb94965e3da22179; });
$parcel$export(module.exports, "removeDeploymentData", function () { return $69a5628a484c53c1$export$2e9b8f455d5875cc; });
$parcel$export(module.exports, "requestDeploymentChanges", function () { return $69a5628a484c53c1$export$5f7ca5b1c31874bf; });
$parcel$export(module.exports, "requestDeploymentCommits", function () { return $69a5628a484c53c1$export$822355a40a20da75; });
$parcel$export(module.exports, "setDeploymentDashboard", function () { return $69a5628a484c53c1$export$49d2f2643ec8c6bd; });
$parcel$export(module.exports, "setBranchRestrictions", function () { return $69a5628a484c53c1$export$8610554835218d93; });
$parcel$export(module.exports, "requestDeploymentDashboard", function () { return $69a5628a484c53c1$export$1d0bf7ec26ceee6a; });
$parcel$export(module.exports, "requestDeploymentSummary", function () { return $69a5628a484c53c1$export$93984966b6706b5b; });
$parcel$export(module.exports, "requestEnvironmentHistory", function () { return $69a5628a484c53c1$export$4f779a6f6a19bf5e; });
$parcel$export(module.exports, "requestRedeployment", function () { return $69a5628a484c53c1$export$f6bcb6dbbe487c81; });
$parcel$export(module.exports, "setDeploymentPreview", function () { return $69a5628a484c53c1$export$36d29a4ae1183b1d; });
$parcel$export(module.exports, "requestCreateEnvironment", function () { return $69a5628a484c53c1$export$f2fa0e004ca417ea; });
$parcel$export(module.exports, "requestUpdateEnvironment", function () { return $69a5628a484c53c1$export$abcd7bdb07ad773b; });
$parcel$export(module.exports, "requestDeleteEnvironment", function () { return $69a5628a484c53c1$export$96c65158f9cfb242; });
$parcel$export(module.exports, "requestReorderEnvironments", function () { return $69a5628a484c53c1$export$3e194d1fa6573dbb; });
$parcel$export(module.exports, "requestCreateBranchRestriction", function () { return $69a5628a484c53c1$export$142edfe61e111165; });
$parcel$export(module.exports, "requestDeleteBranchRestriction", function () { return $69a5628a484c53c1$export$72627457d21051fd; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");

var $IQU41 = parcelRequire("IQU41");
const $69a5628a484c53c1$export$8870a745222fa7a1 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_DEPLOYMENT_CHANGES"));
const $69a5628a484c53c1$export$4ba5e13e97ee3ac0 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_DEPLOYMENT_COMMITS"));
const $69a5628a484c53c1$export$97145242d2b2d21 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_DEPLOYMENT_DASHBOARD"));
const $69a5628a484c53c1$export$73361d3b71ad8b52 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_DEPLOYMENT_PULL_REQUESTS"));
const $69a5628a484c53c1$export$7bdf5927f04391ec = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_DEPLOYMENT_SUMMARY"));
const $69a5628a484c53c1$export$fff910d67c09d9fd = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_ENVIRONMENT_HISTORY"));
const $69a5628a484c53c1$export$70ecc1a343665e68 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_BRANCH_RESTRICTIONS"));
const $69a5628a484c53c1$export$ad3f76d560ce460f = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_CREATE_BRANCH_RESTRICTION"));
const $69a5628a484c53c1$export$8af8a442455e55df = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_DELETE_BRANCH_RESTRICTION"));
const $69a5628a484c53c1$export$2e5088266be927f5 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_REDEPLOYMENT"));
const $69a5628a484c53c1$export$5b2d9ebf4c14e068 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_CREATE_ENVIRONMENT"));
const $69a5628a484c53c1$export$9f0158ee7b8e6bbb = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_UPDATE_ENVIRONMENT"));
const $69a5628a484c53c1$export$31575961f3260409 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_DELETE_ENVIRONMENT"));
const $69a5628a484c53c1$export$9c136987b9aa543e = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_REORDER_ENVIRONMENT"));
const $69a5628a484c53c1$export$ba6c5a90a6208454 = (0, $IQU41.prefixed)("REMOVE_DEPLOYMENT_DATA");
const $69a5628a484c53c1$export$85076027a11fad87 = (0, $IQU41.prefixed)("SET_DEPLOYMENT_PREVIEW");
const $69a5628a484c53c1$export$7db9511461f8501 = "ENVIRONMENT_UPDATED";
const $69a5628a484c53c1$export$341a086f4a59ff1 = "ENVIRONMENT_LOCK_UPDATED";
const $69a5628a484c53c1$export$f44a3f5eaa5cb65a = "ENVIRONMENT_DASHBOARD_UPDATED";
const $69a5628a484c53c1$export$20a3e0804ab47d56 = "SET_DEPLOYMENT_DASHBOARD";
const $69a5628a484c53c1$export$bb94965e3da22179 = "SET_BRANCH_RESTRICTIONS";
const $69a5628a484c53c1$export$2e9b8f455d5875cc = ()=>{
    return {
        type: $69a5628a484c53c1$export$ba6c5a90a6208454
    };
};
const $69a5628a484c53c1$export$5f7ca5b1c31874bf = (revisionFrom, revisionTo, createdOn, isRollback)=>{
    return {
        type: $69a5628a484c53c1$export$8870a745222fa7a1.REQUEST,
        meta: {
            revisionFrom: revisionFrom,
            revisionTo: revisionTo,
            createdOn: createdOn,
            isRollback: isRollback
        }
    };
};
const $69a5628a484c53c1$export$822355a40a20da75 = (revisionFrom, revisionTo, isRollback, page)=>{
    return {
        type: $69a5628a484c53c1$export$4ba5e13e97ee3ac0.REQUEST,
        meta: {
            revisionFrom: revisionFrom,
            revisionTo: revisionTo,
            isRollback: isRollback,
            page: page
        }
    };
};
const $69a5628a484c53c1$export$49d2f2643ec8c6bd = (payload)=>{
    return {
        type: $69a5628a484c53c1$export$20a3e0804ab47d56,
        payload: payload
    };
};
const $69a5628a484c53c1$export$8610554835218d93 = (payload)=>{
    return {
        type: $69a5628a484c53c1$export$bb94965e3da22179,
        payload: payload
    };
};
const $69a5628a484c53c1$export$1d0bf7ec26ceee6a = (queryParams)=>{
    return {
        type: $69a5628a484c53c1$export$97145242d2b2d21.REQUEST,
        meta: {
            queryParams: queryParams
        }
    };
};
const $69a5628a484c53c1$export$93984966b6706b5b = (deploymentUuid)=>{
    return {
        type: $69a5628a484c53c1$export$7bdf5927f04391ec.REQUEST,
        meta: {
            deploymentUuid: deploymentUuid
        }
    };
};
const $69a5628a484c53c1$export$4f779a6f6a19bf5e = (environmentUuid, page)=>{
    return {
        type: $69a5628a484c53c1$export$fff910d67c09d9fd.REQUEST,
        meta: {
            environmentUuid: environmentUuid,
            page: page
        }
    };
};
const $69a5628a484c53c1$export$f6bcb6dbbe487c81 = (environmentUuid, deploymentUuid)=>{
    return {
        type: $69a5628a484c53c1$export$2e5088266be927f5.REQUEST,
        meta: {
            environmentUuid: environmentUuid,
            deploymentUuid: deploymentUuid
        }
    };
};
const $69a5628a484c53c1$export$36d29a4ae1183b1d = (deployment, environment)=>{
    return {
        type: $69a5628a484c53c1$export$85076027a11fad87,
        payload: {
            deployment: deployment,
            environment: environment
        }
    };
};
const $69a5628a484c53c1$export$f2fa0e004ca417ea = (environmentName, environmentType)=>{
    return {
        type: $69a5628a484c53c1$export$5b2d9ebf4c14e068.REQUEST,
        payload: {
            environmentName: environmentName,
            environmentType: environmentType
        }
    };
};
const $69a5628a484c53c1$export$abcd7bdb07ad773b = (environmentUuid, change)=>{
    return {
        type: $69a5628a484c53c1$export$9f0158ee7b8e6bbb.REQUEST,
        payload: {
            environmentUuid: environmentUuid,
            change: change
        }
    };
};
const $69a5628a484c53c1$export$96c65158f9cfb242 = (environmentUuid)=>{
    return {
        type: $69a5628a484c53c1$export$31575961f3260409.REQUEST,
        payload: {
            environmentUuid: environmentUuid
        }
    };
};
const $69a5628a484c53c1$export$3e194d1fa6573dbb = (environmentType, environmentTypeOrder)=>{
    return {
        type: $69a5628a484c53c1$export$9c136987b9aa543e.REQUEST,
        payload: {
            environmentType: environmentType,
            environmentTypeOrder: environmentTypeOrder
        }
    };
};
const $69a5628a484c53c1$export$142edfe61e111165 = (environmentUuid, pattern)=>{
    return {
        type: $69a5628a484c53c1$export$ad3f76d560ce460f.REQUEST,
        payload: {
            environmentUuid: environmentUuid,
            pattern: pattern
        }
    };
};
const $69a5628a484c53c1$export$72627457d21051fd = (environmentUuid, restrictionUuid)=>{
    return {
        type: $69a5628a484c53c1$export$8af8a442455e55df.REQUEST,
        payload: {
            environmentUuid: environmentUuid,
            restrictionUuid: restrictionUuid
        }
    };
};

});

parcelRegister("jjTWw", function(module, exports) {

$parcel$export(module.exports, "getDeploymentDashboardUrl", function () { return $191336c5239f4e4b$export$9656721c5096dcf1; });
$parcel$export(module.exports, "getDeploymentUrl", function () { return $191336c5239f4e4b$export$e85a666e5e38a78d; });
$parcel$export(module.exports, "getDeploymentByStepUrl", function () { return $191336c5239f4e4b$export$d9d48b41fe3bc2e7; });
$parcel$export(module.exports, "getDeploymentsUrl", function () { return $191336c5239f4e4b$export$653fbf2431a154ee; });
$parcel$export(module.exports, "getBranchRestrictionsUrl", function () { return $191336c5239f4e4b$export$82fa17f54b9afa3e; });
$parcel$export(module.exports, "getEnvironmentUuids", function () { return $191336c5239f4e4b$export$cce4799687778a38; });
$parcel$export(module.exports, "requestDeploymentDashboardSaga", function () { return $191336c5239f4e4b$export$16070f3995947eee; });
$parcel$export(module.exports, "requestEnvironmentHistorySaga", function () { return $191336c5239f4e4b$export$f65619fbfcf9f9a3; });
$parcel$export(module.exports, "requestBranchRestrictionsSaga", function () { return $191336c5239f4e4b$export$fa9d8a5200fe82b8; });
$parcel$export(module.exports, "requestCreateBranchRestrictionSaga", function () { return $191336c5239f4e4b$export$4a778dd03b359a0f; });
$parcel$export(module.exports, "requestDeleteBranchRestrictionSaga", function () { return $191336c5239f4e4b$export$bffdaf27ddd1e265; });
$parcel$export(module.exports, "requestDeploymentChangesWithRaceSaga", function () { return $191336c5239f4e4b$export$ef81fde116d780d0; });
$parcel$export(module.exports, "requestDeploymentCommitsWithRaceSaga", function () { return $191336c5239f4e4b$export$2e509c7425719dd3; });
$parcel$export(module.exports, "requestDeploymentPullRequestsWithRaceSaga", function () { return $191336c5239f4e4b$export$8d20e8138ddff543; });
$parcel$export(module.exports, "requestRedeploymentWithRaceSaga", function () { return $191336c5239f4e4b$export$4570b683bf4130bf; });
$parcel$export(module.exports, "requestDeploymentSummaryWithRaceSaga", function () { return $191336c5239f4e4b$export$33665f9caa57cecd; });
$parcel$export(module.exports, "requestCreateEnvironmentSaga", function () { return $191336c5239f4e4b$export$d315c1a0c6da9363; });
$parcel$export(module.exports, "requestUpdateEnvironmentSaga", function () { return $191336c5239f4e4b$export$7ddafeb6d9762dae; });
$parcel$export(module.exports, "requestDeleteEnvironmentSaga", function () { return $191336c5239f4e4b$export$54495f9fd02d627; });
$parcel$export(module.exports, "requestReorderEnvironmentsSaga", function () { return $191336c5239f4e4b$export$51eaaa6cdeb3de0f; });

var $cJH1T = parcelRequire("cJH1T");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $j2N0s = parcelRequire("j2N0s");
parcelRequire("e9n2v");
var $4EUxB = parcelRequire("4EUxB");
var $goDEr = parcelRequire("goDEr");
var $eRckJ = parcelRequire("eRckJ");
var $his0q = parcelRequire("his0q");
var $f7wkq = parcelRequire("f7wkq");

var $4XV6a = parcelRequire("4XV6a");

var $aanBq = parcelRequire("aanBq");

var $k2cPS = parcelRequire("k2cPS");

var $i3LMs = parcelRequire("i3LMs");

var $fEutT = parcelRequire("fEutT");

var $QgM08 = parcelRequire("QgM08");

var $7Ic5Q = parcelRequire("7Ic5Q");
const $191336c5239f4e4b$export$9656721c5096dcf1 = (repositoryFullSlug, queryParams = {})=>{
    const defaultExcludeHiddenFields = "+groupings.environment_summaries.latest_successful_deployment.deployable.commit.*.*,-groupings.environment_summaries.latest_successful_deployment.deployable.commit.parents,-groupings.environment_summaries.latest_successful_deployment.deployable.commit.links.patch,-groupings.environment_summaries.latest_successful_deployment.deployable.commit.properties,+groupings.environment_summaries.latest_successful_deployment.step.run_number,+groupings.environment_summaries.latest_successful_deployment.step.state.*.*,+groupings.environment_summaries.latest_successful_deployment.step.trigger.*.*,+groupings.environment_summaries.latest_deployment.deployable.commit.*.*,-groupings.environment_summaries.latest_deployment.deployable.commit.parents,-groupings.environment_summaries.latest_deployment.deployable.commit.links.patch,-groupings.environment_summaries.latest_deployment.deployable.commit.properties,+groupings.environment_summaries.latest_deployment.step.run_number,+groupings.environment_summaries.latest_deployment.step.state.*.*,+groupings.environment_summaries.latest_deployment.step.trigger.*.*,+groupings.environment_summaries.next_promotion.environment.name";
    const defaultIncludeHiddenFields = "-groupings.environment_summaries.latest_deployment,-groupings.environment_summaries.latest_successful_deployment";
    const { fields: fields = queryParams.includeHidden ? defaultIncludeHiddenFields : defaultExcludeHiddenFields } = queryParams;
    return `${(0, $fEutT.default)("/!api/internal", "deployments")}/repositories/${repositoryFullSlug}/environment-dashboard?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
        ...queryParams,
        fields: fields
    }, {
        allowDots: true
    })}`;
};
const $191336c5239f4e4b$export$e85a666e5e38a78d = (repositoryFullSlug, deploymentUuid, queryParams = {})=>{
    const allQueryParams = {
        fields: "+deployable.commit.*,+deployable.commit.author.*,-deployable.commit.properties,+environment.*,+step.*,+state.deployer.*,+state.last_successful_deployment.*,+state.last_successful_deployment.step.*,+state.last_successful_deployment.state.deployer.*,+state.last_successful_deployment.deployable.commit.*,+state.last_successful_deployment.deployable.commit.author.*,-state.last_successful_deployment.deployable.commit.properties",
        ...queryParams
    };
    return `${(0, $fEutT.default)("/!api/2.0", "deployments")}/repositories/${repositoryFullSlug}/deployments/${deploymentUuid}?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(allQueryParams, {
        allowDots: true
    })}`;
};
const $191336c5239f4e4b$export$d9d48b41fe3bc2e7 = (repositoryFullSlug, pipelineUuid, stepUuid)=>{
    const allQueryParams = {
        fields: "+deployable.commit.*,+deployable.commit.author.*,-deployable.commit.properties,+environment.*,+step.*,+state.deployer.*,+state.last_successful_deployment.*,+state.last_successful_deployment.step.*,+state.last_successful_deployment.state.deployer.*,+state.last_successful_deployment.deployable.commit.*,+state.last_successful_deployment.deployable.commit.author.*,-state.last_successful_deployment.deployable.commit.properties"
    };
    return `${(0, $fEutT.default)("/!api/internal", "deployments", true)}/repositories/${repositoryFullSlug}/pipelines/${pipelineUuid}/steps/${stepUuid}/deployment?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(allQueryParams, {
        allowDots: true
    })}`;
};
const $191336c5239f4e4b$export$653fbf2431a154ee = (repositoryFullSlug, queryParams = {})=>{
    const allQueryParams = {
        "state.name": [
            "COMPLETED",
            "IN_PROGRESS",
            "PENDING"
        ],
        fields: "-values.release,-values.state.last_successful_deployment,+values.deployable.commit.message,+values.deployable.commit.summary.*,+values.deployable.commit.date,+values.deployable.commit.author.*,+values.step.run_number,+values.step.state.*.*,+values.step.trigger.*.*",
        sort: "-state.started_on",
        pagelen: 10,
        ...queryParams
    };
    return `${(0, $fEutT.default)("/!api/2.0", "deployments")}/repositories/${repositoryFullSlug}/deployments/?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(allQueryParams, {
        allowDots: true,
        arrayFormat: "repeat"
    })}`;
};
const $191336c5239f4e4b$export$d1b12fe9ddaa57af = (repositoryFullSlug, revisionFrom, revisionTo, queryParams = {})=>{
    const allQueryParams = {
        include: revisionTo,
        ...revisionFrom && {
            exclude: revisionFrom
        },
        pagelen: 30,
        ...queryParams
    };
    return `/!api/2.0/repositories/${repositoryFullSlug}/commits/?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(allQueryParams)}`;
};
const $191336c5239f4e4b$export$bdbec25ef3ba5220 = (repositoryFullSlug, revisionFrom, revisionTo, queryParams = {})=>{
    const allQueryParams = {
        include: revisionTo,
        ...revisionFrom && {
            exclude: revisionFrom
        },
        pagelen: 30,
        ...queryParams
    };
    return `${(0, $fEutT.default)("/!api/internal")}/repositories/${repositoryFullSlug}/jira-issues?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(allQueryParams)}`;
};
const $191336c5239f4e4b$export$87a1a4e89f9830db = (repositoryFullSlug, revisionFrom, revisionTo)=>{
    return `/!api/2.0/repositories/${repositoryFullSlug}/diff/${revisionTo}..${revisionFrom}?topic=false`;
};
const $191336c5239f4e4b$export$988ab365c729f591 = (repositoryFullSlug, createdOn, queryParams = {})=>{
    const allQueryParams = {
        q: `created_on <= ${createdOn}`,
        pagelen: 50,
        ...queryParams
    };
    return `/!api/2.0/repositories/${repositoryFullSlug}/pullrequests?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(allQueryParams)}`;
};
const $191336c5239f4e4b$export$82fa17f54b9afa3e = (repositoryFullSlug, queryParams = {})=>{
    const allQueryParams = {
        page: 1,
        pagelen: (0, $i3LMs.BRANCH_RESTRICTIONS_PAGE_SIZE),
        ...queryParams
    };
    return `${(0, $fEutT.default)("/!api/internal", "deployments")}/repositories/${repositoryFullSlug}/branch-restrictions/?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(allQueryParams)}`;
};
const $191336c5239f4e4b$export$cce4799687778a38 = (groupings)=>{
    if (!groupings) return [];
    return groupings.map((e)=>e === null || e === void 0 ? void 0 : e.environment_summaries.map((s)=>s === null || s === void 0 ? void 0 : s.uuid)).flat().filter((uuid)=>typeof uuid === "string");
};
const $191336c5239f4e4b$export$6e28ed55224f7a = (repositoryFullSlug, environmentUuid, restrictionUuid = "")=>{
    return `${(0, $fEutT.default)("/!api/internal", "deployments")}/repositories/${repositoryFullSlug}/environments/${environmentUuid}/branch-restrictions/${restrictionUuid}`;
};
const $191336c5239f4e4b$export$3dcab5f391be583a = (repositorySlug, environmentUuid)=>{
    return `${(0, $fEutT.default)("/!api/2.0", "deployments")}/repositories/${repositorySlug}/environments/${environmentUuid !== null && environmentUuid !== void 0 ? environmentUuid : ""}`;
};
const $191336c5239f4e4b$export$3337c94d5a4ba11e = (repositorySlug, environmentUuid)=>{
    return `${(0, $fEutT.default)("/!api/2.0", "deployments")}/repositories/${repositorySlug}/environments/${environmentUuid}/changes/`;
};
function* $191336c5239f4e4b$export$2c15d7ef31b09902(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const { revisionFrom: revisionFrom, revisionTo: revisionTo, isRollback: isRollback } = action.meta;
    try {
        const commitDiffUrl = $191336c5239f4e4b$export$d1b12fe9ddaa57af(full_name, isRollback ? revisionTo : revisionFrom, isRollback ? revisionFrom : revisionTo);
        const jiraIssuesUrl = $191336c5239f4e4b$export$bdbec25ef3ba5220(full_name, isRollback ? revisionTo : revisionFrom, isRollback ? revisionFrom : revisionTo);
        const fileDiffUrl = $191336c5239f4e4b$export$87a1a4e89f9830db(full_name, isRollback ? revisionTo : revisionFrom, isRollback ? revisionFrom : revisionTo);
        const [commitRes, jiraIssuesRes, fileDiffRes] = yield (0, $5NpoY._)([
            (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(commitDiffUrl)),
            (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(jiraIssuesUrl)),
            (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(fileDiffUrl, {
                responseType: "text"
            }))
        ]);
        if (!commitRes.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(commitRes)));
        if (!fileDiffRes.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(fileDiffRes)));
        const [commitDiff, jiraIssues, fileDiff] = yield (0, $5NpoY._)([
            (0, $5NpoY.P)([
                commitRes,
                "json"
            ]),
            jiraIssuesRes.ok ? (0, $5NpoY.P)([
                jiraIssuesRes,
                "json"
            ]) : {
                values: []
            },
            (0, $5NpoY.P)([
                fileDiffRes,
                "text"
            ])
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_DEPLOYMENT_CHANGES).SUCCESS,
            meta: action.meta,
            payload: {
                commitDiff: ((commitDiff === null || commitDiff === void 0 ? void 0 : commitDiff.values) || []).map((data)=>new (0, $4EUxB.Commit)(data)),
                jiraIssues: ((jiraIssues === null || jiraIssues === void 0 ? void 0 : jiraIssues.values) || []).map((data)=>new (0, $his0q.Issue)(data)),
                fileDiff: (0, (/*@__PURE__*/$parcel$interopDefault($j2N0s)))(fileDiff),
                isJiraConnected: jiraIssuesRes.ok
            }
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $7Ic5Q.REQUEST_DEPLOYMENT_CHANGES).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_DEPLOYMENT_CHANGES).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $191336c5239f4e4b$export$149226312d4823dc(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const { revisionFrom: revisionFrom, revisionTo: revisionTo, isRollback: isRollback, page: page } = action.meta;
    try {
        const commitDiffUrl = $191336c5239f4e4b$export$d1b12fe9ddaa57af(full_name, isRollback ? revisionTo : revisionFrom, isRollback ? revisionFrom : revisionTo, {
            page: page
        });
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(commitDiffUrl));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_DEPLOYMENT_COMMITS).SUCCESS,
            meta: action.meta,
            payload: ((data === null || data === void 0 ? void 0 : data.values) || []).map((c)=>new (0, $4EUxB.Commit)(c))
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $7Ic5Q.REQUEST_DEPLOYMENT_COMMITS).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_DEPLOYMENT_COMMITS).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $191336c5239f4e4b$export$16070f3995947eee(action) {
    var _action$meta;
    const { queryParams: queryParams } = (_action$meta = action === null || action === void 0 ? void 0 : action.meta) !== null && _action$meta !== void 0 ? _action$meta : {};
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = $191336c5239f4e4b$export$9656721c5096dcf1(full_name, queryParams);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_DEPLOYMENT_DASHBOARD).SUCCESS,
            payload: data
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $7Ic5Q.REQUEST_DEPLOYMENT_DASHBOARD).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_DEPLOYMENT_DASHBOARD).ERROR,
            payload: e
        });
    }
}
function $191336c5239f4e4b$export$cbc7dc280d22c3e(data, commitDiff) {
    return (data === null || data === void 0 ? void 0 : data.values.map((pr)=>new (0, $f7wkq.PullRequest)(pr)).filter((pullRequest)=>{
        return commitDiff === null || commitDiff === void 0 ? void 0 : commitDiff.some((commit)=>{
            var _pullRequest$mergeCom, _pullRequest$sourceCo;
            return ((_pullRequest$mergeCom = pullRequest.mergeCommit) === null || _pullRequest$mergeCom === void 0 ? void 0 : _pullRequest$mergeCom.hash) && commit.hash.startsWith(pullRequest.mergeCommit.hash) || ((_pullRequest$sourceCo = pullRequest.sourceCommit) === null || _pullRequest$sourceCo === void 0 ? void 0 : _pullRequest$sourceCo.hash) && commit.hash.startsWith(pullRequest.sourceCommit.hash);
        });
    })) || [];
}
function* $191336c5239f4e4b$export$ba5b73fc6b260c2f(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        var _action$payload;
        const url = $191336c5239f4e4b$export$988ab365c729f591(full_name, action.meta.createdOn);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        const payload = $191336c5239f4e4b$export$cbc7dc280d22c3e(data, (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.commitDiff);
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_DEPLOYMENT_PULL_REQUESTS).SUCCESS,
            payload: payload
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $7Ic5Q.REQUEST_DEPLOYMENT_PULL_REQUESTS).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_DEPLOYMENT_PULL_REQUESTS).ERROR,
            payload: e
        });
    }
}
function* $191336c5239f4e4b$export$cdb05daa60290ac4(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = $191336c5239f4e4b$export$e85a666e5e38a78d(full_name, action.meta.deploymentUuid);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_DEPLOYMENT_SUMMARY).SUCCESS,
            meta: action.meta,
            payload: data
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $7Ic5Q.REQUEST_DEPLOYMENT_SUMMARY).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_DEPLOYMENT_SUMMARY).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $191336c5239f4e4b$export$e495dfde1f662256(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        var _latestDeploymentData;
        const redeploymentUrl = $191336c5239f4e4b$export$e85a666e5e38a78d(full_name, action.meta.deploymentUuid);
        // combine with last deployment for given environment
        const latestDeploymentUrl = $191336c5239f4e4b$export$653fbf2431a154ee(full_name, {
            environment: action.meta.environmentUuid,
            fields: "+values.*.*.*.*.*.*",
            pagelen: 1,
            page: 1
        });
        const [redeploymentRes, latestDeploymentRes] = yield (0, $5NpoY._)([
            (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(redeploymentUrl)),
            (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(latestDeploymentUrl))
        ]);
        if (!redeploymentRes.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(redeploymentRes)));
        if (!latestDeploymentRes.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(latestDeploymentRes)));
        const [redeploymentData, latestDeploymentData] = yield (0, $5NpoY._)([
            (0, $5NpoY.P)([
                redeploymentRes,
                "json"
            ]),
            (0, $5NpoY.P)([
                latestDeploymentRes,
                "json"
            ])
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_REDEPLOYMENT).SUCCESS,
            meta: action.meta,
            payload: {
                deployment: new (0, $goDEr.Deployment)(redeploymentData),
                lastSuccessfulDeployment: new (0, $goDEr.Deployment)((_latestDeploymentData = latestDeploymentData.values) === null || _latestDeploymentData === void 0 ? void 0 : _latestDeploymentData[0]),
                environment: new (0, $eRckJ.Environment)(redeploymentData.environment)
            }
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $7Ic5Q.REQUEST_REDEPLOYMENT).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_REDEPLOYMENT).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $191336c5239f4e4b$export$f65619fbfcf9f9a3(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = $191336c5239f4e4b$export$653fbf2431a154ee(full_name, {
            environment: action.meta.environmentUuid,
            page: action.meta.page
        });
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_ENVIRONMENT_HISTORY).SUCCESS,
            meta: action.meta,
            payload: data
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $7Ic5Q.REQUEST_ENVIRONMENT_HISTORY).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_ENVIRONMENT_HISTORY).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $191336c5239f4e4b$export$fa9d8a5200fe82b8(action) {
    var _action$payload2;
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const environmentUuids = $191336c5239f4e4b$export$cce4799687778a38((_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.groupings);
    try {
        const url = $191336c5239f4e4b$export$82fa17f54b9afa3e(full_name);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "POST",
            headers: (0, $k2cPS.jsonHeaders),
            body: JSON.stringify({
                environmentUuids: environmentUuids
            })
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_BRANCH_RESTRICTIONS).SUCCESS,
            payload: data
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $7Ic5Q.REQUEST_BRANCH_RESTRICTIONS).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_BRANCH_RESTRICTIONS).ERROR,
            payload: e
        });
    }
}
function* $191336c5239f4e4b$export$4a778dd03b359a0f(action) {
    const { full_name: repositorySlug } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const { environmentUuid: environmentUuid, pattern: pattern } = action.payload;
    const url = $191336c5239f4e4b$export$6e28ed55224f7a(repositorySlug, environmentUuid);
    try {
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "POST",
            headers: (0, $k2cPS.jsonHeaders),
            body: JSON.stringify({
                pattern: pattern,
                type: "branch_restriction_pattern"
            })
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_CREATE_BRANCH_RESTRICTION).SUCCESS,
            payload: {
                environmentUuid: environmentUuid,
                data: data
            }
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $7Ic5Q.REQUEST_CREATE_BRANCH_RESTRICTION).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_CREATE_BRANCH_RESTRICTION).ERROR,
            payload: {
                environmentUuid: environmentUuid,
                error: e
            }
        });
    }
}
function* $191336c5239f4e4b$export$bffdaf27ddd1e265(action) {
    const { full_name: repositorySlug } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const { environmentUuid: environmentUuid, restrictionUuid: restrictionUuid } = action.payload;
    const url = $191336c5239f4e4b$export$6e28ed55224f7a(repositorySlug, environmentUuid, restrictionUuid);
    try {
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "DELETE"
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_DELETE_BRANCH_RESTRICTION).SUCCESS,
            payload: {
                environmentUuid: environmentUuid,
                restrictionUuid: restrictionUuid
            }
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $7Ic5Q.REQUEST_DELETE_BRANCH_RESTRICTION).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_DELETE_BRANCH_RESTRICTION).ERROR,
            payload: {
                environmentUuid: environmentUuid,
                error: e
            }
        });
    }
}
function* $191336c5239f4e4b$export$ef81fde116d780d0(action) {
    yield (0, $5NpoY.T)([
        (0, $5NpoY.P)($191336c5239f4e4b$export$2c15d7ef31b09902, action),
        (0, $5NpoY.M)((0, $7Ic5Q.REMOVE_DEPLOYMENT_DATA))
    ]);
}
function* $191336c5239f4e4b$export$2e509c7425719dd3(action) {
    yield (0, $5NpoY.T)([
        (0, $5NpoY.P)($191336c5239f4e4b$export$149226312d4823dc, action),
        (0, $5NpoY.M)((0, $7Ic5Q.REMOVE_DEPLOYMENT_DATA))
    ]);
}
function* $191336c5239f4e4b$export$8d20e8138ddff543(action) {
    yield (0, $5NpoY.T)([
        (0, $5NpoY.P)($191336c5239f4e4b$export$ba5b73fc6b260c2f, action),
        (0, $5NpoY.M)((0, $7Ic5Q.REMOVE_DEPLOYMENT_DATA))
    ]);
}
function* $191336c5239f4e4b$export$4570b683bf4130bf(action) {
    yield (0, $5NpoY.T)([
        (0, $5NpoY.P)($191336c5239f4e4b$export$e495dfde1f662256, action),
        (0, $5NpoY.M)((0, $7Ic5Q.REMOVE_DEPLOYMENT_DATA))
    ]);
}
function* $191336c5239f4e4b$export$33665f9caa57cecd(action) {
    yield (0, $5NpoY.T)([
        (0, $5NpoY.P)($191336c5239f4e4b$export$cdb05daa60290ac4, action),
        (0, $5NpoY.M)((0, $7Ic5Q.REMOVE_DEPLOYMENT_DATA))
    ]);
}
function* $191336c5239f4e4b$export$d315c1a0c6da9363(action) {
    if (!action.payload) return;
    const { full_name: repositorySlug } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const { environmentName: environmentName, environmentType: environmentType } = action.payload;
    try {
        const url = $191336c5239f4e4b$export$3dcab5f391be583a(repositorySlug);
        const body = {
            environment_type: {
                name: environmentType
            },
            name: environmentName,
            rank: 0
        };
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "POST",
            headers: (0, $k2cPS.jsonHeaders),
            body: JSON.stringify(body)
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const environment = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_CREATE_ENVIRONMENT).SUCCESS,
            payload: {
                environment: environment,
                environmentName: environmentName,
                environmentType: environmentType
            }
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $7Ic5Q.REQUEST_CREATE_ENVIRONMENT).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_CREATE_ENVIRONMENT).ERROR,
            payload: {
                error: e,
                environmentName: environmentName,
                environmentType: environmentType
            }
        });
    }
}
function* $191336c5239f4e4b$export$7ddafeb6d9762dae(action) {
    if (!action.payload) return;
    const { full_name: repositorySlug } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const { environmentUuid: environmentUuid, change: change } = action.payload;
    try {
        // Note: branch restrictions are not included in the environment responses.
        const { branchRestrictions: branchRestrictions } = (yield (0, $5NpoY.a3)((0, $4XV6a.getEnvironmentsByUuid)))[environmentUuid];
        const url = $191336c5239f4e4b$export$3337c94d5a4ba11e(repositorySlug, environmentUuid);
        const body = {
            change: change
        };
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "POST",
            headers: (0, $k2cPS.jsonHeaders),
            body: JSON.stringify(body)
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        // Unfortunately the request above does not return the updated object.
        // So has to GET the updated environment object separately.
        const getUrl = $191336c5239f4e4b$export$3dcab5f391be583a(repositorySlug, environmentUuid);
        const getRes = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(getUrl));
        if (!getRes.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(getRes)));
        const data = yield (0, $5NpoY.P)([
            getRes,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_UPDATE_ENVIRONMENT).SUCCESS,
            payload: {
                environmentUuid: environmentUuid,
                change: change,
                data: {
                    ...data,
                    branchRestrictions: branchRestrictions
                }
            }
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $7Ic5Q.REQUEST_UPDATE_ENVIRONMENT).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_UPDATE_ENVIRONMENT).ERROR,
            payload: {
                error: e,
                environmentUuid: environmentUuid
            }
        });
    }
}
function* $191336c5239f4e4b$export$54495f9fd02d627(action) {
    if (!action.payload) return;
    const { full_name: repositorySlug } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const { environmentUuid: environmentUuid } = action.payload;
    try {
        const url = $191336c5239f4e4b$export$3dcab5f391be583a(repositorySlug, environmentUuid);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "DELETE"
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_DELETE_ENVIRONMENT).SUCCESS,
            payload: {
                environmentUuid: environmentUuid
            }
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $7Ic5Q.REQUEST_DELETE_ENVIRONMENT).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_DELETE_ENVIRONMENT).ERROR,
            payload: {
                error: e,
                environmentUuid: environmentUuid
            }
        });
    }
}
function* $191336c5239f4e4b$export$51eaaa6cdeb3de0f(action) {
    if (!action.payload) return;
    const { full_name: repositorySlug } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const { environmentType: environmentType, environmentTypeOrder: environmentTypeOrder } = action.payload;
    try {
        const url = $191336c5239f4e4b$export$9656721c5096dcf1(repositorySlug, {});
        const dashboard = yield (0, $5NpoY.a3)((0, $4XV6a.getDeploymentDashboardWithTypeNames));
        const version = yield (0, $5NpoY.a3)((0, $4XV6a.getDeploymentDashboardVersion));
        const body = {
            groupings: [
                "Test",
                "Staging",
                "Production"
            ].map((type)=>({
                    environment_summaries: type === environmentType ? environmentTypeOrder : dashboard[type].map((env)=>({
                            uuid: env.uuid
                        })),
                    environment_type: {
                        name: type
                    }
                })),
            version: version
        };
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "PUT",
            headers: (0, $k2cPS.jsonHeaders),
            body: JSON.stringify(body)
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_REORDER_ENVIRONMENTS).SUCCESS,
            payload: {
                environmentType: environmentType
            }
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $7Ic5Q.REQUEST_REORDER_ENVIRONMENTS).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $7Ic5Q.REQUEST_REORDER_ENVIRONMENTS).ERROR,
            payload: {
                error: e
            }
        });
    }
}

});
parcelRegister("j2N0s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ddd437dc2f24d0ae$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
/**
 * Parse unified diff input
 * see: http://www.gnu.org/software/diffutils/manual/diffutils.html#Unified-Format
 */ module.exports.default = function(input) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!input) return [];
    if (input.match(/^\s+$/)) return [];
    var lines = input.split("\n");
    if (lines.length == 0) return [];
    var files = [];
    var file = null;
    var oldLine = 0;
    var newLine = 0;
    var position = 0;
    var current = null;
    var isInChunk = false;
    function start(line) {
        isInChunk = false;
        var _parseFile = $ddd437dc2f24d0ae$var$parseFile(line), _parseFile2 = $ddd437dc2f24d0ae$var$_slicedToArray(_parseFile, 2), from = _parseFile2[0], to = _parseFile2[1];
        file = {
            from: from,
            to: to,
            headers: [],
            chunks: [],
            deletions: 0,
            additions: 0,
            isBinary: false,
            isExcluded: false,
            isImage: false
        };
        files.push(file);
        position = 0;
    }
    function restart() {
        if (!file || file.chunks.length) start();
    }
    function newFile() {
        restart();
        file.new = true;
        file.from = "/dev/null";
    }
    function deletedFile() {
        restart();
        file.deleted = true;
        file.to = "/dev/null";
    }
    function index(line) {
        restart();
        file.index = line.split(" ").slice(1);
    }
    function fromFile(line) {
        if (isInChunk) {
            del(line);
            return;
        }
        restart();
        file.from = $ddd437dc2f24d0ae$var$parseFileFallback(line);
    }
    function toFile(line) {
        restart();
        file.to = $ddd437dc2f24d0ae$var$parseFileFallback(line);
    }
    function chunk(line, match) {
        isInChunk = true;
        var oldStart = +match[1];
        var oldLines = match[2] === "" ? 1 : +match[2];
        var newStart = +match[3];
        var newLines = match[4] === "" ? 1 : +match[4];
        oldLine = oldStart;
        newLine = newStart;
        current = {
            content: line,
            changes: [],
            oldStart: oldStart,
            oldLines: oldLines,
            newStart: newStart,
            newLines: newLines
        };
        file.chunks.push(current);
        if (!position) position = 1;
    }
    function del(line) {
        current.changes.push({
            type: "del",
            del: true,
            oldLine: oldLine++,
            position: position++,
            content: line
        });
        file.deletions++;
    }
    function add(line) {
        current.changes.push({
            type: "add",
            add: true,
            newLine: newLine++,
            position: position++,
            content: line
        });
        file.additions++;
    }
    var noeol = "\\ No newline at end of file";
    function normal(line) {
        if (!file) return;
        current.changes.push({
            type: "normal",
            normal: true,
            oldLine: line !== noeol ? oldLine++ : undefined,
            newLine: line !== noeol ? newLine++ : undefined,
            position: position++,
            content: line
        });
    }
    function binaryFile() {
        file.isBinary = true;
    }
    function excludedFile() {
        file.isExcluded = true;
    }
    function resetChunk() {
        /*
    Knowing if we're inside a chunk is vital to not mis-parse sql comments.
    However we need to reset this value when we start
    new svn files to not mis-parse svn filenames.
    */ file = null;
        isInChunk = false;
    }
    var schema = [
        [
            /^\s+/,
            normal
        ],
        [
            /^diff\s/,
            start
        ],
        [
            /^GIT binary patch$/,
            binaryFile
        ],
        [
            /^File excluded by pattern\s/,
            excludedFile
        ],
        [
            /^Binary files? .* (?:differ|has changed)$/,
            binaryFile
        ],
        [
            /^new file mode \d+$/,
            newFile
        ],
        [
            /^deleted file mode \d+$/,
            deletedFile
        ],
        [
            /^index\s[\da-zA-Z]+\.\.[\da-zA-Z]+(\s(\d+))?$/,
            index
        ],
        [
            /^Index:/,
            resetChunk
        ],
        [
            /^(---|rename from)\s/,
            fromFile
        ],
        [
            /^(\+\+\+|rename to)\s/,
            toFile
        ],
        [
            /^@@\s+\-(\d+),?(\d*)\s+\+(\d+),?(\d*)\s@@/,
            chunk
        ],
        [
            /^-/,
            del
        ],
        [
            /^\+/,
            add
        ]
    ];
    function parse(line) {
        var result = schema.some(function(p) {
            var _p = $ddd437dc2f24d0ae$var$_slicedToArray(p, 2), pattern = _p[0], handler = _p[1];
            if (typeof handler !== "function") throw new Error(pattern + " has no handler");
            var m = line.match(pattern);
            if (m) {
                handler(line, m);
                return true;
            }
            return false;
        });
        if (file && !isInChunk) file.headers.push(line);
        return result;
    }
    lines.forEach(parse);
    if (opts.findRenames) $ddd437dc2f24d0ae$var$consolidateRenames(files);
    $ddd437dc2f24d0ae$var$identifyImageFiles(files);
    return files;
};

var $gxxZ9 = parcelRequire("gxxZ9");
var $ddd437dc2f24d0ae$var$_mimeTypes2 = $ddd437dc2f24d0ae$var$_interopRequireDefault($gxxZ9);
function $ddd437dc2f24d0ae$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ddd437dc2f24d0ae$var$getContent(file) {
    return file.chunks.map(function(chunk) {
        return chunk.changes.map(function(c) {
            return c.content.slice(1);
        });
    }).join("\n");
}
function $ddd437dc2f24d0ae$var$consolidateRenames(files) {
    var newFiles = files.filter(function(f) {
        return f.new;
    });
    newFiles.forEach(function(newFile) {
        var newContent = $ddd437dc2f24d0ae$var$getContent(newFile);
        var i = files.findIndex(function(f) {
            return f.deleted && $ddd437dc2f24d0ae$var$getContent(f) == newContent;
        });
        if (~i) {
            var oldFile = files[i];
            files.splice(i, 1);
            delete newFile.new;
            delete newFile.chunks;
            delete newFile.deletions;
            delete newFile.additions;
            delete newFile.index;
            newFile.renamed = true;
            newFile.from = oldFile.from;
        }
    });
}
/**
 * Process a list of files and set isImage to true on any file with an image mimetype.
 *
 * @param files - list of files
 */ function $ddd437dc2f24d0ae$var$identifyImageFiles(files) {
    files.forEach(function(file) {
        var fromIsImage = $ddd437dc2f24d0ae$var$isImageMimetype(file.from);
        var toIsImage = $ddd437dc2f24d0ae$var$isImageMimetype(file.to);
        if ((file.from === "/dev/null" || fromIsImage) && (file.to === "/dev/null" || toIsImage)) // Technically this means we'll set isImage to true if both the to and from
        // paths are /dev/null, but that should never happen so we don't really care
        file.isImage = true;
    });
}
function $ddd437dc2f24d0ae$var$isImageMimetype(filename) {
    // Approved by security to render all image file extensions.
    // mime.lookup returns false if cannot find mimetype.
    // Otherwise, returns a String mimetype that we check.
    var mimetype = $ddd437dc2f24d0ae$var$_mimeTypes2.default.lookup(filename);
    // https://softwareteams.atlassian.net/browse/COREX-8074
    // .fbs is also flatbuffer schema
    if (mimetype === "image/vnd.fastbidsheet") return false;
    return mimetype && mimetype.startsWith("image");
}
function $ddd437dc2f24d0ae$var$parseFile(s) {
    if (!s) return [];
    var m = void 0;
    if (m = s.match(/^diff (?:.+ )?("?)a\/(.+)\1 \1b\/\2\1$/)) // git diff without rename
    return [
        m[2],
        m[2]
    ];
    else if (m = s.match(/^diff (?:.+ )?("?)a\/(.+)\1 \1b\/(.+)\1$/)) // git diff with rename
    // This might not work for some ambiguous paths with spaces, but it will be
    // corrected in the fallback.
    return [
        m[2],
        m[3]
    ];
    else if (m = s.match(/^diff -r [0-9a-f]+ -r [0-9a-f]+ (.+)$/)) // hg diff
    // This won't work with renames, but it will be corrected in the fallback.
    return [
        m[1],
        m[1]
    ];
    else {
        var fileNames = s.split(" ").slice(-2);
        return fileNames.map(function(f) {
            return f.replace(/^("?)(a|b)\/(.+)\1$/, "$3");
        });
    }
}
function $ddd437dc2f24d0ae$var$parseFileFallback(s) {
    if (s.match(/^rename (from|to) /)) return s.replace(/^rename (from|to) /, "");
    else {
        // ignore normal prefix
        s = s.replace(/^(---|\+\+\+) /, "");
        // ignore possible GNU-style timestamp
        s = s.replace(/\t\d{4}-\d\d-\d\d \d\d:\d\d:\d\d(.\d+)? (\+|-)\d\d\d\d$/, "");
        // ignore possible Hg-style timestamp
        s = s.replace(/\t[A-Z][a-z]{2} [A-Z][a-z]{2} \d\d \d\d:\d\d:\d\d \d{4} (\+|-)\d{4}$/, "");
        // ignore possible SVN info
        s = s.replace(/\t\([^\)]+\)$/, "");
        if (s.includes(" ") && s.slice(-1) == "	") // If a path contains a space and ends with a tab, then remove the tab.
        // This is a compatibility hack that both Git and Hg do so that GNU patch
        // can correctly parse the diffs they generate.
        s = s.slice(0, -1);
        // ignore git prefixes a/ or b/
        return s.replace(/^("?)(a|b)\/(.+)\1$/, "$3");
    }
}
module.exports = module.exports["default"];

});
parcelRegister("gxxZ9", function(module, exports) {

$parcel$export(module.exports, "charset", function () { return $c0aa17351aeb4e12$export$e4c823724462c3fd; }, function (v) { return $c0aa17351aeb4e12$export$e4c823724462c3fd = v; });
$parcel$export(module.exports, "charsets", function () { return $c0aa17351aeb4e12$export$48d2c0a44ea41a2f; }, function (v) { return $c0aa17351aeb4e12$export$48d2c0a44ea41a2f = v; });
$parcel$export(module.exports, "contentType", function () { return $c0aa17351aeb4e12$export$8019223850b8bf78; }, function (v) { return $c0aa17351aeb4e12$export$8019223850b8bf78 = v; });
$parcel$export(module.exports, "extension", function () { return $c0aa17351aeb4e12$export$1b45514b112dd749; }, function (v) { return $c0aa17351aeb4e12$export$1b45514b112dd749 = v; });
$parcel$export(module.exports, "extensions", function () { return $c0aa17351aeb4e12$export$cc3e2d3244e01b7f; }, function (v) { return $c0aa17351aeb4e12$export$cc3e2d3244e01b7f = v; });
$parcel$export(module.exports, "lookup", function () { return $c0aa17351aeb4e12$export$dfc7155ac0343b8; }, function (v) { return $c0aa17351aeb4e12$export$dfc7155ac0343b8 = v; });
$parcel$export(module.exports, "types", function () { return $c0aa17351aeb4e12$export$b14ad400b1d09e0f; }, function (v) { return $c0aa17351aeb4e12$export$b14ad400b1d09e0f = v; });
/*!
 * mime-types
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $c0aa17351aeb4e12$export$e4c823724462c3fd;
var $c0aa17351aeb4e12$export$48d2c0a44ea41a2f;
var $c0aa17351aeb4e12$export$8019223850b8bf78;
var $c0aa17351aeb4e12$export$1b45514b112dd749;
var $c0aa17351aeb4e12$export$cc3e2d3244e01b7f;
var $c0aa17351aeb4e12$export$dfc7155ac0343b8;
var $c0aa17351aeb4e12$export$b14ad400b1d09e0f;
"use strict";

var $dHkVd = parcelRequire("dHkVd");

var $DEDEv = parcelRequire("DEDEv");
var $c0aa17351aeb4e12$require$extname = $DEDEv.extname;
/**
 * Module variables.
 * @private
 */ var $c0aa17351aeb4e12$var$EXTRACT_TYPE_REGEXP = /^\s*([^;\s]*)(?:;|\s|$)/;
var $c0aa17351aeb4e12$var$TEXT_TYPE_REGEXP = /^text\//i;
$c0aa17351aeb4e12$export$e4c823724462c3fd = $c0aa17351aeb4e12$var$charset;
$c0aa17351aeb4e12$export$48d2c0a44ea41a2f = {
    lookup: $c0aa17351aeb4e12$var$charset
};
$c0aa17351aeb4e12$export$8019223850b8bf78 = $c0aa17351aeb4e12$var$contentType;
$c0aa17351aeb4e12$export$1b45514b112dd749 = $c0aa17351aeb4e12$var$extension;
$c0aa17351aeb4e12$export$cc3e2d3244e01b7f = Object.create(null);
$c0aa17351aeb4e12$export$dfc7155ac0343b8 = $c0aa17351aeb4e12$var$lookup;
$c0aa17351aeb4e12$export$b14ad400b1d09e0f = Object.create(null);
// Populate the extensions/types maps
$c0aa17351aeb4e12$var$populateMaps($c0aa17351aeb4e12$export$cc3e2d3244e01b7f, $c0aa17351aeb4e12$export$b14ad400b1d09e0f);
/**
 * Get the default charset for a MIME type.
 *
 * @param {string} type
 * @return {boolean|string}
 */ function $c0aa17351aeb4e12$var$charset(type) {
    if (!type || typeof type !== "string") return false;
    // TODO: use media-typer
    var match = $c0aa17351aeb4e12$var$EXTRACT_TYPE_REGEXP.exec(type);
    var mime = match && $dHkVd[match[1].toLowerCase()];
    if (mime && mime.charset) return mime.charset;
    // default text/* to utf-8
    if (match && $c0aa17351aeb4e12$var$TEXT_TYPE_REGEXP.test(match[1])) return "UTF-8";
    return false;
}
/**
 * Create a full Content-Type header given a MIME type or extension.
 *
 * @param {string} str
 * @return {boolean|string}
 */ function $c0aa17351aeb4e12$var$contentType(str) {
    // TODO: should this even be in this module?
    if (!str || typeof str !== "string") return false;
    var mime = str.indexOf("/") === -1 ? $c0aa17351aeb4e12$export$dfc7155ac0343b8(str) : str;
    if (!mime) return false;
    // TODO: use content-type or other module
    if (mime.indexOf("charset") === -1) {
        var charset = $c0aa17351aeb4e12$export$e4c823724462c3fd(mime);
        if (charset) mime += "; charset=" + charset.toLowerCase();
    }
    return mime;
}
/**
 * Get the default extension for a MIME type.
 *
 * @param {string} type
 * @return {boolean|string}
 */ function $c0aa17351aeb4e12$var$extension(type) {
    if (!type || typeof type !== "string") return false;
    // TODO: use media-typer
    var match = $c0aa17351aeb4e12$var$EXTRACT_TYPE_REGEXP.exec(type);
    // get extensions
    var exts = match && $c0aa17351aeb4e12$export$cc3e2d3244e01b7f[match[1].toLowerCase()];
    if (!exts || !exts.length) return false;
    return exts[0];
}
/**
 * Lookup the MIME type for a file path/extension.
 *
 * @param {string} path
 * @return {boolean|string}
 */ function $c0aa17351aeb4e12$var$lookup(path) {
    if (!path || typeof path !== "string") return false;
    // get the extension ("ext" or ".ext" or full path)
    var extension = $c0aa17351aeb4e12$require$extname("x." + path).toLowerCase().substr(1);
    if (!extension) return false;
    return $c0aa17351aeb4e12$export$b14ad400b1d09e0f[extension] || false;
}
/**
 * Populate the extensions and types maps.
 * @private
 */ function $c0aa17351aeb4e12$var$populateMaps(extensions, types) {
    // source preference (least -> most)
    var preference = [
        "nginx",
        "apache",
        undefined,
        "iana"
    ];
    Object.keys($dHkVd).forEach(function forEachMimeType(type) {
        var mime = $dHkVd[type];
        var exts = mime.extensions;
        if (!exts || !exts.length) return;
        // mime -> extensions
        extensions[type] = exts;
        // extension -> mime
        for(var i = 0; i < exts.length; i++){
            var extension = exts[i];
            if (types[extension]) {
                var from = preference.indexOf($dHkVd[types[extension]].source);
                var to = preference.indexOf(mime.source);
                if (types[extension] !== "application/octet-stream" && (from > to || from === to && types[extension].substr(0, 12) === "application/")) continue;
            }
            // set the extension -> mime
            types[extension] = type;
        }
    });
}

});
parcelRegister("dHkVd", function(module, exports) {
/*!
 * mime-db
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015-2022 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 */ 
module.exports = (parcelRequire("3Hvzh"));

});
parcelRegister("3Hvzh", function(module, exports) {
module.exports = JSON.parse('{"application/1d-interleaved-parityfec":{"source":"iana"},"application/3gpdash-qoe-report+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/3gpp-ims+xml":{"source":"iana","compressible":true},"application/3gpphal+json":{"source":"iana","compressible":true},"application/3gpphalforms+json":{"source":"iana","compressible":true},"application/a2l":{"source":"iana"},"application/ace+cbor":{"source":"iana"},"application/activemessage":{"source":"iana"},"application/activity+json":{"source":"iana","compressible":true},"application/alto-costmap+json":{"source":"iana","compressible":true},"application/alto-costmapfilter+json":{"source":"iana","compressible":true},"application/alto-directory+json":{"source":"iana","compressible":true},"application/alto-endpointcost+json":{"source":"iana","compressible":true},"application/alto-endpointcostparams+json":{"source":"iana","compressible":true},"application/alto-endpointprop+json":{"source":"iana","compressible":true},"application/alto-endpointpropparams+json":{"source":"iana","compressible":true},"application/alto-error+json":{"source":"iana","compressible":true},"application/alto-networkmap+json":{"source":"iana","compressible":true},"application/alto-networkmapfilter+json":{"source":"iana","compressible":true},"application/alto-updatestreamcontrol+json":{"source":"iana","compressible":true},"application/alto-updatestreamparams+json":{"source":"iana","compressible":true},"application/aml":{"source":"iana"},"application/andrew-inset":{"source":"iana","extensions":["ez"]},"application/applefile":{"source":"iana"},"application/applixware":{"source":"apache","extensions":["aw"]},"application/at+jwt":{"source":"iana"},"application/atf":{"source":"iana"},"application/atfx":{"source":"iana"},"application/atom+xml":{"source":"iana","compressible":true,"extensions":["atom"]},"application/atomcat+xml":{"source":"iana","compressible":true,"extensions":["atomcat"]},"application/atomdeleted+xml":{"source":"iana","compressible":true,"extensions":["atomdeleted"]},"application/atomicmail":{"source":"iana"},"application/atomsvc+xml":{"source":"iana","compressible":true,"extensions":["atomsvc"]},"application/atsc-dwd+xml":{"source":"iana","compressible":true,"extensions":["dwd"]},"application/atsc-dynamic-event-message":{"source":"iana"},"application/atsc-held+xml":{"source":"iana","compressible":true,"extensions":["held"]},"application/atsc-rdt+json":{"source":"iana","compressible":true},"application/atsc-rsat+xml":{"source":"iana","compressible":true,"extensions":["rsat"]},"application/atxml":{"source":"iana"},"application/auth-policy+xml":{"source":"iana","compressible":true},"application/bacnet-xdd+zip":{"source":"iana","compressible":false},"application/batch-smtp":{"source":"iana"},"application/bdoc":{"compressible":false,"extensions":["bdoc"]},"application/beep+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/calendar+json":{"source":"iana","compressible":true},"application/calendar+xml":{"source":"iana","compressible":true,"extensions":["xcs"]},"application/call-completion":{"source":"iana"},"application/cals-1840":{"source":"iana"},"application/captive+json":{"source":"iana","compressible":true},"application/cbor":{"source":"iana"},"application/cbor-seq":{"source":"iana"},"application/cccex":{"source":"iana"},"application/ccmp+xml":{"source":"iana","compressible":true},"application/ccxml+xml":{"source":"iana","compressible":true,"extensions":["ccxml"]},"application/cdfx+xml":{"source":"iana","compressible":true,"extensions":["cdfx"]},"application/cdmi-capability":{"source":"iana","extensions":["cdmia"]},"application/cdmi-container":{"source":"iana","extensions":["cdmic"]},"application/cdmi-domain":{"source":"iana","extensions":["cdmid"]},"application/cdmi-object":{"source":"iana","extensions":["cdmio"]},"application/cdmi-queue":{"source":"iana","extensions":["cdmiq"]},"application/cdni":{"source":"iana"},"application/cea":{"source":"iana"},"application/cea-2018+xml":{"source":"iana","compressible":true},"application/cellml+xml":{"source":"iana","compressible":true},"application/cfw":{"source":"iana"},"application/city+json":{"source":"iana","compressible":true},"application/clr":{"source":"iana"},"application/clue+xml":{"source":"iana","compressible":true},"application/clue_info+xml":{"source":"iana","compressible":true},"application/cms":{"source":"iana"},"application/cnrp+xml":{"source":"iana","compressible":true},"application/coap-group+json":{"source":"iana","compressible":true},"application/coap-payload":{"source":"iana"},"application/commonground":{"source":"iana"},"application/conference-info+xml":{"source":"iana","compressible":true},"application/cose":{"source":"iana"},"application/cose-key":{"source":"iana"},"application/cose-key-set":{"source":"iana"},"application/cpl+xml":{"source":"iana","compressible":true,"extensions":["cpl"]},"application/csrattrs":{"source":"iana"},"application/csta+xml":{"source":"iana","compressible":true},"application/cstadata+xml":{"source":"iana","compressible":true},"application/csvm+json":{"source":"iana","compressible":true},"application/cu-seeme":{"source":"apache","extensions":["cu"]},"application/cwt":{"source":"iana"},"application/cybercash":{"source":"iana"},"application/dart":{"compressible":true},"application/dash+xml":{"source":"iana","compressible":true,"extensions":["mpd"]},"application/dash-patch+xml":{"source":"iana","compressible":true,"extensions":["mpp"]},"application/dashdelta":{"source":"iana"},"application/davmount+xml":{"source":"iana","compressible":true,"extensions":["davmount"]},"application/dca-rft":{"source":"iana"},"application/dcd":{"source":"iana"},"application/dec-dx":{"source":"iana"},"application/dialog-info+xml":{"source":"iana","compressible":true},"application/dicom":{"source":"iana"},"application/dicom+json":{"source":"iana","compressible":true},"application/dicom+xml":{"source":"iana","compressible":true},"application/dii":{"source":"iana"},"application/dit":{"source":"iana"},"application/dns":{"source":"iana"},"application/dns+json":{"source":"iana","compressible":true},"application/dns-message":{"source":"iana"},"application/docbook+xml":{"source":"apache","compressible":true,"extensions":["dbk"]},"application/dots+cbor":{"source":"iana"},"application/dskpp+xml":{"source":"iana","compressible":true},"application/dssc+der":{"source":"iana","extensions":["dssc"]},"application/dssc+xml":{"source":"iana","compressible":true,"extensions":["xdssc"]},"application/dvcs":{"source":"iana"},"application/ecmascript":{"source":"iana","compressible":true,"extensions":["es","ecma"]},"application/edi-consent":{"source":"iana"},"application/edi-x12":{"source":"iana","compressible":false},"application/edifact":{"source":"iana","compressible":false},"application/efi":{"source":"iana"},"application/elm+json":{"source":"iana","charset":"UTF-8","compressible":true},"application/elm+xml":{"source":"iana","compressible":true},"application/emergencycalldata.cap+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/emergencycalldata.comment+xml":{"source":"iana","compressible":true},"application/emergencycalldata.control+xml":{"source":"iana","compressible":true},"application/emergencycalldata.deviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.ecall.msd":{"source":"iana"},"application/emergencycalldata.providerinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.serviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.subscriberinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.veds+xml":{"source":"iana","compressible":true},"application/emma+xml":{"source":"iana","compressible":true,"extensions":["emma"]},"application/emotionml+xml":{"source":"iana","compressible":true,"extensions":["emotionml"]},"application/encaprtp":{"source":"iana"},"application/epp+xml":{"source":"iana","compressible":true},"application/epub+zip":{"source":"iana","compressible":false,"extensions":["epub"]},"application/eshop":{"source":"iana"},"application/exi":{"source":"iana","extensions":["exi"]},"application/expect-ct-report+json":{"source":"iana","compressible":true},"application/express":{"source":"iana","extensions":["exp"]},"application/fastinfoset":{"source":"iana"},"application/fastsoap":{"source":"iana"},"application/fdt+xml":{"source":"iana","compressible":true,"extensions":["fdt"]},"application/fhir+json":{"source":"iana","charset":"UTF-8","compressible":true},"application/fhir+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/fido.trusted-apps+json":{"compressible":true},"application/fits":{"source":"iana"},"application/flexfec":{"source":"iana"},"application/font-sfnt":{"source":"iana"},"application/font-tdpfr":{"source":"iana","extensions":["pfr"]},"application/font-woff":{"source":"iana","compressible":false},"application/framework-attributes+xml":{"source":"iana","compressible":true},"application/geo+json":{"source":"iana","compressible":true,"extensions":["geojson"]},"application/geo+json-seq":{"source":"iana"},"application/geopackage+sqlite3":{"source":"iana"},"application/geoxacml+xml":{"source":"iana","compressible":true},"application/gltf-buffer":{"source":"iana"},"application/gml+xml":{"source":"iana","compressible":true,"extensions":["gml"]},"application/gpx+xml":{"source":"apache","compressible":true,"extensions":["gpx"]},"application/gxf":{"source":"apache","extensions":["gxf"]},"application/gzip":{"source":"iana","compressible":false,"extensions":["gz"]},"application/h224":{"source":"iana"},"application/held+xml":{"source":"iana","compressible":true},"application/hjson":{"extensions":["hjson"]},"application/http":{"source":"iana"},"application/hyperstudio":{"source":"iana","extensions":["stk"]},"application/ibe-key-request+xml":{"source":"iana","compressible":true},"application/ibe-pkg-reply+xml":{"source":"iana","compressible":true},"application/ibe-pp-data":{"source":"iana"},"application/iges":{"source":"iana"},"application/im-iscomposing+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/index":{"source":"iana"},"application/index.cmd":{"source":"iana"},"application/index.obj":{"source":"iana"},"application/index.response":{"source":"iana"},"application/index.vnd":{"source":"iana"},"application/inkml+xml":{"source":"iana","compressible":true,"extensions":["ink","inkml"]},"application/iotp":{"source":"iana"},"application/ipfix":{"source":"iana","extensions":["ipfix"]},"application/ipp":{"source":"iana"},"application/isup":{"source":"iana"},"application/its+xml":{"source":"iana","compressible":true,"extensions":["its"]},"application/java-archive":{"source":"apache","compressible":false,"extensions":["jar","war","ear"]},"application/java-serialized-object":{"source":"apache","compressible":false,"extensions":["ser"]},"application/java-vm":{"source":"apache","compressible":false,"extensions":["class"]},"application/javascript":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["js","mjs"]},"application/jf2feed+json":{"source":"iana","compressible":true},"application/jose":{"source":"iana"},"application/jose+json":{"source":"iana","compressible":true},"application/jrd+json":{"source":"iana","compressible":true},"application/jscalendar+json":{"source":"iana","compressible":true},"application/json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["json","map"]},"application/json-patch+json":{"source":"iana","compressible":true},"application/json-seq":{"source":"iana"},"application/json5":{"extensions":["json5"]},"application/jsonml+json":{"source":"apache","compressible":true,"extensions":["jsonml"]},"application/jwk+json":{"source":"iana","compressible":true},"application/jwk-set+json":{"source":"iana","compressible":true},"application/jwt":{"source":"iana"},"application/kpml-request+xml":{"source":"iana","compressible":true},"application/kpml-response+xml":{"source":"iana","compressible":true},"application/ld+json":{"source":"iana","compressible":true,"extensions":["jsonld"]},"application/lgr+xml":{"source":"iana","compressible":true,"extensions":["lgr"]},"application/link-format":{"source":"iana"},"application/load-control+xml":{"source":"iana","compressible":true},"application/lost+xml":{"source":"iana","compressible":true,"extensions":["lostxml"]},"application/lostsync+xml":{"source":"iana","compressible":true},"application/lpf+zip":{"source":"iana","compressible":false},"application/lxf":{"source":"iana"},"application/mac-binhex40":{"source":"iana","extensions":["hqx"]},"application/mac-compactpro":{"source":"apache","extensions":["cpt"]},"application/macwriteii":{"source":"iana"},"application/mads+xml":{"source":"iana","compressible":true,"extensions":["mads"]},"application/manifest+json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["webmanifest"]},"application/marc":{"source":"iana","extensions":["mrc"]},"application/marcxml+xml":{"source":"iana","compressible":true,"extensions":["mrcx"]},"application/mathematica":{"source":"iana","extensions":["ma","nb","mb"]},"application/mathml+xml":{"source":"iana","compressible":true,"extensions":["mathml"]},"application/mathml-content+xml":{"source":"iana","compressible":true},"application/mathml-presentation+xml":{"source":"iana","compressible":true},"application/mbms-associated-procedure-description+xml":{"source":"iana","compressible":true},"application/mbms-deregister+xml":{"source":"iana","compressible":true},"application/mbms-envelope+xml":{"source":"iana","compressible":true},"application/mbms-msk+xml":{"source":"iana","compressible":true},"application/mbms-msk-response+xml":{"source":"iana","compressible":true},"application/mbms-protection-description+xml":{"source":"iana","compressible":true},"application/mbms-reception-report+xml":{"source":"iana","compressible":true},"application/mbms-register+xml":{"source":"iana","compressible":true},"application/mbms-register-response+xml":{"source":"iana","compressible":true},"application/mbms-schedule+xml":{"source":"iana","compressible":true},"application/mbms-user-service-description+xml":{"source":"iana","compressible":true},"application/mbox":{"source":"iana","extensions":["mbox"]},"application/media-policy-dataset+xml":{"source":"iana","compressible":true,"extensions":["mpf"]},"application/media_control+xml":{"source":"iana","compressible":true},"application/mediaservercontrol+xml":{"source":"iana","compressible":true,"extensions":["mscml"]},"application/merge-patch+json":{"source":"iana","compressible":true},"application/metalink+xml":{"source":"apache","compressible":true,"extensions":["metalink"]},"application/metalink4+xml":{"source":"iana","compressible":true,"extensions":["meta4"]},"application/mets+xml":{"source":"iana","compressible":true,"extensions":["mets"]},"application/mf4":{"source":"iana"},"application/mikey":{"source":"iana"},"application/mipc":{"source":"iana"},"application/missing-blocks+cbor-seq":{"source":"iana"},"application/mmt-aei+xml":{"source":"iana","compressible":true,"extensions":["maei"]},"application/mmt-usd+xml":{"source":"iana","compressible":true,"extensions":["musd"]},"application/mods+xml":{"source":"iana","compressible":true,"extensions":["mods"]},"application/moss-keys":{"source":"iana"},"application/moss-signature":{"source":"iana"},"application/mosskey-data":{"source":"iana"},"application/mosskey-request":{"source":"iana"},"application/mp21":{"source":"iana","extensions":["m21","mp21"]},"application/mp4":{"source":"iana","extensions":["mp4s","m4p"]},"application/mpeg4-generic":{"source":"iana"},"application/mpeg4-iod":{"source":"iana"},"application/mpeg4-iod-xmt":{"source":"iana"},"application/mrb-consumer+xml":{"source":"iana","compressible":true},"application/mrb-publish+xml":{"source":"iana","compressible":true},"application/msc-ivr+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/msc-mixer+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/msword":{"source":"iana","compressible":false,"extensions":["doc","dot"]},"application/mud+json":{"source":"iana","compressible":true},"application/multipart-core":{"source":"iana"},"application/mxf":{"source":"iana","extensions":["mxf"]},"application/n-quads":{"source":"iana","extensions":["nq"]},"application/n-triples":{"source":"iana","extensions":["nt"]},"application/nasdata":{"source":"iana"},"application/news-checkgroups":{"source":"iana","charset":"US-ASCII"},"application/news-groupinfo":{"source":"iana","charset":"US-ASCII"},"application/news-transmission":{"source":"iana"},"application/nlsml+xml":{"source":"iana","compressible":true},"application/node":{"source":"iana","extensions":["cjs"]},"application/nss":{"source":"iana"},"application/oauth-authz-req+jwt":{"source":"iana"},"application/oblivious-dns-message":{"source":"iana"},"application/ocsp-request":{"source":"iana"},"application/ocsp-response":{"source":"iana"},"application/octet-stream":{"source":"iana","compressible":false,"extensions":["bin","dms","lrf","mar","so","dist","distz","pkg","bpk","dump","elc","deploy","exe","dll","deb","dmg","iso","img","msi","msp","msm","buffer"]},"application/oda":{"source":"iana","extensions":["oda"]},"application/odm+xml":{"source":"iana","compressible":true},"application/odx":{"source":"iana"},"application/oebps-package+xml":{"source":"iana","compressible":true,"extensions":["opf"]},"application/ogg":{"source":"iana","compressible":false,"extensions":["ogx"]},"application/omdoc+xml":{"source":"apache","compressible":true,"extensions":["omdoc"]},"application/onenote":{"source":"apache","extensions":["onetoc","onetoc2","onetmp","onepkg"]},"application/opc-nodeset+xml":{"source":"iana","compressible":true},"application/oscore":{"source":"iana"},"application/oxps":{"source":"iana","extensions":["oxps"]},"application/p21":{"source":"iana"},"application/p21+zip":{"source":"iana","compressible":false},"application/p2p-overlay+xml":{"source":"iana","compressible":true,"extensions":["relo"]},"application/parityfec":{"source":"iana"},"application/passport":{"source":"iana"},"application/patch-ops-error+xml":{"source":"iana","compressible":true,"extensions":["xer"]},"application/pdf":{"source":"iana","compressible":false,"extensions":["pdf"]},"application/pdx":{"source":"iana"},"application/pem-certificate-chain":{"source":"iana"},"application/pgp-encrypted":{"source":"iana","compressible":false,"extensions":["pgp"]},"application/pgp-keys":{"source":"iana","extensions":["asc"]},"application/pgp-signature":{"source":"iana","extensions":["asc","sig"]},"application/pics-rules":{"source":"apache","extensions":["prf"]},"application/pidf+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/pidf-diff+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/pkcs10":{"source":"iana","extensions":["p10"]},"application/pkcs12":{"source":"iana"},"application/pkcs7-mime":{"source":"iana","extensions":["p7m","p7c"]},"application/pkcs7-signature":{"source":"iana","extensions":["p7s"]},"application/pkcs8":{"source":"iana","extensions":["p8"]},"application/pkcs8-encrypted":{"source":"iana"},"application/pkix-attr-cert":{"source":"iana","extensions":["ac"]},"application/pkix-cert":{"source":"iana","extensions":["cer"]},"application/pkix-crl":{"source":"iana","extensions":["crl"]},"application/pkix-pkipath":{"source":"iana","extensions":["pkipath"]},"application/pkixcmp":{"source":"iana","extensions":["pki"]},"application/pls+xml":{"source":"iana","compressible":true,"extensions":["pls"]},"application/poc-settings+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/postscript":{"source":"iana","compressible":true,"extensions":["ai","eps","ps"]},"application/ppsp-tracker+json":{"source":"iana","compressible":true},"application/problem+json":{"source":"iana","compressible":true},"application/problem+xml":{"source":"iana","compressible":true},"application/provenance+xml":{"source":"iana","compressible":true,"extensions":["provx"]},"application/prs.alvestrand.titrax-sheet":{"source":"iana"},"application/prs.cww":{"source":"iana","extensions":["cww"]},"application/prs.cyn":{"source":"iana","charset":"7-BIT"},"application/prs.hpub+zip":{"source":"iana","compressible":false},"application/prs.nprend":{"source":"iana"},"application/prs.plucker":{"source":"iana"},"application/prs.rdf-xml-crypt":{"source":"iana"},"application/prs.xsf+xml":{"source":"iana","compressible":true},"application/pskc+xml":{"source":"iana","compressible":true,"extensions":["pskcxml"]},"application/pvd+json":{"source":"iana","compressible":true},"application/qsig":{"source":"iana"},"application/raml+yaml":{"compressible":true,"extensions":["raml"]},"application/raptorfec":{"source":"iana"},"application/rdap+json":{"source":"iana","compressible":true},"application/rdf+xml":{"source":"iana","compressible":true,"extensions":["rdf","owl"]},"application/reginfo+xml":{"source":"iana","compressible":true,"extensions":["rif"]},"application/relax-ng-compact-syntax":{"source":"iana","extensions":["rnc"]},"application/remote-printing":{"source":"iana"},"application/reputon+json":{"source":"iana","compressible":true},"application/resource-lists+xml":{"source":"iana","compressible":true,"extensions":["rl"]},"application/resource-lists-diff+xml":{"source":"iana","compressible":true,"extensions":["rld"]},"application/rfc+xml":{"source":"iana","compressible":true},"application/riscos":{"source":"iana"},"application/rlmi+xml":{"source":"iana","compressible":true},"application/rls-services+xml":{"source":"iana","compressible":true,"extensions":["rs"]},"application/route-apd+xml":{"source":"iana","compressible":true,"extensions":["rapd"]},"application/route-s-tsid+xml":{"source":"iana","compressible":true,"extensions":["sls"]},"application/route-usd+xml":{"source":"iana","compressible":true,"extensions":["rusd"]},"application/rpki-ghostbusters":{"source":"iana","extensions":["gbr"]},"application/rpki-manifest":{"source":"iana","extensions":["mft"]},"application/rpki-publication":{"source":"iana"},"application/rpki-roa":{"source":"iana","extensions":["roa"]},"application/rpki-updown":{"source":"iana"},"application/rsd+xml":{"source":"apache","compressible":true,"extensions":["rsd"]},"application/rss+xml":{"source":"apache","compressible":true,"extensions":["rss"]},"application/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"application/rtploopback":{"source":"iana"},"application/rtx":{"source":"iana"},"application/samlassertion+xml":{"source":"iana","compressible":true},"application/samlmetadata+xml":{"source":"iana","compressible":true},"application/sarif+json":{"source":"iana","compressible":true},"application/sarif-external-properties+json":{"source":"iana","compressible":true},"application/sbe":{"source":"iana"},"application/sbml+xml":{"source":"iana","compressible":true,"extensions":["sbml"]},"application/scaip+xml":{"source":"iana","compressible":true},"application/scim+json":{"source":"iana","compressible":true},"application/scvp-cv-request":{"source":"iana","extensions":["scq"]},"application/scvp-cv-response":{"source":"iana","extensions":["scs"]},"application/scvp-vp-request":{"source":"iana","extensions":["spq"]},"application/scvp-vp-response":{"source":"iana","extensions":["spp"]},"application/sdp":{"source":"iana","extensions":["sdp"]},"application/secevent+jwt":{"source":"iana"},"application/senml+cbor":{"source":"iana"},"application/senml+json":{"source":"iana","compressible":true},"application/senml+xml":{"source":"iana","compressible":true,"extensions":["senmlx"]},"application/senml-etch+cbor":{"source":"iana"},"application/senml-etch+json":{"source":"iana","compressible":true},"application/senml-exi":{"source":"iana"},"application/sensml+cbor":{"source":"iana"},"application/sensml+json":{"source":"iana","compressible":true},"application/sensml+xml":{"source":"iana","compressible":true,"extensions":["sensmlx"]},"application/sensml-exi":{"source":"iana"},"application/sep+xml":{"source":"iana","compressible":true},"application/sep-exi":{"source":"iana"},"application/session-info":{"source":"iana"},"application/set-payment":{"source":"iana"},"application/set-payment-initiation":{"source":"iana","extensions":["setpay"]},"application/set-registration":{"source":"iana"},"application/set-registration-initiation":{"source":"iana","extensions":["setreg"]},"application/sgml":{"source":"iana"},"application/sgml-open-catalog":{"source":"iana"},"application/shf+xml":{"source":"iana","compressible":true,"extensions":["shf"]},"application/sieve":{"source":"iana","extensions":["siv","sieve"]},"application/simple-filter+xml":{"source":"iana","compressible":true},"application/simple-message-summary":{"source":"iana"},"application/simplesymbolcontainer":{"source":"iana"},"application/sipc":{"source":"iana"},"application/slate":{"source":"iana"},"application/smil":{"source":"iana"},"application/smil+xml":{"source":"iana","compressible":true,"extensions":["smi","smil"]},"application/smpte336m":{"source":"iana"},"application/soap+fastinfoset":{"source":"iana"},"application/soap+xml":{"source":"iana","compressible":true},"application/sparql-query":{"source":"iana","extensions":["rq"]},"application/sparql-results+xml":{"source":"iana","compressible":true,"extensions":["srx"]},"application/spdx+json":{"source":"iana","compressible":true},"application/spirits-event+xml":{"source":"iana","compressible":true},"application/sql":{"source":"iana"},"application/srgs":{"source":"iana","extensions":["gram"]},"application/srgs+xml":{"source":"iana","compressible":true,"extensions":["grxml"]},"application/sru+xml":{"source":"iana","compressible":true,"extensions":["sru"]},"application/ssdl+xml":{"source":"apache","compressible":true,"extensions":["ssdl"]},"application/ssml+xml":{"source":"iana","compressible":true,"extensions":["ssml"]},"application/stix+json":{"source":"iana","compressible":true},"application/swid+xml":{"source":"iana","compressible":true,"extensions":["swidtag"]},"application/tamp-apex-update":{"source":"iana"},"application/tamp-apex-update-confirm":{"source":"iana"},"application/tamp-community-update":{"source":"iana"},"application/tamp-community-update-confirm":{"source":"iana"},"application/tamp-error":{"source":"iana"},"application/tamp-sequence-adjust":{"source":"iana"},"application/tamp-sequence-adjust-confirm":{"source":"iana"},"application/tamp-status-query":{"source":"iana"},"application/tamp-status-response":{"source":"iana"},"application/tamp-update":{"source":"iana"},"application/tamp-update-confirm":{"source":"iana"},"application/tar":{"compressible":true},"application/taxii+json":{"source":"iana","compressible":true},"application/td+json":{"source":"iana","compressible":true},"application/tei+xml":{"source":"iana","compressible":true,"extensions":["tei","teicorpus"]},"application/tetra_isi":{"source":"iana"},"application/thraud+xml":{"source":"iana","compressible":true,"extensions":["tfi"]},"application/timestamp-query":{"source":"iana"},"application/timestamp-reply":{"source":"iana"},"application/timestamped-data":{"source":"iana","extensions":["tsd"]},"application/tlsrpt+gzip":{"source":"iana"},"application/tlsrpt+json":{"source":"iana","compressible":true},"application/tnauthlist":{"source":"iana"},"application/token-introspection+jwt":{"source":"iana"},"application/toml":{"compressible":true,"extensions":["toml"]},"application/trickle-ice-sdpfrag":{"source":"iana"},"application/trig":{"source":"iana","extensions":["trig"]},"application/ttml+xml":{"source":"iana","compressible":true,"extensions":["ttml"]},"application/tve-trigger":{"source":"iana"},"application/tzif":{"source":"iana"},"application/tzif-leap":{"source":"iana"},"application/ubjson":{"compressible":false,"extensions":["ubj"]},"application/ulpfec":{"source":"iana"},"application/urc-grpsheet+xml":{"source":"iana","compressible":true},"application/urc-ressheet+xml":{"source":"iana","compressible":true,"extensions":["rsheet"]},"application/urc-targetdesc+xml":{"source":"iana","compressible":true,"extensions":["td"]},"application/urc-uisocketdesc+xml":{"source":"iana","compressible":true},"application/vcard+json":{"source":"iana","compressible":true},"application/vcard+xml":{"source":"iana","compressible":true},"application/vemmi":{"source":"iana"},"application/vividence.scriptfile":{"source":"apache"},"application/vnd.1000minds.decision-model+xml":{"source":"iana","compressible":true,"extensions":["1km"]},"application/vnd.3gpp-prose+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-prose-pc3ch+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-v2x-local-service-information":{"source":"iana"},"application/vnd.3gpp.5gnas":{"source":"iana"},"application/vnd.3gpp.access-transfer-events+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.bsf+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.gmop+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.gtpc":{"source":"iana"},"application/vnd.3gpp.interworking-data":{"source":"iana"},"application/vnd.3gpp.lpp":{"source":"iana"},"application/vnd.3gpp.mc-signalling-ear":{"source":"iana"},"application/vnd.3gpp.mcdata-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-payload":{"source":"iana"},"application/vnd.3gpp.mcdata-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-signalling":{"source":"iana"},"application/vnd.3gpp.mcdata-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-floor-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-signed+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-init-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-affiliation-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-transmission-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mid-call+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.ngap":{"source":"iana"},"application/vnd.3gpp.pfcp":{"source":"iana"},"application/vnd.3gpp.pic-bw-large":{"source":"iana","extensions":["plb"]},"application/vnd.3gpp.pic-bw-small":{"source":"iana","extensions":["psb"]},"application/vnd.3gpp.pic-bw-var":{"source":"iana","extensions":["pvb"]},"application/vnd.3gpp.s1ap":{"source":"iana"},"application/vnd.3gpp.sms":{"source":"iana"},"application/vnd.3gpp.sms+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-ext+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.state-and-event-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.ussd+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.bcmcsinfo+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.sms":{"source":"iana"},"application/vnd.3gpp2.tcap":{"source":"iana","extensions":["tcap"]},"application/vnd.3lightssoftware.imagescal":{"source":"iana"},"application/vnd.3m.post-it-notes":{"source":"iana","extensions":["pwn"]},"application/vnd.accpac.simply.aso":{"source":"iana","extensions":["aso"]},"application/vnd.accpac.simply.imp":{"source":"iana","extensions":["imp"]},"application/vnd.acucobol":{"source":"iana","extensions":["acu"]},"application/vnd.acucorp":{"source":"iana","extensions":["atc","acutc"]},"application/vnd.adobe.air-application-installer-package+zip":{"source":"apache","compressible":false,"extensions":["air"]},"application/vnd.adobe.flash.movie":{"source":"iana"},"application/vnd.adobe.formscentral.fcdt":{"source":"iana","extensions":["fcdt"]},"application/vnd.adobe.fxp":{"source":"iana","extensions":["fxp","fxpl"]},"application/vnd.adobe.partial-upload":{"source":"iana"},"application/vnd.adobe.xdp+xml":{"source":"iana","compressible":true,"extensions":["xdp"]},"application/vnd.adobe.xfdf":{"source":"iana","extensions":["xfdf"]},"application/vnd.aether.imp":{"source":"iana"},"application/vnd.afpc.afplinedata":{"source":"iana"},"application/vnd.afpc.afplinedata-pagedef":{"source":"iana"},"application/vnd.afpc.cmoca-cmresource":{"source":"iana"},"application/vnd.afpc.foca-charset":{"source":"iana"},"application/vnd.afpc.foca-codedfont":{"source":"iana"},"application/vnd.afpc.foca-codepage":{"source":"iana"},"application/vnd.afpc.modca":{"source":"iana"},"application/vnd.afpc.modca-cmtable":{"source":"iana"},"application/vnd.afpc.modca-formdef":{"source":"iana"},"application/vnd.afpc.modca-mediummap":{"source":"iana"},"application/vnd.afpc.modca-objectcontainer":{"source":"iana"},"application/vnd.afpc.modca-overlay":{"source":"iana"},"application/vnd.afpc.modca-pagesegment":{"source":"iana"},"application/vnd.age":{"source":"iana","extensions":["age"]},"application/vnd.ah-barcode":{"source":"iana"},"application/vnd.ahead.space":{"source":"iana","extensions":["ahead"]},"application/vnd.airzip.filesecure.azf":{"source":"iana","extensions":["azf"]},"application/vnd.airzip.filesecure.azs":{"source":"iana","extensions":["azs"]},"application/vnd.amadeus+json":{"source":"iana","compressible":true},"application/vnd.amazon.ebook":{"source":"apache","extensions":["azw"]},"application/vnd.amazon.mobi8-ebook":{"source":"iana"},"application/vnd.americandynamics.acc":{"source":"iana","extensions":["acc"]},"application/vnd.amiga.ami":{"source":"iana","extensions":["ami"]},"application/vnd.amundsen.maze+xml":{"source":"iana","compressible":true},"application/vnd.android.ota":{"source":"iana"},"application/vnd.android.package-archive":{"source":"apache","compressible":false,"extensions":["apk"]},"application/vnd.anki":{"source":"iana"},"application/vnd.anser-web-certificate-issue-initiation":{"source":"iana","extensions":["cii"]},"application/vnd.anser-web-funds-transfer-initiation":{"source":"apache","extensions":["fti"]},"application/vnd.antix.game-component":{"source":"iana","extensions":["atx"]},"application/vnd.apache.arrow.file":{"source":"iana"},"application/vnd.apache.arrow.stream":{"source":"iana"},"application/vnd.apache.thrift.binary":{"source":"iana"},"application/vnd.apache.thrift.compact":{"source":"iana"},"application/vnd.apache.thrift.json":{"source":"iana"},"application/vnd.api+json":{"source":"iana","compressible":true},"application/vnd.aplextor.warrp+json":{"source":"iana","compressible":true},"application/vnd.apothekende.reservation+json":{"source":"iana","compressible":true},"application/vnd.apple.installer+xml":{"source":"iana","compressible":true,"extensions":["mpkg"]},"application/vnd.apple.keynote":{"source":"iana","extensions":["key"]},"application/vnd.apple.mpegurl":{"source":"iana","extensions":["m3u8"]},"application/vnd.apple.numbers":{"source":"iana","extensions":["numbers"]},"application/vnd.apple.pages":{"source":"iana","extensions":["pages"]},"application/vnd.apple.pkpass":{"compressible":false,"extensions":["pkpass"]},"application/vnd.arastra.swi":{"source":"iana"},"application/vnd.aristanetworks.swi":{"source":"iana","extensions":["swi"]},"application/vnd.artisan+json":{"source":"iana","compressible":true},"application/vnd.artsquare":{"source":"iana"},"application/vnd.astraea-software.iota":{"source":"iana","extensions":["iota"]},"application/vnd.audiograph":{"source":"iana","extensions":["aep"]},"application/vnd.autopackage":{"source":"iana"},"application/vnd.avalon+json":{"source":"iana","compressible":true},"application/vnd.avistar+xml":{"source":"iana","compressible":true},"application/vnd.balsamiq.bmml+xml":{"source":"iana","compressible":true,"extensions":["bmml"]},"application/vnd.balsamiq.bmpr":{"source":"iana"},"application/vnd.banana-accounting":{"source":"iana"},"application/vnd.bbf.usp.error":{"source":"iana"},"application/vnd.bbf.usp.msg":{"source":"iana"},"application/vnd.bbf.usp.msg+json":{"source":"iana","compressible":true},"application/vnd.bekitzur-stech+json":{"source":"iana","compressible":true},"application/vnd.bint.med-content":{"source":"iana"},"application/vnd.biopax.rdf+xml":{"source":"iana","compressible":true},"application/vnd.blink-idb-value-wrapper":{"source":"iana"},"application/vnd.blueice.multipass":{"source":"iana","extensions":["mpm"]},"application/vnd.bluetooth.ep.oob":{"source":"iana"},"application/vnd.bluetooth.le.oob":{"source":"iana"},"application/vnd.bmi":{"source":"iana","extensions":["bmi"]},"application/vnd.bpf":{"source":"iana"},"application/vnd.bpf3":{"source":"iana"},"application/vnd.businessobjects":{"source":"iana","extensions":["rep"]},"application/vnd.byu.uapi+json":{"source":"iana","compressible":true},"application/vnd.cab-jscript":{"source":"iana"},"application/vnd.canon-cpdl":{"source":"iana"},"application/vnd.canon-lips":{"source":"iana"},"application/vnd.capasystems-pg+json":{"source":"iana","compressible":true},"application/vnd.cendio.thinlinc.clientconf":{"source":"iana"},"application/vnd.century-systems.tcp_stream":{"source":"iana"},"application/vnd.chemdraw+xml":{"source":"iana","compressible":true,"extensions":["cdxml"]},"application/vnd.chess-pgn":{"source":"iana"},"application/vnd.chipnuts.karaoke-mmd":{"source":"iana","extensions":["mmd"]},"application/vnd.ciedi":{"source":"iana"},"application/vnd.cinderella":{"source":"iana","extensions":["cdy"]},"application/vnd.cirpack.isdn-ext":{"source":"iana"},"application/vnd.citationstyles.style+xml":{"source":"iana","compressible":true,"extensions":["csl"]},"application/vnd.claymore":{"source":"iana","extensions":["cla"]},"application/vnd.cloanto.rp9":{"source":"iana","extensions":["rp9"]},"application/vnd.clonk.c4group":{"source":"iana","extensions":["c4g","c4d","c4f","c4p","c4u"]},"application/vnd.cluetrust.cartomobile-config":{"source":"iana","extensions":["c11amc"]},"application/vnd.cluetrust.cartomobile-config-pkg":{"source":"iana","extensions":["c11amz"]},"application/vnd.coffeescript":{"source":"iana"},"application/vnd.collabio.xodocuments.document":{"source":"iana"},"application/vnd.collabio.xodocuments.document-template":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation-template":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet-template":{"source":"iana"},"application/vnd.collection+json":{"source":"iana","compressible":true},"application/vnd.collection.doc+json":{"source":"iana","compressible":true},"application/vnd.collection.next+json":{"source":"iana","compressible":true},"application/vnd.comicbook+zip":{"source":"iana","compressible":false},"application/vnd.comicbook-rar":{"source":"iana"},"application/vnd.commerce-battelle":{"source":"iana"},"application/vnd.commonspace":{"source":"iana","extensions":["csp"]},"application/vnd.contact.cmsg":{"source":"iana","extensions":["cdbcmsg"]},"application/vnd.coreos.ignition+json":{"source":"iana","compressible":true},"application/vnd.cosmocaller":{"source":"iana","extensions":["cmc"]},"application/vnd.crick.clicker":{"source":"iana","extensions":["clkx"]},"application/vnd.crick.clicker.keyboard":{"source":"iana","extensions":["clkk"]},"application/vnd.crick.clicker.palette":{"source":"iana","extensions":["clkp"]},"application/vnd.crick.clicker.template":{"source":"iana","extensions":["clkt"]},"application/vnd.crick.clicker.wordbank":{"source":"iana","extensions":["clkw"]},"application/vnd.criticaltools.wbs+xml":{"source":"iana","compressible":true,"extensions":["wbs"]},"application/vnd.cryptii.pipe+json":{"source":"iana","compressible":true},"application/vnd.crypto-shade-file":{"source":"iana"},"application/vnd.cryptomator.encrypted":{"source":"iana"},"application/vnd.cryptomator.vault":{"source":"iana"},"application/vnd.ctc-posml":{"source":"iana","extensions":["pml"]},"application/vnd.ctct.ws+xml":{"source":"iana","compressible":true},"application/vnd.cups-pdf":{"source":"iana"},"application/vnd.cups-postscript":{"source":"iana"},"application/vnd.cups-ppd":{"source":"iana","extensions":["ppd"]},"application/vnd.cups-raster":{"source":"iana"},"application/vnd.cups-raw":{"source":"iana"},"application/vnd.curl":{"source":"iana"},"application/vnd.curl.car":{"source":"apache","extensions":["car"]},"application/vnd.curl.pcurl":{"source":"apache","extensions":["pcurl"]},"application/vnd.cyan.dean.root+xml":{"source":"iana","compressible":true},"application/vnd.cybank":{"source":"iana"},"application/vnd.cyclonedx+json":{"source":"iana","compressible":true},"application/vnd.cyclonedx+xml":{"source":"iana","compressible":true},"application/vnd.d2l.coursepackage1p0+zip":{"source":"iana","compressible":false},"application/vnd.d3m-dataset":{"source":"iana"},"application/vnd.d3m-problem":{"source":"iana"},"application/vnd.dart":{"source":"iana","compressible":true,"extensions":["dart"]},"application/vnd.data-vision.rdz":{"source":"iana","extensions":["rdz"]},"application/vnd.datapackage+json":{"source":"iana","compressible":true},"application/vnd.dataresource+json":{"source":"iana","compressible":true},"application/vnd.dbf":{"source":"iana","extensions":["dbf"]},"application/vnd.debian.binary-package":{"source":"iana"},"application/vnd.dece.data":{"source":"iana","extensions":["uvf","uvvf","uvd","uvvd"]},"application/vnd.dece.ttml+xml":{"source":"iana","compressible":true,"extensions":["uvt","uvvt"]},"application/vnd.dece.unspecified":{"source":"iana","extensions":["uvx","uvvx"]},"application/vnd.dece.zip":{"source":"iana","extensions":["uvz","uvvz"]},"application/vnd.denovo.fcselayout-link":{"source":"iana","extensions":["fe_launch"]},"application/vnd.desmume.movie":{"source":"iana"},"application/vnd.dir-bi.plate-dl-nosuffix":{"source":"iana"},"application/vnd.dm.delegation+xml":{"source":"iana","compressible":true},"application/vnd.dna":{"source":"iana","extensions":["dna"]},"application/vnd.document+json":{"source":"iana","compressible":true},"application/vnd.dolby.mlp":{"source":"apache","extensions":["mlp"]},"application/vnd.dolby.mobile.1":{"source":"iana"},"application/vnd.dolby.mobile.2":{"source":"iana"},"application/vnd.doremir.scorecloud-binary-document":{"source":"iana"},"application/vnd.dpgraph":{"source":"iana","extensions":["dpg"]},"application/vnd.dreamfactory":{"source":"iana","extensions":["dfac"]},"application/vnd.drive+json":{"source":"iana","compressible":true},"application/vnd.ds-keypoint":{"source":"apache","extensions":["kpxx"]},"application/vnd.dtg.local":{"source":"iana"},"application/vnd.dtg.local.flash":{"source":"iana"},"application/vnd.dtg.local.html":{"source":"iana"},"application/vnd.dvb.ait":{"source":"iana","extensions":["ait"]},"application/vnd.dvb.dvbisl+xml":{"source":"iana","compressible":true},"application/vnd.dvb.dvbj":{"source":"iana"},"application/vnd.dvb.esgcontainer":{"source":"iana"},"application/vnd.dvb.ipdcdftnotifaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess2":{"source":"iana"},"application/vnd.dvb.ipdcesgpdd":{"source":"iana"},"application/vnd.dvb.ipdcroaming":{"source":"iana"},"application/vnd.dvb.iptv.alfec-base":{"source":"iana"},"application/vnd.dvb.iptv.alfec-enhancement":{"source":"iana"},"application/vnd.dvb.notif-aggregate-root+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-container+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-generic+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-msglist+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-request+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-response+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-init+xml":{"source":"iana","compressible":true},"application/vnd.dvb.pfr":{"source":"iana"},"application/vnd.dvb.service":{"source":"iana","extensions":["svc"]},"application/vnd.dxr":{"source":"iana"},"application/vnd.dynageo":{"source":"iana","extensions":["geo"]},"application/vnd.dzr":{"source":"iana"},"application/vnd.easykaraoke.cdgdownload":{"source":"iana"},"application/vnd.ecdis-update":{"source":"iana"},"application/vnd.ecip.rlp":{"source":"iana"},"application/vnd.eclipse.ditto+json":{"source":"iana","compressible":true},"application/vnd.ecowin.chart":{"source":"iana","extensions":["mag"]},"application/vnd.ecowin.filerequest":{"source":"iana"},"application/vnd.ecowin.fileupdate":{"source":"iana"},"application/vnd.ecowin.series":{"source":"iana"},"application/vnd.ecowin.seriesrequest":{"source":"iana"},"application/vnd.ecowin.seriesupdate":{"source":"iana"},"application/vnd.efi.img":{"source":"iana"},"application/vnd.efi.iso":{"source":"iana"},"application/vnd.emclient.accessrequest+xml":{"source":"iana","compressible":true},"application/vnd.enliven":{"source":"iana","extensions":["nml"]},"application/vnd.enphase.envoy":{"source":"iana"},"application/vnd.eprints.data+xml":{"source":"iana","compressible":true},"application/vnd.epson.esf":{"source":"iana","extensions":["esf"]},"application/vnd.epson.msf":{"source":"iana","extensions":["msf"]},"application/vnd.epson.quickanime":{"source":"iana","extensions":["qam"]},"application/vnd.epson.salt":{"source":"iana","extensions":["slt"]},"application/vnd.epson.ssf":{"source":"iana","extensions":["ssf"]},"application/vnd.ericsson.quickcall":{"source":"iana"},"application/vnd.espass-espass+zip":{"source":"iana","compressible":false},"application/vnd.eszigno3+xml":{"source":"iana","compressible":true,"extensions":["es3","et3"]},"application/vnd.etsi.aoc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.asic-e+zip":{"source":"iana","compressible":false},"application/vnd.etsi.asic-s+zip":{"source":"iana","compressible":false},"application/vnd.etsi.cug+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvcommand+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-bc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-cod+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-npvr+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvservice+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsync+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvueprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mcid+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mheg5":{"source":"iana"},"application/vnd.etsi.overload-control-policy-dataset+xml":{"source":"iana","compressible":true},"application/vnd.etsi.pstn+xml":{"source":"iana","compressible":true},"application/vnd.etsi.sci+xml":{"source":"iana","compressible":true},"application/vnd.etsi.simservs+xml":{"source":"iana","compressible":true},"application/vnd.etsi.timestamp-token":{"source":"iana"},"application/vnd.etsi.tsl+xml":{"source":"iana","compressible":true},"application/vnd.etsi.tsl.der":{"source":"iana"},"application/vnd.eu.kasparian.car+json":{"source":"iana","compressible":true},"application/vnd.eudora.data":{"source":"iana"},"application/vnd.evolv.ecig.profile":{"source":"iana"},"application/vnd.evolv.ecig.settings":{"source":"iana"},"application/vnd.evolv.ecig.theme":{"source":"iana"},"application/vnd.exstream-empower+zip":{"source":"iana","compressible":false},"application/vnd.exstream-package":{"source":"iana"},"application/vnd.ezpix-album":{"source":"iana","extensions":["ez2"]},"application/vnd.ezpix-package":{"source":"iana","extensions":["ez3"]},"application/vnd.f-secure.mobile":{"source":"iana"},"application/vnd.familysearch.gedcom+zip":{"source":"iana","compressible":false},"application/vnd.fastcopy-disk-image":{"source":"iana"},"application/vnd.fdf":{"source":"iana","extensions":["fdf"]},"application/vnd.fdsn.mseed":{"source":"iana","extensions":["mseed"]},"application/vnd.fdsn.seed":{"source":"iana","extensions":["seed","dataless"]},"application/vnd.ffsns":{"source":"iana"},"application/vnd.ficlab.flb+zip":{"source":"iana","compressible":false},"application/vnd.filmit.zfc":{"source":"iana"},"application/vnd.fints":{"source":"iana"},"application/vnd.firemonkeys.cloudcell":{"source":"iana"},"application/vnd.flographit":{"source":"iana","extensions":["gph"]},"application/vnd.fluxtime.clip":{"source":"iana","extensions":["ftc"]},"application/vnd.font-fontforge-sfd":{"source":"iana"},"application/vnd.framemaker":{"source":"iana","extensions":["fm","frame","maker","book"]},"application/vnd.frogans.fnc":{"source":"iana","extensions":["fnc"]},"application/vnd.frogans.ltf":{"source":"iana","extensions":["ltf"]},"application/vnd.fsc.weblaunch":{"source":"iana","extensions":["fsc"]},"application/vnd.fujifilm.fb.docuworks":{"source":"iana"},"application/vnd.fujifilm.fb.docuworks.binder":{"source":"iana"},"application/vnd.fujifilm.fb.docuworks.container":{"source":"iana"},"application/vnd.fujifilm.fb.jfi+xml":{"source":"iana","compressible":true},"application/vnd.fujitsu.oasys":{"source":"iana","extensions":["oas"]},"application/vnd.fujitsu.oasys2":{"source":"iana","extensions":["oa2"]},"application/vnd.fujitsu.oasys3":{"source":"iana","extensions":["oa3"]},"application/vnd.fujitsu.oasysgp":{"source":"iana","extensions":["fg5"]},"application/vnd.fujitsu.oasysprs":{"source":"iana","extensions":["bh2"]},"application/vnd.fujixerox.art-ex":{"source":"iana"},"application/vnd.fujixerox.art4":{"source":"iana"},"application/vnd.fujixerox.ddd":{"source":"iana","extensions":["ddd"]},"application/vnd.fujixerox.docuworks":{"source":"iana","extensions":["xdw"]},"application/vnd.fujixerox.docuworks.binder":{"source":"iana","extensions":["xbd"]},"application/vnd.fujixerox.docuworks.container":{"source":"iana"},"application/vnd.fujixerox.hbpl":{"source":"iana"},"application/vnd.fut-misnet":{"source":"iana"},"application/vnd.futoin+cbor":{"source":"iana"},"application/vnd.futoin+json":{"source":"iana","compressible":true},"application/vnd.fuzzysheet":{"source":"iana","extensions":["fzs"]},"application/vnd.genomatix.tuxedo":{"source":"iana","extensions":["txd"]},"application/vnd.gentics.grd+json":{"source":"iana","compressible":true},"application/vnd.geo+json":{"source":"iana","compressible":true},"application/vnd.geocube+xml":{"source":"iana","compressible":true},"application/vnd.geogebra.file":{"source":"iana","extensions":["ggb"]},"application/vnd.geogebra.slides":{"source":"iana"},"application/vnd.geogebra.tool":{"source":"iana","extensions":["ggt"]},"application/vnd.geometry-explorer":{"source":"iana","extensions":["gex","gre"]},"application/vnd.geonext":{"source":"iana","extensions":["gxt"]},"application/vnd.geoplan":{"source":"iana","extensions":["g2w"]},"application/vnd.geospace":{"source":"iana","extensions":["g3w"]},"application/vnd.gerber":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt-response":{"source":"iana"},"application/vnd.gmx":{"source":"iana","extensions":["gmx"]},"application/vnd.google-apps.document":{"compressible":false,"extensions":["gdoc"]},"application/vnd.google-apps.presentation":{"compressible":false,"extensions":["gslides"]},"application/vnd.google-apps.spreadsheet":{"compressible":false,"extensions":["gsheet"]},"application/vnd.google-earth.kml+xml":{"source":"iana","compressible":true,"extensions":["kml"]},"application/vnd.google-earth.kmz":{"source":"iana","compressible":false,"extensions":["kmz"]},"application/vnd.gov.sk.e-form+xml":{"source":"iana","compressible":true},"application/vnd.gov.sk.e-form+zip":{"source":"iana","compressible":false},"application/vnd.gov.sk.xmldatacontainer+xml":{"source":"iana","compressible":true},"application/vnd.grafeq":{"source":"iana","extensions":["gqf","gqs"]},"application/vnd.gridmp":{"source":"iana"},"application/vnd.groove-account":{"source":"iana","extensions":["gac"]},"application/vnd.groove-help":{"source":"iana","extensions":["ghf"]},"application/vnd.groove-identity-message":{"source":"iana","extensions":["gim"]},"application/vnd.groove-injector":{"source":"iana","extensions":["grv"]},"application/vnd.groove-tool-message":{"source":"iana","extensions":["gtm"]},"application/vnd.groove-tool-template":{"source":"iana","extensions":["tpl"]},"application/vnd.groove-vcard":{"source":"iana","extensions":["vcg"]},"application/vnd.hal+json":{"source":"iana","compressible":true},"application/vnd.hal+xml":{"source":"iana","compressible":true,"extensions":["hal"]},"application/vnd.handheld-entertainment+xml":{"source":"iana","compressible":true,"extensions":["zmm"]},"application/vnd.hbci":{"source":"iana","extensions":["hbci"]},"application/vnd.hc+json":{"source":"iana","compressible":true},"application/vnd.hcl-bireports":{"source":"iana"},"application/vnd.hdt":{"source":"iana"},"application/vnd.heroku+json":{"source":"iana","compressible":true},"application/vnd.hhe.lesson-player":{"source":"iana","extensions":["les"]},"application/vnd.hl7cda+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.hl7v2+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.hp-hpgl":{"source":"iana","extensions":["hpgl"]},"application/vnd.hp-hpid":{"source":"iana","extensions":["hpid"]},"application/vnd.hp-hps":{"source":"iana","extensions":["hps"]},"application/vnd.hp-jlyt":{"source":"iana","extensions":["jlt"]},"application/vnd.hp-pcl":{"source":"iana","extensions":["pcl"]},"application/vnd.hp-pclxl":{"source":"iana","extensions":["pclxl"]},"application/vnd.httphone":{"source":"iana"},"application/vnd.hydrostatix.sof-data":{"source":"iana","extensions":["sfd-hdstx"]},"application/vnd.hyper+json":{"source":"iana","compressible":true},"application/vnd.hyper-item+json":{"source":"iana","compressible":true},"application/vnd.hyperdrive+json":{"source":"iana","compressible":true},"application/vnd.hzn-3d-crossword":{"source":"iana"},"application/vnd.ibm.afplinedata":{"source":"iana"},"application/vnd.ibm.electronic-media":{"source":"iana"},"application/vnd.ibm.minipay":{"source":"iana","extensions":["mpy"]},"application/vnd.ibm.modcap":{"source":"iana","extensions":["afp","listafp","list3820"]},"application/vnd.ibm.rights-management":{"source":"iana","extensions":["irm"]},"application/vnd.ibm.secure-container":{"source":"iana","extensions":["sc"]},"application/vnd.iccprofile":{"source":"iana","extensions":["icc","icm"]},"application/vnd.ieee.1905":{"source":"iana"},"application/vnd.igloader":{"source":"iana","extensions":["igl"]},"application/vnd.imagemeter.folder+zip":{"source":"iana","compressible":false},"application/vnd.imagemeter.image+zip":{"source":"iana","compressible":false},"application/vnd.immervision-ivp":{"source":"iana","extensions":["ivp"]},"application/vnd.immervision-ivu":{"source":"iana","extensions":["ivu"]},"application/vnd.ims.imsccv1p1":{"source":"iana"},"application/vnd.ims.imsccv1p2":{"source":"iana"},"application/vnd.ims.imsccv1p3":{"source":"iana"},"application/vnd.ims.lis.v2.result+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolconsumerprofile+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy.id+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings.simple+json":{"source":"iana","compressible":true},"application/vnd.informedcontrol.rms+xml":{"source":"iana","compressible":true},"application/vnd.informix-visionary":{"source":"iana"},"application/vnd.infotech.project":{"source":"iana"},"application/vnd.infotech.project+xml":{"source":"iana","compressible":true},"application/vnd.innopath.wamp.notification":{"source":"iana"},"application/vnd.insors.igm":{"source":"iana","extensions":["igm"]},"application/vnd.intercon.formnet":{"source":"iana","extensions":["xpw","xpx"]},"application/vnd.intergeo":{"source":"iana","extensions":["i2g"]},"application/vnd.intertrust.digibox":{"source":"iana"},"application/vnd.intertrust.nncp":{"source":"iana"},"application/vnd.intu.qbo":{"source":"iana","extensions":["qbo"]},"application/vnd.intu.qfx":{"source":"iana","extensions":["qfx"]},"application/vnd.iptc.g2.catalogitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.conceptitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.knowledgeitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsmessage+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.packageitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.planningitem+xml":{"source":"iana","compressible":true},"application/vnd.ipunplugged.rcprofile":{"source":"iana","extensions":["rcprofile"]},"application/vnd.irepository.package+xml":{"source":"iana","compressible":true,"extensions":["irp"]},"application/vnd.is-xpr":{"source":"iana","extensions":["xpr"]},"application/vnd.isac.fcs":{"source":"iana","extensions":["fcs"]},"application/vnd.iso11783-10+zip":{"source":"iana","compressible":false},"application/vnd.jam":{"source":"iana","extensions":["jam"]},"application/vnd.japannet-directory-service":{"source":"iana"},"application/vnd.japannet-jpnstore-wakeup":{"source":"iana"},"application/vnd.japannet-payment-wakeup":{"source":"iana"},"application/vnd.japannet-registration":{"source":"iana"},"application/vnd.japannet-registration-wakeup":{"source":"iana"},"application/vnd.japannet-setstore-wakeup":{"source":"iana"},"application/vnd.japannet-verification":{"source":"iana"},"application/vnd.japannet-verification-wakeup":{"source":"iana"},"application/vnd.jcp.javame.midlet-rms":{"source":"iana","extensions":["rms"]},"application/vnd.jisp":{"source":"iana","extensions":["jisp"]},"application/vnd.joost.joda-archive":{"source":"iana","extensions":["joda"]},"application/vnd.jsk.isdn-ngn":{"source":"iana"},"application/vnd.kahootz":{"source":"iana","extensions":["ktz","ktr"]},"application/vnd.kde.karbon":{"source":"iana","extensions":["karbon"]},"application/vnd.kde.kchart":{"source":"iana","extensions":["chrt"]},"application/vnd.kde.kformula":{"source":"iana","extensions":["kfo"]},"application/vnd.kde.kivio":{"source":"iana","extensions":["flw"]},"application/vnd.kde.kontour":{"source":"iana","extensions":["kon"]},"application/vnd.kde.kpresenter":{"source":"iana","extensions":["kpr","kpt"]},"application/vnd.kde.kspread":{"source":"iana","extensions":["ksp"]},"application/vnd.kde.kword":{"source":"iana","extensions":["kwd","kwt"]},"application/vnd.kenameaapp":{"source":"iana","extensions":["htke"]},"application/vnd.kidspiration":{"source":"iana","extensions":["kia"]},"application/vnd.kinar":{"source":"iana","extensions":["kne","knp"]},"application/vnd.koan":{"source":"iana","extensions":["skp","skd","skt","skm"]},"application/vnd.kodak-descriptor":{"source":"iana","extensions":["sse"]},"application/vnd.las":{"source":"iana"},"application/vnd.las.las+json":{"source":"iana","compressible":true},"application/vnd.las.las+xml":{"source":"iana","compressible":true,"extensions":["lasxml"]},"application/vnd.laszip":{"source":"iana"},"application/vnd.leap+json":{"source":"iana","compressible":true},"application/vnd.liberty-request+xml":{"source":"iana","compressible":true},"application/vnd.llamagraphics.life-balance.desktop":{"source":"iana","extensions":["lbd"]},"application/vnd.llamagraphics.life-balance.exchange+xml":{"source":"iana","compressible":true,"extensions":["lbe"]},"application/vnd.logipipe.circuit+zip":{"source":"iana","compressible":false},"application/vnd.loom":{"source":"iana"},"application/vnd.lotus-1-2-3":{"source":"iana","extensions":["123"]},"application/vnd.lotus-approach":{"source":"iana","extensions":["apr"]},"application/vnd.lotus-freelance":{"source":"iana","extensions":["pre"]},"application/vnd.lotus-notes":{"source":"iana","extensions":["nsf"]},"application/vnd.lotus-organizer":{"source":"iana","extensions":["org"]},"application/vnd.lotus-screencam":{"source":"iana","extensions":["scm"]},"application/vnd.lotus-wordpro":{"source":"iana","extensions":["lwp"]},"application/vnd.macports.portpkg":{"source":"iana","extensions":["portpkg"]},"application/vnd.mapbox-vector-tile":{"source":"iana","extensions":["mvt"]},"application/vnd.marlin.drm.actiontoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.conftoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.license+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.mdcf":{"source":"iana"},"application/vnd.mason+json":{"source":"iana","compressible":true},"application/vnd.maxar.archive.3tz+zip":{"source":"iana","compressible":false},"application/vnd.maxmind.maxmind-db":{"source":"iana"},"application/vnd.mcd":{"source":"iana","extensions":["mcd"]},"application/vnd.medcalcdata":{"source":"iana","extensions":["mc1"]},"application/vnd.mediastation.cdkey":{"source":"iana","extensions":["cdkey"]},"application/vnd.meridian-slingshot":{"source":"iana"},"application/vnd.mfer":{"source":"iana","extensions":["mwf"]},"application/vnd.mfmp":{"source":"iana","extensions":["mfm"]},"application/vnd.micro+json":{"source":"iana","compressible":true},"application/vnd.micrografx.flo":{"source":"iana","extensions":["flo"]},"application/vnd.micrografx.igx":{"source":"iana","extensions":["igx"]},"application/vnd.microsoft.portable-executable":{"source":"iana"},"application/vnd.microsoft.windows.thumbnail-cache":{"source":"iana"},"application/vnd.miele+json":{"source":"iana","compressible":true},"application/vnd.mif":{"source":"iana","extensions":["mif"]},"application/vnd.minisoft-hp3000-save":{"source":"iana"},"application/vnd.mitsubishi.misty-guard.trustweb":{"source":"iana"},"application/vnd.mobius.daf":{"source":"iana","extensions":["daf"]},"application/vnd.mobius.dis":{"source":"iana","extensions":["dis"]},"application/vnd.mobius.mbk":{"source":"iana","extensions":["mbk"]},"application/vnd.mobius.mqy":{"source":"iana","extensions":["mqy"]},"application/vnd.mobius.msl":{"source":"iana","extensions":["msl"]},"application/vnd.mobius.plc":{"source":"iana","extensions":["plc"]},"application/vnd.mobius.txf":{"source":"iana","extensions":["txf"]},"application/vnd.mophun.application":{"source":"iana","extensions":["mpn"]},"application/vnd.mophun.certificate":{"source":"iana","extensions":["mpc"]},"application/vnd.motorola.flexsuite":{"source":"iana"},"application/vnd.motorola.flexsuite.adsi":{"source":"iana"},"application/vnd.motorola.flexsuite.fis":{"source":"iana"},"application/vnd.motorola.flexsuite.gotap":{"source":"iana"},"application/vnd.motorola.flexsuite.kmr":{"source":"iana"},"application/vnd.motorola.flexsuite.ttc":{"source":"iana"},"application/vnd.motorola.flexsuite.wem":{"source":"iana"},"application/vnd.motorola.iprm":{"source":"iana"},"application/vnd.mozilla.xul+xml":{"source":"iana","compressible":true,"extensions":["xul"]},"application/vnd.ms-3mfdocument":{"source":"iana"},"application/vnd.ms-artgalry":{"source":"iana","extensions":["cil"]},"application/vnd.ms-asf":{"source":"iana"},"application/vnd.ms-cab-compressed":{"source":"iana","extensions":["cab"]},"application/vnd.ms-color.iccprofile":{"source":"apache"},"application/vnd.ms-excel":{"source":"iana","compressible":false,"extensions":["xls","xlm","xla","xlc","xlt","xlw"]},"application/vnd.ms-excel.addin.macroenabled.12":{"source":"iana","extensions":["xlam"]},"application/vnd.ms-excel.sheet.binary.macroenabled.12":{"source":"iana","extensions":["xlsb"]},"application/vnd.ms-excel.sheet.macroenabled.12":{"source":"iana","extensions":["xlsm"]},"application/vnd.ms-excel.template.macroenabled.12":{"source":"iana","extensions":["xltm"]},"application/vnd.ms-fontobject":{"source":"iana","compressible":true,"extensions":["eot"]},"application/vnd.ms-htmlhelp":{"source":"iana","extensions":["chm"]},"application/vnd.ms-ims":{"source":"iana","extensions":["ims"]},"application/vnd.ms-lrm":{"source":"iana","extensions":["lrm"]},"application/vnd.ms-office.activex+xml":{"source":"iana","compressible":true},"application/vnd.ms-officetheme":{"source":"iana","extensions":["thmx"]},"application/vnd.ms-opentype":{"source":"apache","compressible":true},"application/vnd.ms-outlook":{"compressible":false,"extensions":["msg"]},"application/vnd.ms-package.obfuscated-opentype":{"source":"apache"},"application/vnd.ms-pki.seccat":{"source":"apache","extensions":["cat"]},"application/vnd.ms-pki.stl":{"source":"apache","extensions":["stl"]},"application/vnd.ms-playready.initiator+xml":{"source":"iana","compressible":true},"application/vnd.ms-powerpoint":{"source":"iana","compressible":false,"extensions":["ppt","pps","pot"]},"application/vnd.ms-powerpoint.addin.macroenabled.12":{"source":"iana","extensions":["ppam"]},"application/vnd.ms-powerpoint.presentation.macroenabled.12":{"source":"iana","extensions":["pptm"]},"application/vnd.ms-powerpoint.slide.macroenabled.12":{"source":"iana","extensions":["sldm"]},"application/vnd.ms-powerpoint.slideshow.macroenabled.12":{"source":"iana","extensions":["ppsm"]},"application/vnd.ms-powerpoint.template.macroenabled.12":{"source":"iana","extensions":["potm"]},"application/vnd.ms-printdevicecapabilities+xml":{"source":"iana","compressible":true},"application/vnd.ms-printing.printticket+xml":{"source":"apache","compressible":true},"application/vnd.ms-printschematicket+xml":{"source":"iana","compressible":true},"application/vnd.ms-project":{"source":"iana","extensions":["mpp","mpt"]},"application/vnd.ms-tnef":{"source":"iana"},"application/vnd.ms-windows.devicepairing":{"source":"iana"},"application/vnd.ms-windows.nwprinting.oob":{"source":"iana"},"application/vnd.ms-windows.printerpairing":{"source":"iana"},"application/vnd.ms-windows.wsd.oob":{"source":"iana"},"application/vnd.ms-wmdrm.lic-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.lic-resp":{"source":"iana"},"application/vnd.ms-wmdrm.meter-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.meter-resp":{"source":"iana"},"application/vnd.ms-word.document.macroenabled.12":{"source":"iana","extensions":["docm"]},"application/vnd.ms-word.template.macroenabled.12":{"source":"iana","extensions":["dotm"]},"application/vnd.ms-works":{"source":"iana","extensions":["wps","wks","wcm","wdb"]},"application/vnd.ms-wpl":{"source":"iana","extensions":["wpl"]},"application/vnd.ms-xpsdocument":{"source":"iana","compressible":false,"extensions":["xps"]},"application/vnd.msa-disk-image":{"source":"iana"},"application/vnd.mseq":{"source":"iana","extensions":["mseq"]},"application/vnd.msign":{"source":"iana"},"application/vnd.multiad.creator":{"source":"iana"},"application/vnd.multiad.creator.cif":{"source":"iana"},"application/vnd.music-niff":{"source":"iana"},"application/vnd.musician":{"source":"iana","extensions":["mus"]},"application/vnd.muvee.style":{"source":"iana","extensions":["msty"]},"application/vnd.mynfc":{"source":"iana","extensions":["taglet"]},"application/vnd.nacamar.ybrid+json":{"source":"iana","compressible":true},"application/vnd.ncd.control":{"source":"iana"},"application/vnd.ncd.reference":{"source":"iana"},"application/vnd.nearst.inv+json":{"source":"iana","compressible":true},"application/vnd.nebumind.line":{"source":"iana"},"application/vnd.nervana":{"source":"iana"},"application/vnd.netfpx":{"source":"iana"},"application/vnd.neurolanguage.nlu":{"source":"iana","extensions":["nlu"]},"application/vnd.nimn":{"source":"iana"},"application/vnd.nintendo.nitro.rom":{"source":"iana"},"application/vnd.nintendo.snes.rom":{"source":"iana"},"application/vnd.nitf":{"source":"iana","extensions":["ntf","nitf"]},"application/vnd.noblenet-directory":{"source":"iana","extensions":["nnd"]},"application/vnd.noblenet-sealer":{"source":"iana","extensions":["nns"]},"application/vnd.noblenet-web":{"source":"iana","extensions":["nnw"]},"application/vnd.nokia.catalogs":{"source":"iana"},"application/vnd.nokia.conml+wbxml":{"source":"iana"},"application/vnd.nokia.conml+xml":{"source":"iana","compressible":true},"application/vnd.nokia.iptv.config+xml":{"source":"iana","compressible":true},"application/vnd.nokia.isds-radio-presets":{"source":"iana"},"application/vnd.nokia.landmark+wbxml":{"source":"iana"},"application/vnd.nokia.landmark+xml":{"source":"iana","compressible":true},"application/vnd.nokia.landmarkcollection+xml":{"source":"iana","compressible":true},"application/vnd.nokia.n-gage.ac+xml":{"source":"iana","compressible":true,"extensions":["ac"]},"application/vnd.nokia.n-gage.data":{"source":"iana","extensions":["ngdat"]},"application/vnd.nokia.n-gage.symbian.install":{"source":"iana","extensions":["n-gage"]},"application/vnd.nokia.ncd":{"source":"iana"},"application/vnd.nokia.pcd+wbxml":{"source":"iana"},"application/vnd.nokia.pcd+xml":{"source":"iana","compressible":true},"application/vnd.nokia.radio-preset":{"source":"iana","extensions":["rpst"]},"application/vnd.nokia.radio-presets":{"source":"iana","extensions":["rpss"]},"application/vnd.novadigm.edm":{"source":"iana","extensions":["edm"]},"application/vnd.novadigm.edx":{"source":"iana","extensions":["edx"]},"application/vnd.novadigm.ext":{"source":"iana","extensions":["ext"]},"application/vnd.ntt-local.content-share":{"source":"iana"},"application/vnd.ntt-local.file-transfer":{"source":"iana"},"application/vnd.ntt-local.ogw_remote-access":{"source":"iana"},"application/vnd.ntt-local.sip-ta_remote":{"source":"iana"},"application/vnd.ntt-local.sip-ta_tcp_stream":{"source":"iana"},"application/vnd.oasis.opendocument.chart":{"source":"iana","extensions":["odc"]},"application/vnd.oasis.opendocument.chart-template":{"source":"iana","extensions":["otc"]},"application/vnd.oasis.opendocument.database":{"source":"iana","extensions":["odb"]},"application/vnd.oasis.opendocument.formula":{"source":"iana","extensions":["odf"]},"application/vnd.oasis.opendocument.formula-template":{"source":"iana","extensions":["odft"]},"application/vnd.oasis.opendocument.graphics":{"source":"iana","compressible":false,"extensions":["odg"]},"application/vnd.oasis.opendocument.graphics-template":{"source":"iana","extensions":["otg"]},"application/vnd.oasis.opendocument.image":{"source":"iana","extensions":["odi"]},"application/vnd.oasis.opendocument.image-template":{"source":"iana","extensions":["oti"]},"application/vnd.oasis.opendocument.presentation":{"source":"iana","compressible":false,"extensions":["odp"]},"application/vnd.oasis.opendocument.presentation-template":{"source":"iana","extensions":["otp"]},"application/vnd.oasis.opendocument.spreadsheet":{"source":"iana","compressible":false,"extensions":["ods"]},"application/vnd.oasis.opendocument.spreadsheet-template":{"source":"iana","extensions":["ots"]},"application/vnd.oasis.opendocument.text":{"source":"iana","compressible":false,"extensions":["odt"]},"application/vnd.oasis.opendocument.text-master":{"source":"iana","extensions":["odm"]},"application/vnd.oasis.opendocument.text-template":{"source":"iana","extensions":["ott"]},"application/vnd.oasis.opendocument.text-web":{"source":"iana","extensions":["oth"]},"application/vnd.obn":{"source":"iana"},"application/vnd.ocf+cbor":{"source":"iana"},"application/vnd.oci.image.manifest.v1+json":{"source":"iana","compressible":true},"application/vnd.oftn.l10n+json":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessdownload+xml":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessstreaming+xml":{"source":"iana","compressible":true},"application/vnd.oipf.cspg-hexbinary":{"source":"iana"},"application/vnd.oipf.dae.svg+xml":{"source":"iana","compressible":true},"application/vnd.oipf.dae.xhtml+xml":{"source":"iana","compressible":true},"application/vnd.oipf.mippvcontrolmessage+xml":{"source":"iana","compressible":true},"application/vnd.oipf.pae.gem":{"source":"iana"},"application/vnd.oipf.spdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.oipf.spdlist+xml":{"source":"iana","compressible":true},"application/vnd.oipf.ueprofile+xml":{"source":"iana","compressible":true},"application/vnd.oipf.userprofile+xml":{"source":"iana","compressible":true},"application/vnd.olpc-sugar":{"source":"iana","extensions":["xo"]},"application/vnd.oma-scws-config":{"source":"iana"},"application/vnd.oma-scws-http-request":{"source":"iana"},"application/vnd.oma-scws-http-response":{"source":"iana"},"application/vnd.oma.bcast.associated-procedure-parameter+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.drm-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.imd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.ltkm":{"source":"iana"},"application/vnd.oma.bcast.notification+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.provisioningtrigger":{"source":"iana"},"application/vnd.oma.bcast.sgboot":{"source":"iana"},"application/vnd.oma.bcast.sgdd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sgdu":{"source":"iana"},"application/vnd.oma.bcast.simple-symbol-container":{"source":"iana"},"application/vnd.oma.bcast.smartcard-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sprov+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.stkm":{"source":"iana"},"application/vnd.oma.cab-address-book+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-feature-handler+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-pcc+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-subs-invite+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-user-prefs+xml":{"source":"iana","compressible":true},"application/vnd.oma.dcd":{"source":"iana"},"application/vnd.oma.dcdc":{"source":"iana"},"application/vnd.oma.dd2+xml":{"source":"iana","compressible":true,"extensions":["dd2"]},"application/vnd.oma.drm.risd+xml":{"source":"iana","compressible":true},"application/vnd.oma.group-usage-list+xml":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+cbor":{"source":"iana"},"application/vnd.oma.lwm2m+json":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+tlv":{"source":"iana"},"application/vnd.oma.pal+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.detailed-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.final-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.groups+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.invocation-descriptor+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.optimized-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.push":{"source":"iana"},"application/vnd.oma.scidm.messages+xml":{"source":"iana","compressible":true},"application/vnd.oma.xcap-directory+xml":{"source":"iana","compressible":true},"application/vnd.omads-email+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omads-file+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omads-folder+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omaloc-supl-init":{"source":"iana"},"application/vnd.onepager":{"source":"iana"},"application/vnd.onepagertamp":{"source":"iana"},"application/vnd.onepagertamx":{"source":"iana"},"application/vnd.onepagertat":{"source":"iana"},"application/vnd.onepagertatp":{"source":"iana"},"application/vnd.onepagertatx":{"source":"iana"},"application/vnd.openblox.game+xml":{"source":"iana","compressible":true,"extensions":["obgx"]},"application/vnd.openblox.game-binary":{"source":"iana"},"application/vnd.openeye.oeb":{"source":"iana"},"application/vnd.openofficeorg.extension":{"source":"apache","extensions":["oxt"]},"application/vnd.openstreetmap.data+xml":{"source":"iana","compressible":true,"extensions":["osm"]},"application/vnd.opentimestamps.ots":{"source":"iana"},"application/vnd.openxmlformats-officedocument.custom-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.customxmlproperties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawing+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chart+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.extended-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presentation":{"source":"iana","compressible":false,"extensions":["pptx"]},"application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slide":{"source":"iana","extensions":["sldx"]},"application/vnd.openxmlformats-officedocument.presentationml.slide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideshow":{"source":"iana","extensions":["ppsx"]},"application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tags+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.template":{"source":"iana","extensions":["potx"]},"application/vnd.openxmlformats-officedocument.presentationml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":{"source":"iana","compressible":false,"extensions":["xlsx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.template":{"source":"iana","extensions":["xltx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.theme+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.themeoverride+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.vmldrawing":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document":{"source":"iana","compressible":false,"extensions":["docx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.template":{"source":"iana","extensions":["dotx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.core-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.relationships+xml":{"source":"iana","compressible":true},"application/vnd.oracle.resource+json":{"source":"iana","compressible":true},"application/vnd.orange.indata":{"source":"iana"},"application/vnd.osa.netdeploy":{"source":"iana"},"application/vnd.osgeo.mapguide.package":{"source":"iana","extensions":["mgp"]},"application/vnd.osgi.bundle":{"source":"iana"},"application/vnd.osgi.dp":{"source":"iana","extensions":["dp"]},"application/vnd.osgi.subsystem":{"source":"iana","extensions":["esa"]},"application/vnd.otps.ct-kip+xml":{"source":"iana","compressible":true},"application/vnd.oxli.countgraph":{"source":"iana"},"application/vnd.pagerduty+json":{"source":"iana","compressible":true},"application/vnd.palm":{"source":"iana","extensions":["pdb","pqa","oprc"]},"application/vnd.panoply":{"source":"iana"},"application/vnd.paos.xml":{"source":"iana"},"application/vnd.patentdive":{"source":"iana"},"application/vnd.patientecommsdoc":{"source":"iana"},"application/vnd.pawaafile":{"source":"iana","extensions":["paw"]},"application/vnd.pcos":{"source":"iana"},"application/vnd.pg.format":{"source":"iana","extensions":["str"]},"application/vnd.pg.osasli":{"source":"iana","extensions":["ei6"]},"application/vnd.piaccess.application-licence":{"source":"iana"},"application/vnd.picsel":{"source":"iana","extensions":["efif"]},"application/vnd.pmi.widget":{"source":"iana","extensions":["wg"]},"application/vnd.poc.group-advertisement+xml":{"source":"iana","compressible":true},"application/vnd.pocketlearn":{"source":"iana","extensions":["plf"]},"application/vnd.powerbuilder6":{"source":"iana","extensions":["pbd"]},"application/vnd.powerbuilder6-s":{"source":"iana"},"application/vnd.powerbuilder7":{"source":"iana"},"application/vnd.powerbuilder7-s":{"source":"iana"},"application/vnd.powerbuilder75":{"source":"iana"},"application/vnd.powerbuilder75-s":{"source":"iana"},"application/vnd.preminet":{"source":"iana"},"application/vnd.previewsystems.box":{"source":"iana","extensions":["box"]},"application/vnd.proteus.magazine":{"source":"iana","extensions":["mgz"]},"application/vnd.psfs":{"source":"iana"},"application/vnd.publishare-delta-tree":{"source":"iana","extensions":["qps"]},"application/vnd.pvi.ptid1":{"source":"iana","extensions":["ptid"]},"application/vnd.pwg-multiplexed":{"source":"iana"},"application/vnd.pwg-xhtml-print+xml":{"source":"iana","compressible":true},"application/vnd.qualcomm.brew-app-res":{"source":"iana"},"application/vnd.quarantainenet":{"source":"iana"},"application/vnd.quark.quarkxpress":{"source":"iana","extensions":["qxd","qxt","qwd","qwt","qxl","qxb"]},"application/vnd.quobject-quoxdocument":{"source":"iana"},"application/vnd.radisys.moml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conn+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-stream+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-base+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-detect+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-sendrecv+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-group+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-speech+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-transform+xml":{"source":"iana","compressible":true},"application/vnd.rainstor.data":{"source":"iana"},"application/vnd.rapid":{"source":"iana"},"application/vnd.rar":{"source":"iana","extensions":["rar"]},"application/vnd.realvnc.bed":{"source":"iana","extensions":["bed"]},"application/vnd.recordare.musicxml":{"source":"iana","extensions":["mxl"]},"application/vnd.recordare.musicxml+xml":{"source":"iana","compressible":true,"extensions":["musicxml"]},"application/vnd.renlearn.rlprint":{"source":"iana"},"application/vnd.resilient.logic":{"source":"iana"},"application/vnd.restful+json":{"source":"iana","compressible":true},"application/vnd.rig.cryptonote":{"source":"iana","extensions":["cryptonote"]},"application/vnd.rim.cod":{"source":"apache","extensions":["cod"]},"application/vnd.rn-realmedia":{"source":"apache","extensions":["rm"]},"application/vnd.rn-realmedia-vbr":{"source":"apache","extensions":["rmvb"]},"application/vnd.route66.link66+xml":{"source":"iana","compressible":true,"extensions":["link66"]},"application/vnd.rs-274x":{"source":"iana"},"application/vnd.ruckus.download":{"source":"iana"},"application/vnd.s3sms":{"source":"iana"},"application/vnd.sailingtracker.track":{"source":"iana","extensions":["st"]},"application/vnd.sar":{"source":"iana"},"application/vnd.sbm.cid":{"source":"iana"},"application/vnd.sbm.mid2":{"source":"iana"},"application/vnd.scribus":{"source":"iana"},"application/vnd.sealed.3df":{"source":"iana"},"application/vnd.sealed.csf":{"source":"iana"},"application/vnd.sealed.doc":{"source":"iana"},"application/vnd.sealed.eml":{"source":"iana"},"application/vnd.sealed.mht":{"source":"iana"},"application/vnd.sealed.net":{"source":"iana"},"application/vnd.sealed.ppt":{"source":"iana"},"application/vnd.sealed.tiff":{"source":"iana"},"application/vnd.sealed.xls":{"source":"iana"},"application/vnd.sealedmedia.softseal.html":{"source":"iana"},"application/vnd.sealedmedia.softseal.pdf":{"source":"iana"},"application/vnd.seemail":{"source":"iana","extensions":["see"]},"application/vnd.seis+json":{"source":"iana","compressible":true},"application/vnd.sema":{"source":"iana","extensions":["sema"]},"application/vnd.semd":{"source":"iana","extensions":["semd"]},"application/vnd.semf":{"source":"iana","extensions":["semf"]},"application/vnd.shade-save-file":{"source":"iana"},"application/vnd.shana.informed.formdata":{"source":"iana","extensions":["ifm"]},"application/vnd.shana.informed.formtemplate":{"source":"iana","extensions":["itp"]},"application/vnd.shana.informed.interchange":{"source":"iana","extensions":["iif"]},"application/vnd.shana.informed.package":{"source":"iana","extensions":["ipk"]},"application/vnd.shootproof+json":{"source":"iana","compressible":true},"application/vnd.shopkick+json":{"source":"iana","compressible":true},"application/vnd.shp":{"source":"iana"},"application/vnd.shx":{"source":"iana"},"application/vnd.sigrok.session":{"source":"iana"},"application/vnd.simtech-mindmapper":{"source":"iana","extensions":["twd","twds"]},"application/vnd.siren+json":{"source":"iana","compressible":true},"application/vnd.smaf":{"source":"iana","extensions":["mmf"]},"application/vnd.smart.notebook":{"source":"iana"},"application/vnd.smart.teacher":{"source":"iana","extensions":["teacher"]},"application/vnd.snesdev-page-table":{"source":"iana"},"application/vnd.software602.filler.form+xml":{"source":"iana","compressible":true,"extensions":["fo"]},"application/vnd.software602.filler.form-xml-zip":{"source":"iana"},"application/vnd.solent.sdkm+xml":{"source":"iana","compressible":true,"extensions":["sdkm","sdkd"]},"application/vnd.spotfire.dxp":{"source":"iana","extensions":["dxp"]},"application/vnd.spotfire.sfs":{"source":"iana","extensions":["sfs"]},"application/vnd.sqlite3":{"source":"iana"},"application/vnd.sss-cod":{"source":"iana"},"application/vnd.sss-dtf":{"source":"iana"},"application/vnd.sss-ntf":{"source":"iana"},"application/vnd.stardivision.calc":{"source":"apache","extensions":["sdc"]},"application/vnd.stardivision.draw":{"source":"apache","extensions":["sda"]},"application/vnd.stardivision.impress":{"source":"apache","extensions":["sdd"]},"application/vnd.stardivision.math":{"source":"apache","extensions":["smf"]},"application/vnd.stardivision.writer":{"source":"apache","extensions":["sdw","vor"]},"application/vnd.stardivision.writer-global":{"source":"apache","extensions":["sgl"]},"application/vnd.stepmania.package":{"source":"iana","extensions":["smzip"]},"application/vnd.stepmania.stepchart":{"source":"iana","extensions":["sm"]},"application/vnd.street-stream":{"source":"iana"},"application/vnd.sun.wadl+xml":{"source":"iana","compressible":true,"extensions":["wadl"]},"application/vnd.sun.xml.calc":{"source":"apache","extensions":["sxc"]},"application/vnd.sun.xml.calc.template":{"source":"apache","extensions":["stc"]},"application/vnd.sun.xml.draw":{"source":"apache","extensions":["sxd"]},"application/vnd.sun.xml.draw.template":{"source":"apache","extensions":["std"]},"application/vnd.sun.xml.impress":{"source":"apache","extensions":["sxi"]},"application/vnd.sun.xml.impress.template":{"source":"apache","extensions":["sti"]},"application/vnd.sun.xml.math":{"source":"apache","extensions":["sxm"]},"application/vnd.sun.xml.writer":{"source":"apache","extensions":["sxw"]},"application/vnd.sun.xml.writer.global":{"source":"apache","extensions":["sxg"]},"application/vnd.sun.xml.writer.template":{"source":"apache","extensions":["stw"]},"application/vnd.sus-calendar":{"source":"iana","extensions":["sus","susp"]},"application/vnd.svd":{"source":"iana","extensions":["svd"]},"application/vnd.swiftview-ics":{"source":"iana"},"application/vnd.sycle+xml":{"source":"iana","compressible":true},"application/vnd.syft+json":{"source":"iana","compressible":true},"application/vnd.symbian.install":{"source":"apache","extensions":["sis","sisx"]},"application/vnd.syncml+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["xsm"]},"application/vnd.syncml.dm+wbxml":{"source":"iana","charset":"UTF-8","extensions":["bdm"]},"application/vnd.syncml.dm+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["xdm"]},"application/vnd.syncml.dm.notification":{"source":"iana"},"application/vnd.syncml.dmddf+wbxml":{"source":"iana"},"application/vnd.syncml.dmddf+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["ddf"]},"application/vnd.syncml.dmtnds+wbxml":{"source":"iana"},"application/vnd.syncml.dmtnds+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.syncml.ds.notification":{"source":"iana"},"application/vnd.tableschema+json":{"source":"iana","compressible":true},"application/vnd.tao.intent-module-archive":{"source":"iana","extensions":["tao"]},"application/vnd.tcpdump.pcap":{"source":"iana","extensions":["pcap","cap","dmp"]},"application/vnd.think-cell.ppttc+json":{"source":"iana","compressible":true},"application/vnd.tmd.mediaflex.api+xml":{"source":"iana","compressible":true},"application/vnd.tml":{"source":"iana"},"application/vnd.tmobile-livetv":{"source":"iana","extensions":["tmo"]},"application/vnd.tri.onesource":{"source":"iana"},"application/vnd.trid.tpt":{"source":"iana","extensions":["tpt"]},"application/vnd.triscape.mxs":{"source":"iana","extensions":["mxs"]},"application/vnd.trueapp":{"source":"iana","extensions":["tra"]},"application/vnd.truedoc":{"source":"iana"},"application/vnd.ubisoft.webplayer":{"source":"iana"},"application/vnd.ufdl":{"source":"iana","extensions":["ufd","ufdl"]},"application/vnd.uiq.theme":{"source":"iana","extensions":["utz"]},"application/vnd.umajin":{"source":"iana","extensions":["umj"]},"application/vnd.unity":{"source":"iana","extensions":["unityweb"]},"application/vnd.uoml+xml":{"source":"iana","compressible":true,"extensions":["uoml"]},"application/vnd.uplanet.alert":{"source":"iana"},"application/vnd.uplanet.alert-wbxml":{"source":"iana"},"application/vnd.uplanet.bearer-choice":{"source":"iana"},"application/vnd.uplanet.bearer-choice-wbxml":{"source":"iana"},"application/vnd.uplanet.cacheop":{"source":"iana"},"application/vnd.uplanet.cacheop-wbxml":{"source":"iana"},"application/vnd.uplanet.channel":{"source":"iana"},"application/vnd.uplanet.channel-wbxml":{"source":"iana"},"application/vnd.uplanet.list":{"source":"iana"},"application/vnd.uplanet.list-wbxml":{"source":"iana"},"application/vnd.uplanet.listcmd":{"source":"iana"},"application/vnd.uplanet.listcmd-wbxml":{"source":"iana"},"application/vnd.uplanet.signal":{"source":"iana"},"application/vnd.uri-map":{"source":"iana"},"application/vnd.valve.source.material":{"source":"iana"},"application/vnd.vcx":{"source":"iana","extensions":["vcx"]},"application/vnd.vd-study":{"source":"iana"},"application/vnd.vectorworks":{"source":"iana"},"application/vnd.vel+json":{"source":"iana","compressible":true},"application/vnd.verimatrix.vcas":{"source":"iana"},"application/vnd.veritone.aion+json":{"source":"iana","compressible":true},"application/vnd.veryant.thin":{"source":"iana"},"application/vnd.ves.encrypted":{"source":"iana"},"application/vnd.vidsoft.vidconference":{"source":"iana"},"application/vnd.visio":{"source":"iana","extensions":["vsd","vst","vss","vsw"]},"application/vnd.visionary":{"source":"iana","extensions":["vis"]},"application/vnd.vividence.scriptfile":{"source":"iana"},"application/vnd.vsf":{"source":"iana","extensions":["vsf"]},"application/vnd.wap.sic":{"source":"iana"},"application/vnd.wap.slc":{"source":"iana"},"application/vnd.wap.wbxml":{"source":"iana","charset":"UTF-8","extensions":["wbxml"]},"application/vnd.wap.wmlc":{"source":"iana","extensions":["wmlc"]},"application/vnd.wap.wmlscriptc":{"source":"iana","extensions":["wmlsc"]},"application/vnd.webturbo":{"source":"iana","extensions":["wtb"]},"application/vnd.wfa.dpp":{"source":"iana"},"application/vnd.wfa.p2p":{"source":"iana"},"application/vnd.wfa.wsc":{"source":"iana"},"application/vnd.windows.devicepairing":{"source":"iana"},"application/vnd.wmc":{"source":"iana"},"application/vnd.wmf.bootstrap":{"source":"iana"},"application/vnd.wolfram.mathematica":{"source":"iana"},"application/vnd.wolfram.mathematica.package":{"source":"iana"},"application/vnd.wolfram.player":{"source":"iana","extensions":["nbp"]},"application/vnd.wordperfect":{"source":"iana","extensions":["wpd"]},"application/vnd.wqd":{"source":"iana","extensions":["wqd"]},"application/vnd.wrq-hp3000-labelled":{"source":"iana"},"application/vnd.wt.stf":{"source":"iana","extensions":["stf"]},"application/vnd.wv.csp+wbxml":{"source":"iana"},"application/vnd.wv.csp+xml":{"source":"iana","compressible":true},"application/vnd.wv.ssp+xml":{"source":"iana","compressible":true},"application/vnd.xacml+json":{"source":"iana","compressible":true},"application/vnd.xara":{"source":"iana","extensions":["xar"]},"application/vnd.xfdl":{"source":"iana","extensions":["xfdl"]},"application/vnd.xfdl.webform":{"source":"iana"},"application/vnd.xmi+xml":{"source":"iana","compressible":true},"application/vnd.xmpie.cpkg":{"source":"iana"},"application/vnd.xmpie.dpkg":{"source":"iana"},"application/vnd.xmpie.plan":{"source":"iana"},"application/vnd.xmpie.ppkg":{"source":"iana"},"application/vnd.xmpie.xlim":{"source":"iana"},"application/vnd.yamaha.hv-dic":{"source":"iana","extensions":["hvd"]},"application/vnd.yamaha.hv-script":{"source":"iana","extensions":["hvs"]},"application/vnd.yamaha.hv-voice":{"source":"iana","extensions":["hvp"]},"application/vnd.yamaha.openscoreformat":{"source":"iana","extensions":["osf"]},"application/vnd.yamaha.openscoreformat.osfpvg+xml":{"source":"iana","compressible":true,"extensions":["osfpvg"]},"application/vnd.yamaha.remote-setup":{"source":"iana"},"application/vnd.yamaha.smaf-audio":{"source":"iana","extensions":["saf"]},"application/vnd.yamaha.smaf-phrase":{"source":"iana","extensions":["spf"]},"application/vnd.yamaha.through-ngn":{"source":"iana"},"application/vnd.yamaha.tunnel-udpencap":{"source":"iana"},"application/vnd.yaoweme":{"source":"iana"},"application/vnd.yellowriver-custom-menu":{"source":"iana","extensions":["cmp"]},"application/vnd.youtube.yt":{"source":"iana"},"application/vnd.zul":{"source":"iana","extensions":["zir","zirz"]},"application/vnd.zzazz.deck+xml":{"source":"iana","compressible":true,"extensions":["zaz"]},"application/voicexml+xml":{"source":"iana","compressible":true,"extensions":["vxml"]},"application/voucher-cms+json":{"source":"iana","compressible":true},"application/vq-rtcpxr":{"source":"iana"},"application/wasm":{"source":"iana","compressible":true,"extensions":["wasm"]},"application/watcherinfo+xml":{"source":"iana","compressible":true,"extensions":["wif"]},"application/webpush-options+json":{"source":"iana","compressible":true},"application/whoispp-query":{"source":"iana"},"application/whoispp-response":{"source":"iana"},"application/widget":{"source":"iana","extensions":["wgt"]},"application/winhlp":{"source":"apache","extensions":["hlp"]},"application/wita":{"source":"iana"},"application/wordperfect5.1":{"source":"iana"},"application/wsdl+xml":{"source":"iana","compressible":true,"extensions":["wsdl"]},"application/wspolicy+xml":{"source":"iana","compressible":true,"extensions":["wspolicy"]},"application/x-7z-compressed":{"source":"apache","compressible":false,"extensions":["7z"]},"application/x-abiword":{"source":"apache","extensions":["abw"]},"application/x-ace-compressed":{"source":"apache","extensions":["ace"]},"application/x-amf":{"source":"apache"},"application/x-apple-diskimage":{"source":"apache","extensions":["dmg"]},"application/x-arj":{"compressible":false,"extensions":["arj"]},"application/x-authorware-bin":{"source":"apache","extensions":["aab","x32","u32","vox"]},"application/x-authorware-map":{"source":"apache","extensions":["aam"]},"application/x-authorware-seg":{"source":"apache","extensions":["aas"]},"application/x-bcpio":{"source":"apache","extensions":["bcpio"]},"application/x-bdoc":{"compressible":false,"extensions":["bdoc"]},"application/x-bittorrent":{"source":"apache","extensions":["torrent"]},"application/x-blorb":{"source":"apache","extensions":["blb","blorb"]},"application/x-bzip":{"source":"apache","compressible":false,"extensions":["bz"]},"application/x-bzip2":{"source":"apache","compressible":false,"extensions":["bz2","boz"]},"application/x-cbr":{"source":"apache","extensions":["cbr","cba","cbt","cbz","cb7"]},"application/x-cdlink":{"source":"apache","extensions":["vcd"]},"application/x-cfs-compressed":{"source":"apache","extensions":["cfs"]},"application/x-chat":{"source":"apache","extensions":["chat"]},"application/x-chess-pgn":{"source":"apache","extensions":["pgn"]},"application/x-chrome-extension":{"extensions":["crx"]},"application/x-cocoa":{"source":"nginx","extensions":["cco"]},"application/x-compress":{"source":"apache"},"application/x-conference":{"source":"apache","extensions":["nsc"]},"application/x-cpio":{"source":"apache","extensions":["cpio"]},"application/x-csh":{"source":"apache","extensions":["csh"]},"application/x-deb":{"compressible":false},"application/x-debian-package":{"source":"apache","extensions":["deb","udeb"]},"application/x-dgc-compressed":{"source":"apache","extensions":["dgc"]},"application/x-director":{"source":"apache","extensions":["dir","dcr","dxr","cst","cct","cxt","w3d","fgd","swa"]},"application/x-doom":{"source":"apache","extensions":["wad"]},"application/x-dtbncx+xml":{"source":"apache","compressible":true,"extensions":["ncx"]},"application/x-dtbook+xml":{"source":"apache","compressible":true,"extensions":["dtb"]},"application/x-dtbresource+xml":{"source":"apache","compressible":true,"extensions":["res"]},"application/x-dvi":{"source":"apache","compressible":false,"extensions":["dvi"]},"application/x-envoy":{"source":"apache","extensions":["evy"]},"application/x-eva":{"source":"apache","extensions":["eva"]},"application/x-font-bdf":{"source":"apache","extensions":["bdf"]},"application/x-font-dos":{"source":"apache"},"application/x-font-framemaker":{"source":"apache"},"application/x-font-ghostscript":{"source":"apache","extensions":["gsf"]},"application/x-font-libgrx":{"source":"apache"},"application/x-font-linux-psf":{"source":"apache","extensions":["psf"]},"application/x-font-pcf":{"source":"apache","extensions":["pcf"]},"application/x-font-snf":{"source":"apache","extensions":["snf"]},"application/x-font-speedo":{"source":"apache"},"application/x-font-sunos-news":{"source":"apache"},"application/x-font-type1":{"source":"apache","extensions":["pfa","pfb","pfm","afm"]},"application/x-font-vfont":{"source":"apache"},"application/x-freearc":{"source":"apache","extensions":["arc"]},"application/x-futuresplash":{"source":"apache","extensions":["spl"]},"application/x-gca-compressed":{"source":"apache","extensions":["gca"]},"application/x-glulx":{"source":"apache","extensions":["ulx"]},"application/x-gnumeric":{"source":"apache","extensions":["gnumeric"]},"application/x-gramps-xml":{"source":"apache","extensions":["gramps"]},"application/x-gtar":{"source":"apache","extensions":["gtar"]},"application/x-gzip":{"source":"apache"},"application/x-hdf":{"source":"apache","extensions":["hdf"]},"application/x-httpd-php":{"compressible":true,"extensions":["php"]},"application/x-install-instructions":{"source":"apache","extensions":["install"]},"application/x-iso9660-image":{"source":"apache","extensions":["iso"]},"application/x-iwork-keynote-sffkey":{"extensions":["key"]},"application/x-iwork-numbers-sffnumbers":{"extensions":["numbers"]},"application/x-iwork-pages-sffpages":{"extensions":["pages"]},"application/x-java-archive-diff":{"source":"nginx","extensions":["jardiff"]},"application/x-java-jnlp-file":{"source":"apache","compressible":false,"extensions":["jnlp"]},"application/x-javascript":{"compressible":true},"application/x-keepass2":{"extensions":["kdbx"]},"application/x-latex":{"source":"apache","compressible":false,"extensions":["latex"]},"application/x-lua-bytecode":{"extensions":["luac"]},"application/x-lzh-compressed":{"source":"apache","extensions":["lzh","lha"]},"application/x-makeself":{"source":"nginx","extensions":["run"]},"application/x-mie":{"source":"apache","extensions":["mie"]},"application/x-mobipocket-ebook":{"source":"apache","extensions":["prc","mobi"]},"application/x-mpegurl":{"compressible":false},"application/x-ms-application":{"source":"apache","extensions":["application"]},"application/x-ms-shortcut":{"source":"apache","extensions":["lnk"]},"application/x-ms-wmd":{"source":"apache","extensions":["wmd"]},"application/x-ms-wmz":{"source":"apache","extensions":["wmz"]},"application/x-ms-xbap":{"source":"apache","extensions":["xbap"]},"application/x-msaccess":{"source":"apache","extensions":["mdb"]},"application/x-msbinder":{"source":"apache","extensions":["obd"]},"application/x-mscardfile":{"source":"apache","extensions":["crd"]},"application/x-msclip":{"source":"apache","extensions":["clp"]},"application/x-msdos-program":{"extensions":["exe"]},"application/x-msdownload":{"source":"apache","extensions":["exe","dll","com","bat","msi"]},"application/x-msmediaview":{"source":"apache","extensions":["mvb","m13","m14"]},"application/x-msmetafile":{"source":"apache","extensions":["wmf","wmz","emf","emz"]},"application/x-msmoney":{"source":"apache","extensions":["mny"]},"application/x-mspublisher":{"source":"apache","extensions":["pub"]},"application/x-msschedule":{"source":"apache","extensions":["scd"]},"application/x-msterminal":{"source":"apache","extensions":["trm"]},"application/x-mswrite":{"source":"apache","extensions":["wri"]},"application/x-netcdf":{"source":"apache","extensions":["nc","cdf"]},"application/x-ns-proxy-autoconfig":{"compressible":true,"extensions":["pac"]},"application/x-nzb":{"source":"apache","extensions":["nzb"]},"application/x-perl":{"source":"nginx","extensions":["pl","pm"]},"application/x-pilot":{"source":"nginx","extensions":["prc","pdb"]},"application/x-pkcs12":{"source":"apache","compressible":false,"extensions":["p12","pfx"]},"application/x-pkcs7-certificates":{"source":"apache","extensions":["p7b","spc"]},"application/x-pkcs7-certreqresp":{"source":"apache","extensions":["p7r"]},"application/x-pki-message":{"source":"iana"},"application/x-rar-compressed":{"source":"apache","compressible":false,"extensions":["rar"]},"application/x-redhat-package-manager":{"source":"nginx","extensions":["rpm"]},"application/x-research-info-systems":{"source":"apache","extensions":["ris"]},"application/x-sea":{"source":"nginx","extensions":["sea"]},"application/x-sh":{"source":"apache","compressible":true,"extensions":["sh"]},"application/x-shar":{"source":"apache","extensions":["shar"]},"application/x-shockwave-flash":{"source":"apache","compressible":false,"extensions":["swf"]},"application/x-silverlight-app":{"source":"apache","extensions":["xap"]},"application/x-sql":{"source":"apache","extensions":["sql"]},"application/x-stuffit":{"source":"apache","compressible":false,"extensions":["sit"]},"application/x-stuffitx":{"source":"apache","extensions":["sitx"]},"application/x-subrip":{"source":"apache","extensions":["srt"]},"application/x-sv4cpio":{"source":"apache","extensions":["sv4cpio"]},"application/x-sv4crc":{"source":"apache","extensions":["sv4crc"]},"application/x-t3vm-image":{"source":"apache","extensions":["t3"]},"application/x-tads":{"source":"apache","extensions":["gam"]},"application/x-tar":{"source":"apache","compressible":true,"extensions":["tar"]},"application/x-tcl":{"source":"apache","extensions":["tcl","tk"]},"application/x-tex":{"source":"apache","extensions":["tex"]},"application/x-tex-tfm":{"source":"apache","extensions":["tfm"]},"application/x-texinfo":{"source":"apache","extensions":["texinfo","texi"]},"application/x-tgif":{"source":"apache","extensions":["obj"]},"application/x-ustar":{"source":"apache","extensions":["ustar"]},"application/x-virtualbox-hdd":{"compressible":true,"extensions":["hdd"]},"application/x-virtualbox-ova":{"compressible":true,"extensions":["ova"]},"application/x-virtualbox-ovf":{"compressible":true,"extensions":["ovf"]},"application/x-virtualbox-vbox":{"compressible":true,"extensions":["vbox"]},"application/x-virtualbox-vbox-extpack":{"compressible":false,"extensions":["vbox-extpack"]},"application/x-virtualbox-vdi":{"compressible":true,"extensions":["vdi"]},"application/x-virtualbox-vhd":{"compressible":true,"extensions":["vhd"]},"application/x-virtualbox-vmdk":{"compressible":true,"extensions":["vmdk"]},"application/x-wais-source":{"source":"apache","extensions":["src"]},"application/x-web-app-manifest+json":{"compressible":true,"extensions":["webapp"]},"application/x-www-form-urlencoded":{"source":"iana","compressible":true},"application/x-x509-ca-cert":{"source":"iana","extensions":["der","crt","pem"]},"application/x-x509-ca-ra-cert":{"source":"iana"},"application/x-x509-next-ca-cert":{"source":"iana"},"application/x-xfig":{"source":"apache","extensions":["fig"]},"application/x-xliff+xml":{"source":"apache","compressible":true,"extensions":["xlf"]},"application/x-xpinstall":{"source":"apache","compressible":false,"extensions":["xpi"]},"application/x-xz":{"source":"apache","extensions":["xz"]},"application/x-zmachine":{"source":"apache","extensions":["z1","z2","z3","z4","z5","z6","z7","z8"]},"application/x400-bp":{"source":"iana"},"application/xacml+xml":{"source":"iana","compressible":true},"application/xaml+xml":{"source":"apache","compressible":true,"extensions":["xaml"]},"application/xcap-att+xml":{"source":"iana","compressible":true,"extensions":["xav"]},"application/xcap-caps+xml":{"source":"iana","compressible":true,"extensions":["xca"]},"application/xcap-diff+xml":{"source":"iana","compressible":true,"extensions":["xdf"]},"application/xcap-el+xml":{"source":"iana","compressible":true,"extensions":["xel"]},"application/xcap-error+xml":{"source":"iana","compressible":true},"application/xcap-ns+xml":{"source":"iana","compressible":true,"extensions":["xns"]},"application/xcon-conference-info+xml":{"source":"iana","compressible":true},"application/xcon-conference-info-diff+xml":{"source":"iana","compressible":true},"application/xenc+xml":{"source":"iana","compressible":true,"extensions":["xenc"]},"application/xhtml+xml":{"source":"iana","compressible":true,"extensions":["xhtml","xht"]},"application/xhtml-voice+xml":{"source":"apache","compressible":true},"application/xliff+xml":{"source":"iana","compressible":true,"extensions":["xlf"]},"application/xml":{"source":"iana","compressible":true,"extensions":["xml","xsl","xsd","rng"]},"application/xml-dtd":{"source":"iana","compressible":true,"extensions":["dtd"]},"application/xml-external-parsed-entity":{"source":"iana"},"application/xml-patch+xml":{"source":"iana","compressible":true},"application/xmpp+xml":{"source":"iana","compressible":true},"application/xop+xml":{"source":"iana","compressible":true,"extensions":["xop"]},"application/xproc+xml":{"source":"apache","compressible":true,"extensions":["xpl"]},"application/xslt+xml":{"source":"iana","compressible":true,"extensions":["xsl","xslt"]},"application/xspf+xml":{"source":"apache","compressible":true,"extensions":["xspf"]},"application/xv+xml":{"source":"iana","compressible":true,"extensions":["mxml","xhvml","xvml","xvm"]},"application/yang":{"source":"iana","extensions":["yang"]},"application/yang-data+json":{"source":"iana","compressible":true},"application/yang-data+xml":{"source":"iana","compressible":true},"application/yang-patch+json":{"source":"iana","compressible":true},"application/yang-patch+xml":{"source":"iana","compressible":true},"application/yin+xml":{"source":"iana","compressible":true,"extensions":["yin"]},"application/zip":{"source":"iana","compressible":false,"extensions":["zip"]},"application/zlib":{"source":"iana"},"application/zstd":{"source":"iana"},"audio/1d-interleaved-parityfec":{"source":"iana"},"audio/32kadpcm":{"source":"iana"},"audio/3gpp":{"source":"iana","compressible":false,"extensions":["3gpp"]},"audio/3gpp2":{"source":"iana"},"audio/aac":{"source":"iana"},"audio/ac3":{"source":"iana"},"audio/adpcm":{"source":"apache","extensions":["adp"]},"audio/amr":{"source":"iana","extensions":["amr"]},"audio/amr-wb":{"source":"iana"},"audio/amr-wb+":{"source":"iana"},"audio/aptx":{"source":"iana"},"audio/asc":{"source":"iana"},"audio/atrac-advanced-lossless":{"source":"iana"},"audio/atrac-x":{"source":"iana"},"audio/atrac3":{"source":"iana"},"audio/basic":{"source":"iana","compressible":false,"extensions":["au","snd"]},"audio/bv16":{"source":"iana"},"audio/bv32":{"source":"iana"},"audio/clearmode":{"source":"iana"},"audio/cn":{"source":"iana"},"audio/dat12":{"source":"iana"},"audio/dls":{"source":"iana"},"audio/dsr-es201108":{"source":"iana"},"audio/dsr-es202050":{"source":"iana"},"audio/dsr-es202211":{"source":"iana"},"audio/dsr-es202212":{"source":"iana"},"audio/dv":{"source":"iana"},"audio/dvi4":{"source":"iana"},"audio/eac3":{"source":"iana"},"audio/encaprtp":{"source":"iana"},"audio/evrc":{"source":"iana"},"audio/evrc-qcp":{"source":"iana"},"audio/evrc0":{"source":"iana"},"audio/evrc1":{"source":"iana"},"audio/evrcb":{"source":"iana"},"audio/evrcb0":{"source":"iana"},"audio/evrcb1":{"source":"iana"},"audio/evrcnw":{"source":"iana"},"audio/evrcnw0":{"source":"iana"},"audio/evrcnw1":{"source":"iana"},"audio/evrcwb":{"source":"iana"},"audio/evrcwb0":{"source":"iana"},"audio/evrcwb1":{"source":"iana"},"audio/evs":{"source":"iana"},"audio/flexfec":{"source":"iana"},"audio/fwdred":{"source":"iana"},"audio/g711-0":{"source":"iana"},"audio/g719":{"source":"iana"},"audio/g722":{"source":"iana"},"audio/g7221":{"source":"iana"},"audio/g723":{"source":"iana"},"audio/g726-16":{"source":"iana"},"audio/g726-24":{"source":"iana"},"audio/g726-32":{"source":"iana"},"audio/g726-40":{"source":"iana"},"audio/g728":{"source":"iana"},"audio/g729":{"source":"iana"},"audio/g7291":{"source":"iana"},"audio/g729d":{"source":"iana"},"audio/g729e":{"source":"iana"},"audio/gsm":{"source":"iana"},"audio/gsm-efr":{"source":"iana"},"audio/gsm-hr-08":{"source":"iana"},"audio/ilbc":{"source":"iana"},"audio/ip-mr_v2.5":{"source":"iana"},"audio/isac":{"source":"apache"},"audio/l16":{"source":"iana"},"audio/l20":{"source":"iana"},"audio/l24":{"source":"iana","compressible":false},"audio/l8":{"source":"iana"},"audio/lpc":{"source":"iana"},"audio/melp":{"source":"iana"},"audio/melp1200":{"source":"iana"},"audio/melp2400":{"source":"iana"},"audio/melp600":{"source":"iana"},"audio/mhas":{"source":"iana"},"audio/midi":{"source":"apache","extensions":["mid","midi","kar","rmi"]},"audio/mobile-xmf":{"source":"iana","extensions":["mxmf"]},"audio/mp3":{"compressible":false,"extensions":["mp3"]},"audio/mp4":{"source":"iana","compressible":false,"extensions":["m4a","mp4a"]},"audio/mp4a-latm":{"source":"iana"},"audio/mpa":{"source":"iana"},"audio/mpa-robust":{"source":"iana"},"audio/mpeg":{"source":"iana","compressible":false,"extensions":["mpga","mp2","mp2a","mp3","m2a","m3a"]},"audio/mpeg4-generic":{"source":"iana"},"audio/musepack":{"source":"apache"},"audio/ogg":{"source":"iana","compressible":false,"extensions":["oga","ogg","spx","opus"]},"audio/opus":{"source":"iana"},"audio/parityfec":{"source":"iana"},"audio/pcma":{"source":"iana"},"audio/pcma-wb":{"source":"iana"},"audio/pcmu":{"source":"iana"},"audio/pcmu-wb":{"source":"iana"},"audio/prs.sid":{"source":"iana"},"audio/qcelp":{"source":"iana"},"audio/raptorfec":{"source":"iana"},"audio/red":{"source":"iana"},"audio/rtp-enc-aescm128":{"source":"iana"},"audio/rtp-midi":{"source":"iana"},"audio/rtploopback":{"source":"iana"},"audio/rtx":{"source":"iana"},"audio/s3m":{"source":"apache","extensions":["s3m"]},"audio/scip":{"source":"iana"},"audio/silk":{"source":"apache","extensions":["sil"]},"audio/smv":{"source":"iana"},"audio/smv-qcp":{"source":"iana"},"audio/smv0":{"source":"iana"},"audio/sofa":{"source":"iana"},"audio/sp-midi":{"source":"iana"},"audio/speex":{"source":"iana"},"audio/t140c":{"source":"iana"},"audio/t38":{"source":"iana"},"audio/telephone-event":{"source":"iana"},"audio/tetra_acelp":{"source":"iana"},"audio/tetra_acelp_bb":{"source":"iana"},"audio/tone":{"source":"iana"},"audio/tsvcis":{"source":"iana"},"audio/uemclip":{"source":"iana"},"audio/ulpfec":{"source":"iana"},"audio/usac":{"source":"iana"},"audio/vdvi":{"source":"iana"},"audio/vmr-wb":{"source":"iana"},"audio/vnd.3gpp.iufp":{"source":"iana"},"audio/vnd.4sb":{"source":"iana"},"audio/vnd.audiokoz":{"source":"iana"},"audio/vnd.celp":{"source":"iana"},"audio/vnd.cisco.nse":{"source":"iana"},"audio/vnd.cmles.radio-events":{"source":"iana"},"audio/vnd.cns.anp1":{"source":"iana"},"audio/vnd.cns.inf1":{"source":"iana"},"audio/vnd.dece.audio":{"source":"iana","extensions":["uva","uvva"]},"audio/vnd.digital-winds":{"source":"iana","extensions":["eol"]},"audio/vnd.dlna.adts":{"source":"iana"},"audio/vnd.dolby.heaac.1":{"source":"iana"},"audio/vnd.dolby.heaac.2":{"source":"iana"},"audio/vnd.dolby.mlp":{"source":"iana"},"audio/vnd.dolby.mps":{"source":"iana"},"audio/vnd.dolby.pl2":{"source":"iana"},"audio/vnd.dolby.pl2x":{"source":"iana"},"audio/vnd.dolby.pl2z":{"source":"iana"},"audio/vnd.dolby.pulse.1":{"source":"iana"},"audio/vnd.dra":{"source":"iana","extensions":["dra"]},"audio/vnd.dts":{"source":"iana","extensions":["dts"]},"audio/vnd.dts.hd":{"source":"iana","extensions":["dtshd"]},"audio/vnd.dts.uhd":{"source":"iana"},"audio/vnd.dvb.file":{"source":"iana"},"audio/vnd.everad.plj":{"source":"iana"},"audio/vnd.hns.audio":{"source":"iana"},"audio/vnd.lucent.voice":{"source":"iana","extensions":["lvp"]},"audio/vnd.ms-playready.media.pya":{"source":"iana","extensions":["pya"]},"audio/vnd.nokia.mobile-xmf":{"source":"iana"},"audio/vnd.nortel.vbk":{"source":"iana"},"audio/vnd.nuera.ecelp4800":{"source":"iana","extensions":["ecelp4800"]},"audio/vnd.nuera.ecelp7470":{"source":"iana","extensions":["ecelp7470"]},"audio/vnd.nuera.ecelp9600":{"source":"iana","extensions":["ecelp9600"]},"audio/vnd.octel.sbc":{"source":"iana"},"audio/vnd.presonus.multitrack":{"source":"iana"},"audio/vnd.qcelp":{"source":"iana"},"audio/vnd.rhetorex.32kadpcm":{"source":"iana"},"audio/vnd.rip":{"source":"iana","extensions":["rip"]},"audio/vnd.rn-realaudio":{"compressible":false},"audio/vnd.sealedmedia.softseal.mpeg":{"source":"iana"},"audio/vnd.vmx.cvsd":{"source":"iana"},"audio/vnd.wave":{"compressible":false},"audio/vorbis":{"source":"iana","compressible":false},"audio/vorbis-config":{"source":"iana"},"audio/wav":{"compressible":false,"extensions":["wav"]},"audio/wave":{"compressible":false,"extensions":["wav"]},"audio/webm":{"source":"apache","compressible":false,"extensions":["weba"]},"audio/x-aac":{"source":"apache","compressible":false,"extensions":["aac"]},"audio/x-aiff":{"source":"apache","extensions":["aif","aiff","aifc"]},"audio/x-caf":{"source":"apache","compressible":false,"extensions":["caf"]},"audio/x-flac":{"source":"apache","extensions":["flac"]},"audio/x-m4a":{"source":"nginx","extensions":["m4a"]},"audio/x-matroska":{"source":"apache","extensions":["mka"]},"audio/x-mpegurl":{"source":"apache","extensions":["m3u"]},"audio/x-ms-wax":{"source":"apache","extensions":["wax"]},"audio/x-ms-wma":{"source":"apache","extensions":["wma"]},"audio/x-pn-realaudio":{"source":"apache","extensions":["ram","ra"]},"audio/x-pn-realaudio-plugin":{"source":"apache","extensions":["rmp"]},"audio/x-realaudio":{"source":"nginx","extensions":["ra"]},"audio/x-tta":{"source":"apache"},"audio/x-wav":{"source":"apache","extensions":["wav"]},"audio/xm":{"source":"apache","extensions":["xm"]},"chemical/x-cdx":{"source":"apache","extensions":["cdx"]},"chemical/x-cif":{"source":"apache","extensions":["cif"]},"chemical/x-cmdf":{"source":"apache","extensions":["cmdf"]},"chemical/x-cml":{"source":"apache","extensions":["cml"]},"chemical/x-csml":{"source":"apache","extensions":["csml"]},"chemical/x-pdb":{"source":"apache"},"chemical/x-xyz":{"source":"apache","extensions":["xyz"]},"font/collection":{"source":"iana","extensions":["ttc"]},"font/otf":{"source":"iana","compressible":true,"extensions":["otf"]},"font/sfnt":{"source":"iana"},"font/ttf":{"source":"iana","compressible":true,"extensions":["ttf"]},"font/woff":{"source":"iana","extensions":["woff"]},"font/woff2":{"source":"iana","extensions":["woff2"]},"image/aces":{"source":"iana","extensions":["exr"]},"image/apng":{"compressible":false,"extensions":["apng"]},"image/avci":{"source":"iana","extensions":["avci"]},"image/avcs":{"source":"iana","extensions":["avcs"]},"image/avif":{"source":"iana","compressible":false,"extensions":["avif"]},"image/bmp":{"source":"iana","compressible":true,"extensions":["bmp"]},"image/cgm":{"source":"iana","extensions":["cgm"]},"image/dicom-rle":{"source":"iana","extensions":["drle"]},"image/emf":{"source":"iana","extensions":["emf"]},"image/fits":{"source":"iana","extensions":["fits"]},"image/g3fax":{"source":"iana","extensions":["g3"]},"image/gif":{"source":"iana","compressible":false,"extensions":["gif"]},"image/heic":{"source":"iana","extensions":["heic"]},"image/heic-sequence":{"source":"iana","extensions":["heics"]},"image/heif":{"source":"iana","extensions":["heif"]},"image/heif-sequence":{"source":"iana","extensions":["heifs"]},"image/hej2k":{"source":"iana","extensions":["hej2"]},"image/hsj2":{"source":"iana","extensions":["hsj2"]},"image/ief":{"source":"iana","extensions":["ief"]},"image/jls":{"source":"iana","extensions":["jls"]},"image/jp2":{"source":"iana","compressible":false,"extensions":["jp2","jpg2"]},"image/jpeg":{"source":"iana","compressible":false,"extensions":["jpeg","jpg","jpe"]},"image/jph":{"source":"iana","extensions":["jph"]},"image/jphc":{"source":"iana","extensions":["jhc"]},"image/jpm":{"source":"iana","compressible":false,"extensions":["jpm"]},"image/jpx":{"source":"iana","compressible":false,"extensions":["jpx","jpf"]},"image/jxr":{"source":"iana","extensions":["jxr"]},"image/jxra":{"source":"iana","extensions":["jxra"]},"image/jxrs":{"source":"iana","extensions":["jxrs"]},"image/jxs":{"source":"iana","extensions":["jxs"]},"image/jxsc":{"source":"iana","extensions":["jxsc"]},"image/jxsi":{"source":"iana","extensions":["jxsi"]},"image/jxss":{"source":"iana","extensions":["jxss"]},"image/ktx":{"source":"iana","extensions":["ktx"]},"image/ktx2":{"source":"iana","extensions":["ktx2"]},"image/naplps":{"source":"iana"},"image/pjpeg":{"compressible":false},"image/png":{"source":"iana","compressible":false,"extensions":["png"]},"image/prs.btif":{"source":"iana","extensions":["btif"]},"image/prs.pti":{"source":"iana","extensions":["pti"]},"image/pwg-raster":{"source":"iana"},"image/sgi":{"source":"apache","extensions":["sgi"]},"image/svg+xml":{"source":"iana","compressible":true,"extensions":["svg","svgz"]},"image/t38":{"source":"iana","extensions":["t38"]},"image/tiff":{"source":"iana","compressible":false,"extensions":["tif","tiff"]},"image/tiff-fx":{"source":"iana","extensions":["tfx"]},"image/vnd.adobe.photoshop":{"source":"iana","compressible":true,"extensions":["psd"]},"image/vnd.airzip.accelerator.azv":{"source":"iana","extensions":["azv"]},"image/vnd.cns.inf2":{"source":"iana"},"image/vnd.dece.graphic":{"source":"iana","extensions":["uvi","uvvi","uvg","uvvg"]},"image/vnd.djvu":{"source":"iana","extensions":["djvu","djv"]},"image/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"image/vnd.dwg":{"source":"iana","extensions":["dwg"]},"image/vnd.dxf":{"source":"iana","extensions":["dxf"]},"image/vnd.fastbidsheet":{"source":"iana","extensions":["fbs"]},"image/vnd.fpx":{"source":"iana","extensions":["fpx"]},"image/vnd.fst":{"source":"iana","extensions":["fst"]},"image/vnd.fujixerox.edmics-mmr":{"source":"iana","extensions":["mmr"]},"image/vnd.fujixerox.edmics-rlc":{"source":"iana","extensions":["rlc"]},"image/vnd.globalgraphics.pgb":{"source":"iana"},"image/vnd.microsoft.icon":{"source":"iana","compressible":true,"extensions":["ico"]},"image/vnd.mix":{"source":"iana"},"image/vnd.mozilla.apng":{"source":"iana"},"image/vnd.ms-dds":{"compressible":true,"extensions":["dds"]},"image/vnd.ms-modi":{"source":"iana","extensions":["mdi"]},"image/vnd.ms-photo":{"source":"apache","extensions":["wdp"]},"image/vnd.net-fpx":{"source":"iana","extensions":["npx"]},"image/vnd.pco.b16":{"source":"iana","extensions":["b16"]},"image/vnd.radiance":{"source":"iana"},"image/vnd.sealed.png":{"source":"iana"},"image/vnd.sealedmedia.softseal.gif":{"source":"iana"},"image/vnd.sealedmedia.softseal.jpg":{"source":"iana"},"image/vnd.svf":{"source":"iana"},"image/vnd.tencent.tap":{"source":"iana","extensions":["tap"]},"image/vnd.valve.source.texture":{"source":"iana","extensions":["vtf"]},"image/vnd.wap.wbmp":{"source":"iana","extensions":["wbmp"]},"image/vnd.xiff":{"source":"iana","extensions":["xif"]},"image/vnd.zbrush.pcx":{"source":"iana","extensions":["pcx"]},"image/webp":{"source":"apache","extensions":["webp"]},"image/wmf":{"source":"iana","extensions":["wmf"]},"image/x-3ds":{"source":"apache","extensions":["3ds"]},"image/x-cmu-raster":{"source":"apache","extensions":["ras"]},"image/x-cmx":{"source":"apache","extensions":["cmx"]},"image/x-freehand":{"source":"apache","extensions":["fh","fhc","fh4","fh5","fh7"]},"image/x-icon":{"source":"apache","compressible":true,"extensions":["ico"]},"image/x-jng":{"source":"nginx","extensions":["jng"]},"image/x-mrsid-image":{"source":"apache","extensions":["sid"]},"image/x-ms-bmp":{"source":"nginx","compressible":true,"extensions":["bmp"]},"image/x-pcx":{"source":"apache","extensions":["pcx"]},"image/x-pict":{"source":"apache","extensions":["pic","pct"]},"image/x-portable-anymap":{"source":"apache","extensions":["pnm"]},"image/x-portable-bitmap":{"source":"apache","extensions":["pbm"]},"image/x-portable-graymap":{"source":"apache","extensions":["pgm"]},"image/x-portable-pixmap":{"source":"apache","extensions":["ppm"]},"image/x-rgb":{"source":"apache","extensions":["rgb"]},"image/x-tga":{"source":"apache","extensions":["tga"]},"image/x-xbitmap":{"source":"apache","extensions":["xbm"]},"image/x-xcf":{"compressible":false},"image/x-xpixmap":{"source":"apache","extensions":["xpm"]},"image/x-xwindowdump":{"source":"apache","extensions":["xwd"]},"message/cpim":{"source":"iana"},"message/delivery-status":{"source":"iana"},"message/disposition-notification":{"source":"iana","extensions":["disposition-notification"]},"message/external-body":{"source":"iana"},"message/feedback-report":{"source":"iana"},"message/global":{"source":"iana","extensions":["u8msg"]},"message/global-delivery-status":{"source":"iana","extensions":["u8dsn"]},"message/global-disposition-notification":{"source":"iana","extensions":["u8mdn"]},"message/global-headers":{"source":"iana","extensions":["u8hdr"]},"message/http":{"source":"iana","compressible":false},"message/imdn+xml":{"source":"iana","compressible":true},"message/news":{"source":"iana"},"message/partial":{"source":"iana","compressible":false},"message/rfc822":{"source":"iana","compressible":true,"extensions":["eml","mime"]},"message/s-http":{"source":"iana"},"message/sip":{"source":"iana"},"message/sipfrag":{"source":"iana"},"message/tracking-status":{"source":"iana"},"message/vnd.si.simp":{"source":"iana"},"message/vnd.wfa.wsc":{"source":"iana","extensions":["wsc"]},"model/3mf":{"source":"iana","extensions":["3mf"]},"model/e57":{"source":"iana"},"model/gltf+json":{"source":"iana","compressible":true,"extensions":["gltf"]},"model/gltf-binary":{"source":"iana","compressible":true,"extensions":["glb"]},"model/iges":{"source":"iana","compressible":false,"extensions":["igs","iges"]},"model/mesh":{"source":"iana","compressible":false,"extensions":["msh","mesh","silo"]},"model/mtl":{"source":"iana","extensions":["mtl"]},"model/obj":{"source":"iana","extensions":["obj"]},"model/step":{"source":"iana"},"model/step+xml":{"source":"iana","compressible":true,"extensions":["stpx"]},"model/step+zip":{"source":"iana","compressible":false,"extensions":["stpz"]},"model/step-xml+zip":{"source":"iana","compressible":false,"extensions":["stpxz"]},"model/stl":{"source":"iana","extensions":["stl"]},"model/vnd.collada+xml":{"source":"iana","compressible":true,"extensions":["dae"]},"model/vnd.dwf":{"source":"iana","extensions":["dwf"]},"model/vnd.flatland.3dml":{"source":"iana"},"model/vnd.gdl":{"source":"iana","extensions":["gdl"]},"model/vnd.gs-gdl":{"source":"apache"},"model/vnd.gs.gdl":{"source":"iana"},"model/vnd.gtw":{"source":"iana","extensions":["gtw"]},"model/vnd.moml+xml":{"source":"iana","compressible":true},"model/vnd.mts":{"source":"iana","extensions":["mts"]},"model/vnd.opengex":{"source":"iana","extensions":["ogex"]},"model/vnd.parasolid.transmit.binary":{"source":"iana","extensions":["x_b"]},"model/vnd.parasolid.transmit.text":{"source":"iana","extensions":["x_t"]},"model/vnd.pytha.pyox":{"source":"iana"},"model/vnd.rosette.annotated-data-model":{"source":"iana"},"model/vnd.sap.vds":{"source":"iana","extensions":["vds"]},"model/vnd.usdz+zip":{"source":"iana","compressible":false,"extensions":["usdz"]},"model/vnd.valve.source.compiled-map":{"source":"iana","extensions":["bsp"]},"model/vnd.vtu":{"source":"iana","extensions":["vtu"]},"model/vrml":{"source":"iana","compressible":false,"extensions":["wrl","vrml"]},"model/x3d+binary":{"source":"apache","compressible":false,"extensions":["x3db","x3dbz"]},"model/x3d+fastinfoset":{"source":"iana","extensions":["x3db"]},"model/x3d+vrml":{"source":"apache","compressible":false,"extensions":["x3dv","x3dvz"]},"model/x3d+xml":{"source":"iana","compressible":true,"extensions":["x3d","x3dz"]},"model/x3d-vrml":{"source":"iana","extensions":["x3dv"]},"multipart/alternative":{"source":"iana","compressible":false},"multipart/appledouble":{"source":"iana"},"multipart/byteranges":{"source":"iana"},"multipart/digest":{"source":"iana"},"multipart/encrypted":{"source":"iana","compressible":false},"multipart/form-data":{"source":"iana","compressible":false},"multipart/header-set":{"source":"iana"},"multipart/mixed":{"source":"iana"},"multipart/multilingual":{"source":"iana"},"multipart/parallel":{"source":"iana"},"multipart/related":{"source":"iana","compressible":false},"multipart/report":{"source":"iana"},"multipart/signed":{"source":"iana","compressible":false},"multipart/vnd.bint.med-plus":{"source":"iana"},"multipart/voice-message":{"source":"iana"},"multipart/x-mixed-replace":{"source":"iana"},"text/1d-interleaved-parityfec":{"source":"iana"},"text/cache-manifest":{"source":"iana","compressible":true,"extensions":["appcache","manifest"]},"text/calendar":{"source":"iana","extensions":["ics","ifb"]},"text/calender":{"compressible":true},"text/cmd":{"compressible":true},"text/coffeescript":{"extensions":["coffee","litcoffee"]},"text/cql":{"source":"iana"},"text/cql-expression":{"source":"iana"},"text/cql-identifier":{"source":"iana"},"text/css":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["css"]},"text/csv":{"source":"iana","compressible":true,"extensions":["csv"]},"text/csv-schema":{"source":"iana"},"text/directory":{"source":"iana"},"text/dns":{"source":"iana"},"text/ecmascript":{"source":"iana"},"text/encaprtp":{"source":"iana"},"text/enriched":{"source":"iana"},"text/fhirpath":{"source":"iana"},"text/flexfec":{"source":"iana"},"text/fwdred":{"source":"iana"},"text/gff3":{"source":"iana"},"text/grammar-ref-list":{"source":"iana"},"text/html":{"source":"iana","compressible":true,"extensions":["html","htm","shtml"]},"text/jade":{"extensions":["jade"]},"text/javascript":{"source":"iana","compressible":true},"text/jcr-cnd":{"source":"iana"},"text/jsx":{"compressible":true,"extensions":["jsx"]},"text/less":{"compressible":true,"extensions":["less"]},"text/markdown":{"source":"iana","compressible":true,"extensions":["markdown","md"]},"text/mathml":{"source":"nginx","extensions":["mml"]},"text/mdx":{"compressible":true,"extensions":["mdx"]},"text/mizar":{"source":"iana"},"text/n3":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["n3"]},"text/parameters":{"source":"iana","charset":"UTF-8"},"text/parityfec":{"source":"iana"},"text/plain":{"source":"iana","compressible":true,"extensions":["txt","text","conf","def","list","log","in","ini"]},"text/provenance-notation":{"source":"iana","charset":"UTF-8"},"text/prs.fallenstein.rst":{"source":"iana"},"text/prs.lines.tag":{"source":"iana","extensions":["dsc"]},"text/prs.prop.logic":{"source":"iana"},"text/raptorfec":{"source":"iana"},"text/red":{"source":"iana"},"text/rfc822-headers":{"source":"iana"},"text/richtext":{"source":"iana","compressible":true,"extensions":["rtx"]},"text/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"text/rtp-enc-aescm128":{"source":"iana"},"text/rtploopback":{"source":"iana"},"text/rtx":{"source":"iana"},"text/sgml":{"source":"iana","extensions":["sgml","sgm"]},"text/shaclc":{"source":"iana"},"text/shex":{"source":"iana","extensions":["shex"]},"text/slim":{"extensions":["slim","slm"]},"text/spdx":{"source":"iana","extensions":["spdx"]},"text/strings":{"source":"iana"},"text/stylus":{"extensions":["stylus","styl"]},"text/t140":{"source":"iana"},"text/tab-separated-values":{"source":"iana","compressible":true,"extensions":["tsv"]},"text/troff":{"source":"iana","extensions":["t","tr","roff","man","me","ms"]},"text/turtle":{"source":"iana","charset":"UTF-8","extensions":["ttl"]},"text/ulpfec":{"source":"iana"},"text/uri-list":{"source":"iana","compressible":true,"extensions":["uri","uris","urls"]},"text/vcard":{"source":"iana","compressible":true,"extensions":["vcard"]},"text/vnd.a":{"source":"iana"},"text/vnd.abc":{"source":"iana"},"text/vnd.ascii-art":{"source":"iana"},"text/vnd.curl":{"source":"iana","extensions":["curl"]},"text/vnd.curl.dcurl":{"source":"apache","extensions":["dcurl"]},"text/vnd.curl.mcurl":{"source":"apache","extensions":["mcurl"]},"text/vnd.curl.scurl":{"source":"apache","extensions":["scurl"]},"text/vnd.debian.copyright":{"source":"iana","charset":"UTF-8"},"text/vnd.dmclientscript":{"source":"iana"},"text/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"text/vnd.esmertec.theme-descriptor":{"source":"iana","charset":"UTF-8"},"text/vnd.familysearch.gedcom":{"source":"iana","extensions":["ged"]},"text/vnd.ficlab.flt":{"source":"iana"},"text/vnd.fly":{"source":"iana","extensions":["fly"]},"text/vnd.fmi.flexstor":{"source":"iana","extensions":["flx"]},"text/vnd.gml":{"source":"iana"},"text/vnd.graphviz":{"source":"iana","extensions":["gv"]},"text/vnd.hans":{"source":"iana"},"text/vnd.hgl":{"source":"iana"},"text/vnd.in3d.3dml":{"source":"iana","extensions":["3dml"]},"text/vnd.in3d.spot":{"source":"iana","extensions":["spot"]},"text/vnd.iptc.newsml":{"source":"iana"},"text/vnd.iptc.nitf":{"source":"iana"},"text/vnd.latex-z":{"source":"iana"},"text/vnd.motorola.reflex":{"source":"iana"},"text/vnd.ms-mediapackage":{"source":"iana"},"text/vnd.net2phone.commcenter.command":{"source":"iana"},"text/vnd.radisys.msml-basic-layout":{"source":"iana"},"text/vnd.senx.warpscript":{"source":"iana"},"text/vnd.si.uricatalogue":{"source":"iana"},"text/vnd.sosi":{"source":"iana"},"text/vnd.sun.j2me.app-descriptor":{"source":"iana","charset":"UTF-8","extensions":["jad"]},"text/vnd.trolltech.linguist":{"source":"iana","charset":"UTF-8"},"text/vnd.wap.si":{"source":"iana"},"text/vnd.wap.sl":{"source":"iana"},"text/vnd.wap.wml":{"source":"iana","extensions":["wml"]},"text/vnd.wap.wmlscript":{"source":"iana","extensions":["wmls"]},"text/vtt":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["vtt"]},"text/x-asm":{"source":"apache","extensions":["s","asm"]},"text/x-c":{"source":"apache","extensions":["c","cc","cxx","cpp","h","hh","dic"]},"text/x-component":{"source":"nginx","extensions":["htc"]},"text/x-fortran":{"source":"apache","extensions":["f","for","f77","f90"]},"text/x-gwt-rpc":{"compressible":true},"text/x-handlebars-template":{"extensions":["hbs"]},"text/x-java-source":{"source":"apache","extensions":["java"]},"text/x-jquery-tmpl":{"compressible":true},"text/x-lua":{"extensions":["lua"]},"text/x-markdown":{"compressible":true,"extensions":["mkd"]},"text/x-nfo":{"source":"apache","extensions":["nfo"]},"text/x-opml":{"source":"apache","extensions":["opml"]},"text/x-org":{"compressible":true,"extensions":["org"]},"text/x-pascal":{"source":"apache","extensions":["p","pas"]},"text/x-processing":{"compressible":true,"extensions":["pde"]},"text/x-sass":{"extensions":["sass"]},"text/x-scss":{"extensions":["scss"]},"text/x-setext":{"source":"apache","extensions":["etx"]},"text/x-sfv":{"source":"apache","extensions":["sfv"]},"text/x-suse-ymp":{"compressible":true,"extensions":["ymp"]},"text/x-uuencode":{"source":"apache","extensions":["uu"]},"text/x-vcalendar":{"source":"apache","extensions":["vcs"]},"text/x-vcard":{"source":"apache","extensions":["vcf"]},"text/xml":{"source":"iana","compressible":true,"extensions":["xml"]},"text/xml-external-parsed-entity":{"source":"iana"},"text/yaml":{"compressible":true,"extensions":["yaml","yml"]},"video/1d-interleaved-parityfec":{"source":"iana"},"video/3gpp":{"source":"iana","extensions":["3gp","3gpp"]},"video/3gpp-tt":{"source":"iana"},"video/3gpp2":{"source":"iana","extensions":["3g2"]},"video/av1":{"source":"iana"},"video/bmpeg":{"source":"iana"},"video/bt656":{"source":"iana"},"video/celb":{"source":"iana"},"video/dv":{"source":"iana"},"video/encaprtp":{"source":"iana"},"video/ffv1":{"source":"iana"},"video/flexfec":{"source":"iana"},"video/h261":{"source":"iana","extensions":["h261"]},"video/h263":{"source":"iana","extensions":["h263"]},"video/h263-1998":{"source":"iana"},"video/h263-2000":{"source":"iana"},"video/h264":{"source":"iana","extensions":["h264"]},"video/h264-rcdo":{"source":"iana"},"video/h264-svc":{"source":"iana"},"video/h265":{"source":"iana"},"video/iso.segment":{"source":"iana","extensions":["m4s"]},"video/jpeg":{"source":"iana","extensions":["jpgv"]},"video/jpeg2000":{"source":"iana"},"video/jpm":{"source":"apache","extensions":["jpm","jpgm"]},"video/jxsv":{"source":"iana"},"video/mj2":{"source":"iana","extensions":["mj2","mjp2"]},"video/mp1s":{"source":"iana"},"video/mp2p":{"source":"iana"},"video/mp2t":{"source":"iana","extensions":["ts"]},"video/mp4":{"source":"iana","compressible":false,"extensions":["mp4","mp4v","mpg4"]},"video/mp4v-es":{"source":"iana"},"video/mpeg":{"source":"iana","compressible":false,"extensions":["mpeg","mpg","mpe","m1v","m2v"]},"video/mpeg4-generic":{"source":"iana"},"video/mpv":{"source":"iana"},"video/nv":{"source":"iana"},"video/ogg":{"source":"iana","compressible":false,"extensions":["ogv"]},"video/parityfec":{"source":"iana"},"video/pointer":{"source":"iana"},"video/quicktime":{"source":"iana","compressible":false,"extensions":["qt","mov"]},"video/raptorfec":{"source":"iana"},"video/raw":{"source":"iana"},"video/rtp-enc-aescm128":{"source":"iana"},"video/rtploopback":{"source":"iana"},"video/rtx":{"source":"iana"},"video/scip":{"source":"iana"},"video/smpte291":{"source":"iana"},"video/smpte292m":{"source":"iana"},"video/ulpfec":{"source":"iana"},"video/vc1":{"source":"iana"},"video/vc2":{"source":"iana"},"video/vnd.cctv":{"source":"iana"},"video/vnd.dece.hd":{"source":"iana","extensions":["uvh","uvvh"]},"video/vnd.dece.mobile":{"source":"iana","extensions":["uvm","uvvm"]},"video/vnd.dece.mp4":{"source":"iana"},"video/vnd.dece.pd":{"source":"iana","extensions":["uvp","uvvp"]},"video/vnd.dece.sd":{"source":"iana","extensions":["uvs","uvvs"]},"video/vnd.dece.video":{"source":"iana","extensions":["uvv","uvvv"]},"video/vnd.directv.mpeg":{"source":"iana"},"video/vnd.directv.mpeg-tts":{"source":"iana"},"video/vnd.dlna.mpeg-tts":{"source":"iana"},"video/vnd.dvb.file":{"source":"iana","extensions":["dvb"]},"video/vnd.fvt":{"source":"iana","extensions":["fvt"]},"video/vnd.hns.video":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.ttsavc":{"source":"iana"},"video/vnd.iptvforum.ttsmpeg2":{"source":"iana"},"video/vnd.motorola.video":{"source":"iana"},"video/vnd.motorola.videop":{"source":"iana"},"video/vnd.mpegurl":{"source":"iana","extensions":["mxu","m4u"]},"video/vnd.ms-playready.media.pyv":{"source":"iana","extensions":["pyv"]},"video/vnd.nokia.interleaved-multimedia":{"source":"iana"},"video/vnd.nokia.mp4vr":{"source":"iana"},"video/vnd.nokia.videovoip":{"source":"iana"},"video/vnd.objectvideo":{"source":"iana"},"video/vnd.radgamettools.bink":{"source":"iana"},"video/vnd.radgamettools.smacker":{"source":"iana"},"video/vnd.sealed.mpeg1":{"source":"iana"},"video/vnd.sealed.mpeg4":{"source":"iana"},"video/vnd.sealed.swf":{"source":"iana"},"video/vnd.sealedmedia.softseal.mov":{"source":"iana"},"video/vnd.uvvu.mp4":{"source":"iana","extensions":["uvu","uvvu"]},"video/vnd.vivo":{"source":"iana","extensions":["viv"]},"video/vnd.youtube.yt":{"source":"iana"},"video/vp8":{"source":"iana"},"video/vp9":{"source":"iana"},"video/webm":{"source":"apache","compressible":false,"extensions":["webm"]},"video/x-f4v":{"source":"apache","extensions":["f4v"]},"video/x-fli":{"source":"apache","extensions":["fli"]},"video/x-flv":{"source":"apache","compressible":false,"extensions":["flv"]},"video/x-m4v":{"source":"apache","extensions":["m4v"]},"video/x-matroska":{"source":"apache","compressible":false,"extensions":["mkv","mk3d","mks"]},"video/x-mng":{"source":"apache","extensions":["mng"]},"video/x-ms-asf":{"source":"apache","extensions":["asf","asx"]},"video/x-ms-vob":{"source":"apache","extensions":["vob"]},"video/x-ms-wm":{"source":"apache","extensions":["wm"]},"video/x-ms-wmv":{"source":"apache","compressible":false,"extensions":["wmv"]},"video/x-ms-wmx":{"source":"apache","extensions":["wmx"]},"video/x-ms-wvx":{"source":"apache","extensions":["wvx"]},"video/x-msvideo":{"source":"apache","extensions":["avi"]},"video/x-sgi-movie":{"source":"apache","extensions":["movie"]},"video/x-smv":{"source":"apache","extensions":["smv"]},"x-conference/x-cooltalk":{"source":"apache","extensions":["ice"]},"x-shader/x-fragment":{"compressible":true},"x-shader/x-vertex":{"compressible":true}}');

});


parcelRegister("DEDEv", function(module, exports) {
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $8ovux = parcelRequire("8ovux");
"use strict";
function $07732a9a64f5e53c$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $07732a9a64f5e53c$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $07732a9a64f5e53c$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $07732a9a64f5e53c$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $8ovux.cwd();
                path = cwd;
            }
            $07732a9a64f5e53c$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $07732a9a64f5e53c$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $07732a9a64f5e53c$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $07732a9a64f5e53c$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $07732a9a64f5e53c$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $07732a9a64f5e53c$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $07732a9a64f5e53c$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $07732a9a64f5e53c$var$assertPath(from);
        $07732a9a64f5e53c$var$assertPath(to);
        if (from === to) return "";
        from = $07732a9a64f5e53c$var$posix.resolve(from);
        to = $07732a9a64f5e53c$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $07732a9a64f5e53c$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $07732a9a64f5e53c$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $07732a9a64f5e53c$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $07732a9a64f5e53c$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $07732a9a64f5e53c$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$07732a9a64f5e53c$var$posix.posix = $07732a9a64f5e53c$var$posix;
module.exports = $07732a9a64f5e53c$var$posix;

});



parcelRegister("4XV6a", function(module, exports) {

$parcel$export(module.exports, "getDeploymentChanges", function () { return $7b3f82158923d608$export$fb24c432ed430722; });
$parcel$export(module.exports, "getDeploymentDashboard", function () { return $7b3f82158923d608$export$38b56d556c8e8848; });
$parcel$export(module.exports, "getDeploymentDashboardFetchedStatus", function () { return $7b3f82158923d608$export$160d1ce872e28fbf; });
$parcel$export(module.exports, "getDeploymentDashboardWithTypeNames", function () { return $7b3f82158923d608$export$cbe2ff6168d22b8; });
$parcel$export(module.exports, "getDeploymentDashboardVersion", function () { return $7b3f82158923d608$export$91ec2a75f0182287; });
$parcel$export(module.exports, "getEnvironmentsByUuid", function () { return $7b3f82158923d608$export$f887c46344e1ef94; });
$parcel$export(module.exports, "getEnvironmentNames", function () { return $7b3f82158923d608$export$b56ab41a1378075d; });
$parcel$export(module.exports, "getEditorEnvironments", function () { return $7b3f82158923d608$export$1a1cb415810b6f50; });
$parcel$export(module.exports, "getDeploymentSummary", function () { return $7b3f82158923d608$export$6836d440dd1211ca; });
$parcel$export(module.exports, "getDeploymentPreview", function () { return $7b3f82158923d608$export$6087507c26c894c3; });
$parcel$export(module.exports, "getRedeployment", function () { return $7b3f82158923d608$export$cf1812b0d0aaf5aa; });
$parcel$export(module.exports, "isFetchingDeploymentDashboard", function () { return $7b3f82158923d608$export$12f959c5886da031; });
$parcel$export(module.exports, "isUpdatingDeploymentDashboard", function () { return $7b3f82158923d608$export$5fd41144dccccbac; });
$parcel$export(module.exports, "isUpdatingEnvironment", function () { return $7b3f82158923d608$export$e2bfbd39082c1c71; });
$parcel$export(module.exports, "getEnvironmentHistoryMap", function () { return $7b3f82158923d608$export$62ae90b75d274d11; });
$parcel$export(module.exports, "getFetchingEnvironmentHistoryMap", function () { return $7b3f82158923d608$export$44e4b2ad1795a06a; });
$parcel$export(module.exports, "getHasOnboardedDeployments", function () { return $7b3f82158923d608$export$994a2d5ff0f23406; });
$parcel$export(module.exports, "getDeploymentDashboardAsSelectOptions", function () { return $7b3f82158923d608$export$c7bd82a58e1ca484; });

var $aXXtM = parcelRequire("aXXtM");
parcelRequire("e9n2v");
var $eRckJ = parcelRequire("eRckJ");

var $90kWr = parcelRequire("90kWr");

var $aanBq = parcelRequire("aanBq");

var $7qdXF = parcelRequire("7qdXF");

var $h3kk7 = parcelRequire("h3kk7");

var $i3LMs = parcelRequire("i3LMs");
const $7b3f82158923d608$export$fb24c432ed430722 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), ({ deployments: deployments })=>{
    return deployments.changes;
});
const $7b3f82158923d608$export$38b56d556c8e8848 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), ({ deployments: deployments })=>{
    return Object.values(deployments.dashboard.type);
});
const $7b3f82158923d608$export$160d1ce872e28fbf = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), ({ deployments: deployments })=>{
    return deployments.dashboard.fetchedStatus;
});
const $7b3f82158923d608$export$cbe2ff6168d22b8 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), ({ deployments: deployments })=>deployments.dashboard.type);
const $7b3f82158923d608$export$91ec2a75f0182287 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), ({ deployments: deployments })=>deployments.dashboard.version);
const $7b3f82158923d608$export$f887c46344e1ef94 = (0, $aXXtM.createSelector)($7b3f82158923d608$export$38b56d556c8e8848, (deploymentDashboard)=>{
    return deploymentDashboard.flat().reduce((reducer, environment)=>{
        reducer[environment.uuid] = environment;
        return reducer;
    }, {});
});
const $7b3f82158923d608$export$b56ab41a1378075d = (0, $aXXtM.createSelector)($7b3f82158923d608$export$38b56d556c8e8848, (deploymentDashboard)=>{
    return deploymentDashboard.reduce((reducer, group)=>{
        if (group[0]) reducer[group[0].uuid] = group[0].name;
        return reducer;
    }, {});
});
const $7b3f82158923d608$export$1a1cb415810b6f50 = (0, $aXXtM.createSelector)($7b3f82158923d608$export$38b56d556c8e8848, (deploymentDashboard)=>{
    return deploymentDashboard.map((group)=>group.map((e)=>e.name.toLowerCase()));
});
const $7b3f82158923d608$export$6836d440dd1211ca = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), ({ deployments: deployments })=>{
    var _deployments$summary, _deployments$summary$, _deployments$summary2, _deployments$summary3, _deployments$summary4, _deployments$summary5, _deployments$summary6, _deployments$summary7;
    const previousCommit = (_deployments$summary = deployments.summary) === null || _deployments$summary === void 0 ? void 0 : (_deployments$summary$ = _deployments$summary.lastSuccessfulDeployment) === null || _deployments$summary$ === void 0 ? void 0 : _deployments$summary$.deployable.commit;
    const currentCommit = (_deployments$summary2 = deployments.summary) === null || _deployments$summary2 === void 0 ? void 0 : (_deployments$summary3 = _deployments$summary2.deployment) === null || _deployments$summary3 === void 0 ? void 0 : _deployments$summary3.deployable.commit;
    const isRollback = new Date((previousCommit === null || previousCommit === void 0 ? void 0 : previousCommit.date) || "").getTime() > new Date((currentCommit === null || currentCommit === void 0 ? void 0 : currentCommit.date) || "").getTime();
    const createdOn = isRollback ? ((_deployments$summary4 = deployments.summary) === null || _deployments$summary4 === void 0 ? void 0 : (_deployments$summary5 = _deployments$summary4.lastSuccessfulDeployment) === null || _deployments$summary5 === void 0 ? void 0 : _deployments$summary5.deployable.created_on) || "" : ((_deployments$summary6 = deployments.summary) === null || _deployments$summary6 === void 0 ? void 0 : (_deployments$summary7 = _deployments$summary6.deployment) === null || _deployments$summary7 === void 0 ? void 0 : _deployments$summary7.deployable.created_on) || "";
    return {
        ...deployments.summary,
        revisionFrom: !(previousCommit !== null && previousCommit !== void 0 && previousCommit.hash) && currentCommit !== null && currentCommit !== void 0 && currentCommit.parentHash ? currentCommit.parentHash : (previousCommit === null || previousCommit === void 0 ? void 0 : previousCommit.hash) || "",
        revisionTo: (currentCommit === null || currentCommit === void 0 ? void 0 : currentCommit.hash) || "",
        createdOn: createdOn,
        isRollback: isRollback
    };
});
const $7b3f82158923d608$export$6087507c26c894c3 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), ({ deployments: deployments })=>{
    var _deployment$deployabl, _deployment$deployabl2, _environment$nextProm, _environment$nextProm2, _environment$toJS, _environment$toJS$cal;
    const { environment: environment, environment: { latest_successful_deployment: deployment }, deployment: previousDeployment } = deployments.preview;
    const previousCommit = previousDeployment.deployable.commit;
    const currentCommit = deployment === null || deployment === void 0 ? void 0 : (_deployment$deployabl = deployment.deployable) === null || _deployment$deployabl === void 0 ? void 0 : _deployment$deployabl.commit;
    const isRollback = new Date((previousCommit === null || previousCommit === void 0 ? void 0 : previousCommit.date) || "").getTime() > new Date((currentCommit === null || currentCommit === void 0 ? void 0 : currentCommit.date) || "").getTime();
    const createdOn = isRollback ? previousDeployment.deployable.created_on || "" : (deployment === null || deployment === void 0 ? void 0 : (_deployment$deployabl2 = deployment.deployable) === null || _deployment$deployabl2 === void 0 ? void 0 : _deployment$deployabl2.created_on) || "";
    return {
        deployment: deployment,
        environment: new (0, $eRckJ.Environment)({
            uuid: (_environment$nextProm = environment.nextPromotion) === null || _environment$nextProm === void 0 ? void 0 : _environment$nextProm["environment.uuid"],
            name: (_environment$nextProm2 = environment.nextPromotion) === null || _environment$nextProm2 === void 0 ? void 0 : _environment$nextProm2["environment.name"],
            next_promotion: environment === null || environment === void 0 ? void 0 : (_environment$toJS = environment.toJS) === null || _environment$toJS === void 0 ? void 0 : (_environment$toJS$cal = _environment$toJS.call(environment)) === null || _environment$toJS$cal === void 0 ? void 0 : _environment$toJS$cal.next_promotion
        }),
        previousDeployment: previousDeployment,
        revisionFrom: !(previousCommit !== null && previousCommit !== void 0 && previousCommit.hash) && currentCommit !== null && currentCommit !== void 0 && currentCommit.parentHash ? currentCommit.parentHash : (previousCommit === null || previousCommit === void 0 ? void 0 : previousCommit.hash) || "",
        revisionTo: (currentCommit === null || currentCommit === void 0 ? void 0 : currentCommit.hash) || "",
        createdOn: createdOn,
        isRollback: isRollback
    };
});
const $7b3f82158923d608$export$cf1812b0d0aaf5aa = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), ({ deployments: deployments })=>{
    const { deployment: deployment, environment: environment, lastSuccessfulDeployment: previousDeployment } = deployments.redeployment;
    const previousCommit = previousDeployment.deployable.commit;
    const currentCommit = deployment.deployable.commit;
    const isRollback = new Date((previousCommit === null || previousCommit === void 0 ? void 0 : previousCommit.date) || "").getTime() > new Date((currentCommit === null || currentCommit === void 0 ? void 0 : currentCommit.date) || "").getTime();
    const createdOn = isRollback ? previousDeployment.deployable.created_on || "" : deployment.deployable.created_on || "";
    return {
        deployment: deployment,
        environment: environment,
        previousDeployment: previousDeployment,
        revisionFrom: !(previousCommit !== null && previousCommit !== void 0 && previousCommit.hash) && currentCommit !== null && currentCommit !== void 0 && currentCommit.parentHash ? currentCommit.parentHash : (previousCommit === null || previousCommit === void 0 ? void 0 : previousCommit.hash) || "",
        revisionTo: (currentCommit === null || currentCommit === void 0 ? void 0 : currentCommit.hash) || "",
        createdOn: createdOn,
        isRollback: isRollback
    };
});
const $7b3f82158923d608$export$12f959c5886da031 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), ({ deployments: deployments })=>deployments.dashboard.fetchedStatus === (0, $90kWr.LoadingStatus).Before || deployments.dashboard.fetchedStatus === (0, $90kWr.LoadingStatus).Fetching);
const $7b3f82158923d608$export$5fd41144dccccbac = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), ({ deployments: deployments })=>deployments.dashboard.reorderedStatus === (0, $90kWr.LoadingStatus).Fetching);
const $7b3f82158923d608$export$e2bfbd39082c1c71 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), ({ deployments: deployments })=>(environmentUuid)=>{
        var _deployments$dashboar;
        return !!environmentUuid && !!((_deployments$dashboar = deployments.dashboard.updatingEnvironmentUuids) !== null && _deployments$dashboar !== void 0 && _deployments$dashboar[environmentUuid]);
    });
const $7b3f82158923d608$export$62ae90b75d274d11 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), ({ deployments: deployments })=>{
    return deployments.environmentHistory.map;
});
const $7b3f82158923d608$export$44e4b2ad1795a06a = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), ({ deployments: deployments })=>(environmentUuid)=>{
        var _deployments$environm;
        return ((_deployments$environm = deployments.environmentHistory.fetchedStatus) === null || _deployments$environm === void 0 ? void 0 : _deployments$environm[environmentUuid]) === (0, $90kWr.LoadingStatus).Fetching;
    });
const $7b3f82158923d608$export$64b151e65182ac29 = (0, $aXXtM.createSelector)($7b3f82158923d608$export$38b56d556c8e8848, (dashboard)=>{
    return dashboard.flat().filter((e)=>(e === null || e === void 0 ? void 0 : e.latest_deployment) || (e === null || e === void 0 ? void 0 : e.latest_successful_deployment)).length > 0;
});
const $7b3f82158923d608$export$994a2d5ff0f23406 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (0, $aanBq.getCurrentRepository), $7b3f82158923d608$export$64b151e65182ac29, ({ deployments: deployments }, repository, hasDeployments)=>{
    const key = `${(0, $i3LMs.DEPLOYMENTS_ONBOARDED_KEY)}-${repository === null || repository === void 0 ? void 0 : repository.uuid}`;
    if ((0, $h3kk7.default).get(key)) return true;
    else if (deployments.dashboard.fetchedStatus === (0, $90kWr.LoadingStatus).Success && hasDeployments) {
        (0, $h3kk7.default).set(`${(0, $i3LMs.DEPLOYMENTS_ONBOARDED_KEY)}-${repository === null || repository === void 0 ? void 0 : repository.uuid}`, true);
        return true;
    }
    return false;
});
const $7b3f82158923d608$var$reduceEnvironmentsToSelectOptions = (environments)=>{
    return environments.reduce((reducer, env, index)=>{
        if (env) {
            const val = {
                label: env.name,
                value: env.name,
                uuid: env.uuid,
                type: env.type
            };
            reducer[index] = val;
        }
        return reducer;
    }, []);
};
const $7b3f82158923d608$export$c7bd82a58e1ca484 = (0, $aXXtM.createSelector)($7b3f82158923d608$export$38b56d556c8e8848, (deploymentDashboard)=>{
    const envs = [];
    deploymentDashboard.forEach((environments)=>{
        if (environments.length > 0) {
            const group = `${environments[0].type} environments`;
            envs.push({
                label: group,
                options: $7b3f82158923d608$var$reduceEnvironmentsToSelectOptions(environments)
            });
        }
    });
    if (envs.length !== 0) envs.unshift({
        label: "Other",
        options: [
            {
                label: "No environment",
                value: "no environment",
                uuid: ""
            }
        ]
    });
    return envs;
});

});



parcelRegister("5rTsd", function(module, exports) {

$parcel$export(module.exports, "loadWorkspaceDynamicPipelinesResource", function () { return $4f923fad18284c4d$export$dda33d156b545016; });
$parcel$export(module.exports, "loadRepositoryDynamicPipelinesResource", function () { return $4f923fad18284c4d$export$b2554496c80ab722; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $k2cPS = parcelRequire("k2cPS");

var $jUzO7 = parcelRequire("jUzO7");
async function $4f923fad18284c4d$var$fetchData(url, errorMessage) {
    try {
        const req = (0, $k2cPS.default)(url);
        const resp = await fetch(req);
        if (!resp.ok) {
            if (resp.status === 404) return {
                appAri: ""
            };
            throw new Error(errorMessage);
        }
        const body = await resp.json();
        return {
            appAri: body.appAri || ""
        };
    } catch (e) {
        throw new Error(errorMessage);
    }
}
function $4f923fad18284c4d$var$createDynamicPipelinesResource({ errorMessage: errorMessage, getRequestUrl: getRequestUrl, type: type }) {
    return (0, $3kfkg.createResource)({
        type: type,
        getKey: ({ match: match })=>getRequestUrl(match.params),
        maxAge: 60000,
        getData: async ({ match: match })=>{
            const initialData = await $4f923fad18284c4d$var$fetchData(getRequestUrl(match.params), errorMessage);
            // If the type is 'pipelinesRepositoryDynamicPipelines', fetch additional data
            if (type === "pipelinesRepositoryDynamicPipelines") {
                const workspaceData = await $4f923fad18284c4d$var$fetchData((0, $jUzO7.getWorkspaceDynamicPipelinesProvidersUrl)({
                    workspaceSlug: match.params.repositoryOwner || ""
                }), "Could not fetch inherited workspace dynamic pipelines");
                return {
                    ...initialData,
                    inheritedWorkspaceAPPAri: workspaceData.appAri
                };
            }
            return {
                ...initialData,
                inheritedWorkspaceAPPAri: ""
            };
        }
    });
}
const $4f923fad18284c4d$export$dda33d156b545016 = $4f923fad18284c4d$var$createDynamicPipelinesResource({
    errorMessage: "Could not fetch workspace dynamic pipelines",
    getRequestUrl: (0, $jUzO7.getWorkspaceDynamicPipelinesProvidersUrl),
    type: "pipelinesWorkspaceDynamicPipelines"
});
const $4f923fad18284c4d$export$b2554496c80ab722 = $4f923fad18284c4d$var$createDynamicPipelinesResource({
    errorMessage: "Could not fetch repository dynamic pipelines",
    getRequestUrl: (0, $jUzO7.getRepositoryDynamicPipelinesProvidersUrl),
    type: "pipelinesRepositoryDynamicPipelines"
});

});
parcelRegister("jUzO7", function(module, exports) {

$parcel$export(module.exports, "getKnownHostsUrl", function () { return $fdb61fd969d9cb71$export$98a8679d76e8a7fa; });
$parcel$export(module.exports, "getPipelinesPageURL", function () { return $fdb61fd969d9cb71$export$e5985bb8c8e4603b; });
$parcel$export(module.exports, "getArtifactsPageURL", function () { return $fdb61fd969d9cb71$export$ddad156ffbd8cdb9; });
$parcel$export(module.exports, "getMetricsPageURL", function () { return $fdb61fd969d9cb71$export$2a84ebbf606c642d; });
$parcel$export(module.exports, "getServicePageURL", function () { return $fdb61fd969d9cb71$export$c6356fe2711f3075; });
$parcel$export(module.exports, "getTestReportPageURL", function () { return $fdb61fd969d9cb71$export$7860fb97cd62c980; });
$parcel$export(module.exports, "getGettingStartedPageURL", function () { return $fdb61fd969d9cb71$export$ab32102efeeb66f3; });
$parcel$export(module.exports, "getEditConfigurationURL", function () { return $fdb61fd969d9cb71$export$77a067d428b05e4d; });
$parcel$export(module.exports, "getDeploymentsSettingsPageURL", function () { return $fdb61fd969d9cb71$export$85e3985e191919f7; });
$parcel$export(module.exports, "getPipelinesSettingsPageURL", function () { return $fdb61fd969d9cb71$export$65b3fd5d73905c75; });
$parcel$export(module.exports, "getAdminPlansPageUrl", function () { return $fdb61fd969d9cb71$export$62faa8f78665bdfd; });
$parcel$export(module.exports, "getWorkspaceVariablesPageUrl", function () { return $fdb61fd969d9cb71$export$e7184cff784f1dee; });
$parcel$export(module.exports, "getWorkspaceRunnersPageUrl", function () { return $fdb61fd969d9cb71$export$c19473887325c6bc; });
$parcel$export(module.exports, "getWorkspaceDynamicPipelinesPageUrl", function () { return $fdb61fd969d9cb71$export$5d9625ead2a3b773; });
$parcel$export(module.exports, "getWorkspaceDynamicPipelinesProvidersUrl", function () { return $fdb61fd969d9cb71$export$46005a9e69c011c2; });
$parcel$export(module.exports, "getRepositoryDynamicPipelinesProvidersUrl", function () { return $fdb61fd969d9cb71$export$bc23ac596fe5013d; });

var $cJH1T = parcelRequire("cJH1T");

var $i3LMs = parcelRequire("i3LMs");
parcelRequire("byiIT");
var $4qNbY = parcelRequire("4qNbY");

var $fEutT = parcelRequire("fEutT");
const $fdb61fd969d9cb71$export$98a8679d76e8a7fa = (repoPath, page, pagelen, uuid)=>{
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
        page: page,
        pagelen: pagelen
    });
    return `${repoPath}/pipelines_config/ssh/known_hosts${uuid ? `/${uuid}` : "/"}${query ? `?${query}` : ""}`;
};
function $fdb61fd969d9cb71$export$e5985bb8c8e4603b(repoPath) {
    return `/${repoPath}/pipelines/results/`;
}
function $fdb61fd969d9cb71$export$6af77c4c4e510835(repoPath, pipeline, stepUuid) {
    return `/${repoPath}/pipelines/results/${pipeline.buildNumber || (0, $4qNbY.default)(pipeline.uuid)}/steps/${(0, $4qNbY.default)(stepUuid)}`;
}
function $fdb61fd969d9cb71$export$ddad156ffbd8cdb9(repoPath, pipelineUuid, stepUuid) {
    return `${$fdb61fd969d9cb71$export$6af77c4c4e510835(repoPath, {
        uuid: pipelineUuid
    }, stepUuid)}/artifacts`;
}
function $fdb61fd969d9cb71$export$2a84ebbf606c642d(repoPath, pipelineUuid, stepUuid) {
    return `${$fdb61fd969d9cb71$export$6af77c4c4e510835(repoPath, {
        uuid: pipelineUuid
    }, stepUuid)}/metrics`;
}
function $fdb61fd969d9cb71$export$c6356fe2711f3075(repoPath, pipelineUuid, stepUuid, serviceUuid) {
    return `${$fdb61fd969d9cb71$export$6af77c4c4e510835(repoPath, {
        uuid: pipelineUuid
    }, stepUuid)}${serviceUuid ? `/services/${(0, $4qNbY.default)(serviceUuid)}` : ""}`;
}
function $fdb61fd969d9cb71$export$7860fb97cd62c980(repoPath, pipeline, stepUuid) {
    return `${$fdb61fd969d9cb71$export$6af77c4c4e510835(repoPath, pipeline, stepUuid)}/test-report`;
}
function $fdb61fd969d9cb71$export$ab32102efeeb66f3(repoPath) {
    return `${$fdb61fd969d9cb71$export$e5985bb8c8e4603b(repoPath)}getting-started`;
}
function $fdb61fd969d9cb71$export$77a067d428b05e4d(repoPath, branch, queryParams) {
    const search = (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(queryParams, {
        addQueryPrefix: true,
        skipNulls: true
    });
    return `/${repoPath}/src/${branch}/${0, $i3LMs.YML_FILE_NAME}${search}`;
}
function $fdb61fd969d9cb71$export$85e3985e191919f7(repoPath, isDeploymentsSettingsInFrontbucket) {
    if (isDeploymentsSettingsInFrontbucket) return `/${repoPath}/admin/pipelines/deployment-settings`;
    else return `/${repoPath}/admin/addon/admin/pipelines/deployment-settings`;
}
function $fdb61fd969d9cb71$export$65b3fd5d73905c75(repoPath) {
    return `/${repoPath}/admin/pipelines/settings`;
}
function $fdb61fd969d9cb71$export$62faa8f78665bdfd(workspace) {
    return `/${workspace}/workspace/settings/plans-and-billing`;
}
function $fdb61fd969d9cb71$export$e7184cff784f1dee(workspace) {
    return `/${workspace}/workspace/settings/pipelines/account-variables`;
}
function $fdb61fd969d9cb71$export$c19473887325c6bc(workspace) {
    return `/${workspace}/workspace/settings/pipelines/account-runners`;
}
function $fdb61fd969d9cb71$export$5d9625ead2a3b773(workspace) {
    return `/${workspace}/workspace/settings/pipelines/dynamic-pipelines`;
}
const $fdb61fd969d9cb71$export$46005a9e69c011c2 = (params)=>{
    return `${(0, $fEutT.default)("/!api/internal")}/workspaces/${params.workspaceSlug}/pipelines-config/dynamic-pipelines-provider`;
};
const $fdb61fd969d9cb71$export$bc23ac596fe5013d = (params)=>{
    const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug } = params;
    return `${(0, $fEutT.default)("/!api/internal")}/repositories/${repositoryOwner}/${repositorySlug}/pipelines-config/dynamic-pipelines-provider`;
};

});
parcelRegister("byiIT", function(module, exports) {

$parcel$export(module.exports, "formatUuid", function () { return (parcelRequire("4qNbY")).default; });
$parcel$export(module.exports, "isInIframe", function () { return (parcelRequire("dP8tk")).default; });
$parcel$export(module.exports, "links", function () { return (parcelRequire("cJoaV")); });
$parcel$export(module.exports, "toDate", function () { return (parcelRequire("3TXkJ")).toDate; });
$parcel$export(module.exports, "formatDate", function () { return (parcelRequire("abDCk")).formatDate; });
$parcel$export(module.exports, "formatDistanceToNow", function () { return (parcelRequire("8OofD")).formatDistanceToNow; });

var $cJoaV = parcelRequire("cJoaV");

var $72i0w = parcelRequire("72i0w");

var $4kuFz = parcelRequire("4kuFz");

var $4qNbY = parcelRequire("4qNbY");

var $dP8tk = parcelRequire("dP8tk");

var $gvL5O = parcelRequire("gvL5O");

var $ghXzH = parcelRequire("ghXzH");

var $3TXkJ = parcelRequire("3TXkJ");

var $abDCk = parcelRequire("abDCk");

var $8OofD = parcelRequire("8OofD");

var $f9D66 = parcelRequire("f9D66");

});
parcelRegister("cJoaV", function(module, exports) {

$parcel$export(module.exports, "getEditConfigurationURL", function () { return $65e771b8bc13642f$export$77a067d428b05e4d; });
$parcel$export(module.exports, "getPipelinesPageURL", function () { return $65e771b8bc13642f$export$e5985bb8c8e4603b; });
$parcel$export(module.exports, "getPipelinePageURL", function () { return $65e771b8bc13642f$export$12f694c740df14bf; });
$parcel$export(module.exports, "getStepPageURL", function () { return $65e771b8bc13642f$export$6af77c4c4e510835; });
$parcel$export(module.exports, "getTestReportPageURL", function () { return $65e771b8bc13642f$export$7860fb97cd62c980; });
$parcel$export(module.exports, "getAccountPageURL", function () { return $65e771b8bc13642f$export$d544e464d603324e; });
$parcel$export(module.exports, "getProjectPageURL", function () { return $65e771b8bc13642f$export$ae6f3ddf5c60807d; });
$parcel$export(module.exports, "getSettingsPageURL", function () { return $65e771b8bc13642f$export$c3f033e7fad4995; });
$parcel$export(module.exports, "getDeploymentSettingsPageURL", function () { return $65e771b8bc13642f$export$dc0ccf5d56c08401; });
$parcel$export(module.exports, "getAddConfigurationURL", function () { return $65e771b8bc13642f$export$b65b9ef6da8b7c24; });
$parcel$export(module.exports, "getDeploymentsPageURL", function () { return $65e771b8bc13642f$export$e3eab3545aaa76b; });
$parcel$export(module.exports, "getPlansPageURL", function () { return $65e771b8bc13642f$export$b435aa0e4279a1db; });
$parcel$export(module.exports, "getAdminPlans", function () { return $65e771b8bc13642f$export$4cfa011c30625e47; });
$parcel$export(module.exports, "getTestExecutionUrl", function () { return $65e771b8bc13642f$export$1754fd207c712fcc; });

var $i3LMs = parcelRequire("i3LMs");

var $72i0w = parcelRequire("72i0w");

var $4qNbY = parcelRequire("4qNbY");

var $dP8tk = parcelRequire("dP8tk");
function $65e771b8bc13642f$var$getEnvFromAddonKey(addonKey) {
    if (addonKey !== null && addonKey !== void 0 && addonKey.startsWith((0, $i3LMs.ADDON_KEY_PREFIX))) return addonKey.substring((0, $i3LMs.ADDON_KEY_PREFIX).length);
    return "";
}
function $65e771b8bc13642f$var$getEnvQueryParams(env, addonKey) {
    const value = env || $65e771b8bc13642f$var$getEnvFromAddonKey(addonKey);
    return value ? `?env=${value}` : "";
}
function $65e771b8bc13642f$export$77a067d428b05e4d(repoPath, branch) {
    return `${0, $i3LMs.ORIGIN}/${repoPath}/src/${branch}/${0, $i3LMs.YML_FILE_NAME}`;
}
function $65e771b8bc13642f$export$e5985bb8c8e4603b(repoPath, addonKey, route = "", env) {
    const envParams = $65e771b8bc13642f$var$getEnvQueryParams(env, addonKey);
    if (!(0, $dP8tk.default)() || envParams) return `/${repoPath}/pipelines${route}${envParams}`;
    return `${0, $i3LMs.ORIGIN}/${repoPath}/addon/${addonKey}/home${route ? `#!${route}` : "#!/"}`;
}
function $65e771b8bc13642f$export$12f694c740df14bf(pipeline, repoPath, addonKey, env) {
    const envParams = $65e771b8bc13642f$var$getEnvQueryParams(env, addonKey);
    const route = `/results/${pipeline.buildNumber || (0, $4qNbY.default)(pipeline.uuid)}`;
    if (!(0, $dP8tk.default)() || envParams) return `/${repoPath}/pipelines${route}${envParams}`;
    return repoPath && addonKey ? `${0, $i3LMs.ORIGIN}/${repoPath}/addon/${addonKey}/home#!${route}` : route;
}
function $65e771b8bc13642f$export$6af77c4c4e510835(pipeline, stepUuid, repoPath) {
    const pipelineId = pipeline.buildNumber || (0, $4qNbY.default)(pipeline.uuid);
    const route = `/results/${pipelineId}/steps/${(0, $4qNbY.default)(stepUuid)}`;
    return `/${repoPath}/pipelines${route}`;
}
function $65e771b8bc13642f$export$7860fb97cd62c980(pipeline, stepUuid, repoPath) {
    const stepPage = $65e771b8bc13642f$export$6af77c4c4e510835(pipeline, stepUuid, repoPath);
    return `${stepPage}/test-report`;
}
function $65e771b8bc13642f$export$d544e464d603324e(accountUuid) {
    return `${0, $i3LMs.ORIGIN}/${accountUuid}`;
}
function $65e771b8bc13642f$export$ae6f3ddf5c60807d(repoPath, projectKey) {
    return `${0, $i3LMs.ORIGIN}/account/user/${(0, $72i0w.default)(repoPath)}/projects/${projectKey}`;
}
function $65e771b8bc13642f$export$c3f033e7fad4995(repoPath, addonKey) {
    return `${0, $i3LMs.ORIGIN}/${repoPath}/admin/${addonKey}/settings`;
}
function $65e771b8bc13642f$export$dc0ccf5d56c08401(repoPath, addonKey) {
    return `${0, $i3LMs.ORIGIN}/${repoPath}/admin/addon/admin/${addonKey}/deployment-settings`;
}
function $65e771b8bc13642f$export$b65b9ef6da8b7c24(repoPath, branch, ymlToCopy = "") {
    let yml = ymlToCopy;
    if (yml) yml = `&source=${encodeURIComponent(yml)}&disableFilename=true`;
    return `${0, $i3LMs.ORIGIN}/${repoPath}/create-file/?filename=${0, $i3LMs.YML_FILE_NAME}&at=${branch}${yml}&fromOnboarding=true`;
}
function $65e771b8bc13642f$export$e3eab3545aaa76b(repoPath, addonKey) {
    return `${0, $i3LMs.ORIGIN}/${repoPath}/addon/${addonKey}/deployments`;
}
function $65e771b8bc13642f$export$b435aa0e4279a1db(repoPath = "") {
    return `${0, $i3LMs.ORIGIN}/account/user/${(0, $72i0w.default)(repoPath)}/plans-and-billing/`;
}
function $65e771b8bc13642f$export$4cfa011c30625e47() {
    return `${0, $i3LMs.ORIGIN}/account/admin/plans/`;
}
function $65e771b8bc13642f$export$1754fd207c712fcc(testUuid) {
    return `test-cases/${testUuid}`;
}

});
parcelRegister("72i0w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23c43d9ab11d3927$export$2e2bcd8739ae039; });
/**
 * Assumption that the input is repositoryPath and is of the format <username>/<repository>.
 * Note: repositoryPath cannot contain '/' and are replaced with '-'
 */ function $23c43d9ab11d3927$export$2e2bcd8739ae039(repositoryPath = "") {
    return repositoryPath.replace(/\/(.*)$/, "");
}

});

parcelRegister("4qNbY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0971c54ee39ec30$export$2e2bcd8739ae039; });
const $b0971c54ee39ec30$var$isNumeric = (value)=>!isNaN(parseFloat(value)) && isFinite(Number(value));
function $b0971c54ee39ec30$export$2e2bcd8739ae039(uuidToEnCode = "") {
    let uuid = uuidToEnCode;
    uuid = uuid.toString();
    if ($b0971c54ee39ec30$var$isNumeric(uuid)) return uuid;
    uuid = decodeURI(uuid);
    if (!uuid.startsWith("{")) uuid = `{${uuid}`;
    if (!uuid.endsWith("}")) uuid = `${uuid}}`;
    return encodeURI(uuid);
}

});

parcelRegister("dP8tk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6b611ff8c625233$export$2e2bcd8739ae039; });
function $e6b611ff8c625233$export$2e2bcd8739ae039() {
    let isInIframe = true;
    try {
        if (window.top === window) isInIframe = false;
    // eslint-disable-next-line no-empty
    } catch (ignore) {}
    return isInIframe;
}

});


parcelRegister("4kuFz", function(module, exports) {
const $be4dd7aaa1465ef5$var$isInvalidInput = (seconds)=>{
    return isNaN(seconds) || seconds === Infinity || seconds < 0;
};
function $be4dd7aaa1465ef5$export$d68230bfd6a61736(seconds) {
    const totalSeconds = parseInt(`${seconds}`, 10);
    const hours = Math.floor(totalSeconds / 3600);
    let remainingSeconds = totalSeconds % 3600;
    const minutes = Math.floor(remainingSeconds / 60);
    remainingSeconds %= 60;
    const prettyHoursWithSeparator = hours > 0 ? `${hours}h` : "";
    const prettyMinutes = minutes ? `${minutes}m` : "";
    return `${prettyHoursWithSeparator} ${prettyMinutes} ${remainingSeconds}s`.trim();
}
function $be4dd7aaa1465ef5$export$2e2bcd8739ae039(firstTimestamp, currentTimestamp) {
    const seconds = (Number(new Date(currentTimestamp)) - Number(new Date(firstTimestamp))) / 1000;
    if ($be4dd7aaa1465ef5$var$isInvalidInput(seconds)) return "0s";
    return $be4dd7aaa1465ef5$export$d68230bfd6a61736(seconds);
}

});

parcelRegister("gvL5O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4692138a93217f10$export$2e2bcd8739ae039; });
function $4692138a93217f10$export$2e2bcd8739ae039(bytes, decimals) {
    if (bytes === 0) return "0 Bytes";
    const k = 1000;
    const dm = decimals || 2;
    const sizes = [
        "Bytes",
        "KB",
        "MB",
        "GB",
        "TB",
        "PB"
    ];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

});

parcelRegister("ghXzH", function(module, exports) {

var $jp7ng = parcelRequire("jp7ng");

var $i3LMs = parcelRequire("i3LMs");
function $df5548d8541910ee$export$c5f4d4f533ca9230(fillState) {
    switch(fillState){
        case (0, $i3LMs.PipelineFillState).Success:
            return $jp7ng.G300;
        case (0, $i3LMs.PipelineFillState).Skipped:
            return $jp7ng.Y300;
        case (0, $i3LMs.PipelineFillState).Failure:
            return $jp7ng.R300;
        case (0, $i3LMs.PipelineFillState).Other:
        default:
            return "";
    }
}

});

parcelRegister("3TXkJ", function(module, exports) {

$parcel$export(module.exports, "toDate", function () { return $d7456eee413da0f5$export$e67a095c620b86fe; });

var $goj4O = parcelRequire("goj4O");

var $dqNAr = parcelRequire("dqNAr");
function $d7456eee413da0f5$export$e67a095c620b86fe(dateLike) {
    if (dateLike === null || dateLike === undefined || (0, $goj4O.default)(dateLike)) // Return as is
    return dateLike;
    else if (typeof dateLike === "string") // Parse as ISO date string by default.
    // To support more formats, append them here.
    return (0, $dqNAr.default)(dateLike);
    else return new Date(dateLike);
}

});
parcelRegister("goj4O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $beedaf727514870c$export$2e2bcd8739ae039; });

var $kYqHr = parcelRequire("kYqHr");
function $beedaf727514870c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $beedaf727514870c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $beedaf727514870c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $beedaf727514870c$var$_typeof(obj);
}
function $beedaf727514870c$export$2e2bcd8739ae039(value) {
    (0, $kYqHr.default)(1, arguments);
    return value instanceof Date || $beedaf727514870c$var$_typeof(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

});

parcelRegister("dqNAr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c742af22e2868e3$export$2e2bcd8739ae039; });

var $9UOAF = parcelRequire("9UOAF");

var $kYqHr = parcelRequire("kYqHr");

var $bn0G6 = parcelRequire("bn0G6");
function $9c742af22e2868e3$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $kYqHr.default)(1, arguments);
    var additionalDigits = (0, $bn0G6.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
    if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) return new Date(NaN);
    var dateStrings = $9c742af22e2868e3$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9c742af22e2868e3$var$parseYear(dateStrings.date, additionalDigits);
        date = $9c742af22e2868e3$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9c742af22e2868e3$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9c742af22e2868e3$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9c742af22e2868e3$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9c742af22e2868e3$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9c742af22e2868e3$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9c742af22e2868e3$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9c742af22e2868e3$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9c742af22e2868e3$var$patterns.dateTimeDelimiter);
    var timeString; // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9c742af22e2868e3$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9c742af22e2868e3$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9c742af22e2868e3$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9c742af22e2868e3$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    var captures = dateString.match(regex); // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null; // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9c742af22e2868e3$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9c742af22e2868e3$var$dateRegex); // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9c742af22e2868e3$var$parseDateUnit(captures[1]);
    var month = $9c742af22e2868e3$var$parseDateUnit(captures[2]) - 1;
    var day = $9c742af22e2868e3$var$parseDateUnit(captures[3]);
    var week = $9c742af22e2868e3$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9c742af22e2868e3$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9c742af22e2868e3$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9c742af22e2868e3$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9c742af22e2868e3$var$validateDate(year, month, day) || !$9c742af22e2868e3$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9c742af22e2868e3$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9c742af22e2868e3$var$parseTime(timeString) {
    var captures = timeString.match($9c742af22e2868e3$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9c742af22e2868e3$var$parseTimeUnit(captures[1]);
    var minutes = $9c742af22e2868e3$var$parseTimeUnit(captures[2]);
    var seconds = $9c742af22e2868e3$var$parseTimeUnit(captures[3]);
    if (!$9c742af22e2868e3$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $9UOAF.millisecondsInHour) + minutes * (0, $9UOAF.millisecondsInMinute) + seconds * 1000;
}
function $9c742af22e2868e3$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $9c742af22e2868e3$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    var captures = timezoneString.match($9c742af22e2868e3$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === "+" ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9c742af22e2868e3$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $9UOAF.millisecondsInHour) + minutes * (0, $9UOAF.millisecondsInMinute));
}
function $9c742af22e2868e3$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
} // Validation functions
// February is null to handle the leap year (using ||)
var $9c742af22e2868e3$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9c742af22e2868e3$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9c742af22e2868e3$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9c742af22e2868e3$var$daysInMonths[month] || ($9c742af22e2868e3$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9c742af22e2868e3$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9c742af22e2868e3$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9c742af22e2868e3$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9c742af22e2868e3$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9c742af22e2868e3$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});
parcelRegister("9UOAF", function(module, exports) {

$parcel$export(module.exports, "millisecondsInMinute", function () { return $7380963cb1bad772$export$91246f0b9bd9beff; });
$parcel$export(module.exports, "millisecondsInHour", function () { return $7380963cb1bad772$export$7f72910d6dfd237a; });
$parcel$export(module.exports, "millisecondsInSecond", function () { return $7380963cb1bad772$export$397c2d5776aa9055; });
$parcel$export(module.exports, "secondsInHour", function () { return $7380963cb1bad772$export$698aec755e92c695; });
$parcel$export(module.exports, "secondsInDay", function () { return $7380963cb1bad772$export$815a9362476d2fe3; });
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $7380963cb1bad772$export$dfd9b671c89acc8e = 7;
var $7380963cb1bad772$export$3913210603d8e9ae = 365.2425;
var $7380963cb1bad772$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $7380963cb1bad772$export$91246f0b9bd9beff = 60000;
var $7380963cb1bad772$export$7f72910d6dfd237a = 3600000;
var $7380963cb1bad772$export$397c2d5776aa9055 = 1000;
var $7380963cb1bad772$export$4dec998e48f9c246 = -$7380963cb1bad772$export$81caae6e1cc7a622;
var $7380963cb1bad772$export$f2f5ae5a8e2d8f9f = 60;
var $7380963cb1bad772$export$3c58128db900d44e = 3;
var $7380963cb1bad772$export$80d7e435f744f319 = 12;
var $7380963cb1bad772$export$4db7641526e3241f = 4;
var $7380963cb1bad772$export$698aec755e92c695 = 3600;
var $7380963cb1bad772$export$a77c1a7ebebe2a5a = 60;
var $7380963cb1bad772$export$815a9362476d2fe3 = $7380963cb1bad772$export$698aec755e92c695 * 24;
var $7380963cb1bad772$export$34804a017b31e2fe = $7380963cb1bad772$export$815a9362476d2fe3 * 7;
var $7380963cb1bad772$export$7271e9e3478110d1 = $7380963cb1bad772$export$815a9362476d2fe3 * $7380963cb1bad772$export$3913210603d8e9ae;
var $7380963cb1bad772$export$8e6600bbdee7dabb = $7380963cb1bad772$export$7271e9e3478110d1 / 12;
var $7380963cb1bad772$export$be1dccf2de902d31 = $7380963cb1bad772$export$8e6600bbdee7dabb * 3;

});

parcelRegister("bn0G6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84725e53a012d70e$export$2e2bcd8739ae039; });
function $84725e53a012d70e$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});



parcelRegister("abDCk", function(module, exports) {

$parcel$export(module.exports, "formatDate", function () { return $98553689d417f205$export$3ae94a2503e890a1; });

var $98hJD = parcelRequire("98hJD");

var $2Zwka = parcelRequire("2Zwka");

var $3TXkJ = parcelRequire("3TXkJ");
function $98553689d417f205$export$3ae94a2503e890a1(date, dateFormat = "datetime-us") {
    const dateObj = (0, $3TXkJ.toDate)(date);
    if (!(0, $2Zwka.default)(dateObj)) return "Invalid Date";
    switch(dateFormat){
        case "date-au":
            return (0, $98hJD.default)(dateObj, "dd MMM yyyy");
        case "date-us-short":
            return (0, $98hJD.default)(dateObj, "MMM do");
        default:
            // datetime-us
            return (0, $98hJD.default)(dateObj, "MMMM do yyyy, h:mm:ss aaa");
    }
}
function $98553689d417f205$export$576e15b7e42e3f97(dateFormat = "datetime-us") {
    return $98553689d417f205$export$3ae94a2503e890a1(Date.now(), dateFormat);
}

});
parcelRegister("98hJD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a629e32cee395a0$export$2e2bcd8739ae039; });

var $2Zwka = parcelRequire("2Zwka");

var $6iB35 = parcelRequire("6iB35");

var $2vImn = parcelRequire("2vImn");

var $bKFGQ = parcelRequire("bKFGQ");

var $hIj9n = parcelRequire("hIj9n");

var $jrQ16 = parcelRequire("jrQ16");

var $gWoGA = parcelRequire("gWoGA");

var $bn0G6 = parcelRequire("bn0G6");

var $kYqHr = parcelRequire("kYqHr");

var $aG6hM = parcelRequire("aG6hM");

var $cQtpL = parcelRequire("cQtpL");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $6a629e32cee395a0$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $6a629e32cee395a0$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $6a629e32cee395a0$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $6a629e32cee395a0$var$doubleQuoteRegExp = /''/g;
var $6a629e32cee395a0$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $6a629e32cee395a0$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $kYqHr.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $aG6hM.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $cQtpL.default);
    var firstWeekContainsDate = (0, $bn0G6.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $bn0G6.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $2vImn.default)(dirtyDate);
    if (!(0, $2Zwka.default)(originalDate)) throw new RangeError("Invalid time value");
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $jrQ16.default)(originalDate);
    var utcDate = (0, $6iB35.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($6a629e32cee395a0$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $hIj9n.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($6a629e32cee395a0$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $6a629e32cee395a0$var$cleanEscapedString(substring);
        var formatter = (0, $bKFGQ.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $gWoGA.isProtectedWeekYearToken)(substring)) (0, $gWoGA.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $gWoGA.isProtectedDayOfYearToken)(substring)) (0, $gWoGA.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($6a629e32cee395a0$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $6a629e32cee395a0$var$cleanEscapedString(input) {
    var matched = input.match($6a629e32cee395a0$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($6a629e32cee395a0$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("2Zwka", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22da5a2def65b5e4$export$2e2bcd8739ae039; });

var $goj4O = parcelRequire("goj4O");

var $2vImn = parcelRequire("2vImn");

var $kYqHr = parcelRequire("kYqHr");
function $22da5a2def65b5e4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kYqHr.default)(1, arguments);
    if (!(0, $goj4O.default)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $2vImn.default)(dirtyDate);
    return !isNaN(Number(date));
}

});

parcelRegister("6iB35", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $496129a509d36142$export$2e2bcd8739ae039; });

var $77bYL = parcelRequire("77bYL");

var $kYqHr = parcelRequire("kYqHr");

var $bn0G6 = parcelRequire("bn0G6");
function $496129a509d36142$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kYqHr.default)(2, arguments);
    var amount = (0, $bn0G6.default)(dirtyAmount);
    return (0, $77bYL.default)(dirtyDate, -amount);
}

});
parcelRegister("77bYL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52e27aa1a333ab61$export$2e2bcd8739ae039; });

var $bn0G6 = parcelRequire("bn0G6");

var $2vImn = parcelRequire("2vImn");

var $kYqHr = parcelRequire("kYqHr");
function $52e27aa1a333ab61$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kYqHr.default)(2, arguments);
    var timestamp = (0, $2vImn.default)(dirtyDate).getTime();
    var amount = (0, $bn0G6.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});


parcelRegister("bKFGQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88e45458dace93f0$export$2e2bcd8739ae039; });

var $ebv5g = parcelRequire("ebv5g");

var $kRm12 = parcelRequire("kRm12");

var $8ZHGL = parcelRequire("8ZHGL");

var $bfYAP = parcelRequire("bfYAP");

var $5o8Ta = parcelRequire("5o8Ta");

var $5djf1 = parcelRequire("5djf1");

var $6SgN5 = parcelRequire("6SgN5");
var $88e45458dace93f0$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $88e45458dace93f0$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $6SgN5.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $5o8Ta.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $5djf1.default)(twoDigitYear, 2);
        } // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
         // Padding
        return (0, $5djf1.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $8ZHGL.default)(date); // Padding
        return (0, $5djf1.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $5djf1.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $5djf1.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $5djf1.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $6SgN5.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $5djf1.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $bfYAP.default)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $5djf1.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $kRm12.default)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $5djf1.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $6SgN5.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $ebv5g.default)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $5djf1.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $5djf1.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $5djf1.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $5djf1.default)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $88e45458dace93f0$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $88e45458dace93f0$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $88e45458dace93f0$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $88e45458dace93f0$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $88e45458dace93f0$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $88e45458dace93f0$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $6SgN5.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $6SgN5.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $5djf1.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $5djf1.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $6SgN5.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $6SgN5.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $6SgN5.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $88e45458dace93f0$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $88e45458dace93f0$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $88e45458dace93f0$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $88e45458dace93f0$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $88e45458dace93f0$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $88e45458dace93f0$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $88e45458dace93f0$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $88e45458dace93f0$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $88e45458dace93f0$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $88e45458dace93f0$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $5djf1.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $5djf1.default)(timestamp, token.length);
    }
};
function $88e45458dace93f0$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $5djf1.default)(minutes, 2);
}
function $88e45458dace93f0$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $5djf1.default)(Math.abs(offset) / 60, 2);
    }
    return $88e45458dace93f0$var$formatTimezone(offset, dirtyDelimiter);
}
function $88e45458dace93f0$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $5djf1.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $5djf1.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $88e45458dace93f0$export$2e2bcd8739ae039 = $88e45458dace93f0$var$formatters;

});
parcelRegister("ebv5g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a53a346903ce718e$export$2e2bcd8739ae039; });

var $2vImn = parcelRequire("2vImn");

var $kYqHr = parcelRequire("kYqHr");
var $a53a346903ce718e$var$MILLISECONDS_IN_DAY = 86400000;
function $a53a346903ce718e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kYqHr.default)(1, arguments);
    var date = (0, $2vImn.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $a53a346903ce718e$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("kRm12", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2f9d5c0a6bfa1b1$export$2e2bcd8739ae039; });

var $2vImn = parcelRequire("2vImn");

var $344CN = parcelRequire("344CN");

var $ewPo0 = parcelRequire("ewPo0");

var $kYqHr = parcelRequire("kYqHr");
var $f2f9d5c0a6bfa1b1$var$MILLISECONDS_IN_WEEK = 604800000;
function $f2f9d5c0a6bfa1b1$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kYqHr.default)(1, arguments);
    var date = (0, $2vImn.default)(dirtyDate);
    var diff = (0, $344CN.default)(date).getTime() - (0, $ewPo0.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $f2f9d5c0a6bfa1b1$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("344CN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23b5552c6d222a4e$export$2e2bcd8739ae039; });

var $2vImn = parcelRequire("2vImn");

var $kYqHr = parcelRequire("kYqHr");
function $23b5552c6d222a4e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kYqHr.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $2vImn.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("ewPo0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a93bea0e04ceff39$export$2e2bcd8739ae039; });

var $8ZHGL = parcelRequire("8ZHGL");

var $344CN = parcelRequire("344CN");

var $kYqHr = parcelRequire("kYqHr");
function $a93bea0e04ceff39$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kYqHr.default)(1, arguments);
    var year = (0, $8ZHGL.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $344CN.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("8ZHGL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68c5e8e422529b96$export$2e2bcd8739ae039; });

var $2vImn = parcelRequire("2vImn");

var $kYqHr = parcelRequire("kYqHr");

var $344CN = parcelRequire("344CN");
function $68c5e8e422529b96$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kYqHr.default)(1, arguments);
    var date = (0, $2vImn.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $344CN.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $344CN.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("bfYAP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $832018f092676fee$export$2e2bcd8739ae039; });

var $2vImn = parcelRequire("2vImn");

var $hIttq = parcelRequire("hIttq");

var $d8hjl = parcelRequire("d8hjl");

var $kYqHr = parcelRequire("kYqHr");
var $832018f092676fee$var$MILLISECONDS_IN_WEEK = 604800000;
function $832018f092676fee$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $kYqHr.default)(1, arguments);
    var date = (0, $2vImn.default)(dirtyDate);
    var diff = (0, $hIttq.default)(date, options).getTime() - (0, $d8hjl.default)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $832018f092676fee$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("hIttq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce5d6891272fc196$export$2e2bcd8739ae039; });

var $2vImn = parcelRequire("2vImn");

var $kYqHr = parcelRequire("kYqHr");

var $bn0G6 = parcelRequire("bn0G6");

var $aG6hM = parcelRequire("aG6hM");
function $ce5d6891272fc196$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $kYqHr.default)(1, arguments);
    var defaultOptions = (0, $aG6hM.getDefaultOptions)();
    var weekStartsOn = (0, $bn0G6.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $2vImn.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});
parcelRegister("aG6hM", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $7c62b3e04133988b$export$430a3269e24b912e; });
var $7c62b3e04133988b$var$defaultOptions = {};
function $7c62b3e04133988b$export$430a3269e24b912e() {
    return $7c62b3e04133988b$var$defaultOptions;
}
function $7c62b3e04133988b$export$95365be1b0704abc(newOptions) {
    $7c62b3e04133988b$var$defaultOptions = newOptions;
}

});


parcelRegister("d8hjl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98f9734c79df563b$export$2e2bcd8739ae039; });

var $5o8Ta = parcelRequire("5o8Ta");

var $kYqHr = parcelRequire("kYqHr");

var $hIttq = parcelRequire("hIttq");

var $bn0G6 = parcelRequire("bn0G6");

var $aG6hM = parcelRequire("aG6hM");
function $98f9734c79df563b$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $kYqHr.default)(1, arguments);
    var defaultOptions = (0, $aG6hM.getDefaultOptions)();
    var firstWeekContainsDate = (0, $bn0G6.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $5o8Ta.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $hIttq.default)(firstWeek, options);
    return date;
}

});
parcelRegister("5o8Ta", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ec616c724d5be0e$export$2e2bcd8739ae039; });

var $2vImn = parcelRequire("2vImn");

var $kYqHr = parcelRequire("kYqHr");

var $hIttq = parcelRequire("hIttq");

var $bn0G6 = parcelRequire("bn0G6");

var $aG6hM = parcelRequire("aG6hM");
function $3ec616c724d5be0e$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $kYqHr.default)(1, arguments);
    var date = (0, $2vImn.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $aG6hM.getDefaultOptions)();
    var firstWeekContainsDate = (0, $bn0G6.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $hIttq.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $hIttq.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("5djf1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3cbd1791e316d67c$export$2e2bcd8739ae039; });
function $3cbd1791e316d67c$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}

});

parcelRegister("6SgN5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5014cf874e05b5da$export$2e2bcd8739ae039; });

var $5djf1 = parcelRequire("5djf1");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $5014cf874e05b5da$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $5djf1.default)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $5djf1.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $5djf1.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $5djf1.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $5djf1.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $5djf1.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $5djf1.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $5djf1.default)(fractionalSeconds, token.length);
    }
};
var $5014cf874e05b5da$export$2e2bcd8739ae039 = $5014cf874e05b5da$var$formatters;

});


parcelRegister("hIj9n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce55668b87792c9b$export$2e2bcd8739ae039; });
var $ce55668b87792c9b$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $ce55668b87792c9b$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $ce55668b87792c9b$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $ce55668b87792c9b$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $ce55668b87792c9b$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $ce55668b87792c9b$var$timeLongFormatter(timePattern, formatLong));
};
var $ce55668b87792c9b$var$longFormatters = {
    p: $ce55668b87792c9b$var$timeLongFormatter,
    P: $ce55668b87792c9b$var$dateTimeLongFormatter
};
var $ce55668b87792c9b$export$2e2bcd8739ae039 = $ce55668b87792c9b$var$longFormatters;

});

parcelRegister("gWoGA", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $c555363dc7068147$export$c6cc36aa33304772; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $c555363dc7068147$export$c6b49d6dceb604a1; });
$parcel$export(module.exports, "throwProtectedError", function () { return $c555363dc7068147$export$8073c1ae88f0e727; });
var $c555363dc7068147$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $c555363dc7068147$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $c555363dc7068147$export$c6cc36aa33304772(token) {
    return $c555363dc7068147$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $c555363dc7068147$export$c6b49d6dceb604a1(token) {
    return $c555363dc7068147$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $c555363dc7068147$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("cQtpL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95a128811efa855f$export$2e2bcd8739ae039; });

var $j08XL = parcelRequire("j08XL");
var $95a128811efa855f$export$2e2bcd8739ae039 = (0, $j08XL.default);

});
parcelRegister("j08XL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd54f846ee73bde7$export$2e2bcd8739ae039; });

var $jnk62 = parcelRequire("jnk62");

var $e3Pzo = parcelRequire("e3Pzo");

var $03elU = parcelRequire("03elU");

var $58qOk = parcelRequire("58qOk");

var $69wHu = parcelRequire("69wHu");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $dd54f846ee73bde7$var$locale = {
    code: "en-US",
    formatDistance: (0, $jnk62.default),
    formatLong: (0, $e3Pzo.default),
    formatRelative: (0, $03elU.default),
    localize: (0, $58qOk.default),
    match: (0, $69wHu.default),
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $dd54f846ee73bde7$export$2e2bcd8739ae039 = $dd54f846ee73bde7$var$locale;

});
parcelRegister("jnk62", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1afc1072eb7a9df$export$2e2bcd8739ae039; });
var $e1afc1072eb7a9df$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $e1afc1072eb7a9df$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $e1afc1072eb7a9df$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $e1afc1072eb7a9df$export$2e2bcd8739ae039 = $e1afc1072eb7a9df$var$formatDistance;

});

parcelRegister("e3Pzo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3c959302cac5d94$export$2e2bcd8739ae039; });

var $eqBU9 = parcelRequire("eqBU9");
var $a3c959302cac5d94$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $a3c959302cac5d94$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $a3c959302cac5d94$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $a3c959302cac5d94$var$formatLong = {
    date: (0, $eqBU9.default)({
        formats: $a3c959302cac5d94$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $eqBU9.default)({
        formats: $a3c959302cac5d94$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $eqBU9.default)({
        formats: $a3c959302cac5d94$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $a3c959302cac5d94$export$2e2bcd8739ae039 = $a3c959302cac5d94$var$formatLong;

});
parcelRegister("eqBU9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a810e57ae975994d$export$2e2bcd8739ae039; });
function $a810e57ae975994d$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("03elU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $009b69fe9e1afe68$export$2e2bcd8739ae039; });
var $009b69fe9e1afe68$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $009b69fe9e1afe68$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $009b69fe9e1afe68$var$formatRelativeLocale[token];
};
var $009b69fe9e1afe68$export$2e2bcd8739ae039 = $009b69fe9e1afe68$var$formatRelative;

});

parcelRegister("58qOk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bd27f2cb5be192f$export$2e2bcd8739ae039; });

var $7Mn8I = parcelRequire("7Mn8I");
var $3bd27f2cb5be192f$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $3bd27f2cb5be192f$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $3bd27f2cb5be192f$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $3bd27f2cb5be192f$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $3bd27f2cb5be192f$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $3bd27f2cb5be192f$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $3bd27f2cb5be192f$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $3bd27f2cb5be192f$var$localize = {
    ordinalNumber: $3bd27f2cb5be192f$var$ordinalNumber,
    era: (0, $7Mn8I.default)({
        values: $3bd27f2cb5be192f$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $7Mn8I.default)({
        values: $3bd27f2cb5be192f$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $7Mn8I.default)({
        values: $3bd27f2cb5be192f$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $7Mn8I.default)({
        values: $3bd27f2cb5be192f$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $7Mn8I.default)({
        values: $3bd27f2cb5be192f$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $3bd27f2cb5be192f$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $3bd27f2cb5be192f$export$2e2bcd8739ae039 = $3bd27f2cb5be192f$var$localize;

});
parcelRegister("7Mn8I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a9ef71f9062c995$export$2e2bcd8739ae039; });
function $5a9ef71f9062c995$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("69wHu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47acf2fce39080d8$export$2e2bcd8739ae039; });

var $jkmpS = parcelRequire("jkmpS");

var $6tdNP = parcelRequire("6tdNP");
var $47acf2fce39080d8$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $47acf2fce39080d8$var$parseOrdinalNumberPattern = /\d+/i;
var $47acf2fce39080d8$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $47acf2fce39080d8$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $47acf2fce39080d8$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $47acf2fce39080d8$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $47acf2fce39080d8$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $47acf2fce39080d8$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $47acf2fce39080d8$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $47acf2fce39080d8$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $47acf2fce39080d8$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $47acf2fce39080d8$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $47acf2fce39080d8$var$match = {
    ordinalNumber: (0, $6tdNP.default)({
        matchPattern: $47acf2fce39080d8$var$matchOrdinalNumberPattern,
        parsePattern: $47acf2fce39080d8$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $jkmpS.default)({
        matchPatterns: $47acf2fce39080d8$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $47acf2fce39080d8$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $jkmpS.default)({
        matchPatterns: $47acf2fce39080d8$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $47acf2fce39080d8$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $jkmpS.default)({
        matchPatterns: $47acf2fce39080d8$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $47acf2fce39080d8$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $jkmpS.default)({
        matchPatterns: $47acf2fce39080d8$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $47acf2fce39080d8$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $jkmpS.default)({
        matchPatterns: $47acf2fce39080d8$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $47acf2fce39080d8$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $47acf2fce39080d8$export$2e2bcd8739ae039 = $47acf2fce39080d8$var$match;

});
parcelRegister("jkmpS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1214605c8a1f248$export$2e2bcd8739ae039; });
function $e1214605c8a1f248$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $e1214605c8a1f248$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $e1214605c8a1f248$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $e1214605c8a1f248$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $e1214605c8a1f248$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("6tdNP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b6028706ef56258$export$2e2bcd8739ae039; });
function $4b6028706ef56258$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});






parcelRegister("8OofD", function(module, exports) {

$parcel$export(module.exports, "formatDistanceToNow", function () { return $6efb9e398e1944cb$export$d130c20a256f8817; });

var $jdqnT = parcelRequire("jdqnT");
var $diwNJ = parcelRequire("diwNJ");
var $47b9l = parcelRequire("47b9l");
var $2Zwka = parcelRequire("2Zwka");
var $hknGy = parcelRequire("hknGy");
var $iZHSk = parcelRequire("iZHSk");
var $6A8ta = parcelRequire("6A8ta");
var $iSQ66 = parcelRequire("iSQ66");
var $leXe5 = parcelRequire("leXe5");
var $jMfZy = parcelRequire("jMfZy");

var $3TXkJ = parcelRequire("3TXkJ");
function $6efb9e398e1944cb$export$2c14ff85d6318973(date, baseDate, format = "default") {
    const dateObj = (0, $3TXkJ.toDate)(date);
    const baseObj = (0, $3TXkJ.toDate)(baseDate);
    if (!(0, $2Zwka.default)(dateObj) || !(0, $2Zwka.default)(baseObj)) return "Invalid Date";
    /** Positive, in seconds */ const diff = Math.abs((0, $jdqnT.default)(dateObj, baseObj));
    let prefix = (0, $47b9l.default)(baseObj, dateObj) ? "in " : "";
    const suffix = !(0, $47b9l.default)(baseObj, dateObj) ? " ago" : "";
    if (format === "short") prefix = "";
    // The moment formats outputs by a series of "ranges", i.e. "s", "ss", "m", ...
    if (diff <= 44) // s
    switch(format){
        case "short":
            return "just now";
        default:
            return `${prefix}a few seconds${suffix}`;
    }
    else if (diff <= 89) // m
    return `${prefix}a minute${suffix}`;
    else if (diff <= 2670) ;
    else if (diff <= 5370) // h
    return `${prefix}an hour${suffix}`;
    else if (diff <= 77400) ;
    else if (diff <= 127800) // d
    return `${prefix}a day${suffix}`;
    else if (diff <= 2203200) ;
    else if (diff <= 3931200) // M
    return `${prefix}a month${suffix}`;
    else if (diff <= 27604800) ;
    else if (diff <= 47304000) // y
    return `${prefix}a year${suffix}`;
    // else: yy, use default
    // Default date-fns format
    return `${prefix}${(0, $diwNJ.default)(dateObj, baseObj)}${suffix}`;
}
function $6efb9e398e1944cb$export$d130c20a256f8817(date, format = "default") {
    return $6efb9e398e1944cb$export$2c14ff85d6318973(date, Date.now(), format);
}
function $6efb9e398e1944cb$export$79a70b31aba0931c(timeAgo) {
    const parts = timeAgo.split(" ");
    const quantity = parseInt(parts[0], 10);
    const unit = parts[1];
    const now = new Date();
    let date;
    switch(unit){
        case "year":
        case "years":
            date = (0, $jMfZy.default)(now, quantity);
            break;
        case "month":
        case "months":
            date = (0, $iSQ66.default)(now, quantity);
            break;
        case "day":
        case "days":
            date = (0, $hknGy.default)(now, quantity);
            break;
        case "hour":
        case "hours":
            date = (0, $iZHSk.default)(now, quantity);
            break;
        case "minute":
        case "minutes":
            date = (0, $6A8ta.default)(now, quantity);
            break;
        case "second":
        case "seconds":
            date = (0, $leXe5.default)(now, quantity);
            break;
        default:
            throw new Error(`Unsupported time unit: ${unit}`);
    }
    return date;
}

});
parcelRegister("jdqnT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dfd3b29a7f6e791c$export$2e2bcd8739ae039; });

var $cwsqP = parcelRequire("cwsqP");

var $kYqHr = parcelRequire("kYqHr");

var $22StA = parcelRequire("22StA");
function $dfd3b29a7f6e791c$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $kYqHr.default)(2, arguments);
    var diff = (0, $cwsqP.default)(dateLeft, dateRight) / 1000;
    return (0, $22StA.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});
parcelRegister("cwsqP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91de872119e064f0$export$2e2bcd8739ae039; });

var $2vImn = parcelRequire("2vImn");

var $kYqHr = parcelRequire("kYqHr");
function $91de872119e064f0$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $kYqHr.default)(2, arguments);
    return (0, $2vImn.default)(dateLeft).getTime() - (0, $2vImn.default)(dateRight).getTime();
}

});

parcelRegister("22StA", function(module, exports) {

$parcel$export(module.exports, "getRoundingMethod", function () { return $17d60688afff1f8d$export$b6474a47258c1211; });
var $17d60688afff1f8d$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $17d60688afff1f8d$var$defaultRoundingMethod = "trunc";
function $17d60688afff1f8d$export$b6474a47258c1211(method) {
    return method ? $17d60688afff1f8d$var$roundingMap[method] : $17d60688afff1f8d$var$roundingMap[$17d60688afff1f8d$var$defaultRoundingMethod];
}

});


parcelRegister("diwNJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ae666671cc22c99$export$2e2bcd8739ae039; });

var $aG6hM = parcelRequire("aG6hM");

var $jrQ16 = parcelRequire("jrQ16");

var $87TDw = parcelRequire("87TDw");

var $2vImn = parcelRequire("2vImn");

var $8NTvx = parcelRequire("8NTvx");

var $ij9j5 = parcelRequire("ij9j5");

var $cQtpL = parcelRequire("cQtpL");

var $kYqHr = parcelRequire("kYqHr");
var $9ae666671cc22c99$var$MILLISECONDS_IN_MINUTE = 60000;
var $9ae666671cc22c99$var$MINUTES_IN_DAY = 1440;
var $9ae666671cc22c99$var$MINUTES_IN_MONTH = $9ae666671cc22c99$var$MINUTES_IN_DAY * 30;
var $9ae666671cc22c99$var$MINUTES_IN_YEAR = $9ae666671cc22c99$var$MINUTES_IN_DAY * 365;
function $9ae666671cc22c99$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale, _options$roundingMeth;
    (0, $kYqHr.default)(2, arguments);
    var defaultOptions = (0, $aG6hM.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $cQtpL.default);
    if (!locale.formatDistance) throw new RangeError("locale must contain localize.formatDistance property");
    var comparison = (0, $87TDw.default)(dirtyDate, dirtyBaseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    var localizeOptions = (0, $ij9j5.default)((0, $8NTvx.default)(options), {
        addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, $2vImn.default)(dirtyBaseDate);
        dateRight = (0, $2vImn.default)(dirtyDate);
    } else {
        dateLeft = (0, $2vImn.default)(dirtyDate);
        dateRight = (0, $2vImn.default)(dirtyBaseDate);
    }
    var roundingMethod = String((_options$roundingMeth = options === null || options === void 0 ? void 0 : options.roundingMethod) !== null && _options$roundingMeth !== void 0 ? _options$roundingMeth : "round");
    var roundingMethodFn;
    if (roundingMethod === "floor") roundingMethodFn = Math.floor;
    else if (roundingMethod === "ceil") roundingMethodFn = Math.ceil;
    else if (roundingMethod === "round") roundingMethodFn = Math.round;
    else throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
    var milliseconds = dateRight.getTime() - dateLeft.getTime();
    var minutes = milliseconds / $9ae666671cc22c99$var$MILLISECONDS_IN_MINUTE;
    var timezoneOffset = (0, $jrQ16.default)(dateRight) - (0, $jrQ16.default)(dateLeft); // Use DST-normalized difference in minutes for years, months and days;
    // use regular difference in minutes for hours, minutes and seconds.
    var dstNormalizedMinutes = (milliseconds - timezoneOffset) / $9ae666671cc22c99$var$MILLISECONDS_IN_MINUTE;
    var defaultUnit = options === null || options === void 0 ? void 0 : options.unit;
    var unit;
    if (!defaultUnit) {
        if (minutes < 1) unit = "second";
        else if (minutes < 60) unit = "minute";
        else if (minutes < $9ae666671cc22c99$var$MINUTES_IN_DAY) unit = "hour";
        else if (dstNormalizedMinutes < $9ae666671cc22c99$var$MINUTES_IN_MONTH) unit = "day";
        else if (dstNormalizedMinutes < $9ae666671cc22c99$var$MINUTES_IN_YEAR) unit = "month";
        else unit = "year";
    } else unit = String(defaultUnit);
     // 0 up to 60 seconds
    if (unit === "second") {
        var seconds = roundingMethodFn(milliseconds / 1000);
        return locale.formatDistance("xSeconds", seconds, localizeOptions); // 1 up to 60 mins
    } else if (unit === "minute") {
        var roundedMinutes = roundingMethodFn(minutes);
        return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions); // 1 up to 24 hours
    } else if (unit === "hour") {
        var hours = roundingMethodFn(minutes / 60);
        return locale.formatDistance("xHours", hours, localizeOptions); // 1 up to 30 days
    } else if (unit === "day") {
        var days = roundingMethodFn(dstNormalizedMinutes / $9ae666671cc22c99$var$MINUTES_IN_DAY);
        return locale.formatDistance("xDays", days, localizeOptions); // 1 up to 12 months
    } else if (unit === "month") {
        var months = roundingMethodFn(dstNormalizedMinutes / $9ae666671cc22c99$var$MINUTES_IN_MONTH);
        return months === 12 && defaultUnit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months, localizeOptions); // 1 year up to max Date
    } else if (unit === "year") {
        var years = roundingMethodFn(dstNormalizedMinutes / $9ae666671cc22c99$var$MINUTES_IN_YEAR);
        return locale.formatDistance("xYears", years, localizeOptions);
    }
    throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
}

});
parcelRegister("87TDw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5eaa2270159b436f$export$2e2bcd8739ae039; });

var $2vImn = parcelRequire("2vImn");

var $kYqHr = parcelRequire("kYqHr");
function $5eaa2270159b436f$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $kYqHr.default)(2, arguments);
    var dateLeft = (0, $2vImn.default)(dirtyDateLeft);
    var dateRight = (0, $2vImn.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1; // Return 0 if diff is 0; return NaN if diff is NaN
    else return diff;
}

});

parcelRegister("8NTvx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $668df4fc25ac4685$export$2e2bcd8739ae039; });

var $ij9j5 = parcelRequire("ij9j5");
function $668df4fc25ac4685$export$2e2bcd8739ae039(object) {
    return (0, $ij9j5.default)({}, object);
}

});
parcelRegister("ij9j5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d541387d23f70330$export$2e2bcd8739ae039; });
function $d541387d23f70330$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});



parcelRegister("47b9l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ff076fd2c7b0fb2$export$2e2bcd8739ae039; });

var $2vImn = parcelRequire("2vImn");

var $kYqHr = parcelRequire("kYqHr");
function $2ff076fd2c7b0fb2$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $kYqHr.default)(2, arguments);
    var date = (0, $2vImn.default)(dirtyDate);
    var dateToCompare = (0, $2vImn.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("hknGy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9d6ad5442d41265$export$2e2bcd8739ae039; });

var $dsSEm = parcelRequire("dsSEm");

var $kYqHr = parcelRequire("kYqHr");

var $bn0G6 = parcelRequire("bn0G6");
function $c9d6ad5442d41265$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kYqHr.default)(2, arguments);
    var amount = (0, $bn0G6.default)(dirtyAmount);
    return (0, $dsSEm.default)(dirtyDate, -amount);
}

});
parcelRegister("dsSEm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cd848376b1c03bb$export$2e2bcd8739ae039; });

var $bn0G6 = parcelRequire("bn0G6");

var $2vImn = parcelRequire("2vImn");

var $kYqHr = parcelRequire("kYqHr");
function $9cd848376b1c03bb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kYqHr.default)(2, arguments);
    var date = (0, $2vImn.default)(dirtyDate);
    var amount = (0, $bn0G6.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});


parcelRegister("iZHSk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd3ff53c3b44bbf1$export$2e2bcd8739ae039; });

var $3iqIF = parcelRequire("3iqIF");

var $kYqHr = parcelRequire("kYqHr");

var $bn0G6 = parcelRequire("bn0G6");
function $dd3ff53c3b44bbf1$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kYqHr.default)(2, arguments);
    var amount = (0, $bn0G6.default)(dirtyAmount);
    return (0, $3iqIF.default)(dirtyDate, -amount);
}

});
parcelRegister("3iqIF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2667c776e004dfd5$export$2e2bcd8739ae039; });

var $bn0G6 = parcelRequire("bn0G6");

var $77bYL = parcelRequire("77bYL");

var $kYqHr = parcelRequire("kYqHr");
var $2667c776e004dfd5$var$MILLISECONDS_IN_HOUR = 3600000;
function $2667c776e004dfd5$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kYqHr.default)(2, arguments);
    var amount = (0, $bn0G6.default)(dirtyAmount);
    return (0, $77bYL.default)(dirtyDate, amount * $2667c776e004dfd5$var$MILLISECONDS_IN_HOUR);
}

});


parcelRegister("6A8ta", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cacacbc03db363d$export$2e2bcd8739ae039; });

var $40swk = parcelRequire("40swk");

var $kYqHr = parcelRequire("kYqHr");

var $bn0G6 = parcelRequire("bn0G6");
function $4cacacbc03db363d$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kYqHr.default)(2, arguments);
    var amount = (0, $bn0G6.default)(dirtyAmount);
    return (0, $40swk.default)(dirtyDate, -amount);
}

});
parcelRegister("40swk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ead49188d607950$export$2e2bcd8739ae039; });

var $bn0G6 = parcelRequire("bn0G6");

var $77bYL = parcelRequire("77bYL");

var $kYqHr = parcelRequire("kYqHr");
var $2ead49188d607950$var$MILLISECONDS_IN_MINUTE = 60000;
function $2ead49188d607950$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kYqHr.default)(2, arguments);
    var amount = (0, $bn0G6.default)(dirtyAmount);
    return (0, $77bYL.default)(dirtyDate, amount * $2ead49188d607950$var$MILLISECONDS_IN_MINUTE);
}

});


parcelRegister("iSQ66", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbf5ae9e74ef7525$export$2e2bcd8739ae039; });

var $bn0G6 = parcelRequire("bn0G6");

var $5rhQ7 = parcelRequire("5rhQ7");

var $kYqHr = parcelRequire("kYqHr");
function $dbf5ae9e74ef7525$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kYqHr.default)(2, arguments);
    var amount = (0, $bn0G6.default)(dirtyAmount);
    return (0, $5rhQ7.default)(dirtyDate, -amount);
}

});
parcelRegister("5rhQ7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f5d4ff2325e9b54$export$2e2bcd8739ae039; });

var $bn0G6 = parcelRequire("bn0G6");

var $2vImn = parcelRequire("2vImn");

var $kYqHr = parcelRequire("kYqHr");
function $3f5d4ff2325e9b54$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kYqHr.default)(2, arguments);
    var date = (0, $2vImn.default)(dirtyDate);
    var amount = (0, $bn0G6.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});


parcelRegister("leXe5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f768d8da23a9cb5d$export$2e2bcd8739ae039; });

var $bn0G6 = parcelRequire("bn0G6");

var $2WtLU = parcelRequire("2WtLU");

var $kYqHr = parcelRequire("kYqHr");
function $f768d8da23a9cb5d$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kYqHr.default)(2, arguments);
    var amount = (0, $bn0G6.default)(dirtyAmount);
    return (0, $2WtLU.default)(dirtyDate, -amount);
}

});
parcelRegister("2WtLU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $224817957fba7c46$export$2e2bcd8739ae039; });

var $bn0G6 = parcelRequire("bn0G6");

var $77bYL = parcelRequire("77bYL");

var $kYqHr = parcelRequire("kYqHr");
function $224817957fba7c46$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kYqHr.default)(2, arguments);
    var amount = (0, $bn0G6.default)(dirtyAmount);
    return (0, $77bYL.default)(dirtyDate, amount * 1000);
}

});


parcelRegister("jMfZy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e65ee7a800c9af5f$export$2e2bcd8739ae039; });

var $bn0G6 = parcelRequire("bn0G6");

var $1qDMf = parcelRequire("1qDMf");

var $kYqHr = parcelRequire("kYqHr");
function $e65ee7a800c9af5f$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kYqHr.default)(2, arguments);
    var amount = (0, $bn0G6.default)(dirtyAmount);
    return (0, $1qDMf.default)(dirtyDate, -amount);
}

});
parcelRegister("1qDMf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10a713193b2b2e87$export$2e2bcd8739ae039; });

var $bn0G6 = parcelRequire("bn0G6");

var $5rhQ7 = parcelRequire("5rhQ7");

var $kYqHr = parcelRequire("kYqHr");
function $10a713193b2b2e87$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kYqHr.default)(2, arguments);
    var amount = (0, $bn0G6.default)(dirtyAmount);
    return (0, $5rhQ7.default)(dirtyDate, amount * 12);
}

});



parcelRegister("f9D66", function(module, exports) {
const $2366dfe3718d408a$var$isInvalidInput = (seconds)=>{
    return isNaN(seconds) || seconds === Infinity || seconds < 0;
};
function $2366dfe3718d408a$export$d68230bfd6a61736(seconds) {
    // Note: this is actually doing floor()!
    const totalSeconds = parseInt(`${seconds}`, 10);
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor(totalSeconds % 3600 / 60);
    const s = Math.floor(totalSeconds % 60);
    if (totalSeconds === 0 || $2366dfe3718d408a$var$isInvalidInput(totalSeconds)) return "0s";
    else return [
        h && `${h}h`,
        (m || h && s) && `${m}m`,
        s && `${s}s`
    ].filter(Boolean).join(" ");
}
function $2366dfe3718d408a$export$bc733b0c5cbb3e8a(first, second) {
    const seconds = (Number(new Date(second)) - Number(new Date(first))) / 1000;
    if ($2366dfe3718d408a$var$isInvalidInput(seconds)) return "0s";
    return $2366dfe3718d408a$export$d68230bfd6a61736(seconds);
}

});




parcelRegister("aV0k9", function(module, exports) {

$parcel$export(module.exports, "getKeyPairUrl", function () { return $986fd071d2d91096$export$61a604959a920616; });
$parcel$export(module.exports, "getKeyPairGenerateUrl", function () { return $986fd071d2d91096$export$e41f04e70cc39594; });
$parcel$export(module.exports, "loadPipelinesRepositoryKeyPairResource", function () { return $986fd071d2d91096$export$ff645601e977ef75; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");
parcelRequire("e9n2v");
var $a63fp = parcelRequire("a63fp");

var $k2cPS = parcelRequire("k2cPS");

var $fEutT = parcelRequire("fEutT");
const $986fd071d2d91096$export$61a604959a920616 = (params)=>{
    const { repositoryFullSlug: repositoryFullSlug = `${params.repositoryOwner}/${params.repositorySlug}` } = params;
    return `${(0, $fEutT.default)()}/repositories/${repositoryFullSlug}/pipelines_config/ssh/key_pair`;
};
const $986fd071d2d91096$export$e41f04e70cc39594 = (params)=>{
    const { repositoryFullSlug: repositoryFullSlug = `${params.repositoryOwner}/${params.repositorySlug}` } = params;
    return `${(0, $fEutT.default)("/!api/internal")}/repositories/${repositoryFullSlug}/pipelines_config/ssh/key_pair/generate`;
};
const $986fd071d2d91096$export$ff645601e977ef75 = (0, $3kfkg.createResource)({
    type: "pipelinesRepositoryKeyPair",
    getKey: ({ match: match })=>$986fd071d2d91096$export$61a604959a920616(match.params),
    maxAge: 60000,
    // cache for 1 minute so navigating between pages is fast
    getData: async ({ match: match })=>new (0, $a63fp.KeyPair)(await (await fetch((0, $k2cPS.default)($986fd071d2d91096$export$61a604959a920616(match.params)))).json())
});

});

parcelRegister("Wsnex", function(module, exports) {

$parcel$export(module.exports, "loadPipelinesRepositoryKnownHostsResource", function () { return $22247e52ed6b4660$export$8f405902e3a48039; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $k2cPS = parcelRequire("k2cPS");

var $i3LMs = parcelRequire("i3LMs");

var $1aY9h = parcelRequire("1aY9h");
const $22247e52ed6b4660$export$8f405902e3a48039 = (0, $3kfkg.createResource)({
    type: "pipelinesRepositoryKnownHosts",
    getKey: ({ match: match, query: query })=>(0, $1aY9h.getKnownHostsRepoUrl)({
            page: 1,
            pagelen: (0, $i3LMs.KNOWN_HOSTS_PAGELEN),
            ...match.params,
            ...query
        }),
    maxAge: 60000,
    // cache for 1 minute so navigating between pages is fast
    getData: async ({ match: match, query: query })=>{
        const data = await (await fetch((0, $k2cPS.default)((0, $1aY9h.getKnownHostsRepoUrl)({
            page: 1,
            pagelen: (0, $i3LMs.KNOWN_HOSTS_PAGELEN),
            ...match.params,
            ...query
        })))).json();
        return {
            ...data,
            values: data.values.map((0, $1aY9h.parseKnownHost))
        };
    }
});

});
parcelRegister("1aY9h", function(module, exports) {

$parcel$export(module.exports, "getKnownHostsRepoUrl", function () { return $c22365d05ff83311$export$7d0811aa11b4a4f3; });
$parcel$export(module.exports, "getPublicKeyUrl", function () { return $c22365d05ff83311$export$7928259e1b87aae8; });
$parcel$export(module.exports, "formatHostname", function () { return $c22365d05ff83311$export$3d76dc807e58f123; });
$parcel$export(module.exports, "parseKnownHost", function () { return $c22365d05ff83311$export$c4fbae9fe97b3aaf; });
parcelRequire("e9n2v");
var $j15SL = parcelRequire("j15SL");

var $i3LMs = parcelRequire("i3LMs");

var $jUzO7 = parcelRequire("jUzO7");

var $fEutT = parcelRequire("fEutT");
const $c22365d05ff83311$export$7d0811aa11b4a4f3 = ({ repositoryFullSlug: repositoryFullSlug, repositoryOwner: repositoryOwner, repositorySlug: repositorySlug, page: page, pagelen: pagelen, uuid: uuid })=>{
    const repoPath = repositoryFullSlug || `${repositoryOwner}/${repositorySlug}`;
    return (0, $jUzO7.getKnownHostsUrl)(`${(0, $fEutT.default)()}/repositories/${repoPath}`, page, pagelen, uuid);
};
const $c22365d05ff83311$export$7928259e1b87aae8 = (params, hostname)=>{
    const { repositoryFullSlug: repositoryFullSlug = `${params.repositoryOwner}/${params.repositorySlug}` } = params;
    return `${(0, $fEutT.default)("/!api/internal")}/repositories/${repositoryFullSlug}/pipelines_config/ssh/public_keys/${$c22365d05ff83311$export$3d76dc807e58f123(hostname)}`;
};
function $c22365d05ff83311$export$c4fbae9fe97b3aaf(knownHostData) {
    let { hostname: hostname } = knownHostData;
    const matches = knownHostData.hostname.match((0, $i3LMs.HOSTNAME_PORT_INBOUND_REGEX));
    if (matches !== null && matches.length === 3) {
        // matches[0] is the whole match without groups
        const hostAddress = matches[1];
        const port = matches[2];
        hostname = `${hostAddress}:${port}`;
    }
    return new (0, $j15SL.KnownHost)({
        ...knownHostData,
        hostname: hostname
    });
}
function $c22365d05ff83311$export$3d76dc807e58f123(hostname) {
    let formattedHostname = hostname;
    const matches = hostname.match((0, $i3LMs.HOSTNAME_PORT_OUTBOUND_REGEX));
    if (matches && matches.length === 3) {
        const hostAddress = matches[1];
        const port = matches[2];
        if (!(hostAddress.startsWith("[") && hostAddress.endsWith("]"))) formattedHostname = `[${hostAddress}]:${port}`;
    }
    return formattedHostname;
}
function $c22365d05ff83311$export$66a987555d641c0c(knownHosts, filter) {
    switch(filter){
        case "visible":
            return knownHosts.filter(({ uuid: uuid, isSyncing: isSyncing })=>!!uuid || !uuid && isSyncing);
        case "created":
            return knownHosts[0];
        default:
            return knownHosts;
    }
}

});


parcelRegister("kndtw", function(module, exports) {

$parcel$export(module.exports, "loadPipelineCreatorsResource", function () { return $e282fed6914d745c$export$2ed8b352b781014f; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");
parcelRequire("hw8PW");
var $7JtYi = parcelRequire("7JtYi");

var $i3LMs = parcelRequire("i3LMs");

var $jPcDa = parcelRequire("jPcDa");

var $5E3NZ = parcelRequire("5E3NZ");

var $6t17p = parcelRequire("6t17p");
const $e282fed6914d745c$export$94df0e59ebebf4a7 = (params)=>{
    return (0, $5E3NZ.getPipelinesUrl)(params.repositoryFullSlug, {
        pagelen: (0, $i3LMs.PIPELINE_CREATORS_PAGE_SIZE),
        fields: "-values.*,+values.creator,+values.trigger"
    });
};
const $e282fed6914d745c$export$2ed8b352b781014f = (0, $3kfkg.createResource)({
    type: "pipeline-creators",
    getKey: ({ match: { params: params } })=>$e282fed6914d745c$export$94df0e59ebebf4a7(params),
    maxAge: 0,
    getData: async ({ match: { params: params } }, { reduxStore: reduxStore, appData: appData })=>{
        if (!(appData !== null && appData !== void 0 && appData.features[(0, $7JtYi.FeatureKeys).isPipelinesPageLoadOptimisationEnabled])) return null;
        const { dispatch: dispatch } = reduxStore;
        const data = await (0, $6t17p.fetchData)($e282fed6914d745c$export$94df0e59ebebf4a7(params), "pipeline_creators_resource_exception");
        dispatch((0, $jPcDa.setPipelineCreators)(data));
        return {
            status: "success"
        };
    }
});

});

parcelRegister("32AKt", function(module, exports) {

$parcel$export(module.exports, "loadPipelineDefinitionsResource", function () { return $b859f38e9159615e$export$a400a1ba140f3c19; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");
parcelRequire("hw8PW");
var $7JtYi = parcelRequire("7JtYi");

var $jPcDa = parcelRequire("jPcDa");

var $5E3NZ = parcelRequire("5E3NZ");

var $6t17p = parcelRequire("6t17p");
const $b859f38e9159615e$export$1b1f13aa363a43a2 = (params)=>{
    return `/!api/2.0/repositories/${params.repositoryFullSlug}/refs/branches/${params.branch}`;
};
const $b859f38e9159615e$export$a55900bc0f90d964 = (params, ref)=>{
    return (0, $5E3NZ.getPipelineDefinitionsUrl)(params.repositoryFullSlug, ref);
};
const $b859f38e9159615e$export$a400a1ba140f3c19 = (0, $3kfkg.createResource)({
    type: "pipeline-definitions",
    getKey: ({ match: { params: params } })=>$b859f38e9159615e$export$1b1f13aa363a43a2(params),
    maxAge: 0,
    getData: async ({ match: { params: params } }, { reduxStore: reduxStore, appData: appData })=>{
        var _branchData$target;
        if (!(appData !== null && appData !== void 0 && appData.features[(0, $7JtYi.FeatureKeys).isPipelinesPageLoadOptimisationEnabled])) return null;
        if (!params.branch) return {
            status: "success"
        };
        const { dispatch: dispatch } = reduxStore;
        const branchData = await (0, $6t17p.fetchData)($b859f38e9159615e$export$1b1f13aa363a43a2(params), "pipeline_definitions_resource_exception");
        const definitionData = await (0, $6t17p.fetchData)($b859f38e9159615e$export$a55900bc0f90d964(params, (branchData === null || branchData === void 0 ? void 0 : (_branchData$target = branchData.target) === null || _branchData$target === void 0 ? void 0 : _branchData$target.hash) || branchData.name), "pipeline_definitions_resource_exception");
        dispatch((0, $jPcDa.setPipelineDefinitions)(definitionData));
        return {
            status: "success"
        };
    }
});

});

parcelRegister("jELvD", function(module, exports) {

$parcel$export(module.exports, "loadPipelineRunsResource", function () { return $183f4d3846a53f5c$export$936931368fe50705; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");
parcelRequire("hw8PW");
var $7JtYi = parcelRequire("7JtYi");

var $1OTh3 = parcelRequire("1OTh3");

var $6t17p = parcelRequire("6t17p");
const $183f4d3846a53f5c$export$94df0e59ebebf4a7 = (params)=>{
    return (0, $1OTh3.getPipelineRunsUrl)(params.repositoryFullSlug, params.pipelineUuid);
};
const $183f4d3846a53f5c$export$936931368fe50705 = (0, $3kfkg.createResource)({
    type: "pipeline-runs",
    getKey: ({ match: { params: params } })=>$183f4d3846a53f5c$export$94df0e59ebebf4a7(params),
    maxAge: 60000,
    getData: async ({ match: { params: params } }, { appData: appData })=>{
        if (!(appData !== null && appData !== void 0 && appData.features[(0, $7JtYi.FeatureKeys).isPipelinesPageLoadOptimisationEnabled])) return null;
        const data = await (0, $6t17p.fetchData)($183f4d3846a53f5c$export$94df0e59ebebf4a7(params), "pipeline_runs_resource_exception");
        const runs = (0, $1OTh3.getRunsFromResponse)(data);
        return (0, $1OTh3.sortRuns)(runs);
    }
});

});
parcelRegister("1OTh3", function(module, exports) {

$parcel$export(module.exports, "getPipelineRunsUrl", function () { return $669786040fe90bcf$export$25688ea42480c353; });
$parcel$export(module.exports, "getRunsFromResponse", function () { return $669786040fe90bcf$export$1756cb9fc4c6dfe9; });
$parcel$export(module.exports, "sortRuns", function () { return $669786040fe90bcf$export$7bfebf4c898e66f2; });
$parcel$export(module.exports, "usePipelineRuns", function () { return $669786040fe90bcf$export$cc6a7da2a5627c16; });

var $9nHZC = parcelRequire("9nHZC");

var $3XbtU = parcelRequire("3XbtU");

var $cJH1T = parcelRequire("cJH1T");

var $b7ZcK = parcelRequire("b7ZcK");
parcelRequire("lM4y8");
var $fM82h = parcelRequire("fM82h");

var $jELvD = parcelRequire("jELvD");

var $dyEnO = parcelRequire("dyEnO");

var $jzmnA = parcelRequire("jzmnA");

var $i3LMs = parcelRequire("i3LMs");
parcelRequire("e9n2v");
var $gB1lx = parcelRequire("gB1lx");

var $fEutT = parcelRequire("fEutT");

var $epUvI = parcelRequire("epUvI");
const $669786040fe90bcf$export$25688ea42480c353 = (repositoryFullSlug, pipelineRef, queryParams = {})=>{
    const allQueryParams = {
        page: 1,
        pagelen: (0, $i3LMs.PIPELINE_RUNS_PAGE_SIZE),
        // only fetch latest 10 runs
        fields: "+target.commit.message,+target.commit.summary.html,+target.*,+*",
        ...queryParams
    };
    return `${(0, $fEutT.default)("/!api/internal", "pipelines", true)}/repositories/${repositoryFullSlug}/pipelines/${pipelineRef}/runs?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(allQueryParams, {
        allowDots: true
    })}`;
};
const $669786040fe90bcf$export$1756cb9fc4c6dfe9 = (response)=>response.values.map((fetchedPipelineRun)=>new (0, $gB1lx.Pipeline)(fetchedPipelineRun));
const $669786040fe90bcf$export$7bfebf4c898e66f2 = (runs)=>runs.sort((a, b)=>{
        if (!a.completed_on) return -1;
        if (!b.completed_on) return 1;
        return b.completed_on.localeCompare(a.completed_on);
    });
function $669786040fe90bcf$export$cc6a7da2a5627c16({ repositoryFullSlug: repositoryFullSlug, pipeline: pipeline, isPipelinesPageLoadOptimisationEnabled: isPipelinesPageLoadOptimisationEnabled }) {
    const { data: resourceData, loading: resourceLoading, refresh: refreshResource, error: resourceError } = (0, $fM82h.useResource)((0, $jELvD.loadPipelineRunsResource));
    const [isLoading, setIsLoading] = (0, $9nHZC.useState)(true);
    const [pipelineRuns, setPipelineRuns] = (0, $9nHZC.useState)([]);
    const { formatMessage: formatMessage } = (0, $b7ZcK.default)();
    const { showErrorFlag: showErrorFlag } = (0, $dyEnO.useFlag)({
        enableForPdvs: true
    });
    const fetchPipelineRuns = (0, $9nHZC.useCallback)(async ()=>{
        try {
            if (!repositoryFullSlug || !(pipeline !== null && pipeline !== void 0 && pipeline.uuid)) {
                setPipelineRuns([]);
                setIsLoading(false);
                return;
            }
            setIsLoading(true);
            const url = $669786040fe90bcf$export$25688ea42480c353(repositoryFullSlug, pipeline === null || pipeline === void 0 ? void 0 : pipeline.uuid);
            const response = await (0, $jzmnA.request)(url);
            const runs = $669786040fe90bcf$export$1756cb9fc4c6dfe9(response);
            setPipelineRuns($669786040fe90bcf$export$7bfebf4c898e66f2(runs));
        } catch (e) {
            (0, $3XbtU.captureException)(e);
            showErrorFlag(formatMessage((0, $epUvI.messages).failedFetchErrorFlagMsg));
            setPipelineRuns([]);
        } finally{
            setIsLoading(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        repositoryFullSlug,
        pipeline === null || pipeline === void 0 ? void 0 : pipeline.uuid,
        pipeline === null || pipeline === void 0 ? void 0 : pipeline.status,
        showErrorFlag,
        formatMessage
    ]);
    (0, $9nHZC.useEffect)(()=>{
        if (!isPipelinesPageLoadOptimisationEnabled) fetchPipelineRuns();
    }, [
        fetchPipelineRuns,
        isPipelinesPageLoadOptimisationEnabled
    ]);
    if (isPipelinesPageLoadOptimisationEnabled) {
        if (resourceError) showErrorFlag(formatMessage((0, $epUvI.messages).failedFetchErrorFlagMsg));
        return {
            isLoading: resourceLoading,
            pipelineRuns: resourceData || [],
            resetPipelineRuns: refreshResource
        };
    }
    return {
        isLoading: isLoading,
        pipelineRuns: pipelineRuns,
        resetPipelineRuns: fetchPipelineRuns
    };
}

});
parcelRegister("epUvI", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $7ed9b44f8a82614e$export$defe85febe8b728c; });

var $agjvf = parcelRequire("agjvf");
const $7ed9b44f8a82614e$export$defe85febe8b728c = (0, $agjvf.defineMessages)({
    failedFetchErrorFlagMsg: {
        "id": "frontbucket.pipelines.hooks.pipelineRuns.fetch.errorFlagMsg",
        "defaultMessage": "Failed to fetch previous pipeline runs."
    }
});

});



parcelRegister("3iBXH", function(module, exports) {

$parcel$export(module.exports, "loadPipelinesResource", function () { return $3de45fcb8d2aa965$export$5989c06eb021fb16; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");
parcelRequire("hw8PW");
var $7JtYi = parcelRequire("7JtYi");

var $jPcDa = parcelRequire("jPcDa");

var $5E3NZ = parcelRequire("5E3NZ");

var $kMBn7 = parcelRequire("kMBn7");

var $6t17p = parcelRequire("6t17p");
const $3de45fcb8d2aa965$export$94df0e59ebebf4a7 = (params, url)=>{
    return (0, $5E3NZ.getPipelinesUrl)(params.repositoryFullSlug, (0, $kMBn7.buildPipelineFilterQuery)(params, url));
};
const $3de45fcb8d2aa965$export$5989c06eb021fb16 = (0, $3kfkg.createResource)({
    type: "pipelines",
    getKey: ({ match: { params: params, url: url } })=>$3de45fcb8d2aa965$export$94df0e59ebebf4a7(params, url),
    maxAge: 0,
    getData: async ({ match: { params: params, url: url } }, { reduxStore: reduxStore, appData: appData })=>{
        if (!(appData !== null && appData !== void 0 && appData.features[(0, $7JtYi.FeatureKeys).isPipelinesPageLoadOptimisationEnabled])) return null;
        const { dispatch: dispatch } = reduxStore;
        dispatch((0, $jPcDa.removePipelinesData)());
        const data = await (0, $6t17p.fetchData)($3de45fcb8d2aa965$export$94df0e59ebebf4a7(params, url), "pipelines_resource_exception");
        dispatch((0, $jPcDa.setPipelines)(data));
        return {
            status: "success"
        };
    }
});

});
parcelRegister("kMBn7", function(module, exports) {

$parcel$export(module.exports, "getLocalStorageFilters", function () { return $4d0c81591061245e$export$869661958f84844a; });
$parcel$export(module.exports, "getLocalStorageFilterValue", function () { return $4d0c81591061245e$export$fde116206e9c9774; });
$parcel$export(module.exports, "setLocalStorageFilters", function () { return $4d0c81591061245e$export$c5d81b20c774934e; });
$parcel$export(module.exports, "buildPipelineFilterQuery", function () { return $4d0c81591061245e$export$a472b955c35362b3; });
$parcel$export(module.exports, "parseFilterPathParam", function () { return $4d0c81591061245e$export$d3934b49ddf40a0a; });
$parcel$export(module.exports, "buildFilterPathParam", function () { return $4d0c81591061245e$export$2401bf3187d45078; });
$parcel$export(module.exports, "getFilterQuery", function () { return $4d0c81591061245e$export$af27e998c5db692c; });
$parcel$export(module.exports, "getFilterPathname", function () { return $4d0c81591061245e$export$2c40cb5429599d66; });
parcelRequire("hw8PW");
var $7JtYi = parcelRequire("7JtYi");
var $l9p9x = parcelRequire("l9p9x");

var $5ILcF = parcelRequire("5ILcF");

var $h3kk7 = parcelRequire("h3kk7");
const $4d0c81591061245e$var$LOCAL_STORAGE_FILTER_KEY_PREFIX = "pipelines-filters";
const $4d0c81591061245e$export$869661958f84844a = (repositoryFullSlug)=>{
    const localStorageFilterKey = `${$4d0c81591061245e$var$LOCAL_STORAGE_FILTER_KEY_PREFIX}-${repositoryFullSlug}`;
    const localStorageFiltersString = (0, $h3kk7.default).get(localStorageFilterKey);
    if (!localStorageFiltersString) return null;
    return JSON.parse(localStorageFiltersString);
};
const $4d0c81591061245e$export$fde116206e9c9774 = (type, repositoryFullSlug)=>{
    var _getLocalStorageFilte;
    return ((_getLocalStorageFilte = $4d0c81591061245e$export$869661958f84844a(repositoryFullSlug)) === null || _getLocalStorageFilte === void 0 ? void 0 : _getLocalStorageFilte[type]) || null;
};
const $4d0c81591061245e$export$c5d81b20c774934e = (repositoryFullSlug, filters)=>{
    const localStorageFilterKey = `${$4d0c81591061245e$var$LOCAL_STORAGE_FILTER_KEY_PREFIX}-${repositoryFullSlug}`;
    const localStorageFiltersString = (0, $h3kk7.default).get(localStorageFilterKey);
    let localStorageFilters = {};
    if (localStorageFiltersString) localStorageFilters = JSON.parse(localStorageFiltersString);
    (0, $h3kk7.default).set(localStorageFilterKey, JSON.stringify({
        ...localStorageFilters,
        ...filters
    }));
};
function $4d0c81591061245e$export$a472b955c35362b3({ repositoryFullSlug: repositoryFullSlug, branch: branch, page: page }, url) {
    const filterQueries = {};
    let filters = $4d0c81591061245e$export$d3934b49ddf40a0a(url);
    const haveFilters = Object.values(filters).some((value)=>value !== null);
    const localStorageFilters = $4d0c81591061245e$export$869661958f84844a(repositoryFullSlug);
    if (!haveFilters && !!localStorageFilters) filters = localStorageFilters;
    if (branch) filterQueries["target.branch"] = decodeURIComponent(branch);
    if (branch && filters.selectedPipelineType) {
        const pipelineTypeAndPattern = filters.selectedPipelineType.split(/:(.+)/);
        let type;
        switch(pipelineTypeAndPattern[0].trim().toUpperCase()){
            case "BRANCHES":
                type = "BRANCH";
                break;
            case "PULL-REQUESTS":
                type = "PULLREQUESTS";
                break;
            default:
                type = pipelineTypeAndPattern[0].trim().toUpperCase();
        }
        filterQueries["target.selector.type"] = decodeURIComponent(type);
        if (pipelineTypeAndPattern.length > 1) filterQueries["target.selector.pattern"] = decodeURIComponent(pipelineTypeAndPattern[1].trim());
    }
    if (filters.selectedStatus) filterQueries.status = filters.selectedStatus.map((value)=>value.toUpperCase());
    if (filters.selectedTriggerType) filterQueries.trigger_type = filters.selectedTriggerType.toUpperCase();
    if (filters.uuid) filterQueries["creator.uuid"] = filters.uuid;
    return {
        ...filterQueries,
        page: (0, $5ILcF.getPageNumber)(page)
    };
}
function $4d0c81591061245e$export$2401bf3187d45078(filters, branch) {
    let selectedStatusQuery;
    let selectedTriggerTypeQuery;
    let selectedPipelineTypeQuery;
    let selectedCurrentUserBuildsQuery;
    if (filters && filters.selectedStatus) selectedStatusQuery = `status=${filters.selectedStatus}`;
    if (filters && filters.selectedTriggerType) selectedTriggerTypeQuery = `triggerType=${filters.selectedTriggerType}`;
    if (filters && filters.uuid) selectedCurrentUserBuildsQuery = `selectedUser=${filters.uuid}`;
    if (branch && filters && filters.selectedPipelineType) selectedPipelineTypeQuery = `pipelineType=${encodeURIComponent(filters.selectedPipelineType)}`;
    const path = "/filters/";
    const queries = [
        selectedStatusQuery,
        selectedTriggerTypeQuery,
        selectedPipelineTypeQuery,
        selectedCurrentUserBuildsQuery
    ].filter(Boolean).join("&");
    return queries ? `${path}[${queries}]` : "";
}
function $4d0c81591061245e$export$d3934b49ddf40a0a(path) {
    const filtersIndex = path.indexOf("/filters");
    if (filtersIndex === -1) return {
        selectedStatus: null,
        selectedTriggerType: null,
        uuid: null,
        selectedPipelineType: null
    };
    const isPipelineTypeHandleSpecialChars = (0, $l9p9x.getFlagValue)((0, $7JtYi.FeatureKeys).isPipelineTypeHandleSpecialChars, false);
    if (isPipelineTypeHandleSpecialChars) {
        var _findParamValue$split, _findParamValue;
        const filterPath = path.substring(filtersIndex);
        const filterQuery = filterPath.substring(filterPath.indexOf("[") + 1, filterPath.lastIndexOf("]"));
        const filters = filterQuery.split("&");
        const findParamValue = (paramName)=>{
            const param = filters.find((filter)=>filter.startsWith(`${paramName}=`));
            return param ? decodeURIComponent(param.split("=")[1]) : null;
        };
        return {
            selectedStatus: (_findParamValue$split = (_findParamValue = findParamValue("status")) === null || _findParamValue === void 0 ? void 0 : _findParamValue.split(",")) !== null && _findParamValue$split !== void 0 ? _findParamValue$split : null,
            selectedTriggerType: findParamValue("triggerType"),
            selectedPipelineType: findParamValue("pipelineType"),
            uuid: findParamValue("selectedUser")
        };
    }
    // Original parsing logic without decodeURIComponent
    const filterPath = decodeURIComponent(path).substring(filtersIndex);
    const filterQuery = filterPath.substring(filterPath.indexOf("[") + 1, filterPath.indexOf("]"));
    const filters = filterQuery.split("&");
    const selectedStatusOptional = filters.find((v)=>v.indexOf("status") !== -1);
    const selectedStatus = selectedStatusOptional ? selectedStatusOptional.split("=")[1].split(",") : null;
    const selectedTriggerTypeOptional = filters.find((v)=>v.indexOf("triggerType") !== -1);
    const selectedTriggerType = selectedTriggerTypeOptional ? selectedTriggerTypeOptional.split("=")[1] : null;
    const selectedPipelineTypeOptional = filters.find((v)=>v.indexOf("pipelineType") !== -1);
    const selectedPipelineType = selectedPipelineTypeOptional ? selectedPipelineTypeOptional.split("=")[1] : null;
    const selectedByUserOptional = filters.find((v)=>v.indexOf("selectedUser") !== -1);
    // Return the UUID here because the Avatars filter from filters component
    // expects to receive the UUID from the filters.
    const uuid = selectedByUserOptional ? selectedByUserOptional.split("=")[1] : null;
    return {
        selectedStatus: selectedStatus,
        selectedTriggerType: selectedTriggerType,
        selectedPipelineType: selectedPipelineType,
        uuid: uuid
    };
}
const $4d0c81591061245e$export$af27e998c5db692c = (pathname, branch)=>$4d0c81591061245e$export$2401bf3187d45078($4d0c81591061245e$export$d3934b49ddf40a0a(pathname), branch);
function $4d0c81591061245e$export$2c40cb5429599d66(page, pathname, branch) {
    const filterPath = $4d0c81591061245e$export$af27e998c5db692c(pathname, branch);
    if (branch) return `/results/branch/${encodeURIComponent(branch)}/page/${page}${filterPath}`;
    return `/results/page/${page}${filterPath}`;
}

});
parcelRegister("5ILcF", function(module, exports) {

$parcel$export(module.exports, "getPageNumber", function () { return $30b14fd1b3a2c5a3$export$c173ad1c1111eb41; });
const $30b14fd1b3a2c5a3$export$c173ad1c1111eb41 = (page)=>Number(page) || 1;

});



parcelRegister("3agw6", function(module, exports) {

$parcel$export(module.exports, "getPage", function () { return $91c89e9e5a954463$export$c2a6433281518c91; });
$parcel$export(module.exports, "REPOSITORY_RUNNERS_PAGE_QUERY_PARAM", function () { return $91c89e9e5a954463$export$6a13ed4227c395e5; });
$parcel$export(module.exports, "getRepositoryRunnersUrl", function () { return $91c89e9e5a954463$export$c16cf8707fa600b; });
$parcel$export(module.exports, "getRepositoryRunnerByUuidUrl", function () { return $91c89e9e5a954463$export$1b082139c8a8331b; });
$parcel$export(module.exports, "getRepositoryRunnerStateByUuidUrl", function () { return $91c89e9e5a954463$export$a9346a92bd09adc8; });
$parcel$export(module.exports, "WORKSPACE_RUNNERS_PAGE_QUERY_PARAM", function () { return $91c89e9e5a954463$export$d825088a7c74e5c7; });
$parcel$export(module.exports, "getWorkspaceRunnersUrl", function () { return $91c89e9e5a954463$export$7eb43459286c1fba; });
$parcel$export(module.exports, "getWorkspaceRunnerByUuidUrl", function () { return $91c89e9e5a954463$export$e2d135b428a69c9b; });
$parcel$export(module.exports, "getWorkspaceRunnerStateByUuidUrl", function () { return $91c89e9e5a954463$export$d31475a5b446ab85; });
$parcel$export(module.exports, "loadPipelinesRepositoryRunnersResource", function () { return $91c89e9e5a954463$export$9aed3c18a31a5f6e; });
$parcel$export(module.exports, "loadPipelinesWorkspaceRunnersResource", function () { return $91c89e9e5a954463$export$f5a22ef3900ed511; });

var $cJH1T = parcelRequire("cJH1T");
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $i3LMs = parcelRequire("i3LMs");
parcelRequire("e9n2v");
var $4FRgq = parcelRequire("4FRgq");

var $jzmnA = parcelRequire("jzmnA");

var $fEutT = parcelRequire("fEutT");

var $QgM08 = parcelRequire("QgM08");
function $91c89e9e5a954463$export$c2a6433281518c91(queryParamValue) {
    const page = parseInt(queryParamValue !== null && queryParamValue !== void 0 ? queryParamValue : "1", 10);
    if (Number.isNaN(page) || !Number.isFinite(page) || page <= 1) return 1;
    return page;
}
const $91c89e9e5a954463$export$6a13ed4227c395e5 = "repositoryRunnersPage";
function $91c89e9e5a954463$export$c16cf8707fa600b(params, query = {}) {
    const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug } = params;
    return `${(0, $fEutT.default)("/!api/internal")}/repositories/${repositoryOwner}/${repositorySlug}/pipelines-config/runners${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(query, {
        addQueryPrefix: true
    })}`;
}
function $91c89e9e5a954463$var$getRequestRepositoryRunnersUrl(params, query) {
    return $91c89e9e5a954463$export$c16cf8707fa600b(params, {
        page: $91c89e9e5a954463$export$c2a6433281518c91(query[$91c89e9e5a954463$export$6a13ed4227c395e5]),
        pagelen: (0, $i3LMs.RUNNERS_PAGELEN),
        sort: "-created_on"
    });
}
function $91c89e9e5a954463$export$1b082139c8a8331b(params, query = {}) {
    const { runnerUuid: runnerUuid } = params;
    return `${$91c89e9e5a954463$export$c16cf8707fa600b(params)}/${runnerUuid}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(query, {
        addQueryPrefix: true
    })}`;
}
function $91c89e9e5a954463$export$a9346a92bd09adc8(params, query = {}) {
    return `${$91c89e9e5a954463$export$1b082139c8a8331b(params)}/state${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(query, {
        addQueryPrefix: true
    })}`;
}
const $91c89e9e5a954463$export$d825088a7c74e5c7 = "workspaceRunnersPage";
function $91c89e9e5a954463$export$7eb43459286c1fba(params, query = {}) {
    const { workspaceSlug: workspaceSlug = params.repositoryOwner } = params;
    return `${(0, $fEutT.default)("/!api/internal")}/workspaces/${workspaceSlug}/pipelines-config/runners${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(query, {
        addQueryPrefix: true
    })}`;
}
function $91c89e9e5a954463$var$getRequestWorkspaceRunnersUrl(params, query) {
    return $91c89e9e5a954463$export$7eb43459286c1fba(params, {
        page: $91c89e9e5a954463$export$c2a6433281518c91(query[$91c89e9e5a954463$export$d825088a7c74e5c7]),
        pagelen: (0, $i3LMs.RUNNERS_PAGELEN),
        sort: "-created_on"
    });
}
function $91c89e9e5a954463$export$e2d135b428a69c9b(params, query = {}) {
    const { runnerUuid: runnerUuid } = params;
    return `${$91c89e9e5a954463$export$7eb43459286c1fba(params)}/${runnerUuid}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(query, {
        addQueryPrefix: true
    })}`;
}
function $91c89e9e5a954463$export$d31475a5b446ab85(params, query = {}) {
    return `${$91c89e9e5a954463$export$e2d135b428a69c9b(params)}/state${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(query, {
        addQueryPrefix: true
    })}`;
}
const $91c89e9e5a954463$var$UNDEFINED_RESPONSE = "response undefined";
function $91c89e9e5a954463$var$createRunnerResource({ getRequestUrl: getRequestUrl, type: type }) {
    return (0, $3kfkg.createResource)({
        type: type,
        getKey: ({ match: match, query: query })=>getRequestUrl(match.params, query),
        maxAge: 60000,
        getData: async ({ match: match, query: query })=>{
            try {
                const url = getRequestUrl(match.params, query);
                const resp = await (0, $jzmnA.request)(url);
                if (!resp) throw new Error($91c89e9e5a954463$var$UNDEFINED_RESPONSE);
                if (resp.type === "error") {
                    var _resp$error;
                    throw new Error((_resp$error = resp.error) === null || _resp$error === void 0 ? void 0 : _resp$error.message);
                }
                const { page: page, size: total, values: values } = resp;
                const runners = values === null || values === void 0 ? void 0 : values.map((data)=>new (0, $4FRgq.Runner)(data));
                return {
                    page: page,
                    runners: runners,
                    total: total
                };
            } catch (e) {
                if (!(0, $QgM08.isIgnoredErrorForSentry)(e)) throw e;
                return {
                    page: 1,
                    runners: [],
                    total: 0
                };
            }
        }
    });
}
const $91c89e9e5a954463$export$9aed3c18a31a5f6e = $91c89e9e5a954463$var$createRunnerResource({
    getRequestUrl: $91c89e9e5a954463$var$getRequestRepositoryRunnersUrl,
    type: "pipelinesRepositoryRunners"
});
const $91c89e9e5a954463$export$f5a22ef3900ed511 = $91c89e9e5a954463$var$createRunnerResource({
    getRequestUrl: $91c89e9e5a954463$var$getRequestWorkspaceRunnersUrl,
    type: "pipelinesWorkspaceRunners"
});

});

parcelRegister("3QVWH", function(module, exports) {

$parcel$export(module.exports, "loadShadowRepositoryConfigurationResource", function () { return $11b043f06ae6537c$export$4cf3f8a84a8cec52; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $k2cPS = parcelRequire("k2cPS");

var $iEdYc = parcelRequire("iEdYc");

var $3O4Ba = parcelRequire("3O4Ba");
const $11b043f06ae6537c$export$4cf3f8a84a8cec52 = (0, $3kfkg.createResource)({
    type: "shadowRepositoryConfiguration",
    getKey: ({ match: match })=>(0, $3O4Ba.getShadowRepositoryConfigurationUrl)(match.params),
    maxAge: 60000,
    // cache for 1 minute so navigating between pages is fast
    getData: async ({ match: match })=>{
        const url = (0, $3O4Ba.getShadowRepositoryConfigurationUrl)(match.params);
        const data = await (await fetch((0, $k2cPS.default)(url))).json();
        return new (0, $iEdYc.ShadowRepositoryConfiguration)(data);
    }
});

});
parcelRegister("iEdYc", function(module, exports) {

$parcel$export(module.exports, "ShadowRepositoryConfiguration", function () { return $2ae0a89bed4c31fb$export$88a9a451a8d83eef; });
class $2ae0a89bed4c31fb$export$683fc25c0e15f7b4 {
    constructor(props = {}){
        this.project = "";
        this.repository = "";
        this.enabled = false;
        Object.assign(this, props);
        Object.freeze(this);
    }
}
class $2ae0a89bed4c31fb$export$88a9a451a8d83eef {
    constructor(props = {}){
        this.branch_filter = "";
        this.release_branch_filter = "";
        this.webhook_config = void 0;
        Object.assign(this, props);
        Object.freeze(this);
    }
}

});

parcelRegister("3O4Ba", function(module, exports) {

$parcel$export(module.exports, "getShadowRepositoryConfigurationUrl", function () { return $0417c0ae42ffe666$export$949743a1f5b6d715; });

var $fEutT = parcelRequire("fEutT");
const $0417c0ae42ffe666$export$949743a1f5b6d715 = ({ repositoryFullSlug: repositoryFullSlug, repositoryOwner: repositoryOwner, repositorySlug: repositorySlug })=>{
    const repoPath = repositoryFullSlug || `${repositoryOwner}/${repositorySlug}`;
    return `${(0, $fEutT.default)("/!api/internal", "pipelines", true)}/repositories/${repoPath}/shadow-repository-configuration`;
};

});


parcelRegister("4pqRO", function(module, exports) {

$parcel$export(module.exports, "loadStepsResource", function () { return $0b27c7152d646f41$export$3734118c0d1613b4; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");
parcelRequire("hw8PW");
var $7JtYi = parcelRequire("7JtYi");

var $jPcDa = parcelRequire("jPcDa");

var $eDQOI = parcelRequire("eDQOI");

var $6t17p = parcelRequire("6t17p");
const $0b27c7152d646f41$export$94df0e59ebebf4a7 = (params, query)=>{
    return (0, $eDQOI.getStepsUrl)(params.repositoryFullSlug, params.pipelineUuid, query.run);
};
const $0b27c7152d646f41$export$3734118c0d1613b4 = (0, $3kfkg.createResource)({
    type: "steps",
    getKey: ({ match: { params: params }, query: query })=>$0b27c7152d646f41$export$94df0e59ebebf4a7(params, query),
    maxAge: 0,
    getData: async ({ match: { params: params }, query: query }, { reduxStore: reduxStore, appData: appData })=>{
        if (!(appData !== null && appData !== void 0 && appData.features[(0, $7JtYi.FeatureKeys).isPipelinesPageLoadOptimisationEnabled])) return null;
        const { dispatch: dispatch, getState: getState } = reduxStore;
        if ((0, $6t17p.hasFetchedSteps)(getState())) return {
            status: "success"
        };
        const data = await (0, $6t17p.fetchData)($0b27c7152d646f41$export$94df0e59ebebf4a7(params, query), "steps_resource_exception");
        dispatch((0, $jPcDa.setSteps)(data, params.stepUuid, query.run));
        return {
            status: "success"
        };
    }
});

});
parcelRegister("eDQOI", function(module, exports) {

$parcel$export(module.exports, "getStepsUrl", function () { return $02e2ac19d6c59c64$export$dd59fc60c001a84a; });
$parcel$export(module.exports, "stepsSaga", function () { return $02e2ac19d6c59c64$export$e814177e4f55deaf; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $cJH1T = parcelRequire("cJH1T");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");
parcelRequire("e9n2v");
var $goDEr = parcelRequire("goDEr");
var $eRckJ = parcelRequire("eRckJ");

var $90kWr = parcelRequire("90kWr");

var $aanBq = parcelRequire("aanBq");

var $k2cPS = parcelRequire("k2cPS");

var $i3LMs = parcelRequire("i3LMs");

var $fEutT = parcelRequire("fEutT");

var $QgM08 = parcelRequire("QgM08");

var $jPcDa = parcelRequire("jPcDa");

var $8K6h8 = parcelRequire("8K6h8");

var $jjTWw = parcelRequire("jjTWw");
const $02e2ac19d6c59c64$export$dd59fc60c001a84a = (repositoryFullSlug, pipelineUuid, pipelineRunUuid, queryParams = {})=>{
    const allQueryParams = {
        page: 1,
        pagelen: (0, $i3LMs.STEPS_PAGE_SIZE),
        fields: "+values.environment.*.*.*,+values.test_report.result.*",
        ...queryParams
    };
    if (pipelineRunUuid) return `${(0, $fEutT.default)("/!api/internal", "pipelines", true)}/repositories/${repositoryFullSlug}/pipelines/${pipelineUuid}/runs/${pipelineRunUuid}/steps?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(allQueryParams)}`;
    return `${(0, $fEutT.default)("/!api/internal")}/repositories/${repositoryFullSlug}/pipelines/${pipelineUuid}/steps/?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(allQueryParams)}`;
};
const $02e2ac19d6c59c64$export$98e0d8f274e464be = (repositoryFullSlug, pipelineUuid, stepUuid)=>{
    return `${(0, $fEutT.default)("/!api/internal")}/repositories/${repositoryFullSlug}/pipelines/${pipelineUuid}/steps/${stepUuid}/start_step`;
};
const $02e2ac19d6c59c64$export$8313784f02481bea = (repositoryFullSlug, pipelineUuid, queryParams = {})=>{
    return `${(0, $fEutT.default)("/!api/internal", "pipelines", true)}/repositories/${repositoryFullSlug}/pipelines/${pipelineUuid}/runs?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
        fields: "+target.commit.message,+target.commit.summary.html,+target.*,+*",
        ...queryParams
    })}`;
};
const $02e2ac19d6c59c64$export$9620678e38631c3c = (repositoryFullSlug, pipelineUuid, stepUuid)=>{
    return `${(0, $fEutT.default)("/!api/internal", "pipelines", true)}/repositories/${repositoryFullSlug}/pipelines/${pipelineUuid}/steps/${stepUuid}/redeploy?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
        fields: "+target.commit.message,+target.commit.summary.html,+target.*,+*"
    })}`;
};
const $02e2ac19d6c59c64$export$5746bad09ceb46b3 = (repositoryFullSlug, pipelineUuid, stepUuid)=>{
    return `${(0, $fEutT.default)("/!api/internal")}/repositories/${repositoryFullSlug}/pipelines/${pipelineUuid}/steps/${stepUuid}/log-ranges`;
};
const $02e2ac19d6c59c64$export$8fe7c10034906c2f = (repositoryFullSlug, pipelineUuid, stageIndex)=>{
    return $02e2ac19d6c59c64$export$8313784f02481bea(repositoryFullSlug, pipelineUuid, {
        stageIndex: stageIndex
    });
};
function* $02e2ac19d6c59c64$export$47dc4e9967f2c0f7(action) {
    const { stepUuid: stepUuid, pipelineRunUuid: pipelineRunUuid } = action.meta || action; // websocket is not grouping params in action
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const pipeline = yield (0, $5NpoY.a3)((0, $8K6h8.getCurrentPipeline)); // the pipeline when init the request
    const from_log_update_ws = (action.from_ws || false) && action.type === "LOG_UPDATED";
    if (!pipeline.uuid) return;
    try {
        const url = $02e2ac19d6c59c64$export$dd59fc60c001a84a(full_name, pipeline.uuid, pipelineRunUuid, {
            from_log_update_ws: from_log_update_ws
        });
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        const currPipeline = yield (0, $5NpoY.a3)((0, $8K6h8.getCurrentPipeline)); // the pipeline when tries to merge data into redux
        if (!currPipeline || currPipeline.uuid !== pipeline.uuid) return;
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_STEPS).SUCCESS,
            meta: {
                pipelineUuid: pipeline.uuid,
                stepUuid: stepUuid,
                pipelineRunUuid: pipelineRunUuid
            },
            payload: data
        });
        return;
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_STEPS).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_STEPS).ERROR,
            meta: {
                pipelineUuid: pipeline.uuid,
                stepUuid: stepUuid
            },
            payload: e
        });
    }
}
function* $02e2ac19d6c59c64$export$5a09c3ee31a94ea3(action) {
    var _action$meta;
    yield $02e2ac19d6c59c64$export$47dc4e9967f2c0f7(action);
    yield $02e2ac19d6c59c64$export$bb05aeee03290b37(action);
    if (typeof ((_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : _action$meta.callback) === "function") yield action.meta.callback();
}
function* $02e2ac19d6c59c64$export$26513d3523a303fc() {
    const fetchedBranchRestrictionsMap = yield (0, $5NpoY.a3)((0, $8K6h8.getFetchedStepBranchRestrictionsMap));
    const steps = Object.values((yield (0, $5NpoY.a3)((0, $8K6h8.getStepsMap))));
    const environmentUuids = steps.filter((step)=>step.hasEnvironment).filter((step)=>fetchedBranchRestrictionsMap[step.environmentUuid] !== (0, $90kWr.LoadingStatus).Success).map((step)=>step.environmentUuid);
    if (environmentUuids.length > 0) yield (0, $5NpoY.Y)({
        type: (0, $jPcDa.REQUEST_STEP_BRANCH_RESTRICTIONS).REQUEST,
        meta: {
            environmentUuids: environmentUuids
        }
    });
}
function* $02e2ac19d6c59c64$export$9eabd65ebd0963cd(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = $02e2ac19d6c59c64$export$98e0d8f274e464be(full_name, action.meta.pipelineUuid, action.meta.stepUuid);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "POST"
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_START_STEP).SUCCESS,
            meta: action.meta
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_START_STEP).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_START_STEP).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $02e2ac19d6c59c64$export$f4a1e51db63be33c(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const pipeline = yield (0, $5NpoY.a3)((0, $8K6h8.getCurrentPipeline));
    try {
        const url = $02e2ac19d6c59c64$export$8313784f02481bea(full_name, pipeline.uuid);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "POST"
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_RERUN_STEPS).SUCCESS,
            meta: action.meta,
            payload: data
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_RERUN_STEPS).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_RERUN_STEPS).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $02e2ac19d6c59c64$export$35a76e467e48aa45(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = $02e2ac19d6c59c64$export$9620678e38631c3c(full_name, action.meta.pipelineUuid, action.meta.stepUuid);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "POST"
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_REDEPLOY_STEP).SUCCESS,
            meta: action.meta,
            payload: data
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_REDEPLOY_STEP).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_REDEPLOY_STEP).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $02e2ac19d6c59c64$export$53ef082225a23357(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = $02e2ac19d6c59c64$export$8fe7c10034906c2f(full_name, action.meta.pipelineUuid, action.meta.stageIndex);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "POST"
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_RESUME_STAGE_REDEPLOY).SUCCESS,
            meta: action.meta,
            payload: data
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_RESUME_STAGE_REDEPLOY).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_RESUME_STAGE_REDEPLOY).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $02e2ac19d6c59c64$export$f3bdc748197f6aae(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const { pipelineUuid: pipelineUuid, stepUuid: stepUuid } = action.meta;
        const deploymentsUrl = (0, $jjTWw.getDeploymentDashboardUrl)(full_name);
        const stepDeploymentsUrl = (0, $jjTWw.getDeploymentByStepUrl)(full_name, pipelineUuid, stepUuid);
        const res = yield (0, $5NpoY._)([
            (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(deploymentsUrl)),
            (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(stepDeploymentsUrl))
        ]);
        for (const response of res){
            if (!response.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(response)));
        }
        const [environments, stepDeployments] = yield (0, $5NpoY._)(res.map((r)=>(0, $5NpoY.P)([
                r,
                "json"
            ])));
        const deployment = stepDeployments;
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_STEP_PROMOTION).SUCCESS,
            meta: action.meta,
            payload: {
                environments: environments,
                deployment: deployment
            }
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_STEP_PROMOTION).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_STEP_PROMOTION).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $02e2ac19d6c59c64$export$582a809b3745aab3(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        var _latestDeploymentUrlD;
        const { environmentUuid: environmentUuid, pipelineUuid: pipelineUuid, stepUuid: stepUuid } = action.meta;
        const deploymentUrl = (0, $jjTWw.getDeploymentByStepUrl)(full_name, pipelineUuid, stepUuid);
        const latestDeploymentUrl = (0, $jjTWw.getDeploymentsUrl)(full_name, {
            environment: environmentUuid,
            pagelen: 1,
            fields: "+values.*.*.*.*.*.*"
        });
        const res = yield (0, $5NpoY._)([
            (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(deploymentUrl)),
            (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(latestDeploymentUrl))
        ]);
        for (const response of res){
            if (!response.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(response)));
        }
        const [deploymentUrlData, latestDeploymentUrlData] = yield (0, $5NpoY._)(res.map((r)=>(0, $5NpoY.P)([
                r,
                "json"
            ])));
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_STEP_REDEPLOYMENT).SUCCESS,
            meta: action.meta,
            payload: {
                deployment: new (0, $goDEr.Deployment)(deploymentUrlData),
                lastSuccessfulDeployment: new (0, $goDEr.Deployment)((_latestDeploymentUrlD = latestDeploymentUrlData.values) === null || _latestDeploymentUrlD === void 0 ? void 0 : _latestDeploymentUrlD[0]),
                environment: new (0, $eRckJ.Environment)(deploymentUrlData === null || deploymentUrlData === void 0 ? void 0 : deploymentUrlData.environment)
            }
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_STEP_REDEPLOYMENT).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_STEP_REDEPLOYMENT).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $02e2ac19d6c59c64$export$471a61817f283014(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = (0, $jjTWw.getBranchRestrictionsUrl)(full_name);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "POST",
            headers: (0, $k2cPS.jsonHeaders),
            body: JSON.stringify({
                environmentUuids: action.meta.environmentUuids
            })
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_STEP_BRANCH_RESTRICTIONS).SUCCESS,
            meta: action.meta,
            payload: data
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_STEP_BRANCH_RESTRICTIONS).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_STEP_BRANCH_RESTRICTIONS).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $02e2ac19d6c59c64$export$bb05aeee03290b37(action) {
    const step = yield (0, $5NpoY.a3)((0, $8K6h8.getCurrentStep));
    if (!step) return;
    if (step.logV2Enabled) {
        var _action$meta2, _action$meta3;
        yield $02e2ac19d6c59c64$export$3e19b57b06d56ba5({
            ...action,
            meta: {
                stepUuid: ((_action$meta2 = action.meta) === null || _action$meta2 === void 0 ? void 0 : _action$meta2.stepUuid) || step.uuid
            }
        });
        if (typeof ((_action$meta3 = action.meta) === null || _action$meta3 === void 0 ? void 0 : _action$meta3.callback) === "function") yield action.meta.callback();
    } else yield $02e2ac19d6c59c64$export$47dc4e9967f2c0f7(action);
}
function* $02e2ac19d6c59c64$export$3e19b57b06d56ba5(action) {
    const { stepUuid: stepUuid } = action.meta || action; // websocket is not grouping params in action
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const pipeline = yield (0, $5NpoY.a3)((0, $8K6h8.getCurrentPipeline)); // the pipeline when init the request
    const pipelineUuid = pipeline.uuid || action.pipelineUuid;
    if (!pipelineUuid) return;
    try {
        const url = $02e2ac19d6c59c64$export$5746bad09ceb46b3(full_name, pipelineUuid, stepUuid);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_LOG_RANGES).SUCCESS,
            meta: {
                pipelineUuid: pipelineUuid,
                stepUuid: stepUuid
            },
            payload: data
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_LOG_RANGES).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_LOG_RANGES).ERROR,
            meta: {
                pipelineUuid: pipelineUuid,
                stepUuid: stepUuid
            },
            payload: e
        });
    }
}
function* $02e2ac19d6c59c64$export$e814177e4f55deaf() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_STEPS).REQUEST, $02e2ac19d6c59c64$export$47dc4e9967f2c0f7),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_STEPS).SUCCESS, $02e2ac19d6c59c64$export$26513d3523a303fc),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_STEP_BRANCH_RESTRICTIONS).REQUEST, $02e2ac19d6c59c64$export$471a61817f283014),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_START_STEP).REQUEST, $02e2ac19d6c59c64$export$9eabd65ebd0963cd),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_RERUN_STEPS).REQUEST, $02e2ac19d6c59c64$export$f4a1e51db63be33c),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_REDEPLOY_STEP).REQUEST, $02e2ac19d6c59c64$export$35a76e467e48aa45),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_RESUME_STAGE_REDEPLOY).REQUEST, $02e2ac19d6c59c64$export$53ef082225a23357),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_STEP_PROMOTION).REQUEST, $02e2ac19d6c59c64$export$f3bdc748197f6aae),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_STEP_REDEPLOYMENT).REQUEST, $02e2ac19d6c59c64$export$582a809b3745aab3),
        (0, $jeUNF.debounce)((0, $i3LMs.DELAY_STEP_UPDATED), (0, $jPcDa.STEP_UPDATED), $02e2ac19d6c59c64$export$47dc4e9967f2c0f7),
        (0, $jeUNF.debounce)((0, $i3LMs.DELAY_LOG_UPDATED), (0, $jPcDa.LOG_UPDATED), $02e2ac19d6c59c64$export$bb05aeee03290b37),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_STEP_LOG_RANGE).REQUEST, $02e2ac19d6c59c64$export$bb05aeee03290b37)
    ]);
}

});


parcelRegister("aIRDc", function(module, exports) {

$parcel$export(module.exports, "customMergeChecksConfigRouteResource", function () { return $66603f69390c10f6$export$b9a60f0f6c1d5efd; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");
parcelRequire("hw8PW");
var $7JtYi = parcelRequire("7JtYi");
parcelRequire("76btS");
var $eE4mZ = parcelRequire("eE4mZ");

var $gVgNk = parcelRequire("gVgNk");

var $djFfq = parcelRequire("djFfq");

var $kZnTB = parcelRequire("kZnTB");

var $3UXCH = parcelRequire("3UXCH");
const $66603f69390c10f6$export$b9a60f0f6c1d5efd = (0, $3kfkg.createResource)({
    type: "custom-merge-checks-configuration",
    getKey: ({ match: match })=>{
        // TODO: generate key based on route resource type
        const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug } = match.params;
        return `${repositoryOwner}/${repositorySlug}/custom-merge-checks`;
    },
    maxAge: 60000,
    // cache for 1 minute so navigating between pages is fast
    getData: async ({ match: match }, { reduxStore: reduxStore })=>{
        const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug } = match.params;
        if (!repositoryOwner || !repositorySlug) throw new Error("This resource must be rendered on a route that includes both :repositoryOwner and :repositorySlug");
        const state = reduxStore.getState();
        const stateMap = new Map();
        if (!(0, $3UXCH.getFeatures)(state)[(0, $7JtYi.FeatureKeys).extensibleMergeChecksEnabled]) return {
            branchConfigs: [],
            stateMap: stateMap
        };
        // TODO: Get resource type appropriate URL from route
        const { getBranchConfigs: getBranchConfigs, getCustomMergeChecks: getCustomMergeChecks } = (0, $eE4mZ.customMergeChecksConfigApi)((0, $kZnTB.default).api.internal.customMergeChecks(repositoryOwner, repositorySlug));
        const [branchConfigs, customMergeChecks] = await Promise.all([
            getBranchConfigs(),
            getCustomMergeChecks()
        ]);
        for (const customMergeCheck of customMergeChecks){
            const key = (0, $djFfq.customMergeCheckKey)(// TODO: Get resource type from route
            (0, $gVgNk.CustomMergeChecksResourceType).Repository, customMergeCheck.branchConfig, customMergeCheck.extensionId);
            stateMap.set(key, customMergeCheck.state);
        }
        return {
            branchConfigs: branchConfigs,
            stateMap: stateMap
        };
    }
});

});
parcelRegister("76btS", function(module, exports) {

$parcel$export(module.exports, "MergeChecksHeader", function () { return (parcelRequire("hIi6Z")).MergeChecksHeader; });
$parcel$export(module.exports, "CustomMergeChecksSettings", function () { return (parcelRequire("2MeA1")).CustomMergeChecksSettings; });
$parcel$export(module.exports, "customMergeChecksConfigApi", function () { return (parcelRequire("eE4mZ")).customMergeChecksConfigApi; });
$parcel$export(module.exports, "customMergeChecksConfigureApi", function () { return (parcelRequire("eE4mZ")).customMergeChecksConfigureApi; });
$parcel$export(module.exports, "CustomMergeChecksResourceType", function () { return (parcelRequire("gVgNk")).CustomMergeChecksResourceType; });
parcelRequire("dlefa");
var $hIi6Z = parcelRequire("hIi6Z");

var $2MeA1 = parcelRequire("2MeA1");

var $eE4mZ = parcelRequire("eE4mZ");

var $gVgNk = parcelRequire("gVgNk");

});
parcelRegister("dlefa", function(module, exports) {

$parcel$export(module.exports, "MergeChecksHeader", function () { return (parcelRequire("hIi6Z")).MergeChecksHeader; });

var $hIi6Z = parcelRequire("hIi6Z");

});
parcelRegister("hIi6Z", function(module, exports) {

$parcel$export(module.exports, "MergeChecksHeader", function () { return $1072fe60e05e50cd$export$d2043208c88ad4f8; });

var $9nHZC = parcelRequire("9nHZC");

var $b7ZcK = parcelRequire("b7ZcK");
parcelRequire("4tAgz");
var $gRBmM = parcelRequire("gRBmM");

var $6kA2y = parcelRequire("6kA2y");
const $1072fe60e05e50cd$export$d2043208c88ad4f8 = (props)=>{
    const { formatMessage: formatMessage } = (0, $b7ZcK.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $gRBmM.FocusedPageHeader), props, formatMessage((0, $6kA2y.messages).header));
};

});
parcelRegister("4tAgz", function(module, exports) {

$parcel$export(module.exports, "ScreenReadersOnly", function () { return (parcelRequire("kE3vy")).ScreenReadersOnly; });
$parcel$export(module.exports, "srOnlyStyles", function () { return (parcelRequire("kE3vy")).srOnlyStyles; });
$parcel$export(module.exports, "FocusedPageHeader", function () { return (parcelRequire("gRBmM")).FocusedPageHeader; });

var $kE3vy = parcelRequire("kE3vy");

var $gRBmM = parcelRequire("gRBmM");

});
parcelRegister("kE3vy", function(module, exports) {

$parcel$export(module.exports, "srOnlyStyles", function () { return $4987d0247d88476e$export$985486da8a52d34; });
$parcel$export(module.exports, "ScreenReadersOnly", function () { return $4987d0247d88476e$export$fadb922813d94a89; });

var $fPPqr = parcelRequire("fPPqr");

var $5vLfY = parcelRequire("5vLfY");

var $45CBz = parcelRequire("45CBz");

var $aP6k3 = parcelRequire("aP6k3");
const $4987d0247d88476e$export$985486da8a52d34 = /*#__PURE__*/ (0, $5vLfY.css)((0, $aP6k3.visuallyHidden)(), "");
const $4987d0247d88476e$export$fadb922813d94a89 = (props)=>/* eslint react/no-unknown-property: "warn" */ (0, $45CBz.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        css: (0, $aP6k3.visuallyHidden)
    }, props), props.children);

});
parcelRegister("5vLfY", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $40348128e6ee6942$export$a274e22fb40f762e; });
$parcel$export(module.exports, "css", function () { return $40348128e6ee6942$export$dbf350e5966cf602; });

var $7uo3e = parcelRequire("7uo3e");
var $40348128e6ee6942$var$_createEmotion = (0, $7uo3e.default)(), $40348128e6ee6942$export$4909b86c8034bf73 = $40348128e6ee6942$var$_createEmotion.flush, $40348128e6ee6942$export$fa8d919ba61d84db = $40348128e6ee6942$var$_createEmotion.hydrate, $40348128e6ee6942$export$a274e22fb40f762e = $40348128e6ee6942$var$_createEmotion.cx, $40348128e6ee6942$export$4950aa0f605343fb = $40348128e6ee6942$var$_createEmotion.merge, $40348128e6ee6942$export$95d99596f328fd52 = $40348128e6ee6942$var$_createEmotion.getRegisteredStyles, $40348128e6ee6942$export$efb9f5caaa2ca0c7 = $40348128e6ee6942$var$_createEmotion.injectGlobal, $40348128e6ee6942$export$d25ddfdf17c3ad3e = $40348128e6ee6942$var$_createEmotion.keyframes, $40348128e6ee6942$export$dbf350e5966cf602 = $40348128e6ee6942$var$_createEmotion.css, $40348128e6ee6942$export$995990c5c04c46f0 = $40348128e6ee6942$var$_createEmotion.sheet, $40348128e6ee6942$export$69a3209f1a06c04d = $40348128e6ee6942$var$_createEmotion.cache;

});
parcelRegister("7uo3e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $573dfdc6c083f35d$export$2e2bcd8739ae039; });

var $Wj6UC = parcelRequire("Wj6UC");

var $8RIvM = parcelRequire("8RIvM");

var $jgdi3 = parcelRequire("jgdi3");
function $573dfdc6c083f35d$var$insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert("", serialized, cache.sheet, true);
}
function $573dfdc6c083f35d$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $jgdi3.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $573dfdc6c083f35d$var$createEmotion = function createEmotion(options) {
    var cache = (0, $Wj6UC.default)(options); // $FlowFixMe
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $8RIvM.serializeStyles)(args, cache.registered, undefined);
        (0, $jgdi3.insertStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, $8RIvM.serializeStyles)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        $573dfdc6c083f35d$var$insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, $8RIvM.serializeStyles)(args, cache.registered);
        $573dfdc6c083f35d$var$insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $573dfdc6c083f35d$var$merge(cache.registered, css, $573dfdc6c083f35d$var$classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        // $FlowFixMe
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, $jgdi3.getRegisteredStyles).bind(null, cache.registered),
        merge: $573dfdc6c083f35d$var$merge.bind(null, cache.registered, css)
    };
};
var $573dfdc6c083f35d$var$classnames = function classnames(args) {
    var cls = "";
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
var $573dfdc6c083f35d$export$2e2bcd8739ae039 = $573dfdc6c083f35d$var$createEmotion;

});
parcelRegister("Wj6UC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0af43dd6dd3b27b0$export$2e2bcd8739ae039; });

var $fD7QD = parcelRequire("fD7QD");

var $iKiRq = parcelRequire("iKiRq");
parcelRequire("hhKuv");
// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var $0af43dd6dd3b27b0$var$delimiter = "/*|*/";
var $0af43dd6dd3b27b0$var$needle = $0af43dd6dd3b27b0$var$delimiter + "}";
function $0af43dd6dd3b27b0$var$toSheet(block) {
    if (block) $0af43dd6dd3b27b0$var$Sheet.current.insert(block + "}");
}
var $0af43dd6dd3b27b0$var$Sheet = {
    current: null
};
var $0af43dd6dd3b27b0$var$ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    $0af43dd6dd3b27b0$var$Sheet.current.insert(content + ";");
                    return "";
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return "";
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + $0af43dd6dd3b27b0$var$delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    $0af43dd6dd3b27b0$var$Sheet.current.insert(selectors[0] + content);
                    return "";
                default:
                    return content + (at === 0 ? $0af43dd6dd3b27b0$var$delimiter : "");
            }
        case -2:
            content.split($0af43dd6dd3b27b0$var$needle).forEach($0af43dd6dd3b27b0$var$toSheet);
    }
};
var $0af43dd6dd3b27b0$var$createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || "css";
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, $iKiRq.default)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(" ").forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)($0af43dd6dd3b27b0$var$ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        $0af43dd6dd3b27b0$var$Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, $fD7QD.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
var $0af43dd6dd3b27b0$export$2e2bcd8739ae039 = $0af43dd6dd3b27b0$var$createCache;

});

parcelRegister("8RIvM", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $6745cd0b35dd597b$export$6321afa313b251b5; });

var $b07Hm = parcelRequire("b07Hm");

var $f1zl2 = parcelRequire("f1zl2");

var $hZeKU = parcelRequire("hZeKU");
var $6745cd0b35dd597b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $6745cd0b35dd597b$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $6745cd0b35dd597b$var$hyphenateRegex = /[A-Z]|^ms/g;
var $6745cd0b35dd597b$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $6745cd0b35dd597b$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $6745cd0b35dd597b$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $6745cd0b35dd597b$var$processStyleName = (0, $hZeKU.default)(function(styleName) {
    return $6745cd0b35dd597b$var$isCustomProperty(styleName) ? styleName : styleName.replace($6745cd0b35dd597b$var$hyphenateRegex, "-$&").toLowerCase();
});
var $6745cd0b35dd597b$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($6745cd0b35dd597b$var$animationRegex, function(match, p1, p2) {
                $6745cd0b35dd597b$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $6745cd0b35dd597b$var$cursor
                };
                return p1;
            });
    }
    if ((0, $f1zl2.default)[key] !== 1 && !$6745cd0b35dd597b$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $6745cd0b35dd597b$var$contentValuePattern, $6745cd0b35dd597b$var$contentValues, $6745cd0b35dd597b$var$oldProcessStyleValue, $6745cd0b35dd597b$var$msPattern, $6745cd0b35dd597b$var$hyphenPattern, $6745cd0b35dd597b$var$hyphenatedCache;
var $6745cd0b35dd597b$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $6745cd0b35dd597b$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $6745cd0b35dd597b$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $6745cd0b35dd597b$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $6745cd0b35dd597b$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $6745cd0b35dd597b$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $6745cd0b35dd597b$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $6745cd0b35dd597b$var$cursor;
                var result = interpolation(mergedProps);
                $6745cd0b35dd597b$var$cursor = previousCursor;
                return $6745cd0b35dd597b$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $6745cd0b35dd597b$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $6745cd0b35dd597b$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($6745cd0b35dd597b$var$isProcessableValue(value)) string += $6745cd0b35dd597b$var$processStyleName(_key) + ":" + $6745cd0b35dd597b$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($6745cd0b35dd597b$var$isProcessableValue(value[_i])) string += $6745cd0b35dd597b$var$processStyleName(_key) + ":" + $6745cd0b35dd597b$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $6745cd0b35dd597b$var$handleInterpolation(mergedProps, registered, value, false);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $6745cd0b35dd597b$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $6745cd0b35dd597b$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $6745cd0b35dd597b$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $6745cd0b35dd597b$var$cursor;
var $6745cd0b35dd597b$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $6745cd0b35dd597b$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $6745cd0b35dd597b$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $6745cd0b35dd597b$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $6745cd0b35dd597b$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $6745cd0b35dd597b$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $b07Hm.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $6745cd0b35dd597b$var$cursor
    };
};

});
parcelRegister("f1zl2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af025c73ff2cdf91$export$2e2bcd8739ae039; });
var $af025c73ff2cdf91$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $af025c73ff2cdf91$export$2e2bcd8739ae039 = $af025c73ff2cdf91$var$unitlessKeys;

});





parcelRegister("gRBmM", function(module, exports) {

$parcel$export(module.exports, "FocusedPageHeader", function () { return $3a231824a7a3e814$export$c117cd31bd4bcb46; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $9ZSW0 = parcelRequire("9ZSW0");

var $5M9tF = parcelRequire("5M9tF");
const $3a231824a7a3e814$export$c117cd31bd4bcb46 = (props)=>{
    const headingRef = (0, $9nHZC.useRef)(null);
    (0, $9nHZC.useEffect)(()=>{
        if (headingRef && headingRef.current) headingRef.current.focus();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9ZSW0.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        disableTitleStyles: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5M9tF.StyledTitle), {
        "data-qa": "page-header",
        ref: headingRef,
        tabIndex: -1,
        truncate: props.truncateTitle
    }, props.children));
};

});
parcelRegister("9ZSW0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74746c706a4eb6fc$export$2e2bcd8739ae039; });
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $9nHZC = parcelRequire("9nHZC");

var $6rOtO = parcelRequire("6rOtO");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ var $74746c706a4eb6fc$var$PageHeader = function PageHeader(_ref) {
    var innerRef = _ref.innerRef, breadcrumbs = _ref.breadcrumbs, actions = _ref.actions, bottomBar = _ref.bottomBar, children = _ref.children, id = _ref.id, _ref$disableTitleStyl = _ref.disableTitleStyles, disableTitleStyles = _ref$disableTitleStyl === void 0 ? false : _ref$disableTitleStyl, _ref$truncateTitle = _ref.truncateTitle, truncateTitle = _ref$truncateTitle === void 0 ? false : _ref$truncateTitle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6rOtO.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6rOtO.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6rOtO.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6rOtO.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6rOtO.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6rOtO.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $74746c706a4eb6fc$export$2e2bcd8739ae039 = $74746c706a4eb6fc$var$PageHeader;

});
parcelRegister("6rOtO", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", function () { return $4b1c6bf04b6d25e9$export$edaaad985a878983; });
$parcel$export(module.exports, "StyledTitleWrapper", function () { return $4b1c6bf04b6d25e9$export$284be1ee64a3465c; });
$parcel$export(module.exports, "TitleWrapper", function () { return $4b1c6bf04b6d25e9$export$585a3b23e887288b; });
$parcel$export(module.exports, "TitleContainer", function () { return $4b1c6bf04b6d25e9$export$35e09ba17cc51c69; });
$parcel$export(module.exports, "ActionsWrapper", function () { return $4b1c6bf04b6d25e9$export$c8223871eecc8f3a; });
$parcel$export(module.exports, "BottomBarWrapper", function () { return $4b1c6bf04b6d25e9$export$6330225854c30dc; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $ztDwJ = parcelRequire("ztDwJ");

var $7ptNF = parcelRequire("7ptNF");
var $56gVi = parcelRequire("56gVi");

var $dCDrX = parcelRequire("dCDrX");
var $4b1c6bf04b6d25e9$var$truncateStyles = (0, $avKww.css)({
    overflowX: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $4b1c6bf04b6d25e9$var$outerStyles = (0, $avKww.css)({
    margin: "var(--ds-space-300, 24px)".concat(" 0 ", "var(--ds-space-200, 16px)", " 0")
});
var $4b1c6bf04b6d25e9$var$titleStyles = (0, $avKww.css)({
    color: "var(--ds-text, #172B4D)",
    font: 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    letterSpacing: "normal",
    marginBlockStart: 0,
    outline: "none"
});
var $4b1c6bf04b6d25e9$var$styledTitleStyles = (0, $avKww.css)({
    lineHeight: "var(--ds-font-lineHeight-500, 32px)",
    marginBlockStart: 0,
    outline: "none"
});
var $4b1c6bf04b6d25e9$var$titleWrapperStyles = (0, $avKww.css)({
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "wrap"
});
var $4b1c6bf04b6d25e9$var$titleWrapperTruncateStyles = (0, $avKww.css)({
    flexWrap: "nowrap"
});
var $4b1c6bf04b6d25e9$var$titleContainerStyles = (0, $avKww.css)({
    minWidth: 0,
    maxWidth: "100%",
    flex: "1 0 auto",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
var $4b1c6bf04b6d25e9$var$actionStyles = (0, $avKww.css)({
    maxWidth: "100%",
    flex: "0 0 auto",
    marginBlockEnd: "var(--ds-space-100, 8px)",
    marginInlineStart: "auto",
    paddingInlineStart: "var(--ds-space-400, 32px)",
    whiteSpace: "nowrap",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ">": {
        textAlign: "right"
    }
});
var $4b1c6bf04b6d25e9$var$titleContainerTruncateStyles = (0, $avKww.css)({
    flexShrink: 1
});
var $4b1c6bf04b6d25e9$var$bottomBarStyles = (0, $56gVi.xcss)({
    marginBlockStart: "space.200"
});
var $4b1c6bf04b6d25e9$export$edaaad985a878983 = function OuterWrapper(_ref) {
    var children = _ref.children;
    return (0, $avKww.jsx)("div", {
        css: $4b1c6bf04b6d25e9$var$outerStyles
    }, children);
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $4b1c6bf04b6d25e9$var$h700Styles = (0, $avKww.css)((0, $dCDrX.h700)());
var $4b1c6bf04b6d25e9$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function(_ref2, ref) {
    var children = _ref2.children, id = _ref2.id, truncateTitle = _ref2.truncateTitle;
    return (0, $avKww.jsx)("h1", {
        css: [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))((0, $ztDwJ.getBooleanFF)("platform.design-system-team.page-header-tokenised-typography-styles_lj1ix") ? [
            $4b1c6bf04b6d25e9$var$titleStyles
        ] : [
            $4b1c6bf04b6d25e9$var$h700Styles,
            $4b1c6bf04b6d25e9$var$styledTitleStyles
        ]), [
            truncateTitle && $4b1c6bf04b6d25e9$var$truncateStyles
        ]),
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
var $4b1c6bf04b6d25e9$export$585a3b23e887288b = function TitleWrapper(_ref3) {
    var children = _ref3.children, truncateTitle = _ref3.truncateTitle;
    return (0, $avKww.jsx)("div", {
        css: [
            $4b1c6bf04b6d25e9$var$titleWrapperStyles,
            truncateTitle && $4b1c6bf04b6d25e9$var$titleWrapperTruncateStyles
        ]
    }, children);
};
var $4b1c6bf04b6d25e9$export$35e09ba17cc51c69 = function TitleContainer(_ref4) {
    var children = _ref4.children, truncateTitle = _ref4.truncateTitle;
    return (0, $avKww.jsx)("div", {
        css: [
            $4b1c6bf04b6d25e9$var$titleContainerStyles,
            truncateTitle && $4b1c6bf04b6d25e9$var$titleContainerTruncateStyles
        ]
    }, children);
};
var $4b1c6bf04b6d25e9$export$c8223871eecc8f3a = function ActionsWrapper(_ref5) {
    var children = _ref5.children;
    return (0, $avKww.jsx)("div", {
        css: $4b1c6bf04b6d25e9$var$actionStyles
    }, children);
};
var $4b1c6bf04b6d25e9$export$6330225854c30dc = function BottomBarWrapper(_ref6) {
    var children = _ref6.children;
    return (0, $avKww.jsx)((0, $7ptNF.default), {
        xcss: $4b1c6bf04b6d25e9$var$bottomBarStyles
    }, children);
};

});
parcelRegister("ztDwJ", function(module, exports) {

$parcel$export(module.exports, "getBooleanFF", function () { return $06aa42326bddd1e2$export$470e5c2be1411c89; });

var $bKAwE = parcelRequire("bKAwE");
function $06aa42326bddd1e2$export$ba05d765b8392e5e(flagResolver) {
    (0, $bKAwE.setBooleanResolver)(flagResolver);
}
function $06aa42326bddd1e2$export$470e5c2be1411c89(name) {
    return (0, $bKAwE.resolveBooleanFlag)(name);
}
function $06aa42326bddd1e2$export$b40ec24ac8275656(name) {
    return (0, $bKAwE.resolveBooleanFlag)(name);
}

});
parcelRegister("bKAwE", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $88e052d4bd5e94d3$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $88e052d4bd5e94d3$export$6333b6aff9fc6275; });

var $bzuQU = parcelRequire("bzuQU");

var $8ovux = parcelRequire("8ovux");
var $88e052d4bd5e94d3$var$pkgName = "@atlaskit/platform-feature-flags";
var $88e052d4bd5e94d3$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $88e052d4bd5e94d3$var$hasProcessEnv = typeof $8ovux !== "undefined" && typeof $8ovux.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $88e052d4bd5e94d3$var$ENV_ENABLE_PLATFORM_FF = $88e052d4bd5e94d3$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $88e052d4bd5e94d3$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $88e052d4bd5e94d3$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $88e052d4bd5e94d3$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $88e052d4bd5e94d3$var$ENV_ENABLE_PLATFORM_FF || $88e052d4bd5e94d3$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $88e052d4bd5e94d3$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $88e052d4bd5e94d3$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$88e052d4bd5e94d3$var$globalVar[$88e052d4bd5e94d3$export$7e41b1b2bdee3f98] = $88e052d4bd5e94d3$var$globalVar[$88e052d4bd5e94d3$export$7e41b1b2bdee3f98] || $88e052d4bd5e94d3$var$DEFAULT_PFF_GLOBAL;
function $88e052d4bd5e94d3$export$f2b591175b3e424c(resolver) {
    $88e052d4bd5e94d3$var$globalVar[$88e052d4bd5e94d3$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $88e052d4bd5e94d3$export$6333b6aff9fc6275(flagKey) {
    if ($88e052d4bd5e94d3$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $bzuQU.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $88e052d4bd5e94d3$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $88e052d4bd5e94d3$var$globalVar[$88e052d4bd5e94d3$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("bzuQU", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $86cae540373503c0$export$1c9f709888824e05; });
var $86cae540373503c0$var$_ref, $86cae540373503c0$var$_process, $86cae540373503c0$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $86cae540373503c0$var$TESTS_MODE = ($86cae540373503c0$var$_ref = (globalThis === null || globalThis === void 0 || ($86cae540373503c0$var$_process = globalThis.process) === null || $86cae540373503c0$var$_process === void 0 || ($86cae540373503c0$var$_process = $86cae540373503c0$var$_process.env) === null || $86cae540373503c0$var$_process === void 0 ? void 0 : $86cae540373503c0$var$_process.JEST_WORKER_ID) !== undefined, $86cae540373503c0$var$_ref !== void 0) ? $86cae540373503c0$var$_ref : false;
var $86cae540373503c0$var$DEBUG_MODE = !$86cae540373503c0$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($86cae540373503c0$var$_process2 = globalThis.process) === null || $86cae540373503c0$var$_process2 === void 0 || ($86cae540373503c0$var$_process2 = $86cae540373503c0$var$_process2.env) === null || $86cae540373503c0$var$_process2 === void 0 ? void 0 : $86cae540373503c0$var$_process2.NODE_ENV) !== "production";
var $86cae540373503c0$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$86cae540373503c0$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("7ptNF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5651fbe65dd2a7d0$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $7A2nl = parcelRequire("7A2nl");

var $56gVi = parcelRequire("56gVi");

var $3aLQX = parcelRequire("3aLQX");
var $5651fbe65dd2a7d0$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $5651fbe65dd2a7d0$var$_excluded2 = [
    "className"
];
var $5651fbe65dd2a7d0$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $5651fbe65dd2a7d0$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(htmlAttributes, $5651fbe65dd2a7d0$var$_excluded2);
    var resolvedStyles = (0, $56gVi.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $avKww.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $5651fbe65dd2a7d0$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $7A2nl.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $7A2nl.isSurfaceColorToken)(backgroundColor) && (0, $7A2nl.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $7A2nl.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $7A2nl.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $7A2nl.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $7A2nl.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $7A2nl.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $7A2nl.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $7A2nl.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $avKww.jsx)((0, $3aLQX.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $5651fbe65dd2a7d0$export$2e2bcd8739ae039 = $5651fbe65dd2a7d0$export$e71c4d32a2263218;
var $5651fbe65dd2a7d0$var$baseStyles = (0, $avKww.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});



parcelRegister("5M9tF", function(module, exports) {

$parcel$export(module.exports, "StyledTitle", function () { return $165c0a900c81fdba$export$48331a7adc9a636b; });

var $2xJU3 = parcelRequire("2xJU3");

var $aP6k3 = parcelRequire("aP6k3");
var $dCDrX = parcelRequire("dCDrX");
const $165c0a900c81fdba$var$getTruncationStyles = ({ truncate: truncate })=>truncate ? `
        overflow-x: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      ` : null;
const $165c0a900c81fdba$export$48331a7adc9a636b = (0, $2xJU3.default)("h1", {
    target: "edjjevr0"
})((0, $dCDrX).h700(), ";line-height:", (0, $aP6k3.gridSize)() * 4, "px;margin-top:0;outline:none;", $165c0a900c81fdba$var$getTruncationStyles, "");

});



parcelRegister("6kA2y", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $1f84d9d214bc7db3$export$defe85febe8b728c; });

var $agjvf = parcelRequire("agjvf");
const $1f84d9d214bc7db3$export$defe85febe8b728c = (0, $agjvf.defineMessages)({
    header: {
        "id": "frontbucket.settings.merge-checks.header.title",
        "defaultMessage": "Custom merge checks"
    },
    beta: {
        "id": "frontbucket.settings.merge-checks.header.beta",
        "defaultMessage": "Beta"
    }
});

});



parcelRegister("2MeA1", function(module, exports) {

$parcel$export(module.exports, "CustomMergeChecksSettings", function () { return $2ba5a8e7103edcad$export$f2a01709dbf55225; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $3XbtU = parcelRequire("3XbtU");
parcelRequire("dGzLf");
var $aAre5 = parcelRequire("aAre5");

var $2FnXC = parcelRequire("2FnXC");

var $dEKDm = parcelRequire("dEKDm");
parcelRequire("hw8PW");
var $7JtYi = parcelRequire("7JtYi");
parcelRequire("3hzea");
var $a5HLv = parcelRequire("a5HLv");
parcelRequire("jyUKE");
var $jfseu = parcelRequire("jfseu");

var $dyEnO = parcelRequire("dyEnO");

var $2oo57 = parcelRequire("2oo57");

var $d5Nnm = parcelRequire("d5Nnm");

var $i8uLY = parcelRequire("i8uLY");

var $5utbt = parcelRequire("5utbt");

var $2T5gN = parcelRequire("2T5gN");
parcelRequire("4b58K");
var $4rOLF = parcelRequire("4rOLF");

var $9xIRm = parcelRequire("9xIRm");

var $78qLo = parcelRequire("78qLo");

var $h5cf5 = parcelRequire("h5cf5");
parcelRequire("gTSwQ");
var $dvtJl = parcelRequire("dvtJl");

var $gVgNk = parcelRequire("gVgNk");

var $djFfq = parcelRequire("djFfq");
const $2ba5a8e7103edcad$export$f2a01709dbf55225 = ({ api: api, resourceType: resourceType, resource: { loading: loading, data: customMergeChecksConfig, error: error, update: update, refresh: refresh } })=>{
    var _installedCustomMerge;
    const workspaceUuid = (0, $aAre5.useSelector)((0, $5utbt.getCurrentWorkspaceUUID));
    const workspaceAri = (0, $9nHZC.useMemo)(()=>{
        if (workspaceUuid === undefined) throw new Error("Couldn't get workspace UUID");
        return `ari:cloud:bitbucket::workspace/${(0, $a5HLv.uncurlyUuid)(workspaceUuid)}`;
    }, [
        workspaceUuid
    ]);
    const { data: installedCustomMergeChecksData, error: installedCustomMergeChecksError, loading: installedCustomMergeChecksLoading, refetch: refetchInstalledCustomMergeChecks } = (0, $9xIRm.useInstalledCustomMergeChecks)(workspaceAri);
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $dyEnO.useFlag)({
        enableForPdvs: true
    });
    const isEnabled = (0, $d5Nnm.useDjangoFeature)((0, $7JtYi.FeatureKeys).extensibleMergeChecksEnabled);
    // This state is used to confirm the user's intent to disable a check or changing a check from
    // required to recommended
    const [checkStateToConfirm, setCheckStateToConfirm] = (0, $9nHZC.useState)(undefined);
    const [checkIdBeingConfigured, setCheckIdBeingConfigured] = (0, $9nHZC.useState)(undefined);
    // Called when user enables a check via dropdown
    const enableCheck = (0, $9nHZC.useCallback)(async (branchConfig, checkModule, state)=>{
        setCheckIdBeingConfigured(checkModule.id);
        const { id: id, properties: { name: name } } = checkModule;
        try {
            const updatedCustomMergeCheck = await api.configureCustomMergeCheck(id, branchConfig, state);
            update((0, $djFfq.updateCustomMergeCheckConfigRouteResource)(updatedCustomMergeCheck));
        } catch (e) {
            $3XbtU.captureException(e);
            const flagId = "enableCheckErrorFlag";
            let description = {
                msg: (0, $h5cf5.messages).enableErrorMessage,
                values: {
                    name: name
                }
            };
            const actions = [];
            if (e.status === 403) {
                var _e$error;
                description = (e === null || e === void 0 ? void 0 : (_e$error = e.error) === null || _e$error === void 0 ? void 0 : _e$error.message) || description;
            }
            if (e.status === 409) {
                // We tried to configure a check to an invalid state, refresh enabled/installed checks
                refresh();
                refetchInstalledCustomMergeChecks();
            }
            if (e.status >= 500 && e.status < 600) actions.push({
                content: {
                    msg: (0, $i8uLY.default).tryAgain
                },
                onClick: ()=>{
                    enableCheck(branchConfig, checkModule, state);
                    dismissFlag(flagId);
                }
            });
            showFlag({
                id: flagId,
                iconType: "error",
                title: {
                    msg: (0, $2oo57.default).error
                },
                description: description,
                actions: actions,
                autoDismiss: true
            });
        } finally{
            setCheckIdBeingConfigured(undefined);
        }
    }, [
        api,
        update,
        showFlag,
        refresh,
        refetchInstalledCustomMergeChecks,
        dismissFlag
    ]);
    // Callback for hitting confirm in the confirm check state modal. This can be either disabling a
    // check or changing a check from required to recommended
    const updateCheckState = (0, $9nHZC.useCallback)(async (branchConfig, checkModule, checkStateChangeType)=>{
        setCheckIdBeingConfigured(checkModule.id);
        const { id: id, properties: { name: name } } = checkModule;
        try {
            let newConfigState;
            if (checkStateChangeType === (0, $gVgNk.MergeCheckStateChangeType).DISABLE) newConfigState = "off";
            else if (checkStateChangeType === (0, $gVgNk.MergeCheckStateChangeType).REQUIRED_TO_RECOMMENDED) newConfigState = "recommended";
            else throw new Error("Invalid check state change type");
            const updatedCustomMergeCheck = await api.configureCustomMergeCheck(id, branchConfig, newConfigState);
            update((0, $djFfq.updateCustomMergeCheckConfigRouteResource)(updatedCustomMergeCheck));
        } catch (e) {
            $3XbtU.captureException(e);
            const flagId = "disableCheckErrorFlag";
            const actions = [];
            if (e.status === 409) {
                // We tried to configure a check to an invalid state, refresh enabled/installed checks
                refresh();
                refetchInstalledCustomMergeChecks();
            }
            if (e.status >= 500 && e.status < 600) actions.push({
                content: {
                    msg: (0, $i8uLY.default).tryAgain
                },
                onClick: ()=>{
                    updateCheckState(branchConfig, checkModule, checkStateChangeType);
                    dismissFlag(flagId);
                }
            });
            showFlag({
                id: flagId,
                iconType: "error",
                title: {
                    msg: (0, $2oo57.default).error
                },
                description: {
                    msg: (0, $h5cf5.messages).disableErrorMessage,
                    values: {
                        name: name
                    }
                },
                actions: actions,
                autoDismiss: true
            });
        } finally{
            setCheckIdBeingConfigured(undefined);
            setCheckStateToConfirm(undefined);
        }
    }, [
        api,
        update,
        showFlag,
        refresh,
        refetchInstalledCustomMergeChecks,
        dismissFlag
    ]);
    // We need to prompt the user to confirm their intent to disable a check or change a check from
    // required to recommended.
    const promptToUpdateCheckState = (0, $9nHZC.useCallback)((branchConfig, checkModule, checkStateChangeType)=>{
        setCheckStateToConfirm({
            branchConfig: branchConfig,
            checkModule: checkModule,
            checkStateChangeType: checkStateChangeType
        });
    }, []);
    const onSubmitCheckConfiguration = (0, $9nHZC.useCallback)((branchConfig, checkModule, oldState, newState)=>{
        if (newState === "off" || oldState === "required" && newState === "recommended") {
            const changeType = newState === "off" ? (0, $gVgNk.MergeCheckStateChangeType).DISABLE : (0, $gVgNk.MergeCheckStateChangeType).REQUIRED_TO_RECOMMENDED;
            promptToUpdateCheckState(branchConfig, checkModule, changeType);
        } else enableCheck(branchConfig, checkModule, newState);
    }, [
        promptToUpdateCheckState,
        enableCheck
    ]);
    if (loading || installedCustomMergeChecksLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2T5gN.SettingsPageLoadingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dEKDm.default), {
        size: "large",
        testId: "mergeChecksSpinner"
    }));
    if (error || installedCustomMergeChecksError || !customMergeChecksConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $jfseu.SectionError), null);
    const installedCustomMergeChecks = (_installedCustomMerge = installedCustomMergeChecksData === null || installedCustomMergeChecksData === void 0 ? void 0 : installedCustomMergeChecksData.extensionContext.extensionsByType) !== null && _installedCustomMerge !== void 0 ? _installedCustomMerge : [];
    if (!isEnabled || installedCustomMergeChecks.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $4rOLF.MergeChecksEmptyState), {
        resourceType: resourceType,
        isEnabled: isEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $78qLo.MergeChecksTabs), {
        resourceType: resourceType,
        customMergeChecksResourceState: customMergeChecksConfig,
        installedCustomMergeChecks: installedCustomMergeChecks,
        checkIdBeingConfigured: checkIdBeingConfigured,
        onSubmitCheckConfiguration: onSubmitCheckConfiguration
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2FnXC.default), null, checkStateToConfirm && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dvtJl.ConfirmMergeCheckStateModal), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, checkStateToConfirm, {
        isLoading: checkIdBeingConfigured !== undefined,
        onCancel: ()=>setCheckStateToConfirm(undefined),
        onConfirm: updateCheckState
    }))));
};

});
parcelRegister("d5Nnm", function(module, exports) {

$parcel$export(module.exports, "useDjangoFeatures", function () { return $83f11cb3826a03b6$export$64cd8531984d6aea; });
$parcel$export(module.exports, "useDjangoFeature", function () { return $83f11cb3826a03b6$export$a2abd848d7cd5f7; });
parcelRequire("dGzLf");
var $aAre5 = parcelRequire("aAre5");

var $3UXCH = parcelRequire("3UXCH");
function $83f11cb3826a03b6$export$64cd8531984d6aea(...keys) {
    const features = (0, $aAre5.useSelector)((0, $3UXCH.getFeatures));
    return keys.map((key)=>!!features[key]);
}
const $83f11cb3826a03b6$export$a2abd848d7cd5f7 = (key)=>(0, $aAre5.useSelector)((0, $3UXCH.getFeature)(key));

});
parcelRegister("3UXCH", function(module, exports) {

$parcel$export(module.exports, "getFeatures", function () { return $62295ee11caacd46$export$c5c8eb9e425b0de0; });
$parcel$export(module.exports, "getFeature", function () { return $62295ee11caacd46$export$bba2e7bbd72e62e1; });
$parcel$export(module.exports, "getIsShowUpgradePlansBanner", function () { return $62295ee11caacd46$export$8cf301ffa0d2e8b8; });
$parcel$export(module.exports, "getIsRepositoryPageLoadingErrorGuardEnabled", function () { return $62295ee11caacd46$export$437dc24dfc75e40e; });
$parcel$export(module.exports, "getIsSourceTimeoutFixEnabled", function () { return $62295ee11caacd46$export$ec51f14883601239; });
$parcel$export(module.exports, "getIsPRPushedEnabled", function () { return $62295ee11caacd46$export$66b78e505bca5d2c; });
$parcel$export(module.exports, "getIsCommitExpandEnabled", function () { return $62295ee11caacd46$export$d16a1750af7a63e; });
$parcel$export(module.exports, "getSyntaxHighlightingEnabled", function () { return $62295ee11caacd46$export$cdca699366faf321; });
$parcel$export(module.exports, "getPrReviewGroupsEnabled", function () { return $62295ee11caacd46$export$9ab7a2e8a95bbff3; });
$parcel$export(module.exports, "getIsAIEnabledForWorkspace", function () { return $62295ee11caacd46$export$1f2a7cb3475f094b; });
$parcel$export(module.exports, "getCreateWorkspaceShowRecaptchaEnabled", function () { return $62295ee11caacd46$export$3df4c7956fcce104; });
$parcel$export(module.exports, "getRebaseSyncEnabled", function () { return $62295ee11caacd46$export$18ddd81296585ec; });
$parcel$export(module.exports, "getIsPullRequestLabelsEnabled", function () { return $62295ee11caacd46$export$a91507c09d0248ce; });
$parcel$export(module.exports, "getAllCommentsResolvedMergeCheck", function () { return $62295ee11caacd46$export$685f67c958c3c77f; });
$parcel$export(module.exports, "getIsLazyDiffstatEnabled", function () { return $62295ee11caacd46$export$701b8bdfa7259a67; });
$parcel$export(module.exports, "getSquashFastForwardMergeEnabled", function () { return $62295ee11caacd46$export$de26b024ac0ccba1; });

var $aXXtM = parcelRequire("aXXtM");

var $7qdXF = parcelRequire("7qdXF");
const $62295ee11caacd46$export$c5c8eb9e425b0de0 = (0, $aXXtM.createSelector)((0, $7qdXF.getGlobal), (state)=>state && state.features ? state.features : {});
const $62295ee11caacd46$export$bba2e7bbd72e62e1 = (feature)=>(0, $aXXtM.createSelector)($62295ee11caacd46$export$c5c8eb9e425b0de0, (features)=>!!features[feature]);
const $62295ee11caacd46$export$60eb320db77d1d3c = (multipleFts)=>(0, $aXXtM.createSelector)($62295ee11caacd46$export$c5c8eb9e425b0de0, (features)=>{
        return multipleFts.every((ft)=>!!features[ft]);
    });
const $62295ee11caacd46$export$8cf301ffa0d2e8b8 = $62295ee11caacd46$export$bba2e7bbd72e62e1("show-upgrade-plans-banner");
const $62295ee11caacd46$export$437dc24dfc75e40e = $62295ee11caacd46$export$bba2e7bbd72e62e1("fd-repository-page-loading-error-guard");
const $62295ee11caacd46$export$ec51f14883601239 = $62295ee11caacd46$export$bba2e7bbd72e62e1("view-source-filtering-upon-timeout");
const $62295ee11caacd46$export$66b78e505bca5d2c = $62295ee11caacd46$export$bba2e7bbd72e62e1("pr-code-push-webhook");
const $62295ee11caacd46$export$d16a1750af7a63e = $62295ee11caacd46$export$bba2e7bbd72e62e1("commit-expand-inno");
const $62295ee11caacd46$export$cdca699366faf321 = $62295ee11caacd46$export$bba2e7bbd72e62e1("syntax-highlighting");
const $62295ee11caacd46$export$9ab7a2e8a95bbff3 = $62295ee11caacd46$export$bba2e7bbd72e62e1("pr-review-groups");
const $62295ee11caacd46$export$1f2a7cb3475f094b = $62295ee11caacd46$export$bba2e7bbd72e62e1("workspace-ai-enabled");
const $62295ee11caacd46$export$3df4c7956fcce104 = $62295ee11caacd46$export$bba2e7bbd72e62e1("create-workspace-show-recaptcha");
const $62295ee11caacd46$export$18ddd81296585ec = $62295ee11caacd46$export$bba2e7bbd72e62e1("rebase-sync");
const $62295ee11caacd46$export$a91507c09d0248ce = $62295ee11caacd46$export$bba2e7bbd72e62e1("pull-request-labels");
const $62295ee11caacd46$export$685f67c958c3c77f = $62295ee11caacd46$export$bba2e7bbd72e62e1("unresolved-comments-check");
const $62295ee11caacd46$export$701b8bdfa7259a67 = $62295ee11caacd46$export$bba2e7bbd72e62e1("lazy-diffstat");
const $62295ee11caacd46$export$de26b024ac0ccba1 = $62295ee11caacd46$export$bba2e7bbd72e62e1("squash-fast-forward-merge-strategy");

});


parcelRegister("i8uLY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71d246f50061522a$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $71d246f50061522a$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    close: {
        "id": "frontbucket.common.close",
        "defaultMessage": "Close"
    },
    cancel: {
        "id": "frontbucket.common.cancel",
        "defaultMessage": "Cancel"
    },
    commit: {
        "id": "frontbucket.common.commit",
        "defaultMessage": "Commit"
    },
    errorHeading: {
        "id": "frontbucket.common.error",
        "defaultMessage": "Something went wrong"
    },
    expandIcon: {
        "id": "frontbucket.common.expandIcon",
        "defaultMessage": "Expand"
    },
    tryAgain: {
        "id": "frontbucket.common.tryAgain",
        "defaultMessage": "Try again"
    },
    createRepositoryButton: {
        "id": "frontbucket.common.createRepositoryButton",
        "defaultMessage": "Create repository"
    },
    save: {
        "id": "frontbucket.common.save",
        "defaultMessage": "Save"
    },
    success: {
        "id": "frontbucket.common.success",
        "defaultMessage": "Success"
    },
    clearFilter: {
        "id": "frontbucket.common.clearFilter",
        "defaultMessage": "Clear filter"
    },
    skip: {
        "id": "frontbucket.common.skip",
        "defaultMessage": "Skip"
    },
    next: {
        "id": "frontbucket.common.next",
        "defaultMessage": "Next"
    },
    back: {
        "id": "frontbucket.common.back",
        "defaultMessage": "Back"
    },
    gotIt: {
        "id": "frontbucket.common.gotIt",
        "defaultMessage": "Got it"
    }
});

});

parcelRegister("2T5gN", function(module, exports) {

$parcel$export(module.exports, "SettingsPageLoadingWrapper", function () { return $e2806cfcab9bd283$export$79da7bcd43f1911e; });
$parcel$export(module.exports, "SettingsPageIframe", function () { return $e2806cfcab9bd283$export$9a5da2f43d2e3737; });
$parcel$export(module.exports, "SettingsPageContainer", function () { return $e2806cfcab9bd283$export$edb96db66d2c8b6; });
$parcel$export(module.exports, "SettingsPageSection", function () { return $e2806cfcab9bd283$export$c5ae76cbdbef4797; });
$parcel$export(module.exports, "SettingsPageWrapper", function () { return $e2806cfcab9bd283$export$e839387cad1f7e2b; });

var $2xJU3 = parcelRequire("2xJU3");

var $aP6k3 = parcelRequire("aP6k3");

var $kmgRQ = parcelRequire("kmgRQ");
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */ function $e2806cfcab9bd283$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e2806cfcab9bd283$export$79da7bcd43f1911e = (0, $2xJU3.default)("div", {
    target: "en5j0cq0"
})({
    name: "e8bplx",
    styles: "display:flex;align-items:center;justify-content:center;height:60%;"
});
const $e2806cfcab9bd283$export$9a5da2f43d2e3737 = (0, $2xJU3.default)("iframe", {
    target: "en5j0cq1"
})("display:", ({ isLoading: isLoading })=>isLoading ? "none" : "block", ";border:none;width:100%;height:100%;z-index:202;");
const $e2806cfcab9bd283$export$edb96db66d2c8b6 = (0, $2xJU3.default)("div", {
    target: "en5j0cq2"
})("display:flex;justify-content:center;width:100%;height:", ({ topOffset: topOffset })=>topOffset ? `calc(100vh - ${topOffset}px)` : "100%", ";");
const $e2806cfcab9bd283$export$c5ae76cbdbef4797 = /*#__PURE__*/ (0, $2xJU3.default)((0, $kmgRQ.PageSection), {
    target: "en5j0cq3"
})({
    name: "1e1x0pl",
    styles: "display:flex;flex:auto;height:100%;"
});
const $e2806cfcab9bd283$export$e839387cad1f7e2b = (0, $2xJU3.default)("div", {
    target: "en5j0cq4"
})("display:flex;flex:auto;flex-direction:column;margin:0 ", (0, $aP6k3.gridSize)() * 2.5, "px;padding:0 ", (0, $aP6k3.gridSize)() * 2.5, "px;word-wrap:break-word;margin-bottom:", (0, $aP6k3.gridSize)() * 8, "px;");

});
parcelRegister("kmgRQ", function(module, exports) {

$parcel$export(module.exports, "PageHeaderWrapper", function () { return $eecd3945ff6a7f3c$export$6a4c3cd4b6ad03d4; });
$parcel$export(module.exports, "PageHeaderColumn", function () { return $eecd3945ff6a7f3c$export$9661538772ebe2c6; });
$parcel$export(module.exports, "PageSection", function () { return $eecd3945ff6a7f3c$export$9086365ce732c74c; });
$parcel$export(module.exports, "PanelHeader", function () { return $eecd3945ff6a7f3c$export$968713404ca1c9aa; });

var $2xJU3 = parcelRequire("2xJU3");

var $dCDrX = parcelRequire("dCDrX");

var $h39Sh = parcelRequire("h39Sh");

var $3UVNu = parcelRequire("3UVNu");
// Ak Page widths copied from @atlaskit/page because they can't be imported
const $eecd3945ff6a7f3c$var$fixedGridPageWidth = "960px";
const $eecd3945ff6a7f3c$export$6a4c3cd4b6ad03d4 = (0, $2xJU3.default)("header", {
    target: "e1k2snkw0"
})({
    margin: "0 auto",
    padding: `0 ${(0, $h39Sh.default)("space.250", "20px")}`
}, ({ layout: layout })=>({
        maxWidth: layout === "fluid" ? "100%" : $eecd3945ff6a7f3c$var$fixedGridPageWidth
    }), "");
const $eecd3945ff6a7f3c$export$9661538772ebe2c6 = (0, $2xJU3.default)("div", {
    target: "e1k2snkw1"
})({
    ...(0, $3UVNu.mediaObjectExpression).upToSmall({
        margin: 0
    }),
    margin: `0 ${(0, $h39Sh.default)("space.250", "20px")}`
}, ({ tabbedLayout: tabbedLayout })=>({
        width: tabbedLayout ? "100%" : "auto"
    }), "");
const $eecd3945ff6a7f3c$export$9086365ce732c74c = (0, $2xJU3.default)("section", {
    target: "e1k2snkw2"
})({
    margin: "0 auto",
    maxWidth: $eecd3945ff6a7f3c$var$fixedGridPageWidth
}, "");
const $eecd3945ff6a7f3c$export$968713404ca1c9aa = (0, $2xJU3.default)("h2", {
    target: "e1k2snkw3"
})({
    margin: 0,
    display: "flex",
    alignItems: "center",
    ...(0, $dCDrX).h400()
}, "");

});
parcelRegister("3UVNu", function(module, exports) {

$parcel$export(module.exports, "media", function () { return $547a3ff9157b315e$export$987d49ffe1b0900f; });
$parcel$export(module.exports, "mediaObjectExpression", function () { return $547a3ff9157b315e$export$d9562bc44bcc8ab4; });
parcelRequire("45CBz");
var $7KAwG = parcelRequire("7KAwG");
function $547a3ff9157b315e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $547a3ff9157b315e$export$c647cb0ee6e282fe = {
    upToXSmall: 320,
    upToSmall: 576,
    upToMedium: 768,
    upToLarge: 1024,
    upToXLarge: 1280,
    upToXXLarge: 1520
};
const $547a3ff9157b315e$export$987d49ffe1b0900f = Object.keys($547a3ff9157b315e$export$c647cb0ee6e282fe).reduce((accumulator, label)=>{
    // use em in breakpoints to work properly cross-browser and support users
    // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
    const emSize = $547a3ff9157b315e$export$c647cb0ee6e282fe[label] / 16;
    accumulator[label] = (...args)=>/*#__PURE__*/ (0, $7KAwG.default)({
            [`@media (max-width: ${emSize}em)`]: /*#__PURE__*/ (0, $7KAwG.default)(...args)
        }, "");
    return accumulator;
}, {});
const $547a3ff9157b315e$export$d9562bc44bcc8ab4 = Object.keys($547a3ff9157b315e$export$c647cb0ee6e282fe).reduce((accumulator, label)=>{
    const emSize = $547a3ff9157b315e$export$c647cb0ee6e282fe[label] / 16;
    accumulator[label] = (args)=>({
            [`@media (max-width: ${emSize}em)`]: args
        });
    return accumulator;
}, {});
const $547a3ff9157b315e$export$c5fb69cbe9a29d95 = {
    name: "1b512s9",
    styles: "position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);border:0;"
};

});



parcelRegister("4b58K", function(module, exports) {

$parcel$export(module.exports, "MergeChecksEmptyState", function () { return (parcelRequire("4rOLF")).MergeChecksEmptyState; });

var $4rOLF = parcelRequire("4rOLF");

});
parcelRegister("4rOLF", function(module, exports) {

$parcel$export(module.exports, "MergeChecksEmptyState", function () { return $0f8a09606d3b1afb$export$5cca8d0546e13f94; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $bojMT = parcelRequire("bojMT");

var $7ptNF = parcelRequire("7ptNF");
var $56gVi = parcelRequire("56gVi");

var $jajUg = parcelRequire("jajUg");

var $bU9Oo = parcelRequire("bU9Oo");

var $37goh = parcelRequire("37goh");

var $83bOI = parcelRequire("83bOI");

var $jcOte = parcelRequire("jcOte");
const $0f8a09606d3b1afb$var$nextStepsMessageXcss = (0, $56gVi.xcss)({
    marginTop: "space.200"
});
const $0f8a09606d3b1afb$export$5cca8d0546e13f94 = ({ resourceType: resourceType, isEnabled: isEnabled })=>{
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    const renderDescription = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, (0, $bU9Oo.contextMessages)[resourceType].description, {
            values: {
                learnMoreLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("a", {
                    href: (0, $37goh.urls).learnMore,
                    target: "_blank"
                }, formatMessage((0, $bU9Oo.contextMessages)[resourceType].learnMoreLinkLabel))
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7ptNF.default), {
            xcss: $0f8a09606d3b1afb$var$nextStepsMessageXcss
        }, isEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
            "data-testid": "installExampleAppsMessage"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, (0, $83bOI.messages).installExampleMergeCheckApps, {
            values: {
                exampleAppsLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("a", {
                    href: (0, $37goh.urls).exampleApps,
                    target: "_blank"
                }, formatMessage((0, $83bOI.messages).exampleAppsLinkText))
            }
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
            "data-testid": "checksNotEnabledMessage"
        }, formatMessage((0, $83bOI.messages).checksNotEnabled))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $bojMT.default), {
        header: "",
        description: renderDescription(),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($jcOte))),
        testId: "mergeChecksEmptyState"
    });
};

});
parcelRegister("bojMT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84b148fc41b2880a$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $1VvZI = parcelRequire("1VvZI");

var $btNsg = parcelRequire("btNsg");

var $dIrwS = parcelRequire("dIrwS");

var $tn7XZ = parcelRequire("tn7XZ");

var $NM7YK = parcelRequire("NM7YK");

var $6P4uJ = parcelRequire("6P4uJ");
var $8Pc2y = parcelRequire("8Pc2y");
var $iH7pA = parcelRequire("iH7pA");
var $aIWNc = parcelRequire("aIWNc");
var $ccdfh = parcelRequire("ccdfh");
var $dWrZI = parcelRequire("dWrZI");
/**
 * __Empty state__
 *
 * A component used for presenting various empty states.
 * e.g. (no items, empty search, broken link, welcome screen etc.)
 *
 * @example
 * ```tsx
 * import EmptyState from '@atlaskit/empty-state';
 *
 * // An example of a 404 state
 * export default () => {
 *  <EmptyState
 *   header="Page not found"
 *   imageUrl="https://cdn.io/images/404"
 *   description="Looks like you've stumbled off track. Sorry about that! This page either doesn't exist or has been removed."
 *   primaryAction={<Button appearance="primary">Home Page</Button>}
 *   secondaryAction={<Button>Report a problem</Button>}
 *  />;
 * };
 * ```
 */ var $84b148fc41b2880a$var$EmptyState = function EmptyState(_ref) {
    var buttonGroupLabel = _ref.buttonGroupLabel, description = _ref.description, header = _ref.header, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 4 : _ref$headingLevel, imageHeight = _ref.imageHeight, imageUrl = _ref.imageUrl, imageWidth = _ref.imageWidth, isLoading = _ref.isLoading, _ref$maxImageHeight = _ref.maxImageHeight, maxImageHeight = _ref$maxImageHeight === void 0 ? 160 : _ref$maxImageHeight, _ref$maxImageWidth = _ref.maxImageWidth, maxImageWidth = _ref$maxImageWidth === void 0 ? 160 : _ref$maxImageWidth, primaryAction = _ref.primaryAction, renderImage = _ref.renderImage, secondaryAction = _ref.secondaryAction, width = _ref.width, size = _ref.size, tertiaryAction = _ref.tertiaryAction, testId = _ref.testId;
    var actionsContainer = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6P4uJ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $1VvZI.default), {
        label: buttonGroupLabel || "Button group",
        testId: testId && "".concat(testId, "-button-group")
    }, secondaryAction, primaryAction), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dWrZI.default), null, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $NM7YK.default), {
        testId: "empty-state-spinner"
    }))) : null;
    var tag = "h".concat(headingLevel > 0 && headingLevel < 7 ? headingLevel : headingLevel > 6 ? 6 : 4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $8Pc2y.default), {
        testId: testId,
        width: width || size || "wide"
    }, imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ccdfh.default), {
        src: imageUrl,
        maxWidth: maxImageWidth,
        maxHeight: maxImageHeight,
        width: imageWidth,
        height: imageHeight
    }) : renderImage && renderImage({
        maxImageWidth: maxImageWidth,
        maxImageHeight: maxImageHeight,
        imageWidth: imageWidth,
        imageHeight: imageHeight
    }), (0, $dIrwS.fg)("platform.design-system-team.empty-state-typography-updates_gndrj") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $tn7XZ.default), {
        paddingBlockEnd: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $btNsg.default), {
        size: "medium",
        as: tag
    }, header)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aIWNc.default), {
        level: headingLevel
    }, header), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $iH7pA.default), null, description), actionsContainer, tertiaryAction);
};
var $84b148fc41b2880a$export$2e2bcd8739ae039 = $84b148fc41b2880a$var$EmptyState;

});
parcelRegister("1VvZI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1673eeb814821d3b$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");
var $1673eeb814821d3b$var$buttonGroupStyles = (0, $avKww.css)({
    display: "inline-flex",
    gap: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> *": {
        flex: "1 0 auto"
    }
});
function $1673eeb814821d3b$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, testId = _ref.testId, label = _ref.label, titleId = _ref.titleId;
    return (0, $avKww.jsx)("div", {
        css: $1673eeb814821d3b$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Children.toArray(children), function(child, idx) {
        if (!child) return null;
        return (0, $avKww.jsx)((0, $9nHZC.Fragment), {
            key: idx
        }, child);
    }));
}

});

parcelRegister("btNsg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85b8c3d97c6c45f2$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9q1kH = parcelRequire("9q1kH");

var $avKww = parcelRequire("avKww");

var $iK2Dm = parcelRequire("iK2Dm");

var $g7jFo = parcelRequire("g7jFo");

var $8ovux = parcelRequire("8ovux");
var $85b8c3d97c6c45f2$var$_excluded = [
    "level"
];
// https://atlassian.design/foundations/typography
var $85b8c3d97c6c45f2$var$levelMap = {
    h900: "h1",
    h800: "h1",
    h700: "h2",
    h600: "h3",
    h500: "h4",
    h400: "h5",
    h300: "h6",
    // NB: These two levels are not covered at all by the existing @atlaskit/css-reset
    h200: "div",
    h100: "div"
};
var $85b8c3d97c6c45f2$var$headingResetStyles = (0, $avKww.css)({
    color: "var(--ds-text, #172B4D)",
    marginBlock: "var(--ds-space-0, 0px)"
});
var $85b8c3d97c6c45f2$var$h900Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-600, 35px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-600, 40px)"
});
var $85b8c3d97c6c45f2$var$h800Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-500, 29px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-500, 32px)"
});
var $85b8c3d97c6c45f2$var$h700Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-400, 24px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-400, 28px)"
});
var $85b8c3d97c6c45f2$var$h600Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-300, 20px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.008em",
    lineHeight: "var(--ds-font-lineHeight-300, 24px)"
});
var $85b8c3d97c6c45f2$var$h500Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-200, 16px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.006em",
    lineHeight: "var(--ds-font-lineHeight-200, 20px)"
});
var $85b8c3d97c6c45f2$var$h400Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-100, 14px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.003em",
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $85b8c3d97c6c45f2$var$h300Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)",
    textTransform: "uppercase"
});
var $85b8c3d97c6c45f2$var$h200Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $85b8c3d97c6c45f2$var$h100Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-050, 11px)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $85b8c3d97c6c45f2$var$inverseStyles = (0, $avKww.css)({
    color: "var(--ds-text-inverse, #FFF)"
});
var $85b8c3d97c6c45f2$var$subtlestStyles = (0, $avKww.css)({
    color: "var(--ds-text-subtlest, #6B778C)"
});
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ var $85b8c3d97c6c45f2$var$OldHeading = function OldHeading(_ref) {
    var children = _ref.children, level = _ref.level, id = _ref.id, testId = _ref.testId, as = _ref.as, _ref$color = _ref.color, color = _ref$color === void 0 ? "default" : _ref$color;
    typeof $8ovux;
    var _useHeading = (0, $iK2Dm.useHeading)($85b8c3d97c6c45f2$var$levelMap[level]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Markup = as || inferredElement;
    var isSubtleHeading = level === "h200" || level === "h100";
    var needsAriaRole = Markup === "div" && hLevel;
    return (0, $avKww.jsx)(Markup, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $85b8c3d97c6c45f2$var$headingResetStyles,
            level === "h100" && $85b8c3d97c6c45f2$var$h100Styles,
            level === "h200" && $85b8c3d97c6c45f2$var$h200Styles,
            level === "h300" && $85b8c3d97c6c45f2$var$h300Styles,
            level === "h400" && $85b8c3d97c6c45f2$var$h400Styles,
            level === "h500" && $85b8c3d97c6c45f2$var$h500Styles,
            level === "h600" && $85b8c3d97c6c45f2$var$h600Styles,
            level === "h700" && $85b8c3d97c6c45f2$var$h700Styles,
            level === "h800" && $85b8c3d97c6c45f2$var$h800Styles,
            level === "h900" && $85b8c3d97c6c45f2$var$h900Styles,
            color === "inverse" && $85b8c3d97c6c45f2$var$inverseStyles,
            color === "default" && isSubtleHeading && $85b8c3d97c6c45f2$var$subtlestStyles
        ]
    }, children);
};
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * // New component
 * <Heading size="xxlarge">Page title</Heading>
 *
 * // Old component
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ var $85b8c3d97c6c45f2$var$Heading = function Heading(_ref2) {
    var level = _ref2.level, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref2, $85b8c3d97c6c45f2$var$_excluded);
    return level ? // eslint-disable-next-line jsx-a11y/heading-has-content, @repo/internal/react/no-unsafe-spread-props
    (0, $avKww.jsx)($85b8c3d97c6c45f2$var$OldHeading, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        level: level
    }, props)) : // eslint-disable-next-line jsx-a11y/heading-has-content, @repo/internal/react/no-unsafe-spread-props
    (0, $avKww.jsx)((0, $g7jFo.default), props);
};
var $85b8c3d97c6c45f2$export$2e2bcd8739ae039 = $85b8c3d97c6c45f2$var$Heading;

});
parcelRegister("iK2Dm", function(module, exports) {

$parcel$export(module.exports, "useHeading", function () { return $da4e90ea140c238b$export$97a37b1befbbf9b1; });

var $9nHZC = parcelRequire("9nHZC");
// Allows support for heading levels 1-9 via aria-level
var $da4e90ea140c238b$var$HeadingLevelContext = /*#__PURE__*/ (0, $9nHZC.createContext)(0);
var $da4e90ea140c238b$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $9nHZC.useContext)($da4e90ea140c238b$var$HeadingLevelContext);
};
var $da4e90ea140c238b$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $da4e90ea140c238b$export$6a64a1e2d0bbbf75();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? "div" : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $da4e90ea140c238b$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $da4e90ea140c238b$export$6a64a1e2d0bbbf75();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($da4e90ea140c238b$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $da4e90ea140c238b$export$2e2bcd8739ae039 = $da4e90ea140c238b$var$HeadingLevelContextProvider;

});

parcelRegister("g7jFo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbbc8e305f1876fa$export$2e2bcd8739ae039; });

var $9q1kH = parcelRequire("9q1kH");

var $avKww = parcelRequire("avKww");

var $cRDau = parcelRequire("cRDau");
var $gVCZK = parcelRequire("gVCZK");

var $iK2Dm = parcelRequire("iK2Dm");

var $8ovux = parcelRequire("8ovux");
var $bbbc8e305f1876fa$var$sizeTagMap = {
    xxlarge: "h1",
    xlarge: "h1",
    large: "h2",
    medium: "h3",
    small: "h4",
    xsmall: "h5",
    xxsmall: "h6"
};
var $bbbc8e305f1876fa$var$headingResetStyles = (0, $avKww.css)({
    letterSpacing: "normal",
    marginBlock: 0,
    textTransform: "none"
});
var $bbbc8e305f1876fa$var$useColor = function useColor(colorProp) {
    var surface = (0, $gVCZK.useSurface)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $cRDau.inverseColorMap).hasOwnProperty(surface)) return (0, $cRDau.inverseColorMap)[surface];
    return colorProp || "color.text";
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $bbbc8e305f1876fa$var$Heading = function Heading(_ref) {
    var children = _ref.children, size = _ref.size, id = _ref.id, testId = _ref.testId, as = _ref.as, colorProp = _ref.color;
    typeof $8ovux;
    // Technically size can be undefined here due to how the types work.
    // Once removing the level prop this assertion can be removed since size will be a required prop.
    var _useHeading = (0, $iK2Dm.useHeading)($bbbc8e305f1876fa$var$sizeTagMap[size]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === "div" && hLevel;
    var color = $bbbc8e305f1876fa$var$useColor(colorProp);
    return (0, $avKww.jsx)(Component, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $bbbc8e305f1876fa$var$headingResetStyles,
            size && $bbbc8e305f1876fa$var$headingSizeStylesMap[size],
            $bbbc8e305f1876fa$export$93e8ddd840a408f9[color]
        ]
    }, children);
};
var $bbbc8e305f1876fa$export$93e8ddd840a408f9 = {
    "color.text": (0, $avKww.css)({
        color: "var(--ds-text, #172B4D)"
    }),
    "color.text.inverse": (0, $avKww.css)({
        color: "var(--ds-text-inverse, #FFFFFF)"
    }),
    "color.text.warning.inverse": (0, $avKww.css)({
        color: "var(--ds-text-warning-inverse, #172B4D)"
    })
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df829c6c0aa19bb57c0c77dc08d12d60>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $bbbc8e305f1876fa$var$headingSizeStylesMap = {
    xxlarge: (0, $avKww.css)({
        font: 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xlarge: (0, $avKww.css)({
        font: 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    large: (0, $avKww.css)({
        font: 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    medium: (0, $avKww.css)({
        font: 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    small: (0, $avKww.css)({
        font: 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xsmall: (0, $avKww.css)({
        font: 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xxsmall: (0, $avKww.css)({
        font: 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    })
};
var /**
 * @codegenEnd
 */ $bbbc8e305f1876fa$export$2e2bcd8739ae039 = $bbbc8e305f1876fa$var$Heading;

});
parcelRegister("cRDau", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $95d8d1433dd97209$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $95d8d1433dd97209$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $95d8d1433dd97209$export$632685d741f3dbbf; });
$parcel$export(module.exports, "inverseColorMap", function () { return $95d8d1433dd97209$export$2185ce37f9bdd963; });
$parcel$export(module.exports, "opacityMap", function () { return $95d8d1433dd97209$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $95d8d1433dd97209$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $95d8d1433dd97209$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $95d8d1433dd97209$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $95d8d1433dd97209$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $95d8d1433dd97209$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $95d8d1433dd97209$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $95d8d1433dd97209$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $95d8d1433dd97209$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $95d8d1433dd97209$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $95d8d1433dd97209$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $95d8d1433dd97209$export$5e65a44e5b6ecadb; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $xbX1J = parcelRequire("xbX1J");
function $95d8d1433dd97209$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $95d8d1433dd97209$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $95d8d1433dd97209$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $95d8d1433dd97209$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $95d8d1433dd97209$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $95d8d1433dd97209$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $95d8d1433dd97209$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $95d8d1433dd97209$export$632685d741f3dbbf = $95d8d1433dd97209$var$_objectSpread($95d8d1433dd97209$var$_objectSpread({}, $95d8d1433dd97209$export$958d0ae7f2977ae4), $95d8d1433dd97209$export$d2dc61f58390201c);
var $95d8d1433dd97209$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $95d8d1433dd97209$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $95d8d1433dd97209$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $95d8d1433dd97209$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $95d8d1433dd97209$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $95d8d1433dd97209$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $95d8d1433dd97209$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $95d8d1433dd97209$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $95d8d1433dd97209$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $95d8d1433dd97209$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $95d8d1433dd97209$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $95d8d1433dd97209$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $95d8d1433dd97209$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $95d8d1433dd97209$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $95d8d1433dd97209$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $95d8d1433dd97209$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $avKww.css)((0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $95d8d1433dd97209$export$e615f061ca585a6c = $95d8d1433dd97209$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $95d8d1433dd97209$var$getSerializedStylesMap(spacingProperty, $95d8d1433dd97209$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $95d8d1433dd97209$export$bf46c3f9eeafc71f = $95d8d1433dd97209$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $95d8d1433dd97209$var$getSerializedStylesMap(spacingProperty, $95d8d1433dd97209$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $95d8d1433dd97209$export$e7af83bafe7f9e63 = $95d8d1433dd97209$var$getSerializedStylesMap("backgroundColor", $95d8d1433dd97209$export$d1d79bf68ac056bd);
var $95d8d1433dd97209$export$3a1bcba60b23d7f0 = $95d8d1433dd97209$var$getSerializedStylesMap("color", $95d8d1433dd97209$export$8473307aa00d6ea1);
var $95d8d1433dd97209$export$45f3f4fe16f9f7d5 = $95d8d1433dd97209$var$getSerializedStylesMap("fontWeight", $95d8d1433dd97209$export$303e322c6b1ed114);
var $95d8d1433dd97209$export$68cc305da27dbaa4 = $95d8d1433dd97209$var$getSerializedStylesMap("fontFamily", $95d8d1433dd97209$export$3c7e9587132614b4);
var $95d8d1433dd97209$export$128f10c238242f83 = $95d8d1433dd97209$var$getSerializedStylesMap("font", $95d8d1433dd97209$export$6cc560b4dedf3816);
var $95d8d1433dd97209$export$ff257d957d48c421 = $95d8d1433dd97209$var$getSerializedStylesMap((0, $xbX1J.CURRENT_SURFACE_CSS_VAR), $95d8d1433dd97209$export$41a358c9c2356760);
var $95d8d1433dd97209$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $95d8d1433dd97209$export$41a358c9c2356760[color] !== undefined;
};

});

parcelRegister("gVCZK", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $c53037c6a58a9e34$export$1ca2a26fecb070ae; });
$parcel$export(module.exports, "useSurface", function () { return $c53037c6a58a9e34$export$1aeb4f6b93c4540d; });

var $9nHZC = parcelRequire("9nHZC");
var $c53037c6a58a9e34$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $9nHZC.createContext)("elevation.surface");
var $c53037c6a58a9e34$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $9nHZC.useContext)($c53037c6a58a9e34$export$1ca2a26fecb070ae);
};
$c53037c6a58a9e34$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});



parcelRegister("dIrwS", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $9fc4bd24d40d77f5$export$b40ec24ac8275656; });

var $3Wovg = parcelRequire("3Wovg");
function $9fc4bd24d40d77f5$export$ba05d765b8392e5e(flagResolver) {
    (0, $3Wovg.setBooleanResolver)(flagResolver);
}
function $9fc4bd24d40d77f5$export$470e5c2be1411c89(name) {
    return (0, $3Wovg.resolveBooleanFlag)(name);
}
function $9fc4bd24d40d77f5$export$b40ec24ac8275656(name) {
    return (0, $3Wovg.resolveBooleanFlag)(name);
}

});
parcelRegister("3Wovg", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $2de9cbbbb7553735$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $2de9cbbbb7553735$export$6333b6aff9fc6275; });

var $8e8ab = parcelRequire("8e8ab");

var $8ovux = parcelRequire("8ovux");
var $2de9cbbbb7553735$var$pkgName = "@atlaskit/platform-feature-flags";
var $2de9cbbbb7553735$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $2de9cbbbb7553735$var$hasProcessEnv = typeof $8ovux !== "undefined" && typeof $8ovux.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $2de9cbbbb7553735$var$ENV_ENABLE_PLATFORM_FF = $2de9cbbbb7553735$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $2de9cbbbb7553735$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $2de9cbbbb7553735$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $2de9cbbbb7553735$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $2de9cbbbb7553735$var$ENV_ENABLE_PLATFORM_FF || $2de9cbbbb7553735$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $2de9cbbbb7553735$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $2de9cbbbb7553735$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$2de9cbbbb7553735$var$globalVar[$2de9cbbbb7553735$export$7e41b1b2bdee3f98] = $2de9cbbbb7553735$var$globalVar[$2de9cbbbb7553735$export$7e41b1b2bdee3f98] || $2de9cbbbb7553735$var$DEFAULT_PFF_GLOBAL;
function $2de9cbbbb7553735$export$f2b591175b3e424c(resolver) {
    $2de9cbbbb7553735$var$globalVar[$2de9cbbbb7553735$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $2de9cbbbb7553735$export$6333b6aff9fc6275(flagKey) {
    if ($2de9cbbbb7553735$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $8e8ab.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $2de9cbbbb7553735$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $2de9cbbbb7553735$var$globalVar[$2de9cbbbb7553735$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("8e8ab", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $5fd5f690a615c127$export$1c9f709888824e05; });
var $5fd5f690a615c127$var$_ref, $5fd5f690a615c127$var$_process, $5fd5f690a615c127$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $5fd5f690a615c127$var$TESTS_MODE = ($5fd5f690a615c127$var$_ref = (globalThis === null || globalThis === void 0 || ($5fd5f690a615c127$var$_process = globalThis.process) === null || $5fd5f690a615c127$var$_process === void 0 || ($5fd5f690a615c127$var$_process = $5fd5f690a615c127$var$_process.env) === null || $5fd5f690a615c127$var$_process === void 0 ? void 0 : $5fd5f690a615c127$var$_process.JEST_WORKER_ID) !== undefined, $5fd5f690a615c127$var$_ref !== void 0) ? $5fd5f690a615c127$var$_ref : false;
var $5fd5f690a615c127$var$DEBUG_MODE = !$5fd5f690a615c127$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($5fd5f690a615c127$var$_process2 = globalThis.process) === null || $5fd5f690a615c127$var$_process2 === void 0 || ($5fd5f690a615c127$var$_process2 = $5fd5f690a615c127$var$_process2.env) === null || $5fd5f690a615c127$var$_process2 === void 0 ? void 0 : $5fd5f690a615c127$var$_process2.NODE_ENV) !== "production";
var $5fd5f690a615c127$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$5fd5f690a615c127$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("tn7XZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0584a62fd28ec427$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $cRDau = parcelRequire("cRDau");

var $8TaQx = parcelRequire("8TaQx");

var $gVCZK = parcelRequire("gVCZK");
var $0584a62fd28ec427$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $0584a62fd28ec427$var$_excluded2 = [
    "className"
];
var $0584a62fd28ec427$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $0584a62fd28ec427$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(htmlAttributes, $0584a62fd28ec427$var$_excluded2);
    var resolvedStyles = (0, $8TaQx.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $avKww.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $0584a62fd28ec427$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $cRDau.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $cRDau.isSurfaceColorToken)(backgroundColor) && (0, $cRDau.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $cRDau.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $cRDau.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $cRDau.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $cRDau.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $cRDau.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $cRDau.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $cRDau.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $avKww.jsx)((0, $gVCZK.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $0584a62fd28ec427$export$2e2bcd8739ae039 = $0584a62fd28ec427$export$e71c4d32a2263218;
var $0584a62fd28ec427$var$baseStyles = (0, $avKww.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("8TaQx", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $678bdfa90cb6cdd8$export$a9c84988c8f81f2d; });

var $b4Ivn = parcelRequire("b4Ivn");

var $kFnE9 = parcelRequire("kFnE9");

var $9q1kH = parcelRequire("9q1kH");

var $340K4 = parcelRequire("340K4");

var $avKww = parcelRequire("avKww");

var $cRDau = parcelRequire("cRDau");

var $8ovux = parcelRequire("8ovux");
function $678bdfa90cb6cdd8$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $678bdfa90cb6cdd8$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $678bdfa90cb6cdd8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $678bdfa90cb6cdd8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $678bdfa90cb6cdd8$var$_arrayLikeToArray(o, minLen);
}
function $678bdfa90cb6cdd8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $678bdfa90cb6cdd8$export$9a199fbafee0014e = {
    backgroundColor: (0, $cRDau.backgroundColorMap),
    blockSize: (0, $cRDau.dimensionMap),
    borderBlockColor: (0, $cRDau.borderColorMap),
    borderBlockEndColor: (0, $cRDau.borderColorMap),
    borderBlockEndWidth: (0, $cRDau.borderWidthMap),
    borderBlockStartColor: (0, $cRDau.borderColorMap),
    borderBlockStartWidth: (0, $cRDau.borderWidthMap),
    borderBlockWidth: (0, $cRDau.borderWidthMap),
    borderBottomColor: (0, $cRDau.borderColorMap),
    borderBottomLeftRadius: (0, $cRDau.borderRadiusMap),
    borderBottomRightRadius: (0, $cRDau.borderRadiusMap),
    borderBottomWidth: (0, $cRDau.borderWidthMap),
    borderColor: (0, $cRDau.borderColorMap),
    borderEndEndRadius: (0, $cRDau.borderRadiusMap),
    borderEndStartRadius: (0, $cRDau.borderRadiusMap),
    borderInlineColor: (0, $cRDau.borderColorMap),
    borderInlineEndColor: (0, $cRDau.borderColorMap),
    borderInlineEndWidth: (0, $cRDau.borderWidthMap),
    borderInlineStartColor: (0, $cRDau.borderColorMap),
    borderInlineStartWidth: (0, $cRDau.borderWidthMap),
    borderInlineWidth: (0, $cRDau.borderWidthMap),
    borderLeftColor: (0, $cRDau.borderColorMap),
    borderLeftWidth: (0, $cRDau.borderWidthMap),
    borderRadius: (0, $cRDau.borderRadiusMap),
    borderRightColor: (0, $cRDau.borderColorMap),
    borderRightWidth: (0, $cRDau.borderWidthMap),
    borderStartEndRadius: (0, $cRDau.borderRadiusMap),
    borderStartStartRadius: (0, $cRDau.borderRadiusMap),
    borderTopColor: (0, $cRDau.borderColorMap),
    borderTopLeftRadius: (0, $cRDau.borderRadiusMap),
    borderTopRightRadius: (0, $cRDau.borderRadiusMap),
    borderTopWidth: (0, $cRDau.borderWidthMap),
    borderWidth: (0, $cRDau.borderWidthMap),
    bottom: (0, $cRDau.allSpaceMap),
    boxShadow: (0, $cRDau.shadowMap),
    color: (0, $cRDau.textColorMap),
    columnGap: (0, $cRDau.positiveSpaceMap),
    gap: (0, $cRDau.positiveSpaceMap),
    height: (0, $cRDau.dimensionMap),
    inlineSize: (0, $cRDau.dimensionMap),
    inset: (0, $cRDau.allSpaceMap),
    insetBlock: (0, $cRDau.allSpaceMap),
    insetBlockEnd: (0, $cRDau.allSpaceMap),
    insetBlockStart: (0, $cRDau.allSpaceMap),
    insetInline: (0, $cRDau.allSpaceMap),
    insetInlineEnd: (0, $cRDau.allSpaceMap),
    insetInlineStart: (0, $cRDau.allSpaceMap),
    left: (0, $cRDau.allSpaceMap),
    margin: (0, $cRDau.allSpaceMap),
    marginBlock: (0, $cRDau.allSpaceMap),
    marginBlockEnd: (0, $cRDau.allSpaceMap),
    marginBlockStart: (0, $cRDau.allSpaceMap),
    marginBottom: (0, $cRDau.allSpaceMap),
    marginInline: (0, $cRDau.allSpaceMap),
    marginInlineEnd: (0, $cRDau.allSpaceMap),
    marginInlineStart: (0, $cRDau.allSpaceMap),
    marginLeft: (0, $cRDau.allSpaceMap),
    marginRight: (0, $cRDau.allSpaceMap),
    marginTop: (0, $cRDau.allSpaceMap),
    maxBlockSize: (0, $cRDau.dimensionMap),
    maxHeight: (0, $cRDau.dimensionMap),
    maxInlineSize: (0, $cRDau.dimensionMap),
    maxWidth: (0, $cRDau.dimensionMap),
    minBlockSize: (0, $cRDau.dimensionMap),
    minHeight: (0, $cRDau.dimensionMap),
    minInlineSize: (0, $cRDau.dimensionMap),
    minWidth: (0, $cRDau.dimensionMap),
    opacity: (0, $cRDau.opacityMap),
    outlineColor: (0, $cRDau.borderColorMap),
    outlineOffset: (0, $cRDau.positiveSpaceMap),
    outlineWidth: (0, $cRDau.borderWidthMap),
    padding: (0, $cRDau.positiveSpaceMap),
    paddingBlock: (0, $cRDau.positiveSpaceMap),
    paddingBlockEnd: (0, $cRDau.positiveSpaceMap),
    paddingBlockStart: (0, $cRDau.positiveSpaceMap),
    paddingBottom: (0, $cRDau.positiveSpaceMap),
    paddingInline: (0, $cRDau.positiveSpaceMap),
    paddingInlineEnd: (0, $cRDau.positiveSpaceMap),
    paddingInlineStart: (0, $cRDau.positiveSpaceMap),
    paddingLeft: (0, $cRDau.positiveSpaceMap),
    paddingRight: (0, $cRDau.positiveSpaceMap),
    paddingTop: (0, $cRDau.positiveSpaceMap),
    right: (0, $cRDau.allSpaceMap),
    rowGap: (0, $cRDau.positiveSpaceMap),
    top: (0, $cRDau.allSpaceMap),
    width: (0, $cRDau.dimensionMap),
    zIndex: (0, $cRDau.layerMap)
};
var $678bdfa90cb6cdd8$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $678bdfa90cb6cdd8$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $8ovux === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux.env) === "object" && false;
};
var $678bdfa90cb6cdd8$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $678bdfa90cb6cdd8$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $678bdfa90cb6cdd8$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(value) === "object" && $678bdfa90cb6cdd8$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($678bdfa90cb6cdd8$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($678bdfa90cb6cdd8$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $678bdfa90cb6cdd8$export$9a199fbafee0014e)) return;
        var tokenValue = $678bdfa90cb6cdd8$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $678bdfa90cb6cdd8$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $678bdfa90cb6cdd8$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, $678bdfa90cb6cdd8$var$uniqueSymbol, (0, $avKww.css)(transformedStyles));
};
var $678bdfa90cb6cdd8$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $678bdfa90cb6cdd8$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$678bdfa90cb6cdd8$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $678bdfa90cb6cdd8$export$f6c783d06584602c(style) {
    return $678bdfa90cb6cdd8$var$baseXcss(style);
}

});


parcelRegister("NM7YK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0959e8dff84c6875$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $5fUc4 = parcelRequire("5fUc4");

var $7P9oy = parcelRequire("7P9oy");

var $cAZ8A = parcelRequire("cAZ8A");
/**
 * Returns the appropriate circle stroke color.
 */ function $0959e8dff84c6875$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $7P9oy.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $7P9oy.N0), ")");
}
var $0959e8dff84c6875$var$rotate = (0, $avKww.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $0959e8dff84c6875$var$rotateStyles = (0, $avKww.css)({
    animation: "".concat($0959e8dff84c6875$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $0959e8dff84c6875$var$loadIn = (0, $avKww.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $0959e8dff84c6875$var$loadInStyles = (0, $avKww.css)({
    animation: "".concat($0959e8dff84c6875$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $0959e8dff84c6875$var$wrapperStyles = (0, $avKww.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $0959e8dff84c6875$var$circleStyles = (0, $avKww.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $0959e8dff84c6875$var$useLayoutEffect = typeof window === "undefined" ? (0, $9nHZC.useEffect) : (0, $9nHZC.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $0959e8dff84c6875$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $cAZ8A.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $0959e8dff84c6875$var$getStrokeColor(appearance);
    var context = (0, $9nHZC.useContext)((0, $5fUc4.default));
    $0959e8dff84c6875$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $avKww.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $0959e8dff84c6875$var$wrapperStyles,
            $0959e8dff84c6875$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $avKww.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $0959e8dff84c6875$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none"
    }, (0, $avKww.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $0959e8dff84c6875$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $0959e8dff84c6875$export$2e2bcd8739ae039 = $0959e8dff84c6875$var$Spinner;

});
parcelRegister("7P9oy", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $5b2495753b7ce7ce$export$215b7063051591f1; });
$parcel$export(module.exports, "N0", function () { return $5b2495753b7ce7ce$export$29a4f05edc054374; });
$parcel$export(module.exports, "N200", function () { return $5b2495753b7ce7ce$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N500", function () { return $5b2495753b7ce7ce$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N800", function () { return $5b2495753b7ce7ce$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $5b2495753b7ce7ce$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $5b2495753b7ce7ce$export$920c0d5c49070351; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $5b2495753b7ce7ce$export$4b84fd0e2c617bd = "#FFEBE6";
var $5b2495753b7ce7ce$export$b34b069eff244586 = "#FFBDAD";
var $5b2495753b7ce7ce$export$be802dd0d8b57f35 = "#FF8F73";
var $5b2495753b7ce7ce$export$60847d42f9da92a6 = "#FF7452";
var $5b2495753b7ce7ce$export$4a7404f376229999 = "#FF5630";
var $5b2495753b7ce7ce$export$2010d0fb4295b346 = "#DE350B";
var $5b2495753b7ce7ce$export$2837b5a1a71d5c02 = "#BF2600";
var $5b2495753b7ce7ce$export$8d9596b529bbb9cf = "#FFFAE6";
var $5b2495753b7ce7ce$export$41060a744ab0b7ae = "#FFF0B3";
var $5b2495753b7ce7ce$export$1cc05bbbf340e559 = "#FFE380";
var $5b2495753b7ce7ce$export$5aae31392d72caaa = "#FFC400";
var $5b2495753b7ce7ce$export$c6930421db9fa514 = "#FFAB00";
var $5b2495753b7ce7ce$export$59619663aa6500fb = "#FF991F";
var $5b2495753b7ce7ce$export$874739ea9e379ab6 = "#FF8B00";
var $5b2495753b7ce7ce$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $5b2495753b7ce7ce$export$69a3bf21b9686c2b = "#ABF5D1";
var $5b2495753b7ce7ce$export$afbce1382ec95f73 = "#79F2C0";
var $5b2495753b7ce7ce$export$747d86715d4175de = "#57D9A3";
var $5b2495753b7ce7ce$export$940e1f69e873f202 = "#36B37E";
var $5b2495753b7ce7ce$export$a49394138f7b8e85 = "#00875A";
var $5b2495753b7ce7ce$export$6fa04827ac68a4fb = "#006644";
var $5b2495753b7ce7ce$export$226de0355ed012f8 = "#DEEBFF";
var $5b2495753b7ce7ce$export$8c13c2ee36917869 = "#B3D4FF";
var $5b2495753b7ce7ce$export$ecfc1dff386a3e7a = "#4C9AFF";
var $5b2495753b7ce7ce$export$215b7063051591f1 = "#2684FF";
var $5b2495753b7ce7ce$export$e62e8919cca44969 = "#0065FF";
var $5b2495753b7ce7ce$export$b3de0ae08da2ce64 = "#0052CC";
var $5b2495753b7ce7ce$export$a6ee3d71bc067634 = "#0747A6";
var $5b2495753b7ce7ce$export$363e4475840015bb = "#EAE6FF";
var $5b2495753b7ce7ce$export$4b0a4417ed59760f = "#C0B6F2";
var $5b2495753b7ce7ce$export$6011520a64d9a187 = "#998DD9";
var $5b2495753b7ce7ce$export$a7175d4e9206bc80 = "#8777D9";
var $5b2495753b7ce7ce$export$b48405b95304b5a1 = "#6554C0";
var $5b2495753b7ce7ce$export$c71e4279dd54a18d = "#5243AA";
var $5b2495753b7ce7ce$export$147899de772240ec = "#403294";
var $5b2495753b7ce7ce$export$2cf711fe14c66f06 = "#E6FCFF";
var $5b2495753b7ce7ce$export$7a8f4d33f6f9772c = "#B3F5FF";
var $5b2495753b7ce7ce$export$776c9c497ef08533 = "#79E2F2";
var $5b2495753b7ce7ce$export$69cb3ca10c1e330e = "#00C7E6";
var $5b2495753b7ce7ce$export$9dc1ef0f3f48059b = "#00B8D9";
var $5b2495753b7ce7ce$export$7c835c78b6fcdef8 = "#00A3BF";
var $5b2495753b7ce7ce$export$6036577f95c3877e = "#008DA6";
var $5b2495753b7ce7ce$export$29a4f05edc054374 = "#FFFFFF";
var $5b2495753b7ce7ce$export$e655ef011c4aa1a2 = "#FAFBFC";
var $5b2495753b7ce7ce$export$9fdfb749e33cdf97 = "#F4F5F7";
var $5b2495753b7ce7ce$export$3e51e8f1440314ba = "#EBECF0";
var $5b2495753b7ce7ce$export$1ce2d1575d444ceb = "#DFE1E6";
var $5b2495753b7ce7ce$export$8754fc7e6d8b3000 = "#C1C7D0";
var $5b2495753b7ce7ce$export$c2e91cbeada39b8b = "#B3BAC5";
var $5b2495753b7ce7ce$export$5f71e19f3a7ad9de = "#A5ADBA";
var $5b2495753b7ce7ce$export$eaa8c8a70ac22806 = "#97A0AF";
var $5b2495753b7ce7ce$export$7c87d337fb91a97d = "#8993A4";
var $5b2495753b7ce7ce$export$d6447c357493214f = "#7A869A";
var $5b2495753b7ce7ce$export$f563ee71e9ee74cd = "#6B778C";
var $5b2495753b7ce7ce$export$e2ef2124cf4024b1 = "#5E6C84";
var $5b2495753b7ce7ce$export$eece5f492e429f08 = "#505F79";
var $5b2495753b7ce7ce$export$c39c0fe0f26207ae = "#42526E";
var $5b2495753b7ce7ce$export$7090862dc3038a9f = "#344563";
var $5b2495753b7ce7ce$export$ad0bacf983b7ddaa = "#253858";
var $5b2495753b7ce7ce$export$7d61b15e0da132af = "#172B4D";
var $5b2495753b7ce7ce$export$fbda843f0a27fe96 = "#091E42";
var $5b2495753b7ce7ce$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $5b2495753b7ce7ce$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $5b2495753b7ce7ce$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $5b2495753b7ce7ce$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $5b2495753b7ce7ce$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $5b2495753b7ce7ce$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $5b2495753b7ce7ce$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $5b2495753b7ce7ce$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $5b2495753b7ce7ce$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $5b2495753b7ce7ce$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $5b2495753b7ce7ce$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $5b2495753b7ce7ce$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $5b2495753b7ce7ce$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $5b2495753b7ce7ce$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $5b2495753b7ce7ce$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $5b2495753b7ce7ce$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $5b2495753b7ce7ce$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $5b2495753b7ce7ce$export$2f6319cf7d736c2a = "#E6EDFA";
var $5b2495753b7ce7ce$export$95126bc8884d6634 = "#DCE5F5";
var $5b2495753b7ce7ce$export$8338d8c35d44ff1 = "#CED9EB";
var $5b2495753b7ce7ce$export$5368d76ae4fbbda7 = "#B8C7E0";
var $5b2495753b7ce7ce$export$9f0a771d16ec8d36 = "#ABBBD6";
var $5b2495753b7ce7ce$export$abcf8c38338b4aa5 = "#9FB0CC";
var $5b2495753b7ce7ce$export$97e81faa16a182c7 = "#8C9CB8";
var $5b2495753b7ce7ce$export$bfe21c59123ecf33 = "#7988A3";
var $5b2495753b7ce7ce$export$ee82aa2ea6a1558 = "#67758F";
var $5b2495753b7ce7ce$export$682927c6ed76be02 = "#56637A";
var $5b2495753b7ce7ce$export$91fd9994c5be9757 = "#455166";
var $5b2495753b7ce7ce$export$d281fbfe3cff2df6 = "#3B475C";
var $5b2495753b7ce7ce$export$3902c91d8b98a753 = "#313D52";
var $5b2495753b7ce7ce$export$8e8133c1ba5845b5 = "#283447";
var $5b2495753b7ce7ce$export$33ff357f6620b39 = "#202B3D";
var $5b2495753b7ce7ce$export$633847cf062b69e0 = "#1B2638";
var $5b2495753b7ce7ce$export$9776a6e503bdbf76 = "#121A29";
var $5b2495753b7ce7ce$export$6c813d5160dff5db = "#0E1624";
var $5b2495753b7ce7ce$export$3d4f271a500072a = "#0D1424";
var $5b2495753b7ce7ce$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $5b2495753b7ce7ce$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $5b2495753b7ce7ce$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $5b2495753b7ce7ce$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $5b2495753b7ce7ce$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $5b2495753b7ce7ce$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $5b2495753b7ce7ce$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $5b2495753b7ce7ce$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $5b2495753b7ce7ce$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $5b2495753b7ce7ce$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $5b2495753b7ce7ce$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $5b2495753b7ce7ce$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $5b2495753b7ce7ce$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $5b2495753b7ce7ce$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $5b2495753b7ce7ce$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $5b2495753b7ce7ce$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $5b2495753b7ce7ce$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";

});

parcelRegister("cAZ8A", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $92b8457127dcc5cf$export$4e9f1640bbe7a1a8; });
var $92b8457127dcc5cf$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("6P4uJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f7afe0bba273cbd$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $avKww = parcelRequire("avKww");
var $4f7afe0bba273cbd$var$actionsStyles = (0, $avKww.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBlockEnd: "var(--ds-space-100, 8px)",
    paddingInlineStart: "var(--ds-space-500, 40px)"
});
/**
 * __Actions container__
 *
 * A container for actions: primary action, secondary action, and tertiary action.
 *
 * @internal
 */ var $4f7afe0bba273cbd$var$ActionsContainer = function ActionsContainer(_ref) {
    var children = _ref.children;
    return (0, $avKww.jsx)("div", {
        css: $4f7afe0bba273cbd$var$actionsStyles
    }, children);
};
var $4f7afe0bba273cbd$export$2e2bcd8739ae039 = $4f7afe0bba273cbd$var$ActionsContainer;

});

parcelRegister("8Pc2y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66cc6d1583c32b14$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $avKww = parcelRequire("avKww");

var $1ApY6 = parcelRequire("1ApY6");
var $66cc6d1583c32b14$var$gridSize = (0, $1ApY6.gridSize)();
var $66cc6d1583c32b14$var$verticalMarginSize = "var(--ds-space-600, 48px)";
var $66cc6d1583c32b14$var$columnWidth = $66cc6d1583c32b14$var$gridSize * 8;
var $66cc6d1583c32b14$var$gutter = $66cc6d1583c32b14$var$gridSize * 2;
var $66cc6d1583c32b14$var$containerStyles = (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: "".concat($66cc6d1583c32b14$var$verticalMarginSize, " auto"),
    textAlign: "center"
});
/* Use max-width so the component can shrink on smaller viewports. */ var $66cc6d1583c32b14$var$wideContainerStyles = (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: "".concat($66cc6d1583c32b14$var$columnWidth * 6 + $66cc6d1583c32b14$var$gutter * 5, "px")
});
var $66cc6d1583c32b14$var$narrowContainerStyles = (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: "".concat($66cc6d1583c32b14$var$columnWidth * 4 + $66cc6d1583c32b14$var$gutter * 3, "px")
});
/**
 * __Container__
 *
 * Upper level container for Empty State.
 *
 * @internal
 */ var $66cc6d1583c32b14$var$Container = function Container(_ref) {
    var children = _ref.children, width = _ref.width, testId = _ref.testId;
    return (0, $avKww.jsx)("div", {
        "data-testid": testId,
        css: [
            $66cc6d1583c32b14$var$containerStyles,
            width === "narrow" ? $66cc6d1583c32b14$var$narrowContainerStyles : $66cc6d1583c32b14$var$wideContainerStyles
        ]
    }, children);
};
var $66cc6d1583c32b14$export$2e2bcd8739ae039 = $66cc6d1583c32b14$var$Container;

});
parcelRegister("1ApY6", function(module, exports) {

$parcel$export(module.exports, "gridSize", function () { return $127d4c00bb84bd22$export$6d8204c2cb2e06b8; });

var $1OnrY = parcelRequire("1OnrY");

var $7P9oy = parcelRequire("7P9oy");
var $127d4c00bb84bd22$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $127d4c00bb84bd22$export$c93026a968943f95 = "light";
var $127d4c00bb84bd22$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $127d4c00bb84bd22$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $127d4c00bb84bd22$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $127d4c00bb84bd22$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $127d4c00bb84bd22$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $127d4c00bb84bd22$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $127d4c00bb84bd22$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $127d4c00bb84bd22$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $7P9oy.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $127d4c00bb84bd22$export$6d8204c2cb2e06b8() / 4;
    (0, $1OnrY.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $127d4c00bb84bd22$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $127d4c00bb84bd22$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $127d4c00bb84bd22$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $1OnrY.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $127d4c00bb84bd22$export$ba1d834b86d72a09 = $127d4c00bb84bd22$export$a1b3edb637fb4f35;
var $127d4c00bb84bd22$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $7P9oy.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $7P9oy.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $7P9oy.N30A), ")")
            }
        }
    };
};

});


parcelRegister("iH7pA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9c1fdf9f27c1472$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $avKww = parcelRequire("avKww");

var $7P9oy = parcelRequire("7P9oy");
var $d9c1fdf9f27c1472$var$descriptionStyles = (0, $avKww.css)({
    color: "var(--ds-text, ".concat((0, $7P9oy.N800), ")"),
    marginBlockEnd: "var(--ds-space-300, 24px)",
    marginBlockStart: "var(--ds-space-0, 0px)"
});
/**
 * __Description__
 *
 * Description of Empty State.
 *
 * @internal
 */ var $d9c1fdf9f27c1472$var$Description = function Description(_ref) {
    var children = _ref.children;
    return (0, $avKww.jsx)("p", {
        css: $d9c1fdf9f27c1472$var$descriptionStyles
    }, children);
};
var $d9c1fdf9f27c1472$export$2e2bcd8739ae039 = $d9c1fdf9f27c1472$var$Description;

});

parcelRegister("aIWNc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ceb9e6a329ce634$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $avKww = parcelRequire("avKww");

var $j9Qey = parcelRequire("j9Qey");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-array-arguments -- Ignored via go/DSP-18766
var $7ceb9e6a329ce634$var$headerStyles = (0, $avKww.css)([
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $j9Qey.h600)(),
    {
        marginTop: "var(--ds-space-0, 0px)",
        marginBottom: "var(--ds-space-200, 16px)"
    }
]);
/**
 * __Header__
 *
 * Header of Empty State.
 *
 * @internal
 */ var $7ceb9e6a329ce634$var$EmptyStateHeader = function EmptyStateHeader(_ref) {
    var children = _ref.children, _ref$level = _ref.level, level = _ref$level === void 0 ? 4 : _ref$level;
    var Tag = "h".concat(level > 0 && level < 7 ? level : level > 6 ? 6 : 4);
    return (0, $avKww.jsx)(Tag, {
        css: $7ceb9e6a329ce634$var$headerStyles
    }, children);
};
var $7ceb9e6a329ce634$export$2e2bcd8739ae039 = $7ceb9e6a329ce634$var$EmptyStateHeader;

});
parcelRegister("j9Qey", function(module, exports) {

$parcel$export(module.exports, "h600", function () { return $df27601c38f2d21d$export$1e8b2acea3fb3119; });

var $kFnE9 = parcelRequire("kFnE9");

var $7P9oy = parcelRequire("7P9oy");

var $1ApY6 = parcelRequire("1ApY6");
function $df27601c38f2d21d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $df27601c38f2d21d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $df27601c38f2d21d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $df27601c38f2d21d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $df27601c38f2d21d$export$2a99220fb32ec798 = {
    heading: {
        xxlarge: 'normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xlarge: 'normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        large: 'normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xsmall: 'normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xxsmall: 'normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    },
    body: {
        large: 'normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        UNSAFE_small: 'normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    }
};
var $df27601c38f2d21d$var$baseHeading = function baseHeading(size, lineHeight) {
    return {
        fontSize: "".concat(size / 14, "em"),
        fontStyle: "inherit",
        lineHeight: lineHeight / size
    };
};
var $df27601c38f2d21d$export$bc02e067df412c3b = {
    h900: {
        size: 35,
        lineHeight: 40
    },
    h800: {
        size: 29,
        lineHeight: 32
    },
    h700: {
        size: 24,
        lineHeight: 28
    },
    h600: {
        size: 20,
        lineHeight: 24
    },
    h500: {
        size: 16,
        lineHeight: 20
    },
    h400: {
        size: 14,
        lineHeight: 16
    },
    h300: {
        size: 12,
        lineHeight: 16
    },
    h200: {
        size: 12,
        lineHeight: 16
    },
    h100: {
        size: 11,
        lineHeight: 16
    }
};
var $df27601c38f2d21d$export$bdb8f897727a9c67 = function h900() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $df27601c38f2d21d$var$_objectSpread($df27601c38f2d21d$var$_objectSpread({}, $df27601c38f2d21d$var$baseHeading($df27601c38f2d21d$export$bc02e067df412c3b.h900.size, $df27601c38f2d21d$export$bc02e067df412c3b.h900.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $7P9oy.N800), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $1ApY6.gridSize)() * 6.5, "px")
    });
};
var $df27601c38f2d21d$export$3953fb6fbd158d23 = function h800() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $df27601c38f2d21d$var$_objectSpread($df27601c38f2d21d$var$_objectSpread({}, $df27601c38f2d21d$var$baseHeading($df27601c38f2d21d$export$bc02e067df412c3b.h800.size, $df27601c38f2d21d$export$bc02e067df412c3b.h800.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $7P9oy.N800), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $1ApY6.gridSize)() * 5, "px")
    });
};
var $df27601c38f2d21d$export$e4f993a313607daa = function h700() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $df27601c38f2d21d$var$_objectSpread($df27601c38f2d21d$var$_objectSpread({}, $df27601c38f2d21d$var$baseHeading($df27601c38f2d21d$export$bc02e067df412c3b.h700.size, $df27601c38f2d21d$export$bc02e067df412c3b.h700.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $7P9oy.N800), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $1ApY6.gridSize)() * 5, "px")
    });
};
var $df27601c38f2d21d$export$1e8b2acea3fb3119 = function h600() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $df27601c38f2d21d$var$_objectSpread($df27601c38f2d21d$var$_objectSpread({}, $df27601c38f2d21d$var$baseHeading($df27601c38f2d21d$export$bc02e067df412c3b.h600.size, $df27601c38f2d21d$export$bc02e067df412c3b.h600.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $7P9oy.N800), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.008em",
        marginTop: "".concat((0, $1ApY6.gridSize)() * 3.5, "px")
    });
};
var $df27601c38f2d21d$export$85aa43a9b9f06707 = function h500() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $df27601c38f2d21d$var$_objectSpread($df27601c38f2d21d$var$_objectSpread({}, $df27601c38f2d21d$var$baseHeading($df27601c38f2d21d$export$bc02e067df412c3b.h500.size, $df27601c38f2d21d$export$bc02e067df412c3b.h500.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $7P9oy.N800), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.006em",
        marginTop: "".concat((0, $1ApY6.gridSize)() * 3, "px")
    });
};
var $df27601c38f2d21d$export$fcb7764b80bd908f = function h400() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $df27601c38f2d21d$var$_objectSpread($df27601c38f2d21d$var$_objectSpread({}, $df27601c38f2d21d$var$baseHeading($df27601c38f2d21d$export$bc02e067df412c3b.h400.size, $df27601c38f2d21d$export$bc02e067df412c3b.h400.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $7P9oy.N800), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.003em",
        marginTop: "".concat((0, $1ApY6.gridSize)() * 2, "px")
    });
};
var $df27601c38f2d21d$export$a0e59c3bbc05e815 = function h300() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $df27601c38f2d21d$var$_objectSpread($df27601c38f2d21d$var$_objectSpread({}, $df27601c38f2d21d$var$baseHeading($df27601c38f2d21d$export$bc02e067df412c3b.h300.size, $df27601c38f2d21d$export$bc02e067df412c3b.h300.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $7P9oy.N800), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $1ApY6.gridSize)() * 2.5, "px"),
        textTransform: "uppercase"
    });
};
var $df27601c38f2d21d$export$7ccf32eb2150ac7e = function h200() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $df27601c38f2d21d$var$_objectSpread($df27601c38f2d21d$var$_objectSpread({}, $df27601c38f2d21d$var$baseHeading($df27601c38f2d21d$export$bc02e067df412c3b.h200.size, $df27601c38f2d21d$export$bc02e067df412c3b.h200.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $7P9oy.N200), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $1ApY6.gridSize)() * 2, "px")
    });
};
var $df27601c38f2d21d$export$dfc0e69214efdc3c = function h100() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $df27601c38f2d21d$var$_objectSpread($df27601c38f2d21d$var$_objectSpread({}, $df27601c38f2d21d$var$baseHeading($df27601c38f2d21d$export$bc02e067df412c3b.h100.size, $df27601c38f2d21d$export$bc02e067df412c3b.h100.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $7P9oy.N200), ")"),
        fontWeight: "var(--ds-font-weight-bold, 700)",
        marginTop: "".concat((0, $1ApY6.gridSize)() * 2, "px")
    });
};

});


parcelRegister("ccdfh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e10e1515a59161b$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");
var $8e10e1515a59161b$var$CSS_VAR_MAX_WIDTH = "--max-width";
var $8e10e1515a59161b$var$CSS_VAR_MAX_HEIGHT = "--max-height";
var $8e10e1515a59161b$var$imageStyles = (0, $avKww.css)({
    display: "block",
    maxWidth: "var(".concat($8e10e1515a59161b$var$CSS_VAR_MAX_WIDTH, ")"),
    maxHeight: "var(".concat($8e10e1515a59161b$var$CSS_VAR_MAX_HEIGHT, ")"),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: "0 auto ".concat("var(--ds-space-300, 24px)")
});
/**
 * __Image__
 *
 * Image in Empty State.
 *
 * @internal
 */ var $8e10e1515a59161b$var$Image = function Image(_ref) {
    var _ref2;
    var maxHeight = _ref.maxHeight, maxWidth = _ref.maxWidth, _ref$height = _ref.height, height = _ref$height === void 0 ? "auto" : _ref$height, _ref$width = _ref.width, width = _ref$width === void 0 ? "auto" : _ref$width, src = _ref.src;
    return (0, $avKww.jsx)("img", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: (_ref2 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref2, $8e10e1515a59161b$var$CSS_VAR_MAX_WIDTH, "".concat(maxWidth, "px")), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref2, $8e10e1515a59161b$var$CSS_VAR_MAX_HEIGHT, "".concat(maxHeight, "px")), _ref2),
        width: width,
        height: height,
        alt: "",
        role: "presentation",
        css: $8e10e1515a59161b$var$imageStyles,
        src: src
    });
};
var $8e10e1515a59161b$export$2e2bcd8739ae039 = $8e10e1515a59161b$var$Image;

});

parcelRegister("dWrZI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2666844f21623ba$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $avKww = parcelRequire("avKww");
var $a2666844f21623ba$var$spinnerContainerStyles = (0, $avKww.css)({
    width: "var(--ds-space-300, 24px)",
    marginInlineStart: "var(--ds-space-200, 16px)"
});
/**
 * __Spinner container__
 *
 * A spinner container for loading state of Empty State.
 *
 * @internal
 */ var $a2666844f21623ba$var$SpinnerContainer = function SpinnerContainer(_ref) {
    var children = _ref.children;
    return (0, $avKww.jsx)("div", {
        css: $a2666844f21623ba$var$spinnerContainerStyles
    }, children);
};
var $a2666844f21623ba$export$2e2bcd8739ae039 = $a2666844f21623ba$var$SpinnerContainer;

});


parcelRegister("bU9Oo", function(module, exports) {

$parcel$export(module.exports, "contextMessages", function () { return $b6017d5e149f9459$export$55294b574c387ed1; });

var $agjvf = parcelRequire("agjvf");

var $gVgNk = parcelRequire("gVgNk");
const $b6017d5e149f9459$export$55294b574c387ed1 = {
    [(0, $gVgNk.CustomMergeChecksResourceType).Repository]: (0, $agjvf.defineMessages)({
        description: {
            "id": "frontbucket.settings.merge-checks-tabs.repository-description",
            "defaultMessage": "Merge checks can improve code quality by setting restrictions about when pull requests can be merged. Merge checks are installed by workspace administrators and can be enabled for repositories in a workspace. {learnMoreLink}."
        },
        learnMoreLinkLabel: {
            "id": "frontbucket.settings.merge-checks-tabs.repository-learn-more-link-label",
            "defaultMessage": "Learn more about merge checks"
        }
    })
};

});
parcelRegister("gVgNk", function(module, exports) {

$parcel$export(module.exports, "CustomMergeChecksResourceType", function () { return $9bc13791178067ad$export$e9d379f8582059d; });
$parcel$export(module.exports, "MergeCheckStateChangeType", function () { return $9bc13791178067ad$export$3de35724620a66a2; });
var $9bc13791178067ad$export$e9d379f8582059d;
(function(CustomMergeChecksResourceType) {
    CustomMergeChecksResourceType["Repository"] = "repository";
})($9bc13791178067ad$export$e9d379f8582059d || ($9bc13791178067ad$export$e9d379f8582059d = {}));
var $9bc13791178067ad$export$3de35724620a66a2;
(function(MergeCheckStateChangeType) {
    MergeCheckStateChangeType["DISABLE"] = "disable";
    MergeCheckStateChangeType["REQUIRED_TO_RECOMMENDED"] = "required-to-recommended";
})($9bc13791178067ad$export$3de35724620a66a2 || ($9bc13791178067ad$export$3de35724620a66a2 = {}));

});


parcelRegister("37goh", function(module, exports) {

$parcel$export(module.exports, "urls", function () { return $88c715e57069b01c$export$bcae9ba627f604b6; });
const $88c715e57069b01c$export$bcae9ba627f604b6 = {
    learnMore: "https://support.atlassian.com/bitbucket-cloud/docs/set-up-and-use-custom-merge-checks/",
    exampleApps: "https://developer.atlassian.com/platform/forge/example-apps-bitbucket/"
};

});

parcelRegister("83bOI", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $5ef137466e8e1202$export$defe85febe8b728c; });

var $agjvf = parcelRequire("agjvf");
const $5ef137466e8e1202$export$defe85febe8b728c = (0, $agjvf.defineMessages)({
    checksNotEnabled: {
        "id": "frontbucket.settings.merge-checks-tabs.checksNotEnabled",
        "defaultMessage": "Merge checks are not enabled in this workspace and requires a workspace admin to enable them in workspace settings."
    },
    installExampleMergeCheckApps: {
        "id": "frontbucket.settings.merge-checks-tabs.installExampleMergeCheckApps",
        "defaultMessage": "Looking for ideas? Install one of our {exampleAppsLink} that use custom merge checks to get started."
    },
    exampleAppsLinkText: {
        "id": "frontbucket.settings.merge-checks-tabs.exampleAppsLinkText",
        "defaultMessage": "example apps"
    }
});

});

parcelRegister("jcOte", function(module, exports) {

module.exports = (parcelRequire("1sJKT")).getBundleURL("ekZ4q") + "merge-checks-empty-state.9f3f5bf0.svg";

});



parcelRegister("9xIRm", function(module, exports) {

$parcel$export(module.exports, "useInstalledCustomMergeChecks", function () { return $7183fea4681157fc$export$a80504a2c0e3d3e5; });
parcelRequire("dOsQd");
var $2U6Qd = parcelRequire("2U6Qd");

var $gbiiY = parcelRequire("gbiiY");
const $7183fea4681157fc$export$caaefa554e9cbe0e = (0, $gbiiY.default)`
  query InstalledCustomMergeChecks($workspaceAri: ID!) {
    extensionContext(contextId: $workspaceAri) {
      extensionsByType(type: "bitbucket:mergeCheck") {
        appId
        id
        name
        properties
      }
    }
  }
`;
const $7183fea4681157fc$export$a80504a2c0e3d3e5 = (workspaceAri)=>(0, $2U6Qd.useQuery)($7183fea4681157fc$export$caaefa554e9cbe0e, {
        variables: {
            workspaceAri: workspaceAri
        },
        // Note that due to Apollo caching, subsequent fetches won't set the
        // `loading` flag in the `useQuery` result. This also won't poll
        // unless the `useQuery` hook is actually being rendered.
        pollInterval: 60000
    });

});

parcelRegister("78qLo", function(module, exports) {

$parcel$export(module.exports, "MergeChecksTabs", function () { return $8480de21db1d0511$export$4abdfc53d6ec5d7d; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $4PnVY = parcelRequire("4PnVY");

var $7ptNF = parcelRequire("7ptNF");
var $56gVi = parcelRequire("56gVi");

var $8Mlkh = parcelRequire("8Mlkh");
var $g7ZmP = parcelRequire("g7ZmP");
var $gHKyL = parcelRequire("gHKyL");
var $1DC1S = parcelRequire("1DC1S");

var $j9ioD = parcelRequire("j9ioD");

var $jajUg = parcelRequire("jajUg");

var $9YOzH = parcelRequire("9YOzH");

var $i9bkK = parcelRequire("i9bkK");

var $bU9Oo = parcelRequire("bU9Oo");

var $12u1t = parcelRequire("12u1t");

var $37goh = parcelRequire("37goh");

var $djFfq = parcelRequire("djFfq");
const $8480de21db1d0511$var$tabWithBadgeStyles = (0, $56gVi.xcss)({
    display: "flex",
    flexDirection: "row"
});
const $8480de21db1d0511$var$TabWithBadge = ({ label: label, enabledChecksCount: enabledChecksCount })=>{
    const tabAttributes = (0, $1DC1S.useTab)();
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7ptNF.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, tabAttributes, {
        xcss: $8480de21db1d0511$var$tabWithBadgeStyles,
        "aria-label": formatMessage((0, $i9bkK.sharedMessages).configurationTabsAriaLabel, {
            tabLabel: label,
            enabledChecks: enabledChecksCount > 0 ? formatMessage((0, $i9bkK.sharedMessages).enabledChecksTooltip, {
                count: enabledChecksCount
            }) : ""
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $12u1t.TabLabel), null, label), enabledChecksCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $j9ioD.default), {
        testId: "merge-checks-tabs-tooltip",
        position: "top",
        content: formatMessage((0, $i9bkK.sharedMessages).enabledChecksTooltip, {
            count: enabledChecksCount
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $4PnVY.default), {
        testId: "merge-checks-tabs-badge"
    }, enabledChecksCount)));
};
const $8480de21db1d0511$export$4abdfc53d6ec5d7d = ({ resourceType: resourceType, customMergeChecksResourceState: customMergeChecksResourceState, installedCustomMergeChecks: installedCustomMergeChecks, checkIdBeingConfigured: checkIdBeingConfigured, onSubmitCheckConfiguration: onSubmitCheckConfiguration })=>{
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    // Generate Sets of CustomMergeCheckKeys for all installed custom merge
    // checks. We use this to display the enabled checks count as a badge on each
    // branch config tab. It's required because
    // `customMergeChecksResourceState.stateMap` can contain entries for merge
    // checks that are no longer installed, so we need to make sure these entries
    // aren't counted on the tab badge.
    const installedCustomMergeCheckKeys = (0, $9nHZC.useMemo)(()=>{
        const m = new Map();
        customMergeChecksResourceState.branchConfigs.forEach((branchConfig)=>{
            m.set(branchConfig, new Set(installedCustomMergeChecks.map((check)=>(0, $djFfq.customMergeCheckKey)(resourceType, branchConfig, check.id))));
        });
        return m;
    }, [
        customMergeChecksResourceState.branchConfigs,
        installedCustomMergeChecks,
        resourceType
    ]);
    const renderTab = (0, $9nHZC.useCallback)((branchConfig)=>{
        const { type: type, identifier: identifier } = branchConfig;
        let label = identifier;
        if (type === "model") switch(identifier){
            case "all_branches":
                label = formatMessage((0, $i9bkK.sharedMessages).allBranchesTabLabel);
                break;
            case "main":
                label = formatMessage((0, $i9bkK.sharedMessages).mainBranchTabLabel);
                break;
        }
        let enabledChecksCount = 0;
        if (customMergeChecksResourceState.stateMap !== undefined) for (const [key, state] of customMergeChecksResourceState.stateMap){
            var _installedCustomMerge;
            if (state !== "off" && (_installedCustomMerge = installedCustomMergeCheckKeys.get(branchConfig)) !== null && _installedCustomMerge !== void 0 && _installedCustomMerge.has(key)) enabledChecksCount += 1;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($8480de21db1d0511$var$TabWithBadge, {
            key: `${type}${identifier}`,
            label: label,
            enabledChecksCount: enabledChecksCount
        });
    }, [
        customMergeChecksResourceState.stateMap,
        formatMessage,
        installedCustomMergeCheckKeys
    ]);
    const renderTabPanel = (0, $9nHZC.useCallback)((branchConfig)=>{
        const { type: type, identifier: identifier } = branchConfig;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $gHKyL.default), {
            key: `${type}${identifier}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $12u1t.TableContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9YOzH.MergeCheckModulesTable), {
            resourceType: resourceType,
            branchConfig: branchConfig,
            installedCheckModules: installedCustomMergeChecks,
            stateMap: customMergeChecksResourceState.stateMap,
            checkIdBeingConfigured: checkIdBeingConfigured,
            onSubmitCheckConfiguration: onSubmitCheckConfiguration
        })));
    }, [
        checkIdBeingConfigured,
        resourceType,
        installedCustomMergeChecks,
        onSubmitCheckConfiguration,
        customMergeChecksResourceState.stateMap
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $12u1t.DescriptionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, (0, $bU9Oo.contextMessages)[resourceType].description, {
        values: {
            learnMoreLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("a", {
                href: (0, $37goh.urls).learnMore,
                target: "_blank"
            }, formatMessage((0, $bU9Oo.contextMessages)[resourceType].learnMoreLinkLabel))
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $8Mlkh.default), {
        id: "default"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $g7ZmP.default), null, customMergeChecksResourceState.branchConfigs.map(renderTab)), customMergeChecksResourceState.branchConfigs.map(renderTabPanel)));
};

});
parcelRegister("4PnVY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $383e7da529bec48e$export$2e2bcd8739ae039; });
/* eslint-disable @atlassian/tangerine/import/entry-points */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $9nHZC = parcelRequire("9nHZC");

var $2qvbw = parcelRequire("2qvbw");

var $kNvkC = parcelRequire("kNvkC");
var $b7Eks = parcelRequire("b7Eks");

var $1vln3 = parcelRequire("1vln3");
var $383e7da529bec48e$var$boxStyles = (0, $b7Eks.xcss)({
    borderRadius: "border.radius.200",
    display: "inline-flex",
    blockSize: "min-content"
});
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ var $383e7da529bec48e$var$Badge = /*#__PURE__*/ (0, $9nHZC.memo)(function Badge(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$children = _ref.children, children = _ref$children === void 0 ? 0 : _ref$children, _ref$max = _ref.max, max = _ref$max === void 0 ? 99 : _ref$max, style = _ref.style, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kNvkC.default), {
        testId: testId,
        as: "span",
        backgroundColor: $383e7da529bec48e$var$backgroundColors[appearance],
        xcss: $383e7da529bec48e$var$boxStyles,
        style: style !== null && style !== void 0 && style.backgroundColor ? {
            backgroundColor: style.backgroundColor
        } : undefined,
        paddingInline: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2qvbw.default), {
        fontSize: "size.075",
        lineHeight: "lineHeight.100",
        textAlign: "center",
        color: $383e7da529bec48e$var$textColors[appearance],
        UNSAFE_style: style !== null && style !== void 0 && style.color ? {
            color: style.color
        } : undefined
    }, typeof children === "number" && max ? (0, $1vln3.formatValue)(children, max) : children));
});
$383e7da529bec48e$var$Badge.displayName = "Badge";
var $383e7da529bec48e$export$2e2bcd8739ae039 = $383e7da529bec48e$var$Badge;
var $383e7da529bec48e$var$backgroundColors = {
    added: "color.background.success",
    default: "color.background.neutral",
    important: "color.background.danger.bold",
    primary: "color.background.brand.bold",
    primaryInverted: "elevation.surface",
    removed: "color.background.danger"
};
var $383e7da529bec48e$var$textColors = {
    added: "success",
    default: "color.text",
    important: "inverse",
    primary: "inverse",
    primaryInverted: "brand",
    removed: "danger"
};

});
parcelRegister("2qvbw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c4633225ca04bb7$export$2e2bcd8739ae039; });

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $4GQn2 = parcelRequire("4GQn2");

var $9T0si = parcelRequire("9T0si");

var $5By32 = parcelRequire("5By32");
var $1c4633225ca04bb7$var$_excluded = [
    "children"
];
var $1c4633225ca04bb7$var$asAllowlist = [
    "span",
    "div",
    "p",
    "strong"
];
var $1c4633225ca04bb7$var$textAlignMap = {
    center: (0, $avKww.css)({
        textAlign: "center"
    }),
    end: (0, $avKww.css)({
        textAlign: "end"
    }),
    start: (0, $avKww.css)({
        textAlign: "start"
    })
};
var $1c4633225ca04bb7$var$textTransformMap = {
    none: (0, $avKww.css)({
        textTransform: "none"
    }),
    lowercase: (0, $avKww.css)({
        textTransform: "lowercase"
    }),
    uppercase: (0, $avKww.css)({
        textTransform: "uppercase"
    })
};
var $1c4633225ca04bb7$var$verticalAlignMap = {
    top: (0, $avKww.css)({
        verticalAlign: "top"
    }),
    middle: (0, $avKww.css)({
        verticalAlign: "middle"
    }),
    bottom: (0, $avKww.css)({
        verticalAlign: "bottom"
    })
};
var $1c4633225ca04bb7$var$baseStyles = (0, $avKww.css)({
    boxSizing: "border-box",
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)"
});
var $1c4633225ca04bb7$var$truncateStyles = (0, $avKww.css)({
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $1c4633225ca04bb7$var$useColor = function useColor(colorProp) {
    var surface = (0, $5By32.useSurface)();
    var inverseTextColor = (0, $9T0si.default)[surface];
    /**
   * Where the color of the surface is inverted we override the user choice
   * as there is no valid choice that is not covered by the override.
   */ var color = inverseTextColor !== null && inverseTextColor !== void 0 ? inverseTextColor : colorProp;
    return color;
};
var $1c4633225ca04bb7$var$HasTextAncestorContext = /*#__PURE__*/ (0, $9nHZC.createContext)(false);
var $1c4633225ca04bb7$var$useHasTextAncestor = function useHasTextAncestor() {
    return (0, $9nHZC.useContext)($1c4633225ca04bb7$var$HasTextAncestorContext);
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $1c4633225ca04bb7$var$Text = function Text(_ref) {
    var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $1c4633225ca04bb7$var$_excluded);
    var _props$as = props.as, Component = _props$as === void 0 ? "span" : _props$as, colorProp = props.color, fontSize = props.fontSize, fontWeight = props.fontWeight, lineHeight = props.lineHeight, _props$shouldTruncate = props.shouldTruncate, shouldTruncate = _props$shouldTruncate === void 0 ? false : _props$shouldTruncate, textAlign = props.textAlign, textTransform = props.textTransform, verticalAlign = props.verticalAlign, testId = props.testId, UNSAFE_style = props.UNSAFE_style, id = props.id;
    (0, $4GQn2.default)($1c4633225ca04bb7$var$asAllowlist.includes(Component), '@atlaskit/ds-explorations: Text received an invalid "as" value of "'.concat(Component, '"'));
    var color = $1c4633225ca04bb7$var$useColor(colorProp);
    var isWrapped = $1c4633225ca04bb7$var$useHasTextAncestor();
    /**
   * If the text is already wrapped and applies no props we can just
   * render the children directly as a fragment.
   */ if (isWrapped && Object.keys(props).length === 0) return (0, $avKww.jsx)((0, $9nHZC.Fragment), null, children);
    var component = (0, $avKww.jsx)(Component, {
        style: UNSAFE_style,
        css: [
            $1c4633225ca04bb7$var$baseStyles,
            $1c4633225ca04bb7$var$fontFamilyMap.sans,
            color && $1c4633225ca04bb7$var$textColorMap[color],
            fontSize && $1c4633225ca04bb7$var$fontSizeMap[fontSize],
            fontWeight && $1c4633225ca04bb7$var$fontWeightMap[fontWeight],
            lineHeight && $1c4633225ca04bb7$var$lineHeightMap[lineHeight],
            shouldTruncate && $1c4633225ca04bb7$var$truncateStyles,
            textAlign && $1c4633225ca04bb7$var$textAlignMap[textAlign],
            textTransform && $1c4633225ca04bb7$var$textTransformMap[textTransform],
            verticalAlign && $1c4633225ca04bb7$var$verticalAlignMap[verticalAlign]
        ],
        "data-testid": testId,
        id: id
    }, children);
    return isWrapped ? // no need to re-apply context if the text is already wrapped
    component : (0, $avKww.jsx)($1c4633225ca04bb7$var$HasTextAncestorContext.Provider, {
        value: true
    }, component);
};
var $1c4633225ca04bb7$export$2e2bcd8739ae039 = $1c4633225ca04bb7$var$Text;
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::203ec574e582b95619dc5a1ff65925c7>>
 * @codegenId typography
 * @codegenCommand yarn codegen-styles
 * @codegenParams ["fontSize", "fontWeight", "fontFamily", "lineHeight"]
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-typography-adg3.tsx <<SignedSource::bfa028f044b5112b83b8e52861d48b2f>>
 */ var $1c4633225ca04bb7$var$fontSizeMap = {
    "size.050": (0, $avKww.css)({
        fontSize: "var(--ds-font-size-050, 11px)"
    }),
    "size.075": (0, $avKww.css)({
        fontSize: "var(--ds-font-size-075, 12px)"
    }),
    "size.100": (0, $avKww.css)({
        fontSize: "var(--ds-font-size-100, 14px)"
    }),
    "size.200": (0, $avKww.css)({
        fontSize: "var(--ds-font-size-200, 16px)"
    }),
    "size.300": (0, $avKww.css)({
        fontSize: "var(--ds-font-size-300, 20px)"
    }),
    "size.400": (0, $avKww.css)({
        fontSize: "var(--ds-font-size-400, 24px)"
    }),
    "size.500": (0, $avKww.css)({
        fontSize: "var(--ds-font-size-500, 29px)"
    }),
    "size.600": (0, $avKww.css)({
        fontSize: "var(--ds-font-size-600, 35px)"
    })
};
var $1c4633225ca04bb7$var$fontWeightMap = {
    bold: (0, $avKww.css)({
        fontWeight: "var(--ds-font-weight-bold, 700)"
    }),
    medium: (0, $avKww.css)({
        fontWeight: "var(--ds-font-weight-medium, 500)"
    }),
    regular: (0, $avKww.css)({
        fontWeight: "var(--ds-font-weight-regular, 400)"
    }),
    semibold: (0, $avKww.css)({
        fontWeight: "var(--ds-font-weight-semibold, 600)"
    })
};
var $1c4633225ca04bb7$var$fontFamilyMap = {
    body: (0, $avKww.css)({
        fontFamily: 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    "brand.body": (0, $avKww.css)({
        fontFamily: 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    "brand.heading": (0, $avKww.css)({
        fontFamily: 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    code: (0, $avKww.css)({
        fontFamily: 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)'
    }),
    heading: (0, $avKww.css)({
        fontFamily: 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    monospace: (0, $avKww.css)({
        fontFamily: 'var(--ds-font-family-monospace, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)'
    }),
    sans: (0, $avKww.css)({
        fontFamily: 'var(--ds-font-family-sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif)'
    })
};
var $1c4633225ca04bb7$var$lineHeightMap = {
    "lineHeight.1": (0, $avKww.css)({
        lineHeight: "var(--ds-font-lineHeight-1, 1)"
    }),
    "lineHeight.100": (0, $avKww.css)({
        lineHeight: "var(--ds-font-lineHeight-100, 16px)"
    }),
    "lineHeight.200": (0, $avKww.css)({
        lineHeight: "var(--ds-font-lineHeight-200, 20px)"
    }),
    "lineHeight.300": (0, $avKww.css)({
        lineHeight: "var(--ds-font-lineHeight-300, 24px)"
    }),
    "lineHeight.400": (0, $avKww.css)({
        lineHeight: "var(--ds-font-lineHeight-400, 28px)"
    }),
    "lineHeight.500": (0, $avKww.css)({
        lineHeight: "var(--ds-font-lineHeight-500, 32px)"
    }),
    "lineHeight.600": (0, $avKww.css)({
        lineHeight: "var(--ds-font-lineHeight-600, 40px)"
    })
};
/**
 * @codegenEnd
 */ /**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::607a969c3ff0c84233d12412b1c104b4>>
 * @codegenId colors
 * @codegenCommand yarn codegen-styles
 * @codegenParams ["text"]
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::eface03157c2df5c1b3b305911d3ed4d>>
 */ var $1c4633225ca04bb7$var$textColorMap = {
    "color.text": (0, $avKww.css)({
        color: "var(--ds-text, #172B4D)"
    }),
    disabled: (0, $avKww.css)({
        color: "var(--ds-text-disabled, #A5ADBA)"
    }),
    inverse: (0, $avKww.css)({
        color: "var(--ds-text-inverse, #FFFFFF)"
    }),
    selected: (0, $avKww.css)({
        color: "var(--ds-text-selected, #0052CC)"
    }),
    brand: (0, $avKww.css)({
        color: "var(--ds-text-brand, #0065FF)"
    }),
    danger: (0, $avKww.css)({
        color: "var(--ds-text-danger, #DE350B)"
    }),
    warning: (0, $avKww.css)({
        color: "var(--ds-text-warning, #974F0C)"
    }),
    "warning.inverse": (0, $avKww.css)({
        color: "var(--ds-text-warning-inverse, #172B4D)"
    }),
    success: (0, $avKww.css)({
        color: "var(--ds-text-success, #006644)"
    }),
    discovery: (0, $avKww.css)({
        color: "var(--ds-text-discovery, #403294)"
    }),
    information: (0, $avKww.css)({
        color: "var(--ds-text-information, #0052CC)"
    }),
    subtlest: (0, $avKww.css)({
        color: "var(--ds-text-subtlest, #7A869A)"
    }),
    subtle: (0, $avKww.css)({
        color: "var(--ds-text-subtle, #42526E)"
    })
}; /**
 * @codegenEnd
 */ 

});
parcelRegister("9T0si", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01db827e312ed832$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * The color map is used to map a background color token to a matching text color that will meet contrast.
 *
 * @codegen <<SignedSource::6d974d81ce795e3ce5be6c5035a69fb4>>
 * @codegenCommand yarn codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::eface03157c2df5c1b3b305911d3ed4d>>
 */ var $01db827e312ed832$export$2e2bcd8739ae039 = {
    "neutral.bold": "inverse",
    "neutral.bold.hovered": "inverse",
    "neutral.bold.pressed": "inverse",
    "selected.bold": "inverse",
    "selected.bold.hovered": "inverse",
    "selected.bold.pressed": "inverse",
    "brand.bold": "inverse",
    "brand.bold.hovered": "inverse",
    "brand.bold.pressed": "inverse",
    "brand.boldest": "inverse",
    "brand.boldest.hovered": "inverse",
    "brand.boldest.pressed": "inverse",
    "danger.bold": "inverse",
    "danger.bold.hovered": "inverse",
    "danger.bold.pressed": "inverse",
    "warning.bold": "warning.inverse",
    "warning.bold.hovered": "warning.inverse",
    "warning.bold.pressed": "warning.inverse",
    "success.bold": "inverse",
    "success.bold.hovered": "inverse",
    "success.bold.pressed": "inverse",
    "discovery.bold": "inverse",
    "discovery.bold.hovered": "inverse",
    "discovery.bold.pressed": "inverse",
    "information.bold": "inverse",
    "information.bold.hovered": "inverse",
    "information.bold.pressed": "inverse"
};

});

parcelRegister("5By32", function(module, exports) {

$parcel$export(module.exports, "useSurface", function () { return $414ad1ad92e6e6fd$export$1aeb4f6b93c4540d; });

var $9nHZC = parcelRequire("9nHZC");
var $414ad1ad92e6e6fd$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $9nHZC.createContext)("elevation.surface");
var $414ad1ad92e6e6fd$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $9nHZC.useContext)($414ad1ad92e6e6fd$export$1ca2a26fecb070ae);
};
$414ad1ad92e6e6fd$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("kNvkC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f240b00f0af231a7$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $7JTNn = parcelRequire("7JTNn");

var $b7Eks = parcelRequire("b7Eks");

var $7ZDuc = parcelRequire("7ZDuc");
var $f240b00f0af231a7$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $f240b00f0af231a7$var$_excluded2 = [
    "className"
];
var $f240b00f0af231a7$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, as = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $f240b00f0af231a7$var$_excluded);
    var Component = as;
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(htmlAttributes, $f240b00f0af231a7$var$_excluded2);
    var className = xcss && (0, $b7Eks.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $avKww.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        css: [
            $f240b00f0af231a7$var$baseStyles,
            backgroundColor && (0, $7JTNn.backgroundColorStylesMap)[backgroundColor],
            (0, $7JTNn.isSurfaceColorToken)(backgroundColor) && (0, $7JTNn.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $7JTNn.paddingStylesMap).padding[padding],
            paddingBlock && (0, $7JTNn.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $7JTNn.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $7JTNn.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $7JTNn.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $7JTNn.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $7JTNn.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            className
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $avKww.jsx)((0, $7ZDuc.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $f240b00f0af231a7$export$2e2bcd8739ae039 = $f240b00f0af231a7$export$e71c4d32a2263218;
var $f240b00f0af231a7$var$baseStyles = (0, $avKww.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("7JTNn", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $5a28042c1565a02b$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $5a28042c1565a02b$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $5a28042c1565a02b$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $5a28042c1565a02b$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $5a28042c1565a02b$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $5a28042c1565a02b$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $5a28042c1565a02b$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $5a28042c1565a02b$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $5a28042c1565a02b$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $5a28042c1565a02b$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $5a28042c1565a02b$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $5a28042c1565a02b$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $5a28042c1565a02b$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $5a28042c1565a02b$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $5a28042c1565a02b$export$5e65a44e5b6ecadb; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $xbX1J = parcelRequire("xbX1J");
function $5a28042c1565a02b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5a28042c1565a02b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5a28042c1565a02b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5a28042c1565a02b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5a28042c1565a02b$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $5a28042c1565a02b$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $5a28042c1565a02b$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $5a28042c1565a02b$export$632685d741f3dbbf = $5a28042c1565a02b$var$_objectSpread($5a28042c1565a02b$var$_objectSpread({}, $5a28042c1565a02b$export$958d0ae7f2977ae4), $5a28042c1565a02b$export$d2dc61f58390201c);
var $5a28042c1565a02b$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $5a28042c1565a02b$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $5a28042c1565a02b$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $5a28042c1565a02b$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $5a28042c1565a02b$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $5a28042c1565a02b$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $5a28042c1565a02b$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)"
};
var $5a28042c1565a02b$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $5a28042c1565a02b$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $5a28042c1565a02b$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $5a28042c1565a02b$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $5a28042c1565a02b$export$6cc560b4dedf3816 = {
    "font.size.050": "var(--ds-font-size-050, 11px)",
    "font.size.075": "var(--ds-font-size-075, 12px)",
    "font.size.100": "var(--ds-font-size-100, 14px)",
    "font.size.200": "var(--ds-font-size-200, 16px)",
    "font.size.300": "var(--ds-font-size-300, 20px)",
    "font.size.400": "var(--ds-font-size-400, 24px)",
    "font.size.500": "var(--ds-font-size-500, 29px)",
    "font.size.600": "var(--ds-font-size-600, 35px)"
};
var $5a28042c1565a02b$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $5a28042c1565a02b$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand": "var(--ds-font-family-brand, Charlie Sans)",
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.monospace": 'var(--ds-font-family-monospace, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.sans": 'var(--ds-font-family-sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif)'
};
var $5a28042c1565a02b$export$360c29a380c1a34 = {
    "font.lineHeight.1": "var(--ds-font-lineHeight-1, 1)",
    "font.lineHeight.100": "var(--ds-font-lineHeight-100, 16px)",
    "font.lineHeight.200": "var(--ds-font-lineHeight-200, 20px)",
    "font.lineHeight.300": "var(--ds-font-lineHeight-300, 24px)",
    "font.lineHeight.400": "var(--ds-font-lineHeight-400, 28px)",
    "font.lineHeight.500": "var(--ds-font-lineHeight-500, 32px)",
    "font.lineHeight.600": "var(--ds-font-lineHeight-600, 40px)"
};
var $5a28042c1565a02b$export$b5bac06d7d8fd0d1 = {
    body: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $5a28042c1565a02b$export$b27166c9cf2c9f74 = {
    ui: 'var(--ds-font-ui, normal 500 14px/1 ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "ui.small": 'var(--ds-font-ui-small, normal 400 11px/1 ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $5a28042c1565a02b$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $5a28042c1565a02b$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $avKww.css)((0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $5a28042c1565a02b$export$e615f061ca585a6c = $5a28042c1565a02b$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $5a28042c1565a02b$var$getSerializedStylesMap(spacingProperty, $5a28042c1565a02b$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $5a28042c1565a02b$export$bf46c3f9eeafc71f = $5a28042c1565a02b$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $5a28042c1565a02b$var$getSerializedStylesMap(spacingProperty, $5a28042c1565a02b$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $5a28042c1565a02b$export$e7af83bafe7f9e63 = $5a28042c1565a02b$var$getSerializedStylesMap("backgroundColor", $5a28042c1565a02b$export$d1d79bf68ac056bd);
var $5a28042c1565a02b$export$3a1bcba60b23d7f0 = $5a28042c1565a02b$var$getSerializedStylesMap("color", $5a28042c1565a02b$export$8473307aa00d6ea1);
var $5a28042c1565a02b$export$f7183c9e2dbc2543 = $5a28042c1565a02b$var$getSerializedStylesMap("fontSize", $5a28042c1565a02b$export$6cc560b4dedf3816);
var $5a28042c1565a02b$export$45f3f4fe16f9f7d5 = $5a28042c1565a02b$var$getSerializedStylesMap("fontWeight", $5a28042c1565a02b$export$303e322c6b1ed114);
var $5a28042c1565a02b$export$68cc305da27dbaa4 = $5a28042c1565a02b$var$getSerializedStylesMap("fontFamily", $5a28042c1565a02b$export$3c7e9587132614b4);
var $5a28042c1565a02b$export$8be4a21014f48eb1 = $5a28042c1565a02b$var$getSerializedStylesMap("lineHeight", $5a28042c1565a02b$export$360c29a380c1a34);
var $5a28042c1565a02b$export$a1962444bbf058e = $5a28042c1565a02b$var$getSerializedStylesMap("font", $5a28042c1565a02b$export$b5bac06d7d8fd0d1);
var $5a28042c1565a02b$export$ca3e246f24657bd6 = $5a28042c1565a02b$var$getSerializedStylesMap("font", $5a28042c1565a02b$export$b27166c9cf2c9f74);
var $5a28042c1565a02b$export$ff257d957d48c421 = $5a28042c1565a02b$var$getSerializedStylesMap((0, $xbX1J.CURRENT_SURFACE_CSS_VAR), $5a28042c1565a02b$export$41a358c9c2356760);
var $5a28042c1565a02b$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $5a28042c1565a02b$export$41a358c9c2356760[color] !== undefined;
};

});

parcelRegister("b7Eks", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $818fa1a6975ccfee$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $818fa1a6975ccfee$export$f6c783d06584602c; });

var $kFnE9 = parcelRequire("kFnE9");

var $9q1kH = parcelRequire("9q1kH");

var $340K4 = parcelRequire("340K4");

var $avKww = parcelRequire("avKww");

var $7JTNn = parcelRequire("7JTNn");

var $8ovux = parcelRequire("8ovux");
var $818fa1a6975ccfee$export$9a199fbafee0014e = {
    backgroundColor: (0, $7JTNn.backgroundColorMap),
    blockSize: (0, $7JTNn.dimensionMap),
    borderBlockColor: (0, $7JTNn.borderColorMap),
    borderBlockEndColor: (0, $7JTNn.borderColorMap),
    borderBlockEndWidth: (0, $7JTNn.borderWidthMap),
    borderBlockStartColor: (0, $7JTNn.borderColorMap),
    borderBlockStartWidth: (0, $7JTNn.borderWidthMap),
    borderBlockWidth: (0, $7JTNn.borderWidthMap),
    borderBottomColor: (0, $7JTNn.borderColorMap),
    borderBottomLeftRadius: (0, $7JTNn.borderRadiusMap),
    borderBottomRightRadius: (0, $7JTNn.borderRadiusMap),
    borderBottomWidth: (0, $7JTNn.borderWidthMap),
    borderColor: (0, $7JTNn.borderColorMap),
    borderEndEndRadius: (0, $7JTNn.borderRadiusMap),
    borderEndStartRadius: (0, $7JTNn.borderRadiusMap),
    borderInlineColor: (0, $7JTNn.borderColorMap),
    borderInlineEndColor: (0, $7JTNn.borderColorMap),
    borderInlineEndWidth: (0, $7JTNn.borderWidthMap),
    borderInlineStartColor: (0, $7JTNn.borderColorMap),
    borderInlineStartWidth: (0, $7JTNn.borderWidthMap),
    borderInlineWidth: (0, $7JTNn.borderWidthMap),
    borderLeftColor: (0, $7JTNn.borderColorMap),
    borderLeftWidth: (0, $7JTNn.borderWidthMap),
    borderRadius: (0, $7JTNn.borderRadiusMap),
    borderRightColor: (0, $7JTNn.borderColorMap),
    borderRightWidth: (0, $7JTNn.borderWidthMap),
    borderStartEndRadius: (0, $7JTNn.borderRadiusMap),
    borderStartStartRadius: (0, $7JTNn.borderRadiusMap),
    borderTopColor: (0, $7JTNn.borderColorMap),
    borderTopLeftRadius: (0, $7JTNn.borderRadiusMap),
    borderTopRightRadius: (0, $7JTNn.borderRadiusMap),
    borderTopWidth: (0, $7JTNn.borderWidthMap),
    borderWidth: (0, $7JTNn.borderWidthMap),
    bottom: (0, $7JTNn.allSpaceMap),
    boxShadow: (0, $7JTNn.shadowMap),
    color: (0, $7JTNn.textColorMap),
    columnGap: (0, $7JTNn.positiveSpaceMap),
    gap: (0, $7JTNn.positiveSpaceMap),
    height: (0, $7JTNn.dimensionMap),
    inlineSize: (0, $7JTNn.dimensionMap),
    inset: (0, $7JTNn.allSpaceMap),
    insetBlock: (0, $7JTNn.allSpaceMap),
    insetBlockEnd: (0, $7JTNn.allSpaceMap),
    insetBlockStart: (0, $7JTNn.allSpaceMap),
    insetInline: (0, $7JTNn.allSpaceMap),
    insetInlineEnd: (0, $7JTNn.allSpaceMap),
    insetInlineStart: (0, $7JTNn.allSpaceMap),
    left: (0, $7JTNn.allSpaceMap),
    margin: (0, $7JTNn.allSpaceMap),
    marginBlock: (0, $7JTNn.allSpaceMap),
    marginBlockEnd: (0, $7JTNn.allSpaceMap),
    marginBlockStart: (0, $7JTNn.allSpaceMap),
    marginBottom: (0, $7JTNn.allSpaceMap),
    marginInline: (0, $7JTNn.allSpaceMap),
    marginInlineEnd: (0, $7JTNn.allSpaceMap),
    marginInlineStart: (0, $7JTNn.allSpaceMap),
    marginLeft: (0, $7JTNn.allSpaceMap),
    marginRight: (0, $7JTNn.allSpaceMap),
    marginTop: (0, $7JTNn.allSpaceMap),
    maxBlockSize: (0, $7JTNn.dimensionMap),
    maxHeight: (0, $7JTNn.dimensionMap),
    maxInlineSize: (0, $7JTNn.dimensionMap),
    maxWidth: (0, $7JTNn.dimensionMap),
    minBlockSize: (0, $7JTNn.dimensionMap),
    minHeight: (0, $7JTNn.dimensionMap),
    minInlineSize: (0, $7JTNn.dimensionMap),
    minWidth: (0, $7JTNn.dimensionMap),
    opacity: (0, $7JTNn.opacityMap),
    outlineColor: (0, $7JTNn.borderColorMap),
    outlineOffset: (0, $7JTNn.positiveSpaceMap),
    outlineWidth: (0, $7JTNn.borderWidthMap),
    padding: (0, $7JTNn.positiveSpaceMap),
    paddingBlock: (0, $7JTNn.positiveSpaceMap),
    paddingBlockEnd: (0, $7JTNn.positiveSpaceMap),
    paddingBlockStart: (0, $7JTNn.positiveSpaceMap),
    paddingBottom: (0, $7JTNn.positiveSpaceMap),
    paddingInline: (0, $7JTNn.positiveSpaceMap),
    paddingInlineEnd: (0, $7JTNn.positiveSpaceMap),
    paddingInlineStart: (0, $7JTNn.positiveSpaceMap),
    paddingLeft: (0, $7JTNn.positiveSpaceMap),
    paddingRight: (0, $7JTNn.positiveSpaceMap),
    paddingTop: (0, $7JTNn.positiveSpaceMap),
    right: (0, $7JTNn.allSpaceMap),
    rowGap: (0, $7JTNn.positiveSpaceMap),
    top: (0, $7JTNn.allSpaceMap),
    width: (0, $7JTNn.dimensionMap),
    zIndex: (0, $7JTNn.layerMap)
};
var $818fa1a6975ccfee$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $818fa1a6975ccfee$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $8ovux === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux.env) === "object" && false;
};
var $818fa1a6975ccfee$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $818fa1a6975ccfee$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $818fa1a6975ccfee$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(value) === "object" && $818fa1a6975ccfee$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($818fa1a6975ccfee$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($818fa1a6975ccfee$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $818fa1a6975ccfee$export$9a199fbafee0014e)) return;
        var tokenValue = $818fa1a6975ccfee$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $818fa1a6975ccfee$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $818fa1a6975ccfee$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, $818fa1a6975ccfee$var$uniqueSymbol, (0, $avKww.css)(transformedStyles));
};
var $818fa1a6975ccfee$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) return args.map(function(x) {
        return x && parseXcss(x);
    }).filter(Boolean);
    var styles = args[$818fa1a6975ccfee$var$uniqueSymbol];
    typeof $8ovux === "undefined" || (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux);
    return styles;
};
function $818fa1a6975ccfee$export$f6c783d06584602c(style) {
    return $818fa1a6975ccfee$var$baseXcss(style);
}

});

parcelRegister("7ZDuc", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $5d1cdc0a617a510c$export$1ca2a26fecb070ae; });

var $9nHZC = parcelRequire("9nHZC");
var $5d1cdc0a617a510c$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $9nHZC.createContext)("elevation.surface");
var $5d1cdc0a617a510c$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $9nHZC.useContext)($5d1cdc0a617a510c$export$1ca2a26fecb070ae);
};
$5d1cdc0a617a510c$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("1vln3", function(module, exports) {

$parcel$export(module.exports, "formatValue", function () { return $11894382a3c8938c$export$7c4d25c0c3217d8c; });
function $11894382a3c8938c$var$getSafeValue() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    if (value < 0) return 0;
    return value;
}
function $11894382a3c8938c$export$7c4d25c0c3217d8c(value, max) {
    var safeValue = $11894382a3c8938c$var$getSafeValue(value);
    var safeMax = $11894382a3c8938c$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return "".concat(safeMax, "+");
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("8Mlkh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66435954b35c3211$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $kmCI9 = parcelRequire("kmCI9");

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $i94lO = parcelRequire("i94lO");

var $duDQO = parcelRequire("duDQO");

var $3aOWN = parcelRequire("3aOWN");

var $ikAVn = parcelRequire("ikAVn");
function $66435954b35c3211$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $66435954b35c3211$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $66435954b35c3211$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $66435954b35c3211$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $66435954b35c3211$var$baseStyles = (0, $avKww.css)({
    display: "flex",
    maxWidth: "100%",
    minHeight: "0%",
    flexBasis: "100%",
    flexDirection: "column",
    flexGrow: 1
});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $66435954b35c3211$var$tabsStyles = (0, $3aOWN.getTabsStyles)();
var $66435954b35c3211$var$analyticsAttributes = {
    componentName: "tabs",
    packageName: "@atlaskit/tabs",
    packageVersion: "14.1.0"
};
var $66435954b35c3211$var$getTabPanelWithContext = function getTabPanelWithContext(_ref) {
    var tabPanel = _ref.tabPanel, index = _ref.index, isSelected = _ref.isSelected, tabsId = _ref.tabsId;
    return(// Ensure tabPanel exists in case it has been removed
    tabPanel && (0, $avKww.jsx)((0, $duDQO.TabPanelContext).Provider, {
        value: {
            role: "tabpanel",
            id: "".concat(tabsId, "-").concat(index, "-tab"),
            hidden: isSelected ? undefined : true,
            "aria-labelledby": "".concat(tabsId, "-").concat(index),
            onMouseDown: (0, $ikAVn.onMouseDownBlur),
            tabIndex: isSelected ? 0 : -1
        },
        key: index
    }, tabPanel));
};
/**
 * __Tabs__
 *
 * Tabs acts as a container for all Tab components.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $66435954b35c3211$var$Tabs = function Tabs(props) {
    var _props$shouldUnmountT = props.shouldUnmountTabPanelOnChange, shouldUnmountTabPanelOnChange = _props$shouldUnmountT === void 0 ? false : _props$shouldUnmountT, SelectedType = props.selected, defaultSelected = props.defaultSelected, onChangeProp = props.onChange, id = props.id, analyticsContext = props.analyticsContext, children = props.children, testId = props.testId;
    var _useState = (0, $9nHZC.useState)(SelectedType || defaultSelected || 0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), selectedState = _useState2[0], setSelected = _useState2[1];
    var selected = SelectedType === undefined ? selectedState : SelectedType;
    var childrenArray = (0, $9nHZC.Children).toArray(children)// Don't include any conditional children
    .filter(function(child) {
        return Boolean(child);
    });
    // First child should be a tabList followed by tab panels
    var _childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($kmCI9)))(childrenArray), tabList = _childrenArray[0], tabPanels = _childrenArray.slice(1);
    // Keep track of visited and add to a set
    var visited = (0, $9nHZC.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    var onChange = (0, $9nHZC.useCallback)(function(index, analyticsEvent) {
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    var onChangeAnalytics = (0, $i94lO.usePlatformLeafEventHandler)($66435954b35c3211$var$_objectSpread({
        fn: onChange,
        action: "clicked",
        analyticsData: analyticsContext
    }, $66435954b35c3211$var$analyticsAttributes));
    var tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $66435954b35c3211$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map(function(tabIndex) {
        return $66435954b35c3211$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        });
    });
    return(// Only styles that affect the Tabs container itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTabPanel(),
    // which applies accessibility attributes that we use as a styling hook.
    (0, $avKww.jsx)("div", {
        "data-testid": testId,
        css: [
            $66435954b35c3211$var$baseStyles,
            $66435954b35c3211$var$tabsStyles
        ]
    }, (0, $avKww.jsx)((0, $duDQO.TabListContext).Provider, {
        value: {
            selected: selected,
            onChange: onChangeAnalytics,
            tabsId: id
        }
    }, tabList), (0, $avKww.jsx)((0, $9nHZC.Fragment), null, tabPanelsWithContext)));
};
var $66435954b35c3211$export$2e2bcd8739ae039 = $66435954b35c3211$var$Tabs;

});
parcelRegister("kmCI9", function(module, exports) {

var $ZIKor = parcelRequire("ZIKor");

var $cK5mg = parcelRequire("cK5mg");

var $fWTDc = parcelRequire("fWTDc");

var $8qOET = parcelRequire("8qOET");
function $ed33e3f29db82256$var$_toArray(r) {
    return $ZIKor(r) || $cK5mg(r) || $fWTDc(r) || $8qOET();
}
module.exports = $ed33e3f29db82256$var$_toArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("i94lO", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $d35c7138f1920940$export$a4687b0234b40e28; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $keB1p = parcelRequire("keB1p");

var $c7tCF = parcelRequire("c7tCF");
function $d35c7138f1920940$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d35c7138f1920940$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d35c7138f1920940$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d35c7138f1920940$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d35c7138f1920940$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $keB1p.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $c7tCF.useTrackedRef)(analyticsData);
    var fnRef = (0, $c7tCF.useTrackedRef)(fn);
    var handler = (0, $9nHZC.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $d35c7138f1920940$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("keB1p", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $ebb1d530e958ff54$export$5bf35293e545f20c; });

var $dNznA = parcelRequire("dNznA");

var $a3UIi = parcelRequire("a3UIi");

var $iHpy9 = parcelRequire("iHpy9");
function $ebb1d530e958ff54$export$5bf35293e545f20c() {
    var analyticsContext = (0, $iHpy9.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $a3UIi.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("a3UIi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75362d4db7af5169$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $hzMX3 = parcelRequire("hzMX3");
function $75362d4db7af5169$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $75362d4db7af5169$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $75362d4db7af5169$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($75362d4db7af5169$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $75362d4db7af5169$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $75362d4db7af5169$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $75362d4db7af5169$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $75362d4db7af5169$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $hzMX3.default));

});
parcelRegister("hzMX3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccbbad4c4512d64c$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
function $ccbbad4c4512d64c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ccbbad4c4512d64c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ccbbad4c4512d64c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ccbbad4c4512d64c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ccbbad4c4512d64c$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $ccbbad4c4512d64c$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $ccbbad4c4512d64c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $ccbbad4c4512d64c$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(updater) === "object") this.payload = $ccbbad4c4512d64c$var$_objectSpread($ccbbad4c4512d64c$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("iHpy9", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $d9d00fd4ff321214$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $d9d00fd4ff321214$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});


parcelRegister("c7tCF", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $8d2d1df39ed9cca4$export$1d27a74659855e44; });

var $9nHZC = parcelRequire("9nHZC");
var $8d2d1df39ed9cca4$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("duDQO", function(module, exports) {

$parcel$export(module.exports, "TabContext", function () { return $9d2cfd3e72ec8867$export$5a5d356ca5f10a0a; });
$parcel$export(module.exports, "TabListContext", function () { return $9d2cfd3e72ec8867$export$aa6907f9fd69e93b; });
$parcel$export(module.exports, "TabPanelContext", function () { return $9d2cfd3e72ec8867$export$2054129d247c3102; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $9nHZC = parcelRequire("9nHZC");
var $9d2cfd3e72ec8867$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $9nHZC.createContext)(null);
var $9d2cfd3e72ec8867$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $9nHZC.createContext)(null);
var $9d2cfd3e72ec8867$export$2054129d247c3102 = /*#__PURE__*/ (0, $9nHZC.createContext)(null);

});

parcelRegister("3aOWN", function(module, exports) {

$parcel$export(module.exports, "getTabsStyles", function () { return $24f9d3594c597a95$export$dd5afd2190fb792c; });
$parcel$export(module.exports, "getTabListStyles", function () { return $24f9d3594c597a95$export$42a3c683c377bcb2; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $dbRQ7 = parcelRequire("dbRQ7");
function $24f9d3594c597a95$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $24f9d3594c597a95$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $24f9d3594c597a95$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $24f9d3594c597a95$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $24f9d3594c597a95$var$tabLeftRightPadding = "var(--ds-space-100, 8px)";
var $24f9d3594c597a95$var$tabTopBottomPadding = "var(--ds-space-050, 4px)";
// TODO this should probably be `border.width.indicator`
var $24f9d3594c597a95$var$underlineHeight = "var(--ds-border-width-outline, 2px)";
var $24f9d3594c597a95$var$getTabPanelStyles = function getTabPanelStyles() {
    return {
        flexGrow: 1,
        /*
      NOTE min-height set to 0% because of Firefox bug
      FF http://stackoverflow.com/questions/28636832/firefox-overflow-y-not-working-with-nested-flexbox
    */ minHeight: "0%",
        display: "flex",
        padding: "0 ".concat($24f9d3594c597a95$var$tabLeftRightPadding)
    };
};
var $24f9d3594c597a95$export$dd5afd2190fb792c = function getTabsStyles() {
    return(// eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $avKww.css)({
        '& [role="tabpanel"]': $24f9d3594c597a95$var$getTabPanelStyles(),
        // The hidden attribute doesn't work on flex elements
        // Change display to be none
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "& > [hidden]": {
            display: "none"
        }
    }));
};
var $24f9d3594c597a95$var$tabLineStyles = {
    content: '""',
    borderRadius: "var(--ds-border-radius-050, 2px)",
    bottom: 0,
    margin: 0,
    position: "absolute",
    width: "inherit",
    left: $24f9d3594c597a95$var$tabLeftRightPadding,
    right: $24f9d3594c597a95$var$tabLeftRightPadding
};
var $24f9d3594c597a95$export$42a3c683c377bcb2 = function getTabListStyles() {
    return(// eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $avKww.css)({
        '& [role="tab"]': $24f9d3594c597a95$export$916c8b0fccbb37d2(),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        "&::before": $24f9d3594c597a95$var$_objectSpread($24f9d3594c597a95$var$_objectSpread({}, $24f9d3594c597a95$var$tabLineStyles), {}, {
            height: $24f9d3594c597a95$var$underlineHeight,
            // This line is not a border so the selected line is visible in high contrast mode
            backgroundColor: (0, $dbRQ7.tabLineColors).lineColor
        })
    }));
};
var $24f9d3594c597a95$export$916c8b0fccbb37d2 = function getTabStyles() {
    var colors = (0, $dbRQ7.tabColors);
    return {
        color: colors.labelColor,
        cursor: "pointer",
        lineHeight: 1.8,
        margin: 0,
        padding: "".concat($24f9d3594c597a95$var$tabTopBottomPadding, " ").concat($24f9d3594c597a95$var$tabLeftRightPadding),
        position: "relative",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        "&:hover": {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.hoverLabelColor,
            "&::after": $24f9d3594c597a95$var$_objectSpread($24f9d3594c597a95$var$_objectSpread({}, $24f9d3594c597a95$var$tabLineStyles), {}, {
                borderBottom: "".concat($24f9d3594c597a95$var$underlineHeight, " solid ").concat((0, $dbRQ7.tabLineColors).hoveredColor),
                height: 0
            })
        },
        "&:active": {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.activeLabelColor,
            "&::after": $24f9d3594c597a95$var$_objectSpread($24f9d3594c597a95$var$_objectSpread({}, $24f9d3594c597a95$var$tabLineStyles), {}, {
                borderBottom: "".concat($24f9d3594c597a95$var$underlineHeight, " solid ").concat((0, $dbRQ7.tabLineColors).activeColor),
                height: 0
            })
        },
        '&[aria-selected="true"]': {
            color: colors.selectedColor,
            "&::after": $24f9d3594c597a95$var$_objectSpread($24f9d3594c597a95$var$_objectSpread({}, $24f9d3594c597a95$var$tabLineStyles), {}, {
                // This line is a border so it is visible in high contrast mode
                borderBottom: "".concat($24f9d3594c597a95$var$underlineHeight, " solid ").concat((0, $dbRQ7.tabLineColors).selectedColor),
                height: 0
            })
        }
    };
};

});
parcelRegister("dbRQ7", function(module, exports) {

$parcel$export(module.exports, "tabColors", function () { return $99a610dc0cdbf533$export$5159a1ad8efe50bc; });
$parcel$export(module.exports, "tabLineColors", function () { return $99a610dc0cdbf533$export$6be6fa4649b31472; });

var $jp7ng = parcelRequire("jp7ng");
var $99a610dc0cdbf533$export$5159a1ad8efe50bc = {
    labelColor: "var(--ds-text-subtle, ".concat((0, $jp7ng.N500), ")"),
    activeLabelColor: "var(--ds-text, ".concat((0, $jp7ng.B500), ")"),
    hoverLabelColor: "var(--ds-text-subtle, ".concat((0, $jp7ng.B400), ")"),
    selectedColor: "var(--ds-text-selected, ".concat((0, $jp7ng.B400), ")"),
    focusBorderColor: "var(--ds-border-focused, ".concat((0, $jp7ng.B100), ")")
};
var $99a610dc0cdbf533$export$6be6fa4649b31472 = {
    lineColor: "var(--ds-border, ".concat((0, $jp7ng.N30), ")"),
    hoveredColor: "var(--ds-border, transparent)",
    activeColor: "var(--ds-border, transparent)",
    selectedColor: "var(--ds-border-selected, ".concat((0, $jp7ng.B400), ")")
};

});


parcelRegister("ikAVn", function(module, exports) {

$parcel$export(module.exports, "onMouseDownBlur", function () { return $d586bcab4cf1da23$export$1aedf39a68fc0142; });
// Prevent a focus ring if clicked
var $d586bcab4cf1da23$export$1aedf39a68fc0142 = function onMouseDownBlur(e) {
    var currentTarget = e.currentTarget;
    var focusedDuringMouseDown = currentTarget === document.activeElement;
    requestAnimationFrame(function() {
        if (focusedDuringMouseDown && currentTarget !== document.activeElement && document.body.contains(currentTarget)) {
            currentTarget.focus();
            return;
        }
        if (!focusedDuringMouseDown && document.body.contains(currentTarget)) currentTarget.blur();
    });
};

});


parcelRegister("g7ZmP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbdce7041d0ba574$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $1DC1S = parcelRequire("1DC1S");

var $duDQO = parcelRequire("duDQO");

var $3aOWN = parcelRequire("3aOWN");

var $ikAVn = parcelRequire("ikAVn");
var $bbdce7041d0ba574$var$baseStyles = (0, $avKww.css)({
    display: "flex",
    padding: "var(--ds-space-0, 0px)",
    position: "relative"
});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $bbdce7041d0ba574$var$tabListStyles = (0, $3aOWN.getTabListStyles)();
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $bbdce7041d0ba574$var$TabList = function TabList(_ref) {
    var children = _ref.children;
    var _useTabList = (0, $1DC1S.useTabList)(), tabsId = _useTabList.tabsId, selected = _useTabList.selected, onChange = _useTabList.onChange;
    var ref = /*#__PURE__*/ (0, $9nHZC.createRef)();
    // Don't include any conditional children
    var childrenArray = (0, $9nHZC.Children).toArray(children).filter(Boolean);
    var length = childrenArray.length;
    var selectTabByIndex = (0, $9nHZC.useCallback)(function(index) {
        var _ref$current;
        var newSelectedNode = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.querySelector("[id='".concat(tabsId, "-").concat(index, "']"));
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    var onKeyDown = (0, $9nHZC.useCallback)(function(e) {
        if (![
            "ArrowRight",
            "ArrowLeft",
            "Home",
            "End"
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        var lastTabIndex = length - 1;
        if ([
            "Home",
            "End"
        ].includes(e.key)) {
            var _newSelected = e.key === "Home" ? 0 : lastTabIndex;
            selectTabByIndex(_newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        var selectedIndex = parseInt(e.currentTarget.getAttribute("aria-posinset") || "0") - 1;
        var modifier = e.key === "ArrowRight" ? 1 : -1;
        var newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    var getTabWithContext = (0, $9nHZC.useCallback)(function(_ref2) {
        var tab = _ref2.tab, isSelected = _ref2.isSelected, index = _ref2.index;
        return (0, $avKww.jsx)((0, $duDQO.TabContext).Provider, {
            value: {
                onClick: function onClick() {
                    return onChange(index);
                },
                onMouseDown: (0, $ikAVn.onMouseDownBlur),
                onKeyDown: onKeyDown,
                "aria-setsize": length,
                role: "tab",
                id: "".concat(tabsId, "-").concat(index),
                "aria-posinset": index + 1,
                "aria-selected": isSelected,
                "aria-controls": "".concat(tabsId, "-").concat(index, "-tab"),
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tab);
    }, [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return(// Only styles that affect the TabList itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTab(),
    // which applies accessibility atributes that we use as a styling hook.
    (0, $avKww.jsx)("div", {
        role: "tablist",
        ref: ref,
        css: [
            $bbdce7041d0ba574$var$baseStyles,
            $bbdce7041d0ba574$var$tabListStyles
        ]
    }, childrenArray.map(function(child, index) {
        return getTabWithContext({
            tab: child,
            index: index,
            isSelected: index === selected
        });
    })));
};
var $bbdce7041d0ba574$export$2e2bcd8739ae039 = $bbdce7041d0ba574$var$TabList;

});
parcelRegister("1DC1S", function(module, exports) {

$parcel$export(module.exports, "useTab", function () { return $1316eec4b3ff93e8$export$fdf4756d5b8ef90a; });
$parcel$export(module.exports, "useTabList", function () { return $1316eec4b3ff93e8$export$773e389e644c5874; });
$parcel$export(module.exports, "useTabPanel", function () { return $1316eec4b3ff93e8$export$fae0121b5afe572d; });

var $9nHZC = parcelRequire("9nHZC");

var $duDQO = parcelRequire("duDQO");
var $1316eec4b3ff93e8$export$fdf4756d5b8ef90a = function useTab() {
    var tabData = (0, $9nHZC.useContext)((0, $duDQO.TabContext));
    if (tabData == null || typeof tabData === "undefined") throw Error("@atlaskit/tabs: A Tab must have a TabList parent.");
    return tabData;
};
var $1316eec4b3ff93e8$export$773e389e644c5874 = function useTabList() {
    var tabListData = (0, $9nHZC.useContext)((0, $duDQO.TabListContext));
    if (tabListData === null || typeof tabListData === "undefined") throw Error("@atlaskit/tabs: A TabList must have a Tabs parent.");
    return tabListData;
};
var $1316eec4b3ff93e8$export$fae0121b5afe572d = function useTabPanel() {
    var tabPanelData = (0, $9nHZC.useContext)((0, $duDQO.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === "undefined") throw Error("@atlaskit/tabs:  A TabPanel must have a Tabs parent.");
    return tabPanelData;
};

});


parcelRegister("gHKyL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c294c744c178b8e3$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $dxhCu = parcelRequire("dxhCu");

var $1DC1S = parcelRequire("1DC1S");
// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $c294c744c178b8e3$var$TabPanel = function TabPanel(_ref) {
    var children = _ref.children, testId = _ref.testId;
    var _useTabPanel = (0, $1DC1S.useTabPanel)(), role = _useTabPanel.role, id = _useTabPanel.id, hidden = _useTabPanel.hidden, ariaLabelledBy = _useTabPanel["aria-labelledby"], onMouseDown = _useTabPanel.onMouseDown, tabIndex = _useTabPanel.tabIndex;
    return (0, $avKww.jsx)((0, $dxhCu.default), {
        isInset: true
    }, (0, $avKww.jsx)("div", {
        "data-testid": testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        onMouseDown: onMouseDown,
        tabIndex: tabIndex
    }, (0, $avKww.jsx)((0, $9nHZC.Fragment), null, children)));
};
var $c294c744c178b8e3$export$2e2bcd8739ae039 = $c294c744c178b8e3$var$TabPanel;

});

parcelRegister("j9ioD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df0d20bc578431d0$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9q1kH = parcelRequire("9q1kH");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $63OTf = parcelRequire("63OTf");

var $kwl2v = parcelRequire("kwl2v");

var $8p2GL = parcelRequire("8p2GL");

var $ay1rd = parcelRequire("ay1rd");

var $JcvLo = parcelRequire("JcvLo");
var $gWA00 = parcelRequire("gWA00");

var $htChF = parcelRequire("htChF");

var $e5M8I = parcelRequire("e5M8I");

var $97YIy = parcelRequire("97YIy");

var $aP6k3 = parcelRequire("aP6k3");

var $8lTgW = parcelRequire("8lTgW");

var $hhLg8 = parcelRequire("hhLg8");

var $5N2W9 = parcelRequire("5N2W9");

var $7KtnP = parcelRequire("7KtnP");

var $9c24i = parcelRequire("9c24i");
function $df0d20bc578431d0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $df0d20bc578431d0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $df0d20bc578431d0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $df0d20bc578431d0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $df0d20bc578431d0$var$tooltipZIndex = (0, $aP6k3.layers).tooltip();
var $df0d20bc578431d0$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "18.1.1"
};
// Inverts motion direction
var $df0d20bc578431d0$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param position - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $df0d20bc578431d0$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
function $df0d20bc578431d0$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $7KtnP.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $8p2GL.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $8p2GL.default) : _ref$onHide, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy;
    var tooltipPosition = position === "mouse" ? mousePosition : position;
    var onShowHandler = (0, $kwl2v.usePlatformLeafSyntheticEventHandler)($df0d20bc578431d0$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $df0d20bc578431d0$var$analyticsAttributes));
    var onHideHandler = (0, $kwl2v.usePlatformLeafSyntheticEventHandler)($df0d20bc578431d0$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $df0d20bc578431d0$var$analyticsAttributes));
    var apiRef = (0, $9nHZC.useRef)(null);
    var _useState = (0, $9nHZC.useState)("hide"), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $9nHZC.useRef)(null);
    var containerRef = (0, $9nHZC.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $9nHZC.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var lastState = (0, $9nHZC.useRef)(state);
    var lastDelay = (0, $9nHZC.useRef)(delay);
    var lastHandlers = (0, $9nHZC.useRef)({
        onShowHandler: onShowHandler,
        onHideHandler: onHideHandler
    });
    var hasCalledShowHandler = (0, $9nHZC.useRef)(false);
    (0, $9nHZC.useEffect)(function() {
        lastState.current = state;
        lastDelay.current = delay;
        lastHandlers.current = {
            onShowHandler: onShowHandler,
            onHideHandler: onHideHandler
        };
    }, [
        delay,
        onHideHandler,
        onShowHandler,
        state
    ]);
    var start = (0, $9nHZC.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $9nHZC.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, []);
    var abort = (0, $9nHZC.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
    }, []);
    (0, $9nHZC.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $9nHZC.useRef)(false);
    (0, $9nHZC.useEffect)(function() {
        return (0, $8lTgW.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var showTooltip = (0, $9nHZC.useCallback)(function(source) {
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // Tell the tooltip to keep showing
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        var entry = {
            source: source,
            delay: lastDelay.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    lastHandlers.current.onShowHandler();
                }
                setState(isImmediate ? "show-immediate" : "fade-in");
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done
        };
        var api = (0, $hhLg8.show)(entry);
        start(api);
    }, [
        abort,
        done,
        start
    ]);
    var hideTooltipOnEsc = (0, $9nHZC.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $ay1rd.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $9nHZC.useEffect)(function() {
        if (state === "hide") return 0, $8p2GL.default;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $63OTf.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $9nHZC.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $9nHZC.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $9nHZC.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === "mouse" ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            mouse: (0, $9c24i.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: "keyboard"
        };
        showTooltip(source);
    }, [
        position,
        showTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $9nHZC.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === "mouse" ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $9c24i.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $9nHZC.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $9nHZC.useCallback)(function() {
        showTooltip({
            type: "keyboard"
        });
    }, [
        showTooltip
    ]);
    var onBlur = (0, $9nHZC.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $9nHZC.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && lastState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, []);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipContainer = state !== "hide" && Boolean(content);
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current4;
        if (position === "mouse" && (_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.mousePosition) {
            var _apiRef$current5;
            return (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 ? void 0 : _apiRef$current5.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipId = (0, $5N2W9.default)("tooltip", shouldRenderTooltipContainer);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    (0, $9nHZC.useEffect)(function() {
        // If there is no container element, we should exit early, because that
        // means they are using the render prop API, and that is implemented in a
        // different way. If there is no target element yet or tooltipId, we also
        // shouldn't do anything because there is nothing to operate on or with.
        if (!containerRef.current || !targetRef.current || !tooltipId) return;
        var target = targetRef.current;
        if (shouldRenderTooltipContainer) target.setAttribute("aria-describedby", tooltipId);
        else target.removeAttribute("aria-describedby");
    }, [
        shouldRenderTooltipContainer,
        tooltipId
    ]);
    var hiddenContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipId
    }, typeof content === "function" ? content({}) : content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, typeof children === "function" ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, children($df0d20bc578431d0$var$_objectSpread($df0d20bc578431d0$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipId,
        ref: setDirectRef
    })), shouldRenderTooltipContainer && hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, shouldRenderTooltipContainer && hiddenContent), shouldRenderTooltipContainer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $97YIy.default), {
        zIndex: $df0d20bc578431d0$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $e5M8I.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === "mouse" ? undefined : $df0d20bc578431d0$var$invertedDirection[$df0d20bc578431d0$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $JcvLo.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $gWA00.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state === "show-immediate" ? 0 : (0, $htChF.mediumDurationMs)
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: style,
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$df0d20bc578431d0$var$Tooltip.displayName = "Tooltip";
var $df0d20bc578431d0$export$2e2bcd8739ae039 = $df0d20bc578431d0$var$Tooltip;

});
parcelRegister("63OTf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $4p7CO = parcelRequire("4p7CO");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $4p7CO.bind;
    }
});

var $7dkVZ = parcelRequire("7dkVZ");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $7dkVZ.bindAll;
    }
});

});
parcelRegister("4p7CO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $334f6966490652a8$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $334f6966490652a8$var$bind;

});

parcelRegister("7dkVZ", function(module, exports) {
"use strict";
var $5409fc6c0c7c1355$var$__assign = module.exports && module.exports.__assign || function() {
    $5409fc6c0c7c1355$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5409fc6c0c7c1355$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $4p7CO = parcelRequire("4p7CO");
function $5409fc6c0c7c1355$var$toOptions(value) {
    if (typeof value === "undefined") return undefined;
    if (typeof value === "boolean") return {
        capture: value
    };
    return value;
}
function $5409fc6c0c7c1355$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $5409fc6c0c7c1355$var$__assign($5409fc6c0c7c1355$var$__assign({}, original), {
        options: $5409fc6c0c7c1355$var$__assign($5409fc6c0c7c1355$var$__assign({}, $5409fc6c0c7c1355$var$toOptions(sharedOptions)), $5409fc6c0c7c1355$var$toOptions(original.options))
    });
    return binding;
}
function $5409fc6c0c7c1355$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $5409fc6c0c7c1355$var$getBinding(original, sharedOptions);
        return (0, $4p7CO.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $5409fc6c0c7c1355$var$bindAll;

});


parcelRegister("kwl2v", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $ef071dd014481c6c$export$1a04351537078b55; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $2fAOH = parcelRequire("2fAOH");

var $5vk8y = parcelRequire("5vk8y");
function $ef071dd014481c6c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ef071dd014481c6c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ef071dd014481c6c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ef071dd014481c6c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ef071dd014481c6c$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $2fAOH.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $5vk8y.useTrackedRef)(analyticsData);
    var fnRef = (0, $5vk8y.useTrackedRef)(fn);
    var handler = (0, $9nHZC.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $ef071dd014481c6c$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("2fAOH", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $1a398a814a79ca94$export$5bf35293e545f20c; });

var $dNznA = parcelRequire("dNznA");

var $1eIx0 = parcelRequire("1eIx0");

var $jQvGH = parcelRequire("jQvGH");
function $1a398a814a79ca94$export$5bf35293e545f20c() {
    var analyticsContext = (0, $jQvGH.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $1eIx0.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("1eIx0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e69a43fc86532da$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $ipK6b = parcelRequire("ipK6b");
function $0e69a43fc86532da$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $0e69a43fc86532da$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $0e69a43fc86532da$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0e69a43fc86532da$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $0e69a43fc86532da$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $0e69a43fc86532da$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $0e69a43fc86532da$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $0e69a43fc86532da$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $ipK6b.default));

});
parcelRegister("ipK6b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d67e5206c160a711$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
function $d67e5206c160a711$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d67e5206c160a711$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d67e5206c160a711$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d67e5206c160a711$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d67e5206c160a711$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $d67e5206c160a711$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $d67e5206c160a711$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $d67e5206c160a711$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(updater) === "object") this.payload = $d67e5206c160a711$var$_objectSpread($d67e5206c160a711$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("jQvGH", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $e72b742a3fdbf87e$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $e72b742a3fdbf87e$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});


parcelRegister("5vk8y", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $401f77c7c2a76d2d$export$1d27a74659855e44; });

var $9nHZC = parcelRequire("9nHZC");
var $401f77c7c2a76d2d$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("ay1rd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ade31e659738cce$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $1FiMp = parcelRequire("1FiMp");

var $70mT6 = parcelRequire("70mT6");
function $7ade31e659738cce$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $9nHZC.useRef)(false);
    var onKeyDown = (0, $9nHZC.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $70mT6.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $9nHZC.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $9nHZC.useEffect)(function() {
        return (0, $1FiMp.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});
parcelRegister("70mT6", function(module, exports) {

$parcel$export(module.exports, "KEY_UP", function () { return $519a4989205d241f$export$390330c10ff2b9a1; });
$parcel$export(module.exports, "KEY_DOWN", function () { return $519a4989205d241f$export$a80636c6f41931fe; });
$parcel$export(module.exports, "KEY_HOME", function () { return $519a4989205d241f$export$4af703091671bc; });
$parcel$export(module.exports, "KEY_END", function () { return $519a4989205d241f$export$e2bc30913faa5db7; });
$parcel$export(module.exports, "KEY_TAB", function () { return $519a4989205d241f$export$10f6869ed0a7d75b; });
$parcel$export(module.exports, "KEY_ENTER", function () { return $519a4989205d241f$export$8152f929a25a0ff4; });
$parcel$export(module.exports, "KEY_SPACE", function () { return $519a4989205d241f$export$e51a3576c045c8d5; });
$parcel$export(module.exports, "ESCAPE", function () { return $519a4989205d241f$export$2bb790b9008907b4; });
/**
 * Character key codes which can be used in keyboard events.
 */ var $519a4989205d241f$export$390330c10ff2b9a1 = "ArrowUp";
var $519a4989205d241f$export$a80636c6f41931fe = "ArrowDown";
var $519a4989205d241f$export$4af703091671bc = "Home";
var $519a4989205d241f$export$e2bc30913faa5db7 = "End";
var $519a4989205d241f$export$10f6869ed0a7d75b = "Tab";
var $519a4989205d241f$export$8152f929a25a0ff4 = "Enter";
var $519a4989205d241f$export$e51a3576c045c8d5 = "Space";
var $519a4989205d241f$export$2bb790b9008907b4 = "Escape";

});


parcelRegister("e5M8I", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $a426dfd0343fdcd0$export$badac9ada3a0bdf9; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $cjxQA = parcelRequire("cjxQA");

// Export types from PopperJS / React Popper
var $a426dfd0343fdcd0$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: 5,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    },
    {
        name: "preventOverflow",
        options: {
            padding: 5,
            rootBoundary: "document"
        }
    }
];
function $a426dfd0343fdcd0$var$defaultChildrenFn() {
    return null;
}
var $a426dfd0343fdcd0$var$defaultOffset = [
    0,
    8
];
function $a426dfd0343fdcd0$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $a426dfd0343fdcd0$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $a426dfd0343fdcd0$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    // Merge a new offset modifier only if new offset values passed in
    var internalModifiers = (0, $9nHZC.useMemo)(function() {
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        return [].concat($a426dfd0343fdcd0$var$constantModifiers, [
            offsetModifier
        ]);
    }, [
        offsetX,
        offsetY
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $9nHZC.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $cjxQA.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});

parcelRegister("8lTgW", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $614b28cfe9141805$export$6503ec6e8aabbaf; });
/**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $63OTf = parcelRequire("63OTf");
var $614b28cfe9141805$var$registrations = new Set();
var $614b28cfe9141805$var$cleanupEndEventListeners = null;
function $614b28cfe9141805$var$onDragStart() {
    if ($614b28cfe9141805$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $614b28cfe9141805$var$cleanupEndEventListeners = (0, $63OTf.bindAll)(window, [
        {
            type: "dragend",
            listener: $614b28cfe9141805$var$onDragEnd
        },
        {
            type: "pointerdown",
            listener: $614b28cfe9141805$var$onDragEnd
        },
        {
            type: "pointermove",
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $614b28cfe9141805$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($614b28cfe9141805$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $614b28cfe9141805$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $614b28cfe9141805$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $614b28cfe9141805$var$cleanupEndEventListeners = null;
    var clone = Array.from($614b28cfe9141805$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $614b28cfe9141805$var$bindStartEvents() {
    return (0, $63OTf.bindAll)(window, [
        {
            type: "dragstart",
            listener: $614b28cfe9141805$var$onDragStart
        },
        {
            type: "dragenter",
            listener: $614b28cfe9141805$var$onDragStart
        }
    ]);
}
var $614b28cfe9141805$var$cleanupStartEventListeners = null;
function $614b28cfe9141805$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$614b28cfe9141805$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $614b28cfe9141805$var$cleanupStartEventListeners = $614b28cfe9141805$var$bindStartEvents();
    $614b28cfe9141805$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $614b28cfe9141805$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $614b28cfe9141805$var$registrations.delete(registration);
        if ($614b28cfe9141805$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $614b28cfe9141805$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $614b28cfe9141805$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("hhLg8", function(module, exports) {

$parcel$export(module.exports, "show", function () { return $c958aeea8c6e9820$export$57bf213be019eeb0; });

var $b19dX = parcelRequire("b19dX");
// This file is a singleton for managing tooltips
var $c958aeea8c6e9820$var$active = null;
function $c958aeea8c6e9820$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($c958aeea8c6e9820$var$active && $c958aeea8c6e9820$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $b19dX.clearScheduled)();
            $c958aeea8c6e9820$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $b19dX.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $b19dX.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $b19dX.scheduleTimeout)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($c958aeea8c6e9820$var$active && $c958aeea8c6e9820$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($c958aeea8c6e9820$var$active) {
            (0, $b19dX.clearScheduled)();
            $c958aeea8c6e9820$var$active.entry.hide({
                isImmediate: true
            });
            $c958aeea8c6e9820$var$active.entry.done();
            $c958aeea8c6e9820$var$active = null;
        }
        // this tooltip is now the active tooltip
        $c958aeea8c6e9820$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $b19dX.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("b19dX", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", function () { return $8056f166607986c2$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $8056f166607986c2$export$5f4d6617421d489b; });
var $8056f166607986c2$var$delayId = null;
function $8056f166607986c2$export$eaf678f6f93f5250() {
    if ($8056f166607986c2$var$delayId != null) {
        window.clearTimeout($8056f166607986c2$var$delayId);
        $8056f166607986c2$var$delayId = null;
    }
}
function $8056f166607986c2$export$5f4d6617421d489b(fn, delay) {
    $8056f166607986c2$export$eaf678f6f93f5250();
    $8056f166607986c2$var$delayId = window.setTimeout(function() {
        $8056f166607986c2$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("5N2W9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4373ce92e038f89d$export$2e2bcd8739ae039; });

var $9SZaS = parcelRequire("9SZaS");
function $4373ce92e038f89d$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $9SZaS.useUIDSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});

parcelRegister("7KtnP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a439f2e885d2150$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $jp7ng = parcelRequire("jp7ng");

var $6Uncq = parcelRequire("6Uncq");
var $5a439f2e885d2150$var$baseStyles = (0, $avKww.css)({
    boxSizing: "border-box",
    maxWidth: "240px",
    padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-075, 6px)"),
    insetBlockStart: "var(--ds-space-0, 0px)",
    insetInlineStart: "var(--ds-space-0, 0px)",
    borderRadius: "var(--ds-border-radius, 3px)",
    fontSize: "var(--ds-font-size-075, 12px)",
    lineHeight: 1.3,
    overflowWrap: "break-word",
    wordWrap: "break-word",
    backgroundColor: "var(--ds-background-neutral-bold, ".concat((0, $jp7ng.N800), ")"),
    color: "var(--ds-text-inverse, ".concat((0, $jp7ng.N0), ")")
});
var $5a439f2e885d2150$var$truncateStyles = (0, $avKww.css)({
    maxWidth: "420px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $5a439f2e885d2150$var$TooltipContainer = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return (0, $avKww.jsx)((0, $6Uncq.default), {
        ref: ref,
        style: style,
        className: className,
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: [
            $5a439f2e885d2150$var$baseStyles,
            truncate ? $5a439f2e885d2150$var$truncateStyles : null
        ]
    }, children);
});
$5a439f2e885d2150$var$TooltipContainer.displayName = "TooltipContainer";
var $5a439f2e885d2150$export$2e2bcd8739ae039 = $5a439f2e885d2150$var$TooltipContainer;

});
parcelRegister("6Uncq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5079f7f89071d620$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $aP6k3 = parcelRequire("aP6k3");
function $5079f7f89071d620$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5079f7f89071d620$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5079f7f89071d620$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5079f7f89071d620$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5079f7f89071d620$var$VAR_PRIMITIVE_ZINDEX = "tooltipPrimitiveZindex";
var $5079f7f89071d620$var$primitiveStyles = (0, $avKww.css)({
    zindex: "var(".concat($5079f7f89071d620$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
var $5079f7f89071d620$var$TooltipPrimitive = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $5079f7f89071d620$var$_objectSpread($5079f7f89071d620$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, $5079f7f89071d620$var$VAR_PRIMITIVE_ZINDEX, (0, $aP6k3.layers).tooltip()));
    return (0, $avKww.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $avKww.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $5079f7f89071d620$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$5079f7f89071d620$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $5079f7f89071d620$export$2e2bcd8739ae039 = $5079f7f89071d620$var$TooltipPrimitive;

});


parcelRegister("9c24i", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", function () { return $6b16d6c2eafcf5b4$export$642213d516a9b928; });
function $6b16d6c2eafcf5b4$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("9YOzH", function(module, exports) {

$parcel$export(module.exports, "MergeCheckModulesTable", function () { return $458a5a14e2ac8129$export$6a6bde7e7466c9ec; });

var $9nHZC = parcelRequire("9nHZC");

var $gulLc = parcelRequire("gulLc");

var $7doh5 = parcelRequire("7doh5");

var $7ptNF = parcelRequire("7ptNF");
var $5b2Wc = parcelRequire("5b2Wc");
var $dCs3M = parcelRequire("dCs3M");
var $56gVi = parcelRequire("56gVi");

var $jajUg = parcelRequire("jajUg");

var $kVU7C = parcelRequire("kVU7C");

var $51Kn5 = parcelRequire("51Kn5");

var $i9bkK = parcelRequire("i9bkK");

var $h5cf5 = parcelRequire("h5cf5");

var $12u1t = parcelRequire("12u1t");

var $djFfq = parcelRequire("djFfq");
const $458a5a14e2ac8129$export$6a6bde7e7466c9ec = ({ resourceType: resourceType, branchConfig: branchConfig, installedCheckModules: installedCheckModules, stateMap: stateMap, checkIdBeingConfigured: checkIdBeingConfigured, onSubmitCheckConfiguration: onSubmitCheckConfiguration })=>{
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    const renderTriggerLozenges = (triggers)=>{
        const hasOnMergeTrigger = triggers.includes("on-merge");
        const triggerTypes = [];
        if (triggers.length > (hasOnMergeTrigger ? 1 : 0)) triggerTypes.push("pre-merge");
        if (hasOnMergeTrigger) triggerTypes.push("on-merge");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5b2Wc.default), null, triggerTypes.map((triggerType)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $12u1t.LozengeContainer), {
                key: triggerType
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7doh5.default), {
                maxWidth: 250
            }, formatMessage(triggerType === "pre-merge" ? (0, $h5cf5.messages).preMerge : (0, $h5cf5.messages).onMerge)))));
    };
    const renderActionCell = (checkModule)=>{
        return(/*#__PURE__*/ // set min-width on the dropdown to avoid reflowing the row when different items are selected
        (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7ptNF.default), {
            xcss: (0, $56gVi.xcss)({
                minWidth: "175px"
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $51Kn5.MergeChecksConfigureDropdown), {
            checkModule: checkModule,
            branchConfig: branchConfig,
            checkState: stateMap.get((0, $djFfq.customMergeCheckKey)(resourceType, branchConfig, checkModule.id)),
            isLoading: checkIdBeingConfigured === checkModule.id,
            isDisabled: checkIdBeingConfigured !== undefined,
            onSubmitCheckConfiguration: onSubmitCheckConfiguration
        })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $gulLc.default), {
        head: {
            cells: [
                {
                    content: formatMessage((0, $i9bkK.sharedMessages).tableColumnApp)
                },
                {
                    content: formatMessage((0, $i9bkK.sharedMessages).tableColumnMergeCheck)
                },
                {
                    content: formatMessage((0, $i9bkK.sharedMessages).tableColumnType)
                },
                {
                    content: null
                }
            ]
        },
        label: formatMessage((0, $i9bkK.sharedMessages).configurationTableAriaLabel, {
            branchConfig: formatMessage(branchConfig.identifier === "all_branches" ? (0, $i9bkK.sharedMessages).allBranchesTabLabel : (0, $i9bkK.sharedMessages).mainBranchTabLabel)
        }),
        rows: installedCheckModules.map((checkModule, index)=>{
            const { appId: appId, name: appName, properties: { name: name, description: description, triggers: triggers } } = checkModule;
            return {
                key: index.toString(),
                cells: [
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $12u1t.AppColumnContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dCs3M.default), {
                            space: "space.100"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kVU7C.ForgeAppAvatar), {
                            appId: appId
                        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", null, appName)))
                    },
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $12u1t.MergeCheckColumnContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("p", null, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $12u1t.Description), null, description))
                    },
                    {
                        content: renderTriggerLozenges(triggers)
                    },
                    {
                        content: renderActionCell(checkModule)
                    }
                ]
            };
        }),
        rowsPerPage: 10,
        testId: "merge-checks-modules-table"
    });
};

});
parcelRegister("kVU7C", function(module, exports) {

$parcel$export(module.exports, "ForgeAppAvatar", function () { return $6c5cb681ee8a1498$export$6593336c411d5849; });

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("dOsQd");
var $2U6Qd = parcelRequire("2U6Qd");

var $3XbtU = parcelRequire("3XbtU");

var $gbiiY = parcelRequire("gbiiY");

var $fntui = parcelRequire("fntui");

var $12u1t = parcelRequire("12u1t");
const $6c5cb681ee8a1498$var$FORGE_APP_ARI_PREFIX = "ari:cloud:ecosystem::app/";
const $6c5cb681ee8a1498$export$fba87563d803a15e = (0, $gbiiY.default)`
  query ForgeAppAvatar($appId: ID!) {
    app(id: $appId) {
      avatarUrl
      avatarFileId
    }
  }
`;
const $6c5cb681ee8a1498$export$6593336c411d5849 = ({ appId: appId })=>{
    var _data$app, _data$app2;
    const { data: data, error: error } = (0, $2U6Qd.useQuery)($6c5cb681ee8a1498$export$fba87563d803a15e, {
        variables: {
            appId: $6c5cb681ee8a1498$var$FORGE_APP_ARI_PREFIX + appId
        }
    });
    (0, $9nHZC.useEffect)(()=>{
        if (error) (0, $3XbtU.captureException)(error);
    }, [
        error
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $12u1t.Avatar), {
        src: // If avatarFileId is null, the app does not have a custom avatar set
        data !== null && data !== void 0 && (_data$app = data.app) !== null && _data$app !== void 0 && _data$app.avatarFileId && data !== null && data !== void 0 && (_data$app2 = data.app) !== null && _data$app2 !== void 0 && _data$app2.avatarUrl ? data.app.avatarUrl : (0, (/*@__PURE__*/$parcel$interopDefault($fntui)))
    });
};

});
parcelRegister("fntui", function(module, exports) {

module.exports = (parcelRequire("1sJKT")).getBundleURL("ekZ4q") + "default-icon.94aec26c.svg";

});

parcelRegister("12u1t", function(module, exports) {

$parcel$export(module.exports, "DescriptionContainer", function () { return $ad676c35085c7ce0$export$31dea26885d599bc; });
$parcel$export(module.exports, "AppColumnContainer", function () { return $ad676c35085c7ce0$export$90649e961dd59807; });
$parcel$export(module.exports, "MergeCheckColumnContainer", function () { return $ad676c35085c7ce0$export$6e023deafb5d3013; });
$parcel$export(module.exports, "Avatar", function () { return $ad676c35085c7ce0$export$e2255cf6045e8d47; });
$parcel$export(module.exports, "Description", function () { return $ad676c35085c7ce0$export$393edc798c47379d; });
$parcel$export(module.exports, "TabLabel", function () { return $ad676c35085c7ce0$export$56f62933db040038; });
$parcel$export(module.exports, "TableContainer", function () { return $ad676c35085c7ce0$export$f2c3aea42b2a048f; });
$parcel$export(module.exports, "LozengeContainer", function () { return $ad676c35085c7ce0$export$d5aa9dc8584e2976; });

var $2xJU3 = parcelRequire("2xJU3");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */ function $ad676c35085c7ce0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ad676c35085c7ce0$var$space0 = (0, $h39Sh.default)("space.0", "0px");
const $ad676c35085c7ce0$var$space25 = (0, $h39Sh.default)("space.025", "2px");
const $ad676c35085c7ce0$var$space50 = (0, $h39Sh.default)("space.050", "4px");
const $ad676c35085c7ce0$var$space100 = (0, $h39Sh.default)("space.100", "8px");
const $ad676c35085c7ce0$var$space200 = (0, $h39Sh.default)("space.200", "16px");
const $ad676c35085c7ce0$var$space300 = (0, $h39Sh.default)("space.300", "24px");
const $ad676c35085c7ce0$export$a5e06607a5ac6158 = (0, $2xJU3.default)("div", {
    target: "etpoeeb0"
})({
    display: "flex",
    flex: 1,
    paddingTop: (0, $h39Sh.default)("space.800", "64px"),
    justifyContent: "center",
    alignItems: "flex-start"
}, "");
const $ad676c35085c7ce0$export$31dea26885d599bc = (0, $2xJU3.default)("div", {
    target: "etpoeeb1"
})({
    marginBottom: $ad676c35085c7ce0$var$space200
}, "");
const $ad676c35085c7ce0$export$1e86fd0e1db89578 = (0, $2xJU3.default)("div", {
    target: "etpoeeb2"
})({
    display: "flex",
    justifyContent: "space-between",
    marginTop: $ad676c35085c7ce0$var$space200,
    marginBottom: $ad676c35085c7ce0$var$space200
}, "");
const $ad676c35085c7ce0$export$90649e961dd59807 = (0, $2xJU3.default)("div", {
    target: "etpoeeb3"
})({
    name: "70qvj9",
    styles: "display:flex;align-items:center;"
});
const $ad676c35085c7ce0$export$6e023deafb5d3013 = (0, $2xJU3.default)("div", {
    target: "etpoeeb4"
})({
    lineHeight: 1,
    margin: `${$ad676c35085c7ce0$var$space25} ${$ad676c35085c7ce0$var$space0}`
}, "");
const $ad676c35085c7ce0$export$e2255cf6045e8d47 = (0, $2xJU3.default)("img", {
    target: "etpoeeb5"
})({
    width: $ad676c35085c7ce0$var$space300,
    height: $ad676c35085c7ce0$var$space300,
    borderRadius: (0, $h39Sh.default)("border.radius.100", "3px")
}, "");
const $ad676c35085c7ce0$export$393edc798c47379d = (0, $2xJU3.default)("sub", {
    target: "etpoeeb6"
})({
    lineHeight: 1,
    color: (0, $h39Sh.default)("color.background.accent.gray.bolder", (0, $jp7ng).N500)
}, "");
const $ad676c35085c7ce0$export$56f62933db040038 = (0, $2xJU3.default)("span", {
    target: "etpoeeb7"
})({
    marginRight: $ad676c35085c7ce0$var$space100
}, "");
const $ad676c35085c7ce0$export$f2c3aea42b2a048f = (0, $2xJU3.default)("div", {
    target: "etpoeeb8"
})({
    flex: 1,
    table: {
        marginTop: $ad676c35085c7ce0$var$space300,
        tr: {
            borderTop: `${$ad676c35085c7ce0$var$space25} solid ${(0, $h39Sh.default)("color.border", (0, $jp7ng).N40)}`
        }
    }
}, "");
const $ad676c35085c7ce0$export$d5aa9dc8584e2976 = (0, $2xJU3.default)("div", {
    target: "etpoeeb9"
})({
    marginRight: $ad676c35085c7ce0$var$space50
}, "");

});


parcelRegister("51Kn5", function(module, exports) {

$parcel$export(module.exports, "MergeChecksConfigureDropdown", function () { return $9d22e783f1948a2e$export$1db74fbe8d092a2a; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("dGzLf");
var $aAre5 = parcelRequire("aAre5");

var $97xxA = parcelRequire("97xxA");

var $h24do = parcelRequire("h24do");
var $8Aq6a = parcelRequire("8Aq6a");
var $7Ozc3 = parcelRequire("7Ozc3");

var $dWDB7 = parcelRequire("dWDB7");

var $enZDC = parcelRequire("enZDC");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $j9ioD = parcelRequire("j9ioD");

var $jajUg = parcelRequire("jajUg");

var $5utbt = parcelRequire("5utbt");

var $i9bkK = parcelRequire("i9bkK");

var $h5cf5 = parcelRequire("h5cf5");
const $9d22e783f1948a2e$export$1db74fbe8d092a2a = ({ checkModule: checkModule, branchConfig: branchConfig, checkState: checkState, isDisabled: isDisabled, isLoading: isLoading, onSubmitCheckConfiguration: onSubmitCheckConfiguration })=>{
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    const { isWorkspacePremium: isWorkspacePremium } = (0, $aAre5.useSelector)((0, $5utbt.getWorkspacePlan));
    const currentState = (0, $9nHZC.useMemo)(()=>{
        switch(checkState){
            case "off":
            case "recommended":
                return checkState;
            case "required":
                return isWorkspacePremium ? "required" : "recommended";
            default:
                return "off";
        }
    }, [
        checkState,
        isWorkspacePremium
    ]);
    const onItemClick = (0, $9nHZC.useCallback)((newState)=>{
        if (newState !== currentState) onSubmitCheckConfiguration(branchConfig, checkModule, currentState, newState);
    }, [
        checkModule,
        branchConfig,
        onSubmitCheckConfiguration,
        currentState
    ]);
    const getLabel = (0, $9nHZC.useCallback)((state)=>{
        switch(state){
            case "required":
                return formatMessage((0, $h5cf5.messages).checkRequiredLabel);
            case "recommended":
                return formatMessage((0, $h5cf5.messages).checkRecommendedLabel);
            default:
                return formatMessage((0, $h5cf5.messages).checkDisabledLabel);
        }
    }, [
        formatMessage
    ]);
    const renderTrigger = ({ triggerRef: triggerRef, ...props })=>{
        const hasOnMergeTrigger = checkModule.properties.triggers.includes("on-merge");
        const triggers = [];
        if (checkModule.properties.triggers.length > (hasOnMergeTrigger ? 1 : 0)) triggers.push(formatMessage((0, $h5cf5.messages).preMerge));
        if (hasOnMergeTrigger) triggers.push(formatMessage((0, $h5cf5.messages).onMerge));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $97xxA.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
            "aria-label": formatMessage((0, $i9bkK.sharedMessages).checkDropdownAriaLabel, {
                appName: checkModule.name,
                checkName: checkModule.properties.name,
                triggers: triggers.join(", "),
                status: getLabel(currentState)
            }),
            appearance: "subtle",
            isDisabled: isDisabled,
            isLoading: isLoading,
            ref: triggerRef,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dWDB7))), {
                label: ""
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", null, getLabel(currentState)));
    };
    const renderItem = (state)=>{
        if (state !== "required" || isWorkspacePremium) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $8Aq6a.default), {
            isSelected: state === currentState,
            onClick: ()=>onItemClick(state),
            elemAfter: state === "required" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($enZDC))), {
                label: formatMessage((0, $h5cf5.messages).premiumIconLabel),
                primaryColor: (0, $h39Sh.default)("color.icon.information", (0, $jp7ng).B400)
            }) : undefined
        }, getLabel(state));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $j9ioD.default), {
            content: formatMessage((0, $h5cf5.messages).requiredPremiumOnly)
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $8Aq6a.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                isDisabled: true,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($enZDC))), {
                    label: formatMessage((0, $h5cf5.messages).premiumIconLabel),
                    primaryColor: (0, $h39Sh.default)("color.icon.information", (0, $jp7ng).B400)
                })
            }, tooltipProps), getLabel(state)));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $h24do.default), {
        testId: "merge-checks-module-dropdown",
        trigger: renderTrigger
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7Ozc3.default), null, renderItem("off"), renderItem("recommended"), renderItem("required")));
};

});
parcelRegister("h24do", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c665e499e14cbfb6$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $9XfsT = parcelRequire("9XfsT");

var $3THTN = parcelRequire("3THTN");

var $70mT6 = parcelRequire("70mT6");

var $3aF04 = parcelRequire("3aF04");

var $8p2GL = parcelRequire("8p2GL");

var $84iaW = parcelRequire("84iaW");

var $eIHpi = parcelRequire("eIHpi");

var $dWDB7 = parcelRequire("dWDB7");

var $93cMI = parcelRequire("93cMI");

var $aP6k3 = parcelRequire("aP6k3");

var $1Yet2 = parcelRequire("1Yet2");

var $5czZL = parcelRequire("5czZL");

var $gW4l2 = parcelRequire("gW4l2");

var $bzYG3 = parcelRequire("bzYG3");

var $gRz1X = parcelRequire("gRz1X");
var $c665e499e14cbfb6$var$_excluded = [
    "ref",
    "aria-controls",
    "aria-expanded",
    "aria-haspopup"
];
function $c665e499e14cbfb6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c665e499e14cbfb6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c665e499e14cbfb6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c665e499e14cbfb6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c665e499e14cbfb6$var$gridSize = (0, $aP6k3.gridSize)();
var $c665e499e14cbfb6$var$MAX_HEIGHT = "calc(100vh - ".concat($c665e499e14cbfb6$var$gridSize * 2, "px)");
var $c665e499e14cbfb6$var$opposites = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left",
    start: "end",
    auto: "auto",
    end: "start"
};
var $c665e499e14cbfb6$export$e51a3576c045c8d5 = " ";
var $c665e499e14cbfb6$export$8152f929a25a0ff4 = "Enter";
var $c665e499e14cbfb6$var$getFallbackPlacements = function getFallbackPlacements(placement) {
    var placementPieces = placement.split("-");
    var mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        "top",
        "bottom"
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        "start",
        "end"
    ].includes(placementPieces[1])) {
        var crossAxis = placementPieces[1];
        return [
            "".concat(mainAxis),
            "".concat(mainAxis, "-").concat($c665e499e14cbfb6$var$opposites[crossAxis]),
            "".concat($c665e499e14cbfb6$var$opposites[mainAxis], "-").concat(crossAxis),
            "".concat($c665e499e14cbfb6$var$opposites[mainAxis]),
            "".concat($c665e499e14cbfb6$var$opposites[mainAxis], "-").concat($c665e499e14cbfb6$var$opposites[crossAxis]),
            "auto"
        ];
    } else return [
        "".concat(mainAxis, "-start"),
        "".concat(mainAxis, "-end"),
        "".concat($c665e499e14cbfb6$var$opposites[mainAxis]),
        "".concat($c665e499e14cbfb6$var$opposites[mainAxis], "-start"),
        "".concat($c665e499e14cbfb6$var$opposites[mainAxis], "-end"),
        "auto"
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ var $c665e499e14cbfb6$var$DropdownMenu = function DropdownMenu(_ref) {
    var _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, _ref$defaultOpen = _ref.defaultOpen, defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isOpen = _ref.isOpen, _ref$onOpenChange = _ref.onOpenChange, onOpenChange = _ref$onOpenChange === void 0 ? (0, $8p2GL.default) : _ref$onOpenChange, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, spacing = _ref.spacing, statusLabel = _ref.statusLabel, testId = _ref.testId, _trigger = _ref.trigger, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? (0, $aP6k3.layers).modal() : _ref$zIndex;
    var _useControlledState = (0, $84iaW.default)(isOpen, function() {
        return defaultOpen;
    }), _useControlledState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useControlledState, 2), isLocalOpen = _useControlledState2[0], setLocalIsOpen = _useControlledState2[1];
    var _useState = (0, $9nHZC.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), isTriggeredUsingKeyboard = _useState2[0], setTriggeredUsingKeyboard = _useState2[1];
    var fallbackPlacements = (0, $9nHZC.useMemo)(function() {
        return $c665e499e14cbfb6$var$getFallbackPlacements(placement);
    }, [
        placement
    ]);
    var handleTriggerClicked = (0, $9nHZC.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    function(event) {
        var newValue = !isLocalOpen;
        var clientX = event.clientX, clientY = event.clientY, type = event.type, detail = event.detail;
        if (type === "keydown") setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    var handleOnClose = (0, $9nHZC.useCallback)(function(event) {
        if (event.key !== "Escape" && event.target.closest("[id^=".concat((0, $gRz1X.PREFIX), "] [aria-haspopup]"))) // Check if it is within dropdown and it is a trigger button
        // if it is a nested dropdown, clicking trigger won't close the dropdown
        return;
        var newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        onOpenChange,
        setLocalIsOpen
    ]);
    var _useFocus = (0, $eIHpi.default)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $9nHZC.useEffect)(function() {
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $8p2GL.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $8p2GL.default;
        return (0, $9XfsT.bind)(window, {
            type: "keydown",
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $70mT6.KEY_DOWN)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.key === $c665e499e14cbfb6$export$e51a3576c045c8d5 || e.key === $c665e499e14cbfb6$export$8152f929a25a0ff4) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked
    ]);
    var id = (0, $gRz1X.default)();
    var itemRef = (0, $bzYG3.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $gW4l2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $93cMI.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && "".concat(testId, "--content"),
        shouldUseCaptureOnOutsideClick: true,
        shouldRenderToParent: shouldRenderToParent,
        trigger: function trigger(_ref2) {
            var ref = _ref2.ref, ariaControls = _ref2["aria-controls"], ariaExpanded = _ref2["aria-expanded"], ariaHasPopup = _ref2["aria-haspopup"], rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref2, $c665e499e14cbfb6$var$_excluded);
            if (typeof _trigger === "function") return _trigger($c665e499e14cbfb6$var$_objectSpread($c665e499e14cbfb6$var$_objectSpread($c665e499e14cbfb6$var$_objectSpread({
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup
            }, rest), bindFocus), {}, {
                triggerRef: (0, $3aF04.default)([
                    ref,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger")
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3THTN.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, bindFocus, {
                ref: (0, $3aF04.default)([
                    ref,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dWDB7))), {
                    size: "medium",
                    label: ""
                }),
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger")
            }), _trigger);
        },
        content: function content(_ref3) {
            var setInitialFocusRef = _ref3.setInitialFocusRef, update = _ref3.update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $1Yet2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5czZL.default), {
                spacing: spacing,
                maxHeight: $c665e499e14cbfb6$var$MAX_HEIGHT,
                maxWidth: 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                testId: testId && "".concat(testId, "--menu-wrapper")
            }, children));
        }
    }));
};
var $c665e499e14cbfb6$export$2e2bcd8739ae039 = $c665e499e14cbfb6$var$DropdownMenu;

});
parcelRegister("9XfsT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $5WsXh = parcelRequire("5WsXh");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $5WsXh.bind;
    }
});

var $9X6ox = parcelRequire("9X6ox");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $9X6ox.bindAll;
    }
});

});
parcelRegister("5WsXh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $4538d464070103e3$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $4538d464070103e3$var$bind;

});

parcelRegister("9X6ox", function(module, exports) {
"use strict";
var $73ee959ae9cce803$var$__assign = module.exports && module.exports.__assign || function() {
    $73ee959ae9cce803$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $73ee959ae9cce803$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $5WsXh = parcelRequire("5WsXh");
function $73ee959ae9cce803$var$toOptions(value) {
    if (typeof value === "undefined") return undefined;
    if (typeof value === "boolean") return {
        capture: value
    };
    return value;
}
function $73ee959ae9cce803$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $73ee959ae9cce803$var$__assign($73ee959ae9cce803$var$__assign({}, original), {
        options: $73ee959ae9cce803$var$__assign($73ee959ae9cce803$var$__assign({}, $73ee959ae9cce803$var$toOptions(sharedOptions)), $73ee959ae9cce803$var$toOptions(original.options))
    });
    return binding;
}
function $73ee959ae9cce803$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $73ee959ae9cce803$var$getBinding(original, sharedOptions);
        return (0, $5WsXh.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $73ee959ae9cce803$var$bindAll;

});


parcelRegister("eIHpi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab76d87c99309849$export$2e2bcd8739ae039; });

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");
function $ab76d87c99309849$export$2e2bcd8739ae039() {
    var _useState = (0, $9nHZC.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), isFocused = _useState2[0], setIsFocused = _useState2[1];
    // ensure bindFocus has a stable ref
    var bindFocus = (0, $9nHZC.useRef)({
        onFocus: function onFocus() {
            return setIsFocused(true);
        },
        onBlur: function onBlur() {
            return setIsFocused(false);
        }
    });
    (0, $9nHZC.useEffect)(function() {
        // handle the case where a component might
        // unmount while being focused.
        return function() {
            return setIsFocused(false);
        };
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("93cMI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $696e4fa4218fd478$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Popup", function () { return (parcelRequire("hdpnB")).Popup; });

var $hdpnB = parcelRequire("hdpnB");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$696e4fa4218fd478$export$2e2bcd8739ae039 = (0, $hdpnB.Popup);

});
parcelRegister("hdpnB", function(module, exports) {

$parcel$export(module.exports, "Popup", function () { return $c8875670dc39cbe9$export$129a32eedafa97c5; });

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $9SZaS = parcelRequire("9SZaS");

var $kEiiy = parcelRequire("kEiiy");

var $2Sjnc = parcelRequire("2Sjnc");

var $gwCAL = parcelRequire("gwCAL");
var $16GBP = parcelRequire("16GBP");

var $97YIy = parcelRequire("97YIy");

var $d6gxv = parcelRequire("d6gxv");
var $gCYAh = parcelRequire("gCYAh");

var $1wH1n = parcelRequire("1wH1n");

var $8Rbqj = parcelRequire("8Rbqj");

var $bZL5V = parcelRequire("bZL5V");
var $c8875670dc39cbe9$var$defaultLayer = (0, $1wH1n.layers).layer();
var $c8875670dc39cbe9$var$wrapperStyles = (0, $gCYAh.xcss)({
    position: "relative"
});
var $c8875670dc39cbe9$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $9nHZC.memo)(function(_ref) {
    var isOpen = _ref.isOpen, providedId = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? "viewport" : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "auto" : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $c8875670dc39cbe9$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldDisableFoc = _ref.shouldDisableFocusLock, shouldDisableFocusLock = _ref$shouldDisableFoc === void 0 ? false : _ref$shouldDisableFoc, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers;
    var _useState = (0, $9nHZC.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $bZL5V.useGetMemoizedMergedTriggerRef)();
    var generatedId = (0, $9SZaS.useUID)();
    var id = providedId || generatedId;
    var renderPopperWrapper = (0, $avKww.jsx)((0, $kEiiy.UNSAFE_LAYERING), {
        isDisabled: false
    }, (0, $avKww.jsx)((0, $8Rbqj.default), {
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        triggerRef: triggerRef,
        strategy: shouldFitContainer ? "absolute" : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers
    }));
    var popupContent = (0, $avKww.jsx)((0, $gwCAL.Manager), null, (0, $avKww.jsx)((0, $16GBP.Reference), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: getMergedTriggerRef(ref, setTriggerRef, isOpen),
            "aria-controls": isOpen ? id : undefined,
            "aria-expanded": isOpen,
            "aria-haspopup": role === "dialog" && (0, $2Sjnc.fg)("platform_dst_popup-disable-focuslock") ? "dialog" : true
        });
    }), isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : (0, $avKww.jsx)((0, $97YIy.default), {
        zIndex: zIndex
    }, renderPopperWrapper)));
    if (shouldFitContainer) return (0, $avKww.jsx)((0, $d6gxv.default), {
        xcss: $c8875670dc39cbe9$var$wrapperStyles
    }, popupContent);
    return popupContent;
});
var $c8875670dc39cbe9$export$2e2bcd8739ae039 = $c8875670dc39cbe9$export$129a32eedafa97c5;

});
parcelRegister("2Sjnc", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $217fa70c37f611ba$export$b40ec24ac8275656; });

var $hXqij = parcelRequire("hXqij");
function $217fa70c37f611ba$export$ba05d765b8392e5e(flagResolver) {
    (0, $hXqij.setBooleanResolver)(flagResolver);
}
function $217fa70c37f611ba$export$470e5c2be1411c89(name) {
    return (0, $hXqij.resolveBooleanFlag)(name);
}
function $217fa70c37f611ba$export$b40ec24ac8275656(name) {
    return (0, $hXqij.resolveBooleanFlag)(name);
}

});
parcelRegister("hXqij", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $d12c57d9090bf6ba$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $d12c57d9090bf6ba$export$6333b6aff9fc6275; });

var $jhHUm = parcelRequire("jhHUm");

var $8ovux = parcelRequire("8ovux");
var $d12c57d9090bf6ba$var$pkgName = "@atlaskit/platform-feature-flags";
var $d12c57d9090bf6ba$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $d12c57d9090bf6ba$var$hasProcessEnv = typeof $8ovux !== "undefined" && typeof $8ovux.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $d12c57d9090bf6ba$var$ENV_ENABLE_PLATFORM_FF = $d12c57d9090bf6ba$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $d12c57d9090bf6ba$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $d12c57d9090bf6ba$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $d12c57d9090bf6ba$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $d12c57d9090bf6ba$var$ENV_ENABLE_PLATFORM_FF || $d12c57d9090bf6ba$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $d12c57d9090bf6ba$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $d12c57d9090bf6ba$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$d12c57d9090bf6ba$var$globalVar[$d12c57d9090bf6ba$export$7e41b1b2bdee3f98] = $d12c57d9090bf6ba$var$globalVar[$d12c57d9090bf6ba$export$7e41b1b2bdee3f98] || $d12c57d9090bf6ba$var$DEFAULT_PFF_GLOBAL;
function $d12c57d9090bf6ba$export$f2b591175b3e424c(resolver) {
    $d12c57d9090bf6ba$var$globalVar[$d12c57d9090bf6ba$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $d12c57d9090bf6ba$export$6333b6aff9fc6275(flagKey) {
    if ($d12c57d9090bf6ba$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $jhHUm.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $d12c57d9090bf6ba$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $d12c57d9090bf6ba$var$globalVar[$d12c57d9090bf6ba$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("jhHUm", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $e0a1aa1657a9a1d4$export$1c9f709888824e05; });
var $e0a1aa1657a9a1d4$var$_ref, $e0a1aa1657a9a1d4$var$_process, $e0a1aa1657a9a1d4$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $e0a1aa1657a9a1d4$var$TESTS_MODE = ($e0a1aa1657a9a1d4$var$_ref = (globalThis === null || globalThis === void 0 || ($e0a1aa1657a9a1d4$var$_process = globalThis.process) === null || $e0a1aa1657a9a1d4$var$_process === void 0 || ($e0a1aa1657a9a1d4$var$_process = $e0a1aa1657a9a1d4$var$_process.env) === null || $e0a1aa1657a9a1d4$var$_process === void 0 ? void 0 : $e0a1aa1657a9a1d4$var$_process.JEST_WORKER_ID) !== undefined, $e0a1aa1657a9a1d4$var$_ref !== void 0) ? $e0a1aa1657a9a1d4$var$_ref : false;
var $e0a1aa1657a9a1d4$var$DEBUG_MODE = !$e0a1aa1657a9a1d4$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($e0a1aa1657a9a1d4$var$_process2 = globalThis.process) === null || $e0a1aa1657a9a1d4$var$_process2 === void 0 || ($e0a1aa1657a9a1d4$var$_process2 = $e0a1aa1657a9a1d4$var$_process2.env) === null || $e0a1aa1657a9a1d4$var$_process2 === void 0 ? void 0 : $e0a1aa1657a9a1d4$var$_process2.NODE_ENV) !== "production";
var $e0a1aa1657a9a1d4$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$e0a1aa1657a9a1d4$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("d6gxv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9898aa4bbd720fea$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $jdRQY = parcelRequire("jdRQY");

var $gCYAh = parcelRequire("gCYAh");

var $5eMjN = parcelRequire("5eMjN");
var $9898aa4bbd720fea$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $9898aa4bbd720fea$var$_excluded2 = [
    "className"
];
var $9898aa4bbd720fea$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $9898aa4bbd720fea$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(htmlAttributes, $9898aa4bbd720fea$var$_excluded2);
    var resolvedStyles = (0, $gCYAh.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $avKww.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $9898aa4bbd720fea$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $jdRQY.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $jdRQY.isSurfaceColorToken)(backgroundColor) && (0, $jdRQY.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $jdRQY.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $jdRQY.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $jdRQY.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $jdRQY.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $jdRQY.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $jdRQY.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $jdRQY.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $avKww.jsx)((0, $5eMjN.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $9898aa4bbd720fea$export$2e2bcd8739ae039 = $9898aa4bbd720fea$export$e71c4d32a2263218;
var $9898aa4bbd720fea$var$baseStyles = (0, $avKww.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("jdRQY", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $dfe901631fa1b7c2$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $dfe901631fa1b7c2$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $dfe901631fa1b7c2$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $dfe901631fa1b7c2$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $dfe901631fa1b7c2$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $dfe901631fa1b7c2$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $dfe901631fa1b7c2$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $dfe901631fa1b7c2$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $dfe901631fa1b7c2$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $dfe901631fa1b7c2$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $dfe901631fa1b7c2$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $dfe901631fa1b7c2$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $dfe901631fa1b7c2$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $dfe901631fa1b7c2$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $dfe901631fa1b7c2$export$5e65a44e5b6ecadb; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $xbX1J = parcelRequire("xbX1J");
function $dfe901631fa1b7c2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dfe901631fa1b7c2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dfe901631fa1b7c2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dfe901631fa1b7c2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dfe901631fa1b7c2$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $dfe901631fa1b7c2$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $dfe901631fa1b7c2$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $dfe901631fa1b7c2$export$632685d741f3dbbf = $dfe901631fa1b7c2$var$_objectSpread($dfe901631fa1b7c2$var$_objectSpread({}, $dfe901631fa1b7c2$export$958d0ae7f2977ae4), $dfe901631fa1b7c2$export$d2dc61f58390201c);
var $dfe901631fa1b7c2$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $dfe901631fa1b7c2$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $dfe901631fa1b7c2$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $dfe901631fa1b7c2$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $dfe901631fa1b7c2$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $dfe901631fa1b7c2$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $dfe901631fa1b7c2$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $dfe901631fa1b7c2$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $dfe901631fa1b7c2$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $dfe901631fa1b7c2$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $dfe901631fa1b7c2$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $dfe901631fa1b7c2$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $dfe901631fa1b7c2$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $dfe901631fa1b7c2$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $dfe901631fa1b7c2$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $dfe901631fa1b7c2$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $avKww.css)((0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $dfe901631fa1b7c2$export$e615f061ca585a6c = $dfe901631fa1b7c2$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $dfe901631fa1b7c2$var$getSerializedStylesMap(spacingProperty, $dfe901631fa1b7c2$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $dfe901631fa1b7c2$export$bf46c3f9eeafc71f = $dfe901631fa1b7c2$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $dfe901631fa1b7c2$var$getSerializedStylesMap(spacingProperty, $dfe901631fa1b7c2$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $dfe901631fa1b7c2$export$e7af83bafe7f9e63 = $dfe901631fa1b7c2$var$getSerializedStylesMap("backgroundColor", $dfe901631fa1b7c2$export$d1d79bf68ac056bd);
var $dfe901631fa1b7c2$export$3a1bcba60b23d7f0 = $dfe901631fa1b7c2$var$getSerializedStylesMap("color", $dfe901631fa1b7c2$export$8473307aa00d6ea1);
var $dfe901631fa1b7c2$export$45f3f4fe16f9f7d5 = $dfe901631fa1b7c2$var$getSerializedStylesMap("fontWeight", $dfe901631fa1b7c2$export$303e322c6b1ed114);
var $dfe901631fa1b7c2$export$68cc305da27dbaa4 = $dfe901631fa1b7c2$var$getSerializedStylesMap("fontFamily", $dfe901631fa1b7c2$export$3c7e9587132614b4);
var $dfe901631fa1b7c2$export$128f10c238242f83 = $dfe901631fa1b7c2$var$getSerializedStylesMap("font", $dfe901631fa1b7c2$export$6cc560b4dedf3816);
var $dfe901631fa1b7c2$export$ff257d957d48c421 = $dfe901631fa1b7c2$var$getSerializedStylesMap((0, $xbX1J.CURRENT_SURFACE_CSS_VAR), $dfe901631fa1b7c2$export$41a358c9c2356760);
var $dfe901631fa1b7c2$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $dfe901631fa1b7c2$export$41a358c9c2356760[color] !== undefined;
};

});

parcelRegister("gCYAh", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $c1af30ba5706edd4$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $c1af30ba5706edd4$export$f6c783d06584602c; });

var $b4Ivn = parcelRequire("b4Ivn");

var $kFnE9 = parcelRequire("kFnE9");

var $9q1kH = parcelRequire("9q1kH");

var $340K4 = parcelRequire("340K4");

var $avKww = parcelRequire("avKww");

var $jdRQY = parcelRequire("jdRQY");

var $8ovux = parcelRequire("8ovux");
function $c1af30ba5706edd4$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $c1af30ba5706edd4$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $c1af30ba5706edd4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c1af30ba5706edd4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c1af30ba5706edd4$var$_arrayLikeToArray(o, minLen);
}
function $c1af30ba5706edd4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $c1af30ba5706edd4$export$9a199fbafee0014e = {
    backgroundColor: (0, $jdRQY.backgroundColorMap),
    blockSize: (0, $jdRQY.dimensionMap),
    borderBlockColor: (0, $jdRQY.borderColorMap),
    borderBlockEndColor: (0, $jdRQY.borderColorMap),
    borderBlockEndWidth: (0, $jdRQY.borderWidthMap),
    borderBlockStartColor: (0, $jdRQY.borderColorMap),
    borderBlockStartWidth: (0, $jdRQY.borderWidthMap),
    borderBlockWidth: (0, $jdRQY.borderWidthMap),
    borderBottomColor: (0, $jdRQY.borderColorMap),
    borderBottomLeftRadius: (0, $jdRQY.borderRadiusMap),
    borderBottomRightRadius: (0, $jdRQY.borderRadiusMap),
    borderBottomWidth: (0, $jdRQY.borderWidthMap),
    borderColor: (0, $jdRQY.borderColorMap),
    borderEndEndRadius: (0, $jdRQY.borderRadiusMap),
    borderEndStartRadius: (0, $jdRQY.borderRadiusMap),
    borderInlineColor: (0, $jdRQY.borderColorMap),
    borderInlineEndColor: (0, $jdRQY.borderColorMap),
    borderInlineEndWidth: (0, $jdRQY.borderWidthMap),
    borderInlineStartColor: (0, $jdRQY.borderColorMap),
    borderInlineStartWidth: (0, $jdRQY.borderWidthMap),
    borderInlineWidth: (0, $jdRQY.borderWidthMap),
    borderLeftColor: (0, $jdRQY.borderColorMap),
    borderLeftWidth: (0, $jdRQY.borderWidthMap),
    borderRadius: (0, $jdRQY.borderRadiusMap),
    borderRightColor: (0, $jdRQY.borderColorMap),
    borderRightWidth: (0, $jdRQY.borderWidthMap),
    borderStartEndRadius: (0, $jdRQY.borderRadiusMap),
    borderStartStartRadius: (0, $jdRQY.borderRadiusMap),
    borderTopColor: (0, $jdRQY.borderColorMap),
    borderTopLeftRadius: (0, $jdRQY.borderRadiusMap),
    borderTopRightRadius: (0, $jdRQY.borderRadiusMap),
    borderTopWidth: (0, $jdRQY.borderWidthMap),
    borderWidth: (0, $jdRQY.borderWidthMap),
    bottom: (0, $jdRQY.allSpaceMap),
    boxShadow: (0, $jdRQY.shadowMap),
    color: (0, $jdRQY.textColorMap),
    columnGap: (0, $jdRQY.positiveSpaceMap),
    gap: (0, $jdRQY.positiveSpaceMap),
    height: (0, $jdRQY.dimensionMap),
    inlineSize: (0, $jdRQY.dimensionMap),
    inset: (0, $jdRQY.allSpaceMap),
    insetBlock: (0, $jdRQY.allSpaceMap),
    insetBlockEnd: (0, $jdRQY.allSpaceMap),
    insetBlockStart: (0, $jdRQY.allSpaceMap),
    insetInline: (0, $jdRQY.allSpaceMap),
    insetInlineEnd: (0, $jdRQY.allSpaceMap),
    insetInlineStart: (0, $jdRQY.allSpaceMap),
    left: (0, $jdRQY.allSpaceMap),
    margin: (0, $jdRQY.allSpaceMap),
    marginBlock: (0, $jdRQY.allSpaceMap),
    marginBlockEnd: (0, $jdRQY.allSpaceMap),
    marginBlockStart: (0, $jdRQY.allSpaceMap),
    marginBottom: (0, $jdRQY.allSpaceMap),
    marginInline: (0, $jdRQY.allSpaceMap),
    marginInlineEnd: (0, $jdRQY.allSpaceMap),
    marginInlineStart: (0, $jdRQY.allSpaceMap),
    marginLeft: (0, $jdRQY.allSpaceMap),
    marginRight: (0, $jdRQY.allSpaceMap),
    marginTop: (0, $jdRQY.allSpaceMap),
    maxBlockSize: (0, $jdRQY.dimensionMap),
    maxHeight: (0, $jdRQY.dimensionMap),
    maxInlineSize: (0, $jdRQY.dimensionMap),
    maxWidth: (0, $jdRQY.dimensionMap),
    minBlockSize: (0, $jdRQY.dimensionMap),
    minHeight: (0, $jdRQY.dimensionMap),
    minInlineSize: (0, $jdRQY.dimensionMap),
    minWidth: (0, $jdRQY.dimensionMap),
    opacity: (0, $jdRQY.opacityMap),
    outlineColor: (0, $jdRQY.borderColorMap),
    outlineOffset: (0, $jdRQY.positiveSpaceMap),
    outlineWidth: (0, $jdRQY.borderWidthMap),
    padding: (0, $jdRQY.positiveSpaceMap),
    paddingBlock: (0, $jdRQY.positiveSpaceMap),
    paddingBlockEnd: (0, $jdRQY.positiveSpaceMap),
    paddingBlockStart: (0, $jdRQY.positiveSpaceMap),
    paddingBottom: (0, $jdRQY.positiveSpaceMap),
    paddingInline: (0, $jdRQY.positiveSpaceMap),
    paddingInlineEnd: (0, $jdRQY.positiveSpaceMap),
    paddingInlineStart: (0, $jdRQY.positiveSpaceMap),
    paddingLeft: (0, $jdRQY.positiveSpaceMap),
    paddingRight: (0, $jdRQY.positiveSpaceMap),
    paddingTop: (0, $jdRQY.positiveSpaceMap),
    right: (0, $jdRQY.allSpaceMap),
    rowGap: (0, $jdRQY.positiveSpaceMap),
    top: (0, $jdRQY.allSpaceMap),
    width: (0, $jdRQY.dimensionMap),
    zIndex: (0, $jdRQY.layerMap)
};
var $c1af30ba5706edd4$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $c1af30ba5706edd4$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $8ovux === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux.env) === "object" && false;
};
var $c1af30ba5706edd4$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $c1af30ba5706edd4$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $c1af30ba5706edd4$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(value) === "object" && $c1af30ba5706edd4$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($c1af30ba5706edd4$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($c1af30ba5706edd4$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $c1af30ba5706edd4$export$9a199fbafee0014e)) return;
        var tokenValue = $c1af30ba5706edd4$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $c1af30ba5706edd4$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $c1af30ba5706edd4$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, $c1af30ba5706edd4$var$uniqueSymbol, (0, $avKww.css)(transformedStyles));
};
var $c1af30ba5706edd4$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $c1af30ba5706edd4$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$c1af30ba5706edd4$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $c1af30ba5706edd4$export$f6c783d06584602c(style) {
    return $c1af30ba5706edd4$var$baseXcss(style);
}

});

parcelRegister("5eMjN", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $3d03bd8c35005175$export$1ca2a26fecb070ae; });

var $9nHZC = parcelRequire("9nHZC");
var $3d03bd8c35005175$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $9nHZC.createContext)("elevation.surface");
var $3d03bd8c35005175$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $9nHZC.useContext)($3d03bd8c35005175$export$1ca2a26fecb070ae);
};
$3d03bd8c35005175$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("1wH1n", function(module, exports) {

$parcel$export(module.exports, "layers", function () { return $11ca26b1d4466a59$export$7be255094ccdc533; });

var $1OnrY = parcelRequire("1OnrY");

var $kbqgc = parcelRequire("kbqgc");
var $11ca26b1d4466a59$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $11ca26b1d4466a59$export$c93026a968943f95 = "light";
var $11ca26b1d4466a59$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $11ca26b1d4466a59$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $11ca26b1d4466a59$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $11ca26b1d4466a59$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $11ca26b1d4466a59$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $11ca26b1d4466a59$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $11ca26b1d4466a59$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $11ca26b1d4466a59$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $kbqgc.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $11ca26b1d4466a59$export$6d8204c2cb2e06b8() / 4;
    (0, $1OnrY.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $11ca26b1d4466a59$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $11ca26b1d4466a59$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $11ca26b1d4466a59$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $1OnrY.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $11ca26b1d4466a59$export$ba1d834b86d72a09 = $11ca26b1d4466a59$export$a1b3edb637fb4f35;
var $11ca26b1d4466a59$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $kbqgc.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $kbqgc.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $kbqgc.N30A), ")")
            }
        }
    };
};

});
parcelRegister("kbqgc", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $eb193475a2d80596$export$215b7063051591f1; });
$parcel$export(module.exports, "N0", function () { return $eb193475a2d80596$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20A", function () { return $eb193475a2d80596$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $eb193475a2d80596$export$920c0d5c49070351; });
$parcel$export(module.exports, "N50A", function () { return $eb193475a2d80596$export$7d3359664e8bb0e5; });
$parcel$export(module.exports, "N60A", function () { return $eb193475a2d80596$export$d2d3bedfb276cac0; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $eb193475a2d80596$export$4b84fd0e2c617bd = "#FFEBE6";
var $eb193475a2d80596$export$b34b069eff244586 = "#FFBDAD";
var $eb193475a2d80596$export$be802dd0d8b57f35 = "#FF8F73";
var $eb193475a2d80596$export$60847d42f9da92a6 = "#FF7452";
var $eb193475a2d80596$export$4a7404f376229999 = "#FF5630";
var $eb193475a2d80596$export$2010d0fb4295b346 = "#DE350B";
var $eb193475a2d80596$export$2837b5a1a71d5c02 = "#BF2600";
var $eb193475a2d80596$export$8d9596b529bbb9cf = "#FFFAE6";
var $eb193475a2d80596$export$41060a744ab0b7ae = "#FFF0B3";
var $eb193475a2d80596$export$1cc05bbbf340e559 = "#FFE380";
var $eb193475a2d80596$export$5aae31392d72caaa = "#FFC400";
var $eb193475a2d80596$export$c6930421db9fa514 = "#FFAB00";
var $eb193475a2d80596$export$59619663aa6500fb = "#FF991F";
var $eb193475a2d80596$export$874739ea9e379ab6 = "#FF8B00";
var $eb193475a2d80596$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $eb193475a2d80596$export$69a3bf21b9686c2b = "#ABF5D1";
var $eb193475a2d80596$export$afbce1382ec95f73 = "#79F2C0";
var $eb193475a2d80596$export$747d86715d4175de = "#57D9A3";
var $eb193475a2d80596$export$940e1f69e873f202 = "#36B37E";
var $eb193475a2d80596$export$a49394138f7b8e85 = "#00875A";
var $eb193475a2d80596$export$6fa04827ac68a4fb = "#006644";
var $eb193475a2d80596$export$226de0355ed012f8 = "#DEEBFF";
var $eb193475a2d80596$export$8c13c2ee36917869 = "#B3D4FF";
var $eb193475a2d80596$export$ecfc1dff386a3e7a = "#4C9AFF";
var $eb193475a2d80596$export$215b7063051591f1 = "#2684FF";
var $eb193475a2d80596$export$e62e8919cca44969 = "#0065FF";
var $eb193475a2d80596$export$b3de0ae08da2ce64 = "#0052CC";
var $eb193475a2d80596$export$a6ee3d71bc067634 = "#0747A6";
var $eb193475a2d80596$export$363e4475840015bb = "#EAE6FF";
var $eb193475a2d80596$export$4b0a4417ed59760f = "#C0B6F2";
var $eb193475a2d80596$export$6011520a64d9a187 = "#998DD9";
var $eb193475a2d80596$export$a7175d4e9206bc80 = "#8777D9";
var $eb193475a2d80596$export$b48405b95304b5a1 = "#6554C0";
var $eb193475a2d80596$export$c71e4279dd54a18d = "#5243AA";
var $eb193475a2d80596$export$147899de772240ec = "#403294";
var $eb193475a2d80596$export$2cf711fe14c66f06 = "#E6FCFF";
var $eb193475a2d80596$export$7a8f4d33f6f9772c = "#B3F5FF";
var $eb193475a2d80596$export$776c9c497ef08533 = "#79E2F2";
var $eb193475a2d80596$export$69cb3ca10c1e330e = "#00C7E6";
var $eb193475a2d80596$export$9dc1ef0f3f48059b = "#00B8D9";
var $eb193475a2d80596$export$7c835c78b6fcdef8 = "#00A3BF";
var $eb193475a2d80596$export$6036577f95c3877e = "#008DA6";
var $eb193475a2d80596$export$29a4f05edc054374 = "#FFFFFF";
var $eb193475a2d80596$export$e655ef011c4aa1a2 = "#FAFBFC";
var $eb193475a2d80596$export$9fdfb749e33cdf97 = "#F4F5F7";
var $eb193475a2d80596$export$3e51e8f1440314ba = "#EBECF0";
var $eb193475a2d80596$export$1ce2d1575d444ceb = "#DFE1E6";
var $eb193475a2d80596$export$8754fc7e6d8b3000 = "#C1C7D0";
var $eb193475a2d80596$export$c2e91cbeada39b8b = "#B3BAC5";
var $eb193475a2d80596$export$5f71e19f3a7ad9de = "#A5ADBA";
var $eb193475a2d80596$export$eaa8c8a70ac22806 = "#97A0AF";
var $eb193475a2d80596$export$7c87d337fb91a97d = "#8993A4";
var $eb193475a2d80596$export$d6447c357493214f = "#7A869A";
var $eb193475a2d80596$export$f563ee71e9ee74cd = "#6B778C";
var $eb193475a2d80596$export$e2ef2124cf4024b1 = "#5E6C84";
var $eb193475a2d80596$export$eece5f492e429f08 = "#505F79";
var $eb193475a2d80596$export$c39c0fe0f26207ae = "#42526E";
var $eb193475a2d80596$export$7090862dc3038a9f = "#344563";
var $eb193475a2d80596$export$ad0bacf983b7ddaa = "#253858";
var $eb193475a2d80596$export$7d61b15e0da132af = "#172B4D";
var $eb193475a2d80596$export$fbda843f0a27fe96 = "#091E42";
var $eb193475a2d80596$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $eb193475a2d80596$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $eb193475a2d80596$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $eb193475a2d80596$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $eb193475a2d80596$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $eb193475a2d80596$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $eb193475a2d80596$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $eb193475a2d80596$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $eb193475a2d80596$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $eb193475a2d80596$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $eb193475a2d80596$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $eb193475a2d80596$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $eb193475a2d80596$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $eb193475a2d80596$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $eb193475a2d80596$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $eb193475a2d80596$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $eb193475a2d80596$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $eb193475a2d80596$export$2f6319cf7d736c2a = "#E6EDFA";
var $eb193475a2d80596$export$95126bc8884d6634 = "#DCE5F5";
var $eb193475a2d80596$export$8338d8c35d44ff1 = "#CED9EB";
var $eb193475a2d80596$export$5368d76ae4fbbda7 = "#B8C7E0";
var $eb193475a2d80596$export$9f0a771d16ec8d36 = "#ABBBD6";
var $eb193475a2d80596$export$abcf8c38338b4aa5 = "#9FB0CC";
var $eb193475a2d80596$export$97e81faa16a182c7 = "#8C9CB8";
var $eb193475a2d80596$export$bfe21c59123ecf33 = "#7988A3";
var $eb193475a2d80596$export$ee82aa2ea6a1558 = "#67758F";
var $eb193475a2d80596$export$682927c6ed76be02 = "#56637A";
var $eb193475a2d80596$export$91fd9994c5be9757 = "#455166";
var $eb193475a2d80596$export$d281fbfe3cff2df6 = "#3B475C";
var $eb193475a2d80596$export$3902c91d8b98a753 = "#313D52";
var $eb193475a2d80596$export$8e8133c1ba5845b5 = "#283447";
var $eb193475a2d80596$export$33ff357f6620b39 = "#202B3D";
var $eb193475a2d80596$export$633847cf062b69e0 = "#1B2638";
var $eb193475a2d80596$export$9776a6e503bdbf76 = "#121A29";
var $eb193475a2d80596$export$6c813d5160dff5db = "#0E1624";
var $eb193475a2d80596$export$3d4f271a500072a = "#0D1424";
var $eb193475a2d80596$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $eb193475a2d80596$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $eb193475a2d80596$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $eb193475a2d80596$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $eb193475a2d80596$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $eb193475a2d80596$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $eb193475a2d80596$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $eb193475a2d80596$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $eb193475a2d80596$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $eb193475a2d80596$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $eb193475a2d80596$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $eb193475a2d80596$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $eb193475a2d80596$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $eb193475a2d80596$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $eb193475a2d80596$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $eb193475a2d80596$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $eb193475a2d80596$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";

});


parcelRegister("8Rbqj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $672c22646fdbba44$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9q1kH = parcelRequire("9q1kH");

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $3ybDD = parcelRequire("3ybDD");

var $2Sjnc = parcelRequire("2Sjnc");

var $aRH7N = parcelRequire("aRH7N");

var $kbqgc = parcelRequire("kbqgc");

var $1wH1n = parcelRequire("1wH1n");

var $xbX1J = parcelRequire("xbX1J");

var $3lR0k = parcelRequire("3lR0k");

var $kCzvG = parcelRequire("kCzvG");

var $k4GJf = parcelRequire("k4GJf");
var $672c22646fdbba44$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children"
];
var $672c22646fdbba44$var$_css;
var $672c22646fdbba44$var$popupFullWidthStyles = (0, $avKww.css)({
    width: "100%"
});
var $672c22646fdbba44$var$popupStyles = (0, $avKww.css)(($672c22646fdbba44$var$_css = {
    display: "block",
    boxSizing: "border-box",
    zIndex: (0, $1wH1n.layers).layer(),
    flex: "1 1 auto",
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $kbqgc.N0), ")"),
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat((0, $kbqgc.N50A), ", 0 0 1px ").concat((0, $kbqgc.N60A)), ")"),
    // Resetting text color for portal content.
    // Otherwise, when rendering into the parent (not using a portal),
    // the text color can be inherited from the parent.
    color: "var(--ds-text, #172B4D)"
}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($672c22646fdbba44$var$_css, (0, $xbX1J.CURRENT_SURFACE_CSS_VAR), "var(--ds-surface-overlay, ".concat((0, $kbqgc.N0), ")")), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($672c22646fdbba44$var$_css, "&:focus", {
    outline: "none"
}), $672c22646fdbba44$var$_css));
var $672c22646fdbba44$var$popupOverflowStyles = (0, $avKww.css)({
    overflow: "auto"
});
// disables iframe pointer events while popup is open, except if iframe is nested inside popup
// solves an issue of popup not being closed on iframe click
var $672c22646fdbba44$var$blockPointerEventsOnExternalIframeStyles = (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "iframe:not([data-ds--level] iframe)": {
        pointerEvents: "none"
    }
});
var $672c22646fdbba44$var$DefaultPopupComponent = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(props, $672c22646fdbba44$var$_excluded);
    return (0, $avKww.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        css: [
            $672c22646fdbba44$var$popupStyles,
            !shouldRenderToParent && $672c22646fdbba44$var$popupOverflowStyles,
            shouldFitContainer && $672c22646fdbba44$var$popupFullWidthStyles
        ]
    }, htmlAttributes, {
        ref: ref
    }), children);
});
function $672c22646fdbba44$var$PopperWrapper(_ref) {
    var isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "auto" : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $672c22646fdbba44$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers;
    var _useState = (0, $9nHZC.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $9nHZC.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases where we need to close the Popup on Tab press.
    // Example: DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== "dialog";
    (0, $k4GJf.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap
    });
    (0, $kCzvG.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var _UNSAFE_useLayering = (0, $3ybDD.UNSAFE_useLayering)(), currentLevel = _UNSAFE_useLayering.currentLevel;
    var mergedModifiers = (0, $9nHZC.useMemo)(function() {
        return [
            {
                name: "flip",
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return (0, $avKww.jsx)((0, $aRH7N.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update;
        return (0, $avKww.jsx)(PopupContainer, {
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === "function") _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            style: style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer
        }, (0, $2Sjnc.fg)("platform.design-system-team.iframe_gojiv") && (0, $avKww.jsx)((0, $avKww.Global), {
            styles: $672c22646fdbba44$var$blockPointerEventsOnExternalIframeStyles
        }), (0, $avKww.jsx)((0, $3lR0k.RepositionOnUpdate), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$672c22646fdbba44$export$2e2bcd8739ae039 = $672c22646fdbba44$var$PopperWrapper;

});
parcelRegister("aRH7N", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $7e904e50ddab7ace$export$badac9ada3a0bdf9; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $cjxQA = parcelRequire("cjxQA");

// Export types from PopperJS / React Popper
var $7e904e50ddab7ace$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: 5,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    },
    {
        name: "preventOverflow",
        options: {
            padding: 5,
            rootBoundary: "document"
        }
    }
];
function $7e904e50ddab7ace$var$defaultChildrenFn() {
    return null;
}
var $7e904e50ddab7ace$var$defaultOffset = [
    0,
    8
];
function $7e904e50ddab7ace$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $7e904e50ddab7ace$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $7e904e50ddab7ace$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    // Merge a new offset modifier only if new offset values passed in
    var internalModifiers = (0, $9nHZC.useMemo)(function() {
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        return [].concat($7e904e50ddab7ace$var$constantModifiers, [
            offsetModifier
        ]);
    }, [
        offsetX,
        offsetY
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $9nHZC.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $cjxQA.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});

parcelRegister("3lR0k", function(module, exports) {

$parcel$export(module.exports, "RepositionOnUpdate", function () { return $270c72cae32699b5$export$51eddd7655ca235a; });

var $9nHZC = parcelRequire("9nHZC");
var $270c72cae32699b5$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $9nHZC.useRef)(true);
    (0, $9nHZC.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, children);
};

});

parcelRegister("kCzvG", function(module, exports) {

$parcel$export(module.exports, "useCloseManager", function () { return $f032e6d5403e24da$export$92dae2778ae88f9d; });
// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $9nHZC = parcelRequire("9nHZC");

var $1FiMp = parcelRequire("1FiMp");

var $8p2GL = parcelRequire("8p2GL");

var $3ybDD = parcelRequire("3ybDD");

var $2Sjnc = parcelRequire("2Sjnc");

var $fhnbG = parcelRequire("fhnbG");

var $3B9vO = parcelRequire("3B9vO");
var $f032e6d5403e24da$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, capture = _ref.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldRenderToParent = _ref.shouldRenderToParent;
    var _UNSAFE_useLayering = (0, $3ybDD.UNSAFE_useLayering)(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled, currentLevel = _UNSAFE_useLayering.currentLevel;
    var _useAnimationFrame = (0, $3B9vO.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    (0, $9nHZC.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $8p2GL.default;
        var closePopup = function closePopup(event) {
            if (onClose) onClose(event);
            if (shouldDisableFocusTrap && (0, $2Sjnc.fg)("platform_dst_popup-disable-focuslock")) {
                // Restoring the normal focus order for trigger.
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute("tabindex", "0");
                if (popupRef && autoFocus) popupRef.setAttribute("tabindex", "0");
            }
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            if ((0, $2Sjnc.fg)("platform_dst_popup-disable-focuslock")) {
                var _document$activeEleme;
                if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest("[aria-modal]")) //if it is a disabled layer, we need to disable its click listener.
                return;
            } else {
                if (isLayerDisabled()) //if it is a disabled layer, we need to disable its click listener.
                return;
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $fhnbG.isInteractiveElement)(document.activeElement) && (0, $2Sjnc.fg)("platform_dst_popup-disable-focuslock")) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        var onKeyDown = function onKeyDown(event) {
            if ((0, $2Sjnc.fg)("platform_dst_popup-disable-focuslock")) {
                var key = event.key, shiftKey = event.shiftKey;
                if (shiftKey && key === "Tab" && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === "Tab") {
                    var _document$activeEleme2;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme2 = document.activeElement) !== null && _document$activeEleme2 !== void 0 && _document$activeEleme2.closest("[aria-modal]")) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === "Escape" || key === "Esc") {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                var _key = event.key;
                if (_key === "Escape" || _key === "Esc" || shouldCloseOnTab && _key === "Tab") closePopup(event);
            }
        };
        var unbind = (0, $1FiMp.bindAll)(window, [
            {
                type: "click",
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: "keydown",
                listener: onKeyDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $8p2GL.default);
        unbindBlur = (0, $1FiMp.bind)(window, {
            type: "blur",
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            cancelAllFrames();
            unbind();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("fhnbG", function(module, exports) {

$parcel$export(module.exports, "isInteractiveElement", function () { return $b1fa6e1254daa68b$export$3dee5e4542c672d9; });
var $b1fa6e1254daa68b$var$interactiveTags = [
    "button",
    "a",
    "input",
    "select",
    "textarea"
];
var $b1fa6e1254daa68b$export$3dee5e4542c672d9 = function isInteractiveElement(element) {
    if ($b1fa6e1254daa68b$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute("tabindex") !== null || element.hasAttribute("contenteditable")) return true;
    return false;
};

});

parcelRegister("3B9vO", function(module, exports) {

$parcel$export(module.exports, "useAnimationFrame", function () { return $29ec34b14f5fa8fa$export$641fa9c94086b46e; });

var $9nHZC = parcelRequire("9nHZC");
var $29ec34b14f5fa8fa$export$641fa9c94086b46e = function useAnimationFrame() {
    var animationsRef = (0, $9nHZC.useRef)([]);
    var requestFrame = (0, $9nHZC.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, $9nHZC.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, $9nHZC.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("k4GJf", function(module, exports) {

$parcel$export(module.exports, "useFocusManager", function () { return $e9d5536d75a31a0d$export$10c5169755ce7bd7; });

var $9nHZC = parcelRequire("9nHZC");

var $7fTmn = parcelRequire("7fTmn");

var $8p2GL = parcelRequire("8p2GL");

var $2Sjnc = parcelRequire("2Sjnc");

var $3B9vO = parcelRequire("3B9vO");
var $e9d5536d75a31a0d$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap;
    var _useAnimationFrame = (0, $3B9vO.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    (0, $9nHZC.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $8p2GL.default;
        if (shouldDisableFocusTrap && (0, $2Sjnc.fg)("platform_dst_popup-disable-focuslock")) {
            // Plucking trigger & popup content container from the tab order so that
            // when we Shift+Tab, the focus moves to the element before trigger
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute("tabindex", "-1");
                if (popupRef && autoFocus) popupRef.setAttribute("tabindex", "-1");
                (initialFocusRef || popupRef).focus();
            });
            return 0, $8p2GL.default;
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: true
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($7fTmn)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("7fTmn", function(module, exports) {

var $fTzXr = parcelRequire("fTzXr");
var $5484e07549860d07$var$listeningFocusTrap = null;
function $5484e07549860d07$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === "string" ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $5484e07549860d07$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($5484e07549860d07$var$listeningFocusTrap) $5484e07549860d07$var$listeningFocusTrap.pause();
        $5484e07549860d07$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $5484e07549860d07$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener("focus", checkFocus, true);
        document.addEventListener("click", checkClick, true);
        document.addEventListener("mousedown", checkPointerDown, true);
        document.addEventListener("touchstart", checkPointerDown, true);
        document.addEventListener("keydown", checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $5484e07549860d07$var$listeningFocusTrap !== trap) return;
        document.removeEventListener("focus", checkFocus, true);
        document.removeEventListener("click", checkClick, true);
        document.removeEventListener("mousedown", checkPointerDown, true);
        document.removeEventListener("touchstart", checkPointerDown, true);
        document.removeEventListener("keydown", checkKey, true);
        $5484e07549860d07$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === "string") {
            node = document.querySelector(optionValue);
            if (!node) throw new Error("`" + optionName + "` refers to no known node");
        }
        if (typeof optionValue === "function") {
            node = optionValue();
            if (!node) throw new Error("`" + optionName + "` did not return a node");
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption("initialFocus") !== null) node = getNodeForOption("initialFocus");
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption("fallbackFocus");
        if (!node) throw new Error("You can't have a focus-trap without at least one focusable element");
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === "function") e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === "Tab" || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $5484e07549860d07$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute("tabindex") && Number(e.target.getAttribute("tabindex")) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $5484e07549860d07$var$tryFocus(lastTabbableNode);
            return $5484e07549860d07$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $5484e07549860d07$var$tryFocus(firstTabbableNode);
        $5484e07549860d07$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $fTzXr(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $5484e07549860d07$var$tryFocus(lastTabbableNode);
        $5484e07549860d07$var$tryFocus(firstTabbableNode);
    }
}
function $5484e07549860d07$var$isEscapeEvent(e) {
    return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
}
function $5484e07549860d07$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === "input") node.select();
}
module.exports = $5484e07549860d07$var$focusTrap;

});
parcelRegister("fTzXr", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $b927e287ffe709d9$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        "input",
        "select",
        "a[href]",
        "textarea",
        "button",
        "[tabindex]"
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(","));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute("tabindex"), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === "INPUT" && candidate.type === "hidden" || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $b927e287ffe709d9$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === "none") result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === "hidden";
    };
}

});




parcelRegister("bZL5V", function(module, exports) {

$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", function () { return $8bb9ec38b374dc12$export$7cc5c058dd769dff; });

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $2oxuN = parcelRequire("2oxuN");
var $8bb9ec38b374dc12$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $9nHZC.useState)(function() {
        return (0, $2oxuN.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === "function") ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};

});
parcelRegister("2oxuN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1be7ce32b5a7c8ab$export$2e2bcd8739ae039; });
var $1be7ce32b5a7c8ab$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $1be7ce32b5a7c8ab$var$isEqual(first, second) {
    if (first === second) return true;
    if ($1be7ce32b5a7c8ab$var$safeIsNaN(first) && $1be7ce32b5a7c8ab$var$safeIsNaN(second)) return true;
    return false;
}
function $1be7ce32b5a7c8ab$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$1be7ce32b5a7c8ab$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $1be7ce32b5a7c8ab$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $1be7ce32b5a7c8ab$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});




parcelRegister("1Yet2", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", function () { return $16f69df9def4f153$export$f18c1d4fc7326096; });
$parcel$export(module.exports, "default", function () { return $16f69df9def4f153$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $9XfsT = parcelRequire("9XfsT");

var $8p2GL = parcelRequire("8p2GL");

var $f3xHD = parcelRequire("f3xHD");

var $fMvwI = parcelRequire("fMvwI");
var $16f69df9def4f153$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $9nHZC.createContext)({
    menuItemRefs: [],
    registerRef: (0, $8p2GL.default)
});
/**
 * Focus manager logic
 */ var $16f69df9def4f153$var$FocusManager = function FocusManager(_ref) {
    var children = _ref.children;
    var menuItemRefs = (0, $9nHZC.useRef)([]);
    var registerRef = (0, $9nHZC.useCallback)(function(ref) {
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    var _UNSAFE_useLayering = (0, $f3xHD.UNSAFE_useLayering)(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled;
    // Intentionally rebinding on each render
    (0, $9nHZC.useEffect)(function() {
        return (0, $9XfsT.bind)(window, {
            type: "keydown",
            listener: (0, $fMvwI.default)(menuItemRefs.current, isLayerDisabled)
        });
    });
    var contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($16f69df9def4f153$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $16f69df9def4f153$export$2e2bcd8739ae039 = $16f69df9def4f153$var$FocusManager;

});
parcelRegister("f3xHD", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useLayering", function () { return $af61477aafc1f4b0$export$cec37b93989366d4; });

var $9nHZC = parcelRequire("9nHZC");

var $9XfsT = parcelRequire("9XfsT");

var $2tbiV = parcelRequire("2tbiV");
var $af61477aafc1f4b0$var$ESCAPE = "Escape";
function $af61477aafc1f4b0$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $9nHZC.useRef)(false);
    var _UNSAFE_useLayering = $af61477aafc1f4b0$export$cec37b93989366d4(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled;
    var onKeyDown = (0, $9nHZC.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $af61477aafc1f4b0$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $9nHZC.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $9nHZC.useEffect)(function() {
        return (0, $9XfsT.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $af61477aafc1f4b0$export$cec37b93989366d4() {
    var currentLevel = (0, $9nHZC.useContext)((0, $2tbiV.LevelContext));
    var _useContext = (0, $9nHZC.useContext)((0, $2tbiV.TopLevelContext)), topLevelRef = _useContext.topLevelRef;
    var isLayerDisabled = (0, $9nHZC.useCallback)(function() {
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}

});
parcelRegister("2tbiV", function(module, exports) {

$parcel$export(module.exports, "LevelContext", function () { return $1cc70efae26f243d$export$650d12d3c2ddb8fc; });
$parcel$export(module.exports, "TopLevelContext", function () { return $1cc70efae26f243d$export$48b383b280e20440; });

var $9nHZC = parcelRequire("9nHZC");

var $8p2GL = parcelRequire("8p2GL");

var $dEQSq = parcelRequire("dEQSq");
var $1cc70efae26f243d$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $9nHZC.createContext)(0);
var $1cc70efae26f243d$export$48b383b280e20440 = /*#__PURE__*/ (0, $9nHZC.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $8p2GL.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $1cc70efae26f243d$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $9nHZC.useContext)($1cc70efae26f243d$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel;
    setTopLevel(currentLevel);
    (0, $9nHZC.useEffect)(function() {
        // avoid immediate cleanup using setTimeout when component unmount
        // this will make sure non-top layer components can get the correct top level value
        // when multiple layers trigger onClose in sequence.
        // From React 17, the useEffect cleanup functions are delayed till the commit phase is completed. In other words, the useEffect cleanup functions run asynchronously - for example, if the component is unmounting, the cleanup runs after the screen has been updated.
        // TODO revisit after we migrate to react 18. https://product-fabric.atlassian.net/browse/DSP-13139
        return function() {
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($1cc70efae26f243d$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $1cc70efae26f243d$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $9nHZC.useRef)(0);
    var value = (0, $9nHZC.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($1cc70efae26f243d$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $1cc70efae26f243d$export$a183686c3f6f4ea8 = function UNSAFE_LAYERING(_ref3) {
    var children = _ref3.children;
    var currentLevel = (0, $9nHZC.useContext)($1cc70efae26f243d$export$650d12d3c2ddb8fc);
    var isNested = currentLevel > 0;
    if (!(0, $dEQSq.getBooleanFF)("platform.design-system-team.layering_qmiw3")) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, children);
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($1cc70efae26f243d$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($1cc70efae26f243d$var$LayeringProvider, null, content);
};

});


parcelRegister("fMvwI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7d3cb40650cbb4f$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $70mT6 = parcelRequire("70mT6");
var $b7d3cb40650cbb4f$var$_actionMap;
var $b7d3cb40650cbb4f$var$actionMap = ($b7d3cb40650cbb4f$var$_actionMap = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($b7d3cb40650cbb4f$var$_actionMap, (0, $70mT6.KEY_DOWN), "next"), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($b7d3cb40650cbb4f$var$_actionMap, (0, $70mT6.KEY_UP), "prev"), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($b7d3cb40650cbb4f$var$_actionMap, (0, $70mT6.KEY_HOME), "first"), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($b7d3cb40650cbb4f$var$_actionMap, (0, $70mT6.KEY_END), "last"), $b7d3cb40650cbb4f$var$_actionMap);
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ var $b7d3cb40650cbb4f$var$getNextFocusableElement = function getNextFocusableElement(refs, currentFocusedIdx) {
    while(currentFocusedIdx + 1 < refs.length){
        var isDisabled = refs[currentFocusedIdx + 1].hasAttribute("disabled");
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ var $b7d3cb40650cbb4f$var$getPrevFocusableElement = function getPrevFocusableElement(refs, currentFocusedIdx) {
    while(currentFocusedIdx > 0){
        var isDisabled = refs[currentFocusedIdx - 1].hasAttribute("disabled");
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $b7d3cb40650cbb4f$export$2e2bcd8739ae039(refs, isLayerDisabled) {
    return function(e) {
        var currentFocusedIdx = refs.findIndex(function(el) {
            var _document$activeEleme;
            return (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el);
        });
        if (isLayerDisabled()) // if it is a nested dropdown and the level of the given dropdown is not the current level,
        // we don't need to have focus on it
        return;
        var action = $b7d3cb40650cbb4f$var$actionMap[e.key];
        switch(action){
            case "next":
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    var _nextFocusableElement = $b7d3cb40650cbb4f$var$getNextFocusableElement(refs, currentFocusedIdx);
                    _nextFocusableElement === null || _nextFocusableElement === void 0 || _nextFocusableElement.focus();
                }
                break;
            case "prev":
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    var _prevFocusableElement = $b7d3cb40650cbb4f$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    _prevFocusableElement === null || _prevFocusableElement === void 0 || _prevFocusableElement.focus();
                }
                break;
            case "first":
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                var nextFocusableElement = $b7d3cb40650cbb4f$var$getNextFocusableElement(refs, -1);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case "last":
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                var prevFocusableElement = $b7d3cb40650cbb4f$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});


parcelRegister("5czZL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c99fe9f04e28555$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $8HHuo = parcelRequire("8HHuo");

var $iHwo8 = parcelRequire("iHwo8");
var $bMwoh = parcelRequire("bMwoh");

var $9U6wZ = parcelRequire("9U6wZ");

var $1Yet2 = parcelRequire("1Yet2");

var $A4azx = parcelRequire("A4azx");

var $jvQ2Z = parcelRequire("jvQ2Z");
var $3c99fe9f04e28555$var$spinnerContainerStyles = (0, $bMwoh.xcss)({
    display: "flex",
    minWidth: "160px",
    padding: "space.250",
    justifyContent: "center"
});
var $3c99fe9f04e28555$var$LoadingIndicator = function LoadingIndicator(_ref) {
    var _ref$statusLabel = _ref.statusLabel, statusLabel = _ref$statusLabel === void 0 ? "Loading" : _ref$statusLabel, testId = _ref.testId;
    return (0, $avKww.jsx)((0, $iHwo8.default), {
        xcss: $3c99fe9f04e28555$var$spinnerContainerStyles
    }, (0, $avKww.jsx)((0, $9U6wZ.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
};
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ var $3c99fe9f04e28555$var$MenuWrapper = function MenuWrapper(_ref2) {
    var children = _ref2.children, isLoading = _ref2.isLoading, maxHeight = _ref2.maxHeight, maxWidth = _ref2.maxWidth, onClose = _ref2.onClose, onUpdate = _ref2.onUpdate, statusLabel = _ref2.statusLabel, setInitialFocusRef = _ref2.setInitialFocusRef, spacing = _ref2.spacing, testId = _ref2.testId;
    var _useContext = (0, $9nHZC.useContext)((0, $1Yet2.FocusManagerContext)), menuItemRefs = _useContext.menuItemRefs;
    var closeOnMenuItemClick = function closeOnMenuItemClick(e) {
        var isTargetMenuItemOrDecendant = menuItemRefs.some(function(menuItem) {
            var isCheckboxOrRadio = (0, $A4azx.default)(menuItem) || (0, $jvQ2Z.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $9nHZC.useLayoutEffect)(function() {
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $9nHZC.useEffect)(function() {
        var _menuItemRefs$find;
        var firstFocusableRef = (_menuItemRefs$find = menuItemRefs.find(function(ref) {
            return !ref.hasAttribute("disabled");
        })) !== null && _menuItemRefs$find !== void 0 ? _menuItemRefs$find : null;
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return (0, $avKww.jsx)((0, $8HHuo.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && "".concat(testId, "--menu-group")
    }, isLoading ? (0, $avKww.jsx)($3c99fe9f04e28555$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && "".concat(testId, "--loading-indicator")
    }) : children);
};
var $3c99fe9f04e28555$export$2e2bcd8739ae039 = $3c99fe9f04e28555$var$MenuWrapper;

});
parcelRegister("8HHuo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $656412ed7b887a7e$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $avKww = parcelRequire("avKww");

var $32Kjv = parcelRequire("32Kjv");
var $656412ed7b887a7e$var$_excluded = [
    "isLoading",
    "maxWidth",
    "minWidth",
    "minHeight",
    "maxHeight",
    "testId",
    "role",
    "spacing",
    "className"
];
var $656412ed7b887a7e$var$baseStyles = (0, $avKww.css)({
    display: "flex",
    position: "static",
    flexDirection: "column",
    overflow: "auto"
});
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $656412ed7b887a7e$var$MenuGroup = function MenuGroup(_ref) {
    var isLoading = _ref.isLoading, maxWidth = _ref.maxWidth, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, testId = _ref.testId, role = _ref.role, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "cozy" : _ref$spacing, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $656412ed7b887a7e$var$_excluded);
    return (0, $avKww.jsx)((0, $32Kjv.SpacingContext).Provider, {
        value: spacing
    }, (0, $avKww.jsx)((0, $32Kjv.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "border"
    }, (0, $avKww.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        css: $656412ed7b887a7e$var$baseStyles,
        "data-testid": testId,
        role: role,
        className: UNSAFE_className
    }, rest))));
};
var $656412ed7b887a7e$export$2e2bcd8739ae039 = $656412ed7b887a7e$var$MenuGroup;

});
parcelRegister("32Kjv", function(module, exports) {

$parcel$export(module.exports, "SpacingContext", function () { return $23757bebcb0a018a$export$443076ec7ebce042; });
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", function () { return $23757bebcb0a018a$export$9ca534b70725964d; });

var $9nHZC = parcelRequire("9nHZC");
var $23757bebcb0a018a$export$443076ec7ebce042 = /*#__PURE__*/ (0, $9nHZC.createContext)("cozy");
var $23757bebcb0a018a$export$9ca534b70725964d = /*#__PURE__*/ (0, $9nHZC.createContext)("border");

});


parcelRegister("iHwo8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9d55dc9e1539a46$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $kDLnY = parcelRequire("kDLnY");

var $bMwoh = parcelRequire("bMwoh");

var $aaBo2 = parcelRequire("aaBo2");
var $d9d55dc9e1539a46$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $d9d55dc9e1539a46$var$_excluded2 = [
    "className"
];
var $d9d55dc9e1539a46$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, as = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $d9d55dc9e1539a46$var$_excluded);
    var Component = as;
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(htmlAttributes, $d9d55dc9e1539a46$var$_excluded2);
    var className = xcss && (0, $bMwoh.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $avKww.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        css: [
            $d9d55dc9e1539a46$var$baseStyles,
            backgroundColor && (0, $kDLnY.backgroundColorStylesMap)[backgroundColor],
            (0, $kDLnY.isSurfaceColorToken)(backgroundColor) && (0, $kDLnY.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $kDLnY.paddingStylesMap).padding[padding],
            paddingBlock && (0, $kDLnY.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $kDLnY.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $kDLnY.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $kDLnY.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $kDLnY.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $kDLnY.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            className
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $avKww.jsx)((0, $aaBo2.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $d9d55dc9e1539a46$export$2e2bcd8739ae039 = $d9d55dc9e1539a46$export$e71c4d32a2263218;
var $d9d55dc9e1539a46$var$baseStyles = (0, $avKww.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("kDLnY", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $f06c34f57a4af623$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $f06c34f57a4af623$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $f06c34f57a4af623$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $f06c34f57a4af623$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $f06c34f57a4af623$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $f06c34f57a4af623$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $f06c34f57a4af623$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $f06c34f57a4af623$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $f06c34f57a4af623$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $f06c34f57a4af623$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $f06c34f57a4af623$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $f06c34f57a4af623$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $f06c34f57a4af623$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $f06c34f57a4af623$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $f06c34f57a4af623$export$5e65a44e5b6ecadb; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $xbX1J = parcelRequire("xbX1J");
function $f06c34f57a4af623$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f06c34f57a4af623$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f06c34f57a4af623$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f06c34f57a4af623$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f06c34f57a4af623$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $f06c34f57a4af623$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $f06c34f57a4af623$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $f06c34f57a4af623$export$632685d741f3dbbf = $f06c34f57a4af623$var$_objectSpread($f06c34f57a4af623$var$_objectSpread({}, $f06c34f57a4af623$export$958d0ae7f2977ae4), $f06c34f57a4af623$export$d2dc61f58390201c);
var $f06c34f57a4af623$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $f06c34f57a4af623$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $f06c34f57a4af623$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $f06c34f57a4af623$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $f06c34f57a4af623$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $f06c34f57a4af623$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $f06c34f57a4af623$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)"
};
var $f06c34f57a4af623$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $f06c34f57a4af623$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $f06c34f57a4af623$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $f06c34f57a4af623$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $f06c34f57a4af623$export$6cc560b4dedf3816 = {
    "font.size.050": "var(--ds-font-size-050, 11px)",
    "font.size.075": "var(--ds-font-size-075, 12px)",
    "font.size.100": "var(--ds-font-size-100, 14px)",
    "font.size.200": "var(--ds-font-size-200, 16px)",
    "font.size.300": "var(--ds-font-size-300, 20px)",
    "font.size.400": "var(--ds-font-size-400, 24px)",
    "font.size.500": "var(--ds-font-size-500, 29px)",
    "font.size.600": "var(--ds-font-size-600, 35px)"
};
var $f06c34f57a4af623$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $f06c34f57a4af623$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand": "var(--ds-font-family-brand, Charlie Sans)",
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.monospace": 'var(--ds-font-family-monospace, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.sans": 'var(--ds-font-family-sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif)'
};
var $f06c34f57a4af623$export$360c29a380c1a34 = {
    "font.lineHeight.1": "var(--ds-font-lineHeight-1, 1)",
    "font.lineHeight.100": "var(--ds-font-lineHeight-100, 16px)",
    "font.lineHeight.200": "var(--ds-font-lineHeight-200, 20px)",
    "font.lineHeight.300": "var(--ds-font-lineHeight-300, 24px)",
    "font.lineHeight.400": "var(--ds-font-lineHeight-400, 28px)",
    "font.lineHeight.500": "var(--ds-font-lineHeight-500, 32px)",
    "font.lineHeight.600": "var(--ds-font-lineHeight-600, 40px)"
};
var $f06c34f57a4af623$export$b5bac06d7d8fd0d1 = {
    body: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $f06c34f57a4af623$export$b27166c9cf2c9f74 = {
    ui: 'var(--ds-font-ui, normal 500 14px/1 ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "ui.small": 'var(--ds-font-ui-small, normal 400 11px/1 ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $f06c34f57a4af623$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $f06c34f57a4af623$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $avKww.css)((0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $f06c34f57a4af623$export$e615f061ca585a6c = $f06c34f57a4af623$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $f06c34f57a4af623$var$getSerializedStylesMap(spacingProperty, $f06c34f57a4af623$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $f06c34f57a4af623$export$bf46c3f9eeafc71f = $f06c34f57a4af623$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $f06c34f57a4af623$var$getSerializedStylesMap(spacingProperty, $f06c34f57a4af623$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $f06c34f57a4af623$export$e7af83bafe7f9e63 = $f06c34f57a4af623$var$getSerializedStylesMap("backgroundColor", $f06c34f57a4af623$export$d1d79bf68ac056bd);
var $f06c34f57a4af623$export$3a1bcba60b23d7f0 = $f06c34f57a4af623$var$getSerializedStylesMap("color", $f06c34f57a4af623$export$8473307aa00d6ea1);
var $f06c34f57a4af623$export$f7183c9e2dbc2543 = $f06c34f57a4af623$var$getSerializedStylesMap("fontSize", $f06c34f57a4af623$export$6cc560b4dedf3816);
var $f06c34f57a4af623$export$45f3f4fe16f9f7d5 = $f06c34f57a4af623$var$getSerializedStylesMap("fontWeight", $f06c34f57a4af623$export$303e322c6b1ed114);
var $f06c34f57a4af623$export$68cc305da27dbaa4 = $f06c34f57a4af623$var$getSerializedStylesMap("fontFamily", $f06c34f57a4af623$export$3c7e9587132614b4);
var $f06c34f57a4af623$export$8be4a21014f48eb1 = $f06c34f57a4af623$var$getSerializedStylesMap("lineHeight", $f06c34f57a4af623$export$360c29a380c1a34);
var $f06c34f57a4af623$export$a1962444bbf058e = $f06c34f57a4af623$var$getSerializedStylesMap("font", $f06c34f57a4af623$export$b5bac06d7d8fd0d1);
var $f06c34f57a4af623$export$ca3e246f24657bd6 = $f06c34f57a4af623$var$getSerializedStylesMap("font", $f06c34f57a4af623$export$b27166c9cf2c9f74);
var $f06c34f57a4af623$export$ff257d957d48c421 = $f06c34f57a4af623$var$getSerializedStylesMap((0, $xbX1J.CURRENT_SURFACE_CSS_VAR), $f06c34f57a4af623$export$41a358c9c2356760);
var $f06c34f57a4af623$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $f06c34f57a4af623$export$41a358c9c2356760[color] !== undefined;
};

});

parcelRegister("bMwoh", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $893d4d86c1f2bd96$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $893d4d86c1f2bd96$export$f6c783d06584602c; });

var $kFnE9 = parcelRequire("kFnE9");

var $9q1kH = parcelRequire("9q1kH");

var $340K4 = parcelRequire("340K4");

var $avKww = parcelRequire("avKww");

var $kDLnY = parcelRequire("kDLnY");

var $8ovux = parcelRequire("8ovux");
var $893d4d86c1f2bd96$export$9a199fbafee0014e = {
    backgroundColor: (0, $kDLnY.backgroundColorMap),
    blockSize: (0, $kDLnY.dimensionMap),
    borderBlockColor: (0, $kDLnY.borderColorMap),
    borderBlockEndColor: (0, $kDLnY.borderColorMap),
    borderBlockEndWidth: (0, $kDLnY.borderWidthMap),
    borderBlockStartColor: (0, $kDLnY.borderColorMap),
    borderBlockStartWidth: (0, $kDLnY.borderWidthMap),
    borderBlockWidth: (0, $kDLnY.borderWidthMap),
    borderBottomColor: (0, $kDLnY.borderColorMap),
    borderBottomLeftRadius: (0, $kDLnY.borderRadiusMap),
    borderBottomRightRadius: (0, $kDLnY.borderRadiusMap),
    borderBottomWidth: (0, $kDLnY.borderWidthMap),
    borderColor: (0, $kDLnY.borderColorMap),
    borderEndEndRadius: (0, $kDLnY.borderRadiusMap),
    borderEndStartRadius: (0, $kDLnY.borderRadiusMap),
    borderInlineColor: (0, $kDLnY.borderColorMap),
    borderInlineEndColor: (0, $kDLnY.borderColorMap),
    borderInlineEndWidth: (0, $kDLnY.borderWidthMap),
    borderInlineStartColor: (0, $kDLnY.borderColorMap),
    borderInlineStartWidth: (0, $kDLnY.borderWidthMap),
    borderInlineWidth: (0, $kDLnY.borderWidthMap),
    borderLeftColor: (0, $kDLnY.borderColorMap),
    borderLeftWidth: (0, $kDLnY.borderWidthMap),
    borderRadius: (0, $kDLnY.borderRadiusMap),
    borderRightColor: (0, $kDLnY.borderColorMap),
    borderRightWidth: (0, $kDLnY.borderWidthMap),
    borderStartEndRadius: (0, $kDLnY.borderRadiusMap),
    borderStartStartRadius: (0, $kDLnY.borderRadiusMap),
    borderTopColor: (0, $kDLnY.borderColorMap),
    borderTopLeftRadius: (0, $kDLnY.borderRadiusMap),
    borderTopRightRadius: (0, $kDLnY.borderRadiusMap),
    borderTopWidth: (0, $kDLnY.borderWidthMap),
    borderWidth: (0, $kDLnY.borderWidthMap),
    bottom: (0, $kDLnY.allSpaceMap),
    boxShadow: (0, $kDLnY.shadowMap),
    color: (0, $kDLnY.textColorMap),
    columnGap: (0, $kDLnY.positiveSpaceMap),
    gap: (0, $kDLnY.positiveSpaceMap),
    height: (0, $kDLnY.dimensionMap),
    inlineSize: (0, $kDLnY.dimensionMap),
    inset: (0, $kDLnY.allSpaceMap),
    insetBlock: (0, $kDLnY.allSpaceMap),
    insetBlockEnd: (0, $kDLnY.allSpaceMap),
    insetBlockStart: (0, $kDLnY.allSpaceMap),
    insetInline: (0, $kDLnY.allSpaceMap),
    insetInlineEnd: (0, $kDLnY.allSpaceMap),
    insetInlineStart: (0, $kDLnY.allSpaceMap),
    left: (0, $kDLnY.allSpaceMap),
    margin: (0, $kDLnY.allSpaceMap),
    marginBlock: (0, $kDLnY.allSpaceMap),
    marginBlockEnd: (0, $kDLnY.allSpaceMap),
    marginBlockStart: (0, $kDLnY.allSpaceMap),
    marginBottom: (0, $kDLnY.allSpaceMap),
    marginInline: (0, $kDLnY.allSpaceMap),
    marginInlineEnd: (0, $kDLnY.allSpaceMap),
    marginInlineStart: (0, $kDLnY.allSpaceMap),
    marginLeft: (0, $kDLnY.allSpaceMap),
    marginRight: (0, $kDLnY.allSpaceMap),
    marginTop: (0, $kDLnY.allSpaceMap),
    maxBlockSize: (0, $kDLnY.dimensionMap),
    maxHeight: (0, $kDLnY.dimensionMap),
    maxInlineSize: (0, $kDLnY.dimensionMap),
    maxWidth: (0, $kDLnY.dimensionMap),
    minBlockSize: (0, $kDLnY.dimensionMap),
    minHeight: (0, $kDLnY.dimensionMap),
    minInlineSize: (0, $kDLnY.dimensionMap),
    minWidth: (0, $kDLnY.dimensionMap),
    opacity: (0, $kDLnY.opacityMap),
    outlineColor: (0, $kDLnY.borderColorMap),
    outlineOffset: (0, $kDLnY.positiveSpaceMap),
    outlineWidth: (0, $kDLnY.borderWidthMap),
    padding: (0, $kDLnY.positiveSpaceMap),
    paddingBlock: (0, $kDLnY.positiveSpaceMap),
    paddingBlockEnd: (0, $kDLnY.positiveSpaceMap),
    paddingBlockStart: (0, $kDLnY.positiveSpaceMap),
    paddingBottom: (0, $kDLnY.positiveSpaceMap),
    paddingInline: (0, $kDLnY.positiveSpaceMap),
    paddingInlineEnd: (0, $kDLnY.positiveSpaceMap),
    paddingInlineStart: (0, $kDLnY.positiveSpaceMap),
    paddingLeft: (0, $kDLnY.positiveSpaceMap),
    paddingRight: (0, $kDLnY.positiveSpaceMap),
    paddingTop: (0, $kDLnY.positiveSpaceMap),
    right: (0, $kDLnY.allSpaceMap),
    rowGap: (0, $kDLnY.positiveSpaceMap),
    top: (0, $kDLnY.allSpaceMap),
    width: (0, $kDLnY.dimensionMap),
    zIndex: (0, $kDLnY.layerMap)
};
var $893d4d86c1f2bd96$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $893d4d86c1f2bd96$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $8ovux === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux.env) === "object" && false;
};
var $893d4d86c1f2bd96$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $893d4d86c1f2bd96$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $893d4d86c1f2bd96$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(value) === "object" && $893d4d86c1f2bd96$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($893d4d86c1f2bd96$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($893d4d86c1f2bd96$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $893d4d86c1f2bd96$export$9a199fbafee0014e)) return;
        var tokenValue = $893d4d86c1f2bd96$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $893d4d86c1f2bd96$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $893d4d86c1f2bd96$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, $893d4d86c1f2bd96$var$uniqueSymbol, (0, $avKww.css)(transformedStyles));
};
var $893d4d86c1f2bd96$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) return args.map(function(x) {
        return x && parseXcss(x);
    }).filter(Boolean);
    var styles = args[$893d4d86c1f2bd96$var$uniqueSymbol];
    typeof $8ovux === "undefined" || (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux);
    return styles;
};
function $893d4d86c1f2bd96$export$f6c783d06584602c(style) {
    return $893d4d86c1f2bd96$var$baseXcss(style);
}

});

parcelRegister("aaBo2", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $7677d6c12fccfc52$export$1ca2a26fecb070ae; });

var $9nHZC = parcelRequire("9nHZC");
var $7677d6c12fccfc52$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $9nHZC.createContext)("elevation.surface");
var $7677d6c12fccfc52$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $9nHZC.useContext)($7677d6c12fccfc52$export$1ca2a26fecb070ae);
};
$7677d6c12fccfc52$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("9U6wZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $735e68f953d26b55$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $5fUc4 = parcelRequire("5fUc4");

var $fv0Gh = parcelRequire("fv0Gh");

var $b4W0Q = parcelRequire("b4W0Q");
/**
 * Returns the appropriate circle stroke color.
 */ function $735e68f953d26b55$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $fv0Gh.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $fv0Gh.N0), ")");
}
var $735e68f953d26b55$var$rotate = (0, $avKww.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $735e68f953d26b55$var$rotateStyles = (0, $avKww.css)({
    animation: "".concat($735e68f953d26b55$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $735e68f953d26b55$var$loadIn = (0, $avKww.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $735e68f953d26b55$var$loadInStyles = (0, $avKww.css)({
    animation: "".concat($735e68f953d26b55$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $735e68f953d26b55$var$wrapperStyles = (0, $avKww.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $735e68f953d26b55$var$circleStyles = (0, $avKww.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $735e68f953d26b55$var$useLayoutEffect = typeof window === "undefined" ? (0, $9nHZC.useEffect) : (0, $9nHZC.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $735e68f953d26b55$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $b4W0Q.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $735e68f953d26b55$var$getStrokeColor(appearance);
    var context = (0, $9nHZC.useContext)((0, $5fUc4.default));
    $735e68f953d26b55$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $avKww.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $735e68f953d26b55$var$wrapperStyles,
            $735e68f953d26b55$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $avKww.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $735e68f953d26b55$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none"
    }, (0, $avKww.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $735e68f953d26b55$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $735e68f953d26b55$export$2e2bcd8739ae039 = $735e68f953d26b55$var$Spinner;

});
parcelRegister("fv0Gh", function(module, exports) {

$parcel$export(module.exports, "N0", function () { return $b48a477ac021ebea$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $b48a477ac021ebea$export$c39c0fe0f26207ae; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $b48a477ac021ebea$export$4b84fd0e2c617bd = "#FFEBE6";
var $b48a477ac021ebea$export$b34b069eff244586 = "#FFBDAD";
var $b48a477ac021ebea$export$be802dd0d8b57f35 = "#FF8F73";
var $b48a477ac021ebea$export$60847d42f9da92a6 = "#FF7452";
var $b48a477ac021ebea$export$4a7404f376229999 = "#FF5630";
var $b48a477ac021ebea$export$2010d0fb4295b346 = "#DE350B";
var $b48a477ac021ebea$export$2837b5a1a71d5c02 = "#BF2600";
var $b48a477ac021ebea$export$8d9596b529bbb9cf = "#FFFAE6";
var $b48a477ac021ebea$export$41060a744ab0b7ae = "#FFF0B3";
var $b48a477ac021ebea$export$1cc05bbbf340e559 = "#FFE380";
var $b48a477ac021ebea$export$5aae31392d72caaa = "#FFC400";
var $b48a477ac021ebea$export$c6930421db9fa514 = "#FFAB00";
var $b48a477ac021ebea$export$59619663aa6500fb = "#FF991F";
var $b48a477ac021ebea$export$874739ea9e379ab6 = "#FF8B00";
var $b48a477ac021ebea$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $b48a477ac021ebea$export$69a3bf21b9686c2b = "#ABF5D1";
var $b48a477ac021ebea$export$afbce1382ec95f73 = "#79F2C0";
var $b48a477ac021ebea$export$747d86715d4175de = "#57D9A3";
var $b48a477ac021ebea$export$940e1f69e873f202 = "#36B37E";
var $b48a477ac021ebea$export$a49394138f7b8e85 = "#00875A";
var $b48a477ac021ebea$export$6fa04827ac68a4fb = "#006644";
var $b48a477ac021ebea$export$226de0355ed012f8 = "#DEEBFF";
var $b48a477ac021ebea$export$8c13c2ee36917869 = "#B3D4FF";
var $b48a477ac021ebea$export$ecfc1dff386a3e7a = "#4C9AFF";
var $b48a477ac021ebea$export$215b7063051591f1 = "#2684FF";
var $b48a477ac021ebea$export$e62e8919cca44969 = "#0065FF";
var $b48a477ac021ebea$export$b3de0ae08da2ce64 = "#0052CC";
var $b48a477ac021ebea$export$a6ee3d71bc067634 = "#0747A6";
var $b48a477ac021ebea$export$363e4475840015bb = "#EAE6FF";
var $b48a477ac021ebea$export$4b0a4417ed59760f = "#C0B6F2";
var $b48a477ac021ebea$export$6011520a64d9a187 = "#998DD9";
var $b48a477ac021ebea$export$a7175d4e9206bc80 = "#8777D9";
var $b48a477ac021ebea$export$b48405b95304b5a1 = "#6554C0";
var $b48a477ac021ebea$export$c71e4279dd54a18d = "#5243AA";
var $b48a477ac021ebea$export$147899de772240ec = "#403294";
var $b48a477ac021ebea$export$2cf711fe14c66f06 = "#E6FCFF";
var $b48a477ac021ebea$export$7a8f4d33f6f9772c = "#B3F5FF";
var $b48a477ac021ebea$export$776c9c497ef08533 = "#79E2F2";
var $b48a477ac021ebea$export$69cb3ca10c1e330e = "#00C7E6";
var $b48a477ac021ebea$export$9dc1ef0f3f48059b = "#00B8D9";
var $b48a477ac021ebea$export$7c835c78b6fcdef8 = "#00A3BF";
var $b48a477ac021ebea$export$6036577f95c3877e = "#008DA6";
var $b48a477ac021ebea$export$29a4f05edc054374 = "#FFFFFF";
var $b48a477ac021ebea$export$e655ef011c4aa1a2 = "#FAFBFC";
var $b48a477ac021ebea$export$9fdfb749e33cdf97 = "#F4F5F7";
var $b48a477ac021ebea$export$3e51e8f1440314ba = "#EBECF0";
var $b48a477ac021ebea$export$1ce2d1575d444ceb = "#DFE1E6";
var $b48a477ac021ebea$export$8754fc7e6d8b3000 = "#C1C7D0";
var $b48a477ac021ebea$export$c2e91cbeada39b8b = "#B3BAC5";
var $b48a477ac021ebea$export$5f71e19f3a7ad9de = "#A5ADBA";
var $b48a477ac021ebea$export$eaa8c8a70ac22806 = "#97A0AF";
var $b48a477ac021ebea$export$7c87d337fb91a97d = "#8993A4";
var $b48a477ac021ebea$export$d6447c357493214f = "#7A869A";
var $b48a477ac021ebea$export$f563ee71e9ee74cd = "#6B778C";
var $b48a477ac021ebea$export$e2ef2124cf4024b1 = "#5E6C84";
var $b48a477ac021ebea$export$eece5f492e429f08 = "#505F79";
var $b48a477ac021ebea$export$c39c0fe0f26207ae = "#42526E";
var $b48a477ac021ebea$export$7090862dc3038a9f = "#344563";
var $b48a477ac021ebea$export$ad0bacf983b7ddaa = "#253858";
var $b48a477ac021ebea$export$7d61b15e0da132af = "#172B4D";
var $b48a477ac021ebea$export$fbda843f0a27fe96 = "#091E42";
var $b48a477ac021ebea$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $b48a477ac021ebea$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $b48a477ac021ebea$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $b48a477ac021ebea$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $b48a477ac021ebea$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $b48a477ac021ebea$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $b48a477ac021ebea$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $b48a477ac021ebea$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $b48a477ac021ebea$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $b48a477ac021ebea$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $b48a477ac021ebea$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $b48a477ac021ebea$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $b48a477ac021ebea$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $b48a477ac021ebea$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $b48a477ac021ebea$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $b48a477ac021ebea$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $b48a477ac021ebea$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $b48a477ac021ebea$export$2f6319cf7d736c2a = "#E6EDFA";
var $b48a477ac021ebea$export$95126bc8884d6634 = "#DCE5F5";
var $b48a477ac021ebea$export$8338d8c35d44ff1 = "#CED9EB";
var $b48a477ac021ebea$export$5368d76ae4fbbda7 = "#B8C7E0";
var $b48a477ac021ebea$export$9f0a771d16ec8d36 = "#ABBBD6";
var $b48a477ac021ebea$export$abcf8c38338b4aa5 = "#9FB0CC";
var $b48a477ac021ebea$export$97e81faa16a182c7 = "#8C9CB8";
var $b48a477ac021ebea$export$bfe21c59123ecf33 = "#7988A3";
var $b48a477ac021ebea$export$ee82aa2ea6a1558 = "#67758F";
var $b48a477ac021ebea$export$682927c6ed76be02 = "#56637A";
var $b48a477ac021ebea$export$91fd9994c5be9757 = "#455166";
var $b48a477ac021ebea$export$d281fbfe3cff2df6 = "#3B475C";
var $b48a477ac021ebea$export$3902c91d8b98a753 = "#313D52";
var $b48a477ac021ebea$export$8e8133c1ba5845b5 = "#283447";
var $b48a477ac021ebea$export$33ff357f6620b39 = "#202B3D";
var $b48a477ac021ebea$export$633847cf062b69e0 = "#1B2638";
var $b48a477ac021ebea$export$9776a6e503bdbf76 = "#121A29";
var $b48a477ac021ebea$export$6c813d5160dff5db = "#0E1624";
var $b48a477ac021ebea$export$3d4f271a500072a = "#0D1424";
var $b48a477ac021ebea$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $b48a477ac021ebea$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $b48a477ac021ebea$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $b48a477ac021ebea$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $b48a477ac021ebea$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $b48a477ac021ebea$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $b48a477ac021ebea$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $b48a477ac021ebea$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $b48a477ac021ebea$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $b48a477ac021ebea$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $b48a477ac021ebea$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $b48a477ac021ebea$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $b48a477ac021ebea$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $b48a477ac021ebea$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $b48a477ac021ebea$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $b48a477ac021ebea$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $b48a477ac021ebea$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";

});

parcelRegister("b4W0Q", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $810d118960148dc9$export$4e9f1640bbe7a1a8; });
var $810d118960148dc9$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("A4azx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06c698e3363f751b$export$2e2bcd8739ae039; });
function $06c698e3363f751b$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute("role");
    return role === "checkbox" || role === "menuitemcheckbox";
}

});

parcelRegister("jvQ2Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e349490e6f54fa84$export$2e2bcd8739ae039; });
function $e349490e6f54fa84$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute("role");
    return role === "radio" || role === "menuitemradio";
}

});


parcelRegister("gW4l2", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", function () { return $c5456d9c9294ad66$export$756f795847463ebd; });
$parcel$export(module.exports, "default", function () { return $c5456d9c9294ad66$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $8p2GL = parcelRequire("8p2GL");
var $c5456d9c9294ad66$export$756f795847463ebd = /*#__PURE__*/ (0, $9nHZC.createContext)({
    setItemState: (0, $8p2GL.default),
    getItemState: function getItemState() {
        return undefined;
    },
    setGroupState: (0, $8p2GL.default),
    getGroupState: function getGroupState() {
        return {};
    }
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ var $c5456d9c9294ad66$var$SelectionStore = function SelectionStore(props) {
    var children = props.children;
    var store = (0, $9nHZC.useRef)({});
    var context = (0, $9nHZC.useMemo)(function() {
        return {
            setItemState: function setItemState(group, id, value) {
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: function getItemState(group, id) {
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: function setGroupState(group, value) {
                store.current[group] = value;
            },
            getGroupState: function getGroupState(group) {
                return store.current[group] || {};
            }
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($c5456d9c9294ad66$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $c5456d9c9294ad66$export$2e2bcd8739ae039 = $c5456d9c9294ad66$var$SelectionStore;

});

parcelRegister("bzYG3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86e207d6f6b43759$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $1Yet2 = parcelRequire("1Yet2");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $86e207d6f6b43759$var$useRegisterItemWithFocusManager() {
    var _useContext = (0, $9nHZC.useContext)((0, $1Yet2.FocusManagerContext)), registerRef = _useContext.registerRef;
    var itemRef = (0, $9nHZC.useRef)(null);
    (0, $9nHZC.useEffect)(function() {
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $86e207d6f6b43759$export$2e2bcd8739ae039 = $86e207d6f6b43759$var$useRegisterItemWithFocusManager;

});

parcelRegister("gRz1X", function(module, exports) {

$parcel$export(module.exports, "PREFIX", function () { return $c46cc4eaadc6eda6$export$8a682ae47622dbb9; });
$parcel$export(module.exports, "default", function () { return $c46cc4eaadc6eda6$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");
var $c46cc4eaadc6eda6$export$8a682ae47622dbb9 = "ds--dropdown--";
var $c46cc4eaadc6eda6$var$generateRandomString = function generateRandomString() {
    return(// Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    "".concat($c46cc4eaadc6eda6$export$8a682ae47622dbb9).concat(Math.random().toString(16).substr(2, 8)));
};
function $c46cc4eaadc6eda6$export$2e2bcd8739ae039() {
    var cachedId = (0, $9nHZC.useRef)($c46cc4eaadc6eda6$var$generateRandomString());
    return cachedId.current;
}

});


parcelRegister("8Aq6a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6405ee2905918b24$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $3aF04 = parcelRequire("3aF04");

var $5kzu2 = parcelRequire("5kzu2");

var $87ZI9 = parcelRequire("87ZI9");

var $fuPTF = parcelRequire("fuPTF");

var $bzYG3 = parcelRequire("bzYG3");
var $6405ee2905918b24$var$_excluded = [
    "children",
    "component",
    "description",
    "elemAfter",
    "elemBefore",
    "href",
    "isDisabled",
    "isSelected",
    "onClick",
    "rel",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "target",
    "testId"
];
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ var $6405ee2905918b24$var$DropdownMenuItem = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var children = _ref.children, component = _ref.component, description = _ref.description, elemAfter = _ref.elemAfter, elemBefore = _ref.elemBefore, href = _ref.href, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, rel = _ref.rel, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, target = _ref.target, testId = _ref.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $6405ee2905918b24$var$_excluded);
    var itemRef = (0, $bzYG3.default)();
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $87ZI9.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $3aF04.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        target: target,
        rel: rel
    }, rest), children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fuPTF.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $3aF04.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId
    }, rest), children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5kzu2.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $3aF04.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        target: target,
        rel: rel
    }, rest), children);
});
var $6405ee2905918b24$export$2e2bcd8739ae039 = $6405ee2905918b24$var$DropdownMenuItem;

});
parcelRegister("5kzu2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e1a5844daa320a9$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $1OnrY = parcelRequire("1OnrY");

var $8p2GL = parcelRequire("8p2GL");

var $dtSBD = parcelRequire("dtSBD");
var $3e1a5844daa320a9$var$_excluded = [
    "children",
    "cssFn",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className"
];
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $3e1a5844daa320a9$var$ButtonItem = /*#__PURE__*/ (0, $9nHZC.memo)(/*#__PURE__*/ (0, $9nHZC.forwardRef)(// Type needed on props to extract types with extract react types.
function(props, ref) {
    var children = props.children, _props$cssFn = props.cssFn, cssFn = _props$cssFn === void 0 ? (0, $8p2GL.default) : _props$cssFn, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, overrides = props.overrides, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(props, $3e1a5844daa320a9$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    if (!children) return null;
    (0, $1OnrY.propDeprecationWarning)("@atlaskit/menu", "cssFn", cssFn !== (0, $8p2GL.default), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $avKww.jsx)((0, $dtSBD.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        className: UNSAFE_className
    }, rest, {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return (0, $avKww.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: onClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }), children);
    });
}));
var $3e1a5844daa320a9$export$2e2bcd8739ae039 = $3e1a5844daa320a9$var$ButtonItem;

});
parcelRegister("dtSBD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d0857679a4b3c7f$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $1OnrY = parcelRequire("1OnrY");

var $dxhCu = parcelRequire("dxhCu");

var $ecaUQ = parcelRequire("ecaUQ");
var $iYVsw = parcelRequire("iYVsw");
var $emFMO = parcelRequire("emFMO");

var $lrA9r = parcelRequire("lrA9r");

var $32Kjv = parcelRequire("32Kjv");
var $9d0857679a4b3c7f$var$defaultRender = function defaultRender(Component, props) {
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, $avKww.jsx)(Component, props));
};
var $9d0857679a4b3c7f$var$beforeAfterElementStyles = (0, $avKww.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
});
var $9d0857679a4b3c7f$var$contentStyles = (0, $emFMO.xcss)({
    outline: "none",
    overflow: "hidden",
    textAlign: "left"
});
var $9d0857679a4b3c7f$var$truncateStyles = (0, $avKww.css)({
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $9d0857679a4b3c7f$var$titleStyles = (0, $avKww.css)({
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
});
var $9d0857679a4b3c7f$var$wordBreakStyles = (0, $avKww.css)({
    wordBreak: "break-word"
});
var $9d0857679a4b3c7f$var$descriptionStyles = (0, $avKww.css)({
    color: "var(--ds-text-subtlest, ".concat((0, $lrA9r.N200), ")"),
    font: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
});
var $9d0857679a4b3c7f$var$disabledDescriptionStyles = (0, $avKww.css)({
    color: "var(--ds-text-disabled, ".concat((0, $lrA9r.N200), ")")
});
var $9d0857679a4b3c7f$var$positionRelativeStyles = (0, $avKww.css)({
    position: "relative"
});
var $9d0857679a4b3c7f$var$primitiveStyles = (0, $avKww.css)({
    display: "flex",
    boxSizing: "border-box",
    width: "100%",
    minHeight: 40,
    margin: "var(--ds-space-0, 0px)",
    alignItems: "center",
    border: 0,
    outline: 0,
    textDecoration: "none",
    userSelect: "none",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&::-moz-focus-inner": {
        border: 0
    },
    "&:hover": {
        textDecoration: "none"
    }
});
var $9d0857679a4b3c7f$var$spacingMapStyles = {
    cozy: (0, $avKww.css)({
        // 8 * 2 (16) + icon (24) === 40
        paddingBlock: "var(--ds-space-100, 8px)",
        paddingInline: "var(--ds-space-200, 16px)"
    }),
    compact: (0, $avKww.css)({
        minHeight: 32,
        // 4 * 2 (8) + icon (24) === 32
        paddingBlock: "var(--ds-space-050, 4px)",
        paddingInline: "var(--ds-space-150, 12px)"
    })
};
var $9d0857679a4b3c7f$var$interactiveStyles = (0, $avKww.css)({
    cursor: "pointer"
});
var $9d0857679a4b3c7f$var$unselectedStyles = (0, $avKww.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    color: "currentColor",
    "&:visited": {
        color: "currentColor"
    },
    "&:hover": {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, ".concat((0, $lrA9r.N20), ")"),
        color: "currentColor"
    },
    "&:active": {
        backgroundColor: "var(--ds-background-neutral-subtle-pressed, ".concat((0, $lrA9r.N30), ")"),
        boxShadow: "none",
        color: "currentColor"
    }
});
var $9d0857679a4b3c7f$var$disabledStyles = (0, $avKww.css)({
    cursor: "not-allowed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&, :hover, :active": {
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        color: "var(--ds-text-disabled, ".concat((0, $lrA9r.N200), ")")
    }
});
var $9d0857679a4b3c7f$var$selectedBorderStyles = (0, $avKww.css)({
    "&::before": {
        width: 2,
        position: "absolute",
        background: "var(--ds-border-selected, transparent)",
        content: '""',
        insetBlockEnd: 0,
        insetBlockStart: 0,
        insetInlineStart: 0
    }
});
var $9d0857679a4b3c7f$var$selectedNotchStyles = (0, $avKww.css)({
    "&::before": {
        width: 4,
        position: "absolute",
        background: "var(--ds-border-selected, transparent)",
        borderRadius: "0 ".concat("var(--ds-border-radius, 4px)", " ", "var(--ds-border-radius, 4px)", " 0"),
        content: '""',
        insetBlockEnd: "var(--ds-space-150, 12px)",
        insetBlockStart: "var(--ds-space-150, 12px)",
        insetInlineStart: 0
    }
});
var $9d0857679a4b3c7f$var$selectedStyles = (0, $avKww.css)({
    backgroundColor: "var(--ds-background-selected, ".concat((0, $lrA9r.N20), ")"),
    // Fallback set as babel plugin inserts one otherwise
    color: "var(--ds-text-selected, currentColor)",
    "&:visited": {
        color: "var(--ds-text-selected, currentColor)"
    },
    "&:hover": {
        backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $lrA9r.N20), ")"),
        color: "var(--ds-text-selected, currentColor)"
    },
    "&:active": {
        backgroundColor: "var(--ds-background-selected-pressed, ".concat((0, $lrA9r.N30), ")"),
        color: "var(--ds-text-selected, currentColor)"
    }
});
var $9d0857679a4b3c7f$var$gapMap = {
    compact: "space.100",
    cozy: "space.150"
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $9d0857679a4b3c7f$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, overrides = _ref.overrides, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, testId = _ref.testId;
    (0, $1OnrY.propDeprecationWarning)("@atlaskit/menu", "overrides", overrides !== undefined, "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var spacing = (0, $9nHZC.useContext)((0, $32Kjv.SpacingContext));
    var selectionStyle = (0, $9nHZC.useContext)((0, $32Kjv.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    var renderTitle = overrides && overrides.Title && overrides.Title.render || $9d0857679a4b3c7f$var$defaultRender;
    var UNSAFE_className = UNSAFE_externalClassName;
    return (0, $avKww.jsx)((0, $avKww.ClassNames), null, function(_ref2) {
        var cn = _ref2.css, cx = _ref2.cx;
        return (0, $avKww.jsx)((0, $dxhCu.default), {
            isInset: true
        }, children({
            className: cx([
                cn([
                    $9d0857679a4b3c7f$var$positionRelativeStyles,
                    $9d0857679a4b3c7f$var$primitiveStyles,
                    $9d0857679a4b3c7f$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $9d0857679a4b3c7f$var$unselectedStyles,
                    !isDisabled && isSelected && [
                        $9d0857679a4b3c7f$var$selectedStyles,
                        [
                            selectionStyle === "border" && $9d0857679a4b3c7f$var$selectedBorderStyles,
                            selectionStyle === "notch" && $9d0857679a4b3c7f$var$selectedNotchStyles
                        ]
                    ],
                    isDisabled ? $9d0857679a4b3c7f$var$disabledStyles : $9d0857679a4b3c7f$var$interactiveStyles
                ]),
                UNSAFE_className
            ]),
            children: (0, $avKww.jsx)((0, $ecaUQ.default), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $9d0857679a4b3c7f$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && (0, $avKww.jsx)("span", {
                "data-item-elem-before": true,
                css: $9d0857679a4b3c7f$var$beforeAfterElementStyles,
                "data-testid": testId && "".concat(testId, "--icon-before")
            }, iconBefore), title && (0, $avKww.jsx)((0, $iYVsw.default), {
                alignBlock: "center",
                grow: "fill",
                xcss: $9d0857679a4b3c7f$var$contentStyles
            }, renderTitle("span", {
                children: title,
                className: cn($9d0857679a4b3c7f$var$titleStyles, shouldTitleWrap ? $9d0857679a4b3c7f$var$wordBreakStyles : $9d0857679a4b3c7f$var$truncateStyles),
                "data-item-title": true
            }), description && (0, $avKww.jsx)("span", {
                "data-item-description": true,
                css: [
                    $9d0857679a4b3c7f$var$descriptionStyles,
                    isDisabled && $9d0857679a4b3c7f$var$disabledDescriptionStyles,
                    shouldDescriptionWrap ? $9d0857679a4b3c7f$var$wordBreakStyles : $9d0857679a4b3c7f$var$truncateStyles
                ]
            }, description)), iconAfter && (0, $avKww.jsx)("span", {
                "data-item-elem-after": true,
                css: $9d0857679a4b3c7f$var$beforeAfterElementStyles,
                "data-testid": testId && "".concat(testId, "--icon-after")
            }, iconAfter))
        }));
    });
};
var $9d0857679a4b3c7f$export$2e2bcd8739ae039 = $9d0857679a4b3c7f$var$MenuItemPrimitive;

});
parcelRegister("ecaUQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a55aa756d54898aa$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $emFMO = parcelRequire("emFMO");

var $jU4yN = parcelRequire("jU4yN");
var $a55aa756d54898aa$var$flexGrowMap = {
    hug: (0, $emFMO.xcss)({
        flexGrow: 0
    }),
    fill: (0, $emFMO.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
var $a55aa756d54898aa$var$separatorStyles = (0, $avKww.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $a55aa756d54898aa$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $avKww.jsx)("span", {
        css: $a55aa756d54898aa$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $a55aa756d54898aa$var$Inline = /*#__PURE__*/ (0, $9nHZC.memo)(/*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $avKww.jsx)($a55aa756d54898aa$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $9nHZC.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $avKww.jsx)((0, $9nHZC.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $a55aa756d54898aa$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $avKww.jsx)((0, $jU4yN.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$a55aa756d54898aa$var$Inline.displayName = "Inline";
var $a55aa756d54898aa$export$2e2bcd8739ae039 = $a55aa756d54898aa$var$Inline;

});
parcelRegister("emFMO", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $a75388a6c51a9e81$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $a75388a6c51a9e81$export$f6c783d06584602c; });

var $b4Ivn = parcelRequire("b4Ivn");

var $kFnE9 = parcelRequire("kFnE9");

var $9q1kH = parcelRequire("9q1kH");

var $340K4 = parcelRequire("340K4");

var $avKww = parcelRequire("avKww");

var $jyKZu = parcelRequire("jyKZu");

var $8ovux = parcelRequire("8ovux");
function $a75388a6c51a9e81$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $a75388a6c51a9e81$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $a75388a6c51a9e81$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a75388a6c51a9e81$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a75388a6c51a9e81$var$_arrayLikeToArray(o, minLen);
}
function $a75388a6c51a9e81$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $a75388a6c51a9e81$export$9a199fbafee0014e = {
    backgroundColor: (0, $jyKZu.backgroundColorMap),
    blockSize: (0, $jyKZu.dimensionMap),
    borderBlockColor: (0, $jyKZu.borderColorMap),
    borderBlockEndColor: (0, $jyKZu.borderColorMap),
    borderBlockEndWidth: (0, $jyKZu.borderWidthMap),
    borderBlockStartColor: (0, $jyKZu.borderColorMap),
    borderBlockStartWidth: (0, $jyKZu.borderWidthMap),
    borderBlockWidth: (0, $jyKZu.borderWidthMap),
    borderBottomColor: (0, $jyKZu.borderColorMap),
    borderBottomLeftRadius: (0, $jyKZu.borderRadiusMap),
    borderBottomRightRadius: (0, $jyKZu.borderRadiusMap),
    borderBottomWidth: (0, $jyKZu.borderWidthMap),
    borderColor: (0, $jyKZu.borderColorMap),
    borderEndEndRadius: (0, $jyKZu.borderRadiusMap),
    borderEndStartRadius: (0, $jyKZu.borderRadiusMap),
    borderInlineColor: (0, $jyKZu.borderColorMap),
    borderInlineEndColor: (0, $jyKZu.borderColorMap),
    borderInlineEndWidth: (0, $jyKZu.borderWidthMap),
    borderInlineStartColor: (0, $jyKZu.borderColorMap),
    borderInlineStartWidth: (0, $jyKZu.borderWidthMap),
    borderInlineWidth: (0, $jyKZu.borderWidthMap),
    borderLeftColor: (0, $jyKZu.borderColorMap),
    borderLeftWidth: (0, $jyKZu.borderWidthMap),
    borderRadius: (0, $jyKZu.borderRadiusMap),
    borderRightColor: (0, $jyKZu.borderColorMap),
    borderRightWidth: (0, $jyKZu.borderWidthMap),
    borderStartEndRadius: (0, $jyKZu.borderRadiusMap),
    borderStartStartRadius: (0, $jyKZu.borderRadiusMap),
    borderTopColor: (0, $jyKZu.borderColorMap),
    borderTopLeftRadius: (0, $jyKZu.borderRadiusMap),
    borderTopRightRadius: (0, $jyKZu.borderRadiusMap),
    borderTopWidth: (0, $jyKZu.borderWidthMap),
    borderWidth: (0, $jyKZu.borderWidthMap),
    bottom: (0, $jyKZu.allSpaceMap),
    boxShadow: (0, $jyKZu.shadowMap),
    color: (0, $jyKZu.textColorMap),
    columnGap: (0, $jyKZu.positiveSpaceMap),
    gap: (0, $jyKZu.positiveSpaceMap),
    height: (0, $jyKZu.dimensionMap),
    inlineSize: (0, $jyKZu.dimensionMap),
    inset: (0, $jyKZu.allSpaceMap),
    insetBlock: (0, $jyKZu.allSpaceMap),
    insetBlockEnd: (0, $jyKZu.allSpaceMap),
    insetBlockStart: (0, $jyKZu.allSpaceMap),
    insetInline: (0, $jyKZu.allSpaceMap),
    insetInlineEnd: (0, $jyKZu.allSpaceMap),
    insetInlineStart: (0, $jyKZu.allSpaceMap),
    left: (0, $jyKZu.allSpaceMap),
    margin: (0, $jyKZu.allSpaceMap),
    marginBlock: (0, $jyKZu.allSpaceMap),
    marginBlockEnd: (0, $jyKZu.allSpaceMap),
    marginBlockStart: (0, $jyKZu.allSpaceMap),
    marginBottom: (0, $jyKZu.allSpaceMap),
    marginInline: (0, $jyKZu.allSpaceMap),
    marginInlineEnd: (0, $jyKZu.allSpaceMap),
    marginInlineStart: (0, $jyKZu.allSpaceMap),
    marginLeft: (0, $jyKZu.allSpaceMap),
    marginRight: (0, $jyKZu.allSpaceMap),
    marginTop: (0, $jyKZu.allSpaceMap),
    maxBlockSize: (0, $jyKZu.dimensionMap),
    maxHeight: (0, $jyKZu.dimensionMap),
    maxInlineSize: (0, $jyKZu.dimensionMap),
    maxWidth: (0, $jyKZu.dimensionMap),
    minBlockSize: (0, $jyKZu.dimensionMap),
    minHeight: (0, $jyKZu.dimensionMap),
    minInlineSize: (0, $jyKZu.dimensionMap),
    minWidth: (0, $jyKZu.dimensionMap),
    opacity: (0, $jyKZu.opacityMap),
    outlineColor: (0, $jyKZu.borderColorMap),
    outlineOffset: (0, $jyKZu.positiveSpaceMap),
    outlineWidth: (0, $jyKZu.borderWidthMap),
    padding: (0, $jyKZu.positiveSpaceMap),
    paddingBlock: (0, $jyKZu.positiveSpaceMap),
    paddingBlockEnd: (0, $jyKZu.positiveSpaceMap),
    paddingBlockStart: (0, $jyKZu.positiveSpaceMap),
    paddingBottom: (0, $jyKZu.positiveSpaceMap),
    paddingInline: (0, $jyKZu.positiveSpaceMap),
    paddingInlineEnd: (0, $jyKZu.positiveSpaceMap),
    paddingInlineStart: (0, $jyKZu.positiveSpaceMap),
    paddingLeft: (0, $jyKZu.positiveSpaceMap),
    paddingRight: (0, $jyKZu.positiveSpaceMap),
    paddingTop: (0, $jyKZu.positiveSpaceMap),
    right: (0, $jyKZu.allSpaceMap),
    rowGap: (0, $jyKZu.positiveSpaceMap),
    top: (0, $jyKZu.allSpaceMap),
    width: (0, $jyKZu.dimensionMap),
    zIndex: (0, $jyKZu.layerMap)
};
var $a75388a6c51a9e81$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $a75388a6c51a9e81$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $8ovux === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux.env) === "object" && false;
};
var $a75388a6c51a9e81$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $a75388a6c51a9e81$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $a75388a6c51a9e81$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(value) === "object" && $a75388a6c51a9e81$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($a75388a6c51a9e81$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($a75388a6c51a9e81$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $a75388a6c51a9e81$export$9a199fbafee0014e)) return;
        var tokenValue = $a75388a6c51a9e81$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $a75388a6c51a9e81$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $a75388a6c51a9e81$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, $a75388a6c51a9e81$var$uniqueSymbol, (0, $avKww.css)(transformedStyles));
};
var $a75388a6c51a9e81$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $a75388a6c51a9e81$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$a75388a6c51a9e81$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $a75388a6c51a9e81$export$f6c783d06584602c(style) {
    return $a75388a6c51a9e81$var$baseXcss(style);
}

});
parcelRegister("jyKZu", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $e3d5a4ab31730fb6$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $e3d5a4ab31730fb6$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $e3d5a4ab31730fb6$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $e3d5a4ab31730fb6$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $e3d5a4ab31730fb6$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $e3d5a4ab31730fb6$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $e3d5a4ab31730fb6$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $e3d5a4ab31730fb6$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $e3d5a4ab31730fb6$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $e3d5a4ab31730fb6$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $e3d5a4ab31730fb6$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $e3d5a4ab31730fb6$export$bf46c3f9eeafc71f; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $xbX1J = parcelRequire("xbX1J");
function $e3d5a4ab31730fb6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e3d5a4ab31730fb6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e3d5a4ab31730fb6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e3d5a4ab31730fb6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e3d5a4ab31730fb6$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $e3d5a4ab31730fb6$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $e3d5a4ab31730fb6$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $e3d5a4ab31730fb6$export$632685d741f3dbbf = $e3d5a4ab31730fb6$var$_objectSpread($e3d5a4ab31730fb6$var$_objectSpread({}, $e3d5a4ab31730fb6$export$958d0ae7f2977ae4), $e3d5a4ab31730fb6$export$d2dc61f58390201c);
var $e3d5a4ab31730fb6$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $e3d5a4ab31730fb6$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $e3d5a4ab31730fb6$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $e3d5a4ab31730fb6$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $e3d5a4ab31730fb6$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $e3d5a4ab31730fb6$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $e3d5a4ab31730fb6$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $e3d5a4ab31730fb6$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $e3d5a4ab31730fb6$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $e3d5a4ab31730fb6$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $e3d5a4ab31730fb6$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $e3d5a4ab31730fb6$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $e3d5a4ab31730fb6$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $e3d5a4ab31730fb6$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $e3d5a4ab31730fb6$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $e3d5a4ab31730fb6$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $avKww.css)((0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $e3d5a4ab31730fb6$export$e615f061ca585a6c = $e3d5a4ab31730fb6$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $e3d5a4ab31730fb6$var$getSerializedStylesMap(spacingProperty, $e3d5a4ab31730fb6$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $e3d5a4ab31730fb6$export$bf46c3f9eeafc71f = $e3d5a4ab31730fb6$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $e3d5a4ab31730fb6$var$getSerializedStylesMap(spacingProperty, $e3d5a4ab31730fb6$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $e3d5a4ab31730fb6$export$e7af83bafe7f9e63 = $e3d5a4ab31730fb6$var$getSerializedStylesMap("backgroundColor", $e3d5a4ab31730fb6$export$d1d79bf68ac056bd);
var $e3d5a4ab31730fb6$export$3a1bcba60b23d7f0 = $e3d5a4ab31730fb6$var$getSerializedStylesMap("color", $e3d5a4ab31730fb6$export$8473307aa00d6ea1);
var $e3d5a4ab31730fb6$export$45f3f4fe16f9f7d5 = $e3d5a4ab31730fb6$var$getSerializedStylesMap("fontWeight", $e3d5a4ab31730fb6$export$303e322c6b1ed114);
var $e3d5a4ab31730fb6$export$68cc305da27dbaa4 = $e3d5a4ab31730fb6$var$getSerializedStylesMap("fontFamily", $e3d5a4ab31730fb6$export$3c7e9587132614b4);
var $e3d5a4ab31730fb6$export$128f10c238242f83 = $e3d5a4ab31730fb6$var$getSerializedStylesMap("font", $e3d5a4ab31730fb6$export$6cc560b4dedf3816);
var $e3d5a4ab31730fb6$export$ff257d957d48c421 = $e3d5a4ab31730fb6$var$getSerializedStylesMap((0, $xbX1J.CURRENT_SURFACE_CSS_VAR), $e3d5a4ab31730fb6$export$41a358c9c2356760);
var $e3d5a4ab31730fb6$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $e3d5a4ab31730fb6$export$41a358c9c2356760[color] !== undefined;
};

});


parcelRegister("jU4yN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7d6c8dcffe87b3c$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $jyKZu = parcelRequire("jyKZu");

var $emFMO = parcelRequire("emFMO");
var $e7d6c8dcffe87b3c$var$justifyContentMap = {
    start: (0, $avKww.css)({
        justifyContent: "start"
    }),
    center: (0, $avKww.css)({
        justifyContent: "center"
    }),
    end: (0, $avKww.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $avKww.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $avKww.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $avKww.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $avKww.css)({
        justifyContent: "stretch"
    })
};
var $e7d6c8dcffe87b3c$var$flexDirectionMap = {
    column: (0, $avKww.css)({
        flexDirection: "column"
    }),
    row: (0, $avKww.css)({
        flexDirection: "row"
    })
};
var $e7d6c8dcffe87b3c$var$flexWrapMap = {
    wrap: (0, $avKww.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $avKww.css)({
        flexWrap: "nowrap"
    })
};
var $e7d6c8dcffe87b3c$var$alignItemsMap = {
    start: (0, $avKww.css)({
        alignItems: "start"
    }),
    center: (0, $avKww.css)({
        alignItems: "center"
    }),
    baseline: (0, $avKww.css)({
        alignItems: "baseline"
    }),
    end: (0, $avKww.css)({
        alignItems: "end"
    }),
    stretch: (0, $avKww.css)({
        alignItems: "stretch"
    })
};
var $e7d6c8dcffe87b3c$var$baseStyles = (0, $avKww.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $e7d6c8dcffe87b3c$var$Flex = /*#__PURE__*/ (0, $9nHZC.memo)(/*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $emFMO.parseXcss)(xcss);
    return (0, $avKww.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $e7d6c8dcffe87b3c$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $jyKZu.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $jyKZu.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $jyKZu.spaceStylesMap).rowGap[rowGap],
            alignItems && $e7d6c8dcffe87b3c$var$alignItemsMap[alignItems],
            direction && $e7d6c8dcffe87b3c$var$flexDirectionMap[direction],
            justifyContent && $e7d6c8dcffe87b3c$var$justifyContentMap[justifyContent],
            wrap && $e7d6c8dcffe87b3c$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$e7d6c8dcffe87b3c$var$Flex.displayName = "Flex";
var $e7d6c8dcffe87b3c$export$2e2bcd8739ae039 = $e7d6c8dcffe87b3c$var$Flex;

});


parcelRegister("iYVsw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd1a66c0eec8b606$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $emFMO = parcelRequire("emFMO");

var $jU4yN = parcelRequire("jU4yN");
var $dd1a66c0eec8b606$var$flexGrowMap = {
    hug: (0, $emFMO.xcss)({
        flexGrow: 0
    }),
    fill: (0, $emFMO.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $dd1a66c0eec8b606$var$Stack = /*#__PURE__*/ (0, $9nHZC.memo)(/*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $dd1a66c0eec8b606$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $avKww.jsx)((0, $jU4yN.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$dd1a66c0eec8b606$var$Stack.displayName = "Stack";
var $dd1a66c0eec8b606$export$2e2bcd8739ae039 = $dd1a66c0eec8b606$var$Stack;

});

parcelRegister("lrA9r", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $f9c8297f7aa79b64$export$215b7063051591f1; });
$parcel$export(module.exports, "N20", function () { return $f9c8297f7aa79b64$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $f9c8297f7aa79b64$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N200", function () { return $f9c8297f7aa79b64$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N300", function () { return $f9c8297f7aa79b64$export$e2ef2124cf4024b1; });
$parcel$export(module.exports, "N800", function () { return $f9c8297f7aa79b64$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $f9c8297f7aa79b64$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $f9c8297f7aa79b64$export$920c0d5c49070351; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $f9c8297f7aa79b64$export$4b84fd0e2c617bd = "#FFEBE6";
var $f9c8297f7aa79b64$export$b34b069eff244586 = "#FFBDAD";
var $f9c8297f7aa79b64$export$be802dd0d8b57f35 = "#FF8F73";
var $f9c8297f7aa79b64$export$60847d42f9da92a6 = "#FF7452";
var $f9c8297f7aa79b64$export$4a7404f376229999 = "#FF5630";
var $f9c8297f7aa79b64$export$2010d0fb4295b346 = "#DE350B";
var $f9c8297f7aa79b64$export$2837b5a1a71d5c02 = "#BF2600";
var $f9c8297f7aa79b64$export$8d9596b529bbb9cf = "#FFFAE6";
var $f9c8297f7aa79b64$export$41060a744ab0b7ae = "#FFF0B3";
var $f9c8297f7aa79b64$export$1cc05bbbf340e559 = "#FFE380";
var $f9c8297f7aa79b64$export$5aae31392d72caaa = "#FFC400";
var $f9c8297f7aa79b64$export$c6930421db9fa514 = "#FFAB00";
var $f9c8297f7aa79b64$export$59619663aa6500fb = "#FF991F";
var $f9c8297f7aa79b64$export$874739ea9e379ab6 = "#FF8B00";
var $f9c8297f7aa79b64$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $f9c8297f7aa79b64$export$69a3bf21b9686c2b = "#ABF5D1";
var $f9c8297f7aa79b64$export$afbce1382ec95f73 = "#79F2C0";
var $f9c8297f7aa79b64$export$747d86715d4175de = "#57D9A3";
var $f9c8297f7aa79b64$export$940e1f69e873f202 = "#36B37E";
var $f9c8297f7aa79b64$export$a49394138f7b8e85 = "#00875A";
var $f9c8297f7aa79b64$export$6fa04827ac68a4fb = "#006644";
var $f9c8297f7aa79b64$export$226de0355ed012f8 = "#DEEBFF";
var $f9c8297f7aa79b64$export$8c13c2ee36917869 = "#B3D4FF";
var $f9c8297f7aa79b64$export$ecfc1dff386a3e7a = "#4C9AFF";
var $f9c8297f7aa79b64$export$215b7063051591f1 = "#2684FF";
var $f9c8297f7aa79b64$export$e62e8919cca44969 = "#0065FF";
var $f9c8297f7aa79b64$export$b3de0ae08da2ce64 = "#0052CC";
var $f9c8297f7aa79b64$export$a6ee3d71bc067634 = "#0747A6";
var $f9c8297f7aa79b64$export$363e4475840015bb = "#EAE6FF";
var $f9c8297f7aa79b64$export$4b0a4417ed59760f = "#C0B6F2";
var $f9c8297f7aa79b64$export$6011520a64d9a187 = "#998DD9";
var $f9c8297f7aa79b64$export$a7175d4e9206bc80 = "#8777D9";
var $f9c8297f7aa79b64$export$b48405b95304b5a1 = "#6554C0";
var $f9c8297f7aa79b64$export$c71e4279dd54a18d = "#5243AA";
var $f9c8297f7aa79b64$export$147899de772240ec = "#403294";
var $f9c8297f7aa79b64$export$2cf711fe14c66f06 = "#E6FCFF";
var $f9c8297f7aa79b64$export$7a8f4d33f6f9772c = "#B3F5FF";
var $f9c8297f7aa79b64$export$776c9c497ef08533 = "#79E2F2";
var $f9c8297f7aa79b64$export$69cb3ca10c1e330e = "#00C7E6";
var $f9c8297f7aa79b64$export$9dc1ef0f3f48059b = "#00B8D9";
var $f9c8297f7aa79b64$export$7c835c78b6fcdef8 = "#00A3BF";
var $f9c8297f7aa79b64$export$6036577f95c3877e = "#008DA6";
var $f9c8297f7aa79b64$export$29a4f05edc054374 = "#FFFFFF";
var $f9c8297f7aa79b64$export$e655ef011c4aa1a2 = "#FAFBFC";
var $f9c8297f7aa79b64$export$9fdfb749e33cdf97 = "#F4F5F7";
var $f9c8297f7aa79b64$export$3e51e8f1440314ba = "#EBECF0";
var $f9c8297f7aa79b64$export$1ce2d1575d444ceb = "#DFE1E6";
var $f9c8297f7aa79b64$export$8754fc7e6d8b3000 = "#C1C7D0";
var $f9c8297f7aa79b64$export$c2e91cbeada39b8b = "#B3BAC5";
var $f9c8297f7aa79b64$export$5f71e19f3a7ad9de = "#A5ADBA";
var $f9c8297f7aa79b64$export$eaa8c8a70ac22806 = "#97A0AF";
var $f9c8297f7aa79b64$export$7c87d337fb91a97d = "#8993A4";
var $f9c8297f7aa79b64$export$d6447c357493214f = "#7A869A";
var $f9c8297f7aa79b64$export$f563ee71e9ee74cd = "#6B778C";
var $f9c8297f7aa79b64$export$e2ef2124cf4024b1 = "#5E6C84";
var $f9c8297f7aa79b64$export$eece5f492e429f08 = "#505F79";
var $f9c8297f7aa79b64$export$c39c0fe0f26207ae = "#42526E";
var $f9c8297f7aa79b64$export$7090862dc3038a9f = "#344563";
var $f9c8297f7aa79b64$export$ad0bacf983b7ddaa = "#253858";
var $f9c8297f7aa79b64$export$7d61b15e0da132af = "#172B4D";
var $f9c8297f7aa79b64$export$fbda843f0a27fe96 = "#091E42";
var $f9c8297f7aa79b64$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $f9c8297f7aa79b64$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $f9c8297f7aa79b64$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $f9c8297f7aa79b64$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $f9c8297f7aa79b64$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $f9c8297f7aa79b64$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $f9c8297f7aa79b64$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $f9c8297f7aa79b64$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $f9c8297f7aa79b64$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $f9c8297f7aa79b64$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $f9c8297f7aa79b64$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $f9c8297f7aa79b64$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $f9c8297f7aa79b64$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $f9c8297f7aa79b64$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $f9c8297f7aa79b64$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $f9c8297f7aa79b64$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $f9c8297f7aa79b64$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $f9c8297f7aa79b64$export$2f6319cf7d736c2a = "#E6EDFA";
var $f9c8297f7aa79b64$export$95126bc8884d6634 = "#DCE5F5";
var $f9c8297f7aa79b64$export$8338d8c35d44ff1 = "#CED9EB";
var $f9c8297f7aa79b64$export$5368d76ae4fbbda7 = "#B8C7E0";
var $f9c8297f7aa79b64$export$9f0a771d16ec8d36 = "#ABBBD6";
var $f9c8297f7aa79b64$export$abcf8c38338b4aa5 = "#9FB0CC";
var $f9c8297f7aa79b64$export$97e81faa16a182c7 = "#8C9CB8";
var $f9c8297f7aa79b64$export$bfe21c59123ecf33 = "#7988A3";
var $f9c8297f7aa79b64$export$ee82aa2ea6a1558 = "#67758F";
var $f9c8297f7aa79b64$export$682927c6ed76be02 = "#56637A";
var $f9c8297f7aa79b64$export$91fd9994c5be9757 = "#455166";
var $f9c8297f7aa79b64$export$d281fbfe3cff2df6 = "#3B475C";
var $f9c8297f7aa79b64$export$3902c91d8b98a753 = "#313D52";
var $f9c8297f7aa79b64$export$8e8133c1ba5845b5 = "#283447";
var $f9c8297f7aa79b64$export$33ff357f6620b39 = "#202B3D";
var $f9c8297f7aa79b64$export$633847cf062b69e0 = "#1B2638";
var $f9c8297f7aa79b64$export$9776a6e503bdbf76 = "#121A29";
var $f9c8297f7aa79b64$export$6c813d5160dff5db = "#0E1624";
var $f9c8297f7aa79b64$export$3d4f271a500072a = "#0D1424";
var $f9c8297f7aa79b64$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $f9c8297f7aa79b64$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $f9c8297f7aa79b64$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $f9c8297f7aa79b64$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $f9c8297f7aa79b64$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $f9c8297f7aa79b64$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $f9c8297f7aa79b64$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $f9c8297f7aa79b64$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $f9c8297f7aa79b64$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $f9c8297f7aa79b64$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $f9c8297f7aa79b64$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $f9c8297f7aa79b64$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $f9c8297f7aa79b64$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $f9c8297f7aa79b64$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $f9c8297f7aa79b64$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $f9c8297f7aa79b64$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $f9c8297f7aa79b64$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";

});



parcelRegister("87ZI9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5eaed8b3d36a901e$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $1OnrY = parcelRequire("1OnrY");

var $8p2GL = parcelRequire("8p2GL");

var $dtSBD = parcelRequire("dtSBD");
var $5eaed8b3d36a901e$var$_excluded = [
    "component",
    "cssFn",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_isDraggable"
];
var $5eaed8b3d36a901e$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
// Dirty hack to get generics working with forward ref [1/2]
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $5eaed8b3d36a901e$var$CustomItem = /*#__PURE__*/ (0, $9nHZC.memo)(/*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var Component = _ref.component, _ref$cssFn = _ref.cssFn, cssFn = _ref$cssFn === void 0 ? (0, $8p2GL.default) : _ref$cssFn, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, onClick = _ref.onClick, testId = _ref.testId, children = _ref.children, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, overrides = _ref.overrides, onMouseDown = _ref.onMouseDown, shouldTitleWrap = _ref.shouldTitleWrap, shouldDescriptionWrap = _ref.shouldDescriptionWrap, UNSAFE_className = _ref.className, UNSAFE_isDraggable = _ref.UNSAFE_isDraggable, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $5eaed8b3d36a901e$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    if (!Component) return null;
    (0, $1OnrY.propDeprecationWarning)("@atlaskit/menu", "cssFn", cssFn !== (0, $8p2GL.default), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $avKww.jsx)((0, $dtSBD.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        className: UNSAFE_className
    }, rest, {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: (0, $avKww.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cssFn({
            isDisabled: isDisabled,
            isSelected: isSelected
        })),
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref2) {
        var children = _ref2.children, className = _ref2.className;
        return (0, $avKww.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $5eaed8b3d36a901e$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $5eaed8b3d36a901e$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $5eaed8b3d36a901e$var$preventEvent : onClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled
        }), children);
    });
}));
var $5eaed8b3d36a901e$export$2e2bcd8739ae039 = $5eaed8b3d36a901e$var$CustomItem;

});

parcelRegister("fuPTF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b481e9f97926686d$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $hhpiG = parcelRequire("hhpiG");

var $1OnrY = parcelRequire("1OnrY");

var $8p2GL = parcelRequire("8p2GL");

var $iCV0h = parcelRequire("iCV0h");

var $dtSBD = parcelRequire("dtSBD");
var $b481e9f97926686d$var$_excluded = [
    "children",
    "href",
    "cssFn",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_shouldDisableRouterLink",
    "UNSAFE_isDraggable"
];
var $b481e9f97926686d$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $b481e9f97926686d$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
var $b481e9f97926686d$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $b481e9f97926686d$var$LinkItem = /*#__PURE__*/ (0, $9nHZC.memo)(/*#__PURE__*/ (0, $9nHZC.forwardRef)(// Type needed on props to extract types with extract react types.
function(props, ref) {
    var children = props.children, href = props.href, _props$cssFn = props.cssFn, cssFn = _props$cssFn === void 0 ? (0, $8p2GL.default) : _props$cssFn, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, overrides = props.overrides, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, UNSAFE_shouldDisableRouterLink = props.UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable = props.UNSAFE_isDraggable, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(props, $b481e9f97926686d$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var RouterLink = (0, $hhpiG.default)();
    if (!children) return null;
    var isExternal = typeof href === "string" && $b481e9f97926686d$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === "string" && $b481e9f97926686d$var$IS_NON_HTTP_BASED.test(href);
    var isEmptyHref = href == null || href === "";
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ var isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    var Component = isRouterLink && (0, $iCV0h.fg)("platform.wanjel.use-router-links-for-the-linkitem-component") ? RouterLink : "a";
    (0, $1OnrY.propDeprecationWarning)("@atlaskit/menu", "cssFn", cssFn !== (0, $8p2GL.default), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $avKww.jsx)((0, $dtSBD.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        title: children,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return (0, $avKww.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? "true" : "false" : undefined,
            "data-vc": "link-item"
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            href: isDisabled ? undefined : href
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $b481e9f97926686d$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $b481e9f97926686d$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $b481e9f97926686d$var$preventEvent : onClick,
            "aria-current": isSelected ? "page" : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }), children);
    });
}));
var $b481e9f97926686d$export$2e2bcd8739ae039 = $b481e9f97926686d$var$LinkItem;

});
parcelRegister("hhpiG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c947a64fd7c8a173$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $9dEVg = parcelRequire("9dEVg");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $c947a64fd7c8a173$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $9nHZC.useContext)((0, $9dEVg.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
};
var $c947a64fd7c8a173$export$2e2bcd8739ae039 = $c947a64fd7c8a173$var$useRouterLink;

});
parcelRegister("9dEVg", function(module, exports) {

$parcel$export(module.exports, "RouterLinkProviderContext", function () { return $6b651253bd76d8a0$export$2931e0ee690eee88; });

var $9nHZC = parcelRequire("9nHZC");
var $6b651253bd76d8a0$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $9nHZC.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $6b651253bd76d8a0$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($6b651253bd76d8a0$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $6b651253bd76d8a0$export$2e2bcd8739ae039 = $6b651253bd76d8a0$var$RouterLinkProvider;

});


parcelRegister("iCV0h", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $d8f7fe53b4f99062$export$b40ec24ac8275656; });

var $4tKEb = parcelRequire("4tKEb");
function $d8f7fe53b4f99062$export$ba05d765b8392e5e(flagResolver) {
    (0, $4tKEb.setBooleanResolver)(flagResolver);
}
function $d8f7fe53b4f99062$export$470e5c2be1411c89(name) {
    return (0, $4tKEb.resolveBooleanFlag)(name);
}
function $d8f7fe53b4f99062$export$b40ec24ac8275656(name) {
    return (0, $4tKEb.resolveBooleanFlag)(name);
}

});
parcelRegister("4tKEb", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $342e0e03af2fd793$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $342e0e03af2fd793$export$6333b6aff9fc6275; });

var $kR8YT = parcelRequire("kR8YT");

var $8ovux = parcelRequire("8ovux");
var $342e0e03af2fd793$var$pkgName = "@atlaskit/platform-feature-flags";
var $342e0e03af2fd793$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $342e0e03af2fd793$var$hasProcessEnv = typeof $8ovux !== "undefined" && typeof $8ovux.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $342e0e03af2fd793$var$ENV_ENABLE_PLATFORM_FF = $342e0e03af2fd793$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $342e0e03af2fd793$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $342e0e03af2fd793$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $342e0e03af2fd793$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $342e0e03af2fd793$var$ENV_ENABLE_PLATFORM_FF || $342e0e03af2fd793$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $342e0e03af2fd793$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $342e0e03af2fd793$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$342e0e03af2fd793$var$globalVar[$342e0e03af2fd793$export$7e41b1b2bdee3f98] = $342e0e03af2fd793$var$globalVar[$342e0e03af2fd793$export$7e41b1b2bdee3f98] || $342e0e03af2fd793$var$DEFAULT_PFF_GLOBAL;
function $342e0e03af2fd793$export$f2b591175b3e424c(resolver) {
    $342e0e03af2fd793$var$globalVar[$342e0e03af2fd793$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $342e0e03af2fd793$export$6333b6aff9fc6275(flagKey) {
    if ($342e0e03af2fd793$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $kR8YT.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $342e0e03af2fd793$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $342e0e03af2fd793$var$globalVar[$342e0e03af2fd793$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("kR8YT", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $f2efb9544c6da967$export$1c9f709888824e05; });
var $f2efb9544c6da967$var$_ref, $f2efb9544c6da967$var$_process, $f2efb9544c6da967$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $f2efb9544c6da967$var$TESTS_MODE = ($f2efb9544c6da967$var$_ref = (globalThis === null || globalThis === void 0 || ($f2efb9544c6da967$var$_process = globalThis.process) === null || $f2efb9544c6da967$var$_process === void 0 || ($f2efb9544c6da967$var$_process = $f2efb9544c6da967$var$_process.env) === null || $f2efb9544c6da967$var$_process === void 0 ? void 0 : $f2efb9544c6da967$var$_process.JEST_WORKER_ID) !== undefined, $f2efb9544c6da967$var$_ref !== void 0) ? $f2efb9544c6da967$var$_ref : false;
var $f2efb9544c6da967$var$DEBUG_MODE = !$f2efb9544c6da967$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($f2efb9544c6da967$var$_process2 = globalThis.process) === null || $f2efb9544c6da967$var$_process2 === void 0 || ($f2efb9544c6da967$var$_process2 = $f2efb9544c6da967$var$_process2.env) === null || $f2efb9544c6da967$var$_process2 === void 0 ? void 0 : $f2efb9544c6da967$var$_process2.NODE_ENV) !== "production";
var $f2efb9544c6da967$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$f2efb9544c6da967$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});





parcelRegister("7Ozc3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b0880992516f774$export$2e2bcd8739ae039; });
/**
 * __Section__
 *
 * A dropdown item group includes all the actions or items in a dropdown menu.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-group/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-group/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-group/usage)
 */ 
var $4ymzH = parcelRequire("4ymzH");
var $5b0880992516f774$export$2e2bcd8739ae039 = (0, $4ymzH.default);

});
parcelRegister("4ymzH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $350bd94947b73afc$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $1OnrY = parcelRequire("1OnrY");

var $iCV0h = parcelRequire("iCV0h");

var $lrA9r = parcelRequire("lrA9r");

var $fSlQ8 = parcelRequire("fSlQ8");

var $j6JFH = parcelRequire("j6JFH");

var $3zCy9 = parcelRequire("3zCy9");
var $350bd94947b73afc$var$_excluded = [
    "children",
    "overrides",
    "title",
    "titleId",
    "testId",
    "isScrollable",
    "hasSeparator",
    "id",
    "isList",
    "className"
];
var $350bd94947b73afc$var$gridSize = (0, $fSlQ8.gridSize)();
var $350bd94947b73afc$var$itemHeadingTopMargin = $350bd94947b73afc$var$gridSize * 2.5;
var $350bd94947b73afc$var$itemHeadingBottomMargin = $350bd94947b73afc$var$gridSize * 0.75;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
var $350bd94947b73afc$var$itemHeadingContentHeight = (0, $j6JFH.headingSizes).h100.lineHeight;
var $350bd94947b73afc$var$skeletonHeadingHeight = $350bd94947b73afc$var$gridSize;
var $350bd94947b73afc$var$skeletonHeadingMarginOffset = 3;
var $350bd94947b73afc$var$skeletonHeadingTopMargin = $350bd94947b73afc$var$itemHeadingTopMargin + ($350bd94947b73afc$var$itemHeadingContentHeight - $350bd94947b73afc$var$skeletonHeadingHeight) - $350bd94947b73afc$var$skeletonHeadingMarginOffset;
// We want to move the entire body up by 3px without affecting the height of the skeleton container.
var $350bd94947b73afc$var$skeletonHeadingBottomMargin = $350bd94947b73afc$var$itemHeadingBottomMargin + $350bd94947b73afc$var$skeletonHeadingMarginOffset;
var $350bd94947b73afc$var$sectionPaddingTopBottom = $350bd94947b73afc$var$gridSize * 0.75;
var $350bd94947b73afc$var$VAR_SEPARATOR_COLOR = "--ds-menu-seperator-color";
var $350bd94947b73afc$var$sectionStyles = (0, $avKww.css)({
    "&::before, &::after": {
        display: "block",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: $350bd94947b73afc$var$sectionPaddingTopBottom,
        content: '""'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "& [data-ds--menu--heading-item]": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $350bd94947b73afc$var$itemHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $350bd94947b73afc$var$itemHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "&:first-of-type": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $350bd94947b73afc$var$itemHeadingTopMargin - $350bd94947b73afc$var$sectionPaddingTopBottom
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "& [data-ds--menu--skeleton-heading-item]": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $350bd94947b73afc$var$skeletonHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $350bd94947b73afc$var$skeletonHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "&:first-of-type": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $350bd94947b73afc$var$skeletonHeadingTopMargin - $350bd94947b73afc$var$sectionPaddingTopBottom
        }
    },
    "&:focus": {
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        // This makes the outline go inside by 1px so it can actually be displayed
        // else it gets cut off from the overflow: scroll from the parent menu group.
        outlineOffset: -1
    }
});
var $350bd94947b73afc$var$scrollableStyles = (0, $avKww.css)({
    flexShrink: 1,
    overflow: "auto"
});
var $350bd94947b73afc$var$unscrollableStyles = (0, $avKww.css)({
    flexShrink: 0
});
var $350bd94947b73afc$var$thickSeparatorStyles = (0, $avKww.css)({
    borderBlockStart: "2px solid var(".concat($350bd94947b73afc$var$VAR_SEPARATOR_COLOR, ", ", "var(--ds-border, ".concat((0, $lrA9r.N30A), ")"), ")")
});
var $350bd94947b73afc$var$thinSeparatorStyles = (0, $avKww.css)({
    borderBlockStart: "1px solid var(".concat($350bd94947b73afc$var$VAR_SEPARATOR_COLOR, ", ", "var(--ds-border, ".concat((0, $lrA9r.N30A), ")"), ")")
});
var $350bd94947b73afc$var$noSeparatorStyles = (0, $avKww.css)({
    // this is to ensure that adjacent sections without separators don't get additional margins.
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "[data-section] + &": {
        marginBlockStart: -6
    }
});
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $350bd94947b73afc$var$Section = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var children = _ref.children, overrides = _ref.overrides, title = _ref.title, titleId = _ref.titleId, testId = _ref.testId, isScrollable = _ref.isScrollable, hasSeparator = _ref.hasSeparator, id = _ref.id, _ref$isList = _ref.isList, isList = _ref$isList === void 0 ? false : _ref$isList, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $350bd94947b73afc$var$_excluded);
    (0, $1OnrY.propDeprecationWarning)("@atlaskit/menu", "overrides", overrides !== undefined, "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var UNSAFE_headingOverrides = overrides && overrides.HeadingItem && overrides.HeadingItem.cssFn;
    var content = isList ? (0, $avKww.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $9nHZC.Children).map((0, $9nHZC.Children).toArray(children), function(child, index) {
        return (0, $avKww.jsx)("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: "none",
                margin: 0,
                padding: 0
            },
            key: index
        }, child);
    })) : children;
    var childrenMarkup = title !== undefined ? (0, $avKww.jsx)((0, $9nHZC.Fragment), null, (0, $avKww.jsx)((0, $3zCy9.default), {
        cssFn: UNSAFE_headingOverrides,
        testId: testId && "".concat(testId, "--heading"),
        "aria-hidden": true
    }, title), content) : (0, $avKww.jsx)((0, $9nHZC.Fragment), null, content);
    return (0, $avKww.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        id: id,
        css: [
            $350bd94947b73afc$var$sectionStyles,
            isScrollable ? $350bd94947b73afc$var$scrollableStyles : $350bd94947b73afc$var$unscrollableStyles,
            hasSeparator ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $iCV0h.fg)("platform.design-system-team.section-1px-seperator-borders") ? $350bd94947b73afc$var$thinSeparatorStyles : $350bd94947b73afc$var$thickSeparatorStyles : $350bd94947b73afc$var$noSeparatorStyles
        ],
        "aria-label": title,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }), childrenMarkup);
});
var $350bd94947b73afc$export$2e2bcd8739ae039 = $350bd94947b73afc$var$Section;

});
parcelRegister("fSlQ8", function(module, exports) {

$parcel$export(module.exports, "borderRadius", function () { return $b8ecd716a9a60405$export$7a57f79000377ca2; });
$parcel$export(module.exports, "gridSize", function () { return $b8ecd716a9a60405$export$6d8204c2cb2e06b8; });

var $1OnrY = parcelRequire("1OnrY");

var $lrA9r = parcelRequire("lrA9r");
var $b8ecd716a9a60405$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $b8ecd716a9a60405$export$c93026a968943f95 = "light";
var $b8ecd716a9a60405$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $b8ecd716a9a60405$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $b8ecd716a9a60405$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $b8ecd716a9a60405$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $b8ecd716a9a60405$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $b8ecd716a9a60405$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $b8ecd716a9a60405$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $b8ecd716a9a60405$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $lrA9r.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $b8ecd716a9a60405$export$6d8204c2cb2e06b8() / 4;
    (0, $1OnrY.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $b8ecd716a9a60405$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $b8ecd716a9a60405$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $b8ecd716a9a60405$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $1OnrY.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $b8ecd716a9a60405$export$ba1d834b86d72a09 = $b8ecd716a9a60405$export$a1b3edb637fb4f35;
var $b8ecd716a9a60405$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $lrA9r.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $lrA9r.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $lrA9r.N30A), ")")
            }
        }
    };
};

});

parcelRegister("j6JFH", function(module, exports) {

$parcel$export(module.exports, "headingSizes", function () { return $de92014a2e189c8f$export$bc02e067df412c3b; });

var $kFnE9 = parcelRequire("kFnE9");

var $lrA9r = parcelRequire("lrA9r");

var $fSlQ8 = parcelRequire("fSlQ8");
function $de92014a2e189c8f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $de92014a2e189c8f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $de92014a2e189c8f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $de92014a2e189c8f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $de92014a2e189c8f$export$2a99220fb32ec798 = {
    heading: {
        xxlarge: 'normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xlarge: 'normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        large: 'normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xsmall: 'normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xxsmall: 'normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    },
    body: {
        large: 'normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        UNSAFE_small: 'normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    }
};
var $de92014a2e189c8f$var$baseHeading = function baseHeading(size, lineHeight) {
    return {
        fontSize: "".concat(size / 14, "em"),
        fontStyle: "inherit",
        lineHeight: lineHeight / size
    };
};
var $de92014a2e189c8f$export$bc02e067df412c3b = {
    h900: {
        size: 35,
        lineHeight: 40
    },
    h800: {
        size: 29,
        lineHeight: 32
    },
    h700: {
        size: 24,
        lineHeight: 28
    },
    h600: {
        size: 20,
        lineHeight: 24
    },
    h500: {
        size: 16,
        lineHeight: 20
    },
    h400: {
        size: 14,
        lineHeight: 16
    },
    h300: {
        size: 12,
        lineHeight: 16
    },
    h200: {
        size: 12,
        lineHeight: 16
    },
    h100: {
        size: 11,
        lineHeight: 16
    }
};
var $de92014a2e189c8f$export$bdb8f897727a9c67 = function h900() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $de92014a2e189c8f$var$_objectSpread($de92014a2e189c8f$var$_objectSpread({}, $de92014a2e189c8f$var$baseHeading($de92014a2e189c8f$export$bc02e067df412c3b.h900.size, $de92014a2e189c8f$export$bc02e067df412c3b.h900.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $lrA9r.N800), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $fSlQ8.gridSize)() * 6.5, "px")
    });
};
var $de92014a2e189c8f$export$3953fb6fbd158d23 = function h800() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $de92014a2e189c8f$var$_objectSpread($de92014a2e189c8f$var$_objectSpread({}, $de92014a2e189c8f$var$baseHeading($de92014a2e189c8f$export$bc02e067df412c3b.h800.size, $de92014a2e189c8f$export$bc02e067df412c3b.h800.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $lrA9r.N800), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $fSlQ8.gridSize)() * 5, "px")
    });
};
var $de92014a2e189c8f$export$e4f993a313607daa = function h700() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $de92014a2e189c8f$var$_objectSpread($de92014a2e189c8f$var$_objectSpread({}, $de92014a2e189c8f$var$baseHeading($de92014a2e189c8f$export$bc02e067df412c3b.h700.size, $de92014a2e189c8f$export$bc02e067df412c3b.h700.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $lrA9r.N800), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $fSlQ8.gridSize)() * 5, "px")
    });
};
var $de92014a2e189c8f$export$1e8b2acea3fb3119 = function h600() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $de92014a2e189c8f$var$_objectSpread($de92014a2e189c8f$var$_objectSpread({}, $de92014a2e189c8f$var$baseHeading($de92014a2e189c8f$export$bc02e067df412c3b.h600.size, $de92014a2e189c8f$export$bc02e067df412c3b.h600.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $lrA9r.N800), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.008em",
        marginTop: "".concat((0, $fSlQ8.gridSize)() * 3.5, "px")
    });
};
var $de92014a2e189c8f$export$85aa43a9b9f06707 = function h500() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $de92014a2e189c8f$var$_objectSpread($de92014a2e189c8f$var$_objectSpread({}, $de92014a2e189c8f$var$baseHeading($de92014a2e189c8f$export$bc02e067df412c3b.h500.size, $de92014a2e189c8f$export$bc02e067df412c3b.h500.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $lrA9r.N800), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.006em",
        marginTop: "".concat((0, $fSlQ8.gridSize)() * 3, "px")
    });
};
var $de92014a2e189c8f$export$fcb7764b80bd908f = function h400() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $de92014a2e189c8f$var$_objectSpread($de92014a2e189c8f$var$_objectSpread({}, $de92014a2e189c8f$var$baseHeading($de92014a2e189c8f$export$bc02e067df412c3b.h400.size, $de92014a2e189c8f$export$bc02e067df412c3b.h400.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $lrA9r.N800), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.003em",
        marginTop: "".concat((0, $fSlQ8.gridSize)() * 2, "px")
    });
};
var $de92014a2e189c8f$export$a0e59c3bbc05e815 = function h300() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $de92014a2e189c8f$var$_objectSpread($de92014a2e189c8f$var$_objectSpread({}, $de92014a2e189c8f$var$baseHeading($de92014a2e189c8f$export$bc02e067df412c3b.h300.size, $de92014a2e189c8f$export$bc02e067df412c3b.h300.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $lrA9r.N800), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $fSlQ8.gridSize)() * 2.5, "px"),
        textTransform: "uppercase"
    });
};
var $de92014a2e189c8f$export$7ccf32eb2150ac7e = function h200() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $de92014a2e189c8f$var$_objectSpread($de92014a2e189c8f$var$_objectSpread({}, $de92014a2e189c8f$var$baseHeading($de92014a2e189c8f$export$bc02e067df412c3b.h200.size, $de92014a2e189c8f$export$bc02e067df412c3b.h200.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $lrA9r.N200), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $fSlQ8.gridSize)() * 2, "px")
    });
};
var $de92014a2e189c8f$export$dfc0e69214efdc3c = function h100() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $de92014a2e189c8f$var$_objectSpread($de92014a2e189c8f$var$_objectSpread({}, $de92014a2e189c8f$var$baseHeading($de92014a2e189c8f$export$bc02e067df412c3b.h100.size, $de92014a2e189c8f$export$bc02e067df412c3b.h100.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $lrA9r.N200), ")"),
        fontWeight: "var(--ds-font-weight-bold, 700)",
        marginTop: "".concat((0, $fSlQ8.gridSize)() * 2, "px")
    });
};

});

parcelRegister("3zCy9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29a28b29bbb9f961$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $1OnrY = parcelRequire("1OnrY");

var $8p2GL = parcelRequire("8p2GL");

var $lrA9r = parcelRequire("lrA9r");
var $29a28b29bbb9f961$var$_excluded = [
    "children",
    "testId",
    "headingLevel",
    "id",
    "cssFn",
    "className"
];
var $29a28b29bbb9f961$var$headingStyles = (0, $avKww.css)({
    color: "var(--ds-text-subtle, ".concat((0, $lrA9r.N300), ")"),
    font: 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: "uppercase"
});
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $29a28b29bbb9f961$var$HeadingItem = /*#__PURE__*/ (0, $9nHZC.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 2 : _ref$headingLevel, id = _ref.id, _ref$cssFn = _ref.cssFn, cssFn = _ref$cssFn === void 0 ? (0, $8p2GL.default) : _ref$cssFn, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $29a28b29bbb9f961$var$_excluded);
    (0, $1OnrY.propDeprecationWarning)("@atlaskit/menu", "cssFn", cssFn !== (0, $8p2GL.default), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var UNSAFE_overrides = (0, $avKww.css)(cssFn(undefined));
    return (0, $avKww.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        css: [
            $29a28b29bbb9f961$var$headingStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            UNSAFE_overrides
        ],
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: UNSAFE_className
    }, rest), children);
});
var $29a28b29bbb9f961$export$2e2bcd8739ae039 = $29a28b29bbb9f961$var$HeadingItem;

});



parcelRegister("enZDC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a79306ae3c98a8b6$var$_react = $a79306ae3c98a8b6$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $a79306ae3c98a8b6$var$_premium = $a79306ae3c98a8b6$var$_interopRequireDefault((parcelRequire("enkZF")));
function $a79306ae3c98a8b6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a79306ae3c98a8b6$var$PremiumIcon = (props)=>/*#__PURE__*/ $a79306ae3c98a8b6$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9.276 4.382 7.357 9.247l-4.863 1.917a.78.78 0 0 0 0 1.45l4.863 1.918 1.919 4.863a.78.78 0 0 0 1.45 0h-.001l1.918-4.863 4.864-1.919a.781.781 0 0 0 0-1.45l-4.864-1.916-1.918-4.865a.78.78 0 0 0-.44-.438.78.78 0 0 0-1.01.438m8.297-2.03-.743 1.886-1.884.743a.56.56 0 0 0 0 1.038l1.884.743.743 1.886a.558.558 0 0 0 1.038 0l.745-1.886 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.743-.745-1.885a.55.55 0 0 0-.314-.314.56.56 0 0 0-.724.314m-.704 13.003-.744 1.883-1.883.744a.55.55 0 0 0-.316.314.56.56 0 0 0 .316.724l1.883.743.744 1.884c.057.144.17.258.314.315a.56.56 0 0 0 .724-.315l.744-1.884 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.744-.744-1.883a.55.55 0 0 0-.315-.316.56.56 0 0 0-.723.316"/></svg>`
    }, props, {
        newIcon: $a79306ae3c98a8b6$var$_premium.default
    }));
$a79306ae3c98a8b6$var$PremiumIcon.displayName = "PremiumIcon";
var $a79306ae3c98a8b6$var$_default = module.exports.default = $a79306ae3c98a8b6$var$PremiumIcon;

});
parcelRegister("enkZF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e4e7e52b19e86505e62fa001d0499281>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a7737f9157e5bc42$var$_react = $a7737f9157e5bc42$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $a7737f9157e5bc42$var$_UNSAFE_baseNew = $a7737f9157e5bc42$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $a7737f9157e5bc42$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Premium".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for premium features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a7737f9157e5bc42$var$PremiumIcon = (props)=>/*#__PURE__*/ $a7737f9157e5bc42$var$_react.default.createElement($a7737f9157e5bc42$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M11.5 13.75h2.25m0 0H16m-2.25 0V11.5m0 2.25V16M0 2.25h2.25m0 0H4.5m-2.25 0V0m0 2.25V4.5M8 1.75l1.75 4.5L14.25 8l-4.5 1.75L8 14.25l-1.75-4.5L1.75 8l4.5-1.75z"/>`
    }, props));
$a7737f9157e5bc42$var$PremiumIcon.displayName = "PremiumIcon";
var $a7737f9157e5bc42$var$_default = module.exports.default = $a7737f9157e5bc42$var$PremiumIcon;

});


parcelRegister("i9bkK", function(module, exports) {

$parcel$export(module.exports, "sharedMessages", function () { return $fb9d6ad64e8e0ccc$export$39a13631616da233; });

var $agjvf = parcelRequire("agjvf");
const $fb9d6ad64e8e0ccc$export$39a13631616da233 = (0, $agjvf.defineMessages)({
    allBranchesTabLabel: {
        "id": "frontbucket.settings.merge-checks-tabs.allBranchesTabLabel",
        "defaultMessage": "All branches"
    },
    mainBranchTabLabel: {
        "id": "frontbucket.settings.merge-checks-tabs.mainBranchTabLabel",
        "defaultMessage": "Main branch"
    },
    enabledChecksTooltip: {
        "id": "frontbucket.settings.merge-checks-tabs.enabledChecksTooltip",
        "defaultMessage": "{count} {count, plural, one {check} other {checks}} enabled"
    },
    tableColumnApp: {
        "id": "frontbucket.settings.merge-checks-tabs.tableColumnApp",
        "defaultMessage": "App"
    },
    tableColumnMergeCheck: {
        "id": "frontbucket.settings.merge-checks-tabs.tableColumnMergeCheck",
        "defaultMessage": "Merge Check"
    },
    tableColumnType: {
        "id": "frontbucket.settings.merge-checks-tabs.tableColumnType",
        "defaultMessage": "Type"
    },
    configurationTabsAriaLabel: {
        "id": "frontbucket.settings.merge-checks-tabs.configurationTabsAriaLabel",
        "defaultMessage": "Custom merge checks repository configuration - {tabLabel}. {enabledChecks}"
    },
    configurationTableAriaLabel: {
        "id": "frontbucket.settings.merge-checks-tabs.configurationTableAriaLabel",
        "defaultMessage": "Custom merge checks repository configuration - {branchConfig}"
    },
    checkDropdownAriaLabel: {
        "id": "frontbucket.settings.merge-checks-tabs.checkDropdownAriaLabel",
        "defaultMessage": "{appName}. {checkName}. Runs {triggers}. Currently {status}"
    }
});

});

parcelRegister("h5cf5", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $bb9ba63ca35602a3$export$defe85febe8b728c; });

var $agjvf = parcelRequire("agjvf");
const $bb9ba63ca35602a3$export$defe85febe8b728c = (0, $agjvf.defineMessages)({
    preMerge: {
        "id": "frontbucket.settings.merge-checks.preMerge",
        "defaultMessage": "pre-merge"
    },
    onMerge: {
        "id": "frontbucket.settings.merge-checks.onMerge",
        "defaultMessage": "on-merge"
    },
    enableErrorMessage: {
        "id": "frontbucket.settings.merge-checks.enableErrorMessage",
        "defaultMessage": 'Something went wrong while trying to enable "{name}"'
    },
    disableErrorMessage: {
        "id": "frontbucket.settings.merge-checks.disableErrorMessage",
        "defaultMessage": 'Something went wrong while trying to disable "{name}"'
    },
    checkDisabledLabel: {
        "id": "frontbucket.settings.merge-checks.checkDisabledLabel",
        "defaultMessage": "Off"
    },
    checkRecommendedLabel: {
        "id": "frontbucket.settings.merge-checks.checkRecommendedLabel",
        "defaultMessage": "Recommended"
    },
    checkRequiredLabel: {
        "id": "frontbucket.settings.merge-checks.checkRequiredLabel",
        "defaultMessage": "Required"
    },
    requiredPremiumOnly: {
        "id": "frontbucket.settings.merge-checks.premiumRequired",
        "defaultMessage": "Required is only available to premium workspaces"
    },
    premiumIconLabel: {
        "id": "frontbucket.settings.merge-checks.premiumIconLabel",
        "defaultMessage": "Premium workspaces only"
    }
});

});


parcelRegister("djFfq", function(module, exports) {

$parcel$export(module.exports, "customMergeCheckKey", function () { return $80cc6cac84f69e6c$export$566959bd8be31cee; });
$parcel$export(module.exports, "updateCustomMergeCheckConfigRouteResource", function () { return $80cc6cac84f69e6c$export$8c1b8991e69c034e; });

var $gVgNk = parcelRequire("gVgNk");
const $80cc6cac84f69e6c$export$566959bd8be31cee = (resourceType, branchConfig, extensionId)=>`${resourceType}${branchConfig.type}${branchConfig.identifier}${extensionId}`;
const $80cc6cac84f69e6c$var$REPOSITORY_ARI_PREFIX = "ari:cloud:bitbucket::repository";
const $80cc6cac84f69e6c$var$determineResourceType = (resource)=>{
    if (resource.startsWith($80cc6cac84f69e6c$var$REPOSITORY_ARI_PREFIX)) return (0, $gVgNk.CustomMergeChecksResourceType).Repository;
    throw new Error(`Invalid resource ID ${resource}`);
};
const $80cc6cac84f69e6c$export$8c1b8991e69c034e = ({ extensionId: extensionId, branchConfig: branchConfig, state: state, resource: resource })=>(data)=>{
        const updatedStateMap = new Map(data.stateMap);
        const key = $80cc6cac84f69e6c$export$566959bd8be31cee($80cc6cac84f69e6c$var$determineResourceType(resource), branchConfig, extensionId);
        updatedStateMap.set(key, state);
        return {
            ...data,
            stateMap: updatedStateMap
        };
    };

});



parcelRegister("gTSwQ", function(module, exports) {

$parcel$export(module.exports, "ConfirmMergeCheckStateModal", function () { return (parcelRequire("dvtJl")).ConfirmMergeCheckStateModal; });

var $dvtJl = parcelRequire("dvtJl");

});
parcelRegister("dvtJl", function(module, exports) {

$parcel$export(module.exports, "ConfirmMergeCheckStateModal", function () { return $839375f4bf636ff8$export$84454066d58b5c26; });

var $9nHZC = parcelRequire("9nHZC");

var $hwElN = parcelRequire("hwElN");
var $3THTN = parcelRequire("3THTN");
var $97xxA = parcelRequire("97xxA");

var $cGPG3 = parcelRequire("cGPG3");
var $ljrFr = parcelRequire("ljrFr");
var $2X56B = parcelRequire("2X56B");
var $DPG6Z = parcelRequire("DPG6Z");
var $3qXIy = parcelRequire("3qXIy");

var $jajUg = parcelRequire("jajUg");

var $7vdLP = parcelRequire("7vdLP");
const $839375f4bf636ff8$export$84454066d58b5c26 = ({ branchConfig: branchConfig, checkModule: checkModule, isLoading: isLoading, checkStateChangeType: checkStateChangeType, onConfirm: onConfirm, onCancel: onCancel })=>{
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    const { name: name } = checkModule;
    const onConfirmClick = (0, $9nHZC.useCallback)(()=>{
        onConfirm(branchConfig, checkModule, checkStateChangeType);
    }, [
        onConfirm,
        branchConfig,
        checkModule,
        checkStateChangeType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $cGPG3.default), {
        width: "medium",
        shouldScrollInViewport: true,
        onClose: onCancel,
        shouldCloseOnOverlayClick: !isLoading,
        shouldCloseOnEscapePress: !isLoading,
        testId: "confirm-merge-check-state-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $DPG6Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3qXIy.default), null, name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ljrFr.default), null, formatMessage((0, $7vdLP.contextMessages)[checkStateChangeType].description, {
        name: checkModule.properties.name
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2X56B.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $hwElN.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3THTN.default), {
        appearance: "subtle",
        onClick: onCancel,
        isDisabled: isLoading,
        testId: "confirm-merge-check-state-cancel-btn"
    }, formatMessage((0, $7vdLP.messages).cancelBtn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $97xxA.default), {
        appearance: "danger",
        onClick: onConfirmClick,
        isLoading: isLoading,
        testId: "confirm-merge-check-state-confirm-btn"
    }, formatMessage((0, $7vdLP.contextMessages)[checkStateChangeType].confirmBtn)))));
};

});
parcelRegister("7vdLP", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $48e0121dea5e25a0$export$defe85febe8b728c; });
$parcel$export(module.exports, "contextMessages", function () { return $48e0121dea5e25a0$export$55294b574c387ed1; });

var $agjvf = parcelRequire("agjvf");

var $gVgNk = parcelRequire("gVgNk");
const $48e0121dea5e25a0$export$defe85febe8b728c = (0, $agjvf.defineMessages)({
    cancelBtn: {
        "id": "frontbucket.settings.merge-checks.modals.cancel-button",
        "defaultMessage": "Cancel"
    }
});
const $48e0121dea5e25a0$export$55294b574c387ed1 = {
    [(0, $gVgNk.MergeCheckStateChangeType).DISABLE]: (0, $agjvf.defineMessages)({
        description: {
            "id": "frontbucket.settings.merge-checks.modals.disable-check-description",
            "defaultMessage": 'This will disable the check and it will not be run for future pull requests. Are you sure you wish to disable "{name}"? You can enable it again if you wish to do so.'
        },
        confirmBtn: {
            "id": "frontbucket.settings.merge-checks.modals.disable-button",
            "defaultMessage": "Disable"
        }
    }),
    [(0, $gVgNk.MergeCheckStateChangeType).REQUIRED_TO_RECOMMENDED]: (0, $agjvf.defineMessages)({
        description: {
            "id": "frontbucket.settings.merge-checks.modals.required-to-recommended-check-description",
            "defaultMessage": 'This will change the check from required to recommended and will not prevent the pull request from merging. Are you sure you wish to change "{name}" to recommended? You can change it back to required if you wish to do so.'
        },
        confirmBtn: {
            "id": "frontbucket.settings.merge-checks.modals.change-to-recommended-button",
            "defaultMessage": "Confirm"
        }
    })
};

});




parcelRegister("eE4mZ", function(module, exports) {

$parcel$export(module.exports, "customMergeChecksConfigApi", function () { return $0739bdc9489d2cb1$export$4ac5fa31cfce2b8; });
$parcel$export(module.exports, "customMergeChecksConfigureApi", function () { return $0739bdc9489d2cb1$export$e322339af0174f02; });

var $jzmnA = parcelRequire("jzmnA");
const $0739bdc9489d2cb1$export$4ac5fa31cfce2b8 = (url)=>{
    return {
        getBranchConfigs: ()=>(0, $jzmnA.createHttpRequest)("GET")(`${url}/branch-configs`),
        getCustomMergeChecks: ()=>(0, $jzmnA.createHttpRequest)("GET")(url)
    };
};
const $0739bdc9489d2cb1$export$e322339af0174f02 = (url)=>{
    return {
        configureCustomMergeCheck: (extensionId, branch, state)=>(0, $jzmnA.createHttpRequest)("PUT")(`${url}/configure`, {
                extensionId: extensionId,
                branch: branch,
                state: state
            })
    };
};

});



parcelRegister("iOXsw", function(module, exports) {

$parcel$export(module.exports, "loadNudgedReviewersResource", function () { return $4383610f00285d4e$export$558c379582df9ee2; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");
parcelRequire("hw8PW");
var $7JtYi = parcelRequire("7JtYi");
var $l9p9x = parcelRequire("l9p9x");

var $k2cPS = parcelRequire("k2cPS");

var $czBtW = parcelRequire("czBtW");
const $4383610f00285d4e$var$fetchRecentlyNudgedReviewers = async (owner, slug, id)=>{
    const requestUrl = (0, $czBtW.default).api.internal.nudgeReviewer(owner, slug, id);
    const resp = await fetch((0, $k2cPS.default)(requestUrl));
    if (!resp.ok) throw new Error("Could not fetch recently nudged reviewers");
    const body = await resp.json();
    return body;
};
const $4383610f00285d4e$export$558c379582df9ee2 = (0, $3kfkg.createResource)({
    type: "pullrequest-nudged-reviewers",
    getKey: (routerStoreContext)=>{
        const { pullRequestId: id, repositoryOwner: owner, repositorySlug: slug } = routerStoreContext.match.params;
        return `${owner}/${slug}/${id}/nudged-reviewers`;
    },
    maxAge: 0,
    getData: async (routerStoreContext, { appData: appData })=>{
        var _appData$user;
        const { pullRequestId: id, repositoryOwner: owner, repositorySlug: slug } = routerStoreContext.match.params;
        const isNudgeReviewersEnabled = (0, $l9p9x.getFlagValue)((0, $7JtYi.FeatureKeys).isNudgeReviewersEnabled, false);
        // don't trigger unnecessary requests unless the feature flag is turned on
        if (!isNudgeReviewersEnabled) return [];
        if (!id || !owner || !slug) throw new Error("Could not fetch nudged reviewers, URL params were not available");
        // Return empty list if user is not logged in and don't fetch nudged reviewers
        if (!((_appData$user = appData.user) !== null && _appData$user !== void 0 && _appData$user.uuid)) return [];
        const recentlyNudgedReviewersResult = await $4383610f00285d4e$var$fetchRecentlyNudgedReviewers(owner, slug, id);
        return recentlyNudgedReviewersResult;
    }
});

});
parcelRegister("czBtW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d3855b41c64b0ad$export$2e2bcd8739ae039; });

var $8JO3D = parcelRequire("8JO3D");

var $hz8T1 = parcelRequire("hz8T1");

var $lbZCT = parcelRequire("lbZCT");
const $5d3855b41c64b0ad$var$urls = {
    api: {
        internal: $8JO3D.internal,
        v20: $lbZCT.v20
    },
    external: {},
    ui: $hz8T1.ui
};
var $5d3855b41c64b0ad$export$2e2bcd8739ae039 = $5d3855b41c64b0ad$var$urls;

});
parcelRegister("8JO3D", function(module, exports) {

$parcel$export(module.exports, "internal", function () { return $ff223a08539f575f$export$454b5eaffc99ebf6; });

var $cJH1T = parcelRequire("cJH1T");

var $7Yccf = parcelRequire("7Yccf");
const $ff223a08539f575f$var$baseUrl = "!api/internal/repositories";
const $ff223a08539f575f$var$DEFAULT_ACTIVITY_PAGELEN = 50;
const $ff223a08539f575f$export$454b5eaffc99ebf6 = {
    activity: ({ owner: owner, slug: slug, id: id, pagelen: pagelen = $ff223a08539f575f$var$DEFAULT_ACTIVITY_PAGELEN })=>{
        const qsParams = {
            pagelen: pagelen,
            fields: "+values.attachment.uuid,+values.update.source.commit.parents.hash"
        };
        const query = (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(qsParams, (0, $7Yccf.qsDefaultOptions));
        const url = `/${$ff223a08539f575f$var$baseUrl}/${owner}/${slug}/pullrequests/${id}/activity`;
        return `${url}${query}`;
    },
    orderedCommentsFetch: (user, repoSlug, pullRequestId)=>{
        const fields = "+values.user.account_status,+values.resolution.*,+values.inline.*";
        return (0, $7Yccf.buildCommentUrl)(user, repoSlug, pullRequestId, undefined, {
            baseUrl: $ff223a08539f575f$var$baseUrl,
            extraQueryStringParams: {
                fields: fields,
                pagelen: 100,
                sort: "created_on"
            }
        });
    },
    conflicts: (user, repoSlug, pullRequestId)=>`/!api/internal/repositories/${user}/${repoSlug}/pullrequests/${pullRequestId}/conflicts`,
    contextFromSrcPreviewMerge: (pieces, lineNums)=>{
        const lineNumParams = {
            fromline: lineNums.startingFrom,
            toline: lineNums.endingFrom
        };
        const { owner: owner, slug: slug, destinationHash: destinationHash, filepath: filepath } = pieces;
        const url = `/!api/internal/repositories/${owner}/${slug}/src/${destinationHash}/${encodeURIComponent(filepath)}`;
        const query = (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(lineNumParams, {
            addQueryPrefix: true,
            skipNulls: true
        });
        return `${url}${query}`;
    },
    // TODO: remove contextFromSrcPreviewMerge above and rename this to `context`
    // once we fully switch to topic diffs and consolidate with PR expand context logic
    // we are fetching context from the destination right now because in preview-merge diffs, there may
    // be changes in context lines in the destination that are not present on the source branch
    contextFromSrcTopicDiff: (pieces, lineNums)=>{
        const lineNumParams = {
            fromline: lineNums.startingTo,
            toline: lineNums.endingTo
        };
        const { owner: owner, slug: slug, sourceHash: sourceHash, filepath: filepath } = pieces;
        const url = `/!api/internal/repositories/${owner}/${slug}/src/${sourceHash}/${encodeURIComponent(filepath)}`;
        const query = (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(lineNumParams, {
            addQueryPrefix: true,
            skipNulls: true
        });
        return `${url}${query}`;
    },
    imageUpload: (owner, slug)=>`/xhr/${owner}/${slug}/image-upload/`,
    mergeChecks: (user, repoSlug, pullRequestId)=>`/!api/internal/repositories/${user}/${repoSlug}/pullrequests/${pullRequestId}/merge-restrictions`,
    pendingMerge: (owner, repoSlug, pullRequestId)=>`/!api/internal/repositories/${owner}/${repoSlug}/pullrequests/${pullRequestId}/post-build-merge`,
    watch: (owner, repoSlug, pullRequestId)=>`/!api/internal/repositories/${owner}/${repoSlug}/pullrequests/${pullRequestId}/watch`,
    commentById: (owner, repoSlug, pullRequestId, commentId)=>`/!api/internal/repositories/${owner}/${repoSlug}/pullrequests/${pullRequestId}/comments/${commentId}`,
    likeComment: (owner, repoSlug, pullRequestId, commentId)=>`/!api/internal/repositories/${owner}/${repoSlug}/pullrequests/${pullRequestId}/comments/${commentId}/likes`,
    commentLikes: (owner, repoSlug, pullRequestId)=>`/!api/internal/repositories/${owner}/${repoSlug}/pullrequests/${pullRequestId}/likes`,
    updates: (owner, repoSlug, pullRequestId, since)=>{
        const sinceVal = typeof since === "string" ? since : since.toISOString();
        return `/!api/internal/repositories/${owner}/${repoSlug}/pullrequests/${pullRequestId}/updates?since=${encodeURIComponent(sinceVal)}`;
    },
    branchSyncInfo: (owner, repoSlug, pullRequestId)=>`/!api/internal/repositories/${owner}/${repoSlug}/pullrequests/${pullRequestId}/branch-sync-info`,
    revert: (owner, repoSlug, pullRequestId)=>`/!api/internal/repositories/${owner}/${repoSlug}/pullrequests/${pullRequestId}/revert`,
    nudgeReviewer: (owner, repoSlug, pullRequestId)=>`/!api/internal/repositories/${owner}/${repoSlug}/pullrequests/${pullRequestId}/reviewers/nudge`,
    updateReviewer: (owner, repoSlug, pullRequestId, userAaid)=>`/!api/internal/repositories/${owner}/${repoSlug}/pullrequests/${pullRequestId}/reviewers/${userAaid}`,
    updatePullRequestSourceBranch: (owner, repoSlug, pullRequestId)=>`/!api/internal/repositories/${owner}/${repoSlug}/pullrequests/${pullRequestId}/update-source-branch`,
    // multi-comment review endpoints
    review: (owner, repoSlug, pullRequestId)=>`/!api/internal/repositories/${owner}/${repoSlug}/pullrequests/${pullRequestId}/review`,
    // returns list of pending reviewers for a PR
    pendingReviews: (owner, repoSlug, pullRequestId)=>`/!api/internal/repositories/${owner}/${repoSlug}/pullrequests/${pullRequestId}/pendingreviews`,
    // pr review groups
    reviewGroups: (owner, repoSlug, pullRequestId)=>`/!api/internal/repositories/${owner}/${repoSlug}/pullrequests/${pullRequestId}/reviewers/groups`,
    // iterative review
    checkpoint: (owner, repoSlug, pullRequestId)=>`/!api/internal/repositories/${owner}/${repoSlug}/pullrequests/${pullRequestId}/checkpoint`,
    // pull request labels list
    prLabels: (owner, repoSlug, pullRequestId)=>`/!api/internal/repositories/${owner}/${repoSlug}/pullrequests/${pullRequestId}/labels`,
    // pull request label
    prLabel: (owner, repoSlug, pullRequestId, label)=>`/!api/internal/repositories/${owner}/${repoSlug}/pullrequests/${pullRequestId}/labels/${label}`,
    // pull request labels list
    labels: (owner)=>`/!api/internal/workspaces/${owner}/pullrequest-labels`
};

});
parcelRegister("7Yccf", function(module, exports) {

$parcel$export(module.exports, "qsDefaultOptions", function () { return $eed0c84717f7289b$export$5629f9a35fe28f13; });
$parcel$export(module.exports, "buildCommentUrl", function () { return $eed0c84717f7289b$export$bac6d7a454e9c379; });
$parcel$export(module.exports, "normalizeDiffParams", function () { return $eed0c84717f7289b$export$853044dd51af269e; });
$parcel$export(module.exports, "normalizeDiffStatParams", function () { return $eed0c84717f7289b$export$1c61d58b77454dee; });
$parcel$export(module.exports, "addQueryParams", function () { return $eed0c84717f7289b$export$cbc5b385481fb319; });

var $cJH1T = parcelRequire("cJH1T");
const $eed0c84717f7289b$export$5629f9a35fe28f13 = {
    addQueryPrefix: true,
    skipNulls: true,
    // When requesting the diff for a renamed file we pass the before and after
    // path; the server expects the request to look like `path=before&path=after`
    // so we specify that here
    arrayFormat: "repeat"
};
const $eed0c84717f7289b$var$BASE_URL = "!api/2.0/repositories";
const $eed0c84717f7289b$var$DEFAULT_OPTIONS = {
    baseUrl: $eed0c84717f7289b$var$BASE_URL,
    extraQueryStringParams: {}
};
// IMPORTANT: NUM_INITIAL_CONTEXT_LINES MUST BE AT LEAST 1
// OTHERWISE CONTEXT EXPANSION WILL BREAK.
const $eed0c84717f7289b$var$NUM_INITIAL_CONTEXT_LINES = 3;
function $eed0c84717f7289b$export$bac6d7a454e9c379(user, repoSlug, pullRequestId, commentId = "", options = $eed0c84717f7289b$var$DEFAULT_OPTIONS) {
    const { baseUrl: baseUrl, extraQueryStringParams: extraQueryStringParams } = options;
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
        ...extraQueryStringParams
    }, $eed0c84717f7289b$export$5629f9a35fe28f13);
    const base = baseUrl || $eed0c84717f7289b$var$BASE_URL;
    const url = `/${base}/${user}/${repoSlug}/pullrequests/${pullRequestId}/comments/${commentId}`;
    return `${url}${query}`;
}
const $eed0c84717f7289b$export$853044dd51af269e = (params)=>{
    return {
        binary: false,
        context: $eed0c84717f7289b$var$NUM_INITIAL_CONTEXT_LINES,
        ignore_whitespace: params.ignoreWhitespace || null,
        exclude_files_over_limit: !params.includeFilesOverLimit,
        use_fork_mergebase: params.useForkMergebase,
        // we explicitly pass topic=null so that the topic query param is not passed in the request
        // any value other than topic=true will yield a simple diff (or 2 dot diff)
        topic: params.topicDiff ? true : null,
        ...params.excludeFiles && {
            exclude_files: params.excludeFiles
        }
    };
};
const $eed0c84717f7289b$export$1c61d58b77454dee = (params)=>({
        ignore_whitespace: params.ignoreWhitespace || null,
        use_fork_mergebase: params.useForkMergebase,
        // we explicitly pass topic=null so that the topic query param is not passed in the request
        // any value other than topic=true will yield a simple diff (or 2 dot diff)
        topic: params.topicDiff ? true : null,
        pagelen: 1000,
        ...params.excludeFiles && {
            exclude_files: params.excludeFiles
        }
    });
function $eed0c84717f7289b$export$1b7a7b5c29861a2c(url) {
    const queryStart = url.indexOf("?");
    if (queryStart === -1) return {
        location: url,
        params: {}
    };
    const query = url.substring(queryStart);
    const location = url.substring(0, queryStart);
    return {
        location: location,
        params: (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).parse(query, {
            ignoreQueryPrefix: true
        })
    };
}
function $eed0c84717f7289b$export$cbc5b385481fb319(url, params) {
    const { location: location, params: oldParams } = $eed0c84717f7289b$export$1b7a7b5c29861a2c(url);
    const newParams = {
        ...oldParams,
        ...params
    };
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(newParams, $eed0c84717f7289b$export$5629f9a35fe28f13);
    return `${location}${query}`;
}

});


parcelRegister("hz8T1", function(module, exports) {

$parcel$export(module.exports, "ui", function () { return $10b58f412a0b4ae5$export$5525e5ba287fa6f5; });

var $kZnTB = parcelRequire("kZnTB");
const $10b58f412a0b4ae5$export$5525e5ba287fa6f5 = {
    pullrequest: (owner, slug, pullRequestId)=>`${(0, $kZnTB.default).ui.repository(owner, slug)}/pull-requests/${pullRequestId}`,
    pullrequests: (owner, slug)=>`${(0, $kZnTB.default).ui.repository(owner, slug)}/pull-requests`,
    pullrequestdata: (owner, slug, pullRequestId)=>`${(0, $kZnTB.default).ui.repository(owner, slug)}/pull-requests/${pullRequestId}?state=view&fields=latest_excluded_files_version`
};

});

parcelRegister("lbZCT", function(module, exports) {

$parcel$export(module.exports, "v20", function () { return $1eaeafa8ca11276a$export$91c802c09531daae; });

var $cJH1T = parcelRequire("cJH1T");

var $d5yyK = parcelRequire("d5yyK");

var $964rM = parcelRequire("964rM");

var $7Yccf = parcelRequire("7Yccf");
const $1eaeafa8ca11276a$var$baseV2Url = `/!api/2.0/repositories`;
const $1eaeafa8ca11276a$export$91c802c09531daae = {
    approval: (owner, repoSlug, pullRequestId)=>`${$1eaeafa8ca11276a$var$baseV2Url}/${owner}/${repoSlug}/pullrequests/${pullRequestId}/approve`,
    requestChanges: (owner, repoSlug, pullRequestId)=>`${$1eaeafa8ca11276a$var$baseV2Url}/${owner}/${repoSlug}/pullrequests/${pullRequestId}/request-changes`,
    commentSave: (0, $7Yccf.buildCommentUrl),
    commentUpdate: (0, $7Yccf.buildCommentUrl),
    commentDelete: (0, $7Yccf.buildCommentUrl),
    commentResolve: (owner, repoSlug, pullRequestId, commentId)=>`${$1eaeafa8ca11276a$var$baseV2Url}/${owner}/${repoSlug}/pullrequests/${pullRequestId}/comments/${commentId}/resolve`,
    commits: (owner, slug, id, pagelen)=>{
        const url = `${$1eaeafa8ca11276a$var$baseV2Url}/${owner}/${slug}/pullrequests/${id}/commits`;
        const query_params = {
            truncate_to: (0, $d5yyK.COMMIT_MESSAGE_LENGTH),
            fields: "+*.participants.approved,-*.participants.*",
            ...pagelen && {
                pagelen: pagelen
            }
        };
        const query = (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(query_params);
        return `${url}?${query}`;
    },
    decline: (owner, repoSlug, pullRequestId)=>`${$1eaeafa8ca11276a$var$baseV2Url}/${owner}/${repoSlug}/pullrequests/${pullRequestId}/decline`,
    diff: (user, repoSlug, pullRequestId, params)=>{
        const url = `${$1eaeafa8ca11276a$var$baseV2Url}/${user}/${repoSlug}/pullrequests/${pullRequestId}/diff`;
        const query = Object.keys(params).length !== 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify((0, $7Yccf.normalizeDiffParams)(params), (0, $7Yccf.qsDefaultOptions)) : "";
        return `${url}${query}`;
    },
    diffstat: (user, repoSlug, pullRequestId, params)=>{
        const url = `${$1eaeafa8ca11276a$var$baseV2Url}/${user}/${repoSlug}/pullrequests/${pullRequestId}/diffstat`;
        const qsParams = (0, $7Yccf.normalizeDiffStatParams)(params);
        const query = (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(qsParams, (0, $7Yccf.qsDefaultOptions));
        return `${url}${query}`;
    },
    merge_async: ({ owner: owner, repoSlug: repoSlug, pullRequestId: pullRequestId })=>`${$1eaeafa8ca11276a$var$baseV2Url}/${owner}/${repoSlug}/pullrequests/${pullRequestId}/merge?async=true`,
    participants: (owner, repoSlug, pullRequestId)=>`${$1eaeafa8ca11276a$var$baseV2Url}/${owner}/${repoSlug}/pullrequests/${pullRequestId}?fields=participants`,
    pullRequest: (owner, repoSlug, pullRequestId)=>`${$1eaeafa8ca11276a$var$baseV2Url}/${owner}/${repoSlug}/pullrequests/${pullRequestId}`,
    pullRequests: (owner, repoSlug, destinationBranch)=>{
        const bbql = encodeURIComponent(`destination.branch.name="${(0, $964rM.default)(destinationBranch)}" AND source.branch.name!="${(0, $964rM.default)(destinationBranch)}" AND state="OPEN"`);
        return `/!api/2.0/repositories/${owner}/${repoSlug}/pullrequests?fields=size&q=${bbql}`;
    },
    statusesFetch: (owner, repoSlug, pullRequestId)=>`${$1eaeafa8ca11276a$var$baseV2Url}/${owner}/${repoSlug}/pullrequests/${pullRequestId}/statuses?pagelen=100`,
    members: (owner, userAaid)=>`/!api/2.0/workspaces/${owner}/members/${userAaid}`,
    repositoryPermissions: (owner, repo, aid)=>`/!api/2.0/workspaces/${owner}/permissions/repositories/${repo}?q=user.account_id=%22${aid}%22`,
    sourceBranchPullRequests: (destRepoFullSlug, sourceRepoFullSlug, sourceBranchName)=>{
        const bbqlQuery = `source.branch.name="${(0, $964rM.default)(sourceBranchName)}" AND source.repository.full_name="${(0, $964rM.default)(sourceRepoFullSlug)}" AND state="OPEN"`;
        const bbql = encodeURIComponent(bbqlQuery);
        return `/!api/2.0/repositories/${destRepoFullSlug}/pullrequests?fields=size&q=${bbql}`;
    },
    tasksFetch: (workspaceSlug, repoSlug, pullRequestId)=>`/!api/2.0/repositories/${workspaceSlug}/${repoSlug}/pullrequests/${pullRequestId}/tasks?pagelen=1000`,
    tasks: (workspaceSlug, repoSlug, pullRequestId)=>`/!api/2.0/repositories/${workspaceSlug}/${repoSlug}/pullrequests/${pullRequestId}/tasks`,
    task: (workspaceSlug, repoSlug, pullRequestId, taskId)=>`/!api/2.0/repositories/${workspaceSlug}/${repoSlug}/pullrequests/${pullRequestId}/tasks/${taskId}`
};

});
parcelRegister("d5yyK", function(module, exports) {
$parcel$export(module.exports, "getCommitList", function () { return (parcelRequire("8aZB9")).getCommitList; });
$parcel$export(module.exports, "getCurrentCommitGraph", function () { return (parcelRequire("8aZB9")).getCurrentCommitGraph; });
$parcel$export(module.exports, "getCurrentCommits", function () { return (parcelRequire("8aZB9")).getCurrentCommits; });
$parcel$export(module.exports, "getCurrentPage", function () { return (parcelRequire("8aZB9")).getCurrentPage; });
$parcel$export(module.exports, "getEndPage", function () { return (parcelRequire("8aZB9")).getEndPage; });
$parcel$export(module.exports, "getHasNextPage", function () { return (parcelRequire("8aZB9")).getHasNextPage; });
$parcel$export(module.exports, "getPageLength", function () { return (parcelRequire("8aZB9")).getPageLength; });
$parcel$export(module.exports, "getPaginationUrls", function () { return (parcelRequire("8aZB9")).getPaginationUrls; });
$parcel$export(module.exports, "getStartPage", function () { return (parcelRequire("8aZB9")).getStartPage; });

$parcel$export(module.exports, "LoadCommits", function () { return $0ccd93d8c07f5685$export$309dfc3182bb4b9c; });
$parcel$export(module.exports, "UPDATE_COMMITS", function () { return $0ccd93d8c07f5685$export$166a2b0aed5112a7; });
$parcel$export(module.exports, "COMMIT_MESSAGE_LENGTH", function () { return $0ccd93d8c07f5685$export$52d2b331905769e5; });
$parcel$export(module.exports, "loadCommits", function () { return $0ccd93d8c07f5685$export$75ba219573e4efed; });
$parcel$export(module.exports, "updateCurrentPage", function () { return $0ccd93d8c07f5685$export$f93edae441a67c30; });
$parcel$export(module.exports, "updateStartPage", function () { return $0ccd93d8c07f5685$export$610a11f6d6192a6c; });
$parcel$export(module.exports, "pageUnload", function () { return $0ccd93d8c07f5685$export$4e3385f910e23c73; });
$parcel$export(module.exports, "showNewCommits", function () { return $0ccd93d8c07f5685$export$e79799fec032fe6f; });
$parcel$export(module.exports, "reducer", function () { return $0ccd93d8c07f5685$export$1650419e431d3ba3; });

var $cJH1T = parcelRequire("cJH1T");
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
var $fICwP = parcelRequire("fICwP");

var $2kKDW = parcelRequire("2kKDW");

var $4oBYE = parcelRequire("4oBYE");
parcelRequire("8aZB9");
// Action Types
const $0ccd93d8c07f5685$var$prefixed = (action)=>`commitList/${action}`;
const $0ccd93d8c07f5685$export$309dfc3182bb4b9c = (0, $2MctD.createAsyncAction)($0ccd93d8c07f5685$var$prefixed("LOAD"));
const $0ccd93d8c07f5685$export$166a2b0aed5112a7 = $0ccd93d8c07f5685$var$prefixed("UPDATE");
const $0ccd93d8c07f5685$export$f922d12ac45405f1 = $0ccd93d8c07f5685$var$prefixed("UPDATE_CURRENT_PAGE");
const $0ccd93d8c07f5685$export$831acc55cec03c5e = $0ccd93d8c07f5685$var$prefixed("UPDATE_START_PAGE");
const $0ccd93d8c07f5685$export$79f7ef0e491ca5de = $0ccd93d8c07f5685$var$prefixed("PAGE_UNLOAD");
const $0ccd93d8c07f5685$export$52d2b331905769e5 = 1024;
const $0ccd93d8c07f5685$export$75ba219573e4efed = (options)=>{
    const query = (0, $cJH1T.stringify)({
        fields: "+*.participants.approved,-*.participants.*",
        include: options.refName || undefined,
        ctx: options.ctx || undefined,
        page: options.page || undefined,
        pagelen: options.pageLength || undefined,
        search: options.search || undefined,
        truncate_to: $0ccd93d8c07f5685$export$52d2b331905769e5
    });
    const url = `${(0, $4oBYE.default).api.internal.commits(options.repositoryFullSlug)}?${query}`;
    return (0, $fICwP.fetchAction)($0ccd93d8c07f5685$export$309dfc3182bb4b9c, {
        url: url,
        data: {
            isFiltering: options.isFiltering
        }
    });
};
const $0ccd93d8c07f5685$export$f93edae441a67c30 = (page)=>{
    return {
        type: $0ccd93d8c07f5685$export$f922d12ac45405f1,
        payload: page
    };
};
const $0ccd93d8c07f5685$export$610a11f6d6192a6c = (page)=>{
    return {
        type: $0ccd93d8c07f5685$export$831acc55cec03c5e,
        payload: page
    };
};
const $0ccd93d8c07f5685$export$4e3385f910e23c73 = ()=>({
        type: $0ccd93d8c07f5685$export$79f7ef0e491ca5de
    });
const $0ccd93d8c07f5685$export$5e83a93d344ca6d2 = "commits/ShowNewCommits";
const $0ccd93d8c07f5685$export$e79799fec032fe6f = ()=>(dispatch)=>{
        const showNewCommitsAction = {
            type: $0ccd93d8c07f5685$export$5e83a93d344ca6d2
        };
        const dismissFlagAction = (0, $2kKDW.dismissFlag)("commits-list-updated");
        dispatch(showNewCommitsAction);
        dispatch(dismissFlagAction);
    };
const $0ccd93d8c07f5685$var$initialState = {
    commits: [],
    currentPage: 1,
    hasNextPage: false,
    isLoading: false,
    isFiltering: false,
    isPreRequestState: true,
    pageLength: 25,
    startPage: 1,
    reloadUrl: null,
    newCommits: [],
    newCommitsHasNextPage: false,
    paginationUrls: {}
};
const $0ccd93d8c07f5685$export$1650419e431d3ba3 = (state = $0ccd93d8c07f5685$var$initialState, action)=>{
    switch(action.type){
        case $0ccd93d8c07f5685$export$309dfc3182bb4b9c.REQUEST:
            {
                const { isFiltering: isFiltering = false } = action.meta ? action.meta.data : {};
                const reloadUrl = action.meta && action.meta.url ? action.meta.url : null;
                return {
                    ...state,
                    isLoading: true,
                    isPreRequestState: false,
                    reloadUrl: reloadUrl,
                    isFiltering: isFiltering
                };
            }
        case $0ccd93d8c07f5685$export$309dfc3182bb4b9c.ERROR:
            return {
                ...state,
                isLoading: false
            };
        case $0ccd93d8c07f5685$export$309dfc3182bb4b9c.SUCCESS:
            {
                const { isFiltering: isFiltering = false } = action.meta ? action.meta.data : {};
                const { next: next, previous: previous, values: values } = action.payload;
                const { startPage: startPage, currentPage: currentPage, commits: commits, pageLength: pageLength, hasNextPage: hasNextPage } = state;
                // When commit list is being filtered by branch change, etc.
                // we should make sure that some values like commits, currentPage
                // should be rollback to their initial state
                const commitsAfterFilter = isFiltering ? [] : commits;
                const pagesLoaded = Math.ceil((commitsAfterFilter.length + values.length) / pageLength);
                const endPage = startPage + pagesLoaded - 1;
                const updateCommits = currentPage < startPage ? [
                    ...values,
                    ...commitsAfterFilter
                ] : [
                    ...commitsAfterFilter,
                    ...values
                ];
                const updatedStartPage = currentPage < startPage ? currentPage : startPage;
                const updatedCurrentPage = isFiltering ? 1 : currentPage;
                return {
                    ...state,
                    hasNextPage: updatedCurrentPage === endPage ? !!next : hasNextPage,
                    isLoading: false,
                    isFiltering: false,
                    startPage: isFiltering ? 1 : updatedStartPage,
                    commits: updateCommits,
                    currentPage: updatedCurrentPage,
                    paginationUrls: {
                        ...state.paginationUrls,
                        [currentPage]: {
                            previousUrl: previous,
                            nextUrl: next
                        }
                    }
                };
            }
        case $0ccd93d8c07f5685$export$166a2b0aed5112a7:
            {
                const { commits: commits } = state;
                return {
                    ...state,
                    commits: commits.map((commit)=>{
                        const updatedCommit = action.payload.find(// @ts-ignore TODO: fix noImplicitAny error here
                        ({ hash: hash })=>hash === commit.hash);
                        return updatedCommit || commit;
                    })
                };
            }
        case $0ccd93d8c07f5685$export$f922d12ac45405f1:
            return {
                ...state,
                currentPage: action.payload
            };
        case $0ccd93d8c07f5685$export$831acc55cec03c5e:
            return {
                ...state,
                startPage: action.payload
            };
        case $0ccd93d8c07f5685$export$5e83a93d344ca6d2:
            return {
                ...state,
                commits: [
                    ...state.newCommits
                ],
                hasNextPage: state.newCommitsHasNextPage,
                newCommits: [],
                newCommitsHasNextPage: false
            };
        case $0ccd93d8c07f5685$export$79f7ef0e491ca5de:
            return $0ccd93d8c07f5685$var$initialState;
        default:
            return state;
    }
};

});
parcelRegister("4oBYE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a50bd97ecfabca3f$export$2e2bcd8739ae039; });

var $cJH1T = parcelRequire("cJH1T");

var $d5yyK = parcelRequire("d5yyK");

var $kZnTB = parcelRequire("kZnTB");

var $kvnVB = parcelRequire("kvnVB");
const $a50bd97ecfabca3f$var$urls = {
    api: {
        internal: {
            commitsBuildStatuses: (repositoryFullSlug)=>{
                const url = `/!api/internal/repositories/${repositoryFullSlug}/commits/statuses/`;
                const fields = [
                    "updated_on",
                    "description",
                    "name"
                ];
                const query = (0, $cJH1T.stringify)({
                    fields: fields.map((f)=>`+*.commit_status.${f}`).join(",")
                });
                return `${url}?${query}`;
            },
            commits: (repositoryFullSlug)=>`/!api/internal/repositories/${repositoryFullSlug}/changesets`,
            commit: (repositoryFullSlug, commitHash)=>`/!api/internal/repositories/${repositoryFullSlug}/changeset/${commitHash}`,
            watch: (repositoryFullSlug, commitHash)=>`/!api/internal/repositories/${repositoryFullSlug}/${commitHash}/watch`,
            specCommitsApiUrl: (repositoryFullSlug, sourceHash, destRepoFullSlug, destHash)=>{
                const url = `/!api/internal/repositories/${repositoryFullSlug}/changesets-spec/${repositoryFullSlug}:${sourceHash}%0D${destRepoFullSlug}:${destHash}`;
                const query_params = {
                    truncate_to: (0, $d5yyK.COMMIT_MESSAGE_LENGTH),
                    fields: "+*.participants.approved,-*.participants.*"
                };
                const query = (0, $cJH1T.stringify)(query_params);
                return `${url}?${query}`;
            }
        },
        v20: {
            commit: (repositoryFullSlug, commitHash)=>`/!api/2.0/repositories/${repositoryFullSlug}/commit/${commitHash}`,
            commitAbs: (repositoryFullSlug, commitHash)=>`${(0, $kvnVB.settings)().CANON_URL}${$a50bd97ecfabca3f$var$urls.api.v20.commit(repositoryFullSlug, commitHash)}`,
            statuses: (repositoryFullSlug, commitHash)=>`/!api/2.0/repositories/${repositoryFullSlug}/commit/${commitHash}/statuses?pagelen=100`,
            approve: (repositoryFullSlug, commitHash)=>`/!api/2.0/repositories/${repositoryFullSlug}/commit/${commitHash}/approve`,
            participants: (repositoryFullSlug, commitHash)=>`/!api/2.0/repositories/${repositoryFullSlug}/commit/${commitHash}?fields=participants`,
            diffStat: (repositoryFullSlug, nextCommitHash, parentCommitHash)=>{
                const baseUrl = `/!api/2.0/repositories/${repositoryFullSlug}/diffstat`;
                if (parentCommitHash) return `${baseUrl}/${parentCommitHash}..${nextCommitHash}`;
                return `${baseUrl}/${nextCommitHash}`;
            },
            tags: (repositoryFullSlug)=>`/!api/2.0/repositories/${repositoryFullSlug}/refs/tags`,
            comments: (repoUrl, commitHash)=>`/!api/2.0/repositories/${repoUrl}/commit/${commitHash}/comments?pagelen=100`,
            comment: (repoUrl, commitHash, commentId)=>`/!api/2.0/repositories/${repoUrl}/commit/${commitHash}/comments/${commentId}`
        }
    },
    external: {
        commitListEmptyStateLearnHow: "https://confluence.atlassian.com/x/8QhODQ"
    },
    ui: {
        commits: (repositoryFullSlug)=>{
            const [owner, slug] = repositoryFullSlug.split("/");
            return `${(0, $kZnTB.default).ui.repository(owner, slug)}/commits`;
        },
        rawCommit: (repositoryFullSlug, commitHash)=>{
            const [owner, slug] = repositoryFullSlug.split("/");
            return `${(0, $kZnTB.default).ui.repository(owner, slug)}/commits/${commitHash}/raw`;
        },
        unmappedCommitAuthor: (repositoryFullSlug, username)=>{
            const query = {
                username: username
            };
            return `/${repositoryFullSlug}/admin/committers?${(0, $cJH1T.stringify)(query)}`;
        }
    }
};
var $a50bd97ecfabca3f$export$2e2bcd8739ae039 = $a50bd97ecfabca3f$var$urls;

});

parcelRegister("8aZB9", function(module, exports) {

$parcel$export(module.exports, "getCommitList", function () { return $1b22d64e60620be6$export$db224d88655b63b5; });
$parcel$export(module.exports, "getCurrentCommits", function () { return $1b22d64e60620be6$export$f8522b18691538e4; });
$parcel$export(module.exports, "getCurrentPage", function () { return $1b22d64e60620be6$export$7945ba8eb1c827e6; });
$parcel$export(module.exports, "getPageLength", function () { return $1b22d64e60620be6$export$ea2a0b52df579940; });
$parcel$export(module.exports, "getCurrentCommitGraph", function () { return $1b22d64e60620be6$export$76f02cd72f79596c; });
$parcel$export(module.exports, "getStartPage", function () { return $1b22d64e60620be6$export$1529cd6f2082375f; });
$parcel$export(module.exports, "getEndPage", function () { return $1b22d64e60620be6$export$ab9dff52496ae87e; });
$parcel$export(module.exports, "getPaginationUrls", function () { return $1b22d64e60620be6$export$8d9c5611267c923a; });
$parcel$export(module.exports, "getHasNextPage", function () { return $1b22d64e60620be6$export$c2f167d5dba9e4e6; });

var $aXXtM = parcelRequire("aXXtM");

var $7qdXF = parcelRequire("7qdXF");

var $1sQZH = parcelRequire("1sQZH");
const $1b22d64e60620be6$export$db224d88655b63b5 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (repository)=>repository.commitList);
const $1b22d64e60620be6$export$c76cbc8af6040a47 = (0, $aXXtM.createSelector)($1b22d64e60620be6$export$db224d88655b63b5, (commitList)=>commitList.commits);
const $1b22d64e60620be6$export$f8522b18691538e4 = (0, $aXXtM.createSelector)($1b22d64e60620be6$export$db224d88655b63b5, (commitList)=>{
    const { commits: commits, pageLength: pageLength, currentPage: currentPage, startPage: startPage, isLoading: isLoading, isFiltering: isFiltering } = commitList;
    const previousPage = currentPage - 1;
    const nextPage = currentPage + 1;
    const showPageOnLoad = startPage < currentPage ? previousPage : nextPage;
    const currentCommitPage = isLoading && !isFiltering ? showPageOnLoad : currentPage;
    const offset = (currentCommitPage - startPage) * pageLength;
    return commits.slice(offset, offset + pageLength);
});
const $1b22d64e60620be6$export$7945ba8eb1c827e6 = (0, $aXXtM.createSelector)($1b22d64e60620be6$export$db224d88655b63b5, (commitList)=>commitList.currentPage);
const $1b22d64e60620be6$export$ea2a0b52df579940 = (0, $aXXtM.createSelector)($1b22d64e60620be6$export$db224d88655b63b5, (commitList)=>commitList.pageLength);
const $1b22d64e60620be6$export$2b0a0b25d3f2a176 = (0, $aXXtM.createSelector)($1b22d64e60620be6$export$c76cbc8af6040a47, (commits)=>(0, $1sQZH.default)(commits));
const $1b22d64e60620be6$export$76f02cd72f79596c = (0, $aXXtM.createSelector)($1b22d64e60620be6$export$db224d88655b63b5, $1b22d64e60620be6$export$2b0a0b25d3f2a176, (commitList, commitGraph)=>{
    const { pageLength: pageLength, currentPage: currentPage, startPage: startPage } = commitList;
    const offset = (currentPage - startPage) * pageLength;
    return commitGraph.slice(offset, offset + pageLength);
});
const $1b22d64e60620be6$export$1529cd6f2082375f = (0, $aXXtM.createSelector)($1b22d64e60620be6$export$db224d88655b63b5, (commitList)=>commitList.startPage);
const $1b22d64e60620be6$export$ab9dff52496ae87e = (0, $aXXtM.createSelector)($1b22d64e60620be6$export$c76cbc8af6040a47, $1b22d64e60620be6$export$1529cd6f2082375f, $1b22d64e60620be6$export$ea2a0b52df579940, (commits, startPage, pageLength)=>Math.ceil(startPage + commits.length / pageLength - 1));
const $1b22d64e60620be6$export$8d9c5611267c923a = (0, $aXXtM.createSelector)($1b22d64e60620be6$export$db224d88655b63b5, (commitList)=>commitList.paginationUrls);
const $1b22d64e60620be6$export$c2f167d5dba9e4e6 = (0, $aXXtM.createSelector)($1b22d64e60620be6$export$db224d88655b63b5, $1b22d64e60620be6$export$ab9dff52496ae87e, (commitList, endPage)=>{
    const { hasNextPage: hasNextPage, currentPage: currentPage } = commitList;
    return currentPage < endPage || hasNextPage;
});

});
parcelRegister("1sQZH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $721a21203cddc097$export$2e2bcd8739ae039; });

var $19hSN = parcelRequire("19hSN");
var $bewI9 = parcelRequire("bewI9");
var $h4SCl = parcelRequire("h4SCl");
const $721a21203cddc097$var$addNodes = (dest, source, pos)=>new Array().concat(dest.slice(0, pos), source, dest.slice(pos + 1, dest.length));
// Similar to _.invert, but accepts a transform for the value
// (_.invertBy supports transforming the key)
// @ts-ignore TODO: fix noImplicitAny error here
const $721a21203cddc097$var$invertWith = (collection, valTransform = (a)=>a)=>(0, $bewI9.default)((0, $h4SCl.default)(collection, (v, k)=>[
            v,
            valTransform(k)
        ]));
function $721a21203cddc097$export$2e2bcd8739ae039(commits) {
    let nextColor = 1;
    let columns = {};
    const colors = {};
    let seen = [];
    return commits.map(({ hash: commitHash, parents: parents = [] })=>{
        if (!seen.includes(commitHash)) {
            columns[commitHash] = seen.length;
            colors[commitHash] = nextColor++;
            seen.push(commitHash);
        }
        const column = columns[commitHash];
        const color = colors[commitHash];
        delete colors[commitHash];
        const unseenParents = parents.reduce((acc, { hash: parentHash })=>{
            if (!seen.includes(parentHash)) acc.push(parentHash);
            return acc;
        }, []);
        const next = $721a21203cddc097$var$addNodes(seen, unseenParents, column);
        columns = $721a21203cddc097$var$invertWith(next, parseInt);
        unseenParents.forEach((item, i)=>{
            if (i === 0) // First parent is the same color
            colors[item] = color;
            else colors[item] = nextColor++;
        });
        const segments = (0, $19hSN.default)(seen, (seenHash, currColumn)=>{
            if (next.includes(seenHash)) return {
                startColumn: currColumn,
                endColumn: columns[seenHash],
                color: colors[seenHash]
            };
            if (seenHash === commitHash) return parents.map(({ hash: parentHash })=>({
                    startColumn: currColumn,
                    endColumn: columns[parentHash],
                    color: colors[parentHash]
                }));
            return [];
        });
        seen = next;
        return {
            hash: commitHash,
            column: column,
            color: color,
            segments: segments
        };
    });
}

});
parcelRegister("19hSN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d6480dc09c64c1c$export$2e2bcd8739ae039; });

var $KcLis = parcelRequire("KcLis");

var $h4SCl = parcelRequire("h4SCl");
/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $0d6480dc09c64c1c$var$flatMap(collection, iteratee) {
    return (0, $KcLis.default)((0, $h4SCl.default)(collection, iteratee), 1);
}
var $0d6480dc09c64c1c$export$2e2bcd8739ae039 = $0d6480dc09c64c1c$var$flatMap;

});
parcelRegister("h4SCl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6ed2d44c6ecd5d5$export$2e2bcd8739ae039; });

var $6t2MQ = parcelRequire("6t2MQ");

var $dfCpC = parcelRequire("dfCpC");

var $1cfcx = parcelRequire("1cfcx");

var $dEaOb = parcelRequire("dEaOb");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $c6ed2d44c6ecd5d5$var$map(collection, iteratee) {
    var func = (0, $dEaOb.default)(collection) ? (0, $6t2MQ.default) : (0, $1cfcx.default);
    return func(collection, (0, $dfCpC.default)(iteratee, 3));
}
var $c6ed2d44c6ecd5d5$export$2e2bcd8739ae039 = $c6ed2d44c6ecd5d5$var$map;

});
parcelRegister("dfCpC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a5a78f1f259e60f$export$2e2bcd8739ae039; });

var $eBesX = parcelRequire("eBesX");

var $gHoL5 = parcelRequire("gHoL5");

var $1P6AC = parcelRequire("1P6AC");

var $dEaOb = parcelRequire("dEaOb");

var $kIkEv = parcelRequire("kIkEv");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $9a5a78f1f259e60f$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return 0, $1P6AC.default;
    if (typeof value == "object") return (0, $dEaOb.default)(value) ? (0, $gHoL5.default)(value[0], value[1]) : (0, $eBesX.default)(value);
    return (0, $kIkEv.default)(value);
}
var $9a5a78f1f259e60f$export$2e2bcd8739ae039 = $9a5a78f1f259e60f$var$baseIteratee;

});
parcelRegister("eBesX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa0fbe06dfd3d7bc$export$2e2bcd8739ae039; });

var $3D9Ql = parcelRequire("3D9Ql");

var $iiqcg = parcelRequire("iiqcg");

var $aTvPs = parcelRequire("aTvPs");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $aa0fbe06dfd3d7bc$var$baseMatches(source) {
    var matchData = (0, $iiqcg.default)(source);
    if (matchData.length == 1 && matchData[0][2]) return (0, $aTvPs.default)(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || (0, $3D9Ql.default)(object, source, matchData);
    };
}
var $aa0fbe06dfd3d7bc$export$2e2bcd8739ae039 = $aa0fbe06dfd3d7bc$var$baseMatches;

});
parcelRegister("3D9Ql", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a4ca64e80158e82$export$2e2bcd8739ae039; });

var $9FAVP = parcelRequire("9FAVP");

var $7bH8v = parcelRequire("7bH8v");
/** Used to compose bitmasks for value comparisons. */ var $2a4ca64e80158e82$var$COMPARE_PARTIAL_FLAG = 1, $2a4ca64e80158e82$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $2a4ca64e80158e82$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new (0, $9FAVP.default);
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? (0, $7bH8v.default)(srcValue, objValue, $2a4ca64e80158e82$var$COMPARE_PARTIAL_FLAG | $2a4ca64e80158e82$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
var $2a4ca64e80158e82$export$2e2bcd8739ae039 = $2a4ca64e80158e82$var$baseIsMatch;

});

parcelRegister("iiqcg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d51e3a9655b0f4ad$export$2e2bcd8739ae039; });

var $2IzBO = parcelRequire("2IzBO");

var $d3taP = parcelRequire("d3taP");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $d51e3a9655b0f4ad$var$getMatchData(object) {
    var result = (0, $d3taP.default)(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            (0, $2IzBO.default)(value)
        ];
    }
    return result;
}
var $d51e3a9655b0f4ad$export$2e2bcd8739ae039 = $d51e3a9655b0f4ad$var$getMatchData;

});
parcelRegister("2IzBO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fab4ffcf425eeb8$export$2e2bcd8739ae039; });

var $bmzpf = parcelRequire("bmzpf");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $1fab4ffcf425eeb8$var$isStrictComparable(value) {
    return value === value && !(0, $bmzpf.default)(value);
}
var $1fab4ffcf425eeb8$export$2e2bcd8739ae039 = $1fab4ffcf425eeb8$var$isStrictComparable;

});


parcelRegister("aTvPs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ee7bafb575d0fb4$export$2e2bcd8739ae039; });
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $7ee7bafb575d0fb4$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
var $7ee7bafb575d0fb4$export$2e2bcd8739ae039 = $7ee7bafb575d0fb4$var$matchesStrictComparable;

});


parcelRegister("gHoL5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c283ddff338210bd$export$2e2bcd8739ae039; });

var $7bH8v = parcelRequire("7bH8v");

var $lIZwG = parcelRequire("lIZwG");

var $eLIr4 = parcelRequire("eLIr4");

var $i4K6A = parcelRequire("i4K6A");

var $2IzBO = parcelRequire("2IzBO");

var $aTvPs = parcelRequire("aTvPs");

var $bZfWj = parcelRequire("bZfWj");
/** Used to compose bitmasks for value comparisons. */ var $c283ddff338210bd$var$COMPARE_PARTIAL_FLAG = 1, $c283ddff338210bd$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $c283ddff338210bd$var$baseMatchesProperty(path, srcValue) {
    if ((0, $i4K6A.default)(path) && (0, $2IzBO.default)(srcValue)) return (0, $aTvPs.default)((0, $bZfWj.default)(path), srcValue);
    return function(object) {
        var objValue = (0, $lIZwG.default)(object, path);
        return objValue === undefined && objValue === srcValue ? (0, $eLIr4.default)(object, path) : (0, $7bH8v.default)(srcValue, objValue, $c283ddff338210bd$var$COMPARE_PARTIAL_FLAG | $c283ddff338210bd$var$COMPARE_UNORDERED_FLAG);
    };
}
var $c283ddff338210bd$export$2e2bcd8739ae039 = $c283ddff338210bd$var$baseMatchesProperty;

});
parcelRegister("eLIr4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac07ec75dfbf2e5f$export$2e2bcd8739ae039; });

var $h61ZH = parcelRequire("h61ZH");

var $9hKro = parcelRequire("9hKro");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $ac07ec75dfbf2e5f$var$hasIn(object, path) {
    return object != null && (0, $9hKro.default)(object, path, (0, $h61ZH.default));
}
var $ac07ec75dfbf2e5f$export$2e2bcd8739ae039 = $ac07ec75dfbf2e5f$var$hasIn;

});
parcelRegister("h61ZH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7248b345464e756$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $c7248b345464e756$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
var $c7248b345464e756$export$2e2bcd8739ae039 = $c7248b345464e756$var$baseHasIn;

});

parcelRegister("9hKro", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c29b9c5eb8a20b9$export$2e2bcd8739ae039; });

var $8AUEA = parcelRequire("8AUEA");

var $01Qmm = parcelRequire("01Qmm");

var $dEaOb = parcelRequire("dEaOb");

var $2CjdF = parcelRequire("2CjdF");

var $4xcMZ = parcelRequire("4xcMZ");

var $bZfWj = parcelRequire("bZfWj");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $6c29b9c5eb8a20b9$var$hasPath(object, path, hasFunc) {
    path = (0, $8AUEA.default)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, $bZfWj.default)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, $4xcMZ.default)(length) && (0, $2CjdF.default)(key, length) && ((0, $dEaOb.default)(object) || (0, $01Qmm.default)(object));
}
var $6c29b9c5eb8a20b9$export$2e2bcd8739ae039 = $6c29b9c5eb8a20b9$var$hasPath;

});



parcelRegister("1P6AC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $153faa73e7089992$export$2e2bcd8739ae039; });
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $153faa73e7089992$var$identity(value) {
    return value;
}
var $153faa73e7089992$export$2e2bcd8739ae039 = $153faa73e7089992$var$identity;

});

parcelRegister("kIkEv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f147efd48223071c$export$2e2bcd8739ae039; });

var $7piPG = parcelRequire("7piPG");

var $f8A7Y = parcelRequire("f8A7Y");

var $i4K6A = parcelRequire("i4K6A");

var $bZfWj = parcelRequire("bZfWj");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $f147efd48223071c$var$property(path) {
    return (0, $i4K6A.default)(path) ? (0, $7piPG.default)((0, $bZfWj.default)(path)) : (0, $f8A7Y.default)(path);
}
var $f147efd48223071c$export$2e2bcd8739ae039 = $f147efd48223071c$var$property;

});
parcelRegister("7piPG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $564979fa6e37a322$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $564979fa6e37a322$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
var $564979fa6e37a322$export$2e2bcd8739ae039 = $564979fa6e37a322$var$baseProperty;

});

parcelRegister("f8A7Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b053a09583e0148f$export$2e2bcd8739ae039; });

var $fVuMG = parcelRequire("fVuMG");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $b053a09583e0148f$var$basePropertyDeep(path) {
    return function(object) {
        return (0, $fVuMG.default)(object, path);
    };
}
var $b053a09583e0148f$export$2e2bcd8739ae039 = $b053a09583e0148f$var$basePropertyDeep;

});



parcelRegister("1cfcx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0df2b416f26f4b25$export$2e2bcd8739ae039; });

var $9IXdN = parcelRequire("9IXdN");

var $l3LBL = parcelRequire("l3LBL");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $0df2b416f26f4b25$var$baseMap(collection, iteratee) {
    var index = -1, result = (0, $l3LBL.default)(collection) ? Array(collection.length) : [];
    (0, $9IXdN.default)(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
var $0df2b416f26f4b25$export$2e2bcd8739ae039 = $0df2b416f26f4b25$var$baseMap;

});
parcelRegister("9IXdN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $714629481b411de7$export$2e2bcd8739ae039; });

var $faUtL = parcelRequire("faUtL");

var $860yB = parcelRequire("860yB");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $714629481b411de7$var$baseEach = (0, $860yB.default)((0, $faUtL.default));
var $714629481b411de7$export$2e2bcd8739ae039 = $714629481b411de7$var$baseEach;

});
parcelRegister("faUtL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0c399c55a6bcb29$export$2e2bcd8739ae039; });

var $eIeLQ = parcelRequire("eIeLQ");

var $d3taP = parcelRequire("d3taP");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $b0c399c55a6bcb29$var$baseForOwn(object, iteratee) {
    return object && (0, $eIeLQ.default)(object, iteratee, (0, $d3taP.default));
}
var $b0c399c55a6bcb29$export$2e2bcd8739ae039 = $b0c399c55a6bcb29$var$baseForOwn;

});
parcelRegister("eIeLQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab60a1e3ae4093b5$export$2e2bcd8739ae039; });

var $ahj65 = parcelRequire("ahj65");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $ab60a1e3ae4093b5$var$baseFor = (0, $ahj65.default)();
var $ab60a1e3ae4093b5$export$2e2bcd8739ae039 = $ab60a1e3ae4093b5$var$baseFor;

});
parcelRegister("ahj65", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77ba4e374cd94f4d$export$2e2bcd8739ae039; });
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $77ba4e374cd94f4d$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $77ba4e374cd94f4d$export$2e2bcd8739ae039 = $77ba4e374cd94f4d$var$createBaseFor;

});



parcelRegister("860yB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e4f50e6558263e0$export$2e2bcd8739ae039; });

var $l3LBL = parcelRequire("l3LBL");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $5e4f50e6558263e0$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!(0, $l3LBL.default)(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
var $5e4f50e6558263e0$export$2e2bcd8739ae039 = $5e4f50e6558263e0$var$createBaseEach;

});





parcelRegister("bewI9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82da6048d128d0aa$export$2e2bcd8739ae039; });
/**
 * The inverse of `_.toPairs`; this method returns an object composed
 * from key-value `pairs`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} pairs The key-value pairs.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.fromPairs([['a', 1], ['b', 2]]);
 * // => { 'a': 1, 'b': 2 }
 */ function $82da6048d128d0aa$var$fromPairs(pairs) {
    var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
    while(++index < length){
        var pair = pairs[index];
        result[pair[0]] = pair[1];
    }
    return result;
}
var $82da6048d128d0aa$export$2e2bcd8739ae039 = $82da6048d128d0aa$var$fromPairs;

});







parcelRegister("5Hpkc", function(module, exports) {

$parcel$export(module.exports, "loadPullRequestResource", function () { return $17b45f740a89d271$export$994bb1500bb76e95; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $lj5Bi = parcelRequire("lj5Bi");
parcelRequire("5YpaN");
var $fICwP = parcelRequire("fICwP");
var $kTw57 = parcelRequire("kTw57");

var $bGUx6 = parcelRequire("bGUx6");

var $677Fr = parcelRequire("677Fr");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");

var $kZnTB = parcelRequire("kZnTB");

var $3nrvH = parcelRequire("3nrvH");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $aqJ0c = parcelRequire("aqJ0c");

var $66z6m = parcelRequire("66z6m");

var $b2RHC = parcelRequire("b2RHC");

var $1EkdU = parcelRequire("1EkdU");

var $czBtW = parcelRequire("czBtW");
const $17b45f740a89d271$export$1baffc647ff9fb67 = "repository.pullRequest";
const $17b45f740a89d271$export$40666f0a17798bb7 = {
    isDiffsLoading: true,
    isDiffStatLoading: true
};
const $17b45f740a89d271$export$a9db49351e770479 = (payload)=>{
    if (!(0, $677Fr.hasTransitioned)()) return {
        ...payload,
        lastPoll: (0, $66z6m.makeBackbucketSafeNow)()
    };
    return {
        ...payload,
        lastPoll: (0, $66z6m.makeBackbucketSafeNow)()
    };
};
const $17b45f740a89d271$var$loadPullRequest = async (owner, slug, id, { reduxStore: reduxStore, csrftoken: csrftoken })=>{
    const { dispatch: dispatch } = reduxStore;
    const hydratedPRdata = (0, $3nrvH.getStateFromKey)((0, $lj5Bi.default), $17b45f740a89d271$export$1baffc647ff9fb67).data || undefined;
    const requestUrl = (0, $czBtW.default).ui.pullrequestdata(owner, slug, Number(id));
    const resourceMetadata = {
        isRouterResource: true,
        url: requestUrl,
        csrftoken: csrftoken,
        schema: {
            currentPullRequest: (0, $b2RHC.pullRequest),
            commits: [
                (0, $b2RHC.commit)
            ]
        }
    };
    const action = (0, $fICwP.fetchAction)((0, $6D21P.LOAD_PULL_REQUEST), resourceMetadata);
    if (hydratedPRdata) {
        action.type = (0, $6D21P.LOAD_PULL_REQUEST).SUCCESS;
        action.payload = {
            ...hydratedPRdata,
            ...$17b45f740a89d271$export$40666f0a17798bb7,
            lastPoll: (0, $66z6m.makeBackbucketSafeNow)()
        };
        return dispatch(action);
    } else {
        dispatch(action);
        const result = await dispatch((0, $kTw57.fetchData)(action, $17b45f740a89d271$export$a9db49351e770479));
        if ((result === null || result === void 0 ? void 0 : result.type) === (0, $6D21P.LOAD_PULL_REQUEST).ERROR) return null;
        return result;
    }
};
const $17b45f740a89d271$var$fetchMergeChecks = async (owner, slug, id, { reduxStore: reduxStore, csrftoken: csrftoken })=>{
    const { dispatch: dispatch } = reduxStore;
    const mergeCheckUrl = (0, $czBtW.default).api.internal.mergeChecks(owner, slug, id);
    const action = (0, $fICwP.fetchAction)((0, $6D21P.FETCH_MERGE_CHECKS), {
        url: mergeCheckUrl,
        isRouterResource: true,
        csrftoken: csrftoken
    });
    dispatch(action);
    const result = await dispatch((0, $kTw57.fetchData)(action, (0, $bGUx6.mergeCheckPayloadTransformer)));
    if ((result === null || result === void 0 ? void 0 : result.type) === (0, $6D21P.FETCH_MERGE_CHECKS).ERROR) return null;
    return result;
};
const $17b45f740a89d271$var$fetchSourceRepositoryDetails = async ({ reduxStore: reduxStore, csrftoken: csrftoken })=>{
    const { dispatch: dispatch, getState: getState } = reduxStore;
    const state = getState();
    const sourceRepository = (0, $1EkdU.getPullRequestSourceRepo)(state);
    const destinationRepository = (0, $1EkdU.getPullRequestDestinationRepo)(state);
    if (!!sourceRepository && !!destinationRepository && !!sourceRepository.full_name && sourceRepository.full_name !== destinationRepository.full_name) {
        const baseUrl = (0, $kZnTB.default).api.internal.details(sourceRepository.full_name);
        const action = (0, $fICwP.fetchAction)((0, $jJd6W.FetchSourceRepositoryDetails), {
            url: `${baseUrl}?${(0, $aqJ0c.fetchSourceRepositoryDetailsQuery)}`,
            isRouterResource: true,
            csrftoken: csrftoken
        });
        dispatch(action);
        const result = await dispatch((0, $kTw57.fetchData)(action));
        if ((result === null || result === void 0 ? void 0 : result.type) === (0, $jJd6W.FetchSourceRepositoryDetails).SUCCESS) return result;
    }
    return null;
};
const $17b45f740a89d271$export$994bb1500bb76e95 = (0, $3kfkg.createResource)({
    type: "pullrequest",
    getKey: (routerStoreContext)=>{
        const { pullRequestId: id, repositoryOwner: owner, repositorySlug: slug } = routerStoreContext.match.params;
        return `${owner}/${slug}/${id}`;
    },
    // We can't cache this data yet since it's set in redux. When we leave the
    // page we call UNLOAD_PULL_REQUEST which removes some of the data. If we
    // come back to the same PR (where getKey() would return the same value),
    // then getData() won't be called and there won't be any data in redux. We
    // get an infinite spinner.
    maxAge: 0,
    getData: async (routerStoreContext, { reduxStore: reduxStore, csrftoken: csrftoken })=>{
        const { dispatch: dispatch } = reduxStore;
        const { pullRequestId: id, repositoryOwner: owner, repositorySlug: slug } = routerStoreContext.match.params;
        if (!id || !owner || !slug) {
            dispatch({
                type: (0, $6D21P.LOAD_PULL_REQUEST).ERROR,
                payload: "Loading Pull Request failed due to missing parameters"
            });
            throw new Error("Loading Pull Request failed due to missing parameters");
        }
        const results = await Promise.all([
            $17b45f740a89d271$var$loadPullRequest(owner, slug, id, {
                reduxStore: reduxStore,
                csrftoken: csrftoken
            }),
            $17b45f740a89d271$var$fetchMergeChecks(owner, slug, id, {
                reduxStore: reduxStore,
                csrftoken: csrftoken
            })
        ]);
        // FetchSourceRepositoryDetails need pull request data.
        await $17b45f740a89d271$var$fetchSourceRepositoryDetails({
            reduxStore: reduxStore,
            csrftoken: csrftoken
        });
        // check that we got a result for every request, otherwise fall back to client-side render
        if (!results.every((r)=>r)) return null;
        return {
            status: "success"
        };
    }
});

});
parcelRegister("bGUx6", function(module, exports) {

$parcel$export(module.exports, "mergeCheckPayloadTransformer", function () { return $20cb89ad3874e983$export$f86b2e50224b4374; });

var $dRthA = parcelRequire("dRthA");
const $20cb89ad3874e983$export$f86b2e50224b4374 = (payload)=>{
    const { restrictions: restrictions, can_merge: isMergeable, is_mergable_by_current_user: canCurrentUserMerge = (0, $dRthA.initialState).canCurrentUserMerge, is_missing_commits: isMissingCommits = (0, $dRthA.initialState).isMissingCommits, retriction_source: mergeChecksSource } = payload;
    return {
        mergeChecks: Object.values(restrictions).filter((mergeCheck)=>!!mergeCheck.label),
        isMergeable: isMergeable,
        canCurrentUserMerge: canCurrentUserMerge,
        isMissingCommits: isMissingCommits,
        mergeChecksSource: mergeChecksSource
    };
};

});
parcelRegister("dRthA", function(module, exports) {

$parcel$export(module.exports, "initialState", function () { return $f091289952aa4865$export$d4c72bab9d6cc13a; });
$parcel$export(module.exports, "pullRequestReducer", function () { return $f091289952aa4865$export$6b213852eb777b71; });
parcelRequire("hfhvV");
var $9kTpj = parcelRequire("9kTpj");

var $xz4dB = parcelRequire("xz4dB");

var $90kWr = parcelRequire("90kWr");

var $i2O3k = parcelRequire("i2O3k");

var $dkkN8 = parcelRequire("dkkN8");

var $7wUuE = parcelRequire("7wUuE");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");

var $iHsg5 = parcelRequire("iHsg5");

var $gsXeO = parcelRequire("gsXeO");

var $4coax = parcelRequire("4coax");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");
var $dkXlf = parcelRequire("dkXlf");

var $14kRW = parcelRequire("14kRW");

var $ha5uu = parcelRequire("ha5uu");

var $2WdMK = parcelRequire("2WdMK");

var $k6zif = parcelRequire("k6zif");

var $5gbji = parcelRequire("5gbji");

var $5uWUR = parcelRequire("5uWUR");

var $Sv3E7 = parcelRequire("Sv3E7");

var $8mswv = parcelRequire("8mswv");
const $f091289952aa4865$export$d4c72bab9d6cc13a = {
    activeDiff: "",
    activity: (0, $14kRW.activityInitialState),
    activePermalink: "",
    annotations: undefined,
    contextLines: {},
    diffsExpansionState: {},
    sideBySideDiffState: {},
    isMergeable: false,
    conflicts: [],
    currentPullRequest: null,
    decline: (0, $ha5uu.declineInitialState),
    defaultMergeStrategy: null,
    diff: [],
    diffCommentingMap: {},
    diffStat: undefined,
    error: false,
    errorMessage: "",
    imageUpload: (0, $2WdMK.imageUploadInitialState),
    isRequestingChangesDisabled: false,
    isRequestingChangesError: false,
    isRequestingChangesPending: false,
    isDiffsLoading: false,
    isDiffStatLoading: false,
    isErrorDialogOpen: false,
    isLoadingOutdatedCommentContext: false,
    isLoadingBaseRevCommentContext: false,
    isLoadingAllChangesCommentContext: false,
    isLoadingPendingCommentContext: false,
    isMergeChecksLoading: false,
    isOutdatedDialogOpen: false,
    isReviewDraftDialogOpen: false,
    isDiffCommentsDialogOpen: false,
    isSingleFileMode: false,
    isSingleFileModeEligible: false,
    isSingleFileModeSettingsHeaderVisible: true,
    isStickyHeaderActive: false,
    isNonRenderedDiffCommentsDialogOpen: false,
    isWatching: false,
    lastPullRequestRetrieved: null,
    merge: (0, $k6zif.mergeInitialState),
    mergeInProgress: null,
    mergeChecks: [],
    mergeChecksError: "",
    mergeChecksSource: "",
    outdatedCommentsDialog: undefined,
    baseRevCommentsDialog: undefined,
    polling: (0, $5gbji.initialState),
    rawComments: [],
    commentsLoadingStatus: (0, $90kWr.LoadingStatus).Before,
    tasks: (0, $5uWUR.initialState),
    watchActionLoading: true,
    isCommentsFilterActive: false,
    filterCommentsByUser: null,
    diffErrorCode: null,
    diffStatErrorCode: null,
    diffStatErrorKey: null,
    isEditorOpen: false,
    isRevertDialogOpen: false,
    revertError: null,
    diffSort: "fileTree",
    hiddenFileDialogAnchor: null,
    renderingLimits: null,
    codeInsightsAnnotations: {},
    isCodeInsightsAnnotationsLoading: false,
    hasDestinationBranch: true,
    sourceRepository: (0, $iHsg5.initialStateSourceRepository),
    sourceBranchDetails: undefined,
    canCurrentUserMerge: false,
    viewEntireFile: (0, $8mswv.viewEntireFileInitialState),
    hiddenAnnotations: [],
    hiddenDiffComments: [],
    highlightedCommentId: null,
    highlightCommentThread: null,
    isSettingsChangeboardingDialogOpen: true,
    sidebarCardCollapsed: {},
    isPullRequestTitleUpdatePending: false,
    isPullRequestDescriptionUpdatePending: false,
    isPullRequestRemoveReviewerPending: false,
    pullRequestAddReviewerPendingAaids: [],
    isMissingCommits: false,
    isUpdatingCommits: false,
    hasMissingCommitsError: false,
    refetchBuildsDummy: false,
    mergeMessageMaxSizeBytes: undefined,
    iterativeReview: {
        isIterativeReviewComplete: false
    },
    refetchIRDiffDummy: false
};
function $f091289952aa4865$var$updateFilterCommentsByUser(state, action) {
    const updatedId = action.payload;
    // deselect filter if it's the same
    if (state.isCommentsFilterActive && updatedId === state.filterCommentsByUser) return {
        ...state,
        isCommentsFilterActive: false,
        filterCommentsByUser: null
    };
    return {
        ...state,
        isCommentsFilterActive: true,
        filterCommentsByUser: updatedId
    };
}
function $f091289952aa4865$var$changeDiffSort(state, action) {
    return {
        ...state,
        diffSort: action.payload
    };
}
function $f091289952aa4865$var$mergeContextLines(state, action) {
    const { payload: convos } = action;
    const newContextLines = {
        ...state.contextLines
    };
    if (convos) // We map each context lines value to its convo id, overriding any old values
    convos.forEach((convo)=>{
        newContextLines[convo.conversationId] = convo.meta.context_lines;
    });
    return {
        ...state,
        contextLines: newContextLines,
        isLoadingOutdatedCommentContext: action.type === $6D21P.FETCH_OUTDATED_COMMENT_CONTEXT.SUCCESS ? false : state.isLoadingOutdatedCommentContext,
        isLoadingPendingCommentContext: action.type === $6D21P.FETCH_PENDING_COMMENT_CONTEXT.SUCCESS ? false : state.isLoadingPendingCommentContext,
        isLoadingBaseRevCommentContext: action.type === $6D21P.FETCH_BASE_REV_COMMENT_CONTEXT.SUCCESS ? false : state.isLoadingBaseRevCommentContext,
        isLoadingAllChangesCommentContext: action.type === $6D21P.FETCH_ALL_CHANGES_COMMENT_CONTEXT.SUCCESS ? false : state.isLoadingAllChangesCommentContext
    };
}
const $f091289952aa4865$export$6b213852eb777b71 = (0, $gsXeO.default)($f091289952aa4865$export$d4c72bab9d6cc13a, {
    [$6D21P.FETCH_CONFLICTS.SUCCESS] (state, action) {
        return {
            ...state,
            conflicts: action.payload
        };
    },
    [$6D21P.FETCH_MERGE_CHECKS.REQUEST] (state) {
        return {
            ...state,
            isMergeChecksLoading: true,
            isMergeable: false
        };
    },
    [$6D21P.FETCH_MERGE_CHECKS.SUCCESS] (state, action) {
        const { mergeChecks: mergeChecks, isMergeable: isMergeable, canCurrentUserMerge: canCurrentUserMerge, isMissingCommits: isMissingCommits, mergeChecksSource: mergeChecksSource } = action.payload;
        return {
            ...state,
            isMergeChecksLoading: false,
            mergeChecks: mergeChecks,
            isMergeable: isMergeable,
            canCurrentUserMerge: canCurrentUserMerge,
            isMissingCommits: isMissingCommits,
            mergeChecksError: $f091289952aa4865$export$d4c72bab9d6cc13a.mergeChecksError,
            mergeChecksSource: mergeChecksSource
        };
    },
    [$6D21P.FETCH_MERGE_CHECKS.ERROR] (state, action) {
        return {
            ...state,
            mergeChecksError: action.payload,
            isMergeChecksLoading: false
        };
    },
    [$6D21P.FETCH_MERGE_CHECKS_RETRY] (state) {
        return {
            ...state,
            isMergeChecksLoading: true
        };
    },
    [$6D21P.LOAD_PULL_REQUEST.SUCCESS] (state, action) {
        const { result: result } = action.payload;
        return {
            ...state,
            ...result,
            lastPullRequestRetrieved: Date.now()
        };
    },
    [$6D21P.UNLOAD_PULL_REQUEST] (state) {
        const { contextLines: contextLines, currentPullRequest: currentPullRequest, diff: diff, diffStat: diffStat, rawComments: rawComments, codeInsightsReports: codeInsightsReports, annotations: annotations, isCommentsFilterActive: isCommentsFilterActive, filterCommentsByUser: filterCommentsByUser, diffSort: diffSort, highlightedCommentId: highlightedCommentId, highlightCommentThread: highlightCommentThread, isOutdatedDialogOpen: isOutdatedDialogOpen, outdatedCommentsDialog: outdatedCommentsDialog, diffErrorCode: diffErrorCode, diffStatErrorCode: diffStatErrorCode, diffStatErrorKey: diffStatErrorKey } = $f091289952aa4865$export$d4c72bab9d6cc13a;
        return {
            ...state,
            contextLines: contextLines,
            diff: diff,
            diffStat: diffStat,
            currentPullRequest: currentPullRequest,
            rawComments: rawComments,
            codeInsightsReports: codeInsightsReports,
            annotations: annotations,
            isCommentsFilterActive: isCommentsFilterActive,
            filterCommentsByUser: filterCommentsByUser,
            diffSort: diffSort,
            highlightedCommentId: highlightedCommentId,
            highlightCommentThread: highlightCommentThread,
            isOutdatedDialogOpen: isOutdatedDialogOpen,
            outdatedCommentsDialog: outdatedCommentsDialog,
            diffErrorCode: diffErrorCode,
            diffStatErrorCode: diffStatErrorCode,
            diffStatErrorKey: diffStatErrorKey
        };
    },
    [$6D21P.CLEAR_IN_PROGRESS_MERGE_TASK] (state, _action) {
        return {
            ...state,
            mergeInProgress: null
        };
    },
    [$6D21P.UPDATE_PARTICIPANTS.SUCCESS] (state, action) {
        return {
            ...state,
            currentPullRequest: action.payload.result.currentPullRequest
        };
    },
    [$6D21P.UPDATE_TITLE.REQUEST] (state) {
        return {
            ...state,
            isPullRequestTitleUpdatePending: true
        };
    },
    [$6D21P.UPDATE_TITLE.ERROR] (state) {
        return {
            ...state,
            isPullRequestTitleUpdatePending: false
        };
    },
    [$6D21P.UPDATE_TITLE.SUCCESS] (state, action) {
        return {
            ...state,
            isPullRequestTitleUpdatePending: false,
            currentPullRequest: action.payload.result.currentPullRequest
        };
    },
    [$6D21P.UPDATE_DESCRIPTION.REQUEST] (state) {
        return {
            ...state,
            isPullRequestDescriptionUpdatePending: true
        };
    },
    [$6D21P.UPDATE_DESCRIPTION.ERROR] (state) {
        return {
            ...state,
            isPullRequestDescriptionUpdatePending: false
        };
    },
    [$6D21P.UPDATE_DESCRIPTION.SUCCESS] (state, action) {
        return {
            ...state,
            isPullRequestDescriptionUpdatePending: false,
            currentPullRequest: action.payload.result.currentPullRequest
        };
    },
    [$6D21P.REMOVE_REVIEWER.REQUEST] (state) {
        return {
            ...state,
            isPullRequestRemoveReviewerPending: true
        };
    },
    [$6D21P.REMOVE_REVIEWER.ERROR] (state) {
        return {
            ...state,
            isPullRequestRemoveReviewerPending: false
        };
    },
    [$6D21P.REMOVE_REVIEWER.SUCCESS] (state, action) {
        return {
            ...state,
            isPullRequestRemoveReviewerPending: false,
            currentPullRequest: action.payload.result.currentPullRequest
        };
    },
    [$6D21P.ADD_REVIEWER.REQUEST] (state, action) {
        return {
            ...state,
            pullRequestAddReviewerPendingAaids: [
                ...state.pullRequestAddReviewerPendingAaids,
                ...action.payload.userAaid ? [
                    action.payload.userAaid
                ] : []
            ]
        };
    },
    [$6D21P.ADD_REVIEWER.ERROR] (state, action) {
        return {
            ...state,
            pullRequestAddReviewerPendingAaids: state.pullRequestAddReviewerPendingAaids.filter((id)=>id !== action.payload.userAaid)
        };
    },
    [$6D21P.ADD_REVIEWER.SUCCESS] (state, action) {
        return {
            ...state,
            pullRequestAddReviewerPendingAaids: state.pullRequestAddReviewerPendingAaids.filter((id)=>id !== action.payload.result.userAaid),
            currentPullRequest: action.payload.result.currentPullRequest
        };
    },
    [$6D21P.FETCH_DIFF_FILE] (state, action) {
        const { payload: diff } = action;
        return {
            ...state,
            diff: state.diff.concat(diff),
            isDiffsLoading: false,
            diffErrorCode: null
        };
    },
    [$6D21P.FETCH_DIFF.REQUEST] (state) {
        return {
            ...state,
            isDiffsLoading: true
        };
    },
    [$6D21P.FETCH_DIFF.SUCCESS] (state, action) {
        const { payload: diff } = action;
        return {
            ...state,
            diff: diff,
            isDiffsLoading: false,
            diffErrorCode: null
        };
    },
    [$6D21P.FETCH_DIFF.ERROR] (state, action) {
        const { payload: diffErrorCode } = action;
        return {
            ...state,
            isDiffsLoading: false,
            diffErrorCode: diffErrorCode
        };
    },
    [$6D21P.FETCH_PULL_REQUEST_ANNOTATIONS.SUCCESS] (state, action) {
        const { payload: annotations } = action;
        return {
            ...state,
            annotations: annotations
        };
    },
    [$6D21P.FETCH_CODE_INSIGHTS_REPORTS.REQUEST] (state) {
        return {
            ...state,
            isCodeInsightsReportsLoading: true
        };
    },
    [$6D21P.FETCH_CODE_INSIGHTS_REPORTS.ERROR] (state) {
        return {
            ...state,
            isCodeInsightsReportsLoading: false,
            hasCodeInsightsReportsError: true
        };
    },
    [$6D21P.FETCH_CODE_INSIGHTS_REPORTS.SUCCESS] (state, action) {
        const { payload: codeInsightsReports } = action;
        return {
            ...state,
            isCodeInsightsReportsLoading: false,
            codeInsightsReports: codeInsightsReports
        };
    },
    [$6D21P.FETCH_CODE_INSIGHTS_ANNOTATIONS.REQUEST] (state) {
        return {
            ...state,
            isCodeInsightsAnnotationsLoading: true
        };
    },
    [$6D21P.FETCH_CODE_INSIGHTS_ANNOTATIONS.ERROR] (state) {
        return {
            ...state,
            isCodeInsightsAnnotationsLoading: false
        };
    },
    [$6D21P.FETCH_CODE_INSIGHTS_ANNOTATIONS.SUCCESS] (state, action) {
        return {
            ...state,
            isCodeInsightsAnnotationsLoading: false,
            codeInsightsAnnotations: {
                ...state.codeInsightsAnnotations || {},
                ...action.meta && action.meta.reportId ? {
                    [action.meta.reportId]: action.payload
                } : {}
            }
        };
    },
    [$6D21P.TOGGLE_ANNOTATIONS] (state, action) {
        return {
            ...state,
            hiddenAnnotations: state.hiddenAnnotations.includes(action.payload) ? state.hiddenAnnotations.filter((annotation)=>annotation !== action.payload) : state.hiddenAnnotations.concat(action.payload)
        };
    },
    [$6D21P.TOGGLE_DIFF_COMMENTS] (state, action) {
        return {
            ...state,
            hiddenDiffComments: state.hiddenDiffComments.includes(action.payload) ? state.hiddenDiffComments.filter((filepath)=>filepath !== action.payload) : state.hiddenDiffComments.concat(action.payload)
        };
    },
    [$6D21P.FETCH_COMMENT_CONTEXT.SUCCESS] (state, action) {
        const { newChunk: newChunk, path: path } = action.payload;
        const { diff: diff } = state;
        const targetDiff = diff.find((currentDiff)=>currentDiff.to === path || currentDiff.to === null && currentDiff.from === path);
        if (!targetDiff) return state;
        const updatedDiff = {
            ...targetDiff,
            chunks: (0, $7wUuE.reconcileChunks)([
                newChunk,
                ...targetDiff.chunks
            ])
        };
        return {
            ...state,
            diff: [
                ...diff.slice(0, diff.indexOf(targetDiff)),
                updatedDiff,
                ...diff.slice(diff.indexOf(targetDiff) + 1)
            ]
        };
    },
    [$6D21P.EXPAND_CONTEXT.SUCCESS] (state, action) {
        const { fileIndex: fileIndex, chunkId: chunkId, beforeOrAfter: beforeOrAfter, contextLines: contextLines, hasMoreLines: hasMoreLines } = action.payload;
        const { diff: diff } = state;
        const newDiff = [
            ...diff
        ];
        const newFile = {
            ...diff[fileIndex]
        };
        newFile.chunks = (0, $Sv3E7.mergeContextLinesWithChunks)(diff[fileIndex].chunks, chunkId, contextLines, beforeOrAfter, hasMoreLines);
        newDiff[fileIndex] = newFile;
        return {
            ...state,
            diff: newDiff
        };
    },
    [$6D21P.EXPAND_CONTEXT.ERROR] (state, action) {
        const { fileIndex: fileIndex } = action.payload;
        const { diff: diff } = state;
        const newDiff = [
            ...diff
        ];
        for(let i = 0; i < newDiff[fileIndex].chunks.length; i++){
            const chunk = newDiff[fileIndex].chunks[i];
            chunk.extra.isLoadingAbove = false;
            chunk.extra.isLoadingBelow = false;
        }
        return {
            ...state,
            diff: newDiff
        };
    },
    [$6D21P.REQUEST_CHANGES.REQUEST] (state) {
        return {
            ...state,
            isRequestingChangesDisabled: true,
            isRequestingChangesPending: true
        };
    },
    [$6D21P.REQUEST_CHANGES.SUCCESS] (state) {
        return {
            ...state,
            errorMessage: "",
            isRequestingChangesDisabled: false,
            isRequestingChangesError: false,
            isRequestingChangesPending: false
        };
    },
    [$6D21P.REQUEST_CHANGES.ERROR] (state, action) {
        return {
            ...state,
            errorMessage: action.payload,
            isRequestingChangesDisabled: false,
            isRequestingChangesError: true,
            isRequestingChangesPending: false,
            isErrorDialogOpen: true
        };
    },
    [$6D21P.UNDO_REQUEST_CHANGES.REQUEST] (state) {
        return {
            ...state,
            isRequestingChangesDisabled: true,
            isRequestingChangesPending: true
        };
    },
    [$6D21P.UNDO_REQUEST_CHANGES.SUCCESS] (state) {
        return {
            ...state,
            errorMessage: "",
            isRequestingChangesDisabled: false,
            isRequestingChangesError: false,
            isRequestingChangesPending: false
        };
    },
    [$6D21P.HIDE_ERROR_DIALOG] (state) {
        return {
            ...state,
            isErrorDialogOpen: false
        };
    },
    [$6D21P.APPROVAL_ERROR] (state, action) {
        return {
            ...state,
            isErrorDialogOpen: true,
            errorMessage: action.payload.message
        };
    },
    [(0, $dkkN8.NETWORK_ONLINE)] (state) {
        return {
            ...state,
            isErrorDialogOpen: false
        };
    },
    [$6D21P.SET_APPROVAL_LOADER] (state) {
        return {
            ...state,
            isApprovalPending: true
        };
    },
    [$6D21P.FETCH_COMMENTS.REQUEST] (state) {
        return {
            ...state,
            rawComments: [],
            commentsLoadingStatus: (0, $90kWr.LoadingStatus).Fetching
        };
    },
    [$6D21P.CLEAR_COMMENTS] (state) {
        return {
            ...state,
            rawComments: []
        };
    },
    [$6D21P.FETCH_COMMENTS.SUCCESS] (state, action) {
        const { rawComments: rawComments } = action.payload;
        return {
            ...state,
            rawComments: rawComments,
            commentsLoadingStatus: (0, $90kWr.LoadingStatus).Success
        };
    },
    [$6D21P.ADD_COMMENT.REQUEST] (state, action) {
        const comment = action.payload;
        const nextDiffCommentingMap = (0, $xz4dB.isFileComment)(comment) ? {
            ...state.diffCommentingMap,
            [comment.inline.path]: false
        } : state.diffCommentingMap;
        return {
            ...state,
            rawComments: [
                ...state.rawComments,
                {
                    ...comment,
                    state: "SAVING"
                }
            ],
            diffCommentingMap: nextDiffCommentingMap
        };
    },
    [$6D21P.ADD_COMMENT.SUCCESS] (state, action) {
        const { comment: comment, placeholderId: placeholderId } = action.payload;
        // placeholder comment will be replaced with comment from response
        if (placeholderId) {
            const foundComment = state.rawComments.find((c)=>"placeholderId" in c && c.placeholderId === placeholderId);
            if (foundComment) {
                const index = state.rawComments.indexOf(foundComment);
                const newComment = {
                    ...foundComment,
                    ...comment,
                    placeholderId: undefined,
                    state: undefined
                };
                const commentsBefore = state.rawComments.slice(0, index);
                const commentsAfter = state.rawComments.slice(index + 1);
                return {
                    ...state,
                    rawComments: [
                        ...commentsBefore,
                        newComment,
                        ...commentsAfter
                    ]
                };
            }
        }
        const nextDiffCommentingMap = (0, $xz4dB.isFileComment)(comment) ? {
            ...state.diffCommentingMap,
            [comment.inline.path]: false
        } : state.diffCommentingMap;
        return {
            ...state,
            rawComments: [
                ...state.rawComments,
                {
                    ...comment,
                    placeholderId: undefined,
                    state: undefined
                }
            ],
            diffCommentingMap: nextDiffCommentingMap
        };
    },
    [$6D21P.UPDATE_COMMENT.REQUEST] (state, action) {
        const { id: id, content: content } = action.payload;
        const foundComment = state.rawComments.find((comment)=>(0, $xz4dB.isApiComment)(comment) && comment.id === id);
        if (!foundComment) return state;
        const index = state.rawComments.indexOf(foundComment);
        const newComment = {
            ...foundComment,
            content: {
                doc: content
            },
            state: "SAVING"
        };
        const commentsBefore = state.rawComments.slice(0, index);
        const commentsAfter = state.rawComments.slice(index + 1);
        return {
            ...state,
            rawComments: [
                ...commentsBefore,
                newComment,
                ...commentsAfter
            ]
        };
    },
    [$6D21P.UPDATE_COMMENT.SUCCESS] (state, action) {
        const { comment: comment } = action.payload;
        const foundComment = state.rawComments.find((c)=>(0, $xz4dB.isApiComment)(c) && c.id === comment.id);
        if (!foundComment) return state;
        const index = state.rawComments.indexOf(foundComment);
        const newComment = {
            ...foundComment,
            ...comment,
            state: undefined
        };
        const commentsBefore = state.rawComments.slice(0, index);
        const commentsAfter = state.rawComments.slice(index + 1);
        return {
            ...state,
            rawComments: [
                ...commentsBefore,
                newComment,
                ...commentsAfter
            ]
        };
    },
    [$6D21P.DELETE_COMMENT.REQUEST] (state, action) {
        const { id: id } = action.payload;
        const foundComment = state.rawComments.find((comment)=>(0, $xz4dB.isApiComment)(comment) && comment.id === id);
        if (!foundComment) return state;
        const index = state.rawComments.indexOf(foundComment);
        const newComment = {
            ...foundComment,
            state: "SAVING"
        };
        const commentsBefore = state.rawComments.slice(0, index);
        const commentsAfter = state.rawComments.slice(index + 1);
        return {
            ...state,
            rawComments: [
                ...commentsBefore,
                newComment,
                ...commentsAfter
            ]
        };
    },
    [$6D21P.DELETE_COMMENT.SUCCESS] (state, action) {
        const foundComment = state.rawComments.find((comment)=>(0, $xz4dB.isApiComment)(comment) && comment.id === action.payload.id);
        if (!foundComment) return state;
        const index = state.rawComments.indexOf(foundComment);
        const newComment = {
            ...foundComment,
            state: undefined,
            deleted: true
        };
        const commentsBefore = state.rawComments.slice(0, index);
        const commentsAfter = state.rawComments.slice(index + 1);
        return {
            ...state,
            rawComments: [
                ...commentsBefore,
                newComment,
                ...commentsAfter
            ]
        };
    },
    [$6D21P.RESOLVE_COMMENT.REQUEST] (state, action) {
        const { id: id } = action.payload;
        const foundComment = state.rawComments.find((comment)=>(0, $xz4dB.isApiComment)(comment) && comment.id === id);
        if (!foundComment) return state;
        const index = state.rawComments.indexOf(foundComment);
        const newComment = {
            ...foundComment,
            state: "SAVING"
        };
        const commentsBefore = state.rawComments.slice(0, index);
        const commentsAfter = state.rawComments.slice(index + 1);
        return {
            ...state,
            rawComments: [
                ...commentsBefore,
                newComment,
                ...commentsAfter
            ]
        };
    },
    [$6D21P.RESOLVE_COMMENT.SUCCESS] (state, action) {
        const { id: id, resolution: resolution } = action.payload;
        const foundComment = state.rawComments.find((comment)=>(0, $xz4dB.isApiComment)(comment) && comment.id === id);
        if (!foundComment) return state;
        const index = state.rawComments.indexOf(foundComment);
        const newComment = {
            ...foundComment,
            state: undefined,
            resolution: resolution
        };
        const commentsBefore = state.rawComments.slice(0, index);
        const commentsAfter = state.rawComments.slice(index + 1);
        return {
            ...state,
            rawComments: [
                ...commentsBefore,
                newComment,
                ...commentsAfter
            ]
        };
    },
    [$6D21P.REOPEN_COMMENT.REQUEST] (state, action) {
        const { id: id } = action.payload;
        const foundComment = state.rawComments.find((comment)=>(0, $xz4dB.isApiComment)(comment) && comment.id === id);
        if (!foundComment) return state;
        const index = state.rawComments.indexOf(foundComment);
        const newComment = {
            ...foundComment,
            state: "SAVING"
        };
        const commentsBefore = state.rawComments.slice(0, index);
        const commentsAfter = state.rawComments.slice(index + 1);
        return {
            ...state,
            rawComments: [
                ...commentsBefore,
                newComment,
                ...commentsAfter
            ]
        };
    },
    [$6D21P.REOPEN_COMMENT.SUCCESS] (state, action) {
        const { id: id } = action.payload;
        const foundComment = state.rawComments.find((comment)=>(0, $xz4dB.isApiComment)(comment) && comment.id === id);
        if (!foundComment) return state;
        const index = state.rawComments.indexOf(foundComment);
        const newComment = {
            ...foundComment,
            state: undefined,
            resolution: undefined
        };
        const commentsBefore = state.rawComments.slice(0, index);
        const commentsAfter = state.rawComments.slice(index + 1);
        return {
            ...state,
            rawComments: [
                ...commentsBefore,
                newComment,
                ...commentsAfter
            ]
        };
    },
    [$6D21P.FETCH_OUTDATED_COMMENT_CONTEXT.REQUEST] (state) {
        return {
            ...state,
            isLoadingOutdatedCommentContext: true
        };
    },
    [$6D21P.FETCH_OUTDATED_COMMENT_CONTEXT.ERROR] (state) {
        return {
            ...state,
            isLoadingOutdatedCommentContext: false
        };
    },
    [$6D21P.FETCH_OUTDATED_COMMENT_CONTEXT.SUCCESS]: $f091289952aa4865$var$mergeContextLines,
    [$6D21P.FETCH_BASE_REV_COMMENT_CONTEXT.REQUEST] (state) {
        return {
            ...state,
            isLoadingBaseRevCommentContext: true
        };
    },
    [$6D21P.FETCH_BASE_REV_COMMENT_CONTEXT.ERROR] (state) {
        return {
            ...state,
            isLoadingBaseRevCommentContext: false
        };
    },
    [$6D21P.FETCH_BASE_REV_COMMENT_CONTEXT.SUCCESS]: $f091289952aa4865$var$mergeContextLines,
    [$6D21P.FETCH_ALL_CHANGES_COMMENT_CONTEXT.REQUEST] (state) {
        return {
            ...state,
            isLoadingAllChangesCommentContext: true
        };
    },
    [$6D21P.FETCH_ALL_CHANGES_COMMENT_CONTEXT.ERROR] (state) {
        return {
            ...state,
            isLoadingAllChangesCommentContext: false
        };
    },
    [$6D21P.FETCH_ALL_CHANGES_COMMENT_CONTEXT.SUCCESS]: $f091289952aa4865$var$mergeContextLines,
    [$6D21P.FETCH_PENDING_COMMENT_CONTEXT.REQUEST] (state) {
        return {
            ...state,
            isLoadingPendingCommentContext: true
        };
    },
    [$6D21P.FETCH_PENDING_COMMENT_CONTEXT.ERROR] (state) {
        return {
            ...state,
            isLoadingPendingCommentContext: false
        };
    },
    [$6D21P.FETCH_PENDING_COMMENT_CONTEXT.SUCCESS]: $f091289952aa4865$var$mergeContextLines,
    [$6D21P.FETCH_LARGE_FILE_COMMENT_CONTEXT.SUCCESS]: $f091289952aa4865$var$mergeContextLines,
    [$6D21P.OPEN_OUTDATED_COMMENTS_DIALOG] (state, action) {
        return {
            ...state,
            isOutdatedDialogOpen: true,
            outdatedCommentsDialog: action.payload
        };
    },
    [$6D21P.OPEN_REVIEW_DRAFT_DIALOG] (state) {
        return {
            ...state,
            isReviewDraftDialogOpen: true
        };
    },
    [$6D21P.OPEN_DIFF_COMMENTS_DIALOG] (state, action) {
        return {
            ...state,
            isDiffCommentsDialogOpen: true,
            diffCommentsDialog: action.payload
        };
    },
    [$6D21P.OPEN_NONRENDERED_DIFF_COMMENTS_DIALOG] (state, action) {
        return {
            ...state,
            isNonRenderedDiffCommentsDialogOpen: true,
            nonRenderedDiffCommentsDialogFilepath: action.payload
        };
    },
    [$6D21P.CLOSE_OUTDATED_COMMENTS_DIALOG] (state, _action) {
        return {
            ...state,
            isOutdatedDialogOpen: false
        };
    },
    [$6D21P.CLOSE_REVIEW_DRAFT_DIALOG] (state) {
        return {
            ...state,
            isReviewDraftDialogOpen: false
        };
    },
    [$6D21P.CLOSE_DIFF_COMMENTS_DIALOG] (state, _action) {
        return {
            ...state,
            isDiffCommentsDialogOpen: false
        };
    },
    [$6D21P.CLOSE_NONRENDERED_DIFF_COMMENTS_DIALOG] (state, _action) {
        return {
            ...state,
            isNonRenderedDiffCommentsDialogOpen: false
        };
    },
    [$6D21P.LOAD_DIFFSTAT.REQUEST] (state) {
        return {
            ...state,
            isDiffStatLoading: true
        };
    },
    [$6D21P.LOAD_DIFFSTAT.ERROR] (state, action) {
        const { payload: { diffStatErrorCode: diffStatErrorCode, diffStatErrorKey: diffStatErrorKey } } = action;
        return {
            ...state,
            diffStatErrorCode: diffStatErrorCode,
            diffStatErrorKey: diffStatErrorKey,
            isDiffStatLoading: false,
            isApprovalPending: false
        };
    },
    [$6D21P.LOAD_DIFFSTAT.SUCCESS] (state, action) {
        const { values: values } = action.payload;
        return {
            ...state,
            diffStat: values,
            isDiffStatLoading: false,
            diffStatErrorCode: null,
            diffStatErrorKey: null,
            activeDiff: ""
        };
    },
    [$6D21P.TOGGLE_SINGLE_FILE_MODE] (state, action) {
        const isSingleFileMode = action.payload;
        return {
            ...state,
            isSingleFileMode: isSingleFileMode
        };
    },
    [$6D21P.UPDATE_FILTER_COMMENTS_BY_USER]: $f091289952aa4865$var$updateFilterCommentsByUser,
    [$6D21P.TOGGLE_SINGLE_FILE_MODE_ELIGIBILITY] (state, action) {
        return {
            ...state,
            isSingleFileModeEligible: action.payload
        };
    },
    [$6D21P.TOGGLE_SINGLE_FILE_MODE_SETTINGS_HEADER_VISIBILITY] (state, action) {
        return {
            ...state,
            isSingleFileModeSettingsHeaderVisible: action.payload
        };
    },
    [$6D21P.TOGGLE_STICKY_HEADER_ACTIVE_STATUS] (state, action) {
        return {
            ...state,
            isStickyHeaderActive: action.payload
        };
    },
    [$6D21P.HIGHLIGHT_COMMENT] (state, action) {
        return {
            ...state,
            highlightedCommentId: action.payload.commentId,
            highlightCommentThread: action.payload.highlightThread
        };
    },
    [$6D21P.HIGHLIGHT_ACTIVE_TREE_ITEM] (state, action) {
        return {
            ...state,
            activeDiff: action.payload
        };
    },
    [$dkXlf.RESTORE_DIFFS_EXPAND_STATE] (state, action) {
        return {
            ...state,
            diffsExpansionState: action.payload
        };
    },
    [$6D21P.SCROLL_TO_FILE] (state, action) {
        const { payload: anchorId } = action;
        const filepath = anchorId.replace(/chg-/, "");
        const nextExpansionState = {
            ...state.diffsExpansionState,
            [filepath]: true
        };
        const activeDiff = state.isSingleFileMode ? anchorId : state.activeDiff;
        return {
            ...state,
            diffsExpansionState: nextExpansionState,
            activeDiff: activeDiff
        };
    },
    [$6D21P.OPEN_FILE_COMMENT] (state, action) {
        const filepath = action.payload;
        const nextExpansionState = {
            ...state.diffsExpansionState,
            [filepath]: true
        };
        const nextDiffCommentingMap = {
            ...state.diffCommentingMap,
            [filepath]: true
        };
        return {
            ...state,
            diffsExpansionState: nextExpansionState,
            diffCommentingMap: nextDiffCommentingMap
        };
    },
    [$6D21P.CLOSE_FILE_COMMENT] (state, action) {
        const filepath = action.payload;
        const nextDiffCommentingMap = {
            ...state.diffCommentingMap,
            [filepath]: false
        };
        return {
            ...state,
            diffCommentingMap: nextDiffCommentingMap
        };
    },
    [$dkXlf.TOGGLE_DIFF_EXPANSION] (state, action) {
        const { filepath: filepath, isOpening: isOpening } = action.payload;
        if (state.diffsExpansionState[filepath] === isOpening) return state;
        const nextExpansionState = {
            ...state.diffsExpansionState,
            [filepath]: isOpening
        };
        return {
            ...state,
            diffsExpansionState: nextExpansionState
        };
    },
    [$dkXlf.COLLAPSE_ALL_DIFFS] (state) {
        const allFilepaths = (state.diffStat || []).map((0, $4coax.extractFilepath));
        const allFilesCollapsed = allFilepaths.reduce((prev, filepath)=>({
                ...prev,
                [filepath]: false
            }), {});
        return {
            ...state,
            diffsExpansionState: allFilesCollapsed
        };
    },
    [$dkXlf.EXPAND_ALL_DIFFS] (state) {
        const allFilepaths = (state.diffStat || []).map((0, $4coax.extractFilepath));
        const allFilesExpanded = allFilepaths.reduce((prev, filepath)=>({
                ...prev,
                [filepath]: true
            }), {});
        return {
            ...state,
            diffsExpansionState: allFilesExpanded
        };
    },
    [$6D21P.RESET_ACTIVE_TREE_ITEM] (state, action) {
        if (state.activeDiff && state.activeDiff === action.payload) return {
            ...state,
            activeDiff: ""
        };
        else return state;
    },
    [$6D21P.LOAD_WATCH.BEGIN] (state) {
        return {
            ...state,
            watchActionLoading: true
        };
    },
    [$6D21P.LOAD_WATCH.END] (state, action) {
        return {
            ...state,
            isWatching: action.payload,
            watchActionLoading: false
        };
    },
    [$6D21P.ACTIVE_DIFF_PERMALINK] (state, action) {
        return {
            ...state,
            activePermalink: action.payload
        };
    },
    [$6D21P.PERMALINK_HASH_CHANGE] (state, action) {
        const permalink = action.payload;
        if ((0, $9kTpj.LINE_PERMALINK_MATCHER).test(permalink)) return {
            ...state,
            activePermalink: permalink
        };
        else return state;
    },
    [(0, $dkkN8.LoadGlobal).SUCCESS] (state) {
        return state;
    },
    [$6D21P.CLOSE_SETTINGS_CHANGEBOARDING_DIALOG] (state) {
        return {
            ...state,
            isSettingsChangeboardingDialogOpen: false
        };
    },
    [$dkXlf.TOGGLE_SIDE_BY_SIDE_MODE] (state, action) {
        if (!action.payload.filePath) return state;
        const { filePath: filePath, isSideBySide: isSideBySide } = action.payload;
        return {
            ...state,
            sideBySideDiffState: {
                ...state.sideBySideDiffState,
                [filePath]: isSideBySide
            }
        };
    },
    [(0, $i2O3k.UPDATE_GLOBAL_DIFF_VIEW_MODE_SUCCESS)] (state) {
        return {
            ...state,
            sideBySideDiffState: $f091289952aa4865$export$d4c72bab9d6cc13a.sideBySideDiffState
        };
    },
    [$6D21P.UPDATE_EDITOR_OPEN_STATE] (state, action) {
        return {
            ...state,
            isEditorOpen: action.payload
        };
    },
    [$6D21P.CHANGE_DIFF_SORT]: $f091289952aa4865$var$changeDiffSort,
    [$6D21P.REVERT_DIALOG.OPEN] (state) {
        return {
            ...state,
            isRevertDialogOpen: true,
            revertError: null
        };
    },
    [$6D21P.REVERT_DIALOG.CLOSE] (state) {
        return {
            ...state,
            isRevertDialogOpen: false
        };
    },
    [$6D21P.REVERT_PULL_REQUEST.REQUEST] (state) {
        return {
            ...state,
            revertError: null
        };
    },
    [$6D21P.REVERT_PULL_REQUEST.ERROR] (state, action) {
        return {
            ...state,
            revertError: action.payload
        };
    },
    [$6D21P.FETCH_DESTINATION_BRANCH.SUCCESS] (state) {
        return {
            ...state,
            hasDestinationBranch: true
        };
    },
    [$6D21P.FETCH_DESTINATION_BRANCH.ERROR] (state) {
        return {
            ...state,
            hasDestinationBranch: false
        };
    },
    [(0, $jJd6W.FetchSourceRepositoryDetails).SUCCESS] (state, { payload: payload }) {
        return {
            ...state,
            sourceRepository: {
                accessLevel: payload.access_level
            }
        };
    },
    [$6D21P.FETCH_SOURCE_BRANCH_DETAILS.SUCCESS] (state, action) {
        const details = {
            ...action.payload.values[0],
            isMainBranch: action.payload.values[0].ismainbranch
        };
        return {
            ...state,
            sourceBranchDetails: details
        };
    },
    [$6D21P.EXITED_CODE_REVIEW] (state) {
        const { isSingleFileMode: isSingleFileMode, isSingleFileModeEligible: isSingleFileModeEligible } = $f091289952aa4865$export$d4c72bab9d6cc13a;
        return {
            ...state,
            isSingleFileMode: isSingleFileMode,
            isSingleFileModeEligible: isSingleFileModeEligible
        };
    },
    [$6D21P.HIDDEN_FILE_DIALOG.OPEN] (state, { payload: payload }) {
        return {
            ...state,
            hiddenFileDialogAnchor: payload
        };
    },
    [$6D21P.HIDDEN_FILE_DIALOG.CONFIRM] (state) {
        return {
            ...state,
            hiddenFileDialogAnchor: null,
            // turn off comment filtering
            isCommentsFilterActive: false,
            filterCommentsByUser: null
        };
    },
    [$6D21P.HIDDEN_FILE_DIALOG.CANCEL] (state) {
        return {
            ...state,
            hiddenFileDialogAnchor: null
        };
    },
    [$6D21P.FIX_MISSING_COMMITS.REQUEST] (state) {
        return {
            ...state,
            isUpdatingCommits: true
        };
    },
    [$6D21P.FIX_MISSING_COMMITS.SUCCESS] (state) {
        return {
            ...state,
            errorMessage: "",
            isMissingCommits: false,
            isUpdatingCommits: false
        };
    },
    [$6D21P.FIX_MISSING_COMMITS.ERROR] (state) {
        return {
            ...state,
            hasMissingCommitsError: true,
            isUpdatingCommits: false
        };
    },
    // this action toggles the refetchBuildsDummy value, triggering a
    // builds data fetching hook to re-run
    [$6D21P.TOGGLE_REFETCH_BUILDS_DUMMY] (state) {
        return {
            ...state,
            refetchBuildsDummy: !state.refetchBuildsDummy
        };
    },
    [(0, $k6zif.CREATE_PENDING_MERGE).ERROR] (state, { payload: payload }) {
        if (payload.code === "BUILDS_FINISHED_GO_MERGE") return {
            ...state,
            mergeChecks: state.mergeChecks.map((item)=>{
                if (item.name === "Minimum Successful Builds") item.pass = true;
                return item;
            }),
            isMergeable: true
        };
        return state;
    },
    [$6D21P.REFETCH_IR_DIFF.TRUE] (state) {
        return {
            ...state,
            refetchIRDiffDummy: true
        };
    },
    [$6D21P.REFETCH_IR_DIFF.FALSE] (state) {
        return {
            ...state,
            refetchIRDiffDummy: false
        };
    }
});

});
parcelRegister("hfhvV", function(module, exports) {
$parcel$export(module.exports, "COMMENT_PERMALINK_MATCHER", function () { return (parcelRequire("9kTpj")).COMMENT_PERMALINK_MATCHER; });
$parcel$export(module.exports, "createDiffPermalink", function () { return (parcelRequire("9kTpj")).createDiffPermalink; });
$parcel$export(module.exports, "FILEPATH_PERMALINK_MATCHER", function () { return (parcelRequire("9kTpj")).FILEPATH_PERMALINK_MATCHER; });
$parcel$export(module.exports, "getDiffRange", function () { return (parcelRequire("9kTpj")).getDiffRange; });
$parcel$export(module.exports, "getFilepathFromPermalink", function () { return (parcelRequire("9kTpj")).getFilepathFromPermalink; });
$parcel$export(module.exports, "getPermalink", function () { return (parcelRequire("9kTpj")).getPermalink; });
$parcel$export(module.exports, "isSameCommentPermalink", function () { return (parcelRequire("9kTpj")).isSameCommentPermalink; });
$parcel$export(module.exports, "LINE_PERMALINK_MATCHER", function () { return (parcelRequire("9kTpj")).LINE_PERMALINK_MATCHER; });
$parcel$export(module.exports, "SIDE_BY_SIDE_LINE_PERMALINK_MATCHER", function () { return (parcelRequire("9kTpj")).SIDE_BY_SIDE_LINE_PERMALINK_MATCHER; });
$parcel$export(module.exports, "SIDEBAR_EXPANDER_HASH_MATCHER", function () { return (parcelRequire("9kTpj")).SIDEBAR_EXPANDER_HASH_MATCHER; });
$parcel$export(module.exports, "updateHashInURL", function () { return (parcelRequire("9kTpj")).updateHashInURL; });
parcelRequire("9kTpj");

});
parcelRegister("9kTpj", function(module, exports) {

$parcel$export(module.exports, "COMMENT_PERMALINK_MATCHER", function () { return $58c89c1196fbcdd6$export$a395c1c63cf0c56f; });
$parcel$export(module.exports, "SIDEBAR_EXPANDER_HASH_MATCHER", function () { return $58c89c1196fbcdd6$export$761f7e30a88b4a4f; });
$parcel$export(module.exports, "LINE_PERMALINK_MATCHER", function () { return $58c89c1196fbcdd6$export$5a794b0d13fe0719; });
$parcel$export(module.exports, "SIDE_BY_SIDE_LINE_PERMALINK_MATCHER", function () { return $58c89c1196fbcdd6$export$dc1580d30b50ad0c; });
$parcel$export(module.exports, "FILEPATH_PERMALINK_MATCHER", function () { return $58c89c1196fbcdd6$export$b386cca7930b5ff4; });
$parcel$export(module.exports, "createUnifiedLinePermalink", function () { return $58c89c1196fbcdd6$export$e7454ea2ddd4ef41; });
$parcel$export(module.exports, "createSideBySideLinePermalink", function () { return $58c89c1196fbcdd6$export$78c4e2fa42667ffd; });
$parcel$export(module.exports, "createDiffPermalink", function () { return $58c89c1196fbcdd6$export$45c648168e7aaa03; });
$parcel$export(module.exports, "getFilepathFromPermalink", function () { return $58c89c1196fbcdd6$export$4329c8782a1a54c; });
$parcel$export(module.exports, "getPermalink", function () { return $58c89c1196fbcdd6$export$40cb1fa3871d285b; });
$parcel$export(module.exports, "getDiffRange", function () { return $58c89c1196fbcdd6$export$69d307200752623a; });
$parcel$export(module.exports, "updateHashInURL", function () { return $58c89c1196fbcdd6$export$4d137b33eb44edbf; });
$parcel$export(module.exports, "isSameCommentPermalink", function () { return $58c89c1196fbcdd6$export$890103fa0bb44278; });

var $3BD5g = parcelRequire("3BD5g");

var $ivwvu = parcelRequire("ivwvu");
function $58c89c1196fbcdd6$var$_wrapRegExp() {
    $58c89c1196fbcdd6$var$_wrapRegExp = function(e, r) {
        return new BabelRegExp(e, void 0, r);
    };
    var e = RegExp.prototype, r = new WeakMap();
    function BabelRegExp(e, t, p) {
        var o = RegExp(e, t);
        return r.set(o, p || r.get(e)), (0, (/*@__PURE__*/$parcel$interopDefault($ivwvu)))(o, BabelRegExp.prototype);
    }
    function buildGroups(e, t) {
        var p = r.get(t);
        return Object.keys(p).reduce(function(r, t) {
            var o = p[t];
            if ("number" == typeof o) r[t] = e[o];
            else {
                for(var i = 0; void 0 === e[o[i]] && i + 1 < o.length;)i++;
                r[t] = e[o[i]];
            }
            return r;
        }, Object.create(null));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(r) {
        var t = e.exec.call(this, r);
        if (t) {
            t.groups = buildGroups(t, this);
            var p = t.indices;
            p && (p.groups = buildGroups(p, this));
        }
        return t;
    }, BabelRegExp.prototype[Symbol.replace] = function(t, p) {
        if ("string" == typeof p) {
            var o = r.get(this);
            return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function(e, r) {
                var t = o[r];
                return "$" + (Array.isArray(t) ? t.join("$") : t);
            }));
        }
        if ("function" == typeof p) {
            var i = this;
            return e[Symbol.replace].call(this, t, function() {
                var e = arguments;
                return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e);
            });
        }
        return e[Symbol.replace].call(this, t, p);
    }, $58c89c1196fbcdd6$var$_wrapRegExp.apply(this, arguments);
}
const $58c89c1196fbcdd6$export$a395c1c63cf0c56f = /^comment-/;
const $58c89c1196fbcdd6$export$761f7e30a88b4a4f = /^sidebar-/;
const $58c89c1196fbcdd6$export$5a794b0d13fe0719 = /^L|^chg_/;
const $58c89c1196fbcdd6$export$dc1580d30b50ad0c = /^chg_/;
const $58c89c1196fbcdd6$export$b386cca7930b5ff4 = /^chg-/;
var $58c89c1196fbcdd6$var$PermalinkLineTypes;
(function(PermalinkLineTypes) {
    PermalinkLineTypes["OldLine"] = "oldline";
    PermalinkLineTypes["NewLine"] = "newline";
})($58c89c1196fbcdd6$var$PermalinkLineTypes || ($58c89c1196fbcdd6$var$PermalinkLineTypes = {}));
const $58c89c1196fbcdd6$export$e7454ea2ddd4ef41 = (line, filePath)=>{
    return `L${filePath}${line.oldLine ? `F${line.oldLine}` : ""}${line.newLine ? `T${line.newLine}` : ""}`;
};
const $58c89c1196fbcdd6$export$78c4e2fa42667ffd = (line, filePath, hideNewLines)=>{
    const lineType = hideNewLines ? "oldline" : "newline";
    const lineNumber = hideNewLines ? line.oldLine : line.newLine;
    return `chg_${filePath}_${lineType}${lineNumber}`;
};
const $58c89c1196fbcdd6$export$45c648168e7aaa03 = (filepath)=>`chg-${filepath}`;
const $58c89c1196fbcdd6$var$parseHrefToFilepathWithRegEx = (regex)=>(permalink)=>{
        var _regex$exec, _regex$exec$groups;
        return (_regex$exec = regex.exec(permalink)) === null || _regex$exec === void 0 ? void 0 : (_regex$exec$groups = _regex$exec.groups) === null || _regex$exec$groups === void 0 ? void 0 : _regex$exec$groups.filepath;
    };
const $58c89c1196fbcdd6$var$patterns = [
    $58c89c1196fbcdd6$var$parseHrefToFilepathWithRegEx(/*#__PURE__*/ $58c89c1196fbcdd6$var$_wrapRegExp(/L(.*?)(F([0-9]+))?(T([0-9]+))?$/, {
        filepath: 1,
        fromNumber: 3,
        toNumber: 5
    })),
    $58c89c1196fbcdd6$var$parseHrefToFilepathWithRegEx(/*#__PURE__*/ $58c89c1196fbcdd6$var$_wrapRegExp(/chg_(.*)_(oldline|newline)([0-9]+)$/, {
        filepath: 1,
        lineType: 2,
        lineNumber: 3
    })),
    $58c89c1196fbcdd6$var$parseHrefToFilepathWithRegEx(/*#__PURE__*/ $58c89c1196fbcdd6$var$_wrapRegExp(/chg\x2D(.*)$/, {
        filepath: 1
    }))
];
const $58c89c1196fbcdd6$export$4329c8782a1a54c = (permalink = "")=>$58c89c1196fbcdd6$var$patterns.map((pattern)=>pattern(permalink)).find((matchResult)=>!!matchResult);
const $58c89c1196fbcdd6$export$40cb1fa3871d285b = ()=>{
    try {
        const hash = decodeURIComponent(window.location.hash);
        return hash.slice(1);
    } catch (e) {
        // URIError: malformed URI sequence
        return undefined;
    }
};
const $58c89c1196fbcdd6$export$69d307200752623a = ()=>{
    try {
        const url = decodeURIComponent(window.location.href);
        const diffRangeRegex = /\/([0-9a-f]{7,40})\.\.([0-9a-f]{7,40})/;
        const diffRange = url.match(diffRangeRegex);
        if (diffRange) return diffRange[0];
        return undefined;
    } catch (e) {
        // URIError: malformed URI sequence
        return undefined;
    }
};
const $58c89c1196fbcdd6$var$urlEncodeWhitespace = (permalink)=>permalink.split("").map((chr)=>[
            "	",
            "\n"
        ].includes(chr) ? encodeURIComponent(chr) : chr).join("");
const $58c89c1196fbcdd6$export$4d137b33eb44edbf = (activePermalink, history)=>{
    // Prevent the browser from doing additional scrolling by
    // updating the URL in a way that doens't trigger a hashchange
    // event but still allows the back & forward button to work.
    const newPermalink = $58c89c1196fbcdd6$var$urlEncodeWhitespace(activePermalink);
    history.push({
        ...history.location,
        hash: newPermalink
    });
};
const $58c89c1196fbcdd6$export$890103fa0bb44278 = (commentId)=>{
    const newPermalink = `comment-${commentId}`;
    const currentPermalink = $58c89c1196fbcdd6$export$40cb1fa3871d285b();
    return newPermalink === currentPermalink;
};

});


parcelRegister("xz4dB", function(module, exports) {

$parcel$export(module.exports, "isApiComment", function () { return $901331e897d0d79f$export$da1a8c4cbc5e4b1c; });
$parcel$export(module.exports, "isFileComment", function () { return $901331e897d0d79f$export$c90f63efd340bd2a; });
const $901331e897d0d79f$export$da1a8c4cbc5e4b1c = (comment)=>"id" in comment && "deleted" in comment;
const $901331e897d0d79f$export$c90f63efd340bd2a = (c)=>{
    return !!c.inline && !!c.inline.path;
};

});

parcelRegister("i2O3k", function(module, exports) {

$parcel$export(module.exports, "DiffViewMode", function () { return $235148e8a1114cc6$export$6839dda83f217ae6; });
$parcel$export(module.exports, "LoadFileMode", function () { return $235148e8a1114cc6$export$21be0c4c1d5a3bc9; });
$parcel$export(module.exports, "FileViewMode", function () { return $235148e8a1114cc6$export$d145d29990eda5ec; });
$parcel$export(module.exports, "UPDATE_GLOBAL_DIFF_VIEW_MODE_SUCCESS", function () { return $235148e8a1114cc6$export$b6f994b8e1f01270; });
$parcel$export(module.exports, "UPDATE_GLOBAL_FILE_VIEW_MODE_SUCCESS", function () { return $235148e8a1114cc6$export$b531dfb2ccfb2756; });
$parcel$export(module.exports, "UPDATE_GLOBAL_TAB_SIZE_SUCCESS", function () { return $235148e8a1114cc6$export$3af4ec3b31f3c1de; });
$parcel$export(module.exports, "UPDATE_GLOBAL_IS_WORD_DIFF_ENABLED_SUCCESS", function () { return $235148e8a1114cc6$export$77e036c4c8b26729; });
$parcel$export(module.exports, "UPDATE_GLOBAL_SHOULD_IGNORE_WHITESPACE_SUCCESS", function () { return $235148e8a1114cc6$export$adeb56461d6ef888; });
$parcel$export(module.exports, "UPDATE_GLOBAL_IS_COLOR_BLIND_MODE_ENABLED_SUCCESS", function () { return $235148e8a1114cc6$export$e21a562d85593bd0; });
$parcel$export(module.exports, "UPDATE_GLOBAL_IS_ANNOTATIONS_ENABLED_SUCCESS", function () { return $235148e8a1114cc6$export$6dcd51d77fa0fa6; });
$parcel$export(module.exports, "UPDATE_GLOBAL_IS_SINGLE_FILE_MODE_ENABLED_SUCCESS", function () { return $235148e8a1114cc6$export$316038f6a83137cb; });
$parcel$export(module.exports, "UPDATE_SETTINGS_REQUEST", function () { return $235148e8a1114cc6$export$1e8b447202131b74; });
$parcel$export(module.exports, "UPDATE_SETTINGS_SUCCESS", function () { return $235148e8a1114cc6$export$7f0d5b60968455fa; });
$parcel$export(module.exports, "toggleSettingsDialog", function () { return $235148e8a1114cc6$export$e977ffa3e2c02102; });
$parcel$export(module.exports, "updateSettings", function () { return $235148e8a1114cc6$export$f558026a994b6051; });
$parcel$export(module.exports, "getIsDiffSettingsDialogLoading", function () { return $235148e8a1114cc6$export$371c2c4f1f323be; });
$parcel$export(module.exports, "getIsDiffSettingsDialogOpen", function () { return $235148e8a1114cc6$export$6e2691ca1e1577ff; });
$parcel$export(module.exports, "getGlobalDiffViewMode", function () { return $235148e8a1114cc6$export$fe93e8f35140e050; });
$parcel$export(module.exports, "getGlobalFileViewMode", function () { return $235148e8a1114cc6$export$8cdfee320c1f118d; });
$parcel$export(module.exports, "getGlobalTabSize", function () { return $235148e8a1114cc6$export$d26b6fb98697ea0f; });
$parcel$export(module.exports, "getGlobalIsWordDiffEnabled", function () { return $235148e8a1114cc6$export$e3709c37d101e7da; });
$parcel$export(module.exports, "getGlobalIsColorBlindModeEnabled", function () { return $235148e8a1114cc6$export$71a1c4d84a95e3c6; });
$parcel$export(module.exports, "getGlobalShouldIgnoreWhitespace", function () { return $235148e8a1114cc6$export$4856c30b4b81c08c; });
$parcel$export(module.exports, "getGlobalIsAnnotationsEnabled", function () { return $235148e8a1114cc6$export$3bb5e251da2ebf87; });
$parcel$export(module.exports, "getGlobalIsSingleFileModeEnabled", function () { return $235148e8a1114cc6$export$b4957f01ba4d5f7; });
$parcel$export(module.exports, "reducer", function () { return $235148e8a1114cc6$export$1650419e431d3ba3; });

var $aXXtM = parcelRequire("aXXtM");

var $dkkN8 = parcelRequire("dkkN8");
var $235148e8a1114cc6$export$6839dda83f217ae6;
(function(DiffViewMode) {
    DiffViewMode["Unified"] = "UNIFIED";
    DiffViewMode["SideBySide"] = "SIDE_BY_SIDE";
})($235148e8a1114cc6$export$6839dda83f217ae6 || ($235148e8a1114cc6$export$6839dda83f217ae6 = {}));
var $235148e8a1114cc6$export$21be0c4c1d5a3bc9;
(function(LoadFileMode) {
    LoadFileMode["AllFilesMode"] = "ALL_FILES_MODE";
    LoadFileMode["SingleFileMode"] = "SINGLE_FILE_MODE";
})($235148e8a1114cc6$export$21be0c4c1d5a3bc9 || ($235148e8a1114cc6$export$21be0c4c1d5a3bc9 = {}));
var $235148e8a1114cc6$export$d145d29990eda5ec;
(function(FileViewMode) {
    FileViewMode["Tree"] = "TREE";
    FileViewMode["List"] = "LIST";
})($235148e8a1114cc6$export$d145d29990eda5ec || ($235148e8a1114cc6$export$d145d29990eda5ec = {}));
// Actions
const $235148e8a1114cc6$var$TOGGLE_SETTINGS_DIALOG = "diffSettings/TOGGLE_SETTINGS_DIALOG";
const $235148e8a1114cc6$export$b6f994b8e1f01270 = "diffSettings/UPDATE_GLOBAL_DIFF_VIEW_MODE_SUCCESS";
const $235148e8a1114cc6$export$b531dfb2ccfb2756 = "diffSettings/UPDATE_GLOBAL_FILE_VIEW_MODE_SUCCESS";
const $235148e8a1114cc6$export$3af4ec3b31f3c1de = "diffSettings/UPDATE_GLOBAL_TAB_SIZE_SUCCESS";
const $235148e8a1114cc6$export$77e036c4c8b26729 = "diffSettings/UPDATE_GLOBAL_IS_WORD_DIFF_ENABLED_SUCCESS";
const $235148e8a1114cc6$export$adeb56461d6ef888 = "diffSettings/UPDATE_GLOBAL_SHOULD_IGNORE_WHITESPACE_SUCCESS";
const $235148e8a1114cc6$export$e21a562d85593bd0 = "diffSettings/UPDATE_GLOBAL_IS_COLOR_BLIND_MODE_ENABLED_SUCCESS";
const $235148e8a1114cc6$export$6dcd51d77fa0fa6 = "diffSettings/UPDATE_GLOBAL_IS_ANNOTATIONS_ENABLED_SUCCESS";
const $235148e8a1114cc6$export$316038f6a83137cb = "diffSettings/UPDATE_GLOBAL_IS_SINGLE_FILE_MODE_ENABLED_SUCCESS";
const $235148e8a1114cc6$export$1e8b447202131b74 = "diffSettings/UPDATE_SETTINGS_REQUEST";
const $235148e8a1114cc6$export$7f0d5b60968455fa = "diffSettings/UPDATE_SETTINGS_SUCCESS";
const $235148e8a1114cc6$export$e977ffa3e2c02102 = (isOpen)=>({
        type: $235148e8a1114cc6$var$TOGGLE_SETTINGS_DIALOG,
        payload: {
            isOpen: isOpen
        }
    });
const $235148e8a1114cc6$export$f558026a994b6051 = (settings)=>({
        type: $235148e8a1114cc6$export$1e8b447202131b74,
        payload: settings
    });
// Selectors + Reducer
const $235148e8a1114cc6$var$initialState = {
    globalDiffViewMode: "UNIFIED",
    globalFileViewMode: "TREE",
    globalTabSize: 6,
    globalIsWordDiffEnabled: true,
    globalShouldIgnoreWhitespace: false,
    globalIsColorBlindModeEnabled: false,
    globalIsAnnotationsEnabled: true,
    globalIsSingleFileModeEnabled: false,
    isDialogLoading: false,
    isDialogOpen: false
};
const $235148e8a1114cc6$var$getDiffSettingsSlice = (state)=>state.diffSettings;
const $235148e8a1114cc6$export$371c2c4f1f323be = (0, $aXXtM.createSelector)($235148e8a1114cc6$var$getDiffSettingsSlice, (state)=>state.isDialogLoading);
const $235148e8a1114cc6$export$6e2691ca1e1577ff = (0, $aXXtM.createSelector)($235148e8a1114cc6$var$getDiffSettingsSlice, (state)=>state.isDialogOpen);
const $235148e8a1114cc6$export$fe93e8f35140e050 = (0, $aXXtM.createSelector)($235148e8a1114cc6$var$getDiffSettingsSlice, (state)=>state.globalDiffViewMode);
const $235148e8a1114cc6$export$8cdfee320c1f118d = (0, $aXXtM.createSelector)($235148e8a1114cc6$var$getDiffSettingsSlice, (state)=>state.globalFileViewMode);
const $235148e8a1114cc6$export$d26b6fb98697ea0f = (0, $aXXtM.createSelector)($235148e8a1114cc6$var$getDiffSettingsSlice, (state)=>state.globalTabSize);
const $235148e8a1114cc6$export$e3709c37d101e7da = (0, $aXXtM.createSelector)($235148e8a1114cc6$var$getDiffSettingsSlice, (state)=>state.globalIsWordDiffEnabled);
const $235148e8a1114cc6$export$71a1c4d84a95e3c6 = (0, $aXXtM.createSelector)($235148e8a1114cc6$var$getDiffSettingsSlice, (state)=>state.globalIsColorBlindModeEnabled);
const $235148e8a1114cc6$export$4856c30b4b81c08c = (0, $aXXtM.createSelector)($235148e8a1114cc6$var$getDiffSettingsSlice, (state)=>state.globalShouldIgnoreWhitespace);
const $235148e8a1114cc6$export$3bb5e251da2ebf87 = (0, $aXXtM.createSelector)($235148e8a1114cc6$var$getDiffSettingsSlice, (state)=>state.globalIsAnnotationsEnabled);
const $235148e8a1114cc6$export$b4957f01ba4d5f7 = (0, $aXXtM.createSelector)($235148e8a1114cc6$var$getDiffSettingsSlice, (state)=>state.globalIsSingleFileModeEnabled);
const $235148e8a1114cc6$export$1650419e431d3ba3 = (state = $235148e8a1114cc6$var$initialState, action)=>{
    switch(action.type){
        case (0, $dkkN8.LoadGlobal).SUCCESS:
            {
                // User preference keys are legacy naming, so settings apply to all diffs,
                // not just pull request diffs
                const { isPullRequestIgnoreWhitespaceEnabled: isPullRequestIgnoreWhitespaceEnabled, isPullRequestWordDiffEnabled: isPullRequestWordDiffEnabled, pullRequestDiffViewMode: pullRequestDiffViewMode, pullRequestFileViewMode: pullRequestFileViewMode, pullRequestDiffTabSize: pullRequestDiffTabSize, isPullRequestColorBlindModeEnabled: isPullRequestColorBlindModeEnabled, isPullRequestAnnotationsEnabled: isPullRequestAnnotationsEnabled, isPullRequestSingleFileModeEnabled: isPullRequestSingleFileModeEnabled } = action.payload.result;
                return {
                    ...state,
                    // explicitly make sure a valid enum is used (the preference value from the server can technically be anything)
                    globalDiffViewMode: pullRequestDiffViewMode === "SIDE_BY_SIDE" ? "SIDE_BY_SIDE" : state.globalDiffViewMode,
                    // explicitly make sure a valid enum is used (the preference value from the server can technically be anything)
                    globalFileViewMode: pullRequestFileViewMode === "TREE" ? "TREE" : pullRequestFileViewMode === "LIST" ? "LIST" : state.globalFileViewMode,
                    globalTabSize: pullRequestDiffTabSize !== null ? pullRequestDiffTabSize : state.globalTabSize,
                    globalIsWordDiffEnabled: isPullRequestWordDiffEnabled,
                    globalShouldIgnoreWhitespace: isPullRequestIgnoreWhitespaceEnabled,
                    globalIsColorBlindModeEnabled: isPullRequestColorBlindModeEnabled,
                    globalIsAnnotationsEnabled: isPullRequestAnnotationsEnabled,
                    globalIsSingleFileModeEnabled: isPullRequestSingleFileModeEnabled
                };
            }
        case $235148e8a1114cc6$var$TOGGLE_SETTINGS_DIALOG:
            return {
                ...state,
                isDialogOpen: action.payload.isOpen
            };
        case $235148e8a1114cc6$export$b6f994b8e1f01270:
            return {
                ...state,
                globalDiffViewMode: action.payload.diffViewMode
            };
        case $235148e8a1114cc6$export$b531dfb2ccfb2756:
            return {
                ...state,
                globalFileViewMode: action.payload.fileViewMode
            };
        case $235148e8a1114cc6$export$3af4ec3b31f3c1de:
            return {
                ...state,
                globalTabSize: action.payload.tabSize
            };
        case $235148e8a1114cc6$export$77e036c4c8b26729:
            return {
                ...state,
                globalIsWordDiffEnabled: action.payload.isWordDiffEnabled
            };
        case $235148e8a1114cc6$export$e21a562d85593bd0:
            return {
                ...state,
                globalIsColorBlindModeEnabled: action.payload.isColorBlindModeEnabled
            };
        case $235148e8a1114cc6$export$adeb56461d6ef888:
            return {
                ...state,
                globalShouldIgnoreWhitespace: action.payload.shouldIgnoreWhitespace
            };
        case $235148e8a1114cc6$export$6dcd51d77fa0fa6:
            return {
                ...state,
                globalIsAnnotationsEnabled: action.payload.isAnnotationsEnabled
            };
        case $235148e8a1114cc6$export$316038f6a83137cb:
            return {
                ...state,
                globalIsSingleFileModeEnabled: action.payload.isSingleFileModeEnabled
            };
        case $235148e8a1114cc6$export$1e8b447202131b74:
            return {
                ...state,
                isDialogLoading: true
            };
        case $235148e8a1114cc6$export$7f0d5b60968455fa:
            return {
                ...state,
                isDialogLoading: false,
                isDialogOpen: false
            };
        default:
            return state;
    }
};

});

parcelRegister("7wUuE", function(module, exports) {

$parcel$export(module.exports, "reconcileChunks", function () { return $dc2a40fdc85ae6a1$export$936c8ed93470c359; });

var $fzXBZ = parcelRequire("fzXBZ");

var $cgl5P = parcelRequire("cgl5P");
function $dc2a40fdc85ae6a1$export$936c8ed93470c359(chunks) {
    const sortedChunks = (0, $fzXBZ.default)(chunks, [
        (chunk)=>chunk.oldStart
    ]);
    const reconciledChunks = sortedChunks.reduce((chunksSoFar, currentChunk)=>{
        if (chunksSoFar.length === 0) return [
            currentChunk
        ];
        const prevChunk = chunksSoFar[chunksSoFar.length - 1];
        const chunksOverlap = prevChunk.newStart + prevChunk.newLines >= currentChunk.newStart || prevChunk.oldStart + prevChunk.oldLines >= currentChunk.oldStart;
        if (!chunksOverlap) return [
            ...chunksSoFar,
            currentChunk
        ];
        // Merging current chunk into the previous
        const linesToKeep = currentChunk.changes.filter((line)=>{
            const isPastPrevChunksOldLines = !line.oldLine || line.oldLine > prevChunk.oldStart + prevChunk.oldLines - 1;
            const isPastPrevChunksNewLines = !line.newLine || line.newLine > prevChunk.newStart + prevChunk.newLines - 1;
            return isPastPrevChunksOldLines && isPastPrevChunksNewLines;
        });
        // Updating pieces of previous chunk to include new chunk's stuff.
        // We were previously sorting the resulting list here, but using a
        // comparison function that was non-transitive and therefore caused
        // incorrect results. The sort shouldn't be necessary at all because
        // `linesToKeep` is filtered to include only lines that are after the
        // previous chunk's lines.
        prevChunk.changes = [
            ...prevChunk.changes,
            ...linesToKeep
        ];
        const firstOldLine = prevChunk.changes.find((line)=>!!line.oldLine) || {};
        prevChunk.oldStart = firstOldLine.oldLine || 0;
        prevChunk.oldLines += linesToKeep.filter((line)=>!!line.oldLine).length;
        prevChunk.newLines += linesToKeep.filter((line)=>!!line.newLine).length;
        const firstNewLine = prevChunk.changes.find((line)=>!!line.newLine) || {};
        prevChunk.newStart = firstNewLine.newLine || 0;
        prevChunk.content = (0, $cgl5P.getContentString)(prevChunk);
        return chunksSoFar;
    }, []);
    return reconciledChunks;
}

});
parcelRegister("fzXBZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5785d894dedb7a7$export$2e2bcd8739ae039; });

var $KcLis = parcelRequire("KcLis");

var $1ul3I = parcelRequire("1ul3I");

var $5qd1l = parcelRequire("5qd1l");

var $gjAj0 = parcelRequire("gjAj0");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $b5785d894dedb7a7$var$sortBy = (0, $5qd1l.default)(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && (0, $gjAj0.default)(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && (0, $gjAj0.default)(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return (0, $1ul3I.default)(collection, (0, $KcLis.default)(iteratees, 1), []);
});
var $b5785d894dedb7a7$export$2e2bcd8739ae039 = $b5785d894dedb7a7$var$sortBy;

});
parcelRegister("1ul3I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1158edab2e5a0293$export$2e2bcd8739ae039; });

var $6t2MQ = parcelRequire("6t2MQ");

var $fVuMG = parcelRequire("fVuMG");

var $dfCpC = parcelRequire("dfCpC");

var $1cfcx = parcelRequire("1cfcx");

var $2UCWy = parcelRequire("2UCWy");

var $3TlFX = parcelRequire("3TlFX");

var $2C1Nk = parcelRequire("2C1Nk");

var $1P6AC = parcelRequire("1P6AC");

var $dEaOb = parcelRequire("dEaOb");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $1158edab2e5a0293$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = (0, $6t2MQ.default)(iteratees, function(iteratee) {
        if ((0, $dEaOb.default)(iteratee)) return function(value) {
            return (0, $fVuMG.default)(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        (0, $1P6AC.default)
    ];
    var index = -1;
    iteratees = (0, $6t2MQ.default)(iteratees, (0, $3TlFX.default)((0, $dfCpC.default)));
    var result = (0, $1cfcx.default)(collection, function(value, key, collection) {
        var criteria = (0, $6t2MQ.default)(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            "criteria": criteria,
            "index": ++index,
            "value": value
        };
    });
    return (0, $2UCWy.default)(result, function(object, other) {
        return (0, $2C1Nk.default)(object, other, orders);
    });
}
var $1158edab2e5a0293$export$2e2bcd8739ae039 = $1158edab2e5a0293$var$baseOrderBy;

});
parcelRegister("2UCWy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21ef05181065d6d0$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $21ef05181065d6d0$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
var $21ef05181065d6d0$export$2e2bcd8739ae039 = $21ef05181065d6d0$var$baseSortBy;

});

parcelRegister("2C1Nk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e7085c2cb129e77$export$2e2bcd8739ae039; });

var $6ftaP = parcelRequire("6ftaP");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $1e7085c2cb129e77$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = (0, $6ftaP.default)(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == "desc" ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
var $1e7085c2cb129e77$export$2e2bcd8739ae039 = $1e7085c2cb129e77$var$compareMultiple;

});
parcelRegister("6ftaP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48cac60ece12da44$export$2e2bcd8739ae039; });

var $7Wqa8 = parcelRequire("7Wqa8");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $48cac60ece12da44$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = (0, $7Wqa8.default)(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = (0, $7Wqa8.default)(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
var $48cac60ece12da44$export$2e2bcd8739ae039 = $48cac60ece12da44$var$compareAscending;

});



parcelRegister("5qd1l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f297b174fee4fdf$export$2e2bcd8739ae039; });

var $1P6AC = parcelRequire("1P6AC");

var $4nRoL = parcelRequire("4nRoL");

var $5ZD1t = parcelRequire("5ZD1t");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $3f297b174fee4fdf$var$baseRest(func, start) {
    return (0, $5ZD1t.default)((0, $4nRoL.default)(func, start, (0, $1P6AC.default)), func + "");
}
var $3f297b174fee4fdf$export$2e2bcd8739ae039 = $3f297b174fee4fdf$var$baseRest;

});
parcelRegister("4nRoL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3312bb3e392e67fb$export$2e2bcd8739ae039; });

var $h7uGd = parcelRequire("h7uGd");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3312bb3e392e67fb$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $3312bb3e392e67fb$var$overRest(func, start, transform) {
    start = $3312bb3e392e67fb$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $3312bb3e392e67fb$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $h7uGd.default)(func, this, otherArgs);
    };
}
var $3312bb3e392e67fb$export$2e2bcd8739ae039 = $3312bb3e392e67fb$var$overRest;

});
parcelRegister("h7uGd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c76ae38637c263df$export$2e2bcd8739ae039; });
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $c76ae38637c263df$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $c76ae38637c263df$export$2e2bcd8739ae039 = $c76ae38637c263df$var$apply;

});


parcelRegister("5ZD1t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45d0eb6137653d8f$export$2e2bcd8739ae039; });

var $kyOuk = parcelRequire("kyOuk");

var $ifxyn = parcelRequire("ifxyn");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $45d0eb6137653d8f$var$setToString = (0, $ifxyn.default)((0, $kyOuk.default));
var $45d0eb6137653d8f$export$2e2bcd8739ae039 = $45d0eb6137653d8f$var$setToString;

});
parcelRegister("kyOuk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef7e258bece93f5c$export$2e2bcd8739ae039; });

var $jFP1A = parcelRequire("jFP1A");

var $2BD2c = parcelRequire("2BD2c");

var $1P6AC = parcelRequire("1P6AC");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $ef7e258bece93f5c$var$baseSetToString = !(0, $2BD2c.default) ? (0, $1P6AC.default) : function(func, string) {
    return (0, $2BD2c.default)(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": (0, $jFP1A.default)(string),
        "writable": true
    });
};
var $ef7e258bece93f5c$export$2e2bcd8739ae039 = $ef7e258bece93f5c$var$baseSetToString;

});
parcelRegister("jFP1A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5296d17ca7a74eb$export$2e2bcd8739ae039; });
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $e5296d17ca7a74eb$var$constant(value) {
    return function() {
        return value;
    };
}
var $e5296d17ca7a74eb$export$2e2bcd8739ae039 = $e5296d17ca7a74eb$var$constant;

});


parcelRegister("ifxyn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d493a7b837c86072$export$2e2bcd8739ae039; });
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $d493a7b837c86072$var$HOT_COUNT = 800, $d493a7b837c86072$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d493a7b837c86072$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $d493a7b837c86072$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $d493a7b837c86072$var$nativeNow(), remaining = $d493a7b837c86072$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $d493a7b837c86072$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $d493a7b837c86072$export$2e2bcd8739ae039 = $d493a7b837c86072$var$shortOut;

});




parcelRegister("cgl5P", function(module, exports) {

$parcel$export(module.exports, "getContentString", function () { return $46122bf25edd0cc9$export$45517e7f94118f4d; });
function $46122bf25edd0cc9$export$45517e7f94118f4d(c) {
    return `@@ -${c.oldStart},${c.oldLines} +${c.newStart},${c.newLines} @@`;
}

});


parcelRegister("4coax", function(module, exports) {

$parcel$export(module.exports, "extractFilepath", function () { return $4845f2ad7c74d5bc$export$8198ae2428346de9; });
$parcel$export(module.exports, "extractPrevFilepath", function () { return $4845f2ad7c74d5bc$export$e816d04298aa7c83; });
$parcel$export(module.exports, "isOnFile", function () { return $4845f2ad7c74d5bc$export$a09ff125b7e355f7; });
$parcel$export(module.exports, "isFileLevel", function () { return $4845f2ad7c74d5bc$export$4a2266b227b26bd4; });

var $3WcgS = parcelRequire("3WcgS");
const $4845f2ad7c74d5bc$export$8198ae2428346de9 = (item)=>{
    if ((0, $3WcgS.isDiffStat)(item)) {
        const path = item.new ? item.new.path : item.old ? item.old.path : "";
        return path || "";
    }
    // Here we know it's a Diff
    const { to: to, from: from } = item;
    return [
        "",
        "/dev/null",
        null,
        undefined
    ].includes(to) ? from : to;
};
function $4845f2ad7c74d5bc$export$e816d04298aa7c83(file) {
    return file.fileDiffStatus === "renamed" ? file.from : undefined;
}
function $4845f2ad7c74d5bc$export$a09ff125b7e355f7(meta, file) {
    const hasFileTo = file.to !== "/dev/null" && file.to !== undefined;
    const pathToMatch = hasFileTo ? file.to : file.from;
    return !!(meta && meta.path === pathToMatch);
}
function $4845f2ad7c74d5bc$export$4a2266b227b26bd4(meta) {
    return !!(meta && !meta.to && !meta.from);
}

});
parcelRegister("3WcgS", function(module, exports) {

$parcel$export(module.exports, "isDiffStat", function () { return $a911fe7d172b7541$export$2fdeb4cb5a2b9cfa; });
$parcel$export(module.exports, "DiffStatStatus", function () { return $a911fe7d172b7541$export$32ce330c20aa61fe; });
const $a911fe7d172b7541$export$2fdeb4cb5a2b9cfa = (diff)=>{
    return "type" in diff && diff.type === "diffstat";
};
var $a911fe7d172b7541$export$32ce330c20aa61fe;
(function(DiffStatStatus) {
    DiffStatStatus["Added"] = "added";
    DiffStatStatus["Removed"] = "removed";
    DiffStatStatus["Modified"] = "modified";
    DiffStatStatus["TypeChanged"] = "type changed";
    DiffStatStatus["Renamed"] = "renamed";
    DiffStatStatus["BinaryConflict"] = "binary conflict";
    DiffStatStatus["RemoteDeleted"] = "remote deleted";
    DiffStatStatus["LocalDeleted"] = "local deleted";
    DiffStatStatus["MergeConflict"] = "merge conflict";
    DiffStatStatus["FlagsConflict"] = "flags conflict";
    DiffStatStatus["ModeConflict"] = "mode conflict";
    DiffStatStatus["TypeConflict"] = "type conflict";
    DiffStatStatus["SymlinkConflict"] = "symlink conflict";
    DiffStatStatus["DirectoryFileConflict"] = "directory/file conflict";
    DiffStatStatus["FileDirectoryConflict"] = "file/directory conflict";
    DiffStatStatus["AddRenameConflict"] = "add/rename conflict";
    DiffStatStatus["RenameAddConflict"] = "rename/add conflict";
    DiffStatStatus["DeleteRenameConflict"] = "delete/rename conflict";
    DiffStatStatus["RenameDeleteConflict"] = "rename/delete conflict";
    DiffStatStatus["RenameConflict"] = "rename conflict";
    DiffStatStatus["SuprepoConflict"] = "subrepo conflict";
})($a911fe7d172b7541$export$32ce330c20aa61fe || ($a911fe7d172b7541$export$32ce330c20aa61fe = {}));

});


parcelRegister("24sAG", function(module, exports) {
$parcel$export(module.exports, "COLLAPSE_ALL_DIFFS", function () { return (parcelRequire("dkXlf")).COLLAPSE_ALL_DIFFS; });
$parcel$export(module.exports, "EXPAND_ALL_DIFFS", function () { return (parcelRequire("dkXlf")).EXPAND_ALL_DIFFS; });
$parcel$export(module.exports, "RESTORE_DIFFS_EXPAND_STATE", function () { return (parcelRequire("dkXlf")).RESTORE_DIFFS_EXPAND_STATE; });
$parcel$export(module.exports, "TOGGLE_DIFF_EXPANSION", function () { return (parcelRequire("dkXlf")).TOGGLE_DIFF_EXPANSION; });
$parcel$export(module.exports, "TOGGLE_SIDE_BY_SIDE_MODE", function () { return (parcelRequire("dkXlf")).TOGGLE_SIDE_BY_SIDE_MODE; });
$parcel$export(module.exports, "toggleSideBySideMode", function () { return (parcelRequire("dkXlf")).toggleSideBySideMode; });
$parcel$export(module.exports, "ACTIVE_DIFF_PERMALINK", function () { return (parcelRequire("6D21P")).ACTIVE_DIFF_PERMALINK; });
$parcel$export(module.exports, "ADD_COMMENT", function () { return (parcelRequire("6D21P")).ADD_COMMENT; });
$parcel$export(module.exports, "ADD_REVIEWER", function () { return (parcelRequire("6D21P")).ADD_REVIEWER; });
$parcel$export(module.exports, "APPROVAL_ERROR", function () { return (parcelRequire("6D21P")).APPROVAL_ERROR; });
$parcel$export(module.exports, "APPROVAL_SUCCESS", function () { return (parcelRequire("6D21P")).APPROVAL_SUCCESS; });
$parcel$export(module.exports, "CHANGE_DIFF_SORT", function () { return (parcelRequire("6D21P")).CHANGE_DIFF_SORT; });
$parcel$export(module.exports, "changeDiffSort", function () { return (parcelRequire("6D21P")).changeDiffSort; });
$parcel$export(module.exports, "CLEAR_COMMENTS", function () { return (parcelRequire("6D21P")).CLEAR_COMMENTS; });
$parcel$export(module.exports, "CLEAR_IN_PROGRESS_MERGE_TASK", function () { return (parcelRequire("6D21P")).CLEAR_IN_PROGRESS_MERGE_TASK; });
$parcel$export(module.exports, "CLOSE_DIFF_COMMENTS_DIALOG", function () { return (parcelRequire("6D21P")).CLOSE_DIFF_COMMENTS_DIALOG; });
$parcel$export(module.exports, "CLOSE_FILE_COMMENT", function () { return (parcelRequire("6D21P")).CLOSE_FILE_COMMENT; });
$parcel$export(module.exports, "CLOSE_NONRENDERED_DIFF_COMMENTS_DIALOG", function () { return (parcelRequire("6D21P")).CLOSE_NONRENDERED_DIFF_COMMENTS_DIALOG; });
$parcel$export(module.exports, "CLOSE_OUTDATED_COMMENTS_DIALOG", function () { return (parcelRequire("6D21P")).CLOSE_OUTDATED_COMMENTS_DIALOG; });
$parcel$export(module.exports, "CLOSE_REVIEW_DRAFT_DIALOG", function () { return (parcelRequire("6D21P")).CLOSE_REVIEW_DRAFT_DIALOG; });
$parcel$export(module.exports, "CLOSE_SETTINGS_CHANGEBOARDING_DIALOG", function () { return (parcelRequire("6D21P")).CLOSE_SETTINGS_CHANGEBOARDING_DIALOG; });
$parcel$export(module.exports, "COLLAPSE_TASKS_CARD", function () { return (parcelRequire("6D21P")).COLLAPSE_TASKS_CARD; });
$parcel$export(module.exports, "confirmHiddenFileDialog", function () { return (parcelRequire("6D21P")).confirmHiddenFileDialog; });
$parcel$export(module.exports, "DELETE_COMMENT", function () { return (parcelRequire("6D21P")).DELETE_COMMENT; });
$parcel$export(module.exports, "DIFFS_HAVE_RENDERED", function () { return (parcelRequire("6D21P")).DIFFS_HAVE_RENDERED; });
$parcel$export(module.exports, "ENTERED_CODE_REVIEW", function () { return (parcelRequire("6D21P")).ENTERED_CODE_REVIEW; });
$parcel$export(module.exports, "EXITED_CODE_REVIEW", function () { return (parcelRequire("6D21P")).EXITED_CODE_REVIEW; });
$parcel$export(module.exports, "EXPAND_CONTEXT", function () { return (parcelRequire("6D21P")).EXPAND_CONTEXT; });
$parcel$export(module.exports, "FETCH_ALL_CHANGES_COMMENT_CONTEXT", function () { return (parcelRequire("6D21P")).FETCH_ALL_CHANGES_COMMENT_CONTEXT; });
$parcel$export(module.exports, "FETCH_BASE_REV_COMMENT_CONTEXT", function () { return (parcelRequire("6D21P")).FETCH_BASE_REV_COMMENT_CONTEXT; });
$parcel$export(module.exports, "FETCH_CODE_INSIGHTS_ANNOTATIONS", function () { return (parcelRequire("6D21P")).FETCH_CODE_INSIGHTS_ANNOTATIONS; });
$parcel$export(module.exports, "FETCH_CODE_INSIGHTS_PREINSTALL", function () { return (parcelRequire("6D21P")).FETCH_CODE_INSIGHTS_PREINSTALL; });
$parcel$export(module.exports, "FETCH_CODE_INSIGHTS_REPORTS", function () { return (parcelRequire("6D21P")).FETCH_CODE_INSIGHTS_REPORTS; });
$parcel$export(module.exports, "FETCH_COMMENT_CONTEXT", function () { return (parcelRequire("6D21P")).FETCH_COMMENT_CONTEXT; });
$parcel$export(module.exports, "FETCH_COMMENT_LIKES", function () { return (parcelRequire("6D21P")).FETCH_COMMENT_LIKES; });
$parcel$export(module.exports, "FETCH_COMMENTS", function () { return (parcelRequire("6D21P")).FETCH_COMMENTS; });
$parcel$export(module.exports, "FETCH_CONFLICTS", function () { return (parcelRequire("6D21P")).FETCH_CONFLICTS; });
$parcel$export(module.exports, "FETCH_DESTINATION_BRANCH", function () { return (parcelRequire("6D21P")).FETCH_DESTINATION_BRANCH; });
$parcel$export(module.exports, "FETCH_DIFF", function () { return (parcelRequire("6D21P")).FETCH_DIFF; });
$parcel$export(module.exports, "FETCH_DIFF_FILE", function () { return (parcelRequire("6D21P")).FETCH_DIFF_FILE; });
$parcel$export(module.exports, "FETCH_LARGE_FILE_COMMENT_CONTEXT", function () { return (parcelRequire("6D21P")).FETCH_LARGE_FILE_COMMENT_CONTEXT; });
$parcel$export(module.exports, "FETCH_MERGE_CHECKS", function () { return (parcelRequire("6D21P")).FETCH_MERGE_CHECKS; });
$parcel$export(module.exports, "FETCH_MERGE_CHECKS_RETRY", function () { return (parcelRequire("6D21P")).FETCH_MERGE_CHECKS_RETRY; });
$parcel$export(module.exports, "FETCH_OUTDATED_COMMENT_CONTEXT", function () { return (parcelRequire("6D21P")).FETCH_OUTDATED_COMMENT_CONTEXT; });
$parcel$export(module.exports, "FETCH_PENDING_COMMENT_CONTEXT", function () { return (parcelRequire("6D21P")).FETCH_PENDING_COMMENT_CONTEXT; });
$parcel$export(module.exports, "FETCH_PULL_REQUEST_ANNOTATIONS", function () { return (parcelRequire("6D21P")).FETCH_PULL_REQUEST_ANNOTATIONS; });
$parcel$export(module.exports, "FETCH_SOURCE_BRANCH_DETAILS", function () { return (parcelRequire("6D21P")).FETCH_SOURCE_BRANCH_DETAILS; });
$parcel$export(module.exports, "FETCH_TASKS", function () { return (parcelRequire("6D21P")).FETCH_TASKS; });
$parcel$export(module.exports, "FIX_MISSING_COMMITS", function () { return (parcelRequire("6D21P")).FIX_MISSING_COMMITS; });
$parcel$export(module.exports, "HIDDEN_FILE_DIALOG", function () { return (parcelRequire("6D21P")).HIDDEN_FILE_DIALOG; });
$parcel$export(module.exports, "HIDE_ERROR_DIALOG", function () { return (parcelRequire("6D21P")).HIDE_ERROR_DIALOG; });
$parcel$export(module.exports, "HIGHLIGHT_ACTIVE_TREE_ITEM", function () { return (parcelRequire("6D21P")).HIGHLIGHT_ACTIVE_TREE_ITEM; });
$parcel$export(module.exports, "HIGHLIGHT_COMMENT", function () { return (parcelRequire("6D21P")).HIGHLIGHT_COMMENT; });
$parcel$export(module.exports, "INITIAL_DIFFS_RENDERED", function () { return (parcelRequire("6D21P")).INITIAL_DIFFS_RENDERED; });
$parcel$export(module.exports, "LOAD_DIFFSTAT", function () { return (parcelRequire("6D21P")).LOAD_DIFFSTAT; });
$parcel$export(module.exports, "LOAD_PULL_REQUEST", function () { return (parcelRequire("6D21P")).LOAD_PULL_REQUEST; });
$parcel$export(module.exports, "LOAD_SSR_COMMENTS_CONTEXT", function () { return (parcelRequire("6D21P")).LOAD_SSR_COMMENTS_CONTEXT; });
$parcel$export(module.exports, "LOAD_WATCH", function () { return (parcelRequire("6D21P")).LOAD_WATCH; });
$parcel$export(module.exports, "MOCK_IR_DIFF_FETCH", function () { return (parcelRequire("6D21P")).MOCK_IR_DIFF_FETCH; });
$parcel$export(module.exports, "onEditorOpenStateChange", function () { return (parcelRequire("6D21P")).onEditorOpenStateChange; });
$parcel$export(module.exports, "onPermalinkHashChange", function () { return (parcelRequire("6D21P")).onPermalinkHashChange; });
$parcel$export(module.exports, "OPEN_DIFF_COMMENTS_DIALOG", function () { return (parcelRequire("6D21P")).OPEN_DIFF_COMMENTS_DIALOG; });
$parcel$export(module.exports, "OPEN_FILE_COMMENT", function () { return (parcelRequire("6D21P")).OPEN_FILE_COMMENT; });
$parcel$export(module.exports, "OPEN_NONRENDERED_DIFF_COMMENTS_DIALOG", function () { return (parcelRequire("6D21P")).OPEN_NONRENDERED_DIFF_COMMENTS_DIALOG; });
$parcel$export(module.exports, "OPEN_OUTDATED_COMMENTS_DIALOG", function () { return (parcelRequire("6D21P")).OPEN_OUTDATED_COMMENTS_DIALOG; });
$parcel$export(module.exports, "OPEN_REVIEW_DRAFT_DIALOG", function () { return (parcelRequire("6D21P")).OPEN_REVIEW_DRAFT_DIALOG; });
$parcel$export(module.exports, "openHiddenFileDialog", function () { return (parcelRequire("6D21P")).openHiddenFileDialog; });
$parcel$export(module.exports, "PERMALINK_HASH_CHANGE", function () { return (parcelRequire("6D21P")).PERMALINK_HASH_CHANGE; });
$parcel$export(module.exports, "POLLED_PULLREQUEST", function () { return (parcelRequire("6D21P")).POLLED_PULLREQUEST; });
$parcel$export(module.exports, "prefixed", function () { return (parcelRequire("6D21P")).prefixed; });
$parcel$export(module.exports, "PUBLISH_BASE_PULL_REQUEST_FACT", function () { return (parcelRequire("6D21P")).PUBLISH_BASE_PULL_REQUEST_FACT; });
$parcel$export(module.exports, "PUBLISH_PIPELINES_PULL_REQUEST_SCREEN_EVENT", function () { return (parcelRequire("6D21P")).PUBLISH_PIPELINES_PULL_REQUEST_SCREEN_EVENT; });
$parcel$export(module.exports, "PUBLISH_PULL_REQUEST_DIFF_FACT", function () { return (parcelRequire("6D21P")).PUBLISH_PULL_REQUEST_DIFF_FACT; });
$parcel$export(module.exports, "PUBLISH_PULL_REQUEST_TRACK_EVENT", function () { return (parcelRequire("6D21P")).PUBLISH_PULL_REQUEST_TRACK_EVENT; });
$parcel$export(module.exports, "PUBLISH_PULL_REQUEST_UI_EVENT", function () { return (parcelRequire("6D21P")).PUBLISH_PULL_REQUEST_UI_EVENT; });
$parcel$export(module.exports, "publishBasePullRequestFact", function () { return (parcelRequire("6D21P")).publishBasePullRequestFact; });
$parcel$export(module.exports, "publishPullRequestTrackEvent", function () { return (parcelRequire("6D21P")).publishPullRequestTrackEvent; });
$parcel$export(module.exports, "publishPullRequestUiEvent", function () { return (parcelRequire("6D21P")).publishPullRequestUiEvent; });
$parcel$export(module.exports, "PULL_REQUEST_OPENED", function () { return (parcelRequire("6D21P")).PULL_REQUEST_OPENED; });
$parcel$export(module.exports, "PULL_REQUEST_TAB_REDIRECT", function () { return (parcelRequire("6D21P")).PULL_REQUEST_TAB_REDIRECT; });
$parcel$export(module.exports, "REFETCH_IR_DIFF", function () { return (parcelRequire("6D21P")).REFETCH_IR_DIFF; });
$parcel$export(module.exports, "REFRESH_CODE_REVIEW_DATA", function () { return (parcelRequire("6D21P")).REFRESH_CODE_REVIEW_DATA; });
$parcel$export(module.exports, "REFRESH_CODE_REVIEW_DATA_FROM_POLL_RESULTS", function () { return (parcelRequire("6D21P")).REFRESH_CODE_REVIEW_DATA_FROM_POLL_RESULTS; });
$parcel$export(module.exports, "refreshCodeReviewData", function () { return (parcelRequire("6D21P")).refreshCodeReviewData; });
$parcel$export(module.exports, "REMOVE_REVIEWER", function () { return (parcelRequire("6D21P")).REMOVE_REVIEWER; });
$parcel$export(module.exports, "REOPEN_COMMENT", function () { return (parcelRequire("6D21P")).REOPEN_COMMENT; });
$parcel$export(module.exports, "REQUEST_CHANGES", function () { return (parcelRequire("6D21P")).REQUEST_CHANGES; });
$parcel$export(module.exports, "RESET_ACTIVE_TREE_ITEM", function () { return (parcelRequire("6D21P")).RESET_ACTIVE_TREE_ITEM; });
$parcel$export(module.exports, "RESOLVE_COMMENT", function () { return (parcelRequire("6D21P")).RESOLVE_COMMENT; });
$parcel$export(module.exports, "RETRY_LOAD_DIFF_STAT", function () { return (parcelRequire("6D21P")).RETRY_LOAD_DIFF_STAT; });
$parcel$export(module.exports, "REVERT_DIALOG", function () { return (parcelRequire("6D21P")).REVERT_DIALOG; });
$parcel$export(module.exports, "REVERT_PULL_REQUEST", function () { return (parcelRequire("6D21P")).REVERT_PULL_REQUEST; });
$parcel$export(module.exports, "revertPullRequest", function () { return (parcelRequire("6D21P")).revertPullRequest; });
$parcel$export(module.exports, "SCROLL_TO_FILE", function () { return (parcelRequire("6D21P")).SCROLL_TO_FILE; });
$parcel$export(module.exports, "scrollToAnchor", function () { return (parcelRequire("6D21P")).scrollToAnchor; });
$parcel$export(module.exports, "SET_APPROVAL_LOADER", function () { return (parcelRequire("6D21P")).SET_APPROVAL_LOADER; });
$parcel$export(module.exports, "START_WATCH", function () { return (parcelRequire("6D21P")).START_WATCH; });
$parcel$export(module.exports, "STOP_WATCH", function () { return (parcelRequire("6D21P")).STOP_WATCH; });
$parcel$export(module.exports, "TASK_CREATE", function () { return (parcelRequire("6D21P")).TASK_CREATE; });
$parcel$export(module.exports, "TASK_DELETE", function () { return (parcelRequire("6D21P")).TASK_DELETE; });
$parcel$export(module.exports, "TASK_EDIT", function () { return (parcelRequire("6D21P")).TASK_EDIT; });
$parcel$export(module.exports, "TASK_STATE_CHANGE", function () { return (parcelRequire("6D21P")).TASK_STATE_CHANGE; });
$parcel$export(module.exports, "TASKS_CLEAR_ERRORS", function () { return (parcelRequire("6D21P")).TASKS_CLEAR_ERRORS; });
$parcel$export(module.exports, "TASKS_EDIT", function () { return (parcelRequire("6D21P")).TASKS_EDIT; });
$parcel$export(module.exports, "TOGGLE_ANNOTATIONS", function () { return (parcelRequire("6D21P")).TOGGLE_ANNOTATIONS; });
$parcel$export(module.exports, "TOGGLE_COMMENT_LIKE", function () { return (parcelRequire("6D21P")).TOGGLE_COMMENT_LIKE; });
$parcel$export(module.exports, "TOGGLE_CREATE_COMMENT_TASK_INPUT", function () { return (parcelRequire("6D21P")).TOGGLE_CREATE_COMMENT_TASK_INPUT; });
$parcel$export(module.exports, "TOGGLE_DIFF_COMMENTS", function () { return (parcelRequire("6D21P")).TOGGLE_DIFF_COMMENTS; });
$parcel$export(module.exports, "TOGGLE_EDIT_COMMENT_TASK_INPUT", function () { return (parcelRequire("6D21P")).TOGGLE_EDIT_COMMENT_TASK_INPUT; });
$parcel$export(module.exports, "TOGGLE_REFETCH_BUILDS_DUMMY", function () { return (parcelRequire("6D21P")).TOGGLE_REFETCH_BUILDS_DUMMY; });
$parcel$export(module.exports, "TOGGLE_SINGLE_FILE_MODE", function () { return (parcelRequire("6D21P")).TOGGLE_SINGLE_FILE_MODE; });
$parcel$export(module.exports, "TOGGLE_SINGLE_FILE_MODE_ELIGIBILITY", function () { return (parcelRequire("6D21P")).TOGGLE_SINGLE_FILE_MODE_ELIGIBILITY; });
$parcel$export(module.exports, "TOGGLE_SINGLE_FILE_MODE_SETTINGS_HEADER_VISIBILITY", function () { return (parcelRequire("6D21P")).TOGGLE_SINGLE_FILE_MODE_SETTINGS_HEADER_VISIBILITY; });
$parcel$export(module.exports, "TOGGLE_STICKY_HEADER_ACTIVE_STATUS", function () { return (parcelRequire("6D21P")).TOGGLE_STICKY_HEADER_ACTIVE_STATUS; });
$parcel$export(module.exports, "toggleAnnotations", function () { return (parcelRequire("6D21P")).toggleAnnotations; });
$parcel$export(module.exports, "toggleDiffComments", function () { return (parcelRequire("6D21P")).toggleDiffComments; });
$parcel$export(module.exports, "UNDO_REQUEST_CHANGES", function () { return (parcelRequire("6D21P")).UNDO_REQUEST_CHANGES; });
$parcel$export(module.exports, "UNLOAD_PULL_REQUEST", function () { return (parcelRequire("6D21P")).UNLOAD_PULL_REQUEST; });
$parcel$export(module.exports, "UPDATE_COMMENT", function () { return (parcelRequire("6D21P")).UPDATE_COMMENT; });
$parcel$export(module.exports, "UPDATE_DESCRIPTION", function () { return (parcelRequire("6D21P")).UPDATE_DESCRIPTION; });
$parcel$export(module.exports, "UPDATE_EDITOR_OPEN_STATE", function () { return (parcelRequire("6D21P")).UPDATE_EDITOR_OPEN_STATE; });
$parcel$export(module.exports, "UPDATE_FILTER_COMMENTS_BY_USER", function () { return (parcelRequire("6D21P")).UPDATE_FILTER_COMMENTS_BY_USER; });
$parcel$export(module.exports, "UPDATE_PARTICIPANTS", function () { return (parcelRequire("6D21P")).UPDATE_PARTICIPANTS; });
$parcel$export(module.exports, "UPDATE_PULL_REQUEST_LINKS", function () { return (parcelRequire("6D21P")).UPDATE_PULL_REQUEST_LINKS; });
$parcel$export(module.exports, "UPDATE_TITLE", function () { return (parcelRequire("6D21P")).UPDATE_TITLE; });
$parcel$export(module.exports, "updateFilterCommentsByUser", function () { return (parcelRequire("6D21P")).updateFilterCommentsByUser; });
$parcel$export(module.exports, "VERIFY_REPO_MEMBER", function () { return (parcelRequire("6D21P")).VERIFY_REPO_MEMBER; });
$parcel$export(module.exports, "verifyRepoMember", function () { return (parcelRequire("6D21P")).verifyRepoMember; });
$parcel$export(module.exports, "watchLoading", function () { return (parcelRequire("39E4H")).watchLoading; });
$parcel$export(module.exports, "watchLoadingEnd", function () { return (parcelRequire("39E4H")).watchLoadingEnd; });

$parcel$export(module.exports, "expandContext", function () { return (parcelRequire("3Eh6V")).default; });
$parcel$export(module.exports, "fetchTasks", function () { return (parcelRequire("bQYeX")).default; });
$parcel$export(module.exports, "fetchCodeInsightsAnnotations", function () { return (parcelRequire("bEGFM")).fetchCodeInsightsAnnotations; });
$parcel$export(module.exports, "fetchCodeInsights", function () { return (parcelRequire("bEGFM")).default; });
$parcel$export(module.exports, "taskStateChange", function () { return (parcelRequire("6X71R")).default; });
$parcel$export(module.exports, "fetchSourceBranchDetails", function () { return (parcelRequire("azI4e")).default; });

var $3Eh6V = parcelRequire("3Eh6V");

var $bQYeX = parcelRequire("bQYeX");

var $bEGFM = parcelRequire("bEGFM");

var $6X71R = parcelRequire("6X71R");

var $azI4e = parcelRequire("azI4e");
parcelRequire("dkXlf");
parcelRequire("6D21P");
parcelRequire("39E4H");

var $2kKDW = parcelRequire("2kKDW");

});
parcelRegister("3Eh6V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef6232bef91c4324$export$2e2bcd8739ae039; });

var $6D21P = parcelRequire("6D21P");
const $ef6232bef91c4324$var$expandContext = (expandContextParams)=>({
        type: (0, $6D21P.EXPAND_CONTEXT).REQUEST,
        payload: expandContextParams
    });
var $ef6232bef91c4324$export$2e2bcd8739ae039 = $ef6232bef91c4324$var$expandContext;

});
parcelRegister("6D21P", function(module, exports) {

$parcel$export(module.exports, "prefixed", function () { return $4b016dcf63574f3e$export$302158222cd49bab; });
$parcel$export(module.exports, "COLLAPSE_TASKS_CARD", function () { return $4b016dcf63574f3e$export$5e6ae385529e2caf; });
$parcel$export(module.exports, "LOAD_PULL_REQUEST", function () { return $4b016dcf63574f3e$export$86a4735b229d1f08; });
$parcel$export(module.exports, "CLEAR_IN_PROGRESS_MERGE_TASK", function () { return $4b016dcf63574f3e$export$21c84ebcadc65ae7; });
$parcel$export(module.exports, "CLOSE_OUTDATED_COMMENTS_DIALOG", function () { return $4b016dcf63574f3e$export$c66d1040bb98a2cf; });
$parcel$export(module.exports, "OPEN_OUTDATED_COMMENTS_DIALOG", function () { return $4b016dcf63574f3e$export$aaf36d5917b18ff2; });
$parcel$export(module.exports, "CLOSE_REVIEW_DRAFT_DIALOG", function () { return $4b016dcf63574f3e$export$443fc982d7d6559a; });
$parcel$export(module.exports, "OPEN_REVIEW_DRAFT_DIALOG", function () { return $4b016dcf63574f3e$export$7e4e284d9c3e1f32; });
$parcel$export(module.exports, "OPEN_DIFF_COMMENTS_DIALOG", function () { return $4b016dcf63574f3e$export$f0af338232f68c35; });
$parcel$export(module.exports, "CLOSE_DIFF_COMMENTS_DIALOG", function () { return $4b016dcf63574f3e$export$ca4fbdd3d64f4dca; });
$parcel$export(module.exports, "OPEN_NONRENDERED_DIFF_COMMENTS_DIALOG", function () { return $4b016dcf63574f3e$export$ebbd47fac6e47dac; });
$parcel$export(module.exports, "CLOSE_NONRENDERED_DIFF_COMMENTS_DIALOG", function () { return $4b016dcf63574f3e$export$6a14e1da356c0f3; });
$parcel$export(module.exports, "OPEN_FILE_COMMENT", function () { return $4b016dcf63574f3e$export$a217b08389ca0913; });
$parcel$export(module.exports, "CLOSE_FILE_COMMENT", function () { return $4b016dcf63574f3e$export$2e3084c194ca4101; });
$parcel$export(module.exports, "POLLED_PULLREQUEST", function () { return $4b016dcf63574f3e$export$f57e672ead625638; });
$parcel$export(module.exports, "REQUEST_CHANGES", function () { return $4b016dcf63574f3e$export$46ad58e64d9a7f7a; });
$parcel$export(module.exports, "UNDO_REQUEST_CHANGES", function () { return $4b016dcf63574f3e$export$f92e21eacad6f261; });
$parcel$export(module.exports, "UPDATE_PARTICIPANTS", function () { return $4b016dcf63574f3e$export$3bc815fba128fe4c; });
$parcel$export(module.exports, "UPDATE_TITLE", function () { return $4b016dcf63574f3e$export$342389a5cd713e20; });
$parcel$export(module.exports, "UPDATE_DESCRIPTION", function () { return $4b016dcf63574f3e$export$60e8641319de3651; });
$parcel$export(module.exports, "REMOVE_REVIEWER", function () { return $4b016dcf63574f3e$export$ceae9316f01b024c; });
$parcel$export(module.exports, "ADD_REVIEWER", function () { return $4b016dcf63574f3e$export$557f264d75869eb3; });
$parcel$export(module.exports, "FETCH_DIFF", function () { return $4b016dcf63574f3e$export$cb0e914faa2838da; });
$parcel$export(module.exports, "FETCH_DIFF_FILE", function () { return $4b016dcf63574f3e$export$1b5d3244cea82405; });
$parcel$export(module.exports, "EXPAND_CONTEXT", function () { return $4b016dcf63574f3e$export$42a07559a4401204; });
$parcel$export(module.exports, "FETCH_COMMENT_CONTEXT", function () { return $4b016dcf63574f3e$export$68c5b71f3bf33909; });
$parcel$export(module.exports, "FETCH_CODE_INSIGHTS_PREINSTALL", function () { return $4b016dcf63574f3e$export$87b622f27cd3c557; });
$parcel$export(module.exports, "FETCH_PULL_REQUEST_ANNOTATIONS", function () { return $4b016dcf63574f3e$export$7617cf1d5e06a66; });
$parcel$export(module.exports, "FETCH_CODE_INSIGHTS_REPORTS", function () { return $4b016dcf63574f3e$export$a965ba7acef2933d; });
$parcel$export(module.exports, "FETCH_CODE_INSIGHTS_ANNOTATIONS", function () { return $4b016dcf63574f3e$export$c5024eb532bc65cb; });
$parcel$export(module.exports, "FETCH_COMMENTS", function () { return $4b016dcf63574f3e$export$fab48ebb1bf17fbd; });
$parcel$export(module.exports, "CLEAR_COMMENTS", function () { return $4b016dcf63574f3e$export$c6fcf91409af04b2; });
$parcel$export(module.exports, "FETCH_TASKS", function () { return $4b016dcf63574f3e$export$f81ca146f9baff8a; });
$parcel$export(module.exports, "TASK_STATE_CHANGE", function () { return $4b016dcf63574f3e$export$82d123dd796b492e; });
$parcel$export(module.exports, "TASK_CREATE", function () { return $4b016dcf63574f3e$export$333ea452535e2fd8; });
$parcel$export(module.exports, "TASK_EDIT", function () { return $4b016dcf63574f3e$export$ae828810604dfe15; });
$parcel$export(module.exports, "TASKS_EDIT", function () { return $4b016dcf63574f3e$export$36bc62d47f85eb31; });
$parcel$export(module.exports, "TASKS_CLEAR_ERRORS", function () { return $4b016dcf63574f3e$export$cf367fd7ccc799ba; });
$parcel$export(module.exports, "TASK_DELETE", function () { return $4b016dcf63574f3e$export$292f1800c703f25; });
$parcel$export(module.exports, "TOGGLE_CREATE_COMMENT_TASK_INPUT", function () { return $4b016dcf63574f3e$export$6963eb595d72a854; });
$parcel$export(module.exports, "TOGGLE_EDIT_COMMENT_TASK_INPUT", function () { return $4b016dcf63574f3e$export$d508eff5b6e0c4f; });
$parcel$export(module.exports, "ADD_COMMENT", function () { return $4b016dcf63574f3e$export$35aff3ed3a26081d; });
$parcel$export(module.exports, "DELETE_COMMENT", function () { return $4b016dcf63574f3e$export$91e9174fbc20c283; });
$parcel$export(module.exports, "UPDATE_COMMENT", function () { return $4b016dcf63574f3e$export$e4c3b88d3098e3ee; });
$parcel$export(module.exports, "RESOLVE_COMMENT", function () { return $4b016dcf63574f3e$export$478e49c798fa5878; });
$parcel$export(module.exports, "REOPEN_COMMENT", function () { return $4b016dcf63574f3e$export$28a63bc2d8ba0060; });
$parcel$export(module.exports, "LOAD_DIFFSTAT", function () { return $4b016dcf63574f3e$export$4377980a8f9c3184; });
$parcel$export(module.exports, "RETRY_LOAD_DIFF_STAT", function () { return $4b016dcf63574f3e$export$989df5be27f203aa; });
$parcel$export(module.exports, "START_WATCH", function () { return $4b016dcf63574f3e$export$63dd65e73bbe92c3; });
$parcel$export(module.exports, "STOP_WATCH", function () { return $4b016dcf63574f3e$export$2c546d01e985a3b; });
$parcel$export(module.exports, "LOAD_WATCH", function () { return $4b016dcf63574f3e$export$1304adb3ee9a9669; });
$parcel$export(module.exports, "FETCH_OUTDATED_COMMENT_CONTEXT", function () { return $4b016dcf63574f3e$export$f1056c70eb6d0365; });
$parcel$export(module.exports, "FETCH_LARGE_FILE_COMMENT_CONTEXT", function () { return $4b016dcf63574f3e$export$e3305469b4d5c559; });
$parcel$export(module.exports, "FETCH_PENDING_COMMENT_CONTEXT", function () { return $4b016dcf63574f3e$export$5bf0b32e56540220; });
$parcel$export(module.exports, "FETCH_BASE_REV_COMMENT_CONTEXT", function () { return $4b016dcf63574f3e$export$d1b7e0e695dc3e31; });
$parcel$export(module.exports, "FETCH_ALL_CHANGES_COMMENT_CONTEXT", function () { return $4b016dcf63574f3e$export$c3393629a51aafc5; });
$parcel$export(module.exports, "FETCH_CONFLICTS", function () { return $4b016dcf63574f3e$export$eaa38014b47c15c2; });
$parcel$export(module.exports, "FETCH_MERGE_CHECKS", function () { return $4b016dcf63574f3e$export$396fd7a9baca6491; });
$parcel$export(module.exports, "FETCH_MERGE_CHECKS_RETRY", function () { return $4b016dcf63574f3e$export$5e2a14c3c3dbe8a4; });
$parcel$export(module.exports, "HIDE_ERROR_DIALOG", function () { return $4b016dcf63574f3e$export$1fc255a56a9aa87f; });
$parcel$export(module.exports, "APPROVAL_SUCCESS", function () { return $4b016dcf63574f3e$export$799315a86b2a0e75; });
$parcel$export(module.exports, "APPROVAL_ERROR", function () { return $4b016dcf63574f3e$export$60e4a8c560ab2c0b; });
$parcel$export(module.exports, "SET_APPROVAL_LOADER", function () { return $4b016dcf63574f3e$export$a10ed5a64e2fd221; });
$parcel$export(module.exports, "UNLOAD_PULL_REQUEST", function () { return $4b016dcf63574f3e$export$6fdc3c3d153728c4; });
$parcel$export(module.exports, "ENTERED_CODE_REVIEW", function () { return $4b016dcf63574f3e$export$c76ae90aeeaafea; });
$parcel$export(module.exports, "EXITED_CODE_REVIEW", function () { return $4b016dcf63574f3e$export$b165377a8e7e9138; });
$parcel$export(module.exports, "DIFFS_HAVE_RENDERED", function () { return $4b016dcf63574f3e$export$c6fdac54942613a; });
$parcel$export(module.exports, "INITIAL_DIFFS_RENDERED", function () { return $4b016dcf63574f3e$export$4132ba1238231fb8; });
$parcel$export(module.exports, "HIGHLIGHT_ACTIVE_TREE_ITEM", function () { return $4b016dcf63574f3e$export$79621ebf2dc2f76; });
$parcel$export(module.exports, "HIGHLIGHT_COMMENT", function () { return $4b016dcf63574f3e$export$a985f22edf2b1153; });
$parcel$export(module.exports, "PERMALINK_HASH_CHANGE", function () { return $4b016dcf63574f3e$export$ae72331d008c4f6a; });
$parcel$export(module.exports, "ACTIVE_DIFF_PERMALINK", function () { return $4b016dcf63574f3e$export$39ad66cadee346e; });
$parcel$export(module.exports, "RESET_ACTIVE_TREE_ITEM", function () { return $4b016dcf63574f3e$export$5b5dd3cdf3f812d1; });
$parcel$export(module.exports, "TOGGLE_SINGLE_FILE_MODE", function () { return $4b016dcf63574f3e$export$3afec4be30b448aa; });
$parcel$export(module.exports, "TOGGLE_SINGLE_FILE_MODE_ELIGIBILITY", function () { return $4b016dcf63574f3e$export$6cfa2c46d04bb7e2; });
$parcel$export(module.exports, "TOGGLE_SINGLE_FILE_MODE_SETTINGS_HEADER_VISIBILITY", function () { return $4b016dcf63574f3e$export$d8d366b1ed4c8e60; });
$parcel$export(module.exports, "TOGGLE_STICKY_HEADER_ACTIVE_STATUS", function () { return $4b016dcf63574f3e$export$a890299639b4b9fb; });
$parcel$export(module.exports, "SCROLL_TO_FILE", function () { return $4b016dcf63574f3e$export$9630faf90246929; });
$parcel$export(module.exports, "scrollToAnchor", function () { return $4b016dcf63574f3e$export$ddf9502ca131a979; });
$parcel$export(module.exports, "onPermalinkHashChange", function () { return $4b016dcf63574f3e$export$df3ad98bbbc11319; });
$parcel$export(module.exports, "PUBLISH_BASE_PULL_REQUEST_FACT", function () { return $4b016dcf63574f3e$export$a435386030dd89dc; });
$parcel$export(module.exports, "publishBasePullRequestFact", function () { return $4b016dcf63574f3e$export$ed0bc3f866d2c15a; });
$parcel$export(module.exports, "PUBLISH_PULL_REQUEST_DIFF_FACT", function () { return $4b016dcf63574f3e$export$68508fc8d6422400; });
$parcel$export(module.exports, "REFRESH_CODE_REVIEW_DATA", function () { return $4b016dcf63574f3e$export$1a53ed2c3ad2adbb; });
$parcel$export(module.exports, "REFRESH_CODE_REVIEW_DATA_FROM_POLL_RESULTS", function () { return $4b016dcf63574f3e$export$e2d529a0e88b101c; });
$parcel$export(module.exports, "refreshCodeReviewData", function () { return $4b016dcf63574f3e$export$391878bba108abb5; });
$parcel$export(module.exports, "CLOSE_SETTINGS_CHANGEBOARDING_DIALOG", function () { return $4b016dcf63574f3e$export$23a9337feeb327a; });
$parcel$export(module.exports, "UPDATE_EDITOR_OPEN_STATE", function () { return $4b016dcf63574f3e$export$5df6ee79e5acd568; });
$parcel$export(module.exports, "onEditorOpenStateChange", function () { return $4b016dcf63574f3e$export$9416170437d8a03b; });
$parcel$export(module.exports, "UPDATE_PULL_REQUEST_LINKS", function () { return $4b016dcf63574f3e$export$38540431704b4bf1; });
$parcel$export(module.exports, "REVERT_DIALOG", function () { return $4b016dcf63574f3e$export$3e2b9721d7af8c27; });
$parcel$export(module.exports, "REVERT_PULL_REQUEST", function () { return $4b016dcf63574f3e$export$92bcb0f69c51c5e2; });
$parcel$export(module.exports, "revertPullRequest", function () { return $4b016dcf63574f3e$export$bca396ca8b8ab129; });
$parcel$export(module.exports, "FETCH_DESTINATION_BRANCH", function () { return $4b016dcf63574f3e$export$cd3c625e7af5fa67; });
$parcel$export(module.exports, "FETCH_SOURCE_BRANCH_DETAILS", function () { return $4b016dcf63574f3e$export$57f0f121896b46a3; });
$parcel$export(module.exports, "FETCH_COMMENT_LIKES", function () { return $4b016dcf63574f3e$export$4ea3d7bf104af606; });
$parcel$export(module.exports, "TOGGLE_COMMENT_LIKE", function () { return $4b016dcf63574f3e$export$20bfafd058a06f5d; });
$parcel$export(module.exports, "PULL_REQUEST_OPENED", function () { return $4b016dcf63574f3e$export$2bc113927e6f322c; });
$parcel$export(module.exports, "PUBLISH_PULL_REQUEST_TRACK_EVENT", function () { return $4b016dcf63574f3e$export$bacdd2597058c1e3; });
$parcel$export(module.exports, "PUBLISH_PIPELINES_PULL_REQUEST_SCREEN_EVENT", function () { return $4b016dcf63574f3e$export$e71aa563c24b82d1; });
$parcel$export(module.exports, "PUBLISH_PULL_REQUEST_UI_EVENT", function () { return $4b016dcf63574f3e$export$beab7fea1965ccbe; });
$parcel$export(module.exports, "publishPullRequestTrackEvent", function () { return $4b016dcf63574f3e$export$4d8c7412d553a618; });
$parcel$export(module.exports, "publishPullRequestUiEvent", function () { return $4b016dcf63574f3e$export$1976b26be0b80d27; });
$parcel$export(module.exports, "TOGGLE_ANNOTATIONS", function () { return $4b016dcf63574f3e$export$8c039ff5857b79ab; });
$parcel$export(module.exports, "TOGGLE_DIFF_COMMENTS", function () { return $4b016dcf63574f3e$export$f30b0f49de70a986; });
$parcel$export(module.exports, "toggleAnnotations", function () { return $4b016dcf63574f3e$export$fd495298ad6ce996; });
$parcel$export(module.exports, "toggleDiffComments", function () { return $4b016dcf63574f3e$export$48079d1a049e42bd; });
$parcel$export(module.exports, "UPDATE_FILTER_COMMENTS_BY_USER", function () { return $4b016dcf63574f3e$export$526623b2cc6e79d5; });
$parcel$export(module.exports, "updateFilterCommentsByUser", function () { return $4b016dcf63574f3e$export$2c9cd79ad044c070; });
$parcel$export(module.exports, "CHANGE_DIFF_SORT", function () { return $4b016dcf63574f3e$export$d3c92b92cb5a2df3; });
$parcel$export(module.exports, "changeDiffSort", function () { return $4b016dcf63574f3e$export$a06f5127c900bb0d; });
$parcel$export(module.exports, "HIDDEN_FILE_DIALOG", function () { return $4b016dcf63574f3e$export$bc19ff00f0f47071; });
$parcel$export(module.exports, "openHiddenFileDialog", function () { return $4b016dcf63574f3e$export$2996e251f3628b56; });
$parcel$export(module.exports, "confirmHiddenFileDialog", function () { return $4b016dcf63574f3e$export$9383fbf0e2ef4953; });
$parcel$export(module.exports, "LOAD_SSR_COMMENTS_CONTEXT", function () { return $4b016dcf63574f3e$export$de90804085fd111e; });
$parcel$export(module.exports, "VERIFY_REPO_MEMBER", function () { return $4b016dcf63574f3e$export$83478ca6af64d876; });
$parcel$export(module.exports, "verifyRepoMember", function () { return $4b016dcf63574f3e$export$fbdea8b9a83ca932; });
$parcel$export(module.exports, "FIX_MISSING_COMMITS", function () { return $4b016dcf63574f3e$export$9717262a23545d86; });
$parcel$export(module.exports, "TOGGLE_REFETCH_BUILDS_DUMMY", function () { return $4b016dcf63574f3e$export$8b36367810185560; });
$parcel$export(module.exports, "PULL_REQUEST_TAB_REDIRECT", function () { return $4b016dcf63574f3e$export$3df6ceae566ba14c; });
$parcel$export(module.exports, "MOCK_IR_DIFF_FETCH", function () { return $4b016dcf63574f3e$export$f0ff4e75efee7b5; });
$parcel$export(module.exports, "REFETCH_IR_DIFF", function () { return $4b016dcf63574f3e$export$4cb0f82317da4a2; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
const $4b016dcf63574f3e$export$302158222cd49bab = (action)=>`pullRequest/${action}`;
const $4b016dcf63574f3e$export$5e6ae385529e2caf = $4b016dcf63574f3e$export$302158222cd49bab("COLLAPSE_TASKS_CARD");
const $4b016dcf63574f3e$export$86a4735b229d1f08 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("LOAD_PULL_REQUEST"));
const $4b016dcf63574f3e$export$21c84ebcadc65ae7 = $4b016dcf63574f3e$export$302158222cd49bab("CLEAR_IN_PROGRESS_MERGE_TASK");
const $4b016dcf63574f3e$export$c66d1040bb98a2cf = $4b016dcf63574f3e$export$302158222cd49bab("CLOSE_OUTDATED_COMMENTS_DIALOG");
const $4b016dcf63574f3e$export$aaf36d5917b18ff2 = $4b016dcf63574f3e$export$302158222cd49bab("OPEN_OUTDATED_COMMENTS_DIALOG");
const $4b016dcf63574f3e$export$443fc982d7d6559a = $4b016dcf63574f3e$export$302158222cd49bab("CLOSE_REVIEW_DRAFT_DIALOG");
const $4b016dcf63574f3e$export$7e4e284d9c3e1f32 = $4b016dcf63574f3e$export$302158222cd49bab("OPEN_REVIEW_DRAFT_DIALOG");
const $4b016dcf63574f3e$export$f0af338232f68c35 = $4b016dcf63574f3e$export$302158222cd49bab("OPEN_DIFF_COMMENTS_DIALOG");
const $4b016dcf63574f3e$export$ca4fbdd3d64f4dca = $4b016dcf63574f3e$export$302158222cd49bab("CLOSE_DIFF_COMMENTS_DIALOG");
const $4b016dcf63574f3e$export$ebbd47fac6e47dac = $4b016dcf63574f3e$export$302158222cd49bab("OPEN_NONRENDERED_DIFF_COMMENTS_DIALOG");
const $4b016dcf63574f3e$export$6a14e1da356c0f3 = $4b016dcf63574f3e$export$302158222cd49bab("CLOSE_NONRENDERED_DIFF_COMMENTS_DIALOG");
const $4b016dcf63574f3e$export$a217b08389ca0913 = $4b016dcf63574f3e$export$302158222cd49bab("OPEN_FILE_COMMENT");
const $4b016dcf63574f3e$export$2e3084c194ca4101 = $4b016dcf63574f3e$export$302158222cd49bab("CLOSE_FILE_COMMENT");
const $4b016dcf63574f3e$export$b81c155dda2925ae = $4b016dcf63574f3e$export$302158222cd49bab("COMMIT_RANGE_CHANGE");
const $4b016dcf63574f3e$export$f57e672ead625638 = $4b016dcf63574f3e$export$302158222cd49bab("POLLED_PULLREQUEST");
const $4b016dcf63574f3e$export$46ad58e64d9a7f7a = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("REQUEST_CHANGES"));
const $4b016dcf63574f3e$export$f92e21eacad6f261 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("UNDO_REQUEST_CHANGES"));
const $4b016dcf63574f3e$export$3bc815fba128fe4c = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("UPDATE_PARTICIPANTS"));
const $4b016dcf63574f3e$export$342389a5cd713e20 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("UPDATE_TITLE"));
const $4b016dcf63574f3e$export$60e8641319de3651 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("UPDATE_DESCRIPTION"));
const $4b016dcf63574f3e$export$ceae9316f01b024c = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("REMOVE_REVIEWER"));
const $4b016dcf63574f3e$export$557f264d75869eb3 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("ADD_REVIEWER"));
const $4b016dcf63574f3e$export$cb0e914faa2838da = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("FETCH_DIFF"));
const $4b016dcf63574f3e$export$1b5d3244cea82405 = $4b016dcf63574f3e$export$302158222cd49bab("FETCH_DIFF_FILE");
const $4b016dcf63574f3e$export$42a07559a4401204 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("EXPAND_CONTEXT"));
const $4b016dcf63574f3e$export$68c5b71f3bf33909 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("FETCH_COMMENT_CONTEXT"));
const $4b016dcf63574f3e$export$87b622f27cd3c557 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("FETCH_CODE_INSIGHTS_PREINSTALL"));
const $4b016dcf63574f3e$export$7617cf1d5e06a66 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("FETCH_PULL_REQUEST_ANNOTATIONS"));
const $4b016dcf63574f3e$export$a965ba7acef2933d = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("FETCH_CODE_INSIGHTS_REPORTS"));
const $4b016dcf63574f3e$export$c5024eb532bc65cb = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("FETCH_CODE_INSIGHTS_ANNOTATIONS"));
const $4b016dcf63574f3e$export$fab48ebb1bf17fbd = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("FETCH_COMMENTS"));
const $4b016dcf63574f3e$export$c6fcf91409af04b2 = $4b016dcf63574f3e$export$302158222cd49bab("CLEAR_COMMENTS");
const $4b016dcf63574f3e$export$f81ca146f9baff8a = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("FETCH_TASKS"));
const $4b016dcf63574f3e$export$82d123dd796b492e = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("TASK_STATE_CHANGE"));
const $4b016dcf63574f3e$export$333ea452535e2fd8 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("TASK_CREATE"));
const $4b016dcf63574f3e$export$ae828810604dfe15 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("TASK_EDIT"));
const $4b016dcf63574f3e$export$36bc62d47f85eb31 = {
    ...(0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("TASKS_EDIT")),
    PARTIAL_SUCCESS: `${$4b016dcf63574f3e$export$302158222cd49bab("TASKS_EDIT")}_PARTIAL_SUCCESS`
};
const $4b016dcf63574f3e$export$cf367fd7ccc799ba = $4b016dcf63574f3e$export$302158222cd49bab("TASKS_CLEAR_ERRORS");
const $4b016dcf63574f3e$export$292f1800c703f25 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("TASK_DELETE"));
const $4b016dcf63574f3e$export$6963eb595d72a854 = $4b016dcf63574f3e$export$302158222cd49bab("TOGGLE_CREATE_COMMENT_TASK_INPUT");
const $4b016dcf63574f3e$export$d508eff5b6e0c4f = $4b016dcf63574f3e$export$302158222cd49bab("TOGGLE_EDIT_COMMENT_TASK_INPUT");
const $4b016dcf63574f3e$export$35aff3ed3a26081d = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("ADD_COMMENT"));
const $4b016dcf63574f3e$export$91e9174fbc20c283 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("DELETE_COMMENT"));
const $4b016dcf63574f3e$export$e4c3b88d3098e3ee = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("UPDATE_COMMENT"));
const $4b016dcf63574f3e$export$478e49c798fa5878 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("RESOLVE_COMMENT"));
const $4b016dcf63574f3e$export$28a63bc2d8ba0060 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("REOPEN_COMMENT"));
const $4b016dcf63574f3e$export$4377980a8f9c3184 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("LOAD_DIFFSTAT"));
const $4b016dcf63574f3e$export$989df5be27f203aa = "RETRY_LOAD_DIFF_STAT";
const $4b016dcf63574f3e$export$63dd65e73bbe92c3 = (0, $2MctD.createAsyncActionE)($4b016dcf63574f3e$export$302158222cd49bab("START_WATCH"));
const $4b016dcf63574f3e$export$2c546d01e985a3b = (0, $2MctD.createAsyncActionE)($4b016dcf63574f3e$export$302158222cd49bab("STOP_WATCH"));
const $4b016dcf63574f3e$export$1304adb3ee9a9669 = (0, $2MctD.createAsyncActionE)($4b016dcf63574f3e$export$302158222cd49bab("LOAD_WATCH"));
const $4b016dcf63574f3e$export$f1056c70eb6d0365 = (0, $2MctD.createAsyncAction)("FETCH_OUTDATED_COMMENT_CONTEXT");
const $4b016dcf63574f3e$export$e3305469b4d5c559 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("FETCH_LARGE_FILE_COMMENT_CONTEXT"));
const $4b016dcf63574f3e$export$5bf0b32e56540220 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("FETCH_PENDING_COMMENT_CONTEXT"));
const $4b016dcf63574f3e$export$d1b7e0e695dc3e31 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("FETCH_BASE_REV_COMMENT_CONTEXT"));
const $4b016dcf63574f3e$export$c3393629a51aafc5 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("FETCH_ALL_CHANGES_COMMENT_CONTEXT"));
const $4b016dcf63574f3e$export$eaa38014b47c15c2 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("FETCH_CONFLICTS"));
const $4b016dcf63574f3e$export$396fd7a9baca6491 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("FETCH_MERGE_CHECKS"));
const $4b016dcf63574f3e$export$5e2a14c3c3dbe8a4 = $4b016dcf63574f3e$export$302158222cd49bab("FETCH_MERGE_CHECKS_RETRY");
const $4b016dcf63574f3e$export$1fc255a56a9aa87f = $4b016dcf63574f3e$export$302158222cd49bab("HIDE_ERROR_DIALOG");
const $4b016dcf63574f3e$export$799315a86b2a0e75 = $4b016dcf63574f3e$export$302158222cd49bab("APPROVAL_SUCCESS");
const $4b016dcf63574f3e$export$60e4a8c560ab2c0b = $4b016dcf63574f3e$export$302158222cd49bab("APPROVAL_ERROR");
const $4b016dcf63574f3e$export$a10ed5a64e2fd221 = $4b016dcf63574f3e$export$302158222cd49bab("SET_APPROVAL_LOADER");
const $4b016dcf63574f3e$export$6fdc3c3d153728c4 = $4b016dcf63574f3e$export$302158222cd49bab("UNLOAD_PULL_REQUEST");
const $4b016dcf63574f3e$export$c76ae90aeeaafea = $4b016dcf63574f3e$export$302158222cd49bab("ENTERED_CODE_REVIEW");
const $4b016dcf63574f3e$export$b165377a8e7e9138 = $4b016dcf63574f3e$export$302158222cd49bab("EXITED_CODE_REVIEW");
const $4b016dcf63574f3e$export$c6fdac54942613a = $4b016dcf63574f3e$export$302158222cd49bab("DIFFS_HAVE_RENDERED");
const $4b016dcf63574f3e$export$4132ba1238231fb8 = $4b016dcf63574f3e$export$302158222cd49bab("INITIAL_DIFFS_RENDERED");
const $4b016dcf63574f3e$export$79621ebf2dc2f76 = $4b016dcf63574f3e$export$302158222cd49bab("HIGHLIGHT_ACTIVE_TREE_ITEM");
const $4b016dcf63574f3e$export$a985f22edf2b1153 = $4b016dcf63574f3e$export$302158222cd49bab("HIGHLIGHT_COMMENT");
const $4b016dcf63574f3e$export$ae72331d008c4f6a = $4b016dcf63574f3e$export$302158222cd49bab("PERMALINK_HASH_CHANGE");
const $4b016dcf63574f3e$export$39ad66cadee346e = $4b016dcf63574f3e$export$302158222cd49bab("ACTIVE_DIFF_PERMALINK");
const $4b016dcf63574f3e$export$5b5dd3cdf3f812d1 = $4b016dcf63574f3e$export$302158222cd49bab("RESET_ACTIVE_TREE_ITEM");
const $4b016dcf63574f3e$export$827788443ef1dbf5 = $4b016dcf63574f3e$export$302158222cd49bab("PUBLISH_FILEPATH_CLICKED_FACT");
const $4b016dcf63574f3e$export$3afec4be30b448aa = $4b016dcf63574f3e$export$302158222cd49bab("TOGGLE_SINGLE_FILE_MODE");
const $4b016dcf63574f3e$export$6cfa2c46d04bb7e2 = $4b016dcf63574f3e$export$302158222cd49bab("TOGGLE_SINGLE_FILE_MODE_ELIGIBILITY");
const $4b016dcf63574f3e$export$d8d366b1ed4c8e60 = $4b016dcf63574f3e$export$302158222cd49bab("TOGGLE_SINGLE_FILE_MODE_SETTINGS_HEADER_VISIBILITY");
const $4b016dcf63574f3e$export$a890299639b4b9fb = $4b016dcf63574f3e$export$302158222cd49bab("TOGGLE_STICKY_HEADER_ACTIVE_STATUS");
const $4b016dcf63574f3e$export$9630faf90246929 = $4b016dcf63574f3e$export$302158222cd49bab("SCROLL_TO_FILE");
const $4b016dcf63574f3e$export$ddf9502ca131a979 = (anchorId, skipSagaScroll = false)=>({
        type: $4b016dcf63574f3e$export$9630faf90246929,
        payload: anchorId,
        skipSagaScroll: skipSagaScroll
    });
const $4b016dcf63574f3e$export$df3ad98bbbc11319 = (permalink)=>({
        type: $4b016dcf63574f3e$export$ae72331d008c4f6a,
        payload: permalink
    });
const $4b016dcf63574f3e$export$a435386030dd89dc = $4b016dcf63574f3e$export$302158222cd49bab("PUBLISH_BASE_PULL_REQUEST_FACT");
const $4b016dcf63574f3e$export$ed0bc3f866d2c15a = (factName, extraFactData)=>({
        type: $4b016dcf63574f3e$export$a435386030dd89dc,
        payload: {
            name: factName,
            extraFactData: extraFactData
        }
    });
const $4b016dcf63574f3e$export$68508fc8d6422400 = $4b016dcf63574f3e$export$302158222cd49bab("PUBLISH_PULL_REQUEST_DIFF_FACT");
const $4b016dcf63574f3e$export$1a53ed2c3ad2adbb = $4b016dcf63574f3e$export$302158222cd49bab("REFRESH_CODE_REVIEW_DATA");
const $4b016dcf63574f3e$export$e2d529a0e88b101c = $4b016dcf63574f3e$export$302158222cd49bab("REFRESH_CODE_REVIEW_DATA_FROM_POLL_RESULTS");
const $4b016dcf63574f3e$export$391878bba108abb5 = (payload)=>({
        type: $4b016dcf63574f3e$export$1a53ed2c3ad2adbb,
        payload: payload
    });
const $4b016dcf63574f3e$export$1916104e4862358a = $4b016dcf63574f3e$export$302158222cd49bab("UPDATE_BUILDS");
const $4b016dcf63574f3e$export$23a9337feeb327a = $4b016dcf63574f3e$export$302158222cd49bab("CLOSE_SETTINGS_CHANGEBOARDING_DIALOG");
const $4b016dcf63574f3e$export$5df6ee79e5acd568 = $4b016dcf63574f3e$export$302158222cd49bab("UPDATE_EDITOR_OPEN_STATE");
const $4b016dcf63574f3e$export$9416170437d8a03b = (isOpen)=>({
        type: $4b016dcf63574f3e$export$5df6ee79e5acd568,
        payload: isOpen
    });
class $4b016dcf63574f3e$export$cfc61e8ad8efcf65 {
    constructor(owner, slug, id){
        this.owner = owner;
        this.slug = slug;
        this.id = id;
        this.type = $4b016dcf63574f3e$export$c76ae90aeeaafea;
    }
}
const $4b016dcf63574f3e$export$38540431704b4bf1 = $4b016dcf63574f3e$export$302158222cd49bab("UPDATE_PULL_REQUEST_LINKS");
const $4b016dcf63574f3e$export$3e2b9721d7af8c27 = {
    OPEN: $4b016dcf63574f3e$export$302158222cd49bab("OPEN_REVERT_DIALOG"),
    CLOSE: $4b016dcf63574f3e$export$302158222cd49bab("CLOSE_REVERT_DIALOG")
};
const $4b016dcf63574f3e$export$92bcb0f69c51c5e2 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("REVERT_PULL_REQUEST"));
const $4b016dcf63574f3e$export$bca396ca8b8ab129 = (options)=>({
        type: $4b016dcf63574f3e$export$92bcb0f69c51c5e2.REQUEST,
        payload: options
    });
const $4b016dcf63574f3e$export$cd3c625e7af5fa67 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("FETCH_DESTINATION_BRANCH"));
const $4b016dcf63574f3e$export$57f0f121896b46a3 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("FETCH_SOURCE_BRANCH_DETAILS"));
const $4b016dcf63574f3e$export$4ea3d7bf104af606 = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("FETCH_COMMENT_LIKES"));
const $4b016dcf63574f3e$export$20bfafd058a06f5d = (0, $2MctD.createAsyncAction)($4b016dcf63574f3e$export$302158222cd49bab("TOGGLE_COMMENT_LIKE"));
const $4b016dcf63574f3e$export$2bc113927e6f322c = $4b016dcf63574f3e$export$302158222cd49bab("PULL_REQUEST_OPENED");
const $4b016dcf63574f3e$export$bacdd2597058c1e3 = $4b016dcf63574f3e$export$302158222cd49bab("PUBLISH_PULL_REQUEST_TRACK_EVENT");
const $4b016dcf63574f3e$export$e71aa563c24b82d1 = $4b016dcf63574f3e$export$302158222cd49bab("PUBLISH_PIPELINES_PULL_REQUEST_SCREEN_EVENT");
const $4b016dcf63574f3e$export$beab7fea1965ccbe = $4b016dcf63574f3e$export$302158222cd49bab("PUBLISH_PULL_REQUEST_UI_EVENT");
const $4b016dcf63574f3e$export$4d8c7412d553a618 = (payload)=>({
        type: $4b016dcf63574f3e$export$bacdd2597058c1e3,
        payload: payload
    });
const $4b016dcf63574f3e$export$bbc59c07df387b18 = (payload)=>({
        type: $4b016dcf63574f3e$export$e71aa563c24b82d1,
        payload: payload
    });
const $4b016dcf63574f3e$export$1976b26be0b80d27 = (payload)=>({
        type: $4b016dcf63574f3e$export$beab7fea1965ccbe,
        payload: payload
    });
const $4b016dcf63574f3e$export$8c039ff5857b79ab = $4b016dcf63574f3e$export$302158222cd49bab("TOGGLE_ANNOTATIONS");
const $4b016dcf63574f3e$export$f30b0f49de70a986 = $4b016dcf63574f3e$export$302158222cd49bab("TOGGLE_DIFF_COMMENTS");
const $4b016dcf63574f3e$export$fd495298ad6ce996 = (payload)=>({
        type: $4b016dcf63574f3e$export$8c039ff5857b79ab,
        payload: payload
    });
const $4b016dcf63574f3e$export$48079d1a049e42bd = (payload)=>({
        type: $4b016dcf63574f3e$export$f30b0f49de70a986,
        payload: payload
    });
const $4b016dcf63574f3e$export$526623b2cc6e79d5 = $4b016dcf63574f3e$export$302158222cd49bab("UPDATE_FILTER_COMMENTS_BY_USER");
const $4b016dcf63574f3e$export$2c9cd79ad044c070 = (payload)=>({
        type: $4b016dcf63574f3e$export$526623b2cc6e79d5,
        payload: payload
    });
const $4b016dcf63574f3e$export$d3c92b92cb5a2df3 = $4b016dcf63574f3e$export$302158222cd49bab("CHANGE_DIFF_SORT");
const $4b016dcf63574f3e$export$a06f5127c900bb0d = (payload)=>({
        type: $4b016dcf63574f3e$export$d3c92b92cb5a2df3,
        payload: payload
    });
const $4b016dcf63574f3e$export$bc19ff00f0f47071 = {
    OPEN: $4b016dcf63574f3e$export$302158222cd49bab("OPEN_HIDDEN_FILE_DIALOG"),
    CONFIRM: $4b016dcf63574f3e$export$302158222cd49bab("CONFIRM_HIDDEN_FILE_DIALOG"),
    CANCEL: $4b016dcf63574f3e$export$302158222cd49bab("CANCEL_HIDDEN_FILE_DIALOG")
};
const $4b016dcf63574f3e$export$2996e251f3628b56 = (anchorId)=>({
        type: $4b016dcf63574f3e$export$bc19ff00f0f47071.OPEN,
        payload: anchorId
    });
const $4b016dcf63574f3e$export$9383fbf0e2ef4953 = (anchorId)=>({
        type: $4b016dcf63574f3e$export$bc19ff00f0f47071.CONFIRM,
        payload: anchorId
    });
const $4b016dcf63574f3e$export$de90804085fd111e = $4b016dcf63574f3e$export$302158222cd49bab("LOAD_SSR_COMMENTS_CONTEXT");
const $4b016dcf63574f3e$export$83478ca6af64d876 = $4b016dcf63574f3e$export$302158222cd49bab("VERIFY_REPO_MEMBER");
const $4b016dcf63574f3e$export$fbdea8b9a83ca932 = (userAaid, displayName)=>({
        type: $4b016dcf63574f3e$export$83478ca6af64d876,
        payload: {
            userAaid: userAaid,
            displayName: displayName
        }
    });
const $4b016dcf63574f3e$export$9717262a23545d86 = {
    REQUEST: $4b016dcf63574f3e$export$302158222cd49bab("FIX_MISSING_COMMITS_REQUEST"),
    SUCCESS: $4b016dcf63574f3e$export$302158222cd49bab("FIX_MISSING_COMMITS_SUCCESS"),
    ERROR: $4b016dcf63574f3e$export$302158222cd49bab("FIX_MISSING_COMMITS_ERROR")
};
const $4b016dcf63574f3e$export$8b36367810185560 = $4b016dcf63574f3e$export$302158222cd49bab("TOGGLE_REFETCH_BUILDS_DUMMY");
const $4b016dcf63574f3e$export$3df6ceae566ba14c = $4b016dcf63574f3e$export$302158222cd49bab("PULL_REQUEST_TAB_REDIRECT");
const $4b016dcf63574f3e$export$f0ff4e75efee7b5 = $4b016dcf63574f3e$export$302158222cd49bab("MOCK_IR_DIFF_FETCH");
const $4b016dcf63574f3e$export$4cb0f82317da4a2 = (0, $2MctD.createBoolAction)($4b016dcf63574f3e$export$302158222cd49bab("REFETCH_IR_DIFF"));

});


parcelRegister("bQYeX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $acfaba41d10e2343$export$2e2bcd8739ae039; });
parcelRequire("5YpaN");
var $fICwP = parcelRequire("fICwP");

var $czBtW = parcelRequire("czBtW");

var $6D21P = parcelRequire("6D21P");
var $acfaba41d10e2343$export$2e2bcd8739ae039 = ({ owner: owner, repoSlug: repoSlug, pullRequestId: pullRequestId })=>{
    return (0, $fICwP.fetchAction)((0, $6D21P.FETCH_TASKS), {
        url: (0, $czBtW.default).api.v20.tasksFetch(owner, repoSlug, pullRequestId)
    });
};

});

parcelRegister("bEGFM", function(module, exports) {

$parcel$export(module.exports, "fetchCodeInsightsAnnotations", function () { return $24a22034beb5c2e3$export$5dbbf042aa9398e7; });
$parcel$export(module.exports, "default", function () { return $24a22034beb5c2e3$export$2e2bcd8739ae039; });

var $6D21P = parcelRequire("6D21P");
const $24a22034beb5c2e3$export$5dbbf042aa9398e7 = (reportId)=>({
        type: (0, $6D21P.FETCH_CODE_INSIGHTS_ANNOTATIONS).REQUEST,
        payload: reportId
    });
var $24a22034beb5c2e3$export$2e2bcd8739ae039 = ()=>({
        type: (0, $6D21P.FETCH_CODE_INSIGHTS_REPORTS).REQUEST
    });

});

parcelRegister("6X71R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa62583eedc02118$export$2e2bcd8739ae039; });

var $6D21P = parcelRequire("6D21P");
var $fa62583eedc02118$export$2e2bcd8739ae039 = ({ url: url, task: task, nextTaskState: nextTaskState })=>({
        type: (0, $6D21P.TASK_STATE_CHANGE).REQUEST,
        payload: {
            url: url,
            task: task,
            nextTaskState: nextTaskState
        }
    });

});

parcelRegister("azI4e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f1676caf52b2fc2$export$2e2bcd8739ae039; });

var $cJH1T = parcelRequire("cJH1T");
parcelRequire("5YpaN");
var $fICwP = parcelRequire("fICwP");

var $kZnTB = parcelRequire("kZnTB");

var $6D21P = parcelRequire("6D21P");
const $9f1676caf52b2fc2$var$fetchSourceBranchDetails = (repositoryOwner, repositorySlug, branchName)=>{
    const query = (0, $cJH1T.stringify)({
        branch: branchName
    });
    const url = `${(0, $kZnTB.default).api.internal.branchList(repositoryOwner, repositorySlug)}?${query}`;
    return (0, $fICwP.fetchAction)((0, $6D21P.FETCH_SOURCE_BRANCH_DETAILS), {
        url: url
    });
};
var $9f1676caf52b2fc2$export$2e2bcd8739ae039 = $9f1676caf52b2fc2$var$fetchSourceBranchDetails;

});

parcelRegister("dkXlf", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_DIFF_EXPANSION", function () { return $d97f602a2826e94f$export$beaeee7c16dbb9a1; });
$parcel$export(module.exports, "COLLAPSE_ALL_DIFFS", function () { return $d97f602a2826e94f$export$282172f601464112; });
$parcel$export(module.exports, "EXPAND_ALL_DIFFS", function () { return $d97f602a2826e94f$export$15bf3889a85ce220; });
$parcel$export(module.exports, "RESTORE_DIFFS_EXPAND_STATE", function () { return $d97f602a2826e94f$export$f98b934868d53022; });
$parcel$export(module.exports, "TOGGLE_SIDE_BY_SIDE_MODE", function () { return $d97f602a2826e94f$export$134d298a484e5164; });
$parcel$export(module.exports, "toggleSideBySideMode", function () { return $d97f602a2826e94f$export$f3c9b5e1b182bce5; });
const $d97f602a2826e94f$var$prefixed = (name)=>`pullRequest/${name}`;
const $d97f602a2826e94f$export$beaeee7c16dbb9a1 = $d97f602a2826e94f$var$prefixed("TOGGLE_DIFF_EXPANSION");
const $d97f602a2826e94f$export$282172f601464112 = $d97f602a2826e94f$var$prefixed("COLLAPSE_ALL_DIFFS");
const $d97f602a2826e94f$export$15bf3889a85ce220 = $d97f602a2826e94f$var$prefixed("EXPAND_ALL_DIFFS");
const $d97f602a2826e94f$export$f98b934868d53022 = $d97f602a2826e94f$var$prefixed("RESTORE_DIFFS_EXPAND_STATE");
const $d97f602a2826e94f$export$134d298a484e5164 = $d97f602a2826e94f$var$prefixed("TOGGLE_SIDE_BY_SIDE_MODE");
const $d97f602a2826e94f$export$f3c9b5e1b182bce5 = (options)=>({
        type: $d97f602a2826e94f$export$134d298a484e5164,
        payload: options
    });

});

parcelRegister("39E4H", function(module, exports) {

$parcel$export(module.exports, "watchLoading", function () { return $7704115946f342f1$export$cd679926cf55afc5; });
$parcel$export(module.exports, "watchLoadingEnd", function () { return $7704115946f342f1$export$18ce5938ed866511; });

var $6D21P = parcelRequire("6D21P");
const $7704115946f342f1$export$cd679926cf55afc5 = ()=>({
        type: (0, $6D21P.LOAD_WATCH).BEGIN
    });
const $7704115946f342f1$export$18ce5938ed866511 = (watching)=>({
        type: (0, $6D21P.LOAD_WATCH).END,
        payload: watching
    });

});


parcelRegister("14kRW", function(module, exports) {

$parcel$export(module.exports, "FETCH_ACTIVITY", function () { return $f4e576a99e5c98f4$export$4b4ec11c86c66865; });
$parcel$export(module.exports, "activityInitialState", function () { return $f4e576a99e5c98f4$export$ec39ff509ed9235f; });
$parcel$export(module.exports, "activityReducer", function () { return $f4e576a99e5c98f4$export$2fe345194890c3e; });

var $ga67g = parcelRequire("ga67g");

var $3omLR = parcelRequire("3omLR");
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $ha5uu = parcelRequire("ha5uu");

var $k6zif = parcelRequire("k6zif");

var $b2RHC = parcelRequire("b2RHC");
const $f4e576a99e5c98f4$export$4b4ec11c86c66865 = (0, $2MctD.createAsyncAction)((0, $6D21P.prefixed)("FETCH_ACTIVITY"));
const $f4e576a99e5c98f4$export$ec39ff509ed9235f = {
    activityEvents: [],
    nextUrl: null,
    isActivityLoading: false,
    hasError: false
};
const $f4e576a99e5c98f4$var$transformToTaskEvent = (newTask, currentUser)=>{
    // Transforms a BBTask into an object minimally similiar to the task
    // activity events we get from the activity/ API (ActivityApi['TaskActivity'])
    const { id: id, creator: creator, created_on: createdOn, state: taskState } = newTask;
    return {
        task: {
            id: id,
            actor: currentUser || creator,
            action: taskState === "UNRESOLVED" ? "CREATED" : "RESOLVED",
            action_on: taskState === "UNRESOLVED" ? createdOn : new Date().toISOString(),
            updated_on: taskState === "UNRESOLVED" ? createdOn : new Date().toISOString(),
            task: newTask
        }
    };
};
const $f4e576a99e5c98f4$var$transformToReviewerAddedEvent = (userAdded, currentUser)=>{
    return {
        update: {
            author: currentUser,
            date: new Date().toISOString(),
            changes: {
                reviewers: {
                    added: [
                        userAdded
                    ]
                }
            }
        }
    };
};
const $f4e576a99e5c98f4$var$transformToReviewerRemovedEvent = (userRemoved, currentUser)=>{
    return {
        update: {
            author: currentUser,
            date: new Date().toISOString(),
            changes: {
                reviewers: {
                    removed: [
                        userRemoved
                    ]
                }
            }
        }
    };
};
const $f4e576a99e5c98f4$var$transformToStatusChangeEvent = (pullRequest)=>{
    return {
        update: {
            author: pullRequest.closed_by,
            date: pullRequest.closed_on || new Date().toISOString(),
            state: pullRequest.state,
            changes: {
                status: {
                    new: pullRequest.state
                }
            }
        }
    };
};
const $f4e576a99e5c98f4$var$transformToDescriptionUpdatedEvent = (pullRequest, currentUser)=>{
    return {
        update: {
            author: currentUser,
            date: new Date().toISOString(),
            changes: {
                description: {
                    new: pullRequest.description
                }
            }
        }
    };
};
const $f4e576a99e5c98f4$var$transformToTitleUpdatedEvent = (oldTitle, pullRequest, currentUser)=>{
    return {
        update: {
            author: currentUser,
            date: new Date().toISOString(),
            changes: {
                title: {
                    new: pullRequest.title,
                    old: oldTitle
                }
            }
        }
    };
};
const $f4e576a99e5c98f4$export$2fe345194890c3e = (state = $f4e576a99e5c98f4$export$ec39ff509ed9235f, action)=>{
    switch(action.type){
        case $f4e576a99e5c98f4$export$4b4ec11c86c66865.REQUEST:
            return {
                ...state,
                activityEvents: [],
                isActivityLoading: true,
                hasError: false
            };
        case $f4e576a99e5c98f4$export$4b4ec11c86c66865.SUCCESS:
            {
                const { nextUrl: nextUrl } = action.payload;
                return {
                    ...state,
                    activityEvents: [
                        ...state.activityEvents,
                        ...action.payload.activityEvents
                    ],
                    isActivityLoading: false,
                    hasError: false,
                    nextUrl: nextUrl
                };
            }
        case $f4e576a99e5c98f4$export$4b4ec11c86c66865.ERROR:
            return {
                ...state,
                isActivityLoading: false,
                hasError: true
            };
        case (0, $6D21P.TASK_CREATE).SUCCESS:
            {
                const { newTask: newTask } = action.payload;
                if (newTask.pending) return state;
                return {
                    ...state,
                    activityEvents: [
                        $f4e576a99e5c98f4$var$transformToTaskEvent(newTask),
                        ...state.activityEvents
                    ]
                };
            }
        case (0, $6D21P.TASK_DELETE).SUCCESS:
            {
                const task = action.payload;
                return {
                    ...state,
                    activityEvents: state.activityEvents.filter((event)=>{
                        return !((0, $3omLR.isTaskActivity)(event) && event.task.task.id === task.id);
                    })
                };
            }
        case (0, $6D21P.ADD_REVIEWER).SUCCESS:
            {
                const userAddedUuid = Object.keys(action.payload.entities.users).find((key)=>action.payload.entities.users[key].account_id === action.payload.result.userAaid) || "";
                const userAdded = action.payload.entities.users[userAddedUuid];
                const { currentUser: currentUser } = action.payload.result;
                return {
                    ...state,
                    activityEvents: [
                        $f4e576a99e5c98f4$var$transformToReviewerAddedEvent(userAdded, currentUser),
                        ...state.activityEvents
                    ]
                };
            }
        case 0, $6D21P.APPROVAL_SUCCESS:
            {
                const { currentUser: currentUser, approval: approval } = action.payload;
                if (approval) return {
                    ...state,
                    activityEvents: [
                        {
                            approval: {
                                date: new Date().toISOString(),
                                user: currentUser
                            }
                        },
                        ...state.activityEvents
                    ]
                };
                else // If it's an unapproval, remove the corresponding approval event of the currentUser
                return {
                    ...state,
                    activityEvents: state.activityEvents.filter((event)=>{
                        return(// Keep non-approval events
                        !(0, $3omLR.isApprovalActivity)(event) || // Keep approval events not from the currentUser
                        (0, $3omLR.isApprovalActivity)(event) && event.approval.user.uuid !== currentUser.uuid);
                    })
                };
            }
        case (0, $6D21P.REQUEST_CHANGES).SUCCESS:
            {
                const { currentUser: currentUser } = action.payload;
                return {
                    ...state,
                    activityEvents: [
                        {
                            changes_requested: {
                                date: new Date().toISOString(),
                                user: currentUser
                            }
                        },
                        ...state.activityEvents
                    ]
                };
            }
        case (0, $6D21P.REMOVE_REVIEWER).SUCCESS:
            {
                const { currentUser: currentUser } = action.payload.result;
                if (!action.payload.result.removedUser) return state;
                return {
                    ...state,
                    activityEvents: [
                        $f4e576a99e5c98f4$var$transformToReviewerRemovedEvent(action.payload.result.removedUser, currentUser),
                        ...state.activityEvents
                    ]
                };
            }
        case (0, $6D21P.DELETE_COMMENT).SUCCESS:
            return {
                ...state,
                activityEvents: state.activityEvents.filter((event)=>{
                    var _event$task$task$comm;
                    return !((0, $3omLR.isTaskActivity)(event) && ((_event$task$task$comm = event.task.task.comment) === null || _event$task$task$comm === void 0 ? void 0 : _event$task$task$comm.id) === action.payload.id);
                })
            };
        case (0, $6D21P.TASK_STATE_CHANGE).SUCCESS:
            {
                const { task: task, user: user } = action.payload;
                if (task.state === "RESOLVED") return {
                    ...state,
                    activityEvents: [
                        $f4e576a99e5c98f4$var$transformToTaskEvent(task, user),
                        ...state.activityEvents
                    ]
                };
                else return {
                    ...state,
                    activityEvents: state.activityEvents.filter((event)=>{
                        return !((0, $3omLR.isTaskActivity)(event) && event.task.task.id === task.id && event.task.action === "RESOLVED");
                    })
                };
            }
        case (0, $ha5uu.DECLINE).SUCCESS:
            {
                const declinedPullRequest = (0, $ga67g.denormalize)(action.payload.result, (0, $b2RHC.pullRequest), action.payload.entities);
                return {
                    ...state,
                    activityEvents: [
                        $f4e576a99e5c98f4$var$transformToStatusChangeEvent(declinedPullRequest),
                        ...state.activityEvents
                    ]
                };
            }
        case (0, $k6zif.MERGE).SUCCESS:
            {
                const mergedPullRequest = (0, $ga67g.denormalize)(action.payload.result.currentPullRequest, (0, $b2RHC.pullRequest), action.payload.entities);
                return {
                    ...state,
                    activityEvents: [
                        $f4e576a99e5c98f4$var$transformToStatusChangeEvent(mergedPullRequest),
                        ...state.activityEvents
                    ]
                };
            }
        case (0, $6D21P.UPDATE_DESCRIPTION).SUCCESS:
            {
                const { currentUser: currentUser, currentPullRequest: currentPullRequest } = action.payload.result;
                const pullRequest = (0, $ga67g.denormalize)(currentPullRequest, (0, $b2RHC.pullRequest), action.payload.entities);
                return {
                    ...state,
                    activityEvents: [
                        $f4e576a99e5c98f4$var$transformToDescriptionUpdatedEvent(pullRequest, currentUser),
                        ...state.activityEvents
                    ]
                };
            }
        case (0, $6D21P.UPDATE_TITLE).SUCCESS:
            {
                const { oldTitle: oldTitle, currentUser: currentUser, currentPullRequest: currentPullRequest } = action.payload.result;
                const pullRequest = (0, $ga67g.denormalize)(currentPullRequest, (0, $b2RHC.pullRequest), action.payload.entities);
                return {
                    ...state,
                    activityEvents: [
                        $f4e576a99e5c98f4$var$transformToTitleUpdatedEvent(oldTitle || "", pullRequest, currentUser),
                        ...state.activityEvents
                    ]
                };
            }
        case 0, $6D21P.EXITED_CODE_REVIEW:
            return {
                ...$f4e576a99e5c98f4$export$ec39ff509ed9235f
            };
        default:
            return state;
    }
};

});
parcelRegister("3omLR", function(module, exports) {

$parcel$export(module.exports, "ActivityEntryTypes", function () { return $434d27d3ca250726$export$bac96245b0577502; });
$parcel$export(module.exports, "isCommitEntry", function () { return $434d27d3ca250726$export$531018abf466ffdf; });
$parcel$export(module.exports, "isReviewersAddedEntry", function () { return $434d27d3ca250726$export$9743b086e493bf84; });
$parcel$export(module.exports, "isTasksCreatedEntry", function () { return $434d27d3ca250726$export$6ce266c7a2c6d8cd; });
$parcel$export(module.exports, "isDescriptionChangeEntry", function () { return $434d27d3ca250726$export$b8918ab4d67e90d2; });
$parcel$export(module.exports, "isTasksResolvedEntry", function () { return $434d27d3ca250726$export$c11236f45ce95a7b; });
$parcel$export(module.exports, "isAttachmentEntry", function () { return $434d27d3ca250726$export$3ff3dd168a50d530; });
$parcel$export(module.exports, "isUpdateActivity", function () { return $434d27d3ca250726$export$e04bebfc30836642; });
$parcel$export(module.exports, "isApprovalActivity", function () { return $434d27d3ca250726$export$58024908f2636a68; });
$parcel$export(module.exports, "isChangesRequestedActivity", function () { return $434d27d3ca250726$export$7fc1219e195fd3a4; });
$parcel$export(module.exports, "isTaskActivity", function () { return $434d27d3ca250726$export$8862238f53d663b8; });
$parcel$export(module.exports, "isNotCommentActivity", function () { return $434d27d3ca250726$export$e46e30915d157c82; });
$parcel$export(module.exports, "isAttachmentActivity", function () { return $434d27d3ca250726$export$31689776c5e89db0; });
var $434d27d3ca250726$export$bac96245b0577502;
(function(ActivityEntryTypes) {
    ActivityEntryTypes["CommentStart"] = "comment-start";
    ActivityEntryTypes["CommentReplies"] = "comment-replies";
    ActivityEntryTypes["TaskCreated"] = "task-created";
    ActivityEntryTypes["TaskResolved"] = "task-resolved";
    ActivityEntryTypes["TasksCreated"] = "tasks-created";
    ActivityEntryTypes["TasksResolved"] = "tasks-resolved";
    ActivityEntryTypes["Commit"] = "update";
    ActivityEntryTypes["StatusChange"] = "status-change";
    ActivityEntryTypes["Approval"] = "approval";
    ActivityEntryTypes["AttachmentAdded"] = "attachment-added";
    ActivityEntryTypes["ChangesRequested"] = "changes-requested";
})($434d27d3ca250726$export$bac96245b0577502 || ($434d27d3ca250726$export$bac96245b0577502 = {}));
const $434d27d3ca250726$export$531018abf466ffdf = (entry)=>{
    return entry && "type" in entry && entry.type === "update" && "hashes" in entry;
};
const $434d27d3ca250726$export$9743b086e493bf84 = (entry)=>{
    return entry && "type" in entry && entry.type === "reviewers-added";
};
const $434d27d3ca250726$export$6ce266c7a2c6d8cd = (entry)=>{
    return entry && "type" in entry && entry.type === "tasks-created";
};
const $434d27d3ca250726$export$b8918ab4d67e90d2 = (entry)=>{
    return entry && "type" in entry && entry.type === "description-change";
};
const $434d27d3ca250726$export$c11236f45ce95a7b = (entry)=>{
    return entry && "type" in entry && entry.type === "tasks-resolved";
};
const $434d27d3ca250726$export$3ff3dd168a50d530 = (entry)=>{
    return entry && "type" in entry && entry.type === "attachment-added" && "items" in entry;
};
const $434d27d3ca250726$export$e04bebfc30836642 = (item)=>{
    return "update" in item;
};
const $434d27d3ca250726$export$58024908f2636a68 = (item)=>{
    return "approval" in item;
};
const $434d27d3ca250726$export$7fc1219e195fd3a4 = (item)=>{
    return "changes_requested" in item;
};
const $434d27d3ca250726$export$8862238f53d663b8 = (item)=>{
    return "task" in item;
};
const $434d27d3ca250726$export$e46e30915d157c82 = (item)=>{
    return !("comment" in item);
};
const $434d27d3ca250726$export$31689776c5e89db0 = (item)=>{
    return "attachment" in item;
};

});

parcelRegister("ha5uu", function(module, exports) {

$parcel$export(module.exports, "DECLINE", function () { return $f6ebb2b429d4d004$export$96628771ec209719; });
$parcel$export(module.exports, "requestDecline", function () { return $f6ebb2b429d4d004$export$fd862b5d8cdeac71; });
$parcel$export(module.exports, "closeDialog", function () { return $f6ebb2b429d4d004$export$34bf1befb2fab61a; });
$parcel$export(module.exports, "openDialog", function () { return $f6ebb2b429d4d004$export$45f11db5513b93db; });
$parcel$export(module.exports, "declineInitialState", function () { return $f6ebb2b429d4d004$export$1bfac6b5ca528a85; });
$parcel$export(module.exports, "getIsDeclineDialogOpen", function () { return $f6ebb2b429d4d004$export$24fbe66c555d2fda; });
$parcel$export(module.exports, "getIsDeclineRequesting", function () { return $f6ebb2b429d4d004$export$8dffe770e7c609d3; });
$parcel$export(module.exports, "getIsDeclineErrored", function () { return $f6ebb2b429d4d004$export$84d385616e028938; });
$parcel$export(module.exports, "getDeclineErrorMessage", function () { return $f6ebb2b429d4d004$export$f53721f75c96c487; });
$parcel$export(module.exports, "default", function () { return $f6ebb2b429d4d004$export$2e2bcd8739ae039; });

var $aXXtM = parcelRequire("aXXtM");
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $1EkdU = parcelRequire("1EkdU");
const $f6ebb2b429d4d004$export$96628771ec209719 = (0, $2MctD.createAsyncAction)((0, $6D21P.prefixed)("DECLINE"));
const $f6ebb2b429d4d004$export$bb9c60d21257029e = (0, $6D21P.prefixed)("OPEN_DECLINE_DIALOG");
const $f6ebb2b429d4d004$export$452238d494b585be = (0, $6D21P.prefixed)("CLOSE_DECLINE_DIALOG");
const $f6ebb2b429d4d004$export$fd862b5d8cdeac71 = (reason)=>({
        type: $f6ebb2b429d4d004$export$96628771ec209719.REQUEST,
        payload: reason
    });
const $f6ebb2b429d4d004$export$34bf1befb2fab61a = ()=>({
        type: $f6ebb2b429d4d004$export$452238d494b585be
    });
const $f6ebb2b429d4d004$export$45f11db5513b93db = ()=>({
        type: $f6ebb2b429d4d004$export$bb9c60d21257029e
    });
const $f6ebb2b429d4d004$export$1bfac6b5ca528a85 = {
    isRequesting: false,
    isDialogOpen: false,
    hadError: false,
    lastErrorMessage: null
};
const $f6ebb2b429d4d004$export$24fbe66c555d2fda = (0, $aXXtM.createSelector)((0, $1EkdU.getPullRequestSlice), (state)=>state.decline.isDialogOpen);
const $f6ebb2b429d4d004$export$8dffe770e7c609d3 = (0, $aXXtM.createSelector)((0, $1EkdU.getPullRequestSlice), (state)=>state.decline.isRequesting);
const $f6ebb2b429d4d004$export$84d385616e028938 = (0, $aXXtM.createSelector)((0, $1EkdU.getPullRequestSlice), (state)=>state.decline.hadError);
const $f6ebb2b429d4d004$export$f53721f75c96c487 = (0, $aXXtM.createSelector)((0, $1EkdU.getPullRequestSlice), (state)=>state.decline.lastErrorMessage);
var // Reducer
$f6ebb2b429d4d004$export$2e2bcd8739ae039 = (state = $f6ebb2b429d4d004$export$1bfac6b5ca528a85, action)=>{
    switch(action.type){
        case $f6ebb2b429d4d004$export$bb9c60d21257029e:
            return {
                ...state,
                isDialogOpen: true
            };
        case $f6ebb2b429d4d004$export$452238d494b585be:
            return {
                ...state,
                isDialogOpen: false,
                hadError: false,
                lastErrorMessage: null
            };
        case $f6ebb2b429d4d004$export$96628771ec209719.REQUEST:
            return {
                ...state,
                isRequesting: true,
                hadError: false,
                lastErrorMessage: null
            };
        case $f6ebb2b429d4d004$export$96628771ec209719.SUCCESS:
            return {
                ...$f6ebb2b429d4d004$export$1bfac6b5ca528a85
            };
        case $f6ebb2b429d4d004$export$96628771ec209719.ERROR:
            return {
                ...state,
                isRequesting: false,
                hadError: true,
                lastErrorMessage: action.payload
            };
        default:
            return state;
    }
};

});
parcelRegister("1EkdU", function(module, exports) {

$parcel$export(module.exports, "getPullRequestSlice", function () { return $7256662a4b816bdb$export$1b617bec6a57541b; });
$parcel$export(module.exports, "getAllRawComments", function () { return $7256662a4b816bdb$export$f8de4ca5fb52fe5f; });
$parcel$export(module.exports, "getDefaultMergeStrategy", function () { return $7256662a4b816bdb$export$adda5cf9d71979b8; });
$parcel$export(module.exports, "getMergeMessageMaxSizeBytes", function () { return $7256662a4b816bdb$export$fe1750a63e4475b2; });
$parcel$export(module.exports, "getPullRequestRenderingLimits", function () { return $7256662a4b816bdb$export$9325b1226abfcbd6; });
$parcel$export(module.exports, "getDiffsExpansions", function () { return $7256662a4b816bdb$export$4df7494939751eca; });
$parcel$export(module.exports, "getSingleDiffExpansion", function () { return $7256662a4b816bdb$export$5c5a128d859aacec; });
$parcel$export(module.exports, "getCurrentPullRequest", function () { return $7256662a4b816bdb$export$d771b66b9391b013; });
$parcel$export(module.exports, "getCurrentPullRequestId", function () { return $7256662a4b816bdb$export$888dec7fe8d5fbc8; });
$parcel$export(module.exports, "getIRAnalyticsTrackingAttributes", function () { return $7256662a4b816bdb$export$403d45f626d46542; });
$parcel$export(module.exports, "getCurrentPullRequestTitle", function () { return $7256662a4b816bdb$export$a427536f712a4bbe; });
$parcel$export(module.exports, "getCurrentPullRequestAnnotations", function () { return $7256662a4b816bdb$export$767a9cbfa2cc68a1; });
$parcel$export(module.exports, "getHiddenAnnotations", function () { return $7256662a4b816bdb$export$92071663b35f9896; });
$parcel$export(module.exports, "getHiddenDiffComments", function () { return $7256662a4b816bdb$export$e91c37a786274b9; });
$parcel$export(module.exports, "getCurrentPullRequestAnnotationsForFile", function () { return $7256662a4b816bdb$export$120f820ff10ccd25; });
$parcel$export(module.exports, "getCurrentCodeInsightsReports", function () { return $7256662a4b816bdb$export$af40042a2d6f6e3; });
$parcel$export(module.exports, "getCurrentCodeInsightsReportsLoadingState", function () { return $7256662a4b816bdb$export$41f1850c94ff35de; });
$parcel$export(module.exports, "getCanCreatePendingMerge", function () { return $7256662a4b816bdb$export$f111efe80a312340; });
$parcel$export(module.exports, "getHasCodeInsightsReportsError", function () { return $7256662a4b816bdb$export$55e460c7967a5910; });
$parcel$export(module.exports, "getIsIterativeReviewComplete", function () { return $7256662a4b816bdb$export$259d10243eb9efaf; });
$parcel$export(module.exports, "getCurrentCodeInsightsAnnotations", function () { return $7256662a4b816bdb$export$4998ad8189f87785; });
$parcel$export(module.exports, "getCurrentCodeInsightsAnnotationsLoadingState", function () { return $7256662a4b816bdb$export$c0d1119b49aa28fd; });
$parcel$export(module.exports, "getIsCurrentPullRequestOpen", function () { return $7256662a4b816bdb$export$fb79193924241ae4; });
$parcel$export(module.exports, "getCurrentPullRequestAuthor", function () { return $7256662a4b816bdb$export$bcff36ca266feb49; });
$parcel$export(module.exports, "getCurrentPullRequestDiffType", function () { return $7256662a4b816bdb$export$e9c8863f158f170; });
$parcel$export(module.exports, "getCurrentPullRequestInTopicDiffMode", function () { return $7256662a4b816bdb$export$a9031e95bc91b646; });
$parcel$export(module.exports, "getCurrentPullRequestInPreviewDiffMode", function () { return $7256662a4b816bdb$export$722ef319f7e0ba86; });
$parcel$export(module.exports, "getIsCurrentPullRequestAuthor", function () { return $7256662a4b816bdb$export$7a575a20965792f1; });
$parcel$export(module.exports, "getCurrentPullRequestParticipants", function () { return $7256662a4b816bdb$export$a830aa46910d6675; });
$parcel$export(module.exports, "getCurrentPullRequestReviewers", function () { return $7256662a4b816bdb$export$28eb8231b64b51c3; });
$parcel$export(module.exports, "getCurrentPullRequestApprovers", function () { return $7256662a4b816bdb$export$3d2dbe0d1005510c; });
$parcel$export(module.exports, "getCurrentPullRequestRoleForCurrentUser", function () { return $7256662a4b816bdb$export$bf823f9e542564e7; });
$parcel$export(module.exports, "getIsCurrentPullRequestChangesRequested", function () { return $7256662a4b816bdb$export$6f741a60a1f2d895; });
$parcel$export(module.exports, "getCurrentPullRequestRequestChangesSlice", function () { return $7256662a4b816bdb$export$fe3b7c25084884b0; });
$parcel$export(module.exports, "getIsChangesRequested", function () { return $7256662a4b816bdb$export$4554c83f567790ec; });
$parcel$export(module.exports, "getHasCurrentUserApprovedPr", function () { return $7256662a4b816bdb$export$6f84fa00ebbb8d85; });
$parcel$export(module.exports, "getLastPullRequestRetrievalTime", function () { return $7256662a4b816bdb$export$5c7e947d22f3df64; });
$parcel$export(module.exports, "getCurrentPullRequestError", function () { return $7256662a4b816bdb$export$a62ee43435432a03; });
$parcel$export(module.exports, "getCurrentPullRequestUrlPieces", function () { return $7256662a4b816bdb$export$388a9c4cec4475d0; });
$parcel$export(module.exports, "getPullRequestSourceRepo", function () { return $7256662a4b816bdb$export$a954f0a78a0696f0; });
$parcel$export(module.exports, "getPullRequestSourceRepoUuid", function () { return $7256662a4b816bdb$export$8f1a7306324520ae; });
$parcel$export(module.exports, "getPullRequestDestinationRepo", function () { return $7256662a4b816bdb$export$6a1dccc4087fd1a0; });
$parcel$export(module.exports, "getPullRequestDestinationRepoFullSlug", function () { return $7256662a4b816bdb$export$8d24937e41932997; });
$parcel$export(module.exports, "getPullRequestDestinationRepoUuid", function () { return $7256662a4b816bdb$export$92cec7373e4dfaa7; });
$parcel$export(module.exports, "getPullRequestSourceHash", function () { return $7256662a4b816bdb$export$ce0791f1ca2316dd; });
$parcel$export(module.exports, "getCodeInsightsDiscoveryUrl", function () { return $7256662a4b816bdb$export$56af3d9fc4d2d518; });
$parcel$export(module.exports, "getCodeInsightsAnnotationUrl", function () { return $7256662a4b816bdb$export$d4ad3b81df0d0701; });
$parcel$export(module.exports, "getPipelinesOnboardingUrl", function () { return $7256662a4b816bdb$export$6ae124184a57a5a1; });
$parcel$export(module.exports, "getPullRequestDestinationHash", function () { return $7256662a4b816bdb$export$ed86785d8d2aad6b; });
$parcel$export(module.exports, "getPullRequestBranchName", function () { return $7256662a4b816bdb$export$474ab49172b353a3; });
$parcel$export(module.exports, "getDestinationBranchName", function () { return $7256662a4b816bdb$export$438812fbf036c109; });
$parcel$export(module.exports, "getPullRequestCompareSpecDiffUrl", function () { return $7256662a4b816bdb$export$38d78d47a63da66e; });
$parcel$export(module.exports, "getPullRequestCompareSpecDiffStatUrl", function () { return $7256662a4b816bdb$export$edf855d8807cf611; });
$parcel$export(module.exports, "getPullRequestDescription", function () { return $7256662a4b816bdb$export$7dbd46d1cf50a9d8; });
$parcel$export(module.exports, "getIsDifferentRepo", function () { return $7256662a4b816bdb$export$de9f2827b6041676; });
$parcel$export(module.exports, "getHighlighted", function () { return $7256662a4b816bdb$export$a40c1fdc4c13b972; });
$parcel$export(module.exports, "getHighlightCommentThread", function () { return $7256662a4b816bdb$export$d1ca0f74cdb6f499; });
$parcel$export(module.exports, "getIsSingleFileModeActive", function () { return $7256662a4b816bdb$export$cde20bea06311705; });
$parcel$export(module.exports, "getIsSingleFileModeEligible", function () { return $7256662a4b816bdb$export$31f0e4d642789334; });
$parcel$export(module.exports, "getIsSingleFileModeSettingsHeaderVisible", function () { return $7256662a4b816bdb$export$215e738417f73f52; });
$parcel$export(module.exports, "getIsStickyHeaderActive", function () { return $7256662a4b816bdb$export$f600d4e4e6acfde4; });
$parcel$export(module.exports, "getConflicts", function () { return $7256662a4b816bdb$export$733bb30b9159fd88; });
$parcel$export(module.exports, "getConflictCount", function () { return $7256662a4b816bdb$export$d6435c7cbe3076ec; });
$parcel$export(module.exports, "getConflictStatus", function () { return $7256662a4b816bdb$export$198b839f4813d8b9; });
$parcel$export(module.exports, "getIsAsyncMergeInProgress", function () { return $7256662a4b816bdb$export$1f58c9b8db82f2b; });
$parcel$export(module.exports, "getInProgressMergeTask", function () { return $7256662a4b816bdb$export$fb310a7f9d12e0e6; });
$parcel$export(module.exports, "getPullRequestMergeChecks", function () { return $7256662a4b816bdb$export$5a84fd1aa37b0be4; });
$parcel$export(module.exports, "getPullRequestMergeChecksIsMergeable", function () { return $7256662a4b816bdb$export$4e2264e57c60fabf; });
$parcel$export(module.exports, "getPullRequestCanCurrentUserMerge", function () { return $7256662a4b816bdb$export$56fa1f5004b97f0b; });
$parcel$export(module.exports, "getPullRequestIsMissingCommits", function () { return $7256662a4b816bdb$export$6285a3e8b32ebb57; });
$parcel$export(module.exports, "getPullRequestIsUpdatingCommits", function () { return $7256662a4b816bdb$export$1c5f69608a59bd3c; });
$parcel$export(module.exports, "getPullRequestHasMissingCommitsError", function () { return $7256662a4b816bdb$export$e40d490f8731fbc0; });
$parcel$export(module.exports, "getCountFailedPullRequestMergeChecks", function () { return $7256662a4b816bdb$export$5245eb2a6e8d7eca; });
$parcel$export(module.exports, "getPullRequestApprovalsMergeCheck", function () { return $7256662a4b816bdb$export$7ce08f573b6d6a49; });
$parcel$export(module.exports, "getIsEnforcedMergeChecksEnabled", function () { return $7256662a4b816bdb$export$4b071e33a0906f3d; });
$parcel$export(module.exports, "getPullRequestIsMergeable", function () { return $7256662a4b816bdb$export$9ac503180e3c0b85; });
$parcel$export(module.exports, "getIsPullRequestReadyToUsePendingMerge", function () { return $7256662a4b816bdb$export$16ca4c94fc2a89d; });
$parcel$export(module.exports, "getPullRequestMergeChecksError", function () { return $7256662a4b816bdb$export$fe0d889da20a4d0; });
$parcel$export(module.exports, "getIsMergeChecklistLoading", function () { return $7256662a4b816bdb$export$d27a69ede99fa4a1; });
$parcel$export(module.exports, "getPullRequestDiff", function () { return $7256662a4b816bdb$export$c3b9dbcea3987e20; });
$parcel$export(module.exports, "getPullRequestDiffFileCount", function () { return $7256662a4b816bdb$export$fc7c1666f8fda653; });
$parcel$export(module.exports, "getPullRequestDiffLinesCount", function () { return $7256662a4b816bdb$export$15a0b1e5d81eb36b; });
$parcel$export(module.exports, "getDiffStat", function () { return $7256662a4b816bdb$export$d1b9710aa8435c62; });
$parcel$export(module.exports, "getFileDiffStatus", function () { return $7256662a4b816bdb$export$7f0b13c6415a37cd; });
$parcel$export(module.exports, "getUntruncatedPullRequestDiffFileCount", function () { return $7256662a4b816bdb$export$a70831b5dce49209; });
$parcel$export(module.exports, "getDiffStatErrorKey", function () { return $7256662a4b816bdb$export$57a5747d9a1c9ec1; });
$parcel$export(module.exports, "getDiffErrorCode", function () { return $7256662a4b816bdb$export$adc15ac7f883828f; });
$parcel$export(module.exports, "getDiffStatErrorCode", function () { return $7256662a4b816bdb$export$e6f2edc1337cff8b; });
$parcel$export(module.exports, "getActivePermalink", function () { return $7256662a4b816bdb$export$141d52f7a6564c59; });
$parcel$export(module.exports, "getHiddenFileDialogAnchor", function () { return $7256662a4b816bdb$export$cd2ec653bcf5dc71; });
$parcel$export(module.exports, "getFilterCommentsByUser", function () { return $7256662a4b816bdb$export$ea4ead2c6cafda90; });
$parcel$export(module.exports, "getIsCommentsFilterActive", function () { return $7256662a4b816bdb$export$3da0ddbfc6a831a9; });
$parcel$export(module.exports, "getIsCurrentSelectedFilter", function () { return $7256662a4b816bdb$export$5a1ae1473f49ed4e; });
$parcel$export(module.exports, "getInlineComments", function () { return $7256662a4b816bdb$export$aaf40e476dfebf61; });
$parcel$export(module.exports, "getNumOutdatedPendingComments", function () { return $7256662a4b816bdb$export$ba80024d69556ec7; });
$parcel$export(module.exports, "getFilteredDiffStat", function () { return $7256662a4b816bdb$export$dbba94e196c18a2c; });
$parcel$export(module.exports, "getActiveDiff", function () { return $7256662a4b816bdb$export$b8bc40aa44253c8c; });
$parcel$export(module.exports, "getSingleFileModeActiveDiff", function () { return $7256662a4b816bdb$export$4c4d20accead08b1; });
$parcel$export(module.exports, "getRenderedPullRequestDiff", function () { return $7256662a4b816bdb$export$8defae39a65842ef; });
$parcel$export(module.exports, "getIsPullRequestTruncated", function () { return $7256662a4b816bdb$export$e38541ce4409b7ce; });
$parcel$export(module.exports, "getAllDiffFiles", function () { return $7256662a4b816bdb$export$eab6a89786a61877; });
$parcel$export(module.exports, "getDiffFiles", function () { return $7256662a4b816bdb$export$84e65bd7cd98b976; });
$parcel$export(module.exports, "getWatchActionLoading", function () { return $7256662a4b816bdb$export$c7906ce206376179; });
$parcel$export(module.exports, "getWatch", function () { return $7256662a4b816bdb$export$fbbe94ee2d19ed00; });
$parcel$export(module.exports, "getLastPollTime", function () { return $7256662a4b816bdb$export$3f789cbf798c3961; });
$parcel$export(module.exports, "getUpdateNeeds", function () { return $7256662a4b816bdb$export$b105808586cbd1b3; });
$parcel$export(module.exports, "findFileInDiffFiles", function () { return $7256662a4b816bdb$export$6ef1b7d86d1734c; });
$parcel$export(module.exports, "getIsFileRemovedFromDiff", function () { return $7256662a4b816bdb$export$f4fcc55c4d01519; });
$parcel$export(module.exports, "getOutdatedCommentsDialogFile", function () { return $7256662a4b816bdb$export$3f45b3f1ba7ffa43; });
$parcel$export(module.exports, "getDiffCommentsDialogFile", function () { return $7256662a4b816bdb$export$a50921540f5141c7; });
$parcel$export(module.exports, "getNonRenderedDiffCommentsDialogFile", function () { return $7256662a4b816bdb$export$55d7762f5a5f59af; });
$parcel$export(module.exports, "getIsCorrectPullRequest", function () { return $7256662a4b816bdb$export$72b2e5b28d60f0cb; });
$parcel$export(module.exports, "getSideBySideDiffStateForFile", function () { return $7256662a4b816bdb$export$5bde87782c2abf26; });
$parcel$export(module.exports, "getIsOutdatedDialogOpen", function () { return $7256662a4b816bdb$export$fa22863dfe039abd; });
$parcel$export(module.exports, "getIsReviewDraftDialogOpen", function () { return $7256662a4b816bdb$export$cab6418d1adc1f33; });
$parcel$export(module.exports, "getIsDiffCommentsDialogOpen", function () { return $7256662a4b816bdb$export$bf765564a547b362; });
$parcel$export(module.exports, "getIsNonRenderedDiffCommentsDialogOpen", function () { return $7256662a4b816bdb$export$9d84de8ce2b267e2; });
$parcel$export(module.exports, "getEditorState", function () { return $7256662a4b816bdb$export$62ca784e6947e746; });
$parcel$export(module.exports, "getSourceRepositoryAccessLevel", function () { return $7256662a4b816bdb$export$41b301a3b564bd76; });
$parcel$export(module.exports, "getContainerId", function () { return $7256662a4b816bdb$export$7c8178cc9001d237; });
$parcel$export(module.exports, "getNavUnresolvedComments", function () { return $7256662a4b816bdb$export$d56ad7688fba5394; });
$parcel$export(module.exports, "getNavResolvedComments", function () { return $7256662a4b816bdb$export$ebb5d45b79a091fa; });
$parcel$export(module.exports, "getFabricConversationsList", function () { return $7256662a4b816bdb$export$20c3b1f7e3dccd49; });
$parcel$export(module.exports, "getCommentTree", function () { return $7256662a4b816bdb$export$62b7f18569a1443d; });
$parcel$export(module.exports, "getConversationsList", function () { return $7256662a4b816bdb$export$d4ae3022854f03c4; });
$parcel$export(module.exports, "getIsLoadingOutdatedCommentContext", function () { return $7256662a4b816bdb$export$c62cfd3083e37585; });
$parcel$export(module.exports, "getIsLoadingPendingCommentContext", function () { return $7256662a4b816bdb$export$9d13670a66bf7b16; });
$parcel$export(module.exports, "getisLoadingBaseRevCommentContext", function () { return $7256662a4b816bdb$export$48befafb6b9add0c; });
$parcel$export(module.exports, "getIsLoadingAllChangesCommentContext", function () { return $7256662a4b816bdb$export$d6840651ffd6082d; });
$parcel$export(module.exports, "getIsRevertDialogOpen", function () { return $7256662a4b816bdb$export$4bf1ddfac66115f; });
$parcel$export(module.exports, "getIsPullRequestTitleUpdatePending", function () { return $7256662a4b816bdb$export$f588d66507cfa941; });
$parcel$export(module.exports, "getIsPullRequestDescriptionUpdatePending", function () { return $7256662a4b816bdb$export$904c8ab9ba9648c4; });
$parcel$export(module.exports, "getIsPullRequestRemoveReviewerPending", function () { return $7256662a4b816bdb$export$791081bd6d3fcab8; });
$parcel$export(module.exports, "getIsPullRequestAddReviewerPending", function () { return $7256662a4b816bdb$export$2815f4ac3b46f67a; });
$parcel$export(module.exports, "getPullRequestAddReviewerPendingAaids", function () { return $7256662a4b816bdb$export$c118997b769a38b2; });
$parcel$export(module.exports, "getRevertError", function () { return $7256662a4b816bdb$export$3e989a4871019db7; });
$parcel$export(module.exports, "getHasDestinationBranch", function () { return $7256662a4b816bdb$export$84385a36e0d16fd3; });
$parcel$export(module.exports, "getCurrentPullRequestSourceBranchDetails", function () { return $7256662a4b816bdb$export$e59609e92bb9fcaa; });
$parcel$export(module.exports, "getCanDeleteSourceBranch", function () { return $7256662a4b816bdb$export$feca01302fc536db; });
$parcel$export(module.exports, "getCommentLikes", function () { return $7256662a4b816bdb$export$cd6f4406ffa3f3e2; });
$parcel$export(module.exports, "getCanLikeComments", function () { return $7256662a4b816bdb$export$538537bec0f5c9fb; });
$parcel$export(module.exports, "isFileCommentOpen", function () { return $7256662a4b816bdb$export$37b1c6134cb8d363; });
$parcel$export(module.exports, "getPullRequestRefetchBuildsDummy", function () { return $7256662a4b816bdb$export$7e5826658160117f; });
$parcel$export(module.exports, "getPullRequestRefetchIRDiffDummy", function () { return $7256662a4b816bdb$export$d2eda9f0f94e9d0a; });
$parcel$export(module.exports, "getPullRequestViewSyncStrategies", function () { return $7256662a4b816bdb$export$77ae758fa6d5ee6e; });

var $lIZwG = parcelRequire("lIZwG");

var $ga67g = parcelRequire("ga67g");

var $cQrjH = parcelRequire("cQrjH");

var $aXXtM = parcelRequire("aXXtM");
parcelRequire("3hzea");
var $a5HLv = parcelRequire("a5HLv");
parcelRequire("hfhvV");
var $9kTpj = parcelRequire("9kTpj");

var $xz4dB = parcelRequire("xz4dB");

var $c2vnU = parcelRequire("c2vnU");

var $2hjj7 = parcelRequire("2hjj7");

var $lvqI0 = parcelRequire("lvqI0");
parcelRequire("fequ0");
var $axaTk = parcelRequire("axaTk");

var $axaTk = parcelRequire("axaTk");

var $i2O3k = parcelRequire("i2O3k");

var $b2RHC = parcelRequire("b2RHC");

var $deJTw = parcelRequire("deJTw");

var $8MnfV = parcelRequire("8MnfV");

var $aanBq = parcelRequire("aanBq");

var $7qdXF = parcelRequire("7qdXF");

var $g2R3c = parcelRequire("g2R3c");

var $635SY = parcelRequire("635SY");

var $fN6IA = parcelRequire("fN6IA");

var $70vW8 = parcelRequire("70vW8");

var $4coax = parcelRequire("4coax");

var $6Ef7A = parcelRequire("6Ef7A");

var $cNC3o = parcelRequire("cNC3o");

var $7b2YZ = parcelRequire("7b2YZ");

var $fhEkQ = parcelRequire("fhEkQ");

var $ecsiI = parcelRequire("ecsiI");

var $dcUdk = parcelRequire("dcUdk");
const $7256662a4b816bdb$export$1b617bec6a57541b = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (repository)=>repository.pullRequest);
const $7256662a4b816bdb$export$f8de4ca5fb52fe5f = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.rawComments);
const $7256662a4b816bdb$export$adda5cf9d71979b8 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.defaultMergeStrategy);
const $7256662a4b816bdb$export$fe1750a63e4475b2 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.mergeMessageMaxSizeBytes);
const $7256662a4b816bdb$export$5f7f07413e7c3277 = {
    // These values are provided by the backend in the window.__initial_state__ but providing
    // some fallback here just in case the backend fails to provide the values.
    singleFileModeThresholdFiles: 200,
    singleFileModeThresholdLines: 8000,
    singleFileModePerFileLimitLines: 3000,
    allFilesModePerFileLimitBytes: 102400,
    singleFileModePerFileLimitBytes: 153600,
    allFilesModePerFileLimitLines: 2000,
    singleFileModeTruncateLines: 20000,
    allFilesModeTruncateLines: 8000,
    // The "truncate files" (file tree) limit should generally be the same for SFM and AFM,
    // but separate limits are available in case different limits are needed in the future.
    singleFileModeTruncateFiles: 999,
    allFilesModeTruncateFiles: 999
};
const $7256662a4b816bdb$var$getPullRequestRenderingLimitsWithoutDefaultsApplied = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.renderingLimits);
const $7256662a4b816bdb$export$9325b1226abfcbd6 = (0, $aXXtM.createSelector)($7256662a4b816bdb$var$getPullRequestRenderingLimitsWithoutDefaultsApplied, (limitsWithoutDefaults)=>{
    // During introduction of new limits, the limits provided by the backend may not contain
    // all limit keys, so they are merged on top of the default values stored in the frontend.
    return {
        ...$7256662a4b816bdb$export$5f7f07413e7c3277,
        ...limitsWithoutDefaults
    };
});
const $7256662a4b816bdb$export$4df7494939751eca = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.diffsExpansionState);
const $7256662a4b816bdb$export$5c5a128d859aacec = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$4df7494939751eca, (_, filepath)=>filepath, (diffsExpansionState, filepath)=>diffsExpansionState[filepath]);
const $7256662a4b816bdb$var$getCurrentPullRequestKey = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.currentPullRequest);
const $7256662a4b816bdb$export$d771b66b9391b013 = (0, $aXXtM.createSelector)($7256662a4b816bdb$var$getCurrentPullRequestKey, (0, $7qdXF.getEntities), (key, entities)=>(0, $ga67g.denormalize)(key, (0, $b2RHC.pullRequest), entities));
const $7256662a4b816bdb$export$888dec7fe8d5fbc8 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d771b66b9391b013, (currentPullRequest)=>currentPullRequest ? currentPullRequest.id : null);
const $7256662a4b816bdb$export$403d45f626d46542 = (0, $aXXtM.createSelector)((0, $aanBq.getCurrentRepositoryWorkspaceUUID), (0, $aanBq.getCurrentRepositoryUuid), $7256662a4b816bdb$export$888dec7fe8d5fbc8, (workspaceUuid, repoUuid, prId)=>{
    const prIdentifier = `${(0, $a5HLv.uncurlyUuid)(workspaceUuid || "")}::${(0, $a5HLv.uncurlyUuid)(repoUuid || "")}::${prId || ""}`;
    return {
        irEnabled: true,
        // we expect irSelectedDiffType to be overwritten so this is a placeholder
        irSelectedDiffType: "NONE",
        prIdentifier: prIdentifier
    };
});
const $7256662a4b816bdb$export$a427536f712a4bbe = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d771b66b9391b013, (currentPullRequest)=>currentPullRequest ? currentPullRequest.title : null);
const $7256662a4b816bdb$export$12a0f09967a05f8d = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d771b66b9391b013, (currentPullRequest)=>currentPullRequest ? currentPullRequest.close_source_branch : false);
const $7256662a4b816bdb$export$767a9cbfa2cc68a1 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (pullRequest)=>pullRequest ? pullRequest.annotations : null);
const $7256662a4b816bdb$export$92071663b35f9896 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (pullRequest)=>pullRequest ? pullRequest.hiddenAnnotations : []);
const $7256662a4b816bdb$export$e91c37a786274b9 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (pullRequest)=>pullRequest ? pullRequest.hiddenDiffComments : []);
const $7256662a4b816bdb$export$120f820ff10ccd25 = (0, $cQrjH.default)($7256662a4b816bdb$export$767a9cbfa2cc68a1, $7256662a4b816bdb$export$92071663b35f9896, (_state, filePath)=>filePath, (annotations, hiddenAnnotations, filePath)=>annotations && filePath && !hiddenAnnotations.includes(filePath) ? annotations.filter((annotation)=>annotation.path === filePath) : undefined)((_state, filePath)=>filePath || "");
const $7256662a4b816bdb$export$af40042a2d6f6e3 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (pullRequest)=>pullRequest ? Array.isArray(pullRequest.codeInsightsReports) ? pullRequest.codeInsightsReports : [] : []);
const $7256662a4b816bdb$export$41f1850c94ff35de = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (pullRequest)=>pullRequest ? pullRequest.isCodeInsightsReportsLoading : false);
const $7256662a4b816bdb$export$f111efe80a312340 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (state)=>state.merge.canCreatePendingMerge);
const $7256662a4b816bdb$export$55e460c7967a5910 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (pullRequest)=>pullRequest ? !!pullRequest.hasCodeInsightsReportsError : false);
const $7256662a4b816bdb$export$259d10243eb9efaf = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (pullRequest)=>pullRequest ? pullRequest.iterativeReview.isIterativeReviewComplete : false);
const $7256662a4b816bdb$export$4998ad8189f87785 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (pullRequest)=>pullRequest ? pullRequest.codeInsightsAnnotations || {} : {});
const $7256662a4b816bdb$export$c0d1119b49aa28fd = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (pullRequest)=>pullRequest ? pullRequest.isCodeInsightsAnnotationsLoading : false);
const $7256662a4b816bdb$export$fb79193924241ae4 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d771b66b9391b013, (currentPullRequest)=>(currentPullRequest === null || currentPullRequest === void 0 ? void 0 : currentPullRequest.state) === "OPEN");
const $7256662a4b816bdb$export$bcff36ca266feb49 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d771b66b9391b013, (currentPullRequest)=>currentPullRequest ? currentPullRequest.author : null);
const $7256662a4b816bdb$export$e9c8863f158f170 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d771b66b9391b013, (currentPullRequest)=>{
    var _currentPullRequest$d;
    return (_currentPullRequest$d = currentPullRequest === null || currentPullRequest === void 0 ? void 0 : currentPullRequest.diff_type) !== null && _currentPullRequest$d !== void 0 ? _currentPullRequest$d : null;
});
const $7256662a4b816bdb$export$a9031e95bc91b646 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$e9c8863f158f170, (diffType)=>diffType === (0, $axaTk.DiffType).TOPIC_DIFF);
const $7256662a4b816bdb$export$722ef319f7e0ba86 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$e9c8863f158f170, (diffType)=>diffType === (0, $axaTk.DiffType).PREVIEW_MERGE_DIFF);
const $7256662a4b816bdb$export$7a575a20965792f1 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$bcff36ca266feb49, (0, $g2R3c.getCurrentUserKey), (author, userUuid)=>(author === null || author === void 0 ? void 0 : author.uuid) === userUuid);
const $7256662a4b816bdb$export$a830aa46910d6675 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d771b66b9391b013, (pullRequest)=>pullRequest ? pullRequest.participants || [] : []);
const $7256662a4b816bdb$export$28eb8231b64b51c3 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$bcff36ca266feb49, $7256662a4b816bdb$export$a830aa46910d6675, (author, participants)=>participants.filter((participant)=>(0, $6Ef7A.isReviewer)(participant) && (0, $6Ef7A.isNotAuthor)(participant, author)));
const $7256662a4b816bdb$export$3d2dbe0d1005510c = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$bcff36ca266feb49, $7256662a4b816bdb$export$a830aa46910d6675, (author, participants)=>{
    const reviewers = participants.filter((participant)=>(0, $6Ef7A.isReviewer)(participant) && (0, $6Ef7A.isNotAuthor)(participant, author));
    return reviewers.filter((reviewer)=>reviewer.approved);
});
const $7256662a4b816bdb$export$bf823f9e542564e7 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$bcff36ca266feb49, $7256662a4b816bdb$export$28eb8231b64b51c3, (0, $g2R3c.getCurrentUser), (author, reviewers, currentUser)=>{
    if (!(currentUser !== null && currentUser !== void 0 && currentUser.account_id) || !(author !== null && author !== void 0 && author.account_id)) return "WATCHER";
    else if (currentUser.account_id === (author === null || author === void 0 ? void 0 : author.account_id)) return "AUTHOR";
    else if (reviewers.map((reviewer)=>{
        var _reviewer$user;
        return (_reviewer$user = reviewer.user) === null || _reviewer$user === void 0 ? void 0 : _reviewer$user.account_id;
    }).includes(currentUser.account_id)) return "REVIEWER";
    return "WATCHER";
});
const $7256662a4b816bdb$export$6f741a60a1f2d895 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$bcff36ca266feb49, $7256662a4b816bdb$export$a830aa46910d6675, (author, participants)=>{
    return participants.some((participant)=>(0, $6Ef7A.isReviewer)(participant) && (0, $6Ef7A.isNotAuthor)(participant, author) && participant.state === (0, $axaTk.ParticipantStateTypes).changesRequested);
});
const $7256662a4b816bdb$export$fe3b7c25084884b0 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (pullRequest)=>{
    return {
        isRequestingChangesDisabled: pullRequest.isRequestingChangesDisabled,
        isRequestingChangesError: pullRequest.isRequestingChangesError,
        isRequestingChangesPending: pullRequest.isRequestingChangesPending
    };
});
const $7256662a4b816bdb$export$4554c83f567790ec = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$a830aa46910d6675, (0, $g2R3c.getCurrentUserKey), (participants, userUuid)=>{
    const foundParticipant = participants.find((participant)=>{
        var _participant$user;
        return ((_participant$user = participant.user) === null || _participant$user === void 0 ? void 0 : _participant$user.uuid) === userUuid;
    });
    return (foundParticipant === null || foundParticipant === void 0 ? void 0 : foundParticipant.state) === (0, $axaTk.ParticipantStateTypes).changesRequested;
});
const $7256662a4b816bdb$export$6f84fa00ebbb8d85 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$a830aa46910d6675, (0, $g2R3c.getCurrentUserKey), (participants, userUuid)=>{
    const foundParticipant = participants.find((participant)=>{
        var _participant$user2;
        return ((_participant$user2 = participant.user) === null || _participant$user2 === void 0 ? void 0 : _participant$user2.uuid) === userUuid;
    });
    return (foundParticipant === null || foundParticipant === void 0 ? void 0 : foundParticipant.approved) || (foundParticipant === null || foundParticipant === void 0 ? void 0 : foundParticipant.state) === (0, $axaTk.ParticipantStateTypes).approved;
});
const $7256662a4b816bdb$export$5c7e947d22f3df64 = (state)=>state.repository.pullRequest.lastPullRequestRetrieved;
const $7256662a4b816bdb$export$a62ee43435432a03 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.errorMessage);
const $7256662a4b816bdb$export$f6e282072465cd42 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d771b66b9391b013, (currentPullRequest)=>currentPullRequest ? currentPullRequest.created_on : null);
const $7256662a4b816bdb$export$388a9c4cec4475d0 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d771b66b9391b013, (pullRequest)=>{
    const FALLBACK_REPO = {
        full_name: "/",
        owner: {
            uuid: undefined
        }
    };
    const destRepo = (0, $lIZwG.default)(pullRequest, "destination.repository", // This repo object has so many nullable fields to traverse
    FALLBACK_REPO);
    const ownerUuid = destRepo.owner ? destRepo.owner.uuid : undefined;
    return {
        owner: destRepo.full_name.split("/")[0],
        ownerUuid: ownerUuid,
        slug: destRepo.full_name.split("/")[1],
        repoUuid: destRepo.uuid,
        id: pullRequest ? pullRequest.id : undefined
    };
});
const $7256662a4b816bdb$export$a954f0a78a0696f0 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d771b66b9391b013, (pullRequest)=>{
    var _pullRequest$source;
    return (pullRequest === null || pullRequest === void 0 ? void 0 : (_pullRequest$source = pullRequest.source) === null || _pullRequest$source === void 0 ? void 0 : _pullRequest$source.repository) || null;
});
const $7256662a4b816bdb$export$8f1a7306324520ae = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$a954f0a78a0696f0, (sourceRepo)=>(sourceRepo === null || sourceRepo === void 0 ? void 0 : sourceRepo.uuid) || undefined);
const $7256662a4b816bdb$export$6a1dccc4087fd1a0 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d771b66b9391b013, (pullRequest)=>{
    var _pullRequest$destinat;
    return (pullRequest === null || pullRequest === void 0 ? void 0 : (_pullRequest$destinat = pullRequest.destination) === null || _pullRequest$destinat === void 0 ? void 0 : _pullRequest$destinat.repository) || null;
});
const $7256662a4b816bdb$export$8d24937e41932997 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$6a1dccc4087fd1a0, (repository)=>repository === null || repository === void 0 ? void 0 : repository.full_name);
const $7256662a4b816bdb$export$92cec7373e4dfaa7 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$6a1dccc4087fd1a0, (repository)=>repository === null || repository === void 0 ? void 0 : repository.uuid);
const $7256662a4b816bdb$export$ce0791f1ca2316dd = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d771b66b9391b013, (pullRequest)=>(0, $lIZwG.default)(pullRequest, "source.commit.hash", null));
const $7256662a4b816bdb$export$56af3d9fc4d2d518 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d771b66b9391b013, (pullRequest)=>`${(0, $635SY.default).ui.edit((0, $lIZwG.default)(pullRequest, "source.repository.full_name", null), (0, $lIZwG.default)(pullRequest, "source.commit.hash", null), "bitbucket-pipelines.yml", {
        at: {
            name: (0, $lIZwG.default)(pullRequest, "source.branch.name", null)
        }
    })}&showCodeInsightsPipes=true`);
const $7256662a4b816bdb$export$d4ad3b81df0d0701 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d771b66b9391b013, (pullRequest)=>(path)=>{
        var _pullRequest$source2, _pullRequest$source2$, _pullRequest$source3, _pullRequest$source3$, _pullRequest$source4, _pullRequest$source4$;
        return (0, $635SY.default).ui.source((pullRequest === null || pullRequest === void 0 ? void 0 : (_pullRequest$source2 = pullRequest.source) === null || _pullRequest$source2 === void 0 ? void 0 : (_pullRequest$source2$ = _pullRequest$source2.repository) === null || _pullRequest$source2$ === void 0 ? void 0 : _pullRequest$source2$.full_name) || "", {
            refOrHash: pullRequest === null || pullRequest === void 0 ? void 0 : (_pullRequest$source3 = pullRequest.source) === null || _pullRequest$source3 === void 0 ? void 0 : (_pullRequest$source3$ = _pullRequest$source3.commit) === null || _pullRequest$source3$ === void 0 ? void 0 : _pullRequest$source3$.hash,
            path: path,
            at: pullRequest === null || pullRequest === void 0 ? void 0 : (_pullRequest$source4 = pullRequest.source) === null || _pullRequest$source4 === void 0 ? void 0 : (_pullRequest$source4$ = _pullRequest$source4.branch) === null || _pullRequest$source4$ === void 0 ? void 0 : _pullRequest$source4$.name
        });
    });
const $7256662a4b816bdb$export$6ae124184a57a5a1 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d771b66b9391b013, (pullRequest)=>`/${(0, $lIZwG.default)(pullRequest, "source.repository.full_name", null)}` + `/addon/pipelines-installer/home#!/?from=prPage`);
const $7256662a4b816bdb$export$ed86785d8d2aad6b = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d771b66b9391b013, (pullRequest)=>(0, $lIZwG.default)(pullRequest, "destination.commit.hash", null));
const $7256662a4b816bdb$export$8d8cb3adf31a86c8 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$ce0791f1ca2316dd, $7256662a4b816bdb$export$ed86785d8d2aad6b, (sourceHash, destinationHash)=>{
    if (!sourceHash || !destinationHash) return null;
    return `${sourceHash}..${destinationHash}`;
});
const $7256662a4b816bdb$export$474ab49172b353a3 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d771b66b9391b013, (pullRequest)=>pullRequest ? pullRequest.source.branch.name : "");
const $7256662a4b816bdb$export$438812fbf036c109 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d771b66b9391b013, (pullRequest)=>pullRequest ? pullRequest.destination.branch.name : "");
const $7256662a4b816bdb$export$38d78d47a63da66e = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d771b66b9391b013, (pullRequest)=>pullRequest ? pullRequest.links.diff.href : undefined);
const $7256662a4b816bdb$export$edf855d8807cf611 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d771b66b9391b013, (pullRequest)=>pullRequest ? pullRequest.links.diffstat.href : undefined);
const $7256662a4b816bdb$export$7dbd46d1cf50a9d8 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d771b66b9391b013, (pullRequest)=>pullRequest ? pullRequest.rendered.description.html : "");
const $7256662a4b816bdb$export$de9f2827b6041676 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$a954f0a78a0696f0, $7256662a4b816bdb$export$6a1dccc4087fd1a0, (sourceRepo, destinationRepo)=>{
    const source = (0, $lIZwG.default)(sourceRepo, "uuid");
    const destination = (0, $lIZwG.default)(destinationRepo, "uuid");
    return !source || !destination || source !== destination;
});
const $7256662a4b816bdb$export$a40c1fdc4c13b972 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.highlightedCommentId);
const $7256662a4b816bdb$export$d1ca0f74cdb6f499 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.highlightCommentThread);
const $7256662a4b816bdb$export$cde20bea06311705 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isSingleFileMode);
const $7256662a4b816bdb$export$31f0e4d642789334 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isSingleFileModeEligible);
const $7256662a4b816bdb$export$215e738417f73f52 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isSingleFileModeSettingsHeaderVisible);
const $7256662a4b816bdb$export$f600d4e4e6acfde4 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isStickyHeaderActive);
const $7256662a4b816bdb$export$733bb30b9159fd88 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.conflicts);
const $7256662a4b816bdb$export$d6435c7cbe3076ec = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$733bb30b9159fd88, (conflicts)=>conflicts.length);
const $7256662a4b816bdb$export$198b839f4813d8b9 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$733bb30b9159fd88, (conflicts)=>conflicts.length > 0);
const $7256662a4b816bdb$export$1f58c9b8db82f2b = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (state)=>state.merge.isAsyncMergeInProgress || !!state.mergeInProgress);
const $7256662a4b816bdb$export$fb310a7f9d12e0e6 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.mergeInProgress);
const $7256662a4b816bdb$export$5a84fd1aa37b0be4 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.mergeChecks);
const $7256662a4b816bdb$export$4e2264e57c60fabf = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isMergeable);
const $7256662a4b816bdb$export$56fa1f5004b97f0b = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.canCurrentUserMerge);
const $7256662a4b816bdb$export$6285a3e8b32ebb57 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isMissingCommits);
const $7256662a4b816bdb$export$1c5f69608a59bd3c = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isUpdatingCommits);
const $7256662a4b816bdb$export$e40d490f8731fbc0 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.hasMissingCommitsError);
const $7256662a4b816bdb$export$5245eb2a6e8d7eca = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.mergeChecks.filter((item)=>!item.pass).length);
const $7256662a4b816bdb$export$7ce08f573b6d6a49 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.mergeChecks.filter((item)=>item.key === "minimum_approvals")[0]);
const $7256662a4b816bdb$export$2b96942dabadd251 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.mergeChecks.filter((item)=>item.key === "minimum_successful_builds")[0]);
const $7256662a4b816bdb$export$4b071e33a0906f3d = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$5a84fd1aa37b0be4, (mergeChecks)=>mergeChecks.length > 0 && mergeChecks.every((mergeCheck)=>!mergeCheck.allow_merge));
const $7256662a4b816bdb$export$5707047e7be3f771 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$5a84fd1aa37b0be4, $7256662a4b816bdb$export$733bb30b9159fd88, (mergeChecks, conflicts)=>conflicts.length === 0 && mergeChecks.length > 0 && mergeChecks.every((mergeCheck)=>mergeCheck.pass));
const $7256662a4b816bdb$export$9ac503180e3c0b85 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$5a84fd1aa37b0be4, $7256662a4b816bdb$export$733bb30b9159fd88, $7256662a4b816bdb$export$1f58c9b8db82f2b, $7256662a4b816bdb$export$6285a3e8b32ebb57, (mergeChecks, conflicts, isAsyncMergeInProgress, isMissingCommits)=>conflicts.length === 0 && mergeChecks.every((mergeCheck)=>mergeCheck.pass) && !isAsyncMergeInProgress && !isMissingCommits);
const $7256662a4b816bdb$export$16ca4c94fc2a89d = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$5245eb2a6e8d7eca, $7256662a4b816bdb$export$2b96942dabadd251, (countFailedPullRequestMergeChecks, pullRequestSuccessfulBuildsMergeCheck)=>countFailedPullRequestMergeChecks === 1 && pullRequestSuccessfulBuildsMergeCheck && !pullRequestSuccessfulBuildsMergeCheck.pass);
const $7256662a4b816bdb$export$fe0d889da20a4d0 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.mergeChecksError);
const $7256662a4b816bdb$export$eb474ce8d0737097 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.mergeChecksSource === "frozen");
const $7256662a4b816bdb$export$d27a69ede99fa4a1 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isMergeChecksLoading && !prSlice.mergeChecks.length);
const $7256662a4b816bdb$export$c3b9dbcea3987e20 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (pullRequest)=>pullRequest.diff);
const $7256662a4b816bdb$export$fc7c1666f8fda653 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$c3b9dbcea3987e20, (diff)=>diff.length);
const $7256662a4b816bdb$export$15a0b1e5d81eb36b = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$c3b9dbcea3987e20, (diff)=>(0, $fN6IA.countAllAddedAndDeletedLines)(diff));
const $7256662a4b816bdb$export$d1b9710aa8435c62 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.diffStat);
const $7256662a4b816bdb$export$7f0b13c6415a37cd = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d1b9710aa8435c62, (_, path)=>path, (statuses, path)=>{
    var _statuses$filter$;
    return statuses === null || statuses === void 0 ? void 0 : (_statuses$filter$ = statuses.filter((status)=>{
        var _status$new;
        return ((_status$new = status.new) === null || _status$new === void 0 ? void 0 : _status$new.path) === path;
    })[0]) === null || _statuses$filter$ === void 0 ? void 0 : _statuses$filter$.status;
});
const $7256662a4b816bdb$export$a70831b5dce49209 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d1b9710aa8435c62, (diffStat)=>(diffStat === null || diffStat === void 0 ? void 0 : diffStat.length) || 0);
const $7256662a4b816bdb$var$getFileTruncatedDiffStat = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d1b9710aa8435c62, $7256662a4b816bdb$export$cde20bea06311705, $7256662a4b816bdb$export$9325b1226abfcbd6, (diffStats, isSingleFileModeActive, renderingLimits)=>{
    if (!diffStats) return null;
    return renderingLimits ? diffStats.slice(0, isSingleFileModeActive ? renderingLimits.singleFileModeTruncateFiles : renderingLimits.allFilesModeTruncateFiles) : diffStats;
});
const $7256662a4b816bdb$export$57a5747d9a1c9ec1 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.diffStatErrorKey);
const $7256662a4b816bdb$export$adc15ac7f883828f = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.diffErrorCode);
const $7256662a4b816bdb$export$e6f2edc1337cff8b = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.diffStatErrorCode);
const $7256662a4b816bdb$export$141d52f7a6564c59 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.activePermalink);
const $7256662a4b816bdb$var$getFileAndLineTruncatedPullRequestDiff = (0, $aXXtM.createSelector)($7256662a4b816bdb$var$getFileTruncatedDiffStat, $7256662a4b816bdb$export$c3b9dbcea3987e20, $7256662a4b816bdb$export$cde20bea06311705, $7256662a4b816bdb$export$9325b1226abfcbd6, (diffStats, diffs, isSingleFileModeActive, renderingLimits)=>{
    if (!diffStats || diffStats.length === 0) return [];
    /**
   * The diffstat is the base source of truth for files that will be rendered in the PR
   * because when "ignore whitespace" is enabled, files with whitespace-only changes will
   * not be present in the full diff.
   *
   * The rendered files might be further filtered based on the overall # of lines, which we
   * calculate below.
   */ const filteredDiffStats = diffStats.map((stat)=>(0, $ecsiI.getDiffStatPath)(stat, (0, $ecsiI.DiffStatPathType).Escaped));
    const filteredDiffs = diffs.filter((diff)=>filteredDiffStats.indexOf((0, $ecsiI.getDiffPath)(diff)) !== -1);
    return (0, $cNC3o.truncateDiffsByOverallLineCount)(filteredDiffs, isSingleFileModeActive, renderingLimits);
});
const $7256662a4b816bdb$export$247075d86503c6ba = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$c3b9dbcea3987e20, $7256662a4b816bdb$var$getFileAndLineTruncatedPullRequestDiff, $7256662a4b816bdb$var$getFileTruncatedDiffStat, $7256662a4b816bdb$export$cde20bea06311705, (allDiffs, diffs, diffStats, isSingleFileModeActive)=>{
    if (!diffStats || diffStats.length === 0) return [];
    /**
   * If there are files in the truncated diffstat but not the truncated diff, there are 2 possibilities
   *
   * A) The remaining files present all have whitespace-only changes and "ignore whitespace" is enabled.
   *    In this case, we want to return the diffstat without further changes.
   *
   * B) The 1st file in the diff is rendered, but exceeds the limit on the # of lines for the entire diff.
   *    This should not be possible. The per-file limit should always be at or below the entire diff limit.
   */ if (diffs.length === 0) return diffStats;
    // If we didn't truncate the diff due to the # of lines, just return the full diffstat to avoid
    // accidentally dropping files with whitespace-only changes if they're at the end of the diff
    if (diffs.length === allDiffs.length) return diffStats;
    // For single file mode, we don't want the file tree truncation point to depend on how much of
    // the diff is visible.
    if (isSingleFileModeActive) return diffStats; // truncation is already done in getFileTruncatedDiffStat
    /**
   * Find the path of the last file diff that we render, taking our client-side limits
   * into account, and only return entries in the diffstat up to that file.
   *
   * We can't just filter the diffstat by paths present in the the full diff because when
   * "ignore whitespace" is enabled, files with whitespace-only changes will not be present
   * in the full diff.
   */ const limitBreakingDiffIndex = diffs.length;
    // This is the path of the 1st file that's not included in the truncated diff
    const limitBreakingDiffPath = (0, $ecsiI.getDiffPath)(allDiffs[limitBreakingDiffIndex]);
    const cutoffIndex = diffStats.map((stat)=>(0, $ecsiI.getDiffStatPath)(stat, (0, $ecsiI.DiffStatPathType).Escaped)).indexOf(limitBreakingDiffPath);
    // If a file in the diff isn't found in the diffstat, something is wrong.
    // Fall back to returning an unfiltered diffstat
    if (cutoffIndex === -1) return diffStats;
    // Return everything up to (but not including) the file that went over the
    // diff limit for # of lines
    return diffStats.slice(0, cutoffIndex);
});
const $7256662a4b816bdb$export$cd2ec653bcf5dc71 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.hiddenFileDialogAnchor);
const $7256662a4b816bdb$export$ea4ead2c6cafda90 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.filterCommentsByUser);
const $7256662a4b816bdb$export$3da0ddbfc6a831a9 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isCommentsFilterActive);
const $7256662a4b816bdb$export$5a1ae1473f49ed4e = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$3da0ddbfc6a831a9, $7256662a4b816bdb$export$ea4ead2c6cafda90, (_, passedArg)=>passedArg, (isCommentFilterActive, filterUserUuid, valueArg)=>{
    return isCommentFilterActive && filterUserUuid === valueArg;
});
const $7256662a4b816bdb$export$aaf40e476dfebf61 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$f8de4ca5fb52fe5f, (rawComments)=>{
    return rawComments.filter((c)=>(!(0, $xz4dB.isApiComment)(c) || !c.deleted) && c.inline);
});
const $7256662a4b816bdb$export$e3678887dc01adb5 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$f8de4ca5fb52fe5f, (rawComments)=>{
    return rawComments.filter((c)=>(!(0, $xz4dB.isApiComment)(c) || !c.deleted) && c.pending);
});
const $7256662a4b816bdb$export$ba80024d69556ec7 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$e3678887dc01adb5, (pendingComments)=>{
    return pendingComments.filter((c)=>c.inline && c.inline.outdated).length;
});
const $7256662a4b816bdb$export$fc18a5e000ddb273 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d771b66b9391b013, (currentPullRequest)=>(currentPullRequest === null || currentPullRequest === void 0 ? void 0 : currentPullRequest.state) === "MERGED");
const $7256662a4b816bdb$var$getDiffSort = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.diffSort);
function $7256662a4b816bdb$var$hasFilteredComment(comments, userUuid) {
    const matchesUserFilter = (c, userId)=>userId ? c.user.uuid === userId : true;
    // returns true if comment modified the diff file path
    const matchesDiffPath = (c, diff)=>{
        var _c$inline;
        return ((_c$inline = c.inline) === null || _c$inline === void 0 ? void 0 : _c$inline.path) === (0, $ecsiI.getDiffStatPath)(diff, (0, $ecsiI.DiffStatPathType).Unescaped);
    };
    // return a function to pass to .filter()
    // Return true if the diff should be shown
    return (stat)=>{
        return !!comments.find((c)=>matchesUserFilter(c, userUuid) && matchesDiffPath(c, stat));
    };
}
const $7256662a4b816bdb$var$sortByNewestComments = (inlineComments)=>{
    // sort in descending order; newest comments are first
    const commentsByDate = inlineComments.sort((a, b)=>b.created_on.localeCompare(a.created_on));
    const lastCommentDate = (diffStat)=>{
        const newestComment = commentsByDate.find((c)=>{
            var _c$inline2;
            return ((_c$inline2 = c.inline) === null || _c$inline2 === void 0 ? void 0 : _c$inline2.path) === (0, $ecsiI.getDiffStatPath)(diffStat, (0, $ecsiI.DiffStatPathType).Unescaped);
        });
        return newestComment ? newestComment.created_on : "";
    };
    return (a, b)=>lastCommentDate(b).localeCompare(lastCommentDate(a));
};
const $7256662a4b816bdb$export$dbba94e196c18a2c = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$247075d86503c6ba, $7256662a4b816bdb$export$aaf40e476dfebf61, $7256662a4b816bdb$export$3da0ddbfc6a831a9, $7256662a4b816bdb$export$ea4ead2c6cafda90, $7256662a4b816bdb$var$getDiffSort, (0, $i2O3k.getGlobalFileViewMode), (diffStat, inlineComments, isCommentsFilterActive, userUuid, diffSort, fileViewMode)=>{
    if (!diffStat) return diffStat;
    const filteredDiffStat = isCommentsFilterActive ? diffStat.filter($7256662a4b816bdb$var$hasFilteredComment(inlineComments, userUuid)) : diffStat.slice();
    if (diffSort === "latestComments") {
        // sorting by comment order
        filteredDiffStat.sort($7256662a4b816bdb$var$sortByNewestComments(inlineComments));
        return filteredDiffStat;
    }
    if (fileViewMode === (0, $i2O3k.FileViewMode).List) {
        // sorting by file list order
        const flattenedFileTree = (0, $70vW8.diffStatToFileTree)(filteredDiffStat).map((0, $2hjj7.flattenDirectories));
        const flattenedFiles = (0, $c2vnU.flattenFiles)(flattenedFileTree).flatMap((dirEntry)=>dirEntry.contents);
        // sort diffStat by file list order
        const sortedFilteredDiffStat = [];
        flattenedFiles.forEach((fileEntry)=>{
            // exclude prefix "#chg-" when comparing path in file href as diffstat path doesn't have it
            const matchedDiffStat = filteredDiffStat.find((diffStatEntry)=>(0, $ecsiI.getDiffStatPath)(diffStatEntry, (0, $ecsiI.DiffStatPathType).Unescaped) === (0, $lvqI0.removeUrlHashPrefix)(fileEntry.href));
            if (matchedDiffStat) sortedFilteredDiffStat.push(matchedDiffStat);
        });
        return sortedFilteredDiffStat;
    } else {
        const sortedFilteredDiffStat = filteredDiffStat.slice().sort((a, b)=>{
            const aPath = (0, $ecsiI.getDiffStatPath)(a, (0, $ecsiI.DiffStatPathType).Unescaped);
            const bPath = (0, $ecsiI.getDiffStatPath)(b, (0, $ecsiI.DiffStatPathType).Unescaped);
            // Put root files first
            if (aPath.includes("/") && !bPath.includes("/")) return 1;
            if (!aPath.includes("/") && bPath.includes("/")) return -1;
            // Otherwise, alpha sorting
            return aPath.localeCompare(bPath);
        });
        return sortedFilteredDiffStat;
    }
});
const $7256662a4b816bdb$export$b8bc40aa44253c8c = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, $7256662a4b816bdb$export$dbba94e196c18a2c, $7256662a4b816bdb$var$getFileAndLineTruncatedPullRequestDiff, (pullRequest, diffStat = [], diffs = [])=>{
    if (pullRequest.activeDiff) return pullRequest.activeDiff;
    if (!diffStat.length || !diffs.length) return "";
    const diffPaths = new Set(diffs.map((diff)=>(0, $ecsiI.getDiffPath)(diff)));
    // Pick the first file from the diffStat that also exists in the diff (we
    // may only have a partial diff)
    for (const file of diffStat){
        const filepath = (0, $ecsiI.getDiffStatPath)(file, (0, $ecsiI.DiffStatPathType).Unescaped);
        if (diffPaths.has(filepath)) return (0, $9kTpj.createDiffPermalink)((0, $4coax.extractFilepath)(file));
    }
    return "";
});
const $7256662a4b816bdb$export$4c4d20accead08b1 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$cde20bea06311705, $7256662a4b816bdb$export$b8bc40aa44253c8c, (isSingleFileModeActive, activeDiff)=>isSingleFileModeActive ? activeDiff : undefined);
const $7256662a4b816bdb$export$8defae39a65842ef = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$c3b9dbcea3987e20, $7256662a4b816bdb$var$getFileAndLineTruncatedPullRequestDiff, $7256662a4b816bdb$export$d1b9710aa8435c62, $7256662a4b816bdb$export$cde20bea06311705, $7256662a4b816bdb$export$4c4d20accead08b1, (diffs, limitedDiffs, diffStats, isSingleFileModeActive, activeDiff)=>{
    const relevantDiffs = !isSingleFileModeActive ? limitedDiffs : diffs;
    if (isSingleFileModeActive && activeDiff) {
        if (!diffStats) return [];
        const singleDiffStat = diffStats.find((stat)=>(0, $9kTpj.createDiffPermalink)((0, $ecsiI.getDiffStatPath)(stat, (0, $ecsiI.DiffStatPathType).Unescaped)) === activeDiff);
        if (singleDiffStat) {
            const singleDiff = relevantDiffs.find((diff)=>(0, $ecsiI.getDiffPath)(diff) === (0, $ecsiI.getDiffStatPath)(singleDiffStat, (0, $ecsiI.DiffStatPathType).Escaped));
            if (singleDiff) return [
                singleDiff
            ];
        }
        return [];
    }
    return relevantDiffs;
});
const $7256662a4b816bdb$export$72e42b6bd52e725e = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$8defae39a65842ef, (diff)=>diff.length);
const $7256662a4b816bdb$export$96cfd34cd4a458d3 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$8defae39a65842ef, (diff)=>(0, $fN6IA.countAllAddedAndDeletedLines)(diff));
const $7256662a4b816bdb$export$e38541ce4409b7ce = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d1b9710aa8435c62, $7256662a4b816bdb$export$247075d86503c6ba, (diffStats, limitedDiffStats)=>{
    if (!diffStats || !limitedDiffStats) return false;
    return limitedDiffStats.length < diffStats.length;
});
const $7256662a4b816bdb$var$buildDiffFiles = (diffs, diffStats, conflicts, shouldIgnoreWhitespace, isSingleFileModeActive, singleFileModeActiveDiff)=>{
    if (!diffStats || diffStats.length === 0) return [];
    if (isSingleFileModeActive && !singleFileModeActiveDiff) return [];
    const singleFileModeDiffStat = isSingleFileModeActive && diffStats.find((diffStat)=>(0, $9kTpj.createDiffPermalink)((0, $ecsiI.getDiffStatPath)(diffStat, (0, $ecsiI.DiffStatPathType).Unescaped)) === singleFileModeActiveDiff);
    const relevantDiffStats = singleFileModeDiffStat ? [
        singleFileModeDiffStat
    ] : diffStats;
    return relevantDiffStats.map((diffStat)=>{
        var _diffStat$old2, _diffStat$new2;
        const aConflict = conflicts && conflicts.find((conflict)=>conflict.path === (0, $ecsiI.getDiffStatPath)(diffStat, (0, $ecsiI.DiffStatPathType).Unescaped));
        let matchingDiff = diffs && diffs.find((diff)=>{
            return(// Diffs have escaped file paths so we need to match
            // diff w/ diffstat using the unescaped diffstat path
            (0, $ecsiI.getDiffStatPath)(diffStat, (0, $ecsiI.DiffStatPathType).Escaped) === (0, $ecsiI.getDiffPath)(diff));
        });
        if (matchingDiff) {
            var _diffStat$old, _diffStat$new;
            matchingDiff = {
                ...matchingDiff,
                // We want to get the `from` and `to` values from the diffstat
                // because the diff can have escaping on certain file paths (e.g.
                // paths with tabs, emojis, etc. in them). The diffstat always gives
                // use the unescaped paths which we want to use from this point
                // forward for things such as posting comments, permalinking,
                // file tree, file headers, etc.
                from: ((_diffStat$old = diffStat.old) === null || _diffStat$old === void 0 ? void 0 : _diffStat$old.path) || "/dev/null",
                to: ((_diffStat$new = diffStat.new) === null || _diffStat$new === void 0 ? void 0 : _diffStat$new.path) || "/dev/null"
            };
        }
        const defaultDiff = {
            ...(0, $fhEkQ.defaultDiff),
            fileDiffStatus: diffStat.status,
            from: ((_diffStat$old2 = diffStat.old) === null || _diffStat$old2 === void 0 ? void 0 : _diffStat$old2.path) || "/dev/null",
            to: ((_diffStat$new2 = diffStat.new) === null || _diffStat$new2 === void 0 ? void 0 : _diffStat$new2.path) || "/dev/null"
        };
        // ============================
        // WHITESPACE ONLY DIFF
        // If we are ignoring whitespace, the diff endpoint will return
        // nothing for files that only have whitespace changes.
        // In order to build out a dummy diff placeholder in the UI
        // we need to to find the whitespace-only files and stub out a 'diff'
        // ============================
        return {
            ...defaultDiff,
            // Including the lines added and removed from the diff stat helps us
            // identify whether the file _should_ have been found in the diff
            // (e.g. it was a partial diff)
            additions: diffStat.lines_added,
            deletions: diffStat.lines_removed,
            ...matchingDiff,
            ...aConflict && {
                isConflicted: true
            },
            ...aConflict && {
                conflictMessage: aConflict.message
            },
            isFileContentsUnchanged: !!shouldIgnoreWhitespace && !matchingDiff
        };
    });
};
const $7256662a4b816bdb$export$eab6a89786a61877 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$c3b9dbcea3987e20, $7256662a4b816bdb$export$d1b9710aa8435c62, $7256662a4b816bdb$export$733bb30b9159fd88, (0, $i2O3k.getGlobalShouldIgnoreWhitespace), ()=>false, // when calculating all diff files, single file mode is not relevant
$7256662a4b816bdb$export$4c4d20accead08b1, $7256662a4b816bdb$var$buildDiffFiles);
const $7256662a4b816bdb$export$84e65bd7cd98b976 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$8defae39a65842ef, $7256662a4b816bdb$export$dbba94e196c18a2c, $7256662a4b816bdb$export$733bb30b9159fd88, (0, $i2O3k.getGlobalShouldIgnoreWhitespace), $7256662a4b816bdb$export$cde20bea06311705, $7256662a4b816bdb$export$4c4d20accead08b1, $7256662a4b816bdb$var$buildDiffFiles);
const $7256662a4b816bdb$export$c7906ce206376179 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.watchActionLoading);
const $7256662a4b816bdb$export$fbbe94ee2d19ed00 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isWatching);
const $7256662a4b816bdb$var$getPullRequestPolling = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.polling);
const $7256662a4b816bdb$export$3f789cbf798c3961 = (0, $aXXtM.createSelector)($7256662a4b816bdb$var$getPullRequestPolling, (prPolling)=>prPolling.lastPollTime);
const $7256662a4b816bdb$export$b105808586cbd1b3 = (0, $aXXtM.createSelector)($7256662a4b816bdb$var$getPullRequestPolling, (prPolling)=>({
        ...prPolling,
        lastPollTime: undefined
    }));
const $7256662a4b816bdb$export$a25fb481147e908 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.outdatedCommentsDialog);
const $7256662a4b816bdb$export$c069dcf229d4a27b = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.baseRevCommentsDialog);
const $7256662a4b816bdb$export$7b2681eb82d00ea9 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.diffCommentsDialog);
const $7256662a4b816bdb$export$743be29218944332 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.nonRenderedDiffCommentsDialogFilepath);
const $7256662a4b816bdb$export$6ef1b7d86d1734c = (diffFiles, filepath)=>{
    const files = (diffFiles || []).filter(// @ts-ignore TODO: fix noImplicitAny error here
    (file)=>(0, $4coax.extractFilepath)(file) === filepath);
    return files[0];
};
const $7256662a4b816bdb$export$f4fcc55c4d01519 = (0, $cQrjH.default)($7256662a4b816bdb$export$d1b9710aa8435c62, (_state, filePath)=>filePath, (diffStat, filePath)=>!!filePath && !$7256662a4b816bdb$export$6ef1b7d86d1734c(diffStat, filePath))((_state, filePath)=>filePath || "");
const $7256662a4b816bdb$export$e22cd5df4bfcc34a = (0, $cQrjH.default)($7256662a4b816bdb$export$247075d86503c6ba, $7256662a4b816bdb$export$f4fcc55c4d01519, (_state, filePath)=>filePath, (renderedDiffStat, isFileRemovedFromDiff, filePath)=>!!filePath && !isFileRemovedFromDiff && !$7256662a4b816bdb$export$6ef1b7d86d1734c(renderedDiffStat, filePath))((_state, filePath)=>filePath || "");
const $7256662a4b816bdb$export$3f45b3f1ba7ffa43 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$84e65bd7cd98b976, $7256662a4b816bdb$export$a25fb481147e908, (diffFiles, filepath)=>{
    const outdatedDialogFile = $7256662a4b816bdb$export$6ef1b7d86d1734c(diffFiles, filepath);
    if (outdatedDialogFile) return {
        file: outdatedDialogFile,
        isFileOutdated: false
    };
    // If the requested file isn't in the diff then we will construct a basic
    // "outdated" file that has enough information to fetch the context lines.
    return {
        file: {
            headers: [],
            chunks: [],
            fileDiffStatus: null,
            from: filepath,
            to: filepath
        },
        isFileOutdated: true
    };
});
const $7256662a4b816bdb$export$36844c1ae1bdf02d = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$84e65bd7cd98b976, $7256662a4b816bdb$export$c069dcf229d4a27b, (diffFiles, filepath)=>{
    const cslrDialogFile = $7256662a4b816bdb$export$6ef1b7d86d1734c(diffFiles, filepath);
    if (cslrDialogFile) return {
        file: cslrDialogFile,
        isFileOutdated: false
    };
    // If the requested file isn't in the diff then we will construct a basic
    // "outdated" file that has enough information to fetch the context lines.
    return {
        file: {
            headers: [],
            chunks: [],
            fileDiffStatus: null,
            from: filepath,
            to: filepath
        },
        isFileOutdated: true
    };
});
const $7256662a4b816bdb$export$a50921540f5141c7 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$84e65bd7cd98b976, $7256662a4b816bdb$export$7b2681eb82d00ea9, (diffFiles, filepath)=>$7256662a4b816bdb$export$6ef1b7d86d1734c(diffFiles, filepath));
const $7256662a4b816bdb$export$55d7762f5a5f59af = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$eab6a89786a61877, $7256662a4b816bdb$export$743be29218944332, (diffFiles, filepath)=>$7256662a4b816bdb$export$6ef1b7d86d1734c(diffFiles, filepath));
const $7256662a4b816bdb$export$72b2e5b28d60f0cb = (0, $cQrjH.default)($7256662a4b816bdb$export$388a9c4cec4475d0, (_state, params)=>params, (urlPieces, params)=>{
    return (0, $dcUdk.areLocatorsEqual)(urlPieces, (0, $dcUdk.toPullRequestLocator)(params));
})((_state, params)=>{
    const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug, pullRequestId: pullRequestId } = params;
    return `${repositoryOwner}:${repositorySlug}:${pullRequestId}`;
});
const $7256662a4b816bdb$export$89a8b50c38906331 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isSettingsChangeboardingDialogOpen);
const $7256662a4b816bdb$export$bd062b3793092ea9 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.sideBySideDiffState);
const $7256662a4b816bdb$export$5bde87782c2abf26 = (0, $cQrjH.default)($7256662a4b816bdb$export$1b617bec6a57541b, (0, $i2O3k.getGlobalDiffViewMode), (_state, fileName)=>fileName, (0, $8MnfV.getIsMobileHeaderActive), (prSlice, globalDiffViewMode, fileName, isMobileHeaderActive)=>{
    if (isMobileHeaderActive) return false;
    const isSideBySideEnabledForFile = prSlice.sideBySideDiffState[fileName];
    return isSideBySideEnabledForFile === undefined ? globalDiffViewMode === (0, $i2O3k.DiffViewMode).SideBySide : isSideBySideEnabledForFile;
})((_state, fileName)=>fileName);
const $7256662a4b816bdb$export$fa22863dfe039abd = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isOutdatedDialogOpen);
const $7256662a4b816bdb$export$cab6418d1adc1f33 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isReviewDraftDialogOpen);
const $7256662a4b816bdb$export$bf765564a547b362 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isDiffCommentsDialogOpen);
const $7256662a4b816bdb$export$9d84de8ce2b267e2 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isNonRenderedDiffCommentsDialogOpen);
const $7256662a4b816bdb$export$62ca784e6947e746 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isEditorOpen);
const $7256662a4b816bdb$export$41b301a3b564bd76 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>{
    return prSlice.sourceRepository.accessLevel;
});
const $7256662a4b816bdb$export$7c8178cc9001d237 = (0, $aXXtM.createSelector)((0, $aanBq.getCurrentRepositoryOwnerName), (0, $aanBq.getCurrentRepositorySlug), $7256662a4b816bdb$export$888dec7fe8d5fbc8, (owner, repoSlug, pullRequestId)=>`ari:cloud:bitbucket:${owner}-${repoSlug}:pullrequest/${pullRequestId}`.toLowerCase());
const $7256662a4b816bdb$export$67217321ce79561d = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$f8de4ca5fb52fe5f, (rawComments)=>{
    return rawComments.filter((c)=>(!(0, $xz4dB.isApiComment)(c) || !c.deleted) && !c.parent && c.inline).reverse();
});
const $7256662a4b816bdb$export$d56ad7688fba5394 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$67217321ce79561d, (comments)=>{
    // filter out any comments that are unresolved or pending.
    // we don't have to do this for resolved comments since
    // the user cannot resolve a pending comment
    const unresolvedComments = comments.filter((comment)=>!comment.resolution && !comment.pending);
    return unresolvedComments.map((unresolvedComment)=>(0, $deJTw.toNavComment)(unresolvedComment));
});
const $7256662a4b816bdb$export$ebb5d45b79a091fa = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$67217321ce79561d, (comments)=>{
    const resolvedComments = comments.filter((comment)=>comment.resolution);
    return resolvedComments.map((resolvedComment)=>(0, $deJTw.toNavComment)(resolvedComment));
});
const $7256662a4b816bdb$export$5eaab3768163a619 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$f8de4ca5fb52fe5f, $7256662a4b816bdb$export$7c8178cc9001d237, (rawComments, containerId)=>(0, $7b2YZ.formatAllComments)(rawComments, containerId));
const $7256662a4b816bdb$export$20c3b1f7e3dccd49 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$5eaab3768163a619, (formattedComments)=>formattedComments.fabricConversations);
const $7256662a4b816bdb$export$1c2293eb9e7b3def = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.contextLines || []);
const $7256662a4b816bdb$export$62b7f18569a1443d = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$5eaab3768163a619, (formattedComments)=>formattedComments.commentTree);
const $7256662a4b816bdb$export$d4ae3022854f03c4 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$5eaab3768163a619, $7256662a4b816bdb$export$1c2293eb9e7b3def, (formattedComments, contextLines)=>{
    const { conversations: conversations } = formattedComments;
    return conversations.map((convo)=>{
        const contextForConvo = contextLines[convo.conversationId];
        // explicit undefined check so that empty lines still count, friends don't let friends use truthiness
        if (contextForConvo === undefined) return convo;
        return {
            ...convo,
            meta: {
                ...convo.meta,
                context_lines: contextForConvo
            }
        };
    });
});
const $7256662a4b816bdb$export$5fe74f5b44609ce0 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isDiffsLoading);
const $7256662a4b816bdb$export$c62cfd3083e37585 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isLoadingOutdatedCommentContext);
const $7256662a4b816bdb$export$9d13670a66bf7b16 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isLoadingPendingCommentContext);
const $7256662a4b816bdb$export$48befafb6b9add0c = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isLoadingBaseRevCommentContext);
const $7256662a4b816bdb$export$d6840651ffd6082d = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isLoadingAllChangesCommentContext);
const $7256662a4b816bdb$export$e76c5ebb86b674b7 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isDiffStatLoading);
const $7256662a4b816bdb$export$4bf1ddfac66115f = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isRevertDialogOpen);
const $7256662a4b816bdb$export$f588d66507cfa941 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isPullRequestTitleUpdatePending);
const $7256662a4b816bdb$export$904c8ab9ba9648c4 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isPullRequestDescriptionUpdatePending);
const $7256662a4b816bdb$export$791081bd6d3fcab8 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.isPullRequestRemoveReviewerPending);
const $7256662a4b816bdb$export$2815f4ac3b46f67a = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.pullRequestAddReviewerPendingAaids.length > 0);
const $7256662a4b816bdb$export$c118997b769a38b2 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.pullRequestAddReviewerPendingAaids);
const $7256662a4b816bdb$export$3e989a4871019db7 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.revertError);
const $7256662a4b816bdb$export$84385a36e0d16fd3 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.hasDestinationBranch);
const $7256662a4b816bdb$export$e59609e92bb9fcaa = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.sourceBranchDetails);
const $7256662a4b816bdb$export$9f9e2295d096d9e1 = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$e59609e92bb9fcaa, (sourceBranch)=>sourceBranch ? sourceBranch.permissions : null);
const $7256662a4b816bdb$export$feca01302fc536db = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$a954f0a78a0696f0, $7256662a4b816bdb$export$6a1dccc4087fd1a0, $7256662a4b816bdb$export$9f9e2295d096d9e1, $7256662a4b816bdb$export$e59609e92bb9fcaa, (sourceRepo, destRepo, permissions, sourceBranch)=>sourceRepo && destRepo && permissions && !(sourceBranch !== null && sourceBranch !== void 0 && sourceBranch.isMainBranch) && sourceRepo.full_name === destRepo.full_name && permissions.delete === "allow");
function $7256662a4b816bdb$var$commentsToKey(_state, comments) {
    if (!comments) return "";
    return comments.map((comment)=>comment.id).join(",");
}
const $7256662a4b816bdb$export$cd6f4406ffa3f3e2 = (0, $cQrjH.default)((0, $7qdXF.getEntities), (_state, comments)=>comments, (entities, comments)=>{
    if (!comments) return [];
    return comments.reduce((result, comment)=>{
        const { id: commentId } = comment;
        const commentLikes = (0, $ga67g.denormalize)(commentId, (0, $b2RHC.commentLikes), entities);
        if (commentLikes && commentLikes.users.length !== 0) result.push(commentLikes);
        return result;
    }, []);
})($7256662a4b816bdb$var$commentsToKey);
const $7256662a4b816bdb$export$538537bec0f5c9fb = (0, $aXXtM.createSelector)((0, $aanBq.getRepositoryGrantedAccess), (0, $aanBq.getRepositoryAccessLevel), (grantedAccess)=>grantedAccess !== "none");
const $7256662a4b816bdb$var$getDiffCommentingMap = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.diffCommentingMap);
const $7256662a4b816bdb$export$37b1c6134cb8d363 = (0, $cQrjH.default)($7256662a4b816bdb$var$getDiffCommentingMap, (_state, filepath)=>filepath, (diffCommentingMap, filepath)=>!!diffCommentingMap[filepath])((_state, filePath)=>filePath || "");
const $7256662a4b816bdb$export$7e5826658160117f = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.refetchBuildsDummy);
const $7256662a4b816bdb$export$d2eda9f0f94e9d0a = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$1b617bec6a57541b, (prSlice)=>prSlice.refetchIRDiffDummy);
const $7256662a4b816bdb$export$77ae758fa6d5ee6e = (0, $aXXtM.createSelector)($7256662a4b816bdb$export$d771b66b9391b013, (pullRequest)=>{
    var _pullRequest$source$b;
    return pullRequest === null || pullRequest === void 0 ? void 0 : (_pullRequest$source$b = pullRequest.source.branch) === null || _pullRequest$source$b === void 0 ? void 0 : _pullRequest$source$b.sync_strategies;
});

});
parcelRegister("c2vnU", function(module, exports) {

$parcel$export(module.exports, "isFile", function () { return $f0976e776afdf40a$export$be78b3111c50efdd; });
$parcel$export(module.exports, "flattenFiles", function () { return $f0976e776afdf40a$export$5c3fab9144e74310; });
function $f0976e776afdf40a$export$be78b3111c50efdd(entry) {
    return !!entry && entry.type !== "directory";
}
function $f0976e776afdf40a$export$5c3fab9144e74310(entries, parentPath = "") {
    if (!entries.length) return [];
    // hierarchy is flattened to a single level as an array of dirs
    return entries.reduce((dirEntries, entry)=>{
        if ($f0976e776afdf40a$export$be78b3111c50efdd(entry)) {
            // files at root level
            if (!parentPath) {
                // add file to root dir if it exists
                const rootDir = dirEntries.find((dir)=>dir.name === "/");
                if (rootDir) {
                    rootDir.contents.push(entry);
                    return dirEntries;
                }
                return dirEntries.concat([
                    {
                        name: "/",
                        type: "directory",
                        contents: [
                            entry
                        ]
                    }
                ]);
            }
            // non root level files aren't added directly
            return dirEntries;
        }
        const currPath = `${parentPath}/${entry.name}`;
        const flattenedContents = $f0976e776afdf40a$export$5c3fab9144e74310(entry.contents, currPath);
        // dirs that have at least one file are included
        if (entry.contents.some((dirContent)=>$f0976e776afdf40a$export$be78b3111c50efdd(dirContent))) // parent dir ordered ahead of subdirs
        return dirEntries.concat([
            {
                ...entry,
                name: currPath,
                // only include files of this dir in contents
                contents: entry.contents.filter((entryContent)=>$f0976e776afdf40a$export$be78b3111c50efdd(entryContent))
            }
        ], flattenedContents);
        return dirEntries.concat(flattenedContents);
    }, []);
}

});

parcelRegister("2hjj7", function(module, exports) {

$parcel$export(module.exports, "isFile", function () { return $88c16365764ff49c$export$be78b3111c50efdd; });
$parcel$export(module.exports, "flattenDirectories", function () { return $88c16365764ff49c$export$e77e319eafb0ac29; });
function $88c16365764ff49c$export$be78b3111c50efdd(entry) {
    return !!entry && entry.type !== "directory";
}
function $88c16365764ff49c$var$isDirectory(entry) {
    return !!entry && entry.type === "directory";
}
function $88c16365764ff49c$export$e77e319eafb0ac29(treeEntry) {
    if ($88c16365764ff49c$export$be78b3111c50efdd(treeEntry)) return treeEntry;
    let flattenedDirectory = {
        ...treeEntry
    };
    // Flatten by absorbing the subdirectory into parent directory
    const subDirectory = treeEntry.contents[0];
    const hasOneSubDirectory = treeEntry.contents.length === 1;
    if (hasOneSubDirectory && $88c16365764ff49c$var$isDirectory(subDirectory)) {
        flattenedDirectory.name += `/${subDirectory.name}`;
        flattenedDirectory.contents = subDirectory.contents;
        // Continue to flatten directories down the path
        const temp = $88c16365764ff49c$export$e77e319eafb0ac29(flattenedDirectory);
        flattenedDirectory = temp;
    }
    // Done flattening this directory.  Now check it's current children.
    flattenedDirectory.contents = flattenedDirectory.contents.map($88c16365764ff49c$export$e77e319eafb0ac29);
    return flattenedDirectory;
}
function $88c16365764ff49c$export$1c2acae85e5a436d(a, b) {
    if (a.type === "file" && b.type === "directory") return -1;
    if (a.type === "directory" && b.type === "file") return 1;
    return a.name.localeCompare(b.name);
}

});

parcelRegister("lvqI0", function(module, exports) {

$parcel$export(module.exports, "removeUrlHashPrefix", function () { return $9a3c5bfe0e673416$export$1d8d6feb67b9e7; });
// Removing the first 5 characters (#chg-) from the file href leaves just the file path.
const $9a3c5bfe0e673416$export$1d8d6feb67b9e7 = (href)=>href.slice(5);

});

parcelRegister("b2RHC", function(module, exports) {

$parcel$export(module.exports, "pullRequest", function () { return $b48fd7bb4f91fec6$export$790c849df52bae04; });
$parcel$export(module.exports, "commit", function () { return $b48fd7bb4f91fec6$export$c25eba0b6986e3d5; });
$parcel$export(module.exports, "commentLikes", function () { return $b48fd7bb4f91fec6$export$7284983f3735b896; });

var $ga67g = parcelRequire("ga67g");

var $8saZD = parcelRequire("8saZD");

var $48ZQ3 = parcelRequire("48ZQ3");
const $b48fd7bb4f91fec6$export$790c849df52bae04 = new (0, $ga67g.schema).Entity("pullRequests", // @ts-ignore
{
    author: (0, $8saZD.user),
    closed_by: (0, $8saZD.user),
    destination: {
        repository: $48ZQ3.repository
    },
    participants: [
        {
            user: $8saZD.user
        }
    ],
    reviewers: [
        (0, $8saZD.user)
    ],
    source: {
        repository: $48ZQ3.repository
    }
}, {
    idAttribute: (entity)=>entity.links.self.href
});
const $b48fd7bb4f91fec6$export$c25eba0b6986e3d5 = new (0, $ga67g.schema).Entity("commits", // @ts-ignore
{
    author: {
        user: $8saZD.user
    },
    participants: [
        {
            user: $8saZD.user
        }
    ],
    repository: $48ZQ3.repository
}, {
    idAttribute: (entity)=>entity.hash
});
const $b48fd7bb4f91fec6$export$94e939b87ca64fb4 = new (0, $ga67g.schema).Entity("tasks", {
    creator: (0, $8saZD.user)
});
const $b48fd7bb4f91fec6$export$7284983f3735b896 = new (0, $ga67g.schema).Entity("commentLikes", {
    users: [
        (0, $8saZD.user)
    ]
}, {
    idAttribute: (entity)=>entity.commentId
});

});

parcelRegister("deJTw", function(module, exports) {

$parcel$export(module.exports, "toNavComment", function () { return $0619c26436b24817$export$d109cadcf2995f07; });

var $xz4dB = parcelRequire("xz4dB");
parcelRequire("eRpZn");
var $5D0x5 = parcelRequire("5D0x5");
const $0619c26436b24817$var$extractContent = (comment)=>{
    const { content: content } = comment;
    const html = "html" in content ? content.html : "";
    const doc = new DOMParser().parseFromString(html, "text/html");
    const text = doc.body.textContent || "";
    /* Since trim() doesn't remove zero space characters, we replace them after trimming
    to determine if the string is truly empty.
    u200B: Zero Width Space
    u200C: Zero Width Non-Joiner
    u200D: Zero Width Joiner
    uFEFF: Zero Width No-Break Space
  */ if (!text || text.trim().replace(/[\u200B-\u200D\uFEFF]/g, "") === "") return null;
    return text;
};
function $0619c26436b24817$export$d109cadcf2995f07(comment) {
    const { created_on: createdAt, user: user, inline: inline } = comment;
    const id = (0, $xz4dB.isApiComment)(comment) ? comment.id : 0;
    const content = $0619c26436b24817$var$extractContent(comment);
    return {
        id: id,
        createdBy: (0, $5D0x5.toFabricUser)(user),
        createdAt: createdAt,
        content: content,
        file: inline === null || inline === void 0 ? void 0 : inline.path,
        outdated: inline === null || inline === void 0 ? void 0 : inline.outdated,
        srcHash: inline === null || inline === void 0 ? void 0 : inline.src_rev,
        destHash: inline === null || inline === void 0 ? void 0 : inline.dest_rev,
        baseRevHash: inline === null || inline === void 0 ? void 0 : inline.base_rev
    };
}

});
parcelRegister("eRpZn", function(module, exports) {

$parcel$export(module.exports, "toConversation", function () { return (parcelRequire("b9iHE")).toConversation; });
$parcel$export(module.exports, "apiToFabricComment", function () { return (parcelRequire("g5WaK")).apiToFabricComment; });
$parcel$export(module.exports, "toFabricUser", function () { return (parcelRequire("5D0x5")).toFabricUser; });
$parcel$export(module.exports, "toBBUser", function () { return (parcelRequire("5D0x5")).toBBUser; });
$parcel$export(module.exports, "getNumOfComments", function () { return (parcelRequire("6XPOs")).getNumOfComments; });
$parcel$export(module.exports, "buildInlineConversations", function () { return (parcelRequire("1pgYo")).buildInlineConversations; });

var $b9iHE = parcelRequire("b9iHE");

var $g5WaK = parcelRequire("g5WaK");

var $5D0x5 = parcelRequire("5D0x5");

var $6XPOs = parcelRequire("6XPOs");

var $1pgYo = parcelRequire("1pgYo");

});
parcelRegister("b9iHE", function(module, exports) {

$parcel$export(module.exports, "apiCommentId", function () { return $145dcd559021a04a$export$5f14f1c1b36f1e95; });
$parcel$export(module.exports, "toConversationId", function () { return $145dcd559021a04a$export$bc0db9b1747de8f; });
$parcel$export(module.exports, "conversationIdToTopCommentId", function () { return $145dcd559021a04a$export$4a14b71bad483b27; });
$parcel$export(module.exports, "toConversation", function () { return $145dcd559021a04a$export$b9d16b53f17e6526; });
$parcel$export(module.exports, "threadToConversation", function () { return $145dcd559021a04a$export$836df00e1c9a591a; });
parcelRequire("eRpZn");
var $5D0x5 = parcelRequire("5D0x5");

var $7b2YZ = parcelRequire("7b2YZ");

var $xz4dB = parcelRequire("xz4dB");

var $g5WaK = parcelRequire("g5WaK");
// @ts-ignore TODO: fix noImplicitAny error here
function $145dcd559021a04a$var$hasValidChildren(currentComment, rawComments) {
    // placeholder comments can't have children (but can have a parent)
    if (!(0, $xz4dB.isApiComment)(currentComment)) return false;
    const children = rawComments.filter((comment)=>comment.parent && comment.parent.id === currentComment.id);
    if (children.some((c)=>!(0, $xz4dB.isApiComment)(c) || !c.deleted)) // If any immediate children are undeleted/placeholder then we know we need to render
    return true;
    // Check children at depth
    return children.some((childComment)=>$145dcd559021a04a$var$hasValidChildren(childComment, rawComments));
}
function $145dcd559021a04a$export$5f14f1c1b36f1e95(comment) {
    return (0, $xz4dB.isApiComment)(comment) ? comment.id : comment.placeholderId;
}
function $145dcd559021a04a$export$bc0db9b1747de8f(comment) {
    return `conversation-${$145dcd559021a04a$export$5f14f1c1b36f1e95(comment)}`;
}
function $145dcd559021a04a$export$4a14b71bad483b27(conversationId) {
    // The conversationId is of the form `conversation-<commentId>`
    // so this value can be used to extract the commentId
    const CONVERSATION_ID_PREFIX = "conversation-";
    if (conversationId.startsWith(CONVERSATION_ID_PREFIX)) return conversationId.substring(CONVERSATION_ID_PREFIX.length);
    return undefined;
}
function $145dcd559021a04a$export$b9d16b53f17e6526(rawComments, containerId, localId) {
    if (!rawComments.length) return undefined;
    const [firstComment] = rawComments;
    const conversationId = $145dcd559021a04a$export$bc0db9b1747de8f(firstComment);
    // TODO: THIS NEEDS OPTIMIZING
    const children = rawComments.reduce((processedComments, currentComment)=>{
        const { parent: parent } = currentComment;
        const isTopLevel = !parent;
        // placeholder comments, undeleted comments, deleted comments with undeleted
        // descendants are possible descendants of this conversation
        if (!(0, $xz4dB.isApiComment)(currentComment) || !currentComment.deleted || $145dcd559021a04a$var$hasValidChildren(currentComment, rawComments)) {
            const isDescendant = ()=>processedComments.some((fabricComment)=>!!parent && fabricComment.commentId === parent.id);
            if (isTopLevel || isDescendant()) processedComments.push((0, $g5WaK.apiToFabricComment)(currentComment, conversationId));
        }
        return processedComments;
    }, []);
    if (!children.length) return undefined;
    return {
        containerId: containerId,
        conversationId: conversationId,
        localId: localId,
        meta: firstComment.inline || {},
        comments: children,
        createdAt: firstComment.created_on
    };
}
function $145dcd559021a04a$export$836df00e1c9a591a(thread) {
    const conversationId = $145dcd559021a04a$export$bc0db9b1747de8f(thread.topComment);
    const comments = "id" in thread.topComment ? [
        (0, $7b2YZ.toMinimalComment)(thread.topComment),
        ...Array.from(thread.commentTree.descendentsOf(thread.topComment.id)).map((c)=>(0, $7b2YZ.toMinimalComment)(c))
    ] : [
        (0, $7b2YZ.toMinimalComment)(thread.topComment)
    ];
    return {
        conversationId: conversationId,
        comments: comments,
        meta: thread.topComment.inline || {},
        numOfComments: comments.length,
        createdAt: thread.topComment.created_on,
        createdBy: (0, $5D0x5.toFabricUser)(thread.topComment.user)
    };
}

});
parcelRegister("7b2YZ", function(module, exports) {

$parcel$export(module.exports, "commentPermalink", function () { return $3915758de3d8a410$export$68ab17f07d67e5e5; });
$parcel$export(module.exports, "toMinimalComment", function () { return $3915758de3d8a410$export$616954b737830b8d; });
$parcel$export(module.exports, "formatAllComments", function () { return $3915758de3d8a410$export$b96631816604287d; });
$parcel$export(module.exports, "isFileLevelComment", function () { return $3915758de3d8a410$export$9e521fb24562d2ff; });

var $xz4dB = parcelRequire("xz4dB");
parcelRequire("eRpZn");
var $1pgYo = parcelRequire("1pgYo");
var $6XPOs = parcelRequire("6XPOs");
var $b9iHE = parcelRequire("b9iHE");

var $9z4M9 = parcelRequire("9z4M9");

var $hPLIW = parcelRequire("hPLIW");
function $3915758de3d8a410$var$isGlobalComment(comment) {
    return !comment.inline;
}
function $3915758de3d8a410$export$68ab17f07d67e5e5(comment) {
    const id = (0, $xz4dB.isApiComment)(comment) ? comment.id : -1;
    return `comment-${id}`;
}
function $3915758de3d8a410$export$616954b737830b8d(comment) {
    var _comment$user;
    const id = (0, $xz4dB.isApiComment)(comment) ? comment.id : -1;
    return {
        id: id,
        permalink: $3915758de3d8a410$export$68ab17f07d67e5e5(comment),
        authorUuid: (_comment$user = comment.user) === null || _comment$user === void 0 ? void 0 : _comment$user.uuid
    };
}
function $3915758de3d8a410$export$b89e5f14f60b3ca2(conversation) {
    const { conversationId: conversationId, meta: meta, createdAt: createdAt, comments: comments } = conversation;
    const commentMetaData = comments.map((comment)=>{
        const { commentId: commentId } = comment;
        return {
            id: commentId,
            permalink: `comment-${commentId}`,
            authorUuid: comment.createdBy.id
        };
    });
    return {
        conversationId: conversationId,
        comments: commentMetaData,
        meta: meta,
        numOfComments: (0, $6XPOs.getNumOfComments)(conversation),
        createdAt: createdAt,
        createdBy: (0, $9z4M9.getCreatedBy)(conversation)
    };
}
/**
 * Sorting function that sorts by the created_on timestamp and then by id if the timestamps are equal.
 * PlaceholderApiComment comments do not have an id so they are always sorted to the end of the list.
 */ function $3915758de3d8a410$var$compareComments(a, b) {
    const comparedLocale = a.created_on.localeCompare(b.created_on);
    if (comparedLocale) return comparedLocale;
    if ("id" in b && "id" in a) return a.id - b.id;
    return 0;
}
function $3915758de3d8a410$export$b96631816604287d(commentValues = [], containerId) {
    // Sort comments by timestamp and then by id if the timestamps are equal
    // Comments submitted through a multi-comment review all share the same timestamp upon submission
    // Enforce a deterministic order of comments in each conversation
    const comments = [
        ...commentValues
    ].sort($3915758de3d8a410$var$compareComments);
    const rawCommentTree = new (0, $hPLIW.CommentTree)(comments);
    // First part of condition automatically keeps all placeholder comments
    // Second part of condition Filter out deleted comments with invalid children
    const commentTree = rawCommentTree.filterMatchingSubtrees((c)=>!(0, $xz4dB.isApiComment)(c) || !c.deleted);
    const globalComments = comments.filter($3915758de3d8a410$var$isGlobalComment);
    const globalConversation = (0, $b9iHE.toConversation)(globalComments, containerId);
    const inlineConversations = (0, $1pgYo.buildInlineConversations)(comments, commentTree.commentChildrenMap(), containerId);
    // Global Convo must go first!
    const fabricConversations = globalConversation ? [
        globalConversation,
        ...inlineConversations
    ] : inlineConversations;
    return {
        fabricConversations: fabricConversations,
        conversations: fabricConversations.map($3915758de3d8a410$export$b89e5f14f60b3ca2) || [],
        commentTree: commentTree
    };
}
function $3915758de3d8a410$export$9e521fb24562d2ff(conversation) {
    return conversation.meta.from === null && conversation.meta.to === null && conversation.meta.path;
}

});
parcelRegister("9z4M9", function(module, exports) {

$parcel$export(module.exports, "getCreatedBy", function () { return $234450c57b9fc78a$export$cc8468b84430954; });

var $5D0x5 = parcelRequire("5D0x5");
const $234450c57b9fc78a$export$cc8468b84430954 = (conversation)=>{
    const user = conversation.comments.sort((a, b)=>new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()).map((comment)=>comment.createdBy)[0];
    // If we didn't find a creator we just use a "blank" fabric user
    return user || (0, $5D0x5.toFabricUser)(null);
};

});
parcelRegister("5D0x5", function(module, exports) {

$parcel$export(module.exports, "toFabricUser", function () { return $6119d80dc7066fb2$export$f09a62277be257dc; });
$parcel$export(module.exports, "toBBUser", function () { return $6119d80dc7066fb2$export$6fa9e0350c77cc06; });

var $c4Bvq = parcelRequire("c4Bvq");
function $6119d80dc7066fb2$export$f09a62277be257dc(user) {
    return {
        id: user ? user.uuid : "",
        name: (0, $c4Bvq.getName)(user),
        avatarUrl: (0, $c4Bvq.getAvatarUrl)(user) || undefined,
        profileUrl: (0, $c4Bvq.getProfileUrl)(user) || undefined
    };
}
function $6119d80dc7066fb2$export$6fa9e0350c77cc06(user) {
    return {
        uuid: user && user.id || "",
        display_name: user && user.name || "",
        nickname: user && user.name || "",
        type: "user",
        links: {
            self: {
                href: ""
            },
            avatar: {
                href: user && user.avatarUrl || ""
            },
            html: {
                href: user && user.profileUrl || ""
            }
        }
    };
}

});
parcelRegister("c4Bvq", function(module, exports) {

$parcel$export(module.exports, "getAvatarUrl", function () { return $89cdd6871ba1007f$export$b4f8f1f54acec99b; });
$parcel$export(module.exports, "getName", function () { return $89cdd6871ba1007f$export$7d9f7e9c1c02b41e; });
$parcel$export(module.exports, "getProfileUrl", function () { return $89cdd6871ba1007f$export$6d333a56ff392766; });

var $8ky9z = parcelRequire("8ky9z");
const $89cdd6871ba1007f$export$b4f8f1f54acec99b = (user)=>{
    if (!user) return undefined;
    // Temporarily enable avatars for teams until we launch workspaces (PHAROS-465)
    if (user.type === "team") return user.links.avatar.href;
    return user.links.avatar.href;
};
const $89cdd6871ba1007f$export$7d9f7e9c1c02b41e = (user, intl)=>{
    // Fall back to the original English string if `intl` is not available in the
    // consuming environment
    const formerUser = intl ? intl.formatMessage((0, $8ky9z.default).displayNameDeletedPrivateNickname) : (0, $8ky9z.default).displayNameDeletedPrivateNickname.defaultMessage;
    if (!user) return formerUser;
    if (user.type === "team") return user.display_name;
    return user.display_name || formerUser;
};
const $89cdd6871ba1007f$export$6d333a56ff392766 = (user)=>{
    if (!user || user.type === "app_user" || user.type !== "team" && user.account_status === "closed") return undefined;
    if (user.links.html) return user.links.html.href;
    return `/${user.uuid}/`;
};

});
parcelRegister("8ky9z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2fc37fa36730b7a4$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $2fc37fa36730b7a4$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    displayNameDeletedPrivateNickname: {
        "id": "frontbucket.components.userProfile.displayNameDeletedPrivateNickname",
        "defaultMessage": "Former user"
    },
    statusLabelDeactivated: {
        "id": "frontbucket.components.userProfile.statusLabelDeactivated",
        "defaultMessage": "Account deactivated"
    },
    statusLabelDeleted: {
        "id": "frontbucket.components.userProfile.statusLabelDeleted",
        "defaultMessage": "Account deleted"
    },
    teamProfileCardMessage: {
        "id": "frontbucket.components.userProfile.teamProfileCardMessage",
        "defaultMessage": "You can no longer collaborate with this account. This account has been migrated to a workspace."
    },
    unmatchedCommitAuthorTooltip: {
        "id": "frontbucket.components.userProfile.unmatchedCommitAuthorTooltip",
        "defaultMessage": "{commitAuthor} cannot be matched to an Atlassian account"
    },
    unmatchedUnknownCommitAuthorTooltip: {
        "id": "frontbucket.components.userProfile.unmatchedUnknownCommitAuthorTooltip",
        "defaultMessage": "This user cannot be matched to an Atlassian account."
    },
    unmigratedAtlassianAccountProfileCardMessage: {
        "id": "frontbucket.components.userProfile.unmigratedAtlassianAccountProfileCardMessage",
        "defaultMessage": "You can no longer collaborate with this person. This account has been inactive for more than a year."
    },
    viewProfileAction: {
        "id": "frontbucket.components.userProfile.viewProfileAction",
        "defaultMessage": "View profile"
    }
});

});




parcelRegister("hPLIW", function(module, exports) {

$parcel$export(module.exports, "CommentTree", function () { return $48bbb32e200b66f5$export$fd256917f51c6671; });
$parcel$export(module.exports, "commentsInThread", function () { return $48bbb32e200b66f5$export$5c9af24e52fdbcc0; });

var $xz4dB = parcelRequire("xz4dB");

var $b9iHE = parcelRequire("b9iHE");
class $48bbb32e200b66f5$export$fd256917f51c6671 {
    constructor(comments){
        this.topLevelGlobalCommentList = void 0;
        this.topLevelFileCommentMap = new Map();
        this.childrenMap = new Map();
        this.commentMap = new Map();
        this.topLevelGlobalCommentList = [];
        this.topLevelFileCommentMap = new Map();
        this.childrenMap = new Map();
        if (comments) comments.forEach((comment)=>this.add(comment));
    }
    /**
   * Gets a single comment by ID. This method is O(1) time complexity.
   * @param {number} commentId - The id of the comment to public get
   * @returns {ApiCommentOrPlaceholder | undefined} - The comment with the given id or undefined if not found
   */ get(commentId) {
        return this.commentMap.get(commentId.toString());
    }
    /**
   * Returns a list of children of a comment
   * @param {number} commentId - The id of the comment to get children of
   * @returns {ApiCommentOrPlaceholder[]} - A list of children of the comment
   */ childrenOf(commentId) {
        var _this$childrenMap$get;
        return (_this$childrenMap$get = this.childrenMap.get(commentId)) !== null && _this$childrenMap$get !== void 0 ? _this$childrenMap$get : [];
    }
    /**
   * Returns a map of comment ids to their children
   * @returns {Map<number, ApiCommentOrPlaceholder[]>} - A map of comment ids to their children
   */ commentChildrenMap() {
        return this.childrenMap;
    }
    /**
   * Returns a list of top-level global comments
   * @returns {ApiCommentOrPlaceholder[]} - A list of top-level global comments
   */ topLevelGlobalComments() {
        return this.topLevelGlobalCommentList;
    }
    /**
   * Returns a list of top-level file comments
   * @returns {ApiCommentOrPlaceholder[]} - A list of top-level global comments
   */ topLevelFileComments() {
        return Array.from(this.topLevelFileCommentMap.values());
    }
    /**
   * Returns a list of all top-level comments
   * @returns {ApiCommentOrPlaceholder[]} - A list of all top-level comments
   */ topLevelComments() {
        return [
            ...this.topLevelGlobalComments(),
            ...this.topLevelFileComments()
        ];
    }
    /** Returns the top level comment with the given ID
   * @param {number} commentId - The id of the comment to get
   * @returns {ApiCommentOrPlaceholder | undefined} - The top-level comment with the given id or undefined if not found
   */ topLevelCommentById(commentId) {
        const topLevelFileComment = this.topLevelFileCommentMap.get(commentId);
        if (topLevelFileComment) return topLevelFileComment;
        return this.topLevelGlobalComments().find((c)=>(0, $xz4dB.isApiComment)(c) ? c.id.toString() === commentId : c.placeholderId === commentId);
    }
    /**
   * Returns top-level global comments or a file comment from a conversationId
   * @param {string} conversationId - The id of the conversation of the top-level comment to get
   * @returns {ApiCommentOrPlaceholder[]} - The comment(s) with the given id or undefined if not found
   */ topLevelCommentsByConversationId(conversationId) {
        const commentId = (0, $b9iHE.conversationIdToTopCommentId)(conversationId);
        if (commentId) {
            const comment = this.topLevelCommentById(commentId);
            if (comment) {
                if (comment.inline) // This is a file comment; return it by itself
                return [
                    comment
                ];
                // This is a global comment; we treat all global conversations as one, so return all top-level global comments
                return this.topLevelGlobalComments();
            }
        }
        return [];
    }
    /**
   * Adds a comment to the tree structure.
   * Order of addition matters as it does not determine hierarchy, but rather the order of comments in the tree.
   * Make sure to enforce a deterministic order of comment addition.
   * Adding a child before its parent will work as intended and add it as a child within `commentChildrenMap`,
   * but the parent comment's `id` will be present in the keys of `commentChildrenMap` even if the parent comment is not present in the tree.
   * @param comment - The comment to add to the tree
   */ add(comment) {
        const { parent: parent } = comment;
        const commentId = (0, $b9iHE.apiCommentId)(comment);
        if (commentId) this.commentMap.set(commentId.toString(), comment);
        if (parent) {
            var _this$childrenMap$get2;
            // Comments with a parent are replies and should be added to the descendant map
            const previousThread = (_this$childrenMap$get2 = this.childrenMap.get(parent.id)) !== null && _this$childrenMap$get2 !== void 0 ? _this$childrenMap$get2 : [];
            this.childrenMap.set(parent.id, [
                ...previousThread,
                comment
            ]);
        } else if (!comment.inline) // Comments without a parent and no inline property are top-level global comments
        this.topLevelGlobalCommentList.push(comment);
        else if ((0, $xz4dB.isApiComment)(comment)) // API comments without a parent are top-level file or inline comments
        this.topLevelFileCommentMap.set(comment.id.toString(), comment);
        else // All other comments at this point without a parent are top-level file or inline placeholder comments
        this.topLevelFileCommentMap.set(comment.placeholderId, comment);
    }
    filterThreads(newCommentTree, commentList, predicate) {
        for (const comment of commentList){
            if (!(0, $xz4dB.isApiComment)(comment)) {
                // Keep placeholder comments if they satisfy the predicate
                if (predicate(comment)) newCommentTree.add(comment);
                continue;
            }
            const children = this.childrenOf(comment.id);
            // Recursively clean nested comments of the current comment
            this.filterThreads(newCommentTree, children, predicate);
            const hasValidChildren = newCommentTree.commentChildrenMap().has(comment.id);
            // Keep a comment if it has valid children or satisfies the predicate
            if (hasValidChildren || predicate(comment)) newCommentTree.add(comment);
        }
    }
    /**
   * Returns a new CommentTree with comments that either satisfy the predicate or have children that satisfy the predicate.
   * Comments that do not satisfy the predicate but have children that do satisfy the predicate will still be included in the new tree.
   * Comments within this tree can be either `ApiComment` or `PlaceholderApiComment` types, so make sure the predicate can handle both types.
   * @example
   * // Keep all placeholder comments
   * // Filter out deleted comments that do not have any non-deleted children or placeholder children
   * const newCommentTree = commentTree.filterIncludedChildren(c => !isApiComment(c) || !c.deleted);
   * @example
   * // Filter out comments that are not pending or do not have any pending children
   * // Placeholder comments are not treated any differently to API comments here
   * const newCommentTree = commentTree.filterIncludedChildren(c => c.pending);
   * @param predicate - Function that returns true if the comment should be included in the new tree
   * @returns {CommentTree} - A new CommentTree with comments that satisfy the predicate or have children that satisfy the predicate
   */ filterMatchingSubtrees(predicate) {
        const newCommentTree = new $48bbb32e200b66f5$export$fd256917f51c6671();
        this.filterThreads(newCommentTree, this.topLevelComments(), predicate);
        return newCommentTree;
    }
    /**
   * Returns all decendents of the provided comment ID, not including the provided comment.
   * @param commentId: The ID of the comment to find the descendents of
   * @returns {Generator<ApiCommentOrPlaceholder>} A generator of the descendents of the provided comment ID
   */ *descendentsOf(commentId) {
        for (const child of this.childrenOf(commentId)){
            yield child;
            if ("id" in child) yield* this.descendentsOf(child.id);
        }
    }
    /**
   * Returns a thread for each global comment
   * @returns {CommentThread[]} An array of threads, each containing a global comment and its descendents
   */ globalThreads() {
        return this.topLevelGlobalComments().map((comment)=>this.getThreadForComment(comment));
    }
    /**
   * Returns a thread for each file comment
   * @returns {CommentThread[]} An array of threads, each containing a file comment and its descendents
   */ fileThreads() {
        return this.topLevelFileComments().map((comment)=>this.getThreadForComment(comment));
    }
    /**
   * Returns a thread for each global and each file comment
   * @returns {CommentThread[]} An array of threads, each containing a comment and its descendents
   */ allThreads() {
        return this.topLevelComments().map((comment)=>this.getThreadForComment(comment));
    }
    /**
   * Returns a thread containing only the provided ID and its descendents
   * @param commentId: The ID of the comment to find the subtree of
   * @returns {CommentThread} A thread object containing only the provided comment and its descendents
   */ getThreadForComment(topComment) {
        return {
            topComment: topComment,
            commentTree: new $48bbb32e200b66f5$export$fd256917f51c6671(this.commentAndDescendents(topComment))
        };
    }
    /**
   * Returns a list of the provided comment and its descendents.
   * @param comment: The comment to find the descendents of
   * @returns {ApiCommentOrPlaceholder[]} A list of the provided comment and its descendents
   */ commentAndDescendents(comment) {
        return (0, $xz4dB.isApiComment)(comment) ? [
            comment,
            ...this.descendentsOf(comment.id)
        ] : [
            comment
        ];
    }
    /**
   * Returns a thread containing only the provided ID and its descendents
   * @param commentId: The ID of the comment to find the subtree of
   * @returns {CommentThread} A thread object containing only the provided comment and its descendents
   */ getThread(commentId) {
        const topComment = this.topLevelCommentById(commentId.toString());
        if (topComment) return this.getThreadForComment(topComment);
        return undefined;
    }
}
function $48bbb32e200b66f5$export$5c9af24e52fdbcc0(thread) {
    return thread.commentTree.commentAndDescendents(thread.topComment);
}

});


parcelRegister("g5WaK", function(module, exports) {

$parcel$export(module.exports, "apiToFabricComment", function () { return $8fa8fabde8b401e4$export$8355faba12784525; });

var $3XbtU = parcelRequire("3XbtU");

var $kYqhj = parcelRequire("kYqhj");

var $xz4dB = parcelRequire("xz4dB");

var $5D0x5 = parcelRequire("5D0x5");
function $8fa8fabde8b401e4$export$8355faba12784525(comment, conversationId, nestedDepth) {
    const { created_on: createdAt, user: user, parent: parent, state: state, content: content, resolution: resolution, pending: pending } = comment;
    const id = (0, $xz4dB.isApiComment)(comment) ? comment.id : -1;
    const deleted = (0, $xz4dB.isApiComment)(comment) ? comment.deleted : false;
    // in-flight comments will use the ADF doc (rich text) for
    // seamless transition upon save
    let doc = {};
    try {
        if (!deleted) doc = {
            adf: "html" in content ? (0, $kYqhj.parse)(content.html) : content.doc
        };
    } catch (e) {
        $3XbtU.captureException(e);
    }
    return {
        conversationId: conversationId,
        commentId: id,
        localId: id,
        parentId: parent ? parent.id : undefined,
        createdAt: createdAt,
        createdBy: (0, $5D0x5.toFabricUser)(user),
        deleted: deleted,
        document: doc,
        state: state,
        resolution: resolution,
        pending: pending,
        nestedDepth: nestedDepth
    };
}

});
parcelRegister("kYqhj", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $ed0cb80a8565b72b$export$c564cdbbe6da493; });
$parcel$export(module.exports, "parse", function () { return $ed0cb80a8565b72b$export$98e6a39c04603d36; });

var $hSMmv = parcelRequire("hSMmv");

var $8gREA = parcelRequire("8gREA");

var $3T7XD = parcelRequire("3T7XD");
const $ed0cb80a8565b72b$var$jsonTransformer = new (0, $3T7XD.JSONTransformer)();
const $ed0cb80a8565b72b$var$serializer = new (0, $8gREA.BitbucketTransformer)((0, $hSMmv.defaultSchema), {
    disableBitbucketLinkStripping: true
});
const $ed0cb80a8565b72b$export$c564cdbbe6da493 = (doc)=>$ed0cb80a8565b72b$var$serializer.encode((0, $hSMmv.defaultSchema).nodeFromJSON(doc));
const $ed0cb80a8565b72b$export$98e6a39c04603d36 = (html)=>$ed0cb80a8565b72b$var$jsonTransformer.encode($ed0cb80a8565b72b$var$serializer.parse(html));

});
parcelRegister("hSMmv", function(module, exports) {

$parcel$export(module.exports, "getSchemaBasedOnStage", function () { return $d04cfe8254c041fa$export$fd147e7d448dea03; });
$parcel$export(module.exports, "defaultSchema", function () { return $d04cfe8254c041fa$export$1db618b7b2275ea1; });

var $8RjGr = parcelRequire("8RjGr");

var $5cWOQ = parcelRequire("5cWOQ");
var $c25e8 = parcelRequire("c25e8");
var $2vkJi = parcelRequire("2vkJi");
var $hLooT = parcelRequire("hLooT");

var $hiA8v = parcelRequire("hiA8v");
var $d04cfe8254c041fa$var$getDefaultSchemaConfig = function getDefaultSchemaConfig() {
    var defaultSchemaConfig = {
        nodes: [
            "doc",
            "paragraph",
            "text",
            "bulletList",
            "orderedList",
            "listItem",
            "heading",
            "blockquote",
            "codeBlock",
            "panel",
            "rule",
            "image",
            "caption",
            "mention",
            "media",
            "mediaGroup",
            "mediaSingle",
            "mediaInline",
            "confluenceUnsupportedBlock",
            "confluenceUnsupportedInline",
            "confluenceJiraIssue",
            "expand",
            "nestedExpand",
            "extension",
            "inlineExtension",
            "bodiedExtension",
            "hardBreak",
            "emoji",
            "table",
            "tableCell",
            "tableHeader",
            "tableRow",
            "decisionList",
            "decisionItem",
            "taskList",
            "taskItem",
            "unknownBlock",
            "date",
            "status",
            "placeholder",
            "layoutSection",
            "layoutColumn",
            "inlineCard",
            "blockCard",
            "embedCard",
            "unsupportedBlock",
            "unsupportedInline"
        ],
        marks: [
            "link",
            "em",
            "strong",
            "strike",
            "subsup",
            "underline",
            "code",
            "textColor",
            "backgroundColor",
            "confluenceInlineComment",
            "breakout",
            "alignment",
            "indentation",
            "annotation",
            "dataConsumer",
            "border",
            "unsupportedMark",
            "unsupportedNodeAttribute",
            "typeAheadQuery",
            // https://product-fabric.atlassian.net/browse/ED-10214,
            "fragment"
        ]
    };
    return defaultSchemaConfig;
};
var $d04cfe8254c041fa$export$e4e3ac1fa64862db = $d04cfe8254c041fa$var$getDefaultSchemaConfig();
var $d04cfe8254c041fa$export$fd147e7d448dea03 = (0, $8RjGr.default)(function() {
    var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "final";
    var defaultSchemaConfig = $d04cfe8254c041fa$var$getDefaultSchemaConfig();
    if (stage === "stage0") defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $2vkJi.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $5cWOQ.multiBodiedExtension),
        extensionFrame: (0, $5cWOQ.extensionFrame),
        heading: (0, $c25e8.headingNodeSpec)("stage0"),
        paragraph: (0, $hLooT.paragraphNodeSpec)("stage0")
    };
    return (0, $hiA8v.createSchema)(defaultSchemaConfig);
});
var $d04cfe8254c041fa$export$1db618b7b2275ea1 = $d04cfe8254c041fa$export$fd147e7d448dea03();

});
parcelRegister("8RjGr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67328abb2acfe556$export$2e2bcd8739ae039; });
var $67328abb2acfe556$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $67328abb2acfe556$var$isEqual(first, second) {
    if (first === second) return true;
    if ($67328abb2acfe556$var$safeIsNaN(first) && $67328abb2acfe556$var$safeIsNaN(second)) return true;
    return false;
}
function $67328abb2acfe556$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$67328abb2acfe556$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $67328abb2acfe556$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $67328abb2acfe556$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});

parcelRegister("5cWOQ", function(module, exports) {

$parcel$export(module.exports, "extensionFrame", function () { return $3cabb301b6e18258$export$4fdcae991fd743e7; });
$parcel$export(module.exports, "multiBodiedExtension", function () { return $3cabb301b6e18258$export$c3c04d555a8b9013; });

var $ipPUs = parcelRequire("ipPUs");
var $3cabb301b6e18258$export$4fdcae991fd743e7 = {
    type: "extensionFrame",
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+",
    isolating: true,
    marks: "dataConsumer fragment",
    definingAsContext: false,
    definingForContent: true,
    selectable: false,
    attrs: {},
    parseDOM: [
        {
            context: "extensionFrame//",
            tag: "div[data-extension-frame]",
            skip: true
        },
        {
            tag: "div[data-extension-frame]"
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            "data-extension-frame": "true"
        };
        return [
            "div",
            attrs,
            0
        ];
    }
};
/**
 * @stage 0
 * @name multiBodiedExtension_node
 * @description Wraps multiple extensionFrame objects.
 */ /**
 * @returns NodeSpec for MultiBodiedExtensionDefinition
 */ var $3cabb301b6e18258$var$createMultiBodiedExtensionNodeSpec = function createMultiBodiedExtensionNodeSpec() {
    var nodeSpec = {
        inline: false,
        group: "blockRootOnly",
        content: "extensionFrame+",
        block: true,
        definingAsContext: true,
        selectable: true,
        attrs: {
            extensionKey: {
                default: ""
            },
            extensionType: {
                default: ""
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            layout: {
                default: "default"
            },
            localId: {
                default: null
            }
        },
        parseDOM: [
            {
                context: "multiBodiedExtension//",
                tag: '[data-node-type="multi-bodied-extension"]',
                skip: true
            },
            {
                tag: '[data-node-type="multi-bodied-extension"]',
                getAttrs: function getAttrs(domNode) {
                    return (0, $ipPUs.getExtensionAttrs)(domNode);
                }
            }
        ],
        toDOM: function toDOM(node) {
            var attrs = {
                "data-node-type": "multi-bodied-extension",
                "data-extension-type": node.attrs.extensionType,
                "data-extension-key": node.attrs.extensionKey,
                "data-text": node.attrs.text,
                "data-parameters": JSON.stringify(node.attrs.parameters),
                "data-layout": node.attrs.layout,
                "data-local-id:": node.attrs.localId
            };
            return [
                "div",
                attrs,
                0
            ];
        }
    };
    return nodeSpec;
};
var $3cabb301b6e18258$export$c3c04d555a8b9013 = $3cabb301b6e18258$var$createMultiBodiedExtensionNodeSpec();

});
parcelRegister("ipPUs", function(module, exports) {

$parcel$export(module.exports, "getExtensionAttrs", function () { return $d682d3f095b0ea04$export$1765e2758fc47004; });
var $d682d3f095b0ea04$export$d5f21755dc782a4a = function isValidLayout(name) {
    return !!name && [
        "default",
        "wide",
        "full-width"
    ].includes(name);
};
var $d682d3f095b0ea04$export$1765e2758fc47004 = function getExtensionAttrs(dom) {
    var isInline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var extensionType = dom.getAttribute("data-extension-type");
    var extensionKey = dom.getAttribute("data-extension-key");
    if (!extensionType || !extensionKey) return false;
    var attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute("data-text") || undefined,
        parameters: JSON.parse(dom.getAttribute("data-parameters") || "{}"),
        localId: dom.getAttribute("data-local-id") || undefined
    };
    if (!isInline) {
        var rawLayout = dom.getAttribute("data-layout");
        attrs.layout = $d682d3f095b0ea04$export$d5f21755dc782a4a(rawLayout) ? rawLayout : "default";
    }
    return attrs;
};

});


parcelRegister("c25e8", function(module, exports) {

$parcel$export(module.exports, "heading", function () { return $8c29b9ed8738c03d$export$46e4a324ac90507f; });
$parcel$export(module.exports, "headingStage0", function () { return $8c29b9ed8738c03d$export$8432c9892bf462f4; });
$parcel$export(module.exports, "headingNodeSpec", function () { return $8c29b9ed8738c03d$export$5bb864b24e0f216c; });
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ var $8c29b9ed8738c03d$var$getAttrs = function getAttrs(level) {
    return function(domNode) {
        var _heading$attrs, _heading$attrs$localI;
        return {
            level: level,
            localId: domNode.getAttribute("data-local-id") || ((_heading$attrs = $8c29b9ed8738c03d$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
        };
    };
};
var $8c29b9ed8738c03d$export$8432c9892bf462f4 = {
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    content: "inline*",
    group: "block",
    defining: true,
    selectable: false,
    parseDOM: [
        {
            tag: "h1",
            getAttrs: $8c29b9ed8738c03d$var$getAttrs(1)
        },
        {
            tag: "h2",
            getAttrs: $8c29b9ed8738c03d$var$getAttrs(2)
        },
        {
            tag: "h3",
            getAttrs: $8c29b9ed8738c03d$var$getAttrs(3)
        },
        {
            tag: "h4",
            getAttrs: $8c29b9ed8738c03d$var$getAttrs(4)
        },
        {
            tag: "h5",
            getAttrs: $8c29b9ed8738c03d$var$getAttrs(5)
        },
        {
            tag: "h6",
            getAttrs: $8c29b9ed8738c03d$var$getAttrs(6)
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, level = _node$attrs.level, localId = _node$attrs.localId;
        var name = "h" + level;
        var attrs = localId !== undefined && localId !== null ? [
            {
                "data-local-id": localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
};
var $8c29b9ed8738c03d$export$46e4a324ac90507f = {
    attrs: {
        level: {
            default: 1
        }
    },
    content: "inline*",
    group: "block",
    defining: true,
    selectable: false,
    parseDOM: [
        {
            tag: "h1",
            attrs: {
                level: 1
            }
        },
        {
            tag: "h2",
            attrs: {
                level: 2
            }
        },
        {
            tag: "h3",
            attrs: {
                level: 3
            }
        },
        {
            tag: "h4",
            attrs: {
                level: 4
            }
        },
        {
            tag: "h5",
            attrs: {
                level: 5
            }
        },
        {
            tag: "h6",
            attrs: {
                level: 6
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "h" + node.attrs["level"],
            0
        ];
    }
};
var $8c29b9ed8738c03d$export$5bb864b24e0f216c = function headingNodeSpec() {
    var adfStage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "full";
    return adfStage === "stage0" ? $8c29b9ed8738c03d$export$8432c9892bf462f4 : $8c29b9ed8738c03d$export$46e4a324ac90507f;
};

});

parcelRegister("2vkJi", function(module, exports) {

$parcel$export(module.exports, "layoutSection", function () { return $1d2e8e7680610c7f$export$b3b6a70a7fa4a5be; });
$parcel$export(module.exports, "layoutSectionWithSingleColumn", function () { return $1d2e8e7680610c7f$export$4f9d8f623ff17117; });
/**
 * @name layoutSection_node
 */ /**
 * Need duplicate `type` and `marks` to make both validator and json-schema satisfied
 */ /**
 * @name layoutSection_full_node
 */ /**
 * @stage 0
 * @name layoutSection_with_single_column_node
 */ var $1d2e8e7680610c7f$export$b3b6a70a7fa4a5be = {
    content: "(layoutColumn | unsupportedBlock){1,3} unsupportedBlock* | unsupportedBlock+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    isolating: true,
    parseDOM: [
        {
            context: "layoutSection//|layoutColumn//",
            tag: "div[data-layout-section]",
            skip: true
        },
        {
            tag: "div[data-layout-section]"
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            "data-layout-section": "true"
        };
        return [
            "div",
            attrs,
            0
        ];
    }
};
var $1d2e8e7680610c7f$export$4f9d8f623ff17117 = {
    content: "(layoutColumn | unsupportedBlock){1,3} unsupportedBlock* | unsupportedBlock+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    isolating: true,
    parseDOM: [
        {
            context: "layoutSection//|layoutColumn//",
            tag: "div[data-layout-section]",
            skip: true
        },
        {
            tag: "div[data-layout-section]"
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            "data-layout-section": "true"
        };
        return [
            "div",
            attrs,
            0
        ];
    }
};

});

parcelRegister("hLooT", function(module, exports) {

$parcel$export(module.exports, "paragraphStage0", function () { return $cee9c0e82fc3f557$export$700cbf85d3602974; });
$parcel$export(module.exports, "paragraph", function () { return $cee9c0e82fc3f557$export$9c206ddddb32a9b; });
$parcel$export(module.exports, "paragraphNodeSpec", function () { return $cee9c0e82fc3f557$export$af5ae099d62a62b4; });
/**
 * @name paragraph_node
 */ /**
 * @name paragraph_with_no_marks_node
 */ /**
 * NOTE: Need this because TS is too smart and inline everything.
 * So we need to give them separate identity.
 * Probably there's a way to solve it but that will need time and exploration.
 * // http://bit.ly/2raXFX5
 * type T1 = X | Y
 * type T2 = A | T1 | B // T2 = A | X | Y | B
 */ /**
 * @name paragraph_with_alignment_node
 */ /**
 * @name paragraph_with_indentation_node
 */ var $cee9c0e82fc3f557$export$700cbf85d3602974 = {
    selectable: false,
    content: "inline*",
    group: "block",
    attrs: {
        localId: {
            default: null
        }
    },
    marks: "strong code em link border strike subsup textColor backgroundColor typeAheadQuery underline confluenceInlineComment action annotation unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    parseDOM: [
        {
            tag: "p",
            getAttrs: function getAttrs(domNode) {
                var _paragraph$attrs, _paragraph$attrs$loca;
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute("data-local-id") || ((_paragraph$attrs = $cee9c0e82fc3f557$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var name = "p";
        var attrs = localId !== undefined && localId !== null ? [
            {
                "data-local-id": localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
};
var $cee9c0e82fc3f557$export$9c206ddddb32a9b = {
    selectable: false,
    content: "inline*",
    group: "block",
    marks: "strong code em link border strike subsup textColor backgroundColor typeAheadQuery underline confluenceInlineComment action annotation unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    parseDOM: [
        {
            tag: "p"
        }
    ],
    toDOM: function toDOM() {
        return [
            "p",
            0
        ];
    }
};
var $cee9c0e82fc3f557$export$af5ae099d62a62b4 = function paragraphNodeSpec() {
    var adfStage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "full";
    return adfStage === "stage0" ? $cee9c0e82fc3f557$export$700cbf85d3602974 : $cee9c0e82fc3f557$export$9c206ddddb32a9b;
};

});

parcelRegister("hiA8v", function(module, exports) {

$parcel$export(module.exports, "createSchema", function () { return $c98026040bbd6b6c$export$5f4ce795563f4211; });
$parcel$export(module.exports, "sanitizeNodes", function () { return $c98026040bbd6b6c$export$daf54fed04c8fb77; });

var $kFnE9 = parcelRequire("kFnE9");

var $1cpUy = parcelRequire("1cpUy");

var $2Uu7f = parcelRequire("2Uu7f");

var $fAhqi = parcelRequire("fAhqi");
var $bvuHp = parcelRequire("bvuHp");
var $1QthD = parcelRequire("1QthD");
var $dTp2k = parcelRequire("dTp2k");
var $dgm2E = parcelRequire("dgm2E");
var $hWxmk = parcelRequire("hWxmk");
var $4hACo = parcelRequire("4hACo");
var $gD0YM = parcelRequire("gD0YM");
var $dvQ3b = parcelRequire("dvQ3b");
var $fngjO = parcelRequire("fngjO");
var $30dKh = parcelRequire("30dKh");
var $3BmiG = parcelRequire("3BmiG");
var $81L2N = parcelRequire("81L2N");
var $ajYfX = parcelRequire("ajYfX");
var $rOFHJ = parcelRequire("rOFHJ");
var $f2zQv = parcelRequire("f2zQv");
var $3PgDK = parcelRequire("3PgDK");
var $UK8Dx = parcelRequire("UK8Dx");
var $23a1A = parcelRequire("23a1A");
var $UshAi = parcelRequire("UshAi");

var $3kawi = parcelRequire("3kawi");
var $4M6BM = parcelRequire("4M6BM");
var $anHjF = parcelRequire("anHjF");
var $652Tk = parcelRequire("652Tk");
var $jegNi = parcelRequire("jegNi");
var $bKgNx = parcelRequire("bKgNx");
var $6YGtF = parcelRequire("6YGtF");
var $gkMID = parcelRequire("gkMID");
var $kd1cJ = parcelRequire("kd1cJ");
var $35HdZ = parcelRequire("35HdZ");
var $a0Wt3 = parcelRequire("a0Wt3");
var $EGbJK = parcelRequire("EGbJK");
var $8G9Ir = parcelRequire("8G9Ir");
var $3IOyU = parcelRequire("3IOyU");
var $aS3bF = parcelRequire("aS3bF");
var $ffqiL = parcelRequire("ffqiL");
var $gn7xk = parcelRequire("gn7xk");
var $3AEPx = parcelRequire("3AEPx");
var $5cWOQ = parcelRequire("5cWOQ");
var $2Ur2k = parcelRequire("2Ur2k");
var $c25e8 = parcelRequire("c25e8");
var $NZ26g = parcelRequire("NZ26g");
var $3Q6T8 = parcelRequire("3Q6T8");
var $mGA14 = parcelRequire("mGA14");
var $9rtwv = parcelRequire("9rtwv");
var $2vkJi = parcelRequire("2vkJi");
var $3OMMD = parcelRequire("3OMMD");
var $3P63C = parcelRequire("3P63C");
var $aITSw = parcelRequire("aITSw");
var $cdYe0 = parcelRequire("cdYe0");
var $eHCwG = parcelRequire("eHCwG");
var $8Hxfq = parcelRequire("8Hxfq");
var $04De6 = parcelRequire("04De6");
var $lnUCr = parcelRequire("lnUCr");
var $hLooT = parcelRequire("hLooT");
var $3i5ur = parcelRequire("3i5ur");
var $jlaSl = parcelRequire("jlaSl");
var $8besj = parcelRequire("8besj");
var $37tHX = parcelRequire("37tHX");
var $lmb64 = parcelRequire("lmb64");
var $7ebhx = parcelRequire("7ebhx");
var $j50N1 = parcelRequire("j50N1");
var $1tTmP = parcelRequire("1tTmP");
var $6WVZ3 = parcelRequire("6WVZ3");
var $lsYRl = parcelRequire("lsYRl");
function $c98026040bbd6b6c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c98026040bbd6b6c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c98026040bbd6b6c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c98026040bbd6b6c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c98026040bbd6b6c$var$addItems(builtInItems, config) {
    var customSpecs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ var items = builtInItems.reduce(function(items, _ref) {
        var name = _ref.name, spec = _ref.spec;
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce(function(items, name) {
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $c98026040bbd6b6c$var$groupDeclaration(name) {
    return {
        name: "__".concat(name, "GroupDeclaration"),
        spec: {
            group: name
        }
    };
}
var $c98026040bbd6b6c$var$markGroupDeclarations = [
    $c98026040bbd6b6c$var$groupDeclaration((0, $2Uu7f.COLOR)),
    $c98026040bbd6b6c$var$groupDeclaration((0, $2Uu7f.FONT_STYLE)),
    $c98026040bbd6b6c$var$groupDeclaration((0, $2Uu7f.SEARCH_QUERY)),
    $c98026040bbd6b6c$var$groupDeclaration((0, $2Uu7f.LINK))
];
var $c98026040bbd6b6c$var$markGroupDeclarationsNames = $c98026040bbd6b6c$var$markGroupDeclarations.map(function(groupMark) {
    return groupMark.name;
});
var $c98026040bbd6b6c$var$nodesInOrder = [
    {
        name: "doc",
        spec: (0, $8G9Ir.doc)
    },
    {
        name: "paragraph",
        spec: (0, $hLooT.paragraphNodeSpec)()
    },
    {
        name: "text",
        spec: (0, $j50N1.text)
    },
    {
        name: "bulletList",
        spec: (0, $652Tk.bulletList)
    },
    {
        name: "orderedList",
        spec: (0, $lnUCr.orderedListWithOrder)
    },
    {
        name: "listItem",
        spec: (0, $3OMMD.listItemWithTask)
    },
    {
        name: "heading",
        spec: (0, $c25e8.headingNodeSpec)()
    },
    {
        name: "blockquote",
        spec: (0, $4M6BM.blockquoteWithList)
    },
    {
        name: "codeBlock",
        spec: (0, $bKgNx.codeBlock)
    },
    {
        name: "panel",
        spec: (0, $gn7xk.extendedPanel)(true)
    },
    {
        name: "rule",
        spec: (0, $jlaSl.rule)
    },
    {
        name: "image",
        spec: (0, $NZ26g.image)
    },
    {
        name: "mention",
        spec: (0, $8Hxfq.mention)
    },
    {
        name: "caption",
        spec: (0, $jegNi.caption)
    },
    {
        name: "media",
        spec: (0, $3P63C.media)
    },
    {
        name: "mediaGroup",
        spec: (0, $aITSw.mediaGroup)
    },
    {
        name: "mediaSingle",
        spec: (0, $eHCwG.mediaSingleFull)
    },
    {
        name: "mediaInline",
        spec: (0, $cdYe0.mediaInline)
    },
    {
        name: "placeholder",
        spec: (0, $3i5ur.placeholder)
    },
    {
        name: "layoutSection",
        spec: (0, $2vkJi.layoutSection)
    },
    {
        name: "layoutColumn",
        spec: (0, $9rtwv.layoutColumn)
    },
    {
        name: "hardBreak",
        spec: (0, $2Ur2k.hardBreak)
    },
    {
        name: "emoji",
        spec: (0, $aS3bF.emoji)
    },
    {
        name: "table",
        spec: (0, $37tHX.table)
    },
    {
        name: "tableCell",
        spec: (0, $37tHX.tableCell)
    },
    {
        name: "tableRow",
        spec: (0, $37tHX.tableRow)
    },
    {
        name: "tableHeader",
        spec: (0, $37tHX.tableHeader)
    },
    {
        name: "confluenceJiraIssue",
        spec: (0, $6YGtF.confluenceJiraIssue)
    },
    {
        name: "confluenceUnsupportedInline",
        spec: (0, $kd1cJ.confluenceUnsupportedInline)
    },
    {
        name: "confluenceUnsupportedBlock",
        spec: (0, $gkMID.confluenceUnsupportedBlock)
    },
    {
        name: "decisionList",
        spec: (0, $EGbJK.decisionList)
    },
    {
        name: "decisionItem",
        spec: (0, $a0Wt3.decisionItem)
    },
    {
        name: "taskList",
        spec: (0, $7ebhx.taskList)
    },
    {
        name: "taskItem",
        spec: (0, $lmb64.taskItem)
    },
    {
        name: "date",
        spec: (0, $35HdZ.date)
    },
    {
        name: "status",
        spec: (0, $8besj.status)
    },
    {
        name: "expand",
        spec: (0, $ffqiL.expand)
    },
    {
        name: "nestedExpand",
        spec: (0, $04De6.nestedExpand)
    },
    {
        name: "extension",
        spec: (0, $3AEPx.extension)
    },
    {
        name: "inlineExtension",
        spec: (0, $mGA14.inlineExtension)
    },
    {
        name: "bodiedExtension",
        spec: (0, $anHjF.bodiedExtension)
    },
    {
        name: "multiBodiedExtension",
        spec: (0, $5cWOQ.multiBodiedExtension)
    },
    {
        name: "extensionFrame",
        spec: (0, $5cWOQ.extensionFrame)
    },
    {
        name: "inlineCard",
        spec: (0, $3Q6T8.inlineCard)
    },
    {
        name: "blockCard",
        spec: (0, $3kawi.blockCard)
    },
    {
        name: "embedCard",
        spec: (0, $3IOyU.embedCard)
    },
    {
        name: "unknownBlock",
        spec: (0, $1tTmP.default)
    },
    {
        name: "unsupportedBlock",
        spec: (0, $6WVZ3.unsupportedBlock)
    },
    {
        name: "unsupportedInline",
        spec: (0, $lsYRl.unsupportedInline)
    }
];
var $c98026040bbd6b6c$var$marksInOrder = [
    {
        name: "link",
        spec: (0, $3BmiG.link)
    },
    {
        name: "em",
        spec: (0, $dvQ3b.em)
    },
    {
        name: "strong",
        spec: (0, $ajYfX.strong)
    },
    {
        name: "textColor",
        spec: (0, $f2zQv.textColor)
    },
    {
        name: "backgroundColor",
        spec: (0, $1QthD.backgroundColor)
    },
    {
        name: "strike",
        spec: (0, $81L2N.strike)
    },
    {
        name: "subsup",
        spec: (0, $rOFHJ.subsup)
    },
    {
        name: "underline",
        spec: (0, $UK8Dx.underline)
    },
    {
        name: "code",
        spec: (0, $hWxmk.code)
    },
    {
        name: "typeAheadQuery",
        spec: (0, $3PgDK.typeAheadQuery)
    },
    {
        name: "alignment",
        spec: (0, $fAhqi.alignment)
    },
    {
        name: "annotation",
        spec: (0, $bvuHp.annotation)
    },
    {
        name: "confluenceInlineComment",
        spec: (0, $4hACo.confluenceInlineComment)
    }
].concat($c98026040bbd6b6c$var$markGroupDeclarations, [
    {
        name: "breakout",
        spec: (0, $dgm2E.breakout)
    },
    {
        name: "dataConsumer",
        spec: (0, $gD0YM.dataConsumer)
    },
    {
        name: "fragment",
        spec: (0, $fngjO.fragment)
    },
    {
        name: "indentation",
        spec: (0, $30dKh.indentation)
    },
    {
        name: "border",
        spec: (0, $dTp2k.border)
    },
    {
        name: "unsupportedMark",
        spec: (0, $23a1A.unsupportedMark)
    },
    {
        name: "unsupportedNodeAttribute",
        spec: (0, $UshAi.unsupportedNodeAttribute)
    }
]);
function $c98026040bbd6b6c$export$5f4ce795563f4211(config) {
    var customNodeSpecs = config.customNodeSpecs, customMarkSpecs = config.customMarkSpecs;
    var nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    var marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($c98026040bbd6b6c$var$markGroupDeclarationsNames);
    var nodes = $c98026040bbd6b6c$var$addItems($c98026040bbd6b6c$var$nodesInOrder, nodesConfig, customNodeSpecs);
    var marks = $c98026040bbd6b6c$var$addItems($c98026040bbd6b6c$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = $c98026040bbd6b6c$export$daf54fed04c8fb77(nodes, marks);
    return new (0, $1cpUy.Schema)({
        nodes: nodes,
        marks: marks
    });
}
function $c98026040bbd6b6c$export$daf54fed04c8fb77(nodes, supportedMarks) {
    var nodeNames = Object.keys(nodes);
    nodeNames.forEach(function(nodeKey) {
        var nodeSpec = $c98026040bbd6b6c$var$_objectSpread({}, nodes[nodeKey]);
        if (nodeSpec.marks && nodeSpec.marks !== "_") nodeSpec.marks = nodeSpec.marks.split(" ").filter(function(mark) {
            return !!supportedMarks[mark];
        }).join(" ");
        if (nodeSpec.content) nodeSpec.content = $c98026040bbd6b6c$export$9cb535b0ed27c9c(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $c98026040bbd6b6c$export$9cb535b0ed27c9c(nodes, rawContent) {
    var content = rawContent.replace(/\W/g, " ");
    var contentKeys = content.split(" ");
    var unsupportedContentKeys = contentKeys.filter(function(contentKey) {
        return !$c98026040bbd6b6c$var$isContentSupported(nodes, contentKey);
    });
    return unsupportedContentKeys.reduce(function(newContent, nodeName) {
        return $c98026040bbd6b6c$var$sanitizedContent(newContent, nodeName);
    }, rawContent);
}
function $c98026040bbd6b6c$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || "";
    if (!content || !content.match(/\w/)) return "";
    var pattern = "(".concat(invalidContent, "((\\s)*\\|)+)|((\\|(\\s)*)+").concat(invalidContent, ")|(").concat(invalidContent, "$)|(").concat(invalidContent, "(\\+|\\*))");
    return content.replace(new RegExp(pattern, "g"), "").replace("  ", " ").trim();
}
function $c98026040bbd6b6c$var$isContentSupported(nodes, contentKey) {
    var nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(var supportedKey in nodes){
        var nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}
var $c98026040bbd6b6c$export$c77b6d30da5276a1 = true;

});
parcelRegister("1cpUy", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0dfb02dd05e025eb$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Mark", function () { return $0dfb02dd05e025eb$export$c9d15bcfc6d42044; });
$parcel$export(module.exports, "ReplaceError", function () { return $0dfb02dd05e025eb$export$6de0e778727af3f2; });
$parcel$export(module.exports, "Slice", function () { return $0dfb02dd05e025eb$export$b3f2e2de3a8baa1e; });
$parcel$export(module.exports, "ResolvedPos", function () { return $0dfb02dd05e025eb$export$b2a42f82e59e4b19; });
$parcel$export(module.exports, "NodeRange", function () { return $0dfb02dd05e025eb$export$7bc461ceb770fb16; });
$parcel$export(module.exports, "Node", function () { return $0dfb02dd05e025eb$export$85c928794f8d04d4; });
$parcel$export(module.exports, "MarkType", function () { return $0dfb02dd05e025eb$export$b6a78689043c6521; });
$parcel$export(module.exports, "Schema", function () { return $0dfb02dd05e025eb$export$19342e026b58ebb7; });
$parcel$export(module.exports, "DOMParser", function () { return $0dfb02dd05e025eb$export$1059c6e7d2ce5669; });
$parcel$export(module.exports, "DOMSerializer", function () { return $0dfb02dd05e025eb$export$3476b78f8f5a8b72; });

var $etEfa = parcelRequire("etEfa");
function $0dfb02dd05e025eb$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $0dfb02dd05e025eb$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $0dfb02dd05e025eb$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $0dfb02dd05e025eb$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $0dfb02dd05e025eb$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    @internal
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $0dfb02dd05e025eb$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $0dfb02dd05e025eb$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $0dfb02dd05e025eb$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $0dfb02dd05e025eb$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $0dfb02dd05e025eb$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $0dfb02dd05e025eb$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $0dfb02dd05e025eb$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $0dfb02dd05e025eb$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $0dfb02dd05e025eb$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. (Not public.)
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $0dfb02dd05e025eb$var$retIndex(0, pos);
        if (pos == this.size) return $0dfb02dd05e025eb$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $0dfb02dd05e025eb$var$retIndex(i + 1, end);
                return $0dfb02dd05e025eb$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $0dfb02dd05e025eb$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $0dfb02dd05e025eb$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $0dfb02dd05e025eb$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $0dfb02dd05e025eb$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $0dfb02dd05e025eb$export$ffb0004e005737fa.empty;
        if (nodes instanceof $0dfb02dd05e025eb$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $0dfb02dd05e025eb$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $0dfb02dd05e025eb$export$ffb0004e005737fa.empty = new $0dfb02dd05e025eb$export$ffb0004e005737fa([], 0);
const $0dfb02dd05e025eb$var$found = {
    index: 0,
    offset: 0
};
function $0dfb02dd05e025eb$var$retIndex(index, offset) {
    $0dfb02dd05e025eb$var$found.index = index;
    $0dfb02dd05e025eb$var$found.offset = offset;
    return $0dfb02dd05e025eb$var$found;
}
function $0dfb02dd05e025eb$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$0dfb02dd05e025eb$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$0dfb02dd05e025eb$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $0dfb02dd05e025eb$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $0dfb02dd05e025eb$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        return type.create(json.attrs);
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $0dfb02dd05e025eb$export$c9d15bcfc6d42044.none;
        if (marks instanceof $0dfb02dd05e025eb$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $0dfb02dd05e025eb$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $0dfb02dd05e025eb$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $0dfb02dd05e025eb$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $0dfb02dd05e025eb$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $0dfb02dd05e025eb$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $0dfb02dd05e025eb$export$b3f2e2de3a8baa1e($0dfb02dd05e025eb$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $0dfb02dd05e025eb$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $0dfb02dd05e025eb$export$b3f2e2de3a8baa1e($0dfb02dd05e025eb$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $0dfb02dd05e025eb$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $0dfb02dd05e025eb$export$b3f2e2de3a8baa1e.empty = new $0dfb02dd05e025eb$export$b3f2e2de3a8baa1e($0dfb02dd05e025eb$export$ffb0004e005737fa.empty, 0, 0);
function $0dfb02dd05e025eb$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($0dfb02dd05e025eb$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $0dfb02dd05e025eb$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $0dfb02dd05e025eb$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $0dfb02dd05e025eb$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $0dfb02dd05e025eb$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $0dfb02dd05e025eb$export$6de0e778727af3f2("Inconsistent open depths");
    return $0dfb02dd05e025eb$var$replaceOuter($from, $to, slice, 0);
}
function $0dfb02dd05e025eb$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $0dfb02dd05e025eb$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $0dfb02dd05e025eb$var$close(node, $0dfb02dd05e025eb$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $0dfb02dd05e025eb$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $0dfb02dd05e025eb$var$prepareSliceForReplace(slice, $from);
        return $0dfb02dd05e025eb$var$close(node, $0dfb02dd05e025eb$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $0dfb02dd05e025eb$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $0dfb02dd05e025eb$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $0dfb02dd05e025eb$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $0dfb02dd05e025eb$var$checkJoin(node, $after.node(depth));
    return node;
}
function $0dfb02dd05e025eb$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $0dfb02dd05e025eb$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $0dfb02dd05e025eb$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$0dfb02dd05e025eb$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $0dfb02dd05e025eb$var$addNode($end.nodeBefore, target);
}
function $0dfb02dd05e025eb$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $0dfb02dd05e025eb$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $0dfb02dd05e025eb$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $0dfb02dd05e025eb$var$joinable($end, $to, depth + 1);
    let content = [];
    $0dfb02dd05e025eb$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $0dfb02dd05e025eb$var$checkJoin(openStart, openEnd);
        $0dfb02dd05e025eb$var$addNode($0dfb02dd05e025eb$var$close(openStart, $0dfb02dd05e025eb$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $0dfb02dd05e025eb$var$addNode($0dfb02dd05e025eb$var$close(openStart, $0dfb02dd05e025eb$var$replaceTwoWay($from, $start, depth + 1)), content);
        $0dfb02dd05e025eb$var$addRange($start, $end, depth, content);
        if (openEnd) $0dfb02dd05e025eb$var$addNode($0dfb02dd05e025eb$var$close(openEnd, $0dfb02dd05e025eb$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $0dfb02dd05e025eb$var$addRange($to, null, depth, content);
    return new $0dfb02dd05e025eb$export$ffb0004e005737fa(content);
}
function $0dfb02dd05e025eb$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $0dfb02dd05e025eb$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $0dfb02dd05e025eb$var$joinable($from, $to, depth + 1);
        $0dfb02dd05e025eb$var$addNode($0dfb02dd05e025eb$var$close(type, $0dfb02dd05e025eb$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $0dfb02dd05e025eb$var$addRange($to, null, depth, content);
    return new $0dfb02dd05e025eb$export$ffb0004e005737fa(content);
}
function $0dfb02dd05e025eb$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($0dfb02dd05e025eb$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $0dfb02dd05e025eb$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $0dfb02dd05e025eb$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $0dfb02dd05e025eb$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $0dfb02dd05e025eb$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        for(let i = 0; i < $0dfb02dd05e025eb$var$resolveCache.length; i++){
            let cached = $0dfb02dd05e025eb$var$resolveCache[i];
            if (cached.pos == pos && cached.doc == doc) return cached;
        }
        let result = $0dfb02dd05e025eb$var$resolveCache[$0dfb02dd05e025eb$var$resolveCachePos] = $0dfb02dd05e025eb$export$b2a42f82e59e4b19.resolve(doc, pos);
        $0dfb02dd05e025eb$var$resolveCachePos = ($0dfb02dd05e025eb$var$resolveCachePos + 1) % $0dfb02dd05e025eb$var$resolveCacheSize;
        return result;
    }
}
let $0dfb02dd05e025eb$var$resolveCache = [], $0dfb02dd05e025eb$var$resolveCachePos = 0, $0dfb02dd05e025eb$var$resolveCacheSize = 12;
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $0dfb02dd05e025eb$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $0dfb02dd05e025eb$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $0dfb02dd05e025eb$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $0dfb02dd05e025eb$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $0dfb02dd05e025eb$export$ffb0004e005737fa.empty;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $0dfb02dd05e025eb$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $0dfb02dd05e025eb$var$emptyAttrs) && $0dfb02dd05e025eb$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $0dfb02dd05e025eb$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $0dfb02dd05e025eb$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $0dfb02dd05e025eb$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $0dfb02dd05e025eb$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $0dfb02dd05e025eb$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $0dfb02dd05e025eb$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $0dfb02dd05e025eb$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $0dfb02dd05e025eb$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $0dfb02dd05e025eb$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $0dfb02dd05e025eb$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise error when they do not.
    */ check() {
        this.type.checkContent(this.content);
        let copy = $0dfb02dd05e025eb$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++)copy = this.marks[i].addToSet(copy);
        if (!$0dfb02dd05e025eb$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = null;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $0dfb02dd05e025eb$export$ffb0004e005737fa.fromJSON(schema, json.content);
        return schema.nodeType(json.type).create(json.attrs, content, marks);
    }
}
$0dfb02dd05e025eb$export$85c928794f8d04d4.prototype.text = undefined;
class $0dfb02dd05e025eb$var$TextNode extends $0dfb02dd05e025eb$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $0dfb02dd05e025eb$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $0dfb02dd05e025eb$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $0dfb02dd05e025eb$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $0dfb02dd05e025eb$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $0dfb02dd05e025eb$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $0dfb02dd05e025eb$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $0dfb02dd05e025eb$export$364ed450558d7ec4.empty;
        let expr = $0dfb02dd05e025eb$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $0dfb02dd05e025eb$var$dfa($0dfb02dd05e025eb$var$nfa(expr));
        $0dfb02dd05e025eb$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $0dfb02dd05e025eb$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $0dfb02dd05e025eb$export$364ed450558d7ec4.empty = new $0dfb02dd05e025eb$export$364ed450558d7ec4(true);
class $0dfb02dd05e025eb$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $0dfb02dd05e025eb$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($0dfb02dd05e025eb$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $0dfb02dd05e025eb$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($0dfb02dd05e025eb$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $0dfb02dd05e025eb$var$parseExprSubscript(stream) {
    let expr = $0dfb02dd05e025eb$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $0dfb02dd05e025eb$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $0dfb02dd05e025eb$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $0dfb02dd05e025eb$var$parseExprRange(stream, expr) {
    let min = $0dfb02dd05e025eb$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $0dfb02dd05e025eb$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $0dfb02dd05e025eb$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.groups.indexOf(name) > -1) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $0dfb02dd05e025eb$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $0dfb02dd05e025eb$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $0dfb02dd05e025eb$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
/**
Construct an NFA from an expression as returned by the parser. The
NFA is represented as an array of states, which are themselves
arrays of edges, which are `{term, to}` objects. The first state is
the entry state and the last node is the success state.

Note that unlike typical NFAs, the edge ordering in this one is
significant, in that it is used to contruct filler content when
necessary.
*/ function $0dfb02dd05e025eb$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $0dfb02dd05e025eb$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $0dfb02dd05e025eb$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($0dfb02dd05e025eb$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $0dfb02dd05e025eb$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($0dfb02dd05e025eb$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $0dfb02dd05e025eb$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $0dfb02dd05e025eb$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($0dfb02dd05e025eb$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $0dfb02dd05e025eb$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $0dfb02dd05e025eb$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $0dfb02dd05e025eb$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $0dfb02dd05e025eb$var$initAttrs(attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $0dfb02dd05e025eb$var$Attribute(attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $0dfb02dd05e025eb$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $0dfb02dd05e025eb$var$initAttrs(spec.attrs);
        this.defaultAttrs = $0dfb02dd05e025eb$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $0dfb02dd05e025eb$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $0dfb02dd05e025eb$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $0dfb02dd05e025eb$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $0dfb02dd05e025eb$export$ffb0004e005737fa.from(content), $0dfb02dd05e025eb$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $0dfb02dd05e025eb$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $0dfb02dd05e025eb$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $0dfb02dd05e025eb$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $0dfb02dd05e025eb$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($0dfb02dd05e025eb$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $0dfb02dd05e025eb$export$85c928794f8d04d4(this, attrs, content.append(after), $0dfb02dd05e025eb$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type with the given attributes.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $0dfb02dd05e025eb$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $0dfb02dd05e025eb$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
// Attribute descriptors
class $0dfb02dd05e025eb$var$Attribute {
    constructor(options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $0dfb02dd05e025eb$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $0dfb02dd05e025eb$var$initAttrs(spec.attrs);
        this.excluded = null;
        let defaults = $0dfb02dd05e025eb$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $0dfb02dd05e025eb$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $0dfb02dd05e025eb$export$c9d15bcfc6d42044(this, $0dfb02dd05e025eb$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $0dfb02dd05e025eb$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $0dfb02dd05e025eb$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $etEfa.default).from(spec.nodes), instanceSpec.marks = (0, $etEfa.default).from(spec.marks || {}), this.nodes = $0dfb02dd05e025eb$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $0dfb02dd05e025eb$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $0dfb02dd05e025eb$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            type.markSet = markExpr == "_" ? null : markExpr ? $0dfb02dd05e025eb$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $0dfb02dd05e025eb$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $0dfb02dd05e025eb$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $0dfb02dd05e025eb$var$TextNode(type, type.defaultAttrs, text, $0dfb02dd05e025eb$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $0dfb02dd05e025eb$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $0dfb02dd05e025eb$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $0dfb02dd05e025eb$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $0dfb02dd05e025eb$var$isTagRule(rule) {
    return rule.tag != null;
}
function $0dfb02dd05e025eb$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $0dfb02dd05e025eb$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        rules.forEach((rule)=>{
            if ($0dfb02dd05e025eb$var$isTagRule(rule)) this.tags.push(rule);
            else if ($0dfb02dd05e025eb$var$isStyleRule(rule)) this.styles.push(rule);
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $0dfb02dd05e025eb$var$ParseContext(this, options, false);
        context.addAll(dom, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $0dfb02dd05e025eb$var$ParseContext(this, options, true);
        context.addAll(dom, options.from, options.to);
        return $0dfb02dd05e025eb$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($0dfb02dd05e025eb$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $0dfb02dd05e025eb$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $0dfb02dd05e025eb$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $0dfb02dd05e025eb$export$1059c6e7d2ce5669(schema, $0dfb02dd05e025eb$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $0dfb02dd05e025eb$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $0dfb02dd05e025eb$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $0dfb02dd05e025eb$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $0dfb02dd05e025eb$var$OPT_PRESERVE_WS = 1, $0dfb02dd05e025eb$var$OPT_PRESERVE_WS_FULL = 2, $0dfb02dd05e025eb$var$OPT_OPEN_LEFT = 4;
function $0dfb02dd05e025eb$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $0dfb02dd05e025eb$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $0dfb02dd05e025eb$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $0dfb02dd05e025eb$var$OPT_PRESERVE_WS | $0dfb02dd05e025eb$var$OPT_PRESERVE_WS_FULL : base & ~$0dfb02dd05e025eb$var$OPT_OPEN_LEFT;
}
class $0dfb02dd05e025eb$var$NodeContext {
    constructor(type, attrs, // Marks applied to this node itself
    marks, // Marks that can't apply here, but will be used in children if possible
    pendingMarks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.pendingMarks = pendingMarks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $0dfb02dd05e025eb$export$c9d15bcfc6d42044.none;
        // Nested Marks with same type
        this.stashMarks = [];
        this.match = match || (options & $0dfb02dd05e025eb$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($0dfb02dd05e025eb$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $0dfb02dd05e025eb$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $0dfb02dd05e025eb$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($0dfb02dd05e025eb$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    popFromStashMark(mark) {
        for(let i = this.stashMarks.length - 1; i >= 0; i--)if (mark.eq(this.stashMarks[i])) return this.stashMarks.splice(i, 1)[0];
    }
    applyPending(nextType) {
        for(let i = 0, pending = this.pendingMarks; i < pending.length; i++){
            let mark = pending[i];
            if ((this.type ? this.type.allowsMarkType(mark.type) : $0dfb02dd05e025eb$var$markMayApply(mark.type, nextType)) && !mark.isInSet(this.activeMarks)) {
                this.activeMarks = mark.addToSet(this.activeMarks);
                this.pendingMarks = mark.removeFromSet(this.pendingMarks);
            }
        }
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$0dfb02dd05e025eb$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $0dfb02dd05e025eb$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        let topNode = options.topNode, topContext;
        let topOptions = $0dfb02dd05e025eb$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $0dfb02dd05e025eb$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $0dfb02dd05e025eb$var$NodeContext(topNode.type, topNode.attrs, $0dfb02dd05e025eb$export$c9d15bcfc6d42044.none, $0dfb02dd05e025eb$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $0dfb02dd05e025eb$var$NodeContext(null, null, $0dfb02dd05e025eb$export$c9d15bcfc6d42044.none, $0dfb02dd05e025eb$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $0dfb02dd05e025eb$var$NodeContext(parser.schema.topNodeType, null, $0dfb02dd05e025eb$export$c9d15bcfc6d42044.none, $0dfb02dd05e025eb$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom) {
        if (dom.nodeType == 3) this.addTextNode(dom);
        else if (dom.nodeType == 1) this.addElement(dom);
    }
    withStyleRules(dom, f) {
        let style = dom.getAttribute("style");
        if (!style) return f();
        let marks = this.readStyles($0dfb02dd05e025eb$var$parseStyles(style));
        if (!marks) return; // A style with ignore: true
        let [addMarks, removeMarks] = marks, top = this.top;
        for(let i = 0; i < removeMarks.length; i++)this.removePendingMark(removeMarks[i], top);
        for(let i = 0; i < addMarks.length; i++)this.addPendingMark(addMarks[i]);
        f();
        for(let i = 0; i < addMarks.length; i++)this.removePendingMark(addMarks[i], top);
        for(let i = 0; i < removeMarks.length; i++)this.addPendingMark(removeMarks[i]);
    }
    addTextNode(dom) {
        let value = dom.nodeValue;
        let top = this.top;
        if (top.options & $0dfb02dd05e025eb$var$OPT_PRESERVE_WS_FULL || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!(top.options & $0dfb02dd05e025eb$var$OPT_PRESERVE_WS)) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == "BR" || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (!(top.options & $0dfb02dd05e025eb$var$OPT_PRESERVE_WS_FULL)) value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value));
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, matchAfter) {
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($0dfb02dd05e025eb$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $0dfb02dd05e025eb$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        if (rule ? rule.ignore : $0dfb02dd05e025eb$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, top = this.top, oldNeedsBlock = this.needsBlock;
            if ($0dfb02dd05e025eb$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom);
                return;
            }
            if (rule && rule.skip) this.addAll(dom);
            else this.withStyleRules(dom, ()=>this.addAll(dom));
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else this.withStyleRules(dom, ()=>{
            this.addElementByRule(dom, rule, rule.consuming === false ? ruleID : undefined);
        });
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"));
    }
    // Called for ignored nodes
    ignoreFallback(dom) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"));
    }
    // Run any style parser associated with the node's styles. Either
    // return an array of marks, or null to indicate some of the styles
    // had a rule with `ignore` set.
    readStyles(styles) {
        let add = $0dfb02dd05e025eb$export$c9d15bcfc6d42044.none, remove = $0dfb02dd05e025eb$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < styles.length; i += 2)for(let after = undefined;;){
            let rule = this.parser.matchStyle(styles[i], styles[i + 1], this, after);
            if (!rule) break;
            if (rule.ignore) return null;
            if (rule.clearMark) this.top.pendingMarks.concat(this.top.activeMarks).forEach((m)=>{
                if (rule.clearMark(m)) remove = m.addToSet(remove);
            });
            else add = this.parser.schema.marks[rule.mark].create(rule.attrs).addToSet(add);
            if (rule.consuming === false) after = rule;
            else break;
        }
        return [
            add,
            remove
        ];
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, continueAfter) {
        let sync, nodeType, mark;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) sync = this.enter(nodeType, rule.attrs || null, rule.preserveWhitespace);
            else if (!this.insertNode(nodeType.create(rule.attrs))) this.leafFallback(dom);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            mark = markType.create(rule.attrs);
            this.addPendingMark(mark);
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM);
        }
        if (sync && this.sync(startIn)) this.open--;
        if (mark) this.removePendingMark(mark, startIn);
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return false;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)this.enterInner(route[i], null, false);
        return true;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) this.enterInner(block);
        }
        if (this.findPlace(node)) {
            this.closeExtra();
            let top = this.top;
            top.applyPending(node.type);
            if (top.match) top.match = top.match.matchType(node.type);
            let marks = top.activeMarks;
            for(let i = 0; i < node.marks.length; i++)if (!top.type || top.type.allowsMarkType(node.marks[i].type)) marks = node.marks[i].addToSet(marks);
            top.content.push(node.mark(marks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, preserveWS) {
        let ok = this.findPlace(type.create(attrs));
        if (ok) this.enterInner(type, attrs, true, preserveWS);
        return ok;
    }
    // Open a node of the given type
    enterInner(type, attrs = null, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.applyPending(type);
        top.match = top.match && top.match.matchType(type);
        let options = $0dfb02dd05e025eb$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $0dfb02dd05e025eb$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $0dfb02dd05e025eb$var$OPT_OPEN_LEFT;
        this.nodes.push(new $0dfb02dd05e025eb$var$NodeContext(type, attrs, top.activeMarks, top.pendingMarks, solid, null, options));
        this.open++;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(this.isOpen || this.options.topOpen);
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--)if (this.nodes[i] == to) {
            this.open = i;
            return true;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && next.groups.indexOf(part) == -1) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
    addPendingMark(mark) {
        let found = $0dfb02dd05e025eb$var$findSameMarkInSet(mark, this.top.pendingMarks);
        if (found) this.top.stashMarks.push(found);
        this.top.pendingMarks = mark.addToSet(this.top.pendingMarks);
    }
    removePendingMark(mark, upto) {
        for(let depth = this.open; depth >= 0; depth--){
            let level = this.nodes[depth];
            let found = level.pendingMarks.lastIndexOf(mark);
            if (found > -1) level.pendingMarks = mark.removeFromSet(level.pendingMarks);
            else {
                level.activeMarks = mark.removeFromSet(level.activeMarks);
                let stashMark = level.popFromStashMark(mark);
                if (stashMark && level.type && level.type.allowsMarkType(stashMark.type)) level.activeMarks = stashMark.addToSet(level.activeMarks);
            }
            if (level == upto) break;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $0dfb02dd05e025eb$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $0dfb02dd05e025eb$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $0dfb02dd05e025eb$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
// Tokenize a style attribute into property/value pairs.
function $0dfb02dd05e025eb$var$parseStyles(style) {
    let re = /\s*([\w-]+)\s*:\s*([^;]+)/g, m, result = [];
    while(m = re.exec(style))result.push(m[1], m[2].trim());
    return result;
}
function $0dfb02dd05e025eb$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $0dfb02dd05e025eb$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
function $0dfb02dd05e025eb$var$findSameMarkInSet(mark, set) {
    for(let i = 0; i < set.length; i++){
        if (mark.eq(set[i])) return set[i];
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $0dfb02dd05e025eb$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $0dfb02dd05e025eb$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $0dfb02dd05e025eb$export$3476b78f8f5a8b72.renderSpec($0dfb02dd05e025eb$var$doc(options), this.nodes[node.type.name](node));
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $0dfb02dd05e025eb$export$3476b78f8f5a8b72.renderSpec($0dfb02dd05e025eb$var$doc(options), toDOM(mark, inline));
    }
    /**
    Render an [output spec](https://prosemirror.net/docs/ref/#model.DOMOutputSpec) to a DOM node. If
    the spec has a hole (zero) in it, `contentDOM` will point at the
    node with the hole.
    */ static renderSpec(doc, structure, xmlNS = null) {
        if (typeof structure == "string") return {
            dom: doc.createTextNode(structure)
        };
        if (structure.nodeType != null) return {
            dom: structure
        };
        if (structure.dom && structure.dom.nodeType != null) return structure;
        let tagName = structure[0], space = tagName.indexOf(" ");
        if (space > 0) {
            xmlNS = tagName.slice(0, space);
            tagName = tagName.slice(space + 1);
        }
        let contentDOM;
        let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
        let attrs = structure[1], start = 1;
        if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
            start = 2;
            for(let name in attrs)if (attrs[name] != null) {
                let space = name.indexOf(" ");
                if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
                else dom.setAttribute(name, attrs[name]);
            }
        }
        for(let i = start; i < structure.length; i++){
            let child = structure[i];
            if (child === 0) {
                if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
                return {
                    dom: dom,
                    contentDOM: dom
                };
            } else {
                let { dom: inner, contentDOM: innerContent } = $0dfb02dd05e025eb$export$3476b78f8f5a8b72.renderSpec(doc, child, xmlNS);
                dom.appendChild(inner);
                if (innerContent) {
                    if (contentDOM) throw new RangeError("Multiple content holes");
                    contentDOM = innerContent;
                }
            }
        }
        return {
            dom: dom,
            contentDOM: contentDOM
        };
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $0dfb02dd05e025eb$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $0dfb02dd05e025eb$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $0dfb02dd05e025eb$var$gatherToDOM(schema.marks);
    }
}
function $0dfb02dd05e025eb$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $0dfb02dd05e025eb$var$doc(options) {
    return options.document || window.document;
}

});
parcelRegister("etEfa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8a2fdac009064ef$export$2e2bcd8739ae039; });
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $a8a2fdac009064ef$var$OrderedMap(content) {
    this.content = content;
}
$a8a2fdac009064ef$var$OrderedMap.prototype = {
    constructor: $a8a2fdac009064ef$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $a8a2fdac009064ef$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $a8a2fdac009064ef$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $a8a2fdac009064ef$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $a8a2fdac009064ef$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $a8a2fdac009064ef$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $a8a2fdac009064ef$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $a8a2fdac009064ef$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $a8a2fdac009064ef$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $a8a2fdac009064ef$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $a8a2fdac009064ef$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$a8a2fdac009064ef$var$OrderedMap.from = function(value) {
    if (value instanceof $a8a2fdac009064ef$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $a8a2fdac009064ef$var$OrderedMap(content);
};
var $a8a2fdac009064ef$export$2e2bcd8739ae039 = $a8a2fdac009064ef$var$OrderedMap;

});


parcelRegister("2Uu7f", function(module, exports) {

$parcel$export(module.exports, "FONT_STYLE", function () { return $21e82c2540c875e1$export$4498a6080fed604c; });
$parcel$export(module.exports, "SEARCH_QUERY", function () { return $21e82c2540c875e1$export$f8e8a5f34f6ea725; });
$parcel$export(module.exports, "LINK", function () { return $21e82c2540c875e1$export$b395009ca7f092c7; });
$parcel$export(module.exports, "COLOR", function () { return $21e82c2540c875e1$export$9b982809044276a6; });
$parcel$export(module.exports, "ALIGNMENT", function () { return $21e82c2540c875e1$export$470d0905851e47a1; });
$parcel$export(module.exports, "INDENTATION", function () { return $21e82c2540c875e1$export$bacb7f4b06a06b22; });
// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
var $21e82c2540c875e1$export$4498a6080fed604c = "fontStyle";
var $21e82c2540c875e1$export$f8e8a5f34f6ea725 = "searchQuery";
var $21e82c2540c875e1$export$b395009ca7f092c7 = "link";
var $21e82c2540c875e1$export$9b982809044276a6 = "color";
var $21e82c2540c875e1$export$470d0905851e47a1 = "alignment";
var $21e82c2540c875e1$export$bacb7f4b06a06b22 = "indentation";

});

parcelRegister("fAhqi", function(module, exports) {

$parcel$export(module.exports, "alignmentPositionMap", function () { return $b587bbaac5e85993$export$be9cf49015769bbd; });
$parcel$export(module.exports, "alignment", function () { return $b587bbaac5e85993$export$8e53000a4ec837; });

var $2Uu7f = parcelRequire("2Uu7f");
var $b587bbaac5e85993$export$be9cf49015769bbd = {
    end: "right",
    right: "end",
    center: "center"
};
var $b587bbaac5e85993$export$8e53000a4ec837 = {
    excludes: "alignment ".concat((0, $2Uu7f.INDENTATION)),
    group: (0, $2Uu7f.ALIGNMENT),
    attrs: {
        align: {}
    },
    parseDOM: [
        {
            tag: "div.fabric-editor-block-mark",
            getAttrs: function getAttrs(dom) {
                var align = dom.getAttribute("data-align");
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            "div",
            {
                class: "fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-".concat(mark.attrs.align),
                "data-align": mark.attrs.align
            },
            0
        ];
    }
};

});

parcelRegister("bvuHp", function(module, exports) {

$parcel$export(module.exports, "AnnotationTypes", function () { return $860a67268e0ef355$export$94aa2fc69ad33d19; });
$parcel$export(module.exports, "AnnotationMarkStates", function () { return $860a67268e0ef355$export$4bab14797673da9f; });
$parcel$export(module.exports, "buildDataAttributes", function () { return $860a67268e0ef355$export$93a98caa8bc6cb07; });
$parcel$export(module.exports, "annotation", function () { return $860a67268e0ef355$export$8512c9afa7b24c3b; });

var $kFnE9 = parcelRequire("kFnE9");
function $860a67268e0ef355$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $860a67268e0ef355$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $860a67268e0ef355$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $860a67268e0ef355$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $860a67268e0ef355$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
var $860a67268e0ef355$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $860a67268e0ef355$export$93a98caa8bc6cb07(_ref) {
    var id = _ref.id, annotationType = _ref.annotationType, state = _ref.state;
    var data = {
        "data-mark-type": "annotation",
        "data-mark-annotation-type": annotationType,
        "data-id": id
    };
    if (state) return $860a67268e0ef355$var$_objectSpread($860a67268e0ef355$var$_objectSpread({}, data), {}, {
        "data-mark-annotation-state": state
    });
    return data;
}
var $860a67268e0ef355$export$8512c9afa7b24c3b = {
    inclusive: true,
    group: "annotation",
    excludes: "",
    attrs: {
        id: {
            default: ""
        },
        annotationType: {
            default: $860a67268e0ef355$export$94aa2fc69ad33d19.INLINE_COMMENT
        }
    },
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: "annotation",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    id: dom.getAttribute("data-id"),
                    annotationType: dom.getAttribute("data-mark-annotation-type")
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        /*
      Data attributes on the DOM node are a temporary means of
      incrementally switching over to the Annotation mark. Once renderer
      provides native support for inline comments the data attributes on the
      DOM nodes will be removed.
    */ return [
            "span",
            $860a67268e0ef355$var$_objectSpread({
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                "class": "fabric-editor-annotation"
            }, $860a67268e0ef355$export$93a98caa8bc6cb07({
                id: node.attrs.id,
                annotationType: node.attrs.annotationType
            })),
            0
        ];
    }
};

});

parcelRegister("1QthD", function(module, exports) {

$parcel$export(module.exports, "backgroundColor", function () { return $15815cde3b900e82$export$8c5a050822fd698c; });

var $kFnE9 = parcelRequire("kFnE9");

var $9q1kH = parcelRequire("9q1kH");

var $Pbuln = parcelRequire("Pbuln");

var $2Uu7f = parcelRequire("2Uu7f");

var $g6muZ = parcelRequire("g6muZ");

var $f2zQv = parcelRequire("f2zQv");

var $eD4GP = parcelRequire("eD4GP");
/**
 * @name backgroundColor_mark
 */ var $15815cde3b900e82$var$colorArrayPalette = [
    [
        (0, $g6muZ.Neutral300),
        "Gray"
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $g6muZ.T200),
        "Teal"
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $g6muZ.L200),
        "Lime"
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $g6muZ.O200),
        "Orange"
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $g6muZ.M200),
        "Magenta"
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $g6muZ.P200),
        "Purple"
    ] // token: color.background.accent.purple.subtler
];
var $15815cde3b900e82$export$14ec3f21a268e497 = new Map();
$15815cde3b900e82$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $15815cde3b900e82$export$14ec3f21a268e497.set(color.toLowerCase(), label);
});
var $15815cde3b900e82$export$8c5a050822fd698c = {
    attrs: {
        color: {}
    },
    inclusive: true,
    group: (0, $2Uu7f.COLOR),
    excludes: "".concat((0, $2Uu7f.COLOR)),
    parseDOM: [
        {
            style: "background-color",
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $g6muZ.rgbToHex)(value);
                else if (value[0] === "#") hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $15815cde3b900e82$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: ".fabric-background-color-mark",
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $15815cde3b900e82$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $Pbuln.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $f2zQv.getGlobalTheme)().colorMode === "dark") // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $eD4GP.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            "span",
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({
                class: "fabric-background-color-mark",
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, "data-background-custom-color", mark.attrs.color)
        ];
    }
};

});
parcelRegister("Pbuln", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBorderPaletteColor", function () { return $099dace52c649b5c$export$bad3c41dd33cb4bc; });
$parcel$export(module.exports, "hexToEditorTextPaletteColor", function () { return $099dace52c649b5c$export$9c2f408d391feb93; });
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", function () { return $099dace52c649b5c$export$8b58ff1b36bb75e0; });
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", function () { return $099dace52c649b5c$export$a270511a0e7fd61a; });
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $099dace52c649b5c$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return $099dace52c649b5c$export$aa000893c5e2b9c2[hexColor.toUpperCase()];
}
var $099dace52c649b5c$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ "#091E4224": "var(--ds-border, #091E4224)",
    /** gray */ "#758195": "var(--ds-border-bold, #758195)",
    /** gray - bold */ "#172B4D": "var(--ds-text, #172B4D)"
};
function $099dace52c649b5c$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return $099dace52c649b5c$export$57fa5089caad992[hexColor.toUpperCase()];
}
var $099dace52c649b5c$export$57fa5089caad992 = {
    /** blue - light */ "#B3D4FF": "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    /** blue - medium */ "#4C9AFF": "var(--ds-icon-accent-blue, #4C9AFF)",
    /** blue - strong */ "#0747A6": "var(--ds-text-accent-blue, #0747A6)",
    /** teal - light */ "#B3F5FF": "var(--ds-background-accent-teal-subtler, #B3F5FF)",
    /** teal - medium */ "#00B8D9": "var(--ds-icon-accent-teal, #00B8D9)",
    /** teal - strong */ "#008DA6": "var(--ds-text-accent-teal, #008DA6)",
    /** green - light */ "#ABF5D1": "var(--ds-background-accent-green-subtler, #ABF5D1)",
    /** green - medium */ "#36B37E": "var(--ds-icon-accent-green, #36B37E)",
    /** green - strong */ "#006644": "var(--ds-text-accent-green, #006644)",
    /** yellowOrange - light */ "#FFF0B3": "var(--ds-background-accent-yellow-subtler, #FFF0B3)",
    /** yellowOrange - medium */ "#FFC400": "var(--ds-background-accent-orange-subtle, #FFC400)",
    /** yellowOrange - strong */ "#FF991F": "var(--ds-icon-accent-orange, #FF991F)",
    /** red - light */ "#FFBDAD": "var(--ds-background-accent-red-subtler, #FFBDAD)",
    /** red - medium */ "#FF5630": "var(--ds-icon-accent-red, #FF5630)",
    /** red - strong */ "#BF2600": "var(--ds-text-accent-red, #BF2600)",
    /** purple - light */ "#EAE6FF": "var(--ds-background-accent-purple-subtler, #EAE6FF)",
    /** purple - medium */ "#6554C0": "var(--ds-icon-accent-purple, #6554C0)",
    /** purple - strong */ "#403294": "var(--ds-text-accent-purple, #403294)",
    /** whiteGray - light */ "#FFFFFF": "var(--ds-text-inverse, #FFFFFF)",
    /** whiteGray - medium */ "#97A0AF": "var(--ds-icon-accent-gray, #97A0AF)",
    /** whiteGray - strong */ "#172B4D": "var(--ds-text, #172B4D)"
};
function $099dace52c649b5c$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    return $099dace52c649b5c$export$12a518ff137dd389[hexColor.toUpperCase()];
}
var $099dace52c649b5c$export$12a518ff137dd389 = {
    /** Gray - light */ "#DCDFE4": "var(--ds-background-accent-gray-subtler, #DCDFE4)",
    /** Teal - light */ "#C6EDFB": "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    /** Lime - light */ "#D3F1A7": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** Orange - light */ "#FEDEC8": "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    /** Magenta - light */ "#FDD0EC": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** Purple - light */ "#DFD8FD": "var(--ds-background-accent-purple-subtler, #DFD8FD)"
};
function $099dace52c649b5c$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    var tokenData = $099dace52c649b5c$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
var $099dace52c649b5c$export$2462741d70e6a62f = {
    /** blue - light */ "#DEEBFF": {
        getValue: function getValue() {
            return "#DEEBFF";
        },
        token: "var(--ds-background-accent-blue-subtlest, #DEEBFF)"
    },
    /** blue - medium */ "#B3D4FF": {
        getValue: function getValue() {
            return "#B3D4FF";
        },
        token: "var(--ds-background-accent-blue-subtler, #B3D4FF)"
    },
    /** blue - strong */ "#4C9AFF": {
        getValue: function getValue() {
            return "#4C9AFF";
        },
        token: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
    },
    /** teal - light */ "#E6FCFF": {
        getValue: function getValue() {
            return "#E6FCFF";
        },
        token: "var(--ds-background-accent-teal-subtlest, #E6FCFF)"
    },
    /** teal - medium */ "#B3F5FF": {
        getValue: function getValue() {
            return "#B3F5FF";
        },
        token: "var(--ds-background-accent-teal-subtler, #B3F5FF)"
    },
    /** teal - strong */ "#79E2F2": {
        getValue: function getValue() {
            return "#79E2F2";
        },
        token: "var(--ds-background-accent-teal-subtle, #79E2F2)"
    },
    /** green - light */ "#E3FCEF": {
        getValue: function getValue() {
            return "#E3FCEF";
        },
        token: "var(--ds-background-accent-green-subtlest, #E3FCEF)"
    },
    /** green - medium */ "#ABF5D1": {
        getValue: function getValue() {
            return "#ABF5D1";
        },
        token: "var(--ds-background-accent-green-subtler, #ABF5D1)"
    },
    /** green - strong */ "#57D9A3": {
        getValue: function getValue() {
            return "#57D9A3";
        },
        token: "var(--ds-background-accent-green-subtle, #57D9A3)"
    },
    /** yellowOrange - light */ "#FFFAE6": {
        getValue: function getValue() {
            return "#FFFAE6";
        },
        token: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)"
    },
    /** yellowOrange - medium */ "#FFF0B3": {
        getValue: function getValue() {
            return "#FFF0B3";
        },
        token: "var(--ds-background-accent-yellow-subtler, #FFF0B3)"
    },
    /** yellowOrange - strong */ "#FFC400": {
        getValue: function getValue() {
            return "#FFC400";
        },
        token: "var(--ds-background-accent-orange-subtle, #FFC400)"
    },
    /** red - light */ "#FFEBE6": {
        getValue: function getValue() {
            return "#FFEBE6";
        },
        token: "var(--ds-background-accent-red-subtlest, #FFEBE6)"
    },
    /** red - medium */ "#FFBDAD": {
        getValue: function getValue() {
            return "#FFBDAD";
        },
        token: "var(--ds-background-accent-red-subtler, #FFBDAD)"
    },
    /** red - strong */ "#FF8F73": {
        getValue: function getValue() {
            return "#FF8F73";
        },
        token: "var(--ds-background-accent-red-subtle, #FF8F73)"
    },
    /** purple - light */ "#EAE6FF": {
        getValue: function getValue() {
            return "#EAE6FF";
        },
        token: "var(--ds-background-accent-purple-subtlest, #EAE6FF)"
    },
    /** purple - medium */ "#C0B6F2": {
        getValue: function getValue() {
            return "#C0B6F2";
        },
        token: "var(--ds-background-accent-purple-subtler, #C0B6F2)"
    },
    /** purple - strong */ "#998DD9": {
        getValue: function getValue() {
            return "#998DD9";
        },
        token: "var(--ds-background-accent-purple-subtle, #998DD9)"
    },
    /** whiteGray - light */ "#FFFFFF": {
        getValue: function getValue() {
            return "#FFFFFF";
        },
        token: "var(--ds-surface, #FFFFFF)"
    },
    /** whiteGray - medium */ "#F4F5F7": {
        getValue: function getValue() {
            return "#F4F5F7";
        },
        token: "var(--ds-background-accent-gray-subtlest, #F4F5F7)"
    },
    /** whiteGray - strong */ "#B3BAC5": {
        getValue: function getValue() {
            return "#B3BAC5";
        },
        token: "var(--ds-background-accent-gray-subtle, #B3BAC5)"
    }
};

});

parcelRegister("g6muZ", function(module, exports) {

$parcel$export(module.exports, "R50", function () { return $bb8ea8b1dfb2b79a$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R75", function () { return $bb8ea8b1dfb2b79a$export$b34b069eff244586; });
$parcel$export(module.exports, "R100", function () { return $bb8ea8b1dfb2b79a$export$be802dd0d8b57f35; });
$parcel$export(module.exports, "R300", function () { return $bb8ea8b1dfb2b79a$export$4a7404f376229999; });
$parcel$export(module.exports, "R500", function () { return $bb8ea8b1dfb2b79a$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y50", function () { return $bb8ea8b1dfb2b79a$export$8d9596b529bbb9cf; });
$parcel$export(module.exports, "Y75", function () { return $bb8ea8b1dfb2b79a$export$41060a744ab0b7ae; });
$parcel$export(module.exports, "Y200", function () { return $bb8ea8b1dfb2b79a$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y400", function () { return $bb8ea8b1dfb2b79a$export$59619663aa6500fb; });
$parcel$export(module.exports, "G50", function () { return $bb8ea8b1dfb2b79a$export$8a6341c32b6a3ee6; });
$parcel$export(module.exports, "G75", function () { return $bb8ea8b1dfb2b79a$export$69a3bf21b9686c2b; });
$parcel$export(module.exports, "G200", function () { return $bb8ea8b1dfb2b79a$export$747d86715d4175de; });
$parcel$export(module.exports, "G300", function () { return $bb8ea8b1dfb2b79a$export$940e1f69e873f202; });
$parcel$export(module.exports, "G500", function () { return $bb8ea8b1dfb2b79a$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $bb8ea8b1dfb2b79a$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $bb8ea8b1dfb2b79a$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $bb8ea8b1dfb2b79a$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B400", function () { return $bb8ea8b1dfb2b79a$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $bb8ea8b1dfb2b79a$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "L200", function () { return $bb8ea8b1dfb2b79a$export$f72948ef771f6f15; });
$parcel$export(module.exports, "N0", function () { return $bb8ea8b1dfb2b79a$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $bb8ea8b1dfb2b79a$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $bb8ea8b1dfb2b79a$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N60", function () { return $bb8ea8b1dfb2b79a$export$c2e91cbeada39b8b; });
$parcel$export(module.exports, "N80", function () { return $bb8ea8b1dfb2b79a$export$eaa8c8a70ac22806; });
$parcel$export(module.exports, "Neutral300", function () { return $bb8ea8b1dfb2b79a$export$1ae1cebe22dcedb4; });
$parcel$export(module.exports, "N300A", function () { return $bb8ea8b1dfb2b79a$export$13609db0e6812ab8; });
$parcel$export(module.exports, "N600", function () { return $bb8ea8b1dfb2b79a$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N800", function () { return $bb8ea8b1dfb2b79a$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N1000", function () { return $bb8ea8b1dfb2b79a$export$f78789c8b01753cd; });
$parcel$export(module.exports, "M200", function () { return $bb8ea8b1dfb2b79a$export$a19f0c33186f7767; });
$parcel$export(module.exports, "O200", function () { return $bb8ea8b1dfb2b79a$export$51716a84e62e022c; });
$parcel$export(module.exports, "P50", function () { return $bb8ea8b1dfb2b79a$export$363e4475840015bb; });
$parcel$export(module.exports, "P75", function () { return $bb8ea8b1dfb2b79a$export$4b0a4417ed59760f; });
$parcel$export(module.exports, "P100", function () { return $bb8ea8b1dfb2b79a$export$6011520a64d9a187; });
$parcel$export(module.exports, "P200", function () { return $bb8ea8b1dfb2b79a$export$a7175d4e9206bc80; });
$parcel$export(module.exports, "P300", function () { return $bb8ea8b1dfb2b79a$export$b48405b95304b5a1; });
$parcel$export(module.exports, "P500", function () { return $bb8ea8b1dfb2b79a$export$147899de772240ec; });
$parcel$export(module.exports, "T50", function () { return $bb8ea8b1dfb2b79a$export$2cf711fe14c66f06; });
$parcel$export(module.exports, "T75", function () { return $bb8ea8b1dfb2b79a$export$7a8f4d33f6f9772c; });
$parcel$export(module.exports, "T100", function () { return $bb8ea8b1dfb2b79a$export$776c9c497ef08533; });
$parcel$export(module.exports, "T200", function () { return $bb8ea8b1dfb2b79a$export$69cb3ca10c1e330e; });
$parcel$export(module.exports, "T300", function () { return $bb8ea8b1dfb2b79a$export$9dc1ef0f3f48059b; });
$parcel$export(module.exports, "T500", function () { return $bb8ea8b1dfb2b79a$export$6036577f95c3877e; });
$parcel$export(module.exports, "isHex", function () { return $bb8ea8b1dfb2b79a$export$8a9b6341a7c96bc; });
$parcel$export(module.exports, "isRgb", function () { return $bb8ea8b1dfb2b79a$export$e698776ec826343; });
$parcel$export(module.exports, "rgbToHex", function () { return $bb8ea8b1dfb2b79a$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "hexToRgba", function () { return $bb8ea8b1dfb2b79a$export$9665a07d9187b414; });

var $9q1kH = parcelRequire("9q1kH");

var $37Fk3 = parcelRequire("37Fk3");
var $bb8ea8b1dfb2b79a$export$4b84fd0e2c617bd = "#FFEBE6";
var $bb8ea8b1dfb2b79a$export$b34b069eff244586 = "#FFBDAD";
var $bb8ea8b1dfb2b79a$export$be802dd0d8b57f35 = "#FF8F73";
var $bb8ea8b1dfb2b79a$export$4a7404f376229999 = "#FF5630";
var $bb8ea8b1dfb2b79a$export$2010d0fb4295b346 = "#DE350B";
var $bb8ea8b1dfb2b79a$export$2837b5a1a71d5c02 = "#BF2600";
var $bb8ea8b1dfb2b79a$export$8d9596b529bbb9cf = "#FFFAE6";
var $bb8ea8b1dfb2b79a$export$41060a744ab0b7ae = "#FFF0B3";
var $bb8ea8b1dfb2b79a$export$5aae31392d72caaa = "#FFC400";
var $bb8ea8b1dfb2b79a$export$59619663aa6500fb = "#FF991F";
var $bb8ea8b1dfb2b79a$export$874739ea9e379ab6 = "#FF8B00";
var $bb8ea8b1dfb2b79a$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $bb8ea8b1dfb2b79a$export$69a3bf21b9686c2b = "#ABF5D1";
var $bb8ea8b1dfb2b79a$export$747d86715d4175de = "#57D9A3";
var $bb8ea8b1dfb2b79a$export$940e1f69e873f202 = "#36B37E";
var $bb8ea8b1dfb2b79a$export$a49394138f7b8e85 = "#00875A";
var $bb8ea8b1dfb2b79a$export$6fa04827ac68a4fb = "#006644";
var $bb8ea8b1dfb2b79a$export$226de0355ed012f8 = "#DEEBFF";
var $bb8ea8b1dfb2b79a$export$8c13c2ee36917869 = "#B3D4FF";
var $bb8ea8b1dfb2b79a$export$ecfc1dff386a3e7a = "#4C9AFF";
var $bb8ea8b1dfb2b79a$export$b3de0ae08da2ce64 = "#0052CC";
var $bb8ea8b1dfb2b79a$export$a6ee3d71bc067634 = "#0747A6";
var $bb8ea8b1dfb2b79a$export$f72948ef771f6f15 = "#D3F1A7";
var $bb8ea8b1dfb2b79a$export$29a4f05edc054374 = "#FFFFFF";
var $bb8ea8b1dfb2b79a$export$9fdfb749e33cdf97 = "#F4F5F7";
var $bb8ea8b1dfb2b79a$export$3e51e8f1440314ba = "#EBECF0";
var $bb8ea8b1dfb2b79a$export$1ce2d1575d444ceb = "#DFE1E6";
var $bb8ea8b1dfb2b79a$export$8754fc7e6d8b3000 = "#C1C7D0";
var $bb8ea8b1dfb2b79a$export$c2e91cbeada39b8b = "#B3BAC5";
var $bb8ea8b1dfb2b79a$export$eaa8c8a70ac22806 = "#97A0AF";
var $bb8ea8b1dfb2b79a$export$7c87d337fb91a97d = "#8993A4";
var $bb8ea8b1dfb2b79a$export$f563ee71e9ee74cd = "#6B778C";
var $bb8ea8b1dfb2b79a$export$e2ef2124cf4024b1 = "#5E6C84";
var $bb8ea8b1dfb2b79a$export$1ae1cebe22dcedb4 = "#DCDFE4";
var $bb8ea8b1dfb2b79a$export$13609db0e6812ab8 = "#091E4224";
var $bb8ea8b1dfb2b79a$export$c39c0fe0f26207ae = "#42526E";
var $bb8ea8b1dfb2b79a$export$7090862dc3038a9f = "#758195";
var $bb8ea8b1dfb2b79a$export$7d61b15e0da132af = "#172B4D";
var $bb8ea8b1dfb2b79a$export$f78789c8b01753cd = "#172B4D";
var $bb8ea8b1dfb2b79a$export$a19f0c33186f7767 = "#FDD0EC";
var $bb8ea8b1dfb2b79a$export$51716a84e62e022c = "#FEDEC8";
var $bb8ea8b1dfb2b79a$export$363e4475840015bb = "#EAE6FF";
var $bb8ea8b1dfb2b79a$export$4b0a4417ed59760f = "#C0B6F2";
var $bb8ea8b1dfb2b79a$export$6011520a64d9a187 = "#998DD9";
var $bb8ea8b1dfb2b79a$export$a7175d4e9206bc80 = "#DFD8FD";
var $bb8ea8b1dfb2b79a$export$b48405b95304b5a1 = "#6554C0";
var $bb8ea8b1dfb2b79a$export$c71e4279dd54a18d = "#5243AA";
var $bb8ea8b1dfb2b79a$export$147899de772240ec = "#403294";
var $bb8ea8b1dfb2b79a$export$2cf711fe14c66f06 = "#E6FCFF";
var $bb8ea8b1dfb2b79a$export$7a8f4d33f6f9772c = "#B3F5FF";
var $bb8ea8b1dfb2b79a$export$776c9c497ef08533 = "#79E2F2";
var $bb8ea8b1dfb2b79a$export$69cb3ca10c1e330e = "#C6EDFB";
var $bb8ea8b1dfb2b79a$export$9dc1ef0f3f48059b = "#00B8D9";
var $bb8ea8b1dfb2b79a$export$6036577f95c3877e = "#008DA6";
function $bb8ea8b1dfb2b79a$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($bb8ea8b1dfb2b79a$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split("").map(function(c) {
            return c === "#" ? "#" : "".concat(c).concat(c);
        }).join("");
    } else if ($bb8ea8b1dfb2b79a$export$e698776ec826343(color)) return $bb8ea8b1dfb2b79a$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === "default") return null;
        else if ($37Fk3.default && $37Fk3.default[color]) color = $37Fk3.default[color];
        else if ($37Fk3 && $37Fk3[color]) color = $37Fk3[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $bb8ea8b1dfb2b79a$export$5a544e13ad4e1fa5(color) {
    if (!$bb8ea8b1dfb2b79a$export$8a9b6341a7c96bc(color)) return null;
    var colorBits = color.substring(1).split("");
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    var rgb = Number("0x".concat(colorBits.join("")));
    // eslint-disable-next-line no-bitwise
    return "rgb(".concat(rgb >> 16 & 255, ",").concat(rgb >> 8 & 255, ",").concat(rgb & 255, ")");
}
function $bb8ea8b1dfb2b79a$export$9665a07d9187b414(rawColor, alpha) {
    var color = $bb8ea8b1dfb2b79a$export$b61655071712e690(rawColor);
    if (!color) return null;
    var hex2rgb = function hex2rgb(color) {
        return color.match(/[a-z0-9]{2}/gi).map(function(hex) {
            return parseInt(hex, 16);
        });
    };
    return "rgba(".concat(hex2rgb(color).concat(alpha).join(","), ")");
}
function $bb8ea8b1dfb2b79a$export$34d09c4a771c46ef(value) {
    var matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        var _matches$map = matches.map(Number), _matches$map2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_matches$map, 3), red = _matches$map2[0], green = _matches$map2[1], blue = _matches$map2[2];
        return "#" + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $bb8ea8b1dfb2b79a$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $bb8ea8b1dfb2b79a$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});
parcelRegister("37Fk3", function(module, exports) {
module.exports = JSON.parse('{"aliceblue":"#f0f8ff","antiquewhite":"#faebd7","aqua":"#00ffff","aquamarine":"#7fffd4","azure":"#f0ffff","beige":"#f5f5dc","bisque":"#ffe4c4","black":"#000000","blanchedalmond":"#ffebcd","blue":"#0000ff","blueviolet":"#8a2be2","brown":"#a52a2a","burlywood":"#deb887","cadetblue":"#5f9ea0","chartreuse":"#7fff00","chocolate":"#d2691e","coral":"#ff7f50","cornflowerblue":"#6495ed","cornsilk":"#fff8dc","crimson":"#dc143c","cyan":"#00ffff","darkblue":"#00008b","darkcyan":"#008b8b","darkgoldenrod":"#b8860b","darkgray":"#a9a9a9","darkgreen":"#006400","darkgrey":"#a9a9a9","darkkhaki":"#bdb76b","darkmagenta":"#8b008b","darkolivegreen":"#556b2f","darkorange":"#ff8c00","darkorchid":"#9932cc","darkred":"#8b0000","darksalmon":"#e9967a","darkseagreen":"#8fbc8f","darkslateblue":"#483d8b","darkslategray":"#2f4f4f","darkslategrey":"#2f4f4f","darkturquoise":"#00ced1","darkviolet":"#9400d3","deeppink":"#ff1493","deepskyblue":"#00bfff","dimgray":"#696969","dimgrey":"#696969","dodgerblue":"#1e90ff","firebrick":"#b22222","floralwhite":"#fffaf0","forestgreen":"#228b22","fuchsia":"#ff00ff","gainsboro":"#dcdcdc","ghostwhite":"#f8f8ff","gold":"#ffd700","goldenrod":"#daa520","gray":"#808080","green":"#008000","greenyellow":"#adff2f","grey":"#808080","honeydew":"#f0fff0","hotpink":"#ff69b4","indianred":"#cd5c5c","indigo":"#4b0082","ivory":"#fffff0","khaki":"#f0e68c","lavender":"#e6e6fa","lavenderblush":"#fff0f5","lawngreen":"#7cfc00","lemonchiffon":"#fffacd","lightblue":"#add8e6","lightcoral":"#f08080","lightcyan":"#e0ffff","lightgoldenrodyellow":"#fafad2","lightgray":"#d3d3d3","lightgreen":"#90ee90","lightgrey":"#d3d3d3","lightpink":"#ffb6c1","lightsalmon":"#ffa07a","lightseagreen":"#20b2aa","lightskyblue":"#87cefa","lightslategray":"#778899","lightslategrey":"#778899","lightsteelblue":"#b0c4de","lightyellow":"#ffffe0","lime":"#00ff00","limegreen":"#32cd32","linen":"#faf0e6","magenta":"#ff00ff","maroon":"#800000","mediumaquamarine":"#66cdaa","mediumblue":"#0000cd","mediumorchid":"#ba55d3","mediumpurple":"#9370db","mediumseagreen":"#3cb371","mediumslateblue":"#7b68ee","mediumspringgreen":"#00fa9a","mediumturquoise":"#48d1cc","mediumvioletred":"#c71585","midnightblue":"#191970","mintcream":"#f5fffa","mistyrose":"#ffe4e1","moccasin":"#ffe4b5","navajowhite":"#ffdead","navy":"#000080","oldlace":"#fdf5e6","olive":"#808000","olivedrab":"#6b8e23","orange":"#ffa500","orangered":"#ff4500","orchid":"#da70d6","palegoldenrod":"#eee8aa","palegreen":"#98fb98","paleturquoise":"#afeeee","palevioletred":"#db7093","papayawhip":"#ffefd5","peachpuff":"#ffdab9","peru":"#cd853f","pink":"#ffc0cb","plum":"#dda0dd","powderblue":"#b0e0e6","purple":"#800080","rebeccapurple":"#663399","red":"#ff0000","rosybrown":"#bc8f8f","royalblue":"#4169e1","saddlebrown":"#8b4513","salmon":"#fa8072","sandybrown":"#f4a460","seagreen":"#2e8b57","seashell":"#fff5ee","sienna":"#a0522d","silver":"#c0c0c0","skyblue":"#87ceeb","slateblue":"#6a5acd","slategray":"#708090","slategrey":"#708090","snow":"#fffafa","springgreen":"#00ff7f","steelblue":"#4682b4","tan":"#d2b48c","teal":"#008080","thistle":"#d8bfd8","tomato":"#ff6347","turquoise":"#40e0d0","violet":"#ee82ee","wheat":"#f5deb3","white":"#ffffff","whitesmoke":"#f5f5f5","yellow":"#ffff00","yellowgreen":"#9acd32"}');

});


parcelRegister("f2zQv", function(module, exports) {

$parcel$export(module.exports, "colorPalette", function () { return $af32d927cf1760e3$export$569885e57444f84a; });
$parcel$export(module.exports, "getGlobalTheme", function () { return $af32d927cf1760e3$export$813ecdf77207a053; });
$parcel$export(module.exports, "textColor", function () { return $af32d927cf1760e3$export$32f78bffcd82ff28; });

var $kFnE9 = parcelRequire("kFnE9");

var $9q1kH = parcelRequire("9q1kH");

var $Pbuln = parcelRequire("Pbuln");

var $2Uu7f = parcelRequire("2Uu7f");

var $g6muZ = parcelRequire("g6muZ");

var $eD4GP = parcelRequire("eD4GP");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
var $af32d927cf1760e3$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $g6muZ.B500),
        "Dark blue"
    ],
    // Chore coat
    [
        (0, $g6muZ.T500),
        "Dark teal"
    ],
    // Shabby chic
    [
        (0, $g6muZ.G500),
        "Dark green"
    ],
    // Keen green
    [
        (0, $g6muZ.Y400),
        "Orange"
    ],
    // Cheezy blasters
    [
        (0, $g6muZ.R500),
        "Dark red"
    ],
    // Dragon's blood
    [
        (0, $g6muZ.P500),
        "Dark purple"
    ],
    // Prince
    // row 2
    [
        (0, $g6muZ.N80),
        "Light gray"
    ],
    // Spooky ghost
    [
        (0, $g6muZ.B100),
        "Blue"
    ],
    // Arvo breeze
    [
        (0, $g6muZ.T300),
        "Teal"
    ],
    // Tamarama
    [
        (0, $g6muZ.G300),
        "Green"
    ],
    // Fine pine
    [
        (0, $g6muZ.Y200),
        "Yellow"
    ],
    // Pub mix
    [
        (0, $g6muZ.R300),
        "Red"
    ],
    // Poppy surprise
    [
        (0, $g6muZ.P300),
        "Purple"
    ],
    // Da' juice
    // row 3
    [
        (0, $g6muZ.N0),
        "White"
    ],
    [
        (0, $g6muZ.B75),
        "Light blue"
    ],
    // Schwag
    [
        (0, $g6muZ.T75),
        "Light teal"
    ],
    // Arctic chill
    [
        (0, $g6muZ.G75),
        "Light green"
    ],
    // Mintie
    [
        (0, $g6muZ.Y75),
        "Light yellow"
    ],
    // Dandelion whisper
    [
        (0, $g6muZ.R75),
        "Light red"
    ],
    // Bondi sunburn
    [
        (0, $g6muZ.P50),
        "Light purple"
    ] // Lavender secret
];
var $af32d927cf1760e3$export$569885e57444f84a = new Map();
var $af32d927cf1760e3$export$81e5ed9e84fe2e28 = $af32d927cf1760e3$export$569885e57444f84a;
$af32d927cf1760e3$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $af32d927cf1760e3$export$569885e57444f84a.set(color.toLowerCase(), label);
});
// these are for test only
var $af32d927cf1760e3$var$testGlobalTheme;
var $af32d927cf1760e3$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $af32d927cf1760e3$var$testGlobalTheme = theme;
};
var $af32d927cf1760e3$export$813ecdf77207a053 = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($af32d927cf1760e3$var$testGlobalTheme) return {
        colorMode: $af32d927cf1760e3$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute("data-color-mode") || "";
    return {
        colorMode: colorMode
    };
};
var $af32d927cf1760e3$export$32f78bffcd82ff28 = {
    attrs: {
        color: {}
    },
    inclusive: true,
    group: (0, $2Uu7f.COLOR),
    parseDOM: [
        {
            style: "color",
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $g6muZ.rgbToHex)(value);
                else if (value[0] === "#") hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $af32d927cf1760e3$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: ".fabric-text-color-mark",
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $af32d927cf1760e3$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $Pbuln.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($af32d927cf1760e3$export$813ecdf77207a053().colorMode === "dark") // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $eD4GP.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            "span",
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({
                class: "fabric-text-color-mark",
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, "data-text-custom-color", mark.attrs.color)
        ];
    }
};

});
parcelRegister("eD4GP", function(module, exports) {

$parcel$export(module.exports, "getDarkModeLCHColor", function () { return $aa68587ef874071a$export$a5065c3b8aacaf99; });
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
var $aa68587ef874071a$var$clamp = function clamp(i, min, max) {
    return Math.round(Math.min(Math.max(i, min), max));
};
var $aa68587ef874071a$var$expandShorthandHex = function expandShorthandHex(input) {
    return input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });
};
var $aa68587ef874071a$var$rgbFromHex = function rgbFromHex(input) {
    var fullHex = $aa68587ef874071a$var$expandShorthandHex(input);
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
var $aa68587ef874071a$var$rgbToHex = function rgbToHex(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    var convertComponent = function convertComponent(c) {
        var cBase16 = c.toString(16);
        return cBase16.length === 1 ? "0".concat(cBase16) : cBase16;
    };
    return "#".concat(convertComponent(r)).concat(convertComponent(g)).concat(convertComponent(b));
};
var $aa68587ef874071a$var$rgbToXyz = function rgbToXyz(rgb) {
    var convertRgbComponent = function convertRgbComponent(c) {
        return c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    };
    var convertXyzComponent = function convertXyzComponent(c) {
        return c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    };
    var r = convertRgbComponent(rgb.r / 255);
    var g = convertRgbComponent(rgb.g / 255);
    var b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
var $aa68587ef874071a$var$xyzToLab = function xyzToLab(_ref2) {
    var x = _ref2.x, y = _ref2.y, z = _ref2.z;
    return {
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    };
};
var $aa68587ef874071a$var$labToLch = function labToLch(_ref3) {
    var l = _ref3.l, a = _ref3.a, b = _ref3.b;
    var h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    var c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
var $aa68587ef874071a$var$lchToLab = function lchToLab(_ref4) {
    var l = _ref4.l, c = _ref4.c, h = _ref4.h;
    var convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
var $aa68587ef874071a$var$labToXyz = function labToXyz(_ref5) {
    var l = _ref5.l, a = _ref5.a, b = _ref5.b;
    var convertComponent = function convertComponent(c) {
        return c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    };
    var y = (l + 16) / 116;
    var x = a / 500 + y;
    var z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
var $aa68587ef874071a$var$xyzToRgb = function xyzToRgb(_ref6) {
    var x = _ref6.x, y = _ref6.y, z = _ref6.z;
    var convertComponent = function convertComponent(c) {
        return 255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    };
    return {
        r: $aa68587ef874071a$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $aa68587ef874071a$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $aa68587ef874071a$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
var $aa68587ef874071a$var$rgbToLch = function rgbToLch(rgb) {
    return $aa68587ef874071a$var$labToLch($aa68587ef874071a$var$xyzToLab($aa68587ef874071a$var$rgbToXyz(rgb)));
};
var $aa68587ef874071a$var$lchToRgb = function lchToRgb(lch) {
    return $aa68587ef874071a$var$xyzToRgb($aa68587ef874071a$var$labToXyz($aa68587ef874071a$var$lchToLab(lch)));
};
var $aa68587ef874071a$export$313b8a8fcb34c3b8 = function clampLightness(color, newPercent) {
    var rgb = $aa68587ef874071a$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    var lch = $aa68587ef874071a$var$rgbToLch(rgb);
    lch.l = $aa68587ef874071a$var$clamp(newPercent, 0, 100);
    return $aa68587ef874071a$var$rgbToHex($aa68587ef874071a$var$lchToRgb(lch));
};
var $aa68587ef874071a$var$getLightness = function getLightness(color) {
    var rgb = $aa68587ef874071a$var$rgbFromHex(color);
    if (rgb === null) return 0;
    var lch = $aa68587ef874071a$var$rgbToLch(rgb);
    return lch.l;
};
var $aa68587ef874071a$export$a5065c3b8aacaf99 = function getDarkModeLCHColor(currentBackgroundColor) {
    var lightness = $aa68587ef874071a$var$getLightness(currentBackgroundColor);
    var newLightness = Math.abs(100 - lightness);
    return $aa68587ef874071a$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});



parcelRegister("dTp2k", function(module, exports) {

$parcel$export(module.exports, "borderColorPalette", function () { return $a1d3d527c700c613$export$e4e044c989c86ca7; });
$parcel$export(module.exports, "border", function () { return $a1d3d527c700c613$export$1edee58a52776cd9; });

var $9q1kH = parcelRequire("9q1kH");

var $Pbuln = parcelRequire("Pbuln");

var $g6muZ = parcelRequire("g6muZ");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ var $a1d3d527c700c613$var$borderColorArrayPalette = [
    [
        (0, $g6muZ.N300A),
        "Subtle gray"
    ],
    [
        (0, $g6muZ.N600),
        "Gray"
    ],
    [
        (0, $g6muZ.N1000),
        "Bold gray"
    ]
];
var $a1d3d527c700c613$export$e4e044c989c86ca7 = new Map();
$a1d3d527c700c613$var$borderColorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $a1d3d527c700c613$export$e4e044c989c86ca7.set(color.toLowerCase(), label);
});
var $a1d3d527c700c613$export$1edee58a52776cd9 = {
    inclusive: false,
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: function getAttrs(domNode) {
                var _dom$getAttribute, _dom$getAttribute2;
                var dom = domNode;
                var color = ((_dom$getAttribute = dom.getAttribute("data-color")) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : "").toLowerCase();
                var size = +((_dom$getAttribute2 = dom.getAttribute("data-size")) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : "0");
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $a1d3d527c700c613$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    attrs: {
        color: {},
        size: {}
    },
    toDOM: function toDOM(mark, isInline) {
        var wrapperStyle = isInline ? "span" : "div";
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        var paletteColorValue = (0, $Pbuln.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                "data-mark-type": "border",
                "data-color": mark.attrs.color,
                "data-size": mark.attrs.size,
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }
        ];
    }
};

});

parcelRegister("dgm2E", function(module, exports) {

$parcel$export(module.exports, "breakout", function () { return $9a7dddff7815e220$export$89015c65f1c75e3f; });
var $9a7dddff7815e220$var$allowedTypes = [
    "wide",
    "full-width"
];
var $9a7dddff7815e220$export$89015c65f1c75e3f = {
    spanning: false,
    inclusive: false,
    parseDOM: [
        {
            tag: "div.fabric-editor-breakout-mark",
            getAttrs: function getAttrs(dom) {
                var mode = dom.getAttribute("data-mode");
                return {
                    mode: $9a7dddff7815e220$var$allowedTypes.indexOf(mode || "") === -1 ? "wide" : mode
                };
            }
        }
    ],
    attrs: {
        mode: {
            default: "wide"
        }
    },
    toDOM: function toDOM(mark) {
        return [
            "div",
            {
                class: "fabric-editor-breakout-mark",
                "data-mode": mark.attrs.mode
            },
            0
        ];
    }
};

});

parcelRegister("hWxmk", function(module, exports) {

$parcel$export(module.exports, "code", function () { return $d101baddf728b58e$export$6565f9f03506010b; });

var $2Uu7f = parcelRequire("2Uu7f");
var $d101baddf728b58e$export$6565f9f03506010b = {
    excludes: "".concat((0, $2Uu7f.FONT_STYLE), " ").concat((0, $2Uu7f.LINK), " ").concat((0, $2Uu7f.SEARCH_QUERY), " ").concat((0, $2Uu7f.COLOR)),
    inclusive: true,
    parseDOM: [
        {
            tag: "span.code",
            preserveWhitespace: true
        },
        {
            tag: "code",
            preserveWhitespace: true
        },
        {
            tag: "tt",
            preserveWhitespace: true
        },
        {
            tag: "span",
            preserveWhitespace: true,
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === "pre") return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf("monospace") >= 0) return {};
                return false;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            "span",
            {
                class: "code",
                spellcheck: "false"
            }
        ];
    }
};

});

parcelRegister("4hACo", function(module, exports) {

$parcel$export(module.exports, "confluenceInlineComment", function () { return $31e5278db68e5951$export$f3b72f8fc4684ecd; });
/**
 * @name inline_comment_marker
 * @description This temporary mark represents a Confluence-backed inline comment that wraps a piece of text. It will be replaced with a cross-product inline comment solution at later date.
 */ var $31e5278db68e5951$export$f3b72f8fc4684ecd = {
    inclusive: false,
    excludes: "",
    attrs: {
        reference: {
            default: ""
        }
    },
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "span",
            {
                "data-mark-type": "confluenceInlineComment",
                "data-reference": node.attrs.reference
            }
        ];
    }
};

});

parcelRegister("gD0YM", function(module, exports) {

$parcel$export(module.exports, "dataConsumer", function () { return $c1b10c51c1fed937$export$3024f02c495408d6; });
$parcel$export(module.exports, "toJSON", function () { return $c1b10c51c1fed937$export$54fd2c36b5cc6731; });

var $kFnE9 = parcelRequire("kFnE9");

var $7ZHvS = parcelRequire("7ZHvS");
function $c1b10c51c1fed937$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c1b10c51c1fed937$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c1b10c51c1fed937$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c1b10c51c1fed937$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ var $c1b10c51c1fed937$var$parseDataConsumer = function parseDataConsumer(maybeValue) {
    var sources = (0, $7ZHvS.isDOMElement)(maybeValue) && maybeValue.getAttribute("data-sources");
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch (_unused) {
        return false;
    }
};
var $c1b10c51c1fed937$export$3024f02c495408d6 = {
    attrs: {
        sources: {
            default: []
        }
    },
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: function getAttrs(maybeValue) {
                return $c1b10c51c1fed937$var$parseDataConsumer(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? "span" : "div";
        return [
            wrapperStyle,
            {
                "data-mark-type": "dataConsumer",
                "data-sources": JSON.stringify(mark.attrs.sources)
            }
        ];
    }
};
var $c1b10c51c1fed937$export$54fd2c36b5cc6731 = function toJSON(mark) {
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter(function(key) {
            return key === "sources" && mark.attrs[key].length > 0 && mark.attrs[key] !== null;
        }).reduce(function(acc, key) {
            return $c1b10c51c1fed937$var$_objectSpread($c1b10c51c1fed937$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, key, mark.attrs[key]));
        }, {})
    };
};

});
parcelRegister("7ZHvS", function(module, exports) {

$parcel$export(module.exports, "isDOMElement", function () { return $5d1ffbb75046f713$export$c296e2d4365c37a5; });
var $5d1ffbb75046f713$export$c296e2d4365c37a5 = function isDOMElement(maybeNode) {
    return maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;
};

});


parcelRegister("dvQ3b", function(module, exports) {

$parcel$export(module.exports, "em", function () { return $9d668bbc4928f550$export$c63c6f932822f543; });

var $2Uu7f = parcelRequire("2Uu7f");
/**
 * @name em_mark
 */ var $9d668bbc4928f550$var$emDOM = [
    "em"
];
var $9d668bbc4928f550$export$c63c6f932822f543 = {
    inclusive: true,
    group: (0, $2Uu7f.FONT_STYLE),
    parseDOM: [
        {
            tag: "i"
        },
        {
            tag: "em"
        },
        {
            style: "font-style=italic"
        }
    ],
    toDOM: function toDOM() {
        return $9d668bbc4928f550$var$emDOM;
    }
};

});

parcelRegister("fngjO", function(module, exports) {

$parcel$export(module.exports, "fragment", function () { return $b315a9891068fcd3$export$f00aeb236b6f05af; });
$parcel$export(module.exports, "toJSON", function () { return $b315a9891068fcd3$export$54fd2c36b5cc6731; });

var $kFnE9 = parcelRequire("kFnE9");

var $7ZHvS = parcelRequire("7ZHvS");
function $b315a9891068fcd3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b315a9891068fcd3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b315a9891068fcd3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b315a9891068fcd3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ var $b315a9891068fcd3$var$parseFragment = function parseFragment(maybeValue) {
    var _maybeValue$getAttrib;
    if (!(0, $7ZHvS.isDOMElement)(maybeValue)) return false;
    var name = (_maybeValue$getAttrib = maybeValue.getAttribute("data-name")) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    var localId = maybeValue.getAttribute("data-localId");
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
var $b315a9891068fcd3$export$f00aeb236b6f05af = {
    inclusive: false,
    excludes: "",
    attrs: {
        localId: {
            default: ""
        },
        name: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: function getAttrs(maybeValue) {
                return $b315a9891068fcd3$var$parseFragment(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? "span" : "div";
        return [
            wrapperStyle,
            {
                "data-mark-type": "fragment",
                "data-name": mark.attrs.name,
                "data-localId": mark.attrs.localId
            }
        ];
    }
};
var $b315a9891068fcd3$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: $b315a9891068fcd3$var$_objectSpread({
            localId: mark.attrs.localId
        }, mark.attrs.name ? {
            name: mark.attrs.name
        } : {})
    };
};

});

parcelRegister("30dKh", function(module, exports) {

$parcel$export(module.exports, "indentation", function () { return $22fc08bbf14a06a9$export$480c699bd4ec0d86; });

var $2Uu7f = parcelRequire("2Uu7f");
var $22fc08bbf14a06a9$export$480c699bd4ec0d86 = {
    excludes: "indentation ".concat((0, $2Uu7f.ALIGNMENT)),
    group: (0, $2Uu7f.INDENTATION),
    attrs: {
        level: {}
    },
    parseDOM: [
        {
            tag: "div.fabric-editor-indentation-mark",
            getAttrs: function getAttrs(dom) {
                var level = +(dom.getAttribute("data-level") || "0");
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            "div",
            {
                class: "fabric-editor-block-mark fabric-editor-indentation-mark",
                "data-level": mark.attrs.level
            },
            0
        ];
    }
};

});

parcelRegister("3BmiG", function(module, exports) {

$parcel$export(module.exports, "link", function () { return $29f620289855d53e$export$9c30223ca0a664fb; });
$parcel$export(module.exports, "toJSON", function () { return $29f620289855d53e$export$54fd2c36b5cc6731; });

var $kFnE9 = parcelRequire("kFnE9");

var $2Uu7f = parcelRequire("2Uu7f");

var $li0Vj = parcelRequire("li0Vj");
function $29f620289855d53e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $29f620289855d53e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $29f620289855d53e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $29f620289855d53e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name link_mark
 */ var $29f620289855d53e$var$getLinkAttrs = function getLinkAttrs(attribute) {
    return function(domNode) {
        var dom = domNode;
        var href = dom.getAttribute(attribute) || "";
        var attrs = {
            __confluenceMetadata: dom.hasAttribute("__confluenceMetadata") ? JSON.parse(dom.getAttribute("__confluenceMetadata") || "") : undefined
        };
        if (!(0, $li0Vj.isSafeUrl)(href)) return false;
        if ((0, $li0Vj.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $li0Vj.normalizeUrl)(href);
        return attrs;
    };
};
var $29f620289855d53e$export$9c30223ca0a664fb = {
    excludes: "".concat((0, $2Uu7f.LINK)),
    // ED-5844 No multiple links in media node
    group: (0, $2Uu7f.LINK),
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    parseDOM: [
        {
            tag: "[data-block-link]",
            getAttrs: $29f620289855d53e$var$getLinkAttrs("data-block-link"),
            contentElement: function contentElement(node) {
                var clone = node.cloneNode(true);
                clone.removeAttribute("data-block-link");
                clone.setAttribute("data-skip-paste", "true");
                var wrapper = document.createElement("div");
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: "a[href]",
            getAttrs: $29f620289855d53e$var$getLinkAttrs("href")
        }
    ],
    toDOM: function toDOM(node, isInline) {
        var attrs = Object.keys(node.attrs).reduce(function(attrs, key) {
            if (key === "__confluenceMetadata") {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === "href") attrs[key] = (0, $li0Vj.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            "a",
            attrs
        ];
        return [
            "a",
            $29f620289855d53e$var$_objectSpread($29f620289855d53e$var$_objectSpread({}, attrs), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, "data-block-link", "true"), "class", "blockLink")),
            0
        ];
    }
};
var $29f620289855d53e$var$OPTIONAL_ATTRS = [
    "title",
    "id",
    "collection",
    "occurrenceKey",
    "__confluenceMetadata"
];
var $29f620289855d53e$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce(function(attrs, key) {
            if ($29f620289855d53e$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    };
};

});
parcelRegister("li0Vj", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", function () { return $f7fbfec6bdd02344$export$c9f92f5469372e0f; });
$parcel$export(module.exports, "linkify", function () { return $f7fbfec6bdd02344$export$8ccbde94d5c7f8e7; });
$parcel$export(module.exports, "linkifyMatch", function () { return $f7fbfec6bdd02344$export$6f7d7761b97f967; });
$parcel$export(module.exports, "getLinkMatch", function () { return $f7fbfec6bdd02344$export$ce9ae45aed3e4ec; });
$parcel$export(module.exports, "normalizeUrl", function () { return $f7fbfec6bdd02344$export$6535eb414fa2c8b6; });
$parcel$export(module.exports, "isRootRelative", function () { return $f7fbfec6bdd02344$export$23579274a7a24f7b; });
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $7X0iq = parcelRequire("7X0iq");
var $f7fbfec6bdd02344$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
var $f7fbfec6bdd02344$export$c9f92f5469372e0f = function isSafeUrl(url) {
    var urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $f7fbfec6bdd02344$var$whitelistedURLPatterns.some(function(p) {
        return p.test(urlTrimmed);
    });
};
var $f7fbfec6bdd02344$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($7X0iq)))();
$f7fbfec6bdd02344$export$8ccbde94d5c7f8e7.add("sourcetree:", "http:");
$f7fbfec6bdd02344$export$8ccbde94d5c7f8e7.add("jamfselfservice:", "http:");
var $f7fbfec6bdd02344$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$f7fbfec6bdd02344$export$8ccbde94d5c7f8e7.add("tel:", $f7fbfec6bdd02344$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$f7fbfec6bdd02344$export$8ccbde94d5c7f8e7.add("file:", $f7fbfec6bdd02344$var$urlWithoutSpacesValidator);
$f7fbfec6bdd02344$export$8ccbde94d5c7f8e7.add("notes:", "http:");
var $f7fbfec6bdd02344$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split("|");
var $f7fbfec6bdd02344$var$tlds2Char = "a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]";
$f7fbfec6bdd02344$var$tlds.push($f7fbfec6bdd02344$var$tlds2Char);
$f7fbfec6bdd02344$export$8ccbde94d5c7f8e7.tlds($f7fbfec6bdd02344$var$tlds, false);
var $f7fbfec6bdd02344$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
var $f7fbfec6bdd02344$export$6f7d7761b97f967 = function linkifyMatch(text) {
    if (!$f7fbfec6bdd02344$export$746d02eae03c72e1.test(text)) return [];
    var matches = [];
    var startpos = 0;
    var substr;
    while(substr = text.substr(startpos)){
        var link = (substr.match($f7fbfec6bdd02344$export$746d02eae03c72e1) || [
            ""
        ])[0];
        if (link) {
            var index = substr.search($f7fbfec6bdd02344$export$746d02eae03c72e1);
            var start = index >= 0 ? index + startpos : index;
            var end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ""
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $f7fbfec6bdd02344$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    var match = $f7fbfec6bdd02344$export$6f7d7761b97f967(str);
    if (!match.length) match = $f7fbfec6bdd02344$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $f7fbfec6bdd02344$export$6535eb414fa2c8b6(url) {
    var match = $f7fbfec6bdd02344$export$ce9ae45aed3e4ec(url);
    return match && match.url || "";
}
function $f7fbfec6bdd02344$export$23579274a7a24f7b(url) {
    return url.startsWith("/");
}

});
parcelRegister("7X0iq", function(module, exports) {
"use strict";
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $5c9e45e8dd5044ca$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $5c9e45e8dd5044ca$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $5c9e45e8dd5044ca$var$isString(obj) {
    return $5c9e45e8dd5044ca$var$_class(obj) === "[object String]";
}
function $5c9e45e8dd5044ca$var$isObject(obj) {
    return $5c9e45e8dd5044ca$var$_class(obj) === "[object Object]";
}
function $5c9e45e8dd5044ca$var$isRegExp(obj) {
    return $5c9e45e8dd5044ca$var$_class(obj) === "[object RegExp]";
}
function $5c9e45e8dd5044ca$var$isFunction(obj) {
    return $5c9e45e8dd5044ca$var$_class(obj) === "[object Function]";
}
function $5c9e45e8dd5044ca$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
////////////////////////////////////////////////////////////////////////////////
var $5c9e45e8dd5044ca$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $5c9e45e8dd5044ca$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $5c9e45e8dd5044ca$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $5c9e45e8dd5044ca$var$defaultSchemas = {
    "http:": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp("^\\/\\/" + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, "i");
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    "https:": "http:",
    "ftp:": "http:",
    "//": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp("^" + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            "(?:localhost|(?:(?:" + self.re.src_domain + ")\\.)+" + self.re.src_domain_root + ")" + self.re.src_port + self.re.src_host_terminator + self.re.src_path, "i");
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ":") return 0;
                if (pos >= 3 && text[pos - 3] === "/") return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    "mailto:": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp("^" + self.re.src_email_name + "@" + self.re.src_host_strict, "i");
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $5c9e45e8dd5044ca$var$tlds_2ch_src_re = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]";
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $5c9e45e8dd5044ca$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split("|");
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $5c9e45e8dd5044ca$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = "";
}
function $5c9e45e8dd5044ca$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $5c9e45e8dd5044ca$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $5c9e45e8dd5044ca$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("i8zUw"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($5c9e45e8dd5044ca$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join("|");
    function untpl(tpl) {
        return tpl.replace("%TLDS%", re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), "i");
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), "i");
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), "i");
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), "i");
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($5c9e45e8dd5044ca$var$isObject(val)) {
            if ($5c9e45e8dd5044ca$var$isRegExp(val.validate)) compiled.validate = $5c9e45e8dd5044ca$var$createValidator(val.validate);
            else if ($5c9e45e8dd5044ca$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($5c9e45e8dd5044ca$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $5c9e45e8dd5044ca$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($5c9e45e8dd5044ca$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[""] = {
        validate: null,
        normalize: $5c9e45e8dd5044ca$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($5c9e45e8dd5044ca$var$escapeRE).join("|");
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + "))(" + slist + ")", "i");
    self.re.schema_search = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + "))(" + slist + ")", "ig");
    self.re.pretest = RegExp("(" + self.re.schema_test.source + ")|(" + self.re.host_fuzzy_test.source + ")|@", "i");
    //
    // Cleanup
    //
    $5c9e45e8dd5044ca$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $5c9e45e8dd5044ca$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $5c9e45e8dd5044ca$var$createMatch(self, shift) {
    var match = new $5c9e45e8dd5044ca$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $5c9e45e8dd5044ca$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $5c9e45e8dd5044ca$var$LinkifyIt)) return new $5c9e45e8dd5044ca$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($5c9e45e8dd5044ca$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $5c9e45e8dd5044ca$var$assign({}, $5c9e45e8dd5044ca$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = "";
    this.__text_cache__ = "";
    this.__schemas__ = $5c9e45e8dd5044ca$var$assign({}, $5c9e45e8dd5044ca$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $5c9e45e8dd5044ca$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $5c9e45e8dd5044ca$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $5c9e45e8dd5044ca$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $5c9e45e8dd5044ca$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $5c9e45e8dd5044ca$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $5c9e45e8dd5044ca$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $5c9e45e8dd5044ca$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__["http:"]) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = "";
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__["mailto:"]) {
        // guess schemaless emails
        at_pos = text.indexOf("@");
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = "mailto:";
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $5c9e45e8dd5044ca$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $5c9e45e8dd5044ca$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $5c9e45e8dd5044ca$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($5c9e45e8dd5044ca$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($5c9e45e8dd5044ca$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $5c9e45e8dd5044ca$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $5c9e45e8dd5044ca$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $5c9e45e8dd5044ca$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $5c9e45e8dd5044ca$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = "http://" + match.url;
    if (match.schema === "mailto:" && !/^mailto:/i.test(match.url)) match.url = "mailto:" + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $5c9e45e8dd5044ca$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $5c9e45e8dd5044ca$var$LinkifyIt;

});
parcelRegister("i8zUw", function(module, exports) {
"use strict";




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("dt5PY")).source;
    re.src_Cc = (parcelRequire("3MTE5")).source;
    re.src_Z = (parcelRequire("3545k")).source;
    re.src_P = (parcelRequire("9vEM0")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join("|");
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join("|");
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = "[><\uFF5C]";
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = "(?:(?!" + text_separators + "|" + re.src_ZPCc + ")" + re.src_Any + ")";
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)";
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = "(?:(?:(?!" + re.src_ZCc + "|[@/\\[\\]()]).)+@)?";
    re.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?";
    re.src_host_terminator = "(?=$|" + text_separators + "|" + re.src_ZPCc + ")(?!-|_|:\\d|\\.-|\\.(?!$|" + re.src_ZPCc + "))";
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + "|" + text_separators + "|[()[\\]{}.,\"'?!\\-]).|" + "\\[(?:(?!" + re.src_ZCc + "|\\]).)*\\]|" + "\\((?:(?!" + re.src_ZCc + "|[)]).)*\\)|" + "\\{(?:(?!" + re.src_ZCc + "|[}]).)*\\}|" + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + "|[-]).|" + // allow `I'm_king` if no pair found
    "\\.{2,4}[a-zA-Z0-9%/]|" + // github has ... in commit range links,
    // google has .... in links (issue #66)
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    "\\.(?!" + re.src_ZCc + "|[.]).|" + (opts && opts["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" // `---` => long dash, terminate
     : "\\-+|") + "\\,(?!" + re.src_ZCc + ").|" + // allow `,,,` in paths
    "\\!(?!" + re.src_ZCc + "|[!]).|" + "\\?(?!" + re.src_ZCc + "|[?])." + ")+" + "|\\/" + ")?";
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = "xn--[a-z0-9\\-]{1,59}";
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    "(?:" + re.src_xn + "|" + re.src_pseudo_letter + "{1,63}" + ")";
    re.src_domain = "(?:" + re.src_xn + "|" + "(?:" + re.src_pseudo_letter + ")" + "|" + "(?:" + re.src_pseudo_letter + "(?:-|" + re.src_pseudo_letter + "){0,61}" + re.src_pseudo_letter + ")" + ")";
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ")\\.)*" + re.src_domain /*_root*/  + ")" + ")";
    re.tpl_host_fuzzy = "(?:" + re.src_ip4 + "|" + "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))" + ")";
    re.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))";
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + re.src_ZPCc + "|>|$))";
    re.tpl_email_fuzzy = "(^|" + text_separators + '|"|\\(|' + re.src_ZCc + ")" + "(" + re.src_email_name + "@" + re.tpl_host_fuzzy_strict + ")";
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_fuzzy_strict + re.src_path + ")";
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ")";
    return re;
};

});
parcelRegister("dt5PY", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("3MTE5", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("3545k", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});

parcelRegister("9vEM0", function(module, exports) {
module.exports = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});





parcelRegister("81L2N", function(module, exports) {

$parcel$export(module.exports, "strike", function () { return $01821c871fec4c94$export$4899a95d70ec5056; });

var $2Uu7f = parcelRequire("2Uu7f");
var $01821c871fec4c94$export$4899a95d70ec5056 = {
    inclusive: true,
    group: (0, $2Uu7f.FONT_STYLE),
    parseDOM: [
        {
            tag: "strike"
        },
        {
            tag: "s"
        },
        {
            tag: "del"
        },
        {
            style: "text-decoration",
            getAttrs: function getAttrs(value) {
                return value === "line-through" && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            "s"
        ];
    }
};

});

parcelRegister("ajYfX", function(module, exports) {

$parcel$export(module.exports, "strong", function () { return $783a6b5fddc013a7$export$59ae2c325a998f89; });

var $2Uu7f = parcelRequire("2Uu7f");
/**
 * @name strong_mark
 */ var $783a6b5fddc013a7$var$strongDOM = [
    "strong"
];
var $783a6b5fddc013a7$export$59ae2c325a998f89 = {
    inclusive: true,
    group: (0, $2Uu7f.FONT_STYLE),
    parseDOM: [
        {
            tag: "strong"
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: "b",
            getAttrs: function getAttrs(node) {
                var element = node;
                return element.style.fontWeight !== "normal" && null;
            }
        },
        {
            tag: "span",
            getAttrs: function getAttrs(node) {
                var element = node;
                var fontWeight = element.style.fontWeight;
                return typeof fontWeight === "string" && (fontWeight === "bold" || fontWeight === "bolder" || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return $783a6b5fddc013a7$var$strongDOM;
    }
};

});

parcelRegister("rOFHJ", function(module, exports) {

$parcel$export(module.exports, "subsup", function () { return $0539d410a8ec8941$export$b3401ee80eb31041; });

var $2Uu7f = parcelRequire("2Uu7f");
/**
 * @name subsup_mark
 */ function $0539d410a8ec8941$var$getAttrFromVerticalAlign(node) {
    if (node.style.verticalAlign) {
        var type = node.style.verticalAlign.slice(0, 3);
        if (type === "sub" || type === "sup") return {
            type: type
        };
    }
    return false;
}
var $0539d410a8ec8941$export$b3401ee80eb31041 = {
    inclusive: true,
    group: (0, $2Uu7f.FONT_STYLE),
    attrs: {
        type: {
            default: "sub"
        }
    },
    parseDOM: [
        {
            tag: "sub",
            attrs: {
                type: "sub"
            }
        },
        {
            tag: "sup",
            attrs: {
                type: "sup"
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            tag: "span",
            style: "vertical-align=super",
            getAttrs: function getAttrs(node) {
                return $0539d410a8ec8941$var$getAttrFromVerticalAlign(node);
            }
        },
        {
            tag: "span",
            style: "vertical-align=sub",
            getAttrs: function getAttrs(node) {
                return $0539d410a8ec8941$var$getAttrFromVerticalAlign(node);
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            mark.attrs.type
        ];
    }
};

});

parcelRegister("3PgDK", function(module, exports) {

$parcel$export(module.exports, "typeAheadQuery", function () { return $2c930ae186c334c2$export$20af3dabbb5538df; });

var $2Uu7f = parcelRequire("2Uu7f");

var $g6muZ = parcelRequire("g6muZ");
var $2c930ae186c334c2$export$20af3dabbb5538df = {
    inclusive: true,
    group: (0, $2Uu7f.SEARCH_QUERY),
    parseDOM: [
        {
            tag: "span[data-type-ahead-query]"
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "span",
            {
                "data-type-ahead-query": "true",
                "data-trigger": node.attrs.trigger,
                style: "color: ".concat((0, $g6muZ.B400))
            }
        ];
    },
    attrs: {
        trigger: {
            default: ""
        }
    }
};

});

parcelRegister("UK8Dx", function(module, exports) {

$parcel$export(module.exports, "underline", function () { return $0aa9052ec7854d87$export$425327af25286e5e; });

var $2Uu7f = parcelRequire("2Uu7f");
var $0aa9052ec7854d87$export$425327af25286e5e = {
    inclusive: true,
    group: (0, $2Uu7f.FONT_STYLE),
    parseDOM: [
        {
            tag: "u"
        },
        {
            style: "text-decoration",
            getAttrs: function getAttrs(value) {
                return value === "underline" && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            "u"
        ];
    }
};

});

parcelRegister("23a1A", function(module, exports) {

$parcel$export(module.exports, "unsupportedMark", function () { return $17e3a348ad8e1ab1$export$30d78d5eb6719bb8; });
var $17e3a348ad8e1ab1$export$30d78d5eb6719bb8 = {
    toDOM: function toDOM() {
        return [
            "span"
        ];
    },
    excludes: "",
    attrs: {
        originalValue: {}
    }
};

});

parcelRegister("UshAi", function(module, exports) {

$parcel$export(module.exports, "unsupportedNodeAttribute", function () { return $0a9b2b6aa47bc62b$export$a316dc07ff5182a2; });
var $0a9b2b6aa47bc62b$export$a316dc07ff5182a2 = {
    toDOM: function toDOM() {
        return [
            "span"
        ];
    },
    attrs: {
        type: {},
        unsupported: {}
    }
};

});

parcelRegister("3kawi", function(module, exports) {

$parcel$export(module.exports, "blockCard", function () { return $26bb6665bdf893de$export$c4c2f833baaebdb8; });

var $kFnE9 = parcelRequire("kFnE9");
function $26bb6665bdf893de$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $26bb6665bdf893de$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $26bb6665bdf893de$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $26bb6665bdf893de$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name blockCard_node
 */ var $26bb6665bdf893de$var$getCommonAttributesFromDom = function getCommonAttributesFromDom(dom) {
    var anchor = dom;
    var data = anchor.getAttribute("data-card-data");
    var datasource = anchor.getAttribute("data-datasource");
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute("data-layout") || undefined : undefined,
        width: Number(dom.getAttribute("data-width")) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
var $26bb6665bdf893de$export$c4c2f833baaebdb8 = {
    inline: false,
    group: "block",
    draggable: true,
    selectable: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: "a[data-block-card]",
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $26bb6665bdf893de$var$_objectSpread({
                    url: anchor.getAttribute("href") || undefined
                }, $26bb6665bdf893de$var$getCommonAttributesFromDom(dom));
            }
        },
        {
            tag: "div[data-block-card]",
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $26bb6665bdf893de$var$_objectSpread({
                    url: anchor.getAttribute("data-card-url") || undefined
                }, $26bb6665bdf893de$var$getCommonAttributesFromDom(dom));
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var _ref = node.attrs, url = _ref.url;
        var _ref2 = node.attrs, data = _ref2.data;
        var _ref3 = node.attrs, layout = _ref3.layout, width = _ref3.width, datasource = _ref3.datasource;
        var attrs = {
            "data-block-card": "",
            href: url || "",
            "data-card-data": data ? JSON.stringify(data) : "",
            "data-datasource": datasource ? JSON.stringify(datasource) : "",
            "data-layout": layout,
            "data-width": "".concat(width)
        };
        return [
            "a",
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || " "
        ];
    }
};

});

parcelRegister("4M6BM", function(module, exports) {

$parcel$export(module.exports, "blockquote", function () { return $37a0c56594e34356$export$67dc04e652a298ca; });
$parcel$export(module.exports, "blockquoteWithList", function () { return $37a0c56594e34356$export$9b4686c4b9672643; });
/**
 * @name blockquote_node
 */ var $37a0c56594e34356$var$createBlockquoteSpec = function createBlockquoteSpec(allowList) {
    var blockquoteSpec = {
        group: "block",
        defining: true,
        selectable: false,
        parseDOM: [
            {
                tag: "blockquote"
            }
        ],
        toDOM: function toDOM() {
            return [
                "blockquote",
                0
            ];
        }
    };
    if (allowList) blockquoteSpec.content = "(paragraph | orderedList | bulletList | unsupportedBlock)+";
    else blockquoteSpec.content = "(paragraph | unsupportedBlock)+";
    return blockquoteSpec;
};
var $37a0c56594e34356$export$67dc04e652a298ca = $37a0c56594e34356$var$createBlockquoteSpec(false);
var $37a0c56594e34356$export$9b4686c4b9672643 = $37a0c56594e34356$var$createBlockquoteSpec(true);

});

parcelRegister("anHjF", function(module, exports) {

$parcel$export(module.exports, "bodiedExtension", function () { return $78eda70deece4b86$export$27903d543b563e39; });

var $ipPUs = parcelRequire("ipPUs");
/**
 * @name bodiedExtension_node
 */ /**
 * @name bodiedExtension_with_marks_node
 */ var $78eda70deece4b86$var$createBodiedExtensionNodeSpec = function createBodiedExtensionNodeSpec() {
    var nodeSpec = {
        inline: false,
        group: "block",
        marks: "dataConsumer fragment",
        content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | extension | unsupportedBlock | embedCard)+",
        defining: true,
        selectable: true,
        isolating: true,
        attrs: {
            extensionType: {
                default: ""
            },
            extensionKey: {
                default: ""
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            layout: {
                default: "default"
            },
            localId: {
                default: null
            }
        },
        parseDOM: [
            {
                context: "bodiedExtension//",
                tag: '[data-node-type="bodied-extension"]',
                skip: true
            },
            {
                tag: '[data-node-type="bodied-extension"]',
                getAttrs: function getAttrs(domNode) {
                    return (0, $ipPUs.getExtensionAttrs)(domNode);
                }
            }
        ],
        toDOM: function toDOM(node) {
            var attrs = {
                "data-node-type": "bodied-extension",
                "data-extension-type": node.attrs.extensionType,
                "data-extension-key": node.attrs.extensionKey,
                "data-text": node.attrs.text,
                "data-parameters": JSON.stringify(node.attrs.parameters),
                "data-layout": node.attrs.layout,
                "data-local-id:": node.attrs.localId
            };
            return [
                "div",
                attrs,
                0
            ];
        }
    };
    return nodeSpec;
};
var $78eda70deece4b86$export$27903d543b563e39 = $78eda70deece4b86$var$createBodiedExtensionNodeSpec();

});

parcelRegister("652Tk", function(module, exports) {

$parcel$export(module.exports, "bulletListSelector", function () { return $46d573e712abb1b4$export$5f25a39efab3b58b; });
$parcel$export(module.exports, "bulletList", function () { return $46d573e712abb1b4$export$a140c94e5ea26bee; });
var $46d573e712abb1b4$export$5f25a39efab3b58b = ".ak-ul";
var $46d573e712abb1b4$export$a140c94e5ea26bee = {
    group: "block",
    content: "listItem+",
    selectable: false,
    parseDOM: [
        {
            tag: "ul"
        }
    ],
    marks: "unsupportedMark unsupportedNodeAttribute",
    toDOM: function toDOM() {
        var attrs = {
            class: $46d573e712abb1b4$export$5f25a39efab3b58b.substr(1)
        };
        return [
            "ul",
            attrs,
            0
        ];
    }
};

});

parcelRegister("jegNi", function(module, exports) {

$parcel$export(module.exports, "caption", function () { return $dffc5a12b5380462$export$8e3c2dfdc4f0453d; });
/**
 * @name caption_node
 */ var $dffc5a12b5380462$export$8e3c2dfdc4f0453d = {
    content: "(text|hardBreak|mention|emoji|date|placeholder|inlineCard|status|unsupportedInline)*",
    isolating: true,
    marks: "_",
    selectable: false,
    parseDOM: [
        {
            tag: "figcaption[data-caption]"
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            "data-caption": "true"
        };
        return [
            "figcaption",
            attrs,
            0
        ];
    }
};

});

parcelRegister("bKgNx", function(module, exports) {

$parcel$export(module.exports, "codeBlock", function () { return $88d1054cbf5c9f90$export$7bb0d5c671655cc4; });
$parcel$export(module.exports, "toJSON", function () { return $88d1054cbf5c9f90$export$54fd2c36b5cc6731; });

var $1cpUy = parcelRequire("1cpUy");
/**
 * @name codeBlock_node
 */ /**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_with_marks_node
 */ var $88d1054cbf5c9f90$var$getLanguageFromEditorStyle = function getLanguageFromEditorStyle(dom) {
    return dom.getAttribute("data-language") || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
var $88d1054cbf5c9f90$var$getLanguageFromBitbucketStyle = function getLanguageFromBitbucketStyle(dom) {
    if (dom && dom.classList.contains("codehilite")) // code block html from Bitbucket always contains an extra new line
    return $88d1054cbf5c9f90$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
var $88d1054cbf5c9f90$var$getLanguageFromCode = function getLanguageFromCode(dom) {
    var firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === "CODE") return firstChild.getAttribute("data-language") || undefined;
};
var $88d1054cbf5c9f90$var$extractLanguageFromClass = function extractLanguageFromClass(className) {
    var languageRegex = /(?:^|\s)language-([^\s]+)/;
    var result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
var $88d1054cbf5c9f90$var$removeLastNewLine = function removeLastNewLine(dom) {
    var parent = dom && dom.parentElement;
    if (parent && parent.classList.contains("codehilite")) dom.textContent = dom.textContent.replace(/\n$/, "");
    return dom;
};
var $88d1054cbf5c9f90$export$7bb0d5c671655cc4 = {
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    content: "(text | unsupportedInline)*",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    code: true,
    defining: true,
    parseDOM: [
        {
            tag: "pre",
            preserveWhitespace: "full",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var language = $88d1054cbf5c9f90$var$getLanguageFromBitbucketStyle(dom.parentElement) || $88d1054cbf5c9f90$var$getLanguageFromEditorStyle(dom.parentElement) || $88d1054cbf5c9f90$var$getLanguageFromCode(dom) || dom.getAttribute("data-language");
                dom = $88d1054cbf5c9f90$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: "div[style]",
            preserveWhitespace: "full",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === "pre" || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf("monospace") > -1) return {};
                return false;
            },
            // @see ED-5682
            getContent: function getContent(domNode, schema) {
                var dom = domNode;
                var code = Array.from(dom.children).map(function(child) {
                    return child.textContent;
                }).filter(function(x) {
                    return x !== undefined;
                }).join("\n");
                return code ? (0, $1cpUy.Fragment).from(schema.text(code)) : (0, $1cpUy.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: "table[style]",
            preserveWhitespace: "full",
            getAttrs: function getAttrs(dom) {
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: "div.code-block",
            preserveWhitespace: "full",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                var lineNumber = dom.querySelectorAll(".react-syntax-highlighter-line-number");
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach(function(line) {
                    return line.remove();
                });
                return {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "pre",
            [
                "code",
                {
                    "data-language": node.attrs.language
                },
                0
            ]
        ];
    }
};
var $88d1054cbf5c9f90$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(memo, key) {
            if (key === "uniqueId") return memo;
            if (key === "language" && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    };
};

});

parcelRegister("6YGtF", function(module, exports) {

$parcel$export(module.exports, "confluenceJiraIssue", function () { return $51494bd045251fd0$export$daf889beb5092f95; });
var $51494bd045251fd0$var$name = "confluenceJiraIssue";
var $51494bd045251fd0$export$daf889beb5092f95 = {
    group: "inline",
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ""
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'span[data-node-type="'.concat($51494bd045251fd0$var$name, '"]'),
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": $51494bd045251fd0$var$name,
            "data-macro-id": node.attrs.macroId,
            "data-schema-version": node.attrs.schemaVersion,
            "data-server": node.attrs.server,
            "data-server-id": node.attrs.serverId,
            "data-jira-issue": node.attrs.issueKey
        };
        return [
            "span",
            attrs,
            node.attrs.issueKey
        ];
    }
};

});

parcelRegister("gkMID", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedBlock", function () { return $be444e2c01a06ec3$export$e6e4878f43c27cab; });
var $be444e2c01a06ec3$var$name = "confluenceUnsupportedBlock";
var $be444e2c01a06ec3$export$e6e4878f43c27cab = {
    group: "block",
    attrs: {
        cxhtml: {
            default: null
        }
    },
    toDOM: function toDOM(node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        var attrs = {
            "data-node-type": $be444e2c01a06ec3$var$name,
            "data-confluence-unsupported": "block",
            "data-confluence-unsupported-block-cxhtml": node.attrs["cxhtml"]
        };
        return [
            "div",
            attrs,
            "Unsupported content"
        ];
    },
    parseDOM: [
        {
            tag: 'div[data-node-type="'.concat($be444e2c01a06ec3$var$name, '"]'),
            getAttrs: function getAttrs(dom) {
                return {
                    cxhtml: dom.getAttribute("data-confluence-unsupported-block-cxhtml")
                };
            }
        }
    ]
};

});

parcelRegister("kd1cJ", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedInline", function () { return $eb65f4ade245d09c$export$3e6d667072febc87; });
var $eb65f4ade245d09c$var$name = "confluenceUnsupportedInline";
var $eb65f4ade245d09c$export$3e6d667072febc87 = {
    group: "inline",
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    },
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": $eb65f4ade245d09c$var$name,
            "data-confluence-unsupported": "inline",
            "data-confluence-unsupported-inline-cxhtml": node.attrs["cxhtml"]
        };
        return [
            "div",
            attrs,
            "Unsupported content"
        ];
    },
    parseDOM: [
        {
            tag: 'div[data-node-type="'.concat($eb65f4ade245d09c$var$name, '"]'),
            getAttrs: function getAttrs(dom) {
                return {
                    cxhtml: dom.getAttribute("data-confluence-unsupported-inline-cxhtml")
                };
            }
        }
    ]
};

});

parcelRegister("35HdZ", function(module, exports) {

$parcel$export(module.exports, "date", function () { return $24035e405e885a93$export$324d90190a8b822a; });
/**
 * @name date_node
 */ var $24035e405e885a93$export$324d90190a8b822a = {
    inline: true,
    group: "inline",
    selectable: true,
    attrs: {
        timestamp: {
            default: ""
        }
    },
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: function getAttrs(dom) {
                return {
                    timestamp: dom.getAttribute("data-timestamp")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "date",
            "data-timestamp": node.attrs.timestamp
        };
        return [
            "span",
            attrs
        ];
    }
};

});

parcelRegister("a0Wt3", function(module, exports) {

$parcel$export(module.exports, "decisionItem", function () { return $74a741e9c3d40fb7$export$6959e16eeff859b4; });

var $4SpYR = parcelRequire("4SpYR");
var $74a741e9c3d40fb7$export$6959e16eeff859b4 = {
    content: "inline*",
    defining: true,
    marks: "_",
    attrs: {
        localId: {
            default: ""
        },
        state: {
            default: "DECIDED"
        }
    },
    parseDOM: [
        {
            tag: "li[data-decision-local-id]",
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $4SpYR.uuid).generate(),
                    state: dom.getAttribute("data-decision-state")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            "data-decision-local-id": localId || "local-decision",
            "data-decision-state": state
        };
        return [
            "li",
            attrs,
            0
        ];
    }
};

});
parcelRegister("4SpYR", function(module, exports) {

$parcel$export(module.exports, "generateUuid", function () { return $38d05bc8ab5cc0b3$export$1c3aefb711c3a4cc; });
$parcel$export(module.exports, "uuid", function () { return $38d05bc8ab5cc0b3$export$31b40729666a4ae0; });
/* eslint-disable no-bitwise */ var $38d05bc8ab5cc0b3$export$1c3aefb711c3a4cc = function generateUuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0;
        return (c === "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
/* eslint-enable no-bitwise */ var $38d05bc8ab5cc0b3$var$staticValue = false;
var $38d05bc8ab5cc0b3$export$31b40729666a4ae0 = {
    setStatic: function setStatic(value) {
        $38d05bc8ab5cc0b3$var$staticValue = value;
    },
    generate: function generate() {
        return $38d05bc8ab5cc0b3$var$staticValue || $38d05bc8ab5cc0b3$export$1c3aefb711c3a4cc();
    }
};

});


parcelRegister("EGbJK", function(module, exports) {

$parcel$export(module.exports, "decisionListSelector", function () { return $07a476427ee6d086$export$a5393ce68c2ff601; });
$parcel$export(module.exports, "decisionList", function () { return $07a476427ee6d086$export$62d45a65fb43d95e; });

var $4SpYR = parcelRequire("4SpYR");
/**
 * @name decisionList_node
 */ var $07a476427ee6d086$var$name = "decisionList";
var $07a476427ee6d086$export$a5393ce68c2ff601 = '[data-node-type="'.concat($07a476427ee6d086$var$name, '"]');
var $07a476427ee6d086$export$62d45a65fb43d95e = {
    group: "block",
    defining: true,
    content: "(decisionItem|unsupportedBlock)+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    selectable: false,
    attrs: {
        localId: {
            default: ""
        }
    },
    parseDOM: [
        {
            tag: "ol".concat($07a476427ee6d086$export$a5393ce68c2ff601),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $4SpYR.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            "data-node-type": $07a476427ee6d086$var$name,
            "data-decision-list-local-id": localId || "local-decision-list",
            style: "list-style: none; padding-left: 0"
        };
        return [
            "ol",
            attrs,
            0
        ];
    }
};

});

parcelRegister("8G9Ir", function(module, exports) {

$parcel$export(module.exports, "doc", function () { return $6519c851a5a360e5$export$2a111da947c407d2; });
/**
 * @name doc_node
 */ var $6519c851a5a360e5$export$2a111da947c407d2 = {
    content: "(block|layoutSection|blockRootOnly)+",
    marks: "alignment breakout dataConsumer fragment indentation unsupportedMark unsupportedNodeAttribute"
};

});

parcelRegister("3IOyU", function(module, exports) {

$parcel$export(module.exports, "embedCard", function () { return $2b5cb3bbac8b3d71$export$be4283d9a1cb1ff6; });
/**
 * @name embedCard_node
 */ var $2b5cb3bbac8b3d71$export$be4283d9a1cb1ff6 = {
    inline: false,
    group: "block",
    selectable: true,
    attrs: {
        url: {
            default: ""
        },
        layout: {
            default: "center"
        },
        width: {
            default: 100
        },
        originalWidth: {
            default: null
        },
        originalHeight: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: "div[data-embed-card]",
            getAttrs: function getAttrs(dom) {
                return {
                    url: dom.getAttribute("data-card-url"),
                    layout: dom.getAttribute("data-layout") || "center",
                    width: Number(dom.getAttribute("data-width")) || null,
                    originalWidth: Number(dom.getAttribute("data-card-original-width")) || null,
                    originalHeight: Number(dom.getAttribute("data-card-original-height")) || null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, url = _node$attrs.url, layout = _node$attrs.layout, width = _node$attrs.width, originalWidth = _node$attrs.originalWidth, originalHeight = _node$attrs.originalHeight;
        var attrs = {
            "data-embed-card": "",
            "data-card-url": url,
            "data-layout": layout,
            "data-width": width,
            "data-original-width": originalWidth,
            "data-original-height": originalHeight
        };
        return [
            "div",
            attrs
        ];
    }
};

});

parcelRegister("aS3bF", function(module, exports) {

$parcel$export(module.exports, "emoji", function () { return $7ea16b6d9b143096$export$a19185d1233fc4b2; });

var $k5nmo = parcelRequire("k5nmo");
var $7ea16b6d9b143096$export$a19185d1233fc4b2 = {
    inline: true,
    group: "inline",
    selectable: true,
    attrs: {
        shortName: {
            default: ""
        },
        id: {
            default: ""
        },
        text: {
            default: ""
        }
    },
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: "div.ak-editor-panel__icon span",
            ignore: true
        },
        {
            tag: "span[data-emoji-short-name]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute("data-emoji-short-name") || $7ea16b6d9b143096$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute("data-emoji-id") || $7ea16b6d9b143096$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute("data-emoji-text") || $7ea16b6d9b143096$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: "img[data-emoticon-name]",
            getAttrs: function getAttrs(dom) {
                return (0, $k5nmo.acNameToEmoji)(dom.getAttribute("data-emoticon-name"));
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: "img[data-hipchat-emoticon]",
            getAttrs: function getAttrs(dom) {
                return (0, $k5nmo.acShortcutToEmoji)(dom.getAttribute("data-hipchat-emoticon"));
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: "img.emoji[data-emoji-short-name]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute("data-emoji-short-name") || $7ea16b6d9b143096$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute("data-emoji-id") || $7ea16b6d9b143096$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute("data-emoji-text") || $7ea16b6d9b143096$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, shortName = _node$attrs.shortName, id = _node$attrs.id, text = _node$attrs.text;
        var attrs = {
            "data-emoji-short-name": shortName,
            "data-emoji-id": id,
            "data-emoji-text": text,
            contenteditable: "false"
        };
        return [
            "span",
            attrs,
            text
        ];
    }
};

});
parcelRegister("k5nmo", function(module, exports) {

$parcel$export(module.exports, "acNameToEmoji", function () { return $e9f6652236dff0be$export$f61e93bda2a8b420; });
$parcel$export(module.exports, "acShortcutToEmoji", function () { return $e9f6652236dff0be$export$441f8b58f5790a68; });
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
var $e9f6652236dff0be$var$DEFAULT_EMOJI_ID = "2b50";
// Default ac:name for emoticons as a fallback is `blue-star`
var $e9f6652236dff0be$var$DEFAULT_EMOJI_ACNAME = "blue-star";
// ac:hipchat-emoticon prefix when converting to Emoji ID
var $e9f6652236dff0be$var$HC_EMOTICON_PREFIX = "atlassian-";
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ var $e9f6652236dff0be$var$acNameToEmojiMap = {
    smile: [
        "1f642",
        ":slight_smile:",
        "\uD83D\uDE42"
    ],
    sad: [
        "1f641",
        ":slight_frown:",
        "\uD83D\uDE41"
    ],
    cheeky: [
        "1f61b",
        ":stuck_out_tongue:",
        "\uD83D\uDE1B"
    ],
    laugh: [
        "1f600",
        ":grinning:",
        "\uD83D\uDE00"
    ],
    wink: [
        "1f609",
        ":wink:",
        "\uD83D\uDE09"
    ],
    information: [
        "2139",
        ":information_source:",
        "\u2139"
    ],
    tick: [
        "2705",
        ":white_check_mark:",
        "\u2705"
    ],
    cross: [
        "274c",
        ":x:",
        "\u274C"
    ],
    warning: [
        "26a0",
        ":warning:",
        "\u26A0"
    ],
    plus: [
        "2795",
        ":heavy_plus_sign:",
        "\u2795"
    ],
    minus: [
        "2796",
        ":heavy_minus_sign:",
        "\u2796"
    ],
    question: [
        "2753",
        ":question:",
        "?"
    ],
    "thumbs-up": [
        "1f44d",
        ":thumbsup:",
        "\uD83D\uDC4D"
    ],
    "thumbs-down": [
        "1f44e",
        ":thumbsdown:",
        "\uD83D\uDC4E"
    ],
    "light-on": [
        "1f4a1",
        ":bulb:",
        "\uD83D\uDCA1"
    ],
    "yellow-star": [
        "2b50",
        ":star:",
        "\uD83D\uDC9B"
    ],
    "light-off": [
        "1f6ab",
        ":no_entry_sign:",
        "\uD83D\uDEAB"
    ],
    "red-star": [
        "2764",
        ":heart:",
        "\u2764\uFE0F"
    ],
    "green-star": [
        "1f49a",
        ":green_heart:",
        "\uD83D\uDC9A"
    ],
    "blue-star": [
        "1f499",
        ":blue_heart:",
        "\uD83D\uDC99"
    ],
    heart: [
        "2764",
        ":heart:",
        "\u2764\uFE0F"
    ],
    "broken-heart": [
        "1f494",
        ":broken_heart:",
        "\uD83D\uDC94"
    ]
};
function $e9f6652236dff0be$export$f61e93bda2a8b420(acName) {
    var emojiData = $e9f6652236dff0be$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $e9f6652236dff0be$var$DEFAULT_EMOJI_ID,
        shortName: ":".concat(acName, ":"),
        text: ""
    };
}
function $e9f6652236dff0be$export$bc94e44ec0e7bd82(emojiId) {
    var filterEmojis = function filterEmojis(acName) {
        return $e9f6652236dff0be$var$acNameToEmojiMap[acName] ? $e9f6652236dff0be$var$acNameToEmojiMap[acName][0] === emojiId : false;
    };
    return Object.keys($e9f6652236dff0be$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $e9f6652236dff0be$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: "".concat($e9f6652236dff0be$var$HC_EMOTICON_PREFIX).concat(hipchatEmoticonShortName),
        shortName: ":".concat(hipchatEmoticonShortName, ":"),
        text: ""
    };
}
function $e9f6652236dff0be$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ":" ? 1 : 0, shortName[shortName.length - 1] === ":" ? -1 : shortName.length);
}
function $e9f6652236dff0be$export$880a2465992fbbe(_ref) {
    var id = _ref.id, shortName = _ref.shortName;
    if ($e9f6652236dff0be$var$DEFAULT_EMOJI_ID === id) {
        var possibleName = $e9f6652236dff0be$var$getAcNameFromShortName(shortName);
        if (possibleName in $e9f6652236dff0be$var$acNameToEmojiMap) return possibleName;
    }
    return $e9f6652236dff0be$export$bc94e44ec0e7bd82(id) || $e9f6652236dff0be$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("ffqiL", function(module, exports) {

$parcel$export(module.exports, "expand", function () { return $b19ca8a9b3f44fc0$export$9f77e0932fb78f72; });
$parcel$export(module.exports, "toJSON", function () { return $b19ca8a9b3f44fc0$export$54fd2c36b5cc6731; });

var $kFnE9 = parcelRequire("kFnE9");
function $b19ca8a9b3f44fc0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b19ca8a9b3f44fc0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b19ca8a9b3f44fc0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b19ca8a9b3f44fc0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_with_breakout_mark_node
 */ function $b19ca8a9b3f44fc0$var$getExpandAttrs(domNode) {
    var dom = domNode;
    return {
        title: dom.getAttribute("data-title"),
        __expanded: true
    };
}
var $b19ca8a9b3f44fc0$export$9f77e0932fb78f72 = {
    inline: false,
    group: "block",
    marks: "dataConsumer fragment unsupportedMark unsupportedNodeAttribute",
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+",
    isolating: true,
    selectable: true,
    attrs: {
        title: {
            default: ""
        },
        __expanded: {
            default: true
        }
    },
    parseDOM: [
        {
            context: "table//",
            tag: 'div[data-node-type="expand"]',
            getAttrs: $b19ca8a9b3f44fc0$var$getExpandAttrs
        },
        {
            context: "expand//",
            tag: '[data-node-type="expand"]',
            skip: true
        },
        {
            context: "nestedExpand//",
            tag: '[data-node-type="expand"]',
            skip: true
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $b19ca8a9b3f44fc0$var$getExpandAttrs
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "expand",
            "data-title": node.attrs.title,
            "data-expanded": node.attrs.__expanded
        };
        return [
            "div",
            attrs,
            0
        ];
    }
};
var $b19ca8a9b3f44fc0$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return !key.startsWith("__");
        }).reduce(function(obj, key) {
            return $b19ca8a9b3f44fc0$var$_objectSpread($b19ca8a9b3f44fc0$var$_objectSpread({}, obj), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, key, node.attrs[key]));
        }, {})
    };
};

});

parcelRegister("gn7xk", function(module, exports) {

$parcel$export(module.exports, "PanelType", function () { return $beb4a3f1530a9f0c$export$969277cf61e5a7aa; });
$parcel$export(module.exports, "panel", function () { return $beb4a3f1530a9f0c$export$21f42ab9b6679f44; });
$parcel$export(module.exports, "extendedPanel", function () { return $beb4a3f1530a9f0c$export$ce20b13564211141; });

var $kFnE9 = parcelRequire("kFnE9");
function $beb4a3f1530a9f0c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $beb4a3f1530a9f0c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $beb4a3f1530a9f0c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $beb4a3f1530a9f0c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $beb4a3f1530a9f0c$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ var $beb4a3f1530a9f0c$var$getDefaultAttrs = function getDefaultAttrs() {
    var attrs = {
        panelType: {
            default: "info"
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    };
    return attrs;
};
var $beb4a3f1530a9f0c$var$getDomAttrs = function getDomAttrs(nodeAttrs) {
    var attrs = {
        "data-panel-type": nodeAttrs.panelType,
        "data-panel-icon": nodeAttrs.panelIcon,
        "data-panel-icon-id": nodeAttrs.panelIconId,
        "data-panel-icon-text": nodeAttrs.panelIconText,
        "data-panel-color": nodeAttrs.panelColor
    };
    return attrs;
};
var $beb4a3f1530a9f0c$var$getParseDOMAttrs = function getParseDOMAttrs(allowCustomPanel, dom) {
    var parseDOMAttrs = {
        panelType: dom.getAttribute("data-panel-type")
    };
    if (allowCustomPanel) parseDOMAttrs = $beb4a3f1530a9f0c$var$_objectSpread($beb4a3f1530a9f0c$var$_objectSpread({}, parseDOMAttrs), {}, {
        panelIcon: dom.getAttribute("data-panel-icon"),
        panelIconId: dom.getAttribute("data-panel-icon-id"),
        panelIconText: dom.getAttribute("data-panel-icon-text"),
        panelColor: dom.getAttribute("data-panel-color")
    });
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $beb4a3f1530a9f0c$export$969277cf61e5a7aa.CUSTOM ? $beb4a3f1530a9f0c$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
var $beb4a3f1530a9f0c$export$21f42ab9b6679f44 = function panel(allowCustomPanel) {
    var panelNodeSpec = {
        group: "block",
        content: "(paragraph | heading | bulletList | orderedList | blockCard | unsupportedBlock)+",
        marks: "unsupportedMark unsupportedNodeAttribute",
        attrs: $beb4a3f1530a9f0c$var$getDefaultAttrs(),
        selectable: true,
        parseDOM: [
            {
                tag: "div[data-panel-type]",
                getAttrs: function getAttrs(dom) {
                    return $beb4a3f1530a9f0c$var$getParseDOMAttrs(allowCustomPanel, dom);
                }
            }
        ],
        toDOM: function toDOM(node) {
            var attrs = $beb4a3f1530a9f0c$var$getDomAttrs(node.attrs);
            var contentAttrs = {
                "data-panel-content": "true"
            };
            return [
                "div",
                attrs,
                [
                    "div",
                    contentAttrs,
                    0
                ]
            ];
        }
    };
    return panelNodeSpec;
};
var $beb4a3f1530a9f0c$export$ce20b13564211141 = function extendedPanel(allowCustomPanel) {
    var panelNodeSpec = {
        group: "block",
        content: "(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock)+",
        marks: "unsupportedMark unsupportedNodeAttribute",
        attrs: $beb4a3f1530a9f0c$var$getDefaultAttrs(),
        selectable: true,
        parseDOM: [
            {
                tag: "div[data-panel-type]",
                getAttrs: function getAttrs(dom) {
                    return $beb4a3f1530a9f0c$var$getParseDOMAttrs(allowCustomPanel, dom);
                }
            }
        ],
        toDOM: function toDOM(node) {
            var attrs = $beb4a3f1530a9f0c$var$getDomAttrs(node.attrs);
            var contentAttrs = {
                "data-panel-content": "true"
            };
            return [
                "div",
                attrs,
                [
                    "div",
                    contentAttrs,
                    0
                ]
            ];
        }
    };
    return panelNodeSpec;
};

});

parcelRegister("3AEPx", function(module, exports) {

$parcel$export(module.exports, "extension", function () { return $29d467eba1fea3b5$export$1b45514b112dd749; });

var $ipPUs = parcelRequire("ipPUs");
/**
 * @name extension_node
 */ /**
 * @name extension_with_marks_node
 */ var $29d467eba1fea3b5$var$createExtensionNodeSpec = function createExtensionNodeSpec() {
    var nodeSpec = {
        inline: false,
        group: "block",
        atom: true,
        selectable: true,
        attrs: {
            extensionType: {
                default: ""
            },
            extensionKey: {
                default: ""
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            layout: {
                default: "default"
            },
            localId: {
                default: null
            }
        },
        parseDOM: [
            {
                tag: '[data-node-type="extension"]',
                getAttrs: function getAttrs(domNode) {
                    return (0, $ipPUs.getExtensionAttrs)(domNode);
                }
            }
        ],
        toDOM: function toDOM(node) {
            var attrs = {
                "data-node-type": "extension",
                "data-extension-type": node.attrs.extensionType,
                "data-extension-key": node.attrs.extensionKey,
                "data-text": node.attrs.text,
                "data-parameters": JSON.stringify(node.attrs.parameters),
                "data-layout": node.attrs.layout,
                "data-local-id:": node.attrs.localId
            };
            return [
                "div",
                attrs
            ];
        }
    };
    return nodeSpec;
};
var $29d467eba1fea3b5$export$1b45514b112dd749 = $29d467eba1fea3b5$var$createExtensionNodeSpec();

});

parcelRegister("2Ur2k", function(module, exports) {

$parcel$export(module.exports, "hardBreak", function () { return $21e5c8a502e4a5e1$export$371da9dd35aba193; });
/**
 * @name hardBreak_node
 */ var $21e5c8a502e4a5e1$export$371da9dd35aba193 = {
    inline: true,
    group: "inline",
    selectable: false,
    parseDOM: [
        {
            tag: "br"
        }
    ],
    toDOM: function toDOM() {
        return [
            "br"
        ];
    }
};

});

parcelRegister("NZ26g", function(module, exports) {

$parcel$export(module.exports, "image", function () { return $0963eb93120da813$export$5c452ff88e35e47d; });
var $0963eb93120da813$export$5c452ff88e35e47d = {
    group: "inline",
    inline: true,
    attrs: {
        src: {
            default: ""
        },
        alt: {
            default: ""
        },
        title: {
            default: null
        }
    },
    draggable: true,
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: "img[src]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    src: dom.getAttribute("src"),
                    alt: dom.getAttribute("alt"),
                    title: dom.getAttribute("title")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "img",
            node.attrs
        ];
    }
};

});

parcelRegister("3Q6T8", function(module, exports) {

$parcel$export(module.exports, "inlineCard", function () { return $2cbb924a7f1273fe$export$cbf8224b64e0d942; });
/**
 * @name inlineCard_node
 */ var $2cbb924a7f1273fe$export$cbf8224b64e0d942 = {
    inline: true,
    group: "inline",
    selectable: true,
    draggable: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: "a[data-inline-card], span[data-inline-card]",
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute("data-card-data");
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute("href") || anchor.getAttribute("data-card-url") || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: "div[data-inline-card]",
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute("data-card-data");
                return {
                    url: anchor.getAttribute("data-card-url"),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-inline-card": "",
            href: node.attrs.url || "",
            "data-card-data": node.attrs.data ? JSON.stringify(node.attrs.data) : ""
        };
        if (node.attrs.url) return [
            "a",
            attrs,
            node.attrs.url
        ];
        else return [
            "a",
            attrs
        ];
    }
};

});

parcelRegister("mGA14", function(module, exports) {

$parcel$export(module.exports, "inlineExtension", function () { return $044315abd88639eb$export$16b353b2649bd8d9; });

var $ipPUs = parcelRequire("ipPUs");
/**
 * @name inlineExtension_node
 */ /**
 * @name inlineExtension_with_marks_node
 */ var $044315abd88639eb$var$createInlineExtensionNodeSpec = function createInlineExtensionNodeSpec() {
    var nodeSpec = {
        inline: true,
        group: "inline",
        selectable: true,
        attrs: {
            extensionType: {
                default: ""
            },
            extensionKey: {
                default: ""
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            localId: {
                default: null
            }
        },
        parseDOM: [
            {
                tag: "span[data-extension-type]",
                getAttrs: function getAttrs(domNode) {
                    return (0, $ipPUs.getExtensionAttrs)(domNode, true);
                }
            }
        ],
        toDOM: function toDOM(node) {
            var attrs = {
                "data-extension-type": node.attrs.extensionType,
                "data-extension-key": node.attrs.extensionKey,
                "data-text": node.attrs.text,
                "data-parameters": JSON.stringify(node.attrs.parameters),
                "data-local-id:": node.attrs.localId,
                contenteditable: "false"
            };
            return [
                "span",
                attrs
            ];
        }
    };
    return nodeSpec;
};
var $044315abd88639eb$export$16b353b2649bd8d9 = $044315abd88639eb$var$createInlineExtensionNodeSpec();

});

parcelRegister("9rtwv", function(module, exports) {

$parcel$export(module.exports, "layoutColumn", function () { return $6dfd896585537d13$export$ab76e7c03cd6f650; });
/**
 * @name layoutColumn_node
 */ var $6dfd896585537d13$export$ab76e7c03cd6f650 = {
    content: "(block|unsupportedBlock)+",
    isolating: true,
    marks: "alignment indentation dataConsumer fragment unsupportedMark unsupportedNodeAttribute",
    selectable: false,
    attrs: {
        width: {
            default: undefined
        }
    },
    parseDOM: [
        {
            context: "layoutColumn//",
            tag: "div[data-layout-column]",
            skip: true
        },
        {
            tag: "div[data-layout-column]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    width: Number(dom.getAttribute("data-column-width")) || undefined
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-layout-column": "true"
        };
        var width = node.attrs.width;
        if (width) {
            attrs["style"] = "flex-basis: ".concat(width, "%");
            attrs["data-column-width"] = width;
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        var contentAttrs = {
            "data-layout-content": "true"
        };
        return [
            "div",
            attrs,
            [
                "div",
                contentAttrs,
                0
            ]
        ];
    }
};

});

parcelRegister("3OMMD", function(module, exports) {

$parcel$export(module.exports, "listItem", function () { return $2c7be1faaaa6f613$export$76c7e83ecc9cdf05; });
$parcel$export(module.exports, "listItemWithTask", function () { return $2c7be1faaaa6f613$export$58dca2f0678302a4; });
var $2c7be1faaaa6f613$export$76c7e83ecc9cdf05 = {
    content: "(paragraph | mediaSingle | codeBlock | unsupportedBlock) (paragraph | bulletList | orderedList | mediaSingle | codeBlock | unsupportedBlock)*",
    marks: "unsupportedMark unsupportedNodeAttribute",
    defining: true,
    selectable: false,
    parseDOM: [
        {
            tag: "li"
        }
    ],
    toDOM: function toDOM() {
        return [
            "li",
            0
        ];
    }
};
var $2c7be1faaaa6f613$export$58dca2f0678302a4 = {
    content: "(paragraph | mediaSingle | codeBlock | unsupportedBlock) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock)*",
    marks: "unsupportedMark unsupportedNodeAttribute",
    defining: true,
    selectable: false,
    parseDOM: [
        {
            tag: "li"
        }
    ],
    toDOM: function toDOM() {
        return [
            "li",
            0
        ];
    }
};

});

parcelRegister("3P63C", function(module, exports) {

$parcel$export(module.exports, "defaultAttrs", function () { return $2c8ad55ee361be1f$export$bb3fe706be61f640; });
$parcel$export(module.exports, "createMediaSpec", function () { return $2c8ad55ee361be1f$export$35bdbf5bc8caa677; });
$parcel$export(module.exports, "copyPrivateAttributes", function () { return $2c8ad55ee361be1f$export$111130fa8968d741; });
$parcel$export(module.exports, "media", function () { return $2c8ad55ee361be1f$export$987d49ffe1b0900f; });
$parcel$export(module.exports, "toJSON", function () { return $2c8ad55ee361be1f$export$54fd2c36b5cc6731; });

var $g6muZ = parcelRequire("g6muZ");
var $2c8ad55ee361be1f$export$bb3fe706be61f640 = {
    id: {
        default: ""
    },
    type: {
        default: "file"
    },
    collection: {
        default: ""
    },
    occurrenceKey: {
        default: null
    },
    alt: {
        default: ""
    },
    width: {
        default: null
    },
    height: {
        default: null
    },
    url: {
        default: null
    },
    __fileName: {
        default: null
    },
    __fileSize: {
        default: null
    },
    __fileMimeType: {
        default: null
    },
    __displayType: {
        default: null
    },
    __contextId: {
        default: null
    },
    __mediaTraceId: {
        default: null
    },
    __external: {
        default: false
    }
};
var $2c8ad55ee361be1f$export$35bdbf5bc8caa677 = function createMediaSpec(attributes) {
    var inline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var domNodeType = inline ? "span" : "div";
    var nodeName = inline ? "mediaInline" : "media";
    var parseDOM = [
        {
            tag: "".concat(domNodeType, '[data-node-type="').concat(nodeName, '"]'),
            getAttrs: function getAttrs(dom) {
                var attrs = {};
                if (attributes) Object.keys(attributes).forEach(function(k) {
                    var key = $2c8ad55ee361be1f$export$f84fdfb973c05bd8(k).replace(/^__/, "");
                    var value = dom.getAttribute("data-".concat(key)) || "";
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                var width = Number(attrs.width);
                if (typeof width !== "undefined" && !isNaN(width)) attrs.width = width;
                var height = Number(attrs.height);
                if (typeof height !== "undefined" && !isNaN(height)) attrs.height = height;
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    // media-inline.ts uses this same function to generate the nodespec
    // this ensures that we don't make a media inline out of a copied image
    // https://product-fabric.atlassian.net/browse/EDM-2996
    if (!inline) parseDOM.push({
        tag: "img:not(.smart-link-icon)",
        getAttrs: function getAttrs(dom) {
            return {
                type: "external",
                url: dom.getAttribute("src") || "",
                alt: dom.getAttribute("alt") || ""
            };
        }
    });
    return {
        selectable: true,
        inline: inline,
        group: inline ? "inline" : undefined,
        attrs: attributes,
        parseDOM: parseDOM,
        toDOM: function toDOM(node) {
            var attrs = {
                "data-id": node.attrs.id,
                "data-node-type": "".concat(nodeName),
                "data-type": node.attrs.type,
                "data-collection": node.attrs.collection,
                "data-occurrence-key": node.attrs.occurrenceKey,
                "data-width": node.attrs.width,
                "data-height": node.attrs.height,
                "data-url": node.attrs.url,
                "data-alt": node.attrs.alt,
                // toDOM is used for static rendering as well as editor rendering. This comes into play for
                // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
                // node view being used for editing).
                title: "Attachment",
                // Manually kept in sync with the style of media cards. The goal is to render a plain gray
                // rectangle that provides an affordance for media.
                style: "display: inline-block; border-radius: 3px; background: ".concat((0, $g6muZ.N30), "; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);")
            };
            $2c8ad55ee361be1f$export$111130fa8968d741(node.attrs, attrs, function(key) {
                return "data-".concat($2c8ad55ee361be1f$export$f84fdfb973c05bd8(key.slice(2)));
            });
            return [
                "".concat(domNodeType),
                attrs
            ];
        }
    };
};
var $2c8ad55ee361be1f$export$987d49ffe1b0900f = $2c8ad55ee361be1f$export$35bdbf5bc8caa677($2c8ad55ee361be1f$export$bb3fe706be61f640);
var $2c8ad55ee361be1f$export$f84fdfb973c05bd8 = function camelCaseToKebabCase(str) {
    return str.replace(/([^A-Z]+)([A-Z])/g, function(_, x, y) {
        return "".concat(x, "-").concat(y.toLowerCase());
    });
};
var $2c8ad55ee361be1f$export$111130fa8968d741 = function copyPrivateAttributes(from, to, map) {
    if ($2c8ad55ee361be1f$export$987d49ffe1b0900f.attrs) Object.keys($2c8ad55ee361be1f$export$987d49ffe1b0900f.attrs).forEach(function(key) {
        if (key[0] === "_" && key[1] === "_" && from[key]) to[map ? map(key) : key] = from[key];
    });
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ var $2c8ad55ee361be1f$var$optionalAttributes = [
    "occurrenceKey",
    "width",
    "height",
    "url",
    "alt"
];
var $2c8ad55ee361be1f$var$externalOnlyAttributes = [
    "type",
    "url",
    "width",
    "height",
    "alt"
];
var $2c8ad55ee361be1f$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter(function(key) {
            return !(key[0] === "_" && key[1] === "_");
        }).reduce(function(obj, key) {
            if (node.attrs.type === "external" && $2c8ad55ee361be1f$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($2c8ad55ee361be1f$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === "")) return obj;
            if ([
                "width",
                "height"
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};

});

parcelRegister("aITSw", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", function () { return $7ce95bb6da6cca23$export$2855e964765eac9; });
/**
 * @name mediaGroup_node
 */ // Temporary due to an existing issue in validator below:
// https://product-fabric.atlassian.net/jira/servicedesk/projects/DTR/queues/issue/DTR-1429
// TODO: Remove border and link marks from white list
var $7ce95bb6da6cca23$export$2855e964765eac9 = {
    inline: false,
    group: "block",
    content: "(media|unsupportedBlock)+",
    attrs: {},
    marks: "unsupportedMark unsupportedNodeAttribute annotation border link",
    selectable: false,
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM: function toDOM() {
        return [
            "div",
            {
                "data-node-type": "mediaGroup"
            },
            0
        ];
    }
};

});

parcelRegister("cdYe0", function(module, exports) {

$parcel$export(module.exports, "mediaInline", function () { return $8e656a5bdbce01e6$export$38bab695e3f720f1; });

var $3P63C = parcelRequire("3P63C");
var $8e656a5bdbce01e6$export$38bab695e3f720f1 = (0, $3P63C.createMediaSpec)((0, $3P63C.defaultAttrs), true);

});

parcelRegister("eHCwG", function(module, exports) {

$parcel$export(module.exports, "mediaSingleSpec", function () { return $ab42f7534c490b0f$export$5a1e124099b60c6b; });
$parcel$export(module.exports, "mediaSingle", function () { return $ab42f7534c490b0f$export$969fe3781ca15058; });
$parcel$export(module.exports, "mediaSingleWithCaption", function () { return $ab42f7534c490b0f$export$d35e6c006d4abdfb; });
$parcel$export(module.exports, "mediaSingleWithWidthType", function () { return $ab42f7534c490b0f$export$9c58e19811ce4cf5; });
$parcel$export(module.exports, "mediaSingleFull", function () { return $ab42f7534c490b0f$export$7e767666f2ce108a; });
$parcel$export(module.exports, "toJSON", function () { return $ab42f7534c490b0f$export$54fd2c36b5cc6731; });

var $kFnE9 = parcelRequire("kFnE9");

var $8bgm3 = parcelRequire("8bgm3");

var $7ZHvS = parcelRequire("7ZHvS");
function $ab42f7534c490b0f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ab42f7534c490b0f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ab42f7534c490b0f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ab42f7534c490b0f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ab42f7534c490b0f$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: "center"
    }
};
var $ab42f7534c490b0f$export$5a1e124099b60c6b = function mediaSingleSpec(_ref) {
    var _ref$withCaption = _ref.withCaption, withCaption = _ref$withCaption === void 0 ? false : _ref$withCaption, _ref$withExtendedWidt = _ref.withExtendedWidthTypes, withExtendedWidthTypes = _ref$withExtendedWidt === void 0 ? false : _ref$withExtendedWidt;
    var content = withCaption ? "media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*" : "media|unsupportedBlock+|media unsupportedBlock+";
    var atom = !withCaption;
    var getAttrs = function getAttrs(dom) {
        if (!(0, $7ZHvS.isDOMElement)(dom)) // this should never happen
        return {
            layout: "center"
        };
        var layout = dom.getAttribute("data-layout") || "center";
        var width = Number(dom.getAttribute("data-width")) || null;
        var widthType = dom.getAttribute("data-width-type");
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $8bgm3.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    var getAttrsFromNode = function getAttrsFromNode(node) {
        var _node$attrs = node.attrs, layout = _node$attrs.layout, width = _node$attrs.width;
        var attrs = {
            "data-node-type": "mediaSingle",
            "data-layout": layout,
            "data-width": ""
        };
        if (width) attrs["data-width"] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            var widthType = node.attrs.widthType;
            return $ab42f7534c490b0f$var$_objectSpread($ab42f7534c490b0f$var$_objectSpread({}, attrs), {}, {
                "data-width-type": widthType || (0, $8bgm3.WidthType).PERCENTAGE
            });
        }
        return attrs;
    };
    return {
        inline: false,
        group: "block",
        selectable: true,
        atom: atom,
        content: content,
        attrs: withExtendedWidthTypes ? $ab42f7534c490b0f$var$_objectSpread($ab42f7534c490b0f$var$_objectSpread({}, $ab42f7534c490b0f$export$bb3fe706be61f640), {}, {
            widthType: {
                default: null
            }
        }) : $ab42f7534c490b0f$export$bb3fe706be61f640,
        marks: "unsupportedMark unsupportedNodeAttribute annotation border link",
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                "div",
                getAttrsFromNode(node),
                0
            ];
        }
    };
};
var $ab42f7534c490b0f$export$969fe3781ca15058 = $ab42f7534c490b0f$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
var $ab42f7534c490b0f$export$d35e6c006d4abdfb = $ab42f7534c490b0f$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
var $ab42f7534c490b0f$export$9c58e19811ce4cf5 = $ab42f7534c490b0f$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
var $ab42f7534c490b0f$export$7e767666f2ce108a = $ab42f7534c490b0f$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
var $ab42f7534c490b0f$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};

});
parcelRegister("8bgm3", function(module, exports) {

$parcel$export(module.exports, "WidthType", function () { return $5f4c09854b96bb8c$export$4d41558722ac7eed; });
/**
 * @description The widthType attribute is used to support fixed with media single
 */ var $5f4c09854b96bb8c$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("8Hxfq", function(module, exports) {

$parcel$export(module.exports, "mention", function () { return $655c2133e723b482$export$db83999c14438df4; });
$parcel$export(module.exports, "toJSON", function () { return $655c2133e723b482$export$54fd2c36b5cc6731; });

var $kFnE9 = parcelRequire("kFnE9");

var $4SpYR = parcelRequire("4SpYR");
function $655c2133e723b482$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $655c2133e723b482$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $655c2133e723b482$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $655c2133e723b482$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $655c2133e723b482$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
var $655c2133e723b482$export$db83999c14438df4 = {
    inline: true,
    group: "inline",
    selectable: true,
    attrs: {
        id: {
            default: ""
        },
        text: {
            default: ""
        },
        accessLevel: {
            default: ""
        },
        userType: {
            default: null
        },
        localId: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: "span[data-mention-id]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    id: dom.getAttribute("data-mention-id") || $655c2133e723b482$export$db83999c14438df4.attrs.id.default,
                    text: dom.textContent || $655c2133e723b482$export$db83999c14438df4.attrs.text.default,
                    accessLevel: dom.getAttribute("data-access-level") || $655c2133e723b482$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $4SpYR.uuid).generate()
                };
                var userType = dom.getAttribute("data-user-type");
                if ($655c2133e723b482$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, id = _node$attrs.id, accessLevel = _node$attrs.accessLevel, text = _node$attrs.text, userType = _node$attrs.userType, localId = _node$attrs.localId;
        var attrs = {
            "data-mention-id": id,
            "data-access-level": accessLevel,
            contenteditable: "false"
        };
        if (localId) attrs["data-local-id"] = localId;
        if (userType) attrs["data-user-type"] = userType;
        return [
            "span",
            attrs,
            text
        ];
    }
};
var $655c2133e723b482$var$isOptional = function isOptional(key) {
    return [
        "userType",
        "localId"
    ].indexOf(key) > -1;
};
var $655c2133e723b482$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if ($655c2133e723b482$var$isOptional(key) && !node.attrs[key]) return obj;
            return $655c2133e723b482$var$_objectSpread($655c2133e723b482$var$_objectSpread({}, obj), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, key, node.attrs[key]));
        }, {})
    };
};

});

parcelRegister("04De6", function(module, exports) {

$parcel$export(module.exports, "nestedExpand", function () { return $00decd678b1dcda5$export$63cadbf5f4296627; });
/**
 * @name nestedExpand_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ var $00decd678b1dcda5$var$createNestedExpandSpec = function createNestedExpandSpec() {
    var nestedExpandSpec = {
        inline: false,
        marks: "unsupportedMark unsupportedNodeAttribute",
        isolating: true,
        selectable: true,
        attrs: {
            title: {
                default: ""
            },
            __expanded: {
                default: true
            }
        },
        parseDOM: [
            {
                context: "nestedExpand//",
                tag: '[data-node-type="nestedExpand"]',
                skip: true
            },
            {
                tag: '[data-node-type="nestedExpand"] button',
                ignore: true
            },
            {
                tag: '[data-node-type="expand"] button',
                ignore: true
            },
            {
                tag: 'div[data-node-type="nestedExpand"]',
                getAttrs: function getAttrs(domNode) {
                    var dom = domNode;
                    return {
                        title: dom.getAttribute("data-title"),
                        __expanded: true
                    };
                }
            }
        ],
        toDOM: function toDOM(node) {
            var attrs = {
                "data-node-type": "nestedExpand",
                "data-title": node.attrs.title,
                "data-expanded": node.attrs.__expanded
            };
            return [
                "div",
                attrs,
                0
            ];
        }
    };
    nestedExpandSpec.content = "(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock)+";
    return nestedExpandSpec;
};
var $00decd678b1dcda5$export$63cadbf5f4296627 = $00decd678b1dcda5$var$createNestedExpandSpec();

});

parcelRegister("lnUCr", function(module, exports) {

$parcel$export(module.exports, "orderedListSelector", function () { return $f917aa4afc0f10a3$export$4e7125c7ff595be5; });
$parcel$export(module.exports, "orderedList", function () { return $f917aa4afc0f10a3$export$a5dc81035676e7a; });
$parcel$export(module.exports, "orderedListWithOrder", function () { return $f917aa4afc0f10a3$export$b9ab759e8298198f; });

var $kFnE9 = parcelRequire("kFnE9");
function $f917aa4afc0f10a3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f917aa4afc0f10a3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f917aa4afc0f10a3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f917aa4afc0f10a3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f917aa4afc0f10a3$export$4e7125c7ff595be5 = ".ak-ol";
var $f917aa4afc0f10a3$export$a5dc81035676e7a = {
    group: "block",
    attrs: {
        order: {
            default: 1
        }
    },
    content: "listItem+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    selectable: false,
    parseDOM: [
        {
            tag: "ol"
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            class: $f917aa4afc0f10a3$export$4e7125c7ff595be5.substr(1)
        };
        return [
            "ol",
            attrs,
            0
        ];
    }
};
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
var $f917aa4afc0f10a3$var$resolveStart = function resolveStart(start) {
    var num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
var $f917aa4afc0f10a3$export$b9ab759e8298198f = $f917aa4afc0f10a3$var$_objectSpread($f917aa4afc0f10a3$var$_objectSpread({}, $f917aa4afc0f10a3$export$a5dc81035676e7a), {}, {
    parseDOM: [
        {
            tag: "ol",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var startDOMAttr = dom.getAttribute("start");
                if (startDOMAttr) {
                    var start = $f917aa4afc0f10a3$var$resolveStart(startDOMAttr);
                    if (typeof start === "number") return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var start = $f917aa4afc0f10a3$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.order);
        var attrs = {
            start: typeof start === "number" ? String(start) : undefined,
            class: $f917aa4afc0f10a3$export$4e7125c7ff595be5.substr(1)
        };
        return [
            "ol",
            attrs,
            0
        ];
    }
});

});

parcelRegister("3i5ur", function(module, exports) {

$parcel$export(module.exports, "placeholder", function () { return $26574fb60c9ffb8c$export$c7187bbd1a7a9244; });
/**
 * @name placeholder_node
 */ var $26574fb60c9ffb8c$export$c7187bbd1a7a9244 = {
    inline: true,
    group: "inline",
    selectable: false,
    marks: "",
    attrs: {
        text: {
            default: ""
        }
    },
    parseDOM: [
        {
            tag: "span[data-placeholder]",
            getAttrs: function getAttrs(dom) {
                return {
                    text: dom.getAttribute("data-placeholder") || $26574fb60c9ffb8c$export$c7187bbd1a7a9244.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var text = node.attrs.text;
        var attrs = {
            "data-placeholder": text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: "true"
        };
        return [
            "span",
            attrs,
            text
        ];
    }
};

});

parcelRegister("jlaSl", function(module, exports) {

$parcel$export(module.exports, "rule", function () { return $e1486a1e9bb5b24b$export$fbeb3a3956e8a3c7; });
/**
 * @name rule_node
 */ var $e1486a1e9bb5b24b$var$hrDOM = [
    "hr"
];
var $e1486a1e9bb5b24b$export$fbeb3a3956e8a3c7 = {
    group: "block",
    parseDOM: [
        {
            tag: "hr"
        }
    ],
    toDOM: function toDOM() {
        return $e1486a1e9bb5b24b$var$hrDOM;
    }
};

});

parcelRegister("8besj", function(module, exports) {

$parcel$export(module.exports, "status", function () { return $5f4a90674365e0c0$export$471f7ae5c4103ae1; });

var $4SpYR = parcelRequire("4SpYR");
var $5f4a90674365e0c0$export$471f7ae5c4103ae1 = {
    inline: true,
    group: "inline",
    selectable: true,
    attrs: {
        text: {
            default: ""
        },
        color: {
            default: ""
        },
        localId: {
            default: (0, $4SpYR.uuid).generate()
        },
        style: {
            default: ""
        }
    },
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, "").trim(),
                    color: dom.getAttribute("data-color"),
                    localId: (0, $4SpYR.uuid).generate(),
                    style: dom.getAttribute("data-style")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, text = _node$attrs.text, color = _node$attrs.color, localId = _node$attrs.localId, style = _node$attrs.style;
        var attrs = {
            "data-node-type": "status",
            "data-color": color,
            "data-local-id": localId,
            "data-style": style,
            contenteditable: "false"
        };
        return [
            "span",
            attrs,
            text
        ];
    }
};

});

parcelRegister("37tHX", function(module, exports) {

$parcel$export(module.exports, "tablePrefixSelector", function () { return $245911ee115c28b7$export$9cfceb893b24742a; });
$parcel$export(module.exports, "tableCellSelector", function () { return $245911ee115c28b7$export$69cb4c3f80383763; });
$parcel$export(module.exports, "tableHeaderSelector", function () { return $245911ee115c28b7$export$7b07d37d879c957f; });
$parcel$export(module.exports, "tableCellContentWrapperSelector", function () { return $245911ee115c28b7$export$8dd42a84cd52da07; });
$parcel$export(module.exports, "tableCellContentDomSelector", function () { return $245911ee115c28b7$export$5e26a5c19f0865d8; });
$parcel$export(module.exports, "getCellAttrs", function () { return $245911ee115c28b7$export$43977bde391e007; });
$parcel$export(module.exports, "getCellDomAttrs", function () { return $245911ee115c28b7$export$363c8dda799bfe9c; });
$parcel$export(module.exports, "tableBackgroundColorNames", function () { return $245911ee115c28b7$export$8cc2833b5b349a1e; });
$parcel$export(module.exports, "tableBackgroundColorPalette", function () { return $245911ee115c28b7$export$219b7f492ad209f8; });
$parcel$export(module.exports, "tableBackgroundBorderColor", function () { return $245911ee115c28b7$export$95e9c925fbf01d1c; });
$parcel$export(module.exports, "table", function () { return $245911ee115c28b7$export$9852986a3ec5f6a0; });
$parcel$export(module.exports, "tableWithCustomWidth", function () { return $245911ee115c28b7$export$90e634fbace1f0c4; });
$parcel$export(module.exports, "tableStage0", function () { return $245911ee115c28b7$export$3862de5c8c9098cf; });
$parcel$export(module.exports, "tableToJSON", function () { return $245911ee115c28b7$export$1f92a2f429e06fa8; });
$parcel$export(module.exports, "tableRow", function () { return $245911ee115c28b7$export$ce666bf02318c957; });
$parcel$export(module.exports, "tableCell", function () { return $245911ee115c28b7$export$e1e720e5f4603e6a; });
$parcel$export(module.exports, "toJSONTableCell", function () { return $245911ee115c28b7$export$2ac34c099660f1a8; });
$parcel$export(module.exports, "tableHeader", function () { return $245911ee115c28b7$export$48884d2a5190dc73; });
$parcel$export(module.exports, "toJSONTableHeader", function () { return $245911ee115c28b7$export$2af48797a1010bb1; });

var $kFnE9 = parcelRequire("kFnE9");

var $9q1kH = parcelRequire("9q1kH");

var $Pbuln = parcelRequire("Pbuln");

var $g6muZ = parcelRequire("g6muZ");

var $4SpYR = parcelRequire("4SpYR");

var $eD4GP = parcelRequire("eD4GP");
function $245911ee115c28b7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $245911ee115c28b7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $245911ee115c28b7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $245911ee115c28b7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $245911ee115c28b7$export$9cfceb893b24742a = "pm-table";
var $245911ee115c28b7$export$69cb4c3f80383763 = "".concat($245911ee115c28b7$export$9cfceb893b24742a, "-cell-content-wrap");
var $245911ee115c28b7$export$7b07d37d879c957f = "".concat($245911ee115c28b7$export$9cfceb893b24742a, "-header-content-wrap");
var $245911ee115c28b7$export$8dd42a84cd52da07 = "".concat($245911ee115c28b7$export$9cfceb893b24742a, "-cell-nodeview-wrapper");
var $245911ee115c28b7$export$5e26a5c19f0865d8 = "".concat($245911ee115c28b7$export$9cfceb893b24742a, "-cell-nodeview-content-dom");
var $245911ee115c28b7$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $g6muZ.N20).toLocaleLowerCase();
var $245911ee115c28b7$export$43977bde391e007 = function getCellAttrs(dom) {
    var defaultValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var widthAttr = dom.getAttribute("data-colwidth");
    var width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(",").map(function(str) {
        return Number(str);
    }) : null;
    var colspan = Number(dom.getAttribute("colspan") || 1);
    var backgroundColor = dom.style.backgroundColor;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ var dataCellBackground = dom.getAttribute("data-cell-background");
    var dataCellBackgroundHexCode = dataCellBackground && (0, $g6muZ.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes("--ds-background-neutral")) backgroundColor = "";
    else if (backgroundColor && (0, $g6muZ.isRgb)(backgroundColor)) {
        var result = (0, $g6muZ.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    var backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues["background"] ? backgroundColor : null);
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute("rowspan") || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    };
};
// these are for test only
var $245911ee115c28b7$var$testGlobalTheme;
var $245911ee115c28b7$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $245911ee115c28b7$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
var $245911ee115c28b7$var$getGlobalTheme = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($245911ee115c28b7$var$testGlobalTheme) return {
        colorMode: $245911ee115c28b7$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute("data-color-mode") || "";
    return {
        colorMode: colorMode
    };
};
var $245911ee115c28b7$export$363c8dda799bfe9c = function getCellDomAttrs(node) {
    var attrs = {};
    var nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs["data-colwidth"] = node.attrs.colwidth.join(",");
    if (node.attrs.background) {
        var background = node.attrs.background;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        var ignored = nodeType === "tableHeader" && background === $245911ee115c28b7$export$8cc2833b5b349a1e.get("light gray") || nodeType === "tableCell" && background === $245911ee115c28b7$export$8cc2833b5b349a1e.get("white") || nodeType === "tableHeader" && background.includes("--ds-background-neutral");
        if (ignored) attrs.style = "";
        else {
            var color = (0, $g6muZ.isRgb)(background) && (0, $g6muZ.rgbToHex)(background) ? (0, $g6muZ.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ var tokenColor = (0, $Pbuln.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = "background-color: ".concat(tokenColor, ";");
            else // if we have a custom color, we need to check if we are in dark mode
            if ($245911ee115c28b7$var$getGlobalTheme().colorMode === "dark") // if we have a custom color, we need to check if we are in dark mode
            attrs.style = "background-color: ".concat((0, $eD4GP.getDarkModeLCHColor)(color), ";");
            else // if we are in light mode, we can just set the color
            attrs.style = "background-color: ".concat(background, ";");
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs["data-cell-background"] = color;
            attrs.colorname = $245911ee115c28b7$export$219b7f492ad209f8.get(color);
        }
    }
    if (nodeType === "tableHeader") attrs.class = $245911ee115c28b7$export$7b07d37d879c957f;
    else attrs.class = $245911ee115c28b7$export$69cb4c3f80383763;
    return attrs;
};
var $245911ee115c28b7$export$219b7f492ad209f8 = new Map();
var $245911ee115c28b7$export$95e9c925fbf01d1c = (0, $g6muZ.hexToRgba)((0, $g6muZ.N800), 0.12) || (0, $g6muZ.N0);
var $245911ee115c28b7$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $g6muZ.N0),
        "White"
    ],
    [
        (0, $g6muZ.B50),
        "Light blue"
    ],
    [
        (0, $g6muZ.T50),
        "Light teal"
    ],
    [
        (0, $g6muZ.G50),
        "Light green"
    ],
    [
        (0, $g6muZ.Y50),
        "Light yellow"
    ],
    [
        (0, $g6muZ.R50),
        "Light red"
    ],
    [
        (0, $g6muZ.P50),
        "Light purple"
    ],
    [
        (0, $g6muZ.N20),
        "Light gray"
    ],
    [
        (0, $g6muZ.B75),
        "Blue"
    ],
    [
        (0, $g6muZ.T75),
        "Teal"
    ],
    [
        (0, $g6muZ.G75),
        "Green"
    ],
    [
        (0, $g6muZ.Y75),
        "Yellow"
    ],
    [
        (0, $g6muZ.R75),
        "Red"
    ],
    [
        (0, $g6muZ.P75),
        "Purple"
    ],
    [
        (0, $g6muZ.N60),
        "Gray"
    ],
    [
        (0, $g6muZ.B100),
        "Dark blue"
    ],
    [
        (0, $g6muZ.T100),
        "Dark teal"
    ],
    [
        (0, $g6muZ.G200),
        "Dark green"
    ],
    [
        (0, $g6muZ.Y200),
        "Dark yellow"
    ],
    [
        (0, $g6muZ.R100),
        "Dark red"
    ],
    [
        (0, $g6muZ.P100),
        "Dark purple"
    ]
].forEach(function(_ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), colorValue = _ref2[0], colorName = _ref2[1];
    $245911ee115c28b7$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $245911ee115c28b7$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // TODO: Fix any, potential issue. ED-5048
var $245911ee115c28b7$var$createTableSpec = function createTableSpec() {
    var attrs = {
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: "default"
        },
        __autoSize: {
            default: false
        },
        localId: {
            default: ""
        },
        width: {
            default: null
        },
        displayMode: {
            default: null
        }
    };
    var tableNodeSpec = {
        content: "tableRow+",
        attrs: attrs,
        marks: "unsupportedMark unsupportedNodeAttribute",
        tableRole: "table",
        isolating: true,
        selectable: true,
        group: "block",
        parseDOM: [
            {
                tag: "table",
                getAttrs: function getAttrs(node) {
                    var _dom$parentElement;
                    var dom = node;
                    var breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                    return {
                        isNumberColumnEnabled: dom.getAttribute("data-number-column") === "true",
                        layout: // copying from editor
                        dom.getAttribute("data-layout") || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute("data-layout")) || "default",
                        __autoSize: dom.getAttribute("data-autosize") === "true",
                        localId: dom.getAttribute("data-table-local-id") || (0, $4SpYR.uuid).generate(),
                        width: Number(dom.getAttribute("data-table-width")) || null,
                        displayMode: dom.getAttribute("data-table-display-mode") || null
                    };
                }
            }
        ],
        toDOM: function toDOM(node) {
            var attrs = {
                "data-number-column": node.attrs.isNumberColumnEnabled,
                "data-layout": node.attrs.layout,
                "data-autosize": node.attrs.__autoSize,
                "data-table-local-id": node.attrs.localId,
                "data-table-width": node.attrs.width,
                "data-table-display-mode": node.attrs.displayMode
            };
            return [
                "table",
                attrs,
                [
                    "tbody",
                    0
                ]
            ];
        }
    };
    return tableNodeSpec;
};
var $245911ee115c28b7$export$9852986a3ec5f6a0 = $245911ee115c28b7$var$createTableSpec();
var $245911ee115c28b7$export$90e634fbace1f0c4 = $245911ee115c28b7$var$createTableSpec();
var $245911ee115c28b7$export$3862de5c8c9098cf = $245911ee115c28b7$var$createTableSpec();
var $245911ee115c28b7$var$shouldIncludeAttribute = function shouldIncludeAttribute(key, value) {
    return !key.startsWith("__") && (key !== "localId" || !!value);
};
var $245911ee115c28b7$export$1f92a2f429e06fa8 = function tableToJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return $245911ee115c28b7$var$shouldIncludeAttribute(key, node.attrs[key]);
        }).reduce(function(obj, key) {
            return $245911ee115c28b7$var$_objectSpread($245911ee115c28b7$var$_objectSpread({}, obj), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, key, node.attrs[key]));
        }, {})
    };
};
var $245911ee115c28b7$export$ce666bf02318c957 = {
    selectable: false,
    content: "(tableCell | tableHeader)+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    tableRole: "row",
    parseDOM: [
        {
            tag: "tr"
        }
    ],
    toDOM: function toDOM() {
        return [
            "tr",
            0
        ];
    }
};
var $245911ee115c28b7$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    }
};
var $245911ee115c28b7$export$e1e720e5f4603e6a = {
    selectable: false,
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle |  mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+",
    attrs: $245911ee115c28b7$var$cellAttrs,
    tableRole: "cell",
    marks: "alignment dataConsumer fragment unsupportedMark unsupportedNodeAttribute",
    isolating: true,
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: ".ak-renderer-table-number-column",
            ignore: true
        },
        {
            tag: "td",
            getAttrs: function getAttrs(dom) {
                return $245911ee115c28b7$export$43977bde391e007(dom);
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "td",
            $245911ee115c28b7$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $245911ee115c28b7$export$2ac34c099660f1a8 = function toJSONTableCell(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if ($245911ee115c28b7$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};
var $245911ee115c28b7$export$48884d2a5190dc73 = {
    selectable: false,
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle |  mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+",
    attrs: $245911ee115c28b7$var$cellAttrs,
    tableRole: "header_cell",
    isolating: true,
    marks: "alignment dataConsumer fragment unsupportedMark unsupportedNodeAttribute",
    parseDOM: [
        {
            tag: "th",
            getAttrs: function getAttrs(dom) {
                return $245911ee115c28b7$export$43977bde391e007(dom, {
                    background: $245911ee115c28b7$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "th",
            $245911ee115c28b7$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $245911ee115c28b7$export$2af48797a1010bb1 = $245911ee115c28b7$export$2ac34c099660f1a8;

});

parcelRegister("lmb64", function(module, exports) {

$parcel$export(module.exports, "taskItem", function () { return $f8c442ad81529658$export$6d8b0ef52e2e6390; });

var $4SpYR = parcelRequire("4SpYR");
var $f8c442ad81529658$export$6d8b0ef52e2e6390 = {
    content: "inline*",
    defining: true,
    selectable: false,
    marks: "_",
    attrs: {
        localId: {
            default: ""
        },
        state: {
            default: "TODO"
        }
    },
    parseDOM: [
        {
            tag: "div[data-task-local-id]",
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $4SpYR.uuid).generate(),
                    state: dom.getAttribute("data-task-state") || "TODO"
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            "data-task-local-id": localId || "local-task",
            "data-task-state": state || "TODO"
        };
        return [
            "div",
            attrs,
            0
        ];
    }
};

});

parcelRegister("7ebhx", function(module, exports) {

$parcel$export(module.exports, "taskListSelector", function () { return $5432978947860a38$export$c0ec71adb7a18fb2; });
$parcel$export(module.exports, "taskList", function () { return $5432978947860a38$export$375b6afcc5f4d291; });

var $4SpYR = parcelRequire("4SpYR");
/**
 * @name taskList_node
 */ var $5432978947860a38$var$name = "actionList";
var $5432978947860a38$export$c0ec71adb7a18fb2 = '[data-node-type="'.concat($5432978947860a38$var$name, '"]');
var $5432978947860a38$export$375b6afcc5f4d291 = {
    group: "block",
    defining: true,
    selectable: false,
    content: "(taskItem|unsupportedBlock)+ (taskItem|taskList|unsupportedBlock)*",
    marks: "unsupportedMark unsupportedNodeAttribute",
    attrs: {
        localId: {
            default: ""
        }
    },
    parseDOM: [
        {
            tag: "div".concat($5432978947860a38$export$c0ec71adb7a18fb2),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $4SpYR.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            "data-node-type": $5432978947860a38$var$name,
            "data-task-list-local-id": localId || "local-task-list",
            style: "list-style: none; padding-left: 0"
        };
        return [
            "div",
            attrs,
            0
        ];
    }
};

});

parcelRegister("j50N1", function(module, exports) {

$parcel$export(module.exports, "text", function () { return $de3f18beac9f8874$export$6f093cfa640b7166; });
/**
 * @name text_node
 */ var $de3f18beac9f8874$export$6f093cfa640b7166 = {
    group: "inline",
    toDebugString: function() {
        return "text_node";
    }
};

});

parcelRegister("1tTmP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $114372a390aed3b9$export$2e2bcd8739ae039; });
var $114372a390aed3b9$var$name = "unknownBlock";
var $114372a390aed3b9$export$2e2bcd8739ae039 = {
    group: "block",
    content: "inline+",
    marks: "_",
    toDOM: function toDOM() {
        return [
            "div",
            {
                "data-node-type": $114372a390aed3b9$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: 'div[data-node-type="'.concat($114372a390aed3b9$var$name, '"]')
        }
    ]
};

});

parcelRegister("6WVZ3", function(module, exports) {

$parcel$export(module.exports, "unsupportedBlock", function () { return $50f5233995e4ac49$export$44b79b0979d0f0f7; });
var $50f5233995e4ac49$export$44b79b0979d0f0f7 = {
    inline: false,
    group: "block",
    atom: true,
    selectable: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: function getAttrs(dom) {
                return {
                    originalValue: JSON.parse(dom.getAttribute("data-original-value") || "{}")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "unsupportedBlock",
            "data-original-value": JSON.stringify(node.attrs.originalValue)
        };
        return [
            "div",
            attrs,
            "Unsupported content"
        ];
    }
};

});

parcelRegister("lsYRl", function(module, exports) {

$parcel$export(module.exports, "unsupportedInline", function () { return $fa0b6be4fac6785b$export$310ebe0d80122e9b; });
var $fa0b6be4fac6785b$export$310ebe0d80122e9b = {
    inline: true,
    group: "inline",
    selectable: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: function getAttrs(dom) {
                return {
                    originalValue: JSON.parse(dom.getAttribute("data-original-value") || "{}")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "unsupportedInline",
            "data-original-value": JSON.stringify(node.attrs.originalValue)
        };
        return [
            "span",
            attrs,
            "Unsupported content"
        ];
    }
};

});



parcelRegister("8gREA", function(module, exports) {

$parcel$export(module.exports, "BitbucketTransformer", function () { return $60596fd8a5741064$export$8bb303b87207a8dc; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");

var $1cpUy = parcelRequire("1cpUy");

var $hkkPD = parcelRequire("hkkPD");

var $eBRqR = parcelRequire("eBRqR");
var $60596fd8a5741064$export$8bb303b87207a8dc = /*#__PURE__*/ function() {
    function BitbucketTransformer(schema) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, BitbucketTransformer);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "serializer", new (0, $hkkPD.MarkdownSerializer)((0, $hkkPD.nodes), (0, $hkkPD.marks)));
        this.schema = schema;
        this.options = options;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(BitbucketTransformer, [
        {
            key: "encode",
            value: function encode(node) {
                return this.serializer.serialize(node);
            }
        },
        {
            key: "parse",
            value: function parse(html) {
                var dom = this.buildDOMTree(html);
                return (0, $1cpUy.DOMParser).fromSchema(this.schema).parse(dom);
            }
        },
        {
            key: "buildDOMTree",
            value: function buildDOMTree(html) {
                return (0, $eBRqR.transformHtml)(html, this.options);
            }
        }
    ]);
    return BitbucketTransformer;
}();

});
parcelRegister("hkkPD", function(module, exports) {

$parcel$export(module.exports, "nodes", function () { return nodes; });
$parcel$export(module.exports, "MarkdownSerializer", function () { return MarkdownSerializer; });
$parcel$export(module.exports, "marks", function () { return marks; });

var $9q1kH = parcelRequire("9q1kH");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $6hDS8 = parcelRequire("6hDS8");

var $eBRqR = parcelRequire("eBRqR");

var $6INad = parcelRequire("6INad");

var $gHyMv = parcelRequire("gHyMv");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var generateOuterBacktickChain = function() {
    function getMaxLength(text) {
        var matches = text.match(/`+/g);
        if (matches) return matches.reduce(function(prev, val) {
            return val.length > prev.length ? val : prev;
        }, "").length;
        return 0;
    }
    return function(text) {
        var minLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var length = Math.max(minLength, getMaxLength(text) + 1);
        return (0, $eBRqR.stringRepeat)("`", length);
    };
}();
var MarkdownSerializerState = /*#__PURE__*/ function(_PMMarkdownSerializer) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(MarkdownSerializerState, _PMMarkdownSerializer);
    var _super = _createSuper(MarkdownSerializerState);
    function MarkdownSerializerState() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, MarkdownSerializerState);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "context", {
            insideTable: false
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(MarkdownSerializerState, [
        {
            key: "renderContent",
            value: function renderContent(parent) {
                var _this2 = this;
                parent.forEach(function(child, _offset, index) {
                    if (// If child is an empty Textblock we need to insert a zwnj-character in order to preserve that line in markdown
                    child.isTextblock && !child.textContent && // If child is a Codeblock we need to handle this separately as we want to preserve empty code blocks
                    !(child.type.name === "codeBlock") && !(child.content && child.content.size > 0)) return nodes.empty_line(_this2, child);
                    return _this2.render(child, parent, index);
                });
            }
        },
        {
            key: "renderInline",
            value: function renderInline(parent) {
                var _this3 = this;
                var active = [];
                var trailing = "";
                var progress = function progress(node, _, index) {
                    var marks = node ? node.marks.filter(function(mark) {
                        return _this3.marks[mark.type.name];
                    }) : [];
                    var leading = trailing;
                    trailing = "";
                    // If whitespace has to be expelled from the node, adjust
                    // leading and trailing accordingly.
                    if (node && node.isText && marks.some(function(mark) {
                        var info = _this3.marks[mark.type.name];
                        return info && info.expelEnclosingWhitespace;
                    })) {
                        var _ref = /^(\s*)(.*?)(\s*)$/m.exec(node.text), _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 4), lead = _ref2[1], inner = _ref2[2], trail = _ref2[3];
                        leading += lead;
                        trailing = trail;
                        if (lead || trail) {
                            node = inner ? node.withText(inner) : null;
                            if (!node) marks = active;
                        }
                    }
                    var code = marks.length && marks[marks.length - 1].type.name === "code" && marks[marks.length - 1];
                    var len = marks.length - (code ? 1 : 0);
                    // Try to reorder 'mixable' marks, such as em and strong, which
                    // in Markdown may be opened and closed in different order, so
                    // that order of the marks for the token matches the order in
                    // active.
                    outer: for(var i = 0; i < len; i++){
                        var mark = marks[i];
                        if (!_this3.marks[mark.type.name].mixable) break;
                        for(var j = 0; j < active.length; j++){
                            var other = active[j];
                            if (!_this3.marks[other.type.name].mixable) break;
                            if (mark.eq(other)) {
                                if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                                else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                                continue outer;
                            }
                        }
                    }
                    // Find the prefix of the mark set that didn't change
                    var keep = 0;
                    while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
                    // Close the marks that need to be closed
                    while(keep < active.length)_this3.text(_this3.markString(active.pop(), false), false);
                    // Output any previously expelled trailing whitespace outside the marks
                    if (leading) _this3.text(leading);
                    // Open the marks that need to be opened
                    while(active.length < len){
                        var add = marks[active.length];
                        active.push(add);
                        _this3.text(_this3.markString(add, true), false);
                    }
                    if (node) {
                        if (!code || !node.isText) _this3.render(node, parent, index);
                        else if (node.text) {
                            // Generate valid monospace, fenced with series of backticks longer that backtick series inside it.
                            var _text = node.text;
                            var backticks = generateOuterBacktickChain(node.text, 1);
                            // Make sure there is a space between fences, otherwise python-markdown renderer will get confused
                            if (_text.match(/^`/)) _text = " " + _text;
                            if (_text.match(/`$/)) _text += " ";
                            _this3.text(backticks + _text + backticks, false);
                        }
                    }
                };
                parent.forEach(function(child, _offset, index) {
                    progress(child, parent, index);
                });
                progress(null);
            }
        }
    ]);
    return MarkdownSerializerState;
}((0, $6hDS8.MarkdownSerializerState));
var MarkdownSerializer = /*#__PURE__*/ function(_PMMarkdownSerializer2) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(MarkdownSerializer, _PMMarkdownSerializer2);
    var _super2 = _createSuper(MarkdownSerializer);
    function MarkdownSerializer() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, MarkdownSerializer);
        return _super2.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(MarkdownSerializer, [
        {
            key: "serialize",
            value: function serialize(content, options) {
                var state = new MarkdownSerializerState(this.nodes, this.marks, options || {});
                state.renderContent(content);
                return state.out === "\u200C" ? "" : state.out; // Return empty string if editor only contains a zero-non-width character
            }
        }
    ]);
    return MarkdownSerializer;
}((0, $6hDS8.MarkdownSerializer));
var editorNodes = {
    blockquote: function blockquote(state, node) {
        state.wrapBlock("> ", undefined, node, function() {
            return state.renderContent(node);
        });
    },
    codeBlock: function codeBlock(state, node) {
        var backticks = generateOuterBacktickChain(node.textContent, 3);
        state.write(backticks + (node.attrs.language || "") + "\n");
        state.text(node.textContent ? node.textContent : "\u200C", false);
        state.ensureNewLine();
        state.write(backticks);
        state.closeBlock(node);
    },
    heading: function heading(state, node) {
        state.write(state.repeat("#", node.attrs.level) + " ");
        state.renderInline(node);
        state.closeBlock(node);
    },
    rule: function rule(state, node) {
        state.write(node.attrs.markup || "---");
        state.closeBlock(node);
    },
    bulletList: function bulletList(state, node) {
        for(var i = 0; i < node.childCount; i++){
            var child = node.child(i);
            state.render(child, node, i);
        }
    },
    orderedList: function orderedList(state, node) {
        for(var i = 0; i < node.childCount; i++){
            var child = node.child(i);
            state.render(child, node, i);
        }
    },
    listItem: function listItem(state, node, parent, index) {
        var order = (0, $gHyMv.getOrderFromOrderedListNode)(parent);
        var delimiter = parent.type.name === "bulletList" ? "* " : "".concat(order + index, ". ");
        var _loop = function _loop(i) {
            var child = node.child(i);
            // if  at second child or more of list item, add a newline
            if (i > 0) state.write("\n");
            // if at first child of list item, add delimiter (e.g "1.").
            // if at second child or more of list item, only add spacing (not delimiter)
            if (i === 0) state.wrapBlock("  ", delimiter, node, function() {
                return state.render(child, parent, i);
            });
            else state.wrapBlock("    ", undefined, node, function() {
                return state.render(child, parent, i);
            });
            if (child.type.name === "paragraph" && i > 0) state.write("\n");
            state.flushClose(1);
        };
        for(var i = 0; i < node.childCount; i++)_loop(i);
        // if we're at the final list item, add a final closing newline
        if (index === parent.childCount - 1) state.write("\n");
    },
    paragraph: function paragraph(state, node) {
        state.renderInline(node);
        state.closeBlock(node);
    },
    mediaGroup: function mediaGroup(state, node) {
        for(var i = 0; i < node.childCount; i++){
            var child = node.child(i);
            state.render(child, node, i);
        }
    },
    mediaSingle: function mediaSingle(state, node, parent) {
        for(var i = 0; i < node.childCount; i++){
            var child = node.child(i);
            state.render(child, node, i);
            if (!parent.type.name.startsWith("table")) state.write("\n");
        }
    },
    media: function media(state, node) {
        state.write("![](" + node.attrs.url + ")");
    },
    image: function image(state, node) {
        // Note: the 'title' is not escaped in this flavor of markdown.
        state.write("![" + (0, $eBRqR.escapeMarkdown)(node.attrs.alt) + "](" + node.attrs.src + (node.attrs.title ? " '".concat((0, $eBRqR.escapeMarkdown)(node.attrs.title), "'") : "") + ")");
    },
    hardBreak: function hardBreak(state) {
        state.write("  \n");
    },
    text: function text(state, node, parent, index) {
        var previousNode = index === 0 ? null : parent.child(index - 1);
        var text = node.textContent;
        // BB converts 4 spaces at the beginning of the line to code block
        // that's why we escape 4 spaces with zero-width-non-joiner
        var fourSpaces = "    ";
        if (!previousNode && /^\s{4}/.test(node.textContent)) text = node.textContent.replace(fourSpaces, "\u200C" + fourSpaces);
        var lines = text.split("\n");
        for(var i = 0; i < lines.length; i++){
            var startOfLine = state.atBlank() || !!state.closed;
            state.write();
            state.out += (0, $eBRqR.escapeMarkdown)(lines[i], startOfLine, state.context.insideTable);
            if (i !== lines.length - 1) {
                if (lines[i] && lines[i].length && lines[i + 1] && lines[i + 1].length) state.out += "  ";
                state.out += "\n";
            }
        }
    },
    empty_line: function empty_line(state, node) {
        state.write("\u200C"); // zero-width-non-joiner
        state.closeBlock(node);
    },
    mention: function mention(state, node, parent, index) {
        var isLastNode = parent.childCount === index + 1;
        var delimiter = "";
        if (!isLastNode) {
            var nextNode = parent.child(index + 1);
            var nextNodeHasLeadingSpace = nextNode.textContent.indexOf(" ") === 0;
            delimiter = nextNodeHasLeadingSpace ? "" : " ";
        }
        state.write("@".concat(node.attrs.id).concat(delimiter));
    },
    emoji: function emoji(state, node) {
        state.write(node.attrs.shortName);
    },
    inlineCard: function inlineCard(state, node) {
        state.write("[".concat(node.attrs.url, "](").concat(node.attrs.url, "){: data-inline-card='' }"));
    }
};
var nodes = _objectSpread(_objectSpread({}, editorNodes), (0, $6INad.default));
var marks = {
    em: {
        open: "_",
        close: "_",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: "**",
        close: "**",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strike: {
        open: "~~",
        close: "~~",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open: "[",
        close: function close(_state, mark) {
            return "](" + mark.attrs["href"] + ")";
        }
    },
    code: {
        open: "`",
        close: "`"
    }
};

});
parcelRegister("6hDS8", function(module, exports) {

$parcel$export(module.exports, "MarkdownParser", function () { return $4933426952cfc510$export$a64f782182dea128; });
$parcel$export(module.exports, "MarkdownSerializer", function () { return $4933426952cfc510$export$ae9f6f04acb6c60c; });
$parcel$export(module.exports, "MarkdownSerializerState", function () { return $4933426952cfc510$export$61055fa707e69319; });

var $1cpUy = parcelRequire("1cpUy");
parcelRequire("dVzEG");
var $k7WB6 = parcelRequire("k7WB6");
/**
Document schema for the data model used by CommonMark.
*/ const $4933426952cfc510$export$4902baddc787debb = new (0, $1cpUy.Schema)({
    nodes: {
        doc: {
            content: "block+"
        },
        paragraph: {
            content: "inline*",
            group: "block",
            parseDOM: [
                {
                    tag: "p"
                }
            ],
            toDOM () {
                return [
                    "p",
                    0
                ];
            }
        },
        blockquote: {
            content: "block+",
            group: "block",
            parseDOM: [
                {
                    tag: "blockquote"
                }
            ],
            toDOM () {
                return [
                    "blockquote",
                    0
                ];
            }
        },
        horizontal_rule: {
            group: "block",
            parseDOM: [
                {
                    tag: "hr"
                }
            ],
            toDOM () {
                return [
                    "div",
                    [
                        "hr"
                    ]
                ];
            }
        },
        heading: {
            attrs: {
                level: {
                    default: 1
                }
            },
            content: "(text | image)*",
            group: "block",
            defining: true,
            parseDOM: [
                {
                    tag: "h1",
                    attrs: {
                        level: 1
                    }
                },
                {
                    tag: "h2",
                    attrs: {
                        level: 2
                    }
                },
                {
                    tag: "h3",
                    attrs: {
                        level: 3
                    }
                },
                {
                    tag: "h4",
                    attrs: {
                        level: 4
                    }
                },
                {
                    tag: "h5",
                    attrs: {
                        level: 5
                    }
                },
                {
                    tag: "h6",
                    attrs: {
                        level: 6
                    }
                }
            ],
            toDOM (node) {
                return [
                    "h" + node.attrs.level,
                    0
                ];
            }
        },
        code_block: {
            content: "text*",
            group: "block",
            code: true,
            defining: true,
            marks: "",
            attrs: {
                params: {
                    default: ""
                }
            },
            parseDOM: [
                {
                    tag: "pre",
                    preserveWhitespace: "full",
                    getAttrs: (node)=>({
                            params: node.getAttribute("data-params") || ""
                        })
                }
            ],
            toDOM (node) {
                return [
                    "pre",
                    node.attrs.params ? {
                        "data-params": node.attrs.params
                    } : {},
                    [
                        "code",
                        0
                    ]
                ];
            }
        },
        ordered_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                order: {
                    default: 1
                },
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ol",
                    getAttrs (dom) {
                        return {
                            order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1,
                            tight: dom.hasAttribute("data-tight")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "ol",
                    {
                        start: node.attrs.order == 1 ? null : node.attrs.order,
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        bullet_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ul",
                    getAttrs: (dom)=>({
                            tight: dom.hasAttribute("data-tight")
                        })
                }
            ],
            toDOM (node) {
                return [
                    "ul",
                    {
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        list_item: {
            content: "block+",
            defining: true,
            parseDOM: [
                {
                    tag: "li"
                }
            ],
            toDOM () {
                return [
                    "li",
                    0
                ];
            }
        },
        text: {
            group: "inline"
        },
        image: {
            inline: true,
            attrs: {
                src: {},
                alt: {
                    default: null
                },
                title: {
                    default: null
                }
            },
            group: "inline",
            draggable: true,
            parseDOM: [
                {
                    tag: "img[src]",
                    getAttrs (dom) {
                        return {
                            src: dom.getAttribute("src"),
                            title: dom.getAttribute("title"),
                            alt: dom.getAttribute("alt")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "img",
                    node.attrs
                ];
            }
        },
        hard_break: {
            inline: true,
            group: "inline",
            selectable: false,
            parseDOM: [
                {
                    tag: "br"
                }
            ],
            toDOM () {
                return [
                    "br"
                ];
            }
        }
    },
    marks: {
        em: {
            parseDOM: [
                {
                    tag: "i"
                },
                {
                    tag: "em"
                },
                {
                    style: "font-style=italic"
                },
                {
                    style: "font-style=normal",
                    clearMark: (m)=>m.type.name == "em"
                }
            ],
            toDOM () {
                return [
                    "em"
                ];
            }
        },
        strong: {
            parseDOM: [
                {
                    tag: "strong"
                },
                {
                    tag: "b",
                    getAttrs: (node)=>node.style.fontWeight != "normal" && null
                },
                {
                    style: "font-weight=400",
                    clearMark: (m)=>m.type.name == "strong"
                },
                {
                    style: "font-weight",
                    getAttrs: (value)=>/^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
                }
            ],
            toDOM () {
                return [
                    "strong"
                ];
            }
        },
        link: {
            attrs: {
                href: {},
                title: {
                    default: null
                }
            },
            inclusive: false,
            parseDOM: [
                {
                    tag: "a[href]",
                    getAttrs (dom) {
                        return {
                            href: dom.getAttribute("href"),
                            title: dom.getAttribute("title")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "a",
                    node.attrs
                ];
            }
        },
        code: {
            parseDOM: [
                {
                    tag: "code"
                }
            ],
            toDOM () {
                return [
                    "code"
                ];
            }
        }
    }
});
// @ts-ignore
function $4933426952cfc510$var$maybeMerge(a, b) {
    if (a.isText && b.isText && (0, $1cpUy.Mark).sameSet(a.marks, b.marks)) return a.withText(a.text + b.text);
}
// Object used to track the context of a running parse.
class $4933426952cfc510$var$MarkdownParseState {
    constructor(schema, tokenHandlers){
        this.schema = schema;
        this.tokenHandlers = tokenHandlers;
        this.stack = [
            {
                type: schema.topNodeType,
                attrs: null,
                content: [],
                marks: (0, $1cpUy.Mark).none
            }
        ];
    }
    top() {
        return this.stack[this.stack.length - 1];
    }
    push(elt) {
        if (this.stack.length) this.top().content.push(elt);
    }
    // Adds the given text to the current position in the document,
    // using the current marks as styling.
    addText(text) {
        if (!text) return;
        let top = this.top(), nodes = top.content, last = nodes[nodes.length - 1];
        let node = this.schema.text(text, top.marks), merged;
        if (last && (merged = $4933426952cfc510$var$maybeMerge(last, node))) nodes[nodes.length - 1] = merged;
        else nodes.push(node);
    }
    // Adds the given mark to the set of active marks.
    openMark(mark) {
        let top = this.top();
        top.marks = mark.addToSet(top.marks);
    }
    // Removes the given mark from the set of active marks.
    closeMark(mark) {
        let top = this.top();
        top.marks = mark.removeFromSet(top.marks);
    }
    parseTokens(toks) {
        for(let i = 0; i < toks.length; i++){
            let tok = toks[i];
            let handler = this.tokenHandlers[tok.type];
            if (!handler) throw new Error("Token type `" + tok.type + "` not supported by Markdown parser");
            handler(this, tok, toks, i);
        }
    }
    // Add a node at the current position.
    addNode(type, attrs, content) {
        let top = this.top();
        let node = type.createAndFill(attrs, content, top ? top.marks : []);
        if (!node) return null;
        this.push(node);
        return node;
    }
    // Wrap subsequent content in a node of the given type.
    openNode(type, attrs) {
        this.stack.push({
            type: type,
            attrs: attrs,
            content: [],
            marks: (0, $1cpUy.Mark).none
        });
    }
    // Close and return the node that is currently on top of the stack.
    closeNode() {
        let info = this.stack.pop();
        return this.addNode(info.type, info.attrs, info.content);
    }
}
function $4933426952cfc510$var$attrs(spec, token, tokens, i) {
    if (spec.getAttrs) return spec.getAttrs(token, tokens, i);
    else if (spec.attrs instanceof Function) return spec.attrs(token);
    else return spec.attrs;
}
// Code content is represented as a single token with a `content`
// property in Markdown-it.
function $4933426952cfc510$var$noCloseToken(spec, type) {
    return spec.noCloseToken || type == "code_inline" || type == "code_block" || type == "fence";
}
function $4933426952cfc510$var$withoutTrailingNewline(str) {
    return str[str.length - 1] == "\n" ? str.slice(0, str.length - 1) : str;
}
function $4933426952cfc510$var$noOp() {}
function $4933426952cfc510$var$tokenHandlers(schema, tokens) {
    let handlers = Object.create(null);
    for(let type in tokens){
        let spec = tokens[type];
        if (spec.block) {
            let nodeType = schema.nodeType(spec.block);
            if ($4933426952cfc510$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openNode(nodeType, $4933426952cfc510$var$attrs(spec, tok, tokens, i));
                state.addText($4933426952cfc510$var$withoutTrailingNewline(tok.content));
                state.closeNode();
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openNode(nodeType, $4933426952cfc510$var$attrs(spec, tok, tokens, i));
                handlers[type + "_close"] = (state)=>state.closeNode();
            }
        } else if (spec.node) {
            let nodeType = schema.nodeType(spec.node);
            handlers[type] = (state, tok, tokens, i)=>state.addNode(nodeType, $4933426952cfc510$var$attrs(spec, tok, tokens, i));
        } else if (spec.mark) {
            let markType = schema.marks[spec.mark];
            if ($4933426952cfc510$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openMark(markType.create($4933426952cfc510$var$attrs(spec, tok, tokens, i)));
                state.addText($4933426952cfc510$var$withoutTrailingNewline(tok.content));
                state.closeMark(markType);
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openMark(markType.create($4933426952cfc510$var$attrs(spec, tok, tokens, i)));
                handlers[type + "_close"] = (state)=>state.closeMark(markType);
            }
        } else if (spec.ignore) {
            if ($4933426952cfc510$var$noCloseToken(spec, type)) handlers[type] = $4933426952cfc510$var$noOp;
            else {
                handlers[type + "_open"] = $4933426952cfc510$var$noOp;
                handlers[type + "_close"] = $4933426952cfc510$var$noOp;
            }
        } else throw new RangeError("Unrecognized parsing spec " + JSON.stringify(spec));
    }
    handlers.text = (state, tok)=>state.addText(tok.content);
    handlers.inline = (state, tok)=>state.parseTokens(tok.children);
    handlers.softbreak = handlers.softbreak || ((state)=>state.addText(" "));
    return handlers;
}
/**
A configuration of a Markdown parser. Such a parser uses
[markdown-it](https://github.com/markdown-it/markdown-it) to
tokenize a file, and then runs the custom rules it is given over
the tokens to create a ProseMirror document tree.
*/ class $4933426952cfc510$export$a64f782182dea128 {
    /**
    Create a parser with the given configuration. You can configure
    the markdown-it parser to parse the dialect you want, and provide
    a description of the ProseMirror entities those tokens map to in
    the `tokens` object, which maps token names to descriptions of
    what to do with them. Such a description is an object, and may
    have the following properties:
    */ constructor(/**
    The parser's document schema.
    */ schema, /**
    This parser's markdown-it tokenizer.
    */ tokenizer, /**
    The value of the `tokens` object used to construct this
    parser. Can be useful to copy and modify to base other parsers
    on.
    */ tokens){
        this.schema = schema;
        this.tokenizer = tokenizer;
        this.tokens = tokens;
        this.tokenHandlers = $4933426952cfc510$var$tokenHandlers(schema, tokens);
    }
    /**
    Parse a string as [CommonMark](http://commonmark.org/) markup,
    and create a ProseMirror document as prescribed by this parser's
    rules.
    
    The second argument, when given, is passed through to the
    [Markdown
    parser](https://markdown-it.github.io/markdown-it/#MarkdownIt.parse).
    */ parse(text, markdownEnv = {}) {
        let state = new $4933426952cfc510$var$MarkdownParseState(this.schema, this.tokenHandlers), doc;
        state.parseTokens(this.tokenizer.parse(text, markdownEnv));
        do doc = state.closeNode();
        while (state.stack.length);
        return doc || this.schema.topNodeType.createAndFill();
    }
}
function $4933426952cfc510$var$listIsTight(tokens, i) {
    while(++i < tokens.length)if (tokens[i].type != "list_item_open") return tokens[i].hidden;
    return false;
}
/**
A parser parsing unextended [CommonMark](http://commonmark.org/),
without inline HTML, and producing a document in the basic schema.
*/ const $4933426952cfc510$export$7517583227ad0cb8 = new $4933426952cfc510$export$a64f782182dea128($4933426952cfc510$export$4902baddc787debb, (0, $k7WB6.default)("commonmark", {
    html: false
}), {
    blockquote: {
        block: "blockquote"
    },
    paragraph: {
        block: "paragraph"
    },
    list_item: {
        block: "list_item"
    },
    bullet_list: {
        block: "bullet_list",
        getAttrs: (_, tokens, i)=>({
                tight: $4933426952cfc510$var$listIsTight(tokens, i)
            })
    },
    ordered_list: {
        block: "ordered_list",
        getAttrs: (tok, tokens, i)=>({
                order: +tok.attrGet("start") || 1,
                tight: $4933426952cfc510$var$listIsTight(tokens, i)
            })
    },
    heading: {
        block: "heading",
        getAttrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    code_block: {
        block: "code_block",
        noCloseToken: true
    },
    fence: {
        block: "code_block",
        getAttrs: (tok)=>({
                params: tok.info || ""
            }),
        noCloseToken: true
    },
    hr: {
        node: "horizontal_rule"
    },
    image: {
        node: "image",
        getAttrs: (tok)=>({
                src: tok.attrGet("src"),
                title: tok.attrGet("title") || null,
                alt: tok.children[0] && tok.children[0].content || null
            })
    },
    hardbreak: {
        node: "hard_break"
    },
    em: {
        mark: "em"
    },
    strong: {
        mark: "strong"
    },
    link: {
        mark: "link",
        getAttrs: (tok)=>({
                href: tok.attrGet("href"),
                title: tok.attrGet("title") || null
            })
    },
    code_inline: {
        mark: "code",
        noCloseToken: true
    }
});
/**
A specification for serializing a ProseMirror document as
Markdown/CommonMark text.
*/ class $4933426952cfc510$export$ae9f6f04acb6c60c {
    /**
    Construct a serializer with the given configuration. The `nodes`
    object should map node names in a given schema to function that
    take a serializer state and such a node, and serialize the node.
    */ constructor(/**
    The node serializer functions for this serializer.
    */ nodes, /**
    The mark serializer info.
    */ marks, options = {}){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
    }
    /**
    Serialize the content of the given node to
    [CommonMark](http://commonmark.org/).
    */ serialize(content, options = {}) {
        options = Object.assign({}, this.options, options);
        let state = new $4933426952cfc510$export$61055fa707e69319(this.nodes, this.marks, options);
        state.renderContent(content);
        return state.out;
    }
}
/**
A serializer for the [basic schema](https://prosemirror.net/docs/ref/#schema).
*/ const $4933426952cfc510$export$f996452ca6e9a0ae = new $4933426952cfc510$export$ae9f6f04acb6c60c({
    blockquote (state, node) {
        state.wrapBlock("> ", null, node, ()=>state.renderContent(node));
    },
    code_block (state, node) {
        // Make sure the front matter fences are longer than any dash sequence within it
        const backticks = node.textContent.match(/`{3,}/gm);
        const fence = backticks ? backticks.sort().slice(-1)[0] + "`" : "```";
        state.write(fence + (node.attrs.params || "") + "\n");
        state.text(node.textContent, false);
        // Add a newline to the current content before adding closing marker
        state.write("\n");
        state.write(fence);
        state.closeBlock(node);
    },
    heading (state, node) {
        state.write(state.repeat("#", node.attrs.level) + " ");
        state.renderInline(node, false);
        state.closeBlock(node);
    },
    horizontal_rule (state, node) {
        state.write(node.attrs.markup || "---");
        state.closeBlock(node);
    },
    bullet_list (state, node) {
        state.renderList(node, "  ", ()=>(node.attrs.bullet || "*") + " ");
    },
    ordered_list (state, node) {
        let start = node.attrs.order || 1;
        let maxW = String(start + node.childCount - 1).length;
        let space = state.repeat(" ", maxW + 2);
        state.renderList(node, space, (i)=>{
            let nStr = String(start + i);
            return state.repeat(" ", maxW - nStr.length) + nStr + ". ";
        });
    },
    list_item (state, node) {
        state.renderContent(node);
    },
    paragraph (state, node) {
        state.renderInline(node);
        state.closeBlock(node);
    },
    image (state, node) {
        state.write("![" + state.esc(node.attrs.alt || "") + "](" + node.attrs.src.replace(/[\(\)]/g, "\\$&") + (node.attrs.title ? ' "' + node.attrs.title.replace(/"/g, '\\"') + '"' : "") + ")");
    },
    hard_break (state, node, parent, index) {
        for(let i = index + 1; i < parent.childCount; i++)if (parent.child(i).type != node.type) {
            state.write("\\\n");
            return;
        }
    },
    text (state, node) {
        state.text(node.text, !state.inAutolink);
    }
}, {
    em: {
        open: "*",
        close: "*",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: "**",
        close: "**",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open (state, mark, parent, index) {
            state.inAutolink = $4933426952cfc510$var$isPlainURL(mark, parent, index);
            return state.inAutolink ? "<" : "[";
        },
        close (state, mark, parent, index) {
            let { inAutolink: inAutolink } = state;
            state.inAutolink = undefined;
            return inAutolink ? ">" : "](" + mark.attrs.href.replace(/[\(\)"]/g, "\\$&") + (mark.attrs.title ? ` "${mark.attrs.title.replace(/"/g, '\\"')}"` : "") + ")";
        },
        mixable: true
    },
    code: {
        open (_state, _mark, parent, index) {
            return $4933426952cfc510$var$backticksFor(parent.child(index), -1);
        },
        close (_state, _mark, parent, index) {
            return $4933426952cfc510$var$backticksFor(parent.child(index - 1), 1);
        },
        escape: false
    }
});
function $4933426952cfc510$var$backticksFor(node, side) {
    let ticks = /`+/g, m, len = 0;
    if (node.isText) while(m = ticks.exec(node.text))len = Math.max(len, m[0].length);
    let result = len > 0 && side > 0 ? " `" : "`";
    for(let i = 0; i < len; i++)result += "`";
    if (len > 0 && side < 0) result += " ";
    return result;
}
function $4933426952cfc510$var$isPlainURL(link, parent, index) {
    if (link.attrs.title || !/^\w+:/.test(link.attrs.href)) return false;
    let content = parent.child(index);
    if (!content.isText || content.text != link.attrs.href || content.marks[content.marks.length - 1] != link) return false;
    return index == parent.childCount - 1 || !link.isInSet(parent.child(index + 1).marks);
}
/**
This is an object used to track state and expose
methods related to markdown serialization. Instances are passed to
node and mark serialization methods (see `toMarkdown`).
*/ class $4933426952cfc510$export$61055fa707e69319 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ nodes, /**
    @internal
    */ marks, /**
    The options passed to the serializer.
    */ options){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
        /**
        @internal
        */ this.delim = "";
        /**
        @internal
        */ this.out = "";
        /**
        @internal
        */ this.closed = null;
        /**
        @internal
        */ this.inAutolink = undefined;
        /**
        @internal
        */ this.atBlockStart = false;
        /**
        @internal
        */ this.inTightList = false;
        if (typeof this.options.tightLists == "undefined") this.options.tightLists = false;
        if (typeof this.options.hardBreakNodeName == "undefined") this.options.hardBreakNodeName = "hard_break";
    }
    /**
    @internal
    */ flushClose(size = 2) {
        if (this.closed) {
            if (!this.atBlank()) this.out += "\n";
            if (size > 1) {
                let delimMin = this.delim;
                let trim = /\s+$/.exec(delimMin);
                if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                for(let i = 1; i < size; i++)this.out += delimMin + "\n";
            }
            this.closed = null;
        }
    }
    /**
    Render a block, prefixing each line with `delim`, and the first
    line in `firstDelim`. `node` should be the node that is closed at
    the end of the block, and `f` is a function that renders the
    content of the block.
    */ wrapBlock(delim, firstDelim, node, f) {
        let old = this.delim;
        this.write(firstDelim != null ? firstDelim : delim);
        this.delim += delim;
        f();
        this.delim = old;
        this.closeBlock(node);
    }
    /**
    @internal
    */ atBlank() {
        return /(^|\n)$/.test(this.out);
    }
    /**
    Ensure the current content ends with a newline.
    */ ensureNewLine() {
        if (!this.atBlank()) this.out += "\n";
    }
    /**
    Prepare the state for writing output (closing closed paragraphs,
    adding delimiters, and so on), and then optionally add content
    (unescaped) to the output.
    */ write(content) {
        this.flushClose();
        if (this.delim && this.atBlank()) this.out += this.delim;
        if (content) this.out += content;
    }
    /**
    Close the block for the given node.
    */ closeBlock(node) {
        this.closed = node;
    }
    /**
    Add the given text to the document. When escape is not `false`,
    it will be escaped.
    */ text(text, escape = true) {
        let lines = text.split("\n");
        for(let i = 0; i < lines.length; i++){
            this.write();
            // Escape exclamation marks in front of links
            if (!escape && lines[i][0] == "[" && /(^|[^\\])\!$/.test(this.out)) this.out = this.out.slice(0, this.out.length - 1) + "\\!";
            this.out += escape ? this.esc(lines[i], this.atBlockStart) : lines[i];
            if (i != lines.length - 1) this.out += "\n";
        }
    }
    /**
    Render the given node as a block.
    */ render(node, parent, index) {
        if (!this.nodes[node.type.name]) throw new Error("Token type `" + node.type.name + "` not supported by Markdown renderer");
        this.nodes[node.type.name](this, node, parent, index);
    }
    /**
    Render the contents of `parent` as block nodes.
    */ renderContent(parent) {
        parent.forEach((node, _, i)=>this.render(node, parent, i));
    }
    /**
    Render the contents of `parent` as inline content.
    */ renderInline(parent, fromBlockStart = true) {
        this.atBlockStart = fromBlockStart;
        let active = [], trailing = "";
        let progress = (node, offset, index)=>{
            let marks = node ? node.marks : [];
            // Remove marks from `hard_break` that are the last node inside
            // that mark to prevent parser edge cases with new lines just
            // before closing marks.
            if (node && node.type.name === this.options.hardBreakNodeName) marks = marks.filter((m)=>{
                if (index + 1 == parent.childCount) return false;
                let next = parent.child(index + 1);
                return m.isInSet(next.marks) && (!next.isText || /\S/.test(next.text));
            });
            let leading = trailing;
            trailing = "";
            // If whitespace has to be expelled from the node, adjust
            // leading and trailing accordingly.
            if (node && node.isText && marks.some((mark)=>{
                let info = this.marks[mark.type.name];
                return info && info.expelEnclosingWhitespace && !mark.isInSet(active);
            })) {
                let [_, lead, rest] = /^(\s*)(.*)$/m.exec(node.text);
                if (lead) {
                    leading += lead;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            if (node && node.isText && marks.some((mark)=>{
                let info = this.marks[mark.type.name];
                return info && info.expelEnclosingWhitespace && (index == parent.childCount - 1 || !mark.isInSet(parent.child(index + 1).marks));
            })) {
                let [_, rest, trail] = /^(.*?)(\s*)$/m.exec(node.text);
                if (trail) {
                    trailing = trail;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            let inner = marks.length ? marks[marks.length - 1] : null;
            let noEsc = inner && this.marks[inner.type.name].escape === false;
            let len = marks.length - (noEsc ? 1 : 0);
            // Try to reorder 'mixable' marks, such as em and strong, which
            // in Markdown may be opened and closed in different order, so
            // that order of the marks for the token matches the order in
            // active.
            outer: for(let i = 0; i < len; i++){
                let mark = marks[i];
                if (!this.marks[mark.type.name].mixable) break;
                for(let j = 0; j < active.length; j++){
                    let other = active[j];
                    if (!this.marks[other.type.name].mixable) break;
                    if (mark.eq(other)) {
                        if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                        else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                        continue outer;
                    }
                }
            }
            // Find the prefix of the mark set that didn't change
            let keep = 0;
            while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
            // Close the marks that need to be closed
            while(keep < active.length)this.text(this.markString(active.pop(), false, parent, index), false);
            // Output any previously expelled trailing whitespace outside the marks
            if (leading) this.text(leading);
            // Open the marks that need to be opened
            if (node) {
                while(active.length < len){
                    let add = marks[active.length];
                    active.push(add);
                    this.text(this.markString(add, true, parent, index), false);
                    this.atBlockStart = false;
                }
                // Render the node. Special case code marks, since their content
                // may not be escaped.
                if (noEsc && node.isText) this.text(this.markString(inner, true, parent, index) + node.text + this.markString(inner, false, parent, index + 1), false);
                else this.render(node, parent, index);
                this.atBlockStart = false;
            }
            // After the first non-empty text node is rendered, the end of output
            // is no longer at block start.
            //
            // FIXME: If a non-text node writes something to the output for this
            // block, the end of output is also no longer at block start. But how
            // can we detect that?
            if ((node === null || node === void 0 ? void 0 : node.isText) && node.nodeSize > 0) this.atBlockStart = false;
        };
        parent.forEach(progress);
        progress(null, 0, parent.childCount);
        this.atBlockStart = false;
    }
    /**
    Render a node's content as a list. `delim` should be the extra
    indentation added to all lines except the first in an item,
    `firstDelim` is a function going from an item index to a
    delimiter for the first line of the item.
    */ renderList(node, delim, firstDelim) {
        if (this.closed && this.closed.type == node.type) this.flushClose(3);
        else if (this.inTightList) this.flushClose(1);
        let isTight = typeof node.attrs.tight != "undefined" ? node.attrs.tight : this.options.tightLists;
        let prevTight = this.inTightList;
        this.inTightList = isTight;
        node.forEach((child, _, i)=>{
            if (i && isTight) this.flushClose(1);
            this.wrapBlock(delim, firstDelim(i), node, ()=>this.render(child, node, i));
        });
        this.inTightList = prevTight;
    }
    /**
    Escape the given string so that it can safely appear in Markdown
    content. If `startOfLine` is true, also escape characters that
    have special meaning only at the start of the line.
    */ esc(str, startOfLine = false) {
        str = str.replace(/[`*\\~\[\]_]/g, (m, i)=>m == "_" && i > 0 && i + 1 < str.length && str[i - 1].match(/\w/) && str[i + 1].match(/\w/) ? m : "\\" + m);
        if (startOfLine) str = str.replace(/^(\+[ ]|[\-*>])/, "\\$&").replace(/^(\s*)(#{1,6})(\s|$)/, "$1\\$2$3").replace(/^(\s*\d+)\.\s/, "$1\\. ");
        if (this.options.escapeExtraCharacters) str = str.replace(this.options.escapeExtraCharacters, "\\$&");
        return str;
    }
    /**
    @internal
    */ quote(str) {
        let wrap = str.indexOf('"') == -1 ? '""' : str.indexOf("'") == -1 ? "''" : "()";
        return wrap[0] + str + wrap[1];
    }
    /**
    Repeat the given string `n` times.
    */ repeat(str, n) {
        let out = "";
        for(let i = 0; i < n; i++)out += str;
        return out;
    }
    /**
    Get the markdown string for a given opening or closing mark.
    */ markString(mark, open, parent, index) {
        let info = this.marks[mark.type.name];
        let value = open ? info.open : info.close;
        return typeof value == "string" ? value : value(this, mark, parent, index);
    }
    /**
    Get leading and trailing whitespace from a string. Values of
    leading or trailing property of the return object will be undefined
    if there is no match.
    */ getEnclosingWhitespace(text) {
        return {
            leading: (text.match(/^(\s+)/) || [
                undefined
            ])[0],
            trailing: (text.match(/(\s+)$/) || [
                undefined
            ])[0]
        };
    }
}

});
parcelRegister("dVzEG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("k7WB6")).default; });

var $k7WB6 = parcelRequire("k7WB6");

});
parcelRegister("k7WB6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9456699e42fdfd6$export$2e2bcd8739ae039; });
// Main parser class

var $gy0A9 = parcelRequire("gy0A9");

var $cObR7 = parcelRequire("cObR7");

var $5EvFi = parcelRequire("5EvFi");

var $jpxpn = parcelRequire("jpxpn");

var $79wvp = parcelRequire("79wvp");

var $fYVCx = parcelRequire("fYVCx");

var $fMzl7 = parcelRequire("fMzl7");
parcelRequire("csWDk");
var $29zJT = parcelRequire("29zJT");
var $diKRf = parcelRequire("diKRf");
var $jVdgU = parcelRequire("jVdgU");
var $cRPsE = parcelRequire("cRPsE");

var $lQLQe = parcelRequire("lQLQe");

var $9BeCd = parcelRequire("9BeCd");

var $M9Gic = parcelRequire("M9Gic");

var $gkIt7 = parcelRequire("gkIt7");
const $f9456699e42fdfd6$var$config = {
    default: (0, $9BeCd.default),
    zero: (0, $M9Gic.default),
    commonmark: (0, $gkIt7.default)
};
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
const $f9456699e42fdfd6$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
const $f9456699e42fdfd6$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $f9456699e42fdfd6$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    const str = url.trim().toLowerCase();
    return $f9456699e42fdfd6$var$BAD_PROTO_RE.test(str) ? $f9456699e42fdfd6$var$GOOD_DATA_RE.test(str) : true;
}
const $f9456699e42fdfd6$var$RECODE_HOSTNAME_FOR = [
    "http:",
    "https:",
    "mailto:"
];
function $f9456699e42fdfd6$var$normalizeLink(url) {
    const parsed = $cRPsE.default(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $f9456699e42fdfd6$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = (0, $lQLQe.default).toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $diKRf.default($jVdgU.default(parsed));
}
function $f9456699e42fdfd6$var$normalizeLinkText(url) {
    const parsed = $cRPsE.default(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $f9456699e42fdfd6$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = (0, $lQLQe.default).toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $29zJT.default($jVdgU.default(parsed), $29zJT.default.defaultChars + "%");
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.js) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.js) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.js) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.js) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>` or `<code>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre><code class="hljs">' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre><code class="hljs">' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $f9456699e42fdfd6$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $f9456699e42fdfd6$var$MarkdownIt)) return new $f9456699e42fdfd6$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$gy0A9.isString(presetName)) {
            options = presetName || {};
            presetName = "default";
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new (0, $fYVCx.default)();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new (0, $79wvp.default)();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new (0, $jpxpn.default)();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js).
   **/ this.renderer = new (0, $5EvFi.default)();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js)
   * rule.
   **/ this.linkify = new (0, $fMzl7.default)();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $f9456699e42fdfd6$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $f9456699e42fdfd6$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $f9456699e42fdfd6$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.mjs).
   **/ this.utils = $gy0A9;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $gy0A9.assign({}, $cObR7);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $f9456699e42fdfd6$var$MarkdownIt.prototype.set = function(options) {
    $gy0A9.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $f9456699e42fdfd6$var$MarkdownIt.prototype.configure = function(presets) {
    const self = this;
    if ($gy0A9.isString(presets)) {
        const presetName = presets;
        presets = $f9456699e42fdfd6$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error("Wrong `markdown-it` preset, can't be empty");
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $f9456699e42fdfd6$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    let result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        "core",
        "block",
        "inline"
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    const missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $f9456699e42fdfd6$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    let result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        "core",
        "block",
        "inline"
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    const missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $f9456699e42fdfd6$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    const args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $f9456699e42fdfd6$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== "string") throw new Error("Input data should be a String");
    const state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $f9456699e42fdfd6$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $f9456699e42fdfd6$var$MarkdownIt.prototype.parseInline = function(src, env) {
    const state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $f9456699e42fdfd6$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
var $f9456699e42fdfd6$export$2e2bcd8739ae039 = $f9456699e42fdfd6$var$MarkdownIt;

});
parcelRegister("gy0A9", function(module, exports) {

$parcel$export(module.exports, "isString", function () { return $5dd5c70f4d579b36$export$844ec244b1367d54; });
$parcel$export(module.exports, "has", function () { return $5dd5c70f4d579b36$export$a4f4bb6b1453fff5; });
$parcel$export(module.exports, "assign", function () { return $5dd5c70f4d579b36$export$e6e34fd1f2686227; });
$parcel$export(module.exports, "arrayReplaceAt", function () { return $5dd5c70f4d579b36$export$f78478f71955b6bc; });
$parcel$export(module.exports, "isValidEntityCode", function () { return $5dd5c70f4d579b36$export$644a8f5b13b2a36d; });
$parcel$export(module.exports, "fromCodePoint", function () { return $5dd5c70f4d579b36$export$73bfc63873071f74; });
$parcel$export(module.exports, "unescapeMd", function () { return $5dd5c70f4d579b36$export$5ccde1ea0c14bb03; });
$parcel$export(module.exports, "unescapeAll", function () { return $5dd5c70f4d579b36$export$db8a17c6655f7e2c; });
$parcel$export(module.exports, "escapeHtml", function () { return $5dd5c70f4d579b36$export$4cf11838cdc2a8a8; });
$parcel$export(module.exports, "escapeRE", function () { return $5dd5c70f4d579b36$export$bc616c8f7dc20d5d; });
$parcel$export(module.exports, "isSpace", function () { return $5dd5c70f4d579b36$export$1d5ccafae59b4926; });
$parcel$export(module.exports, "isWhiteSpace", function () { return $5dd5c70f4d579b36$export$3c52dd84024ae72c; });
$parcel$export(module.exports, "isPunctChar", function () { return $5dd5c70f4d579b36$export$4888a643af800fc1; });
$parcel$export(module.exports, "isMdAsciiPunct", function () { return $5dd5c70f4d579b36$export$829a0d33ae4e744; });
$parcel$export(module.exports, "normalizeReference", function () { return $5dd5c70f4d579b36$export$20ef46802c8744b; });
$parcel$export(module.exports, "lib", function () { return $5dd5c70f4d579b36$export$16c08b91f883959a; });
// Utilities
//

var $csWDk = parcelRequire("csWDk");
parcelRequire("eNm8G");
var $bZwjS = parcelRequire("bZwjS");
var $eNm8G = parcelRequire("eNm8G");
parcelRequire("38J9K");
var $8BwAF = parcelRequire("8BwAF");
function $5dd5c70f4d579b36$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $5dd5c70f4d579b36$export$844ec244b1367d54(obj) {
    return $5dd5c70f4d579b36$var$_class(obj) === "[object String]";
}
const $5dd5c70f4d579b36$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $5dd5c70f4d579b36$export$a4f4bb6b1453fff5(object, key) {
    return $5dd5c70f4d579b36$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $5dd5c70f4d579b36$export$e6e34fd1f2686227(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== "object") throw new TypeError(source + "must be object");
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $5dd5c70f4d579b36$export$f78478f71955b6bc(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
function $5dd5c70f4d579b36$export$644a8f5b13b2a36d(c) {
    /* eslint no-bitwise:0 */ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $5dd5c70f4d579b36$export$73bfc63873071f74(c) {
    /* eslint no-bitwise:0 */ if (c > 0xffff) {
        c -= 0x10000;
        const surrogate1 = 0xd800 + (c >> 10);
        const surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
const $5dd5c70f4d579b36$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g;
const $5dd5c70f4d579b36$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
const $5dd5c70f4d579b36$var$UNESCAPE_ALL_RE = new RegExp($5dd5c70f4d579b36$var$UNESCAPE_MD_RE.source + "|" + $5dd5c70f4d579b36$var$ENTITY_RE.source, "gi");
const $5dd5c70f4d579b36$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function $5dd5c70f4d579b36$var$replaceEntityPattern(match, name) {
    if (name.charCodeAt(0) === 0x23 /* # */  && $5dd5c70f4d579b36$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        const code = name[1].toLowerCase() === "x" ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($5dd5c70f4d579b36$export$644a8f5b13b2a36d(code)) return $5dd5c70f4d579b36$export$73bfc63873071f74(code);
        return match;
    }
    const decoded = (0, $8BwAF.decodeHTML)(match);
    if (decoded !== match) return decoded;
    return match;
}
/* function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
} */ function $5dd5c70f4d579b36$export$5ccde1ea0c14bb03(str) {
    if (str.indexOf("\\") < 0) return str;
    return str.replace($5dd5c70f4d579b36$var$UNESCAPE_MD_RE, "$1");
}
function $5dd5c70f4d579b36$export$db8a17c6655f7e2c(str) {
    if (str.indexOf("\\") < 0 && str.indexOf("&") < 0) return str;
    return str.replace($5dd5c70f4d579b36$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $5dd5c70f4d579b36$var$replaceEntityPattern(match, entity);
    });
}
const $5dd5c70f4d579b36$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
const $5dd5c70f4d579b36$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
const $5dd5c70f4d579b36$var$HTML_REPLACEMENTS = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;"
};
function $5dd5c70f4d579b36$var$replaceUnsafeChar(ch) {
    return $5dd5c70f4d579b36$var$HTML_REPLACEMENTS[ch];
}
function $5dd5c70f4d579b36$export$4cf11838cdc2a8a8(str) {
    if ($5dd5c70f4d579b36$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($5dd5c70f4d579b36$var$HTML_ESCAPE_REPLACE_RE, $5dd5c70f4d579b36$var$replaceUnsafeChar);
    return str;
}
const $5dd5c70f4d579b36$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $5dd5c70f4d579b36$export$bc616c8f7dc20d5d(str) {
    return str.replace($5dd5c70f4d579b36$var$REGEXP_ESCAPE_RE, "\\$&");
}
function $5dd5c70f4d579b36$export$1d5ccafae59b4926(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $5dd5c70f4d579b36$export$3c52dd84024ae72c(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}
/* eslint-disable max-len */ // Currently without astral characters support.
function $5dd5c70f4d579b36$export$4888a643af800fc1(ch) {
    return $bZwjS.default.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $5dd5c70f4d579b36$export$829a0d33ae4e744(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $5dd5c70f4d579b36$export$20ef46802c8744b(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, " ");
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
const $5dd5c70f4d579b36$export$16c08b91f883959a = {
    mdurl: $csWDk,
    ucmicro: $eNm8G
};

});
parcelRegister("csWDk", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return (parcelRequire("29zJT")).default; });
$parcel$export(module.exports, "encode", function () { return (parcelRequire("diKRf")).default; });
$parcel$export(module.exports, "format", function () { return (parcelRequire("jVdgU")).default; });
$parcel$export(module.exports, "parse", function () { return (parcelRequire("cRPsE")).default; });

var $29zJT = parcelRequire("29zJT");

var $diKRf = parcelRequire("diKRf");

var $jVdgU = parcelRequire("jVdgU");

var $cRPsE = parcelRequire("cRPsE");

});
parcelRegister("29zJT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5629b13ba964d30d$export$2e2bcd8739ae039; });
/* eslint-disable no-bitwise */ const $5629b13ba964d30d$var$decodeCache = {};
function $5629b13ba964d30d$var$getDecodeCache(exclude) {
    let cache = $5629b13ba964d30d$var$decodeCache[exclude];
    if (cache) return cache;
    cache = $5629b13ba964d30d$var$decodeCache[exclude] = [];
    for(let i = 0; i < 128; i++){
        const ch = String.fromCharCode(i);
        cache.push(ch);
    }
    for(let i = 0; i < exclude.length; i++){
        const ch = exclude.charCodeAt(i);
        cache[ch] = "%" + ("0" + ch.toString(16).toUpperCase()).slice(-2);
    }
    return cache;
}
// Decode percent-encoded string.
//
function $5629b13ba964d30d$var$decode(string, exclude) {
    if (typeof exclude !== "string") exclude = $5629b13ba964d30d$var$decode.defaultChars;
    const cache = $5629b13ba964d30d$var$getDecodeCache(exclude);
    return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
        let result = "";
        for(let i = 0, l = seq.length; i < l; i += 3){
            const b1 = parseInt(seq.slice(i + 1, i + 3), 16);
            if (b1 < 0x80) {
                result += cache[b1];
                continue;
            }
            if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                // 110xxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                if ((b2 & 0xC0) === 0x80) {
                    const chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                    if (chr < 0x80) result += "\uFFFD\uFFFD";
                    else result += String.fromCharCode(chr);
                    i += 3;
                    continue;
                }
            }
            if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                // 1110xxxx 10xxxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                const b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                    const chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                    if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += "\uFFFD\uFFFD\uFFFD";
                    else result += String.fromCharCode(chr);
                    i += 6;
                    continue;
                }
            }
            if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                const b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                const b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                    let chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                    if (chr < 0x10000 || chr > 0x10FFFF) result += "\uFFFD\uFFFD\uFFFD\uFFFD";
                    else {
                        chr -= 0x10000;
                        result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                    }
                    i += 9;
                    continue;
                }
            }
            result += "\uFFFD";
        }
        return result;
    });
}
$5629b13ba964d30d$var$decode.defaultChars = ";/?:@&=+$,#";
$5629b13ba964d30d$var$decode.componentChars = "";
var $5629b13ba964d30d$export$2e2bcd8739ae039 = $5629b13ba964d30d$var$decode;

});

parcelRegister("diKRf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4323d44293debdb7$export$2e2bcd8739ae039; });
const $4323d44293debdb7$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $4323d44293debdb7$var$getEncodeCache(exclude) {
    let cache = $4323d44293debdb7$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $4323d44293debdb7$var$encodeCache[exclude] = [];
    for(let i = 0; i < 128; i++){
        const ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push("%" + ("0" + i.toString(16).toUpperCase()).slice(-2));
    }
    for(let i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $4323d44293debdb7$var$encode(string, exclude, keepEscaped) {
    if (typeof exclude !== "string") {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $4323d44293debdb7$var$encode.defaultChars;
    }
    if (typeof keepEscaped === "undefined") keepEscaped = true;
    const cache = $4323d44293debdb7$var$getEncodeCache(exclude);
    let result = "";
    for(let i = 0, l = string.length; i < l; i++){
        const code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                const nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += "%EF%BF%BD";
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$4323d44293debdb7$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$4323d44293debdb7$var$encode.componentChars = "-_.!~*'()";
var $4323d44293debdb7$export$2e2bcd8739ae039 = $4323d44293debdb7$var$encode;

});

parcelRegister("jVdgU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e85cb983605cfee$export$2e2bcd8739ae039; });
function $9e85cb983605cfee$export$2e2bcd8739ae039(url) {
    let result = "";
    result += url.protocol || "";
    result += url.slashes ? "//" : "";
    result += url.auth ? url.auth + "@" : "";
    if (url.hostname && url.hostname.indexOf(":") !== -1) // ipv6 address
    result += "[" + url.hostname + "]";
    else result += url.hostname || "";
    result += url.port ? ":" + url.port : "";
    result += url.pathname || "";
    result += url.search || "";
    result += url.hash || "";
    return result;
}

});

parcelRegister("cRPsE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5286c0569a6b2d82$export$2e2bcd8739ae039; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
function $5286c0569a6b2d82$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.pathname = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
const $5286c0569a6b2d82$var$protocolPattern = /^([a-z0-9.+-]+:)/i;
const $5286c0569a6b2d82$var$portPattern = /:[0-9]*$/;
// Special case for a simple path URL
/* eslint-disable-next-line no-useless-escape */ const $5286c0569a6b2d82$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/;
// RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
const $5286c0569a6b2d82$var$delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
];
// RFC 2396: characters not allowed for various reasons.
const $5286c0569a6b2d82$var$unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat($5286c0569a6b2d82$var$delims);
// Allowed by RFCs, but cause of XSS attacks.  Always escape these.
const $5286c0569a6b2d82$var$autoEscape = [
    "'"
].concat($5286c0569a6b2d82$var$unwise);
// Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
const $5286c0569a6b2d82$var$nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat($5286c0569a6b2d82$var$autoEscape);
const $5286c0569a6b2d82$var$hostEndingChars = [
    "/",
    "?",
    "#"
];
const $5286c0569a6b2d82$var$hostnameMaxLen = 255;
const $5286c0569a6b2d82$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/;
const $5286c0569a6b2d82$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/;
// protocols that can allow "unsafe" and "unwise" chars.
// protocols that never have a hostname.
const $5286c0569a6b2d82$var$hostlessProtocol = {
    javascript: true,
    "javascript:": true
};
// protocols that always contain a // bit.
const $5286c0569a6b2d82$var$slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};
function $5286c0569a6b2d82$var$urlParse(url, slashesDenoteHost) {
    if (url && url instanceof $5286c0569a6b2d82$var$Url) return url;
    const u = new $5286c0569a6b2d82$var$Url();
    u.parse(url, slashesDenoteHost);
    return u;
}
$5286c0569a6b2d82$var$Url.prototype.parse = function(url, slashesDenoteHost) {
    let lowerProto, hec, slashes;
    let rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        const simplePath = $5286c0569a6b2d82$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.pathname = simplePath[1];
            if (simplePath[2]) this.search = simplePath[2];
            return this;
        }
    }
    let proto = $5286c0569a6b2d82$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    /* eslint-disable-next-line no-useless-escape */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && $5286c0569a6b2d82$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$5286c0569a6b2d82$var$hostlessProtocol[proto] && (slashes || proto && !$5286c0569a6b2d82$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        let hostEnd = -1;
        for(let i = 0; i < $5286c0569a6b2d82$var$hostEndingChars.length; i++){
            hec = rest.indexOf($5286c0569a6b2d82$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        let auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf("@", hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = auth;
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(let i = 0; i < $5286c0569a6b2d82$var$nonHostChars.length; i++){
            hec = rest.indexOf($5286c0569a6b2d82$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        if (rest[hostEnd - 1] === ":") hostEnd--;
        const host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost(host);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || "";
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        const ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            const hostparts = this.hostname.split(/\./);
            for(let i = 0, l = hostparts.length; i < l; i++){
                const part = hostparts[i];
                if (!part) continue;
                if (!part.match($5286c0569a6b2d82$var$hostnamePartPattern)) {
                    let newpart = "";
                    for(let j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($5286c0569a6b2d82$var$hostnamePartPattern)) {
                        const validParts = hostparts.slice(0, i);
                        const notHost = hostparts.slice(i + 1);
                        const bit = part.match($5286c0569a6b2d82$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $5286c0569a6b2d82$var$hostnameMaxLen) this.hostname = "";
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
    // chop off from the tail first.
    const hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    const qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
    }
    if (rest) this.pathname = rest;
    if ($5286c0569a6b2d82$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "";
    return this;
};
$5286c0569a6b2d82$var$Url.prototype.parseHost = function(host) {
    let port = $5286c0569a6b2d82$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
var $5286c0569a6b2d82$export$2e2bcd8739ae039 = $5286c0569a6b2d82$var$urlParse;

});


parcelRegister("eNm8G", function(module, exports) {

$parcel$export(module.exports, "Any", function () { return (parcelRequire("2lNFK")).default; });
$parcel$export(module.exports, "Cc", function () { return (parcelRequire("biVQF")).default; });
$parcel$export(module.exports, "Cf", function () { return (parcelRequire("49y2b")).default; });
$parcel$export(module.exports, "P", function () { return (parcelRequire("bZwjS")).default; });
$parcel$export(module.exports, "Z", function () { return (parcelRequire("7uyBr")).default; });

var $2lNFK = parcelRequire("2lNFK");

var $biVQF = parcelRequire("biVQF");

var $49y2b = parcelRequire("49y2b");

var $bZwjS = parcelRequire("bZwjS");

var $7uyBr = parcelRequire("7uyBr");

});
parcelRegister("2lNFK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc00893d4e435729$export$2e2bcd8739ae039; });
var $fc00893d4e435729$export$2e2bcd8739ae039 = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("biVQF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fecd738b7c2da4cc$export$2e2bcd8739ae039; });
var $fecd738b7c2da4cc$export$2e2bcd8739ae039 = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("49y2b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $729b08d6fcfb2315$export$2e2bcd8739ae039; });
var $729b08d6fcfb2315$export$2e2bcd8739ae039 = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});

parcelRegister("bZwjS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0fbe0d2e471337a$export$2e2bcd8739ae039; });
var $c0fbe0d2e471337a$export$2e2bcd8739ae039 = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});

parcelRegister("7uyBr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5d1fff3fcb8e36c$export$2e2bcd8739ae039; });
var $e5d1fff3fcb8e36c$export$2e2bcd8739ae039 = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});


parcelRegister("38J9K", function(module, exports) {

$parcel$export(module.exports, "decodeHTML", function () { return (parcelRequire("8BwAF")).decodeHTML; });

var $8BwAF = parcelRequire("8BwAF");

var $2CFOf = parcelRequire("2CFOf");

var $fZVPj = parcelRequire("fZVPj");
var $2495258bb5e07ca7$export$b8c86583d9718b50;
(function(EntityLevel) {
    /** Support only XML entities. */ EntityLevel[EntityLevel["XML"] = 0] = "XML";
    /** Support HTML entities, which are a superset of XML entities. */ EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})($2495258bb5e07ca7$export$b8c86583d9718b50 || ($2495258bb5e07ca7$export$b8c86583d9718b50 = {}));
var $2495258bb5e07ca7$export$1851b20d614eb756;
(function(EncodingMode) {
    /**
     * The output is UTF-8 encoded. Only characters that need escaping within
     * XML will be escaped.
     */ EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
    /**
     * The output consists only of ASCII characters. Characters that need
     * escaping within HTML, and characters that aren't ASCII characters will
     * be escaped.
     */ EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
    /**
     * Encode all characters that have an equivalent entity, as well as all
     * characters that are not ASCII characters.
     */ EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
    /**
     * Encode all characters that have to be escaped in HTML attributes,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
    /**
     * Encode all characters that have to be escaped in HTML text,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Text"] = 4] = "Text";
})($2495258bb5e07ca7$export$1851b20d614eb756 || ($2495258bb5e07ca7$export$1851b20d614eb756 = {}));
function $2495258bb5e07ca7$export$2f872c0f2117be69(data, options = $2495258bb5e07ca7$export$b8c86583d9718b50.XML) {
    const level = typeof options === "number" ? options : options.level;
    if (level === $2495258bb5e07ca7$export$b8c86583d9718b50.HTML) {
        const mode = typeof options === "object" ? options.mode : undefined;
        return (0, $8BwAF.decodeHTML)(data, mode);
    }
    return (0, $8BwAF.decodeXML)(data);
}
function $2495258bb5e07ca7$export$c94669f4c7d36be4(data, options = $2495258bb5e07ca7$export$b8c86583d9718b50.XML) {
    var _a;
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = (0, $8BwAF.DecodingMode).Strict;
    return $2495258bb5e07ca7$export$2f872c0f2117be69(data, opts);
}
function $2495258bb5e07ca7$export$c564cdbbe6da493(data, options = $2495258bb5e07ca7$export$b8c86583d9718b50.XML) {
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    // Mode `UTF8` just escapes XML entities
    if (opts.mode === $2495258bb5e07ca7$export$1851b20d614eb756.UTF8) return (0, $fZVPj.escapeUTF8)(data);
    if (opts.mode === $2495258bb5e07ca7$export$1851b20d614eb756.Attribute) return (0, $fZVPj.escapeAttribute)(data);
    if (opts.mode === $2495258bb5e07ca7$export$1851b20d614eb756.Text) return (0, $fZVPj.escapeText)(data);
    if (opts.level === $2495258bb5e07ca7$export$b8c86583d9718b50.HTML) {
        if (opts.mode === $2495258bb5e07ca7$export$1851b20d614eb756.ASCII) return (0, $2CFOf.encodeNonAsciiHTML)(data);
        return (0, $2CFOf.encodeHTML)(data);
    }
    // ASCII and Extensive are equivalent
    return (0, $fZVPj.encodeXML)(data);
}

});
parcelRegister("8BwAF", function(module, exports) {

$parcel$export(module.exports, "DecodingMode", function () { return $643b0f2e74347bbb$export$8c8f129ce60f53c; });
$parcel$export(module.exports, "decodeHTML", function () { return $643b0f2e74347bbb$export$f045cb747ce77a19; });
$parcel$export(module.exports, "decodeXML", function () { return $643b0f2e74347bbb$export$88e3b9643a8bd06e; });

var $9Lkli = parcelRequire("9Lkli");

var $bIK23 = parcelRequire("bIK23");

var $6Q8o8 = parcelRequire("6Q8o8");
var $643b0f2e74347bbb$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($643b0f2e74347bbb$var$CharCodes || ($643b0f2e74347bbb$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ const $643b0f2e74347bbb$var$TO_LOWER_BIT = 32;
var $643b0f2e74347bbb$export$6a4325c613e0faec;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($643b0f2e74347bbb$export$6a4325c613e0faec || ($643b0f2e74347bbb$export$6a4325c613e0faec = {}));
function $643b0f2e74347bbb$var$isNumber(code) {
    return code >= $643b0f2e74347bbb$var$CharCodes.ZERO && code <= $643b0f2e74347bbb$var$CharCodes.NINE;
}
function $643b0f2e74347bbb$var$isHexadecimalCharacter(code) {
    return code >= $643b0f2e74347bbb$var$CharCodes.UPPER_A && code <= $643b0f2e74347bbb$var$CharCodes.UPPER_F || code >= $643b0f2e74347bbb$var$CharCodes.LOWER_A && code <= $643b0f2e74347bbb$var$CharCodes.LOWER_F;
}
function $643b0f2e74347bbb$var$isAsciiAlphaNumeric(code) {
    return code >= $643b0f2e74347bbb$var$CharCodes.UPPER_A && code <= $643b0f2e74347bbb$var$CharCodes.UPPER_Z || code >= $643b0f2e74347bbb$var$CharCodes.LOWER_A && code <= $643b0f2e74347bbb$var$CharCodes.LOWER_Z || $643b0f2e74347bbb$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $643b0f2e74347bbb$var$isEntityInAttributeInvalidEnd(code) {
    return code === $643b0f2e74347bbb$var$CharCodes.EQUALS || $643b0f2e74347bbb$var$isAsciiAlphaNumeric(code);
}
var $643b0f2e74347bbb$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($643b0f2e74347bbb$var$EntityDecoderState || ($643b0f2e74347bbb$var$EntityDecoderState = {}));
var $643b0f2e74347bbb$export$8c8f129ce60f53c;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($643b0f2e74347bbb$export$8c8f129ce60f53c || ($643b0f2e74347bbb$export$8c8f129ce60f53c = {}));
class $643b0f2e74347bbb$export$15263a93ff7ec8ba {
    constructor(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors){
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $643b0f2e74347bbb$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $643b0f2e74347bbb$export$8c8f129ce60f53c.Strict;
    }
    /** Resets the instance to make it reusable. */ startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $643b0f2e74347bbb$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ write(str, offset) {
        switch(this.state){
            case $643b0f2e74347bbb$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $643b0f2e74347bbb$var$CharCodes.NUM) {
                    this.state = $643b0f2e74347bbb$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $643b0f2e74347bbb$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $643b0f2e74347bbb$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $643b0f2e74347bbb$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $643b0f2e74347bbb$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $643b0f2e74347bbb$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericStart(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $643b0f2e74347bbb$var$TO_LOWER_BIT) === $643b0f2e74347bbb$var$CharCodes.LOWER_X) {
            this.state = $643b0f2e74347bbb$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $643b0f2e74347bbb$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    }
    addToNumericResult(str, start, end, base) {
        if (start !== end) {
            const digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericHex(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($643b0f2e74347bbb$var$isNumber(char) || $643b0f2e74347bbb$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericDecimal(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($643b0f2e74347bbb$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ emitNumericEntity(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $643b0f2e74347bbb$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $643b0f2e74347bbb$export$8c8f129ce60f53c.Strict) return 0;
        this.emitCodePoint((0, $6Q8o8.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $643b0f2e74347bbb$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNamedEntity(str, offset) {
        const { decodeTree: decodeTree } = this;
        let current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        let valueLength = (current & $643b0f2e74347bbb$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            const char = str.charCodeAt(offset);
            this.treeIndex = $643b0f2e74347bbb$export$44c08d99945e6276(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $643b0f2e74347bbb$export$8c8f129ce60f53c.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $643b0f2e74347bbb$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $643b0f2e74347bbb$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $643b0f2e74347bbb$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $643b0f2e74347bbb$export$8c8f129ce60f53c.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ emitNotTerminatedNamedEntity() {
        var _a;
        const { result: result, decodeTree: decodeTree } = this;
        const valueLength = (decodeTree[result] & $643b0f2e74347bbb$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree: decodeTree } = this;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$643b0f2e74347bbb$export$6a4325c613e0faec.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ end() {
        var _a;
        switch(this.state){
            case $643b0f2e74347bbb$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $643b0f2e74347bbb$export$8c8f129ce60f53c.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $643b0f2e74347bbb$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $643b0f2e74347bbb$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $643b0f2e74347bbb$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $643b0f2e74347bbb$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    }
}
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $643b0f2e74347bbb$var$getDecoder(decodeTree) {
    let ret = "";
    const decoder = new $643b0f2e74347bbb$export$15263a93ff7ec8ba(decodeTree, (str)=>ret += (0, $6Q8o8.fromCodePoint)(str));
    return function decodeWithTrie(str, decodeMode) {
        let lastIndex = 0;
        let offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            const len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        const result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
function $643b0f2e74347bbb$export$44c08d99945e6276(decodeTree, current, nodeIdx, char) {
    const branchCount = (current & $643b0f2e74347bbb$export$6a4325c613e0faec.BRANCH_LENGTH) >> 7;
    const jumpOffset = current & $643b0f2e74347bbb$export$6a4325c613e0faec.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        const value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    let lo = nodeIdx;
    let hi = lo + branchCount - 1;
    while(lo <= hi){
        const mid = lo + hi >>> 1;
        const midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
const $643b0f2e74347bbb$var$htmlDecoder = $643b0f2e74347bbb$var$getDecoder((0, $9Lkli.default));
const $643b0f2e74347bbb$var$xmlDecoder = $643b0f2e74347bbb$var$getDecoder((0, $bIK23.default));
function $643b0f2e74347bbb$export$f045cb747ce77a19(str, mode = $643b0f2e74347bbb$export$8c8f129ce60f53c.Legacy) {
    return $643b0f2e74347bbb$var$htmlDecoder(str, mode);
}
function $643b0f2e74347bbb$export$49f5e8089adb006a(str) {
    return $643b0f2e74347bbb$var$htmlDecoder(str, $643b0f2e74347bbb$export$8c8f129ce60f53c.Attribute);
}
function $643b0f2e74347bbb$export$da52f4371b3f37de(str) {
    return $643b0f2e74347bbb$var$htmlDecoder(str, $643b0f2e74347bbb$export$8c8f129ce60f53c.Strict);
}
function $643b0f2e74347bbb$export$88e3b9643a8bd06e(str) {
    return $643b0f2e74347bbb$var$xmlDecoder(str, $643b0f2e74347bbb$export$8c8f129ce60f53c.Strict);
}

});
parcelRegister("9Lkli", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71b84869a4602119$export$2e2bcd8739ae039; });
// Generated using scripts/write-decode-map.ts
var $71b84869a4602119$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
'\u1D41<\xd5\u0131\u028A\u049D\u057B\u05D0\u0675\u06DE\u07A2\u07D6\u080F\u0A4A\u0A91\u0DA1\u0E6D\u0F09\u0F26\u10CA\u1228\u12E1\u1415\u149D\u14C3\u14DF\u1525\x00\x00\x00\x00\x00\x00\u156B\u16CD\u198D\u1C12\u1DDD\u1F7E\u2060\u21B0\u228D\u23C0\u23FB\u2442\u2824\u2912\u2D08\u2E48\u2FCE\u3016\u32BA\u3639\u37AC\u38FE\u3A28\u3A71\u3AE0\u3B2E\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803B\xc6\u40C6P\u803B&\u4026cute\u803B\xc1\u40C1reve;\u4102\u0100iyx}rc\u803B\xc2\u40C2;\u4410r;\uC000\ud835\udd04rave\u803B\xc0\u40C0pha;\u4391acr;\u4100d;\u6A53\u0100gp\x9d\xa1on;\u4104f;\uC000\ud835\udd38plyFunction;\u6061ing\u803B\xc5\u40C5\u0100cs\xbe\xc3r;\uC000\ud835\udc9cign;\u6254ilde\u803B\xc3\u40C3ml\u803B\xc4\u40C4\u0400aceforsu\xe5\xfb\xfe\u0117\u011C\u0122\u0127\u012A\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6AE7ed;\u6306y;\u4411\u0180crt\u0105\u010B\u0114ause;\u6235noullis;\u612Ca;\u4392r;\uC000\ud835\udd05pf;\uC000\ud835\udd39eve;\u42D8c\xf2\u0113mpeq;\u624E\u0700HOacdefhilorsu\u014D\u0151\u0156\u0180\u019E\u01A2\u01B5\u01B7\u01BA\u01DC\u0215\u0273\u0278\u027Ecy;\u4427PY\u803B\xa9\u40A9\u0180cpy\u015D\u0162\u017Aute;\u4106\u0100;i\u0167\u0168\u62D2talDifferentialD;\u6145leys;\u612D\u0200aeio\u0189\u018E\u0194\u0198ron;\u410Cdil\u803B\xc7\u40C7rc;\u4108nint;\u6230ot;\u410A\u0100dn\u01A7\u01ADilla;\u40B8terDot;\u40B7\xf2\u017Fi;\u43A7rcle\u0200DMPT\u01C7\u01CB\u01D1\u01D6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01E2\u01F8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020FoubleQuote;\u601Duote;\u6019\u0200lnpu\u021E\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6A74\u0180git\u022F\u0236\u023Aruent;\u6261nt;\u622FourIntegral;\u622E\u0100fr\u024C\u024E;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6A2Fcr;\uC000\ud835\udc9ep\u0100;C\u0284\u0285\u62D3ap;\u624D\u0580DJSZacefios\u02A0\u02AC\u02B0\u02B4\u02B8\u02CB\u02D7\u02E1\u02E6\u0333\u048D\u0100;o\u0179\u02A5trahd;\u6911cy;\u4402cy;\u4405cy;\u440F\u0180grs\u02BF\u02C4\u02C7ger;\u6021r;\u61A1hv;\u6AE4\u0100ay\u02D0\u02D5ron;\u410E;\u4414l\u0100;t\u02DD\u02DE\u6207a;\u4394r;\uC000\ud835\udd07\u0100af\u02EB\u0327\u0100cm\u02F0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031Ccute;\u40B4o\u0174\u030B\u030D;\u42D9bleAcute;\u42DDrave;\u4060ilde;\u42DCond;\u62C4ferentialD;\u6146\u0470\u033D\x00\x00\x00\u0342\u0354\x00\u0405f;\uC000\ud835\udd3b\u0180;DE\u0348\u0349\u034D\u40A8ot;\u60DCqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03CF\u03E2\u03F8ontourIntegra\xec\u0239o\u0274\u0379\x00\x00\u037B\xbb\u0349nArrow;\u61D3\u0100eo\u0387\u03A4ft\u0180ART\u0390\u0396\u03A1rrow;\u61D0ightArrow;\u61D4e\xe5\u02CAng\u0100LR\u03AB\u03C4eft\u0100AR\u03B3\u03B9rrow;\u67F8ightArrow;\u67FAightArrow;\u67F9ight\u0100AT\u03D8\u03DErrow;\u61D2ee;\u62A8p\u0241\u03E9\x00\x00\u03EFrrow;\u61D1ownArrow;\u61D5erticalBar;\u6225n\u0300ABLRTa\u0412\u042A\u0430\u045E\u047F\u037Crrow\u0180;BU\u041D\u041E\u0422\u6193ar;\u6913pArrow;\u61F5reve;\u4311eft\u02D2\u043A\x00\u0446\x00\u0450ightVector;\u6950eeVector;\u695Eector\u0100;B\u0459\u045A\u61BDar;\u6956ight\u01D4\u0467\x00\u0471eeVector;\u695Fector\u0100;B\u047A\u047B\u61C1ar;\u6957ee\u0100;A\u0486\u0487\u62A4rrow;\u61A7\u0100ct\u0492\u0497r;\uC000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04BD\u04C0\u04C4\u04CB\u04DE\u04E2\u04E7\u04EE\u04F5\u0521\u052F\u0536\u0552\u055D\u0560\u0565G;\u414AH\u803B\xd0\u40D0cute\u803B\xc9\u40C9\u0180aiy\u04D2\u04D7\u04DCron;\u411Arc\u803B\xca\u40CA;\u442Dot;\u4116r;\uC000\ud835\udd08rave\u803B\xc8\u40C8ement;\u6208\u0100ap\u04FA\u04FEcr;\u4112ty\u0253\u0506\x00\x00\u0512mallSquare;\u65FBerySmallSquare;\u65AB\u0100gp\u0526\u052Aon;\u4118f;\uC000\ud835\udd3csilon;\u4395u\u0100ai\u053C\u0549l\u0100;T\u0542\u0543\u6A75ilde;\u6242librium;\u61CC\u0100ci\u0557\u055Ar;\u6130m;\u6A73a;\u4397ml\u803B\xcb\u40CB\u0100ip\u056A\u056Fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058D\u05B2\u05CCy;\u4424r;\uC000\ud835\udd09lled\u0253\u0597\x00\x00\u05A3mallSquare;\u65FCerySmallSquare;\u65AA\u0370\u05BA\x00\u05BF\x00\x00\u05C4f;\uC000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05CB\u0600JTabcdfgorst\u05E8\u05EC\u05EF\u05FA\u0600\u0612\u0616\u061B\u061D\u0623\u066C\u0672cy;\u4403\u803B>\u403Emma\u0100;d\u05F7\u05F8\u4393;\u43DCreve;\u411E\u0180eiy\u0607\u060C\u0610dil;\u4122rc;\u411C;\u4413ot;\u4120r;\uC000\ud835\udd0a;\u62D9pf;\uC000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064E\u0656\u065B\u0666qual\u0100;L\u063E\u063F\u6265ess;\u62DBullEqual;\u6267reater;\u6AA2ess;\u6277lantEqual;\u6A7Eilde;\u6273cr;\uC000\ud835\udca2;\u626B\u0400Aacfiosu\u0685\u068B\u0696\u069B\u069E\u06AA\u06BE\u06CARDcy;\u442A\u0100ct\u0690\u0694ek;\u42C7;\u405Eirc;\u4124r;\u610ClbertSpace;\u610B\u01F0\u06AF\x00\u06B2f;\u610DizontalLine;\u6500\u0100ct\u06C3\u06C5\xf2\u06A9rok;\u4126mp\u0144\u06D0\u06D8ownHum\xf0\u012Fqual;\u624F\u0700EJOacdfgmnostu\u06FA\u06FE\u0703\u0707\u070E\u071A\u071E\u0721\u0728\u0744\u0778\u078B\u078F\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803B\xcd\u40CD\u0100iy\u0713\u0718rc\u803B\xce\u40CE;\u4418ot;\u4130r;\u6111rave\u803B\xcc\u40CC\u0180;ap\u0720\u072F\u073F\u0100cg\u0734\u0737r;\u412AinaryI;\u6148lie\xf3\u03DD\u01F4\u0749\x00\u0762\u0100;e\u074D\u074E\u622C\u0100gr\u0753\u0758ral;\u622Bsection;\u62C2isible\u0100CT\u076C\u0772omma;\u6063imes;\u6062\u0180gpt\u077F\u0783\u0788on;\u412Ef;\uC000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01EB\u079A\x00\u079Ecy;\u4406l\u803B\xcf\u40CF\u0280cfosu\u07AC\u07B7\u07BC\u07C2\u07D0\u0100iy\u07B1\u07B5rc;\u4134;\u4419r;\uC000\ud835\udd0dpf;\uC000\ud835\udd41\u01E3\u07C7\x00\u07CCr;\uC000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07E4\u07E8\u07EC\u07F1\u07FD\u0802\u0808cy;\u4425cy;\u440Cppa;\u439A\u0100ey\u07F6\u07FBdil;\u4136;\u441Ar;\uC000\ud835\udd0epf;\uC000\ud835\udd42cr;\uC000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082C\u0850\u0863\u09B3\u09B8\u09C7\u09CD\u0A37\u0A47cy;\u4409\u803B<\u403C\u0280cmnpr\u0837\u083C\u0841\u0844\u084Dute;\u4139bda;\u439Bg;\u67EAlacetrf;\u6112r;\u619E\u0180aey\u0857\u085C\u0861ron;\u413Ddil;\u413B;\u441B\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087E\u08A9\u08B1\u08E0\u08E6\u08FC\u092F\u095B\u0390\u096A\u0100nr\u0883\u088FgleBracket;\u67E8row\u0180;BR\u0899\u089A\u089E\u6190ar;\u61E4ightArrow;\u61C6eiling;\u6308o\u01F5\u08B7\x00\u08C3bleBracket;\u67E6n\u01D4\u08C8\x00\u08D2eeVector;\u6961ector\u0100;B\u08DB\u08DC\u61C3ar;\u6959loor;\u630Aight\u0100AV\u08EF\u08F5rrow;\u6194ector;\u694E\u0100er\u0901\u0917e\u0180;AV\u0909\u090A\u0910\u62A3rrow;\u61A4ector;\u695Aiangle\u0180;BE\u0924\u0925\u0929\u62B2ar;\u69CFqual;\u62B4p\u0180DTV\u0937\u0942\u094CownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61BFar;\u6958ector\u0100;B\u0965\u0966\u61BCar;\u6952ight\xe1\u039Cs\u0300EFGLST\u097E\u098B\u0995\u099D\u09A2\u09ADqualGreater;\u62DAullEqual;\u6266reater;\u6276ess;\u6AA1lantEqual;\u6A7Dilde;\u6272r;\uC000\ud835\udd0f\u0100;e\u09BD\u09BE\u62D8ftarrow;\u61DAidot;\u413F\u0180npw\u09D4\u0A16\u0A1Bg\u0200LRlr\u09DE\u09F7\u0A02\u0A10eft\u0100AR\u09E6\u09ECrrow;\u67F5ightArrow;\u67F7ightArrow;\u67F6eft\u0100ar\u03B3\u0A0Aight\xe1\u03BFight\xe1\u03CAf;\uC000\ud835\udd43er\u0100LR\u0A22\u0A2CeftArrow;\u6199ightArrow;\u6198\u0180cht\u0A3E\u0A40\u0A42\xf2\u084C;\u61B0rok;\u4141;\u626A\u0400acefiosu\u0A5A\u0A5D\u0A60\u0A77\u0A7C\u0A85\u0A8B\u0A8Ep;\u6905y;\u441C\u0100dl\u0A65\u0A6FiumSpace;\u605Flintrf;\u6133r;\uC000\ud835\udd10nusPlus;\u6213pf;\uC000\ud835\udd44c\xf2\u0A76;\u439C\u0480Jacefostu\u0AA3\u0AA7\u0AAD\u0AC0\u0B14\u0B19\u0D91\u0D97\u0D9Ecy;\u440Acute;\u4143\u0180aey\u0AB4\u0AB9\u0ABEron;\u4147dil;\u4145;\u441D\u0180gsw\u0AC7\u0AF0\u0B0Eative\u0180MTV\u0AD3\u0ADF\u0AE8ediumSpace;\u600Bhi\u0100cn\u0AE6\u0AD8\xeb\u0AD9eryThi\xee\u0AD9ted\u0100GL\u0AF8\u0B06reaterGreate\xf2\u0673essLes\xf3\u0A48Line;\u400Ar;\uC000\ud835\udd11\u0200Bnpt\u0B22\u0B28\u0B37\u0B3Areak;\u6060BreakingSpace;\u40A0f;\u6115\u0680;CDEGHLNPRSTV\u0B55\u0B56\u0B6A\u0B7C\u0BA1\u0BEB\u0C04\u0C5E\u0C84\u0CA6\u0CD8\u0D61\u0D85\u6AEC\u0100ou\u0B5B\u0B64ngruent;\u6262pCap;\u626DoubleVerticalBar;\u6226\u0180lqx\u0B83\u0B8A\u0B9Bement;\u6209ual\u0100;T\u0B92\u0B93\u6260ilde;\uC000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0BB6\u0BB7\u0BBD\u0BC9\u0BD3\u0BD8\u0BE5\u626Fqual;\u6271ullEqual;\uC000\u2267\u0338reater;\uC000\u226B\u0338ess;\u6279lantEqual;\uC000\u2A7E\u0338ilde;\u6275ump\u0144\u0BF2\u0BFDownHump;\uC000\u224E\u0338qual;\uC000\u224F\u0338e\u0100fs\u0C0A\u0C27tTriangle\u0180;BE\u0C1A\u0C1B\u0C21\u62EAar;\uC000\u29CF\u0338qual;\u62ECs\u0300;EGLST\u0C35\u0C36\u0C3C\u0C44\u0C4B\u0C58\u626Equal;\u6270reater;\u6278ess;\uC000\u226A\u0338lantEqual;\uC000\u2A7D\u0338ilde;\u6274ested\u0100GL\u0C68\u0C79reaterGreater;\uC000\u2AA2\u0338essLess;\uC000\u2AA1\u0338recedes\u0180;ES\u0C92\u0C93\u0C9B\u6280qual;\uC000\u2AAF\u0338lantEqual;\u62E0\u0100ei\u0CAB\u0CB9verseElement;\u620CghtTriangle\u0180;BE\u0CCB\u0CCC\u0CD2\u62EBar;\uC000\u29D0\u0338qual;\u62ED\u0100qu\u0CDD\u0D0CuareSu\u0100bp\u0CE8\u0CF9set\u0100;E\u0CF0\u0CF3\uC000\u228F\u0338qual;\u62E2erset\u0100;E\u0D03\u0D06\uC000\u2290\u0338qual;\u62E3\u0180bcp\u0D13\u0D24\u0D4Eset\u0100;E\u0D1B\u0D1E\uC000\u2282\u20D2qual;\u6288ceeds\u0200;EST\u0D32\u0D33\u0D3B\u0D46\u6281qual;\uC000\u2AB0\u0338lantEqual;\u62E1ilde;\uC000\u227F\u0338erset\u0100;E\u0D58\u0D5B\uC000\u2283\u20D2qual;\u6289ilde\u0200;EFT\u0D6E\u0D6F\u0D75\u0D7F\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uC000\ud835\udca9ilde\u803B\xd1\u40D1;\u439D\u0700Eacdfgmoprstuv\u0DBD\u0DC2\u0DC9\u0DD5\u0DDB\u0DE0\u0DE7\u0DFC\u0E02\u0E20\u0E22\u0E32\u0E3F\u0E44lig;\u4152cute\u803B\xd3\u40D3\u0100iy\u0DCE\u0DD3rc\u803B\xd4\u40D4;\u441Eblac;\u4150r;\uC000\ud835\udd12rave\u803B\xd2\u40D2\u0180aei\u0DEE\u0DF2\u0DF6cr;\u414Cga;\u43A9cron;\u439Fpf;\uC000\ud835\udd46enCurly\u0100DQ\u0E0E\u0E1AoubleQuote;\u601Cuote;\u6018;\u6A54\u0100cl\u0E27\u0E2Cr;\uC000\ud835\udcaaash\u803B\xd8\u40D8i\u016C\u0E37\u0E3Cde\u803B\xd5\u40D5es;\u6A37ml\u803B\xd6\u40D6er\u0100BP\u0E4B\u0E60\u0100ar\u0E50\u0E53r;\u603Eac\u0100ek\u0E5A\u0E5C;\u63DEet;\u63B4arenthesis;\u63DC\u0480acfhilors\u0E7F\u0E87\u0E8A\u0E8F\u0E92\u0E94\u0E9D\u0EB0\u0EFCrtialD;\u6202y;\u441Fr;\uC000\ud835\udd13i;\u43A6;\u43A0usMinus;\u40B1\u0100ip\u0EA2\u0EADncareplan\xe5\u069Df;\u6119\u0200;eio\u0EB9\u0EBA\u0EE0\u0EE4\u6ABBcedes\u0200;EST\u0EC8\u0EC9\u0ECF\u0EDA\u627Aqual;\u6AAFlantEqual;\u627Cilde;\u627Eme;\u6033\u0100dp\u0EE9\u0EEEuct;\u620Fortion\u0100;a\u0225\u0EF9l;\u621D\u0100ci\u0F01\u0F06r;\uC000\ud835\udcab;\u43A8\u0200Ufos\u0F11\u0F16\u0F1B\u0F1FOT\u803B"\u4022r;\uC000\ud835\udd14pf;\u611Acr;\uC000\ud835\udcac\u0600BEacefhiorsu\u0F3E\u0F43\u0F47\u0F60\u0F73\u0FA7\u0FAA\u0FAD\u1096\u10A9\u10B4\u10BEarr;\u6910G\u803B\xae\u40AE\u0180cnr\u0F4E\u0F53\u0F56ute;\u4154g;\u67EBr\u0100;t\u0F5C\u0F5D\u61A0l;\u6916\u0180aey\u0F67\u0F6C\u0F71ron;\u4158dil;\u4156;\u4420\u0100;v\u0F78\u0F79\u611Cerse\u0100EU\u0F82\u0F99\u0100lq\u0F87\u0F8Eement;\u620Builibrium;\u61CBpEquilibrium;\u696Fr\xbb\u0F79o;\u43A1ght\u0400ACDFTUVa\u0FC1\u0FEB\u0FF3\u1022\u1028\u105B\u1087\u03D8\u0100nr\u0FC6\u0FD2gleBracket;\u67E9row\u0180;BL\u0FDC\u0FDD\u0FE1\u6192ar;\u61E5eftArrow;\u61C4eiling;\u6309o\u01F5\u0FF9\x00\u1005bleBracket;\u67E7n\u01D4\u100A\x00\u1014eeVector;\u695Dector\u0100;B\u101D\u101E\u61C2ar;\u6955loor;\u630B\u0100er\u102D\u1043e\u0180;AV\u1035\u1036\u103C\u62A2rrow;\u61A6ector;\u695Biangle\u0180;BE\u1050\u1051\u1055\u62B3ar;\u69D0qual;\u62B5p\u0180DTV\u1063\u106E\u1078ownVector;\u694FeeVector;\u695Cector\u0100;B\u1082\u1083\u61BEar;\u6954ector\u0100;B\u1091\u1092\u61C0ar;\u6953\u0100pu\u109B\u109Ef;\u611DndImplies;\u6970ightarrow;\u61DB\u0100ch\u10B9\u10BCr;\u611B;\u61B1leDelayed;\u69F4\u0680HOacfhimoqstu\u10E4\u10F1\u10F7\u10FD\u1119\u111E\u1151\u1156\u1161\u1167\u11B5\u11BB\u11BF\u0100Cc\u10E9\u10EEHcy;\u4429y;\u4428FTcy;\u442Ccute;\u415A\u0280;aeiy\u1108\u1109\u110E\u1113\u1117\u6ABCron;\u4160dil;\u415Erc;\u415C;\u4421r;\uC000\ud835\udd16ort\u0200DLRU\u112A\u1134\u113E\u1149ownArrow\xbb\u041EeftArrow\xbb\u089AightArrow\xbb\u0FDDpArrow;\u6191gma;\u43A3allCircle;\u6218pf;\uC000\ud835\udd4a\u0272\u116D\x00\x00\u1170t;\u621Aare\u0200;ISU\u117B\u117C\u1189\u11AF\u65A1ntersection;\u6293u\u0100bp\u118F\u119Eset\u0100;E\u1197\u1198\u628Fqual;\u6291erset\u0100;E\u11A8\u11A9\u6290qual;\u6292nion;\u6294cr;\uC000\ud835\udcaear;\u62C6\u0200bcmp\u11C8\u11DB\u1209\u120B\u0100;s\u11CD\u11CE\u62D0et\u0100;E\u11CD\u11D5qual;\u6286\u0100ch\u11E0\u1205eeds\u0200;EST\u11ED\u11EE\u11F4\u11FF\u627Bqual;\u6AB0lantEqual;\u627Dilde;\u627FTh\xe1\u0F8C;\u6211\u0180;es\u1212\u1213\u1223\u62D1rset\u0100;E\u121C\u121D\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123E\u1244\u1249\u1255\u125E\u1271\u1276\u129F\u12C2\u12C8\u12D1ORN\u803B\xde\u40DEADE;\u6122\u0100Hc\u124E\u1252cy;\u440By;\u4426\u0100bu\u125A\u125C;\u4009;\u43A4\u0180aey\u1265\u126A\u126Fron;\u4164dil;\u4162;\u4422r;\uC000\ud835\udd17\u0100ei\u127B\u1289\u01F2\u1280\x00\u1287efore;\u6234a;\u4398\u0100cn\u128E\u1298kSpace;\uC000\u205F\u200ASpace;\u6009lde\u0200;EFT\u12AB\u12AC\u12B2\u12BC\u623Cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uC000\ud835\udd4bipleDot;\u60DB\u0100ct\u12D6\u12DBr;\uC000\ud835\udcafrok;\u4166\u0AE1\u12F7\u130E\u131A\u1326\x00\u132C\u1331\x00\x00\x00\x00\x00\u1338\u133D\u1377\u1385\x00\u13FF\u1404\u140A\u1410\u0100cr\u12FB\u1301ute\u803B\xda\u40DAr\u0100;o\u1307\u1308\u619Fcir;\u6949r\u01E3\u1313\x00\u1316y;\u440Eve;\u416C\u0100iy\u131E\u1323rc\u803B\xdb\u40DB;\u4423blac;\u4170r;\uC000\ud835\udd18rave\u803B\xd9\u40D9acr;\u416A\u0100di\u1341\u1369er\u0100BP\u1348\u135D\u0100ar\u134D\u1350r;\u405Fac\u0100ek\u1357\u1359;\u63DFet;\u63B5arenthesis;\u63DDon\u0100;P\u1370\u1371\u62C3lus;\u628E\u0100gp\u137B\u137Fon;\u4172f;\uC000\ud835\udd4c\u0400ADETadps\u1395\u13AE\u13B8\u13C4\u03E8\u13D2\u13D7\u13F3rrow\u0180;BD\u1150\u13A0\u13A4ar;\u6912ownArrow;\u61C5ownArrow;\u6195quilibrium;\u696Eee\u0100;A\u13CB\u13CC\u62A5rrow;\u61A5own\xe1\u03F3er\u0100LR\u13DE\u13E8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13F9\u13FA\u43D2on;\u43A5ing;\u416Ecr;\uC000\ud835\udcb0ilde;\u4168ml\u803B\xdc\u40DC\u0480Dbcdefosv\u1427\u142C\u1430\u1433\u143E\u1485\u148A\u1490\u1496ash;\u62ABar;\u6AEBy;\u4412ash\u0100;l\u143B\u143C\u62A9;\u6AE6\u0100er\u1443\u1445;\u62C1\u0180bty\u144C\u1450\u147Aar;\u6016\u0100;i\u144F\u1455cal\u0200BLST\u1461\u1465\u146A\u1474ar;\u6223ine;\u407Ceparator;\u6758ilde;\u6240ThinSpace;\u600Ar;\uC000\ud835\udd19pf;\uC000\ud835\udd4dcr;\uC000\ud835\udcb1dash;\u62AA\u0280cefos\u14A7\u14AC\u14B1\u14B6\u14BCirc;\u4174dge;\u62C0r;\uC000\ud835\udd1apf;\uC000\ud835\udd4ecr;\uC000\ud835\udcb2\u0200fios\u14CB\u14D0\u14D2\u14D8r;\uC000\ud835\udd1b;\u439Epf;\uC000\ud835\udd4fcr;\uC000\ud835\udcb3\u0480AIUacfosu\u14F1\u14F5\u14F9\u14FD\u1504\u150F\u1514\u151A\u1520cy;\u442Fcy;\u4407cy;\u442Ecute\u803B\xdd\u40DD\u0100iy\u1509\u150Drc;\u4176;\u442Br;\uC000\ud835\udd1cpf;\uC000\ud835\udd50cr;\uC000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153F\u154B\u154F\u155D\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417D;\u4417ot;\u417B\u01F2\u1554\x00\u155BoWidt\xe8\u0AD9a;\u4396r;\u6128pf;\u6124cr;\uC000\ud835\udcb5\u0BE1\u1583\u158A\u1590\x00\u15B0\u15B6\u15BF\x00\x00\x00\x00\u15C6\u15DB\u15EB\u165F\u166D\x00\u1695\u169B\u16B2\u16B9\x00\u16BEcute\u803B\xe1\u40E1reve;\u4103\u0300;Ediuy\u159C\u159D\u15A1\u15A3\u15A8\u15AD\u623E;\uC000\u223E\u0333;\u623Frc\u803B\xe2\u40E2te\u80BB\xb4\u0306;\u4430lig\u803B\xe6\u40E6\u0100;r\xb2\u15BA;\uC000\ud835\udd1erave\u803B\xe0\u40E0\u0100ep\u15CA\u15D6\u0100fp\u15CF\u15D4sym;\u6135\xe8\u15D3ha;\u43B1\u0100ap\u15DFc\u0100cl\u15E4\u15E7r;\u4101g;\u6A3F\u0264\u15F0\x00\x00\u160A\u0280;adsv\u15FA\u15FB\u15FF\u1601\u1607\u6227nd;\u6A55;\u6A5Clope;\u6A58;\u6A5A\u0380;elmrsz\u1618\u1619\u161B\u161E\u163F\u164F\u1659\u6220;\u69A4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163A\u163C\u163E;\u69A8;\u69A9;\u69AA;\u69AB;\u69AC;\u69AD;\u69AE;\u69AFt\u0100;v\u1645\u1646\u621Fb\u0100;d\u164C\u164D\u62BE;\u699D\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637C\u0100gp\u1663\u1667on;\u4105f;\uC000\ud835\udd52\u0380;Eaeiop\u12C1\u167B\u167D\u1682\u1684\u1687\u168A;\u6A70cir;\u6A6F;\u624Ad;\u624Bs;\u4027rox\u0100;e\u12C1\u1692\xf1\u1683ing\u803B\xe5\u40E5\u0180cty\u16A1\u16A6\u16A8r;\uC000\ud835\udcb6;\u402Amp\u0100;e\u12C1\u16AF\xf1\u0288ilde\u803B\xe3\u40E3ml\u803B\xe4\u40E4\u0100ci\u16C2\u16C8onin\xf4\u0272nt;\u6A11\u0800Nabcdefiklnoprsu\u16ED\u16F1\u1730\u173C\u1743\u1748\u1778\u177D\u17E0\u17E6\u1839\u1850\u170D\u193D\u1948\u1970ot;\u6AED\u0100cr\u16F6\u171Ek\u0200ceps\u1700\u1705\u170D\u1713ong;\u624Cpsilon;\u43F6rime;\u6035im\u0100;e\u171A\u171B\u623Dq;\u62CD\u0176\u1722\u1726ee;\u62BDed\u0100;g\u172C\u172D\u6305e\xbb\u172Drk\u0100;t\u135C\u1737brk;\u63B6\u0100oy\u1701\u1741;\u4431quo;\u601E\u0280cmprt\u1753\u175B\u1761\u1764\u1768aus\u0100;e\u010A\u0109ptyv;\u69B0s\xe9\u170Cno\xf5\u0113\u0180ahw\u176F\u1771\u1773;\u43B2;\u6136een;\u626Cr;\uC000\ud835\udd1fg\u0380costuvw\u178D\u179D\u17B3\u17C1\u17D5\u17DB\u17DE\u0180aiu\u1794\u1796\u179A\xf0\u0760rc;\u65EFp\xbb\u1371\u0180dpt\u17A4\u17A8\u17ADot;\u6A00lus;\u6A01imes;\u6A02\u0271\u17B9\x00\x00\u17BEcup;\u6A06ar;\u6605riangle\u0100du\u17CD\u17D2own;\u65BDp;\u65B3plus;\u6A04e\xe5\u1444\xe5\u14ADarow;\u690D\u0180ako\u17ED\u1826\u1835\u0100cn\u17F2\u1823k\u0180lst\u17FA\u05AB\u1802ozenge;\u69EBriangle\u0200;dlr\u1812\u1813\u1818\u181D\u65B4own;\u65BEeft;\u65C2ight;\u65B8k;\u6423\u01B1\u182B\x00\u1833\u01B2\u182F\x00\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183E\u184D\u0100;q\u1843\u1846\uC000=\u20E5uiv;\uC000\u2261\u20E5t;\u6310\u0200ptwx\u1859\u185E\u1867\u186Cf;\uC000\ud835\udd53\u0100;t\u13CB\u1863om\xbb\u13CCtie;\u62C8\u0600DHUVbdhmptuv\u1885\u1896\u18AA\u18BB\u18D7\u18DB\u18EC\u18FF\u1905\u190A\u1910\u1921\u0200LRlr\u188E\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18A1\u18A2\u18A4\u18A6\u18A8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18B3\u18B5\u18B7\u18B9;\u655D;\u655A;\u655C;\u6559\u0380;HLRhlr\u18CA\u18CB\u18CD\u18CF\u18D1\u18D3\u18D5\u6551;\u656C;\u6563;\u6560;\u656B;\u6562;\u655Fox;\u69C9\u0200LRlr\u18E4\u18E6\u18E8\u18EA;\u6555;\u6552;\u6510;\u650C\u0280;DUdu\u06BD\u18F7\u18F9\u18FB\u18FD;\u6565;\u6568;\u652C;\u6534inus;\u629Flus;\u629Eimes;\u62A0\u0200LRlr\u1919\u191B\u191D\u191F;\u655B;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193B\u6502;\u656A;\u6561;\u655E;\u653C;\u6524;\u651C\u0100ev\u0123\u1942bar\u803B\xa6\u40A6\u0200ceio\u1951\u1956\u195A\u1960r;\uC000\ud835\udcb7mi;\u604Fm\u0100;e\u171A\u171Cl\u0180;bh\u1968\u1969\u196B\u405C;\u69C5sub;\u67C8\u016C\u1974\u197El\u0100;e\u1979\u197A\u6022t\xbb\u197Ap\u0180;Ee\u012F\u1985\u1987;\u6AAE\u0100;q\u06DC\u06DB\u0CE1\u19A7\x00\u19E8\u1A11\u1A15\u1A32\x00\u1A37\u1A50\x00\x00\u1AB4\x00\x00\u1AC1\x00\x00\u1B21\u1B2E\u1B4D\u1B52\x00\u1BFD\x00\u1C0C\u0180cpr\u19AD\u19B2\u19DDute;\u4107\u0300;abcds\u19BF\u19C0\u19C4\u19CA\u19D5\u19D9\u6229nd;\u6A44rcup;\u6A49\u0100au\u19CF\u19D2p;\u6A4Bp;\u6A47ot;\u6A40;\uC000\u2229\uFE00\u0100eo\u19E2\u19E5t;\u6041\xee\u0693\u0200aeiu\u19F0\u19FB\u1A01\u1A05\u01F0\u19F5\x00\u19F8s;\u6A4Don;\u410Ddil\u803B\xe7\u40E7rc;\u4109ps\u0100;s\u1A0C\u1A0D\u6A4Cm;\u6A50ot;\u410B\u0180dmn\u1A1B\u1A20\u1A26il\u80BB\xb8\u01ADptyv;\u69B2t\u8100\xa2;e\u1A2D\u1A2E\u40A2r\xe4\u01B2r;\uC000\ud835\udd20\u0180cei\u1A3D\u1A40\u1A4Dy;\u4447ck\u0100;m\u1A47\u1A48\u6713ark\xbb\u1A48;\u43C7r\u0380;Ecefms\u1A5F\u1A60\u1A62\u1A6B\u1AA4\u1AAA\u1AAE\u65CB;\u69C3\u0180;el\u1A69\u1A6A\u1A6D\u42C6q;\u6257e\u0261\u1A74\x00\x00\u1A88rrow\u0100lr\u1A7C\u1A81eft;\u61BAight;\u61BB\u0280RSacd\u1A92\u1A94\u1A96\u1A9A\u1A9F\xbb\u0F47;\u64C8st;\u629Birc;\u629Aash;\u629Dnint;\u6A10id;\u6AEFcir;\u69C2ubs\u0100;u\u1ABB\u1ABC\u6663it\xbb\u1ABC\u02EC\u1AC7\u1AD4\u1AFA\x00\u1B0Aon\u0100;e\u1ACD\u1ACE\u403A\u0100;q\xc7\xc6\u026D\u1AD9\x00\x00\u1AE2a\u0100;t\u1ADE\u1ADF\u402C;\u4040\u0180;fl\u1AE8\u1AE9\u1AEB\u6201\xee\u1160e\u0100mx\u1AF1\u1AF6ent\xbb\u1AE9e\xf3\u024D\u01E7\u1AFE\x00\u1B07\u0100;d\u12BB\u1B02ot;\u6A6Dn\xf4\u0246\u0180fry\u1B10\u1B14\u1B17;\uC000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1B1Dr;\u6117\u0100ao\u1B25\u1B29rr;\u61B5ss;\u6717\u0100cu\u1B32\u1B37r;\uC000\ud835\udcb8\u0100bp\u1B3C\u1B44\u0100;e\u1B41\u1B42\u6ACF;\u6AD1\u0100;e\u1B49\u1B4A\u6AD0;\u6AD2dot;\u62EF\u0380delprvw\u1B60\u1B6C\u1B77\u1B82\u1BAC\u1BD4\u1BF9arr\u0100lr\u1B68\u1B6A;\u6938;\u6935\u0270\u1B72\x00\x00\u1B75r;\u62DEc;\u62DFarr\u0100;p\u1B7F\u1B80\u61B6;\u693D\u0300;bcdos\u1B8F\u1B90\u1B96\u1BA1\u1BA5\u1BA8\u622Arcap;\u6A48\u0100au\u1B9B\u1B9Ep;\u6A46p;\u6A4Aot;\u628Dr;\u6A45;\uC000\u222A\uFE00\u0200alrv\u1BB5\u1BBF\u1BDE\u1BE3rr\u0100;m\u1BBC\u1BBD\u61B7;\u693Cy\u0180evw\u1BC7\u1BD4\u1BD8q\u0270\u1BCE\x00\x00\u1BD2re\xe3\u1B73u\xe3\u1B75ee;\u62CEedge;\u62CFen\u803B\xa4\u40A4earrow\u0100lr\u1BEE\u1BF3eft\xbb\u1B80ight\xbb\u1BBDe\xe4\u1BDD\u0100ci\u1C01\u1C07onin\xf4\u01F7nt;\u6231lcty;\u632D\u0980AHabcdefhijlorstuwz\u1C38\u1C3B\u1C3F\u1C5D\u1C69\u1C75\u1C8A\u1C9E\u1CAC\u1CB7\u1CFB\u1CFF\u1D0D\u1D7B\u1D91\u1DAB\u1DBB\u1DC6\u1DCDr\xf2\u0381ar;\u6965\u0200glrs\u1C48\u1C4D\u1C52\u1C54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1C5A\u1C5B\u6010\xbb\u090A\u016B\u1C61\u1C67arow;\u690Fa\xe3\u0315\u0100ay\u1C6E\u1C73ron;\u410F;\u4434\u0180;ao\u0332\u1C7C\u1C84\u0100gr\u02BF\u1C81r;\u61CAtseq;\u6A77\u0180glm\u1C91\u1C94\u1C98\u803B\xb0\u40B0ta;\u43B4ptyv;\u69B1\u0100ir\u1CA3\u1CA8sht;\u697F;\uC000\ud835\udd21ar\u0100lr\u1CB3\u1CB5\xbb\u08DC\xbb\u101E\u0280aegsv\u1CC2\u0378\u1CD6\u1CDC\u1CE0m\u0180;os\u0326\u1CCA\u1CD4nd\u0100;s\u0326\u1CD1uit;\u6666amma;\u43DDin;\u62F2\u0180;io\u1CE7\u1CE8\u1CF8\u40F7de\u8100\xf7;o\u1CE7\u1CF0ntimes;\u62C7n\xf8\u1CF7cy;\u4452c\u026F\u1D06\x00\x00\u1D0Arn;\u631Eop;\u630D\u0280lptuw\u1D18\u1D1D\u1D22\u1D49\u1D55lar;\u4024f;\uC000\ud835\udd55\u0280;emps\u030B\u1D2D\u1D37\u1D3D\u1D42q\u0100;d\u0352\u1D33ot;\u6251inus;\u6238lus;\u6214quare;\u62A1blebarwedg\xe5\xfan\u0180adh\u112E\u1D5D\u1D67ownarrow\xf3\u1C83arpoon\u0100lr\u1D72\u1D76ef\xf4\u1CB4igh\xf4\u1CB6\u0162\u1D7F\u1D85karo\xf7\u0F42\u026F\u1D8A\x00\x00\u1D8Ern;\u631Fop;\u630C\u0180cot\u1D98\u1DA3\u1DA6\u0100ry\u1D9D\u1DA1;\uC000\ud835\udcb9;\u4455l;\u69F6rok;\u4111\u0100dr\u1DB0\u1DB4ot;\u62F1i\u0100;f\u1DBA\u1816\u65BF\u0100ah\u1DC0\u1DC3r\xf2\u0429a\xf2\u0FA6angle;\u69A6\u0100ci\u1DD2\u1DD5y;\u445Fgrarr;\u67FF\u0900Dacdefglmnopqrstux\u1E01\u1E09\u1E19\u1E38\u0578\u1E3C\u1E49\u1E61\u1E7E\u1EA5\u1EAF\u1EBD\u1EE1\u1F2A\u1F37\u1F44\u1F4E\u1F5A\u0100Do\u1E06\u1D34o\xf4\u1C89\u0100cs\u1E0E\u1E14ute\u803B\xe9\u40E9ter;\u6A6E\u0200aioy\u1E22\u1E27\u1E31\u1E36ron;\u411Br\u0100;c\u1E2D\u1E2E\u6256\u803B\xea\u40EAlon;\u6255;\u444Dot;\u4117\u0100Dr\u1E41\u1E45ot;\u6252;\uC000\ud835\udd22\u0180;rs\u1E50\u1E51\u1E57\u6A9Aave\u803B\xe8\u40E8\u0100;d\u1E5C\u1E5D\u6A96ot;\u6A98\u0200;ils\u1E6A\u1E6B\u1E72\u1E74\u6A99nters;\u63E7;\u6113\u0100;d\u1E79\u1E7A\u6A95ot;\u6A97\u0180aps\u1E85\u1E89\u1E97cr;\u4113ty\u0180;sv\u1E92\u1E93\u1E95\u6205et\xbb\u1E93p\u01001;\u1E9D\u1EA4\u0133\u1EA1\u1EA3;\u6004;\u6005\u6003\u0100gs\u1EAA\u1EAC;\u414Bp;\u6002\u0100gp\u1EB4\u1EB8on;\u4119f;\uC000\ud835\udd56\u0180als\u1EC4\u1ECE\u1ED2r\u0100;s\u1ECA\u1ECB\u62D5l;\u69E3us;\u6A71i\u0180;lv\u1EDA\u1EDB\u1EDF\u43B5on\xbb\u1EDB;\u43F5\u0200csuv\u1EEA\u1EF3\u1F0B\u1F23\u0100io\u1EEF\u1E31rc\xbb\u1E2E\u0269\u1EF9\x00\x00\u1EFB\xed\u0548ant\u0100gl\u1F02\u1F06tr\xbb\u1E5Dess\xbb\u1E7A\u0180aei\u1F12\u1F16\u1F1Als;\u403Dst;\u625Fv\u0100;D\u0235\u1F20D;\u6A78parsl;\u69E5\u0100Da\u1F2F\u1F33ot;\u6253rr;\u6971\u0180cdi\u1F3E\u1F41\u1EF8r;\u612Fo\xf4\u0352\u0100ah\u1F49\u1F4B;\u43B7\u803B\xf0\u40F0\u0100mr\u1F53\u1F57l\u803B\xeb\u40EBo;\u60AC\u0180cip\u1F61\u1F64\u1F67l;\u4021s\xf4\u056E\u0100eo\u1F6C\u1F74ctatio\xee\u0559nential\xe5\u0579\u09E1\u1F92\x00\u1F9E\x00\u1FA1\u1FA7\x00\x00\u1FC6\u1FCC\x00\u1FD3\x00\u1FE6\u1FEA\u2000\x00\u2008\u205Allingdotse\xf1\u1E44y;\u4444male;\u6640\u0180ilr\u1FAD\u1FB3\u1FC1lig;\u8000\uFB03\u0269\u1FB9\x00\x00\u1FBDg;\u8000\uFB00ig;\u8000\uFB04;\uC000\ud835\udd23lig;\u8000\uFB01lig;\uC000fj\u0180alt\u1FD9\u1FDC\u1FE1t;\u666Dig;\u8000\uFB02ns;\u65B1of;\u4192\u01F0\u1FEE\x00\u1FF3f;\uC000\ud835\udd57\u0100ak\u05BF\u1FF7\u0100;v\u1FFC\u1FFD\u62D4;\u6AD9artint;\u6A0D\u0100ao\u200C\u2055\u0100cs\u2011\u2052\u03B1\u201A\u2030\u2038\u2045\u2048\x00\u2050\u03B2\u2022\u2025\u2027\u202A\u202C\x00\u202E\u803B\xbd\u40BD;\u6153\u803B\xbc\u40BC;\u6155;\u6159;\u615B\u01B3\u2034\x00\u2036;\u6154;\u6156\u02B4\u203E\u2041\x00\x00\u2043\u803B\xbe\u40BE;\u6157;\u615C5;\u6158\u01B6\u204C\x00\u204E;\u615A;\u615D8;\u615El;\u6044wn;\u6322cr;\uC000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209F\u20A5\u20B0\u20B4\u20F0\u20F5\u20FA\u20FF\u2103\u2112\u2138\u0317\u213E\u2152\u219E\u0100;l\u064D\u2087;\u6A8C\u0180cmp\u2090\u2095\u209Dute;\u41F5ma\u0100;d\u209C\u1CDA\u43B3;\u6A86reve;\u411F\u0100iy\u20AA\u20AErc;\u411D;\u4433ot;\u4121\u0200;lqs\u063E\u0642\u20BD\u20C9\u0180;qs\u063E\u064C\u20C4lan\xf4\u0665\u0200;cdl\u0665\u20D2\u20D5\u20E5c;\u6AA9ot\u0100;o\u20DC\u20DD\u6A80\u0100;l\u20E2\u20E3\u6A82;\u6A84\u0100;e\u20EA\u20ED\uC000\u22DB\uFE00s;\u6A94r;\uC000\ud835\udd24\u0100;g\u0673\u061Bmel;\u6137cy;\u4453\u0200;Eaj\u065A\u210C\u210E\u2110;\u6A92;\u6AA5;\u6AA4\u0200Eaes\u211B\u211D\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6A8Arox\xbb\u2124\u0100;q\u212E\u212F\u6A88\u0100;q\u212E\u211Bim;\u62E7pf;\uC000\ud835\udd58\u0100ci\u2143\u2146r;\u610Am\u0180;el\u066B\u214E\u2150;\u6A8E;\u6A90\u8300>;cdlqr\u05EE\u2160\u216A\u216E\u2173\u2179\u0100ci\u2165\u2167;\u6AA7r;\u6A7Aot;\u62D7Par;\u6995uest;\u6A7C\u0280adels\u2184\u216A\u2190\u0656\u219B\u01F0\u2189\x00\u218Epro\xf8\u209Er;\u6978q\u0100lq\u063F\u2196les\xf3\u2088i\xed\u066B\u0100en\u21A3\u21ADrtneqq;\uC000\u2269\uFE00\xc5\u21AA\u0500Aabcefkosy\u21C4\u21C7\u21F1\u21F5\u21FA\u2218\u221D\u222F\u2268\u227Dr\xf2\u03A0\u0200ilmr\u21D0\u21D4\u21D7\u21DBrs\xf0\u1484f\xbb\u2024il\xf4\u06A9\u0100dr\u21E0\u21E4cy;\u444A\u0180;cw\u08F4\u21EB\u21EFir;\u6948;\u61ADar;\u610Firc;\u4125\u0180alr\u2201\u220E\u2213rts\u0100;u\u2209\u220A\u6665it\xbb\u220Alip;\u6026con;\u62B9r;\uC000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223A\u223E\u2243\u225E\u2263rr;\u61FFtht;\u623Bk\u0100lr\u2249\u2253eftarrow;\u61A9ightarrow;\u61AAf;\uC000\ud835\udd59bar;\u6015\u0180clt\u226F\u2274\u2278r;\uC000\ud835\udcbdas\xe8\u21F4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1C5B\u0AE1\u22A3\x00\u22AA\x00\u22B8\u22C5\u22CE\x00\u22D5\u22F3\x00\x00\u22F8\u2322\u2367\u2362\u237F\x00\u2386\u23AA\u23B4cute\u803B\xed\u40ED\u0180;iy\u0771\u22B0\u22B5rc\u803B\xee\u40EE;\u4438\u0100cx\u22BC\u22BFy;\u4435cl\u803B\xa1\u40A1\u0100fr\u039F\u22C9;\uC000\ud835\udd26rave\u803B\xec\u40EC\u0200;ino\u073E\u22DD\u22E9\u22EE\u0100in\u22E2\u22E6nt;\u6A0Ct;\u622Dfin;\u69DCta;\u6129lig;\u4133\u0180aop\u22FE\u231A\u231D\u0180cgt\u2305\u2308\u2317r;\u412B\u0180elp\u071F\u230F\u2313in\xe5\u078Ear\xf4\u0720h;\u4131f;\u62B7ed;\u41B5\u0280;cfot\u04F4\u232C\u2331\u233D\u2341are;\u6105in\u0100;t\u2338\u2339\u621Eie;\u69DDdo\xf4\u2319\u0280;celp\u0757\u234C\u2350\u235B\u2361al;\u62BA\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234Darhk;\u6A17rod;\u6A3C\u0200cgpt\u236F\u2372\u2376\u237By;\u4451on;\u412Ff;\uC000\ud835\udd5aa;\u43B9uest\u803B\xbf\u40BF\u0100ci\u238A\u238Fr;\uC000\ud835\udcben\u0280;Edsv\u04F4\u239B\u239D\u23A1\u04F3;\u62F9ot;\u62F5\u0100;v\u23A6\u23A7\u62F4;\u62F3\u0100;i\u0777\u23AElde;\u4129\u01EB\u23B8\x00\u23BCcy;\u4456l\u803B\xef\u40EF\u0300cfmosu\u23CC\u23D7\u23DC\u23E1\u23E7\u23F5\u0100iy\u23D1\u23D5rc;\u4135;\u4439r;\uC000\ud835\udd27ath;\u4237pf;\uC000\ud835\udd5b\u01E3\u23EC\x00\u23F1r;\uC000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240B\u2416\u2422\u2427\u242D\u2431\u2435\u243Bppa\u0100;v\u2413\u2414\u43BA;\u43F0\u0100ey\u241B\u2420dil;\u4137;\u443Ar;\uC000\ud835\udd28reen;\u4138cy;\u4445cy;\u445Cpf;\uC000\ud835\udd5ccr;\uC000\ud835\udcc0\u0B80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248D\u2491\u250E\u253D\u255A\u2580\u264E\u265E\u2665\u2679\u267D\u269A\u26B2\u26D8\u275D\u2768\u278B\u27C0\u2801\u2812\u0180art\u2477\u247A\u247Cr\xf2\u09C6\xf2\u0395ail;\u691Barr;\u690E\u0100;g\u0994\u248B;\u6A8Bar;\u6962\u0963\u24A5\x00\u24AA\x00\u24B1\x00\x00\x00\x00\x00\u24B5\u24BA\x00\u24C6\u24C8\u24CD\x00\u24F9ute;\u413Amptyv;\u69B4ra\xee\u084Cbda;\u43BBg\u0180;dl\u088E\u24C1\u24C3;\u6991\xe5\u088E;\u6A85uo\u803B\xab\u40ABr\u0400;bfhlpst\u0899\u24DE\u24E6\u24E9\u24EB\u24EE\u24F1\u24F5\u0100;f\u089D\u24E3s;\u691Fs;\u691D\xeb\u2252p;\u61ABl;\u6939im;\u6973l;\u61A2\u0180;ae\u24FF\u2500\u2504\u6AABil;\u6919\u0100;s\u2509\u250A\u6AAD;\uC000\u2AAD\uFE00\u0180abr\u2515\u2519\u251Drr;\u690Crk;\u6772\u0100ak\u2522\u252Cc\u0100ek\u2528\u252A;\u407B;\u405B\u0100es\u2531\u2533;\u698Bl\u0100du\u2539\u253B;\u698F;\u698D\u0200aeuy\u2546\u254B\u2556\u2558ron;\u413E\u0100di\u2550\u2554il;\u413C\xec\u08B0\xe2\u2529;\u443B\u0200cqrs\u2563\u2566\u256D\u257Da;\u6936uo\u0100;r\u0E19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694Bh;\u61B2\u0280;fgqs\u258B\u258C\u0989\u25F3\u25FF\u6264t\u0280ahlrt\u2598\u25A4\u25B7\u25C2\u25E8rrow\u0100;t\u0899\u25A1a\xe9\u24F6arpoon\u0100du\u25AF\u25B4own\xbb\u045Ap\xbb\u0966eftarrows;\u61C7ight\u0180ahs\u25CD\u25D6\u25DErrow\u0100;s\u08F4\u08A7arpoon\xf3\u0F98quigarro\xf7\u21F0hreetimes;\u62CB\u0180;qs\u258B\u0993\u25FAlan\xf4\u09AC\u0280;cdgs\u09AC\u260A\u260D\u261D\u2628c;\u6AA8ot\u0100;o\u2614\u2615\u6A7F\u0100;r\u261A\u261B\u6A81;\u6A83\u0100;e\u2622\u2625\uC000\u22DA\uFE00s;\u6A93\u0280adegs\u2633\u2639\u263D\u2649\u264Bppro\xf8\u24C6ot;\u62D6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248C\xf4\u099Bi\xed\u09B2\u0180ilr\u2655\u08E1\u265Asht;\u697C;\uC000\ud835\udd29\u0100;E\u099C\u2663;\u6A91\u0161\u2669\u2676r\u0100du\u25B2\u266E\u0100;l\u0965\u2673;\u696Alk;\u6584cy;\u4459\u0280;acht\u0A48\u2688\u268B\u2691\u2696r\xf2\u25C1orne\xf2\u1D08ard;\u696Bri;\u65FA\u0100io\u269F\u26A4dot;\u4140ust\u0100;a\u26AC\u26AD\u63B0che\xbb\u26AD\u0200Eaes\u26BB\u26BD\u26C9\u26D4;\u6268p\u0100;p\u26C3\u26C4\u6A89rox\xbb\u26C4\u0100;q\u26CE\u26CF\u6A87\u0100;q\u26CE\u26BBim;\u62E6\u0400abnoptwz\u26E9\u26F4\u26F7\u271A\u272F\u2741\u2747\u2750\u0100nr\u26EE\u26F1g;\u67ECr;\u61FDr\xeb\u08C1g\u0180lmr\u26FF\u270D\u2714eft\u0100ar\u09E6\u2707ight\xe1\u09F2apsto;\u67FCight\xe1\u09FDparrow\u0100lr\u2725\u2729ef\xf4\u24EDight;\u61AC\u0180afl\u2736\u2739\u273Dr;\u6985;\uC000\ud835\udd5dus;\u6A2Dimes;\u6A34\u0161\u274B\u274Fst;\u6217\xe1\u134E\u0180;ef\u2757\u2758\u1800\u65CAnge\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277C\u2785\u2787r\xf2\u08A8orne\xf2\u1D8Car\u0100;d\u0F98\u2783;\u696D;\u600Eri;\u62BF\u0300achiqt\u2798\u279D\u0A40\u27A2\u27AE\u27BBquo;\u6039r;\uC000\ud835\udcc1m\u0180;eg\u09B2\u27AA\u27AC;\u6A8D;\u6A8F\u0100bu\u252A\u27B3o\u0100;r\u0E1F\u27B9;\u601Arok;\u4142\u8400<;cdhilqr\u082B\u27D2\u2639\u27DC\u27E0\u27E5\u27EA\u27F0\u0100ci\u27D7\u27D9;\u6AA6r;\u6A79re\xe5\u25F2mes;\u62C9arr;\u6976uest;\u6A7B\u0100Pi\u27F5\u27F9ar;\u6996\u0180;ef\u2800\u092D\u181B\u65C3r\u0100du\u2807\u280Dshar;\u694Ahar;\u6966\u0100en\u2817\u2821rtneqq;\uC000\u2268\uFE00\xc5\u281E\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288E\u2893\u28A0\u28A5\u28A8\u28DA\u28E2\u28E4\u0A83\u28F3\u2902Dot;\u623A\u0200clpr\u284E\u2852\u2863\u287Dr\u803B\xaf\u40AF\u0100et\u2857\u2859;\u6642\u0100;e\u285E\u285F\u6720se\xbb\u285F\u0100;s\u103B\u2868to\u0200;dlu\u103B\u2873\u2877\u287Bow\xee\u048Cef\xf4\u090F\xf0\u13D1ker;\u65AE\u0100oy\u2887\u288Cmma;\u6A29;\u443Cash;\u6014asuredangle\xbb\u1626r;\uC000\ud835\udd2ao;\u6127\u0180cdn\u28AF\u28B4\u28C9ro\u803B\xb5\u40B5\u0200;acd\u1464\u28BD\u28C0\u28C4s\xf4\u16A7ir;\u6AF0ot\u80BB\xb7\u01B5us\u0180;bd\u28D2\u1903\u28D3\u6212\u0100;u\u1D3C\u28D8;\u6A2A\u0163\u28DE\u28E1p;\u6ADB\xf2\u2212\xf0\u0A81\u0100dp\u28E9\u28EEels;\u62A7f;\uC000\ud835\udd5e\u0100ct\u28F8\u28FDr;\uC000\ud835\udcc2pos\xbb\u159D\u0180;lm\u2909\u290A\u290D\u43BCtimap;\u62B8\u0C00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297E\u2989\u2998\u29DA\u29E9\u2A15\u2A1A\u2A58\u2A5D\u2A83\u2A95\u2AA4\u2AA8\u2B04\u2B07\u2B44\u2B7F\u2BAE\u2C34\u2C67\u2C7C\u2CE9\u0100gt\u2947\u294B;\uC000\u22D9\u0338\u0100;v\u2950\u0BCF\uC000\u226B\u20D2\u0180elt\u295A\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61CDightarrow;\u61CE;\uC000\u22D8\u0338\u0100;v\u297B\u0C47\uC000\u226A\u20D2ightarrow;\u61CF\u0100Dd\u298E\u2993ash;\u62AFash;\u62AE\u0280bcnpt\u29A3\u29A7\u29AC\u29B1\u29CCla\xbb\u02DEute;\u4144g;\uC000\u2220\u20D2\u0280;Eiop\u0D84\u29BC\u29C0\u29C5\u29C8;\uC000\u2A70\u0338d;\uC000\u224B\u0338s;\u4149ro\xf8\u0D84ur\u0100;a\u29D3\u29D4\u666El\u0100;s\u29D3\u0B38\u01F3\u29DF\x00\u29E3p\u80BB\xa0\u0B37mp\u0100;e\u0BF9\u0C00\u0280aeouy\u29F4\u29FE\u2A03\u2A10\u2A13\u01F0\u29F9\x00\u29FB;\u6A43on;\u4148dil;\u4146ng\u0100;d\u0D7E\u2A0Aot;\uC000\u2A6D\u0338p;\u6A42;\u443Dash;\u6013\u0380;Aadqsx\u0B92\u2A29\u2A2D\u2A3B\u2A41\u2A45\u2A50rr;\u61D7r\u0100hr\u2A33\u2A36k;\u6924\u0100;o\u13F2\u13F0ot;\uC000\u2250\u0338ui\xf6\u0B63\u0100ei\u2A4A\u2A4Ear;\u6928\xed\u0B98ist\u0100;s\u0BA0\u0B9Fr;\uC000\ud835\udd2b\u0200Eest\u0BC5\u2A66\u2A79\u2A7C\u0180;qs\u0BBC\u2A6D\u0BE1\u0180;qs\u0BBC\u0BC5\u2A74lan\xf4\u0BE2i\xed\u0BEA\u0100;r\u0BB6\u2A81\xbb\u0BB7\u0180Aap\u2A8A\u2A8D\u2A91r\xf2\u2971rr;\u61AEar;\u6AF2\u0180;sv\u0F8D\u2A9C\u0F8C\u0100;d\u2AA1\u2AA2\u62FC;\u62FAcy;\u445A\u0380AEadest\u2AB7\u2ABA\u2ABE\u2AC2\u2AC5\u2AF6\u2AF9r\xf2\u2966;\uC000\u2266\u0338rr;\u619Ar;\u6025\u0200;fqs\u0C3B\u2ACE\u2AE3\u2AEFt\u0100ar\u2AD4\u2AD9rro\xf7\u2AC1ightarro\xf7\u2A90\u0180;qs\u0C3B\u2ABA\u2AEAlan\xf4\u0C55\u0100;s\u0C55\u2AF4\xbb\u0C36i\xed\u0C5D\u0100;r\u0C35\u2AFEi\u0100;e\u0C1A\u0C25i\xe4\u0D90\u0100pt\u2B0C\u2B11f;\uC000\ud835\udd5f\u8180\xac;in\u2B19\u2B1A\u2B36\u40ACn\u0200;Edv\u0B89\u2B24\u2B28\u2B2E;\uC000\u22F9\u0338ot;\uC000\u22F5\u0338\u01E1\u0B89\u2B33\u2B35;\u62F7;\u62F6i\u0100;v\u0CB8\u2B3C\u01E1\u0CB8\u2B41\u2B43;\u62FE;\u62FD\u0180aor\u2B4B\u2B63\u2B69r\u0200;ast\u0B7B\u2B55\u2B5A\u2B5Flle\xec\u0B7Bl;\uC000\u2AFD\u20E5;\uC000\u2202\u0338lint;\u6A14\u0180;ce\u0C92\u2B70\u2B73u\xe5\u0CA5\u0100;c\u0C98\u2B78\u0100;e\u0C92\u2B7D\xf1\u0C98\u0200Aait\u2B88\u2B8B\u2B9D\u2BA7r\xf2\u2988rr\u0180;cw\u2B94\u2B95\u2B99\u619B;\uC000\u2933\u0338;\uC000\u219D\u0338ghtarrow\xbb\u2B95ri\u0100;e\u0CCB\u0CD6\u0380chimpqu\u2BBD\u2BCD\u2BD9\u2B04\u0B78\u2BE4\u2BEF\u0200;cer\u0D32\u2BC6\u0D37\u2BC9u\xe5\u0D45;\uC000\ud835\udcc3ort\u026D\u2B05\x00\x00\u2BD6ar\xe1\u2B56m\u0100;e\u0D6E\u2BDF\u0100;q\u0D74\u0D73su\u0100bp\u2BEB\u2BED\xe5\u0CF8\xe5\u0D0B\u0180bcp\u2BF6\u2C11\u2C19\u0200;Ees\u2BFF\u2C00\u0D22\u2C04\u6284;\uC000\u2AC5\u0338et\u0100;e\u0D1B\u2C0Bq\u0100;q\u0D23\u2C00c\u0100;e\u0D32\u2C17\xf1\u0D38\u0200;Ees\u2C22\u2C23\u0D5F\u2C27\u6285;\uC000\u2AC6\u0338et\u0100;e\u0D58\u2C2Eq\u0100;q\u0D60\u2C23\u0200gilr\u2C3D\u2C3F\u2C45\u2C47\xec\u0BD7lde\u803B\xf1\u40F1\xe7\u0C43iangle\u0100lr\u2C52\u2C5Ceft\u0100;e\u0C1A\u2C5A\xf1\u0C26ight\u0100;e\u0CCB\u2C65\xf1\u0CD7\u0100;m\u2C6C\u2C6D\u43BD\u0180;es\u2C74\u2C75\u2C79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2C8F\u2C94\u2C99\u2C9E\u2CA3\u2CB0\u2CB6\u2CD3\u2CE3ash;\u62ADarr;\u6904p;\uC000\u224D\u20D2ash;\u62AC\u0100et\u2CA8\u2CAC;\uC000\u2265\u20D2;\uC000>\u20D2nfin;\u69DE\u0180Aet\u2CBD\u2CC1\u2CC5rr;\u6902;\uC000\u2264\u20D2\u0100;r\u2CCA\u2CCD\uC000<\u20D2ie;\uC000\u22B4\u20D2\u0100At\u2CD8\u2CDCrr;\u6903rie;\uC000\u22B5\u20D2im;\uC000\u223C\u20D2\u0180Aan\u2CF0\u2CF4\u2D02rr;\u61D6r\u0100hr\u2CFA\u2CFDk;\u6923\u0100;o\u13E7\u13E5ear;\u6927\u1253\u1A95\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\u2D2D\x00\u2D38\u2D48\u2D60\u2D65\u2D72\u2D84\u1B07\x00\x00\u2D8D\u2DAB\x00\u2DC8\u2DCE\x00\u2DDC\u2E19\u2E2B\u2E3E\u2E43\u0100cs\u2D31\u1A97ute\u803B\xf3\u40F3\u0100iy\u2D3C\u2D45r\u0100;c\u1A9E\u2D42\u803B\xf4\u40F4;\u443E\u0280abios\u1AA0\u2D52\u2D57\u01C8\u2D5Alac;\u4151v;\u6A38old;\u69BClig;\u4153\u0100cr\u2D69\u2D6Dir;\u69BF;\uC000\ud835\udd2c\u036F\u2D79\x00\x00\u2D7C\x00\u2D82n;\u42DBave\u803B\xf2\u40F2;\u69C1\u0100bm\u2D88\u0DF4ar;\u69B5\u0200acit\u2D95\u2D98\u2DA5\u2DA8r\xf2\u1A80\u0100ir\u2D9D\u2DA0r;\u69BEoss;\u69BBn\xe5\u0E52;\u69C0\u0180aei\u2DB1\u2DB5\u2DB9cr;\u414Dga;\u43C9\u0180cdn\u2DC0\u2DC5\u01CDron;\u43BF;\u69B6pf;\uC000\ud835\udd60\u0180ael\u2DD4\u2DD7\u01D2r;\u69B7rp;\u69B9\u0380;adiosv\u2DEA\u2DEB\u2DEE\u2E08\u2E0D\u2E10\u2E16\u6228r\xf2\u1A86\u0200;efm\u2DF7\u2DF8\u2E02\u2E05\u6A5Dr\u0100;o\u2DFE\u2DFF\u6134f\xbb\u2DFF\u803B\xaa\u40AA\u803B\xba\u40BAgof;\u62B6r;\u6A56lope;\u6A57;\u6A5B\u0180clo\u2E1F\u2E21\u2E27\xf2\u2E01ash\u803B\xf8\u40F8l;\u6298i\u016C\u2E2F\u2E34de\u803B\xf5\u40F5es\u0100;a\u01DB\u2E3As;\u6A36ml\u803B\xf6\u40F6bar;\u633D\u0AE1\u2E5E\x00\u2E7D\x00\u2E80\u2E9D\x00\u2EA2\u2EB9\x00\x00\u2ECB\u0E9C\x00\u2F13\x00\x00\u2F2B\u2FBC\x00\u2FC8r\u0200;ast\u0403\u2E67\u2E72\u0E85\u8100\xb6;l\u2E6D\u2E6E\u40B6le\xec\u0403\u0269\u2E78\x00\x00\u2E7Bm;\u6AF3;\u6AFDy;\u443Fr\u0280cimpt\u2E8B\u2E8F\u2E93\u1865\u2E97nt;\u4025od;\u402Eil;\u6030enk;\u6031r;\uC000\ud835\udd2d\u0180imo\u2EA8\u2EB0\u2EB4\u0100;v\u2EAD\u2EAE\u43C6;\u43D5ma\xf4\u0A76ne;\u660E\u0180;tv\u2EBF\u2EC0\u2EC8\u43C0chfork\xbb\u1FFD;\u43D6\u0100au\u2ECF\u2EDFn\u0100ck\u2ED5\u2EDDk\u0100;h\u21F4\u2EDB;\u610E\xf6\u21F4s\u0480;abcdemst\u2EF3\u2EF4\u1908\u2EF9\u2EFD\u2F04\u2F06\u2F0A\u2F0E\u402Bcir;\u6A23ir;\u6A22\u0100ou\u1D40\u2F02;\u6A25;\u6A72n\u80BB\xb1\u0E9Dim;\u6A26wo;\u6A27\u0180ipu\u2F19\u2F20\u2F25ntint;\u6A15f;\uC000\ud835\udd61nd\u803B\xa3\u40A3\u0500;Eaceinosu\u0EC8\u2F3F\u2F41\u2F44\u2F47\u2F81\u2F89\u2F92\u2F7E\u2FB6;\u6AB3p;\u6AB7u\xe5\u0ED9\u0100;c\u0ECE\u2F4C\u0300;acens\u0EC8\u2F59\u2F5F\u2F66\u2F68\u2F7Eppro\xf8\u2F43urlye\xf1\u0ED9\xf1\u0ECE\u0180aes\u2F6F\u2F76\u2F7Approx;\u6AB9qq;\u6AB5im;\u62E8i\xed\u0EDFme\u0100;s\u2F88\u0EAE\u6032\u0180Eas\u2F78\u2F90\u2F7A\xf0\u2F75\u0180dfp\u0EEC\u2F99\u2FAF\u0180als\u2FA0\u2FA5\u2FAAlar;\u632Eine;\u6312urf;\u6313\u0100;t\u0EFB\u2FB4\xef\u0EFBrel;\u62B0\u0100ci\u2FC0\u2FC5r;\uC000\ud835\udcc5;\u43C8ncsp;\u6008\u0300fiopsu\u2FDA\u22E2\u2FDF\u2FE5\u2FEB\u2FF1r;\uC000\ud835\udd2epf;\uC000\ud835\udd62rime;\u6057cr;\uC000\ud835\udcc6\u0180aeo\u2FF8\u3009\u3013t\u0100ei\u2FFE\u3005rnion\xf3\u06B0nt;\u6A16st\u0100;e\u3010\u3011\u403F\xf1\u1F19\xf4\u0F14\u0A80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30E0\u310E\u312B\u3147\u3162\u3172\u318E\u3206\u3215\u3224\u3229\u3258\u326E\u3272\u3290\u32B0\u32B7\u0180art\u3047\u304A\u304Cr\xf2\u10B3\xf2\u03DDail;\u691Car\xf2\u1C65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307F\u308F\u3094\u30CC\u0100eu\u306D\u3071;\uC000\u223D\u0331te;\u4155i\xe3\u116Emptyv;\u69B3g\u0200;del\u0FD1\u3089\u308B\u308D;\u6992;\u69A5\xe5\u0FD1uo\u803B\xbb\u40BBr\u0580;abcfhlpstw\u0FDC\u30AC\u30AF\u30B7\u30B9\u30BC\u30BE\u30C0\u30C3\u30C7\u30CAp;\u6975\u0100;f\u0FE0\u30B4s;\u6920;\u6933s;\u691E\xeb\u225D\xf0\u272El;\u6945im;\u6974l;\u61A3;\u619D\u0100ai\u30D1\u30D5il;\u691Ao\u0100;n\u30DB\u30DC\u6236al\xf3\u0F1E\u0180abr\u30E7\u30EA\u30EEr\xf2\u17E5rk;\u6773\u0100ak\u30F3\u30FDc\u0100ek\u30F9\u30FB;\u407D;\u405D\u0100es\u3102\u3104;\u698Cl\u0100du\u310A\u310C;\u698E;\u6990\u0200aeuy\u3117\u311C\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0FF2\xe2\u30FA;\u4440\u0200clqs\u3134\u3137\u313D\u3144a;\u6937dhar;\u6969uo\u0100;r\u020E\u020Dh;\u61B3\u0180acg\u314E\u315F\u0F44l\u0200;ips\u0F78\u3158\u315B\u109Cn\xe5\u10BBar\xf4\u0FA9t;\u65AD\u0180ilr\u3169\u1023\u316Esht;\u697D;\uC000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317D\u317F\xbb\u047B\u0100;l\u1091\u3184;\u696C\u0100;v\u318B\u318C\u43C1;\u43F1\u0180gns\u3195\u31F9\u31FCht\u0300ahlrst\u31A4\u31B0\u31C2\u31D8\u31E4\u31EErrow\u0100;t\u0FDC\u31ADa\xe9\u30C8arpoon\u0100du\u31BB\u31BFow\xee\u317Ep\xbb\u1092eft\u0100ah\u31CA\u31D0rrow\xf3\u0FEAarpoon\xf3\u0551ightarrows;\u61C9quigarro\xf7\u30CBhreetimes;\u62CCg;\u42DAingdotse\xf1\u1F32\u0180ahm\u320D\u3210\u3213r\xf2\u0FEAa\xf2\u0551;\u600Foust\u0100;a\u321E\u321F\u63B1che\xbb\u321Fmid;\u6AEE\u0200abpt\u3232\u323D\u3240\u3252\u0100nr\u3237\u323Ag;\u67EDr;\u61FEr\xeb\u1003\u0180afl\u3247\u324A\u324Er;\u6986;\uC000\ud835\udd63us;\u6A2Eimes;\u6A35\u0100ap\u325D\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6A12ar\xf2\u31E3\u0200achq\u327B\u3280\u10BC\u3285quo;\u603Ar;\uC000\ud835\udcc7\u0100bu\u30FB\u328Ao\u0100;r\u0214\u0213\u0180hir\u3297\u329B\u32A0re\xe5\u31F8mes;\u62CAi\u0200;efl\u32AA\u1059\u1821\u32AB\u65B9tri;\u69CEluhar;\u6968;\u611E\u0D61\u32D5\u32DB\u32DF\u332C\u3338\u3371\x00\u337A\u33A4\x00\x00\u33EC\u33F0\x00\u3428\u3448\u345A\u34AD\u34B1\u34CA\u34F1\x00\u3616\x00\x00\u3633cute;\u415Bqu\xef\u27BA\u0500;Eaceinpsy\u11ED\u32F3\u32F5\u32FF\u3302\u330B\u330F\u331F\u3326\u3329;\u6AB4\u01F0\u32FA\x00\u32FC;\u6AB8on;\u4161u\xe5\u11FE\u0100;d\u11F3\u3307il;\u415Frc;\u415D\u0180Eas\u3316\u3318\u331B;\u6AB6p;\u6ABAim;\u62E9olint;\u6A13i\xed\u1204;\u4441ot\u0180;be\u3334\u1D47\u3335\u62C5;\u6A66\u0380Aacmstx\u3346\u334A\u3357\u335B\u335E\u3363\u336Drr;\u61D8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0A36\u0A34t\u803B\xa7\u40A7i;\u403Bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uC000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33A0rp;\u666F\u0100hy\u338B\u338Fcy;\u4449;\u4448rt\u026D\u3399\x00\x00\u339Ci\xe4\u1464ara\xec\u2E6F\u803B\xad\u40AD\u0100gm\u33A8\u33B4ma\u0180;fv\u33B1\u33B2\u33B2\u43C3;\u43C2\u0400;deglnpr\u12AB\u33C5\u33C9\u33CE\u33D6\u33DE\u33E1\u33E6ot;\u6A6A\u0100;q\u12B1\u12B0\u0100;E\u33D3\u33D4\u6A9E;\u6AA0\u0100;E\u33DB\u33DC\u6A9D;\u6A9Fe;\u6246lus;\u6A24arr;\u6972ar\xf2\u113D\u0200aeit\u33F8\u3408\u340F\u3417\u0100ls\u33FD\u3404lsetm\xe9\u336Ahp;\u6A33parsl;\u69E4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341C\u341D\u6AAA\u0100;s\u3422\u3423\u6AAC;\uC000\u2AAC\uFE00\u0180flp\u342E\u3433\u3442tcy;\u444C\u0100;b\u3438\u3439\u402F\u0100;a\u343E\u343F\u69C4r;\u633Ff;\uC000\ud835\udd64a\u0100dr\u344D\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349F\u0100au\u3465\u346Fp\u0100;s\u1188\u346B;\uC000\u2293\uFE00p\u0100;s\u11B4\u3475;\uC000\u2294\uFE00u\u0100bp\u347F\u348F\u0180;es\u1197\u119C\u3486et\u0100;e\u1197\u348D\xf1\u119D\u0180;es\u11A8\u11AD\u3496et\u0100;e\u11A8\u349D\xf1\u11AE\u0180;af\u117B\u34A6\u05B0r\u0165\u34AB\u05B1\xbb\u117Car\xf2\u1148\u0200cemt\u34B9\u34BE\u34C2\u34C5r;\uC000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11BE\u0100ar\u34CE\u34D5r\u0100;f\u34D4\u17BF\u6606\u0100an\u34DA\u34EDight\u0100ep\u34E3\u34EApsilo\xee\u1EE0h\xe9\u2EAFs\xbb\u2852\u0280bcmnp\u34FB\u355E\u1209\u358B\u358E\u0480;Edemnprs\u350E\u350F\u3511\u3515\u351E\u3523\u352C\u3531\u3536\u6282;\u6AC5ot;\u6ABD\u0100;d\u11DA\u351Aot;\u6AC3ult;\u6AC1\u0100Ee\u3528\u352A;\u6ACB;\u628Alus;\u6ABFarr;\u6979\u0180eiu\u353D\u3552\u3555t\u0180;en\u350E\u3545\u354Bq\u0100;q\u11DA\u350Feq\u0100;q\u352B\u3528m;\u6AC7\u0100bp\u355A\u355C;\u6AD5;\u6AD3c\u0300;acens\u11ED\u356C\u3572\u3579\u357B\u3326ppro\xf8\u32FAurlye\xf1\u11FE\xf1\u11F3\u0180aes\u3582\u3588\u331Bppro\xf8\u331Aq\xf1\u3317g;\u666A\u0680123;Edehlmnps\u35A9\u35AC\u35AF\u121C\u35B2\u35B4\u35C0\u35C9\u35D5\u35DA\u35DF\u35E8\u35ED\u803B\xb9\u40B9\u803B\xb2\u40B2\u803B\xb3\u40B3;\u6AC6\u0100os\u35B9\u35BCt;\u6ABEub;\u6AD8\u0100;d\u1222\u35C5ot;\u6AC4s\u0100ou\u35CF\u35D2l;\u67C9b;\u6AD7arr;\u697Bult;\u6AC2\u0100Ee\u35E4\u35E6;\u6ACC;\u628Blus;\u6AC0\u0180eiu\u35F4\u3609\u360Ct\u0180;en\u121C\u35FC\u3602q\u0100;q\u1222\u35B2eq\u0100;q\u35E7\u35E4m;\u6AC8\u0100bp\u3611\u3613;\u6AD4;\u6AD6\u0180Aan\u361C\u3620\u362Drr;\u61D9r\u0100hr\u3626\u3628\xeb\u222E\u0100;o\u0A2B\u0A29war;\u692Alig\u803B\xdf\u40DF\u0BE1\u3651\u365D\u3660\u12CE\u3673\u3679\x00\u367E\u36C2\x00\x00\x00\x00\x00\u36DB\u3703\x00\u3709\u376C\x00\x00\x00\u3787\u0272\u3656\x00\x00\u365Bget;\u6316;\u43C4r\xeb\u0E5F\u0180aey\u3666\u366B\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uC000\ud835\udd31\u0200eiko\u3686\u369D\u36B5\u36BC\u01F2\u368B\x00\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369B\u43B8ym;\u43D1\u0100cn\u36A2\u36B2k\u0100as\u36A8\u36AEppro\xf8\u12C1im\xbb\u12ACs\xf0\u129E\u0100as\u36BA\u36AE\xf0\u12C1rn\u803B\xfe\u40FE\u01EC\u031F\u36C6\u22E7es\u8180\xd7;bd\u36CF\u36D0\u36D8\u40D7\u0100;a\u190F\u36D5r;\u6A31;\u6A30\u0180eps\u36E1\u36E3\u3700\xe1\u2A4D\u0200;bcf\u0486\u36EC\u36F0\u36F4ot;\u6336ir;\u6AF1\u0100;o\u36F9\u36FC\uC000\ud835\udd65rk;\u6ADA\xe1\u3362rime;\u6034\u0180aip\u370F\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374D\u3740\u3751\u3757\u375C\u375Fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65B5own\xbb\u1DBBeft\u0100;e\u2800\u373E\xf1\u092E;\u625Cight\u0100;e\u32AA\u374B\xf1\u105Aot;\u65ECinus;\u6A3Alus;\u6A39b;\u69CDime;\u6A3Bezium;\u63E2\u0180cht\u3772\u377D\u3781\u0100ry\u3777\u377B;\uC000\ud835\udcc9;\u4446cy;\u445Brok;\u4167\u0100io\u378B\u378Ex\xf4\u1777head\u0100lr\u3797\u37A0eftarro\xf7\u084Fightarrow\xbb\u0F5D\u0900AHabcdfghlmoprstuw\u37D0\u37D3\u37D7\u37E4\u37F0\u37FC\u380E\u381C\u3823\u3834\u3851\u385D\u386B\u38A9\u38CC\u38D2\u38EA\u38F6r\xf2\u03EDar;\u6963\u0100cr\u37DC\u37E2ute\u803B\xfa\u40FA\xf2\u1150r\u01E3\u37EA\x00\u37EDy;\u445Eve;\u416D\u0100iy\u37F5\u37FArc\u803B\xfb\u40FB;\u4443\u0180abh\u3803\u3806\u380Br\xf2\u13ADlac;\u4171a\xf2\u13C3\u0100ir\u3813\u3818sht;\u697E;\uC000\ud835\udd32rave\u803B\xf9\u40F9\u0161\u3827\u3831r\u0100lr\u382C\u382E\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384D\u026F\u383F\x00\x00\u384Arn\u0100;e\u3845\u3846\u631Cr\xbb\u3846op;\u630Fri;\u65F8\u0100al\u3856\u385Acr;\u416B\u80BB\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uC000\ud835\udd66\u0300adhlsu\u114B\u3878\u387D\u1372\u3891\u38A0own\xe1\u13B3arpoon\u0100lr\u3888\u388Cef\xf4\u382Digh\xf4\u382Fi\u0180;hl\u3899\u389A\u389C\u43C5\xbb\u13FAon\xbb\u389Aparrows;\u61C8\u0180cit\u38B0\u38C4\u38C8\u026F\u38B6\x00\x00\u38C1rn\u0100;e\u38BC\u38BD\u631Dr\xbb\u38BDop;\u630Eng;\u416Fri;\u65F9cr;\uC000\ud835\udcca\u0180dir\u38D9\u38DD\u38E2ot;\u62F0lde;\u4169i\u0100;f\u3730\u38E8\xbb\u1813\u0100am\u38EF\u38F2r\xf2\u38A8l\u803B\xfc\u40FCangle;\u69A7\u0780ABDacdeflnoprsz\u391C\u391F\u3929\u392D\u39B5\u39B8\u39BD\u39DF\u39E4\u39E8\u39F3\u39F9\u39FD\u3A01\u3A20r\xf2\u03F7ar\u0100;v\u3926\u3927\u6AE8;\u6AE9as\xe8\u03E1\u0100nr\u3932\u3937grt;\u699C\u0380eknprst\u34E3\u3946\u394B\u3952\u395D\u3964\u3996app\xe1\u2415othin\xe7\u1E96\u0180hir\u34EB\u2EC8\u3959op\xf4\u2FB5\u0100;h\u13B7\u3962\xef\u318D\u0100iu\u3969\u396Dgm\xe1\u33B3\u0100bp\u3972\u3984setneq\u0100;q\u397D\u3980\uC000\u228A\uFE00;\uC000\u2ACB\uFE00setneq\u0100;q\u398F\u3992\uC000\u228B\uFE00;\uC000\u2ACC\uFE00\u0100hr\u399B\u399Fet\xe1\u369Ciangle\u0100lr\u39AA\u39AFeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39C4\u39D2\u39D7\u0180;be\u2DEA\u39CB\u39CFar;\u62BBq;\u625Alip;\u62EE\u0100bt\u39DC\u1468a\xf2\u1469r;\uC000\ud835\udd33tr\xe9\u39AEsu\u0100bp\u39EF\u39F1\xbb\u0D1C\xbb\u0D59pf;\uC000\ud835\udd67ro\xf0\u0EFBtr\xe9\u39B4\u0100cu\u3A06\u3A0Br;\uC000\ud835\udccb\u0100bp\u3A10\u3A18n\u0100Ee\u3980\u3A16\xbb\u397En\u0100Ee\u3992\u3A1E\xbb\u3990igzag;\u699A\u0380cefoprs\u3A36\u3A3B\u3A56\u3A5B\u3A54\u3A61\u3A6Airc;\u4175\u0100di\u3A40\u3A51\u0100bg\u3A45\u3A49ar;\u6A5Fe\u0100;q\u15FA\u3A4F;\u6259erp;\u6118r;\uC000\ud835\udd34pf;\uC000\ud835\udd68\u0100;e\u1479\u3A66at\xe8\u1479cr;\uC000\ud835\udccc\u0AE3\u178E\u3A87\x00\u3A8B\x00\u3A90\u3A9B\x00\x00\u3A9D\u3AA8\u3AAB\u3AAF\x00\x00\u3AC3\u3ACE\x00\u3AD8\u17DC\u17DFtr\xe9\u17D1r;\uC000\ud835\udd35\u0100Aa\u3A94\u3A97r\xf2\u03C3r\xf2\u09F6;\u43BE\u0100Aa\u3AA1\u3AA4r\xf2\u03B8r\xf2\u09EBa\xf0\u2713is;\u62FB\u0180dpt\u17A4\u3AB5\u3ABE\u0100fl\u3ABA\u17A9;\uC000\ud835\udd69im\xe5\u17B2\u0100Aa\u3AC7\u3ACAr\xf2\u03CEr\xf2\u0A01\u0100cq\u3AD2\u17B8r;\uC000\ud835\udccd\u0100pt\u17D6\u3ADCr\xe9\u17D4\u0400acefiosu\u3AF0\u3AFD\u3B08\u3B0C\u3B11\u3B15\u3B1B\u3B21c\u0100uy\u3AF6\u3AFBte\u803B\xfd\u40FD;\u444F\u0100iy\u3B02\u3B06rc;\u4177;\u444Bn\u803B\xa5\u40A5r;\uC000\ud835\udd36cy;\u4457pf;\uC000\ud835\udd6acr;\uC000\ud835\udcce\u0100cm\u3B26\u3B29y;\u444El\u803B\xff\u40FF\u0500acdefhiosw\u3B42\u3B48\u3B54\u3B58\u3B64\u3B69\u3B6D\u3B74\u3B7A\u3B80cute;\u417A\u0100ay\u3B4D\u3B52ron;\u417E;\u4437ot;\u417C\u0100et\u3B5D\u3B61tr\xe6\u155Fa;\u43B6r;\uC000\ud835\udd37cy;\u4436grarr;\u61DDpf;\uC000\ud835\udd6bcr;\uC000\ud835\udccf\u0100jn\u3B85\u3B87;\u600Dj;\u600C'.split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("bIK23", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $888782d1464fc704$export$2e2bcd8739ae039; });
// Generated using scripts/write-decode-map.ts
var $888782d1464fc704$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u0200aglq	\x15\x18\x1b\u026D\x0f\x00\x00\x12p;\u4026os;\u4027t;\u403Et;\u403Cuot;\u4022".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("6Q8o8", function(module, exports) {

$parcel$export(module.exports, "fromCodePoint", function () { return $4fae1b1ddc4558df$export$73bfc63873071f74; });
$parcel$export(module.exports, "replaceCodePoint", function () { return $4fae1b1ddc4558df$export$b978ab756102108a; });
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $4fae1b1ddc4558df$var$_a;
const $4fae1b1ddc4558df$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
const $4fae1b1ddc4558df$export$73bfc63873071f74 = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($4fae1b1ddc4558df$var$_a = String.fromCodePoint) !== null && $4fae1b1ddc4558df$var$_a !== void 0 ? $4fae1b1ddc4558df$var$_a : function(codePoint) {
    let output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
function $4fae1b1ddc4558df$export$b978ab756102108a(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $4fae1b1ddc4558df$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
function $4fae1b1ddc4558df$export$2e2bcd8739ae039(codePoint) {
    return $4fae1b1ddc4558df$export$73bfc63873071f74($4fae1b1ddc4558df$export$b978ab756102108a(codePoint));
}

});


parcelRegister("2CFOf", function(module, exports) {

$parcel$export(module.exports, "encodeHTML", function () { return $1e8f8fdda0fdca83$export$f9d6449b9af28dc1; });
$parcel$export(module.exports, "encodeNonAsciiHTML", function () { return $1e8f8fdda0fdca83$export$e6e86c76506f1190; });

var $d5VGS = parcelRequire("d5VGS");

var $fZVPj = parcelRequire("fZVPj");
const $1e8f8fdda0fdca83$var$htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function $1e8f8fdda0fdca83$export$f9d6449b9af28dc1(data) {
    return $1e8f8fdda0fdca83$var$encodeHTMLTrieRe($1e8f8fdda0fdca83$var$htmlReplacer, data);
}
function $1e8f8fdda0fdca83$export$e6e86c76506f1190(data) {
    return $1e8f8fdda0fdca83$var$encodeHTMLTrieRe((0, $fZVPj.xmlReplacer), data);
}
function $1e8f8fdda0fdca83$var$encodeHTMLTrieRe(regExp, str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = regExp.exec(str)) !== null){
        const i = match.index;
        ret += str.substring(lastIdx, i);
        const char = str.charCodeAt(i);
        let next = (0, $d5VGS.default).get(char);
        if (typeof next === "object") {
            // We are in a branch. Try to match the next char.
            if (i + 1 < str.length) {
                const nextChar = str.charCodeAt(i + 1);
                const value = typeof next.n === "number" ? next.n === nextChar ? next.o : undefined : next.n.get(nextChar);
                if (value !== undefined) {
                    ret += value;
                    lastIdx = regExp.lastIndex += 1;
                    continue;
                }
            }
            next = next.v;
        }
        // We might have a tree node without a value; skip and use a numeric entity.
        if (next !== undefined) {
            ret += next;
            lastIdx = i + 1;
        } else {
            const cp = (0, $fZVPj.getCodePoint)(str, i);
            ret += `&#x${cp.toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = regExp.lastIndex += Number(cp !== char);
        }
    }
    return ret + str.substr(lastIdx);
}

});
parcelRegister("d5VGS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98887e1d0958bc17$export$2e2bcd8739ae039; });
// Generated using scripts/write-encode-map.ts
function $98887e1d0958bc17$var$restoreDiff(arr) {
    for(let i = 1; i < arr.length; i++)arr[i][0] += arr[i - 1][0] + 1;
    return arr;
}
var // prettier-ignore
$98887e1d0958bc17$export$2e2bcd8739ae039 = new Map(/* #__PURE__ */ $98887e1d0958bc17$var$restoreDiff([
    [
        9,
        "&Tab;"
    ],
    [
        0,
        "&NewLine;"
    ],
    [
        22,
        "&excl;"
    ],
    [
        0,
        "&quot;"
    ],
    [
        0,
        "&num;"
    ],
    [
        0,
        "&dollar;"
    ],
    [
        0,
        "&percnt;"
    ],
    [
        0,
        "&amp;"
    ],
    [
        0,
        "&apos;"
    ],
    [
        0,
        "&lpar;"
    ],
    [
        0,
        "&rpar;"
    ],
    [
        0,
        "&ast;"
    ],
    [
        0,
        "&plus;"
    ],
    [
        0,
        "&comma;"
    ],
    [
        1,
        "&period;"
    ],
    [
        0,
        "&sol;"
    ],
    [
        10,
        "&colon;"
    ],
    [
        0,
        "&semi;"
    ],
    [
        0,
        {
            v: "&lt;",
            n: 8402,
            o: "&nvlt;"
        }
    ],
    [
        0,
        {
            v: "&equals;",
            n: 8421,
            o: "&bne;"
        }
    ],
    [
        0,
        {
            v: "&gt;",
            n: 8402,
            o: "&nvgt;"
        }
    ],
    [
        0,
        "&quest;"
    ],
    [
        0,
        "&commat;"
    ],
    [
        26,
        "&lbrack;"
    ],
    [
        0,
        "&bsol;"
    ],
    [
        0,
        "&rbrack;"
    ],
    [
        0,
        "&Hat;"
    ],
    [
        0,
        "&lowbar;"
    ],
    [
        0,
        "&DiacriticalGrave;"
    ],
    [
        5,
        {
            n: 106,
            o: "&fjlig;"
        }
    ],
    [
        20,
        "&lbrace;"
    ],
    [
        0,
        "&verbar;"
    ],
    [
        0,
        "&rbrace;"
    ],
    [
        34,
        "&nbsp;"
    ],
    [
        0,
        "&iexcl;"
    ],
    [
        0,
        "&cent;"
    ],
    [
        0,
        "&pound;"
    ],
    [
        0,
        "&curren;"
    ],
    [
        0,
        "&yen;"
    ],
    [
        0,
        "&brvbar;"
    ],
    [
        0,
        "&sect;"
    ],
    [
        0,
        "&die;"
    ],
    [
        0,
        "&copy;"
    ],
    [
        0,
        "&ordf;"
    ],
    [
        0,
        "&laquo;"
    ],
    [
        0,
        "&not;"
    ],
    [
        0,
        "&shy;"
    ],
    [
        0,
        "&circledR;"
    ],
    [
        0,
        "&macr;"
    ],
    [
        0,
        "&deg;"
    ],
    [
        0,
        "&PlusMinus;"
    ],
    [
        0,
        "&sup2;"
    ],
    [
        0,
        "&sup3;"
    ],
    [
        0,
        "&acute;"
    ],
    [
        0,
        "&micro;"
    ],
    [
        0,
        "&para;"
    ],
    [
        0,
        "&centerdot;"
    ],
    [
        0,
        "&cedil;"
    ],
    [
        0,
        "&sup1;"
    ],
    [
        0,
        "&ordm;"
    ],
    [
        0,
        "&raquo;"
    ],
    [
        0,
        "&frac14;"
    ],
    [
        0,
        "&frac12;"
    ],
    [
        0,
        "&frac34;"
    ],
    [
        0,
        "&iquest;"
    ],
    [
        0,
        "&Agrave;"
    ],
    [
        0,
        "&Aacute;"
    ],
    [
        0,
        "&Acirc;"
    ],
    [
        0,
        "&Atilde;"
    ],
    [
        0,
        "&Auml;"
    ],
    [
        0,
        "&angst;"
    ],
    [
        0,
        "&AElig;"
    ],
    [
        0,
        "&Ccedil;"
    ],
    [
        0,
        "&Egrave;"
    ],
    [
        0,
        "&Eacute;"
    ],
    [
        0,
        "&Ecirc;"
    ],
    [
        0,
        "&Euml;"
    ],
    [
        0,
        "&Igrave;"
    ],
    [
        0,
        "&Iacute;"
    ],
    [
        0,
        "&Icirc;"
    ],
    [
        0,
        "&Iuml;"
    ],
    [
        0,
        "&ETH;"
    ],
    [
        0,
        "&Ntilde;"
    ],
    [
        0,
        "&Ograve;"
    ],
    [
        0,
        "&Oacute;"
    ],
    [
        0,
        "&Ocirc;"
    ],
    [
        0,
        "&Otilde;"
    ],
    [
        0,
        "&Ouml;"
    ],
    [
        0,
        "&times;"
    ],
    [
        0,
        "&Oslash;"
    ],
    [
        0,
        "&Ugrave;"
    ],
    [
        0,
        "&Uacute;"
    ],
    [
        0,
        "&Ucirc;"
    ],
    [
        0,
        "&Uuml;"
    ],
    [
        0,
        "&Yacute;"
    ],
    [
        0,
        "&THORN;"
    ],
    [
        0,
        "&szlig;"
    ],
    [
        0,
        "&agrave;"
    ],
    [
        0,
        "&aacute;"
    ],
    [
        0,
        "&acirc;"
    ],
    [
        0,
        "&atilde;"
    ],
    [
        0,
        "&auml;"
    ],
    [
        0,
        "&aring;"
    ],
    [
        0,
        "&aelig;"
    ],
    [
        0,
        "&ccedil;"
    ],
    [
        0,
        "&egrave;"
    ],
    [
        0,
        "&eacute;"
    ],
    [
        0,
        "&ecirc;"
    ],
    [
        0,
        "&euml;"
    ],
    [
        0,
        "&igrave;"
    ],
    [
        0,
        "&iacute;"
    ],
    [
        0,
        "&icirc;"
    ],
    [
        0,
        "&iuml;"
    ],
    [
        0,
        "&eth;"
    ],
    [
        0,
        "&ntilde;"
    ],
    [
        0,
        "&ograve;"
    ],
    [
        0,
        "&oacute;"
    ],
    [
        0,
        "&ocirc;"
    ],
    [
        0,
        "&otilde;"
    ],
    [
        0,
        "&ouml;"
    ],
    [
        0,
        "&div;"
    ],
    [
        0,
        "&oslash;"
    ],
    [
        0,
        "&ugrave;"
    ],
    [
        0,
        "&uacute;"
    ],
    [
        0,
        "&ucirc;"
    ],
    [
        0,
        "&uuml;"
    ],
    [
        0,
        "&yacute;"
    ],
    [
        0,
        "&thorn;"
    ],
    [
        0,
        "&yuml;"
    ],
    [
        0,
        "&Amacr;"
    ],
    [
        0,
        "&amacr;"
    ],
    [
        0,
        "&Abreve;"
    ],
    [
        0,
        "&abreve;"
    ],
    [
        0,
        "&Aogon;"
    ],
    [
        0,
        "&aogon;"
    ],
    [
        0,
        "&Cacute;"
    ],
    [
        0,
        "&cacute;"
    ],
    [
        0,
        "&Ccirc;"
    ],
    [
        0,
        "&ccirc;"
    ],
    [
        0,
        "&Cdot;"
    ],
    [
        0,
        "&cdot;"
    ],
    [
        0,
        "&Ccaron;"
    ],
    [
        0,
        "&ccaron;"
    ],
    [
        0,
        "&Dcaron;"
    ],
    [
        0,
        "&dcaron;"
    ],
    [
        0,
        "&Dstrok;"
    ],
    [
        0,
        "&dstrok;"
    ],
    [
        0,
        "&Emacr;"
    ],
    [
        0,
        "&emacr;"
    ],
    [
        2,
        "&Edot;"
    ],
    [
        0,
        "&edot;"
    ],
    [
        0,
        "&Eogon;"
    ],
    [
        0,
        "&eogon;"
    ],
    [
        0,
        "&Ecaron;"
    ],
    [
        0,
        "&ecaron;"
    ],
    [
        0,
        "&Gcirc;"
    ],
    [
        0,
        "&gcirc;"
    ],
    [
        0,
        "&Gbreve;"
    ],
    [
        0,
        "&gbreve;"
    ],
    [
        0,
        "&Gdot;"
    ],
    [
        0,
        "&gdot;"
    ],
    [
        0,
        "&Gcedil;"
    ],
    [
        1,
        "&Hcirc;"
    ],
    [
        0,
        "&hcirc;"
    ],
    [
        0,
        "&Hstrok;"
    ],
    [
        0,
        "&hstrok;"
    ],
    [
        0,
        "&Itilde;"
    ],
    [
        0,
        "&itilde;"
    ],
    [
        0,
        "&Imacr;"
    ],
    [
        0,
        "&imacr;"
    ],
    [
        2,
        "&Iogon;"
    ],
    [
        0,
        "&iogon;"
    ],
    [
        0,
        "&Idot;"
    ],
    [
        0,
        "&imath;"
    ],
    [
        0,
        "&IJlig;"
    ],
    [
        0,
        "&ijlig;"
    ],
    [
        0,
        "&Jcirc;"
    ],
    [
        0,
        "&jcirc;"
    ],
    [
        0,
        "&Kcedil;"
    ],
    [
        0,
        "&kcedil;"
    ],
    [
        0,
        "&kgreen;"
    ],
    [
        0,
        "&Lacute;"
    ],
    [
        0,
        "&lacute;"
    ],
    [
        0,
        "&Lcedil;"
    ],
    [
        0,
        "&lcedil;"
    ],
    [
        0,
        "&Lcaron;"
    ],
    [
        0,
        "&lcaron;"
    ],
    [
        0,
        "&Lmidot;"
    ],
    [
        0,
        "&lmidot;"
    ],
    [
        0,
        "&Lstrok;"
    ],
    [
        0,
        "&lstrok;"
    ],
    [
        0,
        "&Nacute;"
    ],
    [
        0,
        "&nacute;"
    ],
    [
        0,
        "&Ncedil;"
    ],
    [
        0,
        "&ncedil;"
    ],
    [
        0,
        "&Ncaron;"
    ],
    [
        0,
        "&ncaron;"
    ],
    [
        0,
        "&napos;"
    ],
    [
        0,
        "&ENG;"
    ],
    [
        0,
        "&eng;"
    ],
    [
        0,
        "&Omacr;"
    ],
    [
        0,
        "&omacr;"
    ],
    [
        2,
        "&Odblac;"
    ],
    [
        0,
        "&odblac;"
    ],
    [
        0,
        "&OElig;"
    ],
    [
        0,
        "&oelig;"
    ],
    [
        0,
        "&Racute;"
    ],
    [
        0,
        "&racute;"
    ],
    [
        0,
        "&Rcedil;"
    ],
    [
        0,
        "&rcedil;"
    ],
    [
        0,
        "&Rcaron;"
    ],
    [
        0,
        "&rcaron;"
    ],
    [
        0,
        "&Sacute;"
    ],
    [
        0,
        "&sacute;"
    ],
    [
        0,
        "&Scirc;"
    ],
    [
        0,
        "&scirc;"
    ],
    [
        0,
        "&Scedil;"
    ],
    [
        0,
        "&scedil;"
    ],
    [
        0,
        "&Scaron;"
    ],
    [
        0,
        "&scaron;"
    ],
    [
        0,
        "&Tcedil;"
    ],
    [
        0,
        "&tcedil;"
    ],
    [
        0,
        "&Tcaron;"
    ],
    [
        0,
        "&tcaron;"
    ],
    [
        0,
        "&Tstrok;"
    ],
    [
        0,
        "&tstrok;"
    ],
    [
        0,
        "&Utilde;"
    ],
    [
        0,
        "&utilde;"
    ],
    [
        0,
        "&Umacr;"
    ],
    [
        0,
        "&umacr;"
    ],
    [
        0,
        "&Ubreve;"
    ],
    [
        0,
        "&ubreve;"
    ],
    [
        0,
        "&Uring;"
    ],
    [
        0,
        "&uring;"
    ],
    [
        0,
        "&Udblac;"
    ],
    [
        0,
        "&udblac;"
    ],
    [
        0,
        "&Uogon;"
    ],
    [
        0,
        "&uogon;"
    ],
    [
        0,
        "&Wcirc;"
    ],
    [
        0,
        "&wcirc;"
    ],
    [
        0,
        "&Ycirc;"
    ],
    [
        0,
        "&ycirc;"
    ],
    [
        0,
        "&Yuml;"
    ],
    [
        0,
        "&Zacute;"
    ],
    [
        0,
        "&zacute;"
    ],
    [
        0,
        "&Zdot;"
    ],
    [
        0,
        "&zdot;"
    ],
    [
        0,
        "&Zcaron;"
    ],
    [
        0,
        "&zcaron;"
    ],
    [
        19,
        "&fnof;"
    ],
    [
        34,
        "&imped;"
    ],
    [
        63,
        "&gacute;"
    ],
    [
        65,
        "&jmath;"
    ],
    [
        142,
        "&circ;"
    ],
    [
        0,
        "&caron;"
    ],
    [
        16,
        "&breve;"
    ],
    [
        0,
        "&DiacriticalDot;"
    ],
    [
        0,
        "&ring;"
    ],
    [
        0,
        "&ogon;"
    ],
    [
        0,
        "&DiacriticalTilde;"
    ],
    [
        0,
        "&dblac;"
    ],
    [
        51,
        "&DownBreve;"
    ],
    [
        127,
        "&Alpha;"
    ],
    [
        0,
        "&Beta;"
    ],
    [
        0,
        "&Gamma;"
    ],
    [
        0,
        "&Delta;"
    ],
    [
        0,
        "&Epsilon;"
    ],
    [
        0,
        "&Zeta;"
    ],
    [
        0,
        "&Eta;"
    ],
    [
        0,
        "&Theta;"
    ],
    [
        0,
        "&Iota;"
    ],
    [
        0,
        "&Kappa;"
    ],
    [
        0,
        "&Lambda;"
    ],
    [
        0,
        "&Mu;"
    ],
    [
        0,
        "&Nu;"
    ],
    [
        0,
        "&Xi;"
    ],
    [
        0,
        "&Omicron;"
    ],
    [
        0,
        "&Pi;"
    ],
    [
        0,
        "&Rho;"
    ],
    [
        1,
        "&Sigma;"
    ],
    [
        0,
        "&Tau;"
    ],
    [
        0,
        "&Upsilon;"
    ],
    [
        0,
        "&Phi;"
    ],
    [
        0,
        "&Chi;"
    ],
    [
        0,
        "&Psi;"
    ],
    [
        0,
        "&ohm;"
    ],
    [
        7,
        "&alpha;"
    ],
    [
        0,
        "&beta;"
    ],
    [
        0,
        "&gamma;"
    ],
    [
        0,
        "&delta;"
    ],
    [
        0,
        "&epsi;"
    ],
    [
        0,
        "&zeta;"
    ],
    [
        0,
        "&eta;"
    ],
    [
        0,
        "&theta;"
    ],
    [
        0,
        "&iota;"
    ],
    [
        0,
        "&kappa;"
    ],
    [
        0,
        "&lambda;"
    ],
    [
        0,
        "&mu;"
    ],
    [
        0,
        "&nu;"
    ],
    [
        0,
        "&xi;"
    ],
    [
        0,
        "&omicron;"
    ],
    [
        0,
        "&pi;"
    ],
    [
        0,
        "&rho;"
    ],
    [
        0,
        "&sigmaf;"
    ],
    [
        0,
        "&sigma;"
    ],
    [
        0,
        "&tau;"
    ],
    [
        0,
        "&upsi;"
    ],
    [
        0,
        "&phi;"
    ],
    [
        0,
        "&chi;"
    ],
    [
        0,
        "&psi;"
    ],
    [
        0,
        "&omega;"
    ],
    [
        7,
        "&thetasym;"
    ],
    [
        0,
        "&Upsi;"
    ],
    [
        2,
        "&phiv;"
    ],
    [
        0,
        "&piv;"
    ],
    [
        5,
        "&Gammad;"
    ],
    [
        0,
        "&digamma;"
    ],
    [
        18,
        "&kappav;"
    ],
    [
        0,
        "&rhov;"
    ],
    [
        3,
        "&epsiv;"
    ],
    [
        0,
        "&backepsilon;"
    ],
    [
        10,
        "&IOcy;"
    ],
    [
        0,
        "&DJcy;"
    ],
    [
        0,
        "&GJcy;"
    ],
    [
        0,
        "&Jukcy;"
    ],
    [
        0,
        "&DScy;"
    ],
    [
        0,
        "&Iukcy;"
    ],
    [
        0,
        "&YIcy;"
    ],
    [
        0,
        "&Jsercy;"
    ],
    [
        0,
        "&LJcy;"
    ],
    [
        0,
        "&NJcy;"
    ],
    [
        0,
        "&TSHcy;"
    ],
    [
        0,
        "&KJcy;"
    ],
    [
        1,
        "&Ubrcy;"
    ],
    [
        0,
        "&DZcy;"
    ],
    [
        0,
        "&Acy;"
    ],
    [
        0,
        "&Bcy;"
    ],
    [
        0,
        "&Vcy;"
    ],
    [
        0,
        "&Gcy;"
    ],
    [
        0,
        "&Dcy;"
    ],
    [
        0,
        "&IEcy;"
    ],
    [
        0,
        "&ZHcy;"
    ],
    [
        0,
        "&Zcy;"
    ],
    [
        0,
        "&Icy;"
    ],
    [
        0,
        "&Jcy;"
    ],
    [
        0,
        "&Kcy;"
    ],
    [
        0,
        "&Lcy;"
    ],
    [
        0,
        "&Mcy;"
    ],
    [
        0,
        "&Ncy;"
    ],
    [
        0,
        "&Ocy;"
    ],
    [
        0,
        "&Pcy;"
    ],
    [
        0,
        "&Rcy;"
    ],
    [
        0,
        "&Scy;"
    ],
    [
        0,
        "&Tcy;"
    ],
    [
        0,
        "&Ucy;"
    ],
    [
        0,
        "&Fcy;"
    ],
    [
        0,
        "&KHcy;"
    ],
    [
        0,
        "&TScy;"
    ],
    [
        0,
        "&CHcy;"
    ],
    [
        0,
        "&SHcy;"
    ],
    [
        0,
        "&SHCHcy;"
    ],
    [
        0,
        "&HARDcy;"
    ],
    [
        0,
        "&Ycy;"
    ],
    [
        0,
        "&SOFTcy;"
    ],
    [
        0,
        "&Ecy;"
    ],
    [
        0,
        "&YUcy;"
    ],
    [
        0,
        "&YAcy;"
    ],
    [
        0,
        "&acy;"
    ],
    [
        0,
        "&bcy;"
    ],
    [
        0,
        "&vcy;"
    ],
    [
        0,
        "&gcy;"
    ],
    [
        0,
        "&dcy;"
    ],
    [
        0,
        "&iecy;"
    ],
    [
        0,
        "&zhcy;"
    ],
    [
        0,
        "&zcy;"
    ],
    [
        0,
        "&icy;"
    ],
    [
        0,
        "&jcy;"
    ],
    [
        0,
        "&kcy;"
    ],
    [
        0,
        "&lcy;"
    ],
    [
        0,
        "&mcy;"
    ],
    [
        0,
        "&ncy;"
    ],
    [
        0,
        "&ocy;"
    ],
    [
        0,
        "&pcy;"
    ],
    [
        0,
        "&rcy;"
    ],
    [
        0,
        "&scy;"
    ],
    [
        0,
        "&tcy;"
    ],
    [
        0,
        "&ucy;"
    ],
    [
        0,
        "&fcy;"
    ],
    [
        0,
        "&khcy;"
    ],
    [
        0,
        "&tscy;"
    ],
    [
        0,
        "&chcy;"
    ],
    [
        0,
        "&shcy;"
    ],
    [
        0,
        "&shchcy;"
    ],
    [
        0,
        "&hardcy;"
    ],
    [
        0,
        "&ycy;"
    ],
    [
        0,
        "&softcy;"
    ],
    [
        0,
        "&ecy;"
    ],
    [
        0,
        "&yucy;"
    ],
    [
        0,
        "&yacy;"
    ],
    [
        1,
        "&iocy;"
    ],
    [
        0,
        "&djcy;"
    ],
    [
        0,
        "&gjcy;"
    ],
    [
        0,
        "&jukcy;"
    ],
    [
        0,
        "&dscy;"
    ],
    [
        0,
        "&iukcy;"
    ],
    [
        0,
        "&yicy;"
    ],
    [
        0,
        "&jsercy;"
    ],
    [
        0,
        "&ljcy;"
    ],
    [
        0,
        "&njcy;"
    ],
    [
        0,
        "&tshcy;"
    ],
    [
        0,
        "&kjcy;"
    ],
    [
        1,
        "&ubrcy;"
    ],
    [
        0,
        "&dzcy;"
    ],
    [
        7074,
        "&ensp;"
    ],
    [
        0,
        "&emsp;"
    ],
    [
        0,
        "&emsp13;"
    ],
    [
        0,
        "&emsp14;"
    ],
    [
        1,
        "&numsp;"
    ],
    [
        0,
        "&puncsp;"
    ],
    [
        0,
        "&ThinSpace;"
    ],
    [
        0,
        "&hairsp;"
    ],
    [
        0,
        "&NegativeMediumSpace;"
    ],
    [
        0,
        "&zwnj;"
    ],
    [
        0,
        "&zwj;"
    ],
    [
        0,
        "&lrm;"
    ],
    [
        0,
        "&rlm;"
    ],
    [
        0,
        "&dash;"
    ],
    [
        2,
        "&ndash;"
    ],
    [
        0,
        "&mdash;"
    ],
    [
        0,
        "&horbar;"
    ],
    [
        0,
        "&Verbar;"
    ],
    [
        1,
        "&lsquo;"
    ],
    [
        0,
        "&CloseCurlyQuote;"
    ],
    [
        0,
        "&lsquor;"
    ],
    [
        1,
        "&ldquo;"
    ],
    [
        0,
        "&CloseCurlyDoubleQuote;"
    ],
    [
        0,
        "&bdquo;"
    ],
    [
        1,
        "&dagger;"
    ],
    [
        0,
        "&Dagger;"
    ],
    [
        0,
        "&bull;"
    ],
    [
        2,
        "&nldr;"
    ],
    [
        0,
        "&hellip;"
    ],
    [
        9,
        "&permil;"
    ],
    [
        0,
        "&pertenk;"
    ],
    [
        0,
        "&prime;"
    ],
    [
        0,
        "&Prime;"
    ],
    [
        0,
        "&tprime;"
    ],
    [
        0,
        "&backprime;"
    ],
    [
        3,
        "&lsaquo;"
    ],
    [
        0,
        "&rsaquo;"
    ],
    [
        3,
        "&oline;"
    ],
    [
        2,
        "&caret;"
    ],
    [
        1,
        "&hybull;"
    ],
    [
        0,
        "&frasl;"
    ],
    [
        10,
        "&bsemi;"
    ],
    [
        7,
        "&qprime;"
    ],
    [
        7,
        {
            v: "&MediumSpace;",
            n: 8202,
            o: "&ThickSpace;"
        }
    ],
    [
        0,
        "&NoBreak;"
    ],
    [
        0,
        "&af;"
    ],
    [
        0,
        "&InvisibleTimes;"
    ],
    [
        0,
        "&ic;"
    ],
    [
        72,
        "&euro;"
    ],
    [
        46,
        "&tdot;"
    ],
    [
        0,
        "&DotDot;"
    ],
    [
        37,
        "&complexes;"
    ],
    [
        2,
        "&incare;"
    ],
    [
        4,
        "&gscr;"
    ],
    [
        0,
        "&hamilt;"
    ],
    [
        0,
        "&Hfr;"
    ],
    [
        0,
        "&Hopf;"
    ],
    [
        0,
        "&planckh;"
    ],
    [
        0,
        "&hbar;"
    ],
    [
        0,
        "&imagline;"
    ],
    [
        0,
        "&Ifr;"
    ],
    [
        0,
        "&lagran;"
    ],
    [
        0,
        "&ell;"
    ],
    [
        1,
        "&naturals;"
    ],
    [
        0,
        "&numero;"
    ],
    [
        0,
        "&copysr;"
    ],
    [
        0,
        "&weierp;"
    ],
    [
        0,
        "&Popf;"
    ],
    [
        0,
        "&Qopf;"
    ],
    [
        0,
        "&realine;"
    ],
    [
        0,
        "&real;"
    ],
    [
        0,
        "&reals;"
    ],
    [
        0,
        "&rx;"
    ],
    [
        3,
        "&trade;"
    ],
    [
        1,
        "&integers;"
    ],
    [
        2,
        "&mho;"
    ],
    [
        0,
        "&zeetrf;"
    ],
    [
        0,
        "&iiota;"
    ],
    [
        2,
        "&bernou;"
    ],
    [
        0,
        "&Cayleys;"
    ],
    [
        1,
        "&escr;"
    ],
    [
        0,
        "&Escr;"
    ],
    [
        0,
        "&Fouriertrf;"
    ],
    [
        1,
        "&Mellintrf;"
    ],
    [
        0,
        "&order;"
    ],
    [
        0,
        "&alefsym;"
    ],
    [
        0,
        "&beth;"
    ],
    [
        0,
        "&gimel;"
    ],
    [
        0,
        "&daleth;"
    ],
    [
        12,
        "&CapitalDifferentialD;"
    ],
    [
        0,
        "&dd;"
    ],
    [
        0,
        "&ee;"
    ],
    [
        0,
        "&ii;"
    ],
    [
        10,
        "&frac13;"
    ],
    [
        0,
        "&frac23;"
    ],
    [
        0,
        "&frac15;"
    ],
    [
        0,
        "&frac25;"
    ],
    [
        0,
        "&frac35;"
    ],
    [
        0,
        "&frac45;"
    ],
    [
        0,
        "&frac16;"
    ],
    [
        0,
        "&frac56;"
    ],
    [
        0,
        "&frac18;"
    ],
    [
        0,
        "&frac38;"
    ],
    [
        0,
        "&frac58;"
    ],
    [
        0,
        "&frac78;"
    ],
    [
        49,
        "&larr;"
    ],
    [
        0,
        "&ShortUpArrow;"
    ],
    [
        0,
        "&rarr;"
    ],
    [
        0,
        "&darr;"
    ],
    [
        0,
        "&harr;"
    ],
    [
        0,
        "&updownarrow;"
    ],
    [
        0,
        "&nwarr;"
    ],
    [
        0,
        "&nearr;"
    ],
    [
        0,
        "&LowerRightArrow;"
    ],
    [
        0,
        "&LowerLeftArrow;"
    ],
    [
        0,
        "&nlarr;"
    ],
    [
        0,
        "&nrarr;"
    ],
    [
        1,
        {
            v: "&rarrw;",
            n: 824,
            o: "&nrarrw;"
        }
    ],
    [
        0,
        "&Larr;"
    ],
    [
        0,
        "&Uarr;"
    ],
    [
        0,
        "&Rarr;"
    ],
    [
        0,
        "&Darr;"
    ],
    [
        0,
        "&larrtl;"
    ],
    [
        0,
        "&rarrtl;"
    ],
    [
        0,
        "&LeftTeeArrow;"
    ],
    [
        0,
        "&mapstoup;"
    ],
    [
        0,
        "&map;"
    ],
    [
        0,
        "&DownTeeArrow;"
    ],
    [
        1,
        "&hookleftarrow;"
    ],
    [
        0,
        "&hookrightarrow;"
    ],
    [
        0,
        "&larrlp;"
    ],
    [
        0,
        "&looparrowright;"
    ],
    [
        0,
        "&harrw;"
    ],
    [
        0,
        "&nharr;"
    ],
    [
        1,
        "&lsh;"
    ],
    [
        0,
        "&rsh;"
    ],
    [
        0,
        "&ldsh;"
    ],
    [
        0,
        "&rdsh;"
    ],
    [
        1,
        "&crarr;"
    ],
    [
        0,
        "&cularr;"
    ],
    [
        0,
        "&curarr;"
    ],
    [
        2,
        "&circlearrowleft;"
    ],
    [
        0,
        "&circlearrowright;"
    ],
    [
        0,
        "&leftharpoonup;"
    ],
    [
        0,
        "&DownLeftVector;"
    ],
    [
        0,
        "&RightUpVector;"
    ],
    [
        0,
        "&LeftUpVector;"
    ],
    [
        0,
        "&rharu;"
    ],
    [
        0,
        "&DownRightVector;"
    ],
    [
        0,
        "&dharr;"
    ],
    [
        0,
        "&dharl;"
    ],
    [
        0,
        "&RightArrowLeftArrow;"
    ],
    [
        0,
        "&udarr;"
    ],
    [
        0,
        "&LeftArrowRightArrow;"
    ],
    [
        0,
        "&leftleftarrows;"
    ],
    [
        0,
        "&upuparrows;"
    ],
    [
        0,
        "&rightrightarrows;"
    ],
    [
        0,
        "&ddarr;"
    ],
    [
        0,
        "&leftrightharpoons;"
    ],
    [
        0,
        "&Equilibrium;"
    ],
    [
        0,
        "&nlArr;"
    ],
    [
        0,
        "&nhArr;"
    ],
    [
        0,
        "&nrArr;"
    ],
    [
        0,
        "&DoubleLeftArrow;"
    ],
    [
        0,
        "&DoubleUpArrow;"
    ],
    [
        0,
        "&DoubleRightArrow;"
    ],
    [
        0,
        "&dArr;"
    ],
    [
        0,
        "&DoubleLeftRightArrow;"
    ],
    [
        0,
        "&DoubleUpDownArrow;"
    ],
    [
        0,
        "&nwArr;"
    ],
    [
        0,
        "&neArr;"
    ],
    [
        0,
        "&seArr;"
    ],
    [
        0,
        "&swArr;"
    ],
    [
        0,
        "&lAarr;"
    ],
    [
        0,
        "&rAarr;"
    ],
    [
        1,
        "&zigrarr;"
    ],
    [
        6,
        "&larrb;"
    ],
    [
        0,
        "&rarrb;"
    ],
    [
        15,
        "&DownArrowUpArrow;"
    ],
    [
        7,
        "&loarr;"
    ],
    [
        0,
        "&roarr;"
    ],
    [
        0,
        "&hoarr;"
    ],
    [
        0,
        "&forall;"
    ],
    [
        0,
        "&comp;"
    ],
    [
        0,
        {
            v: "&part;",
            n: 824,
            o: "&npart;"
        }
    ],
    [
        0,
        "&exist;"
    ],
    [
        0,
        "&nexist;"
    ],
    [
        0,
        "&empty;"
    ],
    [
        1,
        "&Del;"
    ],
    [
        0,
        "&Element;"
    ],
    [
        0,
        "&NotElement;"
    ],
    [
        1,
        "&ni;"
    ],
    [
        0,
        "&notni;"
    ],
    [
        2,
        "&prod;"
    ],
    [
        0,
        "&coprod;"
    ],
    [
        0,
        "&sum;"
    ],
    [
        0,
        "&minus;"
    ],
    [
        0,
        "&MinusPlus;"
    ],
    [
        0,
        "&dotplus;"
    ],
    [
        1,
        "&Backslash;"
    ],
    [
        0,
        "&lowast;"
    ],
    [
        0,
        "&compfn;"
    ],
    [
        1,
        "&radic;"
    ],
    [
        2,
        "&prop;"
    ],
    [
        0,
        "&infin;"
    ],
    [
        0,
        "&angrt;"
    ],
    [
        0,
        {
            v: "&ang;",
            n: 8402,
            o: "&nang;"
        }
    ],
    [
        0,
        "&angmsd;"
    ],
    [
        0,
        "&angsph;"
    ],
    [
        0,
        "&mid;"
    ],
    [
        0,
        "&nmid;"
    ],
    [
        0,
        "&DoubleVerticalBar;"
    ],
    [
        0,
        "&NotDoubleVerticalBar;"
    ],
    [
        0,
        "&and;"
    ],
    [
        0,
        "&or;"
    ],
    [
        0,
        {
            v: "&cap;",
            n: 65024,
            o: "&caps;"
        }
    ],
    [
        0,
        {
            v: "&cup;",
            n: 65024,
            o: "&cups;"
        }
    ],
    [
        0,
        "&int;"
    ],
    [
        0,
        "&Int;"
    ],
    [
        0,
        "&iiint;"
    ],
    [
        0,
        "&conint;"
    ],
    [
        0,
        "&Conint;"
    ],
    [
        0,
        "&Cconint;"
    ],
    [
        0,
        "&cwint;"
    ],
    [
        0,
        "&ClockwiseContourIntegral;"
    ],
    [
        0,
        "&awconint;"
    ],
    [
        0,
        "&there4;"
    ],
    [
        0,
        "&becaus;"
    ],
    [
        0,
        "&ratio;"
    ],
    [
        0,
        "&Colon;"
    ],
    [
        0,
        "&dotminus;"
    ],
    [
        1,
        "&mDDot;"
    ],
    [
        0,
        "&homtht;"
    ],
    [
        0,
        {
            v: "&sim;",
            n: 8402,
            o: "&nvsim;"
        }
    ],
    [
        0,
        {
            v: "&backsim;",
            n: 817,
            o: "&race;"
        }
    ],
    [
        0,
        {
            v: "&ac;",
            n: 819,
            o: "&acE;"
        }
    ],
    [
        0,
        "&acd;"
    ],
    [
        0,
        "&VerticalTilde;"
    ],
    [
        0,
        "&NotTilde;"
    ],
    [
        0,
        {
            v: "&eqsim;",
            n: 824,
            o: "&nesim;"
        }
    ],
    [
        0,
        "&sime;"
    ],
    [
        0,
        "&NotTildeEqual;"
    ],
    [
        0,
        "&cong;"
    ],
    [
        0,
        "&simne;"
    ],
    [
        0,
        "&ncong;"
    ],
    [
        0,
        "&ap;"
    ],
    [
        0,
        "&nap;"
    ],
    [
        0,
        "&ape;"
    ],
    [
        0,
        {
            v: "&apid;",
            n: 824,
            o: "&napid;"
        }
    ],
    [
        0,
        "&backcong;"
    ],
    [
        0,
        {
            v: "&asympeq;",
            n: 8402,
            o: "&nvap;"
        }
    ],
    [
        0,
        {
            v: "&bump;",
            n: 824,
            o: "&nbump;"
        }
    ],
    [
        0,
        {
            v: "&bumpe;",
            n: 824,
            o: "&nbumpe;"
        }
    ],
    [
        0,
        {
            v: "&doteq;",
            n: 824,
            o: "&nedot;"
        }
    ],
    [
        0,
        "&doteqdot;"
    ],
    [
        0,
        "&efDot;"
    ],
    [
        0,
        "&erDot;"
    ],
    [
        0,
        "&Assign;"
    ],
    [
        0,
        "&ecolon;"
    ],
    [
        0,
        "&ecir;"
    ],
    [
        0,
        "&circeq;"
    ],
    [
        1,
        "&wedgeq;"
    ],
    [
        0,
        "&veeeq;"
    ],
    [
        1,
        "&triangleq;"
    ],
    [
        2,
        "&equest;"
    ],
    [
        0,
        "&ne;"
    ],
    [
        0,
        {
            v: "&Congruent;",
            n: 8421,
            o: "&bnequiv;"
        }
    ],
    [
        0,
        "&nequiv;"
    ],
    [
        1,
        {
            v: "&le;",
            n: 8402,
            o: "&nvle;"
        }
    ],
    [
        0,
        {
            v: "&ge;",
            n: 8402,
            o: "&nvge;"
        }
    ],
    [
        0,
        {
            v: "&lE;",
            n: 824,
            o: "&nlE;"
        }
    ],
    [
        0,
        {
            v: "&gE;",
            n: 824,
            o: "&ngE;"
        }
    ],
    [
        0,
        {
            v: "&lnE;",
            n: 65024,
            o: "&lvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&gnE;",
            n: 65024,
            o: "&gvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&ll;",
            n: new Map(/* #__PURE__ */ $98887e1d0958bc17$var$restoreDiff([
                [
                    824,
                    "&nLtv;"
                ],
                [
                    7577,
                    "&nLt;"
                ]
            ]))
        }
    ],
    [
        0,
        {
            v: "&gg;",
            n: new Map(/* #__PURE__ */ $98887e1d0958bc17$var$restoreDiff([
                [
                    824,
                    "&nGtv;"
                ],
                [
                    7577,
                    "&nGt;"
                ]
            ]))
        }
    ],
    [
        0,
        "&between;"
    ],
    [
        0,
        "&NotCupCap;"
    ],
    [
        0,
        "&nless;"
    ],
    [
        0,
        "&ngt;"
    ],
    [
        0,
        "&nle;"
    ],
    [
        0,
        "&nge;"
    ],
    [
        0,
        "&lesssim;"
    ],
    [
        0,
        "&GreaterTilde;"
    ],
    [
        0,
        "&nlsim;"
    ],
    [
        0,
        "&ngsim;"
    ],
    [
        0,
        "&LessGreater;"
    ],
    [
        0,
        "&gl;"
    ],
    [
        0,
        "&NotLessGreater;"
    ],
    [
        0,
        "&NotGreaterLess;"
    ],
    [
        0,
        "&pr;"
    ],
    [
        0,
        "&sc;"
    ],
    [
        0,
        "&prcue;"
    ],
    [
        0,
        "&sccue;"
    ],
    [
        0,
        "&PrecedesTilde;"
    ],
    [
        0,
        {
            v: "&scsim;",
            n: 824,
            o: "&NotSucceedsTilde;"
        }
    ],
    [
        0,
        "&NotPrecedes;"
    ],
    [
        0,
        "&NotSucceeds;"
    ],
    [
        0,
        {
            v: "&sub;",
            n: 8402,
            o: "&NotSubset;"
        }
    ],
    [
        0,
        {
            v: "&sup;",
            n: 8402,
            o: "&NotSuperset;"
        }
    ],
    [
        0,
        "&nsub;"
    ],
    [
        0,
        "&nsup;"
    ],
    [
        0,
        "&sube;"
    ],
    [
        0,
        "&supe;"
    ],
    [
        0,
        "&NotSubsetEqual;"
    ],
    [
        0,
        "&NotSupersetEqual;"
    ],
    [
        0,
        {
            v: "&subne;",
            n: 65024,
            o: "&varsubsetneq;"
        }
    ],
    [
        0,
        {
            v: "&supne;",
            n: 65024,
            o: "&varsupsetneq;"
        }
    ],
    [
        1,
        "&cupdot;"
    ],
    [
        0,
        "&UnionPlus;"
    ],
    [
        0,
        {
            v: "&sqsub;",
            n: 824,
            o: "&NotSquareSubset;"
        }
    ],
    [
        0,
        {
            v: "&sqsup;",
            n: 824,
            o: "&NotSquareSuperset;"
        }
    ],
    [
        0,
        "&sqsube;"
    ],
    [
        0,
        "&sqsupe;"
    ],
    [
        0,
        {
            v: "&sqcap;",
            n: 65024,
            o: "&sqcaps;"
        }
    ],
    [
        0,
        {
            v: "&sqcup;",
            n: 65024,
            o: "&sqcups;"
        }
    ],
    [
        0,
        "&CirclePlus;"
    ],
    [
        0,
        "&CircleMinus;"
    ],
    [
        0,
        "&CircleTimes;"
    ],
    [
        0,
        "&osol;"
    ],
    [
        0,
        "&CircleDot;"
    ],
    [
        0,
        "&circledcirc;"
    ],
    [
        0,
        "&circledast;"
    ],
    [
        1,
        "&circleddash;"
    ],
    [
        0,
        "&boxplus;"
    ],
    [
        0,
        "&boxminus;"
    ],
    [
        0,
        "&boxtimes;"
    ],
    [
        0,
        "&dotsquare;"
    ],
    [
        0,
        "&RightTee;"
    ],
    [
        0,
        "&dashv;"
    ],
    [
        0,
        "&DownTee;"
    ],
    [
        0,
        "&bot;"
    ],
    [
        1,
        "&models;"
    ],
    [
        0,
        "&DoubleRightTee;"
    ],
    [
        0,
        "&Vdash;"
    ],
    [
        0,
        "&Vvdash;"
    ],
    [
        0,
        "&VDash;"
    ],
    [
        0,
        "&nvdash;"
    ],
    [
        0,
        "&nvDash;"
    ],
    [
        0,
        "&nVdash;"
    ],
    [
        0,
        "&nVDash;"
    ],
    [
        0,
        "&prurel;"
    ],
    [
        1,
        "&LeftTriangle;"
    ],
    [
        0,
        "&RightTriangle;"
    ],
    [
        0,
        {
            v: "&LeftTriangleEqual;",
            n: 8402,
            o: "&nvltrie;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleEqual;",
            n: 8402,
            o: "&nvrtrie;"
        }
    ],
    [
        0,
        "&origof;"
    ],
    [
        0,
        "&imof;"
    ],
    [
        0,
        "&multimap;"
    ],
    [
        0,
        "&hercon;"
    ],
    [
        0,
        "&intcal;"
    ],
    [
        0,
        "&veebar;"
    ],
    [
        1,
        "&barvee;"
    ],
    [
        0,
        "&angrtvb;"
    ],
    [
        0,
        "&lrtri;"
    ],
    [
        0,
        "&bigwedge;"
    ],
    [
        0,
        "&bigvee;"
    ],
    [
        0,
        "&bigcap;"
    ],
    [
        0,
        "&bigcup;"
    ],
    [
        0,
        "&diam;"
    ],
    [
        0,
        "&sdot;"
    ],
    [
        0,
        "&sstarf;"
    ],
    [
        0,
        "&divideontimes;"
    ],
    [
        0,
        "&bowtie;"
    ],
    [
        0,
        "&ltimes;"
    ],
    [
        0,
        "&rtimes;"
    ],
    [
        0,
        "&leftthreetimes;"
    ],
    [
        0,
        "&rightthreetimes;"
    ],
    [
        0,
        "&backsimeq;"
    ],
    [
        0,
        "&curlyvee;"
    ],
    [
        0,
        "&curlywedge;"
    ],
    [
        0,
        "&Sub;"
    ],
    [
        0,
        "&Sup;"
    ],
    [
        0,
        "&Cap;"
    ],
    [
        0,
        "&Cup;"
    ],
    [
        0,
        "&fork;"
    ],
    [
        0,
        "&epar;"
    ],
    [
        0,
        "&lessdot;"
    ],
    [
        0,
        "&gtdot;"
    ],
    [
        0,
        {
            v: "&Ll;",
            n: 824,
            o: "&nLl;"
        }
    ],
    [
        0,
        {
            v: "&Gg;",
            n: 824,
            o: "&nGg;"
        }
    ],
    [
        0,
        {
            v: "&leg;",
            n: 65024,
            o: "&lesg;"
        }
    ],
    [
        0,
        {
            v: "&gel;",
            n: 65024,
            o: "&gesl;"
        }
    ],
    [
        2,
        "&cuepr;"
    ],
    [
        0,
        "&cuesc;"
    ],
    [
        0,
        "&NotPrecedesSlantEqual;"
    ],
    [
        0,
        "&NotSucceedsSlantEqual;"
    ],
    [
        0,
        "&NotSquareSubsetEqual;"
    ],
    [
        0,
        "&NotSquareSupersetEqual;"
    ],
    [
        2,
        "&lnsim;"
    ],
    [
        0,
        "&gnsim;"
    ],
    [
        0,
        "&precnsim;"
    ],
    [
        0,
        "&scnsim;"
    ],
    [
        0,
        "&nltri;"
    ],
    [
        0,
        "&NotRightTriangle;"
    ],
    [
        0,
        "&nltrie;"
    ],
    [
        0,
        "&NotRightTriangleEqual;"
    ],
    [
        0,
        "&vellip;"
    ],
    [
        0,
        "&ctdot;"
    ],
    [
        0,
        "&utdot;"
    ],
    [
        0,
        "&dtdot;"
    ],
    [
        0,
        "&disin;"
    ],
    [
        0,
        "&isinsv;"
    ],
    [
        0,
        "&isins;"
    ],
    [
        0,
        {
            v: "&isindot;",
            n: 824,
            o: "&notindot;"
        }
    ],
    [
        0,
        "&notinvc;"
    ],
    [
        0,
        "&notinvb;"
    ],
    [
        1,
        {
            v: "&isinE;",
            n: 824,
            o: "&notinE;"
        }
    ],
    [
        0,
        "&nisd;"
    ],
    [
        0,
        "&xnis;"
    ],
    [
        0,
        "&nis;"
    ],
    [
        0,
        "&notnivc;"
    ],
    [
        0,
        "&notnivb;"
    ],
    [
        6,
        "&barwed;"
    ],
    [
        0,
        "&Barwed;"
    ],
    [
        1,
        "&lceil;"
    ],
    [
        0,
        "&rceil;"
    ],
    [
        0,
        "&LeftFloor;"
    ],
    [
        0,
        "&rfloor;"
    ],
    [
        0,
        "&drcrop;"
    ],
    [
        0,
        "&dlcrop;"
    ],
    [
        0,
        "&urcrop;"
    ],
    [
        0,
        "&ulcrop;"
    ],
    [
        0,
        "&bnot;"
    ],
    [
        1,
        "&profline;"
    ],
    [
        0,
        "&profsurf;"
    ],
    [
        1,
        "&telrec;"
    ],
    [
        0,
        "&target;"
    ],
    [
        5,
        "&ulcorn;"
    ],
    [
        0,
        "&urcorn;"
    ],
    [
        0,
        "&dlcorn;"
    ],
    [
        0,
        "&drcorn;"
    ],
    [
        2,
        "&frown;"
    ],
    [
        0,
        "&smile;"
    ],
    [
        9,
        "&cylcty;"
    ],
    [
        0,
        "&profalar;"
    ],
    [
        7,
        "&topbot;"
    ],
    [
        6,
        "&ovbar;"
    ],
    [
        1,
        "&solbar;"
    ],
    [
        60,
        "&angzarr;"
    ],
    [
        51,
        "&lmoustache;"
    ],
    [
        0,
        "&rmoustache;"
    ],
    [
        2,
        "&OverBracket;"
    ],
    [
        0,
        "&bbrk;"
    ],
    [
        0,
        "&bbrktbrk;"
    ],
    [
        37,
        "&OverParenthesis;"
    ],
    [
        0,
        "&UnderParenthesis;"
    ],
    [
        0,
        "&OverBrace;"
    ],
    [
        0,
        "&UnderBrace;"
    ],
    [
        2,
        "&trpezium;"
    ],
    [
        4,
        "&elinters;"
    ],
    [
        59,
        "&blank;"
    ],
    [
        164,
        "&circledS;"
    ],
    [
        55,
        "&boxh;"
    ],
    [
        1,
        "&boxv;"
    ],
    [
        9,
        "&boxdr;"
    ],
    [
        3,
        "&boxdl;"
    ],
    [
        3,
        "&boxur;"
    ],
    [
        3,
        "&boxul;"
    ],
    [
        3,
        "&boxvr;"
    ],
    [
        7,
        "&boxvl;"
    ],
    [
        7,
        "&boxhd;"
    ],
    [
        7,
        "&boxhu;"
    ],
    [
        7,
        "&boxvh;"
    ],
    [
        19,
        "&boxH;"
    ],
    [
        0,
        "&boxV;"
    ],
    [
        0,
        "&boxdR;"
    ],
    [
        0,
        "&boxDr;"
    ],
    [
        0,
        "&boxDR;"
    ],
    [
        0,
        "&boxdL;"
    ],
    [
        0,
        "&boxDl;"
    ],
    [
        0,
        "&boxDL;"
    ],
    [
        0,
        "&boxuR;"
    ],
    [
        0,
        "&boxUr;"
    ],
    [
        0,
        "&boxUR;"
    ],
    [
        0,
        "&boxuL;"
    ],
    [
        0,
        "&boxUl;"
    ],
    [
        0,
        "&boxUL;"
    ],
    [
        0,
        "&boxvR;"
    ],
    [
        0,
        "&boxVr;"
    ],
    [
        0,
        "&boxVR;"
    ],
    [
        0,
        "&boxvL;"
    ],
    [
        0,
        "&boxVl;"
    ],
    [
        0,
        "&boxVL;"
    ],
    [
        0,
        "&boxHd;"
    ],
    [
        0,
        "&boxhD;"
    ],
    [
        0,
        "&boxHD;"
    ],
    [
        0,
        "&boxHu;"
    ],
    [
        0,
        "&boxhU;"
    ],
    [
        0,
        "&boxHU;"
    ],
    [
        0,
        "&boxvH;"
    ],
    [
        0,
        "&boxVh;"
    ],
    [
        0,
        "&boxVH;"
    ],
    [
        19,
        "&uhblk;"
    ],
    [
        3,
        "&lhblk;"
    ],
    [
        3,
        "&block;"
    ],
    [
        8,
        "&blk14;"
    ],
    [
        0,
        "&blk12;"
    ],
    [
        0,
        "&blk34;"
    ],
    [
        13,
        "&square;"
    ],
    [
        8,
        "&blacksquare;"
    ],
    [
        0,
        "&EmptyVerySmallSquare;"
    ],
    [
        1,
        "&rect;"
    ],
    [
        0,
        "&marker;"
    ],
    [
        2,
        "&fltns;"
    ],
    [
        1,
        "&bigtriangleup;"
    ],
    [
        0,
        "&blacktriangle;"
    ],
    [
        0,
        "&triangle;"
    ],
    [
        2,
        "&blacktriangleright;"
    ],
    [
        0,
        "&rtri;"
    ],
    [
        3,
        "&bigtriangledown;"
    ],
    [
        0,
        "&blacktriangledown;"
    ],
    [
        0,
        "&dtri;"
    ],
    [
        2,
        "&blacktriangleleft;"
    ],
    [
        0,
        "&ltri;"
    ],
    [
        6,
        "&loz;"
    ],
    [
        0,
        "&cir;"
    ],
    [
        32,
        "&tridot;"
    ],
    [
        2,
        "&bigcirc;"
    ],
    [
        8,
        "&ultri;"
    ],
    [
        0,
        "&urtri;"
    ],
    [
        0,
        "&lltri;"
    ],
    [
        0,
        "&EmptySmallSquare;"
    ],
    [
        0,
        "&FilledSmallSquare;"
    ],
    [
        8,
        "&bigstar;"
    ],
    [
        0,
        "&star;"
    ],
    [
        7,
        "&phone;"
    ],
    [
        49,
        "&female;"
    ],
    [
        1,
        "&male;"
    ],
    [
        29,
        "&spades;"
    ],
    [
        2,
        "&clubs;"
    ],
    [
        1,
        "&hearts;"
    ],
    [
        0,
        "&diamondsuit;"
    ],
    [
        3,
        "&sung;"
    ],
    [
        2,
        "&flat;"
    ],
    [
        0,
        "&natural;"
    ],
    [
        0,
        "&sharp;"
    ],
    [
        163,
        "&check;"
    ],
    [
        3,
        "&cross;"
    ],
    [
        8,
        "&malt;"
    ],
    [
        21,
        "&sext;"
    ],
    [
        33,
        "&VerticalSeparator;"
    ],
    [
        25,
        "&lbbrk;"
    ],
    [
        0,
        "&rbbrk;"
    ],
    [
        84,
        "&bsolhsub;"
    ],
    [
        0,
        "&suphsol;"
    ],
    [
        28,
        "&LeftDoubleBracket;"
    ],
    [
        0,
        "&RightDoubleBracket;"
    ],
    [
        0,
        "&lang;"
    ],
    [
        0,
        "&rang;"
    ],
    [
        0,
        "&Lang;"
    ],
    [
        0,
        "&Rang;"
    ],
    [
        0,
        "&loang;"
    ],
    [
        0,
        "&roang;"
    ],
    [
        7,
        "&longleftarrow;"
    ],
    [
        0,
        "&longrightarrow;"
    ],
    [
        0,
        "&longleftrightarrow;"
    ],
    [
        0,
        "&DoubleLongLeftArrow;"
    ],
    [
        0,
        "&DoubleLongRightArrow;"
    ],
    [
        0,
        "&DoubleLongLeftRightArrow;"
    ],
    [
        1,
        "&longmapsto;"
    ],
    [
        2,
        "&dzigrarr;"
    ],
    [
        258,
        "&nvlArr;"
    ],
    [
        0,
        "&nvrArr;"
    ],
    [
        0,
        "&nvHarr;"
    ],
    [
        0,
        "&Map;"
    ],
    [
        6,
        "&lbarr;"
    ],
    [
        0,
        "&bkarow;"
    ],
    [
        0,
        "&lBarr;"
    ],
    [
        0,
        "&dbkarow;"
    ],
    [
        0,
        "&drbkarow;"
    ],
    [
        0,
        "&DDotrahd;"
    ],
    [
        0,
        "&UpArrowBar;"
    ],
    [
        0,
        "&DownArrowBar;"
    ],
    [
        2,
        "&Rarrtl;"
    ],
    [
        2,
        "&latail;"
    ],
    [
        0,
        "&ratail;"
    ],
    [
        0,
        "&lAtail;"
    ],
    [
        0,
        "&rAtail;"
    ],
    [
        0,
        "&larrfs;"
    ],
    [
        0,
        "&rarrfs;"
    ],
    [
        0,
        "&larrbfs;"
    ],
    [
        0,
        "&rarrbfs;"
    ],
    [
        2,
        "&nwarhk;"
    ],
    [
        0,
        "&nearhk;"
    ],
    [
        0,
        "&hksearow;"
    ],
    [
        0,
        "&hkswarow;"
    ],
    [
        0,
        "&nwnear;"
    ],
    [
        0,
        "&nesear;"
    ],
    [
        0,
        "&seswar;"
    ],
    [
        0,
        "&swnwar;"
    ],
    [
        8,
        {
            v: "&rarrc;",
            n: 824,
            o: "&nrarrc;"
        }
    ],
    [
        1,
        "&cudarrr;"
    ],
    [
        0,
        "&ldca;"
    ],
    [
        0,
        "&rdca;"
    ],
    [
        0,
        "&cudarrl;"
    ],
    [
        0,
        "&larrpl;"
    ],
    [
        2,
        "&curarrm;"
    ],
    [
        0,
        "&cularrp;"
    ],
    [
        7,
        "&rarrpl;"
    ],
    [
        2,
        "&harrcir;"
    ],
    [
        0,
        "&Uarrocir;"
    ],
    [
        0,
        "&lurdshar;"
    ],
    [
        0,
        "&ldrushar;"
    ],
    [
        2,
        "&LeftRightVector;"
    ],
    [
        0,
        "&RightUpDownVector;"
    ],
    [
        0,
        "&DownLeftRightVector;"
    ],
    [
        0,
        "&LeftUpDownVector;"
    ],
    [
        0,
        "&LeftVectorBar;"
    ],
    [
        0,
        "&RightVectorBar;"
    ],
    [
        0,
        "&RightUpVectorBar;"
    ],
    [
        0,
        "&RightDownVectorBar;"
    ],
    [
        0,
        "&DownLeftVectorBar;"
    ],
    [
        0,
        "&DownRightVectorBar;"
    ],
    [
        0,
        "&LeftUpVectorBar;"
    ],
    [
        0,
        "&LeftDownVectorBar;"
    ],
    [
        0,
        "&LeftTeeVector;"
    ],
    [
        0,
        "&RightTeeVector;"
    ],
    [
        0,
        "&RightUpTeeVector;"
    ],
    [
        0,
        "&RightDownTeeVector;"
    ],
    [
        0,
        "&DownLeftTeeVector;"
    ],
    [
        0,
        "&DownRightTeeVector;"
    ],
    [
        0,
        "&LeftUpTeeVector;"
    ],
    [
        0,
        "&LeftDownTeeVector;"
    ],
    [
        0,
        "&lHar;"
    ],
    [
        0,
        "&uHar;"
    ],
    [
        0,
        "&rHar;"
    ],
    [
        0,
        "&dHar;"
    ],
    [
        0,
        "&luruhar;"
    ],
    [
        0,
        "&ldrdhar;"
    ],
    [
        0,
        "&ruluhar;"
    ],
    [
        0,
        "&rdldhar;"
    ],
    [
        0,
        "&lharul;"
    ],
    [
        0,
        "&llhard;"
    ],
    [
        0,
        "&rharul;"
    ],
    [
        0,
        "&lrhard;"
    ],
    [
        0,
        "&udhar;"
    ],
    [
        0,
        "&duhar;"
    ],
    [
        0,
        "&RoundImplies;"
    ],
    [
        0,
        "&erarr;"
    ],
    [
        0,
        "&simrarr;"
    ],
    [
        0,
        "&larrsim;"
    ],
    [
        0,
        "&rarrsim;"
    ],
    [
        0,
        "&rarrap;"
    ],
    [
        0,
        "&ltlarr;"
    ],
    [
        1,
        "&gtrarr;"
    ],
    [
        0,
        "&subrarr;"
    ],
    [
        1,
        "&suplarr;"
    ],
    [
        0,
        "&lfisht;"
    ],
    [
        0,
        "&rfisht;"
    ],
    [
        0,
        "&ufisht;"
    ],
    [
        0,
        "&dfisht;"
    ],
    [
        5,
        "&lopar;"
    ],
    [
        0,
        "&ropar;"
    ],
    [
        4,
        "&lbrke;"
    ],
    [
        0,
        "&rbrke;"
    ],
    [
        0,
        "&lbrkslu;"
    ],
    [
        0,
        "&rbrksld;"
    ],
    [
        0,
        "&lbrksld;"
    ],
    [
        0,
        "&rbrkslu;"
    ],
    [
        0,
        "&langd;"
    ],
    [
        0,
        "&rangd;"
    ],
    [
        0,
        "&lparlt;"
    ],
    [
        0,
        "&rpargt;"
    ],
    [
        0,
        "&gtlPar;"
    ],
    [
        0,
        "&ltrPar;"
    ],
    [
        3,
        "&vzigzag;"
    ],
    [
        1,
        "&vangrt;"
    ],
    [
        0,
        "&angrtvbd;"
    ],
    [
        6,
        "&ange;"
    ],
    [
        0,
        "&range;"
    ],
    [
        0,
        "&dwangle;"
    ],
    [
        0,
        "&uwangle;"
    ],
    [
        0,
        "&angmsdaa;"
    ],
    [
        0,
        "&angmsdab;"
    ],
    [
        0,
        "&angmsdac;"
    ],
    [
        0,
        "&angmsdad;"
    ],
    [
        0,
        "&angmsdae;"
    ],
    [
        0,
        "&angmsdaf;"
    ],
    [
        0,
        "&angmsdag;"
    ],
    [
        0,
        "&angmsdah;"
    ],
    [
        0,
        "&bemptyv;"
    ],
    [
        0,
        "&demptyv;"
    ],
    [
        0,
        "&cemptyv;"
    ],
    [
        0,
        "&raemptyv;"
    ],
    [
        0,
        "&laemptyv;"
    ],
    [
        0,
        "&ohbar;"
    ],
    [
        0,
        "&omid;"
    ],
    [
        0,
        "&opar;"
    ],
    [
        1,
        "&operp;"
    ],
    [
        1,
        "&olcross;"
    ],
    [
        0,
        "&odsold;"
    ],
    [
        1,
        "&olcir;"
    ],
    [
        0,
        "&ofcir;"
    ],
    [
        0,
        "&olt;"
    ],
    [
        0,
        "&ogt;"
    ],
    [
        0,
        "&cirscir;"
    ],
    [
        0,
        "&cirE;"
    ],
    [
        0,
        "&solb;"
    ],
    [
        0,
        "&bsolb;"
    ],
    [
        3,
        "&boxbox;"
    ],
    [
        3,
        "&trisb;"
    ],
    [
        0,
        "&rtriltri;"
    ],
    [
        0,
        {
            v: "&LeftTriangleBar;",
            n: 824,
            o: "&NotLeftTriangleBar;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleBar;",
            n: 824,
            o: "&NotRightTriangleBar;"
        }
    ],
    [
        11,
        "&iinfin;"
    ],
    [
        0,
        "&infintie;"
    ],
    [
        0,
        "&nvinfin;"
    ],
    [
        4,
        "&eparsl;"
    ],
    [
        0,
        "&smeparsl;"
    ],
    [
        0,
        "&eqvparsl;"
    ],
    [
        5,
        "&blacklozenge;"
    ],
    [
        8,
        "&RuleDelayed;"
    ],
    [
        1,
        "&dsol;"
    ],
    [
        9,
        "&bigodot;"
    ],
    [
        0,
        "&bigoplus;"
    ],
    [
        0,
        "&bigotimes;"
    ],
    [
        1,
        "&biguplus;"
    ],
    [
        1,
        "&bigsqcup;"
    ],
    [
        5,
        "&iiiint;"
    ],
    [
        0,
        "&fpartint;"
    ],
    [
        2,
        "&cirfnint;"
    ],
    [
        0,
        "&awint;"
    ],
    [
        0,
        "&rppolint;"
    ],
    [
        0,
        "&scpolint;"
    ],
    [
        0,
        "&npolint;"
    ],
    [
        0,
        "&pointint;"
    ],
    [
        0,
        "&quatint;"
    ],
    [
        0,
        "&intlarhk;"
    ],
    [
        10,
        "&pluscir;"
    ],
    [
        0,
        "&plusacir;"
    ],
    [
        0,
        "&simplus;"
    ],
    [
        0,
        "&plusdu;"
    ],
    [
        0,
        "&plussim;"
    ],
    [
        0,
        "&plustwo;"
    ],
    [
        1,
        "&mcomma;"
    ],
    [
        0,
        "&minusdu;"
    ],
    [
        2,
        "&loplus;"
    ],
    [
        0,
        "&roplus;"
    ],
    [
        0,
        "&Cross;"
    ],
    [
        0,
        "&timesd;"
    ],
    [
        0,
        "&timesbar;"
    ],
    [
        1,
        "&smashp;"
    ],
    [
        0,
        "&lotimes;"
    ],
    [
        0,
        "&rotimes;"
    ],
    [
        0,
        "&otimesas;"
    ],
    [
        0,
        "&Otimes;"
    ],
    [
        0,
        "&odiv;"
    ],
    [
        0,
        "&triplus;"
    ],
    [
        0,
        "&triminus;"
    ],
    [
        0,
        "&tritime;"
    ],
    [
        0,
        "&intprod;"
    ],
    [
        2,
        "&amalg;"
    ],
    [
        0,
        "&capdot;"
    ],
    [
        1,
        "&ncup;"
    ],
    [
        0,
        "&ncap;"
    ],
    [
        0,
        "&capand;"
    ],
    [
        0,
        "&cupor;"
    ],
    [
        0,
        "&cupcap;"
    ],
    [
        0,
        "&capcup;"
    ],
    [
        0,
        "&cupbrcap;"
    ],
    [
        0,
        "&capbrcup;"
    ],
    [
        0,
        "&cupcup;"
    ],
    [
        0,
        "&capcap;"
    ],
    [
        0,
        "&ccups;"
    ],
    [
        0,
        "&ccaps;"
    ],
    [
        2,
        "&ccupssm;"
    ],
    [
        2,
        "&And;"
    ],
    [
        0,
        "&Or;"
    ],
    [
        0,
        "&andand;"
    ],
    [
        0,
        "&oror;"
    ],
    [
        0,
        "&orslope;"
    ],
    [
        0,
        "&andslope;"
    ],
    [
        1,
        "&andv;"
    ],
    [
        0,
        "&orv;"
    ],
    [
        0,
        "&andd;"
    ],
    [
        0,
        "&ord;"
    ],
    [
        1,
        "&wedbar;"
    ],
    [
        6,
        "&sdote;"
    ],
    [
        3,
        "&simdot;"
    ],
    [
        2,
        {
            v: "&congdot;",
            n: 824,
            o: "&ncongdot;"
        }
    ],
    [
        0,
        "&easter;"
    ],
    [
        0,
        "&apacir;"
    ],
    [
        0,
        {
            v: "&apE;",
            n: 824,
            o: "&napE;"
        }
    ],
    [
        0,
        "&eplus;"
    ],
    [
        0,
        "&pluse;"
    ],
    [
        0,
        "&Esim;"
    ],
    [
        0,
        "&Colone;"
    ],
    [
        0,
        "&Equal;"
    ],
    [
        1,
        "&ddotseq;"
    ],
    [
        0,
        "&equivDD;"
    ],
    [
        0,
        "&ltcir;"
    ],
    [
        0,
        "&gtcir;"
    ],
    [
        0,
        "&ltquest;"
    ],
    [
        0,
        "&gtquest;"
    ],
    [
        0,
        {
            v: "&leqslant;",
            n: 824,
            o: "&nleqslant;"
        }
    ],
    [
        0,
        {
            v: "&geqslant;",
            n: 824,
            o: "&ngeqslant;"
        }
    ],
    [
        0,
        "&lesdot;"
    ],
    [
        0,
        "&gesdot;"
    ],
    [
        0,
        "&lesdoto;"
    ],
    [
        0,
        "&gesdoto;"
    ],
    [
        0,
        "&lesdotor;"
    ],
    [
        0,
        "&gesdotol;"
    ],
    [
        0,
        "&lap;"
    ],
    [
        0,
        "&gap;"
    ],
    [
        0,
        "&lne;"
    ],
    [
        0,
        "&gne;"
    ],
    [
        0,
        "&lnap;"
    ],
    [
        0,
        "&gnap;"
    ],
    [
        0,
        "&lEg;"
    ],
    [
        0,
        "&gEl;"
    ],
    [
        0,
        "&lsime;"
    ],
    [
        0,
        "&gsime;"
    ],
    [
        0,
        "&lsimg;"
    ],
    [
        0,
        "&gsiml;"
    ],
    [
        0,
        "&lgE;"
    ],
    [
        0,
        "&glE;"
    ],
    [
        0,
        "&lesges;"
    ],
    [
        0,
        "&gesles;"
    ],
    [
        0,
        "&els;"
    ],
    [
        0,
        "&egs;"
    ],
    [
        0,
        "&elsdot;"
    ],
    [
        0,
        "&egsdot;"
    ],
    [
        0,
        "&el;"
    ],
    [
        0,
        "&eg;"
    ],
    [
        2,
        "&siml;"
    ],
    [
        0,
        "&simg;"
    ],
    [
        0,
        "&simlE;"
    ],
    [
        0,
        "&simgE;"
    ],
    [
        0,
        {
            v: "&LessLess;",
            n: 824,
            o: "&NotNestedLessLess;"
        }
    ],
    [
        0,
        {
            v: "&GreaterGreater;",
            n: 824,
            o: "&NotNestedGreaterGreater;"
        }
    ],
    [
        1,
        "&glj;"
    ],
    [
        0,
        "&gla;"
    ],
    [
        0,
        "&ltcc;"
    ],
    [
        0,
        "&gtcc;"
    ],
    [
        0,
        "&lescc;"
    ],
    [
        0,
        "&gescc;"
    ],
    [
        0,
        "&smt;"
    ],
    [
        0,
        "&lat;"
    ],
    [
        0,
        {
            v: "&smte;",
            n: 65024,
            o: "&smtes;"
        }
    ],
    [
        0,
        {
            v: "&late;",
            n: 65024,
            o: "&lates;"
        }
    ],
    [
        0,
        "&bumpE;"
    ],
    [
        0,
        {
            v: "&PrecedesEqual;",
            n: 824,
            o: "&NotPrecedesEqual;"
        }
    ],
    [
        0,
        {
            v: "&sce;",
            n: 824,
            o: "&NotSucceedsEqual;"
        }
    ],
    [
        2,
        "&prE;"
    ],
    [
        0,
        "&scE;"
    ],
    [
        0,
        "&precneqq;"
    ],
    [
        0,
        "&scnE;"
    ],
    [
        0,
        "&prap;"
    ],
    [
        0,
        "&scap;"
    ],
    [
        0,
        "&precnapprox;"
    ],
    [
        0,
        "&scnap;"
    ],
    [
        0,
        "&Pr;"
    ],
    [
        0,
        "&Sc;"
    ],
    [
        0,
        "&subdot;"
    ],
    [
        0,
        "&supdot;"
    ],
    [
        0,
        "&subplus;"
    ],
    [
        0,
        "&supplus;"
    ],
    [
        0,
        "&submult;"
    ],
    [
        0,
        "&supmult;"
    ],
    [
        0,
        "&subedot;"
    ],
    [
        0,
        "&supedot;"
    ],
    [
        0,
        {
            v: "&subE;",
            n: 824,
            o: "&nsubE;"
        }
    ],
    [
        0,
        {
            v: "&supE;",
            n: 824,
            o: "&nsupE;"
        }
    ],
    [
        0,
        "&subsim;"
    ],
    [
        0,
        "&supsim;"
    ],
    [
        2,
        {
            v: "&subnE;",
            n: 65024,
            o: "&varsubsetneqq;"
        }
    ],
    [
        0,
        {
            v: "&supnE;",
            n: 65024,
            o: "&varsupsetneqq;"
        }
    ],
    [
        2,
        "&csub;"
    ],
    [
        0,
        "&csup;"
    ],
    [
        0,
        "&csube;"
    ],
    [
        0,
        "&csupe;"
    ],
    [
        0,
        "&subsup;"
    ],
    [
        0,
        "&supsub;"
    ],
    [
        0,
        "&subsub;"
    ],
    [
        0,
        "&supsup;"
    ],
    [
        0,
        "&suphsub;"
    ],
    [
        0,
        "&supdsub;"
    ],
    [
        0,
        "&forkv;"
    ],
    [
        0,
        "&topfork;"
    ],
    [
        0,
        "&mlcp;"
    ],
    [
        8,
        "&Dashv;"
    ],
    [
        1,
        "&Vdashl;"
    ],
    [
        0,
        "&Barv;"
    ],
    [
        0,
        "&vBar;"
    ],
    [
        0,
        "&vBarv;"
    ],
    [
        1,
        "&Vbar;"
    ],
    [
        0,
        "&Not;"
    ],
    [
        0,
        "&bNot;"
    ],
    [
        0,
        "&rnmid;"
    ],
    [
        0,
        "&cirmid;"
    ],
    [
        0,
        "&midcir;"
    ],
    [
        0,
        "&topcir;"
    ],
    [
        0,
        "&nhpar;"
    ],
    [
        0,
        "&parsim;"
    ],
    [
        9,
        {
            v: "&parsl;",
            n: 8421,
            o: "&nparsl;"
        }
    ],
    [
        44343,
        {
            n: new Map(/* #__PURE__ */ $98887e1d0958bc17$var$restoreDiff([
                [
                    56476,
                    "&Ascr;"
                ],
                [
                    1,
                    "&Cscr;"
                ],
                [
                    0,
                    "&Dscr;"
                ],
                [
                    2,
                    "&Gscr;"
                ],
                [
                    2,
                    "&Jscr;"
                ],
                [
                    0,
                    "&Kscr;"
                ],
                [
                    2,
                    "&Nscr;"
                ],
                [
                    0,
                    "&Oscr;"
                ],
                [
                    0,
                    "&Pscr;"
                ],
                [
                    0,
                    "&Qscr;"
                ],
                [
                    1,
                    "&Sscr;"
                ],
                [
                    0,
                    "&Tscr;"
                ],
                [
                    0,
                    "&Uscr;"
                ],
                [
                    0,
                    "&Vscr;"
                ],
                [
                    0,
                    "&Wscr;"
                ],
                [
                    0,
                    "&Xscr;"
                ],
                [
                    0,
                    "&Yscr;"
                ],
                [
                    0,
                    "&Zscr;"
                ],
                [
                    0,
                    "&ascr;"
                ],
                [
                    0,
                    "&bscr;"
                ],
                [
                    0,
                    "&cscr;"
                ],
                [
                    0,
                    "&dscr;"
                ],
                [
                    1,
                    "&fscr;"
                ],
                [
                    1,
                    "&hscr;"
                ],
                [
                    0,
                    "&iscr;"
                ],
                [
                    0,
                    "&jscr;"
                ],
                [
                    0,
                    "&kscr;"
                ],
                [
                    0,
                    "&lscr;"
                ],
                [
                    0,
                    "&mscr;"
                ],
                [
                    0,
                    "&nscr;"
                ],
                [
                    1,
                    "&pscr;"
                ],
                [
                    0,
                    "&qscr;"
                ],
                [
                    0,
                    "&rscr;"
                ],
                [
                    0,
                    "&sscr;"
                ],
                [
                    0,
                    "&tscr;"
                ],
                [
                    0,
                    "&uscr;"
                ],
                [
                    0,
                    "&vscr;"
                ],
                [
                    0,
                    "&wscr;"
                ],
                [
                    0,
                    "&xscr;"
                ],
                [
                    0,
                    "&yscr;"
                ],
                [
                    0,
                    "&zscr;"
                ],
                [
                    52,
                    "&Afr;"
                ],
                [
                    0,
                    "&Bfr;"
                ],
                [
                    1,
                    "&Dfr;"
                ],
                [
                    0,
                    "&Efr;"
                ],
                [
                    0,
                    "&Ffr;"
                ],
                [
                    0,
                    "&Gfr;"
                ],
                [
                    2,
                    "&Jfr;"
                ],
                [
                    0,
                    "&Kfr;"
                ],
                [
                    0,
                    "&Lfr;"
                ],
                [
                    0,
                    "&Mfr;"
                ],
                [
                    0,
                    "&Nfr;"
                ],
                [
                    0,
                    "&Ofr;"
                ],
                [
                    0,
                    "&Pfr;"
                ],
                [
                    0,
                    "&Qfr;"
                ],
                [
                    1,
                    "&Sfr;"
                ],
                [
                    0,
                    "&Tfr;"
                ],
                [
                    0,
                    "&Ufr;"
                ],
                [
                    0,
                    "&Vfr;"
                ],
                [
                    0,
                    "&Wfr;"
                ],
                [
                    0,
                    "&Xfr;"
                ],
                [
                    0,
                    "&Yfr;"
                ],
                [
                    1,
                    "&afr;"
                ],
                [
                    0,
                    "&bfr;"
                ],
                [
                    0,
                    "&cfr;"
                ],
                [
                    0,
                    "&dfr;"
                ],
                [
                    0,
                    "&efr;"
                ],
                [
                    0,
                    "&ffr;"
                ],
                [
                    0,
                    "&gfr;"
                ],
                [
                    0,
                    "&hfr;"
                ],
                [
                    0,
                    "&ifr;"
                ],
                [
                    0,
                    "&jfr;"
                ],
                [
                    0,
                    "&kfr;"
                ],
                [
                    0,
                    "&lfr;"
                ],
                [
                    0,
                    "&mfr;"
                ],
                [
                    0,
                    "&nfr;"
                ],
                [
                    0,
                    "&ofr;"
                ],
                [
                    0,
                    "&pfr;"
                ],
                [
                    0,
                    "&qfr;"
                ],
                [
                    0,
                    "&rfr;"
                ],
                [
                    0,
                    "&sfr;"
                ],
                [
                    0,
                    "&tfr;"
                ],
                [
                    0,
                    "&ufr;"
                ],
                [
                    0,
                    "&vfr;"
                ],
                [
                    0,
                    "&wfr;"
                ],
                [
                    0,
                    "&xfr;"
                ],
                [
                    0,
                    "&yfr;"
                ],
                [
                    0,
                    "&zfr;"
                ],
                [
                    0,
                    "&Aopf;"
                ],
                [
                    0,
                    "&Bopf;"
                ],
                [
                    1,
                    "&Dopf;"
                ],
                [
                    0,
                    "&Eopf;"
                ],
                [
                    0,
                    "&Fopf;"
                ],
                [
                    0,
                    "&Gopf;"
                ],
                [
                    1,
                    "&Iopf;"
                ],
                [
                    0,
                    "&Jopf;"
                ],
                [
                    0,
                    "&Kopf;"
                ],
                [
                    0,
                    "&Lopf;"
                ],
                [
                    0,
                    "&Mopf;"
                ],
                [
                    1,
                    "&Oopf;"
                ],
                [
                    3,
                    "&Sopf;"
                ],
                [
                    0,
                    "&Topf;"
                ],
                [
                    0,
                    "&Uopf;"
                ],
                [
                    0,
                    "&Vopf;"
                ],
                [
                    0,
                    "&Wopf;"
                ],
                [
                    0,
                    "&Xopf;"
                ],
                [
                    0,
                    "&Yopf;"
                ],
                [
                    1,
                    "&aopf;"
                ],
                [
                    0,
                    "&bopf;"
                ],
                [
                    0,
                    "&copf;"
                ],
                [
                    0,
                    "&dopf;"
                ],
                [
                    0,
                    "&eopf;"
                ],
                [
                    0,
                    "&fopf;"
                ],
                [
                    0,
                    "&gopf;"
                ],
                [
                    0,
                    "&hopf;"
                ],
                [
                    0,
                    "&iopf;"
                ],
                [
                    0,
                    "&jopf;"
                ],
                [
                    0,
                    "&kopf;"
                ],
                [
                    0,
                    "&lopf;"
                ],
                [
                    0,
                    "&mopf;"
                ],
                [
                    0,
                    "&nopf;"
                ],
                [
                    0,
                    "&oopf;"
                ],
                [
                    0,
                    "&popf;"
                ],
                [
                    0,
                    "&qopf;"
                ],
                [
                    0,
                    "&ropf;"
                ],
                [
                    0,
                    "&sopf;"
                ],
                [
                    0,
                    "&topf;"
                ],
                [
                    0,
                    "&uopf;"
                ],
                [
                    0,
                    "&vopf;"
                ],
                [
                    0,
                    "&wopf;"
                ],
                [
                    0,
                    "&xopf;"
                ],
                [
                    0,
                    "&yopf;"
                ],
                [
                    0,
                    "&zopf;"
                ]
            ]))
        }
    ],
    [
        8906,
        "&fflig;"
    ],
    [
        0,
        "&filig;"
    ],
    [
        0,
        "&fllig;"
    ],
    [
        0,
        "&ffilig;"
    ],
    [
        0,
        "&ffllig;"
    ]
]));

});

parcelRegister("fZVPj", function(module, exports) {

$parcel$export(module.exports, "xmlReplacer", function () { return $ba5968b114559a7d$export$5699810ce3244ab8; });
$parcel$export(module.exports, "getCodePoint", function () { return $ba5968b114559a7d$export$e02688b8085d016b; });
$parcel$export(module.exports, "encodeXML", function () { return $ba5968b114559a7d$export$18855ec5be97da16; });
$parcel$export(module.exports, "escapeUTF8", function () { return $ba5968b114559a7d$export$9e081872deefdcb0; });
$parcel$export(module.exports, "escapeAttribute", function () { return $ba5968b114559a7d$export$30330f3d5eb70e11; });
$parcel$export(module.exports, "escapeText", function () { return $ba5968b114559a7d$export$96e6fc3a139b2555; });
const $ba5968b114559a7d$export$5699810ce3244ab8 = /["&'<>$\x80-\uFFFF]/g;
const $ba5968b114559a7d$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
const $ba5968b114559a7d$export$e02688b8085d016b = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? (str, index)=>str.codePointAt(index) : (c, index)=>(c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
function $ba5968b114559a7d$export$18855ec5be97da16(str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = $ba5968b114559a7d$export$5699810ce3244ab8.exec(str)) !== null){
        const i = match.index;
        const char = str.charCodeAt(i);
        const next = $ba5968b114559a7d$var$xmlCodeMap.get(char);
        if (next !== undefined) {
            ret += str.substring(lastIdx, i) + next;
            lastIdx = i + 1;
        } else {
            ret += `${str.substring(lastIdx, i)}&#x${$ba5968b114559a7d$export$e02688b8085d016b(str, i).toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = $ba5968b114559a7d$export$5699810ce3244ab8.lastIndex += Number((char & 0xfc00) === 0xd800);
        }
    }
    return ret + str.substr(lastIdx);
}
const $ba5968b114559a7d$export$4e7f196112fea3c5 = $ba5968b114559a7d$export$18855ec5be97da16;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $ba5968b114559a7d$var$getEscaper(regex, map) {
    return function escape(data) {
        let match;
        let lastIdx = 0;
        let result = "";
        while(match = regex.exec(data)){
            if (lastIdx !== match.index) result += data.substring(lastIdx, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIdx = match.index + 1;
        }
        return result + data.substring(lastIdx);
    };
}
const $ba5968b114559a7d$export$9e081872deefdcb0 = $ba5968b114559a7d$var$getEscaper(/[&<>'"]/g, $ba5968b114559a7d$var$xmlCodeMap);
const $ba5968b114559a7d$export$30330f3d5eb70e11 = $ba5968b114559a7d$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
const $ba5968b114559a7d$export$96e6fc3a139b2555 = $ba5968b114559a7d$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));

});




parcelRegister("cObR7", function(module, exports) {

$parcel$export(module.exports, "parseLinkLabel", function () { return (parcelRequire("4z2gu")).default; });
$parcel$export(module.exports, "parseLinkDestination", function () { return (parcelRequire("3FUzi")).default; });
$parcel$export(module.exports, "parseLinkTitle", function () { return (parcelRequire("gWCBT")).default; });
// Just a shortcut for bulk export

var $4z2gu = parcelRequire("4z2gu");

var $3FUzi = parcelRequire("3FUzi");

var $gWCBT = parcelRequire("gWCBT");

});
parcelRegister("4z2gu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85a893e42186acff$export$2e2bcd8739ae039; });
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
function $85a893e42186acff$export$2e2bcd8739ae039(state, start, disableNested) {
    let level, found, marker, prevPos;
    const max = state.posMax;
    const oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    let labelEnd = -1;
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
}

});

parcelRegister("3FUzi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $897e9f20d5758c89$export$2e2bcd8739ae039; });
// Parse link destination
//

var $gy0A9 = parcelRequire("gy0A9");
function $897e9f20d5758c89$export$2e2bcd8739ae039(str, start, max) {
    let code;
    let pos = start;
    const result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ""
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = (0, $gy0A9.unescapeAll)(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    let level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = (0, $gy0A9.unescapeAll)(str.slice(start, pos));
    result.pos = pos;
    result.ok = true;
    return result;
}

});

parcelRegister("gWCBT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b4e36ac357e4291$export$2e2bcd8739ae039; });
// Parse link title
//

var $gy0A9 = parcelRequire("gy0A9");
function $5b4e36ac357e4291$export$2e2bcd8739ae039(str, start, max) {
    let code, marker;
    let lines = 0;
    let pos = start;
    const result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ""
    };
    if (pos >= max) return result;
    marker = str.charCodeAt(pos);
    if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return result;
    pos++;
    // if opening marker is "(", switch it to closing marker ")"
    if (marker === 0x28) marker = 0x29;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === marker) {
            result.pos = pos + 1;
            result.lines = lines;
            result.str = (0, $gy0A9.unescapeAll)(str.slice(start + 1, pos));
            result.ok = true;
            return result;
        } else if (code === 0x28 /* ( */  && marker === 0x29 /* ) */ ) return result;
        else if (code === 0x0A) lines++;
        else if (code === 0x5C /* \ */  && pos + 1 < max) {
            pos++;
            if (str.charCodeAt(pos) === 0x0A) lines++;
        }
        pos++;
    }
    return result;
}

});


parcelRegister("5EvFi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7ac9819350ed96d$export$2e2bcd8739ae039; });
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ 
var $gy0A9 = parcelRequire("gy0A9");
const $f7ac9819350ed96d$var$default_rules = {};
$f7ac9819350ed96d$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    return "<code" + slf.renderAttrs(token) + ">" + (0, $gy0A9.escapeHtml)(token.content) + "</code>";
};
$f7ac9819350ed96d$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    return "<pre" + slf.renderAttrs(token) + "><code>" + (0, $gy0A9.escapeHtml)(tokens[idx].content) + "</code></pre>\n";
};
$f7ac9819350ed96d$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    const info = token.info ? (0, $gy0A9.unescapeAll)(token.info).trim() : "";
    let langName = "";
    let langAttrs = "";
    if (info) {
        const arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join("");
    }
    let highlighted;
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || (0, $gy0A9.escapeHtml)(token.content);
    else highlighted = (0, $gy0A9.escapeHtml)(token.content);
    if (highlighted.indexOf("<pre") === 0) return highlighted + "\n";
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        const i = token.attrIndex("class");
        const tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            "class",
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += " " + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        const tmpToken = {
            attrs: tmpAttrs
        };
        return `<pre><code${slf.renderAttrs(tmpToken)}>${highlighted}</code></pre>\n`;
    }
    return `<pre><code${slf.renderAttrs(token)}>${highlighted}</code></pre>\n`;
};
$f7ac9819350ed96d$var$default_rules.image = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex("alt")][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$f7ac9819350ed96d$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? "<br />\n" : "<br>\n";
};
$f7ac9819350ed96d$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? "<br />\n" : "<br>\n" : "\n";
};
$f7ac9819350ed96d$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return (0, $gy0A9.escapeHtml)(tokens[idx].content);
};
$f7ac9819350ed96d$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$f7ac9819350ed96d$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $f7ac9819350ed96d$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js)
   * for more details and examples.
   **/ this.rules = (0, $gy0A9.assign)({}, $f7ac9819350ed96d$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $f7ac9819350ed96d$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    let i, l, result;
    if (!token.attrs) return "";
    result = "";
    for(i = 0, l = token.attrs.length; i < l; i++)result += " " + (0, $gy0A9.escapeHtml)(token.attrs[i][0]) + '="' + (0, $gy0A9.escapeHtml)(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $f7ac9819350ed96d$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    const token = tokens[idx];
    let result = "";
    // Tight list paragraphs
    if (token.hidden) return "";
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += "\n";
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? "</" : "<") + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += " /";
    // Check if we need to add a newline after this tag
    let needLf = false;
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                const nextToken = tokens[idx + 1];
                if (nextToken.type === "inline" || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? ">\n" : ">";
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $f7ac9819350ed96d$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    let result = "";
    const rules = this.rules;
    for(let i = 0, len = tokens.length; i < len; i++){
        const type = tokens[i].type;
        if (typeof rules[type] !== "undefined") result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $f7ac9819350ed96d$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    let result = "";
    for(let i = 0, len = tokens.length; i < len; i++)switch(tokens[i].type){
        case "text":
            result += tokens[i].content;
            break;
        case "image":
            result += this.renderInlineAsText(tokens[i].children, options, env);
            break;
        case "html_inline":
        case "html_block":
            result += tokens[i].content;
            break;
        case "softbreak":
        case "hardbreak":
            result += "\n";
            break;
        default:
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $f7ac9819350ed96d$var$Renderer.prototype.render = function(tokens, options, env) {
    let result = "";
    const rules = this.rules;
    for(let i = 0, len = tokens.length; i < len; i++){
        const type = tokens[i].type;
        if (type === "inline") result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== "undefined") result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
var $f7ac9819350ed96d$export$2e2bcd8739ae039 = $f7ac9819350ed96d$var$Renderer;

});

parcelRegister("jpxpn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9462b9753493cd5$export$2e2bcd8739ae039; });
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ 
var $byqSe = parcelRequire("byqSe");

var $eQ58f = parcelRequire("eQ58f");

var $6Jcy0 = parcelRequire("6Jcy0");

var $es6jP = parcelRequire("es6jP");

var $7w74C = parcelRequire("7w74C");

var $1f2ia = parcelRequire("1f2ia");

var $1ZaNq = parcelRequire("1ZaNq");

var $1zZiq = parcelRequire("1zZiq");

var $jiX4K = parcelRequire("jiX4K");
const $c9462b9753493cd5$var$_rules = [
    [
        "normalize",
        (0, $6Jcy0.default)
    ],
    [
        "block",
        (0, $es6jP.default)
    ],
    [
        "inline",
        (0, $7w74C.default)
    ],
    [
        "linkify",
        (0, $1f2ia.default)
    ],
    [
        "replacements",
        (0, $1ZaNq.default)
    ],
    [
        "smartquotes",
        (0, $1zZiq.default)
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        "text_join",
        (0, $jiX4K.default)
    ]
];
/**
 * new Core()
 **/ function $c9462b9753493cd5$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new (0, $byqSe.default)();
    for(let i = 0; i < $c9462b9753493cd5$var$_rules.length; i++)this.ruler.push($c9462b9753493cd5$var$_rules[i][0], $c9462b9753493cd5$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $c9462b9753493cd5$var$Core.prototype.process = function(state) {
    const rules = this.ruler.getRules("");
    for(let i = 0, l = rules.length; i < l; i++)rules[i](state);
};
$c9462b9753493cd5$var$Core.prototype.State = (0, $eQ58f.default);
var $c9462b9753493cd5$export$2e2bcd8739ae039 = $c9462b9753493cd5$var$Core;

});
parcelRegister("byqSe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7ebda45defc5b3a$export$2e2bcd8739ae039; });
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ /**
 * new Ruler()
 **/ function $d7ebda45defc5b3a$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
// Helper methods, should not be used directly
// Find rule index by name
//
$d7ebda45defc5b3a$var$Ruler.prototype.__find__ = function(name) {
    for(let i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$d7ebda45defc5b3a$var$Ruler.prototype.__compile__ = function() {
    const self = this;
    const chains = [
        ""
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $d7ebda45defc5b3a$var$Ruler.prototype.at = function(name, fn, options) {
    const index = this.__find__(name);
    const opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $d7ebda45defc5b3a$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    const index = this.__find__(beforeName);
    const opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $d7ebda45defc5b3a$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    const index = this.__find__(afterName);
    const opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $d7ebda45defc5b3a$var$Ruler.prototype.push = function(ruleName, fn, options) {
    const opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $d7ebda45defc5b3a$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    const result = [];
    // Search by name and enable
    list.forEach(function(name) {
        const idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error("Rules manager: invalid rule name " + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $d7ebda45defc5b3a$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $d7ebda45defc5b3a$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    const result = [];
    // Search by name and disable
    list.forEach(function(name) {
        const idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error("Rules manager: invalid rule name " + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $d7ebda45defc5b3a$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
var $d7ebda45defc5b3a$export$2e2bcd8739ae039 = $d7ebda45defc5b3a$var$Ruler;

});

parcelRegister("eQ58f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c29e438853dbe16a$export$2e2bcd8739ae039; });
// Core state object
//

var $69xzQ = parcelRequire("69xzQ");
function $c29e438853dbe16a$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md // link to parser instance
    ;
}
// re-export Token class to use in core rules
$c29e438853dbe16a$var$StateCore.prototype.Token = (0, $69xzQ.default);
var $c29e438853dbe16a$export$2e2bcd8739ae039 = $c29e438853dbe16a$var$StateCore;

});
parcelRegister("69xzQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $145731ac600e4fc9$export$2e2bcd8739ae039; });
// Token class
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $145731ac600e4fc9$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = "";
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = "";
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = "";
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $145731ac600e4fc9$var$Token.prototype.attrIndex = function attrIndex(name) {
    if (!this.attrs) return -1;
    const attrs = this.attrs;
    for(let i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $145731ac600e4fc9$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $145731ac600e4fc9$var$Token.prototype.attrSet = function attrSet(name, value) {
    const idx = this.attrIndex(name);
    const attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $145731ac600e4fc9$var$Token.prototype.attrGet = function attrGet(name) {
    const idx = this.attrIndex(name);
    let value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $145731ac600e4fc9$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    const idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + " " + value;
};
var $145731ac600e4fc9$export$2e2bcd8739ae039 = $145731ac600e4fc9$var$Token;

});


parcelRegister("6Jcy0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6dbd298e494b12cd$export$2e2bcd8739ae039; });
// Normalize input string
// https://spec.commonmark.org/0.29/#line-ending
const $6dbd298e494b12cd$var$NEWLINES_RE = /\r\n?|\n/g;
const $6dbd298e494b12cd$var$NULL_RE = /\0/g;
function $6dbd298e494b12cd$export$2e2bcd8739ae039(state) {
    let str;
    // Normalize newlines
    str = state.src.replace($6dbd298e494b12cd$var$NEWLINES_RE, "\n");
    // Replace NULL characters
    str = str.replace($6dbd298e494b12cd$var$NULL_RE, "\uFFFD");
    state.src = str;
}

});

parcelRegister("es6jP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c7c55930e9559d2$export$2e2bcd8739ae039; });
function $8c7c55930e9559d2$export$2e2bcd8739ae039(state) {
    let token;
    if (state.inlineMode) {
        token = new state.Token("inline", "", 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
}

});

parcelRegister("7w74C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a82fa950223cfc8e$export$2e2bcd8739ae039; });
function $a82fa950223cfc8e$export$2e2bcd8739ae039(state) {
    const tokens = state.tokens;
    // Parse inlines
    for(let i = 0, l = tokens.length; i < l; i++){
        const tok = tokens[i];
        if (tok.type === "inline") state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
}

});

parcelRegister("1f2ia", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $286b9a170fcdf988$export$2e2bcd8739ae039; });
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//

var $gy0A9 = parcelRequire("gy0A9");
function $286b9a170fcdf988$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $286b9a170fcdf988$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $286b9a170fcdf988$export$2e2bcd8739ae039(state) {
    const blockTokens = state.tokens;
    if (!state.md.options.linkify) return;
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== "inline" || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === "link_close") {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== "link_open")i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === "html_inline") {
                if ($286b9a170fcdf988$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($286b9a170fcdf988$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === "text" && state.md.linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = state.md.linkify.match(text);
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === "text_special") links = links.slice(1);
                for(let ln = 0; ln < links.length; ln++){
                    const url = links[ln].url;
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText("http://" + urlText).replace(/^http:\/\//, "");
                    else if (links[ln].schema === "mailto:" && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText("mailto:" + urlText).replace(/^mailto:/, "");
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token("text", "", 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    const token_o = new state.Token("link_open", "a", 1);
                    token_o.attrs = [
                        [
                            "href",
                            fullUrl
                        ]
                    ];
                    token_o.level = level++;
                    token_o.markup = "linkify";
                    token_o.info = "auto";
                    nodes.push(token_o);
                    const token_t = new state.Token("text", "", 0);
                    token_t.content = urlText;
                    token_t.level = level;
                    nodes.push(token_t);
                    const token_c = new state.Token("link_close", "a", -1);
                    token_c.level = --level;
                    token_c.markup = "linkify";
                    token_c.info = "auto";
                    nodes.push(token_c);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token("text", "", 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = (0, $gy0A9.arrayReplaceAt)(tokens, i, nodes);
            }
        }
    }
}

});

parcelRegister("1ZaNq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10ace7fff2e0dccb$export$2e2bcd8739ae039; });
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
const $10ace7fff2e0dccb$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
const $10ace7fff2e0dccb$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
const $10ace7fff2e0dccb$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
const $10ace7fff2e0dccb$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $10ace7fff2e0dccb$var$replaceFn(match, name) {
    return $10ace7fff2e0dccb$var$SCOPED_ABBR[name.toLowerCase()];
}
function $10ace7fff2e0dccb$var$replace_scoped(inlineTokens) {
    let inside_autolink = 0;
    for(let i = inlineTokens.length - 1; i >= 0; i--){
        const token = inlineTokens[i];
        if (token.type === "text" && !inside_autolink) token.content = token.content.replace($10ace7fff2e0dccb$var$SCOPED_ABBR_RE, $10ace7fff2e0dccb$var$replaceFn);
        if (token.type === "link_open" && token.info === "auto") inside_autolink--;
        if (token.type === "link_close" && token.info === "auto") inside_autolink++;
    }
}
function $10ace7fff2e0dccb$var$replace_rare(inlineTokens) {
    let inside_autolink = 0;
    for(let i = inlineTokens.length - 1; i >= 0; i--){
        const token = inlineTokens[i];
        if (token.type === "text" && !inside_autolink) {
            if ($10ace7fff2e0dccb$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",")// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, "$1\u2014")// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, "$1\u2013").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1\u2013");
        }
        if (token.type === "link_open" && token.info === "auto") inside_autolink--;
        if (token.type === "link_close" && token.info === "auto") inside_autolink++;
    }
}
function $10ace7fff2e0dccb$export$2e2bcd8739ae039(state) {
    let blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== "inline") continue;
        if ($10ace7fff2e0dccb$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $10ace7fff2e0dccb$var$replace_scoped(state.tokens[blkIdx].children);
        if ($10ace7fff2e0dccb$var$RARE_RE.test(state.tokens[blkIdx].content)) $10ace7fff2e0dccb$var$replace_rare(state.tokens[blkIdx].children);
    }
}

});

parcelRegister("1zZiq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec0538a58c50b6b6$export$2e2bcd8739ae039; });
// Convert straight quotation marks to typographic ones
//

var $gy0A9 = parcelRequire("gy0A9");
const $ec0538a58c50b6b6$var$QUOTE_TEST_RE = /['"]/;
const $ec0538a58c50b6b6$var$QUOTE_RE = /['"]/g;
const $ec0538a58c50b6b6$var$APOSTROPHE = "\u2019" /* ’ */ ;
function $ec0538a58c50b6b6$var$replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function $ec0538a58c50b6b6$var$process_inlines(tokens, state) {
    let j;
    const stack = [];
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        const thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== "text") continue;
        let text = token.content;
        let pos = 0;
        let max = text.length;
        /* eslint no-labels:0,block-scoped-var:0 */ OUTER: while(pos < max){
            $ec0538a58c50b6b6$var$QUOTE_RE.lastIndex = pos;
            const t = $ec0538a58c50b6b6$var$QUOTE_RE.exec(text);
            if (!t) break;
            let canOpen = true;
            let canClose = true;
            pos = t.index + 1;
            const isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            let lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === "softbreak" || tokens[j].type === "hardbreak") break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            let nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === "softbreak" || tokens[j].type === "hardbreak") break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            const isLastPunctChar = (0, $gy0A9.isMdAsciiPunct)(lastChar) || (0, $gy0A9.isPunctChar)(String.fromCharCode(lastChar));
            const isNextPunctChar = (0, $gy0A9.isMdAsciiPunct)(nextChar) || (0, $gy0A9.isPunctChar)(String.fromCharCode(nextChar));
            const isLastWhiteSpace = (0, $gy0A9.isWhiteSpace)(lastChar);
            const isNextWhiteSpace = (0, $gy0A9.isWhiteSpace)(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $ec0538a58c50b6b6$var$replaceAt(token.content, t.index, $ec0538a58c50b6b6$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                let item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    let openQuote;
                    let closeQuote;
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $ec0538a58c50b6b6$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $ec0538a58c50b6b6$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $ec0538a58c50b6b6$var$replaceAt(token.content, t.index, $ec0538a58c50b6b6$var$APOSTROPHE);
        }
    }
}
function $ec0538a58c50b6b6$export$2e2bcd8739ae039(state) {
    /* eslint max-depth:0 */ if (!state.md.options.typographer) return;
    for(let blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== "inline" || !$ec0538a58c50b6b6$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $ec0538a58c50b6b6$var$process_inlines(state.tokens[blkIdx].children, state);
    }
}

});

parcelRegister("jiX4K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $606e8ea698215c7a$export$2e2bcd8739ae039; });
// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
function $606e8ea698215c7a$export$2e2bcd8739ae039(state) {
    let curr, last;
    const blockTokens = state.tokens;
    const l = blockTokens.length;
    for(let j = 0; j < l; j++){
        if (blockTokens[j].type !== "inline") continue;
        const tokens = blockTokens[j].children;
        const max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === "text_special") tokens[curr].type = "text";
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === "text" && curr + 1 < max && tokens[curr + 1].type === "text") // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
}

});


parcelRegister("79wvp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $101f04ae81e5bb08$export$2e2bcd8739ae039; });
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ 
var $byqSe = parcelRequire("byqSe");

var $eih09 = parcelRequire("eih09");

var $3yJle = parcelRequire("3yJle");

var $hxB6Z = parcelRequire("hxB6Z");

var $aWAtj = parcelRequire("aWAtj");

var $buzrS = parcelRequire("buzrS");

var $kVG72 = parcelRequire("kVG72");

var $aCOfr = parcelRequire("aCOfr");

var $fDFiP = parcelRequire("fDFiP");

var $6prZ4 = parcelRequire("6prZ4");

var $dj3bZ = parcelRequire("dj3bZ");

var $5b6cY = parcelRequire("5b6cY");

var $aoxss = parcelRequire("aoxss");
const $101f04ae81e5bb08$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        "table",
        (0, $3yJle.default),
        [
            "paragraph",
            "reference"
        ]
    ],
    [
        "code",
        (0, $hxB6Z.default)
    ],
    [
        "fence",
        (0, $aWAtj.default),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "blockquote",
        (0, $buzrS.default),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "hr",
        (0, $kVG72.default),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "list",
        (0, $aCOfr.default),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "reference",
        (0, $fDFiP.default)
    ],
    [
        "html_block",
        (0, $6prZ4.default),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "heading",
        (0, $dj3bZ.default),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "lheading",
        (0, $5b6cY.default)
    ],
    [
        "paragraph",
        (0, $aoxss.default)
    ]
];
/**
 * new ParserBlock()
 **/ function $101f04ae81e5bb08$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new (0, $byqSe.default)();
    for(let i = 0; i < $101f04ae81e5bb08$var$_rules.length; i++)this.ruler.push($101f04ae81e5bb08$var$_rules[i][0], $101f04ae81e5bb08$var$_rules[i][1], {
        alt: ($101f04ae81e5bb08$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$101f04ae81e5bb08$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    const rules = this.ruler.getRules("");
    const len = rules.length;
    const maxNesting = state.md.options.maxNesting;
    let line = startLine;
    let hasEmptyLines = false;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        const prevLine = state.line;
        let ok = false;
        for(let i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) {
                if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                break;
            }
        }
        // this can only happen if user disables paragraph rule
        if (!ok) throw new Error("none of the block rules matched");
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $101f04ae81e5bb08$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    if (!src) return;
    const state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};
$101f04ae81e5bb08$var$ParserBlock.prototype.State = (0, $eih09.default);
var $101f04ae81e5bb08$export$2e2bcd8739ae039 = $101f04ae81e5bb08$var$ParserBlock;

});
parcelRegister("eih09", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73133c591076991f$export$2e2bcd8739ae039; });
// Parser state class

var $69xzQ = parcelRequire("69xzQ");

var $gy0A9 = parcelRequire("gy0A9");
function $73133c591076991f$var$StateBlock(src, md, env, tokens) {
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = [] // line begin offsets for fast jumps
    ;
    this.eMarks = [] // line end offsets for fast jumps
    ;
    this.tShift = [] // offsets of the first non-space characters (tabs not expanded)
    ;
    this.sCount = [] // indents for each line (tabs expanded)
    ;
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.blkIndent = 0;
    this.line = 0 // line index in src
    ;
    this.lineMax = 0 // lines count
    ;
    this.tight = false // loose/tight mode for lists
    ;
    this.ddIndent = -1 // indent of the current dd block (-1 if there isn't any)
    ;
    this.listIndent = -1 // indent of the current list block (-1 if there isn't any)
    ;
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = "root";
    this.level = 0;
    // Create caches
    // Generate markers.
    const s = this.src;
    for(let start = 0, pos = 0, indent = 0, offset = 0, len = s.length, indent_found = false; pos < len; pos++){
        const ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ((0, $gy0A9.isSpace)(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1 // don't count last fake line
    ;
}
// Push new token to "stream".
//
$73133c591076991f$var$StateBlock.prototype.push = function(type, tag, nesting) {
    const token = new (0, $69xzQ.default)(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level-- // closing tag
    ;
    token.level = this.level;
    if (nesting > 0) this.level++ // opening tag
    ;
    this.tokens.push(token);
    return token;
};
$73133c591076991f$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$73133c591076991f$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(let max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$73133c591076991f$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    for(let max = this.src.length; pos < max; pos++){
        const ch = this.src.charCodeAt(pos);
        if (!(0, $gy0A9.isSpace)(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$73133c591076991f$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!(0, $gy0A9.isSpace)(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$73133c591076991f$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(let max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$73133c591076991f$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$73133c591076991f$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    if (begin >= end) return "";
    const queue = new Array(end - begin);
    for(let i = 0, line = begin; line < end; line++, i++){
        let lineIndent = 0;
        const lineStart = this.bMarks[line];
        let first = lineStart;
        let last;
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            const ch = this.src.charCodeAt(first);
            if ((0, $gy0A9.isSpace)(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(" ") + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join("");
};
// re-export Token class to use in block rules
$73133c591076991f$var$StateBlock.prototype.Token = (0, $69xzQ.default);
var $73133c591076991f$export$2e2bcd8739ae039 = $73133c591076991f$var$StateBlock;

});

parcelRegister("3yJle", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a556d61578eb3e2$export$2e2bcd8739ae039; });
// GFM table, https://github.github.com/gfm/#tables-extension-

var $gy0A9 = parcelRequire("gy0A9");
function $9a556d61578eb3e2$var$getLine(state, line) {
    const pos = state.bMarks[line] + state.tShift[line];
    const max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $9a556d61578eb3e2$var$escapedSplit(str) {
    const result = [];
    const max = str.length;
    let pos = 0;
    let ch = str.charCodeAt(pos);
    let isEscaped = false;
    let lastPos = 0;
    let current = "";
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = "";
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
function $9a556d61578eb3e2$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    let nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    let pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    const firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    const secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !(0, $gy0A9.isSpace)(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && (0, $gy0A9.isSpace)(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        const ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !(0, $gy0A9.isSpace)(ch)) return false;
        pos++;
    }
    let lineText = $9a556d61578eb3e2$var$getLine(state, startLine + 1);
    let columns = lineText.split("|");
    const aligns = [];
    for(let i = 0; i < columns.length; i++){
        const t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? "center" : "right");
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push("left");
        else aligns.push("");
    }
    lineText = $9a556d61578eb3e2$var$getLine(state, startLine).trim();
    if (lineText.indexOf("|") === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $9a556d61578eb3e2$var$escapedSplit(lineText);
    if (columns.length && columns[0] === "") columns.shift();
    if (columns.length && columns[columns.length - 1] === "") columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    const columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    const oldParentType = state.parentType;
    state.parentType = "table";
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    const terminatorRules = state.md.block.ruler.getRules("blockquote");
    const token_to = state.push("table_open", "table", 1);
    const tableLines = [
        startLine,
        0
    ];
    token_to.map = tableLines;
    const token_tho = state.push("thead_open", "thead", 1);
    token_tho.map = [
        startLine,
        startLine + 1
    ];
    const token_htro = state.push("tr_open", "tr", 1);
    token_htro.map = [
        startLine,
        startLine + 1
    ];
    for(let i = 0; i < columns.length; i++){
        const token_ho = state.push("th_open", "th", 1);
        if (aligns[i]) token_ho.attrs = [
            [
                "style",
                "text-align:" + aligns[i]
            ]
        ];
        const token_il = state.push("inline", "", 0);
        token_il.content = columns[i].trim();
        token_il.children = [];
        state.push("th_close", "th", -1);
    }
    state.push("tr_close", "tr", -1);
    state.push("thead_close", "thead", -1);
    let tbodyLines;
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $9a556d61578eb3e2$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $9a556d61578eb3e2$var$escapedSplit(lineText);
        if (columns.length && columns[0] === "") columns.shift();
        if (columns.length && columns[columns.length - 1] === "") columns.pop();
        if (nextLine === startLine + 2) {
            const token_tbo = state.push("tbody_open", "tbody", 1);
            token_tbo.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        const token_tro = state.push("tr_open", "tr", 1);
        token_tro.map = [
            nextLine,
            nextLine + 1
        ];
        for(let i = 0; i < columnCount; i++){
            const token_tdo = state.push("td_open", "td", 1);
            if (aligns[i]) token_tdo.attrs = [
                [
                    "style",
                    "text-align:" + aligns[i]
                ]
            ];
            const token_il = state.push("inline", "", 0);
            token_il.content = columns[i] ? columns[i].trim() : "";
            token_il.children = [];
            state.push("td_close", "td", -1);
        }
        state.push("tr_close", "tr", -1);
    }
    if (tbodyLines) {
        state.push("tbody_close", "tbody", -1);
        tbodyLines[1] = nextLine;
    }
    state.push("table_close", "table", -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
}

});

parcelRegister("hxB6Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52c0dc7c73e93c02$export$2e2bcd8739ae039; });
// Code block (4 spaces padded)
function $52c0dc7c73e93c02$export$2e2bcd8739ae039(state, startLine, endLine /*, silent */ ) {
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    let nextLine = startLine + 1;
    let last = nextLine;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    const token = state.push("code_block", "code", 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + "\n";
    token.map = [
        startLine,
        state.line
    ];
    return true;
}

});

parcelRegister("aWAtj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8eff661b3413971c$export$2e2bcd8739ae039; });
// fences (``` lang, ~~~ lang)
function $8eff661b3413971c$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    const marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    let mem = pos;
    pos = state.skipChars(pos, marker);
    let len = pos - mem;
    if (len < 3) return false;
    const markup = state.src.slice(mem, pos);
    const params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    let nextLine = startLine;
    let haveEndMarker = false;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    const token = state.push("fence", "code", 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
}

});

parcelRegister("buzrS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f311726a86fafae5$export$2e2bcd8739ae039; });
// Block quotes

var $gy0A9 = parcelRequire("gy0A9");
function $f311726a86fafae5$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    const oldLineMax = state.lineMax;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    const oldBMarks = [];
    const oldBSCount = [];
    const oldSCount = [];
    const oldTShift = [];
    const terminatorRules = state.md.block.ruler.getRules("blockquote");
    const oldParentType = state.parentType;
    state.parentType = "blockquote";
    let lastLineEmpty = false;
    let nextLine;
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        const isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            let initial = state.sCount[nextLine] + 1;
            let spaceAfterMarker;
            let adjustTab;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            let offset = initial;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                const ch = state.src.charCodeAt(pos);
                if ((0, $gy0A9.isSpace)(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    const oldIndent = state.blkIndent;
    state.blkIndent = 0;
    const token_o = state.push("blockquote_open", "blockquote", 1);
    token_o.markup = ">";
    const lines = [
        startLine,
        0
    ];
    token_o.map = lines;
    state.md.block.tokenize(state, startLine, nextLine);
    const token_c = state.push("blockquote_close", "blockquote", -1);
    token_c.markup = ">";
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(let i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
}

});

parcelRegister("kVG72", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b3b077be7e910c2$export$2e2bcd8739ae039; });
// Horizontal rule

var $gy0A9 = parcelRequire("gy0A9");
function $1b3b077be7e910c2$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    const max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    const marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    let cnt = 1;
    while(pos < max){
        const ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !(0, $gy0A9.isSpace)(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    const token = state.push("hr", "hr", 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
}

});

parcelRegister("aCOfr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42cc679d092380a2$export$2e2bcd8739ae039; });
// Lists

var $gy0A9 = parcelRequire("gy0A9");
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $42cc679d092380a2$var$skipBulletListMarker(state, startLine) {
    const max = state.eMarks[startLine];
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    const marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        const ch = state.src.charCodeAt(pos);
        if (!(0, $gy0A9.isSpace)(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $42cc679d092380a2$var$skipOrderedListMarker(state, startLine) {
    const start = state.bMarks[startLine] + state.tShift[startLine];
    const max = state.eMarks[startLine];
    let pos = start;
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    let ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!(0, $gy0A9.isSpace)(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $42cc679d092380a2$var$markTightParagraphs(state, idx) {
    const level = state.level + 2;
    for(let i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === "paragraph_open") {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
function $42cc679d092380a2$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let max, pos, start, token;
    let nextLine = startLine;
    let tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
    let isTerminatingParagraph = false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === "paragraph") // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    let isOrdered;
    let markerValue;
    let posAfterMarker;
    if ((posAfterMarker = $42cc679d092380a2$var$skipOrderedListMarker(state, nextLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[nextLine] + state.tShift[nextLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $42cc679d092380a2$var$skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
    }
    // For validation mode we can terminate immediately
    if (silent) return true;
    // We should terminate list on style change. Remember first one to compare.
    const markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // Start list
    const listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push("ordered_list_open", "ol", 1);
        if (markerValue !== 1) token.attrs = [
            [
                "start",
                markerValue
            ]
        ];
    } else token = state.push("bullet_list_open", "ul", 1);
    const listLines = [
        nextLine,
        0
    ];
    token.map = listLines;
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    let prevEmptyEnd = false;
    const terminatorRules = state.md.block.ruler.getRules("list");
    const oldParentType = state.parentType;
    state.parentType = "list";
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        const initial = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
        let offset = initial;
        while(pos < max){
            const ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        const contentStart = pos;
        let indentAfterMarker;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        const indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push("list_item_open", "li", 1);
        token.markup = String.fromCharCode(markerCharCode);
        const itemLines = [
            nextLine,
            0
        ];
        token.map = itemLines;
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        const oldTight = state.tight;
        const oldTShift = state.tShift[nextLine];
        const oldSCount = state.sCount[nextLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        const oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
        state.sCount[nextLine] = offset;
        if (contentStart >= max && state.isEmpty(nextLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, nextLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[nextLine] = oldTShift;
        state.sCount[nextLine] = oldSCount;
        state.tight = oldTight;
        token = state.push("list_item_close", "li", -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = state.line;
        itemLines[1] = nextLine;
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $42cc679d092380a2$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $42cc679d092380a2$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push("ordered_list_close", "ol", -1);
    else token = state.push("bullet_list_close", "ul", -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $42cc679d092380a2$var$markTightParagraphs(state, listTokIdx);
    return true;
}

});

parcelRegister("fDFiP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa183b222f396e2e$export$2e2bcd8739ae039; });

var $gy0A9 = parcelRequire("gy0A9");
function $aa183b222f396e2e$export$2e2bcd8739ae039(state, startLine, _endLine, silent) {
    let lines = 0;
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    let nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    // Simple check to quickly interrupt scan on [link](url) at the start of line.
    // Can be useful on practice: https://github.com/markdown-it/markdown-it/issues/54
    while(++pos < max)if (state.src.charCodeAt(pos) === 0x5D /* ] */  && state.src.charCodeAt(pos - 1) !== 0x5C /* \ */ ) {
        if (pos + 1 === max) return false;
        if (state.src.charCodeAt(pos + 1) !== 0x3A /* : */ ) return false;
        break;
    }
    const endLine = state.lineMax;
    // jump line-by-line until empty one or EOF
    const terminatorRules = state.md.block.ruler.getRules("reference");
    const oldParentType = state.parentType;
    state.parentType = "reference";
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    const str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    max = str.length;
    let labelEnd = -1;
    for(pos = 1; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) lines++;
        else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) lines++;
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ((0, $gy0A9.isSpace)(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    const destRes = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!destRes.ok) return false;
    const href = state.md.normalizeLink(destRes.str);
    if (!state.md.validateLink(href)) return false;
    pos = destRes.pos;
    lines += destRes.lines;
    // save cursor state, we could require to rollback later
    const destEndPos = pos;
    const destEndLineNo = lines;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    const start = pos;
    for(; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ((0, $gy0A9.isSpace)(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    const titleRes = state.md.helpers.parseLinkTitle(str, pos, max);
    let title;
    if (pos < max && start !== pos && titleRes.ok) {
        title = titleRes.str;
        pos = titleRes.pos;
        lines += titleRes.lines;
    } else {
        title = "";
        pos = destEndPos;
        lines = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        const ch = str.charCodeAt(pos);
        if (!(0, $gy0A9.isSpace)(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = "";
            pos = destEndPos;
            lines = destEndLineNo;
            while(pos < max){
                const ch = str.charCodeAt(pos);
                if (!(0, $gy0A9.isSpace)(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    const label = (0, $gy0A9.normalizeReference)(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /* istanbul ignore if */ if (silent) return true;
    if (typeof state.env.references === "undefined") state.env.references = {};
    if (typeof state.env.references[label] === "undefined") state.env.references[label] = {
        title: title,
        href: href
    };
    state.parentType = oldParentType;
    state.line = startLine + lines + 1;
    return true;
}

});

parcelRegister("6prZ4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d98ed08115ef1e8f$export$2e2bcd8739ae039; });
// HTML block

var $k744N = parcelRequire("k744N");

var $iDMCb = parcelRequire("iDMCb");
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
const $d98ed08115ef1e8f$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp("^</?(" + (0, $k744N.default).join("|") + ")(?=(\\s|/?>|$))", "i"),
        /^$/,
        true
    ],
    [
        new RegExp((0, $iDMCb.HTML_OPEN_CLOSE_TAG_RE).source + "\\s*$"),
        /^$/,
        false
    ]
];
function $d98ed08115ef1e8f$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    let lineText = state.src.slice(pos, max);
    let i = 0;
    for(; i < $d98ed08115ef1e8f$var$HTML_SEQUENCES.length; i++){
        if ($d98ed08115ef1e8f$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $d98ed08115ef1e8f$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $d98ed08115ef1e8f$var$HTML_SEQUENCES[i][2];
    let nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$d98ed08115ef1e8f$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($d98ed08115ef1e8f$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    const token = state.push("html_block", "", 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
}

});
parcelRegister("k744N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0340afc2bac8f7b9$export$2e2bcd8739ae039; });
// List of valid html blocks names, according to commonmark spec
// https://spec.commonmark.org/0.30/#html-blocks
var $0340afc2bac8f7b9$export$2e2bcd8739ae039 = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "section",
    "source",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];

});

parcelRegister("iDMCb", function(module, exports) {

$parcel$export(module.exports, "HTML_TAG_RE", function () { return $0397b007c7be7ff8$export$6db61d2c3a16e419; });
$parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", function () { return $0397b007c7be7ff8$export$cd48660d06f74639; });
// Regexps to match html elements
const $0397b007c7be7ff8$var$attr_name = "[a-zA-Z_:][a-zA-Z0-9:._-]*";
const $0397b007c7be7ff8$var$unquoted = "[^\"'=<>`\\x00-\\x20]+";
const $0397b007c7be7ff8$var$single_quoted = "'[^']*'";
const $0397b007c7be7ff8$var$double_quoted = '"[^"]*"';
const $0397b007c7be7ff8$var$attr_value = "(?:" + $0397b007c7be7ff8$var$unquoted + "|" + $0397b007c7be7ff8$var$single_quoted + "|" + $0397b007c7be7ff8$var$double_quoted + ")";
const $0397b007c7be7ff8$var$attribute = "(?:\\s+" + $0397b007c7be7ff8$var$attr_name + "(?:\\s*=\\s*" + $0397b007c7be7ff8$var$attr_value + ")?)";
const $0397b007c7be7ff8$var$open_tag = "<[A-Za-z][A-Za-z0-9\\-]*" + $0397b007c7be7ff8$var$attribute + "*\\s*\\/?>";
const $0397b007c7be7ff8$var$close_tag = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>";
const $0397b007c7be7ff8$var$comment = "<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->";
const $0397b007c7be7ff8$var$processing = "<[?][\\s\\S]*?[?]>";
const $0397b007c7be7ff8$var$declaration = "<![A-Z]+\\s+[^>]*>";
const $0397b007c7be7ff8$var$cdata = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>";
const $0397b007c7be7ff8$export$6db61d2c3a16e419 = new RegExp("^(?:" + $0397b007c7be7ff8$var$open_tag + "|" + $0397b007c7be7ff8$var$close_tag + "|" + $0397b007c7be7ff8$var$comment + "|" + $0397b007c7be7ff8$var$processing + "|" + $0397b007c7be7ff8$var$declaration + "|" + $0397b007c7be7ff8$var$cdata + ")");
const $0397b007c7be7ff8$export$cd48660d06f74639 = new RegExp("^(?:" + $0397b007c7be7ff8$var$open_tag + "|" + $0397b007c7be7ff8$var$close_tag + ")");

});


parcelRegister("dj3bZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7250a4d86f41fc44$export$2e2bcd8739ae039; });
// heading (#, ##, ...)

var $gy0A9 = parcelRequire("gy0A9");
function $7250a4d86f41fc44$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    let ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    let level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !(0, $gy0A9.isSpace)(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    const tmp = state.skipCharsBack(max, 0x23, pos) // #
    ;
    if (tmp > pos && (0, $gy0A9.isSpace)(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    const token_o = state.push("heading_open", "h" + String(level), 1);
    token_o.markup = "########".slice(0, level);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push("inline", "", 0);
    token_i.content = state.src.slice(pos, max).trim();
    token_i.map = [
        startLine,
        state.line
    ];
    token_i.children = [];
    const token_c = state.push("heading_close", "h" + String(level), -1);
    token_c.markup = "########".slice(0, level);
    return true;
}

});

parcelRegister("5b6cY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96038847e6af7e65$export$2e2bcd8739ae039; });
// lheading (---, ===)
function $96038847e6af7e65$export$2e2bcd8739ae039(state, startLine, endLine /*, silent */ ) {
    const terminatorRules = state.md.block.ruler.getRules("paragraph");
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    const oldParentType = state.parentType;
    state.parentType = "paragraph" // use paragraph to match terminatorRules
    ;
    // jump line-by-line until empty one or EOF
    let level = 0;
    let marker;
    let nextLine = startLine + 1;
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            let pos = state.bMarks[nextLine] + state.tShift[nextLine];
            const max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    const token_o = state.push("heading_open", "h" + String(level), 1);
    token_o.markup = String.fromCharCode(marker);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push("inline", "", 0);
    token_i.content = content;
    token_i.map = [
        startLine,
        state.line - 1
    ];
    token_i.children = [];
    const token_c = state.push("heading_close", "h" + String(level), -1);
    token_c.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
}

});

parcelRegister("aoxss", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19c6f5f052b4d9df$export$2e2bcd8739ae039; });
// Paragraph
function $19c6f5f052b4d9df$export$2e2bcd8739ae039(state, startLine, endLine) {
    const terminatorRules = state.md.block.ruler.getRules("paragraph");
    const oldParentType = state.parentType;
    let nextLine = startLine + 1;
    state.parentType = "paragraph";
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    const token_o = state.push("paragraph_open", "p", 1);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push("inline", "", 0);
    token_i.content = content;
    token_i.map = [
        startLine,
        state.line
    ];
    token_i.children = [];
    state.push("paragraph_close", "p", -1);
    state.parentType = oldParentType;
    return true;
}

});


parcelRegister("fYVCx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3491b5bb5a8e4388$export$2e2bcd8739ae039; });
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ 
var $byqSe = parcelRequire("byqSe");

var $jksfs = parcelRequire("jksfs");

var $5LM4O = parcelRequire("5LM4O");

var $flK7w = parcelRequire("flK7w");

var $eQeUK = parcelRequire("eQeUK");

var $j7oSe = parcelRequire("j7oSe");

var $kGD6a = parcelRequire("kGD6a");

var $2xeuG = parcelRequire("2xeuG");

var $6bcQn = parcelRequire("6bcQn");

var $h6uTG = parcelRequire("h6uTG");

var $2L72Y = parcelRequire("2L72Y");

var $bVoJ3 = parcelRequire("bVoJ3");

var $iVuHA = parcelRequire("iVuHA");

var $2tSQc = parcelRequire("2tSQc");

var $9xY2Q = parcelRequire("9xY2Q");

var $jSHwn = parcelRequire("jSHwn");
// Parser rules
const $3491b5bb5a8e4388$var$_rules = [
    [
        "text",
        (0, $5LM4O.default)
    ],
    [
        "linkify",
        (0, $flK7w.default)
    ],
    [
        "newline",
        (0, $eQeUK.default)
    ],
    [
        "escape",
        (0, $j7oSe.default)
    ],
    [
        "backticks",
        (0, $kGD6a.default)
    ],
    [
        "strikethrough",
        (0, $2xeuG.default).tokenize
    ],
    [
        "emphasis",
        (0, $6bcQn.default).tokenize
    ],
    [
        "link",
        (0, $h6uTG.default)
    ],
    [
        "image",
        (0, $2L72Y.default)
    ],
    [
        "autolink",
        (0, $bVoJ3.default)
    ],
    [
        "html_inline",
        (0, $iVuHA.default)
    ],
    [
        "entity",
        (0, $2tSQc.default)
    ]
];
// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
const $3491b5bb5a8e4388$var$_rules2 = [
    [
        "balance_pairs",
        (0, $9xY2Q.default)
    ],
    [
        "strikethrough",
        (0, $2xeuG.default).postProcess
    ],
    [
        "emphasis",
        (0, $6bcQn.default).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        "fragments_join",
        (0, $jSHwn.default)
    ]
];
/**
 * new ParserInline()
 **/ function $3491b5bb5a8e4388$var$ParserInline() {
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new (0, $byqSe.default)();
    for(let i = 0; i < $3491b5bb5a8e4388$var$_rules.length; i++)this.ruler.push($3491b5bb5a8e4388$var$_rules[i][0], $3491b5bb5a8e4388$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new (0, $byqSe.default)();
    for(let i = 0; i < $3491b5bb5a8e4388$var$_rules2.length; i++)this.ruler2.push($3491b5bb5a8e4388$var$_rules2[i][0], $3491b5bb5a8e4388$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$3491b5bb5a8e4388$var$ParserInline.prototype.skipToken = function(state) {
    const pos = state.pos;
    const rules = this.ruler.getRules("");
    const len = rules.length;
    const maxNesting = state.md.options.maxNesting;
    const cache = state.cache;
    if (typeof cache[pos] !== "undefined") {
        state.pos = cache[pos];
        return;
    }
    let ok = false;
    if (state.level < maxNesting) for(let i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) {
            if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$3491b5bb5a8e4388$var$ParserInline.prototype.tokenize = function(state) {
    const rules = this.ruler.getRules("");
    const len = rules.length;
    const end = state.posMax;
    const maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        const prevPos = state.pos;
        let ok = false;
        if (state.level < maxNesting) for(let i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) {
                if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $3491b5bb5a8e4388$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    const state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    const rules = this.ruler2.getRules("");
    const len = rules.length;
    for(let i = 0; i < len; i++)rules[i](state);
};
$3491b5bb5a8e4388$var$ParserInline.prototype.State = (0, $jksfs.default);
var $3491b5bb5a8e4388$export$2e2bcd8739ae039 = $3491b5bb5a8e4388$var$ParserInline;

});
parcelRegister("jksfs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $474d1700a37e3419$export$2e2bcd8739ae039; });
// Inline parser state

var $69xzQ = parcelRequire("69xzQ");

var $gy0A9 = parcelRequire("gy0A9");
function $474d1700a37e3419$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = "";
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$474d1700a37e3419$var$StateInline.prototype.pushPending = function() {
    const token = new (0, $69xzQ.default)("text", "", 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = "";
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$474d1700a37e3419$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    const token = new (0, $69xzQ.default)(type, tag, nesting);
    let token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$474d1700a37e3419$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    let can_open, can_close;
    let left_flanking = true;
    let right_flanking = true;
    const max = this.posMax;
    const marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    const lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    let pos = start;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    const count = pos - start;
    // treat end of the line as a whitespace
    const nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    const isLastPunctChar = (0, $gy0A9.isMdAsciiPunct)(lastChar) || (0, $gy0A9.isPunctChar)(String.fromCharCode(lastChar));
    const isNextPunctChar = (0, $gy0A9.isMdAsciiPunct)(nextChar) || (0, $gy0A9.isPunctChar)(String.fromCharCode(nextChar));
    const isLastWhiteSpace = (0, $gy0A9.isWhiteSpace)(lastChar);
    const isNextWhiteSpace = (0, $gy0A9.isWhiteSpace)(nextChar);
    if (isNextWhiteSpace) left_flanking = false;
    else if (isNextPunctChar) {
        if (!(isLastWhiteSpace || isLastPunctChar)) left_flanking = false;
    }
    if (isLastWhiteSpace) right_flanking = false;
    else if (isLastPunctChar) {
        if (!(isNextWhiteSpace || isNextPunctChar)) right_flanking = false;
    }
    if (!canSplitWord) {
        can_open = left_flanking && (!right_flanking || isLastPunctChar);
        can_close = right_flanking && (!left_flanking || isNextPunctChar);
    } else {
        can_open = left_flanking;
        can_close = right_flanking;
    }
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$474d1700a37e3419$var$StateInline.prototype.Token = (0, $69xzQ.default);
var $474d1700a37e3419$export$2e2bcd8739ae039 = $474d1700a37e3419$var$StateInline;

});

parcelRegister("5LM4O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $371399f81ec69697$export$2e2bcd8739ae039; });
// Skip text characters for text token, place those to pending buffer
// and increment current pos
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $371399f81ec69697$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
function $371399f81ec69697$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    while(pos < state.posMax && !$371399f81ec69697$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
} // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParcerInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
}; */ 

});

parcelRegister("flK7w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff092122faafacd9$export$2e2bcd8739ae039; });
// Process links like https://example.org/
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
const $ff092122faafacd9$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
function $ff092122faafacd9$export$2e2bcd8739ae039(state, silent) {
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    const pos = state.pos;
    const max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    const match = state.pending.match($ff092122faafacd9$var$SCHEME_RE);
    if (!match) return false;
    const proto = match[1];
    const link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    let url = link.url;
    // invalid link, but still detected by linkify somehow;
    // need to check to prevent infinite loop below
    if (url.length <= proto.length) return false;
    // disallow '*' at the end of the link (conflicts with emphasis)
    url = url.replace(/\*+$/, "");
    const fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        const token_o = state.push("link_open", "a", 1);
        token_o.attrs = [
            [
                "href",
                fullUrl
            ]
        ];
        token_o.markup = "linkify";
        token_o.info = "auto";
        const token_t = state.push("text", "", 0);
        token_t.content = state.md.normalizeLinkText(url);
        const token_c = state.push("link_close", "a", -1);
        token_c.markup = "linkify";
        token_c.info = "auto";
    }
    state.pos += url.length - proto.length;
    return true;
}

});

parcelRegister("eQeUK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5af74e42347d00dd$export$2e2bcd8739ae039; });
// Proceess '\n'

var $gy0A9 = parcelRequire("gy0A9");
function $5af74e42347d00dd$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    const max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                let ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push("hardbreak", "br", 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push("softbreak", "br", 0);
            }
        } else state.push("softbreak", "br", 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && (0, $gy0A9.isSpace)(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
}

});

parcelRegister("j7oSe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7d0c9eee82e081c$export$2e2bcd8739ae039; });
// Process escaped chars and hardbreaks

var $gy0A9 = parcelRequire("gy0A9");
const $d7d0c9eee82e081c$var$ESCAPED = [];
for(let i = 0; i < 256; i++)$d7d0c9eee82e081c$var$ESCAPED.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(ch) {
    $d7d0c9eee82e081c$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
function $d7d0c9eee82e081c$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    let ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push("hardbreak", "br", 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!(0, $gy0A9.isSpace)(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    let escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        const ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    const origStr = "\\" + escapedStr;
    if (!silent) {
        const token = state.push("text_special", "", 0);
        if (ch1 < 256 && $d7d0c9eee82e081c$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = "escape";
    }
    state.pos = pos + 1;
    return true;
}

});

parcelRegister("kGD6a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e11a4096e70127f1$export$2e2bcd8739ae039; });
// Parse backticks
function $e11a4096e70127f1$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    const ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    const start = pos;
    pos++;
    const max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    const marker = state.src.slice(start, pos);
    const openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    let matchEnd = pos;
    let matchStart;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf("`", matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        const closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                const token = state.push("code_inline", "code", 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, " ").replace(/^ (.+) $/, "$1");
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
}

});

parcelRegister("2xeuG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b0f4074662b53fb$export$2e2bcd8739ae039; });
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
function $3b0f4074662b53fb$var$strikethrough_tokenize(state, silent) {
    const start = state.pos;
    const marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    const scanned = state.scanDelims(state.pos, true);
    let len = scanned.length;
    const ch = String.fromCharCode(marker);
    if (len < 2) return false;
    let token;
    if (len % 2) {
        token = state.push("text", "", 0);
        token.content = ch;
        len--;
    }
    for(let i = 0; i < len; i += 2){
        token = state.push("text", "", 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
}
function $3b0f4074662b53fb$var$postProcess(state, delimiters) {
    let token;
    const loneMarkers = [];
    const max = delimiters.length;
    for(let i = 0; i < max; i++){
        const startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        const endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = "s_open";
        token.tag = "s";
        token.nesting = 1;
        token.markup = "~~";
        token.content = "";
        token = state.tokens[endDelim.token];
        token.type = "s_close";
        token.tag = "s";
        token.nesting = -1;
        token.markup = "~~";
        token.content = "";
        if (state.tokens[endDelim.token - 1].type === "text" && state.tokens[endDelim.token - 1].content === "~") loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        const i = loneMarkers.pop();
        let j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === "s_close")j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
// Walk through delimiter list and replace text tokens with tags
//
function $3b0f4074662b53fb$var$strikethrough_postProcess(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $3b0f4074662b53fb$var$postProcess(state, state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $3b0f4074662b53fb$var$postProcess(state, tokens_meta[curr].delimiters);
}
var $3b0f4074662b53fb$export$2e2bcd8739ae039 = {
    tokenize: $3b0f4074662b53fb$var$strikethrough_tokenize,
    postProcess: $3b0f4074662b53fb$var$strikethrough_postProcess
};

});

parcelRegister("6bcQn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4eaa23c3b9ee7db$export$2e2bcd8739ae039; });
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
function $e4eaa23c3b9ee7db$var$emphasis_tokenize(state, silent) {
    const start = state.pos;
    const marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    const scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(let i = 0; i < scanned.length; i++){
        const token = state.push("text", "", 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            marker: // Char code of the starting marker (number).
            //
            marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
}
function $e4eaa23c3b9ee7db$var$postProcess(state, delimiters) {
    const max = delimiters.length;
    for(let i = max - 1; i >= 0; i--){
        const startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        const endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        const isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        const ch = String.fromCharCode(startDelim.marker);
        const token_o = state.tokens[startDelim.token];
        token_o.type = isStrong ? "strong_open" : "em_open";
        token_o.tag = isStrong ? "strong" : "em";
        token_o.nesting = 1;
        token_o.markup = isStrong ? ch + ch : ch;
        token_o.content = "";
        const token_c = state.tokens[endDelim.token];
        token_c.type = isStrong ? "strong_close" : "em_close";
        token_c.tag = isStrong ? "strong" : "em";
        token_c.nesting = -1;
        token_c.markup = isStrong ? ch + ch : ch;
        token_c.content = "";
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = "";
            state.tokens[delimiters[startDelim.end + 1].token].content = "";
            i--;
        }
    }
}
// Walk through delimiter list and replace text tokens with tags
//
function $e4eaa23c3b9ee7db$var$emphasis_post_process(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $e4eaa23c3b9ee7db$var$postProcess(state, state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $e4eaa23c3b9ee7db$var$postProcess(state, tokens_meta[curr].delimiters);
}
var $e4eaa23c3b9ee7db$export$2e2bcd8739ae039 = {
    tokenize: $e4eaa23c3b9ee7db$var$emphasis_tokenize,
    postProcess: $e4eaa23c3b9ee7db$var$emphasis_post_process
};

});

parcelRegister("h6uTG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef2d18b3917f56f6$export$2e2bcd8739ae039; });
// Process [link](<to> "stuff")

var $gy0A9 = parcelRequire("gy0A9");
function $ef2d18b3917f56f6$export$2e2bcd8739ae039(state, silent) {
    let code, label, res, ref;
    let href = "";
    let title = "";
    let start = state.pos;
    let parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    const oldPos = state.pos;
    const max = state.posMax;
    const labelStart = state.pos + 1;
    const labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    let pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $gy0A9.isSpace)(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = "";
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!(0, $gy0A9.isSpace)(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!(0, $gy0A9.isSpace)(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === "undefined") return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[(0, $gy0A9.normalizeReference)(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        const token_o = state.push("link_open", "a", 1);
        const attrs = [
            [
                "href",
                href
            ]
        ];
        token_o.attrs = attrs;
        if (title) attrs.push([
            "title",
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        state.push("link_close", "a", -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
}

});

parcelRegister("2L72Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdbad36543414216$export$2e2bcd8739ae039; });
// Process ![image](<src> "title")

var $gy0A9 = parcelRequire("gy0A9");
function $fdbad36543414216$export$2e2bcd8739ae039(state, silent) {
    let code, content, label, pos, ref, res, title, start;
    let href = "";
    const oldPos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    const labelStart = state.pos + 2;
    const labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $gy0A9.isSpace)(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = "";
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $gy0A9.isSpace)(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!(0, $gy0A9.isSpace)(code) && code !== 0x0A) break;
            }
        } else title = "";
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === "undefined") return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[(0, $gy0A9.normalizeReference)(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        const tokens = [];
        state.md.inline.parse(content, state.md, state.env, tokens);
        const token = state.push("image", "img", 0);
        const attrs = [
            [
                "src",
                href
            ],
            [
                "alt",
                ""
            ]
        ];
        token.attrs = attrs;
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            "title",
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
}

});

parcelRegister("bVoJ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42c3e5efa3faaea2$export$2e2bcd8739ae039; });
// Process autolinks '<protocol:...>'
/* eslint max-len:0 */ const $42c3e5efa3faaea2$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
/* eslint-disable-next-line no-control-regex */ const $42c3e5efa3faaea2$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
function $42c3e5efa3faaea2$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    const start = state.pos;
    const max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        const ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    const url = state.src.slice(start + 1, pos);
    if ($42c3e5efa3faaea2$var$AUTOLINK_RE.test(url)) {
        const fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            const token_o = state.push("link_open", "a", 1);
            token_o.attrs = [
                [
                    "href",
                    fullUrl
                ]
            ];
            token_o.markup = "autolink";
            token_o.info = "auto";
            const token_t = state.push("text", "", 0);
            token_t.content = state.md.normalizeLinkText(url);
            const token_c = state.push("link_close", "a", -1);
            token_c.markup = "autolink";
            token_c.info = "auto";
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($42c3e5efa3faaea2$var$EMAIL_RE.test(url)) {
        const fullUrl = state.md.normalizeLink("mailto:" + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            const token_o = state.push("link_open", "a", 1);
            token_o.attrs = [
                [
                    "href",
                    fullUrl
                ]
            ];
            token_o.markup = "autolink";
            token_o.info = "auto";
            const token_t = state.push("text", "", 0);
            token_t.content = state.md.normalizeLinkText(url);
            const token_c = state.push("link_close", "a", -1);
            token_c.markup = "autolink";
            token_c.info = "auto";
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
}

});

parcelRegister("iVuHA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e836d9f23188305$export$2e2bcd8739ae039; });
// Process html tags

var $iDMCb = parcelRequire("iDMCb");
function $0e836d9f23188305$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $0e836d9f23188305$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $0e836d9f23188305$var$isLetter(ch) {
    /* eslint no-bitwise:0 */ const lc = ch | 0x20 // to lower case
    ;
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
function $0e836d9f23188305$export$2e2bcd8739ae039(state, silent) {
    if (!state.md.options.html) return false;
    // Check start
    const max = state.posMax;
    const pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    const ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$0e836d9f23188305$var$isLetter(ch)) return false;
    const match = state.src.slice(pos).match((0, $iDMCb.HTML_TAG_RE));
    if (!match) return false;
    if (!silent) {
        const token = state.push("html_inline", "", 0);
        token.content = match[0];
        if ($0e836d9f23188305$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($0e836d9f23188305$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
}

});

parcelRegister("2tSQc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e17b27f7ad9503fe$export$2e2bcd8739ae039; });
// Process html entity - &#123;, &#xAF;, &quot;, ...
parcelRequire("38J9K");
var $8BwAF = parcelRequire("8BwAF");

var $gy0A9 = parcelRequire("gy0A9");
const $e17b27f7ad9503fe$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
const $e17b27f7ad9503fe$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
function $e17b27f7ad9503fe$export$2e2bcd8739ae039(state, silent) {
    const pos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    const ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        const match = state.src.slice(pos).match($e17b27f7ad9503fe$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                const code = match[1][0].toLowerCase() === "x" ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                const token = state.push("text_special", "", 0);
                token.content = (0, $gy0A9.isValidEntityCode)(code) ? (0, $gy0A9.fromCodePoint)(code) : (0, $gy0A9.fromCodePoint)(0xFFFD);
                token.markup = match[0];
                token.info = "entity";
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        const match = state.src.slice(pos).match($e17b27f7ad9503fe$var$NAMED_RE);
        if (match) {
            const decoded = (0, $8BwAF.decodeHTML)(match[0]);
            if (decoded !== match[0]) {
                if (!silent) {
                    const token = state.push("text_special", "", 0);
                    token.content = decoded;
                    token.markup = match[0];
                    token.info = "entity";
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
}

});

parcelRegister("9xY2Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d1a4ede406d7aaa$export$2e2bcd8739ae039; });
// For each opening emphasis-like marker find a matching closing one
//
function $1d1a4ede406d7aaa$var$processDelimiters(delimiters) {
    const openersBottom = {};
    const max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    let headerIdx = 0;
    let lastTokenIdx = -2 // needs any value lower than -1
    ;
    const jumps = [];
    for(let closerIdx = 0; closerIdx < max; closerIdx++){
        const closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        /* eslint-disable-next-line no-prototype-builtins */ if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        const minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        let openerIdx = headerIdx - jumps[headerIdx] - 1;
        let newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            const opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                let isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    const lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
function $1d1a4ede406d7aaa$export$2e2bcd8739ae039(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $1d1a4ede406d7aaa$var$processDelimiters(state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $1d1a4ede406d7aaa$var$processDelimiters(tokens_meta[curr].delimiters);
}

});

parcelRegister("jSHwn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06551fce2241052b$export$2e2bcd8739ae039; });
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
function $06551fce2241052b$export$2e2bcd8739ae039(state) {
    let curr, last;
    let level = 0;
    const tokens = state.tokens;
    const max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level-- // closing tag
        ;
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++ // opening tag
        ;
        if (tokens[curr].type === "text" && curr + 1 < max && tokens[curr + 1].type === "text") // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
}

});


parcelRegister("fMzl7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb3c3e52c806991b$export$2e2bcd8739ae039; });

var $itu0m = parcelRequire("itu0m");
//
// Helpers
//
// Merge objects
//
function $bb3c3e52c806991b$var$assign(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $bb3c3e52c806991b$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $bb3c3e52c806991b$var$isString(obj) {
    return $bb3c3e52c806991b$var$_class(obj) === "[object String]";
}
function $bb3c3e52c806991b$var$isObject(obj) {
    return $bb3c3e52c806991b$var$_class(obj) === "[object Object]";
}
function $bb3c3e52c806991b$var$isRegExp(obj) {
    return $bb3c3e52c806991b$var$_class(obj) === "[object RegExp]";
}
function $bb3c3e52c806991b$var$isFunction(obj) {
    return $bb3c3e52c806991b$var$_class(obj) === "[object Function]";
}
function $bb3c3e52c806991b$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
//
const $bb3c3e52c806991b$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $bb3c3e52c806991b$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        /* eslint-disable-next-line no-prototype-builtins */ return acc || $bb3c3e52c806991b$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
const $bb3c3e52c806991b$var$defaultSchemas = {
    "http:": {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp("^\\/\\/" + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, "i");
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    "https:": "http:",
    "ftp:": "http:",
    "//": {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp("^" + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            "(?:localhost|(?:(?:" + self.re.src_domain + ")\\.)+" + self.re.src_domain_root + ")" + self.re.src_port + self.re.src_host_terminator + self.re.src_path, "i");
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ":") return 0;
                if (pos >= 3 && text[pos - 3] === "/") return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    "mailto:": {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp("^" + self.re.src_email_name + "@" + self.re.src_host_strict, "i");
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
/* eslint-disable-next-line max-len */ const $bb3c3e52c806991b$var$tlds_2ch_src_re = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]";
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
const $bb3c3e52c806991b$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split("|");
function $bb3c3e52c806991b$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = "";
}
function $bb3c3e52c806991b$var$createValidator(re) {
    return function(text, pos) {
        const tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $bb3c3e52c806991b$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}
// Schemas compiler. Build regexps.
//
function $bb3c3e52c806991b$var$compile(self) {
    // Load & clone RE patterns.
    const re = self.re = (0, $itu0m.default)(self.__opts__);
    // Define dynamic patterns
    const tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($bb3c3e52c806991b$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join("|");
    function untpl(tpl) {
        return tpl.replace("%TLDS%", re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), "i");
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), "i");
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), "i");
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), "i");
    //
    // Compile each schema
    //
    const aliases = [];
    self.__compiled__ = {} // Reset compiled data
    ;
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        const val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        const compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($bb3c3e52c806991b$var$isObject(val)) {
            if ($bb3c3e52c806991b$var$isRegExp(val.validate)) compiled.validate = $bb3c3e52c806991b$var$createValidator(val.validate);
            else if ($bb3c3e52c806991b$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($bb3c3e52c806991b$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $bb3c3e52c806991b$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($bb3c3e52c806991b$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[""] = {
        validate: null,
        normalize: $bb3c3e52c806991b$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    const slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($bb3c3e52c806991b$var$escapeRE).join("|");
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + "))(" + slist + ")", "i");
    self.re.schema_search = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + "))(" + slist + ")", "ig");
    self.re.schema_at_start = RegExp("^" + self.re.schema_search.source, "i");
    self.re.pretest = RegExp("(" + self.re.schema_test.source + ")|(" + self.re.host_fuzzy_test.source + ")|@", "i");
    //
    // Cleanup
    //
    $bb3c3e52c806991b$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $bb3c3e52c806991b$var$Match(self, shift) {
    const start = self.__index__;
    const end = self.__last_index__;
    const text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $bb3c3e52c806991b$var$createMatch(self, shift) {
    const match = new $bb3c3e52c806991b$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $bb3c3e52c806991b$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $bb3c3e52c806991b$var$LinkifyIt)) return new $bb3c3e52c806991b$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($bb3c3e52c806991b$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $bb3c3e52c806991b$var$assign({}, $bb3c3e52c806991b$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1 // Next scan position
    ;
    this.__schema__ = "";
    this.__text_cache__ = "";
    this.__schemas__ = $bb3c3e52c806991b$var$assign({}, $bb3c3e52c806991b$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $bb3c3e52c806991b$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $bb3c3e52c806991b$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $bb3c3e52c806991b$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $bb3c3e52c806991b$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $bb3c3e52c806991b$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $bb3c3e52c806991b$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $bb3c3e52c806991b$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    let m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__["http:"]) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = "";
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__["mailto:"]) {
        // guess schemaless emails
        at_pos = text.indexOf("@");
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = "mailto:";
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $bb3c3e52c806991b$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $bb3c3e52c806991b$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $bb3c3e52c806991b$var$LinkifyIt.prototype.match = function match(text) {
    const result = [];
    let shift = 0;
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($bb3c3e52c806991b$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    let tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($bb3c3e52c806991b$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $bb3c3e52c806991b$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    const m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    const len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $bb3c3e52c806991b$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $bb3c3e52c806991b$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $bb3c3e52c806991b$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $bb3c3e52c806991b$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $bb3c3e52c806991b$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = "http://" + match.url;
    if (match.schema === "mailto:" && !/^mailto:/i.test(match.url)) match.url = "mailto:" + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $bb3c3e52c806991b$var$LinkifyIt.prototype.onCompile = function onCompile() {};
var $bb3c3e52c806991b$export$2e2bcd8739ae039 = $bb3c3e52c806991b$var$LinkifyIt;

});
parcelRegister("itu0m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a5aaa981ffa2cc2$export$2e2bcd8739ae039; });
parcelRequire("eNm8G");
var $2lNFK = parcelRequire("2lNFK");
var $biVQF = parcelRequire("biVQF");
var $bZwjS = parcelRequire("bZwjS");
var $7uyBr = parcelRequire("7uyBr");
function $7a5aaa981ffa2cc2$export$2e2bcd8739ae039(opts) {
    const re = {};
    opts = opts || {};
    re.src_Any = (0, $2lNFK.default).source;
    re.src_Cc = (0, $biVQF.default).source;
    re.src_Z = (0, $7uyBr.default).source;
    re.src_P = (0, $bZwjS.default).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join("|");
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join("|");
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    const text_separators = "[><\uFF5C]";
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = "(?:(?!" + text_separators + "|" + re.src_ZPCc + ")" + re.src_Any + ")";
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    re.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)";
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = "(?:(?:(?!" + re.src_ZCc + "|[@/\\[\\]()]).)+@)?";
    re.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?";
    re.src_host_terminator = "(?=$|" + text_separators + "|" + re.src_ZPCc + ")" + "(?!" + (opts["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + re.src_ZPCc + "))";
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + "|" + text_separators + "|[()[\\]{}.,\"'?!\\-;]).|" + "\\[(?:(?!" + re.src_ZCc + "|\\]).)*\\]|" + "\\((?:(?!" + re.src_ZCc + "|[)]).)*\\)|" + "\\{(?:(?!" + re.src_ZCc + "|[}]).)*\\}|" + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + // allow `I'm_king` if no pair found
    "\\'(?=" + re.src_pseudo_letter + "|[-])|" + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    "\\.{2,}[a-zA-Z0-9%/&]|" + "\\.(?!" + re.src_ZCc + "|[.]|$)|" + (opts["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" // `---` => long dash, terminate
     : "\\-+|") + // allow `,,,` in paths
    ",(?!" + re.src_ZCc + "|$)|" + // allow `;` if not followed by space-like char
    ";(?!" + re.src_ZCc + "|$)|" + // allow `!!!` in paths, but not at the end
    "\\!+(?!" + re.src_ZCc + "|[!]|$)|" + "\\?(?!" + re.src_ZCc + "|[?]|$)" + ")+" + "|\\/" + ")?";
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = "xn--[a-z0-9\\-]{1,59}";
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    "(?:" + re.src_xn + "|" + re.src_pseudo_letter + "{1,63}" + ")";
    re.src_domain = "(?:" + re.src_xn + "|" + "(?:" + re.src_pseudo_letter + ")" + "|" + "(?:" + re.src_pseudo_letter + "(?:-|" + re.src_pseudo_letter + "){0,61}" + re.src_pseudo_letter + ")" + ")";
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ")\\.)*" + re.src_domain /* _root */  + ")" + ")";
    re.tpl_host_fuzzy = "(?:" + re.src_ip4 + "|" + "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))" + ")";
    re.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))";
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    //
    // Main rules
    //
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + re.src_ZPCc + "|>|$))";
    re.tpl_email_fuzzy = "(^|" + text_separators + '|"|\\(|' + re.src_ZCc + ")" + "(" + re.src_email_name + "@" + re.tpl_host_fuzzy_strict + ")";
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_fuzzy_strict + re.src_path + ")";
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ")";
    return re;
}

});


parcelRegister("lQLQe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe8390a2a2225b36$export$2e2bcd8739ae039; });
"use strict";
/** Highest positive signed 32-bit float value */ const $fe8390a2a2225b36$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $fe8390a2a2225b36$var$base = 36;
const $fe8390a2a2225b36$var$tMin = 1;
const $fe8390a2a2225b36$var$tMax = 26;
const $fe8390a2a2225b36$var$skew = 38;
const $fe8390a2a2225b36$var$damp = 700;
const $fe8390a2a2225b36$var$initialBias = 72;
const $fe8390a2a2225b36$var$initialN = 128; // 0x80
const $fe8390a2a2225b36$var$delimiter = "-"; // '\x2D'
/** Regular expressions */ const $fe8390a2a2225b36$var$regexPunycode = /^xn--/;
const $fe8390a2a2225b36$var$regexNonASCII = /[^\0-\x7F]/; // Note: U+007F DEL is excluded too.
const $fe8390a2a2225b36$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $fe8390a2a2225b36$var$errors = {
    "overflow": "Overflow: input needs wider integers to process",
    "not-basic": "Illegal input >= 0x80 (not a basic code point)",
    "invalid-input": "Invalid input"
};
/** Convenience shortcuts */ const $fe8390a2a2225b36$var$baseMinusTMin = $fe8390a2a2225b36$var$base - $fe8390a2a2225b36$var$tMin;
const $fe8390a2a2225b36$var$floor = Math.floor;
const $fe8390a2a2225b36$var$stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function $fe8390a2a2225b36$var$error(type) {
    throw new RangeError($fe8390a2a2225b36$var$errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function $fe8390a2a2225b36$var$map(array, callback) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = callback(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {String} A new string of characters returned by the callback
 * function.
 */ function $fe8390a2a2225b36$var$mapDomain(domain, callback) {
    const parts = domain.split("@");
    let result = "";
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + "@";
        domain = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    domain = domain.replace($fe8390a2a2225b36$var$regexSeparators, ".");
    const labels = domain.split(".");
    const encoded = $fe8390a2a2225b36$var$map(labels, callback).join(".");
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function $fe8390a2a2225b36$export$c1700176c90f250f(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const $fe8390a2a2225b36$export$f999239d9b149395 = (codePoints)=>String.fromCodePoint(...codePoints);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const $fe8390a2a2225b36$var$basicToDigit = function(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3A) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5B) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7B) return codePoint - 0x61;
    return $fe8390a2a2225b36$var$base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const $fe8390a2a2225b36$var$digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const $fe8390a2a2225b36$var$adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? $fe8390a2a2225b36$var$floor(delta / $fe8390a2a2225b36$var$damp) : delta >> 1;
    delta += $fe8390a2a2225b36$var$floor(delta / numPoints);
    for(; delta > $fe8390a2a2225b36$var$baseMinusTMin * $fe8390a2a2225b36$var$tMax >> 1; k += $fe8390a2a2225b36$var$base)delta = $fe8390a2a2225b36$var$floor(delta / $fe8390a2a2225b36$var$baseMinusTMin);
    return $fe8390a2a2225b36$var$floor(k + ($fe8390a2a2225b36$var$baseMinusTMin + 1) * delta / (delta + $fe8390a2a2225b36$var$skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const $fe8390a2a2225b36$export$2f872c0f2117be69 = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = $fe8390a2a2225b36$var$initialN;
    let bias = $fe8390a2a2225b36$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($fe8390a2a2225b36$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $fe8390a2a2225b36$var$error("not-basic");
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        const oldi = i;
        for(let w = 1, k = $fe8390a2a2225b36$var$base;; k += $fe8390a2a2225b36$var$base){
            if (index >= inputLength) $fe8390a2a2225b36$var$error("invalid-input");
            const digit = $fe8390a2a2225b36$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $fe8390a2a2225b36$var$base) $fe8390a2a2225b36$var$error("invalid-input");
            if (digit > $fe8390a2a2225b36$var$floor(($fe8390a2a2225b36$var$maxInt - i) / w)) $fe8390a2a2225b36$var$error("overflow");
            i += digit * w;
            const t = k <= bias ? $fe8390a2a2225b36$var$tMin : k >= bias + $fe8390a2a2225b36$var$tMax ? $fe8390a2a2225b36$var$tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = $fe8390a2a2225b36$var$base - t;
            if (w > $fe8390a2a2225b36$var$floor($fe8390a2a2225b36$var$maxInt / baseMinusT)) $fe8390a2a2225b36$var$error("overflow");
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = $fe8390a2a2225b36$var$adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if ($fe8390a2a2225b36$var$floor(i / out) > $fe8390a2a2225b36$var$maxInt - n) $fe8390a2a2225b36$var$error("overflow");
        n += $fe8390a2a2225b36$var$floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const $fe8390a2a2225b36$export$c564cdbbe6da493 = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $fe8390a2a2225b36$export$c1700176c90f250f(input);
    // Cache the length.
    const inputLength = input.length;
    // Initialize the state.
    let n = $fe8390a2a2225b36$var$initialN;
    let delta = 0;
    let bias = $fe8390a2a2225b36$var$initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push($fe8390a2a2225b36$var$stringFromCharCode(currentValue));
    const basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push($fe8390a2a2225b36$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = $fe8390a2a2225b36$var$maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $fe8390a2a2225b36$var$floor(($fe8390a2a2225b36$var$maxInt - delta) / handledCPCountPlusOne)) $fe8390a2a2225b36$var$error("overflow");
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > $fe8390a2a2225b36$var$maxInt) $fe8390a2a2225b36$var$error("overflow");
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = $fe8390a2a2225b36$var$base;; k += $fe8390a2a2225b36$var$base){
                    const t = k <= bias ? $fe8390a2a2225b36$var$tMin : k >= bias + $fe8390a2a2225b36$var$tMax ? $fe8390a2a2225b36$var$tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = $fe8390a2a2225b36$var$base - t;
                    output.push($fe8390a2a2225b36$var$stringFromCharCode($fe8390a2a2225b36$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = $fe8390a2a2225b36$var$floor(qMinusT / baseMinusT);
                }
                output.push($fe8390a2a2225b36$var$stringFromCharCode($fe8390a2a2225b36$var$digitToBasic(q, 0)));
                bias = $fe8390a2a2225b36$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join("");
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const $fe8390a2a2225b36$export$110c810e8727e62b = function(input) {
    return $fe8390a2a2225b36$var$mapDomain(input, function(string) {
        return $fe8390a2a2225b36$var$regexPunycode.test(string) ? $fe8390a2a2225b36$export$2f872c0f2117be69(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const $fe8390a2a2225b36$export$69111c4ea6e0c4a0 = function(input) {
    return $fe8390a2a2225b36$var$mapDomain(input, function(string) {
        return $fe8390a2a2225b36$var$regexNonASCII.test(string) ? "xn--" + $fe8390a2a2225b36$export$c564cdbbe6da493(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const $fe8390a2a2225b36$var$punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ "version": "2.3.1",
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ "ucs2": {
        "decode": $fe8390a2a2225b36$export$c1700176c90f250f,
        "encode": $fe8390a2a2225b36$export$f999239d9b149395
    },
    "decode": $fe8390a2a2225b36$export$2f872c0f2117be69,
    "encode": $fe8390a2a2225b36$export$c564cdbbe6da493,
    "toASCII": $fe8390a2a2225b36$export$69111c4ea6e0c4a0,
    "toUnicode": $fe8390a2a2225b36$export$110c810e8727e62b
};
var $fe8390a2a2225b36$export$2e2bcd8739ae039 = $fe8390a2a2225b36$var$punycode;

});

parcelRegister("9BeCd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e1b5f9b30e8d822$export$2e2bcd8739ae039; });
// markdown-it default options
var $1e1b5f9b30e8d822$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: false,
        // Use '/' to close single tags (<br />)
        xhtmlOut: false,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: "language-",
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 100
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRegister("M9Gic", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8d54c06f07da0a3$export$2e2bcd8739ae039; });
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
var $e8d54c06f07da0a3$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: false,
        // Use '/' to close single tags (<br />)
        xhtmlOut: false,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: "language-",
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                "normalize",
                "block",
                "inline",
                "text_join"
            ]
        },
        block: {
            rules: [
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "text"
            ],
            rules2: [
                "balance_pairs",
                "fragments_join"
            ]
        }
    }
};

});

parcelRegister("gkIt7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f18be2cb90cd6dd6$export$2e2bcd8739ae039; });
// Commonmark default options
var $f18be2cb90cd6dd6$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: true,
        // Use '/' to close single tags (<br />)
        xhtmlOut: true,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: "language-",
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                "normalize",
                "block",
                "inline",
                "text_join"
            ]
        },
        block: {
            rules: [
                "blockquote",
                "code",
                "fence",
                "heading",
                "hr",
                "html_block",
                "lheading",
                "list",
                "reference",
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "autolink",
                "backticks",
                "emphasis",
                "entity",
                "escape",
                "html_inline",
                "image",
                "link",
                "newline",
                "text"
            ],
            rules2: [
                "balance_pairs",
                "emphasis",
                "fragments_join"
            ]
        }
    }
};

});




parcelRegister("eBRqR", function(module, exports) {

$parcel$export(module.exports, "stringRepeat", function () { return $aa2df7e574cafe9a$export$345d822805ab3239; });
$parcel$export(module.exports, "escapeMarkdown", function () { return $aa2df7e574cafe9a$export$560888d6fe0cfe97; });
$parcel$export(module.exports, "transformHtml", function () { return $aa2df7e574cafe9a$export$9c95763b5a419f4c; });
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/utils.ts
// If changes are made to this file, please make the same update in the linked file.
/**
 * A replacement for `String.repeat` until it becomes widely available.
 */ function $aa2df7e574cafe9a$export$345d822805ab3239(text, length) {
    var result = "";
    for(var x = 0; x < length; x++)result += text;
    return result;
}
function $aa2df7e574cafe9a$export$560888d6fe0cfe97(str, startOfLine, insideTable) {
    var strToEscape = str || "";
    strToEscape = strToEscape.replace(/[`*\\+_()\[\]{}]/g, "\\$&");
    if (startOfLine) strToEscape = strToEscape.replace(/^[#-&(-*]/, "\\$&") // Don't escape ' character
    .replace(/^(\d+)\./, "$1\\.");
    if (insideTable) strToEscape = strToEscape.replace(/[|]/g, "\\$&");
    return strToEscape;
}
var $aa2df7e574cafe9a$var$SPECIAL_CHARACTERS = /\u200c|↵/g;
function $aa2df7e574cafe9a$var$removeSpecialCharacters(node) {
    if (node.nodeType === 3 && node.textContent) node.textContent = node.textContent.replace($aa2df7e574cafe9a$var$SPECIAL_CHARACTERS, "");
    Array.from(node.childNodes).forEach(function(child) {
        return $aa2df7e574cafe9a$var$removeSpecialCharacters(child);
    });
}
function $aa2df7e574cafe9a$export$9c95763b5a419f4c(html, options) {
    var el = document.createElement("div");
    el.innerHTML = html;
    // Remove zero-width-non-joiner
    Array.from(el.querySelectorAll("p")).forEach(function(p) {
        $aa2df7e574cafe9a$var$removeSpecialCharacters(p);
    });
    // Convert mention containers, i.e.:
    //   <a href="/abodera/" rel="nofollow" title="@abodera" class="mention mention-me">Artur Bodera</a>
    Array.from(el.querySelectorAll("a.mention, a.ap-mention")).forEach(function(a) {
        var span = document.createElement("span");
        span.setAttribute("class", "editor-entity-mention");
        span.setAttribute("contenteditable", "false");
        var atlassianId = a.getAttribute("data-atlassian-id") || "";
        if (atlassianId) // Atlassian ID is wrapped in curlies so that it get serialized as @{aid-id} instead of @aid-id
        span.setAttribute("data-mention-id", "{".concat(atlassianId, "}"));
        else {
            var title = a.getAttribute("title") || "";
            if (title) {
                var usernameMatch = title.match(/^@(.*?)$/);
                if (usernameMatch) {
                    var username = usernameMatch[1];
                    span.setAttribute("data-mention-id", username);
                }
            }
        }
        var text = a.textContent || "";
        if (text.indexOf("@") === 0) span.textContent = a.textContent;
        else span.textContent = "@".concat(a.textContent);
        a.parentNode.insertBefore(span, a);
        a.parentNode.removeChild(a);
    });
    // Convert mention containers, i.e.:
    //   <span class="ap-mention" data-atlassian-id="5c09bf77ec71bd223bbe866f">@Scott Demo</span>
    Array.from(el.querySelectorAll("span.ap-mention")).forEach(function(s) {
        var span = document.createElement("span");
        span.setAttribute("class", "editor-entity-mention");
        span.setAttribute("contenteditable", "false");
        var atlassianId = s.getAttribute("data-atlassian-id") || "";
        span.setAttribute("data-mention-id", "{".concat(atlassianId, "}"));
        var text = s.textContent || "";
        span.textContent = text.indexOf("@") === 0 ? text : "@".concat(text);
        s.parentNode.insertBefore(span, s);
        s.parentNode.removeChild(s);
    });
    // Parse emojis i.e.
    //     <img src="https://d301sr5gafysq2.cloudfront.net/207268dc597d/emoji/img/diamond_shape_with_a_dot_inside.svg" alt="diamond shape with a dot inside" title="diamond shape with a dot inside" class="emoji">
    Array.from(el.querySelectorAll("img.emoji")).forEach(function(img) {
        var span = document.createElement("span");
        var shortName = img.getAttribute("data-emoji-short-name") || "";
        if (!shortName) {
            // Fallback to parsing Bitbucket's src attributes to find the
            // short name
            var src = img.getAttribute("src");
            var idMatch = !src ? false : src.match(/([^\/]+)\.[^\/]+$/);
            if (idMatch) shortName = ":".concat(decodeURIComponent(idMatch[1]), ":");
        }
        if (shortName) span.setAttribute("data-emoji-short-name", shortName);
        img.parentNode.insertBefore(span, img);
        img.parentNode.removeChild(img);
    });
    if (!options.disableBitbucketLinkStripping) // Convert all automatic links to plain text, because they will be re-created on render by the server
    Array.from(el.querySelectorAll("a"))// Don't convert external links (i.e. not automatic links)
    .filter(function(a) {
        return a.getAttribute("data-is-external-link") !== "true" && a.getAttribute("data-inline-card") === null;
    }).forEach(function(a) {
        Array.from(a.childNodes).forEach(function(child) {
            a.parentNode.insertBefore(child, a);
        });
        a.parentNode.removeChild(a);
    });
    // Parse images
    // Not using :pseudo because of IE11 bug:
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/16104908/
    Array.from(el.querySelectorAll("img")).filter(function(img) {
        return !img.classList.contains("emoji");
    }).forEach(function(img) {
        var parentNode = img.parentNode;
        if (!parentNode) return;
        /**
     * Lift image node if parent isn't the root-element
     */ if (parentNode !== el) {
            var isValidPath = validateImageNodeParent(parentNode);
            if (!isValidPath) liftImageNode(parentNode, img);
        }
        /**
     * Replace image with media node
     */ var mediaSingle = document.createElement("div");
        mediaSingle.setAttribute("data-node-type", "mediaSingle");
        var media = document.createElement("div");
        media.setAttribute("data-node-type", "media");
        media.setAttribute("data-type", "external");
        media.setAttribute("data-alt", img.getAttribute("alt") || "");
        media.setAttribute("data-url", img.getAttribute("src"));
        mediaSingle.appendChild(media);
        img.parentNode.insertBefore(mediaSingle, img);
        img.parentNode.removeChild(img);
    });
    function validateImageNodeParent(node) {
        var ALLOWED_PARENTS = [
            "LI",
            "UL",
            "OL",
            "TD",
            "TH",
            "TR",
            "TBODY",
            "THEAD",
            "TABLE"
        ];
        if (node === el) return true;
        if (ALLOWED_PARENTS.indexOf(node.nodeName) === -1) return false;
        if (!node.parentNode) return false;
        return validateImageNodeParent(node.parentNode);
    }
    function liftImageNode(node, img) {
        var foundParent = false;
        var parent = node;
        while(!foundParent){
            foundParent = validateImageNodeParent(parent.parentNode);
            if (!foundParent) parent = parent.parentNode;
        }
        var cloned = parent.cloneNode();
        var target = parent !== el ? parent.parentNode : el;
        while(img.nextSibling)cloned.appendChild(img.nextSibling);
        if (node !== parent) while(node.nextSibling)cloned.appendChild(node.nextSibling);
        if (parent.nextSibling) {
            target.insertBefore(cloned, parent.nextSibling);
            target.insertBefore(img, cloned);
        } else {
            target.appendChild(img);
            target.appendChild(cloned);
        }
        /**
     * If the splitting operation results in
     * the old parent being empty, remove it
     */ if (node.childNodes.length === 0) node.parentNode.removeChild(node);
        /**
     * Remove cloned element if it's empty.
     */ if (cloned.childNodes.length === 0) cloned.parentNode.removeChild(cloned);
    }
    return el;
}

});

parcelRegister("6INad", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e4cfd0af9cafb2b$export$2e2bcd8739ae039; });
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/tableSerializer.ts
// If changes are made to this file, please make the same update in the linked file.
var $4e4cfd0af9cafb2b$var$isHeaderRow = function isHeaderRow(row) {
    return row.child(0).type.name === "tableHeader";
};
var $4e4cfd0af9cafb2b$var$isHeaderRowPresent = function isHeaderRowPresent(table) {
    var headerRowPresent = false;
    table.content.forEach(function(row) {
        if ($4e4cfd0af9cafb2b$var$isHeaderRow(row)) headerRowPresent = true;
    });
    return headerRowPresent;
};
var $4e4cfd0af9cafb2b$var$renderNode = function renderNode(state, node, index) {
    if (index > 0) state.write(" ");
    node.content.forEach(function(child, i) {
        if (child.isTextblock || child.type.name === "mediaSingle") {
            if (i > 0) state.write(" ");
            state.context.insideTable = true;
            state.renderInline(child);
            state.context.insideTable = false;
        } else renderNode(state, child, i);
    });
};
var $4e4cfd0af9cafb2b$var$renderInlineContent = function renderInlineContent(state, node) {
    state.write("| ");
    $4e4cfd0af9cafb2b$var$renderNode(state, node, 0);
    state.write(" ");
};
var $4e4cfd0af9cafb2b$export$2e2bcd8739ae039 = {
    table: function table(state, node) {
        if ($4e4cfd0af9cafb2b$var$isHeaderRowPresent(node)) {
            node.content.forEach(function(child, i) {
                return state.render(child, node, i);
            });
            state.closeBlock(node);
        }
    },
    tableRow: function tableRow(state, node) {
        node.content.forEach(function(child, i) {
            state.render(child, node, i);
        });
        state.write("|");
        state.ensureNewLine();
        if ($4e4cfd0af9cafb2b$var$isHeaderRow(node)) {
            for(var i = 0; i < node.childCount; i++)state.write("| --- ");
            state.write("|");
            state.ensureNewLine();
        }
    },
    tableHeader: $4e4cfd0af9cafb2b$var$renderInlineContent,
    tableCell: $4e4cfd0af9cafb2b$var$renderInlineContent
};

});

parcelRegister("gHyMv", function(module, exports) {

$parcel$export(module.exports, "resolveOrder", function () { return $c28ba45438f27723$export$d445360e2a3c026b; });
$parcel$export(module.exports, "getOrderFromOrderedListNode", function () { return $c28ba45438f27723$export$cbefb5b89ef0719f; });
$parcel$export(module.exports, "getItemCounterDigitsSize", function () { return $c28ba45438f27723$export$320582fc14ba1e0f; });
$parcel$export(module.exports, "isListNode", function () { return $c28ba45438f27723$export$a7d7d2b9ba4d4dbb; });
$parcel$export(module.exports, "isParagraphNode", function () { return $c28ba45438f27723$export$35f600abfe6f0127; });
$parcel$export(module.exports, "isListItemNode", function () { return $c28ba45438f27723$export$2ddb0a75547407f6; });
$parcel$export(module.exports, "isBulletList", function () { return $c28ba45438f27723$export$35b2f400604e700; });
$parcel$export(module.exports, "isOrderedList", function () { return $c28ba45438f27723$export$6e4e1502c6d9e5b8; });
$parcel$export(module.exports, "isOrderedListContinuous", function () { return $c28ba45438f27723$export$a265e5f4220d0409; });
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/list.ts
// If changes are made to this file, please make the same update in the linked file.
var $c28ba45438f27723$export$8ef94ae42a3729bd = 1;
var $c28ba45438f27723$export$d445360e2a3c026b = function resolveOrder(order) {
    var num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
var $c28ba45438f27723$export$cbefb5b89ef0719f = function getOrderFromOrderedListNode(orderedListNode) {
    var _orderedListNode$attr, _resolveOrder;
    var order = orderedListNode === null || orderedListNode === void 0 || (_orderedListNode$attr = orderedListNode.attrs) === null || _orderedListNode$attr === void 0 ? void 0 : _orderedListNode$attr.order;
    return (_resolveOrder = $c28ba45438f27723$export$d445360e2a3c026b(order)) !== null && _resolveOrder !== void 0 ? _resolveOrder : $c28ba45438f27723$export$8ef94ae42a3729bd;
};
var $c28ba45438f27723$export$320582fc14ba1e0f = function getItemCounterDigitsSize(options) {
    var _resolveOrder2, _String;
    var order = (_resolveOrder2 = $c28ba45438f27723$export$d445360e2a3c026b(options.order)) !== null && _resolveOrder2 !== void 0 ? _resolveOrder2 : $c28ba45438f27723$export$8ef94ae42a3729bd;
    var itemsCount = typeof options.itemsCount === "number" ? options.itemsCount : 0;
    var largestCounter = order + (itemsCount - 1);
    return (_String = String(largestCounter)) === null || _String === void 0 || (_String = _String.split(".")) === null || _String === void 0 || (_String = _String[0]) === null || _String === void 0 ? void 0 : _String.length;
};
function $c28ba45438f27723$export$a7d7d2b9ba4d4dbb(node) {
    return Boolean(node && node.type && [
        "orderedList",
        "bulletList"
    ].includes(node.type.name));
}
function $c28ba45438f27723$export$35f600abfe6f0127(node) {
    return Boolean(node && node.type && "paragraph" === node.type.name);
}
function $c28ba45438f27723$export$2ddb0a75547407f6(node) {
    return Boolean(node && node.type && "listItem" === node.type.name);
}
function $c28ba45438f27723$export$35b2f400604e700(node) {
    return Boolean(node && node.type && "bulletList" === node.type.name);
}
function $c28ba45438f27723$export$6e4e1502c6d9e5b8(node) {
    return Boolean(node && node.type && "orderedList" === node.type.name);
}
var $c28ba45438f27723$export$a265e5f4220d0409 = function isOrderedListContinuous(firstOrderedList, secondOrderedList) {
    if (!($c28ba45438f27723$export$6e4e1502c6d9e5b8(firstOrderedList) && $c28ba45438f27723$export$6e4e1502c6d9e5b8(secondOrderedList))) return false;
    return $c28ba45438f27723$export$cbefb5b89ef0719f(firstOrderedList) + firstOrderedList.childCount === $c28ba45438f27723$export$cbefb5b89ef0719f(secondOrderedList);
};

});



parcelRegister("3T7XD", function(module, exports) {

$parcel$export(module.exports, "JSONTransformer", function () { return $2d4caf09881b5dc6$export$98cb1d9308d0944d; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $340K4 = parcelRequire("340K4");

var $lOQkO = parcelRequire("lOQkO");

var $kFnE9 = parcelRequire("kFnE9");

var $7ojd4 = parcelRequire("7ojd4");

var $bKgNx = parcelRequire("bKgNx");
var $gD0YM = parcelRequire("gD0YM");
var $ffqiL = parcelRequire("ffqiL");
var $fngjO = parcelRequire("fngjO");
var $3BmiG = parcelRequire("3BmiG");
var $eHCwG = parcelRequire("eHCwG");
var $3P63C = parcelRequire("3P63C");
var $8Hxfq = parcelRequire("8Hxfq");
var $37tHX = parcelRequire("37tHX");

var $hSMmv = parcelRequire("hSMmv");

var $aY5Lw = parcelRequire("aY5Lw");

var $2JD1j = parcelRequire("2JD1j");
function $2d4caf09881b5dc6$var$_toPropertyKey(t) {
    var i = $2d4caf09881b5dc6$var$_toPrimitive(t, "string");
    return "symbol" == (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(i) ? i : String(i);
}
function $2d4caf09881b5dc6$var$_toPrimitive(t, r) {
    if ("object" != (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2d4caf09881b5dc6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2d4caf09881b5dc6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2d4caf09881b5dc6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2d4caf09881b5dc6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2d4caf09881b5dc6$export$933e6445c497ffd5 = /*#__PURE__*/ function(SchemaStage) {
    SchemaStage["FINAL"] = "final";
    SchemaStage["STAGE_0"] = "stage0";
    return SchemaStage;
}({});
var $2d4caf09881b5dc6$var$isType = function isType(type) {
    return function(node) {
        return node.type.name === type;
    };
};
var $2d4caf09881b5dc6$var$isCodeBlock = $2d4caf09881b5dc6$var$isType("codeBlock");
var $2d4caf09881b5dc6$var$isMediaNode = $2d4caf09881b5dc6$var$isType("media");
var $2d4caf09881b5dc6$var$isMediaInline = $2d4caf09881b5dc6$var$isType("mediaInline");
var $2d4caf09881b5dc6$var$isMediaSingleNode = $2d4caf09881b5dc6$var$isType("mediaSingle");
var $2d4caf09881b5dc6$var$isMentionNode = $2d4caf09881b5dc6$var$isType("mention");
var $2d4caf09881b5dc6$var$isParagraph = $2d4caf09881b5dc6$var$isType("paragraph");
var $2d4caf09881b5dc6$var$isHeading = $2d4caf09881b5dc6$var$isType("heading");
var $2d4caf09881b5dc6$var$isTable = $2d4caf09881b5dc6$var$isType("table");
var $2d4caf09881b5dc6$var$isTableCell = $2d4caf09881b5dc6$var$isType("tableCell");
var $2d4caf09881b5dc6$var$isTableHeader = $2d4caf09881b5dc6$var$isType("tableHeader");
var $2d4caf09881b5dc6$var$isLinkMark = $2d4caf09881b5dc6$var$isType("link");
var $2d4caf09881b5dc6$var$isUnsupportedMark = $2d4caf09881b5dc6$var$isType("unsupportedMark");
var $2d4caf09881b5dc6$var$isUnsupportedNodeAttributeMark = $2d4caf09881b5dc6$var$isType("unsupportedNodeAttribute");
var $2d4caf09881b5dc6$var$isExpand = $2d4caf09881b5dc6$var$isType("expand");
var $2d4caf09881b5dc6$var$isNestedExpand = $2d4caf09881b5dc6$var$isType("nestedExpand");
var $2d4caf09881b5dc6$var$isUnsupportedNode = function isUnsupportedNode(node) {
    return $2d4caf09881b5dc6$var$isType("unsupportedBlock")(node) || $2d4caf09881b5dc6$var$isType("unsupportedInline")(node);
};
var $2d4caf09881b5dc6$var$isDataConsumer = $2d4caf09881b5dc6$var$isType("dataConsumer");
var $2d4caf09881b5dc6$var$isFragmentMark = $2d4caf09881b5dc6$var$isType("fragment");
var $2d4caf09881b5dc6$var$filterNull = function filterNull(subject) {
    var output = $2d4caf09881b5dc6$var$_objectSpread({}, subject);
    for(var key in output){
        var current = output[key];
        if (current === null) {
            var _output = output, unusedKey = _output[key], filteredObj = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_output, [
                key
            ].map($2d4caf09881b5dc6$var$_toPropertyKey));
            output = filteredObj;
        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(current) === "object" && !Array.isArray(current)) output[key] = filterNull(current);
    }
    return output;
};
var $2d4caf09881b5dc6$var$createDocFromContent = function createDocFromContent(content) {
    return {
        version: 1,
        type: "doc",
        content: content || []
    };
};
var $2d4caf09881b5dc6$var$emptyDoc = $2d4caf09881b5dc6$var$createDocFromContent([
    {
        type: "paragraph",
        content: []
    }
]);
var $2d4caf09881b5dc6$var$toJSON = function toJSON(node) {
    var obj = {
        type: node.type.name
    };
    if ($2d4caf09881b5dc6$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($2d4caf09881b5dc6$var$isMediaNode(node)) obj.attrs = (0, $3P63C.toJSON)(node).attrs;
    else if ($2d4caf09881b5dc6$var$isMediaSingleNode(node)) obj.attrs = (0, $eHCwG.toJSON)(node).attrs;
    else if ($2d4caf09881b5dc6$var$isMediaInline(node)) obj.attrs = (0, $3P63C.toJSON)(node).attrs;
    else if ($2d4caf09881b5dc6$var$isMentionNode(node)) obj.attrs = (0, $8Hxfq.toJSON)(node).attrs;
    else if ($2d4caf09881b5dc6$var$isCodeBlock(node)) obj.attrs = (0, $bKgNx.toJSON)(node).attrs;
    else if ($2d4caf09881b5dc6$var$isTable(node)) obj.attrs = (0, $37tHX.tableToJSON)(node).attrs;
    else if ($2d4caf09881b5dc6$var$isTableCell(node)) obj.attrs = (0, $37tHX.toJSONTableCell)(node).attrs;
    else if ($2d4caf09881b5dc6$var$isTableHeader(node)) obj.attrs = (0, $37tHX.toJSONTableHeader)(node).attrs;
    else if ($2d4caf09881b5dc6$var$isExpand(node) || $2d4caf09881b5dc6$var$isNestedExpand(node)) obj.attrs = (0, $ffqiL.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $2d4caf09881b5dc6$var$filterNull(obj.attrs);
    // Remove the attrs property if it's empty, this is currently limited to paragraph nodes.
    if ($2d4caf09881b5dc6$var$isParagraph(node) && obj.attrs && !Object.keys(obj.attrs).length) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach(function(child) {
        obj.content = obj.content || [];
        obj.content.push(toJSON(child));
    });
    if ($2d4caf09881b5dc6$var$isParagraph(node) || $2d4caf09881b5dc6$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        var parsedMarks = node.marks.map(function(mark) {
            if ($2d4caf09881b5dc6$var$isUnsupportedMark(mark)) return $2d4caf09881b5dc6$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($2d4caf09881b5dc6$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($2d4caf09881b5dc6$var$isLinkMark(mark)) return (0, $3BmiG.toJSON)(mark);
            else if ($2d4caf09881b5dc6$var$isDataConsumer(mark)) {
                var _serialised$attrs$sou;
                var serialised = (0, $gD0YM.toJSON)(mark);
                return !serialised.attrs.sources || ((_serialised$attrs$sou = serialised.attrs.sources) === null || _serialised$attrs$sou === void 0 ? void 0 : _serialised$attrs$sou.length) === 0 ? null : serialised;
            } else if ($2d4caf09881b5dc6$var$isFragmentMark(mark)) {
                var fragmentMark = (0, $fngjO.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter(function(maybeMark) {
            return maybeMark !== null;
        });
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = (parsedMarks === null || parsedMarks === void 0 ? void 0 : parsedMarks.length) > 0 ? parsedMarks : undefined;
        var nodeAttributeMark = node.marks.find($2d4caf09881b5dc6$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = $2d4caf09881b5dc6$var$_objectSpread({}, $2d4caf09881b5dc6$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj));
    }
    return obj;
};
var $2d4caf09881b5dc6$var$canOverrideMark = function canOverrideMark(mark, existingMarks) {
    if (existingMarks.some(function(e) {
        return mark.attrs.originalValue.type === e.type.name;
    })) return (0, $aY5Lw.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
var $2d4caf09881b5dc6$var$getUnwrappedNodeAttributes = function getUnwrappedNodeAttributes(node, mark, obj) {
    var nodeAttributes = node.type.spec.attrs;
    var attributes = $2d4caf09881b5dc6$var$_objectSpread($2d4caf09881b5dc6$var$_objectSpread({}, mark.attrs.unsupported), obj.attrs);
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        var attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return $2d4caf09881b5dc6$var$_objectSpread($2d4caf09881b5dc6$var$_objectSpread({}, attributes), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, key, mark.attrs.unsupported[key]));
        }
    }
    return attributes;
};
var $2d4caf09881b5dc6$export$98cb1d9308d0944d = /*#__PURE__*/ function() {
    function JSONTransformer() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, JSONTransformer);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(JSONTransformer, [
        {
            key: "encode",
            value: function encode(node) {
                var content = [];
                node.content.forEach(function(child) {
                    content.push((0, $2JD1j.sanitizeNode)($2d4caf09881b5dc6$var$toJSON(child)));
                });
                if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($7ojd4)))(content, $2d4caf09881b5dc6$var$emptyDoc.content)) return $2d4caf09881b5dc6$var$createDocFromContent([]);
                return $2d4caf09881b5dc6$var$createDocFromContent(content);
            }
        },
        {
            key: "internalParse",
            value: function internalParse(content) {
                var stage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $2d4caf09881b5dc6$export$933e6445c497ffd5.FINAL;
                var schema = (0, $hSMmv.getSchemaBasedOnStage)(stage);
                var doc = schema.nodeFromJSON(content);
                doc.check();
                return doc;
            }
        },
        {
            key: "parse",
            value: function parse(content, stage) {
                if (content.type !== "doc") throw new Error("Expected content format to be ADF");
                if (!content.content || content.content.length === 0) return this.internalParse($2d4caf09881b5dc6$var$emptyDoc, stage);
                return this.internalParse(content, stage);
            }
        },
        {
            key: "encodeNode",
            value: function encodeNode(node) {
                return (0, $2JD1j.sanitizeNode)($2d4caf09881b5dc6$var$toJSON(node));
            }
        }
    ]);
    return JSONTransformer;
}();

});
parcelRegister("7ojd4", function(module, exports) {

var $6Ewzi = parcelRequire("6Ewzi");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $5619acf7aa80f443$var$isEqual(value, other) {
    return $6Ewzi(value, other);
}
module.exports = $5619acf7aa80f443$var$isEqual;

});
parcelRegister("6Ewzi", function(module, exports) {

var $dkRJD = parcelRequire("dkRJD");

var $fSpTQ = parcelRequire("fSpTQ");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $4d7fbde53575defa$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$fSpTQ(value) && !$fSpTQ(other)) return value !== value && other !== other;
    return $dkRJD(value, other, bitmask, customizer, $4d7fbde53575defa$var$baseIsEqual, stack);
}
module.exports = $4d7fbde53575defa$var$baseIsEqual;

});
parcelRegister("dkRJD", function(module, exports) {

var $dF7QF = parcelRequire("dF7QF");

var $7LTUD = parcelRequire("7LTUD");

var $j5M09 = parcelRequire("j5M09");

var $7ya9i = parcelRequire("7ya9i");

var $fskeO = parcelRequire("fskeO");

var $lsPUZ = parcelRequire("lsPUZ");

var $bObB2 = parcelRequire("bObB2");

var $bwDQt = parcelRequire("bwDQt");
/** Used to compose bitmasks for value comparisons. */ var $9b56d341a21693ab$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $9b56d341a21693ab$var$argsTag = "[object Arguments]", $9b56d341a21693ab$var$arrayTag = "[object Array]", $9b56d341a21693ab$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $9b56d341a21693ab$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9b56d341a21693ab$var$hasOwnProperty = $9b56d341a21693ab$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $9b56d341a21693ab$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $lsPUZ(object), othIsArr = $lsPUZ(other), objTag = objIsArr ? $9b56d341a21693ab$var$arrayTag : $fskeO(object), othTag = othIsArr ? $9b56d341a21693ab$var$arrayTag : $fskeO(other);
    objTag = objTag == $9b56d341a21693ab$var$argsTag ? $9b56d341a21693ab$var$objectTag : objTag;
    othTag = othTag == $9b56d341a21693ab$var$argsTag ? $9b56d341a21693ab$var$objectTag : othTag;
    var objIsObj = objTag == $9b56d341a21693ab$var$objectTag, othIsObj = othTag == $9b56d341a21693ab$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $bObB2(object)) {
        if (!$bObB2(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $dF7QF);
        return objIsArr || $bwDQt(object) ? $7LTUD(object, other, bitmask, customizer, equalFunc, stack) : $j5M09(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $9b56d341a21693ab$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $9b56d341a21693ab$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $9b56d341a21693ab$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $dF7QF);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $dF7QF);
    return $7ya9i(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $9b56d341a21693ab$var$baseIsEqualDeep;

});
parcelRegister("7LTUD", function(module, exports) {

var $aOYKK = parcelRequire("aOYKK");

var $9h4bV = parcelRequire("9h4bV");

var $8a1Kn = parcelRequire("8a1Kn");
/** Used to compose bitmasks for value comparisons. */ var $5a884b40eaaec8a6$var$COMPARE_PARTIAL_FLAG = 1, $5a884b40eaaec8a6$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $5a884b40eaaec8a6$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $5a884b40eaaec8a6$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $5a884b40eaaec8a6$var$COMPARE_UNORDERED_FLAG ? new $aOYKK : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$9h4bV(other, function(othValue, othIndex) {
                if (!$8a1Kn(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = $5a884b40eaaec8a6$var$equalArrays;

});
parcelRegister("aOYKK", function(module, exports) {

var $brfVP = parcelRequire("brfVP");

var $jrwKM = parcelRequire("jrwKM");

var $jJNMC = parcelRequire("jJNMC");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $7e0db32c9ee26d23$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $brfVP;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$7e0db32c9ee26d23$var$SetCache.prototype.add = $7e0db32c9ee26d23$var$SetCache.prototype.push = $jrwKM;
$7e0db32c9ee26d23$var$SetCache.prototype.has = $jJNMC;
module.exports = $7e0db32c9ee26d23$var$SetCache;

});
parcelRegister("jrwKM", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $e279f21cf376c7e6$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $e279f21cf376c7e6$var$setCacheAdd(value) {
    this.__data__.set(value, $e279f21cf376c7e6$var$HASH_UNDEFINED);
    return this;
}
module.exports = $e279f21cf376c7e6$var$setCacheAdd;

});

parcelRegister("jJNMC", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $e5e8d62c69fd7f65$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $e5e8d62c69fd7f65$var$setCacheHas;

});


parcelRegister("9h4bV", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $6c08f3e0702c5b30$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $6c08f3e0702c5b30$var$arraySome;

});

parcelRegister("8a1Kn", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $5f109cd5ea6ee9d9$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $5f109cd5ea6ee9d9$var$cacheHas;

});


parcelRegister("j5M09", function(module, exports) {

var $lgMoJ = parcelRequire("lgMoJ");

var $l4waM = parcelRequire("l4waM");

var $c3Max = parcelRequire("c3Max");

var $7LTUD = parcelRequire("7LTUD");

var $cm5WH = parcelRequire("cm5WH");

var $jO8iW = parcelRequire("jO8iW");
/** Used to compose bitmasks for value comparisons. */ var $de63b80b72ed9d83$var$COMPARE_PARTIAL_FLAG = 1, $de63b80b72ed9d83$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $de63b80b72ed9d83$var$boolTag = "[object Boolean]", $de63b80b72ed9d83$var$dateTag = "[object Date]", $de63b80b72ed9d83$var$errorTag = "[object Error]", $de63b80b72ed9d83$var$mapTag = "[object Map]", $de63b80b72ed9d83$var$numberTag = "[object Number]", $de63b80b72ed9d83$var$regexpTag = "[object RegExp]", $de63b80b72ed9d83$var$setTag = "[object Set]", $de63b80b72ed9d83$var$stringTag = "[object String]", $de63b80b72ed9d83$var$symbolTag = "[object Symbol]";
var $de63b80b72ed9d83$var$arrayBufferTag = "[object ArrayBuffer]", $de63b80b72ed9d83$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $de63b80b72ed9d83$var$symbolProto = $lgMoJ ? $lgMoJ.prototype : undefined, $de63b80b72ed9d83$var$symbolValueOf = $de63b80b72ed9d83$var$symbolProto ? $de63b80b72ed9d83$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $de63b80b72ed9d83$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $de63b80b72ed9d83$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $de63b80b72ed9d83$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $l4waM(object), new $l4waM(other))) return false;
            return true;
        case $de63b80b72ed9d83$var$boolTag:
        case $de63b80b72ed9d83$var$dateTag:
        case $de63b80b72ed9d83$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $c3Max(+object, +other);
        case $de63b80b72ed9d83$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $de63b80b72ed9d83$var$regexpTag:
        case $de63b80b72ed9d83$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $de63b80b72ed9d83$var$mapTag:
            var convert = $cm5WH;
        case $de63b80b72ed9d83$var$setTag:
            var isPartial = bitmask & $de63b80b72ed9d83$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $jO8iW);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $de63b80b72ed9d83$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $7LTUD(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $de63b80b72ed9d83$var$symbolTag:
            if ($de63b80b72ed9d83$var$symbolValueOf) return $de63b80b72ed9d83$var$symbolValueOf.call(object) == $de63b80b72ed9d83$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $de63b80b72ed9d83$var$equalByTag;

});
parcelRegister("cm5WH", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $8fec26d734f4e929$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $8fec26d734f4e929$var$mapToArray;

});

parcelRegister("jO8iW", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $e6b920f59539a72e$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $e6b920f59539a72e$var$setToArray;

});


parcelRegister("7ya9i", function(module, exports) {

var $fQ5II = parcelRequire("fQ5II");
/** Used to compose bitmasks for value comparisons. */ var $57f394c494b21973$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $57f394c494b21973$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $57f394c494b21973$var$hasOwnProperty = $57f394c494b21973$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $57f394c494b21973$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $57f394c494b21973$var$COMPARE_PARTIAL_FLAG, objProps = $fQ5II(object), objLength = objProps.length, othProps = $fQ5II(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $57f394c494b21973$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = $57f394c494b21973$var$equalObjects;

});
parcelRegister("fQ5II", function(module, exports) {

var $l3tXM = parcelRequire("l3tXM");

var $fcXxf = parcelRequire("fcXxf");

var $196L7 = parcelRequire("196L7");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $b880263f3aa824cc$var$getAllKeys(object) {
    return $l3tXM(object, $196L7, $fcXxf);
}
module.exports = $b880263f3aa824cc$var$getAllKeys;

});
parcelRegister("l3tXM", function(module, exports) {

var $c6wCA = parcelRequire("c6wCA");

var $lsPUZ = parcelRequire("lsPUZ");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $f5411ed5c409527c$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $lsPUZ(object) ? result : $c6wCA(result, symbolsFunc(object));
}
module.exports = $f5411ed5c409527c$var$baseGetAllKeys;

});
parcelRegister("c6wCA", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $8cff597de8d6ff2b$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $8cff597de8d6ff2b$var$arrayPush;

});


parcelRegister("fcXxf", function(module, exports) {

var $7C7A9 = parcelRequire("7C7A9");

var $bhYMM = parcelRequire("bhYMM");
/** Used for built-in method references. */ var $b12628739881b1df$var$objectProto = Object.prototype;
/** Built-in value references. */ var $b12628739881b1df$var$propertyIsEnumerable = $b12628739881b1df$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b12628739881b1df$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $b12628739881b1df$var$getSymbols = !$b12628739881b1df$var$nativeGetSymbols ? $bhYMM : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $7C7A9($b12628739881b1df$var$nativeGetSymbols(object), function(symbol) {
        return $b12628739881b1df$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $b12628739881b1df$var$getSymbols;

});
parcelRegister("7C7A9", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $58b1f6ad21085869$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $58b1f6ad21085869$var$arrayFilter;

});

parcelRegister("bhYMM", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $83806f0d176ec403$var$stubArray() {
    return [];
}
module.exports = $83806f0d176ec403$var$stubArray;

});


parcelRegister("196L7", function(module, exports) {

var $fkQ3E = parcelRequire("fkQ3E");

var $44BoW = parcelRequire("44BoW");

var $d1hHV = parcelRequire("d1hHV");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $0d5bdfed36a03bec$var$keys(object) {
    return $d1hHV(object) ? $fkQ3E(object) : $44BoW(object);
}
module.exports = $0d5bdfed36a03bec$var$keys;

});
parcelRegister("44BoW", function(module, exports) {

var $6qnde = parcelRequire("6qnde");

var $8fyZ9 = parcelRequire("8fyZ9");
/** Used for built-in method references. */ var $2f748c423e77969e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2f748c423e77969e$var$hasOwnProperty = $2f748c423e77969e$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $2f748c423e77969e$var$baseKeys(object) {
    if (!$6qnde(object)) return $8fyZ9(object);
    var result = [];
    for(var key in Object(object))if ($2f748c423e77969e$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = $2f748c423e77969e$var$baseKeys;

});
parcelRegister("8fyZ9", function(module, exports) {

var $fIxxp = parcelRequire("fIxxp");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $601adcca931940e4$var$nativeKeys = $fIxxp(Object.keys, Object);
module.exports = $601adcca931940e4$var$nativeKeys;

});





parcelRegister("fskeO", function(module, exports) {

var $5vex8 = parcelRequire("5vex8");

var $fz3Q0 = parcelRequire("fz3Q0");

var $dReYb = parcelRequire("dReYb");

var $1emko = parcelRequire("1emko");

var $85YjV = parcelRequire("85YjV");

var $44oBv = parcelRequire("44oBv");

var $gx0ME = parcelRequire("gx0ME");
/** `Object#toString` result references. */ var $b4092b63ac2e11ad$var$mapTag = "[object Map]", $b4092b63ac2e11ad$var$objectTag = "[object Object]", $b4092b63ac2e11ad$var$promiseTag = "[object Promise]", $b4092b63ac2e11ad$var$setTag = "[object Set]", $b4092b63ac2e11ad$var$weakMapTag = "[object WeakMap]";
var $b4092b63ac2e11ad$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $b4092b63ac2e11ad$var$dataViewCtorString = $gx0ME($5vex8), $b4092b63ac2e11ad$var$mapCtorString = $gx0ME($fz3Q0), $b4092b63ac2e11ad$var$promiseCtorString = $gx0ME($dReYb), $b4092b63ac2e11ad$var$setCtorString = $gx0ME($1emko), $b4092b63ac2e11ad$var$weakMapCtorString = $gx0ME($85YjV);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $b4092b63ac2e11ad$var$getTag = $44oBv;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($5vex8 && $b4092b63ac2e11ad$var$getTag(new $5vex8(new ArrayBuffer(1))) != $b4092b63ac2e11ad$var$dataViewTag || $fz3Q0 && $b4092b63ac2e11ad$var$getTag(new $fz3Q0) != $b4092b63ac2e11ad$var$mapTag || $dReYb && $b4092b63ac2e11ad$var$getTag($dReYb.resolve()) != $b4092b63ac2e11ad$var$promiseTag || $1emko && $b4092b63ac2e11ad$var$getTag(new $1emko) != $b4092b63ac2e11ad$var$setTag || $85YjV && $b4092b63ac2e11ad$var$getTag(new $85YjV) != $b4092b63ac2e11ad$var$weakMapTag) $b4092b63ac2e11ad$var$getTag = function(value) {
    var result = $44oBv(value), Ctor = result == $b4092b63ac2e11ad$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $gx0ME(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $b4092b63ac2e11ad$var$dataViewCtorString:
            return $b4092b63ac2e11ad$var$dataViewTag;
        case $b4092b63ac2e11ad$var$mapCtorString:
            return $b4092b63ac2e11ad$var$mapTag;
        case $b4092b63ac2e11ad$var$promiseCtorString:
            return $b4092b63ac2e11ad$var$promiseTag;
        case $b4092b63ac2e11ad$var$setCtorString:
            return $b4092b63ac2e11ad$var$setTag;
        case $b4092b63ac2e11ad$var$weakMapCtorString:
            return $b4092b63ac2e11ad$var$weakMapTag;
    }
    return result;
};
module.exports = $b4092b63ac2e11ad$var$getTag;

});
parcelRegister("5vex8", function(module, exports) {

var $aRcAK = parcelRequire("aRcAK");

var $bR8DU = parcelRequire("bR8DU");
/* Built-in method references that are verified to be native. */ var $401b1f041493469d$var$DataView = $aRcAK($bR8DU, "DataView");
module.exports = $401b1f041493469d$var$DataView;

});

parcelRegister("dReYb", function(module, exports) {

var $aRcAK = parcelRequire("aRcAK");

var $bR8DU = parcelRequire("bR8DU");
/* Built-in method references that are verified to be native. */ var $a16bd642d7c3a951$var$Promise = $aRcAK($bR8DU, "Promise");
module.exports = $a16bd642d7c3a951$var$Promise;

});

parcelRegister("1emko", function(module, exports) {

var $aRcAK = parcelRequire("aRcAK");

var $bR8DU = parcelRequire("bR8DU");
/* Built-in method references that are verified to be native. */ var $0e586b1634a67846$var$Set = $aRcAK($bR8DU, "Set");
module.exports = $0e586b1634a67846$var$Set;

});

parcelRegister("85YjV", function(module, exports) {

var $aRcAK = parcelRequire("aRcAK");

var $bR8DU = parcelRequire("bR8DU");
/* Built-in method references that are verified to be native. */ var $5e4d94b97a8c40db$var$WeakMap = $aRcAK($bR8DU, "WeakMap");
module.exports = $5e4d94b97a8c40db$var$WeakMap;

});





parcelRegister("aY5Lw", function(module, exports) {

$parcel$export(module.exports, "markOverrideRuleFor", function () { return $7fc3fadfdf28c429$export$28e4e3c024cce988; });
var $7fc3fadfdf28c429$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: function canOverrideUnsupportedMark() {
        return true;
    }
};
var $7fc3fadfdf28c429$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: function canOverrideUnsupportedMark() {
        return false;
    }
};
var $7fc3fadfdf28c429$export$28e4e3c024cce988 = function markOverrideRuleFor(type) {
    switch(type){
        case "link":
        case "em":
        case "strong":
        case "strike":
        case "subsup":
        case "underline":
        case "code":
        case "textColor":
        case "backgroundColor":
        case "confluenceInlineComment":
        case "breakout":
        case "alignment":
        case "indentation":
        case "border":
            return $7fc3fadfdf28c429$var$defaultAllowOverrideBehaviour;
        default:
            return $7fc3fadfdf28c429$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});

parcelRegister("2JD1j", function(module, exports) {

$parcel$export(module.exports, "sanitizeNode", function () { return $1fde0d5b2e33b063$export$48b382180baf8e88; });

var $kFnE9 = parcelRequire("kFnE9");

var $cvEf4 = parcelRequire("cvEf4");

var $ldHrL = parcelRequire("ldHrL");
function $1fde0d5b2e33b063$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1fde0d5b2e33b063$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1fde0d5b2e33b063$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1fde0d5b2e33b063$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1fde0d5b2e33b063$export$48b382180baf8e88(json) {
    var sanitizedJSON = (0, $cvEf4.traverse)(json, {
        text: function text(node) {
            if (!node || !Array.isArray(node.marks)) return node;
            return $1fde0d5b2e33b063$var$_objectSpread($1fde0d5b2e33b063$var$_objectSpread({}, node), {}, {
                marks: node.marks.filter(function(mark) {
                    return mark.type !== "typeAheadQuery";
                })
            });
        },
        status: function status(node) {
            if (node.attrs && !!node.attrs.text) return (0, $ldHrL.removeNonAnnotationMarks)(node);
            return false; // empty status
        },
        caption: function caption(node) {
            if (node.content) return node;
            return false; // empty caption
        },
        emoji: (0, $ldHrL.removeNonAnnotationMarks),
        mention: (0, $ldHrL.removeNonAnnotationMarks),
        date: (0, $ldHrL.removeNonAnnotationMarks),
        hardBreak: (0, $ldHrL.removeMarks),
        inlineCard: (0, $ldHrL.removeNonAnnotationMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("cvEf4", function(module, exports) {

$parcel$export(module.exports, "traverse", function () { return $91b7988a3ed33203$export$df3f009e3d155b20; });

var $kFnE9 = parcelRequire("kFnE9");
function $91b7988a3ed33203$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $91b7988a3ed33203$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $91b7988a3ed33203$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $91b7988a3ed33203$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $91b7988a3ed33203$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $91b7988a3ed33203$export$df3f009e3d155b20(adf, visitors) {
    if (!$91b7988a3ed33203$export$735cfea22ce30f58(visitors)) throw new Error('Visitors are not valid: "'.concat(Object.keys(visitors).join(", "), '"'));
    return $91b7988a3ed33203$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $91b7988a3ed33203$var$traverseNode(adfNode, parent, visitors, index, depth) {
    var visitor = visitors[adfNode.type] || visitors["any"];
    var newNode = $91b7988a3ed33203$var$_objectSpread({}, adfNode);
    if (visitor) {
        var processedNode = visitor($91b7988a3ed33203$var$_objectSpread({}, newNode), parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce(function(acc, node, idx) {
        if (!node) return acc;
        var processedNode = $91b7988a3ed33203$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});

parcelRegister("ldHrL", function(module, exports) {

$parcel$export(module.exports, "removeMarks", function () { return $f72c837d9bd32457$export$9bf001d8ef76e497; });
$parcel$export(module.exports, "removeNonAnnotationMarks", function () { return $f72c837d9bd32457$export$8cae9126fc577085; });

var $kFnE9 = parcelRequire("kFnE9");
function $f72c837d9bd32457$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f72c837d9bd32457$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f72c837d9bd32457$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f72c837d9bd32457$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f72c837d9bd32457$export$9bf001d8ef76e497(node) {
    var newNode = $f72c837d9bd32457$var$_objectSpread({}, node);
    delete newNode.marks;
    return newNode;
}
function $f72c837d9bd32457$export$8cae9126fc577085(node) {
    var newNode = $f72c837d9bd32457$var$_objectSpread({}, node);
    if (node.marks) newNode.marks = node.marks.filter(function(mark) {
        return mark.type === "annotation";
    });
    return newNode;
}

});






parcelRegister("6XPOs", function(module, exports) {

$parcel$export(module.exports, "getNumOfComments", function () { return $313d4dd1c13246ff$export$97fee359779dc620; });
const $313d4dd1c13246ff$export$97fee359779dc620 = (conversation)=>{
    if (!conversation) return 0;
    return conversation.comments.reduce((count, comment)=>comment.deleted ? count : count + 1, 0);
};

});

parcelRegister("1pgYo", function(module, exports) {

$parcel$export(module.exports, "buildInlineConversations", function () { return $db72029dc379e0e5$export$32e86d99e8fffdb8; });

var $b9iHE = parcelRequire("b9iHE");
const $db72029dc379e0e5$var$isTopLevelInlineComment = (comment)=>!comment.parent && comment.inline;
/**
 * This is a recursive function that uses the map of (comment id -> child comments) to build a thread of comments
 * where the passed comment is the first element and all comments nested below occur after this comment in the thread.
 * @param {Map<number, ApiCommentOrPlaceholder[]>} commentMap - A map of comment id to its list of children
 * @param {ApiCommentOrPlaceholder} comment - The comment to build a thread for
 * @returns {ApiCommentOrPlaceholder[]} - Thread of comments
 */ function $db72029dc379e0e5$var$buildCommentThread(commentMap, comment) {
    // Add passed comment as first element of the list
    const list = [
        comment
    ];
    // Recursive case to add nested comments below this to the resuling list
    if ("id" in comment && commentMap.has(comment.id)) {
        var _commentMap$get;
        const children = (_commentMap$get = commentMap.get(comment.id)) !== null && _commentMap$get !== void 0 ? _commentMap$get : [];
        return [
            comment,
            ...children.flatMap((child)=>$db72029dc379e0e5$var$buildCommentThread(commentMap, child))
        ];
    }
    return list;
}
function $db72029dc379e0e5$export$32e86d99e8fffdb8(allComments, commentDescendantMap, containerId) {
    const topLevelInlineComments = allComments.filter($db72029dc379e0e5$var$isTopLevelInlineComment);
    const conversations = topLevelInlineComments.map((comment)=>$db72029dc379e0e5$var$buildCommentThread(commentDescendantMap, comment));
    function notEmpty(value) {
        return value !== null && value !== undefined;
    }
    const inlineConversations = conversations.map((thread)=>(0, $b9iHE.toConversation)(thread, containerId)).filter(notEmpty);
    return inlineConversations;
}

});



parcelRegister("8MnfV", function(module, exports) {

$parcel$export(module.exports, "getIsNavigationOpen", function () { return $9df28723be6b385c$export$6410756229b22d6c; });
$parcel$export(module.exports, "getIsSearchDrawerOpen", function () { return $9df28723be6b385c$export$850cd80a079998a9; });
$parcel$export(module.exports, "getIsMobileHeaderActive", function () { return $9df28723be6b385c$export$ca2b017e044feab2; });
$parcel$export(module.exports, "getMobileHeaderState", function () { return $9df28723be6b385c$export$dfb276768b1ac05f; });
$parcel$export(module.exports, "getUpToSmallBreakpointState", function () { return $9df28723be6b385c$export$ba67965a43ed2da1; });
$parcel$export(module.exports, "getIsOrgAdmin", function () { return $9df28723be6b385c$export$f746cbc5ac8267a4; });
$parcel$export(module.exports, "getWorkspaceOrgId", function () { return $9df28723be6b385c$export$324e5dd6c090d9c6; });
$parcel$export(module.exports, "getIsWorkspaceSumEnabled", function () { return $9df28723be6b385c$export$fdd59eaed7992dec; });
$parcel$export(module.exports, "getIsWorkspaceAdmin", function () { return $9df28723be6b385c$export$93708d1e08f1a936; });
$parcel$export(module.exports, "getStatusPageBanner", function () { return $9df28723be6b385c$export$ddb429700200a0f8; });
$parcel$export(module.exports, "getSiteMessageBanner", function () { return $9df28723be6b385c$export$fcddcddad856a4b2; });
$parcel$export(module.exports, "getIsSiteMessageActive", function () { return $9df28723be6b385c$export$4ef4c05b646f4940; });
$parcel$export(module.exports, "getSiteMessageFlag", function () { return $9df28723be6b385c$export$9bf57217c2c49ff3; });
$parcel$export(module.exports, "getCombinedBannerAndHorizontalNavHeight", function () { return $9df28723be6b385c$export$34e92ae6a0cba134; });
$parcel$export(module.exports, "getIsOffline", function () { return $9df28723be6b385c$export$e88aad14c693b98e; });
$parcel$export(module.exports, "getRepositoryPageLoadingStatus", function () { return $9df28723be6b385c$export$f1812411515766ca; });
$parcel$export(module.exports, "getCurrentUserEmail", function () { return $9df28723be6b385c$export$c1375bed4480180b; });
$parcel$export(module.exports, "getIsFeedbackModalOpen", function () { return $9df28723be6b385c$export$a3c4a0fba6baf503; });

var $lIZwG = parcelRequire("lIZwG");

var $aXXtM = parcelRequire("aXXtM");

var $aDsOl = parcelRequire("aDsOl");

var $giIwV = parcelRequire("giIwV");

var $7Om57 = parcelRequire("7Om57");

var $7qdXF = parcelRequire("7qdXF");

var $g2R3c = parcelRequire("g2R3c");
const $9df28723be6b385c$export$6410756229b22d6c = (0, $aXXtM.createSelector)((0, $7qdXF.getGlobal), (state)=>state.isNavigationOpen);
const $9df28723be6b385c$export$850cd80a079998a9 = (0, $aXXtM.createSelector)((0, $7qdXF.getGlobal), (state)=>state.isSearchDrawerOpen);
const $9df28723be6b385c$export$ca2b017e044feab2 = (0, $aXXtM.createSelector)((0, $7qdXF.getGlobal), (state)=>state.isMobileHeaderActive);
const $9df28723be6b385c$export$dfb276768b1ac05f = (0, $aXXtM.createSelector)((0, $7qdXF.getGlobal), (state)=>state.mobileHeaderState);
const $9df28723be6b385c$export$ba67965a43ed2da1 = (0, $aXXtM.createSelector)((0, $7qdXF.getGlobal), (state)=>state.isUpToSmallBreakpointActive);
const $9df28723be6b385c$export$f746cbc5ac8267a4 = (0, $aXXtM.createSelector)((0, $7qdXF.getGlobal), (state)=>!!state.isOrgAdmin);
const $9df28723be6b385c$export$324e5dd6c090d9c6 = (0, $aXXtM.createSelector)((0, $7qdXF.getGlobal), (state)=>state.workspaceOrgId);
const $9df28723be6b385c$export$fdd59eaed7992dec = (0, $aXXtM.createSelector)((0, $7qdXF.getGlobal), (state)=>!!state.isWorkspaceSumEnabled);
const $9df28723be6b385c$export$93708d1e08f1a936 = (0, $aXXtM.createSelector)((0, $7qdXF.getGlobal), (state)=>!!state.isWorkspaceAdmin);
const $9df28723be6b385c$export$92df02cfcff26c73 = (state, targetAppearance)=>{
    const siteMessage = (0, $lIZwG.default)(state, "global.siteMessage");
    const currentUser = (0, $g2R3c.getCurrentUser)(state);
    if (!siteMessage || !currentUser) return null;
    return !$9df28723be6b385c$export$ca2b017e044feab2(state) && siteMessage.appearance === targetAppearance && // Banners cannot be dismissed, so we only need to check the "should display" status for Flags.
    (siteMessage.appearance === "banner" || (0, $7Om57.shouldDisplayFlag)(currentUser.uuid, siteMessage.id)) && // Must set this line last, so it returns the siteMessage itself
    siteMessage;
};
const $9df28723be6b385c$export$ddb429700200a0f8 = (state)=>{
    return (0, $lIZwG.default)(state, "global.siteMessageStatuspageIncident", null);
};
const $9df28723be6b385c$export$ab997597317403fd = (state)=>{
    return (0, $lIZwG.default)(state, "global.workspaceBootstrapping", false);
};
const $9df28723be6b385c$export$fcddcddad856a4b2 = (state)=>{
    const isWorkspaceBootstrapping = $9df28723be6b385c$export$ab997597317403fd(state);
    const bootstrappingMessage = {
        id: 0,
        title: "Bootstrap in progress",
        appearance: "banner",
        text: "Workspace setup in progress. Groups and users may not be fully available for multiple hours. This banner will disappear once the process completes, upon page refresh.",
        isIncident: false,
        linkType: "refresh"
    };
    if (isWorkspaceBootstrapping) return bootstrappingMessage;
    const statuspageIncident = $9df28723be6b385c$export$ddb429700200a0f8(state);
    const currentUser = (0, $g2R3c.getCurrentUser)(state);
    if (!currentUser && statuspageIncident) return statuspageIncident;
    const shouldDisplayIncident = statuspageIncident && (0, $7Om57.shouldDisplayIncidentBanner)(currentUser.uuid, statuspageIncident.id);
    if (shouldDisplayIncident) return statuspageIncident;
    return $9df28723be6b385c$export$92df02cfcff26c73(state, "banner");
};
const $9df28723be6b385c$export$4ef4c05b646f4940 = (state)=>!!$9df28723be6b385c$export$fcddcddad856a4b2(state);
const $9df28723be6b385c$export$9bf57217c2c49ff3 = (state)=>$9df28723be6b385c$export$92df02cfcff26c73(state, "flag");
const $9df28723be6b385c$export$34e92ae6a0cba134 = (state, isBeingRenderedInsideMobileNav, consentBannerHeight)=>{
    // Note: the HORIZONTAL_GLOBAL_NAV_HEIGHT is only relevant if *not*
    // being rendered *inside* the mobile nav. This means that the calculation
    // is for a component rendered inside the mobile nav panel, it is not
    // always relevant even if the mobile nav is visible.
    const bannerHeight = $9df28723be6b385c$export$fcddcddad856a4b2(state) ? (0, $giIwV.BANNER_HEIGHT) + consentBannerHeight : consentBannerHeight;
    const horizontalNavHeight = !$9df28723be6b385c$export$ca2b017e044feab2(state) && !isBeingRenderedInsideMobileNav ? (0, $aDsOl.HORIZONTAL_GLOBAL_NAV_HEIGHT) : 0;
    return bannerHeight + horizontalNavHeight;
};
const $9df28723be6b385c$export$e2bc78fcaaf8c7b6 = (0, $aXXtM.createSelector)((0, $7qdXF.getGlobal), (state)=>state.isPageVisible);
const $9df28723be6b385c$export$e88aad14c693b98e = (0, $aXXtM.createSelector)((0, $7qdXF.getGlobal), (state)=>state.isOffline);
const $9df28723be6b385c$export$f1812411515766ca = (0, $aXXtM.createSelector)((0, $7qdXF.getGlobal), (state)=>state.repositoryPageLoadingStatus);
const $9df28723be6b385c$export$c1375bed4480180b = (0, $aXXtM.createSelector)((0, $7qdXF.getGlobal), (state)=>state.currentUserEmail);
const $9df28723be6b385c$export$a3c4a0fba6baf503 = (0, $aXXtM.createSelector)((0, $7qdXF.getGlobal), (state)=>state.isFeedbackModalOpen);

});
parcelRegister("7Om57", function(module, exports) {

$parcel$export(module.exports, "shouldDisplayFlag", function () { return $ead3efed6c66ba86$export$61e558af3055c626; });
$parcel$export(module.exports, "messageDismissed", function () { return $ead3efed6c66ba86$export$e2dfa572149f195b; });
$parcel$export(module.exports, "shouldDisplayIncidentBanner", function () { return $ead3efed6c66ba86$export$5b28d8ceca3a90aa; });
$parcel$export(module.exports, "incidentBannerDismissed", function () { return $ead3efed6c66ba86$export$f8b68af2f263cc25; });

var $h3kk7 = parcelRequire("h3kk7");
const $ead3efed6c66ba86$export$7367158f2f597ab1 = (userId)=>`sitemessage::${userId}`;
const $ead3efed6c66ba86$export$535b613dda3c19b2 = (userId)=>`statuspage-incident::${userId}`;
function $ead3efed6c66ba86$export$61e558af3055c626(userId, messageId) {
    if (!userId) return false;
    const lastDismissedMessageId = (0, $h3kk7.default).get($ead3efed6c66ba86$export$7367158f2f597ab1(userId), 0);
    return lastDismissedMessageId < messageId;
}
function $ead3efed6c66ba86$export$e2dfa572149f195b(userId, messageId) {
    (0, $h3kk7.default).set($ead3efed6c66ba86$export$7367158f2f597ab1(userId), messageId);
}
function $ead3efed6c66ba86$export$5b28d8ceca3a90aa(userId, messageId) {
    if (!userId) return false;
    const dismissedIDs = (0, $h3kk7.default).get($ead3efed6c66ba86$export$535b613dda3c19b2(userId), {});
    return !dismissedIDs[messageId];
}
function $ead3efed6c66ba86$export$f8b68af2f263cc25(userId, messageId) {
    const dismissedIDs = (0, $h3kk7.default).get($ead3efed6c66ba86$export$535b613dda3c19b2(userId), {});
    dismissedIDs[messageId] = true;
    (0, $h3kk7.default).set($ead3efed6c66ba86$export$535b613dda3c19b2(userId), dismissedIDs);
}
const $ead3efed6c66ba86$export$136229fd5910a7cc = (0, $h3kk7.default).disabled;

});


parcelRegister("635SY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7dea5e755ce68012$export$2e2bcd8739ae039; });

var $krbT4 = parcelRequire("krbT4");

var $hVJ0w = parcelRequire("hVJ0w");

var $92WdM = parcelRequire("92WdM");
var $7dea5e755ce68012$export$2e2bcd8739ae039 = {
    api: {
        internal: $krbT4.internal,
        v20: $92WdM.v20
    },
    ui: $hVJ0w.ui,
    external: {
        gettingStarted: "https://confluence.atlassian.com/x/cGsSMw",
        lfsInfo: "https://confluence.atlassian.com/x/RDRmMQ"
    }
};

});
parcelRegister("krbT4", function(module, exports) {

$parcel$export(module.exports, "internal", function () { return $83ae9636b7d991f3$export$454b5eaffc99ebf6; });

var $9H597 = parcelRequire("9H597");
const $83ae9636b7d991f3$var$baseUrl = "!api/internal/repositories";
const $83ae9636b7d991f3$export$454b5eaffc99ebf6 = {
    repositoryMetadataURL (repositoryFullSlug) {
        return `/${$83ae9636b7d991f3$var$baseUrl}/${repositoryFullSlug}/metadata`;
    },
    lfsInfo (repositoryFullSlug, ref, path) {
        const encodedPath = (0, $9H597.encodePath)(path);
        return `/${$83ae9636b7d991f3$var$baseUrl}/${repositoryFullSlug}/lfs-info-by-path/${ref}/${encodedPath}`;
    },
    tree (repositoryFullSlug, ref, params) {
        const { maxDepth: maxDepth = 0, path: path } = params || {};
        const encodedPath = (0, $9H597.encodePath)(path);
        const url = `/${$83ae9636b7d991f3$var$baseUrl}/${repositoryFullSlug}/tree/${ref}/${encodedPath}`;
        const query = (0, $9H597.stringify)({
            max_depth: maxDepth > 0 ? maxDepth : null,
            no_size: 1
        });
        return `${url}${query}`;
    },
    sourceWithMetadata (repositoryFullSlug, ref, path) {
        const encodedPath = (0, $9H597.encodePath)(path);
        return `/${$83ae9636b7d991f3$var$baseUrl}/${repositoryFullSlug}/srcdir-with-metadata/${ref}/${encodedPath}`;
    }
};

});

parcelRegister("hVJ0w", function(module, exports) {

$parcel$export(module.exports, "ui", function () { return $fb4811e78835ddc2$export$5525e5ba287fa6f5; });

var $2KUil = parcelRequire("2KUil");

var $6kaFm = parcelRequire("6kaFm");

var $9H597 = parcelRequire("9H597");
const $fb4811e78835ddc2$export$5525e5ba287fa6f5 = {
    createFile (repositoryFullSlug, params) {
        const { refOrHash: refOrHash, path: path, at: at } = params || {};
        const encodedPath = (0, $9H597.encodePath)(path);
        if (!refOrHash) return `/${repositoryFullSlug}/create-file`;
        const url = `/${repositoryFullSlug}/create-file/${refOrHash}/${encodedPath}`;
        const query = (0, $9H597.stringify)({
            at: at
        });
        return `${url}${query}`;
    },
    diff (repositoryFullSlug, path, spec, params) {
        const { at: at, json: json, applyRouterFix: applyRouterFix = true } = params || {};
        const { source: source, destination: destination } = spec;
        const encodedPath = applyRouterFix ? (0, $6kaFm.safeEncodePath)(path) : (0, $9H597.encodePath)(path);
        const url = `/${repositoryFullSlug}/diff/${encodedPath}`;
        const query = (0, $9H597.stringify)({
            at: at || undefined,
            diff1: source,
            diff2: destination,
            json: json || undefined
        });
        return `${url}${query}`;
    },
    fileHistory (repositoryFullSlug, refOrHash, path, params) {
        const { at: at } = params || {};
        const encodedPath = (0, $6kaFm.safeEncodePath)(path);
        const url = `/${repositoryFullSlug}/history-node/${refOrHash}/${encodedPath}`;
        const query = (0, $9H597.stringify)({
            at: at
        });
        return `${url}${query}`;
    },
    lfsAdmin (repositoryFullSlug) {
        return `/${repositoryFullSlug}/admin/lfs/file-management/`;
    },
    raw (repositoryFullSlug, refOrHash, path, params) {
        const { at: at } = params || {};
        const query = (0, $9H597.stringify)({
            at: at ? at.name : undefined
        });
        const encodedPath = (0, $9H597.encodePath)(path);
        const url = `/${repositoryFullSlug}/raw/${refOrHash}/${encodedPath}`;
        return `${url}${query}`;
    },
    sourceWithRef (repositoryFullSlug, ref, params) {
        // if the ref contains invalid characters (#, /, %), create a link using
        // the hash and the ?at param
        const { path: path } = params || {};
        const nextParams = (0, $2KUil.default)(ref.name) ? {
            path: path,
            refOrHash: ref.name
        } : {
            path: path,
            refOrHash: ref.target.hash,
            at: ref.name
        };
        return $fb4811e78835ddc2$export$5525e5ba287fa6f5.source(repositoryFullSlug, nextParams);
    },
    source (repositoryFullSlug, params) {
        const { connectEditor: connectEditor, connectViewer: connectViewer, refOrHash: refOrHash, path: path = "", at: at, applyRouterFix: applyRouterFix = true } = params || {};
        const encodedPath = applyRouterFix ? (0, $6kaFm.safeEncodePath)(path) : (0, $9H597.encodePath)(path);
        let url = `/${repositoryFullSlug}/src`;
        if (refOrHash) url += `/${refOrHash}/${encodedPath}`;
        const query = (0, $9H597.stringify)({
            at: at,
            editor: connectEditor,
            viewer: connectViewer
        });
        return `${url}${query}`;
    },
    edit (repositoryFullSlug, refOrHash, path, params) {
        const { at: at } = params || {};
        const query = (0, $9H597.stringify)({
            mode: "edit",
            at: at ? at.name : undefined
        });
        const encodedPath = (0, $9H597.encodePath)(path);
        const url = `/${repositoryFullSlug}/src/${refOrHash}/${encodedPath}`;
        return `${url}${query}`;
    },
    blame (repositoryFullSlug, refOrHash, path, params) {
        const { at: at } = params || {};
        const query = (0, $9H597.stringify)({
            at: at ? at.name : undefined
        });
        const encodedPath = (0, $9H597.encodePath)(path);
        const url = `/${repositoryFullSlug}/annotate/${refOrHash}/${encodedPath}`;
        return `${url}${query}`;
    },
    permissions (repositoryFullSlug) {
        return `/${repositoryFullSlug}/admin/access`;
    },
    pipelines (repositoryFullSlug) {
        return `/${repositoryFullSlug}/addon/pipelines-installer/home`;
    }
};

});
parcelRegister("2KUil", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1fb2f13cde293d9$export$2e2bcd8739ae039; });
var $b1fb2f13cde293d9$export$2e2bcd8739ae039 = (refName)=>!/[/#%]/.test(refName);

});

parcelRegister("6kaFm", function(module, exports) {

$parcel$export(module.exports, "safeEncode", function () { return $e1e958e709906a29$export$c094f85f253e4d7d; });
$parcel$export(module.exports, "safeEncodePath", function () { return $e1e958e709906a29$export$5540c78263a7fe27; });
$parcel$export(module.exports, "safeDecode", function () { return $e1e958e709906a29$export$7a47376c130cfeac; });
$parcel$export(module.exports, "safeDecodePath", function () { return $e1e958e709906a29$export$b6ea104c7c46f19c; });
// React router (well, the `history` module inside it) calls `decodeURI` when
// setting a location. This decodes *some* special characters, but not all. So
// we have to do some safety work in order to handle encoded paths:
//
// - Encoding: `history` calls `encodeURI`, but we need to call
//   `encodeURIComponent` to catch all special characters, so we need to sort of
//   encode twice (for now, just a few chars that cause trouble)
//
// - Decoding: The browser back and forward buttons don't go through
//   react router, so the path might already be decoded. So if decoding fails,
//   we'll just try to return the path as-is
//
// To reiterate, this only needs to be done for paths that will touch
// react router; we don't need to safe encode/decode URLs for use in django
//
// See https://github.com/ReactTraining/history/issues/505#issuecomment-359538055
//
//
// ==================================================================================
// This needs investigation, it might not be necessary any longer. Both react router
// and react-resource-router use the history package.
// ==================================================================================
const $e1e958e709906a29$export$c094f85f253e4d7d = (path)=>encodeURIComponent(path.replace(/%/g, "%25").replace(/#/g, "%23"));
const $e1e958e709906a29$export$5540c78263a7fe27 = (path)=>{
    return path.split("/").map($e1e958e709906a29$export$c094f85f253e4d7d).join("/");
};
const $e1e958e709906a29$export$7a47376c130cfeac = (path)=>{
    try {
        return decodeURIComponent(path);
    } catch (e) {
        return path;
    }
};
const $e1e958e709906a29$export$b6ea104c7c46f19c = (path)=>{
    return path.split("/").map($e1e958e709906a29$export$7a47376c130cfeac).join("/");
};

});


parcelRegister("92WdM", function(module, exports) {

$parcel$export(module.exports, "v20", function () { return $dc4b55e41ea7b699$export$91c802c09531daae; });

var $kvnVB = parcelRequire("kvnVB");

var $9H597 = parcelRequire("9H597");
const $dc4b55e41ea7b699$var$baseUrl = "!api/2.0/repositories";
const $dc4b55e41ea7b699$export$91c802c09531daae = {
    fileHistory (repositoryFullSlug, hash, path, pageLen = 30) {
        const encodedPath = (0, $9H597.encodePath)(path || "/");
        const query = (0, $9H597.stringify)({
            pagelen: pageLen,
            renames: false,
            fields: "+values.commit.message,+values.commit.rendered.message,+values.commit.author.*,+values.commit.date"
        });
        return `/${$dc4b55e41ea7b699$var$baseUrl}/${repositoryFullSlug}/filehistory/${hash}/${encodedPath}${query}`;
    },
    source (repositoryFullSlug, ref, path, params) {
        const { format: format } = params || {};
        const encodedPath = (0, $9H597.encodePath)(path);
        const url = `/${$dc4b55e41ea7b699$var$baseUrl}/${repositoryFullSlug}/src/${ref}/${encodedPath}`;
        const query = (0, $9H597.stringify)({
            format: format
        });
        return `${url}${query}`;
    },
    sourceAbs (repositoryFullSlug, ref, path) {
        const url = $dc4b55e41ea7b699$export$91c802c09531daae.source(repositoryFullSlug, ref, path);
        return `${(0, $kvnVB.settings)().CANON_URL}${url}`;
    },
    buildStatuses (repositoryFullSlug, hash) {
        return `/${$dc4b55e41ea7b699$var$baseUrl}/${repositoryFullSlug}/commit/${hash}/statuses?pagelen=100`;
    },
    downloadRepo (repositoryFullSlug, refName) {
        const extension = ".zip";
        return `/${repositoryFullSlug}/get/${encodeURIComponent(refName)}${extension}`;
    }
};

});


parcelRegister("fN6IA", function(module, exports) {

$parcel$export(module.exports, "countChunkLines", function () { return $90b1f55e4de76ba6$export$72078cd56b009312; });
$parcel$export(module.exports, "countAddedAndDeletedLines", function () { return $90b1f55e4de76ba6$export$4c8ca5d62d836ac7; });
$parcel$export(module.exports, "countAllAddedAndDeletedLines", function () { return $90b1f55e4de76ba6$export$50be9782e356f624; });
const $90b1f55e4de76ba6$export$72078cd56b009312 = (file)=>file.chunks.reduce((prev, chunk)=>prev + chunk.changes.length, 0);
const $90b1f55e4de76ba6$export$4c8ca5d62d836ac7 = (diff)=>(diff.deletions || 0) + (diff.additions || 0);
const $90b1f55e4de76ba6$export$50be9782e356f624 = (diffs)=>diffs.reduce((sum, diff)=>sum + $90b1f55e4de76ba6$export$4c8ca5d62d836ac7(diff), 0);

});

parcelRegister("70vW8", function(module, exports) {

$parcel$export(module.exports, "diffStatToFileTree", function () { return $d8beef21deb5ba32$export$236c18919d47c625; });

var $lIZwG = parcelRequire("lIZwG");

var $lmgkD = parcelRequire("lmgkD");
const $d8beef21deb5ba32$var$buildFile = (name, fullPath, status, isConflicted, isHidden, comments, linesAdded, linesRemoved)=>({
        name: name,
        href: `#${(0, $lmgkD.getFileHref)(fullPath || "")}`,
        type: "file",
        fileDiffStatus: status,
        isConflicted: !!isConflicted,
        isHidden: !!isHidden,
        comments: comments || 0,
        linesAdded: linesAdded,
        linesRemoved: linesRemoved
    });
const $d8beef21deb5ba32$var$buildDirectory = (name, contents)=>({
        name: name,
        type: "directory",
        contents: contents
    });
const $d8beef21deb5ba32$export$8a0e85236081ebb6 = (diffStat, remainingPath, fullPath)=>{
    const segments = remainingPath.split("/");
    const fileSegment = segments.pop(); // Non-nullable as long as remainingPath is non-null
    const file = $d8beef21deb5ba32$var$buildFile(fileSegment, fullPath || remainingPath, diffStat.status, diffStat.isConflicted, diffStat.isHidden, diffStat.comments, diffStat.lines_added, diffStat.lines_removed);
    const result = segments.reduceRight((prev, current)=>$d8beef21deb5ba32$var$buildDirectory(current, [
            prev
        ]), file);
    return result;
};
const $d8beef21deb5ba32$var$directoryByName = (name)=>(entry)=>entry.name === name && entry.type === "directory";
/**
 * Traverses an existing file tree entries list to find where a new diffstat file should be placed.
 * If the new entry's folder doesn't exist then the entry is attached at the root.
 * New entries that share a folder with earlier entries will be placed in the same folder.
 */ const $d8beef21deb5ba32$var$findPlaceInTree = (entries, path)=>{
    let directoryLevelRef = entries;
    const pathSegments = path.split("/");
    let pathSegment = pathSegments[0];
    let matchedDirectory = directoryLevelRef.find($d8beef21deb5ba32$var$directoryByName(pathSegment));
    if (matchedDirectory && matchedDirectory.type === "directory") directoryLevelRef = matchedDirectory.contents;
    while(pathSegments.length > 1 && matchedDirectory){
        pathSegments.shift();
        [pathSegment] = pathSegments;
        matchedDirectory = directoryLevelRef.find($d8beef21deb5ba32$var$directoryByName(pathSegment));
        if (matchedDirectory && matchedDirectory.type === "directory") directoryLevelRef = matchedDirectory.contents;
    }
    return {
        root: directoryLevelRef,
        remainingPath: pathSegments.join("/")
    };
};
const $d8beef21deb5ba32$export$236c18919d47c625 = (diffStats)=>{
    const entries = [];
    diffStats.forEach((stat)=>{
        const displayedPath = (0, $lIZwG.default)(stat, "new.path") || (0, $lIZwG.default)(stat, "old.path", "");
        const { root: root, remainingPath: remainingPath } = $d8beef21deb5ba32$var$findPlaceInTree(entries, displayedPath);
        root.push($d8beef21deb5ba32$export$8a0e85236081ebb6(stat, remainingPath, displayedPath));
    });
    return entries;
};

});
parcelRegister("lmgkD", function(module, exports) {

$parcel$export(module.exports, "getFileHref", function () { return $e1032fea5b45723b$export$8450ab65829adda0; });
function $e1032fea5b45723b$export$8450ab65829adda0(path) {
    return `chg-${path}`;
}

});


parcelRegister("6Ef7A", function(module, exports) {

$parcel$export(module.exports, "isReviewer", function () { return $6caf19cb0d4f62e9$export$ea6b28bb5075d84c; });
$parcel$export(module.exports, "isNotAuthor", function () { return $6caf19cb0d4f62e9$export$5b963e9ed912d40f; });
parcelRequire("fequ0");
var $axaTk = parcelRequire("axaTk");
const $6caf19cb0d4f62e9$var$REVIEWER_ROLE = "REVIEWER";
const $6caf19cb0d4f62e9$export$ea6b28bb5075d84c = (participant)=>participant.role === $6caf19cb0d4f62e9$var$REVIEWER_ROLE || participant.approved || participant.state === (0, $axaTk.ParticipantStateTypes).changesRequested || participant.state === (0, $axaTk.ParticipantStateTypes).approved;
const $6caf19cb0d4f62e9$export$5b963e9ed912d40f = (participant, author)=>!author || !participant.user || participant.user.uuid !== author.uuid;

});

parcelRegister("cNC3o", function(module, exports) {

$parcel$export(module.exports, "truncateDiffsByOverallLineCount", function () { return $937d9c157fa113c2$export$78f3082a3c40b430; });

var $fN6IA = parcelRequire("fN6IA");

var $K8Ikq = parcelRequire("K8Ikq");
const $937d9c157fa113c2$export$78f3082a3c40b430 = (diffs, isSingleFileModeActive, renderingLimits)=>{
    if (!renderingLimits) return diffs;
    let lines = 0;
    let i = 0;
    for(; i < diffs.length; i++){
        const file = diffs[i];
        const newLines = (0, $K8Ikq.hasRenderableLines)(file, isSingleFileModeActive, renderingLimits) ? (0, $fN6IA.countAddedAndDeletedLines)(file) : 0;
        lines += newLines;
        if (lines > (isSingleFileModeActive ? renderingLimits.singleFileModeTruncateLines : renderingLimits.allFilesModeTruncateLines)) break;
    }
    return diffs.slice(0, i);
};

});
parcelRegister("K8Ikq", function(module, exports) {

$parcel$export(module.exports, "isBinaryDiff", function () { return $c96d20dfb853150c$export$1d27e5e7c5d79ad6; });
$parcel$export(module.exports, "isEmptyDiff", function () { return $c96d20dfb853150c$export$9aeed701a827a8f; });
$parcel$export(module.exports, "isPartialDiff", function () { return $c96d20dfb853150c$export$bfe5547004b86a32; });
$parcel$export(module.exports, "isSingleDiffTimeout", function () { return $c96d20dfb853150c$export$345f12586e1c2b; });
$parcel$export(module.exports, "getEffectivePerFileLimits", function () { return $c96d20dfb853150c$export$62002acf621a372b; });
$parcel$export(module.exports, "isExcessiveSizeEntireFile", function () { return $c96d20dfb853150c$export$1c54231133f6ff33; });
$parcel$export(module.exports, "isImageDiff", function () { return $c96d20dfb853150c$export$902605fa5b184203; });
$parcel$export(module.exports, "isFileRenamedDiff", function () { return $c96d20dfb853150c$export$c72e5014a43c71ed; });
$parcel$export(module.exports, "hasRenderableLines", function () { return $c96d20dfb853150c$export$d6cb8a2898173b2d; });
$parcel$export(module.exports, "shouldTriggerSingleFileMode", function () { return $c96d20dfb853150c$export$d301213ccd6dadee; });

var $fN6IA = parcelRequire("fN6IA");

var $6FvET = parcelRequire("6FvET");

var $cx5ao = parcelRequire("cx5ao");

var $jy8Hp = parcelRequire("jy8Hp");
const $c96d20dfb853150c$export$1d27e5e7c5d79ad6 = (diff)=>{
    return diff.isBinary && diff.fileDiffStatus !== "type changed";
};
const $c96d20dfb853150c$export$9aeed701a827a8f = (diff)=>diff.chunks.length === 0;
const $c96d20dfb853150c$export$bfe5547004b86a32 = (diff)=>$c96d20dfb853150c$export$9aeed701a827a8f(diff) && (diff.additions > 0 || diff.deletions > 0);
const $c96d20dfb853150c$export$345f12586e1c2b = (diff)=>{
    if (diff.headers.length === 0) return false;
    return diff.headers[0] === "diff_timeout";
};
function $c96d20dfb853150c$export$62002acf621a372b(isSingleFileModeActive, renderingLimits) {
    const byteLimit = isSingleFileModeActive ? renderingLimits.singleFileModePerFileLimitBytes : renderingLimits.allFilesModePerFileLimitBytes;
    const lineLimit = isSingleFileModeActive ? renderingLimits.singleFileModePerFileLimitLines : renderingLimits.allFilesModePerFileLimitLines;
    return {
        byteLimit: byteLimit,
        lineLimit: lineLimit
    };
}
const $c96d20dfb853150c$export$e717ea8e007bbd6c = (diff, isSingleFileModeActive, renderingLimits)=>{
    if (!renderingLimits) return false;
    const { lineLimit: lineLimit } = $c96d20dfb853150c$export$62002acf621a372b(isSingleFileModeActive, renderingLimits);
    return (0, $fN6IA.countAddedAndDeletedLines)(diff) > lineLimit;
};
const $c96d20dfb853150c$export$1c54231133f6ff33 = (diff, isSingleFileModeActive, renderingLimits)=>{
    if (!renderingLimits) return false;
    const { byteLimit: byteLimit, lineLimit: lineLimit } = $c96d20dfb853150c$export$62002acf621a372b(isSingleFileModeActive, renderingLimits);
    return (0, $jy8Hp.getFileDiffSize)(diff) > byteLimit || (0, $fN6IA.countChunkLines)(diff) > lineLimit;
};
const $c96d20dfb853150c$export$902605fa5b184203 = (diff)=>{
    return diff.isImage && diff.fileDiffStatus !== "type changed";
};
const $c96d20dfb853150c$export$c72e5014a43c71ed = (diff)=>{
    return diff.chunks.length === 0 && diff.fileDiffStatus === "renamed";
};
const $c96d20dfb853150c$export$d6cb8a2898173b2d = (diff, isSingleFileModeActive, renderingLimits)=>!diff.isFileContentsUnchanged && !$c96d20dfb853150c$export$902605fa5b184203(diff) && !$c96d20dfb853150c$export$1d27e5e7c5d79ad6(diff) && !(0, $6FvET.getExcessiveDiffSize)(diff) && !(0, $cx5ao.getExcludedPattern)(diff) && !$c96d20dfb853150c$export$c72e5014a43c71ed(diff) && !$c96d20dfb853150c$export$9aeed701a827a8f(diff) && (isSingleFileModeActive || !$c96d20dfb853150c$export$e717ea8e007bbd6c(diff, isSingleFileModeActive, renderingLimits));
const $c96d20dfb853150c$export$d301213ccd6dadee = (diffs, renderingLimits)=>{
    if (!renderingLimits) return false;
    const { singleFileModeThresholdFiles: singleFileModeThresholdFiles, singleFileModeThresholdLines: singleFileModeThresholdLines } = renderingLimits;
    if (diffs.length >= singleFileModeThresholdFiles) return true;
    return diffs.reduce((accumulator, diff)=>{
        return $c96d20dfb853150c$export$d6cb8a2898173b2d(diff, // isSingleFileModeActive:false is used here, otherwise every diff will be considered "renderable" by hasRenderableLines
        false, renderingLimits) ? accumulator + (0, $fN6IA.countAddedAndDeletedLines)(diff) : accumulator;
    }, 0) >= singleFileModeThresholdLines;
};

});
parcelRegister("6FvET", function(module, exports) {

$parcel$export(module.exports, "getExcessiveDiffSize", function () { return $525a83e529b6fef4$export$66bfcbccc041675c; });
function $525a83e529b6fef4$export$66bfcbccc041675c(file) {
    for(let i = 0; i < file.headers.length; ++i){
        const excludedHeader = file.headers[i].match(/^The diff for this file is too large to render \((\d+) bytes\)$/);
        if (excludedHeader) return Number(excludedHeader[1]);
    }
    return null;
}

});

parcelRegister("cx5ao", function(module, exports) {

$parcel$export(module.exports, "getExcludedPattern", function () { return $ac8189e1f8a4b9de$export$c1713e75adcd2635; });
function $ac8189e1f8a4b9de$export$c1713e75adcd2635(file) {
    for(let i = 0; i < file.headers.length; ++i){
        const excludedHeader = file.headers[i].match(/^File excluded by pattern "(.*)"$/);
        if (excludedHeader) return excludedHeader[1];
    }
    return "";
}

});

parcelRegister("jy8Hp", function(module, exports) {

$parcel$export(module.exports, "getFileDiffSize", function () { return $19eedea0851d3cf6$export$24aa722563235f0d; });
function $19eedea0851d3cf6$export$24aa722563235f0d(file) {
    return file.chunks.reduce((fileSize, chunk)=>{
        return fileSize + chunk.changes.reduce((chunkSize, change)=>{
            return chunkSize + change.content.length;
        }, 0);
    }, 0);
}

});



parcelRegister("fhEkQ", function(module, exports) {

$parcel$export(module.exports, "defaultDiff", function () { return $ac3b39226b410ffc$export$a93cf9b52d6c7cba; });
const $ac3b39226b410ffc$export$a93cf9b52d6c7cba = {
    from: "",
    to: "",
    headers: [],
    chunks: [],
    index: [],
    isBinary: false,
    isImage: false,
    isExcluded: false,
    deletions: 0,
    additions: 0
};

});

parcelRegister("ecsiI", function(module, exports) {

$parcel$export(module.exports, "DiffStatPathType", function () { return $4c5b2f8a99d6ffee$export$254ac263b2c2883f; });
$parcel$export(module.exports, "getDiffStatPath", function () { return $4c5b2f8a99d6ffee$export$9a0a90a28e7744e2; });
$parcel$export(module.exports, "getDiffPath", function () { return $4c5b2f8a99d6ffee$export$a0870db524e80b3a; });
var $4c5b2f8a99d6ffee$export$254ac263b2c2883f;
(function(DiffStatPathType) {
    DiffStatPathType[DiffStatPathType["Escaped"] = 0] = "Escaped";
    DiffStatPathType[DiffStatPathType["Unescaped"] = 1] = "Unescaped";
})($4c5b2f8a99d6ffee$export$254ac263b2c2883f || ($4c5b2f8a99d6ffee$export$254ac263b2c2883f = {}));
const $4c5b2f8a99d6ffee$export$9a0a90a28e7744e2 = (diffStat, type)=>{
    if (type === 0) {
        var _diffStat$new, _diffStat$old;
        return ((_diffStat$new = diffStat.new) === null || _diffStat$new === void 0 ? void 0 : _diffStat$new.escaped_path) || ((_diffStat$old = diffStat.old) === null || _diffStat$old === void 0 ? void 0 : _diffStat$old.escaped_path) || "";
    } else {
        var _diffStat$new2, _diffStat$old2;
        return ((_diffStat$new2 = diffStat.new) === null || _diffStat$new2 === void 0 ? void 0 : _diffStat$new2.path) || ((_diffStat$old2 = diffStat.old) === null || _diffStat$old2 === void 0 ? void 0 : _diffStat$old2.path) || "";
    }
};
const $4c5b2f8a99d6ffee$export$a0870db524e80b3a = (diff)=>diff && diff.to !== "/dev/null" ? diff.to : diff.from;

});

parcelRegister("dcUdk", function(module, exports) {

$parcel$export(module.exports, "areLocatorsEqual", function () { return $b673945b1df9aa1f$export$b2b6e5cb05bbe11f; });
$parcel$export(module.exports, "toPullRequestLocator", function () { return $b673945b1df9aa1f$export$732b5a48850607ec; });
const $b673945b1df9aa1f$var$cleanSlug = (slug)=>(slug || "").replace(/\.git$/, "");
function $b673945b1df9aa1f$export$b2b6e5cb05bbe11f(a, b) {
    // Users can enter the UUID of an owner into the url bar
    const isOwner = a.owner === b.owner || a.ownerUuid === b.owner || a.owner === b.ownerUuid;
    // Users can enter the repo-slug, the UUID, or the repo-slug.git
    const isRepo = $b673945b1df9aa1f$var$cleanSlug(a.slug) === $b673945b1df9aa1f$var$cleanSlug(b.slug) || // if repoUuid is present we have data from state which is more complete
    a.repoUuid === b.slug || b.repoUuid === a.slug;
    return isOwner && a.id === b.id && isRepo;
}
function $b673945b1df9aa1f$export$732b5a48850607ec(routeParams) {
    return {
        owner: routeParams.repositoryOwner,
        slug: routeParams.repositorySlug,
        id: parseInt(routeParams.pullRequestId, 10)
    };
}

});



parcelRegister("k6zif", function(module, exports) {

$parcel$export(module.exports, "MERGE", function () { return $3ef3f0583bd2258a$export$1f78e4fb9285394e; });
$parcel$export(module.exports, "FETCH_PENDING_MERGE_STATUS", function () { return $3ef3f0583bd2258a$export$f17704db11745379; });
$parcel$export(module.exports, "CREATE_PENDING_MERGE", function () { return $3ef3f0583bd2258a$export$4893164b32740fae; });
$parcel$export(module.exports, "CANCEL_PENDING_MERGE", function () { return $3ef3f0583bd2258a$export$f1a953ae5dd89d18; });
$parcel$export(module.exports, "OPEN_MERGE_DIALOG", function () { return $3ef3f0583bd2258a$export$a4866bf311f23de9; });
$parcel$export(module.exports, "FETCH_STACKED_PULL_REQUESTS_COUNT", function () { return $3ef3f0583bd2258a$export$88e9c0e6f6167818; });
$parcel$export(module.exports, "FETCH_PULL_REQUEST_MERGE_STATUS", function () { return $3ef3f0583bd2258a$export$b92ce24937e4dddf; });
$parcel$export(module.exports, "requestMerge", function () { return $3ef3f0583bd2258a$export$ae24afa7c4a41d07; });
$parcel$export(module.exports, "fetchPendingMergeStatus", function () { return $3ef3f0583bd2258a$export$95d9ec76b8e2a814; });
$parcel$export(module.exports, "createPendingMerge", function () { return $3ef3f0583bd2258a$export$b40fc8dbfec344ab; });
$parcel$export(module.exports, "cancelPendingMerge", function () { return $3ef3f0583bd2258a$export$3fb2b9c8bc27ddcc; });
$parcel$export(module.exports, "setAsyncMergeInProgress", function () { return $3ef3f0583bd2258a$export$5b80375d3e32eb0f; });
$parcel$export(module.exports, "fetchPullRequestMergeStatus", function () { return $3ef3f0583bd2258a$export$ec90086a9996755a; });
$parcel$export(module.exports, "closeDialog", function () { return $3ef3f0583bd2258a$export$34bf1befb2fab61a; });
$parcel$export(module.exports, "openDialog", function () { return $3ef3f0583bd2258a$export$45f11db5513b93db; });
$parcel$export(module.exports, "mergeInitialState", function () { return $3ef3f0583bd2258a$export$3cc2cdb310df1b3a; });
$parcel$export(module.exports, "getIsMergeDialogOpen", function () { return $3ef3f0583bd2258a$export$5233c01a2ab150ae; });
$parcel$export(module.exports, "getIsMergeRequesting", function () { return $3ef3f0583bd2258a$export$a5493954e4f79cc4; });
$parcel$export(module.exports, "getIsRequestingPendingMerge", function () { return $3ef3f0583bd2258a$export$16d83cd3980da47c; });
$parcel$export(module.exports, "getIsMergeErrored", function () { return $3ef3f0583bd2258a$export$e79604efb39c84c0; });
$parcel$export(module.exports, "getMergeErrorMessage", function () { return $3ef3f0583bd2258a$export$252485202856b0fe; });
$parcel$export(module.exports, "getMergeErrorCode", function () { return $3ef3f0583bd2258a$export$28d93f565384c5a4; });
$parcel$export(module.exports, "getIsMergePending", function () { return $3ef3f0583bd2258a$export$f224a719c968ef67; });
$parcel$export(module.exports, "getMergeInfo", function () { return $3ef3f0583bd2258a$export$94bbe0be92b1bbb1; });
$parcel$export(module.exports, "getStackedPullRequestsCount", function () { return $3ef3f0583bd2258a$export$b5cd341647f8f339; });
$parcel$export(module.exports, "default", function () { return $3ef3f0583bd2258a$export$2e2bcd8739ae039; });

var $aXXtM = parcelRequire("aXXtM");
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
var $fICwP = parcelRequire("fICwP");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $1EkdU = parcelRequire("1EkdU");
const $3ef3f0583bd2258a$export$1f78e4fb9285394e = (0, $2MctD.createAsyncAction)((0, $6D21P.prefixed)("MERGE"));
const $3ef3f0583bd2258a$export$f17704db11745379 = (0, $2MctD.createAsyncAction)((0, $6D21P.prefixed)("FETCH_PENDING_MERGE_STATUS"));
const $3ef3f0583bd2258a$export$4893164b32740fae = (0, $2MctD.createAsyncAction)((0, $6D21P.prefixed)("CREATE_PENDING_MERGE"));
const $3ef3f0583bd2258a$export$f1a953ae5dd89d18 = (0, $2MctD.createAsyncAction)((0, $6D21P.prefixed)("CANCEL_PENDING_MERGE"));
const $3ef3f0583bd2258a$export$a4866bf311f23de9 = (0, $6D21P.prefixed)("OPEN_MERGE_DIALOG");
const $3ef3f0583bd2258a$export$71b1e77b66216473 = (0, $6D21P.prefixed)("CLOSE_MERGE_DIALOG");
const $3ef3f0583bd2258a$export$88e9c0e6f6167818 = (0, $2MctD.createAsyncAction)((0, $6D21P.prefixed)("FETCH_STACKED_PULL_REQUESTS_COUNT"));
const $3ef3f0583bd2258a$export$f5efe26b850e008c = (0, $6D21P.prefixed)("SET_ASYNC_MERGE_IN_PROGRESS");
const $3ef3f0583bd2258a$export$28ea636a52c7e9c4 = (0, $6D21P.prefixed)("SET_PULL_REQUEST_MERGE_STATUS_POLLING_LINK");
const $3ef3f0583bd2258a$export$b92ce24937e4dddf = (0, $2MctD.createAsyncAction)((0, $6D21P.prefixed)("FETCH_PULL_REQUEST_MERGE_STATUS"));
const $3ef3f0583bd2258a$export$ae24afa7c4a41d07 = (mergeInfo)=>({
        type: $3ef3f0583bd2258a$export$1f78e4fb9285394e.REQUEST,
        payload: mergeInfo
    });
const $3ef3f0583bd2258a$export$95d9ec76b8e2a814 = ()=>({
        type: $3ef3f0583bd2258a$export$f17704db11745379.REQUEST
    });
const $3ef3f0583bd2258a$export$b40fc8dbfec344ab = (mergeInfo)=>({
        type: $3ef3f0583bd2258a$export$4893164b32740fae.REQUEST,
        payload: mergeInfo
    });
const $3ef3f0583bd2258a$export$3fb2b9c8bc27ddcc = ()=>({
        type: $3ef3f0583bd2258a$export$f1a953ae5dd89d18.REQUEST
    });
const $3ef3f0583bd2258a$export$ef1f63b8562844ff = ()=>({
        type: $3ef3f0583bd2258a$export$88e9c0e6f6167818.REQUEST
    });
const $3ef3f0583bd2258a$export$5b80375d3e32eb0f = (isAsyncMergeInProgress)=>({
        type: $3ef3f0583bd2258a$export$f5efe26b850e008c,
        payload: isAsyncMergeInProgress
    });
const $3ef3f0583bd2258a$export$ec90086a9996755a = (pollingLink)=>(0, $fICwP.fetchAction)($3ef3f0583bd2258a$export$b92ce24937e4dddf, {
        url: pollingLink
    });
const $3ef3f0583bd2258a$export$34bf1befb2fab61a = ()=>({
        type: $3ef3f0583bd2258a$export$71b1e77b66216473
    });
const $3ef3f0583bd2258a$export$45f11db5513b93db = ()=>({
        type: $3ef3f0583bd2258a$export$a4866bf311f23de9
    });
const $3ef3f0583bd2258a$export$3cc2cdb310df1b3a = {
    canCreatePendingMerge: false,
    hadError: false,
    isDialogOpen: false,
    isMergePending: false,
    isAsyncMergeInProgress: false,
    isRequesting: false,
    isRequestingPendingMerge: false,
    lastErrorMessage: null,
    lastErrorCode: null,
    mergeInfo: {},
    stackedPullRequestsCount: 0
};
const $3ef3f0583bd2258a$export$5233c01a2ab150ae = (0, $aXXtM.createSelector)((0, $1EkdU.getPullRequestSlice), (state)=>state.merge.isDialogOpen);
const $3ef3f0583bd2258a$export$a5493954e4f79cc4 = (0, $aXXtM.createSelector)((0, $1EkdU.getPullRequestSlice), (state)=>state.merge.isRequesting);
const $3ef3f0583bd2258a$export$16d83cd3980da47c = (0, $aXXtM.createSelector)((0, $1EkdU.getPullRequestSlice), (state)=>state.merge.isRequestingPendingMerge);
const $3ef3f0583bd2258a$export$e79604efb39c84c0 = (0, $aXXtM.createSelector)((0, $1EkdU.getPullRequestSlice), (state)=>state.merge.hadError);
const $3ef3f0583bd2258a$export$252485202856b0fe = (0, $aXXtM.createSelector)((0, $1EkdU.getPullRequestSlice), (state)=>state.merge.lastErrorMessage);
const $3ef3f0583bd2258a$export$28d93f565384c5a4 = (0, $aXXtM.createSelector)((0, $1EkdU.getPullRequestSlice), (state)=>state.merge.lastErrorCode);
const $3ef3f0583bd2258a$export$f224a719c968ef67 = (0, $aXXtM.createSelector)((0, $1EkdU.getPullRequestSlice), (state)=>state.merge.isMergePending);
const $3ef3f0583bd2258a$export$94bbe0be92b1bbb1 = (0, $aXXtM.createSelector)((0, $1EkdU.getPullRequestSlice), (state)=>state.merge.mergeInfo);
const $3ef3f0583bd2258a$export$b5cd341647f8f339 = (0, $aXXtM.createSelector)((0, $1EkdU.getPullRequestSlice), (state)=>state.merge.stackedPullRequestsCount);
var // Reducer
$3ef3f0583bd2258a$export$2e2bcd8739ae039 = (state = $3ef3f0583bd2258a$export$3cc2cdb310df1b3a, action)=>{
    switch(action.type){
        case $3ef3f0583bd2258a$export$a4866bf311f23de9:
            return {
                ...state,
                isDialogOpen: true
            };
        case $3ef3f0583bd2258a$export$71b1e77b66216473:
            return {
                ...state,
                isDialogOpen: false
            };
        case $3ef3f0583bd2258a$export$1f78e4fb9285394e.REQUEST:
            return {
                ...state,
                isRequesting: true,
                hadError: false,
                lastErrorMessage: null
            };
        case $3ef3f0583bd2258a$export$1f78e4fb9285394e.SUCCESS:
            return {
                ...$3ef3f0583bd2258a$export$3cc2cdb310df1b3a
            };
        case $3ef3f0583bd2258a$export$1f78e4fb9285394e.ERROR:
            return {
                ...state,
                isRequesting: false,
                hadError: true,
                lastErrorMessage: action.payload
            };
        case $3ef3f0583bd2258a$export$f17704db11745379.REQUEST:
            return {
                ...state,
                isRequestingPendingMerge: true,
                hadError: false,
                lastErrorMessage: null
            };
        case $3ef3f0583bd2258a$export$f17704db11745379.SUCCESS:
            return {
                ...$3ef3f0583bd2258a$export$3cc2cdb310df1b3a,
                canCreatePendingMerge: action.payload.canCreatePendingMerge,
                isDialogOpen: state.isDialogOpen,
                isMergePending: action.payload.isMergePending,
                mergeInfo: action.payload.mergeInfo
            };
        case $3ef3f0583bd2258a$export$f17704db11745379.ERROR:
            return {
                ...state,
                isRequestingPendingMerge: false
            };
        case $3ef3f0583bd2258a$export$4893164b32740fae.REQUEST:
            return {
                ...state,
                isRequestingPendingMerge: true,
                hadError: false,
                lastErrorMessage: null
            };
        case $3ef3f0583bd2258a$export$4893164b32740fae.SUCCESS:
            return {
                ...$3ef3f0583bd2258a$export$3cc2cdb310df1b3a,
                isMergePending: true,
                mergeInfo: action.payload
            };
        case $3ef3f0583bd2258a$export$4893164b32740fae.ERROR:
            if (action.payload.code === "BUILDS_FINISHED_GO_MERGE") return {
                ...state,
                canCreatePendingMerge: false,
                isMergeable: true,
                isRequestingPendingMerge: false,
                hadError: true,
                lastErrorMessage: action.payload.message,
                lastErrorCode: action.payload.code
            };
            return {
                ...state,
                isRequestingPendingMerge: false,
                hadError: true,
                lastErrorMessage: action.payload.message,
                lastErrorCode: action.payload.errorCode
            };
        case $3ef3f0583bd2258a$export$f1a953ae5dd89d18.REQUEST:
            return {
                ...state,
                isRequestingPendingMerge: true,
                hadError: false,
                lastErrorMessage: null
            };
        case $3ef3f0583bd2258a$export$f1a953ae5dd89d18.SUCCESS:
            return {
                ...$3ef3f0583bd2258a$export$3cc2cdb310df1b3a
            };
        case $3ef3f0583bd2258a$export$f1a953ae5dd89d18.ERROR:
            return {
                ...state,
                isRequestingPendingMerge: false,
                hadError: true,
                lastErrorMessage: action.payload
            };
        case $3ef3f0583bd2258a$export$88e9c0e6f6167818.SUCCESS:
            return {
                ...state,
                stackedPullRequestsCount: action.payload
            };
        case $3ef3f0583bd2258a$export$88e9c0e6f6167818.ERROR:
            return {
                ...state,
                // Ignore errors, show as if there're no stacked PRs
                stackedPullRequestsCount: 0
            };
        case $3ef3f0583bd2258a$export$f5efe26b850e008c:
            return {
                ...state,
                isAsyncMergeInProgress: action.payload
            };
        case 0, $6D21P.EXITED_CODE_REVIEW:
            return {
                ...$3ef3f0583bd2258a$export$3cc2cdb310df1b3a
            };
        default:
            return state;
    }
};

});


parcelRegister("2WdMK", function(module, exports) {

$parcel$export(module.exports, "CHOOSE_IMAGE", function () { return $9ac160ce54fcc474$export$17433152e8526502; });
$parcel$export(module.exports, "CANCEL_IMAGE_CHOICE", function () { return $9ac160ce54fcc474$export$335fa2d14d690a51; });
$parcel$export(module.exports, "UPLOAD_IMAGE", function () { return $9ac160ce54fcc474$export$f1db2c75d6790b63; });
$parcel$export(module.exports, "chooseImage", function () { return $9ac160ce54fcc474$export$9470b76cb755e687; });
$parcel$export(module.exports, "uploadImage", function () { return $9ac160ce54fcc474$export$16a258ac57b9f868; });
$parcel$export(module.exports, "imageUploadInitialState", function () { return $9ac160ce54fcc474$export$830217a1dc8524eb; });
$parcel$export(module.exports, "getIsUploadImageDialogOpen", function () { return $9ac160ce54fcc474$export$308336088e7fd580; });
$parcel$export(module.exports, "getImageUploadError", function () { return $9ac160ce54fcc474$export$77f757fa23f4e37b; });
$parcel$export(module.exports, "default", function () { return $9ac160ce54fcc474$export$2e2bcd8739ae039; });

var $aXXtM = parcelRequire("aXXtM");
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $1EkdU = parcelRequire("1EkdU");
const $9ac160ce54fcc474$export$17433152e8526502 = (0, $6D21P.prefixed)("CHOOSE_IMAGE");
const $9ac160ce54fcc474$export$335fa2d14d690a51 = (0, $6D21P.prefixed)("CANCEL_IMAGE_CHOICE");
const $9ac160ce54fcc474$export$f1db2c75d6790b63 = (0, $2MctD.createAsyncAction)((0, $6D21P.prefixed)("UPLOAD_IMAGE"));
const $9ac160ce54fcc474$export$9470b76cb755e687 = (editorCallback)=>({
        type: $9ac160ce54fcc474$export$17433152e8526502,
        payload: {
            editorCallback: editorCallback
        }
    });
const $9ac160ce54fcc474$export$16a258ac57b9f868 = (file, editorCallback)=>({
        type: $9ac160ce54fcc474$export$f1db2c75d6790b63.REQUEST,
        payload: {
            file: file,
            editorCallback: editorCallback
        }
    });
const $9ac160ce54fcc474$export$830217a1dc8524eb = {
    isChoosingImage: false,
    errorMessage: null
};
const $9ac160ce54fcc474$export$308336088e7fd580 = (0, $aXXtM.createSelector)((0, $1EkdU.getPullRequestSlice), (state)=>state.imageUpload.isChoosingImage);
const $9ac160ce54fcc474$export$77f757fa23f4e37b = (0, $aXXtM.createSelector)((0, $1EkdU.getPullRequestSlice), (state)=>state.imageUpload.errorMessage);
var // Reducer
$9ac160ce54fcc474$export$2e2bcd8739ae039 = (state = $9ac160ce54fcc474$export$830217a1dc8524eb, action)=>{
    switch(action.type){
        case $9ac160ce54fcc474$export$17433152e8526502:
            return {
                ...state,
                isChoosingImage: true,
                errorMessage: null
            };
        case $9ac160ce54fcc474$export$335fa2d14d690a51:
            return {
                ...$9ac160ce54fcc474$export$830217a1dc8524eb
            };
        case $9ac160ce54fcc474$export$f1db2c75d6790b63.SUCCESS:
            return {
                ...$9ac160ce54fcc474$export$830217a1dc8524eb
            };
        case $9ac160ce54fcc474$export$f1db2c75d6790b63.ERROR:
            return {
                ...state,
                errorMessage: action.payload
            };
        default:
            return state;
    }
};

});

parcelRegister("5gbji", function(module, exports) {

$parcel$export(module.exports, "initialState", function () { return $fd85e0d57957a160$export$d4c72bab9d6cc13a; });
$parcel$export(module.exports, "default", function () { return $fd85e0d57957a160$export$2e2bcd8739ae039; });
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");
const $fd85e0d57957a160$export$d4c72bab9d6cc13a = {
    lastPollTime: null,
    needsDiff: false,
    needsComments: false,
    needsTasks: false,
    needsPullRequest: false,
    links: null
};
var // @ts-ignore TODO: fix noImplicitAny error here
$fd85e0d57957a160$export$2e2bcd8739ae039 = (state = $fd85e0d57957a160$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $6D21P.ENTERED_CODE_REVIEW:
        case 0, $6D21P.EXITED_CODE_REVIEW:
            // We leave lastpoll incase they revisit within the stale timer
            return {
                ...state,
                needsComments: false,
                needsTasks: false,
                needsPullRequest: false,
                needsDiff: false,
                links: null
            };
        // This is an imperfect reset since we would be fetching DIFF, DIFFSTAT, CONFLICTS
        case (0, $6D21P.FETCH_DIFF).SUCCESS:
            return {
                ...state,
                needsDiff: false
            };
        case (0, $6D21P.FETCH_COMMENTS).SUCCESS:
            return {
                ...state,
                needsComments: false
            };
        case (0, $6D21P.FETCH_TASKS).SUCCESS:
            return {
                ...state,
                needsTasks: false
            };
        case (0, $6D21P.LOAD_PULL_REQUEST).SUCCESS:
            return {
                ...state,
                needsPullRequest: false,
                lastPollTime: action.payload.result.lastPoll
            };
        case 0, $6D21P.POLLED_PULLREQUEST:
            {
                const { needsDiff: needsDiff, needsComments: needsComments, needsTasks: needsTasks, needsPullRequest: needsPullRequest, lastModified: lastModified, links: links } = action.payload;
                // Never removes existing "needs", only aggregates until the appropriate fetch has happened
                return {
                    ...state,
                    lastPollTime: lastModified,
                    needsDiff: needsDiff || state.needsDiff,
                    needsComments: needsComments || state.needsComments,
                    needsTasks: needsTasks || state.needsTasks,
                    needsPullRequest: needsPullRequest || state.needsPullRequest,
                    links: links || state.links
                };
            }
        default:
            return state;
    }
};

});

parcelRegister("5uWUR", function(module, exports) {

$parcel$export(module.exports, "TASK_LOCATION_GLOBAL", function () { return $74225118d814471f$export$91d0239a7bd6d2a2; });
$parcel$export(module.exports, "getTaskLocation", function () { return $74225118d814471f$export$88329a54cf8d801a; });
$parcel$export(module.exports, "TASK_STATE", function () { return $74225118d814471f$export$bb4e36a4f951cf27; });
$parcel$export(module.exports, "initialState", function () { return $74225118d814471f$export$d4c72bab9d6cc13a; });
$parcel$export(module.exports, "default", function () { return $74225118d814471f$export$2e2bcd8739ae039; });

var $67NwJ = parcelRequire("67NwJ");

var $gsXeO = parcelRequire("gsXeO");
parcelRequire("erZj9");
var $g7vJB = parcelRequire("g7vJB");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");
const $74225118d814471f$export$91d0239a7bd6d2a2 = "TASK_LOCATION_GLOBAL";
function $74225118d814471f$var$mergeTasks(tasks, updatedTasks) {
    return tasks.map((task)=>{
        return updatedTasks.find((t)=>t.id === task.id) || task;
    });
}
const $74225118d814471f$export$88329a54cf8d801a = ({ isGlobal: isGlobal, commentId: commentId })=>isGlobal ? $74225118d814471f$export$91d0239a7bd6d2a2 : commentId;
var $74225118d814471f$export$bb4e36a4f951cf27;
(function(TASK_STATE) {
    TASK_STATE["NOT_EDITING"] = "notEditing";
    TASK_STATE["EDITING"] = "editing";
    TASK_STATE["SUBMITTING"] = "submitting";
    TASK_STATE["ERROR"] = "error";
})($74225118d814471f$export$bb4e36a4f951cf27 || ($74225118d814471f$export$bb4e36a4f951cf27 = {}));
const $74225118d814471f$var$addCommentEditingTaskState = (state, taskId, newTaskState)=>({
        commentEditingTasks: {
            ...state.commentEditingTasks,
            [taskId]: newTaskState
        }
    });
const $74225118d814471f$export$d4c72bab9d6cc13a = {
    items: [],
    // TODO refactor these various separate create/edit/delete states for
    // submitting/hasError/errorMessage into a single taskStates object,
    // which maps task.id to an object which always has a "state" key. This
    // will make things simpler and avoid bugs with "impossible" state combos.
    isLoading: false,
    isCardCollapsed: false,
    hasError: false,
    isCreatingCommentTaskByTaskKey: {},
    createTaskHasErrorByTaskKey: {},
    createTaskErrorMessageByTaskKey: {},
    isCreateTaskSubmittingByTaskKey: {},
    editTasksHasErrors: false,
    commentEditingTasks: {},
    taskErrors: {},
    isEditTasksSubmitting: false,
    isDeleteTaskSubmitting: {},
    initialTaskText: ""
};
var $74225118d814471f$export$2e2bcd8739ae039 = (0, $gsXeO.default)($74225118d814471f$export$d4c72bab9d6cc13a, {
    [$6D21P.COLLAPSE_TASKS_CARD] (state, action) {
        const { payload: isOpen } = action;
        return {
            ...state,
            isCardCollapsed: isOpen
        };
    },
    [$6D21P.LOAD_PULL_REQUEST.REQUEST] (state) {
        return {
            ...state,
            items: $74225118d814471f$export$d4c72bab9d6cc13a.items
        };
    },
    [$6D21P.UNLOAD_PULL_REQUEST] (state) {
        return {
            ...state,
            items: $74225118d814471f$export$d4c72bab9d6cc13a.items
        };
    },
    [$6D21P.FETCH_TASKS.REQUEST] (state) {
        return {
            ...state,
            items: $74225118d814471f$export$d4c72bab9d6cc13a.items,
            hasError: false,
            isLoading: true
        };
    },
    [$6D21P.FETCH_TASKS.SUCCESS] (state, action) {
        return {
            ...state,
            items: action.payload.values,
            hasError: false,
            isLoading: false
        };
    },
    [$6D21P.FETCH_TASKS.ERROR] (state) {
        return {
            ...state,
            items: $74225118d814471f$export$d4c72bab9d6cc13a.items,
            hasError: true,
            isLoading: false
        };
    },
    [$6D21P.TASK_STATE_CHANGE.SUCCESS] (state, action) {
        return {
            ...state,
            items: action.payload.nextTasks
        };
    },
    [$6D21P.TASK_STATE_CHANGE.ERROR] (state, action) {
        return {
            ...state,
            items: action.payload
        };
    },
    [$6D21P.TASK_CREATE.REQUEST] (state, action) {
        const taskLocation = $74225118d814471f$export$88329a54cf8d801a(action.payload);
        return {
            ...state,
            createTaskHasErrorByTaskKey: {
                ...state.createTaskHasErrorByTaskKey,
                [taskLocation]: false
            },
            createTaskErrorMessageByTaskKey: {
                ...state.createTaskErrorMessageByTaskKey,
                [taskLocation]: ""
            },
            isCreateTaskSubmittingByTaskKey: {
                ...state.isCreateTaskSubmittingByTaskKey,
                [taskLocation]: true
            }
        };
    },
    [$6D21P.TASK_CREATE.SUCCESS] (state, action) {
        const { newTask: newTask } = action.payload;
        const taskLocation = $74225118d814471f$export$88329a54cf8d801a(action.payload);
        return {
            ...state,
            items: [
                ...state.items,
                newTask
            ],
            createTaskHasErrorByTaskKey: {
                ...state.createTaskHasErrorByTaskKey,
                [taskLocation]: false
            },
            createTaskErrorMessageByTaskKey: {
                ...state.createTaskErrorMessageByTaskKey,
                [taskLocation]: ""
            },
            isCreateTaskSubmittingByTaskKey: {
                ...state.isCreateTaskSubmittingByTaskKey,
                [taskLocation]: false
            },
            isCreatingCommentTaskByTaskKey: {
                ...state.isCreatingCommentTaskByTaskKey,
                [taskLocation]: false
            }
        };
    },
    [$6D21P.TASK_CREATE.ERROR] (state, action) {
        const { error: error } = action.payload;
        const taskLocation = $74225118d814471f$export$88329a54cf8d801a(action.payload);
        return {
            ...state,
            createTaskHasErrorByTaskKey: {
                ...state.createTaskHasErrorByTaskKey,
                [taskLocation]: true
            },
            createTaskErrorMessageByTaskKey: {
                ...state.createTaskErrorMessageByTaskKey,
                [taskLocation]: error
            },
            isCreateTaskSubmittingByTaskKey: {
                ...state.isCreateTaskSubmittingByTaskKey,
                [taskLocation]: false
            },
            isCreatingCommentTaskByTaskKey: {
                ...state.isCreatingCommentTaskByTaskKey,
                [taskLocation]: true
            }
        };
    },
    [$6D21P.TASKS_EDIT.REQUEST] (state) {
        return {
            ...state,
            editTasksHasErrors: false,
            taskErrors: {},
            isEditTasksSubmitting: true
        };
    },
    [$6D21P.TASKS_EDIT.SUCCESS] (state, action) {
        return {
            ...state,
            items: $74225118d814471f$var$mergeTasks(state.items, action.payload),
            editTasksHasErrors: false,
            isEditTasksSubmitting: false
        };
    },
    [$6D21P.TASKS_EDIT.ERROR] (state, action) {
        return {
            ...state,
            editTasksHasErrors: true,
            taskErrors: action.payload,
            isEditTasksSubmitting: false
        };
    },
    [$6D21P.TASKS_EDIT.PARTIAL_SUCCESS] (state, action) {
        return {
            ...state,
            editTasksHasErrors: true,
            isEditTasksSubmitting: false,
            items: $74225118d814471f$var$mergeTasks(state.items, action.payload.updatedTasks),
            taskErrors: action.payload.errors
        };
    },
    [$6D21P.TASKS_CLEAR_ERRORS] (state) {
        return {
            ...state,
            createTaskHasError: false,
            createTaskErrorMessage: false,
            editTasksHasErrors: false,
            taskErrors: {}
        };
    },
    [$6D21P.TASK_DELETE.REQUEST] (state, action) {
        return {
            ...state,
            taskErrors: {},
            editTasksHasErrors: false,
            isDeleteTaskSubmitting: {
                ...state.isDeleteTaskSubmitting,
                [(0, $67NwJ.taskKey)(action.payload)]: true
            }
        };
    },
    [$6D21P.TASK_DELETE.SUCCESS] (state, action) {
        return {
            ...state,
            isDeleteTaskSubmitting: {
                ...state.isDeleteTaskSubmitting,
                [(0, $67NwJ.taskKey)(action.payload)]: false
            },
            items: state.items.filter((task)=>task.id !== action.payload.id)
        };
    },
    [$6D21P.TASK_DELETE.ERROR] (state, action) {
        return {
            ...state,
            editTasksHasErrors: false,
            taskErrors: action.payload.errors,
            isDeleteTaskSubmitting: {
                ...state.isDeleteTaskSubmitting,
                [(0, $67NwJ.taskKey)(action.payload.task)]: false
            }
        };
    },
    [$6D21P.DELETE_COMMENT.SUCCESS] (state, action) {
        return {
            ...state,
            items: state.items.filter((task)=>{
                var _task$comment;
                return ((_task$comment = task.comment) === null || _task$comment === void 0 ? void 0 : _task$comment.id) !== action.payload.id;
            })
        };
    },
    [$6D21P.TOGGLE_CREATE_COMMENT_TASK_INPUT] (state, action) {
        const { commentId: commentId, isCreating: isCreating, selectedCommentText: selectedCommentText } = action.payload;
        return {
            ...state,
            initialTaskText: selectedCommentText || "",
            isCreatingCommentTaskByTaskKey: {
                ...state.isCreatingCommentTaskByTaskKey,
                [commentId]: isCreating
            }
        };
    },
    [(0, $g7vJB.CREATE_JIRA_ISSUE_FORM_VISIBILITY_CHANGE)] (state, { payload: payload }) {
        // Hides the create task input if the create Jira issue input becomes visible
        const { commentId: commentId, isVisible: isJiraVisible } = payload;
        if (!isJiraVisible) return state;
        return {
            ...state,
            isCreatingCommentTaskByTaskKey: {
                ...state.isCreatingCommentTaskByTaskKey,
                [commentId]: false
            }
        };
    },
    // Action reducers for editing of individual comment tasks (i.e. not sidebar bulk task edit)
    [$6D21P.TOGGLE_EDIT_COMMENT_TASK_INPUT] (state, action) {
        const { taskId: taskId, isEditing: isEditing } = action.payload;
        return {
            ...state,
            ...$74225118d814471f$var$addCommentEditingTaskState(state, taskId, {
                state: isEditing ? "editing" : "notEditing"
            })
        };
    },
    [$6D21P.TASK_EDIT.REQUEST] (state, action) {
        const { taskId: taskId } = action.payload;
        return {
            ...state,
            ...$74225118d814471f$var$addCommentEditingTaskState(state, taskId, {
                state: "submitting"
            })
        };
    },
    [$6D21P.TASK_EDIT.SUCCESS] (state, action) {
        const { taskId: taskId, newTask: newTask } = action.payload;
        return {
            ...state,
            items: $74225118d814471f$var$mergeTasks(state.items, [
                newTask
            ]),
            ...$74225118d814471f$var$addCommentEditingTaskState(state, taskId, {
                state: "notEditing"
            })
        };
    },
    [$6D21P.TASK_EDIT.ERROR] (state, action) {
        const { taskId: taskId, error: error } = action.payload;
        return {
            ...state,
            ...$74225118d814471f$var$addCommentEditingTaskState(state, taskId, {
                state: "error",
                error: error
            })
        };
    }
});

});
parcelRegister("67NwJ", function(module, exports) {

$parcel$export(module.exports, "taskKey", function () { return $1bed47e95be6ff25$export$21d7301482c87a9b; });
const $1bed47e95be6ff25$export$21d7301482c87a9b = (task)=>`task-${typeof task === "number" || typeof task === "string" ? task : task.id}`;

});

parcelRegister("erZj9", function(module, exports) {
$parcel$export(module.exports, "CREATE_JIRA_ISSUE", function () { return (parcelRequire("g7vJB")).CREATE_JIRA_ISSUE; });
$parcel$export(module.exports, "CREATE_JIRA_ISSUE_FORM_VISIBILITY_CHANGE", function () { return (parcelRequire("g7vJB")).CREATE_JIRA_ISSUE_FORM_VISIBILITY_CHANGE; });
$parcel$export(module.exports, "CREATE_JIRA_ISSUE_SELECTED_PROJECT", function () { return (parcelRequire("g7vJB")).CREATE_JIRA_ISSUE_SELECTED_PROJECT; });
$parcel$export(module.exports, "CREATE_PR_JIRA_ISSUE", function () { return (parcelRequire("g7vJB")).CREATE_PR_JIRA_ISSUE; });
$parcel$export(module.exports, "createJiraIssue", function () { return (parcelRequire("g7vJB")).createJiraIssue; });
$parcel$export(module.exports, "createPrJiraIssue", function () { return (parcelRequire("g7vJB")).createPrJiraIssue; });
$parcel$export(module.exports, "FETCH_CONNECTED_JIRA_SITES", function () { return (parcelRequire("g7vJB")).FETCH_CONNECTED_JIRA_SITES; });
$parcel$export(module.exports, "FETCH_CREATE_JIRA_ISSUE_ONBOARDING_VIEWED", function () { return (parcelRequire("g7vJB")).FETCH_CREATE_JIRA_ISSUE_ONBOARDING_VIEWED; });
$parcel$export(module.exports, "FETCH_CREATE_JIRA_ISSUE_PREFERENCES", function () { return (parcelRequire("g7vJB")).FETCH_CREATE_JIRA_ISSUE_PREFERENCES; });
$parcel$export(module.exports, "FETCH_JIRA_ISSUE_CREATION_METADATA", function () { return (parcelRequire("g7vJB")).FETCH_JIRA_ISSUE_CREATION_METADATA; });
$parcel$export(module.exports, "FETCH_JIRA_PROJECT", function () { return (parcelRequire("g7vJB")).FETCH_JIRA_PROJECT; });
$parcel$export(module.exports, "FETCH_JIRA_PROJECTS_FOR_SITE", function () { return (parcelRequire("g7vJB")).FETCH_JIRA_PROJECTS_FOR_SITE; });
$parcel$export(module.exports, "FETCH_JIRA_TAB_CREATE_ISSUE_USER_PREFERENCE", function () { return (parcelRequire("g7vJB")).FETCH_JIRA_TAB_CREATE_ISSUE_USER_PREFERENCE; });
$parcel$export(module.exports, "fetchConnectedJiraSites", function () { return (parcelRequire("g7vJB")).fetchConnectedJiraSites; });
$parcel$export(module.exports, "fetchCreateJiraIssuePreferences", function () { return (parcelRequire("g7vJB")).fetchCreateJiraIssuePreferences; });
$parcel$export(module.exports, "fetchJiraIssueCreationMetadata", function () { return (parcelRequire("g7vJB")).fetchJiraIssueCreationMetadata; });
$parcel$export(module.exports, "fetchJiraProject", function () { return (parcelRequire("g7vJB")).fetchJiraProject; });
$parcel$export(module.exports, "fetchJiraProjectsForSite", function () { return (parcelRequire("g7vJB")).fetchJiraProjectsForSite; });
$parcel$export(module.exports, "fetchJiraTabCreateIssueUserPreferences", function () { return (parcelRequire("g7vJB")).fetchJiraTabCreateIssueUserPreferences; });
$parcel$export(module.exports, "INIT_CREATE_JIRA_ISSUE", function () { return (parcelRequire("g7vJB")).INIT_CREATE_JIRA_ISSUE; });
$parcel$export(module.exports, "ON_PR_UNSUPPORTED_FIELDS_ERROR", function () { return (parcelRequire("g7vJB")).ON_PR_UNSUPPORTED_FIELDS_ERROR; });
$parcel$export(module.exports, "ON_UNSUPPORTED_FIELDS_ERROR", function () { return (parcelRequire("g7vJB")).ON_UNSUPPORTED_FIELDS_ERROR; });
$parcel$export(module.exports, "onCreateJiraIssueFormChangeVisibility", function () { return (parcelRequire("g7vJB")).onCreateJiraIssueFormChangeVisibility; });
$parcel$export(module.exports, "onPrUnsupportedFieldsError", function () { return (parcelRequire("g7vJB")).onPrUnsupportedFieldsError; });
$parcel$export(module.exports, "onUnsupportedFieldsError", function () { return (parcelRequire("g7vJB")).onUnsupportedFieldsError; });
$parcel$export(module.exports, "SET_FORM_ERROR_STATE", function () { return (parcelRequire("g7vJB")).SET_FORM_ERROR_STATE; });
$parcel$export(module.exports, "SET_PR_FORM_ERROR_STATE", function () { return (parcelRequire("g7vJB")).SET_PR_FORM_ERROR_STATE; });
$parcel$export(module.exports, "setFormErrorState", function () { return (parcelRequire("g7vJB")).setFormErrorState; });
$parcel$export(module.exports, "setPrFormErrorState", function () { return (parcelRequire("g7vJB")).setPrFormErrorState; });
$parcel$export(module.exports, "setSelectedProject", function () { return (parcelRequire("g7vJB")).setSelectedProject; });
$parcel$export(module.exports, "UNLOAD_CREATE_JIRA_ISSUE", function () { return (parcelRequire("g7vJB")).UNLOAD_CREATE_JIRA_ISSUE; });
$parcel$export(module.exports, "unloadCreateJiraIssue", function () { return (parcelRequire("g7vJB")).unloadCreateJiraIssue; });
$parcel$export(module.exports, "UPDATE_CREATE_JIRA_ISSUE_ONBOARDING_VIEWED", function () { return (parcelRequire("g7vJB")).UPDATE_CREATE_JIRA_ISSUE_ONBOARDING_VIEWED; });
$parcel$export(module.exports, "UPDATE_CREATE_JIRA_ISSUE_PREFERENCES", function () { return (parcelRequire("g7vJB")).UPDATE_CREATE_JIRA_ISSUE_PREFERENCES; });
$parcel$export(module.exports, "updateCreateJiraIssuePreferences", function () { return (parcelRequire("g7vJB")).updateCreateJiraIssuePreferences; });
$parcel$export(module.exports, "FETCH_DASHBOARD_DEV_ACTIVITY", function () { return (parcelRequire("9KZ2S")).FETCH_DASHBOARD_DEV_ACTIVITY; });
$parcel$export(module.exports, "FETCH_DASHBOARD_JIRA_ISSUES", function () { return (parcelRequire("9KZ2S")).FETCH_DASHBOARD_JIRA_ISSUES; });
$parcel$export(module.exports, "fetchDashboardDevActivity", function () { return (parcelRequire("9KZ2S")).fetchDashboardDevActivity; });
$parcel$export(module.exports, "fetchDashboardJiraIssues", function () { return (parcelRequire("9KZ2S")).fetchDashboardJiraIssues; });
$parcel$export(module.exports, "INIT_DASHBOARD_JIRA", function () { return (parcelRequire("9KZ2S")).INIT_DASHBOARD_JIRA; });
$parcel$export(module.exports, "initDashboardJiraIssues", function () { return (parcelRequire("9KZ2S")).initDashboardJiraIssues; });
$parcel$export(module.exports, "ON_DASHBOARD_JIRA_SITE_CHANGE", function () { return (parcelRequire("9KZ2S")).ON_DASHBOARD_JIRA_SITE_CHANGE; });
$parcel$export(module.exports, "onDashboardJiraSiteChange", function () { return (parcelRequire("9KZ2S")).onDashboardJiraSiteChange; });
$parcel$export(module.exports, "SET_DASHBOARD_JIRA_DEFAULT_CLOUD_ID", function () { return (parcelRequire("9KZ2S")).SET_DASHBOARD_JIRA_DEFAULT_CLOUD_ID; });
$parcel$export(module.exports, "setDashboardJiraDefaultCloudId", function () { return (parcelRequire("9KZ2S")).setDashboardJiraDefaultCloudId; });
$parcel$export(module.exports, "changeFilterState", function () { return (parcelRequire("3OKoD")).changeFilterState; });
$parcel$export(module.exports, "changeIsCreateIssueDialogOpen", function () { return (parcelRequire("3OKoD")).changeIsCreateIssueDialogOpen; });
$parcel$export(module.exports, "closeManageProjectsDialog", function () { return (parcelRequire("3OKoD")).closeManageProjectsDialog; });
$parcel$export(module.exports, "closeProjectsMenu", function () { return (parcelRequire("3OKoD")).closeProjectsMenu; });
$parcel$export(module.exports, "closeUnlinkProjectDialog", function () { return (parcelRequire("3OKoD")).closeUnlinkProjectDialog; });
$parcel$export(module.exports, "CREATE_ISSUE_DIALOG_OPEN_CHANGE", function () { return (parcelRequire("3OKoD")).CREATE_ISSUE_DIALOG_OPEN_CHANGE; });
$parcel$export(module.exports, "FETCH_DEV_ACTIVITY", function () { return (parcelRequire("3OKoD")).FETCH_DEV_ACTIVITY; });
$parcel$export(module.exports, "FETCH_JIRA_ASSIGNEES", function () { return (parcelRequire("3OKoD")).FETCH_JIRA_ASSIGNEES; });
$parcel$export(module.exports, "FETCH_JIRA_PROJECTS", function () { return (parcelRequire("3OKoD")).FETCH_JIRA_PROJECTS; });
$parcel$export(module.exports, "FETCH_JIRA_RELEVANT_ISSUES", function () { return (parcelRequire("3OKoD")).FETCH_JIRA_RELEVANT_ISSUES; });
$parcel$export(module.exports, "FETCH_JIRA_RELEVANT_PROJECTS", function () { return (parcelRequire("3OKoD")).FETCH_JIRA_RELEVANT_PROJECTS; });
$parcel$export(module.exports, "FETCH_JIRA_SITES", function () { return (parcelRequire("3OKoD")).FETCH_JIRA_SITES; });
$parcel$export(module.exports, "FETCH_JIRA_TAB_FILTERS_USER_PREFERENCE", function () { return (parcelRequire("3OKoD")).FETCH_JIRA_TAB_FILTERS_USER_PREFERENCE; });
$parcel$export(module.exports, "FETCH_RELEVANT_JIRA_SITES", function () { return (parcelRequire("3OKoD")).FETCH_RELEVANT_JIRA_SITES; });
$parcel$export(module.exports, "FETCH_WORKSPACE_PERMISSION", function () { return (parcelRequire("3OKoD")).FETCH_WORKSPACE_PERMISSION; });
$parcel$export(module.exports, "fetchDevActivity", function () { return (parcelRequire("3OKoD")).fetchDevActivity; });
$parcel$export(module.exports, "fetchJiraAssignees", function () { return (parcelRequire("3OKoD")).fetchJiraAssignees; });
$parcel$export(module.exports, "fetchJiraProjects", function () { return (parcelRequire("3OKoD")).fetchJiraProjects; });
$parcel$export(module.exports, "fetchJiraRelevantIssues", function () { return (parcelRequire("3OKoD")).fetchJiraRelevantIssues; });
$parcel$export(module.exports, "fetchJiraRelevantProjects", function () { return (parcelRequire("3OKoD")).fetchJiraRelevantProjects; });
$parcel$export(module.exports, "fetchJiraSites", function () { return (parcelRequire("3OKoD")).fetchJiraSites; });
$parcel$export(module.exports, "fetchJiraTabFiltersUserPreference", function () { return (parcelRequire("3OKoD")).fetchJiraTabFiltersUserPreference; });
$parcel$export(module.exports, "fetchRelevantJiraSites", function () { return (parcelRequire("3OKoD")).fetchRelevantJiraSites; });
$parcel$export(module.exports, "fetchWorkspacePermission", function () { return (parcelRequire("3OKoD")).fetchWorkspacePermission; });
$parcel$export(module.exports, "FILTER_STATE", function () { return (parcelRequire("3OKoD")).FILTER_STATE; });
$parcel$export(module.exports, "HYDRATE_JIRA_DATA", function () { return (parcelRequire("3OKoD")).HYDRATE_JIRA_DATA; });
$parcel$export(module.exports, "hydrateJiraData", function () { return (parcelRequire("3OKoD")).hydrateJiraData; });
$parcel$export(module.exports, "INIT_JIRA_REPO_PAGE", function () { return (parcelRequire("3OKoD")).INIT_JIRA_REPO_PAGE; });
$parcel$export(module.exports, "initJiraRepoPage", function () { return (parcelRequire("3OKoD")).initJiraRepoPage; });
$parcel$export(module.exports, "INSTALL_ADDON_JIRA_TAB", function () { return (parcelRequire("3OKoD")).INSTALL_ADDON_JIRA_TAB; });
$parcel$export(module.exports, "installAddonJiraTab", function () { return (parcelRequire("3OKoD")).installAddonJiraTab; });
$parcel$export(module.exports, "JIRA_TAB_FILTERS_USER_PREFERENCE_NOT_REQUIRED", function () { return (parcelRequire("3OKoD")).JIRA_TAB_FILTERS_USER_PREFERENCE_NOT_REQUIRED; });
$parcel$export(module.exports, "LINK_JIRA_PROJECT", function () { return (parcelRequire("3OKoD")).LINK_JIRA_PROJECT; });
$parcel$export(module.exports, "linkJiraProject", function () { return (parcelRequire("3OKoD")).linkJiraProject; });
$parcel$export(module.exports, "MANAGE_PROJECTS_DIALOG_OPEN_CHANGE", function () { return (parcelRequire("3OKoD")).MANAGE_PROJECTS_DIALOG_OPEN_CHANGE; });
$parcel$export(module.exports, "openManageProjectsDialog", function () { return (parcelRequire("3OKoD")).openManageProjectsDialog; });
$parcel$export(module.exports, "openProjectsMenu", function () { return (parcelRequire("3OKoD")).openProjectsMenu; });
$parcel$export(module.exports, "openUnlinkProjectDialog", function () { return (parcelRequire("3OKoD")).openUnlinkProjectDialog; });
$parcel$export(module.exports, "PROJECTS_MENU_OPEN_CHANGE", function () { return (parcelRequire("3OKoD")).PROJECTS_MENU_OPEN_CHANGE; });
$parcel$export(module.exports, "RESET_STATE", function () { return (parcelRequire("3OKoD")).RESET_STATE; });
$parcel$export(module.exports, "resetState", function () { return (parcelRequire("3OKoD")).resetState; });
$parcel$export(module.exports, "saveFilterState", function () { return (parcelRequire("3OKoD")).saveFilterState; });
$parcel$export(module.exports, "SET_EMPTY_STATE_KIND", function () { return (parcelRequire("3OKoD")).SET_EMPTY_STATE_KIND; });
$parcel$export(module.exports, "SET_ISSUE_ASSIGNEE", function () { return (parcelRequire("3OKoD")).SET_ISSUE_ASSIGNEE; });
$parcel$export(module.exports, "setEmptyStateKind", function () { return (parcelRequire("3OKoD")).setEmptyStateKind; });
$parcel$export(module.exports, "setIssueAssignee", function () { return (parcelRequire("3OKoD")).setIssueAssignee; });
$parcel$export(module.exports, "setJiraTabFiltersUserPreferenceNotRequired", function () { return (parcelRequire("3OKoD")).setJiraTabFiltersUserPreferenceNotRequired; });
$parcel$export(module.exports, "UNLINK_JIRA_PROJECT", function () { return (parcelRequire("3OKoD")).UNLINK_JIRA_PROJECT; });
$parcel$export(module.exports, "UNLINK_PROJECT_DIALOG_OPEN_CHANGE", function () { return (parcelRequire("3OKoD")).UNLINK_PROJECT_DIALOG_OPEN_CHANGE; });
$parcel$export(module.exports, "unlinkJiraProject", function () { return (parcelRequire("3OKoD")).unlinkJiraProject; });
$parcel$export(module.exports, "UPDATE_RELEVANT_JIRA_PROJECTS", function () { return (parcelRequire("3OKoD")).UPDATE_RELEVANT_JIRA_PROJECTS; });
$parcel$export(module.exports, "updateRelevantJiraProjects", function () { return (parcelRequire("3OKoD")).updateRelevantJiraProjects; });
$parcel$export(module.exports, "FETCH_AVAILABLE_ISSUE_TRANSITIONS", function () { return (parcelRequire("fYcHx")).FETCH_AVAILABLE_ISSUE_TRANSITIONS; });
$parcel$export(module.exports, "FETCH_PULL_REQUEST_JIRA_ISSUES", function () { return (parcelRequire("fYcHx")).FETCH_PULL_REQUEST_JIRA_ISSUES; });
$parcel$export(module.exports, "FETCH_TRANSITION_USER_PREFERENCE", function () { return (parcelRequire("fYcHx")).FETCH_TRANSITION_USER_PREFERENCE; });
$parcel$export(module.exports, "fetchAvailableIssueTransitions", function () { return (parcelRequire("fYcHx")).fetchAvailableIssueTransitions; });
$parcel$export(module.exports, "fetchPullRequestJiraIssues", function () { return (parcelRequire("fYcHx")).fetchPullRequestJiraIssues; });
$parcel$export(module.exports, "INIT_ISSUE_TRANSITIONS", function () { return (parcelRequire("fYcHx")).INIT_ISSUE_TRANSITIONS; });
$parcel$export(module.exports, "initIssueTransitions", function () { return (parcelRequire("fYcHx")).initIssueTransitions; });
$parcel$export(module.exports, "TRANSITION_ISSUES", function () { return (parcelRequire("fYcHx")).TRANSITION_ISSUES; });
$parcel$export(module.exports, "transitionIssues", function () { return (parcelRequire("fYcHx")).transitionIssues; });
$parcel$export(module.exports, "UPDATE_ISSUE_TRANSITION", function () { return (parcelRequire("fYcHx")).UPDATE_ISSUE_TRANSITION; });
$parcel$export(module.exports, "UPDATE_JIRA_ISSUES_LIST_AFTER_CREATION", function () { return (parcelRequire("fYcHx")).UPDATE_JIRA_ISSUES_LIST_AFTER_CREATION; });
$parcel$export(module.exports, "updateIssueTransition", function () { return (parcelRequire("fYcHx")).updateIssueTransition; });
$parcel$export(module.exports, "updateJiraIssuesListAfterCreation", function () { return (parcelRequire("fYcHx")).updateJiraIssuesListAfterCreation; });
$parcel$export(module.exports, "FETCH_ISSUE_MIGRATION_TO_JIRA_LOGS", function () { return (parcelRequire("5KwLw")).FETCH_ISSUE_MIGRATION_TO_JIRA_LOGS; });
$parcel$export(module.exports, "FETCH_ISSUE_MIGRATION_TO_JIRA_STATUS", function () { return (parcelRequire("5KwLw")).FETCH_ISSUE_MIGRATION_TO_JIRA_STATUS; });
$parcel$export(module.exports, "FETCH_SITES_FOR_JIRA_MIGRATION", function () { return (parcelRequire("5KwLw")).FETCH_SITES_FOR_JIRA_MIGRATION; });
$parcel$export(module.exports, "fetchIssueMigrationToJiraLogs", function () { return (parcelRequire("5KwLw")).fetchIssueMigrationToJiraLogs; });
$parcel$export(module.exports, "fetchSitesForJiraMigration", function () { return (parcelRequire("5KwLw")).fetchSitesForJiraMigration; });
$parcel$export(module.exports, "GO_TO_STEP", function () { return (parcelRequire("5KwLw")).GO_TO_STEP; });
$parcel$export(module.exports, "goToStep", function () { return (parcelRequire("5KwLw")).goToStep; });
$parcel$export(module.exports, "INSTALL_ADDON_JIRA_MIGRATION", function () { return (parcelRequire("5KwLw")).INSTALL_ADDON_JIRA_MIGRATION; });
$parcel$export(module.exports, "installAddonJiraMigration", function () { return (parcelRequire("5KwLw")).installAddonJiraMigration; });
$parcel$export(module.exports, "POLL_ISSUE_MIGRATION_TO_JIRA", function () { return (parcelRequire("5KwLw")).POLL_ISSUE_MIGRATION_TO_JIRA; });
$parcel$export(module.exports, "pollIssueMigrationStatus", function () { return (parcelRequire("5KwLw")).pollIssueMigrationStatus; });
$parcel$export(module.exports, "RESET_JIRA_MIGRATION_STATE", function () { return (parcelRequire("5KwLw")).RESET_JIRA_MIGRATION_STATE; });
$parcel$export(module.exports, "resetJiraMigrationState", function () { return (parcelRequire("5KwLw")).resetJiraMigrationState; });
$parcel$export(module.exports, "SET_PROJECT", function () { return (parcelRequire("5KwLw")).SET_PROJECT; });
$parcel$export(module.exports, "SET_SELECTED_SITE", function () { return (parcelRequire("5KwLw")).SET_SELECTED_SITE; });
$parcel$export(module.exports, "setProject", function () { return (parcelRequire("5KwLw")).setProject; });
$parcel$export(module.exports, "setSelectedSite", function () { return (parcelRequire("5KwLw")).setSelectedSite; });
$parcel$export(module.exports, "START_ISSUE_MIGRATION_TO_JIRA", function () { return (parcelRequire("5KwLw")).START_ISSUE_MIGRATION_TO_JIRA; });
$parcel$export(module.exports, "startIssueMigrationToJira", function () { return (parcelRequire("5KwLw")).startIssueMigrationToJira; });
parcelRequire("g7vJB");
parcelRequire("9KZ2S");
parcelRequire("3OKoD");
parcelRequire("fYcHx");
parcelRequire("5KwLw");

});
parcelRegister("g7vJB", function(module, exports) {

$parcel$export(module.exports, "INIT_CREATE_JIRA_ISSUE", function () { return $56e5dd88fc3eb86c$export$8609b3839b94367b; });
$parcel$export(module.exports, "CREATE_JIRA_ISSUE_FORM_VISIBILITY_CHANGE", function () { return $56e5dd88fc3eb86c$export$e794826dac8c8d7; });
$parcel$export(module.exports, "onCreateJiraIssueFormChangeVisibility", function () { return $56e5dd88fc3eb86c$export$b8932d1cafd4d7c3; });
$parcel$export(module.exports, "FETCH_CONNECTED_JIRA_SITES", function () { return $56e5dd88fc3eb86c$export$1a66f15d67c268f2; });
$parcel$export(module.exports, "fetchConnectedJiraSites", function () { return $56e5dd88fc3eb86c$export$5ed488ee9a948ff3; });
$parcel$export(module.exports, "FETCH_JIRA_PROJECT", function () { return $56e5dd88fc3eb86c$export$41fa6a2a0a67dfd3; });
$parcel$export(module.exports, "fetchJiraProject", function () { return $56e5dd88fc3eb86c$export$51c5b1e8d9470411; });
$parcel$export(module.exports, "FETCH_JIRA_PROJECTS_FOR_SITE", function () { return $56e5dd88fc3eb86c$export$f37f5de91dd0fbf0; });
$parcel$export(module.exports, "fetchJiraProjectsForSite", function () { return $56e5dd88fc3eb86c$export$fce00ca529eca172; });
$parcel$export(module.exports, "FETCH_JIRA_ISSUE_CREATION_METADATA", function () { return $56e5dd88fc3eb86c$export$d616106cdfcc44d9; });
$parcel$export(module.exports, "fetchJiraIssueCreationMetadata", function () { return $56e5dd88fc3eb86c$export$72853dd2ae6e8226; });
$parcel$export(module.exports, "CREATE_PR_JIRA_ISSUE", function () { return $56e5dd88fc3eb86c$export$9136ea8b09c653be; });
$parcel$export(module.exports, "createPrJiraIssue", function () { return $56e5dd88fc3eb86c$export$cdfbebee6cf53f92; });
$parcel$export(module.exports, "ON_PR_UNSUPPORTED_FIELDS_ERROR", function () { return $56e5dd88fc3eb86c$export$1678a59a2800afb5; });
$parcel$export(module.exports, "onPrUnsupportedFieldsError", function () { return $56e5dd88fc3eb86c$export$7e92ca1fc888067e; });
$parcel$export(module.exports, "SET_PR_FORM_ERROR_STATE", function () { return $56e5dd88fc3eb86c$export$857b0717ee255cf; });
$parcel$export(module.exports, "setPrFormErrorState", function () { return $56e5dd88fc3eb86c$export$500943ef946fbe22; });
$parcel$export(module.exports, "FETCH_CREATE_JIRA_ISSUE_ONBOARDING_VIEWED", function () { return $56e5dd88fc3eb86c$export$f49f333d5e8187c; });
$parcel$export(module.exports, "fetchCreateJiraIssueOnboardingViewed", function () { return $56e5dd88fc3eb86c$export$ec6418600a9b50b3; });
$parcel$export(module.exports, "UPDATE_CREATE_JIRA_ISSUE_ONBOARDING_VIEWED", function () { return $56e5dd88fc3eb86c$export$bf17efbf4095d5b5; });
$parcel$export(module.exports, "updateCreateJiraIssueOnboardingViewed", function () { return $56e5dd88fc3eb86c$export$37a5f37ced302844; });
$parcel$export(module.exports, "UNLOAD_CREATE_JIRA_ISSUE", function () { return $56e5dd88fc3eb86c$export$1a11968bbad74925; });
$parcel$export(module.exports, "unloadCreateJiraIssue", function () { return $56e5dd88fc3eb86c$export$e09d99f59b3e1ce6; });
$parcel$export(module.exports, "FETCH_CREATE_JIRA_ISSUE_PREFERENCES", function () { return $56e5dd88fc3eb86c$export$4a3d3f39074443b3; });
$parcel$export(module.exports, "fetchCreateJiraIssuePreferences", function () { return $56e5dd88fc3eb86c$export$43138926eee48410; });
$parcel$export(module.exports, "FETCH_JIRA_TAB_CREATE_ISSUE_USER_PREFERENCE", function () { return $56e5dd88fc3eb86c$export$37c08b4c70ae9549; });
$parcel$export(module.exports, "fetchJiraTabCreateIssueUserPreferences", function () { return $56e5dd88fc3eb86c$export$d074b2b444a2274a; });
$parcel$export(module.exports, "UPDATE_CREATE_JIRA_ISSUE_PREFERENCES", function () { return $56e5dd88fc3eb86c$export$a50a01b6d82b6ac2; });
$parcel$export(module.exports, "updateCreateJiraIssuePreferences", function () { return $56e5dd88fc3eb86c$export$a062d39659120005; });
$parcel$export(module.exports, "CREATE_JIRA_ISSUE_SELECTED_PROJECT", function () { return $56e5dd88fc3eb86c$export$317fce4fbaa0a24; });
$parcel$export(module.exports, "setSelectedProject", function () { return $56e5dd88fc3eb86c$export$825221ad0be08810; });
$parcel$export(module.exports, "CREATE_JIRA_ISSUE", function () { return $56e5dd88fc3eb86c$export$6842dfb4a12b9d06; });
$parcel$export(module.exports, "createJiraIssue", function () { return $56e5dd88fc3eb86c$export$37debc2a346b7376; });
$parcel$export(module.exports, "ON_UNSUPPORTED_FIELDS_ERROR", function () { return $56e5dd88fc3eb86c$export$3f56c62404f38d15; });
$parcel$export(module.exports, "onUnsupportedFieldsError", function () { return $56e5dd88fc3eb86c$export$6ecddf558942e7b5; });
$parcel$export(module.exports, "SET_FORM_ERROR_STATE", function () { return $56e5dd88fc3eb86c$export$d4d9cacf18c8e92d; });
$parcel$export(module.exports, "setFormErrorState", function () { return $56e5dd88fc3eb86c$export$610b15df7effe408; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");

var $dBLdP = parcelRequire("dBLdP");
const $56e5dd88fc3eb86c$export$8609b3839b94367b = (0, $dBLdP.createJiraIssue)("INIT_CREATE_JIRA_ISSUE");
const $56e5dd88fc3eb86c$export$1cfdc82bde592c36 = ()=>({
        type: $56e5dd88fc3eb86c$export$8609b3839b94367b
    });
const $56e5dd88fc3eb86c$export$e794826dac8c8d7 = (0, $dBLdP.createJiraIssue)("CREATE_JIRA_ISSUE_FORM_VISIBILITY_CHANGE");
const $56e5dd88fc3eb86c$export$b8932d1cafd4d7c3 = (payload)=>({
        type: $56e5dd88fc3eb86c$export$e794826dac8c8d7,
        payload: payload
    });
const $56e5dd88fc3eb86c$export$1a66f15d67c268f2 = (0, $2MctD.createAsyncAction)((0, $dBLdP.createJiraIssue)("FETCH_CONNECTED_JIRA_SITES"));
const $56e5dd88fc3eb86c$export$5ed488ee9a948ff3 = ()=>({
        type: $56e5dd88fc3eb86c$export$1a66f15d67c268f2.REQUEST
    });
const $56e5dd88fc3eb86c$export$41fa6a2a0a67dfd3 = (0, $2MctD.createAsyncAction)((0, $dBLdP.createJiraIssue)("FETCH_JIRA_PROJECT"));
const $56e5dd88fc3eb86c$export$51c5b1e8d9470411 = (payload)=>({
        type: $56e5dd88fc3eb86c$export$41fa6a2a0a67dfd3.REQUEST,
        payload: payload
    });
const $56e5dd88fc3eb86c$export$f37f5de91dd0fbf0 = (0, $2MctD.createAsyncAction)((0, $dBLdP.createJiraIssue)("FETCH_JIRA_PROJECTS_FOR_SITE"));
const $56e5dd88fc3eb86c$export$fce00ca529eca172 = (payload)=>({
        type: $56e5dd88fc3eb86c$export$f37f5de91dd0fbf0.REQUEST,
        payload: payload
    });
const $56e5dd88fc3eb86c$export$d616106cdfcc44d9 = (0, $2MctD.createAsyncAction)((0, $dBLdP.createJiraIssue)("FETCH_JIRA_ISSUE_CREATION_METADATA"));
const $56e5dd88fc3eb86c$export$72853dd2ae6e8226 = (payload)=>({
        type: $56e5dd88fc3eb86c$export$d616106cdfcc44d9.REQUEST,
        payload: payload
    });
const $56e5dd88fc3eb86c$export$9136ea8b09c653be = (0, $2MctD.createAsyncAction)((0, $dBLdP.createJiraIssue)("CREATE_PR_JIRA_ISSUE"));
const $56e5dd88fc3eb86c$export$cdfbebee6cf53f92 = (payload)=>({
        type: $56e5dd88fc3eb86c$export$9136ea8b09c653be.REQUEST,
        payload: payload
    });
const $56e5dd88fc3eb86c$export$1678a59a2800afb5 = (0, $dBLdP.createJiraIssue)("ON_PR_UNSUPPORTED_FIELDS_ERROR");
const $56e5dd88fc3eb86c$export$7e92ca1fc888067e = (payload)=>({
        type: $56e5dd88fc3eb86c$export$1678a59a2800afb5,
        payload: payload
    });
const $56e5dd88fc3eb86c$export$857b0717ee255cf = (0, $dBLdP.createJiraIssue)("SET_PR_FORM_ERROR_STATE");
const $56e5dd88fc3eb86c$export$500943ef946fbe22 = (payload)=>({
        type: $56e5dd88fc3eb86c$export$857b0717ee255cf,
        payload: payload
    });
const $56e5dd88fc3eb86c$export$f49f333d5e8187c = (0, $2MctD.createAsyncAction)((0, $dBLdP.createJiraIssue)("FETCH_CREATE_JIRA_ISSUE_ONBOARDING_VIEWED"));
const $56e5dd88fc3eb86c$export$ec6418600a9b50b3 = ()=>({
        type: $56e5dd88fc3eb86c$export$f49f333d5e8187c.REQUEST
    });
const $56e5dd88fc3eb86c$export$bf17efbf4095d5b5 = (0, $2MctD.createAsyncAction)((0, $dBLdP.createJiraIssue)("UPDATE_CREATE_JIRA_ISSUE_ONBOARDING_VIEWED"));
const $56e5dd88fc3eb86c$export$37a5f37ced302844 = (payload)=>({
        type: $56e5dd88fc3eb86c$export$bf17efbf4095d5b5.REQUEST,
        payload: payload
    });
const $56e5dd88fc3eb86c$export$1a11968bbad74925 = (0, $dBLdP.createJiraIssue)("UNLOAD_CREATE_JIRA_ISSUE");
const $56e5dd88fc3eb86c$export$e09d99f59b3e1ce6 = ()=>({
        type: $56e5dd88fc3eb86c$export$1a11968bbad74925
    });
const $56e5dd88fc3eb86c$export$4a3d3f39074443b3 = (0, $2MctD.createAsyncAction)((0, $dBLdP.createJiraIssue)("FETCH_CREATE_JIRA_ISSUE_PREFERENCES"));
const $56e5dd88fc3eb86c$export$43138926eee48410 = (repositoryFullSlug)=>({
        type: $56e5dd88fc3eb86c$export$4a3d3f39074443b3.REQUEST,
        payload: {
            repositoryFullSlug: repositoryFullSlug
        }
    });
const $56e5dd88fc3eb86c$export$37c08b4c70ae9549 = (0, $2MctD.createAsyncAction)((0, $dBLdP.createJiraIssue)("FETCH_JIRA_TAB_CREATE_ISSUE_USER_PREFERENCE"));
const $56e5dd88fc3eb86c$export$d074b2b444a2274a = ()=>({
        type: $56e5dd88fc3eb86c$export$37c08b4c70ae9549.REQUEST
    });
const $56e5dd88fc3eb86c$export$a50a01b6d82b6ac2 = (0, $2MctD.createAsyncAction)((0, $dBLdP.createJiraIssue)("UPDATE_CREATE_JIRA_ISSUE_PREFERENCES"));
const $56e5dd88fc3eb86c$export$a062d39659120005 = (payload)=>({
        type: $56e5dd88fc3eb86c$export$a50a01b6d82b6ac2.REQUEST,
        payload: payload
    });
const $56e5dd88fc3eb86c$export$317fce4fbaa0a24 = (0, $dBLdP.createJiraIssue)("CREATE_JIRA_ISSUE_SELECTED_PROJECT");
const $56e5dd88fc3eb86c$export$825221ad0be08810 = (payload)=>({
        type: $56e5dd88fc3eb86c$export$317fce4fbaa0a24,
        payload: payload
    });
const $56e5dd88fc3eb86c$export$6842dfb4a12b9d06 = (0, $2MctD.createAsyncAction)((0, $dBLdP.createJiraIssue)("CREATE_JIRA_ISSUE"));
const $56e5dd88fc3eb86c$export$37debc2a346b7376 = (payload)=>({
        type: $56e5dd88fc3eb86c$export$6842dfb4a12b9d06.REQUEST,
        payload: payload
    });
const $56e5dd88fc3eb86c$export$3f56c62404f38d15 = (0, $dBLdP.createJiraIssue)("ON_UNSUPPORTED_FIELDS_ERROR");
const $56e5dd88fc3eb86c$export$6ecddf558942e7b5 = (payload)=>({
        type: $56e5dd88fc3eb86c$export$3f56c62404f38d15,
        payload: payload
    });
const $56e5dd88fc3eb86c$export$d4d9cacf18c8e92d = (0, $dBLdP.createJiraIssue)("SET_FORM_ERROR_STATE");
const $56e5dd88fc3eb86c$export$610b15df7effe408 = (payload)=>({
        type: $56e5dd88fc3eb86c$export$d4d9cacf18c8e92d,
        payload: payload
    });

});
parcelRegister("dBLdP", function(module, exports) {

$parcel$export(module.exports, "jiraRepoPage", function () { return $4db39481e9e54920$export$5056b749d4a3b1f; });
$parcel$export(module.exports, "createJiraIssue", function () { return $4db39481e9e54920$export$37debc2a346b7376; });
$parcel$export(module.exports, "jiraIssues", function () { return $4db39481e9e54920$export$7dbd82e5b27d010d; });
$parcel$export(module.exports, "dashboardJiraIssues", function () { return $4db39481e9e54920$export$af0d57b558140bfc; });
$parcel$export(module.exports, "jiraMigration", function () { return $4db39481e9e54920$export$a234c85012bb1e49; });
const $4db39481e9e54920$export$5056b749d4a3b1f = (action)=>`jira-repo-page/${action}`;
const $4db39481e9e54920$export$37debc2a346b7376 = (action)=>`create-jira-issue/${action}`;
const $4db39481e9e54920$export$7dbd82e5b27d010d = (action)=>`jira-issues/${action}`;
const $4db39481e9e54920$export$af0d57b558140bfc = (action)=>`dashboard-jira-issues/${action}`;
const $4db39481e9e54920$export$a234c85012bb1e49 = (action)=>`jira-migration/${action}`;

});


parcelRegister("9KZ2S", function(module, exports) {

$parcel$export(module.exports, "INIT_DASHBOARD_JIRA", function () { return $1cd55f522dacba8a$export$51a0ad0e04066eaf; });
$parcel$export(module.exports, "initDashboardJiraIssues", function () { return $1cd55f522dacba8a$export$58eda0b8b4d22d79; });
$parcel$export(module.exports, "ON_DASHBOARD_JIRA_SITE_CHANGE", function () { return $1cd55f522dacba8a$export$aad58600d00ae405; });
$parcel$export(module.exports, "onDashboardJiraSiteChange", function () { return $1cd55f522dacba8a$export$4f2f1fd6c6660dd8; });
$parcel$export(module.exports, "FETCH_DASHBOARD_JIRA_ISSUES", function () { return $1cd55f522dacba8a$export$3accb8699950fb1a; });
$parcel$export(module.exports, "fetchDashboardJiraIssues", function () { return $1cd55f522dacba8a$export$9205f1d6a9071beb; });
$parcel$export(module.exports, "SET_DASHBOARD_JIRA_DEFAULT_CLOUD_ID", function () { return $1cd55f522dacba8a$export$c6038c0bf47884f; });
$parcel$export(module.exports, "setDashboardJiraDefaultCloudId", function () { return $1cd55f522dacba8a$export$632d0869bc53c2a0; });
$parcel$export(module.exports, "FETCH_DASHBOARD_DEV_ACTIVITY", function () { return $1cd55f522dacba8a$export$e1477086772b9c67; });
$parcel$export(module.exports, "fetchDashboardDevActivity", function () { return $1cd55f522dacba8a$export$57a0606a46013133; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");

var $dBLdP = parcelRequire("dBLdP");
const $1cd55f522dacba8a$export$51a0ad0e04066eaf = (0, $2MctD.createAsyncAction)((0, $dBLdP.dashboardJiraIssues)("INIT_DASHBOARD_JIRA"));
const $1cd55f522dacba8a$export$58eda0b8b4d22d79 = ()=>({
        type: $1cd55f522dacba8a$export$51a0ad0e04066eaf.REQUEST
    });
const $1cd55f522dacba8a$export$aad58600d00ae405 = (0, $dBLdP.dashboardJiraIssues)("ON_DASHBOARD_JIRA_SITE_CHANGE");
const $1cd55f522dacba8a$export$4f2f1fd6c6660dd8 = (site)=>({
        type: $1cd55f522dacba8a$export$aad58600d00ae405,
        payload: site
    });
const $1cd55f522dacba8a$export$3accb8699950fb1a = (0, $2MctD.createAsyncAction)((0, $dBLdP.dashboardJiraIssues)("FETCH_DASHBOARD_JIRA_ISSUES"));
const $1cd55f522dacba8a$export$9205f1d6a9071beb = (site)=>({
        type: $1cd55f522dacba8a$export$3accb8699950fb1a.REQUEST,
        payload: site
    });
const $1cd55f522dacba8a$export$c6038c0bf47884f = (0, $dBLdP.dashboardJiraIssues)("SET_DASHBOARD_JIRA_DEFAULT_CLOUD_ID");
const $1cd55f522dacba8a$export$632d0869bc53c2a0 = (cloudId)=>({
        type: $1cd55f522dacba8a$export$c6038c0bf47884f,
        payload: cloudId
    });
const $1cd55f522dacba8a$export$e1477086772b9c67 = (0, $2MctD.createAsyncAction)((0, $dBLdP.dashboardJiraIssues)("FETCH_DEV_ACTIVITY"));
const $1cd55f522dacba8a$export$57a0606a46013133 = (payload)=>({
        type: $1cd55f522dacba8a$export$e1477086772b9c67.REQUEST,
        payload: payload
    });

});

parcelRegister("3OKoD", function(module, exports) {

$parcel$export(module.exports, "INSTALL_ADDON_JIRA_TAB", function () { return $5cf795c9bfce1498$export$a8d65ac7f6275cc4; });
$parcel$export(module.exports, "installAddonJiraTab", function () { return $5cf795c9bfce1498$export$68bdc28698d35f99; });
$parcel$export(module.exports, "HYDRATE_JIRA_DATA", function () { return $5cf795c9bfce1498$export$2fc96beac969492f; });
$parcel$export(module.exports, "hydrateJiraData", function () { return $5cf795c9bfce1498$export$150dbb0d39175d4d; });
$parcel$export(module.exports, "INIT_JIRA_REPO_PAGE", function () { return $5cf795c9bfce1498$export$44407593aa492a28; });
$parcel$export(module.exports, "initJiraRepoPage", function () { return $5cf795c9bfce1498$export$659c91ed77962947; });
$parcel$export(module.exports, "FETCH_JIRA_SITES", function () { return $5cf795c9bfce1498$export$65f74ed943c4cb75; });
$parcel$export(module.exports, "fetchJiraSites", function () { return $5cf795c9bfce1498$export$2cd622c3bc5e30d8; });
$parcel$export(module.exports, "FETCH_RELEVANT_JIRA_SITES", function () { return $5cf795c9bfce1498$export$fba3542a46feda7f; });
$parcel$export(module.exports, "fetchRelevantJiraSites", function () { return $5cf795c9bfce1498$export$83450fbd7b8c759a; });
$parcel$export(module.exports, "FETCH_JIRA_RELEVANT_PROJECTS", function () { return $5cf795c9bfce1498$export$a0705b9ec154aee8; });
$parcel$export(module.exports, "fetchJiraRelevantProjects", function () { return $5cf795c9bfce1498$export$dee9bad6e5574664; });
$parcel$export(module.exports, "FETCH_JIRA_ASSIGNEES", function () { return $5cf795c9bfce1498$export$d093672506a60b68; });
$parcel$export(module.exports, "fetchJiraAssignees", function () { return $5cf795c9bfce1498$export$e83f886382d22dd5; });
$parcel$export(module.exports, "SET_ISSUE_ASSIGNEE", function () { return $5cf795c9bfce1498$export$d4741a9557be2839; });
$parcel$export(module.exports, "setIssueAssignee", function () { return $5cf795c9bfce1498$export$67265d9cb3fc3b3d; });
$parcel$export(module.exports, "FETCH_JIRA_RELEVANT_ISSUES", function () { return $5cf795c9bfce1498$export$ade77f421e0015a1; });
$parcel$export(module.exports, "fetchJiraRelevantIssues", function () { return $5cf795c9bfce1498$export$af135ae1f137ff77; });
$parcel$export(module.exports, "FETCH_DEV_ACTIVITY", function () { return $5cf795c9bfce1498$export$d80bebc60ec60bf1; });
$parcel$export(module.exports, "fetchDevActivity", function () { return $5cf795c9bfce1498$export$d287336b819de8b6; });
$parcel$export(module.exports, "FETCH_WORKSPACE_PERMISSION", function () { return $5cf795c9bfce1498$export$fb40380d15f0e4a4; });
$parcel$export(module.exports, "fetchWorkspacePermission", function () { return $5cf795c9bfce1498$export$f22600ed83008218; });
$parcel$export(module.exports, "FILTER_STATE", function () { return $5cf795c9bfce1498$export$246319b0962b913c; });
$parcel$export(module.exports, "saveFilterState", function () { return $5cf795c9bfce1498$export$e922cf0a9e42a93b; });
$parcel$export(module.exports, "FETCH_JIRA_TAB_FILTERS_USER_PREFERENCE", function () { return $5cf795c9bfce1498$export$62290d53f51af359; });
$parcel$export(module.exports, "fetchJiraTabFiltersUserPreference", function () { return $5cf795c9bfce1498$export$c92db9da408ac25d; });
$parcel$export(module.exports, "JIRA_TAB_FILTERS_USER_PREFERENCE_NOT_REQUIRED", function () { return $5cf795c9bfce1498$export$a16e0fdd7c1dcfec; });
$parcel$export(module.exports, "setJiraTabFiltersUserPreferenceNotRequired", function () { return $5cf795c9bfce1498$export$ec907a914386555c; });
$parcel$export(module.exports, "changeFilterState", function () { return $5cf795c9bfce1498$export$93284063756eda12; });
$parcel$export(module.exports, "SET_EMPTY_STATE_KIND", function () { return $5cf795c9bfce1498$export$fa6c7bf6cfaa4f87; });
$parcel$export(module.exports, "setEmptyStateKind", function () { return $5cf795c9bfce1498$export$ad84ba03bf4743a2; });
$parcel$export(module.exports, "RESET_STATE", function () { return $5cf795c9bfce1498$export$7431817582ed8a25; });
$parcel$export(module.exports, "resetState", function () { return $5cf795c9bfce1498$export$8e84bad0b35de9e8; });
$parcel$export(module.exports, "MANAGE_PROJECTS_DIALOG_OPEN_CHANGE", function () { return $5cf795c9bfce1498$export$f1952b8b31cd3cbf; });
$parcel$export(module.exports, "openManageProjectsDialog", function () { return $5cf795c9bfce1498$export$b7b22994c8d286e2; });
$parcel$export(module.exports, "closeManageProjectsDialog", function () { return $5cf795c9bfce1498$export$b2e9d867de4a89d6; });
$parcel$export(module.exports, "PROJECTS_MENU_OPEN_CHANGE", function () { return $5cf795c9bfce1498$export$66e3f02335d184dd; });
$parcel$export(module.exports, "openProjectsMenu", function () { return $5cf795c9bfce1498$export$94d967c4edfaa4d3; });
$parcel$export(module.exports, "closeProjectsMenu", function () { return $5cf795c9bfce1498$export$cc94ee265c199b0d; });
$parcel$export(module.exports, "UNLINK_PROJECT_DIALOG_OPEN_CHANGE", function () { return $5cf795c9bfce1498$export$9e31e5c484041a99; });
$parcel$export(module.exports, "openUnlinkProjectDialog", function () { return $5cf795c9bfce1498$export$63e09134e8210e6e; });
$parcel$export(module.exports, "closeUnlinkProjectDialog", function () { return $5cf795c9bfce1498$export$3384525ec79f0261; });
$parcel$export(module.exports, "FETCH_JIRA_PROJECTS", function () { return $5cf795c9bfce1498$export$423c192d1714471e; });
$parcel$export(module.exports, "fetchJiraProjects", function () { return $5cf795c9bfce1498$export$3643d7b900ddb907; });
$parcel$export(module.exports, "LINK_JIRA_PROJECT", function () { return $5cf795c9bfce1498$export$17d49d6df6e5a181; });
$parcel$export(module.exports, "linkJiraProject", function () { return $5cf795c9bfce1498$export$74c1deefa6f0ca84; });
$parcel$export(module.exports, "UNLINK_JIRA_PROJECT", function () { return $5cf795c9bfce1498$export$a07286d5c71b5153; });
$parcel$export(module.exports, "unlinkJiraProject", function () { return $5cf795c9bfce1498$export$b755f49ab42326a8; });
$parcel$export(module.exports, "UPDATE_RELEVANT_JIRA_PROJECTS", function () { return $5cf795c9bfce1498$export$c183120cfcdcd597; });
$parcel$export(module.exports, "updateRelevantJiraProjects", function () { return $5cf795c9bfce1498$export$52ec860fbe72b27e; });
$parcel$export(module.exports, "CREATE_ISSUE_DIALOG_OPEN_CHANGE", function () { return $5cf795c9bfce1498$export$13c35dea91c7f995; });
$parcel$export(module.exports, "changeIsCreateIssueDialogOpen", function () { return $5cf795c9bfce1498$export$278be97e104067d7; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
var $fICwP = parcelRequire("fICwP");

var $4EtqP = parcelRequire("4EtqP");

var $dBLdP = parcelRequire("dBLdP");
const $5cf795c9bfce1498$export$a8d65ac7f6275cc4 = (0, $2MctD.createAsyncAction)((0, $dBLdP.jiraRepoPage)("INSTALL_ADDON_JIRA_TAB"));
const $5cf795c9bfce1498$export$68bdc28698d35f99 = ()=>({
        type: $5cf795c9bfce1498$export$a8d65ac7f6275cc4.REQUEST
    });
const $5cf795c9bfce1498$export$2fc96beac969492f = (0, $2MctD.createAsyncAction)((0, $dBLdP.jiraRepoPage)("HYDRATE_JIRA_DATA"));
const $5cf795c9bfce1498$export$150dbb0d39175d4d = (repositoryFullSlug)=>(0, $fICwP.hydrateAction)($5cf795c9bfce1498$export$2fc96beac969492f, "repository.jira", {
        url: (0, $4EtqP.default).ui.root(repositoryFullSlug)
    });
const $5cf795c9bfce1498$export$44407593aa492a28 = "INIT_JIRA_REPO_PAGE";
const $5cf795c9bfce1498$export$659c91ed77962947 = (repositoryFullSlug)=>({
        type: $5cf795c9bfce1498$export$44407593aa492a28,
        payload: repositoryFullSlug
    });
const $5cf795c9bfce1498$export$65f74ed943c4cb75 = (0, $2MctD.createAsyncAction)((0, $dBLdP.jiraRepoPage)("FETCH_JIRA_SITES"));
const $5cf795c9bfce1498$export$2cd622c3bc5e30d8 = ()=>({
        type: $5cf795c9bfce1498$export$65f74ed943c4cb75.REQUEST
    });
const $5cf795c9bfce1498$export$fba3542a46feda7f = (0, $2MctD.createAsyncAction)((0, $dBLdP.jiraRepoPage)("FETCH_RELEVANT_JIRA_SITES"));
const $5cf795c9bfce1498$export$83450fbd7b8c759a = (repositoryFullSlug)=>({
        type: $5cf795c9bfce1498$export$fba3542a46feda7f.REQUEST,
        payload: repositoryFullSlug
    });
const $5cf795c9bfce1498$export$a0705b9ec154aee8 = (0, $2MctD.createAsyncAction)((0, $dBLdP.jiraRepoPage)("FETCH_JIRA_RELEVANT_PROJECTS"));
const $5cf795c9bfce1498$export$dee9bad6e5574664 = ()=>({
        type: $5cf795c9bfce1498$export$a0705b9ec154aee8.REQUEST
    });
const $5cf795c9bfce1498$export$d093672506a60b68 = (0, $2MctD.createAsyncAction)((0, $dBLdP.jiraRepoPage)("FETCH_JIRA_ASSIGNEES"));
const $5cf795c9bfce1498$export$e83f886382d22dd5 = ()=>({
        type: $5cf795c9bfce1498$export$d093672506a60b68.REQUEST
    });
const $5cf795c9bfce1498$export$d4741a9557be2839 = (0, $2MctD.createAsyncAction)((0, $dBLdP.jiraRepoPage)("SET_ISSUE_ASSIGNEE"));
const $5cf795c9bfce1498$export$67265d9cb3fc3b3d = (issueKey, assigneeId)=>({
        type: $5cf795c9bfce1498$export$d4741a9557be2839.REQUEST,
        payload: {
            issueKey: issueKey,
            assigneeId: assigneeId
        }
    });
const $5cf795c9bfce1498$export$ade77f421e0015a1 = (0, $2MctD.createAsyncAction)((0, $dBLdP.jiraRepoPage)("FETCH_JIRA_RELEVANT_ISSUES"));
const $5cf795c9bfce1498$export$af135ae1f137ff77 = ()=>({
        type: $5cf795c9bfce1498$export$ade77f421e0015a1.REQUEST
    });
const $5cf795c9bfce1498$export$d80bebc60ec60bf1 = (0, $2MctD.createAsyncAction)((0, $dBLdP.jiraRepoPage)("FETCH_DEV_ACTIVITY"));
const $5cf795c9bfce1498$export$d287336b819de8b6 = (payload)=>({
        type: $5cf795c9bfce1498$export$d80bebc60ec60bf1.REQUEST,
        payload: payload
    });
const $5cf795c9bfce1498$export$fb40380d15f0e4a4 = (0, $2MctD.createAsyncAction)((0, $dBLdP.jiraRepoPage)("FETCH_WORKSPACE_PERMISSION"));
const $5cf795c9bfce1498$export$f22600ed83008218 = ()=>({
        type: $5cf795c9bfce1498$export$fb40380d15f0e4a4.REQUEST
    });
const $5cf795c9bfce1498$export$246319b0962b913c = {
    CHANGE: (0, $dBLdP.jiraRepoPage)("CHANGE_FILTER_STATE"),
    SAVE: (0, $dBLdP.jiraRepoPage)("SAVE_FILTER_STATE")
};
const $5cf795c9bfce1498$export$e922cf0a9e42a93b = (payload)=>({
        type: $5cf795c9bfce1498$export$246319b0962b913c.SAVE,
        payload: payload
    });
const $5cf795c9bfce1498$export$62290d53f51af359 = (0, $2MctD.createAsyncAction)((0, $dBLdP.jiraRepoPage)("FETCH_JIRA_TAB_FILTERS_USER_PREFERENCE"));
const $5cf795c9bfce1498$export$c92db9da408ac25d = ()=>({
        type: $5cf795c9bfce1498$export$62290d53f51af359.REQUEST
    });
const $5cf795c9bfce1498$export$a16e0fdd7c1dcfec = (0, $dBLdP.jiraRepoPage)("JIRA_TAB_FILTERS_USER_PREFERENCE_NOT_REQUIRED");
const $5cf795c9bfce1498$export$ec907a914386555c = ()=>({
        type: $5cf795c9bfce1498$export$a16e0fdd7c1dcfec
    });
const $5cf795c9bfce1498$export$93284063756eda12 = (payload)=>({
        type: $5cf795c9bfce1498$export$246319b0962b913c.CHANGE,
        payload: payload
    });
const $5cf795c9bfce1498$export$fa6c7bf6cfaa4f87 = (0, $dBLdP.jiraRepoPage)("SET_EMPTY_STATE_KIND");
const $5cf795c9bfce1498$export$ad84ba03bf4743a2 = (payload)=>({
        type: $5cf795c9bfce1498$export$fa6c7bf6cfaa4f87,
        payload: payload
    });
const $5cf795c9bfce1498$export$7431817582ed8a25 = (0, $dBLdP.jiraRepoPage)("RESET_STATE");
const $5cf795c9bfce1498$export$8e84bad0b35de9e8 = ()=>({
        type: $5cf795c9bfce1498$export$7431817582ed8a25
    });
const $5cf795c9bfce1498$export$f1952b8b31cd3cbf = (0, $dBLdP.jiraRepoPage)("MANAGE_PROJECTS_DIALOG_VISIBLE");
const $5cf795c9bfce1498$export$b7b22994c8d286e2 = ()=>({
        type: $5cf795c9bfce1498$export$f1952b8b31cd3cbf,
        payload: true
    });
const $5cf795c9bfce1498$export$b2e9d867de4a89d6 = ()=>({
        type: $5cf795c9bfce1498$export$f1952b8b31cd3cbf,
        payload: false
    });
const $5cf795c9bfce1498$export$66e3f02335d184dd = (0, $dBLdP.jiraRepoPage)("PROJECTS_MENU_VISIBLE");
const $5cf795c9bfce1498$export$94d967c4edfaa4d3 = ()=>({
        type: $5cf795c9bfce1498$export$66e3f02335d184dd,
        payload: true
    });
const $5cf795c9bfce1498$export$cc94ee265c199b0d = ()=>({
        type: $5cf795c9bfce1498$export$66e3f02335d184dd,
        payload: false
    });
const $5cf795c9bfce1498$export$9e31e5c484041a99 = (0, $dBLdP.jiraRepoPage)("UNLINK_PROJECT_DIALOG_VISIBLE");
const $5cf795c9bfce1498$export$63e09134e8210e6e = (projectToUnlink)=>({
        type: $5cf795c9bfce1498$export$9e31e5c484041a99,
        payload: projectToUnlink
    });
const $5cf795c9bfce1498$export$3384525ec79f0261 = ()=>({
        type: $5cf795c9bfce1498$export$9e31e5c484041a99,
        payload: undefined
    });
const $5cf795c9bfce1498$export$423c192d1714471e = (0, $2MctD.createAsyncAction)((0, $dBLdP.jiraRepoPage)("FETCH_JIRA_PROJECTS"));
const $5cf795c9bfce1498$export$3643d7b900ddb907 = (payload)=>({
        type: $5cf795c9bfce1498$export$423c192d1714471e.REQUEST,
        payload: payload
    });
const $5cf795c9bfce1498$export$17d49d6df6e5a181 = (0, $2MctD.createAsyncAction)((0, $dBLdP.jiraRepoPage)("LINK_JIRA_PROJECT"));
const $5cf795c9bfce1498$export$74c1deefa6f0ca84 = (projectAssociation)=>({
        type: $5cf795c9bfce1498$export$17d49d6df6e5a181.REQUEST,
        payload: {
            projectAssociation: projectAssociation
        }
    });
const $5cf795c9bfce1498$export$a07286d5c71b5153 = (0, $2MctD.createAsyncAction)((0, $dBLdP.jiraRepoPage)("UNLINK_JIRA_PROJECT"));
const $5cf795c9bfce1498$export$b755f49ab42326a8 = (projectAssociation)=>({
        type: $5cf795c9bfce1498$export$a07286d5c71b5153.REQUEST,
        payload: {
            projectAssociation: projectAssociation
        }
    });
const $5cf795c9bfce1498$export$c183120cfcdcd597 = (0, $dBLdP.jiraRepoPage)("UPDATE_RELEVANT_JIRA_PROJECTS");
const $5cf795c9bfce1498$export$52ec860fbe72b27e = (projectAssociations)=>({
        type: $5cf795c9bfce1498$export$c183120cfcdcd597,
        payload: projectAssociations
    });
const $5cf795c9bfce1498$export$13c35dea91c7f995 = (0, $dBLdP.jiraRepoPage)("CREATE_ISSUE_DIALOG_OPEN_CHANGE");
const $5cf795c9bfce1498$export$278be97e104067d7 = (payload)=>({
        type: $5cf795c9bfce1498$export$13c35dea91c7f995,
        payload: payload
    });

});
parcelRegister("4EtqP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcd641baa49d4a93$export$2e2bcd8739ae039; });

var $9H597 = parcelRequire("9H597");
var $dcd641baa49d4a93$export$2e2bcd8739ae039 = {
    ui: {
        root: (repositoryFullSlug)=>`/${repositoryFullSlug}/jira/`,
        settingsJiraIntegration: (workspace)=>`/${workspace}/workspace/settings/jira-integration`,
        workspace: (workspace)=>`/${workspace}/`
    },
    api: {
        v20: {
            workspacePermission: (workspace)=>`/!api/2.0/user/permissions/workspaces?fields=values.permission&q=workspace.slug="${workspace}"`
        },
        internal: {
            sites: (workspace)=>`/!api/internal/workspaces/${workspace}/jira/sites`,
            connectedSites: (workspace)=>`/!api/internal/workspaces/${workspace}/jira/sites?connected=true`,
            relevantSites: (repositoryFullSlug)=>`/!api/internal/repositories/${repositoryFullSlug}/jira/sites`,
            project: (workspace, cloudId, projectId)=>`/!api/internal/workspaces/${workspace}/jira/sites/${cloudId}/projects/${projectId}`,
            validateProject: (workspace, cloudId, projectKey, projectName)=>`/!api/internal/workspaces/${workspace}/jira/sites/${cloudId}/validate-project?project_key=${projectKey}&project_name=${projectName}`,
            generateProjectKey: (workspace, cloudId)=>`/!api/internal/workspaces/${workspace}/jira/sites/${cloudId}/generate-project-key`,
            projects: (workspace, cloudId, projectFilter)=>`/!api/internal/workspaces/${workspace}/jira/sites/${cloudId}/projects${(0, $9H597.stringify)({
                    projectFilter: projectFilter
                })}`,
            projectAssociation: (repositoryFullSlug, cloudId, projectId)=>`/!api/internal/repositories/${repositoryFullSlug}/jira/sites/${cloudId}/projects/${projectId}`,
            devActivity: (workspace, cloudId)=>`/!api/internal/workspaces/${workspace}/jira/sites/${cloudId}/issues/dev-status`,
            relevantProjects: (repositoryFullSlug)=>`/!api/internal/repositories/${repositoryFullSlug}/jira/projects`,
            relevantIssues: (repositoryFullSlug, filterParams)=>`/!api/internal/repositories/${repositoryFullSlug}/jira/projects/issues${(0, $9H597.stringify)(filterParams, {
                    arrayFormat: "repeat",
                    filter: (_, value)=>{
                        if (value && value.length === 0) return undefined;
                        return value;
                    }
                })}`,
            assignees: (repositoryFullSlug, cloudId)=>`/!api/internal/repositories/${repositoryFullSlug}/jira/projects/assignees?cloud_id=${cloudId}&pagelen=90`,
            setAssignee: (cloudId, issueKeyOrId)=>`/!api/internal/sites/${cloudId}/jira/issues/${issueKeyOrId}/assign`,
            jiraUsers: (workspace, cloudId, userIds)=>`/!api/internal/workspaces/${workspace}/jira/sites/${cloudId}/users${(0, $9H597.stringify)({
                    account_ids: userIds
                }, {
                    arrayFormat: "repeat"
                })}`,
            issueCreationMetadata: (workspace, cloudId, projectId)=>`/!api/internal/workspaces/${workspace}/jira/sites/${cloudId}/issuecreationmetadata?project_id=${projectId}`,
            issues: (repositoryFullSlug, pullRequestId)=>`/!api/internal/repositories/${repositoryFullSlug}/pullrequests/${pullRequestId}/jira/issues`,
            jiraIssues: (repositoryFullSlug)=>`/!api/internal/repositories/${repositoryFullSlug}/jira/issues`,
            availableTransitions: (cloudId, issueKeyOrId)=>`/!api/internal/jira/sites/${cloudId}/issues/${issueKeyOrId}/transitions`,
            transitions: (repositoryFullSlug, pullRequestId)=>`/!api/internal/repositories/${repositoryFullSlug}/pullrequests/${pullRequestId}/jira/transitions`,
            myIssues: (cloudId, pagelen)=>`/!api/internal/my/jira/sites/${cloudId}/issues${pagelen ? `?pagelen=${pagelen}` : ""}`,
            dashboardDevActivity: (cloudId)=>`/!api/internal/my/jira/sites/${cloudId}/issues/dev-status`,
            startIssueMigrationToJira: (repositoryFullSlug, cloudId, projectKey, projectName)=>`/!api/internal/repositories/${repositoryFullSlug}/issues/jira-export/${(0, $9H597.stringify)({
                    cloud_id: cloudId,
                    project_key: projectKey,
                    project_name: projectName
                })}`,
            issueMigrationToJiraStatus: (repositoryFullSlug)=>`/!api/internal/repositories/${repositoryFullSlug}/issues/jira-export/status`,
            issueMigrationToJiraLogs: (repositoryFullSlug)=>`/!api/internal/repositories/${repositoryFullSlug}/issues/jira-export/log`
        }
    },
    external: {
        wacTryJiraBbcBundleUrl: "https://www.atlassian.com/software/jira/bitbucket-integration?utm_source=bitbucket&utm_medium=in_product_ad&utm_campaign=bitbucket_jswtab&utm_content=jswtab_welcome",
        docsConnectJira: "https://confluence.atlassian.com/x/FQCDM",
        docsUseJiraProjects: "https://confluence.atlassian.com/x/JJ9gOg",
        docsJiraAdminPermissions: "https://confluence.atlassian.com/x/tRaEOQ",
        docsJiraIssues: "https://confluence.atlassian.com/x/yAiiLQ",
        docsBitbucketJiraIntegration: "https://confluence.atlassian.com/x/jIeHM"
    }
};

});


parcelRegister("fYcHx", function(module, exports) {

$parcel$export(module.exports, "FETCH_PULL_REQUEST_JIRA_ISSUES", function () { return $5dc1ca73dd2ae453$export$e330dc019c1b7609; });
$parcel$export(module.exports, "fetchPullRequestJiraIssues", function () { return $5dc1ca73dd2ae453$export$fa523e8e933e9503; });
$parcel$export(module.exports, "FETCH_AVAILABLE_ISSUE_TRANSITIONS", function () { return $5dc1ca73dd2ae453$export$63a9f82caafa03a6; });
$parcel$export(module.exports, "fetchAvailableIssueTransitions", function () { return $5dc1ca73dd2ae453$export$ef7e4ed3d3845987; });
$parcel$export(module.exports, "UPDATE_ISSUE_TRANSITION", function () { return $5dc1ca73dd2ae453$export$777b8372e4c2b448; });
$parcel$export(module.exports, "updateIssueTransition", function () { return $5dc1ca73dd2ae453$export$bebb8bdafe279f4; });
$parcel$export(module.exports, "INIT_ISSUE_TRANSITIONS", function () { return $5dc1ca73dd2ae453$export$6e4f20293dc2f13b; });
$parcel$export(module.exports, "initIssueTransitions", function () { return $5dc1ca73dd2ae453$export$d28971f5e46bf306; });
$parcel$export(module.exports, "FETCH_TRANSITION_USER_PREFERENCE", function () { return $5dc1ca73dd2ae453$export$a0f92048e6513f92; });
$parcel$export(module.exports, "TRANSITION_ISSUES", function () { return $5dc1ca73dd2ae453$export$ca1429dc80896c4e; });
$parcel$export(module.exports, "transitionIssues", function () { return $5dc1ca73dd2ae453$export$4d5f83ed627dbfd; });
$parcel$export(module.exports, "UPDATE_JIRA_ISSUES_LIST_AFTER_CREATION", function () { return $5dc1ca73dd2ae453$export$4ed1ff196bdb2df2; });
$parcel$export(module.exports, "updateJiraIssuesListAfterCreation", function () { return $5dc1ca73dd2ae453$export$e7d6707c2394e0fb; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");

var $dBLdP = parcelRequire("dBLdP");
const $5dc1ca73dd2ae453$export$e330dc019c1b7609 = (0, $2MctD.createAsyncAction)((0, $dBLdP.jiraIssues)("FETCH_PULL_REQUEST_JIRA_ISSUES"));
const $5dc1ca73dd2ae453$export$fa523e8e933e9503 = (payload)=>({
        type: $5dc1ca73dd2ae453$export$e330dc019c1b7609.REQUEST,
        ...payload
    });
const $5dc1ca73dd2ae453$export$63a9f82caafa03a6 = (0, $2MctD.createAsyncAction)((0, $dBLdP.jiraIssues)("FETCH_AVAILABLE_ISSUE_TRANSITIONS"));
const $5dc1ca73dd2ae453$export$ef7e4ed3d3845987 = (index)=>({
        type: $5dc1ca73dd2ae453$export$63a9f82caafa03a6.REQUEST,
        payload: index
    });
const $5dc1ca73dd2ae453$export$777b8372e4c2b448 = (0, $dBLdP.jiraIssues)("UPDATE_ISSUE_TRANSITION_FORM");
const $5dc1ca73dd2ae453$export$bebb8bdafe279f4 = (payload)=>({
        type: $5dc1ca73dd2ae453$export$777b8372e4c2b448,
        payload: payload
    });
const $5dc1ca73dd2ae453$export$6e4f20293dc2f13b = (0, $dBLdP.jiraIssues)("INIT_ISSUE_TRANSITIONS");
const $5dc1ca73dd2ae453$export$d28971f5e46bf306 = (payload)=>({
        type: $5dc1ca73dd2ae453$export$6e4f20293dc2f13b,
        payload: payload
    });
const $5dc1ca73dd2ae453$export$a0f92048e6513f92 = (0, $2MctD.createAsyncAction)((0, $dBLdP.jiraIssues)("FETCH_TRANSITION_USER_PREFERENCE"));
const $5dc1ca73dd2ae453$export$ca1429dc80896c4e = (0, $2MctD.createAsyncAction)((0, $dBLdP.jiraIssues)("TRANSITION_ISSUES"));
const $5dc1ca73dd2ae453$export$4d5f83ed627dbfd = ()=>({
        type: $5dc1ca73dd2ae453$export$ca1429dc80896c4e.REQUEST
    });
const $5dc1ca73dd2ae453$export$4ed1ff196bdb2df2 = (0, $dBLdP.jiraIssues)("UPDATE_JIRA_ISSUES_LIST_AFTER_CREATION");
const $5dc1ca73dd2ae453$export$e7d6707c2394e0fb = (payload)=>({
        type: $5dc1ca73dd2ae453$export$4ed1ff196bdb2df2,
        payload: payload
    });

});

parcelRegister("5KwLw", function(module, exports) {

$parcel$export(module.exports, "INSTALL_ADDON_JIRA_MIGRATION", function () { return $59d04dd31a5a7e73$export$7797d32233a23b98; });
$parcel$export(module.exports, "installAddonJiraMigration", function () { return $59d04dd31a5a7e73$export$fb0b5889ae638c43; });
$parcel$export(module.exports, "GO_TO_STEP", function () { return $59d04dd31a5a7e73$export$65e2d92c0333658b; });
$parcel$export(module.exports, "goToStep", function () { return $59d04dd31a5a7e73$export$a998600cfb2187; });
$parcel$export(module.exports, "RESET_JIRA_MIGRATION_STATE", function () { return $59d04dd31a5a7e73$export$6bbb4dd813d7db4; });
$parcel$export(module.exports, "resetJiraMigrationState", function () { return $59d04dd31a5a7e73$export$176583a2c0d86c61; });
$parcel$export(module.exports, "FETCH_SITES_FOR_JIRA_MIGRATION", function () { return $59d04dd31a5a7e73$export$33f9dad56d288d03; });
$parcel$export(module.exports, "fetchSitesForJiraMigration", function () { return $59d04dd31a5a7e73$export$913eee39c5189e91; });
$parcel$export(module.exports, "SET_SELECTED_SITE", function () { return $59d04dd31a5a7e73$export$b584bc6edf06c071; });
$parcel$export(module.exports, "setSelectedSite", function () { return $59d04dd31a5a7e73$export$701c7c3dbea0d3a0; });
$parcel$export(module.exports, "SET_PROJECT", function () { return $59d04dd31a5a7e73$export$35df8afda8c89cd9; });
$parcel$export(module.exports, "setProject", function () { return $59d04dd31a5a7e73$export$6d41d22cb5f997c0; });
$parcel$export(module.exports, "START_ISSUE_MIGRATION_TO_JIRA", function () { return $59d04dd31a5a7e73$export$cb785224de035f0; });
$parcel$export(module.exports, "startIssueMigrationToJira", function () { return $59d04dd31a5a7e73$export$229976a94d03876d; });
$parcel$export(module.exports, "FETCH_ISSUE_MIGRATION_TO_JIRA_STATUS", function () { return $59d04dd31a5a7e73$export$fe2be7bc8704bc12; });
$parcel$export(module.exports, "POLL_ISSUE_MIGRATION_TO_JIRA", function () { return $59d04dd31a5a7e73$export$27562c2b82ea51a4; });
$parcel$export(module.exports, "pollIssueMigrationStatus", function () { return $59d04dd31a5a7e73$export$83230f5b10a6cb29; });
$parcel$export(module.exports, "FETCH_ISSUE_MIGRATION_TO_JIRA_LOGS", function () { return $59d04dd31a5a7e73$export$e42cc49ed2dc98a1; });
$parcel$export(module.exports, "fetchIssueMigrationToJiraLogs", function () { return $59d04dd31a5a7e73$export$941eba7fa0174205; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");

var $dBLdP = parcelRequire("dBLdP");
const $59d04dd31a5a7e73$export$7797d32233a23b98 = (0, $2MctD.createAsyncAction)((0, $dBLdP.jiraMigration)("INSTALL_ADDON_JIRA_MIGRATION"));
const $59d04dd31a5a7e73$export$fb0b5889ae638c43 = (workspace)=>({
        type: $59d04dd31a5a7e73$export$7797d32233a23b98.REQUEST,
        payload: workspace
    });
const $59d04dd31a5a7e73$export$65e2d92c0333658b = (0, $dBLdP.jiraMigration)("GO_TO_STEP");
const $59d04dd31a5a7e73$export$a998600cfb2187 = (setpIndex)=>({
        type: $59d04dd31a5a7e73$export$65e2d92c0333658b,
        payload: setpIndex
    });
const $59d04dd31a5a7e73$export$6bbb4dd813d7db4 = (0, $dBLdP.jiraMigration)("RESET_JIRA_MIGRATION_STATE");
const $59d04dd31a5a7e73$export$176583a2c0d86c61 = ()=>({
        type: $59d04dd31a5a7e73$export$6bbb4dd813d7db4
    });
const $59d04dd31a5a7e73$export$33f9dad56d288d03 = (0, $2MctD.createAsyncAction)((0, $dBLdP.jiraMigration)("FETCH_SITES_FOR_JIRA_MIGRATION"));
const $59d04dd31a5a7e73$export$913eee39c5189e91 = ()=>({
        type: $59d04dd31a5a7e73$export$33f9dad56d288d03.REQUEST
    });
const $59d04dd31a5a7e73$export$b584bc6edf06c071 = (0, $dBLdP.jiraMigration)("SET_SELECTED_SITE");
const $59d04dd31a5a7e73$export$701c7c3dbea0d3a0 = (selectedSiteCloudId)=>({
        type: $59d04dd31a5a7e73$export$b584bc6edf06c071,
        payload: selectedSiteCloudId
    });
const $59d04dd31a5a7e73$export$35df8afda8c89cd9 = (0, $dBLdP.jiraMigration)("SET_PROJECT");
const $59d04dd31a5a7e73$export$6d41d22cb5f997c0 = (project)=>({
        type: $59d04dd31a5a7e73$export$35df8afda8c89cd9,
        payload: project
    });
const $59d04dd31a5a7e73$export$cb785224de035f0 = (0, $2MctD.createAsyncAction)((0, $dBLdP.jiraMigration)("START_ISSUE_MIGRATION_TO_JIRA"));
const $59d04dd31a5a7e73$export$229976a94d03876d = (payload)=>({
        type: $59d04dd31a5a7e73$export$cb785224de035f0.REQUEST,
        payload: payload
    });
const $59d04dd31a5a7e73$export$fe2be7bc8704bc12 = (0, $2MctD.createAsyncAction)((0, $dBLdP.jiraMigration)("FETCH_ISSUE_MIGRATION_TO_JIRA_STATUS"));
const $59d04dd31a5a7e73$export$27562c2b82ea51a4 = {
    START: (0, $dBLdP.jiraMigration)("START_POLL_ISSUE_MIGRATION_TO_JIRA"),
    STOP: (0, $dBLdP.jiraMigration)("STOP_POLL_ISSUE_MIGRATION_TO_JIRA")
};
const $59d04dd31a5a7e73$export$83230f5b10a6cb29 = (payload)=>({
        type: $59d04dd31a5a7e73$export$27562c2b82ea51a4.START,
        payload: payload
    });
const $59d04dd31a5a7e73$export$e42cc49ed2dc98a1 = (0, $2MctD.createAsyncAction)((0, $dBLdP.jiraMigration)("FETCH_ISSUE_MIGRATION_TO_JIRA_LOGS"));
const $59d04dd31a5a7e73$export$941eba7fa0174205 = (payload)=>({
        type: $59d04dd31a5a7e73$export$e42cc49ed2dc98a1.REQUEST,
        payload: payload
    });

});



parcelRegister("Sv3E7", function(module, exports) {

$parcel$export(module.exports, "mergeContextLinesWithChunks", function () { return $847a02ef9e25d2f6$export$4e593d70c29cd0f; });

var $fhzMP = parcelRequire("fhzMP");

var $lVt5b = parcelRequire("lVt5b");
function $847a02ef9e25d2f6$export$4e593d70c29cd0f(chunks, chunkId, contextLines, beforeOrAfter, hasMoreLines) {
    const chunkIndex = chunks.findIndex((chunk)=>chunk.id === chunkId);
    if (beforeOrAfter === "before") return (0, $lVt5b.prependToChunk)(chunks, chunkIndex, contextLines, hasMoreLines);
    return (0, $fhzMP.appendToChunk)(chunks, chunkIndex, contextLines, hasMoreLines);
}

});
parcelRegister("fhzMP", function(module, exports) {

$parcel$export(module.exports, "appendToChunk", function () { return $992de36d2ae97943$export$77b71d0c3b19cca8; });

var $gFnct = parcelRequire("gFnct");

var $bz3Zc = parcelRequire("bz3Zc");

var $eu8P0 = parcelRequire("eu8P0");
function $992de36d2ae97943$export$77b71d0c3b19cca8(chunks, chunkIndex, contextLines, hasMoreLines) {
    if ((0, $gFnct.chunksWillConnect)(chunks, chunkIndex, contextLines, false)) return (0, $bz3Zc.mergeChunks)(chunks, chunkIndex, contextLines, false);
    return (0, $eu8P0.simpleAppend)(chunks, chunkIndex, contextLines, hasMoreLines);
}

});
parcelRegister("gFnct", function(module, exports) {

$parcel$export(module.exports, "chunksWillConnect", function () { return $ffd38e3dd622f3d5$export$a3cd49144d0bd433; });
// NOTE: This assumes there are existing context lines.  If the existing
// chunk lines are only diff lines, this WILL BREAK.
function $ffd38e3dd622f3d5$export$a3cd49144d0bd433(chunks, chunkIndex, contextLines, expandUp) {
    if (!contextLines.length) return false;
    const firstContextLine = contextLines[0];
    const lastContextLine = contextLines[contextLines.length - 1];
    // Edge case: the api returns a diff line as last line.
    // Indicates that context lines have already bumped into next diff block.
    const isContextLine = lastContextLine.oldLine && lastContextLine.newLine;
    if (!isContextLine) return true;
    if (expandUp) {
        const contextLinesTop = firstContextLine.oldLine;
        const nextChunk = chunks[chunkIndex - 1] || {};
        const nextChunkBottom = nextChunk.oldStart + nextChunk.oldLines;
        // @ts-ignore
        return contextLinesTop <= nextChunkBottom;
    } else {
        const contextLinesBottom = lastContextLine.oldLine;
        const nextChunk = chunks[chunkIndex + 1] || {};
        const nextChunkTop = nextChunk.oldStart;
        // @ts-ignore
        return contextLinesBottom >= nextChunkTop - 1;
    }
}

});

parcelRegister("bz3Zc", function(module, exports) {

$parcel$export(module.exports, "mergeChunks", function () { return $194e412366013fc4$export$95bf8517f825dcc0; });
// NOTE: This assumes there are existing context lines.  If the existing
// chunk lines are only diff lines, this WILL BREAK.

var $cgl5P = parcelRequire("cgl5P");
function $194e412366013fc4$export$95bf8517f825dcc0(chunks, chunkIndex, contextLines, expandUp) {
    if (expandUp) {
        const oldChunk = chunks[chunkIndex];
        const newChunks = [
            ...chunks
        ];
        const newChunk = {
            ...oldChunk
        };
        const nextChunk = chunks[chunkIndex - 1] || {};
        const nextChunkBottom = nextChunk.oldStart + nextChunk.oldLines;
        const chunkTop = oldChunk.changes[0].oldLine;
        // @ts-ignore - assume existing contextLine
        const trimmedLines = contextLines.slice(nextChunkBottom - chunkTop);
        newChunk.changes = [
            ...nextChunk.changes,
            ...trimmedLines,
            ...oldChunk.changes
        ];
        newChunk.oldLines += trimmedLines.length + nextChunk.oldLines;
        newChunk.newLines += trimmedLines.length + nextChunk.newLines;
        newChunk.newStart = nextChunk.newStart;
        newChunk.oldStart = nextChunk.oldStart;
        newChunk.content = (0, $cgl5P.getContentString)(newChunk);
        newChunk.extra.before.hasMoreLines = nextChunk.extra.before.hasMoreLines;
        newChunks[chunkIndex] = newChunk;
        // delete previous chunk
        newChunks.splice(chunkIndex - 1, 1);
        return newChunks;
    } else {
        const oldChunk = chunks[chunkIndex];
        const newChunks = [
            ...chunks
        ];
        const newChunk = {
            ...oldChunk
        };
        const nextChunk = chunks[chunkIndex + 1] || {};
        const nextChunkTop = nextChunk.oldStart;
        const chunkBottom = oldChunk.changes[oldChunk.changes.length - 1].oldLine;
        // Only chunks with existing context lines will be merged,
        // which means .oldLine and chunkBottom will always be defined.
        // @ts-ignore
        const trimmedLines = contextLines.slice(0, nextChunkTop - chunkBottom - 1);
        newChunk.changes = [
            ...oldChunk.changes,
            ...trimmedLines,
            ...nextChunk.changes
        ];
        newChunk.oldLines += trimmedLines.length + nextChunk.oldLines;
        newChunk.newLines += trimmedLines.length + nextChunk.newLines;
        newChunk.content = (0, $cgl5P.getContentString)(newChunk);
        newChunk.extra.after.hasMoreLines = nextChunk.extra.after.hasMoreLines;
        newChunks[chunkIndex] = newChunk;
        // delete next chunk
        newChunks.splice(chunkIndex + 1, 1);
        return newChunks;
    }
}

});

parcelRegister("eu8P0", function(module, exports) {

$parcel$export(module.exports, "simpleAppend", function () { return $fc9229213ec43211$export$2958a5d3e058ece5; });
$parcel$export(module.exports, "simplePrepend", function () { return $fc9229213ec43211$export$475ed774197052a2; });
// NOTE: This assumes there are existing context lines.  If the existing
// chunk lines are only diff lines, this WILL BREAK.

var $cgl5P = parcelRequire("cgl5P");
function $fc9229213ec43211$export$2958a5d3e058ece5(chunks, chunkIndex, contextLines, hasMoreLines) {
    const oldChunk = chunks[chunkIndex];
    const newChunk = {
        ...oldChunk
    };
    const newChunks = [
        ...chunks
    ];
    newChunk.changes = [
        ...oldChunk.changes,
        ...contextLines
    ];
    newChunk.oldLines += contextLines.length;
    newChunk.newLines += contextLines.length;
    newChunk.content = (0, $cgl5P.getContentString)(newChunk);
    newChunk.extra.after.hasMoreLines = hasMoreLines;
    newChunks[chunkIndex] = newChunk;
    return newChunks;
}
function $fc9229213ec43211$export$475ed774197052a2(chunks, chunkIndex, contextLines, hasMoreLines) {
    const oldChunk = chunks[chunkIndex];
    const newChunks = [
        ...chunks
    ];
    const newChunk = {
        ...oldChunk
    };
    newChunk.changes = [
        ...contextLines,
        ...oldChunk.changes
    ];
    newChunk.oldStart -= contextLines.length;
    newChunk.newStart -= contextLines.length;
    newChunk.oldLines += contextLines.length;
    newChunk.newLines += contextLines.length;
    newChunk.content = (0, $cgl5P.getContentString)(newChunk);
    newChunk.extra.before.hasMoreLines = hasMoreLines;
    if (newChunk.oldStart === 1) newChunk.extra.before.hasMoreLines = false;
    newChunks[chunkIndex] = newChunk;
    return newChunks;
}

});


parcelRegister("lVt5b", function(module, exports) {

$parcel$export(module.exports, "prependToChunk", function () { return $e9842976ee0d766f$export$9c8fc138afbd2db8; });
// NOTE: This assumes there are existing context lines.  If the existing
// chunk lines are only diff lines, this WILL BREAK.

var $gFnct = parcelRequire("gFnct");

var $bz3Zc = parcelRequire("bz3Zc");

var $eu8P0 = parcelRequire("eu8P0");
function $e9842976ee0d766f$export$9c8fc138afbd2db8(chunks, chunkIndex, contextLines, hasMoreLines) {
    if ((0, $gFnct.chunksWillConnect)(chunks, chunkIndex, contextLines, true)) return (0, $bz3Zc.mergeChunks)(chunks, chunkIndex, contextLines, true);
    return (0, $eu8P0.simplePrepend)(chunks, chunkIndex, contextLines, hasMoreLines);
}

});


parcelRegister("8mswv", function(module, exports) {

$parcel$export(module.exports, "FetchEntireFile", function () { return $5fe774d34d84dbd1$export$4e508aa7a2db38c1; });
$parcel$export(module.exports, "VIEW_ENTIRE_FILE", function () { return $5fe774d34d84dbd1$export$1b6dd756bf1337f6; });
$parcel$export(module.exports, "closeViewEntireFileDialog", function () { return $5fe774d34d84dbd1$export$9442f2690c005673; });
$parcel$export(module.exports, "finishedClosingViewEntireFileDialog", function () { return $5fe774d34d84dbd1$export$3ce32b763a187a92; });
$parcel$export(module.exports, "viewEntireFile", function () { return $5fe774d34d84dbd1$export$ba44ab681759b4f2; });
$parcel$export(module.exports, "viewEntireFileInitialState", function () { return $5fe774d34d84dbd1$export$b1b9b090a93dc42d; });
$parcel$export(module.exports, "getIsViewEntireFileLoading", function () { return $5fe774d34d84dbd1$export$57299c270ce9ed85; });
$parcel$export(module.exports, "getViewEntireFileHasError", function () { return $5fe774d34d84dbd1$export$32b62b253055b86e; });
$parcel$export(module.exports, "getViewEntireFileParsedDiffFile", function () { return $5fe774d34d84dbd1$export$bd5bb32af703d766; });
$parcel$export(module.exports, "getViewEntireFilePath", function () { return $5fe774d34d84dbd1$export$609b391af7702c29; });
$parcel$export(module.exports, "getIsViewEntireFileDialogOpen", function () { return $5fe774d34d84dbd1$export$c1099e626e7f7803; });
$parcel$export(module.exports, "getIsViewEntireFileTooLarge", function () { return $5fe774d34d84dbd1$export$469813aebfe3920c; });
$parcel$export(module.exports, "default", function () { return $5fe774d34d84dbd1$export$2e2bcd8739ae039; });

var $aXXtM = parcelRequire("aXXtM");
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");

var $K8Ikq = parcelRequire("K8Ikq");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $1EkdU = parcelRequire("1EkdU");
// Action Types
const $5fe774d34d84dbd1$var$CLOSE_VIEW_ENTIRE_FILE_DIALOG = (0, $6D21P.prefixed)("CLOSE_VIEW_ENTIRE_FILE_DIALOG");
const $5fe774d34d84dbd1$var$FINISHED_CLOSING_VIEW_ENTIRE_FILE_DIALOG = (0, $6D21P.prefixed)("FINISHED_CLOSING_VIEW_ENTIRE_FILE_DIALOG");
const $5fe774d34d84dbd1$export$4e508aa7a2db38c1 = (0, $2MctD.createAsyncAction)((0, $6D21P.prefixed)("FETCH_ENTIRE_FILE"));
const $5fe774d34d84dbd1$export$1b6dd756bf1337f6 = (0, $6D21P.prefixed)("VIEW_ENTIRE_FILE");
const $5fe774d34d84dbd1$export$9442f2690c005673 = ()=>({
        type: $5fe774d34d84dbd1$var$CLOSE_VIEW_ENTIRE_FILE_DIALOG
    });
const $5fe774d34d84dbd1$export$3ce32b763a187a92 = ()=>({
        type: $5fe774d34d84dbd1$var$FINISHED_CLOSING_VIEW_ENTIRE_FILE_DIALOG
    });
const $5fe774d34d84dbd1$export$ba44ab681759b4f2 = (path, url, topicDiff)=>({
        type: $5fe774d34d84dbd1$export$1b6dd756bf1337f6,
        payload: {
            path: path,
            url: url,
            topicDiff: topicDiff
        }
    });
const $5fe774d34d84dbd1$export$b1b9b090a93dc42d = {
    hasError: false,
    isDialogOpen: false,
    isLoading: false,
    parsedDiffFile: null,
    path: null
};
// Selectors
const $5fe774d34d84dbd1$var$getViewEntireFileSlice = (0, $aXXtM.createSelector)((0, $1EkdU.getPullRequestSlice), (pullRequestState)=>pullRequestState.viewEntireFile);
const $5fe774d34d84dbd1$export$57299c270ce9ed85 = (0, $aXXtM.createSelector)($5fe774d34d84dbd1$var$getViewEntireFileSlice, (state)=>state.isLoading);
const $5fe774d34d84dbd1$export$32b62b253055b86e = (0, $aXXtM.createSelector)($5fe774d34d84dbd1$var$getViewEntireFileSlice, (state)=>state.hasError);
const $5fe774d34d84dbd1$export$bd5bb32af703d766 = (0, $aXXtM.createSelector)($5fe774d34d84dbd1$var$getViewEntireFileSlice, (state)=>state.parsedDiffFile);
const $5fe774d34d84dbd1$export$609b391af7702c29 = (0, $aXXtM.createSelector)($5fe774d34d84dbd1$var$getViewEntireFileSlice, (state)=>state.path);
const $5fe774d34d84dbd1$export$c1099e626e7f7803 = (0, $aXXtM.createSelector)($5fe774d34d84dbd1$var$getViewEntireFileSlice, (state)=>state.isDialogOpen);
const $5fe774d34d84dbd1$export$469813aebfe3920c = (0, $aXXtM.createSelector)($5fe774d34d84dbd1$export$bd5bb32af703d766, (0, $1EkdU.getIsSingleFileModeActive), (0, $1EkdU.getPullRequestRenderingLimits), (file, isSingleFileModeActive, renderingLimits)=>file ? (0, $K8Ikq.isExcessiveSizeEntireFile)(file, isSingleFileModeActive, renderingLimits) : false);
var // Reducer
$5fe774d34d84dbd1$export$2e2bcd8739ae039 = (state = $5fe774d34d84dbd1$export$b1b9b090a93dc42d, action)=>{
    switch(action.type){
        // When the user closes the dialog, just the open state is changed so that the dialog contents
        // do not change while the dialog exit animation is happening.
        case $5fe774d34d84dbd1$var$CLOSE_VIEW_ENTIRE_FILE_DIALOG:
            return {
                ...state,
                isDialogOpen: false
            };
        // Reset the state upon the dialog exit animation finishing, so we don't hold the file contents
        // in memory, and to prevent a flash of the previous dialog's contents upon opening the next one
        case $5fe774d34d84dbd1$var$FINISHED_CLOSING_VIEW_ENTIRE_FILE_DIALOG:
            return {
                ...state,
                ...$5fe774d34d84dbd1$export$b1b9b090a93dc42d
            };
        case $5fe774d34d84dbd1$export$4e508aa7a2db38c1.REQUEST:
            return {
                ...state,
                hasError: false,
                isLoading: true,
                parsedDiffFile: null
            };
        case $5fe774d34d84dbd1$export$4e508aa7a2db38c1.SUCCESS:
            return {
                ...state,
                hasError: false,
                isLoading: false,
                parsedDiffFile: action.payload[0]
            };
        case $5fe774d34d84dbd1$export$4e508aa7a2db38c1.ERROR:
            return {
                ...state,
                hasError: true,
                isLoading: false
            };
        case $5fe774d34d84dbd1$export$1b6dd756bf1337f6:
            return {
                ...state,
                isDialogOpen: true,
                path: action.payload.path
            };
        default:
            return state;
    }
};

});



parcelRegister("677Fr", function(module, exports) {

$parcel$export(module.exports, "hasTransitioned", function () { return $b2b75f8994d8f86d$export$6b671f1c76eea18; });
$parcel$export(module.exports, "default", function () { return $b2b75f8994d8f86d$export$2e2bcd8739ae039; });

var $7wvDE = parcelRequire("7wvDE");

var $2AJeO = parcelRequire("2AJeO");
const $b2b75f8994d8f86d$var$browserHistory = (0, $7wvDE.createBrowserHistory)();
let $b2b75f8994d8f86d$var$transitioned = false;
$b2b75f8994d8f86d$var$browserHistory.listen((_, action)=>{
    // if action is POP or PUSH a transition has occured
    if (action !== "REPLACE") $b2b75f8994d8f86d$var$transitioned = true;
});
const $b2b75f8994d8f86d$export$6b671f1c76eea18 = ()=>$b2b75f8994d8f86d$var$transitioned;
const $b2b75f8994d8f86d$export$9d22973adb523569 = (history)=>{
    let cleaned = false;
    let listeners = [];
    // @ts-ignore TODO: fix noImplicitAny error here
    const listen = (callback)=>{
        if (cleaned) return ()=>{};
        const unsubscribe = (0, $2AJeO.default)(history.listen(callback));
        const listener = {
            unsubscribe: unsubscribe
        };
        listeners.push(listener);
        return (0, $2AJeO.default)(()=>{
            listener.unsubscribe();
        });
    };
    const cleanup = ()=>{
        listeners.forEach(({ unsubscribe: unsubscribe })=>{
            unsubscribe();
        });
        cleaned = true;
        listeners = [];
    };
    return {
        length: history.length,
        location: history.location,
        action: history.action,
        index: history.index,
        entries: history.entries,
        // @ts-ignore TODO: fix noImplicitAny error here
        push: (path, params)=>history.push(path, params),
        // @ts-ignore TODO: fix noImplicitAny error here
        replace: (path, params)=>history.replace(path, params),
        go: (n)=>history.go(n),
        goBack: ()=>history.goBack(),
        goForward: ()=>history.goForward(),
        // @ts-ignore TODO: fix noImplicitAny error here
        createHref: (...args)=>history.createHref(...args),
        // Memory only
        canGo: (n)=>{
            if (history.canGo) return history.canGo(n);
            return true;
        },
        listen: listen,
        // @ts-ignore TODO: fix noImplicitAny error here
        block: (blocker)=>history.block(blocker),
        destroy: cleanup
    };
};
var $b2b75f8994d8f86d$export$2e2bcd8739ae039 = $b2b75f8994d8f86d$var$browserHistory;

});
parcelRegister("2AJeO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e3208da411c464a$export$2e2bcd8739ae039; });

var $g3pTJ = parcelRequire("g3pTJ");
/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */ function $1e3208da411c464a$var$once(func) {
    return (0, $g3pTJ.default)(2, func);
}
var $1e3208da411c464a$export$2e2bcd8739ae039 = $1e3208da411c464a$var$once;

});
parcelRegister("g3pTJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb0103e96551fa96$export$2e2bcd8739ae039; });

var $1W9wP = parcelRequire("1W9wP");
/** Error message constants. */ var $bb0103e96551fa96$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */ function $bb0103e96551fa96$var$before(n, func) {
    var result;
    if (typeof func != "function") throw new TypeError($bb0103e96551fa96$var$FUNC_ERROR_TEXT);
    n = (0, $1W9wP.default)(n);
    return function() {
        if (--n > 0) result = func.apply(this, arguments);
        if (n <= 1) func = undefined;
        return result;
    };
}
var $bb0103e96551fa96$export$2e2bcd8739ae039 = $bb0103e96551fa96$var$before;

});



parcelRegister("aqJ0c", function(module, exports) {

$parcel$export(module.exports, "fetchSourceRepositoryDetailsQuery", function () { return $8869f6f588846f70$export$42d4892b251041c8; });
$parcel$export(module.exports, "fetchSourceRepositoryDetails", function () { return $8869f6f588846f70$export$8efc2b994bcef234; });

var $cJH1T = parcelRequire("cJH1T");
parcelRequire("5YpaN");
var $fICwP = parcelRequire("fICwP");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");

var $kZnTB = parcelRequire("kZnTB");
const $8869f6f588846f70$export$42d4892b251041c8 = (0, $cJH1T.stringify)({
    fields: "+parent.mainbranch.*"
});
const $8869f6f588846f70$export$8efc2b994bcef234 = (repositoryFullSlug)=>{
    return (0, $fICwP.fetchAction)((0, $jJd6W.FetchSourceRepositoryDetails), {
        url: `${(0, $kZnTB.default).api.internal.details(repositoryFullSlug)}?${$8869f6f588846f70$export$42d4892b251041c8}`
    });
};

});

parcelRegister("66z6m", function(module, exports) {

$parcel$export(module.exports, "makeBackbucketSafeNow", function () { return $f0c4c780186bae70$export$e51bbe0f30783c22; });
$parcel$export(module.exports, "fetchPullRequest", function () { return $f0c4c780186bae70$export$9ab84ec70215d5ad; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $lIZwG = parcelRequire("lIZwG");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $b2RHC = parcelRequire("b2RHC");

var $1EkdU = parcelRequire("1EkdU");

var $g8glp = parcelRequire("g8glp");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $aqJ0c = parcelRequire("aqJ0c");
const $f0c4c780186bae70$export$e51bbe0f30783c22 = ()=>new Date().toISOString().replace(/Z/, "");
function* $f0c4c780186bae70$var$fetchSourceRepositoryDetailsSaga(sourceFullName) {
    yield (0, $5NpoY.Y)((0, $aqJ0c.fetchSourceRepositoryDetails)(sourceFullName));
}
function* $f0c4c780186bae70$var$completePullRequestUpdate(pullRequest) {
    if (pullRequest) {
        const sourceFullName = (0, $lIZwG.default)(pullRequest, [
            "currentPullRequest",
            "source",
            "repository",
            "full_name"
        ]);
        const destinationFullName = (0, $lIZwG.default)(pullRequest, [
            "currentPullRequest",
            "destination",
            "repository",
            "full_name"
        ]);
        if (sourceFullName && sourceFullName !== destinationFullName) yield (0, $5NpoY.N)($f0c4c780186bae70$var$fetchSourceRepositoryDetailsSaga, sourceFullName);
    }
    yield (0, $5NpoY.Y)({
        type: (0, $6D21P.LOAD_PULL_REQUEST).SUCCESS,
        payload: {
            ...pullRequest,
            lastPoll: $f0c4c780186bae70$export$e51bbe0f30783c22()
        },
        meta: {
            schema: {
                currentPullRequest: (0, $b2RHC.pullRequest),
                // Once we're 100% on commits api usage this can be removed
                commits: [
                    (0, $b2RHC.commit)
                ]
            }
        }
    });
}
function* $f0c4c780186bae70$export$9ab84ec70215d5ad(urlPieces) {
    const api = yield* (0, $g8glp.getPullRequestApis)();
    // eslint-disable-next-line no-param-reassign
    urlPieces = urlPieces || (yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces)));
    if (!urlPieces) return;
    const { owner: owner, slug: slug, id: id } = urlPieces;
    try {
        // @ts-ignore
        const pullRequest = yield (0, $5NpoY.P)(api.getPullRequest, owner, slug, id);
        yield (0, $5NpoY.P)($f0c4c780186bae70$var$completePullRequestUpdate, pullRequest);
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.LOAD_PULL_REQUEST).ERROR
        });
    }
}

});
parcelRegister("g8glp", function(module, exports) {

$parcel$export(module.exports, "SAGAS_CONTEXT_KEY_PR_APIS", function () { return $b7ab2f1f5503df05$export$cdc7ffbf56102b6b; });
$parcel$export(module.exports, "SAGAS_CONTEXT_KEY_PIPELINES_WEBSOCKET", function () { return $b7ab2f1f5503df05$export$14d8f7b773c8afde; });
$parcel$export(module.exports, "getPullRequestApis", function () { return $b7ab2f1f5503df05$export$9f7215721f0158a3; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
const $b7ab2f1f5503df05$export$cdc7ffbf56102b6b = "pullRequestApi";
const $b7ab2f1f5503df05$export$14d8f7b773c8afde = "pipelinesWebSocket";
function* $b7ab2f1f5503df05$export$9f7215721f0158a3() {
    const api = yield (0, $5NpoY.a6)($b7ab2f1f5503df05$export$cdc7ffbf56102b6b);
    return api;
}

});



parcelRegister("h91BB", function(module, exports) {

$parcel$export(module.exports, "loadRepositoryDetailsResource", function () { return $d0413860f2bb54cb$export$bc2604c6be2cf32e; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");
parcelRequire("5YpaN");
var $fICwP = parcelRequire("fICwP");
var $8NQo6 = parcelRequire("8NQo6");

var $677Fr = parcelRequire("677Fr");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");

var $jTcAB = parcelRequire("jTcAB");

var $48ZQ3 = parcelRequire("48ZQ3");

var $kZnTB = parcelRequire("kZnTB");

var $aanBq = parcelRequire("aanBq");

var $4tq7P = parcelRequire("4tq7P");

var $1tZyI = parcelRequire("1tZyI");
const $d0413860f2bb54cb$export$bc2604c6be2cf32e = (0, $3kfkg.createResource)({
    type: "repository-details",
    getKey: ({ match: match })=>`details:${(0, $4tq7P.getRepoFullSlug)(match.params)}`,
    maxAge: 0,
    getData: async (routerStoreContext, { reduxStore: reduxStore, csrftoken: csrftoken })=>{
        const { dispatch: dispatch } = reduxStore;
        const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug } = routerStoreContext.match.params;
        const repositoryFullSlug = `${repositoryOwner}/${repositorySlug}`;
        // Only fetch data if the repository has changed, or on initial load
        const state = reduxStore.getState();
        if ((0, $1tZyI.isSameRepository)(repositoryFullSlug, state) && // check to make sure we have details in state
        (0, $aanBq.getRepositoryAccessLevel)(state) && // The redux store has already been populated by the time we reach here on initial load,
        // (possibly by a previous resource?) so we wouldn't be fetching any data at that point
        // without this additional check
        (0, $677Fr.hasTransitioned)()) return {
            status: "success"
        };
        const action = (0, $fICwP.fetchAction)((0, $jJd6W.FetchRepositoryDetails), {
            url: `${(0, $kZnTB.default).api.internal.details(repositoryFullSlug)}?${(0, $jTcAB.query)}`,
            csrftoken: csrftoken,
            schema: {
                parent: (0, $48ZQ3.repository)
            }
        });
        const result = await dispatch((0, $8NQo6.fetchDataFromResource)(action));
        if ((result === null || result === void 0 ? void 0 : result.type) === (0, $jJd6W.FetchRepositoryDetails).ERROR) return null;
        return {
            status: "success"
        };
    }
});

});
parcelRegister("jTcAB", function(module, exports) {

$parcel$export(module.exports, "query", function () { return $08ab3d06a03fe8e5$export$2fa187e846a241c4; });
$parcel$export(module.exports, "default", function () { return $08ab3d06a03fe8e5$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "fetchIsPipelinesEnabled", function () { return $08ab3d06a03fe8e5$export$3ec12a54c20df8f2; });
$parcel$export(module.exports, "fetchWorkspacePlan", function () { return $08ab3d06a03fe8e5$export$bb5008299b9c4990; });

var $cJH1T = parcelRequire("cJH1T");
parcelRequire("5YpaN");
var $fICwP = parcelRequire("fICwP");

var $5Put2 = parcelRequire("5Put2");

var $48ZQ3 = parcelRequire("48ZQ3");

var $kZnTB = parcelRequire("kZnTB");

var $jJd6W = parcelRequire("jJd6W");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");
const $08ab3d06a03fe8e5$export$2fa187e846a241c4 = (0, $cJH1T.stringify)({
    fields: "+parent.mainbranch.*"
});
var $08ab3d06a03fe8e5$export$2e2bcd8739ae039 = (repositoryFullSlug)=>{
    return (0, $fICwP.fetchAction)((0, $jJd6W.FetchRepositoryDetails), {
        url: `${(0, $kZnTB.default).api.internal.details(repositoryFullSlug)}?${$08ab3d06a03fe8e5$export$2fa187e846a241c4}`,
        schema: {
            parent: (0, $48ZQ3.repository)
        }
    });
};
const $08ab3d06a03fe8e5$export$3ec12a54c20df8f2 = ()=>({
        type: (0, $jJd6W.FETCH_IS_PIPELINES_ENABLED).REQUEST
    });
const $08ab3d06a03fe8e5$export$bb5008299b9c4990 = (workspaceSlug)=>({
        type: (0, $5Put2.FETCH_WORKSPACE_PLAN).REQUEST,
        payload: {
            workspaceSlug: workspaceSlug
        }
    });

});
parcelRegister("5Put2", function(module, exports) {

$parcel$export(module.exports, "ADD_RECENTLY_VIEWED_WORKSPACE", function () { return $6b1dab3163faaed5$export$eabd73b3fadb77b3; });
$parcel$export(module.exports, "GET_RECENTLY_VIEWED_WORKSPACES", function () { return $6b1dab3163faaed5$export$db4b7c175d3261e1; });
$parcel$export(module.exports, "FETCH_WORKSPACE_PLAN", function () { return $6b1dab3163faaed5$export$8163974869361255; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
const $6b1dab3163faaed5$export$eabd73b3fadb77b3 = "workspace/ADD_RECENTLY_VIEWED_WORKSPACE";
const $6b1dab3163faaed5$export$db4b7c175d3261e1 = "workspace/GET_RECENTLY_VIEWED_WORKSPACES";
const $6b1dab3163faaed5$export$8163974869361255 = (0, $2MctD.createAsyncAction)("workspace/FETCH_WORKSPACE_PLAN");

});


parcelRegister("4tq7P", function(module, exports) {

$parcel$export(module.exports, "getRepoFullSlug", function () { return $c07ab2dd030866cb$export$45f54dc784b5c4d7; });
const $c07ab2dd030866cb$export$45f54dc784b5c4d7 = ({ repositoryFullSlug: slug, repositoryOwner: repositoryOwner, repositorySlug: repositorySlug })=>slug || `${repositoryOwner}/${repositorySlug}`;

});

parcelRegister("1tZyI", function(module, exports) {

$parcel$export(module.exports, "isSameRepository", function () { return $bd533a8d44486d0b$export$c4f17314e25f1803; });

var $aanBq = parcelRequire("aanBq");
const $bd533a8d44486d0b$export$c4f17314e25f1803 = (repositoryFullSlug, state)=>{
    const currentRepoFullSlug = (0, $aanBq.getCurrentRepositoryFullSlug)(state);
    return !!currentRepoFullSlug && currentRepoFullSlug === repositoryFullSlug;
};

});


parcelRegister("2ppog", function(module, exports) {

$parcel$export(module.exports, "loadRepositoryResource", function () { return $6ebbbae28159075a$export$76570c153a677d2f; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $fE4bV = parcelRequire("fE4bV");
parcelRequire("5YpaN");
var $kTw57 = parcelRequire("kTw57");
var $fICwP = parcelRequire("fICwP");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");

var $Sv0NW = parcelRequire("Sv0NW");

var $48ZQ3 = parcelRequire("48ZQ3");

var $3nrvH = parcelRequire("3nrvH");

var $4tq7P = parcelRequire("4tq7P");

var $1tZyI = parcelRequire("1tZyI");
const $6ebbbae28159075a$export$76570c153a677d2f = (0, $3kfkg.createResource)({
    type: "repository",
    getKey: ({ match: match })=>`repository:${(0, $4tq7P.getRepoFullSlug)(match.params)}`,
    maxAge: 0,
    getData: async (routerStoreContext, { reduxStore: reduxStore, csrftoken: csrftoken })=>{
        const { dispatch: dispatch } = reduxStore;
        const repositoryFullSlug = (0, $4tq7P.getRepoFullSlug)(routerStoreContext.match.params);
        const url = `/${repositoryFullSlug}`;
        // don't fetch data if repository hasn't changed
        if ((0, $1tZyI.isSameRepository)(repositoryFullSlug, reduxStore.getState())) return {
            status: "success"
        };
        const action = (0, $fICwP.hydrateAction)((0, $jJd6W.LoadRepositoryPage), (0, $Sv0NW.stateKey), {
            url: url,
            isRouterResource: true,
            csrftoken: csrftoken,
            schema: {
                currentRepository: (0, $48ZQ3.repository)
            }
        });
        const hydrateAction = (0, $fE4bV.getHydrateAction)(action, (0, $Sv0NW.stateKey));
        if (hydrateAction) {
            dispatch(hydrateAction);
            return {
                status: "success"
            };
        }
        action.meta.url = (0, $3nrvH.urlWithState)(url, (0, $Sv0NW.stateKey));
        dispatch(action);
        await dispatch((0, $kTw57.fetchData)(action));
        return {
            status: "success"
        };
    }
});

});
parcelRegister("Sv0NW", function(module, exports) {

$parcel$export(module.exports, "stateKey", function () { return $55ced397b6b9e051$export$77b371d6becc8882; });
$parcel$export(module.exports, "default", function () { return $55ced397b6b9e051$export$2e2bcd8739ae039; });
parcelRequire("5YpaN");
var $fICwP = parcelRequire("fICwP");

var $48ZQ3 = parcelRequire("48ZQ3");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");
const $55ced397b6b9e051$export$77b371d6becc8882 = [
    "repository.section",
    "section.repository"
];
var $55ced397b6b9e051$export$2e2bcd8739ae039 = (repositoryFullSlug)=>(0, $fICwP.hydrateAction)((0, $jJd6W.LoadRepositoryPage), $55ced397b6b9e051$export$77b371d6becc8882, {
        url: `/${repositoryFullSlug}`,
        schema: {
            currentRepository: (0, $48ZQ3.repository)
        }
    });

});


parcelRegister("3qRfc", function(module, exports) {

$parcel$export(module.exports, "loadRepositoryResourcePipelines", function () { return $612063b8073b9ab6$export$2e8d23454c6744b4; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $2ppog = parcelRequire("2ppog");

var $4tq7P = parcelRequire("4tq7P");
const $612063b8073b9ab6$export$2e8d23454c6744b4 = (0, $3kfkg.createResource)({
    type: "repository",
    getKey: ({ match: match })=>`repository:${(0, $4tq7P.getRepoFullSlug)(match.params)}`,
    maxAge: 0,
    getData: (routerStoreContext, resourceContext)=>{
        if (location.hash.startsWith("#!/")) return {
            status: "success"
        };
        return (0, $2ppog.loadRepositoryResource).getData(routerStoreContext, resourceContext);
    }
});

});

parcelRegister("a5zrX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c135dfbfcedb58f$export$2e2bcd8739ae039; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

var $4c135dfbfcedb58f$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("gY0bG")),
    modules: [
        "./page"
    ],
    webpack: ()=>[
            undefined("./page")
        ]
});

});
parcelRegister("gY0bG", function(module, exports) {
















module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvUP")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6qh0x")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kjN9y")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("e0Fn7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fDD7i")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7xLkx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3op3S")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("bEMdz"))
]).then(()=>parcelRequire("3spnF"));

});


parcelRegister("k5krn", function(module, exports) {

$parcel$export(module.exports, "repositoryNavigationResource", function () { return $4b9666c5e5e48cf2$export$a7f6ab681ea8e68a; });

var $cJH1T = parcelRequire("cJH1T");
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $5WlOY = parcelRequire("5WlOY");

var $k2cPS = parcelRequire("k2cPS");
const $4b9666c5e5e48cf2$export$a7f6ab681ea8e68a = (0, $3kfkg.createResource)({
    type: "REPOSITORY_NAVIGATION",
    getKey: ({ match: match })=>{
        if (match.params.repositoryFullSlug) return `repository:${match.params.repositoryFullSlug}`;
        else return `repository:${match.params.repositoryOwner}/${match.params.repositorySlug}`;
    },
    maxAge: 600000,
    // 10 minute
    getData: async ({ match: match })=>{
        const { repositoryFullSlug: repositoryFullSlug, repositoryOwner: repositoryOwner, repositorySlug: repositorySlug } = match.params;
        const repo = repositoryFullSlug !== null && repositoryFullSlug !== void 0 ? repositoryFullSlug : `${repositoryOwner}/${repositorySlug}`;
        const url = (0, $5WlOY.default).api.internal.navigation(repo);
        // TODO once we start using this for actual navigation data, include menuItems below
        const query = (0, $cJH1T.stringify)({
            fields: "+repository.landing_page,-menuItems"
        });
        const response = await fetch((0, $k2cPS.default)(`${url}?${query}`, {
            headers: (0, $k2cPS.jsonHeaders)
        }));
        if (!response.ok) throw new Error(`Error fetching repository navigation data (${response.status}): ${response.statusText}`);
        return response.json();
    }
});

});

parcelRegister("8weAu", function(module, exports) {

$parcel$export(module.exports, "RepoSettingsAccessKeysLoadable", function () { return $02fea9ecc9911f22$export$d5a73cf2f38a407e; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

var $84nlJ = parcelRequire("84nlJ");

const $02fea9ecc9911f22$export$4dbc52222ff088ab = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("9Y3Zc")),
    modules: [
        "./access-keys"
    ],
    webpack: ()=>[
            undefined("./access-keys")
        ]
});

const $02fea9ecc9911f22$export$d5a73cf2f38a407e = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("63mFB")),
    modules: [
        "./access-keys-legacy"
    ],
    webpack: ()=>[
            undefined("./access-keys-legacy")
        ]
});

});
parcelRegister("84nlJ", function(module, exports) {

$parcel$export(module.exports, "fetchSshKeys", function () { return $e864d883db032356$export$704e33fea2358855; });
$parcel$export(module.exports, "loadRepositorySettingsAccessKeysResource", function () { return $e864d883db032356$export$bc3637569b3402f2; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $7Me5Z = parcelRequire("7Me5Z");

var $kZnTB = parcelRequire("kZnTB");

var $jzmnA = parcelRequire("jzmnA");
const $e864d883db032356$export$704e33fea2358855 = (repositoryOwner, repositorySlug)=>(options)=>(0, $jzmnA.httpRequest)().get((0, $kZnTB.default).api.v20.deployKeys(repositoryOwner, repositorySlug, {
            ...options
        }));
const $e864d883db032356$export$bc3637569b3402f2 = (0, $3kfkg.createResource)({
    type: "repoAdminAccessKeys",
    getKey: ({ match: match })=>{
        const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug } = match.params;
        return (0, $kZnTB.default).ui.adminPage(repositoryOwner, repositorySlug, "access-keys");
    },
    maxAge: 60000,
    // cache for 1 minute so navigating between pages is fast
    getData: ({ match: match })=>{
        const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug } = match.params;
        if (!repositoryOwner || !repositorySlug) throw new Error("Could not fetch, repositorySlug/repositoryOwner URL param was not available");
        const { pagelen: pagelen = (0, $7Me5Z.DEFAULT_ROWS_PER_PAGE), page: page = 1, sort: sort } = match.query;
        return $e864d883db032356$export$704e33fea2358855(repositoryOwner, repositorySlug)({
            pagelen: ~~pagelen,
            page: ~~page,
            sort: sort
        });
    }
});

});

parcelRegister("9Y3Zc", function(module, exports) {














module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6SfDR")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6cSLd")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("1kPIJ")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6XRs7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c7qp4")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("dGcc6"))
]).then(()=>parcelRequire("9uQDf"));

});

parcelRegister("63mFB", function(module, exports) {














module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6SfDR")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6cSLd")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("1kPIJ")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6XRs7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c7qp4")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6kPvB"))
]).then(()=>parcelRequire("lfV26"));

});


parcelRegister("gq9I5", function(module, exports) {

$parcel$export(module.exports, "AccessTokensLoadable", function () { return $8332afcee4eb100a$export$6131a996f780a55c; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $8332afcee4eb100a$export$6131a996f780a55c = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("3x81O")),
    modules: [
        "./access-tokens"
    ],
    webpack: ()=>[
            undefined("./access-tokens")
        ]
});

});
parcelRegister("3x81O", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2H5Nx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("eWB8F")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c7qp4")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("1ysBT"))
]).then(()=>parcelRequire("guKED"));

});


parcelRegister("amI74", function(module, exports) {

$parcel$export(module.exports, "BranchRestrictionsLoadable", function () { return $19d8fb3175fd7f05$export$a43151c394132253; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $19d8fb3175fd7f05$export$a43151c394132253 = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("aFHRm")),
    modules: [
        "./branch-restrictions"
    ],
    webpack: ()=>[
            undefined("./branch-restrictions")
        ]
});

});
parcelRegister("aFHRm", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kBzNL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fVUDo")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("hCFmN")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9uabR")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("16eyk"))
]).then(()=>parcelRequire("fpOAn"));

});


parcelRegister("gP97l", function(module, exports) {

$parcel$export(module.exports, "BranchingModelLoadable", function () { return $f5014a96037a5c61$export$1050d85af2c45bed; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $f5014a96037a5c61$export$1050d85af2c45bed = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("6aa09")),
    modules: [
        "./branching-model"
    ],
    webpack: ()=>[
            undefined("./branching-model")
        ]
});

});
parcelRegister("6aa09", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("567XC")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kBzNL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("cuZzM"))
]).then(()=>parcelRequire("4kFDI"));

});


parcelRegister("5k8TG", function(module, exports) {

$parcel$export(module.exports, "DefaultReviewGroupsLoadable", function () { return $862dafe6ac408d33$export$4f6dfb73a2bbc4b1; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $862dafe6ac408d33$export$4f6dfb73a2bbc4b1 = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("3QAxt")),
    modules: [
        "./default-review-groups"
    ],
    webpack: ()=>[
            undefined("./default-review-groups")
        ]
});

});
parcelRegister("3QAxt", function(module, exports) {










module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kBzNL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9uabR")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2MxGY")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8sXwO"))
]).then(()=>parcelRequire("hXMlk"));

});


parcelRegister("ekNC5", function(module, exports) {

$parcel$export(module.exports, "DefaultReviewersLoadable", function () { return $a5c41e1cfc79e957$export$ff88064bf46ef0ba; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $a5c41e1cfc79e957$export$ff88064bf46ef0ba = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("a2OUM")),
    modules: [
        "./default-reviewers"
    ],
    webpack: ()=>[
            undefined("./default-reviewers")
        ]
});

});
parcelRegister("a2OUM", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3IMuw")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8CUpx"))
]).then(()=>parcelRequire("e8VQ8"));

});


parcelRegister("9Ue31", function(module, exports) {

$parcel$export(module.exports, "MergeChecksLoadable", function () { return $748d69a32ca36840$export$a9ffd254eed7bd87; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $748d69a32ca36840$export$a9ffd254eed7bd87 = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("7TSOX")),
    modules: [
        "./merge-checks"
    ],
    webpack: ()=>[
            undefined("./merge-checks")
        ]
});

});
parcelRegister("7TSOX", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("luqjn")).then(()=>parcelRequire("gaUyU"));

});


parcelRegister("SUJHq", function(module, exports) {

$parcel$export(module.exports, "RepoSettingsMergeStrategiesLoadable", function () { return $b707348555fab487$export$8c5072876f268fc3; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $b707348555fab487$export$8c5072876f268fc3 = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("6yC4J")),
    modules: [
        "./merge-strategies"
    ],
    webpack: ()=>[
            undefined("./merge-strategies")
        ]
});

});
parcelRegister("6yC4J", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kBzNL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9uabR")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2pPjJ"))
]).then(()=>parcelRequire("8GHOs"));

});


parcelRegister("dQi9S", function(module, exports) {

$parcel$export(module.exports, "RepoSettingsPermissionsLoadable", function () { return $ad11dfecd8ba7d10$export$9e614be145443e7b; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $ad11dfecd8ba7d10$export$9e614be145443e7b = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("esAcP")),
    modules: [
        "./permissions"
    ],
    webpack: ()=>[
            undefined("./permissions")
        ]
});

});
parcelRegister("esAcP", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("hZpa1")).then(()=>parcelRequire("3dtRa"));

});


parcelRegister("e1tSr", function(module, exports) {

$parcel$export(module.exports, "fetchPermissions", function () { return $bb628ad0224bb9e6$export$4f24ecba11982e9d; });
$parcel$export(module.exports, "loadRepositorySettingsPermissionsResource", function () { return $bb628ad0224bb9e6$export$37b5f4b7ed2f6eb6; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");
parcelRequire("DVpDa");
var $5sg28 = parcelRequire("5sg28");
var $hCBEg = parcelRequire("hCBEg");

var $kZnTB = parcelRequire("kZnTB");

var $jzmnA = parcelRequire("jzmnA");
const $bb628ad0224bb9e6$export$4f24ecba11982e9d = (workspaceSlug, repositorySlug, { page: page = 1, accessLevel: accessLevel, permission: permission, principalName: principalName } = {})=>(0, $jzmnA.request)((0, $kZnTB.default).api.internal.inheritedPermissions(workspaceSlug, repositorySlug, {
        page: page,
        q: (0, $5sg28.buildBBQL)({
            accessLevel: accessLevel,
            permission: permission,
            principalName: principalName
        })
    }), {
        successTransformer: ({ values: values = [], page: pagenum, pagelen: pagelen, size: size })=>{
            return {
                permissions: new Map([
                    [
                        pagenum,
                        values.map((0, $hCBEg.mapInheritedUserAndGroupPrivilege))
                    ]
                ]),
                page: pagenum,
                limit: pagelen,
                total: size
            };
        }
    });
const $bb628ad0224bb9e6$export$37b5f4b7ed2f6eb6 = (0, $3kfkg.createResource)({
    type: "repoAdminPermissions",
    getKey: ({ match: match })=>{
        const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug } = match.params;
        return (0, $kZnTB.default).ui.adminPage(repositoryOwner, repositorySlug, "permissions");
    },
    maxAge: 60000,
    // cache for 1 minute so navigating between pages is fast
    getData: async ({ match: match })=>{
        const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug } = match.params;
        const permissions = await $bb628ad0224bb9e6$export$4f24ecba11982e9d(repositoryOwner, repositorySlug);
        // If fetch is successful, set initial access level to repository
        return {
            ...permissions,
            adminLevel: "repository"
        };
    }
});

});

parcelRegister("4Uhvl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f11a7d09c4eed42$export$2e2bcd8739ae039; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $3f11a7d09c4eed42$var$PipelinesRepoDeploymentsPageLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("cFtwt")),
    modules: [
        "./deployments"
    ],
    webpack: ()=>[
            undefined("./deployments")
        ]
});
var $3f11a7d09c4eed42$export$2e2bcd8739ae039 = $3f11a7d09c4eed42$var$PipelinesRepoDeploymentsPageLoadable;

});
parcelRegister("cFtwt", function(module, exports) {






















module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("k7j7T")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jDJuC")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("cFFKC")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9oryG")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3vzef")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("wQ8eQ")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kBzNL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3ECa9")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9uabR")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8iumh")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("lzNGy"))
]).then(()=>parcelRequire("Z9Gsb"));

});


parcelRegister("17McB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b19b07c5ee292027$export$2e2bcd8739ae039; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $b19b07c5ee292027$export$d593f8aa8d3e16b7 = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("aZV56")),
    modules: [
        "./dynamic-pipelines"
    ],
    webpack: ()=>[
            undefined("./dynamic-pipelines")
        ]
});
var $b19b07c5ee292027$export$2e2bcd8739ae039 = $b19b07c5ee292027$export$d593f8aa8d3e16b7;

});
parcelRegister("aZV56", function(module, exports) {














module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("eWSl0")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("k7j7T")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jDJuC")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("cFFKC")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3vzef")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3ECa9")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("ilr10"))
]).then(()=>parcelRequire("afFo5"));

});


parcelRegister("ccRPo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e96e152a82848125$export$2e2bcd8739ae039; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $e96e152a82848125$var$PipelinesRepoOpenIDPageLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("1FpCO")),
    modules: [
        "./openid"
    ],
    webpack: ()=>[
            undefined("./openid")
        ]
});
var $e96e152a82848125$export$2e2bcd8739ae039 = $e96e152a82848125$var$PipelinesRepoOpenIDPageLoadable;

});
parcelRegister("1FpCO", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2cqKR")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2H5Nx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c7qp4")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9aMm2"))
]).then(()=>parcelRequire("dFajj"));

});


parcelRegister("1zb3u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5c9afa0f4c4896f$export$2e2bcd8739ae039; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $a5c9afa0f4c4896f$export$944d4b3e9ff9fbd3 = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("eQNca")),
    modules: [
        "./runners"
    ],
    webpack: ()=>[
            undefined("./runners")
        ]
});
var $a5c9afa0f4c4896f$export$2e2bcd8739ae039 = $a5c9afa0f4c4896f$export$944d4b3e9ff9fbd3;

});
parcelRegister("eQNca", function(module, exports) {
























module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9gDpJ")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5gMKg")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("k7j7T")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jDJuC")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("cFFKC")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3vzef")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2cqKR")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2H5Nx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jokVj")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3ECa9")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c7qp4")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kZ0dj"))
]).then(()=>parcelRequire("2sF7o"));

});


parcelRegister("9KBU4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96a0809dfbba8d0d$export$2e2bcd8739ae039; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $96a0809dfbba8d0d$var$PipelinesRepoSettingsPageLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("6kReP")),
    modules: [
        "./settings"
    ],
    webpack: ()=>[
            undefined("./settings")
        ]
});
var $96a0809dfbba8d0d$export$2e2bcd8739ae039 = $96a0809dfbba8d0d$var$PipelinesRepoSettingsPageLoadable;

});
parcelRegister("6kReP", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kBzNL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9uabR")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("gDBZz"))
]).then(()=>parcelRequire("hAtJm"));

});


parcelRegister("4kLie", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39c13585f13a506c$export$2e2bcd8739ae039; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $39c13585f13a506c$var$PipelinesRepoSshKeysPageLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("4IRuF")),
    modules: [
        "./ssh-keys"
    ],
    webpack: ()=>[
            undefined("./ssh-keys")
        ]
});
var $39c13585f13a506c$export$2e2bcd8739ae039 = $39c13585f13a506c$var$PipelinesRepoSshKeysPageLoadable;

});
parcelRegister("4IRuF", function(module, exports) {














module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("k7j7T")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jDJuC")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("cFFKC")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3vzef")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3ECa9")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3pLdI"))
]).then(()=>parcelRequire("I40XL"));

});


parcelRegister("1uV8K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26b90e5c27130304$export$2e2bcd8739ae039; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $26b90e5c27130304$var$PipelinesRepoVariablesPageLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("i3c7N")),
    modules: [
        "./variables"
    ],
    webpack: ()=>[
            undefined("./variables")
        ]
});
var $26b90e5c27130304$export$2e2bcd8739ae039 = $26b90e5c27130304$var$PipelinesRepoVariablesPageLoadable;

});
parcelRegister("i3c7N", function(module, exports) {


















module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("k7j7T")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jDJuC")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("cFFKC")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9oryG")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3vzef")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("wQ8eQ")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3ECa9")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9uabR")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2F5GI"))
]).then(()=>parcelRequire("kopm9"));

});


parcelRegister("jAOzz", function(module, exports) {

$parcel$export(module.exports, "loadConnectWebhooksResource", function () { return $a9d36a2b1c4d3c7a$export$f7a7185bedc981fc; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $k2cPS = parcelRequire("k2cPS");
// convert a list of url,event pairs into a map of url->[event]
function $a9d36a2b1c4d3c7a$var$eventsByUrl(list) {
    return list.reduce(function(acc, hook) {
        const key = hook.url;
        if (!acc[key]) acc[key] = [];
        acc[key].push(hook.event);
        return acc;
    }, {});
}
function $a9d36a2b1c4d3c7a$var$connectHooksDjangoToJs(json) {
    const hookEventsByUrl = $a9d36a2b1c4d3c7a$var$eventsByUrl(json.hooks);
    const result = Object.entries(hookEventsByUrl).map((item)=>{
        return {
            uuid: json.connection_uuid,
            installationId: json.context_ari,
            description: json.connection_name,
            url: item[0],
            events: item[1]
        };
    });
    return result;
}
const $a9d36a2b1c4d3c7a$export$f7a7185bedc981fc = (0, $3kfkg.createResource)({
    type: "connectWebhooks",
    getKey: ({ match: match })=>`connectWebhooks:${match.params.repositoryOwner}`,
    maxAge: 60000,
    // cache connect hooks for 1 minute so navigating between pages is fast
    getData: async ({ match: match })=>{
        const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug } = match.params;
        if (!repositoryOwner || !repositorySlug) throw new Error("Could not fetch Connect webhooks, URL params were not available");
        const resp = await fetch((0, $k2cPS.default)(`/!api/internal/repositories/${repositoryOwner}/${repositorySlug}/connect/hooks`));
        if (!resp.ok) throw new Error("Could not fetch Connect webhooks");
        const body = await resp.json();
        return body.map($a9d36a2b1c4d3c7a$var$connectHooksDjangoToJs).flat();
    }
});

});

parcelRegister("hqdnb", function(module, exports) {

$parcel$export(module.exports, "loadRepositoryWebhooksResource", function () { return $329d478263b68b05$export$4741d8cdf23ab1aa; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $k2cPS = parcelRequire("k2cPS");
const $329d478263b68b05$export$4741d8cdf23ab1aa = (0, $3kfkg.createResource)({
    type: "repositoryWebhooks",
    getKey: ({ match: match })=>`repositoryWebhooks:${match.params.repositoryOwner}:${match.params.repositorySlug}`,
    maxAge: 60000,
    // cache repo hooks for 1 minute so navigating between pages is fast
    getData: async ({ match: match })=>{
        const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug } = match.params;
        if (!repositoryOwner || !repositorySlug) throw new Error("Could not fetch repository webhooks, URL params were not available");
        const resp = await fetch((0, $k2cPS.default)(// pagelen=100 is the same as the old webhooks UI.
        // We should implement pagination but for now parity with the old UI will do.
        `/!api/2.0/repositories/${repositoryOwner}/${repositorySlug}/hooks/?pagelen=100`));
        if (!resp.ok) throw new Error("Could not fetch repository webhooks");
        const body = await resp.json();
        return body.values.filter((h)=>!h.read_only);
    }
});

});

parcelRegister("kysKv", function(module, exports) {

$parcel$export(module.exports, "loadWorkspaceWebhooksResource", function () { return $d6f852d118c96e82$export$9dfdf69c8b056209; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $k2cPS = parcelRequire("k2cPS");
const $d6f852d118c96e82$export$9dfdf69c8b056209 = (0, $3kfkg.createResource)({
    type: "workspaceWebhooks",
    getKey: ({ match: match })=>`workspaceWebhooks:${match.params.repositoryOwner}`,
    maxAge: 60000,
    // cache workspace hooks for 1 minute so navigating between pages is fast
    getData: async ({ match: match })=>{
        const { repositoryOwner: repositoryOwner } = match.params;
        if (!repositoryOwner) throw new Error("Could not fetch repository webhooks, repositoryOwner URL param was not available");
        const resp = await fetch((0, $k2cPS.default)(`/!api/2.0/workspaces/${repositoryOwner}/hooks/`));
        if (!resp.ok) // The workspace hooks API can return a 403 if the current user is not the owner of the
        // current repo workspace. In that case, just return an error so the an error is shown
        // in the UI explaining this.
        throw new Error("Could not fetch workspace webhooks");
        const body = await resp.json();
        return body.values;
    }
});

});

parcelRegister("iDAZb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1739dd8284a55df9$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("dGzLf");
var $aAre5 = parcelRequire("aAre5");

var $b16Uf = parcelRequire("b16Uf");

var $bVIhs = parcelRequire("bVIhs");

var $dqY9c = parcelRequire("dqY9c");

var $i90RT = parcelRequire("i90RT");

var $aEOf6 = parcelRequire("aEOf6");

var $86Rbu = parcelRequire("86Rbu");
const $1739dd8284a55df9$var$SettingsConnectIframe = (props)=>{
    const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug, appKey: appKey, moduleKey: moduleKey } = (0, $dqY9c.useParams)();
    const repositoryFullSlug = `${repositoryOwner}/${repositorySlug}`;
    const principalId = (0, $aAre5.useSelector)((state)=>(0, $i90RT.getRepositoryOwnerUuid)(state.entities, repositoryFullSlug));
    const target = (0, $bVIhs.repositoryTarget)({
        repositoryOwner: repositoryOwner || "",
        repositorySlug: repositorySlug || ""
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $b16Uf.SettingsConnectIframe), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        appKey: appKey || "",
        moduleKey: moduleKey || "",
        principalId: principalId,
        target: target
    }, props));
};
var $1739dd8284a55df9$export$2e2bcd8739ae039 = (0, $86Rbu.default)($1739dd8284a55df9$var$SettingsConnectIframe, {
    header: (0, $aEOf6.default)
});

});
parcelRegister("b16Uf", function(module, exports) {

$parcel$export(module.exports, "SettingsConnectIframe", function () { return $e7bccc83aba4baa6$export$46060a1b0a17b59c; });

var $9nHZC = parcelRequire("9nHZC");

var $dV1BF = parcelRequire("dV1BF");
parcelRequire("g2goG");
var $QQQjQ = parcelRequire("QQQjQ");
parcelRequire("6x4M3");
var $qh48v = parcelRequire("qh48v");
var $4yK0k = parcelRequire("4yK0k");

var $9uOdI = parcelRequire("9uOdI");
const $e7bccc83aba4baa6$export$46060a1b0a17b59c = /*#__PURE__*/ (0, $9nHZC.memo)(({ principalId: principalId, appKey: appKey, moduleKey: moduleKey, target: target, modules: modules = "adminPages:org.bitbucket.repository.admin,generalPages" })=>{
    if (!principalId) return null;
    // As we are requesting multiple modules for this connect iframe, we need
    // to use this cache resolver to tell <ConnectModules /> to fetch data
    // if module not found in cache. Otherwise it could find an adminPage or
    // generalPage and return our cache without the module we want
    const cacheResolver = ()=>{
        return (0, $QQQjQ.default).filterModules({
            appKey: appKey,
            moduleKey: moduleKey,
            targetHref: target.links.self.href
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $4yK0k.default), {
        principalId: principalId,
        query: [
            {
                target: target,
                modules: modules.split(",").map((mod)=>{
                    const [moduleType, location] = mod.split(":");
                    return Object.assign({
                        moduleType: moduleType
                    }, location && {
                        location: location
                    });
                })
            }
        ],
        cacheResolver: cacheResolver
    }, ({ modules: mods, loading: loading, error: error })=>{
        const page = mods.find((m)=>m.app_key === appKey && m.descriptor.key === moduleKey);
        if (page) {
            var _page$descriptor, _page$descriptor$name;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dV1BF.default), {
                defer: false,
                title: `/ ${((_page$descriptor = page.descriptor) === null || _page$descriptor === void 0 ? void 0 : (_page$descriptor$name = _page$descriptor.name) === null || _page$descriptor$name === void 0 ? void 0 : _page$descriptor$name.value) || page.app_name}`
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $qh48v.default), {
                key: page.id,
                module: page,
                iframeContainer: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, children),
                options: {
                    autoresize: true,
                    isFullPage: true,
                    __featuresInternal: {
                        "nav-next-settings": true
                    }
                }
            }));
        }
        if (!loading && error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9uOdI.GlobalError), null);
        return null;
    });
}, (prev, next)=>{
    return prev.principalId === next.principalId && prev.appKey === next.appKey && prev.moduleKey === next.moduleKey && prev.target.links.self.href === next.target.links.self.href && prev.modules === next.modules;
});

});
parcelRegister("9uOdI", function(module, exports) {

$parcel$export(module.exports, "GlobalError", function () { return $d392bd077aa1445f$export$dd28493542fc4ab7; });

var $2xJU3 = parcelRequire("2xJU3");

var $9nHZC = parcelRequire("9nHZC");

var $aP6k3 = parcelRequire("aP6k3");
parcelRequire("jyUKE");
var $jmbnP = parcelRequire("jmbnP");
const $d392bd077aa1445f$var$SettingsVerticalAlignCenter = (0, $2xJU3.default)("div", {
    target: "e1i11c0x0"
})("display:flex;justify-content:center;align-items:flex-start;height:100%;padding:", (0, $aP6k3.gridSize)() * 8, "px;box-sizing:border-box;");
const $d392bd077aa1445f$export$dd28493542fc4ab7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($d392bd077aa1445f$var$SettingsVerticalAlignCenter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $jmbnP.GlobalError), null));

});


parcelRegister("bVIhs", function(module, exports) {

$parcel$export(module.exports, "repositoryTarget", function () { return $a4b802bbf99c8441$export$716a6d4eaefa4689; });
$parcel$export(module.exports, "commitFileTarget", function () { return $a4b802bbf99c8441$export$552b8ac53aa70059; });
$parcel$export(module.exports, "commitDirectoryTarget", function () { return $a4b802bbf99c8441$export$a0fbd30b86b8f489; });
$parcel$export(module.exports, "branchTarget", function () { return $a4b802bbf99c8441$export$9fc6a1a28522a842; });
$parcel$export(module.exports, "commitTarget", function () { return $a4b802bbf99c8441$export$c1ba5369afdfad50; });

var $kZnTB = parcelRequire("kZnTB");

var $4oBYE = parcelRequire("4oBYE");

var $635SY = parcelRequire("635SY");

var $ksfVj = parcelRequire("ksfVj");
const $a4b802bbf99c8441$export$716a6d4eaefa4689 = ({ repositoryOwner: repositoryOwner, repositorySlug: repositorySlug })=>({
        type: "repository",
        full_name: `${repositoryOwner}/${repositorySlug}`,
        name: repositorySlug,
        links: {
            self: {
                href: (0, $kZnTB.default).api.v20.repositoryAbs(repositoryOwner, repositorySlug)
            }
        }
    });
const $a4b802bbf99c8441$export$552b8ac53aa70059 = ({ path: path, hash: hash, repositoryOwner: repositoryOwner, repositorySlug: repositorySlug })=>({
        type: "commit_file",
        path: path,
        commit: {
            type: "commit",
            hash: hash,
            repository: $a4b802bbf99c8441$export$716a6d4eaefa4689({
                repositoryOwner: repositoryOwner,
                repositorySlug: repositorySlug
            })
        },
        links: {
            self: {
                href: (0, $635SY.default).api.v20.sourceAbs(`${repositoryOwner}/${repositorySlug}`, hash, path)
            }
        }
    });
const $a4b802bbf99c8441$export$a0fbd30b86b8f489 = (props)=>({
        ...$a4b802bbf99c8441$export$552b8ac53aa70059(props),
        type: "commit_directory"
    });
const $a4b802bbf99c8441$export$9fc6a1a28522a842 = ({ name: name, repositoryOwner: repositoryOwner, repositorySlug: repositorySlug })=>({
        type: "branch",
        name: name,
        repository: $a4b802bbf99c8441$export$716a6d4eaefa4689({
            repositoryOwner: repositoryOwner,
            repositorySlug: repositorySlug
        }),
        links: {
            self: {
                href: (0, $kZnTB.default).api.v20.branchAbs(repositoryOwner, repositorySlug, name)
            }
        }
    });
const $a4b802bbf99c8441$export$c1ba5369afdfad50 = ({ repositoryOwner: repositoryOwner, repositorySlug: repositorySlug, hash: hash })=>({
        type: "commit",
        hash: hash,
        repository: $a4b802bbf99c8441$export$716a6d4eaefa4689({
            repositoryOwner: repositoryOwner,
            repositorySlug: repositorySlug
        }),
        links: {
            self: {
                href: (0, $4oBYE.default).api.v20.commitAbs(`${repositoryOwner}/${repositorySlug}`, hash)
            }
        }
    });
const $a4b802bbf99c8441$export$99504df6a5c0fd1d = (slug)=>({
        slug: slug,
        type: "workspace",
        links: {
            self: {
                href: `${window.location.origin}${(0, $ksfVj.default).api.v20.get(slug)}`
            }
        }
    });

});

parcelRegister("i90RT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getRepositoryOwnerUuid", function () { return $53f581297555465f$export$49da28ce8f3eca7e; });
$parcel$export(module.exports, "default", function () { return $53f581297555465f$export$2e2bcd8739ae039; });
parcelRequire("dGzLf");
var $5oGLl = parcelRequire("5oGLl");

var $bEW6n = parcelRequire("bEW6n");

var $gRObH = parcelRequire("gRObH");

var $2bK0E = parcelRequire("2bK0E");
const $53f581297555465f$export$49da28ce8f3eca7e = (entities, // @ts-ignore TODO: fix noImplicitAny error here
repositoryFullSlug)=>{
    const [owner] = repositoryFullSlug.split("/");
    if ((0, $gRObH.default)(owner)) return owner;
    const repo = Object.values(entities.repositories).find((r)=>r.full_name === repositoryFullSlug);
    if (!repo) return undefined;
    // @ts-ignore Repo is normalized, so owner is *not* a User object
    return repo.owner;
};
// @ts-ignore TODO: fix noImplicitAny error here
const $53f581297555465f$var$mapStateToProps = (state, ownProps)=>{
    const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug } = ownProps.match.params;
    const repositoryFullSlug = `${repositoryOwner}/${repositorySlug}`;
    const principalId = $53f581297555465f$export$49da28ce8f3eca7e(state.entities, repositoryFullSlug);
    return {
        principalId: principalId
    };
};
const $53f581297555465f$var$mapDispatchToProps = {
    updateMenuItems: (0, $2bK0E.default)
};
// @ts-ignore TODO: fix noImplicitAny error here
function $53f581297555465f$var$mergeProps(stateProps, dispatchProps, ownProps) {
    const { appKey: appKey, moduleKey: moduleKey, repositoryOwner: repositoryOwner, repositorySlug: repositorySlug } = ownProps.match.params;
    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        appKey: appKey,
        moduleKey: moduleKey,
        repositoryOwner: repositoryOwner,
        repositorySlug: repositorySlug
    };
}
var $53f581297555465f$export$2e2bcd8739ae039 = (0, $5oGLl.default)($53f581297555465f$var$mapStateToProps, $53f581297555465f$var$mapDispatchToProps, $53f581297555465f$var$mergeProps)((0, $bEW6n.default));

});
parcelRegister("bEW6n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ff1d0c0b550f250$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $lIZwG = parcelRequire("lIZwG");

var $dV1BF = parcelRequire("dV1BF");

var $aDsOl = parcelRequire("aDsOl");
parcelRequire("g2goG");
var $QQQjQ = parcelRequire("QQQjQ");
var $kNA8C = parcelRequire("kNA8C");
var $5s0M7 = parcelRequire("5s0M7");
parcelRequire("6x4M3");
var $qh48v = parcelRequire("qh48v");
var $4yK0k = parcelRequire("4yK0k");

var $9uOdI = parcelRequire("9uOdI");

var $bVIhs = parcelRequire("bVIhs");
parcelRequire("3hjiH");
var $jQl2W = parcelRequire("jQl2W");
parcelRequire("ilJwJ");
var $dL9SL = parcelRequire("dL9SL");

var $8MzLl = parcelRequire("8MzLl");

var $6aoKW = parcelRequire("6aoKW");

var $628YF = parcelRequire("628YF");
/**
 * The underlying `simple-xdm` library that handles communication between Connect apps and Bitbucket
 * passes an extra callback function argument when invoking methods defined on modules via `ConnectHost.defineModule`
 * It does so by measuring `method.length` and padding any "missing" arguments as `undefined` in an attempt not to
 * override any positional argument meaning.
 *
 * `fn.length` for the following arrow function returns `2`: const fn = (a, b) => null
 * However, `fn.length` for the following arrow function returns `1`: const fn = (a, b = {}) => null
 *
 * The default argument used in `stopApdex` causes `simple-xdm` to override the 2nd argument with its own
 * special callback fn, producing unintended effects. When a Connect app (like Pipelines) calls
 * `ConnectApi.apdex.stopApdex("eventName")`, `simple-xdm` invokes it as:
 *
 * `stopApdex("eventName", specialCallbackFn)`
 *
 * instead of
 *
 * `stopApdex("eventName", undefined, specialCallbackFn)`
 *
 * Explicitly defining a wrapper function with 2 arguments without default values should correct that.
 */ const $4ff1d0c0b550f250$var$boundStopApdex = (eventName, _options)=>(0, $8MzLl.stopApdex)(eventName);
class $4ff1d0c0b550f250$export$f0a24cf7d1bdd1db extends (0, $9nHZC.Component) {
    // @ts-ignore TODO: fix noImplicitAny error here
    constructor(_props){
        super(_props);
        // define additional Connect modules for Pipelines usage
        this.replaceContentHandler = void 0;
        this.unlistenHistory = void 0;
        this.cacheResolver = (props)=>{
            const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug, appKey: appKey, moduleKey: moduleKey } = this.props;
            if (!repositoryOwner || !repositorySlug || !appKey || !moduleKey) return [];
            const target = (0, $bVIhs.repositoryTarget)({
                repositoryOwner: repositoryOwner,
                repositorySlug: repositorySlug
            });
            return props.addonManager.filterModules({
                appKey: appKey,
                moduleKey: moduleKey,
                targetHref: target.links.self.href
            });
        };
        if (_props.appKey === "pipelines") {
            (0, $kNA8C.default).defineModule("apdex", {
                stopApdex: $4ff1d0c0b550f250$var$boundStopApdex
            });
            const NotificationAPI = window.Notification;
            if (NotificationAPI) (0, $kNA8C.default).defineModule("Notification", {
                // allow to pass permission state without broadcasting event
                [NotificationAPI.permission]: ()=>null,
                // @ts-ignore TODO: fix noImplicitAny error here
                show: (title, options)=>new NotificationAPI(title, options)
            });
        }
    }
    componentDidMount() {
        this.publishScreenEvent(this.props.appKey);
        if (!this.props.history) return;
        // Currently, "AP.history.popState" doesn't listen to external route changes.
        // We're using this custom event to notify the RepoPage of route changes.
        this.unlistenHistory = this.props.history.listen(({ pathname: pathname, search: search, hash: hash })=>{
            (0, $kNA8C.default).broadcastEvent("location-change", {
                addon_key: this.props.appKey
            }, {
                pathname: pathname,
                search: search,
                hash: hash
            });
        });
        // This is needed for legacy compatibility. Currently, Pipelines has an install flow
        // that swaps out the iframe after an install. As a result, we need to update the
        // the nav to reflect the new route (with new module key).
        // @ts-ignore TODO: fix noImplicitAny error here
        this.replaceContentHandler = (0, $5s0M7.replaceContentHandler)((mod)=>{
            if (mod) {
                const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug, appKey: appKey, moduleKey: moduleKey } = this.props;
                const { app_key: aKey, descriptor: { key: mKey } } = mod;
                if (repositoryOwner && repositorySlug && appKey && moduleKey) {
                    const oldRoute = `/${repositoryOwner}/${repositorySlug}/addon/${appKey}/${moduleKey}`;
                    const newRoute = `/${repositoryOwner}/${repositorySlug}/addon/${aKey}/${mKey}`;
                    this.props.updateMenuItems(oldRoute, newRoute);
                    this.props.history.replace(newRoute);
                }
            }
        });
    }
    shouldComponentUpdate(prevProps) {
        const { principalId: principalId, repositoryOwner: repositoryOwner, repositorySlug: repositorySlug, appKey: appKey, moduleKey: moduleKey } = this.props;
        return principalId !== prevProps.principalId || repositoryOwner !== prevProps.repositoryOwner || repositorySlug !== prevProps.repositorySlug || appKey !== prevProps.appKey || moduleKey !== prevProps.moduleKey;
    }
    componentDidUpdate(prevProps) {
        if (prevProps.appKey !== this.props.appKey) this.publishScreenEvent(this.props.appKey);
    }
    componentWillUnmount() {
        if (typeof this.unlistenHistory === "function") this.unlistenHistory();
        if (this.replaceContentHandler && typeof this.replaceContentHandler.unlisten === "function") this.replaceContentHandler.unlisten();
        // undefine apdex module
        (0, $kNA8C.default).defineModule("apdex", {});
        // This clears addon cache when component unmounts
        (0, $QQQjQ.default).removeModules();
    }
    publishScreenEvent(addonKey) {
        if (addonKey) (0, $6aoKW.publishScreenEvent)("addonRepositoryPage", {
            addonKey: addonKey
        });
    }
    render() {
        const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug, appKey: appKey, moduleKey: moduleKey, principalId: principalId } = this.props;
        if (!principalId || !repositoryOwner || !repositorySlug || !appKey || !moduleKey) return null;
        const mod = {
            appKey: appKey,
            // moduleKey, // This has been left out so the associated addon will be returned
            moduleType: "repoPages",
            location: "org.bitbucket.repository.navigation"
        };
        // This is incorrectly typed, as the ConnectModules component requires the
        // links property but we're deleting that property conditionally below.
        // This was typed as any when migrating to Typescript 4.1 as it was flagged
        // in order to avoid making too many changes during the migration
        // TODO: remove "any" type and update logic to handle deleted properties
        const target = (0, $bVIhs.repositoryTarget)({
            repositoryOwner: repositoryOwner,
            repositorySlug: repositorySlug
        });
        // this allows repo pages to be accessed via UUID
        if (repositorySlug.charAt(0) === "{") {
            target.uuid = repositorySlug;
            delete target.full_name;
            delete target.name;
            // remove links object as the selfHref returned from server is
            // in the format {repositoryOwner}/{repositorySlug} and will not match
            delete target.links;
        }
        const query = [
            {
                target: target,
                modules: [
                    mod,
                    {
                        ...mod,
                        location: "org.bitbucket.repository.actions"
                    },
                    {
                        moduleType: "associatedAddon"
                    },
                    {
                        moduleType: "generalPages"
                    }
                ]
            }
        ];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $4yK0k.default), {
            principalId: principalId,
            query: query,
            cacheResolver: this.cacheResolver
        }, ({ modules: modules, loading: loading, error: error })=>{
            const repoPage = modules.find((m)=>m.app_key === appKey && m.descriptor.key === moduleKey && m.module_type === "repoPages");
            if (repoPage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dV1BF.default), {
                defer: false,
                title: `/ ${(0, $lIZwG.default)(repoPage, "descriptor.name.value", repoPage.app_name)}`
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $qh48v.default), {
                key: repoPage.id,
                module: repoPage,
                iframeContainer: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, children),
                defaultStyles: {
                    display: "block",
                    height: `calc(100vh - ${(0, $aDsOl.HORIZONTAL_GLOBAL_NAV_HEIGHT)}px`,
                    width: "100%"
                },
                options: {
                    isFullPage: true,
                    __featuresInternal: {}
                },
                publishUiEvent: (0, $6aoKW.publishUiEvent),
                captureMessageWithTags: (0, $628YF.captureMessageWithTags)
            }));
            if (!loading && error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9uOdI.GlobalError), null);
            // links to pipelines installer should redirect to pipelines if pipelines is installed
            // initially pipelines installer is an repoPages module
            const pipelinesInstaller = modules.find((m)=>m.app_key === appKey && appKey === "pipelines-installer" && m.module_type === "associatedAddon");
            if (pipelinesInstaller) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $jQl2W.Redirect), {
                to: `/${repositoryOwner}/${repositorySlug}/addon/pipelines/home`
            });
            return null;
        });
    }
}
var $4ff1d0c0b550f250$export$2e2bcd8739ae039 = (0, $dL9SL.default)($4ff1d0c0b550f250$export$f0a24cf7d1bdd1db);

});
parcelRegister("ilJwJ", function(module, exports) {

$parcel$export(module.exports, "withRouter", function () { return (parcelRequire("dL9SL")).default; });
$parcel$export(module.exports, "getRouteFeaturesFromAppData", function () { return (parcelRequire("e5hNf")).getRouteFeaturesFromAppData; });

var $dL9SL = parcelRequire("dL9SL");

var $e5hNf = parcelRequire("e5hNf");

});
parcelRegister("dL9SL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4955f9c56fc9ca83$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("lM4y8");
var $gp8oT = parcelRequire("gp8oT");
var $4955f9c56fc9ca83$export$2e2bcd8739ae039 = (Component)=>{
    const WithResourceRouter = (0, $gp8oT.withRouter)(Component);
    function withRouter(props) {
        // @ts-ignore The types from `withRouter` from `react-resource-router` aren't as specific as they could be
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WithResourceRouter, props);
    }
    return withRouter;
};

});

parcelRegister("e5hNf", function(module, exports) {

$parcel$export(module.exports, "getRouteFeaturesFromAppData", function () { return $2736f258e5b3a5a1$export$4e140e46e84a399; });
const $2736f258e5b3a5a1$export$4e140e46e84a399 = (appData)=>({
        isWorkspaceSettingsIndexEnabled: appData.features["spa-ws-settings--settings-index"],
        isRepoAdminAliasesEnabled: appData.features["spa-repo-settings--username-aliases"],
        isRepoAdminComplianceEnabled: appData.features["spa-repo-settings--compliance"],
        isPipelinesTestManagementEnabled: appData.features["pipelines-test-management"]
    });

});


parcelRegister("8MzLl", function(module, exports) {

$parcel$export(module.exports, "startApdex", function () { return $7180fb0877586cd8$export$a3dba528e99a6f77; });
$parcel$export(module.exports, "stopApdex", function () { return $7180fb0877586cd8$export$aeaaa3ad0efccf3b; });

var $3XbtU = parcelRequire("3XbtU");

var $lIZwG = parcelRequire("lIZwG");
var $dHTXM = parcelRequire("dHTXM");

var $1ZBmx = parcelRequire("1ZBmx");

var $bBcuy = parcelRequire("bBcuy");
const $7180fb0877586cd8$export$de42b39524c6191 = "frontbucket";
const $7180fb0877586cd8$var$standardAdditionalAttributes = ()=>{
    return {
        appName: $7180fb0877586cd8$export$de42b39524c6191,
        appWasServerSideRendered: (0, $1ZBmx.appWasServerSideRendered)()
    };
};
const $7180fb0877586cd8$export$a3dba528e99a6f77 = (apdexEventAttributes)=>{
    const appNamePath = "additionalAttributes.appName";
    if (!(0, $lIZwG.default)(apdexEventAttributes, appNamePath)) (0, $dHTXM.default)(apdexEventAttributes, appNamePath, $7180fb0877586cd8$export$de42b39524c6191);
    (0, $bBcuy.analyticsClient)().startApdexEvent(apdexEventAttributes);
};
/**
 * Adds a stopTime property to the stopApdex event if this is intended.
 *
 */ const $7180fb0877586cd8$var$addStopTimeToApdexEventIfRequired = (event, stopTimePerformanceMarkEntryName)=>{
    if (stopTimePerformanceMarkEntryName) {
        const entries = window.performance.getEntriesByName(stopTimePerformanceMarkEntryName);
        if (entries.length) return {
            ...event,
            stopTime: entries[0].startTime
        };
    }
    return event;
};
/**
 * Given a task (apdex event id), check to see if the starting event was started by a SPA
 * transition, otherwise, assume the view was rendered after a full server-rendered page load.
 */ const $7180fb0877586cd8$export$aeaaa3ad0efccf3b = (eventName, options = {})=>{
    const { additionalAttributes: additionalAttributes = {}, stopTimePerformanceMarkEntryName: stopTimePerformanceMarkEntryName } = options;
    // If getApdexStart() returns undefined, we can assume the start was initialLoad
    const startEvent = (0, $bBcuy.analyticsClient)().getApdexStart({
        task: eventName
    });
    const startEventType = startEvent ? "transition" : "initialLoad";
    try {
        // However, we do not want to fire an Apdex stop event if we got here through the
        // browser back/forward buttons OR if we forgot to correctly instrument an in-SPA link.
        // In order to accurately track Apdex we need to start the timer with the
        // user interaction (e.g. clicking a link)
        if (startEventType === "initialLoad" && !window.isInitialLoadApdex) return;
        // After this is called once to time the initialLoad, we'll assume we are navigating around the
        // SPA and we should not have any more "initialLoad" events.
        if (window.isInitialLoadApdex === true) window.isInitialLoadApdex = false;
        const event = $7180fb0877586cd8$var$addStopTimeToApdexEventIfRequired({
            task: eventName,
            type: startEventType,
            additionalAttributes: {
                ...additionalAttributes,
                ...$7180fb0877586cd8$var$standardAdditionalAttributes()
            }
        }, stopTimePerformanceMarkEntryName);
        (0, $bBcuy.analyticsClient)().stopApdexEvent(event);
    } catch (e) {
        $3XbtU.withScope((scope)=>{
            // Adding some extra ApdexEvent context for debugging errors.
            scope.setExtra("eventName", eventName);
            scope.setExtra("startEventType", startEventType);
            $3XbtU.captureException(e);
        });
    }
};

});
parcelRegister("dHTXM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9faab3a9a98482d1$export$2e2bcd8739ae039; });

var $5pez5 = parcelRequire("5pez5");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $9faab3a9a98482d1$var$set(object, path, value) {
    return object == null ? object : (0, $5pez5.default)(object, path, value);
}
var $9faab3a9a98482d1$export$2e2bcd8739ae039 = $9faab3a9a98482d1$var$set;

});
parcelRegister("5pez5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3efa95d9a7fa90f7$export$2e2bcd8739ae039; });

var $lS6Qg = parcelRequire("lS6Qg");

var $8AUEA = parcelRequire("8AUEA");

var $2CjdF = parcelRequire("2CjdF");

var $bmzpf = parcelRequire("bmzpf");

var $bZfWj = parcelRequire("bZfWj");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $3efa95d9a7fa90f7$var$baseSet(object, path, value, customizer) {
    if (!(0, $bmzpf.default)(object)) return object;
    path = (0, $8AUEA.default)(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = (0, $bZfWj.default)(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = (0, $bmzpf.default)(objValue) ? objValue : (0, $2CjdF.default)(path[index + 1]) ? [] : {};
        }
        (0, $lS6Qg.default)(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
var $3efa95d9a7fa90f7$export$2e2bcd8739ae039 = $3efa95d9a7fa90f7$var$baseSet;

});




parcelRegister("gRObH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1a3071f18752b73$export$2e2bcd8739ae039; });
const $b1a3071f18752b73$var$uuidRe = /({|%7B)[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(}|%7D)/;
function $b1a3071f18752b73$export$2e2bcd8739ae039(str) {
    return $b1a3071f18752b73$var$uuidRe.test(str);
}

});

parcelRegister("2bK0E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fe962f0cf26d5f2$export$2e2bcd8739ae039; });
parcelRequire("6ePRx");
var $iaicX = parcelRequire("iaicX");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");
var $5fe962f0cf26d5f2$export$2e2bcd8739ae039 = (oldRoute, newRoute)=>(dispatch, getState)=>{
        const state = getState();
        if (state.repository && state.repository.section) {
            let { menuItems: menuItems } = state.repository.section;
            menuItems = (0, $iaicX.mapNestedMenuItems)(menuItems, (item)=>{
                if (item.url === oldRoute) return {
                    ...item,
                    url: newRoute
                };
                return item;
            });
            dispatch({
                type: (0, $jJd6W.UPDATE_MENU_ITEMS),
                payload: menuItems
            });
        }
    };

});
parcelRegister("6ePRx", function(module, exports) {

$parcel$export(module.exports, "ContainerNavigationNext", function () { return (parcelRequire("gscKt")).default; });
$parcel$export(module.exports, "FocusedNavigationNext", function () { return (parcelRequire("QKGMb")).default; });
$parcel$export(module.exports, "createNestedMenu", function () { return (parcelRequire("iaicX")).createNestedMenu; });
$parcel$export(module.exports, "findNestedMenuItem", function () { return (parcelRequire("iaicX")).findNestedMenuItem; });
$parcel$export(module.exports, "mapNestedMenuItems", function () { return (parcelRequire("iaicX")).mapNestedMenuItems; });
$parcel$export(module.exports, "addMenuItemsById", function () { return (parcelRequire("iaicX")).addMenuItemsById; });
$parcel$export(module.exports, "ROOT_MENU_ID", function () { return (parcelRequire("iaicX")).ROOT_MENU_ID; });
$parcel$export(module.exports, "ReposContext", function () { return (parcelRequire("gNc1c")).default; });
$parcel$export(module.exports, "UIControllerSubscriber", function () { return (parcelRequire("lemjF")).default; });

var $gscKt = parcelRequire("gscKt");

var $QKGMb = parcelRequire("QKGMb");

var $475If = parcelRequire("475If");

var $hUwc6 = parcelRequire("hUwc6");

var $iaicX = parcelRequire("iaicX");

var $6bF5s = parcelRequire("6bF5s");

var $3D3Ah = parcelRequire("3D3Ah");

var $gNc1c = parcelRequire("gNc1c");

var $dogcG = parcelRequire("dogcG");

var $lemjF = parcelRequire("lemjF");

});
parcelRegister("gscKt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3346e7affbf83a6$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $gqmqe = parcelRequire("gqmqe");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $dMZhK = parcelRequire("dMZhK");

var $2RHJh = parcelRequire("2RHJh");

var $22TpA = parcelRequire("22TpA");

var $7doh5 = parcelRequire("7doh5");

var $5kZeT = parcelRequire("5kZeT");
var $eM8tv = parcelRequire("eM8tv");
var $8H0QC = parcelRequire("8H0QC");
var $2syAc = parcelRequire("2syAc");
var $8OqBL = parcelRequire("8OqBL");
var $7NvL6 = parcelRequire("7NvL6");
var $8mEoV = parcelRequire("8mEoV");
var $36tIc = parcelRequire("36tIc");
var $kx4uh = parcelRequire("kx4uh");

var $aP6k3 = parcelRequire("aP6k3");

var $iaicX = parcelRequire("iaicX");

var $kwkVj = parcelRequire("kwkVj");

var $aTYA7 = parcelRequire("aTYA7");

var $dogcG = parcelRequire("dogcG");

var $eKObo = parcelRequire("eKObo");
const $c3346e7affbf83a6$var$linkComponentProps = (menuItem, linkComponent)=>{
    return menuItem.is_client_link ? {
        menuItem: menuItem,
        component: linkComponent
    } : {};
};
const $c3346e7affbf83a6$export$ac710a2049d1d239 = ({ item: item, index: index, publishUiEvent: publishUiEvent, intl: intl, selectedMenuItem: selectedMenuItem, linkComponent: linkComponent, isNested: isNested, history: history })=>{
    const publishEvent = (0, $9nHZC.useCallback)(()=>{
        if (item.type !== (0, $iaicX.MENU_ITEM_GROUP_TYPE)) {
            if (item.label === "Runners") publishUiEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "runners",
                source: "repositorySettingsNavigation"
            });
            else if (item.label === "Workspace runners") publishUiEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "runners",
                source: "workspaceSettingsNavigation"
            });
        }
    }, [
        item,
        publishUiEvent
    ]);
    if (item.type === (0, $iaicX.MENU_ITEM_GROUP_TYPE)) {
        const heading = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $8H0QC.default), {
            key: item.key,
            id: item.key
        }, item.title);
        // If the first item, then remove top margin from heading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, index === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aTYA7.GroupHeadingNoTopMargin), {
            key: item.key
        }, heading) : heading, item.children.map((child, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($c3346e7affbf83a6$export$ac710a2049d1d239, {
                key: child.id,
                history: history,
                item: child,
                index: i,
                selectedMenuItem: selectedMenuItem,
                linkComponent: linkComponent,
                publishUiEvent: publishUiEvent,
                intl: intl,
                isNested: true
            })));
    }
    if (Array.isArray(item.children) && item.children.length) {
        // TODO: Only use the item and item.url
        // We shouldn't need to get the first menuItem child
        // We are doing this because is_client_link is false on "item"
        const firstMenuItem = (0, $iaicX.getFirstMenuItem)(item);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $8OqBL.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            id: item.id,
            before: ()=>(0, $dogcG.renderMenuItemIcon)(item),
            after: ({ isHover: isHover })=>isHover && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dMZhK))), {
                    label: item.label,
                    secondaryColor: "inherit"
                }),
            text: item.label,
            href: firstMenuItem.url
        }, $c3346e7affbf83a6$var$linkComponentProps(firstMenuItem, linkComponent)));
    }
    const icon = isNested ? null : (0, $dogcG.renderMenuItemIcon)(item);
    const renderMenuItem = ()=>{
        if (item.is_new) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aTYA7.MenuItemWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", null, item.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aTYA7.BetaLozenge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7doh5.default), {
            appearance: "new"
        }, intl.formatMessage((0, $kwkVj.default).new))));
        if (item.is_beta) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aTYA7.MenuItemWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", null, item.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aTYA7.BetaLozenge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7doh5.default), {
            appearance: "new"
        }, "Beta")));
        if (item.is_premium) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aTYA7.MenuItemWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", null, item.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eKObo.default), {
            label: "premium icon"
        }));
        return item.label;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $8OqBL.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        id: item.id,
        href: item.url,
        text: renderMenuItem(),
        isSelected: selectedMenuItem && selectedMenuItem.id === item.id
    }, icon ? {
        before: ()=>icon
    } : {}, {
        onClick: publishEvent
    }, $c3346e7affbf83a6$var$linkComponentProps(item, linkComponent), item.is_external_link ? {
        after: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2RHJh))), {
                size: "small",
                label: "external icon"
            }),
        target: item.target
    } : {}));
};
const $c3346e7affbf83a6$export$7bb258b2147d0287 = ({ menuItems: menuItems, publishUiEvent: publishUiEvent, intl: intl, selectedMenuItem: selectedMenuItem, linkComponent: linkComponent, history: history, containerHref: containerHref })=>{
    if (!selectedMenuItem) return null;
    const parentItem = (0, $iaicX.findNestedMenuItemParent)(menuItems, selectedMenuItem);
    const items = parentItem ? parentItem.children : menuItems;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, (parentItem === null || parentItem === void 0 ? void 0 : parentItem.parentId) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $36tIc.default), null, ({ className: className })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
            className: className
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5kZeT.default), {
            onClick: ()=>{
                const containerHrefPathname = (0, (/*@__PURE__*/$parcel$interopDefault($gqmqe))).parse(containerHref).pathname || "/";
                if (history) history.push(containerHrefPathname);
                else window.location.assign(containerHrefPathname);
            }
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $8mEoV.default), {
        key: "nested-section",
        id: parentItem === null || parentItem === void 0 ? void 0 : parentItem.id,
        parentId: parentItem === null || parentItem === void 0 ? void 0 : parentItem.parentId,
        shouldGrow: true
    }, ({ className: className })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
            className: className
        }, items.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($c3346e7affbf83a6$export$ac710a2049d1d239, {
                key: item.id,
                history: history,
                index: index,
                item: item,
                selectedMenuItem: selectedMenuItem,
                linkComponent: linkComponent,
                publishUiEvent: publishUiEvent,
                intl: intl
            })))));
};
const $c3346e7affbf83a6$var$ContainerNavigation = ({ containerHref: containerHref, containerLogo: containerLogo, containerName: containerName, isGlobalContext: isGlobalContext, isPrivate: isPrivate, linkComponent: linkComponent, menuItems: menuItems, selectedMenuItem: selectedMenuItem, publishUiEvent: publishUiEvent, intl: intl, headerLinkComponent: headerLinkComponent, history: history, containerType: containerType })=>{
    const Avatar = (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).useMemo(()=>(itemState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7NvL6.default), {
                itemState: itemState,
                appearance: "square",
                size: "large",
                src: containerLogo,
                status: isPrivate ? "locked" : undefined
            }), [
        containerLogo,
        isPrivate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2syAc.default), null, ({ css: css })=>isGlobalContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
            style: {
                ...css
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kx4uh.default), {
            wordmark: (0, $22TpA.BitbucketWordmark)
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
            style: {
                ...css,
                paddingBottom: (0, $aP6k3.gridSize)() * 2.5
            },
            id: "bitbucket-navigation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eM8tv.default), {
            before: Avatar,
            component: headerLinkComponent,
            id: `${containerType}HeaderTab`,
            href: containerHref,
            text: containerName
        }))), (0, $iaicX.isNestedMenu)(menuItems) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($c3346e7affbf83a6$export$7bb258b2147d0287, {
        history: history,
        containerHref: containerHref,
        menuItems: menuItems,
        selectedMenuItem: selectedMenuItem,
        linkComponent: linkComponent,
        publishUiEvent: publishUiEvent,
        intl: intl
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $8mEoV.default), null, ({ className: className })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
            className: className
        }, menuItems.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $8OqBL.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                href: item.url,
                id: item.id,
                before: ()=>(0, $dogcG.renderMenuItemIcon)(item),
                key: item.id,
                text: item.label,
                isSelected: item === selectedMenuItem
            }, $c3346e7affbf83a6$var$linkComponentProps(item, linkComponent), item.is_external_link ? {
                after: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2RHJh))), {
                        size: "small",
                        label: "external icon"
                    }),
                target: item.target
            } : {}))))));
};
var $c3346e7affbf83a6$export$2e2bcd8739ae039 = (0, $agjvf.injectIntl)($c3346e7affbf83a6$var$ContainerNavigation);

});
parcelRegister("dMZhK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a09f4c0ce7148ae9$var$_react = $a09f4c0ce7148ae9$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $a09f4c0ce7148ae9$var$_arrowRight = $a09f4c0ce7148ae9$var$_interopRequireDefault((parcelRequire("ak23V")));
function $a09f4c0ce7148ae9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a09f4c0ce7148ae9$var$ArrowRightCircleIcon = (props)=>/*#__PURE__*/ $a09f4c0ce7148ae9$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M12.314 8.294a1.01 1.01 0 0 0 0 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005S7.447 13.005 8 13.005h5.585l-1.271 1.279a1.01 1.01 0 0 0 0 1.422 1 1 0 0 0 1.415 0l2.978-2.995a1.01 1.01 0 0 0 0-1.422l-2.978-2.995a1 1 0 0 0-1.415 0"/></g></svg>`
    }, props, {
        newIcon: $a09f4c0ce7148ae9$var$_arrowRight.default
    }));
$a09f4c0ce7148ae9$var$ArrowRightCircleIcon.displayName = "ArrowRightCircleIcon";
var $a09f4c0ce7148ae9$var$_default = module.exports.default = $a09f4c0ce7148ae9$var$ArrowRightCircleIcon;

});
parcelRegister("ak23V", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::81f09b6725db6a703aeff6cd91bee5a6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $783d5f2b26798f3e$var$_react = $783d5f2b26798f3e$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $783d5f2b26798f3e$var$_UNSAFE_baseNew = $783d5f2b26798f3e$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $783d5f2b26798f3e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $783d5f2b26798f3e$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $783d5f2b26798f3e$var$_react.default.createElement($783d5f2b26798f3e$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M14.25 8H1m8.25-5 5 5-5 5"/>`
    }, props));
$783d5f2b26798f3e$var$ArrowRightIcon.displayName = "ArrowRightIcon";
var $783d5f2b26798f3e$var$_default = module.exports.default = $783d5f2b26798f3e$var$ArrowRightIcon;

});


parcelRegister("2RHJh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $216273bb2b27bf9d$var$_react = $216273bb2b27bf9d$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $216273bb2b27bf9d$var$_linkExternal = $216273bb2b27bf9d$var$_interopRequireDefault((parcelRequire("eNwnw")));
function $216273bb2b27bf9d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $216273bb2b27bf9d$var$ShortcutIcon = (props)=>/*#__PURE__*/ $216273bb2b27bf9d$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.01V19zM5 4.99V5zM19 19v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6v2H5v14zM5 4.99V5zM11 5H5v14h14v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6zm8 0v3a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="m12.707 12.707 8-8a1 1 0 1 0-1.414-1.414l-8 8a1 1 0 0 0 1.414 1.414"/></g></svg>`
    }, props, {
        newIcon: $216273bb2b27bf9d$var$_linkExternal.default
    }));
$216273bb2b27bf9d$var$ShortcutIcon.displayName = "ShortcutIcon";
var $216273bb2b27bf9d$var$_default = module.exports.default = $216273bb2b27bf9d$var$ShortcutIcon;

});
parcelRegister("eNwnw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4adc0525e520f8b445f2a6ae3f5a5364>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ac5ec1f8614a7f74$var$_react = $ac5ec1f8614a7f74$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $ac5ec1f8614a7f74$var$_UNSAFE_baseNew = $ac5ec1f8614a7f74$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $ac5ec1f8614a7f74$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ac5ec1f8614a7f74$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $ac5ec1f8614a7f74$var$_react.default.createElement($ac5ec1f8614a7f74$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 2.75H4c-.69 0-1.25.56-1.25 1.25v8c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25v-2M8 8l5.25-5.25m0 4.25V2.75H9"/>`
    }, props));
$ac5ec1f8614a7f74$var$LinkExternalIcon.displayName = "LinkExternalIcon";
var $ac5ec1f8614a7f74$var$_default = module.exports.default = $ac5ec1f8614a7f74$var$LinkExternalIcon;

});


parcelRegister("22TpA", function(module, exports) {

$parcel$export(module.exports, "BitbucketWordmark", function () { return $17d6c04b01faea1a$export$f20958c2e9f3a004; });
/* eslint-disable max-len */ 
var $9nHZC = parcelRequire("9nHZC");

var $gb0Xp = parcelRequire("gb0Xp");

var $EMAbO = parcelRequire("EMAbO");

var $k5A1i = parcelRequire("k5A1i");
var $17d6c04b01faea1a$var$svg = function svg(_ref) {
    var appearance = _ref.appearance, textColor = _ref.textColor;
    var colors = {
        textColor: textColor
    };
    if (appearance) colors = (0, $EMAbO.getColorsFromAppearanceOldLogos)(appearance);
    return '\n<svg viewBox="0 0 105 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">\n  <g stroke="none" stroke-width="1" fill-rule="evenodd" fill="'.concat(colors.textColor, '">\n    <path d="M4.48530102e-14,6.918 L6.63,6.918 C10.114,6.918 11.804,8.634 11.804,11.39 C11.804,13.444 10.868,14.718 8.944,15.186 C11.466,15.602 12.714,16.98 12.714,19.398 C12.714,22.128 10.868,24 7.046,24 L4.48530102e-14,24 L4.48530102e-14,6.918 Z M6.318,9.154 L2.34,9.154 L2.34,14.25 L6.318,14.25 C8.528,14.25 9.438,13.236 9.438,11.598 C9.438,9.934 8.45,9.154 6.318,9.154 Z M7.072,16.33 L2.34,16.33 L2.34,21.66 L7.124,21.66 C9.36,21.66 10.374,20.854 10.374,19.138 C10.374,17.318 9.412,16.33 7.072,16.33 Z M15.236,7.568 C15.236,8.556 15.886,9.128 16.796,9.128 C17.706,9.128 18.356,8.556 18.356,7.568 C18.356,6.58 17.706,6.008 16.796,6.008 C15.886,6.008 15.236,6.58 15.236,7.568 Z M15.652,24 L17.888,24 L17.888,11 L15.652,11 L15.652,24 Z M24.362,19.892 L24.362,13.08 L27.82,13.08 L27.82,11 L24.362,11 L24.362,8.244 L22.178,8.244 L22.178,11 L20.072,11 L20.072,13.08 L22.178,13.08 L22.178,19.944 C22.178,22.362 23.53,24 26.312,24 C26.988,24 27.43,23.896 27.82,23.792 L27.82,21.634 C27.43,21.712 26.936,21.816 26.416,21.816 C25.038,21.816 24.362,21.036 24.362,19.892 Z M42.51,17.5 C42.51,21.166 40.69,24.26 37.05,24.26 C35.152,24.26 33.696,23.402 32.916,21.712 L32.916,24 L30.68,24 L30.68,5.566 L32.916,5.566 L32.916,13.34 C33.748,11.624 35.308,10.74 37.31,10.74 C40.768,10.74 42.51,13.678 42.51,17.5 Z M40.274,17.5 C40.274,14.38 39.026,12.82 36.712,12.82 C34.71,12.82 32.916,14.094 32.916,16.98 L32.916,18.02 C32.916,20.906 34.554,22.18 36.452,22.18 C38.974,22.18 40.274,20.516 40.274,17.5 Z M44.85,18.618 C44.85,22.206 46.566,24.26 49.556,24.26 C51.298,24.26 52.832,23.402 53.664,21.868 L53.664,24 L55.9,24 L55.9,11 L53.664,11 L53.664,18.228 C53.664,20.854 52.234,22.232 50.154,22.232 C48.022,22.232 47.086,21.192 47.086,18.852 L47.086,11 L44.85,11 L44.85,18.618 Z M68.458,21.66 C67.652,21.946 66.82,22.128 65.494,22.128 C62.088,22.128 60.684,19.996 60.684,17.474 C60.684,14.952 62.062,12.82 65.442,12.82 C66.664,12.82 67.548,13.054 68.38,13.444 L68.38,11.364 C67.366,10.896 66.456,10.74 65.286,10.74 C60.658,10.74 58.5,13.548 58.5,17.474 C58.5,21.452 60.658,24.26 65.286,24.26 C66.482,24.26 67.678,24.078 68.458,23.662 L68.458,21.66 Z M73.242,24 L73.242,17.916 L78.962,24 L82.004,24 L75.634,17.396 L81.744,11 L78.832,11 L73.242,17.084 L73.242,5.566 L71.006,5.566 L71.006,24 L73.242,24 Z M94.224,23.48 C93.158,24.052 91.52,24.26 90.194,24.26 C85.332,24.26 83.2,21.452 83.2,17.474 C83.2,13.548 85.384,10.74 89.336,10.74 C93.34,10.74 94.952,13.522 94.952,17.474 L94.952,18.488 L85.462,18.488 C85.774,20.698 87.204,22.128 90.272,22.128 C91.78,22.128 93.054,21.842 94.224,21.426 L94.224,23.48 Z M89.232,12.768 C86.866,12.768 85.67,14.302 85.436,16.564 L92.69,16.564 C92.56,14.146 91.468,12.768 89.232,12.768 Z M100.698,19.892 L100.698,13.08 L104.156,13.08 L104.156,11 L100.698,11 L100.698,8.244 L98.514,8.244 L98.514,11 L96.408,11 L96.408,13.08 L98.514,13.08 L98.514,19.944 C98.514,22.362 99.866,24 102.648,24 C103.324,24 103.766,23.896 104.156,23.792 L104.156,21.634 C103.766,21.712 103.272,21.816 102.752,21.816 C101.374,21.816 100.698,21.036 100.698,19.892 Z"></path>\n  </g>\n</svg>');
};
var $17d6c04b01faea1a$export$f20958c2e9f3a004 = function BitbucketWordmark(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Bitbucket" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $gb0Xp.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $gb0Xp.defaultLogoParams).textColor : _ref2$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $k5A1i.default), {
        appearance: appearance,
        label: label,
        size: size,
        svg: $17d6c04b01faea1a$var$svg({
            appearance: appearance,
            textColor: textColor
        }),
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("gb0Xp", function(module, exports) {

$parcel$export(module.exports, "defaultLogoParams", function () { return $bc6e6a8349ee47e9$export$438460117ae6b7ee; });
$parcel$export(module.exports, "sizes", function () { return $bc6e6a8349ee47e9$export$c647cb0ee6e282fe; });
/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ var $bc6e6a8349ee47e9$export$438460117ae6b7ee = {
    iconColor: "inherit",
    iconGradientStart: "inherit",
    iconGradientStop: "inherit",
    label: "",
    size: "medium",
    textColor: "currentColor"
};
var $bc6e6a8349ee47e9$export$c647cb0ee6e282fe = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
var $bc6e6a8349ee47e9$export$31d7044b7540a6d8 = $bc6e6a8349ee47e9$export$438460117ae6b7ee;

});

parcelRegister("EMAbO", function(module, exports) {

$parcel$export(module.exports, "getColorsFromAppearanceOldLogos", function () { return $07a96c0dde96653c$export$362a25f017e2bc8a; });
$parcel$export(module.exports, "getColorsFromAppearance", function () { return $07a96c0dde96653c$export$bbacc3980e0f3029; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $jp7ng = parcelRequire("jp7ng");
var $07a96c0dde96653c$export$362a25f017e2bc8a = function getColorsFromAppearanceOldLogos(appearance) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case "brand":
            iconGradientStart = (0, $jp7ng.B400);
            iconGradientStop = (0, $jp7ng.B200);
            iconColor = (0, $jp7ng.B200);
            textColor = "var(--ds-text, ".concat((0, $jp7ng.N800), ")");
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $jp7ng.B400);
            break;
        case "neutral":
            iconGradientStart = (0, $jp7ng.N600);
            iconGradientStop = (0, $jp7ng.N100);
            iconColor = (0, $jp7ng.N100);
            textColor = (0, $jp7ng.N400);
            atlassianLogoTextColor = (0, $jp7ng.N400);
            break;
        case "inverse":
            iconGradientStart = (0, $jp7ng.N50);
            iconGradientStop = (0, $jp7ng.N0);
            iconColor = (0, $jp7ng.N0);
            textColor = "var(--ds-text-inverse, ".concat((0, $jp7ng.N0), ")");
            atlassianLogoTextColor = "var(--ds-text-inverse, ".concat((0, $jp7ng.N0), ")");
            break;
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $07a96c0dde96653c$export$bbacc3980e0f3029 = function getColorsFromAppearance(appearance, colorMode) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === "dark") switch(appearance){
        case "brand":
            iconColor = "#357DE8";
            textColor = "#E2E3E4";
            atlassianLogoTextColor = "#357DE8";
            break;
        case "neutral":
            iconColor = "#96999E";
            textColor = "#BFC1C4";
            atlassianLogoTextColor = "#96999E";
            break;
        case "inverse":
            iconColor = "#101214";
            textColor = "#101214";
            atlassianLogoTextColor = "#101214";
            break;
    }
    else switch(appearance){
        case "brand":
            iconColor = "#1868DB";
            textColor = "#101214";
            atlassianLogoTextColor = "#1868DB";
            break;
        case "neutral":
            iconColor = "#6C6F77";
            textColor = "#3B3D42";
            atlassianLogoTextColor = "#6C6F77";
            break;
        case "inverse":
            iconColor = (0, $jp7ng.N0);
            textColor = (0, $jp7ng.N0);
            atlassianLogoTextColor = (0, $jp7ng.N0);
            break;
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $07a96c0dde96653c$export$7818df200941dbbf = function getColorsForLoom(appearance, colorMode) {
    var iconColor = $07a96c0dde96653c$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    var textColor = $07a96c0dde96653c$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === "dark") switch(appearance){
        case "brand":
            iconColor = "#625DF5";
            textColor = "#EFF0FF";
            break;
    }
    else switch(appearance){
        case "brand":
            iconColor = "#625DF5";
            textColor = "#252434";
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};

});

parcelRegister("k5A1i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea00371569259393$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $9q1kH = parcelRequire("9q1kH");

var $avKww = parcelRequire("avKww");

var $gb0Xp = parcelRequire("gb0Xp");
var $ea00371569259393$var$_excluded = [
    "label",
    "svg",
    "size",
    "appearance",
    "iconGradientStart",
    "iconGradientStop",
    "iconColor",
    "textColor",
    "testId"
];
var $ea00371569259393$var$CSS_VAR_COLOR = "--logo-color";
var $ea00371569259393$var$CSS_VAR_FILL = "--logo-fill";
var $ea00371569259393$var$baseWrapperStyles = (0, $avKww.css)({
    display: "inline-block",
    position: "relative",
    color: "var(".concat($ea00371569259393$var$CSS_VAR_COLOR, ")"),
    fill: "var(".concat($ea00371569259393$var$CSS_VAR_FILL, ")"),
    lineHeight: 1,
    userSelect: "none",
    whiteSpace: "normal",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "> svg": {
        height: "100%",
        fill: "inherit"
    }
});
var $ea00371569259393$var$stopColorStyles = (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    stop: {
        stopColor: "currentColor"
    }
});
var $ea00371569259393$var$sizeStyles = Object.entries((0, $gb0Xp.sizes)).reduce(function(acc, _ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), key = _ref2[0], val = _ref2[1];
    acc[key] = (0, $avKww.css)({
        height: "".concat(val, "px")
    });
    return acc;
}, {});
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ var $ea00371569259393$var$Wrapper = function Wrapper(_ref3) {
    var _ref4;
    var label = _ref3.label, svg = _ref3.svg, size = _ref3.size, appearance = _ref3.appearance, iconGradientStart = _ref3.iconGradientStart, iconGradientStop = _ref3.iconGradientStop, iconColor = _ref3.iconColor, textColor = _ref3.textColor, userDefinedTestId = _ref3.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref3, $ea00371569259393$var$_excluded);
    var shouldApplyStopColor = iconGradientStart === "inherit" && iconGradientStop === "inherit" && appearance === undefined;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    return (0, $avKww.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        css: [
            $ea00371569259393$var$baseWrapperStyles,
            shouldApplyStopColor && $ea00371569259393$var$stopColorStyles,
            size && $ea00371569259393$var$sizeStyles[size]
        ],
        "data-testid": testId,
        style: (_ref4 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref4, $ea00371569259393$var$CSS_VAR_COLOR, iconColor), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref4, $ea00371569259393$var$CSS_VAR_FILL, textColor), _ref4),
        "aria-label": label ? label : undefined,
        role: label ? "img" : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest));
};
var $ea00371569259393$export$2e2bcd8739ae039 = $ea00371569259393$var$Wrapper;

});


parcelRegister("5kZeT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e2e52d283215bc9$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $7KAwG = parcelRequire("7KAwG");

var $lOQkO = parcelRequire("lOQkO");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $3rAtz = parcelRequire("3rAtz");

var $aP6k3 = parcelRequire("aP6k3");

var $7XXi0 = parcelRequire("7XXi0");

var $45CBz = parcelRequire("45CBz");
var $3e2e52d283215bc9$var$_excluded = [
    "before",
    "text"
];
function $3e2e52d283215bc9$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3e2e52d283215bc9$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $3e2e52d283215bc9$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $3e2e52d283215bc9$var$gridSize = (0, $aP6k3.gridSize)();
var $3e2e52d283215bc9$var$ArrowLeft = function ArrowLeft() {
    return (0, $45CBz.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3rAtz))), {
        primaryColor: "currentColor",
        secondaryColor: "inherit"
    });
};
var $3e2e52d283215bc9$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(BackItem, _Component);
    var _super = $3e2e52d283215bc9$var$_createSuper(BackItem);
    function BackItem() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, BackItem);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(BackItem, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, beforeProp = _this$props.before, text = _this$props.text, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_this$props, $3e2e52d283215bc9$var$_excluded);
                var before = beforeProp;
                if (!before) before = $3e2e52d283215bc9$var$ArrowLeft;
                return (0, $45CBz.jsx)("div", {
                    css: /*#__PURE__*/ (0, $7KAwG.default)({
                        marginBottom: $3e2e52d283215bc9$var$gridSize * 2
                    }, "")
                }, (0, $45CBz.jsx)((0, $7XXi0.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
                    after: null,
                    before: before,
                    text: text
                })));
            }
        }
    ]);
    return BackItem;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($3e2e52d283215bc9$export$2e2bcd8739ae039, "defaultProps", {
    text: "Back"
});

});
parcelRegister("3rAtz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28203010af260ef6$var$_react = $28203010af260ef6$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $kupLT = parcelRequire("kupLT");
function $28203010af260ef6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $28203010af260ef6$var$ArrowLeftCircleIcon = (props)=>/*#__PURE__*/ $28203010af260ef6$var$_react.default.createElement($kupLT.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle fill="currentColor" cx="12" cy="12" r="10"/><path d="M16 10.995h-5.586l1.272-1.279a1.01 1.01 0 000-1.421.996.996 0 00-1.415 0l-2.978 2.994a1.01 1.01 0 000 1.423l2.978 2.993a.999.999 0 001.415 0 1.01 1.01 0 000-1.421l-1.272-1.279H16c.552 0 1-.45 1-1.005 0-.555-.448-1.005-1-1.005" fill="inherit"/></svg>`
    }, props));
$28203010af260ef6$var$ArrowLeftCircleIcon.displayName = "ArrowLeftCircleIcon";
var $28203010af260ef6$var$_default = $28203010af260ef6$var$ArrowLeftCircleIcon;
module.exports.default = $28203010af260ef6$var$_default;

});
parcelRegister("kupLT", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $eeaa99acd7bed7a1$export$f04a61298a47a40f; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $5LVXk = parcelRequire("5LVXk");

var $lBGNn = parcelRequire("lBGNn");

var $3sOQQ = parcelRequire("3sOQQ");
function $eeaa99acd7bed7a1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $eeaa99acd7bed7a1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $eeaa99acd7bed7a1$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $eeaa99acd7bed7a1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $eeaa99acd7bed7a1$var$iconStyles = (0, $avKww.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "> svg": $eeaa99acd7bed7a1$var$_objectSpread($eeaa99acd7bed7a1$var$_objectSpread({}, (0, $3sOQQ.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $eeaa99acd7bed7a1$var$baseHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $eeaa99acd7bed7a1$var$primaryEqualsSecondaryHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $eeaa99acd7bed7a1$var$secondaryTransparentHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $eeaa99acd7bed7a1$export$f04a61298a47a40f = /*#__PURE__*/ (0, $9nHZC.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $avKww.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $3sOQQ.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    var _useGlobalTheme = (0, $5LVXk.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $avKww.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            "--icon-secondary-color": secondaryColor || (0, $lBGNn.getBackground)(mode)
        }
    }, glyphProps, {
        css: [
            $eeaa99acd7bed7a1$var$iconStyles,
            $eeaa99acd7bed7a1$var$baseHcmStyles,
            primaryColor === secondaryColor && $eeaa99acd7bed7a1$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $eeaa99acd7bed7a1$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsualting them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $avKww.css)({
                width: dimensions.width,
                height: dimensions.height,
                "> svg": dimensions
            })
        ]
    }));
});
var $eeaa99acd7bed7a1$export$2e2bcd8739ae039 = $eeaa99acd7bed7a1$export$f04a61298a47a40f;

});
parcelRegister("lBGNn", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $fbae3ff197abfe24$export$18cb9425622d4e06; });
var $fbae3ff197abfe24$var$themedBackground = {
    light: "var(--ds-surface, #FFFFFF)",
    dark: "var(--ds-surface, #1B2638)"
};
var $fbae3ff197abfe24$export$18cb9425622d4e06 = function getBackground() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "light";
    return $fbae3ff197abfe24$var$themedBackground[mode];
};

});

parcelRegister("3sOQQ", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $285b6ea3b0063f04$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $285b6ea3b0063f04$export$3eb7d6130acfda37; });

var $f3Vj5 = parcelRequire("f3Vj5");

var $avKww = parcelRequire("avKww");
var $285b6ea3b0063f04$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
var $285b6ea3b0063f04$var$smallStyles = (0, $avKww.css)((0, $f3Vj5.dimensions).small);
var $285b6ea3b0063f04$var$mediumStyles = (0, $avKww.css)((0, $f3Vj5.dimensions).medium);
var $285b6ea3b0063f04$var$largeStyles = (0, $avKww.css)((0, $f3Vj5.dimensions).large);
var $285b6ea3b0063f04$var$xlargeStyles = (0, $avKww.css)((0, $f3Vj5.dimensions).xlarge);
var $285b6ea3b0063f04$export$ef0ad74202575b64 = {
    small: $285b6ea3b0063f04$var$smallStyles,
    medium: $285b6ea3b0063f04$var$mediumStyles,
    large: $285b6ea3b0063f04$var$largeStyles,
    xlarge: $285b6ea3b0063f04$var$xlargeStyles
};
var $285b6ea3b0063f04$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $f3Vj5.dimensions)[size];
    return undefined;
};

});
parcelRegister("f3Vj5", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $af7396c98c5a3f38$export$62ad7b0c781000e9; });
var $af7396c98c5a3f38$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $af7396c98c5a3f38$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $af7396c98c5a3f38$export$62ad7b0c781000e9 = {
    small: {
        width: $af7396c98c5a3f38$export$c647cb0ee6e282fe.small,
        height: $af7396c98c5a3f38$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $af7396c98c5a3f38$export$c647cb0ee6e282fe.medium,
        height: $af7396c98c5a3f38$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $af7396c98c5a3f38$export$c647cb0ee6e282fe.large,
        height: $af7396c98c5a3f38$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $af7396c98c5a3f38$export$c647cb0ee6e282fe.xlarge,
        height: $af7396c98c5a3f38$export$c647cb0ee6e282fe.xlarge
    }
};

});




parcelRegister("7XXi0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ccc08bfbc77ffaa$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $9nHZC = parcelRequire("9nHZC");

var $8OqBL = parcelRequire("8OqBL");

var $lIM1e = parcelRequire("lIM1e");

var $45CBz = parcelRequire("45CBz");
var $5ccc08bfbc77ffaa$var$_excluded = [
    "after"
];
function $5ccc08bfbc77ffaa$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5ccc08bfbc77ffaa$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $5ccc08bfbc77ffaa$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $5ccc08bfbc77ffaa$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(ConnectedItem, _Component);
    var _super = $5ccc08bfbc77ffaa$var$_createSuper(ConnectedItem);
    function ConnectedItem() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ConnectedItem);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ConnectedItem, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, after = _this$props.after, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_this$props, $5ccc08bfbc77ffaa$var$_excluded);
                return this.props.goTo ? (0, $45CBz.jsx)((0, $lIM1e.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
                    after: after
                })) : (0, $45CBz.jsx)((0, $8OqBL.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
                    after: after === null ? undefined : after
                }));
            }
        }
    ]);
    return ConnectedItem;
}((0, $9nHZC.Component));

});
parcelRegister("8OqBL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01a7dd73de4c91ff$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $8Z5er = parcelRequire("8Z5er");

var $eDVAW = parcelRequire("eDVAW");

var $b27fK = parcelRequire("b27fK");

var $hhWUm = parcelRequire("hhWUm");

var $45CBz = parcelRequire("45CBz");
var $01a7dd73de4c91ff$var$_excluded = [
    "createAnalyticsEvent"
];
function $01a7dd73de4c91ff$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $01a7dd73de4c91ff$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $01a7dd73de4c91ff$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $01a7dd73de4c91ff$export$9bef42d378bf045f = /*#__PURE__*/ function(_PureComponent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(Item, _PureComponent);
    var _super = $01a7dd73de4c91ff$var$_createSuper(Item);
    function Item() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, Item);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "renderItem", function(state) {
            var _this$props = _this.props, createAnalyticsEvent = _this$props.createAnalyticsEvent, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_this$props, $01a7dd73de4c91ff$var$_excluded);
            return (0, $45CBz.jsx)((0, $hhWUm.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, state, props));
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(Item, [
        {
            key: "render",
            value: function render() {
                return (0, $45CBz.jsx)((0, $b27fK.default), null, this.renderItem);
            }
        }
    ]);
    return Item;
}((0, $9nHZC.PureComponent));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($01a7dd73de4c91ff$export$9bef42d378bf045f, "defaultProps", {
    styles: (0, $eDVAW.default),
    isSelected: false,
    spacing: "default",
    text: ""
});
var $01a7dd73de4c91ff$export$2e2bcd8739ae039 = (0, $8Z5er.navigationItemClicked)($01a7dd73de4c91ff$export$9bef42d378bf045f, "item");

});
parcelRegister("8Z5er", function(module, exports) {

$parcel$export(module.exports, "navigationItemClicked", function () { return $68a8142b5c638078$export$b1a82e4eb8e26587; });
$parcel$export(module.exports, "navigationExpandedCollapsed", function () { return $68a8142b5c638078$export$b5a43c03aaaf6bb0; });

var $lOQkO = parcelRequire("lOQkO");

var $kFnE9 = parcelRequire("kFnE9");

var $kcNZB = parcelRequire("kcNZB");
var $e9mJX = parcelRequire("e9mJX");
var $68a8142b5c638078$var$_excluded = [
    "attributes"
];
function $68a8142b5c638078$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $68a8142b5c638078$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $68a8142b5c638078$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $68a8142b5c638078$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $68a8142b5c638078$export$1afa51c2443af055 = "navigation";
var $68a8142b5c638078$var$getDisplayName = function getDisplayName(component) {
    return component ? component.displayName || component.name : undefined;
};
var $68a8142b5c638078$var$kebabToCamelCase = function kebabToCamelCase(str) {
    return "".concat(str).replace(/-([a-z])/gi, function(g) {
        return g[1].toUpperCase();
    });
};
var $68a8142b5c638078$export$b1a82e4eb8e26587 = function navigationItemClicked(Component, componentName) {
    var useActionSubjectId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return (0, $kcNZB.default)({
        componentName: componentName
    })((0, $e9mJX.default)({
        onClick: function onClick(createAnalyticsEvent, props) {
            var id = $68a8142b5c638078$var$kebabToCamelCase(props.id);
            var basePayload = {
                action: "clicked",
                actionSubject: "navigationItem",
                attributes: {
                    componentName: componentName,
                    iconSource: $68a8142b5c638078$var$getDisplayName(props.icon) || $68a8142b5c638078$var$getDisplayName(props.before),
                    navigationItemIndex: props.index
                }
            };
            var payload;
            if (useActionSubjectId) payload = $68a8142b5c638078$var$_objectSpread($68a8142b5c638078$var$_objectSpread({}, basePayload), {}, {
                actionSubjectId: id
            });
            else {
                var attributes = basePayload.attributes, basePayloadSansAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(basePayload, $68a8142b5c638078$var$_excluded);
                payload = $68a8142b5c638078$var$_objectSpread($68a8142b5c638078$var$_objectSpread({}, basePayloadSansAttributes), {}, {
                    attributes: $68a8142b5c638078$var$_objectSpread($68a8142b5c638078$var$_objectSpread({}, attributes), {}, {
                        itemId: id
                    })
                });
            }
            var event = createAnalyticsEvent(payload);
            event.fire($68a8142b5c638078$export$1afa51c2443af055);
            return null;
        }
    })(Component));
};
var $68a8142b5c638078$export$159a71bd91228e60 = function navigationUILoaded(createAnalyticsEvent, _ref) {
    var layer = _ref.layer;
    return createAnalyticsEvent({
        action: "initialised",
        actionSubject: "navigationUI",
        actionSubjectId: layer,
        eventType: "operational"
    }).fire($68a8142b5c638078$export$1afa51c2443af055);
};
var $68a8142b5c638078$export$b5a43c03aaaf6bb0 = function navigationExpandedCollapsed(createAnalyticsEvent, _ref2) {
    var isCollapsed = _ref2.isCollapsed, trigger = _ref2.trigger;
    return createAnalyticsEvent({
        action: isCollapsed ? "collapsed" : "expanded",
        actionSubject: "productNavigation",
        attributes: {
            trigger: trigger
        }
    }).fire($68a8142b5c638078$export$1afa51c2443af055);
};

});
parcelRegister("kcNZB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb5bb521b63abcd5$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $8dO6V = parcelRequire("8dO6V");
var $eb5bb521b63abcd5$var$_excluded = [
    "analyticsContext"
];
function $eb5bb521b63abcd5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $eb5bb521b63abcd5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $eb5bb521b63abcd5$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $eb5bb521b63abcd5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $eb5bb521b63abcd5$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $eb5bb521b63abcd5$var$_excluded);
            var analyticsData = (0, $9nHZC.useMemo)(function() {
                return $eb5bb521b63abcd5$var$_objectSpread($eb5bb521b63abcd5$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $8dO6V.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
                ref: ref
            })));
        }); // @ts-ignore
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $eb5bb521b63abcd5$export$2e2bcd8739ae039 = $eb5bb521b63abcd5$var$withAnalyticsContext;

});
parcelRegister("8dO6V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fc6688fd5ec1e78$export$2e2bcd8739ae039; });

var $jHwTj = parcelRequire("jHwTj");

var $6dWPK = parcelRequire("6dWPK");

var $8ovux = parcelRequire("8ovux");
var $5fc6688fd5ec1e78$var$_process$env;
var $5fc6688fd5ec1e78$var$ExportedAnalyticsContext;
if (typeof $8ovux !== "undefined" && $8ovux !== null && ($5fc6688fd5ec1e78$var$_process$env = {}, true) && $5fc6688fd5ec1e78$var$_process$env !== void 0 && $5fc6688fd5ec1e78$var$_process$env["ANALYTICS_NEXT_MODERN_CONTEXT"]) $5fc6688fd5ec1e78$var$ExportedAnalyticsContext = (0, $6dWPK.default);
else $5fc6688fd5ec1e78$var$ExportedAnalyticsContext = (0, $jHwTj.default);
var $5fc6688fd5ec1e78$export$2e2bcd8739ae039 = $5fc6688fd5ec1e78$var$ExportedAnalyticsContext;

});
parcelRegister("jHwTj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e57b8bf6362ae9b8$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");

var $kZnbM = parcelRequire("kZnbM");
function $e57b8bf6362ae9b8$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e57b8bf6362ae9b8$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $e57b8bf6362ae9b8$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $e57b8bf6362ae9b8$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func
};
var $e57b8bf6362ae9b8$var$noop = function noop() {
    return [];
}; // eslint-disable-next-line @repo/internal/react/no-class-components
var $e57b8bf6362ae9b8$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(AnalyticsContext, _Component);
    var _super = $e57b8bf6362ae9b8$var$_createSuper(AnalyticsContext);
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsContext);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $e57b8bf6362ae9b8$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $e57b8bf6362ae9b8$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kZnbM.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsContext;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($e57b8bf6362ae9b8$var$AnalyticsContext, "contextTypes", $e57b8bf6362ae9b8$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($e57b8bf6362ae9b8$var$AnalyticsContext, "childContextTypes", $e57b8bf6362ae9b8$var$ContextTypes);
var $e57b8bf6362ae9b8$export$2e2bcd8739ae039 = $e57b8bf6362ae9b8$var$AnalyticsContext;

});

parcelRegister("6dWPK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $488198171537020f$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");

var $efsNQ = parcelRequire("efsNQ");

var $1XhnZ = parcelRequire("1XhnZ");
var $488198171537020f$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $1XhnZ.useTrackedRef)(data);
    var analyticsContext = (0, $efsNQ.useAnalyticsContext)();
    var getAtlaskitAnalyticsContext = (0, $9nHZC.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(analyticsContext.getAtlaskitAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        analyticsContext,
        dataRef
    ]);
    var value = (0, $9nHZC.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: analyticsContext.getAtlaskitAnalyticsEventHandlers
        };
    }, [
        analyticsContext,
        getAtlaskitAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kZnbM.default).Provider, {
        value: value
    }, children);
};
var $488198171537020f$export$2e2bcd8739ae039 = $488198171537020f$var$AnalyticsContext;

});
parcelRegister("efsNQ", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $a5f8cf180dd00076$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $a5f8cf180dd00076$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});

parcelRegister("1XhnZ", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $16c8c99780fa34c9$export$1d27a74659855e44; });

var $9nHZC = parcelRequire("9nHZC");
var $16c8c99780fa34c9$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    (0, $9nHZC.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
};

});




parcelRegister("e9mJX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4d38baad0f1115e$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $2QFHd = parcelRequire("2QFHd");

var $d0N83 = parcelRequire("d0N83");
var $a4d38baad0f1115e$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(props, ref) {
            var _usePatchedProps = (0, $d0N83.usePatchedProps)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $2QFHd.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        }); // @ts-ignore
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $a4d38baad0f1115e$export$2e2bcd8739ae039 = $a4d38baad0f1115e$var$withAnalyticsEvents;

});
parcelRegister("2QFHd", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $2130c80c1b818acd$export$5bf35293e545f20c; });

var $dNznA = parcelRequire("dNznA");

var $41U4A = parcelRequire("41U4A");

var $efsNQ = parcelRequire("efsNQ");
function $2130c80c1b818acd$export$5bf35293e545f20c() {
    var analyticsContext = (0, $efsNQ.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $41U4A.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("41U4A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ef2c0577ca2f2b1$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $fRtng = parcelRequire("fRtng");
function $2ef2c0577ca2f2b1$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2ef2c0577ca2f2b1$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $2ef2c0577ca2f2b1$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $2ef2c0577ca2f2b1$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $2ef2c0577ca2f2b1$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 ? void 0 : (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $2ef2c0577ca2f2b1$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $2ef2c0577ca2f2b1$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $fRtng.default));

});
parcelRegister("fRtng", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8c297623143fe12$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
function $b8c297623143fe12$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b8c297623143fe12$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b8c297623143fe12$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b8c297623143fe12$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $b8c297623143fe12$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $b8c297623143fe12$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 ? void 0 : (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $b8c297623143fe12$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $b8c297623143fe12$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(updater) === "object") this.payload = $b8c297623143fe12$var$_objectSpread($b8c297623143fe12$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});



parcelRegister("d0N83", function(module, exports) {

$parcel$export(module.exports, "usePatchedProps", function () { return $9791626e0aa55443$export$9ebb5a84d17e5d18; });

var $kFnE9 = parcelRequire("kFnE9");

var $340K4 = parcelRequire("340K4");

var $9nHZC = parcelRequire("9nHZC");

var $2QFHd = parcelRequire("2QFHd");
function $9791626e0aa55443$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9791626e0aa55443$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9791626e0aa55443$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9791626e0aa55443$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9791626e0aa55443$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $2QFHd.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $9nHZC.useRef)({});
    var patchedProps = (0, $9nHZC.useMemo)(function() {
        var cache = handlerCache.current; // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                "object",
                "function"
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $9791626e0aa55443$var$_objectSpread($9791626e0aa55443$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === "function" ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === "function") {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $9791626e0aa55443$var$_objectSpread($9791626e0aa55443$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});



parcelRegister("eDVAW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa91625cb71baa59$export$2e2bcd8739ae039; });
var $aa91625cb71baa59$var$styleReducerNoOp = function styleReducerNoOp(styles) {
    return styles;
};
var $aa91625cb71baa59$export$2e2bcd8739ae039 = $aa91625cb71baa59$var$styleReducerNoOp;

});

parcelRegister("b27fK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $808581edf34e64f6$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $45CBz = parcelRequire("45CBz");
function $808581edf34e64f6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $808581edf34e64f6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $808581edf34e64f6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $808581edf34e64f6$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $808581edf34e64f6$var$_ref = {
    name: "7xjigh",
    styles: "width:100%;align-items:center;display:flex;flex-direction:column;justify-content:space-between;"
};
var $808581edf34e64f6$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(InteractionStateManager, _Component);
    var _super = $808581edf34e64f6$var$_createSuper(InteractionStateManager);
    function InteractionStateManager() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, InteractionStateManager);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "state", {
            isActive: false,
            isHover: false,
            isFocused: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onMouseDown", function(e) {
            e.preventDefault();
            _this.setState({
                isActive: true
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onMouseUp", function(e) {
            e.preventDefault();
            _this.setState({
                isActive: false,
                isHover: true
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onMouseEnter", function() {
            if (!_this.state.isHover) _this.setState({
                isHover: true
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onMouseLeave", function() {
            _this.setState({
                isActive: false,
                isHover: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onFocus", function() {
            return _this.setState({
                isFocused: true
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onBlur", function() {
            return _this.setState({
                isFocused: false
            });
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(InteractionStateManager, [
        {
            key: "render",
            value: function render() {
                return (0, $45CBz.jsx)("div", {
                    onMouseDown: this.onMouseDown,
                    onMouseEnter: this.onMouseEnter,
                    onMouseLeave: this.onMouseLeave,
                    onMouseUp: this.onMouseUp,
                    onFocus: this.onFocus,
                    onBlur: this.onBlur,
                    role: "presentation",
                    css: $808581edf34e64f6$var$_ref
                }, this.props.children(this.state));
            }
        }
    ]);
    return InteractionStateManager;
}((0, $9nHZC.Component));

});

parcelRegister("hhWUm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c961b816c4595308$export$2e2bcd8739ae039; });

var $7KAwG = parcelRequire("7KAwG");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $fIcbc = parcelRequire("fIcbc");

var $eDVAW = parcelRequire("eDVAW");
var $vjMcg = parcelRequire("vjMcg");

var $45CBz = parcelRequire("45CBz");
var $c961b816c4595308$var$_excluded = [
    "as",
    "dataset",
    "draggableProps",
    "innerRef"
];
function $c961b816c4595308$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c961b816c4595308$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $c961b816c4595308$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c961b816c4595308$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c961b816c4595308$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c961b816c4595308$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c961b816c4595308$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $c961b816c4595308$var$isString = function isString(x) {
    return typeof x === "string";
};
var $c961b816c4595308$var$ComponentSwitch = function ComponentSwitch(_ref) {
    var as = _ref.as, dataset = _ref.dataset, draggableProps = _ref.draggableProps, innerRef = _ref.innerRef, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $c961b816c4595308$var$_excluded);
    var isElement = $c961b816c4595308$var$isString(as);
    var props = isElement ? $c961b816c4595308$var$_objectSpread($c961b816c4595308$var$_objectSpread({}, dataset), rest) : $c961b816c4595308$var$_objectSpread({
        innerRef: innerRef,
        dataset: dataset,
        draggableProps: draggableProps
    }, rest); // only pass the actual `ref` to an element, it's the responsibility of the
    // component author to use `innerRef` where applicable
    var ref = isElement ? innerRef : null;
    var ElementOrComponent = as;
    return (0, $45CBz.jsx)(ElementOrComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        ref: ref
    }, draggableProps, props));
};
var $c961b816c4595308$var$getItemComponentProps = function getItemComponentProps(props) {
    var nonComponentKeys = [
        "isActive",
        "isHover",
        "isSelected",
        "isFocused",
        "isDragging",
        "theme"
    ];
    var componentProps = {};
    Object.keys(props).forEach(function(prop) {
        if (!nonComponentKeys.includes(prop)) componentProps[prop] = props[prop];
    });
    return componentProps;
};
var $c961b816c4595308$export$28fd94a498a7729d = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(ItemPrimitive, _Component);
    var _super = $c961b816c4595308$var$_createSuper(ItemPrimitive);
    function ItemPrimitive() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ItemPrimitive);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ItemPrimitive, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                return !(0, (/*@__PURE__*/$parcel$interopDefault($fIcbc)))(this.props, nextProps);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, After = _this$props.after, Before = _this$props.before, CustomComponent = _this$props.component, dataset = _this$props.dataset, draggableProps = _this$props.draggableProps, href = _this$props.href, innerRef = _this$props.innerRef, isActive = _this$props.isActive, isDragging = _this$props.isDragging, isHover = _this$props.isHover, isSelected = _this$props.isSelected, isFocused = _this$props.isFocused, onClick = _this$props.onClick, spacing = _this$props.spacing, styleReducer = _this$props.styles, subText = _this$props.subText, target = _this$props.target, text = _this$props.text, theme = _this$props.theme;
                var mode = theme.mode, context = theme.context;
                var presentationProps = {
                    isActive: isActive,
                    isDragging: isDragging,
                    isHover: isHover,
                    isSelected: isSelected,
                    isFocused: isFocused,
                    spacing: spacing
                };
                var defaultStyles = mode.item(presentationProps)[context];
                var styles = styleReducer(defaultStyles, presentationProps, theme); // base element switch
                var itemComponent = "div";
                var itemProps = {
                    draggableProps: draggableProps,
                    innerRef: innerRef,
                    dataset: dataset
                };
                var _this$props2 = this.props, afterGoTo = _this$props2.afterGoTo, spinnerDelay = _this$props2.spinnerDelay, incomingView = _this$props2.incomingView;
                var propsForAfterComp = {
                    afterGoTo: afterGoTo,
                    spinnerDelay: spinnerDelay,
                    incomingView: incomingView
                };
                if (CustomComponent) {
                    itemComponent = CustomComponent;
                    itemProps = $c961b816c4595308$var$getItemComponentProps(this.props);
                } else if (href) {
                    itemComponent = "a";
                    itemProps = {
                        dataset: dataset,
                        href: href,
                        onClick: onClick,
                        target: target,
                        draggableProps: draggableProps,
                        innerRef: innerRef
                    };
                } else if (onClick) {
                    itemComponent = "button";
                    itemProps = {
                        dataset: dataset,
                        onClick: onClick,
                        draggableProps: draggableProps,
                        innerRef: innerRef
                    };
                }
                return (0, $45CBz.jsx)($c961b816c4595308$var$ComponentSwitch, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                    as: itemComponent,
                    css: /*#__PURE__*/ (0, $7KAwG.default)({
                        "&&": styles.itemBase
                    }, "")
                }, itemProps), !!Before && (0, $45CBz.jsx)("div", {
                    css: styles.beforeWrapper
                }, (0, $45CBz.jsx)(Before, presentationProps)), (0, $45CBz.jsx)("div", {
                    css: styles.contentWrapper
                }, (0, $45CBz.jsx)("div", {
                    css: styles.textWrapper
                }, text), !!subText && (0, $45CBz.jsx)("div", {
                    css: styles.subTextWrapper
                }, subText)), !!After && (0, $45CBz.jsx)("div", {
                    css: styles.afterWrapper
                }, (0, $45CBz.jsx)(After, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, presentationProps, propsForAfterComp))));
            }
        }
    ]);
    return ItemPrimitive;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($c961b816c4595308$export$28fd94a498a7729d, "defaultProps", {
    dataset: {
        "data-testid": "NavigationItem"
    },
    isActive: false,
    isDragging: false,
    isHover: false,
    isSelected: false,
    isFocused: false,
    spacing: "default",
    styles: (0, $eDVAW.default),
    text: ""
});
var $c961b816c4595308$export$2e2bcd8739ae039 = (0, $vjMcg.withContentTheme)($c961b816c4595308$export$28fd94a498a7729d);

});
parcelRegister("vjMcg", function(module, exports) {

$parcel$export(module.exports, "withContentTheme", function () { return $05e23c8a3dcbe28b$export$9c7d88d2045ed769; });
$parcel$export(module.exports, "withGlobalTheme", function () { return $05e23c8a3dcbe28b$export$4c5b227ef73a5acb; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");
parcelRequire("9nHZC");

var $1HkF5 = parcelRequire("1HkF5");

var $3YYFd = parcelRequire("3YYFd");

var $45CBz = parcelRequire("45CBz");
var $05e23c8a3dcbe28b$var$_excluded = [
    "theme"
];
var $05e23c8a3dcbe28b$var$withTheme = function withTheme(defaultTheme) {
    return function(WrappedComponent) {
        var WithTheme = (0, $1HkF5.withTheme)(function(props) {
            var ctxTheme = props.theme, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(props, $05e23c8a3dcbe28b$var$_excluded);
            var theme = Object.keys(ctxTheme).length > 0 ? ctxTheme : defaultTheme;
            return (0, $45CBz.jsx)(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                theme: theme
            }, rest));
        });
        WithTheme.displayName = "WithTheme(".concat(WrappedComponent.displayName || WrappedComponent.name || "Component", ")");
        return WithTheme;
    };
};
var $05e23c8a3dcbe28b$var$defaultContentTheme = {
    mode: (0, $3YYFd.light),
    context: "container"
};
var $05e23c8a3dcbe28b$var$defaultGlobalTheme = {
    mode: (0, $3YYFd.light)
};
var $05e23c8a3dcbe28b$export$9c7d88d2045ed769 = function withContentTheme(WrappedComponent) {
    return $05e23c8a3dcbe28b$var$withTheme($05e23c8a3dcbe28b$var$defaultContentTheme)(WrappedComponent);
};
var $05e23c8a3dcbe28b$export$4c5b227ef73a5acb = function withGlobalTheme(WrappedComponent) {
    return $05e23c8a3dcbe28b$var$withTheme($05e23c8a3dcbe28b$var$defaultGlobalTheme)(WrappedComponent);
};
var $05e23c8a3dcbe28b$export$2e2bcd8739ae039 = $05e23c8a3dcbe28b$var$withTheme;

});
parcelRegister("1HkF5", function(module, exports) {

$parcel$export(module.exports, "ThemeProvider", function () { return $13c9d59a1023ebb3$export$d8964aec282183a3; });
$parcel$export(module.exports, "withTheme", function () { return $13c9d59a1023ebb3$export$e8748c6a27b910dc; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("45CBz");
var $eDDQP = parcelRequire("eDDQP");

var $hhKuv = parcelRequire("hhKuv");

var $fPPqr = parcelRequire("fPPqr");

var $1t1PC = parcelRequire("1t1PC");
function $13c9d59a1023ebb3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $13c9d59a1023ebb3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $13c9d59a1023ebb3$var$ownKeys(source, true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $13c9d59a1023ebb3$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $13c9d59a1023ebb3$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return $13c9d59a1023ebb3$var$_objectSpread({}, outerTheme, {}, theme);
};
var $13c9d59a1023ebb3$var$createCacheWithTheme = (0, $hhKuv.default)(function(outerTheme) {
    return (0, $hhKuv.default)(function(theme) {
        return $13c9d59a1023ebb3$var$getTheme(outerTheme, theme);
    });
});
var $13c9d59a1023ebb3$export$d8964aec282183a3 = function ThemeProvider(props) {
    return (0, $9nHZC.createElement)((0, $eDDQP.T).Consumer, null, function(theme) {
        if (props.theme !== theme) theme = $13c9d59a1023ebb3$var$createCacheWithTheme(theme)(props.theme);
        return (0, $9nHZC.createElement)((0, $eDDQP.T).Provider, {
            value: theme
        }, props.children);
    });
};
// should we change this to be forwardRef/withCSSContext style so it doesn't merge with props?
function $13c9d59a1023ebb3$export$e8748c6a27b910dc(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        return (0, $9nHZC.createElement)((0, $eDDQP.T).Consumer, null, function(theme) {
            return (0, $9nHZC.createElement)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                theme: theme,
                ref: ref
            }, props));
        });
    }; // $FlowFixMe
    var WithTheme = (0, $9nHZC.forwardRef)(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($1t1PC)))(WithTheme, Component);
}
function $13c9d59a1023ebb3$export$93d4e7f90805808f() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).useContext((0, $eDDQP.T));
}

});

parcelRegister("3YYFd", function(module, exports) {

$parcel$export(module.exports, "light", function () { return $2e660846294a7f30$export$a43af521ac8c3202; });
$parcel$export(module.exports, "dark", function () { return $2e660846294a7f30$export$55ce6f3a06c59543; });
$parcel$export(module.exports, "settings", function () { return $2e660846294a7f30$export$a5a6e0b888b2c992; });

var $jp7ng = parcelRequire("jp7ng");

var $hh6qM = parcelRequire("hh6qM");
var $2e660846294a7f30$export$a43af521ac8c3202 = (0, $hh6qM.default)({
    product: {
        text: (0, $jp7ng.N0),
        background: (0, $jp7ng.B500)
    }
});
var $2e660846294a7f30$export$55ce6f3a06c59543 = (0, $hh6qM.default)({
    product: {
        text: (0, $jp7ng.DN500),
        background: (0, $jp7ng.DN10)
    }
});
var $2e660846294a7f30$export$a5a6e0b888b2c992 = (0, $hh6qM.default)({
    product: {
        text: (0, $jp7ng.N0),
        background: (0, $jp7ng.N800)
    }
});

});
parcelRegister("hh6qM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c939033b2d48f6ae$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $2SSCH = parcelRequire("2SSCH");

var $274dC = parcelRequire("274dC");

var $6dSvB = parcelRequire("6dSvB");

var $jx8nG = parcelRequire("jx8nG");

var $dzwGj = parcelRequire("dzwGj");

var $90eOl = parcelRequire("90eOl");

var $3hhFC = parcelRequire("3hhFC");

var $89wl0 = parcelRequire("89wl0");

var $1tKTJ = parcelRequire("1tKTJ");
function $c939033b2d48f6ae$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c939033b2d48f6ae$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c939033b2d48f6ae$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c939033b2d48f6ae$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $c939033b2d48f6ae$var$colorMatrix = [
    {
        // Dark
        when: function when(_ref) {
            var l = _ref.l;
            return l <= 20;
        },
        hint: {
            s: 0,
            l: 16
        },
        interact: {
            s: -4,
            l: 8
        },
        static: {
            s: -8,
            l: 12
        }
    },
    {
        // bright and saturated
        when: function when(_ref2) {
            var s = _ref2.s, l = _ref2.l;
            return s > 65 && l > 30;
        },
        hint: {
            s: -16,
            l: 12
        },
        interact: {
            s: -16,
            l: 8
        },
        static: {
            s: 0,
            l: -8
        }
    },
    {
        // bright and dull
        when: function when(_ref3) {
            var s = _ref3.s, l = _ref3.l;
            return s <= 20 && l > 90;
        },
        hint: {
            s: 0,
            l: -2
        },
        interact: {
            s: 0,
            l: -4
        },
        static: {
            s: 0,
            l: -6
        }
    },
    {
        // pastel
        when: function when(_ref4) {
            var s = _ref4.s, l = _ref4.l;
            return s > 20 && s < 50 && l > 50;
        },
        hint: {
            s: 24,
            l: 2
        },
        interact: {
            s: 8,
            l: -4
        },
        static: {
            s: 8,
            l: -12
        }
    },
    {
        // dull
        when: function when(_ref5) {
            var s = _ref5.s, l = _ref5.l;
            return s <= 20 && l <= 90;
        },
        hint: {
            s: 0,
            l: 4
        },
        interact: {
            s: 0,
            l: -4
        },
        static: {
            s: 0,
            l: -8
        }
    }
];
var $c939033b2d48f6ae$var$getStatesBackground = function getStatesBackground(parts, modifier) {
    return [
        "hint",
        "interact",
        "static"
    ].reduce(function(acc, k) {
        acc[k] = (0, $2SSCH.default).convert($c939033b2d48f6ae$var$_objectSpread($c939033b2d48f6ae$var$_objectSpread({}, parts), {}, {
            s: parts.s + modifier[k].s,
            l: parts.l + modifier[k].l
        })).hex;
        return acc;
    }, {});
};
var $c939033b2d48f6ae$var$getContextColors = function getContextColors(_ref6) {
    var background = _ref6.background, text = _ref6.text;
    var bgParts = (0, $2SSCH.default).convert(background).hsl;
    var vs = bgParts.l < 30 && bgParts.s < 50 ? -1 : 1;
    var textSubtle = (0, $2SSCH.default).brightness(1 + vs * 6, (0, $2SSCH.default).fade(4, background, text).hex[2]).hex;
    var colorMod = $c939033b2d48f6ae$var$colorMatrix.find(function(cm) {
        return cm.when(bgParts);
    }) || {
        hint: {
            s: 0,
            l: 8
        },
        interact: {
            s: 0,
            l: 4
        },
        static: {
            s: 8,
            l: -6
        }
    };
    return {
        background: $c939033b2d48f6ae$var$_objectSpread({
            default: background
        }, $c939033b2d48f6ae$var$getStatesBackground(bgParts, colorMod)),
        text: {
            default: text,
            subtle: textSubtle
        }
    };
};
var $c939033b2d48f6ae$export$2e2bcd8739ae039 = function(_ref7) {
    var product = _ref7.product;
    var modeColors = {
        product: $c939033b2d48f6ae$var$getContextColors(product)
    };
    return {
        globalItem: (0, $6dSvB.default)(modeColors),
        globalNav: (0, $jx8nG.default)(modeColors),
        contentNav: (0, $274dC.default)(modeColors),
        heading: (0, $dzwGj.default)(modeColors),
        item: (0, $90eOl.default)(modeColors),
        section: (0, $3hhFC.default)(modeColors),
        separator: (0, $89wl0.default)(modeColors),
        skeletonItem: (0, $1tKTJ.default)(modeColors)
    };
};

});
parcelRegister("2SSCH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $219afef65eab6aad$export$2e2bcd8739ae039; });
function $219afef65eab6aad$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $219afef65eab6aad$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $219afef65eab6aad$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $219afef65eab6aad$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $219afef65eab6aad$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $219afef65eab6aad$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $219afef65eab6aad$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $219afef65eab6aad$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $219afef65eab6aad$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $219afef65eab6aad$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $219afef65eab6aad$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $219afef65eab6aad$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $219afef65eab6aad$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $219afef65eab6aad$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $219afef65eab6aad$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $219afef65eab6aad$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $219afef65eab6aad$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $219afef65eab6aad$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $219afef65eab6aad$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $219afef65eab6aad$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $219afef65eab6aad$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $219afef65eab6aad$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $219afef65eab6aad$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $219afef65eab6aad$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $219afef65eab6aad$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $219afef65eab6aad$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $219afef65eab6aad$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $219afef65eab6aad$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $219afef65eab6aad$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $219afef65eab6aad$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $219afef65eab6aad$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $219afef65eab6aad$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $219afef65eab6aad$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $219afef65eab6aad$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $219afef65eab6aad$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $219afef65eab6aad$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $219afef65eab6aad$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $219afef65eab6aad$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $219afef65eab6aad$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $219afef65eab6aad$var$fromHex_1 = $219afef65eab6aad$var$fromHex, $219afef65eab6aad$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $219afef65eab6aad$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $219afef65eab6aad$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $219afef65eab6aad$var$fromRgb_1 = $219afef65eab6aad$var$fromRgb, $219afef65eab6aad$var$fromCssRgb_1 = $219afef65eab6aad$var$fromCssRgb, $219afef65eab6aad$var$fromHsl_1 = $219afef65eab6aad$var$fromHsl, $219afef65eab6aad$var$fromCssHsl_1 = $219afef65eab6aad$var$fromCssHsl, $219afef65eab6aad$var$fromHsv_1 = $219afef65eab6aad$var$fromHsv, $219afef65eab6aad$var$fromCmyk_1 = $219afef65eab6aad$var$fromCmyk, $219afef65eab6aad$var$fromYiq_1 = $219afef65eab6aad$var$fromYiq, $219afef65eab6aad$var$fromXYZ_1 = $219afef65eab6aad$var$fromXYZ, $219afef65eab6aad$var$fromxyY_1 = $219afef65eab6aad$var$fromxyY, $219afef65eab6aad$var$fromLms_1 = $219afef65eab6aad$var$fromLms, $219afef65eab6aad$var$fromCieLab_1 = $219afef65eab6aad$var$fromCieLab, $219afef65eab6aad$var$fromCieLuv_1 = $219afef65eab6aad$var$fromCieLuv, $219afef65eab6aad$var$fromCieLch_1 = $219afef65eab6aad$var$fromCieLch, $219afef65eab6aad$var$fromHsluv = $219afef65eab6aad$var$fromCieLch$1, $219afef65eab6aad$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $219afef65eab6aad$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $219afef65eab6aad$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $219afef65eab6aad$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $219afef65eab6aad$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $219afef65eab6aad$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $219afef65eab6aad$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $219afef65eab6aad$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $219afef65eab6aad$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $219afef65eab6aad$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $219afef65eab6aad$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $219afef65eab6aad$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $219afef65eab6aad$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $219afef65eab6aad$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $219afef65eab6aad$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $219afef65eab6aad$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $219afef65eab6aad$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $219afef65eab6aad$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $219afef65eab6aad$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $219afef65eab6aad$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $219afef65eab6aad$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $219afef65eab6aad$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $219afef65eab6aad$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $219afef65eab6aad$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $219afef65eab6aad$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $219afef65eab6aad$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $219afef65eab6aad$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $219afef65eab6aad$var$fromHsluv
    }
}, $219afef65eab6aad$var$adapt_1 = $219afef65eab6aad$var$adapt, $219afef65eab6aad$var$adjacent_1 = $219afef65eab6aad$var$adjacent, $219afef65eab6aad$var$brightness_1 = $219afef65eab6aad$var$brightness, $219afef65eab6aad$var$complementary_1 = $219afef65eab6aad$var$complementary, $219afef65eab6aad$var$contrast_1 = $219afef65eab6aad$var$contrast, $219afef65eab6aad$var$contrastRatio_1 = $219afef65eab6aad$var$contrastRatio, $219afef65eab6aad$var$convert_1 = $219afef65eab6aad$var$convert, $219afef65eab6aad$var$difference_1 = $219afef65eab6aad$var$difference, $219afef65eab6aad$var$fade_1 = $219afef65eab6aad$var$fade, $219afef65eab6aad$var$greyscale_1 = $219afef65eab6aad$var$greyscale, $219afef65eab6aad$var$hue_1 = $219afef65eab6aad$var$hue, $219afef65eab6aad$var$invert_1 = $219afef65eab6aad$var$invert, $219afef65eab6aad$var$invertLightness_1 = $219afef65eab6aad$var$invertLightness, $219afef65eab6aad$var$mid_1 = $219afef65eab6aad$var$mid, $219afef65eab6aad$var$multiply_1 = $219afef65eab6aad$var$multiply, $219afef65eab6aad$var$saturation_1 = $219afef65eab6aad$var$saturation, $219afef65eab6aad$var$sepia_1 = $219afef65eab6aad$var$sepia, $219afef65eab6aad$var$shade_1 = $219afef65eab6aad$var$shade, $219afef65eab6aad$var$temperature_1 = $219afef65eab6aad$var$temperature, $219afef65eab6aad$var$tetrad_1 = $219afef65eab6aad$var$tetrad, $219afef65eab6aad$var$triad_1 = $219afef65eab6aad$var$triad, $219afef65eab6aad$var$index$2 = {
    adapt: $219afef65eab6aad$var$adapt_1,
    adjacent: $219afef65eab6aad$var$adjacent_1,
    brightness: $219afef65eab6aad$var$brightness_1,
    complementary: $219afef65eab6aad$var$complementary_1,
    contrast: $219afef65eab6aad$var$contrast_1,
    contrastRatio: $219afef65eab6aad$var$contrastRatio_1,
    convert: $219afef65eab6aad$var$convert_1,
    difference: $219afef65eab6aad$var$difference_1,
    fade: $219afef65eab6aad$var$fade_1,
    greyscale: $219afef65eab6aad$var$greyscale_1,
    hue: $219afef65eab6aad$var$hue_1,
    invert: $219afef65eab6aad$var$invert_1,
    invertLightness: $219afef65eab6aad$var$invertLightness_1,
    mid: $219afef65eab6aad$var$mid_1,
    multiply: $219afef65eab6aad$var$multiply_1,
    saturation: $219afef65eab6aad$var$saturation_1,
    sepia: $219afef65eab6aad$var$sepia_1,
    shade: $219afef65eab6aad$var$shade_1,
    temperature: $219afef65eab6aad$var$temperature_1,
    tetrad: $219afef65eab6aad$var$tetrad_1,
    triad: $219afef65eab6aad$var$triad_1
}, $219afef65eab6aad$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $219afef65eab6aad$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $219afef65eab6aad$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($219afef65eab6aad$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $219afef65eab6aad$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($219afef65eab6aad$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $219afef65eab6aad$var$api_1 = $219afef65eab6aad$var$api, $219afef65eab6aad$var$helpers = {
    getIlluminant: function(r) {
        return $219afef65eab6aad$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $219afef65eab6aad$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $219afef65eab6aad$var$index)if ($219afef65eab6aad$var$index.hasOwnProperty(e) && $219afef65eab6aad$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $219afef65eab6aad$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $219afef65eab6aad$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $219afef65eab6aad$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $219afef65eab6aad$var$constants, s));
            default:
                return null;
        }
    }
}, $219afef65eab6aad$var$helpers_1 = $219afef65eab6aad$var$helpers, $219afef65eab6aad$var$dependencies = {
    conversions: $219afef65eab6aad$var$index,
    operations: $219afef65eab6aad$var$index$2,
    helpers: $219afef65eab6aad$var$helpers_1
}, $219afef65eab6aad$var$entry = $219afef65eab6aad$var$api_1($219afef65eab6aad$var$dependencies, $219afef65eab6aad$var$constants);
var $219afef65eab6aad$export$2e2bcd8739ae039 = $219afef65eab6aad$var$entry;

});

parcelRegister("274dC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $189f81faf08d5170$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $jp7ng = parcelRequire("jp7ng");

var $5SBZk = parcelRequire("5SBZk");
function $189f81faf08d5170$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $189f81faf08d5170$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $189f81faf08d5170$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $189f81faf08d5170$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $189f81faf08d5170$var$baseStyles = {
    boxSizing: "border-box",
    height: "100%",
    left: 0,
    minWidth: (0, $5SBZk.CONTENT_NAV_WIDTH),
    overflowX: "hidden",
    position: "absolute",
    top: 0,
    width: "100%"
};
var $189f81faf08d5170$export$2e2bcd8739ae039 = function(_ref) {
    var product = _ref.product;
    return function() {
        return {
            container: $189f81faf08d5170$var$_objectSpread($189f81faf08d5170$var$_objectSpread({}, $189f81faf08d5170$var$baseStyles), {}, {
                backgroundColor: (0, $jp7ng.N20),
                color: (0, $jp7ng.N500)
            }),
            product: $189f81faf08d5170$var$_objectSpread($189f81faf08d5170$var$_objectSpread({}, $189f81faf08d5170$var$baseStyles), {}, {
                backgroundColor: product.background.default,
                color: product.text.default
            })
        };
    };
};

});
parcelRegister("5SBZk", function(module, exports) {

$parcel$export(module.exports, "transitionDuration", function () { return $447f768c11b282a8$export$3105270315df0e7; });
$parcel$export(module.exports, "transitionDurationMs", function () { return $447f768c11b282a8$export$614e920ab938d7a6; });
$parcel$export(module.exports, "transitionTimingFunction", function () { return $447f768c11b282a8$export$5cc90842f5a0bf76; });
$parcel$export(module.exports, "FLYOUT_DELAY", function () { return $447f768c11b282a8$export$1074d925b0b82be5; });
$parcel$export(module.exports, "ALTERNATE_FLYOUT_DELAY", function () { return $447f768c11b282a8$export$6af600dc35072c8a; });
$parcel$export(module.exports, "CONTENT_NAV_WIDTH", function () { return $447f768c11b282a8$export$278e39ad3c9940dc; });
$parcel$export(module.exports, "CONTENT_NAV_WIDTH_FLYOUT", function () { return $447f768c11b282a8$export$9a1ba89e4cefe5ca; });
$parcel$export(module.exports, "CONTENT_NAV_WIDTH_COLLAPSED", function () { return $447f768c11b282a8$export$858cc9562b32d8b4; });
$parcel$export(module.exports, "GLOBAL_NAV_WIDTH", function () { return $447f768c11b282a8$export$866e8626b3c47f93; });
$parcel$export(module.exports, "GLOBAL_NAV_COLLAPSE_THRESHOLD", function () { return $447f768c11b282a8$export$78659a568be118ba; });
$parcel$export(module.exports, "HORIZONTAL_GLOBAL_NAV_HEIGHT", function () { return $447f768c11b282a8$export$30fa7cc5f2690a43; });
var $447f768c11b282a8$export$3105270315df0e7 = "0.22s";
var $447f768c11b282a8$export$614e920ab938d7a6 = 220;
var $447f768c11b282a8$export$5cc90842f5a0bf76 = "cubic-bezier(0.2, 0, 0, 1)";
var $447f768c11b282a8$export$1074d925b0b82be5 = 350;
var $447f768c11b282a8$export$6af600dc35072c8a = 200;
var $447f768c11b282a8$export$278e39ad3c9940dc = 240;
var $447f768c11b282a8$export$9a1ba89e4cefe5ca = 232;
var $447f768c11b282a8$export$858cc9562b32d8b4 = 20;
var $447f768c11b282a8$export$866e8626b3c47f93 = 64;
var $447f768c11b282a8$export$78659a568be118ba = 200;
var $447f768c11b282a8$export$30fa7cc5f2690a43 = 56;

});


parcelRegister("6dSvB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $487e3d402360f2c4$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $jp7ng = parcelRequire("jp7ng");

var $aP6k3 = parcelRequire("aP6k3");
function $487e3d402360f2c4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $487e3d402360f2c4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $487e3d402360f2c4$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $487e3d402360f2c4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $487e3d402360f2c4$var$baseStyles = {
    itemBase: {
        alignItems: "center",
        border: 0,
        borderRadius: "50%",
        color: "inherit",
        cursor: "pointer",
        display: "flex",
        fontSize: "inherit",
        justifyContent: "center",
        lineHeight: 1,
        outline: "none",
        padding: 0,
        position: "relative",
        // allow badge positioning
        "&:focus": {
            boxShadow: "0 0 0 2px ".concat((0, $jp7ng.B100))
        }
    },
    badgeWrapper: {
        pointerEvents: "none",
        position: "absolute",
        userSelect: "none"
    },
    itemWrapper: {
        display: "flex"
    }
};
var $487e3d402360f2c4$var$sizeStyles = {
    large: {
        itemBase: {
            height: "".concat((0, $aP6k3.gridSize)() * 5, "px"),
            width: "".concat((0, $aP6k3.gridSize)() * 5, "px")
        },
        badgeWrapper: {
            left: "".concat((0, $aP6k3.gridSize)() * 2, "px"),
            top: 0
        },
        itemWrapper: {}
    },
    small: {
        itemBase: {
            height: "".concat((0, $aP6k3.gridSize)() * 4, "px"),
            width: "".concat((0, $aP6k3.gridSize)() * 4, "px")
        },
        badgeWrapper: {
            left: "".concat((0, $aP6k3.gridSize)() * 2.5, "px"),
            top: "-".concat((0, $aP6k3.gridSize)() / 2, "px")
        },
        itemWrapper: {
            padding: "".concat((0, $aP6k3.gridSize)() / 2, "px")
        }
    }
};
var $487e3d402360f2c4$export$2e2bcd8739ae039 = function(_ref) {
    var product = _ref.product;
    return function(_ref2) {
        var isActive = _ref2.isActive, isHover = _ref2.isHover, isSelected = _ref2.isSelected, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? "large" : _ref2$size;
        return {
            itemBase: $487e3d402360f2c4$var$_objectSpread($487e3d402360f2c4$var$_objectSpread($487e3d402360f2c4$var$_objectSpread({}, $487e3d402360f2c4$var$baseStyles.itemBase), $487e3d402360f2c4$var$sizeStyles[size].itemBase), {}, {
                backgroundColor: function() {
                    if (isSelected) return product.background.static;
                    if (isActive) return product.background.interact;
                    if (isHover) return product.background.hint;
                    return product.background.default;
                }(),
                color: product.text.default
            }),
            badgeWrapper: $487e3d402360f2c4$var$_objectSpread($487e3d402360f2c4$var$_objectSpread({}, $487e3d402360f2c4$var$baseStyles.badgeWrapper), $487e3d402360f2c4$var$sizeStyles[size].badgeWrapper),
            itemWrapper: $487e3d402360f2c4$var$_objectSpread({}, $487e3d402360f2c4$var$sizeStyles[size].itemWrapper)
        };
    };
};

});

parcelRegister("jx8nG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e38799a82038a287$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $aP6k3 = parcelRequire("aP6k3");

var $5SBZk = parcelRequire("5SBZk");
function $e38799a82038a287$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e38799a82038a287$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e38799a82038a287$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e38799a82038a287$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $e38799a82038a287$var$gridSize = (0, $aP6k3.gridSize)();
var $e38799a82038a287$var$baseStyles = {
    alignItems: "center",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    justifyContent: "space-between",
    paddingBottom: "calc(".concat($e38799a82038a287$var$gridSize * 3 - 4, "px)"),
    paddingTop: $e38799a82038a287$var$gridSize * 3,
    transition: "background-color 0.3s cubic-bezier(0.2, 0, 0, 1), color 0.3s cubic-bezier(0.2, 0, 0, 1)",
    width: (0, $5SBZk.GLOBAL_NAV_WIDTH)
};
var $e38799a82038a287$export$2e2bcd8739ae039 = function(_ref) {
    var product = _ref.product;
    return function() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            topOffset: "0"
        }, topOffset = _ref2.topOffset;
        return $e38799a82038a287$var$_objectSpread($e38799a82038a287$var$_objectSpread({}, $e38799a82038a287$var$baseStyles), {}, {
            height: "calc(100vh - ".concat(topOffset, "px)"),
            backgroundColor: product.background.default,
            color: product.text.default,
            fill: product.background.default
        });
    };
};

});

parcelRegister("dzwGj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e17e519f3ca7187$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $jp7ng = parcelRequire("jp7ng");

var $aP6k3 = parcelRequire("aP6k3");
function $9e17e519f3ca7187$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9e17e519f3ca7187$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9e17e519f3ca7187$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9e17e519f3ca7187$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $9e17e519f3ca7187$var$gridSize = (0, $aP6k3.gridSize)();
var $9e17e519f3ca7187$var$fontSize = 11;
var $9e17e519f3ca7187$var$baseStyles = {
    headingBase: {
        alignItems: "center",
        display: "flex",
        flexShrink: 0,
        fontSize: "".concat($9e17e519f3ca7187$var$fontSize, "px"),
        fontWeight: 600,
        lineHeight: $9e17e519f3ca7187$var$gridSize * 2 / $9e17e519f3ca7187$var$fontSize,
        margin: "".concat($9e17e519f3ca7187$var$gridSize * 4, "px 0 ").concat($9e17e519f3ca7187$var$gridSize, "px"),
        padding: "0 ".concat($9e17e519f3ca7187$var$gridSize * 1.5, "px"),
        textTransform: "uppercase"
    },
    textWrapper: {
        flexGrow: 1,
        overflowX: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        width: "100%"
    },
    afterWrapper: {
        lineHeight: 1,
        marginLeft: "".concat($9e17e519f3ca7187$var$gridSize / 2, "px")
    }
};
var $9e17e519f3ca7187$export$2e2bcd8739ae039 = function(_ref) {
    var product = _ref.product;
    return function() {
        return {
            container: $9e17e519f3ca7187$var$_objectSpread($9e17e519f3ca7187$var$_objectSpread({}, $9e17e519f3ca7187$var$baseStyles), {}, {
                headingBase: $9e17e519f3ca7187$var$_objectSpread($9e17e519f3ca7187$var$_objectSpread({}, $9e17e519f3ca7187$var$baseStyles.headingBase), {}, {
                    color: (0, $jp7ng.N200)
                })
            }),
            product: $9e17e519f3ca7187$var$_objectSpread($9e17e519f3ca7187$var$_objectSpread({}, $9e17e519f3ca7187$var$baseStyles), {}, {
                headingBase: $9e17e519f3ca7187$var$_objectSpread($9e17e519f3ca7187$var$_objectSpread({}, $9e17e519f3ca7187$var$baseStyles.headingBase), {}, {
                    color: product.text.subtle
                })
            })
        };
    };
};

});

parcelRegister("90eOl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68df9a5284aba6cb$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $jp7ng = parcelRequire("jp7ng");

var $aP6k3 = parcelRequire("aP6k3");
function $68df9a5284aba6cb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $68df9a5284aba6cb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $68df9a5284aba6cb$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $68df9a5284aba6cb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $68df9a5284aba6cb$var$targetEdgeAndIE11 = function targetEdgeAndIE11(styles) {
    // From https://browserstrangeness.github.io/css_hacks.html
    return {
        "@media screen and (-ms-high-contrast: none)": styles,
        "@supports (-ms-ime-align:auto)": styles
    };
};
var $68df9a5284aba6cb$var$targetFirefox = function targetFirefox(styles) {
    // From https://stackoverflow.com/a/953491
    return {
        "@-moz-document url-prefix()": styles
    };
};
var $68df9a5284aba6cb$var$gridSize = (0, $aP6k3.gridSize)();
/**
 * Component tree structure:
 * - itemBase
 *   - beforeWrapper
 *   - contentWrapper
 *     - textWrapper
 *     - subTextWrapper
 *   - afterWrapper
 */ // These are the styles which are consistent regardless of theme or spacing
var $68df9a5284aba6cb$var$baseStyles = {
    itemBase: {
        alignItems: "center",
        border: "none",
        borderRadius: "3px",
        boxSizing: "border-box",
        color: "inherit",
        cursor: "pointer",
        display: "flex",
        flexShrink: 0,
        fontSize: "inherit",
        height: $68df9a5284aba6cb$var$gridSize * 5,
        outline: "none",
        textAlign: "left",
        textDecoration: "none",
        width: "100%",
        "&:focus": {
            boxShadow: "0 0 0 2px ".concat($jp7ng.B100, " inset")
        }
    },
    beforeWrapper: {
        alignItems: "center",
        display: "flex",
        flexShrink: 0
    },
    contentWrapper: $68df9a5284aba6cb$var$_objectSpread({
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        overflowX: "hidden"
    }, $68df9a5284aba6cb$var$targetEdgeAndIE11({
        fontFamily: (0, $aP6k3.fontFamily)()
    })),
    textWrapper: $68df9a5284aba6cb$var$_objectSpread($68df9a5284aba6cb$var$_objectSpread($68df9a5284aba6cb$var$_objectSpread({
        flex: "1 1 auto",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, $68df9a5284aba6cb$var$targetEdgeAndIE11({
        lineHeight: 18 / (0, $aP6k3.fontSize)()
    })), $68df9a5284aba6cb$var$targetFirefox({
        lineHeight: 18 / (0, $aP6k3.fontSize)()
    })), {}, {
        lineHeight: 16 / (0, $aP6k3.fontSize)()
    }),
    subTextWrapper: $68df9a5284aba6cb$var$_objectSpread({
        flex: "1 1 auto",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, $68df9a5284aba6cb$var$targetEdgeAndIE11({
        marginTop: "-2px"
    })),
    afterWrapper: {
        alignItems: "center",
        display: "flex",
        flexShrink: 0
    }
}; // These are styles which switch on the spacing prop
var $68df9a5284aba6cb$var$layoutStyles = {
    compact: {
        itemBase: {
            paddingRight: $68df9a5284aba6cb$var$gridSize,
            paddingLeft: $68df9a5284aba6cb$var$gridSize
        },
        beforeWrapper: {
            marginRight: $68df9a5284aba6cb$var$gridSize
        },
        subTextWrapper: {
            fontSize: "10px",
            lineHeight: 1.2
        },
        afterWrapper: {
            marginLeft: $68df9a5284aba6cb$var$gridSize
        }
    },
    default: {
        itemBase: {
            paddingLeft: $68df9a5284aba6cb$var$gridSize * 1.5,
            paddingRight: $68df9a5284aba6cb$var$gridSize * 1.5
        },
        beforeWrapper: {
            marginRight: $68df9a5284aba6cb$var$gridSize * 2
        },
        subTextWrapper: $68df9a5284aba6cb$var$_objectSpread($68df9a5284aba6cb$var$_objectSpread({
            fontSize: "12px"
        }, $68df9a5284aba6cb$var$targetEdgeAndIE11({
            lineHeight: 16 / 12,
            marginTop: "-2px"
        })), {}, {
            lineHeight: 14 / 12
        }),
        afterWrapper: {
            marginLeft: $68df9a5284aba6cb$var$gridSize * 2
        }
    }
};
var $68df9a5284aba6cb$var$getItemBackgroundColor = function getItemBackgroundColor(background, _ref) {
    var isActive = _ref.isActive, isSelected = _ref.isSelected, isHover = _ref.isHover, isDragging = _ref.isDragging;
    if (isDragging) return background.hint;
    if (isActive) return background.interact;
    if (isSelected) return background.static;
    if (isHover) return background.hint;
    return background.default;
}; // Light theme
var $68df9a5284aba6cb$export$2e2bcd8739ae039 = function(_ref2) {
    var product = _ref2.product;
    return function(_ref3) {
        var isActive = _ref3.isActive, isDragging = _ref3.isDragging, isHover = _ref3.isHover, isSelected = _ref3.isSelected, spacing = _ref3.spacing;
        var containerTextColor = isActive || isSelected ? $jp7ng.B400 : $jp7ng.N500;
        var containerBackgroundColor = $68df9a5284aba6cb$var$getItemBackgroundColor({
            default: $jp7ng.N20,
            hint: $jp7ng.N30,
            interact: $jp7ng.B50,
            static: $jp7ng.N30
        }, {
            isActive: isActive,
            isHover: isHover,
            isSelected: isSelected,
            isDragging: isDragging
        });
        var productBackgroundColor = $68df9a5284aba6cb$var$getItemBackgroundColor(product.background, {
            isActive: isActive,
            isDragging: isDragging,
            isHover: isHover,
            isSelected: isSelected
        });
        return {
            container: {
                itemBase: $68df9a5284aba6cb$var$_objectSpread($68df9a5284aba6cb$var$_objectSpread($68df9a5284aba6cb$var$_objectSpread({}, $68df9a5284aba6cb$var$baseStyles.itemBase), $68df9a5284aba6cb$var$layoutStyles[spacing].itemBase), {}, {
                    backgroundColor: containerBackgroundColor,
                    fill: containerBackgroundColor
                }),
                beforeWrapper: $68df9a5284aba6cb$var$_objectSpread($68df9a5284aba6cb$var$_objectSpread($68df9a5284aba6cb$var$_objectSpread({}, $68df9a5284aba6cb$var$baseStyles.beforeWrapper), $68df9a5284aba6cb$var$layoutStyles[spacing].beforeWrapper), {}, {
                    color: containerTextColor
                }),
                contentWrapper: $68df9a5284aba6cb$var$baseStyles.contentWrapper,
                textWrapper: $68df9a5284aba6cb$var$_objectSpread($68df9a5284aba6cb$var$_objectSpread({}, $68df9a5284aba6cb$var$baseStyles.textWrapper), {}, {
                    color: containerTextColor
                }),
                subTextWrapper: $68df9a5284aba6cb$var$_objectSpread($68df9a5284aba6cb$var$_objectSpread($68df9a5284aba6cb$var$_objectSpread({}, $68df9a5284aba6cb$var$baseStyles.subTextWrapper), $68df9a5284aba6cb$var$layoutStyles[spacing].subTextWrapper), {}, {
                    color: $jp7ng.N200
                }),
                afterWrapper: $68df9a5284aba6cb$var$_objectSpread($68df9a5284aba6cb$var$_objectSpread($68df9a5284aba6cb$var$_objectSpread({}, $68df9a5284aba6cb$var$baseStyles.afterWrapper), $68df9a5284aba6cb$var$layoutStyles[spacing].afterWrapper), {}, {
                    color: $jp7ng.N500
                })
            },
            product: {
                itemBase: $68df9a5284aba6cb$var$_objectSpread($68df9a5284aba6cb$var$_objectSpread($68df9a5284aba6cb$var$_objectSpread({}, $68df9a5284aba6cb$var$baseStyles.itemBase), $68df9a5284aba6cb$var$layoutStyles[spacing].itemBase), {}, {
                    backgroundColor: productBackgroundColor,
                    fill: productBackgroundColor
                }),
                beforeWrapper: $68df9a5284aba6cb$var$_objectSpread($68df9a5284aba6cb$var$_objectSpread($68df9a5284aba6cb$var$_objectSpread({}, $68df9a5284aba6cb$var$baseStyles.beforeWrapper), $68df9a5284aba6cb$var$layoutStyles[spacing].beforeWrapper), {}, {
                    color: product.text.default
                }),
                contentWrapper: $68df9a5284aba6cb$var$baseStyles.contentWrapper,
                textWrapper: $68df9a5284aba6cb$var$_objectSpread($68df9a5284aba6cb$var$_objectSpread({}, $68df9a5284aba6cb$var$baseStyles.textWrapper), {}, {
                    color: product.text.default
                }),
                subTextWrapper: $68df9a5284aba6cb$var$_objectSpread($68df9a5284aba6cb$var$_objectSpread($68df9a5284aba6cb$var$_objectSpread({}, $68df9a5284aba6cb$var$baseStyles.subTextWrapper), $68df9a5284aba6cb$var$layoutStyles[spacing].subTextWrapper), {}, {
                    color: product.text.subtle
                }),
                afterWrapper: $68df9a5284aba6cb$var$_objectSpread($68df9a5284aba6cb$var$_objectSpread($68df9a5284aba6cb$var$_objectSpread({}, $68df9a5284aba6cb$var$baseStyles.afterWrapper), $68df9a5284aba6cb$var$layoutStyles[spacing].afterWrapper), {}, {
                    color: product.text.default
                })
            }
        };
    };
};

});

parcelRegister("3hhFC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2630aa97e4af9ec8$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $jp7ng = parcelRequire("jp7ng");

var $aP6k3 = parcelRequire("aP6k3");
function $2630aa97e4af9ec8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2630aa97e4af9ec8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $2630aa97e4af9ec8$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $2630aa97e4af9ec8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $2630aa97e4af9ec8$var$gridSize = (0, $aP6k3.gridSize)();
var $2630aa97e4af9ec8$var$scrollHintHeight = 2;
var $2630aa97e4af9ec8$var$scrollHintSpacing = $2630aa97e4af9ec8$var$gridSize * 2;
var $2630aa97e4af9ec8$var$isGecko = typeof window !== "undefined" && window.navigator.userAgent.indexOf("Gecko") >= 0;
var $2630aa97e4af9ec8$var$isWebkit = typeof window !== "undefined" && window.navigator.userAgent.indexOf("AppleWebKit") >= 0;
var $2630aa97e4af9ec8$var$scrollBarSize = $2630aa97e4af9ec8$var$isGecko || $2630aa97e4af9ec8$var$isWebkit ? 0 : 30;
var $2630aa97e4af9ec8$var$getBaseStyles = function getBaseStyles(_ref) {
    var alwaysShowScrollHint = _ref.alwaysShowScrollHint;
    return {
        wrapper: {
            height: "100%",
            overflow: "hidden",
            position: "relative",
            width: "100%",
            "&::before": {
                borderRadius: 1,
                content: "''",
                display: "block",
                flex: 0,
                height: "".concat($2630aa97e4af9ec8$var$scrollHintHeight, "px"),
                left: "".concat($2630aa97e4af9ec8$var$scrollHintSpacing, "px"),
                position: "absolute",
                right: "".concat($2630aa97e4af9ec8$var$scrollHintSpacing + $2630aa97e4af9ec8$var$scrollBarSize, "px"),
                top: 0,
                zIndex: 1
            },
            "&::after": {
                borderRadius: 1,
                content: "''",
                display: "block",
                flex: 0,
                height: "".concat($2630aa97e4af9ec8$var$scrollHintHeight, "px"),
                left: "".concat($2630aa97e4af9ec8$var$scrollHintSpacing, "px"),
                position: "absolute",
                right: "".concat($2630aa97e4af9ec8$var$scrollHintSpacing + $2630aa97e4af9ec8$var$scrollBarSize, "px"),
                bottom: 0,
                zIndex: 1
            }
        },
        inner: {
            display: "flex",
            flexDirection: "column",
            flexBasis: "100%",
            height: "100%",
            justifyContent: "flex-start",
            overflowY: "auto",
            position: "relative",
            "&::before": {
                borderRadius: 1,
                content: "''",
                display: alwaysShowScrollHint ? "none" : "block",
                flexShrink: 0,
                height: "".concat($2630aa97e4af9ec8$var$scrollHintHeight, "px"),
                marginLeft: "".concat($2630aa97e4af9ec8$var$scrollHintSpacing, "px"),
                position: "relative",
                zIndex: 2
            },
            "&::after": {
                borderRadius: 1,
                content: "''",
                display: "block",
                flexShrink: 0,
                height: "".concat($2630aa97e4af9ec8$var$scrollHintHeight, "px"),
                marginLeft: "".concat($2630aa97e4af9ec8$var$scrollHintSpacing, "px"),
                marginTop: "auto",
                position: "relative",
                zIndex: 2
            }
        },
        // These styles are passed to the children function for the consumer to
        // apply
        children: {
            boxSizing: "border-box",
            paddingLeft: "".concat($2630aa97e4af9ec8$var$gridSize * 2, "px"),
            paddingRight: "".concat($2630aa97e4af9ec8$var$gridSize * 2, "px")
        }
    };
};
var $2630aa97e4af9ec8$export$2e2bcd8739ae039 = function(_ref2) {
    var product = _ref2.product;
    return function(props) {
        var baseStyles = $2630aa97e4af9ec8$var$getBaseStyles(props);
        return {
            container: $2630aa97e4af9ec8$var$_objectSpread($2630aa97e4af9ec8$var$_objectSpread({}, baseStyles), {}, {
                wrapper: $2630aa97e4af9ec8$var$_objectSpread($2630aa97e4af9ec8$var$_objectSpread({}, baseStyles.wrapper), {}, {
                    "&::before": $2630aa97e4af9ec8$var$_objectSpread($2630aa97e4af9ec8$var$_objectSpread({}, baseStyles.wrapper["&::before"]), {}, {
                        backgroundColor: (0, $jp7ng.N30A)
                    }),
                    "&::after": $2630aa97e4af9ec8$var$_objectSpread($2630aa97e4af9ec8$var$_objectSpread({}, baseStyles.wrapper["&::after"]), {}, {
                        backgroundColor: (0, $jp7ng.N30A)
                    })
                }),
                inner: $2630aa97e4af9ec8$var$_objectSpread($2630aa97e4af9ec8$var$_objectSpread({}, baseStyles.inner), {}, {
                    "&::before": $2630aa97e4af9ec8$var$_objectSpread($2630aa97e4af9ec8$var$_objectSpread({}, baseStyles.inner["&::before"]), {}, {
                        backgroundColor: (0, $jp7ng.N20)
                    }),
                    "&::after": $2630aa97e4af9ec8$var$_objectSpread($2630aa97e4af9ec8$var$_objectSpread({}, baseStyles.inner["&::after"]), {}, {
                        backgroundColor: (0, $jp7ng.N20)
                    })
                })
            }),
            product: $2630aa97e4af9ec8$var$_objectSpread($2630aa97e4af9ec8$var$_objectSpread({}, baseStyles), {}, {
                wrapper: $2630aa97e4af9ec8$var$_objectSpread($2630aa97e4af9ec8$var$_objectSpread({}, baseStyles.wrapper), {}, {
                    "&::before": $2630aa97e4af9ec8$var$_objectSpread($2630aa97e4af9ec8$var$_objectSpread({}, baseStyles.wrapper["&::before"]), {}, {
                        backgroundColor: product.background.static
                    }),
                    "&::after": $2630aa97e4af9ec8$var$_objectSpread($2630aa97e4af9ec8$var$_objectSpread({}, baseStyles.wrapper["&::after"]), {}, {
                        backgroundColor: product.background.static
                    })
                }),
                inner: $2630aa97e4af9ec8$var$_objectSpread($2630aa97e4af9ec8$var$_objectSpread({}, baseStyles.inner), {}, {
                    "&::before": $2630aa97e4af9ec8$var$_objectSpread($2630aa97e4af9ec8$var$_objectSpread({}, baseStyles.inner["&::before"]), {}, {
                        backgroundColor: product.background.default
                    }),
                    "&::after": $2630aa97e4af9ec8$var$_objectSpread($2630aa97e4af9ec8$var$_objectSpread({}, baseStyles.inner["&::after"]), {}, {
                        backgroundColor: product.background.default
                    })
                })
            })
        };
    };
};

});

parcelRegister("89wl0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ef83f9d509e9c9d$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $jp7ng = parcelRequire("jp7ng");

var $aP6k3 = parcelRequire("aP6k3");
function $5ef83f9d509e9c9d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5ef83f9d509e9c9d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $5ef83f9d509e9c9d$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $5ef83f9d509e9c9d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $5ef83f9d509e9c9d$var$dividerLineHeight = 2;
var $5ef83f9d509e9c9d$var$dividerTotalHeight = (0, $aP6k3.gridSize)() * 5;
var $5ef83f9d509e9c9d$var$baseStyles = {
    borderRadius: "1px",
    flexShrink: 0,
    height: "".concat($5ef83f9d509e9c9d$var$dividerLineHeight, "px"),
    margin: "".concat(($5ef83f9d509e9c9d$var$dividerTotalHeight - $5ef83f9d509e9c9d$var$dividerLineHeight) / 2, "px 0")
};
var $5ef83f9d509e9c9d$export$2e2bcd8739ae039 = function(_ref) {
    var product = _ref.product;
    return function() {
        return {
            container: $5ef83f9d509e9c9d$var$_objectSpread($5ef83f9d509e9c9d$var$_objectSpread({}, $5ef83f9d509e9c9d$var$baseStyles), {}, {
                backgroundColor: (0, $jp7ng.N30A)
            }),
            product: $5ef83f9d509e9c9d$var$_objectSpread($5ef83f9d509e9c9d$var$_objectSpread({}, $5ef83f9d509e9c9d$var$baseStyles), {}, {
                backgroundColor: product.background.static
            })
        };
    };
};

});

parcelRegister("1tKTJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $113ce0d61dc12815$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $jp7ng = parcelRequire("jp7ng");

var $aP6k3 = parcelRequire("aP6k3");
function $113ce0d61dc12815$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $113ce0d61dc12815$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $113ce0d61dc12815$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $113ce0d61dc12815$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $113ce0d61dc12815$var$gridSize = (0, $aP6k3.gridSize)(); // These are the styles which are consistent regardless of theme
var $113ce0d61dc12815$var$baseStyles = {
    wrapper: {
        alignItems: "center",
        display: "flex",
        height: "".concat($113ce0d61dc12815$var$gridSize * 5, "px"),
        paddingLeft: "".concat($113ce0d61dc12815$var$gridSize * 1.5, "px"),
        paddingRight: "".concat($113ce0d61dc12815$var$gridSize * 1.5, "px"),
        opacity: 0.5
    },
    before: {
        backgroundColor: "red",
        borderRadius: "50%",
        flexShrink: 0,
        height: "".concat($113ce0d61dc12815$var$gridSize * 3, "px"),
        marginRight: "".concat($113ce0d61dc12815$var$gridSize * 2, "px"),
        width: "".concat($113ce0d61dc12815$var$gridSize * 3, "px")
    },
    content: {
        borderRadius: "".concat($113ce0d61dc12815$var$gridSize / 2, "px"),
        flexGrow: 1,
        height: "".concat($113ce0d61dc12815$var$gridSize * 2.5, "px")
    }
}; // Light theme
var $113ce0d61dc12815$export$2e2bcd8739ae039 = function(_ref) {
    var product = _ref.product;
    return function() {
        return {
            container: {
                wrapper: $113ce0d61dc12815$var$baseStyles.wrapper,
                before: $113ce0d61dc12815$var$_objectSpread($113ce0d61dc12815$var$_objectSpread({}, $113ce0d61dc12815$var$baseStyles.before), {}, {
                    backgroundColor: (0, $jp7ng.N40)
                }),
                content: $113ce0d61dc12815$var$_objectSpread($113ce0d61dc12815$var$_objectSpread({}, $113ce0d61dc12815$var$baseStyles.content), {}, {
                    backgroundColor: (0, $jp7ng.N40)
                })
            },
            product: {
                wrapper: $113ce0d61dc12815$var$baseStyles.wrapper,
                before: $113ce0d61dc12815$var$_objectSpread($113ce0d61dc12815$var$_objectSpread({}, $113ce0d61dc12815$var$baseStyles.before), {}, {
                    backgroundColor: product.background.static
                }),
                content: $113ce0d61dc12815$var$_objectSpread($113ce0d61dc12815$var$_objectSpread({}, $113ce0d61dc12815$var$baseStyles.content), {}, {
                    backgroundColor: product.background.static
                })
            }
        };
    };
};

});






parcelRegister("lIM1e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd02f4980e58fa3e$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $fNVD2 = parcelRequire("fNVD2");

var $dEKDm = parcelRequire("dEKDm");

var $2Ojfd = parcelRequire("2Ojfd");

var $9yV1o = parcelRequire("9yV1o");

var $7XXi0 = parcelRequire("7XXi0");

var $45CBz = parcelRequire("45CBz");
var $fd02f4980e58fa3e$var$_excluded = [
    "after",
    "goTo",
    "navigationViewController"
];
function $fd02f4980e58fa3e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fd02f4980e58fa3e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $fd02f4980e58fa3e$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $fd02f4980e58fa3e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $fd02f4980e58fa3e$var$After = function After(_ref) {
    var afterGoTo = _ref.afterGoTo, spinnerDelay = _ref.spinnerDelay, incomingView = _ref.incomingView, isActive = _ref.isActive, isHover = _ref.isHover, isFocused = _ref.isFocused;
    if (incomingView && incomingView.id === afterGoTo) return (0, $45CBz.jsx)((0, $dEKDm.default), {
        delay: spinnerDelay,
        invertColor: true,
        size: "small"
    });
    if (isActive || isHover || isFocused) return (0, $45CBz.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fNVD2))), {
        primaryColor: "currentColor",
        secondaryColor: "inherit"
    });
    return null;
};
var $fd02f4980e58fa3e$export$84853517e4ebae5e = function GoToItem(gotoItemProps) {
    var scrollProviderRef = (0, $9nHZC.useContext)((0, $9yV1o.ScrollProviderRef));
    var spinnerDelay = gotoItemProps.spinnerDelay || 200;
    var handleClick = function handleClick(e) {
        var goTo = gotoItemProps.goTo, navigationViewController = gotoItemProps.navigationViewController;
        e.preventDefault();
        if (typeof goTo !== "string") return;
         // Hijack focus only if the event is
        // from a keyboard.
        if (e.clientX === 0 && e.clientY === 0 && scrollProviderRef.current) scrollProviderRef.current.focus();
        navigationViewController.setView(goTo);
    };
    var afterProp = gotoItemProps.after, goTo = gotoItemProps.goTo, navigationViewController = gotoItemProps.navigationViewController, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(gotoItemProps, $fd02f4980e58fa3e$var$_excluded);
    var after = typeof afterProp === "undefined" ? $fd02f4980e58fa3e$var$After : afterProp;
    var propsForAfterComp = {
        afterGoTo: goTo || null,
        spinnerDelay: spinnerDelay,
        incomingView: navigationViewController.state.incomingView
    };
    var props = $fd02f4980e58fa3e$var$_objectSpread($fd02f4980e58fa3e$var$_objectSpread({}, rest), {}, {
        after: after
    });
    return (0, $45CBz.jsx)((0, $7XXi0.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        onClick: handleClick
    }, props, propsForAfterComp));
};
var $fd02f4980e58fa3e$export$2e2bcd8739ae039 = (0, $2Ojfd.default)($fd02f4980e58fa3e$export$84853517e4ebae5e);

});
parcelRegister("fNVD2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b818227a4a5d034a$var$_react = $b818227a4a5d034a$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $kupLT = parcelRequire("kupLT");
function $b818227a4a5d034a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b818227a4a5d034a$var$ArrowRightCircleIcon = (props)=>/*#__PURE__*/ $b818227a4a5d034a$var$_react.default.createElement($kupLT.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" fill-rule="nonzero" cx="12" cy="12" r="10"/><path d="M12.314 8.294a1.01 1.01 0 000 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005 0 .555.448 1.005 1.001 1.005h5.585l-1.271 1.279a1.01 1.01 0 000 1.422 1.001 1.001 0 001.415 0l2.978-2.995a1.01 1.01 0 000-1.422l-2.978-2.995a.998.998 0 00-1.415 0z" fill="inherit"/></g></svg>`
    }, props));
$b818227a4a5d034a$var$ArrowRightCircleIcon.displayName = "ArrowRightCircleIcon";
var $b818227a4a5d034a$var$_default = $b818227a4a5d034a$var$ArrowRightCircleIcon;
module.exports.default = $b818227a4a5d034a$var$_default;

});

parcelRegister("2Ojfd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20bf2dd0eb1cc021$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");
parcelRequire("9nHZC");

var $6yZqT = parcelRequire("6yZqT");

var $45CBz = parcelRequire("45CBz");
var $20bf2dd0eb1cc021$export$2e2bcd8739ae039 = function(WrappedComponent) {
    var WithNavigationViewController = function WithNavigationViewController(props) {
        return (0, $45CBz.jsx)((0, $6yZqT.default), null, function(navigationViewController) {
            return (0, $45CBz.jsx)(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                navigationViewController: navigationViewController
            }, props));
        });
    };
    WithNavigationViewController.displayName = "WithNavigationViewController(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
    return WithNavigationViewController;
};

});
parcelRegister("6yZqT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c7592552b0c50d1$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");
parcelRequire("9nHZC");

var $i5sFT = parcelRequire("i5sFT");

var $liApt = parcelRequire("liApt");

var $45CBz = parcelRequire("45CBz");
var $4c7592552b0c50d1$var$to = [
    (0, $liApt.default)
];
var $4c7592552b0c50d1$var$ViewControllerSubscriber = function ViewControllerSubscriber(props) {
    return (0, $45CBz.jsx)((0, $i5sFT.Subscribe), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        to: $4c7592552b0c50d1$var$to
    }, props));
};
var $4c7592552b0c50d1$export$2e2bcd8739ae039 = $4c7592552b0c50d1$var$ViewControllerSubscriber;

});
parcelRegister("i5sFT", function(module, exports) {

$parcel$export(module.exports, "Container", function () { return $0365eb17fcf3d6ac$export$42a852a2b6b56249; });
$parcel$export(module.exports, "Subscribe", function () { return $0365eb17fcf3d6ac$export$b5b6bb8bb5273115; });
$parcel$export(module.exports, "Provider", function () { return $0365eb17fcf3d6ac$export$2881499e37b75b9a; });

var $9nHZC = parcelRequire("9nHZC");

var $01a2M = parcelRequire("01a2M");

var $blCBi = parcelRequire("blCBi");
var $0365eb17fcf3d6ac$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $0365eb17fcf3d6ac$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $0365eb17fcf3d6ac$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $0365eb17fcf3d6ac$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $0365eb17fcf3d6ac$var$StateContext = (0, (/*@__PURE__*/$parcel$interopDefault($01a2M)))(null);
var $0365eb17fcf3d6ac$export$42a852a2b6b56249 = function() {
    function Container() {
        $0365eb17fcf3d6ac$var$_classCallCheck(this, Container);
        this._listeners = [];
    }
    Container.prototype.setState = function setState(state) {
        this.state = Object.assign({}, this.state, state);
        this._listeners.forEach(function(fn) {
            return fn();
        });
    };
    Container.prototype.subscribe = function subscribe(fn) {
        this._listeners.push(fn);
    };
    Container.prototype.unsubscribe = function unsubscribe(fn) {
        this._listeners = this._listeners.filter(function(f) {
            return f !== fn;
        });
    };
    return Container;
}();
var $0365eb17fcf3d6ac$var$DUMMY_STATE = {};
var $0365eb17fcf3d6ac$export$b5b6bb8bb5273115 = function(_React$Component) {
    $0365eb17fcf3d6ac$var$_inherits(Subscribe, _React$Component);
    function Subscribe() {
        var _temp, _this, _ret;
        $0365eb17fcf3d6ac$var$_classCallCheck(this, Subscribe);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $0365eb17fcf3d6ac$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {}, _this.instances = [], _this.onUpdate = function() {
            _this.setState($0365eb17fcf3d6ac$var$DUMMY_STATE);
        }, _temp), $0365eb17fcf3d6ac$var$_possibleConstructorReturn(_this, _ret);
    }
    Subscribe.prototype.componentWillUnmount = function componentWillUnmount() {
        this._unsubscribe();
    };
    Subscribe.prototype._unsubscribe = function _unsubscribe() {
        var _this2 = this;
        this.instances.forEach(function(container) {
            container.unsubscribe(_this2.onUpdate);
        });
    };
    Subscribe.prototype._createInstances = function _createInstances(map, containers) {
        var _this3 = this;
        this._unsubscribe();
        if (map === null) throw new Error("You must wrap your <Subscribe> components with a <Provider>");
        var safeMap = map;
        var instances = containers.map(function(ContainerItem) {
            var instance = void 0;
            if ((typeof ContainerItem === "undefined" ? "undefined" : $0365eb17fcf3d6ac$var$_typeof(ContainerItem)) === "object" && ContainerItem instanceof $0365eb17fcf3d6ac$export$42a852a2b6b56249) instance = ContainerItem;
            else {
                instance = safeMap.get(ContainerItem);
                if (!instance) {
                    instance = new ContainerItem();
                    safeMap.set(ContainerItem, instance);
                }
            }
            instance.unsubscribe(_this3.onUpdate);
            instance.subscribe(_this3.onUpdate);
            return instance;
        });
        this.instances = instances;
        return instances;
    };
    Subscribe.prototype.render = function render() {
        var _this4 = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($0365eb17fcf3d6ac$var$StateContext.Consumer, null, function(map) {
            return _this4.props.children.apply(null, _this4._createInstances(map, _this4.props.to));
        });
    };
    return Subscribe;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component);
$0365eb17fcf3d6ac$export$b5b6bb8bb5273115.propTypes = {
    to: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).array.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func.isRequired
};
function $0365eb17fcf3d6ac$export$2881499e37b75b9a(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($0365eb17fcf3d6ac$var$StateContext.Consumer, null, function(parentMap) {
        var childMap = new Map(parentMap);
        if (props.inject) props.inject.forEach(function(instance) {
            childMap.set(instance.constructor, instance);
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($0365eb17fcf3d6ac$var$StateContext.Provider, {
            value: childMap
        }, props.children);
    });
}

});
parcelRegister("01a2M", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $9nHZC = parcelRequire("9nHZC");
var $0037e29888a453cf$var$_react2 = $0037e29888a453cf$var$_interopRequireDefault($9nHZC);

var $blCBi = parcelRequire("blCBi");
var $0037e29888a453cf$var$_propTypes2 = $0037e29888a453cf$var$_interopRequireDefault($blCBi);
function $0037e29888a453cf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0037e29888a453cf$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0037e29888a453cf$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $0037e29888a453cf$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $0037e29888a453cf$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value);
            });
        }
    };
}
function $0037e29888a453cf$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
var $0037e29888a453cf$var$uniqueId = 0;
function $0037e29888a453cf$var$createReactContext(defaultValue) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $0037e29888a453cf$var$uniqueId++ + "__";
    var Provider = function(_Component) {
        $0037e29888a453cf$var$_inherits(Provider, _Component);
        function Provider() {
            var _temp, _this, _ret;
            $0037e29888a453cf$var$_classCallCheck(this, Provider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $0037e29888a453cf$var$_possibleConstructorReturn(this, _Component.call.apply(_Component, [
                this
            ].concat(args))), _this), _this.emitter = $0037e29888a453cf$var$createEventEmitter(_this.props.value), _temp), $0037e29888a453cf$var$_possibleConstructorReturn(_this, _ret);
        }
        Provider.prototype.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) this.emitter.set(nextProps.value);
        };
        Provider.prototype.render = function render() {
            return this.props.children;
        };
        return Provider;
    }($9nHZC.Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = $0037e29888a453cf$var$_propTypes2.default.object.isRequired, _Provider$childContex);
    var Consumer = function(_Component2) {
        $0037e29888a453cf$var$_inherits(Consumer, _Component2);
        function Consumer() {
            var _temp2, _this2, _ret2;
            $0037e29888a453cf$var$_classCallCheck(this, Consumer);
            for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _ret2 = (_temp2 = (_this2 = $0037e29888a453cf$var$_possibleConstructorReturn(this, _Component2.call.apply(_Component2, [
                this
            ].concat(args))), _this2), _this2.state = {
                value: _this2.getValue()
            }, _this2.onUpdate = function() {
                _this2.setState({
                    value: _this2.getValue()
                });
            }, _temp2), $0037e29888a453cf$var$_possibleConstructorReturn(_this2, _ret2);
        }
        Consumer.prototype.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
        };
        Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        Consumer.prototype.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        Consumer.prototype.render = function render() {
            return $0037e29888a453cf$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }($9nHZC.Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = $0037e29888a453cf$var$_propTypes2.default.object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
module.exports.default = $0037e29888a453cf$var$createReactContext;
module.exports = module.exports["default"];

});


parcelRegister("liApt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f81785a97d9e7664$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $eVDe4 = parcelRequire("eVDe4");

var $uqRmf = parcelRequire("uqRmf");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $i5sFT = parcelRequire("i5sFT");
function $f81785a97d9e7664$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f81785a97d9e7664$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f81785a97d9e7664$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f81785a97d9e7664$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f81785a97d9e7664$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f81785a97d9e7664$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $f81785a97d9e7664$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $f81785a97d9e7664$var$defaultProps = {
    isDebugEnabled: false
};
var $f81785a97d9e7664$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Container) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(ViewController, _Container);
    var _super = $f81785a97d9e7664$var$_createSuper(ViewController);
    function ViewController() {
        var _this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $f81785a97d9e7664$var$defaultProps, _isDebugEnabled = _ref.isDebugEnabled;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ViewController);
        _this = _super.call(this);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "state", {
            activeView: null,
            incomingView: null
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "reducers", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "views", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "isDebugEnabled", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_updateViewController", function(view, initialData) {
            var id = view.id, type = view.type, getAnalyticsAttributes = view.getAnalyticsAttributes;
            var reducers = _this.reducers[id] || [];
            var data = reducers.reduce(function(d, reducer) {
                return reducer(d);
            }, initialData);
            var analyticsAttributes = getAnalyticsAttributes ? getAnalyticsAttributes(data) : undefined;
            _this.setState({
                activeView: {
                    id: id,
                    type: type,
                    data: data,
                    analyticsAttributes: analyticsAttributes
                },
                incomingView: null
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "addReducer", function(viewId, reducer) {
            var reducersForView = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.reducers[viewId] || []), [
                reducer
            ]);
            _this.reducers = $f81785a97d9e7664$var$_objectSpread($f81785a97d9e7664$var$_objectSpread({}, _this.reducers), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, viewId, reducersForView)); // If we're adding a reducer to the active view we'll want to force an
            // update so that the reducer gets applied.
            _this.updateActiveView(viewId);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "removeReducer", function(viewId, reducer) {
            var reducersForView = _this.reducers[viewId];
            if (!reducersForView) return;
            var newReducers = reducersForView.filter(function(r) {
                return r !== reducer;
            });
            _this.reducers = $f81785a97d9e7664$var$_objectSpread($f81785a97d9e7664$var$_objectSpread({}, _this.reducers), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, viewId, newReducers)); // If we're removing a reducer from the active view we'll want to force an
            // update so that the data gets re-evaluated.
            _this.updateActiveView(viewId);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "addView", function(view) {
            var id = view.id;
            _this.views = $f81785a97d9e7664$var$_objectSpread($f81785a97d9e7664$var$_objectSpread({}, _this.views), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, id, view)); // We need to call setView again for the following cases:
            // 1. The added view matches the active view (if it returns a Promise we
            //    want to temporarily enter a loading state while it resolves).
            // 2. The added view matches the expected incoming view and we want to
            //    resolve it.
            var _this$state = _this.state, activeView = _this$state.activeView, incomingView = _this$state.incomingView;
            if (activeView && id === activeView.id || incomingView && id === incomingView.id) _this.setView(id);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "removeView", function(viewId) {
            delete _this.views[viewId];
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "setView", function(viewId) {
            var view = _this.views[viewId]; // The view has been added
            if (view) {
                var id = view.id, type = view.type, getItems = view.getItems;
                var returnedItems = getItems(); // This view returned a Promise
                if (returnedItems instanceof Promise) {
                    // Enter a temporary loading state
                    _this.setState({
                        incomingView: {
                            id: id,
                            type: type
                        }
                    }); // Wait for the Promise to resolve
                    returnedItems.then(function(data) {
                        _this._updateViewController(view, data);
                    });
                    return;
                } // The view returned data
                _this._updateViewController(view, returnedItems);
                return;
            } // The view has not been added yet. We enter an indefinite loading state
            // until the view is added or another view is set.
            _this.setState({
                incomingView: {
                    id: viewId,
                    type: null
                }
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "updateActiveView", function(maybeViewId) {
            var activeView = _this.state.activeView;
            if (!activeView) return;
            if (maybeViewId && maybeViewId === activeView.id) {
                _this.setView(maybeViewId);
                return;
            }
            if (!maybeViewId) _this.setView(activeView.id);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "setIsDebugEnabled", function(isDebugEnabled) {
            _this.isDebugEnabled = isDebugEnabled;
        });
        if (typeof _isDebugEnabled !== "undefined") _this.isDebugEnabled = _isDebugEnabled;
        return _this;
    }
    /**
   * Helper function for reducing a view's data and updating the state.
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ViewController);
}((0, $i5sFT.Container));

});



parcelRegister("9yV1o", function(module, exports) {

$parcel$export(module.exports, "ScrollProviderRef", function () { return $6f6385552f6a1b7a$export$cfad88e300969209; });
$parcel$export(module.exports, "ProductNavigation", function () { return $6f6385552f6a1b7a$export$587c9e8e0a1103c0; });
$parcel$export(module.exports, "ContainerNavigation", function () { return $6f6385552f6a1b7a$export$b545b2e0e8c3dcc8; });
$parcel$export(module.exports, "ContentNavigationWrapper", function () { return $6f6385552f6a1b7a$export$e59a5b674d10fc28; });
$parcel$export(module.exports, "ContainerNavigationMask", function () { return $6f6385552f6a1b7a$export$759440dc7bc521ed; });

var $hlgjl = parcelRequire("hlgjl");

var $kFnE9 = parcelRequire("kFnE9");

var $fPPqr = parcelRequire("fPPqr");

var $7KAwG = parcelRequire("7KAwG");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("45CBz");
var $7KAwG = parcelRequire("7KAwG");
var $45CBz = parcelRequire("45CBz");

var $jp7ng = parcelRequire("jp7ng");

var $5SBZk = parcelRequire("5SBZk");

var $6mrep = parcelRequire("6mrep");

var $3YYFd = parcelRequire("3YYFd");
var $1HkF5 = parcelRequire("1HkF5");
var $vjMcg = parcelRequire("vjMcg");
var $6f6385552f6a1b7a$var$_templateObject;
var $6f6385552f6a1b7a$var$_excluded = [
    "isVisible"
], $6f6385552f6a1b7a$var$_excluded2 = [
    "isVisible",
    "onClick"
], $6f6385552f6a1b7a$var$_excluded3 = [
    "innerRef",
    "disableInteraction"
], $6f6385552f6a1b7a$var$_excluded4 = [
    "disableInteraction"
];
function $6f6385552f6a1b7a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6f6385552f6a1b7a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6f6385552f6a1b7a$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6f6385552f6a1b7a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $6f6385552f6a1b7a$export$cfad88e300969209 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createContext();
var $6f6385552f6a1b7a$var$ScrollProvider = function ScrollProvider(_ref) {
    var isVisible = _ref.isVisible, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $6f6385552f6a1b7a$var$_excluded);
    var scrollProviderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createRef();
    return (0, $45CBz.jsx)($6f6385552f6a1b7a$export$cfad88e300969209.Provider, {
        value: scrollProviderRef
    }, (0, $45CBz.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        css: /*#__PURE__*/ (0, $7KAwG.default)({
            boxSizing: "border-box",
            display: isVisible ? "flex" : "none",
            flexDirection: "column",
            height: "100%",
            overflowX: "hidden",
            overflowY: "auto",
            width: "100%"
        }, ""),
        tabIndex: -1,
        role: "group",
        ref: scrollProviderRef
    }, props)));
};
/**
 * ProductNavigation
 */ var $6f6385552f6a1b7a$var$ProductNavigationPrimitiveBase = function ProductNavigationPrimitiveBase(_ref2) {
    var children = _ref2.children, isVisible = _ref2.isVisible, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? {
        mode: (0, $3YYFd.light),
        context: "product"
    } : _ref2$theme;
    return (0, $45CBz.jsx)("div", {
        css: /*#__PURE__*/ (0, $7KAwG.default)($6f6385552f6a1b7a$var$_objectSpread($6f6385552f6a1b7a$var$_objectSpread({}, theme.mode.contentNav().product), {}, {
            "&:not(:only-child)": {
                // Setting z-index ensures ScrollHints stay below the container nav
                // &:not(:only-child) sets it only when both container and product
                // nav are rendered.
                zIndex: -1
            }
        }), "")
    }, (0, $45CBz.jsx)($6f6385552f6a1b7a$var$ScrollProvider, {
        isVisible: isVisible
    }, children));
};
var $6f6385552f6a1b7a$var$ProductNavigationPrimitive = (0, $vjMcg.withContentTheme)($6f6385552f6a1b7a$var$ProductNavigationPrimitiveBase);
var $6f6385552f6a1b7a$export$84b5e5e47fc2826 = function ProductNavigationTheme(_ref3) {
    var children = _ref3.children;
    return (0, $45CBz.jsx)((0, $1HkF5.ThemeProvider), {
        theme: function theme(oldTheme) {
            return $6f6385552f6a1b7a$var$_objectSpread($6f6385552f6a1b7a$var$_objectSpread({
                mode: (0, $3YYFd.light)
            }, oldTheme), {}, {
                context: "product"
            });
        }
    }, (0, $45CBz.jsx)((0, $9nHZC.Fragment), null, children));
};
var $6f6385552f6a1b7a$export$587c9e8e0a1103c0 = function ProductNavigation(props) {
    return (0, $45CBz.jsx)($6f6385552f6a1b7a$export$84b5e5e47fc2826, null, (0, $45CBz.jsx)($6f6385552f6a1b7a$var$ProductNavigationPrimitive, props));
};
var $6f6385552f6a1b7a$var$slideIn = (0, $45CBz.keyframes)($6f6385552f6a1b7a$var$_templateObject || ($6f6385552f6a1b7a$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n  from { transform: translateX(100%); }\n  to { transform: translateX(0); }\n"
])));
/**
 * ContainerNavigation
 */ var $6f6385552f6a1b7a$var$ContainerNavigationPrimitiveBase = function ContainerNavigationPrimitiveBase(_ref4) {
    var children = _ref4.children, isEntering = _ref4.isEntering, isExiting = _ref4.isExiting, theme = _ref4.theme, isVisible = _ref4.isVisible;
    var animationName;
    if (isEntering) animationName = $6f6385552f6a1b7a$var$slideIn;
    var transform = isExiting ? "translateX(100%)" : null;
    return (0, $45CBz.jsx)("div", {
        css: /*#__PURE__*/ (0, $7KAwG.default)($6f6385552f6a1b7a$var$_objectSpread($6f6385552f6a1b7a$var$_objectSpread({}, theme.mode.contentNav().container), {}, {
            animationDuration: (0, $5SBZk.transitionDuration),
            animationFillMode: "forwards",
            animationTimingFunction: (0, $5SBZk.transitionTimingFunction),
            transitionProperty: "boxShadow, transform",
            transitionDuration: (0, $5SBZk.transitionDuration),
            transitionTimingFunction: (0, $5SBZk.transitionTimingFunction),
            transform: transform
        }), " animation-name:", animationName, ";")
    }, (0, $45CBz.jsx)($6f6385552f6a1b7a$var$ScrollProvider, {
        isVisible: isVisible
    }, children));
};
var $6f6385552f6a1b7a$var$ContainerNavigationPrimitive = (0, $vjMcg.withContentTheme)($6f6385552f6a1b7a$var$ContainerNavigationPrimitiveBase);
var $6f6385552f6a1b7a$export$c271b49c300b2547 = function ContainerNavigationTheme(_ref5) {
    var children = _ref5.children;
    return (0, $45CBz.jsx)((0, $1HkF5.ThemeProvider), {
        theme: {
            mode: (0, $3YYFd.light),
            context: "container"
        }
    }, (0, $45CBz.jsx)((0, $9nHZC.Fragment), null, children));
};
var $6f6385552f6a1b7a$export$b545b2e0e8c3dcc8 = function ContainerNavigation(props) {
    return (0, $45CBz.jsx)($6f6385552f6a1b7a$export$c271b49c300b2547, null, (0, $45CBz.jsx)($6f6385552f6a1b7a$var$ContainerNavigationPrimitive, props));
};
var $6f6385552f6a1b7a$export$5113313143ab69fb = function ContainerOverlay(_ref6) {
    var isVisible = _ref6.isVisible, onClick = _ref6.onClick, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref6, $6f6385552f6a1b7a$var$_excluded2);
    return (0, $45CBz.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        css: /*#__PURE__*/ (0, $7KAwG.default)({
            backgroundColor: (0, $jp7ng.N70A),
            cursor: isVisible ? "pointer" : "default",
            height: "100%",
            left: 0,
            opacity: isVisible ? 1 : 0,
            pointerEvents: isVisible ? "all" : "none",
            position: "absolute",
            top: 0,
            transitionDuration: (0, $5SBZk.transitionDuration),
            transitionProperty: "opacity",
            transitionTimingFunction: (0, $5SBZk.transitionTimingFunction),
            width: "100%",
            zIndex: 5
        }, ""),
        onClick: onClick,
        role: "presentation"
    }, props));
};
var $6f6385552f6a1b7a$export$e59a5b674d10fc28 = function ContentNavigationWrapper(_ref7) {
    var innerRef = _ref7.innerRef, disableInteraction = _ref7.disableInteraction, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref7, $6f6385552f6a1b7a$var$_excluded3);
    return (0, $45CBz.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        ref: innerRef,
        css: /*#__PURE__*/ (0, $7KAwG.default)($6f6385552f6a1b7a$var$_objectSpread({
            height: "100%",
            position: "relative"
        }, (0, $6mrep.applyDisabledProperties)(!!disableInteraction)), "")
    }, props));
};
var $6f6385552f6a1b7a$export$759440dc7bc521ed = function ContainerNavigationMask(_ref8) {
    var disableInteraction = _ref8.disableInteraction, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref8, $6f6385552f6a1b7a$var$_excluded4);
    return (0, $45CBz.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        css: /*#__PURE__*/ (0, $7KAwG.default)($6f6385552f6a1b7a$var$_objectSpread({
            display: "flex",
            flexDirection: "row",
            overflow: "hidden",
            height: "100%"
        }, (0, $6mrep.applyDisabledProperties)(!!disableInteraction)), "")
    }, props));
};

});
parcelRegister("6mrep", function(module, exports) {

$parcel$export(module.exports, "applyDisabledProperties", function () { return $4a19ebbfbcf511e8$export$c300f5e78020a6d5; });
function $4a19ebbfbcf511e8$export$c300f5e78020a6d5(disableInteraction) {
    return disableInteraction ? {
        pointerEvents: "none",
        userSelect: "none"
    } : null;
}

});





parcelRegister("eM8tv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac1c1f5442a5bd8e$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $aP6k3 = parcelRequire("aP6k3");

var $eDVAW = parcelRequire("eDVAW");

var $8OqBL = parcelRequire("8OqBL");

var $45CBz = parcelRequire("45CBz");
var $ac1c1f5442a5bd8e$var$_excluded = [
    "styles"
];
function $ac1c1f5442a5bd8e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ac1c1f5442a5bd8e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $ac1c1f5442a5bd8e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ac1c1f5442a5bd8e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ac1c1f5442a5bd8e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ac1c1f5442a5bd8e$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ac1c1f5442a5bd8e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $ac1c1f5442a5bd8e$var$gridSize = (0, $aP6k3.gridSize)();
var $ac1c1f5442a5bd8e$var$modifyStyles = function modifyStyles(defaultStyles) {
    return $ac1c1f5442a5bd8e$var$_objectSpread($ac1c1f5442a5bd8e$var$_objectSpread({}, defaultStyles), {}, {
        itemBase: $ac1c1f5442a5bd8e$var$_objectSpread($ac1c1f5442a5bd8e$var$_objectSpread({}, defaultStyles.itemBase), {}, {
            height: $ac1c1f5442a5bd8e$var$gridSize * 6,
            paddingBottom: 0,
            paddingLeft: $ac1c1f5442a5bd8e$var$gridSize / 2 - 2,
            // Offset by 2px to account for border of avatar
            paddingRight: $ac1c1f5442a5bd8e$var$gridSize / 2,
            paddingTop: 0
        }),
        beforeWrapper: $ac1c1f5442a5bd8e$var$_objectSpread($ac1c1f5442a5bd8e$var$_objectSpread({}, defaultStyles.beforeWrapper), {}, {
            marginRight: $ac1c1f5442a5bd8e$var$gridSize - 2 // Offset by 2px to account for border of avatar
        }),
        afterWrapper: $ac1c1f5442a5bd8e$var$_objectSpread($ac1c1f5442a5bd8e$var$_objectSpread({}, defaultStyles.afterWrapper), {}, {
            marginLeft: $ac1c1f5442a5bd8e$var$gridSize
        }),
        textWrapper: $ac1c1f5442a5bd8e$var$_objectSpread($ac1c1f5442a5bd8e$var$_objectSpread({}, defaultStyles.textWrapper), {}, {
            fontWeight: 600
        })
    });
};
var $ac1c1f5442a5bd8e$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_PureComponent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(ContainerHeader, _PureComponent);
    var _super = $ac1c1f5442a5bd8e$var$_createSuper(ContainerHeader);
    function ContainerHeader() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ContainerHeader);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ContainerHeader, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, styleReducer = _this$props.styles, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_this$props, $ac1c1f5442a5bd8e$var$_excluded); // We modify the Item styles ourselves, then allow the consumer to modify
                // these if they want to.
                var patchedStyles = function patchedStyles(defaultStyles, state) {
                    return styleReducer($ac1c1f5442a5bd8e$var$modifyStyles(defaultStyles), state);
                };
                return (0, $45CBz.jsx)((0, $8OqBL.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
                    styles: patchedStyles,
                    spacing: "default"
                }));
            }
        }
    ]);
    return ContainerHeader;
}((0, $9nHZC.PureComponent));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($ac1c1f5442a5bd8e$export$2e2bcd8739ae039, "defaultProps", {
    styles: (0, $eDVAW.default),
    isSelected: false,
    text: ""
});

});

parcelRegister("8H0QC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6542ff37772f8a63$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $9nHZC = parcelRequire("9nHZC");

var $vjMcg = parcelRequire("vjMcg");

var $45CBz = parcelRequire("45CBz");
function $6542ff37772f8a63$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6542ff37772f8a63$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $6542ff37772f8a63$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $6542ff37772f8a63$var$GroupHeadingPrimitive = function GroupHeadingPrimitive(_ref) {
    var After = _ref.after, children = _ref.children, theme = _ref.theme;
    var mode = theme.mode, context = theme.context;
    var styles = mode.heading()[context];
    return (0, $45CBz.jsx)("div", {
        css: styles.headingBase
    }, (0, $45CBz.jsx)("div", {
        css: styles.textWrapper
    }, children), !!After && (0, $45CBz.jsx)("div", {
        css: styles.afterWrapper
    }, (0, $45CBz.jsx)(After, null)));
};
var $6542ff37772f8a63$var$GroupHeadingPrimitiveWithTheme = (0, $vjMcg.withContentTheme)($6542ff37772f8a63$var$GroupHeadingPrimitive); // TODO: This component is only defined to pass correct props to our prop docs
// as we require classes for them. Remove once we fix this on the prop doc level.
var $6542ff37772f8a63$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(GroupHeading, _Component);
    var _super = $6542ff37772f8a63$var$_createSuper(GroupHeading);
    function GroupHeading() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, GroupHeading);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(GroupHeading, [
        {
            key: "render",
            value: function render() {
                return (0, $45CBz.jsx)($6542ff37772f8a63$var$GroupHeadingPrimitiveWithTheme, this.props);
            }
        }
    ]);
    return GroupHeading;
}((0, $9nHZC.Component));

});

parcelRegister("2syAc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ca905b940196d3c$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $9nHZC = parcelRequire("9nHZC");

var $45CBz = parcelRequire("45CBz");

var $aP6k3 = parcelRequire("aP6k3");

var $36tIc = parcelRequire("36tIc");
function $1ca905b940196d3c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1ca905b940196d3c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1ca905b940196d3c$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1ca905b940196d3c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1ca905b940196d3c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1ca905b940196d3c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $1ca905b940196d3c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $1ca905b940196d3c$var$gridSize = (0, $aP6k3.gridSize)();
var $1ca905b940196d3c$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(HeaderSection, _Component);
    var _super = $1ca905b940196d3c$var$_createSuper(HeaderSection);
    function HeaderSection() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, HeaderSection);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(HeaderSection, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, children = _this$props.children, id = _this$props.id, parentId = _this$props.parentId;
                return (0, $45CBz.jsx)((0, $36tIc.default), {
                    id: id,
                    key: id,
                    parentId: parentId
                }, function(_ref) {
                    var css = _ref.css;
                    var headerCss = $1ca905b940196d3c$var$_objectSpread($1ca905b940196d3c$var$_objectSpread({}, css), {}, {
                        paddingTop: $1ca905b940196d3c$var$gridSize * 2.5
                    });
                    return (0, $45CBz.jsx)((0, $45CBz.ClassNames), null, function(_ref2) {
                        var getClassName = _ref2.css;
                        return children({
                            css: headerCss,
                            className: getClassName(headerCss)
                        });
                    });
                });
            }
        }
    ]);
    return HeaderSection;
}((0, $9nHZC.Component));

});
parcelRegister("36tIc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2428fad0755993d9$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $eDVAW = parcelRequire("eDVAW");
var $vjMcg = parcelRequire("vjMcg");

var $gnEiL = parcelRequire("gnEiL");

var $45CBz = parcelRequire("45CBz");
function $2428fad0755993d9$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2428fad0755993d9$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $2428fad0755993d9$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $2428fad0755993d9$var$SectionWithTheme = (0, $vjMcg.withContentTheme)((0, $gnEiL.default));
var $2428fad0755993d9$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(Section, _Component);
    var _super = $2428fad0755993d9$var$_createSuper(Section);
    function Section() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, Section);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(Section, [
        {
            key: "render",
            value: function render() {
                return (0, $45CBz.jsx)($2428fad0755993d9$var$SectionWithTheme, this.props);
            }
        }
    ]);
    return Section;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($2428fad0755993d9$export$2e2bcd8739ae039, "defaultProps", {
    alwaysShowScrollHint: false,
    shouldGrow: false,
    styles: (0, $eDVAW.default)
});

});
parcelRegister("gnEiL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bece0e693686ec55$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $45CBz = parcelRequire("45CBz");
var $7KAwG = parcelRequire("7KAwG");

var $3Jogu = parcelRequire("3Jogu");

var $lBdgs = parcelRequire("lBdgs");
parcelRequire("jlzQX");
var $1irk6 = parcelRequire("1irk6");

var $5SBZk = parcelRequire("5SBZk");

var $jjs3S = parcelRequire("jjs3S");
function $bece0e693686ec55$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $bece0e693686ec55$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $bece0e693686ec55$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $bece0e693686ec55$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $bece0e693686ec55$var$_ref = {
    name: "79elbk",
    styles: "position:relative;"
};
var $bece0e693686ec55$export$3dcc51420644798 = function StaticTransitionGroup(props) {
    return (0, $45CBz.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        css: $bece0e693686ec55$var$_ref
    }, props));
};
var $bece0e693686ec55$var$_ref2 = {
    name: "424011",
    styles: "position:relative;flex:1 1 100%;overflow-y:hidden;"
};
var $bece0e693686ec55$export$dc0eb928bda3bfd6 = function ScrollableTransitionGroup(props) {
    return (0, $45CBz.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        css: $bece0e693686ec55$var$_ref2
    }, props));
};
var $bece0e693686ec55$export$306ec41a5602e649 = function ScrollableWrapper(props) {
    return (0, $45CBz.jsx)("div", props);
};
var $bece0e693686ec55$export$41fb2f75de45ebcb = function ScrollableInner(props) {
    return (0, $45CBz.jsx)("div", props);
};
var $bece0e693686ec55$export$7c57aee6978a2aca = function StaticWrapper(props) {
    return (0, $45CBz.jsx)("div", props);
};
var $bece0e693686ec55$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_PureComponent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(Section, _PureComponent);
    var _super = $bece0e693686ec55$var$_createSuper(Section);
    function Section() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, Section);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "state", {
            traversalDirection: null
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isMounted", false);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(Section, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._isMounted = true;
            }
        },
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                if (nextProps.parentId && nextProps.parentId === this.props.id) this.setState({
                    traversalDirection: "down"
                });
                if (this.props.parentId && this.props.parentId === nextProps.id) this.setState({
                    traversalDirection: "up"
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, alwaysShowScrollHint = _this$props.alwaysShowScrollHint, id = _this$props.id, children = _this$props.children, shouldGrow = _this$props.shouldGrow, styleReducer = _this$props.styles, theme = _this$props.theme;
                var mode = theme.mode, context = theme.context;
                var styles = styleReducer(mode.section({
                    alwaysShowScrollHint: alwaysShowScrollHint
                })[context]);
                return (0, $45CBz.jsx)((0, $lBdgs.default), {
                    component: shouldGrow ? $bece0e693686ec55$export$dc0eb928bda3bfd6 : $bece0e693686ec55$export$3dcc51420644798,
                    appear: true
                }, (0, $45CBz.jsx)((0, $3Jogu.default), {
                    key: id,
                    timeout: this._isMounted ? (0, $5SBZk.transitionDurationMs) : 0
                }, function(state) {
                    var traversalDirection = _this2.state.traversalDirection;
                    var animationStyles = (0, $jjs3S.default)({
                        state: state,
                        traversalDirection: traversalDirection
                    }); // We provide both the styles object and the computed className.
                    // This allows consumers to patch the styles if they want to, or
                    // simply apply the className if they're not using a JSS parser like
                    // emotion.
                    return (0, $45CBz.jsx)((0, $1irk6.NavigationAnalyticsContext), {
                        data: {
                            attributes: {
                                viewSection: id
                            },
                            componentName: "Section"
                        }
                    }, (0, $45CBz.jsx)((0, $45CBz.ClassNames), null, function(_ref3) {
                        var getClassName = _ref3.css;
                        return shouldGrow ? (0, $45CBz.jsx)($bece0e693686ec55$export$306ec41a5602e649, {
                            css: /*#__PURE__*/ (0, $7KAwG.default)(styles.wrapper, " ", animationStyles, "")
                        }, (0, $45CBz.jsx)($bece0e693686ec55$export$41fb2f75de45ebcb, {
                            css: styles.inner
                        }, children({
                            className: getClassName(styles.children),
                            css: styles.children
                        }))) : (0, $45CBz.jsx)($bece0e693686ec55$export$7c57aee6978a2aca, {
                            css: animationStyles
                        }, children({
                            className: getClassName(styles.children),
                            css: styles.children
                        }));
                    }));
                }));
            }
        }
    ]);
    return Section;
}((0, $9nHZC.PureComponent));

});
parcelRegister("lBdgs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb9757b3e68ce619$export$2e2bcd8739ae039; });

var $4dya5 = parcelRequire("4dya5");

var $ii97e = parcelRequire("ii97e");

var $gHe8f = parcelRequire("gHe8f");

var $fXGwT = parcelRequire("fXGwT");


var $9nHZC = parcelRequire("9nHZC");

var $dgjLk = parcelRequire("dgjLk");

var $2nVOq = parcelRequire("2nVOq");
var $fb9757b3e68ce619$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $fb9757b3e68ce619$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $fb9757b3e68ce619$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $fXGwT.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $gHe8f.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $2nVOq.getInitialChildMapping)(nextProps, handleExited) : (0, $2nVOq.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $2nVOq.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $ii97e.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $4dya5.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $fb9757b3e68ce619$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dgjLk.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dgjLk.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component);
$fb9757b3e68ce619$var$TransitionGroup.propTypes = {};
$fb9757b3e68ce619$var$TransitionGroup.defaultProps = $fb9757b3e68ce619$var$defaultProps;
var $fb9757b3e68ce619$export$2e2bcd8739ae039 = $fb9757b3e68ce619$var$TransitionGroup;

});
parcelRegister("2nVOq", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $1bca93122725e1ce$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $1bca93122725e1ce$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $1bca93122725e1ce$export$36fd1af28d383ec0; });

var $9nHZC = parcelRequire("9nHZC");
function $1bca93122725e1ce$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $9nHZC.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $9nHZC.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $1bca93122725e1ce$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $1bca93122725e1ce$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $1bca93122725e1ce$export$fa71e2345c31d7a2(props, onExited) {
    return $1bca93122725e1ce$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $9nHZC.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $1bca93122725e1ce$var$getProp(child, "appear", props),
            enter: $1bca93122725e1ce$var$getProp(child, "enter", props),
            exit: $1bca93122725e1ce$var$getProp(child, "exit", props)
        });
    });
}
function $1bca93122725e1ce$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $1bca93122725e1ce$export$bbc8a025727ea824(nextProps.children);
    var children = $1bca93122725e1ce$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $9nHZC.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $9nHZC.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $9nHZC.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $1bca93122725e1ce$var$getProp(child, "exit", nextProps),
            enter: $1bca93122725e1ce$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $9nHZC.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $9nHZC.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $9nHZC.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $1bca93122725e1ce$var$getProp(child, "exit", nextProps),
            enter: $1bca93122725e1ce$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});


parcelRegister("jjs3S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0f58f2136091c75$export$2e2bcd8739ae039; });

var $hlgjl = parcelRequire("hlgjl");
parcelRequire("45CBz");
var $7KAwG = parcelRequire("7KAwG");
var $45CBz = parcelRequire("45CBz");

var $5SBZk = parcelRequire("5SBZk");
var $e0f58f2136091c75$var$_templateObject, $e0f58f2136091c75$var$_templateObject2, $e0f58f2136091c75$var$_templateObject3, $e0f58f2136091c75$var$_templateObject4;
var $e0f58f2136091c75$var$enterAnimationDown = (0, $45CBz.keyframes)($e0f58f2136091c75$var$_templateObject || ($e0f58f2136091c75$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n  from { transform: translateX(100%); }\n  to { transform: translateX(0%); }\n"
])));
var $e0f58f2136091c75$var$enterAnimationUp = (0, $45CBz.keyframes)($e0f58f2136091c75$var$_templateObject2 || ($e0f58f2136091c75$var$_templateObject2 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n  from { transform: translateX(-100%); }\n  to { transform: translateX(0%); }\n"
])));
var $e0f58f2136091c75$var$exitAnimationDown = (0, $45CBz.keyframes)($e0f58f2136091c75$var$_templateObject3 || ($e0f58f2136091c75$var$_templateObject3 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n  from { transform: translateX(0); }\n  to { transform: translateX(-100%); }\n"
])));
var $e0f58f2136091c75$var$exitAnimationUp = (0, $45CBz.keyframes)($e0f58f2136091c75$var$_templateObject4 || ($e0f58f2136091c75$var$_templateObject4 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n  from { transform: translateX(0); }\n  to { transform: translateX(100%); }\n"
])));
var $e0f58f2136091c75$export$2e2bcd8739ae039 = function(_ref) {
    var state = _ref.state, traversalDirection = _ref.traversalDirection;
    if (![
        "entering",
        "exiting"
    ].includes(state) || !traversalDirection) return {};
    if (state === "exiting") {
        var animationName = traversalDirection === "down" ? $e0f58f2136091c75$var$exitAnimationDown : $e0f58f2136091c75$var$exitAnimationUp;
        return /*#__PURE__*/ (0, $7KAwG.default)({
            animationDuration: (0, $5SBZk.transitionDuration),
            animationFillMode: "forwards",
            animationTimingFunction: (0, $5SBZk.transitionTimingFunction)
        }, " animation-name:", animationName, ";");
    }
    if (state === "entering") {
        var _animationName = traversalDirection === "down" ? $e0f58f2136091c75$var$enterAnimationDown : $e0f58f2136091c75$var$enterAnimationUp;
        return /*#__PURE__*/ (0, $7KAwG.default)({
            animationDuration: (0, $5SBZk.transitionDuration),
            animationFillMode: "forwards",
            animationTimingFunction: (0, $5SBZk.transitionTimingFunction),
            position: "absolute",
            width: "100%",
            zIndex: 1
        }, " animation-name:", _animationName, ";");
    }
    return {};
};

});




parcelRegister("7NvL6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ad5be9fb877cdc8$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $eDVAW = parcelRequire("eDVAW");
var $vjMcg = parcelRequire("vjMcg");

var $f750f = parcelRequire("f750f");

var $45CBz = parcelRequire("45CBz");
function $5ad5be9fb877cdc8$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5ad5be9fb877cdc8$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $5ad5be9fb877cdc8$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $5ad5be9fb877cdc8$var$ItemAvatarWithTheme = (0, $vjMcg.withContentTheme)((0, $f750f.default));
var $5ad5be9fb877cdc8$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(ConnectedItemAvatar, _Component);
    var _super = $5ad5be9fb877cdc8$var$_createSuper(ConnectedItemAvatar);
    function ConnectedItemAvatar() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ConnectedItemAvatar);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ConnectedItemAvatar, [
        {
            key: "render",
            value: function render() {
                return (0, $45CBz.jsx)($5ad5be9fb877cdc8$var$ItemAvatarWithTheme, this.props);
            }
        }
    ]);
    return ConnectedItemAvatar;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($5ad5be9fb877cdc8$export$2e2bcd8739ae039, "defaultProps", {
    styles: (0, $eDVAW.default)
});

});
parcelRegister("f750f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b00b63ee96752b4e$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $9nHZC = parcelRequire("9nHZC");

var $ly5Ho = parcelRequire("ly5Ho");

var $vjMcg = parcelRequire("vjMcg");

var $45CBz = parcelRequire("45CBz");
var $b00b63ee96752b4e$var$_excluded = [
    "itemState",
    "styles",
    "theme"
];
function $b00b63ee96752b4e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b00b63ee96752b4e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $b00b63ee96752b4e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $b00b63ee96752b4e$var$ItemAvatar = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(ItemAvatar, _Component);
    var _super = $b00b63ee96752b4e$var$_createSuper(ItemAvatar);
    function ItemAvatar() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ItemAvatar);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ItemAvatar, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, itemState = _this$props.itemState, styleReducer = _this$props.styles, theme = _this$props.theme, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_this$props, $b00b63ee96752b4e$var$_excluded);
                var mode = theme.mode, context = theme.context;
                var borderColor = styleReducer(mode.item(itemState)[context], itemState).itemBase.backgroundColor;
                return (0, $45CBz.jsx)((0, $ly5Ho.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                    borderColor: borderColor
                }, props));
            }
        }
    ]);
    return ItemAvatar;
}((0, $9nHZC.Component));
var $b00b63ee96752b4e$export$2e2bcd8739ae039 = (0, $vjMcg.withContentTheme)($b00b63ee96752b4e$var$ItemAvatar);

});
parcelRegister("ly5Ho", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb0131a5091f6c3f$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $340K4 = parcelRequire("340K4");

var $hlgjl = parcelRequire("hlgjl");

var $9nHZC = parcelRequire("9nHZC");

var $45CBz = parcelRequire("45CBz");

var $2QFHd = parcelRequire("2QFHd");

var $jp7ng = parcelRequire("jp7ng");

var $7px2i = parcelRequire("7px2i");

var $2zBrR = parcelRequire("2zBrR");

var $e7SZZ = parcelRequire("e7SZZ");

var $cffSF = parcelRequire("cffSF");

var $enGIh = parcelRequire("enGIh");
var $fb0131a5091f6c3f$var$_templateObject;
function $fb0131a5091f6c3f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fb0131a5091f6c3f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $fb0131a5091f6c3f$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $fb0131a5091f6c3f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $fb0131a5091f6c3f$var$packageName = "@atlaskit/avatar";
var $fb0131a5091f6c3f$var$packageVersion = "20.5.10";
var $fb0131a5091f6c3f$var$getStyles = function getStyles(css, _ref) {
    var size = _ref.size, radius = _ref.radius, appearance = _ref.appearance, _ref$borderColor = _ref.borderColor, borderColor = _ref$borderColor === void 0 ? "var(--ds-surface-overlay, ".concat((0, $jp7ng.N0), ")") : _ref$borderColor, stackIndex = _ref.stackIndex, isInteractive = _ref.isInteractive, isDisabled = _ref.isDisabled;
    return css($fb0131a5091f6c3f$var$_templateObject || ($fb0131a5091f6c3f$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
        "\n    height: ",
        "px;\n    width: ",
        "px;\n    align-items: stretch;\n    background-color: ",
        ";\n    border-radius: ",
        ";\n    box-sizing: content-box;\n    cursor: inherit;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    outline: none;\n    overflow: hidden;\n    position: static;\n    transform: translateZ(0);\n    transition: transform 200ms, opacity 200ms;\n    box-shadow: 0 0 0 ",
        "px ",
        ";\n    border: none;\n    margin: ",
        "px;\n    padding: 0;\n\n    /* Added font-size and font-family styles to fix alignment issue in firefox for interactive button avatar */\n    font-size: inherit;\n    font-family: inherit;\n\n    &::-moz-focus-inner {\n      border: 0;\n      margin: 0;\n      padding: 0;\n    }\n\n    &::after {\n      background-color: transparent;\n      bottom: 0px;\n\n      /* Added border-radius style to fix hover issue in safari */\n      border-radius: ",
        ";\n      content: ' ';\n      left: 0px;\n      opacity: 0;\n      pointer-events: none;\n      position: absolute;\n      right: 0px;\n      top: 0px;\n      transition: opacity 200ms;\n      width: 100%;\n    }\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n  "
    ])), size, size, borderColor, appearance === "circle" ? "50%" : "".concat(radius, "px"), (0, $2zBrR.BORDER_WIDTH), borderColor, (0, $2zBrR.BORDER_WIDTH), appearance === "circle" ? "50%" : "".concat(radius, "px"), stackIndex && "position: relative;", isInteractive && "\n      cursor: pointer;\n\n      :focus {\n        outline: none;\n        box-shadow: 0 0 0 ".concat((0, $2zBrR.BORDER_WIDTH), "px ").concat("var(--ds-border-focused, ".concat((0, $jp7ng.B300), ")"), "\n      }\n\n      :hover {\n        &::after {\n          background-color: ").concat("var(--ds-interaction-hovered, ".concat((0, $jp7ng.N70A), ")"), ";\n          opacity: 1;\n        }\n      }\n\n      :active {\n        &::after {\n          background-color: ").concat("var(--ds-interaction-pressed, ".concat((0, $jp7ng.N70A), ")"), ";\n          opacity: 1;\n        }\n      }\n\n      :active {\n        transform: scale(").concat((0, $2zBrR.ACTIVE_SCALE_FACTOR), ");\n      }\n\n      @media screen and (forced-colors: active) {\n        &:focus-visible {\n          outline: 1px solid\n        }\n      }\n    "), isDisabled && "\n        cursor: not-allowed;\n\n        &::after {\n          opacity: 0.7;\n          pointer-events: none;\n          background-color: ".concat("var(--ds-surface, ".concat((0, $jp7ng.N0), ")"), ";\n        }\n      "));
};
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ var $fb0131a5091f6c3f$var$Avatar = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref2, ref) {
    var analyticsContext = _ref2.analyticsContext, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "circle" : _ref2$appearance, label = _ref2.label, borderColor = _ref2.borderColor, children = _ref2.children, href = _ref2.href, isDisabled = _ref2.isDisabled, name = _ref2.name, onClick = _ref2.onClick, presence = _ref2.presence, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? "medium" : _ref2$size, src = _ref2.src, stackIndex = _ref2.stackIndex, status = _ref2.status, target = _ref2.target, testId = _ref2.testId;
    var _useAnalyticsEvents = (0, $2QFHd.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var customPresenceNode = (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(presence) === "object" ? presence : null;
    var customStatusNode = (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(status) === "object" ? status : null;
    var isValidIconSize = size !== "xxlarge" && size !== "xsmall";
    var lastAnalytics = (0, $9nHZC.useRef)(analyticsContext);
    (0, $9nHZC.useEffect)(function() {
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    var onClickHandler = (0, $9nHZC.useCallback)(function(event) {
        if (isDisabled || typeof onClick !== "function") return;
        var analyticsEvent = createAnalyticsEvent({
            action: "clicked",
            actionSubject: "avatar",
            attributes: {
                componentName: "avatar",
                packageName: $fb0131a5091f6c3f$var$packageName,
                packageVersion: $fb0131a5091f6c3f$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ var context = $fb0131a5091f6c3f$var$_objectSpread({
            componentName: "avatar",
            packageName: $fb0131a5091f6c3f$var$packageName,
            packageVersion: $fb0131a5091f6c3f$var$packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC
     */ var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    var getTestId = function getTestId(testId, children) {
        return !children ? {
            "data-testid": "".concat(testId, "--inner")
        } : {
            testId: "".concat(testId, "--inner")
        };
    };
    var componentProps = function componentProps() {
        if (isDisabled) return {
            disabled: true
        };
         // return only relevant props for either anchor or button elements
        return $fb0131a5091f6c3f$var$_objectSpread($fb0131a5091f6c3f$var$_objectSpread({}, href && (0, $enGIh.getLinkProps)(href, target)), onClick && !href ? (0, $enGIh.getButtonProps)(onClickHandler) : {
            onClick: onClick
        });
    };
    return (0, $45CBz.jsx)("div", {
        "data-testid": testId,
        style: {
            display: "inline-block",
            position: "relative",
            outline: 0,
            zIndex: stackIndex
        }
    }, (0, $45CBz.jsx)((0, $45CBz.ClassNames), null, function(_ref3) {
        var css = _ref3.css;
        var props = $fb0131a5091f6c3f$var$_objectSpread($fb0131a5091f6c3f$var$_objectSpread($fb0131a5091f6c3f$var$_objectSpread($fb0131a5091f6c3f$var$_objectSpread({
            className: $fb0131a5091f6c3f$var$getStyles(css, {
                size: (0, $2zBrR.AVATAR_SIZES)[size],
                radius: (0, $2zBrR.AVATAR_RADIUS)[size],
                appearance: appearance,
                borderColor: borderColor,
                stackIndex: stackIndex,
                isInteractive: Boolean(href || onClick) && !isDisabled,
                isDisabled: isDisabled
            })
        }, componentProps()), testId && getTestId(testId, children)), (onClick || href) && {
            "aria-label": label
        }), {}, {
            children: (0, $45CBz.jsx)((0, $7px2i.default), {
                alt: name,
                appearance: appearance,
                size: size,
                src: src,
                testId: testId
            }),
            ref: ref
        });
        return children ? children(props) : /*#__PURE__*/ (0, $9nHZC.createElement)((0, $enGIh.getCustomElement)(isDisabled, href, onClick), props);
    }), isValidIconSize && presence && !status && (0, $45CBz.jsx)((0, $e7SZZ.PresenceWrapper), {
        appearance: appearance,
        size: size,
        presence: !customPresenceNode && presence,
        testId: testId
    }, customPresenceNode), isValidIconSize && status && (0, $45CBz.jsx)((0, $cffSF.StatusWrapper), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: !customStatusNode && status,
        testId: testId
    }, customStatusNode));
});
$fb0131a5091f6c3f$var$Avatar.displayName = "Avatar";
var $fb0131a5091f6c3f$export$2e2bcd8739ae039 = $fb0131a5091f6c3f$var$Avatar;

});
parcelRegister("7px2i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56547e7ec8f3537c$export$2e2bcd8739ae039; });

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("45CBz");
var $7KAwG = parcelRequire("7KAwG");
var $45CBz = parcelRequire("45CBz");

var $iEQOn = parcelRequire("iEQOn");

var $k3UZq = parcelRequire("k3UZq");

var $jp7ng = parcelRequire("jp7ng");

var $2zBrR = parcelRequire("2zBrR");
var $56547e7ec8f3537c$export$ebe0b8fe8b6acbfd = "var(--ds-text-inverse, ".concat((0, $jp7ng.background)(), ")");
var $56547e7ec8f3537c$export$72502e51aebdd94e = "var(--ds-text-subtlest, ".concat((0, $jp7ng.N90), ")");
var $56547e7ec8f3537c$var$avatarImageStyles = (0, $7KAwG.default)({
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: $56547e7ec8f3537c$export$72502e51aebdd94e
});
var $56547e7ec8f3537c$var$loadingImageStyles = (0, $7KAwG.default)({
    display: "flex",
    width: "100%",
    height: "100%",
    flex: "1 1 100%",
    backgroundColor: "transparent",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover"
});
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ var $56547e7ec8f3537c$var$AvatarImage = function AvatarImage(_ref) {
    var _ref$alt = _ref.alt, alt = _ref$alt === void 0 ? "" : _ref$alt, src = _ref.src, appearance = _ref.appearance, size = _ref.size, testId = _ref.testId;
    var _useState = (0, $9nHZC.useState)("initial"), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), phase = _useState2[0], setPhase = _useState2[1];
    var borderRadius = appearance === "circle" ? "50%" : "".concat((0, $2zBrR.AVATAR_RADIUS)[size], "px");
    var image = (0, $9nHZC.useMemo)(function() {
        if (src) {
            setPhase("loading");
            var img = new Image();
            img.onload = function() {
                return setPhase("loaded");
            };
            img.onerror = function() {
                return setPhase("error");
            };
            img.src = src;
            return img;
        }
        return null;
    }, [
        src
    ]);
    (0, $9nHZC.useEffect)(function() {
        return function() {
            if (image) {
                image.onload = function() {};
                image.onerror = function() {};
            }
        };
    }, [
        image
    ]);
    var imageHasLoadedAsync = src && phase !== "loading" && phase !== "error";
    var imageHasLoadedSync = src && phase === "loading" && (image === null || image === void 0 ? void 0 : image.complete);
    var imageHasLoaded = imageHasLoadedAsync || imageHasLoadedSync;
    if (!imageHasLoaded) return (0, $45CBz.jsx)("span", {
        css: [
            $56547e7ec8f3537c$var$avatarImageStyles,
            // eslint-disable-next-line @repo/internal/react/consistent-css-prop-usage
            {
                "& svg": {
                    width: "".concat((0, $2zBrR.AVATAR_SIZES)[size], "px"),
                    height: "".concat((0, $2zBrR.AVATAR_SIZES)[size], "px")
                }
            }
        ]
    }, appearance === "circle" ? (0, $45CBz.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iEQOn))), {
        label: alt,
        primaryColor: $56547e7ec8f3537c$export$ebe0b8fe8b6acbfd,
        secondaryColor: $56547e7ec8f3537c$export$72502e51aebdd94e,
        testId: testId && "".concat(testId, "--person")
    }) : (0, $45CBz.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k3UZq))), {
        label: alt,
        primaryColor: $56547e7ec8f3537c$export$ebe0b8fe8b6acbfd,
        secondaryColor: $56547e7ec8f3537c$export$72502e51aebdd94e,
        testId: testId && "".concat(testId, "--ship")
    }));
    return (0, $45CBz.jsx)("span", {
        css: $56547e7ec8f3537c$var$loadingImageStyles,
        style: {
            backgroundImage: 'url("'.concat(src, '")'),
            borderRadius: borderRadius
        },
        role: alt ? "img" : undefined,
        "aria-label": alt || undefined,
        "data-testid": testId && "".concat(testId, "--image")
    });
};
var $56547e7ec8f3537c$export$2e2bcd8739ae039 = $56547e7ec8f3537c$var$AvatarImage;

});
parcelRegister("iEQOn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d954edb0bc09d2ea$var$_react = $d954edb0bc09d2ea$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $kupLT = parcelRequire("kupLT");
function $d954edb0bc09d2ea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d954edb0bc09d2ea$var$PersonIcon = (props)=>/*#__PURE__*/ $d954edb0bc09d2ea$var$_react.default.createElement($kupLT.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0V14z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props));
$d954edb0bc09d2ea$var$PersonIcon.displayName = "PersonIcon";
var $d954edb0bc09d2ea$var$_default = $d954edb0bc09d2ea$var$PersonIcon;
module.exports.default = $d954edb0bc09d2ea$var$_default;

});

parcelRegister("k3UZq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e9b04b7560f03281$var$_react = $e9b04b7560f03281$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $kupLT = parcelRequire("kupLT");
function $e9b04b7560f03281$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e9b04b7560f03281$var$ShipIcon = (props)=>/*#__PURE__*/ $e9b04b7560f03281$var$_react.default.createElement($kupLT.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M6 12h8v-2H6v2zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4V8.99z" fill-rule="nonzero"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6V7.005zm4 0V7H7.999c.005 0 .002.003.002.005V8h2v-.995z"/><path d="M4.5 17h13.994l1.002-3H4.14l.36 3zm-2.495-4.012A.862.862 0 012.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.149 1.149 0 01-1.118-.988l-.602-5.024z" fill-rule="nonzero"/></g></svg>`
    }, props));
$e9b04b7560f03281$var$ShipIcon.displayName = "ShipIcon";
var $e9b04b7560f03281$var$_default = $e9b04b7560f03281$var$ShipIcon;
module.exports.default = $e9b04b7560f03281$var$_default;

});

parcelRegister("2zBrR", function(module, exports) {

$parcel$export(module.exports, "AVATAR_SIZES", function () { return $1dfbe620e0bc5951$export$9a270941bcff7e77; });
$parcel$export(module.exports, "AVATAR_RADIUS", function () { return $1dfbe620e0bc5951$export$e6da6efe4d1a5c9b; });
$parcel$export(module.exports, "BORDER_WIDTH", function () { return $1dfbe620e0bc5951$export$e2bd4c1faded7921; });
$parcel$export(module.exports, "ACTIVE_SCALE_FACTOR", function () { return $1dfbe620e0bc5951$export$89a980dfdf90df51; });
$parcel$export(module.exports, "ICON_SIZES", function () { return $1dfbe620e0bc5951$export$fdc820179f1f9be4; });
$parcel$export(module.exports, "ICON_OFFSET", function () { return $1dfbe620e0bc5951$export$382610e783aa2ae8; });
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $aP6k3 = parcelRequire("aP6k3");
var $1dfbe620e0bc5951$export$9a270941bcff7e77 = {
    xsmall: (0, $aP6k3.gridSize)() * 2,
    small: (0, $aP6k3.gridSize)() * 3,
    medium: (0, $aP6k3.gridSize)() * 4,
    large: (0, $aP6k3.gridSize)() * 5,
    xlarge: (0, $aP6k3.gridSize)() * 12,
    xxlarge: (0, $aP6k3.gridSize)() * 16
}; // border radius only applies to "square" avatars
var $1dfbe620e0bc5951$export$e6da6efe4d1a5c9b = {
    xsmall: 2,
    small: 2,
    medium: 3,
    large: 3,
    xlarge: 6,
    xxlarge: 12
};
var $1dfbe620e0bc5951$export$e2bd4c1faded7921 = 2;
var $1dfbe620e0bc5951$export$89a980dfdf90df51 = 0.9;
var $1dfbe620e0bc5951$export$fdc820179f1f9be4 = {
    small: 12,
    medium: 14,
    large: 15,
    xlarge: 18
};
var $1dfbe620e0bc5951$export$382610e783aa2ae8 = {
    small: 0,
    medium: 0,
    large: 1,
    xlarge: 7
};

});


parcelRegister("e7SZZ", function(module, exports) {

$parcel$export(module.exports, "PresenceWrapper", function () { return $a48c61c1033d2b1f$export$972c5e90200fa0ef; });
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $9nHZC = parcelRequire("9nHZC");

var $jp7ng = parcelRequire("jp7ng");

var $2zBrR = parcelRequire("2zBrR");

var $9yMJ3 = parcelRequire("9yMJ3");
var $a48c61c1033d2b1f$var$BusyIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $jp7ng.R300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $jp7ng.background)(), ")"),
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
var $a48c61c1033d2b1f$var$FocusIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
    fill: "var(--ds-icon-discovery, ".concat((0, $jp7ng.purple)(), ")"),
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
var $a48c61c1033d2b1f$var$OfflineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
    fill: "var(--ds-text-subtlest, ".concat((0, $jp7ng.N200), ")"),
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $jp7ng.N40), ")"),
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
var $a48c61c1033d2b1f$var$OnlineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $jp7ng.G300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
});
function $a48c61c1033d2b1f$var$getPresence(presence) {
    switch(presence){
        case "busy":
            return $a48c61c1033d2b1f$var$BusyIndicator;
        case "focus":
            return $a48c61c1033d2b1f$var$FocusIndicator;
        case "offline":
            return $a48c61c1033d2b1f$var$OfflineIndicator;
        case "online":
            return $a48c61c1033d2b1f$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ var $a48c61c1033d2b1f$var$AvatarPresence = function AvatarPresence(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, presence = _ref.presence;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9yMJ3.default), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $a48c61c1033d2b1f$var$getPresence(presence)) : children);
};
var $a48c61c1033d2b1f$export$2e2bcd8739ae039 = $a48c61c1033d2b1f$var$AvatarPresence;
var $a48c61c1033d2b1f$export$972c5e90200fa0ef = function PresenceWrapper(_ref2) {
    var size = _ref2.size, appearance = _ref2.appearance, children = _ref2.children, borderColor = _ref2.borderColor, presence = _ref2.presence, testId = _ref2.testId;
    var position = appearance === "square" ? -4 : (0, $2zBrR.ICON_OFFSET)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", {
        "data-testid": testId && "".concat(testId, "--presence"),
        style: {
            pointerEvents: "none",
            position: "absolute",
            bottom: "".concat(position, "px"),
            height: "".concat((0, $2zBrR.ICON_SIZES)[size], "px"),
            right: "".concat(position, "px"),
            width: "".concat((0, $2zBrR.ICON_SIZES)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($a48c61c1033d2b1f$var$AvatarPresence, {
        borderColor: borderColor,
        presence: !children && presence
    }, children));
};

});
parcelRegister("9yMJ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f5d15f5e93b3cc4$export$2e2bcd8739ae039; });
/** @jsx jsx */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match
parcelRequire("45CBz");
var $7KAwG = parcelRequire("7KAwG");
var $45CBz = parcelRequire("45CBz");

var $jp7ng = parcelRequire("jp7ng");

var $2zBrR = parcelRequire("2zBrR");
var $6f5d15f5e93b3cc4$var$iconWrapperStyles = (0, $7KAwG.default)({
    display: "flex",
    boxSizing: "border-box",
    width: "100%",
    height: "100%",
    alignItems: "center",
    alignContent: "center",
    borderRadius: "50%",
    overflow: "hidden"
});
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ var $6f5d15f5e93b3cc4$var$IconWrapper = function IconWrapper(_ref) {
    var _ref$bgColor = _ref.bgColor, bgColor = _ref$bgColor === void 0 ? "var(--ds-surface-overlay, ".concat((0, $jp7ng.background)(), ")") : _ref$bgColor, children = _ref.children;
    return (0, $45CBz.jsx)("span", {
        css: $6f5d15f5e93b3cc4$var$iconWrapperStyles,
        style: {
            border: "".concat((0, $2zBrR.BORDER_WIDTH), "px solid ").concat(bgColor),
            backgroundColor: bgColor
        }
    }, children);
};
var $6f5d15f5e93b3cc4$export$2e2bcd8739ae039 = $6f5d15f5e93b3cc4$var$IconWrapper;

});


parcelRegister("cffSF", function(module, exports) {

$parcel$export(module.exports, "StatusWrapper", function () { return $8ea33456ddd90bd8$export$8045894f255f9726; });
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $9nHZC = parcelRequire("9nHZC");

var $jp7ng = parcelRequire("jp7ng");

var $2zBrR = parcelRequire("2zBrR");

var $9yMJ3 = parcelRequire("9yMJ3");
var $8ea33456ddd90bd8$var$ApprovedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $jp7ng.G400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $jp7ng.background)(), ")"),
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
var $8ea33456ddd90bd8$var$DeclinedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $jp7ng.R400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $jp7ng.background)(), ")"),
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
var $8ea33456ddd90bd8$var$LockedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("circle", {
    fill: "var(--ds-text-subtlest, ".concat((0, $jp7ng.N40), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $jp7ng.N500), ")"),
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
function $8ea33456ddd90bd8$var$getStatus(status) {
    switch(status){
        case "approved":
            return $8ea33456ddd90bd8$var$ApprovedIndicator;
        case "declined":
            return $8ea33456ddd90bd8$var$DeclinedIndicator;
        case "locked":
            return $8ea33456ddd90bd8$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ var $8ea33456ddd90bd8$var$AvatarStatus = function AvatarStatus(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, status = _ref.status;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9yMJ3.default), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $8ea33456ddd90bd8$var$getStatus(status)) : children);
};
var $8ea33456ddd90bd8$export$2e2bcd8739ae039 = $8ea33456ddd90bd8$var$AvatarStatus;
var $8ea33456ddd90bd8$export$8045894f255f9726 = function StatusWrapper(_ref2) {
    var size = _ref2.size, status = _ref2.status, appearance = _ref2.appearance, borderColor = _ref2.borderColor, children = _ref2.children, testId = _ref2.testId;
    var position = appearance === "square" ? 0 : (0, $2zBrR.ICON_OFFSET)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", {
        "data-testid": testId && "".concat(testId, "--status"),
        style: {
            position: "absolute",
            height: "".concat((0, $2zBrR.ICON_SIZES)[size], "px"),
            right: "".concat(position, "px"),
            top: "".concat(position, "px"),
            width: "".concat((0, $2zBrR.ICON_SIZES)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($8ea33456ddd90bd8$var$AvatarStatus, {
        borderColor: borderColor,
        status: !children && status
    }, children));
};

});

parcelRegister("enGIh", function(module, exports) {

$parcel$export(module.exports, "getLinkProps", function () { return $a784589985b134d7$export$60113ebe1cf0ecf; });
$parcel$export(module.exports, "getButtonProps", function () { return $a784589985b134d7$export$cca6f1bef43616d3; });
$parcel$export(module.exports, "getCustomElement", function () { return $a784589985b134d7$export$83ee468102cdf04c; });
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match
var $a784589985b134d7$export$60113ebe1cf0ecf = function getLinkProps(href, target) {
    return {
        href: href,
        rel: target === "_blank" ? "noopener noreferrer" : null,
        target: target
    };
};
var $a784589985b134d7$export$cca6f1bef43616d3 = function getButtonProps(onClick) {
    return {
        type: "button",
        onClick: onClick
    };
};
var $a784589985b134d7$export$83ee468102cdf04c = function getCustomElement(isDisabled, href, onClick) {
    if (href && !isDisabled) return "a";
    if (onClick || isDisabled) return "button";
    return "span";
};

});




parcelRegister("8mEoV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $616fb796eb8e637c$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $45CBz = parcelRequire("45CBz");

var $aP6k3 = parcelRequire("aP6k3");

var $36tIc = parcelRequire("36tIc");
function $616fb796eb8e637c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $616fb796eb8e637c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $616fb796eb8e637c$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $616fb796eb8e637c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $616fb796eb8e637c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $616fb796eb8e637c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $616fb796eb8e637c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $616fb796eb8e637c$var$gridSize = (0, $aP6k3.gridSize)();
var $616fb796eb8e637c$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(MenuSection, _Component);
    var _super = $616fb796eb8e637c$var$_createSuper(MenuSection);
    function MenuSection() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, MenuSection);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(MenuSection, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, alwaysShowScrollHint = _this$props.alwaysShowScrollHint, id = _this$props.id, children = _this$props.children, parentId = _this$props.parentId;
                return (0, $45CBz.jsx)((0, $36tIc.default), {
                    id: id,
                    parentId: parentId,
                    alwaysShowScrollHint: alwaysShowScrollHint,
                    shouldGrow: true
                }, function(_ref) {
                    var css = _ref.css;
                    var menuCss = $616fb796eb8e637c$var$_objectSpread($616fb796eb8e637c$var$_objectSpread({}, css), {}, {
                        paddingBottom: $616fb796eb8e637c$var$gridSize * 1.5
                    });
                    return (0, $45CBz.jsx)((0, $45CBz.ClassNames), null, function(_ref2) {
                        var getClassName = _ref2.css;
                        return children({
                            css: menuCss,
                            className: getClassName(menuCss)
                        });
                    });
                });
            }
        }
    ]);
    return MenuSection;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($616fb796eb8e637c$export$2e2bcd8739ae039, "defaultProps", {
    alwaysShowScrollHint: false
});

});

parcelRegister("kx4uh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef2a5ed6326c2e81$export$2e2bcd8739ae039; });

var $7KAwG = parcelRequire("7KAwG");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $9nHZC = parcelRequire("9nHZC");

var $aP6k3 = parcelRequire("aP6k3");

var $45CBz = parcelRequire("45CBz");
function $ef2a5ed6326c2e81$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ef2a5ed6326c2e81$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $ef2a5ed6326c2e81$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $ef2a5ed6326c2e81$var$gridSize = (0, $aP6k3.gridSize)();
var $ef2a5ed6326c2e81$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(Wordmark, _Component);
    var _super = $ef2a5ed6326c2e81$var$_createSuper(Wordmark);
    function Wordmark() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, Wordmark);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(Wordmark, [
        {
            key: "render",
            value: function render() {
                var WordmarkLogo = this.props.wordmark;
                return (0, $45CBz.jsx)("div", {
                    css: /*#__PURE__*/ (0, $7KAwG.default)({
                        lineHeight: 0,
                        // -2px here to account for the extra space at the top of a MenuSection
                        // for the scroll hint.
                        paddingBottom: $ef2a5ed6326c2e81$var$gridSize * 3.5 - 2,
                        paddingLeft: $ef2a5ed6326c2e81$var$gridSize * 2,
                        paddingTop: $ef2a5ed6326c2e81$var$gridSize
                    }, "")
                }, (0, $45CBz.jsx)(WordmarkLogo, null));
            }
        }
    ]);
    return Wordmark;
}((0, $9nHZC.Component));

});

parcelRegister("kwkVj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08d16dc82acf8b27$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $08d16dc82acf8b27$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    tryMe: {
        "id": "bitkit.navigation.containerNavigation.tryMe",
        "defaultMessage": "try me"
    },
    new: {
        "id": "bitkit.navigation.containerNavigation.new",
        "defaultMessage": "New"
    }
});

});

parcelRegister("aTYA7", function(module, exports) {

$parcel$export(module.exports, "GroupHeadingNoTopMargin", function () { return $52d18394b45807e0$export$3a2e595f12978c2e; });
$parcel$export(module.exports, "MenuItemWrapper", function () { return $52d18394b45807e0$export$d69e1d473e997f8; });
$parcel$export(module.exports, "BetaLozenge", function () { return $52d18394b45807e0$export$8e7c25c1ddfa53a; });

var $2xJU3 = parcelRequire("2xJU3");

var $aP6k3 = parcelRequire("aP6k3");
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */ function $52d18394b45807e0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $52d18394b45807e0$export$3a2e595f12978c2e = (0, $2xJU3.default)("div", {
    target: "e8l88vi0"
})({
    name: "1f2po4u",
    styles: "> *:first-child{margin-top:0;}"
});
const $52d18394b45807e0$export$d69e1d473e997f8 = (0, $2xJU3.default)("div", {
    target: "e8l88vi1"
})("display:flex;align-items:center;svg{margin-left:", (0, $aP6k3.gridSize), "px;}");
const $52d18394b45807e0$export$8e7c25c1ddfa53a = (0, $2xJU3.default)("div", {
    target: "e8l88vi2"
})({
    name: "4c3vmw",
    styles: "display:flex;margin-left:3px;"
});

});

parcelRegister("dogcG", function(module, exports) {

$parcel$export(module.exports, "renderMenuItemIcon", function () { return $02b64fd0f445109c$export$6e78ef2e7d03ebb1; });

var $9nHZC = parcelRequire("9nHZC");

var $4cpJW = parcelRequire("4cpJW");

var $ckwpp = parcelRequire("ckwpp");

var $6vFKh = parcelRequire("6vFKh");

var $312Xu = parcelRequire("312Xu");

var $9fsw6 = parcelRequire("9fsw6");

var $gFhop = parcelRequire("gFhop");

var $jqR9D = parcelRequire("jqR9D");

var $4TuTb = parcelRequire("4TuTb");

var $fAcOc = parcelRequire("fAcOc");

var $3d0NI = parcelRequire("3d0NI");

var $15uq9 = parcelRequire("15uq9");

var $6FdDl = parcelRequire("6FdDl");

var $djbxR = parcelRequire("djbxR");

var $5n3Yp = parcelRequire("5n3Yp");

var $9KAD5 = parcelRequire("9KAD5");

var $8Th8r = parcelRequire("8Th8r");

var $56TV6 = parcelRequire("56TV6");

var $4TH54 = parcelRequire("4TH54");

var $bM5vQ = parcelRequire("bM5vQ");

var $lDQSw = parcelRequire("lDQSw");

var $5fnaU = parcelRequire("5fnaU");

var $bZ6on = parcelRequire("bZ6on");

var $cpPAg = parcelRequire("cpPAg");

var $91UEL = parcelRequire("91UEL");

var $kmdgX = parcelRequire("kmdgX");

var $hWEfu = parcelRequire("hWEfu");

var $a7iuM = parcelRequire("a7iuM");
parcelRequire("lzz9d");
var $fzQ8V = parcelRequire("fzQ8V");
parcelRequire("lHcJV");
var $2bStf = parcelRequire("2bStf");

var $3D3Ah = parcelRequire("3D3Ah");

var $6BAyw = parcelRequire("6BAyw");

var $95zGT = parcelRequire("95zGT");
const $02b64fd0f445109c$var$icons = {
    overview: (0, (/*@__PURE__*/$parcel$interopDefault($91UEL))),
    downloads: (0, (/*@__PURE__*/$parcel$interopDefault($3d0NI))),
    source: (0, (/*@__PURE__*/$parcel$interopDefault($fAcOc))),
    commits: (0, (/*@__PURE__*/$parcel$interopDefault($ckwpp))),
    branches: (0, (/*@__PURE__*/$parcel$interopDefault($4cpJW))),
    followers: (0, (/*@__PURE__*/$parcel$interopDefault($6FdDl))),
    following: (0, (/*@__PURE__*/$parcel$interopDefault($djbxR))),
    marketplace: (0, (/*@__PURE__*/$parcel$interopDefault($4TH54))),
    members: (0, (/*@__PURE__*/$parcel$interopDefault($5fnaU))),
    teams: (0, (/*@__PURE__*/$parcel$interopDefault($lDQSw))),
    projects: (0, (/*@__PURE__*/$parcel$interopDefault($15uq9))),
    repositories: (0, (/*@__PURE__*/$parcel$interopDefault($9fsw6))),
    snippets: (0, (/*@__PURE__*/$parcel$interopDefault($gFhop))),
    pullrequests: (0, (/*@__PURE__*/$parcel$interopDefault($312Xu))),
    issues: (0, (/*@__PURE__*/$parcel$interopDefault($8Th8r))),
    wiki: (0, (/*@__PURE__*/$parcel$interopDefault($bM5vQ))),
    admin: (0, (/*@__PURE__*/$parcel$interopDefault($bZ6on))),
    security: (0, $2bStf.ShieldIcon),
    supportadmin: (0, (/*@__PURE__*/$parcel$interopDefault($bZ6on))),
    search: (0, (/*@__PURE__*/$parcel$interopDefault($91UEL))),
    "staff-access": (0, (/*@__PURE__*/$parcel$interopDefault($56TV6))),
    "disk-usage": (0, (/*@__PURE__*/$parcel$interopDefault($4TuTb))),
    "media-usage": (0, (/*@__PURE__*/$parcel$interopDefault($9KAD5))),
    "feature-change-log": (0, (/*@__PURE__*/$parcel$interopDefault($3d0NI))),
    "feature-diff": (0, (/*@__PURE__*/$parcel$interopDefault($6vFKh))),
    "connect-stats": (0, (/*@__PURE__*/$parcel$interopDefault($5n3Yp))),
    "environment-settings": (0, (/*@__PURE__*/$parcel$interopDefault($kmdgX))),
    workspace: (0, (/*@__PURE__*/$parcel$interopDefault($jqR9D))),
    utils: (0, (/*@__PURE__*/$parcel$interopDefault($cpPAg))),
    jira: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $hWEfu.JiraIcon), {
            size: "small"
        }),
    deployments: (0, $6BAyw.default),
    pipelines: (0, $95zGT.default)
};
const $02b64fd0f445109c$var$getIconForMenuItemType = (menuItem)=>{
    switch(menuItem.type){
        case "connect_menu_item":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3D3Ah.default), {
                menuItem: menuItem
            });
        case "forge_menu_item":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fzQ8V.ForgeModuleIcon), {
                iconUrl: menuItem.icon_url
            });
        case "menu_item":
            {
                // @ts-ignore TODO: fix noImplicitAny error here
                const IconComponent = $02b64fd0f445109c$var$icons[menuItem.tab_name];
                if (!IconComponent) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(IconComponent, {
                    size: "medium"
                });
            }
        default:
            return null;
    }
};
const $02b64fd0f445109c$export$6e78ef2e7d03ebb1 = (menuItem, isNavigationOpen = true)=>{
    const icon = $02b64fd0f445109c$var$getIconForMenuItemType(menuItem);
    if (!icon) return null;
    return isNavigationOpen ? icon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $a7iuM.default), {
        position: "right",
        content: menuItem.label
    }, icon);
};
var $02b64fd0f445109c$export$2e2bcd8739ae039 = $02b64fd0f445109c$var$icons;

});
parcelRegister("4cpJW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30ec3fd45b0d3ace$var$_react = $30ec3fd45b0d3ace$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $30ec3fd45b0d3ace$var$_branch = $30ec3fd45b0d3ace$var$_interopRequireDefault((parcelRequire("5mMCj")));
function $30ec3fd45b0d3ace$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $30ec3fd45b0d3ace$var$BitbucketBranchesIcon = (props)=>/*#__PURE__*/ $30ec3fd45b0d3ace$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3M8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1m8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1m-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1"/></svg>`
    }, props, {
        newIcon: $30ec3fd45b0d3ace$var$_branch.default
    }));
$30ec3fd45b0d3ace$var$BitbucketBranchesIcon.displayName = "BitbucketBranchesIcon";
var $30ec3fd45b0d3ace$var$_default = module.exports.default = $30ec3fd45b0d3ace$var$BitbucketBranchesIcon;

});
parcelRegister("5mMCj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8d5333b3016191eb34ab8245e965a2ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e84b81e30045333$var$_react = $3e84b81e30045333$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $3e84b81e30045333$var$_UNSAFE_baseNew = $3e84b81e30045333$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $3e84b81e30045333$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e84b81e30045333$var$BranchIcon = (props)=>/*#__PURE__*/ $3e84b81e30045333$var$_react.default.createElement($3e84b81e30045333$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M4.25 4.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 0V9m1.5 3.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 0h3.5a2.5 2.5 0 0 0 2.5-2.5v-5.5m0 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>`
    }, props));
$3e84b81e30045333$var$BranchIcon.displayName = "BranchIcon";
var $3e84b81e30045333$var$_default = module.exports.default = $3e84b81e30045333$var$BranchIcon;

});


parcelRegister("ckwpp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8fa07dfdb27921f9$var$_react = $8fa07dfdb27921f9$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $8fa07dfdb27921f9$var$_commit = $8fa07dfdb27921f9$var$_interopRequireDefault((parcelRequire("geuAZ")));
function $8fa07dfdb27921f9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $8fa07dfdb27921f9$var$BitbucketCommitsIcon = (props)=>/*#__PURE__*/ $8fa07dfdb27921f9$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16 12c0-1.9-1.3-3.4-3-3.9V4c0-.6-.4-1-1-1s-1 .4-1 1v4.1c-1.7.4-3 2-3 3.9s1.3 3.4 3 3.9V20c0 .6.4 1 1 1s1-.4 1-1v-4.1c1.7-.5 3-2 3-3.9m-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"/></svg>`
    }, props, {
        newIcon: $8fa07dfdb27921f9$var$_commit.default
    }));
$8fa07dfdb27921f9$var$BitbucketCommitsIcon.displayName = "BitbucketCommitsIcon";
var $8fa07dfdb27921f9$var$_default = module.exports.default = $8fa07dfdb27921f9$var$BitbucketCommitsIcon;

});
parcelRegister("geuAZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::927670bf7e49f2d0323a49bec9ba77e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd15afd0a7a2384d$var$_react = $bd15afd0a7a2384d$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $bd15afd0a7a2384d$var$_UNSAFE_baseNew = $bd15afd0a7a2384d$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $bd15afd0a7a2384d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Commit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bd15afd0a7a2384d$var$CommitIcon = (props)=>/*#__PURE__*/ $bd15afd0a7a2384d$var$_react.default.createElement($bd15afd0a7a2384d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 10a2 2 0 1 0 0-4m0 4a2 2 0 1 1 0-4m0 4v6M8 6V0"/>`
    }, props));
$bd15afd0a7a2384d$var$CommitIcon.displayName = "CommitIcon";
var $bd15afd0a7a2384d$var$_default = module.exports.default = $bd15afd0a7a2384d$var$CommitIcon;

});


parcelRegister("6vFKh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4bd6052114566ee7$var$_react = $4bd6052114566ee7$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");
function $4bd6052114566ee7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $4bd6052114566ee7$var$BitbucketCompareIcon = (props)=>/*#__PURE__*/ $4bd6052114566ee7$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10.067 16.441c.334.918 1.306 1.6 2.28 1.6h6.167c.55 0 .996-.444.996-1a1 1 0 0 0-.996-1h-6.167c-.133 0-.355-.156-.401-.284l-.816-2.263zM7.94 10.547l-.816-2.263C7.08 8.16 6.851 8 6.722 8H3.998C3.456 8 3 7.552 3 7c0-.556.447-1 .998-1h2.724c.97 0 1.949.686 2.282 1.6z"/><path d="M19.51 7a1 1 0 0 0-.996-1h-6.167c-.976 0-1.95.684-2.283 1.605l-2.94 8.152c-.044.123-.273.284-.402.284H3.998a.996.996 0 0 0-.998 1c0 .552.456 1 .998 1h2.724c.972 0 1.953-.689 2.284-1.606l2.94-8.151c.046-.128.268-.284.401-.284h6.167c.55 0 .996-.444.996-1"/><path d="M17.29 8.29A1 1 0 1 0 18.7 9.7l2-2a1 1 0 0 0 0-1.42l-2-2a1 1 0 0 0-1.41 1.41L18.59 7zm0 10a1 1 0 0 0 1.41 1.41l2-2a1 1 0 0 0 0-1.42l-2-2a1 1 0 0 0-1.41 1.41l1.3 1.31z"/></g></svg>`
    }, props));
$4bd6052114566ee7$var$BitbucketCompareIcon.displayName = "BitbucketCompareIcon";
var $4bd6052114566ee7$var$_default = module.exports.default = $4bd6052114566ee7$var$BitbucketCompareIcon;

});

parcelRegister("312Xu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2323c29b2979f232$var$_react = $2323c29b2979f232$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $2323c29b2979f232$var$_pullRequest = $2323c29b2979f232$var$_interopRequireDefault((parcelRequire("66rW6")));
function $2323c29b2979f232$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2323c29b2979f232$var$BitbucketPullrequestsIcon = (props)=>/*#__PURE__*/ $2323c29b2979f232$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M18 15.2V11c0-1.7-1.3-3-3-3h-1.9l.8-.8c.3-.3.3-.8 0-1.1s-.8-.3-1.1 0l-2.3 2.3c-.3.4-.3.9 0 1.2l2.3 2.3c.2.2.3.2.5.2q.3 0 .6-.3c.3-.3.3-.8 0-1.1l-.7-.7H15c.6 0 1 .4 1 1v4.2c-1.2.4-2 1.5-2 2.8 0 1.7 1.3 3 3 3s3-1.3 3-3c0-1.3-.8-2.4-2-2.8M17 19c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1M7 3C5.4 3 4 4.3 4 6c0 1.3.8 2.4 2 2.8V20c0 .6.4 1 1 1s1-.4 1-1V8.8c1.2-.4 2-1.5 2-2.8 0-1.7-1.3-3-3-3m0 4c-.5 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1"/></svg>`
    }, props, {
        newIcon: $2323c29b2979f232$var$_pullRequest.default
    }));
$2323c29b2979f232$var$BitbucketPullrequestsIcon.displayName = "BitbucketPullrequestsIcon";
var $2323c29b2979f232$var$_default = module.exports.default = $2323c29b2979f232$var$BitbucketPullrequestsIcon;

});
parcelRegister("66rW6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::21351e5a083835e13e3b37c073126aa9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4718f9258e8c93c3$var$_react = $4718f9258e8c93c3$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $4718f9258e8c93c3$var$_UNSAFE_baseNew = $4718f9258e8c93c3$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $4718f9258e8c93c3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PullRequest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4718f9258e8c93c3$var$PullRequestIcon = (props)=>/*#__PURE__*/ $4718f9258e8c93c3$var$_react.default.createElement($4718f9258e8c93c3$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 3.25h1.75a2 2 0 0 1 2 2v6m-7.5-6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 0v6.5m0 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm7.5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"/>`
    }, props));
$4718f9258e8c93c3$var$PullRequestIcon.displayName = "PullRequestIcon";
var $4718f9258e8c93c3$var$_default = module.exports.default = $4718f9258e8c93c3$var$PullRequestIcon;

});


parcelRegister("9fsw6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6bbba29daab651c9$var$_react = $6bbba29daab651c9$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $6bbba29daab651c9$var$_angleBrackets = $6bbba29daab651c9$var$_interopRequireDefault((parcelRequire("3bpTg")));
function $6bbba29daab651c9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6bbba29daab651c9$var$BitbucketReposIcon = (props)=>/*#__PURE__*/ $6bbba29daab651c9$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 5v14h14V5zm0-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/><path d="M9.23 8.31 6.3 11.26a1.06 1.06 0 0 0 0 1.48l2.93 2.96a1.03 1.03 0 0 0 1.47 0 1.05 1.05 0 0 0 0-1.48L8.5 12l2.2-2.22a1.05 1.05 0 0 0 0-1.48 1.02 1.02 0 0 0-.73-.3c-.27 0-.53.1-.73.31m4.06 0a1.05 1.05 0 0 0 0 1.48L15.5 12l-2.2 2.22a1.05 1.05 0 0 0 0 1.48c.4.41 1.06.41 1.46 0l2.93-2.95a1.05 1.05 0 0 0 0-1.48l-2.93-2.96a1.03 1.03 0 0 0-1.46 0"/></g></svg>`
    }, props, {
        newIcon: $6bbba29daab651c9$var$_angleBrackets.default
    }));
$6bbba29daab651c9$var$BitbucketReposIcon.displayName = "BitbucketReposIcon";
var $6bbba29daab651c9$var$_default = module.exports.default = $6bbba29daab651c9$var$BitbucketReposIcon;

});
parcelRegister("3bpTg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b4c96cb8810c24998853001387ebb87d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25167b77a81f01f7$var$_react = $25167b77a81f01f7$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $25167b77a81f01f7$var$_UNSAFE_baseNew = $25167b77a81f01f7$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $25167b77a81f01f7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25167b77a81f01f7$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $25167b77a81f01f7$var$_react.default.createElement($25167b77a81f01f7$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.5 8.75.75 6 4.5 3.25m7 4L15.25 10l-3.75 2.75M11 1.25l-6 13.5"/>`
    }, props));
$25167b77a81f01f7$var$AngleBracketsIcon.displayName = "AngleBracketsIcon";
var $25167b77a81f01f7$var$_default = module.exports.default = $25167b77a81f01f7$var$AngleBracketsIcon;

});


parcelRegister("gFhop", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c21df77cd961dae5$var$_react = $c21df77cd961dae5$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $c21df77cd961dae5$var$_snippet = $c21df77cd961dae5$var$_interopRequireDefault((parcelRequire("dUaRb")));
function $c21df77cd961dae5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c21df77cd961dae5$var$BitbucketSnippetsIcon = (props)=>/*#__PURE__*/ $c21df77cd961dae5$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M16 9c.8 0 1.6-.3 2.1-.9q.9-.9.9-2.1c0-.8-.3-1.6-.9-2.1-1.1-1.1-3.1-1.1-4.2 0-.6.5-.9 1.3-.9 2.1s.3 1.5.8 2L12 11.1 10.2 8c.5-.5.8-1.2.8-2s-.3-1.6-.9-2.1C9 2.7 7 2.7 5.9 3.9 5.3 4.4 5 5.2 5 6s.3 1.6.9 2.1Q6.8 9 8 9h.4l6.7 11.5c.2.3.5.5.9.5.2 0 .3 0 .5-.1.5-.3.6-.9.4-1.4l-3.7-6.4 2.4-4.2c.1.1.3.1.4.1M8.7 6.7c-.4.4-1 .4-1.4 0-.2-.2-.3-.4-.3-.7s.1-.5.3-.7.4-.3.7-.3.5.1.7.3.3.4.3.7-.1.5-.3.7m6.6-1.4c.2-.2.4-.3.7-.3s.5.1.7.3.3.4.3.7-.1.5-.3.7c-.4.4-1 .4-1.4 0-.2-.2-.3-.4-.3-.7s.1-.5.3-.7"/><path d="m10.3 14.1-3.1 5.4c-.3.5-.2 1.1.3 1.3.2.1.3.2.5.2.3 0 .7-.2.9-.5l2.6-4.4z"/></g></svg>`
    }, props, {
        newIcon: $c21df77cd961dae5$var$_snippet.default
    }));
$c21df77cd961dae5$var$BitbucketSnippetsIcon.displayName = "BitbucketSnippetsIcon";
var $c21df77cd961dae5$var$_default = module.exports.default = $c21df77cd961dae5$var$BitbucketSnippetsIcon;

});
parcelRegister("dUaRb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1b7e55d05f9d1ed74c4e2182d7f24ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1f8ed3e10b7bd50$var$_react = $a1f8ed3e10b7bd50$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $a1f8ed3e10b7bd50$var$_UNSAFE_baseNew = $a1f8ed3e10b7bd50$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $a1f8ed3e10b7bd50$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Snippet".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for snippets in Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1f8ed3e10b7bd50$var$SnippetIcon = (props)=>/*#__PURE__*/ $a1f8ed3e10b7bd50$var$_react.default.createElement($a1f8ed3e10b7bd50$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.75 14.665a2.5 2.5 0 0 1-3.407-.902L8 10.046l-2.343 3.717a2.5 2.5 0 1 1-.09-2.67l1.546-2.454.886-1.407H8L11.866 1.1l1.268.8-4.247 6.74 1.546 2.453a2.5 2.5 0 1 1 3.317 3.572m-6.637-8.84-.887 1.407-3.36-5.333 1.268-.8zM13 13.365a1 1 0 1 1-1-1.731 1 1 0 0 1 1 1.732M4.366 13a1 1 0 1 1-1.732-1 1 1 0 0 1 1.732 1" clip-rule="evenodd"/>`
    }, props));
$a1f8ed3e10b7bd50$var$SnippetIcon.displayName = "SnippetIcon";
var $a1f8ed3e10b7bd50$var$_default = module.exports.default = $a1f8ed3e10b7bd50$var$SnippetIcon;

});


parcelRegister("jqR9D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e259ad64f47e23e0$var$_react = $e259ad64f47e23e0$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $e259ad64f47e23e0$var$_dashboard = $e259ad64f47e23e0$var$_interopRequireDefault((parcelRequire("eckBY")));
function $e259ad64f47e23e0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e259ad64f47e23e0$var$DashboardIcon = (props)=>/*#__PURE__*/ $e259ad64f47e23e0$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0 1 20.01 20H3.99A1.994 1.994 0 0 1 2 18.006z"/><path d="M7 5v14h2V5z"/><path d="M7 11h14V9H7z"/></g></svg>`
    }, props, {
        newIcon: $e259ad64f47e23e0$var$_dashboard.default
    }));
$e259ad64f47e23e0$var$DashboardIcon.displayName = "DashboardIcon";
var $e259ad64f47e23e0$var$_default = module.exports.default = $e259ad64f47e23e0$var$DashboardIcon;

});
parcelRegister("eckBY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cf60205a3460556413b4bbe2c3cf4fed>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a5622cb670d6ad1e$var$_react = $a5622cb670d6ad1e$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $a5622cb670d6ad1e$var$_UNSAFE_baseNew = $a5622cb670d6ad1e$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $a5622cb670d6ad1e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Dashboard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a5622cb670d6ad1e$var$DashboardIcon = (props)=>/*#__PURE__*/ $a5622cb670d6ad1e$var$_react.default.createElement($a5622cb670d6ad1e$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 1.75H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h5m0-12.5h5c.69 0 1.25.56 1.25 1.25v5M8 1.75V8m0 6.25h5c.69 0 1.25-.56 1.25-1.25V8M8 14.25V8m0 0h6.25"/>`
    }, props));
$a5622cb670d6ad1e$var$DashboardIcon.displayName = "DashboardIcon";
var $a5622cb670d6ad1e$var$_default = module.exports.default = $a5622cb670d6ad1e$var$DashboardIcon;

});


parcelRegister("4TuTb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3904426c8bd8e0fb$var$_react = $3904426c8bd8e0fb$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $3904426c8bd8e0fb$var$_pages = $3904426c8bd8e0fb$var$_interopRequireDefault((parcelRequire("7D0OL")));
function $3904426c8bd8e0fb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3904426c8bd8e0fb$var$DocumentsIcon = (props)=>/*#__PURE__*/ $3904426c8bd8e0fb$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17H5V7h1V5H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1zm13-6.99V19H9V5h5.99v2.49a1.5 1.5 0 0 0 1.5 1.5h4.5v-.52c0-.3-.13-.58-.36-.77l-5.07-4.24c-.36-.3-.81-.46-1.28-.46H9a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8.99z"/></svg>`
    }, props, {
        newIcon: $3904426c8bd8e0fb$var$_pages.default
    }));
$3904426c8bd8e0fb$var$DocumentsIcon.displayName = "DocumentsIcon";
var $3904426c8bd8e0fb$var$_default = module.exports.default = $3904426c8bd8e0fb$var$DocumentsIcon;

});
parcelRegister("7D0OL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6fe29fb1fa71b460174eab4f230e9b47>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $58dccf51787d8dd6$var$_react = $58dccf51787d8dd6$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $58dccf51787d8dd6$var$_UNSAFE_baseNew = $58dccf51787d8dd6$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $58dccf51787d8dd6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $58dccf51787d8dd6$var$PagesIcon = (props)=>/*#__PURE__*/ $58dccf51787d8dd6$var$_react.default.createElement($58dccf51787d8dd6$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10 4.75H4m4.5 3H4m-1 4.5h8c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v8c0 .69.56 1.25 1.25 1.25Z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
    }, props));
$58dccf51787d8dd6$var$PagesIcon.displayName = "PagesIcon";
var $58dccf51787d8dd6$var$_default = module.exports.default = $58dccf51787d8dd6$var$PagesIcon;

});


parcelRegister("fAcOc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b584275786c8f7d1$var$_react = $b584275786c8f7d1$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $b584275786c8f7d1$var$_angleBrackets = $b584275786c8f7d1$var$_interopRequireDefault((parcelRequire("3bpTg")));
function $b584275786c8f7d1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b584275786c8f7d1$var$EditorCodeIcon = (props)=>/*#__PURE__*/ $b584275786c8f7d1$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M10.208 7.308a1.09 1.09 0 0 1 0 1.483l-3.515 3.71 3.515 3.708a1.09 1.09 0 0 1 0 1.483.957.957 0 0 1-1.405 0l-3.866-4.08a1.635 1.635 0 0 1 0-2.225l3.866-4.08a.957.957 0 0 1 1.405 0m3.584 0a.957.957 0 0 1 1.405 0l3.866 4.08c.583.614.583 1.61 0 2.225l-3.866 4.08a.957.957 0 0 1-1.405 0 1.09 1.09 0 0 1 0-1.484l3.515-3.708-3.515-3.71a1.09 1.09 0 0 1 0-1.483"/></svg>`
    }, props, {
        newIcon: $b584275786c8f7d1$var$_angleBrackets.default
    }));
$b584275786c8f7d1$var$EditorCodeIcon.displayName = "EditorCodeIcon";
var $b584275786c8f7d1$var$_default = module.exports.default = $b584275786c8f7d1$var$EditorCodeIcon;

});

parcelRegister("3d0NI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2563350a6c5370ce$var$_react = $2563350a6c5370ce$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $2563350a6c5370ce$var$_file = $2563350a6c5370ce$var$_interopRequireDefault((parcelRequire("gKcHx")));
function $2563350a6c5370ce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2563350a6c5370ce$var$FileIcon = (props)=>/*#__PURE__*/ $2563350a6c5370ce$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M17 10.005V19H7V5h5.99v2.49a1.5 1.5 0 0 0 1.5 1.5h4.5v-.522c0-.297-.132-.578-.359-.768l-5.074-4.236c-.36-.3-.813-.464-1.282-.464H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8.995z"/><rect width="8" height="2" x="8" y="12" rx="1"/><rect width="4" height="2" x="8" y="15" rx="1"/></g></svg>`
    }, props, {
        newIcon: $2563350a6c5370ce$var$_file.default
    }));
$2563350a6c5370ce$var$FileIcon.displayName = "FileIcon";
var $2563350a6c5370ce$var$_default = module.exports.default = $2563350a6c5370ce$var$FileIcon;

});
parcelRegister("gKcHx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eb51c4d43dbcfeceb899912fc33494f6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c30acb6f11d7e5dd$var$_react = $c30acb6f11d7e5dd$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $c30acb6f11d7e5dd$var$_UNSAFE_baseNew = $c30acb6f11d7e5dd$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $c30acb6f11d7e5dd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c30acb6f11d7e5dd$var$FileIcon = (props)=>/*#__PURE__*/ $c30acb6f11d7e5dd$var$_react.default.createElement($c30acb6f11d7e5dd$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 5.25V14c0 .69-.56 1.25-1.25 1.25H4c-.69 0-1.25-.56-1.25-1.25V2c0-.69.56-1.25 1.25-1.25h4.75m4.5 4.5h-4.5V.75m4.5 4.5c0-.32-.127-.627-.354-.854L9.604 1.104A1.2 1.2 0 0 0 8.75.75"/>`
    }, props));
$c30acb6f11d7e5dd$var$FileIcon.displayName = "FileIcon";
var $c30acb6f11d7e5dd$var$_default = module.exports.default = $c30acb6f11d7e5dd$var$FileIcon;

});


parcelRegister("15uq9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0caddb01a87c040f$var$_react = $0caddb01a87c040f$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $0caddb01a87c040f$var$_folderClosed = $0caddb01a87c040f$var$_interopRequireDefault((parcelRequire("5AOzO")));
function $0caddb01a87c040f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $0caddb01a87c040f$var$FolderIcon = (props)=>/*#__PURE__*/ $0caddb01a87c040f$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M20 19V8h-9.154l-.503-1.258-.455-1.136C9.778 5.33 9.291 5 9.003 5H3.997C4.002 5 4 19 4 19zM12.2 6h7.809C21.109 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.991 1.992H3.991C2.891 21 2 20.107 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862z"/></svg>`
    }, props, {
        newIcon: $0caddb01a87c040f$var$_folderClosed.default
    }));
$0caddb01a87c040f$var$FolderIcon.displayName = "FolderIcon";
var $0caddb01a87c040f$var$_default = module.exports.default = $0caddb01a87c040f$var$FolderIcon;

});
parcelRegister("5AOzO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d2e1f2a5ac4d58edbb705d97e3e46bc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $41278c04f052182c$var$_react = $41278c04f052182c$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $41278c04f052182c$var$_UNSAFE_baseNew = $41278c04f052182c$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $41278c04f052182c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "FolderClosed".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $41278c04f052182c$var$FolderClosedIcon = (props)=>/*#__PURE__*/ $41278c04f052182c$var$_react.default.createElement($41278c04f052182c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h3.25L8 3.5h5c.69 0 1.25.56 1.25 1.25v2m-12.5 0h12.5"/>`
    }, props));
$41278c04f052182c$var$FolderClosedIcon.displayName = "FolderClosedIcon";
var $41278c04f052182c$var$_default = module.exports.default = $41278c04f052182c$var$FolderClosedIcon;

});


parcelRegister("6FdDl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4da125c402bd8c6b$var$_react = $4da125c402bd8c6b$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $4da125c402bd8c6b$var$_personOffboard = $4da125c402bd8c6b$var$_interopRequireDefault((parcelRequire("bs2BM")));
function $4da125c402bd8c6b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $4da125c402bd8c6b$var$FollowersIcon = (props)=>/*#__PURE__*/ $4da125c402bd8c6b$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M5 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="11" cy="7" r="4"/><path fill-rule="nonzero" d="M17.293 9.293a1 1 0 1 0 1.414 1.414l1.996-1.996a1 1 0 0 0 0-1.422l-1.996-1.996a1 1 0 0 0-1.414 1.414L18.586 8z"/></g></svg>`
    }, props, {
        newIcon: $4da125c402bd8c6b$var$_personOffboard.default
    }));
$4da125c402bd8c6b$var$FollowersIcon.displayName = "FollowersIcon";
var $4da125c402bd8c6b$var$_default = module.exports.default = $4da125c402bd8c6b$var$FollowersIcon;

});
parcelRegister("bs2BM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b6022c9ffb5d557d7df4e0fddd84c372>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8564552de036bfe6$var$_react = $8564552de036bfe6$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $8564552de036bfe6$var$_UNSAFE_baseNew = $8564552de036bfe6$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $8564552de036bfe6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PersonOffboard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/core/person-offboard
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8564552de036bfe6$var$PersonOffboardIcon = (props)=>/*#__PURE__*/ $8564552de036bfe6$var$_react.default.createElement($8564552de036bfe6$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 15v-2.25a3 3 0 0 1 3-3h2.5a3 3 0 0 1 3 3V15M9 8h6.25m-7-4a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Zm3.5.5 3.5 3.5-3.5 3.5"/>`
    }, props));
$8564552de036bfe6$var$PersonOffboardIcon.displayName = "PersonOffboardIcon";
var $8564552de036bfe6$var$_default = module.exports.default = $8564552de036bfe6$var$PersonOffboardIcon;

});


parcelRegister("djbxR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $028018cba2b2003c$var$_react = $028018cba2b2003c$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");
function $028018cba2b2003c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $028018cba2b2003c$var$FollowingIcon = (props)=>/*#__PURE__*/ $028018cba2b2003c$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M20.99 6a.98.98 0 0 1-.29.7l-1.33 1.27 1.28 1.3a.98.98 0 0 1-.41 1.7.99.99 0 0 1-.98-.32l-1.98-1.97a.98.98 0 0 1 0-1.39l2.04-2.03a.99.99 0 0 1 1.08-.19c.37.16.6.52.59.92M5 14c0-1.1.9-2 2.01-2h7.98c1.11 0 2.01.89 2.01 2.01v4.44c0 3.41-12 3.41-12 0z"/><circle cx="11" cy="7" r="4"/></g></svg>`
    }, props));
$028018cba2b2003c$var$FollowingIcon.displayName = "FollowingIcon";
var $028018cba2b2003c$var$_default = module.exports.default = $028018cba2b2003c$var$FollowingIcon;

});

parcelRegister("5n3Yp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e922ec312a39448$var$_react = $3e922ec312a39448$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $3e922ec312a39448$var$_chartTrend = $3e922ec312a39448$var$_interopRequireDefault((parcelRequire("hNECm")));
function $3e922ec312a39448$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3e922ec312a39448$var$GraphLineIcon = (props)=>/*#__PURE__*/ $3e922ec312a39448$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M21 17H5c-.55 0-1-.45-1-1.01V6a1 1 0 1 0-2 0v9.99A3 3 0 0 0 5 19h16a1 1 0 0 0 0-2m-3-8v3a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="M13.293 13.707a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L14 11.586l-2.293-2.293a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L11 11.414z"/></g></svg>`
    }, props, {
        newIcon: $3e922ec312a39448$var$_chartTrend.default
    }));
$3e922ec312a39448$var$GraphLineIcon.displayName = "GraphLineIcon";
var $3e922ec312a39448$var$_default = module.exports.default = $3e922ec312a39448$var$GraphLineIcon;

});
parcelRegister("hNECm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cdb1ccac2bef0b462eb765c5c5d4b174>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf56851e57471de6$var$_react = $cf56851e57471de6$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $cf56851e57471de6$var$_UNSAFE_baseNew = $cf56851e57471de6$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $cf56851e57471de6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChartTrend".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cf56851e57471de6$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $cf56851e57471de6$var$_react.default.createElement($cf56851e57471de6$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 1v9.75M15 14.25H3c-.69 0-1.25-.56-1.25-1.25v-2.25m12.5-8L8.5 8.5 6.25 6.25l-4.5 4.5"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M14.25 7V2.75H10"/>`
    }, props));
$cf56851e57471de6$var$ChartTrendIcon.displayName = "ChartTrendIcon";
var $cf56851e57471de6$var$_default = module.exports.default = $cf56851e57471de6$var$ChartTrendIcon;

});


parcelRegister("9KAD5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7194d2c001d57cc1$var$_react = $7194d2c001d57cc1$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $7194d2c001d57cc1$var$_image = $7194d2c001d57cc1$var$_interopRequireDefault((parcelRequire("e0fZO")));
function $7194d2c001d57cc1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7194d2c001d57cc1$var$ImageIcon = (props)=>/*#__PURE__*/ $7194d2c001d57cc1$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M3 4.995C3 3.893 3.893 3 4.995 3h14.01C20.107 3 21 3.893 21 4.995v14.01A1.995 1.995 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.005zM10.5 16.5 9 15l-3 3h12v-2.7L15 12zM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props, {
        newIcon: $7194d2c001d57cc1$var$_image.default
    }));
$7194d2c001d57cc1$var$ImageIcon.displayName = "ImageIcon";
var $7194d2c001d57cc1$var$_default = module.exports.default = $7194d2c001d57cc1$var$ImageIcon;

});
parcelRegister("e0fZO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::34cce0e65d0b47ff66878c07e93619ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a31d7939841198f1$var$_react = $a31d7939841198f1$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $a31d7939841198f1$var$_UNSAFE_baseNew = $a31d7939841198f1$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $a31d7939841198f1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Image".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: images, image upload.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a31d7939841198f1$var$ImageIcon = (props)=>/*#__PURE__*/ $a31d7939841198f1$var$_react.default.createElement($a31d7939841198f1$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.75 5.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path fill="currentcolor" fill-rule="evenodd" d="M5.75 6.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 14.25h9c.69 0 1.25-.56 1.25-1.25v-2M4 14.25H3c-.69 0-1.25-.56-1.25-1.25V3c0-.69.56-1.25 1.25-1.25h10c.69 0 1.25.56 1.25 1.25v8M4 14.25 10 7l4.25 4m-7.5-5.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"/>`
    }, props));
$a31d7939841198f1$var$ImageIcon.displayName = "ImageIcon";
var $a31d7939841198f1$var$_default = module.exports.default = $a31d7939841198f1$var$ImageIcon;

});


parcelRegister("8Th8r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6790c071d68f702a$var$_react = $6790c071d68f702a$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $6790c071d68f702a$var$_issues = $6790c071d68f702a$var$_interopRequireDefault((parcelRequire("4Ez9l")));
function $6790c071d68f702a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6790c071d68f702a$var$IssuesIcon = (props)=>/*#__PURE__*/ $6790c071d68f702a$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 12.99C5 13 19.01 13 19.01 13 19 13 19 5.01 19 5.01 19 5 5 5 5 5zM3 5.01C3 3.9 3.89 3 5 3h14.01A2 2 0 0 1 21 5.01v7.98A2 2 0 0 1 19.01 15H5a2 2 0 0 1-2-2.01zM19 19c0 1.11-.9 2-2.01 2H7.01A2.01 2.01 0 0 1 5 19zm1-3a2 2 0 0 1-1.99 2H5.99A2 2 0 0 1 4 16z"/><path d="M10.674 11.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3z"/></g></svg>`
    }, props, {
        newIcon: $6790c071d68f702a$var$_issues.default
    }));
$6790c071d68f702a$var$IssuesIcon.displayName = "IssuesIcon";
var $6790c071d68f702a$var$_default = module.exports.default = $6790c071d68f702a$var$IssuesIcon;

});
parcelRegister("4Ez9l", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e20942f1753dfd935ace3c7a2abdb1b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $363629dff2646557$var$_react = $363629dff2646557$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $363629dff2646557$var$_UNSAFE_baseNew = $363629dff2646557$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $363629dff2646557$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Issues".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multiple issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $363629dff2646557$var$IssuesIcon = (props)=>/*#__PURE__*/ $363629dff2646557$var$_react.default.createElement($363629dff2646557$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.125 7 1.583 1.875 3.167-3.75M.75 10V4c0-.69.56-1.25 1.25-1.25h9c.69 0 1.25.56 1.25 1.25v6c0 .69-.56 1.25-1.25 1.25H2c-.69 0-1.25-.56-1.25-1.25Z"/><path stroke="currentcolor" stroke-width="1.5" d="M5 14.25h7.75a2.5 2.5 0 0 0 2.5-2.5V7"/>`
    }, props));
$363629dff2646557$var$IssuesIcon.displayName = "IssuesIcon";
var $363629dff2646557$var$_default = module.exports.default = $363629dff2646557$var$IssuesIcon;

});


parcelRegister("56TV6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b88e3d72098af60$var$_react = $3b88e3d72098af60$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $3b88e3d72098af60$var$_lockLocked = $3b88e3d72098af60$var$_interopRequireDefault((parcelRequire("h2H8c")));
function $3b88e3d72098af60$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3b88e3d72098af60$var$LockIcon = (props)=>/*#__PURE__*/ $3b88e3d72098af60$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props, {
        newIcon: $3b88e3d72098af60$var$_lockLocked.default
    }));
$3b88e3d72098af60$var$LockIcon.displayName = "LockIcon";
var $3b88e3d72098af60$var$_default = module.exports.default = $3b88e3d72098af60$var$LockIcon;

});
parcelRegister("h2H8c", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1d1b3dafeedb3bcbc92be5929839e615>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c68414902ee81d06$var$_react = $c68414902ee81d06$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $c68414902ee81d06$var$_UNSAFE_baseNew = $c68414902ee81d06$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $c68414902ee81d06$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c68414902ee81d06$var$LockLockedIcon = (props)=>/*#__PURE__*/ $c68414902ee81d06$var$_react.default.createElement($c68414902ee81d06$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.75 7.75H4c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25h-.75m-6.5 0V4a3.25 3.25 0 1 1 6.5 0v3.75m-6.5 0h6.5M8 10v3"/>`
    }, props));
$c68414902ee81d06$var$LockLockedIcon.displayName = "LockLockedIcon";
var $c68414902ee81d06$var$_default = module.exports.default = $c68414902ee81d06$var$LockLockedIcon;

});


parcelRegister("4TH54", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $390db765f5e8d992$var$_react = $390db765f5e8d992$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $390db765f5e8d992$var$_marketplace = $390db765f5e8d992$var$_interopRequireDefault((parcelRequire("abhD9")));
function $390db765f5e8d992$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $390db765f5e8d992$var$MarketplaceIcon = (props)=>/*#__PURE__*/ $390db765f5e8d992$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4 11h2v5H4zm.56-7.11C4.8 3.4 5.45 3 6.01 3H18c.56 0 1.21.4 1.45.89L21 7H3zM3 7h18v1H3zm15 4h2v5h-2zM3 8c.14 1.13 1.09 2 2.25 2s2.11-.87 2.25-2zm4.5 0c.14 1.13 1.09 2 2.25 2s2.11-.87 2.25-2zM12 8c.14 1.13 1.09 2 2.25 2s2.11-.87 2.25-2zm4.5 0c.14 1.13 1.09 2 2.25 2s2.11-.87 2.25-2zM4 16h16v3a2 2 0 0 1-1.99 2H5.99A2 2 0 0 1 4 19z"/></svg>`
    }, props, {
        newIcon: $390db765f5e8d992$var$_marketplace.default
    }));
$390db765f5e8d992$var$MarketplaceIcon.displayName = "MarketplaceIcon";
var $390db765f5e8d992$var$_default = module.exports.default = $390db765f5e8d992$var$MarketplaceIcon;

});
parcelRegister("abhD9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0eb691c8c2ea248f4cc86c0a85b9cbcc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76989b84b8d51d00$var$_react = $76989b84b8d51d00$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $76989b84b8d51d00$var$_UNSAFE_baseNew = $76989b84b8d51d00$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $76989b84b8d51d00$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Marketplace".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Marketplace.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76989b84b8d51d00$var$MarketplaceIcon = (props)=>/*#__PURE__*/ $76989b84b8d51d00$var$_react.default.createElement($76989b84b8d51d00$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.167 1.75H2.5L1.25 5.5m4.917-3.75h3.666m-3.666 0-.5 4.5m4.166-4.5H13.5l1.251 3.75M9.833 1.75l.5 4.5m0 0a2.334 2.334 0 1 1-4.667 0m4.668 0a2.334 2.334 0 0 0 2.916 2.26M5.666 6.25A2.334 2.334 0 0 1 2.75 8.51m10.5 0a2.335 2.335 0 0 0 1.751-2.26l-.25-.75M13.25 8.51V13c0 .69-.56 1.25-1.25 1.25H4c-.69 0-1.25-.56-1.25-1.25V8.51m0 0A2.335 2.335 0 0 1 1 6.25l.25-.75m0 0h13.5"/>`
    }, props));
$76989b84b8d51d00$var$MarketplaceIcon.displayName = "MarketplaceIcon";
var $76989b84b8d51d00$var$_default = module.exports.default = $76989b84b8d51d00$var$MarketplaceIcon;

});


parcelRegister("bM5vQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8928741a188cf89e$var$_react = $8928741a188cf89e$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $8928741a188cf89e$var$_page = $8928741a188cf89e$var$_interopRequireDefault((parcelRequire("loO60")));
function $8928741a188cf89e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $8928741a188cf89e$var$PageIcon = (props)=>/*#__PURE__*/ $8928741a188cf89e$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="8" height="2" x="8" y="9" rx="1"/><rect width="4" height="2" x="8" y="12" rx="1"/><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/></g></svg>`
    }, props, {
        newIcon: $8928741a188cf89e$var$_page.default
    }));
$8928741a188cf89e$var$PageIcon.displayName = "PageIcon";
var $8928741a188cf89e$var$_default = module.exports.default = $8928741a188cf89e$var$PageIcon;

});
parcelRegister("loO60", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cab2bd3bf7f5b1e2b2df4de8af9192f9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f942b2e136c885f8$var$_react = $f942b2e136c885f8$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $f942b2e136c885f8$var$_UNSAFE_baseNew = $f942b2e136c885f8$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $f942b2e136c885f8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f942b2e136c885f8$var$PageIcon = (props)=>/*#__PURE__*/ $f942b2e136c885f8$var$_react.default.createElement($f942b2e136c885f8$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 5.25h8m-8 3.5h6m-7 5.5h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25Z"/>`
    }, props));
$f942b2e136c885f8$var$PageIcon.displayName = "PageIcon";
var $f942b2e136c885f8$var$_default = module.exports.default = $f942b2e136c885f8$var$PageIcon;

});


parcelRegister("lDQSw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc1642040c659c27$var$_react = $fc1642040c659c27$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $fc1642040c659c27$var$_peopleGroup = $fc1642040c659c27$var$_interopRequireDefault((parcelRequire("jPVaQ")));
function $fc1642040c659c27$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $fc1642040c659c27$var$PeopleIcon = (props)=>/*#__PURE__*/ $fc1642040c659c27$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
    }, props, {
        newIcon: $fc1642040c659c27$var$_peopleGroup.default
    }));
$fc1642040c659c27$var$PeopleIcon.displayName = "PeopleIcon";
var $fc1642040c659c27$var$_default = module.exports.default = $fc1642040c659c27$var$PeopleIcon;

});

parcelRegister("bZ6on", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b9a5995bbe5979a$var$_react = $8b9a5995bbe5979a$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $8b9a5995bbe5979a$var$_settings = $8b9a5995bbe5979a$var$_interopRequireDefault((parcelRequire("2CIgr")));
function $8b9a5995bbe5979a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $8b9a5995bbe5979a$var$SettingsIcon = (props)=>/*#__PURE__*/ $8b9a5995bbe5979a$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.701 16.7a5.002 5.002 0 1 1 0-10.003 5.002 5.002 0 0 1 0 10.004m8.368-3.117a1.995 1.995 0 0 1-1.346-1.885c0-.876.563-1.613 1.345-1.885a.48.48 0 0 0 .315-.574 9 9 0 0 0-.836-1.993.48.48 0 0 0-.598-.195 2.04 2.04 0 0 1-1.29.08 1.99 1.99 0 0 1-1.404-1.395 2.04 2.04 0 0 1 .076-1.297.48.48 0 0 0-.196-.597 9 9 0 0 0-1.975-.826.48.48 0 0 0-.574.314 1.995 1.995 0 0 1-1.885 1.346 1.99 1.99 0 0 1-1.884-1.345.48.48 0 0 0-.575-.315c-.708.2-1.379.485-2.004.842a.47.47 0 0 0-.198.582A2.002 2.002 0 0 1 4.445 7.06a.48.48 0 0 0-.595.196 9 9 0 0 0-.833 1.994.48.48 0 0 0 .308.572 1.995 1.995 0 0 1 1.323 1.877c0 .867-.552 1.599-1.324 1.877a.48.48 0 0 0-.308.57 9 9 0 0 0 .723 1.79.477.477 0 0 0 .624.194c.595-.273 1.343-.264 2.104.238.117.077.225.185.302.3.527.8.512 1.58.198 2.188a.473.473 0 0 0 .168.628 9 9 0 0 0 2.11.897.474.474 0 0 0 .57-.313 1.995 1.995 0 0 1 1.886-1.353c.878 0 1.618.567 1.887 1.353a.475.475 0 0 0 .57.313 9 9 0 0 0 2.084-.883.473.473 0 0 0 .167-.631c-.318-.608-.337-1.393.191-2.195.077-.116.185-.225.302-.302.772-.511 1.527-.513 2.125-.23a.477.477 0 0 0 .628-.19 9 9 0 0 0 .728-1.793.48.48 0 0 0-.314-.573"/></svg>`
    }, props, {
        newIcon: $8b9a5995bbe5979a$var$_settings.default
    }));
$8b9a5995bbe5979a$var$SettingsIcon.displayName = "SettingsIcon";
var $8b9a5995bbe5979a$var$_default = module.exports.default = $8b9a5995bbe5979a$var$SettingsIcon;

});
parcelRegister("2CIgr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2556fcac2d427bf2f1f588b9efde696>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e91774f1afda78e$var$_react = $1e91774f1afda78e$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $1e91774f1afda78e$var$_UNSAFE_baseNew = $1e91774f1afda78e$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $1e91774f1afda78e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1e91774f1afda78e$var$SettingsIcon = (props)=>/*#__PURE__*/ $1e91774f1afda78e$var$_react.default.createElement($1e91774f1afda78e$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75.75 5.687 3.302a.625.625 0 0 1-.667.378l-2.674-.388-1.25 2.166L2.72 7.625a.625.625 0 0 1 0 .75l-1.624 2.168 1.25 2.165 2.674-.388a.625.625 0 0 1 .667.378L6.75 15.25h2.5l1.063-2.552a.625.625 0 0 1 .667-.378l2.674.388 1.25-2.165-1.623-2.168a.625.625 0 0 1 0-.75l1.623-2.167-1.25-2.166-2.674.388a.625.625 0 0 1-.667-.378L9.25.75z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.25 8a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"/>`
    }, props));
$1e91774f1afda78e$var$SettingsIcon.displayName = "SettingsIcon";
var $1e91774f1afda78e$var$_default = module.exports.default = $1e91774f1afda78e$var$SettingsIcon;

});


parcelRegister("cpPAg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $909fd556112a9476$var$_react = $909fd556112a9476$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $909fd556112a9476$var$_task = $909fd556112a9476$var$_interopRequireDefault((parcelRequire("93YaI")));
function $909fd556112a9476$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $909fd556112a9476$var$TaskIcon = (props)=>/*#__PURE__*/ $909fd556112a9476$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.994.994 0 0 1 3 20.007zM5 5v14h14V5z"/><path fill-rule="nonzero" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $909fd556112a9476$var$_task.default
    }));
$909fd556112a9476$var$TaskIcon.displayName = "TaskIcon";
var $909fd556112a9476$var$_default = module.exports.default = $909fd556112a9476$var$TaskIcon;

});
parcelRegister("93YaI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::221d4fd0f476bafdec4901e78789076d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $699311c1225f8166$var$_react = $699311c1225f8166$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $699311c1225f8166$var$_UNSAFE_baseNew = $699311c1225f8166$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $699311c1225f8166$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $699311c1225f8166$var$TaskIcon = (props)=>/*#__PURE__*/ $699311c1225f8166$var$_react.default.createElement($699311c1225f8166$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.25 8 2.5 3 5-6M3 14.25h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25Z"/>`
    }, props));
$699311c1225f8166$var$TaskIcon.displayName = "TaskIcon";
var $699311c1225f8166$var$_default = module.exports.default = $699311c1225f8166$var$TaskIcon;

});


parcelRegister("91UEL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $693027dfdd158ce4$var$_react = $693027dfdd158ce4$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $693027dfdd158ce4$var$_inbox = $693027dfdd158ce4$var$_interopRequireDefault((parcelRequire("ce7x3")));
function $693027dfdd158ce4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $693027dfdd158ce4$var$TrayIcon = (props)=>/*#__PURE__*/ $693027dfdd158ce4$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 19h14V5H5zM3 4.995C3 3.893 3.893 3 4.995 3h14.01C20.107 3 21 3.893 21 4.995v14.01A1.995 1.995 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.005z"/><path d="M9.17 17H4v1.5c0 .83.67 1.5 1.51 1.5H18.5a1.5 1.5 0 0 0 1.51-1.5V17h-5.17a3 3 0 0 1-5.66 0M7 12h10v2H7zm0-4h10v2H7z"/></g></svg>`
    }, props, {
        newIcon: $693027dfdd158ce4$var$_inbox.default
    }));
$693027dfdd158ce4$var$TrayIcon.displayName = "TrayIcon";
var $693027dfdd158ce4$var$_default = module.exports.default = $693027dfdd158ce4$var$TrayIcon;

});
parcelRegister("ce7x3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00b8efd594b5c299a036654902919c99>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8e6ca2963f75d604$var$_react = $8e6ca2963f75d604$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $8e6ca2963f75d604$var$_UNSAFE_baseNew = $8e6ca2963f75d604$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $8e6ca2963f75d604$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Inbox".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: 'Your work' in Confluence, inbox, mail.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8e6ca2963f75d604$var$InboxIcon = (props)=>/*#__PURE__*/ $8e6ca2963f75d604$var$_react.default.createElement($8e6ca2963f75d604$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 8.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V8.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h10c.69 0 1.25.56 1.25 1.25v5.75m-12.5 0H5.5a2.5 2.5 0 0 0 5 0h3.75M4 5.25h8"/>`
    }, props));
$8e6ca2963f75d604$var$InboxIcon.displayName = "InboxIcon";
var $8e6ca2963f75d604$var$_default = module.exports.default = $8e6ca2963f75d604$var$InboxIcon;

});


parcelRegister("kmdgX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ed20285b8bcc873d$var$_react = $ed20285b8bcc873d$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $ed20285b8bcc873d$var$_globe = $ed20285b8bcc873d$var$_interopRequireDefault((parcelRequire("3jez5")));
function $ed20285b8bcc873d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ed20285b8bcc873d$var$WorldIcon = (props)=>/*#__PURE__*/ $ed20285b8bcc873d$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m-.9-1.863A7.19 7.19 0 0 1 4.8 12c0-.558.072-1.089.189-1.611L9.3 14.7v.9c0 .99.81 1.8 1.8 1.8zm6.21-2.286A1.79 1.79 0 0 0 15.6 15.6h-.9v-2.7c0-.495-.405-.9-.9-.9H8.4v-1.8h1.8c.495 0 .9-.405.9-.9V7.5h1.8c.99 0 1.8-.81 1.8-1.8v-.369c2.637 1.071 4.5 3.654 4.5 6.669 0 1.872-.72 3.573-1.89 4.851"/></svg>`
    }, props, {
        newIcon: $ed20285b8bcc873d$var$_globe.default
    }));
$ed20285b8bcc873d$var$WorldIcon.displayName = "WorldIcon";
var $ed20285b8bcc873d$var$_default = module.exports.default = $ed20285b8bcc873d$var$WorldIcon;

});
parcelRegister("3jez5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e6493d78b1774dadc84e090bf21d843a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $268e71be38926ff3$var$_react = $268e71be38926ff3$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $268e71be38926ff3$var$_UNSAFE_baseNew = $268e71be38926ff3$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $268e71be38926ff3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Globe".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: public link in Confluence share dialog, global rules in Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $268e71be38926ff3$var$GlobeIcon = (props)=>/*#__PURE__*/ $268e71be38926ff3$var$_react.default.createElement($268e71be38926ff3$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 8A7.25 7.25 0 0 1 8 15.25M15.25 8A7.25 7.25 0 0 0 8 .75M15.25 8H.75M8 15.25A7.25 7.25 0 0 1 .75 8M8 15.25c1.657 0 3-3.246 3-7.25S9.657.75 8 .75m0 14.5c-1.657 0-3-3.246-3-7.25S6.343.75 8 .75M.75 8A7.25 7.25 0 0 1 8 .75"/>`
    }, props));
$268e71be38926ff3$var$GlobeIcon.displayName = "GlobeIcon";
var $268e71be38926ff3$var$_default = module.exports.default = $268e71be38926ff3$var$GlobeIcon;

});


parcelRegister("hWEfu", function(module, exports) {

$parcel$export(module.exports, "JiraIcon", function () { return $d10713056ee41427$export$c4b5b1f965d8b3eb; });
/* eslint-disable max-len */ 
var $9nHZC = parcelRequire("9nHZC");

var $4ul5V = parcelRequire("4ul5V");

var $dEQSq = parcelRequire("dEQSq");

var $j9Cxp = parcelRequire("j9Cxp");

var $gb0Xp = parcelRequire("gb0Xp");

var $EMAbO = parcelRequire("EMAbO");

var $k5A1i = parcelRequire("k5A1i");
var $d10713056ee41427$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconGradientStart = _ref.iconGradientStart, iconGradientStop = _ref.iconGradientStop, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor
    };
    if ((0, $dEQSq.getBooleanFF)("platform.design-system-team.brand-refresh-update-product-logos_q7coo")) {
        if (appearance) colors = (0, $EMAbO.getColorsFromAppearance)(appearance, colorMode);
        return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>\n    </svg>');
    } else {
        // Will be fixed upon removal of deprecated iconGradientStart and
        // iconGradientStop props, or with React 18's useId() hook when we update.
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        var id = (0, $4ul5V.uid)({
            iconGradientStart: iconGradientStop
        });
        if (appearance) colors = (0, $EMAbO.getColorsFromAppearanceOldLogos)(appearance);
        return '<svg viewBox="0 0 32 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">\n      <defs>\n        <linearGradient x1="94.092%" x2="56.535%" y1="6.033%" y2="43.087%" id="'.concat(id, '">\n          <stop stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' offset="18%"></stop>\n          <stop stop-color="').concat(colors.iconGradientStop, '" offset="100%"></stop>\n        </linearGradient>\n      </defs>\n      <g stroke="none" stroke-width="1" fill-rule="nonzero">\n        <path fill="').concat(colors.iconColor, '" d="M26.0406546,5 L14.9983562,5 C14.9983562,6.32163748 15.5233746,7.58914413 16.4579134,8.52368295 C17.3924523,9.45822178 18.6599589,9.98324022 19.9815964,9.98324022 L22.0151159,9.98324022 L22.0151159,11.9465283 C22.0168782,14.6974491 24.2474348,16.9265768 26.9983562,16.9265762 L26.9983562,5.95770152 C26.9983562,5.42877757 26.5695786,5 26.0406546,5 Z"></path>\n        <path fill="url(#').concat(id, ')" d="M20.0420436,11 L9,11 C9.00176139,13.7504065 11.2309666,15.9796117 13.9813731,15.9813731 L16.0154337,15.9813731 L16.0154337,17.9451836 C16.0154337,19.2671728 16.5405919,20.5350167 17.4753794,21.4698042 C18.4101669,22.4045917 19.6780108,22.9297499 21,22.9297499 L21,11.9579564 C21,11.4288917 20.5711083,11 20.0420436,11 Z"></path>\n        <path fill="url(#').concat(id, ')" d="M14.0420436,17 L3,17 C3.00176275,19.7516528 5.23291286,21.9813736 7.98456626,21.9813731 L10.0250133,21.9813731 L10.0250133,23.9451836 C10.0250082,26.6943468 12.2508419,28.9244664 15,28.9297499 L15,17.9579564 C15,17.4288917 14.5711083,17 14.0420436,17 Z"></path>\n      </g>\n    </svg>');
    }
};
var $d10713056ee41427$export$c4b5b1f965d8b3eb = function JiraIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $gb0Xp.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $gb0Xp.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $gb0Xp.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$iconGradientSta = _ref2.iconGradientStart, iconGradientStart = _ref2$iconGradientSta === void 0 ? (0, $gb0Xp.defaultLogoParams).iconGradientStart : _ref2$iconGradientSta, _ref2$iconGradientSto = _ref2.iconGradientStop, iconGradientStop = _ref2$iconGradientSto === void 0 ? (0, $gb0Xp.defaultLogoParams).iconGradientStop : _ref2$iconGradientSto;
    var _useThemeObserver = (0, $j9Cxp.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $k5A1i.default), {
        appearance: appearance,
        label: label,
        svg: $d10713056ee41427$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("j9Cxp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df1cc066c3ea2148$export$2e2bcd8739ae039; });

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $fMSHR = parcelRequire("fMSHR");

var $hDJIH = parcelRequire("hDJIH");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $df1cc066c3ea2148$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $9nHZC.useState)((0, $fMSHR.default)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $9nHZC.useEffect)(function() {
        var observer = new (0, $hDJIH.default)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $df1cc066c3ea2148$export$2e2bcd8739ae039 = $df1cc066c3ea2148$var$useThemeObserver;

});
parcelRegister("hDJIH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd798b315a4f6c36$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");

var $xbX1J = parcelRequire("xbX1J");

var $fMSHR = parcelRequire("fMSHR");
/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $cd798b315a4f6c36$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $fMSHR.default)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $xbX1J.THEME_DATA_ATTRIBUTE),
                            (0, $xbX1J.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
    return ThemeMutationObserver;
}();
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($cd798b315a4f6c36$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($cd798b315a4f6c36$export$2e2bcd8739ae039, "callbacks", new Set());

});



parcelRegister("lzz9d", function(module, exports) {

$parcel$export(module.exports, "ForgeModuleIcon", function () { return (parcelRequire("fzQ8V")).ForgeModuleIcon; });

var $fzQ8V = parcelRequire("fzQ8V");

});
parcelRegister("fzQ8V", function(module, exports) {

$parcel$export(module.exports, "ForgeModuleIcon", function () { return $c687a371df3d2275$export$4de55a89d11ce84; });

var $2xJU3 = parcelRequire("2xJU3");

var $9nHZC = parcelRequire("9nHZC");

var $7uSZr = parcelRequire("7uSZr");

var $h39Sh = parcelRequire("h39Sh");
const $c687a371df3d2275$var$IconImg = (0, $2xJU3.default)("img", {
    target: "esfft0m0"
})({
    height: (0, $h39Sh.default)("space.300", "24px"),
    width: (0, $h39Sh.default)("space.300", "24px")
}, "");
function $c687a371df3d2275$export$4de55a89d11ce84({ iconUrl: iconUrl }) {
    const [customIcon, setCustomIcon] = (0, $9nHZC.useState)(iconUrl);
    if (customIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($c687a371df3d2275$var$IconImg, {
        src: customIcon,
        onError: ()=>setCustomIcon(undefined),
        alt: "",
        role: "presentation"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7uSZr))), {
        label: "",
        size: "medium"
    });
}

});
parcelRegister("7uSZr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5755fd9933613093$var$_react = $5755fd9933613093$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $5755fd9933613093$var$_app = $5755fd9933613093$var$_interopRequireDefault((parcelRequire("jvmWK")));
function $5755fd9933613093$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $5755fd9933613093$var$AddonIcon = (props)=>/*#__PURE__*/ $5755fd9933613093$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m5.376 6.455 5.248-3.104c.792-.469 1.963-.467 2.752 0l5.248 3.104C19.416 6.923 20 7.962 20 8.895v6.21c0 .936-.587 1.973-1.376 2.44l-5.248 3.104c-.792.469-1.963.467-2.752 0l-5.248-3.104C4.584 17.077 4 16.038 4 15.105v-6.21c0-.936.587-1.973 1.376-2.44m6.99-1.314c-.165-.098-.566-.098-.733 0L6.385 8.245c-.166.098-.367.454-.367.65v6.21c0 .195.2.551.367.65l5.248 3.104c.166.098.567.098.734 0l5.248-3.104c.166-.098.367-.454.367-.65v-6.21c0-.195-.2-.551-.367-.65z"/><path d="M12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></g></svg>`
    }, props, {
        newIcon: $5755fd9933613093$var$_app.default
    }));
$5755fd9933613093$var$AddonIcon.displayName = "AddonIcon";
var $5755fd9933613093$var$_default = module.exports.default = $5755fd9933613093$var$AddonIcon;

});
parcelRegister("jvmWK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::31337633aba6a2557151320fbcdb47a4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e332b64ba3c58965$var$_react = $e332b64ba3c58965$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $e332b64ba3c58965$var$_UNSAFE_baseNew = $e332b64ba3c58965$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $e332b64ba3c58965$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "App".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for marketplace apps and integrations across products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e332b64ba3c58965$var$AppIcon = (props)=>/*#__PURE__*/ $e332b64ba3c58965$var$_react.default.createElement($e332b64ba3c58965$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2.357 4.136 5-3a1.25 1.25 0 0 1 1.286 0l5 3c.377.226.607.633.607 1.072v5.584c0 .44-.23.846-.607 1.072l-5 3a1.25 1.25 0 0 1-1.286 0l-5-3a1.25 1.25 0 0 1-.607-1.072V5.208c0-.44.23-.846.607-1.072Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.25 8a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"/>`
    }, props));
$e332b64ba3c58965$var$AppIcon.displayName = "AppIcon";
var $e332b64ba3c58965$var$_default = module.exports.default = $e332b64ba3c58965$var$AppIcon;

});




parcelRegister("lHcJV", function(module, exports) {
$parcel$export(module.exports, "IconSizes", function () { return (parcelRequire("iLMDI")).IconSizes; });

$parcel$export(module.exports, "CommentIcon", function () { return (parcelRequire("240Yy")).CommentIcon; });
$parcel$export(module.exports, "CompareIcon", function () { return (parcelRequire("exJiK")).CompareIcon; });
$parcel$export(module.exports, "DirectoryParentIcon", function () { return (parcelRequire("9pyjI")).DirectoryParentIcon; });
$parcel$export(module.exports, "BitbucketPrideIcon", function () { return (parcelRequire("cmQFd")).PrideIcon; });
$parcel$export(module.exports, "FileAddedIcon", function () { return (parcelRequire("lmoTm")).FileAddedIcon; });
$parcel$export(module.exports, "FileModifiedIcon", function () { return (parcelRequire("bYbic")).FileModifiedIcon; });
$parcel$export(module.exports, "FileRenamedIcon", function () { return (parcelRequire("27Btq")).FileRenamedIcon; });
$parcel$export(module.exports, "FileRemovedIcon", function () { return (parcelRequire("jnVZ7")).FileRemovedIcon; });
$parcel$export(module.exports, "SubmoduleIcon", function () { return (parcelRequire("c5vng")).SubmoduleIcon; });
$parcel$export(module.exports, "BlockerIcon", function () { return (parcelRequire("wj492")).BlockerIcon; });
$parcel$export(module.exports, "ShieldIcon", function () { return (parcelRequire("2bStf")).ShieldIcon; });

var $240Yy = parcelRequire("240Yy");

var $exJiK = parcelRequire("exJiK");

var $9pyjI = parcelRequire("9pyjI");

var $cmQFd = parcelRequire("cmQFd");

var $lmoTm = parcelRequire("lmoTm");

var $bYbic = parcelRequire("bYbic");

var $27Btq = parcelRequire("27Btq");

var $jnVZ7 = parcelRequire("jnVZ7");

var $bc1FU = parcelRequire("bc1FU");

var $j9Di9 = parcelRequire("j9Di9");

var $c5vng = parcelRequire("c5vng");

var $wj492 = parcelRequire("wj492");

var $2bStf = parcelRequire("2bStf");

var $e69v7 = parcelRequire("e69v7");
parcelRequire("iLMDI");

});
parcelRegister("240Yy", function(module, exports) {

$parcel$export(module.exports, "CommentIcon", function () { return $512fa2d13b3208cf$export$a3543c9c8473fb3d; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $57VDz = parcelRequire("57VDz");
// Inlining the SVG to manually change snake-case props to camelCase
// so React is happy (https://github.com/facebook/react/issues/2250).
// @ts-ignore TODO: fix noImplicitAny error here
const $512fa2d13b3208cf$var$glyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("svg", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        viewBox: "0 0 18 16",
        "aria-hidden": "true",
        focusable: "false"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        fill: "currentColor",
        d: "M1.99766939,7.5133308 C1.99766939,4.47515334 5.13900449,2.00275379 9.0004994,2.00275379 C12.8609955,2.00275379 16.0023306,4.47515334 16.0023306,7.5133308 C16.0023306,10.5515083 12.8609955,13.0239079 9.0004994,13.0239079 C5.13900449,13.0239079 1.99766939,10.5515083 1.99766939,7.5133308 Z M16.8373564,15.2840155 L16.8373564,15.2830141 L16.8373564,15.2820128 C16.8373564,15.2820128 15.2741801,13.0219051 16.0712502,12.1657279 L16.0342933,12.1857554 C17.2608623,10.9019902 18,9.2787583 18,7.5133308 C18,3.37063462 13.9627102,0 9.0004994,0 C4.03728983,0 0,3.37063462 0,7.5133308 C0,11.656027 4.03728983,15.0266617 9.0004994,15.0266617 C10.4208424,15.0266617 11.7602797,14.7422706 12.9568836,14.2505946 C13.9597137,15.2730004 15.2442151,15.8227563 16.1961045,15.9699587 L16.199101,15.9669546 C16.2510405,15.983978 16.3049775,16 16.3629099,16 C16.6475778,16 16.8773098,15.7686819 16.8773098,15.4832895 C16.8773098,15.4121918 16.8633261,15.3450995 16.8373564,15.2840155 Z"
    }));
const $512fa2d13b3208cf$export$a3543c9c8473fb3d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $57VDz.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        glyph: $512fa2d13b3208cf$var$glyph
    }));

});

parcelRegister("exJiK", function(module, exports) {

$parcel$export(module.exports, "CompareIcon", function () { return $cb30d8c7a61e0da5$export$200af911a2197e19; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $57VDz = parcelRequire("57VDz");
const $cb30d8c7a61e0da5$var$glyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("g", {
        fill: "currentColor",
        fillRule: "nonzero"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M8 17.867a5.867 5.867 0 1 0-.001-11.732A5.867 5.867 0 0 0 8 17.866zM8 20A8 8 0 1 1 8 4a8 8 0 0 1 0 16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M16 17.867a5.867 5.867 0 1 0-.001-11.735A5.867 5.867 0 0 0 16 17.867zM16 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"
    })));
const $cb30d8c7a61e0da5$export$200af911a2197e19 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $57VDz.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        glyph: $cb30d8c7a61e0da5$var$glyph
    }));

});

parcelRegister("9pyjI", function(module, exports) {

$parcel$export(module.exports, "DirectoryParentIcon", function () { return $024669fea62f080c$export$c453e9da65a3b2c; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $57VDz = parcelRequire("57VDz");
// Inlining the SVG to manually change snake-case props to camelCase
// so React is happy (https://github.com/facebook/react/issues/2250).
// @ts-ignore TODO: fix noImplicitAny error here
const $024669fea62f080c$var$glyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("svg", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        width: "19px",
        height: "14px",
        viewBox: "0 0 19 14",
        version: "1.1"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("g", {
        id: "Source-Folder-View",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("g", {
        transform: "translate(-401.000000, -408.000000)",
        id: "up-folder",
        fillRule: "nonzero",
        fill: "#42526E"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("g", {
        transform: "translate(401.000000, 408.000000)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M-1.523,6.5 C-2.063,6.5 -2.5,6.948 -2.5,7.5 C-2.5,8.051 -2.063,8.5 -1.523,8.5 L9.523,8.5 C10.062,8.5 10.5,8.051 10.5,7.5 C10.5,6.948 10.062,6.5 9.523,6.5 L-1.523,6.5 Z",
        id: "Clip-5-Copy",
        transform: "translate(4.000000, 7.500000) rotate(90.000000) translate(-4.000000, -7.500000) "
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M4.20246154,12 C3.53784615,12 3,12.448 3,13 C3,13.551 3.53784615,14 4.20246154,14 L17.7975385,14 C18.4609231,14 19,13.551 19,13 C19,12.448 18.4609231,12 17.7975385,12 L4.20246154,12 Z",
        id: "Clip-5-Copy",
        transform: "translate(11.000000, 13.000000) rotate(-180.000000) translate(-11.000000, -13.000000) "
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M4.731375,-1.193875 L1.801375,1.762125 C1.399375,2.170125 1.399375,2.830125 1.801375,3.238125 L4.731375,6.195125 C4.934375,6.398125 5.199375,6.500125 5.464375,6.500125 C5.729375,6.500125 5.994375,6.398125 6.196375,6.195125 C6.601375,5.786125 6.601375,5.125125 6.196375,4.717125 L3.999375,2.501125 L6.196375,0.283125 C6.601375,-0.123875 6.601375,-0.785875 6.196375,-1.193875 C5.993375,-1.396875 5.729375,-1.499875 5.464375,-1.499875 C5.198375,-1.499875 4.934375,-1.396875 4.731375,-1.193875 Z",
        id: "Clip-2-Copy",
        transform: "translate(4.000000, 2.500125) rotate(90.000000) translate(-4.000000, -2.500125) "
    })))));
const $024669fea62f080c$export$c453e9da65a3b2c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $57VDz.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        glyph: $024669fea62f080c$var$glyph
    }));

});

parcelRegister("cmQFd", function(module, exports) {

$parcel$export(module.exports, "PrideIcon", function () { return $9f1c0e9a03eaa482$export$a03900a1bb7e1dfe; });

var $9nHZC = parcelRequire("9nHZC");

var $bMnaH = parcelRequire("bMnaH");
const $9f1c0e9a03eaa482$var$prideBucketGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("svg", {
        viewBox: "0 0 792 792",
        width: "28",
        height: "28"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("title", null, "Bitbucket Logo Pride"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("linearGradient", {
        id: "gradient-lighten",
        gradientUnits: "userSpaceOnUse",
        x1: "650.0464",
        y1: "1112.6672",
        x2: "391.5135",
        y2: "1287.6945",
        gradientTransform: "matrix(1 0 0 1 0 -726)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("stop", {
        offset: "7.000000e-02",
        stopColor: "#ffffff",
        stopOpacity: "0.4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("stop", {
        offset: "1",
        stopColor: "#ffffff"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("linearGradient", {
        id: "gradient-rainbow",
        x1: "0",
        x2: "1",
        y1: "0",
        y2: "1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("stop", {
        offset: "0%",
        stopColor: "#ff5630"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("stop", {
        offset: "25%",
        stopColor: "#ff5630"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("stop", {
        offset: "25%",
        stopColor: "#ff8b00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("stop", {
        offset: "37.5%",
        stopColor: "#ff8b00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("stop", {
        offset: "37.5%",
        stopColor: "#ffab00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("stop", {
        offset: "50%",
        stopColor: "#ffab00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("stop", {
        offset: "50%",
        stopColor: "#36b37e"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("stop", {
        offset: "62.5%",
        stopColor: "#36b37e"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("stop", {
        offset: "62.5%",
        stopColor: "#00b8d9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("stop", {
        offset: "75%",
        stopColor: "#00b8d9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("stop", {
        offset: "75%",
        stopColor: "#8777d9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("stop", {
        offset: "100%",
        stopColor: "#8777d9"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("rect", {
        x: "0",
        y: "0",
        rx: "396",
        ry: "0",
        width: "792",
        height: "792",
        fill: "url(#gradient-rainbow)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("g", {
        transform: "translate(56, 40) scale(0.9)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        fill: "#ffffff",
        d: "M120.1,148.9c-9.7,0-17.6,7.9-17.6,17.6c0,0.9,0,1.8,0,2.6l74.9,453.6c0.9,5.3,3.5,10.6,7.9,14.1l0,0  c4.4,3.5,9.7,6.2,15.9,6.2l139.2-166.5H321l-30.8-162.1h338.3l23.8-145.3c1.8-9.7-5.3-18.5-15-20.3c-0.9,0-1.8,0-2.6,0H120.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        fill: "url(#gradient-lighten)",
        d: "M628.4,314.5H462.8l-28.2,162.1H320.1L185.3,636.9c4.4,3.5,9.7,6.2,15.9,6.2h358.5c8.8,0,15.9-6.2,17.6-15  L628.4,314.5z"
    })));
const $9f1c0e9a03eaa482$export$a03900a1bb7e1dfe = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($bMnaH.PrideGlyphWrapper, {
        size: props.size,
        onClick: props.onClick,
        "aria-label": props.label
    }, $9f1c0e9a03eaa482$var$prideBucketGlyph());

});
parcelRegister("bMnaH", function(module, exports) {

$parcel$export(module.exports, "PrideGlyphWrapper", function () { return $92f923a495c77f84$export$6774712fbce39a94; });

var $2xJU3 = parcelRequire("2xJU3");
// styles copied from atlaskit's icon package for modification to support multi-color uncustomizable glyphs
// https://bitbucket.org/atlassian/atlaskit-mk-2/src/master/packages/core/icon/src/components/Icon.js
const $92f923a495c77f84$var$sizes = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
// @ts-ignore TODO: fix noImplicitAny error here
const $92f923a495c77f84$var$getSize = (props)=>{
    if (props.size) // @ts-ignore TODO: fix noImplicitAny error here
    return `height: ${$92f923a495c77f84$var$sizes[props.size]}; width: ${$92f923a495c77f84$var$sizes[props.size]};`;
    return null;
};
const $92f923a495c77f84$export$6774712fbce39a94 = (0, $2xJU3.default)("span", {
    target: "e1h7jsif0"
})("display:block;line-height:1;border-radius:50%;overflow:hidden;max-height:none;> svg{", $92f923a495c77f84$var$getSize, " max-height:100%;max-width:100%;vertical-align:bottom;}");

});


parcelRegister("lmoTm", function(module, exports) {

$parcel$export(module.exports, "FileAddedIcon", function () { return $755d35d0c68751bc$export$360ea1c46a04f469; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $57VDz = parcelRequire("57VDz");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");
// Inlining the SVG to manually change snake-case props to camelCase
// so React is happy (https://github.com/facebook/react/issues/2250).
// @ts-ignore TODO: fix noImplicitAny error here
const $755d35d0c68751bc$var$glyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("svg", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        viewBox: "0 0 16 16"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("rect", {
        fill: (0, $h39Sh.default)("color.icon.success", (0, $jp7ng).G400),
        width: "14",
        height: "14",
        x: "1",
        y: "1",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("rect", {
        width: "15",
        height: "15",
        x: ".5",
        y: ".5",
        stroke: (0, $h39Sh.default)("elevation.surface.raised", (0, $jp7ng).N0),
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        fill: (0, $h39Sh.default)("elevation.surface.raised", (0, $jp7ng).N0),
        fillRule: "nonzero",
        d: "M4 7h8v2H4V7zm3-3h2v8H7V4z"
    })));
const $755d35d0c68751bc$export$360ea1c46a04f469 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $57VDz.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        glyph: $755d35d0c68751bc$var$glyph
    }));

});

parcelRegister("bYbic", function(module, exports) {

$parcel$export(module.exports, "FileModifiedIcon", function () { return $0d50c5d6cedd3387$export$63cd4ff36e73d8e2; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $57VDz = parcelRequire("57VDz");

var $jp7ng = parcelRequire("jp7ng");
// Inlining the SVG to manually change snake-case props to camelCase
// so React is happy (https://github.com/facebook/react/issues/2250).
// @ts-ignore TODO: fix noImplicitAny error here
const $0d50c5d6cedd3387$var$glyph = (subtle)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("svg", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            viewBox: "0 0 16 16"
        }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("g", {
            fill: "none",
            fillRule: "evenodd"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("rect", {
            fill: subtle ? (0, $jp7ng).N300 : "#B58503",
            width: "14",
            height: "14",
            x: "1",
            y: "1",
            rx: "3"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("rect", {
            width: "15",
            height: "15",
            x: ".5",
            y: ".5",
            stroke: "#FFF",
            rx: "3"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
            fill: "#FFF",
            d: "M4.01095129 11.4162698c-.03460638.1588194.01397015.3242009.1292215.4399418.11525135.1157409.28167627.1662741.44271745.1344265l1.85519694-.3803763-2.04744532-2.0492777-.37969057 1.8552857zm6.67101901-7.13015493C10.5011218 4.10314173 10.2533609 4 9.99468235 4c-.25867857 0-.50643946.10314173-.68728798.28611487L4.55405299 9.03654019l2.40791105 2.41015971 4.75334136-4.75090076c.3795928-.38217768.3795928-.99478477 0-1.37696244l-1.0333351-1.03272183z"
        })));
const $0d50c5d6cedd3387$export$63cd4ff36e73d8e2 = (props)=>{
    const { subtle: subtle } = props;
    const memoizedGlyph = (0, $9nHZC.useMemo)(()=>$0d50c5d6cedd3387$var$glyph(subtle), [
        subtle
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $57VDz.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        glyph: memoizedGlyph
    }));
};

});

parcelRegister("27Btq", function(module, exports) {

$parcel$export(module.exports, "FileRenamedIcon", function () { return $fb2b00a448e1777b$export$bfe7b4795b048ab; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $57VDz = parcelRequire("57VDz");
// Inlining the SVG to manually change snake-case props to camelCase
// so React is happy (https://github.com/facebook/react/issues/2250).
// @ts-ignore TODO: fix noImplicitAny error here
const $fb2b00a448e1777b$var$glyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("svg", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        viewBox: "0 0 16 16"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("rect", {
        fill: "#6554C0",
        width: "14",
        height: "14",
        x: "1",
        y: "1",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("rect", {
        width: "15",
        height: "15",
        x: ".5",
        y: ".5",
        stroke: "#FFF",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        fill: "#FFF",
        d: "M9.50888348 9H4c-.55228475 0-1-.44771525-1-1s.44771525-1 1-1h5.50888348L8.30330086 5.78361162c-.40440115-.40802583-.40440115-1.06956641 0-1.47759225.40440114-.40802583 1.06006495-.40802583 1.46446609 0l2.92893215 2.9551845c.4044012.40802584.4044012 1.06956642 0 1.47759226L9.76776695 11.6939806c-.40440114.4080259-1.06006495.4080259-1.46446609 0-.40440115-.4080258-.40440115-1.0695664 0-1.4775922L9.50888348 9z"
    })));
const $fb2b00a448e1777b$export$bfe7b4795b048ab = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $57VDz.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        glyph: $fb2b00a448e1777b$var$glyph
    }));

});

parcelRegister("jnVZ7", function(module, exports) {

$parcel$export(module.exports, "FileRemovedIcon", function () { return $ba640f99c08a63a8$export$ac6910029b660cbb; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $57VDz = parcelRequire("57VDz");
// Inlining the SVG to manually change snake-case props to camelCase
// so React is happy (https://github.com/facebook/react/issues/2250).
// @ts-ignore TODO: fix noImplicitAny error here
const $ba640f99c08a63a8$var$glyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("svg", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        viewBox: "0 0 16 16"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("rect", {
        fill: "#FF5630",
        width: "14",
        height: "14",
        x: "1",
        y: "1",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("rect", {
        width: "15",
        height: "15",
        x: ".5",
        y: ".5",
        stroke: "#FFF",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        fill: "#FFF",
        fillRule: "nonzero",
        d: "M4 7h8v2H4z"
    })));
const $ba640f99c08a63a8$export$ac6910029b660cbb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $57VDz.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        glyph: $ba640f99c08a63a8$var$glyph
    }));

});

parcelRegister("bc1FU", function(module, exports) {

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $57VDz = parcelRequire("57VDz");
// Inlining the SVG to manually change snake-case props to camelCase
// so React is happy (https://github.com/facebook/react/issues/2250).
// @ts-ignore TODO: fix noImplicitAny error here
const $2445ca53908d1375$var$glyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("svg", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        x: "0px",
        y: "0px",
        viewBox: "0 0 16 16",
        style: {
            enableBackground: "new 0 0 16 16"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("style", {
        type: "text/css"
    }, `.st0 { fill: #42526E; }`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        className: "st0",
        d: "M9.9,4H13c1.1,0,2,0.9,2,2v7c0,1.1-0.9,2-2,2H3c-1.1,0-2-0.9-2-2V6V3c0-1.1,0.9-2,2-2h3 C7.9,1,9.4,2.3,9.9,4z"
    }));
const $2445ca53908d1375$export$cb4542a972b09aad = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $57VDz.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        glyph: $2445ca53908d1375$var$glyph
    }));

});

parcelRegister("j9Di9", function(module, exports) {

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $57VDz = parcelRequire("57VDz");
// Inlining the SVG to manually change snake-case props to camelCase
// so React is happy (https://github.com/facebook/react/issues/2250).
// @ts-ignore TODO: fix noImplicitAny error here
const $9ed4a1bf5280fade$var$glyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("svg", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        x: "0px",
        y: "0px",
        viewBox: "0 0 16 16",
        style: {
            enableBackground: "new 0 0 16 16"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("style", null, `.st0 { fill: #42526E; }`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        className: "st0",
        d: "M2,7H1.5C1.3,7,1.2,7,1,7.1V6V3c0-1.1,0.9-2,2-2h3c1.9,0,3.4,1.3,3.9,3H13c1.1,0,2,0.9,2,2 v1.1C14.8,7,14.7,7,14.5,7H14V6c0-0.6-0.4-1-1-1H9c0-1.7-1.3-3-3-3H3C2.4,2,2,2.4,2,3v3V7z M2.1,8h11.8c1.1,0,2,0.9,2,2 c0,0.1,0,0.2,0,0.2l-0.3,3c-0.1,1-1,1.8-2,1.8H2.4c-1,0-1.9-0.8-2-1.8l-0.3-3C0,9.1,0.8,8.1,1.9,8C1.9,8,2,8,2.1,8z"
    }));
const $9ed4a1bf5280fade$export$f6a56b2243a6d25 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $57VDz.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        glyph: $9ed4a1bf5280fade$var$glyph
    }));

});

parcelRegister("c5vng", function(module, exports) {

$parcel$export(module.exports, "SubmoduleIcon", function () { return $b78fada45d459816$export$e51601c2b78887ea; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $57VDz = parcelRequire("57VDz");
// @ts-ignore TODO: fix noImplicitAny error here
const $b78fada45d459816$var$glyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("svg", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        version: "1.1"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("g", {
        id: "Source-Submodule-Icon",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("g", {
        id: "Double-Folder-Icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M5.19999981,16.4959421 L5.19999981,19 L3.99079514,19 C2.89130934,19 2,18.1661625 2,17.1409081 L2,10.4266166 L2,4.00585866 C2,2.89805351 2.89585781,2 3.9973917,2 L9.0026083,2 C10.1057373,2 11.3302593,2.82564831 11.7447262,3.86181545 L12.2,5 L20.0092049,5 C21.1086907,5 22,5.83383751 22,6.85909191 L22,12 L15.3999998,12 L14.944726,10.8618155 C14.5302591,9.82564831 13.3057371,9 12.2026081,9 L7.19739151,9 C6.09585762,9 5.19999981,9.89805351 5.19999981,11.0058587 L5.19999981,16.4959421 Z",
        id: "Combined-Shape",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M14.2599142,13.0442477 L20.4571338,13.0442477 C21.3092353,13.0442477 22,13.5776508 22,14.2335025 L22,20.8107452 C22,21.4675525 21.3038854,22 20.4571338,22 L8.04286623,22 C7.19076474,22 6.5,21.466597 6.5,20.8107452 L6.5,17.0069981 L6.5,12.0520376 C6.5,11.1948709 7.17433563,10.5 8.00348904,10.5 L11.7710466,10.5 C12.6014007,10.5 13.5231305,11.1388472 13.8351106,11.9405839 L14.2194132,12.9281773 C14.2342264,12.966245 14.2477197,13.004965 14.2599142,13.0442477 Z",
        id: "Combined-Shape",
        fill: "#42526E"
    }))));
const $b78fada45d459816$export$e51601c2b78887ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $57VDz.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        glyph: $b78fada45d459816$var$glyph
    }));

});

parcelRegister("wj492", function(module, exports) {

$parcel$export(module.exports, "BlockerIcon", function () { return $0918861d0b64ff34$export$8e4c23f81e0a3c33; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $57VDz = parcelRequire("57VDz");
const $0918861d0b64ff34$var$glyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("svg", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("circle", {
        fill: "currentColor",
        cx: "12",
        cy: "12",
        r: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.144 10.76068C17.134700000000002 10.76068 17.1254 10.76078 17.1161 10.76099L7.14397 10.76099C6.45361 10.76099 5.8939699999999995 11.32063 5.8939699999999995 12.011C5.8939699999999995 12.7013 6.45361 13.261 7.14397 13.261L17.144 13.261V13.2607L17.144 13.2607C17.8343 13.2607 18.394 12.701 18.394 12.0107C18.394 11.32033 17.8343 10.76068 17.144 10.76068z",
        fill: "#F4F5F7"
    })));
const $0918861d0b64ff34$export$8e4c23f81e0a3c33 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $57VDz.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        glyph: $0918861d0b64ff34$var$glyph
    }));

});

parcelRegister("2bStf", function(module, exports) {

$parcel$export(module.exports, "ShieldIcon", function () { return $6f99d631333b519c$export$2d8598c0b89a07db; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $57VDz = parcelRequire("57VDz");
const $6f99d631333b519c$var$glyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("svg", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M11 5.73607L6.14177 8.16518L6.64261 12.6727C6.7995 14.0848 7.54972 15.3634 8.70584 16.1892L11 17.8279V5.73607ZM13 5.73607V17.8279L15.2942 16.1892C16.4503 15.3634 17.2005 14.0848 17.3574 12.6727L17.8582 8.16518L13 5.73607ZM4 7L12 3L20 7L19.3452 12.8936C19.1255 14.8705 18.0752 16.6606 16.4566 17.8167L12.5812 20.5848C12.2335 20.8332 11.7665 20.8332 11.4188 20.5848L7.54336 17.8167C5.9248 16.6606 4.8745 14.8705 4.65484 12.8936L4 7Z",
        fill: "currentColor"
    }));
const $6f99d631333b519c$export$2d8598c0b89a07db = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $57VDz.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        glyph: $6f99d631333b519c$var$glyph
    }));

});

parcelRegister("e69v7", function(module, exports) {

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $57VDz = parcelRequire("57VDz");
const $f478ac660c3fa7ad$var$glyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("svg", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.6831 12C17.2137 12 17.6452 12.4234 17.6566 12.95H17.6586L17.6568 12.9606L17.6569 12.9714C17.6569 13.1132 17.6264 13.2479 17.5716 13.3694C16.9569 15.856 14.7061 17.7 12.0235 17.7C8.86769 17.7 6.30939 15.148 6.30939 12C6.30939 8.85198 8.86769 6.3 12.0235 6.3C13.4045 6.3 14.6711 6.78872 15.659 7.60225L17.1213 6.35193C15.7712 5.13857 13.9838 4.40003 12.0234 4.40003C7.8157 4.40003 4.40464 7.80266 4.40464 12C4.40464 16.1974 7.8157 19.6 12.0234 19.6C15.9087 19.6 19.1147 16.699 19.5833 12.95H19.5852C19.5877 12.4249 20.0153 12 20.5423 12C21.0693 12 21.4968 12.4249 21.4994 12.95H21.5L21.4994 12.9562C21.4993 13.0278 21.4913 13.0976 21.4762 13.1647C20.9005 17.862 16.8879 21.5 12.0235 21.5C6.76382 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.76382 2.5 12.0235 2.5C14.2039 2.5 16.2132 3.23095 17.8185 4.4606L19.2447 5.5276C19.4949 5.71481 19.6423 6.00902 19.6423 6.32153C19.6423 6.60952 19.5171 6.88327 19.2992 7.07162L13.9093 11.7313C13.9217 11.8191 13.9282 11.9088 13.9282 12C13.9282 13.0493 13.0754 13.9 12.0235 13.9C10.9716 13.9 10.1188 13.0493 10.1188 12C10.1188 10.9507 10.9716 10.1 12.0235 10.1C12.2336 10.1 12.4357 10.1339 12.6247 10.1966L14.1798 8.86702C13.5666 8.44629 12.8238 8.20001 12.0234 8.20001C9.91951 8.20001 8.21398 9.90133 8.21398 12C8.21398 14.0987 9.91951 15.8 12.0234 15.8C13.7937 15.8 15.2819 14.5955 15.7094 12.9632C15.7138 12.4305 16.148 12 16.6831 12Z",
        fill: "currentColor"
    }));
const $f478ac660c3fa7ad$export$2dd8148b76df4308 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $57VDz.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        glyph: $f478ac660c3fa7ad$var$glyph
    }));

});

parcelRegister("iLMDI", function(module, exports) {

$parcel$export(module.exports, "IconSizes", function () { return $d876ec0a129833e4$export$b22f10f159e77d0b; });
var $d876ec0a129833e4$export$b22f10f159e77d0b;
(function(IconSizes) {
    IconSizes["Small"] = "small";
    IconSizes["Medium"] = "medium";
    IconSizes["Large"] = "large";
    IconSizes["Xlarge"] = "xlarge";
})($d876ec0a129833e4$export$b22f10f159e77d0b || ($d876ec0a129833e4$export$b22f10f159e77d0b = {}));

});


parcelRegister("3D3Ah", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $056dce636435f468$export$2e2bcd8739ae039; });

var $2xJU3 = parcelRequire("2xJU3");

var $9nHZC = parcelRequire("9nHZC");

var $iigdU = parcelRequire("iigdU");

var $aP6k3 = parcelRequire("aP6k3");
const $056dce636435f468$var$Icon = (0, $2xJU3.default)("span", {
    target: "e6ct6940"
})("height:", (0, $aP6k3.gridSize)() * 3, "px;width:", (0, $aP6k3.gridSize)() * 3, "px;&::before{font-size:20px;margin-left:2px;margin-top:-10px;}");
const $056dce636435f468$var$IconImg = (0, $2xJU3.default)("img", {
    target: "e6ct6941"
})("height:", (0, $aP6k3.gridSize)() * 3, "px;width:", (0, $aP6k3.gridSize)() * 3, "px;");
class $056dce636435f468$var$ConnectMenuItemIcon extends (0, $9nHZC.PureComponent) {
    render() {
        const { menuItem: menuItem } = this.props;
        if (menuItem.icon_url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($056dce636435f468$var$IconImg, {
            src: menuItem.icon_url,
            alt: "",
            role: "presentation"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($056dce636435f468$var$Icon, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($iigdU)))(this.props.className, "aui-icon", "aui-icon-large", menuItem.icon_class)
        });
    }
}
var $056dce636435f468$export$2e2bcd8739ae039 = $056dce636435f468$var$ConnectMenuItemIcon;

});

parcelRegister("6BAyw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aabe93e3ff08157f$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $57VDz = parcelRequire("57VDz");
const $aabe93e3ff08157f$var$defaultGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("svg", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        version: "1.1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 12.394v7.6C13 20.55 12.552 21 12 21s-1-.45-1-1.007v-7.648l-.313.317c-.386.388-1.012.388-1.398 0-.386-.39-.386-1.02 0-1.408l1.918-1.933c.216-.216.5-.323.78-.32h.013c.19 0 .364.052.514.142.083.048.16.107.232.18l1.965 1.98c.387.388.386 1.018 0 1.407-.386.387-1.01.387-1.397-.002L13 12.394zm3.84-6.976c2.804 0 5.16 2.202 5.16 5.08C22 13.41 19.615 16 16.9 16h-2.88v-1.993h2.88c1.657 0 3.115-1.663 3.115-3.508 0-1.78-1.47-3.088-3.104-3.088h-.01c-.39 0-.687.05-.97.15l-.17.063c-.606.248-.876-.246-.876-.246l-.15-.268c-.73-1.347-2.2-2.096-3.716-2.12-2.082.035-3.797 1.548-4.07 3.645l-.045.34s-.07.525-.665.525c-.013 0-.012.006-.023.006H5.96c-1.135 0-1.975.957-1.975 2.157 0 1.206.987 2.342 2.07 2.342h3.964V16H6.054C3.895 16 2 13.955 2 11.665 2 9.665 3.312 8 5.138 7.59 5.845 4.885 8.19 3.04 11.024 3c1.975.02 3.9.9 5.038 2.48.256-.04.516-.062.777-.062z"
    }));
const $aabe93e3ff08157f$var$DeploymentIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $57VDz.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        glyph: $aabe93e3ff08157f$var$defaultGlyph
    }, props));
var $aabe93e3ff08157f$export$2e2bcd8739ae039 = $aabe93e3ff08157f$var$DeploymentIcon;

});

parcelRegister("95zGT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30b6ccf928552ec5$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $57VDz = parcelRequire("57VDz");
const $30b6ccf928552ec5$var$defaultGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("svg", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        version: "1.1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M10.762 19.632l-.001.09.419.896c.177.39.01.85-.377 1.034-.256.12-.478.146-.666.077-.188-.068-.283-.103-.402-.358L8.36 18.422c-.179-.384-.008-.854.411-1.128l2.948-1.374a.785.785 0 0 1 1.033.376c.178.389.011.85-.375 1.034l-1.006.503c3.01.204 5.98-1.59 6.5-4.537a5.773 5.773 0 0 0-.973-4.337l-.094-.128a.91.91 0 0 1 .255-1.309 1.068 1.068 0 0 1 1.418.266l.052.07a7.704 7.704 0 0 1 1.298 5.783c-.742 4.205-4.786 6.69-9.065 5.99zm1.932-15.546l-.445-.955a.785.785 0 0 1 .376-1.034.785.785 0 0 1 1.034.376l1.375 2.949c.145.478-.026.947-.41 1.126l-2.948 1.375c-.257.12-.35.086-.539.017-.188-.067-.342-.23-.46-.487a.785.785 0 0 1 .375-1.034l.832-.398c-2.814.038-5.288 2.032-5.788 4.865a5.81 5.81 0 0 0 .434 3.423c.16.354.357.694.59 1.016a.818.818 0 0 1-.222 1.222l-.24.14a.899.899 0 0 1-1.167-.23 7.938 7.938 0 0 1-.776-1.332 7.754 7.754 0 0 1-.588-4.587c.715-4.057 4.472-6.828 8.567-6.452z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $30b6ccf928552ec5$var$PipelinesIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $57VDz.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        glyph: $30b6ccf928552ec5$var$defaultGlyph
    }, props));
var $30b6ccf928552ec5$export$2e2bcd8739ae039 = $30b6ccf928552ec5$var$PipelinesIcon;

});


parcelRegister("eKObo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ffcc94de6c0e9142$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $57VDz = parcelRequire("57VDz");
const $ffcc94de6c0e9142$var$defaultGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("svg", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        version: "1.1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        fill: "#0052CC",
        fillRule: "evenodd",
        d: "M9.276 4.382L7.357 9.247l-4.863 1.917a.78.78 0 0 0 0 1.45l4.863 1.918 1.919 4.863a.78.78 0 0 0 1.45 0h-.001l1.918-4.863 4.864-1.919a.781.781 0 0 0 0-1.45l-4.864-1.916-1.918-4.865a.776.776 0 0 0-.44-.438.778.778 0 0 0-1.01.438zm8.297-2.03l-.743 1.886-1.884.743a.56.56 0 0 0 0 1.038l1.884.743.743 1.886a.558.558 0 0 0 1.038 0l.745-1.886 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.743-.745-1.885a.552.552 0 0 0-.314-.314.562.562 0 0 0-.724.314zm-.704 13.003l-.744 1.883-1.883.744a.553.553 0 0 0-.316.314.56.56 0 0 0 .316.724l1.883.743.744 1.884c.057.144.17.258.314.315a.56.56 0 0 0 .724-.315l.744-1.884 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.744-.744-1.883a.551.551 0 0 0-.315-.316.56.56 0 0 0-.723.316z"
    }));
const $ffcc94de6c0e9142$var$PremiumIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $57VDz.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        glyph: $ffcc94de6c0e9142$var$defaultGlyph
    }, props));
var $ffcc94de6c0e9142$export$2e2bcd8739ae039 = $ffcc94de6c0e9142$var$PremiumIcon;

});


parcelRegister("QKGMb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8182c1fbc7ced9a7$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $1JtcE = parcelRequire("1JtcE");

var $fbBdr = parcelRequire("fbBdr");

var $j9ioD = parcelRequire("j9ioD");

var $fPv7t = parcelRequire("fPv7t");
const $8182c1fbc7ced9a7$var$FocusedNavigation = ({ backButtonUrl: backButtonUrl, customBackIcon: BackIcon, backButtonTooltip: backButtonTooltip, onBackButtonClick: onBackButtonClick })=>{
    const handleBackButtonClick = (e)=>{
        if (onBackButtonClick) {
            e.preventDefault();
            onBackButtonClick();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($fPv7t.FocusedNavigationWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $j9ioD.default), {
        content: backButtonTooltip,
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $1JtcE.default), {
        href: backButtonUrl,
        onClick: handleBackButtonClick,
        UNSAFE_size: "large",
        icon: BackIcon || (0, (/*@__PURE__*/$parcel$interopDefault($fbBdr))),
        label: backButtonTooltip,
        appearance: "subtle"
    })));
};
var $8182c1fbc7ced9a7$export$2e2bcd8739ae039 = $8182c1fbc7ced9a7$var$FocusedNavigation;

});
parcelRegister("1JtcE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1430a587016a2b26$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $9xD1R = parcelRequire("9xD1R");

var $jxxH9 = parcelRequire("jxxH9");
var $1430a587016a2b26$var$_excluded = [
    "analyticsContext",
    "autoFocus",
    "appearance",
    "spacing",
    "isDisabled",
    "isSelected",
    "icon",
    "interactionName",
    "label",
    "overlay",
    "onClick",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onTouchStartCapture",
    "onTouchEndCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onClickCapture",
    "shape",
    "testId",
    "UNSAFE_size",
    "href"
];
var $1430a587016a2b26$var$LinkIconButtonBase = function LinkIconButtonBase(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, autoFocus = _ref.autoFocus, appearance = _ref.appearance, spacing = _ref.spacing, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, icon = _ref.icon, interactionName = _ref.interactionName, label = _ref.label, overlay = _ref.overlay, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, shape = _ref.shape, testId = _ref.testId, UNSAFE_size = _ref.UNSAFE_size, href = _ref.href, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $1430a587016a2b26$var$_excluded);
    var baseProps = (0, $jxxH9.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: "link",
        icon: icon,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        overlay: overlay,
        ref: ref,
        shape: shape,
        spacing: spacing,
        UNSAFE_size: UNSAFE_size
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9xD1R.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        testId: testId,
        href: baseProps.isDisabled ? undefined : href,
        role: baseProps.isDisabled ? "link" : undefined,
        "aria-disabled": baseProps.isDisabled === true ? true : undefined
    }), baseProps.children);
};
// Workarounds to support generic types with forwardRef + memo
var $1430a587016a2b26$var$WithRef = /*#__PURE__*/ (0, $9nHZC.forwardRef)($1430a587016a2b26$var$LinkIconButtonBase);
/**
 * __Link Icon Button__
 *
 * Renders a link in the style of an icon button.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $1430a587016a2b26$var$LinkIconButton = /*#__PURE__*/ (0, $9nHZC.memo)($1430a587016a2b26$var$WithRef);
var $1430a587016a2b26$export$2e2bcd8739ae039 = $1430a587016a2b26$var$LinkIconButton;

});
parcelRegister("9xD1R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f2578749bd4d110$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $340K4 = parcelRequire("340K4");

var $b4Ivn = parcelRequire("b4Ivn");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $4GQn2 = parcelRequire("4GQn2");

var $OIHhl = parcelRequire("OIHhl");

var $7njhD = parcelRequire("7njhD");

var $5fQdm = parcelRequire("5fQdm");
var $6f2578749bd4d110$var$_excluded = [
    "href",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "testId",
    "xcss",
    "target",
    "rel"
];
// TODO: Duplicated FocusRing styles due to lack of `xcss` support
// and to prevent additional dependency
var $6f2578749bd4d110$var$baseFocusRingStyles = {
    outlineColor: "color.border.focused",
    outlineWidth: "border.width.outline",
    outlineStyle: "solid",
    outlineOffset: "space.025"
};
var $6f2578749bd4d110$var$focusRingStyles = (0, $7njhD.xcss)({
    ":focus-visible": $6f2578749bd4d110$var$baseFocusRingStyles,
    "@supports not selector(*:focus-visible)": {
        ":focus": $6f2578749bd4d110$var$baseFocusRingStyles
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        ":focus-visible": {
            outline: "1px solid"
        }
    }
});
var $6f2578749bd4d110$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $6f2578749bd4d110$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
var $6f2578749bd4d110$var$Link = function Link(_ref, ref) {
    var href = _ref.href, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, testId = _ref.testId, xcssStyles = _ref.xcss, target = _ref.target, rel = _ref.rel, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $6f2578749bd4d110$var$_excluded);
    var RouterLink = (0, $OIHhl.default)();
    // Combine default styles with supplied styles. XCSS does not support deep nested arrays
    var styles = Array.isArray(xcssStyles) ? [
        $6f2578749bd4d110$var$focusRingStyles
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(xcssStyles)) : [
        $6f2578749bd4d110$var$focusRingStyles,
        xcssStyles
    ];
    var isExternal = typeof href === "string" && $6f2578749bd4d110$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === "string" && $6f2578749bd4d110$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   * - a link component is set in the app provider
   * - it's not an external link (starting with http:// or https://)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(href) === "object";
    (0, $4GQn2.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Link primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5fQdm.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, htmlAttributes, {
        // @ts-expect-error (TODO: Box doesn't allow `as` components)
        as: isRouterLink ? RouterLink : "a",
        ref: ref,
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? "true" : "false" : undefined,
        href: !isRouterLink && typeof href !== "string" ? undefined : href,
        target: isExternal && target === undefined ? "_blank" : target,
        rel: isExternal && rel === undefined ? "noopener noreferrer" : rel,
        backgroundColor: backgroundColor,
        padding: padding,
        paddingBlock: paddingBlock,
        paddingBlockStart: paddingBlockStart,
        paddingBlockEnd: paddingBlockEnd,
        paddingInline: paddingInline,
        paddingInlineStart: paddingInlineStart,
        paddingInlineEnd: paddingInlineEnd,
        xcss: styles
    }), children);
};
// Workarounds to support generic types with forwardRef
/**
 * __UNSAFE_LINK__
 *
 * @internal Still under development. Do not use.
 *
 * A Link is a primitive component that renders an `<a>` anchor. It utilizes
 * the configured router link component in the AppProvider if set.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ var $6f2578749bd4d110$var$UNSAFE_LINK = /*#__PURE__*/ (0, $9nHZC.forwardRef)($6f2578749bd4d110$var$Link);
var $6f2578749bd4d110$export$2e2bcd8739ae039 = $6f2578749bd4d110$var$UNSAFE_LINK;

});
parcelRegister("OIHhl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $098757874653455b$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $dS8Mr = parcelRequire("dS8Mr");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $098757874653455b$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $9nHZC.useContext)((0, $dS8Mr.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
};
var $098757874653455b$export$2e2bcd8739ae039 = $098757874653455b$var$useRouterLink;

});
parcelRegister("dS8Mr", function(module, exports) {

$parcel$export(module.exports, "RouterLinkProviderContext", function () { return $a19721188aa44650$export$2931e0ee690eee88; });

var $9nHZC = parcelRequire("9nHZC");
var $a19721188aa44650$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $9nHZC.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $a19721188aa44650$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($a19721188aa44650$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $a19721188aa44650$export$2e2bcd8739ae039 = $a19721188aa44650$var$RouterLinkProvider;

});


parcelRegister("7njhD", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $55e9a3b0a14dc44c$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $55e9a3b0a14dc44c$export$f6c783d06584602c; });

var $kFnE9 = parcelRequire("kFnE9");

var $9q1kH = parcelRequire("9q1kH");

var $340K4 = parcelRequire("340K4");

var $avKww = parcelRequire("avKww");

var $e2q9a = parcelRequire("e2q9a");

var $8ovux = parcelRequire("8ovux");
var $55e9a3b0a14dc44c$export$9a199fbafee0014e = {
    backgroundColor: (0, $e2q9a.backgroundColorMap),
    blockSize: (0, $e2q9a.dimensionMap),
    borderBlockColor: (0, $e2q9a.borderColorMap),
    borderBlockEndColor: (0, $e2q9a.borderColorMap),
    borderBlockEndWidth: (0, $e2q9a.borderWidthMap),
    borderBlockStartColor: (0, $e2q9a.borderColorMap),
    borderBlockStartWidth: (0, $e2q9a.borderWidthMap),
    borderBlockWidth: (0, $e2q9a.borderWidthMap),
    borderBottomColor: (0, $e2q9a.borderColorMap),
    borderBottomLeftRadius: (0, $e2q9a.borderRadiusMap),
    borderBottomRightRadius: (0, $e2q9a.borderRadiusMap),
    borderBottomWidth: (0, $e2q9a.borderWidthMap),
    borderColor: (0, $e2q9a.borderColorMap),
    borderEndEndRadius: (0, $e2q9a.borderRadiusMap),
    borderEndStartRadius: (0, $e2q9a.borderRadiusMap),
    borderInlineColor: (0, $e2q9a.borderColorMap),
    borderInlineEndColor: (0, $e2q9a.borderColorMap),
    borderInlineEndWidth: (0, $e2q9a.borderWidthMap),
    borderInlineStartColor: (0, $e2q9a.borderColorMap),
    borderInlineStartWidth: (0, $e2q9a.borderWidthMap),
    borderInlineWidth: (0, $e2q9a.borderWidthMap),
    borderLeftColor: (0, $e2q9a.borderColorMap),
    borderLeftWidth: (0, $e2q9a.borderWidthMap),
    borderRadius: (0, $e2q9a.borderRadiusMap),
    borderRightColor: (0, $e2q9a.borderColorMap),
    borderRightWidth: (0, $e2q9a.borderWidthMap),
    borderStartEndRadius: (0, $e2q9a.borderRadiusMap),
    borderStartStartRadius: (0, $e2q9a.borderRadiusMap),
    borderTopColor: (0, $e2q9a.borderColorMap),
    borderTopLeftRadius: (0, $e2q9a.borderRadiusMap),
    borderTopRightRadius: (0, $e2q9a.borderRadiusMap),
    borderTopWidth: (0, $e2q9a.borderWidthMap),
    borderWidth: (0, $e2q9a.borderWidthMap),
    bottom: (0, $e2q9a.allSpaceMap),
    boxShadow: (0, $e2q9a.shadowMap),
    color: (0, $e2q9a.textColorMap),
    columnGap: (0, $e2q9a.positiveSpaceMap),
    gap: (0, $e2q9a.positiveSpaceMap),
    height: (0, $e2q9a.dimensionMap),
    inlineSize: (0, $e2q9a.dimensionMap),
    inset: (0, $e2q9a.allSpaceMap),
    insetBlock: (0, $e2q9a.allSpaceMap),
    insetBlockEnd: (0, $e2q9a.allSpaceMap),
    insetBlockStart: (0, $e2q9a.allSpaceMap),
    insetInline: (0, $e2q9a.allSpaceMap),
    insetInlineEnd: (0, $e2q9a.allSpaceMap),
    insetInlineStart: (0, $e2q9a.allSpaceMap),
    left: (0, $e2q9a.allSpaceMap),
    margin: (0, $e2q9a.allSpaceMap),
    marginBlock: (0, $e2q9a.allSpaceMap),
    marginBlockEnd: (0, $e2q9a.allSpaceMap),
    marginBlockStart: (0, $e2q9a.allSpaceMap),
    marginBottom: (0, $e2q9a.allSpaceMap),
    marginInline: (0, $e2q9a.allSpaceMap),
    marginInlineEnd: (0, $e2q9a.allSpaceMap),
    marginInlineStart: (0, $e2q9a.allSpaceMap),
    marginLeft: (0, $e2q9a.allSpaceMap),
    marginRight: (0, $e2q9a.allSpaceMap),
    marginTop: (0, $e2q9a.allSpaceMap),
    maxBlockSize: (0, $e2q9a.dimensionMap),
    maxHeight: (0, $e2q9a.dimensionMap),
    maxInlineSize: (0, $e2q9a.dimensionMap),
    maxWidth: (0, $e2q9a.dimensionMap),
    minBlockSize: (0, $e2q9a.dimensionMap),
    minHeight: (0, $e2q9a.dimensionMap),
    minInlineSize: (0, $e2q9a.dimensionMap),
    minWidth: (0, $e2q9a.dimensionMap),
    opacity: (0, $e2q9a.opacityMap),
    outlineColor: (0, $e2q9a.borderColorMap),
    outlineOffset: (0, $e2q9a.positiveSpaceMap),
    outlineWidth: (0, $e2q9a.borderWidthMap),
    padding: (0, $e2q9a.positiveSpaceMap),
    paddingBlock: (0, $e2q9a.positiveSpaceMap),
    paddingBlockEnd: (0, $e2q9a.positiveSpaceMap),
    paddingBlockStart: (0, $e2q9a.positiveSpaceMap),
    paddingBottom: (0, $e2q9a.positiveSpaceMap),
    paddingInline: (0, $e2q9a.positiveSpaceMap),
    paddingInlineEnd: (0, $e2q9a.positiveSpaceMap),
    paddingInlineStart: (0, $e2q9a.positiveSpaceMap),
    paddingLeft: (0, $e2q9a.positiveSpaceMap),
    paddingRight: (0, $e2q9a.positiveSpaceMap),
    paddingTop: (0, $e2q9a.positiveSpaceMap),
    right: (0, $e2q9a.allSpaceMap),
    rowGap: (0, $e2q9a.positiveSpaceMap),
    top: (0, $e2q9a.allSpaceMap),
    width: (0, $e2q9a.dimensionMap),
    zIndex: (0, $e2q9a.layerMap)
};
var $55e9a3b0a14dc44c$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $55e9a3b0a14dc44c$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $8ovux === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux.env) === "object" && false;
};
var $55e9a3b0a14dc44c$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $55e9a3b0a14dc44c$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $55e9a3b0a14dc44c$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(value) === "object" && $55e9a3b0a14dc44c$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($55e9a3b0a14dc44c$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($55e9a3b0a14dc44c$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $55e9a3b0a14dc44c$export$9a199fbafee0014e)) return;
        var tokenValue = $55e9a3b0a14dc44c$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $55e9a3b0a14dc44c$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $55e9a3b0a14dc44c$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, $55e9a3b0a14dc44c$var$uniqueSymbol, (0, $avKww.css)(transformedStyles));
};
var $55e9a3b0a14dc44c$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) return args.map(function(x) {
        return x && parseXcss(x);
    }).filter(Boolean);
    var styles = args[$55e9a3b0a14dc44c$var$uniqueSymbol];
    typeof $8ovux === "undefined" || (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux);
    return styles;
};
function $55e9a3b0a14dc44c$export$f6c783d06584602c(style) {
    return $55e9a3b0a14dc44c$var$baseXcss(style);
}

});
parcelRegister("e2q9a", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $a38588cbb3ffcf8a$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $a38588cbb3ffcf8a$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $a38588cbb3ffcf8a$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $a38588cbb3ffcf8a$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $a38588cbb3ffcf8a$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $a38588cbb3ffcf8a$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $a38588cbb3ffcf8a$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $a38588cbb3ffcf8a$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $a38588cbb3ffcf8a$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $a38588cbb3ffcf8a$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $a38588cbb3ffcf8a$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $a38588cbb3ffcf8a$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $a38588cbb3ffcf8a$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $a38588cbb3ffcf8a$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $a38588cbb3ffcf8a$export$5e65a44e5b6ecadb; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $xbX1J = parcelRequire("xbX1J");
function $a38588cbb3ffcf8a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a38588cbb3ffcf8a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a38588cbb3ffcf8a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a38588cbb3ffcf8a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a38588cbb3ffcf8a$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $a38588cbb3ffcf8a$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $a38588cbb3ffcf8a$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $a38588cbb3ffcf8a$export$632685d741f3dbbf = $a38588cbb3ffcf8a$var$_objectSpread($a38588cbb3ffcf8a$var$_objectSpread({}, $a38588cbb3ffcf8a$export$958d0ae7f2977ae4), $a38588cbb3ffcf8a$export$d2dc61f58390201c);
var $a38588cbb3ffcf8a$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $a38588cbb3ffcf8a$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $a38588cbb3ffcf8a$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $a38588cbb3ffcf8a$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $a38588cbb3ffcf8a$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $a38588cbb3ffcf8a$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $a38588cbb3ffcf8a$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)"
};
var $a38588cbb3ffcf8a$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $a38588cbb3ffcf8a$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $a38588cbb3ffcf8a$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $a38588cbb3ffcf8a$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $a38588cbb3ffcf8a$export$6cc560b4dedf3816 = {
    "font.size.050": "var(--ds-font-size-050, 11px)",
    "font.size.075": "var(--ds-font-size-075, 12px)",
    "font.size.100": "var(--ds-font-size-100, 14px)",
    "font.size.200": "var(--ds-font-size-200, 16px)",
    "font.size.300": "var(--ds-font-size-300, 20px)",
    "font.size.400": "var(--ds-font-size-400, 24px)",
    "font.size.500": "var(--ds-font-size-500, 29px)",
    "font.size.600": "var(--ds-font-size-600, 35px)"
};
var $a38588cbb3ffcf8a$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $a38588cbb3ffcf8a$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand": "var(--ds-font-family-brand, Charlie Sans)",
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.monospace": 'var(--ds-font-family-monospace, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.sans": 'var(--ds-font-family-sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif)'
};
var $a38588cbb3ffcf8a$export$360c29a380c1a34 = {
    "font.lineHeight.1": "var(--ds-font-lineHeight-1, 1)",
    "font.lineHeight.100": "var(--ds-font-lineHeight-100, 16px)",
    "font.lineHeight.200": "var(--ds-font-lineHeight-200, 20px)",
    "font.lineHeight.300": "var(--ds-font-lineHeight-300, 24px)",
    "font.lineHeight.400": "var(--ds-font-lineHeight-400, 28px)",
    "font.lineHeight.500": "var(--ds-font-lineHeight-500, 32px)",
    "font.lineHeight.600": "var(--ds-font-lineHeight-600, 40px)"
};
var $a38588cbb3ffcf8a$export$b5bac06d7d8fd0d1 = {
    body: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $a38588cbb3ffcf8a$export$b27166c9cf2c9f74 = {
    ui: 'var(--ds-font-ui, normal 500 14px/1 ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "ui.small": 'var(--ds-font-ui-small, normal 400 11px/1 ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $a38588cbb3ffcf8a$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $a38588cbb3ffcf8a$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $avKww.css)((0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $a38588cbb3ffcf8a$export$e615f061ca585a6c = $a38588cbb3ffcf8a$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $a38588cbb3ffcf8a$var$getSerializedStylesMap(spacingProperty, $a38588cbb3ffcf8a$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $a38588cbb3ffcf8a$export$bf46c3f9eeafc71f = $a38588cbb3ffcf8a$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $a38588cbb3ffcf8a$var$getSerializedStylesMap(spacingProperty, $a38588cbb3ffcf8a$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $a38588cbb3ffcf8a$export$e7af83bafe7f9e63 = $a38588cbb3ffcf8a$var$getSerializedStylesMap("backgroundColor", $a38588cbb3ffcf8a$export$d1d79bf68ac056bd);
var $a38588cbb3ffcf8a$export$3a1bcba60b23d7f0 = $a38588cbb3ffcf8a$var$getSerializedStylesMap("color", $a38588cbb3ffcf8a$export$8473307aa00d6ea1);
var $a38588cbb3ffcf8a$export$f7183c9e2dbc2543 = $a38588cbb3ffcf8a$var$getSerializedStylesMap("fontSize", $a38588cbb3ffcf8a$export$6cc560b4dedf3816);
var $a38588cbb3ffcf8a$export$45f3f4fe16f9f7d5 = $a38588cbb3ffcf8a$var$getSerializedStylesMap("fontWeight", $a38588cbb3ffcf8a$export$303e322c6b1ed114);
var $a38588cbb3ffcf8a$export$68cc305da27dbaa4 = $a38588cbb3ffcf8a$var$getSerializedStylesMap("fontFamily", $a38588cbb3ffcf8a$export$3c7e9587132614b4);
var $a38588cbb3ffcf8a$export$8be4a21014f48eb1 = $a38588cbb3ffcf8a$var$getSerializedStylesMap("lineHeight", $a38588cbb3ffcf8a$export$360c29a380c1a34);
var $a38588cbb3ffcf8a$export$a1962444bbf058e = $a38588cbb3ffcf8a$var$getSerializedStylesMap("font", $a38588cbb3ffcf8a$export$b5bac06d7d8fd0d1);
var $a38588cbb3ffcf8a$export$ca3e246f24657bd6 = $a38588cbb3ffcf8a$var$getSerializedStylesMap("font", $a38588cbb3ffcf8a$export$b27166c9cf2c9f74);
var $a38588cbb3ffcf8a$export$ff257d957d48c421 = $a38588cbb3ffcf8a$var$getSerializedStylesMap((0, $xbX1J.CURRENT_SURFACE_CSS_VAR), $a38588cbb3ffcf8a$export$41a358c9c2356760);
var $a38588cbb3ffcf8a$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $a38588cbb3ffcf8a$export$41a358c9c2356760[color] !== undefined;
};

});


parcelRegister("5fQdm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d36db32e4bada4f$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $e2q9a = parcelRequire("e2q9a");

var $7njhD = parcelRequire("7njhD");

var $4HoQB = parcelRequire("4HoQB");
var $3d36db32e4bada4f$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $3d36db32e4bada4f$var$_excluded2 = [
    "className"
];
var $3d36db32e4bada4f$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, as = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $3d36db32e4bada4f$var$_excluded);
    var Component = as;
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(htmlAttributes, $3d36db32e4bada4f$var$_excluded2);
    var className = xcss && (0, $7njhD.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $avKww.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        css: [
            $3d36db32e4bada4f$var$baseStyles,
            backgroundColor && (0, $e2q9a.backgroundColorStylesMap)[backgroundColor],
            (0, $e2q9a.isSurfaceColorToken)(backgroundColor) && (0, $e2q9a.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $e2q9a.paddingStylesMap).padding[padding],
            paddingBlock && (0, $e2q9a.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $e2q9a.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $e2q9a.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $e2q9a.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $e2q9a.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $e2q9a.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            className
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $avKww.jsx)((0, $4HoQB.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $3d36db32e4bada4f$export$2e2bcd8739ae039 = $3d36db32e4bada4f$export$e71c4d32a2263218;
var $3d36db32e4bada4f$var$baseStyles = (0, $avKww.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("4HoQB", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $36be73c5b78910f6$export$1ca2a26fecb070ae; });

var $9nHZC = parcelRequire("9nHZC");
var $36be73c5b78910f6$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $9nHZC.createContext)("elevation.surface");
var $36be73c5b78910f6$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $9nHZC.useContext)($36be73c5b78910f6$export$1ca2a26fecb070ae);
};
$36be73c5b78910f6$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});



parcelRegister("jxxH9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e39b3c7f0f788996$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $7S7GL = parcelRequire("7S7GL");

var $3XJpo = parcelRequire("3XJpo");

var $frbhL = parcelRequire("frbhL");
/**
 * __Use icon button__
 *
 * A React hook that accepts a set of icon Button props,
 * and processes them to return consistent base props for usage
 * across IconButton and LinkIconButton variants.
 *
 * @private
 */ var $e39b3c7f0f788996$var$useIconButton = function useIconButton(_ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, buttonType = _ref.buttonType, Icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, label = _ref.label, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, overlay = _ref.overlay, ref = _ref.ref, shape = _ref.shape, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, UNSAFE_size = _ref.UNSAFE_size;
    var hasOverlay = Boolean(overlay);
    var isCircle = shape === "circle";
    var baseProps = (0, $frbhL.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3XJpo.default), {
            type: "icon",
            hasOverlay: hasOverlay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Icon, {
            label: "",
            size: UNSAFE_size
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7S7GL.default), null, label)),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: isCircle,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        overlay: overlay,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    });
    return baseProps;
};
var $e39b3c7f0f788996$export$2e2bcd8739ae039 = $e39b3c7f0f788996$var$useIconButton;

});
parcelRegister("3XJpo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e2a1af4d1fbd513$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9nHZC = parcelRequire("9nHZC");

var $5fQdm = parcelRequire("5fQdm");
var $7njhD = parcelRequire("7njhD");
var $2e2a1af4d1fbd513$var$textStyles = (0, $7njhD.xcss)({
    // content can grow and shrink
    flexGrow: 1,
    flexShrink: 1,
    // ellipsis for overflow text
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $2e2a1af4d1fbd513$var$iconStyles = (0, $7njhD.xcss)({
    display: "flex",
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: "center",
    fontSize: 0,
    lineHeight: 0,
    userSelect: "none"
});
var $2e2a1af4d1fbd513$var$commonStyles = (0, $7njhD.xcss)({
    transition: "opacity 0.3s"
});
var $2e2a1af4d1fbd513$var$fadeStyles = (0, $7njhD.xcss)({
    opacity: 0
});
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $2e2a1af4d1fbd513$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? "text" : _ref$type, hasOverlay = _ref.hasOverlay;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5fQdm.default), {
        as: "span",
        xcss: [
            $2e2a1af4d1fbd513$var$commonStyles
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(type === "text" ? [
            $2e2a1af4d1fbd513$var$textStyles
        ] : [
            $2e2a1af4d1fbd513$var$iconStyles
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(hasOverlay ? [
            $2e2a1af4d1fbd513$var$fadeStyles
        ] : []))
    }, children);
};
var $2e2a1af4d1fbd513$export$2e2bcd8739ae039 = $2e2a1af4d1fbd513$var$Content;

});

parcelRegister("frbhL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3d221b9480c71f0$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $aU14p = parcelRequire("aU14p");

var $8p2GL = parcelRequire("8p2GL");

var $grYZC = parcelRequire("grYZC");

var $5fUc4 = parcelRequire("5fUc4");

var $5fQdm = parcelRequire("5fQdm");
var $7njhD = parcelRequire("7njhD");

var $8nnae = parcelRequire("8nnae");

var $dEwpA = parcelRequire("dEwpA");

var $6Dmxh = parcelRequire("6Dmxh");
function $b3d221b9480c71f0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b3d221b9480c71f0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b3d221b9480c71f0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b3d221b9480c71f0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Include modified onClick with analytics
var $b3d221b9480c71f0$var$overlayStyles = (0, $7njhD.xcss)({
    position: "absolute",
    insetInlineStart: "space.0",
    insetBlockStart: "space.0",
    insetInlineEnd: "space.0",
    insetBlockEnd: "space.0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
/**
 * __Use button base__
 *
 * A React hook that accepts a set of common Button props,
 * and processes them to return consistent base props for usage
 * across various Button components.
 *
 * It also:
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $b3d221b9480c71f0$var$useButtonBase = function useButtonBase(_ref) {
    var analyticsContext = _ref.analyticsContext, _ref$appearance = _ref.appearance, propAppearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, buttonType = _ref.buttonType, interactionName = _ref.interactionName, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $8p2GL.default) : _ref$onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, overlay = _ref.overlay, ref = _ref.ref, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? "default" : _ref$spacing;
    var ourRef = (0, $9nHZC.useRef)();
    var splitButtonContext = (0, $8nnae.useSplitButtonContext)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var appearance = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || propAppearance;
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isHighlighted = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isHighlighted) || false;
    var isActiveOverSelected = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isActiveOverSelected) || false;
    var setRef = (0, $9nHZC.useCallback)(function(node) {
        ourRef.current = node;
        if (ref === null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    (0, $grYZC.default)(ourRef, autoFocus);
    var interactionContext = (0, $9nHZC.useContext)((0, $5fUc4.default));
    var handleClick = (0, $9nHZC.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $aU14p.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "16.18.1",
        analyticsData: analyticsContext,
        actionSubject: buttonType
    });
    var buttonXCSS = (0, $9nHZC.useMemo)(function() {
        return (0, $6Dmxh.getXCSS)({
            appearance: appearance,
            spacing: spacing,
            isDisabled: isDisabled,
            isSelected: isSelected,
            isHighlighted: isHighlighted,
            isActiveOverSelected: isActiveOverSelected,
            shouldFitContainer: shouldFitContainer,
            isIconButton: isIconButton,
            isCircle: isCircle,
            hasOverlay: Boolean(overlay),
            isLink: buttonType === "link",
            hasIconBefore: hasIconBefore,
            hasIconAfter: hasIconAfter,
            isSplit: isSplitButton,
            isNavigationSplit: isNavigationSplitButton
        });
    }, [
        appearance,
        buttonType,
        spacing,
        isDisabled,
        isSelected,
        isHighlighted,
        isActiveOverSelected,
        isIconButton,
        isCircle,
        shouldFitContainer,
        overlay,
        hasIconBefore,
        hasIconAfter,
        isSplitButton,
        isNavigationSplitButton
    ]);
    var isEffectivelyDisabled = isDisabled || Boolean(overlay);
    return $b3d221b9480c71f0$var$_objectSpread({
        ref: setRef,
        xcss: buttonXCSS,
        // Consider overlay buttons to be effectively disabled
        isDisabled: isEffectivelyDisabled,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, children, overlay ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5fQdm.default), {
            as: "span",
            xcss: $b3d221b9480c71f0$var$overlayStyles
        }, overlay) : null)
    }, (0, $dEwpA.default)(isEffectivelyDisabled, {
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }));
};
var $b3d221b9480c71f0$export$2e2bcd8739ae039 = $b3d221b9480c71f0$var$useButtonBase;

});
parcelRegister("8nnae", function(module, exports) {

$parcel$export(module.exports, "useSplitButtonContext", function () { return $6192709ed31ac7bd$export$47e2c6fdb142d947; });

var $9nHZC = parcelRequire("9nHZC");
var $6192709ed31ac7bd$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $9nHZC.createContext)(undefined);
var $6192709ed31ac7bd$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $9nHZC.useContext)($6192709ed31ac7bd$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === "navigation") {
        var newContext = {
            spacing: "default",
            appearance: "subtle",
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("dEwpA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f082719652c61b3$export$2e2bcd8739ae039; });
function $9f082719652c61b3$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $9f082719652c61b3$var$tabKeyCode = 9;
function $9f082719652c61b3$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $9f082719652c61b3$var$tabKeyCode) return;
    $9f082719652c61b3$var$abort(event);
}
function $9f082719652c61b3$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $9f082719652c61b3$var$abort,
        onMouseUpCapture: $9f082719652c61b3$var$abort,
        onKeyDownCapture: $9f082719652c61b3$var$onKey,
        onKeyUpCapture: $9f082719652c61b3$var$onKey,
        onTouchStartCapture: $9f082719652c61b3$var$abort,
        onTouchEndCapture: $9f082719652c61b3$var$abort,
        onPointerDownCapture: $9f082719652c61b3$var$abort,
        onPointerUpCapture: $9f082719652c61b3$var$abort,
        onClickCapture: $9f082719652c61b3$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $9f082719652c61b3$var$abort
    } : events;
}

});

parcelRegister("6Dmxh", function(module, exports) {

$parcel$export(module.exports, "getXCSS", function () { return $4d47ddbe1e1a8b3b$export$f9dc8dc4cff30fc6; });

var $kFnE9 = parcelRequire("kFnE9");

var $7njhD = parcelRequire("7njhD");

var $aP6k3 = parcelRequire("aP6k3");

var $bXDaL = parcelRequire("bXDaL");
function $4d47ddbe1e1a8b3b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4d47ddbe1e1a8b3b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4d47ddbe1e1a8b3b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4d47ddbe1e1a8b3b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4d47ddbe1e1a8b3b$var$fontSize = (0, $aP6k3.fontSize)();
var $4d47ddbe1e1a8b3b$export$6c2552e9776539bb = {
    default: "".concat(32 / $4d47ddbe1e1a8b3b$var$fontSize, "em"),
    compact: "".concat(24 / $4d47ddbe1e1a8b3b$var$fontSize, "em"),
    none: "auto"
};
var $4d47ddbe1e1a8b3b$var$lineHeights = {
    default: $4d47ddbe1e1a8b3b$export$6c2552e9776539bb.default,
    compact: $4d47ddbe1e1a8b3b$export$6c2552e9776539bb.compact,
    none: "inherit"
};
var $4d47ddbe1e1a8b3b$var$paddingInline = {
    default: {
        default: "space.150",
        withIcon: "space.100"
    },
    compact: {
        default: "space.150",
        withIcon: "space.100"
    },
    none: {
        default: "space.0",
        withIcon: "space.0"
    }
};
var $4d47ddbe1e1a8b3b$var$gap = {
    compact: "space.050",
    default: "space.050",
    none: "space.0"
};
var $4d47ddbe1e1a8b3b$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $4d47ddbe1e1a8b3b$var$splitBorderStyles = {
    ":focus-visible": {
        zIndex: 1
    }
};
function $4d47ddbe1e1a8b3b$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key;
    return group[key] || group.default;
}
function $4d47ddbe1e1a8b3b$var$getColors(_ref2) {
    var appearance = _ref2.appearance, _ref2$interactionStat = _ref2.interactionState, interactionState = _ref2$interactionStat === void 0 ? "default" : _ref2$interactionStat, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, isHighlighted = _ref2.isHighlighted, isActiveOverSelected = _ref2.isActiveOverSelected, hasOverlay = _ref2.hasOverlay;
    var key = interactionState;
    // Overlay does not change color on interaction, revert to 'default' or resting state
    key = hasOverlay ? "default" : key;
    key = isSelected || isHighlighted ? isActiveOverSelected ? "active" : "selected" : key;
    // Disabled colors overrule everything else
    key = isDisabled ? "disabled" : key;
    return {
        backgroundColor: $4d47ddbe1e1a8b3b$var$getColor({
            group: (0, $bXDaL.default).background[appearance],
            key: key
        }),
        color: "".concat($4d47ddbe1e1a8b3b$var$getColor({
            group: (0, $bXDaL.default).color[appearance],
            key: key
        }))
    };
}
function $4d47ddbe1e1a8b3b$export$f9dc8dc4cff30fc6(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, isDisabled = _ref3.isDisabled, isSelected = _ref3.isSelected, isHighlighted = _ref3.isHighlighted, isActiveOverSelected = _ref3.isActiveOverSelected, isIconButton = _ref3.isIconButton, isCircle = _ref3.isCircle, shouldFitContainer = _ref3.shouldFitContainer, isLink = _ref3.isLink, isSplit = _ref3.isSplit, isNavigationSplit = _ref3.isNavigationSplit, hasOverlay = _ref3.hasOverlay, hasIconBefore = _ref3.hasIconBefore, hasIconAfter = _ref3.hasIconAfter;
    var baseColors = $4d47ddbe1e1a8b3b$var$getColors({
        appearance: appearance,
        isSelected: isSelected,
        isHighlighted: isHighlighted,
        isActiveOverSelected: isActiveOverSelected,
        isDisabled: isDisabled
    });
    var combinedBaseColorStyles = isLink ? $4d47ddbe1e1a8b3b$var$_objectSpread($4d47ddbe1e1a8b3b$var$_objectSpread({}, baseColors), {}, {
        textDecoration: "none",
        // Disabling visited styles (by re-declaring the base colors)
        ":visited": baseColors
    }) : isNavigationSplit && !isSelected ? $4d47ddbe1e1a8b3b$var$_objectSpread($4d47ddbe1e1a8b3b$var$_objectSpread({}, baseColors), {}, {
        backgroundColor: "color.background.neutral.subtle"
    }) : baseColors;
    var height = $4d47ddbe1e1a8b3b$export$6c2552e9776539bb[spacing];
    var width = shouldFitContainer ? "100%" : "auto";
    width = isIconButton ? isNavigationSplit ? "24px" : height : width;
    var defaultPaddingInlineStart = $4d47ddbe1e1a8b3b$var$paddingInline[spacing][hasIconBefore ? "withIcon" : "default"];
    var defaultPaddingInlineEnd = $4d47ddbe1e1a8b3b$var$paddingInline[spacing][hasIconAfter ? "withIcon" : "default"];
    var splitButtonStyles = isSplit ? $4d47ddbe1e1a8b3b$var$splitBorderStyles : {};
    var getNavigationSplitButtonPaddings = function getNavigationSplitButtonPaddings() {
        if (isNavigationSplit) return {
            paddingInlineStart: "space.075",
            paddingInlineEnd: "space.075"
        };
        return {
            paddingInlineStart: isIconButton ? "space.0" : defaultPaddingInlineStart,
            paddingInlineEnd: isIconButton ? "space.0" : defaultPaddingInlineEnd
        };
    };
    var _getNavigationSplitBu = getNavigationSplitButtonPaddings(), paddingInlineStart = _getNavigationSplitBu.paddingInlineStart, paddingInlineEnd = _getNavigationSplitBu.paddingInlineEnd;
    return (0, $7njhD.xcss)($4d47ddbe1e1a8b3b$var$_objectSpread($4d47ddbe1e1a8b3b$var$_objectSpread($4d47ddbe1e1a8b3b$var$_objectSpread({
        alignItems: "baseline",
        borderWidth: "border.width.0",
        borderRadius: isCircle && !isSplit ? "border.radius.circle" : "border.radius.100",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        fontFamily: "inherit",
        fontWeight: 500,
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap",
        height: height,
        lineHeight: $4d47ddbe1e1a8b3b$var$lineHeights[spacing],
        paddingBlock: "space.0",
        paddingInlineStart: paddingInlineStart,
        paddingInlineEnd: paddingInlineEnd,
        columnGap: $4d47ddbe1e1a8b3b$var$gap[spacing],
        verticalAlign: $4d47ddbe1e1a8b3b$var$verticalAlign[spacing],
        width: width,
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center"
    }, combinedBaseColorStyles), isDisabled || hasOverlay ? {
        cursor: "not-allowed"
    } : {}), {}, {
        ":hover": $4d47ddbe1e1a8b3b$var$_objectSpread($4d47ddbe1e1a8b3b$var$_objectSpread({}, $4d47ddbe1e1a8b3b$var$getColors({
            appearance: appearance,
            isSelected: isNavigationSplit && !isSelected ? false : isSelected,
            isActiveOverSelected: isActiveOverSelected,
            isDisabled: isDisabled,
            interactionState: "hover",
            hasOverlay: hasOverlay
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "none",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        ":active": $4d47ddbe1e1a8b3b$var$_objectSpread($4d47ddbe1e1a8b3b$var$_objectSpread({}, $4d47ddbe1e1a8b3b$var$getColors({
            appearance: appearance,
            isSelected: isNavigationSplit && !isSelected ? false : isSelected,
            isActiveOverSelected: isActiveOverSelected,
            isDisabled: isDisabled,
            interactionState: "active",
            hasOverlay: hasOverlay
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        })
    }, splitButtonStyles));
}

});
parcelRegister("bXDaL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b53973e6978daf0$export$2e2bcd8739ae039; });

var $jp7ng = parcelRequire("jp7ng");
var $8b53973e6978daf0$var$values = {
    // Default appearance
    background: {
        default: {
            /**
       * Some colors need specific fallback colors specified
       * to match the original Button when no theme is active.
       *
       * This is because the `xcss` automatic token fallbacks use
       * the legacy themes, which do not match original colors.
       */ // @ts-expect-error
            default: "var(--ds-background-neutral, ".concat($jp7ng.N20A, ")"),
            hover: "color.background.neutral.hovered",
            active: "color.background.neutral.pressed",
            // @ts-expect-error
            disabled: "var(--ds-background-disabled, ".concat($jp7ng.N20A, ")"),
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($jp7ng.N700, ")")
        },
        primary: {
            default: "color.background.brand.bold",
            hover: "color.background.brand.bold.hovered",
            active: "color.background.brand.bold.pressed",
            // @ts-expect-error
            disabled: "var(--ds-background-disabled, ".concat($jp7ng.N20A, ")"),
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($jp7ng.N700, ")")
        },
        warning: {
            default: "color.background.warning.bold",
            hover: "color.background.warning.bold.hovered",
            active: "color.background.warning.bold.pressed",
            // @ts-expect-error
            disabled: "var(--ds-background-disabled, ".concat($jp7ng.N20A, ")"),
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($jp7ng.Y400, ")")
        },
        danger: {
            default: "color.background.danger.bold",
            hover: "color.background.danger.bold.hovered",
            active: "color.background.danger.bold.pressed",
            // @ts-expect-error
            disabled: "var(--ds-background-disabled, ".concat($jp7ng.N20A, ")"),
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($jp7ng.R500, ")")
        },
        link: {
            default: "color.background.neutral.subtle",
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($jp7ng.N700, ")")
        },
        subtle: {
            default: "color.background.neutral.subtle",
            hover: "color.background.neutral.subtle.hovered",
            active: "color.background.neutral.subtle.pressed",
            // @ts-expect-error
            disabled: "var(--ds-background-neutral-subtle, none)",
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($jp7ng.N700, ")")
        },
        "subtle-link": {
            default: "color.background.neutral.subtle",
            // @ts-expect-error
            selected: "var(--ds-background-selected, ".concat($jp7ng.N700, ")")
        }
    },
    color: {
        default: {
            default: "color.text",
            active: "color.text",
            disabled: "color.text.disabled",
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($jp7ng.N20, ")")
        },
        primary: {
            default: "color.text.inverse",
            disabled: "color.text.disabled",
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($jp7ng.N20, ")")
        },
        warning: {
            default: "color.text.warning.inverse",
            disabled: "color.text.disabled",
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($jp7ng.N800, ")")
        },
        danger: {
            default: "color.text.inverse",
            disabled: "color.text.disabled",
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($jp7ng.N0, ")")
        },
        link: {
            default: "color.link",
            hover: "color.link",
            active: "color.link.pressed",
            disabled: "color.text.disabled",
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($jp7ng.N20, ")")
        },
        subtle: {
            default: "color.text",
            active: "color.text",
            disabled: "color.text.disabled",
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($jp7ng.N20, ")")
        },
        "subtle-link": {
            default: "color.text.subtle",
            hover: "color.text.subtle",
            active: "color.text",
            disabled: "color.text.disabled",
            // @ts-expect-error
            selected: "var(--ds-text-selected, ".concat($jp7ng.N20, ")")
        }
    }
};
var $8b53973e6978daf0$export$2e2bcd8739ae039 = $8b53973e6978daf0$var$values;

});





parcelRegister("fbBdr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0e4c05a4d0bdc92$var$_react = $b0e4c05a4d0bdc92$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $b0e4c05a4d0bdc92$var$_arrowLeft = $b0e4c05a4d0bdc92$var$_interopRequireDefault((parcelRequire("8vQG8")));
function $b0e4c05a4d0bdc92$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b0e4c05a4d0bdc92$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $b0e4c05a4d0bdc92$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.207 5.793a1 1 0 0 1 0 1.414L8.414 11H18a1 1 0 1 1 0 2H8.414l3.793 3.793a1 1 0 1 1-1.415 1.414l-5.499-5.5A1 1 0 0 1 5 12.028v-.057a1 1 0 0 1 .293-.678l5.499-5.5a1 1 0 0 1 1.415 0" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $b0e4c05a4d0bdc92$var$_arrowLeft.default
    }));
$b0e4c05a4d0bdc92$var$ArrowLeftIcon.displayName = "ArrowLeftIcon";
var $b0e4c05a4d0bdc92$var$_default = module.exports.default = $b0e4c05a4d0bdc92$var$ArrowLeftIcon;

});
parcelRegister("8vQG8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9e1fd7b933e999b25f94bae27a6bfcd2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $632a14e001b6457d$var$_react = $632a14e001b6457d$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $632a14e001b6457d$var$_UNSAFE_baseNew = $632a14e001b6457d$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $632a14e001b6457d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $632a14e001b6457d$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $632a14e001b6457d$var$_react.default.createElement($632a14e001b6457d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 8H15M6.75 3l-5 5 5 5"/>`
    }, props));
$632a14e001b6457d$var$ArrowLeftIcon.displayName = "ArrowLeftIcon";
var $632a14e001b6457d$var$_default = module.exports.default = $632a14e001b6457d$var$ArrowLeftIcon;

});


parcelRegister("fPv7t", function(module, exports) {

$parcel$export(module.exports, "FocusedNavigationWrapper", function () { return $9f16d239366ece58$export$820b92e6106334d8; });

var $2xJU3 = parcelRequire("2xJU3");

var $h39Sh = parcelRequire("h39Sh");
const $9f16d239366ece58$export$820b92e6106334d8 = (0, $2xJU3.default)("div", {
    target: "e95vuix0"
})({
    paddingTop: (0, $h39Sh.default)("space.600", "48px"),
    paddingLeft: (0, $h39Sh.default)("space.200", "16px"),
    display: "flex",
    height: "100vh"
}, "");

});


parcelRegister("475If", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da936f88ef5b971b$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $jY575 = parcelRequire("jY575");

var $7ovNJ = parcelRequire("7ovNJ");

var $agjvf = parcelRequire("agjvf");

var $8shKB = parcelRequire("8shKB");

var $3h7Y3 = parcelRequire("3h7Y3");

var $7kuwP = parcelRequire("7kuwP");
var $6Z1Zq = parcelRequire("6Z1Zq");
var $1HkF5 = parcelRequire("1HkF5");
var $lemjF = parcelRequire("lemjF");

var $bnZ0o = parcelRequire("bnZ0o");

var $1al9v = parcelRequire("1al9v");
parcelRequire("jjXrn");
var $3YYFd = parcelRequire("3YYFd");
var $jjXrn = parcelRequire("jjXrn");
const $da936f88ef5b971b$var$COLLAPSE_TOGGLE_SHORTCUT = "[";
const $da936f88ef5b971b$var$OPEN_STATE = {
    EXPANDED: "expanded",
    COLLAPSED: "collapsed"
};

const $da936f88ef5b971b$var$HorizontalNav = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3h7Y3.NavigationSkeleton), {
            primaryItemsCount: 5,
            secondaryItemsCount: 2,
            shouldShowSearch: true
        }),
    loader: ()=>(parcelRequire("4c2RV")),
    modules: [
        "./horizontal-nav/horizontal-navigation"
    ],
    webpack: ()=>[
            undefined("./horizontal-nav/horizontal-navigation")
        ]
});

const $da936f88ef5b971b$var$MobileNav = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: ()=>null,
    loader: ()=>(parcelRequire("cdMcU")),
    modules: [
        "./horizontal-nav/mobile-navigation/horizontal-mobile-nav"
    ],
    webpack: ()=>[
            undefined("./horizontal-nav/mobile-navigation/horizontal-mobile-nav")
        ]
});
const $da936f88ef5b971b$var$buildUiController = (0, $7ovNJ.default)((isMobileHeaderActive, isInitiallyCollapsed)=>({
        isResizeDisabled: isMobileHeaderActive,
        isCollapsed: isInitiallyCollapsed
    }));
class $da936f88ef5b971b$export$1ffc32beef4142df extends (0, $9nHZC.PureComponent) {
    constructor(...args){
        super(...args);
        this.isGlobalNavHidden = ()=>{
            const { isMobileHeaderActive: isMobileHeaderActive, isBeingRenderedInsideMobileNav: isBeingRenderedInsideMobileNav } = this.props;
            return isMobileHeaderActive && !isBeingRenderedInsideMobileNav;
        };
        this.renderGlobalNavigation = ()=>{
            const showMobileNav = this.shouldRenderGlobalNavMobile();
            const showHNav = this.shouldRenderGlobalNavHorizontal();
            if (!showHNav && !showMobileNav) return null;
            const { containerBitbucketActions: containerBitbucketActions, containerConnectActions: containerConnectActions, containerHref: containerHref, containerLogo: containerLogo, containerName: containerName, createDrawerHeaderLinkComponent: createDrawerHeaderLinkComponent, currentProject: currentProject, globalBitbucketActions: globalBitbucketActions, horizontalNavigationItems: horizontalNavigationItems, isGlobalContext: isGlobalContext, isPrivate: isPrivate, linkComponent: linkComponent, switchAccountUrl: switchAccountUrl, manageAccountUrl: manageAccountUrl, loginUrl: loginUrl, logoutUrl: logoutUrl, onCloneClick: onCloneClick, onCreateDrawerClose: onCreateDrawerClose, onSearch: onSearch, onSearchDrawerInit: onSearchDrawerInit, onSearchSubmit: onSearchSubmit, pullRequestLinkComponent: pullRequestLinkComponent, recentlyViewed: recentlyViewed, recentlyViewedWorkspacesKeys: recentlyViewedWorkspacesKeys, repoName: repoName, repositoryLinkComponent: repositoryLinkComponent, repoSlug: repoSlug, searchQuery: searchQuery, userAvatarUrl: userAvatarUrl, userEmail: userEmail, userDisplayName: userDisplayName, userUuid: userUuid, userWorkspaceId: userWorkspaceId, onKeyboardShortcutsActivated: onKeyboardShortcutsActivated, onFeedbackModalOpen: onFeedbackModalOpen, adminHubUrl: adminHubUrl, attributionsUrl: attributionsUrl, whatsNewUrl: whatsNewUrl, onToggleAtlassianSwitcher: onToggleAtlassianSwitcher, isAtlassianSwitcherOpen: isAtlassianSwitcherOpen, isOrgAdmin: isOrgAdmin, isWorkspaceAdmin: isWorkspaceAdmin, hasCompassTabFeatureNonAdmins: hasCompassTabFeatureNonAdmins, workspaceOrgId: workspaceOrgId, publishUiEvent: publishUiEvent, useContainerNavigationProps: useContainerNavigationProps, isSearchDrawerOpen: isSearchDrawerOpen, onSearchDrawerClose: onSearchDrawerClose, onSearchDrawerOpen: onSearchDrawerOpen, workspaceLinkComponent: workspaceLinkComponent, hasPride: hasPride, currentRepository: currentRepository, currentWorkspace: currentWorkspace, currentUser: currentUser, environment: environment, tenantId: tenantId, isNavThemeSelectorEnabled: isNavThemeSelectorEnabled } = this.props;
            const drawerHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $bnZ0o.default), {
                isGlobalContext: isGlobalContext,
                isPrivate: isPrivate,
                href: containerHref,
                name: containerName,
                logo: containerLogo,
                linkComponent: createDrawerHeaderLinkComponent
            });
            if (showMobileNav) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($da936f88ef5b971b$var$MobileNav, {
                avatarUrl: userAvatarUrl,
                environment: environment,
                containerBitbucketActions: containerBitbucketActions,
                containerConnectActions: containerConnectActions,
                currentProject: currentProject,
                drawerHeader: drawerHeader,
                globalBitbucketActions: globalBitbucketActions,
                switchAccountUrl: switchAccountUrl,
                manageAccountUrl: manageAccountUrl,
                loginUrl: loginUrl,
                logoutUrl: logoutUrl,
                menuItems: horizontalNavigationItems || {
                    mainItems: [],
                    secondaryItems: [],
                    settingsItems: []
                },
                isLoggedIn: Boolean(userUuid),
                linkComponent: linkComponent,
                onCloneClick: onCloneClick,
                onCreateDrawerClose: onCreateDrawerClose,
                onSearch: onSearch,
                onSearchDrawerInit: onSearchDrawerInit,
                onSearchSubmit: onSearchSubmit,
                isSearchDrawerOpen: isSearchDrawerOpen,
                onSearchDrawerClose: onSearchDrawerClose,
                onSearchDrawerOpen: onSearchDrawerOpen,
                pullRequestLinkComponent: pullRequestLinkComponent,
                recentlyViewed: recentlyViewed,
                recentlyViewedWorkspacesKeys: recentlyViewedWorkspacesKeys,
                repoName: repoName,
                repositoryLinkComponent: repositoryLinkComponent,
                repoSlug: repoSlug,
                searchQuery: searchQuery,
                userAvatarUrl: userAvatarUrl,
                userEmail: userEmail,
                userDisplayName: userDisplayName,
                userUuid: userUuid,
                userWorkspaceId: userWorkspaceId,
                onKeyboardShortcutsActivated: onKeyboardShortcutsActivated,
                onFeedbackModalOpen: onFeedbackModalOpen,
                adminHubUrl: adminHubUrl,
                attributionsUrl: attributionsUrl,
                whatsNewUrl: whatsNewUrl,
                onToggleAtlassianSwitcher: onToggleAtlassianSwitcher,
                isAtlassianSwitcherOpen: isAtlassianSwitcherOpen,
                isOrgAdmin: isOrgAdmin,
                isWorkspaceAdmin: isWorkspaceAdmin,
                hasCompassTabFeatureNonAdmins: hasCompassTabFeatureNonAdmins,
                workspaceOrgId: workspaceOrgId,
                publishUiEvent: publishUiEvent,
                useContainerNavigationProps: useContainerNavigationProps,
                containerHref: containerHref,
                containerName: containerName,
                handleProductClick: this.handleProductClick,
                workspaceLinkComponent: workspaceLinkComponent,
                currentRepository: currentRepository,
                currentWorkspace: currentWorkspace,
                currentUser: currentUser,
                isNavThemeSelectorEnabled: isNavThemeSelectorEnabled
            });
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($da936f88ef5b971b$var$HorizontalNav, {
                hasPride: hasPride,
                avatarUrl: userAvatarUrl,
                environment: environment,
                containerBitbucketActions: containerBitbucketActions,
                containerConnectActions: containerConnectActions,
                currentProject: currentProject,
                drawerHeader: drawerHeader,
                globalBitbucketActions: globalBitbucketActions,
                switchAccountUrl: switchAccountUrl,
                manageAccountUrl: manageAccountUrl,
                loginUrl: loginUrl,
                logoutUrl: logoutUrl,
                menuItems: horizontalNavigationItems || {
                    mainItems: [],
                    secondaryItems: [],
                    settingsItems: []
                },
                isLoggedIn: Boolean(userUuid),
                linkComponent: linkComponent,
                onCloneClick: onCloneClick,
                onCreateDrawerClose: onCreateDrawerClose,
                onSearch: onSearch,
                onSearchDrawerInit: onSearchDrawerInit,
                isSearchDrawerOpen: isSearchDrawerOpen,
                onSearchDrawerClose: onSearchDrawerClose,
                onSearchDrawerOpen: onSearchDrawerOpen,
                onSearchSubmit: onSearchSubmit,
                pullRequestLinkComponent: pullRequestLinkComponent,
                recentlyViewed: recentlyViewed,
                recentlyViewedWorkspacesKeys: recentlyViewedWorkspacesKeys,
                repoName: repoName,
                repositoryLinkComponent: repositoryLinkComponent,
                repoSlug: repoSlug,
                searchQuery: searchQuery,
                userAvatarUrl: userAvatarUrl,
                userEmail: userEmail,
                userDisplayName: userDisplayName,
                userUuid: userUuid,
                userWorkspaceId: userWorkspaceId,
                onKeyboardShortcutsActivated: onKeyboardShortcutsActivated,
                onFeedbackModalOpen: onFeedbackModalOpen,
                adminHubUrl: adminHubUrl,
                attributionsUrl: attributionsUrl,
                whatsNewUrl: whatsNewUrl,
                onToggleAtlassianSwitcher: onToggleAtlassianSwitcher,
                isAtlassianSwitcherOpen: isAtlassianSwitcherOpen,
                isOrgAdmin: isOrgAdmin,
                isWorkspaceAdmin: isWorkspaceAdmin,
                hasCompassTabFeatureNonAdmins: hasCompassTabFeatureNonAdmins,
                workspaceOrgId: workspaceOrgId,
                handleProductClick: this.handleProductClick,
                publishUiEvent: publishUiEvent,
                workspaceLinkComponent: workspaceLinkComponent,
                currentRepository: currentRepository,
                currentWorkspace: currentWorkspace,
                currentUser: currentUser,
                tenantId: tenantId,
                isNavThemeSelectorEnabled: isNavThemeSelectorEnabled
            });
        };
        this.handleGlobalKeyDown = (e)=>{
            const { isAtlassianSwitcherOpen: isAtlassianSwitcherOpen, isCreateDrawerOpen: isCreateDrawerOpen, isSearchDrawerOpen: isSearchDrawerOpen, onSearchDrawerClose: onSearchDrawerClose, onCreateDrawerClose: onCreateDrawerClose, onToggleAtlassianSwitcher: onToggleAtlassianSwitcher } = this.props;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($jY575)))(e) === "esc") {
                if (isCreateDrawerOpen) onCreateDrawerClose();
                else if (isSearchDrawerOpen) onSearchDrawerClose();
                else if (isAtlassianSwitcherOpen) onToggleAtlassianSwitcher(false);
            }
        };
        this.handleProductClick = (e)=>{
            const { onProductClick: onProductClick } = this.props;
            // Following checks are for not preventing the "open in tab" action:
            if (e.metaKey) // e.metaKey is 'true' for cmd + click on Mac.
            return;
            if (e.ctrlKey) // e.ctrlKey is 'true' for ctrl + click on Windows.
            return;
            if (e.button === 1) // e.button is '1' when mouse middle button is clicked.
            return;
            if (Boolean(this.props.userUuid) && onProductClick) {
                // 'preventDefault' is to avoid full page reload for SPA transitions.
                e.preventDefault();
                onProductClick();
            }
        };
        this.handleResize = (isOpen)=>{
            this.props.onResize({
                isOpen: isOpen
            });
        };
        this.getThemeMode = ()=>{
            let themeMode = (0, $3YYFd.light);
            if (this.props.hasSettingsNavTheme) themeMode = (0, $jjXrn.settings);
            else if (this.props.hasSiteSettingsNavTheme) themeMode = (0, $3YYFd.settings);
            else if (this.props.hasDarkNavTheme) themeMode = (0, $3YYFd.dark);
            return themeMode;
        };
        this.handleRefs = ({ expandCollapseAffordance: expandCollapseAffordance }, isCollapsed)=>{
            // There is no other way to pass expand/collapse button element a unique
            // selector for the E2E tests.
            if (expandCollapseAffordance.current) {
                const element = expandCollapseAffordance.current;
                element.setAttribute("data-qa-id", "expand-collapse-button");
                element.setAttribute("data-qa-open-state", isCollapsed ? $da936f88ef5b971b$var$OPEN_STATE.COLLAPSED : $da936f88ef5b971b$var$OPEN_STATE.EXPANDED);
            }
        };
        this.getDefaultIsCollapsedState = ()=>{
            if (this.props.isMobileHeaderActive) return false;
            else return !this.props.defaultNavigationOpen;
        };
        this.shouldRenderGlobalNavHorizontal = ()=>!this.props.isMobileHeaderActive && !this.props.isBeingRenderedInsideMobileNav;
        this.shouldRenderGlobalNavMobile = ()=>this.props.isMobileHeaderActive && this.props.isBeingRenderedInsideMobileNav;
        this.shouldRenderGlobalNavVertical = ()=>this.props.isBeingRenderedInsideMobileNav;
        this.shouldRenderContainerNav = ()=>{
            if (this.props.isMobileHeaderActive) return false;
            else if (this.props.navigationType === "product") return false;
            else return window.location.pathname !== "/" && window.location.pathname.indexOf("/dashboard/") !== 0 && window.location.pathname.indexOf("/account/settings/") !== 0 && window.location.pathname.indexOf("/account/workspaces/") !== 0;
        };
        this.hideGlobalSideNav = ()=>this.isGlobalNavHidden() && window.location.pathname.indexOf("/dashboard/") === 0;
    }
    componentDidMount() {
        window.addEventListener("keydown", this.handleGlobalKeyDown);
    }
    componentWillUnmount() {
        window.removeEventListener("keydown", this.handleGlobalKeyDown);
    }
    // We want to hide the "global" blue navigation if any of these cases is true:
    // a. we are in mobile nav mode AND this instance of the nav is NOT being rendered inside the mobile nav
    // b. horizontal nav is enabled and we're on the dashboard
    // This is a bit of a hack since Atlaskit doesn't really work with AUI
    // see https://ecosystem.atlassian.net/browse/AK-3456
    // @ts-ignore TODO: fix noImplicitAny error here
    // @ts-ignore TODO: fix noImplicitAny error here
    // When rendering outside of the mobile navigation, the "global" navigation is rendered either
    // horizontally (persistent horizontal white bar).
    // When rendering *inside* the mobile navigation, the "global" navigation is hidden until the
    // menu icon is clicked. Once the menu is clicked the global nav shows as a vertical white bar
    // The "container" navigation is the route-specific navigation i.e. the "gray" nav area.
    // It is always rendered inside the mobile nav.
    // Outside of the mobile nav, it is always rendered unless the horizontal nav feature is
    // enabled AND the user is on a /dashboard, /, /account/settings/ and /account/workspaces/ routes.
    render() {
        const { intl: intl, isMobileHeaderActive: isMobileHeaderActive, navigationType: navigationType, containerNavigationComponent: containerNavigationComponent, topOffset: topOffset } = this.props;
        const containerNavigation = navigationType === "container" ? containerNavigationComponent : null;
        const shouldRenderGlobalNavHorizontal = this.shouldRenderGlobalNavHorizontal();
        const shouldRenderGlobalNavVertical = this.shouldRenderGlobalNavVertical();
        const shouldRenderContainerNav = this.shouldRenderContainerNav();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $1HkF5.ThemeProvider), {
            theme: (theme)=>({
                    ...theme,
                    mode: this.getThemeMode()
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6Z1Zq.default), {
            initialUIController: $da936f88ef5b971b$var$buildUiController(isMobileHeaderActive, this.getDefaultIsCollapsedState())
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $lemjF.default), null, (uiController)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7kuwP.default), {
                experimental_horizontalGlobalNav: shouldRenderGlobalNavHorizontal || !shouldRenderContainerNav,
                showContextualNavigation: shouldRenderContainerNav,
                topOffset: topOffset,
                productNavigation: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", null),
                containerNavigation: shouldRenderContainerNav && containerNavigation,
                collapseToggleTooltipContent: ()=>({
                        text: intl.formatMessage((0, $1al9v.default).resizerButtonLabel),
                        char: $da936f88ef5b971b$var$COLLAPSE_TOGGLE_SHORTCUT
                    }),
                onExpandStart: ()=>{
                    this.handleResize(true);
                },
                onCollapseStart: ()=>{
                    this.handleResize(false);
                },
                experimental_flyoutOnHover: true,
                experimental_alternateFlyoutBehaviour: true,
                experimental_fullWidthFlyout: true,
                shouldHideGlobalNavShadow: shouldRenderGlobalNavVertical,
                globalNavigation: this.renderGlobalNavigation,
                getRefs: (refs)=>this.handleRefs(refs, uiController.state.isCollapsed)
            }, this.props.children))));
    }
}
$da936f88ef5b971b$export$1ffc32beef4142df.defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */ hasPride: false,
    hasSettingsNavTheme: false,
    hasSiteSettingsNavTheme: false,
    containerNavigationComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", null)
};
var $da936f88ef5b971b$export$2e2bcd8739ae039 = (0, $agjvf.injectIntl)($da936f88ef5b971b$export$1ffc32beef4142df);

});
parcelRegister("jY575", function(module, exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && "object" === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ("number" === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && "object" === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === "string") {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === "number") return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    "backspace": 8,
    "tab": 9,
    "enter": 13,
    "shift": 16,
    "ctrl": 17,
    "alt": 18,
    "pause/break": 19,
    "caps lock": 20,
    "esc": 27,
    "space": 32,
    "page up": 33,
    "page down": 34,
    "end": 35,
    "home": 36,
    "left": 37,
    "up": 38,
    "right": 39,
    "down": 40,
    "insert": 45,
    "delete": 46,
    "command": 91,
    "left command": 91,
    "right command": 93,
    "numpad *": 106,
    "numpad +": 107,
    "numpad -": 109,
    "numpad .": 110,
    "numpad /": 111,
    "num lock": 144,
    "scroll lock": 145,
    "my computer": 182,
    "my calculator": 183,
    ";": 186,
    "=": 187,
    ",": 188,
    "-": 189,
    ".": 190,
    "/": 191,
    "`": 192,
    "[": 219,
    "\\": 220,
    "]": 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    "windows": 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    "ctl": 17,
    "control": 17,
    "option": 18,
    "pause": 19,
    "break": 19,
    "caps": 20,
    "return": 13,
    "escape": 27,
    "spc": 32,
    "spacebar": 32,
    "pgup": 33,
    "pgdn": 34,
    "ins": 45,
    "del": 46,
    "cmd": 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes["f" + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes["numpad " + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

});

parcelRegister("3h7Y3", function(module, exports) {

$parcel$export(module.exports, "NavigationSkeleton", function () { return $262923d06708adce$export$ad5e8e6ace98cc2; });
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $avKww = parcelRequire("avKww");

var $jp7ng = parcelRequire("jp7ng");

var $aDsOl = parcelRequire("aDsOl");

var $4l7fi = parcelRequire("4l7fi");
var $kUoTK = parcelRequire("kUoTK");

var $3hHEQ = parcelRequire("3hHEQ");

var $bz1FQ = parcelRequire("bz1FQ");

var $70BmT = parcelRequire("70BmT");

var $eUugj = parcelRequire("eUugj");

var $ikOo8 = parcelRequire("ikOo8");
var $262923d06708adce$var$containerStyles = (0, $avKww.css)({
    display: "flex",
    boxSizing: "border-box",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $aDsOl.HORIZONTAL_GLOBAL_NAV_HEIGHT),
    position: "relative",
    alignItems: "center",
    justifyContent: "space-between",
    flexShrink: 0,
    borderBlockEnd: "1px solid ".concat("var(--ds-border, ".concat((0, $jp7ng.N30), ")")),
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
var $262923d06708adce$var$leftStyles = (0, $avKww.css)({
    display: "flex",
    minWidth: 0,
    height: "inherit",
    alignItems: "center",
    flexGrow: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "& > *": {
        flexShrink: 0
    }
});
var $262923d06708adce$var$rightStyles = (0, $avKww.css)({
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "& > *": {
        flexShrink: 0,
        marginInlineEnd: "var(--ds-space-050, 4px)"
    }
});
var $262923d06708adce$export$ad5e8e6ace98cc2 = function NavigationSkeleton(_ref) {
    var _ref$primaryItemsCoun = _ref.primaryItemsCount, primaryItemsCount = _ref$primaryItemsCoun === void 0 ? 4 : _ref$primaryItemsCoun, _ref$secondaryItemsCo = _ref.secondaryItemsCount, secondaryItemsCount = _ref$secondaryItemsCo === void 0 ? 4 : _ref$secondaryItemsCo, _ref$theme = _ref.theme, theme = _ref$theme === void 0 ? (0, $4l7fi.defaultTheme) : _ref$theme, _ref$showSiteName = _ref.showSiteName, showSiteName = _ref$showSiteName === void 0 ? false : _ref$showSiteName, _ref$shouldShowSearch = _ref.shouldShowSearch, shouldShowSearch = _ref$shouldShowSearch === void 0 ? true : _ref$shouldShowSearch, testId = _ref.testId;
    return (0, $avKww.jsx)((0, $kUoTK.ThemeProvider), {
        value: theme
    }, (0, $avKww.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.navigation,
        css: $262923d06708adce$var$containerStyles,
        "data-testid": testId
    }, (0, $avKww.jsx)("div", {
        css: $262923d06708adce$var$leftStyles
    }, (0, $avKww.jsx)((0, $3hHEQ.IconButtonSkeleton), {
        marginLeft: 0,
        marginRight: 5,
        size: 26
    }), (0, $avKww.jsx)((0, $70BmT.ProductHomeSkeleton), {
        showSiteName: showSiteName
    }), (0, $avKww.jsx)((0, $bz1FQ.PrimaryItemsContainerSkeleton), {
        count: primaryItemsCount
    })), (0, $avKww.jsx)("div", {
        css: $262923d06708adce$var$rightStyles
    }, shouldShowSearch && (0, $avKww.jsx)((0, $ikOo8.SearchSkeleton), null), Array.from({
        length: secondaryItemsCount
    }, function(_, index) {
        return (0, $avKww.jsx)((0, $3hHEQ.IconButtonSkeleton), {
            key: index,
            marginLeft: 0,
            marginRight: 4,
            size: 26
        });
    }), (0, $avKww.jsx)((0, $eUugj.ProfileSkeleton), null))));
};
var $262923d06708adce$export$2e2bcd8739ae039 = $262923d06708adce$export$ad5e8e6ace98cc2;

});
parcelRegister("4l7fi", function(module, exports) {

$parcel$export(module.exports, "defaultTheme", function () { return $328ebe711c552a8f$export$164de7ab8df77ef0; });

var $jp7ng = parcelRequire("jp7ng");

var $7SncE = parcelRequire("7SncE");

var $iaYQE = parcelRequire("iaYQE");
var $328ebe711c552a8f$export$eeee8619e1b91cb0 = (0, $iaYQE.generateTheme)({
    name: (0, $7SncE.DEFAULT_THEME_NAME),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    backgroundColor: (0, $jp7ng.N0),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    highlightColor: (0, $jp7ng.B400)
});
var $328ebe711c552a8f$export$164de7ab8df77ef0 = $328ebe711c552a8f$export$eeee8619e1b91cb0;

});
parcelRegister("7SncE", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_THEME_NAME", function () { return $5bbf932df7ab9190$export$2491e13b198e597d; });
$parcel$export(module.exports, "default", function () { return $5bbf932df7ab9190$export$2e2bcd8739ae039; });

var $jp7ng = parcelRequire("jp7ng");

var $hHXbG = parcelRequire("hHXbG");
var $5bbf932df7ab9190$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: "var(--ds-text-inverse, ".concat((0, $jp7ng.N0), ")"),
                backgroundColor: "var(--ds-background-brand-bold-pressed, ".concat((0, $hHXbG.hexToRGBA)((0, $jp7ng.B400), 0.8), ")"),
                boxShadow: ""
            },
            default: {
                color: "var(--ds-text-inverse, ".concat((0, $jp7ng.N0), ")"),
                backgroundColor: "var(--ds-background-brand-bold, ".concat((0, $jp7ng.B400), ")"),
                boxShadow: ""
            },
            focus: {
                color: "var(--ds-text-inverse, ".concat((0, $jp7ng.N0), ")"),
                backgroundColor: "",
                boxShadow: ""
            },
            hover: {
                color: "var(--ds-text-inverse, ".concat((0, $jp7ng.N0), ")"),
                backgroundColor: "var(--ds-background-brand-bold-hovered, ".concat((0, $hHXbG.hexToRGBA)((0, $jp7ng.B400), 0.9), ")"),
                boxShadow: ""
            },
            selected: {
                color: "",
                backgroundColor: "",
                boxShadow: ""
            }
        },
        iconButton: {
            active: {
                color: "var(--ds-text-subtle, ".concat((0, $jp7ng.B400), ")"),
                backgroundColor: "var(--ds-background-neutral-pressed, ".concat((0, $hHXbG.hexToRGBA)((0, $jp7ng.B50), 0.6), ")"),
                boxShadow: ""
            },
            default: {
                color: "var(--ds-text-subtle, ".concat((0, $jp7ng.N600), ")"),
                backgroundColor: "transparent",
                boxShadow: ""
            },
            focus: {
                color: "var(--ds-text-subtle, ".concat((0, $jp7ng.N600), ")"),
                backgroundColor: "",
                boxShadow: ""
            },
            hover: {
                color: "var(--ds-text-subtle, ".concat((0, $jp7ng.B400), ")"),
                backgroundColor: "var(--ds-background-neutral-hovered, ".concat((0, $hHXbG.hexToRGBA)((0, $jp7ng.B50), 0.9), ")"),
                boxShadow: ""
            },
            selected: {
                color: "var(--ds-text-selected, ".concat((0, $jp7ng.B400), ")"),
                backgroundColor: "var(--ds-background-selected, ".concat((0, $hHXbG.hexToRGBA)((0, $jp7ng.B50), 0.6), ")"),
                boxShadow: ""
            },
            selectedHover: {
                color: "var(--ds-text-selected, ".concat((0, $jp7ng.B400), ")"),
                backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $hHXbG.hexToRGBA)((0, $jp7ng.B50), 0.6), ")"),
                boxShadow: ""
            }
        },
        navigation: {
            backgroundColor: "var(--ds-surface, ".concat((0, $jp7ng.N0), ")"),
            color: "var(--ds-text-subtlest, ".concat((0, $jp7ng.N200), ")")
        },
        productHome: {
            backgroundColor: "var(--ds-text-brand, ".concat((0, $jp7ng.B400), ")"),
            color: "var(--ds-text, ".concat((0, $jp7ng.N700), ")"),
            borderRight: "1px solid ".concat("var(--ds-border, ".concat((0, $hHXbG.hexToRGBA)((0, $jp7ng.N200), 0.3), ")")),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            iconColor: "#357DE8" // TODO: replace with token after brand refresh
        },
        primaryButton: {
            active: {
                color: "var(--ds-text-subtle, ".concat((0, $jp7ng.B400), ")"),
                backgroundColor: "var(--ds-background-neutral-pressed, ".concat((0, $hHXbG.hexToRGBA)((0, $jp7ng.B50), 0.7), ")"),
                boxShadow: ""
            },
            default: {
                color: "var(--ds-text-subtle, ".concat((0, $jp7ng.N600), ")"),
                backgroundColor: "transparent",
                boxShadow: ""
            },
            focus: {
                color: "var(--ds-text-subtle, ".concat((0, $jp7ng.N600), ")"),
                backgroundColor: "",
                boxShadow: ""
            },
            hover: {
                color: "var(--ds-text-subtle, ".concat((0, $jp7ng.B400), ")"),
                backgroundColor: "var(--ds-background-neutral-hovered, ".concat((0, $hHXbG.hexToRGBA)((0, $jp7ng.B50), 0.9), ")"),
                boxShadow: ""
            },
            selected: {
                color: "var(--ds-text-selected, ".concat((0, $jp7ng.B400), ")"),
                backgroundColor: "var(--ds-background-selected, ".concat((0, $hHXbG.hexToRGBA)((0, $jp7ng.B50), 0.7), ")"),
                boxShadow: "",
                borderColor: "var(--ds-border-selected, ".concat((0, $jp7ng.B400), ")")
            },
            selectedHover: {
                color: "var(--ds-text-selected, ".concat((0, $jp7ng.B400), ")"),
                backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $hHXbG.hexToRGBA)((0, $jp7ng.B50), 0.6), ")"),
                boxShadow: "",
                borderColor: "var(--ds-border-selected, ".concat((0, $jp7ng.B400), ")")
            }
        },
        search: {
            default: {
                backgroundColor: "var(--ds-background-input, ".concat((0, $jp7ng.N0), ")"),
                color: "var(--ds-text-subtlest, ".concat((0, $jp7ng.N200), ")"),
                borderColor: "var(--ds-border-input, ".concat((0, $jp7ng.N100), ")")
            },
            focus: {
                borderColor: "var(--ds-border-focused, ".concat((0, $jp7ng.B200), ")")
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, ".concat((0, $jp7ng.N0), ")")
            }
        },
        skeleton: {
            backgroundColor: "var(--ds-background-neutral, ".concat((0, $jp7ng.N20), ")"),
            opacity: 1
        }
    }
};
var $5bbf932df7ab9190$export$2491e13b198e597d = "atlassian";
var $5bbf932df7ab9190$export$2e2bcd8739ae039 = $5bbf932df7ab9190$var$defaultTheme;

});
parcelRegister("hHXbG", function(module, exports) {

$parcel$export(module.exports, "hexToRGBA", function () { return $ce445d3b37301a64$export$7229be6d7219ee6a; });
$parcel$export(module.exports, "getBoxShadow", function () { return $ce445d3b37301a64$export$bba5a971afe05444; });
$parcel$export(module.exports, "generateTextColor", function () { return $ce445d3b37301a64$export$10a10e7cd1193377; });
$parcel$export(module.exports, "getContrastColor", function () { return $ce445d3b37301a64$export$77a1051494882576; });

var $b4Ivn = parcelRequire("b4Ivn");

var $kFnE9 = parcelRequire("kFnE9");

var $2SSCH = parcelRequire("2SSCH");
function $ce445d3b37301a64$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ce445d3b37301a64$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ce445d3b37301a64$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ce445d3b37301a64$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ce445d3b37301a64$export$7229be6d7219ee6a = function hexToRGBA(hex) {
    var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var rgba = $ce445d3b37301a64$var$_objectSpread($ce445d3b37301a64$var$_objectSpread({}, (0, $2SSCH.default).convert(hex).rgb), {
        a: opacity
    });
    return "rgba(".concat(Object.values(rgba).join(", "), ")");
};
var $ce445d3b37301a64$export$bba5a971afe05444 = function getBoxShadow(color) {
    return "0 0 0 2px ".concat(color);
};
var $ce445d3b37301a64$var$hex = "[a-z0-9]";
var $ce445d3b37301a64$var$shortHandHexColorPattern = new RegExp("#(".concat($ce445d3b37301a64$var$hex, ")(").concat($ce445d3b37301a64$var$hex, ")(").concat($ce445d3b37301a64$var$hex, ")"), "i");
var $ce445d3b37301a64$var$repeat = function repeat(str, times) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(Array(times)).map(function() {
        return str;
    }).join("");
};
var $ce445d3b37301a64$var$isShortHexColor = function isShortHexColor(color) {
    return color && color.length === 4;
};
var $ce445d3b37301a64$var$completeHexColor = function completeHexColor(colors) {
    var hex = colors.map(function(color) {
        return $ce445d3b37301a64$var$repeat(color, 2);
    }).join("");
    return "#".concat(hex);
};
var $ce445d3b37301a64$var$completeTriplet = function completeTriplet(colors) {
    return "#".concat($ce445d3b37301a64$var$repeat(colors[1], 6));
};
var $ce445d3b37301a64$var$isTriplet = function isTriplet(colors) {
    return colors[0] === colors[1] && colors[1] === colors[2];
};
var $ce445d3b37301a64$export$db8d2130677f868c = function convertHexShorthand(color) {
    if ($ce445d3b37301a64$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        var matches = color.match($ce445d3b37301a64$var$shortHandHexColorPattern);
        if (matches) {
            var colors = matches.slice(1, 4);
            if ($ce445d3b37301a64$var$isTriplet(colors)) return $ce445d3b37301a64$var$completeTriplet(colors);
            else return $ce445d3b37301a64$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
var $ce445d3b37301a64$export$10a10e7cd1193377 = function generateTextColor(color) {
    var converted = $ce445d3b37301a64$export$db8d2130677f868c(color);
    return (0, $2SSCH.default).contrastRatio(converted).hex;
};
var $ce445d3b37301a64$export$77a1051494882576 = function getContrastColor(contrastValue, opacityValue, color) {
    return $ce445d3b37301a64$export$7229be6d7219ee6a((0, $2SSCH.default).contrast(contrastValue, color).hex, opacityValue);
};

});


parcelRegister("iaYQE", function(module, exports) {

$parcel$export(module.exports, "generateTheme", function () { return $d3b85c5c2ff968a6$export$2e4ecffaca289a18; });

var $kFnE9 = parcelRequire("kFnE9");

var $7SncE = parcelRequire("7SncE");

var $hHXbG = parcelRequire("hHXbG");
function $d3b85c5c2ff968a6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d3b85c5c2ff968a6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d3b85c5c2ff968a6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d3b85c5c2ff968a6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d3b85c5c2ff968a6$var$generateOpacityValue = function generateOpacityValue(color) {
    return color === "#000000" ? 0.3 : 0.6;
};
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $d3b85c5c2ff968a6$var$generateButtonCSSStates = function generateButtonCSSStates(colors, buttonType) {
    var backgroundColor = colors.backgroundColor, color = colors.color, highlightColor = colors.highlightColor;
    // Add less opacity for white text so it is still legible.
    var opacityValue = $d3b85c5c2ff968a6$var$generateOpacityValue(color);
    var isCreateButton = buttonType === "create";
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $hHXbG.hexToRGBA)(backgroundColor, 0.65) : (0, $hHXbG.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $hHXbG.getBoxShadow)("transparent"),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $hHXbG.getBoxShadow)("transparent"),
            color: color
        },
        focus: {
            boxShadow: "none",
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $hHXbG.hexToRGBA)(backgroundColor, 0.8) : (0, $hHXbG.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $hHXbG.getBoxShadow)("transparent"),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $hHXbG.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $hHXbG.getBoxShadow)("transparent")
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $hHXbG.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $hHXbG.getBoxShadow)("transparent")
        }
    };
};
var $d3b85c5c2ff968a6$var$generateCreateButtonColors = function generateCreateButtonColors(themeBackground, themeHighlight) {
    return {
        backgroundColor: themeHighlight,
        color: (0, $hHXbG.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    };
};
var $d3b85c5c2ff968a6$export$2e4ecffaca289a18 = function generateTheme(themeColors) {
    var backgroundColor = themeColors.backgroundColor, highlightColor = themeColors.highlightColor, name = themeColors.name;
    var color = (0, $hHXbG.generateTextColor)(backgroundColor);
    var colors = $d3b85c5c2ff968a6$var$_objectSpread($d3b85c5c2ff968a6$var$_objectSpread({}, themeColors), {}, {
        color: color
    });
    if (name === (0, $7SncE.DEFAULT_THEME_NAME)) return 0, $7SncE.default;
    return {
        mode: {
            create: $d3b85c5c2ff968a6$var$generateButtonCSSStates($d3b85c5c2ff968a6$var$generateCreateButtonColors(backgroundColor, highlightColor), "create"),
            iconButton: $d3b85c5c2ff968a6$var$generateButtonCSSStates(colors, "iconButton"),
            primaryButton: $d3b85c5c2ff968a6$var$generateButtonCSSStates(colors, "primaryButton"),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                backgroundColor: highlightColor,
                borderRight: "1px solid ".concat((0, $hHXbG.hexToRGBA)(color, 0.5))
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $hHXbG.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $hHXbG.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $hHXbG.getBoxShadow)((0, $hHXbG.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $hHXbG.getContrastColor)(0.1, $d3b85c5c2ff968a6$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};
var $d3b85c5c2ff968a6$export$2e2bcd8739ae039 = $d3b85c5c2ff968a6$export$2e4ecffaca289a18;

});


parcelRegister("kUoTK", function(module, exports) {

$parcel$export(module.exports, "ThemeContext", function () { return $f38c59e1fb9e227e$export$2c657da244d00bd6; });
$parcel$export(module.exports, "ThemeProvider", function () { return $f38c59e1fb9e227e$export$d8964aec282183a3; });

var $9nHZC = parcelRequire("9nHZC");

var $4l7fi = parcelRequire("4l7fi");
var $f38c59e1fb9e227e$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $9nHZC.createContext)((0, $4l7fi.defaultTheme));
var $f38c59e1fb9e227e$export$d8964aec282183a3 = $f38c59e1fb9e227e$export$2c657da244d00bd6.Provider;

});

parcelRegister("3hHEQ", function(module, exports) {

$parcel$export(module.exports, "IconButtonSkeleton", function () { return $2644d322c05e0249$export$7a24471cb6f25433; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $6vd4M = parcelRequire("6vd4M");
function $2644d322c05e0249$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2644d322c05e0249$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2644d322c05e0249$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2644d322c05e0249$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2644d322c05e0249$var$buttonHeight = "var(--ds-space-400, 32px)";
var $2644d322c05e0249$var$skeletonStyles = (0, $avKww.css)({
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    opacity: 0.15
});
var $2644d322c05e0249$export$7a24471cb6f25433 = function IconButtonSkeleton(_ref) {
    var className = _ref.className, marginLeft = _ref.marginLeft, marginRight = _ref.marginRight, size = _ref.size;
    var theme = (0, $6vd4M.useTheme)();
    var dynamicStyles = $2644d322c05e0249$var$_objectSpread({
        marginLeft: typeof marginLeft === "number" ? marginLeft : "var(--ds-space-050, 4px)",
        marginRight: typeof marginRight === "number" ? marginRight : 0,
        width: typeof size === "number" ? size : $2644d322c05e0249$var$buttonHeight,
        height: typeof size === "number" ? size : $2644d322c05e0249$var$buttonHeight
    }, theme.mode.skeleton);
    return (0, $avKww.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        style: dynamicStyles,
        css: $2644d322c05e0249$var$skeletonStyles
    });
};

});
parcelRegister("6vd4M", function(module, exports) {

$parcel$export(module.exports, "useTheme", function () { return $4bbfc7fbdc6aaad9$export$93d4e7f90805808f; });

var $9nHZC = parcelRequire("9nHZC");

var $kUoTK = parcelRequire("kUoTK");
var $4bbfc7fbdc6aaad9$export$93d4e7f90805808f = function useTheme() {
    return (0, $9nHZC.useContext)((0, $kUoTK.ThemeContext));
};

});


parcelRegister("bz1FQ", function(module, exports) {

$parcel$export(module.exports, "PrimaryItemsContainerSkeleton", function () { return $86b442ff584645ce$export$fdfc48d2117b79a8; });
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $7m0cb = parcelRequire("7m0cb");
var $86b442ff584645ce$var$primaryButtonSkeletonStyles = (0, $avKww.css)({
    marginInlineEnd: "var(--ds-space-150, 12px)",
    marginInlineStart: "var(--ds-space-150, 12px)"
});
var $86b442ff584645ce$export$fdfc48d2117b79a8 = /*#__PURE__*/ (0, $9nHZC.memo)(function(_ref) {
    var count = _ref.count;
    return (0, $avKww.jsx)((0, $9nHZC.Fragment), null, Array.from({
        length: count
    }, function(_, index) {
        return (0, $avKww.jsx)((0, $7m0cb.PrimaryButtonSkeleton), {
            key: index,
            css: $86b442ff584645ce$var$primaryButtonSkeletonStyles
        });
    }));
});

});
parcelRegister("7m0cb", function(module, exports) {

$parcel$export(module.exports, "PrimaryButtonSkeleton", function () { return $55aabd4d0c69df9f$export$4bc51fe36728414d; });
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $avKww = parcelRequire("avKww");

var $6vd4M = parcelRequire("6vd4M");
var $55aabd4d0c69df9f$var$paddingAll = 4;
var $55aabd4d0c69df9f$var$buttonHeight = 32;
var $55aabd4d0c69df9f$var$skeletonStyles = (0, $avKww.css)({
    display: "inline-flex",
    width: "68px",
    height: "".concat($55aabd4d0c69df9f$var$buttonHeight - $55aabd4d0c69df9f$var$paddingAll * 2.5, "px"),
    borderRadius: "var(--ds-border-radius, 4px)",
    opacity: 0.15
});
var $55aabd4d0c69df9f$export$4bc51fe36728414d = function PrimaryButtonSkeleton(props) {
    var theme = (0, $6vd4M.useTheme)();
    return (0, $avKww.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $55aabd4d0c69df9f$var$skeletonStyles,
        className: props.className
    });
};

});


parcelRegister("70BmT", function(module, exports) {

$parcel$export(module.exports, "ProductHomeSkeleton", function () { return $51a585090b650116$export$3e79e535d76cce4b; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $aDsOl = parcelRequire("aDsOl");

var $6vd4M = parcelRequire("6vd4M");

var $46Hfu = parcelRequire("46Hfu");
var $51a585090b650116$var$_css;
var $51a585090b650116$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = "--product-home-color-active";
var $51a585090b650116$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = "--product-home-bg-color-active";
var $51a585090b650116$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = "--product-home-box-shadow-active";
var $51a585090b650116$var$VAR_PRODUCT_HOME_COLOR_FOCUS = "--product-home-color-focus";
var $51a585090b650116$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = "--product-home-bg-color-focus";
var $51a585090b650116$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = "--product-home-box-shadow-focus";
var $51a585090b650116$var$VAR_PRODUCT_HOME_COLOR_HOVER = "--product-home-color-hover";
var $51a585090b650116$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = "--product-home-bg-color-hover";
var $51a585090b650116$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = "--product-home-box-shadow-hover";
var $51a585090b650116$var$VAR_SITE_TITLE_BG_COLOR_AFTER = "--site-title-bg-color-after";
var $51a585090b650116$var$productHomeButtonStyles = (0, $avKww.css)(($51a585090b650116$var$_css = {
    display: "flex",
    padding: "var(--ds-space-050, 4px)",
    alignItems: "center",
    background: "none",
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    color: "inherit",
    cursor: "pointer",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&::-moz-focus-inner": {
        border: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&:first-of-type": {
        marginInlineStart: 0
    },
    "&:active": {
        backgroundColor: "var(".concat($51a585090b650116$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE, ")"),
        boxShadow: "var(".concat($51a585090b650116$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE, ")"),
        color: "var(".concat($51a585090b650116$var$VAR_PRODUCT_HOME_COLOR_ACTIVE, ")")
    },
    "&:focus": {
        backgroundColor: "var(".concat($51a585090b650116$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS, ")"),
        boxShadow: "var(".concat($51a585090b650116$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS, ")"),
        color: "var(".concat($51a585090b650116$var$VAR_PRODUCT_HOME_COLOR_FOCUS, ")"),
        outline: 0
    },
    "&:hover": {
        backgroundColor: "var(".concat($51a585090b650116$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER, ")"),
        boxShadow: "var(".concat($51a585090b650116$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER, ")"),
        color: "var(".concat($51a585090b650116$var$VAR_PRODUCT_HOME_COLOR_HOVER, ")")
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "div&": {
        pointerEvents: "none"
    }
}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($51a585090b650116$var$_css, "@media (max-width: ".concat((0, $aDsOl.PRODUCT_HOME_BREAKPOINT) - 0.1, "px)"), {
    margin: "0 ".concat("var(--ds-space-100, 8px)")
}), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($51a585090b650116$var$_css, "@media (min-width: ".concat((0, $aDsOl.PRODUCT_HOME_BREAKPOINT), "px)"), {
    margin: "0 ".concat("var(--ds-space-200, 16px)")
}), $51a585090b650116$var$_css));
var $51a585090b650116$var$productLogoStyles = (0, $avKww.css)((0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({
    display: "flex",
    width: 120,
    maxWidth: 120,
    height: 24,
    maxHeight: 28,
    opacity: 0.15,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "& > *": {
        maxHeight: 24
    }
}, "@media (max-width: ".concat((0, $aDsOl.PRODUCT_HOME_BREAKPOINT) - 0.1, "px)"), {
    display: "none"
}));
var $51a585090b650116$var$productIconStyles = (0, $avKww.css)((0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({
    display: "flex",
    width: 28,
    height: 28,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    opacity: 0.15,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "& > *": {
        maxHeight: 24
    }
}, "@media (min-width: ".concat((0, $aDsOl.PRODUCT_HOME_BREAKPOINT), "px)"), {
    display: "none"
}));
var $51a585090b650116$var$siteTitleStyles = (0, $avKww.css)({
    display: "flex",
    width: "var(--ds-space-500, 40px)",
    alignItems: "center",
    backgroundColor: "transparent",
    marginInlineEnd: "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-050, 4px)",
    paddingInlineEnd: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&:after": {
        width: "100%",
        height: 14,
        backgroundColor: "var(".concat($51a585090b650116$var$VAR_SITE_TITLE_BG_COLOR_AFTER, ")"),
        borderRadius: "var(--ds-border-radius, 4px)",
        content: '""'
    }
});
var $51a585090b650116$export$3e79e535d76cce4b = function ProductHomeSkeleton(_ref) {
    var _stripEmptyProperties;
    var showSiteName = _ref.showSiteName;
    var theme = (0, $6vd4M.useTheme)();
    var primaryButton = theme.mode.primaryButton;
    var productHomeButtonDynamicStyles = (0, $46Hfu.stripEmptyProperties)((_stripEmptyProperties = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_stripEmptyProperties, $51a585090b650116$var$VAR_PRODUCT_HOME_COLOR_ACTIVE, primaryButton.active.color), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_stripEmptyProperties, $51a585090b650116$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE, primaryButton.active.backgroundColor), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_stripEmptyProperties, $51a585090b650116$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE, primaryButton.active.boxShadow), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_stripEmptyProperties, $51a585090b650116$var$VAR_PRODUCT_HOME_COLOR_FOCUS, primaryButton.focus.color), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_stripEmptyProperties, $51a585090b650116$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS, primaryButton.focus.backgroundColor), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_stripEmptyProperties, $51a585090b650116$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS, primaryButton.focus.boxShadow), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_stripEmptyProperties, $51a585090b650116$var$VAR_PRODUCT_HOME_COLOR_HOVER, primaryButton.hover.color), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_stripEmptyProperties, $51a585090b650116$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER, primaryButton.hover.backgroundColor), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_stripEmptyProperties, $51a585090b650116$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER, primaryButton.hover.boxShadow), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_stripEmptyProperties, $51a585090b650116$var$VAR_SITE_TITLE_BG_COLOR_AFTER, theme.mode.skeleton.backgroundColor), _stripEmptyProperties));
    var siteTitleDynamicStyles = (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({
        borderRight: theme.mode.productHome.borderRight,
        opacity: theme.mode.skeleton.opacity
    }, $51a585090b650116$var$VAR_SITE_TITLE_BG_COLOR_AFTER, theme.mode.skeleton.backgroundColor);
    return (0, $avKww.jsx)((0, $9nHZC.Fragment), null, (0, $avKww.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $51a585090b650116$var$productHomeButtonStyles
    }, (0, $avKww.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $51a585090b650116$var$productLogoStyles
    }), (0, $avKww.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $51a585090b650116$var$productIconStyles
    })), showSiteName && (0, $avKww.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: siteTitleDynamicStyles,
        css: $51a585090b650116$var$siteTitleStyles
    }));
};

});
parcelRegister("46Hfu", function(module, exports) {

$parcel$export(module.exports, "stripEmptyProperties", function () { return $2fd94546613be1a3$export$e03bb5c7fd72635; });

var $9q1kH = parcelRequire("9q1kH");
function $2fd94546613be1a3$export$e03bb5c7fd72635(obj) {
    return Object.entries(obj).reduce(function(acc, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        if (value !== null && value !== undefined && value !== "") acc[key] = value;
        return acc;
    }, {});
}

});


parcelRegister("eUugj", function(module, exports) {

$parcel$export(module.exports, "ProfileSkeleton", function () { return $adadc512f69ab5c0$export$2bab43fd33adda3b; });

var $9nHZC = parcelRequire("9nHZC");

var $3hHEQ = parcelRequire("3hHEQ");
var $adadc512f69ab5c0$export$2bab43fd33adda3b = function ProfileSkeleton() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3hHEQ.IconButtonSkeleton), {
        marginLeft: 6,
        marginRight: 6,
        size: 26
    });
};

});

parcelRegister("ikOo8", function(module, exports) {

$parcel$export(module.exports, "SearchSkeleton", function () { return $d5912e4f669e3d32$export$d8fbade3e5bbb8e0; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $aDsOl = parcelRequire("aDsOl");

var $6vd4M = parcelRequire("6vd4M");

var $3hHEQ = parcelRequire("3hHEQ");
var $d5912e4f669e3d32$var$searchInputContainerStyles = (0, $avKww.css)((0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginRight: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginLeft: "var(--ds-space-250, 20px)",
    position: "relative"
}, "@media (max-width: ".concat((0, $aDsOl.CREATE_BREAKPOINT) - 1, "px)"), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    display: "none !important"
}));
var $d5912e4f669e3d32$var$searchInputSkeletonStyles = (0, $avKww.css)({
    boxSizing: "border-box",
    width: "220px",
    height: "var(--ds-space-400, 32px)",
    padding: "0 ".concat("var(--ds-space-100, 8px)", " 0 ", "var(--ds-space-500, 40px)"),
    borderRadius: "var(--ds-border-radius-200, 6px)",
    opacity: 0.15
});
var $d5912e4f669e3d32$var$searchIconStyles = (0, $avKww.css)((0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, "@media (min-width: ".concat((0, $aDsOl.CREATE_BREAKPOINT), "px)"), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    display: "none !important"
}));
var $d5912e4f669e3d32$export$d8fbade3e5bbb8e0 = function SearchSkeleton() {
    var theme = (0, $6vd4M.useTheme)();
    return (0, $avKww.jsx)((0, $9nHZC.Fragment), null, (0, $avKww.jsx)("div", {
        css: $d5912e4f669e3d32$var$searchInputContainerStyles
    }, (0, $avKww.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.skeleton,
        css: $d5912e4f669e3d32$var$searchInputSkeletonStyles
    })), (0, $avKww.jsx)((0, $3hHEQ.IconButtonSkeleton), {
        css: $d5912e4f669e3d32$var$searchIconStyles,
        marginRight: 5,
        size: 26
    }));
};

});


parcelRegister("7kuwP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $556214fbb43b17df$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $c3456 = parcelRequire("c3456");

var $5zXt3 = parcelRequire("5zXt3");

var $45CBz = parcelRequire("45CBz");
function $556214fbb43b17df$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $556214fbb43b17df$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $556214fbb43b17df$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $556214fbb43b17df$var$defaultTooltipContent(isCollapsed) {
    return isCollapsed ? {
        text: "Expand",
        char: "["
    } : {
        text: "Collapse",
        char: "["
    };
}
var $556214fbb43b17df$var$LayoutManagerWithNavigationUIController = (0, $c3456.default)((0, $5zXt3.default));
var $556214fbb43b17df$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(ConnectedLayoutManager, _Component);
    var _super = $556214fbb43b17df$var$_createSuper(ConnectedLayoutManager);
    function ConnectedLayoutManager() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ConnectedLayoutManager);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ConnectedLayoutManager, [
        {
            key: "render",
            value: function render() {
                return (0, $45CBz.jsx)($556214fbb43b17df$var$LayoutManagerWithNavigationUIController, this.props);
            }
        }
    ]);
    return ConnectedLayoutManager;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($556214fbb43b17df$export$2e2bcd8739ae039, "defaultProps", {
    collapseToggleTooltipContent: $556214fbb43b17df$var$defaultTooltipContent,
    experimental_alternateFlyoutBehaviour: false,
    experimental_flyoutOnHover: false,
    experimental_fullWidthFlyout: false,
    experimental_hideNavVisuallyOnCollapse: false,
    experimental_horizontalGlobalNav: false,
    topOffset: 0
});

});
parcelRegister("c3456", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c58ee4f5343851c$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");
parcelRequire("9nHZC");

var $lemjF = parcelRequire("lemjF");

var $45CBz = parcelRequire("45CBz");
var $8c58ee4f5343851c$export$2e2bcd8739ae039 = function(WrappedComponent) {
    var withNavigationUIController = function withNavigationUIController(props) {
        return (0, $45CBz.jsx)((0, $lemjF.default), null, function(navigationUIController) {
            return (0, $45CBz.jsx)(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                navigationUIController: navigationUIController
            }, props));
        });
    };
    withNavigationUIController.displayName = "WithNavigationUIController(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
    return withNavigationUIController;
};

});
parcelRegister("lemjF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f74c374c32e96553$export$2e2bcd8739ae039; });
parcelRequire("9nHZC");

var $i5sFT = parcelRequire("i5sFT");

var $68WhI = parcelRequire("68WhI");

var $45CBz = parcelRequire("45CBz");
var $f74c374c32e96553$var$to = [
    (0, $68WhI.default)
];
var $f74c374c32e96553$var$UIControllerSubscriber = function UIControllerSubscriber(_ref) {
    var children = _ref.children;
    return (0, $45CBz.jsx)((0, $i5sFT.Subscribe), {
        to: $f74c374c32e96553$var$to
    }, children);
};
var $f74c374c32e96553$export$2e2bcd8739ae039 = $f74c374c32e96553$var$UIControllerSubscriber;

});
parcelRegister("68WhI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4790b38ad3d136dd$export$2e2bcd8739ae039; });

var $eVDe4 = parcelRequire("eVDe4");

var $uqRmf = parcelRequire("uqRmf");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $i5sFT = parcelRequire("i5sFT");

var $5SBZk = parcelRequire("5SBZk");
function $4790b38ad3d136dd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4790b38ad3d136dd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4790b38ad3d136dd$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4790b38ad3d136dd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4790b38ad3d136dd$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $4790b38ad3d136dd$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $4790b38ad3d136dd$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $4790b38ad3d136dd$var$defaultState = {
    isResizing: false,
    isResizeDisabled: false,
    isCollapsed: false,
    productNavWidth: (0, $5SBZk.CONTENT_NAV_WIDTH)
};
var $4790b38ad3d136dd$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Container) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIController, _Container);
    var _super = $4790b38ad3d136dd$var$_createSuper(UIController);
    function UIController(initialState, cache) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIController);
        _this = _super.call(this);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getCache", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "setCache", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "isCollapsedStore", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "storeState", function(state) {
            _this.setState(state);
            var _this$state = _this.state, isCollapsed = _this$state.isCollapsed, productNavWidth = _this$state.productNavWidth;
            if (_this.setCache) _this.setCache({
                isCollapsed: isCollapsed,
                productNavWidth: productNavWidth
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "collapse", function() {
            if (_this.state.isResizeDisabled) return;
            _this.storeState({
                isCollapsed: true
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "expand", function() {
            if (_this.state.isResizeDisabled) return;
            _this.storeState({
                isCollapsed: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "toggleCollapse", function() {
            var toggle = _this.state.isCollapsed ? _this.expand : _this.collapse;
            toggle();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "manualResizeStart", function(_ref) {
            var productNavWidth = _ref.productNavWidth, isCollapsed = _ref.isCollapsed;
            if (_this.state.isResizeDisabled) return;
            _this.storeState({
                isResizing: true,
                productNavWidth: productNavWidth,
                isCollapsed: isCollapsed
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "manualResizeEnd", function(_ref2) {
            var productNavWidth = _ref2.productNavWidth, isCollapsed = _ref2.isCollapsed;
            if (_this.state.isResizeDisabled) return;
            _this.storeState({
                isResizing: false,
                productNavWidth: productNavWidth,
                isCollapsed: isCollapsed
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "enableResize", function() {
            var isCollapsed = typeof _this.isCollapsedStore === "boolean" ? _this.isCollapsedStore : _this.state.isCollapsed; // This is a page-level setting not a user preference so we don't cache
            // this.
            _this.setState({
                isCollapsed: isCollapsed,
                isResizeDisabled: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "disableResize", function() {
            // Remember this so that we can reset it if resizing is enabled again.
            _this.isCollapsedStore = _this.state.isCollapsed; // This is a page-level setting not a user preference so we don't cache
            // this.
            _this.setState({
                isCollapsed: false,
                isResizeDisabled: true
            });
        });
        var cachedState = {};
        if (cache) {
            var get = cache.get, set = cache.set;
            var retrievedCache = get();
            if (retrievedCache) {
                var isCollapsed = retrievedCache.isCollapsed, productNavWidth = retrievedCache.productNavWidth;
                cachedState = {
                    isCollapsed: isCollapsed,
                    productNavWidth: productNavWidth
                };
            }
            _this.getCache = get;
            _this.setCache = set;
        }
        var _state = $4790b38ad3d136dd$var$_objectSpread($4790b38ad3d136dd$var$_objectSpread($4790b38ad3d136dd$var$_objectSpread({}, $4790b38ad3d136dd$var$defaultState), cachedState), initialState);
        var _isCollapsed = _state.isCollapsed; // isResizeDisabled takes precedence over isCollapsed
        if (initialState && initialState.isResizeDisabled) {
            // Remember this so that we can reset it if resizing is enabled again.
            _this.isCollapsedStore = _isCollapsed;
            _isCollapsed = false;
        }
        _this.state = $4790b38ad3d136dd$var$_objectSpread($4790b38ad3d136dd$var$_objectSpread({}, _state), {}, {
            isCollapsed: _isCollapsed
        });
        return _this;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIController);
}((0, $i5sFT.Container));

});



parcelRegister("5zXt3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40fe59aeb922c075$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("jlzQX");
var $1irk6 = parcelRequire("1irk6");

var $5SBZk = parcelRequire("5SBZk");

var $hYYQc = parcelRequire("hYYQc");

var $9yV1o = parcelRequire("9yV1o");

var $7q00A = parcelRequire("7q00A");

var $hNe55 = parcelRequire("hNe55");

var $lAQgg = parcelRequire("lAQgg");

var $bzE1X = parcelRequire("bzE1X");

var $fXcGH = parcelRequire("fXcGH");

var $7c3Cv = parcelRequire("7c3Cv");

var $45CBz = parcelRequire("45CBz");
function $40fe59aeb922c075$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $40fe59aeb922c075$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $40fe59aeb922c075$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $40fe59aeb922c075$var$packageName = "@atlaskit/navigation-next";
var $40fe59aeb922c075$var$packageVersion = "9.0.17";
function $40fe59aeb922c075$var$defaultTooltipContent(isCollapsed) {
    return isCollapsed ? {
        text: "Expand",
        char: "["
    } : {
        text: "Collapse",
        char: "["
    };
}
/* NOTE: experimental props use an underscore */ var $40fe59aeb922c075$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(LayoutManager, _Component);
    var _super = $40fe59aeb922c075$var$_createSuper(LayoutManager);
    function LayoutManager() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, LayoutManager);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "state", {
            flyoutIsOpen: false,
            itemIsDragging: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "productNavRef", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "pageRef", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "containerRef", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "flyoutMouseOverTimeout", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "nodeRefs", {
            expandCollapseAffordance: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createRef()
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getContainerRef", function(ref) {
            _this.containerRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getNavRef", function(ref) {
            _this.productNavRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getPageRef", function(ref) {
            _this.pageRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "mouseOutFlyoutArea", function(_ref) {
            var currentTarget = _ref.currentTarget, relatedTarget = _ref.relatedTarget;
            if (currentTarget.contains(relatedTarget)) return;
            clearTimeout(_this.flyoutMouseOverTimeout);
            _this.setState({
                flyoutIsOpen: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "mouseOverFlyoutArea", function(_ref2) {
            var currentTarget = _ref2.currentTarget, target = _ref2.target;
            if (!currentTarget.contains(target)) return;
            var EXPERIMENTAL_ALTERNATE_FLYOUT_BEHAVIOUR = _this.props.experimental_alternateFlyoutBehaviour;
            var delay = EXPERIMENTAL_ALTERNATE_FLYOUT_BEHAVIOUR ? (0, $5SBZk.ALTERNATE_FLYOUT_DELAY) : (0, $5SBZk.FLYOUT_DELAY);
            clearTimeout(_this.flyoutMouseOverTimeout);
            _this.flyoutMouseOverTimeout = setTimeout(function() {
                _this.setState({
                    flyoutIsOpen: true
                });
            }, delay);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "closeFlyout", function(e) {
            e.stopPropagation();
            clearTimeout(_this.flyoutMouseOverTimeout);
            if (_this.state.flyoutIsOpen) _this.setState({
                flyoutIsOpen: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "mouseLeave", function() {
            clearTimeout(_this.flyoutMouseOverTimeout);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onItemDragStart", function() {
            _this.setState({
                itemIsDragging: true
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onItemDragEnd", function() {
            _this.setState({
                itemIsDragging: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "renderNavigation", function() {
            var _this$props = _this.props, datasets = _this$props.datasets, navigationUIController = _this$props.navigationUIController, EXPERIMENTAL_ALTERNATE_FLYOUT_BEHAVIOUR = _this$props.experimental_alternateFlyoutBehaviour, EXPERIMENTAL_FLYOUT_ON_HOVER = _this$props.experimental_flyoutOnHover, EXPERIMENTAL_FULL_WIDTH_FLYOUT = _this$props.experimental_fullWidthFlyout, EXPERIMENTAL_HIDE_NAV_VISUALLY_ON_COLLAPSE = _this$props.experimental_hideNavVisuallyOnCollapse, EXPERIMENTAL_HORIZONTAL_GLOBAL_NAV = _this$props.experimental_horizontalGlobalNav, collapseToggleTooltipContent = _this$props.collapseToggleTooltipContent, topOffset = _this$props.topOffset, shouldHideGlobalNavShadow = _this$props.shouldHideGlobalNavShadow, showContextualNavigation = _this$props.showContextualNavigation, globalNavigation = _this$props.globalNavigation, containerNavigation = _this$props.containerNavigation, productNavigation = _this$props.productNavigation, view = _this$props.view;
            var _this$state = _this.state, flyoutIsOpen = _this$state.flyoutIsOpen, itemIsDragging = _this$state.itemIsDragging;
            var _navigationUIControll = navigationUIController.state, isCollapsed = _navigationUIControll.isCollapsed, isResizeDisabled = _navigationUIControll.isResizeDisabled, isResizing = _navigationUIControll.isResizing, productNavWidth = _navigationUIControll.productNavWidth;
            var flyoutWidth = EXPERIMENTAL_FULL_WIDTH_FLYOUT ? productNavWidth : (0, $5SBZk.CONTENT_NAV_WIDTH_FLYOUT);
            var dataset = datasets ? datasets.navigation : {};
            var GlobalNavigation = globalNavigation;
            var navContainerTopOffset = EXPERIMENTAL_HORIZONTAL_GLOBAL_NAV ? (0, $5SBZk.HORIZONTAL_GLOBAL_NAV_HEIGHT) + topOffset : topOffset;
            var onMouseOut = isCollapsed && EXPERIMENTAL_FLYOUT_ON_HOVER && flyoutIsOpen ? _this.mouseOutFlyoutArea : null;
            var onMouseOver = isCollapsed && EXPERIMENTAL_FLYOUT_ON_HOVER && !flyoutIsOpen ? _this.mouseOverFlyoutArea : null;
            return (0, $45CBz.jsx)((0, $hNe55.LayoutEventListener), {
                onItemDragStart: _this.onItemDragStart,
                onItemDragEnd: _this.onItemDragEnd
            }, (0, $45CBz.jsx)((0, $1irk6.NavigationAnalyticsContext), {
                data: {
                    attributes: {
                        isExpanded: !isCollapsed,
                        flyoutOnHoverEnabled: EXPERIMENTAL_FLYOUT_ON_HOVER,
                        alternateFlyoutBehaviourEnabled: EXPERIMENTAL_ALTERNATE_FLYOUT_BEHAVIOUR,
                        fullWidthFlyoutEnabled: EXPERIMENTAL_FULL_WIDTH_FLYOUT,
                        horizontalGlobalNavEnabled: EXPERIMENTAL_HORIZONTAL_GLOBAL_NAV
                    },
                    componentName: "navigation",
                    packageName: $40fe59aeb922c075$var$packageName,
                    packageVersion: $40fe59aeb922c075$var$packageVersion
                }
            }, (0, $45CBz.jsx)((0, $9nHZC.Fragment), null, EXPERIMENTAL_HORIZONTAL_GLOBAL_NAV && (0, $45CBz.jsx)((0, $bzE1X.HorizontalNavigationContainer), {
                topOffset: topOffset
            }, (0, $45CBz.jsx)(GlobalNavigation, null)), (0, $45CBz.jsx)((0, $bzE1X.NavigationContainer), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, dataset, {
                topOffset: navContainerTopOffset,
                innerRef: _this.getContainerRef,
                onMouseOver: EXPERIMENTAL_ALTERNATE_FLYOUT_BEHAVIOUR ? onMouseOver : null,
                onMouseOut: onMouseOut,
                onMouseLeave: _this.mouseLeave
            }), (0, $45CBz.jsx)((0, $9yV1o.ContainerNavigationMask), {
                disableInteraction: itemIsDragging,
                onMouseOver: EXPERIMENTAL_ALTERNATE_FLYOUT_BEHAVIOUR ? null : onMouseOver
            }, (0, $45CBz.jsx)((0, $hYYQc.default), {
                blockOnChange: true,
                itemIsDragging: itemIsDragging
            }, !EXPERIMENTAL_HORIZONTAL_GLOBAL_NAV && // Prevents GlobalNavigation from re-rendering on resize,
            // and flyout expand/collapse
            (0, $45CBz.jsx)((0, $hYYQc.default), {
                blockOnChange: true,
                isResizing: isResizing,
                isCollapsed: isCollapsed,
                flyoutIsOpen: flyoutIsOpen
            }, (0, $45CBz.jsx)((0, $lAQgg.ComposedGlobalNavigation), {
                containerNavigation: containerNavigation,
                datasets: datasets,
                globalNavigation: globalNavigation,
                topOffset: topOffset,
                shouldHideGlobalNavShadow: shouldHideGlobalNavShadow,
                experimental_alternateFlyoutBehaviour: EXPERIMENTAL_ALTERNATE_FLYOUT_BEHAVIOUR,
                closeFlyout: _this.closeFlyout,
                view: view
            })), (0, $45CBz.jsx)((0, $7q00A.default), {
                from: [
                    showContextualNavigation ? (0, $5SBZk.CONTENT_NAV_WIDTH_COLLAPSED) : 0
                ],
                in: showContextualNavigation ? !isCollapsed || flyoutIsOpen : false,
                properties: [
                    "width"
                ],
                to: [
                    flyoutIsOpen ? flyoutWidth : productNavWidth
                ],
                userIsDragging: isResizing // only apply listeners to the NAV resize transition
                ,
                productNavWidth: productNavWidth
            }, function(_ref3) {
                var transitionStyle = _ref3.transitionStyle, transitionState = _ref3.transitionState;
                return (0, $45CBz.jsx)((0, $lAQgg.ComposedContainerNavigation), {
                    containerNavigation: containerNavigation,
                    datasets: datasets,
                    experimental_flyoutOnHover: EXPERIMENTAL_FLYOUT_ON_HOVER,
                    experimental_hideNavVisuallyOnCollapse: !!EXPERIMENTAL_HIDE_NAV_VISUALLY_ON_COLLAPSE,
                    expand: navigationUIController.expand,
                    productNavigation: productNavigation,
                    transitionState: transitionState,
                    transitionStyle: transitionStyle,
                    isCollapsed: isCollapsed,
                    isResizing: isResizing,
                    getNavRef: _this.getNavRef,
                    view: view
                });
            }))), showContextualNavigation && (0, $45CBz.jsx)((0, $fXcGH.default), {
                collapseToggleTooltipContent: collapseToggleTooltipContent,
                expandCollapseAffordanceRef: _this.nodeRefs.expandCollapseAffordance // eslint-disable-next-line camelcase
                ,
                experimental_flyoutOnHover: EXPERIMENTAL_FLYOUT_ON_HOVER,
                isDisabled: isResizeDisabled,
                flyoutIsOpen: flyoutIsOpen,
                isGrabAreaDisabled: itemIsDragging,
                onMouseOverButtonBuffer: EXPERIMENTAL_ALTERNATE_FLYOUT_BEHAVIOUR ? _this.closeFlyout : null,
                mutationRefs: [
                    {
                        ref: _this.pageRef,
                        property: "padding-left"
                    },
                    {
                        ref: _this.productNavRef,
                        property: "width"
                    }
                ],
                navigation: navigationUIController
            })))));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "renderPageContent", function() {
            var _this$props2 = _this.props, datasets = _this$props2.datasets, EXPERIMENTAL_HORIZONTAL_GLOBAL_NAV = _this$props2.experimental_horizontalGlobalNav, navigationUIController = _this$props2.navigationUIController, onExpandStart = _this$props2.onExpandStart, onExpandEnd = _this$props2.onExpandEnd, onCollapseStart = _this$props2.onCollapseStart, onCollapseEnd = _this$props2.onCollapseEnd, children = _this$props2.children, showContextualNavigation = _this$props2.showContextualNavigation;
            var flyoutIsOpen = _this.state.flyoutIsOpen;
            var _navigationUIControll2 = navigationUIController.state, isResizing = _navigationUIControll2.isResizing, isCollapsed = _navigationUIControll2.isCollapsed, productNavWidth = _navigationUIControll2.productNavWidth;
            var leftOffset = EXPERIMENTAL_HORIZONTAL_GLOBAL_NAV ? 0 : (0, $5SBZk.GLOBAL_NAV_WIDTH); // This offset should just be the global nav height, as the topOffset prop has already been applied
            // to layout manager content via a margin
            var topOffset = EXPERIMENTAL_HORIZONTAL_GLOBAL_NAV ? (0, $5SBZk.HORIZONTAL_GLOBAL_NAV_HEIGHT) : 0;
            var collapsedSize = 0;
            var expandedSize = flyoutIsOpen ? (0, $5SBZk.CONTENT_NAV_WIDTH_FLYOUT) : productNavWidth;
            var dataset = datasets ? datasets.content : {};
            return (0, $45CBz.jsx)((0, $7q00A.default), {
                from: [
                    (0, $5SBZk.CONTENT_NAV_WIDTH_COLLAPSED)
                ],
                in: !isCollapsed,
                productNavWidth: productNavWidth,
                properties: [
                    "paddingLeft"
                ],
                to: [
                    showContextualNavigation ? expandedSize : collapsedSize
                ],
                userIsDragging: isResizing,
                onExpandStart: onExpandStart,
                onExpandEnd: onExpandEnd,
                onCollapseStart: onCollapseStart,
                onCollapseEnd: onCollapseEnd
            }, function(_ref4) {
                var transitionStyle = _ref4.transitionStyle, transitionState = _ref4.transitionState;
                return (0, $45CBz.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                    css: (0, $7c3Cv.pageContainerCSS)({
                        disableInteraction: isResizing || (0, $7q00A.isTransitioning)(transitionState),
                        leftOffset: leftOffset,
                        topOffset: topOffset
                    }),
                    ref: _this.getPageRef,
                    style: transitionStyle
                }, dataset), children);
            });
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(LayoutManager, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.publishRefs();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.publishRefs();
            }
        },
        {
            key: "publishRefs",
            value: function publishRefs() {
                var getRefs = this.props.getRefs;
                if (typeof getRefs === "function") getRefs(this.nodeRefs);
            }
        },
        {
            key: "render",
            value: function render() {
                var topOffset = this.props.topOffset;
                return (0, $45CBz.jsx)((0, $bzE1X.LayoutContainer), {
                    topOffset: topOffset
                }, this.renderNavigation(), this.renderPageContent());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // kill the flyout when the user commits to expanding navigation
                if (!props.navigationUIController.state.isCollapsed && state.flyoutIsOpen) return {
                    flyoutIsOpen: false
                };
                return null;
            }
        }
    ]);
    return LayoutManager;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($40fe59aeb922c075$export$2e2bcd8739ae039, "defaultProps", {
    collapseToggleTooltipContent: $40fe59aeb922c075$var$defaultTooltipContent,
    datasets: {
        content: {
            "data-testid": "Content"
        },
        contextualNavigation: {
            "data-testid": "ContextualNavigation"
        },
        globalNavigation: {
            "data-testid": "GlobalNavigation"
        },
        navigation: {
            "data-testid": "Navigation"
        }
    },
    topOffset: 0,
    shouldHideGlobalNavShadow: false,
    // eslint-disable-next-line camelcase
    experimental_alternateFlyoutBehaviour: false,
    experimental_flyoutOnHover: false,
    experimental_fullWidthFlyout: false,
    experimental_hideNavVisuallyOnCollapse: false,
    experimental_horizontalGlobalNav: false,
    showContextualNavigation: true
});

});
parcelRegister("hYYQc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1773bfe510eab51$export$2e2bcd8739ae039; });

var $lOQkO = parcelRequire("lOQkO");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");
var $d1773bfe510eab51$var$_excluded = [
    "blockOnChange",
    "children"
];
function $d1773bfe510eab51$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d1773bfe510eab51$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $d1773bfe510eab51$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * This component blocks render unless any non-children props change via shallow comparison.
 *
 * Alternatively if `blockOnChange` is set, render will only be blocked when another non-children prop changes.
 * For example, if you know you do not want to re-render when a certain prop changes (use with care).
 */ var $d1773bfe510eab51$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(RenderBlocker, _Component);
    var _super = $d1773bfe510eab51$var$_createSuper(RenderBlocker);
    function RenderBlocker() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, RenderBlocker);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(RenderBlocker, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(prevProps) {
                var _this$props = this.props, blockOnChange = _this$props.blockOnChange, children = _this$props.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_this$props, $d1773bfe510eab51$var$_excluded);
                var propsChanged = Object.keys(props).some(function(propName) {
                    return props[propName] !== prevProps[propName];
                });
                return this.props.blockOnChange ? !propsChanged : propsChanged;
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return RenderBlocker;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($d1773bfe510eab51$export$2e2bcd8739ae039, "defaultProps", {
    blockOnChange: false
});

});

parcelRegister("7q00A", function(module, exports) {

$parcel$export(module.exports, "isTransitioning", function () { return $566af7cbaa0cbd3f$export$aba9e8910667bd50; });
$parcel$export(module.exports, "default", function () { return $566af7cbaa0cbd3f$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $3Jogu = parcelRequire("3Jogu");

var $45CBz = parcelRequire("45CBz");
function $566af7cbaa0cbd3f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $566af7cbaa0cbd3f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $566af7cbaa0cbd3f$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $566af7cbaa0cbd3f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $566af7cbaa0cbd3f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $566af7cbaa0cbd3f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $566af7cbaa0cbd3f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $566af7cbaa0cbd3f$var$DURATION = 300;
function $566af7cbaa0cbd3f$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function $566af7cbaa0cbd3f$var$getTransition(keys) {
    return {
        transition: keys.map(function(k) {
            return "".concat($566af7cbaa0cbd3f$var$camelToKebab(k), " ").concat($566af7cbaa0cbd3f$var$DURATION, "ms cubic-bezier(0.2, 0, 0, 1)");
        }).join(",")
    };
}
function $566af7cbaa0cbd3f$var$getStyle(_ref) {
    var keys = _ref.keys, values = _ref.values;
    var style = {};
    keys.forEach(function(k, i) {
        style[k] = values[i];
    });
    return style;
}
function $566af7cbaa0cbd3f$var$getChanges(keys) {
    var props = keys.map(function(k) {
        return $566af7cbaa0cbd3f$var$camelToKebab(k);
    });
    return {
        willChange: props.join(",")
    };
}
function $566af7cbaa0cbd3f$export$aba9e8910667bd50(state) {
    return [
        "entering",
        "exiting"
    ].includes(state);
}
function $566af7cbaa0cbd3f$var$NOOP() {}
var $566af7cbaa0cbd3f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_PureComponent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(ResizeTransition, _PureComponent);
    var _super = $566af7cbaa0cbd3f$var$_createSuper(ResizeTransition);
    function ResizeTransition() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ResizeTransition);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "target", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isMounted", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getTarget", function(ref) {
            _this.target = ref;
            var innerRef = _this.props.innerRef;
            if (innerRef) innerRef(ref);
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ResizeTransition, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._isMounted = true;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, from = _this$props.from, onExpandStart = _this$props.onExpandStart, onExpandEnd = _this$props.onExpandEnd, onCollapseStart = _this$props.onCollapseStart, onCollapseEnd = _this$props.onCollapseEnd, properties = _this$props.properties, to = _this$props.to, userIsDragging = _this$props.userIsDragging, inProp = _this$props.in;
                return (0, $45CBz.jsx)((0, $3Jogu.default), {
                    onEntering: onExpandStart,
                    onEntered: onExpandEnd,
                    onExiting: onCollapseStart,
                    onExited: onCollapseEnd,
                    in: inProp,
                    timeout: this._isMounted ? $566af7cbaa0cbd3f$var$DURATION : 0
                }, function(transitionState) {
                    // transitions interupt manual resize behaviour
                    var cssTransition = !userIsDragging && _this2._isMounted ? $566af7cbaa0cbd3f$var$getTransition(properties) : {}; // `from` and `to` styles tweened by the transition
                    var dynamicProperties = {
                        exiting: $566af7cbaa0cbd3f$var$getStyle({
                            keys: properties,
                            values: from
                        }),
                        exited: $566af7cbaa0cbd3f$var$getStyle({
                            keys: properties,
                            values: from
                        }),
                        entering: $566af7cbaa0cbd3f$var$getStyle({
                            keys: properties,
                            values: to
                        }),
                        entered: $566af7cbaa0cbd3f$var$getStyle({
                            keys: properties,
                            values: to
                        })
                    }; // let the browser know what we're up to
                    var willChange = $566af7cbaa0cbd3f$var$getChanges(properties); // put it all together
                    var transitionStyle = $566af7cbaa0cbd3f$var$_objectSpread($566af7cbaa0cbd3f$var$_objectSpread($566af7cbaa0cbd3f$var$_objectSpread({}, willChange), cssTransition), dynamicProperties[transitionState]);
                    return _this2.props.children({
                        transitionStyle: transitionStyle,
                        // consumers must apply `transitionStyle`
                        transitionState: transitionState // lets consumers react to the current state
                    });
                });
            }
        }
    ]);
    return ResizeTransition;
}((0, $9nHZC.PureComponent));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($566af7cbaa0cbd3f$export$2e2bcd8739ae039, "defaultProps", {
    onExpandStart: $566af7cbaa0cbd3f$var$NOOP,
    onExpandEnd: $566af7cbaa0cbd3f$var$NOOP,
    onCollapseStart: $566af7cbaa0cbd3f$var$NOOP,
    onCollapseEnd: $566af7cbaa0cbd3f$var$NOOP
});

});

parcelRegister("hNe55", function(module, exports) {

$parcel$export(module.exports, "LayoutEventListener", function () { return $cf41ef7c51b08f53$export$8c173c4f2bce980b; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $45CBz = parcelRequire("45CBz");
function $cf41ef7c51b08f53$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $cf41ef7c51b08f53$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $cf41ef7c51b08f53$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $cf41ef7c51b08f53$var$noop = function noop() {};
var $cf41ef7c51b08f53$var$_React$createContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createContext({
    emitItemDragStart: $cf41ef7c51b08f53$var$noop,
    emitItemDragEnd: $cf41ef7c51b08f53$var$noop
}), $cf41ef7c51b08f53$var$Provider = $cf41ef7c51b08f53$var$_React$createContext.Provider, $cf41ef7c51b08f53$export$bdb4857f1ace4871 = $cf41ef7c51b08f53$var$_React$createContext.Consumer;
var $cf41ef7c51b08f53$export$8c173c4f2bce980b = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(LayoutEventListener, _Component);
    var _super = $cf41ef7c51b08f53$var$_createSuper(LayoutEventListener);
    function LayoutEventListener(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, LayoutEventListener);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "emitters", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "emitItemDragStart", function() {
            _this.props.onItemDragStart();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "emitItemDragEnd", function() {
            _this.props.onItemDragEnd();
        });
        _this.emitters = {
            emitItemDragStart: _this.emitItemDragStart,
            emitItemDragEnd: _this.emitItemDragEnd
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(LayoutEventListener, [
        {
            key: "render",
            value: function render() {
                return (0, $45CBz.jsx)($cf41ef7c51b08f53$var$Provider, {
                    value: this.emitters
                }, this.props.children);
            }
        }
    ]);
    return LayoutEventListener;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($cf41ef7c51b08f53$export$8c173c4f2bce980b, "defaultProps", {
    onItemDragStart: $cf41ef7c51b08f53$var$noop,
    onItemDragEnd: $cf41ef7c51b08f53$var$noop
});

});

parcelRegister("lAQgg", function(module, exports) {

$parcel$export(module.exports, "ComposedContainerNavigation", function () { return $fb857fcd324834e2$export$3f7854bee3195a; });
$parcel$export(module.exports, "ComposedGlobalNavigation", function () { return $fb857fcd324834e2$export$8ef199459399b0f3; });

var $kFnE9 = parcelRequire("kFnE9");

var $fPPqr = parcelRequire("fPPqr");

var $7KAwG = parcelRequire("7KAwG");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $9nHZC = parcelRequire("9nHZC");

var $fIcbc = parcelRequire("fIcbc");

var $jp7ng = parcelRequire("jp7ng");

var $5SBZk = parcelRequire("5SBZk");

var $ihtSr = parcelRequire("ihtSr");

var $3YYFd = parcelRequire("3YYFd");
var $1HkF5 = parcelRequire("1HkF5");

var $bgYmH = parcelRequire("bgYmH");

var $9yV1o = parcelRequire("9yV1o");

var $7q00A = parcelRequire("7q00A");

var $45CBz = parcelRequire("45CBz");
function $fb857fcd324834e2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fb857fcd324834e2$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $fb857fcd324834e2$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $fb857fcd324834e2$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $fb857fcd324834e2$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $fb857fcd324834e2$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $fb857fcd324834e2$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $fb857fcd324834e2$export$3f7854bee3195a = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(ComposedContainerNavigation, _Component);
    var _super = $fb857fcd324834e2$var$_createSuper(ComposedContainerNavigation);
    function ComposedContainerNavigation() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ComposedContainerNavigation);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ComposedContainerNavigation, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var props = this.props;
                return !(0, (/*@__PURE__*/$parcel$interopDefault($fIcbc)))(props, nextProps);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, containerNavigation = _this$props.containerNavigation, datasets = _this$props.datasets, EXPERIMENTAL_FLYOUT_ON_HOVER = _this$props.experimental_flyoutOnHover, EXPERIMENTAL_HIDE_NAV_VISUALLY_ON_COLLAPSE = _this$props.experimental_hideNavVisuallyOnCollapse, productNavigation = _this$props.productNavigation, transitionState = _this$props.transitionState, transitionStyle = _this$props.transitionStyle, isCollapsed = _this$props.isCollapsed, isResizing = _this$props.isResizing, getNavRef = _this$props.getNavRef, expand = _this$props.expand, view = _this$props.view;
                var isVisible = transitionState !== "exited";
                var shouldDisableInteraction = isResizing || (0, $7q00A.isTransitioning)(transitionState);
                var dataset = datasets ? datasets.contextualNavigation : {};
                return (0, $45CBz.jsx)((0, $9yV1o.ContentNavigationWrapper), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                    key: "product-nav-wrapper",
                    innerRef: getNavRef,
                    disableInteraction: shouldDisableInteraction,
                    style: transitionStyle
                }, dataset), (0, $45CBz.jsx)((0, $bgYmH.default), {
                    container: containerNavigation,
                    isVisible: isVisible,
                    key: "product-nav",
                    product: productNavigation,
                    experimental_hideNavVisuallyOnCollapse: EXPERIMENTAL_HIDE_NAV_VISUALLY_ON_COLLAPSE,
                    view: view
                }), isCollapsed && !EXPERIMENTAL_FLYOUT_ON_HOVER ? /* eslint-disable jsx-a11y/click-events-have-key-events */ (0, $45CBz.jsx)("div", {
                    "aria-label": "Click to expand the navigation",
                    role: "button",
                    onClick: expand,
                    css: /*#__PURE__*/ (0, $7KAwG.default)({
                        cursor: "pointer",
                        height: "100%",
                        outline: 0,
                        position: "absolute",
                        transition: "background-color 100ms",
                        width: (0, $5SBZk.CONTENT_NAV_WIDTH_COLLAPSED),
                        ":hover": {
                            backgroundColor: containerNavigation ? (0, $jp7ng.N30) : "rgba(255, 255, 255, 0.08)"
                        },
                        ":active": {
                            backgroundColor: (0, $jp7ng.N40A)
                        }
                    }, ""),
                    tabIndex: -1
                }) : /* eslint-enable */ null);
            }
        }
    ]);
    return ComposedContainerNavigation;
}((0, $9nHZC.Component)); // Shallow comparision of props is sufficeint in this case
var $fb857fcd324834e2$export$8ef199459399b0f3 = /*#__PURE__*/ function(_Component2) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(ComposedGlobalNavigation, _Component2);
    var _super2 = $fb857fcd324834e2$var$_createSuper(ComposedGlobalNavigation);
    function ComposedGlobalNavigation() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ComposedGlobalNavigation);
        return _super2.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ComposedGlobalNavigation, [
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, containerNavigation = _this$props2.containerNavigation, datasets = _this$props2.datasets, GlobalNavigation = _this$props2.globalNavigation, topOffset = _this$props2.topOffset, shouldHideGlobalNavShadow = _this$props2.shouldHideGlobalNavShadow, EXPERIMENTAL_ALTERNATE_FLYOUT_BEHAVIOUR = _this$props2.experimental_alternateFlyoutBehaviour, closeFlyout = _this$props2.closeFlyout;
                var dataset = datasets ? datasets.globalNavigation : {};
                return (0, $45CBz.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, dataset, {
                    onMouseOver: EXPERIMENTAL_ALTERNATE_FLYOUT_BEHAVIOUR ? closeFlyout : null
                }), (0, $45CBz.jsx)((0, $1HkF5.ThemeProvider), {
                    theme: function theme(_theme) {
                        return $fb857fcd324834e2$var$_objectSpread({
                            topOffset: topOffset,
                            mode: (0, $3YYFd.light)
                        }, _theme);
                    }
                }, (0, $45CBz.jsx)((0, $9nHZC.Fragment), null, !shouldHideGlobalNavShadow && (0, $45CBz.jsx)((0, $ihtSr.Shadow), {
                    isBold: !!containerNavigation,
                    isOverDarkBg: true,
                    style: {
                        marginLeft: (0, $5SBZk.GLOBAL_NAV_WIDTH)
                    }
                }), (0, $45CBz.jsx)(GlobalNavigation, null))));
            }
        }
    ]);
    return ComposedGlobalNavigation;
}((0, $9nHZC.Component));

});
parcelRegister("ihtSr", function(module, exports) {

$parcel$export(module.exports, "Shadow", function () { return $d4f0fd7a7297aab2$export$a24c14443968327c; });

var $fPPqr = parcelRequire("fPPqr");

var $7KAwG = parcelRequire("7KAwG");

var $lOQkO = parcelRequire("lOQkO");
parcelRequire("9nHZC");

var $5SBZk = parcelRequire("5SBZk");

var $45CBz = parcelRequire("45CBz");
var $d4f0fd7a7297aab2$var$_excluded = [
    "direction",
    "isBold",
    "isOverDarkBg"
];
var $d4f0fd7a7297aab2$export$a24c14443968327c = function Shadow(_ref) {
    var direction = _ref.direction, isBold = _ref.isBold, isOverDarkBg = _ref.isOverDarkBg, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $d4f0fd7a7297aab2$var$_excluded);
    var width = isOverDarkBg ? 6 : 3;
    if (isBold) width = isOverDarkBg ? 12 : 6;
    var colorStops = "\n    rgba(0, 0, 0, 0.2) 0px,\n    rgba(0, 0, 0, 0.2) 1px,\n    rgba(0, 0, 0, 0.1) 1px,\n    rgba(0, 0, 0, 0) 100%\n  ";
    return (0, $45CBz.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        css: /*#__PURE__*/ (0, $7KAwG.default)({
            background: "linear-gradient(".concat(direction, ", ").concat(colorStops, ")"),
            bottom: 0,
            left: direction === "to left" ? -width : -1,
            opacity: isBold ? 1 : 0.5,
            pointerEvents: "none",
            position: "absolute",
            top: 0,
            transitionDuration: (0, $5SBZk.transitionDuration),
            transitionProperty: "left, opacity, width",
            transitionTimingFunction: (0, $5SBZk.transitionTimingFunction),
            width: width
        }, "")
    }, props));
};
$d4f0fd7a7297aab2$export$a24c14443968327c.defaultProps = {
    direction: "to left"
};

});

parcelRegister("bgYmH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8350039a93cbf5ea$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $fIcbc = parcelRequire("fIcbc");

var $3Jogu = parcelRequire("3Jogu");
parcelRequire("jlzQX");
var $1irk6 = parcelRequire("1irk6");

var $5SBZk = parcelRequire("5SBZk");

var $9yV1o = parcelRequire("9yV1o");

var $45CBz = parcelRequire("45CBz");
var $8350039a93cbf5ea$var$_excluded = [
    "isVisible",
    "experimental_hideNavVisuallyOnCollapse"
];
function $8350039a93cbf5ea$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8350039a93cbf5ea$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8350039a93cbf5ea$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8350039a93cbf5ea$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8350039a93cbf5ea$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8350039a93cbf5ea$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $8350039a93cbf5ea$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $8350039a93cbf5ea$var$ToggleContent = function ToggleContent(_ref) {
    var isVisible = _ref.isVisible, EXPERIMENTAL_HIDE_NAV_VISUALLY_ON_COLLAPSE = _ref.experimental_hideNavVisuallyOnCollapse, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $8350039a93cbf5ea$var$_excluded);
    // If FF is false, retain the old behaviour of
    // un-mounting navigation components on collapse
    if (!EXPERIMENTAL_HIDE_NAV_VISUALLY_ON_COLLAPSE && !isVisible) return null;
    return (0, $45CBz.jsx)((0, $9nHZC.Fragment), rest);
};
var $8350039a93cbf5ea$var$productNavigationAnalytics = {
    attributes: {
        navigationLayer: "product"
    }
};
var $8350039a93cbf5ea$var$containerNavigationAnalytics = {
    attributes: {
        navigationLayer: "container"
    }
};
var $8350039a93cbf5ea$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(ContentNavigation, _Component);
    var _super = $8350039a93cbf5ea$var$_createSuper(ContentNavigation);
    function ContentNavigation() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ContentNavigation);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isMounted", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "state", {
            cachedContainer: null
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ContentNavigation, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._isMounted = true;
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var props = this.props;
                return !(0, (/*@__PURE__*/$parcel$interopDefault($fIcbc)))(props, nextProps);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, container = _this$props.container, isVisible = _this$props.isVisible, Product = _this$props.product, EXPERIMENTAL_HIDE_NAV_VISUALLY_ON_COLLAPSE = _this$props.experimental_hideNavVisuallyOnCollapse;
                var CachedContainer = this.state.cachedContainer;
                var shouldRenderContainer = Boolean(container);
                var ContainerComponent = CachedContainer || (0, $9nHZC.Fragment);
                return (0, $45CBz.jsx)((0, $9nHZC.Fragment), null, (0, $45CBz.jsx)((0, $9yV1o.ProductNavigation), {
                    isVisible: isVisible
                }, (0, $45CBz.jsx)($8350039a93cbf5ea$var$ToggleContent, {
                    experimental_hideNavVisuallyOnCollapse: EXPERIMENTAL_HIDE_NAV_VISUALLY_ON_COLLAPSE,
                    isVisible: isVisible
                }, (0, $45CBz.jsx)((0, $1irk6.NavigationAnalyticsContext), {
                    data: $8350039a93cbf5ea$var$productNavigationAnalytics
                }, (0, $45CBz.jsx)(Product, null)))), (0, $45CBz.jsx)((0, $3Jogu.default), {
                    in: shouldRenderContainer,
                    timeout: this._isMounted ? (0, $5SBZk.transitionDurationMs) : 0,
                    mountOnEnter: true,
                    unmountOnExit: true
                }, function(state) {
                    return (0, $45CBz.jsx)((0, $9yV1o.ContainerNavigation), {
                        isEntering: state === "entering",
                        isExiting: state === "exiting",
                        isVisible: isVisible
                    }, (0, $45CBz.jsx)($8350039a93cbf5ea$var$ToggleContent, {
                        experimental_hideNavVisuallyOnCollapse: EXPERIMENTAL_HIDE_NAV_VISUALLY_ON_COLLAPSE,
                        isVisible: isVisible
                    }, (0, $45CBz.jsx)((0, $1irk6.NavigationAnalyticsContext), {
                        data: $8350039a93cbf5ea$var$containerNavigationAnalytics
                    }, (0, $45CBz.jsx)(ContainerComponent, null))));
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(_ref2, state) {
                var container = _ref2.container;
                if (container && container !== state.cachedContainer) // We cache the most recent container component in state so that we can
                // render it while the container layer is transitioning out, which is
                // triggered by setting the container prop to null.
                return $8350039a93cbf5ea$var$_objectSpread($8350039a93cbf5ea$var$_objectSpread({}, state), {}, {
                    cachedContainer: container
                });
                return null;
            }
        }
    ]);
    return ContentNavigation;
}((0, $9nHZC.Component));

});


parcelRegister("bzE1X", function(module, exports) {

$parcel$export(module.exports, "LayoutContainer", function () { return $86d203d975a4b79f$export$faad8b178f68f912; });
$parcel$export(module.exports, "HorizontalNavigationContainer", function () { return $86d203d975a4b79f$export$3b48bf2f5b5a8f60; });
$parcel$export(module.exports, "NavigationContainer", function () { return $86d203d975a4b79f$export$d1b98bde82a43bb3; });

var $fPPqr = parcelRequire("fPPqr");

var $7KAwG = parcelRequire("7KAwG");

var $lOQkO = parcelRequire("lOQkO");
parcelRequire("9nHZC");

var $aP6k3 = parcelRequire("aP6k3");

var $45CBz = parcelRequire("45CBz");
var $86d203d975a4b79f$var$_excluded = [
    "topOffset"
], $86d203d975a4b79f$var$_excluded2 = [
    "topOffset",
    "innerRef"
];
var $86d203d975a4b79f$export$faad8b178f68f912 = function LayoutContainer(_ref) {
    var _ref$topOffset = _ref.topOffset, topOffset = _ref$topOffset === void 0 ? 0 : _ref$topOffset, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $86d203d975a4b79f$var$_excluded);
    return (0, $45CBz.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        // Used as a CSS selector in Confluence
        // https://ecosystem.atlassian.net/browse/DS-7189
        "data-layout-container": true,
        css: /*#__PURE__*/ (0, $7KAwG.default)({
            display: "flex",
            flexDirection: "row",
            height: "calc(100vh - ".concat(topOffset, "px)"),
            marginTop: "".concat(topOffset, "px")
        }, "")
    }, props));
};
var $86d203d975a4b79f$export$3b48bf2f5b5a8f60 = function HorizontalNavigationContainer(_ref2) {
    var children = _ref2.children, topOffset = _ref2.topOffset;
    return (0, $45CBz.jsx)("div", {
        css: /*#__PURE__*/ (0, $7KAwG.default)({
            position: "fixed",
            top: topOffset,
            left: 0,
            right: 0,
            zIndex: (0, $aP6k3.layers).navigation() + 1
        }, "")
    }, children);
};
var $86d203d975a4b79f$export$d1b98bde82a43bb3 = function NavigationContainer(_ref3) {
    var topOffset = _ref3.topOffset, innerRef = _ref3.innerRef, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref3, $86d203d975a4b79f$var$_excluded2);
    return (0, $45CBz.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        ref: innerRef,
        css: /*#__PURE__*/ (0, $7KAwG.default)({
            bottom: 0,
            left: 0,
            position: "fixed",
            top: topOffset,
            zIndex: (0, $aP6k3.layers).navigation(),
            "&:hover .ak-navigation-resize-button": {
                opacity: 1
            }
        }, "")
    }, props));
};

});

parcelRegister("fXcGH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9d6353a34999d11$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $fPPqr = parcelRequire("fPPqr");

var $7KAwG = parcelRequire("7KAwG");

var $9nHZC = parcelRequire("9nHZC");

var $45CBz = parcelRequire("45CBz");

var $eipj2 = parcelRequire("eipj2");

var $e9mJX = parcelRequire("e9mJX");

var $8B1FA = parcelRequire("8B1FA");

var $kavlx = parcelRequire("kavlx");

var $jp7ng = parcelRequire("jp7ng");

var $lMUjN = parcelRequire("lMUjN");

var $8Z5er = parcelRequire("8Z5er");

var $5SBZk = parcelRequire("5SBZk");

var $ihtSr = parcelRequire("ihtSr");
var $b9d6353a34999d11$var$_excluded = [
    "showHandle",
    "isBold"
], $b9d6353a34999d11$var$_excluded2 = [
    "children",
    "hasHighlight",
    "innerRef",
    "isVisible",
    "hitAreaSize"
];
function $b9d6353a34999d11$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b9d6353a34999d11$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $b9d6353a34999d11$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b9d6353a34999d11$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $b9d6353a34999d11$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b9d6353a34999d11$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b9d6353a34999d11$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b9d6353a34999d11$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $b9d6353a34999d11$var$HANDLE_OFFSET = 4;
var $b9d6353a34999d11$var$INNER_WIDTH = 20;
var $b9d6353a34999d11$var$OUTER_WIDTH = $b9d6353a34999d11$var$INNER_WIDTH + $b9d6353a34999d11$var$HANDLE_OFFSET;
var $b9d6353a34999d11$var$HANDLE_WIDTH = 2;
var $b9d6353a34999d11$var$shouldResetGrabArea = function shouldResetGrabArea(width) {
    return width >= (0, $5SBZk.GLOBAL_NAV_COLLAPSE_THRESHOLD) && width < (0, $5SBZk.CONTENT_NAV_WIDTH);
};
var $b9d6353a34999d11$var$preventDefault = function preventDefault(event) {
    return event.preventDefault();
};
var $b9d6353a34999d11$export$9c37550d5bbcae1 = function BodyDragCursor() {
    return (0, $45CBz.jsx)((0, $45CBz.Global), {
        styles: {
            body: {
                cursor: "ew-resize"
            }
        }
    });
};
var $b9d6353a34999d11$var$Outer = function Outer(props) {
    return (0, $45CBz.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        css: /*#__PURE__*/ (0, $7KAwG.default)({
            bottom: 0,
            left: "100%",
            position: "absolute",
            top: 0,
            transform: "translateZ(0)",
            width: $b9d6353a34999d11$var$OUTER_WIDTH,
            zIndex: 3 // higher than the scroll hint lines
        }, "")
    }, props));
};
var $b9d6353a34999d11$export$a79cdb26132f421e = function GrabArea(_ref) {
    var showHandle = _ref.showHandle, isBold = _ref.isBold, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $b9d6353a34999d11$var$_excluded);
    return (0, $45CBz.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        css: /*#__PURE__*/ (0, $7KAwG.default)({
            cursor: "ew-resize",
            height: "100%",
            left: -$b9d6353a34999d11$var$HANDLE_OFFSET,
            position: "relative",
            width: $b9d6353a34999d11$var$OUTER_WIDTH
        }, "")
    }, props), (0, $45CBz.jsx)("div", {
        css: /*#__PURE__*/ (0, $7KAwG.default)({
            backgroundColor: isBold ? $jp7ng.B200 : $jp7ng.B100,
            opacity: showHandle ? 1 : 0,
            height: "100%",
            left: $b9d6353a34999d11$var$HANDLE_OFFSET - $b9d6353a34999d11$var$HANDLE_WIDTH / 2,
            // the handle should "straddle" the dividing line
            position: "absolute",
            transition: "opacity 200ms",
            width: $b9d6353a34999d11$var$HANDLE_WIDTH
        }, "")
    }));
};
var $b9d6353a34999d11$var$largeHitArea = {
    left: -8,
    right: -12,
    bottom: -8,
    top: -8
};
var $b9d6353a34999d11$var$smallHitArea = {
    left: -4,
    right: -4,
    bottom: -4,
    top: -4
};
var $b9d6353a34999d11$var$Button = function Button(_ref2) {
    var children = _ref2.children, hasHighlight = _ref2.hasHighlight, innerRef = _ref2.innerRef, isVisible = _ref2.isVisible, hitAreaSize = _ref2.hitAreaSize, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref2, $b9d6353a34999d11$var$_excluded2);
    return (0, $45CBz.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        className: "ak-navigation-resize-button",
        type: "button",
        ref: innerRef,
        css: /*#__PURE__*/ (0, $7KAwG.default)({
            background: 0,
            backgroundColor: "white",
            border: 0,
            borderRadius: "50%",
            boxShadow: "0 0 0 1px ".concat($jp7ng.N30A, ", 0 2px 4px 1px ").concat($jp7ng.N30A),
            color: hasHighlight ? $jp7ng.B100 : $jp7ng.N200,
            cursor: "pointer",
            height: 24,
            opacity: isVisible ? 1 : 0,
            outline: 0,
            padding: 0,
            position: "absolute",
            top: 32,
            transition: "\n        background-color 100ms linear,\n        color 100ms linear,\n        opacity 300ms cubic-bezier(0.2, 0, 0, 1),\n        transform 300ms cubic-bezier(0.2, 0, 0, 1)\n      ",
            transform: "translate(-50%)",
            width: 24,
            ":hover": {
                backgroundColor: $jp7ng.B100,
                color: "white"
            },
            ":active": {
                backgroundColor: $jp7ng.B200,
                color: "white"
            },
            ":focus": {
                opacity: 1,
                backgroundColor: $jp7ng.B200,
                color: "white"
            }
        }, "")
    }, props), (0, $45CBz.jsx)("div", {
        // increase hit-area
        css: /*#__PURE__*/ (0, $7KAwG.default)($b9d6353a34999d11$var$_objectSpread({
            position: "absolute"
        }, hitAreaSize === "small" ? $b9d6353a34999d11$var$smallHitArea : $b9d6353a34999d11$var$largeHitArea), "")
    }), children);
}; // tinker with the DOM directly by setting style properties, updates the grab bar position by changing padding-left and width.
function $b9d6353a34999d11$var$updateResizeAreaPosition(elements, width) {
    elements.forEach(function(_ref3) {
        var property = _ref3.property, ref = _ref3.ref;
        var newValue = "".concat(width, "px");
        var oldValue = ref.style.getPropertyValue(property); // avoid thrashing
        if (oldValue === newValue) return; // direct attribute manipulation
        ref.style.setProperty(property, newValue);
    });
} // helper for tooltip content keyboard shortcut highlight
var $b9d6353a34999d11$var$_ref5 = {
    name: "jeedki",
    styles: "align-items:baseline;display:flex;line-height:1.3;padding-bottom:1px;padding-top:1px;"
};
function $b9d6353a34999d11$var$makeTooltipNode(_ref4) {
    var text = _ref4.text, char = _ref4.char;
    return (0, $45CBz.jsx)("div", {
        css: $b9d6353a34999d11$var$_ref5
    }, (0, $45CBz.jsx)("span", null, text), (0, $45CBz.jsx)("div", {
        css: /*#__PURE__*/ (0, $7KAwG.default)({
            backgroundColor: $jp7ng.N400,
            borderRadius: 2,
            lineHeight: 1.2,
            marginLeft: 4,
            padding: "1px 8px"
        }, "")
    }, char));
}
/* NOTE: experimental props use an underscore */ var $b9d6353a34999d11$export$67d2000dcb6846eb = /*#__PURE__*/ function(_PureComponent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(ResizeControl, _PureComponent);
    var _super = $b9d6353a34999d11$var$_createSuper(ResizeControl);
    function ResizeControl() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ResizeControl);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "invalidDragAttempted", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "lastWidth", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "wrapper", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "state", {
            delta: 0,
            didDragOpen: false,
            isDragging: false,
            initialWidth: 0,
            initialX: 0,
            mouseIsDown: false,
            mouseIsOverGrabArea: false,
            showGrabArea: true,
            width: _this.props.navigation.state.productNavWidth
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onResizerChevronClick", function() {
            var trigger = _this.props.flyoutIsOpen ? "chevronHover" : "chevron";
            _this.toggleCollapse(trigger);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "mouseEnterGrabArea", function() {
            _this.setState({
                mouseIsOverGrabArea: true
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "mouseLeaveGrabArea", function() {
            _this.setState({
                mouseIsOverGrabArea: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "toggleCollapse", function(trigger) {
            var _this$props = _this.props, navigation = _this$props.navigation, createAnalyticsEvent = _this$props.createAnalyticsEvent;
            var newCollapsedState = !navigation.state.isCollapsed;
            navigation.toggleCollapse();
            (0, $8Z5er.navigationExpandedCollapsed)(createAnalyticsEvent, {
                trigger: trigger,
                isCollapsed: newCollapsedState
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleResizeStart", function(event) {
            var initialX = event.pageX;
            _this.setState({
                initialX: initialX,
                mouseIsDown: true
            }); // attach handlers (handleResizeStart is a bound to onMouseDown)
            window.addEventListener("mousemove", _this.handleResize);
            window.addEventListener("mouseup", _this.handleResizeEnd);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "initializeDrag", function(event) {
            var navigation = _this.props.navigation;
            var delta = event.pageX - _this.state.initialX;
            var isCollapsed = navigation.state.isCollapsed; // only initialize when drag intention is "expand"
            if (isCollapsed && delta <= 0) {
                _this.invalidDragAttempted = true;
                return;
            }
            var initialWidth = navigation.state.productNavWidth;
            var didDragOpen = false; // NOTE
            // if the product nav is collapsed and the consumer starts dragging it open
            // we must expand it and drag should start from 0.
            if (isCollapsed) {
                initialWidth = (0, $5SBZk.CONTENT_NAV_WIDTH_COLLAPSED);
                didDragOpen = true;
                navigation.manualResizeStart({
                    productNavWidth: (0, $5SBZk.CONTENT_NAV_WIDTH_COLLAPSED),
                    isCollapsed: false
                });
            } else navigation.manualResizeStart(navigation.state);
            _this.setState({
                didDragOpen: didDragOpen,
                initialWidth: initialWidth,
                isDragging: true
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleResize", (0, $eipj2.default)(function(event) {
            var mutationRefs = _this.props.mutationRefs;
            var _this$state = _this.state, initialX = _this$state.initialX, initialWidth = _this$state.initialWidth, isDragging = _this$state.isDragging, mouseIsDown = _this$state.mouseIsDown; // on occasion a mouse move event occurs before the event listeners
            // have a chance to detach
            if (!mouseIsDown) return; // initialize dragging
            if (!isDragging) {
                _this.initializeDrag(event);
                return;
            } // allow the product nav to be 75% of the available page width
            var maxWidth = Math.round(window.innerWidth / 4 * 3);
            var minWidth = (0, $5SBZk.CONTENT_NAV_WIDTH_COLLAPSED);
            var adjustedMax = maxWidth - initialWidth - (0, $5SBZk.GLOBAL_NAV_WIDTH);
            var adjustedMin = minWidth - initialWidth;
            var delta = Math.max(Math.min(event.pageX - initialX, adjustedMax), adjustedMin);
            var width = initialWidth + delta; // apply updated styles to the applicable DOM nodes
            $b9d6353a34999d11$var$updateResizeAreaPosition(mutationRefs, width); // NOTE: hijack the maual resize and force collapse, cancels mouse events
            if (event.clientX < 0) {
                _this.setState({
                    width: (0, $5SBZk.CONTENT_NAV_WIDTH_COLLAPSED)
                });
                _this.handleResizeEnd();
            } else // maintain internal width, applied to navigation state on resize end
            _this.setState({
                delta: delta,
                width: width
            });
        }));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleResizeEnd", function() {
            var _this$props2 = _this.props, navigation = _this$props2.navigation, createAnalyticsEvent = _this$props2.createAnalyticsEvent;
            var _this$state2 = _this.state, delta = _this$state2.delta, didDragOpen = _this$state2.didDragOpen, isDragging = _this$state2.isDragging, currentWidth = _this$state2.width;
            var expandThreshold = 24;
            var resizerClicked = !isDragging && !_this.invalidDragAttempted;
            var publishWidth = currentWidth;
            var shouldCollapse = false; // check if the intention was just a click, and toggle
            if (resizerClicked) {
                publishWidth = Math.max((0, $5SBZk.CONTENT_NAV_WIDTH), currentWidth);
                _this.toggleCollapse("resizerClick");
            } // prevent the user from creating an unusable width
            if (publishWidth < (0, $5SBZk.CONTENT_NAV_WIDTH)) {
                publishWidth = (0, $5SBZk.CONTENT_NAV_WIDTH);
                if (didDragOpen && delta > expandThreshold) shouldCollapse = false;
                else if (currentWidth < (0, $5SBZk.GLOBAL_NAV_COLLAPSE_THRESHOLD)) shouldCollapse = true;
            } else shouldCollapse = navigation.state.isCollapsed;
            if (!resizerClicked && (didDragOpen && !shouldCollapse || !didDragOpen && shouldCollapse)) (0, $8Z5er.navigationExpandedCollapsed)(createAnalyticsEvent, {
                trigger: "resizerDrag",
                isCollapsed: shouldCollapse
            });
             // reset everything
            _this.invalidDragAttempted = false;
            _this.setState({
                didDragOpen: false,
                isDragging: false,
                mouseIsDown: false,
                width: publishWidth
            }); // publish the new width, once resizing completes
            navigation.manualResizeEnd({
                productNavWidth: publishWidth,
                isCollapsed: shouldCollapse
            });
            if ($b9d6353a34999d11$var$shouldResetGrabArea(currentWidth)) $b9d6353a34999d11$var$updateResizeAreaPosition(_this.props.mutationRefs, (0, $5SBZk.CONTENT_NAV_WIDTH));
             // cleanup
            window.removeEventListener("mousemove", _this.handleResize);
            window.removeEventListener("mouseup", _this.handleResizeEnd);
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ResizeControl, [
        {
            key: "render",
            value: function render() {
                var _this$state3 = this.state, isDragging = _this$state3.isDragging, mouseIsDown = _this$state3.mouseIsDown, mouseIsOverGrabArea = _this$state3.mouseIsOverGrabArea, showGrabArea = _this$state3.showGrabArea;
                var _this$props3 = this.props, collapseToggleTooltipContent = _this$props3.collapseToggleTooltipContent, expandCollapseAffordanceRef = _this$props3.expandCollapseAffordanceRef, flyoutIsOpen = _this$props3.flyoutIsOpen, isResizeDisabled = _this$props3.isDisabled, isGrabAreaDisabled = _this$props3.isGrabAreaDisabled, onMouseOverButtonBuffer = _this$props3.onMouseOverButtonBuffer, navigation = _this$props3.navigation;
                var isCollapsed = navigation.state.isCollapsed; // the button shouldn't "flip" until the drag is complete
                var ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($8B1FA)));
                if (isCollapsed) ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($kavlx)));
                var button = (0, $45CBz.jsx)($b9d6353a34999d11$var$Button, {
                    onClick: this.onResizerChevronClick,
                    onMouseDown: $b9d6353a34999d11$var$preventDefault,
                    hitAreaSize: onMouseOverButtonBuffer ? "large" : "small" // maintain styles when user is dragging
                    ,
                    isVisible: isCollapsed || mouseIsDown,
                    hasHighlight: mouseIsDown || mouseIsOverGrabArea,
                    innerRef: expandCollapseAffordanceRef,
                    "aria-expanded": !isCollapsed,
                    "aria-label": "Toggle navigation"
                }, (0, $45CBz.jsx)(ButtonIcon, null));
                var shadowDirection = flyoutIsOpen ? "to right" : "to left";
                return (0, $45CBz.jsx)($b9d6353a34999d11$var$Outer, null, isDragging && (0, $45CBz.jsx)($b9d6353a34999d11$export$9c37550d5bbcae1, null), (0, $45CBz.jsx)((0, $ihtSr.Shadow), {
                    direction: shadowDirection,
                    isBold: mouseIsDown
                }), !isResizeDisabled && (0, $45CBz.jsx)((0, $9nHZC.Fragment), null, !isGrabAreaDisabled && showGrabArea && (0, $45CBz.jsx)($b9d6353a34999d11$export$a79cdb26132f421e, {
                    isBold: mouseIsDown,
                    showHandle: mouseIsDown || mouseIsOverGrabArea,
                    onMouseEnter: this.mouseEnterGrabArea,
                    onMouseLeave: this.mouseLeaveGrabArea,
                    onMouseDown: this.handleResizeStart
                }), (0, $45CBz.jsx)("div", {
                    onMouseOver: !flyoutIsOpen ? onMouseOverButtonBuffer : null
                }, collapseToggleTooltipContent ? (0, $45CBz.jsx)((0, $lMUjN.default), {
                    content: $b9d6353a34999d11$var$makeTooltipNode(collapseToggleTooltipContent(isCollapsed)),
                    delay: 600,
                    hideTooltipOnClick: true,
                    position: "right"
                }, button) : button)));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var EXPERIMENTAL_FLYOUT_ON_HOVER = props.experimental_flyoutOnHover, flyoutIsOpen = props.flyoutIsOpen, navigation = props.navigation;
                var isCollapsed = navigation.state.isCollapsed; // resolve "hover locking" issue with resize grab area
                if (EXPERIMENTAL_FLYOUT_ON_HOVER) {
                    var showGrabArea = !isCollapsed && !flyoutIsOpen;
                    var mouseIsOverGrabArea = showGrabArea ? state.mouseIsOverGrabArea : false;
                    return {
                        mouseIsOverGrabArea: mouseIsOverGrabArea,
                        showGrabArea: showGrabArea
                    };
                }
                return null;
            }
        }
    ]);
    return ResizeControl;
}((0, $9nHZC.PureComponent));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($b9d6353a34999d11$export$67d2000dcb6846eb, "defaultProps", {
    isGrabAreaDisabled: false
});
var $b9d6353a34999d11$export$2e2bcd8739ae039 = (0, $e9mJX.default)()($b9d6353a34999d11$export$67d2000dcb6846eb);

});
parcelRegister("8B1FA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $64231307cf52b120$var$_react = $64231307cf52b120$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $kupLT = parcelRequire("kupLT");
function $64231307cf52b120$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $64231307cf52b120$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $64231307cf52b120$var$_react.default.createElement($kupLT.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M13.706 9.698a.988.988 0 000-1.407 1.01 1.01 0 00-1.419 0l-2.965 2.94a1.09 1.09 0 000 1.548l2.955 2.93a1.01 1.01 0 001.42 0 .988.988 0 000-1.407l-2.318-2.297 2.327-2.307z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$64231307cf52b120$var$ChevronLeftIcon.displayName = "ChevronLeftIcon";
var $64231307cf52b120$var$_default = $64231307cf52b120$var$ChevronLeftIcon;
module.exports.default = $64231307cf52b120$var$_default;

});

parcelRegister("kavlx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eaed0e8fd081173c$var$_react = $eaed0e8fd081173c$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $kupLT = parcelRequire("kupLT");
function $eaed0e8fd081173c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $eaed0e8fd081173c$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $eaed0e8fd081173c$var$_react.default.createElement($kupLT.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M10.294 9.698a.988.988 0 010-1.407 1.01 1.01 0 011.419 0l2.965 2.94a1.09 1.09 0 010 1.548l-2.955 2.93a1.01 1.01 0 01-1.42 0 .988.988 0 010-1.407l2.318-2.297-2.327-2.307z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$eaed0e8fd081173c$var$ChevronRightIcon.displayName = "ChevronRightIcon";
var $eaed0e8fd081173c$var$_default = $eaed0e8fd081173c$var$ChevronRightIcon;
module.exports.default = $eaed0e8fd081173c$var$_default;

});

parcelRegister("lMUjN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdc9c453cc15f55a$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9q1kH = parcelRequire("9q1kH");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $caBkR = parcelRequire("caBkR");

var $5FAif = parcelRequire("5FAif");

var $8p2GL = parcelRequire("8p2GL");

var $ay1rd = parcelRequire("ay1rd");

var $JcvLo = parcelRequire("JcvLo");
var $gWA00 = parcelRequire("gWA00");

var $htChF = parcelRequire("htChF");

var $7Qjat = parcelRequire("7Qjat");

var $97YIy = parcelRequire("97YIy");

var $aP6k3 = parcelRequire("aP6k3");

var $6zCxP = parcelRequire("6zCxP");

var $1VQy8 = parcelRequire("1VQy8");

var $36cSd = parcelRequire("36cSd");

var $lQQPP = parcelRequire("lQQPP");
function $fdc9c453cc15f55a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fdc9c453cc15f55a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fdc9c453cc15f55a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fdc9c453cc15f55a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fdc9c453cc15f55a$var$tooltipZIndex = (0, $aP6k3.layers).tooltip();
var $fdc9c453cc15f55a$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "17.8.8"
};
// Inverts motion direction
var $fdc9c453cc15f55a$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param position - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $fdc9c453cc15f55a$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
function $fdc9c453cc15f55a$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $36cSd.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $8p2GL.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $8p2GL.default) : _ref$onHide, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy;
    var tooltipPosition = position === "mouse" ? mousePosition : position;
    var onShowHandler = (0, $5FAif.usePlatformLeafSyntheticEventHandler)($fdc9c453cc15f55a$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $fdc9c453cc15f55a$var$analyticsAttributes));
    var onHideHandler = (0, $5FAif.usePlatformLeafSyntheticEventHandler)($fdc9c453cc15f55a$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $fdc9c453cc15f55a$var$analyticsAttributes));
    var apiRef = (0, $9nHZC.useRef)(null);
    var _useState = (0, $9nHZC.useState)("hide"), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $9nHZC.useRef)(null);
    var containerRef = (0, $9nHZC.useRef)(null);
    var hasFunctionalChildren = typeof children === "function"; // Stored to keep our `setRef` callback cleaner.
    var setRef = (0, $9nHZC.useCallback)(function(node) {
        if (!node) return;
        if (hasFunctionalChildren) targetRef.current = node;
        else {
            containerRef.current = node;
            targetRef.current = node.firstChild;
        }
    }, [
        hasFunctionalChildren
    ]);
    // Putting a few things into refs so that we don't have to break memoization
    var lastState = (0, $9nHZC.useRef)(state);
    var lastDelay = (0, $9nHZC.useRef)(delay);
    var lastHandlers = (0, $9nHZC.useRef)({
        onShowHandler: onShowHandler,
        onHideHandler: onHideHandler
    });
    var hasCalledShowHandler = (0, $9nHZC.useRef)(false);
    (0, $9nHZC.useEffect)(function() {
        lastState.current = state;
        lastDelay.current = delay;
        lastHandlers.current = {
            onShowHandler: onShowHandler,
            onHideHandler: onHideHandler
        };
    }, [
        delay,
        onHideHandler,
        onShowHandler,
        state
    ]);
    var start = (0, $9nHZC.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $9nHZC.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, []);
    var abort = (0, $9nHZC.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
    }, []);
    (0, $9nHZC.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var showTooltip = (0, $9nHZC.useCallback)(function(source) {
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // Tell the tooltip to keep showing
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        var entry = {
            source: source,
            delay: lastDelay.current,
            show: function show(_ref2) {
                var isImmediate = _ref2.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    lastHandlers.current.onShowHandler();
                }
                setState(isImmediate ? "show-immediate" : "fade-in");
            },
            hide: function hide(_ref3) {
                var isImmediate = _ref3.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done
        };
        var api = (0, $6zCxP.show)(entry);
        start(api);
    }, [
        abort,
        done,
        start
    ]);
    var hideTooltipOnEsc = (0, $9nHZC.useCallback)(function() {
        var _apiRef$current;
        (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $ay1rd.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $9nHZC.useEffect)(function() {
        if (state === "hide") return 0, $8p2GL.default;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $caBkR.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $9nHZC.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $9nHZC.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $9nHZC.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === "mouse" ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            mouse: (0, $lQQPP.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: "keyboard"
        };
        showTooltip(source);
    }, [
        position,
        showTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $9nHZC.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === "mouse" ? function(event) {
        var _apiRef$current2;
        if ((_apiRef$current2 = apiRef.current) !== null && _apiRef$current2 !== void 0 && _apiRef$current2.isActive()) apiRef.current.mousePosition = (0, $lQQPP.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $9nHZC.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $9nHZC.useCallback)(function() {
        showTooltip({
            type: "keyboard"
        });
    }, [
        showTooltip
    ]);
    var onBlur = (0, $9nHZC.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $9nHZC.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && lastState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, []);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipContainer = state !== "hide" && Boolean(content);
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current3;
        if (position === "mouse" && (_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.mousePosition) {
            var _apiRef$current4;
            return (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 ? void 0 : _apiRef$current4.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipId = (0, $1VQy8.default)("tooltip", shouldRenderTooltipContainer);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        ref: setRef
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    (0, $9nHZC.useEffect)(function() {
        // If there is no container element, we should exit early, because that
        // means they are using the render prop API, and that is implemented in a
        // different way. If there is no target element yet or tooltipId, we also
        // shouldn't do anything because there is nothing to operate on or with.
        if (!containerRef.current || !targetRef.current || !tooltipId) return;
        // Necessary for TS to know that it has the attribute methods
        var target = targetRef.current;
        if (shouldRenderTooltipContainer) target.setAttribute("aria-describedby", tooltipId);
        else target.removeAttribute("aria-describedby");
    }, [
        shouldRenderTooltipContainer,
        tooltipId
    ]);
    return (0, $avKww.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, typeof children === "function" ? // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    children($fdc9c453cc15f55a$var$_objectSpread($fdc9c453cc15f55a$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipId
    })) : (0, $avKww.jsx)(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, tooltipTriggerProps, {
        role: "presentation"
    }), children), shouldRenderTooltipContainer ? (0, $avKww.jsx)((0, $97YIy.default), {
        zIndex: $fdc9c453cc15f55a$var$tooltipZIndex
    }, (0, $avKww.jsx)((0, $7Qjat.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref4) {
        var ref = _ref4.ref, style = _ref4.style, update = _ref4.update, placement = _ref4.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === "mouse" ? undefined : $fdc9c453cc15f55a$var$invertedDirection[$fdc9c453cc15f55a$var$getDirectionFromPlacement(placement)];
        return (0, $avKww.jsx)((0, $JcvLo.default), {
            appear: true
        }, shouldRenderTooltipChildren && (0, $avKww.jsx)((0, $gWA00.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state === "show-immediate" ? 0 : (0, $htChF.mediumDurationMs)
        }, function(_ref5) {
            var className = _ref5.className;
            return (0, $avKww.jsx)(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: style,
                truncate: truncate,
                placement: tooltipPosition,
                testId: testId,
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                id: tooltipId
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$fdc9c453cc15f55a$var$Tooltip.displayName = "Tooltip";
var $fdc9c453cc15f55a$export$2e2bcd8739ae039 = $fdc9c453cc15f55a$var$Tooltip;

});
parcelRegister("caBkR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $4A2Nq = parcelRequire("4A2Nq");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $4A2Nq.bind;
    }
});

var $8yGiE = parcelRequire("8yGiE");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $8yGiE.bindAll;
    }
});

});
parcelRegister("4A2Nq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $355cb17f72abe562$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $355cb17f72abe562$var$bind;

});

parcelRegister("8yGiE", function(module, exports) {
"use strict";
var $63b24f9439d32b43$var$__assign = module.exports && module.exports.__assign || function() {
    $63b24f9439d32b43$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $63b24f9439d32b43$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $4A2Nq = parcelRequire("4A2Nq");
function $63b24f9439d32b43$var$toOptions(value) {
    if (typeof value === "undefined") return undefined;
    if (typeof value === "boolean") return {
        capture: value
    };
    return value;
}
function $63b24f9439d32b43$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $63b24f9439d32b43$var$__assign($63b24f9439d32b43$var$__assign({}, original), {
        options: $63b24f9439d32b43$var$__assign($63b24f9439d32b43$var$__assign({}, $63b24f9439d32b43$var$toOptions(sharedOptions)), $63b24f9439d32b43$var$toOptions(original.options))
    });
    return binding;
}
function $63b24f9439d32b43$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $63b24f9439d32b43$var$getBinding(original, sharedOptions);
        return (0, $4A2Nq.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $63b24f9439d32b43$var$bindAll;

});


parcelRegister("5FAif", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $420cef2d905cfb1d$export$1a04351537078b55; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $crEFk = parcelRequire("crEFk");

var $3uOfq = parcelRequire("3uOfq");
function $420cef2d905cfb1d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $420cef2d905cfb1d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $420cef2d905cfb1d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $420cef2d905cfb1d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $420cef2d905cfb1d$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $crEFk.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $3uOfq.useTrackedRef)(analyticsData);
    var fnRef = (0, $3uOfq.useTrackedRef)(fn);
    var handler = (0, $9nHZC.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $420cef2d905cfb1d$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("crEFk", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $90f78d025e1b0cc0$export$5bf35293e545f20c; });

var $dNznA = parcelRequire("dNznA");

var $g0V7I = parcelRequire("g0V7I");

var $fQSGL = parcelRequire("fQSGL");
function $90f78d025e1b0cc0$export$5bf35293e545f20c() {
    var analyticsContext = (0, $fQSGL.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $g0V7I.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("g0V7I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba88f4fa2ae647b3$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $kQwXB = parcelRequire("kQwXB");
function $ba88f4fa2ae647b3$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ba88f4fa2ae647b3$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $ba88f4fa2ae647b3$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ba88f4fa2ae647b3$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ba88f4fa2ae647b3$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $ba88f4fa2ae647b3$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $ba88f4fa2ae647b3$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $ba88f4fa2ae647b3$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $kQwXB.default));

});
parcelRegister("kQwXB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2d23b3475a1344a$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
function $f2d23b3475a1344a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f2d23b3475a1344a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f2d23b3475a1344a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f2d23b3475a1344a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f2d23b3475a1344a$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $f2d23b3475a1344a$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $f2d23b3475a1344a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $f2d23b3475a1344a$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(updater) === "object") this.payload = $f2d23b3475a1344a$var$_objectSpread($f2d23b3475a1344a$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("fQSGL", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $b8a622634b441489$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $b8a622634b441489$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});


parcelRegister("3uOfq", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $28bb269cfe78e33e$export$1d27a74659855e44; });

var $9nHZC = parcelRequire("9nHZC");
var $28bb269cfe78e33e$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("7Qjat", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $5b5c4219fc407a1e$export$badac9ada3a0bdf9; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $cjxQA = parcelRequire("cjxQA");

// Export types from PopperJS / React Popper
var $5b5c4219fc407a1e$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: 5,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    },
    {
        name: "preventOverflow",
        options: {
            padding: 5,
            rootBoundary: "document"
        }
    }
];
function $5b5c4219fc407a1e$var$defaultChildrenFn() {
    return null;
}
var $5b5c4219fc407a1e$var$defaultOffset = [
    0,
    8
];
function $5b5c4219fc407a1e$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $5b5c4219fc407a1e$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $5b5c4219fc407a1e$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    // Merge a new offset modifier only if new offset values passed in
    var internalModifiers = (0, $9nHZC.useMemo)(function() {
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        return [].concat($5b5c4219fc407a1e$var$constantModifiers, [
            offsetModifier
        ]);
    }, [
        offsetX,
        offsetY
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $9nHZC.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $cjxQA.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});

parcelRegister("6zCxP", function(module, exports) {

$parcel$export(module.exports, "show", function () { return $4c93e91920e7de82$export$57bf213be019eeb0; });

var $3j6Un = parcelRequire("3j6Un");
// This file is a singleton for managing tooltips
var $4c93e91920e7de82$var$active = null;
function $4c93e91920e7de82$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($4c93e91920e7de82$var$active && $4c93e91920e7de82$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $3j6Un.clearScheduled)();
            $4c93e91920e7de82$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $3j6Un.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $3j6Un.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $3j6Un.scheduleTimeout)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($4c93e91920e7de82$var$active && $4c93e91920e7de82$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($4c93e91920e7de82$var$active) {
            (0, $3j6Un.clearScheduled)();
            $4c93e91920e7de82$var$active.entry.hide({
                isImmediate: true
            });
            $4c93e91920e7de82$var$active.entry.done();
            $4c93e91920e7de82$var$active = null;
        }
        // this tooltip is now the active tooltip
        $4c93e91920e7de82$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $3j6Un.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("3j6Un", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", function () { return $2688814ae73771cf$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $2688814ae73771cf$export$5f4d6617421d489b; });
var $2688814ae73771cf$var$delayId = null;
function $2688814ae73771cf$export$eaf678f6f93f5250() {
    if ($2688814ae73771cf$var$delayId != null) {
        window.clearTimeout($2688814ae73771cf$var$delayId);
        $2688814ae73771cf$var$delayId = null;
    }
}
function $2688814ae73771cf$export$5f4d6617421d489b(fn, delay) {
    $2688814ae73771cf$export$eaf678f6f93f5250();
    $2688814ae73771cf$var$delayId = window.setTimeout(function() {
        $2688814ae73771cf$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("1VQy8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1683e091f3416efe$export$2e2bcd8739ae039; });

var $9SZaS = parcelRequire("9SZaS");
function $1683e091f3416efe$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $9SZaS.useUIDSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});

parcelRegister("36cSd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $241beb051b928d94$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $jp7ng = parcelRequire("jp7ng");

var $5LVXk = parcelRequire("5LVXk");

var $3R92G = parcelRequire("3R92G");
var $241beb051b928d94$var$baseStyles = (0, $avKww.css)({
    boxSizing: "border-box",
    maxWidth: "240px",
    padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-075, 6px)"),
    insetBlockStart: "var(--ds-space-0, 0px)",
    insetInlineStart: "var(--ds-space-0, 0px)",
    borderRadius: "var(--ds-border-radius, 3px)",
    fontSize: "var(--ds-font-size-075, 12px)",
    lineHeight: 1.3,
    overflowWrap: "break-word",
    wordWrap: "break-word"
});
var $241beb051b928d94$var$truncateStyles = (0, $avKww.css)({
    maxWidth: "420px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $241beb051b928d94$var$lightStyles = (0, $avKww.css)({
    backgroundColor: "var(--ds-background-neutral-bold, ".concat((0, $jp7ng.N800), ")"),
    color: "var(--ds-text-inverse, ".concat((0, $jp7ng.N0), ")")
});
var $241beb051b928d94$var$darkStyles = (0, $avKww.css)({
    backgroundColor: "var(--ds-background-neutral-bold, ".concat((0, $jp7ng.DN0), ")"),
    color: "var(--ds-text-inverse, ".concat((0, $jp7ng.DN600), ")")
});
var $241beb051b928d94$var$TooltipContainer = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return (0, $avKww.jsx)((0, $5LVXk.default).Consumer, null, function(_ref2) {
        var mode = _ref2.mode;
        return (0, $avKww.jsx)((0, $3R92G.default), {
            ref: ref,
            style: style,
            className: className,
            placement: placement,
            testId: testId,
            id: id,
            onMouseOut: onMouseOut,
            onMouseOver: onMouseOver,
            css: [
                $241beb051b928d94$var$baseStyles,
                truncate ? $241beb051b928d94$var$truncateStyles : null,
                mode === "light" ? $241beb051b928d94$var$lightStyles : $241beb051b928d94$var$darkStyles
            ]
        }, children);
    });
});
$241beb051b928d94$var$TooltipContainer.displayName = "TooltipContainer";
var $241beb051b928d94$export$2e2bcd8739ae039 = $241beb051b928d94$var$TooltipContainer;

});
parcelRegister("3R92G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ced55f5df78c15c$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $aP6k3 = parcelRequire("aP6k3");
function $2ced55f5df78c15c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2ced55f5df78c15c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2ced55f5df78c15c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2ced55f5df78c15c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2ced55f5df78c15c$var$VAR_PRIMITIVE_ZINDEX = "tooltipPrimitiveZindex";
var $2ced55f5df78c15c$var$primitiveStyles = (0, $avKww.css)({
    zindex: "var(".concat($2ced55f5df78c15c$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
var $2ced55f5df78c15c$var$TooltipPrimitive = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $2ced55f5df78c15c$var$_objectSpread($2ced55f5df78c15c$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, $2ced55f5df78c15c$var$VAR_PRIMITIVE_ZINDEX, (0, $aP6k3.layers).tooltip()));
    return (0, $avKww.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $avKww.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $2ced55f5df78c15c$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$2ced55f5df78c15c$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $2ced55f5df78c15c$export$2e2bcd8739ae039 = $2ced55f5df78c15c$var$TooltipPrimitive;

});


parcelRegister("lQQPP", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", function () { return $fe87703dc16bd129$export$642213d516a9b928; });
function $fe87703dc16bd129$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});



parcelRegister("7c3Cv", function(module, exports) {

$parcel$export(module.exports, "pageContainerCSS", function () { return $53cc76487ccbc456$export$514fb841572181c; });

var $kFnE9 = parcelRequire("kFnE9");

var $6mrep = parcelRequire("6mrep");
function $53cc76487ccbc456$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $53cc76487ccbc456$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $53cc76487ccbc456$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $53cc76487ccbc456$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $53cc76487ccbc456$export$514fb841572181c = function pageContainerCSS(_ref) {
    var disableInteraction = _ref.disableInteraction, leftOffset = _ref.leftOffset, topOffset = _ref.topOffset;
    return $53cc76487ccbc456$var$_objectSpread({
        flex: "1 1 auto",
        marginLeft: leftOffset,
        marginTop: topOffset,
        width: 0
    }, (0, $6mrep.applyDisabledProperties)(!!disableInteraction));
};

});



parcelRegister("6Z1Zq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5159fbb977cddaaf$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $i5sFT = parcelRequire("i5sFT");

var $5SBZk = parcelRequire("5SBZk");

var $68WhI = parcelRequire("68WhI");

var $liApt = parcelRequire("liApt");

var $45CBz = parcelRequire("45CBz");
function $5159fbb977cddaaf$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5159fbb977cddaaf$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $5159fbb977cddaaf$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $5159fbb977cddaaf$var$LS_KEY = "ATLASKIT_NAVIGATION_UI_STATE";
var $5159fbb977cddaaf$var$DEFAULT_UI_STATE = {
    isCollapsed: false,
    productNavWidth: (0, $5SBZk.CONTENT_NAV_WIDTH),
    isResizeDisabled: false
};
function $5159fbb977cddaaf$var$defaultGetCache() {
    try {
        var stored = localStorage.getItem($5159fbb977cddaaf$var$LS_KEY);
        return stored ? JSON.parse(stored) : $5159fbb977cddaaf$var$DEFAULT_UI_STATE;
    } catch (_unused) {}
    return $5159fbb977cddaaf$var$DEFAULT_UI_STATE;
}
function $5159fbb977cddaaf$var$defaultSetCache(state) {
    try {
        localStorage.setItem($5159fbb977cddaaf$var$LS_KEY, JSON.stringify(state));
    } catch (_unused2) {}
}
var $5159fbb977cddaaf$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(NavigationProvider, _Component);
    var _super = $5159fbb977cddaaf$var$_createSuper(NavigationProvider);
    function NavigationProvider(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, NavigationProvider);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "uiState", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "viewController", void 0);
        var cache = props.cache, initialUIController = props.initialUIController, isDebugEnabled = props.isDebugEnabled;
        _this.uiState = new (0, $68WhI.default)(initialUIController, cache);
        _this.viewController = new (0, $liApt.default)({
            isDebugEnabled: isDebugEnabled
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(NavigationProvider, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var viewController = this.viewController;
                var isDebugEnabled = this.props.isDebugEnabled;
                if (isDebugEnabled !== prevProps.isDebugEnabled) viewController.setIsDebugEnabled(!!isDebugEnabled);
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                var uiState = this.uiState, viewController = this.viewController;
                return (0, $45CBz.jsx)((0, $i5sFT.Provider), {
                    inject: [
                        uiState,
                        viewController
                    ]
                }, children);
            }
        }
    ]);
    return NavigationProvider;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($5159fbb977cddaaf$export$2e2bcd8739ae039, "defaultProps", {
    cache: {
        get: $5159fbb977cddaaf$var$defaultGetCache,
        set: $5159fbb977cddaaf$var$defaultSetCache
    },
    isDebugEnabled: false
});

});

parcelRegister("bnZ0o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e37b07037bdc9ccf$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $inFLm = parcelRequire("inFLm");

var $lLrRh = parcelRequire("lLrRh");

var $22TpA = parcelRequire("22TpA");

var $iYbfy = parcelRequire("iYbfy");
class $e37b07037bdc9ccf$var$DrawerHeader extends (0, $9nHZC.PureComponent) {
    render() {
        const { isGlobalContext: isGlobalContext, isPrivate: isPrivate, href: href, name: name, logo: logo, linkComponent: linkComponent } = this.props;
        if (isGlobalContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($iYbfy.BitbucketLogoWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $22TpA.BitbucketWordmark), null));
        const avatarIcon = logo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $inFLm.default), {
            size: "large",
            appearance: "square",
            src: logo,
            name: name,
            status: isPrivate ? "locked" : undefined
        }) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($iYbfy.DrawerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $lLrRh.default), {
            href: href,
            linkComponent: linkComponent,
            elemBefore: avatarIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($iYbfy.HeaderNameWrapper, null, name)));
    }
}
var $e37b07037bdc9ccf$export$2e2bcd8739ae039 = $e37b07037bdc9ccf$var$DrawerHeader;

});
parcelRegister("iYbfy", function(module, exports) {

$parcel$export(module.exports, "DrawerWrapper", function () { return $c2d916aaea155463$export$75f51cf067955710; });
$parcel$export(module.exports, "BitbucketLogoWrapper", function () { return $c2d916aaea155463$export$d7e2a5857541a427; });
$parcel$export(module.exports, "HeaderNameWrapper", function () { return $c2d916aaea155463$export$c8088ee28c67d485; });

var $2xJU3 = parcelRequire("2xJU3");

var $aP6k3 = parcelRequire("aP6k3");
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */ function $c2d916aaea155463$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c2d916aaea155463$export$75f51cf067955710 = (0, $2xJU3.default)("div", {
    target: "e1pq0l0x0"
})("margin-right:", (0, $aP6k3.gridSize)(), "px;margin-bottom:", (0, $aP6k3.gridSize)(), "px;");
const $c2d916aaea155463$export$d7e2a5857541a427 = (0, $2xJU3.default)("div", {
    target: "e1pq0l0x1"
})("padding-left:", (0, $aP6k3.gridSize)(), "px;padding-top:", (0, $aP6k3.gridSize)() / 2, "px;");
const $c2d916aaea155463$export$c8088ee28c67d485 = (0, $2xJU3.default)("div", {
    target: "e1pq0l0x2"
})({
    name: "35ezg3",
    styles: "font-weight:600;"
});

});


parcelRegister("1al9v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb5f8490d991efe5$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $eb5f8490d991efe5$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    resizerButtonLabel: {
        "id": "bitkit.navigation.resizerButton.label",
        "defaultMessage": "Expand or collapse the navigation (left bracket)"
    }
});

});

parcelRegister("jjXrn", function(module, exports) {

$parcel$export(module.exports, "settings", function () { return $10e9ce686c613348$export$a5a6e0b888b2c992; });
$parcel$export(module.exports, "dark", function () { return (parcelRequire("3YYFd")).dark; });
$parcel$export(module.exports, "light", function () { return (parcelRequire("3YYFd")).light; });
$parcel$export(module.exports, "siteSettings", function () { return (parcelRequire("3YYFd")).settings; });
// @ts-ignore TODO: fix noImplicitAny error here
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $3YYFd = parcelRequire("3YYFd");
var $hh6qM = parcelRequire("hh6qM");

var $jp7ng = parcelRequire("jp7ng");
const $10e9ce686c613348$export$a5a6e0b888b2c992 = (0, $hh6qM.default)({
    product: {
        text: (0, $jp7ng).N900,
        background: (0, $jp7ng).N20
    }
});
const $10e9ce686c613348$export$aadf5172123aea58 = (0, $hh6qM.default)({
    product: {
        text: (0, $jp7ng).N500,
        background: (0, $jp7ng).N0
    }
});

});

parcelRegister("4c2RV", function(module, exports) {


























module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("chFsr")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3Sey2")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fFNJN")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jvY8h")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c3BIL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5M5fs")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvz8")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("1y6Fu")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("oRkrx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("e0Fn7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("dHQda")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3XkvO"))
]).then(()=>parcelRequire("kKic7"));

});

parcelRegister("cdMcU", function(module, exports) {


































module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("gBGtw")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5B0yY")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("bUF79")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fnf31")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("chFsr")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3Sey2")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fFNJN")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jvY8h")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c3BIL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5M5fs")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvz8")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("1y6Fu")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("oRkrx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("e0Fn7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("dHQda")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("I0pYx"))
]).then(()=>parcelRequire("jpHL3"));

});


parcelRegister("hUwc6", function(module, exports) {
const $531b78516e4eb60c$var$slugPattern = /^([^\s]+)\/(.*)$/;
function $531b78516e4eb60c$var$getPredicate(input) {
    const query = input.toLowerCase();
    const match = $531b78516e4eb60c$var$slugPattern.exec(query);
    if (match) {
        // When the query contains a slash, we allow for some more precise
        // filtering where the part before the slash matches only on the owner and
        // the part after it on the slug. The name can also include a slash so
        // match the full query on it too.
        const owner = match[1];
        const repo = match[2];
        return (r)=>r.owner.indexOf(owner) !== -1 && r.slug.indexOf(repo) !== -1 || r.name.toLowerCase().indexOf(query) !== -1;
    } else {
        // Filter on any property of the repo. All the parts of the query need
        // to match in at least one of the properties. This allows for some
        // fuzziness when it comes to the order of words.
        const parts = query.split(/[/\s]+/).filter((s)=>!!s.length);
        return (r)=>parts.every((s)=>r.owner.indexOf(s) !== -1 || r.slug.indexOf(s) !== -1 || r.name.toLowerCase().indexOf(s) !== -1);
    }
}
function $531b78516e4eb60c$export$2db131caf18cabab(repositories, query, limit) {
    const predicate = $531b78516e4eb60c$var$getPredicate(query);
    const results = [];
    for (const r of repositories)if (predicate(r)) {
        results.push(r);
        if (results.length === limit) break;
    }
    return results;
}

});

parcelRegister("6bF5s", function(module, exports) {

$parcel$export(module.exports, "Product", function () { return $1439b64b5aa59ef5$export$264ad599d7cef668; });
$parcel$export(module.exports, "isChildrenMenuItems", function () { return $1439b64b5aa59ef5$export$17a75cce14ba2657; });
var $1439b64b5aa59ef5$export$264ad599d7cef668;
(function(Product) {
    Product["Bitbucket"] = "bitbucket.ondemand";
    Product["Confluence"] = "confluence.ondemand";
    Product["JiraSoftware"] = "jira-software.ondemand";
    Product["JiraServiceDesk"] = "jira-servicedesk.ondemand";
    Product["Opsgenie"] = "opsgenie";
})($1439b64b5aa59ef5$export$264ad599d7cef668 || ($1439b64b5aa59ef5$export$264ad599d7cef668 = {}));
var $1439b64b5aa59ef5$export$3e55b84f6ff4241d;
(function(ApiResponseStatusCode) {
    ApiResponseStatusCode[ApiResponseStatusCode["Success"] = 200] = "Success";
    ApiResponseStatusCode[ApiResponseStatusCode["BadRequest"] = 400] = "BadRequest";
    ApiResponseStatusCode[ApiResponseStatusCode["Unauthorized"] = 401] = "Unauthorized";
})($1439b64b5aa59ef5$export$3e55b84f6ff4241d || ($1439b64b5aa59ef5$export$3e55b84f6ff4241d = {}));
const $1439b64b5aa59ef5$export$17a75cce14ba2657 = (menuItems)=>{
    var _;
    return ((_ = menuItems[0]) === null || _ === void 0 ? void 0 : _.type) === "menu_item";
};
const $1439b64b5aa59ef5$export$713a9b0a74eb8d8b = "JIRA_SOFTWARE";

});

parcelRegister("gNc1c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4822c5013d876f8$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");
const $e4822c5013d876f8$var$ReposContext = (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createContext({
    repositories: [],
    loadRepositories: (_includeStatus)=>Promise.resolve([])
});
$e4822c5013d876f8$var$ReposContext.displayName = "ReposContext";
var $e4822c5013d876f8$export$2e2bcd8739ae039 = $e4822c5013d876f8$var$ReposContext;

});




parcelRegister("aEOf6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22f3f7553f107749$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("4tAgz");
var $gRBmM = parcelRequire("gRBmM");

var $dqY9c = parcelRequire("dqY9c");

var $kZnTB = parcelRequire("kZnTB");

var $dxJTk = parcelRequire("dxJTk");
const $22f3f7553f107749$var$ConnectIframeHeader = (props)=>{
    const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug } = (0, $dqY9c.useParams)();
    const settingsHref = (0, $kZnTB.default).ui.admin(repositoryOwner || "", repositorySlug || "");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $gRBmM.FocusedPageHeader), {
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dxJTk.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            settingsHref: settingsHref
        }, props))
    });
};
var $22f3f7553f107749$export$2e2bcd8739ae039 = $22f3f7553f107749$var$ConnectIframeHeader;

});
parcelRegister("dxJTk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8dbd2d6def44e848$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $1ONvK = parcelRequire("1ONvK");

var $aurzp = parcelRequire("aurzp");

var $f9pRZ = parcelRequire("f9pRZ");

var $dULUA = parcelRequire("dULUA");

var $jDLzd = parcelRequire("jDLzd");

var $4MsY5 = parcelRequire("4MsY5");
const $8dbd2d6def44e848$var$RepoAdminBreadcrumbs = ({ intl: intl, settingsHref: settingsHref })=>{
    const text = intl.formatMessage((0, $jDLzd.default).admin);
    const { publishBreadcrumbClickEvent: publishBreadcrumbClickEvent } = (0, $f9pRZ.useAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dULUA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $4MsY5.BreadcrumbItemStyled), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $1ONvK.default), {
        href: settingsHref,
        text: text,
        component: (0, $aurzp.ComponentLink),
        onClick: ()=>publishBreadcrumbClickEvent("SettingsLink")
    })));
};
var $8dbd2d6def44e848$export$2e2bcd8739ae039 = (0, $agjvf.injectIntl)($8dbd2d6def44e848$var$RepoAdminBreadcrumbs);

});
parcelRegister("1ONvK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1530ddd0c193318d$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");
parcelRequire("872DM");
var $6RZ88 = parcelRequire("6RZ88");
var $8Dwfz = parcelRequire("8Dwfz");

var $dEQSq = parcelRequire("dEQSq");

var $aP6k3 = parcelRequire("aP6k3");

var $anIL3 = parcelRequire("anIL3");

var $1FKpu = parcelRequire("1FKpu");

var $5JKJ4 = parcelRequire("5JKJ4");
var $1530ddd0c193318d$var$_excluded = [
    "truncationWidth",
    "text",
    "onTooltipShown"
];
function $1530ddd0c193318d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1530ddd0c193318d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1530ddd0c193318d$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1530ddd0c193318d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $1530ddd0c193318d$var$gridSizeUnit = (0, $aP6k3.gridSize)();
var $1530ddd0c193318d$var$height = (0, $aP6k3.gridSize)() * 3 / (0, $aP6k3.fontSize)();

var $1530ddd0c193318d$var$AKTooltip = (0, $6RZ88.lazyForPaint)(function() {
    return (parcelRequire("QO3gA"));
}, {
    ssr: false
});
var $1530ddd0c193318d$var$itemWrapperStyles = (0, $avKww.css)({
    display: "flex",
    boxSizing: "border-box",
    maxWidth: "100%",
    height: "".concat($1530ddd0c193318d$var$height, "em"),
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    flexDirection: "row",
    lineHeight: "".concat($1530ddd0c193318d$var$height, "em"),
    "&:not(:last-child)::after": {
        width: $1530ddd0c193318d$var$gridSizeUnit,
        padding: "var(--ds-space-0, 0px)".concat(" ", "var(--ds-space-100, 8px)"),
        flexShrink: 0,
        content: '"/"',
        textAlign: "center"
    }
});
var $1530ddd0c193318d$var$VAR_STEP_TRUNCATION_WIDTH = "--max-width";
var $1530ddd0c193318d$var$staticItemWithTruncationStyles = (0, $avKww.css)({
    maxWidth: "var(".concat($1530ddd0c193318d$var$VAR_STEP_TRUNCATION_WIDTH, ")"),
    fontWeight: "var(--ds-font-weight-regular, 400)"
});
var $1530ddd0c193318d$var$staticItemWithoutTruncationStyles = (0, $avKww.css)({
    minWidth: 0,
    flexShrink: 1,
    fontWeight: "var(--ds-font-weight-regular, 400)"
});
var $1530ddd0c193318d$var$BreadcrumbsItem = /*#__PURE__*/ (0, $9nHZC.memo)(function(props) {
    var buttonRef = (0, $9nHZC.useRef)(null);
    var truncationWidth = props.truncationWidth, text = props.text, onTooltipShown = props.onTooltipShown, restButtonProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(props, $1530ddd0c193318d$var$_excluded);
    var showTooltip = (0, $5JKJ4.default)(truncationWidth, buttonRef);
    var buttonProps = $1530ddd0c193318d$var$_objectSpread($1530ddd0c193318d$var$_objectSpread({}, restButtonProps), {}, {
        ref: buttonRef,
        hasOverflow: showTooltip
    });
    // Note: cast to `any` is required to type verification - see https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
    var dynamicItemStyles = (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, $1530ddd0c193318d$var$VAR_STEP_TRUNCATION_WIDTH, "".concat(truncationWidth, "px"));
    var step = (0, $avKww.jsx)((0, $1FKpu.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, buttonProps, {
        css: truncationWidth ? $1530ddd0c193318d$var$staticItemWithTruncationStyles : $1530ddd0c193318d$var$staticItemWithoutTruncationStyles,
        style: dynamicItemStyles
    }), text);
    if ((0, $dEQSq.getBooleanFF)("platform.design-system-team.remove-lazy-loading-of-tooltip-in-breadcrumbs_pki8p")) return (0, $avKww.jsx)("li", {
        css: $1530ddd0c193318d$var$itemWrapperStyles
    }, showTooltip ? (0, $avKww.jsx)((0, $anIL3.default), {
        content: text,
        position: "bottom",
        onShow: onTooltipShown
    }, step) : step);
    return (0, $avKww.jsx)("li", {
        css: $1530ddd0c193318d$var$itemWrapperStyles
    }, showTooltip ? /* The div exists because of tooltip */ (0, $avKww.jsx)((0, $8Dwfz.LazySuspense), {
        fallback: (0, $avKww.jsx)("div", null, step)
    }, (0, $avKww.jsx)($1530ddd0c193318d$var$AKTooltip, {
        content: text,
        position: "bottom",
        onShow: onTooltipShown
    }, step)) : step);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1530ddd0c193318d$export$2e2bcd8739ae039 = $1530ddd0c193318d$var$BreadcrumbsItem;

});
parcelRegister("872DM", function(module, exports) {

$parcel$export(module.exports, "lazyForPaint", function () { return (parcelRequire("6RZ88")).lazyForPaint; });
$parcel$export(module.exports, "LazySuspense", function () { return (parcelRequire("8Dwfz")).LazySuspense; });
parcelRequire("9AIUR");
var $esLgZ = parcelRequire("esLgZ");

var $024Qj = parcelRequire("024Qj");

var $6RZ88 = parcelRequire("6RZ88");
parcelRequire("9Q5rS");
var $jbNq7 = parcelRequire("jbNq7");
parcelRequire("eZ9Lc");
var $8Dwfz = parcelRequire("8Dwfz");

var $9I8Ai = parcelRequire("9I8Ai");

var $c9GqP = parcelRequire("c9GqP");

});
parcelRegister("9AIUR", function(module, exports) {

$parcel$export(module.exports, "getConfig", function () { return $6fba513a27a07c2c$export$44487a86467333c3; });
$parcel$export(module.exports, "setConfig", function () { return $6fba513a27a07c2c$export$940a7873bb071df8; });
$parcel$export(module.exports, "MODE", function () { return (parcelRequire("esLgZ")).MODE; });

var $esLgZ = parcelRequire("esLgZ");
const $6fba513a27a07c2c$var$DEFAULT_CROSS_ORIGIN = undefined;
const $6fba513a27a07c2c$var$DEFAULT_MANIFEST = {
    publicPath: "/",
    assets: {}
};
const $6fba513a27a07c2c$var$DEFAULT_MODE = (0, $esLgZ.MODE).HYDRATE;
const $6fba513a27a07c2c$var$DEFAULT_RETRY = 2;
const $6fba513a27a07c2c$var$config = {
    crossOrigin: $6fba513a27a07c2c$var$DEFAULT_CROSS_ORIGIN,
    manifest: $6fba513a27a07c2c$var$DEFAULT_MANIFEST,
    mode: $6fba513a27a07c2c$var$DEFAULT_MODE,
    retry: $6fba513a27a07c2c$var$DEFAULT_RETRY
};
const $6fba513a27a07c2c$export$44487a86467333c3 = ()=>$6fba513a27a07c2c$var$config;
const $6fba513a27a07c2c$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $6fba513a27a07c2c$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $6fba513a27a07c2c$var$DEFAULT_CROSS_ORIGIN;
    $6fba513a27a07c2c$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $6fba513a27a07c2c$var$DEFAULT_MANIFEST;
    $6fba513a27a07c2c$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $6fba513a27a07c2c$var$DEFAULT_MODE;
    $6fba513a27a07c2c$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $6fba513a27a07c2c$var$DEFAULT_RETRY;
};

});
parcelRegister("esLgZ", function(module, exports) {

$parcel$export(module.exports, "MODE", function () { return $a87859a429ef34ab$export$e48589d9e4824227; });
const $a87859a429ef34ab$export$e48589d9e4824227 = {
    RENDER: "RENDER",
    HYDRATE: "HYDRATE"
};

});


parcelRegister("024Qj", function(module, exports) {

var $hrRFO = parcelRequire("hrRFO");

var $9AIUR = parcelRequire("9AIUR");
parcelRequire("9I8Ai");
var $bL8WZ = parcelRequire("bL8WZ");
var $9QEkY = parcelRequire("9QEkY");

var $4LspV = parcelRequire("4LspV");
const $0063f1b430dc37b7$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $9AIUR.setConfig)(config);
        (0, $bL8WZ.LISTENERS).length = 0;
        (0, $9QEkY.setCurrent)(0);
        if (!(0, $4LspV.isNodeEnvironment)()) (0, $hrRFO.collect)();
    }
};

});
parcelRegister("hrRFO", function(module, exports) {

$parcel$export(module.exports, "collect", function () { return $cb3e97b34edca11a$export$bb44f104e3c54dae; });

var $9AIUR = parcelRequire("9AIUR");
var $esLgZ = parcelRequire("esLgZ");

var $cN2RV = parcelRequire("cN2RV");

var $gThvl = parcelRequire("gThvl");

var $3nhJg = parcelRequire("3nhJg");
const $cb3e97b34edca11a$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll("input[data-lazy-begin]");
    const { mode: mode } = (0, $9AIUR.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $esLgZ.MODE).RENDER ? (0, $gThvl.cloneElements)(markers[i], lazyBegin) : (0, $3nhJg.refElements)(markers[i], lazyBegin);
        if ((0, $cN2RV.COLLECTED).has(lazyBegin)) (0, $cN2RV.COLLECTED).get(lazyBegin).push(value);
        else (0, $cN2RV.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};

});
parcelRegister("cN2RV", function(module, exports) {

$parcel$export(module.exports, "PHASE", function () { return $94fc49500c4b4dfe$export$2cc7a2eaaea7809f; });
$parcel$export(module.exports, "COLLECTED", function () { return $94fc49500c4b4dfe$export$4831ef3968ea94ef; });
const $94fc49500c4b4dfe$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $94fc49500c4b4dfe$export$4831ef3968ea94ef = new Map();

});

parcelRegister("gThvl", function(module, exports) {

$parcel$export(module.exports, "cloneElements", function () { return $c4bf5c7396c81969$export$c42217d53a7ebafb; });
const $c4bf5c7396c81969$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement("div");
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break; // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};

});

parcelRegister("3nhJg", function(module, exports) {

$parcel$export(module.exports, "refElements", function () { return $275145b45c04eaa0$export$c69443129766a7fc; });
const $275145b45c04eaa0$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};

});


parcelRegister("9I8Ai", function(module, exports) {

$parcel$export(module.exports, "LazyPhaseContext", function () { return (parcelRequire("9QEkY")).LazyPhaseContext; });
$parcel$export(module.exports, "setCurrent", function () { return (parcelRequire("9QEkY")).setCurrent; });
$parcel$export(module.exports, "LISTENERS", function () { return (parcelRequire("bL8WZ")).LISTENERS; });

var $9QEkY = parcelRequire("9QEkY");

var $bL8WZ = parcelRequire("bL8WZ");

var $hKdwt = parcelRequire("hKdwt");

});
parcelRegister("9QEkY", function(module, exports) {

$parcel$export(module.exports, "setCurrent", function () { return $72b8428b51178863$export$5f80f094fd31fffd; });
$parcel$export(module.exports, "LazyPhaseContext", function () { return $72b8428b51178863$export$5a25eca35e5debcb; });

var $9nHZC = parcelRequire("9nHZC");

var $cN2RV = parcelRequire("cN2RV");

var $bL8WZ = parcelRequire("bL8WZ");

var $hKdwt = parcelRequire("hKdwt");
let $72b8428b51178863$var$CURRENT_PHASE = (0, $cN2RV.PHASE).PAINT;
const $72b8428b51178863$export$5f80f094fd31fffd = (phase)=>{
    $72b8428b51178863$var$CURRENT_PHASE = phase;
    (0, $bL8WZ.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $72b8428b51178863$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $9nHZC.createContext)({
    subscribe: (0, $hKdwt.createSubscribe)((0, $bL8WZ.LISTENERS)),
    currentValue: ()=>$72b8428b51178863$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $72b8428b51178863$export$5f80f094fd31fffd((0, $cN2RV.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$72b8428b51178863$export$5f80f094fd31fffd((0, $cN2RV.PHASE).PAINT)
    }
});
const $72b8428b51178863$export$1dc361b277327f88 = ()=>{
    const v = (0, $9nHZC.useContext)($72b8428b51178863$export$5a25eca35e5debcb);
    return v.api;
};

});
parcelRegister("bL8WZ", function(module, exports) {

$parcel$export(module.exports, "LISTENERS", function () { return $88fb06dc2da5277d$export$81b9c458a026d68f; });
const $88fb06dc2da5277d$export$81b9c458a026d68f = [];

});

parcelRegister("hKdwt", function(module, exports) {

$parcel$export(module.exports, "createSubscribe", function () { return $ceb138e488b72f97$export$364097d812234b3f; });
const $ceb138e488b72f97$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };

});



parcelRegister("4LspV", function(module, exports) {

$parcel$export(module.exports, "getExport", function () { return $378198404420d570$export$d4c07b1daf44a7f; });
$parcel$export(module.exports, "displayNameFromId", function () { return $378198404420d570$export$4429f98ef60d2d87; });
$parcel$export(module.exports, "isNodeEnvironment", function () { return $378198404420d570$export$283635c04a02cc36; });
$parcel$export(module.exports, "attrToProp", function () { return $378198404420d570$export$62bf630d0de3d781; });
$parcel$export(module.exports, "hash", function () { return (parcelRequire("gp5Al")).default; });

var $gp5Al = parcelRequire("gp5Al");
const $378198404420d570$export$d4c07b1daf44a7f = (m)=>"default" in m ? m.default : m;
const $378198404420d570$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split("/").slice(-3).join("/");
    return fName || "Component";
};
const $378198404420d570$export$283635c04a02cc36 = ()=>{
    return globalThis !== globalThis.window;
};
function $378198404420d570$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case "style":
            break;
        case "class":
            props.className = attr.value;
            break;
        case "crossorigin":
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}

});
parcelRegister("gp5Al", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf135040d193c4bb$export$2e2bcd8739ae039; });
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $bf135040d193c4bb$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});



parcelRegister("6RZ88", function(module, exports) {

$parcel$export(module.exports, "lazyForPaint", function () { return $50071c7a1cdb3741$export$c952e5f94576010e; });

var $iBOBG = parcelRequire("iBOBG");

var $9AIUR = parcelRequire("9AIUR");

var $cN2RV = parcelRequire("cN2RV");

var $4LspV = parcelRequire("4LspV");
var $gp5Al = parcelRequire("gp5Al");

var $lTLZu = parcelRequire("lTLZu");

var $96CX3 = parcelRequire("96CX3");

var $jdFlt = parcelRequire("jdFlt");

var $7ByvR = parcelRequire("7ByvR");

var $7jqZm = parcelRequire("7jqZm");

var $jLsOu = parcelRequire("jLsOu");

var $bakGG = parcelRequire("bakGG");
function $50071c7a1cdb3741$var$_extends() {
    $50071c7a1cdb3741$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $50071c7a1cdb3741$var$_extends.apply(this, arguments);
}
function $50071c7a1cdb3741$var$lazyProxy(_loader, { defer: defer = (0, $cN2RV.PHASE).PAINT, moduleId: moduleId = "", ssr: ssr = true } = {}) {
    const isServer = (0, $4LspV.isNodeEnvironment)();
    const dataLazyId = (0, $gp5Al.default)(moduleId);
    const LazyInternal = isServer ? (0, $jdFlt.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $96CX3.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $7ByvR.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $9AIUR.getConfig)();
                return (0, $jLsOu.retry)(_loader, {
                    delay: (0, $lTLZu.RETRY_DELAY),
                    factor: (0, $lTLZu.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $4LspV.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $9AIUR.getConfig)();
        return (0, $iBOBG.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $cN2RV.PHASE).PAINT ? (0, $lTLZu.PRIORITY).HIGH : (0, $lTLZu.PRIORITY).LOW;
        return (0, $7jqZm.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $50071c7a1cdb3741$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $cN2RV.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $cN2RV.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $cN2RV.PHASE).LAZY
    }
};
function $50071c7a1cdb3741$export$c952e5f94576010e(loader, opts) {
    return $50071c7a1cdb3741$var$lazyProxy(loader, $50071c7a1cdb3741$var$_extends({}, $50071c7a1cdb3741$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $50071c7a1cdb3741$export$291dd592399bdafa(loader, opts) {
    return $50071c7a1cdb3741$var$lazyProxy(loader, $50071c7a1cdb3741$var$_extends({}, $50071c7a1cdb3741$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $50071c7a1cdb3741$export$488013bae63b21da(loader, opts) {
    return $50071c7a1cdb3741$var$lazyProxy(loader, $50071c7a1cdb3741$var$_extends({}, $50071c7a1cdb3741$export$93ca5d3f8675ae4c.lazy, opts || {}));
}

});
parcelRegister("iBOBG", function(module, exports) {

$parcel$export(module.exports, "getAssetUrlsFromId", function () { return $d8c2f02bf6d82d07$export$303f43e55cf1ef2f; });
const $d8c2f02bf6d82d07$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};

});

parcelRegister("lTLZu", function(module, exports) {

$parcel$export(module.exports, "PRIORITY", function () { return $ff13f5f9214dcaee$export$bb34f3538ba26c7e; });
$parcel$export(module.exports, "RETRY_DELAY", function () { return $ff13f5f9214dcaee$export$a339266ad71b2447; });
$parcel$export(module.exports, "RETRY_FACTOR", function () { return $ff13f5f9214dcaee$export$ba64c908e55507fe; });
const $ff13f5f9214dcaee$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $ff13f5f9214dcaee$export$a339266ad71b2447 = 300;
const $ff13f5f9214dcaee$export$ba64c908e55507fe = 1;

});

parcelRegister("96CX3", function(module, exports) {

$parcel$export(module.exports, "createComponentClient", function () { return $6a12e385f39d0ae7$export$6898b5504b58699a; });

var $9nHZC = parcelRequire("9nHZC");

var $9AIUR = parcelRequire("9AIUR");
var $esLgZ = parcelRequire("esLgZ");

var $cN2RV = parcelRequire("cN2RV");
parcelRequire("9Q5rS");
var $5GWKv = parcelRequire("5GWKv");
parcelRequire("9I8Ai");
var $9QEkY = parcelRequire("9QEkY");
parcelRequire("eZ9Lc");
var $2J1iD = parcelRequire("2J1iD");

var $lTLZu = parcelRequire("lTLZu");

var $bakGG = parcelRequire("bakGG");

var $gtqz6 = parcelRequire("gtqz6");

var $1E15p = parcelRequire("1E15p");

var $7jqZm = parcelRequire("7jqZm");

var $c9GqP = parcelRequire("c9GqP");

var $68rL2 = parcelRequire("68rL2");
const { requestIdleCallback: $6a12e385f39d0ae7$var$requestIdleCallback = setTimeout } = window;
function $6a12e385f39d0ae7$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const ResolvedLazy = /*#__PURE__*/ (0, $9nHZC.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $9nHZC.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $cN2RV.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $cN2RV.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $9nHZC.useContext)((0, $c9GqP.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $bakGG.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        }; // Subscribe to LazyWait context, triggering load when until is true
        (0, $68rL2.useSubscription)({
            context: (0, $5GWKv.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $cN2RV.PHASE).AFTER_PAINT) {
            // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $68rL2.useSubscription)({
                context: (0, $9QEkY.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            }); // Schedule preloading as will be needed soon
            (0, $9nHZC.useMemo)(()=>{
                if (!status.preloaded) {
                    status.preloaded = true;
                    $6a12e385f39d0ae7$var$requestIdleCallback(()=>{
                        if (status.started) return;
                        (0, $7jqZm.preloadAsset)({
                            loader: deferred.preload,
                            moduleId: moduleId,
                            priority: (0, $lTLZu.PRIORITY).LOW
                        });
                    });
                }
            }, [
                status
            ]);
        }
        const { setFallback: setFallback } = (0, $9nHZC.useContext)((0, $2J1iD.LazySuspenseContext));
        (0, $9nHZC.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $cN2RV.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return; // override Suspense fallback with magic input wrappers
            const component = (0, $9AIUR.getConfig)().mode === (0, $esLgZ.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $gtqz6.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $1E15p.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(ResolvedLazy, props);
    };
}

});
parcelRegister("9Q5rS", function(module, exports) {

$parcel$export(module.exports, "WaitContext", function () { return (parcelRequire("5GWKv")).WaitContext; });

var $5GWKv = parcelRequire("5GWKv");

var $jbNq7 = parcelRequire("jbNq7");

});
parcelRegister("5GWKv", function(module, exports) {

$parcel$export(module.exports, "WaitContext", function () { return $424e725750a0e2d6$export$9ba3fe09d15de47b; });

var $9nHZC = parcelRequire("9nHZC");

var $cDHQh = parcelRequire("cDHQh");
const $424e725750a0e2d6$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $9nHZC.createContext)({
    subscribe: ()=>(0, $cDHQh.noopCleanup),
    currentValue: ()=>1
});

});
parcelRegister("cDHQh", function(module, exports) {

$parcel$export(module.exports, "noopCleanup", function () { return $933b22b8f94a1d98$export$276c7dbda7675aec; });
const $933b22b8f94a1d98$export$276c7dbda7675aec = ()=>{};

});


parcelRegister("jbNq7", function(module, exports) {

var $9nHZC = parcelRequire("9nHZC");

var $5GWKv = parcelRequire("5GWKv");
const $df85613d83f766bb$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $9nHZC.useContext)((0, $5GWKv.WaitContext));
    const value = (0, $9nHZC.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $9nHZC.useRef)(new Set());
    const api = (0, $9nHZC.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $9nHZC.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5GWKv.WaitContext).Provider, {
        value: api.current
    }, children);
};

});


parcelRegister("eZ9Lc", function(module, exports) {

$parcel$export(module.exports, "LazySuspense", function () { return (parcelRequire("8Dwfz")).LazySuspense; });
$parcel$export(module.exports, "LazySuspenseContext", function () { return (parcelRequire("2J1iD")).LazySuspenseContext; });

var $8Dwfz = parcelRequire("8Dwfz");

var $2J1iD = parcelRequire("2J1iD");

});
parcelRegister("8Dwfz", function(module, exports) {

$parcel$export(module.exports, "LazySuspense", function () { return $649afb6dc61e5cf2$export$256c542058532d6f; });

var $9nHZC = parcelRequire("9nHZC");

var $4LspV = parcelRequire("4LspV");

var $2J1iD = parcelRequire("2J1iD");
class $649afb6dc61e5cf2$export$256c542058532d6f extends (0, $9nHZC.Component) {
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback; // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            }
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $9nHZC.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = "DynamicFallback";
    }
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this; // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2J1iD.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2J1iD.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $4LspV.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
}

});
parcelRegister("2J1iD", function(module, exports) {

$parcel$export(module.exports, "LazySuspenseContext", function () { return $1fc0cac8d3eff759$export$c33990e84065970c; });

var $9nHZC = parcelRequire("9nHZC");
const $1fc0cac8d3eff759$export$c33990e84065970c = /*#__PURE__*/ (0, $9nHZC.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null),
    setFallback: ()=>{
        console.warn("Missing <LooselySuspense /> boundary");
    }
});

});



parcelRegister("bakGG", function(module, exports) {

$parcel$export(module.exports, "createLoaderError", function () { return $8210acf6d6128da0$export$c73a6a6f0bf7d425; });
const $8210acf6d6128da0$export$6aa69c1258005366 = Symbol.for("react-loosely-lazy/loader-error");
const $8210acf6d6128da0$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === "object") return Object.assign(error, {
        [$8210acf6d6128da0$export$6aa69c1258005366]: true
    });
    return error;
};
const $8210acf6d6128da0$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($8210acf6d6128da0$export$6aa69c1258005366);

});

parcelRegister("gtqz6", function(module, exports) {

$parcel$export(module.exports, "PlaceholderFallbackRender", function () { return $bfe3f6143992962a$export$d55db778a3e1446b; });

var $9nHZC = parcelRequire("9nHZC");
function $bfe3f6143992962a$var$isLinkPrefetch(el) {
    return el.tagName === "LINK" && el.rel === "prefetch";
}
const $bfe3f6143992962a$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $9nHZC.useRef)(null);
    const { current: ssrDomNodes } = (0, $9nHZC.useRef)(content || []);
    (0, $9nHZC.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($bfe3f6143992962a$var$isLinkPrefetch(node)) node.rel = "";
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        }; // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $bfe3f6143992962a$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $bfe3f6143992962a$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};

});

parcelRegister("1E15p", function(module, exports) {

$parcel$export(module.exports, "PlaceholderFallbackHydrate", function () { return $132a5e8d311ed2aa$export$ca5b8fbc835d95e4; });

var $9nHZC = parcelRequire("9nHZC");

var $4LspV = parcelRequire("4LspV");
function $132a5e8d311ed2aa$var$_extends() {
    $132a5e8d311ed2aa$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $132a5e8d311ed2aa$var$_extends.apply(this, arguments);
}
const $132a5e8d311ed2aa$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = "", childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $4LspV.attrToProp), {
            key: String(i)
        }); // text node
        if (!tagName) return /*#__PURE__*/ (0, $9nHZC.createElement)((0, $9nHZC.Fragment), props, el.textContent); // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $9nHZC.createElement)(tagName.toLowerCase(), props); // tag with content
        return /*#__PURE__*/ (0, $9nHZC.createElement)(tagName.toLowerCase(), $132a5e8d311ed2aa$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ""
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};

});

parcelRegister("7jqZm", function(module, exports) {

$parcel$export(module.exports, "preloadAsset", function () { return $552f3e1e848bdb52$export$25bad4aa00c45355; });

var $iBOBG = parcelRequire("iBOBG");

var $cDHQh = parcelRequire("cDHQh");

var $9AIUR = parcelRequire("9AIUR");

var $4LspV = parcelRequire("4LspV");

var $lTLZu = parcelRequire("lTLZu");

var $cPHmp = parcelRequire("cPHmp");

var $c9GqP = parcelRequire("c9GqP");
function $552f3e1e848bdb52$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $9AIUR.getConfig)();
    const assets = (0, $iBOBG.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error("Unsupported preload strategy");
    const cleanupLinkTags = assets.map((url)=>(0, $cPHmp.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $552f3e1e848bdb52$var$fakePromise = {
    then: ()=>$552f3e1e848bdb52$var$fakePromise,
    catch: ()=>$552f3e1e848bdb52$var$fakePromise,
    finally: ()=>$552f3e1e848bdb52$var$fakePromise
};
function $552f3e1e848bdb52$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === "undefined" || typeof __webpack_get_script_filename__ === "undefined") throw new Error("Unsupported preload strategy"); // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $cPHmp.insertLinkTag)(href, rel));
        return $552f3e1e848bdb52$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {} // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $552f3e1e848bdb52$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $cDHQh.noopCleanup;
}
function $552f3e1e848bdb52$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $4LspV.isNodeEnvironment)()) return 0, $cDHQh.noopCleanup;
    (_GlobalReactLooselyLa = (0, $c9GqP.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $lTLZu.PRIORITY).HIGH ? "preload" : "prefetch";
    const preloadStrategies = [
        $552f3e1e848bdb52$export$3af04dbcb01bad4d,
        $552f3e1e848bdb52$export$1046fd6a49d5e7a,
        $552f3e1e848bdb52$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {}
    return 0, $cDHQh.noopCleanup;
}

});
parcelRegister("cPHmp", function(module, exports) {

$parcel$export(module.exports, "insertLinkTag", function () { return $957be1f1f85f33f7$export$6610512821c8a4ce; });

var $c9GqP = parcelRequire("c9GqP");

var $cDHQh = parcelRequire("cDHQh");

var $9AIUR = parcelRequire("9AIUR");
function $957be1f1f85f33f7$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $cDHQh.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $9AIUR.getConfig)();
    const link = document.createElement("link");
    link.rel = rel;
    link.as = "script";
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $c9GqP.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener("onload", listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener("onload", listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener("onload", removableListener);
    };
}

});
parcelRegister("c9GqP", function(module, exports) {

$parcel$export(module.exports, "GlobalReactLooselyLazyProfiler", function () { return $8d973d5708a00535$export$e2d53c0cbedd2710; });
$parcel$export(module.exports, "ProfilerContext", function () { return $8d973d5708a00535$export$8146ab57a3f7a7cb; });

var $9nHZC = parcelRequire("9nHZC");
const $8d973d5708a00535$export$e2d53c0cbedd2710 = {
    current: null
};
const $8d973d5708a00535$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $9nHZC.createContext)($8d973d5708a00535$export$e2d53c0cbedd2710);

});



parcelRegister("68rL2", function(module, exports) {

$parcel$export(module.exports, "useSubscription", function () { return $47790587e43c3f23$export$368b4214baeb914c; });

var $9nHZC = parcelRequire("9nHZC");
function $47790587e43c3f23$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $9nHZC.useContext)(context);
    (0, $9nHZC.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("jdFlt", function(module, exports) {

$parcel$export(module.exports, "createComponentServer", function () { return $dfdf4d8915f16280$export$eb2e4b04351cdd9e; });

var $iBOBG = parcelRequire("iBOBG");

var $9nHZC = parcelRequire("9nHZC");

var $9AIUR = parcelRequire("9AIUR");

var $cN2RV = parcelRequire("cN2RV");
parcelRequire("eZ9Lc");
var $2J1iD = parcelRequire("2J1iD");

var $4LspV = parcelRequire("4LspV");

var $bakGG = parcelRequire("bakGG");
function $dfdf4d8915f16280$var$load(moduleId, loader) {
    try {
        return (0, $4LspV.getExport)(loader());
    } catch (err) {
        throw (0, $bakGG.createLoaderError)(err);
    }
}
function $dfdf4d8915f16280$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $dfdf4d8915f16280$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $9nHZC.useContext)((0, $2J1iD.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $9AIUR.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $cN2RV.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $iBOBG.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("link", {
                key: url,
                rel: defer === (0, $cN2RV.PHASE).PAINT ? "preload" : "prefetch",
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}

});

parcelRegister("7ByvR", function(module, exports) {

$parcel$export(module.exports, "createDeferred", function () { return $5896c2aab71ed2c1$export$e673efccd97e4223; });
const $5896c2aab71ed2c1$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{});
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            } // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};

});

parcelRegister("jLsOu", function(module, exports) {

$parcel$export(module.exports, "retry", function () { return $e638c1d5da7b1013$export$9369b12211e1fce4; });
const $e638c1d5da7b1013$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1; // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
     // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $e638c1d5da7b1013$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $e638c1d5da7b1013$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $e638c1d5da7b1013$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $e638c1d5da7b1013$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $e638c1d5da7b1013$var$calculateDelay(context, policy);
        if (delay) await $e638c1d5da7b1013$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}

});



parcelRegister("anIL3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78eec562199cb5b0$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9q1kH = parcelRequire("9q1kH");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $4aKeK = parcelRequire("4aKeK");

var $9qsao = parcelRequire("9qsao");

var $8p2GL = parcelRequire("8p2GL");

var $ay1rd = parcelRequire("ay1rd");

var $JcvLo = parcelRequire("JcvLo");
var $gWA00 = parcelRequire("gWA00");

var $htChF = parcelRequire("htChF");

var $42IPZ = parcelRequire("42IPZ");

var $97YIy = parcelRequire("97YIy");

var $aP6k3 = parcelRequire("aP6k3");

var $8iKQq = parcelRequire("8iKQq");

var $ipXNJ = parcelRequire("ipXNJ");

var $hqrxU = parcelRequire("hqrxU");

var $fs4ZW = parcelRequire("fs4ZW");
function $78eec562199cb5b0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $78eec562199cb5b0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $78eec562199cb5b0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $78eec562199cb5b0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $78eec562199cb5b0$var$tooltipZIndex = (0, $aP6k3.layers).tooltip();
var $78eec562199cb5b0$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "17.8.8"
};
// Inverts motion direction
var $78eec562199cb5b0$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param position - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $78eec562199cb5b0$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
function $78eec562199cb5b0$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $hqrxU.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $8p2GL.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $8p2GL.default) : _ref$onHide, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy;
    var tooltipPosition = position === "mouse" ? mousePosition : position;
    var onShowHandler = (0, $9qsao.usePlatformLeafSyntheticEventHandler)($78eec562199cb5b0$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $78eec562199cb5b0$var$analyticsAttributes));
    var onHideHandler = (0, $9qsao.usePlatformLeafSyntheticEventHandler)($78eec562199cb5b0$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $78eec562199cb5b0$var$analyticsAttributes));
    var apiRef = (0, $9nHZC.useRef)(null);
    var _useState = (0, $9nHZC.useState)("hide"), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $9nHZC.useRef)(null);
    var containerRef = (0, $9nHZC.useRef)(null);
    var hasFunctionalChildren = typeof children === "function"; // Stored to keep our `setRef` callback cleaner.
    var setRef = (0, $9nHZC.useCallback)(function(node) {
        if (!node) return;
        if (hasFunctionalChildren) targetRef.current = node;
        else {
            containerRef.current = node;
            targetRef.current = node.firstChild;
        }
    }, [
        hasFunctionalChildren
    ]);
    // Putting a few things into refs so that we don't have to break memoization
    var lastState = (0, $9nHZC.useRef)(state);
    var lastDelay = (0, $9nHZC.useRef)(delay);
    var lastHandlers = (0, $9nHZC.useRef)({
        onShowHandler: onShowHandler,
        onHideHandler: onHideHandler
    });
    var hasCalledShowHandler = (0, $9nHZC.useRef)(false);
    (0, $9nHZC.useEffect)(function() {
        lastState.current = state;
        lastDelay.current = delay;
        lastHandlers.current = {
            onShowHandler: onShowHandler,
            onHideHandler: onHideHandler
        };
    }, [
        delay,
        onHideHandler,
        onShowHandler,
        state
    ]);
    var start = (0, $9nHZC.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $9nHZC.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, []);
    var abort = (0, $9nHZC.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
    }, []);
    (0, $9nHZC.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var showTooltip = (0, $9nHZC.useCallback)(function(source) {
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // Tell the tooltip to keep showing
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        var entry = {
            source: source,
            delay: lastDelay.current,
            show: function show(_ref2) {
                var isImmediate = _ref2.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    lastHandlers.current.onShowHandler();
                }
                setState(isImmediate ? "show-immediate" : "fade-in");
            },
            hide: function hide(_ref3) {
                var isImmediate = _ref3.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done
        };
        var api = (0, $8iKQq.show)(entry);
        start(api);
    }, [
        abort,
        done,
        start
    ]);
    var hideTooltipOnEsc = (0, $9nHZC.useCallback)(function() {
        var _apiRef$current;
        (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $ay1rd.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $9nHZC.useEffect)(function() {
        if (state === "hide") return 0, $8p2GL.default;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $4aKeK.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $9nHZC.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $9nHZC.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $9nHZC.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === "mouse" ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            mouse: (0, $fs4ZW.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: "keyboard"
        };
        showTooltip(source);
    }, [
        position,
        showTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $9nHZC.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === "mouse" ? function(event) {
        var _apiRef$current2;
        if ((_apiRef$current2 = apiRef.current) !== null && _apiRef$current2 !== void 0 && _apiRef$current2.isActive()) apiRef.current.mousePosition = (0, $fs4ZW.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $9nHZC.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $9nHZC.useCallback)(function() {
        showTooltip({
            type: "keyboard"
        });
    }, [
        showTooltip
    ]);
    var onBlur = (0, $9nHZC.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $9nHZC.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && lastState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, []);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipContainer = state !== "hide" && Boolean(content);
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current3;
        if (position === "mouse" && (_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.mousePosition) {
            var _apiRef$current4;
            return (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 ? void 0 : _apiRef$current4.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipId = (0, $ipXNJ.default)("tooltip", shouldRenderTooltipContainer);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        ref: setRef
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    (0, $9nHZC.useEffect)(function() {
        // If there is no container element, we should exit early, because that
        // means they are using the render prop API, and that is implemented in a
        // different way. If there is no target element yet or tooltipId, we also
        // shouldn't do anything because there is nothing to operate on or with.
        if (!containerRef.current || !targetRef.current || !tooltipId) return;
        // Necessary for TS to know that it has the attribute methods
        var target = targetRef.current;
        if (shouldRenderTooltipContainer) target.setAttribute("aria-describedby", tooltipId);
        else target.removeAttribute("aria-describedby");
    }, [
        shouldRenderTooltipContainer,
        tooltipId
    ]);
    return (0, $avKww.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, typeof children === "function" ? // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    children($78eec562199cb5b0$var$_objectSpread($78eec562199cb5b0$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipId
    })) : (0, $avKww.jsx)(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, tooltipTriggerProps, {
        role: "presentation"
    }), children), shouldRenderTooltipContainer ? (0, $avKww.jsx)((0, $97YIy.default), {
        zIndex: $78eec562199cb5b0$var$tooltipZIndex
    }, (0, $avKww.jsx)((0, $42IPZ.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref4) {
        var ref = _ref4.ref, style = _ref4.style, update = _ref4.update, placement = _ref4.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === "mouse" ? undefined : $78eec562199cb5b0$var$invertedDirection[$78eec562199cb5b0$var$getDirectionFromPlacement(placement)];
        return (0, $avKww.jsx)((0, $JcvLo.default), {
            appear: true
        }, shouldRenderTooltipChildren && (0, $avKww.jsx)((0, $gWA00.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state === "show-immediate" ? 0 : (0, $htChF.mediumDurationMs)
        }, function(_ref5) {
            var className = _ref5.className;
            return (0, $avKww.jsx)(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: style,
                truncate: truncate,
                placement: tooltipPosition,
                testId: testId,
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                id: tooltipId
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$78eec562199cb5b0$var$Tooltip.displayName = "Tooltip";
var $78eec562199cb5b0$export$2e2bcd8739ae039 = $78eec562199cb5b0$var$Tooltip;

});
parcelRegister("4aKeK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $bQFq9 = parcelRequire("bQFq9");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $bQFq9.bind;
    }
});

var $9Rrvg = parcelRequire("9Rrvg");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $9Rrvg.bindAll;
    }
});

});
parcelRegister("bQFq9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $8a04ae53ba4ccae7$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $8a04ae53ba4ccae7$var$bind;

});

parcelRegister("9Rrvg", function(module, exports) {
"use strict";
var $72de65d7afc61339$var$__assign = module.exports && module.exports.__assign || function() {
    $72de65d7afc61339$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $72de65d7afc61339$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $bQFq9 = parcelRequire("bQFq9");
function $72de65d7afc61339$var$toOptions(value) {
    if (typeof value === "undefined") return undefined;
    if (typeof value === "boolean") return {
        capture: value
    };
    return value;
}
function $72de65d7afc61339$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $72de65d7afc61339$var$__assign($72de65d7afc61339$var$__assign({}, original), {
        options: $72de65d7afc61339$var$__assign($72de65d7afc61339$var$__assign({}, $72de65d7afc61339$var$toOptions(sharedOptions)), $72de65d7afc61339$var$toOptions(original.options))
    });
    return binding;
}
function $72de65d7afc61339$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $72de65d7afc61339$var$getBinding(original, sharedOptions);
        return (0, $bQFq9.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $72de65d7afc61339$var$bindAll;

});


parcelRegister("9qsao", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $6dcc6413f8a5e004$export$1a04351537078b55; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $kmQpI = parcelRequire("kmQpI");

var $1DNpC = parcelRequire("1DNpC");
function $6dcc6413f8a5e004$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6dcc6413f8a5e004$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6dcc6413f8a5e004$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6dcc6413f8a5e004$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6dcc6413f8a5e004$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $kmQpI.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $1DNpC.useTrackedRef)(analyticsData);
    var fnRef = (0, $1DNpC.useTrackedRef)(fn);
    var handler = (0, $9nHZC.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $6dcc6413f8a5e004$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("kmQpI", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $ed3e85077577f7bd$export$5bf35293e545f20c; });

var $dNznA = parcelRequire("dNznA");

var $20Lmw = parcelRequire("20Lmw");

var $cl6hY = parcelRequire("cl6hY");
function $ed3e85077577f7bd$export$5bf35293e545f20c() {
    var analyticsContext = (0, $cl6hY.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $20Lmw.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("20Lmw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $177052074e287153$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $6Nnf4 = parcelRequire("6Nnf4");
function $177052074e287153$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $177052074e287153$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $177052074e287153$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($177052074e287153$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $177052074e287153$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $177052074e287153$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $177052074e287153$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $177052074e287153$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $6Nnf4.default));

});
parcelRegister("6Nnf4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f29591101709899$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
function $4f29591101709899$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4f29591101709899$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4f29591101709899$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4f29591101709899$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4f29591101709899$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $4f29591101709899$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $4f29591101709899$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $4f29591101709899$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(updater) === "object") this.payload = $4f29591101709899$var$_objectSpread($4f29591101709899$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("cl6hY", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $8fbc530c5176512d$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $8fbc530c5176512d$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});


parcelRegister("1DNpC", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $131fc32d62c62037$export$1d27a74659855e44; });

var $9nHZC = parcelRequire("9nHZC");
var $131fc32d62c62037$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("42IPZ", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $2f1a2123a97c1933$export$badac9ada3a0bdf9; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $cjxQA = parcelRequire("cjxQA");

// Export types from PopperJS / React Popper
var $2f1a2123a97c1933$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: 5,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    },
    {
        name: "preventOverflow",
        options: {
            padding: 5,
            rootBoundary: "document"
        }
    }
];
function $2f1a2123a97c1933$var$defaultChildrenFn() {
    return null;
}
var $2f1a2123a97c1933$var$defaultOffset = [
    0,
    8
];
function $2f1a2123a97c1933$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $2f1a2123a97c1933$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $2f1a2123a97c1933$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    // Merge a new offset modifier only if new offset values passed in
    var internalModifiers = (0, $9nHZC.useMemo)(function() {
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        return [].concat($2f1a2123a97c1933$var$constantModifiers, [
            offsetModifier
        ]);
    }, [
        offsetX,
        offsetY
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $9nHZC.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $cjxQA.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});

parcelRegister("8iKQq", function(module, exports) {

$parcel$export(module.exports, "show", function () { return $60b4578cb003051e$export$57bf213be019eeb0; });

var $9wHhB = parcelRequire("9wHhB");
// This file is a singleton for managing tooltips
var $60b4578cb003051e$var$active = null;
function $60b4578cb003051e$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($60b4578cb003051e$var$active && $60b4578cb003051e$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $9wHhB.clearScheduled)();
            $60b4578cb003051e$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $9wHhB.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $9wHhB.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $9wHhB.scheduleTimeout)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($60b4578cb003051e$var$active && $60b4578cb003051e$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($60b4578cb003051e$var$active) {
            (0, $9wHhB.clearScheduled)();
            $60b4578cb003051e$var$active.entry.hide({
                isImmediate: true
            });
            $60b4578cb003051e$var$active.entry.done();
            $60b4578cb003051e$var$active = null;
        }
        // this tooltip is now the active tooltip
        $60b4578cb003051e$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $9wHhB.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("9wHhB", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", function () { return $6ef8ad499e17bac1$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $6ef8ad499e17bac1$export$5f4d6617421d489b; });
var $6ef8ad499e17bac1$var$delayId = null;
function $6ef8ad499e17bac1$export$eaf678f6f93f5250() {
    if ($6ef8ad499e17bac1$var$delayId != null) {
        window.clearTimeout($6ef8ad499e17bac1$var$delayId);
        $6ef8ad499e17bac1$var$delayId = null;
    }
}
function $6ef8ad499e17bac1$export$5f4d6617421d489b(fn, delay) {
    $6ef8ad499e17bac1$export$eaf678f6f93f5250();
    $6ef8ad499e17bac1$var$delayId = window.setTimeout(function() {
        $6ef8ad499e17bac1$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("ipXNJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d688f30ab58867c6$export$2e2bcd8739ae039; });

var $9SZaS = parcelRequire("9SZaS");
function $d688f30ab58867c6$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $9SZaS.useUIDSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});

parcelRegister("hqrxU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cafa3b70696ba36a$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $jp7ng = parcelRequire("jp7ng");

var $5LVXk = parcelRequire("5LVXk");

var $hKf58 = parcelRequire("hKf58");
var $cafa3b70696ba36a$var$baseStyles = (0, $avKww.css)({
    boxSizing: "border-box",
    maxWidth: "240px",
    padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-075, 6px)"),
    insetBlockStart: "var(--ds-space-0, 0px)",
    insetInlineStart: "var(--ds-space-0, 0px)",
    borderRadius: "var(--ds-border-radius, 3px)",
    fontSize: "var(--ds-font-size-075, 12px)",
    lineHeight: 1.3,
    overflowWrap: "break-word",
    wordWrap: "break-word"
});
var $cafa3b70696ba36a$var$truncateStyles = (0, $avKww.css)({
    maxWidth: "420px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $cafa3b70696ba36a$var$lightStyles = (0, $avKww.css)({
    backgroundColor: "var(--ds-background-neutral-bold, ".concat((0, $jp7ng.N800), ")"),
    color: "var(--ds-text-inverse, ".concat((0, $jp7ng.N0), ")")
});
var $cafa3b70696ba36a$var$darkStyles = (0, $avKww.css)({
    backgroundColor: "var(--ds-background-neutral-bold, ".concat((0, $jp7ng.DN0), ")"),
    color: "var(--ds-text-inverse, ".concat((0, $jp7ng.DN600), ")")
});
var $cafa3b70696ba36a$var$TooltipContainer = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return (0, $avKww.jsx)((0, $5LVXk.default).Consumer, null, function(_ref2) {
        var mode = _ref2.mode;
        return (0, $avKww.jsx)((0, $hKf58.default), {
            ref: ref,
            style: style,
            className: className,
            placement: placement,
            testId: testId,
            id: id,
            onMouseOut: onMouseOut,
            onMouseOver: onMouseOver,
            css: [
                $cafa3b70696ba36a$var$baseStyles,
                truncate ? $cafa3b70696ba36a$var$truncateStyles : null,
                mode === "light" ? $cafa3b70696ba36a$var$lightStyles : $cafa3b70696ba36a$var$darkStyles
            ]
        }, children);
    });
});
$cafa3b70696ba36a$var$TooltipContainer.displayName = "TooltipContainer";
var $cafa3b70696ba36a$export$2e2bcd8739ae039 = $cafa3b70696ba36a$var$TooltipContainer;

});
parcelRegister("hKf58", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ceb26e766737bbf2$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $aP6k3 = parcelRequire("aP6k3");
function $ceb26e766737bbf2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ceb26e766737bbf2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ceb26e766737bbf2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ceb26e766737bbf2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ceb26e766737bbf2$var$VAR_PRIMITIVE_ZINDEX = "tooltipPrimitiveZindex";
var $ceb26e766737bbf2$var$primitiveStyles = (0, $avKww.css)({
    zindex: "var(".concat($ceb26e766737bbf2$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
var $ceb26e766737bbf2$var$TooltipPrimitive = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $ceb26e766737bbf2$var$_objectSpread($ceb26e766737bbf2$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, $ceb26e766737bbf2$var$VAR_PRIMITIVE_ZINDEX, (0, $aP6k3.layers).tooltip()));
    return (0, $avKww.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $avKww.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $ceb26e766737bbf2$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$ceb26e766737bbf2$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $ceb26e766737bbf2$export$2e2bcd8739ae039 = $ceb26e766737bbf2$var$TooltipPrimitive;

});


parcelRegister("fs4ZW", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", function () { return $b3fd59103e073be9$export$642213d516a9b928; });
function $b3fd59103e073be9$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("1FKpu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $137d9edef072e28b$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $6rNCX = parcelRequire("6rNCX");

var $3THTN = parcelRequire("3THTN");

var $8p2GL = parcelRequire("8p2GL");
var $137d9edef072e28b$var$_excluded = [
    "hasOverflow",
    "href",
    "onClick",
    "analyticsContext",
    "iconBefore",
    "iconAfter"
];
function $137d9edef072e28b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $137d9edef072e28b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $137d9edef072e28b$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $137d9edef072e28b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $137d9edef072e28b$var$analyticsAttributes = {
    componentName: "breadcrumbsItem",
    packageName: "@atlaskit/breadcrumbs",
    packageVersion: "11.10.6"
};
var $137d9edef072e28b$var$noop = (0, $8p2GL.default);
var $137d9edef072e28b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function(_ref, ref) {
    var _ref$hasOverflow = _ref.hasOverflow, hasOverflow = _ref$hasOverflow === void 0 ? true : _ref$hasOverflow, _ref$href = _ref.href, href = _ref$href === void 0 ? "#" : _ref$href, _ref$onClick = _ref.onClick, onClickProvided = _ref$onClick === void 0 ? $137d9edef072e28b$var$noop : _ref$onClick, analyticsContext = _ref.analyticsContext, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $137d9edef072e28b$var$_excluded);
    var handleClicked = (0, $6rNCX.usePlatformLeafEventHandler)($137d9edef072e28b$var$_objectSpread({
        fn: onClickProvided,
        action: "clicked",
        analyticsData: analyticsContext
    }, $137d9edef072e28b$var$analyticsAttributes));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3THTN.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        appearance: "subtle-link",
        spacing: "none",
        iconAfter: hasOverflow ? undefined : iconAfter,
        iconBefore: hasOverflow ? undefined : iconBefore,
        onClick: handleClicked,
        ref: ref,
        href: href
    }, props));
});

});
parcelRegister("6rNCX", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $4b1bc2acee426b37$export$a4687b0234b40e28; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $kmQpI = parcelRequire("kmQpI");

var $1DNpC = parcelRequire("1DNpC");
function $4b1bc2acee426b37$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4b1bc2acee426b37$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4b1bc2acee426b37$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4b1bc2acee426b37$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4b1bc2acee426b37$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $kmQpI.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $1DNpC.useTrackedRef)(analyticsData);
    var fnRef = (0, $1DNpC.useTrackedRef)(fn);
    var handler = (0, $9nHZC.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $4b1bc2acee426b37$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});


parcelRegister("5JKJ4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42d566822b49974c$export$2e2bcd8739ae039; });

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");
function $42d566822b49974c$export$2e2bcd8739ae039(truncationWidth, buttonRef) {
    var _useState = (0, $9nHZC.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), hasOverflow = _useState2[0], setOverflow = _useState2[1];
    // Recalculate hasOverflow on every render cycle
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $9nHZC.useEffect)(function() {
        if (truncationWidth && buttonRef.current) {
            var shouldOverflow = buttonRef.current.clientWidth >= truncationWidth;
            if (shouldOverflow !== hasOverflow) setOverflow(shouldOverflow);
        }
    });
    return hasOverflow;
}

});

parcelRegister("QO3gA", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("4UJOf")).then(()=>parcelRequire("5iejw"));

});


parcelRegister("aurzp", function(module, exports) {

$parcel$export(module.exports, "ComponentLinkProxy", function () { return $2db93bb6300bf763$export$762a4039bca368b5; });
$parcel$export(module.exports, "ComponentLink", function () { return $2db93bb6300bf763$export$9cfbe6470f0d2606; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $gjey0 = parcelRequire("gjey0");
class $2db93bb6300bf763$export$762a4039bca368b5 extends (0, $9nHZC.PureComponent) {
    render() {
        const { href: href, children: children, className: className, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseDown: onMouseDown, qaId: qaId, innerRef: innerRef, "aria-label": ariaLabel, target: target, "data-testid": dataTestId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $gjey0.default), {
            to: href,
            className: className,
            "data-qa": qaId,
            onClick: onClick,
            onFocus: onFocus,
            onKeyDown: onKeyDown,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            innerRef: innerRef,
            "aria-label": ariaLabel,
            target: target,
            "data-testid": dataTestId
        }, children);
    }
}
class $2db93bb6300bf763$export$9cfbe6470f0d2606 extends (0, $9nHZC.PureComponent) {
    render() {
        const { href: href, children: children, ...otherProps } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $gjey0.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
            to: href
        }), children);
    }
}

});

parcelRegister("dULUA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c59c079d76a0acc$export$2e2bcd8739ae039; });
parcelRequire("dGzLf");
var $5oGLl = parcelRequire("5oGLl");

var $aanBq = parcelRequire("aanBq");

var $97gVv = parcelRequire("97gVv");
const $6c59c079d76a0acc$var$mapStateToProps = (state)=>{
    const repository = (0, $aanBq.getCurrentRepository)(state);
    return {
        repository: repository
    };
};
var $6c59c079d76a0acc$export$2e2bcd8739ae039 = (0, $5oGLl.default)($6c59c079d76a0acc$var$mapStateToProps)((0, $97gVv.default));

});
parcelRegister("97gVv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6823e50f7fc6895a$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $1ONvK = parcelRequire("1ONvK");
var $iOmtv = parcelRequire("iOmtv");

var $f9pRZ = parcelRequire("f9pRZ");

var $cUU4Z = parcelRequire("cUU4Z");

var $7ncoz = parcelRequire("7ncoz");

var $a9ixz = parcelRequire("a9ixz");

var $8agvL = parcelRequire("8agvL");
const $6823e50f7fc6895a$var$RepositoryBreadcrumbs = ({ repository: repository, isRoot: isRoot = false, children: children })=>{
    const { publishBreadcrumbClickEvent: publishBreadcrumbClickEvent } = (0, $f9pRZ.useAnalytics)();
    const projectUrl = ()=>{
        if (!repository) return undefined;
        const { owner: owner, project: project } = repository;
        if (!project) return undefined;
        if (project.links) return project.links.html.href;
        return owner ? (0, $a9ixz.default).ui.project(owner.uuid, project.key) : undefined;
    };
    if (!repository) return null;
    const { project: project, slug: slug } = repository;
    const LinkComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function BreadcrumbsItemRepositoryLink(// explicitly don't pass through props
    _props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($8agvL.BreadcrumbsItemRepositoryLink, {
            // @ts-ignore Emotion's types are a bit wonky
            ref: ref,
            onClick: ()=>publishBreadcrumbClickEvent("RepositoryLink"),
            repository: repository
        });
    });
    const workspaceIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7ncoz.default), {
        workspace: repository.workspace
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $iOmtv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $1ONvK.default), {
        href: (0, $cUU4Z.getRepoOwnerUrl)(repository),
        text: (0, $cUU4Z.getRepoOwnerName)(repository) || "",
        onClick: ()=>publishBreadcrumbClickEvent("WorkspaceLink"),
        iconBefore: workspaceIcon
    }), project && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $1ONvK.default), {
        href: projectUrl(),
        text: project.name,
        onClick: ()=>publishBreadcrumbClickEvent("ProjectLink")
    }), slug && !isRoot && /*#__PURE__*/ // `text` is not actually used, but it's a required prop
    (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $1ONvK.default), {
        component: LinkComponent,
        text: slug
    }), children);
};
var $6823e50f7fc6895a$export$2e2bcd8739ae039 = $6823e50f7fc6895a$var$RepositoryBreadcrumbs;

});
parcelRegister("iOmtv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db1e548e671834d2$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $b4Ivn = parcelRequire("b4Ivn");

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $6rNCX = parcelRequire("6rNCX");

var $3aF04 = parcelRequire("3aF04");

var $8p2GL = parcelRequire("8p2GL");

var $5LVXk = parcelRequire("5LVXk");

var $5zNw4 = parcelRequire("5zNw4");

var $hLl2E = parcelRequire("hLl2E");

var $hTcSj = parcelRequire("hTcSj");
function $db1e548e671834d2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $db1e548e671834d2$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $db1e548e671834d2$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $db1e548e671834d2$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $db1e548e671834d2$var$defaultMaxItems = 8;
var $db1e548e671834d2$var$defaultBreadcrumbsLabel = "Breadcrumbs";
var $db1e548e671834d2$var$defaultEllipsisLabel = "Show more breadcrumbs";
var $db1e548e671834d2$var$toArray = (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Children.toArray;
var $db1e548e671834d2$var$analyticsAttributes = {
    componentName: "breadcrumbs",
    packageName: "@atlaskit/breadcrumbs",
    packageVersion: "11.10.6"
};
var $db1e548e671834d2$var$noop = (0, $8p2GL.default);
var $db1e548e671834d2$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
var $db1e548e671834d2$var$breadcrumbStyles = (0, $avKww.css)({
    display: "flex",
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    flexWrap: "wrap"
});
var $db1e548e671834d2$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(props, ref) {
    var _props$defaultExpande = props.defaultExpanded, defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande, isExpanded = props.isExpanded, _props$isNavigation = props.isNavigation, isNavigation = _props$isNavigation === void 0 ? true : _props$isNavigation, _props$maxItems = props.maxItems, maxItems = _props$maxItems === void 0 ? $db1e548e671834d2$var$defaultMaxItems : _props$maxItems, _props$itemsBeforeCol = props.itemsBeforeCollapse, itemsBeforeCollapse = _props$itemsBeforeCol === void 0 ? 1 : _props$itemsBeforeCol, _props$itemsAfterColl = props.itemsAfterCollapse, itemsAfterCollapse = _props$itemsAfterColl === void 0 ? 1 : _props$itemsAfterColl, _props$children = props.children, children = _props$children === void 0 ? [] : _props$children, testId = props.testId, _props$onExpand = props.onExpand, providedExpanse = _props$onExpand === void 0 ? $db1e548e671834d2$var$noop : _props$onExpand, analyticsContext = props.analyticsContext, _props$mode = props.mode, mode = _props$mode === void 0 ? "light" : _props$mode, _props$label = props.label, label = _props$label === void 0 ? $db1e548e671834d2$var$defaultBreadcrumbsLabel : _props$label, _props$ellipsisLabel = props.ellipsisLabel, ellipsisLabel = _props$ellipsisLabel === void 0 ? $db1e548e671834d2$var$defaultEllipsisLabel : _props$ellipsisLabel;
    var _useState = (0, $9nHZC.useState)(defaultExpanded), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), expanded = _useState2[0], setExpanse = _useState2[1];
    var _useState3 = (0, $9nHZC.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState3, 2), isClickedBySpace = _useState4[0], setExpansionTrigger = _useState4[1];
    var wrapperRef = (0, $9nHZC.useRef)(null);
    var isControlled = typeof isExpanded !== "undefined";
    var isExpansionHandled = providedExpanse !== $db1e548e671834d2$var$noop;
    var shouldExpand = isControlled ? isExpanded : expanded;
    var _getColors = (0, $5zNw4.getColors)(mode), separatorColor = _getColors.separatorColor;
    var focusFirstRevealed = function focusFirstRevealed() {
        if (wrapperRef.current) {
            var listItems = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(wrapperRef.current.querySelectorAll("li"));
            var interactiveElements = listItems.map(function(li) {
                return li.querySelector($db1e548e671834d2$var$interactiveElementSelector);
            });
            var elementToFocus = interactiveElements[itemsBeforeCollapse];
            var firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    };
    (0, $hTcSj.useOnRevealed)(focusFirstRevealed, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    var handleExpansion = (0, $6rNCX.usePlatformLeafEventHandler)($db1e548e671834d2$var$_objectSpread({
        fn: function fn(event, analyticsEvent) {
            if (!isControlled) setExpanse(function(expanded) {
                return !expanded;
            });
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === document.activeElement);
            return providedExpanse(event, analyticsEvent);
        },
        action: "expanded",
        analyticsData: analyticsContext
    }, $db1e548e671834d2$var$analyticsAttributes));
    var renderItemsWithEllipsis = function renderItemsWithEllipsis() {
        var allItems = childrenArray;
        // This defends against someone passing weird data, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        var beforeItems = allItems.slice(0, itemsBeforeCollapse);
        var afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(beforeItems), [
            (0, $avKww.jsx)((0, $hLl2E.default), {
                key: "ellipsis",
                testId: testId && "".concat(testId, "--breadcrumb-ellipsis"),
                onClick: handleExpansion,
                label: ellipsisLabel
            })
        ], (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(afterItems));
    };
    var childrenArray = $db1e548e671834d2$var$toArray(children);
    var shouldDisplayItems = shouldExpand || maxItems && childrenArray.length <= maxItems;
    var breadcrumbsItems = shouldDisplayItems ? childrenArray : renderItemsWithEllipsis();
    var Component = isNavigation ? "nav" : "div";
    return (0, $avKww.jsx)(Component, {
        "aria-label": label,
        ref: (0, $3aF04.default)([
            ref,
            wrapperRef
        ]),
        tabIndex: -1
    }, (0, $avKww.jsx)("ol", {
        "data-testid": testId,
        css: $db1e548e671834d2$var$breadcrumbStyles,
        style: {
            color: separatorColor
        }
    }, breadcrumbsItems));
});
var $db1e548e671834d2$var$Breadcrumbs = /*#__PURE__*/ (0, $9nHZC.memo)(/*#__PURE__*/ (0, $9nHZC.forwardRef)(function(props, ref) {
    return (0, $avKww.jsx)((0, $5LVXk.default).Consumer, null, function(tokens) {
        return (0, $avKww.jsx)($db1e548e671834d2$var$InnerBreadcrumbs, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
            mode: tokens.mode,
            ref: ref
        }));
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$db1e548e671834d2$export$2e2bcd8739ae039 = $db1e548e671834d2$var$Breadcrumbs;

});
parcelRegister("5zNw4", function(module, exports) {

$parcel$export(module.exports, "getColors", function () { return $40f6a18d36c645f7$export$6cee60e8aa85e528; });

var $jp7ng = parcelRequire("jp7ng");
var $40f6a18d36c645f7$var$colorMap = {
    light: {
        textColor: "var(--ds-text-subtlest, ".concat((0, $jp7ng.N200), ")"),
        separatorColor: "var(--ds-text-subtlest, ".concat((0, $jp7ng.N200), ")")
    },
    dark: {
        textColor: "var(--ds-text-subtlest, ".concat((0, $jp7ng.N300), ")"),
        separatorColor: "var(--ds-text-subtlest, ".concat((0, $jp7ng.N300), ")")
    }
};
var $40f6a18d36c645f7$export$6cee60e8aa85e528 = function getColors(mode) {
    return $40f6a18d36c645f7$var$colorMap[mode];
};

});

parcelRegister("hLl2E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cee725ea1c724af4$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $3THTN = parcelRequire("3THTN");

var $8p2GL = parcelRequire("8p2GL");

var $aP6k3 = parcelRequire("aP6k3");
var $cee725ea1c724af4$var$height = (0, $aP6k3.gridSize)() * 3 / (0, $aP6k3.fontSize)();
var $cee725ea1c724af4$var$noop = (0, $8p2GL.default);
var $cee725ea1c724af4$var$itemWrapperStyles = (0, $avKww.css)({
    display: "flex",
    boxSizing: "border-box",
    maxWidth: "100%",
    height: "".concat($cee725ea1c724af4$var$height, "em"),
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    flexDirection: "row",
    lineHeight: "".concat($cee725ea1c724af4$var$height, "em"),
    "&:not(:last-child)::after": {
        width: "var(--ds-space-100, 8px)",
        padding: "var(--ds-space-0, 0px)".concat(" ", "var(--ds-space-100, 8px)"),
        flexShrink: 0,
        content: '"/"',
        textAlign: "center"
    }
});
var $cee725ea1c724af4$var$EllipsisItem = /*#__PURE__*/ (0, $9nHZC.memo)(function(props) {
    var _props$onClick = props.onClick, onClick = _props$onClick === void 0 ? $cee725ea1c724af4$var$noop : _props$onClick, testId = props.testId, label = props.label;
    return (0, $avKww.jsx)("li", {
        css: $cee725ea1c724af4$var$itemWrapperStyles
    }, (0, $avKww.jsx)((0, $3THTN.default), {
        appearance: "subtle-link",
        spacing: "none",
        testId: testId,
        onClick: onClick,
        "aria-label": label
    }, "\u2026"));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cee725ea1c724af4$export$2e2bcd8739ae039 = $cee725ea1c724af4$var$EllipsisItem;

});

parcelRegister("hTcSj", function(module, exports) {

$parcel$export(module.exports, "useOnRevealed", function () { return $d0618f69e5dcdd82$export$e9c4922b2ecf808a; });

var $9nHZC = parcelRequire("9nHZC");

var $iIWPw = parcelRequire("iIWPw");
function $d0618f69e5dcdd82$export$e9c4922b2ecf808a(callback, _ref) {
    var isExpanded = _ref.isExpanded, isDisabled = _ref.isDisabled;
    var prevExtended = (0, $iIWPw.default)(isExpanded);
    (0, $9nHZC.useEffect)(function() {
        var hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
}

});


parcelRegister("cUU4Z", function(module, exports) {

$parcel$export(module.exports, "getRepoOwnerAvatarUrl", function () { return $3de9008b3fd9ec26$export$f537fbc5e2218825; });
$parcel$export(module.exports, "getRepoOwnerName", function () { return $3de9008b3fd9ec26$export$4757a4dcb11856e1; });
$parcel$export(module.exports, "getRepoOwnerUrl", function () { return $3de9008b3fd9ec26$export$d6ab3dd95c71a12; });

var $lIZwG = parcelRequire("lIZwG");
parcelRequire("7fTQu");
var $c4Bvq = parcelRequire("c4Bvq");
const $3de9008b3fd9ec26$export$f537fbc5e2218825 = (repository)=>{
    if (!repository) return undefined;
    if (repository.workspace) return (0, $lIZwG.default)(repository, "workspace.links.avatar.href", undefined);
    return (0, $c4Bvq.getAvatarUrl)(repository.owner);
};
const $3de9008b3fd9ec26$export$4757a4dcb11856e1 = (repository)=>{
    if (!repository) return undefined;
    if (repository.workspace) return repository.workspace.name;
    else if (repository.owner) return (0, $c4Bvq.getName)(repository.owner);
    else {
        var _repository$full_name;
        return ((_repository$full_name = repository.full_name) === null || _repository$full_name === void 0 ? void 0 : _repository$full_name.split("/")[0]) || undefined;
    }
};
const $3de9008b3fd9ec26$export$d6ab3dd95c71a12 = (repository)=>{
    if (!repository) return undefined;
    if (repository.workspace) return (0, $lIZwG.default)(repository, "workspace.links.html.href", undefined);
    return (0, $c4Bvq.getProfileUrl)(repository.owner);
};

});
parcelRegister("7fTQu", function(module, exports) {

$parcel$export(module.exports, "DeletedUserAvatar", function () { return (parcelRequire("72IhL")).default; });
$parcel$export(module.exports, "DeletedUserName", function () { return (parcelRequire("1u8Rx")).default; });
$parcel$export(module.exports, "ProfileClient", function () { return (parcelRequire("chrxx")).default; });
$parcel$export(module.exports, "UnmatchedCommitAuthorAvatar", function () { return (parcelRequire("9aLiF")).default; });
$parcel$export(module.exports, "UnmatchedCommitAuthorName", function () { return (parcelRequire("iQBfK")).default; });
$parcel$export(module.exports, "UserAvatar", function () { return (parcelRequire("cgdUo")).default; });
$parcel$export(module.exports, "UserName", function () { return (parcelRequire("13vgM")).default; });
$parcel$export(module.exports, "UserProfileCardTrigger", function () { return (parcelRequire("ktkU5")).default; });
$parcel$export(module.exports, "getProfileCardActions", function () { return (parcelRequire("ktkU5")).getActions; });
$parcel$export(module.exports, "getAvatarUrl", function () { return (parcelRequire("c4Bvq")).getAvatarUrl; });
$parcel$export(module.exports, "getName", function () { return (parcelRequire("c4Bvq")).getName; });
$parcel$export(module.exports, "getProfileUrl", function () { return (parcelRequire("c4Bvq")).getProfileUrl; });

var $72IhL = parcelRequire("72IhL");

var $1u8Rx = parcelRequire("1u8Rx");

var $chrxx = parcelRequire("chrxx");

var $huKdv = parcelRequire("huKdv");

var $9aLiF = parcelRequire("9aLiF");

var $iQBfK = parcelRequire("iQBfK");

var $cgdUo = parcelRequire("cgdUo");

var $13vgM = parcelRequire("13vgM");

var $ktkU5 = parcelRequire("ktkU5");

var $c4Bvq = parcelRequire("c4Bvq");

var $bJvZh = parcelRequire("bJvZh");

});
parcelRegister("72IhL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c339c9865a7eb56$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $a7iuM = parcelRequire("a7iuM");

var $eR8ER = parcelRequire("eR8ER");

var $fSOMa = parcelRequire("fSOMa");

var $ktkU5 = parcelRequire("ktkU5");

var $c4Bvq = parcelRequire("c4Bvq");
var $2c339c9865a7eb56$export$2e2bcd8739ae039;
$2c339c9865a7eb56$export$2e2bcd8739ae039 = class DeletedUserAvatar extends (0, $9nHZC.PureComponent) {
    render() {
        const { hasProfileCard: hasProfileCard, profileCardPosition: profileCardPosition, profileCardTrigger: profileCardTrigger, renderName: renderName, ...avatarProps } = this.props;
        const avatar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eR8ER.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, avatarProps, {
            renderName: renderName
        }));
        if (!hasProfileCard) {
            const name = renderName((0, $c4Bvq.getName)(undefined));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $a7iuM.default), {
                content: name
            }, avatar);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ktkU5.default), {
            position: profileCardPosition,
            profileClient: (0, $fSOMa.deletedUserProfileClient),
            trigger: profileCardTrigger,
            userId: "null"
        }, avatar);
    }
};
$2c339c9865a7eb56$export$2e2bcd8739ae039.defaultProps = {
    renderName: (name)=>name
};

});
parcelRegister("eR8ER", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33944bdeb1bd90f0$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $2xJU3 = parcelRequire("2xJU3");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $inFLm = parcelRequire("inFLm");

var $c4Bvq = parcelRequire("c4Bvq");
function $33944bdeb1bd90f0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $33944bdeb1bd90f0$var$AvatarContainer = (0, $2xJU3.default)("div", {
    target: "etjipaw0"
})({
    name: "1v0cd8t",
    styles: "line-height:1;"
});
class $33944bdeb1bd90f0$var$BaseUserAvatar extends (0, $9nHZC.PureComponent) {
    render() {
        const { intl: intl, renderName: renderName, user: user, tabIndex: tabIndex, ...avatarProps } = this.props;
        const name = (0, $c4Bvq.getName)(user, intl);
        const displayName = renderName(name);
        const avatarUrl = (0, $c4Bvq.getAvatarUrl)(user);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($33944bdeb1bd90f0$var$AvatarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $inFLm.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, avatarProps, {
            name: displayName,
            src: avatarUrl || undefined,
            tabIndex: tabIndex || 0
        })));
    }
}
var $33944bdeb1bd90f0$export$2e2bcd8739ae039 = (0, $agjvf.injectIntl)($33944bdeb1bd90f0$var$BaseUserAvatar);

});

parcelRegister("fSOMa", function(module, exports) {

$parcel$export(module.exports, "deletedUserProfileClient", function () { return $90499628eba8f9c0$export$3b6902556205e218; });
parcelRequire("9GYuS");
var $buNoC = parcelRequire("buNoC");
var $689He = parcelRequire("689He");
class $90499628eba8f9c0$var$DeletedUserClient extends (0, $689He.default) {
    // @ts-ignore (TS thinks that @atlaskit/profilecard defines this as an instance member property vs. an instance member function)
    makeRequest() {
        return Promise.resolve({
            isBot: false,
            isCurrentUser: false,
            isNotMentionable: true,
            status: "closed"
        });
    }
}
const $90499628eba8f9c0$var$deletedUserProfileConfig = {
    cacheMaxAge: Number.MAX_SAFE_INTEGER,
    url: ""
};
const $90499628eba8f9c0$export$3b6902556205e218 = new (0, $buNoC.default)($90499628eba8f9c0$var$deletedUserProfileConfig, {
    userClient: new $90499628eba8f9c0$var$DeletedUserClient($90499628eba8f9c0$var$deletedUserProfileConfig)
});

});
parcelRegister("9GYuS", function(module, exports) {

$parcel$export(module.exports, "ProfileCardTrigger", function () { return (parcelRequire("4p6QA")).default; });
$parcel$export(module.exports, "ProfileClient", function () { return (parcelRequire("buNoC")).default; });
$parcel$export(module.exports, "TeamProfileClient", function () { return (parcelRequire("eVRiQ")).default; });
$parcel$export(module.exports, "UserProfileClient", function () { return (parcelRequire("689He")).default; });
// Avoid exporting new components in this file as they will affect the bundle size of all consumers
// importing directly from @atlaskit/profilecard.

var $buNoC = parcelRequire("buNoC");

var $eVRiQ = parcelRequire("eVRiQ");

var $689He = parcelRequire("689He");

var $886PR = parcelRequire("886PR");

var $hXXuy = parcelRequire("hXXuy");

var $61ItA = parcelRequire("61ItA");

var $4p6QA = parcelRequire("4p6QA");

var $fajw5 = parcelRequire("fajw5");

var $jYw1e = parcelRequire("jYw1e");

var $3bPcB = parcelRequire("3bPcB");
var $01d22d451b2f82d7$export$2e2bcd8739ae039 = (0, $61ItA.default);

});
parcelRegister("buNoC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85e8d013d0940e45$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $a4QC0 = parcelRequire("a4QC0");

var $dEQSq = parcelRequire("dEQSq");

var $lwpBX = parcelRequire("lwpBX");

var $eVRiQ = parcelRequire("eVRiQ");

var $689He = parcelRequire("689He");
function $85e8d013d0940e45$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $85e8d013d0940e45$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $85e8d013d0940e45$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $85e8d013d0940e45$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $85e8d013d0940e45$var$ProfileCardClient = /*#__PURE__*/ function() {
    function ProfileCardClient(config, clients) {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ProfileCardClient);
        this.userClient = (clients === null || clients === void 0 ? void 0 : clients.userClient) || new (0, $689He.default)(config);
        this.teamClient = (clients === null || clients === void 0 ? void 0 : clients.teamClient) || new (0, $eVRiQ.default)(config);
        this.tcClient = $85e8d013d0940e45$var$maybeCreateTeamCentralClient(config, clients);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ProfileCardClient, [
        {
            key: "flushCache",
            value: function flushCache() {
                var _this$tcClient;
                this.userClient.flushCache();
                this.teamClient.flushCache();
                (_this$tcClient = this.tcClient) === null || _this$tcClient === void 0 || _this$tcClient.flushCache();
            }
        },
        {
            key: "getProfile",
            value: function getProfile(cloudId, userId, analytics) {
                return this.userClient.getProfile(cloudId, userId, analytics);
            }
        },
        {
            key: "getTeamProfile",
            value: function getTeamProfile(teamId, orgId, analytics) {
                return this.teamClient.getProfile(teamId, orgId, analytics);
            }
        },
        {
            key: "getReportingLines",
            value: function getReportingLines(userId) {
                var _this$tcClient2;
                return ((_this$tcClient2 = this.tcClient) === null || _this$tcClient2 === void 0 ? void 0 : _this$tcClient2.getReportingLines(userId)) || Promise.resolve({
                    managers: [],
                    reports: []
                });
            }
        },
        {
            key: "getTeamCentralBaseUrl",
            value: function getTeamCentralBaseUrl() {
                var _this$tcClient3;
                return (_this$tcClient3 = this.tcClient) === null || _this$tcClient3 === void 0 ? void 0 : _this$tcClient3.options.teamCentralBaseUrl;
            }
        },
        {
            key: "shouldShowGiveKudos",
            value: function shouldShowGiveKudos() {
                if (!this.tcClient || !this.getTeamCentralBaseUrl()) return Promise.resolve(false);
                return this.tcClient.checkWorkspaceExists();
            }
        }
    ]);
    return ProfileCardClient;
}();
function $85e8d013d0940e45$var$maybeCreateTeamCentralClient(config, clients) {
    if ((0, $dEQSq.getBooleanFF)("platform.profilecard-disable-team-central-client-in-fedramp_ilnm7")) {
        if ((0, $a4QC0.isFedRamp)()) return undefined;
    }
    if (clients !== null && clients !== void 0 && clients.teamCentralClient) return clients.teamCentralClient;
    var teamCentralUrl = config.teamCentralUrl;
    return teamCentralUrl ? new (0, $lwpBX.default)($85e8d013d0940e45$var$_objectSpread($85e8d013d0940e45$var$_objectSpread({}, config), {}, {
        teamCentralUrl: teamCentralUrl
    })) : undefined;
}
var $85e8d013d0940e45$export$2e2bcd8739ae039 = $85e8d013d0940e45$var$ProfileCardClient;

});
parcelRegister("a4QC0", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", function () { return $756316c14b88bd2e$export$64d6499adf9b2e51; });

var $bq62h = parcelRequire("bq62h");
function $756316c14b88bd2e$export$64d6499adf9b2e51() {
    var _globalThis$location;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = globalThis.MICROS_PERIMETER || globalThis.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $bq62h.FEDRAMP_MODERATE);
    var matches = (_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 || (_globalThis$location = _globalThis$location.hostname) === null || _globalThis$location === void 0 ? void 0 : _globalThis$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("bq62h", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", function () { return $8506cdfe2d858edb$export$ce553301d55c2fd8; });
$parcel$export(module.exports, "COMMERCIAL", function () { return $8506cdfe2d858edb$export$f005e2e9f707cb5f; });
$parcel$export(module.exports, "FEDRAMP_FEDEX", function () { return $8506cdfe2d858edb$export$bd6b5a7802d76127; });
$parcel$export(module.exports, "STAGING", function () { return $8506cdfe2d858edb$export$a739cd5aac835909; });
$parcel$export(module.exports, "PRODUCTION", function () { return $8506cdfe2d858edb$export$42dd0cdd351a4a9; });
$parcel$export(module.exports, "DEV", function () { return $8506cdfe2d858edb$export$404582bc18fe4d9e; });
var $8506cdfe2d858edb$export$ce553301d55c2fd8 = "fedramp-moderate";
var $8506cdfe2d858edb$export$f005e2e9f707cb5f = "commercial";
var $8506cdfe2d858edb$export$bd6b5a7802d76127 = "fedramp-fedex";
var $8506cdfe2d858edb$export$a739cd5aac835909 = "stg";
var $8506cdfe2d858edb$export$42dd0cdd351a4a9 = "prod";
var $8506cdfe2d858edb$export$404582bc18fe4d9e = "dev";

});


parcelRegister("lwpBX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fab074015d5e3f93$export$2e2bcd8739ae039; });

var $4mVfk = parcelRequire("4mVfk");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $8DpVo = parcelRequire("8DpVo");

var $dEpNy = parcelRequire("dEpNy");

var $fARti = parcelRequire("fARti");
function $fab074015d5e3f93$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $fab074015d5e3f93$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $fab074015d5e3f93$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($fab074015d5e3f93$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $fab074015d5e3f93$export$1862ef0c3880ca8d = function buildReportingLinesQuery(aaid) {
    return {
        query: "\n    fragment ReportingLinesUserPII on UserPII {\n      name\n      picture\n    }\n\n    fragment ReportingLinesUserFragment on ReportingLinesUser {\n      accountIdentifier\n      identifierType\n      pii {\n        ...ReportingLinesUserPII\n      }\n    }\n\n    query ReportingLines($aaid: String) {\n      reportingLines(aaidOrHash: $aaid) {\n        managers {\n          ...ReportingLinesUserFragment\n        }\n        reports {\n          ...ReportingLinesUserFragment\n        }\n      }\n    }\n  ",
        variables: {
            aaid: aaid
        }
    };
};
var $fab074015d5e3f93$export$f8c05b360e45cd0 = function buildCheckFeatureFlagQuery(featureKey, context) {
    return {
        query: "\n    query isFeatureKeyEnabled($featureKey: String!, $context: [IsFeatureEnabledContextInput]) {\n      isFeatureEnabled(featureKey: $featureKey, context: $context) {\n        enabled\n      }\n    }\n  ",
        variables: {
            featureKey: featureKey,
            context: context || []
        }
    };
};
function $fab074015d5e3f93$var$hasTCWorkspace(config) {
    return config.cloudId ? fetch("/gateway/api/watermelon/organization/containsAnyWorkspace?cloudId=".concat(config.cloudId)).then(function(res) {
        return !res || res && res.ok;
    }) : Promise.resolve(false);
}
var $fab074015d5e3f93$var$isTCReadyPromiseMap = new Map();
var $fab074015d5e3f93$var$TeamCentralCardClient = /*#__PURE__*/ function(_CachingClient) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(TeamCentralCardClient, _CachingClient);
    var _super = $fab074015d5e3f93$var$_createSuper(TeamCentralCardClient);
    /**
   * Simple circuit breaker to avoid making unnecessary calls to Team Central on auth failures
   * This is to handle the case where products may have provided teamCentralUrl, but the site itself
   * doesn't actually have any TC product.
   *
   * There's currently no way to reset this circuit breaker, but that's fine. This is meant to
   * catch a pretty specific edge case.
   */ function TeamCentralCardClient(options) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, TeamCentralCardClient);
        _this = _super.call(this, options);
        _this.options = options;
        _this.bypassOnFailure = false;
        _this.featureFlagKeys = new Map();
        _this.isTCReadyPromise = _this.createTcReadyPromise(options);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(TeamCentralCardClient, [
        {
            key: "createTcReadyPromise",
            value: function createTcReadyPromise(config) {
                if (config.cloudId) {
                    var promise = $fab074015d5e3f93$var$isTCReadyPromiseMap.get(config.cloudId);
                    if (!promise) {
                        promise = $fab074015d5e3f93$var$hasTCWorkspace(config);
                        $fab074015d5e3f93$var$isTCReadyPromiseMap.set(config.cloudId, promise);
                    }
                    return promise;
                }
                return Promise.resolve(true);
            }
        },
        {
            key: "makeFeatureFlagCheckRequest",
            value: function() {
                var _makeFeatureFlagCheckRequest = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee(featureKey, context) {
                    var query, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (this.options.teamCentralUrl) {
                                    _context.next = 2;
                                    break;
                                }
                                throw new Error("options.teamCentralUrl is a required parameter for retrieving Team Central data");
                            case 2:
                                query = $fab074015d5e3f93$export$f8c05b360e45cd0(featureKey, context);
                                _context.next = 5;
                                return (0, $fARti.directoryGraphqlQuery)("".concat(this.options.teamCentralUrl, "?operationName=isFeatureKeyEnabled"), query);
                            case 5:
                                response = _context.sent;
                                return _context.abrupt("return", response.isFeatureEnabled.enabled);
                            case 7:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function makeFeatureFlagCheckRequest(_x, _x2) {
                    return _makeFeatureFlagCheckRequest.apply(this, arguments);
                }
                return makeFeatureFlagCheckRequest;
            }()
        },
        {
            key: "makeRequest",
            value: function() {
                var _makeRequest = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee2(userId) {
                    var query, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                if (this.options.teamCentralUrl) {
                                    _context2.next = 2;
                                    break;
                                }
                                throw new Error("options.teamCentralUrl is a required parameter for retrieving Team Central data");
                            case 2:
                                query = $fab074015d5e3f93$export$1862ef0c3880ca8d(userId);
                                _context2.next = 5;
                                return (0, $fARti.directoryGraphqlQuery)("".concat(this.options.teamCentralUrl, "?operationName=ReportingLines"), query);
                            case 5:
                                response = _context2.sent;
                                return _context2.abrupt("return", response.reportingLines);
                            case 7:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function makeRequest(_x3) {
                    return _makeRequest.apply(this, arguments);
                }
                return makeRequest;
            }()
        },
        {
            key: "getReportingLines",
            value: function getReportingLines(userId) {
                var _this2 = this;
                return this.isTCReadyPromise.then(function(workSpaceExists) {
                    if (workSpaceExists) {
                        if (!userId) return Promise.reject(new Error("userId missing"));
                        var cache = _this2.getCachedProfile(userId);
                        if (cache) return Promise.resolve(cache);
                        if (_this2.bypassOnFailure) return Promise.resolve({});
                        return new Promise(function(resolve) {
                            _this2.makeRequest(userId).then(function(data) {
                                var enhancedData = {
                                    managers: _this2.filterReportingLinesUser(data === null || data === void 0 ? void 0 : data.managers),
                                    reports: _this2.filterReportingLinesUser(data === null || data === void 0 ? void 0 : data.reports)
                                };
                                if (_this2.cache) _this2.setCachedProfile(userId, enhancedData);
                                resolve(enhancedData);
                            }).catch(function(error) {
                                if ((error === null || error === void 0 ? void 0 : error.status) === 401 || (error === null || error === void 0 ? void 0 : error.status) === 403) // Trigger circuit breaker
                                _this2.bypassOnFailure = true;
                                /**
               * Reporting lines aren't part of the critical path of profile card.
               * Just resolve with empty values instead of bubbling up the error.
               */ resolve({});
                            });
                        });
                    }
                    return Promise.resolve({
                        managers: [],
                        reports: []
                    });
                }, function() {
                    return Promise.resolve({
                        managers: [],
                        reports: []
                    });
                });
            }
        },
        {
            key: "getFlagEnabled",
            value: function getFlagEnabled(featureKey, productIdentifier) {
                var _this3 = this;
                return this.isTCReadyPromise.then(function(workSpaceExists) {
                    if (workSpaceExists) {
                        if (!featureKey) return Promise.reject(new Error("featureKey missing"));
                        if (_this3.featureFlagKeys.has(featureKey)) return Promise.resolve(_this3.featureFlagKeys.get(featureKey));
                        if (_this3.bypassOnFailure) return Promise.resolve(false);
                        var context = [
                            {
                                key: "productIdentifier",
                                value: productIdentifier || "unset"
                            }
                        ];
                        return new Promise(function(resolve) {
                            _this3.makeFeatureFlagCheckRequest(featureKey, context).then(function(enabled) {
                                _this3.featureFlagKeys.set(featureKey, enabled);
                                resolve(enabled);
                            }).catch(function(error) {
                                if ((error === null || error === void 0 ? void 0 : error.status) === 401 || (error === null || error === void 0 ? void 0 : error.status) === 403) // Trigger circuit breaker
                                _this3.bypassOnFailure = true;
                                resolve(false);
                            });
                        });
                    }
                    return Promise.resolve(false);
                }, function() {
                    return Promise.resolve(false);
                });
            }
        },
        {
            key: "checkWorkspaceExists",
            value: function checkWorkspaceExists() {
                return this.isTCReadyPromise.then(function(workSpaceExists) {
                    if (workSpaceExists) return Promise.resolve(true);
                    return Promise.resolve(false);
                }, function() {
                    return Promise.resolve(false);
                });
            }
        },
        {
            key: "filterReportingLinesUser",
            value: function filterReportingLinesUser() {
                var users = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                return users.filter(function(user) {
                    return user.identifierType === "ATLASSIAN_ID";
                });
            }
        }
    ]);
    return TeamCentralCardClient;
}((0, $dEpNy.default));
var $fab074015d5e3f93$export$2e2bcd8739ae039 = $fab074015d5e3f93$var$TeamCentralCardClient;

});
parcelRegister("dEpNy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f0305cb78caa787$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $rE472 = parcelRequire("rE472");
function $9f0305cb78caa787$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9f0305cb78caa787$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9f0305cb78caa787$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9f0305cb78caa787$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9f0305cb78caa787$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function CachingClient(config) {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, CachingClient);
        var defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = $9f0305cb78caa787$var$_objectSpread($9f0305cb78caa787$var$_objectSpread({}, defaults), config);
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $rE472.LRUMap)(this.config.cacheSize);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(CachingClient, [
        {
            key: "setCachedProfile",
            value: function setCachedProfile(cacheIdentifier, profile) {
                this.cache && this.cache.set(cacheIdentifier, {
                    expire: Date.now() + this.config.cacheMaxAge,
                    profile: profile
                });
            }
        },
        {
            key: "getCachedProfile",
            value: function getCachedProfile(cacheIdentifier) {
                if (!this.cache) return null;
                var cached = this.cache.get(cacheIdentifier);
                if (!cached) return null;
                if (cached.expire < Date.now()) {
                    this.cache.delete(cacheIdentifier);
                    return null;
                }
                // Extend expiry "date"
                this.setCachedProfile(cacheIdentifier, cached.profile);
                return cached.profile;
            }
        },
        {
            key: "flushCache",
            value: function flushCache() {
                if (this.cache) this.cache.clear();
            }
        }
    ]);
    return CachingClient;
}();

});

parcelRegister("fARti", function(module, exports) {

$parcel$export(module.exports, "directoryGraphqlQuery", function () { return $b5a3b22768246f9a$export$a5b5995619d4fe36; });
$parcel$export(module.exports, "AGGQuery", function () { return $b5a3b22768246f9a$export$a14afb5f82fe705; });

var $4mVfk = parcelRequire("4mVfk");

var $8DpVo = parcelRequire("8DpVo");

var $6byQU = parcelRequire("6byQU");

var $hEoBh = parcelRequire("hEoBh");
var $b5a3b22768246f9a$var$buildHeaders = function buildHeaders() {
    var headers = new Headers();
    headers.append("Content-Type", "application/json");
    return headers;
};
var $b5a3b22768246f9a$var$id = function id(headers) {
    return headers;
};
function $b5a3b22768246f9a$export$a5b5995619d4fe36(_x, _x2) {
    return $b5a3b22768246f9a$var$_directoryGraphqlQuery.apply(this, arguments);
}
/**
 * @param {string} serviceUrl - GraphQL service endpoint
 * @param {Query} query - GraphQL query
 * @param {HeaderProcessor} processHeaders - a function to add extra headers to the request
 */ function $b5a3b22768246f9a$var$_directoryGraphqlQuery() {
    $b5a3b22768246f9a$var$_directoryGraphqlQuery = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee(serviceUrl, query) {
        var processHeaders, _args = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    processHeaders = _args.length > 2 && _args[2] !== undefined ? _args[2] : $b5a3b22768246f9a$var$id;
                    return _context.abrupt("return", $b5a3b22768246f9a$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $hEoBh.handleDirectoryGraphQLErrors)));
                case 2:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $b5a3b22768246f9a$var$_directoryGraphqlQuery.apply(this, arguments);
}
function $b5a3b22768246f9a$export$a14afb5f82fe705(_x3, _x4) {
    return $b5a3b22768246f9a$var$_AGGQuery.apply(this, arguments);
}
function $b5a3b22768246f9a$var$_AGGQuery() {
    $b5a3b22768246f9a$var$_AGGQuery = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee2(serviceUrl, query) {
        var processHeaders, _args2 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    processHeaders = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : $b5a3b22768246f9a$var$id;
                    return _context2.abrupt("return", $b5a3b22768246f9a$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $hEoBh.handleAGGErrors)));
                case 2:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $b5a3b22768246f9a$var$_AGGQuery.apply(this, arguments);
}
function $b5a3b22768246f9a$var$graphQLQuery(_x5, _x6) {
    return $b5a3b22768246f9a$var$_graphQLQuery.apply(this, arguments);
}
function $b5a3b22768246f9a$var$_graphQLQuery() {
    $b5a3b22768246f9a$var$_graphQLQuery = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee3(serviceUrl, query) {
        var _response$headers;
        var processHeaders, handleErrors, headers, response, traceIdFromHeaders, json, _json$extensions$gate, _json$extensions, _args3 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    processHeaders = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : $b5a3b22768246f9a$var$id;
                    handleErrors = _args3.length > 3 ? _args3[3] : undefined;
                    headers = processHeaders($b5a3b22768246f9a$var$buildHeaders());
                    _context3.next = 5;
                    return fetch(new Request(serviceUrl, {
                        method: "POST",
                        credentials: "include",
                        mode: "cors",
                        headers: headers,
                        body: JSON.stringify(query)
                    }));
                case 5:
                    response = _context3.sent;
                    traceIdFromHeaders = response === null || response === void 0 || (_response$headers = response.headers) === null || _response$headers === void 0 ? void 0 : _response$headers.get("atl-traceid");
                    if (response.ok) {
                        _context3.next = 9;
                        break;
                    }
                    throw new (0, $6byQU.HttpError)(response.status, response.statusText, traceIdFromHeaders);
                case 9:
                    _context3.next = 11;
                    return response.json();
                case 11:
                    json = _context3.sent;
                    if (json.errors) handleErrors(json.errors, (_json$extensions$gate = (_json$extensions = json.extensions) === null || _json$extensions === void 0 || (_json$extensions = _json$extensions.gateway) === null || _json$extensions === void 0 ? void 0 : _json$extensions.request_id) !== null && _json$extensions$gate !== void 0 ? _json$extensions$gate : traceIdFromHeaders);
                    return _context3.abrupt("return", json.data);
                case 14:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return $b5a3b22768246f9a$var$_graphQLQuery.apply(this, arguments);
}

});
parcelRegister("6byQU", function(module, exports) {

$parcel$export(module.exports, "HttpError", function () { return $480ece1c50d351ee$export$65bd6083489bd8bb; });
$parcel$export(module.exports, "DirectoryGraphQLError", function () { return $480ece1c50d351ee$export$c1e4d0de940c06a2; });
$parcel$export(module.exports, "DirectoryGraphQLErrors", function () { return $480ece1c50d351ee$export$5a5fbfed34a590a1; });
$parcel$export(module.exports, "AGGError", function () { return $480ece1c50d351ee$export$4a696f048dcc929; });
$parcel$export(module.exports, "AGGErrors", function () { return $480ece1c50d351ee$export$60d8267243755b9c; });

var $lOQkO = parcelRequire("lOQkO");

var $eVDe4 = parcelRequire("eVDe4");

var $uqRmf = parcelRequire("uqRmf");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $6FnrE = parcelRequire("6FnrE");
var $480ece1c50d351ee$var$_excluded = [
    "errorNumber"
], $480ece1c50d351ee$var$_excluded2 = [
    "statusCode",
    "errorType",
    "classification"
];
function $480ece1c50d351ee$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $480ece1c50d351ee$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $480ece1c50d351ee$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($480ece1c50d351ee$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $480ece1c50d351ee$export$65bd6083489bd8bb = /*#__PURE__*/ function(_Error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(HttpError, _Error);
    var _super = $480ece1c50d351ee$var$_createSuper(HttpError);
    function HttpError(code, reason, traceId) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, HttpError);
        _this = _super.call(this, reason);
        _this.code = code;
        _this.traceId = traceId;
        return _this;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(HttpError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6FnrE)))(Error));
var $480ece1c50d351ee$export$c1e4d0de940c06a2 = /*#__PURE__*/ function(_Error2) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(DirectoryGraphQLError, _Error2);
    var _super2 = $480ece1c50d351ee$var$_createSuper(DirectoryGraphQLError);
    function DirectoryGraphQLError(message, category, type) {
        var _this2;
        var extensions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var path = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, DirectoryGraphQLError);
        _this2 = _super2.call(this, message);
        _this2.category = category;
        _this2.type = type;
        _this2.path = path.join(".");
        var errorNumber = extensions.errorNumber, unknownExtension = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(extensions, $480ece1c50d351ee$var$_excluded);
        _this2.errorNumber = extensions.errorNumber;
        _this2.extensions = unknownExtension;
        return _this2;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(DirectoryGraphQLError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6FnrE)))(Error));
var $480ece1c50d351ee$export$5a5fbfed34a590a1 = /*#__PURE__*/ function(_Error3) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(DirectoryGraphQLErrors, _Error3);
    var _super3 = $480ece1c50d351ee$var$_createSuper(DirectoryGraphQLErrors);
    function DirectoryGraphQLErrors(errors, traceId) {
        var _this3;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, DirectoryGraphQLErrors);
        _this3 = _super3.call(this, "DirectoryGraphQLErrors");
        _this3.traceId = traceId;
        if (Array.isArray(errors)) _this3.errors = errors.map(function(error) {
            return new $480ece1c50d351ee$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path);
        });
        else _this3.errors = [];
        return _this3;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(DirectoryGraphQLErrors);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6FnrE)))(Error));
var $480ece1c50d351ee$export$4a696f048dcc929 = /*#__PURE__*/ function(_Error4) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(AGGError, _Error4);
    var _super4 = $480ece1c50d351ee$var$_createSuper(AGGError);
    function AGGError(message, extensions) {
        var _this4;
        var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AGGError);
        _this4 = _super4.call(this, message);
        _this4.path = path === null || path === void 0 ? void 0 : path.join(".");
        var statusCode = extensions.statusCode, errorType = extensions.errorType, classification = extensions.classification, unknownExtension = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(extensions, $480ece1c50d351ee$var$_excluded2);
        _this4.statusCode = statusCode;
        _this4.errorType = errorType;
        _this4.classification = classification;
        _this4.extensions = unknownExtension;
        return _this4;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AGGError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6FnrE)))(Error));
var $480ece1c50d351ee$export$60d8267243755b9c = /*#__PURE__*/ function(_Error5) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(AGGErrors, _Error5);
    var _super5 = $480ece1c50d351ee$var$_createSuper(AGGErrors);
    function AGGErrors(errors, traceId) {
        var _this5;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AGGErrors);
        _this5 = _super5.call(this, "AGGErrors");
        _this5.traceId = traceId;
        if (Array.isArray(errors)) _this5.errors = errors.map(function(error) {
            return new $480ece1c50d351ee$export$4a696f048dcc929(error.message, error.extensions, error.path);
        });
        else _this5.errors = [];
        return _this5;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AGGErrors);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6FnrE)))(Error));

});

parcelRegister("hEoBh", function(module, exports) {

$parcel$export(module.exports, "getErrorAttributes", function () { return $cd994136e8a83650$export$6ad9e7706a4ee0f8; });
$parcel$export(module.exports, "handleDirectoryGraphQLErrors", function () { return $cd994136e8a83650$export$7642af465ceb7f05; });
$parcel$export(module.exports, "handleAGGErrors", function () { return $cd994136e8a83650$export$d9ad65d422ee3f8c; });

var $6byQU = parcelRequire("6byQU");
var $cd994136e8a83650$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    "NotPermitted",
    "Gone",
    "IdentityUserNotFoundError"
];
var $cd994136e8a83650$var$IGNORE_ERROR_TYPES_AGG = [
    "IdentityUserNotFoundError",
    "TEAMS_FORBIDDEN",
    "TEAMS_TEAM_DELETED"
];
var $cd994136e8a83650$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    "Gone"
];
function $cd994136e8a83650$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $6byQU.DirectoryGraphQLError)) return !!error && $cd994136e8a83650$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $6byQU.AGGError)) return !!error.errorType && $cd994136e8a83650$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $cd994136e8a83650$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
var $cd994136e8a83650$export$6ad9e7706a4ee0f8 = function getErrorAttributes(error) {
    if (error instanceof (0, $6byQU.DirectoryGraphQLErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map(getErrorAttributes),
        isSLOFailure: !error.errors.every($cd994136e8a83650$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $6byQU.DirectoryGraphQLError)) return {
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber,
        isSLOFailure: !$cd994136e8a83650$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $6byQU.AGGErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map(getErrorAttributes),
        isSLOFailure: !error.errors.every($cd994136e8a83650$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $6byQU.AGGError)) return {
        errorMessage: error.message,
        errorType: error.errorType,
        errorStatusCode: error.statusCode,
        isSLOFailure: !$cd994136e8a83650$var$isIgnoredError(error),
        errorCategory: error.classification
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith("Unable to fetch user:")) {
            if (error.hasOwnProperty("cause")) {
                var causeError = error.cause;
                if (causeError instanceof (0, $6byQU.DirectoryGraphQLErrors) || causeError instanceof (0, $6byQU.AGGErrors)) return getErrorAttributes(causeError);
            }
            return {
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        errorMessage: "Unknown error",
        isSLOFailure: true
    };
};
var $cd994136e8a83650$export$7642af465ceb7f05 = function handleDirectoryGraphQLErrors(errors, traceId) {
    throw new (0, $6byQU.DirectoryGraphQLErrors)(errors, traceId);
};
var $cd994136e8a83650$export$d9ad65d422ee3f8c = function handleAGGErrors(errors, traceId) {
    throw new (0, $6byQU.AGGErrors)(errors, traceId);
};

});



parcelRegister("eVRiQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adefbc664a203df6$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $18aOe = parcelRequire("18aOe");

var $94uiW = parcelRequire("94uiW");

var $dEpNy = parcelRequire("dEpNy");

var $hEoBh = parcelRequire("hEoBh");

var $6S0pp = parcelRequire("6S0pp");
function $adefbc664a203df6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $adefbc664a203df6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $adefbc664a203df6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $adefbc664a203df6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $adefbc664a203df6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $adefbc664a203df6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $adefbc664a203df6$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($adefbc664a203df6$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $adefbc664a203df6$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CachingClient) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(TeamProfileCardClient, _CachingClient);
    var _super = $adefbc664a203df6$var$_createSuper(TeamProfileCardClient);
    function TeamProfileCardClient(options) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, TeamProfileCardClient);
        _this = _super.call(this, options);
        _this.options = options;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(TeamProfileCardClient, [
        {
            key: "makeRequest",
            value: function makeRequest(teamId, _orgId) {
                if (!this.options.gatewayGraphqlUrl) throw new Error("Trying to fetch via gateway with no specified config.gatewayGraphqlUrl");
                return (0, $6S0pp.getTeamFromAGG)(this.options.gatewayGraphqlUrl, teamId, this.options.cloudId);
            }
        },
        {
            key: "getProfile",
            value: function getProfile(teamId, orgId, analytics) {
                var _this2 = this;
                if (!teamId) return Promise.reject(new Error("teamId is missing"));
                var cache = this.getCachedProfile(teamId);
                if (cache) return Promise.resolve(cache);
                return new Promise(function(resolve, reject) {
                    var startTime = (0, $94uiW.getPageTime)();
                    if (analytics) analytics((0, $18aOe.teamRequestAnalytics)("triggered"));
                    _this2.makeRequest(teamId, orgId).then(function(data) {
                        if (_this2.cache) _this2.setCachedProfile(teamId, data);
                        if (analytics) analytics((0, $18aOe.teamRequestAnalytics)("succeeded", {
                            duration: (0, $94uiW.getPageTime)() - startTime,
                            gateway: true
                        }));
                        resolve(data);
                    }).catch(function(error) {
                        if (analytics) analytics((0, $18aOe.teamRequestAnalytics)("failed", $adefbc664a203df6$var$_objectSpread($adefbc664a203df6$var$_objectSpread({
                            duration: (0, $94uiW.getPageTime)() - startTime
                        }, (0, $hEoBh.getErrorAttributes)(error)), {}, {
                            gateway: true
                        })));
                        reject(error);
                    });
                });
            }
        }
    ]);
    return TeamProfileCardClient;
}((0, $dEpNy.default));

});
parcelRegister("18aOe", function(module, exports) {

$parcel$export(module.exports, "fireEvent", function () { return $0d2eec45c920d329$export$43835e9acf248a15; });
$parcel$export(module.exports, "cardTriggered", function () { return $0d2eec45c920d329$export$d50ab8a3b6975c; });
$parcel$export(module.exports, "teamRequestAnalytics", function () { return $0d2eec45c920d329$export$c9b0e37b229a297b; });
$parcel$export(module.exports, "userRequestAnalytics", function () { return $0d2eec45c920d329$export$12dae48763368ac9; });
$parcel$export(module.exports, "profileCardRendered", function () { return $0d2eec45c920d329$export$41816a317479160b; });
$parcel$export(module.exports, "actionClicked", function () { return $0d2eec45c920d329$export$fdcd134fbeb1f921; });
$parcel$export(module.exports, "reportingLinesClicked", function () { return $0d2eec45c920d329$export$93260987012593be; });
$parcel$export(module.exports, "moreActionsClicked", function () { return $0d2eec45c920d329$export$79befd155063a6a7; });
$parcel$export(module.exports, "teamAvatarClicked", function () { return $0d2eec45c920d329$export$2703289b35687fde; });
$parcel$export(module.exports, "moreMembersClicked", function () { return $0d2eec45c920d329$export$b4411a7661cf2d3f; });
$parcel$export(module.exports, "errorRetryClicked", function () { return $0d2eec45c920d329$export$c86679da702d560e; });

var $kFnE9 = parcelRequire("kFnE9");

var $94uiW = parcelRequire("94uiW");
function $0d2eec45c920d329$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0d2eec45c920d329$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0d2eec45c920d329$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0d2eec45c920d329$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/** Below lines are copied from teams common analytics */ var $0d2eec45c920d329$var$ANALYTICS_CHANNEL = "peopleTeams";
var $0d2eec45c920d329$var$runItLater = function runItLater(cb) {
    var requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === "function") return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === "function") return window.requestAnimationFrame(cb);
    return function() {
        return setTimeout(cb);
    };
};
var $0d2eec45c920d329$export$43835e9acf248a15 = function fireEvent(createAnalyticsEvent, body) {
    if (!createAnalyticsEvent) return;
    $0d2eec45c920d329$var$runItLater(function() {
        createAnalyticsEvent(body).fire($0d2eec45c920d329$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ var $0d2eec45c920d329$var$TEAM_SUBJECT = "teamProfileCard";
var $0d2eec45c920d329$var$USER_SUBJECT = "profilecard";
var $0d2eec45c920d329$var$createEvent = function createEvent(eventType, action, actionSubject, actionSubjectId) {
    var attributes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    return {
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: $0d2eec45c920d329$var$_objectSpread($0d2eec45c920d329$var$_objectSpread({
            packageName: "@atlaskit/profilecard",
            packageVersion: "19.15.1"
        }, attributes), {}, {
            firedAt: Math.round((0, $94uiW.getPageTime)())
        })
    };
};
var $0d2eec45c920d329$export$d50ab8a3b6975c = function cardTriggered(type, method) {
    return $0d2eec45c920d329$var$createEvent("ui", "triggered", type === "user" ? $0d2eec45c920d329$var$USER_SUBJECT : $0d2eec45c920d329$var$TEAM_SUBJECT, undefined, {
        method: method
    });
};
var $0d2eec45c920d329$export$c9b0e37b229a297b = function teamRequestAnalytics(action, attributes) {
    return $0d2eec45c920d329$var$createEvent("operational", action, $0d2eec45c920d329$var$TEAM_SUBJECT, "request", attributes);
};
var $0d2eec45c920d329$export$12dae48763368ac9 = function userRequestAnalytics(action, attributes) {
    return $0d2eec45c920d329$var$createEvent("operational", action, $0d2eec45c920d329$var$USER_SUBJECT, "request", attributes);
};
var $0d2eec45c920d329$export$41816a317479160b = function profileCardRendered(type, actionSubjectId, attributes) {
    return $0d2eec45c920d329$var$createEvent("ui", "rendered", type === "user" ? $0d2eec45c920d329$var$USER_SUBJECT : $0d2eec45c920d329$var$TEAM_SUBJECT, actionSubjectId, attributes);
};
var $0d2eec45c920d329$export$fdcd134fbeb1f921 = function actionClicked(type, attributes) {
    return $0d2eec45c920d329$var$createEvent("ui", "clicked", type === "user" ? $0d2eec45c920d329$var$USER_SUBJECT : $0d2eec45c920d329$var$TEAM_SUBJECT, "action", attributes);
};
var $0d2eec45c920d329$export$93260987012593be = function reportingLinesClicked(attributes) {
    return $0d2eec45c920d329$var$createEvent("ui", "clicked", $0d2eec45c920d329$var$USER_SUBJECT, "reportingLines", attributes);
};
var $0d2eec45c920d329$export$79befd155063a6a7 = function moreActionsClicked(type, attributes) {
    return $0d2eec45c920d329$var$createEvent("ui", "clicked", type === "user" ? $0d2eec45c920d329$var$USER_SUBJECT : $0d2eec45c920d329$var$TEAM_SUBJECT, "moreActions", attributes);
};
var $0d2eec45c920d329$export$2703289b35687fde = function teamAvatarClicked(attributes) {
    return $0d2eec45c920d329$var$createEvent("ui", "clicked", $0d2eec45c920d329$var$TEAM_SUBJECT, "avatar", attributes);
};
var $0d2eec45c920d329$export$b4411a7661cf2d3f = function moreMembersClicked(attributes) {
    return $0d2eec45c920d329$var$createEvent("ui", "clicked", $0d2eec45c920d329$var$TEAM_SUBJECT, "moreMembers", attributes);
};
var $0d2eec45c920d329$export$c86679da702d560e = function errorRetryClicked(attributes) {
    return $0d2eec45c920d329$var$createEvent("ui", "clicked", $0d2eec45c920d329$var$TEAM_SUBJECT, "errorRetry", attributes);
};

});
parcelRegister("94uiW", function(module, exports) {

$parcel$export(module.exports, "getPageTime", function () { return $69abfe9dc14c7f3e$export$e9faea7c41053334; });
var $69abfe9dc14c7f3e$var$isPerformanceAvailable = function isPerformanceAvailable() {
    return typeof window !== "undefined" && "performance" in window && !!performance.now;
};
var $69abfe9dc14c7f3e$var$performanceAvailable = $69abfe9dc14c7f3e$var$isPerformanceAvailable();
var $69abfe9dc14c7f3e$var$initialPageTime = Date.now();
var $69abfe9dc14c7f3e$export$e9faea7c41053334 = function getPageTime() {
    if ($69abfe9dc14c7f3e$var$performanceAvailable) return performance.now();
    return Date.now() - $69abfe9dc14c7f3e$var$initialPageTime;
};

});


parcelRegister("6S0pp", function(module, exports) {

$parcel$export(module.exports, "getTeamFromAGG", function () { return $50081a64a1a094af$export$26a8aad0c7182dd6; });

var $4mVfk = parcelRequire("4mVfk");

var $kFnE9 = parcelRequire("kFnE9");

var $8DpVo = parcelRequire("8DpVo");

var $fARti = parcelRequire("fARti");
function $50081a64a1a094af$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $50081a64a1a094af$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $50081a64a1a094af$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $50081a64a1a094af$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $50081a64a1a094af$export$5816a09dbb711691 = function extractIdFromAri(ari) {
    var slashPos = ari.indexOf("/");
    var id = ari.slice(slashPos + 1);
    return id;
};
var $50081a64a1a094af$export$681597d03c8a0fd2 = function idToAri(teamId) {
    return "ari:cloud:identity::team/".concat(teamId);
};
var $50081a64a1a094af$export$fce1abb40bf8db94 = function convertTeam(result) {
    var _team$members;
    var team = result.team;
    return $50081a64a1a094af$var$_objectSpread($50081a64a1a094af$var$_objectSpread({}, team), {}, {
        id: $50081a64a1a094af$export$5816a09dbb711691(team.id),
        members: (_team$members = team.members) === null || _team$members === void 0 ? void 0 : _team$members.nodes.map(function(_ref) {
            var member = _ref.member;
            return {
                id: member.accountId,
                fullName: member.name,
                avatarUrl: member.picture
            };
        })
    });
};
// indented so it's
var $50081a64a1a094af$var$TEAM_FRAGMENT = "\n      id\n      displayName\n      description\n      smallHeaderImageUrl\n      largeHeaderImageUrl\n      smallAvatarImageUrl\n      largeAvatarImageUrl\n      members {\n        nodes {\n          member {\n            accountId\n            name\n            picture\n          }\n        }\n      }\n";
var $50081a64a1a094af$export$4968f4e0119a5d9c = 'query TeamCard($teamId: ID!, $siteId: String!) {\n  Team: team {\n    team: teamV2(id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {\n      '.concat($50081a64a1a094af$var$TEAM_FRAGMENT, "\n    }\n  }\n}");
var $50081a64a1a094af$export$695d743d1401e038 = function buildGatewayQuery(_ref2) {
    var teamId = _ref2.teamId, siteId = _ref2.siteId;
    return {
        query: $50081a64a1a094af$export$4968f4e0119a5d9c,
        variables: {
            teamId: $50081a64a1a094af$export$681597d03c8a0fd2(teamId),
            siteId: siteId || "None"
        }
    };
};
var $50081a64a1a094af$export$1229c72526c01df2 = function addHeaders(headers) {
    headers.append("X-ExperimentalApi", "teams-beta");
    headers.append("X-ExperimentalApi", "team-members-beta");
    headers.append("atl-client-name", "@atlaskit/profilecard");
    headers.append("atl-client-version", "19.15.1");
    return headers;
};
function $50081a64a1a094af$export$26a8aad0c7182dd6(_x, _x2, _x3) {
    return $50081a64a1a094af$var$_getTeamFromAGG.apply(this, arguments);
}
function $50081a64a1a094af$var$_getTeamFromAGG() {
    $50081a64a1a094af$var$_getTeamFromAGG = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee(url, teamId, siteId) {
        var query, _yield$AGGQuery, Team;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    query = $50081a64a1a094af$export$695d743d1401e038({
                        teamId: teamId,
                        siteId: siteId
                    });
                    _context.next = 3;
                    return (0, $fARti.AGGQuery)(url, query, $50081a64a1a094af$export$1229c72526c01df2);
                case 3:
                    _yield$AGGQuery = _context.sent;
                    Team = _yield$AGGQuery.Team;
                    return _context.abrupt("return", $50081a64a1a094af$export$fce1abb40bf8db94(Team));
                case 6:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $50081a64a1a094af$var$_getTeamFromAGG.apply(this, arguments);
}

});


parcelRegister("689He", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $476b02ede30f7b1a$export$2e2bcd8739ae039; });

var $4mVfk = parcelRequire("4mVfk");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $8DpVo = parcelRequire("8DpVo");

var $18aOe = parcelRequire("18aOe");

var $94uiW = parcelRequire("94uiW");

var $dEpNy = parcelRequire("dEpNy");

var $hEoBh = parcelRequire("hEoBh");

var $fARti = parcelRequire("fARti");
function $476b02ede30f7b1a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $476b02ede30f7b1a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $476b02ede30f7b1a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($476b02ede30f7b1a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $476b02ede30f7b1a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $476b02ede30f7b1a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $476b02ede30f7b1a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $476b02ede30f7b1a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $476b02ede30f7b1a$export$b26b7f9bcf400835 = function modifyResponse(response) {
    var data = $476b02ede30f7b1a$var$_objectSpread({}, response.User);
    var localWeekdayIndex = new Date().getDay().toString();
    if (data.remoteWeekdayIndex && data.remoteWeekdayIndex !== localWeekdayIndex) data.remoteTimeString = "".concat(data.remoteWeekdayString, " ").concat(data.remoteTimeString);
    return {
        isBot: data.isBot,
        isCurrentUser: data.isCurrentUser,
        status: data.status,
        statusModifiedDate: data.statusModifiedDate || undefined,
        avatarUrl: data.avatarUrl || undefined,
        email: data.email || undefined,
        fullName: data.fullName || undefined,
        location: data.location || undefined,
        meta: data.meta || undefined,
        nickname: data.nickname || undefined,
        companyName: data.companyName || undefined,
        timestring: data.remoteTimeString || undefined,
        accountType: data.accountType || undefined
    };
};
var $476b02ede30f7b1a$export$bfbf383663068c37 = function buildUserQuery(cloudId, userId) {
    return {
        query: 'query User($userId: String!, $cloudId: String!) {\n    User: CloudUser(userId: $userId, cloudId: $cloudId) {\n      id\n      isCurrentUser\n      status\n      statusModifiedDate\n      isBot\n      isNotMentionable\n      fullName\n      nickname\n      email\n      meta: title\n      location\n      companyName\n      avatarUrl(size: 192)\n      remoteWeekdayIndex: localTime(format: "d")\n      remoteWeekdayString: localTime(format: "ddd")\n      remoteTimeString: localTime(format: "h:mma")\n    }\n  }',
        variables: {
            cloudId: cloudId,
            userId: userId
        }
    };
};
var $476b02ede30f7b1a$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CachingClient) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UserProfileCardClient, _CachingClient);
    var _super = $476b02ede30f7b1a$var$_createSuper(UserProfileCardClient);
    function UserProfileCardClient(options) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UserProfileCardClient);
        _this = _super.call(this, options);
        _this.options = options;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UserProfileCardClient, [
        {
            key: "makeRequest",
            value: function() {
                var _makeRequest = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee(cloudId, userId) {
                    var query, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (this.options.url) {
                                    _context.next = 2;
                                    break;
                                }
                                throw new Error("options.url is a required parameter");
                            case 2:
                                query = $476b02ede30f7b1a$export$bfbf383663068c37(cloudId, userId);
                                _context.next = 5;
                                return (0, $fARti.directoryGraphqlQuery)(this.options.url, query);
                            case 5:
                                response = _context.sent;
                                return _context.abrupt("return", $476b02ede30f7b1a$export$b26b7f9bcf400835(response));
                            case 7:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function makeRequest(_x, _x2) {
                    return _makeRequest.apply(this, arguments);
                }
                return makeRequest;
            }()
        },
        {
            key: "getProfile",
            value: function getProfile(cloudId, userId, analytics) {
                var _this2 = this;
                if (!userId) return Promise.reject(new Error("userId missing"));
                var cacheIdentifier = "".concat(cloudId, "/").concat(userId);
                var cache = this.getCachedProfile(cacheIdentifier);
                if (cache) return Promise.resolve(cache);
                return new Promise(function(resolve, reject) {
                    var startTime = (0, $94uiW.getPageTime)();
                    if (analytics) analytics((0, $18aOe.userRequestAnalytics)("triggered"));
                    _this2.makeRequest(cloudId, userId).then(function(data) {
                        if (_this2.cache) _this2.setCachedProfile(cacheIdentifier, data);
                        if (analytics) analytics((0, $18aOe.userRequestAnalytics)("succeeded", {
                            duration: (0, $94uiW.getPageTime)() - startTime
                        }));
                        resolve(data);
                    }).catch(function(error) {
                        if (analytics) analytics((0, $18aOe.userRequestAnalytics)("failed", $476b02ede30f7b1a$var$_objectSpread({
                            duration: (0, $94uiW.getPageTime)() - startTime
                        }, (0, $hEoBh.getErrorAttributes)(error))));
                        reject(error);
                    });
                });
            }
        }
    ]);
    return UserProfileCardClient;
}((0, $dEpNy.default));

});


parcelRegister("886PR", function(module, exports) {

var $fPPqr = parcelRequire("fPPqr");

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $eygjM = parcelRequire("eygjM");

var $kk7vA = parcelRequire("kk7vA");

var $9KQqc = parcelRequire("9KQqc");
var $atvDe = parcelRequire("atvDe");

var $93cMI = parcelRequire("93cMI");

var $aP6k3 = parcelRequire("aP6k3");

var $4Zcnm = parcelRequire("4Zcnm");

var $iJFBU = parcelRequire("iJFBU");

var $18aOe = parcelRequire("18aOe");

var $eGUrQ = parcelRequire("eGUrQ");

var $fajw5 = parcelRequire("fajw5");

var $94uiW = parcelRequire("94uiW");
parcelRequire("2ib6V");
var $3icl8 = parcelRequire("3icl8");

var $c1aX4 = parcelRequire("c1aX4");

var $iF2LN = parcelRequire("iF2LN");
function $5eb45f79a763c95a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5eb45f79a763c95a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $5eb45f79a763c95a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5eb45f79a763c95a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $5eb45f79a763c95a$export$f811dc569217c959 = /*#__PURE__*/ function(_React$PureComponent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(TeamProfileCardTriggerInternal, _React$PureComponent);
    var _super = $5eb45f79a763c95a$var$_createSuper(TeamProfileCardTriggerInternal);
    function TeamProfileCardTriggerInternal() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, TeamProfileCardTriggerInternal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isMounted", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "showTimer", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "hideTimer", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "openedByHover", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "openTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fireAnalytics", function(payload) {
            // Don't fire any analytics if the component is unmounted
            if (!_this._isMounted) return;
            if (_this.props.createAnalyticsEvent) (0, $18aOe.fireEvent)(_this.props.createAnalyticsEvent, payload);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fireAnalyticsWithDuration", function(generator) {
            var event = generator((0, $94uiW.getPageTime)() - _this.openTime);
            _this.fireAnalytics(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "hideProfilecard", function() {
            var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            clearTimeout(_this.showTimer);
            clearTimeout(_this.hideTimer);
            _this.hideTimer = window.setTimeout(function() {
                _this.setState({
                    visible: false
                });
            }, delay);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "showProfilecard", function() {
            var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            clearTimeout(_this.hideTimer);
            clearTimeout(_this.showTimer);
            _this.showTimer = window.setTimeout(function() {
                if (!_this.state.visible) {
                    _this.clientFetchProfile();
                    _this.openTime = (0, $94uiW.getPageTime)();
                    _this.setState({
                        visible: true
                    });
                }
            }, delay);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onClick", function(event) {
            if (_this.props.triggerLinkType === "link") // We want to prevent navigation occurring on basic click, but it's important that
            // cmd+click, ctrl+click, etc. still work as expected.
            {
                if ((0, $eGUrQ.isBasicClick)(event)) event.preventDefault();
            }
            if (_this.props.triggerLinkType === "clickable-link") {
                if (_this.props.viewProfileOnClick) _this.props.viewProfileOnClick(event);
            }
            if (_this.props.trigger !== "hover") {
                _this.openedByHover = false;
                _this.showProfilecard(0);
                if (!_this.state.visible) _this.fireAnalytics((0, $18aOe.cardTriggered)("team", "click"));
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onMouseEnter", function() {
            if (_this.props.trigger === "click") return;
            if (!_this.state.visible) {
                _this.openedByHover = true;
                _this.fireAnalytics((0, $18aOe.cardTriggered)("team", "hover"));
            }
            _this.showProfilecard((0, $fajw5.DELAY_MS_SHOW));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onMouseLeave", function() {
            if (_this.props.trigger === "click") return;
            if (_this.openedByHover) _this.hideProfilecard((0, $fajw5.DELAY_MS_HIDE));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onClose", function() {
            _this.hideProfilecard();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "openKudosDrawer", function() {
            _this.hideProfilecard((0, $fajw5.DELAY_MS_HIDE));
            _this.setState({
                kudosDrawerOpen: true
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "closeKudosDrawer", function() {
            _this.setState({
                kudosDrawerOpen: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "kudosUrl", function() {
            var recipientId = _this.props.teamId && "&recipientId=".concat(_this.props.teamId) || "";
            var cloudId = _this.props.cloudId && "&cloudId=".concat(_this.props.cloudId) || "";
            return "".concat(_this.state.teamCentralBaseUrl, "/kudos/give?type=team").concat(recipientId).concat(cloudId);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "stopPropagation", function(event) {
            // We need to stop propagation when users click on the card, so that it
            // doesn't trigger any special effects that occur when clicking the trigger.
            event.stopPropagation();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "triggerListeners", {
            onClick: _this.onClick,
            onMouseEnter: _this.onMouseEnter,
            onMouseLeave: _this.onMouseLeave
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "cardListeners", {
            onClick: _this.stopPropagation,
            onMouseEnter: _this.onMouseEnter,
            onMouseLeave: _this.onMouseLeave
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "state", {
            visible: false,
            isLoading: undefined,
            hasError: false,
            error: null,
            data: null,
            shouldShowGiveKudos: false,
            teamCentralBaseUrl: undefined,
            kudosDrawerOpen: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clientFetchProfile", function() {
            var _this$props = _this.props, orgId = _this$props.orgId, teamId = _this$props.teamId;
            var isLoading = _this.state.isLoading;
            if (isLoading === true) // don't fetch data when fetching is in process
            return;
            _this.setState({
                isLoading: true,
                data: null
            }, function() {
                var fireEvent = function fireEvent(event) {
                    _this.fireAnalytics(event);
                };
                var requests = Promise.all([
                    _this.props.resourceClient.getTeamProfile(teamId, orgId, fireEvent),
                    _this.props.resourceClient.shouldShowGiveKudos()
                ]);
                requests.then(function(res) {
                    var _this2;
                    return (_this2 = _this).handleClientSuccess.apply(_this2, (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(res));
                }, function(err) {
                    return _this.handleClientError(err);
                }).catch(function(err) {
                    return _this.handleClientError(err);
                });
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onErrorBoundary", function() {
            _this.fireAnalytics((0, $18aOe.profileCardRendered)("team", "errorBoundary", {
                duration: 0
            }));
            _this.setState({
                renderError: true
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "renderProfileCard", function() {
            var _this$props2 = _this.props, generateUserLink = _this$props2.generateUserLink, onUserClick = _this$props2.onUserClick, viewingUserId = _this$props2.viewingUserId, viewProfileLink = _this$props2.viewProfileLink, viewProfileOnClick = _this$props2.viewProfileOnClick;
            var _this$state = _this.state, data = _this$state.data, error = _this$state.error, hasError = _this$state.hasError, isLoading = _this$state.isLoading;
            var newProps = {
                clientFetchProfile: _this.clientFetchProfile,
                actions: _this.filterActions(),
                analytics: _this.fireAnalyticsWithDuration,
                team: data || undefined,
                generateUserLink: generateUserLink,
                onUserClick: onUserClick,
                viewingUserId: viewingUserId,
                viewProfileLink: viewProfileLink,
                viewProfileOnClick: viewProfileOnClick
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", _this.cardListeners, _this.state.visible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Suspense), {
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $iF2LN.default), {
                    analytics: _this.fireAnalyticsWithDuration
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $c1aX4.TeamProfileCardLazy), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, newProps, {
                isLoading: isLoading,
                hasError: hasError,
                errorType: error
            }))));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "renderKudosLauncher", function() {
            return _this.state.shouldShowGiveKudos && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Suspense), {
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9KQqc.GiveKudosLauncherLazy), {
                isOpen: _this.state.kudosDrawerOpen,
                recipient: {
                    type: (0, $atvDe.KudosType).TEAM,
                    recipientId: _this.props.teamId
                },
                analyticsSource: "team-profile-card",
                teamCentralBaseUrl: _this.state.teamCentralBaseUrl,
                cloudId: _this.props.cloudId || "",
                addFlag: _this.props.addFlag,
                onClose: _this.closeKudosDrawer
            }));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "renderTrigger", function(triggerProps) {
            var _this$props3 = _this.props, children = _this$props3.children, triggerLinkType = _this$props3.triggerLinkType, viewProfileLink = _this$props3.viewProfileLink;
            if (triggerLinkType === "none") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, _this.renderKudosLauncher(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                "data-testid": "team-profilecard-trigger-wrapper"
            }, triggerProps, _this.triggerListeners), children));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, _this.renderKudosLauncher(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("a", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                "data-testid": "team-profilecard-trigger-wrapper",
                style: {
                    color: "initial",
                    textDecoration: "none"
                },
                href: viewProfileLink
            }, triggerProps, {
                ref: triggerProps.ref
            }, _this.triggerListeners), children));
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(TeamProfileCardTriggerInternal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._isMounted = true;
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props4 = this.props, orgId = _this$props4.orgId, teamId = _this$props4.teamId, resourceClient = _this$props4.resourceClient;
                var visible = this.state.visible;
                // just re-fetching data when the card opens
                if (visible && (teamId !== prevProps.teamId || orgId !== prevProps.orgId || resourceClient !== prevProps.resourceClient)) this.setState({
                    isLoading: undefined
                }, this.clientFetchProfile);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._isMounted = false;
                clearTimeout(this.showTimer);
                clearTimeout(this.hideTimer);
            }
        },
        {
            key: "handleClientSuccess",
            value: function handleClientSuccess(team, shouldShowGiveKudos) {
                if (!this._isMounted) return;
                this.setState({
                    isLoading: false,
                    hasError: false,
                    data: team,
                    shouldShowGiveKudos: shouldShowGiveKudos,
                    teamCentralBaseUrl: this.props.resourceClient.getTeamCentralBaseUrl()
                });
            }
        },
        {
            key: "handleClientError",
            value: function handleClientError(err) {
                if (!this._isMounted) return;
                this.setState({
                    isLoading: false,
                    hasError: true,
                    error: err
                });
            }
        },
        {
            key: "filterActions",
            value: function filterActions() {
                var _this3 = this;
                var actions = (0, $4Zcnm.default)(this.props.actions, this.state.data);
                if (this.state.shouldShowGiveKudos) {
                    var kudosAction = {
                        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eygjM.default), (0, $iJFBU.default).giveKudosButton),
                        id: "give-kudos",
                        callback: function callback() {
                            _this3.openKudosDrawer();
                        },
                        link: this.kudosUrl()
                    };
                    return actions.concat([
                        kudosAction
                    ]);
                }
                return actions;
            }
        },
        {
            key: "renderPopup",
            value: function renderPopup() {
                var _this4 = this;
                if (this.state.renderError) return this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3icl8.ErrorBoundary), {
                    onError: this.onErrorBoundary
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $93cMI.default), {
                    isOpen: !!this.state.visible,
                    onClose: this.onClose,
                    placement: this.props.position,
                    content: this.renderProfileCard,
                    trigger: function trigger(triggerProps) {
                        return _this4.renderTrigger(triggerProps);
                    },
                    zIndex: (0, $aP6k3.layers).modal(),
                    shouldFlip: true,
                    autoFocus: this.props.trigger !== "hover" && !this.openedByHover
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.props.children) return this.renderPopup();
                else throw new Error('Component "TeamProfileCardTrigger" must have "children" property');
            }
        }
    ]);
    return TeamProfileCardTriggerInternal;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).PureComponent);
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($5eb45f79a763c95a$export$f811dc569217c959, "defaultProps", {
    actions: [],
    trigger: "hover",
    position: "bottom-start",
    triggerLinkType: "link"
});
var $5eb45f79a763c95a$export$2e2bcd8739ae039 = (0, $kk7vA.default)()($5eb45f79a763c95a$export$f811dc569217c959);

});
parcelRegister("kk7vA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecbb7ff23ed60b59$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $kWcTk = parcelRequire("kWcTk");

var $cst2x = parcelRequire("cst2x");
var $ecbb7ff23ed60b59$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(props, ref) {
            var _usePatchedProps = (0, $cst2x.usePatchedProps)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $kWcTk.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $ecbb7ff23ed60b59$export$2e2bcd8739ae039 = $ecbb7ff23ed60b59$var$withAnalyticsEvents;

});
parcelRegister("kWcTk", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $f3e3396a492ca79c$export$5bf35293e545f20c; });

var $dNznA = parcelRequire("dNznA");

var $7TY7I = parcelRequire("7TY7I");

var $3Ydla = parcelRequire("3Ydla");
function $f3e3396a492ca79c$export$5bf35293e545f20c() {
    var analyticsContext = (0, $3Ydla.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $7TY7I.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("7TY7I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c0c4ebd93cd344e$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $5lf9m = parcelRequire("5lf9m");
function $5c0c4ebd93cd344e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5c0c4ebd93cd344e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $5c0c4ebd93cd344e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5c0c4ebd93cd344e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $5c0c4ebd93cd344e$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $5c0c4ebd93cd344e$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $5c0c4ebd93cd344e$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $5c0c4ebd93cd344e$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $5lf9m.default));

});
parcelRegister("5lf9m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e3aaa67528bb1a6$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
function $3e3aaa67528bb1a6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3e3aaa67528bb1a6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3e3aaa67528bb1a6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3e3aaa67528bb1a6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3e3aaa67528bb1a6$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $3e3aaa67528bb1a6$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $3e3aaa67528bb1a6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $3e3aaa67528bb1a6$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(updater) === "object") this.payload = $3e3aaa67528bb1a6$var$_objectSpread($3e3aaa67528bb1a6$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("3Ydla", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $2e4152cf93dacd5e$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $2e4152cf93dacd5e$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});


parcelRegister("cst2x", function(module, exports) {

$parcel$export(module.exports, "usePatchedProps", function () { return $911ea0457ee1abe7$export$9ebb5a84d17e5d18; });

var $kFnE9 = parcelRequire("kFnE9");

var $340K4 = parcelRequire("340K4");

var $9nHZC = parcelRequire("9nHZC");

var $kWcTk = parcelRequire("kWcTk");
function $911ea0457ee1abe7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $911ea0457ee1abe7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $911ea0457ee1abe7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $911ea0457ee1abe7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $911ea0457ee1abe7$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $kWcTk.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $9nHZC.useRef)({});
    var patchedProps = (0, $9nHZC.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                "object",
                "function"
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $911ea0457ee1abe7$var$_objectSpread($911ea0457ee1abe7$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === "function" ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === "function") {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $911ea0457ee1abe7$var$_objectSpread($911ea0457ee1abe7$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});


parcelRegister("9KQqc", function(module, exports) {

$parcel$export(module.exports, "GiveKudosLauncherLazy", function () { return $71a112c26c28fe59$export$93fe397a02fe8b76; });

var $9nHZC = parcelRequire("9nHZC");

var $71a112c26c28fe59$export$93fe397a02fe8b76 = /*#__PURE__*/ (0, $9nHZC.lazy)(function() {
    return (parcelRequire("iWsei"));
});

});
parcelRegister("iWsei", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("dHQda")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fpwEn"))
]).then(()=>parcelRequire("ifdLI"));

});


parcelRegister("atvDe", function(module, exports) {

$parcel$export(module.exports, "KudosType", function () { return $7a052636fc398284$export$4fa2020056771264; });
$parcel$export(module.exports, "FlagEventType", function () { return $7a052636fc398284$export$d21f9befaa2961a; });
$parcel$export(module.exports, "isFlagEventTypeValue", function () { return $7a052636fc398284$export$7a1fc1a1b0477464; });
var $7a052636fc398284$export$4fa2020056771264 = /*#__PURE__*/ function(KudosType) {
    KudosType["INDIVIDUAL"] = "individual";
    KudosType["TEAM"] = "team";
    return KudosType;
}({});
var $7a052636fc398284$export$d21f9befaa2961a = /*#__PURE__*/ function(FlagEventType) {
    FlagEventType["KUDOS_CREATED"] = "kudos-created";
    FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
    FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
    FlagEventType["DIRTY"] = "dirty";
    FlagEventType["CLOSE"] = "close";
    return FlagEventType;
}({});
var $7a052636fc398284$export$7a1fc1a1b0477464 = function isFlagEventTypeValue(value) {
    return Object.values($7a052636fc398284$export$d21f9befaa2961a).includes(value);
};

});

parcelRegister("4Zcnm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a1675802f16e433$export$2e2bcd8739ae039; });
var $3a1675802f16e433$var$filterActions = function filterActions() {
    var actions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var data = arguments.length > 1 ? arguments[1] : undefined;
    return actions.filter(function(action) {
        if (!action.shouldRender) return true;
        else if (typeof action.shouldRender !== "function") return Boolean(action.shouldRender);
        return action.shouldRender(data);
    });
};
var $3a1675802f16e433$export$2e2bcd8739ae039 = $3a1675802f16e433$var$filterActions;

});

parcelRegister("iJFBU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da3cb4f13da95b18$export$2e2bcd8739ae039; });

var $dLdNR = parcelRequire("dLdNR");
var $da3cb4f13da95b18$var$messages = (0, $dLdNR.defineMessages)({
    inactiveAccountMsg: {
        id: "pt.profile-card.inactive.account",
        defaultMessage: "Account deactivated",
        description: "A text in a grey lozenge shows that this user is inactive"
    },
    generalDescMsgForDisabledUser: {
        id: "pt.profile-card.general.msg.disabled.user",
        defaultMessage: "You can no longer collaborate with this person.",
        description: "A first sentence of a long text explains this user is inactive/closed"
    },
    inactiveAccountDescMsgNoDate: {
        id: "pt.profile-card.inactive.account.no.date",
        defaultMessage: "Their account has been deactivated.",
        description: "A long text explains this user is inactive when we do not know the date of starting to deactivate"
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.inactive.account.has.date.this.week",
        defaultMessage: "Their account was deactivated this week.",
        description: "A long text explains this user is inactive when we know the date of starting to deactivate"
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.inactive.account.has.date.this.month",
        defaultMessage: "Their account was deactivated this month.",
        description: "A long text explains this user is inactive when we know the date of starting to deactivate"
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.inactive.account.has.date.last.month",
        defaultMessage: "Their account was deactivated last month.",
        description: "A long text explains this user is inactive when we know the date of starting to deactivate"
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.inactive.account.has.date.a.few.months",
        defaultMessage: "Their account has been deactivated for a few months.",
        description: "A long text explains this user is inactive when we know the date of starting to deactivate"
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.inactive.account.has.date.several.months",
        defaultMessage: "Their account has been deactivated for several months.",
        description: "A long text explains this user is inactive when we know the date of starting to deactivate"
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.inactive.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deactivated for more than a year.",
        description: "A long text explains this user is inactive when we know the date of starting to deactivate"
    },
    closedAccountMsg: {
        id: "pt.profile-card.closed.account",
        defaultMessage: "Account deleted",
        description: "A text in a grey lozenge shows that this user is closed/deleted"
    },
    closedAccountDescMsgNoDate: {
        id: "pt.profile-card.closed.account.no.date",
        defaultMessage: "Their account has been deleted.",
        description: "A long text explains this user is closed when we do not know the date of starting to close"
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.closed.account.has.date.this.week",
        defaultMessage: "Their account was deleted this week.",
        description: "A long text explains this user is closed when we know the date of starting to close"
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.closed.account.has.date.this.month",
        defaultMessage: "Their account was deleted this month.",
        description: "A long text explains this user is closed when we know the date of starting to close"
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.closed.account.has.date.last.month",
        defaultMessage: "Their account was deleted last month.",
        description: "A long text explains this user is closed when we know the date of starting to close"
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.closed.account.has.date.a.few.months",
        defaultMessage: "Their account has been deleted for a few months.",
        description: "A long text explains this user is closed when we know the date of starting to close"
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.closed.account.has.date.several.months",
        defaultMessage: "Their account has been deleted for several months.",
        description: "A long text explains this user is closed when we know the date of starting to close"
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.closed.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deleted for more than a year.",
        description: "A long text explains this user is closed when we know the date of starting to close"
    },
    disabledAccountDefaultName: {
        id: "pt.profile-card.disabled.account.default.name",
        defaultMessage: "Former user",
        description: "A default name when we cannot get name of an inactive or closed user"
    },
    teamViewProfile: {
        id: "pt.team-profile-card.team.action.view-profile",
        defaultMessage: "View profile",
        description: "Button that takes you to view this team\u2019s profile"
    },
    memberCount: {
        id: "pt.team-profile-card.team.member.count",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: "Byline to show the number of members in the team"
    },
    memberCountIncludingYou: {
        id: "pt.team-profile-card.team.member.count-including-you",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: "Byline to show the number of members in the team and highlight that the user is a member"
    },
    membersMoreThan50: {
        id: "pt.team-profile-card.team.member.many",
        defaultMessage: "Team \u2022 50+ members",
        description: "Byline to show the team has more than 50 members"
    },
    membersMoreThan50IncludingYou: {
        id: "pt.team-profile-card.team.member.many-including-you",
        defaultMessage: "Team \u2022 50+ members, including you",
        description: "Byline to show the team has more than 50 members and highlight that the user is a member"
    },
    teamErrorTitle: {
        id: "pt.team-profile-card.error.title",
        defaultMessage: "We\u2019re having trouble retrieving this teams information",
        description: "Title for an error view explaining that data for this team cannot be accessed"
    },
    teamErrorText: {
        id: "pt.team-profile-card.error.suggestion",
        defaultMessage: "Wait a few moments, then try again.",
        description: "Second line suggesting how to fix the issue"
    },
    teamErrorButton: {
        id: "pt.team-profile-card.error.refresh-button",
        defaultMessage: "Try again",
        description: "Text on a button that will try to get the data again when clicked"
    },
    teamForbiddenErrorStateTitle: {
        id: "pt.team-profile-card.forbidden-error-state.title",
        defaultMessage: "We can\u2019t show you this team",
        description: "Title for the error state that is displayed when a user lacks access to the team"
    },
    teamForbiddenErrorStateDescription: {
        id: "pt.team-profile-card.forbidden-error-state.description",
        defaultMessage: "You don\u2019t have access to view this team.",
        description: "Description for the error state that is displayed when a user lacks access to the team"
    },
    managerSectionHeading: {
        id: "pt.team-profile-card.manager.heading",
        defaultMessage: "Manager",
        description: "Title for a section on the profile card that show the user's direct manager"
    },
    directReportsSectionHeading: {
        id: "pt.team-profile-card.directReports.heading",
        defaultMessage: "Direct reports",
        description: "Title for a section on the profile card that show the user's direct reports"
    },
    giveKudosButton: {
        id: "pt.profile-card.give-kudos",
        defaultMessage: "Give kudos",
        description: "Title for the button on the profile card for a user to give a kudos"
    },
    profileCardMoreIconLabel: {
        id: "pt.profile-card.more-icon-label",
        defaultMessage: "More",
        description: "Label for the meatballs icon on the profile card, which when clicked will provide more options"
    }
});
var $da3cb4f13da95b18$export$2e2bcd8739ae039 = $da3cb4f13da95b18$var$messages;

});

parcelRegister("eGUrQ", function(module, exports) {

$parcel$export(module.exports, "isBasicClick", function () { return $ab20c65d5a31767b$export$eddcd8a5b7e09991; });
var $ab20c65d5a31767b$export$eddcd8a5b7e09991 = function isBasicClick(event) {
    return !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

});

parcelRegister("fajw5", function(module, exports) {

$parcel$export(module.exports, "DELAY_MS_SHOW", function () { return $b0a6edc5d5d89fcb$export$5b956b542f1bc1b3; });
$parcel$export(module.exports, "DELAY_MS_HIDE", function () { return $b0a6edc5d5d89fcb$export$89a9f35a94d7f196; });
var $b0a6edc5d5d89fcb$export$5b956b542f1bc1b3 = 800;
var $b0a6edc5d5d89fcb$export$89a9f35a94d7f196 = 200;

});

parcelRegister("2ib6V", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", function () { return (parcelRequire("3icl8")).ErrorBoundary; });
$parcel$export(module.exports, "ErrorIllustration", function () { return (parcelRequire("c1XL9")).ErrorIllustration; });
$parcel$export(module.exports, "ErrorMessage", function () { return (parcelRequire("55gHa")).default; });

var $3icl8 = parcelRequire("3icl8");

var $c1XL9 = parcelRequire("c1XL9");

var $55gHa = parcelRequire("55gHa");

});
parcelRegister("3icl8", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", function () { return $265c9fff816567b4$export$e926676385687eaf; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $9nHZC = parcelRequire("9nHZC");
function $265c9fff816567b4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $265c9fff816567b4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $265c9fff816567b4$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($265c9fff816567b4$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $265c9fff816567b4$export$e926676385687eaf = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(ErrorBoundary, _React$Component);
    var _super = $265c9fff816567b4$var$_createSuper(ErrorBoundary);
    function ErrorBoundary() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ErrorBoundary);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch() {
                // Failure analytics here too
                this.props.onError();
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return ErrorBoundary;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component);
var $265c9fff816567b4$export$2e2bcd8739ae039 = $265c9fff816567b4$export$e926676385687eaf;

});

parcelRegister("c1XL9", function(module, exports) {

$parcel$export(module.exports, "ErrorIllustration", function () { return $8c23ef019d0f5c48$export$e0319f52fc2380b1; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $9nHZC = parcelRequire("9nHZC");
var $8c23ef019d0f5c48$export$e0319f52fc2380b1 = function ErrorIllustration() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("svg", {
        width: "42",
        height: "53",
        viewBox: "0 0 164 212",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("g", {
        clipPath: "url(#clip0)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M0.649902 0H163.93V212H0.649902V0Z",
        fill: "var(--ds-surface-overlay, white)",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M95.4299 74.1603L161.87 189.24C167.71 199.36 160.41 212 148.73 212H15.8499C4.16994 212 -3.13006 199.35 2.70994 189.24L69.1499 74.1603C74.9899 64.0403 89.5899 64.0403 95.4299 74.1603ZM87.8699 157.71L90.7499 113.36C91.0899 108.07 86.8899 103.58 81.5899 103.58C76.2799 103.58 72.0799 108.06 72.4299 113.36L75.3099 157.71C75.5299 161.02 78.2699 163.6 81.5899 163.6C84.8999 163.6 87.6499 161.02 87.8699 157.71ZM72.0299 181.25C72.0299 186.91 76.7899 191.35 82.4199 190.83C87.2699 190.38 91.1499 186.33 91.2499 181.46C91.3599 176.01 86.9399 171.52 81.5199 171.52C76.2899 171.51 72.0299 175.89 72.0299 181.25Z",
        fill: "url(#paint0_linear)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        opacity: "0.6",
        d: "M93.3498 27.1702L85.9398 0.450216C85.7698 -0.169784 84.8698 -0.129784 84.7498 0.500216L80.0898 25.6002L74.2898 24.5202C73.8498 24.4402 73.4698 24.8502 73.5898 25.2802L80.9998 52.0002C81.1698 52.6202 82.0698 52.5802 82.1898 51.9502L86.8498 26.8502L92.6498 27.9302C93.0998 28.0102 93.4698 27.6002 93.3498 27.1702Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        opacity: "0.6",
        d: "M66.7699 41.8103L55.8999 33.2603C55.6799 33.0803 55.3699 33.3303 55.4899 33.5903L61.0199 45.0203L58.3599 46.3103C58.1799 46.4003 58.1599 46.6403 58.3099 46.7603L69.1799 55.3103C69.3999 55.4903 69.7099 55.2403 69.5899 54.9803L64.0599 43.5503L66.7199 42.2603C66.8899 42.1803 66.9199 41.9303 66.7699 41.8103Z",
        fill: "#C1C7D0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        opacity: "0.6",
        d: "M102.78 56.7501C102.57 56.7501 102.37 56.6901 102.19 56.5601C101.81 56.2801 101.68 55.7801 101.86 55.3701C101.62 54.6001 99.57 52.5201 98.32 51.2601C95.35 48.2501 93.39 46.2601 94.48 44.7701C95.57 43.2901 98.06 44.5501 101.83 46.4701C103.15 47.1401 105.18 48.1701 106.28 48.5001C105.64 47.5501 104.04 45.9201 103 44.8701C100.03 41.8601 98.07 39.8701 99.16 38.3801C100.24 36.9001 102.74 38.1601 106.5 40.0801C107.82 40.7501 109.84 41.7801 110.95 42.1101C110.31 41.1601 108.71 39.5401 107.67 38.4901C104.7 35.4801 102.74 33.4901 103.83 32.0001C104.91 30.5201 107.4 31.7801 111.17 33.7001C112.75 34.5001 115.35 35.8301 116.15 35.8301C116.49 35.5401 117 35.5101 117.39 35.7901C117.84 36.1201 117.93 36.7401 117.61 37.1901C116.52 38.6701 114.04 37.4101 110.27 35.4901C108.95 34.8201 106.93 33.7901 105.83 33.4601C106.47 34.4101 108.07 36.0301 109.11 37.0801C112.08 40.0901 114.04 42.0801 112.95 43.5701C111.87 45.0501 109.38 43.7901 105.61 41.8701C104.29 41.2001 102.26 40.1701 101.16 39.8401C101.8 40.7901 103.4 42.4101 104.44 43.4701C107.41 46.4801 109.37 48.4701 108.28 49.9601C107.19 51.4401 104.7 50.1801 100.93 48.2601C99.61 47.5901 97.58 46.5501 96.48 46.2301C97.12 47.1801 98.72 48.8101 99.76 49.8601C102.73 52.8701 104.69 54.8601 103.6 56.3501C103.39 56.6101 103.09 56.7501 102.78 56.7501Z",
        fill: "#B3BAC5"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        opacity: "0.6",
        d: "M108.34 71.0702C107.99 71.0702 107.65 70.8802 107.46 70.5502C106.42 68.6702 105.24 66.5302 106.55 65.3402C107.86 64.1402 109.89 65.5202 112.04 66.9702C112.91 67.5602 114.3 68.5002 114.97 68.6802C114.85 68.0002 114.04 66.5302 113.52 65.6102C112.26 63.3402 111.07 61.2002 112.38 60.0002C113.69 58.8002 115.72 60.1802 117.87 61.6302C118.83 62.2802 120.41 63.3502 120.97 63.3702C121.38 63.0702 121.95 63.1202 122.3 63.5002C122.67 63.9102 122.65 64.5402 122.24 64.9102C120.93 66.1102 118.9 64.7402 116.75 63.2802C115.88 62.6902 114.49 61.7502 113.82 61.5702C113.94 62.2502 114.75 63.7202 115.27 64.6402C116.53 66.9102 117.72 69.0502 116.41 70.2502C115.1 71.4502 113.07 70.0702 110.92 68.6202C110.05 68.0302 108.66 67.0902 107.99 66.9102C108.11 67.5902 108.92 69.0502 109.21 69.5802C109.48 70.0602 109.3 70.6702 108.82 70.9402C108.67 71.0302 108.5 71.0702 108.34 71.0702Z",
        fill: "#B3BAC5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        opacity: "0.6",
        d: "M54.02 68.1797C53.8 68.1797 53.58 68.1397 53.35 68.0397C51.71 67.3497 52.11 64.9297 52.54 62.3697C52.71 61.3297 52.99 59.6697 52.87 58.9897C52.3 59.3797 51.31 60.7397 50.69 61.5897C49.16 63.6797 47.7 65.6597 46.07 64.9697C45.56 64.7597 45.32 64.1697 45.54 63.6597C45.74 63.1797 46.27 62.9397 46.75 63.0897C47.27 62.8797 48.4 61.3397 49.09 60.4097C50.62 58.3197 52.07 56.3297 53.71 57.0297C55.35 57.7197 54.95 60.1397 54.52 62.6997C54.35 63.7397 54.07 65.3997 54.19 66.0797C54.76 65.6897 55.75 64.3297 56.37 63.4797C57.9 61.3897 59.35 59.3997 60.99 60.0997C62.62 60.7897 62.23 63.1897 61.88 65.3097C61.79 65.8497 61.28 66.2197 60.73 66.1397C60.19 66.0497 59.81 65.5397 59.9 64.9897C60 64.3997 60.27 62.7497 60.16 62.0697C59.59 62.4597 58.6 63.8197 57.98 64.6697C56.65 66.4597 55.39 68.1797 54.02 68.1797Z",
        fill: "#B3BAC5"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("linearGradient", {
        id: "paint0_linear",
        x1: "26.1692",
        y1: "228.621",
        x2: "138.408",
        y2: "116.382",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("stop", {
        offset: "0.297",
        stopColor: "#C6CBD4",
        stopOpacity: "0.8812"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("stop", {
        offset: "0.6301",
        stopColor: "#D3D7DE",
        stopOpacity: "0.748"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("stop", {
        offset: "0.9795",
        stopColor: "#E9EBEF",
        stopOpacity: "0.6082"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("stop", {
        offset: "1",
        stopColor: "#EBECF0",
        stopOpacity: "0.6"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("clipPath", {
        id: "clip0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M0.649902 0H163.93V212H0.649902V0Z",
        fill: "white"
    }))));
};

});

parcelRegister("55gHa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b3a5eb8f85ac107$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $7fgJe = parcelRequire("7fgJe");

var $i00RS = parcelRequire("i00RS");

var $auXFA = parcelRequire("auXFA");

var $18aOe = parcelRequire("18aOe");
var $3b3a5eb8f85ac107$var$ErrorMessage = function ErrorMessage(props) {
    var errorType = props.errorType || {
        reason: "default"
    };
    var errorReason = errorType.reason;
    var fireAnalytics = props.fireAnalytics, reload = props.reload;
    var hasRetry = !!reload;
    (0, $9nHZC.useEffect)(function() {
        fireAnalytics((0, $18aOe.profileCardRendered)("user", "error", {
            hasRetry: hasRetry,
            errorType: errorReason
        }));
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    var errorContent = function errorContent() {
        if (errorReason === "NotFound") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $auXFA.ErrorTitle), null, "The user is no longer available for the site");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $auXFA.ErrorTitle), null, "Oops, looks like we\u2019re having issues", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("br", null), reload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $auXFA.ErrorText), null, "Try again and we\u2019ll give it another shot"));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $auXFA.ErrorWrapper), {
        "data-testid": "profilecard-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i00RS))), {
        label: "icon error",
        size: "xlarge"
    }), errorContent(), reload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7fgJe.default), {
        appearance: "link",
        onClick: reload
    }, "Try again"));
};
var $3b3a5eb8f85ac107$export$2e2bcd8739ae039 = $3b3a5eb8f85ac107$var$ErrorMessage;

});
parcelRegister("7fgJe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5466e909c1ce0bc6$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9q1kH = parcelRequire("9q1kH");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $8p2GL = parcelRequire("8p2GL");

var $5LVXk = parcelRequire("5LVXk");

var $dPP5B = parcelRequire("dPP5B");

var $cbfok = parcelRequire("cbfok");

var $k8LtO = parcelRequire("k8LtO");
var $5466e909c1ce0bc6$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $5466e909c1ce0bc6$var$isFirefox = typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
/**
 * __Button__
 *
 * CAUTION: Legacy buttons will soon be deprecated. Please use the new Button components from `@atlaskit/button/new`.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $5466e909c1ce0bc6$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $8p2GL.default) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $8p2GL.default) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $5466e909c1ce0bc6$var$_excluded);
    var _useGlobalTheme = (0, $5LVXk.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var isOnlySingleIcon = (0, $k8LtO.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $9nHZC.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    var onMouseDown = (0, $9nHZC.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($5466e909c1ce0bc6$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $9nHZC.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($5466e909c1ce0bc6$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $9nHZC.useMemo)(function() {
        return (0, $cbfok.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dPP5B.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$5466e909c1ce0bc6$var$Button.displayName = "Button";
var $5466e909c1ce0bc6$export$2e2bcd8739ae039 = $5466e909c1ce0bc6$var$Button;

});
parcelRegister("dPP5B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a127ab146d4a0d3d$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $ClKoH = parcelRequire("ClKoH");

var $8p2GL = parcelRequire("8p2GL");

var $grYZC = parcelRequire("grYZC");

var $dxhCu = parcelRequire("dxhCu");

var $5fUc4 = parcelRequire("5fUc4");

var $jp7ng = parcelRequire("jp7ng");

var $jVE7H = parcelRequire("jVE7H");

var $cbfok = parcelRequire("cbfok");

var $9onJM = parcelRequire("9onJM");
var $a127ab146d4a0d3d$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $a127ab146d4a0d3d$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform.design-system-team.enable-new-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $a127ab146d4a0d3d$var$iconBeforeSpacingFixStyle = (0, $avKww.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $a127ab146d4a0d3d$var$iconAfterSpacingFixStyle = (0, $avKww.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $a127ab146d4a0d3d$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $9onJM.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $a127ab146d4a0d3d$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $9onJM.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $avKww.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $a127ab146d4a0d3d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $8p2GL.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $8p2GL.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(props, $a127ab146d4a0d3d$var$_excluded);
    var ourRef = (0, $9nHZC.useRef)();
    var setRef = (0, $9nHZC.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $grYZC.default)(ourRef, autoFocus);
    var interactionContext = (0, $9nHZC.useContext)((0, $5fUc4.default));
    var handleClick = (0, $9nHZC.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $ClKoH.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "17.23.0",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $9nHZC.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $9nHZC.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $avKww.css)((0, $cbfok.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === "warning") spinnerHackCss = {
        "[data-theme] & circle": {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $jp7ng.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $jp7ng.N500), ")"), " !important")
        }
    };
    return (0, $avKww.jsx)((0, $dxhCu.default), null, (0, $avKww.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $a127ab146d4a0d3d$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $jVE7H.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $avKww.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $cbfok.getIconStyle)({
                spacing: spacing
            }),
            $a127ab146d4a0d3d$var$getSpacingFix(children, $a127ab146d4a0d3d$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $a127ab146d4a0d3d$var$getChildren(children, [
        fadeStyles,
        (0, $cbfok.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $avKww.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $cbfok.getIconStyle)({
                spacing: spacing
            }),
            $a127ab146d4a0d3d$var$getSpacingFix(children, $a127ab146d4a0d3d$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $avKww.jsx)("span", {
        css: [
            (0, $cbfok.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});

});
parcelRegister("ClKoH", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $07346b4b501e6500$export$a4687b0234b40e28; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $kWcTk = parcelRequire("kWcTk");

var $d5I2A = parcelRequire("d5I2A");
function $07346b4b501e6500$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $07346b4b501e6500$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $07346b4b501e6500$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $07346b4b501e6500$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $07346b4b501e6500$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $kWcTk.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $d5I2A.useTrackedRef)(analyticsData);
    var fnRef = (0, $d5I2A.useTrackedRef)(fn);
    var handler = (0, $9nHZC.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $07346b4b501e6500$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("d5I2A", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $987de78bc2159f06$export$1d27a74659855e44; });

var $9nHZC = parcelRequire("9nHZC");
var $987de78bc2159f06$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("jVE7H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e82276d4dd34a9a5$export$2e2bcd8739ae039; });
function $e82276d4dd34a9a5$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $e82276d4dd34a9a5$var$tabKeyCode = 9;
function $e82276d4dd34a9a5$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $e82276d4dd34a9a5$var$tabKeyCode) return;
    $e82276d4dd34a9a5$var$abort(event);
}
var $e82276d4dd34a9a5$var$block = {
    onMouseDownCapture: $e82276d4dd34a9a5$var$abort,
    onMouseUpCapture: $e82276d4dd34a9a5$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $e82276d4dd34a9a5$var$onKey,
    onKeyUpCapture: $e82276d4dd34a9a5$var$onKey,
    onTouchStartCapture: $e82276d4dd34a9a5$var$abort,
    onTouchEndCapture: $e82276d4dd34a9a5$var$abort,
    onPointerDownCapture: $e82276d4dd34a9a5$var$abort,
    onPointerUpCapture: $e82276d4dd34a9a5$var$abort,
    onClickCapture: $e82276d4dd34a9a5$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $e82276d4dd34a9a5$var$abort
};
var $e82276d4dd34a9a5$var$doNotBlock = {};
function $e82276d4dd34a9a5$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $e82276d4dd34a9a5$var$doNotBlock : $e82276d4dd34a9a5$var$block;
}

});

parcelRegister("cbfok", function(module, exports) {

$parcel$export(module.exports, "getCss", function () { return $8de27387964beab2$export$955358618f994a11; });
$parcel$export(module.exports, "getIconStyle", function () { return $8de27387964beab2$export$864eea3f4ec3368f; });
$parcel$export(module.exports, "getContentStyle", function () { return $8de27387964beab2$export$7ad0316cc0dd65a; });
$parcel$export(module.exports, "getFadingCss", function () { return $8de27387964beab2$export$1b5827d324e945b1; });
$parcel$export(module.exports, "overlayCss", function () { return $8de27387964beab2$export$1a9fe1b84c876bb5; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $aP6k3 = parcelRequire("aP6k3");

var $4zqY2 = parcelRequire("4zqY2");
function $8de27387964beab2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8de27387964beab2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8de27387964beab2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8de27387964beab2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8de27387964beab2$var$gridSize = (0, $aP6k3.gridSize)();
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $8de27387964beab2$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: "auto"
};
var $8de27387964beab2$var$lineHeights = {
    default: $8de27387964beab2$var$heights.default,
    compact: $8de27387964beab2$var$heights.compact,
    none: "inherit"
};
var $8de27387964beab2$var$padding = {
    // 10px gutter
    default: "0 ".concat($8de27387964beab2$var$gridSize + $8de27387964beab2$var$gridSize / 4, "px"),
    compact: "0 ".concat($8de27387964beab2$var$gridSize + $8de27387964beab2$var$gridSize / 4, "px"),
    none: "0"
};
var $8de27387964beab2$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($8de27387964beab2$var$gridSize / 4, "px"),
    default: "0 ".concat($8de27387964beab2$var$gridSize / 4, "px"),
    none: "0"
};
var $8de27387964beab2$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $8de27387964beab2$var$innerMargin = {
    content: "0 ".concat($8de27387964beab2$var$gridSize / 4, "px"),
    icon: "0 ".concat($8de27387964beab2$var$gridSize / 4, "px")
};
function $8de27387964beab2$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $8de27387964beab2$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $8de27387964beab2$var$getColor({
            group: (0, $4zqY2.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($8de27387964beab2$var$getColor({
            group: (0, $4zqY2.default).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $8de27387964beab2$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $8de27387964beab2$var$getColors({
        appearance: appearance,
        key: isSelected ? "selected" : "default",
        mode: mode
    });
    return $8de27387964beab2$var$_objectSpread($8de27387964beab2$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: 500,
        // margin for button has been applied to css reset
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap"
    }, baseColors), {}, {
        cursor: "pointer",
        height: $8de27387964beab2$var$heights[spacing],
        lineHeight: $8de27387964beab2$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $8de27387964beab2$var$singleIconPadding[spacing] : $8de27387964beab2$var$padding[spacing],
        verticalAlign: $8de27387964beab2$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center",
        // Note: we cannot disable pointer events when there is an overlay.
        // That would be easy for styling, but it would start letting events through on disabled buttons
        // Disabling visited styles (just using the base colors)
        "&:visited": $8de27387964beab2$var$_objectSpread({}, baseColors),
        "&:hover": $8de27387964beab2$var$_objectSpread($8de27387964beab2$var$_objectSpread({}, $8de27387964beab2$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "hover",
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "inherit",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        // giving active styles preference by listing them after focus
        "&:active": $8de27387964beab2$var$_objectSpread($8de27387964beab2$var$_objectSpread({}, $8de27387964beab2$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $8de27387964beab2$var$_objectSpread($8de27387964beab2$var$_objectSpread({}, $8de27387964beab2$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        "&[disabled]": $8de27387964beab2$var$_objectSpread($8de27387964beab2$var$_objectSpread({}, $8de27387964beab2$var$getColors({
            appearance: appearance,
            key: "disabled",
            mode: mode
        })), {}, {
            cursor: "not-allowed",
            textDecoration: "none"
        }),
        '&[data-has-overlay="true"]': {
            cursor: "default",
            textDecoration: "none"
        },
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $8de27387964beab2$var$_objectSpread({}, $8de27387964beab2$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "default",
            mode: mode
        })),
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $8de27387964beab2$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $avKww.css)({
        display: "flex",
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $8de27387964beab2$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: "center",
        fontSize: 0,
        lineHeight: 0,
        userSelect: "none"
    });
}
function $8de27387964beab2$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $avKww.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $8de27387964beab2$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    });
}
function $8de27387964beab2$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $avKww.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: "opacity 0.3s"
    });
}
var $8de27387964beab2$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

});
parcelRegister("4zqY2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $353f597a086e3f0b$export$2e2bcd8739ae039; });

var $jp7ng = parcelRequire("jp7ng");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $353f597a086e3f0b$var$fadedB75 = "rgba(179, 212, 255, 0.6)";
var $353f597a086e3f0b$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($jp7ng.N20A, ")"),
                dark: "var(--ds-background-neutral, ".concat($jp7ng.DN70, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($jp7ng.N30A, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($jp7ng.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($353f597a086e3f0b$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($jp7ng.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($jp7ng.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($jp7ng.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.DN0, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($jp7ng.B400, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($jp7ng.B100, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($jp7ng.B300, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($jp7ng.B75, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($jp7ng.B500, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($jp7ng.B200, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($jp7ng.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($jp7ng.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.DN0, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($jp7ng.Y300, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($jp7ng.Y300, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($jp7ng.Y200, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($jp7ng.Y200, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($jp7ng.Y400, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($jp7ng.Y400, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($jp7ng.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($jp7ng.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.Y400, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.Y400, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($jp7ng.R400, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($jp7ng.R400, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($jp7ng.R300, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($jp7ng.R300, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($jp7ng.R500, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($jp7ng.R500, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($jp7ng.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($jp7ng.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.R500, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.R500, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.N20, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($jp7ng.N30A, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($jp7ng.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($353f597a086e3f0b$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($jp7ng.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.DN0, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($jp7ng.N20, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($jp7ng.N500, ")"),
                dark: "var(--ds-text, ".concat($jp7ng.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($jp7ng.B400, ")"),
                dark: "var(--ds-text, ".concat($jp7ng.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jp7ng.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jp7ng.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.DN400, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($jp7ng.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($jp7ng.DN30, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jp7ng.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jp7ng.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.DN400, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($jp7ng.N800, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($jp7ng.N800, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jp7ng.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jp7ng.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.N800, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.N800, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($jp7ng.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($jp7ng.N0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jp7ng.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jp7ng.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.N0, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.N0, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($jp7ng.B400, ")"),
                dark: "var(--ds-link, ".concat($jp7ng.B100, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($jp7ng.B300, ")"),
                dark: "var(--ds-link, ".concat($jp7ng.B75, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($jp7ng.B500, ")"),
                dark: "var(--ds-link-pressed, ".concat($jp7ng.B200, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jp7ng.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jp7ng.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.N700, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.N700, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($jp7ng.N500, ")"),
                dark: "var(--ds-text, ".concat($jp7ng.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($jp7ng.B400, ")"),
                dark: "var(--ds-text, ".concat($jp7ng.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jp7ng.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jp7ng.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.DN400, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-text-subtle, ".concat($jp7ng.N200, ")"),
                dark: "var(--ds-text-subtle, ".concat($jp7ng.DN400, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($jp7ng.N90, ")"),
                dark: "var(--ds-text-subtle, ".concat($jp7ng.B50, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($jp7ng.N400, ")"),
                dark: "var(--ds-text, ".concat($jp7ng.DN300, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jp7ng.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($jp7ng.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($jp7ng.DN400, ")")
            }
        }
    }
};
var $353f597a086e3f0b$export$2e2bcd8739ae039 = $353f597a086e3f0b$var$values;

});


parcelRegister("9onJM", function(module, exports) {

$parcel$export(module.exports, "getIfVisuallyHiddenChildren", function () { return $6d68c4af29d150cd$export$20bbd2efb0d734c4; });

var $9nHZC = parcelRequire("9nHZC");

var $7S7GL = parcelRequire("7S7GL");
var $6d68c4af29d150cd$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $9nHZC.isValidElement)(children) && children.type === (0, $7S7GL.default);
};

});


parcelRegister("k8LtO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea9962823657f1da$export$2e2bcd8739ae039; });

var $9onJM = parcelRequire("9onJM");
function $ea9962823657f1da$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $9onJM.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});


parcelRegister("i00RS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d1a8e670a32b36c1$var$_react = $d1a8e670a32b36c1$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $d1a8e670a32b36c1$var$_crossCircle = $d1a8e670a32b36c1$var$_interopRequireDefault((parcelRequire("cGWHP")));
function $d1a8e670a32b36c1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d1a8e670a32b36c1$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $d1a8e670a32b36c1$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m13.477 9.113-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41"/><path fill="inherit" d="m9.084 10.501 4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411"/></g></svg>`
    }, props, {
        newIcon: $d1a8e670a32b36c1$var$_crossCircle.default
    }));
$d1a8e670a32b36c1$var$CrossCircleIcon.displayName = "CrossCircleIcon";
var $d1a8e670a32b36c1$var$_default = module.exports.default = $d1a8e670a32b36c1$var$CrossCircleIcon;

});
parcelRegister("cGWHP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e3245a4cda5405cbe39cdb10fb1ac0b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $93d6f208d806c1e6$var$_react = $93d6f208d806c1e6$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $93d6f208d806c1e6$var$_UNSAFE_baseNew = $93d6f208d806c1e6$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $93d6f208d806c1e6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $93d6f208d806c1e6$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $93d6f208d806c1e6$var$_react.default.createElement($93d6f208d806c1e6$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$93d6f208d806c1e6$var$CrossCircleIcon.displayName = "CrossCircleIcon";
var $93d6f208d806c1e6$var$_default = module.exports.default = $93d6f208d806c1e6$var$CrossCircleIcon;

});


parcelRegister("auXFA", function(module, exports) {

$parcel$export(module.exports, "ErrorWrapper", function () { return $7a4afde79bb1f2ad$export$bb27b7e39840238f; });
$parcel$export(module.exports, "ErrorTitle", function () { return $7a4afde79bb1f2ad$export$b065fd053267ec81; });
$parcel$export(module.exports, "ErrorText", function () { return $7a4afde79bb1f2ad$export$7f714e6c560938e5; });
$parcel$export(module.exports, "TeamErrorTitle", function () { return $7a4afde79bb1f2ad$export$d139ade0bdee219d; });
$parcel$export(module.exports, "TeamErrorText", function () { return $7a4afde79bb1f2ad$export$90d92ccfb27352c6; });

var $73D4V = parcelRequire("73D4V");

var $jp7ng = parcelRequire("jp7ng");

var $aP6k3 = parcelRequire("aP6k3");

var $dCDrX = parcelRequire("dCDrX");

var $bVB8f = parcelRequire("bVB8f");
var $7a4afde79bb1f2ad$export$bb27b7e39840238f = (0, $73D4V.default).div({
    textAlign: "center",
    padding: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $bVB8f.errorIconColor)
});
var $7a4afde79bb1f2ad$export$b065fd053267ec81 = (0, $73D4V.default).p({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $bVB8f.errorTitleColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: "".concat((0, $aP6k3.gridSize)() * 3, "px"),
    margin: "var(--ds-space-100, 8px)".concat(" 0")
});
var $7a4afde79bb1f2ad$export$7f714e6c560938e5 = (0, $73D4V.default).span({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $bVB8f.errorTextColor)
});
var $7a4afde79bb1f2ad$export$d139ade0bdee219d = (0, $73D4V.default).p((0, $dCDrX.h400));
var $7a4afde79bb1f2ad$export$90d92ccfb27352c6 = (0, $73D4V.default).p({
    color: "var(--ds-text-subtlest, ".concat((0, $jp7ng.N200), ")"),
    marginTop: "var(--ds-space-100, 8px)"
});

});
parcelRegister("73D4V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5237205e675a7cdb$export$2e2bcd8739ae039; });

var $cwfGi = parcelRequire("cwfGi");
parcelRequire("fPPqr");
parcelRequire("9nHZC");
parcelRequire("7USxn");

parcelRequire("aYxxu");
parcelRequire("9xCOS");
parcelRequire("gxh9m");
var $5237205e675a7cdb$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $5237205e675a7cdb$export$2e2bcd8739ae039 = (0, $cwfGi.default).bind();
$5237205e675a7cdb$var$tags.forEach(function(tagName) {
    $5237205e675a7cdb$export$2e2bcd8739ae039[tagName] = $5237205e675a7cdb$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("cwfGi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91d4a322385fe654$export$2e2bcd8739ae039; });

var $ii97e = parcelRequire("ii97e");

var $9nHZC = parcelRequire("9nHZC");

var $7USxn = parcelRequire("7USxn");
parcelRequire("avKww");
var $hp0gY = parcelRequire("hp0gY");

var $aYxxu = parcelRequire("aYxxu");

var $9xCOS = parcelRequire("9xCOS");

var $gxh9m = parcelRequire("gxh9m");
/* import type {
  ElementType,
  StatelessFunctionalComponent,
  AbstractComponent
} from 'react' */ /*
export type Interpolations = Array<any>

export type StyledElementType<Props> =
  | string
  | AbstractComponent<{ ...Props, className: string }, mixed>

export type StyledOptions = {
  label?: string,
  shouldForwardProp?: string => boolean,
  target?: string
}

export type StyledComponent<Props> = StatelessFunctionalComponent<Props> & {
  defaultProps: any,
  toString: () => string,
  withComponent: (
    nextTag: StyledElementType<Props>,
    nextOptions?: StyledOptions
  ) => StyledComponent<Props>
}

export type PrivateStyledComponent<Props> = StyledComponent<Props> & {
  __emotion_real: StyledComponent<Props>,
  __emotion_base: any,
  __emotion_styles: any,
  __emotion_forwardProp: any
}
*/ var $91d4a322385fe654$var$testOmitPropsOnStringTag = (0, $7USxn.default);
var $91d4a322385fe654$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $91d4a322385fe654$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $91d4a322385fe654$var$testOmitPropsOnStringTag : $91d4a322385fe654$var$testOmitPropsOnComponent;
};
var $91d4a322385fe654$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
/*
export type CreateStyledComponent = <Props>(
  ...args: Interpolations
) => StyledComponent<Props>

export type CreateStyled = {
  <Props>(
    tag: StyledElementType<Props>,
    options?: StyledOptions
  ): (...args: Interpolations) => StyledComponent<Props>,
  [key: string]: CreateStyledComponent,
  bind: () => CreateStyled
}
*/ var $91d4a322385fe654$var$isDevelopment = false;
var $91d4a322385fe654$var$isBrowser = typeof document !== "undefined";
var $91d4a322385fe654$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $aYxxu.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $gxh9m.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $aYxxu.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$91d4a322385fe654$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $9nHZC.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $91d4a322385fe654$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $91d4a322385fe654$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $91d4a322385fe654$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    /* return function<Props>(): PrivateStyledComponent<Props> { */ return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        }
        var Styled = (0, $hp0gY.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $9nHZC.useContext((0, $hp0gY.T));
            }
            if (typeof props.className === "string") className = (0, $aYxxu.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $9xCOS.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $91d4a322385fe654$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $9nHZC.createElement($9nHZC.Fragment, null, /*#__PURE__*/ $9nHZC.createElement($91d4a322385fe654$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $9nHZC.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                if (targetClassName === undefined && $91d4a322385fe654$var$isDevelopment) return "NO_COMPONENT_SELECTOR";
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $ii97e.default)({}, options, nextOptions, {
                shouldForwardProp: $91d4a322385fe654$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("7USxn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c38115d8881885c$export$2e2bcd8739ae039; });

var $hbL4z = parcelRequire("hbL4z");
// eslint-disable-next-line no-undef
var $5c38115d8881885c$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $5c38115d8881885c$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $hbL4z.default)(function(prop) {
    return $5c38115d8881885c$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("hbL4z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c837fa6c5ec65215$export$2e2bcd8739ae039; });
function $c837fa6c5ec65215$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("aYxxu", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $7fd9862bab7420c0$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $7fd9862bab7420c0$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $7fd9862bab7420c0$export$6f077d94b33a01aa; });
var $7fd9862bab7420c0$var$isBrowser = typeof document !== "undefined";
function $7fd9862bab7420c0$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $7fd9862bab7420c0$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $7fd9862bab7420c0$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $7fd9862bab7420c0$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $7fd9862bab7420c0$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = "";
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            if (!$7fd9862bab7420c0$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$7fd9862bab7420c0$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});



parcelRegister("bVB8f", function(module, exports) {

$parcel$export(module.exports, "bgColor", function () { return $8af1d23fd2ead0b0$export$7dcbec377a25efc6; });
$parcel$export(module.exports, "headerBgColor", function () { return $8af1d23fd2ead0b0$export$d3ec0459d8f4bbed; });
$parcel$export(module.exports, "teamHeaderBgColor", function () { return $8af1d23fd2ead0b0$export$afc7ad7e78cf1c79; });
$parcel$export(module.exports, "headerBgColorDisabledUser", function () { return $8af1d23fd2ead0b0$export$ef73fded6fab455c; });
$parcel$export(module.exports, "headerTextColor", function () { return $8af1d23fd2ead0b0$export$5c2df128da90e8de; });
$parcel$export(module.exports, "headerTextColorInactive", function () { return $8af1d23fd2ead0b0$export$a882617dcf7f98a6; });
$parcel$export(module.exports, "appLabelBgColor", function () { return $8af1d23fd2ead0b0$export$6f79b778f6280d31; });
$parcel$export(module.exports, "appLabelTextColor", function () { return $8af1d23fd2ead0b0$export$3db47a978b9599f9; });
$parcel$export(module.exports, "labelTextColor", function () { return $8af1d23fd2ead0b0$export$dd73341f2a5541fa; });
$parcel$export(module.exports, "labelIconColor", function () { return $8af1d23fd2ead0b0$export$5a20f73e634c37e3; });
$parcel$export(module.exports, "errorIconColor", function () { return $8af1d23fd2ead0b0$export$85e73a744c5d1042; });
$parcel$export(module.exports, "errorTitleColor", function () { return $8af1d23fd2ead0b0$export$be3c814f7ed506ed; });
$parcel$export(module.exports, "errorTextColor", function () { return $8af1d23fd2ead0b0$export$ddf766d3bfcf965c; });

var $jp7ng = parcelRequire("jp7ng");
var $8af1d23fd2ead0b0$export$7dcbec377a25efc6 = "var(--ds-surface-overlay, ".concat((0, $jp7ng.N0), ")");
var $8af1d23fd2ead0b0$export$d3ec0459d8f4bbed = "var(--ds-background-brand-bold, ".concat((0, $jp7ng.B500), ")");
var $8af1d23fd2ead0b0$export$afc7ad7e78cf1c79 = "var(--ds-background-neutral, ".concat((0, $jp7ng.N50), ")");
var $8af1d23fd2ead0b0$export$ef73fded6fab455c = "var(--ds-background-disabled, ".concat((0, $jp7ng.N30), ")");
var $8af1d23fd2ead0b0$export$5c2df128da90e8de = "var(--ds-text-inverse, ".concat((0, $jp7ng.N0), ")");
var $8af1d23fd2ead0b0$export$a882617dcf7f98a6 = "var(--ds-text, ".concat((0, $jp7ng.N800), ")");
var $8af1d23fd2ead0b0$export$6f79b778f6280d31 = "var(--ds-background-neutral, ".concat((0, $jp7ng.N20), ")");
var $8af1d23fd2ead0b0$export$3db47a978b9599f9 = "var(--ds-text, ".concat((0, $jp7ng.N500), ")");
var $8af1d23fd2ead0b0$export$dd73341f2a5541fa = "var(--ds-text, ".concat((0, $jp7ng.N800), ")");
var $8af1d23fd2ead0b0$export$5a20f73e634c37e3 = "var(--ds-text-subtlest, ".concat((0, $jp7ng.N60), ")");
var $8af1d23fd2ead0b0$export$85e73a744c5d1042 = "var(--ds-text-disabled, ".concat((0, $jp7ng.N90), ")");
var $8af1d23fd2ead0b0$export$be3c814f7ed506ed = "var(--ds-text, ".concat((0, $jp7ng.N800), ")");
var $8af1d23fd2ead0b0$export$ddf766d3bfcf965c = "var(--ds-text-subtlest, ".concat((0, $jp7ng.N90), ")");

});




parcelRegister("c1aX4", function(module, exports) {

$parcel$export(module.exports, "TeamProfileCardLazy", function () { return $8bfe12d7ca22e4c5$export$82a49d896f41ca78; });

var $9nHZC = parcelRequire("9nHZC");

var $8bfe12d7ca22e4c5$export$82a49d896f41ca78 = /*#__PURE__*/ (0, $9nHZC.lazy)(function() {
    return Promise.resolve((parcelRequire("3bPcB")));
});

});
parcelRegister("3bPcB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $252a1de3bc7a316a$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $b4Ivn = parcelRequire("b4Ivn");

var $9q1kH = parcelRequire("9q1kH");

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $eygjM = parcelRequire("eygjM");

var $71gev = parcelRequire("71gev");

var $lpXGp = parcelRequire("lpXGp");

var $7fgJe = parcelRequire("7fgJe");

var $dxhCu = parcelRequire("dxhCu");

var $kb4D4 = parcelRequire("kb4D4");

var $fuPTF = parcelRequire("fuPTF");
var $8HHuo = parcelRequire("8HHuo");

var $93cMI = parcelRequire("93cMI");

var $aP6k3 = parcelRequire("aP6k3");

var $gFUKI = parcelRequire("gFUKI");

var $iJFBU = parcelRequire("iJFBU");

var $7daq7 = parcelRequire("7daq7");

var $auXFA = parcelRequire("auXFA");

var $5YVyh = parcelRequire("5YVyh");

var $18aOe = parcelRequire("18aOe");

var $eGUrQ = parcelRequire("eGUrQ");
parcelRequire("2ib6V");
var $c1XL9 = parcelRequire("c1XL9");

var $bZ064 = parcelRequire("bZ064");

var $iF2LN = parcelRequire("iF2LN");
function $252a1de3bc7a316a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $252a1de3bc7a316a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $252a1de3bc7a316a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $252a1de3bc7a316a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $252a1de3bc7a316a$var$LARGE_MEMBER_COUNT = 50;
var $252a1de3bc7a316a$var$GIVE_KUDOS_ACTION_ID = "give-kudos";
function $252a1de3bc7a316a$var$onMemberClick(callback, userId, analytics, index, hasHref) {
    return function(event) {
        analytics(function(duration) {
            return (0, $18aOe.teamAvatarClicked)({
                duration: duration,
                hasHref: hasHref,
                hasOnClick: !!callback,
                index: index
            });
        });
        if (callback) callback(userId, event);
    };
}
var $252a1de3bc7a316a$var$TeamMembers = function TeamMembers(_ref) {
    var analytics = _ref.analytics, generateUserLink = _ref.generateUserLink, members = _ref.members, onUserClick = _ref.onUserClick, includingYou = _ref.includingYou;
    var count = members ? members.length : 0;
    var message = includingYou ? count >= $252a1de3bc7a316a$var$LARGE_MEMBER_COUNT ? (0, $iJFBU.default).membersMoreThan50IncludingYou : (0, $iJFBU.default).memberCountIncludingYou : count >= $252a1de3bc7a316a$var$LARGE_MEMBER_COUNT ? (0, $iJFBU.default).membersMoreThan50 : (0, $iJFBU.default).memberCount;
    // Use a ref to track whether this is currently open, so we can fire events
    // iff the more section is being opened (not closed).
    var isMoreMembersOpen = (0, $9nHZC.useRef)(false);
    var onMoreClick = (0, $9nHZC.useCallback)(function() {
        var isOpen = isMoreMembersOpen.current;
        if (!isOpen) analytics(function(duration) {
            return (0, $18aOe.moreMembersClicked)({
                duration: duration,
                memberCount: count
            });
        });
        isMoreMembersOpen.current = !isOpen;
    }, [
        analytics,
        count
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5YVyh.MemberCount), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eygjM.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, message, {
        values: {
            count: count
        }
    }))), members && members.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5YVyh.AvatarSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $71gev.default), {
        appearance: "stack",
        data: members.map(function(member, index) {
            var href = generateUserLink === null || generateUserLink === void 0 ? void 0 : generateUserLink(member.id);
            var onClick = $252a1de3bc7a316a$var$onMemberClick(onUserClick, member.id, analytics, index, !!generateUserLink);
            return {
                key: member.id,
                name: member.fullName,
                src: member.avatarUrl,
                href: href,
                onClick: onClick
            };
        }),
        maxCount: 9,
        showMoreButtonProps: {
            onClick: onMoreClick
        },
        testId: "profilecard-avatar-group"
    })));
};
function $252a1de3bc7a316a$var$onActionClick(action, analytics, index) {
    return function(event) {
        analytics(function(duration) {
            return (0, $18aOe.actionClicked)("team", {
                duration: duration,
                hasHref: !!action.link,
                hasOnClick: !!action.callback,
                index: index,
                actionId: action.id || ""
            });
        });
        if (action.callback && (0, $eGUrQ.isBasicClick)(event)) {
            event.preventDefault();
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            action.callback.apply(action, [
                event
            ].concat(args));
        }
    };
}
var $252a1de3bc7a316a$var$ActionButton = function ActionButton(_ref2) {
    var action = _ref2.action, analytics = _ref2.analytics, index = _ref2.index;
    var isGiveKudosActionButton = action.id === $252a1de3bc7a316a$var$GIVE_KUDOS_ACTION_ID;
    var actionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dxhCu.default), {
        isInset: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7fgJe.default), {
        key: action.id || index,
        onClick: $252a1de3bc7a316a$var$onActionClick(action, analytics, index),
        href: action.link,
        shouldFitContainer: true
    }, action.label, isGiveKudosActionButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.AnimationWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.KudosBlobAnimation), null))));
    if (isGiveKudosActionButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.AnimatedKudosButton), null, actionButton);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5YVyh.WrappedButton), null, actionButton);
};
var $252a1de3bc7a316a$var$ExtraActions = function ExtraActions(_ref3) {
    var actions = _ref3.actions, analytics = _ref3.analytics;
    var _useState = (0, $9nHZC.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), isOpen = _useState2[0], setOpen = _useState2[1];
    var count = actions.length;
    var onMoreClick = (0, $9nHZC.useCallback)(function(shouldBeOpen) {
        if (shouldBeOpen) // Only fire this event when OPENING the dropdown
        analytics(function(duration) {
            return (0, $18aOe.moreActionsClicked)("team", {
                duration: duration,
                numActions: count + 2
            });
        });
        setOpen(shouldBeOpen);
    }, [
        analytics,
        count
    ]);
    if (!count) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5YVyh.MoreButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $93cMI.default), {
        isOpen: isOpen,
        onClose: function onClose() {
            return setOpen(false);
        },
        placement: "bottom-start",
        content: function content() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $8HHuo.default), null, actions.map(function(action, index) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fuPTF.default), {
                    onClick: $252a1de3bc7a316a$var$onActionClick(action, analytics, index + 2),
                    key: action.id || index,
                    href: action.link
                }, action.label);
            }));
        },
        trigger: function trigger(triggerProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7fgJe.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                testId: "more-actions-button"
            }, triggerProps, {
                isSelected: isOpen,
                onClick: function onClick() {
                    return onMoreClick(!isOpen);
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kb4D4))), {
                    label: "actions"
                })
            }));
        },
        zIndex: (0, $aP6k3.layers).modal()
    }));
};
var $252a1de3bc7a316a$var$ButtonSection = function ButtonSection(_ref4) {
    var actions = _ref4.actions, analytics = _ref4.analytics;
    if (!actions) return null;
    var extraActions = actions.slice(2);
    var initialActions = actions.slice(0, 2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5YVyh.ActionButtons), null, initialActions.map(function(action, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($252a1de3bc7a316a$var$ActionButton, {
            action: action,
            analytics: analytics,
            index: index,
            key: index
        });
    }), extraActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($252a1de3bc7a316a$var$ExtraActions, {
        actions: extraActions,
        analytics: analytics
    }));
};
var $252a1de3bc7a316a$var$TeamProfilecardContent = function TeamProfilecardContent(_ref5) {
    var actions = _ref5.actions, analytics = _ref5.analytics, team = _ref5.team, viewingUserId = _ref5.viewingUserId, generateUserLink = _ref5.generateUserLink, onUserClick = _ref5.onUserClick, viewProfileLink = _ref5.viewProfileLink, viewProfileOnClick = _ref5.viewProfileOnClick;
    var allActions = [
        {
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eygjM.default), (0, $iJFBU.default).teamViewProfile),
            link: viewProfileLink,
            callback: viewProfileOnClick,
            id: "view-profile"
        }
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(actions || []));
    var includingYou = team.members && team.members.some(function(member) {
        return member.id === viewingUserId;
    });
    (0, $9nHZC.useEffect)(function() {
        analytics(function(duration) {
            var _team$members;
            return (0, $18aOe.profileCardRendered)("team", "content", {
                duration: duration,
                numActions: allActions.length,
                memberCount: (_team$members = team.members) === null || _team$members === void 0 ? void 0 : _team$members.length,
                includingYou: includingYou,
                descriptionLength: team.description.length,
                titleLength: team.displayName.length
            });
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5YVyh.CardWrapper), {
        "data-testid": "team-profilecard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5YVyh.CardHeader), {
        image: team.largeHeaderImageUrl || team.smallHeaderImageUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5YVyh.CardContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $gFUKI.default), {
        content: team.displayName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5YVyh.TeamName), null, team.displayName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($252a1de3bc7a316a$var$TeamMembers, {
        analytics: analytics,
        members: team.members,
        generateUserLink: generateUserLink,
        includingYou: includingYou,
        onUserClick: onUserClick
    }), team.description.trim() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5YVyh.DescriptionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5YVyh.Description), null, team.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($252a1de3bc7a316a$var$ButtonSection, {
        actions: allActions,
        analytics: analytics
    })));
};
var $252a1de3bc7a316a$var$ErrorMessage = function ErrorMessage(_ref6) {
    var analytics = _ref6.analytics, clientFetchProfile = _ref6.clientFetchProfile, isLoading = _ref6.isLoading;
    var hasRetry = !!clientFetchProfile;
    (0, $9nHZC.useEffect)(function() {
        analytics(function(duration) {
            return (0, $18aOe.profileCardRendered)("team", "error", {
                duration: duration,
                hasRetry: hasRetry
            });
        });
    }, [
        analytics,
        hasRetry
    ]);
    var retry = (0, $9nHZC.useCallback)(function() {
        analytics(function(duration) {
            return (0, $18aOe.errorRetryClicked)({
                duration: duration
            });
        });
        if (clientFetchProfile) clientFetchProfile();
    }, [
        analytics,
        clientFetchProfile
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $auXFA.ErrorWrapper), {
        "data-testid": "team-profilecard-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $c1XL9.ErrorIllustration), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $auXFA.TeamErrorTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eygjM.default), (0, $iJFBU.default).teamErrorTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $auXFA.TeamErrorText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eygjM.default), (0, $iJFBU.default).teamErrorText)), clientFetchProfile && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5YVyh.ActionButtons), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5YVyh.WrappedButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $lpXGp.default), {
        testId: "client-fetch-profile-button",
        shouldFitContainer: true,
        onClick: retry,
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eygjM.default), (0, $iJFBU.default).teamErrorButton)))));
};
var $252a1de3bc7a316a$var$TeamProfileCard = function TeamProfileCard(props) {
    var analytics = props.analytics, clientFetchProfile = props.clientFetchProfile, hasError = props.hasError, isLoading = props.isLoading, team = props.team, errorType = props.errorType;
    if (hasError) {
        if ((errorType === null || errorType === void 0 ? void 0 : errorType.reason) === "TEAMS_FORBIDDEN") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $bZ064.default), {
            analytics: analytics
        });
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5YVyh.CardWrapper), {
            "data-testid": "team-profilecard"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($252a1de3bc7a316a$var$ErrorMessage, {
            analytics: analytics,
            clientFetchProfile: clientFetchProfile,
            isLoading: isLoading
        }));
    }
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $iF2LN.default), {
        analytics: analytics
    });
    if (team) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($252a1de3bc7a316a$var$TeamProfilecardContent, $252a1de3bc7a316a$var$_objectSpread($252a1de3bc7a316a$var$_objectSpread({}, props), {}, {
        team: team
    }));
    return null;
};
var $252a1de3bc7a316a$export$2e2bcd8739ae039 = $252a1de3bc7a316a$var$TeamProfileCard;

});
parcelRegister("71gev", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51c537ecc8acd558$export$2e2bcd8739ae039; });

var $9q1kH = parcelRequire("9q1kH");

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $1FiMp = parcelRequire("1FiMp");

var $inFLm = parcelRequire("inFLm");

var $70mT6 = parcelRequire("70mT6");

var $8p2GL = parcelRequire("8p2GL");

var $eIHpi = parcelRequire("eIHpi");

var $4ymzH = parcelRequire("4ymzH");

var $93cMI = parcelRequire("93cMI");

var $a3hI0 = parcelRequire("a3hI0");

var $l68LM = parcelRequire("l68LM");

var $i4IhC = parcelRequire("i4IhC");

var $lXsdT = parcelRequire("lXsdT");

var $dUVR7 = parcelRequire("dUVR7");

var $02hCv = parcelRequire("02hCv");

var $kEgCC = parcelRequire("kEgCC");

var $dKFm7 = parcelRequire("dKFm7");

var $iIo2D = parcelRequire("iIo2D");
function $51c537ecc8acd558$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $51c537ecc8acd558$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $51c537ecc8acd558$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $51c537ecc8acd558$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $51c537ecc8acd558$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $51c537ecc8acd558$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: $51c537ecc8acd558$var$_objectSpread({
            render: function render(Component, props, index) {
                return (0, $avKww.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
                    key: (0, $iIo2D.composeUniqueKey)(props.avatar, index)
                }));
            }
        }, overrides && overrides.AvatarGroupItem),
        Avatar: $51c537ecc8acd558$var$_objectSpread({
            render: function render(Component, props, index) {
                return (0, $avKww.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
                    key: (0, $iIo2D.composeUniqueKey)(props, index)
                }));
            }
        }, overrides && overrides.Avatar)
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ var $51c537ecc8acd558$var$AvatarGroup = function AvatarGroup(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "stack" : _ref$appearance, _ref$avatar = _ref.avatar, avatar = _ref$avatar === void 0 ? (0, $inFLm.default) : _ref$avatar, borderColor = _ref.borderColor, boundariesElement = _ref.boundariesElement, data = _ref.data, isTooltipDisabled = _ref.isTooltipDisabled, maxCount = _ref.maxCount, onAvatarClick = _ref.onAvatarClick, onMoreClick = _ref.onMoreClick, overrides = _ref.overrides, _ref$showMoreButtonPr = _ref.showMoreButtonProps, showMoreButtonProps = _ref$showMoreButtonPr === void 0 ? {} : _ref$showMoreButtonPr, _ref$size = _ref.size, size = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId, _ref$label = _ref.label, label = _ref$label === void 0 ? "avatar group" : _ref$label, _ref$tooltipPosition = _ref.tooltipPosition, tooltipPosition = _ref$tooltipPosition === void 0 ? "bottom" : _ref$tooltipPosition, _ref$shouldPopupRende = _ref.shouldPopupRenderToParent, shouldPopupRenderToParent = _ref$shouldPopupRende === void 0 ? false : _ref$shouldPopupRende;
    var _useState = (0, $9nHZC.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), isTriggeredUsingKeyboard = _useState2[0], setTriggeredUsingKeyboard = _useState2[1];
    var _useState3 = (0, $9nHZC.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState3, 2), isOpen = _useState4[0], setIsOpen = _useState4[1];
    var onClose = (0, $9nHZC.useCallback)(function() {
        return setIsOpen(false);
    }, []);
    var handleTriggerClicked = (0, $9nHZC.useCallback)(function(event) {
        var _ref2 = event, clientX = _ref2.clientX, clientY = _ref2.clientY, type = _ref2.type;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === "keydown" || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen(function(isOpen) {
            return !isOpen;
        });
    }, []);
    var _useFocus = (0, $eIHpi.default)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $9nHZC.useEffect)(function() {
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $8p2GL.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $8p2GL.default;
        (0, $1FiMp.bind)(window, {
            type: "keydown",
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $70mT6.KEY_DOWN)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        var unbind = function unbind() {
            (0, $1FiMp.bind)(window, {
                type: "keydown",
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $70mT6.KEY_DOWN)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total) {
        if (total <= max) return null;
        var renderMoreButton = function renderMoreButton(props) {
            return (0, $avKww.jsx)((0, $kEgCC.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && "".concat(testId, "--overflow-menu--trigger"),
                isActive: isOpen
            }, props));
        };
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === "function") return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        var boundary = boundariesElement === "scrollParent" ? "clippingParents" : undefined;
        var rootBoundary = function() {
            if (boundariesElement === "scrollParent") return undefined;
            return boundariesElement === "window" ? "document" : "viewport";
        }();
        return (0, $avKww.jsx)((0, $93cMI.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: (0, $a3hI0.layers).modal(),
            shouldRenderToParent: shouldPopupRenderToParent,
            content: function content(_ref3) {
                var setInitialFocusRef = _ref3.setInitialFocusRef;
                return (0, $avKww.jsx)((0, $dUVR7.default), null, (0, $avKww.jsx)((0, $02hCv.default), {
                    onClick: function onClick(e) {
                        return e.stopPropagation();
                    },
                    minWidth: 250,
                    maxHeight: 300,
                    setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined
                }, (0, $avKww.jsx)((0, $4ymzH.default), null, data.slice(max).map(function(avatar, index) {
                    return $51c537ecc8acd558$var$getOverrides(overrides).AvatarGroupItem.render((0, $i4IhC.default), {
                        avatar: avatar,
                        onAvatarClick: onAvatarClick,
                        testId: testId && "".concat(testId, "--avatar-group-item-").concat(index + max),
                        index: index + max
                    }, // This index holds the true index,
                    // adding up the index of non-overflowed avatars and overflowed avatars.
                    index + max);
                }))));
            },
            trigger: function trigger(triggerProps) {
                return renderMoreButton($51c537ecc8acd558$var$_objectSpread($51c537ecc8acd558$var$_objectSpread($51c537ecc8acd558$var$_objectSpread({}, triggerProps), bindFocus), {}, {
                    onClick: handleTriggerClicked
                }));
            },
            testId: testId && "".concat(testId, "--overflow-menu")
        });
    }
    var max = maxCount === undefined || maxCount === 0 ? $51c537ecc8acd558$var$MAX_COUNT[appearance] : maxCount;
    var total = data.length;
    var maxAvatar = total > max ? max - 1 : max;
    var Group = appearance === "stack" ? (0, $dKFm7.default) : (0, $lXsdT.default);
    return (0, $avKww.jsx)(Group, {
        testId: testId && "".concat(testId, "--avatar-group"),
        "aria-label": label
    }, data.slice(0, maxAvatar).map(function(avatarData, idx) {
        var callback = avatarData.onClick || onAvatarClick;
        var finalAvatar = $51c537ecc8acd558$var$getOverrides(overrides).Avatar.render(avatar, $51c537ecc8acd558$var$_objectSpread($51c537ecc8acd558$var$_objectSpread({}, avatarData), {}, {
            size: size,
            borderColor: borderColor || avatarData.borderColor,
            testId: testId && "".concat(testId, "--avatar-").concat(idx),
            onClick: callback ? function(event, analyticsEvent) {
                callback(event, analyticsEvent, idx);
            } : undefined,
            stackIndex: max - idx
        }), idx);
        return !isTooltipDisabled && !avatarData.isDisabled ? (0, $avKww.jsx)((0, $l68LM.default), {
            key: (0, $iIo2D.composeUniqueKey)(avatarData, idx),
            content: avatarData.name,
            testId: testId && "".concat(testId, "--tooltip-").concat(idx),
            position: tooltipPosition
        }, finalAvatar) : finalAvatar;
    }), renderMoreDropdown(+maxAvatar, total));
};
var $51c537ecc8acd558$export$2e2bcd8739ae039 = $51c537ecc8acd558$var$AvatarGroup;

});
parcelRegister("a3hI0", function(module, exports) {

$parcel$export(module.exports, "gridSize", function () { return $7517ebc4b027ffe1$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "layers", function () { return $7517ebc4b027ffe1$export$7be255094ccdc533; });

var $1OnrY = parcelRequire("1OnrY");

var $eZPmg = parcelRequire("eZPmg");
var $7517ebc4b027ffe1$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $7517ebc4b027ffe1$export$c93026a968943f95 = "light";
var $7517ebc4b027ffe1$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $7517ebc4b027ffe1$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $7517ebc4b027ffe1$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $7517ebc4b027ffe1$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $7517ebc4b027ffe1$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $7517ebc4b027ffe1$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $7517ebc4b027ffe1$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $7517ebc4b027ffe1$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $eZPmg.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $7517ebc4b027ffe1$export$6d8204c2cb2e06b8() / 4;
    (0, $1OnrY.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $7517ebc4b027ffe1$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $7517ebc4b027ffe1$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $7517ebc4b027ffe1$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $1OnrY.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $7517ebc4b027ffe1$export$ba1d834b86d72a09 = $7517ebc4b027ffe1$export$a1b3edb637fb4f35;
var $7517ebc4b027ffe1$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $eZPmg.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $eZPmg.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $eZPmg.N30A), ")")
            }
        }
    };
};

});
parcelRegister("eZPmg", function(module, exports) {

$parcel$export(module.exports, "B50", function () { return $aeae99da463e0617$export$226de0355ed012f8; });
$parcel$export(module.exports, "B200", function () { return $aeae99da463e0617$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $aeae99da463e0617$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $aeae99da463e0617$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N0", function () { return $aeae99da463e0617$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $aeae99da463e0617$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $aeae99da463e0617$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N500", function () { return $aeae99da463e0617$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N800", function () { return $aeae99da463e0617$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $aeae99da463e0617$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $aeae99da463e0617$export$920c0d5c49070351; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $aeae99da463e0617$export$4b84fd0e2c617bd = "#FFEBE6";
var $aeae99da463e0617$export$b34b069eff244586 = "#FFBDAD";
var $aeae99da463e0617$export$be802dd0d8b57f35 = "#FF8F73";
var $aeae99da463e0617$export$60847d42f9da92a6 = "#FF7452";
var $aeae99da463e0617$export$4a7404f376229999 = "#FF5630";
var $aeae99da463e0617$export$2010d0fb4295b346 = "#DE350B";
var $aeae99da463e0617$export$2837b5a1a71d5c02 = "#BF2600";
var $aeae99da463e0617$export$8d9596b529bbb9cf = "#FFFAE6";
var $aeae99da463e0617$export$41060a744ab0b7ae = "#FFF0B3";
var $aeae99da463e0617$export$1cc05bbbf340e559 = "#FFE380";
var $aeae99da463e0617$export$5aae31392d72caaa = "#FFC400";
var $aeae99da463e0617$export$c6930421db9fa514 = "#FFAB00";
var $aeae99da463e0617$export$59619663aa6500fb = "#FF991F";
var $aeae99da463e0617$export$874739ea9e379ab6 = "#FF8B00";
var $aeae99da463e0617$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $aeae99da463e0617$export$69a3bf21b9686c2b = "#ABF5D1";
var $aeae99da463e0617$export$afbce1382ec95f73 = "#79F2C0";
var $aeae99da463e0617$export$747d86715d4175de = "#57D9A3";
var $aeae99da463e0617$export$940e1f69e873f202 = "#36B37E";
var $aeae99da463e0617$export$a49394138f7b8e85 = "#00875A";
var $aeae99da463e0617$export$6fa04827ac68a4fb = "#006644";
var $aeae99da463e0617$export$226de0355ed012f8 = "#DEEBFF";
var $aeae99da463e0617$export$8c13c2ee36917869 = "#B3D4FF";
var $aeae99da463e0617$export$ecfc1dff386a3e7a = "#4C9AFF";
var $aeae99da463e0617$export$215b7063051591f1 = "#2684FF";
var $aeae99da463e0617$export$e62e8919cca44969 = "#0065FF";
var $aeae99da463e0617$export$b3de0ae08da2ce64 = "#0052CC";
var $aeae99da463e0617$export$a6ee3d71bc067634 = "#0747A6";
var $aeae99da463e0617$export$363e4475840015bb = "#EAE6FF";
var $aeae99da463e0617$export$4b0a4417ed59760f = "#C0B6F2";
var $aeae99da463e0617$export$6011520a64d9a187 = "#998DD9";
var $aeae99da463e0617$export$a7175d4e9206bc80 = "#8777D9";
var $aeae99da463e0617$export$b48405b95304b5a1 = "#6554C0";
var $aeae99da463e0617$export$c71e4279dd54a18d = "#5243AA";
var $aeae99da463e0617$export$147899de772240ec = "#403294";
var $aeae99da463e0617$export$2cf711fe14c66f06 = "#E6FCFF";
var $aeae99da463e0617$export$7a8f4d33f6f9772c = "#B3F5FF";
var $aeae99da463e0617$export$776c9c497ef08533 = "#79E2F2";
var $aeae99da463e0617$export$69cb3ca10c1e330e = "#00C7E6";
var $aeae99da463e0617$export$9dc1ef0f3f48059b = "#00B8D9";
var $aeae99da463e0617$export$7c835c78b6fcdef8 = "#00A3BF";
var $aeae99da463e0617$export$6036577f95c3877e = "#008DA6";
var $aeae99da463e0617$export$29a4f05edc054374 = "#FFFFFF";
var $aeae99da463e0617$export$e655ef011c4aa1a2 = "#FAFBFC";
var $aeae99da463e0617$export$9fdfb749e33cdf97 = "#F4F5F7";
var $aeae99da463e0617$export$3e51e8f1440314ba = "#EBECF0";
var $aeae99da463e0617$export$1ce2d1575d444ceb = "#DFE1E6";
var $aeae99da463e0617$export$8754fc7e6d8b3000 = "#C1C7D0";
var $aeae99da463e0617$export$c2e91cbeada39b8b = "#B3BAC5";
var $aeae99da463e0617$export$5f71e19f3a7ad9de = "#A5ADBA";
var $aeae99da463e0617$export$eaa8c8a70ac22806 = "#97A0AF";
var $aeae99da463e0617$export$7c87d337fb91a97d = "#8993A4";
var $aeae99da463e0617$export$d6447c357493214f = "#7A869A";
var $aeae99da463e0617$export$f563ee71e9ee74cd = "#6B778C";
var $aeae99da463e0617$export$e2ef2124cf4024b1 = "#5E6C84";
var $aeae99da463e0617$export$eece5f492e429f08 = "#505F79";
var $aeae99da463e0617$export$c39c0fe0f26207ae = "#42526E";
var $aeae99da463e0617$export$7090862dc3038a9f = "#344563";
var $aeae99da463e0617$export$ad0bacf983b7ddaa = "#253858";
var $aeae99da463e0617$export$7d61b15e0da132af = "#172B4D";
var $aeae99da463e0617$export$fbda843f0a27fe96 = "#091E42";
var $aeae99da463e0617$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $aeae99da463e0617$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $aeae99da463e0617$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $aeae99da463e0617$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $aeae99da463e0617$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $aeae99da463e0617$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $aeae99da463e0617$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $aeae99da463e0617$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $aeae99da463e0617$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $aeae99da463e0617$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $aeae99da463e0617$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $aeae99da463e0617$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $aeae99da463e0617$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $aeae99da463e0617$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $aeae99da463e0617$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $aeae99da463e0617$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $aeae99da463e0617$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $aeae99da463e0617$export$2f6319cf7d736c2a = "#E6EDFA";
var $aeae99da463e0617$export$95126bc8884d6634 = "#DCE5F5";
var $aeae99da463e0617$export$8338d8c35d44ff1 = "#CED9EB";
var $aeae99da463e0617$export$5368d76ae4fbbda7 = "#B8C7E0";
var $aeae99da463e0617$export$9f0a771d16ec8d36 = "#ABBBD6";
var $aeae99da463e0617$export$abcf8c38338b4aa5 = "#9FB0CC";
var $aeae99da463e0617$export$97e81faa16a182c7 = "#8C9CB8";
var $aeae99da463e0617$export$bfe21c59123ecf33 = "#7988A3";
var $aeae99da463e0617$export$ee82aa2ea6a1558 = "#67758F";
var $aeae99da463e0617$export$682927c6ed76be02 = "#56637A";
var $aeae99da463e0617$export$91fd9994c5be9757 = "#455166";
var $aeae99da463e0617$export$d281fbfe3cff2df6 = "#3B475C";
var $aeae99da463e0617$export$3902c91d8b98a753 = "#313D52";
var $aeae99da463e0617$export$8e8133c1ba5845b5 = "#283447";
var $aeae99da463e0617$export$33ff357f6620b39 = "#202B3D";
var $aeae99da463e0617$export$633847cf062b69e0 = "#1B2638";
var $aeae99da463e0617$export$9776a6e503bdbf76 = "#121A29";
var $aeae99da463e0617$export$6c813d5160dff5db = "#0E1624";
var $aeae99da463e0617$export$3d4f271a500072a = "#0D1424";
var $aeae99da463e0617$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $aeae99da463e0617$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $aeae99da463e0617$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $aeae99da463e0617$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $aeae99da463e0617$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $aeae99da463e0617$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $aeae99da463e0617$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $aeae99da463e0617$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $aeae99da463e0617$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $aeae99da463e0617$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $aeae99da463e0617$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $aeae99da463e0617$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $aeae99da463e0617$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $aeae99da463e0617$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $aeae99da463e0617$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $aeae99da463e0617$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $aeae99da463e0617$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";

});


parcelRegister("l68LM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5c0f5f6e58d9405$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9q1kH = parcelRequire("9q1kH");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $1FiMp = parcelRequire("1FiMp");

var $6hJzd = parcelRequire("6hJzd");

var $8p2GL = parcelRequire("8p2GL");

var $ay1rd = parcelRequire("ay1rd");

var $JcvLo = parcelRequire("JcvLo");
var $gWA00 = parcelRequire("gWA00");

var $htChF = parcelRequire("htChF");

var $aRH7N = parcelRequire("aRH7N");

var $97YIy = parcelRequire("97YIy");

var $a3hI0 = parcelRequire("a3hI0");

var $dT69P = parcelRequire("dT69P");

var $R3UGj = parcelRequire("R3UGj");

var $2Opm5 = parcelRequire("2Opm5");

var $1ZvLN = parcelRequire("1ZvLN");

var $bxfA5 = parcelRequire("bxfA5");
function $f5c0f5f6e58d9405$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f5c0f5f6e58d9405$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f5c0f5f6e58d9405$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f5c0f5f6e58d9405$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f5c0f5f6e58d9405$var$tooltipZIndex = (0, $a3hI0.layers).tooltip();
var $f5c0f5f6e58d9405$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "18.7.1"
};
// Inverts motion direction
var $f5c0f5f6e58d9405$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $f5c0f5f6e58d9405$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
function $f5c0f5f6e58d9405$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $1ZvLN.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $8p2GL.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $8p2GL.default) : _ref$onHide, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi;
    var tooltipPosition = position === "mouse" ? mousePosition : position;
    var onShowHandler = (0, $6hJzd.usePlatformLeafSyntheticEventHandler)($f5c0f5f6e58d9405$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $f5c0f5f6e58d9405$var$analyticsAttributes));
    var onHideHandler = (0, $6hJzd.usePlatformLeafSyntheticEventHandler)($f5c0f5f6e58d9405$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $f5c0f5f6e58d9405$var$analyticsAttributes));
    var apiRef = (0, $9nHZC.useRef)(null);
    var _useState = (0, $9nHZC.useState)("hide"), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $9nHZC.useRef)(null);
    var containerRef = (0, $9nHZC.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $9nHZC.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var lastState = (0, $9nHZC.useRef)(state);
    var lastDelay = (0, $9nHZC.useRef)(delay);
    var lastHandlers = (0, $9nHZC.useRef)({
        onShowHandler: onShowHandler,
        onHideHandler: onHideHandler
    });
    var hasCalledShowHandler = (0, $9nHZC.useRef)(false);
    (0, $9nHZC.useEffect)(function() {
        lastState.current = state;
        lastDelay.current = delay;
        lastHandlers.current = {
            onShowHandler: onShowHandler,
            onHideHandler: onHideHandler
        };
    }, [
        delay,
        onHideHandler,
        onShowHandler,
        state
    ]);
    var start = (0, $9nHZC.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $9nHZC.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, []);
    var abort = (0, $9nHZC.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
    }, []);
    (0, $9nHZC.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $9nHZC.useRef)(false);
    (0, $9nHZC.useEffect)(function() {
        return (0, $dT69P.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var showTooltip = (0, $9nHZC.useCallback)(function(source) {
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // Tell the tooltip to keep showing
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        var entry = {
            source: source,
            delay: lastDelay.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    lastHandlers.current.onShowHandler();
                }
                setState(isImmediate ? "show-immediate" : "fade-in");
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done
        };
        var api = (0, $R3UGj.show)(entry);
        start(api);
    }, [
        abort,
        done,
        start
    ]);
    var hideTooltipOnEsc = (0, $9nHZC.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $ay1rd.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $9nHZC.useEffect)(function() {
        if (state === "hide") return 0, $8p2GL.default;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $1FiMp.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $9nHZC.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $9nHZC.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $9nHZC.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === "mouse" ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            mouse: (0, $bxfA5.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: "keyboard"
        };
        showTooltip(source);
    }, [
        position,
        showTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $9nHZC.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === "mouse" ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $bxfA5.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $9nHZC.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $9nHZC.useCallback)(function() {
        showTooltip({
            type: "keyboard"
        });
    }, [
        showTooltip
    ]);
    var onBlur = (0, $9nHZC.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $9nHZC.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && lastState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, []);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipContainer = state !== "hide" && Boolean(content);
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current4;
        if (position === "mouse" && (_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.mousePosition) {
            var _apiRef$current5;
            return (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 ? void 0 : _apiRef$current5.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipId = (0, $2Opm5.default)("tooltip", shouldRenderTooltipContainer);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    (0, $9nHZC.useEffect)(function() {
        // If there is no container element, we should exit early, because that
        // means they are using the render prop API, and that is implemented in a
        // different way. If there is no target element yet or tooltipId, we also
        // shouldn't do anything because there is nothing to operate on or with.
        if (!containerRef.current || !targetRef.current || !tooltipId) return;
        var target = targetRef.current;
        if (shouldRenderTooltipContainer) target.setAttribute("aria-describedby", tooltipId);
        else target.removeAttribute("aria-describedby");
    }, [
        shouldRenderTooltipContainer,
        tooltipId
    ]);
    var hiddenContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipId
    }, typeof content === "function" ? content({}) : content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, typeof children === "function" ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, children($f5c0f5f6e58d9405$var$_objectSpread($f5c0f5f6e58d9405$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipId,
        ref: setDirectRef
    })), shouldRenderTooltipContainer && hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, shouldRenderTooltipContainer && hiddenContent), shouldRenderTooltipContainer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $97YIy.default), {
        zIndex: $f5c0f5f6e58d9405$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aRH7N.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === "mouse" ? undefined : $f5c0f5f6e58d9405$var$invertedDirection[$f5c0f5f6e58d9405$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $JcvLo.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $gWA00.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state === "show-immediate" ? 0 : (0, $htChF.mediumDurationMs)
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $f5c0f5f6e58d9405$var$_objectSpread($f5c0f5f6e58d9405$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: "none"
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$f5c0f5f6e58d9405$var$Tooltip.displayName = "Tooltip";
var $f5c0f5f6e58d9405$export$2e2bcd8739ae039 = $f5c0f5f6e58d9405$var$Tooltip;

});
parcelRegister("6hJzd", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $4937ad47e0fc5f24$export$1a04351537078b55; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $3hqYE = parcelRequire("3hqYE");

var $l73kg = parcelRequire("l73kg");
function $4937ad47e0fc5f24$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4937ad47e0fc5f24$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4937ad47e0fc5f24$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4937ad47e0fc5f24$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4937ad47e0fc5f24$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $3hqYE.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $l73kg.useTrackedRef)(analyticsData);
    var fnRef = (0, $l73kg.useTrackedRef)(fn);
    var handler = (0, $9nHZC.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $4937ad47e0fc5f24$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("3hqYE", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $2637e2b99c09ad4e$export$5bf35293e545f20c; });

var $dNznA = parcelRequire("dNznA");

var $4OLnQ = parcelRequire("4OLnQ");

var $EHIgS = parcelRequire("EHIgS");
function $2637e2b99c09ad4e$export$5bf35293e545f20c() {
    var analyticsContext = (0, $EHIgS.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $4OLnQ.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("4OLnQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38209650e21a28f7$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $j69H1 = parcelRequire("j69H1");
function $38209650e21a28f7$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $38209650e21a28f7$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $38209650e21a28f7$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($38209650e21a28f7$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $38209650e21a28f7$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $38209650e21a28f7$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $38209650e21a28f7$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $38209650e21a28f7$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $j69H1.default));

});
parcelRegister("j69H1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03968cc8e2755216$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
function $03968cc8e2755216$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $03968cc8e2755216$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $03968cc8e2755216$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $03968cc8e2755216$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $03968cc8e2755216$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $03968cc8e2755216$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $03968cc8e2755216$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $03968cc8e2755216$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(updater) === "object") this.payload = $03968cc8e2755216$var$_objectSpread($03968cc8e2755216$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("EHIgS", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $07a5a50b12ca2bc3$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $07a5a50b12ca2bc3$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});


parcelRegister("l73kg", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $f5ecd4dcb23e2c98$export$1d27a74659855e44; });

var $9nHZC = parcelRequire("9nHZC");
var $f5ecd4dcb23e2c98$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("dT69P", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $a1c5302de73c54ea$export$6503ec6e8aabbaf; });
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $1FiMp = parcelRequire("1FiMp");
var $a1c5302de73c54ea$var$registrations = new Set();
var $a1c5302de73c54ea$var$cleanupEndEventListeners = null;
function $a1c5302de73c54ea$var$onDragStart() {
    if ($a1c5302de73c54ea$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $a1c5302de73c54ea$var$cleanupEndEventListeners = (0, $1FiMp.bindAll)(window, [
        {
            type: "dragend",
            listener: $a1c5302de73c54ea$var$onDragEnd
        },
        {
            type: "pointerdown",
            listener: $a1c5302de73c54ea$var$onDragEnd
        },
        {
            type: "pointermove",
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $a1c5302de73c54ea$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($a1c5302de73c54ea$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $a1c5302de73c54ea$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $a1c5302de73c54ea$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $a1c5302de73c54ea$var$cleanupEndEventListeners = null;
    var clone = Array.from($a1c5302de73c54ea$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $a1c5302de73c54ea$var$bindStartEvents() {
    return (0, $1FiMp.bindAll)(window, [
        {
            type: "dragstart",
            listener: $a1c5302de73c54ea$var$onDragStart
        },
        {
            type: "dragenter",
            listener: $a1c5302de73c54ea$var$onDragStart
        }
    ]);
}
var $a1c5302de73c54ea$var$cleanupStartEventListeners = null;
function $a1c5302de73c54ea$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$a1c5302de73c54ea$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $a1c5302de73c54ea$var$cleanupStartEventListeners = $a1c5302de73c54ea$var$bindStartEvents();
    $a1c5302de73c54ea$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $a1c5302de73c54ea$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $a1c5302de73c54ea$var$registrations.delete(registration);
        if ($a1c5302de73c54ea$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $a1c5302de73c54ea$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $a1c5302de73c54ea$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("R3UGj", function(module, exports) {

$parcel$export(module.exports, "show", function () { return $09f7fc6f6bf75139$export$57bf213be019eeb0; });

var $dbkzX = parcelRequire("dbkzX");
// This file is a singleton for managing tooltips
var $09f7fc6f6bf75139$var$active = null;
function $09f7fc6f6bf75139$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($09f7fc6f6bf75139$var$active && $09f7fc6f6bf75139$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $dbkzX.clearScheduled)();
            $09f7fc6f6bf75139$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $dbkzX.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $dbkzX.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $dbkzX.scheduleTimeout)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($09f7fc6f6bf75139$var$active && $09f7fc6f6bf75139$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($09f7fc6f6bf75139$var$active) {
            (0, $dbkzX.clearScheduled)();
            $09f7fc6f6bf75139$var$active.entry.hide({
                isImmediate: true
            });
            $09f7fc6f6bf75139$var$active.entry.done();
            $09f7fc6f6bf75139$var$active = null;
        }
        // this tooltip is now the active tooltip
        $09f7fc6f6bf75139$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $dbkzX.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("dbkzX", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", function () { return $998c43fe1eb45661$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $998c43fe1eb45661$export$5f4d6617421d489b; });
var $998c43fe1eb45661$var$delayId = null;
function $998c43fe1eb45661$export$eaf678f6f93f5250() {
    if ($998c43fe1eb45661$var$delayId != null) {
        window.clearTimeout($998c43fe1eb45661$var$delayId);
        $998c43fe1eb45661$var$delayId = null;
    }
}
function $998c43fe1eb45661$export$5f4d6617421d489b(fn, delay) {
    $998c43fe1eb45661$export$eaf678f6f93f5250();
    $998c43fe1eb45661$var$delayId = window.setTimeout(function() {
        $998c43fe1eb45661$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("2Opm5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20c3eb50cb0c30fc$export$2e2bcd8739ae039; });

var $9SZaS = parcelRequire("9SZaS");
function $20c3eb50cb0c30fc$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $9SZaS.useUIDSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});

parcelRegister("1ZvLN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $173421ca5dc8cf21$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $eZPmg = parcelRequire("eZPmg");

var $lMJzk = parcelRequire("lMJzk");
var $173421ca5dc8cf21$var$baseStyles = (0, $avKww.css)({
    boxSizing: "border-box",
    maxWidth: "240px",
    padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-075, 6px)"),
    insetBlockStart: "var(--ds-space-0, 0px)",
    insetInlineStart: "var(--ds-space-0, 0px)",
    borderRadius: "var(--ds-border-radius, 3px)",
    font: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    overflowWrap: "break-word",
    wordWrap: "break-word",
    backgroundColor: "var(--ds-background-neutral-bold, ".concat((0, $eZPmg.N800), ")"),
    color: "var(--ds-text-inverse, ".concat((0, $eZPmg.N0), ")")
});
var $173421ca5dc8cf21$var$truncateStyles = (0, $avKww.css)({
    maxWidth: "420px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $173421ca5dc8cf21$var$TooltipContainer = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return (0, $avKww.jsx)((0, $lMJzk.default), {
        ref: ref,
        style: style,
        className: className,
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: [
            $173421ca5dc8cf21$var$baseStyles,
            truncate ? $173421ca5dc8cf21$var$truncateStyles : null
        ]
    }, children);
});
$173421ca5dc8cf21$var$TooltipContainer.displayName = "TooltipContainer";
var $173421ca5dc8cf21$export$2e2bcd8739ae039 = $173421ca5dc8cf21$var$TooltipContainer;

});
parcelRegister("lMJzk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdc16db4de7f9310$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $a3hI0 = parcelRequire("a3hI0");
function $fdc16db4de7f9310$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fdc16db4de7f9310$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fdc16db4de7f9310$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fdc16db4de7f9310$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fdc16db4de7f9310$var$VAR_PRIMITIVE_ZINDEX = "tooltipPrimitiveZindex";
var $fdc16db4de7f9310$var$primitiveStyles = (0, $avKww.css)({
    zindex: "var(".concat($fdc16db4de7f9310$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
var $fdc16db4de7f9310$var$TooltipPrimitive = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $fdc16db4de7f9310$var$_objectSpread($fdc16db4de7f9310$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, $fdc16db4de7f9310$var$VAR_PRIMITIVE_ZINDEX, (0, $a3hI0.layers).tooltip()));
    return (0, $avKww.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $avKww.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $fdc16db4de7f9310$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$fdc16db4de7f9310$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $fdc16db4de7f9310$export$2e2bcd8739ae039 = $fdc16db4de7f9310$var$TooltipPrimitive;

});


parcelRegister("bxfA5", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", function () { return $865edcdac21d2082$export$642213d516a9b928; });
function $865edcdac21d2082$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("i4IhC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d28af3721d4925d4$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $inFLm = parcelRequire("inFLm");

var $3aF04 = parcelRequire("3aF04");

var $5kzu2 = parcelRequire("5kzu2");
var $87ZI9 = parcelRequire("87ZI9");
var $fuPTF = parcelRequire("fuPTF");

var $g4tw6 = parcelRequire("g4tw6");
var $d28af3721d4925d4$var$_excluded = [
    "href",
    "onClick"
], $d28af3721d4925d4$var$_excluded2 = [
    "children"
];
var $d28af3721d4925d4$var$AvatarGroupItem = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(props, ref) {
    var avatar = props.avatar, onAvatarClick = props.onAvatarClick, testId = props.testId, index = props.index;
    var href = avatar.href, onClick = avatar.onClick, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(avatar, $d28af3721d4925d4$var$_excluded);
    var itemRef = (0, $g4tw6.default)();
    var CustomComponent = function CustomComponent(_ref) {
        var children = _ref.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $d28af3721d4925d4$var$_excluded2);
        return(/*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
        (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("button", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            type: "button"
        }, props), children));
    };
    var AvatarIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $inFLm.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
        testId: testId && "".concat(testId, "--avatar"),
        borderColor: "transparent",
        size: "small",
        name: ""
    }));
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    var callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fuPTF.default), {
        ref: (0, $3aF04.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: avatar.target,
        rel: avatar.target === "_blank" ? "noopener noreferrer" : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: function onClick(event) {
            return callback && callback(event, undefined, index);
        }
    }, avatar.name);
    if (typeof callback === "function") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5kzu2.default), {
        ref: (0, $3aF04.default)([
            ref,
            itemRef
        ]),
        onClick: function onClick(event) {
            return callback && callback(event, undefined, index);
        },
        iconBefore: AvatarIcon,
        testId: testId
    }, avatar.name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $87ZI9.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId
    }, avatar.name);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d28af3721d4925d4$export$2e2bcd8739ae039 = $d28af3721d4925d4$var$AvatarGroupItem;

});
parcelRegister("g4tw6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb33ea7e18cbfa40$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $dUVR7 = parcelRequire("dUVR7");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $bb33ea7e18cbfa40$var$useRegisterItemWithFocusManager() {
    var _useContext = (0, $9nHZC.useContext)((0, $dUVR7.FocusManagerContext)), registerRef = _useContext.registerRef;
    var itemRef = (0, $9nHZC.useRef)(null);
    (0, $9nHZC.useEffect)(function() {
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $bb33ea7e18cbfa40$export$2e2bcd8739ae039 = $bb33ea7e18cbfa40$var$useRegisterItemWithFocusManager;

});
parcelRegister("dUVR7", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", function () { return $a21d624816e35d85$export$f18c1d4fc7326096; });
$parcel$export(module.exports, "default", function () { return $a21d624816e35d85$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $1FiMp = parcelRequire("1FiMp");

var $8p2GL = parcelRequire("8p2GL");

var $6eKe1 = parcelRequire("6eKe1");
var $a21d624816e35d85$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $9nHZC.createContext)({
    menuItemRefs: [],
    registerRef: (0, $8p2GL.default)
});
/**
 * Focus manager logic
 */ var $a21d624816e35d85$var$FocusManager = function FocusManager(_ref) {
    var children = _ref.children;
    var menuItemRefs = (0, $9nHZC.useRef)([]);
    var registerRef = (0, $9nHZC.useCallback)(function(ref) {
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $9nHZC.useEffect)(function() {
        (0, $1FiMp.bind)(window, {
            type: "keydown",
            listener: (0, $6eKe1.default)(menuItemRefs.current)
        });
        var unbind = function unbind() {
            (0, $1FiMp.bind)(window, {
                type: "keydown",
                listener: (0, $6eKe1.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    var contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($a21d624816e35d85$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $a21d624816e35d85$export$2e2bcd8739ae039 = $a21d624816e35d85$var$FocusManager;

});
parcelRegister("6eKe1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48a7e84131238ea5$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $70mT6 = parcelRequire("70mT6");
var $48a7e84131238ea5$var$_actionMap;
var $48a7e84131238ea5$var$actionMap = ($48a7e84131238ea5$var$_actionMap = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($48a7e84131238ea5$var$_actionMap, (0, $70mT6.KEY_DOWN), "next"), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($48a7e84131238ea5$var$_actionMap, (0, $70mT6.KEY_UP), "prev"), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($48a7e84131238ea5$var$_actionMap, (0, $70mT6.KEY_HOME), "first"), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($48a7e84131238ea5$var$_actionMap, (0, $70mT6.KEY_END), "last"), $48a7e84131238ea5$var$_actionMap);
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ var $48a7e84131238ea5$var$getNextFocusableElement = function getNextFocusableElement(refs, currentFocusedIdx) {
    while(currentFocusedIdx + 1 < refs.length){
        var isDisabled = refs[currentFocusedIdx + 1].getAttribute("disabled") !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ var $48a7e84131238ea5$var$getPrevFocusableElement = function getPrevFocusableElement(refs, currentFocusedIdx) {
    while(currentFocusedIdx > 0){
        var isDisabled = refs[currentFocusedIdx - 1].getAttribute("disabled") !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $48a7e84131238ea5$export$2e2bcd8739ae039(refs) {
    return function(e) {
        var currentFocusedIdx = refs.findIndex(function(el) {
            var _document$activeEleme;
            return (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el);
        });
        var action = $48a7e84131238ea5$var$actionMap[e.key];
        switch(action){
            case "next":
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    var _nextFocusableElement = $48a7e84131238ea5$var$getNextFocusableElement(refs, currentFocusedIdx);
                    _nextFocusableElement && _nextFocusableElement.focus();
                }
                break;
            case "prev":
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    var _prevFocusableElement = $48a7e84131238ea5$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    _prevFocusableElement && _prevFocusableElement.focus();
                }
                break;
            case "first":
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                var nextFocusableElement = $48a7e84131238ea5$var$getNextFocusableElement(refs, -1);
                nextFocusableElement && nextFocusableElement.focus();
                break;
            case "last":
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                var prevFocusableElement = $48a7e84131238ea5$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement && prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});




parcelRegister("lXsdT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ffc50030e4ec34b7$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");
var $ffc50030e4ec34b7$var$gutter = "var(--ds-space-negative-050, -4px)";
var $ffc50030e4ec34b7$var$listStyles = (0, $avKww.css)({
    display: "flex",
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    listStyleType: "none !important",
    marginInlineEnd: $ffc50030e4ec34b7$var$gutter,
    marginInlineStart: $ffc50030e4ec34b7$var$gutter
});
var $ffc50030e4ec34b7$var$listItemStyles = (0, $avKww.css)({
    margin: "var(--ds-space-0, 0px)",
    marginBlockEnd: "var(--ds-space-100, 8px)",
    paddingInlineEnd: "var(--ds-space-050, 4px)",
    paddingInlineStart: "var(--ds-space-050, 4px)"
});
var $ffc50030e4ec34b7$var$Grid = function Grid(_ref) {
    var children = _ref.children, testId = _ref.testId, label = _ref["aria-label"];
    return (0, $avKww.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $ffc50030e4ec34b7$var$listStyles
    }, (0, $9nHZC.Children).map(children, function(child) {
        return child && (0, $avKww.jsx)("li", {
            css: $ffc50030e4ec34b7$var$listItemStyles
        }, child);
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ffc50030e4ec34b7$export$2e2bcd8739ae039 = $ffc50030e4ec34b7$var$Grid;

});

parcelRegister("02hCv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $006ddafdf0881b9d$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $8HHuo = parcelRequire("8HHuo");

var $dUVR7 = parcelRequire("dUVR7");
var $006ddafdf0881b9d$var$_excluded = [
    "maxWidth",
    "minWidth",
    "setInitialFocusRef"
];
/**
 * It sets focus to the first avatar when popup is open.
 */ var $006ddafdf0881b9d$var$PopupAvatarGroup = function PopupAvatarGroup(_ref) {
    var _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 800 : _ref$maxWidth, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 320 : _ref$minWidth, setInitialFocusRef = _ref.setInitialFocusRef, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $006ddafdf0881b9d$var$_excluded);
    var _useContext = (0, $9nHZC.useContext)((0, $dUVR7.FocusManagerContext)), menuItemRefs = _useContext.menuItemRefs;
    (0, $9nHZC.useEffect)(function() {
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, $avKww.jsx)((0, $8HHuo.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        maxWidth: maxWidth,
        minWidth: minWidth
    }, rest)));
};
var $006ddafdf0881b9d$export$2e2bcd8739ae039 = $006ddafdf0881b9d$var$PopupAvatarGroup;

});

parcelRegister("kEgCC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0846fd6dca97a19$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $6eWbL = parcelRequire("6eWbL");
var $inFLm = parcelRequire("inFLm");

var $4DeWi = parcelRequire("4DeWi");

var $eZPmg = parcelRequire("eZPmg");
var $f0846fd6dca97a19$var$_excluded = [
    "testId",
    "className",
    "ref"
];
var $f0846fd6dca97a19$var$buttonSizes = {
    xsmall: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    medium: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    xlarge: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    xxlarge: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $f0846fd6dca97a19$var$buttonActiveStyles = (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&&": {
        backgroundColor: "var(--ds-background-selected, ".concat((0, $eZPmg.B50), ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: "0 0 0 ".concat((0, $6eWbL.BORDER_WIDTH), "px ", "var(--ds-border-selected, ".concat((0, $eZPmg.B300), ")")),
        color: "var(--ds-text-selected, ".concat((0, $eZPmg.B400), ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transform: "scale(".concat((0, $6eWbL.ACTIVE_SCALE_FACTOR), ")"),
        "&:hover": {
            backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $eZPmg.N30), ")"),
            color: "var(--ds-text-selected, ".concat((0, $eZPmg.N500), ")")
        },
        "&:active": {
            backgroundColor: "var(--ds-background-selected-pressed, ".concat((0, $eZPmg.B50), ")"),
            color: "var(--ds-text-selected, ".concat((0, $eZPmg.B400), ")")
        }
    }
});
var $f0846fd6dca97a19$var$buttonStyles = (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&&": {
        backgroundColor: "var(--ds-background-neutral, ".concat((0, $eZPmg.N20), ")"),
        color: "var(--ds-text, ".concat((0, $eZPmg.N500), ")"),
        "&:hover": {
            backgroundColor: "var(--ds-background-neutral-hovered, ".concat((0, $eZPmg.N30), ")"),
            color: "var(--ds-text, ".concat((0, $eZPmg.N500), ")")
        },
        "&:active": {
            backgroundColor: "var(--ds-background-neutral-pressed, ".concat((0, $eZPmg.B50), ")"),
            color: "var(--ds-text, ".concat((0, $eZPmg.B400), ")")
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "&::after": {
            display: "none"
        }
    }
});
var $f0846fd6dca97a19$var$MAX_DISPLAY_COUNT = 99;
var $f0846fd6dca97a19$var$MoreIndicator = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "circle" : _ref$appearance, _ref$borderColor = _ref.borderColor, borderColor = _ref$borderColor === void 0 ? (0, $4DeWi.fg)("platform-component-visual-refresh") ? "var(--ds-surface, #FFFFFF)" : "var(--ds-border-inverse, ".concat((0, $eZPmg.N0), ")") : _ref$borderColor, _ref$size = _ref.size, size = _ref$size === void 0 ? "medium" : _ref$size, _ref$count = _ref.count, count = _ref$count === void 0 ? 0 : _ref$count, testId = _ref.testId, onClick = _ref.onClick, ariaControls = _ref["aria-controls"], ariaExpanded = _ref["aria-expanded"], ariaHaspopup = _ref["aria-haspopup"], _ref$buttonProps = _ref.buttonProps, buttonProps = _ref$buttonProps === void 0 ? {} : _ref$buttonProps, isActive = _ref.isActive;
    var onClickHander = (0, $9nHZC.useCallback)(function(event, analyticsEvent) {
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    return (0, $avKww.jsx)((0, $inFLm.default), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        ref: ref,
        onClick: onClickHander
    }, function(_ref2) {
        var _ = _ref2.testId, className = _ref2.className, ref = _ref2.ref, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref2, $f0846fd6dca97a19$var$_excluded);
        return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
        (0, $avKww.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            type: "submit"
        }, buttonProps, props, {
            ref: ref,
            "data-testid": testId,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHaspopup,
            style: {
                font: $f0846fd6dca97a19$var$buttonSizes[size]
            },
            css: [
                $f0846fd6dca97a19$var$buttonStyles,
                isActive && $f0846fd6dca97a19$var$buttonActiveStyles
            ],
            className: className
        }), "+", count > $f0846fd6dca97a19$var$MAX_DISPLAY_COUNT ? $f0846fd6dca97a19$var$MAX_DISPLAY_COUNT : count));
    });
});
$f0846fd6dca97a19$var$MoreIndicator.displayName = "MoreIndicator";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f0846fd6dca97a19$export$2e2bcd8739ae039 = $f0846fd6dca97a19$var$MoreIndicator;

});
parcelRegister("4DeWi", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $35f664942960b406$export$b40ec24ac8275656; });

var $d9R0c = parcelRequire("d9R0c");
function $35f664942960b406$export$ba05d765b8392e5e(flagResolver) {
    (0, $d9R0c.setBooleanResolver)(flagResolver);
}
function $35f664942960b406$export$470e5c2be1411c89(name) {
    return (0, $d9R0c.resolveBooleanFlag)(name);
}
function $35f664942960b406$export$b40ec24ac8275656(name) {
    return (0, $d9R0c.resolveBooleanFlag)(name);
}

});
parcelRegister("d9R0c", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $99453abf62249f9e$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $99453abf62249f9e$export$6333b6aff9fc6275; });

var $iBkYk = parcelRequire("iBkYk");

var $8ovux = parcelRequire("8ovux");
var $99453abf62249f9e$var$pkgName = "@atlaskit/platform-feature-flags";
var $99453abf62249f9e$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $99453abf62249f9e$var$hasProcessEnv = typeof $8ovux !== "undefined" && typeof $8ovux.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $99453abf62249f9e$var$ENV_ENABLE_PLATFORM_FF = $99453abf62249f9e$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $99453abf62249f9e$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $99453abf62249f9e$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $99453abf62249f9e$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $99453abf62249f9e$var$ENV_ENABLE_PLATFORM_FF || $99453abf62249f9e$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $99453abf62249f9e$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $99453abf62249f9e$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$99453abf62249f9e$var$globalVar[$99453abf62249f9e$export$7e41b1b2bdee3f98] = $99453abf62249f9e$var$globalVar[$99453abf62249f9e$export$7e41b1b2bdee3f98] || $99453abf62249f9e$var$DEFAULT_PFF_GLOBAL;
function $99453abf62249f9e$export$f2b591175b3e424c(resolver) {
    $99453abf62249f9e$var$globalVar[$99453abf62249f9e$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $99453abf62249f9e$export$6333b6aff9fc6275(flagKey) {
    if ($99453abf62249f9e$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $iBkYk.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $99453abf62249f9e$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $99453abf62249f9e$var$globalVar[$99453abf62249f9e$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("iBkYk", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $d8abf34df9a935cf$export$1c9f709888824e05; });
var $d8abf34df9a935cf$var$_ref, $d8abf34df9a935cf$var$_process, $d8abf34df9a935cf$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $d8abf34df9a935cf$var$TESTS_MODE = ($d8abf34df9a935cf$var$_ref = (globalThis === null || globalThis === void 0 || ($d8abf34df9a935cf$var$_process = globalThis.process) === null || $d8abf34df9a935cf$var$_process === void 0 || ($d8abf34df9a935cf$var$_process = $d8abf34df9a935cf$var$_process.env) === null || $d8abf34df9a935cf$var$_process === void 0 ? void 0 : $d8abf34df9a935cf$var$_process.JEST_WORKER_ID) !== undefined, $d8abf34df9a935cf$var$_ref !== void 0) ? $d8abf34df9a935cf$var$_ref : false;
var $d8abf34df9a935cf$var$DEBUG_MODE = !$d8abf34df9a935cf$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($d8abf34df9a935cf$var$_process2 = globalThis.process) === null || $d8abf34df9a935cf$var$_process2 === void 0 || ($d8abf34df9a935cf$var$_process2 = $d8abf34df9a935cf$var$_process2.env) === null || $d8abf34df9a935cf$var$_process2 === void 0 ? void 0 : $d8abf34df9a935cf$var$_process2.NODE_ENV) !== "production";
var $d8abf34df9a935cf$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$d8abf34df9a935cf$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("dKFm7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a02fa69be5c1a640$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $6eWbL = parcelRequire("6eWbL");

var $a3hI0 = parcelRequire("a3hI0");
var $a02fa69be5c1a640$var$gutter = (0, $6eWbL.BORDER_WIDTH) * 2 + (0, $a3hI0.gridSize)() / 2;
var $a02fa69be5c1a640$var$listStyles = (0, $avKww.css)({
    display: "flex",
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    listStyleType: "none !important",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: $a02fa69be5c1a640$var$gutter
});
var $a02fa69be5c1a640$var$listItemStyles = (0, $avKww.css)({
    margin: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: -$a02fa69be5c1a640$var$gutter
});
var $a02fa69be5c1a640$var$Stack = function Stack(_ref) {
    var children = _ref.children, testId = _ref.testId, label = _ref["aria-label"];
    return (0, $avKww.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $a02fa69be5c1a640$var$listStyles
    }, (0, $9nHZC.Children).map(children, function(child) {
        return child && (0, $avKww.jsx)("li", {
            css: $a02fa69be5c1a640$var$listItemStyles
        }, child);
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a02fa69be5c1a640$export$2e2bcd8739ae039 = $a02fa69be5c1a640$var$Stack;

});

parcelRegister("iIo2D", function(module, exports) {

$parcel$export(module.exports, "composeUniqueKey", function () { return $d9fefc2f17a07395$export$b067756944994c79; });
var $d9fefc2f17a07395$export$b067756944994c79 = function composeUniqueKey(props, index) {
    if (props.key) return props.key;
    return index;
};

});


parcelRegister("lpXGp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f97a3a8dc2cb21fc$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $7fgJe = parcelRequire("7fgJe");

var $8DBz6 = parcelRequire("8DBz6");
var $f97a3a8dc2cb21fc$var$_excluded = [
    "appearance",
    "isDisabled",
    "isSelected",
    "isLoading",
    "spacing"
];
/**
 * __Loading button__
 *
 * CAUTION: Legacy loading buttons will soon be deprecated. Please use the new Button components from `@atlaskit/button/new` with the `isLoading` prop.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ var $f97a3a8dc2cb21fc$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function LoadingButton(_ref, ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, spacing = _ref.spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $f97a3a8dc2cb21fc$var$_excluded);
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7fgJe.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
        ref: ref,
        appearance: appearance,
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $8DBz6.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    }));
});
// Tools including enzyme rely on components having a display name
$f97a3a8dc2cb21fc$var$LoadingButton.displayName = "LoadingButton";
var $f97a3a8dc2cb21fc$export$2e2bcd8739ae039 = $f97a3a8dc2cb21fc$var$LoadingButton;

});
parcelRegister("8DBz6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $649f1ae7fe7351b0$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $e9BTj = parcelRequire("e9BTj");
function $649f1ae7fe7351b0$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return "inherit";
    if (isSelected) return "invert";
    if (appearance === "primary" || appearance === "danger") return "invert";
    return "inherit";
}
function $649f1ae7fe7351b0$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing;
    var size = spacing === "default" ? "medium" : "small";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $e9BTj.default), {
        size: size,
        label: ", Loading",
        appearance: $649f1ae7fe7351b0$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});
parcelRegister("e9BTj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4df4c5781b65cdd$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $5fUc4 = parcelRequire("5fUc4");

var $hBOhN = parcelRequire("hBOhN");

var $6aiV1 = parcelRequire("6aiV1");
/**
 * Returns the appropriate circle stroke color.
 */ function $a4df4c5781b65cdd$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $hBOhN.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $hBOhN.N0), ")");
}
var $a4df4c5781b65cdd$var$rotate = (0, $avKww.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $a4df4c5781b65cdd$var$rotateStyles = (0, $avKww.css)({
    animation: "".concat($a4df4c5781b65cdd$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $a4df4c5781b65cdd$var$loadIn = (0, $avKww.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $a4df4c5781b65cdd$var$loadInStyles = (0, $avKww.css)({
    animation: "".concat($a4df4c5781b65cdd$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $a4df4c5781b65cdd$var$wrapperStyles = (0, $avKww.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $a4df4c5781b65cdd$var$circleStyles = (0, $avKww.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $a4df4c5781b65cdd$var$useLayoutEffect = typeof window === "undefined" ? (0, $9nHZC.useEffect) : (0, $9nHZC.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $a4df4c5781b65cdd$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $6aiV1.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $a4df4c5781b65cdd$var$getStrokeColor(appearance);
    var context = (0, $9nHZC.useContext)((0, $5fUc4.default));
    $a4df4c5781b65cdd$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $avKww.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $a4df4c5781b65cdd$var$wrapperStyles,
            $a4df4c5781b65cdd$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $avKww.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $a4df4c5781b65cdd$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none"
    }, (0, $avKww.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $a4df4c5781b65cdd$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $a4df4c5781b65cdd$export$2e2bcd8739ae039 = $a4df4c5781b65cdd$var$Spinner;

});
parcelRegister("hBOhN", function(module, exports) {

$parcel$export(module.exports, "N0", function () { return $cd1ce61b305a8f38$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $cd1ce61b305a8f38$export$c39c0fe0f26207ae; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $cd1ce61b305a8f38$export$4b84fd0e2c617bd = "#FFEBE6";
var $cd1ce61b305a8f38$export$b34b069eff244586 = "#FFBDAD";
var $cd1ce61b305a8f38$export$be802dd0d8b57f35 = "#FF8F73";
var $cd1ce61b305a8f38$export$60847d42f9da92a6 = "#FF7452";
var $cd1ce61b305a8f38$export$4a7404f376229999 = "#FF5630";
var $cd1ce61b305a8f38$export$2010d0fb4295b346 = "#DE350B";
var $cd1ce61b305a8f38$export$2837b5a1a71d5c02 = "#BF2600";
var $cd1ce61b305a8f38$export$8d9596b529bbb9cf = "#FFFAE6";
var $cd1ce61b305a8f38$export$41060a744ab0b7ae = "#FFF0B3";
var $cd1ce61b305a8f38$export$1cc05bbbf340e559 = "#FFE380";
var $cd1ce61b305a8f38$export$5aae31392d72caaa = "#FFC400";
var $cd1ce61b305a8f38$export$c6930421db9fa514 = "#FFAB00";
var $cd1ce61b305a8f38$export$59619663aa6500fb = "#FF991F";
var $cd1ce61b305a8f38$export$874739ea9e379ab6 = "#FF8B00";
var $cd1ce61b305a8f38$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $cd1ce61b305a8f38$export$69a3bf21b9686c2b = "#ABF5D1";
var $cd1ce61b305a8f38$export$afbce1382ec95f73 = "#79F2C0";
var $cd1ce61b305a8f38$export$747d86715d4175de = "#57D9A3";
var $cd1ce61b305a8f38$export$940e1f69e873f202 = "#36B37E";
var $cd1ce61b305a8f38$export$a49394138f7b8e85 = "#00875A";
var $cd1ce61b305a8f38$export$6fa04827ac68a4fb = "#006644";
var $cd1ce61b305a8f38$export$226de0355ed012f8 = "#DEEBFF";
var $cd1ce61b305a8f38$export$8c13c2ee36917869 = "#B3D4FF";
var $cd1ce61b305a8f38$export$ecfc1dff386a3e7a = "#4C9AFF";
var $cd1ce61b305a8f38$export$215b7063051591f1 = "#2684FF";
var $cd1ce61b305a8f38$export$e62e8919cca44969 = "#0065FF";
var $cd1ce61b305a8f38$export$b3de0ae08da2ce64 = "#0052CC";
var $cd1ce61b305a8f38$export$a6ee3d71bc067634 = "#0747A6";
var $cd1ce61b305a8f38$export$363e4475840015bb = "#EAE6FF";
var $cd1ce61b305a8f38$export$4b0a4417ed59760f = "#C0B6F2";
var $cd1ce61b305a8f38$export$6011520a64d9a187 = "#998DD9";
var $cd1ce61b305a8f38$export$a7175d4e9206bc80 = "#8777D9";
var $cd1ce61b305a8f38$export$b48405b95304b5a1 = "#6554C0";
var $cd1ce61b305a8f38$export$c71e4279dd54a18d = "#5243AA";
var $cd1ce61b305a8f38$export$147899de772240ec = "#403294";
var $cd1ce61b305a8f38$export$2cf711fe14c66f06 = "#E6FCFF";
var $cd1ce61b305a8f38$export$7a8f4d33f6f9772c = "#B3F5FF";
var $cd1ce61b305a8f38$export$776c9c497ef08533 = "#79E2F2";
var $cd1ce61b305a8f38$export$69cb3ca10c1e330e = "#00C7E6";
var $cd1ce61b305a8f38$export$9dc1ef0f3f48059b = "#00B8D9";
var $cd1ce61b305a8f38$export$7c835c78b6fcdef8 = "#00A3BF";
var $cd1ce61b305a8f38$export$6036577f95c3877e = "#008DA6";
var $cd1ce61b305a8f38$export$29a4f05edc054374 = "#FFFFFF";
var $cd1ce61b305a8f38$export$e655ef011c4aa1a2 = "#FAFBFC";
var $cd1ce61b305a8f38$export$9fdfb749e33cdf97 = "#F4F5F7";
var $cd1ce61b305a8f38$export$3e51e8f1440314ba = "#EBECF0";
var $cd1ce61b305a8f38$export$1ce2d1575d444ceb = "#DFE1E6";
var $cd1ce61b305a8f38$export$8754fc7e6d8b3000 = "#C1C7D0";
var $cd1ce61b305a8f38$export$c2e91cbeada39b8b = "#B3BAC5";
var $cd1ce61b305a8f38$export$5f71e19f3a7ad9de = "#A5ADBA";
var $cd1ce61b305a8f38$export$eaa8c8a70ac22806 = "#97A0AF";
var $cd1ce61b305a8f38$export$7c87d337fb91a97d = "#8993A4";
var $cd1ce61b305a8f38$export$d6447c357493214f = "#7A869A";
var $cd1ce61b305a8f38$export$f563ee71e9ee74cd = "#6B778C";
var $cd1ce61b305a8f38$export$e2ef2124cf4024b1 = "#5E6C84";
var $cd1ce61b305a8f38$export$eece5f492e429f08 = "#505F79";
var $cd1ce61b305a8f38$export$c39c0fe0f26207ae = "#42526E";
var $cd1ce61b305a8f38$export$7090862dc3038a9f = "#344563";
var $cd1ce61b305a8f38$export$ad0bacf983b7ddaa = "#253858";
var $cd1ce61b305a8f38$export$7d61b15e0da132af = "#172B4D";
var $cd1ce61b305a8f38$export$fbda843f0a27fe96 = "#091E42";
var $cd1ce61b305a8f38$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $cd1ce61b305a8f38$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $cd1ce61b305a8f38$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $cd1ce61b305a8f38$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $cd1ce61b305a8f38$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $cd1ce61b305a8f38$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $cd1ce61b305a8f38$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $cd1ce61b305a8f38$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $cd1ce61b305a8f38$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $cd1ce61b305a8f38$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $cd1ce61b305a8f38$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $cd1ce61b305a8f38$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $cd1ce61b305a8f38$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $cd1ce61b305a8f38$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $cd1ce61b305a8f38$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $cd1ce61b305a8f38$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $cd1ce61b305a8f38$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $cd1ce61b305a8f38$export$2f6319cf7d736c2a = "#E6EDFA";
var $cd1ce61b305a8f38$export$95126bc8884d6634 = "#DCE5F5";
var $cd1ce61b305a8f38$export$8338d8c35d44ff1 = "#CED9EB";
var $cd1ce61b305a8f38$export$5368d76ae4fbbda7 = "#B8C7E0";
var $cd1ce61b305a8f38$export$9f0a771d16ec8d36 = "#ABBBD6";
var $cd1ce61b305a8f38$export$abcf8c38338b4aa5 = "#9FB0CC";
var $cd1ce61b305a8f38$export$97e81faa16a182c7 = "#8C9CB8";
var $cd1ce61b305a8f38$export$bfe21c59123ecf33 = "#7988A3";
var $cd1ce61b305a8f38$export$ee82aa2ea6a1558 = "#67758F";
var $cd1ce61b305a8f38$export$682927c6ed76be02 = "#56637A";
var $cd1ce61b305a8f38$export$91fd9994c5be9757 = "#455166";
var $cd1ce61b305a8f38$export$d281fbfe3cff2df6 = "#3B475C";
var $cd1ce61b305a8f38$export$3902c91d8b98a753 = "#313D52";
var $cd1ce61b305a8f38$export$8e8133c1ba5845b5 = "#283447";
var $cd1ce61b305a8f38$export$33ff357f6620b39 = "#202B3D";
var $cd1ce61b305a8f38$export$633847cf062b69e0 = "#1B2638";
var $cd1ce61b305a8f38$export$9776a6e503bdbf76 = "#121A29";
var $cd1ce61b305a8f38$export$6c813d5160dff5db = "#0E1624";
var $cd1ce61b305a8f38$export$3d4f271a500072a = "#0D1424";
var $cd1ce61b305a8f38$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $cd1ce61b305a8f38$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $cd1ce61b305a8f38$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $cd1ce61b305a8f38$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $cd1ce61b305a8f38$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $cd1ce61b305a8f38$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $cd1ce61b305a8f38$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $cd1ce61b305a8f38$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $cd1ce61b305a8f38$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $cd1ce61b305a8f38$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $cd1ce61b305a8f38$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $cd1ce61b305a8f38$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $cd1ce61b305a8f38$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $cd1ce61b305a8f38$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $cd1ce61b305a8f38$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $cd1ce61b305a8f38$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $cd1ce61b305a8f38$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";

});

parcelRegister("6aiV1", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $47d25a217015fc64$export$4e9f1640bbe7a1a8; });
var $47d25a217015fc64$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("kb4D4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb086cf64c23c82a$var$_react = $eb086cf64c23c82a$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $eb086cf64c23c82a$var$_showMoreHorizontal = $eb086cf64c23c82a$var$_interopRequireDefault((parcelRequire("fAASt")));
function $eb086cf64c23c82a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $eb086cf64c23c82a$var$MoreIcon = (props)=>/*#__PURE__*/ $eb086cf64c23c82a$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></g></svg>`
    }, props, {
        newIcon: $eb086cf64c23c82a$var$_showMoreHorizontal.default
    }));
$eb086cf64c23c82a$var$MoreIcon.displayName = "MoreIcon";
var $eb086cf64c23c82a$var$_default = module.exports.default = $eb086cf64c23c82a$var$MoreIcon;

});
parcelRegister("fAASt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3a425de3d8288b05a3222c93ad991c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b596d2ed3fc72809$var$_react = $b596d2ed3fc72809$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $b596d2ed3fc72809$var$_UNSAFE_baseNew = $b596d2ed3fc72809$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $b596d2ed3fc72809$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b596d2ed3fc72809$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $b596d2ed3fc72809$var$_react.default.createElement($b596d2ed3fc72809$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.25 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path stroke="currentcolor" stroke-width="1.5" d="M2.25 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"/>`
    }, props));
$b596d2ed3fc72809$var$ShowMoreHorizontalIcon.displayName = "ShowMoreHorizontalIcon";
var $b596d2ed3fc72809$var$_default = module.exports.default = $b596d2ed3fc72809$var$ShowMoreHorizontalIcon;

});


parcelRegister("gFUKI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c23c7f8c69a423c9$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9q1kH = parcelRequire("9q1kH");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $1FiMp = parcelRequire("1FiMp");

var $2eMVY = parcelRequire("2eMVY");

var $8p2GL = parcelRequire("8p2GL");

var $ay1rd = parcelRequire("ay1rd");

var $JcvLo = parcelRequire("JcvLo");
var $gWA00 = parcelRequire("gWA00");

var $htChF = parcelRequire("htChF");

var $aRH7N = parcelRequire("aRH7N");

var $97YIy = parcelRequire("97YIy");

var $28Syw = parcelRequire("28Syw");

var $5LqgM = parcelRequire("5LqgM");

var $1TFMd = parcelRequire("1TFMd");

var $fKTgs = parcelRequire("fKTgs");

var $6hNJn = parcelRequire("6hNJn");

var $hikI6 = parcelRequire("hikI6");
function $c23c7f8c69a423c9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c23c7f8c69a423c9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c23c7f8c69a423c9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c23c7f8c69a423c9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c23c7f8c69a423c9$var$tooltipZIndex = (0, $28Syw.layers).tooltip();
var $c23c7f8c69a423c9$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "18.7.1"
};
// Inverts motion direction
var $c23c7f8c69a423c9$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $c23c7f8c69a423c9$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
function $c23c7f8c69a423c9$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $6hNJn.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $8p2GL.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $8p2GL.default) : _ref$onHide, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi;
    var tooltipPosition = position === "mouse" ? mousePosition : position;
    var onShowHandler = (0, $2eMVY.usePlatformLeafSyntheticEventHandler)($c23c7f8c69a423c9$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $c23c7f8c69a423c9$var$analyticsAttributes));
    var onHideHandler = (0, $2eMVY.usePlatformLeafSyntheticEventHandler)($c23c7f8c69a423c9$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $c23c7f8c69a423c9$var$analyticsAttributes));
    var apiRef = (0, $9nHZC.useRef)(null);
    var _useState = (0, $9nHZC.useState)("hide"), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $9nHZC.useRef)(null);
    var containerRef = (0, $9nHZC.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $9nHZC.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var lastState = (0, $9nHZC.useRef)(state);
    var lastDelay = (0, $9nHZC.useRef)(delay);
    var lastHandlers = (0, $9nHZC.useRef)({
        onShowHandler: onShowHandler,
        onHideHandler: onHideHandler
    });
    var hasCalledShowHandler = (0, $9nHZC.useRef)(false);
    (0, $9nHZC.useEffect)(function() {
        lastState.current = state;
        lastDelay.current = delay;
        lastHandlers.current = {
            onShowHandler: onShowHandler,
            onHideHandler: onHideHandler
        };
    }, [
        delay,
        onHideHandler,
        onShowHandler,
        state
    ]);
    var start = (0, $9nHZC.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $9nHZC.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, []);
    var abort = (0, $9nHZC.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
    }, []);
    (0, $9nHZC.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $9nHZC.useRef)(false);
    (0, $9nHZC.useEffect)(function() {
        return (0, $5LqgM.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var showTooltip = (0, $9nHZC.useCallback)(function(source) {
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // Tell the tooltip to keep showing
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        var entry = {
            source: source,
            delay: lastDelay.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    lastHandlers.current.onShowHandler();
                }
                setState(isImmediate ? "show-immediate" : "fade-in");
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done
        };
        var api = (0, $1TFMd.show)(entry);
        start(api);
    }, [
        abort,
        done,
        start
    ]);
    var hideTooltipOnEsc = (0, $9nHZC.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $ay1rd.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $9nHZC.useEffect)(function() {
        if (state === "hide") return 0, $8p2GL.default;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $1FiMp.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $9nHZC.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $9nHZC.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $9nHZC.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === "mouse" ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            mouse: (0, $hikI6.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: "keyboard"
        };
        showTooltip(source);
    }, [
        position,
        showTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $9nHZC.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === "mouse" ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $hikI6.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $9nHZC.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $9nHZC.useCallback)(function() {
        showTooltip({
            type: "keyboard"
        });
    }, [
        showTooltip
    ]);
    var onBlur = (0, $9nHZC.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $9nHZC.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && lastState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, []);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipContainer = state !== "hide" && Boolean(content);
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current4;
        if (position === "mouse" && (_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.mousePosition) {
            var _apiRef$current5;
            return (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 ? void 0 : _apiRef$current5.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipId = (0, $fKTgs.default)("tooltip", shouldRenderTooltipContainer);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    (0, $9nHZC.useEffect)(function() {
        // If there is no container element, we should exit early, because that
        // means they are using the render prop API, and that is implemented in a
        // different way. If there is no target element yet or tooltipId, we also
        // shouldn't do anything because there is nothing to operate on or with.
        if (!containerRef.current || !targetRef.current || !tooltipId) return;
        var target = targetRef.current;
        if (shouldRenderTooltipContainer) target.setAttribute("aria-describedby", tooltipId);
        else target.removeAttribute("aria-describedby");
    }, [
        shouldRenderTooltipContainer,
        tooltipId
    ]);
    var hiddenContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipId
    }, typeof content === "function" ? content({}) : content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, typeof children === "function" ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, children($c23c7f8c69a423c9$var$_objectSpread($c23c7f8c69a423c9$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipId,
        ref: setDirectRef
    })), shouldRenderTooltipContainer && hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, shouldRenderTooltipContainer && hiddenContent), shouldRenderTooltipContainer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $97YIy.default), {
        zIndex: $c23c7f8c69a423c9$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aRH7N.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === "mouse" ? undefined : $c23c7f8c69a423c9$var$invertedDirection[$c23c7f8c69a423c9$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $JcvLo.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $gWA00.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state === "show-immediate" ? 0 : (0, $htChF.mediumDurationMs)
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $c23c7f8c69a423c9$var$_objectSpread($c23c7f8c69a423c9$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: "none"
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$c23c7f8c69a423c9$var$Tooltip.displayName = "Tooltip";
var $c23c7f8c69a423c9$export$2e2bcd8739ae039 = $c23c7f8c69a423c9$var$Tooltip;

});
parcelRegister("2eMVY", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $1a12d8dfea1e1ecb$export$1a04351537078b55; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $lx35z = parcelRequire("lx35z");

var $1k47V = parcelRequire("1k47V");
function $1a12d8dfea1e1ecb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1a12d8dfea1e1ecb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1a12d8dfea1e1ecb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1a12d8dfea1e1ecb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1a12d8dfea1e1ecb$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $lx35z.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $1k47V.useTrackedRef)(analyticsData);
    var fnRef = (0, $1k47V.useTrackedRef)(fn);
    var handler = (0, $9nHZC.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $1a12d8dfea1e1ecb$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("lx35z", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $facf1371827c458d$export$5bf35293e545f20c; });

var $dNznA = parcelRequire("dNznA");

var $e3boz = parcelRequire("e3boz");

var $jwFMp = parcelRequire("jwFMp");
function $facf1371827c458d$export$5bf35293e545f20c() {
    var analyticsContext = (0, $jwFMp.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $e3boz.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("e3boz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3aa2f6093f8a3be$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $jkzWW = parcelRequire("jkzWW");
function $a3aa2f6093f8a3be$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a3aa2f6093f8a3be$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $a3aa2f6093f8a3be$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a3aa2f6093f8a3be$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $a3aa2f6093f8a3be$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $a3aa2f6093f8a3be$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $a3aa2f6093f8a3be$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $a3aa2f6093f8a3be$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $jkzWW.default));

});
parcelRegister("jkzWW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e12bc5733a2bd59d$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
function $e12bc5733a2bd59d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e12bc5733a2bd59d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e12bc5733a2bd59d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e12bc5733a2bd59d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e12bc5733a2bd59d$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $e12bc5733a2bd59d$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $e12bc5733a2bd59d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $e12bc5733a2bd59d$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(updater) === "object") this.payload = $e12bc5733a2bd59d$var$_objectSpread($e12bc5733a2bd59d$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("jwFMp", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $e3716a0f83182de8$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $e3716a0f83182de8$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});


parcelRegister("1k47V", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $0f6adc3a1425a2d1$export$1d27a74659855e44; });

var $9nHZC = parcelRequire("9nHZC");
var $0f6adc3a1425a2d1$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("28Syw", function(module, exports) {

$parcel$export(module.exports, "layers", function () { return $18f6a5c5c6f55404$export$7be255094ccdc533; });

var $1OnrY = parcelRequire("1OnrY");

var $gMke4 = parcelRequire("gMke4");
var $18f6a5c5c6f55404$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $18f6a5c5c6f55404$export$c93026a968943f95 = "light";
var $18f6a5c5c6f55404$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $18f6a5c5c6f55404$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $18f6a5c5c6f55404$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $18f6a5c5c6f55404$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $18f6a5c5c6f55404$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $18f6a5c5c6f55404$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $18f6a5c5c6f55404$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $18f6a5c5c6f55404$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $gMke4.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $18f6a5c5c6f55404$export$6d8204c2cb2e06b8() / 4;
    (0, $1OnrY.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $18f6a5c5c6f55404$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $18f6a5c5c6f55404$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $18f6a5c5c6f55404$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $1OnrY.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $18f6a5c5c6f55404$export$ba1d834b86d72a09 = $18f6a5c5c6f55404$export$a1b3edb637fb4f35;
var $18f6a5c5c6f55404$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $gMke4.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $gMke4.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $gMke4.N30A), ")")
            }
        }
    };
};

});
parcelRegister("gMke4", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $c370d179e8bcc247$export$215b7063051591f1; });
$parcel$export(module.exports, "N0", function () { return $c370d179e8bcc247$export$29a4f05edc054374; });
$parcel$export(module.exports, "N800", function () { return $c370d179e8bcc247$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $c370d179e8bcc247$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $c370d179e8bcc247$export$920c0d5c49070351; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $c370d179e8bcc247$export$4b84fd0e2c617bd = "#FFEBE6";
var $c370d179e8bcc247$export$b34b069eff244586 = "#FFBDAD";
var $c370d179e8bcc247$export$be802dd0d8b57f35 = "#FF8F73";
var $c370d179e8bcc247$export$60847d42f9da92a6 = "#FF7452";
var $c370d179e8bcc247$export$4a7404f376229999 = "#FF5630";
var $c370d179e8bcc247$export$2010d0fb4295b346 = "#DE350B";
var $c370d179e8bcc247$export$2837b5a1a71d5c02 = "#BF2600";
var $c370d179e8bcc247$export$8d9596b529bbb9cf = "#FFFAE6";
var $c370d179e8bcc247$export$41060a744ab0b7ae = "#FFF0B3";
var $c370d179e8bcc247$export$1cc05bbbf340e559 = "#FFE380";
var $c370d179e8bcc247$export$5aae31392d72caaa = "#FFC400";
var $c370d179e8bcc247$export$c6930421db9fa514 = "#FFAB00";
var $c370d179e8bcc247$export$59619663aa6500fb = "#FF991F";
var $c370d179e8bcc247$export$874739ea9e379ab6 = "#FF8B00";
var $c370d179e8bcc247$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $c370d179e8bcc247$export$69a3bf21b9686c2b = "#ABF5D1";
var $c370d179e8bcc247$export$afbce1382ec95f73 = "#79F2C0";
var $c370d179e8bcc247$export$747d86715d4175de = "#57D9A3";
var $c370d179e8bcc247$export$940e1f69e873f202 = "#36B37E";
var $c370d179e8bcc247$export$a49394138f7b8e85 = "#00875A";
var $c370d179e8bcc247$export$6fa04827ac68a4fb = "#006644";
var $c370d179e8bcc247$export$226de0355ed012f8 = "#DEEBFF";
var $c370d179e8bcc247$export$8c13c2ee36917869 = "#B3D4FF";
var $c370d179e8bcc247$export$ecfc1dff386a3e7a = "#4C9AFF";
var $c370d179e8bcc247$export$215b7063051591f1 = "#2684FF";
var $c370d179e8bcc247$export$e62e8919cca44969 = "#0065FF";
var $c370d179e8bcc247$export$b3de0ae08da2ce64 = "#0052CC";
var $c370d179e8bcc247$export$a6ee3d71bc067634 = "#0747A6";
var $c370d179e8bcc247$export$363e4475840015bb = "#EAE6FF";
var $c370d179e8bcc247$export$4b0a4417ed59760f = "#C0B6F2";
var $c370d179e8bcc247$export$6011520a64d9a187 = "#998DD9";
var $c370d179e8bcc247$export$a7175d4e9206bc80 = "#8777D9";
var $c370d179e8bcc247$export$b48405b95304b5a1 = "#6554C0";
var $c370d179e8bcc247$export$c71e4279dd54a18d = "#5243AA";
var $c370d179e8bcc247$export$147899de772240ec = "#403294";
var $c370d179e8bcc247$export$2cf711fe14c66f06 = "#E6FCFF";
var $c370d179e8bcc247$export$7a8f4d33f6f9772c = "#B3F5FF";
var $c370d179e8bcc247$export$776c9c497ef08533 = "#79E2F2";
var $c370d179e8bcc247$export$69cb3ca10c1e330e = "#00C7E6";
var $c370d179e8bcc247$export$9dc1ef0f3f48059b = "#00B8D9";
var $c370d179e8bcc247$export$7c835c78b6fcdef8 = "#00A3BF";
var $c370d179e8bcc247$export$6036577f95c3877e = "#008DA6";
var $c370d179e8bcc247$export$29a4f05edc054374 = "#FFFFFF";
var $c370d179e8bcc247$export$e655ef011c4aa1a2 = "#FAFBFC";
var $c370d179e8bcc247$export$9fdfb749e33cdf97 = "#F4F5F7";
var $c370d179e8bcc247$export$3e51e8f1440314ba = "#EBECF0";
var $c370d179e8bcc247$export$1ce2d1575d444ceb = "#DFE1E6";
var $c370d179e8bcc247$export$8754fc7e6d8b3000 = "#C1C7D0";
var $c370d179e8bcc247$export$c2e91cbeada39b8b = "#B3BAC5";
var $c370d179e8bcc247$export$5f71e19f3a7ad9de = "#A5ADBA";
var $c370d179e8bcc247$export$eaa8c8a70ac22806 = "#97A0AF";
var $c370d179e8bcc247$export$7c87d337fb91a97d = "#8993A4";
var $c370d179e8bcc247$export$d6447c357493214f = "#7A869A";
var $c370d179e8bcc247$export$f563ee71e9ee74cd = "#6B778C";
var $c370d179e8bcc247$export$e2ef2124cf4024b1 = "#5E6C84";
var $c370d179e8bcc247$export$eece5f492e429f08 = "#505F79";
var $c370d179e8bcc247$export$c39c0fe0f26207ae = "#42526E";
var $c370d179e8bcc247$export$7090862dc3038a9f = "#344563";
var $c370d179e8bcc247$export$ad0bacf983b7ddaa = "#253858";
var $c370d179e8bcc247$export$7d61b15e0da132af = "#172B4D";
var $c370d179e8bcc247$export$fbda843f0a27fe96 = "#091E42";
var $c370d179e8bcc247$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $c370d179e8bcc247$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $c370d179e8bcc247$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $c370d179e8bcc247$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $c370d179e8bcc247$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $c370d179e8bcc247$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $c370d179e8bcc247$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $c370d179e8bcc247$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $c370d179e8bcc247$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $c370d179e8bcc247$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $c370d179e8bcc247$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $c370d179e8bcc247$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $c370d179e8bcc247$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $c370d179e8bcc247$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $c370d179e8bcc247$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $c370d179e8bcc247$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $c370d179e8bcc247$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $c370d179e8bcc247$export$2f6319cf7d736c2a = "#E6EDFA";
var $c370d179e8bcc247$export$95126bc8884d6634 = "#DCE5F5";
var $c370d179e8bcc247$export$8338d8c35d44ff1 = "#CED9EB";
var $c370d179e8bcc247$export$5368d76ae4fbbda7 = "#B8C7E0";
var $c370d179e8bcc247$export$9f0a771d16ec8d36 = "#ABBBD6";
var $c370d179e8bcc247$export$abcf8c38338b4aa5 = "#9FB0CC";
var $c370d179e8bcc247$export$97e81faa16a182c7 = "#8C9CB8";
var $c370d179e8bcc247$export$bfe21c59123ecf33 = "#7988A3";
var $c370d179e8bcc247$export$ee82aa2ea6a1558 = "#67758F";
var $c370d179e8bcc247$export$682927c6ed76be02 = "#56637A";
var $c370d179e8bcc247$export$91fd9994c5be9757 = "#455166";
var $c370d179e8bcc247$export$d281fbfe3cff2df6 = "#3B475C";
var $c370d179e8bcc247$export$3902c91d8b98a753 = "#313D52";
var $c370d179e8bcc247$export$8e8133c1ba5845b5 = "#283447";
var $c370d179e8bcc247$export$33ff357f6620b39 = "#202B3D";
var $c370d179e8bcc247$export$633847cf062b69e0 = "#1B2638";
var $c370d179e8bcc247$export$9776a6e503bdbf76 = "#121A29";
var $c370d179e8bcc247$export$6c813d5160dff5db = "#0E1624";
var $c370d179e8bcc247$export$3d4f271a500072a = "#0D1424";
var $c370d179e8bcc247$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $c370d179e8bcc247$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $c370d179e8bcc247$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $c370d179e8bcc247$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $c370d179e8bcc247$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $c370d179e8bcc247$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $c370d179e8bcc247$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $c370d179e8bcc247$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $c370d179e8bcc247$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $c370d179e8bcc247$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $c370d179e8bcc247$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $c370d179e8bcc247$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $c370d179e8bcc247$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $c370d179e8bcc247$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $c370d179e8bcc247$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $c370d179e8bcc247$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $c370d179e8bcc247$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";

});


parcelRegister("5LqgM", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $4325b8265739d91f$export$6503ec6e8aabbaf; });
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $1FiMp = parcelRequire("1FiMp");
var $4325b8265739d91f$var$registrations = new Set();
var $4325b8265739d91f$var$cleanupEndEventListeners = null;
function $4325b8265739d91f$var$onDragStart() {
    if ($4325b8265739d91f$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $4325b8265739d91f$var$cleanupEndEventListeners = (0, $1FiMp.bindAll)(window, [
        {
            type: "dragend",
            listener: $4325b8265739d91f$var$onDragEnd
        },
        {
            type: "pointerdown",
            listener: $4325b8265739d91f$var$onDragEnd
        },
        {
            type: "pointermove",
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $4325b8265739d91f$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($4325b8265739d91f$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $4325b8265739d91f$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $4325b8265739d91f$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $4325b8265739d91f$var$cleanupEndEventListeners = null;
    var clone = Array.from($4325b8265739d91f$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $4325b8265739d91f$var$bindStartEvents() {
    return (0, $1FiMp.bindAll)(window, [
        {
            type: "dragstart",
            listener: $4325b8265739d91f$var$onDragStart
        },
        {
            type: "dragenter",
            listener: $4325b8265739d91f$var$onDragStart
        }
    ]);
}
var $4325b8265739d91f$var$cleanupStartEventListeners = null;
function $4325b8265739d91f$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$4325b8265739d91f$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $4325b8265739d91f$var$cleanupStartEventListeners = $4325b8265739d91f$var$bindStartEvents();
    $4325b8265739d91f$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $4325b8265739d91f$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $4325b8265739d91f$var$registrations.delete(registration);
        if ($4325b8265739d91f$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $4325b8265739d91f$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $4325b8265739d91f$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("1TFMd", function(module, exports) {

$parcel$export(module.exports, "show", function () { return $161b557ed695d735$export$57bf213be019eeb0; });

var $2leCH = parcelRequire("2leCH");
// This file is a singleton for managing tooltips
var $161b557ed695d735$var$active = null;
function $161b557ed695d735$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($161b557ed695d735$var$active && $161b557ed695d735$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $2leCH.clearScheduled)();
            $161b557ed695d735$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $2leCH.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $2leCH.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $2leCH.scheduleTimeout)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($161b557ed695d735$var$active && $161b557ed695d735$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($161b557ed695d735$var$active) {
            (0, $2leCH.clearScheduled)();
            $161b557ed695d735$var$active.entry.hide({
                isImmediate: true
            });
            $161b557ed695d735$var$active.entry.done();
            $161b557ed695d735$var$active = null;
        }
        // this tooltip is now the active tooltip
        $161b557ed695d735$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $2leCH.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("2leCH", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", function () { return $1b48e2c8ba3f1109$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $1b48e2c8ba3f1109$export$5f4d6617421d489b; });
var $1b48e2c8ba3f1109$var$delayId = null;
function $1b48e2c8ba3f1109$export$eaf678f6f93f5250() {
    if ($1b48e2c8ba3f1109$var$delayId != null) {
        window.clearTimeout($1b48e2c8ba3f1109$var$delayId);
        $1b48e2c8ba3f1109$var$delayId = null;
    }
}
function $1b48e2c8ba3f1109$export$5f4d6617421d489b(fn, delay) {
    $1b48e2c8ba3f1109$export$eaf678f6f93f5250();
    $1b48e2c8ba3f1109$var$delayId = window.setTimeout(function() {
        $1b48e2c8ba3f1109$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("fKTgs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b78605408a34f7b7$export$2e2bcd8739ae039; });

var $9SZaS = parcelRequire("9SZaS");
function $b78605408a34f7b7$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $9SZaS.useUIDSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});

parcelRegister("6hNJn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $493ae82431e63009$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $gMke4 = parcelRequire("gMke4");

var $4kMYX = parcelRequire("4kMYX");
var $493ae82431e63009$var$baseStyles = (0, $avKww.css)({
    boxSizing: "border-box",
    maxWidth: "240px",
    padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-075, 6px)"),
    insetBlockStart: "var(--ds-space-0, 0px)",
    insetInlineStart: "var(--ds-space-0, 0px)",
    borderRadius: "var(--ds-border-radius, 3px)",
    font: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    overflowWrap: "break-word",
    wordWrap: "break-word",
    backgroundColor: "var(--ds-background-neutral-bold, ".concat((0, $gMke4.N800), ")"),
    color: "var(--ds-text-inverse, ".concat((0, $gMke4.N0), ")")
});
var $493ae82431e63009$var$truncateStyles = (0, $avKww.css)({
    maxWidth: "420px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $493ae82431e63009$var$TooltipContainer = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return (0, $avKww.jsx)((0, $4kMYX.default), {
        ref: ref,
        style: style,
        className: className,
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: [
            $493ae82431e63009$var$baseStyles,
            truncate ? $493ae82431e63009$var$truncateStyles : null
        ]
    }, children);
});
$493ae82431e63009$var$TooltipContainer.displayName = "TooltipContainer";
var $493ae82431e63009$export$2e2bcd8739ae039 = $493ae82431e63009$var$TooltipContainer;

});
parcelRegister("4kMYX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $327f06850588a1b8$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $28Syw = parcelRequire("28Syw");
function $327f06850588a1b8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $327f06850588a1b8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $327f06850588a1b8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $327f06850588a1b8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $327f06850588a1b8$var$VAR_PRIMITIVE_ZINDEX = "tooltipPrimitiveZindex";
var $327f06850588a1b8$var$primitiveStyles = (0, $avKww.css)({
    zindex: "var(".concat($327f06850588a1b8$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
var $327f06850588a1b8$var$TooltipPrimitive = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $327f06850588a1b8$var$_objectSpread($327f06850588a1b8$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, $327f06850588a1b8$var$VAR_PRIMITIVE_ZINDEX, (0, $28Syw.layers).tooltip()));
    return (0, $avKww.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $avKww.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $327f06850588a1b8$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$327f06850588a1b8$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $327f06850588a1b8$export$2e2bcd8739ae039 = $327f06850588a1b8$var$TooltipPrimitive;

});


parcelRegister("hikI6", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", function () { return $c9742eb9ab5401f9$export$642213d516a9b928; });
function $c9742eb9ab5401f9$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("7daq7", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", function () { return $5401d4881e8989b9$export$6aa22a823032b784; });
$parcel$export(module.exports, "ProfileImage", function () { return $5401d4881e8989b9$export$a7a74ab5cffd1455; });
$parcel$export(module.exports, "ActionsFlexSpacer", function () { return $5401d4881e8989b9$export$d395c8d16f1e359d; });
$parcel$export(module.exports, "KudosBlobAnimation", function () { return $5401d4881e8989b9$export$4a8a956251d4bf6f; });
$parcel$export(module.exports, "AnimationWrapper", function () { return $5401d4881e8989b9$export$58517bb1b373a54c; });
$parcel$export(module.exports, "AnimatedKudosButton", function () { return $5401d4881e8989b9$export$6196a3f52a6944fe; });
$parcel$export(module.exports, "ActionButtonGroup", function () { return $5401d4881e8989b9$export$73d695ae27330056; });
$parcel$export(module.exports, "OverflowActionButtonsWrapper", function () { return $5401d4881e8989b9$export$ff778e5b796745a6; });
$parcel$export(module.exports, "CardContent", function () { return $5401d4881e8989b9$export$64ef9b8c11710c47; });
$parcel$export(module.exports, "DetailsGroup", function () { return $5401d4881e8989b9$export$35cf684daac137ac; });
$parcel$export(module.exports, "DisabledInfo", function () { return $5401d4881e8989b9$export$2062e7265a95a823; });
$parcel$export(module.exports, "FullNameLabel", function () { return $5401d4881e8989b9$export$1270e9c1fc39142b; });
$parcel$export(module.exports, "LozengeWrapper", function () { return $5401d4881e8989b9$export$75180efdd3f4d9c2; });
$parcel$export(module.exports, "CustomLozengeContainer", function () { return $5401d4881e8989b9$export$6ebf103500ba5a45; });
$parcel$export(module.exports, "JobTitleLabel", function () { return $5401d4881e8989b9$export$d6c0e5f211c8d617; });
$parcel$export(module.exports, "AppTitleLabel", function () { return $5401d4881e8989b9$export$4865ffa72a4d5f9; });
$parcel$export(module.exports, "SpinnerContainer", function () { return $5401d4881e8989b9$export$a5e06607a5ac6158; });
$parcel$export(module.exports, "CardContainer", function () { return $5401d4881e8989b9$export$8a23e74e5cf3ca41; });
$parcel$export(module.exports, "DetailsLabel", function () { return $5401d4881e8989b9$export$138a08882ebf7289; });
$parcel$export(module.exports, "DetailsLabelIcon", function () { return $5401d4881e8989b9$export$79d7d9b2f6a70c70; });
$parcel$export(module.exports, "DetailsLabelText", function () { return $5401d4881e8989b9$export$b0ec2c767a0e0eab; });

var $fPPqr = parcelRequire("fPPqr");

var $hlgjl = parcelRequire("hlgjl");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $73D4V = parcelRequire("73D4V");

var $jp7ng = parcelRequire("jp7ng");

var $aP6k3 = parcelRequire("aP6k3");

var $bVB8f = parcelRequire("bVB8f");
var $5401d4881e8989b9$var$_templateObject, $5401d4881e8989b9$var$_templateObject2, $5401d4881e8989b9$var$_templateObject3, $5401d4881e8989b9$var$_templateObject4, $5401d4881e8989b9$var$_templateObject5, $5401d4881e8989b9$var$_templateObject6, $5401d4881e8989b9$var$_templateObject7, $5401d4881e8989b9$var$_templateObject8, $5401d4881e8989b9$var$_templateObject9, $5401d4881e8989b9$var$_templateObject10, $5401d4881e8989b9$var$_templateObject11, $5401d4881e8989b9$var$_templateObject12, $5401d4881e8989b9$var$_templateObject13, $5401d4881e8989b9$var$_templateObject14, $5401d4881e8989b9$var$_templateObject15, $5401d4881e8989b9$var$_templateObject16, $5401d4881e8989b9$var$_templateObject17, $5401d4881e8989b9$var$_templateObject18, $5401d4881e8989b9$var$_templateObject19, $5401d4881e8989b9$var$_templateObject20, $5401d4881e8989b9$var$_templateObject21, $5401d4881e8989b9$var$_templateObject22;
var $5401d4881e8989b9$var$getFullNameMargin = function getFullNameMargin(props) {
    return props.noMeta ? "var(--ds-space-400, 32px)".concat(" 0 ", "var(--ds-space-150, 12px)", " 0") : "var(--ds-space-150, 12px)".concat(" 0 0 0");
};
var $5401d4881e8989b9$export$6aa22a823032b784 = (0, $73D4V.default).div($5401d4881e8989b9$var$_templateObject || ($5401d4881e8989b9$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n	background-color: ",
    ";\n	border-radius: ",
    ";\n	width: ",
    "px;\n"
])), (0, $bVB8f.bgColor), "var(--ds-border-radius, 3px)", (0, $aP6k3.gridSize)() * 45);
var $5401d4881e8989b9$export$a7a74ab5cffd1455 = (0, $73D4V.default).div($5401d4881e8989b9$var$_templateObject2 || ($5401d4881e8989b9$var$_templateObject2 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n	position: absolute;\n	top: ",
    ";\n	left: ",
    ";\n"
])), "var(--ds-space-300, 24px)", "var(--ds-space-300, 24px)");
var $5401d4881e8989b9$export$d395c8d16f1e359d = (0, $73D4V.default).div($5401d4881e8989b9$var$_templateObject3 || ($5401d4881e8989b9$var$_templateObject3 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n	flex: 1 0 auto;\n"
])));
// eslint-disable-next-line @atlaskit/design-system/no-keyframes-tagged-template-expression -- needs manual remediation
var $5401d4881e8989b9$var$kudosButtonAnimationTransformation = (0, $avKww.keyframes)($5401d4881e8989b9$var$_templateObject4 || ($5401d4881e8989b9$var$_templateObject4 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n  0%   { transform: translate(-80px, -50px); }\n  100% { transform: translate(90px, -70px); }\n"
])));
var $5401d4881e8989b9$export$b08abf2f97b92ea5 = (0, $73D4V.default).div($5401d4881e8989b9$var$_templateObject5 || ($5401d4881e8989b9$var$_templateObject5 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n	display: none;\n	height: 150px;\n	width: 150px;\n	z-index: -1;\n	position: absolute;\n	top: ",
    "em;\n	animation-name: ",
    ";\n	animation-iteration-count: 1;\n	animation-duration: 3s;\n	background-image: radial-gradient(\n		circle,\n		",
    " 0%,\n		",
    " 25%,\n		transparent 50%\n	);\n	overflow: hidden;\n"
])), (0, $aP6k3.gridSize)() * 4 / (0, $aP6k3.fontSize)(), $5401d4881e8989b9$var$kudosButtonAnimationTransformation, "var(--ds-background-information-pressed, #85B8FF)", "var(--ds-background-discovery-pressed, #B8ACF6)");
var $5401d4881e8989b9$export$4a8a956251d4bf6f = function KudosBlobAnimation(props) {
    return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($5401d4881e8989b9$export$b08abf2f97b92ea5, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        className: "kudos-blob-animation"
    }, props)));
};
var $5401d4881e8989b9$export$58517bb1b373a54c = (0, $73D4V.default).div($5401d4881e8989b9$var$_templateObject6 || ($5401d4881e8989b9$var$_templateObject6 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n	clip-path: inset(0px 0px 0px 0px round ",
    "px);\n	position: absolute;\n	top: 0;\n	left: 0;\n	bottom: 0;\n	right: 0;\n"
])), (0, $aP6k3.borderRadius)());
var $5401d4881e8989b9$export$6196a3f52a6944fe = (0, $73D4V.default).div($5401d4881e8989b9$var$_templateObject7 || ($5401d4881e8989b9$var$_templateObject7 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n	margin-left: ",
    ";\n\n	/* Need babel-plugin-emotion to use component selector */\n	/* Previously with styled-components: &:hover {KudosBlobAnimation} { */\n	&:focus-within .kudos-blob-animation,\n	&:focus .kudos-blob-animation,\n	&:hover .kudos-blob-animation {\n		display: block;\n	}\n"
])), "var(--ds-space-100, 8px)");
var $5401d4881e8989b9$export$73d695ae27330056 = (0, $73D4V.default).div($5401d4881e8989b9$var$_templateObject8 || ($5401d4881e8989b9$var$_templateObject8 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n	user-select: none;\n	margin: ",
    " 0 0 0;\n	text-align: right;\n	display: flex;\n	justify-content: flex-end;\n\n	button,\n	a {\n		position: relative;\n	}\n\n	button,\n	a,\n	span {\n		margin-left: ",
    ";\n\n		&:first-child {\n			margin-left: ",
    ";\n		}\n	}\n\n	a,\n	button {\n		&:focus {\n			outline-color: ",
    ";\n			outline-offset: ",
    ";\n			outline-style: solid;\n			outline-width: ",
    ";\n		}\n	}\n"
])), "var(--ds-space-200, 16px)", "var(--ds-space-100, 8px)", "var(--ds-space-0, 0px)", "var(--ds-border-focused, ".concat((0, $jp7ng.B200), ")"), "var(--ds-border-width, 2px)", "var(--ds-border-width, 2px)");
var $5401d4881e8989b9$export$ff778e5b796745a6 = (0, $73D4V.default).div($5401d4881e8989b9$var$_templateObject9 || ($5401d4881e8989b9$var$_templateObject9 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n	display: inline-block;\n	width: ",
    ";\n	height: ",
    ";\n	margin-left: ",
    ";\n\n	button {\n		&:focus {\n			outline-color: ",
    ";\n			outline-offset: ",
    ";\n			outline-style: solid;\n			outline-width: ",
    ";\n		}\n	}\n"
])), "var(--ds-space-400, 32px)", "var(--ds-space-400, 32px)", "var(--ds-space-100, 8px)", "var(--ds-border-focused, ".concat((0, $jp7ng.B200), ")"), "var(--ds-border-width, 2px)", "var(--ds-border-width, 2px)");
var $5401d4881e8989b9$export$64ef9b8c11710c47 = (0, $73D4V.default).div($5401d4881e8989b9$var$_templateObject10 || ($5401d4881e8989b9$var$_templateObject10 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n	display: flex;\n	flex-direction: column;\n	min-height: ",
    "px;\n"
])), (0, $aP6k3.gridSize)() * 17);
var $5401d4881e8989b9$export$35cf684daac137ac = (0, $73D4V.default).div($5401d4881e8989b9$var$_templateObject11 || ($5401d4881e8989b9$var$_templateObject11 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n	display: flex;\n	flex-direction: column;\n	margin-left: ",
    "px;\n	width: ",
    "px;\n"
])), (0, $aP6k3.gridSize)() * 14.5, (0, $aP6k3.gridSize)() * 24.5);
var $5401d4881e8989b9$export$2062e7265a95a823 = (0, $73D4V.default).div($5401d4881e8989b9$var$_templateObject12 || ($5401d4881e8989b9$var$_templateObject12 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n	font-size: ",
    "px;\n	color: ",
    ";\n	margin: ",
    " 0 0 0;\n	line-height: 16px;\n"
])), (0, $aP6k3.fontSizeSmall)(), (0, $bVB8f.labelTextColor), "var(--ds-space-150, 12px)");
var $5401d4881e8989b9$export$1270e9c1fc39142b = (0, $73D4V.default).h2($5401d4881e8989b9$var$_templateObject13 || ($5401d4881e8989b9$var$_templateObject13 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n	overflow: hidden;\n	text-overflow: ellipsis;\n	white-space: nowrap;\n\n	font-size: 18px;\n	font-weight: 400;\n	letter-spacing: normal;\n	color: ",
    ";\n	margin: ",
    ";\n	line-height: ",
    "em;\n	:first-child {\n		margin: ",
    ";\n	}\n"
])), function(props) {
    return props.isDisabledAccount ? (0, $bVB8f.headerTextColorInactive) : (0, $bVB8f.headerTextColor);
}, function(props) {
    return $5401d4881e8989b9$var$getFullNameMargin(props);
}, 24 / 18, function(props) {
    return $5401d4881e8989b9$var$getFullNameMargin(props);
});
var $5401d4881e8989b9$export$75180efdd3f4d9c2 = (0, $73D4V.default).div($5401d4881e8989b9$var$_templateObject14 || ($5401d4881e8989b9$var$_templateObject14 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n	margin-top: ",
    ";\n	text-transform: uppercase;\n	display: block;\n"
])), "var(--ds-space-200, 16px)");
var $5401d4881e8989b9$export$6ebf103500ba5a45 = (0, $73D4V.default)($5401d4881e8989b9$export$75180efdd3f4d9c2)($5401d4881e8989b9$var$_templateObject15 || ($5401d4881e8989b9$var$_templateObject15 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n	display: flex;\n	flex-direction: row;\n	flex-wrap: wrap;\n	justify-content: flex-start;\n	margin-top: ",
    ";\n	> * {\n		margin-top: ",
    ";\n		&:not(:last-child) {\n			margin-right: ",
    ";\n		}\n	}\n"
])), "var(--ds-space-150, 12px)", "var(--ds-space-050, 4px)", "var(--ds-space-050, 4px)");
var $5401d4881e8989b9$export$d6c0e5f211c8d617 = (0, $73D4V.default).span($5401d4881e8989b9$var$_templateObject16 || ($5401d4881e8989b9$var$_templateObject16 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n	overflow: hidden;\n	text-overflow: ellipsis;\n	white-space: nowrap;\n\n	font-size: 14px;\n	color: ",
    ";\n	margin: 0 0 ",
    " 0;\n	line-height: ",
    "em;\n"
])), (0, $bVB8f.headerTextColor), "var(--ds-space-150, 12px)", 24 / 14);
var $5401d4881e8989b9$export$4865ffa72a4d5f9 = (0, $73D4V.default).span($5401d4881e8989b9$var$_templateObject17 || ($5401d4881e8989b9$var$_templateObject17 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n	background: ",
    ";\n	color: ",
    ";\n	border-radius: ",
    ";\n	padding: 0 ",
    ";\n	width: fit-content;\n	font-weight: bold;\n	text-transform: uppercase;\n\n	font-size: 12px;\n	margin: ",
    " 0 ",
    " 0;\n	line-height: ",
    "em;\n"
])), (0, $bVB8f.appLabelBgColor), (0, $bVB8f.appLabelTextColor), (0, $aP6k3.borderRadius)(), "var(--ds-space-075, 6px)", "var(--ds-space-050, 4px)", "var(--ds-space-150, 12px)", 24 / 14);
var $5401d4881e8989b9$export$a5e06607a5ac6158 = (0, $73D4V.default).div($5401d4881e8989b9$var$_templateObject18 || ($5401d4881e8989b9$var$_templateObject18 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n	align-items: center;\n	display: flex;\n	height: ",
    "px;\n	justify-content: center;\n	position: relative;\n"
])), (0, $aP6k3.gridSize)() * 12);
var $5401d4881e8989b9$export$8a23e74e5cf3ca41 = (0, $73D4V.default).div($5401d4881e8989b9$var$_templateObject19 || ($5401d4881e8989b9$var$_templateObject19 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n	position: relative;\n	-webkit-font-smoothing: antialiased;\n	-moz-osx-font-smoothing: grayscale;\n	background-image: linear-gradient(\n		to bottom,\n		",
    "\n			0%,\n		",
    " 100%\n	);\n	background-repeat: no-repeat;\n	background-size: 100% ",
    "px;\n	box-sizing: content-box;\n	padding: ",
    ";\n	box-shadow: ",
    ";\n	border-radius: ",
    ";\n\n	overflow: hidden;\n"
])), function(props) {
    return props.isDisabledUser ? (0, $bVB8f.headerBgColorDisabledUser) : (0, $bVB8f.headerBgColor);
}, function(props) {
    return props.isDisabledUser ? (0, $bVB8f.headerBgColorDisabledUser) : (0, $bVB8f.headerBgColor);
}, (0, $aP6k3.gridSize)() * 12, "var(--ds-space-300, 24px)", function(props) {
    return props.withoutElevation ? "" : "".concat("var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat((0, $jp7ng.N50A), ", 0 0 1px ").concat((0, $jp7ng.N60A)), ")"));
}, function(props) {
    return props.withoutElevation ? "" : "".concat((0, $aP6k3.borderRadius)(), "px");
});
var $5401d4881e8989b9$export$138a08882ebf7289 = (0, $73D4V.default).div($5401d4881e8989b9$var$_templateObject20 || ($5401d4881e8989b9$var$_templateObject20 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n	display: flex;\n	align-items: center;\n	line-height: 24px;\n	font-size: ",
    "px;\n	margin: ",
    " 0 0 0;\n	white-space: nowrap;\n\n	& + & {\n		margin-top: ",
    ";\n	}\n"
])), (0, $aP6k3.gridSize)() * 1.5, "var(--ds-space-200, 16px)", "var(--ds-space-025, 2px)");
var $5401d4881e8989b9$export$79d7d9b2f6a70c70 = (0, $73D4V.default).div($5401d4881e8989b9$var$_templateObject21 || ($5401d4881e8989b9$var$_templateObject21 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n	display: flex;\n	flex-shrink: 0;\n	color: ",
    ";\n	width: ",
    ";\n	height: ",
    ";\n	padding: ",
    ";\n	vertical-align: top;\n\n	svg {\n		width: 100%;\n		height: 100%;\n	}\n"
])), (0, $bVB8f.labelIconColor), "var(--ds-space-200, 16px)", "var(--ds-space-200, 16px)", "var(--ds-space-050, 4px)");
var $5401d4881e8989b9$export$b0ec2c767a0e0eab = (0, $73D4V.default).span($5401d4881e8989b9$var$_templateObject22 || ($5401d4881e8989b9$var$_templateObject22 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n	overflow: hidden;\n	text-overflow: ellipsis;\n	color: ",
    ";\n	padding-left: ",
    ";\n	margin-inline-start: 0;\n	margin-top: 0;\n"
])), (0, $bVB8f.labelTextColor), "var(--ds-space-050, 4px)");

});

parcelRegister("5YVyh", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", function () { return $45af32f85c5534b3$export$6aa22a823032b784; });
$parcel$export(module.exports, "TeamForbiddenErrorStateWrapper", function () { return $45af32f85c5534b3$export$66ecf3d3b7b1c016; });
$parcel$export(module.exports, "CardHeader", function () { return $45af32f85c5534b3$export$5665775b26e26c5d; });
$parcel$export(module.exports, "CardContent", function () { return $45af32f85c5534b3$export$64ef9b8c11710c47; });
$parcel$export(module.exports, "TeamName", function () { return $45af32f85c5534b3$export$8fe6f0aed18a58c7; });
$parcel$export(module.exports, "MemberCount", function () { return $45af32f85c5534b3$export$1cbd03a20253b620; });
$parcel$export(module.exports, "AvatarSection", function () { return $45af32f85c5534b3$export$82a6f3ee677bdbfe; });
$parcel$export(module.exports, "DescriptionWrapper", function () { return $45af32f85c5534b3$export$2bf1f2b0d31b60fc; });
$parcel$export(module.exports, "Description", function () { return $45af32f85c5534b3$export$393edc798c47379d; });
$parcel$export(module.exports, "ActionButtons", function () { return $45af32f85c5534b3$export$88c65d2d98aab183; });
$parcel$export(module.exports, "WrappedButton", function () { return $45af32f85c5534b3$export$44e087c32db6077d; });
$parcel$export(module.exports, "MoreButton", function () { return $45af32f85c5534b3$export$7f94856880993f27; });
$parcel$export(module.exports, "LoadingWrapper", function () { return $45af32f85c5534b3$export$43a792a870d28db2; });
$parcel$export(module.exports, "AccessLockSVGWrapper", function () { return $45af32f85c5534b3$export$71bcd744fda975e5; });

var $hlgjl = parcelRequire("hlgjl");

var $73D4V = parcelRequire("73D4V");

var $jp7ng = parcelRequire("jp7ng");

var $aP6k3 = parcelRequire("aP6k3");

var $dCDrX = parcelRequire("dCDrX");

var $bVB8f = parcelRequire("bVB8f");
var $45af32f85c5534b3$var$_templateObject;
var $45af32f85c5534b3$export$a443be8291b92497 = (0, $73D4V.default).div({
    display: "inherit"
});
var $45af32f85c5534b3$export$6aa22a823032b784 = (0, $73D4V.default).div({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: (0, $bVB8f.bgColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "".concat((0, $aP6k3.borderRadius)(), "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: "".concat((0, $aP6k3.gridSize)() * 40, "px"),
    position: "relative",
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale"
});
var $45af32f85c5534b3$export$66ecf3d3b7b1c016 = (0, $73D4V.default).div({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: "".concat((0, $aP6k3.gridSize)() * 40, "px"),
    position: "relative"
});
var $45af32f85c5534b3$export$5665775b26e26c5d = (0, $73D4V.default).div($45af32f85c5534b3$var$_templateObject || ($45af32f85c5534b3$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
    "\n	background-color: ",
    ";\n	background-image: ",
    ";\n	background-repeat: no-repeat;\n	background-position: center;\n	background-size: cover;\n	box-sizing: content-box;\n	height: ",
    "px;\n"
])), function(props) {
    return props.isLoading ? "var(--ds-background-neutral, ".concat((0, $jp7ng.N20), ")") : props.image ? "" : (0, $bVB8f.teamHeaderBgColor);
}, function(props) {
    return props.image ? "url(".concat(props.image, ")") : "";
}, (0, $aP6k3.gridSize)() * 16);
var $45af32f85c5534b3$export$64ef9b8c11710c47 = (0, $73D4V.default).div({
    display: "flex",
    flexDirection: "column",
    padding: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minHeight: "".concat((0, $aP6k3.gridSize)() * 13, "px")
});
var $45af32f85c5534b3$export$8fe6f0aed18a58c7 = (0, $73D4V.default).h6((0, $dCDrX.h600), {
    textTransform: "none",
    overflow: "hidden",
    maxHeight: "48px",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical"
});
var $45af32f85c5534b3$export$1cbd03a20253b620 = (0, $73D4V.default).div({
    color: "var(--ds-text-subtlest, ".concat((0, $jp7ng.N200), ")"),
    marginTop: "var(--ds-space-050, 4px)"
});
var $45af32f85c5534b3$export$82a6f3ee677bdbfe = (0, $73D4V.default).div({
    marginTop: "var(--ds-space-200, 16px)",
    marginLeft: "var(--ds-space-negative-025, -2px)"
});
var $45af32f85c5534b3$export$2bf1f2b0d31b60fc = (0, $73D4V.default).div({
    marginTop: "var(--ds-space-200, 16px)",
    alignItems: "center",
    display: "flex"
});
var $45af32f85c5534b3$export$393edc798c47379d = (0, $73D4V.default).span({
    overflow: "hidden",
    maxHeight: "60px",
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical"
});
var $45af32f85c5534b3$export$88c65d2d98aab183 = (0, $73D4V.default).div({
    width: "calc(100% + 8px)",
    display: "flex",
    justifyContent: "space-between",
    margin: "var(--ds-space-300, 24px)".concat(" ", "var(--ds-space-negative-300, -24px)", " 0 ", "var(--ds-space-negative-100, -8px)"),
    backgroundColor: "var(--ds-surface-overlay, hsla(0, 100%, 100%, 0.2))"
});
var $45af32f85c5534b3$export$44e087c32db6077d = (0, $73D4V.default).div({
    flexBasis: 0,
    flexGrow: 1,
    marginLeft: "var(--ds-space-100, 8px)"
});
var $45af32f85c5534b3$export$7f94856880993f27 = (0, $73D4V.default).div({
    marginLeft: "var(--ds-space-100, 8px)"
});
var $45af32f85c5534b3$export$43a792a870d28db2 = (0, $73D4V.default).div({
    textAlign: "center",
    marginTop: "var(--ds-space-500, 40px)"
});
var $45af32f85c5534b3$export$71bcd744fda975e5 = (0, $73D4V.default).div({
    marginBottom: "var(--ds-space-300, 24px)"
}); // export const LoadingTeamName = styled.div`
 //   width: 175px;
 //   height: ${gridSize () *3)px;
 //   border-radius: ${borderRadius}px;
 //   background-color: #f4f5f7;
 // `;
 // export const LoadingMemberCount = styled.div`
 //   width: 81px;
 //   height: ${gridSize () *2)px;
 //   border-radius: 3px;
 //   background-color: #f4f5f7;
 //   margin: 4px 0;
 // `;

});

parcelRegister("bZ064", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b95776ee12b6b66$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $b7ZcK = parcelRequire("b7ZcK");

var $bojMT = parcelRequire("bojMT");

var $iJFBU = parcelRequire("iJFBU");

var $5YVyh = parcelRequire("5YVyh");

var $18aOe = parcelRequire("18aOe");

var $jQHic = parcelRequire("jQHic");
var $8b95776ee12b6b66$export$2e2bcd8739ae039 = function(props) {
    var analytics = props.analytics;
    var intl = (0, $b7ZcK.default)();
    (0, $9nHZC.useEffect)(function() {
        analytics(function(duration) {
            return (0, $18aOe.profileCardRendered)("team", "error", {
                duration: duration
            });
        });
    }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5YVyh.TeamForbiddenErrorStateWrapper), {
        "data-testid": "team-profilecard-forbidden-error-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $bojMT.default), {
        header: intl.formatMessage((0, $iJFBU.default).teamForbiddenErrorStateTitle),
        description: intl.formatMessage((0, $iJFBU.default).teamForbiddenErrorStateDescription),
        renderImage: function renderImage() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5YVyh.AccessLockSVGWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $jQHic.default), null));
        }
    }));
};

});
parcelRegister("jQHic", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e73474a0ddb82bf4$export$2e2bcd8739ae039; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $9nHZC = parcelRequire("9nHZC");
var $e73474a0ddb82bf4$var$AccessLockSVG = function AccessLockSVG() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("svg", {
        width: "191",
        height: "222",
        viewBox: "0 0 191 222",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("g", {
        clipPath: "url(#clip0)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M0 0.400391H190.2V221.9H0V0.400391Z",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M122.7 119.9H49.4V36.9998C49.8906 27.6107 53.9659 18.7679 60.7854 12.2956C67.6048 5.82318 76.6481 2.21484 86.05 2.21484C95.4519 2.21484 104.495 5.82318 111.315 12.2956C118.134 18.7679 122.209 27.6107 122.7 36.9998V119.9ZM61.4 107.9H110.7V36.9998C110.301 30.7336 107.53 24.8546 102.951 20.5583C98.3722 16.2619 92.3289 13.8706 86.05 13.8706C79.7711 13.8706 73.7279 16.2619 69.149 20.5583C64.5701 24.8546 61.7993 30.7336 61.4 36.9998V107.9Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M160.3 111.601C152.848 97.4396 150.855 81.0347 154.7 65.501C154.883 64.7606 154.894 63.9882 154.733 63.2428C154.572 62.4974 154.242 61.7989 153.769 61.2005C153.296 60.6022 152.693 60.1199 152.005 59.7907C151.317 59.4615 150.563 59.2939 149.8 59.301H19.1C18.348 59.2976 17.605 59.4639 16.9262 59.7874C16.2474 60.111 15.6503 60.5834 15.1794 61.1697C14.7085 61.7559 14.3758 62.4408 14.2063 63.1734C14.0367 63.906 14.0346 64.6675 14.2 65.401C17.9782 81.0252 15.9154 97.4916 8.4 111.701C2.5112 123.071 -0.389112 135.752 -0.0282299 148.551C0.332652 161.351 3.94288 173.848 10.463 184.868C16.9831 195.888 26.1988 205.069 37.2436 211.548C48.2884 218.026 60.7993 221.589 73.6 221.901H91.5C101.565 222.141 111.577 220.365 120.946 216.679C130.315 212.992 138.851 207.469 146.054 200.434C153.257 193.399 158.979 184.995 162.886 175.715C166.792 166.436 168.803 156.469 168.8 146.401C168.86 134.28 165.941 122.33 160.3 111.601Z",
        fill: "#FF991F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M154.7 65.501C154.883 64.7606 154.894 63.9882 154.733 63.2428C154.572 62.4974 154.242 61.7989 153.769 61.2005C153.296 60.6022 152.693 60.1199 152.005 59.7907C151.317 59.4615 150.563 59.2939 149.8 59.301H36.9C36.154 59.3157 35.4203 59.494 34.7507 59.8232C34.0812 60.1523 33.492 60.6244 33.0247 61.2061C32.5574 61.7878 32.2235 62.4649 32.0464 63.1897C31.8694 63.9146 31.8535 64.6694 32 65.401C35.8087 81.0131 33.7816 97.4789 26.3 111.701C20.3828 123.006 17.4891 135.648 17.9 148.401C18.9 188.401 51.5 220.901 91.5 221.901C101.565 222.141 111.577 220.365 120.946 216.679C130.314 212.992 138.851 207.469 146.054 200.434C153.257 193.399 158.979 184.995 162.886 175.715C166.792 166.436 168.803 156.469 168.8 146.401C168.86 134.28 165.941 122.33 160.3 111.601C152.848 97.4396 150.855 81.0347 154.7 65.501Z",
        fill: "#FFAB00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M93.4001 214H91.7001C80.2465 213.718 69.0525 210.53 59.1692 204.735C49.2859 198.939 41.0377 190.727 35.1991 180.87C29.3605 171.012 26.1231 159.832 25.7909 148.38C25.4587 136.928 28.0426 125.579 33.3001 115.4C41.036 100.558 43.5711 83.5517 40.5001 67.0996H146.2C143.017 83.4736 145.522 100.444 153.3 115.2C158.352 124.82 160.962 135.534 160.9 146.4C160.926 155.276 159.199 164.07 155.818 172.277C152.436 180.484 147.467 187.942 141.195 194.223C134.923 200.505 127.472 205.485 119.27 208.879C111.068 212.273 102.276 214.013 93.4001 214Z",
        fill: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("g", {
        style: {
            mixBlendMode: "multiply"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M152.8 178.6L84.5 119.6L80.8 123.9L149.9 183.5L152.8 178.6Z",
        fill: "#FFE380"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M90.4 170.601C88.3452 170.598 86.3155 170.15 84.4509 169.287C82.5862 168.424 80.9312 167.166 79.5999 165.601C78.2601 164.053 77.2786 162.229 76.7254 160.259C76.1722 158.288 76.0611 156.219 76.4 154.201L78.3 141.601C75.4643 138.69 73.5294 135.023 72.7277 131.039C71.926 127.055 72.2917 122.925 73.7808 119.144C75.2699 115.363 77.8191 112.093 81.122 109.726C84.4249 107.359 88.3411 105.996 92.4 105.801H93.4C98.996 105.801 104.363 108.024 108.32 111.981C112.277 115.938 114.5 121.305 114.5 126.901C114.496 132.416 112.302 137.703 108.4 141.601L110.4 154.201C110.692 156.226 110.548 158.291 109.979 160.257C109.41 162.222 108.428 164.044 107.1 165.601C105.769 167.166 104.114 168.424 102.249 169.287C100.384 170.15 98.3547 170.598 96.3 170.601H90.4Z",
        fill: "#FFAB00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M106.6 126.9C106.586 128.711 106.196 130.499 105.456 132.151C104.716 133.803 103.641 135.284 102.3 136.5C101.574 137.222 101.032 138.107 100.719 139.081C100.405 140.056 100.33 141.091 100.5 142.1L102.6 155.4C102.728 156.305 102.662 157.226 102.405 158.103C102.147 158.979 101.706 159.79 101.109 160.482C100.512 161.173 99.7741 161.729 98.9446 162.112C98.1152 162.494 97.2134 162.695 96.3 162.7H90.4C89.4866 162.695 88.5848 162.494 87.7554 162.112C86.926 161.729 86.188 161.173 85.5912 160.482C84.9944 159.79 84.5526 158.979 84.2954 158.103C84.0382 157.226 83.9715 156.305 84.1 155.4L86.2 142C86.3747 140.983 86.2925 139.937 85.9607 138.959C85.6289 137.981 85.058 137.102 84.3 136.4C82.8962 135.116 81.7988 133.532 81.0892 131.767C80.3795 130.001 80.0756 128.099 80.2 126.2C80.2928 122.699 81.7726 119.379 84.3137 116.969C86.8548 114.559 90.2492 113.258 93.75 113.35C97.2509 113.443 100.571 114.923 102.981 117.464C105.391 120.005 106.693 123.399 106.6 126.9Z",
        fill: "#253858"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M149.2 130.901H93.4C92.8286 130.992 92.2443 130.959 91.6872 130.802C91.1302 130.645 90.6138 130.37 90.1736 129.994C89.7334 129.619 89.3799 129.152 89.1375 128.627C88.8951 128.102 88.7695 127.53 88.7695 126.951C88.7695 126.373 88.8951 125.801 89.1375 125.275C89.3799 124.75 89.7334 124.284 90.1736 123.908C90.6138 123.532 91.1302 123.257 91.6872 123.1C92.2443 122.944 92.8286 122.91 93.4 123.001H149.2C150.14 123.151 150.995 123.631 151.613 124.355C152.23 125.079 152.57 126 152.57 126.951C152.57 127.903 152.23 128.823 151.613 129.547C150.995 130.271 150.14 130.751 149.2 130.901Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M153.1 126.901C153.075 125.875 152.656 124.897 151.93 124.172C151.204 123.446 150.226 123.027 149.2 123.001H112.4C111.829 122.91 111.244 122.944 110.687 123.1C110.13 123.257 109.614 123.532 109.174 123.908C108.733 124.284 108.38 124.75 108.137 125.275C107.895 125.801 107.77 126.373 107.77 126.951C107.77 127.53 107.895 128.102 108.137 128.627C108.38 129.152 108.733 129.619 109.174 129.994C109.614 130.37 110.13 130.645 110.687 130.802C111.244 130.959 111.829 130.992 112.4 130.901H149.2C150.243 130.875 151.235 130.442 151.964 129.695C152.693 128.947 153.1 127.945 153.1 126.901Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M167.7 149.4C163.25 149.4 158.9 148.081 155.2 145.608C151.5 143.136 148.616 139.622 146.913 135.511C145.21 131.399 144.764 126.875 145.632 122.511C146.5 118.146 148.643 114.137 151.79 110.99C154.937 107.844 158.946 105.701 163.31 104.833C167.675 103.965 172.199 104.41 176.31 106.113C180.422 107.816 183.936 110.7 186.408 114.4C188.88 118.1 190.2 122.45 190.2 126.9C190.2 132.868 187.829 138.591 183.61 142.81C179.39 147.03 173.667 149.4 167.7 149.4ZM167.7 112.3C164.812 112.3 161.99 113.157 159.589 114.761C157.188 116.365 155.316 118.645 154.211 121.313C153.106 123.981 152.817 126.917 153.381 129.749C153.944 132.581 155.334 135.182 157.376 137.224C159.418 139.266 162.02 140.657 164.852 141.22C167.684 141.783 170.619 141.494 173.287 140.389C175.955 139.284 178.235 137.413 179.839 135.012C181.444 132.611 182.3 129.788 182.3 126.9C182.274 123.036 180.727 119.338 177.995 116.606C175.262 113.873 171.564 112.327 167.7 112.3Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M67.8 165.301H55.6C55.3423 165.278 55.1009 165.166 54.918 164.983C54.7351 164.8 54.6225 164.558 54.6 164.301C54.6 164.036 54.7053 163.781 54.8929 163.594C55.0804 163.406 55.3348 163.301 55.6 163.301H67.8C68.0652 163.301 68.3196 163.406 68.5071 163.594C68.6946 163.781 68.8 164.036 68.8 164.301C68.7775 164.558 68.6649 164.8 68.482 164.983C68.2991 165.166 68.0576 165.278 67.8 165.301Z",
        fill: "#FFFAE5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M62.7999 182.5C62.6675 182.512 62.5342 182.491 62.412 182.438C62.2897 182.386 62.1825 182.304 62.0999 182.2C61.9167 182.013 61.8141 181.761 61.8141 181.5C61.8141 181.238 61.9167 180.987 62.0999 180.8L70.4999 172.3C70.6925 172.155 70.9307 172.085 71.1708 172.102C71.4109 172.119 71.6368 172.222 71.807 172.393C71.9773 172.563 72.0804 172.789 72.0974 173.029C72.1145 173.269 72.0444 173.507 71.8999 173.7L63.4999 182.2C63.3098 182.38 63.0616 182.486 62.7999 182.5Z",
        fill: "#FFFAE5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M79.9 189.6C79.6424 189.577 79.4009 189.464 79.218 189.282C79.0351 189.099 78.9226 188.857 78.9 188.6V175.6C78.9226 175.342 79.0351 175.1 79.218 174.918C79.4009 174.735 79.6424 174.622 79.9 174.6C80.1652 174.6 80.4196 174.705 80.6071 174.893C80.7947 175.08 80.9 175.334 80.9 175.6V188.6C80.9 188.865 80.7947 189.119 80.6071 189.307C80.4196 189.494 80.1652 189.6 79.9 189.6Z",
        fill: "#FFFAE5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M128.8 111.301H116.7C116.565 111.317 116.428 111.302 116.299 111.257C116.17 111.213 116.054 111.14 115.957 111.043C115.861 110.947 115.788 110.83 115.743 110.702C115.699 110.573 115.684 110.436 115.7 110.301C115.7 110.036 115.805 109.781 115.993 109.594C116.18 109.406 116.435 109.301 116.7 109.301H128.8C129.065 109.301 129.32 109.406 129.507 109.594C129.695 109.781 129.8 110.036 129.8 110.301C129.816 110.436 129.801 110.573 129.757 110.702C129.712 110.83 129.639 110.947 129.543 111.043C129.446 111.14 129.33 111.213 129.201 111.257C129.072 111.302 128.935 111.317 128.8 111.301Z",
        fill: "#FFFAE5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M113.2 102.601C112.938 102.587 112.69 102.481 112.5 102.301C112.317 102.114 112.214 101.863 112.214 101.601C112.214 101.339 112.317 101.088 112.5 100.901L121 92.5008C121.193 92.3563 121.431 92.2862 121.671 92.3033C121.911 92.3204 122.137 92.4235 122.307 92.5937C122.477 92.7639 122.58 92.9898 122.597 93.2299C122.615 93.47 122.544 93.7082 122.4 93.9008L113.9 102.301C113.812 102.399 113.704 102.477 113.583 102.528C113.462 102.58 113.331 102.605 113.2 102.601Z",
        fill: "#FFFAE5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M104.5 100C104.235 100 103.98 99.8947 103.793 99.7072C103.605 99.5196 103.5 99.2653 103.5 99.0001V86.1C103.5 85.8348 103.605 85.5805 103.793 85.3929C103.98 85.2054 104.235 85.1 104.5 85.1C104.635 85.084 104.772 85.0988 104.901 85.1433C105.03 85.1879 105.146 85.2611 105.243 85.3574C105.339 85.4536 105.412 85.5705 105.457 85.6991C105.501 85.8278 105.516 85.9649 105.5 86.1V99.0001C105.516 99.1352 105.501 99.2723 105.457 99.401C105.412 99.5296 105.339 99.6465 105.243 99.7428C105.146 99.839 105.03 99.9122 104.901 99.9568C104.772 100.001 104.635 100.016 104.5 100Z",
        fill: "#FFFAE5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("clipPath", {
        id: "clip0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
        d: "M0 0.400391H190.2V221.9H0V0.400391Z",
        fill: "white"
    }))));
};
var $e73474a0ddb82bf4$export$2e2bcd8739ae039 = $e73474a0ddb82bf4$var$AccessLockSVG;

});


parcelRegister("iF2LN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d95e346697e38661$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $e9BTj = parcelRequire("e9BTj");

var $5YVyh = parcelRequire("5YVyh");

var $18aOe = parcelRequire("18aOe");
var $d95e346697e38661$export$2e2bcd8739ae039 = function(props) {
    var analytics = props.analytics;
    (0, $9nHZC.useEffect)(function() {
        analytics(function(duration) {
            return (0, $18aOe.profileCardRendered)("team", "spinner", {
                duration: duration
            });
        });
    }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5YVyh.CardWrapper), {
        "data-testid": "team-profilecard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5YVyh.CardHeader), {
        isLoading: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5YVyh.CardContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5YVyh.LoadingWrapper), {
        "data-testid": "team-profilecard-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $e9BTj.default), null))));
};

});




parcelRegister("hXXuy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ProfilecardInternal", function () { return $d146182e3fcfe6c1$export$64e0275ede8ab792; });
$parcel$export(module.exports, "default", function () { return $d146182e3fcfe6c1$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $fPPqr = parcelRequire("fPPqr");

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $eygjM = parcelRequire("eygjM");

var $kk7vA = parcelRequire("kk7vA");

var $inFLm = parcelRequire("inFLm");

var $fVy1l = parcelRequire("fVy1l");

var $dxhCu = parcelRequire("dxhCu");

var $e9BTj = parcelRequire("e9BTj");

var $jp7ng = parcelRequire("jp7ng");

var $iJFBU = parcelRequire("iJFBU");

var $7daq7 = parcelRequire("7daq7");

var $18aOe = parcelRequire("18aOe");

var $eGUrQ = parcelRequire("eGUrQ");

var $94uiW = parcelRequire("94uiW");
parcelRequire("2ib6V");
var $55gHa = parcelRequire("55gHa");

var $6SxXC = parcelRequire("6SxXC");

var $jNP7Q = parcelRequire("jNP7Q");
var $d146182e3fcfe6c1$var$GIVE_KUDOS_ACTION_ID = "give-kudos";
var $d146182e3fcfe6c1$var$useKudos = function useKudos(cloudId, userId, teamCentralBaseUrl, openKudosDrawer) {
    var kudosUrl = (0, $9nHZC.useMemo)(function() {
        var recipientId = userId ? "&recipientId=".concat(userId) : "";
        var cloudIdParam = cloudId ? "&cloudId=".concat(cloudId) : "";
        return "".concat(teamCentralBaseUrl || "", "/kudos/give?type=individual").concat(recipientId).concat(cloudIdParam);
    }, [
        cloudId,
        teamCentralBaseUrl,
        userId
    ]);
    var kudosButtonCallback = (0, $9nHZC.useCallback)(function() {
        if (openKudosDrawer) openKudosDrawer();
        else window.open(kudosUrl);
    }, [
        kudosUrl,
        openKudosDrawer
    ]);
    var kudosAction = (0, $9nHZC.useMemo)(function() {
        return {
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eygjM.default), (0, $iJFBU.default).giveKudosButton),
            id: $d146182e3fcfe6c1$var$GIVE_KUDOS_ACTION_ID,
            callback: kudosButtonCallback,
            link: kudosUrl
        };
    }, [
        kudosButtonCallback,
        kudosUrl
    ]);
    return {
        kudosAction: kudosAction,
        kudosButtonCallback: kudosButtonCallback,
        kudosUrl: kudosUrl
    };
};
var $d146182e3fcfe6c1$var$Wrapper = function Wrapper(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.CardWrapper), {
        "data-testid": "profilecard",
        role: "dialog",
        "aria-labelledby": "profilecard-name-label"
    }, props.children);
};
var $d146182e3fcfe6c1$export$64e0275ede8ab792 = function ProfilecardInternal(props) {
    var _useState = (0, $9nHZC.useState)((0, $94uiW.getPageTime)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 1), openTime = _useState2[0];
    var createAnalyticsEvent = props.createAnalyticsEvent;
    var fireAnalytics = (0, $9nHZC.useCallback)(function(payload) {
        if (createAnalyticsEvent) (0, $18aOe.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    var fireAnalyticsWithDuration = (0, $9nHZC.useCallback)(function(generator) {
        var elapsed = (0, $94uiW.getPageTime)() - openTime;
        var event = generator(elapsed);
        fireAnalytics(event);
    }, [
        fireAnalytics,
        openTime
    ]);
    var _useKudos = $d146182e3fcfe6c1$var$useKudos(props.cloudId, props.userId, props.teamCentralBaseUrl, props.openKudosDrawer), kudosAction = _useKudos.kudosAction;
    var _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, isCurrentUser = props.isCurrentUser, isKudosEnabled = props.isKudosEnabled, _props$status = props.status, status = _props$status === void 0 ? "active" : _props$status;
    var realActions = (0, $9nHZC.useMemo)(function() {
        if (isCurrentUser || !isKudosEnabled || status !== "active") return actions;
        return actions.concat([
            kudosAction
        ]);
    }, [
        actions,
        isCurrentUser,
        isKudosEnabled,
        kudosAction,
        status
    ]);
    var isLoading = props.isLoading, fullName = props.fullName, hasError = props.hasError;
    var canRender = !hasError && !isLoading && !!(fullName || status === "closed");
    (0, $9nHZC.useEffect)(function() {
        if (canRender) fireAnalyticsWithDuration(function(duration) {
            return (0, $18aOe.profileCardRendered)("user", "content", {
                duration: duration,
                numActions: realActions.length
            });
        });
    }, [
        canRender,
        fireAnalyticsWithDuration,
        realActions
    ]);
    if (hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($d146182e3fcfe6c1$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $55gHa.default), {
        reload: props.clientFetchProfile,
        errorType: props.errorType || null,
        fireAnalytics: fireAnalytics
    }));
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($d146182e3fcfe6c1$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($d146182e3fcfe6c1$var$LoadingView, {
        fireAnalyticsWithDuration: fireAnalyticsWithDuration
    }));
    if (!canRender) return null;
    var isDisabledUser = status === "inactive" || status === "closed";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($d146182e3fcfe6c1$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.CardContainer), {
        isDisabledUser: isDisabledUser,
        withoutElevation: props.withoutElevation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.ProfileImage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $inFLm.default), {
        size: "xlarge",
        src: status !== "closed" ? props.avatarUrl : undefined,
        borderColor: "var(--ds-shadow-overlay, ".concat((0, $jp7ng.N0), ")")
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.CardContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $jNP7Q.ProfileCardDetails), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        status: status,
        fireAnalyticsWithDuration: fireAnalyticsWithDuration
    })), realActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.ActionsFlexSpacer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($d146182e3fcfe6c1$var$Actions, {
        actions: realActions,
        fireAnalyticsWithDuration: fireAnalyticsWithDuration,
        isTriggeredUsingKeyboard: props.isTriggeredUsingKeyboard
    })))));
};
var $d146182e3fcfe6c1$var$Actions = function Actions(_ref) {
    var actions = _ref.actions, fireAnalyticsWithDuration = _ref.fireAnalyticsWithDuration, isTriggeredUsingKeyboard = _ref.isTriggeredUsingKeyboard;
    var onActionClick = (0, $9nHZC.useCallback)(function(action, args, event, index) {
        fireAnalyticsWithDuration(function(duration) {
            return (0, $18aOe.actionClicked)("user", {
                duration: duration,
                hasHref: !!action.link,
                hasOnClick: !!action.callback,
                index: index,
                actionId: action.id || "no-id-specified"
            });
        });
        if (action.callback && (0, $eGUrQ.isBasicClick)(event)) {
            event.preventDefault();
            action.callback.apply(action, [
                event
            ].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(args)));
        }
    }, [
        fireAnalyticsWithDuration
    ]);
    if (!actions || actions.length === 0) return null;
    var regularActions = actions.slice(0, (0, $6SxXC.ACTION_OVERFLOW_THRESHOLD));
    var overflowActions = actions.length > (0, $6SxXC.ACTION_OVERFLOW_THRESHOLD) ? actions.slice((0, $6SxXC.ACTION_OVERFLOW_THRESHOLD)) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.ActionButtonGroup), {
        "data-testid": "profilecard-actions"
    }, regularActions.map(function(action, index) {
        var isKudos = action.id === $d146182e3fcfe6c1$var$GIVE_KUDOS_ACTION_ID;
        var button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dxhCu.default), {
            isInset: true,
            key: "profile-card-action-focus-ring_".concat(action.id || index)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fVy1l.default), {
            appearance: "default",
            key: action.id || index,
            onClick: function onClick(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                return onActionClick(action, args, event, index);
            },
            href: action.link,
            autoFocus: index === 0 && isTriggeredUsingKeyboard
        }, action.label, isKudos && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.AnimationWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.KudosBlobAnimation), null))));
        if (isKudos) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.AnimatedKudosButton), {
            key: "profile-card-action-kudos_".concat(action.id || index)
        }, button);
        return button;
    }), overflowActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6SxXC.OverflowProfileCardButtons), {
        actions: overflowActions,
        fireAnalyticsWithDuration: fireAnalyticsWithDuration,
        onItemClick: function onItemClick(action, args, event, index) {
            return onActionClick(action, args, event, index + (0, $6SxXC.ACTION_OVERFLOW_THRESHOLD));
        }
    }));
};
var $d146182e3fcfe6c1$var$LoadingView = function LoadingView(_ref2) {
    var fireAnalyticsWithDuration = _ref2.fireAnalyticsWithDuration;
    (0, $9nHZC.useEffect)(function() {
        fireAnalyticsWithDuration(function(duration) {
            return (0, $18aOe.profileCardRendered)("user", "spinner", {
                duration: duration
            });
        });
    }, [
        fireAnalyticsWithDuration
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.SpinnerContainer), {
        "data-testid": "profilecard-spinner-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $e9BTj.default), null));
};
var $d146182e3fcfe6c1$export$2e2bcd8739ae039 = (0, $kk7vA.default)()($d146182e3fcfe6c1$export$64e0275ede8ab792);

});
parcelRegister("fVy1l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b98691b308892595$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9q1kH = parcelRequire("9q1kH");

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $5LVXk = parcelRequire("5LVXk");

var $dPP5B = parcelRequire("dPP5B");

var $k8LtO = parcelRequire("k8LtO");

var $8DBz6 = parcelRequire("8DBz6");

var $7vNGM = parcelRequire("7vNGM");
var $b98691b308892595$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isSelected",
    "shouldFitContainer",
    "spacing",
    "isLoading",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseDown",
    "onMouseUp",
    "onFocus",
    "onBlur",
    "theme"
];
function $b98691b308892595$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b98691b308892595$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b98691b308892595$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b98691b308892595$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b98691b308892595$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return "disabled";
    if (isSelected && isFocus) return "focusSelected";
    if (isSelected) return "selected";
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return "active";
    if (!isLoading && isHover) return "hover";
    if (isFocus) return "focus";
    return "default";
}
var $b98691b308892595$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var $b98691b308892595$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $7vNGM.defaultThemeFn) : _ref2$theme, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref2, $b98691b308892595$var$_excluded);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $b98691b308892595$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $9nHZC.useState)($b98691b308892595$var$initial), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $b98691b308892595$var$_objectSpread($b98691b308892595$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $b98691b308892595$var$_objectSpread($b98691b308892595$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $b98691b308892595$var$_objectSpread($b98691b308892595$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $b98691b308892595$var$_objectSpread($b98691b308892595$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $b98691b308892595$var$_objectSpread($b98691b308892595$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $b98691b308892595$var$_objectSpread($b98691b308892595$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7vNGM.default).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5LVXk.default).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7vNGM.default).Consumer, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            mode: mode,
            state: $b98691b308892595$var$getInteractionState($b98691b308892595$var$_objectSpread($b98691b308892595$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $k8LtO.default)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dPP5B.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $8DBz6.default), restProps) : null,
                "aria-disabled": isLoading || restProps["aria-disabled"],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $7vNGM.getSpecifiers)(buttonStyles)
            }));
        });
    }));
}));
// Tools including enzyme rely on components having a display name
$b98691b308892595$var$CustomThemeButton.displayName = "CustomThemeButton";
var $b98691b308892595$export$2e2bcd8739ae039 = $b98691b308892595$var$CustomThemeButton;

});
parcelRegister("7vNGM", function(module, exports) {

$parcel$export(module.exports, "getSpecifiers", function () { return $016952772413c48f$export$643db0b8d8778e; });
$parcel$export(module.exports, "defaultThemeFn", function () { return $016952772413c48f$export$437a7f77d13d7916; });
$parcel$export(module.exports, "default", function () { return $016952772413c48f$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $dHFxE = parcelRequire("dHFxE");

var $cbfok = parcelRequire("cbfok");
function $016952772413c48f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $016952772413c48f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $016952772413c48f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $016952772413c48f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $016952772413c48f$var$stateToSelectorMap = {
    focus: "&:focus",
    focusSelected: "&:focus",
    hover: "&:hover",
    active: "&:active",
    disabled: "&[disabled]"
};
function $016952772413c48f$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? "light" : _ref$mode, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $cbfok.getCss)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = "none";
    // Pulling relevant styles up to the top level
    var selector = $016952772413c48f$var$stateToSelectorMap[state];
    if (selector) result = $016952772413c48f$var$_objectSpread($016952772413c48f$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $016952772413c48f$var$_objectSpread($016952772413c48f$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === "&::-moz-focus-inner") return;
        // Not using .startsWith for ie11
        if (key.indexOf("&") === 0) delete result[key];
    });
    return result;
}
function $016952772413c48f$export$643db0b8d8778e(styles) {
    return {
        "&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]": styles
    };
}
function $016952772413c48f$export$437a7f77d13d7916(current, values) {
    return current(values);
}
var $016952772413c48f$var$Theme = (0, $dHFxE.createTheme)(function(themeProps) {
    return {
        buttonStyles: $016952772413c48f$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$016952772413c48f$export$2e2bcd8739ae039 = $016952772413c48f$var$Theme;

});


parcelRegister("6SxXC", function(module, exports) {

$parcel$export(module.exports, "ACTION_OVERFLOW_THRESHOLD", function () { return $502221109b914f32$export$3e2419a7546ad45e; });
$parcel$export(module.exports, "OverflowProfileCardButtons", function () { return $502221109b914f32$export$9d9b53d23c0df7a1; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $b7ZcK = parcelRequire("b7ZcK");

var $fVy1l = parcelRequire("fVy1l");

var $g69Bq = parcelRequire("g69Bq");
var $Vt2jo = parcelRequire("Vt2jo");
var $liugG = parcelRequire("liugG");

var $kb4D4 = parcelRequire("kb4D4");

var $iJFBU = parcelRequire("iJFBU");

var $7daq7 = parcelRequire("7daq7");

var $18aOe = parcelRequire("18aOe");
var $502221109b914f32$var$_excluded = [
    "triggerRef",
    "isSelected",
    "testId"
];
var $502221109b914f32$export$3e2419a7546ad45e = 2;
var $502221109b914f32$export$9d9b53d23c0df7a1 = function OverflowProfileCardButtons(props) {
    var intl = (0, $b7ZcK.default)();
    var _useState = (0, $9nHZC.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), setOpen = _useState2[1];
    var actions = props.actions, onItemClick = props.onItemClick, fireAnalyticsWithDuration = props.fireAnalyticsWithDuration;
    var numActions = actions.length + $502221109b914f32$export$3e2419a7546ad45e;
    var onOpenChange = (0, $9nHZC.useCallback)(function(_ref) {
        var nextOpen = _ref.isOpen;
        setOpen(function(prevOpen) {
            if (nextOpen && !prevOpen) fireAnalyticsWithDuration(function(duration) {
                return (0, $18aOe.moreActionsClicked)("user", {
                    duration: duration,
                    numActions: numActions
                });
            });
            return nextOpen;
        });
    }, [
        numActions,
        fireAnalyticsWithDuration
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.OverflowActionButtonsWrapper), {
        "data-testid": "profilecard-actions-overflow"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $g69Bq.default), {
        onOpenChange: onOpenChange,
        placement: "bottom-end",
        trigger: function trigger(_ref2) {
            var triggerRef = _ref2.triggerRef, isSelected = _ref2.isSelected, testId = _ref2.testId, providedProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref2, $502221109b914f32$var$_excluded);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fVy1l.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                type: "button"
            }, providedProps, {
                ref: triggerRef,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kb4D4))), {
                    label: intl.formatMessage((0, $iJFBU.default).profileCardMoreIconLabel)
                })
            }));
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $liugG.default), null, actions.map(function(action, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $Vt2jo.default), {
            key: action.id,
            onClick: function onClick(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                onItemClick(action, args, event, index);
            },
            href: action.link
        }, action.label);
    }))));
};

});
parcelRegister("g69Bq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb84a7bef8d2631d$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $1FiMp = parcelRequire("1FiMp");

var $hndKT = parcelRequire("hndKT");

var $70mT6 = parcelRequire("70mT6");

var $3aF04 = parcelRequire("3aF04");

var $8p2GL = parcelRequire("8p2GL");

var $84iaW = parcelRequire("84iaW");

var $eIHpi = parcelRequire("eIHpi");

var $dWDB7 = parcelRequire("dWDB7");

var $93cMI = parcelRequire("93cMI");

var $aP6k3 = parcelRequire("aP6k3");

var $1RcCv = parcelRequire("1RcCv");

var $h21tr = parcelRequire("h21tr");

var $b12tK = parcelRequire("b12tK");

var $dMUnM = parcelRequire("dMUnM");

var $9UfnV = parcelRequire("9UfnV");
var $bb84a7bef8d2631d$var$_excluded = [
    "ref",
    "aria-controls",
    "aria-expanded",
    "aria-haspopup"
];
function $bb84a7bef8d2631d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bb84a7bef8d2631d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bb84a7bef8d2631d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bb84a7bef8d2631d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bb84a7bef8d2631d$var$gridSize = (0, $aP6k3.gridSize)();
var $bb84a7bef8d2631d$var$MAX_HEIGHT = "calc(100vh - ".concat($bb84a7bef8d2631d$var$gridSize * 2, "px)");
var $bb84a7bef8d2631d$var$opposites = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left",
    start: "end",
    auto: "auto",
    end: "start"
};
var $bb84a7bef8d2631d$var$getFallbackPlacements = function getFallbackPlacements(placement) {
    var placementPieces = placement.split("-");
    var mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        "top",
        "bottom"
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        "start",
        "end"
    ].includes(placementPieces[1])) {
        var crossAxis = placementPieces[1];
        return [
            "".concat(mainAxis),
            "".concat(mainAxis, "-").concat($bb84a7bef8d2631d$var$opposites[crossAxis]),
            "".concat($bb84a7bef8d2631d$var$opposites[mainAxis], "-").concat(crossAxis),
            "".concat($bb84a7bef8d2631d$var$opposites[mainAxis]),
            "".concat($bb84a7bef8d2631d$var$opposites[mainAxis], "-").concat($bb84a7bef8d2631d$var$opposites[crossAxis]),
            "auto"
        ];
    } else return [
        "".concat(mainAxis, "-start"),
        "".concat(mainAxis, "-end"),
        "".concat($bb84a7bef8d2631d$var$opposites[mainAxis]),
        "".concat($bb84a7bef8d2631d$var$opposites[mainAxis], "-start"),
        "".concat($bb84a7bef8d2631d$var$opposites[mainAxis], "-end"),
        "auto"
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ var $bb84a7bef8d2631d$var$DropdownMenu = function DropdownMenu(_ref) {
    var _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, _ref$defaultOpen = _ref.defaultOpen, defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isOpen = _ref.isOpen, _ref$onOpenChange = _ref.onOpenChange, onOpenChange = _ref$onOpenChange === void 0 ? (0, $8p2GL.default) : _ref$onOpenChange, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, spacing = _ref.spacing, statusLabel = _ref.statusLabel, testId = _ref.testId, _trigger = _ref.trigger, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? (0, $aP6k3.layers).modal() : _ref$zIndex, label = _ref.label;
    var _useControlledState = (0, $84iaW.default)(isOpen, function() {
        return defaultOpen;
    }), _useControlledState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useControlledState, 2), isLocalOpen = _useControlledState2[0], setLocalIsOpen = _useControlledState2[1];
    var _useState = (0, $9nHZC.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), isTriggeredUsingKeyboard = _useState2[0], setTriggeredUsingKeyboard = _useState2[1];
    var id = (0, $9UfnV.default)();
    var itemRef = (0, $dMUnM.default)();
    var fallbackPlacements = (0, $9nHZC.useMemo)(function() {
        return $bb84a7bef8d2631d$var$getFallbackPlacements(placement);
    }, [
        placement
    ]);
    var handleTriggerClicked = (0, $9nHZC.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    function(event) {
        var newValue = !isLocalOpen;
        var clientX = event.clientX, clientY = event.clientY, type = event.type, detail = event.detail;
        if (type === "keydown") setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            var _itemRef$current;
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef === null || itemRef === void 0 || (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || _itemRef$current.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    var handleOnClose = (0, $9nHZC.useCallback)(function(event) {
        var _event$target, _event$target$closest;
        if (event.key !== "Escape" && event.key !== "Tab" && (_event$target = event.target) !== null && _event$target !== void 0 && (_event$target$closest = _event$target.closest) !== null && _event$target$closest !== void 0 && _event$target$closest.call(_event$target, "[id^=".concat((0, $9UfnV.PREFIX), "] [aria-haspopup]"))) // Check if it is within dropdown and it is a trigger button
        // if it is a nested dropdown, clicking trigger won't close the dropdown
        // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
        return;
        if (event.key === "Tab" && event.shiftKey || event.key === "Escape") requestAnimationFrame(function() {
            var _itemRef$current2;
            (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 || _itemRef$current2.focus();
        });
        var newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        onOpenChange,
        setLocalIsOpen,
        itemRef
    ]);
    var _useFocus = (0, $eIHpi.default)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $9nHZC.useEffect)(function() {
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $8p2GL.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $8p2GL.default;
        return (0, $1FiMp.bind)(window, {
            type: "keydown",
            listener: function openOnKeyDown(e) {
                var isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest("[id^=".concat((0, $9UfnV.PREFIX), "] [aria-haspopup]"));
                if (e.key === (0, $70mT6.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $70mT6.KEY_SPACE) || e.key === (0, $70mT6.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $70mT6.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ var conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer
    } : {
        shouldRenderToParent: shouldRenderToParent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $b12tK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $93cMI.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && "".concat(testId, "--content"),
        shouldUseCaptureOnOutsideClick: true
    }, conditionalProps, {
        shouldDisableFocusLock: true,
        trigger: function trigger(_ref2) {
            var ref = _ref2.ref, ariaControls = _ref2["aria-controls"], ariaExpanded = _ref2["aria-expanded"], ariaHasPopup = _ref2["aria-haspopup"], rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref2, $bb84a7bef8d2631d$var$_excluded);
            if (typeof _trigger === "function") return _trigger($bb84a7bef8d2631d$var$_objectSpread($bb84a7bef8d2631d$var$_objectSpread($bb84a7bef8d2631d$var$_objectSpread({
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup
            }, rest), bindFocus), {}, {
                triggerRef: (0, $3aF04.default)([
                    ref,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger")
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $hndKT.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, bindFocus, {
                ref: (0, $3aF04.default)([
                    ref,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($dWDB7))),
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger"),
                "aria-label": label
            }), _trigger);
        },
        content: function content(_ref3) {
            var setInitialFocusRef = _ref3.setInitialFocusRef, update = _ref3.update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $1RcCv.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $h21tr.default), {
                spacing: spacing,
                maxHeight: $bb84a7bef8d2631d$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && "".concat(testId, "--menu-wrapper")
            }, children));
        }
    })));
};
var $bb84a7bef8d2631d$export$2e2bcd8739ae039 = $bb84a7bef8d2631d$var$DropdownMenu;

});
parcelRegister("hndKT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca5f412d20a29967$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $dEQSq = parcelRequire("dEQSq");

var $b3pNY = parcelRequire("b3pNY");

var $5HmWt = parcelRequire("5HmWt");
var $ca5f412d20a29967$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type",
    "UNSAFE_iconAfter_size",
    "UNSAFE_iconBefore_size"
], $ca5f412d20a29967$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $ca5f412d20a29967$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isLoading = _ref.isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, UNSAFE_iconAfter_size = _ref.UNSAFE_iconAfter_size, UNSAFE_iconBefore_size = _ref.UNSAFE_iconBefore_size, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $ca5f412d20a29967$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(unsafeRest, $ca5f412d20a29967$var$_excluded2);
    var rest = (0, $dEQSq.getBooleanFF)("platform.design-system-team.remove-unsafe-spread-from-new-button_a2xhw") ? saferRest : unsafeRest;
    var baseProps = (0, $5HmWt.default)({
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: "button",
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId,
        UNSAFE_iconAfter_size: UNSAFE_iconAfter_size,
        UNSAFE_iconBefore_size: UNSAFE_iconBefore_size
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $b3pNY.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
        "aria-label": baseProps["aria-label"],
        "aria-labelledby": baseProps["aria-labelledby"],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "Button"
    }), baseProps.children);
}));
$ca5f412d20a29967$var$Button.displayName = "Button";
var $ca5f412d20a29967$export$2e2bcd8739ae039 = $ca5f412d20a29967$var$Button;

});
parcelRegister("b3pNY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80c3fde14cd0d3a4$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $ClKoH = parcelRequire("ClKoH");

var $8p2GL = parcelRequire("8p2GL");

var $5fUc4 = parcelRequire("5fUc4");

var $4aGLX = parcelRequire("4aGLX");

var $eDOWt = parcelRequire("eDOWt");

var $6leay = parcelRequire("6leay");
var $80c3fde14cd0d3a4$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $80c3fde14cd0d3a4$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $80c3fde14cd0d3a4$var$focusRingStyles = (0, $avKww.css)({
    "&:focus, &:focus-visible": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $4aGLX.borderColorMap)["color.border.focused"],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $4aGLX.positiveSpaceMap)["space.025"],
        outlineStyle: "solid",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $4aGLX.borderWidthMap)["border.width.outline"]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $80c3fde14cd0d3a4$var$baseStyles = (0, $avKww.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});
var $80c3fde14cd0d3a4$var$enabledStyles = (0, $avKww.css)({
    cursor: "pointer"
});
var $80c3fde14cd0d3a4$var$disabledStyles = (0, $avKww.css)({
    cursor: "not-allowed"
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $80c3fde14cd0d3a4$var$Pressable = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $8p2GL.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $80c3fde14cd0d3a4$var$_excluded);
    var interactionContext = (0, $9nHZC.useContext)((0, $5fUc4.default));
    var handleClick = (0, $9nHZC.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $ClKoH.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "8.2.1",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(htmlAttributes, $80c3fde14cd0d3a4$var$_excluded2);
    var resolvedStyles = (0, $eDOWt.parseXcss)(xcss);
    var node = // eslint-disable-next-line @atlaskit/design-system/no-html-button
    (0, $avKww.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $80c3fde14cd0d3a4$var$baseStyles,
            $80c3fde14cd0d3a4$var$focusRingStyles,
            isDisabled ? $80c3fde14cd0d3a4$var$disabledStyles : $80c3fde14cd0d3a4$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $4aGLX.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $4aGLX.isSurfaceColorToken)(backgroundColor) && (0, $4aGLX.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $4aGLX.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $4aGLX.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $4aGLX.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $4aGLX.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $4aGLX.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $4aGLX.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $4aGLX.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $avKww.jsx)((0, $6leay.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $80c3fde14cd0d3a4$export$2e2bcd8739ae039 = $80c3fde14cd0d3a4$var$Pressable;

});
parcelRegister("4aGLX", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $3099464cc84818bf$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $3099464cc84818bf$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $3099464cc84818bf$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $3099464cc84818bf$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $3099464cc84818bf$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $3099464cc84818bf$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $3099464cc84818bf$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $3099464cc84818bf$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $3099464cc84818bf$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $3099464cc84818bf$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $3099464cc84818bf$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $3099464cc84818bf$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $3099464cc84818bf$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $3099464cc84818bf$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $3099464cc84818bf$export$5e65a44e5b6ecadb; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $xbX1J = parcelRequire("xbX1J");
function $3099464cc84818bf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3099464cc84818bf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3099464cc84818bf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3099464cc84818bf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3099464cc84818bf$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $3099464cc84818bf$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $3099464cc84818bf$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $3099464cc84818bf$export$632685d741f3dbbf = $3099464cc84818bf$var$_objectSpread($3099464cc84818bf$var$_objectSpread({}, $3099464cc84818bf$export$958d0ae7f2977ae4), $3099464cc84818bf$export$d2dc61f58390201c);
var $3099464cc84818bf$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $3099464cc84818bf$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $3099464cc84818bf$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $3099464cc84818bf$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $3099464cc84818bf$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $3099464cc84818bf$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $3099464cc84818bf$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $3099464cc84818bf$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $3099464cc84818bf$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $3099464cc84818bf$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $3099464cc84818bf$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $3099464cc84818bf$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $3099464cc84818bf$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $3099464cc84818bf$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $3099464cc84818bf$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $3099464cc84818bf$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $avKww.css)((0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $3099464cc84818bf$export$e615f061ca585a6c = $3099464cc84818bf$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $3099464cc84818bf$var$getSerializedStylesMap(spacingProperty, $3099464cc84818bf$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $3099464cc84818bf$export$bf46c3f9eeafc71f = $3099464cc84818bf$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $3099464cc84818bf$var$getSerializedStylesMap(spacingProperty, $3099464cc84818bf$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $3099464cc84818bf$export$e7af83bafe7f9e63 = $3099464cc84818bf$var$getSerializedStylesMap("backgroundColor", $3099464cc84818bf$export$d1d79bf68ac056bd);
var $3099464cc84818bf$export$3a1bcba60b23d7f0 = $3099464cc84818bf$var$getSerializedStylesMap("color", $3099464cc84818bf$export$8473307aa00d6ea1);
var $3099464cc84818bf$export$45f3f4fe16f9f7d5 = $3099464cc84818bf$var$getSerializedStylesMap("fontWeight", $3099464cc84818bf$export$303e322c6b1ed114);
var $3099464cc84818bf$export$68cc305da27dbaa4 = $3099464cc84818bf$var$getSerializedStylesMap("fontFamily", $3099464cc84818bf$export$3c7e9587132614b4);
var $3099464cc84818bf$export$128f10c238242f83 = $3099464cc84818bf$var$getSerializedStylesMap("font", $3099464cc84818bf$export$6cc560b4dedf3816);
var $3099464cc84818bf$export$ff257d957d48c421 = $3099464cc84818bf$var$getSerializedStylesMap((0, $xbX1J.CURRENT_SURFACE_CSS_VAR), $3099464cc84818bf$export$41a358c9c2356760);
var $3099464cc84818bf$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $3099464cc84818bf$export$41a358c9c2356760[color] !== undefined;
};

});

parcelRegister("eDOWt", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $aa8c3941eee81a38$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $aa8c3941eee81a38$export$f6c783d06584602c; });

var $b4Ivn = parcelRequire("b4Ivn");

var $kFnE9 = parcelRequire("kFnE9");

var $9q1kH = parcelRequire("9q1kH");

var $340K4 = parcelRequire("340K4");

var $avKww = parcelRequire("avKww");

var $4aGLX = parcelRequire("4aGLX");

var $8ovux = parcelRequire("8ovux");
function $aa8c3941eee81a38$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $aa8c3941eee81a38$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $aa8c3941eee81a38$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $aa8c3941eee81a38$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $aa8c3941eee81a38$var$_arrayLikeToArray(o, minLen);
}
function $aa8c3941eee81a38$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $aa8c3941eee81a38$export$9a199fbafee0014e = {
    backgroundColor: (0, $4aGLX.backgroundColorMap),
    blockSize: (0, $4aGLX.dimensionMap),
    borderBlockColor: (0, $4aGLX.borderColorMap),
    borderBlockEndColor: (0, $4aGLX.borderColorMap),
    borderBlockEndWidth: (0, $4aGLX.borderWidthMap),
    borderBlockStartColor: (0, $4aGLX.borderColorMap),
    borderBlockStartWidth: (0, $4aGLX.borderWidthMap),
    borderBlockWidth: (0, $4aGLX.borderWidthMap),
    borderBottomColor: (0, $4aGLX.borderColorMap),
    borderBottomLeftRadius: (0, $4aGLX.borderRadiusMap),
    borderBottomRightRadius: (0, $4aGLX.borderRadiusMap),
    borderBottomWidth: (0, $4aGLX.borderWidthMap),
    borderColor: (0, $4aGLX.borderColorMap),
    borderEndEndRadius: (0, $4aGLX.borderRadiusMap),
    borderEndStartRadius: (0, $4aGLX.borderRadiusMap),
    borderInlineColor: (0, $4aGLX.borderColorMap),
    borderInlineEndColor: (0, $4aGLX.borderColorMap),
    borderInlineEndWidth: (0, $4aGLX.borderWidthMap),
    borderInlineStartColor: (0, $4aGLX.borderColorMap),
    borderInlineStartWidth: (0, $4aGLX.borderWidthMap),
    borderInlineWidth: (0, $4aGLX.borderWidthMap),
    borderLeftColor: (0, $4aGLX.borderColorMap),
    borderLeftWidth: (0, $4aGLX.borderWidthMap),
    borderRadius: (0, $4aGLX.borderRadiusMap),
    borderRightColor: (0, $4aGLX.borderColorMap),
    borderRightWidth: (0, $4aGLX.borderWidthMap),
    borderStartEndRadius: (0, $4aGLX.borderRadiusMap),
    borderStartStartRadius: (0, $4aGLX.borderRadiusMap),
    borderTopColor: (0, $4aGLX.borderColorMap),
    borderTopLeftRadius: (0, $4aGLX.borderRadiusMap),
    borderTopRightRadius: (0, $4aGLX.borderRadiusMap),
    borderTopWidth: (0, $4aGLX.borderWidthMap),
    borderWidth: (0, $4aGLX.borderWidthMap),
    bottom: (0, $4aGLX.allSpaceMap),
    boxShadow: (0, $4aGLX.shadowMap),
    color: (0, $4aGLX.textColorMap),
    columnGap: (0, $4aGLX.positiveSpaceMap),
    gap: (0, $4aGLX.positiveSpaceMap),
    height: (0, $4aGLX.dimensionMap),
    inlineSize: (0, $4aGLX.dimensionMap),
    inset: (0, $4aGLX.allSpaceMap),
    insetBlock: (0, $4aGLX.allSpaceMap),
    insetBlockEnd: (0, $4aGLX.allSpaceMap),
    insetBlockStart: (0, $4aGLX.allSpaceMap),
    insetInline: (0, $4aGLX.allSpaceMap),
    insetInlineEnd: (0, $4aGLX.allSpaceMap),
    insetInlineStart: (0, $4aGLX.allSpaceMap),
    left: (0, $4aGLX.allSpaceMap),
    margin: (0, $4aGLX.allSpaceMap),
    marginBlock: (0, $4aGLX.allSpaceMap),
    marginBlockEnd: (0, $4aGLX.allSpaceMap),
    marginBlockStart: (0, $4aGLX.allSpaceMap),
    marginBottom: (0, $4aGLX.allSpaceMap),
    marginInline: (0, $4aGLX.allSpaceMap),
    marginInlineEnd: (0, $4aGLX.allSpaceMap),
    marginInlineStart: (0, $4aGLX.allSpaceMap),
    marginLeft: (0, $4aGLX.allSpaceMap),
    marginRight: (0, $4aGLX.allSpaceMap),
    marginTop: (0, $4aGLX.allSpaceMap),
    maxBlockSize: (0, $4aGLX.dimensionMap),
    maxHeight: (0, $4aGLX.dimensionMap),
    maxInlineSize: (0, $4aGLX.dimensionMap),
    maxWidth: (0, $4aGLX.dimensionMap),
    minBlockSize: (0, $4aGLX.dimensionMap),
    minHeight: (0, $4aGLX.dimensionMap),
    minInlineSize: (0, $4aGLX.dimensionMap),
    minWidth: (0, $4aGLX.dimensionMap),
    opacity: (0, $4aGLX.opacityMap),
    outlineColor: (0, $4aGLX.borderColorMap),
    outlineOffset: (0, $4aGLX.positiveSpaceMap),
    outlineWidth: (0, $4aGLX.borderWidthMap),
    padding: (0, $4aGLX.positiveSpaceMap),
    paddingBlock: (0, $4aGLX.positiveSpaceMap),
    paddingBlockEnd: (0, $4aGLX.positiveSpaceMap),
    paddingBlockStart: (0, $4aGLX.positiveSpaceMap),
    paddingBottom: (0, $4aGLX.positiveSpaceMap),
    paddingInline: (0, $4aGLX.positiveSpaceMap),
    paddingInlineEnd: (0, $4aGLX.positiveSpaceMap),
    paddingInlineStart: (0, $4aGLX.positiveSpaceMap),
    paddingLeft: (0, $4aGLX.positiveSpaceMap),
    paddingRight: (0, $4aGLX.positiveSpaceMap),
    paddingTop: (0, $4aGLX.positiveSpaceMap),
    right: (0, $4aGLX.allSpaceMap),
    rowGap: (0, $4aGLX.positiveSpaceMap),
    top: (0, $4aGLX.allSpaceMap),
    width: (0, $4aGLX.dimensionMap),
    zIndex: (0, $4aGLX.layerMap)
};
var $aa8c3941eee81a38$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $aa8c3941eee81a38$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $8ovux === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux.env) === "object" && false;
};
var $aa8c3941eee81a38$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $aa8c3941eee81a38$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $aa8c3941eee81a38$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(value) === "object" && $aa8c3941eee81a38$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($aa8c3941eee81a38$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($aa8c3941eee81a38$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $aa8c3941eee81a38$export$9a199fbafee0014e)) return;
        var tokenValue = $aa8c3941eee81a38$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $aa8c3941eee81a38$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $aa8c3941eee81a38$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, $aa8c3941eee81a38$var$uniqueSymbol, (0, $avKww.css)(transformedStyles));
};
var $aa8c3941eee81a38$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $aa8c3941eee81a38$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$aa8c3941eee81a38$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $aa8c3941eee81a38$export$f6c783d06584602c(style) {
    return $aa8c3941eee81a38$var$baseXcss(style);
}

});

parcelRegister("6leay", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $49dfb1f4788bf588$export$1ca2a26fecb070ae; });

var $9nHZC = parcelRequire("9nHZC");
var $49dfb1f4788bf588$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $9nHZC.createContext)("elevation.surface");
var $49dfb1f4788bf588$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $9nHZC.useContext)($49dfb1f4788bf588$export$1ca2a26fecb070ae);
};
$49dfb1f4788bf588$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("5HmWt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4262c3bf3f2d64db$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $kgAch = parcelRequire("kgAch");

var $5asZP = parcelRequire("5asZP");

var $9XLA4 = parcelRequire("9XLA4");
/**
 * __Use default button base__
 *
 * A React hook that accepts a set of default Button props,
 * and processes them to return consistent base props for usage
 * across Button and LinkButton variants.
 *
 * @private
 */ var $4262c3bf3f2d64db$var$useDefaultButton = function useDefaultButton(_ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, autoFocus = _ref.autoFocus, buttonType = _ref.buttonType, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, ref = _ref.ref, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, UNSAFE_iconAfter_size = _ref.UNSAFE_iconAfter_size, UNSAFE_iconBefore_size = _ref.UNSAFE_iconBefore_size;
    var baseProps = (0, $9XLA4.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kgAch.default), {
            type: "icon",
            position: "before",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5asZP.default), {
            icon: iconBefore,
            size: UNSAFE_iconBefore_size
        })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kgAch.default), {
            isLoading: isLoading
        }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kgAch.default), {
            type: "icon",
            position: "after",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5asZP.default), {
            icon: iconAfter,
            size: UNSAFE_iconAfter_size
        }))),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter)
    });
    return baseProps;
};
var $4262c3bf3f2d64db$export$2e2bcd8739ae039 = $4262c3bf3f2d64db$var$useDefaultButton;

});
parcelRegister("kgAch", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec116141aca1dfc1$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9nHZC = parcelRequire("9nHZC");

var $6Vblr = parcelRequire("6Vblr");
var $eDOWt = parcelRequire("eDOWt");
var $ec116141aca1dfc1$var$textStyles = (0, $eDOWt.xcss)({
    // content can grow and shrink
    flexGrow: 1,
    flexShrink: 1,
    // ellipsis for overflow text
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $ec116141aca1dfc1$var$iconStyles = (0, $eDOWt.xcss)({
    display: "flex",
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: "center",
    fontSize: 0,
    lineHeight: 0,
    userSelect: "none"
});
var $ec116141aca1dfc1$var$commonStyles = (0, $eDOWt.xcss)({
    transition: "opacity 0.3s"
});
var $ec116141aca1dfc1$var$fadeStyles = (0, $eDOWt.xcss)({
    opacity: 0
});
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform.design-system-team.enable-new-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $ec116141aca1dfc1$var$beforeIconStyles = (0, $eDOWt.xcss)({
    // @ts-ignore
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    // @ts-ignore
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)"
});
var $ec116141aca1dfc1$var$afterIconStyles = (0, $eDOWt.xcss)({
    // @ts-ignore
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    // @ts-ignore
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)"
});
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $ec116141aca1dfc1$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? "text" : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6Vblr.default), {
        as: "span",
        xcss: [
            $ec116141aca1dfc1$var$commonStyles
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(type === "text" ? [
            $ec116141aca1dfc1$var$textStyles
        ] : [
            $ec116141aca1dfc1$var$iconStyles
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(isLoading ? [
            $ec116141aca1dfc1$var$fadeStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(position === "before" ? [
            $ec116141aca1dfc1$var$beforeIconStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(position === "after" ? [
            $ec116141aca1dfc1$var$afterIconStyles
        ] : []))
    }, children);
};
var $ec116141aca1dfc1$export$2e2bcd8739ae039 = $ec116141aca1dfc1$var$Content;

});
parcelRegister("6Vblr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50a0ddc95f8e2fd1$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $4aGLX = parcelRequire("4aGLX");

var $eDOWt = parcelRequire("eDOWt");

var $6leay = parcelRequire("6leay");
var $50a0ddc95f8e2fd1$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $50a0ddc95f8e2fd1$var$_excluded2 = [
    "className"
];
var $50a0ddc95f8e2fd1$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $50a0ddc95f8e2fd1$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(htmlAttributes, $50a0ddc95f8e2fd1$var$_excluded2);
    var resolvedStyles = (0, $eDOWt.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $avKww.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $50a0ddc95f8e2fd1$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $4aGLX.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $4aGLX.isSurfaceColorToken)(backgroundColor) && (0, $4aGLX.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $4aGLX.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $4aGLX.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $4aGLX.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $4aGLX.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $4aGLX.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $4aGLX.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $4aGLX.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $avKww.jsx)((0, $6leay.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $50a0ddc95f8e2fd1$export$2e2bcd8739ae039 = $50a0ddc95f8e2fd1$export$e71c4d32a2263218;
var $50a0ddc95f8e2fd1$var$baseStyles = (0, $avKww.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});


parcelRegister("5asZP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c3460ff102300ea$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $dEQSq = parcelRequire("dEQSq");
function $3c3460ff102300ea$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === "function" // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $3c3460ff102300ea$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon, size = _ref.size;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, (0, $dEQSq.getBooleanFF)("platform.design-system-team.button-render-prop-fix_lyo55") && $3c3460ff102300ea$var$isIconRenderProp(Icon) ? Icon({
        label: "",
        size: size,
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Icon, {
        label: "",
        size: size,
        color: "currentColor"
    }));
};
var $3c3460ff102300ea$export$2e2bcd8739ae039 = $3c3460ff102300ea$var$IconRenderer;

});

parcelRegister("9XLA4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $740e884ae163b767$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $4ul5V = parcelRequire("4ul5V");

var $3aF04 = parcelRequire("3aF04");

var $grYZC = parcelRequire("grYZC");

var $dEQSq = parcelRequire("dEQSq");

var $6Vblr = parcelRequire("6Vblr");
var $eDOWt = parcelRequire("eDOWt");

var $jp7ng = parcelRequire("jp7ng");

var $7S7GL = parcelRequire("7S7GL");

var $hHlXd = parcelRequire("hHlXd");

var $huBSv = parcelRequire("huBSv");

var $jCDbx = parcelRequire("jCDbx");

var $hZkkx = parcelRequire("hZkkx");
function $740e884ae163b767$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $740e884ae163b767$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $740e884ae163b767$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $740e884ae163b767$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $740e884ae163b767$var$buttonStyles = (0, $eDOWt.xcss)({
    display: "inline-flex",
    boxSizing: "border-box",
    width: "auto",
    maxWidth: "100%",
    position: "relative",
    alignItems: "baseline",
    justifyContent: "center",
    columnGap: "space.050",
    borderRadius: "border.radius.100",
    borderWidth: "border.width.0",
    flexShrink: 0,
    height: "".concat(32 / 14, "em"),
    paddingInlineEnd: "space.150",
    paddingInlineStart: "space.150",
    textAlign: "center",
    transition: "background 0.1s ease-out",
    verticalAlign: "middle",
    "::after": {
        borderRadius: "inherit",
        inset: "space.0",
        borderStyle: "solid",
        borderWidth: "var(--ds-border-width, 1px)",
        pointerEvents: "none",
        position: "absolute"
    }
});
var $740e884ae163b767$var$hardCodedButtonStyles = (0, $eDOWt.xcss)({
    fontFamily: "inherit",
    fontSize: "inherit",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "".concat(32 / 14, "em"),
    paddingBlock: "space.0"
});
var $740e884ae163b767$var$tokenizedButtonStyles = (0, $eDOWt.xcss)({
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    fontWeight: "var(--ds-font-weight-medium, 500)",
    paddingBlock: "space.075"
});
var $740e884ae163b767$var$defaultInteractiveStyles = (0, $eDOWt.xcss)({
    ":hover": {
        background: "var(--ds-background-neutral-hovered, #091e4214)",
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($jp7ng.N500, ")")
    },
    ":active": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-neutral-pressed, ".concat($jp7ng.B75, ")"),
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($jp7ng.B400, ")")
    }
});
var $740e884ae163b767$var$defaultInteractiveRefreshedStyles = (0, $eDOWt.xcss)({
    ":hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: "color.text.subtle"
    },
    ":active": {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: "color.text.subtle"
    }
});
var $740e884ae163b767$var$defaultStyles = (0, $eDOWt.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    background: "var(--ds-background-neutral, ".concat($jp7ng.N20A, ")"),
    // @ts-expect-error — using tokens for explicit fallback usage.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values --  -- Ignored via go/DSP-18766
    color: "var(--ds-text, ".concat($jp7ng.N500, ")"),
    ":visited": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($jp7ng.N500, ")")
    }
});
var $740e884ae163b767$var$defaultRefreshedStyles = (0, $eDOWt.xcss)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "color.text.subtle",
    "::after": {
        content: '""',
        borderColor: "color.border"
    },
    ":visited": {
        color: "color.text.subtle"
    }
});
var $740e884ae163b767$var$primaryStyles = (0, $eDOWt.xcss)({
    background: "var(--ds-background-brand-bold, #0052CC)",
    // @ts-expect-error
    color: "var(--ds-text-inverse, #FFFFFF)",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)"
    }
});
var $740e884ae163b767$var$primaryInteractiveStyles = (0, $eDOWt.xcss)({
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-hovered, #0065FF)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-pressed, #0747A6)"
    }
});
var $740e884ae163b767$var$warningStyles = (0, $eDOWt.xcss)({
    background: "var(--ds-background-warning-bold, #FFAB00)",
    // @ts-expect-error
    color: "var(--ds-text-warning-inverse, #172B4D)",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)"
    }
});
var $740e884ae163b767$var$warningInteractiveStyles = (0, $eDOWt.xcss)({
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-hovered, #FFC400)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-pressed, #FF991F)"
    }
});
var $740e884ae163b767$var$dangerStyles = (0, $eDOWt.xcss)({
    background: "var(--ds-background-danger-bold, #DE350B)",
    color: "color.text.inverse",
    ":visited": {
        color: "color.text.inverse"
    }
});
var $740e884ae163b767$var$dangerInteractiveStyles = (0, $eDOWt.xcss)({
    ":hover": {
        color: "color.text.inverse",
        background: "var(--ds-background-danger-bold-hovered, #FF5630)"
    },
    ":active": {
        color: "color.text.inverse",
        background: "var(--ds-background-danger-bold-pressed, #BF2600)"
    }
});
var $740e884ae163b767$var$discoveryStyles = (0, $eDOWt.xcss)({
    background: "var(--ds-background-discovery-bold, #5243AA)",
    color: "color.text.inverse",
    ":visited": {
        color: "color.text.inverse"
    }
});
var $740e884ae163b767$var$discoveryInteractiveStyles = (0, $eDOWt.xcss)({
    ":hover": {
        color: "color.text.inverse",
        background: "var(--ds-background-discovery-bold-hovered, #8777D9)"
    },
    ":active": {
        color: "color.text.inverse",
        background: "var(--ds-background-discovery-bold-pressed, #5243AA)"
    }
});
var $740e884ae163b767$var$subtleStyles = (0, $eDOWt.xcss)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    // @ts-expect-error
    color: "var(--ds-text, #42526E)",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $740e884ae163b767$var$subtleRefreshedStyles = (0, $eDOWt.xcss)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    color: "color.text.subtle",
    ":visited": {
        color: "color.text.subtle"
    }
});
var $740e884ae163b767$var$subtleInteractiveStyles = (0, $eDOWt.xcss)({
    ":hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    },
    ":active": {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $740e884ae163b767$var$subtleInteractiveRefreshedStyles = (0, $eDOWt.xcss)({
    ":hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        color: "color.text.subtle"
    },
    ":active": {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        color: "color.text.subtle"
    }
});
var $740e884ae163b767$var$linkStyles = (0, $eDOWt.xcss)({
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-link, ".concat($jp7ng.B400, ")"),
    background: "var(--ds-background-neutral-subtle, transparent)",
    textDecoration: "none",
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-link, ".concat($jp7ng.B300, ")"),
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-link-pressed, #0055CC)",
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ":visited": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-link, ".concat($jp7ng.B400, ")")
    }
});
var $740e884ae163b767$var$subtleLinkStyles = (0, $eDOWt.xcss)({
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-subtle, ".concat($jp7ng.N200, ")"),
    background: "var(--ds-background-neutral-subtle, transparent)",
    textDecoration: "none",
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-subtle, ".concat($jp7ng.N90, ")"),
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($jp7ng.N400, ")"),
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ":visited": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-subtle, ".concat($jp7ng.N200, ")")
    }
});
// Required due to Jira's AUI CSS reset: https://product-fabric.atlassian.net/browse/DSP-15687
var $740e884ae163b767$var$linkDecorationUnsetStyles = (0, $eDOWt.xcss)({
    textDecoration: "none",
    ":hover": {
        textDecoration: "none"
    },
    ":active": {
        textDecoration: "none"
    },
    ":focus": {
        textDecoration: "none"
    }
});
var $740e884ae163b767$var$linkDecorationStyles = (0, $eDOWt.xcss)({
    ":hover": {
        textDecoration: "underline"
    },
    ":focus": {
        textDecoration: "underline"
    }
});
var $740e884ae163b767$var$disabledStyles = (0, $eDOWt.xcss)({
    cursor: "not-allowed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-disabled, ".concat($jp7ng.N20A, ")"),
    // @ts-expect-error
    color: "var(--ds-text-disabled, #091E424F)",
    ":hover": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-disabled, ".concat($jp7ng.N20A, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    ":active": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-disabled, ".concat($jp7ng.N20A, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    "::after": {
        content: "none"
    }
});
var $740e884ae163b767$var$selectedStyles = (0, $eDOWt.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($jp7ng.N700, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
    ":visited": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($jp7ng.N20, ")")
    }
});
var $740e884ae163b767$var$selectedRefreshedStyles = (0, $eDOWt.xcss)({
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "color.text.selected",
    "::after": {
        content: '""',
        borderColor: "color.border.selected"
    },
    ":visited": {
        color: "color.text.selected"
    }
});
var $740e884ae163b767$var$selectedInteractiveStyles = (0, $eDOWt.xcss)({
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected-hovered, ".concat($jp7ng.N700, ")")
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected-pressed, ".concat($jp7ng.N700, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $740e884ae163b767$var$selectedWarningStyles = (0, $eDOWt.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($jp7ng.Y400, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($jp7ng.N800, ")"),
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($jp7ng.Y400, ")")
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($jp7ng.Y400, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $740e884ae163b767$var$selectedDangerStyles = (0, $eDOWt.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($jp7ng.R500, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($jp7ng.R500, ")")
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($jp7ng.R500, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $740e884ae163b767$var$selectedDiscoveryStyles = (0, $eDOWt.xcss)({
    background: "var(--ds-background-selected, #403294)",
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
        background: "var(--ds-background-selected, #403294)"
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($jp7ng.N20, ")"),
        background: "var(--ds-background-selected, #403294)"
    }
});
var $740e884ae163b767$var$spacingCompactStyles = (0, $eDOWt.xcss)({
    columnGap: "space.050",
    height: "".concat(24 / 14, "em"),
    paddingInlineEnd: "space.150",
    paddingInlineStart: "space.150",
    verticalAlign: "middle"
});
var $740e884ae163b767$var$baseSpacingCompactStyles = (0, $eDOWt.xcss)({
    lineHeight: "".concat(24 / 14, "em")
});
var $740e884ae163b767$var$tokenizedSpacingCompactStyles = (0, $eDOWt.xcss)({
    paddingBlock: "space.025"
});
var $740e884ae163b767$var$spacingNoneStyles = (0, $eDOWt.xcss)({
    columnGap: "space.0",
    height: "auto",
    lineHeight: "inherit",
    paddingInlineEnd: "space.0",
    paddingInlineStart: "space.0",
    verticalAlign: "baseline"
});
var $740e884ae163b767$var$tokenizedSpacingNoneStyles = (0, $eDOWt.xcss)({
    paddingBlock: "space.0"
});
var $740e884ae163b767$var$circleStyles = (0, $eDOWt.xcss)({
    borderRadius: "border.radius.circle"
});
var $740e884ae163b767$var$fullWidthStyles = (0, $eDOWt.xcss)({
    width: "100%"
});
var $740e884ae163b767$var$loadingStyles = (0, $eDOWt.xcss)({
    cursor: "progress"
});
var $740e884ae163b767$var$iconButtonStyles = (0, $eDOWt.xcss)({
    height: "".concat(32 / 14, "em"),
    width: "".concat(32 / 14, "em"),
    paddingInlineEnd: "space.0",
    paddingInlineStart: "space.0"
});
var $740e884ae163b767$var$iconButtonCompactStyles = (0, $eDOWt.xcss)({
    width: "".concat(24 / 14, "em"),
    height: "".concat(24 / 14, "em")
});
var $740e884ae163b767$var$buttonIconBeforeStyles = (0, $eDOWt.xcss)({
    paddingInlineStart: "space.100"
});
var $740e884ae163b767$var$buttonIconAfterStyles = (0, $eDOWt.xcss)({
    paddingInlineEnd: "space.100"
});
var $740e884ae163b767$var$splitButtonStyles = (0, $eDOWt.xcss)({
    ":focus-visible": {
        zIndex: "card"
    }
});
var $740e884ae163b767$var$navigationSplitButtonStyles = (0, $eDOWt.xcss)({
    width: "24px",
    backgroundColor: "color.background.neutral.subtle",
    paddingInlineEnd: "space.075",
    paddingInlineStart: "space.075"
});
var $740e884ae163b767$var$loadingOverlayStyles = (0, $eDOWt.xcss)({
    display: "flex",
    position: "absolute",
    alignItems: "center",
    justifyContent: "center",
    insetBlockEnd: "space.0",
    insetBlockStart: "space.0",
    insetInlineEnd: "space.0",
    insetInlineStart: "space.0"
});
/**
 * __Use button base__
 *
 * A React hook that accepts a set of common Button props,
 * and processes them to return consistent base props for usage
 * across various Button components.
 *
 * It also:
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $740e884ae163b767$var$useButtonBase = function useButtonBase(_ref) {
    var _ref$appearance = _ref.appearance, propAppearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, children = _ref.children, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, ref = _ref.ref, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? "default" : _ref$spacing, testId = _ref.testId, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy;
    var localRef = (0, $9nHZC.useRef)(null);
    var splitButtonContext = (0, $hHlXd.useSplitButtonContext)();
    // TODO: Use React 18's useId() hook when we update.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    var loadingLabelId = (0, $4ul5V.uid)({
        ariaLabelledBy: ariaLabelledBy
    });
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === "default";
    var appearance = (0, $dEQSq.getBooleanFF)("platform.design-system-team.component-visual-refresh_t8zbo") && isDefaultAppearanceSplitButton ? "subtle" : (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || propAppearance;
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $grYZC.default)(localRef, autoFocus);
    return $740e884ae163b767$var$_objectSpread({
        ref: (0, $3aF04.default)([
            localRef,
            ref
        ]),
        xcss: [
            (0, $dEQSq.getBooleanFF)("platform.design-system-team.button-tokenised-typography-styles") ? $740e884ae163b767$var$tokenizedButtonStyles : $740e884ae163b767$var$hardCodedButtonStyles,
            $740e884ae163b767$var$buttonStyles,
            appearance === "default" && ((0, $dEQSq.getBooleanFF)("platform.design-system-team.component-visual-refresh_t8zbo") ? $740e884ae163b767$var$defaultRefreshedStyles : $740e884ae163b767$var$defaultStyles),
            appearance === "default" && isInteractive && ((0, $dEQSq.getBooleanFF)("platform.design-system-team.component-visual-refresh_t8zbo") ? $740e884ae163b767$var$defaultInteractiveRefreshedStyles : $740e884ae163b767$var$defaultInteractiveStyles),
            appearance === "primary" && $740e884ae163b767$var$primaryStyles,
            appearance === "primary" && isInteractive && $740e884ae163b767$var$primaryInteractiveStyles,
            appearance === "warning" && $740e884ae163b767$var$warningStyles,
            appearance === "warning" && isInteractive && $740e884ae163b767$var$warningInteractiveStyles,
            appearance === "danger" && $740e884ae163b767$var$dangerStyles,
            appearance === "danger" && isInteractive && $740e884ae163b767$var$dangerInteractiveStyles,
            appearance === "discovery" && $740e884ae163b767$var$discoveryStyles,
            appearance === "discovery" && isInteractive && $740e884ae163b767$var$discoveryInteractiveStyles,
            appearance === "subtle" && ((0, $dEQSq.getBooleanFF)("platform.design-system-team.component-visual-refresh_t8zbo") ? $740e884ae163b767$var$subtleRefreshedStyles : $740e884ae163b767$var$subtleStyles),
            appearance === "subtle" && isInteractive && ((0, $dEQSq.getBooleanFF)("platform.design-system-team.component-visual-refresh_t8zbo") ? $740e884ae163b767$var$subtleInteractiveRefreshedStyles : $740e884ae163b767$var$subtleInteractiveStyles),
            appearance === "link" && $740e884ae163b767$var$linkStyles,
            appearance === "subtle-link" && $740e884ae163b767$var$subtleLinkStyles,
            !isSelected && (appearance === "link" || appearance === "subtle-link") ? $740e884ae163b767$var$linkDecorationStyles : $740e884ae163b767$var$linkDecorationUnsetStyles,
            isSelected && ((0, $dEQSq.getBooleanFF)("platform.design-system-team.component-visual-refresh_t8zbo") ? $740e884ae163b767$var$selectedRefreshedStyles : $740e884ae163b767$var$selectedStyles),
            isSelected && isInteractive && $740e884ae163b767$var$selectedInteractiveStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "danger" && $740e884ae163b767$var$selectedDangerStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "warning" && $740e884ae163b767$var$selectedWarningStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "discovery" && $740e884ae163b767$var$selectedDiscoveryStyles,
            isDisabled && $740e884ae163b767$var$disabledStyles,
            isCircle && !isSplitButton && $740e884ae163b767$var$circleStyles,
            spacing === "compact" && $740e884ae163b767$var$spacingCompactStyles,
            spacing === "compact" && ((0, $dEQSq.getBooleanFF)("platform.design-system-team.button-tokenised-typography-styles") ? $740e884ae163b767$var$tokenizedSpacingCompactStyles : $740e884ae163b767$var$baseSpacingCompactStyles),
            spacing === "none" && $740e884ae163b767$var$spacingNoneStyles,
            spacing === "none" && (0, $dEQSq.getBooleanFF)("platform.design-system-team.button-tokenised-typography-styles") && $740e884ae163b767$var$tokenizedSpacingNoneStyles,
            spacing !== "none" && hasIconBefore && $740e884ae163b767$var$buttonIconBeforeStyles,
            spacing !== "none" && hasIconAfter && $740e884ae163b767$var$buttonIconAfterStyles,
            isIconButton && $740e884ae163b767$var$iconButtonStyles,
            isIconButton && spacing === "compact" && $740e884ae163b767$var$iconButtonCompactStyles,
            shouldFitContainer && $740e884ae163b767$var$fullWidthStyles,
            isLoading && $740e884ae163b767$var$loadingStyles,
            isSplitButton && $740e884ae163b767$var$splitButtonStyles,
            isNavigationSplitButton && $740e884ae163b767$var$navigationSplitButtonStyles
        ],
        isDisabled: isEffectivelyDisabled,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, children, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6Vblr.default), {
            as: "span",
            xcss: $740e884ae163b767$var$loadingOverlayStyles
        }, (0, $hZkkx.default)({
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected,
            testId: testId
        })) : null, isLoading && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7S7GL.default), {
            id: loadingLabelId
        }, (0, $jCDbx.LOADING_LABEL))),
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat((0, $jCDbx.LOADING_LABEL)) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy
    }, (0, $huBSv.default)(isEffectivelyDisabled, {
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }));
};
var $740e884ae163b767$export$2e2bcd8739ae039 = $740e884ae163b767$var$useButtonBase;

});
parcelRegister("hHlXd", function(module, exports) {

$parcel$export(module.exports, "useSplitButtonContext", function () { return $ce277b7686c7828e$export$47e2c6fdb142d947; });

var $9nHZC = parcelRequire("9nHZC");
var $ce277b7686c7828e$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $9nHZC.createContext)(undefined);
var $ce277b7686c7828e$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $9nHZC.useContext)($ce277b7686c7828e$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === "navigation") {
        var newContext = {
            spacing: "default",
            appearance: "subtle",
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("huBSv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbc29ecfcc6f7c6c$export$2e2bcd8739ae039; });
function $cbc29ecfcc6f7c6c$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $cbc29ecfcc6f7c6c$var$tabKeyCode = 9;
function $cbc29ecfcc6f7c6c$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $cbc29ecfcc6f7c6c$var$tabKeyCode) return;
    $cbc29ecfcc6f7c6c$var$abort(event);
}
function $cbc29ecfcc6f7c6c$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $cbc29ecfcc6f7c6c$var$abort,
        onMouseUpCapture: $cbc29ecfcc6f7c6c$var$abort,
        onKeyDownCapture: $cbc29ecfcc6f7c6c$var$onKey,
        onKeyUpCapture: $cbc29ecfcc6f7c6c$var$onKey,
        onTouchStartCapture: $cbc29ecfcc6f7c6c$var$abort,
        onTouchEndCapture: $cbc29ecfcc6f7c6c$var$abort,
        onPointerDownCapture: $cbc29ecfcc6f7c6c$var$abort,
        onPointerUpCapture: $cbc29ecfcc6f7c6c$var$abort,
        onClickCapture: $cbc29ecfcc6f7c6c$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $cbc29ecfcc6f7c6c$var$abort
    } : events;
}

});

parcelRegister("jCDbx", function(module, exports) {

$parcel$export(module.exports, "LOADING_LABEL", function () { return $e48ff6497c7aeb87$export$d4c5499dc806c969; });
var $e48ff6497c7aeb87$export$d4c5499dc806c969 = ", Loading";

});

parcelRegister("hZkkx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d187e75cb3aa5b2e$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $e9BTj = parcelRequire("e9BTj");
function $d187e75cb3aa5b2e$var$getIconSpacing(spacing) {
    switch(spacing){
        case "compact":
            return "small";
        case "none":
            return "xsmall";
        default:
            return "medium";
    }
}
function $d187e75cb3aa5b2e$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return "inherit";
    if (appearance === "primary" || appearance === "danger" || appearance === "discovery") return "invert";
    return "inherit";
}
function $d187e75cb3aa5b2e$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $e9BTj.default), {
        size: $d187e75cb3aa5b2e$var$getIconSpacing(spacing),
        appearance: $d187e75cb3aa5b2e$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});




parcelRegister("1RcCv", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", function () { return $15a487c0cf6df688$export$f18c1d4fc7326096; });
$parcel$export(module.exports, "default", function () { return $15a487c0cf6df688$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $1FiMp = parcelRequire("1FiMp");

var $8p2GL = parcelRequire("8p2GL");

var $ezORQ = parcelRequire("ezORQ");

var $4czYk = parcelRequire("4czYk");
var $15a487c0cf6df688$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $9nHZC.createContext)({
    menuItemRefs: [],
    registerRef: (0, $8p2GL.default)
});
/**
 * Focus manager logic.
 */ var $15a487c0cf6df688$var$FocusManager = function FocusManager(_ref) {
    var children = _ref.children, onClose = _ref.onClose;
    var menuItemRefs = (0, $9nHZC.useRef)([]);
    var registerRef = (0, $9nHZC.useCallback)(function(ref) {
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    var _UNSAFE_useLayering = (0, $ezORQ.UNSAFE_useLayering)(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled;
    // Intentionally rebinding on each render
    (0, $9nHZC.useEffect)(function() {
        return (0, $1FiMp.bind)(window, {
            type: "keydown",
            listener: (0, $4czYk.default)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    var contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($15a487c0cf6df688$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $15a487c0cf6df688$export$2e2bcd8739ae039 = $15a487c0cf6df688$var$FocusManager;

});
parcelRegister("ezORQ", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useLayering", function () { return $a9cbcad07be9b2eb$export$cec37b93989366d4; });

var $9nHZC = parcelRequire("9nHZC");

var $1FiMp = parcelRequire("1FiMp");

var $kur1Q = parcelRequire("kur1Q");
var $a9cbcad07be9b2eb$var$ESCAPE = "Escape";
function $a9cbcad07be9b2eb$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $9nHZC.useRef)(false);
    var _UNSAFE_useLayering = $a9cbcad07be9b2eb$export$cec37b93989366d4(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled;
    var onKeyDown = (0, $9nHZC.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $a9cbcad07be9b2eb$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $9nHZC.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $9nHZC.useEffect)(function() {
        return (0, $1FiMp.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $a9cbcad07be9b2eb$export$cec37b93989366d4() {
    var currentLevel = (0, $9nHZC.useContext)((0, $kur1Q.LevelContext));
    var _useContext = (0, $9nHZC.useContext)((0, $kur1Q.TopLevelContext)), topLevelRef = _useContext.topLevelRef;
    var isLayerDisabled = (0, $9nHZC.useCallback)(function() {
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}

});
parcelRegister("kur1Q", function(module, exports) {

$parcel$export(module.exports, "LevelContext", function () { return $eeab93593b04d6d5$export$650d12d3c2ddb8fc; });
$parcel$export(module.exports, "TopLevelContext", function () { return $eeab93593b04d6d5$export$48b383b280e20440; });

var $9nHZC = parcelRequire("9nHZC");

var $8p2GL = parcelRequire("8p2GL");
var $eeab93593b04d6d5$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $9nHZC.createContext)(0);
var $eeab93593b04d6d5$export$48b383b280e20440 = /*#__PURE__*/ (0, $9nHZC.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $8p2GL.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $eeab93593b04d6d5$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $9nHZC.useContext)($eeab93593b04d6d5$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel;
    setTopLevel(currentLevel);
    (0, $9nHZC.useEffect)(function() {
        // avoid immediate cleanup using setTimeout when component unmount
        // this will make sure non-top layer components can get the correct top level value
        // when multiple layers trigger onClose in sequence.
        // From React 17, the useEffect cleanup functions are delayed till the commit phase is completed. In other words, the useEffect cleanup functions run asynchronously - for example, if the component is unmounting, the cleanup runs after the screen has been updated.
        // TODO revisit after we migrate to react 18. https://product-fabric.atlassian.net/browse/DSP-13139
        return function() {
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eeab93593b04d6d5$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $eeab93593b04d6d5$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $9nHZC.useRef)(0);
    var value = (0, $9nHZC.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eeab93593b04d6d5$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $eeab93593b04d6d5$export$a183686c3f6f4ea8 = function UNSAFE_LAYERING(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $9nHZC.useContext)($eeab93593b04d6d5$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eeab93593b04d6d5$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eeab93593b04d6d5$var$LayeringProvider, null, content);
};

});


parcelRegister("4czYk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30f42fb47b4f5390$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $70mT6 = parcelRequire("70mT6");
var $30f42fb47b4f5390$var$_actionMap;
var $30f42fb47b4f5390$var$actionMap = ($30f42fb47b4f5390$var$_actionMap = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($30f42fb47b4f5390$var$_actionMap, (0, $70mT6.KEY_DOWN), "next"), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($30f42fb47b4f5390$var$_actionMap, (0, $70mT6.KEY_UP), "prev"), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($30f42fb47b4f5390$var$_actionMap, (0, $70mT6.KEY_HOME), "first"), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($30f42fb47b4f5390$var$_actionMap, (0, $70mT6.KEY_END), "last"), $30f42fb47b4f5390$var$_actionMap);
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ var $30f42fb47b4f5390$var$getNextFocusableElement = function getNextFocusableElement(refs, currentFocusedIdx) {
    while(currentFocusedIdx + 1 < refs.length){
        var isDisabled = refs[currentFocusedIdx + 1].hasAttribute("disabled");
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ var $30f42fb47b4f5390$var$getPrevFocusableElement = function getPrevFocusableElement(refs, currentFocusedIdx) {
    while(currentFocusedIdx > 0){
        var isDisabled = refs[currentFocusedIdx - 1].hasAttribute("disabled");
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $30f42fb47b4f5390$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return function(e) {
        var currentFocusedIdx = refs.findIndex(function(el) {
            var _document$activeEleme;
            return (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el);
        });
        if (isLayerDisabled()) {
            // if nested dropdown isOpen we need to close on Tab key press
            if (e.key === (0, $70mT6.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        var action = $30f42fb47b4f5390$var$actionMap[e.key];
        switch(action){
            case "next":
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    var _nextFocusableElement = $30f42fb47b4f5390$var$getNextFocusableElement(refs, currentFocusedIdx);
                    _nextFocusableElement === null || _nextFocusableElement === void 0 || _nextFocusableElement.focus();
                } else {
                    var firstFocusableElement = $30f42fb47b4f5390$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
                }
                break;
            case "prev":
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    var _prevFocusableElement = $30f42fb47b4f5390$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    _prevFocusableElement === null || _prevFocusableElement === void 0 || _prevFocusableElement.focus();
                } else {
                    var lastFocusableElement = $30f42fb47b4f5390$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement === null || lastFocusableElement === void 0 || lastFocusableElement.focus();
                }
                break;
            case "first":
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                var nextFocusableElement = $30f42fb47b4f5390$var$getNextFocusableElement(refs, -1);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case "last":
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                var prevFocusableElement = $30f42fb47b4f5390$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});


parcelRegister("h21tr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c663c43b8e2ad780$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $8HHuo = parcelRequire("8HHuo");

var $6Vblr = parcelRequire("6Vblr");
var $eDOWt = parcelRequire("eDOWt");

var $e9BTj = parcelRequire("e9BTj");

var $1RcCv = parcelRequire("1RcCv");

var $difni = parcelRequire("difni");

var $g6Pbh = parcelRequire("g6Pbh");
var $c663c43b8e2ad780$var$spinnerContainerStyles = (0, $eDOWt.xcss)({
    display: "flex",
    minWidth: "160px",
    padding: "space.250",
    justifyContent: "center"
});
var $c663c43b8e2ad780$var$LoadingIndicator = function LoadingIndicator(_ref) {
    var _ref$statusLabel = _ref.statusLabel, statusLabel = _ref$statusLabel === void 0 ? "Loading" : _ref$statusLabel, testId = _ref.testId;
    return (0, $avKww.jsx)((0, $6Vblr.default), {
        xcss: $c663c43b8e2ad780$var$spinnerContainerStyles
    }, (0, $avKww.jsx)((0, $e9BTj.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
};
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ var $c663c43b8e2ad780$var$MenuWrapper = function MenuWrapper(_ref2) {
    var children = _ref2.children, isLoading = _ref2.isLoading, maxHeight = _ref2.maxHeight, maxWidth = _ref2.maxWidth, onClose = _ref2.onClose, onUpdate = _ref2.onUpdate, statusLabel = _ref2.statusLabel, setInitialFocusRef = _ref2.setInitialFocusRef, shouldRenderToParent = _ref2.shouldRenderToParent, spacing = _ref2.spacing, testId = _ref2.testId, isTriggeredUsingKeyboard = _ref2.isTriggeredUsingKeyboard, autoFocus = _ref2.autoFocus;
    var _useContext = (0, $9nHZC.useContext)((0, $1RcCv.FocusManagerContext)), menuItemRefs = _useContext.menuItemRefs;
    var closeOnMenuItemClick = function closeOnMenuItemClick(e) {
        var isTargetMenuItemOrDecendant = menuItemRefs.some(function(menuItem) {
            var isCheckboxOrRadio = (0, $difni.default)(menuItem) || (0, $g6Pbh.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $9nHZC.useLayoutEffect)(function() {
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $9nHZC.useEffect)(function() {
        var _menuItemRefs$find;
        var firstFocusableRef = (_menuItemRefs$find = menuItemRefs.find(function(ref) {
            return !ref.hasAttribute("disabled");
        })) !== null && _menuItemRefs$find !== void 0 ? _menuItemRefs$find : null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef === null || firstFocusableRef === void 0 || firstFocusableRef.focus();
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return (0, $avKww.jsx)((0, $8HHuo.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && "".concat(testId, "--menu-group")
    }, isLoading ? (0, $avKww.jsx)($c663c43b8e2ad780$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && "".concat(testId, "--loading-indicator")
    }) : children);
};
var $c663c43b8e2ad780$export$2e2bcd8739ae039 = $c663c43b8e2ad780$var$MenuWrapper;

});
parcelRegister("difni", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ad8e1e44b793451$export$2e2bcd8739ae039; });
function $9ad8e1e44b793451$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute("role");
    return role === "checkbox" || role === "menuitemcheckbox";
}

});

parcelRegister("g6Pbh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bba4e85534344123$export$2e2bcd8739ae039; });
function $bba4e85534344123$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute("role");
    return role === "radio" || role === "menuitemradio";
}

});


parcelRegister("b12tK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8051b5f43c58e5aa$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $8p2GL = parcelRequire("8p2GL");
var $8051b5f43c58e5aa$export$756f795847463ebd = /*#__PURE__*/ (0, $9nHZC.createContext)({
    setItemState: (0, $8p2GL.default),
    getItemState: function getItemState() {
        return undefined;
    },
    setGroupState: (0, $8p2GL.default),
    getGroupState: function getGroupState() {
        return {};
    }
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ var $8051b5f43c58e5aa$var$SelectionStore = function SelectionStore(props) {
    var children = props.children;
    var store = (0, $9nHZC.useRef)({});
    var context = (0, $9nHZC.useMemo)(function() {
        return {
            setItemState: function setItemState(group, id, value) {
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: function getItemState(group, id) {
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: function setGroupState(group, value) {
                store.current[group] = value;
            },
            getGroupState: function getGroupState(group) {
                return store.current[group] || {};
            }
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($8051b5f43c58e5aa$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $8051b5f43c58e5aa$export$2e2bcd8739ae039 = $8051b5f43c58e5aa$var$SelectionStore;

});

parcelRegister("dMUnM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a09b7e7a538ad0fa$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $1RcCv = parcelRequire("1RcCv");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $a09b7e7a538ad0fa$var$useRegisterItemWithFocusManager() {
    var _useContext = (0, $9nHZC.useContext)((0, $1RcCv.FocusManagerContext)), registerRef = _useContext.registerRef;
    var itemRef = (0, $9nHZC.useRef)(null);
    (0, $9nHZC.useEffect)(function() {
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $a09b7e7a538ad0fa$export$2e2bcd8739ae039 = $a09b7e7a538ad0fa$var$useRegisterItemWithFocusManager;

});

parcelRegister("9UfnV", function(module, exports) {

$parcel$export(module.exports, "PREFIX", function () { return $73654729c656eac7$export$8a682ae47622dbb9; });
$parcel$export(module.exports, "default", function () { return $73654729c656eac7$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");
var $73654729c656eac7$export$8a682ae47622dbb9 = "ds--dropdown--";
var $73654729c656eac7$var$generateRandomString = function generateRandomString() {
    return(// Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    "".concat($73654729c656eac7$export$8a682ae47622dbb9).concat(Math.random().toString(16).substr(2, 8)));
};
function $73654729c656eac7$export$2e2bcd8739ae039() {
    var cachedId = (0, $9nHZC.useRef)($73654729c656eac7$var$generateRandomString());
    return cachedId.current;
}

});


parcelRegister("Vt2jo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0acbd8fcd76d4adf$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $3aF04 = parcelRequire("3aF04");

var $5kzu2 = parcelRequire("5kzu2");

var $87ZI9 = parcelRequire("87ZI9");

var $fuPTF = parcelRequire("fuPTF");

var $dMUnM = parcelRequire("dMUnM");
var $0acbd8fcd76d4adf$var$_excluded = [
    "children",
    "component",
    "description",
    "elemAfter",
    "elemBefore",
    "href",
    "isDisabled",
    "isSelected",
    "onClick",
    "rel",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "target",
    "testId"
];
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ var $0acbd8fcd76d4adf$var$DropdownMenuItem = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var children = _ref.children, component = _ref.component, description = _ref.description, elemAfter = _ref.elemAfter, elemBefore = _ref.elemBefore, href = _ref.href, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, rel = _ref.rel, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, target = _ref.target, testId = _ref.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $0acbd8fcd76d4adf$var$_excluded);
    var itemRef = (0, $dMUnM.default)();
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $87ZI9.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $3aF04.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        target: target,
        rel: rel
    }, rest), children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fuPTF.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $3aF04.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId
    }, rest), children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5kzu2.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $3aF04.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        target: target,
        rel: rel
    }, rest), children);
});
var $0acbd8fcd76d4adf$export$2e2bcd8739ae039 = $0acbd8fcd76d4adf$var$DropdownMenuItem;

});

parcelRegister("liugG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f812c2093bc97453$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $9SZaS = parcelRequire("9SZaS");

var $4ymzH = parcelRequire("4ymzH");

var $aEOLh = parcelRequire("aEOLh");
var $f812c2093bc97453$var$_excluded = [
    "children",
    "id",
    "isList",
    "isScrollable",
    "title",
    "testId",
    "hasSeparator",
    "overrides"
];
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ var $f812c2093bc97453$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var children = _ref.children, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, title = _ref.title, testId = _ref.testId, hasSeparator = _ref.hasSeparator, overrides = _ref.overrides, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $f812c2093bc97453$var$_excluded);
    var uid = (0, $9SZaS.useUID)();
    var titleId = "dropdown-menu-item-group-title-".concat(uid);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $4ymzH.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        overrides: overrides
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aEOLh.default), {
        id: titleId,
        title: title
    }), children);
});
var $f812c2093bc97453$export$2e2bcd8739ae039 = $f812c2093bc97453$var$DropdownMenuItemGroup;

});
parcelRegister("aEOLh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c2503fea44aa682$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $avKww = parcelRequire("avKww");

var $jp7ng = parcelRequire("jp7ng");

var $dCDrX = parcelRequire("dCDrX");
var $7c2503fea44aa682$var$itemHeadingContentHeight = (0, $dCDrX.headingSizes).h100.lineHeight;
var $7c2503fea44aa682$var$itemHeadingFontSize = (0, $dCDrX.headingSizes).h100.size;
var $7c2503fea44aa682$var$headingStyles = (0, $avKww.css)({
    color: "var(--ds-text-subtle, ".concat((0, $jp7ng.N300), ")"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: $7c2503fea44aa682$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: $7c2503fea44aa682$var$itemHeadingContentHeight / $7c2503fea44aa682$var$itemHeadingFontSize,
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: "uppercase"
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ var $7c2503fea44aa682$var$GroupTitle = function GroupTitle(_ref) {
    var id = _ref.id, title = _ref.title;
    return (0, $avKww.jsx)("div", {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        css: $7c2503fea44aa682$var$headingStyles
    }, title);
};
var $7c2503fea44aa682$export$2e2bcd8739ae039 = $7c2503fea44aa682$var$GroupTitle;

});



parcelRegister("jNP7Q", function(module, exports) {

$parcel$export(module.exports, "ProfileCardDetails", function () { return $e6aa4061e628dab3$export$c0e6870b898eb99d; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $eygjM = parcelRequire("eygjM");

var $7doh5 = parcelRequire("7doh5");

var $3t9Oi = parcelRequire("3t9Oi");
var $5oWf0 = parcelRequire("5oWf0");

var $d6usV = parcelRequire("d6usV");

var $iJFBU = parcelRequire("iJFBU");

var $7daq7 = parcelRequire("7daq7");
parcelRequire("cpeG8");
var $khCx6 = parcelRequire("khCx6");

var $e9oob = parcelRequire("e9oob");
var $e6aa4061e628dab3$var$_excluded = [
    "text"
];
var $e6aa4061e628dab3$var$detailedListWrapperStyles = (0, $5oWf0.xcss)({
    margin: "space.0",
    padding: "space.0"
});
var $e6aa4061e628dab3$var$renderName = function renderName(nickname, fullName, meta) {
    if (!fullName && !nickname) return null;
    var isNicknameRedundant = !nickname || nickname === fullName;
    var shownNickname = " (".concat(nickname, ") ");
    var displayName = isNicknameRedundant ? fullName : "".concat(fullName).concat(shownNickname);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.FullNameLabel), {
        noMeta: !meta,
        "data-testid": "profilecard-name",
        id: "profilecard-name-label"
    }, displayName);
};
var $e6aa4061e628dab3$var$disabledAccountDesc = function disabledAccountDesc(statusModifiedDate, disabledAccountMessage) {
    var status = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "closed";
    // consumer does not want to use built-in message
    if (disabledAccountMessage) return disabledAccountMessage;
    var date = statusModifiedDate ? new Date(statusModifiedDate * 1000) : null;
    var relativeDateKey = (0, $d6usV.default)(date);
    var msgKey = relativeDateKey ? "".concat(status, "AccountDescMsgHasDate").concat(relativeDateKey) : "".concat(status, "AccountDescMsgNoDate");
    var secondSentence = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eygjM.default), (0, $iJFBU.default)[msgKey]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("p", {
        "data-testid": "profilecard-disabled-account"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eygjM.default), (0, $iJFBU.default).generalDescMsgForDisabledUser), " ", secondSentence);
};
var $e6aa4061e628dab3$var$CustomLozenges = function CustomLozenges(_ref) {
    var _ref$lozenges = _ref.lozenges, lozenges = _ref$lozenges === void 0 ? [] : _ref$lozenges;
    if (lozenges.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.CustomLozengeContainer), null, lozenges.map(function(_ref2, index) {
        var text = _ref2.text, otherProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref2, $e6aa4061e628dab3$var$_excluded);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7doh5.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
            key: index
        }), text);
    }));
};
var $e6aa4061e628dab3$var$BotProfileCardDetails = function BotProfileCardDetails(props) {
    var fullName = props.fullName, nickname = props.nickname;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.DetailsGroup), null, $e6aa4061e628dab3$var$renderName(nickname, fullName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.AppTitleLabel), null, "App"));
};
var $e6aa4061e628dab3$var$DisabledProfileCardDetails = function DisabledProfileCardDetails(props) {
    var companyName = props.companyName, disabledAccountMessage = props.disabledAccountMessage, fullName = props.fullName, _props$hasDisabledAcc = props.hasDisabledAccountLozenge, hasDisabledAccountLozenge = _props$hasDisabledAcc === void 0 ? true : _props$hasDisabledAcc, nickname = props.nickname, status = props.status, statusModifiedDate = props.statusModifiedDate;
    var name = status === "inactive" ? fullName || nickname : nickname || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eygjM.default), (0, $iJFBU.default).disabledAccountDefaultName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.DetailsGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.FullNameLabel), {
        noMeta: true,
        isDisabledAccount: true,
        "data-testid": "profilecard-name",
        id: "profilecard-name-label"
    }, name), hasDisabledAccountLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.LozengeWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7doh5.default), {
        appearance: "default",
        isBold: true
    }, status === "inactive" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eygjM.default), (0, $iJFBU.default).inactiveAccountMsg) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eygjM.default), (0, $iJFBU.default).closedAccountMsg))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.DisabledInfo), null, $e6aa4061e628dab3$var$disabledAccountDesc(statusModifiedDate, disabledAccountMessage, status)), status === "inactive" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $khCx6.default), {
        icon: "companyName"
    }, companyName));
};
var $e6aa4061e628dab3$export$c0e6870b898eb99d = function ProfileCardDetails(props) {
    var meta = props.meta, status = props.status;
    if (props.isBot) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($e6aa4061e628dab3$var$BotProfileCardDetails, props);
    if (status === "inactive" || status === "closed") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($e6aa4061e628dab3$var$DisabledProfileCardDetails, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        status: status
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.DetailsGroup), null, $e6aa4061e628dab3$var$renderName(props.nickname, props.fullName, meta), meta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.JobTitleLabel), null, meta), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($e6aa4061e628dab3$var$CustomLozenges, {
        lozenges: props.customLozenges
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3t9Oi.default), {
        as: "dl",
        xcss: $e6aa4061e628dab3$var$detailedListWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $khCx6.default), {
        icon: "email"
    }, props.email), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $khCx6.default), {
        icon: "time"
    }, props.timestring), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $khCx6.default), {
        icon: "companyName"
    }, props.companyName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $khCx6.default), {
        icon: "location"
    }, props.location)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $e9oob.default), {
        reportingLines: props.reportingLines,
        reportingLinesProfileUrl: props.reportingLinesProfileUrl,
        onReportingLinesClick: props.onReportingLinesClick,
        fireAnalyticsWithDuration: props.fireAnalyticsWithDuration
    }));
};

});
parcelRegister("3t9Oi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $286bb0a9d7822528$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $1GVCW = parcelRequire("1GVCW");

var $5oWf0 = parcelRequire("5oWf0");

var $hq99a = parcelRequire("hq99a");
var $286bb0a9d7822528$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $286bb0a9d7822528$var$_excluded2 = [
    "className"
];
var $286bb0a9d7822528$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $286bb0a9d7822528$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(htmlAttributes, $286bb0a9d7822528$var$_excluded2);
    var resolvedStyles = (0, $5oWf0.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $avKww.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $286bb0a9d7822528$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $1GVCW.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $1GVCW.isSurfaceColorToken)(backgroundColor) && (0, $1GVCW.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $1GVCW.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $1GVCW.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $1GVCW.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $1GVCW.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $1GVCW.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $1GVCW.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $1GVCW.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $avKww.jsx)((0, $hq99a.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $286bb0a9d7822528$export$2e2bcd8739ae039 = $286bb0a9d7822528$export$e71c4d32a2263218;
var $286bb0a9d7822528$var$baseStyles = (0, $avKww.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("1GVCW", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $13b66a3eff2c5ed4$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $13b66a3eff2c5ed4$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $13b66a3eff2c5ed4$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $13b66a3eff2c5ed4$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $13b66a3eff2c5ed4$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $13b66a3eff2c5ed4$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $13b66a3eff2c5ed4$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $13b66a3eff2c5ed4$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $13b66a3eff2c5ed4$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $13b66a3eff2c5ed4$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $13b66a3eff2c5ed4$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $13b66a3eff2c5ed4$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $13b66a3eff2c5ed4$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $13b66a3eff2c5ed4$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $13b66a3eff2c5ed4$export$5e65a44e5b6ecadb; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $xbX1J = parcelRequire("xbX1J");
function $13b66a3eff2c5ed4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $13b66a3eff2c5ed4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $13b66a3eff2c5ed4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $13b66a3eff2c5ed4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $13b66a3eff2c5ed4$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $13b66a3eff2c5ed4$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $13b66a3eff2c5ed4$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $13b66a3eff2c5ed4$export$632685d741f3dbbf = $13b66a3eff2c5ed4$var$_objectSpread($13b66a3eff2c5ed4$var$_objectSpread({}, $13b66a3eff2c5ed4$export$958d0ae7f2977ae4), $13b66a3eff2c5ed4$export$d2dc61f58390201c);
var $13b66a3eff2c5ed4$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $13b66a3eff2c5ed4$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $13b66a3eff2c5ed4$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $13b66a3eff2c5ed4$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $13b66a3eff2c5ed4$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $13b66a3eff2c5ed4$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $13b66a3eff2c5ed4$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $13b66a3eff2c5ed4$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $13b66a3eff2c5ed4$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $13b66a3eff2c5ed4$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $13b66a3eff2c5ed4$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $13b66a3eff2c5ed4$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $13b66a3eff2c5ed4$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $13b66a3eff2c5ed4$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $13b66a3eff2c5ed4$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $13b66a3eff2c5ed4$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $avKww.css)((0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $13b66a3eff2c5ed4$export$e615f061ca585a6c = $13b66a3eff2c5ed4$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $13b66a3eff2c5ed4$var$getSerializedStylesMap(spacingProperty, $13b66a3eff2c5ed4$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $13b66a3eff2c5ed4$export$bf46c3f9eeafc71f = $13b66a3eff2c5ed4$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $13b66a3eff2c5ed4$var$getSerializedStylesMap(spacingProperty, $13b66a3eff2c5ed4$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $13b66a3eff2c5ed4$export$e7af83bafe7f9e63 = $13b66a3eff2c5ed4$var$getSerializedStylesMap("backgroundColor", $13b66a3eff2c5ed4$export$d1d79bf68ac056bd);
var $13b66a3eff2c5ed4$export$3a1bcba60b23d7f0 = $13b66a3eff2c5ed4$var$getSerializedStylesMap("color", $13b66a3eff2c5ed4$export$8473307aa00d6ea1);
var $13b66a3eff2c5ed4$export$45f3f4fe16f9f7d5 = $13b66a3eff2c5ed4$var$getSerializedStylesMap("fontWeight", $13b66a3eff2c5ed4$export$303e322c6b1ed114);
var $13b66a3eff2c5ed4$export$68cc305da27dbaa4 = $13b66a3eff2c5ed4$var$getSerializedStylesMap("fontFamily", $13b66a3eff2c5ed4$export$3c7e9587132614b4);
var $13b66a3eff2c5ed4$export$128f10c238242f83 = $13b66a3eff2c5ed4$var$getSerializedStylesMap("font", $13b66a3eff2c5ed4$export$6cc560b4dedf3816);
var $13b66a3eff2c5ed4$export$ff257d957d48c421 = $13b66a3eff2c5ed4$var$getSerializedStylesMap((0, $xbX1J.CURRENT_SURFACE_CSS_VAR), $13b66a3eff2c5ed4$export$41a358c9c2356760);
var $13b66a3eff2c5ed4$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $13b66a3eff2c5ed4$export$41a358c9c2356760[color] !== undefined;
};

});

parcelRegister("5oWf0", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $3eec5f149b6b56c5$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $3eec5f149b6b56c5$export$f6c783d06584602c; });

var $b4Ivn = parcelRequire("b4Ivn");

var $kFnE9 = parcelRequire("kFnE9");

var $9q1kH = parcelRequire("9q1kH");

var $340K4 = parcelRequire("340K4");

var $avKww = parcelRequire("avKww");

var $1GVCW = parcelRequire("1GVCW");

var $8ovux = parcelRequire("8ovux");
function $3eec5f149b6b56c5$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $3eec5f149b6b56c5$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $3eec5f149b6b56c5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3eec5f149b6b56c5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3eec5f149b6b56c5$var$_arrayLikeToArray(o, minLen);
}
function $3eec5f149b6b56c5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $3eec5f149b6b56c5$export$9a199fbafee0014e = {
    backgroundColor: (0, $1GVCW.backgroundColorMap),
    blockSize: (0, $1GVCW.dimensionMap),
    borderBlockColor: (0, $1GVCW.borderColorMap),
    borderBlockEndColor: (0, $1GVCW.borderColorMap),
    borderBlockEndWidth: (0, $1GVCW.borderWidthMap),
    borderBlockStartColor: (0, $1GVCW.borderColorMap),
    borderBlockStartWidth: (0, $1GVCW.borderWidthMap),
    borderBlockWidth: (0, $1GVCW.borderWidthMap),
    borderBottomColor: (0, $1GVCW.borderColorMap),
    borderBottomLeftRadius: (0, $1GVCW.borderRadiusMap),
    borderBottomRightRadius: (0, $1GVCW.borderRadiusMap),
    borderBottomWidth: (0, $1GVCW.borderWidthMap),
    borderColor: (0, $1GVCW.borderColorMap),
    borderEndEndRadius: (0, $1GVCW.borderRadiusMap),
    borderEndStartRadius: (0, $1GVCW.borderRadiusMap),
    borderInlineColor: (0, $1GVCW.borderColorMap),
    borderInlineEndColor: (0, $1GVCW.borderColorMap),
    borderInlineEndWidth: (0, $1GVCW.borderWidthMap),
    borderInlineStartColor: (0, $1GVCW.borderColorMap),
    borderInlineStartWidth: (0, $1GVCW.borderWidthMap),
    borderInlineWidth: (0, $1GVCW.borderWidthMap),
    borderLeftColor: (0, $1GVCW.borderColorMap),
    borderLeftWidth: (0, $1GVCW.borderWidthMap),
    borderRadius: (0, $1GVCW.borderRadiusMap),
    borderRightColor: (0, $1GVCW.borderColorMap),
    borderRightWidth: (0, $1GVCW.borderWidthMap),
    borderStartEndRadius: (0, $1GVCW.borderRadiusMap),
    borderStartStartRadius: (0, $1GVCW.borderRadiusMap),
    borderTopColor: (0, $1GVCW.borderColorMap),
    borderTopLeftRadius: (0, $1GVCW.borderRadiusMap),
    borderTopRightRadius: (0, $1GVCW.borderRadiusMap),
    borderTopWidth: (0, $1GVCW.borderWidthMap),
    borderWidth: (0, $1GVCW.borderWidthMap),
    bottom: (0, $1GVCW.allSpaceMap),
    boxShadow: (0, $1GVCW.shadowMap),
    color: (0, $1GVCW.textColorMap),
    columnGap: (0, $1GVCW.positiveSpaceMap),
    gap: (0, $1GVCW.positiveSpaceMap),
    height: (0, $1GVCW.dimensionMap),
    inlineSize: (0, $1GVCW.dimensionMap),
    inset: (0, $1GVCW.allSpaceMap),
    insetBlock: (0, $1GVCW.allSpaceMap),
    insetBlockEnd: (0, $1GVCW.allSpaceMap),
    insetBlockStart: (0, $1GVCW.allSpaceMap),
    insetInline: (0, $1GVCW.allSpaceMap),
    insetInlineEnd: (0, $1GVCW.allSpaceMap),
    insetInlineStart: (0, $1GVCW.allSpaceMap),
    left: (0, $1GVCW.allSpaceMap),
    margin: (0, $1GVCW.allSpaceMap),
    marginBlock: (0, $1GVCW.allSpaceMap),
    marginBlockEnd: (0, $1GVCW.allSpaceMap),
    marginBlockStart: (0, $1GVCW.allSpaceMap),
    marginBottom: (0, $1GVCW.allSpaceMap),
    marginInline: (0, $1GVCW.allSpaceMap),
    marginInlineEnd: (0, $1GVCW.allSpaceMap),
    marginInlineStart: (0, $1GVCW.allSpaceMap),
    marginLeft: (0, $1GVCW.allSpaceMap),
    marginRight: (0, $1GVCW.allSpaceMap),
    marginTop: (0, $1GVCW.allSpaceMap),
    maxBlockSize: (0, $1GVCW.dimensionMap),
    maxHeight: (0, $1GVCW.dimensionMap),
    maxInlineSize: (0, $1GVCW.dimensionMap),
    maxWidth: (0, $1GVCW.dimensionMap),
    minBlockSize: (0, $1GVCW.dimensionMap),
    minHeight: (0, $1GVCW.dimensionMap),
    minInlineSize: (0, $1GVCW.dimensionMap),
    minWidth: (0, $1GVCW.dimensionMap),
    opacity: (0, $1GVCW.opacityMap),
    outlineColor: (0, $1GVCW.borderColorMap),
    outlineOffset: (0, $1GVCW.positiveSpaceMap),
    outlineWidth: (0, $1GVCW.borderWidthMap),
    padding: (0, $1GVCW.positiveSpaceMap),
    paddingBlock: (0, $1GVCW.positiveSpaceMap),
    paddingBlockEnd: (0, $1GVCW.positiveSpaceMap),
    paddingBlockStart: (0, $1GVCW.positiveSpaceMap),
    paddingBottom: (0, $1GVCW.positiveSpaceMap),
    paddingInline: (0, $1GVCW.positiveSpaceMap),
    paddingInlineEnd: (0, $1GVCW.positiveSpaceMap),
    paddingInlineStart: (0, $1GVCW.positiveSpaceMap),
    paddingLeft: (0, $1GVCW.positiveSpaceMap),
    paddingRight: (0, $1GVCW.positiveSpaceMap),
    paddingTop: (0, $1GVCW.positiveSpaceMap),
    right: (0, $1GVCW.allSpaceMap),
    rowGap: (0, $1GVCW.positiveSpaceMap),
    top: (0, $1GVCW.allSpaceMap),
    width: (0, $1GVCW.dimensionMap),
    zIndex: (0, $1GVCW.layerMap)
};
var $3eec5f149b6b56c5$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $3eec5f149b6b56c5$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $8ovux === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux.env) === "object" && false;
};
var $3eec5f149b6b56c5$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $3eec5f149b6b56c5$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $3eec5f149b6b56c5$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(value) === "object" && $3eec5f149b6b56c5$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($3eec5f149b6b56c5$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($3eec5f149b6b56c5$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $3eec5f149b6b56c5$export$9a199fbafee0014e)) return;
        var tokenValue = $3eec5f149b6b56c5$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $3eec5f149b6b56c5$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $3eec5f149b6b56c5$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, $3eec5f149b6b56c5$var$uniqueSymbol, (0, $avKww.css)(transformedStyles));
};
var $3eec5f149b6b56c5$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $3eec5f149b6b56c5$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$3eec5f149b6b56c5$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $3eec5f149b6b56c5$export$f6c783d06584602c(style) {
    return $3eec5f149b6b56c5$var$baseXcss(style);
}

});

parcelRegister("hq99a", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $caebf5bf8421a09b$export$1ca2a26fecb070ae; });

var $9nHZC = parcelRequire("9nHZC");
var $caebf5bf8421a09b$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $9nHZC.createContext)("elevation.surface");
var $caebf5bf8421a09b$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $9nHZC.useContext)($caebf5bf8421a09b$export$1ca2a26fecb070ae);
};
$caebf5bf8421a09b$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("d6usV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98a377be86008e3c$export$2e2bcd8739ae039; });

var $kRWr9 = parcelRequire("kRWr9");

var $5iXRI = parcelRequire("5iXRI");

var $lfEe9 = parcelRequire("lfEe9");

var $2Zwka = parcelRequire("2Zwka");
function $98a377be86008e3c$export$c03bb0116ee09d4b(date) {
    var today = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
    return !!date.getTime && (0, $2Zwka.default)(date) && date.getTime() <= today.getTime();
}
function $98a377be86008e3c$export$2e2bcd8739ae039(date) {
    var today = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
    if (!date || !$98a377be86008e3c$export$c03bb0116ee09d4b(date, today)) return null;
    if ((0, $lfEe9.default)(date)) return "ThisWeek";
    if ((0, $5iXRI.default)(date)) return "ThisMonth";
    if (date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() - 1) return "LastMonth";
    var diffInMonths = (0, $kRWr9.default)(today, date);
    if (diffInMonths < 6) return "AFewMonths";
    if (diffInMonths <= 12) return "SeveralMonths";
    return "MoreThanAYear";
}

});
parcelRegister("kRWr9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f316163e237183e9$export$2e2bcd8739ae039; });

var $2vImn = parcelRequire("2vImn");

var $gQCGx = parcelRequire("gQCGx");

var $87TDw = parcelRequire("87TDw");

var $kYqHr = parcelRequire("kYqHr");

var $e04tp = parcelRequire("e04tp");
function $f316163e237183e9$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $kYqHr.default)(2, arguments);
    var dateLeft = (0, $2vImn.default)(dirtyDateLeft);
    var dateRight = (0, $2vImn.default)(dirtyDateRight);
    var sign = (0, $87TDw.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $gQCGx.default)(dateLeft, dateRight));
    var result; // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference); // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $87TDw.default)(dateLeft, dateRight) === -sign; // Check for cases of one full calendar month
        if ((0, $e04tp.default)((0, $2vImn.default)(dirtyDateLeft)) && difference === 1 && (0, $87TDw.default)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    } // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("gQCGx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c43f82bb6ad0063b$export$2e2bcd8739ae039; });

var $2vImn = parcelRequire("2vImn");

var $kYqHr = parcelRequire("kYqHr");
function $c43f82bb6ad0063b$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $kYqHr.default)(2, arguments);
    var dateLeft = (0, $2vImn.default)(dirtyDateLeft);
    var dateRight = (0, $2vImn.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("e04tp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3148912241677e9$export$2e2bcd8739ae039; });

var $2vImn = parcelRequire("2vImn");

var $7osXj = parcelRequire("7osXj");

var $9YT28 = parcelRequire("9YT28");

var $kYqHr = parcelRequire("kYqHr");
function $a3148912241677e9$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kYqHr.default)(1, arguments);
    var date = (0, $2vImn.default)(dirtyDate);
    return (0, $7osXj.default)(date).getTime() === (0, $9YT28.default)(date).getTime();
}

});
parcelRegister("7osXj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56213c4907b378aa$export$2e2bcd8739ae039; });

var $2vImn = parcelRequire("2vImn");

var $kYqHr = parcelRequire("kYqHr");
function $56213c4907b378aa$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kYqHr.default)(1, arguments);
    var date = (0, $2vImn.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("9YT28", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74446823764a92a3$export$2e2bcd8739ae039; });

var $2vImn = parcelRequire("2vImn");

var $kYqHr = parcelRequire("kYqHr");
function $74446823764a92a3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kYqHr.default)(1, arguments);
    var date = (0, $2vImn.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});



parcelRegister("5iXRI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3dcd1238b1bfd48c$export$2e2bcd8739ae039; });

var $3NDos = parcelRequire("3NDos");

var $kYqHr = parcelRequire("kYqHr");
function $3dcd1238b1bfd48c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kYqHr.default)(1, arguments);
    return (0, $3NDos.default)(Date.now(), dirtyDate);
}

});
parcelRegister("3NDos", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c448168aab44fe3$export$2e2bcd8739ae039; });

var $2vImn = parcelRequire("2vImn");

var $kYqHr = parcelRequire("kYqHr");
function $2c448168aab44fe3$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $kYqHr.default)(2, arguments);
    var dateLeft = (0, $2vImn.default)(dirtyDateLeft);
    var dateRight = (0, $2vImn.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

});


parcelRegister("lfEe9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f78a33f739a96b9c$export$2e2bcd8739ae039; });

var $bXYHp = parcelRequire("bXYHp");

var $kYqHr = parcelRequire("kYqHr");
function $f78a33f739a96b9c$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $kYqHr.default)(1, arguments);
    return (0, $bXYHp.default)(dirtyDate, Date.now(), options);
}

});
parcelRegister("bXYHp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b6449fafc51ba31$export$2e2bcd8739ae039; });

var $kwwXE = parcelRequire("kwwXE");

var $kYqHr = parcelRequire("kYqHr");
function $8b6449fafc51ba31$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight, options) {
    (0, $kYqHr.default)(2, arguments);
    var dateLeftStartOfWeek = (0, $kwwXE.default)(dirtyDateLeft, options);
    var dateRightStartOfWeek = (0, $kwwXE.default)(dirtyDateRight, options);
    return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}

});
parcelRegister("kwwXE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef105d2c85878264$export$2e2bcd8739ae039; });

var $2vImn = parcelRequire("2vImn");

var $bn0G6 = parcelRequire("bn0G6");

var $kYqHr = parcelRequire("kYqHr");

var $aG6hM = parcelRequire("aG6hM");
function $ef105d2c85878264$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $kYqHr.default)(1, arguments);
    var defaultOptions = (0, $aG6hM.getDefaultOptions)();
    var weekStartsOn = (0, $bn0G6.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $2vImn.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

});




parcelRegister("cpeG8", function(module, exports) {

$parcel$export(module.exports, "IconLabel", function () { return (parcelRequire("khCx6")).default; });

var $khCx6 = parcelRequire("khCx6");

});
parcelRegister("khCx6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec434901d6066310$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $amAY0 = parcelRequire("amAY0");

var $5dpC9 = parcelRequire("5dpC9");

var $5Qd7e = parcelRequire("5Qd7e");

var $50dHR = parcelRequire("50dHR");

var $7daq7 = parcelRequire("7daq7");
function $ec434901d6066310$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ec434901d6066310$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $ec434901d6066310$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ec434901d6066310$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ec434901d6066310$var$icons = {
    location: (0, (/*@__PURE__*/$parcel$interopDefault($5dpC9))),
    time: (0, (/*@__PURE__*/$parcel$interopDefault($50dHR))),
    email: (0, (/*@__PURE__*/$parcel$interopDefault($amAY0))),
    companyName: (0, (/*@__PURE__*/$parcel$interopDefault($5Qd7e)))
};
var $ec434901d6066310$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$PureComponent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(IconLabel, _React$PureComponent);
    var _super = $ec434901d6066310$var$_createSuper(IconLabel);
    function IconLabel() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, IconLabel);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(IconLabel, [
        {
            key: "render",
            value: function render() {
                if (!this.props.children) return null;
                // @ts-ignore
                var IconElement = this.props.icon && $ec434901d6066310$var$icons[this.props.icon];
                var displayIcon = IconElement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(IconElement, {
                    label: "".concat(this.props.icon),
                    size: "small"
                }) : null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.DetailsLabel), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.DetailsLabelIcon), null, displayIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.DetailsLabelText), null, this.props.children));
            }
        }
    ]);
    return IconLabel;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).PureComponent);
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($ec434901d6066310$export$2e2bcd8739ae039, "defaultProps", {
    icon: ""
});

});
parcelRegister("amAY0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78b8a251db91138c$var$_react = $78b8a251db91138c$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $78b8a251db91138c$var$_email = $78b8a251db91138c$var$_interopRequireDefault((parcelRequire("h77xJ")));
function $78b8a251db91138c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $78b8a251db91138c$var$EmailIcon = (props)=>/*#__PURE__*/ $78b8a251db91138c$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
    }, props, {
        newIcon: $78b8a251db91138c$var$_email.default
    }));
$78b8a251db91138c$var$EmailIcon.displayName = "EmailIcon";
var $78b8a251db91138c$var$_default = module.exports.default = $78b8a251db91138c$var$EmailIcon;

});
parcelRegister("h77xJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5cb86c704b4aada9757c695d217a2634>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c758f0ffdd2377cc$var$_react = $c758f0ffdd2377cc$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $c758f0ffdd2377cc$var$_UNSAFE_baseNew = $c758f0ffdd2377cc$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $c758f0ffdd2377cc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c758f0ffdd2377cc$var$EmailIcon = (props)=>/*#__PURE__*/ $c758f0ffdd2377cc$var$_react.default.createElement($c758f0ffdd2377cc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 4.97V4c0-.69-.56-1.25-1.25-1.25H2C1.31 2.75.75 3.31.75 4v.97m14.5 0V12c0 .69-.56 1.25-1.25 1.25H2c-.69 0-1.25-.56-1.25-1.25V4.97m14.5 0L8 8.986.75 4.971"/>`
    }, props));
$c758f0ffdd2377cc$var$EmailIcon.displayName = "EmailIcon";
var $c758f0ffdd2377cc$var$_default = module.exports.default = $c758f0ffdd2377cc$var$EmailIcon;

});


parcelRegister("5dpC9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3cc20920069479e7$var$_react = $3cc20920069479e7$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $3cc20920069479e7$var$_location = $3cc20920069479e7$var$_interopRequireDefault((parcelRequire("bRwY6")));
function $3cc20920069479e7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3cc20920069479e7$var$LocationIcon = (props)=>/*#__PURE__*/ $3cc20920069479e7$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21c-2.28 0-6-8.686-6-12a6 6 0 1 1 12 0c0 3.314-3.72 12-6 12m0-9a2.912 2.912 0 1 0 0-5.824A2.912 2.912 0 0 0 12 12"/></svg>`
    }, props, {
        newIcon: $3cc20920069479e7$var$_location.default
    }));
$3cc20920069479e7$var$LocationIcon.displayName = "LocationIcon";
var $3cc20920069479e7$var$_default = module.exports.default = $3cc20920069479e7$var$LocationIcon;

});
parcelRegister("bRwY6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63fb0b6df7e49e2098c2ec6d28a5ea51>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a2e37c97533f191$var$_react = $8a2e37c97533f191$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $8a2e37c97533f191$var$_UNSAFE_baseNew = $8a2e37c97533f191$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $8a2e37c97533f191$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Location".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8a2e37c97533f191$var$LocationIcon = (props)=>/*#__PURE__*/ $8a2e37c97533f191$var$_react.default.createElement($8a2e37c97533f191$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M3.677 8.982 8 15.25l4.323-6.268C14.725 5.5 12.232.75 8 .75c-4.231 0-6.725 4.749-4.323 8.232Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M9.75 6a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"/>`
    }, props));
$8a2e37c97533f191$var$LocationIcon.displayName = "LocationIcon";
var $8a2e37c97533f191$var$_default = module.exports.default = $8a2e37c97533f191$var$LocationIcon;

});


parcelRegister("5Qd7e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $440bfb93f5822ea4$var$_react = $440bfb93f5822ea4$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $440bfb93f5822ea4$var$_officeBuilding = $440bfb93f5822ea4$var$_interopRequireDefault((parcelRequire("cSV0z")));
function $440bfb93f5822ea4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $440bfb93f5822ea4$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $440bfb93f5822ea4$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6H5.009C3.902 6 3 6.962 3 8.15v10.7C3 20.04 3.9 21 5.009 21h5.487H8v-2.145c-1.616-.001-3-.003-3-.004 0 0 .005-10.708.009-10.708L8 8.144z"/><path d="M12 7h2v2h-2zm-6 3h2v2H6zm0 3h2v2H6zm6-3h2v2h-2zm0 3h2v2h-2zm2 3h2v3h-2zm2-9h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z"/><path fill-rule="nonzero" d="M18.991 19C18.998 19 19 4.995 19 4.995c0 .006-7.991.005-7.991.005C11.002 5 11 19 11 19zM9 4.995C9 3.893 9.902 3 11.009 3h7.982C20.101 3 21 3.893 21 4.995v14.01A2.004 2.004 0 0 1 18.991 21H9z"/></g></svg>`
    }, props, {
        newIcon: $440bfb93f5822ea4$var$_officeBuilding.default
    }));
$440bfb93f5822ea4$var$OfficeBuildingIcon.displayName = "OfficeBuildingIcon";
var $440bfb93f5822ea4$var$_default = module.exports.default = $440bfb93f5822ea4$var$OfficeBuildingIcon;

});
parcelRegister("cSV0z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::59ed0d1eaf3692b12c2c689c7a7ea5c7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9616bfcc122a585a$var$_react = $9616bfcc122a585a$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $9616bfcc122a585a$var$_UNSAFE_baseNew = $9616bfcc122a585a$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $9616bfcc122a585a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "OfficeBuilding".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9616bfcc122a585a$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $9616bfcc122a585a$var$_react.default.createElement($9616bfcc122a585a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 15.25V2c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25v13.25m10.5 0h-3.5m3.5 0H15m-12.25 0h3.5m-3.5 0H1m4-11.5h2m2 0h2m0 3H9m-2 0H5m1.25 8.5v-4.5h3.5v4.5m-3.5 0h3.5"/>`
    }, props));
$9616bfcc122a585a$var$OfficeBuildingIcon.displayName = "OfficeBuildingIcon";
var $9616bfcc122a585a$var$_default = module.exports.default = $9616bfcc122a585a$var$OfficeBuildingIcon;

});


parcelRegister("50dHR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a4795a9b67bac38$var$_react = $3a4795a9b67bac38$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $3a4795a9b67bac38$var$_clock = $3a4795a9b67bac38$var$_interopRequireDefault((parcelRequire("hDKoC")));
function $3a4795a9b67bac38$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3a4795a9b67bac38$var$RecentIcon = (props)=>/*#__PURE__*/ $3a4795a9b67bac38$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 8.002v4.002c0 .28.116.53.301.712l2.47 2.47a1.003 1.003 0 0 0 1.414 0 1.003 1.003 0 0 0 0-1.415L13 11.586V6a1 1 0 0 0-2 0zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/></svg>`
    }, props, {
        newIcon: $3a4795a9b67bac38$var$_clock.default
    }));
$3a4795a9b67bac38$var$RecentIcon.displayName = "RecentIcon";
var $3a4795a9b67bac38$var$_default = module.exports.default = $3a4795a9b67bac38$var$RecentIcon;

});
parcelRegister("hDKoC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::833e8a33316d384f26236b8b96c6d5be>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cd7a11817937cc6d$var$_react = $cd7a11817937cc6d$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $cd7a11817937cc6d$var$_UNSAFE_baseNew = $cd7a11817937cc6d$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $cd7a11817937cc6d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Clock".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: recent, time input, sprint time remaining.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cd7a11817937cc6d$var$ClockIcon = (props)=>/*#__PURE__*/ $cd7a11817937cc6d$var$_react.default.createElement($cd7a11817937cc6d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 3.25V8l2.5 2m4.75-2A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Z"/>`
    }, props));
$cd7a11817937cc6d$var$ClockIcon.displayName = "ClockIcon";
var $cd7a11817937cc6d$var$_default = module.exports.default = $cd7a11817937cc6d$var$ClockIcon;

});




parcelRegister("e9oob", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4d4d31f43a6bd66$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $eygjM = parcelRequire("eygjM");

var $inFLm = parcelRequire("inFLm");

var $71gev = parcelRequire("71gev");

var $fVy1l = parcelRequire("fVy1l");

var $iJFBU = parcelRequire("iJFBU");

var $98qlh = parcelRequire("98qlh");

var $18aOe = parcelRequire("18aOe");
function $a4d4d31f43a6bd66$var$getProfileHref(userId, profileUrl) {
    return profileUrl ? profileUrl + userId : undefined;
}
var $a4d4d31f43a6bd66$var$ReportingLinesDetails = function ReportingLinesDetails(props) {
    var _manager$pii, _manager$pii2;
    var fireAnalyticsWithDuration = props.fireAnalyticsWithDuration, _props$reportingLines = props.reportingLines, reportingLines = _props$reportingLines === void 0 ? {} : _props$reportingLines, reportingLinesProfileUrl = props.reportingLinesProfileUrl, onReportingLinesClick = props.onReportingLinesClick;
    var _reportingLines$manag = reportingLines.managers, managers = _reportingLines$manag === void 0 ? [] : _reportingLines$manag, _reportingLines$repor = reportingLines.reports, reports = _reportingLines$repor === void 0 ? [] : _reportingLines$repor;
    var manager = managers.length >= 1 ? managers[0] : undefined;
    var hasReports = reports.length > 0;
    var getReportingLinesOnClick = function getReportingLinesOnClick(user, userType) {
        return onReportingLinesClick ? function() {
            fireAnalyticsWithDuration(function(duration) {
                return (0, $18aOe.reportingLinesClicked)({
                    duration: duration,
                    userType: userType
                });
            });
            onReportingLinesClick(user);
        } : undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, manager && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $98qlh.ReportingLinesSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $98qlh.ReportingLinesHeading), {
        style: {
            marginBottom: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eygjM.default), (0, $iJFBU.default).managerSectionHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $98qlh.OffsetWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fVy1l.default), {
        appearance: "subtle",
        spacing: "none",
        href: $a4d4d31f43a6bd66$var$getProfileHref(manager.accountIdentifier, reportingLinesProfileUrl),
        onClick: getReportingLinesOnClick(manager, "manager"),
        isDisabled: !onReportingLinesClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $98qlh.ManagerSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $inFLm.default), {
        size: "xsmall",
        src: (_manager$pii = manager.pii) === null || _manager$pii === void 0 ? void 0 : _manager$pii.picture
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $98qlh.ManagerName), null, (_manager$pii2 = manager.pii) === null || _manager$pii2 === void 0 ? void 0 : _manager$pii2.name))))), hasReports && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $98qlh.ReportingLinesSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $98qlh.ReportingLinesHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eygjM.default), (0, $iJFBU.default).directReportsSectionHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $71gev.default), {
        appearance: "stack",
        size: "small",
        data: reports.map(function(member) {
            var _member$pii, _member$pii2;
            return {
                key: member.accountIdentifier,
                name: ((_member$pii = member.pii) === null || _member$pii === void 0 ? void 0 : _member$pii.name) || "",
                src: (_member$pii2 = member.pii) === null || _member$pii2 === void 0 ? void 0 : _member$pii2.picture,
                href: $a4d4d31f43a6bd66$var$getProfileHref(member.accountIdentifier, reportingLinesProfileUrl),
                onClick: getReportingLinesOnClick(member, "direct-report")
            };
        }),
        maxCount: 5,
        testId: "profilecard-reports-avatar-group"
    })));
};
var $a4d4d31f43a6bd66$export$2e2bcd8739ae039 = $a4d4d31f43a6bd66$var$ReportingLinesDetails;

});
parcelRegister("98qlh", function(module, exports) {

$parcel$export(module.exports, "ReportingLinesSection", function () { return $6a694b726e3517b2$export$ae48ddd79a45b949; });
$parcel$export(module.exports, "ReportingLinesHeading", function () { return $6a694b726e3517b2$export$abdd342d30bb5b5f; });
$parcel$export(module.exports, "ManagerSection", function () { return $6a694b726e3517b2$export$2992b481dad9fb03; });
$parcel$export(module.exports, "ManagerName", function () { return $6a694b726e3517b2$export$98f8ec89e658b052; });
$parcel$export(module.exports, "OffsetWrapper", function () { return $6a694b726e3517b2$export$56eae56612ce5f3; });

var $73D4V = parcelRequire("73D4V");

var $aP6k3 = parcelRequire("aP6k3");

var $bVB8f = parcelRequire("bVB8f");
var $6a694b726e3517b2$export$ae48ddd79a45b949 = (0, $73D4V.default).div({
    // Minor left margin to align better with existing icon fields
    marginLeft: "var(--ds-space-050, 4px)",
    marginTop: "var(--ds-space-100, 8px)"
});
var $6a694b726e3517b2$export$abdd342d30bb5b5f = (0, $73D4V.default).h3({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $bVB8f.appLabelTextColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: "".concat((0, $aP6k3.gridSize)() * 1.5, "px"),
    fontWeight: 600,
    marginBottom: "var(--ds-space-100, 8px)"
});
var $6a694b726e3517b2$export$2992b481dad9fb03 = (0, $73D4V.default).div({
    display: "flex",
    alignItems: "center",
    margin: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-050, 4px)")
});
var $6a694b726e3517b2$export$98f8ec89e658b052 = (0, $73D4V.default).span({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: "".concat((0, $aP6k3.gridSize)() * 1.5, "px"),
    marginLeft: "var(--ds-space-100, 8px)"
});
var $6a694b726e3517b2$export$56eae56612ce5f3 = (0, $73D4V.default).div({
    marginTop: "var(--ds-space-050, 4px)",
    // Offset left margin so the avatar aligns with the heading
    marginLeft: "var(--ds-space-negative-050, -4px)"
});

});




parcelRegister("61ItA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4635561bd5a7dcf7$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $kk7vA = parcelRequire("kk7vA");

var $9KQqc = parcelRequire("9KQqc");
var $atvDe = parcelRequire("atvDe");

var $4Zcnm = parcelRequire("4Zcnm");

var $7daq7 = parcelRequire("7daq7");

var $18aOe = parcelRequire("18aOe");
parcelRequire("2ib6V");
var $55gHa = parcelRequire("55gHa");

var $hXXuy = parcelRequire("hXXuy");

var $e9kJ1 = parcelRequire("e9kJ1");
function $4635561bd5a7dcf7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4635561bd5a7dcf7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4635561bd5a7dcf7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4635561bd5a7dcf7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4635561bd5a7dcf7$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $4635561bd5a7dcf7$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $4635561bd5a7dcf7$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4635561bd5a7dcf7$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $4635561bd5a7dcf7$var$ProfileCardResourced = /*#__PURE__*/ function(_React$PureComponent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(ProfileCardResourced, _React$PureComponent);
    var _super = $4635561bd5a7dcf7$var$_createSuper(ProfileCardResourced);
    function ProfileCardResourced() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ProfileCardResourced);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isMounted", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "state", {
            visible: false,
            isLoading: undefined,
            hasError: false,
            error: null,
            data: null,
            reportingLinesData: undefined,
            isKudosEnabled: false,
            kudosDrawerOpen: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fireAnalytics", function(payload) {
            // Don't fire analytics if the component is unmounted
            if (!_this._isMounted) return;
            if (_this.props.createAnalyticsEvent) (0, $18aOe.fireEvent)(_this.props.createAnalyticsEvent, payload);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clientFetchProfile", function() {
            var _this$props = _this.props, cloudId = _this$props.cloudId, userId = _this$props.userId;
            var isLoading = _this.state.isLoading;
            if (isLoading === true) // don't fetch data when fetching is in process
            return;
            _this.setState({
                isLoading: true,
                hasError: false,
                data: null
            }, function() {
                var requests = Promise.all([
                    _this.props.resourceClient.getProfile(cloudId, userId, _this.fireAnalytics),
                    _this.props.resourceClient.getReportingLines(userId),
                    _this.props.resourceClient.shouldShowGiveKudos()
                ]);
                requests.then(function(res) {
                    var _this2;
                    return (_this2 = _this).handleClientSuccess.apply(_this2, (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(res));
                }, function(err) {
                    return _this.handleClientError(err);
                }).catch(function(err) {
                    return _this.handleClientError(err);
                });
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "filterActions", function() {
            return (0, $4Zcnm.default)(_this.props.actions, _this.state.data);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "openKudosDrawer", function() {
            _this.setState({
                kudosDrawerOpen: true
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "closeKudosDrawer", function() {
            _this.setState({
                kudosDrawerOpen: false
            });
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ProfileCardResourced, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._isMounted = true;
                this.clientFetchProfile();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props2 = this.props, userId = _this$props2.userId, cloudId = _this$props2.cloudId, resourceClient = _this$props2.resourceClient;
                if (userId !== prevProps.userId || cloudId !== prevProps.cloudId || resourceClient !== prevProps.resourceClient) this.setState({
                    isLoading: undefined
                }, this.clientFetchProfile);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._isMounted = false;
            }
        },
        {
            key: "handleClientSuccess",
            value: function handleClientSuccess(profileData, reportingLinesData, shouldShowGiveKudos) {
                if (!this._isMounted) return;
                this.setState({
                    isLoading: false,
                    hasError: false,
                    data: profileData,
                    reportingLinesData: reportingLinesData,
                    isKudosEnabled: shouldShowGiveKudos
                });
            }
        },
        {
            key: "handleClientError",
            value: function handleClientError(err) {
                if (!this._isMounted) return;
                this.setState({
                    isLoading: false,
                    hasError: true,
                    error: err
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$state = this.state, isLoading = _this$state.isLoading, hasError = _this$state.hasError, error = _this$state.error, data = _this$state.data, reportingLinesData = _this$state.reportingLinesData, isKudosEnabled = _this$state.isKudosEnabled;
                var _this$props3 = this.props, onReportingLinesClick = _this$props3.onReportingLinesClick, cloudId = _this$props3.cloudId, userId = _this$props3.userId, addFlag = _this$props3.addFlag;
                var isFetchingOrNotStartToFetchYet = isLoading === true || isLoading === undefined;
                if (isFetchingOrNotStartToFetchYet) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.CardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $e9kJ1.default), {
                    fireAnalytics: this.fireAnalytics
                }));
                else if (hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.CardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $55gHa.default), {
                    errorType: error,
                    reload: this.clientFetchProfile,
                    fireAnalytics: this.fireAnalytics
                }));
                var newProps = $4635561bd5a7dcf7$var$_objectSpread($4635561bd5a7dcf7$var$_objectSpread({
                    hasError: hasError,
                    errorType: error,
                    clientFetchProfile: this.clientFetchProfile,
                    reportingLines: reportingLinesData,
                    onReportingLinesClick: onReportingLinesClick,
                    cloudId: cloudId,
                    userId: userId,
                    addFlag: addFlag
                }, data), {}, {
                    isKudosEnabled: isKudosEnabled,
                    teamCentralBaseUrl: this.props.resourceClient.getTeamCentralBaseUrl(),
                    openKudosDrawer: this.openKudosDrawer
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.CardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, isKudosEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Suspense), {
                    fallback: null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9KQqc.GiveKudosLauncherLazy), {
                    isOpen: this.state.kudosDrawerOpen,
                    recipient: {
                        type: (0, $atvDe.KudosType).INDIVIDUAL,
                        recipientId: this.props.userId
                    },
                    analyticsSource: "profile-card",
                    teamCentralBaseUrl: newProps.teamCentralBaseUrl,
                    cloudId: this.props.cloudId,
                    addFlag: this.props.addFlag,
                    onClose: this.closeKudosDrawer
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $hXXuy.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, newProps, {
                    actions: this.filterActions()
                }))));
            }
        }
    ]);
    return ProfileCardResourced;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).PureComponent);
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($4635561bd5a7dcf7$var$ProfileCardResourced, "defaultProps", {
    actions: []
});
var $4635561bd5a7dcf7$export$a6d9ff68ecba3be5 = $4635561bd5a7dcf7$var$ProfileCardResourced;
var $4635561bd5a7dcf7$export$2e2bcd8739ae039 = (0, $kk7vA.default)()($4635561bd5a7dcf7$var$ProfileCardResourced);

});
parcelRegister("e9kJ1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4d1fb8a3cccfa15$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $e9BTj = parcelRequire("e9BTj");

var $7daq7 = parcelRequire("7daq7");

var $18aOe = parcelRequire("18aOe");
var $a4d1fb8a3cccfa15$var$UserLoadingState = function UserLoadingState(_ref) {
    var fireAnalytics = _ref.fireAnalytics;
    (0, $9nHZC.useEffect)(function() {
        fireAnalytics((0, $18aOe.profileCardRendered)("user", "spinner"));
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.SpinnerContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $e9BTj.default), null));
};
var $a4d1fb8a3cccfa15$export$2e2bcd8739ae039 = $a4d1fb8a3cccfa15$var$UserLoadingState;

});


parcelRegister("4p6QA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $334eceefe7fbd959$export$2e2bcd8739ae039; });

var $lOQkO = parcelRequire("lOQkO");

var $fPPqr = parcelRequire("fPPqr");

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $kk7vA = parcelRequire("kk7vA");

var $9KQqc = parcelRequire("9KQqc");
var $atvDe = parcelRequire("atvDe");

var $dEQSq = parcelRequire("dEQSq");

var $93cMI = parcelRequire("93cMI");

var $aP6k3 = parcelRequire("aP6k3");

var $4Zcnm = parcelRequire("4Zcnm");

var $7daq7 = parcelRequire("7daq7");

var $18aOe = parcelRequire("18aOe");

var $fajw5 = parcelRequire("fajw5");

var $3VSpl = parcelRequire("3VSpl");

var $7u7wI = parcelRequire("7u7wI");

var $e9kJ1 = parcelRequire("e9kJ1");
var $334eceefe7fbd959$var$_excluded = [
    "ref"
];
function $334eceefe7fbd959$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $334eceefe7fbd959$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $334eceefe7fbd959$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $334eceefe7fbd959$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $334eceefe7fbd959$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $334eceefe7fbd959$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $334eceefe7fbd959$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($334eceefe7fbd959$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $334eceefe7fbd959$var$ProfilecardTrigger = /*#__PURE__*/ function(_React$PureComponent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(ProfilecardTrigger, _React$PureComponent);
    var _super = $334eceefe7fbd959$var$_createSuper(ProfilecardTrigger);
    function ProfilecardTrigger() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ProfilecardTrigger);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isMounted", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "showDelay", _this.props.trigger === "click" ? 0 : (0, $fajw5.DELAY_MS_SHOW));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "hideDelay", _this.props.trigger === "click" ? 0 : (0, $fajw5.DELAY_MS_HIDE));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "showTimer", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "hideTimer", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fireAnalytics", function(payload) {
            // Don't fire any analytics if the component is unmounted
            if (!_this._isMounted) return;
            if (_this.props.createAnalyticsEvent) (0, $18aOe.fireEvent)(_this.props.createAnalyticsEvent, payload);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "hideProfilecard", function() {
            clearTimeout(_this.showTimer);
            clearTimeout(_this.hideTimer);
            _this.hideTimer = window.setTimeout(function() {
                _this.setState({
                    visible: false
                });
            }, _this.hideDelay);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "showProfilecard", function() {
            clearTimeout(_this.hideTimer);
            clearTimeout(_this.showTimer);
            _this.showTimer = window.setTimeout(function() {
                if (!_this.state.visible) {
                    _this.clientFetchProfile();
                    _this.setState({
                        visible: true
                    });
                }
            }, _this.showDelay);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onClick", function(event) {
            // If the user clicks on the trigger then we don't want that click event to
            // propagate out to parent containers. For example when clicking a mention
            // lozenge in an inline-edit.
            event.stopPropagation();
            _this.showProfilecard();
            if (!_this.state.visible) _this.fireAnalytics((0, $18aOe.cardTriggered)("user", "click"));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onMouseEnter", function() {
            _this.showProfilecard();
            if (!_this.state.visible) _this.fireAnalytics((0, $18aOe.cardTriggered)("user", "hover"));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onKeyPress", function(event) {
            if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                _this.showProfilecard();
                if (!_this.state.visible) _this.fireAnalytics((0, $18aOe.cardTriggered)("user", "click"));
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onFocus", function() {
            _this.showProfilecard();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "containerListeners", _this.props.trigger === "hover" ? {
            onMouseEnter: _this.onMouseEnter,
            onMouseLeave: _this.hideProfilecard,
            onBlur: _this.hideProfilecard,
            onKeyPress: _this.onKeyPress
        } : {
            onClick: _this.onClick,
            onKeyPress: _this.onKeyPress
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "layerListeners", {
            handleClickOutside: _this.hideProfilecard,
            handleEscapeKeydown: _this.hideProfilecard
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "state", {
            visible: false,
            isLoading: undefined,
            hasError: false,
            error: null,
            data: null,
            reportingLinesData: undefined,
            shouldShowGiveKudos: false,
            teamCentralBaseUrl: undefined,
            kudosDrawerOpen: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clientFetchProfile", function() {
            var _this$props = _this.props, cloudId = _this$props.cloudId, userId = _this$props.userId;
            var isLoading = _this.state.isLoading;
            if (isLoading === true) // don't fetch data when fetching is in process
            return;
            _this.setState({
                teamCentralBaseUrl: _this.props.resourceClient.getTeamCentralBaseUrl()
            });
            _this.setState({
                isLoading: true,
                hasError: false,
                data: null
            }, function() {
                var requests = Promise.all([
                    _this.props.resourceClient.getProfile(cloudId || "", userId, _this.fireAnalytics),
                    _this.props.resourceClient.getReportingLines(userId),
                    _this.props.resourceClient.shouldShowGiveKudos()
                ]);
                requests.then(function(res) {
                    var _this2;
                    return (_this2 = _this).handleClientSuccess.apply(_this2, (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(res));
                }, function(err) {
                    return _this.handleClientError(err);
                }).catch(function(err) {
                    return _this.handleClientError(err);
                });
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "openKudosDrawer", function() {
            _this.hideProfilecard();
            _this.setState({
                kudosDrawerOpen: true
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "closeKudosDrawer", function() {
            _this.setState({
                kudosDrawerOpen: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "renderCard", function() {
            var isLoading = _this.state.isLoading;
            if (isLoading === true || isLoading === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.CardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $e9kJ1.default), {
                fireAnalytics: _this.fireAnalytics
            }));
            else return _this.renderProfileCard();
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ProfilecardTrigger, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._isMounted = true;
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props2 = this.props, userId = _this$props2.userId, cloudId = _this$props2.cloudId, resourceClient = _this$props2.resourceClient;
                var visible = this.state.visible;
                // just re-fetching data when the card opens
                if (visible && (userId !== prevProps.userId || cloudId !== prevProps.cloudId || resourceClient !== prevProps.resourceClient)) this.setState({
                    isLoading: undefined
                }, this.clientFetchProfile);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._isMounted = false;
                clearTimeout(this.showTimer);
                clearTimeout(this.hideTimer);
            }
        },
        {
            key: "handleClientSuccess",
            value: function handleClientSuccess(profileData, reportingLinesData, shouldShowGiveKudos) {
                if (!this._isMounted) return;
                this.setState({
                    isLoading: false,
                    hasError: false,
                    data: profileData,
                    reportingLinesData: reportingLinesData,
                    shouldShowGiveKudos: shouldShowGiveKudos
                });
            }
        },
        {
            key: "handleClientError",
            value: function handleClientError(err) {
                if (!this._isMounted) return;
                this.setState({
                    isLoading: false,
                    hasError: true,
                    error: err
                });
            }
        },
        {
            key: "filterActions",
            value: function filterActions() {
                return (0, $4Zcnm.default)(this.props.actions, this.state.data);
            }
        },
        {
            key: "renderProfileCard",
            value: function renderProfileCard() {
                var _this$state$data;
                var newProps = $334eceefe7fbd959$var$_objectSpread($334eceefe7fbd959$var$_objectSpread({
                    userId: this.props.userId,
                    isCurrentUser: (_this$state$data = this.state.data) === null || _this$state$data === void 0 ? void 0 : _this$state$data.isCurrentUser,
                    clientFetchProfile: this.clientFetchProfile
                }, this.state.data), {}, {
                    reportingLines: this.state.reportingLinesData,
                    onReportingLinesClick: this.props.onReportingLinesClick,
                    isKudosEnabled: this.state.shouldShowGiveKudos,
                    teamCentralBaseUrl: this.state.teamCentralBaseUrl,
                    cloudId: this.props.cloudId,
                    openKudosDrawer: this.openKudosDrawer
                });
                var wrapperProps = this.props.trigger === "hover" ? {
                    onMouseEnter: this.onMouseEnter,
                    onMouseLeave: this.hideProfilecard,
                    onFocus: this.onFocus
                } : {};
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", wrapperProps, this.state.visible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Suspense), {
                    fallback: null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3VSpl.ProfileCardLazy), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, newProps, {
                    actions: this.filterActions(),
                    hasError: this.state.hasError,
                    errorType: this.state.error,
                    withoutElevation: true
                }))));
            }
        },
        {
            key: "renderWithTrigger",
            value: function renderWithTrigger() {
                var _this3 = this;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $93cMI.default), {
                    isOpen: !!this.state.visible,
                    onClose: this.hideProfilecard,
                    placement: this.props.position,
                    content: this.renderCard,
                    trigger: function trigger(triggerProps) {
                        var ref = triggerProps.ref, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(triggerProps, $334eceefe7fbd959$var$_excluded);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, innerProps, _this3.containerListeners, {
                            ref: ref,
                            "data-testid": _this3.props.testId,
                            role: "button",
                            tabIndex: 0
                        }), _this3.props.children);
                    },
                    zIndex: (0, $aP6k3.layers).modal(),
                    shouldUseCaptureOnOutsideClick: true,
                    autoFocus: this.props.trigger === "click"
                }), this.state.shouldShowGiveKudos && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Suspense), {
                    fallback: null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9KQqc.GiveKudosLauncherLazy), {
                    isOpen: this.state.kudosDrawerOpen,
                    recipient: {
                        type: (0, $atvDe.KudosType).INDIVIDUAL,
                        recipientId: this.props.userId
                    },
                    analyticsSource: "profile-card",
                    teamCentralBaseUrl: this.state.teamCentralBaseUrl,
                    cloudId: this.props.cloudId,
                    addFlag: this.props.addFlag,
                    onClose: this.closeKudosDrawer
                })));
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.props.children) return this.renderWithTrigger();
                else throw new Error('Component "ProfileCardTrigger" must have "children" property');
            }
        }
    ]);
    return ProfilecardTrigger;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).PureComponent);
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($334eceefe7fbd959$var$ProfilecardTrigger, "defaultProps", {
    actions: [],
    trigger: "hover",
    position: "bottom-start"
});
var $334eceefe7fbd959$var$ProfilecardTriggerLegacy = (0, $kk7vA.default)()($334eceefe7fbd959$var$ProfilecardTrigger);
function $334eceefe7fbd959$export$2e2bcd8739ae039(props) {
    return (0, $dEQSq.getBooleanFF)("platform.profile-card-trigger-next") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7u7wI.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        onVisibilityChange: function onVisibilityChange(isVisible) {
            if (props.onVisibilityChange) props.onVisibilityChange(isVisible);
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($334eceefe7fbd959$var$ProfilecardTriggerLegacy, props);
}

});
parcelRegister("3VSpl", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLazy", function () { return $2dd0e63a5f7b8e5f$export$403d297463f226af; });

var $9nHZC = parcelRequire("9nHZC");

var $2dd0e63a5f7b8e5f$export$403d297463f226af = /*#__PURE__*/ (0, $9nHZC.lazy)(function() {
    return Promise.resolve((parcelRequire("hXXuy")));
});

});

parcelRegister("7u7wI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57312c5d64f3d21f$export$2e2bcd8739ae039; });

var $lOQkO = parcelRequire("lOQkO");

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $b4Ivn = parcelRequire("b4Ivn");

var $4mVfk = parcelRequire("4mVfk");

var $9q1kH = parcelRequire("9q1kH");

var $8DpVo = parcelRequire("8DpVo");

var $9nHZC = parcelRequire("9nHZC");

var $b7ZcK = parcelRequire("b7ZcK");

var $kWcTk = parcelRequire("kWcTk");

var $9KQqc = parcelRequire("9KQqc");
var $atvDe = parcelRequire("atvDe");

var $93cMI = parcelRequire("93cMI");

var $aP6k3 = parcelRequire("aP6k3");

var $4Zcnm = parcelRequire("4Zcnm");

var $3acJy = parcelRequire("3acJy");

var $7daq7 = parcelRequire("7daq7");

var $18aOe = parcelRequire("18aOe");

var $fajw5 = parcelRequire("fajw5");

var $3VSpl = parcelRequire("3VSpl");

var $e9kJ1 = parcelRequire("e9kJ1");
var $57312c5d64f3d21f$var$_excluded = [
    "ref"
], $57312c5d64f3d21f$var$_excluded2 = [
    "aria-expanded",
    "aria-haspopup"
];
function $57312c5d64f3d21f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $57312c5d64f3d21f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $57312c5d64f3d21f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $57312c5d64f3d21f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $57312c5d64f3d21f$export$2e2bcd8739ae039(_ref) {
    var _ref$trigger = _ref.trigger, trigger = _ref$trigger === void 0 ? "hover" : _ref$trigger, userId = _ref.userId, cloudId = _ref.cloudId, resourceClient = _ref.resourceClient, _ref$actions = _ref.actions, actions = _ref$actions === void 0 ? [] : _ref$actions, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom-start" : _ref$position, children = _ref.children, testId = _ref.testId, addFlag = _ref.addFlag, onReportingLinesClick = _ref.onReportingLinesClick, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, prepopulatedData = _ref.prepopulatedData, disabledAriaAttributes = _ref.disabledAriaAttributes, onVisibilityChange = _ref.onVisibilityChange;
    var _useAnalyticsEvents = (0, $kWcTk.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var _useIntl = (0, $b7ZcK.default)(), formatMessage = _useIntl.formatMessage;
    var _useState = (0, $9nHZC.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), isMounted = _useState2[0], setIsMounted = _useState2[1];
    var showDelay = trigger === "click" ? 0 : (0, $fajw5.DELAY_MS_SHOW);
    var hideDelay = trigger === "click" ? 0 : (0, $fajw5.DELAY_MS_HIDE);
    var showTimer = (0, $9nHZC.useRef)(0);
    var hideTimer = (0, $9nHZC.useRef)(0);
    var _useState3 = (0, $9nHZC.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState3, 2), visible = _useState4[0], setVisible = _useState4[1];
    var _useState5 = (0, $9nHZC.useState)(undefined), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $9nHZC.useState)(false), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState7, 2), hasError = _useState8[0], setHasError = _useState8[1];
    var _useState9 = (0, $9nHZC.useState)(null), _useState10 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState9, 2), error = _useState10[0], setError = _useState10[1];
    var _useState11 = (0, $9nHZC.useState)(null), _useState12 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState11, 2), data = _useState12[0], setData = _useState12[1];
    var _useState13 = (0, $9nHZC.useState)(undefined), _useState14 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState13, 2), reportingLinesData = _useState14[0], setReportingLinesData = _useState14[1];
    var _useState15 = (0, $9nHZC.useState)(false), _useState16 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState15, 2), shouldShowGiveKudos = _useState16[0], setShouldShowGiveKudos = _useState16[1];
    var _useState17 = (0, $9nHZC.useState)(undefined), _useState18 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState17, 2), teamCentralBaseUrl = _useState18[0], setTeamCentralBaseUrl = _useState18[1];
    var _useState19 = (0, $9nHZC.useState)(false), _useState20 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState19, 2), kudosDrawerOpen = _useState20[0], setKudosDrawerOpen = _useState20[1];
    var _useState21 = (0, $9nHZC.useState)(false), _useState22 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState21, 2), isTriggeredUsingKeyboard = _useState22[0], setTriggeredUsingKeyboard = _useState22[1];
    var triggerRef = (0, $9nHZC.useRef)(null);
    (0, $9nHZC.useEffect)(function() {
        setIsMounted(true);
        return function() {
            setIsMounted(false);
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $9nHZC.useEffect)(function() {
        // Reset state when the userId changes
        setIsLoading(undefined);
        setHasError(false);
        setError(null);
        setData(null);
        setReportingLinesData(undefined);
        setShouldShowGiveKudos(false);
        setTeamCentralBaseUrl(undefined);
    }, [
        userId
    ]);
    var fireAnalytics = (0, $9nHZC.useCallback)(function(payload) {
        // Don't fire any analytics if the component is unmounted
        if (!isMounted) return;
        (0, $18aOe.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent,
        isMounted
    ]);
    var hideProfilecard = (0, $9nHZC.useCallback)(function() {
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(function() {
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, hideDelay);
    }, [
        hideDelay,
        isTriggeredUsingKeyboard,
        onVisibilityChange
    ]);
    var handleKeyboardClose = (0, $9nHZC.useCallback)(function(event) {
        if (event.key && event.key !== "Escape") return;
        if (triggerRef.current) triggerRef.current.focus();
        setTriggeredUsingKeyboard(false);
        setVisible(false);
        onVisibilityChange && onVisibilityChange(false);
    }, [
        setTriggeredUsingKeyboard,
        setVisible,
        onVisibilityChange
    ]);
    var handleClientSuccess = (0, $9nHZC.useCallback)(function(profileData, reportingLinesData, shouldShowGiveKudos) {
        if (!isMounted) return;
        setIsLoading(false);
        setHasError(false);
        setData(profileData);
        setReportingLinesData(reportingLinesData);
        setShouldShowGiveKudos(shouldShowGiveKudos);
    }, [
        isMounted,
        setHasError,
        setIsLoading,
        setData,
        setReportingLinesData,
        setShouldShowGiveKudos
    ]);
    var handleClientError = (0, $9nHZC.useCallback)(function(err) {
        if (!isMounted) return;
        setIsLoading(false);
        setHasError(true);
        setError(err);
    }, [
        isMounted,
        setHasError,
        setIsLoading,
        setError
    ]);
    var clientFetchProfile = (0, $9nHZC.useCallback)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee() {
        var requests, responses;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(isLoading === true)) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    setTeamCentralBaseUrl(resourceClient.getTeamCentralBaseUrl());
                    setIsLoading(true);
                    setHasError(false);
                    setError(null);
                    setData(null);
                    _context.prev = 7;
                    requests = Promise.all([
                        resourceClient.getProfile(cloudId || "", userId, fireAnalytics),
                        resourceClient.getReportingLines(userId),
                        resourceClient.shouldShowGiveKudos()
                    ]);
                    _context.next = 11;
                    return requests;
                case 11:
                    responses = _context.sent;
                    handleClientSuccess.apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(responses));
                    _context.next = 18;
                    break;
                case 15:
                    _context.prev = 15;
                    _context.t0 = _context["catch"](7);
                    handleClientError(_context.t0);
                case 18:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                7,
                15
            ]
        ]);
    })), [
        cloudId,
        fireAnalytics,
        isLoading,
        resourceClient,
        userId,
        handleClientSuccess,
        handleClientError
    ]);
    var showProfilecard = (0, $9nHZC.useCallback)(function() {
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(function() {
            if (!visible) {
                clientFetchProfile();
                setVisible(true);
                onVisibilityChange && onVisibilityChange(true);
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        clientFetchProfile,
        onVisibilityChange
    ]);
    var onClick = (0, $9nHZC.useCallback)(function(event) {
        // If the user clicks on the trigger then we don't want that click event to
        // propagate out to parent containers. For example when clicking a mention
        // lozenge in an inline-edit.
        event.stopPropagation();
        showProfilecard();
        if (!visible) fireAnalytics((0, $18aOe.cardTriggered)("user", "click"));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    var onMouseEnter = (0, $9nHZC.useCallback)(function() {
        showProfilecard();
        if (!visible) fireAnalytics((0, $18aOe.cardTriggered)("user", "hover"));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    var onKeyPress = (0, $9nHZC.useCallback)(function(event) {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            setTriggeredUsingKeyboard(true);
            showProfilecard();
            if (!visible) fireAnalytics((0, $18aOe.cardTriggered)("user", "click"));
        }
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    var onFocus = (0, $9nHZC.useCallback)(function() {
        showProfilecard();
    }, [
        showProfilecard
    ]);
    var containerListeners = (0, $9nHZC.useMemo)(function() {
        return trigger === "hover" ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        };
    }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    var filterActions = (0, $9nHZC.useCallback)(function() {
        return (0, $4Zcnm.default)(actions, data);
    }, [
        actions,
        data
    ]);
    var openKudosDrawer = function openKudosDrawer() {
        hideProfilecard();
        setKudosDrawerOpen(true);
    };
    var closeKudosDrawer = function closeKudosDrawer() {
        setKudosDrawerOpen(false);
    };
    var showLoading = isLoading === true || isLoading === undefined;
    var wrapperProps = (0, $9nHZC.useMemo)(function() {
        return trigger === "hover" ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onFocus: onFocus
        } : {};
    }, [
        hideProfilecard,
        onFocus,
        onMouseEnter,
        trigger
    ]);
    var profilecardProps = $57312c5d64f3d21f$var$_objectSpread($57312c5d64f3d21f$var$_objectSpread({
        userId: userId,
        fullName: prepopulatedData === null || prepopulatedData === void 0 ? void 0 : prepopulatedData.fullName,
        isCurrentUser: data === null || data === void 0 ? void 0 : data.isCurrentUser,
        clientFetchProfile: clientFetchProfile
    }, data), {}, {
        reportingLines: reportingLinesData,
        onReportingLinesClick: onReportingLinesClick,
        isKudosEnabled: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        openKudosDrawer: openKudosDrawer,
        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
        disabledAriaAttributes: disabledAriaAttributes
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $93cMI.default), {
        isOpen: !!visible,
        onClose: function onClose(event) {
            hideProfilecard();
            handleKeyboardClose(event);
        },
        placement: position,
        content: function content() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", wrapperProps, showLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($57312c5d64f3d21f$var$LoadingView, {
                fireAnalytics: fireAnalytics
            }) : visible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Suspense), {
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3VSpl.ProfileCardLazy), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, profilecardProps, {
                actions: filterActions(),
                hasError: hasError,
                errorType: error,
                withoutElevation: true
            }))));
        },
        trigger: function trigger(triggerProps) {
            var callbackRef = triggerProps.ref, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(triggerProps, $57312c5d64f3d21f$var$_excluded);
            var ref = function ref(element) {
                triggerRef.current = element;
                if (typeof callbackRef === "function") callbackRef(element);
            };
            var _ = innerProps["aria-expanded"], __ = innerProps["aria-haspopup"], restInnerProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(innerProps, $57312c5d64f3d21f$var$_excluded2);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, disabledAriaAttributes ? restInnerProps : triggerProps, containerListeners, {
                ref: ref,
                "data-testid": testId,
                "aria-labelledby": ariaLabelledBy
            }, disabledAriaAttributes ? {} : {
                role: "button",
                tabIndex: 0,
                "aria-label": (0, $3acJy.default)(ariaLabel, profilecardProps.fullName, formatMessage)
            }), children);
        },
        zIndex: (0, $aP6k3.layers).modal(),
        shouldUseCaptureOnOutsideClick: true,
        autoFocus: trigger === "click"
    }), shouldShowGiveKudos && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9KQqc.GiveKudosLauncherLazy), {
        isOpen: kudosDrawerOpen,
        recipient: {
            type: (0, $atvDe.KudosType).INDIVIDUAL,
            recipientId: userId
        },
        analyticsSource: "profile-card",
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        addFlag: addFlag,
        onClose: closeKudosDrawer
    })));
}
var $57312c5d64f3d21f$var$LoadingView = function LoadingView(_ref3) {
    var fireAnalytics = _ref3.fireAnalytics;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7daq7.CardWrapper), {
        "data-testId": "profilecard.profilecardtrigger.loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $e9kJ1.default), {
        fireAnalytics: fireAnalytics
    }));
};

});
parcelRegister("3acJy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24dc2ee748dd0741$export$2e2bcd8739ae039; });

var $dLdNR = parcelRequire("dLdNR");
var $24dc2ee748dd0741$var$getLabelMessage = function getLabelMessage(ariaLabelProp, fullName, formatMessage) {
    if (ariaLabelProp) return ariaLabelProp;
    return fullName ? formatMessage($24dc2ee748dd0741$var$messages.label, {
        fullName: fullName
    }) : formatMessage($24dc2ee748dd0741$var$messages.fallbackLabel);
};
var $24dc2ee748dd0741$var$messages = (0, $dLdNR.defineMessages)({
    fallbackLabel: {
        id: "profilecard.user.trigger.fallback-aria-label",
        defaultMessage: "More information about this user",
        description: "Label for profile card trigger when we do not have user name"
    },
    label: {
        id: "profilecard.user.trigger.aria-label",
        defaultMessage: "More information about {fullName}",
        description: "Label for profile card trigger"
    }
});
var $24dc2ee748dd0741$export$2e2bcd8739ae039 = $24dc2ee748dd0741$var$getLabelMessage;

});



parcelRegister("jYw1e", function(module, exports) {

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $lnOmc = parcelRequire("lnOmc");
function $e8ac753283a0189e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e8ac753283a0189e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $e8ac753283a0189e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e8ac753283a0189e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $e8ac753283a0189e$export$2e2bcd8739ae039(Component) {
    return /*#__PURE__*/ function(_React$PureComponent) {
        (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(WithOuterListeners, _React$PureComponent);
        var _super = $e8ac753283a0189e$var$_createSuper(WithOuterListeners);
        function WithOuterListeners() {
            var _this;
            (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, WithOuterListeners);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleClick", function(evt) {
                var handleClickOutside = _this.props.handleClickOutside;
                if (handleClickOutside) {
                    var domNode = (0, (/*@__PURE__*/$parcel$interopDefault($lnOmc))).findDOMNode((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this)); // eslint-disable-line react/no-find-dom-node
                    if (!domNode || evt.target instanceof Node && !domNode.contains(evt.target)) handleClickOutside();
                }
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "handleKeydown", function(evt) {
                var handleEscapeKeydown = _this.props.handleEscapeKeydown;
                if (handleEscapeKeydown && evt.code === "Escape") handleEscapeKeydown();
            });
            return _this;
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(WithOuterListeners, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (this.props.handleClickOutside) document.addEventListener("click", this.handleClick, false);
                    if (this.props.handleEscapeKeydown) document.addEventListener("keydown", this.handleKeydown, false);
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (this.props.handleClickOutside) document.removeEventListener("click", this.handleClick, false);
                    if (this.props.handleEscapeKeydown) document.removeEventListener("keydown", this.handleKeydown, false);
                }
            },
            {
                key: "render",
                value: function render() {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Component, this.props);
                }
            }
        ]);
        return WithOuterListeners;
    }((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).PureComponent);
}

});



parcelRegister("ktkU5", function(module, exports) {

$parcel$export(module.exports, "getActions", function () { return $8cd1f7bd633ddda1$export$fe3955935f564b31; });
$parcel$export(module.exports, "default", function () { return $8cd1f7bd633ddda1$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");
parcelRequire("9GYuS");
var $4p6QA = parcelRequire("4p6QA");

var $8ky9z = parcelRequire("8ky9z");
const $8cd1f7bd633ddda1$export$fe3955935f564b31 = (config)=>[
        {
            callback: ()=>window.open(config.profileUrl || "", "_blank"),
            // @ts-ignore @atlaskit/profilecard hasn't updated their TS interface for actions
            id: "view-profile",
            label: config.intl.formatMessage((0, $8ky9z.default).viewProfileAction),
            shouldRender: (data)=>!!config.profileUrl && (!data || !data.hideProfileLink)
        }
    ];
class $8cd1f7bd633ddda1$var$UserProfileCardTrigger extends (0, $9nHZC.PureComponent) {
    render() {
        const { intl: intl, profileUrl: profileUrl } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $4p6QA.default), {
            actions: $8cd1f7bd633ddda1$export$fe3955935f564b31({
                intl: intl,
                profileUrl: profileUrl
            }),
            cloudId: "null",
            position: this.props.position,
            resourceClient: this.props.profileClient,
            trigger: this.props.trigger,
            userId: this.props.userId,
            testId: "profileCardTrigger"
        }, this.props.children);
    }
}
var $8cd1f7bd633ddda1$export$2e2bcd8739ae039 = (0, $agjvf.injectIntl)($8cd1f7bd633ddda1$var$UserProfileCardTrigger);

});


parcelRegister("1u8Rx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d3d5ec05398059e$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $fSOMa = parcelRequire("fSOMa");

var $13vgM = parcelRequire("13vgM");

var $ktkU5 = parcelRequire("ktkU5");
var $8d3d5ec05398059e$export$2e2bcd8739ae039;
$8d3d5ec05398059e$export$2e2bcd8739ae039 = class DeletedUserName extends (0, $9nHZC.PureComponent) {
    render() {
        const { hasProfileCard: hasProfileCard, profileCardPosition: profileCardPosition, profileCardTrigger: profileCardTrigger } = this.props;
        const name = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $13vgM.default), {
            user: undefined
        });
        if (!hasProfileCard) return name;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ktkU5.default), {
            position: profileCardPosition,
            profileClient: (0, $fSOMa.deletedUserProfileClient),
            trigger: profileCardTrigger,
            userId: "null"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", null, name));
    }
};

});
parcelRegister("13vgM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3683188e884bb9d6$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $c4Bvq = parcelRequire("c4Bvq");
class $3683188e884bb9d6$var$UserName extends (0, $9nHZC.PureComponent) {
    render() {
        return (0, $c4Bvq.getName)(this.props.user, this.props.intl);
    }
}
var $3683188e884bb9d6$export$2e2bcd8739ae039 = (0, $agjvf.injectIntl)($3683188e884bb9d6$var$UserName);

});


parcelRegister("chrxx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6b7927e342e68be$export$2e2bcd8739ae039; });
parcelRequire("9GYuS");
var $buNoC = parcelRequire("buNoC");
var $eVRiQ = parcelRequire("eVRiQ");

var $huKdv = parcelRequire("huKdv");
var $d6b7927e342e68be$export$2e2bcd8739ae039;
$d6b7927e342e68be$export$2e2bcd8739ae039 = class ProfileClient extends (0, $buNoC.default) {
    constructor(config, clients){
        const extendedConfig = {
            ...config,
            url: ""
        };
        const { fetchUser: fetchUser, onError: onError, ...profileConfig } = extendedConfig;
        super({
            ...profileConfig
        });
        // Setting userClient to our UserClient, so the consumer would not have to use it
        this.userClient = new (0, $huKdv.default)(extendedConfig);
        // Following AK's API for teamClient as we have not implemented this yet
        this.teamClient = (clients === null || clients === void 0 ? void 0 : clients.teamClient) || new (0, $eVRiQ.default)(profileConfig);
    }
};

});
parcelRegister("huKdv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65cb11eb577b0df0$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");
parcelRequire("9GYuS");
var $689He = parcelRequire("689He");

var $8ky9z = parcelRequire("8ky9z");
const $65cb11eb577b0df0$export$a5debb1a7a359dee = (0, $agjvf.defineMessages)({
    repositoryAccessToken: {
        "id": "frontbucket.components.userProfile.appUserKind.repositoryAccessToken",
        "defaultMessage": "Repository Access Token"
    },
    projectAccessToken: {
        "id": "frontbucket.components.userProfile.appUserKind.projectAccessToken",
        "defaultMessage": "Project Access Token"
    },
    workspaceAccessToken: {
        "id": "frontbucket.components.userProfile.appUserKind.workspaceAccessToken",
        "defaultMessage": "Workspace Access Token"
    },
    forgeApp: {
        "id": "frontbucket.components.userProfile.appUserKind.forgeApp",
        "defaultMessage": "Forge App"
    },
    unknownAppUser: {
        "id": "frontbucket.components.userProfile.appUserKind.unknownAppUser",
        "defaultMessage": "Unknown App User"
    }
});
var $65cb11eb577b0df0$export$2e2bcd8739ae039;
$65cb11eb577b0df0$export$2e2bcd8739ae039 = class UserClient extends (0, $689He.default) {
    constructor(extendedConfig){
        const { fetchUser: fetchUser, onError: onError, ...config } = extendedConfig;
        super({
            ...config,
            url: ""
        });
        this.bbConfig = void 0;
        this.bbConfig = {
            fetchUser: fetchUser,
            onError: onError
        };
    }
    getReadableAppUserKind(kind) {
        switch(kind){
            case "repository_access_token":
                return $65cb11eb577b0df0$export$a5debb1a7a359dee.repositoryAccessToken;
            case "project_access_token":
                return $65cb11eb577b0df0$export$a5debb1a7a359dee.projectAccessToken;
            case "workspace_access_token":
                return $65cb11eb577b0df0$export$a5debb1a7a359dee.workspaceAccessToken;
            case "forge_app":
                return $65cb11eb577b0df0$export$a5debb1a7a359dee.forgeApp;
            default:
                return $65cb11eb577b0df0$export$a5debb1a7a359dee.unknownAppUser;
        }
    }
    transformUser(user) {
        if (user.type === "team") return {
            disabledAccountMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, $8ky9z.default).teamProfileCardMessage),
            fullName: user.display_name,
            status: "inactive",
            hasDisabledAccountLozenge: false,
            isBot: false,
            isNotMentionable: true
        };
        if (user.account_status === "UNKNOWN") throw new Error();
        if (user.type === "app_user") {
            const appUser = user;
            const appUserLozenges = [
                {
                    text: "APP USER",
                    appearance: "new"
                }
            ];
            if (user.account_status === "inactive") appUserLozenges.push({
                text: "DEACTIVATED",
                appearance: "default"
            });
            const userKindMessage = this.getReadableAppUserKind(appUser.kind);
            return {
                fullName: appUser.display_name,
                status: "active",
                // use 'active' status so that we can show `meta` details
                meta: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), userKindMessage),
                isBot: false,
                // use isBot is false so that we can show `meta` details
                isNotMentionable: true,
                avatarUrl: appUser.links.avatar.href,
                customLozenges: appUserLozenges
            };
        }
        if (!user.account_id) return {
            disabledAccountMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, $8ky9z.default).unmigratedAtlassianAccountProfileCardMessage),
            fullName: user.display_name,
            status: "inactive",
            hasDisabledAccountLozenge: false,
            hideProfileLink: true,
            isBot: false,
            isNotMentionable: true
        };
        // Attempt to generate a timestring based on the `zoneinfo` field, which can be
        // a value that is not IANA-compliant (meaning not supported by `Intl.DateTimeFormat`)
        let timestring;
        if (user.zoneinfo) try {
            timestring = new Intl.DateTimeFormat(undefined, {
                timeZone: user.zoneinfo,
                hour: "numeric",
                minute: "numeric",
                weekday: "short"
            }).format(Date.now());
        } catch (e) {
            if (this.bbConfig.onError) this.bbConfig.onError(e);
        }
        let companyName = user.organization || user.department || undefined;
        if (user.organization && user.department) companyName = `${user.organization} (${user.department})`;
        const commonFields = {
            isBot: false,
            isNotMentionable: false,
            avatarUrl: user.links.avatar.href,
            companyName: companyName,
            fullName: user.display_name,
            location: user.location ? user.location : undefined,
            status: user.account_status ? user.account_status : "inactive",
            timestring: timestring
        };
        // omit `nickname` so the profile card doesn't render it in parens beside `fullName`
        // pass it as `meta` instead to render beneath where the job title would normally go
        if (user.display_name !== user.nickname) return {
            ...commonFields,
            meta: user.nickname
        };
        return {
            ...commonFields,
            nickname: user.nickname
        };
    }
    makeRequest(_cloudId, userId) {
        return this.bbConfig.fetchUser(userId).then(this.transformUser.bind(this));
    }
};

});


parcelRegister("9aLiF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e26bfd12e5744f92$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $inFLm = parcelRequire("inFLm");

var $a7iuM = parcelRequire("a7iuM");

var $8ky9z = parcelRequire("8ky9z");

var $iQBfK = parcelRequire("iQBfK");
class $e26bfd12e5744f92$var$UnmatchedCommitAuthorAvatar extends (0, $9nHZC.PureComponent) {
    render() {
        const { intl: intl, rawCommitAuthor: rawCommitAuthor, ...avatarProps } = this.props;
        const parsedCommitAuthor = (0, $iQBfK.parseCommitAuthor)(rawCommitAuthor);
        const tooltip = !parsedCommitAuthor ? intl.formatMessage((0, $8ky9z.default).unmatchedUnknownCommitAuthorTooltip) : intl.formatMessage((0, $8ky9z.default).unmatchedCommitAuthorTooltip, {
            commitAuthor: parsedCommitAuthor
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $a7iuM.default), {
            content: tooltip
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $inFLm.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, avatarProps, {
            name: tooltip
        })));
    }
}
var $e26bfd12e5744f92$export$2e2bcd8739ae039 = (0, $agjvf.injectIntl)($e26bfd12e5744f92$var$UnmatchedCommitAuthorAvatar);

});
parcelRegister("iQBfK", function(module, exports) {

$parcel$export(module.exports, "parseCommitAuthor", function () { return $c3e91d7a16372c28$export$20e3e53b53a62a93; });
$parcel$export(module.exports, "default", function () { return $c3e91d7a16372c28$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $a7iuM = parcelRequire("a7iuM");

var $8ky9z = parcelRequire("8ky9z");
const $c3e91d7a16372c28$var$authorEmailRegex = /<.*>$/;
const $c3e91d7a16372c28$export$20e3e53b53a62a93 = (rawCommitAuthor)=>{
    if (rawCommitAuthor === undefined) return undefined;
    const unknownAuthor = ""; // show blank if raw commit author is not present
    if (!rawCommitAuthor.trim()) return unknownAuthor;
    const name = rawCommitAuthor.replace($c3e91d7a16372c28$var$authorEmailRegex, "").trim();
    return name.trim() || unknownAuthor;
};
class $c3e91d7a16372c28$var$UnmatchedCommitAuthorName extends (0, $9nHZC.PureComponent) {
    render() {
        const { disableTooltip: disableTooltip, rawCommitAuthor: rawCommitAuthor } = this.props;
        const text = $c3e91d7a16372c28$export$20e3e53b53a62a93(rawCommitAuthor);
        if (!text) return null;
        if (disableTooltip) return text;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $a7iuM.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, $8ky9z.default).unmatchedUnknownCommitAuthorTooltip),
            position: "bottom",
            tag: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", null, text));
    }
}
$c3e91d7a16372c28$var$UnmatchedCommitAuthorName.defaultProps = {
    disableTooltip: false
};
var $c3e91d7a16372c28$export$2e2bcd8739ae039 = $c3e91d7a16372c28$var$UnmatchedCommitAuthorName;

});


parcelRegister("cgdUo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50711ce3885aa81a$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $a7iuM = parcelRequire("a7iuM");

var $eR8ER = parcelRequire("eR8ER");

var $ktkU5 = parcelRequire("ktkU5");

var $c4Bvq = parcelRequire("c4Bvq");
var $50711ce3885aa81a$export$2e2bcd8739ae039;
$50711ce3885aa81a$export$2e2bcd8739ae039 = class UserAvatar extends (0, $9nHZC.PureComponent) {
    render() {
        const { profileCardPosition: profileCardPosition, profileCardTrigger: profileCardTrigger, profileClient: profileClient, profileUrl: profileUrl, renderName: renderName, user: user, ...avatarProps } = this.props;
        const avatar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eR8ER.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, avatarProps, {
            renderName: renderName,
            user: user
        }));
        if (!profileClient) {
            const name = renderName((0, $c4Bvq.getName)(user));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $a7iuM.default), {
                content: name
            }, avatar);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ktkU5.default), {
            position: profileCardPosition,
            profileUrl: profileUrl,
            profileClient: profileClient,
            trigger: profileCardTrigger,
            userId: user.uuid
        }, avatar);
    }
};
$50711ce3885aa81a$export$2e2bcd8739ae039.defaultProps = {
    renderName: (name)=>name
};

});

parcelRegister("bJvZh", function(module, exports) {

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $7doh5 = parcelRequire("7doh5");

var $8ky9z = parcelRequire("8ky9z");
function $4fad34a088f438ab$var$isUser(userType) {
    return !!userType && userType.type === "user";
}
class $4fad34a088f438ab$var$UserStatusLozenge extends (0, $9nHZC.PureComponent) {
    getStatus() {
        const { intl: intl, user: user } = this.props;
        if (!user) return intl.formatMessage((0, $8ky9z.default).statusLabelDeleted);
        if ($4fad34a088f438ab$var$isUser(user) && user.account_status === "inactive") return intl.formatMessage((0, $8ky9z.default).statusLabelDeactivated);
        if ($4fad34a088f438ab$var$isUser(user) && user.account_status === "closed") return intl.formatMessage((0, $8ky9z.default).statusLabelDeleted);
        return undefined;
    }
    render() {
        const status = this.getStatus();
        return status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7doh5.default), null, status) : null;
    }
}
var $4fad34a088f438ab$export$2e2bcd8739ae039 = (0, $agjvf.injectIntl)($4fad34a088f438ab$var$UserStatusLozenge);

});



parcelRegister("7ncoz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1ec3e18df7ddd35$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $inFLm = parcelRequire("inFLm");

var $dm41H = parcelRequire("dm41H");

var $aILep = parcelRequire("aILep");
const $f1ec3e18df7ddd35$var$WorkspaceIcon = ({ workspace: workspace, intl: intl })=>{
    const src = workspace ? workspace.links.avatar.href : undefined;
    const altText = workspace ? intl.formatMessage((0, $aILep.default).workspaceBreadcrumbsAvatarAltText, {
        workspaceName: workspace.name
    }) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dm41H.Icon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $inFLm.default), {
        size: "xsmall",
        appearance: "square",
        src: src,
        name: altText
    }));
};
var $f1ec3e18df7ddd35$export$2e2bcd8739ae039 = (0, $agjvf.injectIntl)($f1ec3e18df7ddd35$var$WorkspaceIcon);

});
parcelRegister("dm41H", function(module, exports) {

$parcel$export(module.exports, "Panel", function () { return $74b4dce521769c39$export$2ddb90ad54e5f587; });
$parcel$export(module.exports, "PanelHeadingWrapper", function () { return $74b4dce521769c39$export$13966cb3e6df1bf9; });
$parcel$export(module.exports, "PanelHeading", function () { return $74b4dce521769c39$export$acf0e2a3d5f6ab38; });
$parcel$export(module.exports, "PanelHeadingLabel", function () { return $74b4dce521769c39$export$4837df6f79e5b263; });
$parcel$export(module.exports, "PanelHeader", function () { return $74b4dce521769c39$export$968713404ca1c9aa; });
$parcel$export(module.exports, "ExpanderPanelBody", function () { return $74b4dce521769c39$export$b2a3b148200f5ad8; });
$parcel$export(module.exports, "AnimateHeightContainer", function () { return $74b4dce521769c39$export$3bbb441f13315f8f; });
$parcel$export(module.exports, "Icon", function () { return $74b4dce521769c39$export$f04a61298a47a40f; });
$parcel$export(module.exports, "IconSecondary", function () { return $74b4dce521769c39$export$c03da0f248ea0422; });
$parcel$export(module.exports, "Chevron", function () { return $74b4dce521769c39$export$65be7b63f510f362; });
$parcel$export(module.exports, "Spinner", function () { return $74b4dce521769c39$export$7f7cbe89f1eacd2; });
$parcel$export(module.exports, "WarningWrapper", function () { return $74b4dce521769c39$export$e2229b703bf96afa; });
$parcel$export(module.exports, "GrayDivider", function () { return $74b4dce521769c39$export$69a862f63efb8ef8; });

var $2xJU3 = parcelRequire("2xJU3");

var $aP6k3 = parcelRequire("aP6k3");
var $jp7ng = parcelRequire("jp7ng");
var $dCDrX = parcelRequire("dCDrX");

var $h39Sh = parcelRequire("h39Sh");
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */ function $74b4dce521769c39$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $74b4dce521769c39$export$2ddb90ad54e5f587 = (0, $2xJU3.default)("section", {
    target: "e1m6l9kn0"
})("background-color:", (0, $h39Sh.default)("elevation.surface", (0, $jp7ng).N0), ";border-radius:", (0, $aP6k3.borderRadius)(), "px;text-align:left;");
const $74b4dce521769c39$export$13966cb3e6df1bf9 = (0, $2xJU3.default)("h2", {
    target: "e1m6l9kn1"
})({
    name: "1qd1r5f",
    styles: "margin-top:0;margin-bottom:0;"
});
const $74b4dce521769c39$export$acf0e2a3d5f6ab38 = (0, $2xJU3.default)("button", {
    target: "e1m6l9kn2"
})("align-items:center;background-color:", (0, $h39Sh.default)("elevation.surface", (0, $jp7ng).N0), ";border:0 none transparent;border-bottom:1px solid ", (0, $h39Sh.default)("color.border", (0, $jp7ng).N30), ";border-radius:", ({ isCollapsed: isCollapsed })=>isCollapsed ? `${(0, $aP6k3.borderRadius)()}px` : `${(0, $aP6k3.borderRadius)()}px ${(0, $aP6k3.borderRadius)()}px 0 0`, ";box-sizing:border-box;color:inherit;cursor:", ({ isExpandable: isExpandable })=>isExpandable ? "pointer" : "inherit", ";display:flex;flex-wrap:wrap;min-height:", (0, $aP6k3.gridSize)() * 5, "px;padding:", (0, $aP6k3.gridSize)(), "px;position:sticky;top:0;z-index:1;text-align:left;font-size:", (0, $aP6k3.fontSize)(), "px;width:100%;outline:none;line-height:inherit;&:hover{box-shadow:", ({ isCollapsed: isCollapsed, isExpandable: isExpandable })=>isExpandable && isCollapsed ? `0 0 0 1px ${(0, $h39Sh.default)("color.background.information", (0, $jp7ng).B200)}` : "none", ";}&:focus,&:active{box-shadow:", ({ isExpandable: isExpandable })=>isExpandable ? `0 0 0 1px ${(0, $h39Sh.default)("color.background.information", (0, $jp7ng).B200)}` : "none", ";}");
const $74b4dce521769c39$export$4837df6f79e5b263 = (0, $2xJU3.default)("span", {
    target: "e1m6l9kn3"
})({
    name: "1q27zj9",
    styles: "flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"
});
const $74b4dce521769c39$export$968713404ca1c9aa = (0, $2xJU3.default)("h2", {
    target: "e1m6l9kn4"
})({
    margin: 0,
    display: "flex",
    alignItems: "center",
    ...(0, $dCDrX).h400()
}, "");
const $74b4dce521769c39$export$b2a3b148200f5ad8 = (0, $2xJU3.default)("div", {
    target: "e1m6l9kn5"
})("border-radius:0 0 ", (0, $aP6k3.borderRadius)(), "px ", (0, $aP6k3.borderRadius)(), "px;flex-flow:column;overflow:", ({ isOverflowVisible: isOverflowVisible })=>isOverflowVisible ? "visible" : "hidden", ";padding:", (props)=>props.panelBodyPadding ? `${props.panelBodyPadding}` : `${(0, $aP6k3.gridSize)()}px`, ";");
const $74b4dce521769c39$export$3bbb441f13315f8f = (0, $2xJU3.default)("div", {
    target: "e1m6l9kn6"
})("max-height:", ({ allowMaxHeight: allowMaxHeight })=>allowMaxHeight ? `${(0, $aP6k3.gridSize)() * 100}px` : "none", ";overflow-y:", ({ allowMaxHeight: allowMaxHeight })=>allowMaxHeight ? "auto" : "visible", ";");
const $74b4dce521769c39$export$f04a61298a47a40f = (0, $2xJU3.default)("span", {
    target: "e1m6l9kn7"
})({
    name: "1b5prcp",
    styles: "display:flex;margin-right:4px;"
});
const $74b4dce521769c39$export$c03da0f248ea0422 = (0, $2xJU3.default)("div", {
    target: "e1m6l9kn8"
})({
    name: "1gh0ykx",
    styles: "display:flex;> *{display:flex;}"
});
const $74b4dce521769c39$export$65be7b63f510f362 = (0, $2xJU3.default)("span", {
    target: "e1m6l9kn9"
})({
    name: "1y4kgfw",
    styles: "display:flex;margin-left:auto;"
});
const $74b4dce521769c39$export$7f7cbe89f1eacd2 = (0, $2xJU3.default)("div", {
    target: "e1m6l9kn10"
})({
    name: "1w5bj86",
    styles: "& > div{display:flex;}"
});
const $74b4dce521769c39$export$e2229b703bf96afa = (0, $2xJU3.default)("span", {
    target: "e1m6l9kn11"
})("color:", (0, $h39Sh.default)("color.text.warning", (0, $jp7ng).Y300), ";display:flex;button{display:flex;}");
const $74b4dce521769c39$export$69a862f63efb8ef8 = (0, $2xJU3.default)("hr", {
    target: "e1m6l9kn12"
})({
    backgroundColor: (0, $h39Sh.default)("color.background.accent.gray.subtler", "#DCDFE4"),
    height: (0, $h39Sh.default)("space.025", "2px"),
    border: "none"
}, "");

});

parcelRegister("aILep", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2d1ff191fe109ff$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $b2d1ff191fe109ff$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    workspaceBreadcrumbsAvatarAltText: {
        "id": "frontbucket.components.workspace.workspaceBreadcrumbsAvatarAltText",
        "defaultMessage": "{workspaceName} Avatar"
    }
});

});


parcelRegister("a9ixz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fedb80a485eb6e3$export$2e2bcd8739ae039; });

var $cJH1T = parcelRequire("cJH1T");
parcelRequire("3hzea");
var $a5HLv = parcelRequire("a5HLv");
const $5fedb80a485eb6e3$var$urls = {
    api: {
        internal: {
            toggleFeature: (owner, feature)=>`/!api/internal/account/${owner}/features/${feature}`,
            contentPreview: ()=>`/!api/internal/content-preview/`
        },
        v10: {},
        v20: {
            // This uses the WorkspacePermissionsHandler in core
            workspacePermissionsForUser: (workspaceUuid, currentUserUuid)=>`/!api/2.0/workspaces/${encodeURIComponent(workspaceUuid)}/permissions?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
                    fields: "values.permissions",
                    q: `user.uuid="${currentUserUuid}"`
                })}`,
            // This uses the UserPermissionsWorkspacesHandler in core
            userPermissionsForWorkspace: (workspaceUuid)=>`/!api/2.0/user/permissions/workspaces?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
                    fields: "values.permissions",
                    q: `workspace.uuid="${workspaceUuid}"`
                })}`
        }
    },
    external: {
        atlassianAccountLogin: (aaLoginUrl, canonUrl, prompt)=>`${aaLoginUrl}?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
                application: "bitbucket",
                continue: canonUrl,
                prompt: prompt
            })}`,
        // TODO: Remove this once every page and navigation implementation is using
        // the navigation API and resource (which will provide logoutUrl instead of
        // having to manually calculate it)
        atlassianAccountLogout: (aaLogoutUrl, canonUrl)=>`${aaLogoutUrl}?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
                continue: `${canonUrl}${$5fedb80a485eb6e3$var$urls.ui.logout()}`,
                prompt: "none"
            })}`,
        fileRenderingLimitDocs: "https://confluence.atlassian.com/display/BITBUCKET/Limits+for+viewing+content+and+diffs",
        socialAuthLink: "/socialauth/login/atlassianid/",
        codeInsightsLearnMore: "https://confluence.atlassian.com/display/BITBUCKET/Code+insights",
        resolveMergeConflictDocs: "https://support.atlassian.com/bitbucket-cloud/docs/resolve-merge-conflicts/",
        grantRepositoryAccessToUsersAndGroups: "https://support.atlassian.com/bitbucket-cloud/docs/grant-repository-access-to-users-and-groups/",
        mergeStrategiesLearnMore: "https://confluence.atlassian.com/x/idFbO#Merge-strategies",
        adminHub: (adminHubBaseUrl, orgId, workspaceUuid, path)=>{
            const workspaceAri = `ari:cloud:bitbucket::workspace/${(0, $a5HLv.uncurlyUuid)(workspaceUuid)}`;
            const params = {
                product: workspaceAri,
                referrerName: "Bitbucket"
            };
            return `${adminHubBaseUrl}/o/${orgId}/${path}?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(params)}`;
        }
    },
    ui: {
        adminPlans: "/account/admin/plans/",
        fullCommit: (repositoryFullSlug, commitHash)=>`/${repositoryFullSlug}/commits/${commitHash}`,
        // TODO: Remove this once every page and navigation implementation is using
        // the navigation API and resource (which will provide logoutUrl instead of
        // having to manually calculate it)
        logout: ()=>"/account/signout/",
        project: (owner, key)=>`/account/user/${owner}/projects/${key}`,
        accountPlansAndBilling: (uuid)=>`/account/user/${uuid}/plans-and-billing/`,
        workspacePlansAndBilling: (slug)=>`/${slug}/workspace/settings/plans-and-billing/`,
        workspaceUsersOnPlan: (slug)=>`/${slug}/workspace/settings/plan-users/`,
        workspaceGroups: (slug)=>`/${slug}/workspace/settings/groups/`,
        repositoryMentions: (owner, slug, query)=>`/xhr/mentions/repositories/${owner}/${slug}?term=${query}`,
        pullRequest: (repositoryFullSlug, pullRequestId)=>`/${repositoryFullSlug}/pull-requests/${pullRequestId}`,
        pullRequestTab: (owner, slug, pullRequestId, tab)=>`/${owner}/${slug}/pull-requests/${pullRequestId}/${tab}`
    }
};
var $5fedb80a485eb6e3$export$2e2bcd8739ae039 = $5fedb80a485eb6e3$var$urls;

});

parcelRegister("8agvL", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbsItemRepositoryLink", function () { return $7fd87b14a4435d49$export$93bd2d49891e1c4e; });

var $2xJU3 = parcelRequire("2xJU3");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $cS2SK = parcelRequire("cS2SK");
const $7fd87b14a4435d49$export$93bd2d49891e1c4e = /*#__PURE__*/ (0, $2xJU3.default)((0, $cS2SK.default), {
    target: "ea534y60"
})({
    color: (0, $h39Sh.default)("color.text.subtle", (0, $jp7ng).N200),
    "&:hover": {
        color: (0, $h39Sh.default)("color.text.subtle", (0, $jp7ng).N200)
    },
    "&:focus": {
        color: (0, $h39Sh.default)("color.text.subtle", (0, $jp7ng).N200)
    }
}, "");

});
parcelRegister("cS2SK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9058527c83eeb8ba$export$2e2bcd8739ae039; });

var $NS9rR = parcelRequire("NS9rR");

var $4ds8f = parcelRequire("4ds8f");
var $9058527c83eeb8ba$export$2e2bcd8739ae039 = (0, $NS9rR.default);

});
parcelRegister("NS9rR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91472dffa1ccbb32$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $gQBAa = parcelRequire("gQBAa");

var $kZnTB = parcelRequire("kZnTB");

var $gtaeM = parcelRequire("gtaeM");
const $91472dffa1ccbb32$var$LANDING_PAGES = {
    source: {
        task: (0, $gtaeM.ApdexTask).Source,
        getHref: (owner, slug)=>`/${owner}/${slug}/`
    },
    commits: {
        task: (0, $gtaeM.ApdexTask).Commits,
        getHref: (owner, slug)=>(0, $kZnTB.default).ui.commits(`${owner}/${slug}`)
    },
    branches: {
        task: (0, $gtaeM.ApdexTask).Branches,
        getHref: (0, $kZnTB.default).ui.branches
    },
    pull_requests: {
        task: (0, $gtaeM.ApdexTask).PullRequests,
        getHref: (0, $kZnTB.default).ui.pullRequests
    }
};
const $91472dffa1ccbb32$var$RepositoryLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function BaseRepositoryLink(props, ref) {
    const { children: children, className: className = "", innerRef: innerRef, repository: repository } = props;
    // Some HOCs (like Emotion) will forward refs as `ref` while other parts of our code explicitly pass `innerRef`
    const trueRef = ref || innerRef;
    const content = children || repository.name;
    const [owner, slug] = repository.full_name.split("/");
    const { href: href } = repository.links.html;
    const { landing_page: landingPage } = repository;
    // If the landing page is null, source (or overview), or not in the map, redirect
    // to the source view. Otherwise, check the landing pages map and redirect to the
    // appropiate page.
    const clientLandingPage = landingPage && landingPage in $91472dffa1ccbb32$var$LANDING_PAGES ? $91472dffa1ccbb32$var$LANDING_PAGES[landingPage] : $91472dffa1ccbb32$var$LANDING_PAGES.source;
    return clientLandingPage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $gQBAa.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        to: clientLandingPage.getHref(owner, slug),
        className: className,
        innerRef: trueRef,
        task: clientLandingPage.task
    }), content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("a", {
        href: href,
        className: className,
        ref: trueRef
    }, content);
}));
var $91472dffa1ccbb32$export$2e2bcd8739ae039 = $91472dffa1ccbb32$var$RepositoryLink;

});
parcelRegister("gQBAa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67f155afc870ae77$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $8MzLl = parcelRequire("8MzLl");

var $aurzp = parcelRequire("aurzp");
var $67f155afc870ae77$export$2e2bcd8739ae039;
$67f155afc870ae77$export$2e2bcd8739ae039 = class ApdexMeasuredLink extends (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).PureComponent {
    constructor(...args){
        super(...args);
        this.handleClick = (event)=>{
            const { task: task, onClick: onClick } = this.props;
            (0, $8MzLl.startApdex)({
                task: task,
                type: "transition"
            });
            if (onClick) onClick(event);
        };
    }
    render() {
        const { children: children, to: to } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aurzp.ComponentLinkProxy), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, this.props, {
            href: to,
            onClick: this.handleClick
        }), children);
    }
};

});

parcelRegister("gtaeM", function(module, exports) {

$parcel$export(module.exports, "ApdexTask", function () { return $58146fa52b1a6542$export$954fa9a13ef9cb2; });
var $58146fa52b1a6542$export$954fa9a13ef9cb2;
(function(ApdexTask) {
    ApdexTask["Source"] = "bitbucket.apps.repo2.views.source";
    ApdexTask["FileBrowse"] = "bitbucket.apps.repo2.views.filebrowse";
    ApdexTask["Commits"] = "bitbucket.apps.repo2.views.CommitList";
    ApdexTask["Changeset"] = "apps.bitbucket.repo2.views.changeset";
    ApdexTask["Branches"] = "bitbucket.apps.repo2.views.BranchList";
    ApdexTask["PullRequest"] = "bitbucket.apps.pullrequests.views.pullrequest";
    ApdexTask["PullRequests"] = "bitbucket.apps.pullrequests.views.list_pullrequests";
    ApdexTask["RepoCreateBranch"] = "bitbucket.apps.repo2.views.RepoCreateBranchView";
    ApdexTask["RepoSettingsView"] = "bitbucket.apps.repo2.views.RepoSettingsView";
    ApdexTask["WorkspaceSettingsView"] = "bitbucket.apps.workspace.views.WorkspaceSettingsView";
    ApdexTask["GlobalCreateBranch"] = "bitbucket.apps.repo2.views.GlobalCreateBranchView";
    ApdexTask["PipelineList"] = "bitbucket.connect.list_pipelines";
    ApdexTask["DashboardOverview"] = "bitbucket.apps.dashboard.views.DashboardOverviewView";
    ApdexTask["DashboardRepositories"] = "bitbucket.apps.dashboard.views.DashboardRepositories";
    ApdexTask["ProfileRepositories"] = "bitbucket.apps.profile.views.ProfileRepositories";
    ApdexTask["ProjectRepositories"] = "bitbucket.apps.projects.views.ProjectRepositories";
})($58146fa52b1a6542$export$954fa9a13ef9cb2 || ($58146fa52b1a6542$export$954fa9a13ef9cb2 = {}));

});


parcelRegister("4ds8f", function(module, exports) {

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");
const $8346cd35a26b3452$var$getDisplayName = (c)=>c.displayName || c.name || "Component";
const $8346cd35a26b3452$export$8d60e4be3d293f92 = (repository)=>(Comp)=>{
        var _class;
        return _class = class WithRepository extends (0, $9nHZC.PureComponent) {
            /* eslint react/sort-comp: warn */ render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Comp, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, this.props, {
                    repository: repository
                }));
            }
        }, _class.WrappedComponent = Comp, _class.displayName = `WithRepository(${$8346cd35a26b3452$var$getDisplayName(Comp)})`, _class;
    };

});





parcelRegister("jDLzd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1e2d37dfdca4b92$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $c1e2d37dfdca4b92$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    admin: {
        "id": "frontbucket.repository.admin.breadcrumbs.repodetails",
        "defaultMessage": "Repository settings"
    }
});

});

parcelRegister("4MsY5", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbItemStyled", function () { return $4d9d9c66d813dfeb$export$820839f8f459a573; });

var $2xJU3 = parcelRequire("2xJU3");
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */ function $4d9d9c66d813dfeb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4d9d9c66d813dfeb$export$820839f8f459a573 = (0, $2xJU3.default)("span", {
    target: "e1s4gyzm0"
})({
    name: "14z6xdi",
    styles: "& span{font-weight:normal;}"
});

});



parcelRegister("86Rbu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f316f68f2e73d8a$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $ezdYA = parcelRequire("ezdYA");

var $dqY9c = parcelRequire("dqY9c");

var $kZnTB = parcelRequire("kZnTB");

var $aanBq = parcelRequire("aanBq");

var $dxJTk = parcelRequire("dxJTk");
const $8f316f68f2e73d8a$var$Breadcrumbs = ()=>{
    const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug } = (0, $dqY9c.useParams)();
    const settingsHref = (0, $kZnTB.default).ui.admin(repositoryOwner || "", repositorySlug || "");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dxJTk.default), {
        settingsHref: settingsHref
    });
};
var $8f316f68f2e73d8a$export$2e2bcd8739ae039 = (0, $ezdYA.default)((0, $aanBq.getSelectedMenuItem), {
    breadcrumbs: $8f316f68f2e73d8a$var$Breadcrumbs
});

});
parcelRegister("ezdYA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $745f6523ec311fb6$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("dGzLf");
var $aAre5 = parcelRequire("aAre5");
parcelRequire("4tAgz");
var $gRBmM = parcelRequire("gRBmM");

var $dqY9c = parcelRequire("dqY9c");

var $8MnfV = parcelRequire("8MnfV");

var $2T5gN = parcelRequire("2T5gN");
const $745f6523ec311fb6$var$MOBILE_NAV_HEIGHT = 54;
const $745f6523ec311fb6$var$createSettingsHOC = (getSelectedMenuItem, defaultProps)=>(Component, componentProps)=>{
        return (settingsProps)=>{
            const match = (0, $dqY9c.useMatch)();
            const location = (0, $dqY9c.useLocation)();
            const isMobileHeaderActive = (0, $aAre5.useSelector)((0, $8MnfV.getIsMobileHeaderActive));
            const topOffset = isMobileHeaderActive ? $745f6523ec311fb6$var$MOBILE_NAV_HEIGHT : 0;
            const selectedMenuItem = (0, $aAre5.useSelector)((state)=>getSelectedMenuItem(state, location.pathname, match.url));
            const props = {
                ...defaultProps,
                ...componentProps,
                ...settingsProps
            };
            const { noLayout: noLayout } = props;
            const sharedProps = (0, $9nHZC.useMemo)(()=>({
                    selectedMenuItem: selectedMenuItem,
                    topOffset: topOffset
                }), [
                selectedMenuItem,
                topOffset
            ]);
            if (noLayout) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, sharedProps));
            const { actions: Actions, header: Header, container: Container, breadcrumbs: PageBreadcrumbs, passHeader: passHeader } = props;
            const PageHeader = (0, $9nHZC.useMemo)(()=>(headerProps = {})=>{
                    var _sharedProps$selected;
                    return Header && typeof Header === "function" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Header, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, sharedProps, headerProps)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $gRBmM.FocusedPageHeader), {
                        actions: typeof Actions === "function" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Actions, null) : Actions,
                        breadcrumbs: PageBreadcrumbs ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(PageBreadcrumbs, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, sharedProps, headerProps)) : undefined
                    }, headerProps.pageTitle || sharedProps.pageTitle || ((_sharedProps$selected = sharedProps.selectedMenuItem) === null || _sharedProps$selected === void 0 ? void 0 : _sharedProps$selected.label));
                }, [
                Header,
                Actions,
                PageBreadcrumbs,
                sharedProps
            ]);
            const layout = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2T5gN.SettingsPageSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2T5gN.SettingsPageWrapper), null, passHeader ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(PageHeader, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, sharedProps, {
                header: passHeader ? PageHeader : undefined
            }))));
            if (Container) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Container, null, layout);
            return layout;
        };
    };
var $745f6523ec311fb6$export$2e2bcd8739ae039 = $745f6523ec311fb6$var$createSettingsHOC;

});



parcelRegister("1yRHp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c9bcbef3a909d09$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("dGzLf");
var $eeHDY = parcelRequire("eeHDY");

var $iye3w = parcelRequire("iye3w");

var $dqY9c = parcelRequire("dqY9c");

var $Sv0NW = parcelRequire("Sv0NW");

var $86Rbu = parcelRequire("86Rbu");
const $3c9bcbef3a909d09$export$8208678e7bf6238a = ({ selectedMenuItem: selectedMenuItem, topOffset: topOffset })=>{
    const dispatch = (0, $eeHDY.useDispatch)();
    const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug } = (0, $dqY9c.useParams)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $iye3w.SettingsIframe), {
        url: selectedMenuItem === null || selectedMenuItem === void 0 ? void 0 : selectedMenuItem.url,
        title: selectedMenuItem === null || selectedMenuItem === void 0 ? void 0 : selectedMenuItem.label,
        topOffset: topOffset,
        showLoadingOnUrlChange: true,
        onIframeLoad: (setIsLoading)=>setIsLoading(false),
        onIframeReadyStateChangeComplete: ({ isLoading: isLoading, setIsLoading: setIsLoading })=>{
            if (isLoading) setIsLoading(false);
            if (selectedMenuItem && (selectedMenuItem.tab_name === "wiki" || selectedMenuItem.tab_name === "issues")) {
                if (repositoryOwner && repositorySlug) dispatch((0, $Sv0NW.default)(`${repositoryOwner}/${repositorySlug}`));
            }
        }
    });
};
var $3c9bcbef3a909d09$export$2e2bcd8739ae039 = (0, $86Rbu.default)($3c9bcbef3a909d09$export$8208678e7bf6238a, {
    noLayout: true
});

});
parcelRegister("iye3w", function(module, exports) {

$parcel$export(module.exports, "SettingsIframe", function () { return $2c1c5a1cc834393f$export$8208678e7bf6238a; });

var $gqmqe = parcelRequire("gqmqe");

var $9nHZC = parcelRequire("9nHZC");

var $cJH1T = parcelRequire("cJH1T");

var $dEKDm = parcelRequire("dEKDm");

var $2T5gN = parcelRequire("2T5gN");
class $2c1c5a1cc834393f$export$8208678e7bf6238a extends (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component {
    constructor(...args){
        super(...args);
        this.state = {
            isLoading: true
        };
        this.iframeRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createRef();
        this.setIsLoading = (isLoading)=>this.setState({
                isLoading: isLoading
            });
        this.getActionProps = (event)=>({
                event: event,
                isLoading: this.state.isLoading,
                setIsLoading: this.setIsLoading,
                iframeRef: this.iframeRef
            });
        this.onMessage = (evt)=>{
            const { onIframeSubmit: onSubmit, onIframeReadyStateChangeComplete: onChange } = this.props;
            if (evt.origin !== window.location.origin) return;
            if (evt.data === "iframe:submit") {
                if (typeof onSubmit === "function") onSubmit(this.getActionProps(evt));
                else this.setIsLoading(true);
            } else if (evt.data === "iframe:readystatechange:complete") {
                if (typeof onChange === "function") onChange(this.getActionProps(evt));
                else this.setIsLoading(false);
            }
        };
    }
    static getIframeURL(str) {
        const url = (0, (/*@__PURE__*/$parcel$interopDefault($gqmqe))).parse(str);
        const query = (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).parse(url.query || "");
        const pageQuery = (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).parse((0, (/*@__PURE__*/$parcel$interopDefault($gqmqe))).parse(window.location.href).query || "");
        return (0, (/*@__PURE__*/$parcel$interopDefault($gqmqe))).format({
            protocol: url.protocol || window.location.protocol,
            host: url.host || window.location.host,
            pathname: url.pathname,
            query: {
                ...query,
                ...pageQuery,
                iframe: true,
                spa: 0
            },
            hash: window.location.hash
        });
    }
    componentDidMount() {
        window.addEventListener("message", this.onMessage);
    }
    componentDidUpdate(prevProps) {
        if (this.props.showLoadingOnUrlChange && prevProps.url !== this.props.url) this.setIsLoading(true);
    }
    componentWillUnmount() {
        window.removeEventListener("message", this.onMessage);
    }
    render() {
        const { isLoading: isLoading } = this.state;
        const { url: url, title: title, onIframeLoad: onIframeLoad, topOffset: topOffset } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2T5gN.SettingsPageContainer), {
            topOffset: topOffset
        }, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2T5gN.SettingsPageLoadingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dEKDm.default), {
            size: "large"
        })), url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2T5gN.SettingsPageIframe), {
            id: "settings-frame",
            title: title,
            src: $2c1c5a1cc834393f$export$8208678e7bf6238a.getIframeURL(url),
            isLoading: isLoading,
            onLoad: onIframeLoad && (()=>onIframeLoad(this.setIsLoading)),
            "aria-hidden": isLoading,
            ref: this.iframeRef
        }));
    }
}

});


parcelRegister("kUD1u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4251ec181b792e6d$export$2e2bcd8739ae039; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

var $4251ec181b792e6d$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("i8Ivr")),
    modules: [
        "./components/page"
    ],
    webpack: ()=>[
            undefined("./components/page")
        ]
});

});
parcelRegister("i8Ivr", function(module, exports) {






















module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fVUDo")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6XRs7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvUP")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6qh0x")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kjN9y")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9r5Qy")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("e0Fn7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fDD7i")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7xLkx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3op3S")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("vzwqp"))
]).then(()=>parcelRequire("bae7q"));

});


parcelRegister("cHvpw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21223fd0a2d3228d$export$2e2bcd8739ae039; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

var $21223fd0a2d3228d$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("3xl56")),
    modules: [
        "./route"
    ],
    webpack: ()=>[
            undefined("./route")
        ]
});

});
parcelRegister("3xl56", function(module, exports) {




















module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("cZ7JN")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jkg4B")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3vzef")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("N6nXV")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kBzNL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8FZFT")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3rlr8")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2Ju5h")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9r5Qy")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("hjhO6"))
]).then(()=>parcelRequire("40aY8"));

});


parcelRegister("c1CiF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9936c33b4e12db1a$export$2e2bcd8739ae039; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

var $9936c33b4e12db1a$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("kqRFo")),
    modules: [
        "./route"
    ],
    webpack: ()=>[
            undefined("./route")
        ]
});

});
parcelRegister("kqRFo", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7imFj")).then(()=>parcelRequire("kzQ0K"));

});


parcelRegister("7DpkT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a3d3721970f2801$export$2e2bcd8739ae039; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

var $5a3d3721970f2801$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("crMSU")),
    modules: [
        "./route"
    ],
    webpack: ()=>[
            undefined("./route")
        ]
});

});
parcelRegister("crMSU", function(module, exports) {


















module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kMnHx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5JtgB")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5yI7S")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3zl8N")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8FZFT")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("gBGtw")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3rlr8")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c7qp4")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kQVXz"))
]).then(()=>parcelRequire("kQb1L"));

});


parcelRegister("6egPG", function(module, exports) {

$parcel$export(module.exports, "loadCommitResource", function () { return $36194aeffe36f85c$export$90988a02cad1a078; });

var $cJH1T = parcelRequire("cJH1T");
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $aBe8c = parcelRequire("aBe8c");

var $kZnTB = parcelRequire("kZnTB");

var $k2cPS = parcelRequire("k2cPS");
const $36194aeffe36f85c$var$fetchData = async (repoOwner, repoSlug, hash)=>{
    const url = (0, $kZnTB.default).api.v20.commit(repoOwner, repoSlug, hash);
    const query_params = {
        fields: "+*.rendered.*"
    };
    const query = (0, $cJH1T.stringify)(query_params);
    const fullUrl = `${url}?${query}`;
    const resp = await fetch((0, $k2cPS.default)(fullUrl));
    if (resp.ok) return resp.json();
    else {
        const error = new (0, $aBe8c.BBError)("error loading commit", "error-loading-commit", resp.status);
        throw error;
    }
};
const $36194aeffe36f85c$export$90988a02cad1a078 = (0, $3kfkg.createResource)({
    type: "loadCommit",
    getKey: ({ match: match })=>{
        return `loadCommit:${match.params.repositoryOwner}:${match.params.repositorySlug}:${match.params.ref}.`;
    },
    maxAge: 1000000,
    getData: async ({ match: match })=>{
        // TODO, check out src/redux/pull-request/resources/load-pull-request.ts
        // and try to pull the commit out of redux if we have it
        // https://softwareteams.atlassian.net/browse/COREX-5857
        const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug, ref: ref } = match.params;
        if (!repositoryOwner || !repositorySlug || !ref) throw new Error("Could not fetch commit, URL params were not available");
        const commit = await $36194aeffe36f85c$var$fetchData(repositoryOwner, repositorySlug, ref);
        return commit;
    }
});

});
parcelRegister("aBe8c", function(module, exports) {

$parcel$export(module.exports, "BBError", function () { return $d57a1953fe2fd6cd$export$623b51f9d05416c6; });
$parcel$export(module.exports, "getBranchSyncInfo", function () { return $d57a1953fe2fd6cd$export$2adeaadb1289df2a; });
$parcel$export(module.exports, "getCommits", function () { return $d57a1953fe2fd6cd$export$c76cbc8af6040a47; });
$parcel$export(module.exports, "getCommentById", function () { return $d57a1953fe2fd6cd$export$7228659693004e6; });
$parcel$export(module.exports, "getUpdates", function () { return $d57a1953fe2fd6cd$export$41dd10970b7c946; });
$parcel$export(module.exports, "getWatch", function () { return $d57a1953fe2fd6cd$export$fbbe94ee2d19ed00; });
$parcel$export(module.exports, "watch", function () { return $d57a1953fe2fd6cd$export$3db5d71bdb2d5499; });
$parcel$export(module.exports, "startWatch", function () { return $d57a1953fe2fd6cd$export$8c3ed683d2ced402; });
$parcel$export(module.exports, "stopWatch", function () { return $d57a1953fe2fd6cd$export$d38475e6e890fc63; });
$parcel$export(module.exports, "getCommentLikes", function () { return $d57a1953fe2fd6cd$export$cd6f4406ffa3f3e2; });
$parcel$export(module.exports, "getDiff", function () { return $d57a1953fe2fd6cd$export$c2eaa8b43b33ba41; });
$parcel$export(module.exports, "getActivity", function () { return $d57a1953fe2fd6cd$export$b68ab0737e5e28db; });
$parcel$export(module.exports, "getMergeChecks", function () { return $d57a1953fe2fd6cd$export$fa6f69b54bd510fd; });
$parcel$export(module.exports, "getPullRequest", function () { return $d57a1953fe2fd6cd$export$d3b8fca238a81fbc; });
$parcel$export(module.exports, "getConflicts", function () { return $d57a1953fe2fd6cd$export$733bb30b9159fd88; });
$parcel$export(module.exports, "getDiffStat", function () { return $d57a1953fe2fd6cd$export$d1b9710aa8435c62; });
$parcel$export(module.exports, "getStackedPullRequestsCount", function () { return $d57a1953fe2fd6cd$export$b5cd341647f8f339; });
/* eslint-disable no-use-before-define, @typescript-eslint/no-use-before-define */ 
var $l5grM = parcelRequire("l5grM");
parcelRequire("fequ0");
var $6vWKR = parcelRequire("6vWKR");

var $czBtW = parcelRequire("czBtW");

var $k2cPS = parcelRequire("k2cPS");
class $d57a1953fe2fd6cd$export$623b51f9d05416c6 extends Error {
    constructor(message, key, status){
        super(message);
        this.key = void 0;
        this.status = void 0;
        this.key = key;
        this.status = status;
    }
}
const $d57a1953fe2fd6cd$export$2adeaadb1289df2a = async (owner, slug, pullRequestId)=>{
    try {
        const url = (0, $czBtW.default).api.internal.branchSyncInfo(owner, slug, pullRequestId);
        const response = await fetch((0, $k2cPS.default)(url));
        if (response.ok) return response.json();
        else return {
            error: true,
            status: response.status
        };
    } catch (e) {
        return {
            error: true
        };
    }
};
const $d57a1953fe2fd6cd$export$c76cbc8af6040a47 = async (url)=>{
    try {
        const response = await fetch((0, $k2cPS.default)(url));
        if (response.ok) {
            const { page: page, pagelen: pagelen, next: next, values: commits } = await response.json();
            return {
                commits: commits,
                next: next,
                page: page,
                pagelen: pagelen
            };
        } else return {
            error: true,
            status: response.status
        };
    } catch (e) {
        return {
            error: true
        };
    }
};
const $d57a1953fe2fd6cd$export$7228659693004e6 = async (owner, slug, pullRequestId, commentId)=>{
    const response = await fetch((0, $k2cPS.default)((0, $czBtW.default).api.internal.commentById(owner, slug, pullRequestId, commentId), {
        method: (0, $6vWKR.HttpMethods).get
    }));
    const result = await response.json();
    if (!response.ok) {
        const error = {
            msg: `An error occurred while fetching a comment with id ${commentId}`,
            status: response.status
        };
        return error;
    }
    return result;
};
const $d57a1953fe2fd6cd$export$41dd10970b7c946 = async (...args)=>{
    const url = (0, $czBtW.default).api.internal.updates(...args);
    try {
        const resp = await fetch((0, $k2cPS.default)(url));
        const json = await resp.json();
        return json;
    } catch (e) {
        return {
            error: true
        };
    }
};
const $d57a1953fe2fd6cd$export$fbbe94ee2d19ed00 = (owner, slug, id)=>$d57a1953fe2fd6cd$export$3db5d71bdb2d5499(owner, slug, id, (0, $6vWKR.HttpMethods).get, "An error occurred while fetching watch status.");
const $d57a1953fe2fd6cd$export$8c3ed683d2ced402 = (owner, slug, id)=>$d57a1953fe2fd6cd$export$3db5d71bdb2d5499(owner, slug, id, (0, $6vWKR.HttpMethods).post, "An error occurred while trying to watch.");
const $d57a1953fe2fd6cd$export$d38475e6e890fc63 = (owner, slug, id)=>$d57a1953fe2fd6cd$export$3db5d71bdb2d5499(owner, slug, id, (0, $6vWKR.HttpMethods).delete, "An error occurred while trying to stop watching.");
const $d57a1953fe2fd6cd$export$3db5d71bdb2d5499 = async (owner, slug, id, method, errorMsg)=>{
    const response = await fetch((0, $k2cPS.default)((0, $czBtW.default).api.internal.watch(owner, slug, id), {
        method: method
    }));
    const result = await response.json();
    if (!response.ok) {
        const error = {
            status: response.status,
            msg: errorMsg
        };
        return (0, $l5grM.Left)(error);
    }
    return (0, $l5grM.Right)(result);
};
const $d57a1953fe2fd6cd$var$IdentityFunction = (a)=>a;
const $d57a1953fe2fd6cd$var$createPullRequestFetch = (url, valueExtractor = $d57a1953fe2fd6cd$var$IdentityFunction, errorExtractor = $d57a1953fe2fd6cd$var$IdentityFunction)=>{
    return async (owner, slug, id)=>{
        const response = await fetch((0, $k2cPS.default)(url(owner, slug, id)), {
            headers: (0, $k2cPS.jsonHeaders)
        });
        const json = await response.json();
        if (!response.ok) throw new Error(errorExtractor(json.error.message));
        return valueExtractor(json);
    };
};
const $d57a1953fe2fd6cd$export$cd6f4406ffa3f3e2 = async (url)=>{
    const response = await fetch((0, $k2cPS.default)(url));
    if (!response.ok) {
        const error = new Error("An error occurred while fetching the comment likes.");
        // @ts-ignore
        error.status = response.status;
        throw error;
    }
    const json = await response.json();
    return json;
};
const $d57a1953fe2fd6cd$export$c2eaa8b43b33ba41 = async (url)=>{
    const response = await fetch((0, $k2cPS.default)(url));
    if (!response.ok) {
        const error = new Error("An error occurred while fetching the diff.");
        // @ts-ignore
        error.status = response.status;
        throw error;
    }
    const diff = await response.text();
    const isPartial = response.headers.has("atl-bb-partial-diff");
    return {
        diff: diff,
        isPartial: isPartial
    };
};
const $d57a1953fe2fd6cd$export$b68ab0737e5e28db = async (url)=>{
    const response = await fetch((0, $k2cPS.default)(url));
    if (!response.ok) {
        const error = new Error("An error ocurred while fetching the pull request activity.");
        // @ts-ignore
        error.status = response.status;
        // The error message being displayed to the user is translated.
        error.message = `Couldn't load content`;
        throw error;
    }
    const json = await response.json();
    return json;
};
const $d57a1953fe2fd6cd$export$fa6f69b54bd510fd = async (url)=>{
    const response = await fetch((0, $k2cPS.default)(url));
    if (!response.ok) {
        const error = new Error("An error ocurred while fetching the merge checks.");
        // @ts-ignore
        error.status = response.status;
        // The error message being displayed to the user is translated.
        error.message = `Couldn't load content`;
        throw error;
    }
    const json = await response.json();
    return json;
};
const $d57a1953fe2fd6cd$export$d3b8fca238a81fbc = $d57a1953fe2fd6cd$var$createPullRequestFetch((0, $czBtW.default).ui.pullrequestdata);
const $d57a1953fe2fd6cd$export$733bb30b9159fd88 = $d57a1953fe2fd6cd$var$createPullRequestFetch((0, $czBtW.default).api.internal.conflicts);
const $d57a1953fe2fd6cd$export$d1b9710aa8435c62 = async (url)=>{
    const response = await fetch((0, $k2cPS.default)(url), {
        headers: (0, $k2cPS.jsonHeaders)
    });
    const result = await response.json();
    if (!response.ok) {
        var _result$error$data;
        const error = new $d57a1953fe2fd6cd$export$623b51f9d05416c6(result.error.message, (_result$error$data = result.error.data) === null || _result$error$data === void 0 ? void 0 : _result$error$data.key, response.status);
        throw error;
    }
    return result;
};
const $d57a1953fe2fd6cd$export$b5cd341647f8f339 = async (owner, slug, destinationBranch)=>{
    const url = (0, $czBtW.default).api.v20.pullRequests(owner, slug, destinationBranch);
    const response = await fetch((0, $k2cPS.default)(url));
    if (!response.ok) {
        const error = new Error("An error occurred while fetching stacked pull requests.");
        // @ts-ignore
        error.status = response.status;
        throw error;
    }
    const json = await response.json();
    return json.size;
};

});
parcelRegister("l5grM", function(module, exports) {

$parcel$export(module.exports, "Left", function () { return $f596d2a117ee0b06$export$37c4d04eafdc5515; });
$parcel$export(module.exports, "Right", function () { return $f596d2a117ee0b06$export$19db0165690c701a; });
function $f596d2a117ee0b06$export$b24f7407c77e5bd(ref) {
    return !!(ref && typeof ref.equals === "function" && typeof ref.hashCode === "function");
}
function $f596d2a117ee0b06$export$226b3eccf92c9ed9(lh, rh) {
    if (lh === rh || lh !== lh && rh !== rh) return true;
    if (!lh || !rh) return false;
    if (typeof lh.valueOf === "function" && typeof rh.valueOf === "function") {
        var lh2 = lh.valueOf();
        var rh2 = rh.valueOf();
        if (lh2 === rh2 || lh2 !== lh2 && rh2 !== rh2) return true;
        if (!lh2 || !rh2) return false;
    }
    return !!($f596d2a117ee0b06$export$b24f7407c77e5bd(lh) && lh.equals(rh));
}
function $f596d2a117ee0b06$export$e9bab7fafb253603(lh, rh) {
    return $f596d2a117ee0b06$export$226b3eccf92c9ed9(lh, rh);
}
var $f596d2a117ee0b06$export$280f210877e5565b = {
    equals: $f596d2a117ee0b06$export$e9bab7fafb253603
};
function $f596d2a117ee0b06$export$d41d9ab3de2def3d(ref) {
    if (typeof ref === "number") return ref & ref;
    if (typeof ref.valueOf === "function") {
        var v = ref.valueOf();
        if (v !== ref) return $f596d2a117ee0b06$export$d41d9ab3de2def3d(v);
    }
    if ($f596d2a117ee0b06$export$b24f7407c77e5bd(ref)) return ref.hashCode();
    return $f596d2a117ee0b06$export$39e05520a596a3da(String(ref));
}
function $f596d2a117ee0b06$export$39e05520a596a3da(str) {
    var hash = 0;
    if (str == null || str.length === 0) return hash;
    for(var i = 0; i < str.length; i++){
        var character = str.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash;
    }
    return hash;
}
function $f596d2a117ee0b06$export$d560c7e4a29451c2(a) {
    return a;
}
function $f596d2a117ee0b06$export$6ccb92ce135089b4(derivedCtor, baseCtors) {
    baseCtors.forEach(function(baseCtor) {
        Object.getOwnPropertyNames(baseCtor.prototype).forEach(function(name) {
            if (!derivedCtor.prototype[name]) derivedCtor.prototype[name] = baseCtor.prototype[name];
        });
    });
}
var $f596d2a117ee0b06$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $f596d2a117ee0b06$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $f596d2a117ee0b06$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $f596d2a117ee0b06$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $f596d2a117ee0b06$export$6fbeb926bac523c3 = function(_Error) {
    $f596d2a117ee0b06$var$inherits(CompositeError, _Error);
    function CompositeError(errors) {
        $f596d2a117ee0b06$var$classCallCheck(this, CompositeError);
        var reasons = "";
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = errors.slice(0, 2)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var e = _step.value;
                var message = "";
                if (e instanceof Error) message = e.name + "(" + e.message + ")";
                else message = "" + e;
                reasons += ", " + message;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
        reasons = reasons.slice(2);
        if (errors.length > 2) reasons = reasons + ", ...";
        var _this = $f596d2a117ee0b06$var$possibleConstructorReturn(this, (CompositeError.__proto__ || Object.getPrototypeOf(CompositeError)).call(this, reasons));
        _this.name = "CompositeError";
        _this.errorsRef = errors;
        var self = _this;
        self.constructor = CompositeError;
        self.__proto__ = CompositeError.prototype;
        return _this;
    }
    $f596d2a117ee0b06$var$createClass(CompositeError, [
        {
            key: "errors",
            value: function errors() {
                return this.errorsRef.slice();
            }
        }
    ]);
    return CompositeError;
}(Error);
var $f596d2a117ee0b06$export$4a48f57740b5ad1e = function(_Error2) {
    $f596d2a117ee0b06$var$inherits(DummyError, _Error2);
    function DummyError(message) {
        $f596d2a117ee0b06$var$classCallCheck(this, DummyError);
        var _this2 = $f596d2a117ee0b06$var$possibleConstructorReturn(this, (DummyError.__proto__ || Object.getPrototypeOf(DummyError)).call(this, message));
        _this2.name = "DummyError";
        var self = _this2;
        self.constructor = DummyError;
        self.__proto__ = DummyError.prototype;
        return _this2;
    }
    return DummyError;
}(Error);
var $f596d2a117ee0b06$export$48d368d160387990 = function(_Error3) {
    $f596d2a117ee0b06$var$inherits(NoSuchElementError, _Error3);
    function NoSuchElementError(message) {
        $f596d2a117ee0b06$var$classCallCheck(this, NoSuchElementError);
        var _this3 = $f596d2a117ee0b06$var$possibleConstructorReturn(this, (NoSuchElementError.__proto__ || Object.getPrototypeOf(NoSuchElementError)).call(this, message));
        _this3.name = "NoSuchElementError";
        var self = _this3;
        self.constructor = NoSuchElementError;
        self.__proto__ = NoSuchElementError.prototype;
        return _this3;
    }
    return NoSuchElementError;
}(Error);
var $f596d2a117ee0b06$export$e6c18cacaad31d56 = function(_Error4) {
    $f596d2a117ee0b06$var$inherits(IllegalInheritanceError, _Error4);
    function IllegalInheritanceError(message) {
        $f596d2a117ee0b06$var$classCallCheck(this, IllegalInheritanceError);
        var _this4 = $f596d2a117ee0b06$var$possibleConstructorReturn(this, (IllegalInheritanceError.__proto__ || Object.getPrototypeOf(IllegalInheritanceError)).call(this, message));
        _this4.name = "IllegalInheritanceError";
        var self = _this4;
        self.constructor = IllegalInheritanceError;
        self.__proto__ = IllegalInheritanceError.prototype;
        return _this4;
    }
    return IllegalInheritanceError;
}(Error);
var $f596d2a117ee0b06$export$25b19446f82d7080 = function(_Error5) {
    $f596d2a117ee0b06$var$inherits(IllegalStateError, _Error5);
    function IllegalStateError(message) {
        $f596d2a117ee0b06$var$classCallCheck(this, IllegalStateError);
        var _this5 = $f596d2a117ee0b06$var$possibleConstructorReturn(this, (IllegalStateError.__proto__ || Object.getPrototypeOf(IllegalStateError)).call(this, message));
        _this5.name = "IllegalStateError";
        var self = _this5;
        self.constructor = IllegalStateError;
        self.__proto__ = IllegalStateError.prototype;
        return _this5;
    }
    return IllegalStateError;
}(Error);
var $f596d2a117ee0b06$export$10a4c2bfc9c71dbd = function(_Error6) {
    $f596d2a117ee0b06$var$inherits(IllegalArgumentError, _Error6);
    function IllegalArgumentError(message) {
        $f596d2a117ee0b06$var$classCallCheck(this, IllegalArgumentError);
        var _this6 = $f596d2a117ee0b06$var$possibleConstructorReturn(this, (IllegalArgumentError.__proto__ || Object.getPrototypeOf(IllegalArgumentError)).call(this, message));
        _this6.name = "IllegalArgumentError";
        var self = _this6;
        self.constructor = IllegalArgumentError;
        self.__proto__ = IllegalArgumentError.prototype;
        return _this6;
    }
    return IllegalArgumentError;
}(Error);
var $f596d2a117ee0b06$export$e162153238934121 = function(_Error7) {
    $f596d2a117ee0b06$var$inherits(NotImplementedError, _Error7);
    function NotImplementedError(message) {
        $f596d2a117ee0b06$var$classCallCheck(this, NotImplementedError);
        var _this7 = $f596d2a117ee0b06$var$possibleConstructorReturn(this, (NotImplementedError.__proto__ || Object.getPrototypeOf(NotImplementedError)).call(this, message));
        _this7.name = "NotImplementedError";
        var self = _this7;
        self.constructor = NotImplementedError;
        self.__proto__ = NotImplementedError.prototype;
        return _this7;
    }
    return NotImplementedError;
}(Error);
var $f596d2a117ee0b06$export$66d311bf29d5c89c = function(_Error8) {
    $f596d2a117ee0b06$var$inherits(TimeoutError, _Error8);
    function TimeoutError(message) {
        $f596d2a117ee0b06$var$classCallCheck(this, TimeoutError);
        var _this8 = $f596d2a117ee0b06$var$possibleConstructorReturn(this, (TimeoutError.__proto__ || Object.getPrototypeOf(TimeoutError)).call(this, message));
        _this8.name = "TimeoutError";
        var self = _this8;
        self.constructor = TimeoutError;
        self.__proto__ = TimeoutError.prototype;
        return _this8;
    }
    return TimeoutError;
}(Error);
function $f596d2a117ee0b06$var$convertToMethod(f) {
    return function() {
        var args = Array.prototype.slice.call(arguments);
        args.push(this);
        return f.apply(undefined, args);
    };
}
function $f596d2a117ee0b06$var$fantasyLandRegister(cls, monad, setoid) {
    var c = cls;
    var p = c.prototype;
    var fl = "fantasy-land/";
    var equals = "equals";
    var flEquals = fl + equals;
    var map = "map";
    var flMap = fl + map;
    var ap = "ap";
    var flAp = fl + ap;
    var flOf = fl + "of";
    var chain = "chain";
    var flChain = fl + chain;
    var chainRec = "chainRec";
    var flChainRec = fl + chainRec;
    if (p[equals]) p[flEquals] = p[equals];
    else if (setoid) p[flEquals] = $f596d2a117ee0b06$var$convertToMethod(setoid.equals);
    if (p[map]) p[flMap] = p[map];
    else if (monad) p[flMap] = $f596d2a117ee0b06$var$convertToMethod(monad.map);
    if (p[ap]) p[flAp] = p[ap];
    else if (monad) p[flAp] = $f596d2a117ee0b06$var$convertToMethod(monad.ap);
    if (c["pure"]) c[flOf] = c["pure"];
    else if (monad) c[flOf] = monad.of;
    if (p[chain]) p[flChain] = p[chain];
    else if (monad) p[flChain] = $f596d2a117ee0b06$var$convertToMethod(monad.chain);
    if (c[chainRec]) c[flChainRec] = c[chainRec];
    else if (monad) c[flChainRec] = monad.chainRec;
}
var $f596d2a117ee0b06$export$37fdcdf447590763 = Object.freeze({
    convertToMethod: $f596d2a117ee0b06$var$convertToMethod,
    fantasyLandRegister: $f596d2a117ee0b06$var$fantasyLandRegister
});
var $f596d2a117ee0b06$export$37cbe166bfc81b63 = function() {
    function Either(value, tag) {
        $f596d2a117ee0b06$var$classCallCheck(this, Either);
        this._isRight = tag === "right";
        this.value = value;
    }
    $f596d2a117ee0b06$var$createClass(Either, [
        {
            key: "isLeft",
            value: function isLeft() {
                return !this._isRight;
            }
        },
        {
            key: "isRight",
            value: function isRight() {
                return this._isRight;
            }
        },
        {
            key: "contains",
            value: function contains(elem) {
                return this._isRight && $f596d2a117ee0b06$export$226b3eccf92c9ed9(this.value, elem);
            }
        },
        {
            key: "exists",
            value: function exists(p) {
                return this._isRight && p(this.value);
            }
        },
        {
            key: "filterOrElse",
            value: function filterOrElse(p, zero) {
                return this._isRight ? p(this.value) ? this : $f596d2a117ee0b06$export$37c4d04eafdc5515(zero()) : this;
            }
        },
        {
            key: "flatMap",
            value: function flatMap(f) {
                return this._isRight ? f(this.value) : this;
            }
        },
        {
            key: "chain",
            value: function chain(f) {
                return this.flatMap(f);
            }
        },
        {
            key: "ap",
            value: function ap(ff) {
                var _this = this;
                return ff.flatMap(function(f) {
                    return _this.map(f);
                });
            }
        },
        {
            key: "fold",
            value: function fold(left, right) {
                return this._isRight ? right(this.value) : left(this.value);
            }
        },
        {
            key: "forAll",
            value: function forAll(p) {
                return !this._isRight || p(this.value);
            }
        },
        {
            key: "get",
            value: function get$$1() {
                if (this._isRight) return this.value;
                throw new $f596d2a117ee0b06$export$48d368d160387990("left.get()");
            }
        },
        {
            key: "getOrElse",
            value: function getOrElse(fallback) {
                return this._isRight ? this.value : fallback;
            }
        },
        {
            key: "getOrElseL",
            value: function getOrElseL(thunk) {
                return this._isRight ? this.value : thunk();
            }
        },
        {
            key: "map",
            value: function map(f) {
                return this._isRight ? $f596d2a117ee0b06$export$19db0165690c701a(f(this.value)) : this;
            }
        },
        {
            key: "forEach",
            value: function forEach(cb) {
                if (this._isRight) cb(this.value);
            }
        },
        {
            key: "swap",
            value: function swap() {
                return this._isRight ? $f596d2a117ee0b06$export$37c4d04eafdc5515(this.value) : $f596d2a117ee0b06$export$19db0165690c701a(this.value);
            }
        },
        {
            key: "toOption",
            value: function toOption() {
                return this._isRight ? $f596d2a117ee0b06$export$9f9d0139d032da4f(this.value) : $f596d2a117ee0b06$export$57ca7e07b341709d;
            }
        },
        {
            key: "equals",
            value: function equals$$1(that) {
                if (that == null) return false;
                return this._isRight === that._isRight && $f596d2a117ee0b06$export$226b3eccf92c9ed9(this.value, that.value);
            }
        },
        {
            key: "hashCode",
            value: function hashCode$$1() {
                return this._isRight ? $f596d2a117ee0b06$export$d41d9ab3de2def3d(this.value) << 2 : $f596d2a117ee0b06$export$d41d9ab3de2def3d(this.value) << 3;
            }
        }
    ], [
        {
            key: "pure",
            value: function pure(value) {
                return new $f596d2a117ee0b06$export$8cd6fcff08338c9a(value);
            }
        },
        {
            key: "left",
            value: function left(value) {
                return $f596d2a117ee0b06$export$37c4d04eafdc5515(value);
            }
        },
        {
            key: "right",
            value: function right(value) {
                return $f596d2a117ee0b06$export$19db0165690c701a(value);
            }
        },
        {
            key: "map2",
            value: function map2(fa1, fa2, f) {
                if (fa1.isLeft()) return fa1;
                if (fa2.isLeft()) return fa2;
                return $f596d2a117ee0b06$export$19db0165690c701a(f(fa1.value, fa2.value));
            }
        },
        {
            key: "map3",
            value: function map3(fa1, fa2, fa3, f) {
                if (fa1.isLeft()) return fa1;
                if (fa2.isLeft()) return fa2;
                if (fa3.isLeft()) return fa3;
                return $f596d2a117ee0b06$export$19db0165690c701a(f(fa1.value, fa2.value, fa3.value));
            }
        },
        {
            key: "map4",
            value: function map4(fa1, fa2, fa3, fa4, f) {
                if (fa1.isLeft()) return fa1;
                if (fa2.isLeft()) return fa2;
                if (fa3.isLeft()) return fa3;
                if (fa4.isLeft()) return fa4;
                return $f596d2a117ee0b06$export$19db0165690c701a(f(fa1.value, fa2.value, fa3.value, fa4.value));
            }
        },
        {
            key: "map5",
            value: function map5(fa1, fa2, fa3, fa4, fa5, f) {
                if (fa1.isLeft()) return fa1;
                if (fa2.isLeft()) return fa2;
                if (fa3.isLeft()) return fa3;
                if (fa4.isLeft()) return fa4;
                if (fa5.isLeft()) return fa5;
                return $f596d2a117ee0b06$export$19db0165690c701a(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value));
            }
        },
        {
            key: "map6",
            value: function map6(fa1, fa2, fa3, fa4, fa5, fa6, f) {
                if (fa1.isLeft()) return fa1;
                if (fa2.isLeft()) return fa2;
                if (fa3.isLeft()) return fa3;
                if (fa4.isLeft()) return fa4;
                if (fa5.isLeft()) return fa5;
                if (fa6.isLeft()) return fa6;
                return $f596d2a117ee0b06$export$19db0165690c701a(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value, fa6.value));
            }
        },
        {
            key: "tailRecM",
            value: function tailRecM(a, f) {
                var cursor = a;
                while(true){
                    var result = f(cursor);
                    if (!result.isRight()) return result;
                    var some = result.value;
                    if (some.isRight()) return $f596d2a117ee0b06$export$19db0165690c701a(some.value);
                    cursor = some.value;
                }
            }
        }
    ]);
    return Either;
}();
var $f596d2a117ee0b06$export$500560ce56dda718 = function(_Either) {
    $f596d2a117ee0b06$var$inherits(TLeft, _Either);
    function TLeft(value) {
        $f596d2a117ee0b06$var$classCallCheck(this, TLeft);
        return $f596d2a117ee0b06$var$possibleConstructorReturn(this, (TLeft.__proto__ || Object.getPrototypeOf(TLeft)).call(this, value, "left"));
    }
    return TLeft;
}($f596d2a117ee0b06$export$37cbe166bfc81b63);
function $f596d2a117ee0b06$export$37c4d04eafdc5515(value) {
    return new $f596d2a117ee0b06$export$500560ce56dda718(value);
}
var $f596d2a117ee0b06$export$8cd6fcff08338c9a = function(_Either2) {
    $f596d2a117ee0b06$var$inherits(TRight, _Either2);
    function TRight(value) {
        $f596d2a117ee0b06$var$classCallCheck(this, TRight);
        return $f596d2a117ee0b06$var$possibleConstructorReturn(this, (TRight.__proto__ || Object.getPrototypeOf(TRight)).call(this, value, "right"));
    }
    return TRight;
}($f596d2a117ee0b06$export$37cbe166bfc81b63);
function $f596d2a117ee0b06$export$19db0165690c701a(value) {
    return new $f596d2a117ee0b06$export$8cd6fcff08338c9a(value);
}
var $f596d2a117ee0b06$export$e772b5f99e4d377d = {
    equals: function equals$$1(x, y) {
        return x ? x.equals(y) : !y;
    },
    map: function map(f, fa) {
        return fa.map(f);
    },
    ap: function ap(ff, fa) {
        return fa.ap(ff);
    },
    of: $f596d2a117ee0b06$export$37cbe166bfc81b63.pure,
    chain: function chain(f, fa) {
        return fa.flatMap(f);
    },
    chainRec: function chainRec(f, a) {
        return $f596d2a117ee0b06$export$37cbe166bfc81b63.tailRecM(a, function(a) {
            return f($f596d2a117ee0b06$export$37cbe166bfc81b63.left, $f596d2a117ee0b06$export$37cbe166bfc81b63.right, a);
        });
    }
};
$f596d2a117ee0b06$var$fantasyLandRegister($f596d2a117ee0b06$export$37cbe166bfc81b63, $f596d2a117ee0b06$export$e772b5f99e4d377d, $f596d2a117ee0b06$export$e772b5f99e4d377d);
var $f596d2a117ee0b06$export$36d18380658d5d20 = function() {
    function Option(ref, isEmpty) {
        $f596d2a117ee0b06$var$classCallCheck(this, Option);
        this._isEmpty = isEmpty != null ? isEmpty : ref === null || ref === undefined;
        this.value = ref;
    }
    $f596d2a117ee0b06$var$createClass(Option, [
        {
            key: "get",
            value: function get$$1() {
                if (!this._isEmpty) return this.value;
                throw new $f596d2a117ee0b06$export$48d368d160387990("Option.get");
            }
        },
        {
            key: "getOrElse",
            value: function getOrElse(fallback) {
                if (!this._isEmpty) return this.value;
                else return fallback;
            }
        },
        {
            key: "orNull",
            value: function orNull() {
                return !this._isEmpty ? this.value : null;
            }
        },
        {
            key: "orUndefined",
            value: function orUndefined() {
                return !this._isEmpty ? this.value : undefined;
            }
        },
        {
            key: "getOrElseL",
            value: function getOrElseL(thunk) {
                if (!this._isEmpty) return this.value;
                else return thunk();
            }
        },
        {
            key: "orElse",
            value: function orElse(fallback) {
                if (!this._isEmpty) return this;
                else return fallback;
            }
        },
        {
            key: "orElseL",
            value: function orElseL(thunk) {
                if (!this._isEmpty) return this;
                else return thunk();
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this._isEmpty;
            }
        },
        {
            key: "nonEmpty",
            value: function nonEmpty() {
                return !this._isEmpty;
            }
        },
        {
            key: "map",
            value: function map(f) {
                return this._isEmpty ? $f596d2a117ee0b06$export$57ca7e07b341709d : $f596d2a117ee0b06$export$9f9d0139d032da4f(f(this.value));
            }
        },
        {
            key: "flatMap",
            value: function flatMap(f) {
                if (this._isEmpty) return $f596d2a117ee0b06$export$57ca7e07b341709d;
                else return f(this.value);
            }
        },
        {
            key: "chain",
            value: function chain(f) {
                return this.flatMap(f);
            }
        },
        {
            key: "ap",
            value: function ap(ff) {
                var _this4 = this;
                return ff.flatMap(function(f) {
                    return _this4.map(f);
                });
            }
        },
        {
            key: "filter",
            value: function filter(p) {
                if (this._isEmpty || !p(this.value)) return $f596d2a117ee0b06$export$57ca7e07b341709d;
                else return this;
            }
        },
        {
            key: "fold",
            value: function fold(fallback, f) {
                if (this._isEmpty) return fallback();
                return f(this.value);
            }
        },
        {
            key: "contains",
            value: function contains(elem) {
                return !this._isEmpty && $f596d2a117ee0b06$export$226b3eccf92c9ed9(this.value, elem);
            }
        },
        {
            key: "exists",
            value: function exists(p) {
                return !this._isEmpty && p(this.value);
            }
        },
        {
            key: "forAll",
            value: function forAll(p) {
                return this._isEmpty || p(this.value);
            }
        },
        {
            key: "forEach",
            value: function forEach(cb) {
                if (!this._isEmpty) cb(this.value);
            }
        },
        {
            key: "equals",
            value: function equals$$1(that) {
                if (that == null) return false;
                if (this.nonEmpty() && that.nonEmpty()) return $f596d2a117ee0b06$export$226b3eccf92c9ed9(this.value, that.value);
                return this.isEmpty() && that.isEmpty();
            }
        },
        {
            key: "hashCode",
            value: function hashCode$$1() {
                if (this._isEmpty) return 2433880;
                else if (this.value == null) return 9735524;
                else return $f596d2a117ee0b06$export$d41d9ab3de2def3d(this.value) << 2;
            }
        }
    ], [
        {
            key: "of",
            value: function of(value) {
                return value != null ? $f596d2a117ee0b06$export$9f9d0139d032da4f(value) : $f596d2a117ee0b06$export$57ca7e07b341709d;
            }
        },
        {
            key: "some",
            value: function some(value) {
                return new Option(value, false);
            }
        },
        {
            key: "none",
            value: function none() {
                return $f596d2a117ee0b06$export$57ca7e07b341709d;
            }
        },
        {
            key: "empty",
            value: function empty() {
                return $f596d2a117ee0b06$export$57ca7e07b341709d;
            }
        },
        {
            key: "pure",
            value: function pure(value) {
                return $f596d2a117ee0b06$export$9f9d0139d032da4f(value);
            }
        },
        {
            key: "map2",
            value: function map2(fa1, fa2, f) {
                return fa1.nonEmpty() && fa2.nonEmpty() ? $f596d2a117ee0b06$export$9f9d0139d032da4f(f(fa1.value, fa2.value)) : $f596d2a117ee0b06$export$57ca7e07b341709d;
            }
        },
        {
            key: "map3",
            value: function map3(fa1, fa2, fa3, f) {
                return fa1.nonEmpty() && fa2.nonEmpty() && fa3.nonEmpty() ? $f596d2a117ee0b06$export$9f9d0139d032da4f(f(fa1.value, fa2.value, fa3.value)) : $f596d2a117ee0b06$export$57ca7e07b341709d;
            }
        },
        {
            key: "map4",
            value: function map4(fa1, fa2, fa3, fa4, f) {
                return fa1.nonEmpty() && fa2.nonEmpty() && fa3.nonEmpty() && fa4.nonEmpty() ? $f596d2a117ee0b06$export$9f9d0139d032da4f(f(fa1.value, fa2.value, fa3.value, fa4.value)) : $f596d2a117ee0b06$export$57ca7e07b341709d;
            }
        },
        {
            key: "map5",
            value: function map5(fa1, fa2, fa3, fa4, fa5, f) {
                return fa1.nonEmpty() && fa2.nonEmpty() && fa3.nonEmpty() && fa4.nonEmpty() && fa5.nonEmpty() ? $f596d2a117ee0b06$export$9f9d0139d032da4f(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value)) : $f596d2a117ee0b06$export$57ca7e07b341709d;
            }
        },
        {
            key: "map6",
            value: function map6(fa1, fa2, fa3, fa4, fa5, fa6, f) {
                return fa1.nonEmpty() && fa2.nonEmpty() && fa3.nonEmpty() && fa4.nonEmpty() && fa5.nonEmpty() && fa6.nonEmpty() ? $f596d2a117ee0b06$export$9f9d0139d032da4f(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value, fa6.value)) : $f596d2a117ee0b06$export$57ca7e07b341709d;
            }
        },
        {
            key: "tailRecM",
            value: function tailRecM(a, f) {
                var cursor = a;
                while(true){
                    var result = f(cursor);
                    if (result.nonEmpty()) {
                        var some = result.value;
                        if (some.isRight()) return $f596d2a117ee0b06$export$9f9d0139d032da4f(some.value);
                        cursor = some.value;
                    } else return $f596d2a117ee0b06$export$57ca7e07b341709d;
                }
            }
        }
    ]);
    return Option;
}();
var $f596d2a117ee0b06$export$c279cda0429c6dbe = function(_Option) {
    $f596d2a117ee0b06$var$inherits(TSome, _Option);
    function TSome(value) {
        $f596d2a117ee0b06$var$classCallCheck(this, TSome);
        return $f596d2a117ee0b06$var$possibleConstructorReturn(this, (TSome.__proto__ || Object.getPrototypeOf(TSome)).call(this, value, false));
    }
    return TSome;
}($f596d2a117ee0b06$export$36d18380658d5d20);
function $f596d2a117ee0b06$export$9f9d0139d032da4f(value) {
    return new $f596d2a117ee0b06$export$c279cda0429c6dbe(value);
}
var $f596d2a117ee0b06$export$ee2288f2b4bc04c4 = function(_Option2) {
    $f596d2a117ee0b06$var$inherits(TNone, _Option2);
    function TNone() {
        $f596d2a117ee0b06$var$classCallCheck(this, TNone);
        return $f596d2a117ee0b06$var$possibleConstructorReturn(this, (TNone.__proto__ || Object.getPrototypeOf(TNone)).call(this, undefined, true));
    }
    return TNone;
}($f596d2a117ee0b06$export$36d18380658d5d20);
var $f596d2a117ee0b06$export$57ca7e07b341709d = new $f596d2a117ee0b06$export$ee2288f2b4bc04c4();
var $f596d2a117ee0b06$export$dae05fd938c910bc = {
    equals: function equals$$1(x, y) {
        return x ? x.equals(y) : !y;
    },
    map: function map(f, fa) {
        return fa.map(f);
    },
    ap: function ap(ff, fa) {
        return fa.ap(ff);
    },
    of: $f596d2a117ee0b06$export$36d18380658d5d20.pure,
    chain: function chain(f, fa) {
        return fa.flatMap(f);
    },
    chainRec: function chainRec(f, a) {
        return $f596d2a117ee0b06$export$36d18380658d5d20.tailRecM(a, function(a) {
            return f($f596d2a117ee0b06$export$37cbe166bfc81b63.left, $f596d2a117ee0b06$export$37cbe166bfc81b63.right, a);
        });
    }
};
$f596d2a117ee0b06$var$fantasyLandRegister($f596d2a117ee0b06$export$36d18380658d5d20, $f596d2a117ee0b06$export$dae05fd938c910bc, $f596d2a117ee0b06$export$dae05fd938c910bc);
var $f596d2a117ee0b06$export$fa957d01b0310fd7 = function() {
    function Try(value, tag) {
        $f596d2a117ee0b06$var$classCallCheck(this, Try);
        this._isSuccess = tag === "success";
        this.value = value;
    }
    $f596d2a117ee0b06$var$createClass(Try, [
        {
            key: "isSuccess",
            value: function isSuccess() {
                return this._isSuccess;
            }
        },
        {
            key: "isFailure",
            value: function isFailure() {
                return !this._isSuccess;
            }
        },
        {
            key: "get",
            value: function get$$1() {
                if (!this._isSuccess) throw this.value;
                return this.value;
            }
        },
        {
            key: "getOrElse",
            value: function getOrElse(fallback) {
                return this._isSuccess ? this.value : fallback;
            }
        },
        {
            key: "getOrElseL",
            value: function getOrElseL(thunk) {
                return this._isSuccess ? this.value : thunk();
            }
        },
        {
            key: "orNull",
            value: function orNull() {
                return this._isSuccess ? this.value : null;
            }
        },
        {
            key: "orUndefined",
            value: function orUndefined() {
                return this._isSuccess ? this.value : undefined;
            }
        },
        {
            key: "orElse",
            value: function orElse(fallback) {
                if (this._isSuccess) return this;
                return fallback;
            }
        },
        {
            key: "orElseL",
            value: function orElseL(thunk) {
                if (this._isSuccess) return this;
                return thunk();
            }
        },
        {
            key: "failed",
            value: function failed() {
                return this._isSuccess ? $f596d2a117ee0b06$export$5ebc9a4af3ac0850(new $f596d2a117ee0b06$export$48d368d160387990("try.failed()")) : $f596d2a117ee0b06$export$ffa3d9fee6fd705a(this.value);
            }
        },
        {
            key: "fold",
            value: function fold(failure, success) {
                return this._isSuccess ? success(this.value) : failure(this.value);
            }
        },
        {
            key: "filter",
            value: function filter(p) {
                if (!this._isSuccess) return this;
                try {
                    if (p(this.value)) return this;
                    return $f596d2a117ee0b06$export$5ebc9a4af3ac0850(new $f596d2a117ee0b06$export$48d368d160387990("Predicate does not hold for " + this.value));
                } catch (e) {
                    return $f596d2a117ee0b06$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "flatMap",
            value: function flatMap(f) {
                if (!this._isSuccess) return this;
                try {
                    return f(this.value);
                } catch (e) {
                    return $f596d2a117ee0b06$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "chain",
            value: function chain(f) {
                return this.flatMap(f);
            }
        },
        {
            key: "ap",
            value: function ap(ff) {
                var _this7 = this;
                return ff.flatMap(function(f) {
                    return _this7.map(f);
                });
            }
        },
        {
            key: "map",
            value: function map(f) {
                var _this8 = this;
                return this._isSuccess ? Try.of(function() {
                    return f(_this8.value);
                }) : this;
            }
        },
        {
            key: "forEach",
            value: function forEach(cb) {
                if (this._isSuccess) cb(this.value);
            }
        },
        {
            key: "recover",
            value: function recover(f) {
                var _this9 = this;
                return this._isSuccess ? this : Try.of(function() {
                    return f(_this9.value);
                });
            }
        },
        {
            key: "recoverWith",
            value: function recoverWith(f) {
                try {
                    return this._isSuccess ? this : f(this.value);
                } catch (e) {
                    return $f596d2a117ee0b06$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "toOption",
            value: function toOption() {
                return this._isSuccess ? $f596d2a117ee0b06$export$9f9d0139d032da4f(this.value) : $f596d2a117ee0b06$export$57ca7e07b341709d;
            }
        },
        {
            key: "toEither",
            value: function toEither() {
                return this._isSuccess ? $f596d2a117ee0b06$export$19db0165690c701a(this.value) : $f596d2a117ee0b06$export$37c4d04eafdc5515(this.value);
            }
        },
        {
            key: "equals",
            value: function equals$$1(that) {
                if (that == null) return false;
                return this._isSuccess ? that._isSuccess && $f596d2a117ee0b06$export$226b3eccf92c9ed9(this.value, that.value) : !that._isSuccess && $f596d2a117ee0b06$export$226b3eccf92c9ed9(this.value, that.value);
            }
        },
        {
            key: "hashCode",
            value: function hashCode$$1() {
                return this._isSuccess ? $f596d2a117ee0b06$export$d41d9ab3de2def3d(this.value) : $f596d2a117ee0b06$export$d41d9ab3de2def3d(this.value);
            }
        }
    ], [
        {
            key: "of",
            value: function of(thunk) {
                try {
                    return $f596d2a117ee0b06$export$ffa3d9fee6fd705a(thunk());
                } catch (e) {
                    return $f596d2a117ee0b06$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "pure",
            value: function pure(value) {
                return Try.success(value);
            }
        },
        {
            key: "unit",
            value: function unit() {
                return $f596d2a117ee0b06$var$tryUnitRef;
            }
        },
        {
            key: "success",
            value: function success(value) {
                return $f596d2a117ee0b06$export$ffa3d9fee6fd705a(value);
            }
        },
        {
            key: "failure",
            value: function failure(e) {
                return $f596d2a117ee0b06$export$5ebc9a4af3ac0850(e);
            }
        },
        {
            key: "raise",
            value: function raise(e) {
                return $f596d2a117ee0b06$export$5ebc9a4af3ac0850(e);
            }
        },
        {
            key: "map2",
            value: function map2(fa1, fa2, f) {
                if (fa1.isFailure()) return fa1;
                if (fa2.isFailure()) return fa2;
                try {
                    return $f596d2a117ee0b06$export$ffa3d9fee6fd705a(f(fa1.value, fa2.value));
                } catch (e) {
                    return $f596d2a117ee0b06$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "map3",
            value: function map3(fa1, fa2, fa3, f) {
                if (fa1.isFailure()) return fa1;
                if (fa2.isFailure()) return fa2;
                if (fa3.isFailure()) return fa3;
                try {
                    return $f596d2a117ee0b06$export$ffa3d9fee6fd705a(f(fa1.value, fa2.value, fa3.value));
                } catch (e) {
                    return $f596d2a117ee0b06$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "map4",
            value: function map4(fa1, fa2, fa3, fa4, f) {
                if (fa1.isFailure()) return fa1;
                if (fa2.isFailure()) return fa2;
                if (fa3.isFailure()) return fa3;
                if (fa4.isFailure()) return fa4;
                try {
                    return $f596d2a117ee0b06$export$ffa3d9fee6fd705a(f(fa1.value, fa2.value, fa3.value, fa4.value));
                } catch (e) {
                    return $f596d2a117ee0b06$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "map5",
            value: function map5(fa1, fa2, fa3, fa4, fa5, f) {
                if (fa1.isFailure()) return fa1;
                if (fa2.isFailure()) return fa2;
                if (fa3.isFailure()) return fa3;
                if (fa4.isFailure()) return fa4;
                if (fa5.isFailure()) return fa5;
                try {
                    return $f596d2a117ee0b06$export$ffa3d9fee6fd705a(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value));
                } catch (e) {
                    return $f596d2a117ee0b06$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "map6",
            value: function map6(fa1, fa2, fa3, fa4, fa5, fa6, f) {
                if (fa1.isFailure()) return fa1;
                if (fa2.isFailure()) return fa2;
                if (fa3.isFailure()) return fa3;
                if (fa4.isFailure()) return fa4;
                if (fa5.isFailure()) return fa5;
                if (fa6.isFailure()) return fa6;
                try {
                    return $f596d2a117ee0b06$export$ffa3d9fee6fd705a(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value, fa6.value));
                } catch (e) {
                    return $f596d2a117ee0b06$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "tailRecM",
            value: function tailRecM(a, f) {
                var cursor = a;
                while(true)try {
                    var result = f(cursor);
                    if (result.isFailure()) return result;
                    var some = result.get();
                    if (some.isRight()) return $f596d2a117ee0b06$export$ffa3d9fee6fd705a(some.value);
                    cursor = some.value;
                } catch (e) {
                    return $f596d2a117ee0b06$export$5ebc9a4af3ac0850(e);
                }
            }
        }
    ]);
    return Try;
}();
var $f596d2a117ee0b06$export$a78bea8ed2ae2fde = function(_Try) {
    $f596d2a117ee0b06$var$inherits(TSuccess, _Try);
    function TSuccess(value) {
        $f596d2a117ee0b06$var$classCallCheck(this, TSuccess);
        return $f596d2a117ee0b06$var$possibleConstructorReturn(this, (TSuccess.__proto__ || Object.getPrototypeOf(TSuccess)).call(this, value, "success"));
    }
    return TSuccess;
}($f596d2a117ee0b06$export$fa957d01b0310fd7);
function $f596d2a117ee0b06$export$ffa3d9fee6fd705a(value) {
    return new $f596d2a117ee0b06$export$a78bea8ed2ae2fde(value);
}
var $f596d2a117ee0b06$export$a432f16a0795683f = function(_Try2) {
    $f596d2a117ee0b06$var$inherits(TFailure, _Try2);
    function TFailure(value) {
        $f596d2a117ee0b06$var$classCallCheck(this, TFailure);
        return $f596d2a117ee0b06$var$possibleConstructorReturn(this, (TFailure.__proto__ || Object.getPrototypeOf(TFailure)).call(this, value, "failure"));
    }
    return TFailure;
}($f596d2a117ee0b06$export$fa957d01b0310fd7);
function $f596d2a117ee0b06$export$5ebc9a4af3ac0850(e) {
    return new $f596d2a117ee0b06$export$a432f16a0795683f(e);
}
var $f596d2a117ee0b06$export$93cc75c33014d88a = {
    equals: function equals$$1(x, y) {
        return x ? x.equals(y) : !y;
    },
    map: function map(f, fa) {
        return fa.map(f);
    },
    ap: function ap(ff, fa) {
        return fa.ap(ff);
    },
    of: $f596d2a117ee0b06$export$fa957d01b0310fd7.pure,
    chain: function chain(f, fa) {
        return fa.flatMap(f);
    },
    chainRec: function chainRec(f, a) {
        return $f596d2a117ee0b06$export$fa957d01b0310fd7.tailRecM(a, function(a) {
            return f($f596d2a117ee0b06$export$37cbe166bfc81b63.left, $f596d2a117ee0b06$export$37cbe166bfc81b63.right, a);
        });
    }
};
$f596d2a117ee0b06$var$fantasyLandRegister($f596d2a117ee0b06$export$fa957d01b0310fd7, $f596d2a117ee0b06$export$93cc75c33014d88a, $f596d2a117ee0b06$export$93cc75c33014d88a);
var $f596d2a117ee0b06$var$tryUnitRef = $f596d2a117ee0b06$export$ffa3d9fee6fd705a(undefined);

});



parcelRegister("6l8Gn", function(module, exports) {

$parcel$export(module.exports, "loadBranchesResource", function () { return $de53d79c0555ffff$export$da578271b24ed77; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $abRa1 = parcelRequire("abRa1");

var $kZnTB = parcelRequire("kZnTB");

var $k2cPS = parcelRequire("k2cPS");
const $de53d79c0555ffff$var$fetchData = async (repoOwner, repoSlug, sourceBranch, destRepo, destBranch)=>{
    const url = (0, $kZnTB.default).api.internal.createPullRequestData(repoOwner, repoSlug, sourceBranch, destRepo, destBranch);
    const resp = await fetch((0, $k2cPS.default)(url));
    return resp.json();
};
const $de53d79c0555ffff$export$da578271b24ed77 = (0, $3kfkg.createResource)({
    type: "createPullRequestBranches",
    getKey: ({ match: match, query: query })=>{
        return `createPullRequestBranches:${match.params.repositoryOwner}:${match.params.repositorySlug}:${query.source}:${query.dest}.`;
    },
    maxAge: 10000,
    // cache for 10 seconds to help with quick moves around pages, but refs could change so don't cache for too long
    getData: async ({ match: match, query: query })=>{
        const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug } = match.params;
        if (!repositoryOwner || !repositorySlug) throw new Error("Could not fetch create PR branches, URL params were not available");
        const { source: source, dest: dest } = query;
        let sourceBranchName;
        let destBranchName;
        let destRepoName;
        if (source && source.includes("::")) sourceBranchName = source.split("::")[1];
        else sourceBranchName = source;
        if (dest && dest.includes("::")) [destRepoName, destBranchName] = dest.split("::");
        else destBranchName = dest;
        const { source_branch: sourceBranch, dest_branch: destBranch, dest_repo: destRepo, error_on_source: errorOnSourceLoad, error_on_dest: errorOnDestLoad, can_access_parent_repo: showParentRepo, pull_request_url: pullRequestUrl } = await $de53d79c0555ffff$var$fetchData(repositoryOwner, repositorySlug, sourceBranchName, destRepoName, destBranchName);
        const sourceRef = (0, $abRa1.getRef)(sourceBranch);
        const destRef = (0, $abRa1.getRef)(destBranch);
        if (sourceRef === undefined) throw Error("undefined source ref");
        if (destRef === undefined) throw Error("undefined dest ref");
        return {
            sourceRef: sourceRef,
            errorOnSourceLoad: errorOnSourceLoad,
            destRepo: destRepo,
            destRef: destRef,
            errorOnDestLoad: errorOnDestLoad,
            showParentRepo: showParentRepo,
            pullRequestUrl: pullRequestUrl
        };
    }
});

});
parcelRegister("abRa1", function(module, exports) {

$parcel$export(module.exports, "getRepoOwnerAndSlug", function () { return $7e00e7621df7f0d8$export$9d009ace8288892e; });
$parcel$export(module.exports, "getRepoFullName", function () { return $7e00e7621df7f0d8$export$b5349ce103e8a1cc; });
$parcel$export(module.exports, "sanitizeBranchName", function () { return $7e00e7621df7f0d8$export$f4716d9265705b9e; });
$parcel$export(module.exports, "sanitizeIssueSummary", function () { return $7e00e7621df7f0d8$export$eee05511e8c67b21; });
$parcel$export(module.exports, "generateBranchName", function () { return $7e00e7621df7f0d8$export$a37da8057dfdf722; });
$parcel$export(module.exports, "getRef", function () { return $7e00e7621df7f0d8$export$f0c653cfd7dea798; });
$parcel$export(module.exports, "getRefs", function () { return $7e00e7621df7f0d8$export$298f5b3210f877af; });
$parcel$export(module.exports, "getNewBranchEnabledRef", function () { return $7e00e7621df7f0d8$export$96bc1244a2310885; });
$parcel$export(module.exports, "moveMainBranchToTop", function () { return $7e00e7621df7f0d8$export$6c1b5002dd25057e; });
$parcel$export(module.exports, "getRefOption", function () { return $7e00e7621df7f0d8$export$4291a0e31904ebec; });
$parcel$export(module.exports, "generateRefSelectorOptions", function () { return $7e00e7621df7f0d8$export$cf19af1f6074be5d; });
$parcel$export(module.exports, "areRefsSame", function () { return $7e00e7621df7f0d8$export$8d7725808657bf4d; });
$parcel$export(module.exports, "optionFilter", function () { return $7e00e7621df7f0d8$export$6ea3d2facad493d2; });
$parcel$export(module.exports, "limit", function () { return $7e00e7621df7f0d8$export$ee37e834aaad6f7e; });
$parcel$export(module.exports, "suggestFromBranch", function () { return $7e00e7621df7f0d8$export$1450b04188682388; });
// @ts-ignore TODO: fix noImplicitAny error here

var $bpHvF = parcelRequire("bpHvF");

var $biyfN = parcelRequire("biyfN");

var $h3kk7 = parcelRequire("h3kk7");

var $5gF7V = parcelRequire("5gF7V");
/* eslint-disable no-useless-escape */ // Derived from https://git-scm.com/docs/git-check-ref-format
const $7e00e7621df7f0d8$var$ILLEGAL_GIT_REF_CHARACTERS = /[\~\^\:\?\*\[\\]/g;
// Derived from https://docs.microsoft.com/en-us/windows/win32/fileio/naming-a-file
const $7e00e7621df7f0d8$var$RESERVED_WINDOWS_CHARACTERS = /[\<\>\"\|\%]/g;
// Incompatible or troublesome file system and shell characters
const $7e00e7621df7f0d8$var$INCOMPATIBLE_CHARACTERS = /[\]\;\+\'’\`\&\(\)\$\!\#\{\}\,\=\@]/g;
/* eslint-enable no-useless-escape */ const $7e00e7621df7f0d8$var$ASCII_CONTROL_CHARACTERS = /[\000-\037\177]/g;
const $7e00e7621df7f0d8$var$CONSECUTIVE_DOTS = /\.\.+/g;
const $7e00e7621df7f0d8$var$TRAILING_DOT = /\.$/g;
const $7e00e7621df7f0d8$var$CONSECUTIVE_SLASHES = /\/\/+/g;
const $7e00e7621df7f0d8$var$TRAILING_SLASH = /\/$/g;
const $7e00e7621df7f0d8$var$LEADING_SLASH = /^\//g;
const $7e00e7621df7f0d8$var$CONSECUTIVE_SPACES = /\s+/g;
const $7e00e7621df7f0d8$var$BRANCH_TYPES = [
    (0, $5gF7V.REF_TYPE).BRANCH
];
const $7e00e7621df7f0d8$export$9d009ace8288892e = (repoFullName = "")=>{
    return repoFullName.split("/", 2);
};
const $7e00e7621df7f0d8$export$b5349ce103e8a1cc = (repository)=>{
    return repository ? `${repository.owner}/${repository.slug}` : "";
};
const $7e00e7621df7f0d8$export$f4716d9265705b9e = (name)=>name.trim().replace($7e00e7621df7f0d8$var$ASCII_CONTROL_CHARACTERS, "").replace($7e00e7621df7f0d8$var$ILLEGAL_GIT_REF_CHARACTERS, "").replace($7e00e7621df7f0d8$var$RESERVED_WINDOWS_CHARACTERS, "").replace($7e00e7621df7f0d8$var$INCOMPATIBLE_CHARACTERS, "").replace($7e00e7621df7f0d8$var$CONSECUTIVE_DOTS, ".").replace($7e00e7621df7f0d8$var$TRAILING_DOT, "").replace($7e00e7621df7f0d8$var$CONSECUTIVE_SLASHES, "/").replace($7e00e7621df7f0d8$var$TRAILING_SLASH, "").replace($7e00e7621df7f0d8$var$LEADING_SLASH, "").replace($7e00e7621df7f0d8$var$CONSECUTIVE_SPACES, "-");
const $7e00e7621df7f0d8$export$eee05511e8c67b21 = (name)=>name.trim().replace("/", "-");
const $7e00e7621df7f0d8$export$a37da8057dfdf722 = (name, type)=>{
    const cleanedName = $7e00e7621df7f0d8$export$f4716d9265705b9e(name);
    // We only add the prefix if the user has typed something because a prefix only branch name doesn't make much
    // sense.
    if (cleanedName && type && type.prefix) return $7e00e7621df7f0d8$export$f4716d9265705b9e(`${type.prefix}${cleanedName}`);
    return cleanedName;
};
const $7e00e7621df7f0d8$export$f0c653cfd7dea798 = (o)=>({
        type: o.type ? o.type.toUpperCase() : (0, $5gF7V.REF_TYPE).BRANCH,
        name: o.name,
        hash: o.target ? o.target.hash : undefined
    });
const $7e00e7621df7f0d8$export$298f5b3210f877af = (objects)=>{
    return objects.map($7e00e7621df7f0d8$export$f0c653cfd7dea798);
};
const $7e00e7621df7f0d8$export$96bc1244a2310885 = (o)=>({
        type: o.type ? o.type.toUpperCase() : (0, $5gF7V.REF_TYPE).BRANCH,
        name: o.name,
        hash: o.target ? o.target.hash : undefined,
        isNewBranch: o.isNewBranch
    });
const $7e00e7621df7f0d8$export$7e649eb7dab467e = (objects)=>{
    return objects.map($7e00e7621df7f0d8$export$96bc1244a2310885);
};
// @ts-ignore TODO: fix noImplicitAny error here
const $7e00e7621df7f0d8$var$isMainBranchRef = (ref, mainBranch)=>{
    return $7e00e7621df7f0d8$var$BRANCH_TYPES.includes(ref.type) && ref.name === mainBranch.name;
};
const $7e00e7621df7f0d8$export$6c1b5002dd25057e = (refs, mainBranch, isFiltered)=>{
    if (!mainBranch) return refs;
    // @ts-ignore TODO: fix noImplicitAny error here
    const mainRef = refs.find((ref)=>$7e00e7621df7f0d8$var$isMainBranchRef(ref, mainBranch));
    if (mainRef) {
        const withoutMainBranch = refs.filter(// @ts-ignore TODO: fix noImplicitAny error here
        (ref)=>!$7e00e7621df7f0d8$var$isMainBranchRef(ref, mainBranch));
        return [
            mainRef,
            ...withoutMainBranch
        ];
    }
    if (isFiltered) return refs;
    return [
        $7e00e7621df7f0d8$export$f0c653cfd7dea798(mainBranch),
        ...refs
    ];
};
const $7e00e7621df7f0d8$export$4291a0e31904ebec = (ref)=>({
        label: ref.name,
        value: `${ref.type}:${ref.name}`,
        data: undefined,
        ref: ref
    });
const $7e00e7621df7f0d8$export$cf19af1f6074be5d = (refs)=>{
    const options = [];
    const branches = refs.filter((ref)=>$7e00e7621df7f0d8$var$BRANCH_TYPES.includes(ref.type));
    const tags = refs.filter((ref)=>ref.type === (0, $5gF7V.REF_TYPE).TAG);
    if (branches.length) options.push({
        label: "refSelectorLabelBranches",
        value: "refSelectorLabelBranches",
        data: undefined,
        options: branches.map((ref)=>$7e00e7621df7f0d8$export$4291a0e31904ebec(ref))
    });
    if (tags.length) options.push({
        label: "refSelectorLabelTags",
        value: "refSelectorLabelTags",
        data: undefined,
        options: tags.map((tag)=>$7e00e7621df7f0d8$export$4291a0e31904ebec(tag))
    });
    return options;
};
const $7e00e7621df7f0d8$export$8d7725808657bf4d = (ref1, ref2)=>{
    return ref1.name === ref2.name && ref1.type === ref2.type;
};
const $7e00e7621df7f0d8$export$6ea3d2facad493d2 = (0, $bpHvF.c)({
    // Ignoring accents is pretty expensive, and we strip out non-ASCII anyway
    ignoreAccents: false,
    // Only filter on label (by default it would filter both label and value, but we don't need filtering on values)
    // @ts-ignore TODO: fix noImplicitAny error here
    stringify: (option)=>option.label
});
const $7e00e7621df7f0d8$export$ee37e834aaad6f7e = (values, maxValues, predicate)=>{
    if (!predicate) return {
        values: values.slice(0, maxValues),
        hasMore: values.length > maxValues
    };
    const result = [];
    let hasMore = false;
    for (const value of values)if (predicate(value)) {
        if (result.length < maxValues) result.push(value);
        else {
            // Once we have enough matching values, we find one more to indicate whether the values are limited or not.
            hasMore = true;
            break;
        }
    }
    return {
        values: result,
        hasMore: hasMore
    };
};
const $7e00e7621df7f0d8$export$50a3ac59e5aa04a0 = (selectOption)=>{
    const [owner, slug] = selectOption.value.split("/");
    return {
        owner: owner,
        slug: slug
    };
};
const $7e00e7621df7f0d8$export$1450b04188682388 = (workflowBranches, branchType)=>{
    const { development: development, production: production, main: main } = workflowBranches;
    // When branching model has not been fetched yet (or request ended up
    // with an error), we suggest the main branch as the best option
    const defaultSuggestion = development || main;
    const isHotfix = branchType && branchType.kind === (0, $biyfN.BRANCH_KIND).HOT_FIX;
    if (isHotfix && production) return production;
    else return defaultSuggestion;
};
const $7e00e7621df7f0d8$export$1693f10cfe1beedd = ()=>{
    return (0, $h3kk7.default).get((0, $5gF7V.JIRA_ISSUE_MAPPING_MESSAGE_SHOWN), false);
};
const $7e00e7621df7f0d8$export$e33fb209c76da76c = (shown)=>{
    return (0, $h3kk7.default).set((0, $5gF7V.JIRA_ISSUE_MAPPING_MESSAGE_SHOWN), shown);
};

});
parcelRegister("biyfN", function(module, exports) {

$parcel$export(module.exports, "BRANCH_KIND", function () { return $390d372d6197e0cd$export$f4bf7af9ed33adb3; });
var $390d372d6197e0cd$export$f4bf7af9ed33adb3;
(function(BRANCH_KIND) {
    BRANCH_KIND["OTHER"] = "other";
    BRANCH_KIND["FEATURE"] = "feature";
    BRANCH_KIND["BUG_FIX"] = "bugfix";
    BRANCH_KIND["HOT_FIX"] = "hotfix";
    BRANCH_KIND["RELEASE"] = "release";
})($390d372d6197e0cd$export$f4bf7af9ed33adb3 || ($390d372d6197e0cd$export$f4bf7af9ed33adb3 = {}));

});

parcelRegister("5gF7V", function(module, exports) {

$parcel$export(module.exports, "CREATE_BRANCH_FORM_ID", function () { return $8ee4c1cccc60297e$export$7a87589224b0108; });
$parcel$export(module.exports, "CREATE_FROM", function () { return $8ee4c1cccc60297e$export$3a1d4a37fb268ffc; });
$parcel$export(module.exports, "EXTENDED_BRANCH_KINDS", function () { return $8ee4c1cccc60297e$export$64c3f95ec512910b; });
$parcel$export(module.exports, "BRANCH_TYPE_OTHER", function () { return $8ee4c1cccc60297e$export$ec155221f6eefe5b; });
$parcel$export(module.exports, "LOADING_STATE", function () { return $8ee4c1cccc60297e$export$40d7c6d204875c5b; });
$parcel$export(module.exports, "CREATE_BRANCH_ERROR_TYPE", function () { return $8ee4c1cccc60297e$export$8987e7f72b40d88e; });
$parcel$export(module.exports, "REF_TYPE", function () { return $8ee4c1cccc60297e$export$412afd13f6f23029; });
$parcel$export(module.exports, "JIRA_ISSUE_MAPPING_MESSAGE_SHOWN", function () { return $8ee4c1cccc60297e$export$63b84933b9012208; });
$parcel$export(module.exports, "JIRA_ISSUE_TYPE_MAPPING", function () { return $8ee4c1cccc60297e$export$5d9568283e9dc06f; });
$parcel$export(module.exports, "SAFE_JIRA_ISSUE_TYPES", function () { return $8ee4c1cccc60297e$export$f9d40efe2f40921e; });
$parcel$export(module.exports, "JIRA_BUG_KEYS", function () { return $8ee4c1cccc60297e$export$5754005b9ee99338; });

var $biyfN = parcelRequire("biyfN");
const $8ee4c1cccc60297e$export$7a87589224b0108 = "create-branch-form";
var $8ee4c1cccc60297e$export$3a1d4a37fb268ffc;
(function(CREATE_FROM) {
    CREATE_FROM["REPO_DIALOG"] = "createBranchDialog";
    CREATE_FROM["GLOBAL_DIALOG"] = "createBranchDialogGlobal";
    CREATE_FROM["REPO_PAGE"] = "createBranchScreen";
    CREATE_FROM["GLOBAL_PAGE"] = "createBranchScreenGlobal";
})($8ee4c1cccc60297e$export$3a1d4a37fb268ffc || ($8ee4c1cccc60297e$export$3a1d4a37fb268ffc = {}));
var $8ee4c1cccc60297e$export$64c3f95ec512910b;
(function(EXTENDED_BRANCH_KINDS) {
    EXTENDED_BRANCH_KINDS["OTHER"] = "other";
})($8ee4c1cccc60297e$export$64c3f95ec512910b || ($8ee4c1cccc60297e$export$64c3f95ec512910b = {}));
const $8ee4c1cccc60297e$export$ec155221f6eefe5b = Object.freeze({
    kind: "other",
    prefix: ""
});
var $8ee4c1cccc60297e$export$40d7c6d204875c5b;
(function(LOADING_STATE) {
    LOADING_STATE["LOADING"] = "LOADING";
    LOADING_STATE["SUCCESS"] = "SUCCESS";
    LOADING_STATE["ERROR"] = "ERROR";
})($8ee4c1cccc60297e$export$40d7c6d204875c5b || ($8ee4c1cccc60297e$export$40d7c6d204875c5b = {}));
var $8ee4c1cccc60297e$export$8987e7f72b40d88e;
(function(CREATE_BRANCH_ERROR_TYPE) {
    CREATE_BRANCH_ERROR_TYPE["BRANCH_ALREADY_EXISTS"] = "BRANCH_ALREADY_EXISTS";
    CREATE_BRANCH_ERROR_TYPE["BRANCH_PERMISSION_VIOLATED"] = "BRANCH_PERMISSION_VIOLATED";
    CREATE_BRANCH_ERROR_TYPE["GENERIC"] = "GENERIC";
    CREATE_BRANCH_ERROR_TYPE["INSUFFICIENT_RIGHTS"] = "INSUFFICIENT_RIGHTS";
    CREATE_BRANCH_ERROR_TYPE["INVALID_BRANCH_NAME"] = "INVALID_BRANCH_NAME";
    CREATE_BRANCH_ERROR_TYPE["BRANCH_PARAMS_MISSING"] = "BRANCH_PARAMS_MISSING";
    CREATE_BRANCH_ERROR_TYPE["OTHER"] = "OTHER";
})($8ee4c1cccc60297e$export$8987e7f72b40d88e || ($8ee4c1cccc60297e$export$8987e7f72b40d88e = {}));
var $8ee4c1cccc60297e$export$412afd13f6f23029;
(function(REF_TYPE) {
    REF_TYPE["BRANCH"] = "BRANCH";
    REF_TYPE["TAG"] = "TAG";
})($8ee4c1cccc60297e$export$412afd13f6f23029 || ($8ee4c1cccc60297e$export$412afd13f6f23029 = {}));
const $8ee4c1cccc60297e$export$63b84933b9012208 = "create-branch.jira-issue-mapping-message.shown";
const $8ee4c1cccc60297e$export$5d9568283e9dc06f = Object.freeze({
    enhancement: (0, $biyfN.BRANCH_KIND).FEATURE,
    feature: (0, $biyfN.BRANCH_KIND).FEATURE,
    improvement: (0, $biyfN.BRANCH_KIND).FEATURE,
    "new feature": (0, $biyfN.BRANCH_KIND).FEATURE,
    story: (0, $biyfN.BRANCH_KIND).FEATURE,
    "user story": (0, $biyfN.BRANCH_KIND).FEATURE
});
const $8ee4c1cccc60297e$export$f9d40efe2f40921e = Object.freeze([
    "bug",
    "change",
    "defect",
    "enhancement",
    "epic",
    "feature",
    "improvement",
    "incident",
    "new feature",
    "problem",
    "service request",
    "story",
    "sub-task",
    "task",
    "technical task",
    "user story"
]);
const $8ee4c1cccc60297e$export$5754005b9ee99338 = [
    "bug",
    "defect"
];

});



parcelRegister("4WNDe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d745af1aac50e6e4$export$2e2bcd8739ae039; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

var $d745af1aac50e6e4$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("h0Wjn")),
    modules: [
        "./route"
    ],
    webpack: ()=>[
            undefined("./route")
        ]
});

});
parcelRegister("h0Wjn", function(module, exports) {
















module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7O1Mm")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("hFPDk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9oryG")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8FZFT")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3rlr8")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("apPbw")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c7qp4")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5GGCj"))
]).then(()=>parcelRequire("eSJZM"));

});


parcelRegister("2KpP3", function(module, exports) {

$parcel$export(module.exports, "loadForgeMergeChecksResultsResource", function () { return $ba5863ced0b0e710$export$64c56442835711b9; });

var $3XbtU = parcelRequire("3XbtU");
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");
parcelRequire("hw8PW");
var $7JtYi = parcelRequire("7JtYi");

var $3UXCH = parcelRequire("3UXCH");

var $jzmnA = parcelRequire("jzmnA");

var $a0Gq9 = parcelRequire("a0Gq9");
const $ba5863ced0b0e710$export$64c56442835711b9 = (0, $3kfkg.createResource)({
    type: "pull-request-forge-merge-checks-results",
    getKey: ({ match: { params: params } })=>{
        const { pullRequestId: pullRequestId, repositoryOwner: repositoryOwner, repositorySlug: repositorySlug } = params;
        return `${repositoryOwner}/${repositorySlug}/${pullRequestId}`;
    },
    // we need to ensure the value is cached, otherwise getData resets to null upon every refresh call which causes the UI
    // to reset every time
    maxAge: 60000,
    // 1 minute in ms
    getData: async ({ match: { params: params } }, { reduxStore: reduxStore })=>{
        const { pullRequestId: pullRequestId, repositoryOwner: repositoryOwner, repositorySlug: repositorySlug } = params;
        const lastPolled = Date.now();
        const emptyResults = {
            results: [],
            lastPolled: lastPolled
        };
        if (!repositoryOwner || !repositorySlug || !pullRequestId) throw new Error("This resource must be rendered on a route that includes all :repositoryOwner, :repositorySlug and :pullRequestId");
        const state = reduxStore.getState();
        if (!(0, $3UXCH.getFeatures)(state)[(0, $7JtYi.FeatureKeys).extensibleMergeChecksEnabled]) return emptyResults;
        try {
            const results = await (0, $jzmnA.createHttpRequest)("GET", {
                throwErrorType: "errorObject"
            })((0, $a0Gq9.urls).results(repositoryOwner, repositorySlug, pullRequestId));
            return {
                results: results,
                lastPolled: lastPolled
            };
        } catch (error) {
            $3XbtU.captureException(error);
            throw error;
        }
    }
});

});
parcelRegister("a0Gq9", function(module, exports) {

$parcel$export(module.exports, "urls", function () { return $c382db2a64decb72$export$bcae9ba627f604b6; });
const $c382db2a64decb72$export$bcae9ba627f604b6 = {
    results: (repositoryOwner, repositorySlug, pullRequestId)=>`/!api/internal/repositories/${repositoryOwner}/${repositorySlug}/pullrequests/${pullRequestId}/checks/results`,
    retry: (repositoryOwner, repositorySlug, pullRequestId, resultUuid)=>`/!api/internal/repositories/${repositoryOwner}/${repositorySlug}/pullrequests/${pullRequestId}/checks/results/${resultUuid}/retry`
};

});


parcelRegister("hIwXT", function(module, exports) {

$parcel$export(module.exports, "RepoSecurityLandingPageLoadable", function () { return $1fc1b0ae210e8a81$export$6292f78fb16d5564; });
$parcel$export(module.exports, "RepoSecurityLearnMoreLoadable", function () { return $1fc1b0ae210e8a81$export$6f2770654411e436; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $1fc1b0ae210e8a81$export$6292f78fb16d5564 = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("4PoxW")),
    modules: [
        "./pages/security-landing-page"
    ],
    webpack: ()=>[
            undefined("./pages/security-landing-page")
        ]
});

const $1fc1b0ae210e8a81$export$6f2770654411e436 = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("1oagD")),
    modules: [
        "./pages/security-learn-more-page"
    ],
    webpack: ()=>[
            undefined("./pages/security-learn-more-page")
        ]
});

});
parcelRegister("4PoxW", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("hohJU")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2YIib"))
]).then(()=>parcelRequire("3FNir"));

});

parcelRegister("1oagD", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("hohJU")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("a0pdz")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("24vFm"))
]).then(()=>parcelRequire("iJswR"));

});


parcelRegister("hm2h4", function(module, exports) {










































module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5yI7S")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("cZ7JN")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jokVj")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("a0pdz")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("4lXxI")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8FZFT")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("lHmBe")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("gSn8f")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvUP")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6qh0x")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kjN9y")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c7qp4")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c3BIL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvz8")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("e0Fn7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fDD7i")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7xLkx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3op3S")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("gw4te")),
    (parcelRequire("18jdD"))((parcelRequire("1sJKT")).getBundleURL("ekZ4q") + "repository-navigation-next.e2af5f50.js", "script", false)
]).then(()=>parcelRequire("fnACM"));

});

parcelRegister("7oafM", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("17ruM")).then(()=>parcelRequire("lU6e6"));

});

parcelRegister("gcojQ", function(module, exports) {






















































module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("bIgAg")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("b1ziB")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("ktqxM")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fVP4k")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("4RqtW")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6l0sN")),
    (parcelRequire("8iLLr"))((parcelRequire("7kEWw")).resolve("kprU6")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6cFsM")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5yI7S")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("HOeIP")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8FZFT")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6XRs7")),
    (parcelRequire("8iLLr"))((parcelRequire("7kEWw")).resolve("gQqOh")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("i5DDp")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("eEZpb")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9QfrB")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6ONT9")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("d8Eky")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("eaknl")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6GaHv")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9jmnm")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3xV3Z")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3B6sv")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2K4u4")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c3BIL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9r5Qy")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("N69WE"))
]).then(()=>parcelRequire("jctN8"));

});

parcelRegister("iphj0", function(module, exports) {


















































module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("bIgAg")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("b1ziB")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("ktqxM")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fVP4k")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("4RqtW")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6l0sN")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kMnHx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5yI7S")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3zl8N")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("HOeIP")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8FZFT")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6XRs7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9QfrB")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6ONT9")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("d8Eky")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("eaknl")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6GaHv")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c7qp4")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9jmnm")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3xV3Z")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3B6sv")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2K4u4")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c3BIL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9r5Qy")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("lfoTT"))
]).then(()=>parcelRequire("bykrN"));

});

parcelRegister("al1PW", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("dycjn")).then(()=>parcelRequire("fw6Ui"));

});

parcelRegister("6pgK1", function(module, exports) {






















































module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("bIgAg")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("b1ziB")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("ktqxM")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fVP4k")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("4RqtW")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6l0sN")),
    (parcelRequire("8iLLr"))((parcelRequire("7kEWw")).resolve("kprU6")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6cFsM")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kMnHx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5yI7S")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("cZ7JN")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("HOeIP")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8FZFT")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6XRs7")),
    (parcelRequire("8iLLr"))((parcelRequire("7kEWw")).resolve("gQqOh")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("i5DDp")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("dx5v1")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3rlr8")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("eEZpb")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5to2p")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9QfrB")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9jmnm")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3B6sv")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2K4u4")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c3BIL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9r5Qy")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fwSZ4"))
]).then(()=>parcelRequire("kzIiA"));

});

parcelRegister("GxHC8", function(module, exports) {






















































module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6cFsM")),
    (parcelRequire("8iLLr"))((parcelRequire("7kEWw")).resolve("kprU6")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5jbPB")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jkg4B")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("133AZ")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6XRs7")),
    (parcelRequire("8iLLr"))((parcelRequire("7kEWw")).resolve("gQqOh")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("i5DDp")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7B0aG")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("4UyJR")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("dO7De")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("hUxd3")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("hXKIr")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("aJhSx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2Zgcf")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("hXt8u")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2kjCa")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("69qfB")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7I7DM")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("ehpDH")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8axMs")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7knCY")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jFvy9")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c3BIL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvz8")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9r5Qy")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9JIkx"))
]).then(()=>parcelRequire("f3ZGt"));

});

parcelRegister("73vEv", function(module, exports) {






















































module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6cFsM")),
    (parcelRequire("8iLLr"))((parcelRequire("7kEWw")).resolve("kprU6")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5jbPB")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("133AZ")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2H5Nx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6XRs7")),
    (parcelRequire("8iLLr"))((parcelRequire("7kEWw")).resolve("gQqOh")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("i5DDp")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7B0aG")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("4UyJR")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("dO7De")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("hXKIr")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("aJhSx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2Zgcf")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("hXt8u")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2kjCa")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("69qfB")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7I7DM")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("ehpDH")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8axMs")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7knCY")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jFvy9")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jSISz")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6LXwM")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvz8")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9r5Qy")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("CdPRh"))
]).then(()=>parcelRequire("1LnkR"));

});

parcelRegister("jNY5D", function(module, exports) {


















































module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6cFsM")),
    (parcelRequire("8iLLr"))((parcelRequire("7kEWw")).resolve("kprU6")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5jbPB")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("133AZ")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("lHmBe")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6XRs7")),
    (parcelRequire("8iLLr"))((parcelRequire("7kEWw")).resolve("gQqOh")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("i5DDp")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7B0aG")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("4UyJR")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("hXKIr")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("aJhSx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2Zgcf")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("hXt8u")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2kjCa")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("69qfB")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7I7DM")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("ehpDH")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8axMs")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7knCY")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jFvy9")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jSISz")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6LXwM")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvz8")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("cMAkB"))
]).then(()=>parcelRequire("iLvf9"));

});

parcelRegister("eNsia", function(module, exports) {




















module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("dFon2")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9gDpJ")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jokVj")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("alk8w")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("eVxMg")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jlbhG")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c3BIL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9r5Qy")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("f9iih"))
]).then(()=>parcelRequire("8hXcC"));

});

parcelRegister("fS8dn", function(module, exports) {




















module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("dFon2")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9gDpJ")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jokVj")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("alk8w")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("eVxMg")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jlbhG")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c3BIL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9r5Qy")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7K1lz"))
]).then(()=>parcelRequire("6lx4d"));

});

parcelRegister("cyStG", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("iHB3M")).then(()=>parcelRequire("bHXUz"));

});

parcelRegister("2D7R6", function(module, exports) {




















module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2cqKR")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2H5Nx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6SfDR")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2Nsyz")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c7qp4")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5B0yY")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("bUF79")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c3BIL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9r5Qy")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kozTx"))
]).then(()=>parcelRequire("cqbDr"));

});

parcelRegister("gkC80", function(module, exports) {




















module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("b1ziB")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("HOeIP")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9cz44")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kBzNL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6XRs7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("1QkO4")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9uabR")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9r5Qy")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("dLN2R"))
]).then(()=>parcelRequire("kxQHo"));

});

parcelRegister("k9YSQ", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8mm1s")).then(()=>parcelRequire("a08K5"));

});

parcelRegister("kQgAG", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("4P6f0")).then(()=>parcelRequire("6rB3n"));

});

parcelRegister("5vgPi", function(module, exports) {






















































module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6cFsM")),
    (parcelRequire("8iLLr"))((parcelRequire("7kEWw")).resolve("kprU6")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5jbPB")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jkg4B")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("133AZ")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6XRs7")),
    (parcelRequire("8iLLr"))((parcelRequire("7kEWw")).resolve("gQqOh")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("i5DDp")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7B0aG")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("4UyJR")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("dO7De")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("hUxd3")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("hXKIr")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("aJhSx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2Zgcf")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("hXt8u")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2kjCa")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("69qfB")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7I7DM")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("ehpDH")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8axMs")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7knCY")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jFvy9")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c3BIL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvz8")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9r5Qy")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("1v9LL"))
]).then(()=>parcelRequire("3GO3c"));

});

parcelRegister("fG54d", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3s4yG")).then(()=>parcelRequire("R5PEX"));

});

parcelRegister("1on5U", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8bIbR")).then(()=>parcelRequire("4azbv"));

});


parcelRegister("8egek", function(module, exports) {

$parcel$export(module.exports, "getWorkspaceRoutesConfig", function () { return $aab8d18871cc813e$export$203b9ccb96ed3d90; });

var $8shKB = parcelRequire("8shKB");

var $5rTsd = parcelRequire("5rTsd");

var $3agw6 = parcelRequire("3agw6");

var $39p3I = parcelRequire("39p3I");

var $3wXS7 = parcelRequire("3wXS7");

var $bT38u = parcelRequire("bT38u");

var $lbGYZ = parcelRequire("lbGYZ");

var $4Ytrw = parcelRequire("4Ytrw");

var $lM37z = parcelRequire("lM37z");

var $gi7Vc = parcelRequire("gi7Vc");

var $ag538 = parcelRequire("ag538");

var $l1OmI = parcelRequire("l1OmI");

var $5OdXm = parcelRequire("5OdXm");

var $c406Y = parcelRequire("c406Y");

var $gkHct = parcelRequire("gkHct");

var $dcA0E = parcelRequire("dcA0E");

var $jvOKb = parcelRequire("jvOKb");

var $JQKkV = parcelRequire("JQKkV");

var $7sB53 = parcelRequire("7sB53");

var $bF07x = parcelRequire("bF07x");

var $7IfQd = parcelRequire("7IfQd");

const $aab8d18871cc813e$var$RootRedirect = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("jZQtV")),
    modules: [
        "src/sections/global/containers/root-redirect"
    ],
    webpack: ()=>[
            undefined("src/sections/global/containers/root-redirect")
        ]
});

const $aab8d18871cc813e$var$DashboardOverview = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("6hmXS")),
    modules: [
        "src/sections/dashboard/sections/overview/containers"
    ],
    webpack: ()=>[
            undefined("src/sections/dashboard/sections/overview/containers")
        ]
});

const $aab8d18871cc813e$var$WorkspaceLayout = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("hQ43v")),
    modules: [
        "src/sections/workspace/layout"
    ],
    webpack: ()=>[
            undefined("src/sections/workspace/layout")
        ]
});

const $aab8d18871cc813e$var$WorkspaceSettingsLayout = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("94Q7K")),
    modules: [
        "src/sections/workspace/settings-layout"
    ],
    webpack: ()=>[
            undefined("src/sections/workspace/settings-layout")
        ]
});

const $aab8d18871cc813e$var$WorkspaceCreatePage = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("hP6P1")),
    modules: [
        "src/sections/workspace/sections/create/containers/create-workspace-page"
    ],
    webpack: ()=>[
            undefined("src/sections/workspace/sections/create/containers/create-workspace-page")
        ]
});

const $aab8d18871cc813e$var$WorkspacePullRequests = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("2VQ2V")),
    modules: [
        "src/sections/workspace/sections/pullrequests/route"
    ],
    webpack: ()=>[
            undefined("src/sections/workspace/sections/pullrequests/route")
        ]
});

const $aab8d18871cc813e$var$WorkspaceSearch = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("e477H")),
    modules: [
        "src/sections/workspace/sections/search/route"
    ],
    webpack: ()=>[
            undefined("src/sections/workspace/sections/search/route")
        ]
});

const $aab8d18871cc813e$var$WorkspaceRepositories = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("7VnJp")),
    modules: [
        "src/sections/profile/sections/repositories/route"
    ],
    webpack: ()=>[
            undefined("src/sections/profile/sections/repositories/route")
        ]
});

const $aab8d18871cc813e$var$WorkspaceProjects = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("ekVxR")),
    modules: [
        "src/sections/workspace/sections/projects/resource-router-route"
    ],
    webpack: ()=>[
            undefined("src/sections/workspace/sections/projects/resource-router-route")
        ]
});

const $aab8d18871cc813e$var$WorkspaceSettingsConnect = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("bAQTT")),
    modules: [
        "src/sections/workspace/sections/settings/containers/settings-connect-iframe"
    ],
    webpack: ()=>[
            undefined("src/sections/workspace/sections/settings/containers/settings-connect-iframe")
        ]
});

const $aab8d18871cc813e$var$WorkspaceSettingsForge = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("eld9X")),
    modules: [
        "src/forge/workspace-settings-menu-page/workspace-settings-menu-page"
    ],
    webpack: ()=>[
            undefined("src/forge/workspace-settings-menu-page/workspace-settings-menu-page")
        ]
});

const $aab8d18871cc813e$var$WorkspaceSettingsIframe = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("jlxXg")),
    modules: [
        "src/sections/workspace/sections/settings/containers/settings-iframe"
    ],
    webpack: ()=>[
            undefined("src/sections/workspace/sections/settings/containers/settings-iframe")
        ]
});

const $aab8d18871cc813e$var$WorkspaceSettingsGroup = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("3NBse")),
    modules: [
        "src/sections/workspace/sections/settings/components/group"
    ],
    webpack: ()=>[
            undefined("src/sections/workspace/sections/settings/components/group")
        ]
});

const $aab8d18871cc813e$var$WorkspaceSettingsGroups = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("aPnRZ")),
    modules: [
        "src/sections/workspace/sections/settings/components/groups"
    ],
    webpack: ()=>[
            undefined("src/sections/workspace/sections/settings/components/groups")
        ]
});

const $aab8d18871cc813e$var$WorkspaceSettingsRoot = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("aqcqt")),
    modules: [
        "src/sections/workspace/sections/settings/components/settings-index"
    ],
    webpack: ()=>[
            undefined("src/sections/workspace/sections/settings/components/settings-index")
        ]
});

const $aab8d18871cc813e$var$WorkspaceSettingsUserDirectory = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("5MoEN")),
    modules: [
        "src/sections/workspace/sections/settings/components/user-directory"
    ],
    webpack: ()=>[
            undefined("src/sections/workspace/sections/settings/components/user-directory")
        ]
});

const $aab8d18871cc813e$var$WorkspaceSettingsAtlassianIntelligence = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("jBjaA")),
    modules: [
        "src/sections/workspace/sections/settings/components/atlassian-intelligence"
    ],
    webpack: ()=>[
            undefined("src/sections/workspace/sections/settings/components/atlassian-intelligence")
        ]
});

const $aab8d18871cc813e$var$WorkspaceSettingsCompass = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("dk4Y0")),
    modules: [
        "src/sections/workspace/sections/settings/components/compass/compass-workspace-settings-page"
    ],
    webpack: ()=>[
            undefined("src/sections/workspace/sections/settings/components/compass/compass-workspace-settings-page")
        ]
});

const $aab8d18871cc813e$var$WorkspaceSettingsMergeChecks = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("6orNp")),
    modules: [
        "src/sections/workspace/sections/settings/components/merge-checks/merge-checks-workspace-settings-page"
    ],
    webpack: ()=>[
            undefined("src/sections/workspace/sections/settings/components/merge-checks/merge-checks-workspace-settings-page")
        ]
});

const $aab8d18871cc813e$var$PipelinesWorkspaceSettingsRedirectSettingsLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("9GOyO")),
    modules: [
        "src/sections/workspace/sections/settings/components/pipelines/redirect/to-frontbucket-settings"
    ],
    webpack: ()=>[
            undefined("src/sections/workspace/sections/settings/components/pipelines/redirect/to-frontbucket-settings")
        ]
});

const $aab8d18871cc813e$var$PipelinesWorkspaceSettingsRedirectRunnersLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("5ANcH")),
    modules: [
        "src/sections/workspace/sections/settings/components/pipelines/redirect/to-frontbucket-runners"
    ],
    webpack: ()=>[
            undefined("src/sections/workspace/sections/settings/components/pipelines/redirect/to-frontbucket-runners")
        ]
});
const $aab8d18871cc813e$export$203b9ccb96ed3d90 = ({ isWorkspaceSettingsIndexEnabled: isWorkspaceSettingsIndexEnabled })=>{
    return {
        [(0, $7IfQd.ROUTE_NAME).ROOT]: {
            component: $aab8d18871cc813e$var$RootRedirect,
            resources: []
        },
        [(0, $7IfQd.ROUTE_NAME).WORKSPACE_CREATE]: {
            // @ts-ignore: requires RouteContext type on component
            component: $aab8d18871cc813e$var$WorkspaceCreatePage,
            resources: [
                (0, $bT38u.loadGlobalResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).WORKSPACE_OVERVIEW]: {
            // @ts-ignore: requires RouteContext type on component
            component: $aab8d18871cc813e$var$DashboardOverview,
            layout: $aab8d18871cc813e$var$WorkspaceLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $bF07x.workspaceSectionResource),
                (0, $lbGYZ.dashboardOverviewViewResource),
                (0, $7sB53.workspaceNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).WORKSPACE_REPOSITORIES]: {
            // @ts-ignore: requires RouteContext type on component
            component: $aab8d18871cc813e$var$WorkspaceRepositories,
            layout: $aab8d18871cc813e$var$WorkspaceLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $bF07x.workspaceSectionResource),
                (0, $4Ytrw.workspaceRepositoriesResource),
                (0, $7sB53.workspaceNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).WORKSPACE_ROOT]: {
            // @ts-ignore: requires RouteContext type on component
            component: $aab8d18871cc813e$var$WorkspaceRepositories,
            layout: $aab8d18871cc813e$var$WorkspaceLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $bF07x.workspaceSectionResource),
                (0, $4Ytrw.workspaceRepositoriesResource),
                (0, $7sB53.workspaceNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).PROFILE_REPOSITORIES]: {
            // @ts-ignore: requires RouteContext type on component
            component: $aab8d18871cc813e$var$WorkspaceRepositories,
            layout: $aab8d18871cc813e$var$WorkspaceLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $bF07x.workspaceSectionResource),
                (0, $4Ytrw.workspaceRepositoriesResource),
                (0, $7sB53.workspaceNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).WORKSPACE_PROJECTS]: {
            component: $aab8d18871cc813e$var$WorkspaceProjects,
            layout: $aab8d18871cc813e$var$WorkspaceLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $bF07x.workspaceSectionResource),
                (0, $lM37z.workspaceProjectsResource),
                (0, $7sB53.workspaceNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).WORKSPACE_PULL_REQUESTS]: {
            component: $aab8d18871cc813e$var$WorkspacePullRequests,
            layout: $aab8d18871cc813e$var$WorkspaceLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $bF07x.workspaceSectionResource),
                (0, $gi7Vc.workspacePullRequestsResource),
                (0, $7sB53.workspaceNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).WORKSPACE_SEARCH]: {
            component: $aab8d18871cc813e$var$WorkspaceSearch,
            resources: [
                (0, $bF07x.workspaceSectionResource),
                (0, $7sB53.workspaceNavigationResource),
                (0, $bT38u.loadGlobalResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_ROOT]: {
            // @ts-ignore: requires RouteContext type on component
            component: isWorkspaceSettingsIndexEnabled ? $aab8d18871cc813e$var$WorkspaceSettingsRoot : $aab8d18871cc813e$var$WorkspaceSettingsIframe,
            layout: $aab8d18871cc813e$var$WorkspaceSettingsLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $bF07x.workspaceSectionResource),
                (0, $7sB53.workspaceNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_GROUP]: {
            component: $aab8d18871cc813e$var$WorkspaceSettingsGroup,
            layout: $aab8d18871cc813e$var$WorkspaceSettingsLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $bF07x.workspaceSectionResource),
                (0, $7sB53.workspaceNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_GROUPS]: {
            component: $aab8d18871cc813e$var$WorkspaceSettingsGroups,
            layout: $aab8d18871cc813e$var$WorkspaceSettingsLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $bF07x.workspaceSectionResource),
                (0, $7sB53.workspaceNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_USER_DIRECTORY]: {
            component: $aab8d18871cc813e$var$WorkspaceSettingsUserDirectory,
            layout: $aab8d18871cc813e$var$WorkspaceSettingsLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $bF07x.workspaceSectionResource),
                (0, $7sB53.workspaceNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_ATLASSIAN_INTELLIGENCE]: {
            component: $aab8d18871cc813e$var$WorkspaceSettingsAtlassianIntelligence,
            layout: $aab8d18871cc813e$var$WorkspaceSettingsLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $bF07x.workspaceSectionResource),
                (0, $7sB53.workspaceNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_COMPASS]: {
            component: $aab8d18871cc813e$var$WorkspaceSettingsCompass,
            layout: $aab8d18871cc813e$var$WorkspaceSettingsLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $bF07x.workspaceSectionResource),
                (0, $7sB53.workspaceNavigationResource),
                (0, $l1OmI.compassResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_MERGE_CHECKS]: {
            component: $aab8d18871cc813e$var$WorkspaceSettingsMergeChecks,
            layout: $aab8d18871cc813e$var$WorkspaceSettingsLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $bF07x.workspaceSectionResource),
                (0, $5OdXm.mergeChecksActivationResource),
                (0, $7sB53.workspaceNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_PERMISSIONS]: {
            component: (0, $c406Y.WorkspaceSettingsPermissionsLoadable),
            layout: $aab8d18871cc813e$var$WorkspaceSettingsLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $bF07x.workspaceSectionResource),
                (0, $gkHct.loadWorkspaceSettingsPermissionsResource),
                (0, $7sB53.workspaceNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_CONNECT_ADMIN]: {
            component: $aab8d18871cc813e$var$WorkspaceSettingsConnect,
            layout: $aab8d18871cc813e$var$WorkspaceSettingsLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $bF07x.workspaceSectionResource),
                (0, $7sB53.workspaceNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_CONNECT_CONFIGURE]: {
            component: $aab8d18871cc813e$var$WorkspaceSettingsConnect,
            layout: $aab8d18871cc813e$var$WorkspaceSettingsLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $bF07x.workspaceSectionResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_FORGE_PAGE]: {
            // @ts-ignore: requires RouteContext type on component
            component: $aab8d18871cc813e$var$WorkspaceSettingsForge,
            layout: $aab8d18871cc813e$var$WorkspaceSettingsLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $bF07x.workspaceSectionResource),
                (0, $7sB53.workspaceNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_ACCESS_TOKENS]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $ag538.WorkspaceSettingsAccessTokensLoadable),
            layout: $aab8d18871cc813e$var$WorkspaceSettingsLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $bF07x.workspaceSectionResource),
                (0, $7sB53.workspaceNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_PIPELINES_REDIRECT_SETTINGS]: {
            // @ts-ignore: requires RouteContext type on component
            component: $aab8d18871cc813e$var$PipelinesWorkspaceSettingsRedirectSettingsLoadable,
            layout: $aab8d18871cc813e$var$WorkspaceSettingsLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $bF07x.workspaceSectionResource),
                (0, $7sB53.workspaceNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_PIPELINES_REDIRECT_RUNNERS]: {
            // @ts-ignore: requires RouteContext type on component
            component: $aab8d18871cc813e$var$PipelinesWorkspaceSettingsRedirectRunnersLoadable,
            layout: $aab8d18871cc813e$var$WorkspaceSettingsLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $bF07x.workspaceSectionResource),
                (0, $7sB53.workspaceNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_PIPELINES_RUNNERS]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $jvOKb.default),
            layout: $aab8d18871cc813e$var$WorkspaceSettingsLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $bF07x.workspaceSectionResource),
                (0, $3agw6.loadPipelinesWorkspaceRunnersResource),
                (0, $7sB53.workspaceNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_PIPELINES_VARIABLES]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $JQKkV.default),
            layout: $aab8d18871cc813e$var$WorkspaceSettingsLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $bF07x.workspaceSectionResource),
                (0, $39p3I.loadPipelinesWorkspaceVariablesResource),
                (0, $7sB53.workspaceNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_PIPELINES_DYNAMIC_PIPELINES]: {
            // @ts-ignore: requires RouteContext type on component
            component: (0, $dcA0E.default),
            layout: $aab8d18871cc813e$var$WorkspaceSettingsLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $bF07x.workspaceSectionResource),
                (0, $5rTsd.loadWorkspaceDynamicPipelinesResource),
                (0, $7sB53.workspaceNavigationResource)
            ]
        },
        [(0, $7IfQd.ROUTE_NAME).WORKSPACE_SETTINGS_IFRAME]: {
            // @ts-ignore: requires RouteContext type on component
            component: $aab8d18871cc813e$var$WorkspaceSettingsIframe,
            layout: $aab8d18871cc813e$var$WorkspaceSettingsLayout,
            resources: [
                (0, $bT38u.loadGlobalResource),
                (0, $bF07x.workspaceSectionResource),
                (0, $7sB53.workspaceNavigationResource)
            ]
        }
    };
};

});
parcelRegister("39p3I", function(module, exports) {

$parcel$export(module.exports, "getWorkspaceVariablesUrl", function () { return $10b8be97eb242213$export$3fde0dc09dc74f7d; });
$parcel$export(module.exports, "loadPipelinesWorkspaceVariablesResource", function () { return $10b8be97eb242213$export$c5cd1f46b0286c83; });

var $cJH1T = parcelRequire("cJH1T");
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $i3LMs = parcelRequire("i3LMs");
parcelRequire("e9n2v");
var $iUiPN = parcelRequire("iUiPN");

var $k2cPS = parcelRequire("k2cPS");

var $fEutT = parcelRequire("fEutT");
const $10b8be97eb242213$export$3fde0dc09dc74f7d = (params, query)=>{
    var _query$page, _query$pagelen;
    return `${(0, $fEutT.default)()}/workspaces/${params.workspaceSlug}/pipelines-config/variables?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
        page: (_query$page = query === null || query === void 0 ? void 0 : query.page) !== null && _query$page !== void 0 ? _query$page : 1,
        pagelen: (_query$pagelen = query === null || query === void 0 ? void 0 : query.pagelen) !== null && _query$pagelen !== void 0 ? _query$pagelen : (0, $i3LMs.VARIABLES_PAGELEN)
    })}`;
};
const $10b8be97eb242213$export$c5cd1f46b0286c83 = (0, $3kfkg.createResource)({
    type: "pipelinesWorkspaceVariables",
    getKey: ({ match: match })=>$10b8be97eb242213$export$3fde0dc09dc74f7d(match.params),
    maxAge: 60000,
    getData: async ({ match: match })=>{
        const req = (0, $k2cPS.default)($10b8be97eb242213$export$3fde0dc09dc74f7d(match.params));
        const resp = await fetch(req);
        if (!resp.ok) throw new Error("Could not fetch workspace variables");
        else {
            var _values$map;
            // Note: The `pagelen` here is the actual size of page returned from the backend.
            // Can be different from what we passed in the request query.
            const { page: page, pagelen: pagelen, size: size, values: values } = await resp.json();
            return {
                hasNextPage: size > pagelen * page,
                page: page,
                total: size,
                variables: (_values$map = values === null || values === void 0 ? void 0 : values.map((item)=>new (0, $iUiPN.Variable)(item))) !== null && _values$map !== void 0 ? _values$map : []
            };
        }
    }
});

});

parcelRegister("lbGYZ", function(module, exports) {

$parcel$export(module.exports, "dashboardOverviewViewResource", function () { return $73335d9ef28594e5$export$fb99b2c436f51f6f; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $9H597 = parcelRequire("9H597");

var $ksfVj = parcelRequire("ksfVj");

var $k2cPS = parcelRequire("k2cPS");
const $73335d9ef28594e5$var$FIELDS = [
    "+pullRequests.*.author",
    "+pullRequests.*.closed_on",
    "+pullRequests.*.comment_count",
    "+pullRequests.*.created_on",
    "+pullRequests.*.destination.branch.name",
    "+pullRequests.*.destination.commit.hash",
    // Need to manually grab some of *.destination.repository and let *.repository fields fill out the rest
    "+pullRequests.*.destination.repository.workspace",
    "+pullRequests.*.id",
    "+pullRequests.*.links.html",
    "+pullRequests.*.links.self",
    "+pullRequests.*.participants",
    // These fill out *.destination.repository and *.source.repository
    "+pullRequests.*.repository.links.avatar",
    "+pullRequests.*.repository.links.html",
    "+pullRequests.*.repository.full_name",
    "+pullRequests.*.repository.name",
    "+pullRequests.*.source.branch.name",
    "+pullRequests.*.source.commit.hash",
    // Need to manually grab some of *.source.repository and let *.repository fields fill out the rest
    "+pullRequests.*.source.repository.workspace",
    "+pullRequests.*.state",
    "+pullRequests.*.task_count",
    "+pullRequests.*.title",
    "+pullRequests.*.updated_on"
].join(",");
const $73335d9ef28594e5$export$fb99b2c436f51f6f = (0, $3kfkg.createResource)({
    type: "DASHBOARD_VIEW",
    getKey: ({ match: match })=>`dashboard:${match.params.workspaceSlug}`,
    maxAge: 2000,
    getData: async ({ match: match }, { csrftoken: csrftoken })=>{
        const { workspaceSlug: workspaceSlug } = match.params;
        // If we can't match the URL to a workspace slug, this resource is being used on a route
        // it shouldn't be.
        if (!workspaceSlug) return null;
        const requestUrl = (0, $ksfVj.default).api.internal.overviewViewState(workspaceSlug);
        const params = (0, $9H597.stringify)({
            fields: $73335d9ef28594e5$var$FIELDS
        });
        const response = await fetch((0, $k2cPS.default)(`${requestUrl}/${params}`, {
            headers: (0, $k2cPS.jsonHeaders)
        }, csrftoken));
        if (!response.ok) throw new Error(`Error fetching dashboard overview view data (${response.status}): ${response.statusText}`);
        const viewData = await response.json();
        return viewData;
    },
    isBrowserOnly: true
});

});

parcelRegister("4Ytrw", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_REPOSITORIES_SORTING", function () { return $0157767513aa01ce$export$9888fd33e0f61cd7; });
$parcel$export(module.exports, "parseQuery", function () { return $0157767513aa01ce$export$1e8473eaf75b0d10; });
$parcel$export(module.exports, "toQueryParams", function () { return $0157767513aa01ce$export$6e169ea8bc3c8798; });
$parcel$export(module.exports, "workspaceRepositoriesResource", function () { return $0157767513aa01ce$export$eba9a9a608b7f6c5; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $55W4G = parcelRequire("55W4G");

var $6OwE2 = parcelRequire("6OwE2");

var $9H597 = parcelRequire("9H597");

var $k2cPS = parcelRequire("k2cPS");
function $0157767513aa01ce$var$isPrivacyFilter(privacy) {
    return privacy === "private" || privacy === "public";
}
const $0157767513aa01ce$export$ac98aac1633fdf3a = 25;
const $0157767513aa01ce$export$9888fd33e0f61cd7 = "-updated_on";
const $0157767513aa01ce$export$1e8473eaf75b0d10 = (query)=>{
    const parsedPage = parseInt(query.page, 10);
    return {
        filters: {
            language: query.language || undefined,
            privacy: $0157767513aa01ce$var$isPrivacyFilter(query.privacy) ? query.privacy : undefined,
            search: query.search || undefined,
            watching: query.watching,
            project: query.project || undefined
        },
        page: !isNaN(parsedPage) ? Math.max(parsedPage, 1) : 1,
        sort: query.sort || $0157767513aa01ce$export$9888fd33e0f61cd7
    };
};
const $0157767513aa01ce$export$6e169ea8bc3c8798 = (query)=>{
    const { filters: filters, page: page, sort: sort } = query;
    const { language: language, privacy: privacy, search: search, watching: watching, project: project } = filters;
    return {
        language: language || undefined,
        page: page && page > 1 ? page : undefined,
        privacy: privacy || undefined,
        search: search || undefined,
        sort: sort || undefined,
        watching: watching || undefined,
        project: project || undefined
    };
};
const $0157767513aa01ce$export$eba9a9a608b7f6c5 = (0, $3kfkg.createResource)({
    type: "WORKSPACE_REPOSITORIES",
    getKey: ({ match: match, query: query })=>{
        // Strip out query params unrelated to fetching the repository list
        const parsedQuery = $0157767513aa01ce$export$1e8473eaf75b0d10(query);
        const filteredQueryString = (0, $9H597.stringify)(parsedQuery);
        return `workspace:${match.params.workspaceSlug}::repositories:${filteredQueryString}`;
    },
    maxAge: 0,
    getData: async ({ match: match, query: query })=>{
        const { workspaceSlug: workspaceSlug } = match.params;
        // If we can't match the URL to a workspace slug, this resource is being used on a route
        // it shouldn't be.
        if (!workspaceSlug) return null;
        const { filters: filters, page: page, sort: sort } = $0157767513aa01ce$export$1e8473eaf75b0d10(query);
        const response = await fetch((0, $k2cPS.default)((0, $6OwE2.default).api.v20.profileRepositories(workspaceSlug, {
            page: page,
            pagelen: $0157767513aa01ce$export$ac98aac1633fdf3a,
            sort: sort,
            q: (0, $55W4G.buildProfileRepositoryBBQL)(filters),
            fields: "-values.owner,-values.workspace"
        })));
        if (!response.ok) throw new Error(`${response.status} ${response.statusText}`);
        const { values: repositories, pagelen: pagelen, size: size } = await response.json();
        return {
            repositories: repositories,
            pagelen: pagelen,
            size: size
        };
    }
});

});
parcelRegister("55W4G", function(module, exports) {

$parcel$export(module.exports, "buildProfileRepositoryBBQL", function () { return $1ad770e4f521e2ff$export$dc96bd0f24d3bf39; });

var $eAC7E = parcelRequire("eAC7E");
const $1ad770e4f521e2ff$export$dc96bd0f24d3bf39 = (filter)=>{
    if (!filter) return null;
    const queries = [];
    if (filter.search) queries.push(`(name ~ "${filter.search}" OR description ~ "${filter.search}")`);
    if (filter.privacy) queries.push(`is_private = ${filter.privacy === (0, $eAC7E.FILTER_KIND).PRIVATE}`);
    if (filter.language) queries.push(`language = "${filter.language}"`);
    if (filter.watching) queries.push(`followers.uuid = "${filter.watching}"`);
    if (filter.project) queries.push(`(project.uuid = "${filter.project}")`);
    return queries.join(" AND ");
};

});
parcelRegister("eAC7E", function(module, exports) {

$parcel$export(module.exports, "FILTER_KIND", function () { return $45831ecef2e60ce8$export$3c6f634eaf477c42; });
var $45831ecef2e60ce8$export$3c6f634eaf477c42;
(function(FILTER_KIND) {
    FILTER_KIND["PRIVATE"] = "private";
    FILTER_KIND["PUBLIC"] = "public";
})($45831ecef2e60ce8$export$3c6f634eaf477c42 || ($45831ecef2e60ce8$export$3c6f634eaf477c42 = {}));

});



parcelRegister("lM37z", function(module, exports) {

$parcel$export(module.exports, "workspaceProjectsResource", function () { return $08aa21b6b98043bc$export$878bdd27116a7995; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $9H597 = parcelRequire("9H597");

var $ksfVj = parcelRequire("ksfVj");

var $964rM = parcelRequire("964rM");

var $k2cPS = parcelRequire("k2cPS");
const $08aa21b6b98043bc$var$parseQuery = (query)=>{
    const parsedPage = parseInt(query.page, 10);
    return {
        page: !isNaN(parsedPage) ? Math.max(parsedPage, 1) : 1,
        isPrivate: query.is_private,
        search: query.query
    };
};
const $08aa21b6b98043bc$var$buildBbql = ({ isPrivate: is_private, search: inputSearch })=>{
    const bbql = [];
    if (is_private) bbql.push(`is_private=${is_private === "true"}`);
    const search = (0, $964rM.default)(inputSearch || "");
    if (search) {
        const conditions = [
            `description~"${search}"`,
            `name~"${search}"`,
            `key~"${search}"`
        ];
        bbql.push(`(${conditions.join(" OR ")})`);
    }
    return bbql.join(" AND ");
};
const $08aa21b6b98043bc$export$878bdd27116a7995 = (0, $3kfkg.createResource)({
    type: "WORKSPACE_PROJECTS",
    getKey: ({ match: match, query: query })=>{
        // Strip out query params unrelated to fetching the project list
        const parsedQuery = $08aa21b6b98043bc$var$parseQuery(query);
        const filteredQueryString = (0, $9H597.stringify)(parsedQuery);
        return `workspace:${match.params.workspaceSlug}::projects:${filteredQueryString}`;
    },
    maxAge: 30000,
    // 30 seconds
    getData: async ({ match: match, query: query }, { csrftoken: csrftoken })=>{
        const { workspaceSlug: workspaceSlug } = match.params;
        // If we can't match the URL to a workspace slug, this resource is being used on a route
        // it shouldn't be.
        if (!workspaceSlug) return null;
        const { page: page, isPrivate: isPrivate, search: search } = $08aa21b6b98043bc$var$parseQuery(query);
        const filter = {
            isPrivate: isPrivate,
            search: search
        };
        const q = $08aa21b6b98043bc$var$buildBbql(filter);
        const params = (0, $9H597.stringify)({
            page: page,
            q: q,
            sort: "name",
            fields: "-values.workspace,-values.owner"
        });
        const response = await fetch((0, $k2cPS.default)(`${(0, $ksfVj.default).api.v20.projects(workspaceSlug)}/${params}`, {
            headers: (0, $k2cPS.jsonHeaders)
        }, csrftoken));
        if (!response.ok) throw new Error(`${response.status} ${response.statusText}`);
        const { values: values, size: size, pagelen: pagelen } = await response.json();
        const projects = values;
        return {
            projects: projects,
            size: size,
            pagelen: pagelen
        };
    }
});

});

parcelRegister("gi7Vc", function(module, exports) {

$parcel$export(module.exports, "parseQuery", function () { return $c57fd619d0cf1006$export$1e8473eaf75b0d10; });
$parcel$export(module.exports, "workspacePullRequestsResource", function () { return $c57fd619d0cf1006$export$6cc91fa40e373a20; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $9H597 = parcelRequire("9H597");

var $ksfVj = parcelRequire("ksfVj");

var $964rM = parcelRequire("964rM");

var $k2cPS = parcelRequire("k2cPS");
const $c57fd619d0cf1006$var$FIELDS = [
    "-values.closed_by",
    "-values.description",
    "-values.summary",
    "-values.rendered",
    "-values.properties",
    "-values.reason",
    "-values.reviewers",
    "-values.participants.user.nickname",
    "+values.destination.branch.name",
    "+values.destination.repository.full_name",
    "+values.destination.repository.name",
    "+values.destination.repository.uuid",
    "+values.destination.repository.full_name",
    "+values.destination.repository.name",
    "+values.destination.repository.links.self.href",
    "+values.destination.repository.links.html.href",
    "+values.source.branch.name",
    "+values.source.repository.full_name",
    "+values.source.repository.name",
    "+values.source.repository.uuid",
    "+values.source.repository.full_name",
    "+values.source.repository.name",
    "+values.source.repository.links.self.href",
    "+values.source.repository.links.html.href",
    "+values.source.commit.hash"
].join(",");
const $c57fd619d0cf1006$var$buildBBQL = ({ search: inputSearch, prState: prState, prUserFilter: prUserFilter, authorsAaid: authorsAaid, project: project }, user)=>{
    const bbql = [];
    const validStates = [
        "MERGED",
        "DECLINED",
        "OPEN"
    ];
    if (validStates.indexOf(prState) !== -1) bbql.push(`state="${prState}"`);
    else // The state should default to OPEN if ALL is not explicitly set
    if (prState !== "ALL") bbql.push('state="OPEN"');
    if (user) {
        if (prUserFilter === "REVIEWING") bbql.push(`reviewers.uuid="${user.uuid}"`);
        else if (prUserFilter === "WATCHING") bbql.push(`followers.uuid="${user.uuid}"`);
    // For the third/last case, if `prUserFilter` is `ALL` then we do not filter.
    }
    if (project) bbql.push(`source.repository.project.uuid="${project}"`);
    const search = (0, $964rM.default)(inputSearch || "");
    if (search) {
        const conditions = [
            `description~"${search}"`,
            `title~"${search}"`
        ];
        // Extract numbers from the search
        const numerics = search.match(/\d+/g) || [];
        // Try to match them to a pull request ID
        const pullRequestIds = [
            ...new Set(numerics)
        ].map((id)=>`id=${id}`);
        conditions.push(...pullRequestIds);
        bbql.push(`(${conditions.join(" OR ")})`);
    }
    if (authorsAaid) {
        const aaids = authorsAaid.map((aaid)=>`author.account_id="${aaid}"`);
        bbql.push(`(${aaids.join(" OR ")})`);
    }
    return bbql.join(" AND ");
};
const $c57fd619d0cf1006$var$PAGE_LEN = 20;
const $c57fd619d0cf1006$export$1e8473eaf75b0d10 = (query)=>{
    const parsedPage = parseInt(query.page, 10);
    const prUserFilter = query.user_filter || "REVIEWING";
    return {
        page: !isNaN(parsedPage) ? Math.max(parsedPage, 1) : 1,
        search: query.query,
        prState: query.state,
        prUserFilter: prUserFilter,
        authorsAaid: query.author ? query.author.split("+") : undefined,
        project: query.project
    };
};
const $c57fd619d0cf1006$export$6cc91fa40e373a20 = (0, $3kfkg.createResource)({
    type: "WORKSPACE_PULL_REQUESTS",
    getKey: ({ match: match, query: query })=>{
        // Strip out query params unrelated to fetching the pull request list
        const parsedQuery = $c57fd619d0cf1006$export$1e8473eaf75b0d10(query);
        const filteredQueryString = (0, $9H597.stringify)(parsedQuery);
        return `workspace:${match.params.workspaceSlug}::pullRequests:${filteredQueryString}`;
    },
    maxAge: 30000,
    // 30 seconds
    getData: async ({ match: match, query: query }, { csrftoken: csrftoken, appData: appData })=>{
        const { workspaceSlug: workspaceSlug } = match.params;
        // If we can't match the URL to a workspace slug, this resource is being used on a route
        // it shouldn't be.
        if (!workspaceSlug) return null;
        const { page: page, search: search, prState: prState, prUserFilter: prUserFilter, authorsAaid: authorsAaid, project: project } = $c57fd619d0cf1006$export$1e8473eaf75b0d10(query);
        const filter = {
            search: search,
            prState: prState,
            prUserFilter: prUserFilter,
            authorsAaid: authorsAaid,
            project: project
        };
        const { user: user } = appData;
        const q = $c57fd619d0cf1006$var$buildBBQL(filter, user);
        const params = (0, $9H597.stringify)({
            fields: $c57fd619d0cf1006$var$FIELDS,
            page: page,
            pagelen: $c57fd619d0cf1006$var$PAGE_LEN,
            q: q
        });
        const response = await fetch((0, $k2cPS.default)(`${(0, $ksfVj.default).api.internal.pullRequests(workspaceSlug)}/${params}`, {
            headers: (0, $k2cPS.jsonHeaders)
        }, csrftoken));
        if (!response.ok) throw new Error(`${response.status} ${response.statusText}`);
        const responseData = await response.json();
        const { size: size, pagelen: pagelen } = responseData;
        const pullRequests = responseData.values;
        return {
            size: size,
            pagelen: pagelen,
            pullRequests: pullRequests
        };
    }
});

});

parcelRegister("ag538", function(module, exports) {

$parcel$export(module.exports, "WorkspaceSettingsAccessTokensLoadable", function () { return $f5b53ac3ad551b54$export$8ec52a9efadfa106; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $f5b53ac3ad551b54$export$8ec52a9efadfa106 = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("4DtNp")),
    modules: [
        "./access-tokens"
    ],
    webpack: ()=>[
            undefined("./access-tokens")
        ]
});

});
parcelRegister("4DtNp", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2H5Nx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("eWB8F")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c7qp4")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c2d9Y"))
]).then(()=>parcelRequire("3P0S7"));

});


parcelRegister("l1OmI", function(module, exports) {

$parcel$export(module.exports, "compassResource", function () { return $de2517d726a963bf$export$b515718a97152a6e; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $cwUgA = parcelRequire("cwUgA");
const $de2517d726a963bf$export$b515718a97152a6e = (0, $3kfkg.createResource)({
    type: "compassResource",
    getKey: ({ match: match })=>{
        return `compassResource.${match.params.workspaceSlug}`;
    },
    maxAge: 60000,
    getData: ({ match: match })=>{
        const { workspaceSlug: workspaceSlug } = match.params;
        if (!workspaceSlug) throw new Error("Could not fetch compass cloudIds, URL params were not available");
        const api = (0, $cwUgA.compassApi)();
        return api.getCloudIdsForWorkspace(workspaceSlug);
    }
});

});
parcelRegister("cwUgA", function(module, exports) {

$parcel$export(module.exports, "compassApi", function () { return $077f71853463551d$export$2a855f2a60a7bc87; });

var $1IoYt = parcelRequire("1IoYt");

var $ksfVj = parcelRequire("ksfVj");

var $jzmnA = parcelRequire("jzmnA");
// The throttling is used to prevent multiple requests being sent
// from different React components trying to load the same data
const $077f71853463551d$var$THROTTLE_TIMEOUT = 30000;
const $077f71853463551d$var$getCloudIdsForWorkspace = (0, $1IoYt.default)((workspaceSlug)=>(0, $jzmnA.createHttpRequest)("GET")((0, $ksfVj.default).api.internal.getCompassCloudIdsForWorkspace(workspaceSlug)), $077f71853463551d$var$THROTTLE_TIMEOUT);
const $077f71853463551d$var$getCloudIdsForRepository = (0, $1IoYt.default)((workspaceSlug, repositorySlug)=>{
    return (0, $jzmnA.createHttpRequest)("GET")((0, $ksfVj.default).api.internal.getCompassCloudIdsForRepository(workspaceSlug, repositorySlug));
}, $077f71853463551d$var$THROTTLE_TIMEOUT);
const $077f71853463551d$export$2a855f2a60a7bc87 = ()=>{
    return {
        getCloudIdsForWorkspace: $077f71853463551d$var$getCloudIdsForWorkspace,
        getCloudIdsForRepository: $077f71853463551d$var$getCloudIdsForRepository
    };
};

});
parcelRegister("1IoYt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13fd45df66fc5b23$export$2e2bcd8739ae039; });

var $62zzi = parcelRequire("62zzi");

var $bmzpf = parcelRequire("bmzpf");
/** Error message constants. */ var $13fd45df66fc5b23$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $13fd45df66fc5b23$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($13fd45df66fc5b23$var$FUNC_ERROR_TEXT);
    if ((0, $bmzpf.default)(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return (0, $62zzi.default)(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
var $13fd45df66fc5b23$export$2e2bcd8739ae039 = $13fd45df66fc5b23$var$throttle;

});



parcelRegister("5OdXm", function(module, exports) {

$parcel$export(module.exports, "mergeChecksActivationResource", function () { return $9c0f954f9ac82005$export$c56effcc00636584; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $eBnOv = parcelRequire("eBnOv");
const $9c0f954f9ac82005$export$c56effcc00636584 = (0, $3kfkg.createResource)({
    type: "mergeChecksActivationResource",
    getKey: ({ match: match })=>{
        return `mergeChecksActivationResource.${match.params.workspaceSlug}`;
    },
    maxAge: 1,
    getData: ({ match: match })=>{
        const { workspaceSlug: workspaceSlug } = match.params;
        if (!workspaceSlug) throw new Error("Could not fetch merge checks activation, URL params were not available");
        const api = (0, $eBnOv.createMergeChecksActivationApi)(workspaceSlug);
        return api.getActivation();
    }
});

});
parcelRegister("eBnOv", function(module, exports) {

$parcel$export(module.exports, "createMergeChecksActivationApi", function () { return $a443570a03915345$export$149bff3e576198c6; });

var $ksfVj = parcelRequire("ksfVj");

var $jzmnA = parcelRequire("jzmnA");
const $a443570a03915345$export$149bff3e576198c6 = (workspaceSlug)=>({
        getActivation: ()=>(0, $jzmnA.createHttpRequest)("GET", {
                throwErrorType: "errorObject"
            })((0, $ksfVj.default).api.internal.mergeChecksActivation(workspaceSlug)),
        setActivation: (activated)=>(0, $jzmnA.createHttpRequest)("PUT", {
                successCustomHandler: ()=>null
            } // handle 204 response
            )((0, $ksfVj.default).api.internal.mergeChecksActivation(workspaceSlug), {
                activated: activated
            })
    });

});


parcelRegister("c406Y", function(module, exports) {

$parcel$export(module.exports, "WorkspaceSettingsPermissionsLoadable", function () { return $ebc8aeb6c5b4386a$export$8c2ad27aa6168f58; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $ebc8aeb6c5b4386a$export$8c2ad27aa6168f58 = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("9oz61")),
    modules: [
        "./permissions"
    ],
    webpack: ()=>[
            undefined("./permissions")
        ]
});

});
parcelRegister("9oz61", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("dp5FD")).then(()=>parcelRequire("lH5pz"));

});


parcelRegister("gkHct", function(module, exports) {

$parcel$export(module.exports, "fetchPermissions", function () { return $8ff3200c1c21ca5a$export$4f24ecba11982e9d; });
$parcel$export(module.exports, "loadWorkspaceSettingsPermissionsResource", function () { return $8ff3200c1c21ca5a$export$8c02ad3040b0f335; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");
parcelRequire("DVpDa");
var $5sg28 = parcelRequire("5sg28");
var $hCBEg = parcelRequire("hCBEg");

var $ksfVj = parcelRequire("ksfVj");

var $jzmnA = parcelRequire("jzmnA");
const $8ff3200c1c21ca5a$export$4f24ecba11982e9d = (workspaceSlug, { page: page = 1, permission: permission, principalName: principalName } = {})=>{
    return (0, $jzmnA.request)((0, $ksfVj.default).api.internal.inheritedPermissions(workspaceSlug, {
        page: page,
        q: (0, $5sg28.buildBBQL)({
            permission: permission,
            principalName: principalName
        })
    }), {
        successTransformer: ({ values: values = [], page: pagenum, pagelen: pagelen, size: size })=>{
            return {
                permissions: new Map([
                    [
                        pagenum,
                        values.map((0, $hCBEg.mapInheritedUserAndGroupPrivilege))
                    ]
                ]),
                page: pagenum,
                limit: pagelen,
                total: size
            };
        }
    });
};
const $8ff3200c1c21ca5a$export$8c02ad3040b0f335 = (0, $3kfkg.createResource)({
    type: "workspaceAdminPermissions",
    getKey: ({ match: match })=>{
        const { workspaceSlug: workspaceSlug } = match.params;
        return (0, $ksfVj.default).ui.permissions(workspaceSlug);
    },
    maxAge: 60000,
    // cache for 1 minute so navigating between pages is fast
    getData: async ({ match: match })=>{
        const { workspaceSlug: workspaceSlug } = match.params;
        return {
            ...await $8ff3200c1c21ca5a$export$4f24ecba11982e9d(workspaceSlug),
            adminLevel: "workspace"
        };
    }
});

});

parcelRegister("dcA0E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4e73c161a494efa$export$2e2bcd8739ae039; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $e4e73c161a494efa$var$PipelinesWorkspaceDynamicPipelinesPageLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("6rV0J")),
    modules: [
        "./dynamic-pipelines"
    ],
    webpack: ()=>[
            undefined("./dynamic-pipelines")
        ]
});
var $e4e73c161a494efa$export$2e2bcd8739ae039 = $e4e73c161a494efa$var$PipelinesWorkspaceDynamicPipelinesPageLoadable;

});
parcelRegister("6rV0J", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("eWSl0")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9Qnhv"))
]).then(()=>parcelRequire("14ZvX"));

});


parcelRegister("jvOKb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc487b8910fadddd$export$2e2bcd8739ae039; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $fc487b8910fadddd$var$PipelinesWorkspaceRunnersPageLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("6teZW")),
    modules: [
        "./runners"
    ],
    webpack: ()=>[
            undefined("./runners")
        ]
});
var $fc487b8910fadddd$export$2e2bcd8739ae039 = $fc487b8910fadddd$var$PipelinesWorkspaceRunnersPageLoadable;

});
parcelRegister("6teZW", function(module, exports) {
























module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9gDpJ")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5gMKg")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("k7j7T")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jDJuC")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("cFFKC")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3vzef")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2cqKR")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2H5Nx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jokVj")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3ECa9")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c7qp4")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8R4F2"))
]).then(()=>parcelRequire("t6ElD"));

});


parcelRegister("JQKkV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81def441a3a77207$export$2e2bcd8739ae039; });

var $8shKB = parcelRequire("8shKB");

var $3wXS7 = parcelRequire("3wXS7");

const $81def441a3a77207$var$PipelinesWorkspaceVariablesPageLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.LoadingPage),
    loader: ()=>(parcelRequire("bNipo")),
    modules: [
        "./variables"
    ],
    webpack: ()=>[
            undefined("./variables")
        ]
});
var $81def441a3a77207$export$2e2bcd8739ae039 = $81def441a3a77207$var$PipelinesWorkspaceVariablesPageLoadable;

});
parcelRegister("bNipo", function(module, exports) {


















module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("k7j7T")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jDJuC")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("cFFKC")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9oryG")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3vzef")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("wQ8eQ")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3ECa9")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9uabR")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5TlsJ"))
]).then(()=>parcelRequire("iWoXX"));

});


parcelRegister("bF07x", function(module, exports) {

$parcel$export(module.exports, "workspaceSectionResource", function () { return $e047ffadef5c9ae6$export$218a9853fa2397f; });
parcelRequire("lM4y8");
var $3kfkg = parcelRequire("3kfkg");

var $fE4bV = parcelRequire("fE4bV");
parcelRequire("5YpaN");
var $8NQo6 = parcelRequire("8NQo6");
parcelRequire("6tQ7a");
var $k5ZQb = parcelRequire("k5ZQb");

var $4bDaH = parcelRequire("4bDaH");

var $3nrvH = parcelRequire("3nrvH");
const $e047ffadef5c9ae6$export$218a9853fa2397f = (0, $3kfkg.createResource)({
    type: "WORKSPACE_SECTION",
    getKey: ({ match: match })=>`workspace:${match.params.workspaceSlug}`,
    maxAge: 0,
    getData: async ({ match: match }, { reduxStore: reduxStore, csrftoken: csrftoken })=>{
        const { workspaceSlug: workspaceSlug } = match.params;
        // If we can't match the URL to a workspace slug, this resource is being used on a route
        // it shouldn't be.
        if (!workspaceSlug) return null;
        const { dispatch: dispatch } = reduxStore;
        const action = (0, $4bDaH.default)(workspaceSlug, {
            csrftoken: csrftoken,
            isRouterResource: true
        });
        // check the initial state and skip to MyAction.SUCCESS if we already have the data
        const hydrateAction = (0, $fE4bV.getHydrateAction)(action, (0, $4bDaH.stateKey));
        if (hydrateAction) {
            dispatch(hydrateAction);
            return {
                status: "success"
            };
        }
        // Update the URL to fetch the data based on the state key
        action.meta.url = (0, $3nrvH.urlWithState)((0, $4bDaH.getApiUrl)(workspaceSlug), (0, $4bDaH.stateKey));
        const result = await dispatch((0, $8NQo6.fetchDataFromResource)(action));
        if ((result === null || result === void 0 ? void 0 : result.type) === (0, $k5ZQb.LoadProfilePage).ERROR) return null;
        return {
            status: "success"
        };
    }
});

});
parcelRegister("6tQ7a", function(module, exports) {
$parcel$export(module.exports, "LoadProfilePage", function () { return (parcelRequire("k5ZQb")).LoadProfilePage; });
parcelRequire("k5ZQb");

});
parcelRegister("k5ZQb", function(module, exports) {

$parcel$export(module.exports, "LoadProfilePage", function () { return $3340e2a4e3ab99a1$export$a39717ea63da0b68; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
const $3340e2a4e3ab99a1$export$a39717ea63da0b68 = (0, $2MctD.createAsyncAction)("profile/LOAD_PROFILE_PAGE");

});


parcelRegister("4bDaH", function(module, exports) {

$parcel$export(module.exports, "getApiUrl", function () { return $80b1267bb8933eb8$export$1b98eaf73d37f034; });
$parcel$export(module.exports, "stateKey", function () { return $80b1267bb8933eb8$export$77b371d6becc8882; });
$parcel$export(module.exports, "default", function () { return $80b1267bb8933eb8$export$2e2bcd8739ae039; });
parcelRequire("5YpaN");
var $fICwP = parcelRequire("fICwP");

var $3rtV2 = parcelRequire("3rtV2");
parcelRequire("6tQ7a");
var $k5ZQb = parcelRequire("k5ZQb");
const $80b1267bb8933eb8$export$1b98eaf73d37f034 = (workspaceSlug)=>(0, $3rtV2.default).ui.profile(workspaceSlug);
const $80b1267bb8933eb8$export$77b371d6becc8882 = [
    "profile.section",
    "section.profile"
];
var $80b1267bb8933eb8$export$2e2bcd8739ae039 = (workspaceSlug, meta = {})=>(0, $fICwP.hydrateAction)((0, $k5ZQb.LoadProfilePage), $80b1267bb8933eb8$export$77b371d6becc8882, {
        ...meta,
        url: $80b1267bb8933eb8$export$1b98eaf73d37f034(workspaceSlug)
    });

});
parcelRegister("3rtV2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecd1cb44975bb670$export$2e2bcd8739ae039; });
const $ecd1cb44975bb670$var$urls = {
    api: {
        internal: {
            userPreference: (uuid, key)=>`/!api/internal/user/preferences/${uuid}/${key}/`,
            repositoriesLanguages: (workspaceSlug)=>`/!api/internal/repositories/${workspaceSlug}/languages`
        },
        v10: {},
        v20: {
            user: (uuid)=>`/!api/2.0/users/${uuid}`
        }
    },
    external: {},
    ui: {
        // Trailing slash is necessary here to avoid a redirect that could wipe out query params
        profile: (username)=>`/${username}/workspace/overview/`
    }
};
var $ecd1cb44975bb670$export$2e2bcd8739ae039 = $ecd1cb44975bb670$var$urls;

});



parcelRegister("jZQtV", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("buqAL")).then(()=>parcelRequire("2A7S4"));

});

parcelRegister("6hmXS", function(module, exports) {
































module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("bIgAg")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("1lMUy")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fgeUo")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7O1Mm")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("hFPDk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("HOeIP")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9oryG")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6XRs7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3rlr8")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("apPbw")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c7qp4")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jFvy9")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3eASR")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5M5fs")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9r5Qy")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("duu9J"))
]).then(()=>parcelRequire("5Tfpn"));

});

parcelRegister("hQ43v", function(module, exports) {




































module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jokVj")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("a0pdz")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("4lXxI")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8FZFT")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("lHmBe")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("gSn8f")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvUP")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6qh0x")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kjN9y")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c3BIL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvz8")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("e0Fn7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fDD7i")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7xLkx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3op3S")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8YPZB")),
    (parcelRequire("18jdD"))((parcelRequire("1sJKT")).getBundleURL("ekZ4q") + "container-navigation.211acefb.js", "script", false)
]).then(()=>parcelRequire("2OiLW"));

});

parcelRegister("94Q7K", function(module, exports) {




































module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jokVj")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("a0pdz")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("4lXxI")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8FZFT")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("lHmBe")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("gSn8f")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvUP")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6qh0x")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kjN9y")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c3BIL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvz8")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("e0Fn7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fDD7i")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7xLkx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3op3S")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2iDSb")),
    (parcelRequire("18jdD"))((parcelRequire("1sJKT")).getBundleURL("ekZ4q") + "profile-navigation-next.ef842739.js", "script", false)
]).then(()=>parcelRequire("k4odM"));

});

parcelRegister("hP6P1", function(module, exports) {
















module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvUP")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6qh0x")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kjN9y")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("e0Fn7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fDD7i")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7xLkx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3op3S")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("hI4T6"))
]).then(()=>parcelRequire("bL9fN"));

});

parcelRegister("2VQ2V", function(module, exports) {
























module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7O1Mm")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("hFPDk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9oryG")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3rlr8")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("apPbw")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c7qp4")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2MxGY")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("bUF8s")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jSISz")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2K4u4")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6LXwM")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("cdT6X"))
]).then(()=>parcelRequire("1lX6G"));

});

parcelRegister("e477H", function(module, exports) {


















































module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jokVj")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("a0pdz")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("4lXxI")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8FZFT")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("lHmBe")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6XRs7")),
    (parcelRequire("8iLLr"))((parcelRequire("7kEWw")).resolve("gQqOh")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("i5DDp")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("dx5v1")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("aNQri")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvUP")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6qh0x")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kjN9y")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("eEZpb")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c3BIL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5chan")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2Ju5h")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9fvz8")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("e0Fn7")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fDD7i")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("7xLkx")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3op3S")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("ewUvT")),
    (parcelRequire("18jdD"))((parcelRequire("1sJKT")).getBundleURL("ekZ4q") + "container-navigation.211acefb.js", "script", false)
]).then(()=>parcelRequire("g9z8O"));

});

parcelRegister("7VnJp", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3rlr8")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2Ju5h")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("lcAz2"))
]).then(()=>parcelRequire("4R61W"));

});

parcelRegister("ekVxR", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("3rlr8")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c8k6J"))
]).then(()=>parcelRequire("lQdeS"));

});

parcelRegister("bAQTT", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("k923v")).then(()=>parcelRequire("k5Y4v"));

});

parcelRegister("eld9X", function(module, exports) {




















module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("dFon2")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9gDpJ")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jokVj")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("alk8w")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("eVxMg")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jlbhG")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("c3BIL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9r5Qy")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("azvsv"))
]).then(()=>parcelRequire("7rqwV"));

});

parcelRegister("jlxXg", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jmLwq")).then(()=>parcelRequire("8VXW2"));

});

parcelRegister("3NBse", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5ZKZo")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9oryG")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("clqsk")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("ltrPs"))
]).then(()=>parcelRequire("lu8Pq"));

});

parcelRegister("aPnRZ", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5ZKZo")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("iIO0Z"))
]).then(()=>parcelRequire("bXV6t"));

});

parcelRegister("aqcqt", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9cz44")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("1QkO4")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fyTtw"))
]).then(()=>parcelRequire("kmXR2"));

});

parcelRegister("5MoEN", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("5ZKZo")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kPXIw"))
]).then(()=>parcelRequire("cLlmB"));

});

parcelRegister("jBjaA", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kSZdj")).then(()=>parcelRequire("bVLj8"));

});

parcelRegister("dk4Y0", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("6FvKn")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2KoxF"))
]).then(()=>parcelRequire("jyMlZ"));

});

parcelRegister("6orNp", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kBzNL")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9epQ8"))
]).then(()=>parcelRequire("gphhn"));

});

parcelRegister("9GOyO", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("k923v")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("8XOzv"))
]).then(()=>parcelRequire("94fvG"));

});

parcelRegister("5ANcH", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("k923v")),
    (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kO3S7"))
]).then(()=>parcelRequire("kSy6f"));

});




parcelRegister("1jQQK", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_PERFORMANCE_MARK_NAMESPACE", function () { return $4847b128d29e89e1$export$3f77d045a3a77f5; });
$parcel$export(module.exports, "PERFORMANCE_MARK_SSR_HTML", function () { return $4847b128d29e89e1$export$d0731266fdec6d15; });
const $4847b128d29e89e1$export$3f77d045a3a77f5 = "SPA";
const $4847b128d29e89e1$export$cc4bd64d03ea60b3 = "SSR_START";
const $4847b128d29e89e1$export$d0731266fdec6d15 = "SSR_HTML";
const $4847b128d29e89e1$export$46bea76d14cc1d67 = "SSR_STYLES";

});

parcelRegister("hp1uP", function(module, exports) {

$parcel$export(module.exports, "CurrentDataContext", function () { return $40c3ac64e8eff4b8$export$4a2643a21ed34633; });
$parcel$export(module.exports, "CurrentDataProvider", function () { return $40c3ac64e8eff4b8$export$e62e8d2a4c845be; });

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("lM4y8");
var $fM82h = parcelRequire("fM82h");

var $aH4uQ = parcelRequire("aH4uQ");

var $k5krn = parcelRequire("k5krn");

var $7sB53 = parcelRequire("7sB53");
const $40c3ac64e8eff4b8$export$4a2643a21ed34633 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createContext({
    workspace: undefined,
    project: undefined,
    repository: undefined
});
const $40c3ac64e8eff4b8$export$e62e8d2a4c845be = (props)=>{
    // We get the initial context from the server via app data. As soon as we
    // get any content from a resource we should ignore the initial values so
    // we don't pass stale data.
    const hasUpdatedRef = (0, $9nHZC.useRef)(false);
    const initialValue = props.initialContext;
    const { data: workspaceData } = (0, $fM82h.useResource)((0, $7sB53.workspaceNavigationResource));
    const { data: projectData } = (0, $fM82h.useResource)((0, $aH4uQ.projectNavigationResource));
    const { data: repoData } = (0, $fM82h.useResource)((0, $k5krn.repositoryNavigationResource));
    const workspace = (workspaceData === null || workspaceData === void 0 ? void 0 : workspaceData.workspace) || (projectData === null || projectData === void 0 ? void 0 : projectData.project.workspace) || (repoData === null || repoData === void 0 ? void 0 : repoData.repository.workspace);
    const project = (projectData === null || projectData === void 0 ? void 0 : projectData.project) || (repoData === null || repoData === void 0 ? void 0 : repoData.repository.project);
    const repository = repoData === null || repoData === void 0 ? void 0 : repoData.repository;
    const resourceValue = (0, $9nHZC.useMemo)(()=>{
        return {
            workspace: workspace,
            project: project,
            repository: repository
        };
    }, [
        workspace,
        project,
        repository
    ]);
    if (workspaceData || projectData || repoData) hasUpdatedRef.current = true;
    const value = hasUpdatedRef.current ? resourceValue : initialValue;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($40c3ac64e8eff4b8$export$4a2643a21ed34633.Provider, {
        value: value
    }, props.children);
};

});

parcelRegister("ikMGL", function(module, exports) {

$parcel$export(module.exports, "useRecentData", function () { return $8eda94c1d85120f7$export$5b0ada08b9b7bd62; });

var $9nHZC = parcelRequire("9nHZC");

var $ga67g = parcelRequire("ga67g");
parcelRequire("dGzLf");
var $eeHDY = parcelRequire("eeHDY");
var $aAre5 = parcelRequire("aAre5");

var $1D3HA = parcelRequire("1D3HA");
parcelRequire("5YpaN");
var $kTw57 = parcelRequire("kTw57");

var $e8VvG = parcelRequire("e8VvG");

var $3VThC = parcelRequire("3VThC");

var $grdQ5 = parcelRequire("grdQ5");
parcelRequire("85vJP");
var $5Put2 = parcelRequire("5Put2");

var $48ZQ3 = parcelRequire("48ZQ3");

var $aanBq = parcelRequire("aanBq");

var $6OwE2 = parcelRequire("6OwE2");

var $k2cPS = parcelRequire("k2cPS");

var $7hVkj = parcelRequire("7hVkj");

var $4uvOm = parcelRequire("4uvOm");
const $8eda94c1d85120f7$var$useRepositoryLoader = ()=>{
    const appData = (0, $9nHZC.useContext)((0, $1D3HA.AppDataContext));
    const dispatch = (0, $eeHDY.useDispatch)();
    return (0, $9nHZC.useCallback)(async (includeBuildStatus)=>{
        if (!appData.user) return [];
        if (!appData.initialContext.workspace) return [];
        // storage key expects UUID with braces
        const recentlyViewedRepositories = (0, $7hVkj.default).get({
            uuid: `{${appData.user.uuid}}`
        });
        const { workspaceUuids: workspaceUuids } = recentlyViewedRepositories;
        const repositoryUuids = workspaceUuids[appData.initialContext.workspace.uuid];
        if (Object.keys(workspaceUuids).length === 0 || !repositoryUuids || !repositoryUuids.length) return [];
        const uniqueUuids = repositoryUuids.filter((uuid, i, arr)=>arr.indexOf(uuid) === i);
        const fetchAsyncData = (action)=>{
            // Ignore the `fetch-action-saga` so we can await the fetchData action
            action.meta.isRouterResource = true;
            dispatch(action);
            // @ts-ignore
            return dispatch((0, $kTw57.fetchData)(action));
        };
        const fetchAction = (0, $grdQ5.fetchRecentlyViewedRepositories)(uniqueUuids);
        const recentReposResponse = await fetchAsyncData(fetchAction);
        const { payload: { result: { values: responseUuids }, entities: entities } } = recentReposResponse;
        let repos = (0, $ga67g.denormalize)(responseUuids, [
            (0, $48ZQ3.repository)
        ], entities);
        if (!includeBuildStatus) // We're using implicit knowledge that if we aren't requesting build
        // statuses, this is called from the horizontal nav search. In that
        // case, we're taking some shortcuts to return some (possibly
        // incomplete) data faster. We need to return the repository objects,
        // so denormalize the response.
        return repos;
        try {
            const url = (0, $6OwE2.default).api.internal.repositoryBuildStatuses();
            const response = await fetch((0, $k2cPS.default)(url, {
                method: "POST",
                body: uniqueUuids.map((uuid)=>`uuid=${uuid}`).join("&"),
                headers: {
                    "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
                }
            }));
            if (response.ok) {
                const statuses = await response.json();
                repos = (0, $3VThC.addStatuses)(repos, statuses);
                // normalizr will handle this action
                dispatch({
                    type: (0, $e8VvG.UPDATE_REPOSITORY_BUILD_STATUSES).SUCCESS,
                    payload: repos,
                    meta: {
                        schema: [
                            (0, $48ZQ3.repository)
                        ]
                    }
                });
            }
        } catch (e) {
            dispatch({
                type: (0, $e8VvG.UPDATE_REPOSITORY_BUILD_STATUSES).ERROR,
                payload: e
            });
        }
        return repos;
    }, [
        dispatch,
        appData.user,
        appData.initialContext.workspace
    ]);
};
const $8eda94c1d85120f7$export$5b0ada08b9b7bd62 = ()=>{
    const appData = (0, $9nHZC.useContext)((0, $1D3HA.AppDataContext));
    const recentRepositories = (0, $aAre5.useSelector)((0, $aanBq.getRecentlyViewedRepositories));
    const dispatch = (0, $eeHDY.useDispatch)();
    const loadRecentRepositories = $8eda94c1d85120f7$var$useRepositoryLoader();
    const loadRecentWorkspaces = (0, $9nHZC.useCallback)(()=>{
        if (!appData.user) return;
        // storage key expects UUID with braces
        const workspaceUuids = (0, $4uvOm.default).get({
            uuid: `{${appData.user.uuid}}`
        });
        if (workspaceUuids) dispatch({
            type: (0, $5Put2.GET_RECENTLY_VIEWED_WORKSPACES),
            payload: workspaceUuids
        });
    }, [
        dispatch,
        appData.user
    ]);
    return {
        recentRepositories: recentRepositories,
        loadRecentRepositories: loadRecentRepositories,
        loadRecentWorkspaces: loadRecentWorkspaces
    };
};

});
parcelRegister("e8VvG", function(module, exports) {

$parcel$export(module.exports, "UPDATE_REPOSITORY_BUILD_STATUSES", function () { return $b00bfe552c1989cc$export$4504296f2abf8038; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
const $b00bfe552c1989cc$export$4504296f2abf8038 = (0, $2MctD.createAsyncAction)("dashboard/update-repositories-with-build-status");

});

parcelRegister("3VThC", function(module, exports) {

$parcel$export(module.exports, "addStatuses", function () { return $f96ed2ae987cb190$export$6020b49f9b4a75d7; });
const $f96ed2ae987cb190$export$6020b49f9b4a75d7 = (repositories, statuses)=>{
    return repositories.map((repository)=>{
        const buildStatus = statuses.find((s)=>s.repository.uuid === repository.uuid);
        return {
            ...repository,
            status_counts: buildStatus && buildStatus.status_counts,
            statusUrl: buildStatus && buildStatus.links.builds.href
        };
    });
};

});

parcelRegister("grdQ5", function(module, exports) {

$parcel$export(module.exports, "ADD_RECENTLY_VIEWED_REPOSITORY", function () { return $6a7ef0e4b1c362ad$export$c15ddd6afbbe57b2; });
$parcel$export(module.exports, "FetchRecentlyViewedRepository", function () { return $6a7ef0e4b1c362ad$export$4082ff971612dbc1; });
$parcel$export(module.exports, "addRecentlyViewedRepository", function () { return $6a7ef0e4b1c362ad$export$a44c5cecd2136ad6; });
$parcel$export(module.exports, "fetchRecentlyViewedRepositories", function () { return $6a7ef0e4b1c362ad$export$8b4318823ff9b9cf; });
$parcel$export(module.exports, "reducer", function () { return $6a7ef0e4b1c362ad$export$1650419e431d3ba3; });

var $cJH1T = parcelRequire("cJH1T");
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
var $fICwP = parcelRequire("fICwP");

var $48ZQ3 = parcelRequire("48ZQ3");

var $kZnTB = parcelRequire("kZnTB");

var $gsXeO = parcelRequire("gsXeO");

var $7hVkj = parcelRequire("7hVkj");
const $6a7ef0e4b1c362ad$export$c15ddd6afbbe57b2 = "repository/ADD_RECENTLY_VIEWED_REPOSITORY";
const $6a7ef0e4b1c362ad$export$f8b134d771c1f9fd = (0, $2MctD.createAsyncAction)("repository/FETCH_RECENTLY_VIEWED_REPOSITORIES");
const $6a7ef0e4b1c362ad$export$4082ff971612dbc1 = (0, $2MctD.createAsyncAction)("repository/FETCH_RECENTLY_VIEWED_REPOSITORY");
const $6a7ef0e4b1c362ad$export$a44c5cecd2136ad6 = (repository)=>{
    const { workspace: workspace } = repository;
    const { uuid: workspaceUuid } = workspace || {};
    return {
        type: $6a7ef0e4b1c362ad$export$c15ddd6afbbe57b2,
        payload: repository,
        meta: {
            schema: (0, $48ZQ3.repository),
            workspaceUuid: workspaceUuid
        }
    };
};
const $6a7ef0e4b1c362ad$var$recentRepositoryFields = [
    "uuid",
    "name",
    "workspace.name",
    "links.html.href",
    "links.avatar.href",
    // These are used on the dashboard overview repo card
    "full_name",
    "landing_page",
    // The source browser expects the fork_policy to be present, and apparently
    // this recent repositories call is implicitly expected to be called on that
    // page, including the currently visible repository
    "fork_policy",
    // The repository navigation expects the workspace slug to be present
    "workspace.slug",
    // This is used by the vertical nav and can be removed when we
    // move entirely to the horizontal nav
    "owner.uuid"
];
const $6a7ef0e4b1c362ad$export$8b4318823ff9b9cf = (repositoryUuids)=>{
    const url = (0, $kZnTB.default).api.v20.repositories();
    const fields = $6a7ef0e4b1c362ad$var$recentRepositoryFields.map((f)=>`values.${f}`).join(",");
    const bbql = repositoryUuids.map((uuid)=>`uuid = "${uuid}"`).join(" OR ");
    const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
        q: bbql,
        role: "member",
        fields: fields
    });
    return (0, $fICwP.fetchAction)($6a7ef0e4b1c362ad$export$f8b134d771c1f9fd, {
        url: `${url}?${queryParams}`,
        data: {
            requestedUuids: repositoryUuids
        },
        schema: {
            values: [
                (0, $48ZQ3.repository)
            ]
        }
    });
};
const $6a7ef0e4b1c362ad$export$c5eb27163aa071b8 = (uuid)=>{
    const url = (0, $kZnTB.default).api.v20.repositoryByUuid(uuid);
    const fields = $6a7ef0e4b1c362ad$var$recentRepositoryFields.join(",");
    const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
        fields: fields
    });
    return (0, $fICwP.fetchAction)($6a7ef0e4b1c362ad$export$4082ff971612dbc1, {
        url: `${url}?${queryParams}`,
        data: {
            requestedUuid: uuid
        },
        schema: (0, $48ZQ3.repository)
    });
};
const $6a7ef0e4b1c362ad$var$initialState = [];
const $6a7ef0e4b1c362ad$export$1650419e431d3ba3 = (0, $gsXeO.default)($6a7ef0e4b1c362ad$var$initialState, {
    [$6a7ef0e4b1c362ad$export$c15ddd6afbbe57b2] (state, action) {
        const repositoryId = action.payload.result;
        const idx = state.indexOf(repositoryId);
        if (idx === 0) return state;
        if (idx !== -1) return [
            repositoryId,
            ...state.slice(0, idx),
            ...state.slice(idx + 1)
        ];
        return [
            repositoryId,
            ...state.slice(0, (0, $7hVkj.MAX_RECENTLY_VIEWED_REPOS) - 1)
        ];
    },
    // Proactively/Immediately update redux with the cached UUIDs from localstorage
    // to prevent race conditions that could override the data if the request is slow
    [$6a7ef0e4b1c362ad$export$f8b134d771c1f9fd.REQUEST] (state, action) {
        if (!action.meta.data || !action.meta.data.requestedUuids) return state;
        return [
            ...action.meta.data.requestedUuids
        ];
    },
    [$6a7ef0e4b1c362ad$export$4082ff971612dbc1.ERROR] (state, action) {
        const { data: data, status: status } = action.meta;
        // If the repository has been deleted or is no longer accessible, remove it
        if (data && data.requestedUuid && (status === 404 || status === 403)) return state.filter((uuid)=>uuid !== data.requestedUuid);
        return state;
    }
});

});
parcelRegister("7hVkj", function(module, exports) {

$parcel$export(module.exports, "MAX_RECENTLY_VIEWED_REPOS", function () { return $e0027023b39d3786$export$de4c3c97da1637a0; });
$parcel$export(module.exports, "default", function () { return $e0027023b39d3786$export$2e2bcd8739ae039; });

var $3XbtU = parcelRequire("3XbtU");

var $h3kk7 = parcelRequire("h3kk7");
const $e0027023b39d3786$export$de4c3c97da1637a0 = 15;
/* 
In this file, we store metadata into local storage as shown below to fetch recently viewed repo
uuids for workspace-scoped 'Your work'.

{
  "workspaceUuids": {
    "{workspace_uuid_1}": ["{repo_uuid_1}", "{repo_uuid_2}"],
    "{workspace_uuid_2}": ["{repo_uuid_3}"]
  }
}

The above data schema does not apply to the `recentlyViewedRepositories` reducer which
still expects an array of repo uuids due to several other dependencies.
*/ const $e0027023b39d3786$var$storageName = (user)=>`recently-viewed-repo-uuids-v2:${user.uuid}`;
function $e0027023b39d3786$var$insertRecentRepository(repositoryList, repositoryUuid) {
    if (repositoryList === undefined) return [
        repositoryUuid
    ];
    else {
        const idx = repositoryList.findIndex((r)=>repositoryUuid === r);
        if (idx === 0) return repositoryList;
        else if (idx !== -1) return [
            repositoryUuid,
            ...repositoryList.slice(0, idx),
            ...repositoryList.slice(idx + 1)
        ];
        else return [
            repositoryUuid,
            ...repositoryList.slice(0, $e0027023b39d3786$export$de4c3c97da1637a0 - 1)
        ];
    }
}
function $e0027023b39d3786$var$add(user, repositoryUuid, workspaceUuid) {
    try {
        if ((0, $h3kk7.default).enabled) {
            if (!workspaceUuid) // We should have workspace context but in case we don't
            throw new Error("Workspace context unavailable.");
            const key = $e0027023b39d3786$var$storageName(user);
            const repositoryStore = $e0027023b39d3786$var$get(user);
            const { workspaceUuids: workspaceUuids } = repositoryStore;
            const repositoryUuids = $e0027023b39d3786$var$insertRecentRepository(workspaceUuids[workspaceUuid], repositoryUuid);
            workspaceUuids[workspaceUuid] = repositoryUuids;
            (0, $h3kk7.default).set(key, {
                workspaceUuids: workspaceUuids
            });
        }
    } catch (e) {
        $3XbtU.captureException(e);
    }
}
function $e0027023b39d3786$var$set(user, recentlyViewedRepositories) {
    if ((0, $h3kk7.default).enabled) (0, $h3kk7.default).set($e0027023b39d3786$var$storageName(user), recentlyViewedRepositories);
}
function $e0027023b39d3786$var$get(user) {
    const initialStore = {
        workspaceUuids: {}
    };
    if (!(0, $h3kk7.default).enabled) return initialStore;
    return (0, $h3kk7.default).get($e0027023b39d3786$var$storageName(user)) || initialStore;
}
var $e0027023b39d3786$export$2e2bcd8739ae039 = {
    add: $e0027023b39d3786$var$add,
    get: $e0027023b39d3786$var$get,
    set: $e0027023b39d3786$var$set
};

});


parcelRegister("85vJP", function(module, exports) {
$parcel$export(module.exports, "ADD_RECENTLY_VIEWED_WORKSPACE", function () { return (parcelRequire("5Put2")).ADD_RECENTLY_VIEWED_WORKSPACE; });
$parcel$export(module.exports, "FETCH_WORKSPACE_PLAN", function () { return (parcelRequire("5Put2")).FETCH_WORKSPACE_PLAN; });
$parcel$export(module.exports, "GET_RECENTLY_VIEWED_WORKSPACES", function () { return (parcelRequire("5Put2")).GET_RECENTLY_VIEWED_WORKSPACES; });
parcelRequire("5Put2");

});

parcelRegister("4uvOm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d72b785ef9c7acbf$export$2e2bcd8739ae039; });

var $h3kk7 = parcelRequire("h3kk7");
const $d72b785ef9c7acbf$var$MAX_RECENTS = 5;
const $d72b785ef9c7acbf$var$storageName = (user)=>`recently-viewed-workspace-uuids:${user.uuid}`;
function $d72b785ef9c7acbf$var$addToRecents(recentUuids, uuid) {
    const idx = recentUuids.indexOf(uuid);
    if (idx === 0) return recentUuids;
    else if (idx > 0) recentUuids.splice(idx, 1);
    return [
        uuid,
        ...recentUuids
    ];
}
function $d72b785ef9c7acbf$var$add(user, workspaceUuid) {
    if ((0, $h3kk7.default).enabled) {
        const key = $d72b785ef9c7acbf$var$storageName(user);
        const currentUuids = (0, $h3kk7.default).get(key) || [];
        const uuids = $d72b785ef9c7acbf$var$addToRecents(currentUuids, workspaceUuid);
        (0, $h3kk7.default).set(key, uuids.slice(0, $d72b785ef9c7acbf$var$MAX_RECENTS));
    }
}
function $d72b785ef9c7acbf$var$set(user, workspaceUuids) {
    if ((0, $h3kk7.default).enabled) (0, $h3kk7.default).set($d72b785ef9c7acbf$var$storageName(user), workspaceUuids);
}
function $d72b785ef9c7acbf$var$get(user) {
    if (!(0, $h3kk7.default).enabled) return [];
    return (0, $h3kk7.default).get($d72b785ef9c7acbf$var$storageName(user)) || [];
}
var $d72b785ef9c7acbf$export$2e2bcd8739ae039 = {
    get: $d72b785ef9c7acbf$var$get,
    set: $d72b785ef9c7acbf$var$set,
    add: $d72b785ef9c7acbf$var$add
};

});


parcelRegister("iyyGb", function(module, exports) {

$parcel$export(module.exports, "LOAD_STATUSPAGE_INCIDENTS", function () { return $2f813bab53eec7c0$export$374b68dde686170d; });
$parcel$export(module.exports, "LoadStatusPageIncidentsSuccess", function () { return $2f813bab53eec7c0$export$35a8f168c5ade0a9; });
$parcel$export(module.exports, "LoadStatusPageIncidentsError", function () { return $2f813bab53eec7c0$export$6d4b02e8f7e2fd24; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
const $2f813bab53eec7c0$var$prefixed = (action)=>`global/${action}`;
const $2f813bab53eec7c0$export$374b68dde686170d = (0, $2MctD.createAsyncAction)($2f813bab53eec7c0$var$prefixed("LOAD_STATUSPAGE_INCIDENTS"));
const $2f813bab53eec7c0$export$35a8f168c5ade0a9 = (incidents)=>({
        type: $2f813bab53eec7c0$export$374b68dde686170d.SUCCESS,
        payload: incidents
    });
const $2f813bab53eec7c0$export$6d4b02e8f7e2fd24 = (error)=>({
        type: $2f813bab53eec7c0$export$374b68dde686170d.ERROR,
        error: error
    });

});

parcelRegister("61bjs", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_TITLE", function () { return $d8c4564766b01406$export$b7f953e4215212cf; });
$parcel$export(module.exports, "TITLE_TEMPLATE", function () { return $d8c4564766b01406$export$52331ad40249389f; });
const $d8c4564766b01406$export$b7f953e4215212cf = "Bitbucket";
const $d8c4564766b01406$export$52331ad40249389f = "%s \u2014 Bitbucket";

});

parcelRegister("jjdf2", function(module, exports) {

var $hGXKg = parcelRequire("hGXKg");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $e0ea102b179a6953$var$toInteger(value) {
    var result = $hGXKg(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = $e0ea102b179a6953$var$toInteger;

});
parcelRegister("hGXKg", function(module, exports) {

var $2WmHu = parcelRequire("2WmHu");
/** Used as references for various `Number` constants. */ var $ce14b41163d8921d$var$INFINITY = 1 / 0, $ce14b41163d8921d$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $ce14b41163d8921d$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $2WmHu(value);
    if (value === $ce14b41163d8921d$var$INFINITY || value === -$ce14b41163d8921d$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $ce14b41163d8921d$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = $ce14b41163d8921d$var$toFinite;

});
parcelRegister("2WmHu", function(module, exports) {

var $j5Gnb = parcelRequire("j5Gnb");

var $3kSRQ = parcelRequire("3kSRQ");

var $eE9rN = parcelRequire("eE9rN");
/** Used as references for various `Number` constants. */ var $22429b607f5027ef$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $22429b607f5027ef$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $22429b607f5027ef$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $22429b607f5027ef$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $22429b607f5027ef$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $22429b607f5027ef$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($eE9rN(value)) return $22429b607f5027ef$var$NAN;
    if ($3kSRQ(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $3kSRQ(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $j5Gnb(value);
    var isBinary = $22429b607f5027ef$var$reIsBinary.test(value);
    return isBinary || $22429b607f5027ef$var$reIsOctal.test(value) ? $22429b607f5027ef$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $22429b607f5027ef$var$reIsBadHex.test(value) ? $22429b607f5027ef$var$NAN : +value;
}
module.exports = $22429b607f5027ef$var$toNumber;

});
parcelRegister("j5Gnb", function(module, exports) {

var $lzkoL = parcelRequire("lzkoL");
/** Used to match leading whitespace. */ var $de5f5a53a571d405$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $de5f5a53a571d405$var$baseTrim(string) {
    return string ? string.slice(0, $lzkoL(string) + 1).replace($de5f5a53a571d405$var$reTrimStart, "") : string;
}
module.exports = $de5f5a53a571d405$var$baseTrim;

});
parcelRegister("lzkoL", function(module, exports) {
/** Used to match a single whitespace character. */ var $fb3cb08f48255409$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $fb3cb08f48255409$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $fb3cb08f48255409$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $fb3cb08f48255409$var$trimmedEndIndex;

});


parcelRegister("eE9rN", function(module, exports) {

var $44oBv = parcelRequire("44oBv");

var $fSpTQ = parcelRequire("fSpTQ");
/** `Object#toString` result references. */ var $aa9c212d99b4a86e$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $aa9c212d99b4a86e$var$isSymbol(value) {
    return typeof value == "symbol" || $fSpTQ(value) && $44oBv(value) == $aa9c212d99b4a86e$var$symbolTag;
}
module.exports = $aa9c212d99b4a86e$var$isSymbol;

});




parcelRegister("6Tn56", function(module, exports) {

$parcel$export(module.exports, "BbEnv", function () { return $fcf86092ef5ec2f8$export$96584299af1a4c70; });
$parcel$export(module.exports, "getBbEnv", function () { return $fcf86092ef5ec2f8$export$517241a94f815266; });
$parcel$export(module.exports, "getBbCommitHash", function () { return $fcf86092ef5ec2f8$export$1b755bfb3fa2ddcc; });
var $fcf86092ef5ec2f8$export$96584299af1a4c70;
(function(BbEnv) {
    BbEnv["Development"] = "development";
    BbEnv["Production"] = "production";
    BbEnv["Staging"] = "staging";
    BbEnv["Integration"] = "integration";
    BbEnv["Test"] = "dev-west2";
})($fcf86092ef5ec2f8$export$96584299af1a4c70 || ($fcf86092ef5ec2f8$export$96584299af1a4c70 = {})); // Infra Dev "Red" test, not testing test
const $fcf86092ef5ec2f8$export$517241a94f815266 = ()=>{
    const envMeta = document.querySelector('meta[name="bb-env"]');
    const env = envMeta ? envMeta.getAttribute("content") : null;
    return env;
};
const $fcf86092ef5ec2f8$export$1b755bfb3fa2ddcc = ()=>{
    const meta = document.querySelector('meta[name="bitbucket-commit-hash"]');
    return meta ? meta.getAttribute("content") || "" : "";
};

});

parcelRegister("2FglY", function(module, exports) {

$parcel$export(module.exports, "envMap", function () { return $051d994910d92eaa$export$d76bdf9f4281ae1b; });
$parcel$export(module.exports, "FeatureProvider", function () { return $051d994910d92eaa$export$98541361bc463108; });
$parcel$export(module.exports, "StatsigFeatures", function () { return $051d994910d92eaa$export$27acbe9f5f1f2f04; });
$parcel$export(module.exports, "useStatsigGate", function () { return $051d994910d92eaa$export$f68db60e1e106190; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("dGzLf");
var $aAre5 = parcelRequire("aAre5");
parcelRequire("lM4y8");
var $fM82h = parcelRequire("fM82h");

var $8HwYi = parcelRequire("8HwYi");
var $2yOpU = parcelRequire("2yOpU");
parcelRequire("hw8PW");
var $bwg5y = parcelRequire("bwg5y");
var $hw8PW = parcelRequire("hw8PW");
parcelRequire("3hzea");
var $a5HLv = parcelRequire("a5HLv");

var $iflz5 = parcelRequire("iflz5");

var $1D3HA = parcelRequire("1D3HA");

var $b1Qv2 = parcelRequire("b1Qv2");

var $7sB53 = parcelRequire("7sB53");

var $3yhbh = parcelRequire("3yhbh");

var $aanBq = parcelRequire("aanBq");

var $5utbt = parcelRequire("5utbt");

var $bBcuy = parcelRequire("bBcuy");

var $6Tn56 = parcelRequire("6Tn56");
const $051d994910d92eaa$export$d76bdf9f4281ae1b = {
    [(0, $6Tn56.BbEnv).Development]: (0, $bwg5y.EnvironmentType).DEV,
    [(0, $6Tn56.BbEnv).Test]: (0, $bwg5y.EnvironmentType).PROD,
    // Test is prod-like for application changes
    [(0, $6Tn56.BbEnv).Staging]: (0, $bwg5y.EnvironmentType).STAGING,
    [(0, $6Tn56.BbEnv).Integration]: (0, $bwg5y.EnvironmentType).STAGING,
    [(0, $6Tn56.BbEnv).Production]: (0, $bwg5y.EnvironmentType).PROD
};
const $051d994910d92eaa$var$uncurl = (uuid)=>(0, $a5HLv.uncurlyUuid)(uuid || "") || uuid || undefined;
const $051d994910d92eaa$export$98541361bc463108 = ({ children: children })=>{
    var _workspaceResource$da;
    // For now we need to avoid unmounting the child components due to a
    // bug with the AK router. This can be replaced with `useSelector`
    // once the router has been updated
    const { user: user } = (0, $1D3HA.useAppData)();
    const [featureFlagUser, setFeatureFlagUser] = (0, $9nHZC.useState)((0, $hw8PW.getUserIdentifier)(user));
    const workspaceResource = (0, $fM82h.useResource)((0, $7sB53.workspaceNavigationResource));
    const workspaceUUID = (0, $aAre5.useSelector)((0, $5utbt.getCurrentWorkspaceUUID));
    const projectUUID = (0, $aAre5.useSelector)((0, $3yhbh.getCurrentProjectUuid));
    const repositoryUUID = (0, $aAre5.useSelector)((0, $aanBq.getCurrentRepositoryUuid));
    const repositoryProjectUUID = (0, $aAre5.useSelector)((0, $aanBq.getCurrentRepositoryProjectUuid));
    const repositoryWorkspaceUUID = (0, $aAre5.useSelector)((0, $aanBq.getCurrentRepositoryWorkspaceUUID));
    const workspaceUuid = $051d994910d92eaa$var$uncurl(((_workspaceResource$da = workspaceResource.data) === null || _workspaceResource$da === void 0 ? void 0 : _workspaceResource$da.workspace.uuid) || repositoryWorkspaceUUID || workspaceUUID);
    const projectUuid = $051d994910d92eaa$var$uncurl(repositoryProjectUUID || projectUUID);
    const repositoryUuid = $051d994910d92eaa$var$uncurl(repositoryUUID);
    const env = $051d994910d92eaa$export$d76bdf9f4281ae1b[(0, $6Tn56.getBbEnv)() || (0, $6Tn56.BbEnv).Development];
    const apiKey = (0, $b1Qv2.FeatureKeys)[env];
    (0, $9nHZC.useEffect)(()=>{
        setFeatureFlagUser((0, $hw8PW.getUserIdentifier)(user ? {
            ...user,
            workspaceUuid: workspaceUuid,
            projectUuid: projectUuid,
            repositoryUuid: repositoryUuid
        } : user));
    }, [
        user,
        workspaceUuid,
        projectUuid,
        repositoryUuid
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $hw8PW.FeatureProvider), {
        analyticsWebClient: (0, $bBcuy.analyticsClient)(),
        apiKey: apiKey,
        featureFlagUser: featureFlagUser,
        options: {
            productKey: "bitbucket",
            environment: env
        }
    }, children);
};
const $051d994910d92eaa$export$769ea6f0f2ade486 = {
    [(0, $6Tn56.BbEnv).Development]: (0, $2yOpU.FeatureGateEnvironment).Development,
    [(0, $6Tn56.BbEnv).Test]: (0, $2yOpU.FeatureGateEnvironment).Production,
    // Test is prod-like for application changes
    [(0, $6Tn56.BbEnv).Staging]: (0, $2yOpU.FeatureGateEnvironment).Staging,
    [(0, $6Tn56.BbEnv).Integration]: (0, $2yOpU.FeatureGateEnvironment).Staging,
    [(0, $6Tn56.BbEnv).Production]: (0, $2yOpU.FeatureGateEnvironment).Production
};
const $051d994910d92eaa$var$onReadySubscribers = new Set();
const $051d994910d92eaa$var$StatsigEvents = {
    onReady: (fn)=>{
        $051d994910d92eaa$var$onReadySubscribers.add(fn);
    },
    clearOnReady: (fn)=>{
        $051d994910d92eaa$var$onReadySubscribers.delete(fn);
    },
    broadcastOnReady: ()=>{
        $051d994910d92eaa$var$onReadySubscribers.forEach((fn)=>fn());
    }
};
const $051d994910d92eaa$var$statsigOptions = function() {
    const env = $051d994910d92eaa$export$769ea6f0f2ade486[(0, $6Tn56.getBbEnv)() || (0, $6Tn56.BbEnv).Development];
    const apiKey = (0, $b1Qv2.StatsigKeys)[env];
    return {
        apiKey: apiKey,
        environment: env,
        targetApp: "bitbucket-cloud_web"
    };
}();
const $051d994910d92eaa$export$27acbe9f5f1f2f04 = ()=>{
    const { user: user } = (0, $1D3HA.useAppData)();
    const workspaceUUID = (0, $aAre5.useSelector)((0, $5utbt.getCurrentWorkspaceUUID));
    const repositoryUUID = (0, $aAre5.useSelector)((0, $aanBq.getCurrentRepositoryUuid));
    const repositoryWorkspaceUUID = (0, $aAre5.useSelector)((0, $aanBq.getCurrentRepositoryWorkspaceUUID));
    const workspaceUuid = $051d994910d92eaa$var$uncurl(repositoryWorkspaceUUID || workspaceUUID);
    const repositoryUuid = $051d994910d92eaa$var$uncurl(repositoryUUID);
    const featureIdsAndAttributes = (0, $9nHZC.useMemo)(()=>{
        var _user$isAtlassian, _user$isBitbucket, _user$aaid;
        const customAttributes = {
            atlassianStaff: (_user$isAtlassian = user === null || user === void 0 ? void 0 : user.isAtlassian) !== null && _user$isAtlassian !== void 0 ? _user$isAtlassian : false,
            bitbucketTeam: (_user$isBitbucket = user === null || user === void 0 ? void 0 : user.isBitbucket) !== null && _user$isBitbucket !== void 0 ? _user$isBitbucket : false
        };
        if (repositoryUuid) customAttributes.repositoryId = repositoryUuid;
        return {
            identifiers: {
                atlassianAccountId: (_user$aaid = user === null || user === void 0 ? void 0 : user.aaid) !== null && _user$aaid !== void 0 ? _user$aaid : undefined,
                bitbucketWorkspaceId: workspaceUuid
            },
            customAttributes: customAttributes
        };
    }, [
        user === null || user === void 0 ? void 0 : user.aaid,
        user === null || user === void 0 ? void 0 : user.isBitbucket,
        user === null || user === void 0 ? void 0 : user.isAtlassian,
        workspaceUuid,
        repositoryUuid
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $iflz5.FeatureGatesInitialization), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        options: $051d994910d92eaa$var$statsigOptions,
        onReady: $051d994910d92eaa$var$StatsigEvents.broadcastOnReady
    }, featureIdsAndAttributes));
};
function $051d994910d92eaa$export$f68db60e1e106190(key) {
    const [flagValue, setFlagValue] = (0, $9nHZC.useState)((0, $8HwYi.default).checkGate(key));
    (0, $9nHZC.useEffect)(()=>{
        const onReady = ()=>{
            setFlagValue((0, $8HwYi.default).checkGate(key));
        };
        $051d994910d92eaa$var$StatsigEvents.onReady(onReady);
        return ()=>{
            $051d994910d92eaa$var$StatsigEvents.clearOnReady(onReady);
        };
    }, [
        key
    ]);
    return flagValue;
}

});
parcelRegister("iflz5", function(module, exports) {
"use strict";
var $d48a5b11d3a3e35b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d48a5b11d3a3e35b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d48a5b11d3a3e35b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d48a5b11d3a3e35b$var$__exportStar((parcelRequire("8QBsv")), module.exports);

$d48a5b11d3a3e35b$var$__exportStar((parcelRequire("cxXVj")), module.exports);

$d48a5b11d3a3e35b$var$__exportStar((parcelRequire("a5KOT")), module.exports);

});
parcelRegister("8QBsv", function(module, exports) {
"use strict";
var $67103c9887b122f0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitialization = void 0;

var $9nHZC = parcelRequire("9nHZC");

const $67103c9887b122f0$var$feature_gate_js_client_1 = $67103c9887b122f0$var$__importDefault((parcelRequire("28uqN")));

var $jOVEk = parcelRequire("jOVEk");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $67103c9887b122f0$var$FeatureGatesInitialization = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializingComponent: initializingComponent, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $9nHZC.useState)(!overrides && (0, $jOVEk.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $9nHZC.useRef)(options);
    (0, $9nHZC.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $9nHZC.useEffect)(()=>{
        if (enabled) {
            if ((0, $jOVEk.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $jOVEk.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $67103c9887b122f0$var$feature_gate_js_client_1.default.initializeCalled() ? $67103c9887b122f0$var$feature_gate_js_client_1.default.updateUser(optionsRef.current, identifiers, customAttributes) : $67103c9887b122f0$var$feature_gate_js_client_1.default.initialize(optionsRef.current, identifiers, customAttributes);
                initPromise.then(()=>(0, $jOVEk.applyOverrides)(overrides)).catch((err)=>(0, $jOVEk.toError)(err)).then((err)=>{
                    setInitialized(true);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $jOVEk.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $jOVEk.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
module.exports.FeatureGatesInitialization = $67103c9887b122f0$var$FeatureGatesInitialization;
module.exports.default = module.exports.FeatureGatesInitialization;

});
parcelRegister("28uqN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("8HwYi")).default; });
$parcel$export(module.exports, "FeatureGateEnvironment", function () { return (parcelRequire("2yOpU")).FeatureGateEnvironment; });
$parcel$export(module.exports, "PerimeterType", function () { return (parcelRequire("2yOpU")).PerimeterType; });
$parcel$export(module.exports, "DynamicConfig", function () { return (parcelRequire("iiPPB")).DynamicConfig; });
$parcel$export(module.exports, "EvaluationReason", function () { return (parcelRequire("iiPPB")).EvaluationReason; });

var $8HwYi = parcelRequire("8HwYi");
var $iiPPB = parcelRequire("iiPPB");
var $2yOpU = parcelRequire("2yOpU");

});

parcelRegister("jOVEk", function(module, exports) {
"use strict";
var $e6df67d6fea64efc$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearOverrides = module.exports.applyOverrides = module.exports.toError = module.exports.pickChildToRender = module.exports.isClientAlreadyInCorrectState = void 0;

const $e6df67d6fea64efc$var$react_1 = $e6df67d6fea64efc$var$__importDefault((parcelRequire("9nHZC")));

const $e6df67d6fea64efc$var$feature_gate_js_client_1 = $e6df67d6fea64efc$var$__importDefault((parcelRequire("28uqN")));
let $e6df67d6fea64efc$var$hasWarnedAboutMissingOverrideSupport = false;
function $e6df67d6fea64efc$var$isClientAlreadyInCorrectState(identifiers, customAttributes) {
    var _a, _b;
    // If either of these methods don't exist (ie. if the product is using <v4.2.0), then this method will always return false
    return ((_a = $e6df67d6fea64efc$var$feature_gate_js_client_1.default.initializeCompleted) === null || _a === void 0 ? void 0 : _a.call($e6df67d6fea64efc$var$feature_gate_js_client_1.default)) && ((_b = $e6df67d6fea64efc$var$feature_gate_js_client_1.default.isCurrentUser) === null || _b === void 0 ? void 0 : _b.call($e6df67d6fea64efc$var$feature_gate_js_client_1.default, identifiers, customAttributes));
}
module.exports.isClientAlreadyInCorrectState = $e6df67d6fea64efc$var$isClientAlreadyInCorrectState;
function $e6df67d6fea64efc$var$pickChildToRender(enabled, isInitialized, children, initializingComponent) {
    if (!enabled || isInitialized) return $e6df67d6fea64efc$var$react_1.default.createElement($e6df67d6fea64efc$var$react_1.default.Fragment, null, children);
    if (initializingComponent != null) return $e6df67d6fea64efc$var$react_1.default.createElement($e6df67d6fea64efc$var$react_1.default.Fragment, null, initializingComponent);
    return null;
}
module.exports.pickChildToRender = $e6df67d6fea64efc$var$pickChildToRender;
function $e6df67d6fea64efc$var$toError(err) {
    if (err instanceof Error) return err;
    return new Error(err === null || err === void 0 ? void 0 : err.toString());
}
module.exports.toError = $e6df67d6fea64efc$var$toError;
function $e6df67d6fea64efc$var$applyOverrides(overrides) {
    // Allow newer versions of the React SDK to be used with older v3.x JS client versions,
    // provided the caller does not try to leverage the overrides which were introduced in v4.
    if (overrides && (!$e6df67d6fea64efc$var$feature_gate_js_client_1.default.overrideGate || !$e6df67d6fea64efc$var$feature_gate_js_client_1.default.overrideConfig)) {
        if (!$e6df67d6fea64efc$var$hasWarnedAboutMissingOverrideSupport) {
            console.warn("Overrides are only supported in @atlaskit/feature-gate-js-client v4.0.0+");
            $e6df67d6fea64efc$var$hasWarnedAboutMissingOverrideSupport = true;
        }
        return;
    }
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach(([gateName, value])=>{
        var _a;
        (_a = $e6df67d6fea64efc$var$feature_gate_js_client_1.default.overrideGate) === null || _a === void 0 || _a.call($e6df67d6fea64efc$var$feature_gate_js_client_1.default, gateName, value);
    });
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach(([configName, values])=>{
        var _a;
        (_a = $e6df67d6fea64efc$var$feature_gate_js_client_1.default.overrideConfig) === null || _a === void 0 || _a.call($e6df67d6fea64efc$var$feature_gate_js_client_1.default, configName, values);
    });
}
module.exports.applyOverrides = $e6df67d6fea64efc$var$applyOverrides;
function $e6df67d6fea64efc$var$clearOverrides(overrides) {
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach((gateName)=>{
        var _a;
        (_a = $e6df67d6fea64efc$var$feature_gate_js_client_1.default.clearGateOverride) === null || _a === void 0 || _a.call($e6df67d6fea64efc$var$feature_gate_js_client_1.default, gateName);
    });
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach((configName)=>{
        var _a;
        (_a = $e6df67d6fea64efc$var$feature_gate_js_client_1.default.clearConfigOverride) === null || _a === void 0 || _a.call($e6df67d6fea64efc$var$feature_gate_js_client_1.default, configName);
    });
}
module.exports.clearOverrides = $e6df67d6fea64efc$var$clearOverrides;

});


parcelRegister("cxXVj", function(module, exports) {
"use strict";
var $92270ca1302b62e5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithDefaults = void 0;

var $9nHZC = parcelRequire("9nHZC");

const $92270ca1302b62e5$var$feature_gate_js_client_1 = $92270ca1302b62e5$var$__importDefault((parcelRequire("28uqN")));

var $jOVEk = parcelRequire("jOVEk");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $92270ca1302b62e5$var$FeatureGatesInitializationWithDefaults = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $9nHZC.useState)(!overrides && (0, $jOVEk.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $9nHZC.useRef)(options);
    (0, $9nHZC.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $9nHZC.useEffect)(()=>{
        if (enabled) {
            if ((0, $jOVEk.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $jOVEk.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $92270ca1302b62e5$var$feature_gate_js_client_1.default.initializeCalled() ? $92270ca1302b62e5$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes) : $92270ca1302b62e5$var$feature_gate_js_client_1.default.initializeFromValues(Object.assign({
                    sdkKey: "client-default-key"
                }, optionsRef.current || {}), identifiers, customAttributes);
                initPromise.then(()=>(0, $jOVEk.applyOverrides)(overrides)).catch((err)=>(0, $jOVEk.toError)(err)).then((err)=>{
                    setInitialized(true);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $jOVEk.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $jOVEk.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithDefaults = $92270ca1302b62e5$var$FeatureGatesInitializationWithDefaults;
module.exports.default = module.exports.FeatureGatesInitializationWithDefaults;

});

parcelRegister("a5KOT", function(module, exports) {
"use strict";
var $758eb06feadfd31c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithValues = void 0;

var $9nHZC = parcelRequire("9nHZC");

const $758eb06feadfd31c$var$feature_gate_js_client_1 = $758eb06feadfd31c$var$__importDefault((parcelRequire("28uqN")));

var $jOVEk = parcelRequire("jOVEk");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $758eb06feadfd31c$var$FeatureGatesInitializationWithValues = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializeValues: initializeValues, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $9nHZC.useState)(!overrides && (0, $jOVEk.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $9nHZC.useRef)(options);
    (0, $9nHZC.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $9nHZC.useEffect)(()=>{
        if (enabled) {
            if ((0, $jOVEk.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $jOVEk.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $758eb06feadfd31c$var$feature_gate_js_client_1.default.initializeCalled() ? $758eb06feadfd31c$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes, initializeValues) : $758eb06feadfd31c$var$feature_gate_js_client_1.default.initializeFromValues(optionsRef.current, identifiers, customAttributes, initializeValues);
                initPromise.then(()=>(0, $jOVEk.applyOverrides)(overrides)).catch((err)=>(0, $jOVEk.toError)(err)).then((err)=>{
                    setInitialized(true);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $jOVEk.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        initializeValues,
        overrides
    ]);
    return (0, $jOVEk.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithValues = $758eb06feadfd31c$var$FeatureGatesInitializationWithValues;
module.exports.default = module.exports.FeatureGatesInitializationWithValues;

});


parcelRegister("b1Qv2", function(module, exports) {

$parcel$export(module.exports, "FeatureKeys", function () { return $0af6332cf92689b9$export$c6924e03165427f7; });
$parcel$export(module.exports, "StatsigKeys", function () { return $0af6332cf92689b9$export$613fc64ae6f5b447; });
parcelRequire("8HwYi");
var $2yOpU = parcelRequire("2yOpU");
parcelRequire("hw8PW");
var $bwg5y = parcelRequire("bwg5y");
const $0af6332cf92689b9$export$c6924e03165427f7 = {
    [(0, $bwg5y.EnvironmentType).LOCAL]: "425f239d-3a44-44fa-a8bd-6bd9cc982166",
    [(0, $bwg5y.EnvironmentType).DEV]: "d2619f54-fa78-489d-bf35-243e1735fb74",
    [(0, $bwg5y.EnvironmentType).STAGING]: "50a4ddb1-bd22-4bf6-8c5f-ec5090e1dd4b",
    [(0, $bwg5y.EnvironmentType).PROD]: "e68da679-ff2b-4bae-913d-22d58892baa8"
};
const $0af6332cf92689b9$export$613fc64ae6f5b447 = {
    [(0, $2yOpU.FeatureGateEnvironment).Development]: "d2619f54-fa78-489d-bf35-243e1735fb74",
    [(0, $2yOpU.FeatureGateEnvironment).Staging]: "50a4ddb1-bd22-4bf6-8c5f-ec5090e1dd4b",
    [(0, $2yOpU.FeatureGateEnvironment).Production]: "e68da679-ff2b-4bae-913d-22d58892baa8"
};

});


parcelRegister("iihFv", function(module, exports) {

$parcel$export(module.exports, "ForgeAppsContext", function () { return $03bb1188f1fdba9b$export$47a124c25278e8c0; });
$parcel$export(module.exports, "ForgeAppsProvider", function () { return $03bb1188f1fdba9b$export$a1d719d9115c99f7; });

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("lM4y8");
var $fM82h = parcelRequire("fM82h");

var $7sB53 = parcelRequire("7sB53");

var $ksfVj = parcelRequire("ksfVj");

var $k2cPS = parcelRequire("k2cPS");
const $03bb1188f1fdba9b$export$47a124c25278e8c0 = /*#__PURE__*/ (0, $9nHZC.createContext)({
    workspaceForgeMenuItems: []
});
const $03bb1188f1fdba9b$export$a1d719d9115c99f7 = ({ children: children })=>{
    const [wsMenuItems, setWsMenuItems] = (0, $9nHZC.useState)([]);
    const { data: data, loading: loading } = (0, $fM82h.useResource)((0, $7sB53.workspaceNavigationResource));
    const workspaceSlug = (data === null || data === void 0 ? void 0 : data.workspace.slug) || null;
    const currentWorkspace = (0, $9nHZC.useRef)(workspaceSlug);
    (0, $9nHZC.useEffect)(()=>{
        let didCancel = false;
        const fetchWorkspaceMenuItems = async ()=>{
            if (!loading && workspaceSlug != null) {
                if (currentWorkspace.current !== workspaceSlug) {
                    setWsMenuItems([]);
                    currentWorkspace.current = workspaceSlug;
                }
                const response = await fetch((0, $k2cPS.default)(`${(0, $ksfVj.default).api.internal.forgeMenuItems(workspaceSlug)}`, {
                    headers: (0, $k2cPS.jsonHeaders)
                }));
                if (response.ok) {
                    const result = await response.json();
                    const adminMenuItems = result.admin_menu_items || [];
                    if (!didCancel) setWsMenuItems(adminMenuItems);
                }
            }
        };
        fetchWorkspaceMenuItems();
        return ()=>{
            didCancel = true;
        };
    }, [
        loading,
        workspaceSlug
    ]);
    const providerValue = (0, $9nHZC.useMemo)(()=>({
            workspaceForgeMenuItems: wsMenuItems
        }), [
        wsMenuItems
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($03bb1188f1fdba9b$export$47a124c25278e8c0.Provider, {
        value: providerValue
    }, children);
};

});

parcelRegister("kEV2T", function(module, exports) {

$parcel$export(module.exports, "usePostOfficeContext", function () { return $f0a3cb297b944ac5$export$5bd9099e0ae94a43; });
$parcel$export(module.exports, "usePostOfficeEnvironment", function () { return $f0a3cb297b944ac5$export$877b97169cc75e8b; });
$parcel$export(module.exports, "useStableObject", function () { return $f0a3cb297b944ac5$export$ed02d4adf2068b08; });
$parcel$export(module.exports, "usePostOfficeRoute", function () { return $f0a3cb297b944ac5$export$79301b66f7808cd8; });
$parcel$export(module.exports, "PostOfficeProvider", function () { return $f0a3cb297b944ac5$export$fb465b6e855c1e85; });
$parcel$export(module.exports, "API_PATHNAME_STG_PROD", function () { return $f0a3cb297b944ac5$export$d4fe3482c88e73a8; });

var $9nHZC = parcelRequire("9nHZC");

var $7TKVV = parcelRequire("7TKVV");

var $ftHXp = parcelRequire("ftHXp");

var $1LFiK = parcelRequire("1LFiK");

var $drcDv = parcelRequire("drcDv");

var $dGehf = parcelRequire("dGehf");
function $f0a3cb297b944ac5$var$f(e, t, a, r) {
    Object.defineProperty(e, t, {
        get: a,
        set: r,
        enumerable: !0,
        configurable: !0
    });
}
var $f0a3cb297b944ac5$var$l = {};
$f0a3cb297b944ac5$var$f($f0a3cb297b944ac5$var$l, "API_ORIGIN_LOCAL", ()=>$f0a3cb297b944ac5$var$m), $f0a3cb297b944ac5$var$f($f0a3cb297b944ac5$var$l, "API_PATHNAME_LOCAL", ()=>$f0a3cb297b944ac5$var$h), $f0a3cb297b944ac5$var$f($f0a3cb297b944ac5$var$l, "API_PATHNAME_STG_PROD", ()=>$f0a3cb297b944ac5$var$v), $f0a3cb297b944ac5$var$f($f0a3cb297b944ac5$var$l, "REMOTE_MODULE_URI_LOCAL", ()=>$f0a3cb297b944ac5$var$P), $f0a3cb297b944ac5$var$f($f0a3cb297b944ac5$var$l, "REMOTE_MODULE_URI_STG", ()=>$f0a3cb297b944ac5$var$b), $f0a3cb297b944ac5$var$f($f0a3cb297b944ac5$var$l, "REMOTE_MODULE_URI_PROD", ()=>$f0a3cb297b944ac5$var$O);
let $f0a3cb297b944ac5$var$m = "http://localhost:8081", $f0a3cb297b944ac5$var$h = "/api/v1/placements/", $f0a3cb297b944ac5$var$v = "/gateway/api/post-office/api/v1/placements/", $f0a3cb297b944ac5$var$P = "http://localhost:9009", $f0a3cb297b944ac5$var$b = "https://post-office-rml-frontend.stg-east.frontend.public.atl-paas.net", $f0a3cb297b944ac5$var$O = "https://post-office-rml-frontend.prod-east.frontend.public.atl-paas.net", $f0a3cb297b944ac5$var$$ = {
    product: void 0,
    subproduct: void 0,
    locale: void 0,
    isSiteAdmin: void 0,
    tenantId: void 0,
    workspaceId: void 0,
    orgId: void 0
}, $f0a3cb297b944ac5$export$a228be81fcb77b42 = (0, $9nHZC.createContext)($f0a3cb297b944ac5$var$$), $f0a3cb297b944ac5$var$M = $f0a3cb297b944ac5$export$a228be81fcb77b42.Provider, $f0a3cb297b944ac5$export$b77983be89bb0a4e = $f0a3cb297b944ac5$var$M, $f0a3cb297b944ac5$export$5bd9099e0ae94a43 = ()=>(0, $9nHZC.useContext)($f0a3cb297b944ac5$export$a228be81fcb77b42), $f0a3cb297b944ac5$var$E = {
    currentEnv: "local",
    envConfigs: {
        test: {
            remoteModule: {
                origin: $f0a3cb297b944ac5$var$P,
                pathname: void 0,
                searchParams: void 0
            },
            api: {
                origin: $f0a3cb297b944ac5$var$m,
                pathname: $f0a3cb297b944ac5$var$h,
                searchParams: void 0
            }
        },
        local: {
            remoteModule: {
                origin: $f0a3cb297b944ac5$var$P,
                pathname: void 0,
                searchParams: void 0
            },
            api: {
                origin: $f0a3cb297b944ac5$var$m,
                pathname: $f0a3cb297b944ac5$var$h,
                searchParams: void 0
            }
        },
        dev: {
            remoteModule: {
                origin: $f0a3cb297b944ac5$var$P,
                pathname: void 0,
                searchParams: void 0
            },
            api: {
                origin: $f0a3cb297b944ac5$var$m,
                pathname: $f0a3cb297b944ac5$var$h,
                searchParams: void 0
            }
        },
        staging: {
            remoteModule: {
                origin: $f0a3cb297b944ac5$var$b,
                pathname: void 0,
                searchParams: void 0
            },
            api: {
                origin: void 0,
                pathname: $f0a3cb297b944ac5$var$v,
                searchParams: void 0
            }
        },
        "stg-fedm-east": {
            remoteModule: {
                origin: $f0a3cb297b944ac5$var$b,
                pathname: void 0,
                searchParams: void 0
            },
            api: {
                origin: void 0,
                pathname: $f0a3cb297b944ac5$var$v,
                searchParams: void 0
            }
        },
        production: {
            remoteModule: {
                origin: $f0a3cb297b944ac5$var$O,
                pathname: void 0,
                searchParams: void 0
            },
            api: {
                origin: void 0,
                pathname: $f0a3cb297b944ac5$var$v,
                searchParams: void 0
            }
        },
        "prod-fedm-east": {
            remoteModule: {
                origin: $f0a3cb297b944ac5$var$O,
                pathname: void 0,
                searchParams: void 0
            },
            api: {
                origin: void 0,
                pathname: $f0a3cb297b944ac5$var$v,
                searchParams: void 0
            }
        }
    }
}, $f0a3cb297b944ac5$var$R = (0, $9nHZC.createContext)($f0a3cb297b944ac5$var$E), $f0a3cb297b944ac5$export$604607f913ef367c = $f0a3cb297b944ac5$var$R.Provider, $f0a3cb297b944ac5$export$877b97169cc75e8b = ()=>(0, $9nHZC.useContext)($f0a3cb297b944ac5$var$R);
function $f0a3cb297b944ac5$export$ed02d4adf2068b08(e) {
    return (0, $9nHZC.useMemo)(()=>e, Object.entries(e).sort().flatMap((e)=>e));
}
let $f0a3cb297b944ac5$var$I = ({ routeSubscriber: e, initialUrl: t })=>{
    let a = $f0a3cb297b944ac5$var$S({
        initialUrl: t
    }), r = (e)=>{
        let t = e.next?.toString();
        t !== a.current && (a = {
            previous: a.current,
            current: t
        });
    };
    return {
        subscribe: (t)=>e((e)=>{
                r(e), t();
            }),
        getSnapshot: ()=>a
    };
}, $f0a3cb297b944ac5$var$C = ({ subscribe: e, getSnapshot: t })=>$f0a3cb297b944ac5$export$ed02d4adf2068b08((0, $1LFiK.useSyncExternalStore)(e, t)), $f0a3cb297b944ac5$var$U = {
    previous: void 0,
    current: void 0
}, $f0a3cb297b944ac5$var$S = ({ initialUrl: e })=>({
        ...$f0a3cb297b944ac5$var$U,
        current: e ? e?.toString() : void 0
    }), $f0a3cb297b944ac5$export$f7f47a74e8b47b1f = (0, $9nHZC.createContext)($f0a3cb297b944ac5$var$U), $f0a3cb297b944ac5$var$y = ({ children: e, ...t })=>{
    let a = (0, $9nHZC.useRef)();
    a.current || (a.current = $f0a3cb297b944ac5$var$I(t));
    let r = $f0a3cb297b944ac5$var$C(a.current);
    return (0, $ftHXp.jsx)($f0a3cb297b944ac5$export$f7f47a74e8b47b1f.Provider, {
        value: r,
        children: e
    });
}, $f0a3cb297b944ac5$export$79301b66f7808cd8 = ()=>(0, $9nHZC.useContext)($f0a3cb297b944ac5$export$f7f47a74e8b47b1f), $f0a3cb297b944ac5$var$N = ()=>{
    let e = new Map;
    return [
        (t)=>(e.set(t, t), ()=>{
                e.delete(t);
            }),
        (t)=>{
            e.forEach((e)=>e(t));
        }
    ];
}, $f0a3cb297b944ac5$export$9d0701a63efe8b5c = (e)=>{
    let t = (0, $9nHZC.useCallback)($f0a3cb297b944ac5$var$J(e), [
        e.scopes
    ]), [a, i] = (0, $9nHZC.useState)($f0a3cb297b944ac5$var$V), s = t({
        route: $f0a3cb297b944ac5$export$79301b66f7808cd8(),
        context: $f0a3cb297b944ac5$export$5bd9099e0ae94a43()
    });
    return $f0a3cb297b944ac5$var$B(a, e), (0, $9nHZC.useEffect)(()=>{
        if ($f0a3cb297b944ac5$var$W({
            next: s,
            state: a
        })) return i({
            current: s,
            previous: a.current
        });
    }, [
        $f0a3cb297b944ac5$var$z(s)
    ]), a;
}, $f0a3cb297b944ac5$var$V = {
    current: [],
    previous: []
}, $f0a3cb297b944ac5$var$j = ({ route: e, context: t })=>(a)=>$f0a3cb297b944ac5$var$k({
            contextMatch: e?.current ? {
                route: $f0a3cb297b944ac5$var$H(e.current),
                context: t
            } : {
                route: void 0,
                context: t
            },
            inputMatch: a.when
        }), $f0a3cb297b944ac5$var$H = (e)=>{
    let { hostname: t, pathname: a } = new URL(e);
    return {
        hostname: t,
        pathname: a
    };
}, $f0a3cb297b944ac5$var$k = ({ contextMatch: e, inputMatch: t })=>(0, (/*@__PURE__*/$parcel$interopDefault($7TKVV)))(e, t, (e, t)=>$f0a3cb297b944ac5$var$F({
            contextValue: e,
            inputValue: t
        })), $f0a3cb297b944ac5$var$q = ({ contextValue: e, inputValue: t })=>!!e && !!t && ("string" == typeof t ? e === t : t?.equals ? e === t.equals : !!t?.matches && "string" == typeof t.matches && "string" == typeof e && new RegExp(t.matches).test(e)), $f0a3cb297b944ac5$var$F = ({ contextValue: e, inputValue: t })=>"object" == typeof t && "object" == typeof e ? $f0a3cb297b944ac5$var$k({
        contextMatch: e,
        inputMatch: t
    }) : $f0a3cb297b944ac5$var$q({
        contextValue: e,
        inputValue: t
    }), $f0a3cb297b944ac5$var$J = ({ scopes: e })=>(t)=>e.filter($f0a3cb297b944ac5$var$j(t)).map((e)=>({
                name: e.name
            })), $f0a3cb297b944ac5$var$W = ({ next: e, state: t })=>{
    let a = Array.from(new Set(t.current.map((e)=>e.name))), r = Array.from(new Set(e.map((e)=>e.name)));
    return r.length !== a.length || !r.every((e)=>a.includes(e));
}, $f0a3cb297b944ac5$var$z = (e)=>JSON.stringify(e.map((e)=>e?.name)), $f0a3cb297b944ac5$var$B = (e, t)=>{
    if (t?.consoleSpy && "undefined" != typeof window && !window?.postOffice?.scopes) {
        let [e, a] = $f0a3cb297b944ac5$var$N();
        window.postOffice = {
            ...window.postOffice,
            scopes: {
                [t?.consoleSpy.name]: {
                    listen: e,
                    update: a,
                    list: t.scopes
                }
            }
        };
    }
    (0, $9nHZC.useEffect)(()=>{
        t?.consoleSpy && window.postOffice?.scopes && window.postOffice?.scopes?.[t?.consoleSpy.name]?.update?.(e);
    }, [
        $f0a3cb297b944ac5$var$z(e.current)
    ]);
}, $f0a3cb297b944ac5$var$K = ()=>{
    let e = new Map;
    return [
        (t)=>(e.set(t, t), ()=>{
                e.delete(t);
            }),
        (t)=>{
            e.forEach((e)=>e(t));
        }
    ];
}, $f0a3cb297b944ac5$var$Q = ()=>{
    let [e, t] = $f0a3cb297b944ac5$var$K(), [a, r] = $f0a3cb297b944ac5$var$K();
    return {
        onMessageDismiss: e,
        dismissMessageFromPlacement: t,
        onMessageRead: a,
        markReadFromPlacement: r
    };
}, $f0a3cb297b944ac5$var$X = (0, $9nHZC.createContext)($f0a3cb297b944ac5$var$Q()), $f0a3cb297b944ac5$var$Y = $f0a3cb297b944ac5$var$X.Provider, $f0a3cb297b944ac5$export$89f8e1f623d8f5ac = ()=>(0, $9nHZC.useContext)($f0a3cb297b944ac5$var$X), $f0a3cb297b944ac5$var$ee = (e, t)=>{
    let { env: a, overrides: r } = t;
    return {
        currentEnv: a,
        envConfigs: {
            ...e.envConfigs,
            [a]: {
                remoteModule: {
                    origin: r?.remoteModule?.origin ?? e.envConfigs[a].remoteModule.origin,
                    pathname: r?.remoteModule?.pathname ?? e.envConfigs[a].remoteModule.pathname,
                    searchParams: r?.remoteModule?.searchParams ?? e.envConfigs[a].remoteModule.searchParams
                },
                api: {
                    origin: r?.api?.origin ?? e.envConfigs[a].api.origin,
                    pathname: r?.api?.pathname ?? e.envConfigs[a].api.pathname,
                    searchParams: r?.api?.searchParams ?? e.envConfigs[a].api.searchParams
                }
            }
        }
    };
}, $f0a3cb297b944ac5$var$et = (0, $9nHZC.createContext)({
    update: ()=>{}
}), $f0a3cb297b944ac5$var$ea = ()=>$f0a3cb297b944ac5$var$N(), $f0a3cb297b944ac5$var$er = ()=>(0, $9nHZC.useContext)($f0a3cb297b944ac5$var$et), $f0a3cb297b944ac5$var$eo = ()=>{
    let e = (0, $9nHZC.useRef)();
    e.current || (e.current = $f0a3cb297b944ac5$var$ea());
    let [t, r] = e.current;
    return [
        (0, $9nHZC.useMemo)(()=>({
                initialUrl: new URL(window.location.href),
                routeSubscriber: t
            }), [
            t
        ]),
        (0, $9nHZC.useMemo)(()=>({
                update: r
            }), [
            r
        ])
    ];
}, $f0a3cb297b944ac5$export$bb606326acdd1a64 = (e)=>{
    let { update: t } = $f0a3cb297b944ac5$var$er();
    (0, $9nHZC.useEffect)(()=>{
        "undefined" != typeof window && t({
            next: new URL(window.location.href)
        });
    }, e);
}, $f0a3cb297b944ac5$var$ei = ({ children: e })=>{
    let [t, a] = $f0a3cb297b944ac5$var$eo();
    return (0, $ftHXp.jsx)($f0a3cb297b944ac5$var$et.Provider, {
        value: a,
        children: (0, $ftHXp.jsx)($f0a3cb297b944ac5$var$y, {
            ...t,
            children: e
        })
    });
}, $f0a3cb297b944ac5$export$fb465b6e855c1e85 = ({ environment: e, context: t, children: r })=>(0, $ftHXp.jsx)($f0a3cb297b944ac5$export$604607f913ef367c, {
        value: $f0a3cb297b944ac5$export$ed02d4adf2068b08($f0a3cb297b944ac5$var$ee($f0a3cb297b944ac5$var$E, e)),
        children: (0, $ftHXp.jsx)($f0a3cb297b944ac5$var$M, {
            value: $f0a3cb297b944ac5$export$ed02d4adf2068b08($f0a3cb297b944ac5$var$ec($f0a3cb297b944ac5$var$$, t.current)),
            children: (0, $ftHXp.jsx)($f0a3cb297b944ac5$var$Y, {
                value: (0, $9nHZC.useMemo)(()=>$f0a3cb297b944ac5$var$Q(), []),
                children: (0, $ftHXp.jsx)($f0a3cb297b944ac5$var$ei, {
                    children: r
                })
            })
        })
    }), $f0a3cb297b944ac5$var$ec = (e, ...t)=>t.reduce((e, t)=>(0, (/*@__PURE__*/$parcel$interopDefault($dGehf)))(e, t), (0, (/*@__PURE__*/$parcel$interopDefault($drcDv)))(e)), { REMOTE_MODULE_URI_LOCAL: $f0a3cb297b944ac5$export$67be2569ef5d7666, REMOTE_MODULE_URI_PROD: $f0a3cb297b944ac5$export$bbd96cd490b0df63, REMOTE_MODULE_URI_STG: $f0a3cb297b944ac5$export$b49738b89db261cd, API_ORIGIN_LOCAL: $f0a3cb297b944ac5$export$1e9fed4c0197724c, API_PATHNAME_LOCAL: $f0a3cb297b944ac5$export$919a9569bce66f17, API_PATHNAME_STG_PROD: $f0a3cb297b944ac5$export$d4fe3482c88e73a8 } = $f0a3cb297b944ac5$var$l;

});
parcelRegister("7TKVV", function(module, exports) {

var $4sMvO = parcelRequire("4sMvO");

var $dYZYl = parcelRequire("dYZYl");
/**
 * This method is like `_.isMatch` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with five
 * arguments: (objValue, srcValue, index|key, object, source).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, srcValue) {
 *   if (isGreeting(objValue) && isGreeting(srcValue)) {
 *     return true;
 *   }
 * }
 *
 * var object = { 'greeting': 'hello' };
 * var source = { 'greeting': 'hi' };
 *
 * _.isMatchWith(object, source, customizer);
 * // => true
 */ function $5c02137450ce5ab5$var$isMatchWith(object, source, customizer) {
    customizer = typeof customizer == "function" ? customizer : undefined;
    return $4sMvO(object, source, $dYZYl(source), customizer);
}
module.exports = $5c02137450ce5ab5$var$isMatchWith;

});
parcelRegister("4sMvO", function(module, exports) {

var $dF7QF = parcelRequire("dF7QF");

var $6Ewzi = parcelRequire("6Ewzi");
/** Used to compose bitmasks for value comparisons. */ var $33ff686e0d99fb58$var$COMPARE_PARTIAL_FLAG = 1, $33ff686e0d99fb58$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $33ff686e0d99fb58$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $dF7QF;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $6Ewzi(srcValue, objValue, $33ff686e0d99fb58$var$COMPARE_PARTIAL_FLAG | $33ff686e0d99fb58$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $33ff686e0d99fb58$var$baseIsMatch;

});

parcelRegister("dYZYl", function(module, exports) {

var $kK3Bb = parcelRequire("kK3Bb");

var $196L7 = parcelRequire("196L7");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $a2e0f35f685df74f$var$getMatchData(object) {
    var result = $196L7(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $kK3Bb(value)
        ];
    }
    return result;
}
module.exports = $a2e0f35f685df74f$var$getMatchData;

});
parcelRegister("kK3Bb", function(module, exports) {

var $3kSRQ = parcelRequire("3kSRQ");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $f19ae52a47941ecf$var$isStrictComparable(value) {
    return value === value && !$3kSRQ(value);
}
module.exports = $f19ae52a47941ecf$var$isStrictComparable;

});



parcelRegister("ftHXp", function(module, exports) {
"use strict";

module.exports = (parcelRequire("5WhmS"));

});
parcelRegister("5WhmS", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $452fd76de7d1a22f$export$ffb0004e005737fa; }, function (v) { return $452fd76de7d1a22f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $452fd76de7d1a22f$export$34b9dba7ce09269b; }, function (v) { return $452fd76de7d1a22f$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $452fd76de7d1a22f$export$25062201e9e25d76; }, function (v) { return $452fd76de7d1a22f$export$25062201e9e25d76 = v; });
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $452fd76de7d1a22f$export$ffb0004e005737fa;
var $452fd76de7d1a22f$export$34b9dba7ce09269b;
var $452fd76de7d1a22f$export$25062201e9e25d76;
"use strict";

var $9nHZC = parcelRequire("9nHZC");
var $452fd76de7d1a22f$var$g = 60103;
$452fd76de7d1a22f$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $452fd76de7d1a22f$var$h = Symbol.for;
    $452fd76de7d1a22f$var$g = $452fd76de7d1a22f$var$h("react.element");
    $452fd76de7d1a22f$export$ffb0004e005737fa = $452fd76de7d1a22f$var$h("react.fragment");
}
var $452fd76de7d1a22f$var$m = $9nHZC.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $452fd76de7d1a22f$var$n = Object.prototype.hasOwnProperty, $452fd76de7d1a22f$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $452fd76de7d1a22f$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$452fd76de7d1a22f$var$n.call(a, b) && !$452fd76de7d1a22f$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $452fd76de7d1a22f$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $452fd76de7d1a22f$var$m.current
    };
}
$452fd76de7d1a22f$export$34b9dba7ce09269b = $452fd76de7d1a22f$var$q;
$452fd76de7d1a22f$export$25062201e9e25d76 = $452fd76de7d1a22f$var$q;

});


parcelRegister("drcDv", function(module, exports) {

var $k44MR = parcelRequire("k44MR");
/** Used to compose bitmasks for cloning. */ var $9c879942c0a1857f$var$CLONE_DEEP_FLAG = 1, $9c879942c0a1857f$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $9c879942c0a1857f$var$cloneDeep(value) {
    return $k44MR(value, $9c879942c0a1857f$var$CLONE_DEEP_FLAG | $9c879942c0a1857f$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $9c879942c0a1857f$var$cloneDeep;

});
parcelRegister("k44MR", function(module, exports) {

var $dF7QF = parcelRequire("dF7QF");

var $cnoot = parcelRequire("cnoot");

var $7LKGc = parcelRequire("7LKGc");

var $e4jYY = parcelRequire("e4jYY");

var $jVIrP = parcelRequire("jVIrP");

var $eu3ax = parcelRequire("eu3ax");

var $8HdJ8 = parcelRequire("8HdJ8");

var $lsEGS = parcelRequire("lsEGS");

var $lkPL0 = parcelRequire("lkPL0");

var $fQ5II = parcelRequire("fQ5II");

var $1Uoz3 = parcelRequire("1Uoz3");

var $fskeO = parcelRequire("fskeO");

var $fyXB1 = parcelRequire("fyXB1");

var $2yWUP = parcelRequire("2yWUP");

var $lHUcx = parcelRequire("lHUcx");

var $lsPUZ = parcelRequire("lsPUZ");

var $bObB2 = parcelRequire("bObB2");

var $5CTEP = parcelRequire("5CTEP");

var $3kSRQ = parcelRequire("3kSRQ");

var $4MA3k = parcelRequire("4MA3k");

var $196L7 = parcelRequire("196L7");

var $1IIVj = parcelRequire("1IIVj");
/** Used to compose bitmasks for cloning. */ var $e9b7e4f970ec45e8$var$CLONE_DEEP_FLAG = 1, $e9b7e4f970ec45e8$var$CLONE_FLAT_FLAG = 2, $e9b7e4f970ec45e8$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $e9b7e4f970ec45e8$var$argsTag = "[object Arguments]", $e9b7e4f970ec45e8$var$arrayTag = "[object Array]", $e9b7e4f970ec45e8$var$boolTag = "[object Boolean]", $e9b7e4f970ec45e8$var$dateTag = "[object Date]", $e9b7e4f970ec45e8$var$errorTag = "[object Error]", $e9b7e4f970ec45e8$var$funcTag = "[object Function]", $e9b7e4f970ec45e8$var$genTag = "[object GeneratorFunction]", $e9b7e4f970ec45e8$var$mapTag = "[object Map]", $e9b7e4f970ec45e8$var$numberTag = "[object Number]", $e9b7e4f970ec45e8$var$objectTag = "[object Object]", $e9b7e4f970ec45e8$var$regexpTag = "[object RegExp]", $e9b7e4f970ec45e8$var$setTag = "[object Set]", $e9b7e4f970ec45e8$var$stringTag = "[object String]", $e9b7e4f970ec45e8$var$symbolTag = "[object Symbol]", $e9b7e4f970ec45e8$var$weakMapTag = "[object WeakMap]";
var $e9b7e4f970ec45e8$var$arrayBufferTag = "[object ArrayBuffer]", $e9b7e4f970ec45e8$var$dataViewTag = "[object DataView]", $e9b7e4f970ec45e8$var$float32Tag = "[object Float32Array]", $e9b7e4f970ec45e8$var$float64Tag = "[object Float64Array]", $e9b7e4f970ec45e8$var$int8Tag = "[object Int8Array]", $e9b7e4f970ec45e8$var$int16Tag = "[object Int16Array]", $e9b7e4f970ec45e8$var$int32Tag = "[object Int32Array]", $e9b7e4f970ec45e8$var$uint8Tag = "[object Uint8Array]", $e9b7e4f970ec45e8$var$uint8ClampedTag = "[object Uint8ClampedArray]", $e9b7e4f970ec45e8$var$uint16Tag = "[object Uint16Array]", $e9b7e4f970ec45e8$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $e9b7e4f970ec45e8$var$cloneableTags = {};
$e9b7e4f970ec45e8$var$cloneableTags[$e9b7e4f970ec45e8$var$argsTag] = $e9b7e4f970ec45e8$var$cloneableTags[$e9b7e4f970ec45e8$var$arrayTag] = $e9b7e4f970ec45e8$var$cloneableTags[$e9b7e4f970ec45e8$var$arrayBufferTag] = $e9b7e4f970ec45e8$var$cloneableTags[$e9b7e4f970ec45e8$var$dataViewTag] = $e9b7e4f970ec45e8$var$cloneableTags[$e9b7e4f970ec45e8$var$boolTag] = $e9b7e4f970ec45e8$var$cloneableTags[$e9b7e4f970ec45e8$var$dateTag] = $e9b7e4f970ec45e8$var$cloneableTags[$e9b7e4f970ec45e8$var$float32Tag] = $e9b7e4f970ec45e8$var$cloneableTags[$e9b7e4f970ec45e8$var$float64Tag] = $e9b7e4f970ec45e8$var$cloneableTags[$e9b7e4f970ec45e8$var$int8Tag] = $e9b7e4f970ec45e8$var$cloneableTags[$e9b7e4f970ec45e8$var$int16Tag] = $e9b7e4f970ec45e8$var$cloneableTags[$e9b7e4f970ec45e8$var$int32Tag] = $e9b7e4f970ec45e8$var$cloneableTags[$e9b7e4f970ec45e8$var$mapTag] = $e9b7e4f970ec45e8$var$cloneableTags[$e9b7e4f970ec45e8$var$numberTag] = $e9b7e4f970ec45e8$var$cloneableTags[$e9b7e4f970ec45e8$var$objectTag] = $e9b7e4f970ec45e8$var$cloneableTags[$e9b7e4f970ec45e8$var$regexpTag] = $e9b7e4f970ec45e8$var$cloneableTags[$e9b7e4f970ec45e8$var$setTag] = $e9b7e4f970ec45e8$var$cloneableTags[$e9b7e4f970ec45e8$var$stringTag] = $e9b7e4f970ec45e8$var$cloneableTags[$e9b7e4f970ec45e8$var$symbolTag] = $e9b7e4f970ec45e8$var$cloneableTags[$e9b7e4f970ec45e8$var$uint8Tag] = $e9b7e4f970ec45e8$var$cloneableTags[$e9b7e4f970ec45e8$var$uint8ClampedTag] = $e9b7e4f970ec45e8$var$cloneableTags[$e9b7e4f970ec45e8$var$uint16Tag] = $e9b7e4f970ec45e8$var$cloneableTags[$e9b7e4f970ec45e8$var$uint32Tag] = true;
$e9b7e4f970ec45e8$var$cloneableTags[$e9b7e4f970ec45e8$var$errorTag] = $e9b7e4f970ec45e8$var$cloneableTags[$e9b7e4f970ec45e8$var$funcTag] = $e9b7e4f970ec45e8$var$cloneableTags[$e9b7e4f970ec45e8$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $e9b7e4f970ec45e8$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $e9b7e4f970ec45e8$var$CLONE_DEEP_FLAG, isFlat = bitmask & $e9b7e4f970ec45e8$var$CLONE_FLAT_FLAG, isFull = bitmask & $e9b7e4f970ec45e8$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$3kSRQ(value)) return value;
    var isArr = $lsPUZ(value);
    if (isArr) {
        result = $fyXB1(value);
        if (!isDeep) return $8HdJ8(value, result);
    } else {
        var tag = $fskeO(value), isFunc = tag == $e9b7e4f970ec45e8$var$funcTag || tag == $e9b7e4f970ec45e8$var$genTag;
        if ($bObB2(value)) return $eu3ax(value, isDeep);
        if (tag == $e9b7e4f970ec45e8$var$objectTag || tag == $e9b7e4f970ec45e8$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $lHUcx(value);
            if (!isDeep) return isFlat ? $lkPL0(value, $jVIrP(result, value)) : $lsEGS(value, $e4jYY(result, value));
        } else {
            if (!$e9b7e4f970ec45e8$var$cloneableTags[tag]) return object ? value : {};
            result = $2yWUP(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $dF7QF);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($4MA3k(value)) value.forEach(function(subValue) {
        result.add($e9b7e4f970ec45e8$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($5CTEP(value)) value.forEach(function(subValue, key) {
        result.set(key, $e9b7e4f970ec45e8$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $1Uoz3 : $fQ5II : isFlat ? $1IIVj : $196L7;
    var props = isArr ? undefined : keysFunc(value);
    $cnoot(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $7LKGc(result, key, $e9b7e4f970ec45e8$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $e9b7e4f970ec45e8$var$baseClone;

});
parcelRegister("cnoot", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $902a8e1acc4532a0$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $902a8e1acc4532a0$var$arrayEach;

});

parcelRegister("e4jYY", function(module, exports) {

var $bFHqq = parcelRequire("bFHqq");

var $196L7 = parcelRequire("196L7");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $a3e0f07c0c65e5b4$var$baseAssign(object, source) {
    return object && $bFHqq(source, $196L7(source), object);
}
module.exports = $a3e0f07c0c65e5b4$var$baseAssign;

});

parcelRegister("jVIrP", function(module, exports) {

var $bFHqq = parcelRequire("bFHqq");

var $1IIVj = parcelRequire("1IIVj");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $e825d199b775ce74$var$baseAssignIn(object, source) {
    return object && $bFHqq(source, $1IIVj(source), object);
}
module.exports = $e825d199b775ce74$var$baseAssignIn;

});

parcelRegister("lsEGS", function(module, exports) {

var $bFHqq = parcelRequire("bFHqq");

var $fcXxf = parcelRequire("fcXxf");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $f9fbc6d0cf8a2681$var$copySymbols(source, object) {
    return $bFHqq(source, $fcXxf(source), object);
}
module.exports = $f9fbc6d0cf8a2681$var$copySymbols;

});

parcelRegister("lkPL0", function(module, exports) {

var $bFHqq = parcelRequire("bFHqq");

var $cXfHm = parcelRequire("cXfHm");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $f8839d1d630f7cba$var$copySymbolsIn(source, object) {
    return $bFHqq(source, $cXfHm(source), object);
}
module.exports = $f8839d1d630f7cba$var$copySymbolsIn;

});
parcelRegister("cXfHm", function(module, exports) {

var $c6wCA = parcelRequire("c6wCA");

var $jrAzq = parcelRequire("jrAzq");

var $fcXxf = parcelRequire("fcXxf");

var $bhYMM = parcelRequire("bhYMM");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $96e72c1a61e4524b$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $96e72c1a61e4524b$var$getSymbolsIn = !$96e72c1a61e4524b$var$nativeGetSymbols ? $bhYMM : function(object) {
    var result = [];
    while(object){
        $c6wCA(result, $fcXxf(object));
        object = $jrAzq(object);
    }
    return result;
};
module.exports = $96e72c1a61e4524b$var$getSymbolsIn;

});


parcelRegister("1Uoz3", function(module, exports) {

var $l3tXM = parcelRequire("l3tXM");

var $cXfHm = parcelRequire("cXfHm");

var $1IIVj = parcelRequire("1IIVj");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $163e1367967bf26a$var$getAllKeysIn(object) {
    return $l3tXM(object, $1IIVj, $cXfHm);
}
module.exports = $163e1367967bf26a$var$getAllKeysIn;

});

parcelRegister("fyXB1", function(module, exports) {
/** Used for built-in method references. */ var $b548428f8a9bf39d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b548428f8a9bf39d$var$hasOwnProperty = $b548428f8a9bf39d$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $b548428f8a9bf39d$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $b548428f8a9bf39d$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $b548428f8a9bf39d$var$initCloneArray;

});

parcelRegister("2yWUP", function(module, exports) {

var $kPYJh = parcelRequire("kPYJh");

var $jp63U = parcelRequire("jp63U");

var $8QRf8 = parcelRequire("8QRf8");

var $6bFYR = parcelRequire("6bFYR");

var $1zntn = parcelRequire("1zntn");
/** `Object#toString` result references. */ var $1ddc75276fe3544f$var$boolTag = "[object Boolean]", $1ddc75276fe3544f$var$dateTag = "[object Date]", $1ddc75276fe3544f$var$mapTag = "[object Map]", $1ddc75276fe3544f$var$numberTag = "[object Number]", $1ddc75276fe3544f$var$regexpTag = "[object RegExp]", $1ddc75276fe3544f$var$setTag = "[object Set]", $1ddc75276fe3544f$var$stringTag = "[object String]", $1ddc75276fe3544f$var$symbolTag = "[object Symbol]";
var $1ddc75276fe3544f$var$arrayBufferTag = "[object ArrayBuffer]", $1ddc75276fe3544f$var$dataViewTag = "[object DataView]", $1ddc75276fe3544f$var$float32Tag = "[object Float32Array]", $1ddc75276fe3544f$var$float64Tag = "[object Float64Array]", $1ddc75276fe3544f$var$int8Tag = "[object Int8Array]", $1ddc75276fe3544f$var$int16Tag = "[object Int16Array]", $1ddc75276fe3544f$var$int32Tag = "[object Int32Array]", $1ddc75276fe3544f$var$uint8Tag = "[object Uint8Array]", $1ddc75276fe3544f$var$uint8ClampedTag = "[object Uint8ClampedArray]", $1ddc75276fe3544f$var$uint16Tag = "[object Uint16Array]", $1ddc75276fe3544f$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $1ddc75276fe3544f$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $1ddc75276fe3544f$var$arrayBufferTag:
            return $kPYJh(object);
        case $1ddc75276fe3544f$var$boolTag:
        case $1ddc75276fe3544f$var$dateTag:
            return new Ctor(+object);
        case $1ddc75276fe3544f$var$dataViewTag:
            return $jp63U(object, isDeep);
        case $1ddc75276fe3544f$var$float32Tag:
        case $1ddc75276fe3544f$var$float64Tag:
        case $1ddc75276fe3544f$var$int8Tag:
        case $1ddc75276fe3544f$var$int16Tag:
        case $1ddc75276fe3544f$var$int32Tag:
        case $1ddc75276fe3544f$var$uint8Tag:
        case $1ddc75276fe3544f$var$uint8ClampedTag:
        case $1ddc75276fe3544f$var$uint16Tag:
        case $1ddc75276fe3544f$var$uint32Tag:
            return $1zntn(object, isDeep);
        case $1ddc75276fe3544f$var$mapTag:
            return new Ctor;
        case $1ddc75276fe3544f$var$numberTag:
        case $1ddc75276fe3544f$var$stringTag:
            return new Ctor(object);
        case $1ddc75276fe3544f$var$regexpTag:
            return $8QRf8(object);
        case $1ddc75276fe3544f$var$setTag:
            return new Ctor;
        case $1ddc75276fe3544f$var$symbolTag:
            return $6bFYR(object);
    }
}
module.exports = $1ddc75276fe3544f$var$initCloneByTag;

});
parcelRegister("jp63U", function(module, exports) {

var $kPYJh = parcelRequire("kPYJh");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $e2050df0933f0cb8$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $kPYJh(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $e2050df0933f0cb8$var$cloneDataView;

});

parcelRegister("8QRf8", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $671c7b08eea42aeb$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $671c7b08eea42aeb$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $671c7b08eea42aeb$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $671c7b08eea42aeb$var$cloneRegExp;

});

parcelRegister("6bFYR", function(module, exports) {

var $lgMoJ = parcelRequire("lgMoJ");
/** Used to convert symbols to primitives and strings. */ var $4814559d99fb1521$var$symbolProto = $lgMoJ ? $lgMoJ.prototype : undefined, $4814559d99fb1521$var$symbolValueOf = $4814559d99fb1521$var$symbolProto ? $4814559d99fb1521$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $4814559d99fb1521$var$cloneSymbol(symbol) {
    return $4814559d99fb1521$var$symbolValueOf ? Object($4814559d99fb1521$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $4814559d99fb1521$var$cloneSymbol;

});


parcelRegister("5CTEP", function(module, exports) {

var $d29To = parcelRequire("d29To");

var $lV9Iv = parcelRequire("lV9Iv");

var $ciO9b = parcelRequire("ciO9b");
/* Node.js helper references. */ var $418bacc80704caf9$var$nodeIsMap = $ciO9b && $ciO9b.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $418bacc80704caf9$var$isMap = $418bacc80704caf9$var$nodeIsMap ? $lV9Iv($418bacc80704caf9$var$nodeIsMap) : $d29To;
module.exports = $418bacc80704caf9$var$isMap;

});
parcelRegister("d29To", function(module, exports) {

var $fskeO = parcelRequire("fskeO");

var $fSpTQ = parcelRequire("fSpTQ");
/** `Object#toString` result references. */ var $97d322adddee5dcf$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $97d322adddee5dcf$var$baseIsMap(value) {
    return $fSpTQ(value) && $fskeO(value) == $97d322adddee5dcf$var$mapTag;
}
module.exports = $97d322adddee5dcf$var$baseIsMap;

});


parcelRegister("4MA3k", function(module, exports) {

var $cqlJ3 = parcelRequire("cqlJ3");

var $lV9Iv = parcelRequire("lV9Iv");

var $ciO9b = parcelRequire("ciO9b");
/* Node.js helper references. */ var $37b79c74a620534a$var$nodeIsSet = $ciO9b && $ciO9b.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $37b79c74a620534a$var$isSet = $37b79c74a620534a$var$nodeIsSet ? $lV9Iv($37b79c74a620534a$var$nodeIsSet) : $cqlJ3;
module.exports = $37b79c74a620534a$var$isSet;

});
parcelRegister("cqlJ3", function(module, exports) {

var $fskeO = parcelRequire("fskeO");

var $fSpTQ = parcelRequire("fSpTQ");
/** `Object#toString` result references. */ var $90b8c3fcb33d254e$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $90b8c3fcb33d254e$var$baseIsSet(value) {
    return $fSpTQ(value) && $fskeO(value) == $90b8c3fcb33d254e$var$setTag;
}
module.exports = $90b8c3fcb33d254e$var$baseIsSet;

});





parcelRegister("4KCOO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcc118e7a9e9c950$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $EKmRU = parcelRequire("EKmRU");

var $2X56B = parcelRequire("2X56B");

var $a7iuM = parcelRequire("a7iuM");

var $ci5gC = parcelRequire("ci5gC");

var $6SlIf = parcelRequire("6SlIf");

var $6aoKW = parcelRequire("6aoKW");

var $5gF7V = parcelRequire("5gF7V");

var $fyDNm = parcelRequire("fyDNm");

var $8x7qc = parcelRequire("8x7qc");

var $3KeTq = parcelRequire("3KeTq");

var $9xBn1 = parcelRequire("9xBn1");

var $eEasA = parcelRequire("eEasA");
class $dcc118e7a9e9c950$export$9a6d250c55c358e extends (0, $9nHZC.PureComponent) {
    constructor(...args){
        super(...args);
        this.handleCreate = ()=>{
            this.props.onCreate({
                createFrom: this.props.createFrom
            });
        };
        this.isOpen = ()=>{
            const { createFrom: createFrom, isRepoDialogOpen: isRepoDialogOpen, isGlobalDialogOpen: isGlobalDialogOpen } = this.props;
            if (createFrom === (0, $5gF7V.CREATE_FROM).REPO_DIALOG) return isRepoDialogOpen;
            else if (createFrom === (0, $5gF7V.CREATE_FROM).GLOBAL_DIALOG) return isGlobalDialogOpen;
            return false;
        };
        this.handleCloseDialog = ()=>{
            const { createFrom: createFrom, closeCreateBranchGlobalDialog: closeCreateBranchGlobalDialog, closeCreateBranchRepoDialog: closeCreateBranchRepoDialog } = this.props;
            if (createFrom === (0, $5gF7V.CREATE_FROM).GLOBAL_DIALOG) closeCreateBranchGlobalDialog();
            else if (createFrom === (0, $5gF7V.CREATE_FROM).REPO_DIALOG) closeCreateBranchRepoDialog();
        };
        this.handleOpenDialog = ()=>{
            const { createFrom: createFrom, openCreateBranchGlobalDialog: openCreateBranchGlobalDialog, openCreateBranchRepoDialog: openCreateBranchRepoDialog } = this.props;
            if (createFrom === (0, $5gF7V.CREATE_FROM).GLOBAL_DIALOG) openCreateBranchGlobalDialog();
            else if (createFrom === (0, $5gF7V.CREATE_FROM).REPO_DIALOG) openCreateBranchRepoDialog();
        };
        this.handleOpenDialogComplete = ()=>{
            if (this.props.isGlobalDialogOpen) (0, $6aoKW.publishScreenEvent)("globalCreateBranchDialog");
            else if (this.props.isRepoDialogOpen) (0, $6aoKW.publishScreenEvent)("createBranchDialog", {
                source: this.props.source
            });
        };
        this.renderModal = ()=>{
            const { intl: intl, isCreating: isCreating, isBannerOpen: isBannerOpen, refSelector: refSelector, createParams: createParams, newBranchName: newBranchName, onChangeFromBranch: onChangeFromBranch, onChangeNewBranchName: onChangeNewBranchName, onFetchCommitStatuses: onFetchCommitStatuses, branchTypeSelector: branchTypeSelector, onChangeBranchType: onChangeBranchType, error: error, workflowBranches: workflowBranches, createFrom: createFrom, onChangeRepository: onChangeRepository, repositorySelector: repositorySelector } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ci5gC.default), {
                footer: this.renderFooter,
                onClose: this.handleCloseDialog,
                onOpenComplete: this.handleOpenDialogComplete,
                heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, $9xBn1.default).title),
                shouldCloseOnEscapePress: !isCreating,
                shouldCloseOnOverlayClick: !isCreating
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3KeTq.CreateBranchForm), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fyDNm.CreateBranch), {
                intl: intl,
                isCreating: isCreating,
                refSelector: refSelector,
                createParams: createParams,
                newBranchName: newBranchName,
                workflowBranches: workflowBranches,
                onFetchCommitStatuses: onFetchCommitStatuses,
                branchTypeSelector: branchTypeSelector,
                onChangeBranchType: onChangeBranchType,
                onChangeFromBranch: onChangeFromBranch,
                onChangeNewBranchName: onChangeNewBranchName,
                error: error,
                isBannerOpen: isBannerOpen,
                createFrom: createFrom,
                onChangeRepository: onChangeRepository,
                repositorySelector: repositorySelector
            })));
        };
        this.renderFooter = ()=>{
            const { isCreating: isCreating, isDisabled: isDisabled } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2X56B.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eEasA.FooterContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $8x7qc.CreateBranchActions), {
                isLoading: isCreating,
                onCreate: this.handleCreate,
                onCancel: this.handleCloseDialog,
                isSaveDisabled: isDisabled,
                isCancelDisabled: isCreating
            })));
        };
        this.renderCreateBranchButton = ()=>{
            const { userLevel: userLevel, requiredLevel: requiredLevel } = this.props;
            const userHasAccess = (0, $6SlIf.checkUserAccess)({
                userLevel: userLevel,
                requiredLevel: requiredLevel
            });
            return userHasAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $EKmRU.default), {
                onClick: this.handleOpenDialog,
                id: "open-create-branch-modal"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, $9xBn1.default).createBranchButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $a7iuM.default), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, $9xBn1.default).createBranchButtonDisabled)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $EKmRU.default), {
                onClick: this.handleOpenDialog,
                isDisabled: true,
                id: "open-create-branch-modal"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, $9xBn1.default).createBranchButton)));
        };
    }
    componentDidUpdate(prevProps) {
        if (this.props.isGlobalDialogOpen && prevProps.isGlobalDialogOpen !== this.props.isGlobalDialogOpen) this.props.loadRepositories();
        if (this.props.isRepoDialogOpen && prevProps.isRepoDialogOpen !== this.props.isRepoDialogOpen) this.props.setCurrentRepository();
    }
    render() {
        const { shouldRenderCreateBranchButton: shouldRenderCreateBranchButton } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, shouldRenderCreateBranchButton && this.renderCreateBranchButton(), this.isOpen() && this.renderModal());
    }
}
var $dcc118e7a9e9c950$export$2e2bcd8739ae039 = (0, $agjvf.injectIntl)($dcc118e7a9e9c950$export$9a6d250c55c358e);

});
parcelRegister("6SlIf", function(module, exports) {

$parcel$export(module.exports, "checkUserAccess", function () { return $11e97d472fd45b14$export$256728288648ff6a; });
const $11e97d472fd45b14$export$256728288648ff6a = (access)=>{
    switch(access.userLevel){
        case "read":
            return access.requiredLevel === "read";
        case "write":
            return [
                "read",
                "write"
            ].includes(access.requiredLevel);
        case "admin":
            return true;
        default:
            return false;
    }
};

});

parcelRegister("fyDNm", function(module, exports) {

$parcel$export(module.exports, "CreateBranch", function () { return $43890423ced343e8$export$f6c4038ea0a9e3d0; });

var $9nHZC = parcelRequire("9nHZC");

var $fzXBZ = parcelRequire("fzXBZ");

var $agjvf = parcelRequire("agjvf");

var $jDMOr = parcelRequire("jDMOr");

var $g3VDW = parcelRequire("g3VDW");

var $cMb4y = parcelRequire("cMb4y");

var $lepT7 = parcelRequire("lepT7");

var $a7iuM = parcelRequire("a7iuM");
parcelRequire("a7A34");
var $b0Ym4 = parcelRequire("b0Ym4");

var $9UqTj = parcelRequire("9UqTj");

var $iWbF7 = parcelRequire("iWbF7");

var $6aoKW = parcelRequire("6aoKW");

var $5gF7V = parcelRequire("5gF7V");

var $5bCME = parcelRequire("5bCME");

var $abRa1 = parcelRequire("abRa1");

var $8JHOA = parcelRequire("8JHOA");

var $9xBn1 = parcelRequire("9xBn1");

var $eEasA = parcelRequire("eEasA");

var $9hHuX = parcelRequire("9hHuX");
const $43890423ced343e8$var$BRANCHING_MODEL_TYPE_LABEL = {
    bugfix: (0, $9xBn1.default).branchTypeBugfixOptionLabel,
    feature: (0, $9xBn1.default).branchTypeFeatureOptionLabel,
    hotfix: (0, $9xBn1.default).branchTypeHotfixOptionLabel,
    release: (0, $9xBn1.default).branchTypeReleaseOptionLabel,
    other: (0, $9xBn1.default).branchTypeOtherOptionLabel
};
const $43890423ced343e8$var$BRANCH_TYPE_ORDER = [
    "bugfix",
    "feature",
    "hotfix",
    "release"
];
class $43890423ced343e8$export$f6c4038ea0a9e3d0 extends (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).PureComponent {
    constructor(...args){
        super(...args);
        this.branchNameInputRef = void 0;
        this.state = {
            isBranchTypeSelectorHelpShown: false
        };
        this.handleChangeFromBranch = (ref)=>{
            this.publishEventForChangeFromBranch(ref);
            this.props.onChangeFromBranch(ref);
        };
        this.publishEventForChangeFromBranch = (newFromBranch)=>{
            const { refSelector: { selected: selected, suggestedRef: suggestedRef }, branchTypeSelector: { selected: selectedBranchType, branchTypes: branchTypes }, workflowBranches: { development: development, production: production } } = this.props;
            const previous = selected ? selected.ref : null;
            if (!previous || !newFromBranch || previous === newFromBranch) // `previous === newFromBranch` is the case when the dropdown is opened and the existing selected option is chosen.
            // We don't want to send an analytics event for that.
            return;
            const branchType = (ref)=>{
                if (ref.type === (0, $5gF7V.REF_TYPE).TAG) return "tag";
                // Check if branch name is one of development or production
                if (development && (0, $abRa1.areRefsSame)(ref, development)) return "development";
                else if (production && (0, $abRa1.areRefsSame)(ref, production)) return "production";
                if (!branchTypes.length) return null;
                // Check if branch name matches a prefix
                const type = branchTypes.find((t)=>ref.name.indexOf(t.prefix) === 0);
                return type ? type.kind : (0, $5gF7V.BRANCH_TYPE_OTHER).kind;
            };
            const isDefault = (ref)=>suggestedRef ? (0, $abRa1.areRefsSame)(ref, suggestedRef) : false;
            const attributes = {
                branchType: selectedBranchType ? selectedBranchType.kind : null,
                newIsDefault: isDefault(newFromBranch),
                newType: branchType(newFromBranch),
                previousIsDefault: isDefault(previous),
                previousType: branchType(previous)
            };
            (0, $6aoKW.publishUiEvent)({
                action: "changed",
                actionSubject: "option",
                actionSubjectId: "fromBranchSelect",
                source: "createBranchScreen",
                attributes: attributes
            });
        };
        this.branchTypeOption = (branchType, isSelected = false)=>{
            const message = this.props.intl.formatMessage($43890423ced343e8$var$BRANCHING_MODEL_TYPE_LABEL[branchType.kind]);
            const label = isSelected ? message : this.branchTypeOptionLabel(branchType, message);
            return {
                label: label,
                value: branchType
            };
        };
        this.branchTypeOptionLabel = (branchType, message)=>{
            if (branchType.kind === (0, $5gF7V.EXTENDED_BRANCH_KINDS).OTHER) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eEasA.BranchTypeOptionOther, {
                "data-qa": "create-branch-type-option"
            }, message);
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", {
                "data-qa": "create-branch-type-option"
            }, message);
        };
        this.getSelectedBranchType = ()=>{
            const { selected: selected } = this.props.branchTypeSelector;
            if (selected) return this.branchTypeOption(selected, true);
            else return this.branchTypeOption((0, $5gF7V.BRANCH_TYPE_OTHER), true);
        };
        this.getBranchTypeOptions = ()=>{
            const { branchTypes: branchTypes } = this.props.branchTypeSelector;
            const options = (0, $fzXBZ.default)(branchTypes, [
                (type)=>$43890423ced343e8$var$BRANCH_TYPE_ORDER.indexOf(type.kind)
            ]).map((type)=>this.branchTypeOption(type));
            if (options.length > 0) options.push(this.branchTypeOption((0, $5gF7V.BRANCH_TYPE_OTHER)));
            return options;
        };
        this.setHelpShown = (showHelp)=>this.setState({
                isBranchTypeSelectorHelpShown: showHelp
            });
        this.renderBranchTypeSelectorLabel = (htmlFor)=>{
            const { intl: intl } = this.props;
            const { isBranchTypeSelectorHelpShown: helpShown } = this.state;
            const tooltipContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eEasA.BranchTypeSelectorTooltipContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, $9xBn1.default).branchTypeTooltipText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("a", {
                href: (0, $iWbF7.default).external.docs(),
                target: "_blank",
                onClick: ()=>this.setHelpShown(false)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, $9xBn1.default).branchTypeTooltipLearnMoreLink))));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eEasA.FormLabel, {
                htmlFor: htmlFor
            }, intl.formatMessage((0, $9xBn1.default).branchTypeLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eEasA.BranchTypeSelectorIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $cMb4y.default), {
                content: tooltipContent,
                isOpen: helpShown,
                onClose: ()=>this.setHelpShown(false),
                placement: "right-start"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eEasA.CursorPointer, {
                type: "button",
                onClick: ()=>this.setHelpShown(!helpShown)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g3VDW))), {
                size: "small",
                label: ""
            })))));
        };
        this.hasBuildStatuses = ()=>this.props.refSelector.selectedCommitStatuses && this.props.refSelector.selectedCommitStatuses.length > 0;
        this.renderApiErrorMessage = ()=>{
            const { error: error } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", null, error && error.message);
        };
        this.branchNameErrorMessages = {
            [(0, $5gF7V.CREATE_BRANCH_ERROR_TYPE).BRANCH_ALREADY_EXISTS]: ()=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, $9xBn1.default).errorDescriptionBranchAlreadyExists);
            },
            // For these errors we simply show the message returned in API response
            [(0, $5gF7V.CREATE_BRANCH_ERROR_TYPE).BRANCH_PERMISSION_VIOLATED]: ()=>this.renderApiErrorMessage(),
            [(0, $5gF7V.CREATE_BRANCH_ERROR_TYPE).INVALID_BRANCH_NAME]: ()=>this.renderApiErrorMessage()
        };
        this.renderInvalidBranchNameMessage = ()=>{
            const { error: error } = this.props;
            if (error) {
                const type = Object.keys(this.branchNameErrorMessages).find((t)=>t === error.type);
                if (type) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eEasA.BranchNameError, null, this.branchNameErrorMessages[type]());
            }
            return null;
        };
        this.renderBranchNameInputField = ()=>{
            const branchType = this.getSelectedBranchType();
            const prefix = branchType && branchType.value.prefix;
            const errorMessage = this.renderInvalidBranchNameMessage();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eEasA.BranchNameInputWrapper, null, !!prefix && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eEasA.BranchNamePrefix, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $a7iuM.default), {
                content: prefix,
                position: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", {
                id: "branch-name-prefix"
            }, prefix))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eEasA.BranchNameInput, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $jDMOr.default), {
                name: "branchName",
                onChange: (e)=>this.props.onChangeNewBranchName(e.target.value),
                disabled: this.props.isCreating,
                autoComplete: "off",
                shouldFitContainer: true,
                autoFocus: true,
                isLabelHidden: true,
                value: this.props.createParams.name,
                isInvalid: !!errorMessage,
                invalidMessage: errorMessage,
                innerRef: (ref)=>{
                    this.branchNameInputRef = ref;
                }
            })));
        };
        this.renderRepositorySelector = ()=>{
            return this.props.createFrom === (0, $5gF7V.CREATE_FROM).GLOBAL_PAGE || this.props.createFrom === (0, $5gF7V.CREATE_FROM).GLOBAL_DIALOG ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9hHuX.default), {
                repositorySelector: this.props.repositorySelector,
                intl: this.props.intl,
                isCreating: this.props.isCreating,
                onChangeRepository: this.props.onChangeRepository
            }) : null;
        };
    }
    componentDidUpdate(prevProps) {
        const { onFetchCommitStatuses: onFetchCommitStatuses, error: error, createParams: createParams } = this.props;
        const prevRefHash = (prevProps.createParams.target || {}).hash;
        const currRefHash = (createParams.target || {}).hash;
        if (prevRefHash !== currRefHash && currRefHash) onFetchCommitStatuses();
        // Focus on the branch name input field if new state contains related error
        if (this.branchNameInputRef && !prevProps.error && error && error.type in this.branchNameErrorMessages) this.branchNameInputRef.focus();
    }
    render() {
        const { intl: intl, isCreating: isCreating, refSelector: refSelector, createParams: createParams, onChangeBranchType: onChangeBranchType, branchTypeSelector: branchTypeSelector, isBannerOpen: isBannerOpen } = this.props;
        const isLoading = branchTypeSelector.loadingState === (0, $5gF7V.LOADING_STATE).LOADING || refSelector.loadingState === (0, $5gF7V.LOADING_STATE).LOADING;
        const targetName = createParams.target && createParams.target.name || "";
        const branchTypeId = "select-branch-type";
        const selectStyles = (0, $9UqTj.getModalMenuPortalStyles)(isBannerOpen);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
            "data-qa": !isLoading ? "create-branch-loaded" : ""
        }, this.renderRepositorySelector(), branchTypeSelector.isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eEasA.FieldWrapper, null, this.renderBranchTypeSelectorLabel(branchTypeId), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $lepT7.default), {
            id: branchTypeId,
            isDisabled: isCreating || isLoading,
            isLoading: isLoading,
            options: this.getBranchTypeOptions(),
            value: this.getSelectedBranchType(),
            onChange: (option)=>onChangeBranchType(option.value),
            onClickPreventDefault: false,
            menuPortalTarget: document.body,
            styles: selectStyles
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eEasA.FieldWrapper, {
            id: "select-branch"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eEasA.FormLabel, null, intl.formatMessage((0, $9xBn1.default).fromBranchLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eEasA.FieldRefSelector, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eEasA.FieldRefSelectorDropdown, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5bCME.default), {
            intl: intl,
            refSelector: refSelector,
            isCreating: isCreating,
            isLoading: isLoading,
            onChangeFromBranch: this.handleChangeFromBranch,
            selectStyles: selectStyles
        })), this.hasBuildStatuses() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eEasA.FieldRefSelectorBuildStatus, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $b0Ym4.default), {
            builds: refSelector.selectedCommitStatuses
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eEasA.FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eEasA.FormLabel, null, intl.formatMessage((0, $9xBn1.default).branchNameLabel)), this.renderBranchNameInputField()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $8JHOA.BranchGraphic), {
            targetBranchName: targetName,
            newBranchName: this.props.newBranchName
        }));
    }
}

});
parcelRegister("jDMOr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4c7860644e05380$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $13MK1 = parcelRequire("13MK1");

var $hL2rg = parcelRequire("hL2rg");
var $gZi8P = parcelRequire("gZi8P");
var $doLAF = parcelRequire("doLAF");

var $6lvh4 = parcelRequire("6lvh4");
var $2sKZp = parcelRequire("2sKZp");

var $gPZYo = parcelRequire("gPZYo");
function $e4c7860644e05380$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e4c7860644e05380$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $e4c7860644e05380$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $e4c7860644e05380$var$packageName = "@atlaskit/field-text";
var $e4c7860644e05380$var$packageVersion = "11.0.7";
var $e4c7860644e05380$var$Wrapper = (0, $13MK1.default).div.withConfig({
    displayName: "FieldTextStateless__Wrapper",
    componentId: "ynbdsh-0"
})([
    "\n  flex: 1 1 100%;\n"
]);
var $e4c7860644e05380$export$58776388b6c67955 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(FieldTextStateless, _Component);
    var _super = $e4c7860644e05380$var$_createSuper(FieldTextStateless);
    function FieldTextStateless() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, FieldTextStateless);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "input", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "setInputRef", function(input) {
            _this.input = input;
            _this.props.innerRef(input);
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(FieldTextStateless, [
        {
            key: "focus",
            value: function focus() {
                if (this.input) this.input.focus();
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($e4c7860644e05380$var$Wrapper, null, !this.props.isLabelHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2sKZp.default), {
                    htmlFor: this.props.id,
                    isDisabled: this.props.disabled,
                    isLabelHidden: this.props.isLabelHidden,
                    isRequired: this.props.required,
                    label: this.props.label || ""
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6lvh4.default), {
                    invalidMessage: this.props.invalidMessage,
                    isCompact: this.props.compact,
                    isDisabled: this.props.disabled,
                    isFitContainerWidthEnabled: this.props.shouldFitContainer,
                    isInvalid: this.props.isInvalid,
                    isReadOnly: this.props.isReadOnly,
                    isRequired: this.props.required,
                    isValidationHidden: this.props.isValidationHidden
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $gPZYo.default), {
                    autoComplete: this.props.autoComplete,
                    autoFocus: this.props.autoFocus,
                    disabled: this.props.disabled,
                    form: this.props.form,
                    id: this.props.id,
                    innerRef: this.setInputRef,
                    isMonospaced: this.props.isMonospaced,
                    maxLength: this.props.maxLength,
                    min: this.props.min,
                    max: this.props.max,
                    name: this.props.name,
                    onBlur: this.props.onBlur,
                    onChange: this.props.onChange,
                    onFocus: this.props.onFocus,
                    onKeyDown: this.props.onKeyDown,
                    onKeyPress: this.props.onKeyPress,
                    onKeyUp: this.props.onKeyUp,
                    pattern: this.props.pattern,
                    placeholder: this.props.placeholder,
                    readOnly: this.props.isReadOnly,
                    required: this.props.required,
                    spellCheck: this.props.isSpellCheckEnabled,
                    type: this.props.type,
                    value: this.props.value
                })));
            }
        }
    ]);
    return FieldTextStateless;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($e4c7860644e05380$export$58776388b6c67955, "defaultProps", {
    compact: false,
    disabled: false,
    isInvalid: false,
    isReadOnly: false,
    isSpellCheckEnabled: true,
    onChange: function onChange() {},
    required: false,
    type: "text",
    isValidationHidden: false,
    innerRef: function innerRef() {}
});
var $e4c7860644e05380$var$createAndFireEventOnAtlaskit = (0, $hL2rg.default)("atlaskit");
var $e4c7860644e05380$export$2e2bcd8739ae039 = (0, $gZi8P.default)({
    componentName: "fieldText",
    packageName: $e4c7860644e05380$var$packageName,
    packageVersion: $e4c7860644e05380$var$packageVersion
})((0, $doLAF.default)({
    onBlur: $e4c7860644e05380$var$createAndFireEventOnAtlaskit({
        action: "blurred",
        actionSubject: "textField",
        attributes: {
            componentName: "fieldText",
            packageName: $e4c7860644e05380$var$packageName,
            packageVersion: $e4c7860644e05380$var$packageVersion
        }
    }),
    onFocus: $e4c7860644e05380$var$createAndFireEventOnAtlaskit({
        action: "focused",
        actionSubject: "textField",
        attributes: {
            componentName: "fieldText",
            packageName: $e4c7860644e05380$var$packageName,
            packageVersion: $e4c7860644e05380$var$packageVersion
        }
    })
})($e4c7860644e05380$export$58776388b6c67955));

});
parcelRegister("hL2rg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ced8b7c16c92cd07$export$2e2bcd8739ae039; });
var $ced8b7c16c92cd07$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};

});

parcelRegister("gZi8P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5e06a5742c0d2cd$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $lPUHe = parcelRequire("lPUHe");
var $c5e06a5742c0d2cd$var$_excluded = [
    "analyticsContext"
];
function $c5e06a5742c0d2cd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c5e06a5742c0d2cd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c5e06a5742c0d2cd$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c5e06a5742c0d2cd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $c5e06a5742c0d2cd$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $c5e06a5742c0d2cd$var$_excluded);
            var analyticsData = (0, $9nHZC.useMemo)(function() {
                return $c5e06a5742c0d2cd$var$_objectSpread($c5e06a5742c0d2cd$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $lPUHe.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
                ref: ref
            })));
        }); // @ts-ignore
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $c5e06a5742c0d2cd$export$2e2bcd8739ae039 = $c5e06a5742c0d2cd$var$withAnalyticsContext;

});
parcelRegister("lPUHe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe5a571e04cde468$export$2e2bcd8739ae039; });

var $er2nY = parcelRequire("er2nY");

var $7GRFh = parcelRequire("7GRFh");

var $8ovux = parcelRequire("8ovux");
var $fe5a571e04cde468$var$_process$env;
var $fe5a571e04cde468$var$ExportedAnalyticsContext;
if (typeof $8ovux !== "undefined" && $8ovux !== null && ($fe5a571e04cde468$var$_process$env = {}, true) && $fe5a571e04cde468$var$_process$env !== void 0 && $fe5a571e04cde468$var$_process$env["ANALYTICS_NEXT_MODERN_CONTEXT"]) $fe5a571e04cde468$var$ExportedAnalyticsContext = (0, $7GRFh.default);
else $fe5a571e04cde468$var$ExportedAnalyticsContext = (0, $er2nY.default);
var $fe5a571e04cde468$export$2e2bcd8739ae039 = $fe5a571e04cde468$var$ExportedAnalyticsContext;

});
parcelRegister("er2nY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8257012e114cbb9$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");

var $kZnbM = parcelRequire("kZnbM");
function $a8257012e114cbb9$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a8257012e114cbb9$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $a8257012e114cbb9$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $a8257012e114cbb9$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func
};
var $a8257012e114cbb9$var$noop = function noop() {
    return [];
}; // eslint-disable-next-line @repo/internal/react/no-class-components
var $a8257012e114cbb9$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(AnalyticsContext, _Component);
    var _super = $a8257012e114cbb9$var$_createSuper(AnalyticsContext);
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsContext);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $a8257012e114cbb9$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $a8257012e114cbb9$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kZnbM.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsContext;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($a8257012e114cbb9$var$AnalyticsContext, "contextTypes", $a8257012e114cbb9$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($a8257012e114cbb9$var$AnalyticsContext, "childContextTypes", $a8257012e114cbb9$var$ContextTypes);
var $a8257012e114cbb9$export$2e2bcd8739ae039 = $a8257012e114cbb9$var$AnalyticsContext;

});

parcelRegister("7GRFh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59961557eeed4491$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");

var $5OyrI = parcelRequire("5OyrI");

var $gOqx2 = parcelRequire("gOqx2");
var $59961557eeed4491$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $gOqx2.useTrackedRef)(data);
    var analyticsContext = (0, $5OyrI.useAnalyticsContext)();
    var getAtlaskitAnalyticsContext = (0, $9nHZC.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(analyticsContext.getAtlaskitAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        analyticsContext,
        dataRef
    ]);
    var value = (0, $9nHZC.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: analyticsContext.getAtlaskitAnalyticsEventHandlers
        };
    }, [
        analyticsContext,
        getAtlaskitAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kZnbM.default).Provider, {
        value: value
    }, children);
};
var $59961557eeed4491$export$2e2bcd8739ae039 = $59961557eeed4491$var$AnalyticsContext;

});
parcelRegister("5OyrI", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $43bc57869853f7ca$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $43bc57869853f7ca$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});

parcelRegister("gOqx2", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $c3d5e58c2bfd9df8$export$1d27a74659855e44; });

var $9nHZC = parcelRequire("9nHZC");
var $c3d5e58c2bfd9df8$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    (0, $9nHZC.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
};

});




parcelRegister("doLAF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c126ebb1146e006$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $lNMT6 = parcelRequire("lNMT6");

var $dNzsL = parcelRequire("dNzsL");
var $9c126ebb1146e006$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(props, ref) {
            var _usePatchedProps = (0, $dNzsL.usePatchedProps)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $lNMT6.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        }); // @ts-ignore
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $9c126ebb1146e006$export$2e2bcd8739ae039 = $9c126ebb1146e006$var$withAnalyticsEvents;

});
parcelRegister("lNMT6", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $fdf418a9f09f34c7$export$5bf35293e545f20c; });

var $dNznA = parcelRequire("dNznA");

var $dfawr = parcelRequire("dfawr");

var $5OyrI = parcelRequire("5OyrI");
function $fdf418a9f09f34c7$export$5bf35293e545f20c() {
    var analyticsContext = (0, $5OyrI.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $dfawr.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("dfawr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a44d69897a64f86$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $iKjna = parcelRequire("iKjna");
function $9a44d69897a64f86$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $9a44d69897a64f86$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $9a44d69897a64f86$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $9a44d69897a64f86$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $9a44d69897a64f86$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 ? void 0 : (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $9a44d69897a64f86$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $9a44d69897a64f86$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $iKjna.default));

});
parcelRegister("iKjna", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da5b8cdcfbf432a6$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
function $da5b8cdcfbf432a6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $da5b8cdcfbf432a6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $da5b8cdcfbf432a6$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $da5b8cdcfbf432a6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $da5b8cdcfbf432a6$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $da5b8cdcfbf432a6$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 ? void 0 : (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $da5b8cdcfbf432a6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $da5b8cdcfbf432a6$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(updater) === "object") this.payload = $da5b8cdcfbf432a6$var$_objectSpread($da5b8cdcfbf432a6$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});



parcelRegister("dNzsL", function(module, exports) {

$parcel$export(module.exports, "usePatchedProps", function () { return $a0bb5c2e7ae6d280$export$9ebb5a84d17e5d18; });

var $kFnE9 = parcelRequire("kFnE9");

var $340K4 = parcelRequire("340K4");

var $9nHZC = parcelRequire("9nHZC");

var $lNMT6 = parcelRequire("lNMT6");
function $a0bb5c2e7ae6d280$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a0bb5c2e7ae6d280$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a0bb5c2e7ae6d280$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a0bb5c2e7ae6d280$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a0bb5c2e7ae6d280$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $lNMT6.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $9nHZC.useRef)({});
    var patchedProps = (0, $9nHZC.useMemo)(function() {
        var cache = handlerCache.current; // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                "object",
                "function"
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $a0bb5c2e7ae6d280$var$_objectSpread($a0bb5c2e7ae6d280$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === "function" ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === "function") {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $a0bb5c2e7ae6d280$var$_objectSpread($a0bb5c2e7ae6d280$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});


parcelRegister("6lvh4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49ecf6af1c70fb3e$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $bAaUT = parcelRequire("bAaUT");
function $49ecf6af1c70fb3e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $49ecf6af1c70fb3e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $49ecf6af1c70fb3e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $49ecf6af1c70fb3e$var$ON_BLUR_KEY = "onBlurKey";
var $49ecf6af1c70fb3e$var$ON_CONTENT_BLUR_KEY = "onContentBlurKey";
function $49ecf6af1c70fb3e$var$waitForRender(cb) {
    // Execute the callback after any upcoming render calls in the execution queue
    setTimeout(cb, 0);
}
var $49ecf6af1c70fb3e$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(FieldBase, _Component);
    var _super = $49ecf6af1c70fb3e$var$_createSuper(FieldBase);
    function FieldBase() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, FieldBase);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "state", {
            isFocused: _this.props.defaultIsFocused,
            isDialogFocused: false,
            shouldIgnoreNextDialogBlur: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "timers", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onFocus", function(e) {
            _this.setState({
                isFocused: true
            });
            _this.props.onFocus(e); // Escape from a possible race-condition when blur and focus happen one by one
            // (otherwise the dialog might be left closed)
            _this.cancelSchedule($49ecf6af1c70fb3e$var$ON_BLUR_KEY);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onBlur", function(e) {
            // Because the blur event fires before the focus event, we want to make sure that we don't
            // render and close the dialog before we can check if the dialog is focused.
            _this.reschedule($49ecf6af1c70fb3e$var$ON_BLUR_KEY, function() {
                _this.setState({
                    isFocused: false
                });
                _this.props.onBlur(e);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onContentFocus", function() {
            if (_this.state.isDialogFocused) // If we are tabbing between two elements in the warning dialog, we need to prevent the
            // dialog from closing.
            _this.setState({
                shouldIgnoreNextDialogBlur: true
            });
            else _this.setState({
                isDialogFocused: true
            });
             // Escape from a possible race-condition when blur and focus happen one by one
            // (otherwise the dialog might be left closed)
            _this.cancelSchedule($49ecf6af1c70fb3e$var$ON_CONTENT_BLUR_KEY);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onContentBlur", function() {
            $49ecf6af1c70fb3e$var$waitForRender(function() {
                if (_this.state.shouldIgnoreNextDialogBlur) // Ignore the blur event if we are still focused in the dialog.
                _this.setState({
                    shouldIgnoreNextDialogBlur: false
                });
                else _this.setState({
                    isDialogFocused: false
                });
            });
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(FieldBase, [
        {
            key: "cancelSchedule",
            value: function cancelSchedule(key) {
                this.timers = this.timers || {};
                if (this.timers[key]) {
                    clearTimeout(this.timers[key]);
                    delete this.timers[key];
                }
            }
        },
        {
            key: "reschedule",
            value: function reschedule(key, callback) {
                var _this2 = this;
                // Use reschedule (not just schedule) to avoid race conditions when multiple blur events
                // happen one by one.
                this.timers = this.timers || {};
                this.cancelSchedule(key);
                this.timers[key] = setTimeout(function() {
                    callback();
                    _this2.cancelSchedule(key);
                }, 0);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.cancelSchedule($49ecf6af1c70fb3e$var$ON_BLUR_KEY);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, defaultIsFocused = _this$props.defaultIsFocused, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_this$props, [
                    "defaultIsFocused"
                ]);
                var _this$state = this.state, isFocused = _this$state.isFocused, isDialogFocused = _this$state.isDialogFocused;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $bAaUT.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
                    isDialogOpen: isFocused || isDialogFocused,
                    isFocused: isFocused,
                    onBlur: this.onBlur,
                    onFocus: this.onFocus,
                    onDialogFocus: this.onContentFocus,
                    onDialogBlur: this.onContentBlur
                }));
            }
        }
    ]);
    return FieldBase;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($49ecf6af1c70fb3e$export$2e2bcd8739ae039, "defaultProps", {
    defaultIsFocused: false,
    onFocus: function onFocus() {},
    onBlur: function onBlur() {}
});

});
parcelRegister("bAaUT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86eb865236e87bda$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $cMb4y = parcelRequire("cMb4y");

var $lsIMB = parcelRequire("lsIMB");

var $c0NEe = parcelRequire("c0NEe");
function $86eb865236e87bda$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $86eb865236e87bda$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $86eb865236e87bda$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $86eb865236e87bda$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(FieldBaseStateless, _Component);
    var _super = $86eb865236e87bda$var$_createSuper(FieldBaseStateless);
    function FieldBaseStateless() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, FieldBaseStateless);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(FieldBaseStateless, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (this.props.shouldReset) this.props.onBlur();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, appearance = _this$props.appearance, children = _this$props.children, invalidMessage = _this$props.invalidMessage, isCompact = _this$props.isCompact, isDialogOpen = _this$props.isDialogOpen, isDisabled = _this$props.isDisabled, isFitContainerWidthEnabled = _this$props.isFitContainerWidthEnabled, isFocused = _this$props.isFocused, isInvalid = _this$props.isInvalid, isLoading = _this$props.isLoading, isPaddingDisabled = _this$props.isPaddingDisabled, isReadOnly = _this$props.isReadOnly, maxWidth = _this$props.maxWidth, onBlur = _this$props.onBlur, onDialogBlur = _this$props.onDialogBlur, onDialogClick = _this$props.onDialogClick, onDialogFocus = _this$props.onDialogFocus, onFocus = _this$props.onFocus, isValidationHidden = _this$props.isValidationHidden;
                function getAppearance(a) {
                    if (isDisabled) return "disabled";
                    if (isInvalid) return "invalid";
                    return a;
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $lsIMB.ContentWrapper), {
                    disabled: isDisabled,
                    maxWidth: maxWidth,
                    grow: isFitContainerWidthEnabled
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $cMb4y.default), {
                    content: invalidMessage,
                    isOpen: isDialogOpen && !!invalidMessage && !isValidationHidden,
                    onContentBlur: onDialogBlur,
                    onContentClick: onDialogClick,
                    onContentFocus: onDialogFocus,
                    placement: "right"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $lsIMB.ChildWrapper), {
                    compact: isCompact
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $lsIMB.Content), {
                    appearance: getAppearance(appearance),
                    compact: isCompact,
                    disabled: isDisabled,
                    isFocused: isFocused,
                    invalid: isInvalid && !isFocused,
                    none: appearance === "none",
                    onBlurCapture: onBlur,
                    onFocusCapture: onFocus,
                    paddingDisabled: isPaddingDisabled,
                    readOnly: isReadOnly,
                    subtle: appearance === "subtle"
                }, children, !isValidationHidden ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $c0NEe.default), {
                    isDisabled: isDisabled,
                    isInvalid: isInvalid,
                    isLoading: isLoading
                }) : null))));
            }
        }
    ]);
    return FieldBaseStateless;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($86eb865236e87bda$export$2e2bcd8739ae039, "defaultProps", {
    appearance: "standard",
    invalidMessage: "",
    isCompact: false,
    isDialogOpen: false,
    isDisabled: false,
    isFitContainerWidthEnabled: false,
    isFocused: false,
    isInvalid: false,
    isLoading: false,
    isPaddingDisabled: false,
    isReadOnly: false,
    onDialogBlur: function onDialogBlur() {},
    onDialogClick: function onDialogClick() {},
    onDialogFocus: function onDialogFocus() {},
    shouldReset: false,
    isValidationHidden: false
});

});
parcelRegister("lsIMB", function(module, exports) {

$parcel$export(module.exports, "ChildWrapper", function () { return $f9fef3782f1dd6e8$export$87c2de9f2249ec47; });
$parcel$export(module.exports, "Content", function () { return $f9fef3782f1dd6e8$export$7c6e2c02157bb7d2; });
$parcel$export(module.exports, "ContentWrapper", function () { return $f9fef3782f1dd6e8$export$6ce170286acaa8d3; });

var $13MK1 = parcelRequire("13MK1");

var $kD01A = parcelRequire("kD01A");

var $aP6k3 = parcelRequire("aP6k3");

var $jp7ng = parcelRequire("jp7ng");

var $2VRkv = parcelRequire("2VRkv");
var $f9fef3782f1dd6e8$var$borderRadius = "3px";
var $f9fef3782f1dd6e8$var$borderWidth = 2;
var $f9fef3782f1dd6e8$var$grid = (0, $aP6k3.gridSize)();
var $f9fef3782f1dd6e8$var$lineHeightBase = $f9fef3782f1dd6e8$var$grid * 2.5;
var $f9fef3782f1dd6e8$var$lineHeightCompact = $f9fef3782f1dd6e8$var$grid * 2;
var $f9fef3782f1dd6e8$var$heightBase = $f9fef3782f1dd6e8$var$grid * 5;
var $f9fef3782f1dd6e8$var$heightCompact = $f9fef3782f1dd6e8$var$grid * 4;
var $f9fef3782f1dd6e8$var$horizontalPadding = $f9fef3782f1dd6e8$var$grid;
var $f9fef3782f1dd6e8$var$innerHeight = $f9fef3782f1dd6e8$var$grid * 3;
var $f9fef3782f1dd6e8$var$transitionDuration = "0.2s";
var $f9fef3782f1dd6e8$var$getBorderAndPadding = function getBorderAndPadding(_ref) {
    var paddingDisabled = _ref.paddingDisabled, compact = _ref.compact;
    var height = compact ? $f9fef3782f1dd6e8$var$heightCompact : $f9fef3782f1dd6e8$var$heightBase;
    var padding = paddingDisabled ? "0" : "".concat((height - 2 * $f9fef3782f1dd6e8$var$borderWidth - $f9fef3782f1dd6e8$var$innerHeight) / 2, "px ").concat($f9fef3782f1dd6e8$var$horizontalPadding - $f9fef3782f1dd6e8$var$borderWidth, "px");
    return (0, $13MK1.css)([
        "\n    border-width: ",
        "px;\n    padding: ",
        ";\n  "
    ], $f9fef3782f1dd6e8$var$borderWidth, padding);
};
var $f9fef3782f1dd6e8$var$getLineHeight = function getLineHeight(props) {
    var currentLineHeight = props.compact ? $f9fef3782f1dd6e8$var$lineHeightCompact : $f9fef3782f1dd6e8$var$lineHeightBase;
    return currentLineHeight / (0, $aP6k3.fontSize)();
};
var $f9fef3782f1dd6e8$var$getDisabledColor = (0, $kD01A.default)({
    light: (0, $jp7ng.N70),
    dark: (0, $jp7ng.DN90)
});
var $f9fef3782f1dd6e8$var$getDisabledState = function getDisabledState(props) {
    return props.disabled && (0, $13MK1.css)([
        "\n    color: ",
        ";\n    pointer-events: none;\n  "
    ], $f9fef3782f1dd6e8$var$getDisabledColor(props));
};
var $f9fef3782f1dd6e8$var$getHoverState = function getHoverState(props) {
    if (props.readOnly || props.isFocused || props.none) return null;
    return (0, $13MK1.css)([
        "\n    &:hover {\n      background-color: ",
        ";\n    }\n  "
    ], (0, $2VRkv.getBackgroundColorHover)(props));
};
var $f9fef3782f1dd6e8$var$getBorderStyle = function getBorderStyle(props) {
    return props.appearance === "none" ? "none" : "solid";
};
var $f9fef3782f1dd6e8$var$getMinHeight = function getMinHeight(_ref2) {
    var compact = _ref2.compact;
    var minHeight = compact ? $f9fef3782f1dd6e8$var$heightCompact : $f9fef3782f1dd6e8$var$heightBase;
    return (0, $13MK1.css)([
        "\n    min-height: ",
        "px;\n  "
    ], minHeight);
}; // need an element wrapping the children because IE11 doesn't apply min-height correctly
var $f9fef3782f1dd6e8$export$87c2de9f2249ec47 = (0, $13MK1.default).div.withConfig({
    displayName: "Content__ChildWrapper",
    componentId: "ve26fj-0"
})([
    "\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 auto;\n  max-width: 100%;\n  ",
    ";\n"
], function(p) {
    return $f9fef3782f1dd6e8$var$getMinHeight(p);
});
var $f9fef3782f1dd6e8$var$getColor = (0, $kD01A.default)({
    light: (0, $jp7ng.N900),
    dark: (0, $jp7ng.DN600)
});
var $f9fef3782f1dd6e8$export$7c6e2c02157bb7d2 = (0, $13MK1.default).div.withConfig({
    displayName: "Content",
    componentId: "ve26fj-1"
})([
    "\n  align-items: center;\n  background-color: ",
    ";\n  border-color: ",
    ";\n  border-radius: ",
    ";\n  border-style: ",
    ";\n  box-sizing: border-box;\n  color: ",
    ";\n  display: flex;\n  flex: 1 0 auto;\n  font-size: ",
    "px;\n  justify-content: space-between;\n  line-height: ",
    ";\n  max-width: 100%;\n  overflow: hidden;\n  transition: background-color ",
    " ease-in-out,\n    border-color ",
    " ease-in-out;\n  word-wrap: break-word;\n  ",
    " ",
    " ",
    ";\n"
], function(props) {
    return props.isFocused ? (0, $2VRkv.getBackgroundColorFocus)(props) : (0, $2VRkv.getBackgroundColor)(props);
}, function(props) {
    return props.isFocused ? (0, $2VRkv.getBorderColorFocus)(props) : (0, $2VRkv.getBorderColor)(props);
}, $f9fef3782f1dd6e8$var$borderRadius, $f9fef3782f1dd6e8$var$getBorderStyle, $f9fef3782f1dd6e8$var$getColor, (0, $aP6k3.fontSize), $f9fef3782f1dd6e8$var$getLineHeight, $f9fef3782f1dd6e8$var$transitionDuration, $f9fef3782f1dd6e8$var$transitionDuration, $f9fef3782f1dd6e8$var$getBorderAndPadding, $f9fef3782f1dd6e8$var$getHoverState, $f9fef3782f1dd6e8$var$getDisabledState);
var $f9fef3782f1dd6e8$var$getMaxWidth = function getMaxWidth(maxWidth) {
    return maxWidth ? "".concat(maxWidth, "px") : "100%";
};
var $f9fef3782f1dd6e8$export$6ce170286acaa8d3 = (0, $13MK1.default).div.withConfig({
    displayName: "Content__ContentWrapper",
    componentId: "ve26fj-2"
})([
    "\n  ",
    " ",
    " ",
    " max-width: ",
    ";\n"
], function(props) {
    return props.disabled && "\n      cursor: not-allowed;\n    ";
}, function(props) {
    return props.grow ? (0, $13MK1.css)([
        "\n          flex: 0 0 ",
        ";\n        "
    ], $f9fef3782f1dd6e8$var$getMaxWidth(props.maxWidth)) : "\n          flex: 0 0 auto;\n        ";
}, function(props) {
    return props.grow ? "\n          display: block;\n        " : "\n          display: inline-block;\n          vertical-align: top;\n        ";
}, function(props) {
    return $f9fef3782f1dd6e8$var$getMaxWidth(props.maxWidth);
});

});
parcelRegister("2VRkv", function(module, exports) {

$parcel$export(module.exports, "getBackgroundColor", function () { return $222a45cb31b667d4$export$4420ac7a34197e42; });
$parcel$export(module.exports, "getBackgroundColorFocus", function () { return $222a45cb31b667d4$export$f77f6fb2bc6cf8db; });
$parcel$export(module.exports, "getBackgroundColorHover", function () { return $222a45cb31b667d4$export$110328113a9622db; });
$parcel$export(module.exports, "getBorderColor", function () { return $222a45cb31b667d4$export$dbc6cfecd630bcea; });
$parcel$export(module.exports, "getBorderColorFocus", function () { return $222a45cb31b667d4$export$53871f284b5dc77b; });

var $kD01A = parcelRequire("kD01A");

var $jp7ng = parcelRequire("jp7ng");
// The exports are the functions, not the objects, so could not be used here
var $222a45cb31b667d4$var$disabled = {
    light: $jp7ng.N20,
    dark: $jp7ng.DN20
}; // For validation red is the new 'yellow' which was { light: colors.Y300, dark: colors.Y300 }
var $222a45cb31b667d4$var$red = {
    light: $jp7ng.R400,
    dark: $jp7ng.R400
}; // The following do not yet have a darkmode 'map': N20A, N10
var $222a45cb31b667d4$export$4420ac7a34197e42 = (0, $kD01A.default)("appearance", {
    standard: {
        light: $jp7ng.N10,
        dark: $jp7ng.DN10
    },
    disabled: $222a45cb31b667d4$var$disabled,
    invalid: {
        light: $jp7ng.N10,
        dark: $jp7ng.DN10
    },
    subtle: {
        light: "transparent",
        dark: "transparent"
    },
    none: {
        light: "transparent",
        dark: "transparent"
    }
});
var $222a45cb31b667d4$export$f77f6fb2bc6cf8db = (0, $kD01A.default)("appearance", {
    standard: {
        light: $jp7ng.N0,
        dark: $jp7ng.DN10
    },
    disabled: $222a45cb31b667d4$var$disabled,
    invalid: {
        light: $jp7ng.N0,
        dark: $jp7ng.DN10
    },
    subtle: {
        light: $jp7ng.N0,
        dark: $jp7ng.DN10
    },
    none: {
        light: "transparent",
        dark: "transparent"
    }
});
var $222a45cb31b667d4$export$110328113a9622db = (0, $kD01A.default)("appearance", {
    standard: {
        light: $jp7ng.N30,
        dark: $jp7ng.DN30
    },
    disabled: $222a45cb31b667d4$var$disabled,
    invalid: {
        light: $jp7ng.N30,
        dark: $jp7ng.DN30
    },
    subtle: {
        light: $jp7ng.N30,
        dark: $jp7ng.DN30
    },
    none: {
        light: "transparent",
        dark: "transparent"
    }
});
var $222a45cb31b667d4$export$dbc6cfecd630bcea = (0, $kD01A.default)("appearance", {
    standard: {
        light: $jp7ng.N40,
        dark: $jp7ng.DN40
    },
    disabled: {
        light: $jp7ng.N40,
        dark: $jp7ng.DN40
    },
    invalid: $222a45cb31b667d4$var$red,
    subtle: {
        light: "transparent",
        dark: "transparent"
    },
    none: {
        light: "transparent",
        dark: "transparent"
    }
});
var $222a45cb31b667d4$export$53871f284b5dc77b = (0, $kD01A.default)("appearance", {
    standard: {
        light: $jp7ng.B100,
        dark: $jp7ng.B75
    },
    disabled: {
        light: $jp7ng.B100,
        dark: $jp7ng.B75
    },
    invalid: {
        light: $jp7ng.B100,
        dark: $jp7ng.B75
    },
    subtle: {
        light: $jp7ng.B100,
        dark: $jp7ng.B75
    },
    none: {
        light: "transparent",
        dark: "transparent"
    }
});

});


parcelRegister("c0NEe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8bebff246f064b34$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $13MK1 = parcelRequire("13MK1");

var $9nHZC = parcelRequire("9nHZC");

var $jp7ng = parcelRequire("jp7ng");

var $dEKDm = parcelRequire("dEKDm");

var $jofEu = parcelRequire("jofEu");
function $8bebff246f064b34$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8bebff246f064b34$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $8bebff246f064b34$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $8bebff246f064b34$export$f7dc499a72baa103 = (0, $13MK1.default).div.withConfig({
    displayName: "ValidationElement__WarningIcon",
    componentId: "sc-1fk9yms-0"
})([
    "\n  align-items: center;\n  color: ",
    ";\n  display: flex;\n  flex-shrink: 0;\n"
], (0, $jp7ng.yellow)); // Spinner needs set height to avoid height jumping
// Also needs a margin so there is space between it and preceding text
var $8bebff246f064b34$var$SpinnerParent = (0, $13MK1.default).div.withConfig({
    displayName: "ValidationElement__SpinnerParent",
    componentId: "sc-1fk9yms-1"
})([
    "\n  height: 20px;\n  margin-left: 10px;\n"
]);
var $8bebff246f064b34$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(ValidationElement, _Component);
    var _super = $8bebff246f064b34$var$_createSuper(ValidationElement);
    function ValidationElement() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ValidationElement);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ValidationElement, [
        {
            key: "render",
            value: function render() {
                if (!this.props.isDisabled && this.props.isInvalid) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($8bebff246f064b34$export$f7dc499a72baa103, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jofEu))), {
                    label: "warning"
                }));
                return this.props.isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($8bebff246f064b34$var$SpinnerParent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dEKDm.default), {
                    size: "small"
                })) : null;
            }
        }
    ]);
    return ValidationElement;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($8bebff246f064b34$export$2e2bcd8739ae039, "defaultProps", {
    isDisabled: false,
    isInvalid: false,
    isLoading: false
});

});
parcelRegister("jofEu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e1dc6662c29d1401$var$_react = $e1dc6662c29d1401$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $kV7ST = parcelRequire("kV7ST");
function $e1dc6662c29d1401$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e1dc6662c29d1401$var$WarningIcon = (props)=>/*#__PURE__*/ $e1dc6662c29d1401$var$_react.default.createElement($kV7ST.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771L12.938 4.967z" fill="currentColor"/><path d="M12 15a1 1 0 01-1-1V9a1 1 0 012 0v5a1 1 0 01-1 1m0 3a1 1 0 010-2 1 1 0 010 2" fill="inherit"/></g></svg>`
    }, props));
$e1dc6662c29d1401$var$WarningIcon.displayName = "WarningIcon";
var $e1dc6662c29d1401$var$_default = $e1dc6662c29d1401$var$WarningIcon;
module.exports.default = $e1dc6662c29d1401$var$_default;

});
parcelRegister("kV7ST", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $f3af3f35b7576200$export$f04a61298a47a40f; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $5LVXk = parcelRequire("5LVXk");

var $f5LHT = parcelRequire("f5LHT");

var $7Vg1D = parcelRequire("7Vg1D");
function $f3af3f35b7576200$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f3af3f35b7576200$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f3af3f35b7576200$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f3af3f35b7576200$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $f3af3f35b7576200$var$iconStyles = (0, $avKww.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "> svg": $f3af3f35b7576200$var$_objectSpread($f3af3f35b7576200$var$_objectSpread({}, (0, $7Vg1D.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $f3af3f35b7576200$var$baseHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $f3af3f35b7576200$var$primaryEqualsSecondaryHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $f3af3f35b7576200$var$secondaryTransparentHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $f3af3f35b7576200$export$f04a61298a47a40f = /*#__PURE__*/ (0, $9nHZC.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $avKww.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $7Vg1D.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    var _useGlobalTheme = (0, $5LVXk.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $avKww.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            "--icon-secondary-color": secondaryColor || (0, $f5LHT.getBackground)(mode)
        }
    }, glyphProps, {
        css: [
            $f3af3f35b7576200$var$iconStyles,
            $f3af3f35b7576200$var$baseHcmStyles,
            primaryColor === secondaryColor && $f3af3f35b7576200$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $f3af3f35b7576200$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsualting them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $avKww.css)({
                width: dimensions.width,
                height: dimensions.height,
                "> svg": dimensions
            })
        ]
    }));
});
var $f3af3f35b7576200$export$2e2bcd8739ae039 = $f3af3f35b7576200$export$f04a61298a47a40f;

});
parcelRegister("f5LHT", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $afcc5442285bf663$export$18cb9425622d4e06; });
var $afcc5442285bf663$var$themedBackground = {
    light: "var(--ds-surface, #FFFFFF)",
    dark: "var(--ds-surface, #1B2638)"
};
var $afcc5442285bf663$export$18cb9425622d4e06 = function getBackground() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "light";
    return $afcc5442285bf663$var$themedBackground[mode];
};

});

parcelRegister("7Vg1D", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $5c4a4993823e2e08$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $5c4a4993823e2e08$export$3eb7d6130acfda37; });

var $cXBIA = parcelRequire("cXBIA");

var $avKww = parcelRequire("avKww");
var $5c4a4993823e2e08$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
var $5c4a4993823e2e08$var$smallStyles = (0, $avKww.css)((0, $cXBIA.dimensions).small);
var $5c4a4993823e2e08$var$mediumStyles = (0, $avKww.css)((0, $cXBIA.dimensions).medium);
var $5c4a4993823e2e08$var$largeStyles = (0, $avKww.css)((0, $cXBIA.dimensions).large);
var $5c4a4993823e2e08$var$xlargeStyles = (0, $avKww.css)((0, $cXBIA.dimensions).xlarge);
var $5c4a4993823e2e08$export$ef0ad74202575b64 = {
    small: $5c4a4993823e2e08$var$smallStyles,
    medium: $5c4a4993823e2e08$var$mediumStyles,
    large: $5c4a4993823e2e08$var$largeStyles,
    xlarge: $5c4a4993823e2e08$var$xlargeStyles
};
var $5c4a4993823e2e08$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $cXBIA.dimensions)[size];
    return undefined;
};

});
parcelRegister("cXBIA", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $96f840c6adeff96a$export$62ad7b0c781000e9; });
var $96f840c6adeff96a$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $96f840c6adeff96a$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $96f840c6adeff96a$export$62ad7b0c781000e9 = {
    small: {
        width: $96f840c6adeff96a$export$c647cb0ee6e282fe.small,
        height: $96f840c6adeff96a$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $96f840c6adeff96a$export$c647cb0ee6e282fe.medium,
        height: $96f840c6adeff96a$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $96f840c6adeff96a$export$c647cb0ee6e282fe.large,
        height: $96f840c6adeff96a$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $96f840c6adeff96a$export$c647cb0ee6e282fe.xlarge,
        height: $96f840c6adeff96a$export$c647cb0ee6e282fe.xlarge
    }
};

});







parcelRegister("2sKZp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cb2a56fbeeda50a$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $867YB = parcelRequire("867YB");
function $1cb2a56fbeeda50a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1cb2a56fbeeda50a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $1cb2a56fbeeda50a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $1cb2a56fbeeda50a$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(Label, _Component);
    var _super = $1cb2a56fbeeda50a$var$_createSuper(Label);
    function Label() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, Label);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(Label, [
        {
            key: "render",
            value: /* eslint-disable jsx-a11y/no-static-element-interactions */ function render() {
                var _this$props = this.props, appearance = _this$props.appearance, children = _this$props.children, htmlFor = _this$props.htmlFor, isFirstChild = _this$props.isFirstChild, isLabelHidden = _this$props.isLabelHidden, isDisabled = _this$props.isDisabled, isRequired = _this$props.isRequired, label = _this$props.label, onClick = _this$props.onClick;
                /* eslint-disable jsx-a11y/click-events-have-key-events */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $867YB.LabelWrapper), {
                    htmlFor: htmlFor
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $867YB.LabelInner), {
                    isHidden: isLabelHidden,
                    inlineEdit: appearance === "inline-edit",
                    firstChild: isFirstChild,
                    isDisabled: isDisabled
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", {
                    onClick: onClick
                }, label), isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $867YB.RequiredIndicator), {
                    role: "presentation"
                }, "*") : null), children);
            }
        }
    ]);
    return Label;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($1cb2a56fbeeda50a$export$2e2bcd8739ae039, "defaultProps", {
    appearance: "default"
});

});
parcelRegister("867YB", function(module, exports) {

$parcel$export(module.exports, "LabelWrapper", function () { return $5e55123e12d30f4d$export$147422f7450ccfac; });
$parcel$export(module.exports, "LabelInner", function () { return $5e55123e12d30f4d$export$6aeb05cc9e9b5063; });
$parcel$export(module.exports, "RequiredIndicator", function () { return $5e55123e12d30f4d$export$b36d93bade3250e4; });

var $13MK1 = parcelRequire("13MK1");

var $kD01A = parcelRequire("kD01A");

var $aP6k3 = parcelRequire("aP6k3");

var $jp7ng = parcelRequire("jp7ng");
var $5e55123e12d30f4d$var$spacing = (0, $aP6k3.gridSize)();
var $5e55123e12d30f4d$var$fontSize = 12;
var $5e55123e12d30f4d$var$innerHeight = $5e55123e12d30f4d$var$spacing * 2; // 16px
var $5e55123e12d30f4d$var$lineHeight = $5e55123e12d30f4d$var$innerHeight / $5e55123e12d30f4d$var$fontSize;
var $5e55123e12d30f4d$var$getPadding = function getPadding(_ref) {
    var firstChild = _ref.firstChild, inlineEdit = _ref.inlineEdit;
    var right = 0;
    var bottom = $5e55123e12d30f4d$var$spacing / 2;
    var left = 0;
    var top = $5e55123e12d30f4d$var$spacing * 2.5;
    if (inlineEdit) {
        bottom = 0;
        left = $5e55123e12d30f4d$var$spacing;
        top = $5e55123e12d30f4d$var$spacing;
    }
    if (firstChild) top = $5e55123e12d30f4d$var$spacing / 2;
    return (0, $13MK1.css)([
        "\n    padding: ",
        "px ",
        "px ",
        "px ",
        "px;\n  "
    ], top, right, bottom, left);
};
var $5e55123e12d30f4d$export$147422f7450ccfac = (0, $13MK1.default).label.withConfig({
    displayName: "Label__LabelWrapper",
    componentId: "sc-17towfw-0"
})([
    "\n  display: block;\n"
]);
var $5e55123e12d30f4d$var$getColor = (0, $kD01A.default)({
    light: (0, $jp7ng.N200),
    dark: (0, $jp7ng.DN90)
});
var $5e55123e12d30f4d$var$getDisabledColor = (0, $kD01A.default)({
    light: (0, $jp7ng.N60),
    dark: (0, $jp7ng.DN300)
});
var $5e55123e12d30f4d$export$6aeb05cc9e9b5063 = (0, $13MK1.default).div.withConfig({
    displayName: "Label__LabelInner",
    componentId: "sc-17towfw-1"
})([
    "\n  color: ",
    ";\n  font-size: ",
    "px;\n  font-weight: 600;\n  line-height: ",
    ";\n  ",
    ";\n\n  ",
    ";\n"
], function(props) {
    return props.isDisabled ? $5e55123e12d30f4d$var$getDisabledColor(props) : $5e55123e12d30f4d$var$getColor(props);
}, $5e55123e12d30f4d$var$fontSize, $5e55123e12d30f4d$var$lineHeight, $5e55123e12d30f4d$var$getPadding, function(p) {
    return p.isHidden && "display: none;";
});
var $5e55123e12d30f4d$export$b36d93bade3250e4 = (0, $13MK1.default).span.withConfig({
    displayName: "Label__RequiredIndicator",
    componentId: "sc-17towfw-2"
})([
    "\n  color: ",
    ";\n  padding-left: 2px;\n"
], (0, $jp7ng.red));

});


parcelRegister("gPZYo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4217b5755a1475c$export$2e2bcd8739ae039; });

var $13MK1 = parcelRequire("13MK1");

var $kD01A = parcelRequire("kD01A");

var $aP6k3 = parcelRequire("aP6k3");

var $jp7ng = parcelRequire("jp7ng");
var $c4217b5755a1475c$var$getPlaceholderColor = function getPlaceholderColor(_ref) {
    var disabled = _ref.disabled;
    if (disabled) return (0, $kD01A.default)({
        light: (0, $jp7ng.N70),
        dark: (0, $jp7ng.DN90)
    });
    return (0, $kD01A.default)({
        light: (0, $jp7ng.N100),
        dark: (0, $jp7ng.DN90)
    });
}; // can't group these placeholder styles into one block because browsers drop
// entire style blocks when any single selector fails to parse
var $c4217b5755a1475c$var$getPlaceholderStyle = function getPlaceholderStyle() {
    return (0, $13MK1.css)([
        "\n  &::-webkit-input-placeholder {\n    /* WebKit, Blink, Edge */\n    color: ",
        ";\n  }\n  &::-moz-placeholder {\n    /* Mozilla Firefox 19+ */\n    color: ",
        ";\n    opacity: 1;\n  }\n  &::-ms-input-placeholder {\n    /* Microsoft Edge */\n    color: ",
        ";\n  }\n  &:-ms-input-placeholder {\n    /* Internet Explorer 10-11 */\n    color: ",
        ";\n  }\n"
    ], $c4217b5755a1475c$var$getPlaceholderColor, $c4217b5755a1475c$var$getPlaceholderColor, $c4217b5755a1475c$var$getPlaceholderColor, $c4217b5755a1475c$var$getPlaceholderColor);
}; // Safari puts on some difficult to remove styles, mainly for disabled inputs
// but we want full control so need to override them in all cases
var $c4217b5755a1475c$var$overrideSafariDisabledStyles = "\n  -webkit-text-fill-color: unset;\n  -webkit-opacity: 1;\n";
var $c4217b5755a1475c$var$InputElement = (0, $13MK1.default).input.withConfig({
    displayName: "Input__InputElement",
    componentId: "sc-1o6bj35-0"
})([
    "\n  background: transparent;\n  border: 0;\n  box-sizing: border-box;\n  color: inherit;\n  cursor: inherit;\n  font-family: ",
    ";\n  font-size: ",
    "px;\n  min-width: 0;\n  outline: none;\n  width: 100%;\n\n  [disabled] {\n    ",
    ";\n  }\n\n  &::-ms-clear {\n    display: none;\n  }\n\n  &:invalid {\n    box-shadow: none;\n  }\n  ",
    ";\n"
], function(p) {
    return p.isMonospaced ? (0, $aP6k3.codeFontFamily)() : "inherit";
}, (0, $aP6k3.fontSize), $c4217b5755a1475c$var$overrideSafariDisabledStyles, $c4217b5755a1475c$var$getPlaceholderStyle);
var $c4217b5755a1475c$export$2e2bcd8739ae039 = $c4217b5755a1475c$var$InputElement;

});


parcelRegister("lepT7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f74efc94726d721c$export$2e2bcd8739ae039; });

var $6zUw7 = parcelRequire("6zUw7");

var $94Io2 = parcelRequire("94Io2");
var $enW9H = parcelRequire("enW9H");
var $hqV46 = parcelRequire("hqV46");

var $i04lD = parcelRequire("i04lD");
var $f74efc94726d721c$var$packageName = "@atlaskit/select";
var $f74efc94726d721c$var$packageVersion = "16.7.6";
var $f74efc94726d721c$export$d1de3b251ccaa8a3 = (0, $i04lD.default)((0, $6zUw7.default));
var $f74efc94726d721c$var$createAndFireEventOnAtlaskit = (0, $94Io2.default)("atlaskit");
var $f74efc94726d721c$export$2e2bcd8739ae039 = (0, $enW9H.default)({
    componentName: "select",
    packageName: $f74efc94726d721c$var$packageName,
    packageVersion: $f74efc94726d721c$var$packageVersion
})((0, $hqV46.default)({
    onChange: $f74efc94726d721c$var$createAndFireEventOnAtlaskit({
        action: "changed",
        actionSubject: "option",
        attributes: {
            componentName: "select",
            packageName: $f74efc94726d721c$var$packageName,
            packageVersion: $f74efc94726d721c$var$packageVersion
        }
    })
})($f74efc94726d721c$export$d1de3b251ccaa8a3));

});
parcelRegister("6zUw7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ca1da0ce03b1ec3$export$2e2bcd8739ae039; });

var $kIN0M = parcelRequire("kIN0M");

var $ii97e = parcelRequire("ii97e");

var $9nHZC = parcelRequire("9nHZC");

var $bpHvF = parcelRequire("bpHvF");

var $hp0gY = parcelRequire("hp0gY");

var $3hca7 = parcelRequire("3hca7");

var $dUfie = parcelRequire("dUfie");
parcelRequire("aHkQz");
parcelRequire("9q1kH");
parcelRequire("lOQkO");
parcelRequire("uqRmf");
parcelRequire("eVDe4");
parcelRequire("3BD5g");
parcelRequire("d7Kxt");
parcelRequire("b4Ivn");

parcelRequire("340K4");
parcelRequire("hlgjl");
parcelRequire("kFnE9");
parcelRequire("lnOmc");

parcelRequire("05GjO");
var $4ca1da0ce03b1ec3$var$StateManagedSelect = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $kIN0M.u)(props);
    return /*#__PURE__*/ $9nHZC.createElement((0, $bpHvF.S), (0, $ii97e.default)({
        ref: ref
    }, baseSelectProps));
});
var $4ca1da0ce03b1ec3$export$2e2bcd8739ae039 = $4ca1da0ce03b1ec3$var$StateManagedSelect;
var $4ca1da0ce03b1ec3$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $9nHZC.useMemo)(function() {
        return (0, $3hca7.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $9nHZC.createElement((0, $hp0gY.C), {
        value: emotionCache
    }, children);
};

});

parcelRegister("94Io2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69b6eb10f94db548$export$2e2bcd8739ae039; });
var $69b6eb10f94db548$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};

});

parcelRegister("enW9H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a79053218fa9a3ad$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $lcMMy = parcelRequire("lcMMy");
var $a79053218fa9a3ad$var$_excluded = [
    "analyticsContext"
];
function $a79053218fa9a3ad$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a79053218fa9a3ad$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a79053218fa9a3ad$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a79053218fa9a3ad$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a79053218fa9a3ad$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $a79053218fa9a3ad$var$_excluded);
            var analyticsData = (0, $9nHZC.useMemo)(function() {
                return $a79053218fa9a3ad$var$_objectSpread($a79053218fa9a3ad$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $lcMMy.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
                ref: ref
            })));
        });
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $a79053218fa9a3ad$export$2e2bcd8739ae039 = $a79053218fa9a3ad$var$withAnalyticsContext;

});
parcelRegister("lcMMy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7008f14e0bfe8af$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $dEQSq = parcelRequire("dEQSq");

var $iWYsd = parcelRequire("iWYsd");

var $ksWr2 = parcelRequire("ksWr2");

var $8ovux = parcelRequire("8ovux");
var $f7008f14e0bfe8af$var$ExportedAnalyticsContext = function ExportedAnalyticsContext(props) {
    var _process$env;
    var isModernContextEnabledEnv = typeof $8ovux !== "undefined" && $8ovux !== null && ((_process$env = {}, _process$env === void 0) ? void 0 : _process$env["ANALYTICS_NEXT_MODERN_CONTEXT"]);
    return isModernContextEnabledEnv || (0, $dEQSq.getBooleanFF)("platform.analytics-next-use-modern-context_fqgbx") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ksWr2.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $iWYsd.default), props);
};
var $f7008f14e0bfe8af$export$2e2bcd8739ae039 = $f7008f14e0bfe8af$var$ExportedAnalyticsContext;

});
parcelRegister("iWYsd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcbc89b09de8210b$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");

var $kZnbM = parcelRequire("kZnbM");
function $dcbc89b09de8210b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $dcbc89b09de8210b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $dcbc89b09de8210b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dcbc89b09de8210b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $dcbc89b09de8210b$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func
};
var $dcbc89b09de8210b$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $dcbc89b09de8210b$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(AnalyticsContext, _Component);
    var _super = $dcbc89b09de8210b$var$_createSuper(AnalyticsContext);
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsContext);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $dcbc89b09de8210b$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $dcbc89b09de8210b$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kZnbM.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsContext;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($dcbc89b09de8210b$var$AnalyticsContext, "contextTypes", $dcbc89b09de8210b$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($dcbc89b09de8210b$var$AnalyticsContext, "childContextTypes", $dcbc89b09de8210b$var$ContextTypes);
var $dcbc89b09de8210b$export$2e2bcd8739ae039 = $dcbc89b09de8210b$var$AnalyticsContext;

});

parcelRegister("ksWr2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee63c0255621f0c3$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");

var $ihzJ2 = parcelRequire("ihzJ2");

var $hFZIh = parcelRequire("hFZIh");
var $ee63c0255621f0c3$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $hFZIh.useTrackedRef)(data);
    var analyticsContext = (0, $ihzJ2.useAnalyticsContext)();
    var getAtlaskitAnalyticsContext = (0, $9nHZC.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(analyticsContext.getAtlaskitAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        analyticsContext,
        dataRef
    ]);
    var value = (0, $9nHZC.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: analyticsContext.getAtlaskitAnalyticsEventHandlers
        };
    }, [
        analyticsContext,
        getAtlaskitAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kZnbM.default).Provider, {
        value: value
    }, children);
};
var $ee63c0255621f0c3$export$2e2bcd8739ae039 = $ee63c0255621f0c3$var$AnalyticsContext;

});
parcelRegister("ihzJ2", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $d4f586d5cf7932b1$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $d4f586d5cf7932b1$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});

parcelRegister("hFZIh", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $cde622fbcb04c0c1$export$1d27a74659855e44; });

var $9nHZC = parcelRequire("9nHZC");
var $cde622fbcb04c0c1$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    ref.current = value;
    return ref;
};

});




parcelRegister("hqV46", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb112150f148cf99$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $1MRzF = parcelRequire("1MRzF");

var $7l6Uo = parcelRequire("7l6Uo");
var $cb112150f148cf99$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(props, ref) {
            var _usePatchedProps = (0, $7l6Uo.usePatchedProps)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $1MRzF.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $cb112150f148cf99$export$2e2bcd8739ae039 = $cb112150f148cf99$var$withAnalyticsEvents;

});
parcelRegister("1MRzF", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $14d3d4de6305cd56$export$5bf35293e545f20c; });

var $dNznA = parcelRequire("dNznA");

var $b8KUe = parcelRequire("b8KUe");

var $ihzJ2 = parcelRequire("ihzJ2");
function $14d3d4de6305cd56$export$5bf35293e545f20c() {
    var analyticsContext = (0, $ihzJ2.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $b8KUe.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("b8KUe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81c4d3a32ab7dea3$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $h4Jbr = parcelRequire("h4Jbr");
function $81c4d3a32ab7dea3$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $81c4d3a32ab7dea3$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $81c4d3a32ab7dea3$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($81c4d3a32ab7dea3$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $81c4d3a32ab7dea3$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $81c4d3a32ab7dea3$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $81c4d3a32ab7dea3$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $81c4d3a32ab7dea3$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $h4Jbr.default));

});
parcelRegister("h4Jbr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6e5dbe17490329d$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
function $c6e5dbe17490329d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c6e5dbe17490329d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c6e5dbe17490329d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c6e5dbe17490329d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c6e5dbe17490329d$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $c6e5dbe17490329d$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $c6e5dbe17490329d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $c6e5dbe17490329d$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(updater) === "object") this.payload = $c6e5dbe17490329d$var$_objectSpread($c6e5dbe17490329d$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});



parcelRegister("7l6Uo", function(module, exports) {

$parcel$export(module.exports, "usePatchedProps", function () { return $557fda78739bab90$export$9ebb5a84d17e5d18; });

var $kFnE9 = parcelRequire("kFnE9");

var $340K4 = parcelRequire("340K4");

var $9nHZC = parcelRequire("9nHZC");

var $1MRzF = parcelRequire("1MRzF");
function $557fda78739bab90$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $557fda78739bab90$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $557fda78739bab90$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $557fda78739bab90$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $557fda78739bab90$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $1MRzF.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $9nHZC.useRef)({});
    var patchedProps = (0, $9nHZC.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                "object",
                "function"
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $557fda78739bab90$var$_objectSpread($557fda78739bab90$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === "function" ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === "function") {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $557fda78739bab90$var$_objectSpread($557fda78739bab90$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});



parcelRegister("a7A34", function(module, exports) {

$parcel$export(module.exports, "BuildStatus", function () { return (parcelRequire("b0Ym4")).default; });
$parcel$export(module.exports, "BuildSummary", function () { return (parcelRequire("g8VL3")).default; });
$parcel$export(module.exports, "LazyBuildStatus", function () { return (parcelRequire("7f5Qo")).default; });
parcelRequire("l2p0E");
var $b0Ym4 = parcelRequire("b0Ym4");
parcelRequire("fHSyv");
var $g8VL3 = parcelRequire("g8VL3");

var $7f5Qo = parcelRequire("7f5Qo");

});
parcelRegister("l2p0E", function(module, exports) {

$parcel$export(module.exports, "BuildStatus", function () { return (parcelRequire("b0Ym4")).default; });

var $b0Ym4 = parcelRequire("b0Ym4");

});
parcelRegister("b0Ym4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d984a74dba5320b3$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("fHSyv");
var $g8VL3 = parcelRequire("g8VL3");

var $geiTy = parcelRequire("geiTy");

var $skg5C = parcelRequire("skg5C");
// @ts-ignore TODO: fix noImplicitAny error here
function $d984a74dba5320b3$var$getBuildCounts(builds) {
    const statuses = {
        FAILED: 0,
        INPROGRESS: 0,
        STOPPED: 0,
        SUCCESSFUL: 0
    };
    // @ts-ignore TODO: fix noImplicitAny error here
    return builds.reduce((acc, build)=>{
        acc[build.state] += 1;
        return acc;
    }, statuses);
}
var $d984a74dba5320b3$export$2e2bcd8739ae039;
$d984a74dba5320b3$export$2e2bcd8739ae039 = class BuildStatusComponent extends (0, $9nHZC.Component) {
    constructor(...args){
        super(...args);
        this.state = {
            isDialogOpen: false
        };
        this.onTrigger = ()=>{
            this.setState({
                isDialogOpen: true
            });
        };
        this.onCloseDialog = ()=>{
            this.setState({
                isDialogOpen: false
            });
        };
    }
    render() {
        const { builds: builds, iconSize: iconSize, showIcon: showIcon } = this.props;
        const { isDialogOpen: isDialogOpen } = this.state;
        if (!builds || !builds.length) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $skg5C.default), {
            buildCounts: $d984a74dba5320b3$var$getBuildCounts(builds),
            onTrigger: this.onTrigger,
            showIcon: showIcon,
            iconSize: iconSize
        }), isDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $geiTy.BuildStatusModalDialog), {
            onClose: this.onCloseDialog
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $g8VL3.default), {
            builds: builds
        })));
    }
};

});
parcelRegister("fHSyv", function(module, exports) {

$parcel$export(module.exports, "BuildSummary", function () { return (parcelRequire("g8VL3")).default; });

var $g8VL3 = parcelRequire("g8VL3");

});
parcelRegister("g8VL3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85495a683ddaa4b3$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $6nS7n = parcelRequire("6nS7n");
var $85495a683ddaa4b3$export$2e2bcd8739ae039;
$85495a683ddaa4b3$export$2e2bcd8739ae039 = class BuildSummary extends (0, $9nHZC.Component) {
    render() {
        const { builds: builds, shouldSort: shouldSort } = this.props;
        if (shouldSort) {
            const stateOrder = [
                "FAILED",
                "STOPPED",
                "INPROGRESS",
                "SUCCESSFUL"
            ];
            builds.sort((a, b)=>{
                const aState = stateOrder.indexOf(a.state);
                const bState = stateOrder.indexOf(b.state);
                if (aState !== bState) return aState - bState;
                // `numeric` option sorts numbers nicely, e.g. "1", "2", "10" (instead of string sort "1", "10", "2")
                const nameCmp = a.name.localeCompare(b.name, undefined, {
                    numeric: true
                });
                if (nameCmp !== 0) return nameCmp;
                // Fall back to key if name and state are the same
                return a.key.localeCompare(b.key, undefined, {
                    numeric: true
                });
            });
        }
        return builds.map((build)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6nS7n.Build), {
                key: build.key,
                build: build
            }));
    }
};
$85495a683ddaa4b3$export$2e2bcd8739ae039.defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */ builds: [],
    shouldSort: true
};

});
parcelRegister("6nS7n", function(module, exports) {

$parcel$export(module.exports, "Build", function () { return $f398f7331edef24b$export$77b5f1d340d6466b; });

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $5eELe = parcelRequire("5eELe");

var $4dJkZ = parcelRequire("4dJkZ");

var $50dHR = parcelRequire("50dHR");

var $9hjCt = parcelRequire("9hjCt");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");
parcelRequire("l8rpz");
var $eQRm3 = parcelRequire("eQRm3");

var $fcRKi = parcelRequire("fcRKi");

var $9ueSe = parcelRequire("9ueSe");
const $f398f7331edef24b$var$BUILD_STATUS_ICON_LABELS = new Map([
    [
        "SUCCESSFUL",
        (0, $fcRKi.default).successfulStatusIcon
    ],
    [
        "STOPPED",
        (0, $fcRKi.default).stoppedStatusIcon
    ],
    [
        "FAILED",
        (0, $fcRKi.default).failedStatusIcon
    ],
    [
        "INPROGRESS",
        (0, $fcRKi.default).inProgressStatusIcon
    ]
]);
class $f398f7331edef24b$var$BuildComponent extends (0, $9nHZC.Component) {
    constructor(...args){
        super(...args);
        this.getStatusIcon = (buildState)=>{
            const message = $f398f7331edef24b$var$BUILD_STATUS_ICON_LABELS.get(buildState);
            let label = "";
            if (message) label = this.props.intl.formatMessage(message);
            switch(buildState){
                case "SUCCESSFUL":
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5eELe))), {
                        label: label,
                        primaryColor: (0, $h39Sh.default)("color.icon.success", (0, $jp7ng).G300)
                    });
                case "STOPPED":
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9hjCt))), {
                        label: label,
                        primaryColor: (0, $h39Sh.default)("color.icon.accent.yellow", (0, $jp7ng).Y400)
                    });
                case "FAILED":
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4dJkZ))), {
                        label: label,
                        primaryColor: (0, $h39Sh.default)("color.icon.danger", (0, $jp7ng).R400)
                    });
                case "INPROGRESS":
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($50dHR))), {
                        label: label,
                        primaryColor: (0, $h39Sh.default)("color.icon.information", (0, $jp7ng).B300)
                    });
                default:
                    return null;
            }
        };
    }
    render() {
        const { build: build } = this.props;
        const buildName = build.name || build.key;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($9ueSe.BuildItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($9ueSe.BuildState, null, this.getStatusIcon(build.state)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($9ueSe.BuildInfo, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($9ueSe.BuildName, {
            title: buildName
        }, build.url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("a", {
            href: build.url
        }, buildName) : buildName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($9ueSe.BuildDetails, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($9ueSe.BuildDescription, {
            title: build.description
        }, build.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($9ueSe.BuildTime, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eQRm3.default), {
            date: build.updated_on
        })))));
    }
}
const $f398f7331edef24b$export$77b5f1d340d6466b = (0, $agjvf.injectIntl)($f398f7331edef24b$var$BuildComponent);

});
parcelRegister("fcRKi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d6f02c38fbf2139$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $9d6f02c38fbf2139$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    buildDialogCloseButton: {
        "id": "bitkit.builds.buildDialogCloseButton",
        "defaultMessage": "Close"
    },
    tooltipFailedStatus: {
        "id": "bitkit.builds.tooltipFailed",
        "defaultMessage": "{count, number} of {total} failed"
    },
    tooltipPassedStatus: {
        "id": "bitkit.builds.tooltipSuccess",
        "defaultMessage": "{count, number} of {total} passed"
    },
    successfulStatusIcon: {
        "id": "bitkit.builds.successfulIcon",
        "defaultMessage": "Successful"
    },
    stoppedStatusIcon: {
        "id": "bitkit.builds.stoppedIcon",
        "defaultMessage": "Stopped"
    },
    failedStatusIcon: {
        "id": "bitkit.builds.failedIcon",
        "defaultMessage": "Failed"
    },
    inProgressStatusIcon: {
        "id": "bitkit.builds.inProgressIcon",
        "defaultMessage": "In progress"
    },
    buildSummaryDialogHeading: {
        "id": "bitkit.builds.buildSummaryDialogHeading",
        "defaultMessage": "Builds"
    },
    buttonLabel: {
        "id": "bitkit.builds.buttonLabel",
        "defaultMessage": "{count, plural, one {{count} build} other {{count} builds}}"
    },
    buildInformationButtonLabel: {
        "id": "bitkit.builds.buildInformationButtonLabel",
        "defaultMessage": "Build information"
    }
});

});

parcelRegister("9ueSe", function(module, exports) {

$parcel$export(module.exports, "BuildInfo", function () { return $e43e63b69342fa8f$export$97f739d4bfd2c637; });
$parcel$export(module.exports, "BuildItem", function () { return $e43e63b69342fa8f$export$ad240479eb89fb45; });
$parcel$export(module.exports, "BuildName", function () { return $e43e63b69342fa8f$export$852ecfed39811481; });
$parcel$export(module.exports, "BuildState", function () { return $e43e63b69342fa8f$export$2882c67643beb37e; });
$parcel$export(module.exports, "BuildDescription", function () { return $e43e63b69342fa8f$export$fd1d345b2ad1f83f; });
$parcel$export(module.exports, "BuildTime", function () { return $e43e63b69342fa8f$export$70a6d6f4ad198f32; });
$parcel$export(module.exports, "BuildDetails", function () { return $e43e63b69342fa8f$export$3b5f3a88912a7e13; });
$parcel$export(module.exports, "DialogTitle", function () { return $e43e63b69342fa8f$export$16f7638e4a34b909; });
$parcel$export(module.exports, "DialogContainer", function () { return $e43e63b69342fa8f$export$547754aada6e339f; });

var $2xJU3 = parcelRequire("2xJU3");

var $3qXIy = parcelRequire("3qXIy");

var $aP6k3 = parcelRequire("aP6k3");
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */ function $e43e63b69342fa8f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e43e63b69342fa8f$var$WRAP_MARGIN = (0, $aP6k3.gridSize)() / 4;
const $e43e63b69342fa8f$export$7f6458e4051f9103 = (0, $2xJU3.default)("div", {
    target: "e11gw9gu0"
})({
    display: "flex",
    flexFlow: "column",
    padding: `${(0, $aP6k3.gridSize)()}px`
}, "");
const $e43e63b69342fa8f$export$97f739d4bfd2c637 = (0, $2xJU3.default)("div", {
    target: "e11gw9gu1"
})({
    minWidth: 0,
    padding: `${(0, $aP6k3.gridSize)() / 4}px`
}, "");
const $e43e63b69342fa8f$export$ad240479eb89fb45 = (0, $2xJU3.default)("div", {
    target: "e11gw9gu2"
})({
    display: "flex",
    alignItems: "center",
    paddingBottom: `${(0, $aP6k3.gridSize)()}px`
}, "");
const $e43e63b69342fa8f$export$852ecfed39811481 = (0, $2xJU3.default)("div", {
    target: "e11gw9gu3"
})({
    display: "inline-block",
    verticalAlign: "bottom",
    maxWidth: "100%",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    marginBottom: `${(0, $aP6k3.gridSize)() / 2}px`,
    overflow: "hidden"
}, "");
const $e43e63b69342fa8f$export$2882c67643beb37e = (0, $2xJU3.default)("div", {
    target: "e11gw9gu4"
})({
    flex: "0 0 auto",
    marginRight: `${(0, $aP6k3.gridSize)()}px`
}, "");
const $e43e63b69342fa8f$export$fd1d345b2ad1f83f = (0, $2xJU3.default)("small", {
    target: "e11gw9gu5"
})({
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    display: "block",
    marginTop: `${$e43e63b69342fa8f$var$WRAP_MARGIN}px`,
    "&::after": {
        content: "'\xb7'",
        width: `${(0, $aP6k3.gridSize)() * 2}px`,
        display: "inline-block",
        textAlign: "center"
    },
    "&:empty::after": {
        display: "none"
    }
}, "");
const $e43e63b69342fa8f$export$70a6d6f4ad198f32 = (0, $2xJU3.default)("small", {
    target: "e11gw9gu6"
})({
    marginTop: `${$e43e63b69342fa8f$var$WRAP_MARGIN}px`
}, "");
const $e43e63b69342fa8f$export$3b5f3a88912a7e13 = (0, $2xJU3.default)("div", {
    target: "e11gw9gu7"
})({
    display: "flex",
    flexWrap: "wrap",
    marginTop: `-${$e43e63b69342fa8f$var$WRAP_MARGIN}px`
}, "");
const $e43e63b69342fa8f$export$16f7638e4a34b909 = /*#__PURE__*/ (0, $2xJU3.default)((0, $3qXIy.default), {
    target: "e11gw9gu8"
})({
    name: "z7mtfw",
    styles: "display:flex;justify-content:space-between;width:100%;"
});
const $e43e63b69342fa8f$export$547754aada6e339f = (0, $2xJU3.default)("div", {
    target: "e11gw9gu9"
})({
    paddingBottom: `${(0, $aP6k3.gridSize)() * 1.75}px`
}, "");

});




parcelRegister("geiTy", function(module, exports) {

$parcel$export(module.exports, "BuildStatusModalDialog", function () { return $99ac6411cee6c988$export$38e786c68e4a26cf; });

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $3THTN = parcelRequire("3THTN");

var $4AmPv = parcelRequire("4AmPv");

var $cGPG3 = parcelRequire("cGPG3");
var $ljrFr = parcelRequire("ljrFr");
var $DPG6Z = parcelRequire("DPG6Z");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $fcRKi = parcelRequire("fcRKi");

var $9ueSe = parcelRequire("9ueSe");
const $99ac6411cee6c988$var$DialogHeader = (0, $agjvf.injectIntl)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo((props)=>{
    const { onClose: onClose, intl: intl } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $DPG6Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9ueSe.DialogTitle), null, intl.formatMessage((0, $fcRKi.default).buildSummaryDialogHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3THTN.default), {
        onClick: onClose,
        appearance: "subtle",
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4AmPv))), {
            label: intl.formatMessage((0, $fcRKi.default).buildDialogCloseButton),
            primaryColor: (0, $h39Sh.default)("color.icon", (0, $jp7ng).N800)
        })
    }));
}));
const $99ac6411cee6c988$export$38e786c68e4a26cf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $cGPG3.default), {
        width: "medium",
        onClose: props.onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9ueSe.DialogContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($99ac6411cee6c988$var$DialogHeader, {
        onClose: props.onClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ljrFr.default), null, props.children))));

});
parcelRegister("4AmPv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $356c3bb78be959df$var$_react = $356c3bb78be959df$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $356c3bb78be959df$var$_close = $356c3bb78be959df$var$_interopRequireDefault((parcelRequire("hKCfl")));
function $356c3bb78be959df$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $356c3bb78be959df$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $356c3bb78be959df$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $356c3bb78be959df$var$_close.default
    }));
$356c3bb78be959df$var$EditorCloseIcon.displayName = "EditorCloseIcon";
var $356c3bb78be959df$var$_default = module.exports.default = $356c3bb78be959df$var$EditorCloseIcon;

});


parcelRegister("skg5C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b66818ba203b794a$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $EKmRU = parcelRequire("EKmRU");

var $5eELe = parcelRequire("5eELe");

var $4dJkZ = parcelRequire("4dJkZ");

var $50dHR = parcelRequire("50dHR");

var $jp7ng = parcelRequire("jp7ng");

var $a7iuM = parcelRequire("a7iuM");

var $fcRKi = parcelRequire("fcRKi");
class $b66818ba203b794a$var$Trigger extends (0, $9nHZC.Component) {
    render() {
        const { buildCounts: buildCounts, iconSize: iconSize, onTrigger: onTrigger, isLoading: isLoading, intl: intl, showIcon: showIcon } = this.props;
        const { FAILED: FAILED, INPROGRESS: INPROGRESS, STOPPED: STOPPED, SUCCESSFUL: SUCCESSFUL } = buildCounts;
        const total = FAILED + INPROGRESS + STOPPED + SUCCESSFUL;
        let IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($5eELe)));
        let tooltipLabel = intl.formatMessage((0, $fcRKi.default).tooltipPassedStatus, {
            count: SUCCESSFUL,
            total: total
        });
        let primaryColor = (0, $jp7ng).G400;
        if (FAILED) {
            tooltipLabel = intl.formatMessage((0, $fcRKi.default).tooltipFailedStatus, {
                count: FAILED,
                total: total
            });
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($4dJkZ)));
            primaryColor = (0, $jp7ng).R400;
        } else if (STOPPED) {
            tooltipLabel = intl.formatMessage((0, $fcRKi.default).tooltipPassedStatus, {
                count: SUCCESSFUL,
                total: total
            });
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($4dJkZ)));
            primaryColor = (0, $jp7ng).R400;
        } else if (INPROGRESS) {
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($50dHR)));
            primaryColor = (0, $jp7ng).B300;
        }
        const BuildIcon = showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(IconComponent, {
            size: iconSize,
            label: tooltipLabel,
            primaryColor: primaryColor
        }) : undefined;
        const buttonLabel = !showIcon ? intl.formatMessage((0, $fcRKi.default).buttonLabel, {
            count: total
        }) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $a7iuM.default), {
            content: tooltipLabel,
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $EKmRU.default), {
            onClick: onTrigger,
            isLoading: isLoading,
            appearance: "link",
            spacing: showIcon ? "default" : "none",
            iconBefore: BuildIcon,
            "aria-label": intl.formatMessage((0, $fcRKi.default).buildInformationButtonLabel)
        }, buttonLabel));
    }
}
$b66818ba203b794a$var$Trigger.defaultProps = {
    showIcon: true
};
var $b66818ba203b794a$export$2e2bcd8739ae039 = (0, $agjvf.injectIntl)($b66818ba203b794a$var$Trigger);

});



parcelRegister("7f5Qo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7efa7a7a26c5833c$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $skg5C = parcelRequire("skg5C");
parcelRequire("fHSyv");
var $g8VL3 = parcelRequire("g8VL3");

var $geiTy = parcelRequire("geiTy");
const $7efa7a7a26c5833c$var$totalBuilds = (buildCounts)=>{
    const { FAILED: FAILED, INPROGRESS: INPROGRESS, STOPPED: STOPPED, SUCCESSFUL: SUCCESSFUL } = buildCounts;
    return FAILED + INPROGRESS + STOPPED + SUCCESSFUL;
};
const $7efa7a7a26c5833c$var$isBuildCountsEqual = (a, b)=>// @ts-ignore TODO: fix noImplicitAny error here
    Object.keys(a).every((key)=>a[key] === b[key]);
class $7efa7a7a26c5833c$var$LazyBuildStatus extends (0, $9nHZC.Component) {
    constructor(...args){
        super(...args);
        this.state = {
            isDialogOpen: false,
            isLoadingBuilds: false,
            builds: [],
            lastCounts: this.props.buildCounts
        };
        this.onTrigger = ()=>{
            if (this.state.builds.length) {
                this.setState({
                    isDialogOpen: true
                });
                return;
            }
            this.setState({
                isLoadingBuilds: true
            });
            this.props.loadBuilds().then((builds)=>{
                // Check to see if we have a real array of builds.
                // Maybe the consumer caught an error and forgot to return
                // anything to us
                if (Array.isArray(builds) && builds.length) this.setState({
                    builds: builds,
                    isLoadingBuilds: false,
                    isDialogOpen: true
                });
                else this.setState({
                    isLoadingBuilds: false
                });
            }).catch(()=>{
                this.setState({
                    isLoadingBuilds: false
                });
            });
        };
        this.onCloseDialog = ()=>{
            this.setState({
                isDialogOpen: false
            });
        };
    }
    static getDerivedStateFromProps(props, state) {
        // If we got new build counts, reset the list of full builds.
        if (!$7efa7a7a26c5833c$var$isBuildCountsEqual(props.buildCounts, state.lastCounts)) return {
            ...state,
            builds: [],
            lastCounts: props.buildCounts
        };
        return null;
    }
    render() {
        const { isDialogOpen: isDialogOpen, isLoadingBuilds: isLoadingBuilds, builds: builds } = this.state;
        const { buildCounts: buildCounts, iconSize: iconSize, showIcon: showIcon } = this.props;
        const buildCount = $7efa7a7a26c5833c$var$totalBuilds(buildCounts);
        if (!buildCount) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $skg5C.default), {
            buildCounts: buildCounts,
            onTrigger: this.onTrigger,
            isLoading: isLoadingBuilds,
            showIcon: showIcon,
            iconSize: iconSize
        }), isDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $geiTy.BuildStatusModalDialog), {
            onClose: this.onCloseDialog
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $g8VL3.default), {
            builds: builds
        })));
    }
}
var $7efa7a7a26c5833c$export$2e2bcd8739ae039 = $7efa7a7a26c5833c$var$LazyBuildStatus;

});


parcelRegister("9UqTj", function(module, exports) {

$parcel$export(module.exports, "getModalMenuPortalStyles", function () { return $373298b3c89d4398$export$ae35a6414a64778; });
$parcel$export(module.exports, "selectControlStyles", function () { return $373298b3c89d4398$export$f962c52752450c90; });

var $aP6k3 = parcelRequire("aP6k3");

var $giIwV = parcelRequire("giIwV");
const $373298b3c89d4398$var$MODAL_MENU_PORTAL_LAYER = (0, $aP6k3.layers).modal() + 10;
const $373298b3c89d4398$export$ae35a6414a64778 = (isBannerOpen)=>{
    return {
        // @ts-ignore TODO: Upgrade @atlaskit/select and use `StylesConfig` as this full object's type
        // to fix noImplicitAny error here
        menuPortal: (base)=>{
            const topOverride = isBannerOpen ? {
                top: base.top - (0, $giIwV.BANNER_HEIGHT)
            } : {};
            return {
                ...base,
                ...topOverride,
                zIndex: $373298b3c89d4398$var$MODAL_MENU_PORTAL_LAYER
            };
        }
    };
};
const $373298b3c89d4398$export$f962c52752450c90 = {
    minHeight: (0, $aP6k3.gridSize)() * 4,
    height: (0, $aP6k3.gridSize)() * 4,
    alignContent: "center"
};

});

parcelRegister("iWbF7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74c92e12c7a891fb$export$2e2bcd8739ae039; });
const $74c92e12c7a891fb$var$urls = {
    api: {
        v10: {},
        v20: {},
        internal: {}
    },
    external: {
        docs: ()=>"https://confluence.atlassian.com/x/TwlODQ",
        docsBranchingModel: ()=>"https://confluence.atlassian.com/x/TwlODQ#BranchingaRepository-jirabranchTocreateabranchfromanissueinJiraSoftware"
    },
    ui: {}
};
var $74c92e12c7a891fb$export$2e2bcd8739ae039 = $74c92e12c7a891fb$var$urls;

});

parcelRegister("5bCME", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c992c26deed33c81$export$2e2bcd8739ae039; });
parcelRequire("dGzLf");
var $5oGLl = parcelRequire("5oGLl");
parcelRequire("9waDg");
var $1kvgs = parcelRequire("1kvgs");

var $eTL4A = parcelRequire("eTL4A");
const $c992c26deed33c81$var$mapDispatchToProps = {
    fetchRefOptions: $1kvgs.fetchRefOptions
};
var $c992c26deed33c81$export$2e2bcd8739ae039 = (0, $5oGLl.default)(null, $c992c26deed33c81$var$mapDispatchToProps)((0, $eTL4A.SelectBranch));

});
parcelRegister("9waDg", function(module, exports) {
$parcel$export(module.exports, "CHANGE_BRANCH_TYPE", function () { return (parcelRequire("1kvgs")).CHANGE_BRANCH_TYPE; });
$parcel$export(module.exports, "CHANGE_FROM_BRANCH", function () { return (parcelRequire("1kvgs")).CHANGE_FROM_BRANCH; });
$parcel$export(module.exports, "CHANGE_NEW_BRANCH_NAME", function () { return (parcelRequire("1kvgs")).CHANGE_NEW_BRANCH_NAME; });
$parcel$export(module.exports, "CHANGE_REPOSITORY", function () { return (parcelRequire("1kvgs")).CHANGE_REPOSITORY; });
$parcel$export(module.exports, "changeBranchType", function () { return (parcelRequire("1kvgs")).changeBranchType; });
$parcel$export(module.exports, "changeFromBranch", function () { return (parcelRequire("1kvgs")).changeFromBranch; });
$parcel$export(module.exports, "changeNewBranchName", function () { return (parcelRequire("1kvgs")).changeNewBranchName; });
$parcel$export(module.exports, "closeCreateBranchGlobalDialog", function () { return (parcelRequire("1kvgs")).closeCreateBranchGlobalDialog; });
$parcel$export(module.exports, "closeCreateBranchRepoDialog", function () { return (parcelRequire("1kvgs")).closeCreateBranchRepoDialog; });
$parcel$export(module.exports, "CREATE_BRANCH", function () { return (parcelRequire("1kvgs")).CREATE_BRANCH; });
$parcel$export(module.exports, "CREATE_BRANCH_GLOBAL_DIALOG", function () { return (parcelRequire("1kvgs")).CREATE_BRANCH_GLOBAL_DIALOG; });
$parcel$export(module.exports, "CREATE_BRANCH_REPO_DIALOG", function () { return (parcelRequire("1kvgs")).CREATE_BRANCH_REPO_DIALOG; });
$parcel$export(module.exports, "createBranch", function () { return (parcelRequire("1kvgs")).createBranch; });
$parcel$export(module.exports, "FETCH_BRANCHING_MODEL", function () { return (parcelRequire("1kvgs")).FETCH_BRANCHING_MODEL; });
$parcel$export(module.exports, "FETCH_COMMIT_STATUSES", function () { return (parcelRequire("1kvgs")).FETCH_COMMIT_STATUSES; });
$parcel$export(module.exports, "FETCH_REF_OPTIONS", function () { return (parcelRequire("1kvgs")).FETCH_REF_OPTIONS; });
$parcel$export(module.exports, "fetchBranchingModel", function () { return (parcelRequire("1kvgs")).fetchBranchingModel; });
$parcel$export(module.exports, "fetchCommitStatuses", function () { return (parcelRequire("1kvgs")).fetchCommitStatuses; });
$parcel$export(module.exports, "fetchRefOptions", function () { return (parcelRequire("1kvgs")).fetchRefOptions; });
$parcel$export(module.exports, "LOAD_REPOSITORIES", function () { return (parcelRequire("1kvgs")).LOAD_REPOSITORIES; });
$parcel$export(module.exports, "LOAD_REPOSITORY", function () { return (parcelRequire("1kvgs")).LOAD_REPOSITORY; });
$parcel$export(module.exports, "loadRepositories", function () { return (parcelRequire("1kvgs")).loadRepositories; });
$parcel$export(module.exports, "loadRepository", function () { return (parcelRequire("1kvgs")).loadRepository; });
$parcel$export(module.exports, "onChangeRepository", function () { return (parcelRequire("1kvgs")).onChangeRepository; });
$parcel$export(module.exports, "openCreateBranchGlobalDialog", function () { return (parcelRequire("1kvgs")).openCreateBranchGlobalDialog; });
$parcel$export(module.exports, "openCreateBranchRepoDialog", function () { return (parcelRequire("1kvgs")).openCreateBranchRepoDialog; });
$parcel$export(module.exports, "SET_CURRENT_REPOSITORY", function () { return (parcelRequire("1kvgs")).SET_CURRENT_REPOSITORY; });
$parcel$export(module.exports, "SET_JIRA_ISSUE", function () { return (parcelRequire("1kvgs")).SET_JIRA_ISSUE; });
$parcel$export(module.exports, "SET_SUGGESTED_FROM_BRANCH", function () { return (parcelRequire("1kvgs")).SET_SUGGESTED_FROM_BRANCH; });
$parcel$export(module.exports, "setCurrentRepository", function () { return (parcelRequire("1kvgs")).setCurrentRepository; });
$parcel$export(module.exports, "setJiraIssue", function () { return (parcelRequire("1kvgs")).setJiraIssue; });
$parcel$export(module.exports, "setSuggestedFromBranch", function () { return (parcelRequire("1kvgs")).setSuggestedFromBranch; });
$parcel$export(module.exports, "SHOW_CREATE_BRANCH_SUCCESS_FLAG", function () { return (parcelRequire("1kvgs")).SHOW_CREATE_BRANCH_SUCCESS_FLAG; });
parcelRequire("1kvgs");

});
parcelRegister("1kvgs", function(module, exports) {

$parcel$export(module.exports, "LOAD_REPOSITORY", function () { return $a06cde61e0283693$export$40c2aed245f18805; });
$parcel$export(module.exports, "loadRepository", function () { return $a06cde61e0283693$export$bc1e30813b6110a7; });
$parcel$export(module.exports, "LOAD_REPOSITORIES", function () { return $a06cde61e0283693$export$d627e0dc04dd615d; });
$parcel$export(module.exports, "loadRepositories", function () { return $a06cde61e0283693$export$4e9b675fc3dc4dbe; });
$parcel$export(module.exports, "CREATE_BRANCH_REPO_DIALOG", function () { return $a06cde61e0283693$export$e51c10cb75a41a00; });
$parcel$export(module.exports, "CREATE_BRANCH_GLOBAL_DIALOG", function () { return $a06cde61e0283693$export$66b2bf05aad106f9; });
$parcel$export(module.exports, "openCreateBranchRepoDialog", function () { return $a06cde61e0283693$export$27874912df689dbd; });
$parcel$export(module.exports, "closeCreateBranchRepoDialog", function () { return $a06cde61e0283693$export$6c2c55879c123025; });
$parcel$export(module.exports, "openCreateBranchGlobalDialog", function () { return $a06cde61e0283693$export$ec3548346a5c2f4a; });
$parcel$export(module.exports, "closeCreateBranchGlobalDialog", function () { return $a06cde61e0283693$export$fc2abee1c53cc37c; });
$parcel$export(module.exports, "FETCH_REF_OPTIONS", function () { return $a06cde61e0283693$export$497c5510f9fe274b; });
$parcel$export(module.exports, "fetchRefOptions", function () { return $a06cde61e0283693$export$4ec3b042c9c5aa9; });
$parcel$export(module.exports, "FETCH_COMMIT_STATUSES", function () { return $a06cde61e0283693$export$d7968070be115975; });
$parcel$export(module.exports, "fetchCommitStatuses", function () { return $a06cde61e0283693$export$c4bc72db5404b422; });
$parcel$export(module.exports, "FETCH_BRANCHING_MODEL", function () { return $a06cde61e0283693$export$b2a0736f8646c089; });
$parcel$export(module.exports, "fetchBranchingModel", function () { return $a06cde61e0283693$export$e4161fa28e5e3f41; });
$parcel$export(module.exports, "SET_SUGGESTED_FROM_BRANCH", function () { return $a06cde61e0283693$export$ce5b07ee2d649240; });
$parcel$export(module.exports, "setSuggestedFromBranch", function () { return $a06cde61e0283693$export$4ea4ad0fdd42d01; });
$parcel$export(module.exports, "CHANGE_FROM_BRANCH", function () { return $a06cde61e0283693$export$636dff126b106a08; });
$parcel$export(module.exports, "changeFromBranch", function () { return $a06cde61e0283693$export$e472e2f76ee51690; });
$parcel$export(module.exports, "CHANGE_NEW_BRANCH_NAME", function () { return $a06cde61e0283693$export$37739d46dc01d5ac; });
$parcel$export(module.exports, "changeNewBranchName", function () { return $a06cde61e0283693$export$b48b28e5ccc4727; });
$parcel$export(module.exports, "CREATE_BRANCH", function () { return $a06cde61e0283693$export$852d908b6524fa54; });
$parcel$export(module.exports, "createBranch", function () { return $a06cde61e0283693$export$2a9bf4c22289dd1a; });
$parcel$export(module.exports, "CHANGE_BRANCH_TYPE", function () { return $a06cde61e0283693$export$63de8bf92882840d; });
$parcel$export(module.exports, "changeBranchType", function () { return $a06cde61e0283693$export$65b953678db35c59; });
$parcel$export(module.exports, "SHOW_CREATE_BRANCH_SUCCESS_FLAG", function () { return $a06cde61e0283693$export$9792deb23fe628a0; });
$parcel$export(module.exports, "CHANGE_REPOSITORY", function () { return $a06cde61e0283693$export$bacc576c58991274; });
$parcel$export(module.exports, "onChangeRepository", function () { return $a06cde61e0283693$export$317fd21754d5c4fe; });
$parcel$export(module.exports, "SET_CURRENT_REPOSITORY", function () { return $a06cde61e0283693$export$348aa7adebbeedc; });
$parcel$export(module.exports, "setCurrentRepository", function () { return $a06cde61e0283693$export$7e123227387f6db2; });
$parcel$export(module.exports, "SET_JIRA_ISSUE", function () { return $a06cde61e0283693$export$d286fb91eb23b6f; });
$parcel$export(module.exports, "setJiraIssue", function () { return $a06cde61e0283693$export$16cd16c279bc477d; });

var $cJH1T = parcelRequire("cJH1T");
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
var $fICwP = parcelRequire("fICwP");

var $kZnTB = parcelRequire("kZnTB");
const $a06cde61e0283693$var$prefixed = (action)=>`create-branch/${action}`;
const $a06cde61e0283693$export$40c2aed245f18805 = (0, $2MctD.createAsyncAction)($a06cde61e0283693$var$prefixed("LOAD_REPOSITORY"));
const $a06cde61e0283693$export$bc1e30813b6110a7 = (owner, slug)=>{
    const fields = [
        "*",
        "mainbranch.type",
        "mainbranch.name",
        "mainbranch.target.hash",
        "-project",
        "-owner"
    ];
    const qs = (0, $cJH1T.stringify)({
        fields: fields.join(",")
    }, {
        indices: false
    });
    const url = `${(0, $kZnTB.default).api.v20.repository(owner, slug)}?${qs}`;
    return (0, $fICwP.fetchAction)($a06cde61e0283693$export$40c2aed245f18805, {
        url: url
    });
};
const $a06cde61e0283693$export$d627e0dc04dd615d = (0, $2MctD.createAsyncAction)($a06cde61e0283693$var$prefixed("LOAD_REPOSITORIES"));
const $a06cde61e0283693$export$4e9b675fc3dc4dbe = ()=>(0, $fICwP.hydrateAction)($a06cde61e0283693$export$d627e0dc04dd615d, "createBranch", {
        url: "/branch/create"
    });
const $a06cde61e0283693$export$e51c10cb75a41a00 = {
    OPEN: $a06cde61e0283693$var$prefixed("OPEN_CREATE_BRANCH_REPO_DIALOG"),
    CLOSE: $a06cde61e0283693$var$prefixed("CLOSE_CREATE_BRANCH_REPO_DIALOG")
};
const $a06cde61e0283693$export$66b2bf05aad106f9 = {
    OPEN: $a06cde61e0283693$var$prefixed("OPEN_CREATE_BRANCH_GLOBAL_DIALOG"),
    CLOSE: $a06cde61e0283693$var$prefixed("CLOSE_CREATE_BRANCH_GLOBAL_DIALOG")
};
const $a06cde61e0283693$export$27874912df689dbd = ()=>({
        type: $a06cde61e0283693$export$e51c10cb75a41a00.OPEN
    });
const $a06cde61e0283693$export$6c2c55879c123025 = ()=>({
        type: $a06cde61e0283693$export$e51c10cb75a41a00.CLOSE
    });
const $a06cde61e0283693$export$ec3548346a5c2f4a = ()=>({
        type: $a06cde61e0283693$export$66b2bf05aad106f9.OPEN
    });
const $a06cde61e0283693$export$fc2abee1c53cc37c = ()=>({
        type: $a06cde61e0283693$export$66b2bf05aad106f9.CLOSE
    });
const $a06cde61e0283693$export$497c5510f9fe274b = (0, $2MctD.createAsyncAction)($a06cde61e0283693$var$prefixed("FETCH_REF_OPTIONS"));
const $a06cde61e0283693$export$4ec3b042c9c5aa9 = (payload = {})=>({
        type: $a06cde61e0283693$export$497c5510f9fe274b.REQUEST,
        payload: payload
    });
const $a06cde61e0283693$export$d7968070be115975 = (0, $2MctD.createAsyncAction)($a06cde61e0283693$var$prefixed("FETCH_COMMIT_STATUSES"));
const $a06cde61e0283693$export$c4bc72db5404b422 = ()=>({
        type: $a06cde61e0283693$export$d7968070be115975.REQUEST
    });
const $a06cde61e0283693$export$b2a0736f8646c089 = (0, $2MctD.createAsyncAction)($a06cde61e0283693$var$prefixed("FETCH_BRANCHING_MODEL"));
const $a06cde61e0283693$export$e4161fa28e5e3f41 = ()=>({
        type: $a06cde61e0283693$export$b2a0736f8646c089.REQUEST
    });
const $a06cde61e0283693$export$ce5b07ee2d649240 = $a06cde61e0283693$var$prefixed("SET_SUGGESTED_FROM_BRANCH");
const $a06cde61e0283693$export$4ea4ad0fdd42d01 = (branch)=>({
        type: $a06cde61e0283693$export$ce5b07ee2d649240,
        payload: branch
    });
const $a06cde61e0283693$export$636dff126b106a08 = $a06cde61e0283693$var$prefixed("CHANGE_FROM_BRANCH");
const $a06cde61e0283693$export$e472e2f76ee51690 = (ref, selectedByUser = true)=>({
        type: $a06cde61e0283693$export$636dff126b106a08,
        payload: {
            ref: ref,
            selectedByUser: selectedByUser
        }
    });
const $a06cde61e0283693$export$37739d46dc01d5ac = $a06cde61e0283693$var$prefixed("CHANGE_NEW_BRANCH_NAME");
const $a06cde61e0283693$export$b48b28e5ccc4727 = (name)=>({
        type: $a06cde61e0283693$export$37739d46dc01d5ac,
        payload: name
    });
const $a06cde61e0283693$export$852d908b6524fa54 = (0, $2MctD.createAsyncAction)($a06cde61e0283693$var$prefixed("CREATE_BRANCH"));
const $a06cde61e0283693$export$2a9bf4c22289dd1a = (payload)=>({
        type: $a06cde61e0283693$export$852d908b6524fa54.REQUEST,
        payload: payload
    });
const $a06cde61e0283693$export$63de8bf92882840d = $a06cde61e0283693$var$prefixed("CHANGE_BRANCH_TYPE");
const $a06cde61e0283693$export$65b953678db35c59 = (branchType)=>({
        type: $a06cde61e0283693$export$63de8bf92882840d,
        payload: branchType
    });
const $a06cde61e0283693$export$9792deb23fe628a0 = $a06cde61e0283693$var$prefixed("SHOW_CREATE_BRANCH_SUCCESS_FLAG");
const $a06cde61e0283693$export$a3660ab827494857 = (branch)=>({
        type: $a06cde61e0283693$export$9792deb23fe628a0,
        payload: branch
    });
const $a06cde61e0283693$export$bacc576c58991274 = $a06cde61e0283693$var$prefixed("CHANGE_REPOSITORY");
const $a06cde61e0283693$export$317fd21754d5c4fe = (selected)=>({
        type: $a06cde61e0283693$export$bacc576c58991274,
        payload: {
            selected: selected
        }
    });
const $a06cde61e0283693$export$348aa7adebbeedc = $a06cde61e0283693$var$prefixed("SET_CURRENT_REPOSITORY");
const $a06cde61e0283693$export$7e123227387f6db2 = ()=>({
        type: $a06cde61e0283693$export$348aa7adebbeedc
    });
const $a06cde61e0283693$export$d286fb91eb23b6f = $a06cde61e0283693$var$prefixed("SET_JIRA_ISSUE");
const $a06cde61e0283693$export$16cd16c279bc477d = (payload)=>({
        type: $a06cde61e0283693$export$d286fb91eb23b6f,
        payload: payload
    });

});


parcelRegister("eTL4A", function(module, exports) {

$parcel$export(module.exports, "SelectBranch", function () { return $66ae6bea69d78194$export$a3257b9f753043ed; });

var $9nHZC = parcelRequire("9nHZC");

var $62zzi = parcelRequire("62zzi");

var $lepT7 = parcelRequire("lepT7");

var $5gF7V = parcelRequire("5gF7V");

var $9xBn1 = parcelRequire("9xBn1");

var $7gyAE = parcelRequire("7gyAE");
class $66ae6bea69d78194$export$a3257b9f753043ed extends (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).PureComponent {
    constructor(...args){
        super(...args);
        this.hasInputChanged = false;
        this.handleSelectBranch = (option)=>{
            if (option.ref) this.props.onChangeFromBranch(option.ref);
        };
        this.handleInputChange = (inputValue, { action: action })=>{
            if (action === "input-change") {
                this.hasInputChanged = true;
                this.props.fetchRefOptions({
                    search: inputValue
                });
                return;
            }
            if (action === "menu-close" && this.hasInputChanged) {
                this.hasInputChanged = false;
                this.props.fetchRefOptions();
            }
        };
        this.debouncedInputChange = (0, $62zzi.default)(this.handleInputChange, 1000);
        this.getOptions = ()=>{
            const { refSelector: refSelector, intl: intl } = this.props;
            if (!refSelector.refs.length) return [];
            if (!refSelector.hasMoreRefs) return refSelector.refs;
            return [
                ...refSelector.refs,
                {
                    label: intl.formatMessage((0, $9xBn1.default).refSelectorMoreOptions),
                    value: "",
                    isDisabled: true,
                    data: undefined
                }
            ];
        };
    }
    render() {
        const { intl: intl, isCreating: isCreating, isLoading: isLoading, selectStyles: selectStyles, refSelector: { loadingState: loadingState, refs: refs, selected: selected } } = this.props;
        let placeholder = null;
        if (loadingState === (0, $5gF7V.LOADING_STATE).SUCCESS && !refs.length) placeholder = intl.formatMessage((0, $9xBn1.default).refSelectorNoRefs);
        else if (loadingState === (0, $5gF7V.LOADING_STATE).ERROR) placeholder = intl.formatMessage((0, $9xBn1.default).refSelectorLoadError);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $lepT7.default), {
            backspaceRemovesValue: false,
            components: {
                GroupHeading: (0, $7gyAE.CustomGroupHeading),
                Option: (0, $7gyAE.CustomSelectOption)
            },
            filterOption: null,
            isDisabled: isCreating,
            isLoading: isLoading,
            menuPortalTarget: document.body,
            noOptionsMessage: ()=>intl.formatMessage((0, $9xBn1.default).refSelectorNoMatches),
            onChange: this.handleSelectBranch,
            onClickPreventDefault: false,
            onInputChange: this.debouncedInputChange,
            options: this.getOptions(),
            placeholder: placeholder,
            styles: selectStyles,
            value: selected
        });
    }
}

});
parcelRegister("9xBn1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d867abb69f876f27$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $d867abb69f876f27$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    refSelectorLabelBranches: {
        "id": "frontbucket.createBranch.refSelectorLabelBranches",
        "defaultMessage": "Branches"
    },
    title: {
        "id": "frontbucket.createBranch.createBranchTitle",
        "defaultMessage": "Create branch"
    },
    refSelectorLabelTags: {
        "id": "frontbucket.createBranch.refSelectorLabelTags",
        "defaultMessage": "Tags"
    },
    refSelectorNoMatches: {
        "id": "frontbucket.createBranch.refSelectorNoMatches",
        "defaultMessage": "We can't find that branch or tag"
    },
    refSelectorNoRefs: {
        "id": "frontbucket.createBranch.refSelectorNoRefs",
        "defaultMessage": "No branches or tags"
    },
    refSelectorLoadError: {
        "id": "frontbucket.createBranch.refSelectorLoadError",
        "defaultMessage": "We couldn't load branches or tags"
    },
    refSelectorMoreOptions: {
        "id": "frontbucket.createBranch.refSelectorMoreOptions",
        "defaultMessage": "Type to filter..."
    },
    repositoryLabel: {
        "id": "frontbucket.createBranch.repositoryLabel",
        "defaultMessage": "Repository"
    },
    repositorySelectorNoRepositories: {
        "id": "frontbucket.createBranch.repositorySelectorNoRepositories",
        "defaultMessage": "We can't find any repositories you have write access to"
    },
    repositorySelectorNoMatches: {
        "id": "frontbucket.createBranch.repositorySelectorNoMatches",
        "defaultMessage": "We can't find that repository"
    },
    repositorySelectorLoadError: {
        "id": "frontbucket.createBranch.repositorySelectorLoadError",
        "defaultMessage": "Unable to load repositories"
    },
    repositorySelectorMoreOptions: {
        "id": "frontbucket.createBranch.repositorySelectorMoreOptions",
        "defaultMessage": "Type to filter..."
    },
    fromBranchLabel: {
        "id": "frontbucket.createBranch.fromBranchLabel",
        "defaultMessage": "From branch"
    },
    branchTypeLabel: {
        "id": "frontbucket.createBranch.branchTypeLabel",
        "defaultMessage": "Type"
    },
    branchTypeTooltipText: {
        "id": "frontbucket.createBranch.branchTypeTooltipText",
        "defaultMessage": "Select a branch type, and we\u2019ll add the prefix to your branch name."
    },
    branchTypeTooltipLearnMoreLink: {
        "id": "frontbucket.createBranch.branchTypeTooltipLearnMoreLink",
        "defaultMessage": "Learn more"
    },
    branchTypeBugfixOptionLabel: {
        "id": "frontbucket.createBranch.branchTypeBugfixOptionLabel",
        "defaultMessage": "Bugfix"
    },
    branchTypeFeatureOptionLabel: {
        "id": "frontbucket.createBranch.branchTypeFeatureOptionLabel",
        "defaultMessage": "Feature"
    },
    branchTypeHotfixOptionLabel: {
        "id": "frontbucket.createBranch.branchTypeHotfixOptionLabel",
        "defaultMessage": "Hotfix"
    },
    branchTypeReleaseOptionLabel: {
        "id": "frontbucket.createBranch.branchTypeReleaseOptionLabel",
        "defaultMessage": "Release"
    },
    branchTypeOtherOptionLabel: {
        "id": "frontbucket.createBranch.branchTypeOtherOptionLabel",
        "defaultMessage": "Other"
    },
    branchNameLabel: {
        "id": "frontbucket.createBranch.branchNameLabel",
        "defaultMessage": "Branch name"
    },
    createButton: {
        "id": "frontbucket.createBranch.createBranchScreenCreateButton",
        "defaultMessage": "Create"
    },
    cancelButton: {
        "id": "frontbucket.createBranch.createBranchScreenCancelButton",
        "defaultMessage": "Cancel"
    },
    createBranchButton: {
        "id": "frontbucket.createBranch.createBranchButton",
        "defaultMessage": "Create branch"
    },
    createBranchButtonDisabled: {
        "id": "frontbucket.createBranch.createBranchButtonDisabled",
        "defaultMessage": "You do not have permission to create a branch"
    },
    errorDescriptionBranchAlreadyExists: {
        "id": "frontbucket.createBranch.errorDescription.BranchAlreadyExists",
        "defaultMessage": "Branch already exists."
    }
});

});

parcelRegister("7gyAE", function(module, exports) {

$parcel$export(module.exports, "CustomSelectOption", function () { return $98222c31ee675b99$export$be7472b36ab2e901; });
$parcel$export(module.exports, "CustomGroupHeading", function () { return $98222c31ee675b99$export$1faf1717f724586d; });

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $dUfie = parcelRequire("dUfie");

var $9xBn1 = parcelRequire("9xBn1");

var $eEasA = parcelRequire("eEasA");
const $98222c31ee675b99$export$be7472b36ab2e901 = (props)=>{
    const option = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dUfie.c).Option, props);
    return props.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eEasA.DisabledOption, null, option) : option;
};
const $98222c31ee675b99$export$1faf1717f724586d = (props)=>{
    const { children: messageKey, ...restProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dUfie.c).GroupHeading, restProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, $9xBn1.default)[messageKey]));
};

});
parcelRegister("eEasA", function(module, exports) {

$parcel$export(module.exports, "FieldWrapper", function () { return $96cd38d93cad598b$export$6a00f65eec6002a6; });
$parcel$export(module.exports, "FormLabel", function () { return $96cd38d93cad598b$export$842aba50ed0ce9d7; });
$parcel$export(module.exports, "FieldRefSelector", function () { return $96cd38d93cad598b$export$f96d9a2b317fcf13; });
$parcel$export(module.exports, "FieldRefSelectorDropdown", function () { return $96cd38d93cad598b$export$7f2242f6bbde5d91; });
$parcel$export(module.exports, "FieldRefSelectorBuildStatus", function () { return $96cd38d93cad598b$export$1cf39326d50c4512; });
$parcel$export(module.exports, "FooterContent", function () { return $96cd38d93cad598b$export$69917a81bb9593b3; });
$parcel$export(module.exports, "BranchTypeSelectorTooltipContent", function () { return $96cd38d93cad598b$export$ad2c8ba6f5381547; });
$parcel$export(module.exports, "BranchTypeSelectorIconWrapper", function () { return $96cd38d93cad598b$export$8fd689d080520b29; });
$parcel$export(module.exports, "CursorPointer", function () { return $96cd38d93cad598b$export$9808a559342853ad; });
$parcel$export(module.exports, "BranchTypeOptionOther", function () { return $96cd38d93cad598b$export$a42e484f0e1a9762; });
$parcel$export(module.exports, "BranchNameInputWrapper", function () { return $96cd38d93cad598b$export$5a817dbc31a7c902; });
$parcel$export(module.exports, "BranchNamePrefix", function () { return $96cd38d93cad598b$export$91fa4f7bd5cb0b76; });
$parcel$export(module.exports, "BranchNameInput", function () { return $96cd38d93cad598b$export$1eab5412dcc4a7b6; });
$parcel$export(module.exports, "BranchNameError", function () { return $96cd38d93cad598b$export$6b3347a13c4ca9f2; });
$parcel$export(module.exports, "DisabledOption", function () { return $96cd38d93cad598b$export$bb0a8a43a936e057; });

var $2xJU3 = parcelRequire("2xJU3");

var $aP6k3 = parcelRequire("aP6k3");
var $jp7ng = parcelRequire("jp7ng");
var $dCDrX = parcelRequire("dCDrX");

var $h39Sh = parcelRequire("h39Sh");
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */ function $96cd38d93cad598b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $96cd38d93cad598b$export$6a00f65eec6002a6 = (0, $2xJU3.default)("div", {
    target: "e8xapdy0"
})("padding-top:", (0, $aP6k3.gridSize)(), "px;");
const $96cd38d93cad598b$export$842aba50ed0ce9d7 = (0, $2xJU3.default)("label", {
    target: "e8xapdy1"
})((0, $dCDrX).h200(), ";display:inline-block;margin-bottom:", (0, $aP6k3.gridSize)() / 2, "px;margin-top:0;margin-right:", (0, $aP6k3.gridSize)() / 2, "px;");
const $96cd38d93cad598b$export$f96d9a2b317fcf13 = (0, $2xJU3.default)("div", {
    target: "e8xapdy2"
})({
    name: "1lads1q",
    styles: "display:flex;align-items:center;justify-content:center;width:100%;"
});
const $96cd38d93cad598b$export$7f2242f6bbde5d91 = (0, $2xJU3.default)("div", {
    target: "e8xapdy3"
})({
    name: "i9gxme",
    styles: "flex-grow:1;"
});
const $96cd38d93cad598b$export$1cf39326d50c4512 = (0, $2xJU3.default)("div", {
    target: "e8xapdy4"
})("margin-left:", (0, $aP6k3.gridSize)() / 2, "px;");
const $96cd38d93cad598b$export$69917a81bb9593b3 = (0, $2xJU3.default)("div", {
    target: "e8xapdy5"
})({
    name: "v2w2ah",
    styles: "display:flex;align-items:center;justify-content:flex-end;width:100%;position:relative;"
});
const $96cd38d93cad598b$export$ad2c8ba6f5381547 = (0, $2xJU3.default)("div", {
    target: "e8xapdy6"
})("max-width:", (0, $aP6k3.gridSize)() * 33, "px;");
const $96cd38d93cad598b$export$8fd689d080520b29 = (0, $2xJU3.default)("div", {
    target: "e8xapdy7"
})({
    name: "1baulvz",
    styles: "display:inline-block;"
});
const $96cd38d93cad598b$export$9808a559342853ad = (0, $2xJU3.default)("button", {
    target: "e8xapdy8"
})("background-color:transparent;border:transparent;color:currentColor;cursor:pointer;padding:0;position:relative;bottom:-", (0, $aP6k3.gridSize)() / 4, "px;");
const $96cd38d93cad598b$export$e7a2e72ef7459c4 = (0, $2xJU3.default)("div", {
    target: "e8xapdy9"
})("width:", (0, $aP6k3.gridSize)() * 16, "px;");
const $96cd38d93cad598b$export$a42e484f0e1a9762 = (0, $2xJU3.default)("span", {
    target: "e8xapdy10"
})({
    name: "1msjh1x",
    styles: "font-style:italic;"
});
const $96cd38d93cad598b$export$5a817dbc31a7c902 = (0, $2xJU3.default)("div", {
    target: "e8xapdy11"
})({
    name: "czkowe",
    styles: "align-items:stretch;display:flex;"
});
const $96cd38d93cad598b$export$91fa4f7bd5cb0b76 = (0, $2xJU3.default)("div", {
    target: "e8xapdy12"
})("align-items:center;background-color:", (0, $h39Sh.default)("color.background.input", (0, $jp7ng).N20), ";border:2px solid ", (0, $h39Sh.default)("color.border", (0, $jp7ng).N40), ";border-radius:", (0, $aP6k3.borderRadius)(), "px 0 0 ", (0, $aP6k3.borderRadius)(), "px;display:flex;justify-content:center;max-width:", (0, $aP6k3.gridSize)() * 19, "px;margin-right:-3px;padding:0 ", (0, $aP6k3.gridSize)(), "px;> div{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}");
const $96cd38d93cad598b$export$1eab5412dcc4a7b6 = (0, $2xJU3.default)("div", {
    target: "e8xapdy13"
})({
    name: "i9gxme",
    styles: "flex-grow:1;"
});
const $96cd38d93cad598b$export$6b3347a13c4ca9f2 = (0, $2xJU3.default)("div", {
    target: "e8xapdy14"
})("max-width:", (0, $aP6k3.gridSize)() * 25, "px;");
const $96cd38d93cad598b$export$bb0a8a43a936e057 = (0, $2xJU3.default)("span", {
    target: "e8xapdy15"
})("color:", (0, $h39Sh.default)("color.text.subtlest", (0, $jp7ng).N80), ";");

});




parcelRegister("8JHOA", function(module, exports) {

$parcel$export(module.exports, "BranchGraphic", function () { return $b780f4669b9200a4$export$aa803a48372ae6d2; });

var $9nHZC = parcelRequire("9nHZC");

var $4cpJW = parcelRequire("4cpJW");

var $jp7ng = parcelRequire("jp7ng");

var $a7iuM = parcelRequire("a7iuM");

var $kkFIU = parcelRequire("kkFIU");
const $b780f4669b9200a4$export$6aefae60e099b9a6 = {
    targetBranch: {
        highlight: (0, $jp7ng).N300,
        dim: (0, $jp7ng).N40
    },
    newBranch: {
        highlight: (0, $jp7ng).B300,
        dim: (0, $jp7ng).B50
    }
};
class $b780f4669b9200a4$export$aa803a48372ae6d2 extends (0, $9nHZC.PureComponent) {
    constructor(...args){
        super(...args);
        this.renderLabel = (branchName, dataQa)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($kkFIU.BranchLabelWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $a7iuM.default), {
                content: branchName,
                position: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($kkFIU.BranchLabel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4cpJW))), {
                label: ""
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", {
                "data-qa": dataQa
            }, branchName))));
        };
    }
    renderSvg() {
        const { newBranchName: newBranchName, targetBranchName: targetBranchName } = this.props;
        const highlight = newBranchName && targetBranchName;
        const targetBranchColor = highlight ? $b780f4669b9200a4$export$6aefae60e099b9a6.targetBranch.highlight : $b780f4669b9200a4$export$6aefae60e099b9a6.targetBranch.dim;
        const newBranchColor = highlight ? $b780f4669b9200a4$export$6aefae60e099b9a6.newBranch.highlight : $b780f4669b9200a4$export$6aefae60e099b9a6.newBranch.dim;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("svg", {
            width: "141.53846154px",
            height: "60px",
            viewBox: "0 0 92 39"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("g", {
            id: "branch-diagram-create"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
            d: "M86,36 C87.6568542,36 89,34.6568542 89,33 C89,31.3431458 87.6568542,30 86,30 C84.3431458,30 83,31.3431458 83,33 C83,34.6568542 84.3431458,36 86,36 Z M80.1081488,34.1399309 C65.7396146,32.2267058 58.0992007,22.7452367 57.5009625,6.05372681 L60.4990375,5.94627319 C61.0417803,21.0894001 67.5381337,29.3713241 80.2936839,31.1405887 C81.0763531,28.7370585 83.3353207,27 86,27 C89.3137085,27 92,29.6862915 92,33 C92,36.3137085 89.3137085,39 86,39 C83.076066,39 80.6406301,36.9084914 80.1081488,34.1399309 Z",
            id: "Combined-Shape",
            fill: targetBranchColor,
            fillRule: "nonzero"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("path", {
            d: "M53.3414114,8 L11.6585886,8 C10.8349158,10.3303847 8.61243765,12 6,12 C2.6862915,12 0,9.3137085 0,6 C0,2.6862915 2.6862915,0 6,0 C8.61243765,0 10.8349158,1.66961525 11.6585886,4 L53.3414114,4 C54.1650842,1.66961525 56.3875623,0 59,0 C62.3137085,0 65,2.6862915 65,6 C65,9.3137085 62.3137085,12 59,12 C56.3875623,12 54.1650842,10.3303847 53.3414114,8 Z",
            id: "Combined-Shape",
            fill: newBranchColor
        }))));
    }
    renderLabels() {
        const { newBranchName: newBranchName, targetBranchName: targetBranchName } = this.props;
        if (!targetBranchName) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($kkFIU.BranchLabels, null, targetBranchName && this.renderLabel(targetBranchName, "create-branch-graphic-from-branch"), newBranchName && this.renderLabel(newBranchName, "create-branch-graphic-new-branch"));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($kkFIU.BranchGraphic, null, this.renderSvg(), this.renderLabels());
    }
}

});
parcelRegister("kkFIU", function(module, exports) {

$parcel$export(module.exports, "BranchGraphic", function () { return $e7d62187b240c56e$export$aa803a48372ae6d2; });
$parcel$export(module.exports, "BranchLabels", function () { return $e7d62187b240c56e$export$537be6fdf2ebf882; });
$parcel$export(module.exports, "BranchLabelWrapper", function () { return $e7d62187b240c56e$export$d71399a2d055a602; });
$parcel$export(module.exports, "BranchLabel", function () { return $e7d62187b240c56e$export$e0d6e4370cabc21; });

var $2xJU3 = parcelRequire("2xJU3");

var $aP6k3 = parcelRequire("aP6k3");
var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */ function $e7d62187b240c56e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e7d62187b240c56e$export$aa803a48372ae6d2 = (0, $2xJU3.default)("div", {
    target: "eioz98c0"
})("display:flex;align-items:center;padding:", (0, $aP6k3.gridSize)() * 4, "px 0;>:first-child{flex:0 0 auto;margin-right:", (0, $aP6k3.gridSize)() * 4, "px;}");
const $e7d62187b240c56e$export$537be6fdf2ebf882 = (0, $2xJU3.default)("div", {
    target: "eioz98c1"
})({
    name: "1s9tdnu",
    styles: "display:flex;flex-direction:column;align-items:flex-start;justify-content:space-between;min-width:1px;height:60px;>:first-child{margin-top:-5px;}>:last-child{margin-bottom:-5px;}"
});
const $e7d62187b240c56e$export$d71399a2d055a602 = (0, $2xJU3.default)("div", {
    target: "eioz98c2"
})("background:", (0, $h39Sh.default)("color.background.input", (0, $jp7ng).N20), ";padding:", (0, $aP6k3.gridSize)() / 4, "px ", (0, $aP6k3.gridSize)() / 2, "px;border-radius:", (0, $aP6k3.borderRadius)(), "px;max-width:100%;box-sizing:border-box;");
const $e7d62187b240c56e$export$e0d6e4370cabc21 = (0, $2xJU3.default)("div", {
    target: "eioz98c3"
})("display:flex;align-items:center;font-family:", (0, $aP6k3.codeFontFamily)(), ";> span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}");

});


parcelRegister("9hHuX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e354be7551f295b4$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $lepT7 = parcelRequire("lepT7");

var $5gF7V = parcelRequire("5gF7V");

var $abRa1 = parcelRequire("abRa1");

var $9xBn1 = parcelRequire("9xBn1");

var $eEasA = parcelRequire("eEasA");

var $7gyAE = parcelRequire("7gyAE");
const $e354be7551f295b4$export$6f70d30dd58be0fa = 100;
var $e354be7551f295b4$export$2e2bcd8739ae039;
$e354be7551f295b4$export$2e2bcd8739ae039 = class SelectRepository extends (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).PureComponent {
    constructor(...args){
        super(...args);
        this.state = {
            options: []
        };
        this.handleSelectRepository = (option, _action)=>{
            this.props.onChangeRepository(option);
        };
        this.handleInputChange = (inputValue)=>{
            this.setOptions(inputValue);
        };
        this.getFilteredOptions = (predicate)=>{
            const { intl: intl } = this.props;
            const { values: values, hasMore: hasMore } = (0, $abRa1.limit)(this.props.repositorySelector.repositories, $e354be7551f295b4$export$6f70d30dd58be0fa, predicate);
            if (hasMore) values.push({
                value: "",
                label: intl.formatMessage((0, $9xBn1.default).repositorySelectorMoreOptions),
                isDisabled: true,
                data: undefined
            });
            return values;
        };
    }
    componentDidUpdate(prevProps) {
        if (this.props.repositorySelector.repositories !== prevProps.repositorySelector.repositories) this.setOptions();
    }
    setOptions(inputValue = "") {
        let options;
        if (!inputValue) options = this.getFilteredOptions();
        else options = this.getFilteredOptions((option)=>(0, $abRa1.optionFilter)(option, inputValue));
        this.setState({
            options: options
        });
    }
    render() {
        const { intl: intl, isCreating: isCreating, repositorySelector: { loadingState: loadingState, repositories: repositories, selected: selected } } = this.props;
        let placeholder = null;
        if (loadingState === (0, $5gF7V.LOADING_STATE).SUCCESS && !repositories.length) placeholder = intl.formatMessage((0, $9xBn1.default).repositorySelectorNoRepositories);
        else if (loadingState === (0, $5gF7V.LOADING_STATE).ERROR) placeholder = intl.formatMessage((0, $9xBn1.default).repositorySelectorLoadError);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eEasA.FieldWrapper, {
            id: "select-repository"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($eEasA.FormLabel, null, intl.formatMessage((0, $9xBn1.default).repositoryLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $lepT7.default), {
            backspaceRemovesValue: false,
            components: {
                Option: (0, $7gyAE.CustomSelectOption)
            },
            filterOption: null,
            isDisabled: isCreating || placeholder !== null,
            isLoading: loadingState === (0, $5gF7V.LOADING_STATE).LOADING,
            noOptionsMessage: ()=>intl.formatMessage((0, $9xBn1.default).repositorySelectorNoMatches),
            onChange: this.handleSelectRepository,
            onClickPreventDefault: false,
            onInputChange: this.handleInputChange,
            options: this.state.options,
            placeholder: placeholder,
            value: selected
        }));
    }
};

});


parcelRegister("8x7qc", function(module, exports) {

$parcel$export(module.exports, "CreateBranchActions", function () { return $53944e945d35b998$export$a66cef3a8b6c6723; });

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $hwElN = parcelRequire("hwElN");

var $EKmRU = parcelRequire("EKmRU");

var $5gF7V = parcelRequire("5gF7V");

var $9xBn1 = parcelRequire("9xBn1");
const $53944e945d35b998$export$a66cef3a8b6c6723 = ({ isLoading: isLoading, onCreate: onCreate, onCancel: onCancel, isSaveDisabled: isSaveDisabled, isCancelDisabled: isCancelDisabled })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $hwElN.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $EKmRU.default), {
        id: "create-branch-button",
        form: (0, $5gF7V.CREATE_BRANCH_FORM_ID),
        type: "submit",
        appearance: "primary",
        onClick: onCreate,
        isDisabled: isSaveDisabled,
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, $9xBn1.default).createButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $EKmRU.default), {
        id: "cancel-create-branch-button",
        appearance: "subtle",
        onClick: onCancel,
        isDisabled: isCancelDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, $9xBn1.default).cancelButton)));
};

});

parcelRegister("3KeTq", function(module, exports) {

$parcel$export(module.exports, "CreateBranchForm", function () { return $f058ced3e4bc2c5e$export$6ae2db88f78a9305; });

var $9nHZC = parcelRequire("9nHZC");

var $5gF7V = parcelRequire("5gF7V");
class $f058ced3e4bc2c5e$export$6ae2db88f78a9305 extends (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).PureComponent {
    constructor(...args){
        super(...args);
        this.handleSubmit = (e)=>{
            e.preventDefault();
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("form", {
            id: (0, $5gF7V.CREATE_BRANCH_FORM_ID),
            onSubmit: this.handleSubmit
        }, this.props.children);
    }
}

});


parcelRegister("fqfFF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fd2701354577d64$export$2e2bcd8739ae039; });
parcelRequire("dGzLf");
var $5oGLl = parcelRequire("5oGLl");
parcelRequire("9waDg");
var $1kvgs = parcelRequire("1kvgs");

var $gyx4R = parcelRequire("gyx4R");

var $8MnfV = parcelRequire("8MnfV");

var $aanBq = parcelRequire("aanBq");

var $5gF7V = parcelRequire("5gF7V");

var $abRa1 = parcelRequire("abRa1");
const $1fd2701354577d64$var$mapStateToProps = (state)=>{
    const { branchTypeSelector: branchTypeSelector, isCreating: isCreating, isRepoDialogOpen: isRepoDialogOpen, isGlobalDialogOpen: isGlobalDialogOpen, params: params, refSelector: refSelector, repositorySelector: repositorySelector, error: error, workflowBranches: workflowBranches } = state.createBranch;
    const newBranchName = (0, $abRa1.generateBranchName)(params.name, branchTypeSelector.selected);
    // We are disabled when:
    //   1. LOADING: branch type, branches or repositories
    //   2. ERROR: branches or repositories. When branch type is in error we just hide the type
    //          but let the user submit without the types.
    //   3. There is no new branch name.
    //   4. There is no target branch.
    const isDisabled = refSelector.loadingState !== (0, $5gF7V.LOADING_STATE).SUCCESS || repositorySelector.loadingState !== (0, $5gF7V.LOADING_STATE).SUCCESS || branchTypeSelector.loadingState === (0, $5gF7V.LOADING_STATE).LOADING || !newBranchName || !(params.target && params.target.hash);
    return {
        branchTypeSelector: branchTypeSelector,
        isRepoDialogOpen: isRepoDialogOpen,
        isGlobalDialogOpen: isGlobalDialogOpen,
        isCreating: isCreating,
        isDisabled: isDisabled,
        createParams: params,
        refSelector: (0, $gyx4R.getRefSelectorState)(state),
        repositorySelector: (0, $gyx4R.getRepositorySelectorState)(state),
        repositoryFullSlug: (0, $aanBq.getCurrentRepositoryFullSlug)(state),
        isBannerOpen: (0, $8MnfV.getIsSiteMessageActive)(state),
        newBranchName: newBranchName,
        error: error,
        workflowBranches: workflowBranches,
        userLevel: (0, $aanBq.getRepositoryAccessLevel)(state),
        focusedTaskBackButtonUrl: state.global.focusedTaskBackButtonUrl
    };
};
// @ts-ignore TODO: fix noImplicitAny error here
const $1fd2701354577d64$var$mapDispatchToProps = (dispatch)=>({
        openCreateBranchRepoDialog: ()=>dispatch((0, $1kvgs.openCreateBranchRepoDialog)()),
        openCreateBranchGlobalDialog: ()=>dispatch((0, $1kvgs.openCreateBranchGlobalDialog)()),
        closeCreateBranchRepoDialog: ()=>dispatch((0, $1kvgs.closeCreateBranchRepoDialog)()),
        closeCreateBranchGlobalDialog: ()=>dispatch((0, $1kvgs.closeCreateBranchGlobalDialog)()),
        onChangeBranchType: (payload)=>dispatch((0, $1kvgs.changeBranchType)(payload)),
        onChangeFromBranch: (branch)=>dispatch((0, $1kvgs.changeFromBranch)(branch)),
        onChangeNewBranchName: (name)=>dispatch((0, $1kvgs.changeNewBranchName)(name)),
        onCreate: (payload)=>dispatch((0, $1kvgs.createBranch)(payload)),
        onFetchCommitStatuses: ()=>dispatch((0, $1kvgs.fetchCommitStatuses)()),
        onChangeRepository: (payload)=>dispatch((0, $1kvgs.onChangeRepository)(payload)),
        setCurrentRepository: ()=>dispatch((0, $1kvgs.setCurrentRepository)()),
        loadRepositories: ()=>dispatch((0, $1kvgs.loadRepositories)()),
        setJiraIssue: (jiraIssue)=>{
            if (jiraIssue) dispatch((0, $1kvgs.setJiraIssue)(jiraIssue));
        }
    });
var $1fd2701354577d64$export$2e2bcd8739ae039 = (0, $5oGLl.default)($1fd2701354577d64$var$mapStateToProps, $1fd2701354577d64$var$mapDispatchToProps);

});
parcelRegister("gyx4R", function(module, exports) {

$parcel$export(module.exports, "getCreateBranchParams", function () { return $493dda654819ebbf$export$70fe52ac8efd7652; });
$parcel$export(module.exports, "getBranchTypesVisible", function () { return $493dda654819ebbf$export$76144ab1cfe978d3; });
$parcel$export(module.exports, "getSelectedRepoFullSlug", function () { return $493dda654819ebbf$export$ac001011e85c5637; });
$parcel$export(module.exports, "getSelectedRepoOwnerAndSlug", function () { return $493dda654819ebbf$export$b8f287cf5438da01; });
$parcel$export(module.exports, "getSelectedBranchType", function () { return $493dda654819ebbf$export$6ef3fde2ed4b8254; });
$parcel$export(module.exports, "getJiraIssue", function () { return $493dda654819ebbf$export$d7bc930185d48cf7; });
$parcel$export(module.exports, "getRefSelectorState", function () { return $493dda654819ebbf$export$c07a08102c8008af; });
$parcel$export(module.exports, "getRepositorySelectorState", function () { return $493dda654819ebbf$export$e21f42390548128a; });
$parcel$export(module.exports, "getSelectedRepositoryMainBranch", function () { return $493dda654819ebbf$export$5945d8ea53227836; });
$parcel$export(module.exports, "getWorkflowBranches", function () { return $493dda654819ebbf$export$3609526c15ff0c2f; });

var $aXXtM = parcelRequire("aXXtM");

var $abRa1 = parcelRequire("abRa1");
const $493dda654819ebbf$export$70fe52ac8efd7652 = (state)=>state.createBranch.params;
const $493dda654819ebbf$export$76144ab1cfe978d3 = (state)=>state.createBranch.branchTypeSelector.isVisible;
const $493dda654819ebbf$export$ac001011e85c5637 = (state)=>{
    const { selected: selected } = state.createBranch.repositorySelector;
    return selected ? selected.value : "";
};
const $493dda654819ebbf$export$b8f287cf5438da01 = (state)=>{
    const { selected: selected } = state.createBranch.repositorySelector;
    return (0, $abRa1.getRepoOwnerAndSlug)((selected || {}).value);
};
const $493dda654819ebbf$export$72675fce44ecc4a2 = (state)=>{
    return state.createBranch.branchTypeSelector.branchTypes;
};
const $493dda654819ebbf$export$6ef3fde2ed4b8254 = (state)=>{
    return state.createBranch.branchTypeSelector.selected;
};
const $493dda654819ebbf$export$d7bc930185d48cf7 = (state)=>{
    return state.createBranch.issue;
};
const $493dda654819ebbf$export$c07a08102c8008af = (state)=>state.createBranch.refSelector;
const $493dda654819ebbf$export$e21f42390548128a = (state)=>state.createBranch.repositorySelector;
const $493dda654819ebbf$export$45296d91cbb7cbb8 = (0, $aXXtM.createSelector)($493dda654819ebbf$export$e21f42390548128a, (state)=>state.selectedDetails);
const $493dda654819ebbf$export$5945d8ea53227836 = (0, $aXXtM.createSelector)($493dda654819ebbf$export$45296d91cbb7cbb8, (details)=>details ? details.mainbranch : null);
const $493dda654819ebbf$export$3609526c15ff0c2f = (state)=>state.createBranch.workflowBranches;

});


parcelRegister("8FAjc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64fe51305d8df26e$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9q1kH = parcelRequire("9q1kH");

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $aa6gv = parcelRequire("aa6gv");

var $7irku = parcelRequire("7irku");

var $l0KJe = parcelRequire("l0KJe");

var $4yc47 = parcelRequire("4yc47");

var $4nGYJ = parcelRequire("4nGYJ");
var $64fe51305d8df26e$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isSelected",
    "shouldFitContainer",
    "spacing",
    "isLoading",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseDown",
    "onMouseUp",
    "onFocus",
    "onBlur",
    "theme"
];
function $64fe51305d8df26e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $64fe51305d8df26e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $64fe51305d8df26e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $64fe51305d8df26e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $64fe51305d8df26e$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return "disabled";
    if (isSelected && isFocus) return "focusSelected";
    if (isSelected) return "selected";
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return "active";
    if (!isLoading && isHover) return "hover";
    if (isFocus) return "focus";
    return "default";
}
var $64fe51305d8df26e$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var $64fe51305d8df26e$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $4nGYJ.defaultThemeFn) : _ref2$theme, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref2, $64fe51305d8df26e$var$_excluded);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $64fe51305d8df26e$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $9nHZC.useState)($64fe51305d8df26e$var$initial), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $64fe51305d8df26e$var$_objectSpread($64fe51305d8df26e$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $64fe51305d8df26e$var$_objectSpread($64fe51305d8df26e$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $64fe51305d8df26e$var$_objectSpread($64fe51305d8df26e$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $64fe51305d8df26e$var$_objectSpread($64fe51305d8df26e$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $64fe51305d8df26e$var$_objectSpread($64fe51305d8df26e$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $64fe51305d8df26e$var$_objectSpread($64fe51305d8df26e$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $4nGYJ.default).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aa6gv.default).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $4nGYJ.default).Consumer, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            mode: mode,
            state: $64fe51305d8df26e$var$getInteractionState($64fe51305d8df26e$var$_objectSpread($64fe51305d8df26e$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $l0KJe.default)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7irku.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $4yc47.default), restProps) : null,
                "aria-disabled": isLoading || restProps["aria-disabled"],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $4nGYJ.getSpecifiers)(buttonStyles)
            }));
        });
    }));
}));
// Tools including enzyme rely on components having a display name
$64fe51305d8df26e$var$CustomThemeButton.displayName = "CustomThemeButton";
var $64fe51305d8df26e$export$2e2bcd8739ae039 = $64fe51305d8df26e$var$CustomThemeButton;

});
parcelRegister("aa6gv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $765fb2b1dbcaf6a1$export$2e2bcd8739ae039; });

var $5tHdD = parcelRequire("5tHdD");
// Create default global light theme
var $765fb2b1dbcaf6a1$var$_createTheme = (0, $5tHdD.createTheme)(function() {
    return {
        mode: "light"
    };
}), $765fb2b1dbcaf6a1$var$Provider = $765fb2b1dbcaf6a1$var$_createTheme.Provider, $765fb2b1dbcaf6a1$var$Consumer = $765fb2b1dbcaf6a1$var$_createTheme.Consumer, $765fb2b1dbcaf6a1$export$7692396083754928 = $765fb2b1dbcaf6a1$var$_createTheme.useTheme;
var $765fb2b1dbcaf6a1$var$Theme = {
    Provider: $765fb2b1dbcaf6a1$var$Provider,
    Consumer: $765fb2b1dbcaf6a1$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$765fb2b1dbcaf6a1$export$2e2bcd8739ae039 = $765fb2b1dbcaf6a1$var$Theme;

});
parcelRegister("5tHdD", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $3fd12f910fcd777d$export$25d302a5b900a763; });

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");
var $3fd12f910fcd777d$var$_excluded = [
    "children"
];
function $3fd12f910fcd777d$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $9nHZC.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $9nHZC.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(props, $3fd12f910fcd777d$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $9nHZC.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $9nHZC.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("7irku", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54ff69e7dd3a38ec$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $gQHZ5 = parcelRequire("gQHZ5");

var $8p2GL = parcelRequire("8p2GL");

var $grYZC = parcelRequire("grYZC");

var $dxhCu = parcelRequire("dxhCu");

var $5fUc4 = parcelRequire("5fUc4");

var $8eKJ0 = parcelRequire("8eKJ0");

var $bSs4J = parcelRequire("bSs4J");

var $7J0kn = parcelRequire("7J0kn");

var $R0ZTR = parcelRequire("R0ZTR");
var $54ff69e7dd3a38ec$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $54ff69e7dd3a38ec$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform.design-system-team.enable-new-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $54ff69e7dd3a38ec$var$iconBeforeSpacingFixStyle = (0, $avKww.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $54ff69e7dd3a38ec$var$iconAfterSpacingFixStyle = (0, $avKww.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $54ff69e7dd3a38ec$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $R0ZTR.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $54ff69e7dd3a38ec$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $R0ZTR.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $avKww.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $54ff69e7dd3a38ec$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $8p2GL.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $8p2GL.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(props, $54ff69e7dd3a38ec$var$_excluded);
    var ourRef = (0, $9nHZC.useRef)();
    var setRef = (0, $9nHZC.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $grYZC.default)(ourRef, autoFocus);
    var interactionContext = (0, $9nHZC.useContext)((0, $5fUc4.default));
    var handleClick = (0, $9nHZC.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $gQHZ5.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "19.2.1",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $9nHZC.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $9nHZC.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $avKww.css)((0, $7J0kn.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === "warning") spinnerHackCss = {
        "[data-theme] & circle": {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $8eKJ0.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $8eKJ0.N500), ")"), " !important")
        }
    };
    return (0, $avKww.jsx)((0, $dxhCu.default), null, (0, $avKww.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $54ff69e7dd3a38ec$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $bSs4J.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $avKww.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $7J0kn.getIconStyle)({
                spacing: spacing
            }),
            $54ff69e7dd3a38ec$var$getSpacingFix(children, $54ff69e7dd3a38ec$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $54ff69e7dd3a38ec$var$getChildren(children, [
        fadeStyles,
        (0, $7J0kn.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $avKww.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $7J0kn.getIconStyle)({
                spacing: spacing
            }),
            $54ff69e7dd3a38ec$var$getSpacingFix(children, $54ff69e7dd3a38ec$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $avKww.jsx)("span", {
        css: [
            (0, $7J0kn.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$54ff69e7dd3a38ec$export$2e2bcd8739ae039 = $54ff69e7dd3a38ec$var$ButtonBase;

});
parcelRegister("gQHZ5", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $c4439f08ef842662$export$a4687b0234b40e28; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $iVRsR = parcelRequire("iVRsR");

var $fvFqa = parcelRequire("fvFqa");
function $c4439f08ef842662$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c4439f08ef842662$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c4439f08ef842662$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c4439f08ef842662$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c4439f08ef842662$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $iVRsR.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $fvFqa.useTrackedRef)(analyticsData);
    var fnRef = (0, $fvFqa.useTrackedRef)(fn);
    var handler = (0, $9nHZC.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $c4439f08ef842662$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("iVRsR", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $dc8705ccf8d54c10$export$5bf35293e545f20c; });

var $dNznA = parcelRequire("dNznA");

var $kIOd4 = parcelRequire("kIOd4");

var $fIHZx = parcelRequire("fIHZx");
function $dc8705ccf8d54c10$export$5bf35293e545f20c() {
    var analyticsContext = (0, $fIHZx.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $kIOd4.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("kIOd4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f15edd53dea3a3a0$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $803Cg = parcelRequire("803Cg");
function $f15edd53dea3a3a0$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f15edd53dea3a3a0$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $f15edd53dea3a3a0$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f15edd53dea3a3a0$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $f15edd53dea3a3a0$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $f15edd53dea3a3a0$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $f15edd53dea3a3a0$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $f15edd53dea3a3a0$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $803Cg.default));

});
parcelRegister("803Cg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d3120e47f420f4e$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
function $5d3120e47f420f4e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5d3120e47f420f4e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5d3120e47f420f4e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5d3120e47f420f4e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5d3120e47f420f4e$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $5d3120e47f420f4e$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $5d3120e47f420f4e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $5d3120e47f420f4e$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(updater) === "object") this.payload = $5d3120e47f420f4e$var$_objectSpread($5d3120e47f420f4e$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("fIHZx", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $b71d16dba12c12f0$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $b71d16dba12c12f0$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});


parcelRegister("fvFqa", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $b4a9e1a10162e12e$export$1d27a74659855e44; });

var $9nHZC = parcelRequire("9nHZC");
var $b4a9e1a10162e12e$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("8eKJ0", function(module, exports) {

$parcel$export(module.exports, "R300", function () { return $5ff3e024ecd9c2d4$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $5ff3e024ecd9c2d4$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $5ff3e024ecd9c2d4$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y200", function () { return $5ff3e024ecd9c2d4$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $5ff3e024ecd9c2d4$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $5ff3e024ecd9c2d4$export$59619663aa6500fb; });
$parcel$export(module.exports, "B50", function () { return $5ff3e024ecd9c2d4$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $5ff3e024ecd9c2d4$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $5ff3e024ecd9c2d4$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $5ff3e024ecd9c2d4$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $5ff3e024ecd9c2d4$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $5ff3e024ecd9c2d4$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $5ff3e024ecd9c2d4$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "N0", function () { return $5ff3e024ecd9c2d4$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $5ff3e024ecd9c2d4$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N70", function () { return $5ff3e024ecd9c2d4$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N90", function () { return $5ff3e024ecd9c2d4$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N200", function () { return $5ff3e024ecd9c2d4$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N400", function () { return $5ff3e024ecd9c2d4$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $5ff3e024ecd9c2d4$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $5ff3e024ecd9c2d4$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $5ff3e024ecd9c2d4$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $5ff3e024ecd9c2d4$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $5ff3e024ecd9c2d4$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN400", function () { return $5ff3e024ecd9c2d4$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $5ff3e024ecd9c2d4$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN100", function () { return $5ff3e024ecd9c2d4$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN70", function () { return $5ff3e024ecd9c2d4$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $5ff3e024ecd9c2d4$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN30", function () { return $5ff3e024ecd9c2d4$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN0", function () { return $5ff3e024ecd9c2d4$export$3d4f271a500072a; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $5ff3e024ecd9c2d4$export$4b84fd0e2c617bd = "#FFEBE6";
var $5ff3e024ecd9c2d4$export$b34b069eff244586 = "#FFBDAD";
var $5ff3e024ecd9c2d4$export$be802dd0d8b57f35 = "#FF8F73";
var $5ff3e024ecd9c2d4$export$60847d42f9da92a6 = "#FF7452";
var $5ff3e024ecd9c2d4$export$4a7404f376229999 = "#FF5630";
var $5ff3e024ecd9c2d4$export$2010d0fb4295b346 = "#DE350B";
var $5ff3e024ecd9c2d4$export$2837b5a1a71d5c02 = "#BF2600";
var $5ff3e024ecd9c2d4$export$8d9596b529bbb9cf = "#FFFAE6";
var $5ff3e024ecd9c2d4$export$41060a744ab0b7ae = "#FFF0B3";
var $5ff3e024ecd9c2d4$export$1cc05bbbf340e559 = "#FFE380";
var $5ff3e024ecd9c2d4$export$5aae31392d72caaa = "#FFC400";
var $5ff3e024ecd9c2d4$export$c6930421db9fa514 = "#FFAB00";
var $5ff3e024ecd9c2d4$export$59619663aa6500fb = "#FF991F";
var $5ff3e024ecd9c2d4$export$874739ea9e379ab6 = "#FF8B00";
var $5ff3e024ecd9c2d4$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $5ff3e024ecd9c2d4$export$69a3bf21b9686c2b = "#ABF5D1";
var $5ff3e024ecd9c2d4$export$afbce1382ec95f73 = "#79F2C0";
var $5ff3e024ecd9c2d4$export$747d86715d4175de = "#57D9A3";
var $5ff3e024ecd9c2d4$export$940e1f69e873f202 = "#36B37E";
var $5ff3e024ecd9c2d4$export$a49394138f7b8e85 = "#00875A";
var $5ff3e024ecd9c2d4$export$6fa04827ac68a4fb = "#006644";
var $5ff3e024ecd9c2d4$export$226de0355ed012f8 = "#DEEBFF";
var $5ff3e024ecd9c2d4$export$8c13c2ee36917869 = "#B3D4FF";
var $5ff3e024ecd9c2d4$export$ecfc1dff386a3e7a = "#4C9AFF";
var $5ff3e024ecd9c2d4$export$215b7063051591f1 = "#2684FF";
var $5ff3e024ecd9c2d4$export$e62e8919cca44969 = "#0065FF";
var $5ff3e024ecd9c2d4$export$b3de0ae08da2ce64 = "#0052CC";
var $5ff3e024ecd9c2d4$export$a6ee3d71bc067634 = "#0747A6";
var $5ff3e024ecd9c2d4$export$363e4475840015bb = "#EAE6FF";
var $5ff3e024ecd9c2d4$export$4b0a4417ed59760f = "#C0B6F2";
var $5ff3e024ecd9c2d4$export$6011520a64d9a187 = "#998DD9";
var $5ff3e024ecd9c2d4$export$a7175d4e9206bc80 = "#8777D9";
var $5ff3e024ecd9c2d4$export$b48405b95304b5a1 = "#6554C0";
var $5ff3e024ecd9c2d4$export$c71e4279dd54a18d = "#5243AA";
var $5ff3e024ecd9c2d4$export$147899de772240ec = "#403294";
var $5ff3e024ecd9c2d4$export$2cf711fe14c66f06 = "#E6FCFF";
var $5ff3e024ecd9c2d4$export$7a8f4d33f6f9772c = "#B3F5FF";
var $5ff3e024ecd9c2d4$export$776c9c497ef08533 = "#79E2F2";
var $5ff3e024ecd9c2d4$export$69cb3ca10c1e330e = "#00C7E6";
var $5ff3e024ecd9c2d4$export$9dc1ef0f3f48059b = "#00B8D9";
var $5ff3e024ecd9c2d4$export$7c835c78b6fcdef8 = "#00A3BF";
var $5ff3e024ecd9c2d4$export$6036577f95c3877e = "#008DA6";
var $5ff3e024ecd9c2d4$export$29a4f05edc054374 = "#FFFFFF";
var $5ff3e024ecd9c2d4$export$e655ef011c4aa1a2 = "#FAFBFC";
var $5ff3e024ecd9c2d4$export$9fdfb749e33cdf97 = "#F4F5F7";
var $5ff3e024ecd9c2d4$export$3e51e8f1440314ba = "#EBECF0";
var $5ff3e024ecd9c2d4$export$1ce2d1575d444ceb = "#DFE1E6";
var $5ff3e024ecd9c2d4$export$8754fc7e6d8b3000 = "#C1C7D0";
var $5ff3e024ecd9c2d4$export$c2e91cbeada39b8b = "#B3BAC5";
var $5ff3e024ecd9c2d4$export$5f71e19f3a7ad9de = "#A5ADBA";
var $5ff3e024ecd9c2d4$export$eaa8c8a70ac22806 = "#97A0AF";
var $5ff3e024ecd9c2d4$export$7c87d337fb91a97d = "#8993A4";
var $5ff3e024ecd9c2d4$export$d6447c357493214f = "#7A869A";
var $5ff3e024ecd9c2d4$export$f563ee71e9ee74cd = "#6B778C";
var $5ff3e024ecd9c2d4$export$e2ef2124cf4024b1 = "#5E6C84";
var $5ff3e024ecd9c2d4$export$eece5f492e429f08 = "#505F79";
var $5ff3e024ecd9c2d4$export$c39c0fe0f26207ae = "#42526E";
var $5ff3e024ecd9c2d4$export$7090862dc3038a9f = "#344563";
var $5ff3e024ecd9c2d4$export$ad0bacf983b7ddaa = "#253858";
var $5ff3e024ecd9c2d4$export$7d61b15e0da132af = "#172B4D";
var $5ff3e024ecd9c2d4$export$fbda843f0a27fe96 = "#091E42";
var $5ff3e024ecd9c2d4$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $5ff3e024ecd9c2d4$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $5ff3e024ecd9c2d4$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $5ff3e024ecd9c2d4$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $5ff3e024ecd9c2d4$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $5ff3e024ecd9c2d4$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $5ff3e024ecd9c2d4$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $5ff3e024ecd9c2d4$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $5ff3e024ecd9c2d4$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $5ff3e024ecd9c2d4$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $5ff3e024ecd9c2d4$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $5ff3e024ecd9c2d4$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $5ff3e024ecd9c2d4$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $5ff3e024ecd9c2d4$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $5ff3e024ecd9c2d4$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $5ff3e024ecd9c2d4$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $5ff3e024ecd9c2d4$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $5ff3e024ecd9c2d4$export$2f6319cf7d736c2a = "#E6EDFA";
var $5ff3e024ecd9c2d4$export$95126bc8884d6634 = "#DCE5F5";
var $5ff3e024ecd9c2d4$export$8338d8c35d44ff1 = "#CED9EB";
var $5ff3e024ecd9c2d4$export$5368d76ae4fbbda7 = "#B8C7E0";
var $5ff3e024ecd9c2d4$export$9f0a771d16ec8d36 = "#ABBBD6";
var $5ff3e024ecd9c2d4$export$abcf8c38338b4aa5 = "#9FB0CC";
var $5ff3e024ecd9c2d4$export$97e81faa16a182c7 = "#8C9CB8";
var $5ff3e024ecd9c2d4$export$bfe21c59123ecf33 = "#7988A3";
var $5ff3e024ecd9c2d4$export$ee82aa2ea6a1558 = "#67758F";
var $5ff3e024ecd9c2d4$export$682927c6ed76be02 = "#56637A";
var $5ff3e024ecd9c2d4$export$91fd9994c5be9757 = "#455166";
var $5ff3e024ecd9c2d4$export$d281fbfe3cff2df6 = "#3B475C";
var $5ff3e024ecd9c2d4$export$3902c91d8b98a753 = "#313D52";
var $5ff3e024ecd9c2d4$export$8e8133c1ba5845b5 = "#283447";
var $5ff3e024ecd9c2d4$export$33ff357f6620b39 = "#202B3D";
var $5ff3e024ecd9c2d4$export$633847cf062b69e0 = "#1B2638";
var $5ff3e024ecd9c2d4$export$9776a6e503bdbf76 = "#121A29";
var $5ff3e024ecd9c2d4$export$6c813d5160dff5db = "#0E1624";
var $5ff3e024ecd9c2d4$export$3d4f271a500072a = "#0D1424";
var $5ff3e024ecd9c2d4$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $5ff3e024ecd9c2d4$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $5ff3e024ecd9c2d4$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $5ff3e024ecd9c2d4$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $5ff3e024ecd9c2d4$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $5ff3e024ecd9c2d4$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $5ff3e024ecd9c2d4$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $5ff3e024ecd9c2d4$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $5ff3e024ecd9c2d4$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $5ff3e024ecd9c2d4$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $5ff3e024ecd9c2d4$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $5ff3e024ecd9c2d4$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $5ff3e024ecd9c2d4$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $5ff3e024ecd9c2d4$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $5ff3e024ecd9c2d4$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $5ff3e024ecd9c2d4$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $5ff3e024ecd9c2d4$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";

});

parcelRegister("bSs4J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a5a8405c4ee8173$export$2e2bcd8739ae039; });
function $8a5a8405c4ee8173$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $8a5a8405c4ee8173$var$tabKeyCode = 9;
function $8a5a8405c4ee8173$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $8a5a8405c4ee8173$var$tabKeyCode) return;
    $8a5a8405c4ee8173$var$abort(event);
}
var $8a5a8405c4ee8173$var$block = {
    onMouseDownCapture: $8a5a8405c4ee8173$var$abort,
    onMouseUpCapture: $8a5a8405c4ee8173$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $8a5a8405c4ee8173$var$onKey,
    onKeyUpCapture: $8a5a8405c4ee8173$var$onKey,
    onTouchStartCapture: $8a5a8405c4ee8173$var$abort,
    onTouchEndCapture: $8a5a8405c4ee8173$var$abort,
    onPointerDownCapture: $8a5a8405c4ee8173$var$abort,
    onPointerUpCapture: $8a5a8405c4ee8173$var$abort,
    onClickCapture: $8a5a8405c4ee8173$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $8a5a8405c4ee8173$var$abort
};
var $8a5a8405c4ee8173$var$doNotBlock = {};
function $8a5a8405c4ee8173$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $8a5a8405c4ee8173$var$doNotBlock : $8a5a8405c4ee8173$var$block;
}

});

parcelRegister("7J0kn", function(module, exports) {

$parcel$export(module.exports, "getCss", function () { return $59fcfd7396144970$export$955358618f994a11; });
$parcel$export(module.exports, "getIconStyle", function () { return $59fcfd7396144970$export$864eea3f4ec3368f; });
$parcel$export(module.exports, "getContentStyle", function () { return $59fcfd7396144970$export$7ad0316cc0dd65a; });
$parcel$export(module.exports, "getFadingCss", function () { return $59fcfd7396144970$export$1b5827d324e945b1; });
$parcel$export(module.exports, "overlayCss", function () { return $59fcfd7396144970$export$1a9fe1b84c876bb5; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $g8qbw = parcelRequire("g8qbw");

var $85rTR = parcelRequire("85rTR");

var $lth26 = parcelRequire("lth26");
function $59fcfd7396144970$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $59fcfd7396144970$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $59fcfd7396144970$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $59fcfd7396144970$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $59fcfd7396144970$var$gridSize = (0, $85rTR.gridSize)();
var $59fcfd7396144970$var$HAS_DISABLED_BACKGROUND = [
    "default",
    "primary",
    "danger",
    "warning"
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $59fcfd7396144970$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: "auto"
};
var $59fcfd7396144970$var$lineHeights = {
    default: $59fcfd7396144970$var$heights.default,
    compact: $59fcfd7396144970$var$heights.compact,
    none: "inherit"
};
var $59fcfd7396144970$var$padding = {
    // 10px gutter
    default: "0 ".concat($59fcfd7396144970$var$gridSize + $59fcfd7396144970$var$gridSize / 4, "px"),
    compact: "0 ".concat($59fcfd7396144970$var$gridSize + $59fcfd7396144970$var$gridSize / 4, "px"),
    none: "0"
};
var $59fcfd7396144970$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($59fcfd7396144970$var$gridSize / 4, "px"),
    default: "0 ".concat($59fcfd7396144970$var$gridSize / 4, "px"),
    none: "0"
};
var $59fcfd7396144970$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $59fcfd7396144970$var$innerMargin = {
    content: "0 ".concat($59fcfd7396144970$var$gridSize / 4, "px"),
    icon: "0 ".concat($59fcfd7396144970$var$gridSize / 4, "px")
};
var $59fcfd7396144970$var$defaultAfterStyles = {
    borderRadius: "inherit",
    inset: "var(--ds-space-0, 0px)",
    borderStyle: "solid",
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: "none",
    position: "absolute"
};
var $59fcfd7396144970$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #172B4D)",
    "&:not([disabled])::after": $59fcfd7396144970$var$_objectSpread($59fcfd7396144970$var$_objectSpread({}, $59fcfd7396144970$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #091E4224)"
    }),
    "&:hover": {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    }
};
var $59fcfd7396144970$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #0C66E4)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
    },
    "&:active": {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
    }
};
var $59fcfd7396144970$var$linkStyles = {
    background: "transparent",
    color: "var(--ds-link, #0C66E4)",
    "&:hover": {
        color: "var(--ds-link, #0C66E4)",
        textDecoration: "underline"
    },
    "&:active": {
        color: "var(--ds-link-pressed, #0055CC)",
        textDecoration: "underline"
    }
};
var $59fcfd7396144970$var$subtleStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    }
};
var $59fcfd7396144970$var$subtleLinkStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "transparent",
        color: "var(--ds-text-subtle, #44546F)",
        textDecoration: "underline"
    },
    "&:active": {
        background: "transparent",
        color: "var(--ds-text, #172B4D)",
        textDecoration: "underline"
    }
};
var $59fcfd7396144970$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #F5CD47)",
    color: "var(--ds-text-warning-inverse, #172B4D)",
    "&:hover": {
        background: "var(--ds-background-warning-bold-hovered, #E2B203)"
    },
    "&:active": {
        background: "var(--ds-background-warning-bold-pressed, #CF9F02)"
    }
};
var $59fcfd7396144970$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    "&:active": {
        background: "var(--ds-background-danger-bold-pressed, #5D1F1A)"
    }
};
var $59fcfd7396144970$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "var(--ds-text-selected, #0C66E4)",
    "&:not([disabled])::after": $59fcfd7396144970$var$_objectSpread($59fcfd7396144970$var$_objectSpread({}, $59fcfd7396144970$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #0C66E4)"
    })
};
var $59fcfd7396144970$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: "default",
        textDecoration: "none"
    }
};
function $59fcfd7396144970$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $59fcfd7396144970$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $59fcfd7396144970$var$getColor({
            group: (0, $lth26.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($59fcfd7396144970$var$getColor({
            group: (0, $lth26.default).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $59fcfd7396144970$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $59fcfd7396144970$var$getColors({
        appearance: appearance,
        key: isSelected ? "selected" : "default",
        mode: mode
    });
    return $59fcfd7396144970$var$_objectSpread($59fcfd7396144970$var$_objectSpread($59fcfd7396144970$var$_objectSpread($59fcfd7396144970$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: 500,
        // margin for button has been applied to css reset
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap"
    }, !(0, $g8qbw.fg)("platform-component-visual-refresh") && baseColors), {}, {
        cursor: "pointer",
        height: $59fcfd7396144970$var$heights[spacing],
        lineHeight: $59fcfd7396144970$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $59fcfd7396144970$var$singleIconPadding[spacing] : $59fcfd7396144970$var$padding[spacing],
        verticalAlign: $59fcfd7396144970$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center"
    }, !(0, $g8qbw.fg)("platform-component-visual-refresh") && $59fcfd7396144970$var$_objectSpread($59fcfd7396144970$var$_objectSpread({
        // Disabling visited styles (just using the base colors)
        "&:visited": $59fcfd7396144970$var$_objectSpread({}, baseColors),
        "&:hover": $59fcfd7396144970$var$_objectSpread($59fcfd7396144970$var$_objectSpread({}, $59fcfd7396144970$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "hover",
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "inherit",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        // giving active styles preference by listing them after focus
        "&:active": $59fcfd7396144970$var$_objectSpread($59fcfd7396144970$var$_objectSpread({}, $59fcfd7396144970$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $59fcfd7396144970$var$_objectSpread($59fcfd7396144970$var$_objectSpread({}, $59fcfd7396144970$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        "&[disabled]": $59fcfd7396144970$var$_objectSpread($59fcfd7396144970$var$_objectSpread({}, $59fcfd7396144970$var$getColors({
            appearance: appearance,
            key: "disabled",
            mode: mode
        })), {}, {
            cursor: "not-allowed",
            textDecoration: "none"
        })
    }, $59fcfd7396144970$var$hasOverlayStyles), {}, {
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $59fcfd7396144970$var$_objectSpread({}, $59fcfd7396144970$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "default",
            mode: mode
        }))
    })), (0, $g8qbw.fg)("platform-component-visual-refresh") && (isSelected ? $59fcfd7396144970$var$selectedStyles : $59fcfd7396144970$var$_objectSpread($59fcfd7396144970$var$_objectSpread($59fcfd7396144970$var$_objectSpread($59fcfd7396144970$var$_objectSpread($59fcfd7396144970$var$_objectSpread($59fcfd7396144970$var$_objectSpread($59fcfd7396144970$var$_objectSpread($59fcfd7396144970$var$_objectSpread($59fcfd7396144970$var$_objectSpread({}, appearance === "default" && $59fcfd7396144970$var$defaultStyles), appearance === "primary" && $59fcfd7396144970$var$primaryStyles), appearance === "link" && $59fcfd7396144970$var$linkStyles), appearance === "subtle" && $59fcfd7396144970$var$subtleStyles), appearance === "subtle-link" && $59fcfd7396144970$var$subtleLinkStyles), appearance === "warning" && $59fcfd7396144970$var$warningStyles), appearance === "danger" && $59fcfd7396144970$var$dangerStyles), {}, {
        "&[disabled]": {
            color: "var(--ds-text-disabled, #091E424F)",
            backgroundColor: $59fcfd7396144970$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent",
            cursor: "not-allowed",
            textDecoration: "none",
            "&:hovered": {
                backgroundColor: $59fcfd7396144970$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            },
            "&:active": {
                backgroundColor: $59fcfd7396144970$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            }
        }
    }, $59fcfd7396144970$var$hasOverlayStyles), {}, {
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': {
            background: "inherit"
        }
    }))), {}, {
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $59fcfd7396144970$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $avKww.css)({
        display: "flex",
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $59fcfd7396144970$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: "center",
        fontSize: 0,
        lineHeight: 0,
        userSelect: "none"
    });
}
function $59fcfd7396144970$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $avKww.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $59fcfd7396144970$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    });
}
function $59fcfd7396144970$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $avKww.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: "opacity 0.3s"
    });
}
var $59fcfd7396144970$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

});
parcelRegister("g8qbw", function(module, exports) {

$parcel$export(module.exports, "getBooleanFF", function () { return $bbf1b4783f2c3b62$export$470e5c2be1411c89; });
$parcel$export(module.exports, "fg", function () { return $bbf1b4783f2c3b62$export$b40ec24ac8275656; });

var $lE7s5 = parcelRequire("lE7s5");
function $bbf1b4783f2c3b62$export$ba05d765b8392e5e(flagResolver) {
    (0, $lE7s5.setBooleanResolver)(flagResolver);
}
function $bbf1b4783f2c3b62$export$470e5c2be1411c89(name) {
    return (0, $lE7s5.resolveBooleanFlag)(name);
}
function $bbf1b4783f2c3b62$export$b40ec24ac8275656(name) {
    return (0, $lE7s5.resolveBooleanFlag)(name);
}

});
parcelRegister("lE7s5", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $fc231d3d33af1494$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $fc231d3d33af1494$export$6333b6aff9fc6275; });

var $eh5QQ = parcelRequire("eh5QQ");

var $8ovux = parcelRequire("8ovux");
var $fc231d3d33af1494$var$pkgName = "@atlaskit/platform-feature-flags";
var $fc231d3d33af1494$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $fc231d3d33af1494$var$hasProcessEnv = typeof $8ovux !== "undefined" && typeof $8ovux.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $fc231d3d33af1494$var$ENV_ENABLE_PLATFORM_FF = $fc231d3d33af1494$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $fc231d3d33af1494$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $fc231d3d33af1494$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $fc231d3d33af1494$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $fc231d3d33af1494$var$ENV_ENABLE_PLATFORM_FF || $fc231d3d33af1494$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $fc231d3d33af1494$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $fc231d3d33af1494$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$fc231d3d33af1494$var$globalVar[$fc231d3d33af1494$export$7e41b1b2bdee3f98] = $fc231d3d33af1494$var$globalVar[$fc231d3d33af1494$export$7e41b1b2bdee3f98] || $fc231d3d33af1494$var$DEFAULT_PFF_GLOBAL;
function $fc231d3d33af1494$export$f2b591175b3e424c(resolver) {
    $fc231d3d33af1494$var$globalVar[$fc231d3d33af1494$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $fc231d3d33af1494$export$6333b6aff9fc6275(flagKey) {
    if ($fc231d3d33af1494$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $eh5QQ.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $fc231d3d33af1494$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $fc231d3d33af1494$var$globalVar[$fc231d3d33af1494$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("eh5QQ", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $a647312b854bdd21$export$1c9f709888824e05; });
var $a647312b854bdd21$var$_ref, $a647312b854bdd21$var$_process, $a647312b854bdd21$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $a647312b854bdd21$var$TESTS_MODE = ($a647312b854bdd21$var$_ref = (globalThis === null || globalThis === void 0 || ($a647312b854bdd21$var$_process = globalThis.process) === null || $a647312b854bdd21$var$_process === void 0 || ($a647312b854bdd21$var$_process = $a647312b854bdd21$var$_process.env) === null || $a647312b854bdd21$var$_process === void 0 ? void 0 : $a647312b854bdd21$var$_process.JEST_WORKER_ID) !== undefined, $a647312b854bdd21$var$_ref !== void 0) ? $a647312b854bdd21$var$_ref : false;
var $a647312b854bdd21$var$DEBUG_MODE = !$a647312b854bdd21$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($a647312b854bdd21$var$_process2 = globalThis.process) === null || $a647312b854bdd21$var$_process2 === void 0 || ($a647312b854bdd21$var$_process2 = $a647312b854bdd21$var$_process2.env) === null || $a647312b854bdd21$var$_process2 === void 0 ? void 0 : $a647312b854bdd21$var$_process2.NODE_ENV) !== "production";
var $a647312b854bdd21$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$a647312b854bdd21$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("85rTR", function(module, exports) {

$parcel$export(module.exports, "gridSize", function () { return $5e346eb1b503363a$export$6d8204c2cb2e06b8; });

var $1OnrY = parcelRequire("1OnrY");

var $8eKJ0 = parcelRequire("8eKJ0");
var $5e346eb1b503363a$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $5e346eb1b503363a$export$c93026a968943f95 = "light";
var $5e346eb1b503363a$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $5e346eb1b503363a$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $5e346eb1b503363a$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $5e346eb1b503363a$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $5e346eb1b503363a$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $5e346eb1b503363a$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $5e346eb1b503363a$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $5e346eb1b503363a$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $8eKJ0.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $5e346eb1b503363a$export$6d8204c2cb2e06b8() / 4;
    (0, $1OnrY.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $5e346eb1b503363a$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $5e346eb1b503363a$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $5e346eb1b503363a$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $1OnrY.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $5e346eb1b503363a$export$ba1d834b86d72a09 = $5e346eb1b503363a$export$a1b3edb637fb4f35;
var $5e346eb1b503363a$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $8eKJ0.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $8eKJ0.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $8eKJ0.N30A), ")")
            }
        }
    };
};

});

parcelRegister("lth26", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa1984c3ae3bea04$export$2e2bcd8739ae039; });

var $8eKJ0 = parcelRequire("8eKJ0");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $fa1984c3ae3bea04$var$fadedB75 = "rgba(179, 212, 255, 0.6)";
var $fa1984c3ae3bea04$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($8eKJ0.N20A, ")"),
                dark: "var(--ds-background-neutral, ".concat($8eKJ0.DN70, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($8eKJ0.N30A, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($8eKJ0.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($fa1984c3ae3bea04$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($8eKJ0.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($8eKJ0.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($8eKJ0.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($8eKJ0.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($8eKJ0.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($8eKJ0.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($8eKJ0.DN0, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($8eKJ0.B400, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($8eKJ0.B100, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($8eKJ0.B300, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($8eKJ0.B75, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($8eKJ0.B500, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($8eKJ0.B200, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($8eKJ0.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($8eKJ0.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($8eKJ0.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($8eKJ0.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($8eKJ0.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($8eKJ0.DN0, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($8eKJ0.Y300, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($8eKJ0.Y300, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($8eKJ0.Y200, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($8eKJ0.Y200, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($8eKJ0.Y400, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($8eKJ0.Y400, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($8eKJ0.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($8eKJ0.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($8eKJ0.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($8eKJ0.Y400, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($8eKJ0.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($8eKJ0.Y400, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($8eKJ0.R400, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($8eKJ0.R400, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($8eKJ0.R300, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($8eKJ0.R300, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($8eKJ0.R500, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($8eKJ0.R500, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($8eKJ0.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($8eKJ0.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($8eKJ0.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($8eKJ0.R500, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($8eKJ0.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($8eKJ0.R500, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($8eKJ0.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($8eKJ0.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($8eKJ0.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($8eKJ0.N20, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($8eKJ0.N30A, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($8eKJ0.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($fa1984c3ae3bea04$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($8eKJ0.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($8eKJ0.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($8eKJ0.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($8eKJ0.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($8eKJ0.DN0, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($8eKJ0.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($8eKJ0.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($8eKJ0.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($8eKJ0.N20, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($8eKJ0.N500, ")"),
                dark: "var(--ds-text, ".concat($8eKJ0.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($8eKJ0.B400, ")"),
                dark: "var(--ds-text, ".concat($8eKJ0.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($8eKJ0.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($8eKJ0.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($8eKJ0.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($8eKJ0.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($8eKJ0.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($8eKJ0.DN400, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($8eKJ0.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($8eKJ0.DN30, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($8eKJ0.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($8eKJ0.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($8eKJ0.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($8eKJ0.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($8eKJ0.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($8eKJ0.DN400, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($8eKJ0.N800, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($8eKJ0.N800, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($8eKJ0.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($8eKJ0.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($8eKJ0.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($8eKJ0.N800, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($8eKJ0.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($8eKJ0.N800, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($8eKJ0.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($8eKJ0.N0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($8eKJ0.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($8eKJ0.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($8eKJ0.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($8eKJ0.N0, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($8eKJ0.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($8eKJ0.N0, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($8eKJ0.B400, ")"),
                dark: "var(--ds-link, ".concat($8eKJ0.B100, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($8eKJ0.B300, ")"),
                dark: "var(--ds-link, ".concat($8eKJ0.B75, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($8eKJ0.B500, ")"),
                dark: "var(--ds-link-pressed, ".concat($8eKJ0.B200, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($8eKJ0.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($8eKJ0.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($8eKJ0.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($8eKJ0.N700, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($8eKJ0.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($8eKJ0.N700, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($8eKJ0.N500, ")"),
                dark: "var(--ds-text, ".concat($8eKJ0.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($8eKJ0.B400, ")"),
                dark: "var(--ds-text, ".concat($8eKJ0.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($8eKJ0.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($8eKJ0.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($8eKJ0.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($8eKJ0.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($8eKJ0.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($8eKJ0.DN400, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-text-subtle, ".concat($8eKJ0.N200, ")"),
                dark: "var(--ds-text-subtle, ".concat($8eKJ0.DN400, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($8eKJ0.N90, ")"),
                dark: "var(--ds-text-subtle, ".concat($8eKJ0.B50, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($8eKJ0.N400, ")"),
                dark: "var(--ds-text, ".concat($8eKJ0.DN300, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($8eKJ0.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($8eKJ0.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($8eKJ0.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($8eKJ0.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($8eKJ0.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($8eKJ0.DN400, ")")
            }
        }
    }
};
var $fa1984c3ae3bea04$export$2e2bcd8739ae039 = $fa1984c3ae3bea04$var$values;

});


parcelRegister("R0ZTR", function(module, exports) {

$parcel$export(module.exports, "getIfVisuallyHiddenChildren", function () { return $09f5b969816ede3b$export$20bbd2efb0d734c4; });

var $9nHZC = parcelRequire("9nHZC");

var $7S7GL = parcelRequire("7S7GL");
var $09f5b969816ede3b$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $9nHZC.isValidElement)(children) && children.type === (0, $7S7GL.default);
};

});


parcelRegister("l0KJe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4bdd85de2862c24$export$2e2bcd8739ae039; });

var $R0ZTR = parcelRequire("R0ZTR");
function $f4bdd85de2862c24$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $R0ZTR.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});

parcelRegister("4yc47", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3503b256926a7b9e$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $epmsx = parcelRequire("epmsx");
function $3503b256926a7b9e$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return "inherit";
    if (isSelected) return "invert";
    if (appearance === "primary" || appearance === "danger") return "invert";
    return "inherit";
}
function $3503b256926a7b9e$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing;
    var size = spacing === "default" ? "medium" : "small";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $epmsx.default), {
        size: size,
        label: ", Loading",
        appearance: $3503b256926a7b9e$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});
parcelRegister("epmsx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7d4d26d196f0f16$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $5fUc4 = parcelRequire("5fUc4");

var $3eJ41 = parcelRequire("3eJ41");

var $334rJ = parcelRequire("334rJ");
/**
 * Returns the appropriate circle stroke color.
 */ function $a7d4d26d196f0f16$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $3eJ41.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $3eJ41.N0), ")");
}
var $a7d4d26d196f0f16$var$rotate = (0, $avKww.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $a7d4d26d196f0f16$var$rotateStyles = (0, $avKww.css)({
    animation: "".concat($a7d4d26d196f0f16$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $a7d4d26d196f0f16$var$loadIn = (0, $avKww.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $a7d4d26d196f0f16$var$loadInStyles = (0, $avKww.css)({
    animation: "".concat($a7d4d26d196f0f16$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $a7d4d26d196f0f16$var$wrapperStyles = (0, $avKww.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $a7d4d26d196f0f16$var$circleStyles = (0, $avKww.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $a7d4d26d196f0f16$var$useLayoutEffect = typeof window === "undefined" ? (0, $9nHZC.useEffect) : (0, $9nHZC.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $a7d4d26d196f0f16$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $334rJ.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $a7d4d26d196f0f16$var$getStrokeColor(appearance);
    var context = (0, $9nHZC.useContext)((0, $5fUc4.default));
    $a7d4d26d196f0f16$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $avKww.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $a7d4d26d196f0f16$var$wrapperStyles,
            $a7d4d26d196f0f16$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $avKww.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $a7d4d26d196f0f16$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none"
    }, (0, $avKww.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $a7d4d26d196f0f16$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $a7d4d26d196f0f16$export$2e2bcd8739ae039 = $a7d4d26d196f0f16$var$Spinner;

});
parcelRegister("3eJ41", function(module, exports) {

$parcel$export(module.exports, "N0", function () { return $25b5a2a52de94639$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $25b5a2a52de94639$export$c39c0fe0f26207ae; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $25b5a2a52de94639$export$4b84fd0e2c617bd = "#FFEBE6";
var $25b5a2a52de94639$export$b34b069eff244586 = "#FFBDAD";
var $25b5a2a52de94639$export$be802dd0d8b57f35 = "#FF8F73";
var $25b5a2a52de94639$export$60847d42f9da92a6 = "#FF7452";
var $25b5a2a52de94639$export$4a7404f376229999 = "#FF5630";
var $25b5a2a52de94639$export$2010d0fb4295b346 = "#DE350B";
var $25b5a2a52de94639$export$2837b5a1a71d5c02 = "#BF2600";
var $25b5a2a52de94639$export$8d9596b529bbb9cf = "#FFFAE6";
var $25b5a2a52de94639$export$41060a744ab0b7ae = "#FFF0B3";
var $25b5a2a52de94639$export$1cc05bbbf340e559 = "#FFE380";
var $25b5a2a52de94639$export$5aae31392d72caaa = "#FFC400";
var $25b5a2a52de94639$export$c6930421db9fa514 = "#FFAB00";
var $25b5a2a52de94639$export$59619663aa6500fb = "#FF991F";
var $25b5a2a52de94639$export$874739ea9e379ab6 = "#FF8B00";
var $25b5a2a52de94639$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $25b5a2a52de94639$export$69a3bf21b9686c2b = "#ABF5D1";
var $25b5a2a52de94639$export$afbce1382ec95f73 = "#79F2C0";
var $25b5a2a52de94639$export$747d86715d4175de = "#57D9A3";
var $25b5a2a52de94639$export$940e1f69e873f202 = "#36B37E";
var $25b5a2a52de94639$export$a49394138f7b8e85 = "#00875A";
var $25b5a2a52de94639$export$6fa04827ac68a4fb = "#006644";
var $25b5a2a52de94639$export$226de0355ed012f8 = "#DEEBFF";
var $25b5a2a52de94639$export$8c13c2ee36917869 = "#B3D4FF";
var $25b5a2a52de94639$export$ecfc1dff386a3e7a = "#4C9AFF";
var $25b5a2a52de94639$export$215b7063051591f1 = "#2684FF";
var $25b5a2a52de94639$export$e62e8919cca44969 = "#0065FF";
var $25b5a2a52de94639$export$b3de0ae08da2ce64 = "#0052CC";
var $25b5a2a52de94639$export$a6ee3d71bc067634 = "#0747A6";
var $25b5a2a52de94639$export$363e4475840015bb = "#EAE6FF";
var $25b5a2a52de94639$export$4b0a4417ed59760f = "#C0B6F2";
var $25b5a2a52de94639$export$6011520a64d9a187 = "#998DD9";
var $25b5a2a52de94639$export$a7175d4e9206bc80 = "#8777D9";
var $25b5a2a52de94639$export$b48405b95304b5a1 = "#6554C0";
var $25b5a2a52de94639$export$c71e4279dd54a18d = "#5243AA";
var $25b5a2a52de94639$export$147899de772240ec = "#403294";
var $25b5a2a52de94639$export$2cf711fe14c66f06 = "#E6FCFF";
var $25b5a2a52de94639$export$7a8f4d33f6f9772c = "#B3F5FF";
var $25b5a2a52de94639$export$776c9c497ef08533 = "#79E2F2";
var $25b5a2a52de94639$export$69cb3ca10c1e330e = "#00C7E6";
var $25b5a2a52de94639$export$9dc1ef0f3f48059b = "#00B8D9";
var $25b5a2a52de94639$export$7c835c78b6fcdef8 = "#00A3BF";
var $25b5a2a52de94639$export$6036577f95c3877e = "#008DA6";
var $25b5a2a52de94639$export$29a4f05edc054374 = "#FFFFFF";
var $25b5a2a52de94639$export$e655ef011c4aa1a2 = "#FAFBFC";
var $25b5a2a52de94639$export$9fdfb749e33cdf97 = "#F4F5F7";
var $25b5a2a52de94639$export$3e51e8f1440314ba = "#EBECF0";
var $25b5a2a52de94639$export$1ce2d1575d444ceb = "#DFE1E6";
var $25b5a2a52de94639$export$8754fc7e6d8b3000 = "#C1C7D0";
var $25b5a2a52de94639$export$c2e91cbeada39b8b = "#B3BAC5";
var $25b5a2a52de94639$export$5f71e19f3a7ad9de = "#A5ADBA";
var $25b5a2a52de94639$export$eaa8c8a70ac22806 = "#97A0AF";
var $25b5a2a52de94639$export$7c87d337fb91a97d = "#8993A4";
var $25b5a2a52de94639$export$d6447c357493214f = "#7A869A";
var $25b5a2a52de94639$export$f563ee71e9ee74cd = "#6B778C";
var $25b5a2a52de94639$export$e2ef2124cf4024b1 = "#5E6C84";
var $25b5a2a52de94639$export$eece5f492e429f08 = "#505F79";
var $25b5a2a52de94639$export$c39c0fe0f26207ae = "#42526E";
var $25b5a2a52de94639$export$7090862dc3038a9f = "#344563";
var $25b5a2a52de94639$export$ad0bacf983b7ddaa = "#253858";
var $25b5a2a52de94639$export$7d61b15e0da132af = "#172B4D";
var $25b5a2a52de94639$export$fbda843f0a27fe96 = "#091E42";
var $25b5a2a52de94639$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $25b5a2a52de94639$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $25b5a2a52de94639$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $25b5a2a52de94639$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $25b5a2a52de94639$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $25b5a2a52de94639$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $25b5a2a52de94639$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $25b5a2a52de94639$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $25b5a2a52de94639$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $25b5a2a52de94639$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $25b5a2a52de94639$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $25b5a2a52de94639$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $25b5a2a52de94639$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $25b5a2a52de94639$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $25b5a2a52de94639$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $25b5a2a52de94639$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $25b5a2a52de94639$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $25b5a2a52de94639$export$2f6319cf7d736c2a = "#E6EDFA";
var $25b5a2a52de94639$export$95126bc8884d6634 = "#DCE5F5";
var $25b5a2a52de94639$export$8338d8c35d44ff1 = "#CED9EB";
var $25b5a2a52de94639$export$5368d76ae4fbbda7 = "#B8C7E0";
var $25b5a2a52de94639$export$9f0a771d16ec8d36 = "#ABBBD6";
var $25b5a2a52de94639$export$abcf8c38338b4aa5 = "#9FB0CC";
var $25b5a2a52de94639$export$97e81faa16a182c7 = "#8C9CB8";
var $25b5a2a52de94639$export$bfe21c59123ecf33 = "#7988A3";
var $25b5a2a52de94639$export$ee82aa2ea6a1558 = "#67758F";
var $25b5a2a52de94639$export$682927c6ed76be02 = "#56637A";
var $25b5a2a52de94639$export$91fd9994c5be9757 = "#455166";
var $25b5a2a52de94639$export$d281fbfe3cff2df6 = "#3B475C";
var $25b5a2a52de94639$export$3902c91d8b98a753 = "#313D52";
var $25b5a2a52de94639$export$8e8133c1ba5845b5 = "#283447";
var $25b5a2a52de94639$export$33ff357f6620b39 = "#202B3D";
var $25b5a2a52de94639$export$633847cf062b69e0 = "#1B2638";
var $25b5a2a52de94639$export$9776a6e503bdbf76 = "#121A29";
var $25b5a2a52de94639$export$6c813d5160dff5db = "#0E1624";
var $25b5a2a52de94639$export$3d4f271a500072a = "#0D1424";
var $25b5a2a52de94639$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $25b5a2a52de94639$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $25b5a2a52de94639$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $25b5a2a52de94639$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $25b5a2a52de94639$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $25b5a2a52de94639$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $25b5a2a52de94639$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $25b5a2a52de94639$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $25b5a2a52de94639$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $25b5a2a52de94639$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $25b5a2a52de94639$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $25b5a2a52de94639$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $25b5a2a52de94639$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $25b5a2a52de94639$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $25b5a2a52de94639$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $25b5a2a52de94639$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $25b5a2a52de94639$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";

});

parcelRegister("334rJ", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $238519dddbe3d5f9$export$4e9f1640bbe7a1a8; });
var $238519dddbe3d5f9$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});



parcelRegister("4nGYJ", function(module, exports) {

$parcel$export(module.exports, "getSpecifiers", function () { return $330aa6112b6c0d0b$export$643db0b8d8778e; });
$parcel$export(module.exports, "defaultThemeFn", function () { return $330aa6112b6c0d0b$export$437a7f77d13d7916; });
$parcel$export(module.exports, "default", function () { return $330aa6112b6c0d0b$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $5tHdD = parcelRequire("5tHdD");

var $7J0kn = parcelRequire("7J0kn");
function $330aa6112b6c0d0b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $330aa6112b6c0d0b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $330aa6112b6c0d0b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $330aa6112b6c0d0b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $330aa6112b6c0d0b$var$stateToSelectorMap = {
    focus: "&:focus",
    focusSelected: "&:focus",
    hover: "&:hover",
    active: "&:active",
    disabled: "&[disabled]"
};
function $330aa6112b6c0d0b$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? "light" : _ref$mode, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $7J0kn.getCss)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = "none";
    // Pulling relevant styles up to the top level
    var selector = $330aa6112b6c0d0b$var$stateToSelectorMap[state];
    if (selector) result = $330aa6112b6c0d0b$var$_objectSpread($330aa6112b6c0d0b$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $330aa6112b6c0d0b$var$_objectSpread($330aa6112b6c0d0b$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === "&::-moz-focus-inner") return;
        // Not using .startsWith for ie11
        if (key.indexOf("&") === 0) delete result[key];
    });
    return result;
}
function $330aa6112b6c0d0b$export$643db0b8d8778e(styles) {
    return {
        "&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]": styles
    };
}
function $330aa6112b6c0d0b$export$437a7f77d13d7916(current, values) {
    return current(values);
}
var $330aa6112b6c0d0b$var$Theme = (0, $5tHdD.createTheme)(function(themeProps) {
    return {
        buttonStyles: $330aa6112b6c0d0b$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$330aa6112b6c0d0b$export$2e2bcd8739ae039 = $330aa6112b6c0d0b$var$Theme;

});


parcelRegister("fA3mK", function(module, exports) {

$parcel$export(module.exports, "spotlightButtonTheme", function () { return $b57cd430b409ed72$export$39a36121076ca24; });
$parcel$export(module.exports, "modalButtonTheme", function () { return $b57cd430b409ed72$export$d131eb21ba4cbd16; });

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $340K4 = parcelRequire("340K4");

var $jp7ng = parcelRequire("jp7ng");
var $b57cd430b409ed72$var$_excluded = [
    "buttonStyles"
], $b57cd430b409ed72$var$_excluded2 = [
    "buttonStyles"
];
function $b57cd430b409ed72$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b57cd430b409ed72$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b57cd430b409ed72$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b57cd430b409ed72$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b57cd430b409ed72$var$spotlightTheme = {
    default: {
        background: {
            default: "var(--ds-background-inverse-subtle, ".concat($jp7ng.P500, ")"),
            hover: "var(--ds-background-inverse-subtle-hovered, ".concat($jp7ng.P200, ")"),
            active: "var(--ds-background-inverse-subtle-pressed, ".concat($jp7ng.P500, ")"),
            disabled: "var(--ds-background-disabled, ".concat($jp7ng.P400, ")"),
            selected: "var(--ds-background-inverse-subtle-pressed, ".concat($jp7ng.R500, ")"),
            focus: "var(--ds-background-inverse-subtle, ".concat($jp7ng.P500, ")")
        },
        color: {
            default: "var(--ds-text-inverse, ".concat($jp7ng.N0, ")"),
            hover: "var(--ds-text-inverse, ".concat($jp7ng.N0, ")"),
            active: "var(--ds-text-inverse, ".concat($jp7ng.N0, ")"),
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jp7ng.N0, ")"),
                dark: "var(--ds-text-disabled, ".concat($jp7ng.DN30, ")")
            },
            selected: "var(--ds-text-inverse, ".concat($jp7ng.N0, ")"),
            focus: "var(--ds-text-inverse, ".concat($jp7ng.N0, ")")
        }
    },
    subtle: {
        background: {
            default: "none",
            hover: "var(--ds-background-inverse-subtle-hovered, ".concat($jp7ng.P200, ")"),
            active: "var(--ds-background-inverse-subtle-pressed, ".concat($jp7ng.P500, ")"),
            disabled: "none",
            selected: {
                light: "var(--ds-background-selected-hovered, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected-hovered, ".concat($jp7ng.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected-hovered, ".concat($jp7ng.N700, ")"),
                dark: "var(--ds-background-selected-hovered, ".concat($jp7ng.DN0, ")")
            }
        },
        color: {
            default: "var(--ds-text-inverse, ".concat($jp7ng.N0, ")"),
            hover: "var(--ds-text-inverse, ".concat($jp7ng.N0, ")"),
            active: "var(--ds-text-inverse, ".concat($jp7ng.N0, ")"),
            disabled: "var(--ds-text-disabled, ".concat($jp7ng.N0, ")"),
            selected: "var(--ds-text-inverse, ".concat($jp7ng.N0, ")"),
            focus: "var(--ds-text-inverse, ".concat($jp7ng.N0, ")")
        }
    },
    "subtle-link": {
        textDecoration: {
            hover: "underline ".concat("var(--ds-text-inverse, ".concat($jp7ng.P75, ")"))
        },
        textDecorationLine: {
            active: "none"
        },
        color: {
            default: "var(--ds-text-inverse, ".concat($jp7ng.N0, ")"),
            hover: "var(--ds-text-inverse, ".concat($jp7ng.P75, ")"),
            active: "var(--ds-text-inverse, ".concat($jp7ng.P100, ")"),
            disabled: "var(--ds-text-discovery, ".concat($jp7ng.P500, ")"),
            selected: "var(--ds-text-selected, ".concat($jp7ng.N0, ")"),
            focus: "var(--ds-text-inverse, ".concat($jp7ng.N0, ")")
        }
    }
};
var $b57cd430b409ed72$var$modalTheme = {
    primary: {
        background: {
            default: "var(--ds-background-discovery-bold, ".concat($jp7ng.P400, ")"),
            hover: "var(--ds-background-discovery-bold-hovered, ".concat($jp7ng.P200, ")"),
            active: "var(--ds-background-discovery-bold-pressed, ".concat($jp7ng.P500, ")"),
            disabled: {
                light: "var(--ds-background-disabled, ".concat($jp7ng.N30, ")"),
                dark: "var(--ds-background-disabled, ".concat($jp7ng.DN70, ")")
            },
            selected: "var(--ds-background-selected-hovered, ".concat($jp7ng.R500, ")"),
            focus: "var(--ds-background-discovery-bold-hovered, ".concat($jp7ng.P400, ")")
        },
        color: {
            default: "var(--ds-text-inverse, ".concat($jp7ng.N0, ")"),
            disabled: {
                light: "var(--ds-text-disabled, ".concat($jp7ng.N0, ")"),
                dark: "var(--ds-text-disabled, ".concat($jp7ng.DN30, ")")
            },
            selected: "var(--ds-text-selected, ".concat($jp7ng.N0, ")"),
            focus: "var(--ds-text-inverse, ".concat($jp7ng.N0, ")")
        }
    }
};
function $b57cd430b409ed72$var$extract(newTheme, _ref) {
    var mode = _ref.mode, appearance = _ref.appearance, state = _ref.state;
    if (!newTheme[appearance]) return undefined;
    var root = newTheme[appearance];
    return Object.keys(root).reduce(function(acc, val) {
        var node = root;
        [
            val,
            state,
            mode
        ].forEach(function(item) {
            if (!node[item]) return undefined;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(node[item]) !== "object") {
                acc[val] = node[item];
                return undefined;
            }
            node = node[item];
            return undefined;
        });
        return acc;
    }, {});
}
var $b57cd430b409ed72$export$39a36121076ca24 = function spotlightButtonTheme(current, themeProps) {
    var _current = current(themeProps), buttonStyles = _current.buttonStyles, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_current, $b57cd430b409ed72$var$_excluded);
    return $b57cd430b409ed72$var$_objectSpread({
        buttonStyles: $b57cd430b409ed72$var$_objectSpread($b57cd430b409ed72$var$_objectSpread({}, buttonStyles), $b57cd430b409ed72$var$extract($b57cd430b409ed72$var$spotlightTheme, themeProps))
    }, rest);
};
var $b57cd430b409ed72$export$d131eb21ba4cbd16 = function modalButtonTheme(current, themeProps) {
    var _current2 = current(themeProps), buttonStyles = _current2.buttonStyles, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_current2, $b57cd430b409ed72$var$_excluded2);
    return $b57cd430b409ed72$var$_objectSpread({
        buttonStyles: $b57cd430b409ed72$var$_objectSpread($b57cd430b409ed72$var$_objectSpread({}, buttonStyles), $b57cd430b409ed72$var$extract($b57cd430b409ed72$var$modalTheme, themeProps))
    }, rest);
};

});

parcelRegister("jmonP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a91b8e72a552f72d$export$2e2bcd8739ae039; });
// Copied from src/sections/global/constants
const $a91b8e72a552f72d$var$HORIZONTAL_NAVIGATION_MOBILE_HEADER_ACTIVE_WIDTH = 768;
function $a91b8e72a552f72d$export$2e2bcd8739ae039() {
    return Math.max(document.documentElement ? document.documentElement.clientWidth : 0, window.innerWidth || 0) < $a91b8e72a552f72d$var$HORIZONTAL_NAVIGATION_MOBILE_HEADER_ACTIVE_WIDTH;
}

});

parcelRegister("1zBji", function(module, exports) {

$parcel$export(module.exports, "useFlagGroup", function () { return $12560062f74864f0$export$e91ea202abb66350; });
$parcel$export(module.exports, "default", function () { return $12560062f74864f0$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $6ZCxy = parcelRequire("6ZCxy");
var $JcvLo = parcelRequire("JcvLo");
var $5FaFu = parcelRequire("5FaFu");

var $7S7GL = parcelRequire("7S7GL");

var $8p2GL = parcelRequire("8p2GL");

var $97YIy = parcelRequire("97YIy");

var $a9KrV = parcelRequire("a9KrV");
var $12560062f74864f0$var$gridSize = (0, $a9KrV.gridSize)();
var $12560062f74864f0$export$1eee5ddc4f6d41c5 = $12560062f74864f0$var$gridSize * 50;
var $12560062f74864f0$export$a56455a41666bb2a = 400;
var $12560062f74864f0$var$defaultFlagGroupContext = {
    onDismissed: (0, $8p2GL.default),
    isDismissAllowed: false
};
var $12560062f74864f0$export$c57ba665aaa722be = /*#__PURE__*/ (0, $9nHZC.createContext)($12560062f74864f0$var$defaultFlagGroupContext);
function $12560062f74864f0$export$e91ea202abb66350() {
    return (0, $9nHZC.useContext)($12560062f74864f0$export$c57ba665aaa722be);
}
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
var $12560062f74864f0$var$baseStyles = (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: $12560062f74864f0$export$1eee5ddc4f6d41c5,
    position: "absolute",
    insetBlockEnd: 0,
    transition: "transform ".concat($12560062f74864f0$export$a56455a41666bb2a, "ms ease-in-out"),
    // TODO: Use new breakpoints
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "@media (max-width: 560px)": {
        width: "100vw"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ":first-of-type": {
        transform: "translate(0,0)",
        transition: "none"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ":nth-of-type(n + 2)": {
        animationDuration: "0ms",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transform: "translateX(0) translateY(100%) translateY(".concat(2 * $12560062f74864f0$var$gridSize, "px)")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ":nth-of-type(1)": {
        zIndex: 5
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ":nth-of-type(2)": {
        zIndex: 4
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&:nth-of-type(n + 4)": {
        visibility: "hidden"
    }
});
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
var $12560062f74864f0$var$dismissAllowedStyles = (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&& + *": {
        transform: "translate(0, 0)",
        transitionDuration: "".concat($12560062f74864f0$export$a56455a41666bb2a / 2, "ms")
    }
});
var $12560062f74864f0$var$flagGroupContainerStyles = (0, $avKww.css)({
    position: "fixed",
    zIndex: "flag",
    insetBlockEnd: "var(--ds-space-600, 48px)",
    insetInlineStart: "var(--ds-space-1000, 80px)",
    // TODO: Use new breakpoints
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "@media (max-width: 560px)": {
        insetBlockEnd: 0,
        insetInlineStart: 0
    }
});
/**
 * __Flag group__
 *
 * A flag group is used to group a set of related flags, with entry and exit animations.
 *
 * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
 * - [Code](https://atlassian.design/components/flag/flag-group/code)
 */ var $12560062f74864f0$var$FlagGroup = function FlagGroup(props) {
    var id = props.id, _props$label = props.label, label = _props$label === void 0 ? "Flag notifications" : _props$label, _props$labelTag = props.labelTag, LabelTag = _props$labelTag === void 0 ? "h2" : _props$labelTag, _props$shouldRenderTo = props.shouldRenderToParent, shouldRenderToParent = _props$shouldRenderTo === void 0 ? false : _props$shouldRenderTo, children = props.children, _props$onDismissed = props.onDismissed, onDismissed = _props$onDismissed === void 0 ? (0, $8p2GL.default) : _props$onDismissed;
    var hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    var dismissFlagContext = (0, $9nHZC.useMemo)(function() {
        return {
            onDismissed: onDismissed,
            isDismissAllowed: true
        };
    }, [
        onDismissed
    ]);
    var renderChildren = function renderChildren() {
        return children && (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(children) === "object" ? (0, $9nHZC.Children).map(children, function(flag, index) {
            var isDismissAllowed = index === 0;
            return (0, $avKww.jsx)((0, $5FaFu.default), {
                enterFrom: "left",
                fade: "inout",
                duration: $12560062f74864f0$export$a56455a41666bb2a,
                animationTimingFunction: function animationTimingFunction() {
                    return 0, $6ZCxy.easeIn;
                }
            }, function(_ref) {
                var className = _ref.className, ref = _ref.ref;
                return (0, $avKww.jsx)("div", {
                    css: [
                        $12560062f74864f0$var$baseStyles,
                        isDismissAllowed && $12560062f74864f0$var$dismissAllowedStyles
                    ],
                    className: className,
                    ref: ref
                }, (0, $avKww.jsx)($12560062f74864f0$export$c57ba665aaa722be.Provider, {
                    value: // Only the first flag should be able to be dismissed.
                    isDismissAllowed ? dismissFlagContext : $12560062f74864f0$var$defaultFlagGroupContext
                }, flag));
            });
        }) : false;
    };
    var flags = (0, $avKww.jsx)("div", {
        id: id,
        css: $12560062f74864f0$var$flagGroupContainerStyles
    }, hasFlags ? (0, $avKww.jsx)((0, $7S7GL.default), null, (0, $avKww.jsx)(LabelTag, null, label)) : null, (0, $avKww.jsx)((0, $JcvLo.default), {
        appear: false
    }, renderChildren()));
    return shouldRenderToParent ? flags : (0, $avKww.jsx)((0, $97YIy.default), {
        zIndex: (0, $a9KrV.layers).flag()
    }, flags);
};
var $12560062f74864f0$export$2e2bcd8739ae039 = $12560062f74864f0$var$FlagGroup;

});
parcelRegister("a9KrV", function(module, exports) {

$parcel$export(module.exports, "gridSize", function () { return $764ec68e42a256b5$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "layers", function () { return $764ec68e42a256b5$export$7be255094ccdc533; });

var $1OnrY = parcelRequire("1OnrY");

var $dqBP1 = parcelRequire("dqBP1");
var $764ec68e42a256b5$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $764ec68e42a256b5$export$c93026a968943f95 = "light";
var $764ec68e42a256b5$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $764ec68e42a256b5$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $764ec68e42a256b5$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $764ec68e42a256b5$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $764ec68e42a256b5$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $764ec68e42a256b5$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $764ec68e42a256b5$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $764ec68e42a256b5$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $dqBP1.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $764ec68e42a256b5$export$6d8204c2cb2e06b8() / 4;
    (0, $1OnrY.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $764ec68e42a256b5$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $764ec68e42a256b5$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $764ec68e42a256b5$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $1OnrY.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $764ec68e42a256b5$export$ba1d834b86d72a09 = $764ec68e42a256b5$export$a1b3edb637fb4f35;
var $764ec68e42a256b5$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $dqBP1.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $dqBP1.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $dqBP1.N30A), ")")
            }
        }
    };
};

});
parcelRegister("dqBP1", function(module, exports) {

$parcel$export(module.exports, "R300", function () { return $9c6b0ab3a8c2d6b8$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $9c6b0ab3a8c2d6b8$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $9c6b0ab3a8c2d6b8$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y200", function () { return $9c6b0ab3a8c2d6b8$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $9c6b0ab3a8c2d6b8$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $9c6b0ab3a8c2d6b8$export$59619663aa6500fb; });
$parcel$export(module.exports, "B50", function () { return $9c6b0ab3a8c2d6b8$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $9c6b0ab3a8c2d6b8$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $9c6b0ab3a8c2d6b8$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $9c6b0ab3a8c2d6b8$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $9c6b0ab3a8c2d6b8$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $9c6b0ab3a8c2d6b8$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $9c6b0ab3a8c2d6b8$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "N0", function () { return $9c6b0ab3a8c2d6b8$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $9c6b0ab3a8c2d6b8$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N70", function () { return $9c6b0ab3a8c2d6b8$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N90", function () { return $9c6b0ab3a8c2d6b8$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N200", function () { return $9c6b0ab3a8c2d6b8$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N400", function () { return $9c6b0ab3a8c2d6b8$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $9c6b0ab3a8c2d6b8$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $9c6b0ab3a8c2d6b8$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $9c6b0ab3a8c2d6b8$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $9c6b0ab3a8c2d6b8$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $9c6b0ab3a8c2d6b8$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN400", function () { return $9c6b0ab3a8c2d6b8$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $9c6b0ab3a8c2d6b8$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN100", function () { return $9c6b0ab3a8c2d6b8$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN70", function () { return $9c6b0ab3a8c2d6b8$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $9c6b0ab3a8c2d6b8$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN30", function () { return $9c6b0ab3a8c2d6b8$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN0", function () { return $9c6b0ab3a8c2d6b8$export$3d4f271a500072a; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $9c6b0ab3a8c2d6b8$export$4b84fd0e2c617bd = "#FFEBE6";
var $9c6b0ab3a8c2d6b8$export$b34b069eff244586 = "#FFBDAD";
var $9c6b0ab3a8c2d6b8$export$be802dd0d8b57f35 = "#FF8F73";
var $9c6b0ab3a8c2d6b8$export$60847d42f9da92a6 = "#FF7452";
var $9c6b0ab3a8c2d6b8$export$4a7404f376229999 = "#FF5630";
var $9c6b0ab3a8c2d6b8$export$2010d0fb4295b346 = "#DE350B";
var $9c6b0ab3a8c2d6b8$export$2837b5a1a71d5c02 = "#BF2600";
var $9c6b0ab3a8c2d6b8$export$8d9596b529bbb9cf = "#FFFAE6";
var $9c6b0ab3a8c2d6b8$export$41060a744ab0b7ae = "#FFF0B3";
var $9c6b0ab3a8c2d6b8$export$1cc05bbbf340e559 = "#FFE380";
var $9c6b0ab3a8c2d6b8$export$5aae31392d72caaa = "#FFC400";
var $9c6b0ab3a8c2d6b8$export$c6930421db9fa514 = "#FFAB00";
var $9c6b0ab3a8c2d6b8$export$59619663aa6500fb = "#FF991F";
var $9c6b0ab3a8c2d6b8$export$874739ea9e379ab6 = "#FF8B00";
var $9c6b0ab3a8c2d6b8$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $9c6b0ab3a8c2d6b8$export$69a3bf21b9686c2b = "#ABF5D1";
var $9c6b0ab3a8c2d6b8$export$afbce1382ec95f73 = "#79F2C0";
var $9c6b0ab3a8c2d6b8$export$747d86715d4175de = "#57D9A3";
var $9c6b0ab3a8c2d6b8$export$940e1f69e873f202 = "#36B37E";
var $9c6b0ab3a8c2d6b8$export$a49394138f7b8e85 = "#00875A";
var $9c6b0ab3a8c2d6b8$export$6fa04827ac68a4fb = "#006644";
var $9c6b0ab3a8c2d6b8$export$226de0355ed012f8 = "#DEEBFF";
var $9c6b0ab3a8c2d6b8$export$8c13c2ee36917869 = "#B3D4FF";
var $9c6b0ab3a8c2d6b8$export$ecfc1dff386a3e7a = "#4C9AFF";
var $9c6b0ab3a8c2d6b8$export$215b7063051591f1 = "#2684FF";
var $9c6b0ab3a8c2d6b8$export$e62e8919cca44969 = "#0065FF";
var $9c6b0ab3a8c2d6b8$export$b3de0ae08da2ce64 = "#0052CC";
var $9c6b0ab3a8c2d6b8$export$a6ee3d71bc067634 = "#0747A6";
var $9c6b0ab3a8c2d6b8$export$363e4475840015bb = "#EAE6FF";
var $9c6b0ab3a8c2d6b8$export$4b0a4417ed59760f = "#C0B6F2";
var $9c6b0ab3a8c2d6b8$export$6011520a64d9a187 = "#998DD9";
var $9c6b0ab3a8c2d6b8$export$a7175d4e9206bc80 = "#8777D9";
var $9c6b0ab3a8c2d6b8$export$b48405b95304b5a1 = "#6554C0";
var $9c6b0ab3a8c2d6b8$export$c71e4279dd54a18d = "#5243AA";
var $9c6b0ab3a8c2d6b8$export$147899de772240ec = "#403294";
var $9c6b0ab3a8c2d6b8$export$2cf711fe14c66f06 = "#E6FCFF";
var $9c6b0ab3a8c2d6b8$export$7a8f4d33f6f9772c = "#B3F5FF";
var $9c6b0ab3a8c2d6b8$export$776c9c497ef08533 = "#79E2F2";
var $9c6b0ab3a8c2d6b8$export$69cb3ca10c1e330e = "#00C7E6";
var $9c6b0ab3a8c2d6b8$export$9dc1ef0f3f48059b = "#00B8D9";
var $9c6b0ab3a8c2d6b8$export$7c835c78b6fcdef8 = "#00A3BF";
var $9c6b0ab3a8c2d6b8$export$6036577f95c3877e = "#008DA6";
var $9c6b0ab3a8c2d6b8$export$29a4f05edc054374 = "#FFFFFF";
var $9c6b0ab3a8c2d6b8$export$e655ef011c4aa1a2 = "#FAFBFC";
var $9c6b0ab3a8c2d6b8$export$9fdfb749e33cdf97 = "#F4F5F7";
var $9c6b0ab3a8c2d6b8$export$3e51e8f1440314ba = "#EBECF0";
var $9c6b0ab3a8c2d6b8$export$1ce2d1575d444ceb = "#DFE1E6";
var $9c6b0ab3a8c2d6b8$export$8754fc7e6d8b3000 = "#C1C7D0";
var $9c6b0ab3a8c2d6b8$export$c2e91cbeada39b8b = "#B3BAC5";
var $9c6b0ab3a8c2d6b8$export$5f71e19f3a7ad9de = "#A5ADBA";
var $9c6b0ab3a8c2d6b8$export$eaa8c8a70ac22806 = "#97A0AF";
var $9c6b0ab3a8c2d6b8$export$7c87d337fb91a97d = "#8993A4";
var $9c6b0ab3a8c2d6b8$export$d6447c357493214f = "#7A869A";
var $9c6b0ab3a8c2d6b8$export$f563ee71e9ee74cd = "#6B778C";
var $9c6b0ab3a8c2d6b8$export$e2ef2124cf4024b1 = "#5E6C84";
var $9c6b0ab3a8c2d6b8$export$eece5f492e429f08 = "#505F79";
var $9c6b0ab3a8c2d6b8$export$c39c0fe0f26207ae = "#42526E";
var $9c6b0ab3a8c2d6b8$export$7090862dc3038a9f = "#344563";
var $9c6b0ab3a8c2d6b8$export$ad0bacf983b7ddaa = "#253858";
var $9c6b0ab3a8c2d6b8$export$7d61b15e0da132af = "#172B4D";
var $9c6b0ab3a8c2d6b8$export$fbda843f0a27fe96 = "#091E42";
var $9c6b0ab3a8c2d6b8$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $9c6b0ab3a8c2d6b8$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $9c6b0ab3a8c2d6b8$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $9c6b0ab3a8c2d6b8$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $9c6b0ab3a8c2d6b8$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $9c6b0ab3a8c2d6b8$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $9c6b0ab3a8c2d6b8$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $9c6b0ab3a8c2d6b8$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $9c6b0ab3a8c2d6b8$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $9c6b0ab3a8c2d6b8$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $9c6b0ab3a8c2d6b8$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $9c6b0ab3a8c2d6b8$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $9c6b0ab3a8c2d6b8$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $9c6b0ab3a8c2d6b8$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $9c6b0ab3a8c2d6b8$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $9c6b0ab3a8c2d6b8$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $9c6b0ab3a8c2d6b8$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $9c6b0ab3a8c2d6b8$export$2f6319cf7d736c2a = "#E6EDFA";
var $9c6b0ab3a8c2d6b8$export$95126bc8884d6634 = "#DCE5F5";
var $9c6b0ab3a8c2d6b8$export$8338d8c35d44ff1 = "#CED9EB";
var $9c6b0ab3a8c2d6b8$export$5368d76ae4fbbda7 = "#B8C7E0";
var $9c6b0ab3a8c2d6b8$export$9f0a771d16ec8d36 = "#ABBBD6";
var $9c6b0ab3a8c2d6b8$export$abcf8c38338b4aa5 = "#9FB0CC";
var $9c6b0ab3a8c2d6b8$export$97e81faa16a182c7 = "#8C9CB8";
var $9c6b0ab3a8c2d6b8$export$bfe21c59123ecf33 = "#7988A3";
var $9c6b0ab3a8c2d6b8$export$ee82aa2ea6a1558 = "#67758F";
var $9c6b0ab3a8c2d6b8$export$682927c6ed76be02 = "#56637A";
var $9c6b0ab3a8c2d6b8$export$91fd9994c5be9757 = "#455166";
var $9c6b0ab3a8c2d6b8$export$d281fbfe3cff2df6 = "#3B475C";
var $9c6b0ab3a8c2d6b8$export$3902c91d8b98a753 = "#313D52";
var $9c6b0ab3a8c2d6b8$export$8e8133c1ba5845b5 = "#283447";
var $9c6b0ab3a8c2d6b8$export$33ff357f6620b39 = "#202B3D";
var $9c6b0ab3a8c2d6b8$export$633847cf062b69e0 = "#1B2638";
var $9c6b0ab3a8c2d6b8$export$9776a6e503bdbf76 = "#121A29";
var $9c6b0ab3a8c2d6b8$export$6c813d5160dff5db = "#0E1624";
var $9c6b0ab3a8c2d6b8$export$3d4f271a500072a = "#0D1424";
var $9c6b0ab3a8c2d6b8$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $9c6b0ab3a8c2d6b8$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $9c6b0ab3a8c2d6b8$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $9c6b0ab3a8c2d6b8$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $9c6b0ab3a8c2d6b8$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $9c6b0ab3a8c2d6b8$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $9c6b0ab3a8c2d6b8$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $9c6b0ab3a8c2d6b8$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $9c6b0ab3a8c2d6b8$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $9c6b0ab3a8c2d6b8$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $9c6b0ab3a8c2d6b8$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $9c6b0ab3a8c2d6b8$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $9c6b0ab3a8c2d6b8$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $9c6b0ab3a8c2d6b8$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $9c6b0ab3a8c2d6b8$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $9c6b0ab3a8c2d6b8$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $9c6b0ab3a8c2d6b8$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";

});



parcelRegister("b8tvv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81b75490b75e3be2$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $ll9SN = parcelRequire("ll9SN");
function $81b75490b75e3be2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $81b75490b75e3be2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $81b75490b75e3be2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $81b75490b75e3be2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $81b75490b75e3be2$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $81b75490b75e3be2$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $81b75490b75e3be2$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($81b75490b75e3be2$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $81b75490b75e3be2$export$2e2bcd8739ae039 = function(InnerComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    var EngagementEventsWrapper = /*#__PURE__*/ function(_Component) {
        (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(EngagementEventsWrapper, _Component);
        var _super = $81b75490b75e3be2$var$_createSuper(EngagementEventsWrapper);
        function EngagementEventsWrapper() {
            var _this;
            (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, EngagementEventsWrapper);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fireClickEvent", function(clickType) {
                _this.fireEvent("click", {
                    clickType: clickType
                });
            });
            return _this;
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(EngagementEventsWrapper, [
            {
                key: "UNSAFE_componentWillMount",
                value: function UNSAFE_componentWillMount() {
                    this.fireEvent("shown");
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.fireEvent("hidden");
                }
            },
            {
                key: "fireEvent",
                value: function fireEvent(action) {
                    var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    var _this$props = this.props, createAnalyticsEvent = _this$props.createAnalyticsEvent, messageId = _this$props.messageId, variationId = _this$props.variationId, componentId = _this$props.componentId, componentType = _this$props.componentType, isLast = _this$props.isLast;
                    var analyticsEvent = createAnalyticsEvent($81b75490b75e3be2$var$_objectSpread({
                        action: action
                    }, properties));
                    analyticsEvent.update({
                        ekMessageId: messageId,
                        ekVariationId: variationId,
                        ekComponentId: componentId,
                        ekComponentType: componentType,
                        ekIsLast: isLast
                    });
                    analyticsEvent.fire("engagement");
                }
            },
            {
                key: "render",
                value: function render() {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(InnerComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, this.props, {
                        fireClickEvent: this.fireClickEvent
                    }));
                }
            }
        ]);
        return EngagementEventsWrapper;
    }((0, $9nHZC.Component));
    return (0, $ll9SN.default)()(EngagementEventsWrapper);
};

});
parcelRegister("ll9SN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f89339a8bb5296d6$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $68hkj = parcelRequire("68hkj");

var $6oWuv = parcelRequire("6oWuv");
var $f89339a8bb5296d6$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(props, ref) {
            var _usePatchedProps = (0, $6oWuv.usePatchedProps)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $68hkj.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $f89339a8bb5296d6$export$2e2bcd8739ae039 = $f89339a8bb5296d6$var$withAnalyticsEvents;

});
parcelRegister("68hkj", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $4770ee20fddf492c$export$5bf35293e545f20c; });

var $dNznA = parcelRequire("dNznA");

var $hqq8b = parcelRequire("hqq8b");

var $iWzne = parcelRequire("iWzne");
function $4770ee20fddf492c$export$5bf35293e545f20c() {
    var analyticsContext = (0, $iWzne.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $hqq8b.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("hqq8b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $caf9226ef02b3d5a$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $PvaWJ = parcelRequire("PvaWJ");
function $caf9226ef02b3d5a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $caf9226ef02b3d5a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $caf9226ef02b3d5a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($caf9226ef02b3d5a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $caf9226ef02b3d5a$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $caf9226ef02b3d5a$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $caf9226ef02b3d5a$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $caf9226ef02b3d5a$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $PvaWJ.default));

});
parcelRegister("PvaWJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09acf259c6f3524e$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
function $09acf259c6f3524e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $09acf259c6f3524e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $09acf259c6f3524e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $09acf259c6f3524e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $09acf259c6f3524e$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $09acf259c6f3524e$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $09acf259c6f3524e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $09acf259c6f3524e$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(updater) === "object") this.payload = $09acf259c6f3524e$var$_objectSpread($09acf259c6f3524e$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("iWzne", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $dca9154606224c56$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $dca9154606224c56$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});


parcelRegister("6oWuv", function(module, exports) {

$parcel$export(module.exports, "usePatchedProps", function () { return $4a925b1693c0ca0d$export$9ebb5a84d17e5d18; });

var $kFnE9 = parcelRequire("kFnE9");

var $340K4 = parcelRequire("340K4");

var $9nHZC = parcelRequire("9nHZC");

var $68hkj = parcelRequire("68hkj");
function $4a925b1693c0ca0d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4a925b1693c0ca0d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4a925b1693c0ca0d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4a925b1693c0ca0d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4a925b1693c0ca0d$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $68hkj.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $9nHZC.useRef)({});
    var patchedProps = (0, $9nHZC.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                "object",
                "function"
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $4a925b1693c0ca0d$var$_objectSpread($4a925b1693c0ca0d$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === "function" ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === "function") {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $4a925b1693c0ca0d$var$_objectSpread($4a925b1693c0ca0d$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});



parcelRegister("eeQJ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5db45bb86b7ded1$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");
function $a5db45bb86b7ded1$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a5db45bb86b7ded1$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $a5db45bb86b7ded1$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a5db45bb86b7ded1$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $a5db45bb86b7ded1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a5db45bb86b7ded1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a5db45bb86b7ded1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a5db45bb86b7ded1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a5db45bb86b7ded1$export$2e2bcd8739ae039 = function(InnerComponent, componentType) {
    function isTargetComponent(message) {
        return message.componentType === componentType;
    }
    function computeNewState(state) {
        var current = state.current;
        if (current && isTargetComponent(current)) {
            var message;
            switch(current.componentType){
                case "contextualSurvey":
                    message = $a5db45bb86b7ded1$var$_objectSpread($a5db45bb86b7ded1$var$_objectSpread({}, current), {}, {
                        aaid: state.config.aaid,
                        cloudId: state.config.cloudId,
                        stargateUrl: state.config.stargateUrl,
                        product: state.config.product,
                        orgId: state.config.orgId,
                        workspaceId: state.config.workspaceId
                    });
                    break;
                default:
                    message = current;
            }
            return {
                message: message
            };
        }
        return {
            message: null
        };
    }
    // eslint-disable-next-line @repo/internal/react/no-class-components
    var StoreWrapper = /*#__PURE__*/ function(_Component) {
        (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(StoreWrapper, _Component);
        var _super = $a5db45bb86b7ded1$var$_createSuper(StoreWrapper);
        function StoreWrapper() {
            var _this;
            (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, StoreWrapper);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "state", {
                message: null
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onStoreChange", function(state) {
                _this.setState(computeNewState(state));
            });
            return _this;
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(StoreWrapper, [
            {
                key: "UNSAFE_componentWillMount",
                value: function UNSAFE_componentWillMount() {
                    if (this.canSubscribe()) this.unsubscribe = this.subscribeToStore();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (this.unsubscribe) this.unsubscribe();
                }
            },
            {
                key: "canSubscribe",
                value: function canSubscribe() {
                    return this.context && this.context.subscribeEngagementState;
                }
            },
            {
                key: "subscribeToStore",
                value: function subscribeToStore() {
                    return this.context.subscribeEngagementState(this.onStoreChange);
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$props = this.props, children = _this$props.children, engagementId = _this$props.engagementId;
                    var message = this.state.message;
                    if (!message) {
                        if (componentType === "inlineDialog") return children || null;
                        return null;
                    }
                    if (engagementId && message !== null && message.target && engagementId !== message.target) return null;
                    var messageKey = "".concat(message.messageId, ".").concat(message.variationId, ".").concat(message.componentId);
                    // Key is useful here to make sure that when the currently active
                    // messages changes, the old component is unmounted (therefore
                    // firing an analytic event for hiding the component) and mounting
                    // a new component for the new message (firing a shown event for
                    // the new message). Not using key would allow React to apply an
                    // optimization that would reuse the current component for a new
                    // message which would not call the normal mount and unmount
                    // lifecycle methods.
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(InnerComponent, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                        key: messageKey
                    }, this.props, message));
                }
            }
        ]);
        return StoreWrapper;
    }((0, $9nHZC.Component));
    (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(StoreWrapper, "contextTypes", {
        subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func
    });
    return StoreWrapper;
};

});

parcelRegister("fI6ia", function(module, exports) {
function $b6ffd88b4056fe56$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
module.exports = $b6ffd88b4056fe56$var$_objectDestructuringEmpty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1K9zK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $145183cf59fc9bf5$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $b4Ivn = parcelRequire("b4Ivn");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $7S5Ao = parcelRequire("7S5Ao");
var $145183cf59fc9bf5$var$_excluded = [
    "children",
    "defaultIsChecked",
    "value"
], $145183cf59fc9bf5$var$_excluded2 = [
    "value"
], $145183cf59fc9bf5$var$_excluded3 = [
    "fieldProps"
], $145183cf59fc9bf5$var$_excluded4 = [
    "value"
], $145183cf59fc9bf5$var$_excluded5 = [
    "fieldProps"
];
function $145183cf59fc9bf5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $145183cf59fc9bf5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $145183cf59fc9bf5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $145183cf59fc9bf5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * __Checkbox field__
 *
 * A checkbox field is a form field that lets users select an item. Users can check or uncheck the checkbox.
 *
 * - [Examples] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Code] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Usage] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 */ var $145183cf59fc9bf5$var$CheckboxField = function CheckboxField(props) {
    var children = props.children, _props$defaultIsCheck = props.defaultIsChecked, defaultIsChecked = _props$defaultIsCheck === void 0 ? false : _props$defaultIsCheck, value = props.value, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(props, $145183cf59fc9bf5$var$_excluded);
    // Maintains a memoised list of the default values
    var defaultValue = (0, $9nHZC.useCallback)(function() {
        var currentValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return defaultIsChecked && value !== undefined ? [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(currentValue), [
            value
        ]) : currentValue;
    }, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7S5Ao.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
        defaultValue: defaultValue,
        transform: function transform(event, currentValue) {
            return event.currentTarget.checked && currentValue ? [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(currentValue), [
                value
            ]) : currentValue.filter(function(v) {
                return v !== value;
            });
        }
    }), function(_ref) {
        var _ref$fieldProps = _ref.fieldProps, fieldValue = _ref$fieldProps.value, otherFieldProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref$fieldProps, $145183cf59fc9bf5$var$_excluded2), others = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $145183cf59fc9bf5$var$_excluded3);
        return children($145183cf59fc9bf5$var$_objectSpread({
            fieldProps: $145183cf59fc9bf5$var$_objectSpread($145183cf59fc9bf5$var$_objectSpread({}, otherFieldProps), {}, {
                isChecked: !!fieldValue.find(function(v) {
                    return v === value;
                }),
                value: value
            })
        }, others));
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7S5Ao.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
        defaultValue: defaultIsChecked,
        transform: function transform(event) {
            return event.currentTarget.checked;
        }
    }), function(_ref2) {
        var _ref2$fieldProps = _ref2.fieldProps, fieldValue = _ref2$fieldProps.value, otherFieldProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref2$fieldProps, $145183cf59fc9bf5$var$_excluded4), others = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref2, $145183cf59fc9bf5$var$_excluded5);
        return children($145183cf59fc9bf5$var$_objectSpread({
            fieldProps: $145183cf59fc9bf5$var$_objectSpread($145183cf59fc9bf5$var$_objectSpread({}, otherFieldProps), {}, {
                isChecked: fieldValue,
                value: value
            })
        }, others));
    });
};
$145183cf59fc9bf5$var$CheckboxField.defaultProps = {
    defaultIsChecked: false
};
var $145183cf59fc9bf5$export$2e2bcd8739ae039 = $145183cf59fc9bf5$var$CheckboxField;

});
parcelRegister("7S5Ao", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bb1e8ca0c21988a$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $9q1kH = parcelRequire("9q1kH");

var $340K4 = parcelRequire("340K4");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $4ul5V = parcelRequire("4ul5V");


var $hkHbL = parcelRequire("hkHbL");

var $ezi8k = parcelRequire("ezi8k");

var $9Titd = parcelRequire("9Titd");

var $7OocK = parcelRequire("7OocK");

var $8ovux = parcelRequire("8ovux");
function $5bb1e8ca0c21988a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5bb1e8ca0c21988a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5bb1e8ca0c21988a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5bb1e8ca0c21988a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5bb1e8ca0c21988a$var$fieldWrapperStyles = (0, $avKww.css)({
    marginTop: "var(--ds-space-100, 8px)"
});
function $5bb1e8ca0c21988a$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $5bb1e8ca0c21988a$var$isFunction(x) {
    return typeof x === "function";
}
function $5bb1e8ca0c21988a$var$usePreviousRef(current) {
    var ref = (0, $9nHZC.useRef)(current);
    // will be updated on the next render
    (0, $9nHZC.useEffect)(function() {
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $5bb1e8ca0c21988a$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === "function" && typeof currentValue === "function") return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(previousValue) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(currentValue) === "object") return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $5bb1e8ca0c21988a$export$2e2bcd8739ae039(props) {
    var _getCurrentValue;
    var _useContext = (0, $9nHZC.useContext)((0, $ezi8k.FormContext)), registerField = _useContext.registerField, getCurrentValue = _useContext.getCurrentValue;
    var isDisabled = (0, $9nHZC.useContext)((0, $ezi8k.IsDisabledContext)) || props.isDisabled || false;
    var defaultValue = $5bb1e8ca0c21988a$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    var latestPropsRef = $5bb1e8ca0c21988a$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ var isDefaultValueChanged = !$5bb1e8ca0c21988a$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    var _useState = (0, $9nHZC.useState)({
        fieldProps: {
            onChange: function onChange() {},
            onBlur: function onBlur() {},
            onFocus: function onFocus() {},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
         * effectively made it an optional prop to external consumers of Field. However the
         * prop types defined defaultValue as required, so inside the component it was not
         * valid for defaultValue to be undefined. We need to suppress the error
         * after changing defaultValue to explictly be an optional prop.
         * If default value has changed we are using new default value.
         * Otherwise we need to check if we already have value for this field
         * (because we are using changing key prop to re-run field level validation, and that
         * cause the component re-mounting) to not override the actual value with the default value.
         */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : (_getCurrentValue = getCurrentValue(props.name)) !== null && _getCurrentValue !== void 0 ? _getCurrentValue : defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var latestStateRef = $5bb1e8ca0c21988a$var$usePreviousRef(state);
    (0, $9nHZC.useEffect)(function() {
        typeof $8ovux;
        function fieldStateToMeta() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        var unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $5bb1e8ca0c21988a$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, function(fieldState) {
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ var modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ var modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ var modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            var modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ var modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($5bb1e8ca0c21988a$var$isEvent(eventOrValue)) {
                    var currentTarget = eventOrValue.currentTarget;
                    if (currentTarget.type === "checkbox") {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: function onChange(e) {
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: function getValidator() {
                return function validate(value, formState, fieldState) {
                    var supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                };
            }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    var fieldId = (0, $9nHZC.useMemo)(// eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    function() {
        return props.id ? props.id : "".concat(props.name, "-").concat((0, $4ul5V.uid)({
            id: props.name
        }));
    }, [
        props.id,
        props.name
    ]);
    var getDescribedBy = function getDescribedBy() {
        var value = "";
        if (state.error) value += "".concat(fieldId, "-error ");
        if (state.valid) value += "".concat(fieldId, "-valid ");
        return "".concat(value).concat(fieldId, "-helper");
    };
    var extendedFieldProps = $5bb1e8ca0c21988a$var$_objectSpread($5bb1e8ca0c21988a$var$_objectSpread({}, state.fieldProps), {}, {
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        "aria-invalid": state.error ? "true" : "false",
        "aria-describedby": getDescribedBy(),
        "aria-labelledby": "".concat(fieldId, "-label"),
        id: fieldId
    });
    return (0, $avKww.jsx)("div", {
        css: $5bb1e8ca0c21988a$var$fieldWrapperStyles,
        "data-testid": props.testId
    }, props.label && (0, $avKww.jsx)((0, $9Titd.Label), {
        htmlFor: fieldId,
        id: "".concat(fieldId, "-label"),
        testId: props.testId && "".concat(props.testId, "--label")
    }, props.label, props.isRequired && (0, $avKww.jsx)((0, $7OocK.default), null), props.elementAfterLabel), (0, $avKww.jsx)((0, $hkHbL.FieldId).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("ezi8k", function(module, exports) {

$parcel$export(module.exports, "FormContext", function () { return $a9b2667b01f9f37a$export$c24727297075ec6a; });
$parcel$export(module.exports, "IsDisabledContext", function () { return $a9b2667b01f9f37a$export$c17cf6b332a82dbc; });
$parcel$export(module.exports, "default", function () { return $a9b2667b01f9f37a$export$2e2bcd8739ae039; });

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $6qjTz = parcelRequire("6qjTz");

var $lB6ZR = parcelRequire("lB6ZR");

var $bWgcj = parcelRequire("bWgcj");
var $a9b2667b01f9f37a$export$c24727297075ec6a = /*#__PURE__*/ (0, $9nHZC.createContext)({
    registerField: function registerField() {
        return function() {};
    },
    getCurrentValue: function getCurrentValue() {
        return undefined;
    }
});
var $a9b2667b01f9f37a$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $9nHZC.createContext)(false);
function $a9b2667b01f9f37a$export$2e2bcd8739ae039(props) {
    var formRef = (0, $9nHZC.useRef)(null);
    var onSubmitRef = (0, $9nHZC.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    var _useState = (0, $9nHZC.useState)(function() {
        // Types here would break the existing API
        var finalForm = (0, $6qjTz.createForm)({
            onSubmit: function onSubmit() {
                return onSubmitRef.current.apply(onSubmitRef, arguments);
            },
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: function setDefaultValue(_ref, state) {
                    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), name = _ref2[0], defaultValue = _ref2[1];
                    if (state.formState.initialValues) {
                        var _initialValues = state.formState.initialValues;
                        var values = state.formState.values;
                        var _value = name && typeof defaultValue === "function" ? defaultValue(_initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($bWgcj)))(_initialValues, name, _value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($bWgcj)))(values, name, _value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $lB6ZR.default)(function() {
            return formRef.current ? Array.from(formRef.current.querySelectorAll("input")) : [];
        })(finalForm);
        return finalForm;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 1), form = _useState2[0];
    var _useState3 = (0, $9nHZC.useState)({
        dirty: false,
        submitting: false
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState3, 2), state = _useState4[0], setState = _useState4[1];
    (0, $9nHZC.useEffect)(function() {
        var unsubscribe = form.subscribe(function(_ref3) {
            var dirty = _ref3.dirty, submitting = _ref3.submitting;
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    var registerField = (0, $9nHZC.useCallback)(function(name, defaultValue, subscriber, subscription, config) {
        form.pauseValidation();
        var unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    var handleSubmit = function handleSubmit(e) {
        if (e) e.preventDefault();
        form.submit();
    };
    var handleReset = function handleReset(initialValues) {
        form.reset(initialValues);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (e.key === "Enter" && (e.ctrlKey || e.metaKey) && formRef.current) {
            var submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    var _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, children = props.children;
    var dirty = state.dirty, submitting = state.submitting;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ var getCurrentValue = (0, $9nHZC.useCallback)(function(name) {
        var formState = form.getState();
        return (formState === null || formState === void 0 ? void 0 : formState.values[name]) || undefined;
    }, [
        form
    ]);
    var FormContextValue = (0, $9nHZC.useMemo)(function() {
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue
        };
    }, [
        registerField,
        getCurrentValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($a9b2667b01f9f37a$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($a9b2667b01f9f37a$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, children({
        formProps: {
            onSubmit: handleSubmit,
            ref: formRef,
            onKeyDown: handleKeyDown
        },
        dirty: dirty,
        reset: handleReset,
        submitting: submitting,
        disabled: isDisabled,
        getState: function getState() {
            return form.getState();
        },
        getValues: function getValues() {
            return form.getState().values;
        },
        // TODO: deprecate
        setFieldValue: form.change
    })));
}

});
parcelRegister("6qjTz", function(module, exports) {

$parcel$export(module.exports, "getIn", function () { return $4ad49a99f7841e25$export$c52e5867d5879e24; });
$parcel$export(module.exports, "createForm", function () { return $4ad49a99f7841e25$export$f681a8129d2e9d28; });

var $ii97e = parcelRequire("ii97e");

var $4dya5 = parcelRequire("4dya5");
//      
var $4ad49a99f7841e25$var$charCodeOfDot = ".".charCodeAt(0);
var $4ad49a99f7841e25$var$reEscapeChar = /\\(\\)?/g;
var $4ad49a99f7841e25$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $4ad49a99f7841e25$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $4ad49a99f7841e25$var$charCodeOfDot) result.push("");
    string.replace($4ad49a99f7841e25$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($4ad49a99f7841e25$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $4ad49a99f7841e25$var$keysCache = {};
var $4ad49a99f7841e25$var$keysRegex = /[.[\]]+/;
var $4ad49a99f7841e25$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($4ad49a99f7841e25$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $4ad49a99f7841e25$var$keysCache[key] = key.split($4ad49a99f7841e25$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $4ad49a99f7841e25$var$keysCache[key] = $4ad49a99f7841e25$var$stringToPath(key);
    }
    return $4ad49a99f7841e25$var$keysCache[key];
};
//      
var $4ad49a99f7841e25$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $4ad49a99f7841e25$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $4ad49a99f7841e25$var$_toPropertyKey(arg) {
    var key = $4ad49a99f7841e25$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $4ad49a99f7841e25$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $4ad49a99f7841e25$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $4dya5.default)(current, [
                key
            ].map($4ad49a99f7841e25$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $ii97e.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $4ad49a99f7841e25$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $4ad49a99f7841e25$var$setInRecursor(state, 0, $4ad49a99f7841e25$var$toPath(key), value1, destroyArrays);
};
var $4ad49a99f7841e25$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $4ad49a99f7841e25$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $4ad49a99f7841e25$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $4ad49a99f7841e25$export$c52e5867d5879e24(values, name);
    var error = $4ad49a99f7841e25$export$c52e5867d5879e24(errors, name);
    if (error && error[$4ad49a99f7841e25$export$735bebc8ffabf28a]) error = error[$4ad49a99f7841e25$export$735bebc8ffabf28a];
    var submitError = submitErrors && $4ad49a99f7841e25$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $4ad49a99f7841e25$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($4ad49a99f7841e25$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $4ad49a99f7841e25$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $4ad49a99f7841e25$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $4ad49a99f7841e25$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$4ad49a99f7841e25$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $4ad49a99f7841e25$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $4ad49a99f7841e25$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $4ad49a99f7841e25$var$subscriptionFilter(result, state, previousState, subscription, $4ad49a99f7841e25$export$41e855cb628c1b55, $4ad49a99f7841e25$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $4ad49a99f7841e25$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $4ad49a99f7841e25$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $4ad49a99f7841e25$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $4ad49a99f7841e25$var$subscriptionFilter(result, state, previousState, subscription, $4ad49a99f7841e25$export$f1ff97b9d1c7a3c3, $4ad49a99f7841e25$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $4ad49a99f7841e25$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$4ad49a99f7841e25$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $4ad49a99f7841e25$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $4ad49a99f7841e25$export$83d89fbfd8236492 = "4.20.10";
var $4ad49a99f7841e25$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $4ad49a99f7841e25$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $4ad49a99f7841e25$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $4ad49a99f7841e25$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $4ad49a99f7841e25$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $4ad49a99f7841e25$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $4ad49a99f7841e25$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $4ad49a99f7841e25$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($4ad49a99f7841e25$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $4ad49a99f7841e25$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $ii97e.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $ii97e.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $4ad49a99f7841e25$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $4ad49a99f7841e25$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $ii97e.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $ii97e.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $ii97e.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $4ad49a99f7841e25$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $4ad49a99f7841e25$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $4ad49a99f7841e25$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $4ad49a99f7841e25$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $4ad49a99f7841e25$export$e6bdf135a54e021b,
                    shallowEqual: $4ad49a99f7841e25$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $ii97e.default)({}, state.formState.values)); // clone to avoid writing
            if ($4ad49a99f7841e25$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($4ad49a99f7841e25$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $4ad49a99f7841e25$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $4ad49a99f7841e25$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $ii97e.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $ii97e.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $4ad49a99f7841e25$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $4ad49a99f7841e25$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $4ad49a99f7841e25$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$4ad49a99f7841e25$export$735bebc8ffabf28a]) {
                    var existing = $4ad49a99f7841e25$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$4ad49a99f7841e25$export$735bebc8ffabf28a] = error[$4ad49a99f7841e25$export$735bebc8ffabf28a];
                    merged = $4ad49a99f7841e25$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$4ad49a99f7841e25$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$4ad49a99f7841e25$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $ii97e.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $4ad49a99f7841e25$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $4ad49a99f7841e25$var$notify(fieldSubscriber, fieldState, lastFieldState, $4ad49a99f7841e25$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $4ad49a99f7841e25$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $ii97e.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($4ad49a99f7841e25$export$c52e5867d5879e24(formState.values, key), $4ad49a99f7841e25$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($4ad49a99f7841e25$export$c52e5867d5879e24(formState.values, key), $4ad49a99f7841e25$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$4ad49a99f7841e25$var$hasAnyError(formState.errors) && !(formState.submitErrors && $4ad49a99f7841e25$var$hasAnyError(formState.submitErrors));
        var nextFormState = $4ad49a99f7841e25$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $4ad49a99f7841e25$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $4ad49a99f7841e25$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $4ad49a99f7841e25$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $4ad49a99f7841e25$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $4ad49a99f7841e25$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $4ad49a99f7841e25$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $4ad49a99f7841e25$var$notify(state.subscribers, nextFormState, lastFormState, $4ad49a99f7841e25$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $ii97e.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($4ad49a99f7841e25$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $ii97e.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $ii97e.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($4ad49a99f7841e25$export$c52e5867d5879e24(formState.values, key), $4ad49a99f7841e25$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $4ad49a99f7841e25$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $4ad49a99f7841e25$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $4ad49a99f7841e25$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $4ad49a99f7841e25$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $4ad49a99f7841e25$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $4ad49a99f7841e25$export$c52e5867d5879e24(state.formState.values, name) === $4ad49a99f7841e25$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $4ad49a99f7841e25$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $4ad49a99f7841e25$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $4ad49a99f7841e25$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $4ad49a99f7841e25$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $4ad49a99f7841e25$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $4ad49a99f7841e25$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $ii97e.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $ii97e.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $ii97e.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $4ad49a99f7841e25$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$4ad49a99f7841e25$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $ii97e.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $4ad49a99f7841e25$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $4ad49a99f7841e25$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $4ad49a99f7841e25$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $4ad49a99f7841e25$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("lB6ZR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb927b10f2c1d2da$export$2e2bcd8739ae039; });

var $6qjTz = parcelRequire("6qjTz");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $fb927b10f2c1d2da$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === "function");
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $fb927b10f2c1d2da$var$getAllInputs = function getAllInputs() {
    if (typeof document === "undefined") return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($fb927b10f2c1d2da$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $fb927b10f2c1d2da$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $6qjTz.getIn)(errors, input.name);
    });
};
//      
var $fb927b10f2c1d2da$var$noop = function noop() {};
var $fb927b10f2c1d2da$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $fb927b10f2c1d2da$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $fb927b10f2c1d2da$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === "function") // async
            result.then(afterSubmit, $fb927b10f2c1d2da$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $fb927b10f2c1d2da$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === "undefined") return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($fb927b10f2c1d2da$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$fb927b10f2c1d2da$export$2e2bcd8739ae039 = $fb927b10f2c1d2da$var$createDecorator;

});

parcelRegister("bWgcj", function(module, exports) {

var $lyCKU = parcelRequire("lyCKU");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $8b11ad0389650847$var$set(object, path, value) {
    return object == null ? object : $lyCKU(object, path, value);
}
module.exports = $8b11ad0389650847$var$set;

});
parcelRegister("lyCKU", function(module, exports) {

var $7LKGc = parcelRequire("7LKGc");

var $3HwTM = parcelRequire("3HwTM");

var $btWIf = parcelRequire("btWIf");

var $3kSRQ = parcelRequire("3kSRQ");

var $fyTMm = parcelRequire("fyTMm");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $fb1ad606cdd6f581$var$baseSet(object, path, value, customizer) {
    if (!$3kSRQ(object)) return object;
    path = $3HwTM(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $fyTMm(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $3kSRQ(objValue) ? objValue : $btWIf(path[index + 1]) ? [] : {};
        }
        $7LKGc(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $fb1ad606cdd6f581$var$baseSet;

});
parcelRegister("3HwTM", function(module, exports) {

var $lsPUZ = parcelRequire("lsPUZ");

var $jRbZM = parcelRequire("jRbZM");

var $8ceA6 = parcelRequire("8ceA6");

var $1srqY = parcelRequire("1srqY");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $2b1ee83c4d2b4af4$var$castPath(value, object) {
    if ($lsPUZ(value)) return value;
    return $jRbZM(value, object) ? [
        value
    ] : $8ceA6($1srqY(value));
}
module.exports = $2b1ee83c4d2b4af4$var$castPath;

});
parcelRegister("jRbZM", function(module, exports) {

var $lsPUZ = parcelRequire("lsPUZ");

var $eE9rN = parcelRequire("eE9rN");
/** Used to match property names within property paths. */ var $e74c4597683f98c1$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $e74c4597683f98c1$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $e74c4597683f98c1$var$isKey(value, object) {
    if ($lsPUZ(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $eE9rN(value)) return true;
    return $e74c4597683f98c1$var$reIsPlainProp.test(value) || !$e74c4597683f98c1$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $e74c4597683f98c1$var$isKey;

});

parcelRegister("8ceA6", function(module, exports) {

var $5NBme = parcelRequire("5NBme");
/** Used to match property names within property paths. */ var $5f7ac143291a4b6f$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $5f7ac143291a4b6f$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $5f7ac143291a4b6f$var$stringToPath = $5NBme(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($5f7ac143291a4b6f$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($5f7ac143291a4b6f$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = $5f7ac143291a4b6f$var$stringToPath;

});
parcelRegister("5NBme", function(module, exports) {

var $bjB6j = parcelRequire("bjB6j");
/** Used as the maximum memoize cache size. */ var $438e81cabf509c33$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $438e81cabf509c33$var$memoizeCapped(func) {
    var result = $bjB6j(func, function(key) {
        if (cache.size === $438e81cabf509c33$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $438e81cabf509c33$var$memoizeCapped;

});
parcelRegister("bjB6j", function(module, exports) {

var $brfVP = parcelRequire("brfVP");
/** Error message constants. */ var $83ce3f81904cc970$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $83ce3f81904cc970$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($83ce3f81904cc970$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($83ce3f81904cc970$var$memoize.Cache || $brfVP);
    return memoized;
}
// Expose `MapCache`.
$83ce3f81904cc970$var$memoize.Cache = $brfVP;
module.exports = $83ce3f81904cc970$var$memoize;

});



parcelRegister("1srqY", function(module, exports) {

var $lIX6H = parcelRequire("lIX6H");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $10fdafcbf0a13d46$var$toString(value) {
    return value == null ? "" : $lIX6H(value);
}
module.exports = $10fdafcbf0a13d46$var$toString;

});
parcelRegister("lIX6H", function(module, exports) {

var $lgMoJ = parcelRequire("lgMoJ");

var $Ne8Zl = parcelRequire("Ne8Zl");

var $lsPUZ = parcelRequire("lsPUZ");

var $eE9rN = parcelRequire("eE9rN");
/** Used as references for various `Number` constants. */ var $fd0b8e73337dc02a$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $fd0b8e73337dc02a$var$symbolProto = $lgMoJ ? $lgMoJ.prototype : undefined, $fd0b8e73337dc02a$var$symbolToString = $fd0b8e73337dc02a$var$symbolProto ? $fd0b8e73337dc02a$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $fd0b8e73337dc02a$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($lsPUZ(value)) // Recursively convert values (susceptible to call stack limits).
    return $Ne8Zl(value, $fd0b8e73337dc02a$var$baseToString) + "";
    if ($eE9rN(value)) return $fd0b8e73337dc02a$var$symbolToString ? $fd0b8e73337dc02a$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$fd0b8e73337dc02a$var$INFINITY ? "-0" : result;
}
module.exports = $fd0b8e73337dc02a$var$baseToString;

});
parcelRegister("Ne8Zl", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $093f8c6abb2d7b24$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $093f8c6abb2d7b24$var$arrayMap;

});




parcelRegister("fyTMm", function(module, exports) {

var $eE9rN = parcelRequire("eE9rN");
/** Used as references for various `Number` constants. */ var $b5454c8ef3587544$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $b5454c8ef3587544$var$toKey(value) {
    if (typeof value == "string" || $eE9rN(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$b5454c8ef3587544$var$INFINITY ? "-0" : result;
}
module.exports = $b5454c8ef3587544$var$toKey;

});




parcelRegister("9Titd", function(module, exports) {

$parcel$export(module.exports, "Label", function () { return $733793ef606eab33$export$b04be29aa201d4f5; });
$parcel$export(module.exports, "Legend", function () { return $733793ef606eab33$export$ed247974535929c7; });
/** @jsx jsx */ 
var $avKww = parcelRequire("avKww");

var $jp7ng = parcelRequire("jp7ng");

var $kD01A = parcelRequire("kD01A");
var $5LVXk = parcelRequire("5LVXk");

var $aP6k3 = parcelRequire("aP6k3");

var $dCDrX = parcelRequire("dCDrX");
var $733793ef606eab33$var$fontFamily = (0, $aP6k3.fontFamily)();
var $733793ef606eab33$var$fieldsetLabelStyles = (0, $avKww.css)({
    display: "inline-block",
    marginTop: 0,
    marginBottom: "var(--ds-space-050, 4px)",
    fontFamily: $733793ef606eab33$var$fontFamily
});
var $733793ef606eab33$var$getFieldsetLabelDynamicStyles = function getFieldsetLabelDynamicStyles(mode) {
    return (0, $avKww.css)([
        (0, $dCDrX.h200)({
            theme: {
                mode: mode
            }
        }),
        {
            color: (0, $kD01A.default)({
                dark: "var(--ds-text-subtle, ".concat((0, $jp7ng.DN300), ")"),
                light: "var(--ds-text-subtle, ".concat((0, $jp7ng.N200), ")")
            })({
                theme: {
                    mode: mode
                }
            })
        }
    ]);
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $733793ef606eab33$var$lightH200Styles = $733793ef606eab33$var$getFieldsetLabelDynamicStyles("light");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $733793ef606eab33$var$darkH200Styles = $733793ef606eab33$var$getFieldsetLabelDynamicStyles("dark");
var $733793ef606eab33$export$b04be29aa201d4f5 = function Label(_ref) {
    var children = _ref.children, htmlFor = _ref.htmlFor, id = _ref.id, testId = _ref.testId;
    var _useGlobalTheme = (0, $5LVXk.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $avKww.jsx)("label", {
        css: [
            mode === "light" ? $733793ef606eab33$var$lightH200Styles : $733793ef606eab33$var$darkH200Styles,
            $733793ef606eab33$var$fieldsetLabelStyles
        ],
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
};
var $733793ef606eab33$export$ed247974535929c7 = function Legend(_ref2) {
    var children = _ref2.children;
    var _useGlobalTheme2 = (0, $5LVXk.useGlobalTheme)(), mode = _useGlobalTheme2.mode;
    return (0, $avKww.jsx)("legend", {
        css: [
            mode === "light" ? $733793ef606eab33$var$lightH200Styles : $733793ef606eab33$var$darkH200Styles,
            $733793ef606eab33$var$fieldsetLabelStyles
        ]
    }, children);
};
var $733793ef606eab33$export$2e2bcd8739ae039 = $733793ef606eab33$export$b04be29aa201d4f5;

});

parcelRegister("7OocK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5afffa6cba299296$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $avKww = parcelRequire("avKww");

var $jp7ng = parcelRequire("jp7ng");

var $aP6k3 = parcelRequire("aP6k3");
var $5afffa6cba299296$var$fontFamily = (0, $aP6k3.fontFamily)();
var $5afffa6cba299296$var$requiredIndicatorStyles = (0, $avKww.css)({
    paddingLeft: "var(--ds-space-025, 2px)",
    color: "var(--ds-text-danger, ".concat((0, $jp7ng.R400), ")"),
    fontFamily: $5afffa6cba299296$var$fontFamily
});
function $5afffa6cba299296$export$2e2bcd8739ae039() {
    return (0, $avKww.jsx)("span", {
        css: $5afffa6cba299296$var$requiredIndicatorStyles,
        "aria-hidden": "true",
        title: "required"
    }, "*");
}

});



parcelRegister("5H0cN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $425120adba6a0f67$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $avKww = parcelRequire("avKww");
var $425120adba6a0f67$var$formFooterWrapperStyles = (0, $avKww.css)({
    display: "flex",
    marginTop: "var(--ds-space-300, 24px)",
    justifyContent: "flex-end"
});
var $425120adba6a0f67$var$justifyContentStyles = (0, $avKww.css)({
    justifyContent: "flex-start"
});
function $425120adba6a0f67$export$2e2bcd8739ae039(_ref) {
    var _ref$align = _ref.align, align = _ref$align === void 0 ? "end" : _ref$align, children = _ref.children;
    return (0, $avKww.jsx)("footer", {
        css: [
            $425120adba6a0f67$var$formFooterWrapperStyles,
            align === "start" && $425120adba6a0f67$var$justifyContentStyles
        ]
    }, children);
}

});

parcelRegister("9tjXs", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $6e564dbf5a64fc72$var$noop() {
// No operation performed.
}
module.exports = $6e564dbf5a64fc72$var$noop;

});

parcelRegister("aMNOk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7da50670e2b1b4ac$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $iXx2A = parcelRequire("iXx2A");
var $gSq3s = parcelRequire("gSq3s");
var $goo1d = parcelRequire("goo1d");
var $85L9m = parcelRequire("85L9m");

var $crbSw = parcelRequire("crbSw");

var $5nR8v = parcelRequire("5nR8v");

var $8p2GL = parcelRequire("8p2GL");

var $5vvNZ = parcelRequire("5vvNZ");

var $lqpGd = parcelRequire("lqpGd");

var $kleGq = parcelRequire("kleGq");

var $1zBji = parcelRequire("1zBji");

var $7DQWv = parcelRequire("7DQWv");
var $9Qu5e = parcelRequire("9Qu5e");

var $7S7GL = parcelRequire("7S7GL");
function $7da50670e2b1b4ac$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7da50670e2b1b4ac$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7da50670e2b1b4ac$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7da50670e2b1b4ac$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7da50670e2b1b4ac$var$CSS_VAR_ICON_COLOR = "--flag-icon-color";
// For cases where a single word is longer than the container (e.g. filenames)
var $7da50670e2b1b4ac$var$overflowWrapStyles = (0, $85L9m.xcss)({
    overflowWrap: "anywhere"
});
var $7da50670e2b1b4ac$var$descriptionStyles = (0, $avKww.css)({
    maxHeight: 100,
    // height is defined as 5 lines maximum by design
    overflow: "auto",
    overflowWrap: "anywhere" // For cases where a single word is longer than the container (e.g. filenames)
});
var $7da50670e2b1b4ac$var$iconWrapperStyles = (0, $avKww.css)({
    display: "flex",
    alignItems: "start",
    flexShrink: 0,
    color: "var(".concat($7da50670e2b1b4ac$var$CSS_VAR_ICON_COLOR, ")")
});
var $7da50670e2b1b4ac$var$flagStyles = (0, $85L9m.xcss)({
    boxShadow: "elevation.shadow.overlay",
    borderRadius: "border.radius.100",
    overflow: "hidden",
    zIndex: "flag",
    width: "100%",
    transition: "background-color 200ms"
});
var $7da50670e2b1b4ac$var$flagWrapperStyles = (0, $avKww.css)({
    width: "100%"
});
var $7da50670e2b1b4ac$var$analyticsAttributes = {
    componentName: "flag",
    packageName: "@atlaskit/flag",
    packageVersion: "15.8.1"
};
var $7da50670e2b1b4ac$var$transitionStyles = (0, $avKww.css)({
    flexGrow: 1,
    transition: "gap 0.3s"
});
/**
 * __Flag__
 *
 * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
 * often displayed using a flag group.
 *
 * - [Examples](https://atlassian.design/components/flag/examples)
 * - [Code](https://atlassian.design/components/flag/code)
 * - [Usage](https://atlassian.design/components/flag/usage)
 */ var $7da50670e2b1b4ac$var$Flag = function Flag(props) {
    var _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $5vvNZ.DEFAULT_APPEARANCE) : _props$appearance, icon = props.icon, title = props.title, description = props.description, linkComponent = props.linkComponent, onMouseOver = props.onMouseOver, _props$onFocus = props.onFocus, onFocus = _props$onFocus === void 0 ? (0, $8p2GL.default) : _props$onFocus, onMouseOut = props.onMouseOut, _props$onBlur = props.onBlur, onBlur = _props$onBlur === void 0 ? (0, $8p2GL.default) : _props$onBlur, _props$onDismissed = props.onDismissed, onDismissedProp = _props$onDismissed === void 0 ? (0, $8p2GL.default) : _props$onDismissed, testId = props.testId, id = props.id, analyticsContext = props.analyticsContext, delayAnnouncement = props.delayAnnouncement, _props$headingLevel = props.headingLevel, headingLevel = _props$headingLevel === void 0 ? 2 : _props$headingLevel;
    var _useState = (0, $9nHZC.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), isDelayToAnnounce = _useState2[0], setIsDelayToAnnounce = _useState2[1];
    var _useFlagGroup = (0, $1zBji.useFlagGroup)(), onDismissedFromFlagGroup = _useFlagGroup.onDismissed, isDismissAllowed = _useFlagGroup.isDismissAllowed;
    var onDismissed = (0, $9nHZC.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var _useState3 = (0, $9nHZC.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState3, 2), isExpanded = _useState4[0], setIsExpanded = _useState4[1];
    var onDismissedAnalytics = (0, $5nR8v.usePlatformLeafEventHandler)($7da50670e2b1b4ac$var$_objectSpread({
        fn: onDismissed,
        action: "dismissed",
        analyticsData: analyticsContext
    }, $7da50670e2b1b4ac$var$analyticsAttributes));
    var isBold = appearance !== (0, $5vvNZ.DEFAULT_APPEARANCE);
    var toggleExpand = (0, $9nHZC.useCallback)(function() {
        setIsExpanded(function(previous) {
            return !previous;
        });
    }, []);
    var buttonActionCallback = (0, $9nHZC.useCallback)(function() {
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $9nHZC.useEffect)(function() {
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $9nHZC.useEffect)(function() {
        if (!delayAnnouncement) return;
        setTimeout(function() {
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    var onFocusAnalytics = (0, $5nR8v.usePlatformLeafEventHandler)($7da50670e2b1b4ac$var$_objectSpread({
        fn: onFocus,
        action: "focused",
        analyticsData: analyticsContext
    }, $7da50670e2b1b4ac$var$analyticsAttributes));
    var onBlurAnalytics = (0, $5nR8v.usePlatformLeafEventHandler)($7da50670e2b1b4ac$var$_objectSpread({
        fn: onBlur,
        action: "blurred",
        analyticsData: analyticsContext
    }, $7da50670e2b1b4ac$var$analyticsAttributes));
    var autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    var textColor = (0, $lqpGd.flagTextColor)[appearance];
    var iconColor = (0, $lqpGd.flagIconColor)[appearance];
    var isDismissable = isBold || isDismissAllowed;
    var shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
    // when delayAnnouncement is available we will use a hidden content for announcement
    var delayedAnnouncement = delayAnnouncement ? (0, $avKww.jsx)((0, $7S7GL.default), {
        role: "alert"
    }, title, description) : undefined;
    return (0, $avKww.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        role: delayAnnouncement ? undefined : "alert",
        css: $7da50670e2b1b4ac$var$flagWrapperStyles,
        "data-testid": testId
    }, autoDismissProps), (0, $avKww.jsx)((0, $iXx2A.default), {
        backgroundColor: (0, $lqpGd.flagBackgroundColor)[appearance],
        padding: "space.200",
        xcss: $7da50670e2b1b4ac$var$flagStyles
    }, (0, $avKww.jsx)((0, $gSq3s.default), {
        alignBlock: "stretch",
        space: "space.200"
    }, (0, $avKww.jsx)("div", {
        css: $7da50670e2b1b4ac$var$iconWrapperStyles,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, $7da50670e2b1b4ac$var$CSS_VAR_ICON_COLOR, iconColor)
    }, icon), (0, $avKww.jsx)("span", {
        css: $7da50670e2b1b4ac$var$transitionStyles
    }, (0, $avKww.jsx)((0, $goo1d.default), {
        space: shouldRenderGap ? "space.100" : "space.0" // Gap exists even when not expanded due to Expander internals always being in the DOM
    }, isDelayToAnnounce && delayedAnnouncement, (0, $avKww.jsx)((0, $gSq3s.default), {
        alignBlock: "stretch",
        space: "space.100",
        spread: "space-between"
    }, (0, $avKww.jsx)((0, $iXx2A.default), {
        paddingBlockStart: "space.050",
        paddingBlockEnd: "space.025",
        xcss: $7da50670e2b1b4ac$var$overflowWrapStyles
    }, (0, $avKww.jsx)((0, $crbSw.default), {
        as: "h".concat(headingLevel),
        size: "xsmall",
        color: textColor
    }, title)), isDismissable ? !(isBold && !description && !actions.length) && (0, $avKww.jsx)((0, $7DQWv.default), {
        testId: testId,
        appearance: appearance,
        isBold: isBold,
        isExpanded: isExpanded,
        onClick: isBold ? toggleExpand : buttonActionCallback
    }) : null), (0, $avKww.jsx)((0, $9Qu5e.default), {
        isExpanded: !isBold || isExpanded,
        testId: testId
    }, description && (0, $avKww.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            color: (0, $lqpGd.flagTextColorToken)[appearance]
        },
        css: $7da50670e2b1b4ac$var$descriptionStyles,
        "data-testid": testId && "".concat(testId, "-description")
    }, description), (0, $avKww.jsx)((0, $kleGq.default), {
        actions: actions,
        appearance: appearance,
        linkComponent: linkComponent,
        testId: testId
    })))))));
};
var $7da50670e2b1b4ac$export$2e2bcd8739ae039 = $7da50670e2b1b4ac$var$Flag;

});
parcelRegister("iXx2A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcd75ddf155844db$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $2O9b8 = parcelRequire("2O9b8");

var $85L9m = parcelRequire("85L9m");

var $kYoz7 = parcelRequire("kYoz7");
var $dcd75ddf155844db$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $dcd75ddf155844db$var$_excluded2 = [
    "className"
];
var $dcd75ddf155844db$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $dcd75ddf155844db$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(htmlAttributes, $dcd75ddf155844db$var$_excluded2);
    var resolvedStyles = (0, $85L9m.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $avKww.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $dcd75ddf155844db$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $2O9b8.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $2O9b8.isSurfaceColorToken)(backgroundColor) && (0, $2O9b8.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $2O9b8.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $2O9b8.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $2O9b8.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $2O9b8.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $2O9b8.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $2O9b8.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $2O9b8.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $avKww.jsx)((0, $kYoz7.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $dcd75ddf155844db$export$2e2bcd8739ae039 = $dcd75ddf155844db$export$e71c4d32a2263218;
var $dcd75ddf155844db$var$baseStyles = (0, $avKww.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("2O9b8", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $20b75ef50fc32704$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $20b75ef50fc32704$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $20b75ef50fc32704$export$632685d741f3dbbf; });
$parcel$export(module.exports, "inverseColorMap", function () { return $20b75ef50fc32704$export$2185ce37f9bdd963; });
$parcel$export(module.exports, "opacityMap", function () { return $20b75ef50fc32704$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $20b75ef50fc32704$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $20b75ef50fc32704$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $20b75ef50fc32704$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $20b75ef50fc32704$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $20b75ef50fc32704$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $20b75ef50fc32704$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $20b75ef50fc32704$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $20b75ef50fc32704$export$e615f061ca585a6c; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $20b75ef50fc32704$export$bf46c3f9eeafc71f; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $20b75ef50fc32704$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $20b75ef50fc32704$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $20b75ef50fc32704$export$5e65a44e5b6ecadb; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $xbX1J = parcelRequire("xbX1J");
function $20b75ef50fc32704$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $20b75ef50fc32704$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $20b75ef50fc32704$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $20b75ef50fc32704$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $20b75ef50fc32704$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $20b75ef50fc32704$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $20b75ef50fc32704$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $20b75ef50fc32704$export$632685d741f3dbbf = $20b75ef50fc32704$var$_objectSpread($20b75ef50fc32704$var$_objectSpread({}, $20b75ef50fc32704$export$958d0ae7f2977ae4), $20b75ef50fc32704$export$d2dc61f58390201c);
var $20b75ef50fc32704$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $20b75ef50fc32704$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $20b75ef50fc32704$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $20b75ef50fc32704$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $20b75ef50fc32704$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $20b75ef50fc32704$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $20b75ef50fc32704$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $20b75ef50fc32704$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $20b75ef50fc32704$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $20b75ef50fc32704$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $20b75ef50fc32704$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $20b75ef50fc32704$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $20b75ef50fc32704$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $20b75ef50fc32704$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $20b75ef50fc32704$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $20b75ef50fc32704$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $avKww.css)((0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $20b75ef50fc32704$export$e615f061ca585a6c = $20b75ef50fc32704$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $20b75ef50fc32704$var$getSerializedStylesMap(spacingProperty, $20b75ef50fc32704$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $20b75ef50fc32704$export$bf46c3f9eeafc71f = $20b75ef50fc32704$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $20b75ef50fc32704$var$getSerializedStylesMap(spacingProperty, $20b75ef50fc32704$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $20b75ef50fc32704$export$e7af83bafe7f9e63 = $20b75ef50fc32704$var$getSerializedStylesMap("backgroundColor", $20b75ef50fc32704$export$d1d79bf68ac056bd);
var $20b75ef50fc32704$export$3a1bcba60b23d7f0 = $20b75ef50fc32704$var$getSerializedStylesMap("color", $20b75ef50fc32704$export$8473307aa00d6ea1);
var $20b75ef50fc32704$export$45f3f4fe16f9f7d5 = $20b75ef50fc32704$var$getSerializedStylesMap("fontWeight", $20b75ef50fc32704$export$303e322c6b1ed114);
var $20b75ef50fc32704$export$68cc305da27dbaa4 = $20b75ef50fc32704$var$getSerializedStylesMap("fontFamily", $20b75ef50fc32704$export$3c7e9587132614b4);
var $20b75ef50fc32704$export$128f10c238242f83 = $20b75ef50fc32704$var$getSerializedStylesMap("font", $20b75ef50fc32704$export$6cc560b4dedf3816);
var $20b75ef50fc32704$export$ff257d957d48c421 = $20b75ef50fc32704$var$getSerializedStylesMap((0, $xbX1J.CURRENT_SURFACE_CSS_VAR), $20b75ef50fc32704$export$41a358c9c2356760);
var $20b75ef50fc32704$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $20b75ef50fc32704$export$41a358c9c2356760[color] !== undefined;
};

});

parcelRegister("85L9m", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $5e435d61490b34ed$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $5e435d61490b34ed$export$f6c783d06584602c; });

var $b4Ivn = parcelRequire("b4Ivn");

var $kFnE9 = parcelRequire("kFnE9");

var $9q1kH = parcelRequire("9q1kH");

var $340K4 = parcelRequire("340K4");

var $avKww = parcelRequire("avKww");

var $2O9b8 = parcelRequire("2O9b8");

var $8ovux = parcelRequire("8ovux");
function $5e435d61490b34ed$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $5e435d61490b34ed$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $5e435d61490b34ed$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5e435d61490b34ed$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5e435d61490b34ed$var$_arrayLikeToArray(o, minLen);
}
function $5e435d61490b34ed$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $5e435d61490b34ed$export$9a199fbafee0014e = {
    backgroundColor: (0, $2O9b8.backgroundColorMap),
    blockSize: (0, $2O9b8.dimensionMap),
    borderBlockColor: (0, $2O9b8.borderColorMap),
    borderBlockEndColor: (0, $2O9b8.borderColorMap),
    borderBlockEndWidth: (0, $2O9b8.borderWidthMap),
    borderBlockStartColor: (0, $2O9b8.borderColorMap),
    borderBlockStartWidth: (0, $2O9b8.borderWidthMap),
    borderBlockWidth: (0, $2O9b8.borderWidthMap),
    borderBottomColor: (0, $2O9b8.borderColorMap),
    borderBottomLeftRadius: (0, $2O9b8.borderRadiusMap),
    borderBottomRightRadius: (0, $2O9b8.borderRadiusMap),
    borderBottomWidth: (0, $2O9b8.borderWidthMap),
    borderColor: (0, $2O9b8.borderColorMap),
    borderEndEndRadius: (0, $2O9b8.borderRadiusMap),
    borderEndStartRadius: (0, $2O9b8.borderRadiusMap),
    borderInlineColor: (0, $2O9b8.borderColorMap),
    borderInlineEndColor: (0, $2O9b8.borderColorMap),
    borderInlineEndWidth: (0, $2O9b8.borderWidthMap),
    borderInlineStartColor: (0, $2O9b8.borderColorMap),
    borderInlineStartWidth: (0, $2O9b8.borderWidthMap),
    borderInlineWidth: (0, $2O9b8.borderWidthMap),
    borderLeftColor: (0, $2O9b8.borderColorMap),
    borderLeftWidth: (0, $2O9b8.borderWidthMap),
    borderRadius: (0, $2O9b8.borderRadiusMap),
    borderRightColor: (0, $2O9b8.borderColorMap),
    borderRightWidth: (0, $2O9b8.borderWidthMap),
    borderStartEndRadius: (0, $2O9b8.borderRadiusMap),
    borderStartStartRadius: (0, $2O9b8.borderRadiusMap),
    borderTopColor: (0, $2O9b8.borderColorMap),
    borderTopLeftRadius: (0, $2O9b8.borderRadiusMap),
    borderTopRightRadius: (0, $2O9b8.borderRadiusMap),
    borderTopWidth: (0, $2O9b8.borderWidthMap),
    borderWidth: (0, $2O9b8.borderWidthMap),
    bottom: (0, $2O9b8.allSpaceMap),
    boxShadow: (0, $2O9b8.shadowMap),
    color: (0, $2O9b8.textColorMap),
    columnGap: (0, $2O9b8.positiveSpaceMap),
    gap: (0, $2O9b8.positiveSpaceMap),
    height: (0, $2O9b8.dimensionMap),
    inlineSize: (0, $2O9b8.dimensionMap),
    inset: (0, $2O9b8.allSpaceMap),
    insetBlock: (0, $2O9b8.allSpaceMap),
    insetBlockEnd: (0, $2O9b8.allSpaceMap),
    insetBlockStart: (0, $2O9b8.allSpaceMap),
    insetInline: (0, $2O9b8.allSpaceMap),
    insetInlineEnd: (0, $2O9b8.allSpaceMap),
    insetInlineStart: (0, $2O9b8.allSpaceMap),
    left: (0, $2O9b8.allSpaceMap),
    margin: (0, $2O9b8.allSpaceMap),
    marginBlock: (0, $2O9b8.allSpaceMap),
    marginBlockEnd: (0, $2O9b8.allSpaceMap),
    marginBlockStart: (0, $2O9b8.allSpaceMap),
    marginBottom: (0, $2O9b8.allSpaceMap),
    marginInline: (0, $2O9b8.allSpaceMap),
    marginInlineEnd: (0, $2O9b8.allSpaceMap),
    marginInlineStart: (0, $2O9b8.allSpaceMap),
    marginLeft: (0, $2O9b8.allSpaceMap),
    marginRight: (0, $2O9b8.allSpaceMap),
    marginTop: (0, $2O9b8.allSpaceMap),
    maxBlockSize: (0, $2O9b8.dimensionMap),
    maxHeight: (0, $2O9b8.dimensionMap),
    maxInlineSize: (0, $2O9b8.dimensionMap),
    maxWidth: (0, $2O9b8.dimensionMap),
    minBlockSize: (0, $2O9b8.dimensionMap),
    minHeight: (0, $2O9b8.dimensionMap),
    minInlineSize: (0, $2O9b8.dimensionMap),
    minWidth: (0, $2O9b8.dimensionMap),
    opacity: (0, $2O9b8.opacityMap),
    outlineColor: (0, $2O9b8.borderColorMap),
    outlineOffset: (0, $2O9b8.positiveSpaceMap),
    outlineWidth: (0, $2O9b8.borderWidthMap),
    padding: (0, $2O9b8.positiveSpaceMap),
    paddingBlock: (0, $2O9b8.positiveSpaceMap),
    paddingBlockEnd: (0, $2O9b8.positiveSpaceMap),
    paddingBlockStart: (0, $2O9b8.positiveSpaceMap),
    paddingBottom: (0, $2O9b8.positiveSpaceMap),
    paddingInline: (0, $2O9b8.positiveSpaceMap),
    paddingInlineEnd: (0, $2O9b8.positiveSpaceMap),
    paddingInlineStart: (0, $2O9b8.positiveSpaceMap),
    paddingLeft: (0, $2O9b8.positiveSpaceMap),
    paddingRight: (0, $2O9b8.positiveSpaceMap),
    paddingTop: (0, $2O9b8.positiveSpaceMap),
    right: (0, $2O9b8.allSpaceMap),
    rowGap: (0, $2O9b8.positiveSpaceMap),
    top: (0, $2O9b8.allSpaceMap),
    width: (0, $2O9b8.dimensionMap),
    zIndex: (0, $2O9b8.layerMap)
};
var $5e435d61490b34ed$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $5e435d61490b34ed$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $8ovux === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))($8ovux.env) === "object" && false;
};
var $5e435d61490b34ed$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $5e435d61490b34ed$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $5e435d61490b34ed$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(value) === "object" && $5e435d61490b34ed$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($5e435d61490b34ed$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($5e435d61490b34ed$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $5e435d61490b34ed$export$9a199fbafee0014e)) return;
        var tokenValue = $5e435d61490b34ed$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $5e435d61490b34ed$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $5e435d61490b34ed$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, $5e435d61490b34ed$var$uniqueSymbol, (0, $avKww.css)(transformedStyles));
};
var $5e435d61490b34ed$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $5e435d61490b34ed$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$5e435d61490b34ed$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $5e435d61490b34ed$export$f6c783d06584602c(style) {
    return $5e435d61490b34ed$var$baseXcss(style);
}

});

parcelRegister("kYoz7", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $f44c7773a93bb395$export$1ca2a26fecb070ae; });
$parcel$export(module.exports, "useSurface", function () { return $f44c7773a93bb395$export$1aeb4f6b93c4540d; });

var $9nHZC = parcelRequire("9nHZC");
var $f44c7773a93bb395$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $9nHZC.createContext)("elevation.surface");
var $f44c7773a93bb395$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $9nHZC.useContext)($f44c7773a93bb395$export$1ca2a26fecb070ae);
};
$f44c7773a93bb395$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("gSq3s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c495e668b1b3c569$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $85L9m = parcelRequire("85L9m");

var $6lEdW = parcelRequire("6lEdW");
var $c495e668b1b3c569$var$flexGrowMap = {
    hug: (0, $85L9m.xcss)({
        flexGrow: 0
    }),
    fill: (0, $85L9m.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
var $c495e668b1b3c569$var$separatorStyles = (0, $avKww.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $c495e668b1b3c569$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $avKww.jsx)("span", {
        css: $c495e668b1b3c569$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $c495e668b1b3c569$var$Inline = /*#__PURE__*/ (0, $9nHZC.memo)(/*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $avKww.jsx)($c495e668b1b3c569$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $9nHZC.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $avKww.jsx)((0, $9nHZC.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $c495e668b1b3c569$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $avKww.jsx)((0, $6lEdW.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$c495e668b1b3c569$var$Inline.displayName = "Inline";
var $c495e668b1b3c569$export$2e2bcd8739ae039 = $c495e668b1b3c569$var$Inline;

});
parcelRegister("6lEdW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49f3e7dfd7495e63$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $2O9b8 = parcelRequire("2O9b8");

var $85L9m = parcelRequire("85L9m");
var $49f3e7dfd7495e63$var$justifyContentMap = {
    start: (0, $avKww.css)({
        justifyContent: "start"
    }),
    center: (0, $avKww.css)({
        justifyContent: "center"
    }),
    end: (0, $avKww.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $avKww.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $avKww.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $avKww.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $avKww.css)({
        justifyContent: "stretch"
    })
};
var $49f3e7dfd7495e63$var$flexDirectionMap = {
    column: (0, $avKww.css)({
        flexDirection: "column"
    }),
    row: (0, $avKww.css)({
        flexDirection: "row"
    })
};
var $49f3e7dfd7495e63$var$flexWrapMap = {
    wrap: (0, $avKww.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $avKww.css)({
        flexWrap: "nowrap"
    })
};
var $49f3e7dfd7495e63$var$alignItemsMap = {
    start: (0, $avKww.css)({
        alignItems: "start"
    }),
    center: (0, $avKww.css)({
        alignItems: "center"
    }),
    baseline: (0, $avKww.css)({
        alignItems: "baseline"
    }),
    end: (0, $avKww.css)({
        alignItems: "end"
    }),
    stretch: (0, $avKww.css)({
        alignItems: "stretch"
    })
};
var $49f3e7dfd7495e63$var$baseStyles = (0, $avKww.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $49f3e7dfd7495e63$var$Flex = /*#__PURE__*/ (0, $9nHZC.memo)(/*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $85L9m.parseXcss)(xcss);
    return (0, $avKww.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $49f3e7dfd7495e63$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $2O9b8.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $2O9b8.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $2O9b8.spaceStylesMap).rowGap[rowGap],
            alignItems && $49f3e7dfd7495e63$var$alignItemsMap[alignItems],
            direction && $49f3e7dfd7495e63$var$flexDirectionMap[direction],
            justifyContent && $49f3e7dfd7495e63$var$justifyContentMap[justifyContent],
            wrap && $49f3e7dfd7495e63$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$49f3e7dfd7495e63$var$Flex.displayName = "Flex";
var $49f3e7dfd7495e63$export$2e2bcd8739ae039 = $49f3e7dfd7495e63$var$Flex;

});


parcelRegister("goo1d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bef184d77973af0e$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $85L9m = parcelRequire("85L9m");

var $6lEdW = parcelRequire("6lEdW");
var $bef184d77973af0e$var$flexGrowMap = {
    hug: (0, $85L9m.xcss)({
        flexGrow: 0
    }),
    fill: (0, $85L9m.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $bef184d77973af0e$var$Stack = /*#__PURE__*/ (0, $9nHZC.memo)(/*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $bef184d77973af0e$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $avKww.jsx)((0, $6lEdW.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$bef184d77973af0e$var$Stack.displayName = "Stack";
var $bef184d77973af0e$export$2e2bcd8739ae039 = $bef184d77973af0e$var$Stack;

});

parcelRegister("crbSw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90e13879ce0b77b3$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9q1kH = parcelRequire("9q1kH");

var $avKww = parcelRequire("avKww");

var $30S9O = parcelRequire("30S9O");

var $kpijv = parcelRequire("kpijv");

var $8ovux = parcelRequire("8ovux");
var $90e13879ce0b77b3$var$_excluded = [
    "level"
];
// https://atlassian.design/foundations/typography
var $90e13879ce0b77b3$var$levelMap = {
    h900: "h1",
    h800: "h1",
    h700: "h2",
    h600: "h3",
    h500: "h4",
    h400: "h5",
    h300: "h6",
    // NB: These two levels are not covered at all by the existing @atlaskit/css-reset
    h200: "div",
    h100: "div"
};
var $90e13879ce0b77b3$var$headingResetStyles = (0, $avKww.css)({
    color: "var(--ds-text, #172B4D)",
    marginBlock: "var(--ds-space-0, 0px)"
});
var $90e13879ce0b77b3$var$h900Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-600, 35px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-600, 40px)"
});
var $90e13879ce0b77b3$var$h800Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-500, 29px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-500, 32px)"
});
var $90e13879ce0b77b3$var$h700Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-400, 24px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-400, 28px)"
});
var $90e13879ce0b77b3$var$h600Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-300, 20px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.008em",
    lineHeight: "var(--ds-font-lineHeight-300, 24px)"
});
var $90e13879ce0b77b3$var$h500Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-200, 16px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.006em",
    lineHeight: "var(--ds-font-lineHeight-200, 20px)"
});
var $90e13879ce0b77b3$var$h400Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-100, 14px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.003em",
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $90e13879ce0b77b3$var$h300Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)",
    textTransform: "uppercase"
});
var $90e13879ce0b77b3$var$h200Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $90e13879ce0b77b3$var$h100Styles = (0, $avKww.css)({
    fontSize: "var(--ds-font-size-050, 11px)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $90e13879ce0b77b3$var$inverseStyles = (0, $avKww.css)({
    color: "var(--ds-text-inverse, #FFF)"
});
var $90e13879ce0b77b3$var$subtlestStyles = (0, $avKww.css)({
    color: "var(--ds-text-subtlest, #6B778C)"
});
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ var $90e13879ce0b77b3$var$OldHeading = function OldHeading(_ref) {
    var children = _ref.children, level = _ref.level, id = _ref.id, testId = _ref.testId, as = _ref.as, _ref$color = _ref.color, color = _ref$color === void 0 ? "default" : _ref$color;
    typeof $8ovux;
    var _useHeading = (0, $30S9O.useHeading)($90e13879ce0b77b3$var$levelMap[level]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Markup = as || inferredElement;
    var isSubtleHeading = level === "h200" || level === "h100";
    var needsAriaRole = Markup === "div" && hLevel;
    return (0, $avKww.jsx)(Markup, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $90e13879ce0b77b3$var$headingResetStyles,
            level === "h100" && $90e13879ce0b77b3$var$h100Styles,
            level === "h200" && $90e13879ce0b77b3$var$h200Styles,
            level === "h300" && $90e13879ce0b77b3$var$h300Styles,
            level === "h400" && $90e13879ce0b77b3$var$h400Styles,
            level === "h500" && $90e13879ce0b77b3$var$h500Styles,
            level === "h600" && $90e13879ce0b77b3$var$h600Styles,
            level === "h700" && $90e13879ce0b77b3$var$h700Styles,
            level === "h800" && $90e13879ce0b77b3$var$h800Styles,
            level === "h900" && $90e13879ce0b77b3$var$h900Styles,
            color === "inverse" && $90e13879ce0b77b3$var$inverseStyles,
            color === "default" && isSubtleHeading && $90e13879ce0b77b3$var$subtlestStyles
        ]
    }, children);
};
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * // New component
 * <Heading size="xxlarge">Page title</Heading>
 *
 * // Old component
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ var $90e13879ce0b77b3$var$Heading = function Heading(_ref2) {
    var level = _ref2.level, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref2, $90e13879ce0b77b3$var$_excluded);
    return level ? // eslint-disable-next-line jsx-a11y/heading-has-content, @repo/internal/react/no-unsafe-spread-props
    (0, $avKww.jsx)($90e13879ce0b77b3$var$OldHeading, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        level: level
    }, props)) : // eslint-disable-next-line jsx-a11y/heading-has-content, @repo/internal/react/no-unsafe-spread-props
    (0, $avKww.jsx)((0, $kpijv.default), props);
};
var $90e13879ce0b77b3$export$2e2bcd8739ae039 = $90e13879ce0b77b3$var$Heading;

});
parcelRegister("30S9O", function(module, exports) {

$parcel$export(module.exports, "useHeading", function () { return $231b61ada25cf006$export$97a37b1befbbf9b1; });

var $9nHZC = parcelRequire("9nHZC");
// Allows support for heading levels 1-9 via aria-level
var $231b61ada25cf006$var$HeadingLevelContext = /*#__PURE__*/ (0, $9nHZC.createContext)(0);
var $231b61ada25cf006$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $9nHZC.useContext)($231b61ada25cf006$var$HeadingLevelContext);
};
var $231b61ada25cf006$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $231b61ada25cf006$export$6a64a1e2d0bbbf75();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? "div" : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $231b61ada25cf006$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $231b61ada25cf006$export$6a64a1e2d0bbbf75();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($231b61ada25cf006$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $231b61ada25cf006$export$2e2bcd8739ae039 = $231b61ada25cf006$var$HeadingLevelContextProvider;

});

parcelRegister("kpijv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edb4592b9b2f0246$export$2e2bcd8739ae039; });

var $9q1kH = parcelRequire("9q1kH");

var $avKww = parcelRequire("avKww");

var $2O9b8 = parcelRequire("2O9b8");
var $kYoz7 = parcelRequire("kYoz7");

var $30S9O = parcelRequire("30S9O");

var $8ovux = parcelRequire("8ovux");
var $edb4592b9b2f0246$var$sizeTagMap = {
    xxlarge: "h1",
    xlarge: "h1",
    large: "h2",
    medium: "h3",
    small: "h4",
    xsmall: "h5",
    xxsmall: "h6"
};
var $edb4592b9b2f0246$var$headingResetStyles = (0, $avKww.css)({
    letterSpacing: "normal",
    marginBlock: 0,
    textTransform: "none"
});
var $edb4592b9b2f0246$var$useColor = function useColor(colorProp) {
    var surface = (0, $kYoz7.useSurface)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $2O9b8.inverseColorMap).hasOwnProperty(surface)) return (0, $2O9b8.inverseColorMap)[surface];
    return colorProp || "color.text";
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $edb4592b9b2f0246$var$Heading = function Heading(_ref) {
    var children = _ref.children, size = _ref.size, id = _ref.id, testId = _ref.testId, as = _ref.as, colorProp = _ref.color;
    typeof $8ovux;
    // Technically size can be undefined here due to how the types work.
    // Once removing the level prop this assertion can be removed since size will be a required prop.
    var _useHeading = (0, $30S9O.useHeading)($edb4592b9b2f0246$var$sizeTagMap[size]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === "div" && hLevel;
    var color = $edb4592b9b2f0246$var$useColor(colorProp);
    return (0, $avKww.jsx)(Component, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $edb4592b9b2f0246$var$headingResetStyles,
            size && $edb4592b9b2f0246$var$headingSizeStylesMap[size],
            $edb4592b9b2f0246$export$93e8ddd840a408f9[color]
        ]
    }, children);
};
var $edb4592b9b2f0246$export$93e8ddd840a408f9 = {
    "color.text": (0, $avKww.css)({
        color: "var(--ds-text, #172B4D)"
    }),
    "color.text.inverse": (0, $avKww.css)({
        color: "var(--ds-text-inverse, #FFFFFF)"
    }),
    "color.text.warning.inverse": (0, $avKww.css)({
        color: "var(--ds-text-warning-inverse, #172B4D)"
    })
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df829c6c0aa19bb57c0c77dc08d12d60>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $edb4592b9b2f0246$var$headingSizeStylesMap = {
    xxlarge: (0, $avKww.css)({
        font: 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xlarge: (0, $avKww.css)({
        font: 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    large: (0, $avKww.css)({
        font: 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    medium: (0, $avKww.css)({
        font: 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    small: (0, $avKww.css)({
        font: 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xsmall: (0, $avKww.css)({
        font: 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xxsmall: (0, $avKww.css)({
        font: 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    })
};
var /**
 * @codegenEnd
 */ $edb4592b9b2f0246$export$2e2bcd8739ae039 = $edb4592b9b2f0246$var$Heading;

});


parcelRegister("5nR8v", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $3eb8517d22bba803$export$a4687b0234b40e28; });

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $gyN09 = parcelRequire("gyN09");

var $28pQY = parcelRequire("28pQY");
function $3eb8517d22bba803$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3eb8517d22bba803$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3eb8517d22bba803$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3eb8517d22bba803$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3eb8517d22bba803$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $gyN09.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $28pQY.useTrackedRef)(analyticsData);
    var fnRef = (0, $28pQY.useTrackedRef)(fn);
    var handler = (0, $9nHZC.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $3eb8517d22bba803$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("gyN09", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $c0e5d4f721f92502$export$5bf35293e545f20c; });

var $dNznA = parcelRequire("dNznA");

var $aN2pE = parcelRequire("aN2pE");

var $jFmXT = parcelRequire("jFmXT");
function $c0e5d4f721f92502$export$5bf35293e545f20c() {
    var analyticsContext = (0, $jFmXT.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $aN2pE.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("aN2pE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7db05a19f608513c$export$2e2bcd8739ae039; });

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $gNVO2 = parcelRequire("gNVO2");
function $7db05a19f608513c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7db05a19f608513c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $7db05a19f608513c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7db05a19f608513c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $7db05a19f608513c$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $7db05a19f608513c$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $7db05a19f608513c$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $7db05a19f608513c$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $gNVO2.default));

});
parcelRegister("gNVO2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3be100727dfbef4$export$2e2bcd8739ae039; });

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
function $c3be100727dfbef4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c3be100727dfbef4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c3be100727dfbef4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c3be100727dfbef4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c3be100727dfbef4$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $c3be100727dfbef4$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $c3be100727dfbef4$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $c3be100727dfbef4$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(updater) === "object") this.payload = $c3be100727dfbef4$var$_objectSpread($c3be100727dfbef4$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("jFmXT", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $e513a904170784a7$export$d1f587f82ad51c4; });

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $e513a904170784a7$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};

});


parcelRegister("28pQY", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $18e062113945504e$export$1d27a74659855e44; });

var $9nHZC = parcelRequire("9nHZC");
var $18e062113945504e$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("5vvNZ", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_APPEARANCE", function () { return $402884dfa3d68ac8$export$d6830277b06edd6; });
$parcel$export(module.exports, "VAR_COLOR", function () { return $402884dfa3d68ac8$export$4f8f13a66ae77bdd; });
$parcel$export(module.exports, "VAR_BG_COLOR", function () { return $402884dfa3d68ac8$export$e9244ec13bd422b5; });
$parcel$export(module.exports, "VAR_BG_COLOR_HOVER", function () { return $402884dfa3d68ac8$export$97e78d9745006c11; });
$parcel$export(module.exports, "VAR_BG_COLOR_ACTIVE", function () { return $402884dfa3d68ac8$export$291d63757828f290; });
var $402884dfa3d68ac8$export$d6830277b06edd6 = "normal";
var $402884dfa3d68ac8$export$4f8f13a66ae77bdd = "--color";
var $402884dfa3d68ac8$export$e9244ec13bd422b5 = "--bg-color";
var $402884dfa3d68ac8$export$97e78d9745006c11 = "--bg-color-hover";
var $402884dfa3d68ac8$export$291d63757828f290 = "--bg-color-active";

});

parcelRegister("lqpGd", function(module, exports) {

$parcel$export(module.exports, "flagBackgroundColor", function () { return $f98ff22865693dac$export$59e42969c95d314; });
$parcel$export(module.exports, "flagIconColor", function () { return $f98ff22865693dac$export$7f70afe2167f8235; });
$parcel$export(module.exports, "flagTextColor", function () { return $f98ff22865693dac$export$f50075b2584087f; });
$parcel$export(module.exports, "flagTextColorToken", function () { return $f98ff22865693dac$export$13b42cd9d596bfe0; });
$parcel$export(module.exports, "actionBackgroundColor", function () { return $f98ff22865693dac$export$81ba6b63eedb299f; });
$parcel$export(module.exports, "actionTextColor", function () { return $f98ff22865693dac$export$7bcfe3cca4dd78b6; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $dqBP1 = parcelRequire("dqBP1");
var $f98ff22865693dac$export$59e42969c95d314 = {
    error: "color.background.danger.bold",
    info: "color.background.neutral.bold",
    normal: "elevation.surface.overlay",
    success: "color.background.success.bold",
    warning: "color.background.warning.bold"
};
var $f98ff22865693dac$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, ".concat((0, $dqBP1.N0), ")"),
    info: "var(--ds-icon-inverse, ".concat((0, $dqBP1.N0), ")"),
    normal: "var(--ds-icon-subtle, ".concat((0, $dqBP1.N500), ")"),
    success: "var(--ds-icon-inverse, ".concat((0, $dqBP1.N0), ")"),
    warning: "var(--ds-icon-warning-inverse, ".concat((0, $dqBP1.N700), ")")
};
var $f98ff22865693dac$export$f50075b2584087f = {
    error: "color.text.inverse",
    info: "color.text.inverse",
    normal: "color.text",
    success: "color.text.inverse",
    warning: "color.text.warning.inverse"
};
var $f98ff22865693dac$export$13b42cd9d596bfe0 = {
    error: "var(--ds-text-inverse, ".concat((0, $dqBP1.N0), ")"),
    info: "var(--ds-text-inverse, ".concat((0, $dqBP1.N0), ")"),
    normal: "var(--ds-text, ".concat((0, $dqBP1.N800), ")"),
    success: "var(--ds-text-inverse, ".concat((0, $dqBP1.N0), ")"),
    warning: "var(--ds-text-warning-inverse, ".concat((0, $dqBP1.N700), ")")
};
var $f98ff22865693dac$export$81ba6b63eedb299f = {
    success: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $dqBP1.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $dqBP1.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $dqBP1.N30A), ")")
    },
    info: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $dqBP1.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $dqBP1.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $dqBP1.N30A), ")")
    },
    error: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $dqBP1.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $dqBP1.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $dqBP1.N30A), ")")
    },
    warning: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $dqBP1.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $dqBP1.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $dqBP1.N30A), ")")
    },
    normal: {
        default: "none",
        active: "none",
        pressed: "none"
    }
};
var $f98ff22865693dac$export$7bcfe3cca4dd78b6 = {
    success: "var(--ds-text-inverse, ".concat((0, $dqBP1.N0), ")"),
    info: "var(--ds-text-inverse, ".concat((0, $dqBP1.N0), ")"),
    error: "var(--ds-text-inverse, ".concat((0, $dqBP1.N0), ")"),
    warning: "var(--ds-text-warning-inverse, ".concat((0, $dqBP1.N700), ")"),
    normal: "var(--ds-link, ".concat((0, $dqBP1.B400), ")")
};

});

parcelRegister("kleGq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecf1289fef01fddf$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $eREML = parcelRequire("eREML");

var $gSq3s = parcelRequire("gSq3s");

var $5vvNZ = parcelRequire("5vvNZ");

var $lqpGd = parcelRequire("lqpGd");
var $ecf1289fef01fddf$var$buttonStyles = (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&&, a&&": {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        padding: "0 ".concat("var(--ds-space-100, 8px)", " !important"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: "var(".concat((0, $5vvNZ.VAR_BG_COLOR), ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: "var(".concat((0, $5vvNZ.VAR_COLOR), ") !important"),
        fontWeight: "var(--ds-font-weight-medium, 500)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&&:hover, &&:active, a&&:hover, a&&:active": {
        textDecoration: "underline"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&&:hover": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: "var(".concat((0, $5vvNZ.VAR_BG_COLOR_HOVER), ")")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&&:active": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: "var(".concat((0, $5vvNZ.VAR_BG_COLOR_ACTIVE), ")")
    }
});
var $ecf1289fef01fddf$var$appearanceNormalButtonStyles = (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&&, a&&": {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        padding: "0 !important"
    }
});
var $ecf1289fef01fddf$var$appearanceNormalActionsContainerStyles = (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&&, a&&": {
        transform: "translateX(-2px)"
    }
});
var $ecf1289fef01fddf$var$FlagActions = function FlagActions(props) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $5vvNZ.DEFAULT_APPEARANCE) : _props$appearance, _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, linkComponent = props.linkComponent, testId = props.testId;
    if (!actions.length) return null;
    var isBold = appearance !== (0, $5vvNZ.DEFAULT_APPEARANCE);
    return (0, $avKww.jsx)("span", {
        css: !isBold && $ecf1289fef01fddf$var$appearanceNormalActionsContainerStyles
    }, (0, $avKww.jsx)((0, $gSq3s.default), {
        space: "space.100",
        shouldWrap: true,
        alignBlock: "center",
        separator: isBold ? undefined : "\xb7",
        testId: testId && "".concat(testId, "-actions")
    }, actions.map(function(action, index) {
        var _ref;
        return (0, $avKww.jsx)((0, $eREML.default), {
            onClick: action.onClick,
            href: action.href,
            target: action.target,
            appearance: isBold ? "default" : "link",
            component: linkComponent,
            spacing: "compact",
            testId: action.testId,
            key: index,
            style: (_ref = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref, (0, $5vvNZ.VAR_COLOR), (0, $lqpGd.actionTextColor)[appearance]), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref, (0, $5vvNZ.VAR_BG_COLOR), (0, $lqpGd.actionBackgroundColor)[appearance].default), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref, (0, $5vvNZ.VAR_BG_COLOR_HOVER), (0, $lqpGd.actionBackgroundColor)[appearance].pressed), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref, (0, $5vvNZ.VAR_BG_COLOR_ACTIVE), (0, $lqpGd.actionBackgroundColor)[appearance].active), _ref),
            css: [
                $ecf1289fef01fddf$var$buttonStyles,
                appearance === (0, $5vvNZ.DEFAULT_APPEARANCE) && $ecf1289fef01fddf$var$appearanceNormalButtonStyles
            ]
        }, action.content);
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ecf1289fef01fddf$export$2e2bcd8739ae039 = $ecf1289fef01fddf$var$FlagActions;

});
parcelRegister("eREML", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad25a71ab554bfd2$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9q1kH = parcelRequire("9q1kH");

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $esZp2 = parcelRequire("esZp2");

var $4gLI3 = parcelRequire("4gLI3");

var $gvZSr = parcelRequire("gvZSr");

var $dLGLx = parcelRequire("dLGLx");

var $b2R7o = parcelRequire("b2R7o");
var $ad25a71ab554bfd2$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isSelected",
    "shouldFitContainer",
    "spacing",
    "isLoading",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseDown",
    "onMouseUp",
    "onFocus",
    "onBlur",
    "theme"
];
function $ad25a71ab554bfd2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ad25a71ab554bfd2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ad25a71ab554bfd2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ad25a71ab554bfd2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ad25a71ab554bfd2$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return "disabled";
    if (isSelected && isFocus) return "focusSelected";
    if (isSelected) return "selected";
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return "active";
    if (!isLoading && isHover) return "hover";
    if (isFocus) return "focus";
    return "default";
}
var $ad25a71ab554bfd2$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var $ad25a71ab554bfd2$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $b2R7o.defaultThemeFn) : _ref2$theme, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref2, $ad25a71ab554bfd2$var$_excluded);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $ad25a71ab554bfd2$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $9nHZC.useState)($ad25a71ab554bfd2$var$initial), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $ad25a71ab554bfd2$var$_objectSpread($ad25a71ab554bfd2$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $ad25a71ab554bfd2$var$_objectSpread($ad25a71ab554bfd2$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $ad25a71ab554bfd2$var$_objectSpread($ad25a71ab554bfd2$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $ad25a71ab554bfd2$var$_objectSpread($ad25a71ab554bfd2$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $ad25a71ab554bfd2$var$_objectSpread($ad25a71ab554bfd2$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $9nHZC.useCallback)(function(event) {
        setState(function(current) {
            return $ad25a71ab554bfd2$var$_objectSpread($ad25a71ab554bfd2$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $b2R7o.default).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $esZp2.default).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $b2R7o.default).Consumer, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            mode: mode,
            state: $ad25a71ab554bfd2$var$getInteractionState($ad25a71ab554bfd2$var$_objectSpread($ad25a71ab554bfd2$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $gvZSr.default)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $4gLI3.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dLGLx.default), restProps) : null,
                "aria-disabled": isLoading || restProps["aria-disabled"],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $b2R7o.getSpecifiers)(buttonStyles)
            }));
        });
    }));
}));
// Tools including enzyme rely on components having a display name
$ad25a71ab554bfd2$var$CustomThemeButton.displayName = "CustomThemeButton";
var $ad25a71ab554bfd2$export$2e2bcd8739ae039 = $ad25a71ab554bfd2$var$CustomThemeButton;

});
parcelRegister("esZp2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8834f86d9c5ff5f$export$2e2bcd8739ae039; });

var $hKoet = parcelRequire("hKoet");
// Create default global light theme
var $a8834f86d9c5ff5f$var$_createTheme = (0, $hKoet.createTheme)(function() {
    return {
        mode: "light"
    };
}), $a8834f86d9c5ff5f$var$Provider = $a8834f86d9c5ff5f$var$_createTheme.Provider, $a8834f86d9c5ff5f$var$Consumer = $a8834f86d9c5ff5f$var$_createTheme.Consumer, $a8834f86d9c5ff5f$export$7692396083754928 = $a8834f86d9c5ff5f$var$_createTheme.useTheme;
var $a8834f86d9c5ff5f$var$Theme = {
    Provider: $a8834f86d9c5ff5f$var$Provider,
    Consumer: $a8834f86d9c5ff5f$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a8834f86d9c5ff5f$export$2e2bcd8739ae039 = $a8834f86d9c5ff5f$var$Theme;

});
parcelRegister("hKoet", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $ceb9879b55f8d4ed$export$25d302a5b900a763; });

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");
var $ceb9879b55f8d4ed$var$_excluded = [
    "children"
];
function $ceb9879b55f8d4ed$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $9nHZC.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $9nHZC.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(props, $ceb9879b55f8d4ed$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $9nHZC.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $9nHZC.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("4gLI3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31bdaa289c90027b$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $5nR8v = parcelRequire("5nR8v");

var $8p2GL = parcelRequire("8p2GL");

var $grYZC = parcelRequire("grYZC");

var $dxhCu = parcelRequire("dxhCu");

var $5fUc4 = parcelRequire("5fUc4");

var $dqBP1 = parcelRequire("dqBP1");

var $ifQpQ = parcelRequire("ifQpQ");

var $gMfYL = parcelRequire("gMfYL");

var $a4TeR = parcelRequire("a4TeR");
var $31bdaa289c90027b$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $31bdaa289c90027b$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform.design-system-team.enable-new-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $31bdaa289c90027b$var$iconBeforeSpacingFixStyle = (0, $avKww.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $31bdaa289c90027b$var$iconAfterSpacingFixStyle = (0, $avKww.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $31bdaa289c90027b$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $a4TeR.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $31bdaa289c90027b$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $a4TeR.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $avKww.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $31bdaa289c90027b$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $8p2GL.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $8p2GL.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(props, $31bdaa289c90027b$var$_excluded);
    var ourRef = (0, $9nHZC.useRef)();
    var setRef = (0, $9nHZC.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $grYZC.default)(ourRef, autoFocus);
    var interactionContext = (0, $9nHZC.useContext)((0, $5fUc4.default));
    var handleClick = (0, $9nHZC.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $5nR8v.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "19.2.1",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $9nHZC.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $9nHZC.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $avKww.css)((0, $gMfYL.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === "warning") spinnerHackCss = {
        "[data-theme] & circle": {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $dqBP1.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $dqBP1.N500), ")"), " !important")
        }
    };
    return (0, $avKww.jsx)((0, $dxhCu.default), null, (0, $avKww.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $31bdaa289c90027b$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $ifQpQ.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $avKww.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $gMfYL.getIconStyle)({
                spacing: spacing
            }),
            $31bdaa289c90027b$var$getSpacingFix(children, $31bdaa289c90027b$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $31bdaa289c90027b$var$getChildren(children, [
        fadeStyles,
        (0, $gMfYL.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $avKww.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $gMfYL.getIconStyle)({
                spacing: spacing
            }),
            $31bdaa289c90027b$var$getSpacingFix(children, $31bdaa289c90027b$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $avKww.jsx)("span", {
        css: [
            (0, $gMfYL.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$31bdaa289c90027b$export$2e2bcd8739ae039 = $31bdaa289c90027b$var$ButtonBase;

});
parcelRegister("ifQpQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4a249663ba7e446$export$2e2bcd8739ae039; });
function $d4a249663ba7e446$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $d4a249663ba7e446$var$tabKeyCode = 9;
function $d4a249663ba7e446$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $d4a249663ba7e446$var$tabKeyCode) return;
    $d4a249663ba7e446$var$abort(event);
}
var $d4a249663ba7e446$var$block = {
    onMouseDownCapture: $d4a249663ba7e446$var$abort,
    onMouseUpCapture: $d4a249663ba7e446$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $d4a249663ba7e446$var$onKey,
    onKeyUpCapture: $d4a249663ba7e446$var$onKey,
    onTouchStartCapture: $d4a249663ba7e446$var$abort,
    onTouchEndCapture: $d4a249663ba7e446$var$abort,
    onPointerDownCapture: $d4a249663ba7e446$var$abort,
    onPointerUpCapture: $d4a249663ba7e446$var$abort,
    onClickCapture: $d4a249663ba7e446$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $d4a249663ba7e446$var$abort
};
var $d4a249663ba7e446$var$doNotBlock = {};
function $d4a249663ba7e446$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $d4a249663ba7e446$var$doNotBlock : $d4a249663ba7e446$var$block;
}

});

parcelRegister("gMfYL", function(module, exports) {

$parcel$export(module.exports, "getCss", function () { return $c36d86225150e781$export$955358618f994a11; });
$parcel$export(module.exports, "getIconStyle", function () { return $c36d86225150e781$export$864eea3f4ec3368f; });
$parcel$export(module.exports, "getContentStyle", function () { return $c36d86225150e781$export$7ad0316cc0dd65a; });
$parcel$export(module.exports, "getFadingCss", function () { return $c36d86225150e781$export$1b5827d324e945b1; });
$parcel$export(module.exports, "overlayCss", function () { return $c36d86225150e781$export$1a9fe1b84c876bb5; });

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $l93Pg = parcelRequire("l93Pg");

var $a9KrV = parcelRequire("a9KrV");

var $mYvLm = parcelRequire("mYvLm");
function $c36d86225150e781$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c36d86225150e781$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c36d86225150e781$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c36d86225150e781$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c36d86225150e781$var$gridSize = (0, $a9KrV.gridSize)();
var $c36d86225150e781$var$HAS_DISABLED_BACKGROUND = [
    "default",
    "primary",
    "danger",
    "warning"
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $c36d86225150e781$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: "auto"
};
var $c36d86225150e781$var$lineHeights = {
    default: $c36d86225150e781$var$heights.default,
    compact: $c36d86225150e781$var$heights.compact,
    none: "inherit"
};
var $c36d86225150e781$var$padding = {
    // 10px gutter
    default: "0 ".concat($c36d86225150e781$var$gridSize + $c36d86225150e781$var$gridSize / 4, "px"),
    compact: "0 ".concat($c36d86225150e781$var$gridSize + $c36d86225150e781$var$gridSize / 4, "px"),
    none: "0"
};
var $c36d86225150e781$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($c36d86225150e781$var$gridSize / 4, "px"),
    default: "0 ".concat($c36d86225150e781$var$gridSize / 4, "px"),
    none: "0"
};
var $c36d86225150e781$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $c36d86225150e781$var$innerMargin = {
    content: "0 ".concat($c36d86225150e781$var$gridSize / 4, "px"),
    icon: "0 ".concat($c36d86225150e781$var$gridSize / 4, "px")
};
var $c36d86225150e781$var$defaultAfterStyles = {
    borderRadius: "inherit",
    inset: "var(--ds-space-0, 0px)",
    borderStyle: "solid",
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: "none",
    position: "absolute"
};
var $c36d86225150e781$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #172B4D)",
    "&:not([disabled])::after": $c36d86225150e781$var$_objectSpread($c36d86225150e781$var$_objectSpread({}, $c36d86225150e781$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #091E4224)"
    }),
    "&:hover": {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    }
};
var $c36d86225150e781$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #0C66E4)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
    },
    "&:active": {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
    }
};
var $c36d86225150e781$var$linkStyles = {
    background: "transparent",
    color: "var(--ds-link, #0C66E4)",
    "&:hover": {
        color: "var(--ds-link, #0C66E4)",
        textDecoration: "underline"
    },
    "&:active": {
        color: "var(--ds-link-pressed, #0055CC)",
        textDecoration: "underline"
    }
};
var $c36d86225150e781$var$subtleStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    }
};
var $c36d86225150e781$var$subtleLinkStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "transparent",
        color: "var(--ds-text-subtle, #44546F)",
        textDecoration: "underline"
    },
    "&:active": {
        background: "transparent",
        color: "var(--ds-text, #172B4D)",
        textDecoration: "underline"
    }
};
var $c36d86225150e781$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #F5CD47)",
    color: "var(--ds-text-warning-inverse, #172B4D)",
    "&:hover": {
        background: "var(--ds-background-warning-bold-hovered, #E2B203)"
    },
    "&:active": {
        background: "var(--ds-background-warning-bold-pressed, #CF9F02)"
    }
};
var $c36d86225150e781$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    "&:active": {
        background: "var(--ds-background-danger-bold-pressed, #5D1F1A)"
    }
};
var $c36d86225150e781$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "var(--ds-text-selected, #0C66E4)",
    "&:not([disabled])::after": $c36d86225150e781$var$_objectSpread($c36d86225150e781$var$_objectSpread({}, $c36d86225150e781$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #0C66E4)"
    })
};
var $c36d86225150e781$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: "default",
        textDecoration: "none"
    }
};
function $c36d86225150e781$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $c36d86225150e781$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $c36d86225150e781$var$getColor({
            group: (0, $mYvLm.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($c36d86225150e781$var$getColor({
            group: (0, $mYvLm.default).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $c36d86225150e781$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $c36d86225150e781$var$getColors({
        appearance: appearance,
        key: isSelected ? "selected" : "default",
        mode: mode
    });
    return $c36d86225150e781$var$_objectSpread($c36d86225150e781$var$_objectSpread($c36d86225150e781$var$_objectSpread($c36d86225150e781$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: 500,
        // margin for button has been applied to css reset
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap"
    }, !(0, $l93Pg.fg)("platform-component-visual-refresh") && baseColors), {}, {
        cursor: "pointer",
        height: $c36d86225150e781$var$heights[spacing],
        lineHeight: $c36d86225150e781$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $c36d86225150e781$var$singleIconPadding[spacing] : $c36d86225150e781$var$padding[spacing],
        verticalAlign: $c36d86225150e781$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center"
    }, !(0, $l93Pg.fg)("platform-component-visual-refresh") && $c36d86225150e781$var$_objectSpread($c36d86225150e781$var$_objectSpread({
        // Disabling visited styles (just using the base colors)
        "&:visited": $c36d86225150e781$var$_objectSpread({}, baseColors),
        "&:hover": $c36d86225150e781$var$_objectSpread($c36d86225150e781$var$_objectSpread({}, $c36d86225150e781$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "hover",
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "inherit",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        // giving active styles preference by listing them after focus
        "&:active": $c36d86225150e781$var$_objectSpread($c36d86225150e781$var$_objectSpread({}, $c36d86225150e781$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $c36d86225150e781$var$_objectSpread($c36d86225150e781$var$_objectSpread({}, $c36d86225150e781$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        "&[disabled]": $c36d86225150e781$var$_objectSpread($c36d86225150e781$var$_objectSpread({}, $c36d86225150e781$var$getColors({
            appearance: appearance,
            key: "disabled",
            mode: mode
        })), {}, {
            cursor: "not-allowed",
            textDecoration: "none"
        })
    }, $c36d86225150e781$var$hasOverlayStyles), {}, {
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $c36d86225150e781$var$_objectSpread({}, $c36d86225150e781$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "default",
            mode: mode
        }))
    })), (0, $l93Pg.fg)("platform-component-visual-refresh") && (isSelected ? $c36d86225150e781$var$selectedStyles : $c36d86225150e781$var$_objectSpread($c36d86225150e781$var$_objectSpread($c36d86225150e781$var$_objectSpread($c36d86225150e781$var$_objectSpread($c36d86225150e781$var$_objectSpread($c36d86225150e781$var$_objectSpread($c36d86225150e781$var$_objectSpread($c36d86225150e781$var$_objectSpread($c36d86225150e781$var$_objectSpread({}, appearance === "default" && $c36d86225150e781$var$defaultStyles), appearance === "primary" && $c36d86225150e781$var$primaryStyles), appearance === "link" && $c36d86225150e781$var$linkStyles), appearance === "subtle" && $c36d86225150e781$var$subtleStyles), appearance === "subtle-link" && $c36d86225150e781$var$subtleLinkStyles), appearance === "warning" && $c36d86225150e781$var$warningStyles), appearance === "danger" && $c36d86225150e781$var$dangerStyles), {}, {
        "&[disabled]": {
            color: "var(--ds-text-disabled, #091E424F)",
            backgroundColor: $c36d86225150e781$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent",
            cursor: "not-allowed",
            textDecoration: "none",
            "&:hovered": {
                backgroundColor: $c36d86225150e781$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            },
            "&:active": {
                backgroundColor: $c36d86225150e781$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            }
        }
    }, $c36d86225150e781$var$hasOverlayStyles), {}, {
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': {
            background: "inherit"
        }
    }))), {}, {
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $c36d86225150e781$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $avKww.css)({
        display: "flex",
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $c36d86225150e781$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: "center",
        fontSize: 0,
        lineHeight: 0,
        userSelect: "none"
    });
}
function $c36d86225150e781$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $avKww.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $c36d86225150e781$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    });
}
function $c36d86225150e781$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $avKww.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: "opacity 0.3s"
    });
}
var $c36d86225150e781$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

});
parcelRegister("l93Pg", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $f64d67fa1861d8ff$export$b40ec24ac8275656; });

var $dRMPk = parcelRequire("dRMPk");
function $f64d67fa1861d8ff$export$ba05d765b8392e5e(flagResolver) {
    (0, $dRMPk.setBooleanResolver)(flagResolver);
}
function $f64d67fa1861d8ff$export$470e5c2be1411c89(name) {
    return (0, $dRMPk.resolveBooleanFlag)(name);
}
function $f64d67fa1861d8ff$export$b40ec24ac8275656(name) {
    return (0, $dRMPk.resolveBooleanFlag)(name);
}

});
parcelRegister("dRMPk", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $a186199aceb33e16$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $a186199aceb33e16$export$6333b6aff9fc6275; });

var $2ZKOc = parcelRequire("2ZKOc");

var $8ovux = parcelRequire("8ovux");
var $a186199aceb33e16$var$pkgName = "@atlaskit/platform-feature-flags";
var $a186199aceb33e16$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $a186199aceb33e16$var$hasProcessEnv = typeof $8ovux !== "undefined" && typeof $8ovux.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $a186199aceb33e16$var$ENV_ENABLE_PLATFORM_FF = $a186199aceb33e16$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $a186199aceb33e16$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $a186199aceb33e16$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $a186199aceb33e16$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $a186199aceb33e16$var$ENV_ENABLE_PLATFORM_FF || $a186199aceb33e16$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $a186199aceb33e16$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $a186199aceb33e16$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$a186199aceb33e16$var$globalVar[$a186199aceb33e16$export$7e41b1b2bdee3f98] = $a186199aceb33e16$var$globalVar[$a186199aceb33e16$export$7e41b1b2bdee3f98] || $a186199aceb33e16$var$DEFAULT_PFF_GLOBAL;
function $a186199aceb33e16$export$f2b591175b3e424c(resolver) {
    $a186199aceb33e16$var$globalVar[$a186199aceb33e16$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $a186199aceb33e16$export$6333b6aff9fc6275(flagKey) {
    if ($a186199aceb33e16$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $2ZKOc.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $a186199aceb33e16$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $a186199aceb33e16$var$globalVar[$a186199aceb33e16$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("2ZKOc", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $22e59684092f41e7$export$1c9f709888824e05; });
var $22e59684092f41e7$var$_ref, $22e59684092f41e7$var$_process, $22e59684092f41e7$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $22e59684092f41e7$var$TESTS_MODE = ($22e59684092f41e7$var$_ref = (globalThis === null || globalThis === void 0 || ($22e59684092f41e7$var$_process = globalThis.process) === null || $22e59684092f41e7$var$_process === void 0 || ($22e59684092f41e7$var$_process = $22e59684092f41e7$var$_process.env) === null || $22e59684092f41e7$var$_process === void 0 ? void 0 : $22e59684092f41e7$var$_process.JEST_WORKER_ID) !== undefined, $22e59684092f41e7$var$_ref !== void 0) ? $22e59684092f41e7$var$_ref : false;
var $22e59684092f41e7$var$DEBUG_MODE = !$22e59684092f41e7$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($22e59684092f41e7$var$_process2 = globalThis.process) === null || $22e59684092f41e7$var$_process2 === void 0 || ($22e59684092f41e7$var$_process2 = $22e59684092f41e7$var$_process2.env) === null || $22e59684092f41e7$var$_process2 === void 0 ? void 0 : $22e59684092f41e7$var$_process2.NODE_ENV) !== "production";
var $22e59684092f41e7$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$22e59684092f41e7$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("mYvLm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0450fe790f8a2819$export$2e2bcd8739ae039; });

var $dqBP1 = parcelRequire("dqBP1");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $0450fe790f8a2819$var$fadedB75 = "rgba(179, 212, 255, 0.6)";
var $0450fe790f8a2819$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($dqBP1.N20A, ")"),
                dark: "var(--ds-background-neutral, ".concat($dqBP1.DN70, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($dqBP1.N30A, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($dqBP1.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($0450fe790f8a2819$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($dqBP1.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($dqBP1.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($dqBP1.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($dqBP1.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dqBP1.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($dqBP1.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dqBP1.DN0, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($dqBP1.B400, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($dqBP1.B100, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($dqBP1.B300, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($dqBP1.B75, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($dqBP1.B500, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($dqBP1.B200, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($dqBP1.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($dqBP1.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($dqBP1.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dqBP1.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($dqBP1.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dqBP1.DN0, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($dqBP1.Y300, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($dqBP1.Y300, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($dqBP1.Y200, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($dqBP1.Y200, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($dqBP1.Y400, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($dqBP1.Y400, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($dqBP1.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($dqBP1.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($dqBP1.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($dqBP1.Y400, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($dqBP1.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($dqBP1.Y400, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($dqBP1.R400, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($dqBP1.R400, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($dqBP1.R300, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($dqBP1.R300, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($dqBP1.R500, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($dqBP1.R500, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($dqBP1.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($dqBP1.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($dqBP1.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($dqBP1.R500, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($dqBP1.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($dqBP1.R500, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($dqBP1.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dqBP1.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($dqBP1.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dqBP1.N20, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($dqBP1.N30A, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($dqBP1.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($0450fe790f8a2819$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($dqBP1.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($dqBP1.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dqBP1.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($dqBP1.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dqBP1.DN0, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($dqBP1.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dqBP1.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($dqBP1.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($dqBP1.N20, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($dqBP1.N500, ")"),
                dark: "var(--ds-text, ".concat($dqBP1.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($dqBP1.B400, ")"),
                dark: "var(--ds-text, ".concat($dqBP1.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($dqBP1.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($dqBP1.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($dqBP1.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dqBP1.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($dqBP1.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dqBP1.DN400, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($dqBP1.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($dqBP1.DN30, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($dqBP1.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($dqBP1.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($dqBP1.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dqBP1.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($dqBP1.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dqBP1.DN400, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($dqBP1.N800, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($dqBP1.N800, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($dqBP1.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($dqBP1.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($dqBP1.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($dqBP1.N800, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($dqBP1.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($dqBP1.N800, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($dqBP1.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($dqBP1.N0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($dqBP1.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($dqBP1.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($dqBP1.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($dqBP1.N0, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($dqBP1.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($dqBP1.N0, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($dqBP1.B400, ")"),
                dark: "var(--ds-link, ".concat($dqBP1.B100, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($dqBP1.B300, ")"),
                dark: "var(--ds-link, ".concat($dqBP1.B75, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($dqBP1.B500, ")"),
                dark: "var(--ds-link-pressed, ".concat($dqBP1.B200, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($dqBP1.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($dqBP1.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($dqBP1.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dqBP1.N700, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($dqBP1.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dqBP1.N700, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($dqBP1.N500, ")"),
                dark: "var(--ds-text, ".concat($dqBP1.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($dqBP1.B400, ")"),
                dark: "var(--ds-text, ".concat($dqBP1.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($dqBP1.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($dqBP1.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($dqBP1.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dqBP1.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($dqBP1.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dqBP1.DN400, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-text-subtle, ".concat($dqBP1.N200, ")"),
                dark: "var(--ds-text-subtle, ".concat($dqBP1.DN400, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($dqBP1.N90, ")"),
                dark: "var(--ds-text-subtle, ".concat($dqBP1.B50, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($dqBP1.N400, ")"),
                dark: "var(--ds-text, ".concat($dqBP1.DN300, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($dqBP1.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($dqBP1.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($dqBP1.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dqBP1.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($dqBP1.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($dqBP1.DN400, ")")
            }
        }
    }
};
var $0450fe790f8a2819$export$2e2bcd8739ae039 = $0450fe790f8a2819$var$values;

});


parcelRegister("a4TeR", function(module, exports) {

$parcel$export(module.exports, "getIfVisuallyHiddenChildren", function () { return $7565205d0767a025$export$20bbd2efb0d734c4; });

var $9nHZC = parcelRequire("9nHZC");

var $7S7GL = parcelRequire("7S7GL");
var $7565205d0767a025$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $9nHZC.isValidElement)(children) && children.type === (0, $7S7GL.default);
};

});


parcelRegister("gvZSr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c05f8a195a153169$export$2e2bcd8739ae039; });

var $a4TeR = parcelRequire("a4TeR");
function $c05f8a195a153169$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $a4TeR.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});

parcelRegister("dLGLx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a060d682f543ce88$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $jgImq = parcelRequire("jgImq");
function $a060d682f543ce88$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return "inherit";
    if (isSelected) return "invert";
    if (appearance === "primary" || appearance === "danger") return "invert";
    return "inherit";
}
function $a060d682f543ce88$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing;
    var size = spacing === "default" ? "medium" : "small";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $jgImq.default), {
        size: size,
        label: ", Loading",
        appearance: $a060d682f543ce88$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});
parcelRegister("jgImq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e071ec0da30672ae$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $5fUc4 = parcelRequire("5fUc4");

var $dqBP1 = parcelRequire("dqBP1");

var $jmESx = parcelRequire("jmESx");
/**
 * Returns the appropriate circle stroke color.
 */ function $e071ec0da30672ae$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $dqBP1.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $dqBP1.N0), ")");
}
var $e071ec0da30672ae$var$rotate = (0, $avKww.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $e071ec0da30672ae$var$rotateStyles = (0, $avKww.css)({
    animation: "".concat($e071ec0da30672ae$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $e071ec0da30672ae$var$loadIn = (0, $avKww.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $e071ec0da30672ae$var$loadInStyles = (0, $avKww.css)({
    animation: "".concat($e071ec0da30672ae$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $e071ec0da30672ae$var$wrapperStyles = (0, $avKww.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $e071ec0da30672ae$var$circleStyles = (0, $avKww.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $e071ec0da30672ae$var$useLayoutEffect = typeof window === "undefined" ? (0, $9nHZC.useEffect) : (0, $9nHZC.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $e071ec0da30672ae$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $jmESx.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $e071ec0da30672ae$var$getStrokeColor(appearance);
    var context = (0, $9nHZC.useContext)((0, $5fUc4.default));
    $e071ec0da30672ae$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $avKww.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $e071ec0da30672ae$var$wrapperStyles,
            $e071ec0da30672ae$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $avKww.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $e071ec0da30672ae$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none"
    }, (0, $avKww.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $e071ec0da30672ae$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $e071ec0da30672ae$export$2e2bcd8739ae039 = $e071ec0da30672ae$var$Spinner;

});
parcelRegister("jmESx", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $e18fc80b9d22d57f$export$4e9f1640bbe7a1a8; });
var $e18fc80b9d22d57f$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});



parcelRegister("b2R7o", function(module, exports) {

$parcel$export(module.exports, "getSpecifiers", function () { return $80a915d0749d95d9$export$643db0b8d8778e; });
$parcel$export(module.exports, "defaultThemeFn", function () { return $80a915d0749d95d9$export$437a7f77d13d7916; });
$parcel$export(module.exports, "default", function () { return $80a915d0749d95d9$export$2e2bcd8739ae039; });

var $kFnE9 = parcelRequire("kFnE9");

var $hKoet = parcelRequire("hKoet");

var $gMfYL = parcelRequire("gMfYL");
function $80a915d0749d95d9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $80a915d0749d95d9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $80a915d0749d95d9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $80a915d0749d95d9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $80a915d0749d95d9$var$stateToSelectorMap = {
    focus: "&:focus",
    focusSelected: "&:focus",
    hover: "&:hover",
    active: "&:active",
    disabled: "&[disabled]"
};
function $80a915d0749d95d9$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? "light" : _ref$mode, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $gMfYL.getCss)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = "none";
    // Pulling relevant styles up to the top level
    var selector = $80a915d0749d95d9$var$stateToSelectorMap[state];
    if (selector) result = $80a915d0749d95d9$var$_objectSpread($80a915d0749d95d9$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $80a915d0749d95d9$var$_objectSpread($80a915d0749d95d9$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === "&::-moz-focus-inner") return;
        // Not using .startsWith for ie11
        if (key.indexOf("&") === 0) delete result[key];
    });
    return result;
}
function $80a915d0749d95d9$export$643db0b8d8778e(styles) {
    return {
        "&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]": styles
    };
}
function $80a915d0749d95d9$export$437a7f77d13d7916(current, values) {
    return current(values);
}
var $80a915d0749d95d9$var$Theme = (0, $hKoet.createTheme)(function(themeProps) {
    return {
        buttonStyles: $80a915d0749d95d9$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$80a915d0749d95d9$export$2e2bcd8739ae039 = $80a915d0749d95d9$var$Theme;

});



parcelRegister("7DQWv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59053e38f3db674b$export$2e2bcd8739ae039; });

var $9nHZC = parcelRequire("9nHZC");

var $8XCaF = parcelRequire("8XCaF");

var $4qFd7 = parcelRequire("4qFd7");

var $6vB7D = parcelRequire("6vB7D");

var $lQyz2 = parcelRequire("lQyz2");
var $85L9m = parcelRequire("85L9m");

var $lqpGd = parcelRequire("lqpGd");
var $59053e38f3db674b$var$buttonStyles = (0, $85L9m.xcss)({
    display: "flex",
    width: "24px",
    height: "24px",
    padding: "space.0",
    alignItems: "center",
    justifyContent: "center",
    flex: "0 0 auto",
    background: "none",
    borderStyle: "none",
    cursor: "pointer",
    whiteSpace: "nowrap"
});
var $59053e38f3db674b$var$DismissButtonComponent = function DismissButtonComponent(_ref) {
    var appearance = _ref.appearance, onClick = _ref.onClick, isBold = _ref.isBold, isExpanded = _ref.isExpanded, testId = _ref.testId;
    var ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($6vB7D)));
    var buttonLabel = "Dismiss";
    var size = "small";
    var buttonTestId = testId && "".concat(testId, "-dismiss");
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($4qFd7))) : (0, (/*@__PURE__*/$parcel$interopDefault($8XCaF)));
        buttonLabel = isExpanded ? "Collapse" : "Expand";
        size = "medium";
        buttonTestId = testId && "".concat(testId, "-toggle");
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $lQyz2.default), {
        xcss: $59053e38f3db674b$var$buttonStyles,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(ButtonIcon, {
        label: buttonLabel,
        size: size,
        primaryColor: (0, $lqpGd.flagTextColorToken)[appearance]
    }));
};
var $59053e38f3db674b$var$DismissButton = /*#__PURE__*/ (0, $9nHZC.memo)($59053e38f3db674b$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$59053e38f3db674b$export$2e2bcd8739ae039 = $59053e38f3db674b$var$DismissButton;

});
parcelRegister("8XCaF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $686171697e94ab25$var$_react = $686171697e94ab25$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $686171697e94ab25$var$_chevronDown = $686171697e94ab25$var$_interopRequireDefault((parcelRequire("408Sl")));
function $686171697e94ab25$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $686171697e94ab25$var$HipchatChevronDownIcon = (props)=>/*#__PURE__*/ $686171697e94ab25$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.744 8.744a1.053 1.053 0 0 0 0 1.49l4.547 4.557a1 1 0 0 0 1.416 0l4.55-4.558a1.051 1.051 0 1 0-1.488-1.488l-3.77 3.776-3.768-3.776a1.05 1.05 0 0 0-1.487 0"/></svg>`
    }, props, {
        newIcon: $686171697e94ab25$var$_chevronDown.default,
        iconType: "utility"
    }));
$686171697e94ab25$var$HipchatChevronDownIcon.displayName = "HipchatChevronDownIcon";
var $686171697e94ab25$var$_default = module.exports.default = $686171697e94ab25$var$HipchatChevronDownIcon;

});

parcelRegister("4qFd7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33998eb37b5fcf83$var$_react = $33998eb37b5fcf83$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $33998eb37b5fcf83$var$_chevronUp = $33998eb37b5fcf83$var$_interopRequireDefault((parcelRequire("60QPH")));
function $33998eb37b5fcf83$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $33998eb37b5fcf83$var$HipchatChevronUpIcon = (props)=>/*#__PURE__*/ $33998eb37b5fcf83$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.294 8.708-4.549 4.559a1.051 1.051 0 1 0 1.486 1.488l.001-.001 3.77-3.776 3.768 3.776a1.05 1.05 0 0 0 1.486.001h.001a1.054 1.054 0 0 0 .001-1.489L12.71 8.708a1 1 0 0 0-1.415-.001"/></svg>`
    }, props, {
        newIcon: $33998eb37b5fcf83$var$_chevronUp.default,
        iconType: "utility"
    }));
$33998eb37b5fcf83$var$HipchatChevronUpIcon.displayName = "HipchatChevronUpIcon";
var $33998eb37b5fcf83$var$_default = module.exports.default = $33998eb37b5fcf83$var$HipchatChevronUpIcon;

});
parcelRegister("60QPH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab8a8aa2ebc044e57b9de62448e21102>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $460bb9ad78900f4c$var$_react = $460bb9ad78900f4c$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $460bb9ad78900f4c$var$_UNSAFE_baseNew = $460bb9ad78900f4c$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $460bb9ad78900f4c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronUp".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for accordions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $460bb9ad78900f4c$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $460bb9ad78900f4c$var$_react.default.createElement($460bb9ad78900f4c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 7.5 6 3 1.5 7.5"/>`,
        type: "utility"
    }, props));
$460bb9ad78900f4c$var$ChevronUpIcon.displayName = "ChevronUpIcon";
var $460bb9ad78900f4c$var$_default = module.exports.default = $460bb9ad78900f4c$var$ChevronUpIcon;

});


parcelRegister("lQyz2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe7943fe8a989bc3$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $5nR8v = parcelRequire("5nR8v");

var $8p2GL = parcelRequire("8p2GL");

var $5fUc4 = parcelRequire("5fUc4");

var $2O9b8 = parcelRequire("2O9b8");

var $85L9m = parcelRequire("85L9m");
var $fe7943fe8a989bc3$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $fe7943fe8a989bc3$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $fe7943fe8a989bc3$var$focusRingStyles = (0, $avKww.css)({
    "&:focus, &:focus-visible": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $2O9b8.borderColorMap)["color.border.focused"],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $2O9b8.positiveSpaceMap)["space.025"],
        outlineStyle: "solid",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $2O9b8.borderWidthMap)["border.width.outline"]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $fe7943fe8a989bc3$var$baseStyles = (0, $avKww.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});
var $fe7943fe8a989bc3$var$enabledStyles = (0, $avKww.css)({
    cursor: "pointer"
});
var $fe7943fe8a989bc3$var$disabledStyles = (0, $avKww.css)({
    cursor: "not-allowed"
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $fe7943fe8a989bc3$var$Pressable = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $8p2GL.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $fe7943fe8a989bc3$var$_excluded);
    var interactionContext = (0, $9nHZC.useContext)((0, $5fUc4.default));
    var handleClick = (0, $9nHZC.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $5nR8v.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "12.0.1",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(htmlAttributes, $fe7943fe8a989bc3$var$_excluded2);
    var resolvedStyles = (0, $85L9m.parseXcss)(xcss);
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
    (0, $avKww.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $fe7943fe8a989bc3$var$baseStyles,
            $fe7943fe8a989bc3$var$focusRingStyles,
            isDisabled ? $fe7943fe8a989bc3$var$disabledStyles : $fe7943fe8a989bc3$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $2O9b8.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $2O9b8.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $2O9b8.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $2O9b8.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $2O9b8.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $2O9b8.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $2O9b8.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $2O9b8.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children));
});
var $fe7943fe8a989bc3$export$2e2bcd8739ae039 = $fe7943fe8a989bc3$var$Pressable;

});


parcelRegister("9Qu5e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72b04e506973f4d4$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $iXx2A = parcelRequire("iXx2A");
var $goo1d = parcelRequire("goo1d");
var $85L9m = parcelRequire("85L9m");

var $JcvLo = parcelRequire("JcvLo");
var $gWA00 = parcelRequire("gWA00");
var $72b04e506973f4d4$var$expanderStyles = (0, $85L9m.xcss)({
    width: "100%"
});
var $72b04e506973f4d4$var$containerStyles = (0, $85L9m.xcss)({
    transition: "max-height 0.3s"
});
var $72b04e506973f4d4$var$Expander = function Expander(_ref) {
    var children = _ref.children, isExpanded = _ref.isExpanded, testId = _ref.testId;
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $iXx2A.default), {
        xcss: $72b04e506973f4d4$var$containerStyles,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: "1 1 100%",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && "".concat(testId, "-expander")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $JcvLo.default), {
        appear: true
    }, isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $gWA00.default), null, function(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $iXx2A.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            xcss: $72b04e506973f4d4$var$expanderStyles
        }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $goo1d.default), {
            space: "space.100"
        }, children));
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$72b04e506973f4d4$export$2e2bcd8739ae039 = $72b04e506973f4d4$var$Expander;

});


parcelRegister("29P43", function(module, exports) {

$parcel$export(module.exports, "buttonActionTypes", function () { return $1924085a4e9df5cf$export$e7d79186651244da; });
var $1924085a4e9df5cf$export$e7d79186651244da = {
    LINK: "link",
    DISMISS: "dismiss"
};

});

parcelRegister("itT3v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d745a451ac20f740$export$2e2bcd8739ae039; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $9nHZC = parcelRequire("9nHZC");
function $d745a451ac20f740$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d745a451ac20f740$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $d745a451ac20f740$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d745a451ac20f740$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
// eslint-disable-next-line @repo/internal/react/no-class-components
var $d745a451ac20f740$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_PureComponent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(HtmlContent, _PureComponent);
    var _super = $d745a451ac20f740$var$_createSuper(HtmlContent);
    function HtmlContent() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, HtmlContent);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(HtmlContent, [
        {
            key: "render",
            value: function render() {
                var html = this.props.html;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", {
                    dangerouslySetInnerHTML: {
                        __html: html
                    }
                });
            }
        }
    ]);
    return HtmlContent;
}((0, $9nHZC.PureComponent));

});

parcelRegister("iQHUe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db8f241c8c6bcf02$var$_react = $db8f241c8c6bcf02$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $db8f241c8c6bcf02$var$_comment = $db8f241c8c6bcf02$var$_interopRequireDefault((parcelRequire("bJJvZ")));
function $db8f241c8c6bcf02$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $db8f241c8c6bcf02$var$CommentIcon = (props)=>/*#__PURE__*/ $db8f241c8c6bcf02$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51s7.002 2.472 7.002 5.51c0 3.039-3.141 5.51-7.002 5.51s-7.002-2.471-7.002-5.51m14.84 7.771v-.001s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.5.5 0 0 0 .164.033.515.515 0 0 0 .474-.716"/><rect width="10" height="2" x="7" y="9" rx="1"/><rect width="5" height="2" x="7" y="12" rx="1"/></g></svg>`
    }, props, {
        newIcon: $db8f241c8c6bcf02$var$_comment.default
    }));
$db8f241c8c6bcf02$var$CommentIcon.displayName = "CommentIcon";
var $db8f241c8c6bcf02$var$_default = module.exports.default = $db8f241c8c6bcf02$var$CommentIcon;

});
parcelRegister("bJJvZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16e54766c3ecb23743fd478f54b2afa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88b734067edb11be$var$_react = $88b734067edb11be$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $88b734067edb11be$var$_UNSAFE_baseNew = $88b734067edb11be$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $88b734067edb11be$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $88b734067edb11be$var$CommentIcon = (props)=>/*#__PURE__*/ $88b734067edb11be$var$_react.default.createElement($88b734067edb11be$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M4.25 13.25v-.75h-.2l-.172.099zm-3.5 2H0a.75.75 0 0 0 1.122.651zM2.625 2h10.75V.5H2.625zM14.5 3.125v8.25H16v-8.25zM13.375 12.5H4.25V14h9.125zm-9.497.099-3.5 2 .744 1.302 3.5-2zM1.5 15.25V3.125H0V15.25zM4 6.5h8V5H4zm0 3h5V8H4zm10.5 1.875c0 .621-.504 1.125-1.125 1.125V14A2.625 2.625 0 0 0 16 11.375zM13.375 2c.621 0 1.125.504 1.125 1.125H16A2.625 2.625 0 0 0 13.375.5zM2.625.5A2.625 2.625 0 0 0 0 3.125h1.5C1.5 2.504 2.004 2 2.625 2z"/>`
    }, props));
$88b734067edb11be$var$CommentIcon.displayName = "CommentIcon";
var $88b734067edb11be$var$_default = module.exports.default = $88b734067edb11be$var$CommentIcon;

});


parcelRegister("fBtgO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5c1042abf84c1ad$var$_react = $b5c1042abf84c1ad$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $b5c1042abf84c1ad$var$_download = $b5c1042abf84c1ad$var$_interopRequireDefault((parcelRequire("lEOqq")));
function $b5c1042abf84c1ad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b5c1042abf84c1ad$var$DownloadIcon = (props)=>/*#__PURE__*/ $b5c1042abf84c1ad$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props, {
        newIcon: $b5c1042abf84c1ad$var$_download.default
    }));
$b5c1042abf84c1ad$var$DownloadIcon.displayName = "DownloadIcon";
var $b5c1042abf84c1ad$var$_default = module.exports.default = $b5c1042abf84c1ad$var$DownloadIcon;

});
parcelRegister("lEOqq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9aaf4aeb0306f2d3ee9684dc41f2c22>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc4472c96c4d73c7$var$_react = $fc4472c96c4d73c7$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $fc4472c96c4d73c7$var$_UNSAFE_baseNew = $fc4472c96c4d73c7$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $fc4472c96c4d73c7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc4472c96c4d73c7$var$DownloadIcon = (props)=>/*#__PURE__*/ $fc4472c96c4d73c7$var$_react.default.createElement($fc4472c96c4d73c7$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 10.25V1"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4 6.25 4 4 4-4"/>`
    }, props));
$fc4472c96c4d73c7$var$DownloadIcon.displayName = "DownloadIcon";
var $fc4472c96c4d73c7$var$_default = module.exports.default = $fc4472c96c4d73c7$var$DownloadIcon;

});


parcelRegister("3UtzK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2d8d8b249b8f090a$var$_react = $2d8d8b249b8f090a$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $2d8d8b249b8f090a$var$_information = $2d8d8b249b8f090a$var$_interopRequireDefault((parcelRequire("JluUo")));
function $2d8d8b249b8f090a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2d8d8b249b8f090a$var$EditorInfoIcon = (props)=>/*#__PURE__*/ $2d8d8b249b8f090a$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-8.5a1 1 0 0 0-1 1V15a1 1 0 0 0 2 0v-2.5a1 1 0 0 0-1-1m0-1.125a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75"/></svg>`
    }, props, {
        newIcon: $2d8d8b249b8f090a$var$_information.default
    }));
$2d8d8b249b8f090a$var$EditorInfoIcon.displayName = "EditorInfoIcon";
var $2d8d8b249b8f090a$var$_default = module.exports.default = $2d8d8b249b8f090a$var$EditorInfoIcon;

});

parcelRegister("867dg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e547a98cd146ab1$var$_react = $5e547a98cd146ab1$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $heZQR = parcelRequire("heZQR");

var $5e547a98cd146ab1$var$_feedback = $5e547a98cd146ab1$var$_interopRequireDefault((parcelRequire("abaKm")));
function $5e547a98cd146ab1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $5e547a98cd146ab1$var$FeedbackIcon = (props)=>/*#__PURE__*/ $5e547a98cd146ab1$var$_react.default.createElement($heZQR.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $5e547a98cd146ab1$var$_feedback.default
    }));
$5e547a98cd146ab1$var$FeedbackIcon.displayName = "FeedbackIcon";
var $5e547a98cd146ab1$var$_default = module.exports.default = $5e547a98cd146ab1$var$FeedbackIcon;

});
parcelRegister("abaKm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fdc79421e640da36581eab376b367cc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $769344865b1fa739$var$_react = $769344865b1fa739$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $769344865b1fa739$var$_UNSAFE_baseNew = $769344865b1fa739$var$_interopRequireDefault((parcelRequire("a1YFK")));
function $769344865b1fa739$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $769344865b1fa739$var$FeedbackIcon = (props)=>/*#__PURE__*/ $769344865b1fa739$var$_react.default.createElement($769344865b1fa739$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.25 7H3c-.69 0-1.25-.56-1.25-1.25V3c0-.69.56-1.25 1.25-1.25h10c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H6L1.75 15V9.5"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m7.75 4.5 2.5 2.5-2.5 2.5"/>`
    }, props));
$769344865b1fa739$var$FeedbackIcon.displayName = "FeedbackIcon";
var $769344865b1fa739$var$_default = module.exports.default = $769344865b1fa739$var$FeedbackIcon;

});


parcelRegister("fBIHI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5ccfd04dbe968ad$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $5nR8v = parcelRequire("5nR8v");

var $8p2GL = parcelRequire("8p2GL");

var $aMNOk = parcelRequire("aMNOk");

var $1zBji = parcelRequire("1zBji");
var $b5ccfd04dbe968ad$var$packageName = "@atlaskit/flag";
var $b5ccfd04dbe968ad$var$packageVersion = "15.8.1";
var $b5ccfd04dbe968ad$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ var $b5ccfd04dbe968ad$var$AutoDismissFlag = function AutoDismissFlag(props) {
    var id = props.id, analyticsContext = props.analyticsContext, _props$onDismissed = props.onDismissed, onDismissedProp = _props$onDismissed === void 0 ? (0, $8p2GL.default) : _props$onDismissed;
    var autoDismissTimer = (0, $9nHZC.useRef)(null);
    var _useFlagGroup = (0, $1zBji.useFlagGroup)(), onDismissedFromFlagGroup = _useFlagGroup.onDismissed, isDismissAllowed = _useFlagGroup.isDismissAllowed;
    var onDismissed = (0, $9nHZC.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var onDismissedAnalytics = (0, $5nR8v.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: "dismissed",
        analyticsData: analyticsContext,
        componentName: "flag",
        packageName: $b5ccfd04dbe968ad$var$packageName,
        packageVersion: $b5ccfd04dbe968ad$var$packageVersion
    });
    var isAutoDismissAllowed = isDismissAllowed && onDismissed;
    var dismissFlag = (0, $9nHZC.useCallback)(function() {
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    var stopAutoDismissTimer = (0, $9nHZC.useCallback)(function() {
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    var startAutoDismissTimer = (0, $9nHZC.useCallback)(function() {
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, $b5ccfd04dbe968ad$export$66c3d409977b5615 * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed
    ]);
    (0, $9nHZC.useEffect)(function() {
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aMNOk.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    }));
};
var $b5ccfd04dbe968ad$export$2e2bcd8739ae039 = $b5ccfd04dbe968ad$var$AutoDismissFlag;

});

parcelRegister("dLTSq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a06b021c5a498cf9$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $k4eyH = parcelRequire("k4eyH");

var $3XiaB = parcelRequire("3XiaB");

var $5fDCf = parcelRequire("5fDCf");
var $a06b021c5a498cf9$var$SimpleTag = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(_ref, ref) {
    var appearance = _ref.appearance, _ref$elemBefore = _ref.elemBefore, elemBefore = _ref$elemBefore === void 0 ? null : _ref$elemBefore, _ref$color = _ref.color, color = _ref$color === void 0 ? "standard" : _ref$color, href = _ref.href, testId = _ref.testId, _ref$text = _ref.text, text = _ref$text === void 0 ? "" : _ref$text, linkComponent = _ref.linkComponent;
    var content = (0, $avKww.jsx)((0, $5fDCf.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    return (0, $avKww.jsx)((0, $k4eyH.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: (0, $avKww.jsx)((0, $3XiaB.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
var $a06b021c5a498cf9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $9nHZC.memo)($a06b021c5a498cf9$var$SimpleTag);

});
parcelRegister("k4eyH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9bf796ce78ba92b$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $5LVXk = parcelRequire("5LVXk");

var $65sEH = parcelRequire("65sEH");

var $iZzqN = parcelRequire("iZzqN");
var $e9bf796ce78ba92b$var$_excluded = [
    "before",
    "contentElement",
    "after",
    "testId",
    "appearance",
    "style",
    "color",
    "href",
    "className"
];
function $e9bf796ce78ba92b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e9bf796ce78ba92b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e9bf796ce78ba92b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e9bf796ce78ba92b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e9bf796ce78ba92b$var$baseStyles = (0, $avKww.css)({
    display: "inline-flex",
    height: (0, $65sEH.tagHeight),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: (0, $65sEH.defaultMargin),
    padding: "var(--ds-space-0, 0px)",
    position: "relative",
    backgroundColor: "var(".concat((0, $65sEH.cssVar).color.background.default, ")"),
    borderRadius: "var(".concat((0, $65sEH.cssVar).borderRadius, ")"),
    color: "var(".concat((0, $65sEH.cssVar).color.text.default, ")"),
    cursor: "default",
    lineHeight: 1,
    overflow: "hidden"
});
var $e9bf796ce78ba92b$var$interactiveStyles = (0, $avKww.css)({
    "&:hover": {
        backgroundColor: "var(".concat((0, $65sEH.cssVar).color.background.hover, ")")
    },
    "&:active": {
        backgroundColor: "var(".concat((0, $65sEH.cssVar).color.background.active, ")")
    }
});
var $e9bf796ce78ba92b$var$focusRingStyles = (0, $avKww.css)({
    "&:focus-within": {
        boxShadow: "0 0 0 2px var(".concat((0, $65sEH.cssVar).color.focusRing, ")"),
        outline: "none"
    }
});
var $e9bf796ce78ba92b$var$nonStandardLinkStyles = (0, $avKww.css)({
    "&:active": {
        color: "var(".concat((0, $65sEH.cssVar).color.text.active, ")")
    }
});
var $e9bf796ce78ba92b$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).forwardRef(function BaseTag(_ref, ref) {
    var _objectSpread2;
    var before = _ref.before, contentElement = _ref.contentElement, after = _ref.after, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, style = _ref.style, _ref$color = _ref.color, color = _ref$color === void 0 ? "standard" : _ref$color, href = _ref.href, className = _ref.className, other = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $e9bf796ce78ba92b$var$_excluded);
    var _useGlobalTheme = (0, $5LVXk.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var isLink = Boolean(href);
    var isRemovable = Boolean(after);
    var isInteractive = isLink || isRemovable;
    var isStandardLink = isLink && color === "standard";
    // Change link text color if  the tag is standard color
    var textLinkColors = isStandardLink ? $iZzqN.textColors["standardLink"][mode] : $iZzqN.textColors[color][mode];
    var backgroundHoverColors = isRemovable && !isLink ? $iZzqN.backgroundColors[color][mode] : $iZzqN.linkHoverBackgroundColors[color][mode];
    var backgroundActiveColors = isRemovable && !isLink ? $iZzqN.backgroundColors[color][mode] : $iZzqN.linkActiveBackgroundColors[color][mode];
    return (0, $avKww.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, other, {
        ref: ref,
        css: [
            $e9bf796ce78ba92b$var$baseStyles,
            (isRemovable || isLink) && $e9bf796ce78ba92b$var$focusRingStyles,
            isLink && !isStandardLink && $e9bf796ce78ba92b$var$nonStandardLinkStyles,
            isInteractive && $e9bf796ce78ba92b$var$interactiveStyles
        ],
        style: $e9bf796ce78ba92b$var$_objectSpread((_objectSpread2 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, (0, $65sEH.cssVar).color.text.default, $iZzqN.textColors[color][mode]), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, (0, $65sEH.cssVar).color.text.hover, $iZzqN.textHoverColors[color][mode]), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, (0, $65sEH.cssVar).color.text.active, $iZzqN.textActiveColors[color][mode]), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, (0, $65sEH.cssVar).color.text.link, textLinkColors), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, (0, $65sEH.cssVar).color.background.default, $iZzqN.backgroundColors[color][mode]), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, (0, $65sEH.cssVar).color.background.hover, backgroundHoverColors), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, (0, $65sEH.cssVar).color.background.active, backgroundActiveColors), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, (0, $65sEH.cssVar).color.focusRing, $iZzqN.focusRingColors[mode]), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, (0, $65sEH.cssVar).color.removeButton.default, $iZzqN.removeButtonColors[color]), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, (0, $65sEH.cssVar).color.removeButton.hover, $iZzqN.removeButtonHoverColors[color][mode]), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_objectSpread2, (0, $65sEH.cssVar).borderRadius, $iZzqN.borderRadius[appearance]), _objectSpread2), style),
        className: className,
        "data-testid": testId
    }), before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e9bf796ce78ba92b$export$2e2bcd8739ae039 = $e9bf796ce78ba92b$var$BaseTag;

});
parcelRegister("65sEH", function(module, exports) {

$parcel$export(module.exports, "tagHeight", function () { return $46e97013b7d22aff$export$5b2b1030a679f37; });
$parcel$export(module.exports, "buttonWidthUnitless", function () { return $46e97013b7d22aff$export$c6f3ea2b4cffd0ca; });
$parcel$export(module.exports, "maxTextWidthUnitless", function () { return $46e97013b7d22aff$export$2e3bcb01bf928995; });
$parcel$export(module.exports, "maxTextWidth", function () { return $46e97013b7d22aff$export$982d4a1a6de11130; });
$parcel$export(module.exports, "defaultBorderRadius", function () { return $46e97013b7d22aff$export$35d5d1e251b985cf; });
$parcel$export(module.exports, "defaultRoundedBorderRadius", function () { return $46e97013b7d22aff$export$c49771100fee18c8; });
$parcel$export(module.exports, "defaultMargin", function () { return $46e97013b7d22aff$export$6728fea658cfb92e; });
$parcel$export(module.exports, "defaultTextPadding", function () { return $46e97013b7d22aff$export$c2d03c4c68282362; });
$parcel$export(module.exports, "textPaddingRight", function () { return $46e97013b7d22aff$export$b5686dedf408caa0; });
$parcel$export(module.exports, "textMarginLeft", function () { return $46e97013b7d22aff$export$b824cac86306f7a2; });
$parcel$export(module.exports, "textFontSize", function () { return $46e97013b7d22aff$export$c27152681dbd5238; });
$parcel$export(module.exports, "cssVar", function () { return $46e97013b7d22aff$export$8b4981022bd80a4e; });
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $aP6k3 = parcelRequire("aP6k3");
var $46e97013b7d22aff$var$gridSizeValue = (0, $aP6k3.gridSize)();
var $46e97013b7d22aff$var$borderRadiusValue = (0, $aP6k3.borderRadius)();
var $46e97013b7d22aff$var$fontSizeValue = (0, $aP6k3.fontSize)();
var $46e97013b7d22aff$export$b4d89c3994664204 = 2.5 * $46e97013b7d22aff$var$gridSizeValue;
var $46e97013b7d22aff$export$5b2b1030a679f37 = "var(--ds-space-250, ".concat("".concat($46e97013b7d22aff$export$b4d89c3994664204, "px"), ")");
var $46e97013b7d22aff$export$c6f3ea2b4cffd0ca = $46e97013b7d22aff$export$b4d89c3994664204; // button should be square
var $46e97013b7d22aff$export$aba002ef70684916 = $46e97013b7d22aff$export$5b2b1030a679f37; // button should be square
var $46e97013b7d22aff$export$d5949a2c2ea9dcea = 25 * $46e97013b7d22aff$var$gridSizeValue;
var $46e97013b7d22aff$export$488fda99655ff65a = "".concat($46e97013b7d22aff$export$d5949a2c2ea9dcea, "px");
var $46e97013b7d22aff$export$2e3bcb01bf928995 = $46e97013b7d22aff$export$d5949a2c2ea9dcea - $46e97013b7d22aff$export$b4d89c3994664204;
var $46e97013b7d22aff$export$982d4a1a6de11130 = "".concat($46e97013b7d22aff$export$2e3bcb01bf928995, "px");
var $46e97013b7d22aff$export$35d5d1e251b985cf = "".concat($46e97013b7d22aff$var$borderRadiusValue, "px");
var $46e97013b7d22aff$export$c49771100fee18c8 = "".concat($46e97013b7d22aff$export$c6f3ea2b4cffd0ca / 2, "px");
var $46e97013b7d22aff$export$6728fea658cfb92e = "var(--ds-space-050, ".concat("".concat($46e97013b7d22aff$var$gridSizeValue / 2, "px"), ")");
var $46e97013b7d22aff$export$c2d03c4c68282362 = "var(--ds-space-050, ".concat("".concat($46e97013b7d22aff$var$gridSizeValue / 2, "px"), ")");
var $46e97013b7d22aff$export$b5686dedf408caa0 = "var(--ds-space-200, ".concat("".concat(2 * $46e97013b7d22aff$var$gridSizeValue, "px"), ")");
var $46e97013b7d22aff$export$b824cac86306f7a2 = $46e97013b7d22aff$export$5b2b1030a679f37;
var $46e97013b7d22aff$export$c27152681dbd5238 = "".concat($46e97013b7d22aff$var$fontSizeValue, "px");
var $46e97013b7d22aff$export$8b4981022bd80a4e = {
    color: {
        background: {
            default: "--ds-cb",
            hover: "--ds-cbh",
            active: "--ds-cba"
        },
        focusRing: "--ds-cfr",
        text: {
            default: "--ds-ct",
            hover: "--ds-cth",
            active: "--ds-ctp",
            link: "--ds-ctl"
        },
        removeButton: {
            default: "--ds-rb",
            hover: "--ds-rbh"
        }
    },
    borderRadius: "--ds-br"
};

});

parcelRegister("iZzqN", function(module, exports) {

$parcel$export(module.exports, "textColors", function () { return $dd39686231693ba8$export$daa0ace263cb20d2; });
$parcel$export(module.exports, "textHoverColors", function () { return $dd39686231693ba8$export$7c7104a5f052cab7; });
$parcel$export(module.exports, "textActiveColors", function () { return $dd39686231693ba8$export$382469baad253eb7; });
$parcel$export(module.exports, "backgroundColors", function () { return $dd39686231693ba8$export$b9d7c59a579c23c6; });
$parcel$export(module.exports, "linkHoverBackgroundColors", function () { return $dd39686231693ba8$export$4410079763249c74; });
$parcel$export(module.exports, "linkActiveBackgroundColors", function () { return $dd39686231693ba8$export$76be99c5e13e3566; });
$parcel$export(module.exports, "focusRingColors", function () { return $dd39686231693ba8$export$2a31dbe82788f940; });
$parcel$export(module.exports, "borderRadius", function () { return $dd39686231693ba8$export$7a57f79000377ca2; });
$parcel$export(module.exports, "removalHoverBackgroundColors", function () { return $dd39686231693ba8$export$1202b7eb21da7b58; });
$parcel$export(module.exports, "removalActiveBackgroundColors", function () { return $dd39686231693ba8$export$62ace793ebb16bda; });
$parcel$export(module.exports, "removalTextColors", function () { return $dd39686231693ba8$export$17d206ccea111bbb; });
$parcel$export(module.exports, "removeButtonColors", function () { return $dd39686231693ba8$export$f64c7641cbc22da7; });
$parcel$export(module.exports, "removeButtonHoverColors", function () { return $dd39686231693ba8$export$b03fbc2a369c563e; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $jp7ng = parcelRequire("jp7ng");

var $65sEH = parcelRequire("65sEH");
var $dd39686231693ba8$export$daa0ace263cb20d2 = {
    standard: {
        light: "var(--ds-text, ".concat($jp7ng.N700, ")"),
        dark: "var(--ds-text, ".concat($jp7ng.DN600, ")")
    },
    standardLink: {
        light: "var(--ds-link, ".concat($jp7ng.B400, ")"),
        dark: "var(--ds-link, ".concat($jp7ng.B400, ")")
    },
    blue: {
        light: "var(--ds-text-accent-blue-bolder, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-accent-blue-bolder, ".concat($jp7ng.N800, ")")
    },
    red: {
        light: "var(--ds-text-accent-red-bolder, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-accent-red-bolder, ".concat($jp7ng.N800, ")")
    },
    yellow: {
        light: "var(--ds-text-accent-yellow-bolder, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-accent-yellow-bolder, ".concat($jp7ng.N800, ")")
    },
    green: {
        light: "var(--ds-text-accent-green-bolder, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-accent-green-bolder, ".concat($jp7ng.N800, ")")
    },
    teal: {
        light: "var(--ds-text-accent-teal-bolder, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-accent-teal-bolder, ".concat($jp7ng.N800, ")")
    },
    purple: {
        light: "var(--ds-text-accent-purple-bolder, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-accent-purple-bolder, ".concat($jp7ng.N800, ")")
    },
    lime: {
        light: "var(--ds-text-accent-lime-bolder, #37471F)",
        dark: "var(--ds-text-accent-lime-bolder, #D3F1A7)"
    },
    magenta: {
        light: "var(--ds-text-accent-magenta-bolder, #50253F)",
        dark: "var(--ds-text-accent-magenta-bolder, #FDD0EC)"
    },
    orange: {
        light: "var(--ds-text-accent-orange-bolder, #5F3811)",
        dark: "var(--ds-text-accent-orange-bolder, #FFE2BD)"
    },
    grey: {
        light: "var(--ds-text-accent-gray-bolder, ".concat($jp7ng.N0, ")"),
        dark: "var(--ds-text-accent-gray-bolder, ".concat($jp7ng.N0, ")")
    },
    blueLight: {
        light: "var(--ds-text-accent-blue, ".concat($jp7ng.B500, ")"),
        dark: "var(--ds-text-accent-blue, ".concat($jp7ng.B500, ")")
    },
    redLight: {
        light: "var(--ds-text-accent-red, ".concat($jp7ng.N500, ")"),
        dark: "var(--ds-text-accent-red, ".concat($jp7ng.N500, ")")
    },
    yellowLight: {
        light: "var(--ds-text-accent-yellow, ".concat($jp7ng.N500, ")"),
        dark: "var(--ds-text-accent-yellow, ".concat($jp7ng.N500, ")")
    },
    greenLight: {
        light: "var(--ds-text-accent-green, ".concat($jp7ng.G500, ")"),
        dark: "var(--ds-text-accent-green, ".concat($jp7ng.G500, ")")
    },
    tealLight: {
        light: "var(--ds-text-accent-teal, ".concat($jp7ng.N500, ")"),
        dark: "var(--ds-text-accent-teal, ".concat($jp7ng.N500, ")")
    },
    purpleLight: {
        light: "var(--ds-text-accent-purple, ".concat($jp7ng.P500, ")"),
        dark: "var(--ds-text-accent-purple, ".concat($jp7ng.P500, ")")
    },
    limeLight: {
        light: "var(--ds-text-accent-lime, #4C6B1F)",
        dark: "var(--ds-text-accent-lime, #B3DF72)"
    },
    magentaLight: {
        light: "var(--ds-text-accent-magenta, #943D73)",
        dark: "var(--ds-text-accent-magenta, #F797D2)"
    },
    orangeLight: {
        light: "var(--ds-text-accent-orange, #974F0C)",
        dark: "var(--ds-text-accent-orange, #FEC57B)"
    },
    greyLight: {
        light: "var(--ds-text-accent-gray, ".concat($jp7ng.N500, ")"),
        dark: "var(--ds-text-accent-gray, ".concat($jp7ng.N500, ")")
    }
};
var $dd39686231693ba8$export$7c7104a5f052cab7 = {
    standard: {
        light: "var(--ds-link, ".concat($jp7ng.B300, ")"),
        dark: "var(--ds-link, ".concat($jp7ng.B200, ")")
    },
    blue: {
        light: "var(--ds-text-accent-blue-bolder, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-accent-blue-bolder, ".concat($jp7ng.N800, ")")
    },
    red: {
        light: "var(--ds-text-accent-red-bolder, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-accent-red-bolder, ".concat($jp7ng.N800, ")")
    },
    yellow: {
        light: "var(--ds-text-accent-yellow-bolder, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-accent-yellow-bolder, ".concat($jp7ng.N800, ")")
    },
    green: {
        light: "var(--ds-text-accent-green-bolder, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-accent-green-bolder, ".concat($jp7ng.N800, ")")
    },
    teal: {
        light: "var(--ds-text-accent-teal-bolder, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-accent-teal-bolder, ".concat($jp7ng.N800, ")")
    },
    purple: {
        light: "var(--ds-text-accent-purple-bolder, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-accent-purple-bolder, ".concat($jp7ng.N800, ")")
    },
    lime: {
        light: "var(--ds-text-accent-lime-bolder, #37471F)",
        dark: "var(--ds-text-accent-lime-bolder, #D3F1A7)"
    },
    magenta: {
        light: "var(--ds-text-accent-magenta-bolder, #50253F)",
        dark: "var(--ds-text-accent-magenta-bolder, #FDD0EC)"
    },
    orange: {
        light: "var(--ds-text-accent-orange-bolder, #5F3811)",
        dark: "var(--ds-text-accent-orange-bolder, #FFE2BD)"
    },
    grey: {
        light: "var(--ds-text-accent-gray-bolder, ".concat($jp7ng.N0, ")"),
        dark: "var(--ds-text-accent-gray-bolder, ".concat($jp7ng.N0, ")")
    },
    blueLight: {
        light: "var(--ds-text-accent-blue, ".concat($jp7ng.B500, ")"),
        dark: "var(--ds-text-accent-blue, ".concat($jp7ng.B500, ")")
    },
    redLight: {
        light: "var(--ds-text-accent-red, ".concat($jp7ng.N500, ")"),
        dark: "var(--ds-text-accent-red, ".concat($jp7ng.N500, ")")
    },
    yellowLight: {
        light: "var(--ds-text-accent-yellow, ".concat($jp7ng.N500, ")"),
        dark: "var(--ds-text-accent-yellow, ".concat($jp7ng.N500, ")")
    },
    greenLight: {
        light: "var(--ds-text-accent-green, ".concat($jp7ng.G500, ")"),
        dark: "var(--ds-text-accent-green, ".concat($jp7ng.G500, ")")
    },
    tealLight: {
        light: "var(--ds-text-accent-teal, ".concat($jp7ng.N500, ")"),
        dark: "var(--ds-text-accent-teal, ".concat($jp7ng.N500, ")")
    },
    purpleLight: {
        light: "var(--ds-text-accent-purple, ".concat($jp7ng.P500, ")"),
        dark: "var(--ds-text-accent-purple, ".concat($jp7ng.P500, ")")
    },
    limeLight: {
        light: "var(--ds-text-accent-lime, #4C6B1F)",
        dark: "var(--ds-text-accent-lime, #B3DF72)"
    },
    magentaLight: {
        light: "var(--ds-text-accent-magenta, #943D73)",
        dark: "var(--ds-text-accent-magenta, #F797D2)"
    },
    orangeLight: {
        light: "var(--ds-text-accent-orange, #974F0C)",
        dark: "var(--ds-text-accent-orange, #FEC57B)"
    },
    greyLight: {
        light: "var(--ds-text-accent-gray, ".concat($jp7ng.N500, ")"),
        dark: "var(--ds-text-accent-gray, ".concat($jp7ng.N500, ")")
    }
};
var $dd39686231693ba8$export$382469baad253eb7 = {
    standard: {
        light: "var(--ds-link-pressed, ".concat($jp7ng.B300, ")"),
        dark: "var(--ds-link-pressed, ".concat($jp7ng.B300, ")")
    },
    blue: {
        light: "var(--ds-text-accent-blue, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-accent-blue, ".concat($jp7ng.N800, ")")
    },
    red: {
        light: "var(--ds-text-accent-red, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-accent-red, ".concat($jp7ng.N800, ")")
    },
    yellow: {
        light: "var(--ds-text-accent-yellow, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-accent-yellow, ".concat($jp7ng.N800, ")")
    },
    green: {
        light: "var(--ds-text-accent-green, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-accent-green, ".concat($jp7ng.N800, ")")
    },
    teal: {
        light: "var(--ds-text-accent-teal, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-accent-teal, ".concat($jp7ng.N800, ")")
    },
    purple: {
        light: "var(--ds-text-accent-purple, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-accent-purple, ".concat($jp7ng.N800, ")")
    },
    lime: {
        light: "var(--ds-text-accent-lime, #4C6B1F)",
        dark: "var(--ds-text-accent-lime, #B3DF72)"
    },
    magenta: {
        light: "var(--ds-text-accent-magenta, #943D73)",
        dark: "var(--ds-text-accent-magenta, #F797D2)"
    },
    orange: {
        light: "var(--ds-text-accent-orange, #974F0C)",
        dark: "var(--ds-text-accent-orange, #FEC57B)"
    },
    grey: {
        light: "var(--ds-text-accent-gray, ".concat($jp7ng.N0, ")"),
        dark: "var(--ds-text-accent-gray, ".concat($jp7ng.N0, ")")
    },
    blueLight: {
        light: "var(--ds-text-accent-blue-bolder, ".concat($jp7ng.B500, ")"),
        dark: "var(--ds-text-accent-blue-bolder, ".concat($jp7ng.B500, ")")
    },
    redLight: {
        light: "var(--ds-text-accent-red-bolder, ".concat($jp7ng.N500, ")"),
        dark: "var(--ds-text-accent-red-bolder, ".concat($jp7ng.N500, ")")
    },
    yellowLight: {
        light: "var(--ds-text-accent-yellow-bolder, ".concat($jp7ng.N500, ")"),
        dark: "var(--ds-text-accent-yellow-bolder, ".concat($jp7ng.N500, ")")
    },
    greenLight: {
        light: "var(--ds-text-accent-green-bolder, ".concat($jp7ng.G500, ")"),
        dark: "var(--ds-text-accent-green-bolder, ".concat($jp7ng.G500, ")")
    },
    tealLight: {
        light: "var(--ds-text-accent-teal-bolder, ".concat($jp7ng.N500, ")"),
        dark: "var(--ds-text-accent-teal-bolder, ".concat($jp7ng.N500, ")")
    },
    purpleLight: {
        light: "var(--ds-text-accent-purple-bolder, ".concat($jp7ng.P500, ")"),
        dark: "var(--ds-text-accent-purple-bolder, ".concat($jp7ng.P500, ")")
    },
    limeLight: {
        light: "var(--ds-text-accent-lime-bolder, #37471F)",
        dark: "var(--ds-text-accent-lime-bolder, #D3F1A7)"
    },
    magentaLight: {
        light: "var(--ds-text-accent-magenta-bolder, #50253F)",
        dark: "var(--ds-text-accent-magenta-bolder, #FDD0EC)"
    },
    orangeLight: {
        light: "var(--ds-text-accent-orange-bolder, #5F3811)",
        dark: "var(--ds-text-accent-orange-bolder, #FFE2BD)"
    },
    greyLight: {
        light: "var(--ds-text-accent-gray-bolder, ".concat($jp7ng.N500, ")"),
        dark: "var(--ds-text-accent-gray-bolder, ".concat($jp7ng.N500, ")")
    }
};
var $dd39686231693ba8$export$b9d7c59a579c23c6 = {
    standard: {
        light: "var(--ds-background-neutral, ".concat($jp7ng.N20, ")"),
        dark: "var(--ds-background-neutral, ".concat($jp7ng.DN100A, ")")
    },
    blue: {
        light: "var(--ds-background-accent-blue-subtle, ".concat($jp7ng.B100, ")"),
        dark: "var(--ds-background-accent-blue-subtle, ".concat($jp7ng.B100, ")")
    },
    red: {
        light: "var(--ds-background-accent-red-subtle, ".concat($jp7ng.R100, ")"),
        dark: "var(--ds-background-accent-red-subtle, ".concat($jp7ng.R100, ")")
    },
    yellow: {
        light: "var(--ds-background-accent-yellow-subtle, ".concat($jp7ng.Y200, ")"),
        dark: "var(--ds-background-accent-yellow-subtle, ".concat($jp7ng.Y200, ")")
    },
    green: {
        light: "var(--ds-background-accent-green-subtle, ".concat($jp7ng.G200, ")"),
        dark: "var(--ds-background-accent-green-subtle, ".concat($jp7ng.G200, ")")
    },
    teal: {
        light: "var(--ds-background-accent-teal-subtle, ".concat($jp7ng.T200, ")"),
        dark: "var(--ds-background-accent-teal-subtle, ".concat($jp7ng.T200, ")")
    },
    purple: {
        light: "var(--ds-background-accent-purple-subtle, ".concat($jp7ng.P100, ")"),
        dark: "var(--ds-background-accent-purple-subtle, ".concat($jp7ng.P100, ")")
    },
    lime: {
        light: "var(--ds-background-accent-lime-subtle, #94C748)",
        dark: "var(--ds-background-accent-lime-subtle, #4C6B1F)"
    },
    magenta: {
        light: "var(--ds-background-accent-magenta-subtle, #E774BB)",
        dark: "var(--ds-background-accent-magenta-subtle, #943D73)"
    },
    orange: {
        light: "var(--ds-background-accent-orange-subtle, #FAA53D)",
        dark: "var(--ds-background-accent-orange-subtle, #974F0C)"
    },
    grey: {
        light: "var(--ds-background-accent-gray-subtle, ".concat($jp7ng.N500, ")"),
        dark: "var(--ds-background-accent-gray-subtle, ".concat($jp7ng.N500, ")")
    },
    blueLight: {
        light: "var(--ds-background-accent-blue-subtler, ".concat($jp7ng.B75, ")"),
        dark: "var(--ds-background-accent-blue-subtler, ".concat($jp7ng.B75, ")")
    },
    redLight: {
        light: "var(--ds-background-accent-red-subtler, ".concat($jp7ng.R75, ")"),
        dark: "var(--ds-background-accent-red-subtler, ".concat($jp7ng.R75, ")")
    },
    yellowLight: {
        light: "var(--ds-background-accent-orange-subtler, ".concat($jp7ng.Y100, ")"),
        dark: "var(--ds-background-accent-orange-subtler, ".concat($jp7ng.Y100, ")")
    },
    greenLight: {
        light: "var(--ds-background-accent-green-subtler, ".concat($jp7ng.G100, ")"),
        dark: "var(--ds-background-accent-green-subtler, ".concat($jp7ng.G100, ")")
    },
    tealLight: {
        light: "var(--ds-background-accent-teal-subtler, ".concat($jp7ng.T100, ")"),
        dark: "var(--ds-background-accent-teal-subtler, ".concat($jp7ng.T100, ")")
    },
    purpleLight: {
        light: "var(--ds-background-accent-purple-subtler, ".concat($jp7ng.P75, ")"),
        dark: "var(--ds-background-accent-purple-subtler, ".concat($jp7ng.P75, ")")
    },
    limeLight: {
        light: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        dark: "var(--ds-background-accent-lime-subtler, #37471F)"
    },
    magentaLight: {
        light: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        dark: "var(--ds-background-accent-magenta-subtler, #50253F)"
    },
    orangeLight: {
        light: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
        dark: "var(--ds-background-accent-orange-subtler, #5F3811)"
    },
    greyLight: {
        light: "var(--ds-background-accent-gray-subtler, ".concat($jp7ng.N30, ")"),
        dark: "var(--ds-background-accent-gray-subtler, ".concat($jp7ng.N30, ")")
    }
};
var $dd39686231693ba8$export$4410079763249c74 = {
    standard: {
        light: "var(--ds-background-neutral-hovered, ".concat($jp7ng.N30, ")"),
        dark: "var(--ds-background-neutral-hovered, ".concat($jp7ng.DN60, ")")
    },
    blue: {
        light: "var(--ds-background-accent-blue-subtle-hovered, ".concat($jp7ng.B75, ")"),
        dark: "var(--ds-background-accent-blue-subtle-hovered, ".concat($jp7ng.DN60, ")")
    },
    red: {
        light: "var(--ds-background-accent-red-subtle-hovered, ".concat($jp7ng.R75, ")"),
        dark: "var(--ds-background-accent-red-subtle-hovered, ".concat($jp7ng.DN60, ")")
    },
    yellow: {
        light: "var(--ds-background-accent-yellow-subtle-hovered, ".concat($jp7ng.Y100, ")"),
        dark: "var(--ds-background-accent-yellow-subtle-hovered, ".concat($jp7ng.DN60, ")")
    },
    green: {
        light: "var(--ds-background-accent-green-subtle-hovered, ".concat($jp7ng.G100, ")"),
        dark: "var(--ds-background-accent-green-subtle-hovered, ".concat($jp7ng.DN60, ")")
    },
    teal: {
        light: "var(--ds-background-accent-teal-subtle-hovered, ".concat($jp7ng.T100, ")"),
        dark: "var(--ds-background-accent-teal-subtle-hovered, ".concat($jp7ng.DN60, ")")
    },
    purple: {
        light: "var(--ds-background-accent-purple-subtle-hovered, ".concat($jp7ng.P75, ")"),
        dark: "var(--ds-background-accent-purple-subtle-hovered, ".concat($jp7ng.DN60, ")")
    },
    lime: {
        light: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
        dark: "var(--ds-background-accent-lime-subtle-hovered, #37471F)"
    },
    magenta: {
        light: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
        dark: "var(--ds-background-accent-magenta-subtle-hovered, #50253F)"
    },
    orange: {
        light: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
        dark: "var(--ds-background-accent-orange-subtle-hovered, #37471F)"
    },
    grey: {
        light: "var(--ds-background-accent-gray-subtle-hovered, ".concat($jp7ng.N400, ")"),
        dark: "var(--ds-background-accent-gray-subtle-hovered, ".concat($jp7ng.N500, ")")
    },
    blueLight: {
        light: "var(--ds-background-accent-blue-subtler-hovered, ".concat($jp7ng.B50, ")"),
        dark: "var(--ds-background-accent-blue-subtler-hovered, ".concat($jp7ng.DN60, ")")
    },
    redLight: {
        light: "var(--ds-background-accent-red-subtler-hovered, ".concat($jp7ng.R50, ")"),
        dark: "var(--ds-background-accent-red-subtler-hovered, ".concat($jp7ng.DN60, ")")
    },
    yellowLight: {
        light: "var(--ds-background-accent-yellow-subtler-hovered, ".concat($jp7ng.Y75, ")"),
        dark: "var(--ds-background-accent-yellow-subtler-hovered, ".concat($jp7ng.DN60, ")")
    },
    greenLight: {
        light: "var(--ds-background-accent-green-subtler-hovered, ".concat($jp7ng.G75, ")"),
        dark: "var(--ds-background-accent-green-subtler-hovered, ".concat($jp7ng.DN60, ")")
    },
    tealLight: {
        light: "var(--ds-background-accent-teal-subtler-hovered, ".concat($jp7ng.T75, ")"),
        dark: "var(--ds-background-accent-teal-subtler-hovered, ".concat($jp7ng.DN60, ")")
    },
    purpleLight: {
        light: "var(--ds-background-accent-purple-subtler-hovered, ".concat($jp7ng.P50, ")"),
        dark: "var(--ds-background-accent-purple-subtler-hovered, ".concat($jp7ng.DN60, ")")
    },
    limeLight: {
        light: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
        dark: "var(--ds-background-accent-lime-subtler-hovered, #4C6B1F)"
    },
    magentaLight: {
        light: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
        dark: "var(--ds-background-accent-magenta-subtler-hovered, #943D73)"
    },
    orangeLight: {
        light: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
        dark: "var(--ds-background-accent-orange-subtler-hovered, #974F0C)"
    },
    greyLight: {
        light: "var(--ds-background-accent-gray-subtler-hovered, ".concat($jp7ng.N40, ")"),
        dark: "var(--ds-background-accent-gray-subtler-hovered, ".concat($jp7ng.DN60, ")")
    }
};
var $dd39686231693ba8$export$76be99c5e13e3566 = {
    standard: {
        light: "var(--ds-background-neutral-pressed, ".concat($jp7ng.N30, ")"),
        dark: "var(--ds-background-neutral-pressed, ".concat($jp7ng.DN600, ")")
    },
    blue: {
        light: "var(--ds-background-accent-blue-subtle-pressed, ".concat($jp7ng.B50, ")"),
        dark: "var(--ds-background-accent-blue-subtle-pressed, ".concat($jp7ng.DN600, ")")
    },
    red: {
        light: "var(--ds-background-accent-red-subtle-pressed, ".concat($jp7ng.R50, ")"),
        dark: "var(--ds-background-accent-red-subtle-pressed, ".concat($jp7ng.DN600, ")")
    },
    yellow: {
        light: "var(--ds-background-accent-yellow-subtle-pressed, ".concat($jp7ng.Y75, ")"),
        dark: "var(--ds-background-accent-yellow-subtle-pressed, ".concat($jp7ng.DN600, ")")
    },
    green: {
        light: "var(--ds-background-accent-green-subtle-pressed, ".concat($jp7ng.G75, ")"),
        dark: "var(--ds-background-accent-green-subtle-pressed, ".concat($jp7ng.DN600, ")")
    },
    teal: {
        light: "var(--ds-background-accent-teal-subtle-pressed, ".concat($jp7ng.T75, ")"),
        dark: "var(--ds-background-accent-teal-subtle-pressed, ".concat($jp7ng.DN600, ")")
    },
    purple: {
        light: "var(--ds-background-accent-purple-subtle-pressed, ".concat($jp7ng.P50, ")"),
        dark: "var(--ds-background-accent-purple-subtle-pressed, ".concat($jp7ng.DN600, ")")
    },
    grey: {
        light: "var(--ds-background-accent-gray-subtle-pressed, ".concat($jp7ng.N300, ")"),
        dark: "var(--ds-background-accent-gray-subtle-pressed, ".concat($jp7ng.DN600, ")")
    },
    lime: {
        light: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
        dark: "var(--ds-background-accent-lime-subtle-pressed, #2A3818)"
    },
    magenta: {
        light: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
        dark: "var(--ds-background-accent-magenta-subtle-pressed, #421F34)"
    },
    orange: {
        light: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
        dark: "var(--ds-background-accent-orange-subtle-pressed, #4A2B0F)"
    },
    blueLight: {
        light: "var(--ds-background-accent-blue-subtler-pressed, ".concat($jp7ng.B100, ")"),
        dark: "var(--ds-background-accent-blue-subtler-pressed, ".concat($jp7ng.DN600, ")")
    },
    redLight: {
        light: "var(--ds-background-accent-red-subtler-pressed, ".concat($jp7ng.R100, ")"),
        dark: "var(--ds-background-accent-red-subtler-pressed, ".concat($jp7ng.DN600, ")")
    },
    yellowLight: {
        light: "var(--ds-background-accent-yellow-subtler-pressed, ".concat($jp7ng.Y200, ")"),
        dark: "var(--ds-background-accent-yellow-subtler-pressed, ".concat($jp7ng.DN600, ")")
    },
    greenLight: {
        light: "var(--ds-background-accent-green-subtler-pressed, ".concat($jp7ng.G200, ")"),
        dark: "var(--ds-background-accent-green-subtler-pressed, ".concat($jp7ng.DN600, ")")
    },
    tealLight: {
        light: "var(--ds-background-accent-teal-subtler-pressed, ".concat($jp7ng.T200, ")"),
        dark: "var(--ds-background-accent-teal-subtler-pressed, ".concat($jp7ng.DN600, ")")
    },
    purpleLight: {
        light: "var(--ds-background-accent-purple-subtler-pressed, ".concat($jp7ng.P100, ")"),
        dark: "var(--ds-background-accent-purple-subtler-pressed, ".concat($jp7ng.DN600, ")")
    },
    limeLight: {
        light: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
        dark: "var(--ds-background-accent-lime-subtler-pressed, #5B7F24)"
    },
    magentaLight: {
        light: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
        dark: "var(--ds-background-accent-magenta-subtler-pressed, #AE4787)"
    },
    orangeLight: {
        light: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
        dark: "var(--ds-background-accent-orange-subtler-pressed, #B65C02)"
    },
    greyLight: {
        light: "var(--ds-background-accent-gray-subtler-pressed, ".concat($jp7ng.N50, ")"),
        dark: "var(--ds-background-accent-gray-subtler-pressed, ".concat($jp7ng.DN600, ")")
    }
};
var $dd39686231693ba8$export$2a31dbe82788f940 = {
    light: "var(--ds-border-focused, ".concat($jp7ng.B100, ")"),
    dark: "var(--ds-border-focused, ".concat($jp7ng.B75, ")")
};
var $dd39686231693ba8$export$7a57f79000377ca2 = {
    default: (0, $65sEH.defaultBorderRadius),
    rounded: (0, $65sEH.defaultRoundedBorderRadius)
};
var $dd39686231693ba8$export$1202b7eb21da7b58 = {
    light: "var(--ds-background-danger, ".concat($jp7ng.R50, ")"),
    dark: "var(--ds-background-danger, ".concat($jp7ng.R100, ")")
};
var $dd39686231693ba8$export$62ace793ebb16bda = {
    light: "var(--ds-background-danger-hovered, ".concat($jp7ng.R50, ")"),
    dark: "var(--ds-background-danger-hovered, ".concat($jp7ng.DN600, ")")
};
var $dd39686231693ba8$export$17d206ccea111bbb = {
    light: "var(--ds-text-danger, ".concat($jp7ng.R500, ")"),
    dark: "var(--ds-text-danger, ".concat($jp7ng.DN30, ")")
};
var $dd39686231693ba8$export$f64c7641cbc22da7 = {
    standard: "var(--ds-text, ".concat($jp7ng.N500, ")"),
    blue: "var(--ds-text-accent-blue-bolder, ".concat($jp7ng.N500, ")"),
    red: "var(--ds-text-accent-red-bolder, ".concat($jp7ng.N500, ")"),
    yellow: "var(--ds-text-accent-yellow-bolder, ".concat($jp7ng.N500, ")"),
    green: "var(--ds-text-accent-green-bolder, ".concat($jp7ng.N500, ")"),
    teal: "var(--ds-text-accent-teal-bolder, ".concat($jp7ng.N500, ")"),
    purple: "var(--ds-text-accent-purple-bolder, ".concat($jp7ng.N500, ")"),
    lime: "var(--ds-text-accent-lime-bolder, ".concat($jp7ng.N500, ")"),
    magenta: "var(--ds-text-accent-magenta-bolder, ".concat($jp7ng.N500, ")"),
    orange: "var(--ds-text-accent-orange-bolder, ".concat($jp7ng.N500, ")"),
    grey: "var(--ds-text-accent-gray-bolder, ".concat($jp7ng.N500, ")"),
    blueLight: "var(--ds-text-accent-blue, ".concat($jp7ng.N500, ")"),
    redLight: "var(--ds-text-accent-red, ".concat($jp7ng.N500, ")"),
    yellowLight: "var(--ds-text-accent-yellow, ".concat($jp7ng.N500, ")"),
    greenLight: "var(--ds-text-accent-green, ".concat($jp7ng.N500, ")"),
    tealLight: "var(--ds-text-accent-teal, ".concat($jp7ng.N500, ")"),
    purpleLight: "var(--ds-text-accent-purple, ".concat($jp7ng.N500, ")"),
    limeLight: "var(--ds-text-accent-lime, ".concat($jp7ng.N500, ")"),
    magentaLight: "var(--ds-text-accent-magenta, ".concat($jp7ng.N500, ")"),
    orangeLight: "var(--ds-text-accent-orange, ".concat($jp7ng.N500, ")"),
    greyLight: "var(--ds-text-accent-gray, ".concat($jp7ng.N500, ")")
};
var $dd39686231693ba8$export$b03fbc2a369c563e = {
    standard: {
        light: "var(--ds-text-danger, ".concat($jp7ng.N700, ")"),
        dark: "var(--ds-text-danger, ".concat($jp7ng.DN600, ")")
    },
    standardLink: {
        light: "var(--ds-text-danger, ".concat($jp7ng.B400, ")"),
        dark: "var(--ds-text-danger, ".concat($jp7ng.B400, ")")
    },
    blue: {
        light: "var(--ds-text-danger, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-danger, ".concat($jp7ng.N800, ")")
    },
    red: {
        light: "var(--ds-text-danger, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-danger, ".concat($jp7ng.N800, ")")
    },
    yellow: {
        light: "var(--ds-text-danger, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-danger, ".concat($jp7ng.N800, ")")
    },
    green: {
        light: "var(--ds-text-danger, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-danger, ".concat($jp7ng.N800, ")")
    },
    teal: {
        light: "var(--ds-text-danger, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-danger, ".concat($jp7ng.N800, ")")
    },
    purple: {
        light: "var(--ds-text-danger, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-danger, ".concat($jp7ng.N800, ")")
    },
    lime: {
        light: "var(--ds-text-danger, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-danger, ".concat($jp7ng.N800, ")")
    },
    magenta: {
        light: "var(--ds-text-danger, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-danger, ".concat($jp7ng.N800, ")")
    },
    orange: {
        light: "var(--ds-text-danger, ".concat($jp7ng.N800, ")"),
        dark: "var(--ds-text-danger, ".concat($jp7ng.N800, ")")
    },
    grey: {
        light: "var(--ds-text-danger, ".concat($jp7ng.N0, ")"),
        dark: "var(--ds-text-danger, ".concat($jp7ng.N0, ")")
    },
    blueLight: {
        light: "var(--ds-text-danger, ".concat($jp7ng.B500, ")"),
        dark: "var(--ds-text-danger, ".concat($jp7ng.B500, ")")
    },
    redLight: {
        light: "var(--ds-text-danger, ".concat($jp7ng.N500, ")"),
        dark: "var(--ds-text-danger, ".concat($jp7ng.N500, ")")
    },
    yellowLight: {
        light: "var(--ds-text-danger, ".concat($jp7ng.N500, ")"),
        dark: "var(--ds-text-danger, ".concat($jp7ng.N500, ")")
    },
    greenLight: {
        light: "var(--ds-text-danger, ".concat($jp7ng.G500, ")"),
        dark: "var(--ds-text-danger, ".concat($jp7ng.G500, ")")
    },
    tealLight: {
        light: "var(--ds-text-danger, ".concat($jp7ng.N500, ")"),
        dark: "var(--ds-text-danger, ".concat($jp7ng.N500, ")")
    },
    purpleLight: {
        light: "var(--ds-text-danger, ".concat($jp7ng.P500, ")"),
        dark: "var(--ds-text-danger, ".concat($jp7ng.P500, ")")
    },
    limeLight: {
        light: "var(--ds-text-danger, ".concat($jp7ng.P500, ")"),
        dark: "var(--ds-text-danger, ".concat($jp7ng.P500, ")")
    },
    magentaLight: {
        light: "var(--ds-text-danger, ".concat($jp7ng.P500, ")"),
        dark: "var(--ds-text-danger, ".concat($jp7ng.P500, ")")
    },
    orangeLight: {
        light: "var(--ds-text-danger, ".concat($jp7ng.P500, ")"),
        dark: "var(--ds-text-danger, ".concat($jp7ng.P500, ")")
    },
    greyLight: {
        light: "var(--ds-text-danger, ".concat($jp7ng.N500, ")"),
        dark: "var(--ds-text-danger, ".concat($jp7ng.N500, ")")
    }
};

});


parcelRegister("3XiaB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e14f9f396828a9f$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $avKww = parcelRequire("avKww");

var $65sEH = parcelRequire("65sEH");
var $2e14f9f396828a9f$var$beforeElementStyles = (0, $avKww.css)({
    display: "flex",
    position: "absolute",
    top: "var(--ds-space-0, 0px)",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "var(".concat((0, $65sEH.cssVar).borderRadius, ")")
});
var $2e14f9f396828a9f$var$Before = function Before(_ref) {
    var elemBefore = _ref.elemBefore;
    return elemBefore ? (0, $avKww.jsx)("span", {
        css: $2e14f9f396828a9f$var$beforeElementStyles
    }, elemBefore) : null;
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2e14f9f396828a9f$export$2e2bcd8739ae039 = $2e14f9f396828a9f$var$Before;

});

parcelRegister("5fDCf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d2d155bd7664aa8$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $avKww = parcelRequire("avKww");

var $65sEH = parcelRequire("65sEH");
var $3d2d155bd7664aa8$var$baseStyles = (0, $avKww.css)({
    maxWidth: (0, $65sEH.maxTextWidth),
    paddingTop: "var(--ds-space-025, 2px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    paddingRight: (0, $65sEH.defaultTextPadding),
    paddingBottom: "var(--ds-space-025, 2px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    paddingLeft: (0, $65sEH.defaultTextPadding),
    fontSize: (0, $65sEH.textFontSize),
    fontWeight: "normal",
    lineHeight: 1,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    // Use "clip" overflow to allow ellipses on x-axis without clipping descenders
    "@supports not (overflow-x: clip)": {
        overflow: "hidden"
    },
    "@supports (overflow-x: clip)": {
        overflowX: "clip"
    }
});
var $3d2d155bd7664aa8$var$linkStyles = (0, $avKww.css)({
    color: "var(".concat((0, $65sEH.cssVar).color.text.link, ")"),
    pointerEvents: "auto",
    textDecoration: "none",
    "&:hover": {
        color: "var(".concat((0, $65sEH.cssVar).color.text.hover, ")"),
        textDecoration: "underline"
    },
    "&:active": {
        color: "var(".concat((0, $65sEH.cssVar).color.text.active, ")"),
        textDecoration: "underline"
    },
    "&:focus": {
        outline: "none"
    }
});
var $3d2d155bd7664aa8$var$hasAfterStyles = (0, $avKww.css)({
    maxWidth: "".concat((0, $65sEH.maxTextWidthUnitless) - (0, $65sEH.buttonWidthUnitless), "px"),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    paddingRight: (0, $65sEH.textPaddingRight)
});
var $3d2d155bd7664aa8$var$hasBeforeStyles = (0, $avKww.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    marginLeft: (0, $65sEH.textMarginLeft)
});
var $3d2d155bd7664aa8$var$Content = function Content(_ref) {
    var _ref$elemBefore = _ref.elemBefore, elemBefore = _ref$elemBefore === void 0 ? null : _ref$elemBefore, _ref$isRemovable = _ref.isRemovable, isRemovable = _ref$isRemovable === void 0 ? true : _ref$isRemovable, _ref$text = _ref.text, text = _ref$text === void 0 ? "" : _ref$text, _ref$color = _ref.color, color = _ref$color === void 0 ? "standard" : _ref$color, href = _ref.href, linkComponent = _ref.linkComponent;
    var Link = linkComponent !== null && linkComponent !== void 0 ? linkComponent : "a";
    if (href) return (0, $avKww.jsx)(Link, {
        href: href,
        "data-color": color,
        css: [
            $3d2d155bd7664aa8$var$baseStyles,
            $3d2d155bd7664aa8$var$linkStyles,
            elemBefore && $3d2d155bd7664aa8$var$hasBeforeStyles,
            isRemovable && $3d2d155bd7664aa8$var$hasAfterStyles
        ]
    }, text);
    else return (0, $avKww.jsx)("span", {
        css: [
            $3d2d155bd7664aa8$var$baseStyles,
            elemBefore && $3d2d155bd7664aa8$var$hasBeforeStyles,
            isRemovable && $3d2d155bd7664aa8$var$hasAfterStyles
        ]
    }, text);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3d2d155bd7664aa8$export$2e2bcd8739ae039 = $3d2d155bd7664aa8$var$Content;

});


parcelRegister("bUo4Z", function(module, exports) {

$parcel$export(module.exports, "FlagDismissed", function () { return $b79e27f0d265d08a$export$8526fb8fe8f74a74; });
$parcel$export(module.exports, "FlagViewed", function () { return $b79e27f0d265d08a$export$97cccb622d5d4bcd; });
$parcel$export(module.exports, "FocusedTaskPageBackButtonClickedFact", function () { return $b79e27f0d265d08a$export$2136f45af5c4ac43; });
$parcel$export(module.exports, "ToggleSearchDrawerFact", function () { return $b79e27f0d265d08a$export$d99c21ca5f0709b1; });
parcelRequire("3hzea");
var $6E7t8 = parcelRequire("6E7t8");
class $b79e27f0d265d08a$export$40107b9a6be946ee extends (0, $6E7t8.default) {
    constructor(...args){
        super(...args);
        this.name = "bitbucket.flags.action_clicked";
    }
}
class $b79e27f0d265d08a$export$8526fb8fe8f74a74 extends (0, $6E7t8.default) {
    constructor(...args){
        super(...args);
        this.name = "bitbucket.flags.dismissed";
    }
}
class $b79e27f0d265d08a$export$97cccb622d5d4bcd extends (0, $6E7t8.default) {
    constructor(...args){
        super(...args);
        this.name = "bitbucket.flags.viewed";
    }
}
class $b79e27f0d265d08a$export$2136f45af5c4ac43 extends (0, $6E7t8.default) {
    constructor(...args){
        super(...args);
        this.name = "bitbucket.navigation.focused-task.back-button.clicked";
    }
}
class $b79e27f0d265d08a$export$d99c21ca5f0709b1 extends (0, $6E7t8.default) {
    constructor(...args){
        super(...args);
        this.name = "bitbucket.search_drawer.toggled";
    }
}

});

parcelRegister("cjZE0", function(module, exports) {

$parcel$export(module.exports, "ModalDialogName", function () { return $c4bf1c376fdff328$export$9aca1c603adb7b98; });
$parcel$export(module.exports, "ModalDialogUrlHash", function () { return $c4bf1c376fdff328$export$64e8136b90fa8916; });
var $c4bf1c376fdff328$export$9aca1c603adb7b98;
(function(ModalDialogName) {
    ModalDialogName["group"] = "group";
    ModalDialogName["member"] = "member";
    ModalDialogName["remove"] = "remove";
    ModalDialogName["chooseDefaultGroup"] = "choose";
    ModalDialogName["makeDefault"] = "makeDefault";
})($c4bf1c376fdff328$export$9aca1c603adb7b98 || ($c4bf1c376fdff328$export$9aca1c603adb7b98 = {}));
var $c4bf1c376fdff328$export$64e8136b90fa8916;
(function(ModalDialogUrlHash) {
    ModalDialogUrlHash["CREATE_GROUP_MODAL_KEY"] = "createGroup";
    ModalDialogUrlHash["CHOOSE_GROUP_MODAL_KEY"] = "chooseGroup";
})($c4bf1c376fdff328$export$64e8136b90fa8916 || ($c4bf1c376fdff328$export$64e8136b90fa8916 = {}));

});

parcelRegister("5vIkm", function(module, exports) {

$parcel$export(module.exports, "setDismissed", function () { return $9fb1661ac631c31c$export$5f60579e856b28d8; });
$parcel$export(module.exports, "getDismissedCount", function () { return $9fb1661ac631c31c$export$b794d377c62468dc; });
$parcel$export(module.exports, "setShownNow", function () { return $9fb1661ac631c31c$export$33d7c76ddad977fa; });
$parcel$export(module.exports, "getShown", function () { return $9fb1661ac631c31c$export$75d5ea8092347462; });
parcelRequire("l8rpz");
var $dUPSr = parcelRequire("dUPSr");

var $h3kk7 = parcelRequire("h3kk7");
const $9fb1661ac631c31c$var$storageNameDismissedCount = (user, workspaceSlug)=>`default-group-intro-flag:dismisscount:${user.uuid}:${workspaceSlug}`;
const $9fb1661ac631c31c$var$storageNameShownTime = (user, workspaceSlug)=>`default-group-intro-flag:lastshown:${user.uuid}:${workspaceSlug}`;
const $9fb1661ac631c31c$export$5f60579e856b28d8 = (user, workspaceSlug)=>{
    const key = $9fb1661ac631c31c$var$storageNameDismissedCount(user, workspaceSlug);
    const dismissCount = (0, $h3kk7.default).get(key, 0);
    (0, $h3kk7.default).set(key, Number(dismissCount) + 1);
};
const $9fb1661ac631c31c$export$b794d377c62468dc = (user, workspaceSlug)=>{
    const key = $9fb1661ac631c31c$var$storageNameDismissedCount(user, workspaceSlug);
    return (0, $h3kk7.default).get(key, 0);
};
const $9fb1661ac631c31c$export$33d7c76ddad977fa = (user, workspaceSlug)=>{
    const key = $9fb1661ac631c31c$var$storageNameShownTime(user, workspaceSlug);
    (0, $h3kk7.default).set(key, Date.now());
};
const $9fb1661ac631c31c$export$75d5ea8092347462 = (user, workspaceSlug)=>{
    const key = $9fb1661ac631c31c$var$storageNameShownTime(user, workspaceSlug);
    // if no date stored, return a day ago
    return (0, $h3kk7.default).get(key, Date.now() - (0, $dUPSr.oneDay));
};

});

parcelRegister("fojQl", function(module, exports) {
$parcel$export(module.exports, "bulkDeleteBranches", function () { return (parcelRequire("k2UuV")).bulkDeleteBranches; });
$parcel$export(module.exports, "clearSelectedBranches", function () { return (parcelRequire("k2UuV")).clearSelectedBranches; });
$parcel$export(module.exports, "closeBulkDeleteBranchesDialog", function () { return (parcelRequire("k2UuV")).closeBulkDeleteBranchesDialog; });
$parcel$export(module.exports, "closeCompareBranchesDialog", function () { return (parcelRequire("exHB3")).closeCompareBranchesDialog; });
$parcel$export(module.exports, "closeDeleteBranchDialog", function () { return (parcelRequire("1ElOF")).closeDeleteBranchDialog; });
$parcel$export(module.exports, "compareBranches", function () { return (parcelRequire("exHB3")).compareBranches; });
$parcel$export(module.exports, "DELETE_BRANCH", function () { return (parcelRequire("1ElOF")).DELETE_BRANCH; });
$parcel$export(module.exports, "deleteBranch", function () { return (parcelRequire("1ElOF")).deleteBranch; });
$parcel$export(module.exports, "fetchDefaultCommitMessage", function () { return (parcelRequire("28cQM")).fetchDefaultCommitMessage; });
$parcel$export(module.exports, "loadBranches", function () { return (parcelRequire("j7nzB")).loadBranches; });
$parcel$export(module.exports, "loadBranchingModel", function () { return (parcelRequire("j7nzB")).loadBranchingModel; });
$parcel$export(module.exports, "loadMainBranch", function () { return (parcelRequire("j7nzB")).loadMainBranch; });
$parcel$export(module.exports, "onToggleBranchSelect", function () { return (parcelRequire("k2UuV")).onToggleBranchSelect; });
$parcel$export(module.exports, "onToggleBranchSelectAllInPage", function () { return (parcelRequire("k2UuV")).onToggleBranchSelectAllInPage; });
$parcel$export(module.exports, "onToggleBulkDeleteSelectionMode", function () { return (parcelRequire("k2UuV")).onToggleBulkDeleteSelectionMode; });
$parcel$export(module.exports, "openBulkDeleteBranchesDialog", function () { return (parcelRequire("k2UuV")).openBulkDeleteBranchesDialog; });
$parcel$export(module.exports, "openDeleteBranchDialog", function () { return (parcelRequire("1ElOF")).openDeleteBranchDialog; });
$parcel$export(module.exports, "openMergeBranchDialog", function () { return (parcelRequire("exHB3")).openMergeBranchDialog; });
$parcel$export(module.exports, "openSyncBranchDialog", function () { return (parcelRequire("exHB3")).openSyncBranchDialog; });
$parcel$export(module.exports, "RELOAD_BRANCHES", function () { return (parcelRequire("j7nzB")).RELOAD_BRANCHES; });
$parcel$export(module.exports, "reloadBranches", function () { return (parcelRequire("j7nzB")).reloadBranches; });
$parcel$export(module.exports, "unloadBranches", function () { return (parcelRequire("j7nzB")).unloadBranches; });
$parcel$export(module.exports, "getAllBranches", function () { return (parcelRequire("4cfLu")).getAllBranches; });
$parcel$export(module.exports, "getBranchesPagination", function () { return (parcelRequire("4cfLu")).getBranchesPagination; });
$parcel$export(module.exports, "getBranchingModel", function () { return (parcelRequire("4cfLu")).getBranchingModel; });
$parcel$export(module.exports, "getBranchListReloadUrl", function () { return (parcelRequire("4cfLu")).getBranchListReloadUrl; });
$parcel$export(module.exports, "getBulkDeleteBranchesSlice", function () { return (parcelRequire("4cfLu")).getBulkDeleteBranchesSlice; });
$parcel$export(module.exports, "getCompareBranchesDialogSlice", function () { return (parcelRequire("4cfLu")).getCompareBranchesDialogSlice; });
$parcel$export(module.exports, "getDeleteBranchDialogBranch", function () { return (parcelRequire("4cfLu")).getDeleteBranchDialogBranch; });
$parcel$export(module.exports, "getDeleteBranchDialogSlice", function () { return (parcelRequire("4cfLu")).getDeleteBranchDialogSlice; });
$parcel$export(module.exports, "getIsBranchListError", function () { return (parcelRequire("4cfLu")).getIsBranchListError; });
$parcel$export(module.exports, "getIsBranchListLoading", function () { return (parcelRequire("4cfLu")).getIsBranchListLoading; });
$parcel$export(module.exports, "getIsInSelectionMode", function () { return (parcelRequire("4cfLu")).getIsInSelectionMode; });
$parcel$export(module.exports, "getMainBranch", function () { return (parcelRequire("4cfLu")).getMainBranch; });
$parcel$export(module.exports, "getSelectedBranches", function () { return (parcelRequire("4cfLu")).getSelectedBranches; });

$parcel$export(module.exports, "DeleteBranchErrorTypes", function () { return (parcelRequire("pUQWs")).DeleteBranchErrorTypes; });
parcelRequire("fe3Mu");

var $2Nc6d = parcelRequire("2Nc6d");

var $pUQWs = parcelRequire("pUQWs");

var $5JXyS = parcelRequire("5JXyS");
parcelRequire("4cfLu");

});
parcelRegister("fe3Mu", function(module, exports) {
$parcel$export(module.exports, "LOAD_BRANCHES", function () { return (parcelRequire("j7nzB")).LOAD_BRANCHES; });
$parcel$export(module.exports, "LOAD_BRANCHING_MODEL", function () { return (parcelRequire("j7nzB")).LOAD_BRANCHING_MODEL; });
$parcel$export(module.exports, "LOAD_MAIN_BRANCH", function () { return (parcelRequire("j7nzB")).LOAD_MAIN_BRANCH; });
$parcel$export(module.exports, "loadBranches", function () { return (parcelRequire("j7nzB")).loadBranches; });
$parcel$export(module.exports, "loadBranchingModel", function () { return (parcelRequire("j7nzB")).loadBranchingModel; });
$parcel$export(module.exports, "loadMainBranch", function () { return (parcelRequire("j7nzB")).loadMainBranch; });
$parcel$export(module.exports, "RELOAD_BRANCHES", function () { return (parcelRequire("j7nzB")).RELOAD_BRANCHES; });
$parcel$export(module.exports, "reloadBranches", function () { return (parcelRequire("j7nzB")).reloadBranches; });
$parcel$export(module.exports, "UNLOAD_BRANCHES", function () { return (parcelRequire("j7nzB")).UNLOAD_BRANCHES; });
$parcel$export(module.exports, "unloadBranches", function () { return (parcelRequire("j7nzB")).unloadBranches; });
$parcel$export(module.exports, "FETCH_DEFAULT_COMMIT_MESSAGE", function () { return (parcelRequire("28cQM")).FETCH_DEFAULT_COMMIT_MESSAGE; });
$parcel$export(module.exports, "fetchDefaultCommitMessage", function () { return (parcelRequire("28cQM")).fetchDefaultCommitMessage; });
$parcel$export(module.exports, "closeCompareBranchesDialog", function () { return (parcelRequire("exHB3")).closeCompareBranchesDialog; });
$parcel$export(module.exports, "COMPARE_BRANCHES", function () { return (parcelRequire("exHB3")).COMPARE_BRANCHES; });
$parcel$export(module.exports, "COMPARE_BRANCHES_DIALOG", function () { return (parcelRequire("exHB3")).COMPARE_BRANCHES_DIALOG; });
$parcel$export(module.exports, "COMPARE_BRANCHES_POLL_STATUS", function () { return (parcelRequire("exHB3")).COMPARE_BRANCHES_POLL_STATUS; });
$parcel$export(module.exports, "COMPARE_BRANCHES_POLL_STATUS_TIMEOUT", function () { return (parcelRequire("exHB3")).COMPARE_BRANCHES_POLL_STATUS_TIMEOUT; });
$parcel$export(module.exports, "compareBranches", function () { return (parcelRequire("exHB3")).compareBranches; });
$parcel$export(module.exports, "compareBranchesPollStatus", function () { return (parcelRequire("exHB3")).compareBranchesPollStatus; });
$parcel$export(module.exports, "openMergeBranchDialog", function () { return (parcelRequire("exHB3")).openMergeBranchDialog; });
$parcel$export(module.exports, "openSyncBranchDialog", function () { return (parcelRequire("exHB3")).openSyncBranchDialog; });
$parcel$export(module.exports, "closeDeleteBranchDialog", function () { return (parcelRequire("1ElOF")).closeDeleteBranchDialog; });
$parcel$export(module.exports, "DELETE_BRANCH", function () { return (parcelRequire("1ElOF")).DELETE_BRANCH; });
$parcel$export(module.exports, "DELETE_BRANCH_DIALOG", function () { return (parcelRequire("1ElOF")).DELETE_BRANCH_DIALOG; });
$parcel$export(module.exports, "DELETE_BRANCH_PAGE", function () { return (parcelRequire("1ElOF")).DELETE_BRANCH_PAGE; });
$parcel$export(module.exports, "deleteBranch", function () { return (parcelRequire("1ElOF")).deleteBranch; });
$parcel$export(module.exports, "openDeleteBranchDialog", function () { return (parcelRequire("1ElOF")).openDeleteBranchDialog; });
$parcel$export(module.exports, "BULK_DELETE_BRANCHES", function () { return (parcelRequire("k2UuV")).BULK_DELETE_BRANCHES; });
$parcel$export(module.exports, "BULK_DELETE_BRANCHES_DIALOG", function () { return (parcelRequire("k2UuV")).BULK_DELETE_BRANCHES_DIALOG; });
$parcel$export(module.exports, "bulkDeleteBranches", function () { return (parcelRequire("k2UuV")).bulkDeleteBranches; });
$parcel$export(module.exports, "clearSelectedBranches", function () { return (parcelRequire("k2UuV")).clearSelectedBranches; });
$parcel$export(module.exports, "closeBulkDeleteBranchesDialog", function () { return (parcelRequire("k2UuV")).closeBulkDeleteBranchesDialog; });
$parcel$export(module.exports, "onToggleBranchSelect", function () { return (parcelRequire("k2UuV")).onToggleBranchSelect; });
$parcel$export(module.exports, "onToggleBranchSelectAllInPage", function () { return (parcelRequire("k2UuV")).onToggleBranchSelectAllInPage; });
$parcel$export(module.exports, "onToggleBranchSelectSave", function () { return (parcelRequire("k2UuV")).onToggleBranchSelectSave; });
$parcel$export(module.exports, "onToggleBulkDeleteSelectionMode", function () { return (parcelRequire("k2UuV")).onToggleBulkDeleteSelectionMode; });
$parcel$export(module.exports, "openBulkDeleteBranchesDialog", function () { return (parcelRequire("k2UuV")).openBulkDeleteBranchesDialog; });
$parcel$export(module.exports, "TOGGLE_BRANCH_SELECT", function () { return (parcelRequire("k2UuV")).TOGGLE_BRANCH_SELECT; });
$parcel$export(module.exports, "TOGGLE_SELECTION_MODE", function () { return (parcelRequire("k2UuV")).TOGGLE_SELECTION_MODE; });
parcelRequire("j7nzB");
parcelRequire("28cQM");
parcelRequire("exHB3");
parcelRequire("1ElOF");
parcelRequire("k2UuV");

});
parcelRegister("j7nzB", function(module, exports) {

$parcel$export(module.exports, "LOAD_MAIN_BRANCH", function () { return $ce5dc4ef5587be59$export$a5fec13c4364da7; });
$parcel$export(module.exports, "loadMainBranch", function () { return $ce5dc4ef5587be59$export$6d1bd10ef4a7ea1e; });
$parcel$export(module.exports, "LOAD_BRANCHING_MODEL", function () { return $ce5dc4ef5587be59$export$892641cc7464a183; });
$parcel$export(module.exports, "loadBranchingModel", function () { return $ce5dc4ef5587be59$export$ee0b14f175b1a3c1; });
$parcel$export(module.exports, "LOAD_BRANCHES", function () { return $ce5dc4ef5587be59$export$40ac7d66ca4f84fe; });
$parcel$export(module.exports, "loadBranches", function () { return $ce5dc4ef5587be59$export$57a548695dab252f; });
$parcel$export(module.exports, "RELOAD_BRANCHES", function () { return $ce5dc4ef5587be59$export$d9255684ba343a7d; });
$parcel$export(module.exports, "reloadBranches", function () { return $ce5dc4ef5587be59$export$6bc73dd5a8cc047a; });
$parcel$export(module.exports, "UNLOAD_BRANCHES", function () { return $ce5dc4ef5587be59$export$e345b5244fcf4002; });
$parcel$export(module.exports, "unloadBranches", function () { return $ce5dc4ef5587be59$export$772757f29d688c14; });

var $cJH1T = parcelRequire("cJH1T");
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
var $fICwP = parcelRequire("fICwP");

var $kZnTB = parcelRequire("kZnTB");

var $5JXyS = parcelRequire("5JXyS");

var $e4CY6 = parcelRequire("e4CY6");
const $ce5dc4ef5587be59$var$queryFields = [
    "-values.target.author.user.account_id",
    "+values.pullrequest.state",
    "+values.pullrequest.created_on",
    "+values.pullrequests.state",
    "+values.pullrequests.created_on",
    "+values.pullrequests.closed_on",
    "-values.statuses",
    "+values.default_merge_strategy",
    "+values.merge_strategies",
    "+values.sync_strategies"
].join(",");
const $ce5dc4ef5587be59$export$a5fec13c4364da7 = (0, $2MctD.createAsyncAction)((0, $e4CY6.prefixed)("LOAD_MAIN_BRANCH"));
const $ce5dc4ef5587be59$export$6d1bd10ef4a7ea1e = (options)=>{
    const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug, name: name } = options;
    const query = (0, $cJH1T.stringify)({
        branch: name,
        fields: $ce5dc4ef5587be59$var$queryFields
    });
    const url = `${(0, $kZnTB.default).api.internal.branchList(repositoryOwner, repositorySlug)}?${query}`;
    const schema = {
        values: [
            (0, $5JXyS.branch)
        ]
    };
    return (0, $fICwP.fetchAction)($ce5dc4ef5587be59$export$a5fec13c4364da7, {
        url: url,
        schema: schema
    });
};
const $ce5dc4ef5587be59$export$892641cc7464a183 = (0, $2MctD.createAsyncAction)((0, $e4CY6.prefixed)("LOAD_BRANCHING_MODEL"));
const $ce5dc4ef5587be59$export$ee0b14f175b1a3c1 = (options)=>{
    const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug } = options;
    const url = (0, $kZnTB.default).api.v20.branchingModel(repositoryOwner, repositorySlug);
    return (0, $fICwP.fetchAction)($ce5dc4ef5587be59$export$892641cc7464a183, {
        url: url
    });
};
const $ce5dc4ef5587be59$export$40ac7d66ca4f84fe = (0, $2MctD.createAsyncAction)((0, $e4CY6.prefixed)("LOAD_BRANCHES"));
const $ce5dc4ef5587be59$export$57a548695dab252f = (options)=>{
    const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug } = options;
    const { sort: sort, page: page, bbql: bbql, pagelen: pagelen } = options;
    const query = (0, $cJH1T.stringify)({
        sort: sort,
        page: page,
        q: bbql,
        pagelen: pagelen,
        fields: $ce5dc4ef5587be59$var$queryFields
    }, {
        skipNulls: true
    });
    const url = `${(0, $kZnTB.default).api.internal.branchList(repositoryOwner, repositorySlug)}?${query}`;
    const schema = {
        values: [
            (0, $5JXyS.branch)
        ]
    };
    return (0, $fICwP.fetchAction)($ce5dc4ef5587be59$export$40ac7d66ca4f84fe, {
        url: url,
        schema: schema
    });
};
const $ce5dc4ef5587be59$export$d9255684ba343a7d = (0, $e4CY6.prefixed)("RELOAD_BRANCHES");
const $ce5dc4ef5587be59$export$6bc73dd5a8cc047a = (url)=>{
    const schema = {
        values: [
            (0, $5JXyS.branch)
        ]
    };
    return (0, $fICwP.fetchAction)($ce5dc4ef5587be59$export$40ac7d66ca4f84fe, {
        url: url,
        schema: schema
    });
};
const $ce5dc4ef5587be59$export$e345b5244fcf4002 = (0, $e4CY6.prefixed)("UNLOAD_BRANCHES");
const $ce5dc4ef5587be59$export$772757f29d688c14 = ()=>({
        type: $ce5dc4ef5587be59$export$e345b5244fcf4002
    });

});
parcelRegister("5JXyS", function(module, exports) {

$parcel$export(module.exports, "branch", function () { return $15f32f702b84828d$export$7b927fb32d8824c0; });

var $km2sU = parcelRequire("km2sU");

var $ga67g = parcelRequire("ga67g");
const $15f32f702b84828d$export$7b927fb32d8824c0 = new (0, $ga67g.schema).Entity("branches", {}, {
    idAttribute: (entity)=>entity.links.self.href,
    processStrategy: (entity)=>{
        return (0, $km2sU.default)({
            ...entity,
            isMainBranch: entity.ismainbranch,
            pullRequests: entity.pullrequests,
            commitStatuses: entity.statuses,
            pullRequestsTargetedCount: entity.pullrequests_targeted_count
        }, [
            "statuses",
            "pullrequests",
            "ismainbranch",
            "pullrequests_targeted_count"
        ]);
    }
});
$15f32f702b84828d$export$7b927fb32d8824c0.define({});

});
parcelRegister("km2sU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed17c640bc1f5a28$export$2e2bcd8739ae039; });

var $6t2MQ = parcelRequire("6t2MQ");

var $5Ng8I = parcelRequire("5Ng8I");

var $i5tt5 = parcelRequire("i5tt5");

var $8AUEA = parcelRequire("8AUEA");

var $bSXSS = parcelRequire("bSXSS");

var $8iUaL = parcelRequire("8iUaL");

var $4MOgk = parcelRequire("4MOgk");

var $kksWN = parcelRequire("kksWN");
/** Used to compose bitmasks for cloning. */ var $ed17c640bc1f5a28$var$CLONE_DEEP_FLAG = 1, $ed17c640bc1f5a28$var$CLONE_FLAT_FLAG = 2, $ed17c640bc1f5a28$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $ed17c640bc1f5a28$var$omit = (0, $4MOgk.default)(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = (0, $6t2MQ.default)(paths, function(path) {
        path = (0, $8AUEA.default)(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    (0, $bSXSS.default)(object, (0, $kksWN.default)(object), result);
    if (isDeep) result = (0, $5Ng8I.default)(result, $ed17c640bc1f5a28$var$CLONE_DEEP_FLAG | $ed17c640bc1f5a28$var$CLONE_FLAT_FLAG | $ed17c640bc1f5a28$var$CLONE_SYMBOLS_FLAG, (0, $8iUaL.default));
    var length = paths.length;
    while(length--)(0, $i5tt5.default)(result, paths[length]);
    return result;
});
var $ed17c640bc1f5a28$export$2e2bcd8739ae039 = $ed17c640bc1f5a28$var$omit;

});
parcelRegister("i5tt5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2af8d5e2d6317f6$export$2e2bcd8739ae039; });

var $8AUEA = parcelRequire("8AUEA");

var $jrmDy = parcelRequire("jrmDy");

var $jKatU = parcelRequire("jKatU");

var $bZfWj = parcelRequire("bZfWj");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $d2af8d5e2d6317f6$var$baseUnset(object, path) {
    path = (0, $8AUEA.default)(path, object);
    object = (0, $jKatU.default)(object, path);
    return object == null || delete object[(0, $bZfWj.default)((0, $jrmDy.default)(path))];
}
var $d2af8d5e2d6317f6$export$2e2bcd8739ae039 = $d2af8d5e2d6317f6$var$baseUnset;

});
parcelRegister("jrmDy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e27219259a2305d8$export$2e2bcd8739ae039; });
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $e27219259a2305d8$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
var $e27219259a2305d8$export$2e2bcd8739ae039 = $e27219259a2305d8$var$last;

});

parcelRegister("jKatU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5fa7195d0fcfb48$export$2e2bcd8739ae039; });

var $fVuMG = parcelRequire("fVuMG");

var $6pCwL = parcelRequire("6pCwL");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $e5fa7195d0fcfb48$var$parent(object, path) {
    return path.length < 2 ? object : (0, $fVuMG.default)(object, (0, $6pCwL.default)(path, 0, -1));
}
var $e5fa7195d0fcfb48$export$2e2bcd8739ae039 = $e5fa7195d0fcfb48$var$parent;

});


parcelRegister("8iUaL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60bb93e3b03d6e2d$export$2e2bcd8739ae039; });

var $4vOvC = parcelRequire("4vOvC");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $60bb93e3b03d6e2d$var$customOmitClone(value) {
    return (0, $4vOvC.default)(value) ? undefined : value;
}
var $60bb93e3b03d6e2d$export$2e2bcd8739ae039 = $60bb93e3b03d6e2d$var$customOmitClone;

});

parcelRegister("4MOgk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37c2a231d619011f$export$2e2bcd8739ae039; });

var $7RHHu = parcelRequire("7RHHu");

var $4nRoL = parcelRequire("4nRoL");

var $5ZD1t = parcelRequire("5ZD1t");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $37c2a231d619011f$var$flatRest(func) {
    return (0, $5ZD1t.default)((0, $4nRoL.default)(func, undefined, (0, $7RHHu.default)), func + "");
}
var $37c2a231d619011f$export$2e2bcd8739ae039 = $37c2a231d619011f$var$flatRest;

});



parcelRegister("e4CY6", function(module, exports) {

$parcel$export(module.exports, "prefixed", function () { return $e753c3731e436e63$export$302158222cd49bab; });
const $e753c3731e436e63$export$302158222cd49bab = (action)=>`branches/${action}`;

});


parcelRegister("28cQM", function(module, exports) {

$parcel$export(module.exports, "FETCH_DEFAULT_COMMIT_MESSAGE", function () { return $cf095bfc5c585c1d$export$d4b38c7385eca96; });
$parcel$export(module.exports, "fetchDefaultCommitMessage", function () { return $cf095bfc5c585c1d$export$f458129ee33bea4e; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");

var $e4CY6 = parcelRequire("e4CY6");
const $cf095bfc5c585c1d$export$d4b38c7385eca96 = (0, $2MctD.createAsyncAction)((0, $e4CY6.prefixed)("FETCH_DEFAULT_COMMIT_MESSAGE"));
const $cf095bfc5c585c1d$export$f458129ee33bea4e = (payload)=>({
        type: $cf095bfc5c585c1d$export$d4b38c7385eca96.REQUEST,
        payload: payload
    });

});

parcelRegister("exHB3", function(module, exports) {

$parcel$export(module.exports, "COMPARE_BRANCHES", function () { return $4985404bede643e5$export$fa7d6850340949de; });
$parcel$export(module.exports, "compareBranches", function () { return $4985404bede643e5$export$dc407486c77c7826; });
$parcel$export(module.exports, "COMPARE_BRANCHES_POLL_STATUS", function () { return $4985404bede643e5$export$262d0bc5976973a6; });
$parcel$export(module.exports, "COMPARE_BRANCHES_POLL_STATUS_TIMEOUT", function () { return $4985404bede643e5$export$8b1cada7d9477a42; });
$parcel$export(module.exports, "compareBranchesPollStatus", function () { return $4985404bede643e5$export$a1a9fe55741c27dc; });
$parcel$export(module.exports, "COMPARE_BRANCHES_DIALOG", function () { return $4985404bede643e5$export$96477d718adbc436; });
$parcel$export(module.exports, "closeCompareBranchesDialog", function () { return $4985404bede643e5$export$a4d37953e90a6dc1; });
$parcel$export(module.exports, "openSyncBranchDialog", function () { return $4985404bede643e5$export$eb4afb219744c778; });
$parcel$export(module.exports, "openMergeBranchDialog", function () { return $4985404bede643e5$export$9cf3428a156a6ba; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");

var $e4CY6 = parcelRequire("e4CY6");
const $4985404bede643e5$export$fa7d6850340949de = (0, $2MctD.createAsyncAction)((0, $e4CY6.prefixed)("COMPARE_BRANCHES"));
const $4985404bede643e5$export$dc407486c77c7826 = (payload)=>({
        type: $4985404bede643e5$export$fa7d6850340949de.REQUEST,
        payload: payload
    });
const $4985404bede643e5$export$262d0bc5976973a6 = (0, $2MctD.createAsyncAction)((0, $e4CY6.prefixed)("COMPARE_BRANCHES_POLL_STATUS"));
const $4985404bede643e5$export$8b1cada7d9477a42 = "COMPARE_BRANCHES_POLL_STATUS_TIMEOUT";
const $4985404bede643e5$export$a1a9fe55741c27dc = (payload)=>({
        type: $4985404bede643e5$export$262d0bc5976973a6.REQUEST,
        payload: payload
    });
const $4985404bede643e5$export$96477d718adbc436 = {
    OPEN: (0, $e4CY6.prefixed)("OPEN_COMPARE_BRANCHES_DIALOG"),
    CLOSE: (0, $e4CY6.prefixed)("CLOSE_COMPARE_BRANCHES_DIALOG")
};
const $4985404bede643e5$export$a4d37953e90a6dc1 = ()=>({
        type: $4985404bede643e5$export$96477d718adbc436.CLOSE
    });
const $4985404bede643e5$export$eb4afb219744c778 = (options)=>({
        type: $4985404bede643e5$export$96477d718adbc436.OPEN,
        payload: {
            isMerge: false,
            ...options
        }
    });
const $4985404bede643e5$export$9cf3428a156a6ba = (options)=>({
        type: $4985404bede643e5$export$96477d718adbc436.OPEN,
        payload: {
            isMerge: true,
            ...options
        }
    });

});

parcelRegister("1ElOF", function(module, exports) {

$parcel$export(module.exports, "DELETE_BRANCH_DIALOG", function () { return $86218c6f6f94f57a$export$35a465668285d3b3; });
$parcel$export(module.exports, "openDeleteBranchDialog", function () { return $86218c6f6f94f57a$export$9495083e3d21013d; });
$parcel$export(module.exports, "closeDeleteBranchDialog", function () { return $86218c6f6f94f57a$export$f57b4a834afea8e1; });
$parcel$export(module.exports, "DELETE_BRANCH", function () { return $86218c6f6f94f57a$export$d5a12c5e8666c849; });
$parcel$export(module.exports, "deleteBranch", function () { return $86218c6f6f94f57a$export$3bcbbe78488f4be6; });
$parcel$export(module.exports, "DELETE_BRANCH_PAGE", function () { return $86218c6f6f94f57a$export$500357d71a0a0754; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");

var $e4CY6 = parcelRequire("e4CY6");
const $86218c6f6f94f57a$export$35a465668285d3b3 = {
    OPEN: (0, $e4CY6.prefixed)("OPEN_DELETE_BRANCH_DIALOG"),
    CLOSE: (0, $e4CY6.prefixed)("CLOSE_DELETE_BRANCH_DIALOG")
};
const $86218c6f6f94f57a$export$9495083e3d21013d = (branchName)=>({
        type: $86218c6f6f94f57a$export$35a465668285d3b3.OPEN,
        payload: {
            branchName: branchName
        }
    });
const $86218c6f6f94f57a$export$f57b4a834afea8e1 = ()=>({
        type: $86218c6f6f94f57a$export$35a465668285d3b3.CLOSE
    });
const $86218c6f6f94f57a$export$d5a12c5e8666c849 = (0, $2MctD.createAsyncAction)((0, $e4CY6.prefixed)("DELETE_BRANCH"));
const $86218c6f6f94f57a$export$3bcbbe78488f4be6 = ()=>({
        type: $86218c6f6f94f57a$export$d5a12c5e8666c849.REQUEST
    });
const $86218c6f6f94f57a$export$500357d71a0a0754 = (0, $2MctD.createAsyncAction)((0, $e4CY6.prefixed)("DELETE_BRANCH_PAGE"));
const $86218c6f6f94f57a$export$41acc62fa8a31d6f = ()=>({
        type: $86218c6f6f94f57a$export$500357d71a0a0754.REQUEST
    });

});

parcelRegister("k2UuV", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_BRANCH_SELECT", function () { return $ff935821b889eac5$export$228ec9ae10aefa06; });
$parcel$export(module.exports, "onToggleBranchSelect", function () { return $ff935821b889eac5$export$77cc5edd94c86d0b; });
$parcel$export(module.exports, "onToggleBranchSelectAllInPage", function () { return $ff935821b889eac5$export$f87f7ed67aaa79f; });
$parcel$export(module.exports, "onToggleBranchSelectSave", function () { return $ff935821b889eac5$export$232a3f4bf30c5203; });
$parcel$export(module.exports, "clearSelectedBranches", function () { return $ff935821b889eac5$export$dbb63d96aa2cf253; });
$parcel$export(module.exports, "TOGGLE_SELECTION_MODE", function () { return $ff935821b889eac5$export$e6440edd2254aced; });
$parcel$export(module.exports, "onToggleBulkDeleteSelectionMode", function () { return $ff935821b889eac5$export$8afa1a44030721b4; });
$parcel$export(module.exports, "BULK_DELETE_BRANCHES_DIALOG", function () { return $ff935821b889eac5$export$6d3882559b4bef4c; });
$parcel$export(module.exports, "openBulkDeleteBranchesDialog", function () { return $ff935821b889eac5$export$6fc470c6ffbe80f9; });
$parcel$export(module.exports, "closeBulkDeleteBranchesDialog", function () { return $ff935821b889eac5$export$9383ad019c72fadd; });
$parcel$export(module.exports, "BULK_DELETE_BRANCHES", function () { return $ff935821b889eac5$export$ee96c3b041b4c232; });
$parcel$export(module.exports, "bulkDeleteBranches", function () { return $ff935821b889eac5$export$2fc9ab9592f664da; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");

var $e4CY6 = parcelRequire("e4CY6");
const $ff935821b889eac5$export$228ec9ae10aefa06 = {
    ONE: (0, $e4CY6.prefixed)("TOGGLE_BRANCH_SELECT_ONE"),
    ALL_IN_PAGE: (0, $e4CY6.prefixed)("TOGGLE_BRANCH_SELECT_ALL_IN_PAGE"),
    SAVE: (0, $e4CY6.prefixed)("TOGGLE_BRANCH_SELECT_SAVE")
};
const $ff935821b889eac5$export$77cc5edd94c86d0b = (payload)=>({
        type: $ff935821b889eac5$export$228ec9ae10aefa06.ONE,
        payload: payload
    });
const $ff935821b889eac5$export$f87f7ed67aaa79f = (isSelected)=>({
        type: $ff935821b889eac5$export$228ec9ae10aefa06.ALL_IN_PAGE,
        payload: isSelected
    });
const $ff935821b889eac5$export$232a3f4bf30c5203 = (branches)=>({
        type: $ff935821b889eac5$export$228ec9ae10aefa06.SAVE,
        payload: branches
    });
const $ff935821b889eac5$export$dbb63d96aa2cf253 = ()=>({
        type: $ff935821b889eac5$export$228ec9ae10aefa06.SAVE,
        payload: []
    });
const $ff935821b889eac5$export$e6440edd2254aced = (0, $e4CY6.prefixed)("TOGGLE_SELECTION_MODE");
const $ff935821b889eac5$export$8afa1a44030721b4 = (isSelectionMode)=>({
        type: $ff935821b889eac5$export$e6440edd2254aced,
        payload: isSelectionMode
    });
const $ff935821b889eac5$export$6d3882559b4bef4c = {
    OPEN: (0, $e4CY6.prefixed)("BULK_DELETE_BRANCHES_DIALOG_OPEN"),
    CLOSE: (0, $e4CY6.prefixed)("BULK_DELETE_BRANCHES_DIALOG_CLOSE")
};
const $ff935821b889eac5$export$6fc470c6ffbe80f9 = (stale)=>({
        type: $ff935821b889eac5$export$6d3882559b4bef4c.OPEN,
        payload: stale
    });
const $ff935821b889eac5$export$9383ad019c72fadd = ()=>({
        type: $ff935821b889eac5$export$6d3882559b4bef4c.CLOSE
    });
const $ff935821b889eac5$export$ee96c3b041b4c232 = (0, $2MctD.createAsyncAction)((0, $e4CY6.prefixed)("BULK_DELETE_BRANCHES"));
const $ff935821b889eac5$export$2fc9ab9592f664da = ()=>({
        type: $ff935821b889eac5$export$ee96c3b041b4c232.REQUEST
    });

});


parcelRegister("2Nc6d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8682167db2047f27$export$2e2bcd8739ae039; });

var $jF3Yx = parcelRequire("jF3Yx");

var $hNx7o = parcelRequire("hNx7o");

var $gbtN5 = parcelRequire("gbtN5");

var $21Kq1 = parcelRequire("21Kq1");

var $pUQWs = parcelRequire("pUQWs");
const $8682167db2047f27$export$d4c72bab9d6cc13a = {
    branchList: (0, $hNx7o.initialState),
    deleteBranchDialog: (0, $pUQWs.initialState),
    compareBranchesDialog: (0, $21Kq1.initialState),
    bulkDeleteBranches: (0, $gbtN5.initialState)
};
var $8682167db2047f27$export$2e2bcd8739ae039 = (0, $jF3Yx.combineReducers)({
    branchList: (0, $hNx7o.default),
    deleteBranchDialog: (0, $pUQWs.default),
    compareBranchesDialog: (0, $21Kq1.default),
    bulkDeleteBranches: (0, $gbtN5.default)
});

});
parcelRegister("hNx7o", function(module, exports) {

$parcel$export(module.exports, "initialState", function () { return $1fbbe80665a993d6$export$d4c72bab9d6cc13a; });
$parcel$export(module.exports, "default", function () { return $1fbbe80665a993d6$export$2e2bcd8739ae039; });

var $gsXeO = parcelRequire("gsXeO");
parcelRequire("fe3Mu");
var $j7nzB = parcelRequire("j7nzB");
const $1fbbe80665a993d6$export$d4c72bab9d6cc13a = {
    branchingModel: {
        branchTypes: [],
        production: null,
        development: null,
        isLoading: false
    },
    mainBranch: {
        branch: null,
        isLoading: true
    },
    listItems: {
        reloadUrl: null,
        size: 0,
        pageLength: 0,
        branches: [],
        isLoading: false
    },
    isError: false
};
var $1fbbe80665a993d6$export$2e2bcd8739ae039 = (0, $gsXeO.default)($1fbbe80665a993d6$export$d4c72bab9d6cc13a, {
    [(0, $j7nzB.LOAD_MAIN_BRANCH).REQUEST] (state) {
        return {
            ...state,
            mainBranch: {
                ...state.mainBranch,
                isLoading: true
            }
        };
    },
    [(0, $j7nzB.LOAD_MAIN_BRANCH).SUCCESS] (state, action) {
        const [branch] = action.payload.result.values;
        return {
            ...state,
            mainBranch: {
                ...state.mainBranch,
                isLoading: false,
                branch: branch
            }
        };
    },
    [(0, $j7nzB.LOAD_MAIN_BRANCH).ERROR] (state) {
        return {
            ...state,
            isError: true,
            mainBranch: {
                ...state.mainBranch,
                isLoading: false
            }
        };
    },
    [(0, $j7nzB.LOAD_BRANCHING_MODEL).REQUEST] (state) {
        return {
            ...state,
            branchingModel: {
                ...state.branchingModel,
                branchTypes: [],
                production: null,
                development: null,
                isLoading: true
            }
        };
    },
    [(0, $j7nzB.LOAD_BRANCHING_MODEL).SUCCESS] (state, action) {
        const { branch_types: branchTypes, production: production, development: development } = action.payload;
        const devBranch = development && development.branch && {
            ...development.branch,
            use_mainbranch: development.use_mainbranch
        };
        const prodBranch = production && production.branch && {
            ...production.branch,
            use_mainbranch: production.use_mainbranch
        };
        return {
            ...state,
            branchingModel: {
                ...state.branchingModel,
                branchTypes: branchTypes,
                development: devBranch || null,
                production: prodBranch || null,
                isLoading: false
            }
        };
    },
    [(0, $j7nzB.LOAD_BRANCHING_MODEL).ERROR] (state) {
        return {
            ...state,
            branchingModel: {
                ...state.branchingModel,
                branchTypes: [],
                production: null,
                development: null,
                isLoading: false
            }
        };
    },
    [(0, $j7nzB.LOAD_BRANCHES).REQUEST] (state, action) {
        const { url: url } = action.meta;
        return {
            ...state,
            isError: false,
            listItems: {
                ...state.listItems,
                ...url && {
                    reloadUrl: url
                },
                isLoading: true
            }
        };
    },
    [(0, $j7nzB.LOAD_BRANCHES).SUCCESS] (state, action) {
        const { values: branches, size: size, pagelen: pageLength } = action.payload.result;
        return {
            ...state,
            listItems: {
                ...state.listItems,
                size: size,
                pageLength: pageLength,
                branches: branches,
                isLoading: false
            }
        };
    },
    [(0, $j7nzB.LOAD_BRANCHES).ERROR] (state) {
        return {
            ...state,
            isError: true,
            listItems: {
                ...state.listItems,
                isLoading: false
            }
        };
    },
    [(0, $j7nzB.UNLOAD_BRANCHES)] () {
        return $1fbbe80665a993d6$export$d4c72bab9d6cc13a;
    }
});

});

parcelRegister("gbtN5", function(module, exports) {

$parcel$export(module.exports, "LoadingStatus", function () { return $3a7618ac709388cb$export$19d37de7e9a4af59; });
$parcel$export(module.exports, "initialState", function () { return $3a7618ac709388cb$export$d4c72bab9d6cc13a; });
$parcel$export(module.exports, "default", function () { return $3a7618ac709388cb$export$2e2bcd8739ae039; });

var $gsXeO = parcelRequire("gsXeO");
parcelRequire("fe3Mu");
var $k2UuV = parcelRequire("k2UuV");
var $3a7618ac709388cb$export$19d37de7e9a4af59;
(function(LoadingStatus) {
    LoadingStatus["Before"] = "BEFORE";
    LoadingStatus["Loading"] = "LOADING";
    LoadingStatus["Success"] = "SUCCESS";
    LoadingStatus["Failed"] = "FAILED";
})($3a7618ac709388cb$export$19d37de7e9a4af59 || ($3a7618ac709388cb$export$19d37de7e9a4af59 = {}));
const $3a7618ac709388cb$export$d4c72bab9d6cc13a = {
    selectedBranches: [],
    isInSelectionMode: false,
    isBulkDeleteBranchesDialogOpen: false,
    stale: false,
    bulkDeleteBranchesStatus: "BEFORE"
};
var $3a7618ac709388cb$export$2e2bcd8739ae039 = (0, $gsXeO.default)($3a7618ac709388cb$export$d4c72bab9d6cc13a, {
    [(0, $k2UuV.TOGGLE_BRANCH_SELECT).SAVE] (state, { payload: selectedBranches }) {
        return {
            ...state,
            selectedBranches: selectedBranches
        };
    },
    [(0, $k2UuV.TOGGLE_SELECTION_MODE)] (state, { payload: isSelected }) {
        return {
            ...state,
            isInSelectionMode: isSelected,
            selectedBranches: isSelected ? state.selectedBranches : []
        };
    },
    [(0, $k2UuV.BULK_DELETE_BRANCHES_DIALOG).OPEN] (state, { payload: stale }) {
        return {
            ...state,
            isBulkDeleteBranchesDialogOpen: true,
            stale: stale
        };
    },
    [(0, $k2UuV.BULK_DELETE_BRANCHES_DIALOG).CLOSE] (state) {
        return {
            ...state,
            isBulkDeleteBranchesDialogOpen: false
        };
    },
    [(0, $k2UuV.BULK_DELETE_BRANCHES).REQUEST] (state) {
        return {
            ...state,
            bulkDeleteBranchesStatus: "LOADING"
        };
    },
    [(0, $k2UuV.BULK_DELETE_BRANCHES).SUCCESS] (state) {
        return {
            ...state,
            bulkDeleteBranchesStatus: "SUCCESS"
        };
    },
    [(0, $k2UuV.BULK_DELETE_BRANCHES).ERROR] (state) {
        return {
            ...state,
            bulkDeleteBranchesStatus: "FAILED"
        };
    }
});

});

parcelRegister("21Kq1", function(module, exports) {

$parcel$export(module.exports, "initialState", function () { return $c3023fc4e3998273$export$d4c72bab9d6cc13a; });
$parcel$export(module.exports, "default", function () { return $c3023fc4e3998273$export$2e2bcd8739ae039; });

var $gsXeO = parcelRequire("gsXeO");
parcelRequire("fe3Mu");
var $exHB3 = parcelRequire("exHB3");
var $28cQM = parcelRequire("28cQM");
const $c3023fc4e3998273$export$d4c72bab9d6cc13a = {
    isOpen: false,
    sourceBranchName: null,
    destinationBranchName: null,
    sourceRepositoryFullName: null,
    destinationRepositoryFullName: null,
    defaultCommitMessage: "",
    isLoading: false,
    isMerge: false,
    errorMessage: null,
    reloadAction: null,
    renderFlagOnSuccess: true,
    canDeleteSourceBranch: false
};
var $c3023fc4e3998273$export$2e2bcd8739ae039 = (0, $gsXeO.default)($c3023fc4e3998273$export$d4c72bab9d6cc13a, {
    [(0, $exHB3.COMPARE_BRANCHES_DIALOG).OPEN] (_, action) {
        const { sourceBranchName: sourceBranchName, destinationBranchName: destinationBranchName, sourceRepositoryFullName: sourceRepositoryFullName, destinationRepositoryFullName: destinationRepositoryFullName, isMerge: isMerge, reloadAction: reloadAction, renderFlagOnSuccess: renderFlagOnSuccess, canDeleteSourceBranch: canDeleteSourceBranch } = action.payload;
        return {
            isOpen: true,
            defaultCommitMessage: "",
            isLoading: false,
            sourceBranchName: sourceBranchName,
            destinationBranchName: destinationBranchName,
            sourceRepositoryFullName: sourceRepositoryFullName,
            destinationRepositoryFullName: destinationRepositoryFullName,
            isMerge: isMerge,
            errorMessage: null,
            reloadAction: reloadAction,
            canDeleteSourceBranch: canDeleteSourceBranch || false,
            renderFlagOnSuccess: renderFlagOnSuccess !== undefined ? renderFlagOnSuccess : true
        };
    },
    [(0, $exHB3.COMPARE_BRANCHES).REQUEST] (state) {
        return {
            ...state,
            isLoading: true
        };
    },
    [(0, $exHB3.COMPARE_BRANCHES_POLL_STATUS).ERROR] (state, action) {
        return {
            ...state,
            errorMessage: action.payload
        };
    },
    [(0, $28cQM.FETCH_DEFAULT_COMMIT_MESSAGE).REQUEST] (state) {
        return {
            ...state,
            defaultCommitMessage: ""
        };
    },
    [(0, $28cQM.FETCH_DEFAULT_COMMIT_MESSAGE).SUCCESS] (state, action) {
        return {
            ...state,
            defaultCommitMessage: action.payload
        };
    },
    [(0, $exHB3.COMPARE_BRANCHES_DIALOG).CLOSE] (state) {
        return {
            ...state,
            isOpen: false
        };
    }
});

});

parcelRegister("pUQWs", function(module, exports) {

$parcel$export(module.exports, "DeleteBranchErrorTypes", function () { return $5de7185adf9a381a$export$bef492f2d79f91db; });
$parcel$export(module.exports, "initialState", function () { return $5de7185adf9a381a$export$d4c72bab9d6cc13a; });
$parcel$export(module.exports, "default", function () { return $5de7185adf9a381a$export$2e2bcd8739ae039; });

var $gsXeO = parcelRequire("gsXeO");
parcelRequire("fe3Mu");
var $1ElOF = parcelRequire("1ElOF");
const $5de7185adf9a381a$export$bef492f2d79f91db = {
    ACCESS_DENIED: "ACCESS_DENIED",
    BRANCH_NOT_FOUND: "BRANCH_NOT_FOUND",
    GENERIC: "GENERIC"
};
const $5de7185adf9a381a$export$d4c72bab9d6cc13a = {
    branchName: "",
    isOpen: false,
    isDeleting: false,
    successFlag: {
        branchName: null
    },
    errorFlag: {
        branchName: null,
        errorType: null
    }
};
var $5de7185adf9a381a$export$2e2bcd8739ae039 = (0, $gsXeO.default)($5de7185adf9a381a$export$d4c72bab9d6cc13a, {
    [(0, $1ElOF.DELETE_BRANCH_DIALOG).OPEN] (state, action) {
        const { branchName: branchName } = action.payload;
        return {
            ...state,
            branchName: branchName,
            isOpen: true
        };
    },
    [(0, $1ElOF.DELETE_BRANCH_DIALOG).CLOSE] (state) {
        return {
            ...state,
            isOpen: false,
            branch: null
        };
    },
    [(0, $1ElOF.DELETE_BRANCH).REQUEST] (state) {
        return {
            ...state,
            isDeleting: true
        };
    },
    [(0, $1ElOF.DELETE_BRANCH).SUCCESS] (state, action) {
        const { branchName: branchName } = action.payload;
        return {
            ...state,
            isOpen: false,
            isDeleting: false,
            successFlag: {
                ...state.successFlag,
                branchName: branchName
            }
        };
    },
    [(0, $1ElOF.DELETE_BRANCH).ERROR] (state, action) {
        const { branchName: branchName, errorType: errorType } = action.payload;
        return {
            ...state,
            isOpen: false,
            isDeleting: false,
            errorFlag: {
                ...state.errorFlag,
                branchName: branchName,
                errorType: errorType
            }
        };
    },
    [(0, $1ElOF.DELETE_BRANCH_PAGE).REQUEST] (state) {
        return {
            ...state,
            isDeleting: true
        };
    },
    [(0, $1ElOF.DELETE_BRANCH_PAGE).SUCCESS] (state, action) {
        const { branchName: branchName } = action.payload;
        return {
            ...state,
            isOpen: false,
            isDeleting: false,
            successFlag: {
                ...state.successFlag,
                branchName: branchName
            }
        };
    },
    [(0, $1ElOF.DELETE_BRANCH_PAGE).ERROR] (state, action) {
        const { branchName: branchName, errorType: errorType } = action.payload;
        return {
            ...state,
            isOpen: false,
            isDeleting: false,
            errorFlag: {
                ...state.errorFlag,
                branchName: branchName,
                errorType: errorType
            }
        };
    }
});

});


parcelRegister("4cfLu", function(module, exports) {

$parcel$export(module.exports, "getBulkDeleteBranchesSlice", function () { return $8aa1c306304e1744$export$ae1e2666a44d6c27; });
$parcel$export(module.exports, "getBranchingModel", function () { return $8aa1c306304e1744$export$5b01464e5fd4f62; });
$parcel$export(module.exports, "getIsBranchListLoading", function () { return $8aa1c306304e1744$export$a59ca48664df7573; });
$parcel$export(module.exports, "getIsBranchListError", function () { return $8aa1c306304e1744$export$d9575584fb38baac; });
$parcel$export(module.exports, "getBranchListReloadUrl", function () { return $8aa1c306304e1744$export$362091953c625dba; });
$parcel$export(module.exports, "getMainBranch", function () { return $8aa1c306304e1744$export$44705bfbfdf57676; });
$parcel$export(module.exports, "getDeleteBranchDialogSlice", function () { return $8aa1c306304e1744$export$9e62d0b90a9d4fbd; });
$parcel$export(module.exports, "getDeleteBranchDialogBranch", function () { return $8aa1c306304e1744$export$ac2bc54f0dbc19db; });
$parcel$export(module.exports, "getCompareBranchesDialogSlice", function () { return $8aa1c306304e1744$export$5f9c26af4772376f; });
$parcel$export(module.exports, "getAllBranches", function () { return $8aa1c306304e1744$export$fbe7833bb0d7195a; });
$parcel$export(module.exports, "getSelectedBranches", function () { return $8aa1c306304e1744$export$f2d953a3eff016b2; });
$parcel$export(module.exports, "getIsInSelectionMode", function () { return $8aa1c306304e1744$export$6cb174075a2f5cec; });
$parcel$export(module.exports, "getBranchesPagination", function () { return $8aa1c306304e1744$export$46db08d2d80eaaba; });

var $fLzne = parcelRequire("fLzne");

var $ga67g = parcelRequire("ga67g");

var $aXXtM = parcelRequire("aXXtM");

var $7qdXF = parcelRequire("7qdXF");

var $90ndC = parcelRequire("90ndC");

var $5JXyS = parcelRequire("5JXyS");
const $8aa1c306304e1744$export$617b893af1593320 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), ({ branches: branches })=>branches);
const $8aa1c306304e1744$export$b2a4d740436380ac = (0, $aXXtM.createSelector)($8aa1c306304e1744$export$617b893af1593320, ({ branchList: branchList })=>branchList);
const $8aa1c306304e1744$export$ae1e2666a44d6c27 = (0, $aXXtM.createSelector)($8aa1c306304e1744$export$617b893af1593320, ({ bulkDeleteBranches: bulkDeleteBranches })=>bulkDeleteBranches);
const $8aa1c306304e1744$export$8e83e642f64b3797 = (0, $aXXtM.createSelector)($8aa1c306304e1744$export$b2a4d740436380ac, (0, $7qdXF.getEntities), ({ listItems: listItems }, entities)=>(0, $ga67g.denormalize)(listItems.branches, [
        (0, $5JXyS.branch)
    ], entities));
const $8aa1c306304e1744$export$5b01464e5fd4f62 = (0, $aXXtM.createSelector)($8aa1c306304e1744$export$b2a4d740436380ac, (branches)=>branches.branchingModel);
const $8aa1c306304e1744$export$a59ca48664df7573 = (0, $aXXtM.createSelector)($8aa1c306304e1744$export$b2a4d740436380ac, ({ listItems: listItems, mainBranch: mainBranch })=>listItems.isLoading || mainBranch.isLoading);
const $8aa1c306304e1744$export$d9575584fb38baac = (0, $aXXtM.createSelector)($8aa1c306304e1744$export$b2a4d740436380ac, ({ isError: isError })=>isError);
const $8aa1c306304e1744$export$362091953c625dba = (0, $aXXtM.createSelector)($8aa1c306304e1744$export$b2a4d740436380ac, ({ listItems: listItems })=>listItems.reloadUrl);
const $8aa1c306304e1744$export$44705bfbfdf57676 = (0, $aXXtM.createSelector)($8aa1c306304e1744$export$b2a4d740436380ac, (0, $7qdXF.getEntities), ({ mainBranch: mainBranch }, entities)=>(0, $ga67g.denormalize)(mainBranch.branch, (0, $5JXyS.branch), entities));
const $8aa1c306304e1744$export$538c92fd2242f7d2 = (0, $aXXtM.createSelector)($8aa1c306304e1744$export$44705bfbfdf57676, (mainBranch)=>mainBranch === null || mainBranch === void 0 ? void 0 : mainBranch.sync_strategies);
const $8aa1c306304e1744$export$9e62d0b90a9d4fbd = (0, $aXXtM.createSelector)($8aa1c306304e1744$export$617b893af1593320, ({ deleteBranchDialog: deleteBranchDialog })=>deleteBranchDialog);
const $8aa1c306304e1744$export$ac2bc54f0dbc19db = (0, $aXXtM.createSelector)($8aa1c306304e1744$export$9e62d0b90a9d4fbd, $8aa1c306304e1744$export$8e83e642f64b3797, ({ branchName: branchName }, branches)=>branches.find((branch)=>branch.name === branchName));
const $8aa1c306304e1744$export$5f9c26af4772376f = (0, $aXXtM.createSelector)($8aa1c306304e1744$export$617b893af1593320, ({ compareBranchesDialog: compareBranchesDialog })=>compareBranchesDialog);
const $8aa1c306304e1744$export$fbe7833bb0d7195a = (0, $aXXtM.createSelector)($8aa1c306304e1744$export$8e83e642f64b3797, $8aa1c306304e1744$export$44705bfbfdf57676, $8aa1c306304e1744$export$a59ca48664df7573, (branches, mainBranch, isLoading)=>{
    // Stop the main branch from rendering before
    // the other branches to prevent the connect
    // caching from breaking
    // The branches are passed into a <ConnectModules> component to pre-fetch the
    // modules so when the dropdown(s) are opened the web items are pulled from
    // cache instead of fetched on the spot (which would cause them render 200-500ms
    // after the dropdown is open). The main branch and the additional branches need
    // to be rendered at the same time, otherwise the modules won't be cached correctly.
    const allBranches = mainBranch && branches.length ? [
        mainBranch,
        ...branches
    ] : [];
    // Still render the main branch if no other
    // branches are returned
    if (mainBranch && !branches.length && !isLoading) allBranches.push(mainBranch);
    return allBranches;
});
const $8aa1c306304e1744$export$f2d953a3eff016b2 = (0, $aXXtM.createSelector)($8aa1c306304e1744$export$ae1e2666a44d6c27, ({ selectedBranches: selectedBranches })=>selectedBranches);
const $8aa1c306304e1744$export$6cb174075a2f5cec = (0, $aXXtM.createSelector)($8aa1c306304e1744$export$ae1e2666a44d6c27, ({ isInSelectionMode: isInSelectionMode })=>isInSelectionMode);
const $8aa1c306304e1744$var$getBranchListSize = (state)=>state.repository.branches.branchList.listItems.size;
const $8aa1c306304e1744$var$getBranchListLength = (state)=>state.repository.branches.branchList.listItems.pageLength;
const $8aa1c306304e1744$export$64364797dcaed99f = (0, $aXXtM.createSelector)($8aa1c306304e1744$var$getBranchListSize, $8aa1c306304e1744$var$getBranchListLength, (size, pageLength)=>size && pageLength ? Math.ceil(size / pageLength) : 1);
const $8aa1c306304e1744$export$46db08d2d80eaaba = (0, $aXXtM.createSelector)($8aa1c306304e1744$export$64364797dcaed99f, (totalPages)=>(0, $fLzne.default)((0, $90ndC.getPagination)(totalPages)));

});
parcelRegister("90ndC", function(module, exports) {

$parcel$export(module.exports, "getPagination", function () { return $8cfc541213b2470c$export$7107d372eaf3477f; });
const $8cfc541213b2470c$export$7107d372eaf3477f = (totalPages)=>(getPaginationUrl)=>{
        const pages = [];
        [
            ...Array(totalPages).keys()
        ].forEach((pageNum)=>{
            const page = pageNum + 1;
            pages.push({
                href: getPaginationUrl(page),
                label: page
            });
        });
        return pages;
    };

});



parcelRegister("14luU", function(module, exports) {

$parcel$export(module.exports, "getBranchesFullNames", function () { return $56371cd786094a7b$export$bf1db546ade4de0f; });
function $56371cd786094a7b$export$bf1db546ade4de0f(sourceBranchName, destinationBranchName, sourceRepositoryFullName, destinationRepostioryFullName) {
    if (!sourceBranchName || !destinationBranchName) return {
        sourceBranchName: "",
        destinationBranchName: ""
    };
    if (!sourceRepositoryFullName || !destinationRepostioryFullName || sourceRepositoryFullName === destinationRepostioryFullName) return {
        sourceBranchName: sourceBranchName,
        destinationBranchName: destinationBranchName
    };
    return {
        sourceBranchName: `${sourceRepositoryFullName}:${sourceBranchName}`,
        destinationBranchName: `${destinationRepostioryFullName}:${destinationBranchName}`
    };
}

});

parcelRegister("19fn8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b64b4b210560c664$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $b64b4b210560c664$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    colorAccessibilityLabel: {
        "id": "frontbucket.pullRequest.settings.colorAccessibilityFiled",
        "defaultMessage": "Enable color accessibility"
    },
    colorAccessibilityLabelCheckbox: {
        "id": "frontbucket.pullRequest.settings.colorAccessibilityFiledCheckbox",
        "defaultMessage": "Color accessibility"
    },
    filesRadioGroupSectionLabel: {
        "id": "frontbucket.pullRequest.filesRadioGroupSectionLabel",
        "defaultMessage": "Diff"
    },
    diffViewModeLabel: {
        "id": "frontbucket.pullRequest.settings.diffViewModeLabel",
        "defaultMessage": "View"
    },
    showLabel: {
        "id": "frontbucket.pullRequest.settings.showLabel",
        "defaultMessage": "Show"
    },
    diffViewModeLabelSideBySide: {
        "id": "frontbucket.pullRequest.settings.diffViewModeLabelSideBySide",
        "defaultMessage": "Side-by-side"
    },
    diffViewModeLabelUnified: {
        "id": "frontbucket.pullRequest.settings.diffViewModeLabelUnified",
        "defaultMessage": "Unified"
    },
    errorFlagDescription: {
        "id": "frontbucket.pullRequest.settings.errorFlagDescription",
        "defaultMessage": "Some of the updates to your diff settings may not have been saved."
    },
    errorFlagRetryButton: {
        "id": "frontbucket.pullRequest.settings.errorFlagRetryButton",
        "defaultMessage": "Try again"
    },
    errorFlagTitle: {
        "id": "frontbucket.pullRequest.settings.errorFlagTitle",
        "defaultMessage": "Something went wrong"
    },
    iconLabel: {
        "id": "frontbucket.pullRequest.settings.iconLabel",
        "defaultMessage": "Open modal window: diff display settings"
    },
    diffSettingsButtonLabel: {
        "id": "frontbucket.pullRequest.settings.diffSettingsButtonLabel",
        "defaultMessage": "Global diff settings"
    },
    ignoreWhitespaceLabel: {
        "id": "frontbucket.pullRequest.settings.ignoreWhitespaceLabel",
        "defaultMessage": "Ignore whitespace"
    },
    ignoreWhitespaceLabelCheckbox: {
        "id": "frontbucket.pullRequest.settings.ignoreWhitespaceLabelCheckbox",
        "defaultMessage": "Whitespace changes"
    },
    singleFileModeLabel: {
        "id": "frontbucket.pullRequest.settings.singleFileModeLabel",
        "defaultMessage": "Load files individually"
    },
    singleFileModeRadioGroupLabel: {
        "id": "frontbucket.pullRequest.settings.singleFileModeRadioGroupLabel",
        "defaultMessage": "Load files"
    },
    allFileModeRadioButtonLabel: {
        "id": "frontbucket.pullRequest.allFileModeRadioButtonLabel",
        "defaultMessage": "All at once"
    },
    singleFileModeRadioButtonLabel: {
        "id": "frontbucket.pullRequest.singleFileModeRadioButtonLabel",
        "defaultMessage": "Individually"
    },
    sidebarRadioGroupSectionLabel: {
        "id": "frontbucket.pullRequest.sidebarRadioGroupSectionLabel",
        "defaultMessage": "Right Sidebar"
    },
    fileViewRadioGroupLabel: {
        "id": "frontbucket.pullRequest.fileViewRadioGroupLabel",
        "defaultMessage": "File view"
    },
    fileViewTreeRadioButtonLabel: {
        "id": "frontbucket.pullRequest.fileViewTreeRadioButtonLabel",
        "defaultMessage": "Tree"
    },
    fileViewListRadioButtonLabel: {
        "id": "frontbucket.pullRequest.fileViewListRadioButtonLabel",
        "defaultMessage": "List"
    },
    modalButton: {
        "id": "frontbucket.pullRequest.settings.modalButton",
        "defaultMessage": "Settings"
    },
    modalHeading: {
        "id": "frontbucket.pullRequest.settings.modalHeading",
        "defaultMessage": "Global diff view settings"
    },
    successFlagDescription: {
        "id": "frontbucket.pullRequest.settings.successFlagDescription",
        "defaultMessage": "Your diff settings have been updated."
    },
    wordDiffLabel: {
        "id": "frontbucket.pullRequest.settings.wordDiffLabel",
        "defaultMessage": "Enable word diff"
    },
    wordDiffLabelCheckbox: {
        "id": "frontbucket.pullRequest.settings.wordDiffLabelCheckbox",
        "defaultMessage": "Word diff"
    },
    annotationsLabel: {
        "id": "frontbucket.pullRequest.settings.annotationsLabel",
        "defaultMessage": "Enable annotations"
    },
    annotationsLabelCheckbox: {
        "id": "frontbucket.pullRequest.settings.annotationsLabelCheckbox",
        "defaultMessage": "Annotations"
    },
    tabSizePrefLabel: {
        "id": "frontbucket.pullRequest.settings.tabSizeLabel",
        "defaultMessage": "Tab size"
    },
    tabSizeOptionLabel: {
        "id": "frontbucket.pullRequest.settings.tabSizeOptionLabel",
        "defaultMessage": "{tabWidth, plural, one {{tabWidth} space} other {{tabWidth} spaces}}"
    },
    diffViewLabel: {
        "id": "frontbucket.pullRequest.settings.diffViewLabel",
        "defaultMessage": "Diff view"
    }
});

});

parcelRegister("26ud1", function(module, exports) {

$parcel$export(module.exports, "handleJiraIssueLinkClick", function () { return $4c93800f1aee3f0e$export$857fc66c37d72889; });

var $cJH1T = parcelRequire("cJH1T");
parcelRequire("g2goG");
var $kNA8C = parcelRequire("kNA8C");

var $6aoKW = parcelRequire("6aoKW");

var $6Tn56 = parcelRequire("6Tn56");
const $4c93800f1aee3f0e$export$1f088824810f7ee1 = (jiraUrl, jiraIssueKey)=>{
    const dialogProvider = (0, $kNA8C.default).frameworkAdaptor.getProviderByModuleName("dialog");
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
        "issue-key": jiraIssueKey,
        "modal-size": "maximum",
        // These two params are needed so that Jira can load the connect JS.
        // Why is that needed? So that the "close" button within the iframe (Jira)
        // can close the dialog in the host (Bitbucket).
        cenv: (0, $6Tn56.getBbEnv)(),
        crev: `${(0, $6Tn56.getBbCommitHash)()}/dist/connect/v5`
    });
    const url = `${jiraUrl}/rest/bitbucket/1.0/issue-details/fragment-csp?${query}`;
    const options = {
        chrome: false,
        size: "maximum"
    };
    const urlIframeProps = {
        // These are required by the library but we don't actually have a module here.
        // Use a key that shouldn't clash with any existing ones.
        appKey: `jira-bitbucket-connector-plugin.${jiraUrl}`,
        moduleKey: "dashboard-jira-issue-dialog",
        moduleId: "dashboard-jira-issue-dialog",
        url: url
    };
    dialogProvider.createUrlIframeDialog(options, urlIframeProps);
};
const $4c93800f1aee3f0e$export$857fc66c37d72889 = (e, uiEvent, jiraUrl, jiraIssueKey)=>{
    (0, $6aoKW.publishUiEvent)(uiEvent);
    // command-click or ctrl-click should do the default handling of opening in a new tab
    if (e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    $4c93800f1aee3f0e$export$1f088824810f7ee1(jiraUrl, jiraIssueKey);
};

});

parcelRegister("lALYr", function(module, exports) {

$parcel$export(module.exports, "getPullRequestJiraIssuesFetchedStatus", function () { return $c3a2f0c3f70f31fd$export$4c07289af6f59e25; });
$parcel$export(module.exports, "getPullRequestJiraIssues", function () { return $c3a2f0c3f70f31fd$export$a839fbed4e30af0d; });
$parcel$export(module.exports, "getIssueTransitionForm", function () { return $c3a2f0c3f70f31fd$export$94a43ea730949405; });
$parcel$export(module.exports, "getPullRequestJiraIssuesState", function () { return $c3a2f0c3f70f31fd$export$49cc545ffa2b4652; });
$parcel$export(module.exports, "getJiraIssueConnectedSites", function () { return $c3a2f0c3f70f31fd$export$c8a714b4c75de387; });
$parcel$export(module.exports, "getJiraIssueFetchedStatus", function () { return $c3a2f0c3f70f31fd$export$a4fcb39973403b33; });
$parcel$export(module.exports, "getPullRequestJiraIssuesForComment", function () { return $c3a2f0c3f70f31fd$export$beb2c50bd4958d7; });
$parcel$export(module.exports, "getPullRequestJiraIssuesByType", function () { return $c3a2f0c3f70f31fd$export$3adcc278239f6745; });
$parcel$export(module.exports, "getCreateJiraIssuePreferences", function () { return $c3a2f0c3f70f31fd$export$a3e1a7dc78b61393; });
$parcel$export(module.exports, "getCreatedJiraIssue", function () { return $c3a2f0c3f70f31fd$export$c09df45235779e; });

var $cQrjH = parcelRequire("cQrjH");

var $aXXtM = parcelRequire("aXXtM");

var $7qdXF = parcelRequire("7qdXF");
const $c3a2f0c3f70f31fd$export$4c07289af6f59e25 = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.pullRequestJiraIssues.jiraIssuesFetchedStatus);
const $c3a2f0c3f70f31fd$export$a839fbed4e30af0d = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.pullRequestJiraIssues.jiraIssues);
const $c3a2f0c3f70f31fd$export$94a43ea730949405 = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.pullRequestJiraIssues.issueTransitionFormData);
const $c3a2f0c3f70f31fd$export$49cc545ffa2b4652 = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.pullRequestJiraIssues);
const $c3a2f0c3f70f31fd$export$c8a714b4c75de387 = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.createJiraIssue.connectedSites);
const $c3a2f0c3f70f31fd$export$a4fcb39973403b33 = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.createJiraIssue.connectedSitesFetchedStatus);
const $c3a2f0c3f70f31fd$export$beb2c50bd4958d7 = (0, $cQrjH.default)($c3a2f0c3f70f31fd$export$a839fbed4e30af0d, (_state, commentId)=>commentId, (issues, commentId)=>{
    return issues.filter((issue)=>issue.commentId === commentId);
})((_state, commentId)=>commentId);
const $c3a2f0c3f70f31fd$export$3adcc278239f6745 = (0, $cQrjH.default)($c3a2f0c3f70f31fd$export$a839fbed4e30af0d, (_state, type)=>type, (issues, type)=>{
    return issues.filter((issue)=>issue.type === type);
})((_state, type)=>type);
const $c3a2f0c3f70f31fd$export$a3e1a7dc78b61393 = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.createJiraIssue.preferences);
const $c3a2f0c3f70f31fd$export$c09df45235779e = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.createJiraIssue.jiraTabCreateForm.issue);

});

parcelRegister("fEXRj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f81ad8e55da72c5$export$2e2bcd8739ae039; });

var $dkkN8 = parcelRequire("dkkN8");
function $0f81ad8e55da72c5$export$2e2bcd8739ae039(payload) {
    return {
        type: (0, $dkkN8.SCROLL_TO),
        payload: payload
    };
}

});

parcelRegister("aTiUP", function(module, exports) {

$parcel$export(module.exports, "useDiscardCommentsDialogState", function () { return $015c8510cfad0e0b$export$26bce9ac5a0d4610; });
$parcel$export(module.exports, "default", function () { return $015c8510cfad0e0b$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $EKmRU = parcelRequire("EKmRU");

var $cGPG3 = parcelRequire("cGPG3");
var $ljrFr = parcelRequire("ljrFr");
var $2X56B = parcelRequire("2X56B");
var $DPG6Z = parcelRequire("DPG6Z");
var $3qXIy = parcelRequire("3qXIy");

var $jajUg = parcelRequire("jajUg");

var $bzso6 = parcelRequire("bzso6");
const $015c8510cfad0e0b$export$26bce9ac5a0d4610 = ()=>{
    const [config, setConfig] = (0, $9nHZC.useState)(null);
    const confirmDiscardComments = (0, $9nHZC.useCallback)((cfg)=>setConfig(cfg), []);
    const onCancel = (0, $9nHZC.useCallback)(()=>{
        var _config$onCancelDisca;
        config === null || config === void 0 || (_config$onCancelDisca = config.onCancelDiscard) === null || _config$onCancelDisca === void 0 || _config$onCancelDisca.call(config);
        setConfig(null);
    }, [
        config
    ]);
    const onDiscard = (0, $9nHZC.useCallback)(()=>{
        if (!config) return;
        config.onConfirmDiscard();
        setConfig(null);
    }, [
        config
    ]);
    const dialogProps = {
        children: config ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, config.message, {
            tagName: "p"
        })) : null,
        onCancel: onCancel,
        onDiscard: onDiscard
    };
    return {
        confirmDiscardComments: confirmDiscardComments,
        dialogProps: dialogProps,
        isDialogOpen: !!config
    };
};
const $015c8510cfad0e0b$var$DiscardCommentsDialog = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo((props)=>{
    const intl = (0, $jajUg.useIntl)();
    const { onDiscard: onDiscard, onCancel: onCancel, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $cGPG3.default), {
        width: "small",
        onClose: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $DPG6Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3qXIy.default), {
        appearance: "danger"
    }, intl.formatMessage((0, $bzso6.default).discardCommentsModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ljrFr.default), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2X56B.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $EKmRU.default), {
        appearance: "danger",
        onClick: onDiscard
    }, intl.formatMessage((0, $bzso6.default).discardCommentsModalDiscardButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $EKmRU.default), {
        appearance: "subtle",
        onClick: onCancel
    }, intl.formatMessage((0, $bzso6.default).discardCommentsModalCancelButton))));
});
var $015c8510cfad0e0b$export$2e2bcd8739ae039 = $015c8510cfad0e0b$var$DiscardCommentsDialog;

});
parcelRegister("bzso6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00ebf07fc9ef59fc$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
const $00ebf07fc9ef59fc$export$defe85febe8b728c = (0, $agjvf.defineMessages)({
    ambiguousRefs: {
        "id": "frontbucket.repository.pullRequest.ambiguousRefs",
        "defaultMessage": "This repository contains a branch or tag {sourceHash} or {destHash} which shadows this pull request's source or destination commit. Delete it in order to view this pull request's diff."
    },
    diffSetLabel: {
        "id": "frontbucket.repository.pullRequest.diffSetLabel",
        "defaultMessage": "Diff"
    },
    diffFileTitle: {
        "id": "frontbucket.repository.pullRequest.diffFileTitle",
        "defaultMessage": "Diff of file {filepath}"
    },
    thisFile: {
        "id": "frontbucket.repository.pullRequest.diff.thisFile",
        "defaultMessage": "This file"
    },
    fileCount: {
        "id": "frontbucket.repository.pullRequest.diff.fileCount",
        "defaultMessage": "{fileCount} {fileCount, plural, one {file} other {files}}"
    },
    fileRenamed: {
        "id": "frontbucket.repository.pullRequest.diff.fileRenamed",
        "defaultMessage": "File renamed but contents unchanged"
    },
    allFiles: {
        "id": "frontbucket.repository.pullRequest.diff.allFiles",
        "defaultMessage": "All files"
    },
    sideBySide: {
        "id": "frontbucket.repository.pullRequest.diff.sideBySide",
        "defaultMessage": "View side-by-side"
    },
    unifiedDiff: {
        "id": "frontbucket.repository.pullRequest.diff.unifiedDiff",
        "defaultMessage": "View unified"
    },
    viewFile: {
        "id": "frontbucket.repository.pullRequest.diff.viewFile",
        "defaultMessage": "Open in Source"
    },
    editFile: {
        "id": "frontbucket.repository.pullRequest.diff.editFile",
        "defaultMessage": "Edit file"
    },
    hideWordDiff: {
        "id": "frontbucket.repository.pullRequest.diff.hideWordDiff",
        "defaultMessage": "Hide word diff"
    },
    expandAll: {
        "id": "frontbucket.repository.pullRequest.diff.expandAll",
        "defaultMessage": "Expand all files"
    },
    collapseAll: {
        "id": "frontbucket.repository.pullRequest.diff.collapseAll",
        "defaultMessage": "Collapse all files"
    },
    unmarkAllViewed: {
        "id": "frontbucket.repository.pullRequest.diff.clearViewed",
        "defaultMessage": "Unmark all files as viewed"
    },
    markAllViewed: {
        "id": "frontbucket.repository.pullRequest.diff.markAllViewed",
        "defaultMessage": "Mark all files as viewed"
    },
    hideAnnotations: {
        "id": "frontbucket.repository.pullRequest.diff.hideAnnotations",
        "defaultMessage": "Hide annotations"
    },
    showAnnotations: {
        "id": "frontbucket.repository.pullRequest.diff.showAnnotations",
        "defaultMessage": "Show annotations"
    },
    showComments: {
        "id": "frontbucket.repository.pullRequest.diff.showComments",
        "defaultMessage": "Show comments"
    },
    commentsHidden: {
        "id": "frontbucket.repository.pullRequest.diff.commentsHidden",
        "defaultMessage": "Comments are hidden."
    },
    hideComments: {
        "id": "frontbucket.repository.pullRequest.diff.hideComments",
        "defaultMessage": "Hide comments"
    },
    lozengeNewLabel: {
        "id": "frontbucket.repository.pullRequest.diff.lozengeNewLabel",
        "defaultMessage": "New"
    },
    diffActionsButtonLabel: {
        "id": "frontbucket.repository.pullRequest.diff.actions.menu.label",
        "defaultMessage": "Diff actions"
    },
    viewEntireFile: {
        "id": "frontbucket.repository.pullRequest.diff.viewEntireFile",
        "defaultMessage": "View entire file"
    },
    missingDiffsOnMergedPr: {
        "id": "frontbucket.repository.pullRequest.missingDiffsOnMergedPr",
        "defaultMessage": "The source or destination branch was deleted.{newLine}If the destination still exists, you can view the merged changes by inspecting the merge commit: {mergeCommitShortHash}"
    },
    missingDiffsErrorTitle: {
        "id": "frontbucket.repository.pullRequest.missingDiffsErrorTitle",
        "defaultMessage": "Cannot generate the diff"
    },
    missingDiffs: {
        "id": "frontbucket.repository.pullRequest.missingDiffs",
        "defaultMessage": "The source or destination branch was deleted, or these changes already exist in the destination repository."
    },
    missingDiffsTitle: {
        "id": "frontbucket.repository.pullRequest.missingDiffsTitle",
        "defaultMessage": "Nothing to merge"
    },
    diffError: {
        "id": "frontbucket.repository.pullRequest.diffError",
        "defaultMessage": "Wait a few moments, then try again. If this keeps happening, let us know at {contactLink}."
    },
    noFiles: {
        "id": "frontbucket.repository.pullRequest.noFiles",
        "defaultMessage": "This {context} has no changed files to display."
    },
    noFilesTitle: {
        "id": "frontbucket.repository.pullRequest.noFilesTitle",
        "defaultMessage": "Nothing has changed"
    },
    noFilesMatchFilter: {
        "id": "frontbucket.repository.pullRequest.noFilesMatchFilter",
        "defaultMessage": "{isCurrentUser, select, true {You haven't commented on any files.} other {There are no comments on these files.}}"
    },
    unhandledMergeConflictsTitle: {
        "id": "frontbucket.repository.pullRequest.unhandledMergeConflictsTitle",
        "defaultMessage": "Unable to handle merge conflicts"
    },
    unhandledMergeConflictsError: {
        "id": "frontbucket.repository.pullRequest.unhandledMergeConflictsError",
        "defaultMessage": "Resolve any conflicts locally and try again. {resolveMergeConflictsLink}."
    },
    learnHowLink: {
        "id": "frontbucket.repository.pullRequest.learnHowLink",
        "defaultMessage": "Learn how"
    },
    /*
   * Copy for diff alert modals.
   */ discardCommentsModalTitle: {
        "id": "frontbucket.repository.pullRequest.discardCommentsModal.title",
        "defaultMessage": "Discard unsaved comments?"
    },
    discardCommentsModalDiscardButton: {
        "id": "frontbucket.repository.pullRequest.discardCommentsModal.discard",
        "defaultMessage": "Discard"
    },
    discardCommentsModalCancelButton: {
        "id": "frontbucket.repository.pullRequest.discardCommentsModal.cancel",
        "defaultMessage": "Cancel"
    },
    discardCommentsModalBody__SideBySideToggle: {
        "id": "frontbucket.repository.pullRequest.discardCommentsModal.body.sideBySideToggle",
        "defaultMessage": "Changing to side-by-side view discards your unsaved comments."
    },
    discardCommentsModalBody__ExpandContext: {
        "id": "frontbucket.repository.pullRequest.discardCommentsModal.body.expandContext",
        "defaultMessage": "Showing more lines discards your unsaved comments."
    },
    discardCommentsModalBody__SameFileComment: {
        "id": "frontbucket.repository.pullRequest.discardCommentsModal.body.sameFileComment",
        "defaultMessage": "Adding a new comment in the same file discards any unsaved comments."
    },
    diffTimeout: {
        "id": "frontbucket.repository.pullRequest.diffTimeout",
        "defaultMessage": "The diff has timed out. For more information on diff limits or managing pull request size, refer to {docLink}. If this issue persists, contact {supportLink}."
    },
    diffLimitsDocTitle: {
        "id": "frontbucket.repository.pullRequest.diffLimitsDocTitle",
        "defaultMessage": "Limits for viewing content and diffs"
    },
    noCommonAncestor: {
        "id": "frontbucket.repository.pullRequest.noCommonAncestor",
        "defaultMessage": "These branches have no common ancestor."
    },
    noCommonAncestorTitle: {
        "id": "frontbucket.repository.pullRequest.noCommonAncestorTitle",
        "defaultMessage": "Unrelated branches"
    }
});
var $00ebf07fc9ef59fc$export$2e2bcd8739ae039 = $00ebf07fc9ef59fc$export$defe85febe8b728c;

});


parcelRegister("bRi2x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf793fcc16de8890$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $cf793fcc16de8890$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    finishReview: {
        "id": "frontbucket.repository.pullRequest.finishReview.button",
        "defaultMessage": "Finish Review"
    },
    popupTitle: {
        "id": "frontbucket.repository.pullRequest.finishReview.title",
        "defaultMessage": "Comments in Review"
    },
    pendingLink: {
        "id": "frontbucket.repository.pullRequest.finishReview.pendingLink",
        "defaultMessage": "View all pending comments and tasks"
    },
    statusFormTitle: {
        "id": "frontbucket.repository.pullRequest.finishReview.status.FormTitle",
        "defaultMessage": "Mark pull request as"
    },
    submitButton: {
        "id": "frontbucket.repository.pullRequest.finishReview.status.submitButton",
        "defaultMessage": "Submit"
    },
    cancelButton: {
        "id": "frontbucket.repository.pullRequest.review.status.cancelButton",
        "defaultMessage": "Cancel"
    },
    discardButton: {
        "id": "frontbucket.repository.pullRequest.discardReview.status.discardButton",
        "defaultMessage": "Discard"
    },
    discardReview: {
        "id": "frontbucket.repository.pullRequest.discardReview.label",
        "defaultMessage": "Discard Review"
    },
    discardReviewConfirmation: {
        "id": "frontbucket.repository.pullRequest.discardReview.confirmationText",
        "defaultMessage": "Are you sure you want to discard your review? This will delete any pending comments and tasks you have created."
    },
    noStatusTitle: {
        "id": "frontbucket.repository.pullRequest.finishReview.noStatus.title",
        "defaultMessage": "No status"
    },
    noStatusDescription: {
        "id": "frontbucket.repository.pullRequest.finishReview.noStatus.description",
        "defaultMessage": "Submit review with no pull request status applied"
    },
    requestChangesTitle: {
        "id": "frontbucket.repository.pullRequest.finishReview.requestChanges.title",
        "defaultMessage": "Request changes"
    },
    requestChangesDescription: {
        "id": "frontbucket.repository.pullRequest.finishReview.requestChanges.description",
        "defaultMessage": "Submit feedback that must be addressed before merging"
    },
    approveTitle: {
        "id": "frontbucket.repository.pullRequest.finishReview.approve.title",
        "defaultMessage": "Approve"
    },
    approveDescription: {
        "id": "frontbucket.repository.pullRequest.finishReview.approve.description",
        "defaultMessage": "This pull request is ready to merge"
    },
    permissionsError: {
        "id": "frontbucket.repository.pullRequest.finishReview.error.permissions",
        "defaultMessage": "You have not been granted the permissions required to submit a pull request review."
    },
    requestChangesError: {
        "id": "frontbucket.repository.pullRequest.finishReview.error.requestChanges",
        "defaultMessage": "Since this pull request has already been merged, you cannot request changes."
    },
    discardNoPullRequestIdError: {
        "id": "frontbucket.repository.pullRequest.discardReview.error.noPRId",
        "defaultMessage": "Pull request id is not defined"
    },
    discardChangesError: {
        "id": "frontbucket.repository.pullRequest.discardReview.error.failure",
        "defaultMessage": "Error deleting pull request review"
    },
    discardReviewSuccess: {
        "id": "frontbucket.repository.pullRequest.discardReview.success",
        "defaultMessage": "Your review has been deleted"
    },
    errorSubmitTitle: {
        "id": "frontbucket.repository.pullRequest.finishReview.submit.error.title",
        "defaultMessage": "Unable to submit review"
    },
    errorDiscardTitle: {
        "id": "frontbucket.repository.pullRequest.finishReview.discard.error.title",
        "defaultMessage": "Unable to delete review"
    },
    successTitle: {
        "id": "frontbucket.repository.pullRequest.finishReview.success",
        "defaultMessage": "Your review has been submitted"
    },
    generalErrorDescription: {
        "id": "frontbucket.repository.pullRequest.finishReview.error.description",
        "defaultMessage": "Wait a few moments, then try again. If the problem persists, {supportLink}."
    },
    supportLink: {
        "id": "frontbucket.repository.pullRequest.finishReview.error.support",
        "defaultMessage": "contact support"
    },
    outdatedCommentsTitle: {
        "id": "frontbucket.repository.pullRequest.finishReview.outdatedComments.title",
        "defaultMessage": "Outdated Comments"
    },
    outdatedCommentsDescription: {
        "id": "frontbucket.repository.pullRequest.finishReview.outdatedComments.description",
        "defaultMessage": "You're about to submit a review that will have {outdatedCommentCount}."
    },
    outdatedCommentCount: {
        "id": "frontbucket.repository.pullRequest.finishReview.outdatedComments.count",
        "defaultMessage": "{numOutdatedComments, plural, one {{numOutdatedComments} outdated comment} other {{numOutdatedComments} outdated comments}}"
    }
});

});

parcelRegister("50zD2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ead28ae0b6a4e4f9$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $ead28ae0b6a4e4f9$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    dismissButton: {
        "id": "frontbucket.flags.siteMessage.dismiss",
        "defaultMessage": "Dismiss"
    },
    learnMoreButton: {
        "id": "frontbucket.flags.siteMessage.learnMore",
        "defaultMessage": "Learn more"
    },
    refreshButton: {
        "id": "frontbucket.flags.siteMessage.refresh",
        "defaultMessage": "Refresh page"
    }
});

});

parcelRegister("05iag", function(module, exports) {

$parcel$export(module.exports, "SYNTAX_HIGHLIGHTING_FLAG_ID", function () { return $9c617c0dfc9f57c6$export$25a6ef8a65a5a4da; });
$parcel$export(module.exports, "SyntaxHighlightingFlag", function () { return $9c617c0dfc9f57c6$export$2c8cd58be0ecc314; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $aMNOk = parcelRequire("aMNOk");

var $g3VDW = parcelRequire("g3VDW");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $jajUg = parcelRequire("jajUg");

var $cy76E = parcelRequire("cy76E");

var $11JYn = parcelRequire("11JYn");
const $9c617c0dfc9f57c6$export$25a6ef8a65a5a4da = "syntax-highlighting";
const $9c617c0dfc9f57c6$export$2c8cd58be0ecc314 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo((props)=>{
    const intl = (0, $jajUg.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aMNOk.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        title: intl.formatMessage((0, $cy76E.default).syntaxHighlightingPopupTitle),
        appearance: (0, $11JYn.AppearanceTypes).normal,
        description: intl.formatMessage((0, $cy76E.default).syntaxHighlightingPopupBody),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g3VDW))), {
            label: "",
            primaryColor: (0, $h39Sh.default)("color.icon.discovery", (0, $jp7ng).P300)
        }),
        actions: [
            {
                content: intl.formatMessage((0, $cy76E.default).syntaxHighlightingGoToLabsAction),
                href: "/account/settings/features/#feature_syntax-highlighting",
                target: "_blank"
            }
        ]
    }));
});

});
parcelRegister("cy76E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efbe102ae8cf0ee3$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $efbe102ae8cf0ee3$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    pullRequestUpdated: {
        "id": "frontbucket.pullRequest.updatedFlagTitle",
        "defaultMessage": "This pull request was updated"
    },
    anchorMovedTitle: {
        "id": "frontbucket.pullRequest.anchorMovedTitle",
        "defaultMessage": "Source branch updated"
    },
    anchorMovedDescription: {
        "id": "frontbucket.pullRequest.anchorMovedDescription",
        "defaultMessage": "The source branch for this pull request has been updated."
    },
    reload: {
        "id": "frontbucket.pullRequest.reloadAction",
        "defaultMessage": "Reload page"
    },
    discardCommentsModalBody: {
        "id": "frontbucket.pullRequest.updatedFlagTitle.discardCommentsModalBody",
        "defaultMessage": "Reloading the pull request discards your unsaved comments."
    },
    topicDiffConflictTitle: {
        "id": "frontbucket.pullRquest.topicDiffRolloutConflictsFlag.title",
        "defaultMessage": "Merge conflicts look a bit different now"
    },
    topicDiffConflictBody: {
        "id": "frontbucket.pullRquest.topicDiffRolloutConflictsFlag.body",
        "defaultMessage": "To help improve performance, we\u2019ve updated the way our diffs are displayed. Now, files with merge conflicts are still marked as conflicted, but no longer display the conflicts in highlighted text on the diffs."
    },
    syntaxHighlightingPopupTitle: {
        "id": "frontbucket.pullRequest.syntaxHighlightingPopup.title",
        "defaultMessage": "Syntax highlighting is available"
    },
    syntaxHighlightingPopupBody: {
        "id": "frontbucket.pullRequest.syntaxHighlightingPopup.body",
        "defaultMessage": "Try out syntax highlighting by enabling the feature in Labs. You can provide feedback via the Labs feedback collector."
    },
    syntaxHighlightingGoToLabsAction: {
        "id": "frontbucket.pullRequest.syntaxHighlightingPopup.goToLabsAction",
        "defaultMessage": "Go to Labs"
    }
});

});

parcelRegister("11JYn", function(module, exports) {

$parcel$export(module.exports, "AppearanceTypes", function () { return $18eb7d2cb7f65637$export$d810535c30012a62; });
$parcel$export(module.exports, "default", function () { return $18eb7d2cb7f65637$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $fBIHI = parcelRequire("fBIHI");
var $aMNOk = parcelRequire("aMNOk");

var $5eELe = parcelRequire("5eELe");

var $4dJkZ = parcelRequire("4dJkZ");

var $g3VDW = parcelRequire("g3VDW");

var $9hjCt = parcelRequire("9hjCt");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $jajUg = parcelRequire("jajUg");

var $6aoKW = parcelRequire("6aoKW");

var $bUo4Z = parcelRequire("bUo4Z");

var $iPlcj = parcelRequire("iPlcj");
var $18eb7d2cb7f65637$export$d810535c30012a62;
(function(AppearanceTypes) {
    AppearanceTypes["error"] = "error";
    AppearanceTypes["info"] = "info";
    AppearanceTypes["normal"] = "normal";
    AppearanceTypes["success"] = "success";
    AppearanceTypes["warning"] = "warning";
})($18eb7d2cb7f65637$export$d810535c30012a62 || ($18eb7d2cb7f65637$export$d810535c30012a62 = {}));
const $18eb7d2cb7f65637$var$icons = {
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4dJkZ))), {
        label: "Error",
        primaryColor: (0, $h39Sh.default)("color.icon.danger", (0, $jp7ng).R300)
    }),
    info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g3VDW))), {
        label: "Info",
        primaryColor: (0, $h39Sh.default)("color.icon.discovery", (0, $jp7ng).P300)
    }),
    normal: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g3VDW))), {
        label: "Info",
        primaryColor: (0, $h39Sh.default)("color.icon.discovery", (0, $jp7ng).P300)
    }),
    success: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5eELe))), {
        label: "Success",
        primaryColor: (0, $h39Sh.default)("color.icon.success", (0, $jp7ng).G300)
    }),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9hjCt))), {
        label: "Warning",
        primaryColor: (0, $h39Sh.default)("color.icon.warning", (0, $jp7ng).Y300)
    })
};
const $18eb7d2cb7f65637$var$SimpleFlag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo((props)=>{
    const { actions: actions, nonIntlActions: nonIntlActions, autoDismiss: // ability to pass in non-Intl actions for Forge
    autoDismiss, coloredAppearance: coloredAppearance, description: description, iconType: iconType, id: id, title: title, props: additionalProps = {}, // FlagGroup passes other props through to its Children that need to be preserved
    ...akProps } = props;
    const intl = (0, $jajUg.useIntl)();
    (0, $9nHZC.useEffect)(()=>{
        (0, $6aoKW.publishFact)(new (0, $bUo4Z.FlagViewed)({
            flag_id: id
        }));
        (0, $6aoKW.publishScreenEvent)("siteMessageFlag", {
            flag_id: id
        });
    }, [
        id
    ]);
    const extractIntlMessage = (text)=>typeof text === "string" ? text : intl.formatMessage(text.msg, text.values);
    const intlActions = actions ? actions.map((action)=>({
            content: extractIntlMessage(action.content),
            href: action.href,
            target: action.target,
            onClick: action.onClick
        })) : undefined;
    const intlTitle = extractIntlMessage(title);
    const intlDescription = description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($iPlcj.SimpleFlagDescription, null, extractIntlMessage(description)) : undefined;
    const flagProps = {
        ...akProps,
        actions: nonIntlActions || intlActions,
        appearance: coloredAppearance ? iconType : "normal",
        description: intlDescription,
        icon: iconType ? $18eb7d2cb7f65637$var$icons[iconType] : $18eb7d2cb7f65637$var$icons.normal,
        id: id,
        title: intlTitle,
        // any Flag props explicitly passed to the SimpleFlag component
        // will take precedent over other props computed here
        ...additionalProps
    };
    return autoDismiss ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fBIHI.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        key: id
    }, flagProps)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aMNOk.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        key: id
    }, flagProps));
});
var $18eb7d2cb7f65637$export$2e2bcd8739ae039 = $18eb7d2cb7f65637$var$SimpleFlag;

});
parcelRegister("iPlcj", function(module, exports) {

$parcel$export(module.exports, "SimpleFlagDescription", function () { return $0d400c82d3f8fe19$export$870f7a5f199ba30a; });

var $2xJU3 = parcelRequire("2xJU3");
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */ function $0d400c82d3f8fe19$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0d400c82d3f8fe19$export$870f7a5f199ba30a = (0, $2xJU3.default)("div", {
    target: "en0j1jx0"
})({
    name: "1kxrhf3",
    styles: "white-space:pre-wrap;"
});

});



parcelRegister("iaxMc", function(module, exports) {

$parcel$export(module.exports, "getUserAiOnboardingFlagDismissed", function () { return $a6a32ea93a4a6c68$export$768de8de4ab95e4b; });
$parcel$export(module.exports, "UserAiOnboardingFlag", function () { return $a6a32ea93a4a6c68$export$ca97d1fe73f8cc9; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $aMNOk = parcelRequire("aMNOk");

var $i419A = parcelRequire("i419A");

var $jajUg = parcelRequire("jajUg");

var $dJfxn = parcelRequire("dJfxn");

var $h3kk7 = parcelRequire("h3kk7");

var $aJCYU = parcelRequire("aJCYU");

var $9D1Ab = parcelRequire("9D1Ab");
const $a6a32ea93a4a6c68$var$userAiOnboardingFlagDismissedKey = "user-ai-onboarding-flag-dismissed";
const $a6a32ea93a4a6c68$export$768de8de4ab95e4b = ()=>{
    return (0, $h3kk7.default).get($a6a32ea93a4a6c68$var$userAiOnboardingFlagDismissedKey);
};
const $a6a32ea93a4a6c68$export$ca97d1fe73f8cc9 = ({ id: id, handleDismissed: handleDismissed })=>{
    const intl = (0, $jajUg.useIntl)();
    const dismiss = ()=>{
        (0, $h3kk7.default).set($a6a32ea93a4a6c68$var$userAiOnboardingFlagDismissedKey, true);
        handleDismissed(id);
    };
    const actions = [
        {
            content: intl.formatMessage((0, $aJCYU.default).userAiOnboardingFlagLearnMore),
            onClick: ()=>dismiss(),
            href: (0, $dJfxn.default).ui.learnMore(),
            target: "_blank"
        }
    ];
    const description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, (0, $aJCYU.default).userAiOnboardingFlagDescription, {
        tagName: "span",
        values: {
            editorToolbar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("b", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, $aJCYU.default).userAiOnboardingFlagEditorToolbar)),
            aiShortcut: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("b", null, "`/ai`")
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aMNOk.default), {
        id: id,
        description: description,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9D1Ab.AILogoWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $i419A.LogoSvg), {
            alt: "user-ai-onboarding"
        })),
        title: intl.formatMessage((0, $aJCYU.default).userAiOnboardingFlagTitle),
        actions: actions,
        onDismissed: ()=>dismiss()
    });
};

});
parcelRegister("i419A", function(module, exports) {

$parcel$export(module.exports, "LogoSvg", function () { return $d2697ecfe00e5040$export$77af5b11f07c3aed; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /** @jsx jsx */ 
var $avKww = parcelRequire("avKww");
var $d2697ecfe00e5040$export$77af5b11f07c3aed = function LogoSvg(_ref) {
    var alt = _ref.alt, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, className = _ref.className, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size;
    var stroke = isDisabled ? "var(--ds-icon-disabled, #091E424F)" : "var(--ds-icon, #44546F)";
    return (0, $avKww.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        stroke: stroke,
        className: className,
        role: alt === "" ? "presentation" : undefined
    }, alt && (0, $avKww.jsx)("title", null, alt), (0, $avKww.jsx)("path", {
        d: "M14.5 14.5L17.5 17.5",
        strokeWidth: "1.5",
        strokeLinecap: "square"
    }), (0, $avKww.jsx)("path", {
        d: "M9.5 14.5L6.5 17.5",
        strokeWidth: "1.5",
        strokeLinecap: "square"
    }), (0, $avKww.jsx)("path", {
        d: "M9.5 9.5L6.5 6.5",
        strokeWidth: "1.5",
        strokeLinecap: "square"
    }), (0, $avKww.jsx)("path", {
        d: "M14.5 9.5L17.5 6.5",
        strokeWidth: "1.5",
        strokeLinecap: "square"
    }), (0, $avKww.jsx)("path", {
        d: "M12.0001 16V19",
        strokeWidth: "1.5"
    }), (0, $avKww.jsx)("path", {
        d: "M8.00012 12L5.00012 12",
        strokeWidth: "1.5"
    }), (0, $avKww.jsx)("path", {
        d: "M12.0001 8.00002L12.0001 4.99999",
        strokeWidth: "1.5"
    }), (0, $avKww.jsx)("path", {
        d: "M16.0002 12L19.0002 12",
        strokeWidth: "1.5"
    }));
};

});

parcelRegister("dJfxn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aafd29b2ee368e9f$export$2e2bcd8739ae039; });
const $aafd29b2ee368e9f$var$urls = {
    ui: {
        learnMore: ()=>`https://support.atlassian.com/organization-administration/docs/learn-about-atlassian-intelligence/`,
        trustCenter: ()=>`https://www.atlassian.com/trust/atlassian-intelligence`,
        acceptableUsePolicy: ()=>`https://www.atlassian.com/legal/acceptable-use-policy`,
        specificToS: ()=>`https://www.atlassian.com/legal/product-specific-terms#atlassian-intelligence-specific-terms`,
        otherProducts: ()=>"https://support.atlassian.com/organization-administration/docs/activate-atlassian-intelligence-for-products/"
    }
};
var $aafd29b2ee368e9f$export$2e2bcd8739ae039 = $aafd29b2ee368e9f$var$urls;

});

parcelRegister("aJCYU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c4a15011a631f44$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $8c4a15011a631f44$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    userAiOnboardingFlagTitle: {
        "id": "frontbucket.pullRequest.userAiOnboardingFlagTitle",
        "defaultMessage": "Introducing Atlassian Intelligence (AI)"
    },
    userAiOnboardingFlagDescription: {
        "id": "frontbucket.pullRequest.userAiOnboardingFlagDescription",
        "defaultMessage": "Write pull request descriptions, generate comments, or change the tone of your comments using AI. Access it via the {editorToolbar} or by typing {aiShortcut} in the description or comment fields."
    },
    userAiOnboardingFlagEditorToolbar: {
        "id": "frontbucket.pullRequest.userAiOnboardingFlagEditorToolbar",
        "defaultMessage": "editor toolbar"
    },
    userAiOnboardingFlagLearnMore: {
        "id": "frontbucket.pullRequest.userAiOnboardingFlagLearnMore",
        "defaultMessage": "Learn more"
    }
});

});

parcelRegister("9D1Ab", function(module, exports) {

$parcel$export(module.exports, "AILogoWrapper", function () { return $f0b768509a0229c4$export$cf3264e141188a64; });

var $2xJU3 = parcelRequire("2xJU3");

var $h39Sh = parcelRequire("h39Sh");
const $f0b768509a0229c4$export$cf3264e141188a64 = (0, $2xJU3.default)("div", {
    target: "ej2mkn40"
})("> svg{width:", (0, $h39Sh.default)("space.300", "24px"), ";height:", (0, $h39Sh.default)("space.300", "24px"), ";}");

});


parcelRegister("dbdtR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9986c26bfd5e88d4$export$2e2bcd8739ae039; });

var $44n3P = parcelRequire("44n3P");

var $9986c26bfd5e88d4$var$ExportedAnalyticsListener;
$9986c26bfd5e88d4$var$ExportedAnalyticsListener = (0, $44n3P.default);
var $9986c26bfd5e88d4$export$2e2bcd8739ae039 = $9986c26bfd5e88d4$var$ExportedAnalyticsListener;

});
parcelRegister("44n3P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f696c876858f3f2$export$2e2bcd8739ae039; });

var $5Rl6H = parcelRequire("5Rl6H");

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");

var $kZnbM = parcelRequire("kZnbM");
var $2f696c876858f3f2$var$ContextTypes = {
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func
};
var $2f696c876858f3f2$var$noop = function() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $2f696c876858f3f2$var$AnalyticsListener = /** @class */ function(_super) {
    (0, $5Rl6H.__extends)(AnalyticsListener, _super);
    function AnalyticsListener(props) {
        var _this = _super.call(this, props) || this;
        _this.getChildContext = function() {
            return {
                getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers,
                getAtlaskitAnalyticsContext: _this.getAtlaskitAnalyticsContext
            };
        };
        _this.getAnalyticsEventHandlers = function() {
            var _a = _this.props, channel = _a.channel, onEvent = _a.onEvent;
            var _b = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _b === void 0 ? $2f696c876858f3f2$var$noop : _b;
            var handler = function(event, eventChannel) {
                if (channel === "*" || channel === eventChannel) onEvent(event, eventChannel);
            };
            return (0, $5Rl6H.__spread)([
                handler
            ], getAtlaskitAnalyticsEventHandlers());
        };
        _this.getAtlaskitAnalyticsContext = function() {
            var _a = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _a === void 0 ? $2f696c876858f3f2$var$noop : _a;
            return getAtlaskitAnalyticsContext();
        };
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    AnalyticsListener.prototype.render = function() {
        var children = this.props.children;
        return (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kZnbM.default).Provider, {
            value: this.contextValue
        }, children);
    };
    AnalyticsListener.contextTypes = $2f696c876858f3f2$var$ContextTypes;
    AnalyticsListener.childContextTypes = $2f696c876858f3f2$var$ContextTypes;
    return AnalyticsListener;
}((0, $9nHZC.Component));
var $2f696c876858f3f2$export$2e2bcd8739ae039 = $2f696c876858f3f2$var$AnalyticsListener;

});


parcelRegister("c03Tp", function(module, exports) {

$parcel$export(module.exports, "SCREEN", function () { return $8bc8811f07099b4b$export$f636b5b56f1d624a; });
$parcel$export(module.exports, "UI_EVENT_TYPE", function () { return $8bc8811f07099b4b$export$a1562d08625f5d7e; });
$parcel$export(module.exports, "TRACK_EVENT_TYPE", function () { return $8bc8811f07099b4b$export$947dac6c72b26f81; });
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", function () { return $8bc8811f07099b4b$export$f1d537d508d2945a; });
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", function () { return $8bc8811f07099b4b$export$12346a674644c156; });
$parcel$export(module.exports, "ANALYTICS_BRIDGE_CHANNEL", function () { return $8bc8811f07099b4b$export$2ceccf177fae277c; });
var $8bc8811f07099b4b$export$f636b5b56f1d624a = "Screen";
var $8bc8811f07099b4b$export$9d2de6eebf7462b5 = "Drawer";
var $8bc8811f07099b4b$export$1171103ea9083ffa = "Modal";
var $8bc8811f07099b4b$export$cae2783c9279926 = "InlineDialog";
var $8bc8811f07099b4b$export$d1123261ca8831d2 = "Dropdown";
var $8bc8811f07099b4b$export$a1562d08625f5d7e = "UI";
var $8bc8811f07099b4b$export$947dac6c72b26f81 = "TRACK";
var $8bc8811f07099b4b$export$f1d537d508d2945a = "SCREEN";
var $8bc8811f07099b4b$export$12346a674644c156 = "OPERATIONAL";
var $8bc8811f07099b4b$export$2ceccf177fae277c = "analyticsBridge";

});

parcelRegister("a3lEo", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $751afa859d85b6ef$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $751afa859d85b6ef$var$isUndefined;

});

parcelRegister("4ym3q", function(module, exports) {

var $dpOau = parcelRequire("dpOau");

var $huB3R = parcelRequire("huB3R");

var $7cshz = parcelRequire("7cshz");
/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */ function $350b71e88c37f101$var$omitBy(object, predicate) {
    return $7cshz(object, $huB3R($dpOau(predicate)));
}
module.exports = $350b71e88c37f101$var$omitBy;

});
parcelRegister("dpOau", function(module, exports) {

var $3bqVt = parcelRequire("3bqVt");

var $5Mk1O = parcelRequire("5Mk1O");

var $eQNRM = parcelRequire("eQNRM");

var $lsPUZ = parcelRequire("lsPUZ");

var $gaIfk = parcelRequire("gaIfk");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $9c448684732c7a1c$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $eQNRM;
    if (typeof value == "object") return $lsPUZ(value) ? $5Mk1O(value[0], value[1]) : $3bqVt(value);
    return $gaIfk(value);
}
module.exports = $9c448684732c7a1c$var$baseIteratee;

});
parcelRegister("3bqVt", function(module, exports) {

var $4sMvO = parcelRequire("4sMvO");

var $dYZYl = parcelRequire("dYZYl");

var $fcSla = parcelRequire("fcSla");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $25174922aebfc736$var$baseMatches(source) {
    var matchData = $dYZYl(source);
    if (matchData.length == 1 && matchData[0][2]) return $fcSla(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $4sMvO(object, source, matchData);
    };
}
module.exports = $25174922aebfc736$var$baseMatches;

});
parcelRegister("fcSla", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $b12220e16f518d6a$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $b12220e16f518d6a$var$matchesStrictComparable;

});


parcelRegister("5Mk1O", function(module, exports) {

var $6Ewzi = parcelRequire("6Ewzi");

var $5BOIP = parcelRequire("5BOIP");

var $4oMUl = parcelRequire("4oMUl");

var $jRbZM = parcelRequire("jRbZM");

var $kK3Bb = parcelRequire("kK3Bb");

var $fcSla = parcelRequire("fcSla");

var $fyTMm = parcelRequire("fyTMm");
/** Used to compose bitmasks for value comparisons. */ var $4350f89ddd13a140$var$COMPARE_PARTIAL_FLAG = 1, $4350f89ddd13a140$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $4350f89ddd13a140$var$baseMatchesProperty(path, srcValue) {
    if ($jRbZM(path) && $kK3Bb(srcValue)) return $fcSla($fyTMm(path), srcValue);
    return function(object) {
        var objValue = $5BOIP(object, path);
        return objValue === undefined && objValue === srcValue ? $4oMUl(object, path) : $6Ewzi(srcValue, objValue, $4350f89ddd13a140$var$COMPARE_PARTIAL_FLAG | $4350f89ddd13a140$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $4350f89ddd13a140$var$baseMatchesProperty;

});
parcelRegister("5BOIP", function(module, exports) {

var $eKdOr = parcelRequire("eKdOr");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $4157c0cc514c64e9$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $eKdOr(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $4157c0cc514c64e9$var$get;

});
parcelRegister("eKdOr", function(module, exports) {

var $3HwTM = parcelRequire("3HwTM");

var $fyTMm = parcelRequire("fyTMm");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $abc01378b4e87ae9$var$baseGet(object, path) {
    path = $3HwTM(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$fyTMm(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $abc01378b4e87ae9$var$baseGet;

});


parcelRegister("4oMUl", function(module, exports) {

var $hWFgG = parcelRequire("hWFgG");

var $00kFt = parcelRequire("00kFt");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $333f576391238968$var$hasIn(object, path) {
    return object != null && $00kFt(object, path, $hWFgG);
}
module.exports = $333f576391238968$var$hasIn;

});
parcelRegister("hWFgG", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d107dd70b51cb562$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $d107dd70b51cb562$var$baseHasIn;

});

parcelRegister("00kFt", function(module, exports) {

var $3HwTM = parcelRequire("3HwTM");

var $3gXKg = parcelRequire("3gXKg");

var $lsPUZ = parcelRequire("lsPUZ");

var $btWIf = parcelRequire("btWIf");

var $cDdYu = parcelRequire("cDdYu");

var $fyTMm = parcelRequire("fyTMm");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $000042334242b72e$var$hasPath(object, path, hasFunc) {
    path = $3HwTM(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $fyTMm(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $cDdYu(length) && $btWIf(key, length) && ($lsPUZ(object) || $3gXKg(object));
}
module.exports = $000042334242b72e$var$hasPath;

});



parcelRegister("gaIfk", function(module, exports) {

var $kp5WK = parcelRequire("kp5WK");

var $057mo = parcelRequire("057mo");

var $jRbZM = parcelRequire("jRbZM");

var $fyTMm = parcelRequire("fyTMm");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $bc5fe6e1ba206b66$var$property(path) {
    return $jRbZM(path) ? $kp5WK($fyTMm(path)) : $057mo(path);
}
module.exports = $bc5fe6e1ba206b66$var$property;

});
parcelRegister("kp5WK", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $edaac154c4f9c30c$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $edaac154c4f9c30c$var$baseProperty;

});

parcelRegister("057mo", function(module, exports) {

var $eKdOr = parcelRequire("eKdOr");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $00f62d56c4fa9248$var$basePropertyDeep(path) {
    return function(object) {
        return $eKdOr(object, path);
    };
}
module.exports = $00f62d56c4fa9248$var$basePropertyDeep;

});



parcelRegister("huB3R", function(module, exports) {
/** Error message constants. */ var $cbc1fc9e9facca82$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */ function $cbc1fc9e9facca82$var$negate(predicate) {
    if (typeof predicate != "function") throw new TypeError($cbc1fc9e9facca82$var$FUNC_ERROR_TEXT);
    return function() {
        var args = arguments;
        switch(args.length){
            case 0:
                return !predicate.call(this);
            case 1:
                return !predicate.call(this, args[0]);
            case 2:
                return !predicate.call(this, args[0], args[1]);
            case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
    };
}
module.exports = $cbc1fc9e9facca82$var$negate;

});

parcelRegister("7cshz", function(module, exports) {

var $Ne8Zl = parcelRequire("Ne8Zl");

var $dpOau = parcelRequire("dpOau");

var $aRYtr = parcelRequire("aRYtr");

var $1Uoz3 = parcelRequire("1Uoz3");
/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function $53df97b63b40e92f$var$pickBy(object, predicate) {
    if (object == null) return {};
    var props = $Ne8Zl($1Uoz3(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = $dpOau(predicate);
    return $aRYtr(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
module.exports = $53df97b63b40e92f$var$pickBy;

});
parcelRegister("aRYtr", function(module, exports) {

var $eKdOr = parcelRequire("eKdOr");

var $lyCKU = parcelRequire("lyCKU");

var $3HwTM = parcelRequire("3HwTM");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $7e9dc37dc4ad6eb9$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $eKdOr(object, path);
        if (predicate(value, path)) $lyCKU(result, $3HwTM(path, object), value);
    }
    return result;
}
module.exports = $7e9dc37dc4ad6eb9$var$basePickBy;

});



parcelRegister("b82uS", function(module, exports) {

var $kwTPS = parcelRequire("kwTPS");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $81a260ed24b250bf$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $kwTPS(array, 1) : [];
}
module.exports = $81a260ed24b250bf$var$flatten;

});
parcelRegister("kwTPS", function(module, exports) {

var $c6wCA = parcelRequire("c6wCA");

var $87Ht5 = parcelRequire("87Ht5");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $ef221b9b908f060b$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $87Ht5);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $ef221b9b908f060b$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $c6wCA(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $ef221b9b908f060b$var$baseFlatten;

});
parcelRegister("87Ht5", function(module, exports) {

var $lgMoJ = parcelRequire("lgMoJ");

var $3gXKg = parcelRequire("3gXKg");

var $lsPUZ = parcelRequire("lsPUZ");
/** Built-in value references. */ var $5ea0b2080af8e108$var$spreadableSymbol = $lgMoJ ? $lgMoJ.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $5ea0b2080af8e108$var$isFlattenable(value) {
    return $lsPUZ(value) || $3gXKg(value) || !!($5ea0b2080af8e108$var$spreadableSymbol && value && value[$5ea0b2080af8e108$var$spreadableSymbol]);
}
module.exports = $5ea0b2080af8e108$var$isFlattenable;

});



parcelRegister("olABV", function(module, exports) {

var $aOYKK = parcelRequire("aOYKK");

var $aziB8 = parcelRequire("aziB8");

var $eJYvo = parcelRequire("eJYvo");

var $8a1Kn = parcelRequire("8a1Kn");

var $filBO = parcelRequire("filBO");

var $jO8iW = parcelRequire("jO8iW");
/** Used as the size to enable large array optimizations. */ var $0492fd3aca190646$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $0492fd3aca190646$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $aziB8, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $eJYvo;
    } else if (length >= $0492fd3aca190646$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $filBO(array);
        if (set) return $jO8iW(set);
        isCommon = false;
        includes = $8a1Kn;
        seen = new $aOYKK;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $0492fd3aca190646$var$baseUniq;

});
parcelRegister("aziB8", function(module, exports) {

var $lKWhC = parcelRequire("lKWhC");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $7b1b996b3fc3942f$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $lKWhC(array, value, 0) > -1;
}
module.exports = $7b1b996b3fc3942f$var$arrayIncludes;

});
parcelRegister("lKWhC", function(module, exports) {

var $1KSyC = parcelRequire("1KSyC");

var $2WfoY = parcelRequire("2WfoY");

var $bVhVy = parcelRequire("bVhVy");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $fd6b1aa7b2fee4f3$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $bVhVy(array, value, fromIndex) : $1KSyC(array, $2WfoY, fromIndex);
}
module.exports = $fd6b1aa7b2fee4f3$var$baseIndexOf;

});
parcelRegister("1KSyC", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $147468469de26663$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $147468469de26663$var$baseFindIndex;

});

parcelRegister("2WfoY", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $223cf20b52bef8f9$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $223cf20b52bef8f9$var$baseIsNaN;

});

parcelRegister("bVhVy", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $8ae2ec8b50cdc9c7$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $8ae2ec8b50cdc9c7$var$strictIndexOf;

});



parcelRegister("eJYvo", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $abb433bcf2aed214$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $abb433bcf2aed214$var$arrayIncludesWith;

});

parcelRegister("filBO", function(module, exports) {

var $1emko = parcelRequire("1emko");

var $9tjXs = parcelRequire("9tjXs");

var $jO8iW = parcelRequire("jO8iW");
/** Used as references for various `Number` constants. */ var $b2294c8a2faddea1$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $b2294c8a2faddea1$var$createSet = !($1emko && 1 / $jO8iW(new $1emko([
    ,
    -0
]))[1] == $b2294c8a2faddea1$var$INFINITY) ? $9tjXs : function(values) {
    return new $1emko(values);
};
module.exports = $b2294c8a2faddea1$var$createSet;

});


parcelRegister("fpWfS", function(module, exports) {

$parcel$export(module.exports, "ExperienceName", function () { return $0301f8767135418b$export$b881bd9f00ed8ed1; });
$parcel$export(module.exports, "getExperienceTracker", function () { return $0301f8767135418b$export$a1fa58e5690a5a9a; });
$parcel$export(module.exports, "useExperienceTracker", function () { return $0301f8767135418b$export$cdefb2a8b53f879f; });
$parcel$export(module.exports, "ExperienceFailure", function () { return $0301f8767135418b$export$eed1d73ebdd8c7ab; });
$parcel$export(module.exports, "ExperienceSuccess", function () { return $0301f8767135418b$export$4962f3898bd5c829; });
$parcel$export(module.exports, "ExperienceStart", function () { return $0301f8767135418b$export$f20b867e738a222c; });
$parcel$export(module.exports, "ExperienceAbort", function () { return $0301f8767135418b$export$c9b6bcd70239a39c; });

var $9nHZC = parcelRequire("9nHZC");

var $7ovNJ = parcelRequire("7ovNJ");
parcelRequire("dGzLf");
var $aAre5 = parcelRequire("aAre5");
parcelRequire("3hzea");
var $a5HLv = parcelRequire("a5HLv");

var $8lQoI = parcelRequire("8lQoI");
var $6gjHX = parcelRequire("6gjHX");

var $4dH0J = parcelRequire("4dH0J");

var $1EkdU = parcelRequire("1EkdU");

var $aanBq = parcelRequire("aanBq");

var $6aoKW = parcelRequire("6aoKW");
var $0301f8767135418b$export$b881bd9f00ed8ed1;
(function(ExperienceName) {
    ExperienceName["PULL_REQUEST_APPROVE"] = "pull-request/approve";
    ExperienceName["PULL_REQUEST_DIFF"] = "pull-request/diff";
    ExperienceName["PULL_REQUEST_CREATE"] = "pull-request/create";
    // sub-experiences for PR Create
    ExperienceName["CREATE_PR_SOURCE"] = "create-pr/source/load";
    ExperienceName["CREATE_PR_DEST"] = "create-pr/dest/load";
})($0301f8767135418b$export$b881bd9f00ed8ed1 || ($0301f8767135418b$export$b881bd9f00ed8ed1 = {}));
var $0301f8767135418b$export$5e180a90f8d3e374;
(function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 40000] = "DEFAULT";
})($0301f8767135418b$export$5e180a90f8d3e374 || ($0301f8767135418b$export$5e180a90f8d3e374 = {})); // ms
const $0301f8767135418b$export$9c05e7ef9f2c8895 = (event)=>({
        // Events should match the schema defined here:
        // https://hello.atlassian.net/wiki/spaces/BIZOPS/pages/387788554/Analytics+Event+Schema+for+SLA
        source: "ui",
        actionSubject: "ui",
        actionSubjectId: event.name,
        action: event.action,
        eventType: "operational",
        attributes: $0301f8767135418b$var$createExperienceTrackerAnalyticsAttributes(event)
    });
function $0301f8767135418b$var$createExperienceTrackerAnalyticsAttributes(event) {
    const { action: action, name: name, id: id, attributes: experienceAttributes, ...rest } = event;
    const attributes = {
        ...experienceAttributes,
        ...rest,
        task: name,
        taskId: id
    };
    if (attributes.error) {
        let error;
        if (typeof attributes.error === "string") error = new Error(attributes.error);
        else error = attributes.error;
        delete attributes.error;
        attributes.errorName = error.name;
        if (!attributes.traceId && error.traceId) attributes.traceId = error.traceId;
        attributes.errorMessage = error.message;
    }
    attributes.browserInfo = window.navigator.userAgent;
    // Matches the analytics-web-client's apdex event
    attributes.isActiveTab = document.visibilityState === "visible";
    return attributes;
}
const $0301f8767135418b$export$a1fa58e5690a5a9a = (0, $7ovNJ.default)(()=>{
    const tracker = new (0, $8lQoI.ExperienceTracker)();
    tracker.subscribe((event)=>{
        if (event.action === "taskSuccess" || event.action === "taskFail" || event.action === "taskAbort" || event.action === "taskStart") (0, $6aoKW.publishOperationalEvent)($0301f8767135418b$export$9c05e7ef9f2c8895(event));
    });
    return tracker;
});
function $0301f8767135418b$var$isFetchNetworkError(e) {
    return e instanceof TypeError && [
        "NetworkError when attempting to fetch resource.",
        // Firefox
        "Failed to fetch",
        // Chrome
        "Load failed" // Safari
    ].includes(e.message);
}
const $0301f8767135418b$export$cdefb2a8b53f879f = (name)=>{
    const experienceTracker = (0, $9nHZC.useContext)((0, $6gjHX.ExperienceTrackerContext));
    const repositoryId = (0, $aAre5.useSelector)((0, $aanBq.getCurrentRepositoryUuid));
    const workspaceId = (0, $aAre5.useSelector)((0, $aanBq.getCurrentRepositoryWorkspaceUUID));
    const prId = (0, $aAre5.useSelector)((0, $1EkdU.getCurrentPullRequestId));
    if (experienceTracker === null) throw new Error("useExperienceTracker requires a parent ExperienceTrackerContextProvider");
    const ids = (0, $9nHZC.useMemo)(()=>{
        return {
            repositoryId: (0, $a5HLv.uncurlyUuid)(repositoryId || ""),
            workspaceId: (0, $a5HLv.uncurlyUuid)(workspaceId || ""),
            prId: prId
        };
    }, [
        repositoryId,
        workspaceId,
        prId
    ]);
    const startExperience = (0, $9nHZC.useCallback)((options)=>{
        experienceTracker.start({
            id: (0, $4dH0J.generateUuid)(),
            // timeout: ExperienceTimeout.DEFAULT,
            attributes: ids,
            ...options,
            name: name
        });
    }, [
        name,
        ids,
        experienceTracker
    ]);
    const succeedExperience = (0, $9nHZC.useCallback)(// allow consumer to pass additional event attributes on success
    (additionalAttributes)=>{
        experienceTracker.succeed({
            name: name,
            attributes: additionalAttributes ? {
                ...additionalAttributes,
                ...ids
            } : ids
        });
    }, [
        name,
        ids,
        experienceTracker
    ]);
    const abortExperience = (0, $9nHZC.useCallback)((reason)=>{
        experienceTracker.abort({
            name: name,
            reason: reason,
            attributes: ids,
            checkForTimeout: false // disallow `taskAbort` to be converted into `taskFail`
        });
    }, [
        name,
        ids,
        experienceTracker
    ]);
    const failExperience = (0, $9nHZC.useCallback)((error)=>{
        // These errors are indicative of client-side failures to access Bitbucket.
        // We don't want to count these against our SLA calculations.
        if ($0301f8767135418b$var$isFetchNetworkError(error)) abortExperience(error.message);
        else experienceTracker.fail({
            name: name,
            error: error,
            attributes: ids
        });
    }, [
        name,
        ids,
        experienceTracker,
        abortExperience
    ]);
    (0, $9nHZC.useEffect)(()=>{
        return ()=>{
            abortExperience("component unload");
        };
    }, [
        abortExperience
    ]);
    return {
        startExperience: startExperience,
        succeedExperience: succeedExperience,
        failExperience: failExperience,
        abortExperience: abortExperience
    };
};
function $0301f8767135418b$export$eed1d73ebdd8c7ab({ name: name, error: error }) {
    const { failExperience: failExperience } = $0301f8767135418b$export$cdefb2a8b53f879f(name);
    (0, $9nHZC.useEffect)(()=>failExperience(error), [
        failExperience,
        error
    ]);
    return null;
}
function $0301f8767135418b$export$4962f3898bd5c829({ name: name }) {
    const { succeedExperience: succeedExperience } = $0301f8767135418b$export$cdefb2a8b53f879f(name);
    (0, $9nHZC.useEffect)(()=>succeedExperience(), [
        succeedExperience
    ]);
    return null;
}
function $0301f8767135418b$export$f20b867e738a222c({ options: options }) {
    const { startExperience: startExperience } = $0301f8767135418b$export$cdefb2a8b53f879f(options.name);
    (0, $9nHZC.useEffect)(()=>{
        startExperience(options);
    }, [
        startExperience,
        options
    ]);
    return null;
}
function $0301f8767135418b$export$c9b6bcd70239a39c({ reason: reason, name: name }) {
    const { abortExperience: abortExperience } = $0301f8767135418b$export$cdefb2a8b53f879f(name);
    (0, $9nHZC.useEffect)(()=>abortExperience(reason), [
        abortExperience,
        reason
    ]);
    return null;
}

});
parcelRegister("8lQoI", function(module, exports) {

$parcel$export(module.exports, "ExperienceTracker", function () { return $6148edfa545c41d7$export$12b6b072930fd68f; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");

var $iht9A = parcelRequire("iht9A");
var $6148edfa545c41d7$export$12b6b072930fd68f = /*#__PURE__*/ function() {
    function ExperienceTracker(options) {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ExperienceTracker);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "experiences", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "subscribers", []);
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || function() {
            return false;
        };
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ExperienceTracker, [
        {
            key: "start",
            value: function start(_ref) {
                var _this = this;
                var name = _ref.name, id = _ref.id, timeout = _ref.timeout, startTime = _ref.startTime, attributes = _ref.attributes, onSuccess = _ref.onSuccess, onFailure = _ref.onFailure, onAbort = _ref.onAbort, collect = _ref.collect;
                var current = this.experiences[name];
                if (current && !current.hasStopped && current.id === id) return;
                // Before replacing a current experience, abort it to ensure
                // it is cleaned up.
                if (current) current.abort({
                    reason: "Aborted because the same experience was started with a new id"
                });
                var experience = new (0, $iht9A.Experience)({
                    name: name,
                    id: id,
                    timeout: timeout,
                    startTime: startTime,
                    attributes: attributes,
                    onSuccess: onSuccess,
                    onFailure: onFailure,
                    onAbort: onAbort,
                    onStart: function onStart(startEvent) {
                        _this.emit(startEvent);
                        var disposeCollectSubscription = function disposeCollectSubscription() {};
                        if (collect) {
                            var _events = [];
                            disposeCollectSubscription = _this.subscribe(function(event) {
                                // Ignore already running experiences that started before this
                                // experience started
                                if (event.action === "taskStart" || _events.some(function(previousEvent) {
                                    return previousEvent.name === event.name && previousEvent.action === "taskStart";
                                })) {
                                    _events.push(event);
                                    collect(_events, experience);
                                }
                            });
                        }
                        return function(stopEvent) {
                            disposeCollectSubscription();
                            _this.emit(stopEvent);
                        };
                    }
                });
                this.experiences[name] = experience;
            }
        },
        {
            key: "succeed",
            value: function succeed(_ref2) {
                var name = _ref2.name, attributes = _ref2.attributes;
                var current = this.experiences[name];
                if (!current) return;
                current.succeed(attributes);
            }
        },
        {
            key: "fail",
            value: function fail(_ref3) {
                var name = _ref3.name, error = _ref3.error, attributes = _ref3.attributes;
                Object.values(this.experiences).forEach(function(current) {
                    if (name != null && current.name !== name) return;
                    current.fail({
                        error: error,
                        attributes: attributes
                    });
                });
            }
        },
        {
            key: "abort",
            value: function abort(_ref4) {
                var name = _ref4.name, reason = _ref4.reason, attributes = _ref4.attributes, checkForTimeout = _ref4.checkForTimeout;
                function abort(experience) {
                    if (name != null && experience.name !== name) return;
                    experience.abort({
                        reason: reason,
                        checkForTimeout: checkForTimeout,
                        attributes: attributes
                    });
                }
                var experiencesWithTimeouts = Object.values(this.experiences).filter(function(experience) {
                    return experience.timeout;
                });
                var experiencesWithoutTimeouts = Object.values(this.experiences).filter(function(experience) {
                    return !experience.timeout;
                });
                // We need to abort all experiences with timeouts first in order to properly
                // capture compound experiences composed of sub-experiences which have timeouts
                experiencesWithTimeouts.forEach(abort);
                experiencesWithoutTimeouts.forEach(abort);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(subscriber) {
                var _this2 = this;
                if (typeof subscriber !== "function") throw new Error("Subscriber must be a function");
                this.subscribers.push(subscriber);
                return function() {
                    _this2.subscribers = _this2.subscribers.filter(function(x) {
                        return x !== subscriber;
                    });
                };
            }
        },
        {
            key: "stopOnError",
            value: function stopOnError(_ref5) {
                var name = _ref5.name, error = _ref5.error, attributes = _ref5.attributes;
                if (this.isNetworkOfflineError(error)) {
                    this.abort({
                        name: name,
                        reason: "Aborted ".concat(name, " because of network error: ").concat(error.toString()),
                        checkForTimeout: false,
                        attributes: attributes
                    });
                    return;
                }
                return this.fail({
                    name: name,
                    error: error,
                    attributes: attributes
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                this.subscribers.forEach(function(subscriber) {
                    try {
                        subscriber(event);
                    } catch (e) {}
                });
            }
        }
    ]);
    return ExperienceTracker;
}();

});
parcelRegister("iht9A", function(module, exports) {

$parcel$export(module.exports, "Experience", function () { return $d4f06dd8573f18f7$export$c90b54e658fc4d7c; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");

var $agVfR = parcelRequire("agVfR");
function $d4f06dd8573f18f7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d4f06dd8573f18f7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d4f06dd8573f18f7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d4f06dd8573f18f7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d4f06dd8573f18f7$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return $d4f06dd8573f18f7$var$_objectSpread($d4f06dd8573f18f7$var$_objectSpread({}, first), last);
}
var $d4f06dd8573f18f7$export$c90b54e658fc4d7c = /*#__PURE__*/ function() {
    function Experience(_ref) {
        var name = _ref.name, id = _ref.id, timeout = _ref.timeout, _ref$startTime = _ref.startTime, startTime = _ref$startTime === void 0 ? window.performance.now() : _ref$startTime, attributes = _ref.attributes, onStart = _ref.onStart, onSuccess = _ref.onSuccess, onFailure = _ref.onFailure, onAbort = _ref.onAbort;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, Experience);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_hasStopped", false);
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        var startEvent = {
            action: "taskStart",
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(Experience, [
        {
            key: "hasStopped",
            get: function get() {
                return this._hasStopped;
            }
        },
        {
            key: "succeed",
            value: function succeed(attributes) {
                if (this._hasStopped) return;
                this.onSuccess && this.onSuccess();
                this.stop({
                    action: "taskSuccess",
                    name: this.name,
                    id: this.id,
                    startTime: this.startTime,
                    duration: this.getDuration(),
                    attributes: $d4f06dd8573f18f7$var$mergeAttributes(this.attributes, attributes)
                });
            }
        },
        {
            key: "fail",
            value: function fail(_ref2) {
                var error = _ref2.error, attributes = _ref2.attributes;
                if (this._hasStopped) return;
                this.onFailure && this.onFailure();
                this.stop({
                    action: "taskFail",
                    name: this.name,
                    id: this.id,
                    startTime: this.startTime,
                    duration: this.getDuration(),
                    error: error,
                    attributes: $d4f06dd8573f18f7$var$mergeAttributes(this.attributes, attributes)
                });
            }
        },
        {
            key: "abort",
            value: function abort(_ref3) {
                var reason = _ref3.reason, attributes = _ref3.attributes, _ref3$checkForTimeout = _ref3.checkForTimeout, checkForTimeout = _ref3$checkForTimeout === void 0 ? true : _ref3$checkForTimeout;
                if (this._hasStopped) return;
                // Check if the experience should have failed due to timeout
                if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
                    this.fail({
                        attributes: attributes,
                        error: new (0, $agVfR.ExperienceTimeoutError)("".concat(this.name, " failed to complete in ").concat(this.timeout, "ms"))
                    });
                    return;
                }
                this.onAbort && this.onAbort();
                this.stop({
                    action: "taskAbort",
                    name: this.name,
                    id: this.id,
                    startTime: this.startTime,
                    duration: this.getDuration(),
                    reason: reason,
                    checkForTimeout: checkForTimeout,
                    attributes: $d4f06dd8573f18f7$var$mergeAttributes(this.attributes, attributes)
                });
            }
        },
        {
            key: "stopOn",
            value: function stopOn(event) {
                if (!event) return;
                if (event.action === "taskSuccess") this.succeed();
                else if (event.action === "taskAbort") this.abort({
                    reason: event.reason,
                    checkForTimeout: event.checkForTimeout
                });
                else if (event.action === "taskFail") this.fail({
                    error: event.error
                });
            }
        },
        {
            key: "stop",
            value: function stop(event) {
                this._hasStopped = true;
                if (this.onStop) this.onStop(event);
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                return Math.round(window.performance.now() - this.startTime);
            }
        }
    ]);
    return Experience;
}();

});
parcelRegister("agVfR", function(module, exports) {

$parcel$export(module.exports, "ExperienceTimeoutError", function () { return $77a7cfa10a8115da$export$d27a2b6293f7631c; });

var $eVDe4 = parcelRequire("eVDe4");

var $uqRmf = parcelRequire("uqRmf");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $6FnrE = parcelRequire("6FnrE");
function $77a7cfa10a8115da$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $77a7cfa10a8115da$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $77a7cfa10a8115da$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($77a7cfa10a8115da$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $77a7cfa10a8115da$export$d27a2b6293f7631c = /*#__PURE__*/ function(_Error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(ExperienceTimeoutError, _Error);
    var _super = $77a7cfa10a8115da$var$_createSuper(ExperienceTimeoutError);
    function ExperienceTimeoutError(message) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ExperienceTimeoutError);
        _this = _super.call(this, message);
        _this.name = "ExperienceTimeoutError";
        return _this;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ExperienceTimeoutError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6FnrE)))(Error));

});



parcelRegister("6gjHX", function(module, exports) {

$parcel$export(module.exports, "ExperienceTrackerContext", function () { return $48f386501cf03647$export$a7b0697657ed8bd0; });

var $9nHZC = parcelRequire("9nHZC");
var $48f386501cf03647$export$a7b0697657ed8bd0 = /*#__PURE__*/ (0, $9nHZC.createContext)({
    abort: function abort() {},
    fail: function fail() {},
    start: function start() {},
    succeed: function succeed() {},
    stopOnError: function stopOnError() {},
    subscribe: function subscribe() {
        return function() {};
    }
});

});

parcelRegister("4dH0J", function(module, exports) {

$parcel$export(module.exports, "generateUuid", function () { return $9b60cdc0d007fa91$export$1c3aefb711c3a4cc; });
$parcel$export(module.exports, "uuid", function () { return $9b60cdc0d007fa91$export$31b40729666a4ae0; });
/* eslint-disable no-bitwise */ const $9b60cdc0d007fa91$export$1c3aefb711c3a4cc = ()=>"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === "x" ? r : r & 0x3 | 0x8).toString(16);
    });
/* eslint-enable no-bitwise */ let $9b60cdc0d007fa91$var$staticValue = false;
const $9b60cdc0d007fa91$export$31b40729666a4ae0 = {
    setStatic (value) {
        $9b60cdc0d007fa91$var$staticValue = value;
    },
    generate () {
        return $9b60cdc0d007fa91$var$staticValue || $9b60cdc0d007fa91$export$1c3aefb711c3a4cc();
    }
};

});


parcelRegister("4FqTo", function(module, exports) {

$parcel$export(module.exports, "initializeBrowserMetrics", function () { return (parcelRequire("3REYY")).initializeBrowserMetrics; });
$parcel$export(module.exports, "useBrowserMetricsWatcher", function () { return (parcelRequire("3REYY")).useBrowserMetricsWatcher; });
$parcel$export(module.exports, "MetricSender", function () { return (parcelRequire("7RxS0")).MetricSender; });
$parcel$export(module.exports, "useAbortMetricOnUnmount", function () { return (parcelRequire("7RxS0")).useAbortMetricOnUnmount; });
$parcel$export(module.exports, "useMetricSender", function () { return (parcelRequire("7RxS0")).useMetricSender; });
$parcel$export(module.exports, "startMetric", function () { return (parcelRequire("3TI1y")).startMetric; });
$parcel$export(module.exports, "PageSegmentMetricStarter", function () { return (parcelRequire("eRsFk")).PageSegmentMetricStarter; });

var $3REYY = parcelRequire("3REYY");

var $7RxS0 = parcelRequire("7RxS0");

var $3TI1y = parcelRequire("3TI1y");

var $eRsFk = parcelRequire("eRsFk");

var $iYwpt = parcelRequire("iYwpt");

});
parcelRegister("3REYY", function(module, exports) {

$parcel$export(module.exports, "initializeBrowserMetrics", function () { return $deaa7e5cb1e09324$export$efcab8bd082cbc1f; });
$parcel$export(module.exports, "useBrowserMetricsWatcher", function () { return $deaa7e5cb1e09324$export$85df16dc533e8be9; });

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("lM4y8");
var $b7V6F = parcelRequire("b7V6F");

var $iqLpb = parcelRequire("iqLpb");

var $c7cuD = parcelRequire("c7cuD");

var $1jQQK = parcelRequire("1jQQK");

var $bBcuy = parcelRequire("bBcuy");

var $1ZBmx = parcelRequire("1ZBmx");

var $jS1LM = parcelRequire("jS1LM");
const $deaa7e5cb1e09324$export$efcab8bd082cbc1f = (sessionData)=>{
    const { isAtlassian: isAtlassian, featureFlagClient: featureFlagClient, frontbucket_version: frontbucket_version } = sessionData;
    (0, $iqLpb.browserMetrics).init({
        info: {
            app: {
                framework: {
                    name: "react",
                    version: (0, $9nHZC.version)
                },
                version: {
                    web: frontbucket_version
                }
            },
            hostname: window.location.hostname,
            product: "bitbucket",
            region: "unknown"
        },
        endpoints: {
            eventPipelineClient: Promise.resolve((0, $bBcuy.analyticsClient)())
        },
        events: {
            all: {
                custom: {
                    ssr: (0, $1ZBmx.appWasServerSideRendered)(),
                    isAtlassian: isAtlassian
                }
            }
        },
        plugins: {
            featureFlags: {
                client: Promise.resolve({
                    getValue: (featureFlagKey)=>featureFlagClient.getFlagValue(featureFlagKey, false)
                })
            },
            resourceTimings: {
                mapResources: $jS1LM.mapResources,
                sanitiseEndpoints: $jS1LM.sanitiseEndpoints
            },
            bundleEvalTimings: $jS1LM.bundleEvalTimings
        },
        ssr: {
            getDoneMark: ()=>{
                var _getMark;
                return (_getMark = (0, $c7cuD.getMark)((0, $1jQQK.PERFORMANCE_MARK_SSR_HTML))) !== null && _getMark !== void 0 ? _getMark : null;
            },
            getTimings: ()=>null
        },
        enableReactUFOTracker: true
    });
    // We should start the page load metric immediately, outside of the React
    // render cycle. Only this first page load is marked as `isInitial`;
    (0, $iqLpb.browserMetrics).startPageLoad({
        isInitial: true
    });
};
const $deaa7e5cb1e09324$export$85df16dc533e8be9 = ()=>{
    const [routerState] = (0, $b7V6F.useRouter)();
    // From my testing, the only actions that should start metrics are PUSH
    // events, when a user clicks a link and we append a value to the browser
    // history. Page loads have some combination of POP and REPLACE actions (and
    // those are already tracked separately above). Some client links also have
    // REPLACE actions, but that is after the initial PUSH action (and we want to
    // start tracking from the very first event).
    if (routerState.action === "PUSH") (0, $iqLpb.browserMetrics).startPageLoad();
};

});
parcelRegister("iqLpb", function(module, exports) {

$parcel$export(module.exports, "browserMetrics", function () { return $d6af6d636d759f83$export$c08e7affcf78b064; });

var $kFnE9 = parcelRequire("kFnE9");

var $aj6q4 = parcelRequire("aj6q4");

var $6VOgp = parcelRequire("6VOgp");

var $iFHHo = parcelRequire("iFHHo");

var $ehmYT = parcelRequire("ehmYT");

var $9ubiG = parcelRequire("9ubiG");

var $778Ru = parcelRequire("778Ru");

var $4RrJ9 = parcelRequire("4RrJ9");

var $lqMQx = parcelRequire("lqMQx");
function $d6af6d636d759f83$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d6af6d636d759f83$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d6af6d636d759f83$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d6af6d636d759f83$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d6af6d636d759f83$var$makeBrowserMetrics = function makeBrowserMetrics() {
    var bm = {
        init: function init(config) {
            var _config$events$BMEven, _config$ssr;
            (0, $ehmYT.visibilityChangeObserver).start();
            if ((_config$events$BMEven = config.events[(0, $lqMQx.BMEventsType).WEB_VITALS]) !== null && _config$events$BMEven !== void 0 && _config$events$BMEven.enabled) (0, $9ubiG.webVitalsObserver).start();
            if (config.debug) {
                (0, $6VOgp.logger).enable();
                (0, $4RrJ9.submitter).setDebug(true);
                (0, $iFHHo.pageLoadMetaMetric).setDebug(true);
            }
            (0, $4RrJ9.submitter).configure(config);
            if ((_config$ssr = config.ssr) !== null && _config$ssr !== void 0 && _config$ssr.getDoneMark) (0, $aj6q4.SSRGetDoneMark).setGetDoneMark(config.ssr.getDoneMark);
        },
        setRoute: function setRoute(newRoute) {
            (0, $778Ru.Route).setRoute(newRoute);
        },
        startPageLoad: function startPageLoad(params) {
            (0, $iFHHo.pageLoadMetaMetric).startPageLoad($d6af6d636d759f83$var$_objectSpread({
                isInitial: false,
                cancelStarted: true
            }, params));
        },
        getPageLoadMetric: function getPageLoadMetric() {
            return 0, $iFHHo.pageLoadMetaMetric;
        },
        experimental__addPageLoadTimingFromPerformanceMarks: function experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark) {
            var initialOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
            if (initialOnly && !(0, $iFHHo.pageLoadMetaMetric).isInitialLoad()) return;
            var start = performance.getEntriesByName(startMark);
            var stop = performance.getEntriesByName(stopMark);
            if (start.length > 0 && stop.length > 0) {
                if ((0, $iFHHo.pageLoadMetaMetric).isDebugMode()) try {
                    performance.measure(name, startMark, stopMark);
                } catch (e) {}
                var pageLoadData = (0, $iFHHo.pageLoadMetaMetric).getData();
                if (pageLoadData.start !== null) {
                    var _startMark = start[start.length - 1];
                    var timing = {
                        startTime: Math.round(_startMark.startTime - pageLoadData.start),
                        duration: Math.round(stop[stop.length - 1].startTime - _startMark.startTime)
                    };
                    (0, $iFHHo.pageLoadMetaMetric).experimental__addExplicitTiming(name, timing);
                }
            }
        }
    };
    return bm;
};
var $d6af6d636d759f83$export$c08e7affcf78b064 = $d6af6d636d759f83$var$makeBrowserMetrics();

});
parcelRegister("aj6q4", function(module, exports) {

$parcel$export(module.exports, "SSRGetDoneMark", function () { return $7810a887c5097a8c$export$9e87a201397ac0a9; });
var $7810a887c5097a8c$export$9e87a201397ac0a9 = {
    getDoneMark: function() {
        return null;
    },
    setGetDoneMark: function setGetDoneMark(fn) {
        $7810a887c5097a8c$export$9e87a201397ac0a9.getDoneMark = fn;
    }
};

});

parcelRegister("6VOgp", function(module, exports) {

$parcel$export(module.exports, "logger", function () { return $50bf0e3ed06c7ab7$export$af88d00dbe7f521; });
var $50bf0e3ed06c7ab7$export$af88d00dbe7f521 = {
    enabled: false,
    enable: function enable() {
        this.enabled = true;
    },
    log: function log() {
        if (this.enabled) {
            var _console;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            // eslint-disable-next-line no-console
            (_console = console).log.apply(_console, [
                "BM log: "
            ].concat(args));
        }
    },
    logCond: function logCond(condition) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        if (this.enabled && condition && args.length > 1) this.log.apply(this, args);
    }
};

});

parcelRegister("iFHHo", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetaMetric", function () { return $d97df409d690a203$export$24b7a1a311eb05dc; });

var $lOQkO = parcelRequire("lOQkO");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $lqMQx = parcelRequire("lqMQx");

var $ahvvj = parcelRequire("ahvvj");

var $jpp6o = parcelRequire("jpp6o");
var $d97df409d690a203$var$_excluded = [
    "cancelStarted"
];
function $d97df409d690a203$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d97df409d690a203$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $d97df409d690a203$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d97df409d690a203$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $d97df409d690a203$export$9609608c00ea5077 = /*#__PURE__*/ function(_BasePageLoadMetric) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(PageLoadMetaMetric, _BasePageLoadMetric);
    var _super = $d97df409d690a203$var$_createSuper(PageLoadMetaMetric);
    function PageLoadMetaMetric() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, PageLoadMetaMetric);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "activePageLoadMetric", null);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(PageLoadMetaMetric, [
        {
            key: "startPageLoad",
            value: function startPageLoad() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                    isInitial: false,
                    cancelStarted: false
                };
                var cancelStarted = _ref.cancelStarted, startPageLoadParams = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $d97df409d690a203$var$_excluded);
                if (cancelStarted || this.state !== (0, $ahvvj.MetricState).STARTED) (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(PageLoadMetaMetric.prototype), "startPageLoad", this).call(this, startPageLoadParams);
            }
        },
        {
            key: "setActive",
            value: function setActive(metric) {
                this.activePageLoadMetric = metric;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(debug) {
                this.config.debug = debug;
            }
        },
        {
            key: "isDebugMode",
            value: function isDebugMode() {
                return this.config.debug;
            }
        },
        {
            key: "isInitialLoad",
            value: function isInitialLoad() {
                return this.isInitial;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.activePageLoadMetric && this.activePageLoadMetric.cancel();
                (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(PageLoadMetaMetric.prototype), "clear", this).call(this);
            }
        },
        {
            key: "include",
            value: function include(metric) {
                if (!this.config.include) this.config.include = [
                    metric
                ];
                else this.config.include.push(metric);
            }
        },
        {
            key: "experimental__addExplicitTiming",
            value: function experimental__addExplicitTiming(name, timing) {
                if (this.explicitTimings === null) this.explicitTimings = {};
                this.explicitTimings[name] = timing;
            }
        }
    ]);
    return PageLoadMetaMetric;
}((0, $jpp6o.BasePageLoadMetric));
var $d97df409d690a203$export$24b7a1a311eb05dc = new $d97df409d690a203$export$9609608c00ea5077({
    type: (0, $lqMQx.BMEventsType).PAGE_LOAD,
    key: "page_load_meta_metric"
});

});
parcelRegister("lqMQx", function(module, exports) {

$parcel$export(module.exports, "BMEventsType", function () { return $f9a1ea8dff0c402e$export$9c73e297d4be9159; });
$parcel$export(module.exports, "StorableBMEventsType", function () { return $f9a1ea8dff0c402e$export$9b7037ec30489597; });
$parcel$export(module.exports, "BMPageLoadMetrics", function () { return $f9a1ea8dff0c402e$export$74c1fb0997d51e2a; });
$parcel$export(module.exports, "BMPageSegmentLoadMetrics", function () { return $f9a1ea8dff0c402e$export$88195ac8200d03a6; });
$parcel$export(module.exports, "BMInteractionMetrics", function () { return $f9a1ea8dff0c402e$export$6e28252a002afdb2; });
$parcel$export(module.exports, "PageSegmentPageLoadMetricsOptions", function () { return $f9a1ea8dff0c402e$export$474154836bfd8dd9; });
$parcel$export(module.exports, "PageVisibleFields", function () { return $f9a1ea8dff0c402e$export$e89802082dab5633; });
$parcel$export(module.exports, "PageVisibleValueOrigin", function () { return $f9a1ea8dff0c402e$export$983b017156c2aee2; });
$parcel$export(module.exports, "isDetailedPageLoadSlo", function () { return $f9a1ea8dff0c402e$export$5866f95702a15142; });
$parcel$export(module.exports, "isDetailedPageSegmentLoadSlo", function () { return $f9a1ea8dff0c402e$export$f087a59bd717e49d; });
$parcel$export(module.exports, "isInteractionMetricsSlo", function () { return $f9a1ea8dff0c402e$export$b10c1d9a7db7765b; });
$parcel$export(module.exports, "IncludeSSRFeatureFlagsConfig", function () { return $f9a1ea8dff0c402e$export$60c0193054fc3040; });

var $ahvvj = parcelRequire("ahvvj");
var $f9a1ea8dff0c402e$export$9c73e297d4be9159 = /*#__PURE__*/ function(BMEventsType) {
    BMEventsType["PAGE_LOAD"] = "PAGE_LOAD";
    BMEventsType["PAGE_SEGMENT_LOAD"] = "PAGE_SEGMENT_LOAD";
    BMEventsType["INLINE_RESULT"] = "INLINE_RESULT";
    BMEventsType["CUSTOM"] = "CUSTOM";
    BMEventsType["WEB_VITALS"] = "WEB_VITALS";
    return BMEventsType;
}({});
var $f9a1ea8dff0c402e$export$9b7037ec30489597 = /*#__PURE__*/ function(StorableBMEventsType) {
    StorableBMEventsType["PAGE_LOAD"] = "page-load";
    StorableBMEventsType["PAGE_SEGMENT_LOAD"] = "page-segment-load";
    StorableBMEventsType["INLINE_RESULT"] = "inline-result";
    StorableBMEventsType["CUSTOM"] = "custom";
    StorableBMEventsType["WEB_VITALS"] = "web-vitals";
    return StorableBMEventsType;
}({});
var $f9a1ea8dff0c402e$export$74c1fb0997d51e2a = /*#__PURE__*/ function(BMPageLoadMetrics) {
    BMPageLoadMetrics["fmp"] = "fmp";
    BMPageLoadMetrics["tti"] = "tti";
    return BMPageLoadMetrics;
}({});
var $f9a1ea8dff0c402e$export$88195ac8200d03a6 = /*#__PURE__*/ function(BMPageSegmentLoadMetrics) {
    BMPageSegmentLoadMetrics["fmp"] = "fmp";
    BMPageSegmentLoadMetrics["tti"] = "tti";
    return BMPageSegmentLoadMetrics;
}({});
var $f9a1ea8dff0c402e$export$6e28252a002afdb2 = /*#__PURE__*/ function(BMInteractionMetrics) {
    BMInteractionMetrics["response"] = "response";
    BMInteractionMetrics["result"] = "result";
    return BMInteractionMetrics;
}({});
var $f9a1ea8dff0c402e$export$474154836bfd8dd9 = /*#__PURE__*/ function(PageSegmentPageLoadMetricsOptions) {
    PageSegmentPageLoadMetricsOptions["OFF"] = "OFF";
    PageSegmentPageLoadMetricsOptions["IF_PRESENT"] = "IF_PRESENT";
    PageSegmentPageLoadMetricsOptions["WAIT_UNTIL_PRESENT"] = "WAIT_UNTIL_PRESENT";
    return PageSegmentPageLoadMetricsOptions;
}({});
var $f9a1ea8dff0c402e$export$e89802082dab5633 = /*#__PURE__*/ function(PageVisibleFields) {
    PageVisibleFields["pageVisibleState"] = "page-visible-state";
    PageVisibleFields["pageVisibleValue"] = "page-visible-value";
    return PageVisibleFields;
}({});
var $f9a1ea8dff0c402e$export$983b017156c2aee2 = /*#__PURE__*/ function(PageVisibleValueOrigin) {
    PageVisibleValueOrigin["documentHidden"] = "document-hidden";
    PageVisibleValueOrigin["pageVisibleState"] = "page-visible-state";
    return PageVisibleValueOrigin;
}({});
var $f9a1ea8dff0c402e$export$5866f95702a15142 = function isDetailedPageLoadSlo(data) {
    return Boolean(data.initial);
};
var $f9a1ea8dff0c402e$export$f087a59bd717e49d = function isDetailedPageSegmentLoadSlo(data) {
    return Boolean(data.initial);
};
var $f9a1ea8dff0c402e$export$153c4c72fa5eeece = function isPageLoadMetricsSlo(data) {
    var obj = data;
    return Boolean(obj.fmp !== undefined || obj.tti !== undefined);
};
var $f9a1ea8dff0c402e$export$b10c1d9a7db7765b = function isInteractionMetricsSlo(data) {
    var obj = data;
    return Boolean(obj.result !== undefined || obj.response !== undefined);
};
var $f9a1ea8dff0c402e$export$60c0193054fc3040 = /*#__PURE__*/ function(IncludeSSRFeatureFlagsConfig) {
    IncludeSSRFeatureFlagsConfig["NEVER"] = "never";
    IncludeSSRFeatureFlagsConfig["WHEN_FMP"] = "when-fmp";
    IncludeSSRFeatureFlagsConfig["WHEN_AVAILABLE"] = "when-available";
    return IncludeSSRFeatureFlagsConfig;
}({});

});
parcelRegister("ahvvj", function(module, exports) {

$parcel$export(module.exports, "MetricState", function () { return $77c3edf5ee0c76a0$export$1e458f18c0c7bfe3; });
$parcel$export(module.exports, "PageVisibleState", function () { return $77c3edf5ee0c76a0$export$a12c67b37a306b13; });
$parcel$export(module.exports, "BaseMetric", function () { return $77c3edf5ee0c76a0$export$2bce4ffdd840e878; });

var $b4Ivn = parcelRequire("b4Ivn");

var $9q1kH = parcelRequire("9q1kH");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");

var $hGxkd = parcelRequire("hGxkd");

var $6VOgp = parcelRequire("6VOgp");

var $ehmYT = parcelRequire("ehmYT");

var $fRBfy = parcelRequire("fRBfy");
function $77c3edf5ee0c76a0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $77c3edf5ee0c76a0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $77c3edf5ee0c76a0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $77c3edf5ee0c76a0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $77c3edf5ee0c76a0$export$1e458f18c0c7bfe3 = /*#__PURE__*/ function(MetricState) {
    MetricState["NOT_STARTED"] = "not-started";
    MetricState["STARTED"] = "started";
    MetricState["FINISHED"] = "finished";
    MetricState["CANCELLED"] = "cancelled";
    return MetricState;
}({});
var $77c3edf5ee0c76a0$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["MIXED"] = "mixed";
    PageVisibleState["HIDDEN"] = "hidden";
    return PageVisibleState;
}({});
function $77c3edf5ee0c76a0$var$getPageVisibleState() {
    return typeof document !== "undefined" && document.visibilityState === "visible" ? $77c3edf5ee0c76a0$export$a12c67b37a306b13.VISIBLE : $77c3edf5ee0c76a0$export$a12c67b37a306b13.HIDDEN;
}
var $77c3edf5ee0c76a0$export$2bce4ffdd840e878 = /*#__PURE__*/ function() {
    function BaseMetric(config) {
        var _this = this, _this$config$timings;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, BaseMetric);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "state", $77c3edf5ee0c76a0$export$1e458f18c0c7bfe3.NOT_STARTED);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "startTime", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "stopTime", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "marks", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "onStopCallbacks", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "custom", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "submetrics", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "route", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "untilOnStopCallback", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "pageVisibleState", $77c3edf5ee0c76a0$var$getPageVisibleState());
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "setPageVisibleStateToMixed", function() {
            _this.pageVisibleState = $77c3edf5ee0c76a0$export$a12c67b37a306b13.MIXED;
        });
        this.config = config;
        this.key = config.key.replace(/ /gi, "-");
        this.type = config.type;
        (_this$config$timings = this.config.timings) === null || _this$config$timings === void 0 || _this$config$timings.forEach(function(entry) {
            if ((0, $hGxkd.restrictedTimingKeys).includes(entry.key)) {
                // eslint-disable-next-line no-console
                console.warn("Entry ".concat(entry.key, " is restricted and has been renamed to custom__").concat(entry.key));
                entry.key = "custom__".concat(entry.key);
            }
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(BaseMetric, [
        {
            key: "untilMetrics",
            get: function get() {
                var until = this.config.until;
                if (!until) return [];
                else if (Array.isArray(until)) return this.getConfiguredUntilMetricArray(until);
                return this.getConfiguredUntilMetricArray([
                    until
                ]);
            }
        },
        {
            key: "start",
            value: function start() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$startTime = _ref.startTime, startTime = _ref$startTime === void 0 ? window.performance.now() : _ref$startTime;
                this.clear();
                (0, $6VOgp.logger).logCond(!!this.config.debug, this.key, startTime);
                this.state = $77c3edf5ee0c76a0$export$1e458f18c0c7bfe3.STARTED;
                this.startTime = startTime;
                this.pageVisibleState = $77c3edf5ee0c76a0$var$getPageVisibleState();
                (0, $ehmYT.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                this.watchUntil();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var stopArguments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var _stopArguments$stopTi = stopArguments.stopTime, stopTime = _stopArguments$stopTi === void 0 ? window.performance.now() : _stopArguments$stopTi;
                if (this.state !== $77c3edf5ee0c76a0$export$1e458f18c0c7bfe3.STARTED || this.startTime === null) {
                    (0, $6VOgp.logger).log("metric ".concat(this.config.key, " has been stopped while not being started before; current state: ").concat(this.state));
                    return false;
                }
                if (stopTime < this.startTime) {
                    (0, $6VOgp.logger).log("metric ".concat(this.config.key, " has been stopped with stopTime lower than startTime; startTime: ").concat(this.startTime, "; stopTime: ").concat(stopTime));
                    return false;
                }
                this.stopTime = stopTime;
                this.state = $77c3edf5ee0c76a0$export$1e458f18c0c7bfe3.FINISHED;
                this.handleStop(stopArguments);
                (0, $ehmYT.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
                return true;
            }
        },
        {
            key: "handleStop",
            value: function handleStop(stopArguments) {
                var _this2 = this;
                var _stopArguments$custom = stopArguments.customData, customData = _stopArguments$custom === void 0 ? null : _stopArguments$custom;
                if (customData) this.custom = $77c3edf5ee0c76a0$var$_objectSpread($77c3edf5ee0c76a0$var$_objectSpread({}, this.custom), customData);
                this.config.include && this.config.include.forEach(function(metric) {
                    var included = metric.getData();
                    if (included.state === $77c3edf5ee0c76a0$export$1e458f18c0c7bfe3.FINISHED && included.start !== null && included.start >= (_this2.startTime || 0)) _this2.addSubMetric(metric.getData());
                });
                this.onStopCallbacks.forEach(function(_ref2) {
                    var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref2, 1), success = _ref3[0];
                    success(stopArguments);
                });
                this.onStopCallbacks = [];
                (0, $6VOgp.logger).logCond(!!this.config.debug, this.key, this.config.debug && this.getData());
            }
        },
        {
            key: "mark",
            value: function mark(_mark) {
                var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
                this.marks[_mark] = timestamp;
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                if (this.state !== $77c3edf5ee0c76a0$export$1e458f18c0c7bfe3.STARTED) return;
                this.state = $77c3edf5ee0c76a0$export$1e458f18c0c7bfe3.CANCELLED;
                this.cancelUntil();
                this.onStopCallbacks.forEach(function(_ref4) {
                    var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref4, 2), cancel = _ref5[1];
                    cancel();
                });
                this.onStopCallbacks = [];
                (0, $ehmYT.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
            }
        },
        {
            key: "merge",
            value: function merge(mergeData) {
                this.state = mergeData.state;
                this.pageVisibleState = mergeData.pageVisibleState;
                this.startTime = mergeData.start;
                this.stopTime = mergeData.stop;
                this.marks = $77c3edf5ee0c76a0$var$_objectSpread($77c3edf5ee0c76a0$var$_objectSpread({}, this.marks), mergeData.marks);
                this.submetrics = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(this.submetrics), (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(mergeData.submetrics));
                this.onStopCallbacks = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(this.onStopCallbacks), (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(mergeData.onStopCallbacks));
            }
        },
        {
            key: "onStop",
            value: function onStop(success, cancel) {
                this.onStopCallbacks.push([
                    success,
                    cancel
                ]);
            }
        },
        {
            key: "removeOnStopCallback",
            value: function removeOnStopCallback(success) {
                var index = this.onStopCallbacks.findIndex(function(_ref6) {
                    var _ref7 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref6, 1), successCallback = _ref7[0];
                    return success === successCallback;
                });
                if (index > -1) this.onStopCallbacks.splice(index, 1);
            }
        },
        {
            key: "getData",
            value: function getData() {
                return {
                    key: this.key,
                    state: this.state,
                    start: this.startTime,
                    stop: this.stopTime,
                    //todo ranges
                    // ranges: this.makeRanges()
                    marks: this.marks,
                    // todo make copy
                    custom: this.custom,
                    submetrics: this.submetrics,
                    config: this.config,
                    route: this.route,
                    pageVisibleState: this.pageVisibleState,
                    type: this.config.type
                };
            }
        },
        {
            key: "getDataToMerge",
            value: function getDataToMerge() {
                return $77c3edf5ee0c76a0$var$_objectSpread($77c3edf5ee0c76a0$var$_objectSpread({}, this.getData()), {}, {
                    onStopCallbacks: this.onStopCallbacks
                });
            }
        },
        {
            key: "addSubMetric",
            value: function addSubMetric(data) {
                this.submetrics.push(data);
            }
        },
        {
            key: "getConfiguredUntilMetric",
            value: function getConfiguredUntilMetric(metricOrConfig) {
                return metricOrConfig instanceof BaseMetric ? (0, $fRBfy.UntilExperience).fromMetric(metricOrConfig) : (0, $fRBfy.UntilExperience).fromConfig(metricOrConfig);
            }
        },
        {
            key: "getConfiguredUntilMetricArray",
            value: function getConfiguredUntilMetricArray(metricArray) {
                var _this3 = this;
                if (!metricArray.length) return [];
                return metricArray.map(function(metric) {
                    return _this3.getConfiguredUntilMetric(metric);
                });
            }
        },
        {
            key: "isUntilFinished",
            value: function isUntilFinished() {
                return this.untilMetrics.every(function(metric) {
                    return metric.experience.getData().state === $77c3edf5ee0c76a0$export$1e458f18c0c7bfe3.FINISHED;
                });
            }
        },
        {
            key: "handleAllUntilFinished",
            value: function handleAllUntilFinished() {
                // Order by ascending stop time
                var sorted = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(this.untilMetrics).sort(function(m1, m2) {
                    return m1.getDependencyStopTime() - m2.getDependencyStopTime();
                });
                // Find the latest page segment to become fully interactive
                var latestFullyInteractiveSegment = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(this.untilMetrics).reduce(function(currentLatestSegment, metric) {
                    var _currentLatestSegment, _metric$getFullyInter;
                    var currentLatestStopTime = (_currentLatestSegment = currentLatestSegment === null || currentLatestSegment === void 0 ? void 0 : currentLatestSegment.getFullyInteractiveStopTime()) !== null && _currentLatestSegment !== void 0 ? _currentLatestSegment : 0;
                    var metricStopTime = (_metric$getFullyInter = metric.getFullyInteractiveStopTime()) !== null && _metric$getFullyInter !== void 0 ? _metric$getFullyInter : 0;
                    return metricStopTime > currentLatestStopTime ? metric : currentLatestSegment;
                }, undefined);
                // Accumulate the custom data from each metric, later metrics take priority
                var accumulatedCustomData = {};
                sorted.forEach(function(metric) {
                    Object.assign(accumulatedCustomData, metric.experience.getData().custom);
                });
                var latestSegment = sorted[sorted.length - 1];
                var latestFullyInteractiveStopTime = latestFullyInteractiveSegment === null || latestFullyInteractiveSegment === void 0 ? void 0 : latestFullyInteractiveSegment.getFullyInteractiveStopTime();
                this.stop({
                    stopTime: latestSegment.getDependencyStopTime(),
                    customData: $77c3edf5ee0c76a0$var$_objectSpread($77c3edf5ee0c76a0$var$_objectSpread({}, accumulatedCustomData), {}, {
                        segment: latestSegment.getKey(),
                        segmentOverrided: latestSegment.getIsSegmentLoadOverrided()
                    }, latestFullyInteractiveStopTime ? {
                        latestFullyInteractiveSegment: latestFullyInteractiveSegment === null || latestFullyInteractiveSegment === void 0 ? void 0 : latestFullyInteractiveSegment.getKey(),
                        latestFullyInteractiveStopTime: latestFullyInteractiveStopTime
                    } : {})
                });
            }
        },
        {
            key: "watchUntil",
            value: function watchUntil() {
                var _this4 = this;
                if (!this.untilMetrics.length) return;
                if (this.isUntilFinished()) {
                    // Already finished, handle it immediately
                    this.handleAllUntilFinished();
                    return;
                }
                // If not currently finished, register stop callbacks to re-check
                this.untilOnStopCallback = function() {
                    if (_this4.isUntilFinished()) _this4.handleAllUntilFinished();
                };
                this.untilMetrics.forEach(function(metric) {
                    if (metric.experience.getData().state !== $77c3edf5ee0c76a0$export$1e458f18c0c7bfe3.FINISHED) metric.experience.onStop(_this4.untilOnStopCallback, function() {
                        return _this4.cancel();
                    });
                });
            }
        },
        {
            key: "cancelUntil",
            value: function cancelUntil() {
                var _this5 = this;
                this.untilMetrics.forEach(function(metric) {
                    if (metric.experience.getData().state !== $77c3edf5ee0c76a0$export$1e458f18c0c7bfe3.CANCELLED && _this5.untilOnStopCallback) metric.experience.removeOnStopCallback(_this5.untilOnStopCallback);
                });
            }
        },
        {
            key: "clear",
            value: function clear() {
                // todo before clearing - handle cancelling existing onStop / unsubscribe submetrics
                this.cancelUntil();
                this.state = $77c3edf5ee0c76a0$export$1e458f18c0c7bfe3.NOT_STARTED;
                this.startTime = null;
                this.stopTime = null;
                this.marks = {};
                this.custom = null;
                this.submetrics = [];
                this.route = null;
                this.pageVisibleState = $77c3edf5ee0c76a0$var$getPageVisibleState();
            }
        }
    ]);
    return BaseMetric;
}();
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($77c3edf5ee0c76a0$export$2bce4ffdd840e878, "FMP", "fmp");

});
parcelRegister("hGxkd", function(module, exports) {

$parcel$export(module.exports, "restrictedTimingKeys", function () { return $ce00359053a6997c$export$1d17377365286b00; });
$parcel$export(module.exports, "clsWaitTimeMs", function () { return $ce00359053a6997c$export$df21d285cfcda81e; });
var $ce00359053a6997c$export$1d17377365286b00 = [
    "ssr"
];
var $ce00359053a6997c$export$df21d285cfcda81e = 7500;

});

parcelRegister("ehmYT", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", function () { return $a6547ac6c5599c0e$export$13e680397ec8f3eb; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
var $a6547ac6c5599c0e$var$VisibilityChangeObserver = /*#__PURE__*/ function() {
    function VisibilityChangeObserver() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, VisibilityChangeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "observers", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "broadcast", function() {
            _this.observers.forEach(function(fn) {
                return fn();
            });
            _this.observers = [];
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(VisibilityChangeObserver, [
        {
            key: "start",
            value: function start() {
                document.addEventListener("visibilitychange", this.broadcast);
                /**
       * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
       * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
       * so for that case, you need to also include code to listen for the pagehide event.
       */ window.addEventListener("pagehide", this.broadcast);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                this.observers.push(callback);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(callback) {
                this.observers = this.observers.filter(function(fn) {
                    return fn !== callback;
                });
            }
        }
    ]);
    return VisibilityChangeObserver;
}();
var $a6547ac6c5599c0e$export$13e680397ec8f3eb = new $a6547ac6c5599c0e$var$VisibilityChangeObserver();

});

parcelRegister("fRBfy", function(module, exports) {

$parcel$export(module.exports, "UntilExperience", function () { return $b8c8b3499a76b089$export$3fcc0936ee2cc852; });

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
var $b8c8b3499a76b089$export$3fcc0936ee2cc852 = /*#__PURE__*/ function() {
    function UntilExperience(experience, useFmpAsUntilStopTime) {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UntilExperience);
        this.experience = experience;
        this.useFmpAsUntilStopTime = useFmpAsUntilStopTime;
    }
    /**
   * If FMP mark is present, return that
   * otherwise return the eventual load
   */ (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UntilExperience, [
        {
            key: "getFmp",
            value: function getFmp() {
                var _marks$UntilExperienc;
                var _this$experience$getD = this.experience.getData(), marks = _this$experience$getD.marks, stop = _this$experience$getD.stop;
                return (_marks$UntilExperienc = marks[UntilExperience.FMP]) !== null && _marks$UntilExperienc !== void 0 ? _marks$UntilExperienc : stop;
            }
        },
        {
            key: "getDependencyStopTime",
            value: function getDependencyStopTime() {
                if (this.useFmpAsUntilStopTime) return this.getFmp();
                return this.experience.getData().stop;
            }
        },
        {
            key: "getFullyInteractiveStopTime",
            value: function getFullyInteractiveStopTime() {
                return this.experience.getData().stop;
            }
        },
        {
            key: "getIsSegmentLoadOverrided",
            value: function getIsSegmentLoadOverrided() {
                if (this.useFmpAsUntilStopTime) {
                    var _this$experience$getD2 = this.experience.getData(), marks = _this$experience$getD2.marks;
                    return marks[UntilExperience.FMP] ? true : false;
                }
                return false;
            }
        },
        {
            key: "getKey",
            value: function getKey() {
                return this.experience.getData().key;
            }
        }
    ], [
        {
            key: "fromConfig",
            value: function fromConfig(config) {
                return new UntilExperience(config.experience, config.useFmpAsUntilStopTime);
            }
        },
        {
            key: "fromMetric",
            value: function fromMetric(metric) {
                return new UntilExperience(metric);
            }
        }
    ]);
    return UntilExperience;
}();
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($b8c8b3499a76b089$export$3fcc0936ee2cc852, "FMP", "fmp");

});



parcelRegister("jpp6o", function(module, exports) {

$parcel$export(module.exports, "BasePageLoadMetric", function () { return $e213d2de52ac7b6c$export$fd1447b187f590fe; });

var $b4Ivn = parcelRequire("b4Ivn");

var $fI6ia = parcelRequire("fI6ia");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $6VOgp = parcelRequire("6VOgp");

var $ahvvj = parcelRequire("ahvvj");
function $e213d2de52ac7b6c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e213d2de52ac7b6c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e213d2de52ac7b6c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e213d2de52ac7b6c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e213d2de52ac7b6c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e213d2de52ac7b6c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $e213d2de52ac7b6c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e213d2de52ac7b6c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $e213d2de52ac7b6c$export$fd1447b187f590fe = /*#__PURE__*/ function(_BaseMetric) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(BasePageLoadMetric, _BaseMetric);
    var _super = $e213d2de52ac7b6c$var$_createSuper(BasePageLoadMetric);
    function BasePageLoadMetric(args) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, BasePageLoadMetric);
        _this = _super.call(this, args);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "isInitial", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "explicitTimings", null);
        _this.config = args;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(BasePageLoadMetric, [
        {
            key: "start",
            value: function start() {
                (0, (/*@__PURE__*/$parcel$interopDefault($fI6ia)))(arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {});
                // please use startPageLoad
                return;
            }
        },
        {
            key: "startPageLoad",
            value: function startPageLoad() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                    isInitial: false
                };
                // todo this should update meta page load metric
                this.isInitial = params.isInitial;
                if (params.isInitial) (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(BasePageLoadMetric.prototype), "start", this).call(this, {
                    startTime: 0
                });
                else (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(BasePageLoadMetric.prototype), "start", this).call(this, params);
                (0, $6VOgp.logger).logCond(!!this.config.debug, this.key, this.startTime);
            }
        },
        {
            key: "stopPageLoad",
            value: function stopPageLoad(pageLoadMetaMetricData) {
                var stopArguments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    stopTime: window.performance.now()
                };
                if (pageLoadMetaMetricData.state !== (0, $ahvvj.MetricState).STARTED || pageLoadMetaMetricData.start === null || stopArguments.stopTime === undefined) {
                    (0, $6VOgp.logger).log("meta metric has been stopped while not being started before; current state: ".concat(this.state));
                    return false;
                }
                if (stopArguments.stopTime < pageLoadMetaMetricData.start) {
                    (0, $6VOgp.logger).log("metric ".concat(this.config.key, " has been stopped with stopTime lower than startTime; startTime: ").concat(pageLoadMetaMetricData.start, "; stopTime: ").concat(stopArguments.stopTime));
                    return false;
                }
                this.merge(pageLoadMetaMetricData);
                this.stopTime = stopArguments.stopTime;
                this.state = (0, $ahvvj.MetricState).FINISHED;
                this.handleStop(stopArguments);
                return true;
            }
        },
        {
            key: "handleStop",
            value: function handleStop(stopArguments) {
                var until = this.config.until;
                var fmpWasMarked = BasePageLoadMetric.FMP in this.marks;
                if (!fmpWasMarked && until) {
                    // Extract the maximum FMP value from the until metrics
                    var untilArr = Array.isArray(until) ? this.getConfiguredUntilMetricArray(until) : this.getConfiguredUntilMetricArray([
                        until
                    ]);
                    var untilFmpMarks = untilArr.map(function(metric) {
                        return metric.getFmp();
                    });
                    if (untilFmpMarks.every(Number.isFinite)) this.markFMP(Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(untilFmpMarks)));
                }
                (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(BasePageLoadMetric.prototype), "handleStop", this).call(this, stopArguments);
            }
        },
        {
            key: "mark",
            value: function mark(_mark) {
                var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
                if (_mark === BasePageLoadMetric.FMP) return;
                (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(BasePageLoadMetric.prototype), "mark", this).call(this, _mark, timestamp);
            }
        },
        {
            key: "merge",
            value: function merge(mergeData) {
                (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(BasePageLoadMetric.prototype), "merge", this).call(this, mergeData);
                this.isInitial = mergeData.isInitial;
                this.explicitTimings = this.explicitTimings || mergeData.explicitTimings ? $e213d2de52ac7b6c$var$_objectSpread($e213d2de52ac7b6c$var$_objectSpread({}, mergeData.explicitTimings), this.explicitTimings) : null;
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(BasePageLoadMetric.prototype), "mark", this).call(this, BasePageLoadMetric.FMP, timestamp);
            }
        },
        {
            key: "getPageLoadData",
            value: function getPageLoadData() {
                return {
                    isInitial: this.isInitial,
                    explicitTimings: this.explicitTimings
                };
            }
        },
        {
            key: "getData",
            value: function getData() {
                return $e213d2de52ac7b6c$var$_objectSpread($e213d2de52ac7b6c$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(BasePageLoadMetric.prototype), "getData", this).call(this)), this.getPageLoadData());
            }
        },
        {
            key: "getDataToMerge",
            value: function getDataToMerge() {
                return $e213d2de52ac7b6c$var$_objectSpread($e213d2de52ac7b6c$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(BasePageLoadMetric.prototype), "getDataToMerge", this).call(this)), this.getPageLoadData());
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.explicitTimings = null;
                (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(BasePageLoadMetric.prototype), "clear", this).call(this);
            }
        }
    ]);
    return BasePageLoadMetric;
}((0, $ahvvj.BaseMetric));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($e213d2de52ac7b6c$export$fd1447b187f590fe, "FMP", "fmp");

});


parcelRegister("9ubiG", function(module, exports) {

$parcel$export(module.exports, "webVitalsObserver", function () { return $6e7fae650d1e93f7$export$253d38dccbb37615; });

var $4mVfk = parcelRequire("4mVfk");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");

var $8DpVo = parcelRequire("8DpVo");


var $6e7fae650d1e93f7$var$WebVitalsObserver = /*#__PURE__*/ function() {
    function WebVitalsObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, WebVitalsObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "data", {
            "metric:ttci": null,
            "metric:ttfb": null,
            "metric:fid": null,
            "metric:fcp": null,
            "metric:lcp": null,
            "metric:cls": null
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(WebVitalsObserver, [
        {
            key: "start",
            value: function start() {
                this.ttciDetermined = this.registerTTCI();
                this.webVitalsDetermined = this.registerWebVitals();
            }
        },
        {
            key: "registerWebVitals",
            value: function() {
                var _registerWebVitals = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee() {
                    var _this = this;
                    var _yield$import, getCLS, getFCP, getFID, getLCP, getTTFB;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return (parcelRequire("acKKk"));
                            case 3:
                                _yield$import = _context.sent;
                                getCLS = _yield$import.getCLS;
                                getFCP = _yield$import.getFCP;
                                getFID = _yield$import.getFID;
                                getLCP = _yield$import.getLCP;
                                getTTFB = _yield$import.getTTFB;
                                _context.next = 11;
                                return Promise.all([
                                    getTTFB,
                                    getFID,
                                    getFCP,
                                    getLCP,
                                    getCLS
                                ].map(function(fx) {
                                    return new Promise(function(resolve) {
                                        fx(function(_ref) {
                                            var name = _ref.name, value = _ref.value;
                                            // round FCP, FID, LCP, TTFB to nearest integer.
                                            // CLS is rounded to two decimal places.
                                            var metricName = name.toLowerCase();
                                            var metricValue = metricName === "cls" ? parseFloat(value.toFixed(2)) : Math.round(value);
                                            _this.data["metric:".concat(metricName)] = metricValue;
                                            resolve();
                                        });
                                    });
                                }));
                            case 11:
                                _context.next = 15;
                                break;
                            case 13:
                                _context.prev = 13;
                                _context.t0 = _context["catch"](0);
                            case 15:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, null, [
                        [
                            0,
                            13
                        ]
                    ]);
                }));
                function registerWebVitals() {
                    return _registerWebVitals.apply(this, arguments);
                }
                return registerWebVitals;
            }()
        },
        {
            key: "registerTTCI",
            value: function() {
                var _registerTTCI = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee2() {
                    var _this2 = this;
                    var ttiPolyfill;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return (parcelRequire("kAewe"));
                            case 3:
                                ttiPolyfill = _context2.sent;
                                _context2.next = 6;
                                return ttiPolyfill.getFirstConsistentlyInteractive().then(function(value) {
                                    // according to the docs:
                                    // If no TTI value can be found, or if the browser doesn't support all the APIs required to detect TTI,
                                    // the promise resolves to null.
                                    _this2.data["metric:ttci"] = typeof value === "number" ? Math.round(value) : value;
                                    return true;
                                });
                            case 6:
                                _context2.next = 10;
                                break;
                            case 8:
                                _context2.prev = 8;
                                _context2.t0 = _context2["catch"](0);
                            case 10:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, null, [
                        [
                            0,
                            8
                        ]
                    ]);
                }));
                function registerTTCI() {
                    return _registerTTCI.apply(this, arguments);
                }
                return registerTTCI;
            }()
        }
    ]);
    return WebVitalsObserver;
}();
var $6e7fae650d1e93f7$export$253d38dccbb37615 = new $6e7fae650d1e93f7$var$WebVitalsObserver();

});
parcelRegister("acKKk", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("1iiJ8")).then(()=>parcelRequire("dRVR9"));

});

parcelRegister("kAewe", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("f4LfZ")).then(()=>parcelRequire("3LVkd"));

});


parcelRegister("778Ru", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $52e00f9a8e7980c4$export$e7b0ac011bb776c6; });
var $52e00f9a8e7980c4$export$e7b0ac011bb776c6 = {
    route: "",
    setRoute: function setRoute(newRoute) {
        this.route = newRoute;
    },
    getRoute: function getRoute() {
        return this.route;
    }
};

});

parcelRegister("4RrJ9", function(module, exports) {

$parcel$export(module.exports, "submitter", function () { return $38a19eb2420fe0c2$export$c21a25872e3f5a2b; });

var $4mVfk = parcelRequire("4mVfk");

var $8DpVo = parcelRequire("8DpVo");

var $6COnG = parcelRequire("6COnG");

var $lqMQx = parcelRequire("lqMQx");

var $ikFWs = parcelRequire("ikFWs");

var $bkfmQ = parcelRequire("bkfmQ");
var $38a19eb2420fe0c2$export$c21a25872e3f5a2b = {
    debug: false,
    config: {
        gasv3: undefined,
        configChunk: null,
        useVisibleState: false,
        histogram: {},
        enableReactUFOTracker: false
    },
    configure: function configure(config) {
        this.config.gasv3 = config.endpoints.eventPipelineClient;
        this.config.enableReactUFOTracker = config.enableReactUFOTracker;
        this.config.configChunk = (0, $bkfmQ.makeShareableGlobalConfig)(config);
        if (config.events.all && config.events.all.sfxEvents) this.config.useVisibleState = config.events.all.sfxEvents.activeTab === (0, $lqMQx.PageVisibleFields).pageVisibleState;
    },
    setDebug: function setDebug(debug) {
        this.debug = debug;
    },
    queue: function queue(data) {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee() {
            var chunk, payload, client, attributes;
            return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        if (_this.config.enableReactUFOTracker) (0, $6COnG.addBrowserMetricEvent)(data);
                        if (_this.config.configChunk) {
                            _context.next = 4;
                            break;
                        }
                        // eslint-disable-next-line no-console
                        _this.debug && console.warn("Submitter is not configured");
                        return _context.abrupt("return", null);
                    case 4:
                        _context.next = 6;
                        return _this.config.configChunk;
                    case 6:
                        chunk = _context.sent;
                        _context.next = 9;
                        return (0, $ikFWs.eventDataProcessor)(chunk[data.config.type], data);
                    case 9:
                        payload = _context.sent;
                        if (!(payload === null)) {
                            _context.next = 12;
                            break;
                        }
                        return _context.abrupt("return");
                    case 12:
                        if (!(_this.config.gasv3 !== undefined)) {
                            _context.next = 18;
                            break;
                        }
                        _context.next = 15;
                        return _this.config.gasv3;
                    case 15:
                        client = _context.sent;
                        attributes = {
                            task: payload["event:key"],
                            properties: payload
                        };
                        client && client.sendOperationalEvent({
                            actionSubject: "performance",
                            attributes: attributes,
                            source: "performance",
                            action: "measured"
                        });
                    case 18:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }))();
    }
};

});
parcelRegister("6COnG", function(module, exports) {

$parcel$export(module.exports, "addBrowserMetricEvent", function () { return $4d2d5f48822919f9$export$4a759336b50e86e3; });
parcelRequire("9q1kH");

var $kFnE9 = parcelRequire("kFnE9");

var $b4Ivn = parcelRequire("b4Ivn");

var $5m0MG = parcelRequire("5m0MG");

var $4Pw3J = parcelRequire("4Pw3J");

var $41O29 = parcelRequire("41O29");

var $hDvgZ = parcelRequire("hDvgZ");

var $4wIrX = parcelRequire("4wIrX");

var $biOnu = parcelRequire("biOnu");

var $2xpzD = parcelRequire("2xpzD");

var $fcJSo = parcelRequire("fcJSo");

var $eaDTp = parcelRequire("eaDTp");
function $4d2d5f48822919f9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4d2d5f48822919f9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4d2d5f48822919f9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4d2d5f48822919f9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4d2d5f48822919f9$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $4d2d5f48822919f9$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $4d2d5f48822919f9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4d2d5f48822919f9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4d2d5f48822919f9$var$_arrayLikeToArray(o, minLen);
}
function $4d2d5f48822919f9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $4d2d5f48822919f9$var$PreviousInteractionLog = {
    name: undefined,
    isAborted: undefined
};
var $4d2d5f48822919f9$var$interactionQueue = [];
var $4d2d5f48822919f9$var$segmentCache = new Map();
var $4d2d5f48822919f9$var$CLEANUP_TIMEOUT = 60000;
var $4d2d5f48822919f9$var$CLEANUP_TIMEOUT_AFTER_APDEX = 15000;
var $4d2d5f48822919f9$var$segmentObservers = [];
function $4d2d5f48822919f9$export$2b3954d2e8509985() {
    var interactionId = (0, $2xpzD.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $eaDTp.default).get(interactionId.current);
}
function $4d2d5f48822919f9$var$labelStackToString(labelStack, name) {
    var _stack$map;
    var stack = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(labelStack !== null && labelStack !== void 0 ? labelStack : []);
    if (name) stack.push({
        name: name
    });
    return (_stack$map = stack.map(function(l) {
        return l.name;
    })) === null || _stack$map === void 0 ? void 0 : _stack$map.join("/");
}
function $4d2d5f48822919f9$var$labelStackToIdString(labelStack) {
    var _labelStack$map;
    return labelStack === null || labelStack === void 0 || (_labelStack$map = labelStack.map(function(l) {
        return "segmentId" in l ? "".concat(l.name, ":").concat(l.segmentId) : "".concat(l.name);
    })) === null || _labelStack$map === void 0 ? void 0 : _labelStack$map.join("/");
}
function $4d2d5f48822919f9$var$addSegmentObserver(observer) {
    $4d2d5f48822919f9$var$segmentObservers.push(observer);
    var _iterator = $4d2d5f48822919f9$var$_createForOfIteratorHelper($4d2d5f48822919f9$var$segmentCache.values()), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var segmentInfo = _step.value;
            observer.onAdd(segmentInfo);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function $4d2d5f48822919f9$var$removeSegmentObserver(observer) {
    var index = $4d2d5f48822919f9$var$segmentObservers.findIndex(function(obs) {
        return obs === observer;
    });
    if (index !== -1) $4d2d5f48822919f9$var$segmentObservers.splice(index, 1);
}
function $4d2d5f48822919f9$export$cd7f480d6b8286c3(interactionId) {
    (0, $eaDTp.default).delete(interactionId);
}
function $4d2d5f48822919f9$export$12f2b6cb85d59904(interactionId, data) {
    var interaction = (0, $eaDTp.default).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(key) {
        interaction.metaData[key] = data[key];
    });
}
function $4d2d5f48822919f9$export$e4380431c2bdabee(interactionId, labelStack, data) {
    var interaction = (0, $eaDTp.default).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(i) {
        interaction.customData.push({
            labelStack: labelStack,
            data: (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, i, data[i])
        });
    });
}
function $4d2d5f48822919f9$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    var interaction = (0, $eaDTp.default).get(interactionId);
    if (interaction != null) {
        interaction.customTimings.push({
            labelStack: labelStack,
            data: data
        });
        var _i, _Object$entries, _Object$entries$_i, key, timingData, startTime, endTime, e;
    }
}
function $4d2d5f48822919f9$export$728e28c22a0fba4(interactionId, type, name, labelStack) {
    var time = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var interaction = (0, $eaDTp.default).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
}
function $4d2d5f48822919f9$export$c4b23cc624bd2fb(type, name, labelStack) {
    var time = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : performance.now();
    (0, $eaDTp.default).forEach(function(interaction) {
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
}
function $4d2d5f48822919f9$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start) {
    var end = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : performance.now();
    var size = arguments.length > 6 ? arguments[6] : undefined;
    var interaction = (0, $eaDTp.default).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        var e;
    }
}
function $4d2d5f48822919f9$export$943a8b2b5d6b1809(type, name, labelStack, start) {
    var end = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var size = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    (0, $eaDTp.default).forEach(function(interaction) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    var e;
}
function $4d2d5f48822919f9$export$9e04fe1a58571ec(moduleId, timestamp) {
    $4d2d5f48822919f9$export$c4b23cc624bd2fb("bundle_preload", moduleId, null, timestamp);
}
function $4d2d5f48822919f9$export$6f228d1fdc911d7(identifier, start, end) {
    $4d2d5f48822919f9$export$943a8b2b5d6b1809("bundle_load", identifier, null, start, end - start);
}
var $4d2d5f48822919f9$var$moduleLoadingRequests = {};
function $4d2d5f48822919f9$export$f5a8f10de74904da(input) {
    var result = input !== null && input !== void 0 ? input : "";
    result = result.replace(/^\.\/src\/packages\//, "");
    result = result.replace(/^\.\/node_modules\//, "");
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, "");
    return result;
}
function $4d2d5f48822919f9$export$7606887303596f82(interactionId, labelStack, name) {
    var interaction = (0, $eaDTp.default).get(interactionId);
    var id = (0, $5m0MG.v4)();
    if (interaction != null) {
        var start = performance.now();
        interaction.holdActive.set(id, {
            labelStack: labelStack,
            name: name,
            start: start
        });
        return function() {
            var end = performance.now();
            var e;
            var currentInteraction = (0, $eaDTp.default).get(interactionId);
            var currentHold = interaction.holdActive.get(id);
            if (currentInteraction != null && currentHold != null) {
                currentInteraction.holdInfo.push($4d2d5f48822919f9$var$_objectSpread($4d2d5f48822919f9$var$_objectSpread({}, currentHold), {}, {
                    end: end
                }));
                interaction.holdActive.delete(id);
            }
        };
    }
    return function() {};
}
function $4d2d5f48822919f9$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    var interaction = (0, $eaDTp.default).get(interactionId);
    if (interaction != null) {
        var start = performance.now();
        interaction.holdActive.set(id, {
            labelStack: labelStack,
            name: name,
            start: start,
            ignoreOnSubmit: ignoreOnSubmit
        });
    }
    return function() {};
}
function $4d2d5f48822919f9$export$4983dfbbb996f7ae(interactionId, id) {
    var interaction = (0, $eaDTp.default).get(interactionId);
    if (interaction != null) {
        var end = performance.now();
        var currentInteraction = (0, $eaDTp.default).get(interactionId);
        var currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            currentInteraction.holdInfo.push($4d2d5f48822919f9$var$_objectSpread($4d2d5f48822919f9$var$_objectSpread({}, currentHold), {}, {
                end: end
            }));
            interaction.holdActive.delete(id);
        }
    }
}
function $4d2d5f48822919f9$export$2df109852219d16e(interactionId) {
    var interaction = (0, $eaDTp.default).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
var $4d2d5f48822919f9$export$9591b52b33ccc510 = {
    onPreload: function onPreload(moduleId, _priority) {
        $4d2d5f48822919f9$export$9e04fe1a58571ec($4d2d5f48822919f9$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart: function onLoadStart(info) {
        var timeoutId = setTimeout(function() {
            delete $4d2d5f48822919f9$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        var request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $4d2d5f48822919f9$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete: function onLoadComplete(info) {
        var request = $4d2d5f48822919f9$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $4d2d5f48822919f9$var$moduleLoadingRequests[info.identifier];
            $4d2d5f48822919f9$export$6f228d1fdc911d7($4d2d5f48822919f9$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted: function placeholderFallBackMounted(id, moduleId) {
        var interactionId = (0, $2xpzD.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $4d2d5f48822919f9$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted: function placeholderFallBackUnmounted(id) {
        var interactionId = (0, $2xpzD.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $4d2d5f48822919f9$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $4d2d5f48822919f9$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError) {
    var interaction = (0, $eaDTp.default).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError
    });
}
function $4d2d5f48822919f9$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack) {
    (0, $eaDTp.default).forEach(function(interaction) {
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack
        });
    });
}
var $4d2d5f48822919f9$export$53d6f611de951a13 = function addProfilerTimings(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    var interaction = (0, $eaDTp.default).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
};
var $4d2d5f48822919f9$var$pushToQueue = function pushToQueue(id, data) {
    $4d2d5f48822919f9$var$interactionQueue.push({
        id: id,
        data: data
    });
};
var $4d2d5f48822919f9$var$handleInteraction = $4d2d5f48822919f9$var$pushToQueue;
function $4d2d5f48822919f9$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach(function(cleanUpCallback) {
        cleanUpCallback();
    });
}
var $4d2d5f48822919f9$var$finishInteraction = function finishInteraction(id, data) {
    var endTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    // eslint-disable-next-line no-param-reassign
    data.end = endTime;
    try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat(data.ufoName, " [ttai]"), {
            start: data.start,
            end: data.end
        });
    } catch (e) {
    // do nothing
    }
    if (data.featureFlags) // eslint-disable-next-line no-param-reassign
    data.featureFlags.during = Object.fromEntries((0, $biOnu.currentFeatureFlagsAccessed));
    (0, $4wIrX.clearActiveTrace)();
    $4d2d5f48822919f9$var$callCleanUpCallbacks(data);
    $4d2d5f48822919f9$export$cd7f480d6b8286c3(id);
    $4d2d5f48822919f9$var$PreviousInteractionLog.name = data.ufoName;
    $4d2d5f48822919f9$var$PreviousInteractionLog.isAborted = data.abortReason != null;
    $4d2d5f48822919f9$var$handleInteraction(id, data);
    var profilerTimingMap, _iterator2, _step2, _step2$value, _step2$value$, labelStack, start, end, err, e;
};
var $4d2d5f48822919f9$export$9e614a29a1ac213e = function sinkInteractionHandler(sinkFn) {
    if ($4d2d5f48822919f9$var$handleInteraction === $4d2d5f48822919f9$var$pushToQueue) {
        $4d2d5f48822919f9$var$handleInteraction = sinkFn;
        $4d2d5f48822919f9$var$interactionQueue.forEach(function(interaction) {
            sinkFn(interaction.id, interaction.data);
        });
        $4d2d5f48822919f9$var$interactionQueue.length = 0;
    }
};
function $4d2d5f48822919f9$export$673be905888f8839(interactionId, endTime) {
    var interaction = (0, $eaDTp.default).get(interactionId);
    if (interaction != null) {
        var noMoreHolds = interaction.holdActive.size === 0;
        if (noMoreHolds) $4d2d5f48822919f9$var$finishInteraction(interactionId, interaction, endTime);
    }
}
function $4d2d5f48822919f9$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach(function(cancelCallback) {
        cancelCallback();
    });
}
function $4d2d5f48822919f9$export$5def58af4fd46132(interactionId, abortReason) {
    var interaction = (0, $eaDTp.default).get(interactionId);
    if (interaction != null) {
        $4d2d5f48822919f9$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $4d2d5f48822919f9$var$finishInteraction(interactionId, interaction);
    }
}
function $4d2d5f48822919f9$export$c4a545284f55edf2(interactionId, interactionName) {
    (0, $hDvgZ.cancelTTVC)();
    var interaction = (0, $eaDTp.default).get(interactionId);
    if (interaction != null) {
        $4d2d5f48822919f9$var$callCancelCallbacks(interaction);
        interaction.abortReason = "new_interaction";
        interaction.abortedByInteractionName = interactionName;
        $4d2d5f48822919f9$var$finishInteraction(interactionId, interaction);
    }
}
function $4d2d5f48822919f9$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    (0, $hDvgZ.cancelTTVC)();
    (0, $eaDTp.default).forEach(function(interaction, interactionId) {
        $4d2d5f48822919f9$var$callCancelCallbacks(interaction);
        // eslint-disable-next-line no-param-reassign
        interaction.abortReason = abortReason;
        if (abortedByInteractionName != null) // eslint-disable-next-line no-param-reassign
        interaction.abortedByInteractionName = abortedByInteractionName;
        $4d2d5f48822919f9$var$finishInteraction(interactionId, interaction);
    });
}
function $4d2d5f48822919f9$export$7b9261a96cfe427b(id, cancelCallback) {
    var interaction = (0, $eaDTp.default).get(id);
    interaction === null || interaction === void 0 || interaction.cancelCallbacks.push(cancelCallback);
}
function $4d2d5f48822919f9$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName) {
    var trace = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
    var previousTime = startTime;
    var timeoutTime = $4d2d5f48822919f9$var$CLEANUP_TIMEOUT;
    var timerID = setTimeout(function() {
        $4d2d5f48822919f9$export$5def58af4fd46132(interactionId, "timeout");
    }, $4d2d5f48822919f9$var$CLEANUP_TIMEOUT);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        var currentTime = performance.now();
        var timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        var newTimerID = setTimeout(function() {
            $4d2d5f48822919f9$export$5def58af4fd46132(interactionId, "timeout");
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    var addFeatureFlagsToInteraction = (0, $4Pw3J.default)((0, $41O29.getCapabilityRate)("feature_flag_access"));
    var metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $4d2d5f48822919f9$var$PreviousInteractionLog.name,
        isPreviousInteractionAborted: $4d2d5f48822919f9$var$PreviousInteractionLog.isAborted === true,
        marks: [],
        customData: [],
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdActive: new Map(),
        // measure when we execute this code
        // from this we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName !== null && routeName !== void 0 ? routeName : ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: Object.fromEntries((0, $biOnu.allFeatureFlagsAccessed)),
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace
    };
    if (addFeatureFlagsToInteraction) (0, $biOnu.currentFeatureFlagsAccessed).clear();
    (0, $eaDTp.default).set(interactionId, metrics);
    var segmentObserver = {
        onAdd: function onAdd(segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove: function onRemove() {}
    };
    $4d2d5f48822919f9$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(function() {
        $4d2d5f48822919f9$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(function() {
        clearTimeout(metrics.timerID);
    });
    var awaitBM3TTIList = (0, $41O29.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $4d2d5f48822919f9$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === "transition") (0, $fcJSo.getVCObserver)().start({
        startTime: startTime
    });
}
function $4d2d5f48822919f9$export$4a759336b50e86e3(event) {
    var interaction = $4d2d5f48822919f9$export$2b3954d2e8509985();
    if (interaction) {
        var _event$config;
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === "page_load" || interaction.type === "transition") && ((_event$config = event.config) === null || _event$config === void 0 ? void 0 : _event$config.type) === "PAGE_LOAD") {
            interaction.changeTimeout($4d2d5f48822919f9$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $4d2d5f48822919f9$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
        }
    }
}
function $4d2d5f48822919f9$export$ad216cc25852d44b(apdex) {
    (0, $eaDTp.default).forEach(function(interaction, key) {
        interaction.apdex.push(apdex);
        try {
            var _apdex$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdex.key, " [bm3_tti]"), {
                start: (_apdex$startTime = apdex.startTime) !== null && _apdex$startTime !== void 0 ? _apdex$startTime : interaction.start,
                end: apdex.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === "page_load" || interaction.type === "transition") {
            interaction.changeTimeout($4d2d5f48822919f9$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $4d2d5f48822919f9$export$4983dfbbb996f7ae(key, interaction.ufoName);
        }
    });
}
function $4d2d5f48822919f9$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    var interaction = (0, $eaDTp.default).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            var _apdexInfo$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdexInfo.key, " [bm3_tti]"), {
                start: (_apdexInfo$startTime = apdexInfo.startTime) !== null && _apdexInfo$startTime !== void 0 ? _apdexInfo$startTime : interaction.start,
                end: apdexInfo.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === "page_load" || interaction.type === "transition") {
            interaction.changeTimeout($4d2d5f48822919f9$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $4d2d5f48822919f9$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
        }
    }
}
function $4d2d5f48822919f9$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    var interaction = (0, $eaDTp.default).get(interactionId);
    if (interaction != null) interaction.requestInfo.push($4d2d5f48822919f9$var$_objectSpread({
        labelStack: labelStack
    }, requestInfo));
}
function $4d2d5f48822919f9$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === "string" && typeof obj.segmentId === "string";
}
function $4d2d5f48822919f9$var$getSegmentCacheKey(labelStack) {
    return labelStack.map(function(l) {
        if ($4d2d5f48822919f9$var$isSegmentLabel(l)) return "".concat(l.name, "_").concat(l.segmentId);
        return l.name;
    }).join("|");
}
function $4d2d5f48822919f9$export$1c43f9ac826b6462(labelStack) {
    var key = $4d2d5f48822919f9$var$getSegmentCacheKey(labelStack);
    var existingSegment = $4d2d5f48822919f9$var$segmentCache.get(key);
    if (!existingSegment) {
        var segmentInfo = {
            labelStack: labelStack
        };
        $4d2d5f48822919f9$var$segmentCache.set(key, segmentInfo);
        $4d2d5f48822919f9$var$segmentObservers.forEach(function(observer) {
            observer.onAdd(segmentInfo);
        });
    }
}
function $4d2d5f48822919f9$export$d0365e48b58231c3(labelStack) {
    var key = $4d2d5f48822919f9$var$getSegmentCacheKey(labelStack);
    var segmentInfo = $4d2d5f48822919f9$var$segmentCache.get(key);
    if (segmentInfo) {
        $4d2d5f48822919f9$var$segmentCache.delete(JSON.stringify(labelStack));
        $4d2d5f48822919f9$var$segmentObservers.forEach(function(observer) {
            observer.onRemove(segmentInfo);
        });
    }
}
function $4d2d5f48822919f9$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    var interaction = (0, $eaDTp.default).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        var prevRedirect, _prevRedirect$time, e;
    }
}

});
parcelRegister("eaDTp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a510f1b964235a93$export$2e2bcd8739ae039; });
var $a510f1b964235a93$var$interactions = new Map();
var $a510f1b964235a93$export$2e2bcd8739ae039 = $a510f1b964235a93$var$interactions;

});


parcelRegister("ikFWs", function(module, exports) {

$parcel$export(module.exports, "eventDataProcessor", function () { return $d58aa10aafa4b251$export$896b6e121bbaec25; });

var $4mVfk = parcelRequire("4mVfk");

var $b4Ivn = parcelRequire("b4Ivn");

var $8DpVo = parcelRequire("8DpVo");

var $hGxkd = parcelRequire("hGxkd");

var $6VOgp = parcelRequire("6VOgp");

var $iq1I9 = parcelRequire("iq1I9");

var $eQXvZ = parcelRequire("eQXvZ");

var $8h4O4 = parcelRequire("8h4O4");

var $gYS98 = parcelRequire("gYS98");

var $2zQuc = parcelRequire("2zQuc");

var $hPqHW = parcelRequire("hPqHW");

var $jSSqM = parcelRequire("jSSqM");

var $eNlCm = parcelRequire("eNlCm");

var $7frRB = parcelRequire("7frRB");

var $1dZSV = parcelRequire("1dZSV");

var $geyQ4 = parcelRequire("geyQ4");

var $93kHM = parcelRequire("93kHM");

var $7VvZ5 = parcelRequire("7VvZ5");

var $cBz3p = parcelRequire("cBz3p");

var $klSv2 = parcelRequire("klSv2");

var $dBkBW = parcelRequire("dBkBW");

var $dSQAZ = parcelRequire("dSQAZ");

var $dQICt = parcelRequire("dQICt");

var $6bBQz = parcelRequire("6bBQz");

var $2J6j2 = parcelRequire("2J6j2");

var $16q9a = parcelRequire("16q9a");

var $l2hZO = parcelRequire("l2hZO");

var $01wnb = parcelRequire("01wnb");

var $iDxvN = parcelRequire("iDxvN");

var $kZ3WG = parcelRequire("kZ3WG");

var $kkwun = parcelRequire("kkwun");

var $4elC6 = parcelRequire("4elC6");

var $aR1mF = parcelRequire("aR1mF");

var $20Arx = parcelRequire("20Arx");

var $4ghSB = parcelRequire("4ghSB");

var $aYzd4 = parcelRequire("aYzd4");

var $2EvZV = parcelRequire("2EvZV");

var $5rFPR = parcelRequire("5rFPR");

var $8jPNU = parcelRequire("8jPNU");

var $lqMQx = parcelRequire("lqMQx");
function $d58aa10aafa4b251$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $d58aa10aafa4b251$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $d58aa10aafa4b251$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d58aa10aafa4b251$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d58aa10aafa4b251$var$_arrayLikeToArray(o, minLen);
}
function $d58aa10aafa4b251$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $d58aa10aafa4b251$var$defaultSet = [
    (0, $eNlCm.eventKey),
    (0, $7VvZ5.eventType),
    (0, $1dZSV.eventProduct),
    (0, $93kHM.eventRoute),
    (0, $hPqHW.eventId),
    (0, $7frRB.eventLocalTime),
    (0, $geyQ4.eventRegion),
    (0, $eQXvZ.appFramework),
    (0, $8h4O4.appVersion),
    (0, $gYS98.bmVersion),
    (0, $aR1mF.telemetryBrowser),
    (0, $20Arx.telemetryCpu),
    (0, $4ghSB.telemetryMemory),
    (0, $aYzd4.telemetryNetwork),
    (0, $2zQuc.customData),
    (0, $cBz3p.featureFlags),
    (0, $klSv2.hostname),
    (0, $kZ3WG.productCustomData),
    (0, $2EvZV.appTimings),
    (0, $8jPNU.resourceTimings)
];
var $d58aa10aafa4b251$var$pageLoadCommon = [].concat($d58aa10aafa4b251$var$defaultSet, [
    (0, $01wnb.pageVisibleState),
    (0, $iDxvN.pageVisibleValue),
    (0, $jSSqM.eventInitial),
    (0, $2J6j2.pageLoadMetrics),
    (0, $5rFPR.bundleEvalTimings)
]);
var $d58aa10aafa4b251$var$initialPageLoadSet = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))($d58aa10aafa4b251$var$pageLoadCommon), [
    (0, $dSQAZ.initialPageLoadMetrics),
    (0, $6bBQz.navigationMetrics),
    (0, $4elC6.ssrSuccess),
    (0, $kkwun.ssrFeatureFlags)
]);
var $d58aa10aafa4b251$var$spaTransitionSet = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))($d58aa10aafa4b251$var$pageLoadCommon);
var $d58aa10aafa4b251$var$pageSegmentLoadSet = [].concat($d58aa10aafa4b251$var$defaultSet, [
    (0, $16q9a.pageSegmentLoadMetrics),
    (0, $01wnb.pageVisibleState),
    (0, $iDxvN.pageVisibleValue),
    (0, $jSSqM.eventInitial),
    (0, $5rFPR.bundleEvalTimings)
]);
var $d58aa10aafa4b251$var$interactionSet = [].concat($d58aa10aafa4b251$var$defaultSet, [
    (0, $01wnb.pageVisibleState),
    (0, $iDxvN.pageVisibleValue),
    (0, $dQICt.interactionMetrics)
]);
var $d58aa10aafa4b251$var$customMetricSet = [].concat($d58aa10aafa4b251$var$defaultSet, [
    (0, $01wnb.pageVisibleState),
    (0, $iDxvN.pageVisibleValue),
    (0, $dBkBW.customEventMetrics)
]);
// pageVisibleState and pageVisibleValue has been handled within webVitalsMetrics.
var $d58aa10aafa4b251$var$webVitalsMetricSet = [].concat($d58aa10aafa4b251$var$defaultSet, [
    (0, $l2hZO.webVitalsMetrics)
]);
// Function that returns a promise which resolves after clsWaitTimeMs + 500ms
// so that clsData is guaranteed to be attached to window
var $d58aa10aafa4b251$var$waitForCLS = function waitForCLS() {
    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $hGxkd.clsWaitTimeMs) + 500;
    return new Promise(function(resolve) {
        return setTimeout(resolve, delay);
    });
};
var $d58aa10aafa4b251$export$896b6e121bbaec25 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee(globalConfig, data) {
        var set, plugins, _iterator, _step, plugin, result, pluginResults, generated;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(data.start === null || data.stop === null)) {
                        _context.next = 3;
                        break;
                    }
                    (0, $6VOgp.logger).log('eventDataProcessor: Metric "'.concat(data.key, '" start or stop are incorrect; start: ').concat(data.start, "; stop: ").concat(data.stop));
                    return _context.abrupt("return", null);
                case 3:
                    set = [];
                    if (data.config.type === (0, $lqMQx.BMEventsType).PAGE_LOAD && (0, $iq1I9.isPageLoadMetricData)(data) && data.isInitial) set = $d58aa10aafa4b251$var$initialPageLoadSet;
                    if (data.config.type === (0, $lqMQx.BMEventsType).PAGE_LOAD && (0, $iq1I9.isPageLoadMetricData)(data) && !data.isInitial) set = $d58aa10aafa4b251$var$spaTransitionSet;
                    if (data.config.type === (0, $lqMQx.BMEventsType).PAGE_SEGMENT_LOAD && (0, $iq1I9.isPageSegmentLoadMetricData)(data)) set = $d58aa10aafa4b251$var$pageSegmentLoadSet;
                    if (data.config.type === (0, $lqMQx.BMEventsType).INLINE_RESULT) set = $d58aa10aafa4b251$var$interactionSet;
                    if (data.config.type === (0, $lqMQx.BMEventsType).CUSTOM) set = $d58aa10aafa4b251$var$customMetricSet;
                    if (!(data.config.type === (0, $lqMQx.BMEventsType).WEB_VITALS)) {
                        _context.next = 13;
                        break;
                    }
                    set = $d58aa10aafa4b251$var$webVitalsMetricSet;
                    // Wait for CLS to be recorded before proceeding to run plugin and attach CLS data
                    _context.next = 13;
                    return $d58aa10aafa4b251$var$waitForCLS();
                case 13:
                    //TODO if type is different - do not send at all
                    plugins = [];
                    _iterator = $d58aa10aafa4b251$var$_createForOfIteratorHelper(set);
                    _context.prev = 15;
                    _iterator.s();
                case 17:
                    if ((_step = _iterator.n()).done) {
                        _context.next = 25;
                        break;
                    }
                    plugin = _step.value;
                    _context.next = 21;
                    return plugin(data.config, data, // some plugins support page load specific data with special check
                    globalConfig);
                case 21:
                    result = _context.sent;
                    if (result) plugins.push(result);
                case 23:
                    _context.next = 17;
                    break;
                case 25:
                    _context.next = 30;
                    break;
                case 27:
                    _context.prev = 27;
                    _context.t0 = _context["catch"](15);
                    _iterator.e(_context.t0);
                case 30:
                    _context.prev = 30;
                    _iterator.f();
                    return _context.finish(30);
                case 33:
                    _context.next = 35;
                    return Promise.all(plugins);
                case 35:
                    pluginResults = _context.sent;
                    generated = {};
                    pluginResults.forEach(function(pluginResult) {
                        if (pluginResult === null) return;
                        Object.keys(pluginResult).forEach(function(key) {
                            var keyResult = pluginResult[key];
                            if (keyResult !== null && keyResult !== undefined) generated[key] = keyResult;
                        });
                    });
                    return _context.abrupt("return", generated);
                case 39:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                15,
                27,
                30,
                33
            ]
        ]);
    }));
    return function eventDataProcessor(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("iq1I9", function(module, exports) {

$parcel$export(module.exports, "isPageLoadMetricData", function () { return $d68bfb7e2a266126$export$b0e12e7abb0bff11; });
$parcel$export(module.exports, "isPageSegmentLoadMetricData", function () { return $d68bfb7e2a266126$export$83d0099ee6dbb5b0; });
$parcel$export(module.exports, "isPageLoadConfig", function () { return $d68bfb7e2a266126$export$8672fa27ba8bba88; });
$parcel$export(module.exports, "isPageSegmentLoadConfig", function () { return $d68bfb7e2a266126$export$abe063537ef4987b; });
$parcel$export(module.exports, "isInteractionConfig", function () { return $d68bfb7e2a266126$export$ae68674b6a9353be; });
$parcel$export(module.exports, "isCustomConfig", function () { return $d68bfb7e2a266126$export$b493eb8b2ba87421; });

var $lqMQx = parcelRequire("lqMQx");
var $d68bfb7e2a266126$export$b0e12e7abb0bff11 = function isPageLoadMetricData(data) {
    return data.type === (0, $lqMQx.BMEventsType).PAGE_LOAD;
};
var $d68bfb7e2a266126$export$83d0099ee6dbb5b0 = function isPageSegmentLoadMetricData(data) {
    return data.type === (0, $lqMQx.BMEventsType).PAGE_SEGMENT_LOAD;
};
var $d68bfb7e2a266126$export$8672fa27ba8bba88 = function isPageLoadConfig(data) {
    return data.type === (0, $lqMQx.BMEventsType).PAGE_LOAD;
};
var $d68bfb7e2a266126$export$abe063537ef4987b = function isPageSegmentLoadConfig(data) {
    return data.type === (0, $lqMQx.BMEventsType).PAGE_SEGMENT_LOAD;
};
var $d68bfb7e2a266126$export$ae68674b6a9353be = function isInteractionConfig(data) {
    return data.type === (0, $lqMQx.BMEventsType).INLINE_RESULT;
};
var $d68bfb7e2a266126$export$b493eb8b2ba87421 = function isCustomConfig(data) {
    return data.type === (0, $lqMQx.BMEventsType).CUSTOM;
};

});

parcelRegister("eQXvZ", function(module, exports) {

$parcel$export(module.exports, "appFramework", function () { return $ad041670e5a69a59$export$e34e4529b979f74c; });
var $ad041670e5a69a59$export$e34e4529b979f74c = function appFramework(_config, _data, globalConfig) {
    if (!globalConfig.app.framework) return null;
    return {
        "app:framework:name": globalConfig.app.framework.name,
        "app:framework:version": globalConfig.app.framework.version
    };
};

});

parcelRegister("8h4O4", function(module, exports) {

$parcel$export(module.exports, "appVersion", function () { return $6063a3c0bd1327a3$export$82ae485178b37419; });
var $6063a3c0bd1327a3$export$82ae485178b37419 = function appVersion(_config, _data, globalConfig) {
    var pluginData = {
        "app:web:version": globalConfig.app.version.web
    };
    if (globalConfig.app.version.ssr) pluginData["app:ssr:version"] = globalConfig.app.version.ssr;
    return pluginData;
};

});

parcelRegister("gYS98", function(module, exports) {

$parcel$export(module.exports, "bmVersion", function () { return $c5cc4047b16a37c8$export$5cafa465fc876895; });
var $c5cc4047b16a37c8$export$5cafa465fc876895 = function bmVersion() {
    return {
        "bm:version": 3
    };
};

});

parcelRegister("2zQuc", function(module, exports) {

$parcel$export(module.exports, "customData", function () { return $1e07904f8c75d143$export$f7e743c7db162193; });

var $9q1kH = parcelRequire("9q1kH");
var $1e07904f8c75d143$export$f7e743c7db162193 = function customData(_config, data) {
    var custom = {};
    var changed = false;
    if (data.custom) Object.entries(data.custom).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        changed = true;
        custom["custom:".concat(key)] = value;
    });
    return changed ? custom : null;
};

});

parcelRegister("hPqHW", function(module, exports) {

$parcel$export(module.exports, "eventId", function () { return $cfabeaaa8022b376$export$aed28df7ac07d79a; });
var $cfabeaaa8022b376$export$aed28df7ac07d79a = function eventId(config) {
    return {
        "event:id": config.key
    };
};

});

parcelRegister("jSSqM", function(module, exports) {

$parcel$export(module.exports, "eventInitial", function () { return $e79d484b191b1c6e$export$fa8e91d436b3ef8b; });

var $iq1I9 = parcelRequire("iq1I9");
var $e79d484b191b1c6e$export$fa8e91d436b3ef8b = function eventInitial(_config, data) {
    if (!(0, $iq1I9.isPageLoadMetricData)(data) && !(0, $iq1I9.isPageSegmentLoadMetricData)(data)) return null;
    return {
        "event:initial": data.isInitial
    };
};

});

parcelRegister("eNlCm", function(module, exports) {

$parcel$export(module.exports, "eventKey", function () { return $ac56691d53506fd6$export$10be2d3a558d3f88; });

var $7XDu6 = parcelRequire("7XDu6");
var $ac56691d53506fd6$export$10be2d3a558d3f88 = function eventKey(config, _data, globalConfig) {
    return {
        "event:key": "".concat(globalConfig.product, ".fe.").concat((0, $7XDu6.mapEventType)(config.type), ".").concat(config.key)
    };
};

});
parcelRegister("7XDu6", function(module, exports) {

$parcel$export(module.exports, "mapEventType", function () { return $5cbcabea3fd34355$export$b334d07f11140768; });

var $lqMQx = parcelRequire("lqMQx");
var $5cbcabea3fd34355$export$b334d07f11140768 = function mapEventType(type) {
    switch(type){
        case (0, $lqMQx.BMEventsType).CUSTOM:
            return (0, $lqMQx.StorableBMEventsType).CUSTOM;
        case (0, $lqMQx.BMEventsType).INLINE_RESULT:
            return (0, $lqMQx.StorableBMEventsType).INLINE_RESULT;
        case (0, $lqMQx.BMEventsType).PAGE_LOAD:
            return (0, $lqMQx.StorableBMEventsType).PAGE_LOAD;
        case (0, $lqMQx.BMEventsType).PAGE_SEGMENT_LOAD:
            return (0, $lqMQx.StorableBMEventsType).PAGE_SEGMENT_LOAD;
        case (0, $lqMQx.BMEventsType).WEB_VITALS:
            return (0, $lqMQx.StorableBMEventsType).WEB_VITALS;
        default:
            return "unknown";
    }
};

});


parcelRegister("7frRB", function(module, exports) {

$parcel$export(module.exports, "eventLocalTime", function () { return $546f8c3b75081239$export$5219854ae7ec45da; });

var $98hJD = parcelRequire("98hJD");
var $546f8c3b75081239$export$5219854ae7ec45da = function eventLocalTime() {
    return {
        "event:localHour": parseInt((0, $98hJD.default)(new Date(), "H"), 10),
        "event:localDayOfWeek": parseInt((0, $98hJD.default)(new Date(), "i"), 10)
    };
};

});

parcelRegister("1dZSV", function(module, exports) {

$parcel$export(module.exports, "eventProduct", function () { return $0e47026218684633$export$a7df4e8088db8843; });
var $0e47026218684633$export$a7df4e8088db8843 = function eventProduct(_config, _data, globalConfig) {
    return {
        "event:product": "".concat(globalConfig.product)
    };
};

});

parcelRegister("geyQ4", function(module, exports) {

$parcel$export(module.exports, "eventRegion", function () { return $bd18fa6913cd42ca$export$d0117b71adcdebc0; });
var $bd18fa6913cd42ca$export$d0117b71adcdebc0 = function eventRegion(_config, _data, globalConfig) {
    return {
        "event:region": "".concat(globalConfig.region)
    };
};

});

parcelRegister("93kHM", function(module, exports) {

$parcel$export(module.exports, "eventRoute", function () { return $6974747768838276$export$44d3627af289ca16; });
var $6974747768838276$export$44d3627af289ca16 = function eventRoute(_config, data) {
    if (!data.route) return null;
    return {
        "event:route": data.route
    };
};

});

parcelRegister("7VvZ5", function(module, exports) {

$parcel$export(module.exports, "eventType", function () { return $5c56aaae72ca3a48$export$4c045e605d532c98; });

var $7XDu6 = parcelRequire("7XDu6");
var $5c56aaae72ca3a48$export$4c045e605d532c98 = function eventType(config) {
    return {
        "event:type": (0, $7XDu6.mapEventType)(config.type)
    };
};

});

parcelRegister("cBz3p", function(module, exports) {

$parcel$export(module.exports, "featureFlags", function () { return $92d421b4c5580a54$export$e62953d023125748; });

var $kFnE9 = parcelRequire("kFnE9");
function $92d421b4c5580a54$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $92d421b4c5580a54$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $92d421b4c5580a54$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $92d421b4c5580a54$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $92d421b4c5580a54$export$e62953d023125748 = function featureFlags(config, _data, globalConfig) {
    var _config$featureFlags;
    var localFeatureFlags = ((_config$featureFlags = config.featureFlags) === null || _config$featureFlags === void 0 ? void 0 : _config$featureFlags.reduce(function(acc, ffName) {
        acc[ffName] = globalConfig.ffClient.getValue(ffName);
        return acc;
    }, {})) || null;
    if ((!globalConfig.featureFlags || Object.keys(globalConfig.featureFlags).length === 0) && (!localFeatureFlags || Object.keys(localFeatureFlags).length === 0)) return null;
    return {
        featureFlags: $92d421b4c5580a54$var$_objectSpread($92d421b4c5580a54$var$_objectSpread({}, localFeatureFlags), globalConfig.featureFlags)
    };
};

});

parcelRegister("klSv2", function(module, exports) {

$parcel$export(module.exports, "hostname", function () { return $ed100b4fb7781077$export$640106f6dc7d2706; });
var $ed100b4fb7781077$export$640106f6dc7d2706 = function hostname(_config, _data, globalConfig) {
    return {
        hostname: globalConfig.hostname
    };
};

});

parcelRegister("dBkBW", function(module, exports) {

$parcel$export(module.exports, "customEventMetrics", function () { return $9e6eb7f3f8a573c0$export$cab039265c52a2e9; });

var $iq1I9 = parcelRequire("iq1I9");
var $9e6eb7f3f8a573c0$export$cab039265c52a2e9 = function customEventMetrics(config, data, globalConfig) {
    var _config$slo, _config$histogram;
    if (!(0, $iq1I9.isCustomConfig)(config)) return null;
    var payload = {
        "metric:duration": Math.round(data.stop - data.start)
    };
    if (((_config$slo = config.slo) === null || _config$slo === void 0 ? void 0 : _config$slo.threshold) !== undefined) {
        var _config$slo2, _config$slo3;
        payload["metric:duration:slo"] = payload["metric:duration"] <= ((_config$slo2 = config.slo) === null || _config$slo2 === void 0 ? void 0 : _config$slo2.threshold);
        payload["metric:duration:slo:threshold"] = (_config$slo3 = config.slo) === null || _config$slo3 === void 0 ? void 0 : _config$slo3.threshold;
    }
    if ((_config$histogram = config.histogram) !== null && _config$histogram !== void 0 && _config$histogram.duration) payload["metric:duration:histogramBuckets"] = config.histogram.duration;
    else if (globalConfig.histogram) payload["metric:duration:histogramBuckets"] = globalConfig.histogram.duration;
    return payload;
};

});

parcelRegister("dSQAZ", function(module, exports) {

$parcel$export(module.exports, "initialPageLoadMetrics", function () { return $a1b91de244cd84d7$export$cc95aa3f6ea8e5cb; });
var $a1b91de244cd84d7$export$cc95aa3f6ea8e5cb = function initialPageLoadMetrics() {
    var metrics = {};
    performance.getEntriesByType("paint").forEach(function(entry) {
        if (entry.name === "first-paint") metrics["metric:fp"] = Math.round(entry.startTime);
        if (entry.name === "first-contentful-paint") metrics["metric:fcp"] = Math.round(entry.startTime);
    });
    return metrics;
};

});

parcelRegister("dQICt", function(module, exports) {

$parcel$export(module.exports, "interactionMetrics", function () { return $a152be36b867080f$export$86db56030b57ba34; });

var $iq1I9 = parcelRequire("iq1I9");

var $lqMQx = parcelRequire("lqMQx");
var $a152be36b867080f$export$86db56030b57ba34 = function interactionMetrics(config, data, globalConfig) {
    var _config$histogram;
    if (!(0, $iq1I9.isInteractionConfig)(config)) return null;
    var result = {
        "metric:result": Math.round(data.stop - data.start)
    };
    if ((_config$histogram = config.histogram) !== null && _config$histogram !== void 0 && _config$histogram.result) result["metric:result:histogramBuckets"] = config.histogram.result;
    else if (globalConfig.histogram) {
        var histogram = globalConfig.histogram;
        if (histogram.result !== undefined) result["metric:result:histogramBuckets"] = histogram[(0, $lqMQx.BMInteractionMetrics).result];
    }
    if (config.slo && (0, $lqMQx.isInteractionMetricsSlo)(config.slo) && config.slo.result) {
        result["metric:result:slo"] = result["metric:result"] <= config.slo.result.threshold;
        result["metric:result:slo:threshold"] = config.slo.result.threshold;
    }
    if (data.marks["feedback"]) {
        var _config$histogram2;
        result["metric:response"] = Math.round((data.marks["feedback"] || data.stop) - data.start);
        if ((_config$histogram2 = config.histogram) !== null && _config$histogram2 !== void 0 && _config$histogram2.response) result["metric:response:histogramBuckets"] = config.histogram[(0, $lqMQx.BMInteractionMetrics).response];
        else if (globalConfig.histogram) {
            var _histogram = globalConfig.histogram;
            if (_histogram.result !== undefined) result["metric:response:histogramBuckets"] = _histogram[(0, $lqMQx.BMInteractionMetrics).response];
        }
        if (config.slo && (0, $lqMQx.isInteractionMetricsSlo)(config.slo) && config.slo.response) {
            result["metric:response:slo"] = result["metric:response"] <= config.slo.response.threshold;
            result["metric:response:slo:threshold"] = config.slo.response.threshold;
        }
    }
    return result;
};

});

parcelRegister("6bBQz", function(module, exports) {

$parcel$export(module.exports, "navigationMetrics", function () { return $481120c3a40d4fd6$export$b88d990436be0f8a; });
var $481120c3a40d4fd6$export$b88d990436be0f8a = function navigationMetrics() {
    var entries = performance.getEntriesByType("navigation");
    if (entries.length === 0) return null;
    var navigation = entries[0];
    var metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        "metrics:navigation": metrics
    };
};

});

parcelRegister("2J6j2", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetrics", function () { return $1fc4ad02b5cb253e$export$2878bf482e539059; });

var $iq1I9 = parcelRequire("iq1I9");

var $lqMQx = parcelRequire("lqMQx");
var $1fc4ad02b5cb253e$var$getThreshold = function getThreshold(isInitial, metric) {
    return (0, $lqMQx.isDetailedPageLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
var $1fc4ad02b5cb253e$var$getHistogram = function getHistogram(isInitial, metric, histogram) {
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
var $1fc4ad02b5cb253e$export$2878bf482e539059 = function pageLoadMetrics(config, data, globalConfig) {
    if (!(0, $iq1I9.isPageLoadConfig)(config)) throw new Error("Browser Metrics: cannot gather page load data for non-page-load config");
    var fmp = data.marks[(0, $lqMQx.BMPageLoadMetrics).fmp] || data.stop;
    var result = {
        "metric:fmp": Math.round(fmp - data.start),
        "metric:tti": Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result["metric:fmp:histogramBuckets"] = $1fc4ad02b5cb253e$var$getHistogram(data.isInitial, (0, $lqMQx.BMPageLoadMetrics).fmp, config.histogram);
        result["metric:tti:histogramBuckets"] = $1fc4ad02b5cb253e$var$getHistogram(data.isInitial, (0, $lqMQx.BMPageLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        var histogram = globalConfig.histogram;
        result["metric:fmp:histogramBuckets"] = $1fc4ad02b5cb253e$var$getHistogram(data.isInitial, (0, $lqMQx.BMPageLoadMetrics).fmp, histogram);
        result["metric:tti:histogramBuckets"] = $1fc4ad02b5cb253e$var$getHistogram(data.isInitial, (0, $lqMQx.BMPageLoadMetrics).tti, histogram);
    }
    if (config.slo && config.slo.fmp) {
        var threshold = $1fc4ad02b5cb253e$var$getThreshold(data.isInitial, config.slo.fmp);
        result["metric:fmp:slo"] = result["metric:fmp"] <= threshold;
        result["metric:fmp:slo:threshold"] = threshold;
    }
    if (config.slo && config.slo.tti) {
        var _threshold = $1fc4ad02b5cb253e$var$getThreshold(data.isInitial, config.slo.tti);
        result["metric:tti:slo"] = result["metric:tti"] <= _threshold;
        result["metric:tti:slo:threshold"] = _threshold;
    }
    return result;
};

});

parcelRegister("16q9a", function(module, exports) {

$parcel$export(module.exports, "pageSegmentLoadMetrics", function () { return $0cdaa23a13737c47$export$ba86cb47f2f22db5; });

var $iFHHo = parcelRequire("iFHHo");

var $iq1I9 = parcelRequire("iq1I9");

var $lqMQx = parcelRequire("lqMQx");
var $0cdaa23a13737c47$var$getThreshold = function getThreshold(isInitial, metric) {
    return (0, $lqMQx.isDetailedPageSegmentLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
var $0cdaa23a13737c47$var$getHistogram = function getHistogram(isInitial, metric, histogram) {
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
var $0cdaa23a13737c47$export$ba86cb47f2f22db5 = function pageSegmentLoadMetrics(config, data, globalConfig) {
    var _config$slo, _config$slo2;
    if (!(0, $iq1I9.isPageSegmentLoadConfig)(config)) throw new Error("Browser Metrics: cannot gather page segment load data for non-page-segment-load config");
    var fmp = data.marks[(0, $lqMQx.BMPageSegmentLoadMetrics).fmp] || data.stop;
    var result = {
        "metric:fmp": Math.round(fmp - data.start),
        "metric:tti": Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result["metric:fmp:histogramBuckets"] = $0cdaa23a13737c47$var$getHistogram(data.isInitial, (0, $lqMQx.BMPageSegmentLoadMetrics).fmp, config.histogram);
        result["metric:tti:histogramBuckets"] = $0cdaa23a13737c47$var$getHistogram(data.isInitial, (0, $lqMQx.BMPageSegmentLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        var histogram = globalConfig.histogram;
        result["metric:fmp:histogramBuckets"] = $0cdaa23a13737c47$var$getHistogram(data.isInitial, (0, $lqMQx.BMPageSegmentLoadMetrics).fmp, histogram);
        result["metric:tti:histogramBuckets"] = $0cdaa23a13737c47$var$getHistogram(data.isInitial, (0, $lqMQx.BMPageSegmentLoadMetrics).tti, histogram);
    }
    if ((_config$slo = config.slo) !== null && _config$slo !== void 0 && _config$slo.fmp) {
        var threshold = $0cdaa23a13737c47$var$getThreshold(data.isInitial, config.slo.fmp);
        result["metric:fmp:slo"] = result["metric:fmp"] <= threshold;
        result["metric:fmp:slo:threshold"] = threshold;
    }
    if ((_config$slo2 = config.slo) !== null && _config$slo2 !== void 0 && _config$slo2.tti) {
        var _threshold = $0cdaa23a13737c47$var$getThreshold(data.isInitial, config.slo.tti);
        result["metric:tti:slo"] = result["metric:tti"] <= _threshold;
        result["metric:tti:slo:threshold"] = _threshold;
    }
    if (config.includePageLoadTimings === (0, $lqMQx.PageSegmentPageLoadMetricsOptions).IF_PRESENT || config.includePageLoadTimings === (0, $lqMQx.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT) {
        var pageLoadData = (0, $iFHHo.pageLoadMetaMetric).getData();
        var _fmp = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round((pageLoadData.marks[(0, $lqMQx.BMPageLoadMetrics).fmp] || pageLoadData.stop) - pageLoadData.start) : null;
        var _tti = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round(pageLoadData.stop - pageLoadData.start) : null;
        result["pageLoad"] = {
            fmp: _fmp,
            tti: _tti
        };
    }
    return result;
};

});

parcelRegister("l2hZO", function(module, exports) {

$parcel$export(module.exports, "webVitalsMetrics", function () { return $f507be7dd10ea207$export$3731db279f590f30; });

var $kFnE9 = parcelRequire("kFnE9");

var $4mVfk = parcelRequire("4mVfk");

var $8DpVo = parcelRequire("8DpVo");

var $ahvvj = parcelRequire("ahvvj");

var $ehmYT = parcelRequire("ehmYT");

var $9ubiG = parcelRequire("9ubiG");

var $iDxvN = parcelRequire("iDxvN");
function $f507be7dd10ea207$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f507be7dd10ea207$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f507be7dd10ea207$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f507be7dd10ea207$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f507be7dd10ea207$export$3731db279f590f30 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee(config, data, globalConfig) {
        var _globalConfig$webVita, _globalConfig$webVita2, _globalConfig$webVita3;
        var pageVisibleState, setPageVisibleStateToMixed, ttciEnabled, webVitalMetrics;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    pageVisibleState = data.pageVisibleState;
                    setPageVisibleStateToMixed = function setPageVisibleStateToMixed() {
                        pageVisibleState = (0, $ahvvj.PageVisibleState).MIXED;
                    };
                    (0, $ehmYT.visibilityChangeObserver).subscribe(setPageVisibleStateToMixed);
                    ttciEnabled = ((_globalConfig$webVita = globalConfig.webVitals) === null || _globalConfig$webVita === void 0 ? void 0 : _globalConfig$webVita.ttciEnabled) !== undefined ? (_globalConfig$webVita2 = globalConfig.webVitals) === null || _globalConfig$webVita2 === void 0 ? void 0 : _globalConfig$webVita2.ttciEnabled : true;
                    _context.next = 6;
                    return $f507be7dd10ea207$export$193ae490b52081dd(ttciEnabled, ((_globalConfig$webVita3 = globalConfig.webVitals) === null || _globalConfig$webVita3 === void 0 ? void 0 : _globalConfig$webVita3.timeout) || 30000);
                case 6:
                    webVitalMetrics = _context.sent;
                    (0, $ehmYT.visibilityChangeObserver).unsubscribe(setPageVisibleStateToMixed);
                    return _context.abrupt("return", $f507be7dd10ea207$var$_objectSpread($f507be7dd10ea207$var$_objectSpread({}, webVitalMetrics), {}, {
                        "pageVisible:state": pageVisibleState
                    }, (0, $iDxvN.pageVisibleValue)(config, data, globalConfig)));
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function webVitalsMetrics(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();
var $f507be7dd10ea207$export$193ae490b52081dd = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee2(ttciEnabled, timeout) {
        var timeoutWindow;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return ttciEnabled ? (0, $9ubiG.webVitalsObserver).ttciDetermined : Promise.resolve();
                case 2:
                    // wait up to $timeout ms longer for web-vitals until returning
                    timeoutWindow = new Promise(function(resolve) {
                        return setTimeout(resolve, timeout);
                    });
                    _context2.next = 5;
                    return Promise.race([
                        timeoutWindow,
                        (0, $9ubiG.webVitalsObserver).webVitalsDetermined
                    ]);
                case 5:
                    return _context2.abrupt("return", (0, $9ubiG.webVitalsObserver).data);
                case 6:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function webVitalsMetricCustomTimeout(_x4, _x5) {
        return _ref2.apply(this, arguments);
    };
}();

});
parcelRegister("iDxvN", function(module, exports) {

$parcel$export(module.exports, "pageVisibleValue", function () { return $d915dd48e8515ee5$export$177b923114656380; });

var $ahvvj = parcelRequire("ahvvj");
var $lqMQx = parcelRequire("lqMQx");
var $d915dd48e8515ee5$export$177b923114656380 = function pageVisibleValue(_config, data, globalConfig) {
    var value = globalConfig.pageVisibleValueOrigin === (0, $lqMQx.PageVisibleValueOrigin).documentHidden ? !document.hidden || false : data.pageVisibleState === (0, $ahvvj.PageVisibleState).VISIBLE;
    return {
        "pageVisible:value": value
    };
};

});


parcelRegister("01wnb", function(module, exports) {

$parcel$export(module.exports, "pageVisibleState", function () { return $004934b03554f44d$export$723b4c298aca63af; });
var $004934b03554f44d$export$723b4c298aca63af = function pageVisibleState(_config, data) {
    return {
        "pageVisible:state": data.pageVisibleState
    };
};

});

parcelRegister("kZ3WG", function(module, exports) {

$parcel$export(module.exports, "productCustomData", function () { return $f46c90a9b112c410$export$fa2af6e412815a74; });

var $9q1kH = parcelRequire("9q1kH");

var $4mVfk = parcelRequire("4mVfk");

var $8DpVo = parcelRequire("8DpVo");
var $f46c90a9b112c410$export$fa2af6e412815a74 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee(_config, data, globalConfig) {
        var result, pluginOutputs;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(!globalConfig.custom && !globalConfig.plugins)) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return", null);
                case 2:
                    result = {};
                    if (globalConfig.custom) Object.entries(globalConfig.custom).forEach(function(_ref2) {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref2, 2), key = _ref3[0], value = _ref3[1];
                        result["".concat(globalConfig.product, ":").concat(key)] = value;
                    });
                    if (!globalConfig.plugins) {
                        _context.next = 9;
                        break;
                    }
                    _context.next = 7;
                    return Promise.all(globalConfig.plugins.map(function(plugin) {
                        return plugin({
                            start: data.start,
                            stop: data.stop,
                            key: data.key
                        });
                    }));
                case 7:
                    pluginOutputs = _context.sent;
                    pluginOutputs.forEach(function(pluginOutput) {
                        if (pluginOutput === null) return;
                        Object.entries(pluginOutput).forEach(function(_ref4) {
                            var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref4, 2), key = _ref5[0], value = _ref5[1];
                            result["".concat(globalConfig.product, ":").concat(key)] = value;
                        });
                    });
                case 9:
                    return _context.abrupt("return", result);
                case 10:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function productCustomData(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

});

parcelRegister("kkwun", function(module, exports) {

$parcel$export(module.exports, "ssrFeatureFlags", function () { return $eccee08bc464c9f2$export$fdbea518c19dfa8; });

var $4mVfk = parcelRequire("4mVfk");

var $8DpVo = parcelRequire("8DpVo");

var $lqMQx = parcelRequire("lqMQx");
var $eccee08bc464c9f2$var$retrieveFeatureFlags = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee(getFeatureFlags) {
        var featureFlags;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return getFeatureFlags();
                case 3:
                    featureFlags = _context.sent;
                    if (!featureFlags) {
                        _context.next = 6;
                        break;
                    }
                    return _context.abrupt("return", {
                        "ssr:featureFlags": featureFlags
                    });
                case 6:
                    _context.next = 10;
                    break;
                case 8:
                    _context.prev = 8;
                    _context.t0 = _context["catch"](0);
                case 10:
                    return _context.abrupt("return", null);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function retrieveFeatureFlags(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $eccee08bc464c9f2$export$fdbea518c19dfa8 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee2(config, _data, globalConfig) {
        var _globalConfig$ssr, _config$ssr, _globalConfig$ssr2, _config$ssr2;
        var includeFeatureFlags;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if ((_globalConfig$ssr = globalConfig.ssr) !== null && _globalConfig$ssr !== void 0 && _globalConfig$ssr.getFeatureFlags) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return", null);
                case 2:
                    includeFeatureFlags = ((_config$ssr = config.ssr) === null || _config$ssr === void 0 ? void 0 : _config$ssr.includeFeatureFlags) || ((_globalConfig$ssr2 = globalConfig.ssr) === null || _globalConfig$ssr2 === void 0 ? void 0 : _globalConfig$ssr2.includeFeatureFlags) || (0, $lqMQx.IncludeSSRFeatureFlagsConfig).WHEN_FMP;
                    if (!(includeFeatureFlags === (0, $lqMQx.IncludeSSRFeatureFlagsConfig).WHEN_AVAILABLE || (_config$ssr2 = config.ssr) !== null && _config$ssr2 !== void 0 && _config$ssr2.doneAsFmp && includeFeatureFlags === (0, $lqMQx.IncludeSSRFeatureFlagsConfig).WHEN_FMP)) {
                        _context2.next = 7;
                        break;
                    }
                    _context2.next = 6;
                    return $eccee08bc464c9f2$var$retrieveFeatureFlags(globalConfig.ssr.getFeatureFlags);
                case 6:
                    return _context2.abrupt("return", _context2.sent);
                case 7:
                    return _context2.abrupt("return", null);
                case 8:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function ssrFeatureFlags(_x2, _x3, _x4) {
        return _ref2.apply(this, arguments);
    };
}();

});

parcelRegister("4elC6", function(module, exports) {

$parcel$export(module.exports, "ssrSuccess", function () { return $31493c3ab2d030f9$export$a3dc8251cf55b2e0; });
var $31493c3ab2d030f9$export$a3dc8251cf55b2e0 = function ssrSuccess(config, _data, globalConfig) {
    if (config.ssr && config.ssr.doneAsFmp && globalConfig.ssr && globalConfig.ssr.getDoneMark && globalConfig.ssr.getDoneMark()) return {
        "ssr:success": true
    };
    return null;
};

});

parcelRegister("aR1mF", function(module, exports) {

$parcel$export(module.exports, "telemetryBrowser", function () { return $7e6fe99cb5ad7f72$export$386b10ac64a50b1; });

var $jXIui = parcelRequire("jXIui");
var $7e6fe99cb5ad7f72$export$386b10ac64a50b1 = function telemetryBrowser() {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($jXIui))).getParser) return null;
    var browser = (0, (/*@__PURE__*/$parcel$interopDefault($jXIui))).getParser(window.navigator.userAgent);
    return {
        "telemetry:browser:name": browser.getBrowserName(),
        "telemetry:browser:version": browser.getBrowserVersion()
    };
};

});
parcelRegister("jXIui", function(module, exports) {
!function(e, r) {
    module.exports = r();
}(module.exports, function() {
    return function(e) {
        var r = {};
        function t(n) {
            if (r[n]) return r[n].exports;
            var i = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
        }
        return t.m = e, t.c = r, t.d = function(e, r, n) {
            t.o(e, r) || Object.defineProperty(e, r, {
                enumerable: !0,
                get: n
            });
        }, t.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, t.t = function(e, r) {
            if (1 & r && (e = t(e)), 8 & r) return e;
            if (4 & r && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (t.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & r && "string" != typeof e) for(var i in e)t.d(n, i, (function(r) {
                return e[r];
            }).bind(null, i));
            return n;
        }, t.n = function(e) {
            var r = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(r, "a", r), r;
        }, t.o = function(e, r) {
            return Object.prototype.hasOwnProperty.call(e, r);
        }, t.p = "", t(t.s = 0);
    }([
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(1)) && n.__esModule ? n : {
                default: n
            };
            /*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */ var o = function() {
                function e() {}
                return e.getParser = function(e, r) {
                    if (void 0 === r && (r = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, r);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(2)) && n.__esModule ? n : {
                default: n
            };
            var o = function() {
                function e(e, r) {
                    if (void 0 === r && (r = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== r && this.parse();
                }
                var r = e.prototype;
                return r.getUA = function() {
                    return this._ua;
                }, r.test = function(e) {
                    return e.test(this._ua);
                }, r.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var r = i.default.find(function(r) {
                        if ("function" == typeof r.test) return r.test(e);
                        if (r.test instanceof Array) return r.test.some(function(r) {
                            return e.test(r);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return r && (this.parsedResult.browser = r.describe(this.getUA())), this.parsedResult.browser;
                }, r.isMobile = function() {
                    return this.test(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
                }, r.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, r.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, r.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, r.parse = function() {
                    return this.parseBrowser(), this;
                }, r.getResult = function() {
                    return Object.assign({}, this.parsedResult);
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            function n(e, r) {
                var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (t) return (t = t.call(e)).next.bind(t);
                if (Array.isArray(e) || (t = function(e, r) {
                    if (!e) return;
                    if ("string" == typeof e) return i(e, r);
                    var t = Object.prototype.toString.call(e).slice(8, -1);
                    "Object" === t && e.constructor && (t = e.constructor.name);
                    if ("Map" === t || "Set" === t) return Array.from(e);
                    if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return i(e, r);
                }(e)) || r && e && "number" == typeof e.length) {
                    t && (e = t);
                    var n = 0;
                    return function() {
                        return n >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[n++]
                        };
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function i(e, r) {
                (null == r || r > e.length) && (r = e.length);
                for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
                return n;
            }
            r.__esModule = !0, r.default = void 0;
            var o = function(e, r) {
                var t = r.match(e);
                return t && t.length > 0 && t[1] || "";
            }, s = function(e, r) {
                var t = r.match(e);
                return t && t.length > 1 && t[2] || "";
            }, u = /version\/(\d+(\.?_?\d+)+)/i, a = function(e, r) {
                void 0 === e && (e = []);
                for(var t, i = n(e); !(t = i()).done;){
                    var s = t.value, u = o(s, r);
                    if (u) return u;
                }
                return null;
            }, d = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Googlebot",
                            version: a([
                                /googlebot\/(\d+(\.\d+))/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                u,
                                /(?:opera)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                /(?:opr|opios)[\s/](\S+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Samsung Internet for Android",
                            version: a([
                                u,
                                /(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        return {
                            name: "NAVER Whale Browser",
                            version: a([
                                u,
                                /(?:whale)[\s/](\d+(?:\.\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Coast",
                            version: a([
                                u,
                                /(?:coast)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Touch",
                            version: a([
                                /(?:opt)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Internet Explorer",
                            version: a([
                                /(?:msie |rv:)(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: a([
                                /\sedg\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: s(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e)
                        };
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Vivaldi",
                            version: a([
                                /vivaldi\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Tizen",
                            version: a([
                                /(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Firefox",
                            version: a([
                                /(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Electron",
                            version: a([
                                /(?:electron)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chromium",
                            version: a([
                                /(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chrome",
                            version: a([
                                /(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Google Search",
                            version: a([
                                /(?:GSA)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: function(e) {
                        var r = !e.test(/like android/i), t = e.test(/android/i);
                        return r && t;
                    },
                    describe: function(e) {
                        return {
                            name: "Android Browser",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Safari",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var r = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: o(r, e),
                            version: s(r, e)
                        };
                    }
                }
            ];
            r.default = d, e.exports = r.default;
        }
    ]);
});

});


parcelRegister("20Arx", function(module, exports) {

$parcel$export(module.exports, "telemetryCpu", function () { return $1767d9b08c2cd258$export$9f84cb359ed29139; });
var $1767d9b08c2cd258$export$9f84cb359ed29139 = function telemetryCpu() {
    if (!navigator.hardwareConcurrency) return null;
    return {
        "telemetry:cpus": navigator.hardwareConcurrency
    };
};

});

parcelRegister("4ghSB", function(module, exports) {

$parcel$export(module.exports, "telemetryMemory", function () { return $31a6869091ce8675$export$496c14d72b257e07; });
var $31a6869091ce8675$export$496c14d72b257e07 = function telemetryMemory() {
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        "telemetry:memory": navigator.deviceMemory
    };
};

});

parcelRegister("aYzd4", function(module, exports) {

$parcel$export(module.exports, "telemetryNetwork", function () { return $7fdad1e8e9f4dfcc$export$88bf7b55f7fc4e8e; });
var $7fdad1e8e9f4dfcc$export$88bf7b55f7fc4e8e = function telemetryNetwork() {
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        "telemetry:network:effectiveType": navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        "telemetry:network:rtt": navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        "telemetry:network:downlink": navigator.connection.downlink
    };
};

});

parcelRegister("2EvZV", function(module, exports) {

$parcel$export(module.exports, "appTimings", function () { return $1ee8234991ca6719$export$e952f50a4f2d02da; });

var $kFnE9 = parcelRequire("kFnE9");

var $lqMQx = parcelRequire("lqMQx");

var $lsb3O = parcelRequire("lsb3O");

var $eCyrY = parcelRequire("eCyrY");
function $1ee8234991ca6719$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1ee8234991ca6719$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1ee8234991ca6719$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1ee8234991ca6719$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1ee8234991ca6719$export$e952f50a4f2d02da = function appTimings(config, data, globalConfig) {
    var explicitTimings = config.type === (0, $lqMQx.BMEventsType).PAGE_LOAD && data.explicitTimings || null;
    var timings = (0, $lsb3O.customTimings)(config, data);
    var ssr = config.type === (0, $lqMQx.BMEventsType).PAGE_LOAD && data.isInitial ? (0, $eCyrY.ssrTimings)(config, data, globalConfig) : null;
    var timingsApp = (explicitTimings || timings || ssr) && $1ee8234991ca6719$var$_objectSpread($1ee8234991ca6719$var$_objectSpread($1ee8234991ca6719$var$_objectSpread({}, explicitTimings), timings), ssr);
    if (!timingsApp) return null;
    return {
        "timings:app": timingsApp
    };
};

});
parcelRegister("lsb3O", function(module, exports) {

$parcel$export(module.exports, "customTimings", function () { return $f9e4cae1df823342$export$6126f85083a72c6e; });

var $9lrK1 = parcelRequire("9lrK1");
var $f9e4cae1df823342$var$retrieveTimings = function retrieveTimings(config, data) {
    var relativeTo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var prefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
    var configTimings = config.timings || [];
    var timings = configTimings.reduce(function(entries, timing) {
        if (timing.startMark && !data.marks[timing.startMark]) return entries;
        if (timing.endMark && !data.marks[timing.endMark]) return entries;
        if (data.start === null || data.stop === null) return null;
        var startTime = Math.round((data.marks[timing.startMark] !== undefined ? data.marks[timing.startMark] : data.start) - data.start + relativeTo);
        var duration = Math.round((data.marks[timing.endMark] !== undefined ? data.marks[timing.endMark] : data.stop) - data.start - startTime + relativeTo);
        entries["".concat(prefix).concat(timing.key)] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
var $f9e4cae1df823342$export$6126f85083a72c6e = function customTimings(config, data) {
    if (!config.timings && data.submetrics.length === 0) return null;
    var timings = $f9e4cae1df823342$var$retrieveTimings(config, data);
    data.submetrics.forEach(function(submetric) {
        if (submetric.start !== null && submetric.stop !== null) {
            var submetricPrefix = "include:".concat(submetric.config.key);
            timings[submetricPrefix] = {
                startTime: Math.round(submetric.start - data.start),
                duration: Math.round(submetric.stop - submetric.start)
            };
            Object.assign(timings, $f9e4cae1df823342$var$retrieveTimings(submetric.config, submetric, submetric.start - data.start, submetricPrefix + (0, $9lrK1.NESTED_METRIC_SEPARATOR)));
        }
    });
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});
parcelRegister("9lrK1", function(module, exports) {

$parcel$export(module.exports, "NESTED_METRIC_SEPARATOR", function () { return $6cdb980d80cb5bab$export$b98e411ae80c806f; });
var $6cdb980d80cb5bab$export$b98e411ae80c806f = "/";

});


parcelRegister("eCyrY", function(module, exports) {

$parcel$export(module.exports, "ssrTimings", function () { return $aa4f565e446d075e$export$130f411261a599c5; });

var $340K4 = parcelRequire("340K4");

var $9lrK1 = parcelRequire("9lrK1");
var $aa4f565e446d075e$var$filterEntry = function filterEntry(entry) {
    return !(!entry || (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(entry) !== "object" || entry.startTime < 0 || entry.duration < 0);
};
var $aa4f565e446d075e$var$mapEntry = function mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
var $aa4f565e446d075e$var$SSR_PREFIX = "ssr";
var $aa4f565e446d075e$var$mapKey = function mapKey(key) {
    if (key === "total") return $aa4f565e446d075e$var$SSR_PREFIX;
    return "".concat($aa4f565e446d075e$var$SSR_PREFIX).concat((0, $9lrK1.NESTED_METRIC_SEPARATOR)).concat(key);
};
var $aa4f565e446d075e$export$130f411261a599c5 = function ssrTimings(_config, _data, globalConfig) {
    if (!globalConfig.ssr || !globalConfig.ssr.getTimings) return null;
    var timings = globalConfig.ssr.getTimings();
    if (!timings) return null;
    var ssrTimings = Object.entries(timings).reduce(function(acc, entry) {
        if ($aa4f565e446d075e$var$filterEntry(entry[1])) acc[$aa4f565e446d075e$var$mapKey(entry[0])] = $aa4f565e446d075e$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});


parcelRegister("5rFPR", function(module, exports) {

$parcel$export(module.exports, "bundleEvalTimings", function () { return $3f6fed050c9ca99a$export$1a2bb347935fc536; });

var $9q1kH = parcelRequire("9q1kH");
var $3f6fed050c9ca99a$var$bundleEvalTimingsInternal = function bundleEvalTimingsInternal(_config, data, globalConfig) {
    var _globalConfig$enableB;
    var performance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window.performance;
    var started = {};
    var timings = {};
    var enableBundleEvalTimings = (_globalConfig$enableB = globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.enableBundleEvalTimings) !== null && _globalConfig$enableB !== void 0 ? _globalConfig$enableB : true;
    performance.getEntriesByType("mark").forEach(function(mark) {
        if (!globalConfig.bundleEvalTimings) return;
        var result = globalConfig.bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result) return;
        var type = result.type, name = result.name;
        if (type === "start" && data.start !== null && mark.startTime >= data.start) {
            started[name] = mark;
            return;
        }
        if (type === "end" && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.start),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (globalConfig.bundleEvalTimings && globalConfig.bundleEvalTimings.additionalTimings && data.start !== null && enableBundleEvalTimings) {
        var result = globalConfig.bundleEvalTimings.additionalTimings(data.start);
        if (result) Object.entries(result).forEach(function(_ref) {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), key = _ref2[0], value = _ref2[1];
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        "timings:bundleEval": timings
    };
};
var $3f6fed050c9ca99a$export$1a2bb347935fc536 = function bundleEvalTimings() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return new Promise(function(resolve) {
        setTimeout(function() {
            resolve($3f6fed050c9ca99a$var$bundleEvalTimingsInternal.apply(void 0, args));
        });
    });
};

});

parcelRegister("8jPNU", function(module, exports) {

$parcel$export(module.exports, "resourceTimings", function () { return $60e84849610bea0e$export$81a7d52441a06b50; });

var $kFnE9 = parcelRequire("kFnE9");
function $60e84849610bea0e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $60e84849610bea0e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $60e84849610bea0e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $60e84849610bea0e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $60e84849610bea0e$var$cacheableTypes = [
    "script",
    "link"
];
var $60e84849610bea0e$var$resourceTypes = [
    "fetch",
    "xmlhttprequest"
];
var $60e84849610bea0e$var$CACHE_NETWORK = "network";
var $60e84849610bea0e$var$CACHE_MEMORY = "memory";
var $60e84849610bea0e$var$CACHE_DISK = "disk";
var $60e84849610bea0e$var$calculateTransferType = function calculateTransferType(type, duration, size) {
    if (!$60e84849610bea0e$var$cacheableTypes.includes(type)) return $60e84849610bea0e$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $60e84849610bea0e$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $60e84849610bea0e$var$CACHE_DISK;
    if (size === undefined) return null;
    return $60e84849610bea0e$var$CACHE_NETWORK;
};
var $60e84849610bea0e$var$hasAccessToResourceSize = function hasAccessToResourceSize(url, type, hasTimingHeaders) {
    return !$60e84849610bea0e$var$cacheableTypes.includes(type) || url.includes("localhost") || url.includes(window.location.hostname) || hasTimingHeaders(url);
};
var $60e84849610bea0e$var$getReportedInitiatorTypes = function getReportedInitiatorTypes(xhrEnabled) {
    if (xhrEnabled) return [
        "script",
        "link",
        "fetch",
        "xmlhttprequest"
    ];
    return [
        "script",
        "link",
        "fetch"
    ];
};
var $60e84849610bea0e$var$withoutHeaders = function withoutHeaders() {
    return false;
};
var $60e84849610bea0e$var$evaluateAccessToResourceTimings = function evaluateAccessToResourceTimings(entry) {
    if (entry.responseStart === 0 && entry.startTime > entry.responseStart) return false;
    return true;
};
var $60e84849610bea0e$var$getEvaluatedTimingHeader = function getEvaluatedTimingHeader(entry) {
    var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var hasTimingHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $60e84849610bea0e$var$withoutHeaders;
    if (!enabled) return null;
    var manualResolution = entry.name.includes("localhost") || entry.name.includes(window.location.hostname) || hasTimingHeaders(entry.name);
    var autoResolution = $60e84849610bea0e$var$evaluateAccessToResourceTimings(entry);
    return {
        m_h: manualResolution,
        a_h: autoResolution
    };
};
var $60e84849610bea0e$var$getSizeObject = function getSizeObject(size) {
    return size !== undefined ? {
        size: size
    } : null;
};
var $60e84849610bea0e$var$getNetworkData = function getNetworkData(item, eventStart) {
    var hasTimingHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $60e84849610bea0e$var$withoutHeaders;
    var name = item.name, duration = item.duration, size = item.transferSize, type = item.initiatorType, responseStart = item.responseStart;
    var ttfb = Math.round(responseStart - eventStart);
    if (!$60e84849610bea0e$var$hasAccessToResourceSize(name, type, hasTimingHeaders)) return {};
    if ($60e84849610bea0e$var$cacheableTypes.includes(type)) {
        var transferType = $60e84849610bea0e$var$calculateTransferType(type, duration, size);
        if (!transferType) return $60e84849610bea0e$var$_objectSpread({
            ttfb: ttfb
        }, $60e84849610bea0e$var$getSizeObject(size));
        if (transferType !== $60e84849610bea0e$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return $60e84849610bea0e$var$_objectSpread({
            ttfb: ttfb,
            transferType: transferType
        }, $60e84849610bea0e$var$getSizeObject(size));
    }
    return $60e84849610bea0e$var$_objectSpread({
        ttfb: ttfb
    }, $60e84849610bea0e$var$getSizeObject(size));
};
var $60e84849610bea0e$export$81a7d52441a06b50 = function resourceTimings(_config, data, globalConfig) {
    var performance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window.performance;
    if (data.start === null) return null;
    var resources = performance.getEntriesByType("resource").filter(function(entry) {
        return entry.startTime >= data.start;
    });
    if (!resources.length) return null;
    var resourceTiming = {};
    var xhrFilter = globalConfig.resourceTimings.xhrFilter;
    var reportedInitiatorTypes = $60e84849610bea0e$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach(function(item) {
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        var name = item.name, startTime = item.startTime, duration = item.duration, workerStart = item.workerStart, fetchStart = item.fetchStart, type = item.initiatorType;
        if (!name) return;
        if (type === "xmlhttprequest" && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        var url = $60e84849610bea0e$var$resourceTypes.includes(type) ? globalConfig.resourceTimings.sanitiseEndpoints(name) : globalConfig.resourceTimings.mapResources(name);
        if (resourceTiming[url]) return;
        resourceTiming[url] = $60e84849610bea0e$var$_objectSpread($60e84849610bea0e$var$_objectSpread({
            startTime: Math.round(startTime - data.start),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.start), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.start), 0),
            type: type
        }, $60e84849610bea0e$var$getNetworkData(item, data.start, globalConfig.resourceTimings.hasTimingHeaders)), $60e84849610bea0e$var$getEvaluatedTimingHeader(item, globalConfig.resourceTimings.experimental__reportEvaluatedTimingHeaders, globalConfig.resourceTimings.hasTimingHeaders));
    });
    return {
        "timings:resource": resourceTiming
    };
};

});


parcelRegister("bkfmQ", function(module, exports) {

$parcel$export(module.exports, "makeShareableGlobalConfig", function () { return $83ed7ba2943c4b7e$export$5b4fb14409a2a825; });

var $4mVfk = parcelRequire("4mVfk");

var $kFnE9 = parcelRequire("kFnE9");

var $b4Ivn = parcelRequire("b4Ivn");

var $8DpVo = parcelRequire("8DpVo");

var $lqMQx = parcelRequire("lqMQx");
function $83ed7ba2943c4b7e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $83ed7ba2943c4b7e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $83ed7ba2943c4b7e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $83ed7ba2943c4b7e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $83ed7ba2943c4b7e$var$makeFeatureFlags = function makeFeatureFlags(allFeatureFlags, eventTypeFeatureFlags) {
    var featureFlagsForType = [];
    if (allFeatureFlags) featureFlagsForType.push.apply(featureFlagsForType, (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(allFeatureFlags));
    if (eventTypeFeatureFlags) featureFlagsForType.push.apply(featureFlagsForType, (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(eventTypeFeatureFlags));
    return featureFlagsForType;
};
var $83ed7ba2943c4b7e$var$makeGlobalConfigPerType = function makeGlobalConfigPerType(global, ffClient, allEventsConfig, eventConfig) {
    var _ref, _eventConfig$pageVisi;
    var allEventsConfigCustom = allEventsConfig && allEventsConfig.custom;
    var eventConfigCustom = eventConfig && eventConfig.custom;
    var custom = (allEventsConfigCustom || eventConfigCustom) && $83ed7ba2943c4b7e$var$_objectSpread($83ed7ba2943c4b7e$var$_objectSpread({}, allEventsConfigCustom), eventConfigCustom) || undefined;
    var allEventsConfigPlugins = allEventsConfig && allEventsConfig.plugins;
    var eventConfigPlugins = eventConfig && eventConfig.plugins;
    var plugins = (allEventsConfigPlugins || eventConfigPlugins) && [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(allEventsConfigPlugins || []), (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(eventConfigPlugins || [])) || undefined;
    var pageVisibleValueOrigin = (_ref = (_eventConfig$pageVisi = eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.pageVisibleValueOrigin) !== null && _eventConfig$pageVisi !== void 0 ? _eventConfig$pageVisi : allEventsConfig === null || allEventsConfig === void 0 ? void 0 : allEventsConfig.pageVisibleValueOrigin) !== null && _ref !== void 0 ? _ref : (0, $lqMQx.PageVisibleValueOrigin).documentHidden;
    return Object.freeze($83ed7ba2943c4b7e$var$_objectSpread($83ed7ba2943c4b7e$var$_objectSpread({}, global), {}, {
        featureFlags: Object.freeze($83ed7ba2943c4b7e$var$makeFeatureFlags(allEventsConfig && allEventsConfig.featureFlags, eventConfig && eventConfig.featureFlags).reduce(function(acc, value) {
            acc[value] = ffClient.getValue(value);
            return acc;
        }, {})),
        custom: custom,
        plugins: plugins,
        histogram: eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.histogram,
        pageVisibleValueOrigin: pageVisibleValueOrigin,
        enableBundleEvalTimings: eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.enableBundleEvalTimings
    }));
};
var $83ed7ba2943c4b7e$export$5b4fb14409a2a825 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee(globalConfig) {
        var _globalConfig$events$, _globalConfig$events$2, _globalConfig$events$3, _ref3;
        var ffClient, global;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return globalConfig.plugins.featureFlags.client;
                case 2:
                    ffClient = _context.sent;
                    global = {
                        app: globalConfig.info.app,
                        product: globalConfig.info.product,
                        region: globalConfig.info.region,
                        resourceTimings: globalConfig.plugins.resourceTimings,
                        bundleEvalTimings: globalConfig.plugins.bundleEvalTimings,
                        ffClient: ffClient,
                        hostname: globalConfig.info.hostname || window.location.hostname,
                        ssr: globalConfig.ssr,
                        enableReactUFOTracker: globalConfig.enableReactUFOTracker,
                        webVitals: {
                            enabled: (_globalConfig$events$ = globalConfig.events[(0, $lqMQx.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$ === void 0 ? void 0 : _globalConfig$events$.enabled,
                            timeout: (_globalConfig$events$2 = globalConfig.events[(0, $lqMQx.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$2 === void 0 ? void 0 : _globalConfig$events$2.timeout,
                            ttciEnabled: (_globalConfig$events$3 = globalConfig.events[(0, $lqMQx.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$3 === void 0 ? void 0 : _globalConfig$events$3.ttciEnabled
                        }
                    };
                    return _context.abrupt("return", (_ref3 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref3, (0, $lqMQx.BMEventsType).PAGE_LOAD, $83ed7ba2943c4b7e$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $lqMQx.BMEventsType).PAGE_LOAD])), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref3, (0, $lqMQx.BMEventsType).PAGE_SEGMENT_LOAD, $83ed7ba2943c4b7e$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $lqMQx.BMEventsType).PAGE_SEGMENT_LOAD])), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref3, (0, $lqMQx.BMEventsType).INLINE_RESULT, $83ed7ba2943c4b7e$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $lqMQx.BMEventsType).INLINE_RESULT])), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref3, (0, $lqMQx.BMEventsType).CUSTOM, $83ed7ba2943c4b7e$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $lqMQx.BMEventsType).CUSTOM])), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_ref3, (0, $lqMQx.BMEventsType).WEB_VITALS, $83ed7ba2943c4b7e$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $lqMQx.BMEventsType).WEB_VITALS])), _ref3));
                case 5:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function makeShareableGlobalConfig(_x) {
        return _ref2.apply(this, arguments);
    };
}();

});



parcelRegister("c7cuD", function(module, exports) {

$parcel$export(module.exports, "getMark", function () { return $edbb428983459a02$export$f45af69d005a6ed; });
const $edbb428983459a02$var$getEntryByName = (name)=>{
    if (window.performance && window.performance.getEntriesByName) {
        const entries = window.performance.getEntriesByName(name);
        return entries && entries[0];
    }
    return null;
};
const $edbb428983459a02$export$f45af69d005a6ed = (name)=>{
    const mark = $edbb428983459a02$var$getEntryByName(name);
    if (mark) return mark.startTime;
    // ./src/ssr/services/metrics/utils.ts uses a namespace for the performance
    // mark when rendering SSR. If we didn't find an entry already, try with the
    // default namespace
    const namespacedMark = $edbb428983459a02$var$getEntryByName(`SSR_SPA_${name}`);
    if (namespacedMark) return namespacedMark.startTime;
    return undefined;
};

});

parcelRegister("jS1LM", function(module, exports) {

$parcel$export(module.exports, "mapResources", function () { return $a3e81959d2e9735f$export$17a3da637c5ea336; });
$parcel$export(module.exports, "sanitiseEndpoints", function () { return $a3e81959d2e9735f$export$6dfc8bfc2349f367; });
$parcel$export(module.exports, "bundleEvalTimings", function () { return $a3e81959d2e9735f$export$1a2bb347935fc536; });

var $k6V2y = parcelRequire("k6V2y");
const $a3e81959d2e9735f$var$JS_EVAL_START = ":load-start";
const $a3e81959d2e9735f$var$JS_EVAL_STOP = ":load-end";
/**
 * Processors used by 'mapResources'
 */ const $a3e81959d2e9735f$var$resourceProcessors = [
    $k6V2y.cloudfrontAssets,
    $k6V2y.localhostAssets,
    $k6V2y.newRelicBamCell,
    $k6V2y.newRelicCom
];
/**
 * Processors used by 'sanitiseEndpoints'
 */ const $a3e81959d2e9735f$var$sanitiseProcessors = [
    $k6V2y.gatewayApi,
    $k6V2y.bitbucketApi,
    $k6V2y.repositoryPaths,
    $k6V2y.sentryApi,
    $k6V2y.atlassianApi
];
const $a3e81959d2e9735f$export$17a3da637c5ea336 = (url)=>{
    return $k6V2y.processUrl(url, $a3e81959d2e9735f$var$resourceProcessors);
};
const $a3e81959d2e9735f$export$6dfc8bfc2349f367 = (url)=>{
    return $k6V2y.processUrl(url, $a3e81959d2e9735f$var$sanitiseProcessors);
};
const $a3e81959d2e9735f$export$1a2bb347935fc536 = {
    mapPerformanceMark: (mark)=>{
        if (mark.endsWith($a3e81959d2e9735f$var$JS_EVAL_START)) return {
            name: mark.substring(0, mark.indexOf($a3e81959d2e9735f$var$JS_EVAL_START)),
            type: "start"
        };
        if (mark.endsWith($a3e81959d2e9735f$var$JS_EVAL_STOP)) return {
            name: mark.substring(0, mark.indexOf($a3e81959d2e9735f$var$JS_EVAL_STOP)),
            type: "end"
        };
        return null;
    }
};

});
parcelRegister("k6V2y", function(module, exports) {

$parcel$export(module.exports, "cloudfrontAssets", function () { return $97e9fba0289f71c4$export$9581c822f3b77e4c; });
$parcel$export(module.exports, "localhostAssets", function () { return $97e9fba0289f71c4$export$32827123677bcf65; });
$parcel$export(module.exports, "gatewayApi", function () { return $97e9fba0289f71c4$export$15247145d398acd9; });
$parcel$export(module.exports, "bitbucketApi", function () { return $97e9fba0289f71c4$export$31d00ab5c188606b; });
$parcel$export(module.exports, "repositoryPaths", function () { return $97e9fba0289f71c4$export$1d6bb2a2af295e96; });
$parcel$export(module.exports, "newRelicBamCell", function () { return $97e9fba0289f71c4$export$376b04b55ec2f5bd; });
$parcel$export(module.exports, "newRelicCom", function () { return $97e9fba0289f71c4$export$aa877d0b2b2b93d1; });
$parcel$export(module.exports, "atlassianApi", function () { return $97e9fba0289f71c4$export$76d217cb15e43f5b; });
$parcel$export(module.exports, "sentryApi", function () { return $97e9fba0289f71c4$export$7da8059870412f09; });
$parcel$export(module.exports, "processUrl", function () { return $97e9fba0289f71c4$export$8378cb52a6ed7e05; });

var $3XbtU = parcelRequire("3XbtU");
var $i3ov7 = parcelRequire("i3ov7");
const $97e9fba0289f71c4$export$21afe8ca77e5cab2 = (url)=>{
    /**
   * [^/]
   *   start with the first non-"/" character
   * (?!.*\/
   *   that doesn't have a trailing slash
   * (?!$))
   *   _unless_ that trailing slash is the end of the line
   * .*
   *   finally, grab everything until the end
   */ const matches = url.match(/[^/](?!.*\/(?!$)).*/) || [];
    return matches[0] || url;
};
const $97e9fba0289f71c4$export$4f9c066ec897736f = (url)=>{
    // Pattern to match and replace a question mark and everything after it
    return url.replace(/\?.*/, "");
};
const $97e9fba0289f71c4$export$21e6a895087dc443 = (url)=>{
    // Pattern to match and replace a pound sign and everything after it
    return url.replace(/#.*/, "");
};
const $97e9fba0289f71c4$export$9f7cc2006d12bae0 = (url)=>{
    /**
   * (\.)(?:[a-zA-Z0-9]{8})
   *   matches an 8 character string that immediately follows a "."
   * (?=\.map\.js|\.js|\.css)
   *   that has one of the specified extensions immediately after it
   */ return url.replace(/(\.)(?:[a-zA-Z0-9]{8})(?=\.map\.js|\.js|\.css)/, "");
};
const $97e9fba0289f71c4$export$9581c822f3b77e4c = {
    pattern: /(^.*)\/\/bbc-object-storage--frontbucket\.us-(.*)-1\.(.*)\.public\.atl-paas\.net(.*)/,
    onMatch: (url, _matches)=>{
        let processedUrl = url;
        processedUrl = $97e9fba0289f71c4$export$21afe8ca77e5cab2(processedUrl);
        processedUrl = $97e9fba0289f71c4$export$4f9c066ec897736f(processedUrl);
        processedUrl = $97e9fba0289f71c4$export$9f7cc2006d12bae0(processedUrl);
        return `<cloudfront>/${processedUrl}`;
    }
};
const $97e9fba0289f71c4$export$32827123677bcf65 = {
    pattern: /(^.*)\/\/(.*)localhost:([0-9]+)\/static(.*)/,
    onMatch: (url, _matches)=>{
        let processedUrl = url;
        processedUrl = $97e9fba0289f71c4$export$21afe8ca77e5cab2(processedUrl);
        processedUrl = $97e9fba0289f71c4$export$4f9c066ec897736f(processedUrl);
        processedUrl = $97e9fba0289f71c4$export$9f7cc2006d12bae0(processedUrl);
        return `<localhost>/${processedUrl}`;
    }
};
const $97e9fba0289f71c4$export$15247145d398acd9 = {
    pattern: new RegExp(`(^.*)/${window.location.hostname}/gateway/api/`),
    onMatch: (url, _matches)=>{
        let processedUrl = url;
        processedUrl = $97e9fba0289f71c4$export$21afe8ca77e5cab2(processedUrl);
        processedUrl = $97e9fba0289f71c4$export$4f9c066ec897736f(processedUrl);
        return `<gateway-api>/${processedUrl}`;
    }
};
const $97e9fba0289f71c4$export$31d00ab5c188606b = {
    pattern: new RegExp(`(^.*)/(${window.location.hostname}/!api/)|(api.${window.location.hostname})`),
    onMatch: (url, _matches)=>{
        let processedUrl = url;
        processedUrl = $97e9fba0289f71c4$export$21afe8ca77e5cab2(processedUrl);
        processedUrl = $97e9fba0289f71c4$export$4f9c066ec897736f(processedUrl);
        return `<bitbucket-api>/${processedUrl}`;
    }
};
const $97e9fba0289f71c4$export$1d6bb2a2af295e96 = {
    /**
   * (^.*)/${window.location.hostname}
   *   start within the app domain
   * /[^/]+/[^/]
   *   has at least two route paths after the TLD
   * .*?(?=\\?|\\/|$)
   *   lazy match everything until it hits a "?", "/", or end of string
   */ pattern: new RegExp(`(^.*)/${window.location.hostname}/[^/]+/[^/].*?(?=\\?|\\/|$)`),
    onMatch: (url, matches)=>{
        let processedUrl = url.replace(matches[0], "<repository>");
        processedUrl = $97e9fba0289f71c4$export$4f9c066ec897736f(processedUrl);
        processedUrl = $97e9fba0289f71c4$export$21e6a895087dc443(processedUrl);
        return processedUrl;
    }
};
const $97e9fba0289f71c4$export$376b04b55ec2f5bd = {
    pattern: /(^.*)\/bam-cell\.nr-data\.net(.*)/,
    onMatch: (_url, _matches)=>{
        return `<new-relic-bam-cell>`;
    }
};
const $97e9fba0289f71c4$export$aa877d0b2b2b93d1 = {
    pattern: /(^.*)\.newrelic\.com(.*)/,
    onMatch: (_url, _matches)=>{
        return `<new-relic>`;
    }
};
const $97e9fba0289f71c4$export$76d217cb15e43f5b = {
    pattern: /(^.*)\/api\.(.*)atlassian\.com\/(.*)/,
    onMatch: (url, _matches)=>{
        let processedUrl = url;
        processedUrl = $97e9fba0289f71c4$export$21afe8ca77e5cab2(processedUrl);
        processedUrl = $97e9fba0289f71c4$export$4f9c066ec897736f(processedUrl);
        return `<atlassian-api>/${processedUrl}`;
    }
};
const $97e9fba0289f71c4$export$7da8059870412f09 = {
    pattern: /(^.*)\/(.*)sentry\.io\/(.*)/,
    onMatch: (url, _matches)=>{
        let processedUrl = url;
        processedUrl = $97e9fba0289f71c4$export$4f9c066ec897736f(processedUrl);
        processedUrl = $97e9fba0289f71c4$export$21afe8ca77e5cab2(processedUrl);
        return `<sentry-api>/${processedUrl}`;
    }
};
const $97e9fba0289f71c4$export$8378cb52a6ed7e05 = (url, processors)=>{
    for(let a = 0; a < processors.length; a += 1){
        const matches = url.match(processors[a].pattern);
        if (matches) return processors[a].onMatch(url, matches);
    }
    // Try to extract the TLD
    // Very rudimentary but will match everything from the beginning through the first '/' after a '//'
    const tldMatch = url.match(/(^.*)\/\/(.+?)\//);
    // Since these aren't urgent warnings, we only need to capture a sampling of them
    // I tried to get the built-in tracesSampler method working, but with no luck
    // We may want to figure that out later though as it could significantly cut down on our log rate:
    // https://docs.sentry.io/platforms/javascript/configuration/sampling/
    const SAMPLE_RATE = 0.02;
    if (Math.random() < SAMPLE_RATE) $3XbtU.captureMessage(`Unprocessed browser-metrics URL at TLD: ${tldMatch ? tldMatch[0] : "unknown"}`, $i3ov7.Severity.Warning);
    return "<unknown>";
};

});



parcelRegister("7RxS0", function(module, exports) {

$parcel$export(module.exports, "useMetricSender", function () { return $4a4ffa5af630e115$export$f617a46bf1bb6ce0; });
$parcel$export(module.exports, "MetricSender", function () { return $4a4ffa5af630e115$export$731c6734ad4e2b19; });
$parcel$export(module.exports, "useAbortMetricOnUnmount", function () { return $4a4ffa5af630e115$export$58ca20ff972f3c48; });

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("dGzLf");
var $aAre5 = parcelRequire("aAre5");
parcelRequire("3hzea");
var $a5HLv = parcelRequire("a5HLv");

var $aanBq = parcelRequire("aanBq");
const $4a4ffa5af630e115$export$f617a46bf1bb6ce0 = (metric)=>{
    const repository = (0, $aAre5.useSelector)((0, $aanBq.getCurrentRepository));
    const metricRef = (0, $9nHZC.useRef)();
    const sendMetric = (0, $9nHZC.useCallback)(()=>{
        // We only want this hook to fire if metric has changed, not any other
        // dependencies, because it marks the end of the metric. However, we want to
        // be passively aware of when dependencies change, so we can include them as
        // custom attributes, if they are available.
        if (metricRef.current !== metric) {
            let metricReady = true;
            // Unless it's a full page load, we want to ensure state === 'started'
            if (metric.type !== "PAGE_LOAD") metricReady = metric.getData().state === "started";
            if (metricReady) {
                const customValues = {};
                if (repository !== null && repository !== void 0 && repository.uuid) customValues.repositoryId = (0, $a5HLv.uncurlyUuid)(repository.uuid);
                const stopArgs = {
                    customData: customValues
                };
                metric.stop(stopArgs);
            }
        }
        metricRef.current = metric;
    }, [
        metric,
        repository
    ]);
    return sendMetric;
};
const $4a4ffa5af630e115$export$731c6734ad4e2b19 = /*#__PURE__*/ (0, $9nHZC.memo)(({ metric: metric })=>{
    const sendMetric = $4a4ffa5af630e115$export$f617a46bf1bb6ce0(metric);
    (0, $9nHZC.useEffect)(()=>{
        sendMetric();
    }, [
        sendMetric
    ]);
    return null;
});
function $4a4ffa5af630e115$export$58ca20ff972f3c48(metric) {
    (0, $9nHZC.useEffect)(()=>{
        return ()=>{
            if (metric.getData().state === "started") metric.stop();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});

parcelRegister("3TI1y", function(module, exports) {

$parcel$export(module.exports, "startMetric", function () { return $19a1e99be10ce23a$export$236ec03323f8399a; });
const $19a1e99be10ce23a$export$236ec03323f8399a = (metric)=>{
    if (metric.getData().state !== "started") metric.start();
};

});

parcelRegister("eRsFk", function(module, exports) {

$parcel$export(module.exports, "PageSegmentMetricStarter", function () { return $334caab98ce955b4$export$8fbccb828b2c3a50; });

var $9nHZC = parcelRequire("9nHZC");

var $3TI1y = parcelRequire("3TI1y");
const $334caab98ce955b4$export$8fbccb828b2c3a50 = /*#__PURE__*/ (0, $9nHZC.memo)(({ metric: metric })=>{
    (0, $3TI1y.startMetric)(metric);
    return null;
});

});

parcelRegister("iYwpt", function(module, exports) {

});


parcelRegister("bjxwU", function(module, exports) {

$parcel$export(module.exports, "bitbucketStore", function () { return $553c9e3072cd665a$export$458f058128ac4031; });
// @ts-ignore this package has no typings

var $1kdi8 = parcelRequire("1kdi8");

var $jF3Yx = parcelRequire("jF3Yx");

var $h7VOS = parcelRequire("h7VOS");

var $1hYh8 = parcelRequire("1hYh8");

var $aBe8c = parcelRequire("aBe8c");

var $5ppJu = parcelRequire("5ppJu");

var $g8glp = parcelRequire("g8glp");

var $1ZBmx = parcelRequire("1ZBmx");

var $bGAE6 = parcelRequire("bGAE6");

var $fE4bV = parcelRequire("fE4bV");

var $1sh9M = parcelRequire("1sh9M");

var $mL4xD = parcelRequire("mL4xD");

var $lT98D = parcelRequire("lT98D");

var $2IWOH = parcelRequire("2IWOH");
const $553c9e3072cd665a$var$composeEnhancers = // Enabled dev-mode redux devtools with traceability
window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    trace: true,
    traceLimit: 200,
    maxAge: 200
}) : (0, $jF3Yx.compose);
const $553c9e3072cd665a$var$createBitbucketStore = ({ enableSagas: enableSagas = true, enableStories: enableStories = false } = {
    enableSagas: !(0, $1ZBmx.IS_SERVER),
    enableStories: false
})=>{
    const middlewares = [
        (0, $fE4bV.default)(),
        (0, $1sh9M.default)(),
        (0, $lT98D.default)()
    ];
    let sagaMiddleware;
    if (enableSagas) {
        sagaMiddleware = (0, $h7VOS.default)({
            context: {
                [(0, $g8glp.SAGAS_CONTEXT_KEY_PR_APIS)]: $aBe8c,
                [(0, $g8glp.SAGAS_CONTEXT_KEY_PIPELINES_WEBSOCKET)]: (0, $1hYh8.default)
            }
        });
        middlewares.push(sagaMiddleware);
    }
    // Put this last to collect the action information in its "final" state
    middlewares.push((0, $mL4xD.default));
    const enhancers = [
        (0, $jF3Yx.applyMiddleware)(...middlewares)
    ];
    if (enableStories) enhancers.push((0, (/*@__PURE__*/$parcel$interopDefault($1kdi8))));
    const store = (0, $jF3Yx.createStore)((0, $2IWOH.default), (0, $bGAE6.getReduxStoreSsrState)(), $553c9e3072cd665a$var$composeEnhancers(...enhancers));
    if (enableSagas && sagaMiddleware) sagaMiddleware.run((0, $5ppJu.default));
    return store;
};
var $553c9e3072cd665a$export$2e2bcd8739ae039 = $553c9e3072cd665a$var$createBitbucketStore;
const $553c9e3072cd665a$export$458f058128ac4031 = $553c9e3072cd665a$var$createBitbucketStore();

});
parcelRegister("1kdi8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setStateAction = module.exports.mergeStateAction = module.exports.WITH_REDUX_ENABLED = undefined;
var $0f71f81f321d7dd1$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $bkoED = parcelRequire("bkoED");
var $0f71f81f321d7dd1$var$types = $0f71f81f321d7dd1$var$_interopRequireWildcard($bkoED);
function $0f71f81f321d7dd1$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $0f71f81f321d7dd1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $0f71f81f321d7dd1$var$WITH_REDUX_ENABLED = module.exports.WITH_REDUX_ENABLED = "__WITH_REDUX_ENABLED__";
var $0f71f81f321d7dd1$var$mergeStateAction = module.exports.mergeStateAction = function mergeStateAction(state) {
    return {
        type: $0f71f81f321d7dd1$var$types.MERGE_STATE_TYPE,
        state: state
    };
};
var $0f71f81f321d7dd1$var$setStateAction = module.exports.setStateAction = function setStateAction(state) {
    return {
        type: $0f71f81f321d7dd1$var$types.SET_STATE_TYPE,
        state: state
    };
};
var $0f71f81f321d7dd1$var$enhanceReducer = function enhanceReducer(mainReducer) {
    return function(state, action) {
        switch(action.type){
            case $0f71f81f321d7dd1$var$types.MERGE_STATE_TYPE:
                return $0f71f81f321d7dd1$var$_extends({}, state, action.state);
            case $0f71f81f321d7dd1$var$types.SET_STATE_TYPE:
                return $0f71f81f321d7dd1$var$_extends({}, action.state);
            default:
                return mainReducer(state, action);
        }
    };
};
module.exports.default = function(createStore) {
    return function(reducer, state, enhancer) {
        var store = createStore($0f71f81f321d7dd1$var$enhanceReducer(reducer), state, enhancer);
        var listener = null;
        var enhanceDispatch = function enhanceDispatch(dispatch) {
            return function(action) {
                var prev = store.getState();
                dispatch(action);
                var next = store.getState();
                if (listener) listener(action, prev, next);
            };
        };
        return $0f71f81f321d7dd1$var$_extends({}, store, $0f71f81f321d7dd1$var$_defineProperty({
            dispatch: enhanceDispatch(store.dispatch)
        }, $0f71f81f321d7dd1$var$WITH_REDUX_ENABLED, {
            listenToStateChange: function listenToStateChange(l) {
                return listener = l;
            }
        }));
    };
};

});
parcelRegister("bkoED", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $83f4afce595204be$var$MERGE_STATE_TYPE = module.exports.MERGE_STATE_TYPE = "@@WITH_REDUX_MERGE_STATE";
var $83f4afce595204be$var$SET_STATE_TYPE = module.exports.SET_STATE_TYPE = "@@WITH_REDUX_SET_STATE";

});


parcelRegister("h7VOS", function(module, exports) {
$parcel$export(module.exports, "eventChannel", function () { return (parcelRequire("kVHkf")).eventChannel; });

$parcel$export(module.exports, "default", function () { return $c77ff0df9288da65$export$2e2bcd8739ae039; });

var $kVHkf = parcelRequire("kVHkf");
var $c77ff0df9288da65$export$2e2bcd8739ae039 = (0, $kVHkf.default);

});
parcelRegister("kVHkf", function(module, exports) {

$parcel$export(module.exports, "eventChannel", function () { return $f3cabd103a641dd7$export$dfc3101b3180c292; });
$parcel$export(module.exports, "default", function () { return $f3cabd103a641dd7$export$2e2bcd8739ae039; });

var $fQGsC = parcelRequire("fQGsC");

var $ii97e = parcelRequire("ii97e");

var $4dya5 = parcelRequire("4dya5");

var $f1e9n = parcelRequire("f1e9n");

var $5NpoY = parcelRequire("5NpoY");

var $jF3Yx = parcelRequire("jF3Yx");

var $cEzHV = parcelRequire("cEzHV");
parcelRequire("7v88c");
var $f3cabd103a641dd7$var$queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/ var $f3cabd103a641dd7$var$semaphore = 0;
/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/ function $f3cabd103a641dd7$var$exec(task) {
    try {
        $f3cabd103a641dd7$var$suspend();
        task();
    } finally{
        $f3cabd103a641dd7$var$release();
    }
}
/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/ function $f3cabd103a641dd7$var$asap(task) {
    $f3cabd103a641dd7$var$queue.push(task);
    if (!$f3cabd103a641dd7$var$semaphore) {
        $f3cabd103a641dd7$var$suspend();
        $f3cabd103a641dd7$var$flush();
    }
}
/**
 * Puts the scheduler in a `suspended` state and executes a task immediately.
 */ function $f3cabd103a641dd7$var$immediately(task) {
    try {
        $f3cabd103a641dd7$var$suspend();
        return task();
    } finally{
        $f3cabd103a641dd7$var$flush();
    }
}
/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/ function $f3cabd103a641dd7$var$suspend() {
    $f3cabd103a641dd7$var$semaphore++;
}
/**
  Puts the scheduler in a `released` state.
**/ function $f3cabd103a641dd7$var$release() {
    $f3cabd103a641dd7$var$semaphore--;
}
/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/ function $f3cabd103a641dd7$var$flush() {
    $f3cabd103a641dd7$var$release();
    var task;
    while(!$f3cabd103a641dd7$var$semaphore && (task = $f3cabd103a641dd7$var$queue.shift()) !== undefined)$f3cabd103a641dd7$var$exec(task);
}
var $f3cabd103a641dd7$var$array$1 = function array$$1(patterns) {
    return function(input) {
        return patterns.some(function(p) {
            return $f3cabd103a641dd7$var$matcher(p)(input);
        });
    };
};
var $f3cabd103a641dd7$var$predicate = function predicate(_predicate) {
    return function(input) {
        return _predicate(input);
    };
};
var $f3cabd103a641dd7$var$string$1 = function string$$1(pattern) {
    return function(input) {
        return input.type === String(pattern);
    };
};
var $f3cabd103a641dd7$var$symbol$1 = function symbol$$1(pattern) {
    return function(input) {
        return input.type === pattern;
    };
};
var $f3cabd103a641dd7$var$wildcard = function wildcard() {
    return 0, $5NpoY.a;
};
function $f3cabd103a641dd7$var$matcher(pattern) {
    // prettier-ignore
    var matcherCreator = pattern === "*" ? $f3cabd103a641dd7$var$wildcard : (0, $f1e9n.string)(pattern) ? $f3cabd103a641dd7$var$string$1 : (0, $f1e9n.array)(pattern) ? $f3cabd103a641dd7$var$array$1 : (0, $f1e9n.stringableFunc)(pattern) ? $f3cabd103a641dd7$var$string$1 : (0, $f1e9n.func)(pattern) ? $f3cabd103a641dd7$var$predicate : (0, $f1e9n.symbol)(pattern) ? $f3cabd103a641dd7$var$symbol$1 : null;
    if (matcherCreator === null) throw new Error("invalid pattern: " + pattern);
    return matcherCreator(pattern);
}
var $f3cabd103a641dd7$export$32239d68d9c6cb49 = {
    type: (0, $fQGsC.CHANNEL_END_TYPE)
};
var $f3cabd103a641dd7$export$42af6f45c6e0d09f = function isEnd(a) {
    return a && a.type === (0, $fQGsC.CHANNEL_END_TYPE);
};
var $f3cabd103a641dd7$var$CLOSED_CHANNEL_WITH_TAKERS = "Cannot have a closed channel with pending takers";
var $f3cabd103a641dd7$var$INVALID_BUFFER = "invalid buffer passed to channel factory function";
var $f3cabd103a641dd7$var$UNDEFINED_INPUT_ERROR = "Saga or channel was provided with an undefined action\nHints:\n  - check that your Action Creator returns a non-undefined value\n  - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners";
function $f3cabd103a641dd7$export$1f95fbd68d964d36(buffer$$1) {
    if (buffer$$1 === void 0) buffer$$1 = (0, $5NpoY.b)();
    var closed = false;
    var takers = [];
    function checkForbiddenStates() {
        if (closed && takers.length) throw (0, $5NpoY.g)($f3cabd103a641dd7$var$CLOSED_CHANNEL_WITH_TAKERS);
        if (takers.length && !buffer$$1.isEmpty()) throw (0, $5NpoY.g)("Cannot have pending takers with non empty buffer");
    }
    function put(input) {
        if (closed) return;
        if (takers.length === 0) return buffer$$1.put(input);
        var cb = takers.shift();
        cb(input);
    }
    function take(cb) {
        if (closed && buffer$$1.isEmpty()) cb($f3cabd103a641dd7$export$32239d68d9c6cb49);
        else if (!buffer$$1.isEmpty()) cb(buffer$$1.take());
        else {
            takers.push(cb);
            cb.cancel = function() {
                (0, $5NpoY.f)(takers, cb);
            };
        }
    }
    function flush(cb) {
        if (closed && buffer$$1.isEmpty()) {
            cb($f3cabd103a641dd7$export$32239d68d9c6cb49);
            return;
        }
        cb(buffer$$1.flush());
    }
    function close() {
        if (closed) return;
        closed = true;
        var arr = takers;
        takers = [];
        for(var i = 0, len = arr.length; i < len; i++){
            var taker = arr[i];
            taker($f3cabd103a641dd7$export$32239d68d9c6cb49);
        }
    }
    return {
        take: take,
        put: put,
        flush: flush,
        close: close
    };
}
function $f3cabd103a641dd7$export$dfc3101b3180c292(subscribe, buffer$$1) {
    if (buffer$$1 === void 0) buffer$$1 = (0, $5NpoY.d)();
    var closed = false;
    var unsubscribe;
    var chan = $f3cabd103a641dd7$export$1f95fbd68d964d36(buffer$$1);
    var close = function close() {
        if (closed) return;
        closed = true;
        if ((0, $f1e9n.func)(unsubscribe)) unsubscribe();
        chan.close();
    };
    unsubscribe = subscribe(function(input) {
        if ($f3cabd103a641dd7$export$42af6f45c6e0d09f(input)) {
            close();
            return;
        }
        chan.put(input);
    });
    unsubscribe = (0, $5NpoY.e)(unsubscribe);
    if (closed) unsubscribe();
    return {
        take: chan.take,
        flush: chan.flush,
        close: close
    };
}
function $f3cabd103a641dd7$export$438eddf2fd884f37() {
    var _ref;
    var closed = false;
    var currentTakers = [];
    var nextTakers = currentTakers;
    function checkForbiddenStates() {
        if (closed && nextTakers.length) throw (0, $5NpoY.g)($f3cabd103a641dd7$var$CLOSED_CHANNEL_WITH_TAKERS);
    }
    var ensureCanMutateNextTakers = function ensureCanMutateNextTakers() {
        if (nextTakers !== currentTakers) return;
        nextTakers = currentTakers.slice();
    };
    var close = function close() {
        closed = true;
        var takers = currentTakers = nextTakers;
        nextTakers = [];
        takers.forEach(function(taker) {
            taker($f3cabd103a641dd7$export$32239d68d9c6cb49);
        });
    };
    return _ref = {}, _ref[0, $fQGsC.MULTICAST] = true, _ref.put = function put(input) {
        if (closed) return;
        if ($f3cabd103a641dd7$export$42af6f45c6e0d09f(input)) {
            close();
            return;
        }
        var takers = currentTakers = nextTakers;
        for(var i = 0, len = takers.length; i < len; i++){
            var taker = takers[i];
            if (taker[0, $fQGsC.MATCH](input)) {
                taker.cancel();
                taker(input);
            }
        }
    }, _ref.take = function take(cb, matcher$$1) {
        if (matcher$$1 === void 0) matcher$$1 = $f3cabd103a641dd7$var$wildcard;
        if (closed) {
            cb($f3cabd103a641dd7$export$32239d68d9c6cb49);
            return;
        }
        cb[0, $fQGsC.MATCH] = matcher$$1;
        ensureCanMutateNextTakers();
        nextTakers.push(cb);
        cb.cancel = (0, $5NpoY.e)(function() {
            ensureCanMutateNextTakers();
            (0, $5NpoY.f)(nextTakers, cb);
        });
    }, _ref.close = close, _ref;
}
function $f3cabd103a641dd7$export$e987d166a3a4f3ec() {
    var chan = $f3cabd103a641dd7$export$438eddf2fd884f37();
    var put = chan.put;
    chan.put = function(input) {
        if (input[0, $fQGsC.SAGA_ACTION]) {
            put(input);
            return;
        }
        $f3cabd103a641dd7$var$asap(function() {
            put(input);
        });
    };
    return chan;
}
var $f3cabd103a641dd7$var$RUNNING = 0;
var $f3cabd103a641dd7$var$CANCELLED$1 = 1;
var $f3cabd103a641dd7$var$ABORTED = 2;
var $f3cabd103a641dd7$var$DONE = 3;
function $f3cabd103a641dd7$var$resolvePromise(promise$$1, cb) {
    var cancelPromise = promise$$1[0, $fQGsC.CANCEL];
    if ((0, $f1e9n.func)(cancelPromise)) cb.cancel = cancelPromise;
    promise$$1.then(cb, function(error) {
        cb(error, true);
    });
}
var $f3cabd103a641dd7$var$current = 0;
var $f3cabd103a641dd7$var$nextEffectId = function() {
    return ++$f3cabd103a641dd7$var$current;
};
var $f3cabd103a641dd7$var$_effectRunnerMap;
function $f3cabd103a641dd7$var$getIteratorMetaInfo(iterator$$1, fn) {
    if (iterator$$1.isSagaIterator) return {
        name: iterator$$1.meta.name
    };
    return (0, $5NpoY.w)(fn);
}
function $f3cabd103a641dd7$var$createTaskIterator(_ref) {
    var context = _ref.context, fn = _ref.fn, args = _ref.args;
    // catch synchronous failures; see #152 and #441
    try {
        var result = fn.apply(context, args); // i.e. a generator function returns an iterator
        if ((0, $f1e9n.iterator)(result)) return result;
        var resolved = false;
        var next = function next(arg) {
            if (!resolved) {
                resolved = true; // Only promises returned from fork will be interpreted. See #1573
                return {
                    value: result,
                    done: !(0, $f1e9n.promise)(result)
                };
            } else return {
                value: arg,
                done: true
            };
        };
        return (0, $5NpoY.B)(next);
    } catch (err) {
        // do not bubble up synchronous failures for detached forks
        // instead create a failed task. See #152 and #441
        return (0, $5NpoY.B)(function() {
            throw err;
        });
    }
}
function $f3cabd103a641dd7$var$runPutEffect(env, _ref2, cb) {
    var channel$$1 = _ref2.channel, action = _ref2.action, resolve = _ref2.resolve;
    /**
   Schedule the put in case another saga is holding a lock.
   The put will be executed atomically. ie nested puts will execute after
   this put has terminated.
   **/ $f3cabd103a641dd7$var$asap(function() {
        var result;
        try {
            result = (channel$$1 ? channel$$1.put : env.dispatch)(action);
        } catch (error) {
            cb(error, true);
            return;
        }
        if (resolve && (0, $f1e9n.promise)(result)) $f3cabd103a641dd7$var$resolvePromise(result, cb);
        else cb(result);
    }); // Put effects are non cancellables
}
function $f3cabd103a641dd7$var$runTakeEffect(env, _ref3, cb) {
    var _ref3$channel = _ref3.channel, channel$$1 = _ref3$channel === void 0 ? env.channel : _ref3$channel, pattern = _ref3.pattern, maybe = _ref3.maybe;
    var takeCb = function takeCb(input) {
        if (input instanceof Error) {
            cb(input, true);
            return;
        }
        if ($f3cabd103a641dd7$export$42af6f45c6e0d09f(input) && !maybe) {
            cb((0, $fQGsC.TERMINATE));
            return;
        }
        cb(input);
    };
    try {
        channel$$1.take(takeCb, (0, $f1e9n.notUndef)(pattern) ? $f3cabd103a641dd7$var$matcher(pattern) : null);
    } catch (err) {
        cb(err, true);
        return;
    }
    cb.cancel = takeCb.cancel;
}
function $f3cabd103a641dd7$var$runCallEffect(env, _ref4, cb, _ref5) {
    var context = _ref4.context, fn = _ref4.fn, args = _ref4.args;
    var task = _ref5.task;
    // catch synchronous failures; see #152
    try {
        var result = fn.apply(context, args);
        if ((0, $f1e9n.promise)(result)) {
            $f3cabd103a641dd7$var$resolvePromise(result, cb);
            return;
        }
        if ((0, $f1e9n.iterator)(result)) {
            // resolve iterator
            $f3cabd103a641dd7$var$proc(env, result, task.context, $f3cabd103a641dd7$var$current, (0, $5NpoY.w)(fn), /* isRoot */ false, cb);
            return;
        }
        cb(result);
    } catch (error) {
        cb(error, true);
    }
}
function $f3cabd103a641dd7$var$runCPSEffect(env, _ref6, cb) {
    var context = _ref6.context, fn = _ref6.fn, args = _ref6.args;
    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb
    // catch synchronous failures; see #152
    try {
        var cpsCb = function cpsCb(err, res) {
            if ((0, $f1e9n.undef)(err)) cb(res);
            else cb(err, true);
        };
        fn.apply(context, args.concat(cpsCb));
        if (cpsCb.cancel) cb.cancel = cpsCb.cancel;
    } catch (error) {
        cb(error, true);
    }
}
function $f3cabd103a641dd7$var$runForkEffect(env, _ref7, cb, _ref8) {
    var context = _ref7.context, fn = _ref7.fn, args = _ref7.args, detached = _ref7.detached;
    var parent = _ref8.task;
    var taskIterator = $f3cabd103a641dd7$var$createTaskIterator({
        context: context,
        fn: fn,
        args: args
    });
    var meta = $f3cabd103a641dd7$var$getIteratorMetaInfo(taskIterator, fn);
    $f3cabd103a641dd7$var$immediately(function() {
        var child = $f3cabd103a641dd7$var$proc(env, taskIterator, parent.context, $f3cabd103a641dd7$var$current, meta, detached, (0, $5NpoY.x));
        if (detached) cb(child);
        else {
            if (child.isRunning()) {
                parent.queue.addTask(child);
                cb(child);
            } else if (child.isAborted()) parent.queue.abort(child.error());
            else cb(child);
        }
    }); // Fork effects are non cancellables
}
function $f3cabd103a641dd7$var$runJoinEffect(env, taskOrTasks, cb, _ref9) {
    var task = _ref9.task;
    var joinSingleTask = function joinSingleTask(taskToJoin, cb) {
        if (taskToJoin.isRunning()) {
            var joiner = {
                task: task,
                cb: cb
            };
            cb.cancel = function() {
                (0, $5NpoY.f)(taskToJoin.joiners, joiner);
            };
            taskToJoin.joiners.push(joiner);
        } else if (taskToJoin.isAborted()) cb(taskToJoin.error(), true);
        else cb(taskToJoin.result());
    };
    if ((0, $f1e9n.array)(taskOrTasks)) {
        if (taskOrTasks.length === 0) {
            cb([]);
            return;
        }
        var childCallbacks = (0, $5NpoY.y)(taskOrTasks, cb);
        taskOrTasks.forEach(function(t, i) {
            joinSingleTask(t, childCallbacks[i]);
        });
    } else joinSingleTask(taskOrTasks, cb);
}
function $f3cabd103a641dd7$var$cancelSingleTask(taskToCancel) {
    if (taskToCancel.isRunning()) taskToCancel.cancel();
}
function $f3cabd103a641dd7$var$runCancelEffect(env, taskOrTasks, cb, _ref10) {
    var task = _ref10.task;
    if (taskOrTasks === (0, $fQGsC.SELF_CANCELLATION)) $f3cabd103a641dd7$var$cancelSingleTask(task);
    else if ((0, $f1e9n.array)(taskOrTasks)) taskOrTasks.forEach($f3cabd103a641dd7$var$cancelSingleTask);
    else $f3cabd103a641dd7$var$cancelSingleTask(taskOrTasks);
    cb(); // cancel effects are non cancellables
}
function $f3cabd103a641dd7$var$runAllEffect(env, effects, cb, _ref11) {
    var digestEffect = _ref11.digestEffect;
    var effectId = $f3cabd103a641dd7$var$current;
    var keys = Object.keys(effects);
    if (keys.length === 0) {
        cb((0, $f1e9n.array)(effects) ? [] : {});
        return;
    }
    var childCallbacks = (0, $5NpoY.y)(effects, cb);
    keys.forEach(function(key) {
        digestEffect(effects[key], effectId, childCallbacks[key], key);
    });
}
function $f3cabd103a641dd7$var$runRaceEffect(env, effects, cb, _ref12) {
    var digestEffect = _ref12.digestEffect;
    var effectId = $f3cabd103a641dd7$var$current;
    var keys = Object.keys(effects);
    var response = (0, $f1e9n.array)(effects) ? (0, $5NpoY.z)(keys.length) : {};
    var childCbs = {};
    var completed = false;
    keys.forEach(function(key) {
        var chCbAtKey = function chCbAtKey(res, isErr) {
            if (completed) return;
            if (isErr || (0, $5NpoY.C)(res)) {
                // Race Auto cancellation
                cb.cancel();
                cb(res, isErr);
            } else {
                cb.cancel();
                completed = true;
                response[key] = res;
                cb(response);
            }
        };
        chCbAtKey.cancel = (0, $5NpoY.x);
        childCbs[key] = chCbAtKey;
    });
    cb.cancel = function() {
        // prevents unnecessary cancellation
        if (!completed) {
            completed = true;
            keys.forEach(function(key) {
                return childCbs[key].cancel();
            });
        }
    };
    keys.forEach(function(key) {
        if (completed) return;
        digestEffect(effects[key], effectId, childCbs[key], key);
    });
}
function $f3cabd103a641dd7$var$runSelectEffect(env, _ref13, cb) {
    var selector = _ref13.selector, args = _ref13.args;
    try {
        var state = selector.apply(void 0, [
            env.getState()
        ].concat(args));
        cb(state);
    } catch (error) {
        cb(error, true);
    }
}
function $f3cabd103a641dd7$var$runChannelEffect(env, _ref14, cb) {
    var pattern = _ref14.pattern, buffer$$1 = _ref14.buffer;
    var chan = $f3cabd103a641dd7$export$1f95fbd68d964d36(buffer$$1);
    var match = $f3cabd103a641dd7$var$matcher(pattern);
    var taker = function taker(action) {
        if (!$f3cabd103a641dd7$export$42af6f45c6e0d09f(action)) env.channel.take(taker, match);
        chan.put(action);
    };
    var close = chan.close;
    chan.close = function() {
        taker.cancel();
        close();
    };
    env.channel.take(taker, match);
    cb(chan);
}
function $f3cabd103a641dd7$var$runCancelledEffect(env, data, cb, _ref15) {
    var task = _ref15.task;
    cb(task.isCancelled());
}
function $f3cabd103a641dd7$var$runFlushEffect(env, channel$$1, cb) {
    channel$$1.flush(cb);
}
function $f3cabd103a641dd7$var$runGetContextEffect(env, prop, cb, _ref16) {
    var task = _ref16.task;
    cb(task.context[prop]);
}
function $f3cabd103a641dd7$var$runSetContextEffect(env, props, cb, _ref17) {
    var task = _ref17.task;
    (0, $5NpoY.A)(task.context, props);
    cb();
}
var $f3cabd103a641dd7$var$effectRunnerMap = ($f3cabd103a641dd7$var$_effectRunnerMap = {}, $f3cabd103a641dd7$var$_effectRunnerMap[0, $5NpoY.h] = $f3cabd103a641dd7$var$runTakeEffect, $f3cabd103a641dd7$var$_effectRunnerMap[0, $5NpoY.i] = $f3cabd103a641dd7$var$runPutEffect, $f3cabd103a641dd7$var$_effectRunnerMap[0, $5NpoY.j] = $f3cabd103a641dd7$var$runAllEffect, $f3cabd103a641dd7$var$_effectRunnerMap[0, $5NpoY.k] = $f3cabd103a641dd7$var$runRaceEffect, $f3cabd103a641dd7$var$_effectRunnerMap[0, $5NpoY.l] = $f3cabd103a641dd7$var$runCallEffect, $f3cabd103a641dd7$var$_effectRunnerMap[0, $5NpoY.m] = $f3cabd103a641dd7$var$runCPSEffect, $f3cabd103a641dd7$var$_effectRunnerMap[0, $5NpoY.n] = $f3cabd103a641dd7$var$runForkEffect, $f3cabd103a641dd7$var$_effectRunnerMap[0, $5NpoY.o] = $f3cabd103a641dd7$var$runJoinEffect, $f3cabd103a641dd7$var$_effectRunnerMap[0, $5NpoY.p] = $f3cabd103a641dd7$var$runCancelEffect, $f3cabd103a641dd7$var$_effectRunnerMap[0, $5NpoY.q] = $f3cabd103a641dd7$var$runSelectEffect, $f3cabd103a641dd7$var$_effectRunnerMap[0, $5NpoY.r] = $f3cabd103a641dd7$var$runChannelEffect, $f3cabd103a641dd7$var$_effectRunnerMap[0, $5NpoY.s] = $f3cabd103a641dd7$var$runCancelledEffect, $f3cabd103a641dd7$var$_effectRunnerMap[0, $5NpoY.t] = $f3cabd103a641dd7$var$runFlushEffect, $f3cabd103a641dd7$var$_effectRunnerMap[0, $5NpoY.u] = $f3cabd103a641dd7$var$runGetContextEffect, $f3cabd103a641dd7$var$_effectRunnerMap[0, $5NpoY.v] = $f3cabd103a641dd7$var$runSetContextEffect, $f3cabd103a641dd7$var$_effectRunnerMap);
/**
 Used to track a parent task and its forks
 In the fork model, forked tasks are attached by default to their parent
 We model this using the concept of Parent task && main Task
 main task is the main flow of the current Generator, the parent tasks is the
 aggregation of the main tasks + all its forked tasks.
 Thus the whole model represents an execution tree with multiple branches (vs the
 linear execution tree in sequential (non parallel) programming)

 A parent tasks has the following semantics
 - It completes if all its forks either complete or all cancelled
 - If it's cancelled, all forks are cancelled as well
 - It aborts if any uncaught error bubbles up from forks
 - If it completes, the return value is the one returned by the main task
 **/ function $f3cabd103a641dd7$var$forkQueue(mainTask, onAbort, cont) {
    var tasks = [];
    var result;
    var completed = false;
    addTask(mainTask);
    var getTasks = function getTasks() {
        return tasks;
    };
    function abort(err) {
        onAbort();
        cancelAll();
        cont(err, true);
    }
    function addTask(task) {
        tasks.push(task);
        task.cont = function(res, isErr) {
            if (completed) return;
            (0, $5NpoY.f)(tasks, task);
            task.cont = (0, $5NpoY.x);
            if (isErr) abort(res);
            else {
                if (task === mainTask) result = res;
                if (!tasks.length) {
                    completed = true;
                    cont(result);
                }
            }
        };
    }
    function cancelAll() {
        if (completed) return;
        completed = true;
        tasks.forEach(function(t) {
            t.cont = (0, $5NpoY.x);
            t.cancel();
        });
        tasks = [];
    }
    return {
        addTask: addTask,
        cancelAll: cancelAll,
        abort: abort,
        getTasks: getTasks
    };
}
// there can be only a single saga error created at any given moment
function $f3cabd103a641dd7$var$formatLocation(fileName, lineNumber) {
    return fileName + "?" + lineNumber;
}
function $f3cabd103a641dd7$var$effectLocationAsString(effect) {
    var location = (0, $5NpoY.E)(effect);
    if (location) {
        var code = location.code, fileName = location.fileName, lineNumber = location.lineNumber;
        var source = code + "  " + $f3cabd103a641dd7$var$formatLocation(fileName, lineNumber);
        return source;
    }
    return "";
}
function $f3cabd103a641dd7$var$sagaLocationAsString(sagaMeta) {
    var name = sagaMeta.name, location = sagaMeta.location;
    if (location) return name + "  " + $f3cabd103a641dd7$var$formatLocation(location.fileName, location.lineNumber);
    return name;
}
function $f3cabd103a641dd7$var$cancelledTasksAsString(sagaStack) {
    var cancelledTasks = (0, $5NpoY.D)(function(i) {
        return i.cancelledTasks;
    }, sagaStack);
    if (!cancelledTasks.length) return "";
    return [
        "Tasks cancelled due to error:"
    ].concat(cancelledTasks).join("\n");
}
var $f3cabd103a641dd7$var$crashedEffect = null;
var $f3cabd103a641dd7$var$sagaStack = [];
var $f3cabd103a641dd7$var$addSagaFrame = function addSagaFrame(frame) {
    frame.crashedEffect = $f3cabd103a641dd7$var$crashedEffect;
    $f3cabd103a641dd7$var$sagaStack.push(frame);
};
var $f3cabd103a641dd7$var$clear = function clear() {
    $f3cabd103a641dd7$var$crashedEffect = null;
    $f3cabd103a641dd7$var$sagaStack.length = 0;
}; // this sets crashed effect for the soon-to-be-reported saga frame
// this slightly streatches the singleton nature of this module into wrong direction
// as it's even less obvious what's the data flow here, but it is what it is for now
var $f3cabd103a641dd7$var$setCrashedEffect = function setCrashedEffect(effect) {
    $f3cabd103a641dd7$var$crashedEffect = effect;
};
/**
  @returns {string}

  @example
  The above error occurred in task errorInPutSaga {pathToFile}
  when executing effect put({type: 'REDUCER_ACTION_ERROR_IN_PUT'}) {pathToFile}
      created by fetchSaga {pathToFile}
      created by rootSaga {pathToFile}
*/ var $f3cabd103a641dd7$var$toString = function toString() {
    var firstSaga = $f3cabd103a641dd7$var$sagaStack[0], otherSagas = $f3cabd103a641dd7$var$sagaStack.slice(1);
    var crashedEffectLocation = firstSaga.crashedEffect ? $f3cabd103a641dd7$var$effectLocationAsString(firstSaga.crashedEffect) : null;
    var errorMessage = "The above error occurred in task " + $f3cabd103a641dd7$var$sagaLocationAsString(firstSaga.meta) + (crashedEffectLocation ? " \n when executing effect " + crashedEffectLocation : "");
    return [
        errorMessage
    ].concat(otherSagas.map(function(s) {
        return "    created by " + $f3cabd103a641dd7$var$sagaLocationAsString(s.meta);
    }), [
        $f3cabd103a641dd7$var$cancelledTasksAsString($f3cabd103a641dd7$var$sagaStack)
    ]).join("\n");
};
function $f3cabd103a641dd7$var$newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont) {
    var _task;
    var status = $f3cabd103a641dd7$var$RUNNING;
    var taskResult;
    var taskError;
    var deferredEnd = null;
    var cancelledDueToErrorTasks = [];
    var context = Object.create(parentContext);
    var queue = $f3cabd103a641dd7$var$forkQueue(mainTask, function onAbort() {
        cancelledDueToErrorTasks.push.apply(cancelledDueToErrorTasks, queue.getTasks().map(function(t) {
            return t.meta.name;
        }));
    }, end);
    /**
   This may be called by a parent generator to trigger/propagate cancellation
   cancel all pending tasks (including the main task), then end the current task.
    Cancellation propagates down to the whole execution tree held by this Parent task
   It's also propagated to all joiners of this task and their execution tree/joiners
    Cancellation is noop for terminated/Cancelled tasks tasks
   **/ function cancel() {
        if (status === $f3cabd103a641dd7$var$RUNNING) {
            // Setting status to CANCELLED does not necessarily mean that the task/iterators are stopped
            // effects in the iterator's finally block will still be executed
            status = $f3cabd103a641dd7$var$CANCELLED$1;
            queue.cancelAll(); // Ending with a TASK_CANCEL will propagate the Cancellation to all joiners
            end((0, $fQGsC.TASK_CANCEL), false);
        }
    }
    function end(result, isErr) {
        if (!isErr) {
            // The status here may be RUNNING or CANCELLED
            // If the status is CANCELLED, then we do not need to change it here
            if (result === (0, $fQGsC.TASK_CANCEL)) status = $f3cabd103a641dd7$var$CANCELLED$1;
            else if (status !== $f3cabd103a641dd7$var$CANCELLED$1) status = $f3cabd103a641dd7$var$DONE;
            taskResult = result;
            deferredEnd && deferredEnd.resolve(result);
        } else {
            status = $f3cabd103a641dd7$var$ABORTED;
            $f3cabd103a641dd7$var$addSagaFrame({
                meta: meta,
                cancelledTasks: cancelledDueToErrorTasks
            });
            if (task.isRoot) {
                var sagaStack = $f3cabd103a641dd7$var$toString(); // we've dumped the saga stack to string and are passing it to user's code
                // we know that it won't be needed anymore and we need to clear it
                $f3cabd103a641dd7$var$clear();
                env.onError(result, {
                    sagaStack: sagaStack
                });
            }
            taskError = result;
            deferredEnd && deferredEnd.reject(result);
        }
        task.cont(result, isErr);
        task.joiners.forEach(function(joiner) {
            joiner.cb(result, isErr);
        });
        task.joiners = null;
    }
    function setContext(props) {
        (0, $5NpoY.A)(context, props);
    }
    function toPromise() {
        if (deferredEnd) return deferredEnd.promise;
        deferredEnd = (0, $cEzHV.default)();
        if (status === $f3cabd103a641dd7$var$ABORTED) deferredEnd.reject(taskError);
        else if (status !== $f3cabd103a641dd7$var$RUNNING) deferredEnd.resolve(taskResult);
        return deferredEnd.promise;
    }
    var task = (_task = {}, _task[0, $fQGsC.TASK] = true, _task.id = parentEffectId, _task.meta = meta, _task.isRoot = isRoot, _task.context = context, _task.joiners = [], _task.queue = queue, _task.cancel = cancel, _task.cont = cont, _task.end = end, _task.setContext = setContext, _task.toPromise = toPromise, _task.isRunning = function isRunning() {
        return status === $f3cabd103a641dd7$var$RUNNING;
    }, _task.isCancelled = function isCancelled() {
        return status === $f3cabd103a641dd7$var$CANCELLED$1 || status === $f3cabd103a641dd7$var$RUNNING && mainTask.status === $f3cabd103a641dd7$var$CANCELLED$1;
    }, _task.isAborted = function isAborted() {
        return status === $f3cabd103a641dd7$var$ABORTED;
    }, _task.result = function result() {
        return taskResult;
    }, _task.error = function error() {
        return taskError;
    }, _task);
    return task;
}
function $f3cabd103a641dd7$var$proc(env, iterator$$1, parentContext, parentEffectId, meta, isRoot, cont) {
    var finalRunEffect = env.finalizeRunEffect(runEffect);
    /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/ next.cancel = (0, $5NpoY.x);
    /** Creates a main task to track the main flow */ var mainTask = {
        meta: meta,
        cancel: cancelMain,
        status: $f3cabd103a641dd7$var$RUNNING
    };
    var task = $f3cabd103a641dd7$var$newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont);
    var executingContext = {
        task: task,
        digestEffect: digestEffect
    };
    function cancelMain() {
        if (mainTask.status === $f3cabd103a641dd7$var$RUNNING) {
            mainTask.status = $f3cabd103a641dd7$var$CANCELLED$1;
            next((0, $fQGsC.TASK_CANCEL));
        }
    }
    /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/ cont.cancel = task.cancel; // kicks up the generator
    next(); // then return the task descriptor to the caller
    return task;
    /**
   * This is the generator driver
   * It's a recursive async/continuation function which calls itself
   * until the generator terminates or throws
   * @param {internal commands(TASK_CANCEL | TERMINATE) | any} arg - value, generator will be resumed with.
   * @param {boolean} isErr - the flag shows if effect finished with an error
   *
   * receives either (command | effect result, false) or (any thrown thing, true)
   */ function next(arg, isErr) {
        try {
            var result;
            if (isErr) {
                result = iterator$$1.throw(arg); // user handled the error, we can clear bookkept values
                $f3cabd103a641dd7$var$clear();
            } else if ((0, $5NpoY.H)(arg)) {
                /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/ mainTask.status = $f3cabd103a641dd7$var$CANCELLED$1;
                /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/ next.cancel();
                /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/ result = (0, $f1e9n.func)(iterator$$1.return) ? iterator$$1.return((0, $fQGsC.TASK_CANCEL)) : {
                    done: true,
                    value: (0, $fQGsC.TASK_CANCEL)
                };
            } else if ((0, $5NpoY.I)(arg)) // We get TERMINATE flag, i.e. by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
            result = (0, $f1e9n.func)(iterator$$1.return) ? iterator$$1.return() : {
                done: true
            };
            else result = iterator$$1.next(arg);
            if (!result.done) digestEffect(result.value, parentEffectId, next);
            else {
                /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/ if (mainTask.status !== $f3cabd103a641dd7$var$CANCELLED$1) mainTask.status = $f3cabd103a641dd7$var$DONE;
                mainTask.cont(result.value);
            }
        } catch (error) {
            if (mainTask.status === $f3cabd103a641dd7$var$CANCELLED$1) throw error;
            mainTask.status = $f3cabd103a641dd7$var$ABORTED;
            mainTask.cont(error, true);
        }
    }
    function runEffect(effect, effectId, currCb) {
        /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      of completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/ if ((0, $f1e9n.promise)(effect)) $f3cabd103a641dd7$var$resolvePromise(effect, currCb);
        else if ((0, $f1e9n.iterator)(effect)) // resolve iterator
        $f3cabd103a641dd7$var$proc(env, effect, task.context, effectId, meta, /* isRoot */ false, currCb);
        else if (effect && effect[0, $fQGsC.IO]) {
            var effectRunner = $f3cabd103a641dd7$var$effectRunnerMap[effect.type];
            effectRunner(env, effect.payload, currCb, executingContext);
        } else // anything else returned as is
        currCb(effect);
    }
    function digestEffect(effect, parentEffectId, cb, label) {
        if (label === void 0) label = "";
        var effectId = $f3cabd103a641dd7$var$nextEffectId();
        env.sagaMonitor && env.sagaMonitor.effectTriggered({
            effectId: effectId,
            parentEffectId: parentEffectId,
            label: label,
            effect: effect
        });
        /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/ var effectSettled; // Completion callback passed to the appropriate effect runner
        function currCb(res, isErr) {
            if (effectSettled) return;
            effectSettled = true;
            cb.cancel = (0, $5NpoY.x); // defensive measure
            if (env.sagaMonitor) {
                if (isErr) env.sagaMonitor.effectRejected(effectId, res);
                else env.sagaMonitor.effectResolved(effectId, res);
            }
            if (isErr) $f3cabd103a641dd7$var$setCrashedEffect(effect);
            cb(res, isErr);
        } // tracks down the current cancel
        currCb.cancel = (0, $5NpoY.x); // setup cancellation logic on the parent cb
        cb.cancel = function() {
            // prevents cancelling an already completed effect
            if (effectSettled) return;
            effectSettled = true;
            currCb.cancel(); // propagates cancel downward
            currCb.cancel = (0, $5NpoY.x); // defensive measure
            env.sagaMonitor && env.sagaMonitor.effectCancelled(effectId);
        };
        finalRunEffect(effect, effectId, currCb);
    }
}
var $f3cabd103a641dd7$var$RUN_SAGA_SIGNATURE = "runSaga(options, saga, ...args)";
var $f3cabd103a641dd7$var$NON_GENERATOR_ERR = $f3cabd103a641dd7$var$RUN_SAGA_SIGNATURE + ": saga argument must be a Generator function!";
function $f3cabd103a641dd7$export$3d8d44bf0c43bb61(_ref, saga) {
    var _ref$channel = _ref.channel, channel$$1 = _ref$channel === void 0 ? $f3cabd103a641dd7$export$e987d166a3a4f3ec() : _ref$channel, dispatch = _ref.dispatch, getState = _ref.getState, _ref$context = _ref.context, context = _ref$context === void 0 ? {} : _ref$context, sagaMonitor = _ref.sagaMonitor, effectMiddlewares = _ref.effectMiddlewares, _ref$onError = _ref.onError, onError = _ref$onError === void 0 ? (0, $5NpoY.J) : _ref$onError;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var iterator$$1 = saga.apply(void 0, args);
    var effectId = $f3cabd103a641dd7$var$nextEffectId();
    if (sagaMonitor) {
        // monitors are expected to have a certain interface, let's fill-in any missing ones
        sagaMonitor.rootSagaStarted = sagaMonitor.rootSagaStarted || (0, $5NpoY.x);
        sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || (0, $5NpoY.x);
        sagaMonitor.effectResolved = sagaMonitor.effectResolved || (0, $5NpoY.x);
        sagaMonitor.effectRejected = sagaMonitor.effectRejected || (0, $5NpoY.x);
        sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || (0, $5NpoY.x);
        sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || (0, $5NpoY.x);
        sagaMonitor.rootSagaStarted({
            effectId: effectId,
            saga: saga,
            args: args
        });
    }
    var MIDDLEWARE_TYPE_ERROR;
    var finalizeRunEffect;
    if (effectMiddlewares) {
        var middleware = (0, $jF3Yx.compose).apply(void 0, effectMiddlewares);
        finalizeRunEffect = function finalizeRunEffect(runEffect) {
            return function(effect, effectId, currCb) {
                var plainRunEffect = function plainRunEffect(eff) {
                    return runEffect(eff, effectId, currCb);
                };
                return middleware(plainRunEffect)(effect);
            };
        };
    } else finalizeRunEffect = (0, $5NpoY.L);
    var env = {
        channel: channel$$1,
        dispatch: (0, $5NpoY.K)(dispatch),
        getState: getState,
        sagaMonitor: sagaMonitor,
        onError: onError,
        finalizeRunEffect: finalizeRunEffect
    };
    return $f3cabd103a641dd7$var$immediately(function() {
        var task = $f3cabd103a641dd7$var$proc(env, iterator$$1, context, effectId, (0, $5NpoY.w)(saga), /* isRoot */ true, (0, $5NpoY.x));
        if (sagaMonitor) sagaMonitor.effectResolved(effectId, task);
        return task;
    });
}
function $f3cabd103a641dd7$var$sagaMiddlewareFactory(_ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? {} : _ref2$context, _ref2$channel = _ref2.channel, channel$$1 = _ref2$channel === void 0 ? $f3cabd103a641dd7$export$e987d166a3a4f3ec() : _ref2$channel, sagaMonitor = _ref2.sagaMonitor, options = (0, $4dya5.default)(_ref2, [
        "context",
        "channel",
        "sagaMonitor"
    ]);
    var boundRunSaga;
    function sagaMiddleware(_ref3) {
        var getState = _ref3.getState, dispatch = _ref3.dispatch;
        boundRunSaga = $f3cabd103a641dd7$export$3d8d44bf0c43bb61.bind(null, (0, $ii97e.default)({}, options, {
            context: context,
            channel: channel$$1,
            dispatch: dispatch,
            getState: getState,
            sagaMonitor: sagaMonitor
        }));
        return function(next) {
            return function(action) {
                if (sagaMonitor && sagaMonitor.actionDispatched) sagaMonitor.actionDispatched(action);
                var result = next(action); // hit reducers
                channel$$1.put(action);
                return result;
            };
        };
    }
    sagaMiddleware.run = function() {
        return boundRunSaga.apply(void 0, arguments);
    };
    sagaMiddleware.setContext = function(props) {
        (0, $5NpoY.A)(context, props);
    };
    return sagaMiddleware;
}
var $f3cabd103a641dd7$export$2e2bcd8739ae039 = $f3cabd103a641dd7$var$sagaMiddlewareFactory;

});
parcelRegister("cEzHV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9364eb3b12da5c46$export$2e2bcd8739ae039; });
function $9364eb3b12da5c46$var$deferred() {
    var def = {};
    def.promise = new Promise(function(resolve, reject) {
        def.resolve = resolve;
        def.reject = reject;
    });
    return def;
}
function $9364eb3b12da5c46$export$368f32fb8739d33c(length) {
    var arr = [];
    for(var i = 0; i < length; i++)arr.push($9364eb3b12da5c46$var$deferred());
    return arr;
}
var $9364eb3b12da5c46$export$2e2bcd8739ae039 = $9364eb3b12da5c46$var$deferred;

});



parcelRegister("1hYh8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e5cd97e9948637d$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("h7VOS");
var $kVHkf = parcelRequire("kVHkf");

var $3sl0N = parcelRequire("3sl0N");

var $fEutT = parcelRequire("fEutT");

var $jPcDa = parcelRequire("jPcDa");
var $7e5cd97e9948637d$export$2e2bcd8739ae039 = function() {
    let sendResolver;
    let send = ()=>null;
    const sendPromise = new Promise(function(resolve) {
        sendResolver = resolve;
    });
    const channel = (0, $kVHkf.eventChannel)((emit)=>{
        const wsUrl = (0, $fEutT.getWebSocketUrl)();
        let socket;
        const onmessage = (e)=>{
            let data = null;
            try {
                data = JSON.parse(e.data);
                if (data.event) emit({
                    ...data,
                    type: data.event,
                    from_ws: true
                });
            } catch (error) {
            /* empty */ }
        };
        const onopen = ()=>{
            if (sendResolver) {
                sendResolver();
                sendResolver = null;
            } else emit({
                type: (0, $jPcDa.WEBSOCKET_RECONNECT)
            });
        };
        const getSocket = ()=>{
            if (!socket) socket = new (0, $3sl0N.default)(wsUrl, {
                onmessage: onmessage,
                onopen: onopen
            });
            return new Promise(function(resolve) {
                sendPromise.then(()=>resolve(socket));
            });
        };
        send = (event)=>getSocket().then((s)=>s === null || s === void 0 ? void 0 : s.send(event));
        return ()=>getSocket().then((s)=>s === null || s === void 0 ? void 0 : s.close());
    });
    channel.send = send;
    return channel;
}();

});
parcelRegister("3sl0N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7e7dabebefcd462$export$2e2bcd8739ae039; });
function $c7e7dabebefcd462$var$noop() {}
function $c7e7dabebefcd462$export$2e2bcd8739ae039(url, opts) {
    opts = opts || {};
    var ws, num = 0, timer = 1, $ = {};
    var max = opts.maxAttempts || Infinity;
    $.open = function() {
        ws = new WebSocket(url, opts.protocols || []);
        ws.onmessage = opts.onmessage || $c7e7dabebefcd462$var$noop;
        ws.onopen = function(e) {
            (opts.onopen || $c7e7dabebefcd462$var$noop)(e);
            num = 0;
        };
        ws.onclose = function(e) {
            e.code === 1e3 || e.code === 1001 || e.code === 1005 || $.reconnect(e);
            (opts.onclose || $c7e7dabebefcd462$var$noop)(e);
        };
        ws.onerror = function(e) {
            e && e.code === "ECONNREFUSED" ? $.reconnect(e) : (opts.onerror || $c7e7dabebefcd462$var$noop)(e);
        };
    };
    $.reconnect = function(e) {
        if (timer && num++ < max) timer = setTimeout(function() {
            (opts.onreconnect || $c7e7dabebefcd462$var$noop)(e);
            $.open();
        }, opts.timeout || 1e3);
        else (opts.onmaximum || $c7e7dabebefcd462$var$noop)(e);
    };
    $.json = function(x) {
        ws.send(JSON.stringify(x));
    };
    $.send = function(x) {
        ws.send(x);
    };
    $.close = function(x, y) {
        timer = clearTimeout(timer);
        ws.close(x || 1e3, y);
    };
    $.open(); // init
    return $;
}

});


parcelRegister("5ppJu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e3864474be35960$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $78TRY = parcelRequire("78TRY");

var $gBre8 = parcelRequire("gBre8");

var $gxEWz = parcelRequire("gxEWz");

var $fEpUk = parcelRequire("fEpUk");

var $ftQUc = parcelRequire("ftQUc");

var $kzG9F = parcelRequire("kzG9F");

var $6P3zs = parcelRequire("6P3zs");

var $dkkN8 = parcelRequire("dkkN8");

var $2QCBo = parcelRequire("2QCBo");

var $01EWw = parcelRequire("01EWw");

var $91m2T = parcelRequire("91m2T");

var $fr7bz = parcelRequire("fr7bz");

var $c9sCK = parcelRequire("c9sCK");

var $hR3ag = parcelRequire("hR3ag");

var $jIwpr = parcelRequire("jIwpr");

var $plq9H = parcelRequire("plq9H");

var $a7dqv = parcelRequire("a7dqv");

var $8CVKy = parcelRequire("8CVKy");

var $9vzNQ = parcelRequire("9vzNQ");

var $k96Kn = parcelRequire("k96Kn");

var $7sn3o = parcelRequire("7sn3o");
parcelRequire("mNHVL");
var $1d3DX = parcelRequire("1d3DX");
var $kncIe = parcelRequire("kncIe");
var $6Fbvl = parcelRequire("6Fbvl");

var $bBuHW = parcelRequire("bBuHW");

var $bRCxm = parcelRequire("bRCxm");

var $9LI2I = parcelRequire("9LI2I");

var $8oYaU = parcelRequire("8oYaU");

var $RmFDb = parcelRequire("RmFDb");

var $7pIWM = parcelRequire("7pIWM");

var $jBylV = parcelRequire("jBylV");

var $gJJYb = parcelRequire("gJJYb");

var $gEKvy = parcelRequire("gEKvy");

var $1a7QU = parcelRequire("1a7QU");

var $hZ2vI = parcelRequire("hZ2vI");

var $nVTIu = parcelRequire("nVTIu");

var $XWFsz = parcelRequire("XWFsz");
function* $9e3864474be35960$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $nVTIu.default)(),
        (0, $8oYaU.default)(),
        (0, $78TRY.default)(),
        (0, $gBre8.pipelinesSaga)(),
        (0, $bRCxm.default)(),
        (0, $2QCBo.default)(),
        (0, $fr7bz.default)(),
        (0, $fEpUk.default)(),
        (0, $8CVKy.default)(),
        (0, $k96Kn.default)(),
        (0, $a7dqv.default)(),
        (0, $jBylV.default)(),
        (0, $jBylV.fetchLatestActionSaga)(),
        (0, $gEKvy.default)(),
        (0, $9LI2I.default)(),
        (0, $gJJYb.default)(),
        (0, $hZ2vI.default)(),
        (0, $9vzNQ.default)(),
        (0, $bBuHW.default)(),
        (0, $1a7QU.default)(),
        (0, $7pIWM.default)(),
        (0, $RmFDb.default)(),
        (0, $1d3DX.default)(),
        (0, $gxEWz.default)(),
        (0, $ftQUc.default)(),
        (0, $kzG9F.default)(),
        (0, $91m2T.default)(),
        (0, $7sn3o.default)(),
        (0, $hR3ag.default)(),
        (0, $01EWw.default)(),
        (0, $plq9H.default)(),
        (0, $6P3zs.default)(),
        (0, $jeUNF.takeLatest)((0, $kncIe.UPDATE_SIDEBAR_STATE), (0, $6Fbvl.default)),
        (0, $jeUNF.takeLatest)((0, $dkkN8.UPDATE_NAVIGATION_STATE), (0, $jIwpr.default)),
        (0, $jeUNF.takeLatest)((0, $dkkN8.SCROLL_TO), (0, $c9sCK.default))
    ]);
}

});
parcelRegister("78TRY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70c57d95a608a2c7$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $7Ic5Q = parcelRequire("7Ic5Q");

var $jjTWw = parcelRequire("jjTWw");
function* $70c57d95a608a2c7$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLatest)((0, $7Ic5Q.REQUEST_DEPLOYMENT_CHANGES).REQUEST, (0, $jjTWw.requestDeploymentChangesWithRaceSaga)),
        (0, $jeUNF.takeLatest)((0, $7Ic5Q.REQUEST_DEPLOYMENT_CHANGES).SUCCESS, (0, $jjTWw.requestDeploymentPullRequestsWithRaceSaga)),
        (0, $jeUNF.takeLatest)((0, $7Ic5Q.REQUEST_DEPLOYMENT_COMMITS).REQUEST, (0, $jjTWw.requestDeploymentCommitsWithRaceSaga)),
        (0, $jeUNF.takeLatest)((0, $7Ic5Q.REQUEST_DEPLOYMENT_DASHBOARD).REQUEST, (0, $jjTWw.requestDeploymentDashboardSaga)),
        (0, $jeUNF.takeLatest)((0, $7Ic5Q.REQUEST_DEPLOYMENT_DASHBOARD).SUCCESS, (0, $jjTWw.requestBranchRestrictionsSaga)),
        (0, $jeUNF.takeLatest)((0, $7Ic5Q.REQUEST_DEPLOYMENT_SUMMARY).REQUEST, (0, $jjTWw.requestDeploymentSummaryWithRaceSaga)),
        (0, $jeUNF.takeLatest)((0, $7Ic5Q.REQUEST_REDEPLOYMENT).REQUEST, (0, $jjTWw.requestRedeploymentWithRaceSaga)),
        (0, $jeUNF.takeLatest)((0, $7Ic5Q.REQUEST_ENVIRONMENT_HISTORY).REQUEST, (0, $jjTWw.requestEnvironmentHistorySaga)),
        (0, $jeUNF.takeLatest)((0, $7Ic5Q.REQUEST_CREATE_ENVIRONMENT).REQUEST, (0, $jjTWw.requestCreateEnvironmentSaga)),
        (0, $jeUNF.takeLatest)((0, $7Ic5Q.REQUEST_CREATE_ENVIRONMENT).ERROR, (0, $jjTWw.requestDeploymentDashboardSaga)),
        (0, $jeUNF.takeLatest)((0, $7Ic5Q.REQUEST_UPDATE_ENVIRONMENT).REQUEST, (0, $jjTWw.requestUpdateEnvironmentSaga)),
        (0, $jeUNF.takeLatest)((0, $7Ic5Q.REQUEST_UPDATE_ENVIRONMENT).ERROR, (0, $jjTWw.requestDeploymentDashboardSaga)),
        (0, $jeUNF.takeLatest)((0, $7Ic5Q.REQUEST_DELETE_ENVIRONMENT).REQUEST, (0, $jjTWw.requestDeleteEnvironmentSaga)),
        (0, $jeUNF.takeLatest)((0, $7Ic5Q.REQUEST_DELETE_ENVIRONMENT).ERROR, (0, $jjTWw.requestDeploymentDashboardSaga)),
        (0, $jeUNF.takeLatest)((0, $7Ic5Q.REQUEST_REORDER_ENVIRONMENTS).REQUEST, (0, $jjTWw.requestReorderEnvironmentsSaga)),
        (0, $jeUNF.takeLatest)((0, $7Ic5Q.REQUEST_REORDER_ENVIRONMENTS).ERROR, (0, $jjTWw.requestDeploymentDashboardSaga)),
        (0, $jeUNF.takeLatest)((0, $7Ic5Q.ENVIRONMENT_UPDATED), (0, $jjTWw.requestDeploymentDashboardSaga)),
        (0, $jeUNF.takeLatest)((0, $7Ic5Q.ENVIRONMENT_LOCK_UPDATED), (0, $jjTWw.requestDeploymentDashboardSaga)),
        (0, $jeUNF.takeLatest)((0, $7Ic5Q.ENVIRONMENT_DASHBOARD_UPDATED), (0, $jjTWw.requestDeploymentDashboardSaga)),
        (0, $jeUNF.takeLatest)((0, $7Ic5Q.REQUEST_CREATE_BRANCH_RESTRICTION).REQUEST, (0, $jjTWw.requestCreateBranchRestrictionSaga)),
        (0, $jeUNF.takeLatest)((0, $7Ic5Q.REQUEST_DELETE_BRANCH_RESTRICTION).REQUEST, (0, $jjTWw.requestDeleteBranchRestrictionSaga))
    ]);
}

});

parcelRegister("gBre8", function(module, exports) {

$parcel$export(module.exports, "pipelinesSaga", function () { return $3b870dbd556b4424$export$565f74be5f32e56; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $df7D5 = parcelRequire("df7D5");

var $bK2sI = parcelRequire("bK2sI");

var $5QTDu = parcelRequire("5QTDu");

var $8qG03 = parcelRequire("8qG03");

var $i48lW = parcelRequire("i48lW");

var $h4cqg = parcelRequire("h4cqg");

var $5E3NZ = parcelRequire("5E3NZ");

var $eb0Ze = parcelRequire("eb0Ze");

var $fn1lI = parcelRequire("fn1lI");

var $2ZoPX = parcelRequire("2ZoPX");

var $3mAB1 = parcelRequire("3mAB1");

var $eDQOI = parcelRequire("eDQOI");

var $clLnm = parcelRequire("clLnm");

var $doQdL = parcelRequire("doQdL");

var $3ICW7 = parcelRequire("3ICW7");
function* $3b870dbd556b4424$export$565f74be5f32e56() {
    yield (0, $5NpoY._)([
        (0, $5NpoY.P)((0, $df7D5.allowanceSaga)),
        (0, $5NpoY.P)((0, $bK2sI.default)),
        (0, $5NpoY.P)((0, $5QTDu.default)),
        (0, $5NpoY.P)((0, $8qG03.default)),
        (0, $5NpoY.P)((0, $i48lW.logSaga)),
        (0, $5NpoY.P)((0, $h4cqg.default)),
        (0, $5NpoY.P)((0, $5E3NZ.default)),
        (0, $5NpoY.P)((0, $eb0Ze.default)),
        (0, $5NpoY.P)((0, $fn1lI.default)),
        (0, $5NpoY.P)((0, $2ZoPX.default)),
        (0, $5NpoY.P)((0, $3mAB1.default)),
        (0, $5NpoY.P)((0, $eDQOI.stepsSaga)),
        (0, $5NpoY.P)((0, $clLnm.default)),
        (0, $5NpoY.P)((0, $doQdL.default)),
        (0, $5NpoY.P)((0, $3ICW7.default))
    ]);
}

});
parcelRegister("df7D5", function(module, exports) {

$parcel$export(module.exports, "allowanceSaga", function () { return $a3367d6b7574ce04$export$9036ebe3452b5e78; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $k2cPS = parcelRequire("k2cPS");

var $QgM08 = parcelRequire("QgM08");

var $jPcDa = parcelRequire("jPcDa");
const $a3367d6b7574ce04$export$b1d99b9fac8164a8 = (accountUuid)=>{
    return `/!api/internal/accounts/${accountUuid}/pipelines_config/allowance`;
};
const $a3367d6b7574ce04$export$78586c919b207de7 = (accountUuid)=>{
    return `/!api/internal/workspaces/${accountUuid}/pipelines-users/is-trusted`;
};
function* $a3367d6b7574ce04$export$3b11c22184fbad73(action) {
    const { accountUuid: accountUuid } = action.meta;
    try {
        const allowanceUrl = $a3367d6b7574ce04$export$b1d99b9fac8164a8(accountUuid);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(allowanceUrl));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const payload = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        let isTrusted = undefined;
        try {
            const isTrustedUrl = $a3367d6b7574ce04$export$78586c919b207de7(accountUuid);
            const isTrustedRes = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(isTrustedUrl));
            if (!isTrustedRes || !isTrustedRes.ok) throw new Error("Failed to fetch isTrusted status.");
            const isTrustedPayload = yield (0, $5NpoY.P)([
                isTrustedRes,
                "json"
            ]);
            isTrusted = isTrustedPayload === null || isTrustedPayload === void 0 ? void 0 : isTrustedPayload.trusted;
        } catch (e) {
            (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
                segment: "PIPELINES_FAILED_TO_VALIDATE_USER_IS_TRUSTED"
            });
        }
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_ALLOWANCE).SUCCESS,
            meta: action.meta,
            payload: isTrusted !== undefined ? {
                ...payload,
                is_trusted: isTrusted
            } : payload
        });
    } catch (e) {
        if (!(0, $QgM08.isIgnoredErrorForSentry)(e)) (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_ALLOWANCE).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_ALLOWANCE).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $a3367d6b7574ce04$export$9036ebe3452b5e78() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_ALLOWANCE).REQUEST, $a3367d6b7574ce04$export$3b11c22184fbad73)
    ]);
}

});

parcelRegister("bK2sI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4faa3d17ff30bf25$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $aanBq = parcelRequire("aanBq");

var $k2cPS = parcelRequire("k2cPS");

var $fEutT = parcelRequire("fEutT");

var $QgM08 = parcelRequire("QgM08");

var $jPcDa = parcelRequire("jPcDa");
const $4faa3d17ff30bf25$export$259b72f6f1237e5c = (repositoryFullSlug, pipelineUuid)=>{
    return `${(0, $fEutT.default)("/!api/internal")}/repositories/${repositoryFullSlug}/pipelines/${pipelineUuid}/artifacts`;
};
const $4faa3d17ff30bf25$export$c7db25df15c834b7 = (repositoryFullSlug, pipelineUuid, artifactUuid)=>{
    return `${(0, $fEutT.default)("/!api/internal")}/repositories/${repositoryFullSlug}/pipelines/${pipelineUuid}/artifacts/${artifactUuid}/content`;
};
function* $4faa3d17ff30bf25$export$6a3d047e85cb9800(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = $4faa3d17ff30bf25$export$259b72f6f1237e5c(full_name, action.meta.pipelineUuid);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        data.values = data.values.map((artifact)=>({
                ...artifact,
                artifact_content_url: $4faa3d17ff30bf25$export$c7db25df15c834b7(full_name, action.meta.pipelineUuid, artifact.uuid)
            }));
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_ARTIFACTS).SUCCESS,
            meta: action.meta,
            payload: data
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_ARTIFACTS).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_ARTIFACTS).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $4faa3d17ff30bf25$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_ARTIFACTS).REQUEST, $4faa3d17ff30bf25$export$6a3d047e85cb9800)
    ]);
}

});

parcelRegister("5QTDu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2350432b868cbc64$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $aanBq = parcelRequire("aanBq");

var $k2cPS = parcelRequire("k2cPS");

var $fEutT = parcelRequire("fEutT");

var $QgM08 = parcelRequire("QgM08");

var $jPcDa = parcelRequire("jPcDa");
const $2350432b868cbc64$export$ad64949169b25e6b = (repositoryFullSlug, cacheUuid = "")=>{
    return `${(0, $fEutT.default)("/!api/2.0")}/repositories/${repositoryFullSlug}/pipelines-config/caches/${cacheUuid}`;
};
const $2350432b868cbc64$export$fa262c646fc31573 = (repositoryFullSlug, cacheName)=>{
    return `${(0, $fEutT.default)("/!api/2.0")}/repositories/${repositoryFullSlug}/pipelines-config/caches?name=${cacheName}`;
};
function* $2350432b868cbc64$export$7f8371a8c01040f7() {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = $2350432b868cbc64$export$ad64949169b25e6b(full_name);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const payload = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_CACHES).SUCCESS,
            payload: payload
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_CACHES).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_CACHES).ERROR,
            payload: e
        });
    }
}
function* $2350432b868cbc64$export$6afd4102cec9c87c(action) {
    const repository = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = $2350432b868cbc64$export$ad64949169b25e6b(repository.full_name, action.meta.cacheUuid);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "DELETE"
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_DELETE_CACHE).SUCCESS,
            meta: action.meta
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_DELETE_CACHE).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_DELETE_CACHE).ERROR,
            meta: action.meta
        });
    }
}
function* $2350432b868cbc64$export$ff8da3e41881d4fc(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = $2350432b868cbc64$export$fa262c646fc31573(full_name, action.meta.cache.name);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "DELETE"
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_DELETE_CACHES).SUCCESS,
            meta: action.meta
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_DELETE_CACHES).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_DELETE_CACHES).ERROR,
            meta: action.meta
        });
    }
}
function* $2350432b868cbc64$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_CACHES).REQUEST, $2350432b868cbc64$export$7f8371a8c01040f7),
        (0, $jeUNF.takeEvery)((0, $jPcDa.REQUEST_DELETE_CACHE).REQUEST, $2350432b868cbc64$export$6afd4102cec9c87c),
        (0, $jeUNF.takeEvery)((0, $jPcDa.REQUEST_DELETE_CACHES).REQUEST, $2350432b868cbc64$export$ff8da3e41881d4fc)
    ]);
}

});

parcelRegister("8qG03", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ee95508a2a0fbb9$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $aanBq = parcelRequire("aanBq");

var $g2R3c = parcelRequire("g2R3c");

var $k2cPS = parcelRequire("k2cPS");

var $fEutT = parcelRequire("fEutT");

var $QgM08 = parcelRequire("QgM08");

var $jPcDa = parcelRequire("jPcDa");

var $8K6h8 = parcelRequire("8K6h8");

var $jjTWw = parcelRequire("jjTWw");
const $5ee95508a2a0fbb9$export$155b977d3c1a6cb1 = (accountUuid, repositoryUuid, revision)=>{
    return `${(0, $fEutT.default)("/!api/internal")}/accounts/${accountUuid}/repositories/${repositoryUuid}/commit/${revision}/check-suites`;
};
const $5ee95508a2a0fbb9$export$7e870091aa58d5c5 = (accountUuid, repositoryUuid, revision, checkSuiteUuid)=>{
    return `${(0, $fEutT.default)("/!api/internal")}/accounts/${accountUuid}/repositories/${repositoryUuid}/commit/${revision}/check-suites/${checkSuiteUuid}/check-runs`;
};
function* $5ee95508a2a0fbb9$export$ce8fe0021432452a(action) {
    const targetUserKey = yield (0, $5NpoY.a3)((0, $g2R3c.getTargetUserKey));
    const { uuid: uuid } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = $5ee95508a2a0fbb9$export$155b977d3c1a6cb1(targetUserKey, uuid, action.meta.revision);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const payload = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_CHECK_SUITES).SUCCESS,
            meta: action.meta,
            payload: payload
        });
        yield (0, $5NpoY._)(payload.values.map((suite)=>(0, $5NpoY.Y)({
                type: (0, $jPcDa.REQUEST_CHECK_RUNS).REQUEST,
                meta: {
                    ...action.meta,
                    checkSuiteUuid: suite.uuid
                }
            })));
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_CHECK_SUITES).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_CHECK_SUITES).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $5ee95508a2a0fbb9$export$69a5229e3d237047(action) {
    const targetUserKey = yield (0, $5NpoY.a3)((0, $g2R3c.getTargetUserKey));
    const { uuid: uuid } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = `${$5ee95508a2a0fbb9$export$155b977d3c1a6cb1(targetUserKey, uuid, action.meta.revision)}/${action.meta.checkSuiteUuid}`;
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const payload = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_CHECK_SUITE).SUCCESS,
            meta: action.meta,
            payload: payload
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_CHECK_SUITE).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_CHECK_SUITE).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $5ee95508a2a0fbb9$export$d7a64b7a3033ac1(action) {
    const targetUserKey = yield (0, $5NpoY.a3)((0, $g2R3c.getTargetUserKey));
    const { uuid: uuid } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = $5ee95508a2a0fbb9$export$7e870091aa58d5c5(targetUserKey, uuid, action.meta.revision, action.meta.checkSuiteUuid);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const payload = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_CHECK_RUNS).SUCCESS,
            meta: action.meta,
            payload: payload
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_CHECK_RUNS).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_CHECK_RUNS).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $5ee95508a2a0fbb9$export$c2e72cc08b948a2e(action) {
    const targetUserKey = yield (0, $5NpoY.a3)((0, $g2R3c.getTargetUserKey));
    const { uuid: uuid } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = `${$5ee95508a2a0fbb9$export$7e870091aa58d5c5(targetUserKey, uuid, action.meta.revision, action.meta.checkSuiteUuid)}/${action.meta.checkRunUuid}`;
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const payload = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_CHECK_RUN).SUCCESS,
            meta: action.meta,
            payload: payload
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_CHECK_RUN).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_CHECK_RUN).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $5ee95508a2a0fbb9$export$2f72eaeeb463dde(action) {
    const { commitHash: revision, checkSuiteUuid: checkSuiteUuid, uuid: checkRunUuid } = action;
    if (!checkSuiteUuid || !checkRunUuid || !revision) return;
    const checkSuite = (yield (0, $5NpoY.a3)((0, $8K6h8.getCheckSuite)))(checkSuiteUuid);
    if (!checkSuite) yield (0, $5NpoY.Y)({
        type: (0, $jPcDa.REQUEST_CHECK_SUITE).REQUEST,
        meta: {
            revision: revision,
            checkSuiteUuid: checkSuiteUuid
        }
    });
    yield (0, $5NpoY.Y)({
        type: (0, $jPcDa.REQUEST_CHECK_RUN).REQUEST,
        meta: {
            revision: revision,
            checkSuiteUuid: checkSuiteUuid,
            checkRunUuid: checkRunUuid
        }
    });
}
function* $5ee95508a2a0fbb9$export$edb270bb51977ec0(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const res = yield (0, $5NpoY._)(action.meta.deploymentUuids.map((deploymentUuid)=>(0, $5NpoY.P)(fetch, (0, $k2cPS.default)((0, $jjTWw.getDeploymentUrl)(full_name, deploymentUuid)))));
        for (const response of res){
            if (!response.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(response)));
        }
        const payload = yield (0, $5NpoY._)(res.map((r)=>(0, $5NpoY.P)([
                r,
                "json"
            ])));
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_CHECKS_DEPLOYMENTS).SUCCESS,
            meta: action.meta,
            payload: payload
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_CHECKS_DEPLOYMENTS).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_CHECKS_DEPLOYMENTS).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $5ee95508a2a0fbb9$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_CHECK_SUITES).REQUEST, $5ee95508a2a0fbb9$export$ce8fe0021432452a),
        (0, $jeUNF.takeEvery)((0, $jPcDa.REQUEST_CHECK_RUNS).REQUEST, $5ee95508a2a0fbb9$export$d7a64b7a3033ac1),
        (0, $jeUNF.takeLatest)((0, $jPcDa.CHECK_RUN_UPDATED), $5ee95508a2a0fbb9$export$2f72eaeeb463dde),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_CHECKS_DEPLOYMENTS).REQUEST, $5ee95508a2a0fbb9$export$edb270bb51977ec0)
    ]);
}

});

parcelRegister("i48lW", function(module, exports) {

$parcel$export(module.exports, "getFileUrl", function () { return $5058a42b0efd5ad4$export$5d85806ee7b8d9f2; });
$parcel$export(module.exports, "logSaga", function () { return $5058a42b0efd5ad4$export$a12c1f884c126cb0; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $fxTkM = parcelRequire("fxTkM");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");
parcelRequire("hw8PW");
var $7JtYi = parcelRequire("7JtYi");
var $l9p9x = parcelRequire("l9p9x");

var $gG9M6 = parcelRequire("gG9M6");

var $aanBq = parcelRequire("aanBq");

var $k2cPS = parcelRequire("k2cPS");

var $i3LMs = parcelRequire("i3LMs");

var $fEutT = parcelRequire("fEutT");

var $QgM08 = parcelRequire("QgM08");

var $jPcDa = parcelRequire("jPcDa");

var $8K6h8 = parcelRequire("8K6h8");
const $5058a42b0efd5ad4$export$1bea5040aa9ec595 = (repositoryFullSlug, pipelineUuid, stepUuid)=>{
    return `${(0, $fEutT.default)("/!api/2.0")}/repositories/${repositoryFullSlug}/pipelines/${pipelineUuid}/steps/${stepUuid}/log`;
};
const $5058a42b0efd5ad4$export$6fe9fabba2d42928 = (repositoryFullSlug, pipelineUuid, stepUuid, serviceUuid)=>{
    return `${(0, $fEutT.default)("/!api/2.0")}/repositories/${repositoryFullSlug}/pipelines/${pipelineUuid}/steps/${stepUuid}/logs/${serviceUuid}`;
};
const $5058a42b0efd5ad4$export$f9e442a2c33c64b8 = (repositoryFullSlug, pipelineUuid, stepUuid, serviceUuid)=>{
    return `${(0, $fEutT.default)("/!api/internal")}/repositories/${repositoryFullSlug}/pipelines/${pipelineUuid}/steps/${stepUuid}/logs/${serviceUuid}`;
};
const $5058a42b0efd5ad4$export$5d85806ee7b8d9f2 = (repositoryFullSlug, revision, path = "")=>{
    return `${location.origin}/${repositoryFullSlug}/src/${encodeURIComponent(revision)}/${path}`;
};
const $5058a42b0efd5ad4$var$IGNORED_ERRORS = [
    "upstream service timed out on proxied request"
];
function $5058a42b0efd5ad4$export$4e5a96ac3a3ecf91(create, message) {
    return new Promise((resolve, reject)=>{
        const worker = create();
        worker.postMessage(message);
        worker.onmessage = (event)=>{
            worker.terminate();
            resolve(event.data);
        };
        worker.onerror = (err)=>{
            worker.terminate();
            reject(err);
        };
        worker.onmessageerror = (err)=>{
            worker.terminate();
            reject(err);
        };
        setTimeout(()=>{
            worker.terminate();
            reject(new Error("Log worker timeout"));
        }, (0, $i3LMs.MAX_WORKER_TIMEOUT_LIMIT));
    });
}
function* $5058a42b0efd5ad4$export$1f9bf8e0505a44a1(log, meta) {
    const { files: files, path: path } = yield (0, $5NpoY.a3)((0, $8K6h8.getRepository));
    const { revision: revision } = yield (0, $5NpoY.a3)((0, $8K6h8.getCurrentPipeline));
    const stepLog = yield (0, $5NpoY.a3)((0, $8K6h8.getStepLogForCurrentStep));
    const fileUrl = $5058a42b0efd5ad4$export$5d85806ee7b8d9f2(path, revision);
    if (meta.index === undefined) return log.trimEnd().split(/\r?\n|\r/);
    return yield $5058a42b0efd5ad4$export$4e5a96ac3a3ecf91((0, $gG9M6.createLogLineWorker), {
        fileUrl: fileUrl,
        files: files,
        logLines: log.trimEnd().split(/\r?\n|\r/),
        stepLog: stepLog,
        meta: meta
    });
}
function* $5058a42b0efd5ad4$export$213516da90bc4f34(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const { pipelineUuid: pipelineUuid, stepUuid: stepUuid, range: range, requestCounter: requestCounter, incrementalRequestEnabled: incrementalRequestEnabled, index: index, requestType: requestType } = action.meta;
    try {
        const url = $5058a42b0efd5ad4$export$1bea5040aa9ec595(full_name, pipelineUuid, stepUuid);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            headers: {
                Range: `bytes=${range.rangeStart}-${range.rangeEnd}`,
                "Command-Index": index,
                "Request-Counter": requestCounter,
                "Incremental-Request-Enabled": !!incrementalRequestEnabled,
                "Request-Type": requestType || ""
            },
            responseType: "text"
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "text"
        ]);
        const payload = yield (0, $5NpoY.P)($5058a42b0efd5ad4$export$1f9bf8e0505a44a1, data, action.meta);
        yield (0, $5NpoY.Y)({
            type: incrementalRequestEnabled ? (0, $jPcDa.REQUEST_FLAT_NESTED_LOGS).SUCCESS : (0, $jPcDa.REQUEST_LOG).SUCCESS,
            meta: action.meta,
            payload: payload
        });
    } catch (e) {
        if (!(0, $QgM08.isIgnoredErrorForSentry)(e, $5058a42b0efd5ad4$var$IGNORED_ERRORS)) (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_LOG).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_LOG).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $5058a42b0efd5ad4$export$3de820a109cb4c29(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const { pipelineUuid: pipelineUuid, stepUuid: stepUuid, serviceUuid: serviceUuid } = action.meta;
    try {
        const url = $5058a42b0efd5ad4$export$6fe9fabba2d42928(full_name, pipelineUuid, stepUuid, serviceUuid);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            responseType: "text"
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "text"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_SERVICE_LOG).SUCCESS,
            meta: action.meta,
            payload: data
        });
    } catch (e) {
        if (!(0, $QgM08.isIgnoredErrorForSentry)(e, $5058a42b0efd5ad4$var$IGNORED_ERRORS)) (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_SERVICE_LOG).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_SERVICE_LOG).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $5058a42b0efd5ad4$export$230849a063430459(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const pipeline = yield (0, $5NpoY.a3)((0, $8K6h8.getCurrentPipeline));
    const step = yield (0, $5NpoY.a3)((0, $8K6h8.getCurrentStep));
    try {
        const url = $5058a42b0efd5ad4$export$f9e442a2c33c64b8(full_name, pipeline.uuid, step.uuid, action.meta.serviceUuid || step.uuid);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "DELETE"
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_DELETE_LOG).SUCCESS,
            meta: {
                ...action.meta,
                stepUuid: step.uuid
            }
        });
    } catch (e) {
        if (!(0, $QgM08.isIgnoredErrorForSentry)(e, $5058a42b0efd5ad4$var$IGNORED_ERRORS)) (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_DELETE_LOG).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_DELETE_LOG).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $5058a42b0efd5ad4$export$44efeb906c7895e0(action) {
    const matches = [];
    const incrementalRequestEnabled = yield (0, $5NpoY.P)((0, $l9p9x.getFlagValue), (0, $7JtYi.FeatureKeys).incrementalRequestEnabled, false);
    if (action.meta.length > 2) {
        const infiniteLog = yield (0, $5NpoY.a3)(incrementalRequestEnabled ? (0, $8K6h8.getExpandedInfiniteLogV2) : (0, $8K6h8.getExpandedInfiniteLog));
        const regex = new RegExp((0, $fxTkM.default)(action.meta), "i");
        const logLimit = infiniteLog.length;
        for(let index = 0; index < logLimit; index++){
            const line = infiniteLog[index];
            if (typeof line === "string" && regex.test(line)) matches.push(index);
        }
    }
    yield (0, $5NpoY.Y)({
        type: (0, $jPcDa.SEARCH_LOG).SUCCESS,
        payload: matches,
        meta: action.meta
    });
}
function* $5058a42b0efd5ad4$export$4221db2179df969d() {
    const incrementalRequestEnabled = yield (0, $5NpoY.P)((0, $l9p9x.getFlagValue), (0, $7JtYi.FeatureKeys).incrementalRequestEnabled, false);
    const pipeline = yield (0, $5NpoY.a3)((0, $8K6h8.getCurrentPipeline));
    const step = yield (0, $5NpoY.a3)((0, $8K6h8.getCurrentStep));
    const commands = yield (0, $5NpoY.a3)((0, $8K6h8.getCommandsForCurrentStep));
    const isCommandDownloaded = yield (0, $5NpoY.a3)((0, $8K6h8.getIsCommandDownloaded));
    yield (0, $5NpoY._)(commands.map((command, index)=>{
        if (!command.log_range) return undefined;
        const rangeStart = command.log_range.first_byte_position;
        const rangeEnd = command.log_range.last_byte_position;
        if (!isCommandDownloaded(command) && rangeStart !== rangeEnd) {
            const range = {
                rangeStart: rangeStart,
                rangeEnd: rangeEnd
            };
            return (0, $5NpoY.P)($5058a42b0efd5ad4$export$213516da90bc4f34, {
                meta: {
                    pipelineUuid: pipeline.uuid,
                    stepUuid: step.uuid,
                    range: range,
                    index: index,
                    requestCounter: 0,
                    incrementalRequestEnabled: incrementalRequestEnabled
                }
            });
        } else return undefined;
    }));
}
function* $5058a42b0efd5ad4$export$5c4dfd6b892b06fb() {
    const step = yield (0, $5NpoY.a3)((0, $8K6h8.getCurrentStep));
    const commands = yield (0, $5NpoY.a3)((0, $8K6h8.getCommandsForCurrentStep));
    yield (0, $5NpoY.Y)({
        type: (0, $jPcDa.DOWNLOAD_ALL_COMMANDS).REQUEST
    });
    try {
        yield (0, $5NpoY.P)($5058a42b0efd5ad4$export$4221db2179df969d);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.DOWNLOAD_ALL_COMMANDS).SUCCESS
        });
        yield (0, $5NpoY._)(/* eslint-disable @typescript-eslint/no-unused-vars */ // @ts-ignore
        commands.map((c, index)=>(0, $5NpoY.Y)((0, $jPcDa.expandCommand)(step.uuid, index))));
    } catch (ignore) {
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.DOWNLOAD_ALL_COMMANDS).ERROR
        });
    }
}
function* $5058a42b0efd5ad4$export$feab72187a1fa476() {
    const expandedCommands = yield (0, $5NpoY.a3)((0, $8K6h8.getExpandedCommands));
    const collapseAllCommands = Object.keys(expandedCommands).reduce((reducer, stepUuid)=>{
        return reducer.concat(/* eslint-disable @typescript-eslint/no-unused-vars */ // @ts-ignore
        expandedCommands[stepUuid].map((c, index)=>(0, $5NpoY.Y)((0, $jPcDa.collapseCommand)(stepUuid, index))));
    }, []);
    yield (0, $5NpoY._)(collapseAllCommands);
}
function* $5058a42b0efd5ad4$export$c9b52d44a05027fa() {
    const searchLog = yield (0, $5NpoY.a3)((0, $8K6h8.getSearchLog));
    if (!searchLog.enabled) return;
    yield (0, $5NpoY.Y)({
        type: (0, $jPcDa.DISABLE_LOG_SEARCH)
    });
}
const $5058a42b0efd5ad4$export$a12c1f884c126cb0 = function*() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLeading)((0, $jPcDa.REQUEST_LOG_THROTTLED).REQUEST, $5058a42b0efd5ad4$export$213516da90bc4f34),
        (0, $jeUNF.takeEvery)((0, $jPcDa.REQUEST_LOG).REQUEST, $5058a42b0efd5ad4$export$213516da90bc4f34),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_SERVICE_LOG).REQUEST, $5058a42b0efd5ad4$export$3de820a109cb4c29),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_DELETE_LOG).REQUEST, $5058a42b0efd5ad4$export$230849a063430459),
        (0, $jeUNF.takeEvery)((0, $jPcDa.ENABLE_LOG_SEARCH), $5058a42b0efd5ad4$export$5c4dfd6b892b06fb),
        (0, $jeUNF.takeEvery)((0, $jPcDa.DISABLE_LOG_SEARCH), $5058a42b0efd5ad4$export$feab72187a1fa476),
        (0, $jeUNF.takeEvery)((0, $jPcDa.SEARCH_LOG).REQUEST, $5058a42b0efd5ad4$export$44efeb906c7895e0),
        (0, $jeUNF.takeEvery)((0, $jPcDa.SET_STEP), $5058a42b0efd5ad4$export$c9b52d44a05027fa)
    ]);
};

});
parcelRegister("fxTkM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b514dc5181b7dad6$export$2e2bcd8739ae039; });

var $aV88P = parcelRequire("aV88P");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $b514dc5181b7dad6$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $b514dc5181b7dad6$var$reHasRegExpChar = RegExp($b514dc5181b7dad6$var$reRegExpChar.source);
/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */ function $b514dc5181b7dad6$var$escapeRegExp(string) {
    string = (0, $aV88P.default)(string);
    return string && $b514dc5181b7dad6$var$reHasRegExpChar.test(string) ? string.replace($b514dc5181b7dad6$var$reRegExpChar, "\\$&") : string;
}
var $b514dc5181b7dad6$export$2e2bcd8739ae039 = $b514dc5181b7dad6$var$escapeRegExp;

});

parcelRegister("gG9M6", function(module, exports) {

$parcel$export(module.exports, "createLogLineWorker", function () { return $a2f4182ef4c4b5c6$export$71f057ee32a98702; });

function $a2f4182ef4c4b5c6$export$71f057ee32a98702() {
    return new Worker((parcelRequire("fbV6g")));
}

});
parcelRegister("fbV6g", function(module, exports) {

var $9Fow1 = parcelRequire("9Fow1");

var $1sJKT = parcelRequire("1sJKT");
let $b0f42cf6649d9ffb$var$url = $1sJKT.getBundleURL("ekZ4q") + "log-line-worker.f8666c36.js";
module.exports = $9Fow1($b0f42cf6649d9ffb$var$url, $1sJKT.getOrigin($b0f42cf6649d9ffb$var$url), false);

});
parcelRegister("9Fow1", function(module, exports) {
"use strict";
module.exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};

});




parcelRegister("h4cqg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $784a1776470092ec$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $cJH1T = parcelRequire("cJH1T");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $aanBq = parcelRequire("aanBq");

var $k2cPS = parcelRequire("k2cPS");

var $i3LMs = parcelRequire("i3LMs");

var $fEutT = parcelRequire("fEutT");

var $QgM08 = parcelRequire("QgM08");

var $jPcDa = parcelRequire("jPcDa");
const $784a1776470092ec$export$d4848d2cecbf9ce8 = (repositoryFullSlug, pipelineUuid, stepUuid, queryParams = {})=>{
    const allQueryParams = {
        pagelen: 100,
        ...queryParams
    };
    return `${(0, $fEutT.default)("/!api/internal")}/repositories/${repositoryFullSlug}/pipelines/${pipelineUuid}/steps/${stepUuid}/metrics?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(allQueryParams, {
        allowDots: true
    })}`;
};
function* $784a1776470092ec$export$6a58339fababf8c1(action) {
    const meta = action.meta || action; // websocket is not grouping params in action
    if (!meta.pipelineUuid || !meta.stepUuid || meta.stepUuid === (0, $i3LMs.EMPTY_STEP)) return;
    const { pipelineUuid: pipelineUuid, stepUuid: stepUuid } = meta;
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const res = yield (0, $5NpoY._)([
            (0, $5NpoY.P)(fetch, (0, $k2cPS.default)($784a1776470092ec$export$d4848d2cecbf9ce8(full_name, pipelineUuid, stepUuid, {
                metric_type: "CPU"
            }))),
            (0, $5NpoY.P)(fetch, (0, $k2cPS.default)($784a1776470092ec$export$d4848d2cecbf9ce8(full_name, pipelineUuid, stepUuid, {
                metric_type: "MEMORY"
            }))),
            (0, $5NpoY.P)(fetch, (0, $k2cPS.default)($784a1776470092ec$export$d4848d2cecbf9ce8(full_name, pipelineUuid, stepUuid, {
                metric_type: "MEMORY_PERCENTAGE"
            })))
        ]);
        for (const response of res){
            if (!response.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(response)));
        }
        const data = yield (0, $5NpoY._)(res.map((r)=>(0, $5NpoY.P)([
                r,
                "json"
            ])));
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_METRICS).SUCCESS,
            meta: action.meta,
            payload: data.reduce((reducer, r)=>{
                // @ts-ignore use es2019 lib
                reducer.push(r.values.flat());
                return reducer;
            }, []).flat()
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_METRICS).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_METRICS).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $784a1776470092ec$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_METRICS).REQUEST, $784a1776470092ec$export$6a58339fababf8c1),
        (0, $jeUNF.takeLatest)((0, $jPcDa.METRIC_UPDATED), $784a1776470092ec$export$6a58339fababf8c1)
    ]);
}

});

parcelRegister("eb0Ze", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c29cd74959b38882$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $aBXBT = parcelRequire("aBXBT");

var $g2R3c = parcelRequire("g2R3c");

var $kvnVB = parcelRequire("kvnVB");

var $k2cPS = parcelRequire("k2cPS");

var $9NUw3 = parcelRequire("9NUw3");

var $QgM08 = parcelRequire("QgM08");

var $jPcDa = parcelRequire("jPcDa");
const $c29cd74959b38882$export$29d15273399539fb = (accountUuid)=>{
    return `/!api/internal/accounts/${accountUuid}/pipelines_config`;
};
const $c29cd74959b38882$export$b4317273b737f505 = (accountUuid)=>{
    return `${(0, $kvnVB.settings)().API_CANON_URL}/internal/site/addons/account/${accountUuid}/install/`;
};
function* $c29cd74959b38882$export$e1fc715ebfa40729() {
    const targetUserKey = yield (0, $5NpoY.a3)((0, $g2R3c.getTargetUserKey));
    const url = $c29cd74959b38882$export$29d15273399539fb(targetUserKey);
    const installUrl = $c29cd74959b38882$export$b4317273b737f505(targetUserKey);
    try {
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "HEAD"
        }));
        if (!res.ok && res.status === 404) {
            const accessToken = yield (0, $5NpoY.P)((0, $9NUw3.default), `site:pipelines-ui-installer`);
            yield (0, $5NpoY.P)((0, $aBXBT.default), installUrl, accessToken, false, "POST");
            yield (0, $5NpoY.Y)((0, $jPcDa.requestAllowance)(targetUserKey));
        }
    } catch (e) {
        if (e instanceof Error) (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.VERIFY_PIPELINES_INSTALLATION)
        });
    }
}
function* $c29cd74959b38882$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLatest)((0, $jPcDa.VERIFY_PIPELINES_INSTALLATION), $c29cd74959b38882$export$e1fc715ebfa40729)
    ]);
}

});
parcelRegister("aBXBT", function(module, exports) {

$parcel$export(module.exports, "fetchAllPages", function () { return $a44d606e0cb66f15$export$9eabed129173d9b8; });
$parcel$export(module.exports, "default", function () { return $a44d606e0cb66f15$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $cJH1T = parcelRequire("cJH1T");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $k2cPS = parcelRequire("k2cPS");
const $a44d606e0cb66f15$export$118da7b6237c3071 = (url, page, pagelen)=>{
    const [baseUrl, search] = url.split("?");
    return `${baseUrl}?${(0, $cJH1T.stringify)({
        ...(0, $cJH1T.parse)(search || "", {
            ignoreQueryPrefix: true
        }),
        page: page,
        pagelen: pagelen
    })}`;
};
function* $a44d606e0cb66f15$export$9eabed129173d9b8(url, pagelen = 10) {
    const fetchPage = function*(currentPage) {
        const pageUrl = $a44d606e0cb66f15$export$118da7b6237c3071(url, currentPage, pagelen);
        const response = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(pageUrl));
        if (!response.ok) throw Error(`Response failed with text - ${response.statusText}, status: ${response.status}`);
        return response;
    };
    let values = [];
    const firstPageResponse = yield fetchPage(1);
    // @ts-ignore
    const firstPagePayload = yield firstPageResponse.json();
    values = values.concat(firstPagePayload.values);
    // returns an array of page numbers left to fetch
    const pagesLeft = [
        ...Array(Math.ceil(firstPagePayload.size / pagelen) + 1).keys()
    ].slice(2);
    const remainingPagesResponses = yield (0, $5NpoY._)(pagesLeft.map(fetchPage));
    if (remainingPagesResponses.length) {
        // @ts-ignore
        const remainingPagesPayloads = yield (0, $5NpoY._)(remainingPagesResponses.map((r)=>r.json()));
        values = values.concat(remainingPagesPayloads.reduce((reducer, p)=>reducer.concat(p.values), []));
    }
    return values;
}
function* $a44d606e0cb66f15$export$2e2bcd8739ae039(url, accessToken, returnValuesField = true, method = "GET") {
    const response = yield (0, $5NpoY.P)(fetch, url, {
        method: method,
        headers: {
            Authorization: `Bearer ${accessToken.token}`
        }
    });
    if (!response.ok) throw Error(`Response failed with text - ${response.statusText}, status: ${response.status}`);
    try {
        // @ts-ignore
        const json = yield response.json();
        return returnValuesField ? json.values : json;
    } catch (e) {
        return response;
    }
}

});

parcelRegister("9NUw3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa0d12c6450893ea$export$2e2bcd8739ae039; });

var $cJH1T = parcelRequire("cJH1T");

var $kvnVB = parcelRequire("kvnVB");

var $k2cPS = parcelRequire("k2cPS");

var $3Hukx = parcelRequire("3Hukx");
function $fa0d12c6450893ea$export$2e2bcd8739ae039(clientId) {
    if (clientId === "site:JSAPITOKEN") {
        const rawToken = (0, $3Hukx.parseTokenDetailsFromMetaTag)();
        if (rawToken.expiration && rawToken.token) {
            const expiresInSeconds = (rawToken.expiration - Date.now()) / 1000;
            if (expiresInSeconds > 15) // Return token from page if it's not going to expire soon. Subsequent requests should
            // re-call fetch-access-token so expiry should be handled there.
            return Promise.resolve({
                expiresInSeconds: expiresInSeconds,
                token: rawToken.token
            });
        }
    }
    const requestData = {
        client_id: clientId,
        redirect_uri: "https://bitbucket.org/",
        grant_type: "urn:bitbucket:oauth2:session"
    };
    return fetch((0, $k2cPS.default)(`${(0, $kvnVB.settings)().CANON_URL}/site/oauth2/access_token`, {
        method: "POST",
        body: (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(requestData),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    })).then((response)=>response.ok ? response.json() : Promise.reject(response)).then((json)=>({
            expiresInSeconds: json.expires_in,
            token: json.access_token
        }));
}

});
parcelRegister("3Hukx", function(module, exports) {

$parcel$export(module.exports, "parseTokenDetailsFromMetaTag", function () { return $1eb1ed25b62cb21a$export$8c1d4993da23fbf; });

var $h3kk7 = parcelRequire("h3kk7");

var $fgxvv = parcelRequire("fgxvv");
const $1eb1ed25b62cb21a$var$TOKEN_EXPIRY_THRESHOLD = 30000;
function $1eb1ed25b62cb21a$var$anonymousToken() {
    const tokenDetails = {
        token: null,
        expiration: null
    };
    return tokenDetails;
}
function $1eb1ed25b62cb21a$export$8c1d4993da23fbf() {
    const tokenMetaTag = document.querySelector("meta[name=apitoken]");
    const rawTokenDetails = tokenMetaTag && tokenMetaTag.hasAttribute("content") ? tokenMetaTag.getAttribute("content") : null;
    if (rawTokenDetails) try {
        const tokenDetails = JSON.parse(rawTokenDetails);
        // convert tokenDetails expiration to milliseconds
        if (tokenDetails.expiration) tokenDetails.expiration *= 1000;
        return tokenDetails;
    } catch (ignore) {
        return $1eb1ed25b62cb21a$var$anonymousToken();
    }
    return $1eb1ed25b62cb21a$var$anonymousToken();
}
// This function compares the expiration of the token that we extracted from
// the meta tag with the token in local storage. It then updates local
// storage with the latest token and returns the latest token.
function $1eb1ed25b62cb21a$var$getLatestToken(userUuid, tokenFromMetaTag) {
    const tokenStored = (0, $h3kk7.default).get(`api-token-data:${userUuid}`);
    let latestToken;
    if (tokenStored && tokenStored.expiration && tokenFromMetaTag.expiration) {
        if (tokenStored.expiration > tokenFromMetaTag.expiration) // The stored token is newer than the token from meta tag
        latestToken = tokenStored;
        else {
            // Update the store with the newer token from meta tag
            (0, $h3kk7.default).set(`api-token-data:${userUuid}`, tokenFromMetaTag);
            latestToken = tokenFromMetaTag;
        }
    } else if (!tokenStored && tokenFromMetaTag.expiration) {
        // No stored token and the token from meta tag is NOT the anonymous token
        (0, $h3kk7.default).set(`api-token-data:${userUuid}`, tokenFromMetaTag);
        latestToken = tokenFromMetaTag;
    } else if (tokenStored && !tokenFromMetaTag.expiration) // Stored token and the token from meta tag is the anonymous token
    latestToken = tokenStored;
    else // No stored token and the token from meta tag is the anonymous token
    latestToken = tokenFromMetaTag;
    return latestToken;
}
function $1eb1ed25b62cb21a$var$isExpired(tokenDetails) {
    // The token is expired if now is after (>) the expiration time.
    // We include a threshold so that we refresh the token before it
    // actually expires.
    return !tokenDetails.expiration || Date.now() + $1eb1ed25b62cb21a$var$TOKEN_EXPIRY_THRESHOLD > tokenDetails.expiration;
}
const $1eb1ed25b62cb21a$export$3cb9aa1d75f51be3 = async (userUuid)=>{
    // Anonymous users have no token
    if (!userUuid) return $1eb1ed25b62cb21a$var$anonymousToken();
    const tokenFromMetaTag = $1eb1ed25b62cb21a$export$8c1d4993da23fbf();
    const latestToken = $1eb1ed25b62cb21a$var$getLatestToken(userUuid, tokenFromMetaTag);
    if ($1eb1ed25b62cb21a$var$isExpired(latestToken)) {
        const refreshedToken = await (0, $fgxvv.default)(latestToken);
        (0, $h3kk7.default).set(`api-token-data:${userUuid}`, refreshedToken);
        return refreshedToken;
    }
    return latestToken;
};
const $1eb1ed25b62cb21a$export$11a51455c5740ca6 = (options)=>{
    // Anonymous user have no token
    if (!options.token) return {};
    return {
        Authorization: `Bearer ${options.token ? options.token : ""}`
    };
};

});
parcelRegister("fgxvv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6b071f38e6e6dec$export$2e2bcd8739ae039; });

var $9NUw3 = parcelRequire("9NUw3");
async function $c6b071f38e6e6dec$export$2e2bcd8739ae039(options) {
    let newOptions = {
        ...options
    };
    try {
        const accessToken = await (0, $9NUw3.default)("site:JSAPITOKEN");
        newOptions.token = accessToken.token;
        newOptions.expiration = Date.now() + accessToken.expiresInSeconds * 1000;
    } catch  {
        newOptions = {
            token: null,
            expiration: null
        };
    }
    return newOptions;
}

});




parcelRegister("fn1lI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b20d5b7de7811db$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $aBXBT = parcelRequire("aBXBT");

var $aanBq = parcelRequire("aanBq");

var $k2cPS = parcelRequire("k2cPS");

var $i3LMs = parcelRequire("i3LMs");

var $fEutT = parcelRequire("fEutT");

var $QgM08 = parcelRequire("QgM08");

var $jPcDa = parcelRequire("jPcDa");

var $8K6h8 = parcelRequire("8K6h8");
const $6b20d5b7de7811db$export$34564d8eb8477f5 = (repositoryFullSlug, commitHash)=>{
    return `${(0, $fEutT.default)("/!api/2.0")}/repositories/${repositoryFullSlug}/commit/${commitHash}/reports`;
};
function* $6b20d5b7de7811db$export$e08c1976d338b018() {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const pipeline = yield (0, $5NpoY.a3)((0, $8K6h8.getCurrentPipeline));
    try {
        const url = $6b20d5b7de7811db$export$34564d8eb8477f5(full_name, pipeline.revision);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_REPORTS).SUCCESS,
            payload: data
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_REPORTS).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_REPORTS).ERROR,
            payload: e
        });
    }
}
function* $6b20d5b7de7811db$export$e6fe9543efada322(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const pipeline = yield (0, $5NpoY.a3)((0, $8K6h8.getCurrentPipeline));
    const { reportUuid: reportUuid } = action;
    if (!reportUuid) return;
    try {
        const url = `${$6b20d5b7de7811db$export$34564d8eb8477f5(full_name, pipeline.revision)}/${reportUuid}`;
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_REPORT).SUCCESS,
            meta: {
                reportUuid: reportUuid
            },
            payload: data
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_REPORT).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_REPORT).ERROR,
            meta: {
                reportUuid: reportUuid
            },
            payload: e
        });
    }
}
function* $6b20d5b7de7811db$export$869e5aba88f0bbc2(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const pipeline = yield (0, $5NpoY.a3)((0, $8K6h8.getCurrentPipeline));
    try {
        const url = `${$6b20d5b7de7811db$export$34564d8eb8477f5(full_name, pipeline.revision)}/${action.meta.reportUuid}/annotations?sort=-severity&page=1`;
        const data = yield (0, $5NpoY.P)((0, $aBXBT.fetchAllPages), url, (0, $i3LMs.ANNOTATIONS_PAGE_SIZE));
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_ANNOTATIONS).SUCCESS,
            meta: action.meta,
            payload: data
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_ANNOTATIONS).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_ANNOTATIONS).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $6b20d5b7de7811db$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_REPORTS).REQUEST, $6b20d5b7de7811db$export$e08c1976d338b018),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_ANNOTATIONS).REQUEST, $6b20d5b7de7811db$export$869e5aba88f0bbc2),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REPORT_UPDATED), $6b20d5b7de7811db$export$e6fe9543efada322)
    ]);
}

});

parcelRegister("2ZoPX", function(module, exports) {

$parcel$export(module.exports, "getBranchesUrl", function () { return $4d59810ba48a0805$export$422c21f34cf6456d; });
$parcel$export(module.exports, "default", function () { return $4d59810ba48a0805$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $cJH1T = parcelRequire("cJH1T");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");
parcelRequire("e9n2v");
var $6vGsr = parcelRequire("6vGsr");

var $iyRMZ = parcelRequire("iyRMZ");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");

var $aanBq = parcelRequire("aanBq");

var $g2R3c = parcelRequire("g2R3c");

var $k2cPS = parcelRequire("k2cPS");

var $fEutT = parcelRequire("fEutT");

var $QgM08 = parcelRequire("QgM08");

var $jPcDa = parcelRequire("jPcDa");

var $8K6h8 = parcelRequire("8K6h8");
const $4d59810ba48a0805$export$29d15273399539fb = (repositoryFullSlug)=>{
    return `${(0, $fEutT.default)("/!api/2.0")}/repositories/${repositoryFullSlug}/pipelines_config`;
};
const $4d59810ba48a0805$export$82fa17f54b9afa3e = (repositoryFullSlug)=>{
    return `/!api/internal/repositories/${repositoryFullSlug}/branch-restrictions/group-by-branch/`;
};
const $4d59810ba48a0805$export$422c21f34cf6456d = (repositoryFullSlug, queryParams = {})=>{
    return `/!api/2.0/repositories/${repositoryFullSlug}/refs/branches?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(queryParams)}`;
};
const $4d59810ba48a0805$export$cb74d528797ed399 = (owner = "", queryParams = {})=>{
    return `/!api/2.0/repositories/${owner}?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(queryParams)}`;
};
const $4d59810ba48a0805$export$67f20c979db887a6 = (repositoryFullSlug)=>{
    return `/!api/2.0/repositories/${repositoryFullSlug}/src/`;
};
const $4d59810ba48a0805$export$f946d3080d86690a = ()=>{
    return `/!api/2.0/repositories/bitbucketpipelines/official-templates/src/master/templates.prod.json`;
};
const $4d59810ba48a0805$export$ae208cd352101060 = (repositoryFullSlug, ref)=>{
    return `/!api/2.0/repositories/${repositoryFullSlug}/src/${ref}/bitbucket-pipelines.yml`;
};
const $4d59810ba48a0805$export$63a6a636c523f80d = (repositoryFullSlug, revision)=>{
    return `/!api/internal/repositories/${repositoryFullSlug}/tree/${revision}/?no_size=1`;
};
function* $4d59810ba48a0805$export$712a5113036976f8() {
    const repository = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    yield (0, $5NpoY.Y)({
        type: (0, $jPcDa.SET_REPOSITORY),
        payload: repository
    });
    yield (0, $5NpoY.Y)({
        type: (0, $iyRMZ.CLEAR_VARIABLES)
    });
}
function* $4d59810ba48a0805$export$fa9d8a5200fe82b8(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = $4d59810ba48a0805$export$82fa17f54b9afa3e(full_name);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const payload = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_REPOSITORY_BRANCH_RESTRICTIONS).SUCCESS,
            meta: action === null || action === void 0 ? void 0 : action.meta,
            payload: payload
        });
    } catch (e) {
        if (!(0, $QgM08.isIgnoredErrorForSentry)(e)) (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_REPOSITORY_BRANCH_RESTRICTIONS).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_REPOSITORY_BRANCH_RESTRICTIONS).ERROR,
            meta: action === null || action === void 0 ? void 0 : action.meta,
            payload: e
        });
    }
}
function* $4d59810ba48a0805$export$91fa868d67c5a60e(action) {
    var _action$meta;
    const targetUserKey = yield (0, $5NpoY.a3)((0, $g2R3c.getTargetUserKey));
    const { path: path, hasFetchedUserIsAdmin: hasFetchedUserIsAdmin } = yield (0, $5NpoY.a3)((0, $8K6h8.getRepository));
    const role = ((_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : _action$meta.role) || "admin";
    if (role === "admin" && hasFetchedUserIsAdmin) return;
    try {
        var _action$meta2;
        const url = $4d59810ba48a0805$export$cb74d528797ed399(targetUserKey, {
            role: ((_action$meta2 = action.meta) === null || _action$meta2 === void 0 ? void 0 : _action$meta2.role) || "admin",
            q: `full_name="${path}"`,
            pagelen: 1,
            page: 1
        });
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const payload = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_REPOSITORY_USER_IS_MEMBER).SUCCESS,
            meta: action === null || action === void 0 ? void 0 : action.meta,
            payload: payload
        });
    } catch (e) {
        if (!(0, $QgM08.isIgnoredErrorForSentry)(e)) (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_REPOSITORY_USER_IS_MEMBER).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_REPOSITORY_USER_IS_MEMBER).ERROR,
            meta: action === null || action === void 0 ? void 0 : action.meta,
            payload: e
        });
    }
}
function* $4d59810ba48a0805$export$b524de1c7a680141(action) {
    try {
        var _templates$;
        const url = $4d59810ba48a0805$export$f946d3080d86690a();
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const payload = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        const templates = payload.sort((a, b)=>(a === null || a === void 0 ? void 0 : a.weight) - (b === null || b === void 0 ? void 0 : b.weight));
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_OFFICIAL_TEMPLATES).SUCCESS,
            meta: action === null || action === void 0 ? void 0 : action.meta,
            payload: templates
        });
        const validator = yield (0, $5NpoY.a3)((0, $8K6h8.getValidator));
        const buildConfiguration = yield (0, $5NpoY.a3)((0, $8K6h8.getBuildConfiguration));
        if (validator.currentEditor === (0, $6vGsr.EditorEnum).DeploymentsOnboarding && (buildConfiguration.yml || (_templates$ = templates[0]) !== null && _templates$ !== void 0 && _templates$.yml)) {
            var _templates$2;
            yield (0, $5NpoY.Y)((0, $jPcDa.setValidator)({
                code: buildConfiguration.yml || ((_templates$2 = templates[0]) === null || _templates$2 === void 0 ? void 0 : _templates$2.yml)
            }));
        }
    } catch (e) {
        if (!(0, $QgM08.isIgnoredErrorForSentry)(e)) (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_OFFICIAL_TEMPLATES).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_OFFICIAL_TEMPLATES).ERROR,
            meta: action === null || action === void 0 ? void 0 : action.meta,
            payload: e
        });
    }
}
function* $4d59810ba48a0805$export$1234e2af73157b80(action) {
    const { full_name: full_name, mainbranch: mainbranch } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        var _action$meta3;
        const url = $4d59810ba48a0805$export$ae208cd352101060(full_name, ((_action$meta3 = action.meta) === null || _action$meta3 === void 0 ? void 0 : _action$meta3.ref) || (mainbranch === null || mainbranch === void 0 ? void 0 : mainbranch.name));
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            responseType: "text"
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const payload = yield (0, $5NpoY.P)([
            res,
            "text"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_BUILD_CONFIGURATION).SUCCESS,
            meta: action === null || action === void 0 ? void 0 : action.meta,
            payload: payload
        });
    } catch (e) {
        if (!(0, $QgM08.isIgnoredErrorForSentry)(e)) (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_BUILD_CONFIGURATION).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_BUILD_CONFIGURATION).ERROR,
            meta: action === null || action === void 0 ? void 0 : action.meta,
            payload: e
        });
    }
}
const $4d59810ba48a0805$var$makeEnableDisablePipelinesSaga = (action, enabled)=>function* requestEnablePipelinesSaga() {
        const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
        try {
            const url = $4d59810ba48a0805$export$29d15273399539fb(full_name);
            const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
                method: "PUT",
                headers: (0, $k2cPS.jsonHeaders),
                body: JSON.stringify({
                    enabled: enabled
                })
            }));
            if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
            const payload = yield (0, $5NpoY.P)([
                res,
                "json"
            ]);
            yield (0, $5NpoY.Y)({
                type: action.SUCCESS,
                payload: payload
            });
        } catch (e) {
            if (!(0, $QgM08.isIgnoredErrorForSentry)(e)) (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
                segment: enabled ? "pipelines_enable" : "pipelines_disable"
            });
            yield (0, $5NpoY.Y)({
                type: action.ERROR,
                payload: e
            });
        }
    };
const $4d59810ba48a0805$export$b5e4b433202b4f57 = $4d59810ba48a0805$var$makeEnableDisablePipelinesSaga((0, $jPcDa.REQUEST_ENABLE_PIPELINES), true);
const $4d59810ba48a0805$export$e327bc1f8fd69f78 = $4d59810ba48a0805$var$makeEnableDisablePipelinesSaga((0, $jPcDa.REQUEST_DISABLE_PIPELINES), false);
function* $4d59810ba48a0805$export$67e556a6372ff2b4(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = $4d59810ba48a0805$export$67f20c979db887a6(full_name);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "POST",
            headers: {
                "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
            },
            body: (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
                ...action.meta.configuration ? {
                    "bitbucket-pipelines.yml": action.meta.configuration
                } : {},
                message: action.meta.commitMessage
            })
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_COMMIT_CONFIGURATION).SUCCESS,
            meta: action === null || action === void 0 ? void 0 : action.meta
        });
    } catch (e) {
        if (!(0, $QgM08.isIgnoredErrorForSentry)(e)) (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_COMMIT_CONFIGURATION).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_COMMIT_CONFIGURATION).ERROR,
            meta: action === null || action === void 0 ? void 0 : action.meta,
            payload: e
        });
    }
}
function* $4d59810ba48a0805$export$55b4236cdefb351d(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = $4d59810ba48a0805$export$63a6a636c523f80d(full_name, action.meta.revision);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const payload = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_REPOSITORY_FILES).SUCCESS,
            meta: action === null || action === void 0 ? void 0 : action.meta,
            payload: payload
        });
    } catch (e) {
        if (!(0, $QgM08.isIgnoredErrorForSentry)(e)) (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_REPOSITORY_FILES).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_REPOSITORY_FILES).ERROR,
            meta: action === null || action === void 0 ? void 0 : action.meta,
            payload: e
        });
    }
}
function* $4d59810ba48a0805$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLatest)((0, $jJd6W.LoadRepositoryPage).SUCCESS, $4d59810ba48a0805$export$712a5113036976f8),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_REPOSITORY_BRANCH_RESTRICTIONS).REQUEST, $4d59810ba48a0805$export$fa9d8a5200fe82b8),
        (0, $jeUNF.takeEvery)((0, $jPcDa.REQUEST_REPOSITORY_USER_IS_MEMBER).REQUEST, $4d59810ba48a0805$export$91fa868d67c5a60e),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_REPOSITORY_FILES).REQUEST, $4d59810ba48a0805$export$55b4236cdefb351d),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_BUILD_CONFIGURATION).REQUEST, $4d59810ba48a0805$export$1234e2af73157b80),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_ENABLE_PIPELINES).REQUEST, $4d59810ba48a0805$export$b5e4b433202b4f57),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_DISABLE_PIPELINES).REQUEST, $4d59810ba48a0805$export$e327bc1f8fd69f78),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_COMMIT_CONFIGURATION).REQUEST, $4d59810ba48a0805$export$67e556a6372ff2b4),
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_OFFICIAL_TEMPLATES).REQUEST, $4d59810ba48a0805$export$b524de1c7a680141)
    ]);
}

});
parcelRegister("iyRMZ", function(module, exports) {

$parcel$export(module.exports, "CLEAR_VARIABLES", function () { return $e2593fc7b7bfda7a$export$2ae1afb0a6a7e3ca; });
$parcel$export(module.exports, "REQUEST_VARIABLES", function () { return $e2593fc7b7bfda7a$export$56b0875515a3528c; });
$parcel$export(module.exports, "REQUEST_CREATE_VARIABLE", function () { return $e2593fc7b7bfda7a$export$3efdd48986c029d; });
$parcel$export(module.exports, "REQUEST_UPDATE_VARIABLE", function () { return $e2593fc7b7bfda7a$export$6df5d90bd8310e43; });
$parcel$export(module.exports, "REQUEST_DELETE_VARIABLE", function () { return $e2593fc7b7bfda7a$export$3662197cc8f2fae; });
$parcel$export(module.exports, "REQUEST_ENVIRONMENT_VARIABLES", function () { return $e2593fc7b7bfda7a$export$a4c7b07597f4a3c3; });
$parcel$export(module.exports, "REQUEST_CREATE_ENVIRONMENT_VARIABLE", function () { return $e2593fc7b7bfda7a$export$e081260dbdc8aad6; });
$parcel$export(module.exports, "REQUEST_UPDATE_ENVIRONMENT_VARIABLE", function () { return $e2593fc7b7bfda7a$export$9e094f41d41410f6; });
$parcel$export(module.exports, "REQUEST_DELETE_ENVIRONMENT_VARIABLE", function () { return $e2593fc7b7bfda7a$export$728b578ae586009f; });
$parcel$export(module.exports, "requestVariables", function () { return $e2593fc7b7bfda7a$export$9071cef70b9a1787; });
$parcel$export(module.exports, "requestCreateVariable", function () { return $e2593fc7b7bfda7a$export$422afede7e3f47f7; });
$parcel$export(module.exports, "requestUpdateVariable", function () { return $e2593fc7b7bfda7a$export$b2b1855880fcab8e; });
$parcel$export(module.exports, "requestDeleteVariable", function () { return $e2593fc7b7bfda7a$export$9c4e907d52730fb9; });
$parcel$export(module.exports, "requestEnvironmentVariables", function () { return $e2593fc7b7bfda7a$export$1efc006944aa7b97; });
$parcel$export(module.exports, "requestCreateEnvironmentVariable", function () { return $e2593fc7b7bfda7a$export$a73f4bdf158f8f1b; });
$parcel$export(module.exports, "requestUpdateEnvironmentVariable", function () { return $e2593fc7b7bfda7a$export$ef4d35684f501485; });
$parcel$export(module.exports, "requestDeleteEnvironmentVariable", function () { return $e2593fc7b7bfda7a$export$b33d9f51edbdad7d; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");

var $IQU41 = parcelRequire("IQU41");
const $e2593fc7b7bfda7a$export$2ae1afb0a6a7e3ca = "CLEAR_VARIABLES";
const $e2593fc7b7bfda7a$export$56b0875515a3528c = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_VARIABLES"));
const $e2593fc7b7bfda7a$export$3efdd48986c029d = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_CREATE_VARIABLE"));
const $e2593fc7b7bfda7a$export$6df5d90bd8310e43 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_UPDATE_VARIABLE"));
const $e2593fc7b7bfda7a$export$3662197cc8f2fae = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_DELETE_VARIABLE"));
const $e2593fc7b7bfda7a$export$a4c7b07597f4a3c3 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_ENVIRONMENT_VARIABLES"));
const $e2593fc7b7bfda7a$export$e081260dbdc8aad6 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_CREATE_ENVIRONMENT_VARIABLE"));
const $e2593fc7b7bfda7a$export$9e094f41d41410f6 = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_UPDATE_ENVIRONMENT_VARIABLE"));
const $e2593fc7b7bfda7a$export$728b578ae586009f = (0, $2MctD.createAsyncAction)((0, $IQU41.prefixed)("REQUEST_DELETE_ENVIRONMENT_VARIABLE"));
const $e2593fc7b7bfda7a$export$9071cef70b9a1787 = ()=>({
        type: $e2593fc7b7bfda7a$export$56b0875515a3528c.REQUEST,
        meta: {}
    });
const $e2593fc7b7bfda7a$export$422afede7e3f47f7 = (variable)=>({
        type: $e2593fc7b7bfda7a$export$3efdd48986c029d.REQUEST,
        meta: {
            variable: variable
        }
    });
const $e2593fc7b7bfda7a$export$b2b1855880fcab8e = (previousVariable, variable)=>({
        type: $e2593fc7b7bfda7a$export$6df5d90bd8310e43.REQUEST,
        meta: {
            previousVariable: previousVariable,
            variable: variable
        }
    });
const $e2593fc7b7bfda7a$export$9c4e907d52730fb9 = (variable, variableIndex)=>({
        type: $e2593fc7b7bfda7a$export$3662197cc8f2fae.REQUEST,
        meta: {
            variable: variable,
            variableIndex: variableIndex
        }
    });
const $e2593fc7b7bfda7a$export$1efc006944aa7b97 = (environmentUuid)=>{
    return {
        type: $e2593fc7b7bfda7a$export$a4c7b07597f4a3c3.REQUEST,
        meta: {
            environmentUuid: environmentUuid
        }
    };
};
const $e2593fc7b7bfda7a$export$a73f4bdf158f8f1b = (environmentUuid, variable)=>{
    return {
        type: $e2593fc7b7bfda7a$export$e081260dbdc8aad6.REQUEST,
        meta: {
            environmentUuid: environmentUuid,
            variable: variable
        }
    };
};
const $e2593fc7b7bfda7a$export$ef4d35684f501485 = (environmentUuid, previousVariable, variable)=>({
        type: $e2593fc7b7bfda7a$export$9e094f41d41410f6.REQUEST,
        meta: {
            environmentUuid: environmentUuid,
            previousVariable: previousVariable,
            variable: variable
        }
    });
const $e2593fc7b7bfda7a$export$b33d9f51edbdad7d = (environmentUuid, variable, variableIndex)=>({
        type: $e2593fc7b7bfda7a$export$728b578ae586009f.REQUEST,
        meta: {
            environmentUuid: environmentUuid,
            variable: variable,
            variableIndex: variableIndex
        }
    });

});


parcelRegister("3mAB1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cc6fc891e8eaaf1$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $cJH1T = parcelRequire("cJH1T");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $aanBq = parcelRequire("aanBq");

var $k2cPS = parcelRequire("k2cPS");

var $i3LMs = parcelRequire("i3LMs");

var $fEutT = parcelRequire("fEutT");

var $QgM08 = parcelRequire("QgM08");

var $jPcDa = parcelRequire("jPcDa");
const $4cc6fc891e8eaaf1$export$2cd642e690ccdf35 = (repositoryFullSlug, scheduleUuid = "", queryParams = {})=>{
    return `${(0, $fEutT.default)("/!api/2.0")}/repositories/${repositoryFullSlug}/pipelines_config/schedules/${scheduleUuid}${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(queryParams, {
        addQueryPrefix: true
    })}`;
};
function* $4cc6fc891e8eaaf1$export$cd2ee2a1d57355b7() {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = $4cc6fc891e8eaaf1$export$2cd642e690ccdf35(full_name, "", {
            page: 1,
            pagelen: (0, $i3LMs.SCHEDULES_PAGE_SIZE)
        });
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const schedulesPayload = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        const executionsRes = yield (0, $5NpoY._)(schedulesPayload.values.map((schedule)=>(0, $5NpoY.P)(fetch, (0, $k2cPS.default)($4cc6fc891e8eaaf1$export$2cd642e690ccdf35(full_name, `${schedule.uuid}/executions/`, {
                page: 1,
                pagelen: 10,
                sort: "-triggeredOn"
            })))));
        const executionsPayload = yield (0, $5NpoY._)(executionsRes.map((r)=>(0, $5NpoY.P)([
                r,
                "json"
            ])));
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_SCHEDULES).SUCCESS,
            payload: schedulesPayload.values.map((schedule, key)=>({
                    ...schedule,
                    executions: executionsPayload[key].values
                }))
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_SCHEDULES).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_SCHEDULES).ERROR,
            payload: e
        });
    }
}
function* $4cc6fc891e8eaaf1$export$2996c682f337167e(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = $4cc6fc891e8eaaf1$export$2cd642e690ccdf35(full_name, action.meta.schedule.uuid);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "DELETE"
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_DELETE_SCHEDULE).SUCCESS,
            meta: action.meta
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_DELETE_SCHEDULE).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_DELETE_SCHEDULE).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $4cc6fc891e8eaaf1$export$1e6e863d3336a4e1(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = $4cc6fc891e8eaaf1$export$2cd642e690ccdf35(full_name);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "POST",
            headers: (0, $k2cPS.jsonHeaders),
            body: JSON.stringify(action.meta.schedule)
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const response = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_CREATE_SCHEDULE).SUCCESS,
            payload: response
        });
    } catch (e) {
        if (!(0, $QgM08.isIgnoredErrorForSentry)(e)) (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_CREATE_SCHEDULE).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_CREATE_SCHEDULE).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $4cc6fc891e8eaaf1$export$ae8fa5bdcddc91c0(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = $4cc6fc891e8eaaf1$export$2cd642e690ccdf35(full_name, action.meta.schedule.uuid);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "PUT",
            headers: (0, $k2cPS.jsonHeaders),
            body: JSON.stringify({
                enabled: !action.meta.schedule.enabled
            })
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_TOGGLE_SCHEDULE).SUCCESS,
            meta: action.meta
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_TOGGLE_SCHEDULE).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_TOGGLE_SCHEDULE).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $4cc6fc891e8eaaf1$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLatest)((0, $jPcDa.REQUEST_SCHEDULES).REQUEST, $4cc6fc891e8eaaf1$export$cd2ee2a1d57355b7),
        (0, $jeUNF.takeEvery)((0, $jPcDa.REQUEST_CREATE_SCHEDULE).REQUEST, $4cc6fc891e8eaaf1$export$1e6e863d3336a4e1),
        (0, $jeUNF.takeEvery)((0, $jPcDa.REQUEST_DELETE_SCHEDULE).REQUEST, $4cc6fc891e8eaaf1$export$2996c682f337167e),
        (0, $jeUNF.takeEvery)((0, $jPcDa.REQUEST_TOGGLE_SCHEDULE).REQUEST, $4cc6fc891e8eaaf1$export$ae8fa5bdcddc91c0)
    ]);
}

});

parcelRegister("clLnm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3535a705322965f2$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $cJH1T = parcelRequire("cJH1T");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $aanBq = parcelRequire("aanBq");

var $k2cPS = parcelRequire("k2cPS");

var $i3LMs = parcelRequire("i3LMs");

var $fEutT = parcelRequire("fEutT");

var $QgM08 = parcelRequire("QgM08");

var $jPcDa = parcelRequire("jPcDa");
const $3535a705322965f2$export$4d2bf45a8b996c95 = (repositoryFullSlug, pipelineUuid, stepUuid, queryParams = {})=>{
    const allQueryParams = {
        page: 1,
        pagelen: (0, $i3LMs.TEST_REPORTS_PAGE_SIZE),
        successfulTestCases: "false",
        fields: "-values.reason",
        ...queryParams
    };
    return `${(0, $fEutT.default)("/!api/2.0")}/repositories/${repositoryFullSlug}/pipelines/${pipelineUuid}/steps/${stepUuid}/test_reports/test_cases?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(allQueryParams)}`;
};
const $3535a705322965f2$export$76f89258a1f39eb1 = (repositoryFullSlug, pipelineUuid, stepUuid, testCaseUuid)=>{
    return `${(0, $fEutT.default)("/!api/2.0")}/repositories/${repositoryFullSlug}/pipelines/${pipelineUuid}/steps/${stepUuid}/test_reports/test_cases/${testCaseUuid}/test_case_reasons`;
};
function* $3535a705322965f2$export$1fdd897347b5dd2d(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const { pipelineUuid: pipelineUuid, stepUuid: stepUuid } = action.meta;
    try {
        const url = $3535a705322965f2$export$4d2bf45a8b996c95(full_name, pipelineUuid, stepUuid);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_FAILED_TEST_CASES).SUCCESS,
            meta: action.meta,
            payload: data
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_FAILED_TEST_CASES).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_FAILED_TEST_CASES).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $3535a705322965f2$export$b4ce2dbd234fcbc4(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const { pipelineUuid: pipelineUuid, stepUuid: stepUuid, testCaseUuid: testCaseUuid } = action.meta;
    try {
        const url = $3535a705322965f2$export$76f89258a1f39eb1(full_name, pipelineUuid, stepUuid, testCaseUuid);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_TEST_CASE_REASON).SUCCESS,
            meta: action.meta,
            payload: data
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $jPcDa.REQUEST_TEST_CASE_REASON).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jPcDa.REQUEST_TEST_CASE_REASON).ERROR,
            meta: action.meta,
            payload: e
        });
    }
}
function* $3535a705322965f2$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeEvery)((0, $jPcDa.REQUEST_FAILED_TEST_CASES).REQUEST, $3535a705322965f2$export$1fdd897347b5dd2d),
        (0, $jeUNF.takeEvery)((0, $jPcDa.REQUEST_TEST_CASE_REASON).REQUEST, $3535a705322965f2$export$b4ce2dbd234fcbc4)
    ]);
}

});

parcelRegister("doQdL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a448df2e4ca6f2db$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $cJH1T = parcelRequire("cJH1T");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $i3LMs = parcelRequire("i3LMs");

var $8K6h8 = parcelRequire("8K6h8");

var $aanBq = parcelRequire("aanBq");

var $k2cPS = parcelRequire("k2cPS");

var $fEutT = parcelRequire("fEutT");

var $QgM08 = parcelRequire("QgM08");

var $iyRMZ = parcelRequire("iyRMZ");
const $a448df2e4ca6f2db$export$34b23f8637217659 = (repositoryFullSlug, variableUuid = "")=>{
    return `${(0, $fEutT.default)("/!api/2.0")}/repositories/${repositoryFullSlug}/pipelines_config/variables/${variableUuid}`;
};
const $a448df2e4ca6f2db$export$ad6ee5dc334d3844 = (repositoryFullSlug, environmentUuid, variableUuid = "")=>{
    return `${(0, $fEutT.default)("/!api/internal", "deployments")}/repositories/${repositoryFullSlug}/deployments_config/environments/${environmentUuid}/variables/${variableUuid}`;
};
function* $a448df2e4ca6f2db$export$1e852072946e2f66(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const page = yield (0, $5NpoY.a3)((0, $8K6h8.getVariablesPage));
    try {
        const url = `${$a448df2e4ca6f2db$export$34b23f8637217659(full_name)}?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
            page: page,
            pagelen: (0, $i3LMs.VARIABLES_PAGELEN)
        })}`;
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const payload = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $iyRMZ.REQUEST_VARIABLES).SUCCESS,
            meta: action === null || action === void 0 ? void 0 : action.meta,
            payload: payload
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $iyRMZ.REQUEST_VARIABLES).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $iyRMZ.REQUEST_VARIABLES).ERROR,
            meta: action === null || action === void 0 ? void 0 : action.meta,
            payload: e
        });
    }
}
function* $a448df2e4ca6f2db$export$e645c0f3b2ea9b9a(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = $a448df2e4ca6f2db$export$34b23f8637217659(full_name);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "POST",
            headers: (0, $k2cPS.jsonHeaders),
            body: JSON.stringify(action.meta.variable)
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const payload = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $iyRMZ.REQUEST_CREATE_VARIABLE).SUCCESS,
            meta: action === null || action === void 0 ? void 0 : action.meta,
            payload: payload
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $iyRMZ.REQUEST_CREATE_VARIABLE).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $iyRMZ.REQUEST_CREATE_VARIABLE).ERROR,
            meta: action === null || action === void 0 ? void 0 : action.meta,
            payload: e
        });
    }
}
function* $a448df2e4ca6f2db$export$3e538bbb2a5767c3(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        var _action$meta, _action$meta$previous;
        const url = $a448df2e4ca6f2db$export$34b23f8637217659(full_name, (_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : (_action$meta$previous = _action$meta.previousVariable) === null || _action$meta$previous === void 0 ? void 0 : _action$meta$previous.uuid);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "PUT",
            headers: (0, $k2cPS.jsonHeaders),
            body: JSON.stringify(action.meta.variable)
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const payload = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $iyRMZ.REQUEST_UPDATE_VARIABLE).SUCCESS,
            meta: action === null || action === void 0 ? void 0 : action.meta,
            payload: payload
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $iyRMZ.REQUEST_UPDATE_VARIABLE).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $iyRMZ.REQUEST_UPDATE_VARIABLE).ERROR,
            meta: action === null || action === void 0 ? void 0 : action.meta,
            payload: e
        });
    }
}
function* $a448df2e4ca6f2db$export$8c6a63993fd97052(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        var _action$meta2, _action$meta2$variabl;
        const url = $a448df2e4ca6f2db$export$34b23f8637217659(full_name, (_action$meta2 = action.meta) === null || _action$meta2 === void 0 ? void 0 : (_action$meta2$variabl = _action$meta2.variable) === null || _action$meta2$variabl === void 0 ? void 0 : _action$meta2$variabl.uuid);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "DELETE"
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        yield (0, $5NpoY.Y)({
            type: (0, $iyRMZ.REQUEST_DELETE_VARIABLE).SUCCESS,
            meta: action === null || action === void 0 ? void 0 : action.meta
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $iyRMZ.REQUEST_DELETE_VARIABLE).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $iyRMZ.REQUEST_DELETE_VARIABLE).ERROR,
            meta: action === null || action === void 0 ? void 0 : action.meta,
            payload: e
        });
    }
}
function* $a448df2e4ca6f2db$export$1403496b47e70932(action) {
    var _yield$select$environ, _yield$select;
    const { environmentUuid: environmentUuid } = action.meta;
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const page = (_yield$select$environ = (_yield$select = yield (0, $5NpoY.a3)((0, $8K6h8.getEnvironmentVariablesPage))) === null || _yield$select === void 0 ? void 0 : _yield$select[environmentUuid]) !== null && _yield$select$environ !== void 0 ? _yield$select$environ : 1;
    try {
        const url = `${$a448df2e4ca6f2db$export$ad6ee5dc334d3844(full_name, environmentUuid)}?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
            page: page,
            pagelen: (0, $i3LMs.VARIABLES_PAGELEN)
        })}`;
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const payload = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $iyRMZ.REQUEST_ENVIRONMENT_VARIABLES).SUCCESS,
            meta: action === null || action === void 0 ? void 0 : action.meta,
            payload: payload
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $iyRMZ.REQUEST_ENVIRONMENT_VARIABLES).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $iyRMZ.REQUEST_ENVIRONMENT_VARIABLES).ERROR,
            meta: action === null || action === void 0 ? void 0 : action.meta,
            payload: e
        });
    }
}
function* $a448df2e4ca6f2db$export$1bc746717a3441e6(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        const url = $a448df2e4ca6f2db$export$ad6ee5dc334d3844(full_name, action.meta.environmentUuid);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "POST",
            headers: (0, $k2cPS.jsonHeaders),
            body: JSON.stringify(action.meta.variable)
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const payload = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $iyRMZ.REQUEST_CREATE_ENVIRONMENT_VARIABLE).SUCCESS,
            meta: action === null || action === void 0 ? void 0 : action.meta,
            payload: payload
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $iyRMZ.REQUEST_CREATE_ENVIRONMENT_VARIABLE).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $iyRMZ.REQUEST_CREATE_ENVIRONMENT_VARIABLE).ERROR,
            meta: action === null || action === void 0 ? void 0 : action.meta,
            payload: e
        });
    }
}
function* $a448df2e4ca6f2db$export$cb37187c8153cf10(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        var _action$meta3, _action$meta4, _action$meta4$previou;
        const url = $a448df2e4ca6f2db$export$ad6ee5dc334d3844(full_name, (_action$meta3 = action.meta) === null || _action$meta3 === void 0 ? void 0 : _action$meta3.environmentUuid, (_action$meta4 = action.meta) === null || _action$meta4 === void 0 ? void 0 : (_action$meta4$previou = _action$meta4.previousVariable) === null || _action$meta4$previou === void 0 ? void 0 : _action$meta4$previou.uuid);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "PUT",
            headers: (0, $k2cPS.jsonHeaders),
            body: JSON.stringify(action.meta.variable)
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        const payload = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $iyRMZ.REQUEST_UPDATE_ENVIRONMENT_VARIABLE).SUCCESS,
            meta: action === null || action === void 0 ? void 0 : action.meta,
            payload: payload
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $iyRMZ.REQUEST_UPDATE_ENVIRONMENT_VARIABLE).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $iyRMZ.REQUEST_UPDATE_ENVIRONMENT_VARIABLE).ERROR,
            meta: action === null || action === void 0 ? void 0 : action.meta,
            payload: e
        });
    }
}
function* $a448df2e4ca6f2db$export$e4aa7eba670c8bcb(action) {
    const { full_name: full_name } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    try {
        var _action$meta5, _action$meta6, _action$meta6$variabl;
        const url = $a448df2e4ca6f2db$export$ad6ee5dc334d3844(full_name, (_action$meta5 = action.meta) === null || _action$meta5 === void 0 ? void 0 : _action$meta5.environmentUuid, (_action$meta6 = action.meta) === null || _action$meta6 === void 0 ? void 0 : (_action$meta6$variabl = _action$meta6.variable) === null || _action$meta6$variabl === void 0 ? void 0 : _action$meta6$variabl.uuid);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, {
            method: "DELETE"
        }));
        if (!res.ok) throw new Error((yield (0, $QgM08.createErrorMessage)(res)));
        yield (0, $5NpoY.Y)({
            type: (0, $iyRMZ.REQUEST_DELETE_ENVIRONMENT_VARIABLE).SUCCESS,
            meta: action === null || action === void 0 ? void 0 : action.meta
        });
    } catch (e) {
        (0, $QgM08.capturePipelinesExceptionWithTags)(e, {
            segment: (0, $iyRMZ.REQUEST_DELETE_ENVIRONMENT_VARIABLE).ERROR
        });
        yield (0, $5NpoY.Y)({
            type: (0, $iyRMZ.REQUEST_DELETE_ENVIRONMENT_VARIABLE).ERROR,
            meta: action === null || action === void 0 ? void 0 : action.meta,
            payload: e
        });
    }
}
function* $a448df2e4ca6f2db$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLatest)((0, $iyRMZ.REQUEST_VARIABLES).REQUEST, $a448df2e4ca6f2db$export$1e852072946e2f66),
        (0, $jeUNF.takeEvery)((0, $iyRMZ.REQUEST_CREATE_VARIABLE).REQUEST, $a448df2e4ca6f2db$export$e645c0f3b2ea9b9a),
        (0, $jeUNF.takeEvery)((0, $iyRMZ.REQUEST_UPDATE_VARIABLE).REQUEST, $a448df2e4ca6f2db$export$3e538bbb2a5767c3),
        (0, $jeUNF.takeEvery)((0, $iyRMZ.REQUEST_DELETE_VARIABLE).REQUEST, $a448df2e4ca6f2db$export$8c6a63993fd97052),
        (0, $jeUNF.takeEvery)((0, $iyRMZ.REQUEST_ENVIRONMENT_VARIABLES).REQUEST, $a448df2e4ca6f2db$export$1403496b47e70932),
        (0, $jeUNF.takeEvery)((0, $iyRMZ.REQUEST_CREATE_ENVIRONMENT_VARIABLE).REQUEST, $a448df2e4ca6f2db$export$1bc746717a3441e6),
        (0, $jeUNF.takeEvery)((0, $iyRMZ.REQUEST_UPDATE_ENVIRONMENT_VARIABLE).REQUEST, $a448df2e4ca6f2db$export$cb37187c8153cf10),
        (0, $jeUNF.takeEvery)((0, $iyRMZ.REQUEST_DELETE_ENVIRONMENT_VARIABLE).REQUEST, $a448df2e4ca6f2db$export$e4aa7eba670c8bcb)
    ]);
}

});

parcelRegister("3ICW7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ba95b99a6260d9d$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $g8glp = parcelRequire("g8glp");

var $aanBq = parcelRequire("aanBq");

var $jPcDa = parcelRequire("jPcDa");

var $8K6h8 = parcelRequire("8K6h8");
function* $2ba95b99a6260d9d$export$b80489fffc5aa7de(action) {
    const { event: event, criteria: criteria } = action.payload || {};
    if (!event) return;
    const { uuid: repositoryUuid } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const socketChannel = yield (0, $5NpoY.a6)((0, $g8glp.SAGAS_CONTEXT_KEY_PIPELINES_WEBSOCKET));
    socketChannel.send(JSON.stringify({
        type: "SUBSCRIBE",
        event: event,
        criteria: {
            repositoryUuid: repositoryUuid,
            ...criteria
        },
        requestId: 0
    }));
}
function* $2ba95b99a6260d9d$export$48bbefdf75264ed6(action) {
    const { event: event, criteria: criteria } = action.payload || {};
    if (!event) return;
    const socketChannel = yield (0, $5NpoY.a6)((0, $g8glp.SAGAS_CONTEXT_KEY_PIPELINES_WEBSOCKET));
    socketChannel.send(JSON.stringify({
        type: "UNSUBSCRIBE",
        event: event,
        requestId: 0,
        ...criteria ? {
            criteria: criteria
        } : {}
    }));
}
function* $2ba95b99a6260d9d$export$5073360c4dd080f5() {
    const { uuid: repositoryUuid } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const socketChannel = yield (0, $5NpoY.a6)((0, $g8glp.SAGAS_CONTEXT_KEY_PIPELINES_WEBSOCKET));
    const subscriptions = yield (0, $5NpoY.a3)((0, $8K6h8.getWebsocketSubscriptions));
    subscriptions.forEach((subscription)=>{
        socketChannel.send(JSON.stringify({
            type: "SUBSCRIBE",
            event: subscription.event,
            criteria: {
                repositoryUuid: repositoryUuid,
                ...subscription.criteria
            },
            requestId: 0
        }));
    });
    yield (0, $5NpoY._)(subscriptions.map((subscription)=>(0, $5NpoY.Y)({
            type: subscription.event.toUpperCase(),
            ...subscription.criteria
        })));
}
function* $2ba95b99a6260d9d$export$5034799b2d7b99d0({ type: type, ...params }) {
    yield (0, $5NpoY.Y)({
        ...params,
        type: type
    });
}
function* $2ba95b99a6260d9d$export$c581890b0cbcdc8a() {
    const socketChannel = yield (0, $5NpoY.a6)((0, $g8glp.SAGAS_CONTEXT_KEY_PIPELINES_WEBSOCKET));
    yield (0, $jeUNF.takeEvery)(socketChannel, $2ba95b99a6260d9d$export$5034799b2d7b99d0);
}
function* $2ba95b99a6260d9d$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $5NpoY.P)($2ba95b99a6260d9d$export$c581890b0cbcdc8a),
        (0, $jeUNF.takeLatest)((0, $jPcDa.WEBSOCKET_SUBSCRIBE), $2ba95b99a6260d9d$export$b80489fffc5aa7de),
        (0, $jeUNF.takeLatest)((0, $jPcDa.WEBSOCKET_UNSUBSCRIBE), $2ba95b99a6260d9d$export$48bbefdf75264ed6),
        (0, $jeUNF.takeLatest)((0, $jPcDa.WEBSOCKET_RECONNECT), $2ba95b99a6260d9d$export$5073360c4dd080f5)
    ]);
}

});


parcelRegister("gxEWz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3cff1f40c33cb502$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");
parcelRequire("fe3Mu");
var $k2UuV = parcelRequire("k2UuV");
var $exHB3 = parcelRequire("exHB3");
var $1ElOF = parcelRequire("1ElOF");
var $28cQM = parcelRequire("28cQM");
var $j7nzB = parcelRequire("j7nzB");

var $1xpct = parcelRequire("1xpct");

var $1VnPK = parcelRequire("1VnPK");

var $ylGDJ = parcelRequire("ylGDJ");

var $ckxBY = parcelRequire("ckxBY");

var $9uJ93 = parcelRequire("9uJ93");

var $4u79D = parcelRequire("4u79D");
function* $3cff1f40c33cb502$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLatest)((0, $1ElOF.DELETE_BRANCH).REQUEST, (0, $ckxBY.default)),
        (0, $jeUNF.takeLatest)((0, $1ElOF.DELETE_BRANCH).SUCCESS, (0, $ckxBY.handleDeleteBranchSuccessSaga)),
        (0, $jeUNF.takeLatest)((0, $1ElOF.DELETE_BRANCH).ERROR, (0, $ckxBY.handleDeleteBranchErrorSaga)),
        (0, $jeUNF.takeLatest)((0, $exHB3.COMPARE_BRANCHES).REQUEST, (0, $ylGDJ.default)),
        (0, $jeUNF.takeLatest)((0, $exHB3.COMPARE_BRANCHES).SUCCESS, (0, $ylGDJ.handleCompareSuccessSaga)),
        (0, $jeUNF.takeLatest)((0, $exHB3.COMPARE_BRANCHES).ERROR, (0, $ylGDJ.handleCompareErrorSaga)),
        (0, $jeUNF.takeLatest)((0, $exHB3.COMPARE_BRANCHES_POLL_STATUS).REQUEST, (0, $ylGDJ.compareBranchesPollStatusSaga)),
        (0, $jeUNF.takeLatest)((0, $exHB3.COMPARE_BRANCHES_POLL_STATUS).SUCCESS, (0, $ylGDJ.handlePollSuccessSaga)),
        (0, $jeUNF.takeLatest)((0, $exHB3.COMPARE_BRANCHES_POLL_STATUS).ERROR, (0, $ylGDJ.handleCompareErrorSaga)),
        (0, $jeUNF.takeLatest)((0, $exHB3.COMPARE_BRANCHES_POLL_STATUS_TIMEOUT), (0, $ylGDJ.handlePollTimeoutSaga)),
        (0, $jeUNF.takeLatest)((0, $28cQM.FETCH_DEFAULT_COMMIT_MESSAGE).REQUEST, (0, $9uJ93.default)),
        (0, $1xpct.loadBranchesStatusWatcher)(),
        (0, $jeUNF.takeLatest)((0, $j7nzB.RELOAD_BRANCHES), (0, $4u79D.default)),
        (0, $jeUNF.takeLatest)((0, $k2UuV.TOGGLE_BRANCH_SELECT).ALL_IN_PAGE, (0, $1VnPK.toggleSelectAllSaga)),
        (0, $jeUNF.takeLatest)((0, $k2UuV.TOGGLE_BRANCH_SELECT).ONE, (0, $1VnPK.toggleSelectOneSaga)),
        (0, $jeUNF.takeLatest)((0, $k2UuV.BULK_DELETE_BRANCHES).REQUEST, (0, $1VnPK.bulkDeleteBranchesSaga)),
        (0, $jeUNF.takeLatest)((0, $k2UuV.BULK_DELETE_BRANCHES).SUCCESS, (0, $1VnPK.handleBulkDeleteBranchesSuccessSaga)),
        (0, $jeUNF.takeLatest)((0, $k2UuV.BULK_DELETE_BRANCHES).ERROR, (0, $1VnPK.handleBulkDeleteBranchesErrorSaga))
    ]);
}

});
parcelRegister("1xpct", function(module, exports) {

$parcel$export(module.exports, "loadBranchesStatusWatcher", function () { return $74c5834c51325ded$export$6ca3ef7dd873eb60; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $aanBq = parcelRequire("aanBq");

var $4oBYE = parcelRequire("4oBYE");

var $k2cPS = parcelRequire("k2cPS");

var $26wAJ = parcelRequire("26wAJ");
parcelRequire("fe3Mu");
var $j7nzB = parcelRequire("j7nzB");

var $5JXyS = parcelRequire("5JXyS");

var $4cfLu = parcelRequire("4cfLu");
function $74c5834c51325ded$export$39a4509fe32a0ce1(statuses) {
    return (branch)=>{
        const status = statuses[(0, $26wAJ.short12Hash)(branch.target.hash)];
        return {
            ...branch,
            status_counts: status && status.status_counts
        };
    };
}
function* $74c5834c51325ded$export$96e98c646e260a4d() {
    // @ts-ignore
    const allBranches = yield (0, $5NpoY.a3)((0, $4cfLu.getAllBranches));
    const repoFullSlug = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryFullSlug));
    const url = (0, $4oBYE.default).api.internal.commitsBuildStatuses(repoFullSlug);
    try {
        const request = (0, $k2cPS.default)(url, {
            method: "POST",
            body: allBranches// @ts-ignore TODO: fix noImplicitAny error here
            .map((branch)=>`commits=${branch.target.hash}`).join("&"),
            headers: {
                "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
            }
        });
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            // @ts-ignore
            const statuses = yield response.json();
            if (Object.keys(statuses).length === 0) return;
            const updatedBranches = allBranches.map($74c5834c51325ded$export$39a4509fe32a0ce1(statuses));
            // normalizr will handle this action
            yield (0, $5NpoY.Y)({
                type: "branches/update-branches-with-build-status",
                payload: updatedBranches,
                meta: {
                    schema: [
                        (0, $5JXyS.branch)
                    ]
                }
            });
        }
    } catch (e) {
    // Silently fail for now
    }
}
function* $74c5834c51325ded$export$6ca3ef7dd873eb60() {
    while(true){
        // @ts-ignore
        const mainBranch = yield (0, $5NpoY.a3)((0, $4cfLu.getMainBranch));
        const actions = [
            (0, $j7nzB.LOAD_BRANCHES).SUCCESS
        ];
        if (!mainBranch) actions.push((0, $j7nzB.LOAD_MAIN_BRANCH).SUCCESS);
        yield (0, $5NpoY._)(actions.map((action)=>(0, $5NpoY.M)(action)));
        yield* $74c5834c51325ded$export$96e98c646e260a4d();
    }
}

});
parcelRegister("26wAJ", function(module, exports) {

$parcel$export(module.exports, "shortHash", function () { return $4ad9050041fc1033$export$243e7ec9385096f0; });
$parcel$export(module.exports, "short12Hash", function () { return $4ad9050041fc1033$export$4013200335cdc452; });
$parcel$export(module.exports, "hashCompare", function () { return $4ad9050041fc1033$export$850014183e852c8a; });
const $4ad9050041fc1033$export$243e7ec9385096f0 = (hash)=>hash.slice(0, 7);
const $4ad9050041fc1033$export$4013200335cdc452 = (hash)=>hash.slice(0, 12);
const $4ad9050041fc1033$export$850014183e852c8a = (hash1, hash2)=>$4ad9050041fc1033$export$243e7ec9385096f0(hash1) === $4ad9050041fc1033$export$243e7ec9385096f0(hash2);

});


parcelRegister("1VnPK", function(module, exports) {

$parcel$export(module.exports, "toggleSelectAllSaga", function () { return $108ece9d61b5eda5$export$b980796711d3ccea; });
$parcel$export(module.exports, "toggleSelectOneSaga", function () { return $108ece9d61b5eda5$export$5ee7a1ec70a13cb2; });
$parcel$export(module.exports, "bulkDeleteBranchesSaga", function () { return $108ece9d61b5eda5$export$b23def5e5a2f673; });
$parcel$export(module.exports, "handleBulkDeleteBranchesSuccessSaga", function () { return $108ece9d61b5eda5$export$d6b91573a7d42bb0; });
$parcel$export(module.exports, "handleBulkDeleteBranchesErrorSaga", function () { return $108ece9d61b5eda5$export$5c44a3893d17777d; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $3XbtU = parcelRequire("3XbtU");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $2kKDW = parcelRequire("2kKDW");

var $j07oi = parcelRequire("j07oi");

var $kZnTB = parcelRequire("kZnTB");

var $aanBq = parcelRequire("aanBq");

var $6aoKW = parcelRequire("6aoKW");

var $k2cPS = parcelRequire("k2cPS");

var $628YF = parcelRequire("628YF");
parcelRequire("fe3Mu");
var $k2UuV = parcelRequire("k2UuV");

var $4cfLu = parcelRequire("4cfLu");

var $7nqQH = parcelRequire("7nqQH");

var $4u79D = parcelRequire("4u79D");
function* $108ece9d61b5eda5$export$b980796711d3ccea({ payload: selectAllEnabled }) {
    const branches = yield (0, $5NpoY.a3)((0, $4cfLu.getAllBranches));
    const branchingModel = yield (0, $5NpoY.a3)((0, $4cfLu.getBranchingModel));
    let selectedBranches = yield (0, $5NpoY.a3)((0, $4cfLu.getSelectedBranches));
    // Copy them so that we don't end up mutating the state.
    selectedBranches = [
        ...selectedBranches
    ];
    branches.forEach((branch)=>{
        const selectedIndex = selectedBranches.findIndex((br)=>br.name === branch.name);
        const isSelected = selectedIndex >= 0;
        if (selectAllEnabled && !isSelected) {
            if ((0, $7nqQH.shouldAllowBulkDelete)(branch, branchingModel)) selectedBranches.push(branch);
        } else if (!selectAllEnabled && isSelected) {
            if (isSelected) selectedBranches.splice(selectedIndex, 1);
        }
    });
    yield (0, $5NpoY.Y)((0, $k2UuV.onToggleBranchSelectSave)(selectedBranches));
}
function* $108ece9d61b5eda5$export$5ee7a1ec70a13cb2({ payload: branch }) {
    let selectedBranches = yield (0, $5NpoY.a3)((0, $4cfLu.getSelectedBranches));
    if (selectedBranches.find((br)=>br.name === branch.name)) selectedBranches = selectedBranches.filter((br)=>br.name !== branch.name);
    else selectedBranches = [
        ...selectedBranches,
        branch
    ];
    yield (0, $5NpoY.Y)((0, $k2UuV.onToggleBranchSelectSave)(selectedBranches));
}
function* $108ece9d61b5eda5$export$b23def5e5a2f673() {
    const selectedBranches = yield (0, $5NpoY.a3)((0, $4cfLu.getSelectedBranches));
    const fullSlug = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryFullSlug));
    const url = (0, $kZnTB.default).api.internal.bulkDeleteBranches(fullSlug);
    const request = (0, $k2cPS.default)(url, {
        method: "POST",
        headers: (0, $k2cPS.jsonHeaders),
        body: JSON.stringify({
            names: selectedBranches.map((br)=>br.name)
        })
    });
    try {
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            yield (0, $5NpoY.Y)({
                type: (0, $k2UuV.BULK_DELETE_BRANCHES).SUCCESS
            });
            (0, $6aoKW.publishTrackEvent)({
                action: "deleted",
                actionSubject: "branches",
                actionSubjectId: "deleteMultipleBranches",
                source: "branchesScreen",
                attributes: {
                    count: selectedBranches.length
                }
            });
        } else {
            yield (0, $628YF.captureMessageForResponse)(response, "Bulk deleting branches failed");
            yield (0, $5NpoY.Y)({
                type: (0, $k2UuV.BULK_DELETE_BRANCHES).ERROR
            });
        }
    } catch (error) {
        $3XbtU.captureException(error);
        yield (0, $5NpoY.Y)({
            type: (0, $k2UuV.BULK_DELETE_BRANCHES).ERROR
        });
    }
}
function* $108ece9d61b5eda5$export$d6b91573a7d42bb0() {
    yield (0, $5NpoY.Y)((0, $k2UuV.closeBulkDeleteBranchesDialog)());
    yield (0, $5NpoY.Y)((0, $k2UuV.clearSelectedBranches)());
    yield (0, $5NpoY.Y)((0, $k2UuV.onToggleBulkDeleteSelectionMode)(false));
    yield* (0, $4u79D.default)();
    yield (0, $5NpoY.Y)((0, $2kKDW.showFlag)({
        title: {
            msg: (0, $j07oi.default).deleteSuccessTitle
        },
        description: {
            msg: (0, $j07oi.default).deleteSuccessDescription
        },
        id: "bulk-delete-branches-success",
        iconType: "success",
        autoDismiss: true
    }));
}
function* $108ece9d61b5eda5$export$5c44a3893d17777d() {
    yield (0, $5NpoY.Y)((0, $k2UuV.closeBulkDeleteBranchesDialog)());
    yield (0, $5NpoY.Y)((0, $2kKDW.showFlag)({
        title: {
            msg: (0, $j07oi.default).deleteFailedTitle
        },
        description: {
            msg: (0, $j07oi.default).deleteFailedDescription
        },
        id: "bulk-delete-branches-error",
        iconType: "error",
        autoDismiss: true
    }));
}

});
parcelRegister("j07oi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6608d2d9d74584c2$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $6608d2d9d74584c2$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    cancelButton: {
        "id": "frontbucket.branches.bulkDeleteBranchesDialog.cancelButton",
        "defaultMessage": "Cancel"
    },
    dialogTitle: {
        "id": "frontbucket.branches.bulkDeleteBranches.dialogTitle",
        "defaultMessage": "Delete branches"
    },
    dialogDescription: {
        "id": "frontbucket.branches.bulkDeleteBranches.dialogDescription",
        "defaultMessage": "Are you sure you want to delete the selected branches?"
    },
    deleteButton: {
        "id": "frontbucket.branches.bulkDeleteBranches.deleteButton",
        "defaultMessage": "Delete"
    },
    showBranchesToBeDeletedHeader: {
        "id": "frontbucket.branches.bulkDeleteBranches.showBranchesToBeDeletedHeader",
        "defaultMessage": "Branches about to be deleted"
    },
    deleteSuccessTitle: {
        "id": "frontbucket.branches.bulkDeleteBranches.deleteSuccessTitle",
        "defaultMessage": "Deleted successfully"
    },
    deleteSuccessDescription: {
        "id": "frontbucket.branches.bulkDeleteBranches.deleteSuccessDescription",
        "defaultMessage": "All the selected branches have been deleted successfully."
    },
    deleteFailedTitle: {
        "id": "frontbucket.branches.bulkDeleteBranches.deleteFailedTitle",
        "defaultMessage": "Failed to delete branches"
    },
    deleteFailedDescription: {
        "id": "frontbucket.branches.bulkDeleteBranches.deleteFailedDescription",
        "defaultMessage": "We have failed to delete the selected branches. Please try again!"
    }
});

});

parcelRegister("7nqQH", function(module, exports) {

$parcel$export(module.exports, "shouldAllowBulkDelete", function () { return $3591d13841a78601$export$170edf22d58fbc1e; });
const $3591d13841a78601$export$170edf22d58fbc1e = (branch, branchingModel)=>{
    var _branchingModel$produ, _branchingModel$devel;
    const { isMainBranch: isMainBranch, permissions: permissions } = branch;
    if (isMainBranch) return false;
    else if (permissions.delete !== "allow") return false;
    else if (branch.name === ((_branchingModel$produ = branchingModel.production) === null || _branchingModel$produ === void 0 ? void 0 : _branchingModel$produ.name)) return false;
    else if (branch.name === ((_branchingModel$devel = branchingModel.development) === null || _branchingModel$devel === void 0 ? void 0 : _branchingModel$devel.name)) return false;
    else if (branch.pullRequests.length > 0 || branch.pullRequestsTargetedCount > 0) return false;
    return true;
};

});

parcelRegister("4u79D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a68e82fec416d54$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $cJH1T = parcelRequire("cJH1T");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("fojQl");
var $4cfLu = parcelRequire("4cfLu");
var $j7nzB = parcelRequire("j7nzB");
function* $3a68e82fec416d54$export$2e2bcd8739ae039() {
    const fullUrl = yield (0, $5NpoY.a3)((0, $4cfLu.getBranchListReloadUrl));
    const [url, query] = fullUrl.split("?");
    const params = (0, $cJH1T.parse)(query);
    const nextQuery = (0, $cJH1T.stringify)({
        ...params,
        cacheBust: Date.now()
    }, {
        skipNulls: true
    });
    yield (0, $5NpoY.Y)((0, $j7nzB.reloadBranches)(`${url}?${nextQuery}`));
}

});


parcelRegister("ylGDJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $674300f85650123a$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "compareBranchesPollStatusSaga", function () { return $674300f85650123a$export$cdf897afff19d4dd; });
$parcel$export(module.exports, "handleCompareSuccessSaga", function () { return $674300f85650123a$export$5306c970b3fe4937; });
$parcel$export(module.exports, "handlePollSuccessSaga", function () { return $674300f85650123a$export$327f648fe4ea1f6c; });
$parcel$export(module.exports, "handlePollTimeoutSaga", function () { return $674300f85650123a$export$4597bbff55972dca; });
$parcel$export(module.exports, "handleCompareErrorSaga", function () { return $674300f85650123a$export$705a2f61cf22918; });

var $cJH1T = parcelRequire("cJH1T");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $2kKDW = parcelRequire("2kKDW");

var $kZnTB = parcelRequire("kZnTB");

var $3UXCH = parcelRequire("3UXCH");

var $k2cPS = parcelRequire("k2cPS");
parcelRequire("fe3Mu");
var $exHB3 = parcelRequire("exHB3");

var $4cfLu = parcelRequire("4cfLu");
function* $674300f85650123a$export$2e2bcd8739ae039(action) {
    const { isMerge: isMerge, sourceBranchName: sourceBranchName, destinationBranchName: destinationBranchName, sourceRepositoryFullName: sourceRepositoryFullName, destinationRepositoryFullName: destinationRepositoryFullName } = yield (0, $5NpoY.a3)((0, $4cfLu.getCompareBranchesDialogSlice));
    const { commitMessage: commitMessage, closeBranch: closeBranch, strategy: strategy } = action.payload;
    const isRebaseSyncEnabled = yield (0, $5NpoY.a3)((0, $3UXCH.getRebaseSyncEnabled));
    let body = {
        commit_message: commitMessage,
        close_branch: closeBranch,
        source: `${sourceRepositoryFullName}::${sourceBranchName}`,
        dest: `${destinationRepositoryFullName}::${destinationBranchName}`,
        event: isMerge && strategy ? "list:merge" : "list:sync"
    };
    if (isMerge && strategy) body = {
        ...body,
        merge_strategy: strategy
    };
    else if (isRebaseSyncEnabled) body = {
        ...body,
        sync_strategy: strategy
    };
    const url = (0, $kZnTB.default).api.internal.compare(destinationRepositoryFullName);
    const request = {
        method: "POST",
        body: (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(body, {
            skipNulls: true
        }),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
    };
    try {
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url, request));
        if (!res.ok) throw new Error(res.statusText);
        // @ts-ignore
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $exHB3.COMPARE_BRANCHES).SUCCESS,
            payload: data
        });
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $exHB3.COMPARE_BRANCHES).ERROR,
            payload: e
        });
    }
}
const $674300f85650123a$export$7545f7309ff70c02 = 60;
function* $674300f85650123a$export$cdf897afff19d4dd(action) {
    try {
        let status = {};
        let i = 0;
        while(!status.complete && i < $674300f85650123a$export$7545f7309ff70c02){
            const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(action.payload.url));
            if (!res.ok) throw new Error(res.statusText);
            status = yield (0, $5NpoY.P)([
                res,
                "json"
            ]);
            i++;
            if (!status.complete) {
                const delayTimeout = Math.min(Math.max(250 * i, 1000), 5000);
                yield (0, $5NpoY.S)(delayTimeout);
            }
        }
        if (status.error) {
            yield (0, $5NpoY.Y)({
                type: (0, $exHB3.COMPARE_BRANCHES_POLL_STATUS).ERROR,
                payload: status.error
            });
            return;
        }
        if (!status.complete) {
            yield (0, $5NpoY.Y)({
                type: (0, $exHB3.COMPARE_BRANCHES_POLL_STATUS_TIMEOUT)
            });
            return;
        }
        yield (0, $5NpoY.Y)({
            type: (0, $exHB3.COMPARE_BRANCHES_POLL_STATUS).SUCCESS,
            payload: status
        });
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $exHB3.COMPARE_BRANCHES_POLL_STATUS).ERROR
        });
    }
}
function* $674300f85650123a$export$5306c970b3fe4937(action) {
    yield (0, $5NpoY.Y)((0, $exHB3.compareBranchesPollStatus)(action.payload));
}
function* $674300f85650123a$export$327f648fe4ea1f6c(action) {
    var _action$payload;
    yield (0, $5NpoY.Y)((0, $exHB3.closeCompareBranchesDialog)());
    const { reloadAction: reloadAction, renderFlagOnSuccess: renderFlagOnSuccess } = yield (0, $5NpoY.a3)((0, $4cfLu.getCompareBranchesDialogSlice));
    if (reloadAction) yield (0, $5NpoY.Y)(reloadAction);
    if (renderFlagOnSuccess) yield (0, $5NpoY.Y)((0, $2kKDW.showFlagComponent)("compare-branches-success"));
    else if (action !== null && action !== void 0 && (_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.url) location.assign(action.payload.url);
}
function* $674300f85650123a$export$4597bbff55972dca() {
    yield (0, $5NpoY.Y)((0, $exHB3.closeCompareBranchesDialog)());
    yield (0, $5NpoY.Y)((0, $2kKDW.showFlagComponent)("compare-branches-timeout"));
}
function* $674300f85650123a$export$705a2f61cf22918() {
    yield (0, $5NpoY.Y)((0, $exHB3.closeCompareBranchesDialog)());
    yield (0, $5NpoY.Y)((0, $2kKDW.showFlagComponent)("compare-branches-error"));
}

});

parcelRegister("ckxBY", function(module, exports) {

$parcel$export(module.exports, "getErrorType", function () { return $c0b27d19bc512db6$export$e19f9f08a6d79fd2; });
$parcel$export(module.exports, "default", function () { return $c0b27d19bc512db6$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "handleDeleteBranchSuccessSaga", function () { return $c0b27d19bc512db6$export$a3e42fe7a7f6ac56; });
$parcel$export(module.exports, "handleDeleteBranchErrorSaga", function () { return $c0b27d19bc512db6$export$fd15cd7be5627a82; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $2kKDW = parcelRequire("2kKDW");

var $kZnTB = parcelRequire("kZnTB");

var $aanBq = parcelRequire("aanBq");

var $9H597 = parcelRequire("9H597");

var $k2cPS = parcelRequire("k2cPS");
parcelRequire("fojQl");
var $1ElOF = parcelRequire("1ElOF");
var $4cfLu = parcelRequire("4cfLu");

var $pUQWs = parcelRequire("pUQWs");

var $4u79D = parcelRequire("4u79D");
const $c0b27d19bc512db6$export$e19f9f08a6d79fd2 = (status)=>{
    switch(status){
        case 404:
            return (0, $pUQWs.DeleteBranchErrorTypes).BRANCH_NOT_FOUND;
        case 403:
            return (0, $pUQWs.DeleteBranchErrorTypes).ACCESS_DENIED;
        default:
            return (0, $pUQWs.DeleteBranchErrorTypes).GENERIC;
    }
};
function* $c0b27d19bc512db6$export$2e2bcd8739ae039() {
    const slug = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositorySlug));
    const owner = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryOwnerName));
    // @ts-ignore
    const branch = yield (0, $5NpoY.a3)((0, $4cfLu.getDeleteBranchDialogBranch));
    const branchName = branch.name;
    const url = `${(0, $kZnTB.default).api.v20.branches(owner, slug)}/${(0, $9H597.encodeBranchName)(branch.name)}`;
    const request = (0, $k2cPS.default)(url, {
        method: "DELETE"
    });
    try {
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) yield (0, $5NpoY.Y)({
            type: (0, $1ElOF.DELETE_BRANCH).SUCCESS,
            payload: {
                branch: branch,
                branchName: branch.name
            }
        });
        else {
            const errorType = $c0b27d19bc512db6$export$e19f9f08a6d79fd2(response.status);
            yield (0, $5NpoY.Y)({
                type: (0, $1ElOF.DELETE_BRANCH).ERROR,
                payload: {
                    branchName: branchName,
                    errorType: errorType
                }
            });
        }
    } catch (error) {
        yield (0, $5NpoY.Y)({
            type: (0, $1ElOF.DELETE_BRANCH).ERROR,
            payload: {
                branchName: branchName,
                errorType: (0, $pUQWs.DeleteBranchErrorTypes).GENERIC
            }
        });
    }
}
function* $c0b27d19bc512db6$export$a3e42fe7a7f6ac56() {
    yield (0, $5NpoY.Y)((0, $2kKDW.showFlagComponent)("delete-branch-success"));
    yield* (0, $4u79D.default)();
}
function* $c0b27d19bc512db6$export$fd15cd7be5627a82() {
    yield (0, $5NpoY.Y)((0, $2kKDW.showFlagComponent)("delete-branch-error"));
}

});

parcelRegister("9uJ93", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80eef897a4172fd3$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $kZnTB = parcelRequire("kZnTB");

var $aanBq = parcelRequire("aanBq");

var $k2cPS = parcelRequire("k2cPS");
parcelRequire("fe3Mu");
var $28cQM = parcelRequire("28cQM");
function* $80eef897a4172fd3$export$2e2bcd8739ae039(action) {
    const repositoryFullName = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryFullSlug));
    const { sourceBranchName: sourceBranchName, destinationBranchName: destinationBranchName, mergeStrategy: mergeStrategy } = action.payload;
    try {
        const url = (0, $kZnTB.default).api.internal.defaultCommitMsg(repositoryFullName, mergeStrategy, sourceBranchName, destinationBranchName);
        const res = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!res.ok) throw new Error(res.statusText);
        // @ts-ignore
        const data = yield (0, $5NpoY.P)([
            res,
            "json"
        ]);
        yield (0, $5NpoY.Y)({
            type: (0, $28cQM.FETCH_DEFAULT_COMMIT_MESSAGE).SUCCESS,
            payload: data
        });
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $28cQM.FETCH_DEFAULT_COMMIT_MESSAGE).ERROR,
            payload: e
        });
    }
}

});


parcelRegister("fEpUk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40d4b190c31d5281$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $aanBq = parcelRequire("aanBq");

var $4oBYE = parcelRequire("4oBYE");

var $k2cPS = parcelRequire("k2cPS");

var $26wAJ = parcelRequire("26wAJ");

var $8aZB9 = parcelRequire("8aZB9");

var $d5yyK = parcelRequire("d5yyK");
function $40d4b190c31d5281$var$createCommitStatusMapper(statuses) {
    return (commit)=>{
        const status = statuses[(0, $26wAJ.short12Hash)(commit.hash)];
        return {
            ...commit,
            extra: {
                ...commit.extra,
                builds: status ? [
                    status.commit_status
                ] : [],
                status_counts: status ? status.status_counts : undefined
            }
        };
    };
}
function* $40d4b190c31d5281$export$fefc0999848213f5() {
    const commits = yield (0, $5NpoY.a3)((0, $8aZB9.getCurrentCommits));
    if (!commits.length) return;
    const { full_name: fullName } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const url = (0, $4oBYE.default).api.internal.commitsBuildStatuses(fullName);
    try {
        const request = (0, $k2cPS.default)(url, {
            method: "POST",
            body: commits.map((commit)=>`commits=${commit.hash}`).join("&"),
            headers: {
                "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
            }
        });
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            // @ts-ignore
            const statuses = yield response.json();
            if (Object.keys(statuses).length === 0) return;
            const addStatus = $40d4b190c31d5281$var$createCommitStatusMapper(statuses);
            yield (0, $5NpoY.Y)({
                type: (0, $d5yyK.UPDATE_COMMITS),
                payload: commits.map(addStatus)
            });
        }
    } catch (e) {
    // Silently fail for now
    }
}
function* $40d4b190c31d5281$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLatest)((0, $d5yyK.LoadCommits).SUCCESS, $40d4b190c31d5281$export$fefc0999848213f5)
    ]);
}

});

parcelRegister("ftQUc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40edc4e4a5779c7b$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");
parcelRequire("9waDg");
var $1kvgs = parcelRequire("1kvgs");

var $eyYY0 = parcelRequire("eyYY0");
function* $40edc4e4a5779c7b$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLatest)((0, $1kvgs.FETCH_REF_OPTIONS).REQUEST, (0, $eyYY0.selectDataAndFetchRefOptionsSaga)),
        (0, $jeUNF.takeLatest)((0, $1kvgs.FETCH_COMMIT_STATUSES).REQUEST, (0, $eyYY0.fetchCommitStatusesSaga)),
        (0, $jeUNF.takeLatest)((0, $1kvgs.FETCH_BRANCHING_MODEL).REQUEST, (0, $eyYY0.fetchBranchingModelSaga)),
        (0, $jeUNF.takeLatest)((0, $1kvgs.CREATE_BRANCH).REQUEST, (0, $eyYY0.createBranchSaga)),
        (0, $jeUNF.takeLatest)((0, $1kvgs.CHANGE_REPOSITORY), (0, $eyYY0.handleChangeRepositorySaga)),
        (0, $jeUNF.takeLatest)((0, $1kvgs.SET_CURRENT_REPOSITORY), (0, $eyYY0.setCurrentRepositorySaga)),
        (0, $jeUNF.takeLatest)((0, $1kvgs.LOAD_REPOSITORIES).SUCCESS, (0, $eyYY0.handleLoadRepositoriesSuccessSaga)),
        (0, $jeUNF.takeLatest)((0, $1kvgs.LOAD_REPOSITORIES).ERROR, (0, $eyYY0.handleLoadRepositoriesErrorSaga)),
        (0, $eyYY0.suggestFromBranchSaga)()
    ]);
}

});
parcelRegister("eyYY0", function(module, exports) {

$parcel$export(module.exports, "createBranchSaga", function () { return $7db64b86f19cdf31$export$671a095e88a3815e; });
$parcel$export(module.exports, "selectDataAndFetchRefOptionsSaga", function () { return $7db64b86f19cdf31$export$d87bf7785834e53b; });
$parcel$export(module.exports, "fetchCommitStatusesSaga", function () { return $7db64b86f19cdf31$export$af522b996a9c591e; });
$parcel$export(module.exports, "fetchBranchingModelSaga", function () { return $7db64b86f19cdf31$export$22fa971c9a866389; });
$parcel$export(module.exports, "handleChangeRepositorySaga", function () { return $7db64b86f19cdf31$export$61671dcbac770c72; });
$parcel$export(module.exports, "setCurrentRepositorySaga", function () { return $7db64b86f19cdf31$export$305ee53869f1d041; });
$parcel$export(module.exports, "handleLoadRepositoriesSuccessSaga", function () { return $7db64b86f19cdf31$export$82f6c515edb88e7a; });
$parcel$export(module.exports, "handleLoadRepositoriesErrorSaga", function () { return $7db64b86f19cdf31$export$251f5f26b614999a; });
$parcel$export(module.exports, "suggestFromBranchSaga", function () { return $7db64b86f19cdf31$export$2fbc1fab5e349f87; });

var $3XbtU = parcelRequire("3XbtU");
var $i3ov7 = parcelRequire("i3ov7");

var $l4v9F = parcelRequire("l4v9F");

var $cJH1T = parcelRequire("cJH1T");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $2kKDW = parcelRequire("2kKDW");

var $5gF7V = parcelRequire("5gF7V");

var $683bT = parcelRequire("683bT");

var $abRa1 = parcelRequire("abRa1");

var $f0vcS = parcelRequire("f0vcS");

var $eO3IF = parcelRequire("eO3IF");

var $lUW6w = parcelRequire("lUW6w");

var $kZnTB = parcelRequire("kZnTB");

var $aanBq = parcelRequire("aanBq");

var $g2R3c = parcelRequire("g2R3c");

var $k2cPS = parcelRequire("k2cPS");

var $j9gxd = parcelRequire("j9gxd");
parcelRequire("9waDg");
var $1kvgs = parcelRequire("1kvgs");

var $gyx4R = parcelRequire("gyx4R");
const $7db64b86f19cdf31$var$getErrorType = (status, errorKey, message)=>{
    if (status >= 500 || !errorKey || !message) return (0, $5gF7V.CREATE_BRANCH_ERROR_TYPE).GENERIC;
    // @ts-ignore TODO: fix noImplicitAny error here
    return (0, $5gF7V.CREATE_BRANCH_ERROR_TYPE)[errorKey] || (0, $5gF7V.CREATE_BRANCH_ERROR_TYPE).OTHER;
};
const $7db64b86f19cdf31$var$getRepositoryForJiraIssueUserPrefKey = (issue)=>`create-branch:repo-for-jira-project-${issue.project}`;
function $7db64b86f19cdf31$export$710f1aadf8aedc76(href) {
    window.location.assign(href);
}
function* $7db64b86f19cdf31$export$cdeaa536a091c765(createFrom, branch, targetBranchName) {
    // Once the branch page is a SPA, we will also
    // want to show the "create branch success" flag
    // here after redirecting the user.
    if (createFrom === (0, $5gF7V.CREATE_FROM).REPO_DIALOG) yield (0, $5NpoY.Y)((0, $1kvgs.closeCreateBranchRepoDialog)());
    else if (createFrom === (0, $5gF7V.CREATE_FROM).GLOBAL_DIALOG) yield (0, $5NpoY.Y)((0, $1kvgs.closeCreateBranchGlobalDialog)());
    // Store the preferred repository for the issue project in user preferences
    if ([
        (0, $5gF7V.CREATE_FROM).GLOBAL_DIALOG,
        (0, $5gF7V.CREATE_FROM).GLOBAL_PAGE
    ].includes(createFrom)) {
        const issue = yield (0, $5NpoY.a3)((0, $gyx4R.getJiraIssue));
        if (issue) {
            const prefsKey = $7db64b86f19cdf31$var$getRepositoryForJiraIssueUserPrefKey(issue);
            if (prefsKey) {
                const currentUser = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
                const { selected: selected } = yield (0, $5NpoY.a3)((0, $gyx4R.getRepositorySelectorState));
                try {
                    yield (0, $5NpoY.P)((0, $j9gxd.default).set, currentUser.uuid, prefsKey, selected.value);
                } catch  {
                    $3XbtU.captureException("Failed to save the preferred repo for issue");
                }
            }
        }
    }
    const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
        dest: targetBranchName
    });
    yield $7db64b86f19cdf31$export$710f1aadf8aedc76(`${branch.links.html.href}?${queryParams}`);
}
function* $7db64b86f19cdf31$export$3919f700bb272836() {
    yield (0, $5NpoY.Y)({
        type: (0, $1kvgs.FETCH_BRANCHING_MODEL).ERROR
    });
    /**
   *  this error flag is stateless and
   *  auto-dismiss disable
   * */ yield (0, $5NpoY.Y)((0, $2kKDW.showFlag)({
        id: (0, $1kvgs.FETCH_BRANCHING_MODEL).ERROR,
        iconType: "warning",
        title: {
            msg: (0, $f0vcS.default).branchingModelsLoadingErrorTitle
        },
        description: {
            msg: (0, $f0vcS.default).branchingModelsLoadingErrorDescription
        }
    }));
}
function* $7db64b86f19cdf31$export$6b2bdabb41f3d80b(error) {
    yield (0, $5NpoY.Y)({
        type: (0, $1kvgs.CREATE_BRANCH).ERROR,
        payload: error
    });
    yield (0, $5NpoY.Y)((0, $2kKDW.showFlagComponent)("create-branch-error"));
}
function* $7db64b86f19cdf31$export$671a095e88a3815e(action) {
    // eslint-disable-next-line prefer-destructuring
    const payload = action.payload;
    const params = yield (0, $5NpoY.a3)((0, $gyx4R.getCreateBranchParams));
    const [owner, slug] = yield (0, $5NpoY.a3)((0, $gyx4R.getSelectedRepoOwnerAndSlug));
    const branchType = yield (0, $5NpoY.a3)((0, $gyx4R.getSelectedBranchType));
    const branchTypeVisible = yield (0, $5NpoY.a3)((0, $gyx4R.getBranchTypesVisible));
    const jiraIssue = yield (0, $5NpoY.a3)((0, $gyx4R.getJiraIssue));
    const url = (0, $kZnTB.default).api.v20.branches(owner, slug);
    const targetBranch = params.target;
    if (!targetBranch) {
        $3XbtU.captureMessage(`Tried to create branch but could not find target branch data`, $i3ov7.Severity.Error);
        yield (0, $5NpoY.P)($7db64b86f19cdf31$export$6b2bdabb41f3d80b, {
            type: (0, $5gF7V.CREATE_BRANCH_ERROR_TYPE).BRANCH_PARAMS_MISSING
        });
        return;
    }
    const body = JSON.stringify({
        name: (0, $abRa1.generateBranchName)(params.name, branchType),
        target: {
            hash: targetBranch.hash
        }
    });
    const headers = {
        ...(0, $k2cPS.jsonHeaders),
        "X-Bitbucket-ScreenName": payload.createFrom,
        // urlencode branch name because it can contain non-latin1 characters which are problematic in headers
        "X-Bitbucket-SourceBranch": encodeURIComponent(targetBranch.name)
    };
    if (branchTypeVisible) headers["X-Bitbucket-BranchType"] = branchType ? branchType.kind : (0, $5gF7V.EXTENDED_BRANCH_KINDS).OTHER;
    if (jiraIssue) headers["X-Bitbucket-JiraIssueType"] = (0, $683bT.getJiraIssueTypeForAnalytics)(jiraIssue);
    const request = (0, $k2cPS.default)(url, {
        method: "POST",
        body: body,
        headers: headers
    });
    try {
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            // @ts-ignore
            const branch = yield response.json();
            yield (0, $5NpoY.P)($7db64b86f19cdf31$export$cdeaa536a091c765, action.payload.createFrom, branch, targetBranch.name);
        } else {
            const { error: error } = yield response.json();
            const errorType = $7db64b86f19cdf31$var$getErrorType(response.status, error.data && error.data.key, error.message);
            yield (0, $5NpoY.P)($7db64b86f19cdf31$export$6b2bdabb41f3d80b, {
                type: errorType,
                message: error.message
            });
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.P)($7db64b86f19cdf31$export$6b2bdabb41f3d80b, {
            type: (0, $5gF7V.CREATE_BRANCH_ERROR_TYPE).GENERIC
        });
    }
}
function* $7db64b86f19cdf31$export$a9d980742002e5fe({ // @ts-ignore TODO: fix noImplicitAny error here
payload: { search: search, mainBranch: mainBranch, repositoryFullSlug: repositoryFullSlug } }) {
    // If a search query is not provided, we will fetch branches in one request
    // If a search query is provided, we will fetch branches in two requests
    // - First request fetches the exact match from the filter
    // - Second request fetches similar matches from the filter
    const urls = (0, $eO3IF.buildRefUrls)(repositoryFullSlug, "all", search || "");
    try {
        // Since branches can be fetched in 1 or 2 requests, we can use this object
        // to join the results for each request
        let res = {
            success: true,
            values: [],
            next: ""
        };
        for (const url of urls){
            const request = (0, $k2cPS.default)(url);
            const response = yield (0, $5NpoY.P)(fetch, request);
            if (response.ok) {
                // @ts-ignore
                const result = yield response.json();
                // Combine each request's list of branches
                res.values = res.values.concat(result.values);
                // Store the last next url to populate hasMoreRefs
                res.next = result.next;
            } else {
                // If either request fails, we want to dispatch a FETCH_REF_OPTIONS.ERROR
                res = {
                    success: false,
                    values: [],
                    next: ""
                };
                break;
            }
        }
        if (res.success) {
            let refs = (0, $abRa1.getRefs)(res.values);
            const branchingModel = yield (0, $5NpoY.a3)((0, $aanBq.getRepositoryBranchingModel));
            // @ts-ignore TODO: fix noImplicitAny error here
            const searchCondition = (branch)=>{
                if (!search || !branch.name) return true;
                if (branch.name.includes(search)) return true;
                return false;
            };
            if (branchingModel) {
                const { development: development, production: production } = branchingModel;
                const priorityRefs = [
                    development,
                    production
                ].filter((b)=>b && b.use_mainbranch && searchCondition(b)).map((b)=>({
                        hash: b && b.target ? b.target.hash : undefined,
                        name: b && b.name ? b.name : "",
                        type: b && b.type.toUpperCase()
                    }));
                const uniqPriorityRefs = (0, $l4v9F.default)(priorityRefs, "name");
                const priorityRefNames = uniqPriorityRefs.map((b)=>b.name);
                const filteredRefs = refs.filter((b)=>!priorityRefNames.includes(b.name));
                refs = [
                    ...uniqPriorityRefs,
                    ...filteredRefs
                ];
            }
            const reorderedRefs = (0, $abRa1.moveMainBranchToTop)(refs, mainBranch, !!search);
            const result = {
                type: (0, $1kvgs.FETCH_REF_OPTIONS).SUCCESS,
                payload: {
                    mainRef: mainBranch ? (0, $abRa1.getRef)(mainBranch) : null,
                    refs: (0, $abRa1.generateRefSelectorOptions)(reorderedRefs),
                    hasMoreRefs: !!res.next
                }
            };
            yield (0, $5NpoY.Y)(result);
        } else yield (0, $5NpoY.Y)({
            type: (0, $1kvgs.FETCH_REF_OPTIONS).ERROR
        });
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $1kvgs.FETCH_REF_OPTIONS).ERROR
        });
    }
}
function* $7db64b86f19cdf31$export$d87bf7785834e53b({ payload: { search: search } }) {
    const repositoryFullSlug = yield (0, $5NpoY.a3)((0, $gyx4R.getSelectedRepoFullSlug));
    const mainBranch = yield (0, $5NpoY.a3)((0, $gyx4R.getSelectedRepositoryMainBranch));
    yield (0, $5NpoY.P)($7db64b86f19cdf31$export$a9d980742002e5fe, {
        payload: {
            repositoryFullSlug: repositoryFullSlug,
            mainBranch: mainBranch,
            search: search
        }
    });
}
function* $7db64b86f19cdf31$export$af522b996a9c591e() {
    const [owner, slug] = yield (0, $5NpoY.a3)((0, $gyx4R.getSelectedRepoOwnerAndSlug));
    const { target: { hash: hash } } = yield (0, $5NpoY.a3)((0, $gyx4R.getCreateBranchParams));
    const url = (0, $lUW6w.default).api.v20.commitStatuses(owner, slug, hash);
    const request = (0, $k2cPS.default)(url);
    try {
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            const { values: statuses } = yield response.json();
            yield (0, $5NpoY.Y)({
                type: (0, $1kvgs.FETCH_COMMIT_STATUSES).SUCCESS,
                payload: statuses
            });
        } else yield (0, $5NpoY.Y)({
            type: (0, $1kvgs.FETCH_COMMIT_STATUSES).ERROR
        });
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $1kvgs.FETCH_COMMIT_STATUSES).ERROR
        });
    }
}
function* $7db64b86f19cdf31$export$22fa971c9a866389() {
    const [owner, slug] = yield (0, $5NpoY.a3)((0, $gyx4R.getSelectedRepoOwnerAndSlug));
    try {
        const url = (0, $kZnTB.default).api.v20.branchingModel(owner, slug);
        const request = (0, $k2cPS.default)(url);
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            const { development: development, production: production, branch_types: branchTypes } = yield response.json();
            const devBranch = development && development.branch;
            const prodBranch = production && production.branch;
            yield (0, $5NpoY.Y)({
                type: (0, $1kvgs.FETCH_BRANCHING_MODEL).SUCCESS,
                payload: {
                    development: devBranch ? (0, $abRa1.getRef)(devBranch) : null,
                    production: prodBranch ? (0, $abRa1.getRef)(prodBranch) : null,
                    branchTypes: branchTypes
                }
            });
        } else yield (0, $5NpoY.P)($7db64b86f19cdf31$export$3919f700bb272836);
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.P)($7db64b86f19cdf31$export$3919f700bb272836);
    }
}
function* $7db64b86f19cdf31$export$61671dcbac770c72(action) {
    const { payload: { selected: selected } } = action;
    const [owner, slug] = (0, $abRa1.getRepoOwnerAndSlug)(selected.value);
    yield (0, $5NpoY.Y)((0, $1kvgs.loadRepository)(owner, slug));
    yield (0, $5NpoY.M)([
        (0, $1kvgs.LOAD_REPOSITORY).SUCCESS,
        (0, $1kvgs.LOAD_REPOSITORY).ERROR
    ]);
    yield (0, $5NpoY.Y)((0, $1kvgs.fetchRefOptions)());
    yield (0, $5NpoY.Y)((0, $1kvgs.fetchBranchingModel)());
}
function* $7db64b86f19cdf31$export$305ee53869f1d041() {
    const owner = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryOwnerName));
    const slug = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositorySlug));
    const fullName = (0, $abRa1.getRepoFullName)({
        owner: owner,
        slug: slug
    });
    yield (0, $5NpoY.Y)((0, $1kvgs.onChangeRepository)({
        value: fullName,
        label: fullName,
        data: undefined
    }));
}
function* $7db64b86f19cdf31$export$82f6c515edb88e7a({ payload: payload }) {
    const { repositories: repositories } = payload;
    if (repositories && repositories.length !== 0) {
        const issue = yield (0, $5NpoY.a3)((0, $gyx4R.getJiraIssue));
        let repoForIssue = null;
        if (issue) {
            let repoNameForIssue = null;
            const prefsKey = $7db64b86f19cdf31$var$getRepositoryForJiraIssueUserPrefKey(issue);
            if (prefsKey) {
                const currentUser = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
                try {
                    repoNameForIssue = yield (0, $5NpoY.P)((0, $j9gxd.default).get, currentUser.uuid, prefsKey);
                } catch  {
                    $3XbtU.captureException("Failed to get the preferred repo for issue");
                }
            }
            // Fall back to reading from local storage to allow some transition period
            if (!repoNameForIssue) repoNameForIssue = (0, $683bT.getRepositoryForIssueFromLocalStorage)(issue);
            repoForIssue = repoNameForIssue && // @ts-ignore TODO: fix noImplicitAny error here
            repositories.find((r)=>r.full_name === repoNameForIssue);
        }
        const defaultRepo = repoForIssue || repositories[0];
        yield (0, $5NpoY.Y)((0, $1kvgs.onChangeRepository)({
            value: defaultRepo.full_name,
            label: defaultRepo.full_name,
            data: undefined
        }));
    }
}
function* $7db64b86f19cdf31$export$251f5f26b614999a() {
    yield (0, $5NpoY.Y)((0, $2kKDW.showFlagComponent)("create-branch-load-repositories-error"));
}
function* $7db64b86f19cdf31$export$2fbc1fab5e349f87() {
    while(true){
        // We need to trigger pre-selection in the following cases:
        //   - repository refs were successfully fetched AND
        //     branching model was fetched successfully or with an error
        //   - branch type was changed
        yield (0, $5NpoY.T)({
            changeBranchType: (0, $5NpoY.M)((0, $1kvgs.CHANGE_BRANCH_TYPE)),
            fetchBranchAndRefs: (0, $5NpoY._)([
                (0, $5NpoY.T)({
                    branchModelSuccess: (0, $5NpoY.M)((0, $1kvgs.FETCH_BRANCHING_MODEL).SUCCESS),
                    branchModelFailure: (0, $5NpoY.M)((0, $1kvgs.FETCH_BRANCHING_MODEL).ERROR)
                }),
                (0, $5NpoY.M)((0, $1kvgs.FETCH_REF_OPTIONS).SUCCESS)
            ])
        });
        const workflowBranches = yield (0, $5NpoY.a3)((0, $gyx4R.getWorkflowBranches));
        const branchType = yield (0, $5NpoY.a3)((0, $gyx4R.getSelectedBranchType));
        const fromBranch = (0, $abRa1.suggestFromBranch)(workflowBranches, branchType);
        if (fromBranch) {
            yield (0, $5NpoY.Y)((0, $1kvgs.setSuggestedFromBranch)(fromBranch));
            const refSelector = yield (0, $5NpoY.a3)((0, $gyx4R.getRefSelectorState));
            // Change from branch only if user hasn't changed it already
            if (!refSelector.selectedByUser) yield (0, $5NpoY.Y)((0, $1kvgs.changeFromBranch)(fromBranch, false));
        }
    }
}

});
parcelRegister("l4v9F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f572236ca7300392$export$2e2bcd8739ae039; });

var $dfCpC = parcelRequire("dfCpC");

var $bVr6r = parcelRequire("bVr6r");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $f572236ca7300392$var$uniqBy(array, iteratee) {
    return array && array.length ? (0, $bVr6r.default)(array, (0, $dfCpC.default)(iteratee, 2)) : [];
}
var $f572236ca7300392$export$2e2bcd8739ae039 = $f572236ca7300392$var$uniqBy;

});
parcelRegister("bVr6r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8aea0aa1587ebbf6$export$2e2bcd8739ae039; });

var $fJMvm = parcelRequire("fJMvm");

var $c13Bt = parcelRequire("c13Bt");

var $kY4tK = parcelRequire("kY4tK");

var $4I1X7 = parcelRequire("4I1X7");

var $9xRn3 = parcelRequire("9xRn3");

var $bkWf6 = parcelRequire("bkWf6");
/** Used as the size to enable large array optimizations. */ var $8aea0aa1587ebbf6$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $8aea0aa1587ebbf6$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = (0, $c13Bt.default), length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = (0, $kY4tK.default);
    } else if (length >= $8aea0aa1587ebbf6$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : (0, $9xRn3.default)(array);
        if (set) return (0, $bkWf6.default)(set);
        isCommon = false;
        includes = (0, $4I1X7.default);
        seen = new (0, $fJMvm.default);
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
var $8aea0aa1587ebbf6$export$2e2bcd8739ae039 = $8aea0aa1587ebbf6$var$baseUniq;

});
parcelRegister("c13Bt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8bf85f96c98e1421$export$2e2bcd8739ae039; });

var $kOc9y = parcelRequire("kOc9y");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $8bf85f96c98e1421$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && (0, $kOc9y.default)(array, value, 0) > -1;
}
var $8bf85f96c98e1421$export$2e2bcd8739ae039 = $8bf85f96c98e1421$var$arrayIncludes;

});
parcelRegister("kOc9y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f261e78252411218$export$2e2bcd8739ae039; });

var $7ng8o = parcelRequire("7ng8o");

var $20wNj = parcelRequire("20wNj");

var $6DpPk = parcelRequire("6DpPk");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f261e78252411218$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? (0, $6DpPk.default)(array, value, fromIndex) : (0, $7ng8o.default)(array, (0, $20wNj.default), fromIndex);
}
var $f261e78252411218$export$2e2bcd8739ae039 = $f261e78252411218$var$baseIndexOf;

});
parcelRegister("7ng8o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55e732563a24dcf5$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $55e732563a24dcf5$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
var $55e732563a24dcf5$export$2e2bcd8739ae039 = $55e732563a24dcf5$var$baseFindIndex;

});

parcelRegister("20wNj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1765051e24cc1488$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $1765051e24cc1488$var$baseIsNaN(value) {
    return value !== value;
}
var $1765051e24cc1488$export$2e2bcd8739ae039 = $1765051e24cc1488$var$baseIsNaN;

});

parcelRegister("6DpPk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d4a6b46967cd7c8$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $4d4a6b46967cd7c8$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
var $4d4a6b46967cd7c8$export$2e2bcd8739ae039 = $4d4a6b46967cd7c8$var$strictIndexOf;

});



parcelRegister("kY4tK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f43ce2a05e4bea46$export$2e2bcd8739ae039; });
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f43ce2a05e4bea46$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
var $f43ce2a05e4bea46$export$2e2bcd8739ae039 = $f43ce2a05e4bea46$var$arrayIncludesWith;

});

parcelRegister("9xRn3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f309871a19e7e6c$export$2e2bcd8739ae039; });

var $66wjI = parcelRequire("66wjI");

var $8mkdU = parcelRequire("8mkdU");

var $bkWf6 = parcelRequire("bkWf6");
/** Used as references for various `Number` constants. */ var $6f309871a19e7e6c$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $6f309871a19e7e6c$var$createSet = !((0, $66wjI.default) && 1 / (0, $bkWf6.default)(new (0, $66wjI.default)([
    ,
    -0
]))[1] == $6f309871a19e7e6c$var$INFINITY) ? (0, $8mkdU.default) : function(values) {
    return new (0, $66wjI.default)(values);
};
var $6f309871a19e7e6c$export$2e2bcd8739ae039 = $6f309871a19e7e6c$var$createSet;

});
parcelRegister("8mkdU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $019210c94ba1a9ba$export$2e2bcd8739ae039; });
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $019210c94ba1a9ba$var$noop() {
// No operation performed.
}
var $019210c94ba1a9ba$export$2e2bcd8739ae039 = $019210c94ba1a9ba$var$noop;

});




parcelRegister("683bT", function(module, exports) {

$parcel$export(module.exports, "getRepositoryForIssueFromLocalStorage", function () { return $b8f66fc73934184e$export$324654308d5c4d30; });
$parcel$export(module.exports, "generateBranchNameFromIssue", function () { return $b8f66fc73934184e$export$d27f7dbbe3d9c055; });
$parcel$export(module.exports, "parseIssueFromQueryString", function () { return $b8f66fc73934184e$export$25bf383e77f0311a; });
$parcel$export(module.exports, "branchTypeFromIssue", function () { return $b8f66fc73934184e$export$cdb642abd1f0450; });
$parcel$export(module.exports, "getJiraIssueTypeForAnalytics", function () { return $b8f66fc73934184e$export$1866f9df748bd47; });

var $cJH1T = parcelRequire("cJH1T");

var $biyfN = parcelRequire("biyfN");

var $h3kk7 = parcelRequire("h3kk7");

var $5gF7V = parcelRequire("5gF7V");

var $abRa1 = parcelRequire("abRa1");
const $b8f66fc73934184e$var$getProjectFromIssueKey = (issueKey)=>{
    return issueKey.split("-")[0];
};
const $b8f66fc73934184e$var$getStorageKey = (issue)=>{
    return issue.project && `bb-jira-repo-map-${issue.project}` || null;
};
const $b8f66fc73934184e$export$324654308d5c4d30 = (issue)=>{
    const storageKey = $b8f66fc73934184e$var$getStorageKey(issue);
    return storageKey && (0, $h3kk7.default).get(storageKey) || null;
};
const $b8f66fc73934184e$export$d27f7dbbe3d9c055 = (issue)=>{
    let result = "";
    const summary = (0, $abRa1.sanitizeIssueSummary)(issue.summary ? issue.summary.toLowerCase() : "");
    if (issue.key && summary) result = `${issue.key}-${summary}`;
    else if (issue.key) result = issue.key;
    else if (summary) result = summary;
    result = (0, $abRa1.sanitizeBranchName)(result);
    return result.slice(0, 40);
};
const $b8f66fc73934184e$export$25bf383e77f0311a = (query)=>{
    const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).parse(query, {
        ignoreQueryPrefix: true
    });
    const key = (parsed.issueKey || "").trim();
    const summary = (parsed.issueSummary || "").trim();
    const type = (parsed.issueType || "").trim();
    if (key || summary || type) {
        const issue = {};
        if (key) {
            issue.key = key;
            issue.project = $b8f66fc73934184e$var$getProjectFromIssueKey(key);
        }
        if (summary) issue.summary = summary;
        if (type) issue.type = type;
        return issue;
    }
    return null;
};
const $b8f66fc73934184e$export$cdb642abd1f0450 = (issue, isBugfixEnabled)=>{
    if (issue.type) {
        const key = issue.type.toLowerCase();
        if ((0, $5gF7V.JIRA_BUG_KEYS).includes(key)) {
            if (isBugfixEnabled) return (0, $biyfN.BRANCH_KIND).BUG_FIX;
            else return (0, $biyfN.BRANCH_KIND).FEATURE;
        } else // @ts-ignore TODO: fix noImplicitAny error here
        return (0, $5gF7V.JIRA_ISSUE_TYPE_MAPPING)[key] || (0, $5gF7V.EXTENDED_BRANCH_KINDS).OTHER;
    }
    return (0, $5gF7V.EXTENDED_BRANCH_KINDS).OTHER;
};
const $b8f66fc73934184e$export$1866f9df748bd47 = (issue)=>{
    if (issue.type) {
        const type = issue.type.toLowerCase();
        if ((0, $5gF7V.SAFE_JIRA_ISSUE_TYPES).includes(type)) return type;
    }
    return "custom";
};

});

parcelRegister("f0vcS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9536e6c4a8dc5a3$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $f9536e6c4a8dc5a3$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    createBranchErrorTitle: {
        "id": "frontbucket.branches.createBranchErrorTitle",
        "defaultMessage": "We couldn't create a branch"
    },
    insufficientRepoAccessRightsDescription: {
        "id": "frontbucket.branches.insufficientRepoAccessRightsDescription",
        "defaultMessage": "You have insufficient rights to create a branch in this repository."
    },
    genericErrorDescription: {
        "id": "frontbucket.branches.genericErrorDescription",
        "defaultMessage": "If this keeps happening, {supportLink}."
    },
    loadRepositoriesErrorTitle: {
        "id": "frontbucket.branches.loadRepositoriesErrorTitle",
        "defaultMessage": "We weren\u2019t able to load the repositories"
    },
    supportLink: {
        "id": "frontbucket.branches.supportPageLink",
        "defaultMessage": "contact support"
    },
    branchingModelsLoadingErrorTitle: {
        "id": "frontbucket.branches.loadBranchingModelTypesErrorTitle",
        "defaultMessage": "We couldn't load the branch types"
    },
    branchingModelsLoadingErrorDescription: {
        "id": "frontbucket.branches.loadBranchingModelTypesErrorDescription",
        "defaultMessage": "Refresh the page or enter your branch prefix manually."
    }
});

});

parcelRegister("eO3IF", function(module, exports) {

$parcel$export(module.exports, "buildRefUrls", function () { return $75258bfeb78bfcd5$export$ff8112cab977b255; });

var $fyvjM = parcelRequire("fyvjM");
const $75258bfeb78bfcd5$export$ff8112cab977b255 = (slug, type, filter, customQuery = "")=>{
    const requestUrls = [];
    if (filter === "") // If there is no search filter, fetch the main branch + last modified branches
    requestUrls.push((0, $fyvjM.generateRefUrl)(slug, "", type, undefined, undefined, "-target.date", {
        type: "custom",
        customQuery: customQuery
    }));
    else {
        const customQueryWithAnd = customQuery.length > 0 ? customQuery.concat(" AND ") : "";
        // When a search filter is present, fetch exact matches first, then similar matches
        const customQueries = [
            {
                type: "custom",
                customQuery: `${customQueryWithAnd}name = "${filter}"`
            },
            // Only return similar matches that aren't exact
            {
                type: "custom",
                customQuery: `${customQueryWithAnd}name != "${filter}" AND name ~ "${filter}"`
            }
        ];
        customQueries.forEach((query)=>{
            requestUrls.push((0, $fyvjM.generateRefUrl)(slug, filter, type, undefined, undefined, "-target.date", query));
        });
    }
    return requestUrls;
};

});
parcelRegister("fyvjM", function(module, exports) {

$parcel$export(module.exports, "generateRefUrl", function () { return $1db4f40a483eee60$export$fd7f1fb5bc38ab9a; });
$parcel$export(module.exports, "fetchRefOptions", function () { return $1db4f40a483eee60$export$4ec3b042c9c5aa9; });

var $l4v9F = parcelRequire("l4v9F");

var $cJH1T = parcelRequire("cJH1T");

var $kZnTB = parcelRequire("kZnTB");

var $k2cPS = parcelRequire("k2cPS");
const $1db4f40a483eee60$var$PAGE_LEN = 25;
const $1db4f40a483eee60$export$fd7f1fb5bc38ab9a = (repositoryFullSlug, filter, type, mainRef, branchingModel, sort, queryOptions)=>{
    const [owner, slug] = repositoryFullSlug.split("/");
    let url;
    switch(type){
        case "branch":
            url = (0, $kZnTB.default).api.v20.branches(owner, slug);
            break;
        case "tag":
            url = (0, $kZnTB.default).api.v20.tags(owner, slug);
            break;
        default:
            url = (0, $kZnTB.default).api.v20.refs(owner, slug);
            break;
    }
    // Prevent duplicate priority refs
    const priorityRefs = new Set(mainRef ? [
        mainRef.name
    ] : []);
    if (branchingModel) {
        const { production: production, development: development } = branchingModel;
        const priorityModelRefs = [
            production,
            development
        ].filter((n)=>!!n && !n.use_mainbranch);
        priorityModelRefs.forEach((ref)=>{
            if (ref) priorityRefs.add(ref.name);
        });
    }
    const specialRefsQuery = Array.from(priorityRefs).map((ref)=>`name != "${ref}" AND `).join("");
    const sortQuery = sort || (type === "branch" ? "name" : "-target.date");
    // Define the base query
    let query = type === "branch" ? `${specialRefsQuery}` : "";
    if (queryOptions) switch(queryOptions.type){
        case "exact":
            query = queryOptions.exact ? `name = "${filter}"` // Query for exact matches
             : query.concat(`name ~ "${filter}"`); // Base query + similar matches
            break;
        case "custom":
            query = queryOptions.customQuery; // Custom query
            break;
    }
    else query = query.concat(`name ~ "${filter}"`); // Base query + similar matches
    const queryString = (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
        pagelen: $1db4f40a483eee60$var$PAGE_LEN,
        q: query,
        sort: sortQuery,
        // Filter down to just the target.hash, so we don't have to load
        // the commit object which could be unreasonably large, as the commit
        // message is user-controlled. If we only access the ref hash, we can
        // usually skip loading the commit object entirely.
        //
        // We need the hash because a ref name may not be safe to use as a
        // path element (e.g. a branch with a / in it). See `sourceWithRef`.
        fields: "-values.target.*,+values.target.hash"
    });
    return `${url}?${queryString}`;
};
const $1db4f40a483eee60$export$e1b800348b19c7d6 = (ref, filter)=>{
    if (!ref || !ref.name) return false;
    return ref.name.includes(filter);
};
const $1db4f40a483eee60$export$4ec3b042c9c5aa9 = async (url, reset, filter, type, mainRef, branchingModel, onError)=>{
    const response = await fetch((0, $k2cPS.default)(url));
    if (!response.ok) {
        if (onError) {
            const e = new Error(response.statusText || "error loading branches");
            onError({
                ...e,
                status: response.status
            });
        } else throw Error();
    }
    const { next: next, values: newRefs } = await response.json();
    let preparedRefs = newRefs;
    // for branches, we apply custom ordering
    if (type === "branch") {
        let priorityRefs = [];
        if ($1db4f40a483eee60$export$e1b800348b19c7d6(mainRef, filter) && reset) priorityRefs = [
            mainRef
        ];
        if (branchingModel) {
            const { development: development, production: production } = branchingModel;
            const priorityModelRefs = [
                development,
                production
            ].filter((b)=>!!b && !b.use_mainbranch && $1db4f40a483eee60$export$e1b800348b19c7d6(b, filter) && reset);
            priorityRefs = [
                ...priorityRefs,
                ...priorityModelRefs
            ];
        }
        preparedRefs = (0, $l4v9F.default)([
            ...priorityRefs,
            ...preparedRefs
        ], "name");
        return {
            preparedRefs: preparedRefs,
            next: next
        };
    }
    // tags
    return {
        preparedRefs: preparedRefs,
        next: next
    };
};

});


parcelRegister("lUW6w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a30a0c8340cf7123$export$2e2bcd8739ae039; });

var $9H597 = parcelRequire("9H597");
const $a30a0c8340cf7123$var$urls = {
    api: {
        v10: {
            branchesTags: (owner, slug)=>`/!api/1.0/repositories/${owner}/${slug}/branches-tags`
        },
        v20: {
            commitStatuses: (owner, slug, node)=>`/!api/2.0/repositories/${owner}/${slug}/commit/${node}/statuses`
        }
    },
    external: {
        branchesEmptyStateLearnHow: "https://confluence.atlassian.com/x/TwlODQ"
    },
    ui: {
        compareBranch: (repositoryFullSlug, branchName, params)=>{
            return `/${repositoryFullSlug}/branches/compare/${(0, $9H597.encodeBranchName)(branchName)}..${(0, $9H597.encodeBranchName)((params === null || params === void 0 ? void 0 : params.compareWith) || "")}`;
        }
    }
};
var $a30a0c8340cf7123$export$2e2bcd8739ae039 = $a30a0c8340cf7123$var$urls;

});

parcelRegister("j9gxd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c4890604f67872b$export$2e2bcd8739ae039; });

var $3rtV2 = parcelRequire("3rtV2");

var $k2cPS = parcelRequire("k2cPS");
var $1c4890604f67872b$export$2e2bcd8739ae039 = {
    get: (uuid, key)=>{
        const url = (0, $3rtV2.default).api.internal.userPreference(uuid, encodeURIComponent(key.toString()));
        if (!uuid) return Promise.reject();
        return fetch((0, $k2cPS.default)(url)).then((response)=>{
            if (response.ok) return response.json();
            else {
                // If the response status is 404, it means the preference has not been set yet.
                // It makes more sense to resolve the promise with a value`undefined` instead of rejecting it.
                if (response.status === 404) return Promise.resolve(undefined);
            }
            return Promise.reject();
        });
    },
    set: (uuid, key, value)=>{
        const url = (0, $3rtV2.default).api.internal.userPreference(uuid, encodeURIComponent(key.toString()));
        if (!uuid) return Promise.reject();
        const data = new FormData();
        data.append("value", value);
        return fetch((0, $k2cPS.default)(url, {
            method: "PUT",
            body: data
        })).then((response)=>response.ok ? response.json() : Promise.reject());
    },
    delete: (uuid, key)=>{
        const url = (0, $3rtV2.default).api.internal.userPreference(uuid, encodeURIComponent(key.toString()));
        if (!uuid) return Promise.reject();
        return fetch((0, $k2cPS.default)(url, {
            method: "DELETE"
        })).then((response)=>response.ok ? Promise.resolve() : Promise.reject());
    }
};

});



parcelRegister("kzG9F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da938c10eeea3bb9$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $jKnoY = parcelRequire("jKnoY");

var $bYzfL = parcelRequire("bYzfL");

var $l3s74 = parcelRequire("l3s74");
function* $da938c10eeea3bb9$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLatest)([
            (0, $jKnoY.FetchRepositories).SUCCESS
        ], (0, $l3s74.getDashboardRepositoryListBuildStatuses)),
        (0, $jeUNF.takeLatest)([
            (0, $jKnoY.FETCH_NONCRITICAL_REPOSITORIES_DATA)
        ], (0, $l3s74.getDashboardRepositoryListBuildStatuses)),
        (0, $jeUNF.takeLatest)([
            (0, $jKnoY.CLEAR_PULL_REQUEST_FILTERS),
            (0, $jKnoY.FILTER_PULL_REQUESTS)
        ], (0, $bYzfL.default))
    ]);
}

});
parcelRegister("jKnoY", function(module, exports) {

$parcel$export(module.exports, "EXPAND_PULL_REQUESTS", function () { return $e92b58b3306228fc$export$cf6b7d0379a4eff5; });
$parcel$export(module.exports, "FetchRepositories", function () { return $e92b58b3306228fc$export$6f0db78810030816; });
$parcel$export(module.exports, "FETCH_NONCRITICAL_REPOSITORIES_DATA", function () { return $e92b58b3306228fc$export$abb3cd3c1b50ba5c; });
$parcel$export(module.exports, "LoadDashboard", function () { return $e92b58b3306228fc$export$f64c6fd164233695; });
$parcel$export(module.exports, "LoadDashboardOverview", function () { return $e92b58b3306228fc$export$77bfc63b4e69d313; });
$parcel$export(module.exports, "FILTER_PULL_REQUESTS", function () { return $e92b58b3306228fc$export$fff7e8d93db80e45; });
$parcel$export(module.exports, "CLEAR_PULL_REQUEST_FILTERS", function () { return $e92b58b3306228fc$export$e58c975c9dc0efd3; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
const $e92b58b3306228fc$export$cf6b7d0379a4eff5 = "dashboard/EXPAND_PULL_REQUESTS";
const $e92b58b3306228fc$export$6f0db78810030816 = (0, $2MctD.createAsyncAction)("dashboard/FETCH_REPOSITORIES");
const $e92b58b3306228fc$export$abb3cd3c1b50ba5c = "dashboard/FETCH_NONCRITICAL_REPOSITORIES_DATA";
const $e92b58b3306228fc$export$f64c6fd164233695 = (0, $2MctD.createAsyncAction)("dashboard/LOAD");
const $e92b58b3306228fc$export$77bfc63b4e69d313 = (0, $2MctD.createAsyncAction)("dashboard/LOAD_OVERVIEW");
const $e92b58b3306228fc$export$fff7e8d93db80e45 = "dashboard/FILTER_PULL_REQUESTS";
const $e92b58b3306228fc$export$e58c975c9dc0efd3 = "dashboard/CLEAR_PULL_REQUEST_FILTERS";

});

parcelRegister("bYzfL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $364acbf658b93f84$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $abzF7 = parcelRequire("abzF7");

var $g2R3c = parcelRequire("g2R3c");

var $j9gxd = parcelRequire("j9gxd");
function* $364acbf658b93f84$export$2e2bcd8739ae039() {
    const user = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
    const pullRequestFilters = yield (0, $5NpoY.a3)((0, $abzF7.getPullRequestsFilters));
    if (user) yield (0, $5NpoY.P)((0, $j9gxd.default).set, user.uuid, "dashboard:pullRequests:filter", JSON.stringify(pullRequestFilters));
}

});
parcelRegister("abzF7", function(module, exports) {

$parcel$export(module.exports, "getPullRequestsFilters", function () { return $a170aafc882a2bfa$export$3fc9035103dba7d6; });

var $ga67g = parcelRequire("ga67g");

var $aXXtM = parcelRequire("aXXtM");

var $b2RHC = parcelRequire("b2RHC");

var $7qdXF = parcelRequire("7qdXF");
const $a170aafc882a2bfa$export$5352c8efadf0c628 = (0, $aXXtM.createSelector)((0, $7qdXF.getDashboard), (dashboard)=>dashboard.pullRequests);
const $a170aafc882a2bfa$var$getPullRequests = (0, $aXXtM.createSelector)($a170aafc882a2bfa$export$5352c8efadf0c628, (slice)=>slice.pullRequests);
const $a170aafc882a2bfa$var$getAuthorPullRequestKeys = (0, $aXXtM.createSelector)($a170aafc882a2bfa$var$getPullRequests, (pullRequests)=>pullRequests.authored);
const $a170aafc882a2bfa$var$getReviewingPullRequestsKeys = (0, $aXXtM.createSelector)($a170aafc882a2bfa$var$getPullRequests, (pullRequests)=>pullRequests.reviewing);
const $a170aafc882a2bfa$var$getClosedPullRequestKeys = (0, $aXXtM.createSelector)($a170aafc882a2bfa$var$getPullRequests, (pullRequests)=>pullRequests.closed);
const $a170aafc882a2bfa$export$12f6f26aec2c0aca = (0, $aXXtM.createSelector)($a170aafc882a2bfa$var$getReviewingPullRequestsKeys, (0, $7qdXF.getEntities), (keys, entities)=>(0, $ga67g.denormalize)(keys, [
        (0, $b2RHC.pullRequest)
    ], entities));
const $a170aafc882a2bfa$export$ecb44aa0f02e6ba9 = (0, $aXXtM.createSelector)($a170aafc882a2bfa$var$getAuthorPullRequestKeys, (0, $7qdXF.getEntities), (keys, entities)=>(0, $ga67g.denormalize)(keys, [
        (0, $b2RHC.pullRequest)
    ], entities));
const $a170aafc882a2bfa$export$6978f11cb05bcdfc = (0, $aXXtM.createSelector)($a170aafc882a2bfa$var$getClosedPullRequestKeys, (0, $7qdXF.getEntities), (keys, entities)=>(0, $ga67g.denormalize)(keys, [
        (0, $b2RHC.pullRequest)
    ], entities));
const $a170aafc882a2bfa$export$3fc9035103dba7d6 = (0, $aXXtM.createSelector)($a170aafc882a2bfa$export$5352c8efadf0c628, (slice)=>slice.pullRequestFilters);

});


parcelRegister("l3s74", function(module, exports) {

$parcel$export(module.exports, "getDashboardRepositoryListBuildStatuses", function () { return $e9d3cea9e9134cb5$export$82ba8e866da8754; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $uqR9X = parcelRequire("uqR9X");

var $e8VvG = parcelRequire("e8VvG");

var $a62eX = parcelRequire("a62eX");
const $e9d3cea9e9134cb5$export$82ba8e866da8754 = (0, $a62eX.createGetRepositoryBuildStatuses)((0, $e8VvG.UPDATE_REPOSITORY_BUILD_STATUSES), (0, $uqR9X.getRepositories));

});
parcelRegister("uqR9X", function(module, exports) {

$parcel$export(module.exports, "getRepositories", function () { return $5761e08975d1193b$export$f594c030cdaac8cb; });

var $ga67g = parcelRequire("ga67g");

var $aXXtM = parcelRequire("aXXtM");

var $48ZQ3 = parcelRequire("48ZQ3");

var $7qdXF = parcelRequire("7qdXF");
const $5761e08975d1193b$export$99e70b444edcbe54 = (0, $aXXtM.createSelector)((0, $7qdXF.getDashboard), (dashboard)=>dashboard.repositories);
const $5761e08975d1193b$var$getRepositoryKeys = (0, $aXXtM.createSelector)($5761e08975d1193b$export$99e70b444edcbe54, (slice)=>slice.repositories);
const $5761e08975d1193b$export$f594c030cdaac8cb = (0, $aXXtM.createSelector)($5761e08975d1193b$var$getRepositoryKeys, (0, $7qdXF.getEntities), (keys, entities)=>(0, $ga67g.denormalize)(keys, [
        (0, $48ZQ3.repository)
    ], entities));
const $5761e08975d1193b$var$getRepositoriesSize = (0, $aXXtM.createSelector)($5761e08975d1193b$export$99e70b444edcbe54, (slice)=>slice.size);
const $5761e08975d1193b$var$getRepositoriesLength = (0, $aXXtM.createSelector)($5761e08975d1193b$export$99e70b444edcbe54, (slice)=>slice.pagelen);
const $5761e08975d1193b$export$832f9815643a153b = (0, $aXXtM.createSelector)($5761e08975d1193b$var$getRepositoriesSize, $5761e08975d1193b$var$getRepositoriesLength, (size, pageLength)=>size && pageLength ? Math.ceil(size / pageLength) : 1);
const $5761e08975d1193b$export$62f882597b99a426 = (0, $aXXtM.createSelector)((0, $7qdXF.getDashboard), (dashboard)=>dashboard.repositoryFilters);
const $5761e08975d1193b$export$ab236becb60c24d6 = (0, $aXXtM.createSelector)($5761e08975d1193b$export$62f882597b99a426, (repositoryFilters)=>repositoryFilters.owners);
const $5761e08975d1193b$export$17592ee170875257 = (0, $aXXtM.createSelector)($5761e08975d1193b$export$62f882597b99a426, (repositoryFilters)=>repositoryFilters.workspaces);
const $5761e08975d1193b$export$89eca504f0bd5c98 = (0, $aXXtM.createSelector)($5761e08975d1193b$export$62f882597b99a426, (repositoryFilters)=>repositoryFilters.projects);
const $5761e08975d1193b$export$b00a271f69f3d728 = (0, $aXXtM.createSelector)($5761e08975d1193b$export$89eca504f0bd5c98, ({ filteredProjects: filteredProjects, data: data })=>filteredProjects.length ? filteredProjects : data);

});

parcelRegister("a62eX", function(module, exports) {

$parcel$export(module.exports, "createGetRepositoryBuildStatuses", function () { return $034e1ded32933b0c$export$e83c26f1ddcef4cd; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $3VThC = parcelRequire("3VThC");

var $48ZQ3 = parcelRequire("48ZQ3");

var $6OwE2 = parcelRequire("6OwE2");

var $k2cPS = parcelRequire("k2cPS");
function $034e1ded32933b0c$export$e83c26f1ddcef4cd(action, repositorySelector) {
    return function* getRepositoryBuildStatusesSaga() {
        // @ts-ignore
        const repositories = yield (0, $5NpoY.a3)(repositorySelector);
        if (repositories.length === 0) return;
        const url = (0, $6OwE2.default).api.internal.repositoryBuildStatuses();
        try {
            const request = (0, $k2cPS.default)(url, {
                method: "POST",
                // @ts-ignore TODO: fix noImplicitAny error here
                body: repositories.map((r)=>`uuid=${r.uuid}`).join("&"),
                headers: {
                    "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
                }
            });
            const response = yield (0, $5NpoY.P)(fetch, request);
            if (response.ok) {
                const statuses = yield response.json() || [];
                const updatedRepositories = (0, $3VThC.addStatuses)(repositories, statuses);
                // normalizr will handle this action
                yield (0, $5NpoY.Y)({
                    type: action.SUCCESS,
                    payload: updatedRepositories,
                    meta: {
                        schema: [
                            (0, $48ZQ3.repository)
                        ]
                    }
                });
            }
        } catch (e) {
            yield (0, $5NpoY.Y)({
                type: action.ERROR,
                payload: e
            });
        }
    };
}

});



parcelRegister("6P3zs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4dcf950c4e568078$export$2e2bcd8739ae039; });

var $3XbtU = parcelRequire("3XbtU");
var $i3ov7 = parcelRequire("i3ov7");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $i8uLY = parcelRequire("i8uLY");

var $i2O3k = parcelRequire("i2O3k");

var $2kKDW = parcelRequire("2kKDW");

var $19fn8 = parcelRequire("19fn8");

var $g2R3c = parcelRequire("g2R3c");

var $j9gxd = parcelRequire("j9gxd");
const $4dcf950c4e568078$export$7805ffab5d24d39b = "pull-request-diff-view-mode";
const $4dcf950c4e568078$export$6a42b95f6311b9b7 = "pull-request-file-view-mode";
const $4dcf950c4e568078$export$6b95bcf562bf567d = "pull-request-diff-tab-size";
const $4dcf950c4e568078$export$d8c8b246ce64116f = "pull-request-color-blind-mode-enabled";
const $4dcf950c4e568078$export$32608cc2a066c069 = "pull-request-ignore-whitespace-enabled";
const $4dcf950c4e568078$export$903a1970693e4296 = "pull-request-word-diff-enabled";
const $4dcf950c4e568078$export$be35eca555f0f372 = "pull-request-annotations-enabled";
const $4dcf950c4e568078$export$c5b5f2ba3bf7be5a = "pull-request-single-file-mode-enabled";
const $4dcf950c4e568078$export$e6d1ded25e87efdb = {
    id: "diff-settings-update-success",
    description: {
        msg: (0, $19fn8.default).successFlagDescription
    },
    iconType: "success",
    title: {
        msg: (0, $i8uLY.default).success
    }
};
function* $4dcf950c4e568078$var$updateUserPreference(options) {
    try {
        // If the current user isn't logged in, we don't have a user preference to update, so just fire the
        // success action to trigger any necessary re-renders and move on
        if (!options.userUuid) {
            yield (0, $5NpoY.Y)(options.successAction);
            // Return a truthy value so the saga doesn't produce an error flag
            return true;
        }
        // @ts-ignore
        const response = yield (0, $5NpoY.P)((0, $j9gxd.default).set, options.userUuid, options.key, options.value);
        yield (0, $5NpoY.Y)(options.successAction);
        return response;
    } catch (e) {
        // Don't re-throw -- we want the `yield all` to wait for *all* of the updates to finish rather than
        // exit early if one fails
        $3XbtU.withScope((scope)=>{
            scope.setTag("preferenceKey", `${options.key}`);
            $3XbtU.captureMessage(`Error while updating a user preference via the Pull Request settings modal`, $i3ov7.Severity.Error);
        });
        return undefined;
    }
}
function* $4dcf950c4e568078$export$91b6a598e63df92f(action) {
    const currentUser = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
    const globalDiffViewMode = yield (0, $5NpoY.a3)((0, $i2O3k.getGlobalDiffViewMode));
    const globalFileViewMode = yield (0, $5NpoY.a3)((0, $i2O3k.getGlobalFileViewMode));
    const globalTabSize = yield (0, $5NpoY.a3)((0, $i2O3k.getGlobalTabSize));
    const globalIsWordDiffEnabled = yield (0, $5NpoY.a3)((0, $i2O3k.getGlobalIsWordDiffEnabled));
    const globalIsColorBlindModeEnabled = yield (0, $5NpoY.a3)((0, $i2O3k.getGlobalIsColorBlindModeEnabled));
    const globalShouldIgnoreWhitespace = yield (0, $5NpoY.a3)((0, $i2O3k.getGlobalShouldIgnoreWhitespace));
    const globalIsAnnotationsEnabled = yield (0, $5NpoY.a3)((0, $i2O3k.getGlobalIsAnnotationsEnabled));
    const globalIsSingleFileModeEnabled = yield (0, $5NpoY.a3)((0, $i2O3k.getGlobalIsSingleFileModeEnabled));
    const newGlobalDiffViewMode = action.payload.diffViewMode;
    const newGlobalFileViewMode = action.payload.fileViewMode;
    const newGlobalTabSize = action.payload.tabSize;
    const newGlobalIsWordDiffEnabled = action.payload.isWordDiffEnabled;
    const newGlobalShouldIgnoreWhitespace = action.payload.shouldIgnoreWhitespace;
    const newGlobalIsColorBlindModeEnabled = action.payload.isColorBlindModeEnabled;
    const newGlobalIsAnnotationsEnabled = action.payload.isAnnotationsEnabled;
    const newGlobalIsSingleFileModeEnabled = action.payload.isSingleFileModeEnabled;
    const preferenceUpdateEffects = [];
    // This is just a passthrough for now, but the persistence logic to use a user pref (starting with COREX-1934)
    // will go here and this success action will then depend on the result of that API request
    if (newGlobalDiffViewMode !== globalDiffViewMode) {
        const successAction = {
            type: (0, $i2O3k.UPDATE_GLOBAL_DIFF_VIEW_MODE_SUCCESS),
            payload: {
                diffViewMode: newGlobalDiffViewMode
            }
        };
        preferenceUpdateEffects.push((0, $5NpoY.P)($4dcf950c4e568078$var$updateUserPreference, {
            key: $4dcf950c4e568078$export$7805ffab5d24d39b,
            successAction: successAction,
            userUuid: currentUser === null || currentUser === void 0 ? void 0 : currentUser.uuid,
            value: newGlobalDiffViewMode
        }));
    }
    if (newGlobalFileViewMode !== globalFileViewMode) {
        const successAction = {
            type: (0, $i2O3k.UPDATE_GLOBAL_FILE_VIEW_MODE_SUCCESS),
            payload: {
                fileViewMode: newGlobalFileViewMode
            }
        };
        preferenceUpdateEffects.push((0, $5NpoY.P)($4dcf950c4e568078$var$updateUserPreference, {
            key: $4dcf950c4e568078$export$6a42b95f6311b9b7,
            successAction: successAction,
            userUuid: currentUser === null || currentUser === void 0 ? void 0 : currentUser.uuid,
            value: newGlobalFileViewMode
        }));
    }
    if (newGlobalTabSize !== globalTabSize) {
        const successAction = {
            type: (0, $i2O3k.UPDATE_GLOBAL_TAB_SIZE_SUCCESS),
            payload: {
                tabSize: newGlobalTabSize
            }
        };
        preferenceUpdateEffects.push((0, $5NpoY.P)($4dcf950c4e568078$var$updateUserPreference, {
            key: $4dcf950c4e568078$export$6b95bcf562bf567d,
            successAction: successAction,
            userUuid: currentUser === null || currentUser === void 0 ? void 0 : currentUser.uuid,
            value: newGlobalTabSize
        }));
    }
    if (newGlobalIsWordDiffEnabled !== globalIsWordDiffEnabled) {
        const successAction = {
            type: (0, $i2O3k.UPDATE_GLOBAL_IS_WORD_DIFF_ENABLED_SUCCESS),
            payload: {
                isWordDiffEnabled: newGlobalIsWordDiffEnabled
            }
        };
        preferenceUpdateEffects.push((0, $5NpoY.P)($4dcf950c4e568078$var$updateUserPreference, {
            key: $4dcf950c4e568078$export$903a1970693e4296,
            successAction: successAction,
            userUuid: currentUser === null || currentUser === void 0 ? void 0 : currentUser.uuid,
            value: newGlobalIsWordDiffEnabled
        }));
    }
    if (newGlobalShouldIgnoreWhitespace !== globalShouldIgnoreWhitespace) {
        const successAction = {
            type: (0, $i2O3k.UPDATE_GLOBAL_SHOULD_IGNORE_WHITESPACE_SUCCESS),
            payload: {
                shouldIgnoreWhitespace: newGlobalShouldIgnoreWhitespace
            }
        };
        preferenceUpdateEffects.push((0, $5NpoY.P)($4dcf950c4e568078$var$updateUserPreference, {
            key: $4dcf950c4e568078$export$32608cc2a066c069,
            successAction: successAction,
            userUuid: currentUser === null || currentUser === void 0 ? void 0 : currentUser.uuid,
            value: newGlobalShouldIgnoreWhitespace
        }));
    }
    if (newGlobalIsColorBlindModeEnabled !== globalIsColorBlindModeEnabled) {
        const successAction = {
            type: (0, $i2O3k.UPDATE_GLOBAL_IS_COLOR_BLIND_MODE_ENABLED_SUCCESS),
            payload: {
                isColorBlindModeEnabled: newGlobalIsColorBlindModeEnabled
            }
        };
        preferenceUpdateEffects.push((0, $5NpoY.P)($4dcf950c4e568078$var$updateUserPreference, {
            key: $4dcf950c4e568078$export$d8c8b246ce64116f,
            successAction: successAction,
            userUuid: currentUser === null || currentUser === void 0 ? void 0 : currentUser.uuid,
            value: newGlobalIsColorBlindModeEnabled
        }));
    }
    if (newGlobalIsAnnotationsEnabled !== globalIsAnnotationsEnabled) {
        const successAction = {
            type: (0, $i2O3k.UPDATE_GLOBAL_IS_ANNOTATIONS_ENABLED_SUCCESS),
            payload: {
                isAnnotationsEnabled: newGlobalIsAnnotationsEnabled
            }
        };
        preferenceUpdateEffects.push((0, $5NpoY.P)($4dcf950c4e568078$var$updateUserPreference, {
            key: $4dcf950c4e568078$export$be35eca555f0f372,
            successAction: successAction,
            userUuid: currentUser === null || currentUser === void 0 ? void 0 : currentUser.uuid,
            value: newGlobalIsAnnotationsEnabled
        }));
    }
    if (newGlobalIsSingleFileModeEnabled !== globalIsSingleFileModeEnabled) {
        const successAction = {
            type: (0, $i2O3k.UPDATE_GLOBAL_IS_SINGLE_FILE_MODE_ENABLED_SUCCESS),
            payload: {
                isSingleFileModeEnabled: newGlobalIsSingleFileModeEnabled
            }
        };
        preferenceUpdateEffects.push((0, $5NpoY.P)($4dcf950c4e568078$var$updateUserPreference, {
            key: $4dcf950c4e568078$export$c5b5f2ba3bf7be5a,
            successAction: successAction,
            userUuid: currentUser === null || currentUser === void 0 ? void 0 : currentUser.uuid,
            value: newGlobalIsSingleFileModeEnabled
        }));
    }
    const results = yield (0, $5NpoY._)(preferenceUpdateEffects);
    if (results.every(Boolean)) {
        const successAction = {
            type: (0, $i2O3k.UPDATE_SETTINGS_SUCCESS)
        };
        yield (0, $5NpoY.Y)(successAction);
        yield (0, $5NpoY.Y)((0, $2kKDW.showFlag)($4dcf950c4e568078$export$e6d1ded25e87efdb));
    } else yield (0, $5NpoY.Y)((0, $2kKDW.showFlagComponent)("diff-settings-error"));
}
function* $4dcf950c4e568078$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLatest)((0, $i2O3k.UPDATE_SETTINGS_REQUEST), $4dcf950c4e568078$export$91b6a598e63df92f)
    ]);
}

});

parcelRegister("2QCBo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15dc107d8e42ccea$export$2e2bcd8739ae039; });

var $3XbtU = parcelRequire("3XbtU");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $g2R3c = parcelRequire("g2R3c");

var $dkkN8 = parcelRequire("dkkN8");
function* $15dc107d8e42ccea$export$2e2bcd8739ae039() {
    yield (0, $5NpoY.M)((0, $dkkN8.LoadGlobal).SUCCESS);
    const currentUser = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
    if (currentUser && currentUser.uuid) yield (0, $5NpoY.P)($3XbtU.configureScope, (scope)=>{
        scope.setUser({
            id: currentUser.uuid
        });
    });
}

});

parcelRegister("01EWw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd2e17434e1cc7cf$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $bUo4Z = parcelRequire("bUo4Z");

var $8MnfV = parcelRequire("8MnfV");

var $6aoKW = parcelRequire("6aoKW");

var $dkkN8 = parcelRequire("dkkN8");
function* $bd2e17434e1cc7cf$export$17963b666e389276() {
    const isSearchDrawerOpen = yield (0, $5NpoY.a3)((0, $8MnfV.getIsSearchDrawerOpen));
    yield (0, $5NpoY.P)((0, $6aoKW.publishFact), new (0, $bUo4Z.ToggleSearchDrawerFact)({
        action: isSearchDrawerOpen ? "opened" : "closed"
    }));
    yield (0, $5NpoY.P)((0, $6aoKW.publishUiEvent), {
        action: "clicked",
        actionSubject: "button",
        actionSubjectId: `searchDrawer${isSearchDrawerOpen ? "Opened" : "Closed"}`,
        source: "navigation"
    });
    if (isSearchDrawerOpen) yield (0, $5NpoY.P)((0, $6aoKW.publishScreenEvent), "globalSearchDrawer");
}
function* $bd2e17434e1cc7cf$export$966e23720eb0cfa6(action) {
    const { payload: payload } = action;
    if (payload) yield (0, $5NpoY.P)((0, $6aoKW.publishScreenEvent), "globalCreateDrawer");
}
function* $bd2e17434e1cc7cf$var$drawerSagas() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLatest)((0, $dkkN8.TOGGLE_SEARCH_DRAWER), $bd2e17434e1cc7cf$export$17963b666e389276),
        (0, $jeUNF.takeLatest)((0, $dkkN8.TOGGLE_CREATE_DRAWER), $bd2e17434e1cc7cf$export$966e23720eb0cfa6)
    ]);
}
var $bd2e17434e1cc7cf$export$2e2bcd8739ae039 = $bd2e17434e1cc7cf$var$drawerSagas;

});

parcelRegister("91m2T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65766d057035fda0$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("h7VOS");
var $kVHkf = parcelRequire("kVHkf");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $2kKDW = parcelRequire("2kKDW");

var $jOlj7 = parcelRequire("jOlj7");

var $dkkN8 = parcelRequire("dkkN8");
const $65766d057035fda0$export$f1a23c1a0096955c = 500;
function $65766d057035fda0$export$b5c227dbad8a1774() {
    return (0, $kVHkf.eventChannel)((emitter)=>{
        const setOnline = ()=>emitter(false);
        const setOffline = ()=>emitter(true);
        window.addEventListener("online", setOnline);
        window.addEventListener("offline", setOffline);
        return ()=>{
            window.removeEventListener("online", setOnline);
            window.removeEventListener("offline", setOffline);
        };
    });
}
function* $65766d057035fda0$var$notifyOnline() {
    yield (0, $5NpoY.Y)({
        type: (0, $dkkN8.NETWORK_ONLINE)
    });
    yield (0, $5NpoY.Y)((0, $2kKDW.dismissFlag)("network-offline"));
    yield (0, $5NpoY.S)($65766d057035fda0$export$f1a23c1a0096955c);
    yield (0, $5NpoY.Y)((0, $2kKDW.showFlagComponent)("network-online"));
}
function* $65766d057035fda0$var$notifyOffline() {
    yield (0, $5NpoY.Y)({
        type: (0, $dkkN8.NETWORK_OFFLINE)
    });
    yield (0, $5NpoY.Y)((0, $2kKDW.dismissFlag)("network-online"));
    yield (0, $5NpoY.S)($65766d057035fda0$export$f1a23c1a0096955c);
    yield (0, $5NpoY.Y)((0, $2kKDW.showFlagComponent)("network-offline"));
}
function* $65766d057035fda0$export$28a6e0eccf8bba89() {
    yield (0, $5NpoY.M)((0, $jOlj7.PAGE_VISIBLE));
    if (navigator.onLine) yield (0, $5NpoY.Y)((0, $2kKDW.dismissFlag)("network-offline"));
    else yield (0, $5NpoY.Y)((0, $2kKDW.dismissFlag)("network-online"));
}
function* $65766d057035fda0$export$2e2bcd8739ae039() {
    // @ts-ignore
    const offlineEventChannel = yield (0, $5NpoY.P)($65766d057035fda0$export$b5c227dbad8a1774);
    let prevNotifyTask;
    let dismissStuckFlagsTask;
    while(true){
        const isOffline = yield (0, $5NpoY.M)(offlineEventChannel);
        if (prevNotifyTask) {
            yield (0, $5NpoY.O)(prevNotifyTask);
            // @ts-ignore
            dismissStuckFlagsTask = yield (0, $5NpoY.N)($65766d057035fda0$export$28a6e0eccf8bba89);
        }
        if (document.visibilityState === "visible") {
            if (isOffline) // @ts-ignore
            prevNotifyTask = yield (0, $5NpoY.N)($65766d057035fda0$var$notifyOffline);
            else // @ts-ignore
            prevNotifyTask = yield (0, $5NpoY.N)($65766d057035fda0$var$notifyOnline);
            if (dismissStuckFlagsTask) yield (0, $5NpoY.O)(dismissStuckFlagsTask);
        }
    }
}

});
parcelRegister("jOlj7", function(module, exports) {

$parcel$export(module.exports, "PAGE_VISIBLE", function () { return $1cdba6df036d6946$export$e1b4968c853913be; });
$parcel$export(module.exports, "PageVisible", function () { return $1cdba6df036d6946$export$82660823720ee75c; });
$parcel$export(module.exports, "PAGE_HIDDEN", function () { return $1cdba6df036d6946$export$d8e33d11a8f54b1b; });
$parcel$export(module.exports, "PageHidden", function () { return $1cdba6df036d6946$export$a2dd39524295e002; });
const $1cdba6df036d6946$export$e1b4968c853913be = "global/PAGE_VISIBLE";
const $1cdba6df036d6946$export$82660823720ee75c = ()=>({
        type: $1cdba6df036d6946$export$e1b4968c853913be
    });
const $1cdba6df036d6946$export$d8e33d11a8f54b1b = "global/PAGE_HIDDEN";
const $1cdba6df036d6946$export$a2dd39524295e002 = ()=>({
        type: $1cdba6df036d6946$export$d8e33d11a8f54b1b
    });

});


parcelRegister("fr7bz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2df618e845e6af55$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("h7VOS");
var $kVHkf = parcelRequire("kVHkf");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $jOlj7 = parcelRequire("jOlj7");
function $2df618e845e6af55$var$createVisibilityChannel() {
    // @ts-ignore
    return (0, $kVHkf.eventChannel)((emit)=>{
        const change = ()=>{
            emit(document.hidden);
        };
        document.addEventListener("visibilitychange", change);
        return ()=>{
            document.removeEventListener("visibilitychange", change);
        };
    });
}
function* $2df618e845e6af55$export$2e2bcd8739ae039() {
    const channel = $2df618e845e6af55$var$createVisibilityChannel();
    while(true){
        // @ts-ignore
        const action = (yield (0, $5NpoY.M)(channel)) ? (0, $jOlj7.PageHidden)() : (0, $jOlj7.PageVisible)();
        yield (0, $5NpoY.Y)(action);
    }
}

});

parcelRegister("c9sCK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2c8c83cf05e4c54$export$2e2bcd8739ae039; });
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $bxEHe = parcelRequire("bxEHe");

var $1D6WP = parcelRequire("1D6WP");
function* $c2c8c83cf05e4c54$export$2e2bcd8739ae039(action) {
    const { payload: payload } = action;
    const { duration: duration = (0, $1D6WP.SCROLL_TO_DURATION), targetId: targetId, customBehavior: customBehavior, block: block = "start", inline: inline = "start" } = payload;
    const targetElement = document.getElementById(targetId);
    if (!targetElement) return null;
    const options = {
        behavior: customBehavior || "smooth",
        block: block,
        inline: inline,
        duration: customBehavior ? 0 : duration
    };
    yield (0, $5NpoY.P)((0, $bxEHe.default), targetElement, options);
    const targetNow = document.getElementById(targetId);
    const targetChanged = targetElement !== targetNow;
    // This helps compensate if intersection observation is used
    if (targetNow && targetChanged) yield (0, $5NpoY.P)((0, $bxEHe.default), targetNow, {
        behavior: "instant",
        block: block,
        inline: inline
    });
    return null;
}

});

parcelRegister("hR3ag", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e1e721d6e1bf959$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $g2R3c = parcelRequire("g2R3c");

var $j9gxd = parcelRequire("j9gxd");

var $dkkN8 = parcelRequire("dkkN8");
function* $6e1e721d6e1bf959$export$5a2306e30c690c6d(action) {
    const { payload: payload } = action;
    const isOpen = payload;
    const user = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
    if (user) yield (0, $5NpoY.P)((0, $j9gxd.default).set, user.uuid, "adg3-sidebar-closed", !isOpen);
}
function* $6e1e721d6e1bf959$var$toggleNavigationSaga() {
    yield (0, $jeUNF.takeLatest)((0, $dkkN8.TOGGLE_NAVIGATION_INIT), $6e1e721d6e1bf959$export$5a2306e30c690c6d);
}
var $6e1e721d6e1bf959$export$2e2bcd8739ae039 = $6e1e721d6e1bf959$var$toggleNavigationSaga;

});

parcelRegister("jIwpr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa486bd082666f7d$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $iAWzg = parcelRequire("iAWzg");

var $8MnfV = parcelRequire("8MnfV");

var $9vma5 = parcelRequire("9vma5");
function* $fa486bd082666f7d$export$2e2bcd8739ae039(action) {
    const isMobileHeaderActive = yield (0, $5NpoY.a3)((0, $8MnfV.getIsMobileHeaderActive));
    const isOpen = action.payload !== undefined && action.payload;
    if (isMobileHeaderActive && !isOpen) yield (0, $5NpoY.Y)((0, $iAWzg.default)("none"));
    else yield (0, $5NpoY.Y)((0, $9vma5.default)(action.payload));
}

});
parcelRegister("iAWzg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38f0c5ea701a92cd$export$2e2bcd8739ae039; });

var $dkkN8 = parcelRequire("dkkN8");
var $38f0c5ea701a92cd$export$2e2bcd8739ae039 = (nextState)=>({
        type: (0, $dkkN8.UPDATE_MOBILE_HEADER_STATE),
        payload: nextState
    });

});

parcelRegister("9vma5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a360b6c65aed6a78$export$2e2bcd8739ae039; });

var $dkkN8 = parcelRequire("dkkN8");
var $a360b6c65aed6a78$export$2e2bcd8739ae039 = (isOpen)=>{
    return {
        type: (0, $dkkN8.TOGGLE_NAVIGATION_INIT),
        payload: isOpen
    };
};

});


parcelRegister("plq9H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4eeefef51f0f668$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");
parcelRequire("erZj9");
var $g7vJB = parcelRequire("g7vJB");
var $fYcHx = parcelRequire("fYcHx");
var $9KZ2S = parcelRequire("9KZ2S");
var $3OKoD = parcelRequire("3OKoD");
var $5KwLw = parcelRequire("5KwLw");

var $64gC0 = parcelRequire("64gC0");

var $6mnkW = parcelRequire("6mnkW");

var $hUHA3 = parcelRequire("hUHA3");

var $epNrA = parcelRequire("epNrA");

var $4PGc7 = parcelRequire("4PGc7");

var $eapIg = parcelRequire("eapIg");
function* $f4eeefef51f0f668$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLatest)((0, $6D21P.ENTERED_CODE_REVIEW), (0, $eapIg.fetchTransitionUserPreference)),
        (0, $jeUNF.takeLatest)((0, $3OKoD.FETCH_JIRA_RELEVANT_ISSUES).REQUEST, (0, $4PGc7.fetchJiraRelevantIssuesSaga)),
        (0, $jeUNF.takeLatest)((0, $3OKoD.FETCH_DEV_ACTIVITY).REQUEST, (0, $4PGc7.fetchDevActivitySaga)),
        (0, $jeUNF.takeLatest)((0, $3OKoD.FETCH_JIRA_ASSIGNEES).REQUEST, (0, $4PGc7.fetchJiraAssigneesSaga)),
        (0, $jeUNF.takeLatest)((0, $3OKoD.INSTALL_ADDON_JIRA_TAB).REQUEST, (0, $hUHA3.installAddonJiraTabSaga)),
        (0, $jeUNF.takeLatest)((0, $3OKoD.INIT_JIRA_REPO_PAGE), (0, $4PGc7.initJiraRepoPageSaga)),
        (0, $jeUNF.takeLatest)((0, $3OKoD.FETCH_RELEVANT_JIRA_SITES).REQUEST, (0, $4PGc7.fetchRelevantJiraSitesSaga)),
        (0, $jeUNF.takeLatest)((0, $3OKoD.FETCH_JIRA_RELEVANT_ISSUES).SUCCESS, (0, $4PGc7.handleFetchRelevantIssuesSuccessSaga)),
        (0, $jeUNF.takeLatest)((0, $3OKoD.FETCH_RELEVANT_JIRA_SITES).SUCCESS, (0, $4PGc7.handleFetchRelevantSitesSuccessSaga)),
        (0, $jeUNF.takeLatest)((0, $3OKoD.FETCH_JIRA_SITES).REQUEST, (0, $4PGc7.fetchSitesSaga)),
        (0, $jeUNF.takeLatest)((0, $3OKoD.FETCH_JIRA_RELEVANT_PROJECTS).REQUEST, (0, $4PGc7.fetchJiraRelevantProjectsSaga)),
        (0, $4PGc7.debouncedFetchJiraProjectsSaga)(),
        (0, $jeUNF.takeLatest)((0, $3OKoD.FETCH_JIRA_RELEVANT_PROJECTS).SUCCESS, (0, $4PGc7.handleFetchRelevantProjectsSuccessSaga)),
        (0, $jeUNF.takeLatest)((0, $3OKoD.FETCH_JIRA_RELEVANT_PROJECTS).ERROR, (0, $4PGc7.updateEmptyStateForSelectedSite)),
        (0, $jeUNF.takeLatest)((0, $3OKoD.FETCH_WORKSPACE_PERMISSION).REQUEST, (0, $4PGc7.fetchWorkspacePermissionSaga)),
        (0, $jeUNF.takeLatest)((0, $g7vJB.FETCH_CONNECTED_JIRA_SITES).REQUEST, (0, $64gC0.fetchConnectedJiraSitesSaga)),
        (0, $jeUNF.takeLatest)((0, $g7vJB.FETCH_JIRA_ISSUE_CREATION_METADATA).REQUEST, (0, $64gC0.fetchJiraIssueCreationMetadataSaga)),
        (0, $jeUNF.takeLatest)((0, $g7vJB.CREATE_JIRA_ISSUE).REQUEST, (0, $64gC0.createJiraIssueSaga)),
        (0, $jeUNF.takeLatest)((0, $fYcHx.FETCH_PULL_REQUEST_JIRA_ISSUES).REQUEST, (0, $eapIg.fetchPullRequestJiraIssuesSaga)),
        (0, $jeUNF.takeLatest)((0, $g7vJB.CREATE_PR_JIRA_ISSUE).REQUEST, (0, $64gC0.createPrJiraIssueSaga)),
        (0, $jeUNF.takeLatest)((0, $fYcHx.FETCH_PULL_REQUEST_JIRA_ISSUES).REQUEST, (0, $eapIg.fetchPullRequestJiraIssuesSaga)),
        (0, $jeUNF.takeLatest)((0, $3OKoD.SET_ISSUE_ASSIGNEE).REQUEST, (0, $4PGc7.setIssueAssigneeSaga)),
        (0, $jeUNF.takeLatest)((0, $fYcHx.FETCH_AVAILABLE_ISSUE_TRANSITIONS).REQUEST, (0, $eapIg.fetchAvailableIssueTransitionsSaga)),
        (0, $jeUNF.takeLatest)((0, $fYcHx.FETCH_PULL_REQUEST_JIRA_ISSUES).SUCCESS, (0, $eapIg.initialiseIssueTransitions)),
        (0, $jeUNF.takeLatest)((0, $fYcHx.TRANSITION_ISSUES).REQUEST, (0, $eapIg.transitionIssuesSaga)),
        (0, $jeUNF.takeLatest)((0, $g7vJB.ON_UNSUPPORTED_FIELDS_ERROR), (0, $64gC0.handleUnsupportedFieldsErrorSaga)),
        (0, $jeUNF.takeLatest)((0, $g7vJB.ON_PR_UNSUPPORTED_FIELDS_ERROR), (0, $64gC0.handlePrUnsupportedFieldsErrorSaga)),
        (0, $jeUNF.takeLatest)((0, $g7vJB.FETCH_CREATE_JIRA_ISSUE_ONBOARDING_VIEWED).REQUEST, (0, $64gC0.fetchCreateJiraIssueOnboardingViewedSaga)),
        (0, $jeUNF.takeLatest)((0, $3OKoD.FETCH_JIRA_TAB_FILTERS_USER_PREFERENCE).REQUEST, (0, $4PGc7.fetchJiraTabFiltersUserPreferencesSaga)),
        (0, $jeUNF.takeLatest)((0, $g7vJB.FETCH_JIRA_TAB_CREATE_ISSUE_USER_PREFERENCE).REQUEST, (0, $64gC0.fetchJiraTabCreateIssueUserPreferencesSaga)),
        (0, $jeUNF.takeLatest)((0, $g7vJB.UPDATE_CREATE_JIRA_ISSUE_ONBOARDING_VIEWED).REQUEST, (0, $64gC0.updateCreateJiraIssueOnboardingViewedSaga)),
        (0, $jeUNF.takeLatest)((0, $g7vJB.FETCH_CREATE_JIRA_ISSUE_PREFERENCES).REQUEST, (0, $64gC0.fetchCreateJiraIssuePreferencesSaga)),
        (0, $jeUNF.takeLatest)((0, $g7vJB.UPDATE_CREATE_JIRA_ISSUE_PREFERENCES).REQUEST, (0, $64gC0.updateCreateJiraIssuePreferencesSaga)),
        (0, $jeUNF.takeLatest)((0, $g7vJB.INIT_CREATE_JIRA_ISSUE), (0, $64gC0.initCreateJiraIssueSaga)),
        (0, $jeUNF.takeLatest)((0, $9KZ2S.INIT_DASHBOARD_JIRA).REQUEST, (0, $6mnkW.initDashboardJira)),
        (0, $jeUNF.takeLatest)((0, $9KZ2S.ON_DASHBOARD_JIRA_SITE_CHANGE), (0, $6mnkW.onSelectedSiteChangeSaga)),
        (0, $jeUNF.takeLatest)((0, $9KZ2S.FETCH_DASHBOARD_JIRA_ISSUES).REQUEST, (0, $6mnkW.fetchDashboardJiraIssuesSaga)),
        (0, $jeUNF.takeLatest)((0, $9KZ2S.FETCH_DASHBOARD_DEV_ACTIVITY).REQUEST, (0, $6mnkW.fetchDashboardDevActivitySaga)),
        (0, $jeUNF.takeLatest)((0, $g7vJB.FETCH_JIRA_PROJECT).REQUEST, (0, $64gC0.fetchJiraProjectSaga)),
        (0, $jeUNF.takeLatest)((0, $3OKoD.FILTER_STATE).CHANGE, (0, $4PGc7.changeFilterStateSaga)),
        (0, $jeUNF.takeLatest)((0, $3OKoD.LINK_JIRA_PROJECT).REQUEST, (0, $4PGc7.linkJiraProjectSaga)),
        (0, $jeUNF.takeLatest)((0, $3OKoD.UNLINK_JIRA_PROJECT).REQUEST, (0, $4PGc7.unlinkJiraProjectSaga)),
        (0, $64gC0.fetchDebouncedJiraProjectsForSiteSaga)(),
        // Jira migration sagas
        (0, $jeUNF.takeLatest)((0, $5KwLw.FETCH_SITES_FOR_JIRA_MIGRATION).REQUEST, (0, $epNrA.fetchSitesForJiraMigrationSaga)),
        (0, $jeUNF.takeLatest)((0, $5KwLw.START_ISSUE_MIGRATION_TO_JIRA).REQUEST, (0, $epNrA.startIssueMigrationToJiraSaga)),
        (0, $jeUNF.takeLatest)((0, $5KwLw.FETCH_ISSUE_MIGRATION_TO_JIRA_LOGS).REQUEST, (0, $epNrA.fetchIssueMigrationToJiraLogsSaga)),
        (0, $jeUNF.takeLatest)((0, $5KwLw.INSTALL_ADDON_JIRA_MIGRATION).REQUEST, (0, $hUHA3.installAddonJiraMigrationSaga)),
        (0, $epNrA.issueMigrationToJiraStatusSaga)()
    ]);
}

});
parcelRegister("64gC0", function(module, exports) {

$parcel$export(module.exports, "initCreateJiraIssueSaga", function () { return $da817d17c56657ac$export$39ab2cf2adb4dd4f; });
$parcel$export(module.exports, "fetchConnectedJiraSitesSaga", function () { return $da817d17c56657ac$export$3fb57eb263d8136f; });
$parcel$export(module.exports, "fetchJiraProjectSaga", function () { return $da817d17c56657ac$export$18588010b53f76ca; });
$parcel$export(module.exports, "fetchDebouncedJiraProjectsForSiteSaga", function () { return $da817d17c56657ac$export$59daed417b223103; });
$parcel$export(module.exports, "fetchJiraIssueCreationMetadataSaga", function () { return $da817d17c56657ac$export$3f56d8dae0da4020; });
$parcel$export(module.exports, "fetchJiraTabCreateIssueUserPreferencesSaga", function () { return $da817d17c56657ac$export$f3cb7efc65f62361; });
$parcel$export(module.exports, "createJiraIssueSaga", function () { return $da817d17c56657ac$export$df7f60079be00012; });
$parcel$export(module.exports, "handleUnsupportedFieldsErrorSaga", function () { return $da817d17c56657ac$export$dd0dd29838621ee2; });
$parcel$export(module.exports, "handlePrUnsupportedFieldsErrorSaga", function () { return $da817d17c56657ac$export$d2afa673f25825ab; });
$parcel$export(module.exports, "createPrJiraIssueSaga", function () { return $da817d17c56657ac$export$46b76cbf7bffd5dc; });
$parcel$export(module.exports, "fetchCreateJiraIssueOnboardingViewedSaga", function () { return $da817d17c56657ac$export$344bb032c0560180; });
$parcel$export(module.exports, "updateCreateJiraIssueOnboardingViewedSaga", function () { return $da817d17c56657ac$export$ee26a9aa59bdd829; });
$parcel$export(module.exports, "fetchCreateJiraIssuePreferencesSaga", function () { return $da817d17c56657ac$export$10a8cb937fc5df43; });
$parcel$export(module.exports, "updateCreateJiraIssuePreferencesSaga", function () { return $da817d17c56657ac$export$728d93ac5cc82026; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $3XbtU = parcelRequire("3XbtU");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $90kWr = parcelRequire("90kWr");

var $2kKDW = parcelRequire("2kKDW");

var $lALYr = parcelRequire("lALYr");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");

var $8MnfV = parcelRequire("8MnfV");

var $aanBq = parcelRequire("aanBq");

var $g2R3c = parcelRequire("g2R3c");

var $4EtqP = parcelRequire("4EtqP");

var $6aoKW = parcelRequire("6aoKW");

var $k2cPS = parcelRequire("k2cPS");

var $j9gxd = parcelRequire("j9gxd");

var $628YF = parcelRequire("628YF");
parcelRequire("erZj9");
var $3OKoD = parcelRequire("3OKoD");
var $g7vJB = parcelRequire("g7vJB");
var $fYcHx = parcelRequire("fYcHx");

var $hahvB = parcelRequire("hahvB");

var $6jeXr = parcelRequire("6jeXr");

var $1wDb1 = parcelRequire("1wDb1");
function* $da817d17c56657ac$export$39ab2cf2adb4dd4f(action) {
    const { owner: owner, slug: slug } = action;
    const repositoryFullSlug = `${owner}/${slug}`;
    yield (0, $5NpoY.Y)((0, $g7vJB.fetchCreateJiraIssuePreferences)(repositoryFullSlug));
    yield (0, $5NpoY.Y)((0, $g7vJB.fetchConnectedJiraSites)());
}
function* $da817d17c56657ac$export$3fb57eb263d8136f() {
    try {
        const workspace = yield (0, $1wDb1.getWorkspace)();
        const url = (0, $4EtqP.default).api.internal.connectedSites(workspace.uuid);
        const request = (0, $k2cPS.default)(url);
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            // @ts-ignore
            const data = yield response.json();
            yield (0, $5NpoY.Y)({
                type: (0, $g7vJB.FETCH_CONNECTED_JIRA_SITES).SUCCESS,
                payload: data.values
            });
        } else {
            yield (0, $628YF.captureMessageForResponse)(response, "Fetching Jira sites in PR failed");
            yield (0, $5NpoY.Y)({
                type: (0, $g7vJB.FETCH_CONNECTED_JIRA_SITES).ERROR
            });
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $g7vJB.FETCH_CONNECTED_JIRA_SITES).ERROR
        });
    }
}
function* $da817d17c56657ac$export$18588010b53f76ca({ payload: payload }) {
    const { cloudId: cloudId, projectId: projectId } = payload;
    try {
        const workspace = yield (0, $1wDb1.getWorkspace)();
        const url = (0, $4EtqP.default).api.internal.project(workspace.uuid, cloudId, projectId);
        const request = (0, $k2cPS.default)(url);
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            // @ts-ignore
            const data = yield response.json();
            yield (0, $5NpoY.Y)({
                type: (0, $g7vJB.FETCH_JIRA_PROJECT).SUCCESS,
                payload: {
                    [cloudId]: {
                        project: data,
                        fetchedStatus: (0, $90kWr.LoadingStatus).Success
                    }
                }
            });
        } else {
            yield (0, $628YF.captureMessageForResponse)(response, "Fetching Jira project failed");
            yield (0, $5NpoY.Y)({
                type: (0, $g7vJB.FETCH_JIRA_PROJECT).ERROR,
                payload: {
                    [cloudId]: {
                        project: {},
                        fetchedStatus: (0, $90kWr.LoadingStatus).Failed
                    }
                }
            });
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $g7vJB.FETCH_JIRA_PROJECT).ERROR,
            payload: {
                [cloudId]: {
                    project: {},
                    fetchedStatus: (0, $90kWr.LoadingStatus).Failed
                }
            }
        });
    }
}
function* $da817d17c56657ac$export$ac178b6be5634066({ payload: payload }) {
    const { site: site, projectFilter: projectFilter, commentId: commentId } = payload;
    const cloudId = site ? site.cloudId : "";
    try {
        const workspace = yield (0, $1wDb1.getWorkspace)();
        const url = (0, $4EtqP.default).api.internal.projects(workspace.uuid, cloudId, projectFilter);
        const request = (0, $k2cPS.default)(url);
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.status === 403) yield (0, $5NpoY.Y)({
            type: (0, $g7vJB.FETCH_JIRA_PROJECTS_FOR_SITE).ERROR,
            payload: {
                [cloudId]: {
                    list: [],
                    fetchedStatus: (0, $90kWr.LoadingStatus).Forbidden
                }
            }
        });
        else if (!response.ok) {
            yield (0, $628YF.captureMessageForResponse)(response, "Fetching Jira projects for a site failed");
            yield (0, $5NpoY.Y)({
                type: (0, $g7vJB.FETCH_JIRA_PROJECTS_FOR_SITE).ERROR,
                payload: {
                    [cloudId]: {
                        list: [],
                        fetchedStatus: (0, $90kWr.LoadingStatus).Failed
                    }
                }
            });
        } else {
            // @ts-ignore
            const data = yield response.json();
            yield (0, $5NpoY.Y)({
                type: (0, $g7vJB.FETCH_JIRA_PROJECTS_FOR_SITE).SUCCESS,
                payload: {
                    [commentId]: {
                        [cloudId]: {
                            list: data.values,
                            fetchedStatus: (0, $90kWr.LoadingStatus).Success
                        }
                    }
                }
            });
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $g7vJB.FETCH_JIRA_PROJECTS_FOR_SITE).ERROR,
            payload: {
                [cloudId]: {
                    list: [],
                    fetchedStatus: (0, $90kWr.LoadingStatus).Failed
                }
            }
        });
    }
}
function* $da817d17c56657ac$export$59daed417b223103() {
    yield (0, $jeUNF.debounce)(400, (0, $g7vJB.FETCH_JIRA_PROJECTS_FOR_SITE).REQUEST, $da817d17c56657ac$export$ac178b6be5634066);
}
function* $da817d17c56657ac$export$3f56d8dae0da4020({ payload: payload }) {
    if (!payload) return;
    const { cloudId: cloudId, projectId: projectId } = payload;
    try {
        const workspace = yield (0, $1wDb1.getWorkspace)();
        const url = (0, $4EtqP.default).api.internal.issueCreationMetadata(workspace.uuid, cloudId, projectId);
        const request = (0, $k2cPS.default)(url);
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (!response.ok) {
            const { status: status } = response;
            if (status === 403) yield (0, $5NpoY.Y)({
                type: (0, $g7vJB.FETCH_JIRA_ISSUE_CREATION_METADATA).ERROR,
                payload: {
                    cloudId: cloudId,
                    projectId: projectId,
                    fetchedStatus: (0, $90kWr.LoadingStatus).Forbidden
                }
            });
            else {
                yield (0, $628YF.captureMessageForResponse)(response, "Fetching Jira issue creation metadata failed");
                yield (0, $5NpoY.Y)({
                    type: (0, $g7vJB.FETCH_JIRA_ISSUE_CREATION_METADATA).ERROR,
                    payload: {
                        cloudId: cloudId,
                        fetchedStatus: (0, $90kWr.LoadingStatus).Failed,
                        projectId: projectId
                    }
                });
            }
        } else {
            // @ts-ignore
            const data = yield response.json();
            // Filter "subtask" out
            const issueTypes = (data.issuetypes || []).filter(// @ts-ignore TODO: fix noImplicitAny error here
            ({ subtask: subtask })=>!subtask);
            yield (0, $5NpoY.Y)({
                type: (0, $g7vJB.FETCH_JIRA_ISSUE_CREATION_METADATA).SUCCESS,
                payload: {
                    cloudId: cloudId,
                    projectId: projectId,
                    issueTypes: issueTypes
                }
            });
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $g7vJB.FETCH_JIRA_ISSUE_CREATION_METADATA).ERROR,
            payload: {
                cloudId: cloudId,
                projectId: projectId,
                fetchedStatus: (0, $90kWr.LoadingStatus).Failed
            }
        });
    }
}
function* $da817d17c56657ac$export$f02e4d74f8f7e1e6() {
    const currentUser = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
    if (!currentUser) return;
    const repositoryUuid = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryUuid));
    const preferences = yield (0, $5NpoY.a3)((0, $lALYr.getCreateJiraIssuePreferences));
    try {
        if (preferences.value) yield (0, $5NpoY.P)((0, $j9gxd.default).set, currentUser.uuid, (0, $6jeXr.createJiraTabCreateIssueUserPreferencesKey)(repositoryUuid), JSON.stringify(preferences.value));
    } catch (e) {
        $3XbtU.captureException(e);
    }
}
function* $da817d17c56657ac$export$f3cb7efc65f62361() {
    const { status: status } = yield (0, $5NpoY.a3)((0, $8MnfV.getRepositoryPageLoadingStatus));
    if (status !== (0, $90kWr.LoadingStatus).Success) yield (0, $5NpoY.M)((0, $jJd6W.LoadRepositoryPage).SUCCESS);
    const currentUser = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
    const repositoryUuid = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryUuid));
    try {
        if (currentUser) {
            // @ts-ignore
            const preferencesRaw = yield (0, $5NpoY.P)((0, $j9gxd.default).get, currentUser.uuid, (0, $6jeXr.createJiraTabCreateIssueUserPreferencesKey)(repositoryUuid));
            const preferences = preferencesRaw && preferencesRaw !== "undefined" ? JSON.parse(preferencesRaw) : undefined;
            if (preferences) yield (0, $5NpoY.Y)({
                type: (0, $g7vJB.FETCH_JIRA_TAB_CREATE_ISSUE_USER_PREFERENCE).SUCCESS,
                payload: preferences
            });
            else yield (0, $5NpoY.Y)({
                type: (0, $g7vJB.FETCH_JIRA_TAB_CREATE_ISSUE_USER_PREFERENCE).ERROR
            });
        } else // Put ERROR action for an anonymous user.
        yield (0, $5NpoY.Y)({
            type: (0, $g7vJB.FETCH_JIRA_TAB_CREATE_ISSUE_USER_PREFERENCE).ERROR
        });
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $g7vJB.FETCH_JIRA_TAB_CREATE_ISSUE_USER_PREFERENCE).ERROR
        });
        $3XbtU.captureException(e);
    }
}
function* $da817d17c56657ac$export$df7f60079be00012({ payload: payload }) {
    const repositoryFullSlug = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryFullSlug));
    if (!payload) return;
    const url = (0, $4EtqP.default).api.internal.jiraIssues(repositoryFullSlug);
    try {
        const request = (0, $k2cPS.default)(url, {
            headers: {
                "Content-Type": "application/json"
            }
        });
        const response = yield (0, $5NpoY.P)(fetch, request, {
            method: "POST",
            body: JSON.stringify(payload)
        });
        if (response.ok) {
            const createdIssue = yield response.json();
            // Issue returned from the backend has only reference to the project,
            // whereas we need its key and name, so fill them in since we have them at hand
            const newIssue = {
                ...createdIssue,
                project: {
                    ...createdIssue.project,
                    key: payload.projectKey,
                    name: payload.projectName
                }
            };
            yield (0, $5NpoY.P)((0, $6aoKW.publishTrackEvent), {
                action: "created",
                actionSubject: "issue",
                actionSubjectId: newIssue.id,
                source: "jiraTab"
            });
            // Order is important here: the flag requires the issue to be stored
            // in the Redux state, so we need to call the reducer first
            yield (0, $5NpoY.Y)({
                type: (0, $g7vJB.CREATE_JIRA_ISSUE).SUCCESS,
                payload: newIssue
            });
            yield (0, $5NpoY.Y)((0, $2kKDW.showFlagComponent)("create-jira-issue-success"));
            yield (0, $5NpoY.Y)((0, $3OKoD.changeIsCreateIssueDialogOpen)(false));
            yield (0, $5NpoY.P)($da817d17c56657ac$export$f02e4d74f8f7e1e6);
            yield (0, $5NpoY.Y)((0, $3OKoD.fetchJiraRelevantIssues)());
        } else {
            yield (0, $628YF.captureMessageForResponse)(response, "Creating Jira issue failed");
            yield (0, $5NpoY.Y)({
                type: (0, $g7vJB.CREATE_JIRA_ISSUE).ERROR,
                payload: {
                    failureReason: (0, $hahvB.IssueCreationFailureReason).Unknown
                }
            });
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $g7vJB.CREATE_JIRA_ISSUE).ERROR,
            payload: {
                failureReason: (0, $hahvB.IssueCreationFailureReason).Unknown
            }
        });
    }
}
const $da817d17c56657ac$var$supportedFields = [
    "issuetype",
    "summary",
    "project",
    "reporter"
];
const $da817d17c56657ac$var$hasUnsupportedFields = (issueType)=>{
    if (issueType.fields) {
        const { fields: fields } = issueType;
        return Object.keys(fields).some((fieldKey)=>{
            if (fields[fieldKey] && fields[fieldKey].required) // Check if any of the required fields are not supported
            return !$da817d17c56657ac$var$supportedFields.find((f)=>f === fieldKey);
            return false;
        });
    }
    return false;
};
function* $da817d17c56657ac$export$dd0dd29838621ee2({ payload: payload }) {
    const { issueType: issueType } = payload;
    if ($da817d17c56657ac$var$hasUnsupportedFields(issueType)) yield (0, $5NpoY.Y)((0, $g7vJB.setFormErrorState)({
        failureReason: (0, $hahvB.IssueCreationFailureReason).UnsupportedFields,
        status: (0, $90kWr.LoadingStatus).Failed
    }));
    else yield (0, $5NpoY.Y)((0, $g7vJB.setFormErrorState)({
        failureReason: (0, $hahvB.IssueCreationFailureReason).None,
        status: (0, $90kWr.LoadingStatus).Before
    }));
}
function* $da817d17c56657ac$export$d2afa673f25825ab({ payload: payload }) {
    const { issueType: issueType, commentId: commentId } = payload;
    if ($da817d17c56657ac$var$hasUnsupportedFields(issueType)) yield (0, $5NpoY.Y)((0, $g7vJB.setPrFormErrorState)({
        commentId: commentId,
        failureReason: (0, $hahvB.IssueCreationFailureReason).UnsupportedFields,
        status: (0, $90kWr.LoadingStatus).Failed
    }));
    else yield (0, $5NpoY.Y)((0, $g7vJB.setPrFormErrorState)({
        commentId: commentId,
        failureReason: (0, $hahvB.IssueCreationFailureReason).None,
        status: (0, $90kWr.LoadingStatus).Before
    }));
}
function* $da817d17c56657ac$export$46b76cbf7bffd5dc({ payload: payload }) {
    const repositoryFullSlug = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryFullSlug));
    if (!payload) return;
    const { pullRequestId: pullRequestId, ...requestPayload } = payload;
    try {
        const url = (0, $4EtqP.default).api.internal.issues(repositoryFullSlug, pullRequestId);
        const request = (0, $k2cPS.default)(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(requestPayload)
        });
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            // Hide the form after successful creation.
            yield (0, $5NpoY.Y)((0, $g7vJB.onCreateJiraIssueFormChangeVisibility)({
                commentId: payload.commentId,
                isVisible: false
            }));
            // Update the Jira issues list to include the newly created issue
            // @ts-ignore
            const newIssue = yield response.json();
            yield (0, $5NpoY.Y)((0, $fYcHx.updateJiraIssuesListAfterCreation)(newIssue));
            yield (0, $5NpoY.Y)({
                type: (0, $g7vJB.CREATE_PR_JIRA_ISSUE).SUCCESS,
                payload: {
                    commentId: payload.commentId
                }
            });
            yield (0, $5NpoY.Y)((0, $g7vJB.updateCreateJiraIssuePreferences)({
                cloudId: requestPayload.cloudId,
                projectId: requestPayload.projectId,
                repositoryFullSlug: repositoryFullSlug
            }));
        } else {
            yield (0, $628YF.captureMessageForResponse)(response, "Creating Jira issue failed");
            yield (0, $5NpoY.Y)({
                type: (0, $g7vJB.CREATE_PR_JIRA_ISSUE).ERROR,
                payload: {
                    commentId: payload.commentId,
                    failureReason: (0, $hahvB.IssueCreationFailureReason).Unknown
                }
            });
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $g7vJB.CREATE_PR_JIRA_ISSUE).ERROR,
            payload: {
                commentId: payload.commentId,
                failureReason: (0, $hahvB.IssueCreationFailureReason).Unknown
            }
        });
    }
}
function* $da817d17c56657ac$export$344bb032c0560180() {
    const user = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
    if (!user || !user.uuid) return;
    try {
        // @ts-ignore
        const onboardingViewed = yield (0, $5NpoY.P)((0, $j9gxd.default).get, user.uuid, (0, $hahvB.ONBOARDING_VIEWED_PREF_KEY));
        // If onboardingViewed = undefined, the preference hasn't set yet.
        // Which means the user has not seen the onboarding.
        yield (0, $5NpoY.Y)({
            type: (0, $g7vJB.FETCH_CREATE_JIRA_ISSUE_ONBOARDING_VIEWED).SUCCESS,
            payload: onboardingViewed || (0, $hahvB.OnboardingViewed).Unseen
        });
    } catch  {
        $3XbtU.captureException(`Failed to get the ${(0, $hahvB.ONBOARDING_VIEWED_PREF_KEY)} preference`);
        // If fetching the preference fails for any reason, assume the user
        // has seen onboarding already. We don't want to show the onboarding more than once.
        yield (0, $5NpoY.Y)({
            type: (0, $g7vJB.FETCH_CREATE_JIRA_ISSUE_ONBOARDING_VIEWED).SUCCESS,
            payload: (0, $hahvB.OnboardingViewed).Seen
        });
    }
}
function* $da817d17c56657ac$export$ee26a9aa59bdd829({ payload: onboardingViewed }) {
    const user = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
    if (!user || !user.uuid) return;
    try {
        yield (0, $5NpoY.P)((0, $j9gxd.default).set, user.uuid, (0, $hahvB.ONBOARDING_VIEWED_PREF_KEY), onboardingViewed);
        yield (0, $5NpoY.Y)({
            type: (0, $g7vJB.UPDATE_CREATE_JIRA_ISSUE_ONBOARDING_VIEWED).SUCCESS,
            payload: onboardingViewed
        });
    } catch (e) {
        $3XbtU.captureException(e);
        // If setting the preference fails for any reason, set viewed == SEEN.
        // We don't want to show the onboarding more than once.
        yield (0, $5NpoY.Y)({
            type: (0, $g7vJB.UPDATE_CREATE_JIRA_ISSUE_ONBOARDING_VIEWED).SUCCESS,
            payload: (0, $hahvB.OnboardingViewed).Seen
        });
    }
}
function* $da817d17c56657ac$export$10a8cb937fc5df43({ payload: payload }) {
    const user = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
    if (!user || !user.uuid) return;
    const { repositoryFullSlug: repositoryFullSlug } = payload;
    try {
        // @ts-ignore
        const preferencesRaw = yield (0, $5NpoY.P)((0, $j9gxd.default).get, user.uuid, (0, $6jeXr.createJiraIssueUserPreferencesKey)(repositoryFullSlug));
        const preferences = preferencesRaw ? JSON.parse(preferencesRaw) : undefined;
        yield (0, $5NpoY.Y)({
            type: (0, $g7vJB.FETCH_CREATE_JIRA_ISSUE_PREFERENCES).SUCCESS,
            payload: preferences
        });
        if (preferences) yield (0, $5NpoY.Y)((0, $g7vJB.fetchJiraProject)({
            cloudId: preferences.cloudId,
            projectId: preferences.projectId
        }));
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $g7vJB.FETCH_CREATE_JIRA_ISSUE_PREFERENCES).ERROR
        });
    }
}
function* $da817d17c56657ac$export$728d93ac5cc82026({ payload: payload }) {
    const user = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
    if (!user || !user.uuid) return;
    const { cloudId: cloudId, projectId: projectId, repositoryFullSlug: repositoryFullSlug } = payload;
    const preferences = {
        cloudId: cloudId,
        projectId: projectId
    };
    try {
        yield (0, $5NpoY.P)((0, $j9gxd.default).set, user.uuid, (0, $6jeXr.createJiraIssueUserPreferencesKey)(repositoryFullSlug), JSON.stringify(preferences));
        yield (0, $5NpoY.Y)({
            type: (0, $g7vJB.UPDATE_CREATE_JIRA_ISSUE_PREFERENCES).SUCCESS,
            payload: preferences
        });
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $g7vJB.UPDATE_CREATE_JIRA_ISSUE_PREFERENCES).ERROR
        });
    }
}

});
parcelRegister("hahvB", function(module, exports) {

$parcel$export(module.exports, "AppInstalledStatus", function () { return $9334de49207164a3$export$44fda8df845246e4; });
$parcel$export(module.exports, "EmptyStateKind", function () { return $9334de49207164a3$export$1a69f1982298d317; });
$parcel$export(module.exports, "IssueCreationFailureReason", function () { return $9334de49207164a3$export$c69eff2f84ff59e; });
$parcel$export(module.exports, "OnboardingViewed", function () { return $9334de49207164a3$export$dedbf8d2ee80c1e7; });
$parcel$export(module.exports, "DevActivityKind", function () { return $9334de49207164a3$export$93e68a94df2b919f; });
$parcel$export(module.exports, "IssueCategory", function () { return $9334de49207164a3$export$f34b5d276fa0a9a9; });
$parcel$export(module.exports, "IssueMigrationCurrentStep", function () { return $9334de49207164a3$export$c6ba5a4ac86f228a; });
$parcel$export(module.exports, "ONBOARDING_VIEWED_PREF_KEY", function () { return $9334de49207164a3$export$5c64402125a25377; });
$parcel$export(module.exports, "UNASSIGNED_USER_ID", function () { return $9334de49207164a3$export$12e572fd459c10dc; });
var $9334de49207164a3$export$44fda8df845246e4;
(function(AppInstalledStatus) {
    AppInstalledStatus["Before"] = "BEFORE";
    AppInstalledStatus["Fetching"] = "FETCHING";
    AppInstalledStatus["NotInstalled"] = "NOT_INSTALLED";
    AppInstalledStatus["Installed"] = "INSTALLED";
    AppInstalledStatus["Installing"] = "INSTALLING";
    AppInstalledStatus["FailedToInstall"] = "FAILED_TO_INSTALL";
    AppInstalledStatus["FailedToFetch"] = "FAILED_TO_FETCH";
})($9334de49207164a3$export$44fda8df845246e4 || ($9334de49207164a3$export$44fda8df845246e4 = {}));
var $9334de49207164a3$export$1a69f1982298d317;
(function(EmptyStateKind) {
    EmptyStateKind["Before"] = "BEFORE";
    EmptyStateKind["None"] = "NONE";
    EmptyStateKind["HasAvailableSites"] = "HAS_AVAILABLE_SITES";
    EmptyStateKind["HasNoAvailableSites"] = "HAS_NO_AVAILABLE_SITES";
    EmptyStateKind["HasNoRelevantProjects"] = "HAS_NO_RELEVANT_PROJECTS";
    EmptyStateKind["HasNoAccessibleRelevantProjects"] = "HAS_NO_ACCESSIBLE_RELEVANT_PROJECTS";
    EmptyStateKind["HasNoAccessibleRelevantSites"] = "HAS_NO_ACCESSIBLE_RELEVANT_SITES";
})($9334de49207164a3$export$1a69f1982298d317 || ($9334de49207164a3$export$1a69f1982298d317 = {}));
var $9334de49207164a3$export$c69eff2f84ff59e;
(function(IssueCreationFailureReason) {
    IssueCreationFailureReason["None"] = "NONE";
    IssueCreationFailureReason["Unknown"] = "UNKNOWN";
    IssueCreationFailureReason["UnsupportedFields"] = "UNSUPPORTED_FIELDS";
})($9334de49207164a3$export$c69eff2f84ff59e || ($9334de49207164a3$export$c69eff2f84ff59e = {}));
var $9334de49207164a3$export$dedbf8d2ee80c1e7;
(function(OnboardingViewed) {
    OnboardingViewed["Seen"] = "SEEN";
    OnboardingViewed["Unseen"] = "UNSEEN";
})($9334de49207164a3$export$dedbf8d2ee80c1e7 || ($9334de49207164a3$export$dedbf8d2ee80c1e7 = {}));
var $9334de49207164a3$export$93e68a94df2b919f;
(function(DevActivityKind) {
    DevActivityKind["Branch"] = "branch";
    // This is named 'repository' to conform to Jira's naming conventions.
    // It really represents a commit made against an issue.
    DevActivityKind["Commit"] = "repository";
    DevActivityKind["PullRequest"] = "pullrequest";
    DevActivityKind["Deployment"] = "deployment";
})($9334de49207164a3$export$93e68a94df2b919f || ($9334de49207164a3$export$93e68a94df2b919f = {}));
var $9334de49207164a3$export$f34b5d276fa0a9a9;
(function(IssueCategory) {
    IssueCategory["Todo"] = "new";
    IssueCategory["InProgress"] = "indeterminate";
    IssueCategory["Done"] = "done";
})($9334de49207164a3$export$f34b5d276fa0a9a9 || ($9334de49207164a3$export$f34b5d276fa0a9a9 = {}));
var $9334de49207164a3$export$c6ba5a4ac86f228a;
(function(IssueMigrationCurrentStep) {
    IssueMigrationCurrentStep["Exporting"] = "EXPORTING";
    IssueMigrationCurrentStep["Importing"] = "IMPORTING";
    IssueMigrationCurrentStep["Finished"] = "FINISHED";
    IssueMigrationCurrentStep["Failed"] = "FAILED";
})($9334de49207164a3$export$c6ba5a4ac86f228a || ($9334de49207164a3$export$c6ba5a4ac86f228a = {}));
const $9334de49207164a3$export$5c64402125a25377 = "viewed-create-jira-issue-onboarding";
const $9334de49207164a3$export$12e572fd459c10dc = "EMPTY";

});

parcelRegister("6jeXr", function(module, exports) {

$parcel$export(module.exports, "createJiraIssueUserPreferencesKey", function () { return $9cd201c427ce9d44$export$dec8eaf842d1e037; });
$parcel$export(module.exports, "createJiraTabFiltersUserPreferencesKey", function () { return $9cd201c427ce9d44$export$8fb41d49f4d6a4fb; });
$parcel$export(module.exports, "createJiraTabCreateIssueUserPreferencesKey", function () { return $9cd201c427ce9d44$export$cad35aa0d2ea9a77; });
const $9cd201c427ce9d44$export$dec8eaf842d1e037 = (repoUuid)=>`default-jira-project:${repoUuid}`;
const $9cd201c427ce9d44$export$8fb41d49f4d6a4fb = (repoUuid)=>`jira-tab:filters:${repoUuid}`;
const $9cd201c427ce9d44$export$cad35aa0d2ea9a77 = (repoUuid)=>`jira-tab:create-issue:${repoUuid}`;

});

parcelRegister("1wDb1", function(module, exports) {

$parcel$export(module.exports, "getWorkspace", function () { return $dfe8ef6de6d21f0c$export$9c41d1c3b33f9caa; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");

var $aanBq = parcelRequire("aanBq");
function* $dfe8ef6de6d21f0c$export$9c41d1c3b33f9caa() {
    var _owner;
    // Unfortunately `workspace` is not reliably present on LoadRepositoryPage.SUCCESS,
    // and since at the moment we only need workspace UUID, fetch the `owner` instead
    // which appears to be more reliable (always comes with `repository` object itself).
    // In the future, when workspace becomes first class citizen in Frontbucket,
    // this will need to be replaced with the proper `workspace` object.
    let owner = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryOwner));
    if (!owner) {
        // Wait for the current repository page to be loaded
        // so that `repository` object becomes available
        yield (0, $5NpoY.M)((0, $jJd6W.LoadRepositoryPage).SUCCESS);
        owner = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryOwner));
    }
    return {
        uuid: (_owner = owner) === null || _owner === void 0 ? void 0 : _owner.uuid
    };
}

});


parcelRegister("6mnkW", function(module, exports) {

$parcel$export(module.exports, "initDashboardJira", function () { return $4a4436916893a51a$export$42c4e9ce54bce615; });
$parcel$export(module.exports, "onSelectedSiteChangeSaga", function () { return $4a4436916893a51a$export$6226fc24f261c39c; });
$parcel$export(module.exports, "fetchDashboardJiraIssuesSaga", function () { return $4a4436916893a51a$export$9c1f2e53a76e5251; });
$parcel$export(module.exports, "fetchDashboardDevActivitySaga", function () { return $4a4436916893a51a$export$7804c754b480291d; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $3XbtU = parcelRequire("3XbtU");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $g2R3c = parcelRequire("g2R3c");

var $4EtqP = parcelRequire("4EtqP");

var $k2cPS = parcelRequire("k2cPS");

var $j9gxd = parcelRequire("j9gxd");

var $628YF = parcelRequire("628YF");
parcelRequire("erZj9");
var $9KZ2S = parcelRequire("9KZ2S");

var $gAff5 = parcelRequire("gAff5");
const $4a4436916893a51a$var$SITE_PREFERENCE_KEY = "dashboard:jira-issues:site";
function* $4a4436916893a51a$export$5f27a3bbdcd96e98() {
    const user = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
    if (user) try {
        // @ts-ignore
        const selectedSiteCloudId = yield (0, $5NpoY.P)((0, $j9gxd.default).get, user.uuid, $4a4436916893a51a$var$SITE_PREFERENCE_KEY);
        yield (0, $5NpoY.Y)((0, $9KZ2S.setDashboardJiraDefaultCloudId)(selectedSiteCloudId));
        return selectedSiteCloudId;
    } catch (e) {
        $3XbtU.captureException(e);
        return undefined;
    }
    else return undefined;
}
function* $4a4436916893a51a$export$9fcfef832e467966(cloudId) {
    const user = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
    if (user) try {
        if (cloudId === "") yield (0, $5NpoY.P)((0, $j9gxd.default).delete, user.uuid, $4a4436916893a51a$var$SITE_PREFERENCE_KEY);
        else yield (0, $5NpoY.P)((0, $j9gxd.default).set, user.uuid, $4a4436916893a51a$var$SITE_PREFERENCE_KEY, cloudId);
    } catch (e) {
        $3XbtU.captureException(e);
    }
}
function* $4a4436916893a51a$export$42c4e9ce54bce615() {
    try {
        const [availableSites, defaultSiteCloudId] = yield (0, $5NpoY._)([
            (0, $5NpoY.P)((0, $gAff5.fetchAvailableJiraSitesSaga)),
            (0, $5NpoY.P)($4a4436916893a51a$export$5f27a3bbdcd96e98)
        ]);
        if (availableSites === undefined) {
            yield (0, $5NpoY.Y)({
                type: (0, $9KZ2S.INIT_DASHBOARD_JIRA).ERROR
            });
            return;
        }
        if (availableSites.length === 0) {
            if (defaultSiteCloudId) // Clear the preference
            yield (0, $5NpoY.P)($4a4436916893a51a$export$9fcfef832e467966, "");
            yield (0, $5NpoY.Y)({
                type: (0, $9KZ2S.INIT_DASHBOARD_JIRA).SUCCESS,
                payload: {
                    selectedSite: undefined,
                    availableSites: []
                }
            });
            return;
        }
        const selectedSite = availableSites.find((site)=>site.cloudId === defaultSiteCloudId) || availableSites[0];
        yield (0, $5NpoY.Y)({
            type: (0, $9KZ2S.INIT_DASHBOARD_JIRA).SUCCESS,
            payload: {
                selectedSite: selectedSite,
                availableSites: availableSites
            }
        });
        yield (0, $5NpoY.Y)((0, $9KZ2S.fetchDashboardJiraIssues)(selectedSite));
        if (!defaultSiteCloudId) // If we haven't saved the selected site as a preference yet, save it now so that in case the sites change, we
        // don't suddenly pick a different one for the user. By saving it, it will just stay the same as the initial
        // selection.
        yield (0, $5NpoY.P)($4a4436916893a51a$export$9fcfef832e467966, selectedSite.cloudId);
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $9KZ2S.INIT_DASHBOARD_JIRA).ERROR
        });
    }
}
function* $4a4436916893a51a$export$6226fc24f261c39c({ payload: payload }) {
    if (payload) yield (0, $5NpoY._)([
        (0, $5NpoY.P)($4a4436916893a51a$export$9fcfef832e467966, payload.cloudId),
        (0, $5NpoY.Y)((0, $9KZ2S.fetchDashboardJiraIssues)(payload))
    ]);
}
function* $4a4436916893a51a$export$9c1f2e53a76e5251({ payload: payload }) {
    if (!payload) return;
    try {
        const url = (0, $4EtqP.default).api.internal.myIssues(payload.cloudId, 15);
        const request = (0, $k2cPS.default)(url);
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            // @ts-ignore
            const data = yield response.json();
            yield (0, $5NpoY.Y)({
                type: (0, $9KZ2S.FETCH_DASHBOARD_JIRA_ISSUES).SUCCESS,
                payload: {
                    jiraIssues: data.values,
                    jiraIssuesCount: data.size,
                    jiraIssuesJql: data.links.jira.jql
                }
            });
            yield (0, $5NpoY.Y)((0, $9KZ2S.fetchDashboardDevActivity)({
                cloudId: payload.cloudId,
                // @ts-ignore TODO: fix noImplicitAny error here
                issueIds: data.values.map((val)=>val.id)
            }));
        } else {
            yield (0, $628YF.captureMessageForResponse)(response, "Fetching dashboard Jira issues failed");
            yield (0, $5NpoY.Y)({
                type: (0, $9KZ2S.FETCH_DASHBOARD_JIRA_ISSUES).ERROR
            });
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $9KZ2S.FETCH_DASHBOARD_JIRA_ISSUES).ERROR
        });
    }
}
function* $4a4436916893a51a$export$7804c754b480291d({ payload: payload }) {
    if (!payload) return;
    const { cloudId: cloudId, issueIds: issueIds } = payload;
    try {
        const url = (0, $4EtqP.default).api.internal.dashboardDevActivity(cloudId);
        const request = (0, $k2cPS.default)(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                issueIds: issueIds
            })
        });
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            // @ts-ignore
            const data = yield response.json();
            yield (0, $5NpoY.Y)({
                type: (0, $9KZ2S.FETCH_DASHBOARD_DEV_ACTIVITY).SUCCESS,
                payload: data ? {
                    [cloudId]: data.activity
                } : {}
            });
        } else {
            yield (0, $628YF.captureMessageForResponse)(response, "Fetching dashboard Jira issues dev activity information failed");
            yield (0, $5NpoY.Y)({
                type: (0, $9KZ2S.FETCH_DASHBOARD_DEV_ACTIVITY).ERROR
            });
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $9KZ2S.FETCH_DASHBOARD_DEV_ACTIVITY).ERROR
        });
    }
}

});
parcelRegister("gAff5", function(module, exports) {

$parcel$export(module.exports, "fetchAvailableJiraSitesSaga", function () { return $556ef96a9a1d2837$export$aaa0c26e83937f0b; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $1gtcM = parcelRequire("1gtcM");

var $g2R3c = parcelRequire("g2R3c");

var $k2cPS = parcelRequire("k2cPS");

var $628YF = parcelRequire("628YF");
function* $556ef96a9a1d2837$export$aaa0c26e83937f0b() {
    const isAnonymousUser = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUserIsAnonymous));
    if (isAnonymousUser) return [];
    const url = (0, $1gtcM.default).api.gateway.aisAvailableProducts();
    const request = (0, $k2cPS.default)(url);
    const response = yield (0, $5NpoY.P)(fetch, request);
    if (response.ok) {
        // @ts-ignore
        const data = yield response.json();
        // @ts-ignore TODO: fix noImplicitAny error here
        const sites = data.sites.filter((s)=>// @ts-ignore TODO: fix noImplicitAny error here
            s.products.find((p)=>p === "jira-software.ondemand"));
        // @ts-ignore TODO: fix noImplicitAny error here
        sites.sort((a, b)=>a.displayName.localeCompare(b.displayName));
        return sites;
    } else if (response.status === 401) return undefined;
    else {
        yield (0, $628YF.captureMessageForResponse)(response, "Fetching dashboard Jira sites failed");
        return undefined;
    }
}

});


parcelRegister("hUHA3", function(module, exports) {

$parcel$export(module.exports, "installAddonJiraMigrationSaga", function () { return $c3d16c1a6582ee8a$export$19ef9b3a67ce93e5; });
$parcel$export(module.exports, "installAddonJiraTabSaga", function () { return $c3d16c1a6582ee8a$export$37ed01bf0c2f6fed; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $3XbtU = parcelRequire("3XbtU");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $aanBq = parcelRequire("aanBq");

var $kvnVB = parcelRequire("kvnVB");

var $9NUw3 = parcelRequire("9NUw3");

var $628YF = parcelRequire("628YF");
parcelRequire("erZj9");
var $5KwLw = parcelRequire("5KwLw");
var $3OKoD = parcelRequire("3OKoD");
function* $c3d16c1a6582ee8a$export$53e47487768000ca(action, workspace) {
    const url = `${(0, $kvnVB.settings)().API_CANON_URL}/internal/site/addons/account/${workspace}/install/`;
    try {
        const accessToken = yield (0, $5NpoY.P)((0, $9NUw3.default), "site:bitbucket-jira-installer");
        const response = yield (0, $5NpoY.P)(fetch, url, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${accessToken.token}`
            }
        });
        if (response.ok) yield (0, $5NpoY.Y)({
            type: action.SUCCESS
        });
        else {
            yield (0, $628YF.captureMessageForResponse)(response, "Installing Jira addon failed");
            yield (0, $5NpoY.Y)({
                type: action.ERROR
            });
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: action.ERROR
        });
    }
}
function* $c3d16c1a6582ee8a$export$19ef9b3a67ce93e5({ payload: workspace }) {
    yield (0, $5NpoY.P)($c3d16c1a6582ee8a$export$53e47487768000ca, (0, $5KwLw.INSTALL_ADDON_JIRA_MIGRATION), workspace);
}
function* $c3d16c1a6582ee8a$export$37ed01bf0c2f6fed() {
    var _currentRepo$owner;
    const currentRepo = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    const workspace = (currentRepo === null || currentRepo === void 0 ? void 0 : (_currentRepo$owner = currentRepo.owner) === null || _currentRepo$owner === void 0 ? void 0 : _currentRepo$owner.uuid) || "";
    yield (0, $5NpoY.P)($c3d16c1a6582ee8a$export$53e47487768000ca, (0, $3OKoD.INSTALL_ADDON_JIRA_TAB), workspace);
}

});

parcelRegister("epNrA", function(module, exports) {

$parcel$export(module.exports, "fetchSitesForJiraMigrationSaga", function () { return $c9bbe77fc9aa48a4$export$8f4efba641a5cff4; });
$parcel$export(module.exports, "startIssueMigrationToJiraSaga", function () { return $c9bbe77fc9aa48a4$export$9c73298a89ee72d1; });
$parcel$export(module.exports, "issueMigrationToJiraStatusSaga", function () { return $c9bbe77fc9aa48a4$export$5af9d2c40ae9308b; });
$parcel$export(module.exports, "fetchIssueMigrationToJiraLogsSaga", function () { return $c9bbe77fc9aa48a4$export$bdd92ab808d47ab0; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $3XbtU = parcelRequire("3XbtU");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $4EtqP = parcelRequire("4EtqP");

var $k2cPS = parcelRequire("k2cPS");

var $628YF = parcelRequire("628YF");
parcelRequire("erZj9");
var $5KwLw = parcelRequire("5KwLw");

var $hahvB = parcelRequire("hahvB");

var $1TxBM = parcelRequire("1TxBM");

var $gAff5 = parcelRequire("gAff5");
const $c9bbe77fc9aa48a4$var$ISSUE_MIGRATION_STATUS_POLL_DELAY = 5000;
function* $c9bbe77fc9aa48a4$export$8f4efba641a5cff4() {
    try {
        const availableSites = yield (0, $5NpoY.P)((0, $gAff5.fetchAvailableJiraSitesSaga));
        if (availableSites === undefined) {
            yield (0, $5NpoY.Y)({
                type: (0, $5KwLw.FETCH_SITES_FOR_JIRA_MIGRATION).ERROR
            });
            return;
        } else yield (0, $5NpoY.Y)({
            type: (0, $5KwLw.FETCH_SITES_FOR_JIRA_MIGRATION).SUCCESS,
            payload: availableSites
        });
        return;
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $5KwLw.FETCH_SITES_FOR_JIRA_MIGRATION).ERROR
        });
    }
}
function* $c9bbe77fc9aa48a4$export$9c73298a89ee72d1({ payload: payload }) {
    if (!payload) return;
    const selectedStepIndex = yield (0, $5NpoY.a3)((0, $1TxBM.getActiveStepIndex));
    const { repositoryFullSlug: repositoryFullSlug, cloudId: cloudId, projectKey: projectKey, projectName: projectName } = payload;
    try {
        const url = (0, $4EtqP.default).api.internal.startIssueMigrationToJira(repositoryFullSlug, cloudId, projectKey, projectName);
        const request = (0, $k2cPS.default)(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            }
        });
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            yield (0, $5NpoY.Y)({
                type: (0, $5KwLw.START_ISSUE_MIGRATION_TO_JIRA).SUCCESS
            });
            yield (0, $5NpoY.Y)((0, $5KwLw.goToStep)(selectedStepIndex + 1));
        } else {
            yield (0, $628YF.captureMessageForResponse)(response, "Failed to start migrating issues to Jira");
            yield (0, $5NpoY.Y)({
                type: (0, $5KwLw.START_ISSUE_MIGRATION_TO_JIRA).ERROR,
                payload: response.status
            });
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $5KwLw.START_ISSUE_MIGRATION_TO_JIRA).ERROR
        });
    }
}
function* $c9bbe77fc9aa48a4$export$b692bc358b9f3096({ payload: payload }) {
    if (!payload) return;
    yield (0, $5NpoY.Y)({
        type: (0, $5KwLw.FETCH_ISSUE_MIGRATION_TO_JIRA_STATUS).REQUEST
    });
    const { repositoryFullSlug: repositoryFullSlug } = payload;
    try {
        while(true){
            const url = (0, $4EtqP.default).api.internal.issueMigrationToJiraStatus(repositoryFullSlug);
            const request = (0, $k2cPS.default)(url);
            const response = yield (0, $5NpoY.P)(fetch, request);
            if (response.ok) {
                const data = yield response.json();
                yield (0, $5NpoY.Y)({
                    type: (0, $5KwLw.FETCH_ISSUE_MIGRATION_TO_JIRA_STATUS).SUCCESS,
                    payload: data
                });
                // Stop polling when the migration is finished/failed.
                if (data.currentStep === (0, $hahvB.IssueMigrationCurrentStep).Finished || data.currentStep === (0, $hahvB.IssueMigrationCurrentStep).Failed) yield (0, $5NpoY.Y)({
                    type: (0, $5KwLw.POLL_ISSUE_MIGRATION_TO_JIRA).STOP
                });
            } else {
                yield (0, $628YF.captureMessageForResponse)(response, "Failed to fetch issue migration Jira status");
                yield (0, $5NpoY.Y)({
                    type: (0, $5KwLw.FETCH_ISSUE_MIGRATION_TO_JIRA_STATUS).ERROR
                });
            }
            yield (0, $5NpoY.S)($c9bbe77fc9aa48a4$var$ISSUE_MIGRATION_STATUS_POLL_DELAY);
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $5KwLw.FETCH_ISSUE_MIGRATION_TO_JIRA_STATUS).ERROR
        });
    }
}
function* $c9bbe77fc9aa48a4$export$5af9d2c40ae9308b() {
    while(true){
        const action = yield (0, $5NpoY.M)((0, $5KwLw.POLL_ISSUE_MIGRATION_TO_JIRA).START);
        yield (0, $5NpoY.T)([
            (0, $5NpoY.P)($c9bbe77fc9aa48a4$export$b692bc358b9f3096, action),
            (0, $5NpoY.M)((0, $5KwLw.POLL_ISSUE_MIGRATION_TO_JIRA).STOP)
        ]);
    }
}
function* $c9bbe77fc9aa48a4$export$bdd92ab808d47ab0({ payload: payload }) {
    if (!payload) return;
    const { repositoryFullSlug: repositoryFullSlug } = payload;
    try {
        const url = (0, $4EtqP.default).api.internal.issueMigrationToJiraLogs(repositoryFullSlug);
        const request = (0, $k2cPS.default)(url);
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            const logs = yield response.text();
            yield (0, $5NpoY.Y)({
                type: (0, $5KwLw.FETCH_ISSUE_MIGRATION_TO_JIRA_LOGS).SUCCESS,
                payload: logs
            });
        } else {
            yield (0, $628YF.captureMessageForResponse)(response, "Failed to fetch logs for the migration");
            yield (0, $5NpoY.Y)({
                type: (0, $5KwLw.FETCH_ISSUE_MIGRATION_TO_JIRA_LOGS).ERROR
            });
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $5KwLw.FETCH_ISSUE_MIGRATION_TO_JIRA_LOGS).ERROR
        });
    }
}

});
parcelRegister("1TxBM", function(module, exports) {

$parcel$export(module.exports, "getActiveStepIndex", function () { return $cba000181bd24d2e$export$dded590d60708d31; });
$parcel$export(module.exports, "getAvailableSites", function () { return $cba000181bd24d2e$export$1c577aaf38fb00a; });
$parcel$export(module.exports, "getAvailableSitesFetchedStatus", function () { return $cba000181bd24d2e$export$ec89bcfbb596b41a; });
$parcel$export(module.exports, "getSelectedSiteCloudId", function () { return $cba000181bd24d2e$export$c4b0dfa1b5137041; });
$parcel$export(module.exports, "getJiraMigrationProgress", function () { return $cba000181bd24d2e$export$ab56908cba6dbc55; });
$parcel$export(module.exports, "getJiraMigrationStarted", function () { return $cba000181bd24d2e$export$35938f4c0752057d; });
$parcel$export(module.exports, "getJiraMigrationLogs", function () { return $cba000181bd24d2e$export$46fe59a7b414a49c; });
$parcel$export(module.exports, "getAppInstalledStatus", function () { return $cba000181bd24d2e$export$60d478f4b9df20ff; });

var $aXXtM = parcelRequire("aXXtM");

var $7qdXF = parcelRequire("7qdXF");
const $cba000181bd24d2e$export$dded590d60708d31 = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraMigration.activeStepIndex);
const $cba000181bd24d2e$export$1c577aaf38fb00a = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraMigration.availableSites);
const $cba000181bd24d2e$export$ec89bcfbb596b41a = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraMigration.availableSitesFetchedStatus);
const $cba000181bd24d2e$export$c4b0dfa1b5137041 = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraMigration.selectedSiteCloudId);
const $cba000181bd24d2e$export$a9e2e842858f8586 = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraMigration.projectKey);
const $cba000181bd24d2e$export$3efa83b806b378d8 = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraMigration.projectName);
const $cba000181bd24d2e$export$ab56908cba6dbc55 = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraMigration.migrationProgress);
const $cba000181bd24d2e$export$35938f4c0752057d = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraMigration.migrationStarted);
const $cba000181bd24d2e$export$46fe59a7b414a49c = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraMigration.migrationLogs);
const $cba000181bd24d2e$export$60d478f4b9df20ff = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraMigration.appInstalledStatus);

});


parcelRegister("4PGc7", function(module, exports) {

$parcel$export(module.exports, "initJiraRepoPageSaga", function () { return $d7dec7463d86359a$export$1bd2c165a812783b; });
$parcel$export(module.exports, "fetchJiraTabFiltersUserPreferencesSaga", function () { return $d7dec7463d86359a$export$3d2c0661640e11bf; });
$parcel$export(module.exports, "fetchJiraAssigneesSaga", function () { return $d7dec7463d86359a$export$833c0e189c5c4328; });
$parcel$export(module.exports, "updateEmptyStateForSelectedSite", function () { return $d7dec7463d86359a$export$88e8897e9f43825; });
$parcel$export(module.exports, "fetchSitesSaga", function () { return $d7dec7463d86359a$export$9b602888aa1353cd; });
$parcel$export(module.exports, "fetchJiraRelevantIssuesSaga", function () { return $d7dec7463d86359a$export$c0a302444a3a438f; });
$parcel$export(module.exports, "fetchRelevantJiraSitesSaga", function () { return $d7dec7463d86359a$export$c25098ff13af2df3; });
$parcel$export(module.exports, "fetchJiraRelevantProjectsSaga", function () { return $d7dec7463d86359a$export$ed9aa1511e65312a; });
$parcel$export(module.exports, "handleFetchRelevantIssuesSuccessSaga", function () { return $d7dec7463d86359a$export$52147c7a0ae88e96; });
$parcel$export(module.exports, "handleFetchRelevantProjectsSuccessSaga", function () { return $d7dec7463d86359a$export$5177fe510f9e283c; });
$parcel$export(module.exports, "handleFetchRelevantSitesSuccessSaga", function () { return $d7dec7463d86359a$export$6b0c2dde5327c0a7; });
$parcel$export(module.exports, "fetchWorkspacePermissionSaga", function () { return $d7dec7463d86359a$export$96fb1f9a98708144; });
$parcel$export(module.exports, "changeFilterStateSaga", function () { return $d7dec7463d86359a$export$169c48be164be45a; });
$parcel$export(module.exports, "fetchDevActivitySaga", function () { return $d7dec7463d86359a$export$e08ff827ba858019; });
$parcel$export(module.exports, "debouncedFetchJiraProjectsSaga", function () { return $d7dec7463d86359a$export$78970157721986b5; });
$parcel$export(module.exports, "setIssueAssigneeSaga", function () { return $d7dec7463d86359a$export$74e59e8ee6b81ec7; });
$parcel$export(module.exports, "linkJiraProjectSaga", function () { return $d7dec7463d86359a$export$b733bbd5aeb48fbb; });
$parcel$export(module.exports, "unlinkJiraProjectSaga", function () { return $d7dec7463d86359a$export$8f09cfc5d6fb63b3; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $3XbtU = parcelRequire("3XbtU");

var $km2sU = parcelRequire("km2sU");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $90kWr = parcelRequire("90kWr");

var $7Me5Z = parcelRequire("7Me5Z");

var $2kKDW = parcelRequire("2kKDW");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");

var $gcnCs = parcelRequire("gcnCs");

var $fMQt0 = parcelRequire("fMQt0");

var $1cbbV = parcelRequire("1cbbV");

var $8MnfV = parcelRequire("8MnfV");

var $aanBq = parcelRequire("aanBq");

var $g2R3c = parcelRequire("g2R3c");

var $4EtqP = parcelRequire("4EtqP");

var $6aoKW = parcelRequire("6aoKW");

var $k2cPS = parcelRequire("k2cPS");

var $j9gxd = parcelRequire("j9gxd");

var $628YF = parcelRequire("628YF");
parcelRequire("erZj9");
var $3OKoD = parcelRequire("3OKoD");

var $hahvB = parcelRequire("hahvB");

var $bWpII = parcelRequire("bWpII");

var $9Og0J = parcelRequire("9Og0J");

var $6jeXr = parcelRequire("6jeXr");

var $1wDb1 = parcelRequire("1wDb1");
function* $d7dec7463d86359a$export$1bd2c165a812783b({ payload: repositoryFullSlug }) {
    // Fetch relevant projects from all sites - this feeds both relevant project navigation
    // and project filter of the issues table
    yield (0, $5NpoY.Y)((0, $3OKoD.fetchJiraRelevantProjects)());
    // TODO BBCFAM-480 fetch the user preference here in parallel with relevant sites
    // Fetch relevant sites to figure out where to fetch issues from or empty state to show
    yield (0, $5NpoY.Y)((0, $3OKoD.fetchRelevantJiraSites)(repositoryFullSlug));
}
function* $d7dec7463d86359a$export$e0238493499e77ac() {
    const currentUser = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
    if (!currentUser) return;
    const repositoryUuid = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryUuid));
    const filterState = yield (0, $5NpoY.a3)((0, $bWpII.getFilterState));
    try {
        yield (0, $5NpoY.P)((0, $j9gxd.default).set, currentUser.uuid, (0, $6jeXr.createJiraTabFiltersUserPreferencesKey)(repositoryUuid), JSON.stringify((0, $km2sU.default)(filterState, [
            "textFilterQuery",
            "currentPage",
            "sort"
        ])));
    } catch (e) {
        $3XbtU.captureException(e);
    }
}
function* $d7dec7463d86359a$export$3d2c0661640e11bf() {
    const { status: status } = yield (0, $5NpoY.a3)((0, $8MnfV.getRepositoryPageLoadingStatus));
    if (status !== (0, $90kWr.LoadingStatus).Success) yield (0, $5NpoY.M)((0, $jJd6W.LoadRepositoryPage).SUCCESS);
    const currentUser = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
    const repositoryUuid = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryUuid));
    try {
        if (currentUser) {
            // @ts-ignore
            const preferencesRaw = yield (0, $5NpoY.P)((0, $j9gxd.default).get, currentUser.uuid, (0, $6jeXr.createJiraTabFiltersUserPreferencesKey)(repositoryUuid));
            const preferences = preferencesRaw ? JSON.parse(preferencesRaw) : undefined;
            if (preferences) {
                yield (0, $5NpoY.Y)({
                    type: (0, $3OKoD.FETCH_JIRA_TAB_FILTERS_USER_PREFERENCE).SUCCESS
                });
                yield (0, $5NpoY.Y)((0, $3OKoD.saveFilterState)(preferences));
            } else yield (0, $5NpoY.Y)({
                type: (0, $3OKoD.FETCH_JIRA_TAB_FILTERS_USER_PREFERENCE).ERROR
            });
        } else // Put ERROR action for an anonymous user.
        yield (0, $5NpoY.Y)({
            type: (0, $3OKoD.FETCH_JIRA_TAB_FILTERS_USER_PREFERENCE).ERROR
        });
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $3OKoD.FETCH_JIRA_TAB_FILTERS_USER_PREFERENCE).ERROR
        });
        $3XbtU.captureException(e);
    }
}
function* $d7dec7463d86359a$var$fetchJiraAssigneesRecursively(repositoryFullSlug, siteCloudId, currentPage, values = []) {
    const url = `${(0, $4EtqP.default).api.internal.assignees(repositoryFullSlug, siteCloudId)}&page=${currentPage}`;
    const request = (0, $k2cPS.default)(url);
    const response = yield (0, $5NpoY.P)(fetch, request);
    if (response.ok) {
        const data = yield response.json();
        if (Array.isArray(data.values)) values.push(...data.values);
        const hasFetchedAllAssignees = values.length === data.size || (data.values || []).length === 0;
        if (!hasFetchedAllAssignees) yield $d7dec7463d86359a$var$fetchJiraAssigneesRecursively(repositoryFullSlug, siteCloudId, currentPage + 1, values);
        else yield (0, $5NpoY.Y)({
            type: (0, $3OKoD.FETCH_JIRA_ASSIGNEES).SUCCESS,
            payload: {
                values: values
            }
        });
    } else {
        yield (0, $628YF.captureMessageForResponse)(response, `Fetching assignees for the Jira site ${siteCloudId}`);
        yield (0, $5NpoY.Y)({
            type: (0, $3OKoD.FETCH_JIRA_ASSIGNEES).ERROR
        });
    }
}
function* $d7dec7463d86359a$export$833c0e189c5c4328() {
    const repositoryFullSlug = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryFullSlug));
    const { siteCloudId: siteCloudId } = yield (0, $5NpoY.a3)((0, $bWpII.getFilterState));
    try {
        yield $d7dec7463d86359a$var$fetchJiraAssigneesRecursively(repositoryFullSlug, siteCloudId, 1);
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $3OKoD.FETCH_JIRA_ASSIGNEES).ERROR
        });
    }
}
function* $d7dec7463d86359a$export$88e8897e9f43825() {
    // To decide which empty state reflects the situation we might need
    // to check the outcome of concurrently executed API calls to fetch
    // relevant sites and relevant projects. Due to visibility of these
    // to the requesting user, we can't make such decision earlier.
    const { siteCloudId: siteCloudId } = yield (0, $5NpoY.a3)((0, $bWpII.getFilterState));
    // If no site selected yet, we are not ready to show the page
    if (!siteCloudId) return;
    const relevantProjectFetchedStatus = yield (0, $5NpoY.a3)((0, $bWpII.getRelevantProjectFetchedStatus));
    if (relevantProjectFetchedStatus === (0, $90kWr.LoadingStatus).Forbidden) // No relevant projects are visible to the user, but we can only get
    // into this branch if at least one of the relevant sites is visible
    // and became selected
    yield (0, $5NpoY.Y)((0, $3OKoD.setEmptyStateKind)((0, $hahvB.EmptyStateKind).HasNoAccessibleRelevantProjects));
    else if (relevantProjectFetchedStatus === (0, $90kWr.LoadingStatus).Success) {
        const projectAssociations = yield (0, $5NpoY.a3)((0, $bWpII.getProjectAssociations));
        // No relevant projects means no relevant sites, for that case we have a special
        // flow to fetch available sites and decide which empty state to show, so here we
        // only need to care about the case when there're some relevant projects
        if (projectAssociations.length > 0) {
            // We might have a site selected which has no relevant projects visible to the user,
            // while there are relevant projects on other sites that user can access; we need to
            // detect such case to show appropriate empty state and hide an empty project filter
            const someVisibleProjectsOnSelectedSite = projectAssociations.some((pa)=>pa.project.site.cloudId === siteCloudId);
            yield (0, $5NpoY.Y)((0, $3OKoD.setEmptyStateKind)(someVisibleProjectsOnSelectedSite ? (0, $hahvB.EmptyStateKind).None : (0, $hahvB.EmptyStateKind).HasNoAccessibleRelevantProjects));
        }
    } else if (relevantProjectFetchedStatus === (0, $90kWr.LoadingStatus).Failed) // We need to let the user see the page so that they are able to retry fetching
    // relevant projects if they want. Once they do that, empty state might change
    // but that's ok since that would be a reaction on a button click.
    yield (0, $5NpoY.Y)((0, $3OKoD.setEmptyStateKind)((0, $hahvB.EmptyStateKind).None));
}
function* $d7dec7463d86359a$export$c445fde48bc9f9d8() {
    yield (0, $5NpoY._)([
        (0, $5NpoY.Y)((0, $3OKoD.fetchJiraAssignees)()),
        (0, $5NpoY.Y)((0, $3OKoD.fetchJiraRelevantIssues)()),
        (0, $5NpoY.P)($d7dec7463d86359a$export$88e8897e9f43825)
    ]);
}
function* $d7dec7463d86359a$export$9b602888aa1353cd() {
    const targetAccount = yield (0, $5NpoY.a3)((0, $g2R3c.getTargetUser));
    try {
        const url = (0, $4EtqP.default).api.internal.sites(targetAccount.uuid);
        const request = (0, $k2cPS.default)(url);
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            // @ts-ignore
            const data = yield response.json();
            yield (0, $5NpoY.Y)({
                type: (0, $3OKoD.FETCH_JIRA_SITES).SUCCESS,
                payload: data.values
            });
        } else {
            yield (0, $628YF.captureMessageForResponse)(response, "Fetching Jira sites in Jira tab failed");
            yield (0, $5NpoY.Y)({
                type: (0, $3OKoD.FETCH_JIRA_SITES).ERROR
            });
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $3OKoD.FETCH_JIRA_SITES).ERROR
        });
    }
}
function* $d7dec7463d86359a$export$4462549eca739f49(size, pageLen) {
    const relevantSites = yield (0, $5NpoY.a3)((0, $bWpII.getRelevantSites));
    const relevantProjects = yield (0, $5NpoY.a3)((0, $bWpII.getProjectAssociations));
    const relevantProjectsFetchedStatus = yield (0, $5NpoY.a3)((0, $bWpII.getRelevantProjectFetchedStatus));
    const assignees = yield (0, $5NpoY.a3)((0, $bWpII.getAssignees));
    const assigneesFetchedStatus = yield (0, $5NpoY.a3)((0, $bWpII.getAssigneesFetchedStatus));
    const filterState = yield (0, $5NpoY.a3)((0, $bWpII.getFilterState));
    yield (0, $5NpoY.P)((0, $6aoKW.publishTrackEvent), {
        source: (0, $gcnCs.SCREEN_NAME),
        action: "fetched",
        actionSubject: "jiraTabRelevantIssues",
        actionSubjectId: "jiraTabRelevantIssues",
        attributes: {
            relevantSitesCount: relevantSites.length,
            relevantProjectsCount: relevantProjectsFetchedStatus === (0, $90kWr.LoadingStatus).Success ? relevantProjects.length : undefined,
            relevantProjectsForSelectedSiteCount: relevantProjectsFetchedStatus === (0, $90kWr.LoadingStatus).Success ? relevantProjects.filter((p)=>p.project.site.cloudId === filterState.siteCloudId).length : undefined,
            assigneesCount: assigneesFetchedStatus === (0, $90kWr.LoadingStatus).Success ? assignees.length : undefined,
            selectedProjectsCount: filterState.projectIds.length,
            selectedAssigneesCount: filterState.assignees.length,
            selectedStatusCategories: filterState.issueCategories,
            isSearchingByText: Boolean(filterState.textFilterQuery),
            sort: filterState.sort,
            currentPage: filterState.currentPage,
            totalPages: Math.ceil(size / pageLen)
        }
    });
}
function* $d7dec7463d86359a$export$c0a302444a3a438f() {
    const RELEVANT_ISSUES_PAGE_LEN = 25;
    const repositoryFullSlug = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryFullSlug));
    const filterState = yield (0, $5NpoY.a3)((0, $bWpII.getFilterState));
    const cloudId = filterState.siteCloudId;
    const filterParams = {
        cloud_id: cloudId,
        project_ids: filterState.projectIds,
        statuses: filterState.issueCategories,
        text: filterState.textFilterQuery,
        assignees: filterState.assignees,
        sort: filterState.sort ? filterState.sort.order === (0, $9Og0J.SORT_ORDER).ASC ? filterState.sort.field : `-${filterState.sort.field}` : undefined,
        page: filterState.currentPage,
        pagelen: RELEVANT_ISSUES_PAGE_LEN
    };
    try {
        const url = (0, $4EtqP.default).api.internal.relevantIssues(repositoryFullSlug, filterParams);
        const request = (0, $k2cPS.default)(url);
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            // @ts-ignore
            const data = yield response.json();
            yield (0, $5NpoY.Y)({
                type: (0, $3OKoD.FETCH_JIRA_RELEVANT_ISSUES).SUCCESS,
                payload: data
            });
            const issues = data.values;
            const issueIds = issues.map((issue)=>issue.id);
            yield (0, $5NpoY.Y)((0, $3OKoD.fetchDevActivity)({
                cloudId: cloudId,
                issueIds: issueIds
            }));
            yield (0, $5NpoY.P)($d7dec7463d86359a$export$4462549eca739f49, data.size, RELEVANT_ISSUES_PAGE_LEN);
        } else {
            yield (0, $628YF.captureMessageForResponse)(response, "Fetching relevant Jira issues in Jira tab failed");
            yield (0, $5NpoY.Y)({
                type: (0, $3OKoD.FETCH_JIRA_RELEVANT_ISSUES).ERROR
            });
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $3OKoD.FETCH_JIRA_RELEVANT_ISSUES).ERROR
        });
    }
}
function* $d7dec7463d86359a$export$c25098ff13af2df3({ payload: repositoryFullSlug }) {
    try {
        const url = (0, $4EtqP.default).api.internal.relevantSites(repositoryFullSlug);
        const request = (0, $k2cPS.default)(url);
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            // @ts-ignore
            const data = yield response.json();
            yield (0, $5NpoY.Y)({
                type: (0, $3OKoD.FETCH_RELEVANT_JIRA_SITES).SUCCESS,
                payload: {
                    values: data.values,
                    hasPermission: true
                }
            });
        } else if (response.status === 403) yield (0, $5NpoY.Y)({
            type: (0, $3OKoD.FETCH_RELEVANT_JIRA_SITES).SUCCESS,
            payload: {
                values: [],
                hasPermission: false
            }
        });
        else {
            yield (0, $628YF.captureMessageForResponse)(response, "Fetching relevant Jira sites in Jira tab failed");
            yield (0, $5NpoY.Y)({
                type: (0, $3OKoD.FETCH_RELEVANT_JIRA_SITES).ERROR
            });
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $3OKoD.FETCH_RELEVANT_JIRA_SITES).ERROR
        });
    }
}
function* $d7dec7463d86359a$var$fetchRelevantProjectsRecursively(repositoryFullSlug, currentPage, values = []) {
    const url = `${(0, $4EtqP.default).api.internal.relevantProjects(repositoryFullSlug)}?page=${currentPage}`;
    const request = (0, $k2cPS.default)(url);
    const response = yield (0, $5NpoY.P)(fetch, request);
    if (response.ok) {
        const data = yield response.json();
        if (Array.isArray(data.values)) values.push(...data.values);
        // Due to doing multiple separate requests, we could end up with a situation
        // where values.length and data.size never match, so also stop if we get no
        // results in the new page.
        const hasFetchedAllRelevantProjects = values.length === data.size || (data.values || []).length === 0;
        if (hasFetchedAllRelevantProjects) {
            // This code handles the edge case where a project was saved in the user preference
            // api but is no longer a relevant project for this repo. We discard the saved project.
            const filterState = yield (0, $5NpoY.a3)((0, $bWpII.getFilterState));
            const projectIds = filterState.projectIds.filter((id)=>values.some((association)=>association.project.id === id));
            yield (0, $5NpoY.Y)({
                type: (0, $3OKoD.FETCH_JIRA_RELEVANT_PROJECTS).SUCCESS,
                payload: {
                    projectAssociations: values,
                    projectIds: projectIds,
                    hasPermission: true
                }
            });
        } else yield $d7dec7463d86359a$var$fetchRelevantProjectsRecursively(repositoryFullSlug, currentPage + 1, values);
    } else if (response.status === 403) yield (0, $5NpoY.Y)({
        type: (0, $3OKoD.FETCH_JIRA_RELEVANT_PROJECTS).SUCCESS,
        payload: {
            projectAssociations: [],
            projectIds: [],
            hasPermission: false
        }
    });
    else {
        yield (0, $628YF.captureMessageForResponse)(response, "Fetching relevant Jira projects failed");
        yield (0, $5NpoY.Y)({
            type: (0, $3OKoD.FETCH_JIRA_RELEVANT_PROJECTS).ERROR
        });
    }
}
function* $d7dec7463d86359a$export$ed9aa1511e65312a() {
    const repositoryFullSlug = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryFullSlug));
    try {
        yield $d7dec7463d86359a$var$fetchRelevantProjectsRecursively(repositoryFullSlug, 1);
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $3OKoD.FETCH_JIRA_RELEVANT_PROJECTS).ERROR
        });
    }
}
function* $d7dec7463d86359a$export$52147c7a0ae88e96({ payload: payload }) {
    // If we got some issues back, we can show them straight away
    // without waiting for all relevant projects to finish loading
    if (((payload === null || payload === void 0 ? void 0 : payload.values) || []).length > 0) yield (0, $5NpoY.Y)((0, $3OKoD.setEmptyStateKind)((0, $hahvB.EmptyStateKind).None));
}
function* $d7dec7463d86359a$export$5177fe510f9e283c() {
    yield (0, $5NpoY.P)($d7dec7463d86359a$export$88e8897e9f43825);
}
function* $d7dec7463d86359a$export$931ca8b5a2ccee9c() {
    yield (0, $5NpoY.Y)((0, $3OKoD.fetchJiraSites)());
    yield (0, $5NpoY.M)((0, $3OKoD.FETCH_JIRA_SITES).SUCCESS);
    const sites = yield (0, $5NpoY.a3)((0, $bWpII.getJiraSites));
    const connectedSites = (sites || []).filter((s)=>s.connected);
    const availableSites = (sites || []).filter((s)=>!s.connected);
    if (connectedSites.length > 0) // We're only fetching all Jira sites if there're no relevant sites,
    // and therefore no relevant projects.
    yield (0, $5NpoY.Y)((0, $3OKoD.setEmptyStateKind)((0, $hahvB.EmptyStateKind).HasNoRelevantProjects));
    else if (connectedSites.length === 0 && availableSites.length > 0) {
        yield (0, $5NpoY.Y)((0, $3OKoD.setEmptyStateKind)((0, $hahvB.EmptyStateKind).HasAvailableSites));
        yield (0, $5NpoY.Y)((0, $3OKoD.fetchWorkspacePermission)());
    } else if (connectedSites.length === 0 && availableSites.length === 0) {
        yield (0, $5NpoY.Y)((0, $3OKoD.setEmptyStateKind)((0, $hahvB.EmptyStateKind).HasNoAvailableSites));
        yield (0, $5NpoY.Y)((0, $3OKoD.fetchWorkspacePermission)());
    }
}
function* $d7dec7463d86359a$export$6b0c2dde5327c0a7() {
    // Make sure the repository has been loaded.
    const { status: status } = yield (0, $5NpoY.a3)((0, $8MnfV.getRepositoryPageLoadingStatus));
    if (status !== (0, $90kWr.LoadingStatus).Success) yield (0, $5NpoY.M)((0, $jJd6W.LoadRepositoryPage).SUCCESS);
    const relevantSites = yield (0, $5NpoY.a3)((0, $bWpII.getRelevantSites));
    if ((relevantSites || []).length === 0) {
        const relevantSitesFetchStatus = yield (0, $5NpoY.a3)((0, $bWpII.getRelevantSitesFetchedStatus));
        if (relevantSitesFetchStatus === (0, $90kWr.LoadingStatus).Forbidden) yield (0, $5NpoY.Y)((0, $3OKoD.setEmptyStateKind)((0, $hahvB.EmptyStateKind).HasNoAccessibleRelevantSites));
        else yield (0, $5NpoY.P)($d7dec7463d86359a$export$931ca8b5a2ccee9c);
    } else {
        const filterPreferencesFetchedStatus = yield (0, $5NpoY.a3)((0, $bWpII.getFilterPreferencesFetchedStatus));
        // Wait for preferences to be fetched.
        if (filterPreferencesFetchedStatus !== (0, $90kWr.LoadingStatus).Success && filterPreferencesFetchedStatus !== (0, $90kWr.LoadingStatus).Failed && filterPreferencesFetchedStatus !== "NOT_REQUIRED") yield (0, $5NpoY.M)([
            (0, $3OKoD.FETCH_JIRA_TAB_FILTERS_USER_PREFERENCE).SUCCESS,
            (0, $3OKoD.FETCH_JIRA_TAB_FILTERS_USER_PREFERENCE).ERROR,
            (0, $3OKoD.JIRA_TAB_FILTERS_USER_PREFERENCE_NOT_REQUIRED)
        ]);
        const filterState = yield (0, $5NpoY.a3)((0, $bWpII.getFilterState));
        if (!filterState.siteCloudId || !relevantSites.some((s)=>s.cloudId === filterState.siteCloudId)) // Select the first site if we don't have a site selected yet, or if the selected site is not relevant anymore.
        // The latter can happen if users open an old URL that has a `site` query param of an old site.
        yield (0, $5NpoY.Y)((0, $3OKoD.saveFilterState)({
            siteCloudId: relevantSites[0].cloudId
        }));
        yield (0, $5NpoY.P)($d7dec7463d86359a$export$c445fde48bc9f9d8);
    }
}
function* $d7dec7463d86359a$export$96fb1f9a98708144() {
    const isAnonymousUser = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUserIsAnonymous));
    // Request to get workspace permissions needs auth, don't try for anonymous users.
    if (isAnonymousUser) {
        yield (0, $5NpoY.Y)({
            type: (0, $3OKoD.FETCH_WORKSPACE_PERMISSION).SUCCESS,
            payload: []
        });
        return;
    }
    const repoOwnerName = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryOwnerName));
    const url = (0, $4EtqP.default).api.v20.workspacePermission(repoOwnerName);
    try {
        const request = (0, $k2cPS.default)(url);
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            // @ts-ignore
            const data = yield response.json();
            yield (0, $5NpoY.Y)({
                type: (0, $3OKoD.FETCH_WORKSPACE_PERMISSION).SUCCESS,
                payload: data.values
            });
        } else {
            yield (0, $628YF.captureMessageForResponse)(response, "Fetching workspace permission in Jira tab failed");
            yield (0, $5NpoY.Y)({
                type: (0, $3OKoD.FETCH_WORKSPACE_PERMISSION).ERROR
            });
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $3OKoD.FETCH_WORKSPACE_PERMISSION).ERROR
        });
    }
}
function* $d7dec7463d86359a$export$169c48be164be45a({ payload: nextFilterState }) {
    const prevFilterState = yield (0, $5NpoY.a3)((0, $bWpII.getFilterState));
    const filterState = {
        ...nextFilterState
    };
    const filtersOrSortChanged = !nextFilterState.currentPage;
    if (filtersOrSortChanged) // When changing any of the filters or sort order, we want to reset to page 1, not stay on the page that they were
    // before because the context is no longer the same. See https://ux.stackexchange.com/a/129076/68221
    filterState.currentPage = 1;
    const selectedSiteChanged = nextFilterState.siteCloudId && nextFilterState.siteCloudId !== prevFilterState.siteCloudId;
    if (selectedSiteChanged) {
        // When switching to a different site, we don't want to keep the project or assignee filters. For projects it
        // doesn't make sense because they are completely different. The same assignee user might exist on a different site,
        // but might not have any issues on that site, so it would just be an empty result and confusing UX.
        filterState.projectIds = [];
        filterState.assignees = [];
    }
    yield (0, $5NpoY.Y)((0, $3OKoD.saveFilterState)(filterState));
    // Don't update preferences when text filter, column sort or page is changed
    // because these values are not included in the preferences anyway.
    const persistFiltersChanged = !nextFilterState.currentPage && !nextFilterState.sort && !nextFilterState.textFilterQuery;
    if (persistFiltersChanged) yield (0, $5NpoY.P)($d7dec7463d86359a$export$e0238493499e77ac);
    if (selectedSiteChanged) yield (0, $5NpoY.P)($d7dec7463d86359a$export$c445fde48bc9f9d8);
    else yield (0, $5NpoY.Y)((0, $3OKoD.fetchJiraRelevantIssues)());
}
function* $d7dec7463d86359a$export$e08ff827ba858019({ payload: payload }) {
    if (!payload) return;
    const { cloudId: cloudId, issueIds: issueIds } = payload;
    try {
        const workspace = yield (0, $1wDb1.getWorkspace)();
        const url = (0, $4EtqP.default).api.internal.devActivity(workspace.uuid, cloudId);
        const request = (0, $k2cPS.default)(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                issueIds: issueIds
            })
        });
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            // @ts-ignore
            const data = yield response.json();
            yield (0, $5NpoY.Y)({
                type: (0, $3OKoD.FETCH_DEV_ACTIVITY).SUCCESS,
                payload: data ? {
                    [cloudId]: data.activity
                } : {}
            });
        } else {
            yield (0, $628YF.captureMessageForResponse)(response, "Fetching dev activity in Jira tab failed");
            yield (0, $5NpoY.Y)({
                type: (0, $3OKoD.FETCH_DEV_ACTIVITY).ERROR
            });
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $3OKoD.FETCH_DEV_ACTIVITY).ERROR
        });
    }
}
function* $d7dec7463d86359a$export$1cb67f69a26a4e6c({ payload: payload }) {
    if (!payload) return;
    const { cloudId: cloudId, projectQuery: projectQuery } = payload;
    try {
        const workspace = yield (0, $1wDb1.getWorkspace)();
        const url = (0, $4EtqP.default).api.internal.projects(workspace.uuid, cloudId, projectQuery);
        const request = (0, $k2cPS.default)(url);
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            // @ts-ignore
            const data = yield response.json();
            yield (0, $5NpoY.Y)({
                type: (0, $3OKoD.FETCH_JIRA_PROJECTS).SUCCESS,
                payload: data ? {
                    [cloudId]: {
                        projects: data.values,
                        fetchedStatus: (0, $90kWr.LoadingStatus).Success,
                        size: data.size
                    }
                } : {}
            });
        } else {
            yield (0, $628YF.captureMessageForResponse)(response, "Fetching Jira projects failed");
            yield (0, $5NpoY.Y)({
                type: (0, $3OKoD.FETCH_JIRA_PROJECTS).ERROR
            });
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $3OKoD.FETCH_JIRA_PROJECTS).ERROR,
            payload: {
                cloudId: cloudId
            }
        });
    }
}
function* $d7dec7463d86359a$export$78970157721986b5() {
    yield (0, $jeUNF.debounce)((0, $7Me5Z.DEBOUNCE_DELAY), (0, $3OKoD.FETCH_JIRA_PROJECTS).REQUEST, $d7dec7463d86359a$export$1cb67f69a26a4e6c);
}
function* $d7dec7463d86359a$export$3b86858fd9851e26(projectAssociation) {
    const { id: projectId, site: { cloudId: cloudId } } = projectAssociation.project;
    const repositoryFullSlug = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryFullSlug));
    const url = (0, $4EtqP.default).api.internal.projectAssociation(repositoryFullSlug, cloudId, projectId);
    const request = (0, $k2cPS.default)(url, {
        method: "PUT",
        headers: (0, $k2cPS.jsonHeaders),
        body: JSON.stringify(projectAssociation)
    });
    const response = yield (0, $5NpoY.P)(fetch, request);
    return response;
}
function* $d7dec7463d86359a$export$e238503cabb4ac67(projectAssociation) {
    const projectAssociations = yield (0, $5NpoY.a3)((0, $bWpII.getProjectAssociations));
    const newProjectAssociations = [
        ...projectAssociations,
        projectAssociation
    ];
    // Update the list of relevant projects to include the new one,
    yield (0, $5NpoY.Y)((0, $3OKoD.updateRelevantJiraProjects)(newProjectAssociations));
    // fetch updated list of relevant sites (this will update relevant issues list too),
    const repositoryFullSlug = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryFullSlug));
    yield (0, $5NpoY.Y)((0, $3OKoD.fetchRelevantJiraSites)(repositoryFullSlug));
    // and show the success flag.
    yield (0, $5NpoY.Y)((0, $2kKDW.showFlag)({
        id: "link-project-success-message",
        title: {
            msg: (0, $fMQt0.default).linkProjectSuccessMessage
        },
        autoDismiss: true,
        iconType: "success"
    }));
    yield (0, $5NpoY.P)((0, $6aoKW.publishTrackEvent), {
        source: (0, $gcnCs.SCREEN_NAME),
        action: "linked",
        actionSubject: "jiraProject",
        actionSubjectId: projectAssociation.project.id,
        attributes: {
            relevantProjectsCount: newProjectAssociations.length
        }
    });
}
function* $d7dec7463d86359a$export$74e59e8ee6b81ec7({ payload: payload }) {
    if (!payload) return;
    const { issueKey: issueKey, assigneeId: assigneeId } = payload;
    const currentUser = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
    const { siteCloudId: siteCloudId } = yield (0, $5NpoY.a3)((0, $bWpII.getFilterState));
    const url = (0, $4EtqP.default).api.internal.setAssignee(siteCloudId, issueKey);
    try {
        const request = (0, $k2cPS.default)(url, {
            method: "PUT",
            headers: (0, $k2cPS.jsonHeaders),
            body: JSON.stringify({
                assigneeId: assigneeId
            })
        });
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            yield (0, $5NpoY.Y)({
                type: (0, $3OKoD.SET_ISSUE_ASSIGNEE).SUCCESS,
                payload: {
                    currentJiraUser: {
                        displayName: currentUser.display_name,
                        accountId: currentUser.account_id,
                        avatarUrls: {
                            "16x16": currentUser.links.avatar.href,
                            "24x24": currentUser.links.avatar.href,
                            "32x32": currentUser.links.avatar.href,
                            "48x48": currentUser.links.avatar.href,
                            "128x128": currentUser.links.avatar.href
                        }
                    },
                    issueKey: issueKey
                }
            });
            yield (0, $5NpoY.Y)((0, $2kKDW.showFlag)({
                id: "assign-issue-success-flag",
                title: {
                    msg: (0, $1cbbV.default).assignIssueSuccessTitle
                },
                autoDismiss: true,
                iconType: "success"
            }));
        } else {
            yield (0, $5NpoY.Y)({
                type: (0, $3OKoD.SET_ISSUE_ASSIGNEE).ERROR
            });
            yield (0, $5NpoY.Y)((0, $2kKDW.showFlag)({
                id: "assign-issue-failure-flag",
                title: {
                    msg: (0, $1cbbV.default).assignIssueFailureTitle
                },
                autoDismiss: true,
                iconType: "error"
            }));
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $3OKoD.SET_ISSUE_ASSIGNEE).ERROR
        });
        yield (0, $5NpoY.Y)((0, $2kKDW.showFlag)({
            id: "assign-issue-failure-flag",
            title: {
                msg: (0, $1cbbV.default).assignIssueFailureTitle
            },
            autoDismiss: true,
            iconType: "error"
        }));
    }
}
function* $d7dec7463d86359a$export$b733bbd5aeb48fbb({ payload: payload }) {
    if (!payload) return;
    try {
        const response = yield (0, $5NpoY.P)($d7dec7463d86359a$export$3b86858fd9851e26, payload.projectAssociation);
        if (response.ok) {
            // @ts-ignore
            const data = yield response.json();
            yield (0, $5NpoY.Y)({
                type: (0, $3OKoD.LINK_JIRA_PROJECT).SUCCESS,
                payload: {
                    projectAssociation: data
                }
            });
            yield (0, $5NpoY.P)($d7dec7463d86359a$export$e238503cabb4ac67, data);
        } else {
            yield (0, $628YF.captureMessageForResponse)(response, "Linking Jira project failed");
            yield (0, $5NpoY.Y)({
                type: (0, $3OKoD.LINK_JIRA_PROJECT).ERROR
            });
            yield (0, $5NpoY.Y)((0, $2kKDW.showFlag)({
                id: "link-project-failed-message",
                title: {
                    msg: (0, $fMQt0.default).linkProjectFailedMessage
                },
                autoDismiss: true,
                iconType: "error"
            }));
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $3OKoD.LINK_JIRA_PROJECT).ERROR
        });
    }
}
function* $d7dec7463d86359a$export$354c3fede049f23f(projectAssociation) {
    const projectAssociations = yield (0, $5NpoY.a3)((0, $bWpII.getProjectAssociations));
    // Filter out the unlinked project association from the list,
    const newProjectAssociations = (projectAssociations || []).filter((pa)=>!(pa.project.site.cloudId === projectAssociation.project.site.cloudId && pa.project.id === projectAssociation.project.id));
    yield (0, $5NpoY.Y)((0, $3OKoD.updateRelevantJiraProjects)(newProjectAssociations));
    // fetch updated list of relevant sites (this will update relevant issues list too),
    const repositoryFullSlug = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryFullSlug));
    yield (0, $5NpoY.Y)((0, $3OKoD.fetchRelevantJiraSites)(repositoryFullSlug));
    // close the unlink project confirmation dialog,
    yield (0, $5NpoY.Y)((0, $3OKoD.closeUnlinkProjectDialog)());
    // and show the success flag.
    yield (0, $5NpoY.Y)((0, $2kKDW.showFlag)({
        id: "unlink-project-success-message",
        title: {
            msg: (0, $fMQt0.default).unlinkProjectSuccessMessage
        },
        autoDismiss: true,
        iconType: "success"
    }));
    yield (0, $5NpoY.P)((0, $6aoKW.publishTrackEvent), {
        source: (0, $gcnCs.SCREEN_NAME),
        action: "unlinked",
        actionSubject: "jiraProject",
        actionSubjectId: projectAssociation.project.id,
        attributes: {
            relevantProjectsCount: newProjectAssociations.length
        }
    });
}
function* $d7dec7463d86359a$export$8f09cfc5d6fb63b3({ payload: payload }) {
    if (!payload) return;
    try {
        const response = yield (0, $5NpoY.P)($d7dec7463d86359a$export$3b86858fd9851e26, payload.projectAssociation);
        if (response.ok) {
            // @ts-ignore
            const data = yield response.json();
            yield (0, $5NpoY.Y)({
                type: (0, $3OKoD.UNLINK_JIRA_PROJECT).SUCCESS,
                payload: {
                    projectAssociation: data
                }
            });
            yield (0, $5NpoY.P)($d7dec7463d86359a$export$354c3fede049f23f, data);
        } else {
            yield (0, $628YF.captureMessageForResponse)(response, "Unlinking Jira project failed");
            yield (0, $5NpoY.Y)({
                type: (0, $3OKoD.UNLINK_JIRA_PROJECT).ERROR
            });
            yield (0, $5NpoY.Y)((0, $2kKDW.showFlag)({
                id: "unlink-project-failed-message",
                title: {
                    msg: (0, $fMQt0.default).unlinkProjectFailedMessage
                },
                autoDismiss: true,
                iconType: "error"
            }));
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $3OKoD.UNLINK_JIRA_PROJECT).ERROR
        });
    }
}

});
parcelRegister("gcnCs", function(module, exports) {

$parcel$export(module.exports, "SCREEN_NAME", function () { return $969ad0fc178202c4$export$d2cea8e85c08e64c; });
$parcel$export(module.exports, "MAX_ASSIGNEES_C0UNT", function () { return $969ad0fc178202c4$export$eb5debc51c803591; });
const $969ad0fc178202c4$export$d2cea8e85c08e64c = "repositoryJiraScreen";
const $969ad0fc178202c4$export$eb5debc51c803591 = 5;

});

parcelRegister("fMQt0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fa409404020d98f$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $3fa409404020d98f$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    manageProjectsDialogHeading: {
        "id": "frontbucket.jiraTab.manageProjectsDialog.heading",
        "defaultMessage": "Manage linked Jira projects"
    },
    manageProjectsDialogDetails: {
        "id": "frontbucket.jiraTab.manageProjectsDialog.details",
        "defaultMessage": "Link Jira projects to this repository by including an issue key in any branch name or commit. Alternatively you can manually select a project below."
    },
    errorLoadingProjectsMessage: {
        "id": "frontbucket.jiraTab.manageProjectsDialog.errorLoadingProjectsMessage",
        "defaultMessage": "We can't load the project list."
    },
    unlinkProjectLabel: {
        "id": "frontbucket.jiraTab.manageProjectsDialog.unlinkProjectLabel",
        "defaultMessage": "Unlink project"
    },
    linkedProjectsTitle: {
        "id": "frontbucket.jiraTab.manageProjectsDialog.linkedProjectsTitle",
        "defaultMessage": "Linked projects"
    },
    automaticallyLinkedProjectLabel: {
        "id": "frontbucket.jiraTab.manageProjectsDialog.automaticallyLinkedProjectLabel",
        "defaultMessage": "Linked via commit/pull request"
    },
    manuallyLinkedProjectLabel: {
        "id": "frontbucket.jiraTab.manageProjectsDialog.manuallyLinkedProjectLabel",
        "defaultMessage": "Manually linked by {personName}"
    },
    closeManageProjectsDialogLabel: {
        "id": "frontbucket.jiraTab.manageProjectsDialog.closeManageProjectsDialogLabel",
        "defaultMessage": "Close manage projects dialog"
    },
    manuallyLinkProjectTitle: {
        "id": "frontbucket.jiraTab.manageProjectsDialog.manuallyLinkProjectTitle",
        "defaultMessage": "Manually link project"
    },
    unlinkProjectTitle: {
        "id": "frontbucket.jiraTab.manageProjectsDialog.unlinkProjectTitle",
        "defaultMessage": "Unlink project"
    },
    unlinkProjectDetails: {
        "id": "frontbucket.jiraTab.manageProjectsDialog.unlinkProjectDetails",
        "defaultMessage": "<p>Are you sure that you want to unlink the <b>{projectName} ({projectKey})</b> project from this repository?</p><p>You can link this project again in the future by manually linking it from \u2018Manage linked projects\u2019.</p>"
    },
    unlinkProjectCancel: {
        "id": "frontbucket.jiraTab.manageProjectsDialog.unlinkProjectCancel",
        "defaultMessage": "Cancel"
    },
    unlinkProjectConfirm: {
        "id": "frontbucket.jiraTab.manageProjectsDialog.unlinkProjectConfirm",
        "defaultMessage": "Confirm"
    },
    linkProjectFailedMessage: {
        "id": "frontbucket.jiraTab.manageProjectsDialog.linkProjectFailedMessage",
        "defaultMessage": "Failed to link project"
    },
    linkProjectSuccessMessage: {
        "id": "frontbucket.jiraTab.manageProjectsDialog.linkProjectSuccessMessage",
        "defaultMessage": "Project linked successfully"
    },
    unlinkProjectFailedMessage: {
        "id": "frontbucket.jiraTab.manageProjectsDialog.unlinkProjectFailedMessage",
        "defaultMessage": "Failed to unlink project"
    },
    unlinkProjectSuccessMessage: {
        "id": "frontbucket.jiraTab.manageProjectsDialog.unlinkProjectSuccessMessage",
        "defaultMessage": "Project unlinked successfully"
    }
});

});

parcelRegister("1cbbV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97090e822341997d$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $97090e822341997d$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    issueHeader: {
        "id": "frontbucket.jswTab.siteIssuesList.issueHeader",
        "defaultMessage": "Issue"
    },
    statusHeader: {
        "id": "frontbucket.jswTab.siteIssuesList.statusHeader",
        "defaultMessage": "Status"
    },
    assigneeHeader: {
        "id": "frontbucket.jswTab.siteIssuesList.assigneeHeader",
        "defaultMessage": "Assignee"
    },
    updatedHeader: {
        "id": "frontbucket.jswTab.siteIssuesList.updatedHeader",
        "defaultMessage": "Updated"
    },
    actionsHeader: {
        "id": "frontbucket.jswTab.siteIssuesList.actionsHeader",
        "defaultMessage": "Actions"
    },
    moreLabel: {
        "id": "frontbucket.jswTab.siteIssuesList.moreLabel",
        "defaultMessage": "More"
    },
    createBranchButton: {
        "id": "frontbucket.jswTab.siteIssuesList.createBranchButton",
        "defaultMessage": "Create branch"
    },
    failedToLoadIssuesTitle: {
        "id": "frontbucket.jswTab.siteIssuesList.failedToLoadIssuesTitle",
        "defaultMessage": "We can't load the issues"
    },
    bitbucket: {
        "id": "frontbucket.dashboard.overview.jiraIssues.bitbucket",
        "defaultMessage": "Bitbucket"
    },
    jira: {
        "id": "frontbucket.dashboard.overview.jiraIssues.jira",
        "defaultMessage": "Jira"
    },
    copyIssueLink: {
        "id": "frontbucket.dashboard.overview.jiraIssues.copyIssueLink",
        "defaultMessage": "Copy issue link"
    },
    issueLinkCopiedTitle: {
        "id": "frontbucket.dashboard.overview.jiraIssues.issueLinkCopiedTitle",
        "defaultMessage": "Issue link copied"
    },
    issueLinkCopiedBody: {
        "id": "frontbucket.dashboard.overview.jiraIssues.issueLinkCopiedBody",
        "defaultMessage": "Issue link successfully copied to your clipboard"
    },
    assignIssueSuccessTitle: {
        "id": "frontbucket.dashboard.overview.jiraIssues.assignIssueSuccessTitle",
        "defaultMessage": "Issue assigned successfully"
    },
    assignIssueFailureTitle: {
        "id": "frontbucket.dashboard.overview.jiraIssues.assignIssueFailureTitle",
        "defaultMessage": "Assigning the issue failed"
    },
    openInJira: {
        "id": "frontbucket.dashboard.overview.jiraIssues.openInJira",
        "defaultMessage": "Open in Jira"
    },
    assignToMe: {
        "id": "frontbucket.dashboard.overview.jiraIssues.assignToMe",
        "defaultMessage": "Assign to me"
    }
});

});

parcelRegister("bWpII", function(module, exports) {

$parcel$export(module.exports, "getFilterState", function () { return $bd8fc542ed3cf704$export$26893885d9a03bc4; });
$parcel$export(module.exports, "getFilterPreferencesFetchedStatus", function () { return $bd8fc542ed3cf704$export$94ebd57d6d3e8c3e; });
$parcel$export(module.exports, "getRelevantSitesFetchedStatus", function () { return $bd8fc542ed3cf704$export$a625f328dc5e055a; });
$parcel$export(module.exports, "getRelevantSites", function () { return $bd8fc542ed3cf704$export$ff383dba30dc96b2; });
$parcel$export(module.exports, "getRelevantProjectFetchedStatus", function () { return $bd8fc542ed3cf704$export$54eb2a981484c826; });
$parcel$export(module.exports, "getProjectAssociations", function () { return $bd8fc542ed3cf704$export$535c27b000879349; });
$parcel$export(module.exports, "getSelectedAssignees", function () { return $bd8fc542ed3cf704$export$b162c62cb0504aa; });
$parcel$export(module.exports, "getRelevantIssuesFetchedStatus", function () { return $bd8fc542ed3cf704$export$84a79c57566793b8; });
$parcel$export(module.exports, "getRelevantIssues", function () { return $bd8fc542ed3cf704$export$510fe4819c3d9151; });
$parcel$export(module.exports, "getRelevantIssuesPages", function () { return $bd8fc542ed3cf704$export$8ebfec662420f551; });
$parcel$export(module.exports, "getAssigneesFetchedStatus", function () { return $bd8fc542ed3cf704$export$991e196343d4b280; });
$parcel$export(module.exports, "getAssignees", function () { return $bd8fc542ed3cf704$export$83f72e15d115a0e7; });
$parcel$export(module.exports, "getIsManageProjectsDialogOpen", function () { return $bd8fc542ed3cf704$export$cbc44e7396dd3272; });
$parcel$export(module.exports, "getIsProjectsMenuOpen", function () { return $bd8fc542ed3cf704$export$2e58e589d4b62059; });
$parcel$export(module.exports, "getProjectToUnlink", function () { return $bd8fc542ed3cf704$export$219c0b28118558d0; });
$parcel$export(module.exports, "getJiraSites", function () { return $bd8fc542ed3cf704$export$c654f9d19ba9cf7b; });
$parcel$export(module.exports, "getJiraSitesFetchedStatus", function () { return $bd8fc542ed3cf704$export$c57d402021f9e1bd; });
$parcel$export(module.exports, "getJiraProjects", function () { return $bd8fc542ed3cf704$export$9e28e4d92e9a4215; });
$parcel$export(module.exports, "getLinkJiraProjectStatus", function () { return $bd8fc542ed3cf704$export$3d34257861502cbd; });
$parcel$export(module.exports, "getUnlinkJiraProjectStatus", function () { return $bd8fc542ed3cf704$export$460356913526a814; });

var $aXXtM = parcelRequire("aXXtM");

var $7qdXF = parcelRequire("7qdXF");
const $bd8fc542ed3cf704$export$26893885d9a03bc4 = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraRepoPage.filterState);
const $bd8fc542ed3cf704$export$94ebd57d6d3e8c3e = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraRepoPage.filterPreferencesFetchedStatus);
const $bd8fc542ed3cf704$export$a625f328dc5e055a = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraRepoPage.relevantSitesFetchedStatus);
const $bd8fc542ed3cf704$export$ff383dba30dc96b2 = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraRepoPage.relevantSites);
const $bd8fc542ed3cf704$export$54eb2a981484c826 = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraRepoPage.relevantProjectsFetchedStatus);
const $bd8fc542ed3cf704$export$535c27b000879349 = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraRepoPage.projectAssociations);
const $bd8fc542ed3cf704$export$b162c62cb0504aa = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraRepoPage.filterState.assignees);
const $bd8fc542ed3cf704$export$84a79c57566793b8 = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraRepoPage.jiraRelevantIssuesFetchedStatus);
const $bd8fc542ed3cf704$export$510fe4819c3d9151 = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraRepoPage.jiraRelevantIssues);
const $bd8fc542ed3cf704$export$8ebfec662420f551 = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraRepoPage.jiraRelevantIssuesPages);
const $bd8fc542ed3cf704$export$991e196343d4b280 = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraRepoPage.assigneesFetchedStatus);
const $bd8fc542ed3cf704$export$83f72e15d115a0e7 = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraRepoPage.assignees);
const $bd8fc542ed3cf704$export$cbc44e7396dd3272 = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraRepoPage.isManageProjectsDialogOpen);
const $bd8fc542ed3cf704$export$2e58e589d4b62059 = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraRepoPage.isProjectsMenuOpen);
const $bd8fc542ed3cf704$export$219c0b28118558d0 = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraRepoPage.projectToUnlink);
const $bd8fc542ed3cf704$export$c654f9d19ba9cf7b = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraRepoPage.sites);
const $bd8fc542ed3cf704$export$c57d402021f9e1bd = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraRepoPage.sitesFetchedStatus);
const $bd8fc542ed3cf704$export$9e28e4d92e9a4215 = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraRepoPage.projects);
const $bd8fc542ed3cf704$export$3d34257861502cbd = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraRepoPage.linkJiraProjectStatus);
const $bd8fc542ed3cf704$export$460356913526a814 = (0, $aXXtM.createSelector)((0, $7qdXF.getJiraSlice), (state)=>state.jiraRepoPage.unlinkJiraProjectStatus);

});

parcelRegister("9Og0J", function(module, exports) {

$parcel$export(module.exports, "SORT_ORDER", function () { return $0784203334559ed8$export$d33cb9b119034d29; });
$parcel$export(module.exports, "AssigneeType", function () { return $0784203334559ed8$export$11c4bc849d297c77; });
var $0784203334559ed8$export$d33cb9b119034d29;
(function(SORT_ORDER) {
    SORT_ORDER["ASC"] = "ASC";
    SORT_ORDER["DESC"] = "DESC";
})($0784203334559ed8$export$d33cb9b119034d29 || ($0784203334559ed8$export$d33cb9b119034d29 = {}));
var $0784203334559ed8$export$11c4bc849d297c77;
(function(AssigneeType) {
    AssigneeType["Self"] = "SELF";
    AssigneeType["Avatars"] = "AVATARS";
    AssigneeType["Unassigned"] = "UNASSIGNED";
    AssigneeType["Dropdown"] = "DROPDOWN";
})($0784203334559ed8$export$11c4bc849d297c77 || ($0784203334559ed8$export$11c4bc849d297c77 = {}));

});


parcelRegister("eapIg", function(module, exports) {

$parcel$export(module.exports, "fetchAvailableIssueTransitionsSaga", function () { return $03015cc23f9e2c54$export$ddc546529dbd9c4c; });
$parcel$export(module.exports, "fetchPullRequestJiraIssuesSaga", function () { return $03015cc23f9e2c54$export$31e1971c6fe19f0; });
$parcel$export(module.exports, "fetchTransitionUserPreference", function () { return $03015cc23f9e2c54$export$e8ebb8d6323dc7ca; });
$parcel$export(module.exports, "initialiseIssueTransitions", function () { return $03015cc23f9e2c54$export$b6b9457ad2f05357; });
$parcel$export(module.exports, "transitionIssuesSaga", function () { return $03015cc23f9e2c54$export$42327e275f0df798; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $3XbtU = parcelRequire("3XbtU");

var $67Kn2 = parcelRequire("67Kn2");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $90kWr = parcelRequire("90kWr");

var $1EkdU = parcelRequire("1EkdU");

var $aanBq = parcelRequire("aanBq");

var $g2R3c = parcelRequire("g2R3c");

var $4EtqP = parcelRequire("4EtqP");

var $k2cPS = parcelRequire("k2cPS");

var $j9gxd = parcelRequire("j9gxd");

var $628YF = parcelRequire("628YF");
parcelRequire("erZj9");
var $fYcHx = parcelRequire("fYcHx");

var $hahvB = parcelRequire("hahvB");

var $lALYr = parcelRequire("lALYr");
function* $03015cc23f9e2c54$export$ddc546529dbd9c4c({ payload: index }) {
    const { issueTransitionPreferenceFetchedStatus: issueTransitionPreferenceFetchedStatus } = yield (0, $5NpoY.a3)((0, $lALYr.getPullRequestJiraIssuesState));
    if (issueTransitionPreferenceFetchedStatus !== (0, $90kWr.LoadingStatus).Failed && issueTransitionPreferenceFetchedStatus !== (0, $90kWr.LoadingStatus).Success) yield (0, $5NpoY.T)({
        success: (0, $5NpoY.M)((0, $fYcHx.FETCH_TRANSITION_USER_PREFERENCE).SUCCESS),
        failure: (0, $5NpoY.M)((0, $fYcHx.FETCH_TRANSITION_USER_PREFERENCE).ERROR)
    });
    const { issueTransitionFormData: issueTransitionFormData, issueTransitionPreference: issueTransitionPreference } = yield (0, $5NpoY.a3)((0, $lALYr.getPullRequestJiraIssuesState));
    try {
        const prIssue = issueTransitionFormData[index].selectedIssue;
        const url = (0, $4EtqP.default).api.internal.availableTransitions(prIssue.issue.site.cloudId, prIssue.issue.key);
        const request = (0, $k2cPS.default)(url);
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            // @ts-ignore
            const data = yield response.json();
            const transitionData = (0, $67Kn2.default)(issueTransitionFormData[index]);
            const automaticTransitions = data.filter((transition)=>transition.triggers && transition.triggers.filter((trigger)=>trigger === "pull_request_merged").length > 0);
            const availableTransitions = data// Exclude unsupported transitions
            .filter((transition)=>transition.isAvailable && !transition.hasScreen)// Order the remaining transitions according to their status category.
            .sort((a, b)=>{
                var _a$to, _b$to, _a$to2, _b$to2;
                if (((_a$to = a.to) === null || _a$to === void 0 ? void 0 : _a$to.statusCategory.key) === ((_b$to = b.to) === null || _b$to === void 0 ? void 0 : _b$to.statusCategory.key)) return 0;
                if (((_a$to2 = a.to) === null || _a$to2 === void 0 ? void 0 : _a$to2.statusCategory.key) === (0, $hahvB.IssueCategory).Todo || ((_b$to2 = b.to) === null || _b$to2 === void 0 ? void 0 : _b$to2.statusCategory.key) === (0, $hahvB.IssueCategory).Done) return -1;
                return 1;
            });
            // Use the transition saved in user preference API as the default option.
            // If this transition doesn't exist in the list of available transitions
            // then use the transition which is at the end of the list sorted by status
            // category.
            let selectedTransition;
            selectedTransition = availableTransitions.find((transition)=>transition.id === (issueTransitionPreference === null || issueTransitionPreference === void 0 ? void 0 : issueTransitionPreference.toString()));
            if (!issueTransitionPreference || !selectedTransition) selectedTransition = availableTransitions ? availableTransitions[availableTransitions.length - 1] : undefined;
            const updatedTransitionForm = {
                ...transitionData,
                availableIssueTransitions: availableTransitions,
                availableIssueTransitionsFetchedStatus: (0, $90kWr.LoadingStatus).Success,
                automaticTransition: automaticTransitions ? automaticTransitions[0] : undefined,
                selectedTransition: selectedTransition,
                hasUnsupportedTransitions: availableTransitions.length !== data.length
            };
            yield (0, $5NpoY.Y)({
                type: (0, $fYcHx.FETCH_AVAILABLE_ISSUE_TRANSITIONS).SUCCESS,
                payload: {
                    updatedTransitionForm: updatedTransitionForm,
                    index: index
                }
            });
        } else {
            yield (0, $628YF.captureMessageForResponse)(response, "Fetching available issue transitions failed");
            yield (0, $5NpoY.Y)({
                type: (0, $fYcHx.FETCH_AVAILABLE_ISSUE_TRANSITIONS).ERROR,
                payload: index
            });
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $fYcHx.FETCH_AVAILABLE_ISSUE_TRANSITIONS).ERROR,
            payload: index
        });
    }
}
function* $03015cc23f9e2c54$var$fetchIssuesRecursively(repositoryFullSlug, pullRequestId, currentPage, values = []) {
    const url = `${(0, $4EtqP.default).api.internal.issues(repositoryFullSlug, pullRequestId)}?page=${currentPage}`;
    const request = (0, $k2cPS.default)(url);
    const response = yield (0, $5NpoY.P)(fetch, request);
    if (response.ok) {
        const data = yield response.json();
        if (Array.isArray(data.values)) values.push(...data.values);
        // Due to doing multiple separate requests, we could end up with a situation
        // where values.length and data.size never match, so also stop if we get no
        // new results in the page.
        if (values.length === data.size || (data.values || []).length === 0) yield (0, $5NpoY.Y)({
            type: (0, $fYcHx.FETCH_PULL_REQUEST_JIRA_ISSUES).SUCCESS,
            payload: values
        });
        else yield $03015cc23f9e2c54$var$fetchIssuesRecursively(repositoryFullSlug, pullRequestId, currentPage + 1, values);
    } else {
        // Receiving a 404 error is the expected behaviour when a user isn't
        // authenticated so don't send an error to sentry.
        if (response.status !== 404) yield (0, $628YF.captureMessageForResponse)(response, "Fetching PR Jira issues failed");
        yield (0, $5NpoY.Y)({
            type: (0, $fYcHx.FETCH_PULL_REQUEST_JIRA_ISSUES).ERROR
        });
    }
}
function* $03015cc23f9e2c54$export$31e1971c6fe19f0({ owner: owner, slug: slug, id: pullRequestId }) {
    const repositoryFullSlug = `${owner}/${slug}`;
    try {
        yield $03015cc23f9e2c54$var$fetchIssuesRecursively(repositoryFullSlug, pullRequestId, 1);
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $fYcHx.FETCH_PULL_REQUEST_JIRA_ISSUES).ERROR
        });
    }
}
const $03015cc23f9e2c54$var$transitionIssueUserPrefKey = "transition-issue-on-merge-preference";
function* $03015cc23f9e2c54$export$d51368d9e844f4cc(transitionId) {
    const currentUser = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
    if (!currentUser) return;
    try {
        yield (0, $5NpoY.P)((0, $j9gxd.default).set, currentUser.uuid, $03015cc23f9e2c54$var$transitionIssueUserPrefKey, transitionId);
    } catch (e) {
        $3XbtU.captureException(e);
    }
}
function* $03015cc23f9e2c54$export$e8ebb8d6323dc7ca() {
    const currentUser = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
    if (!currentUser) return;
    try {
        // @ts-ignore
        const preferencesRaw = yield (0, $5NpoY.P)((0, $j9gxd.default).get, currentUser.uuid, $03015cc23f9e2c54$var$transitionIssueUserPrefKey);
        const preferences = preferencesRaw ? JSON.parse(preferencesRaw) : undefined;
        if (preferences) yield (0, $5NpoY.Y)({
            type: (0, $fYcHx.FETCH_TRANSITION_USER_PREFERENCE).SUCCESS,
            payload: preferences
        });
        else yield (0, $5NpoY.Y)({
            type: (0, $fYcHx.FETCH_TRANSITION_USER_PREFERENCE).ERROR
        });
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $fYcHx.FETCH_TRANSITION_USER_PREFERENCE).ERROR
        });
        $3XbtU.captureException(e);
    }
}
function* $03015cc23f9e2c54$export$b6b9457ad2f05357() {
    const allPrIssues = yield (0, $5NpoY.a3)((0, $lALYr.getPullRequestJiraIssues));
    const prIssues = allPrIssues.slice(0, 3);
    const transitions = prIssues.map((prIssue)=>({
            selectedIssue: prIssue,
            availableIssueTransitions: [],
            availableIssueTransitionsFetchedStatus: (0, $90kWr.LoadingStatus).Before,
            automaticTransition: undefined,
            selectedTransition: undefined,
            shouldTransition: false,
            hasUnsupportedTransitions: false
        }));
    yield (0, $5NpoY.Y)((0, $fYcHx.initIssueTransitions)(transitions));
    yield (0, $5NpoY._)(transitions.map((_, index)=>(0, $5NpoY.P)($03015cc23f9e2c54$export$ddc546529dbd9c4c, {
            type: (0, $fYcHx.FETCH_AVAILABLE_ISSUE_TRANSITIONS).REQUEST,
            payload: index
        })));
}
function* $03015cc23f9e2c54$export$42327e275f0df798() {
    const repositoryFullSlug = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryFullSlug));
    const pullRequestId = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestId));
    const issueTransitionForm = yield (0, $5NpoY.a3)((0, $lALYr.getIssueTransitionForm));
    const issueTransitions = issueTransitionForm.filter((issue)=>issue.shouldTransition);
    try {
        const url = (0, $4EtqP.default).api.internal.transitions(repositoryFullSlug, pullRequestId);
        const body = {
            transitions: issueTransitions.map((transition)=>{
                var _transition$selectedI, _transition$selectedI2, _transition$selectedT;
                return {
                    cloudId: (_transition$selectedI = transition.selectedIssue) === null || _transition$selectedI === void 0 ? void 0 : _transition$selectedI.issue.site.cloudId,
                    issueKeyOrId: (_transition$selectedI2 = transition.selectedIssue) === null || _transition$selectedI2 === void 0 ? void 0 : _transition$selectedI2.issue.key,
                    transitionId: (_transition$selectedT = transition.selectedTransition) === null || _transition$selectedT === void 0 ? void 0 : _transition$selectedT.id
                };
            })
        };
        const request = (0, $k2cPS.default)(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
        });
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            yield (0, $5NpoY.Y)({
                type: (0, $fYcHx.TRANSITION_ISSUES).SUCCESS
            });
            // If there are transitions of multiple types, we will save the first one as their preference.
            if (issueTransitions[0].selectedTransition) yield (0, $5NpoY.P)($03015cc23f9e2c54$export$d51368d9e844f4cc, issueTransitions[0].selectedTransition.id);
        } else {
            yield (0, $628YF.captureMessageForResponse)(response, "Transitioning issue failed");
            yield (0, $5NpoY.Y)({
                type: (0, $fYcHx.TRANSITION_ISSUES).ERROR
            });
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $fYcHx.TRANSITION_ISSUES).ERROR
        });
    }
}

});
parcelRegister("67Kn2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47575dbf15d468f5$export$2e2bcd8739ae039; });

var $5Ng8I = parcelRequire("5Ng8I");
/** Used to compose bitmasks for cloning. */ var $47575dbf15d468f5$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $47575dbf15d468f5$var$clone(value) {
    return (0, $5Ng8I.default)(value, $47575dbf15d468f5$var$CLONE_SYMBOLS_FLAG);
}
var $47575dbf15d468f5$export$2e2bcd8739ae039 = $47575dbf15d468f5$var$clone;

});



parcelRegister("a7dqv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6b149cb6b0cc495$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");

var $gAfkB = parcelRequire("gAfkB");

var $2Vhjr = parcelRequire("2Vhjr");
function* $d6b149cb6b0cc495$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLatest)([
            (0, $gAfkB.LoadPullRequests).SUCCESS,
            (0, $jJd6W.LoadRepositoryPage).SUCCESS
        ], (0, $2Vhjr.default))
    ]);
}

});
parcelRegister("gAfkB", function(module, exports) {
$parcel$export(module.exports, "clearFilteredAuthors", function () { return (parcelRequire("a3bLa")).clearFilteredAuthors; });
$parcel$export(module.exports, "ClearFilteredAuthors", function () { return (parcelRequire("a3bLa")).ClearFilteredAuthors; });
$parcel$export(module.exports, "fetchPullRequestAuthor", function () { return (parcelRequire("a3bLa")).fetchPullRequestAuthor; });
$parcel$export(module.exports, "fetchPullRequestAuthors", function () { return (parcelRequire("a3bLa")).fetchPullRequestAuthors; });
$parcel$export(module.exports, "LoadPullRequestAuthor", function () { return (parcelRequire("a3bLa")).LoadPullRequestAuthor; });
$parcel$export(module.exports, "LoadPullRequestAuthors", function () { return (parcelRequire("a3bLa")).LoadPullRequestAuthors; });
$parcel$export(module.exports, "updatePreloadedAuthor", function () { return (parcelRequire("a3bLa")).updatePreloadedAuthor; });
$parcel$export(module.exports, "UpdatePreloadedAuthor", function () { return (parcelRequire("a3bLa")).UpdatePreloadedAuthor; });

$parcel$export(module.exports, "LoadPullRequests", function () { return $18990c7f6c8691a8$export$68cbdec951e94a2b; });
$parcel$export(module.exports, "loadPullRequests", function () { return $18990c7f6c8691a8$export$b1da3a2fce50fe1b; });
$parcel$export(module.exports, "UnloadPullRequests", function () { return $18990c7f6c8691a8$export$e85e9a043c821dea; });
$parcel$export(module.exports, "unloadPullRequests", function () { return $18990c7f6c8691a8$export$e416b176bfdbce71; });

var $cJH1T = parcelRequire("cJH1T");
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
var $fICwP = parcelRequire("fICwP");

var $b2RHC = parcelRequire("b2RHC");
parcelRequire("a3bLa");
const $18990c7f6c8691a8$export$68cbdec951e94a2b = (0, $2MctD.createAsyncAction)("pullRequestList/LOAD");
const $18990c7f6c8691a8$export$b1da3a2fce50fe1b = (props)=>{
    const { repositoryOwner: repositoryOwner, repositorySlug: repositorySlug, page: page, sort: sort } = props;
    const query = (0, $cJH1T.stringify)({
        pagelen: 25,
        fields: "+values.participants,-values.description,-values.summary",
        q: props.bbql,
        sort: sort,
        page: page
    });
    const url = `/!api/2.0/repositories/${repositoryOwner}/${repositorySlug}/pullrequests?${query}`;
    const schema = {
        values: [
            (0, $b2RHC.pullRequest)
        ]
    };
    return (0, $fICwP.fetchAction)($18990c7f6c8691a8$export$68cbdec951e94a2b, {
        url: url,
        schema: schema,
        takeLatest: true
    });
};
const $18990c7f6c8691a8$export$e3d572cceda3ab9f = "pullRequestList/loadNextPage";
const $18990c7f6c8691a8$export$4d52b9323dab374a = "pullRequestList/loadPreviousPage";
const $18990c7f6c8691a8$export$226b4e6021a9ee05 = "pullRequestList/PageUnload";
const $18990c7f6c8691a8$export$4e3385f910e23c73 = ()=>({
        type: $18990c7f6c8691a8$export$226b4e6021a9ee05
    });
const $18990c7f6c8691a8$export$e85e9a043c821dea = "pullRequestList/UNLOAD";
const $18990c7f6c8691a8$export$e416b176bfdbce71 = ()=>({
        type: $18990c7f6c8691a8$export$e85e9a043c821dea
    });

});
parcelRegister("a3bLa", function(module, exports) {

$parcel$export(module.exports, "LoadPullRequestAuthors", function () { return $db8028faf9d46de5$export$e4afe1b4a446b8aa; });
$parcel$export(module.exports, "ClearFilteredAuthors", function () { return $db8028faf9d46de5$export$2e8f2947a73d6b44; });
$parcel$export(module.exports, "LoadPullRequestAuthor", function () { return $db8028faf9d46de5$export$425431985f62b5bb; });
$parcel$export(module.exports, "UpdatePreloadedAuthor", function () { return $db8028faf9d46de5$export$d017ecb38c7fac2d; });
$parcel$export(module.exports, "fetchPullRequestAuthors", function () { return $db8028faf9d46de5$export$98abcf22a707b72f; });
$parcel$export(module.exports, "fetchPullRequestAuthor", function () { return $db8028faf9d46de5$export$fb595e039241ae20; });
$parcel$export(module.exports, "clearFilteredAuthors", function () { return $db8028faf9d46de5$export$14add0a399c3b0d8; });
$parcel$export(module.exports, "updatePreloadedAuthor", function () { return $db8028faf9d46de5$export$f900d820d79974f; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
var $fICwP = parcelRequire("fICwP");

var $kZnTB = parcelRequire("kZnTB");

var $3rtV2 = parcelRequire("3rtV2");
const $db8028faf9d46de5$export$e4afe1b4a446b8aa = (0, $2MctD.createAsyncAction)("pullRequestList/LOAD_AUTHORS");
const $db8028faf9d46de5$export$2e8f2947a73d6b44 = "pullRequestList/CLEAR_FILTERED_AUTHORS";
const $db8028faf9d46de5$export$425431985f62b5bb = (0, $2MctD.createAsyncAction)("pullRequestList/LOAD_AUTHOR");
const $db8028faf9d46de5$export$d017ecb38c7fac2d = "pullRequestList/UPDATE_AUTHOR";
const $db8028faf9d46de5$export$98abcf22a707b72f = (repoUrl, status, query)=>{
    return (0, $fICwP.fetchAction)($db8028faf9d46de5$export$e4afe1b4a446b8aa, {
        url: (0, $kZnTB.default).api.internal.pullRequestAuthors(repoUrl, {
            status: status,
            query: query
        }),
        data: {
            status: status,
            query: query
        }
    });
};
const $db8028faf9d46de5$export$fb595e039241ae20 = (uuid)=>{
    return (0, $fICwP.fetchAction)($db8028faf9d46de5$export$425431985f62b5bb, {
        url: (0, $3rtV2.default).api.v20.user(uuid)
    });
};
const $db8028faf9d46de5$export$14add0a399c3b0d8 = ()=>({
        type: $db8028faf9d46de5$export$2e8f2947a73d6b44
    });
const $db8028faf9d46de5$export$f900d820d79974f = (payload)=>({
        type: $db8028faf9d46de5$export$d017ecb38c7fac2d,
        payload: payload
    });

});


parcelRegister("2Vhjr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $347bf23571e45d15$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $b2RHC = parcelRequire("b2RHC");

var $aanBq = parcelRequire("aanBq");

var $4oBYE = parcelRequire("4oBYE");

var $k2cPS = parcelRequire("k2cPS");

var $26wAJ = parcelRequire("26wAJ");

var $6rydh = parcelRequire("6rydh");
function $347bf23571e45d15$var$createCommitStatusMapper(statuses) {
    return (pr)=>{
        const status = statuses[(0, $26wAJ.short12Hash)(pr.source.commit.hash)];
        return {
            ...pr,
            status_counts: status && status.status_counts
        };
    };
}
function* $347bf23571e45d15$export$2e2bcd8739ae039() {
    const currentRepository = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    // @ts-ignore
    const prs = yield (0, $5NpoY.a3)((0, $6rydh.getPullRequests));
    if (!prs.length || !currentRepository) return;
    const url = (0, $4oBYE.default).api.internal.commitsBuildStatuses(currentRepository.full_name);
    try {
        const request = (0, $k2cPS.default)(url, {
            method: "POST",
            // @ts-ignore TODO: fix noImplicitAny error here
            body: prs.map((pr)=>`commits=${pr.source.commit.hash}`).join("&"),
            headers: {
                "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
            }
        });
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            // @ts-ignore
            const statuses = yield response.json();
            // not using an action creator for this because no reducer uses this
            // information; we rely on the normalizr middleware
            yield (0, $5NpoY.Y)({
                type: "pullRequestList/update-prs-with-build-status",
                payload: prs.map($347bf23571e45d15$var$createCommitStatusMapper(statuses)),
                meta: {
                    schema: [
                        (0, $b2RHC.pullRequest)
                    ]
                }
            });
        }
    } catch (e) {
    // ah dang, too bad
    }
}

});
parcelRegister("6rydh", function(module, exports) {

$parcel$export(module.exports, "getPullRequestList", function () { return $eb663ea857efecf5$export$764cb14360925eb1; });
$parcel$export(module.exports, "getPullRequests", function () { return $eb663ea857efecf5$export$89579874f56fc99d; });
$parcel$export(module.exports, "getPullRequestAuthorsSlice", function () { return $eb663ea857efecf5$export$3df02e583b4ec485; });
$parcel$export(module.exports, "getPullRequestPreloadedAuthorSlice", function () { return $eb663ea857efecf5$export$a541db441f5caaf7; });
$parcel$export(module.exports, "getPullRequestAuthorOptions", function () { return $eb663ea857efecf5$export$d58a9740b6bd1ca5; });
$parcel$export(module.exports, "getPullRequestPreloadedAuthorOption", function () { return $eb663ea857efecf5$export$815ce5010cb3c7ce; });
$parcel$export(module.exports, "getPullRequestsPagination", function () { return $eb663ea857efecf5$export$fe86b905f7f7d7e8; });

var $lIZwG = parcelRequire("lIZwG");
var $fLzne = parcelRequire("fLzne");

var $ga67g = parcelRequire("ga67g");

var $aXXtM = parcelRequire("aXXtM");

var $b2RHC = parcelRequire("b2RHC");

var $7qdXF = parcelRequire("7qdXF");

var $g2R3c = parcelRequire("g2R3c");

var $fIVvG = parcelRequire("fIVvG");

var $90ndC = parcelRequire("90ndC");
const $eb663ea857efecf5$export$764cb14360925eb1 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (repository)=>repository.pullRequestList.pullRequests);
const $eb663ea857efecf5$export$89579874f56fc99d = (0, $aXXtM.createSelector)($eb663ea857efecf5$export$764cb14360925eb1, (0, $7qdXF.getEntities), (prList, entities)=>(0, $ga67g.denormalize)(prList.listItems, [
        (0, $b2RHC.pullRequest)
    ], entities));
const $eb663ea857efecf5$export$3df02e583b4ec485 = (state)=>{
    return state.repository.pullRequestList.pullRequestAuthors;
};
const $eb663ea857efecf5$export$a541db441f5caaf7 = (state)=>{
    return state.repository.pullRequestList.pullRequestPreloadedAuthor;
};
const $eb663ea857efecf5$var$makeOption = (user)=>({
        label: (0, $fIVvG.default)(user.display_name, user.nickname),
        value: user
    });
const $eb663ea857efecf5$var$prependCurrentUserToAuthors = (currentUser, authors)=>{
    if (!currentUser) return authors;
    return [
        currentUser,
        ...authors.filter((a)=>a.uuid !== currentUser.uuid)
    ];
};
const $eb663ea857efecf5$export$d58a9740b6bd1ca5 = (0, $aXXtM.createSelector)($eb663ea857efecf5$export$3df02e583b4ec485, (0, $g2R3c.getCurrentUser), ({ authors: authors, filteredAuthors: filteredAuthors }, currentUser)=>{
    const authorsToUse = filteredAuthors.length ? filteredAuthors : authors;
    const reorderedAuthors = $eb663ea857efecf5$var$prependCurrentUserToAuthors(currentUser, authorsToUse);
    return reorderedAuthors.map((author)=>$eb663ea857efecf5$var$makeOption(author));
});
const $eb663ea857efecf5$export$815ce5010cb3c7ce = (uuid)=>(0, $aXXtM.createSelector)($eb663ea857efecf5$export$d58a9740b6bd1ca5, $eb663ea857efecf5$export$a541db441f5caaf7, (options, { author: preloadedAuthor })=>{
        if (!uuid) return null;
        if (preloadedAuthor && preloadedAuthor.uuid === uuid) return $eb663ea857efecf5$var$makeOption(preloadedAuthor);
        // @ts-ignore TODO: fix noImplicitAny error here
        return options.find((option)=>(0, $lIZwG.default)(option, "value.uuid") === uuid);
    });
const $eb663ea857efecf5$var$getPullRequestListSize = (state)=>state.repository.pullRequestList.pullRequests.size;
const $eb663ea857efecf5$var$getPullRequestListLength = (state)=>state.repository.pullRequestList.pullRequests.pagelen;
const $eb663ea857efecf5$export$53fcb9aaecde6f9b = (0, $aXXtM.createSelector)($eb663ea857efecf5$var$getPullRequestListSize, $eb663ea857efecf5$var$getPullRequestListLength, (size, pageLength)=>size && pageLength ? Math.ceil(size / pageLength) : 1);
const $eb663ea857efecf5$export$fe86b905f7f7d7e8 = (0, $aXXtM.createSelector)($eb663ea857efecf5$export$53fcb9aaecde6f9b, (totalPages)=>(0, $fLzne.default)((0, $90ndC.getPagination)(totalPages)));

});
parcelRegister("fIVvG", function(module, exports) {

$parcel$export(module.exports, "hasDistinctDisplayName", function () { return $cb1972e7dae52943$export$fa65c3874c5418b0; });
$parcel$export(module.exports, "default", function () { return $cb1972e7dae52943$export$2e2bcd8739ae039; });
function $cb1972e7dae52943$export$fa65c3874c5418b0(displayName, nickname) {
    return nickname && displayName !== nickname;
}
function $cb1972e7dae52943$export$2e2bcd8739ae039(displayName, nickname) {
    return $cb1972e7dae52943$export$fa65c3874c5418b0(displayName, nickname) ? `${displayName} (${nickname})` : displayName;
}

});




parcelRegister("8CVKy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d2403b304061309$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $i2O3k = parcelRequire("i2O3k");

var $64gC0 = parcelRequire("64gC0");

var $eapIg = parcelRequire("eapIg");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");
var $dkXlf = parcelRequire("dkXlf");

var $k6zif = parcelRequire("k6zif");

var $8mswv = parcelRequire("8mswv");

var $8Ao0D = parcelRequire("8Ao0D");

var $lp4Gn = parcelRequire("lp4Gn");

var $JRfJN = parcelRequire("JRfJN");

var $14kRW = parcelRequire("14kRW");

var $aBe8c = parcelRequire("aBe8c");

var $2WdMK = parcelRequire("2WdMK");

var $6vkvB = parcelRequire("6vkvB");

var $ioXzt = parcelRequire("ioXzt");

var $1gAUK = parcelRequire("1gAUK");

var $3Eq4L = parcelRequire("3Eq4L");

var $a3m1Q = parcelRequire("a3m1Q");

var $etixh = parcelRequire("etixh");

var $2DnR8 = parcelRequire("2DnR8");

var $3CRlf = parcelRequire("3CRlf");

var $dkZ38 = parcelRequire("dkZ38");

var $h5rrr = parcelRequire("h5rrr");

var $gLU6V = parcelRequire("gLU6V");

var $7pCcb = parcelRequire("7pCcb");

var $aAhXh = parcelRequire("aAhXh");

var $cBYtK = parcelRequire("cBYtK");

var $i1nwo = parcelRequire("i1nwo");

var $fTGX3 = parcelRequire("fTGX3");

var $63mqJ = parcelRequire("63mqJ");

var $gzGkQ = parcelRequire("gzGkQ");

var $8jjaz = parcelRequire("8jjaz");

var $cKQdu = parcelRequire("cKQdu");

var $gB6Wt = parcelRequire("gB6Wt");

var $AunSz = parcelRequire("AunSz");

var $dXUHi = parcelRequire("dXUHi");

var $1lUhL = parcelRequire("1lUhL");

var $6wffr = parcelRequire("6wffr");

var $e7ae2 = parcelRequire("e7ae2");

var $4eFnp = parcelRequire("4eFnp");

var $jIQcY = parcelRequire("jIQcY");

var $5mCUg = parcelRequire("5mCUg");

var $lSc3Y = parcelRequire("lSc3Y");

var $VXZCu = parcelRequire("VXZCu");

var $e06Gc = parcelRequire("e06Gc");

var $8NUP2 = parcelRequire("8NUP2");

var $4H339 = parcelRequire("4H339");

var $3qdsi = parcelRequire("3qdsi");

var $ffege = parcelRequire("ffege");

var $b88QV = parcelRequire("b88QV");

var $dBEfZ = parcelRequire("dBEfZ");

var $a8V3A = parcelRequire("a8V3A");

var $bjEV1 = parcelRequire("bjEV1");

var $k94X1 = parcelRequire("k94X1");

var $XatWx = parcelRequire("XatWx");

var $lf0Id = parcelRequire("lf0Id");
function* $9d2403b304061309$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $lp4Gn.rootPrCommitsSaga)(),
        (0, $5mCUg.mergePullRequestSaga)(),
        (0, $jeUNF.takeLatest)((0, $6D21P.LOAD_PULL_REQUEST).SUCCESS, (0, $5mCUg.pollMergeTaskStatusSaga)),
        (0, $jeUNF.takeLatest)((0, $6D21P.LOAD_PULL_REQUEST).SUCCESS, (0, $AunSz.fetchPullRequestComments)),
        (0, $jeUNF.takeLatest)((0, $6D21P.LOAD_PULL_REQUEST).SUCCESS, (0, $i1nwo.fetchCommentLikes)),
        (0, $jeUNF.takeLatest)((0, $6D21P.LOAD_PULL_REQUEST).SUCCESS, (0, $dXUHi.default)),
        (0, $jeUNF.takeLatest)((0, $k6zif.FETCH_PENDING_MERGE_STATUS).REQUEST, (0, $cKQdu.fetchPendingMergeStatusSaga)),
        (0, $jeUNF.takeLatest)((0, $k6zif.CREATE_PENDING_MERGE).REQUEST, (0, $a3m1Q.createPendingMergeSaga)),
        (0, $jeUNF.takeLatest)((0, $k6zif.CANCEL_PENDING_MERGE).REQUEST, (0, $ioXzt.cancelPendingMergeSaga)),
        (0, $jeUNF.takeEvery)((0, $6D21P.UPDATE_TITLE).REQUEST, (0, $k94X1.updatePrTitleSaga)),
        (0, $jeUNF.takeEvery)((0, $6D21P.UPDATE_DESCRIPTION).REQUEST, (0, $k94X1.updatePrDescriptionSaga)),
        (0, $jeUNF.takeEvery)((0, $6D21P.REMOVE_REVIEWER).REQUEST, (0, $k94X1.removeReviewerSaga)),
        (0, $jeUNF.takeEvery)((0, $6D21P.ADD_REVIEWER).REQUEST, (0, $k94X1.addReviewerSaga)),
        (0, $jeUNF.takeEvery)((0, $6D21P.REQUEST_CHANGES).REQUEST, (0, $e06Gc.default)),
        (0, $jeUNF.takeEvery)((0, $6D21P.UNDO_REQUEST_CHANGES).REQUEST, (0, $a8V3A.default)),
        (0, $2DnR8.default)(),
        (0, $jeUNF.takeEvery)((0, $2WdMK.UPLOAD_IMAGE).REQUEST, (0, $4eFnp.imageUploaderSaga)),
        (0, $e7ae2.rememberImageUploadCallbacks)(),
        (0, $b88QV.default)(),
        (0, $etixh.default)(),
        (0, $jeUNF.takeEvery)([
            (0, $6D21P.TASK_EDIT).REQUEST
        ], (0, $dkZ38.editTaskSaga)),
        (0, $jeUNF.takeEvery)([
            (0, $6D21P.TOGGLE_COMMENT_LIKE).REQUEST
        ], (0, $dBEfZ.toggleCommentLike)),
        (0, $dkZ38.editTasksSaga)(),
        (0, $3CRlf.default)(),
        (0, $jeUNF.takeEvery)((0, $6D21P.EXPAND_CONTEXT).REQUEST, (0, $h5rrr.expandContextSaga)),
        (0, $jeUNF.takeLatest)((0, $6D21P.ENTERED_CODE_REVIEW), (0, $4H339.scrollToGenericPermalink)),
        (0, $jeUNF.takeLatest)((0, $6D21P.INITIAL_DIFFS_RENDERED), (0, $4H339.scrollToLine)),
        (0, $jeUNF.takeLatest)((0, $6D21P.INITIAL_DIFFS_RENDERED), (0, $4H339.scrollToFilepath)),
        (0, $jeUNF.takeLatest)([
            (0, $6D21P.ENTERED_CODE_REVIEW),
            (0, $6D21P.PULL_REQUEST_TAB_REDIRECT)
        ], (0, $4H339.pullRequestCommentPermalinkScrollerSaga)),
        (0, $4H339.commitCommentPermalinkScrollerSaga)(),
        (0, $4H339.permalinkClickedScrollerSaga)(),
        (0, $4H339.permalinkChangedScrollerSaga)(),
        (0, $4H339.scrollToHiddenFile)(),
        (0, $jeUNF.takeLatest)((0, $6D21P.CHANGE_DIFF_SORT), (0, $4H339.scrollToFilteredSingleFile)),
        (0, $jeUNF.takeLatest)((0, $6D21P.UPDATE_FILTER_COMMENTS_BY_USER), (0, $4H339.scrollToFilteredSingleFile)),
        (0, $jeUNF.takeLatest)((0, $6D21P.SCROLL_TO_FILE), (0, $4H339.fileScrollerSaga)),
        (0, $jeUNF.takeEvery)((0, $6D21P.PUBLISH_BASE_PULL_REQUEST_FACT), (0, $gLU6V.publishBasePullRequestFactSaga)),
        (0, $jeUNF.takeEvery)((0, $6D21P.PUBLISH_PULL_REQUEST_DIFF_FACT), (0, $gLU6V.publishPullRequestDiffFactSaga)),
        (0, $jeUNF.takeEvery)((0, $6D21P.PULL_REQUEST_OPENED), (0, $6vkvB.publishScreenEventSaga)),
        (0, $jeUNF.takeEvery)((0, $6D21P.PUBLISH_PULL_REQUEST_TRACK_EVENT), (0, $6vkvB.publishTrackEventSaga)),
        (0, $jeUNF.takeEvery)((0, $6D21P.PUBLISH_PIPELINES_PULL_REQUEST_SCREEN_EVENT), (0, $6vkvB.publishPipelinesScreenEventSaga)),
        (0, $jeUNF.takeEvery)((0, $6D21P.PUBLISH_PULL_REQUEST_UI_EVENT), (0, $6vkvB.publishUiEventSaga)),
        (0, $3Eq4L.commentsContextSaga)(),
        (0, $jeUNF.takeLatest)((0, $6D21P.ENTERED_CODE_REVIEW), (0, $jIQcY.viewPullRequestCapabilitySaga)),
        (0, $jeUNF.takeLatest)((0, $6D21P.ENTERED_CODE_REVIEW), (0, $1gAUK.codeReviewDataSaga)),
        (0, $jeUNF.takeLatest)((0, $6D21P.ENTERED_CODE_REVIEW), (0, $lSc3Y.startingPollingForUpdates)),
        (0, $jeUNF.takeLatest)((0, $6D21P.ENTERED_CODE_REVIEW), (0, $64gC0.initCreateJiraIssueSaga)),
        (0, $jeUNF.takeLatest)((0, $6D21P.ENTERED_CODE_REVIEW), (0, $eapIg.fetchPullRequestJiraIssuesSaga)),
        (0, $jeUNF.takeLatest)((0, $i2O3k.UPDATE_GLOBAL_IS_SINGLE_FILE_MODE_ENABLED_SUCCESS), (0, $6wffr.globalSingleFileModeEnabledSaga)),
        (0, $jeUNF.takeLatest)((0, $6D21P.EXITED_CODE_REVIEW), (0, $lSc3Y.dismissUpdateFlag)),
        (0, $jeUNF.takeLatest)((0, $6D21P.FETCH_MERGE_CHECKS_RETRY), (0, $8jjaz.retryFetchMergeChecks)),
        (0, $jeUNF.takeLatest)([
            (0, $6D21P.TASK_STATE_CHANGE).SUCCESS,
            (0, $6D21P.TASK_CREATE).SUCCESS,
            (0, $6D21P.TASK_DELETE).SUCCESS
        ], (0, $8jjaz.retryFetchConcreteMergeChecks), // @ts-ignore TS defs for redux-saga aren't perfect
        [
            (0, $JRfJN.MergeCheckKey).RESOLVED_TASKS
        ]),
        (0, $jeUNF.takeLatest)([
            (0, $6D21P.APPROVAL_SUCCESS),
            (0, $6D21P.REQUEST_CHANGES).SUCCESS,
            (0, $6D21P.UNDO_REQUEST_CHANGES).SUCCESS
        ], (0, $8jjaz.retryFetchConcreteMergeChecks), // @ts-ignore TS defs for redux-saga aren't perfect
        [
            (0, $JRfJN.MergeCheckKey).MINIMUM_APPROVALS,
            (0, $JRfJN.MergeCheckKey).MINIMUM_DEFAULT_REVIEWER_APPROVALS,
            (0, $JRfJN.MergeCheckKey).NO_CHANGES_REQUESTED,
            (0, $JRfJN.MergeCheckKey).REVIEW_GROUPS
        ]),
        (0, $jeUNF.takeLatest)((0, $6D21P.REFRESH_CODE_REVIEW_DATA), (0, $lSc3Y.minimalUpdateSaga)),
        (0, $jeUNF.takeLatest)((0, $6D21P.REFRESH_CODE_REVIEW_DATA_FROM_POLL_RESULTS), (0, $lSc3Y.minimalUpdateFromPollResults)),
        (0, $jeUNF.takeLatest)((0, $14kRW.FETCH_ACTIVITY).REQUEST, (0, $7pCcb.fetchActivityFeed)),
        (0, $VXZCu.reprocessDiffSaga)(),
        (0, $jeUNF.takeLatest)(// api.getWatch will also get called when user enters code review (ENTERED_CODE_REVIEW)
        // but that has to be done from the code review data saga since PR store might
        // not be ready yet in certain scenarios.
        [
            (0, $6D21P.ADD_COMMENT).SUCCESS,
            (0, $6D21P.APPROVAL_SUCCESS),
            (0, $6D21P.REQUEST_CHANGES).SUCCESS
        ], (0, $lf0Id.watchSaga), // @ts-ignore TS defs for redux-saga aren't perfect
        $aBe8c.getWatch),
        (0, $jeUNF.takeLatest)(// @ts-ignore TODO: fix noImplicitAny error here
        (action)=>action.type === (0, $dkXlf.TOGGLE_DIFF_EXPANSION) && action.payload.isOpening === false, (0, $4H339.activeFileCollapsedScrollerSaga)),
        (0, $3qdsi.startWatchSaga)(),
        (0, $ffege.stopWatchSaga)(),
        (0, $cBYtK.fetchOutdatedCommentContext)($aBe8c.getCommentById),
        (0, $cBYtK.fetchCommentContext)($aBe8c.getCommentById),
        (0, $cBYtK.fetchPendingCommentContext)($aBe8c.getCommentById),
        (0, $cBYtK.fetchBaseRevCommentContext)($aBe8c.getCommentById),
        (0, $jeUNF.takeLatest)([
            (0, $6D21P.ADD_COMMENT).SUCCESS,
            (0, $6D21P.LOAD_PULL_REQUEST).SUCCESS
        ], (0, $bjEV1.updateLastSeenSaga)),
        (0, $jeUNF.takeLatest)((0, $k6zif.OPEN_MERGE_DIALOG), (0, $1lUhL.fetchStackedPullRequestsCountSaga)),
        (0, $jeUNF.takeLatest)((0, $6D21P.RETRY_LOAD_DIFF_STAT), (0, $gzGkQ.fetchDiffStatForCurrentPullRequest)),
        (0, $jeUNF.takeLatest)((0, $6D21P.REVERT_PULL_REQUEST).REQUEST, (0, $8NUP2.revertPullRequestSaga)),
        (0, $jeUNF.takeLatest)((0, $8Ao0D.prCommitActions).UPDATE_COMMITS, (0, $fTGX3.fetchCommitsStatusesSaga)),
        (0, $aAhXh.default)(),
        (0, $jeUNF.takeLatest)((0, $6D21P.LOAD_PULL_REQUEST).SUCCESS, (0, $gB6Wt.fetchPullRequestAnnotations)),
        (0, $jeUNF.takeLatest)((0, $8mswv.VIEW_ENTIRE_FILE), (0, $63mqJ.viewEntireDiffFileSaga)),
        (0, $jeUNF.takeEvery)((0, $6D21P.VERIFY_REPO_MEMBER), (0, $XatWx.verifyRepoMemberSaga))
    ]);
}

});
parcelRegister("8Ao0D", function(module, exports) {

$parcel$export(module.exports, "PR_UPDATE_COMMITS_STATUS", function () { return $5fcc63a698d3dfd1$export$9ca0c0b8bba5cf67; });
$parcel$export(module.exports, "BRANCH_UPDATE_COMMITS_STATUS", function () { return $5fcc63a698d3dfd1$export$27af15e64b361af5; });
$parcel$export(module.exports, "FETCH_BRANCH_SYNC_INFO", function () { return $5fcc63a698d3dfd1$export$65dc5eee9de7cd83; });
$parcel$export(module.exports, "UNLOAD_BRANCH_COMMITS", function () { return $5fcc63a698d3dfd1$export$9590b2b39f31acc6; });
$parcel$export(module.exports, "prCommitActions", function () { return $5fcc63a698d3dfd1$export$46c98389f9540e27; });
$parcel$export(module.exports, "branchCommitActions", function () { return $5fcc63a698d3dfd1$export$ae1ecd2bac8957f; });

var $6OKKg = parcelRequire("6OKKg");
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
const $5fcc63a698d3dfd1$var$COMMITS_PREFIX = "commits/";
const $5fcc63a698d3dfd1$var$PR_PREFIX = "pullrequest/";
const $5fcc63a698d3dfd1$var$BRANCH_PREFIX = "branch/";
// Any entry added here will get a string built be used as an Action type
// and autocomplete assistance from the default export of this module
const $5fcc63a698d3dfd1$var$ACTIONS = {
    UPDATE_COMMITS: "",
    FETCH_COMMITS: "",
    FETCH_MORE_COMMITS: "",
    RETRY_COMMITS: "",
    COMMIT_FETCH_ERROR: ""
};
const $5fcc63a698d3dfd1$export$9ca0c0b8bba5cf67 = (0, $2MctD.createAsyncAction)(`${$5fcc63a698d3dfd1$var$PR_PREFIX}UPDATE_COMMITS_STATUS`);
const $5fcc63a698d3dfd1$export$27af15e64b361af5 = (0, $2MctD.createAsyncAction)(`${$5fcc63a698d3dfd1$var$BRANCH_PREFIX}UPDATE_COMMITS_STATUS`);
const $5fcc63a698d3dfd1$export$65dc5eee9de7cd83 = (0, $2MctD.createAsyncAction)(`${$5fcc63a698d3dfd1$var$COMMITS_PREFIX}FETCH_BRANCH_SYNC_INFO`);
const $5fcc63a698d3dfd1$export$9590b2b39f31acc6 = `${$5fcc63a698d3dfd1$var$BRANCH_PREFIX}UNLOAD_BRANCH_COMMITS`;
function $5fcc63a698d3dfd1$var$makeActions(actions, opts) {
    const prefixed = Object.keys(actions).map((action)=>`${opts.prefix}${action}`);
    // Lodash tries to type as a string Dictionary, this casting keeps our autocomplete
    return (0, $6OKKg.default)(Object.keys(actions), prefixed);
}
const $5fcc63a698d3dfd1$export$46c98389f9540e27 = $5fcc63a698d3dfd1$var$makeActions($5fcc63a698d3dfd1$var$ACTIONS, {
    prefix: $5fcc63a698d3dfd1$var$PR_PREFIX
});
const $5fcc63a698d3dfd1$export$ae1ecd2bac8957f = $5fcc63a698d3dfd1$var$makeActions($5fcc63a698d3dfd1$var$ACTIONS, {
    prefix: $5fcc63a698d3dfd1$var$BRANCH_PREFIX
});

});
parcelRegister("6OKKg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f6bac3744503002$export$2e2bcd8739ae039; });

var $lS6Qg = parcelRequire("lS6Qg");

var $49Z3p = parcelRequire("49Z3p");
/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */ function $4f6bac3744503002$var$zipObject(props, values) {
    return (0, $49Z3p.default)(props || [], values || [], (0, $lS6Qg.default));
}
var $4f6bac3744503002$export$2e2bcd8739ae039 = $4f6bac3744503002$var$zipObject;

});
parcelRegister("49Z3p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30775cb68c91d003$export$2e2bcd8739ae039; });
/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */ function $30775cb68c91d003$var$baseZipObject(props, values, assignFunc) {
    var index = -1, length = props.length, valsLength = values.length, result = {};
    while(++index < length){
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
    }
    return result;
}
var $30775cb68c91d003$export$2e2bcd8739ae039 = $30775cb68c91d003$var$baseZipObject;

});



parcelRegister("lp4Gn", function(module, exports) {

$parcel$export(module.exports, "prefetchCommits", function () { return $843cb90d40ab9c89$export$5fcd3d6f1bd84a0e; });
$parcel$export(module.exports, "rootPrCommitsSaga", function () { return $843cb90d40ab9c89$export$b49a2ac6b10fa1b0; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $1EkdU = parcelRequire("1EkdU");

var $czBtW = parcelRequire("czBtW");

var $g8glp = parcelRequire("g8glp");

var $b2RHC = parcelRequire("b2RHC");

var $8Ao0D = parcelRequire("8Ao0D");

var $lkmX7 = parcelRequire("lkmX7");
const $843cb90d40ab9c89$var$PAGE_LIMIT = "25";
function* $843cb90d40ab9c89$export$d5ad6cb73b750dea(url) {
    const api = yield* (0, $g8glp.getPullRequestApis)();
    const response = yield (0, $5NpoY.P)(api.getCommits, url);
    if ("error" in response) {
        yield (0, $5NpoY.Y)({
            type: (0, $8Ao0D.prCommitActions).COMMIT_FETCH_ERROR,
            payload: response.status
        });
        return;
    }
    const { commits: commits, next: next, page: page } = response;
    yield (0, $5NpoY.Y)({
        type: (0, $8Ao0D.prCommitActions).UPDATE_COMMITS,
        meta: {
            schema: {
                commits: [
                    (0, $b2RHC.commit)
                ]
            }
        },
        payload: {
            commits: commits,
            next: next,
            page: page
        }
    });
}
function* $843cb90d40ab9c89$export$5fcd3d6f1bd84a0e({ owner: owner, slug: slug, id: id }) {
    yield $843cb90d40ab9c89$export$d5ad6cb73b750dea((0, $czBtW.default).api.v20.commits(owner, slug, id, $843cb90d40ab9c89$var$PAGE_LIMIT));
}
function* $843cb90d40ab9c89$export$2163554908521f27() {
    const { owner: owner, slug: slug, id: id } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    if (!owner || !slug || !id) return;
    yield $843cb90d40ab9c89$export$d5ad6cb73b750dea((0, $czBtW.default).api.v20.commits(owner, slug, id, $843cb90d40ab9c89$var$PAGE_LIMIT));
}
function* $843cb90d40ab9c89$export$27bfa107813f1646() {
    let nextUrl = yield (0, $5NpoY.a3)((0, $lkmX7.getCommitsNextUrl));
    const nextCommitsUrl = new URL(nextUrl);
    nextCommitsUrl.searchParams.set("pagelen", $843cb90d40ab9c89$var$PAGE_LIMIT);
    nextUrl = nextCommitsUrl.href;
    yield $843cb90d40ab9c89$export$d5ad6cb73b750dea(nextUrl);
}
function* $843cb90d40ab9c89$export$b49a2ac6b10fa1b0() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLatest)((0, $8Ao0D.prCommitActions).RETRY_COMMITS, $843cb90d40ab9c89$export$2163554908521f27),
        (0, $jeUNF.takeLatest)((0, $8Ao0D.prCommitActions).FETCH_MORE_COMMITS, $843cb90d40ab9c89$export$27bfa107813f1646)
    ]);
}

});
parcelRegister("lkmX7", function(module, exports) {

$parcel$export(module.exports, "getCommitsNextUrl", function () { return $da9ced7115ede215$export$e0d700c310b76b71; });
$parcel$export(module.exports, "getCurrentRepoCommits", function () { return $da9ced7115ede215$export$740fd3184e42ad3c; });
$parcel$export(module.exports, "getBranchSyncInfo", function () { return $da9ced7115ede215$export$2adeaadb1289df2a; });
$parcel$export(module.exports, "getRepoCommitsState", function () { return $da9ced7115ede215$export$76d694e7ab613dec; });

var $ga67g = parcelRequire("ga67g");

var $aXXtM = parcelRequire("aXXtM");

var $b2RHC = parcelRequire("b2RHC");

var $7qdXF = parcelRequire("7qdXF");
const $da9ced7115ede215$var$getCommitsKeys = (state)=>state.commits.commits;
const $da9ced7115ede215$export$e0d700c310b76b71 = (state)=>state.commits.nextCommitsUrl;
const $da9ced7115ede215$var$getCommitsLoading = (state)=>state.commits.isLoading;
const $da9ced7115ede215$var$getCommitsError = (state)=>state.commits.hasError;
const $da9ced7115ede215$var$getCommitState = (state)=>state.commits;
const $da9ced7115ede215$export$740fd3184e42ad3c = (0, $aXXtM.createSelector)($da9ced7115ede215$var$getCommitsKeys, (0, $7qdXF.getEntities), (keys, entities)=>(0, $ga67g.denormalize)(keys, [
        (0, $b2RHC.commit)
    ], entities));
const $da9ced7115ede215$export$2adeaadb1289df2a = (0, $aXXtM.createSelector)($da9ced7115ede215$var$getCommitState, (commits)=>commits.branchSyncInfo);
const $da9ced7115ede215$export$76d694e7ab613dec = (0, $aXXtM.createSelector)($da9ced7115ede215$export$740fd3184e42ad3c, $da9ced7115ede215$var$getCommitsError, $da9ced7115ede215$var$getCommitsLoading, $da9ced7115ede215$export$e0d700c310b76b71, (commits, hasError, isLoading, nextUrl)=>({
        commits: commits,
        hasError: hasError,
        isLoading: isLoading,
        nextUrl: nextUrl
    }));

});


parcelRegister("JRfJN", function(module, exports) {

$parcel$export(module.exports, "MergeCheckKey", function () { return $8f1d24d12417d041$export$bafd945d02203194; });
var $8f1d24d12417d041$export$bafd945d02203194;
(function(MergeCheckKey) {
    MergeCheckKey["MINIMUM_APPROVALS"] = "minimum_approvals";
    MergeCheckKey["MINIMUM_DEFAULT_REVIEWER_APPROVALS"] = "minimum_default_reviewer_approvals";
    MergeCheckKey["MINIMUM_SUCCESSFUL_BUILDS"] = "minimum_successful_builds";
    MergeCheckKey["MAXIMUM_COMMITS_BEHIND"] = "maximum_commits_behind";
    MergeCheckKey["REVIEW_GROUPS"] = "required_review_group_approvals";
    MergeCheckKey["FAILED_BUILDS"] = "failed_builds";
    MergeCheckKey["RESOLVED_TASKS"] = "resolved_tasks";
    MergeCheckKey["PR_DEPS_MERGED"] = "pr_deps_merged";
    MergeCheckKey["NO_CHANGES_REQUESTED"] = "no_changes_requested";
    MergeCheckKey["IN_PROGRESS_BUILDS"] = "in_progress_builds";
    MergeCheckKey["NO_RESOLVABLE_COMMENTS"] = "resolvable_comments";
})($8f1d24d12417d041$export$bafd945d02203194 || ($8f1d24d12417d041$export$bafd945d02203194 = {}));

});

parcelRegister("6vkvB", function(module, exports) {

$parcel$export(module.exports, "PULL_REQUEST_SCREEN_NAME", function () { return $dd149618940ad4db$export$2be802f8b7e5ac14; });
$parcel$export(module.exports, "publishPipelinesScreenEventSaga", function () { return $dd149618940ad4db$export$c2ebccf9fb8ff5f8; });
$parcel$export(module.exports, "publishScreenEventSaga", function () { return $dd149618940ad4db$export$d31466229e598818; });
$parcel$export(module.exports, "publishTrackEventSaga", function () { return $dd149618940ad4db$export$d316292ffb921854; });
$parcel$export(module.exports, "publishUiEventSaga", function () { return $dd149618940ad4db$export$1ac9e0bb0af2a76; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("3hzea");
var $a5HLv = parcelRequire("a5HLv");

var $i2O3k = parcelRequire("i2O3k");

var $6aoKW = parcelRequire("6aoKW");

var $1EkdU = parcelRequire("1EkdU");
const $dd149618940ad4db$export$2be802f8b7e5ac14 = "pullRequestScreen";
const $dd149618940ad4db$export$f2187db2d282abbc = "pipelinesPullRequestBanner";
function* $dd149618940ad4db$export$c2ebccf9fb8ff5f8(action) {
    yield (0, $5NpoY.P)((0, $6aoKW.publishScreenEvent), $dd149618940ad4db$export$f2187db2d282abbc, {
        action: action.payload.action,
        actionSubject: action.payload.actionSubject,
        actionSubjectId: action.payload.actionSubjectId,
        source: $dd149618940ad4db$export$f2187db2d282abbc,
        pipelinesPremium: action.payload.pipelinesPremium,
        paidWorkspace: action.payload.paidWorkspace,
        premiumWorkspace: action.payload.premiumWorkspace
    });
}
function* $dd149618940ad4db$export$d31466229e598818() {
    const diffView = yield (0, $5NpoY.a3)((0, $i2O3k.getGlobalDiffViewMode));
    const fileView = yield (0, $5NpoY.a3)((0, $i2O3k.getGlobalFileViewMode));
    const tabSize = yield (0, $5NpoY.a3)((0, $i2O3k.getGlobalTabSize));
    const enableWordDiff = yield (0, $5NpoY.a3)((0, $i2O3k.getGlobalIsWordDiffEnabled));
    const ignoreWhitespace = yield (0, $5NpoY.a3)((0, $i2O3k.getGlobalShouldIgnoreWhitespace));
    const role = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestRoleForCurrentUser));
    const pullRequestId = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestId));
    const pullRequestSourceRepo = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestSourceRepo));
    yield (0, $5NpoY.P)((0, $6aoKW.publishScreenEvent), $dd149618940ad4db$export$2be802f8b7e5ac14, {
        diffView: diffView === (0, $i2O3k.DiffViewMode).SideBySide ? "sideBySide" : "unified",
        fileView: fileView === (0, $i2O3k.FileViewMode).List ? "list" : fileView === (0, $i2O3k.FileViewMode).Tree ? "tree" : null,
        tabSize: tabSize,
        enableWordDiff: enableWordDiff,
        ignoreWhitespace: ignoreWhitespace,
        pullRequestLocalId: pullRequestId,
        repoUuid: pullRequestSourceRepo === null || pullRequestSourceRepo === void 0 ? void 0 : pullRequestSourceRepo.uuid,
        role: role
    });
}
function* $dd149618940ad4db$export$d316292ffb921854(action) {
    const pullRequestId = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestId));
    const pullRequestSourceRepo = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestSourceRepo));
    yield (0, $5NpoY.P)((0, $6aoKW.publishTrackEvent), {
        action: action.payload.action,
        actionSubject: action.payload.actionSubject,
        actionSubjectId: action.payload.actionSubjectId,
        source: $dd149618940ad4db$export$2be802f8b7e5ac14,
        objectType: "pullRequest",
        objectId: `${(0, $a5HLv.uncurlyUuid)((pullRequestSourceRepo === null || pullRequestSourceRepo === void 0 ? void 0 : pullRequestSourceRepo.uuid) || "")}/${pullRequestId}`,
        attributes: action.payload.attributes
    });
}
function* $dd149618940ad4db$export$1ac9e0bb0af2a76(action) {
    var _pullRequestSourceRep, _pullRequestDestinati;
    const pullRequestId = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestId));
    const pullRequestDestinationRepo = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestDestinationRepo));
    const pullRequestSourceRepo = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestSourceRepo));
    yield (0, $5NpoY.P)((0, $6aoKW.publishUiEvent), {
        action: action.payload.action,
        actionSubject: action.payload.actionSubject,
        actionSubjectId: action.payload.actionSubjectId,
        source: "pullRequest",
        objectId: (0, $a5HLv.uncurlyUuid)(pullRequestSourceRepo === null || pullRequestSourceRepo === void 0 ? void 0 : pullRequestSourceRepo.uuid),
        objectType: "repository",
        containerId: (0, $a5HLv.uncurlyUuid)((pullRequestSourceRepo === null || pullRequestSourceRepo === void 0 ? void 0 : (_pullRequestSourceRep = pullRequestSourceRepo.workspace) === null || _pullRequestSourceRep === void 0 ? void 0 : _pullRequestSourceRep.uuid) || ""),
        containerType: "workspace",
        attributes: {
            pullRequestId: pullRequestId,
            toRepositoryUuid: (0, $a5HLv.uncurlyUuid)(pullRequestDestinationRepo === null || pullRequestDestinationRepo === void 0 ? void 0 : pullRequestDestinationRepo.uuid),
            toRepositoryOwnerUuid: (0, $a5HLv.uncurlyUuid)((pullRequestDestinationRepo === null || pullRequestDestinationRepo === void 0 ? void 0 : (_pullRequestDestinati = pullRequestDestinationRepo.owner) === null || _pullRequestDestinati === void 0 ? void 0 : _pullRequestDestinati.uuid) || ""),
            ...action.payload.attributes
        }
    });
}

});

parcelRegister("ioXzt", function(module, exports) {

$parcel$export(module.exports, "cancelPendingMergeSaga", function () { return $05aebeaeea185202$export$ba893cc02e289db6; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $k6zif = parcelRequire("k6zif");

var $1EkdU = parcelRequire("1EkdU");

var $czBtW = parcelRequire("czBtW");

var $k2cPS = parcelRequire("k2cPS");
function* $05aebeaeea185202$export$ba893cc02e289db6() {
    const { owner: owner, slug: slug, id: id } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    const url = (0, $czBtW.default).api.internal.pendingMerge(owner, slug, id);
    const authUrl = (0, $k2cPS.default)(url);
    try {
        const response = yield (0, $5NpoY.P)(fetch, authUrl, {
            method: "DELETE"
        });
        if (!response.ok) {
            const error = yield response.text();
            throw new Error(error);
        }
        yield (0, $5NpoY.Y)({
            type: (0, $k6zif.CANCEL_PENDING_MERGE).SUCCESS
        });
        yield (0, $5NpoY.Y)({
            type: (0, $k6zif.FETCH_PENDING_MERGE_STATUS).REQUEST
        });
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $k6zif.CANCEL_PENDING_MERGE).ERROR,
            payload: e.message,
            error: true
        });
    }
}

});

parcelRegister("1gAUK", function(module, exports) {

$parcel$export(module.exports, "codeReviewDataSaga", function () { return $4d9a266ec3f8a904$export$d00993964c75a4c6; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $lj5Bi = parcelRequire("lj5Bi");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");
var $bQYeX = parcelRequire("bQYeX");

var $14kRW = parcelRequire("14kRW");

var $1EkdU = parcelRequire("1EkdU");

var $2LBVC = parcelRequire("2LBVC");

var $lp4Gn = parcelRequire("lp4Gn");

var $lkmX7 = parcelRequire("lkmX7");

var $677Fr = parcelRequire("677Fr");

var $1ZBmx = parcelRequire("1ZBmx");

var $aBe8c = parcelRequire("aBe8c");

var $7p7CY = parcelRequire("7p7CY");

var $j2CMC = parcelRequire("j2CMC");

var $d3vpB = parcelRequire("d3vpB");

var $lf0Id = parcelRequire("lf0Id");
const $4d9a266ec3f8a904$export$5490efc058639250 = 30000;
const $4d9a266ec3f8a904$export$cf4088eae1d5f523 = (prData, owner, slug, id)=>{
    var _currentPullRequest$d, _currentPullRequest$d2;
    const currentPullRequest = (prData === null || prData === void 0 ? void 0 : prData.currentPullRequest) || {};
    const prFullName = (currentPullRequest === null || currentPullRequest === void 0 ? void 0 : (_currentPullRequest$d = currentPullRequest.destination) === null || _currentPullRequest$d === void 0 ? void 0 : (_currentPullRequest$d2 = _currentPullRequest$d.repository) === null || _currentPullRequest$d2 === void 0 ? void 0 : _currentPullRequest$d2.full_name) || "/";
    const [prOwner, prSlug] = prFullName.split("/");
    return parseInt(currentPullRequest.id, 10) === parseInt(id, 10) && prOwner === owner && prSlug === slug;
};
function* $4d9a266ec3f8a904$export$d00993964c75a4c6(action) {
    // In rare cases, it's possible that EXITED_CODE_REVIEW fails to dispatch
    // If activityEvents length is !== 0, then the action was not dispatched
    const activityEvents = yield (0, $5NpoY.a3)((0, $2LBVC.getPullRequestActivityFeed));
    if (activityEvents.length !== 0) yield (0, $5NpoY.Y)({
        type: (0, $6D21P.EXITED_CODE_REVIEW)
    });
    const { owner: owner, slug: slug, id: id } = action;
    // This mimics the structure of the hydrated pr data from window.__initial_state__
    const statePRdata = {
        // @ts-ignore
        commits: yield (0, $5NpoY.a3)((0, $lkmX7.getCurrentRepoCommits)),
        // @ts-ignore
        currentPullRequest: yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequest)),
        // @ts-ignore
        defaultMergeStrategy: yield (0, $5NpoY.a3)((0, $1EkdU.getDefaultMergeStrategy))
    };
    // When SSR is enabled and init load, PR data should be ready in ssrstate.reduxStore
    // When SSR is enabled and has transitioned, hydratedPRdata should be undefined
    // If SSR is off, get PRdata from initialState
    let hydratedPRdata;
    if ((0, $1ZBmx.appWasServerSideRendered)()) {
        var _getInitialOrBucketSt, _getInitialOrBucketSt2;
        hydratedPRdata = !(0, $677Fr.hasTransitioned)() ? (_getInitialOrBucketSt = (0, $1ZBmx.getInitialOrBucketState)()) === null || _getInitialOrBucketSt === void 0 ? void 0 : (_getInitialOrBucketSt2 = _getInitialOrBucketSt.repository) === null || _getInitialOrBucketSt2 === void 0 ? void 0 : _getInitialOrBucketSt2.pullRequest : undefined;
    } else {
        var _initialState$reposit;
        hydratedPRdata = (0, $lj5Bi.default) === null || (0, $lj5Bi.default) === void 0 ? void 0 : (_initialState$reposit = (0, $lj5Bi.default).repository) === null || _initialState$reposit === void 0 ? void 0 : _initialState$reposit.pullRequest;
    }
    const lastFetched = yield (0, $5NpoY.a3)((0, $1EkdU.getLastPullRequestRetrievalTime));
    const timeSinceLastFetch = lastFetched ? Date.now() - lastFetched : 0;
    const shouldUseState = !!statePRdata && !!statePRdata.commits && !!statePRdata.currentPullRequest && $4d9a266ec3f8a904$export$cf4088eae1d5f523(statePRdata, owner, slug, id) && timeSinceLastFetch <= $4d9a266ec3f8a904$export$5490efc058639250 && // Only use cached redux state and skip fetching of non-critical data
    // when it's not an initial page load via SSR
    (0, $677Fr.hasTransitioned)();
    // Activity feed should be cleared when the user leaves a PR.
    // So, we need to refetch it even if it's the same PR
    yield (0, $5NpoY.Y)({
        type: (0, $14kRW.FETCH_ACTIVITY).REQUEST,
        owner: owner,
        slug: slug,
        id: id
    });
    // Fetch the watching status when PR initially loads (ENTERED_CODE_REVIEW)
    yield (0, $5NpoY.a1)((0, $lf0Id.watchSaga), $aBe8c.getWatch, {
        owner: owner,
        slug: slug,
        id: id
    });
    if (shouldUseState) return;
    yield (0, $5NpoY.a1)((0, $lp4Gn.prefetchCommits), {
        owner: owner,
        slug: slug,
        id: id
    });
    yield (0, $5NpoY.a1)((0, $7p7CY.default), owner, slug, id);
    yield (0, $5NpoY.Y)((0, $bQYeX.default)({
        owner: owner,
        repoSlug: slug,
        pullRequestId: id
    }));
    // Completing a fetch of pullrequest will trigger a fetch of conversations
    const haveHydratedPR = !!hydratedPRdata;
    if (haveHydratedPR) {
        var _initialState$reposit2;
        // we should not have to delete a property on an initialState object,
        // but this was flagged as an error when upgrading to Typescript 4.1
        // so in order to avoid changing too much as part of the upgrade I'm just
        // ts-ignoring the error for now and flagging it.
        // @ts-ignore TODO: Change approach to no longer delete the property
        (0, $lj5Bi.default) === null || (0, $lj5Bi.default) === void 0 || (_initialState$reposit2 = (0, $lj5Bi.default).repository) === null || _initialState$reposit2 === void 0 || delete _initialState$reposit2.pullRequest;
    }
    yield (0, $5NpoY.a1)((0, $d3vpB.fetchDestinationBranch), owner, slug);
    yield (0, $5NpoY.M)([
        (0, $6D21P.FETCH_DIFF).SUCCESS,
        (0, $6D21P.LOAD_DIFFSTAT).SUCCESS
    ]);
    yield (0, $5NpoY.a1)((0, $j2CMC.default), owner, slug, id);
}

});
parcelRegister("2LBVC", function(module, exports) {

$parcel$export(module.exports, "getCurrentPullRequestActivityError", function () { return $d9fc10087f9e9999$export$7902f19f58611d1a; });
$parcel$export(module.exports, "getCurrentPullRequestActivityLoadingState", function () { return $d9fc10087f9e9999$export$f142f9e7506df42a; });
$parcel$export(module.exports, "getPullRequestActivityFeed", function () { return $d9fc10087f9e9999$export$968882488d2534ea; });
$parcel$export(module.exports, "getPullRequestRichActivityFeed", function () { return $d9fc10087f9e9999$export$fae0087f7dbb39a4; });
$parcel$export(module.exports, "getCurrentPullRequestActivityApprovalEvent", function () { return $d9fc10087f9e9999$export$8eedf522cf9f6c3e; });
$parcel$export(module.exports, "getCurrentPullRequestActivityChangesRequestedEvent", function () { return $d9fc10087f9e9999$export$fd062996eda7276c; });

var $aXXtM = parcelRequire("aXXtM");

var $3omLR = parcelRequire("3omLR");

var $cCrBH = parcelRequire("cCrBH");

var $g2R3c = parcelRequire("g2R3c");

var $7BuDj = parcelRequire("7BuDj");

var $1EkdU = parcelRequire("1EkdU");
const $d9fc10087f9e9999$export$33362e2358da5656 = (0, $aXXtM.createSelector)((0, $1EkdU.getPullRequestSlice), (prSlice)=>prSlice.activity);
const $d9fc10087f9e9999$export$16a0099f924582e3 = (0, $aXXtM.createSelector)($d9fc10087f9e9999$export$33362e2358da5656, (activity)=>activity.nextUrl);
const $d9fc10087f9e9999$export$7902f19f58611d1a = (0, $aXXtM.createSelector)($d9fc10087f9e9999$export$33362e2358da5656, (activity)=>activity.hasError);
const $d9fc10087f9e9999$export$f142f9e7506df42a = (0, $aXXtM.createSelector)($d9fc10087f9e9999$export$33362e2358da5656, (activity)=>activity.isActivityLoading);
const $d9fc10087f9e9999$export$c0bb1d4cb079872a = (0, $aXXtM.createSelector)($d9fc10087f9e9999$export$33362e2358da5656, (activity)=>!!activity.nextUrl);
const $d9fc10087f9e9999$export$e175c086a4122395 = (0, $aXXtM.createSelector)($d9fc10087f9e9999$export$33362e2358da5656, (activity)=>activity.activityEvents);
const $d9fc10087f9e9999$export$968882488d2534ea = (0, $aXXtM.createSelector)($d9fc10087f9e9999$export$33362e2358da5656, (0, $cCrBH.getFabricConversations), $d9fc10087f9e9999$export$c0bb1d4cb079872a, /**
 * This is the transformation of activity API events and conversations (data) into
 * Activity Feed Entries (visual representations).
 */ (activitySlice, fabricConversations, hasNext)=>{
    // Event - a single happening as reported by the backend in endpoint data structures
    // Entry - a single visual representation in the Activity Feed of the UI
    const { activityEvents: activityEvents } = activitySlice;
    // We have all comments already so we ignore the ones in Activity Endpoint
    const nonCommentEvents = activityEvents.filter((0, $3omLR.isNotCommentActivity));
    const getTime = (activityEvent)=>{
        var _activityEvent$approv;
        if ((0, $3omLR.isUpdateActivity)(activityEvent)) return activityEvent.update.date;
        else if ((0, $3omLR.isTaskActivity)(activityEvent)) return activityEvent.task.action_on;
        else if ((0, $3omLR.isAttachmentActivity)(activityEvent)) return activityEvent.attachment.created_on;
        else if ((0, $3omLR.isChangesRequestedActivity)(activityEvent)) return activityEvent.changes_requested.date;
        return (_activityEvent$approv = activityEvent.approval) === null || _activityEvent$approv === void 0 ? void 0 : _activityEvent$approv.date;
    };
    const chronologicalEvents = nonCommentEvents.sort((a, b)=>{
        const aTime = getTime(a);
        const bTime = getTime(b);
        const aMilliseconds = new Date(aTime).getTime();
        const bMilliseconds = new Date(bTime).getTime();
        // For entries with the same timestamp, preserve original order
        // by sorting `a` to a lower index than `b`.
        // Returning 0 does not guarantee order will be unchanged.
        // (Added to preserve the ordering of bulk uploaded attachments)
        if (aMilliseconds === bMilliseconds) return -1;
        return aMilliseconds - bMilliseconds;
    });
    // Build the two classes of entries, activities + comments
    const commentEntries = (0, $7BuDj.breakoutCommentEntries)(fabricConversations);
    const activityEntries = (0, $7BuDj.transformActivities)(chronologicalEvents, !hasNext);
    // Collapse attachment updates into single entries
    const collapsedActivityEntries = (0, $7BuDj.collapseAttachments)(activityEntries);
    // Combine them
    const combinedEntries = [
        ...collapsedActivityEntries,
        ...commentEntries
    ];
    // Put them in oldestToNewest order for commits collapsing, so
    // duplicate commits are only rendered at their oldest point, not most recent.
    const oldestToNewest = combinedEntries.sort((a, b)=>a.timestamp.getTime() - b.timestamp.getTime());
    // Collapse commit updates into single entries
    const condensedEntries = (0, $7BuDj.collapseCommits)(oldestToNewest);
    // Reverse so that the feed renders newestToOldest
    return condensedEntries.reverse();
});
const $d9fc10087f9e9999$export$fae0087f7dbb39a4 = (0, $aXXtM.createSelector)($d9fc10087f9e9999$export$33362e2358da5656, (0, $1EkdU.getCommentTree), $d9fc10087f9e9999$export$c0bb1d4cb079872a, /**
 * This is the transformation of activity API events and conversations (data) into
 * Activity Feed Entries (visual representations).
 */ (activitySlice, commentTree, hasNext)=>{
    // Event - a single happening as reported by the backend in endpoint data structures
    // Entry - a single visual representation in the Activity Feed of the UI
    const { activityEvents: activityEvents } = activitySlice;
    // We have all comments already so we ignore the ones in Activity Endpoint
    const nonCommentEvents = activityEvents.filter((0, $3omLR.isNotCommentActivity));
    const getTime = (activityEvent)=>{
        var _activityEvent$approv2;
        if ((0, $3omLR.isUpdateActivity)(activityEvent)) return activityEvent.update.date;
        else if ((0, $3omLR.isTaskActivity)(activityEvent)) return activityEvent.task.action_on;
        else if ((0, $3omLR.isAttachmentActivity)(activityEvent)) return activityEvent.attachment.created_on;
        else if ((0, $3omLR.isChangesRequestedActivity)(activityEvent)) return activityEvent.changes_requested.date;
        return (_activityEvent$approv2 = activityEvent.approval) === null || _activityEvent$approv2 === void 0 ? void 0 : _activityEvent$approv2.date;
    };
    const chronologicalEvents = nonCommentEvents.sort((a, b)=>{
        const aTime = getTime(a);
        const bTime = getTime(b);
        const aMilliseconds = new Date(aTime).getTime();
        const bMilliseconds = new Date(bTime).getTime();
        // For entries with the same timestamp, preserve original order
        // by sorting `a` to a lower index than `b`.
        // Returning 0 does not guarantee order will be unchanged.
        // (Added to preserve the ordering of bulk uploaded attachments)
        if (aMilliseconds === bMilliseconds) return -1;
        return aMilliseconds - bMilliseconds;
    });
    // Build the two classes of entries, activities + comments
    const commentEntries = (0, $7BuDj.breakoutOverviewCommentEntries)(commentTree);
    const activityEntries = (0, $7BuDj.transformOverviewActivities)(chronologicalEvents, !hasNext);
    // Collapse attachment updates into single entries
    const collapsedActivityEntries = (0, $7BuDj.collapseAttachments)(activityEntries);
    // Combine them
    const combinedEntries = [
        ...collapsedActivityEntries,
        ...commentEntries
    ];
    // Put them in oldestToNewest order for commits collapsing, so
    // duplicate commits are only rendered at their oldest point, not most recent.
    const oldestToNewest = combinedEntries.sort((a, b)=>a.timestamp.getTime() - b.timestamp.getTime());
    // Collapse commit updates into single entries
    const condensedEntries = (0, $7BuDj.collapseCommits)(oldestToNewest);
    // collapse down the reviewers and task entries
    const moreCondensedEntries = (0, $7BuDj.collapseRichActivities)(condensedEntries);
    // Reverse so that the feed renders newestToOldest
    return moreCondensedEntries.reverse();
});
const $d9fc10087f9e9999$export$8eedf522cf9f6c3e = (0, $aXXtM.createSelector)($d9fc10087f9e9999$export$e175c086a4122395, (0, $g2R3c.getCurrentUserKey), (activityEvents, userUuid)=>{
    const activityEvent = activityEvents.find((event)=>(0, $3omLR.isApprovalActivity)(event) && event.approval.user.uuid === userUuid);
    if (activityEvent && (0, $3omLR.isApprovalActivity)(activityEvent)) return activityEvent.approval;
    return null;
});
const $d9fc10087f9e9999$export$fd062996eda7276c = (0, $aXXtM.createSelector)($d9fc10087f9e9999$export$e175c086a4122395, (0, $g2R3c.getCurrentUserKey), (activityEvents, userUuid)=>{
    const activityEvent = activityEvents.find((event)=>(0, $3omLR.isChangesRequestedActivity)(event) && event.changes_requested.user.uuid === userUuid);
    if (activityEvent && (0, $3omLR.isChangesRequestedActivity)(activityEvent)) return activityEvent.changes_requested;
    return null;
});

});
parcelRegister("cCrBH", function(module, exports) {

$parcel$export(module.exports, "getConversation", function () { return $81071aca1c95b40c$export$a2ff1144002a6147; });
$parcel$export(module.exports, "getFabricConversations", function () { return $81071aca1c95b40c$export$6feb3b1470f88dd4; });
$parcel$export(module.exports, "getConversations", function () { return $81071aca1c95b40c$export$950629ad9418ab6a; });
$parcel$export(module.exports, "getLeveledFabricConversations", function () { return $81071aca1c95b40c$export$191747bd8fdcab54; });
$parcel$export(module.exports, "getCommentsMetaData", function () { return $81071aca1c95b40c$export$7861b896bca91208; });
$parcel$export(module.exports, "getAllConversationsForFile", function () { return $81071aca1c95b40c$export$ee0ca4caafb77ed; });
$parcel$export(module.exports, "getFileLevelThreadsForFile", function () { return $81071aca1c95b40c$export$e18407316ae02980; });
$parcel$export(module.exports, "getValidConversationsForFile", function () { return $81071aca1c95b40c$export$c4c46726d5ef6b59; });
$parcel$export(module.exports, "getInlineThreadsForFile", function () { return $81071aca1c95b40c$export$8d403d5cfee55516; });
$parcel$export(module.exports, "getOutdatedConversationsForFile", function () { return $81071aca1c95b40c$export$63408a03aa33ee85; });
$parcel$export(module.exports, "getOutdatedCommentsCountForFile", function () { return $81071aca1c95b40c$export$bc680c95c035dae6; });
$parcel$export(module.exports, "getBaseRevConversationsForFile", function () { return $81071aca1c95b40c$export$49bff0c2ebaaa51d; });
$parcel$export(module.exports, "getBaseRevCommentsCountForFile", function () { return $81071aca1c95b40c$export$8d46cab76e8d5e4e; });
$parcel$export(module.exports, "getAllChangesConversationsForFile", function () { return $81071aca1c95b40c$export$b41bcffb3baae9a2; });
$parcel$export(module.exports, "getAllChangesCommentsCountForFile", function () { return $81071aca1c95b40c$export$30b80b1c8d92c41a; });
$parcel$export(module.exports, "getCommentsCountForFile", function () { return $81071aca1c95b40c$export$f1026161de9bb063; });
$parcel$export(module.exports, "getConversationsGlobal", function () { return $81071aca1c95b40c$export$5089c0ac12360e3d; });
$parcel$export(module.exports, "getCommentsLoadingState", function () { return $81071aca1c95b40c$export$953d9acbc856867f; });
$parcel$export(module.exports, "getConversationAnalytics", function () { return $81071aca1c95b40c$export$db8e81ae5b770789; });
$parcel$export(module.exports, "getCurrentFabricUser", function () { return $81071aca1c95b40c$export$3e419cf82ceed13a; });
$parcel$export(module.exports, "getConversationsMentionsContext", function () { return $81071aca1c95b40c$export$707da24cbd7d3720; });
$parcel$export(module.exports, "getPendingInlineConversations", function () { return $81071aca1c95b40c$export$a42144a38b913b51; });

var $cQrjH = parcelRequire("cQrjH");

var $aXXtM = parcelRequire("aXXtM");
parcelRequire("3hzea");
var $a5HLv = parcelRequire("a5HLv");

var $xz4dB = parcelRequire("xz4dB");
parcelRequire("eRpZn");
var $5D0x5 = parcelRequire("5D0x5");

var $1EkdU = parcelRequire("1EkdU");

var $7b2YZ = parcelRequire("7b2YZ");

var $aanBq = parcelRequire("aanBq");

var $g2R3c = parcelRequire("g2R3c");

var $4coax = parcelRequire("4coax");

var $krSFm = parcelRequire("krSFm");
function $81071aca1c95b40c$var$getConversationType(meta) {
    if (!meta || !meta.path) return "global";
    if (!meta.to && !meta.from) return "file";
    return "inline";
}
const $81071aca1c95b40c$export$a2ff1144002a6147 = (fabricConversations, conversationId)=>fabricConversations.filter((c)=>c.conversationId === conversationId || c.localId === conversationId)[0];
const $81071aca1c95b40c$var$getNestedDepth = (conversation, parentId, level = 0)=>{
    // top-level comment
    if (!conversation || !conversation.comments || !parentId) return level;
    const parent = conversation.comments.find((comment)=>comment.commentId === parentId);
    if (!parent) return level;
    if (typeof parent.nestedDepth === "number") return parent.nestedDepth + 1;
    return $81071aca1c95b40c$var$getNestedDepth(conversation, parent.parentId, level + 1);
};
function $81071aca1c95b40c$var$getFileCacheKey(_state, file) {
    const cacheKey = `${file.from}->${file.to}`;
    return cacheKey;
}
const $81071aca1c95b40c$export$6feb3b1470f88dd4 = (0, $aXXtM.createSelector)((0, $1EkdU.getFabricConversationsList), (fabricConversations)=>(fabricConversations || []).sort((a, b)=>{
        if (a.createdAt === b.createdAt) return 0;
        return a.createdAt < b.createdAt ? -1 : 1;
    }));
const $81071aca1c95b40c$export$950629ad9418ab6a = (0, $aXXtM.createSelector)((0, $1EkdU.getConversationsList), (conversations)=>(conversations || []).sort((a, b)=>{
        if (a.createdAt === b.createdAt) return 0;
        return a.createdAt < b.createdAt ? -1 : 1;
    }));
const $81071aca1c95b40c$export$191747bd8fdcab54 = (0, $aXXtM.createSelector)($81071aca1c95b40c$export$6feb3b1470f88dd4, (fabricConversations)=>fabricConversations.map((conversation)=>{
        if (!conversation.comments) return conversation;
        const retConvo = {
            ...conversation,
            comments: conversation.comments.map((comment)=>({
                    ...comment,
                    // @ts-ignore
                    nestedDepth: $81071aca1c95b40c$var$getNestedDepth(conversation, comment.parentId)
                }))
        };
        return retConvo;
    }));
const $81071aca1c95b40c$export$498ad49c38e43ea = (0, $cQrjH.default)($81071aca1c95b40c$export$191747bd8fdcab54, (_state, conversationId)=>conversationId, (fabricConversations, conversationId)=>fabricConversations.filter((c)=>c.conversationId === conversationId || c.localId === conversationId)[0])((_state, conversationId)=>conversationId);
const $81071aca1c95b40c$export$5ee35527a0b3dc6d = (0, $cQrjH.default)((state, conversationId, _parentId)=>$81071aca1c95b40c$export$498ad49c38e43ea(state, conversationId), (_state, _conversationId, parentId)=>parentId, (fabricConversation, parentId)=>{
    if (fabricConversation) {
        if (parentId) // all replies to a comment
        return (fabricConversation.comments || []).filter((c)=>c.parentId === parentId);
        // all top-level comments of a conversation sorted by creation date
        return (fabricConversation.comments || []).filter((c)=>!c.parentId && c.conversationId === fabricConversation.conversationId).sort((a, b)=>a.createdAt === b.createdAt ? 0 : a.createdAt < b.createdAt ? -1 : 1);
    }
    return [];
})((_state, conversationId, parentId)=>parentId !== undefined ? `${conversationId}->${parentId}` : conversationId);
const $81071aca1c95b40c$export$7861b896bca91208 = (0, $aXXtM.createSelector)((0, $1EkdU.getAllRawComments), (conversations)=>{
    const commentsMetaData = [];
    conversations.forEach((conversation)=>{
        const { path: filepath, outdated: isOutdated } = conversation.inline || {};
        commentsMetaData.push({
            permalink: `comment-${(0, $xz4dB.isApiComment)(conversation) ? conversation.id : conversation.placeholderId}`,
            filepath: filepath || "",
            isOutdated: !!isOutdated,
            isResolved: !!conversation.resolution
        });
    });
    return commentsMetaData;
});
const $81071aca1c95b40c$export$b2a6b901ece130d6 = (0, $cQrjH.default)($81071aca1c95b40c$export$7861b896bca91208, (0, $1EkdU.getAllDiffFiles), (_state, permalink)=>permalink, (commentsMetaData, diffFiles, permalink)=>{
    const metadata = commentsMetaData.find((data)=>data.permalink === permalink);
    if (!metadata) return false;
    return !!(0, $1EkdU.findFileInDiffFiles)(diffFiles, metadata.filepath);
})((_state, permalink)=>permalink);
const $81071aca1c95b40c$export$a3edd3f478b4bb1 = (0, $cQrjH.default)($81071aca1c95b40c$export$7861b896bca91208, (0, $1EkdU.getAllDiffFiles), (0, $1EkdU.getDiffFiles), (_state, permalink)=>permalink, (commentsMetaData, diffFiles, limitedDiffFiles, permalink)=>{
    const metadata = commentsMetaData.find((data)=>data.permalink === permalink);
    if (!metadata) return false;
    return !(0, $1EkdU.findFileInDiffFiles)(limitedDiffFiles, metadata.filepath) && !!(0, $1EkdU.findFileInDiffFiles)(diffFiles, metadata.filepath);
})((_state, permalink)=>permalink);
const $81071aca1c95b40c$export$ee0ca4caafb77ed = (0, $cQrjH.default)($81071aca1c95b40c$export$950629ad9418ab6a, (_state, file)=>file, (conversations, file)=>{
    return (conversations || []).filter((convo)=>(0, $4coax.isOnFile)(convo.meta, file));
})($81071aca1c95b40c$var$getFileCacheKey);
const $81071aca1c95b40c$export$532c1bafd29d4fdc = (0, $cQrjH.default)((0, $1EkdU.getCommentTree), (_state, file)=>file, (commentTree, file)=>{
    return (commentTree.allThreads() || []).filter((thread)=>(0, $4coax.isOnFile)(thread.topComment.inline, file));
})($81071aca1c95b40c$var$getFileCacheKey);
const $81071aca1c95b40c$export$e18407316ae02980 = (0, $cQrjH.default)($81071aca1c95b40c$export$532c1bafd29d4fdc, (threads)=>(threads || []).filter((thread)=>(0, $4coax.isFileLevel)(thread.topComment.inline)))($81071aca1c95b40c$var$getFileCacheKey);
const $81071aca1c95b40c$export$8d98c1722660c3b3 = (0, $cQrjH.default)($81071aca1c95b40c$export$ee0ca4caafb77ed, (conversations)=>(conversations || []).filter((convo)=>(0, $4coax.isFileLevel)(convo.meta)))($81071aca1c95b40c$var$getFileCacheKey);
const $81071aca1c95b40c$export$c4c46726d5ef6b59 = (0, $cQrjH.default)($81071aca1c95b40c$export$ee0ca4caafb77ed, (fileConversations)=>fileConversations.filter((convo)=>!convo.meta.outdated))($81071aca1c95b40c$var$getFileCacheKey);
const $81071aca1c95b40c$export$9493cf340c48617e = (0, $cQrjH.default)($81071aca1c95b40c$export$532c1bafd29d4fdc, (fileThreads)=>fileThreads.filter((thread)=>{
        var _thread$topComment$in;
        return !((_thread$topComment$in = thread.topComment.inline) !== null && _thread$topComment$in !== void 0 && _thread$topComment$in.outdated);
    }))($81071aca1c95b40c$var$getFileCacheKey);
const $81071aca1c95b40c$export$ccbb39ed368f294b = (0, $cQrjH.default)($81071aca1c95b40c$export$c4c46726d5ef6b59, (validConversations)=>validConversations.filter((convo)=>$81071aca1c95b40c$var$getConversationType(convo.meta) === "inline"))($81071aca1c95b40c$var$getFileCacheKey);
const $81071aca1c95b40c$export$8d403d5cfee55516 = (0, $cQrjH.default)($81071aca1c95b40c$export$9493cf340c48617e, (validThreads)=>validThreads.filter((thread)=>$81071aca1c95b40c$var$getConversationType(thread.topComment.inline) === "inline"))($81071aca1c95b40c$var$getFileCacheKey);
const $81071aca1c95b40c$export$63408a03aa33ee85 = (0, $cQrjH.default)($81071aca1c95b40c$export$ee0ca4caafb77ed, (fileConversations)=>{
    return fileConversations.filter((convo)=>convo.meta.outdated && !(0, $7b2YZ.isFileLevelComment)(convo));
})($81071aca1c95b40c$var$getFileCacheKey);
const $81071aca1c95b40c$export$bc680c95c035dae6 = (0, $aXXtM.createSelector)($81071aca1c95b40c$export$63408a03aa33ee85, (outdatedConversations)=>outdatedConversations.reduce((count, convo)=>count + convo.numOfComments, 0));
const $81071aca1c95b40c$export$49bff0c2ebaaa51d = (0, $cQrjH.default)($81071aca1c95b40c$export$ee0ca4caafb77ed, (fileConversations)=>{
    return fileConversations.filter((convo)=>convo.meta.base_rev);
})($81071aca1c95b40c$var$getFileCacheKey);
const $81071aca1c95b40c$export$8d46cab76e8d5e4e = (0, $aXXtM.createSelector)($81071aca1c95b40c$export$49bff0c2ebaaa51d, (baseRevConversations)=>baseRevConversations.reduce((count, convo)=>!(0, $7b2YZ.isFileLevelComment)(convo) ? count + convo.numOfComments : count, 0));
const $81071aca1c95b40c$export$b41bcffb3baae9a2 = (0, $cQrjH.default)($81071aca1c95b40c$export$ee0ca4caafb77ed, (fileConversations)=>{
    return fileConversations.filter((convo)=>!convo.meta.base_rev && !convo.meta.outdated && !(0, $7b2YZ.isFileLevelComment)(convo));
})($81071aca1c95b40c$var$getFileCacheKey);
const $81071aca1c95b40c$export$30b80b1c8d92c41a = (0, $aXXtM.createSelector)($81071aca1c95b40c$export$b41bcffb3baae9a2, (conversations)=>conversations.reduce((count, convo)=>count + convo.numOfComments, 0));
const $81071aca1c95b40c$export$f1026161de9bb063 = (0, $aXXtM.createSelector)($81071aca1c95b40c$export$ee0ca4caafb77ed, (fileConversations)=>fileConversations.reduce((count, convo)=>count + convo.numOfComments, 0));
const $81071aca1c95b40c$export$5089c0ac12360e3d = (0, $aXXtM.createSelector)($81071aca1c95b40c$export$950629ad9418ab6a, (conversations)=>conversations.filter((c)=>Object.keys(c.meta).length === 0));
const $81071aca1c95b40c$export$953d9acbc856867f = (0, $aXXtM.createSelector)((0, $1EkdU.getPullRequestSlice), (pullRequest)=>pullRequest.commentsLoadingStatus);
const $81071aca1c95b40c$export$db8e81ae5b770789 = (0, $aXXtM.createSelector)((0, $1EkdU.getCurrentPullRequestId), (0, $aanBq.getCurrentRepositoryUuid), (0, $aanBq.getCurrentRepositoryProjectUuid), (0, $aanBq.getCurrentRepositoryWorkspaceUUID), (0, $g2R3c.getCurrentUserAccountId), (0, $g2R3c.getCurrentUserUuid), (pullRequestId, repositoryUuid, repositoryProjectUuid, repositoryWorkspaceUuid, currentUserAccountId, currentUserUuid)=>({
        repositoryUUID: (0, $a5HLv.uncurlyUuid)(repositoryUuid || "") || null,
        repositoryProjectUUID: (0, $a5HLv.uncurlyUuid)(repositoryProjectUuid || "") || null,
        repositoryWorkspaceUUID: (0, $a5HLv.uncurlyUuid)(repositoryWorkspaceUuid || "") || null,
        pullrequestId: pullRequestId,
        currentUserUUID: (0, $a5HLv.uncurlyUuid)(currentUserUuid || "") || null,
        currentUserAccountId: currentUserAccountId
    }));
const $81071aca1c95b40c$export$3e419cf82ceed13a = (0, $aXXtM.createSelector)((0, $g2R3c.getCurrentUser), (currentUser)=>currentUser ? (0, $5D0x5.toFabricUser)(currentUser) : null);
const $81071aca1c95b40c$export$707da24cbd7d3720 = (0, $aXXtM.createSelector)((0, $aanBq.getCurrentRepositoryUuid), (0, $1EkdU.getCurrentPullRequestId), (0, $aanBq.getCurrentRepositoryWorkspaceUUID), (0, $aanBq.getIsCurrentRepositoryPrivate), (currentRepositoryUuid, currentPullRequestId, currentRepositoryWorkspaceUUID, isCurrentRepoPrivate)=>({
        repositoryUUID: (0, $a5HLv.uncurlyUuid)(currentRepositoryUuid || "") || null,
        repositoryWorkspaceUUID: (0, $a5HLv.uncurlyUuid)(currentRepositoryWorkspaceUUID || "") || null,
        pullrequestId: currentPullRequestId,
        isPrivateRepo: isCurrentRepoPrivate || false
    }));
const $81071aca1c95b40c$export$9cb624b7b153ef20 = (0, $aXXtM.createSelector)($81071aca1c95b40c$export$6feb3b1470f88dd4, (0, $krSFm.getPendingCommentTasks), (conversations, commentTasks)=>{
    const pendingCommentSet = new Set();
    const pendingConversationSet = new Set();
    // Iterate through each task first to add comments that should be rendered
    commentTasks.forEach((task)=>{
        const { comment: comment } = task;
        if (comment) pendingCommentSet.add(comment.id);
    });
    // FabricConversation comments are sorted by timestamp from oldest to newest
    // If we start from the back of the array, we will always traverse the child component before its parent
    // Iterate through each conversation to determine which should be rendered
    conversations.forEach((conversation)=>{
        const { comments: comments } = conversation;
        // Start from newest comment
        for(let i = comments.length - 1; i >= 0; i--){
            const comment = comments[i];
            // A comment may not be pending but if their commentId is in the set, then they must be an ancestor
            // to a pending comment or they have a pending task attached so we must add their conversation to
            // pendingConversationSet
            if (pendingCommentSet.has(comment.commentId)) pendingConversationSet.add(conversation.conversationId);
            // Add pending comment to set
            if (comment.pending) {
                pendingCommentSet.add(comment.commentId);
                // If we want to render these comments, then we want to keep their conversation to render
                pendingConversationSet.add(conversation.conversationId);
            }
            // If comment is pending or has a pending child, add its parent to set
            if (pendingCommentSet.has(comment.commentId) && comment.parentId) pendingCommentSet.add(comment.parentId);
        }
    });
    return {
        pendingConversationSet: pendingConversationSet,
        pendingCommentSet: pendingCommentSet
    };
});
const $81071aca1c95b40c$export$3e4b1c89cee1a077 = (0, $aXXtM.createSelector)((0, $1EkdU.getConversationsList), $81071aca1c95b40c$export$9cb624b7b153ef20, (conversations, pendingSets)=>{
    return conversations.filter((conversation)=>pendingSets.pendingConversationSet.has(conversation.conversationId));
});
const $81071aca1c95b40c$export$afd021c377537581 = (0, $aXXtM.createSelector)($81071aca1c95b40c$export$3e4b1c89cee1a077, (conversations)=>conversations.find((conversation)=>!conversation.meta.path));
const $81071aca1c95b40c$export$f10f0aa909c64e30 = (0, $aXXtM.createSelector)($81071aca1c95b40c$export$3e4b1c89cee1a077, (conversations)=>conversations.filter((conversation)=>conversation.meta.path));
const $81071aca1c95b40c$export$a42144a38b913b51 = (0, $aXXtM.createSelector)($81071aca1c95b40c$export$3e4b1c89cee1a077, (pendingConversations)=>pendingConversations.filter((conversation)=>Object.keys(conversation.meta).length !== 0 && (conversation.meta.from !== null || conversation.meta.to !== null)));

});
parcelRegister("krSFm", function(module, exports) {

$parcel$export(module.exports, "getTasksSlice", function () { return $18c37e0097c6a8b1$export$49827f2d2b983ca1; });
$parcel$export(module.exports, "getTasks", function () { return $18c37e0097c6a8b1$export$20b82b4a32771893; });
$parcel$export(module.exports, "getUniqueTasksErrorMessages", function () { return $18c37e0097c6a8b1$export$56fc2656d7cd3e98; });
$parcel$export(module.exports, "getCanCreateTask", function () { return $18c37e0097c6a8b1$export$f4ed3b0690c2b3a6; });
$parcel$export(module.exports, "getCanResolveTask", function () { return $18c37e0097c6a8b1$export$b8fffaacf323f32b; });
$parcel$export(module.exports, "getModifiableTasks", function () { return $18c37e0097c6a8b1$export$e3cfbfac843f589; });
$parcel$export(module.exports, "getCanEditSomeTasks", function () { return $18c37e0097c6a8b1$export$e4fe5e78200868e3; });
$parcel$export(module.exports, "getTasksForComment", function () { return $18c37e0097c6a8b1$export$a74773f5eb948e84; });
$parcel$export(module.exports, "getInitialTaskText", function () { return $18c37e0097c6a8b1$export$ded5eb9dfdf743d3; });
$parcel$export(module.exports, "isCreateTaskInputVisible", function () { return $18c37e0097c6a8b1$export$b0b4c57a7223c15c; });
$parcel$export(module.exports, "getPendingTasks", function () { return $18c37e0097c6a8b1$export$461260a351dd1159; });
$parcel$export(module.exports, "getPendingGlobalTasks", function () { return $18c37e0097c6a8b1$export$49794953aac3ec50; });
$parcel$export(module.exports, "getPendingCommentTasks", function () { return $18c37e0097c6a8b1$export$f70cc748706aeabc; });

var $cQrjH = parcelRequire("cQrjH");

var $aXXtM = parcelRequire("aXXtM");

var $1EkdU = parcelRequire("1EkdU");

var $67NwJ = parcelRequire("67NwJ");

var $aanBq = parcelRequire("aanBq");

var $g2R3c = parcelRequire("g2R3c");
const $18c37e0097c6a8b1$export$49827f2d2b983ca1 = (0, $aXXtM.createSelector)((0, $1EkdU.getPullRequestSlice), (prSlice)=>prSlice.tasks);
const $18c37e0097c6a8b1$export$f14d30cf0d71be14 = (0, $aXXtM.createSelector)($18c37e0097c6a8b1$export$49827f2d2b983ca1, (tasksSlice)=>tasksSlice.isLoading);
const $18c37e0097c6a8b1$export$20b82b4a32771893 = (0, $aXXtM.createSelector)($18c37e0097c6a8b1$export$49827f2d2b983ca1, ({ items: items })=>items);
const $18c37e0097c6a8b1$export$56fc2656d7cd3e98 = (0, $aXXtM.createSelector)($18c37e0097c6a8b1$export$49827f2d2b983ca1, ({ taskErrors: taskErrors })=>Array.from(new Set(Object.values(taskErrors || {}))));
const $18c37e0097c6a8b1$export$f4ed3b0690c2b3a6 = (0, $aXXtM.createSelector)((0, $aanBq.getRepositoryGrantedAccess), (0, $aanBq.getRepositoryAccessLevel), (grantedAccess)=>grantedAccess !== "none");
const $18c37e0097c6a8b1$export$b8fffaacf323f32b = (0, $aXXtM.createSelector)($18c37e0097c6a8b1$export$f4ed3b0690c2b3a6, (canCreate)=>canCreate);
const $18c37e0097c6a8b1$export$e3cfbfac843f589 = (0, $aXXtM.createSelector)($18c37e0097c6a8b1$export$20b82b4a32771893, (0, $g2R3c.getCurrentUser), (0, $1EkdU.getCurrentPullRequestAuthor), (0, $aanBq.getRepositoryAccessLevel), (tasks, currentUser, prAuthor, accessLevel)=>{
    // Anonymous users cannot modify any tasks
    if (!currentUser) return [];
    // Admins and PR authors can edit all tasks
    if (accessLevel === "admin" || prAuthor && prAuthor.uuid === currentUser.uuid) return tasks.map((0, $67NwJ.taskKey));
    // Non-admins and non-pr-authors can modify tasks
    // that they create
    return tasks.filter((task)=>task.creator && task.creator.uuid === currentUser.uuid).map((0, $67NwJ.taskKey));
});
const $18c37e0097c6a8b1$export$e4fe5e78200868e3 = (0, $aXXtM.createSelector)($18c37e0097c6a8b1$export$20b82b4a32771893, $18c37e0097c6a8b1$export$e3cfbfac843f589, (tasks, modifiableTasks)=>{
    return tasks.reduce((result, task)=>{
        if (result) return result;
        const denyEdit = task.state === "RESOLVED" || !modifiableTasks.includes((0, $67NwJ.taskKey)(task));
        return !denyEdit || result;
    }, false);
});
const $18c37e0097c6a8b1$export$a74773f5eb948e84 = (0, $cQrjH.default)($18c37e0097c6a8b1$export$20b82b4a32771893, (_state, commentId)=>commentId, (tasks, commentId)=>{
    if (!commentId || !tasks.length) return [];
    const id = parseInt(commentId, 10);
    return tasks.filter((task)=>task.comment && task.comment.id === id);
})((_state, commentId)=>commentId);
const $18c37e0097c6a8b1$var$getIsCreatingCommentTask = (0, $aXXtM.createSelector)($18c37e0097c6a8b1$export$49827f2d2b983ca1, ({ isCreatingCommentTaskByTaskKey: isCreatingCommentTaskByTaskKey })=>isCreatingCommentTaskByTaskKey);
const $18c37e0097c6a8b1$export$ded5eb9dfdf743d3 = (0, $aXXtM.createSelector)($18c37e0097c6a8b1$export$49827f2d2b983ca1, ({ initialTaskText: initialTaskText })=>initialTaskText);
const $18c37e0097c6a8b1$export$b0b4c57a7223c15c = (0, $cQrjH.default)($18c37e0097c6a8b1$var$getIsCreatingCommentTask, (_state, commentId)=>commentId, (isCreating, commentId)=>!!isCreating[commentId])((_state, commentId)=>commentId);
const $18c37e0097c6a8b1$export$461260a351dd1159 = (0, $aXXtM.createSelector)($18c37e0097c6a8b1$export$20b82b4a32771893, (tasks)=>tasks.filter((task)=>task.pending));
const $18c37e0097c6a8b1$export$49794953aac3ec50 = (0, $aXXtM.createSelector)($18c37e0097c6a8b1$export$461260a351dd1159, (tasks)=>tasks.filter((task)=>!task.comment));
const $18c37e0097c6a8b1$export$f70cc748706aeabc = (0, $aXXtM.createSelector)($18c37e0097c6a8b1$export$461260a351dd1159, (tasks)=>tasks.filter((task)=>task.comment));

});


parcelRegister("7BuDj", function(module, exports) {

$parcel$export(module.exports, "breakoutCommentEntries", function () { return $a87640ed760259e0$export$f392cd6d0f1e8d4d; });
$parcel$export(module.exports, "breakoutOverviewCommentEntries", function () { return $a87640ed760259e0$export$a53aae77dd600790; });
$parcel$export(module.exports, "transformActivities", function () { return $a87640ed760259e0$export$db725b679f3a524b; });
$parcel$export(module.exports, "transformOverviewActivities", function () { return $a87640ed760259e0$export$921946d307a1b121; });
$parcel$export(module.exports, "collapseCommits", function () { return $a87640ed760259e0$export$6e4769640d5b8ba0; });
$parcel$export(module.exports, "collapseAttachments", function () { return $a87640ed760259e0$export$c2901076135c302; });
$parcel$export(module.exports, "collapseRichActivities", function () { return $a87640ed760259e0$export$8093bb3f9201d2fa; });

var $2O50j = parcelRequire("2O50j");
var $67vw2 = parcelRequire("67vw2");

var $fapR5 = parcelRequire("fapR5");
var $dPFph = parcelRequire("dPFph");

var $3omLR = parcelRequire("3omLR");

var $xz4dB = parcelRequire("xz4dB");
parcelRequire("eRpZn");
var $5D0x5 = parcelRequire("5D0x5");

var $26wAJ = parcelRequire("26wAJ");
const $a87640ed760259e0$export$f392cd6d0f1e8d4d = (fabricConversations)=>{
    const commentEntries = [];
    fabricConversations.forEach((conversation)=>{
        const isDeleted = conversation.comments[0].deleted;
        const isPending = conversation.comments[0].pending;
        if (!isDeleted && !isPending) commentEntries.push({
            type: "comment-start",
            event: conversation,
            actor: (0, $5D0x5.toBBUser)(conversation.comments[0].createdBy),
            timestamp: new Date(conversation.createdAt)
        });
        const notDeletedOrPendingReplies = conversation.comments.slice(1).filter((comment)=>!comment.deleted && !comment.pending);
        const hasReplies = notDeletedOrPendingReplies.length > 0;
        if (hasReplies) {
            const sortedComments = notDeletedOrPendingReplies.sort((a, b)=>new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
            const latestComment = sortedComments[0];
            commentEntries.push({
                type: "comment-replies",
                event: conversation,
                numOfReplies: notDeletedOrPendingReplies.length,
                actor: (0, $5D0x5.toBBUser)(latestComment.createdBy),
                timestamp: new Date(latestComment.createdAt)
            });
        }
    });
    return commentEntries;
};
const $a87640ed760259e0$var$findLatestComment = (commentThread)=>{
    if (!(0, $xz4dB.isApiComment)(commentThread.topComment)) // It's a placeholder comment with no children, so must be the latest
    return commentThread.topComment;
    return Array.from(commentThread.commentTree.descendentsOf(commentThread.topComment.id)).reduce((latest, current)=>{
        if (latest === null) return current;
        if (new Date(latest.created_on) > new Date(current.created_on)) return latest;
        return current;
    }, commentThread.topComment);
};
const $a87640ed760259e0$export$a53aae77dd600790 = (commentTree)=>{
    const commentEntries = [];
    commentTree.allThreads().forEach((thread)=>{
        const isDeleted = "deleted" in thread.topComment && thread.topComment.deleted;
        if (!isDeleted) {
            const latestComment = $a87640ed760259e0$var$findLatestComment(thread);
            commentEntries.push({
                type: "comment-start",
                event: thread,
                actor: latestComment.user,
                timestamp: new Date(latestComment.created_on),
                latestComment: latestComment
            });
        }
    });
    return commentEntries;
};
/** Simple builder for title change activity feed entries */ const $a87640ed760259e0$var$titleChanged = (event)=>({
        type: "title-change",
        actor: event.update.author,
        event: event,
        lastTitle: event.update.changes.title.old,
        timestamp: new Date(event.update.date)
    });
/** Simple builder for description change activity feed entries */ const $a87640ed760259e0$var$descriptionChanged = (event)=>({
        type: "description-change",
        actor: event.update.author,
        event: event,
        timestamp: new Date(event.update.date)
    });
const $a87640ed760259e0$export$f1fd2e06bebed142 = (event)=>{
    const { commit: commit } = event.update.source;
    return {
        type: "update",
        actor: event.update.author,
        event: event,
        hashes: [
            {
                hash: commit ? (0, $26wAJ.shortHash)(commit.hash) : null,
                parentHash: commit && commit.parents && commit.parents[0] ? (0, $26wAJ.shortHash)(commit.parents[0].hash) : null,
                url: commit ? commit.links.html.href : null
            }
        ],
        timestamp: new Date(event.update.date)
    };
};
/** Simple builder for status change activity feed entries */ const $a87640ed760259e0$var$statusChanged = (event)=>({
        type: "status-change",
        actor: event.update.author,
        event: event,
        timestamp: new Date(event.update.date)
    });
/** Simple builder for the reviewers added activity feed entires.
 * Technically this event contains added and removed reviewers, so the name
 * "reviewers-added" is a bit of a misnomer.
 */ const $a87640ed760259e0$var$reviewersAdded = (event)=>({
        type: "reviewers-added",
        actor: event.update.author,
        event: event,
        timestamp: new Date(event.update.date)
    });
/** Simple builder for approval activity feed entries */ const $a87640ed760259e0$var$approved = (event)=>({
        type: "approval",
        event: event,
        actor: event.approval.user,
        timestamp: new Date(event.approval.date)
    });
const $a87640ed760259e0$var$changesRequested = (event)=>({
        type: "changes-requested",
        event: event,
        actor: event.changes_requested.user,
        timestamp: new Date(event.changes_requested.date)
    });
/** Simple builder for the task created activity feed entries */ const $a87640ed760259e0$var$taskCreated = (event)=>({
        type: "task-created",
        actor: event.task.actor,
        event: event,
        timestamp: new Date(event.task.action_on)
    });
/** Simple builder for the task resolved activity feed entries */ const $a87640ed760259e0$var$taskResolved = (event)=>({
        type: "task-resolved",
        actor: event.task.actor,
        event: event,
        timestamp: new Date(event.task.action_on)
    });
/** Simple builder for the task created activity feed entries */ const $a87640ed760259e0$var$tasksCreated = (event)=>({
        type: "tasks-created",
        actor: event.task.actor,
        event: [
            event
        ],
        timestamp: new Date(event.task.action_on)
    });
/** Simple builder for the task resolved activity feed entries */ const $a87640ed760259e0$var$tasksResolved = (event)=>({
        type: "tasks-resolved",
        actor: event.task.actor,
        event: [
            event
        ],
        timestamp: new Date(event.task.action_on)
    });
/** Simple builder for the attachment added activity feed entries */ const $a87640ed760259e0$var$attachmentAdded = (event)=>{
    const { attachment: attachment } = event;
    return {
        type: "attachment-added",
        actor: attachment.uploaded_by,
        event: event,
        items: [
            {
                name: attachment.name,
                uuid: attachment.uuid
            }
        ],
        timestamp: new Date(attachment.created_on)
    };
};
// COREX-1733 Activity feed shows user updating commits when only the destination commit changed
const $a87640ed760259e0$var$isSourceCommitChanged = (openEvent, event)=>{
    var _openEvent$update, _openEvent$update$sou, _openEvent$update$sou2, _event$update, _event$update$source, _event$update$source$;
    return (openEvent === null || openEvent === void 0 ? void 0 : (_openEvent$update = openEvent.update) === null || _openEvent$update === void 0 ? void 0 : (_openEvent$update$sou = _openEvent$update.source) === null || _openEvent$update$sou === void 0 ? void 0 : (_openEvent$update$sou2 = _openEvent$update$sou.commit) === null || _openEvent$update$sou2 === void 0 ? void 0 : _openEvent$update$sou2.hash) !== (event === null || event === void 0 ? void 0 : (_event$update = event.update) === null || _event$update === void 0 ? void 0 : (_event$update$source = _event$update.source) === null || _event$update$source === void 0 ? void 0 : (_event$update$source$ = _event$update$source.commit) === null || _event$update$source$ === void 0 ? void 0 : _event$update$source$.hash);
};
const $a87640ed760259e0$export$db725b679f3a524b = (chronologicalEvents, hasAllEvents)=>{
    let openEvent;
    let updateEventsSeen = 0;
    // The first two update events from the API will be duplicate OPEN events
    // Capture the values of 2nd and discard the 1st
    const result = chronologicalEvents.filter((activityEvent)=>{
        if (hasAllEvents && updateEventsSeen < 2 && (0, $3omLR.isUpdateActivity)(activityEvent)) {
            openEvent = activityEvent;
            updateEventsSeen += 1;
            return false;
        }
        return true;
    }).reduce((events, event)=>{
        if ((0, $3omLR.isUpdateActivity)(event)) {
            const changes = event.update.changes ? event.update.changes : {};
            if ((0, $dPFph.default)(changes) && $a87640ed760259e0$var$isSourceCommitChanged(openEvent, event)) events.push($a87640ed760259e0$export$f1fd2e06bebed142(event));
            else {
                if ("title" in changes) events.push($a87640ed760259e0$var$titleChanged(event));
                if ("description" in changes) events.push($a87640ed760259e0$var$descriptionChanged(event));
                if ("status" in changes) events.push($a87640ed760259e0$var$statusChanged(event));
                if ("reviewers" in changes && "added" in changes.reviewers) events.push($a87640ed760259e0$var$reviewersAdded(event));
            }
        } else if ((0, $3omLR.isApprovalActivity)(event)) events.push($a87640ed760259e0$var$approved(event));
        else if ((0, $3omLR.isChangesRequestedActivity)(event)) events.push($a87640ed760259e0$var$changesRequested(event));
        else if (// The check for the actor is specifically to exclude default tasks
        // This ensures that default tasks, which lack an actor, are hidden
        (0, $3omLR.isTaskActivity)(event) && !event.task.task.pending && event.task.actor) {
            if (event.task.action === "CREATED") events.push($a87640ed760259e0$var$taskCreated(event));
            else if (event.task.action === "RESOLVED") events.push($a87640ed760259e0$var$taskResolved(event));
        } else if ((0, $3omLR.isAttachmentActivity)(event)) events.push($a87640ed760259e0$var$attachmentAdded(event));
        return events;
    }, []);
    if (openEvent && (0, $3omLR.isUpdateActivity)(openEvent)) // These are supposed to be sorted oldest -> newest so we put the OPEN in front
    result.unshift($a87640ed760259e0$var$statusChanged(openEvent));
    return result;
};
const $a87640ed760259e0$export$921946d307a1b121 = (chronologicalEvents, hasAllEvents)=>{
    let openEvent;
    let updateEventsSeen = 0;
    // The first two update events from the API will be duplicate OPEN events
    // Capture the values of 2nd and discard the 1st
    const result = chronologicalEvents.filter((activityEvent)=>{
        if (hasAllEvents && updateEventsSeen < 2 && (0, $3omLR.isUpdateActivity)(activityEvent)) {
            openEvent = activityEvent;
            updateEventsSeen += 1;
            return false;
        }
        return true;
    }).reduce((events, event)=>{
        if ((0, $3omLR.isUpdateActivity)(event)) {
            const changes = event.update.changes ? event.update.changes : {};
            if ((0, $dPFph.default)(changes) && $a87640ed760259e0$var$isSourceCommitChanged(openEvent, event)) events.push($a87640ed760259e0$export$f1fd2e06bebed142(event));
            else {
                if ("title" in changes) events.push($a87640ed760259e0$var$titleChanged(event));
                if ("description" in changes) events.push($a87640ed760259e0$var$descriptionChanged(event));
                if ("status" in changes) events.push($a87640ed760259e0$var$statusChanged(event));
                if ("reviewers" in changes && ("added" in changes.reviewers || "removed" in changes.reviewers)) events.push($a87640ed760259e0$var$reviewersAdded(event));
            }
        } else if ((0, $3omLR.isApprovalActivity)(event)) events.push($a87640ed760259e0$var$approved(event));
        else if ((0, $3omLR.isChangesRequestedActivity)(event)) events.push($a87640ed760259e0$var$changesRequested(event));
        else if (// The check for the actor is specifically to exclude default tasks
        // This ensures that default tasks, which lack an actor, are hidden
        (0, $3omLR.isTaskActivity)(event) && !event.task.task.pending && event.task.actor) {
            if (event.task.action === "CREATED") events.push($a87640ed760259e0$var$tasksCreated(event));
            else if (event.task.action === "RESOLVED") events.push($a87640ed760259e0$var$tasksResolved(event));
        } else if ((0, $3omLR.isAttachmentActivity)(event)) events.push($a87640ed760259e0$var$attachmentAdded(event));
        return events;
    }, []);
    if (openEvent && (0, $3omLR.isUpdateActivity)(openEvent)) // These are supposed to be sorted oldest -> newest so we put the OPEN in front
    result.unshift($a87640ed760259e0$var$statusChanged(openEvent));
    return result;
};
const $a87640ed760259e0$export$6e4769640d5b8ba0 = (entries)=>{
    return entries.reduce((previousEntries, currentEntry)=>{
        if (!(0, $3omLR.isCommitEntry)(currentEntry)) // We aren't concerned with non-commits here
        return [
            ...previousEntries,
            currentEntry
        ];
        const { commit: commit } = currentEntry.event.update.source;
        const newHash = commit ? (0, $26wAJ.shortHash)(commit.hash) : null;
        const isContainedInAnyPreviousCommitEntry = newHash && previousEntries.filter((entry)=>(0, $3omLR.isCommitEntry)(entry) && entry.hashes.find(({ hash: hash })=>hash === (0, $26wAJ.shortHash)(newHash))).length > 0;
        if (isContainedInAnyPreviousCommitEntry) // If the commit hash has already been added to any commit entry then
        // this return ensures that we don't add it as a new event either.
        return previousEntries;
        const previousEntry = previousEntries[previousEntries.length - 1];
        if ((0, $3omLR.isCommitEntry)(previousEntry)) {
            const isSameAuthor = currentEntry.actor.uuid === previousEntry.actor.uuid;
            if (isSameAuthor && (0, $67vw2.default)(currentEntry.timestamp, previousEntry.timestamp)) {
                previousEntry.hashes.push({
                    hash: commit ? (0, $26wAJ.shortHash)(commit.hash) : null,
                    parentHash: commit && commit.parents && commit.parents[0] ? (0, $26wAJ.shortHash)(commit.parents[0].hash) : null,
                    url: commit ? commit.links.html.href : null
                });
                return previousEntries;
            }
        }
        // This return is the result of it being a brand new commit entry
        return [
            ...previousEntries,
            currentEntry
        ];
    }, []);
};
const $a87640ed760259e0$export$c2901076135c302 = (entries)=>{
    return entries.reduce((previousEntries, currentEntry)=>{
        if (!(0, $3omLR.isAttachmentEntry)(currentEntry)) return [
            ...previousEntries,
            currentEntry
        ];
        const { attachment: attachment } = currentEntry.event;
        const previousEntry = previousEntries[previousEntries.length - 1];
        if ((0, $3omLR.isAttachmentEntry)(previousEntry)) {
            const isSameAuthor = currentEntry.actor.uuid === previousEntry.actor.uuid;
            const TIME_GAP = 1800000; // 30 minutes
            const isRecent = new Date(currentEntry.timestamp).getTime() - new Date(previousEntry.timestamp).getTime() <= TIME_GAP;
            if (isSameAuthor && isRecent) {
                // most recent items go first in array
                previousEntry.items.unshift({
                    name: attachment.name,
                    uuid: attachment.uuid
                });
                return previousEntries;
            }
        }
        // This return is the result of it being a brand new attachment entry
        return [
            ...previousEntries,
            currentEntry
        ];
    }, []);
};
/**
 * This is an internal helper function which collapses down the tasks entries
 */ const $a87640ed760259e0$var$combineTasks = (previousEntries, previousEntry, currentEntry)=>{
    // make sure we don't accidentally combine two different types of tasks
    if (previousEntry.type !== currentEntry.type) return [
        ...previousEntries,
        currentEntry
    ];
    previousEntry.event = (previousEntry.event || []).concat(currentEntry.event);
    return previousEntries;
};
const $a87640ed760259e0$var$combineDescriptionChanges = (previousEntry, currentEntry)=>{
    if (previousEntry.event.update.changes.description && currentEntry.event.update.changes.description) previousEntry.event.update.changes.description.new = currentEntry.event.update.changes.description.new;
    return previousEntry;
};
/**
 * This is an internal helper function which collapses down the reviewers added entries.
 * Note that this includes reviewers removed as well.
 */ const $a87640ed760259e0$var$combineReviewersAddedAndRemoved = (previousEntry, currentEntry)=>{
    var _currentEntry$event$u, _currentEntry$event$u2, _currentEntry$event$u3, _currentEntry$event$u4;
    if (!previousEntry.event.update.changes.reviewers) // This is primarily to keep the typing happy, and will likely never happen
    previousEntry.event.update.changes.reviewers = {
        added: [],
        removed: []
    };
    // It is possible to concat two events that only had additions or removals, so we need to handle all the cases
    previousEntry.event.update.changes.reviewers.added = (previousEntry.event.update.changes.reviewers.added || []).concat(((_currentEntry$event$u = currentEntry.event.update.changes) === null || _currentEntry$event$u === void 0 ? void 0 : (_currentEntry$event$u2 = _currentEntry$event$u.reviewers) === null || _currentEntry$event$u2 === void 0 ? void 0 : _currentEntry$event$u2.added) || []);
    previousEntry.event.update.changes.reviewers.removed = (previousEntry.event.update.changes.reviewers.removed || []).concat(((_currentEntry$event$u3 = currentEntry.event.update.changes) === null || _currentEntry$event$u3 === void 0 ? void 0 : (_currentEntry$event$u4 = _currentEntry$event$u3.reviewers) === null || _currentEntry$event$u4 === void 0 ? void 0 : _currentEntry$event$u4.removed) || []);
    return previousEntry;
};
const $a87640ed760259e0$export$8093bb3f9201d2fa = (entries)=>{
    // This selector gets run multiple times when a page is loading new data
    // Since it permutes the data we need to make sure
    // we clone the entries first so we don't run that permutation multiple times.
    const clonedEntries = (0, $fapR5.default)(entries);
    return clonedEntries.reduce((previousEntries, currentEntry)=>{
        const previousEntry = previousEntries[previousEntries.length - 1];
        if (!previousEntry) // This is the first entry so we can't merge it with anything
        return [
            currentEntry
        ];
        if (!previousEntry.actor || !currentEntry.actor) // if we don't have an actor we can't merge
        // this can happen when bots are making automated comments on PRs
        return [
            ...previousEntries,
            currentEntry
        ];
        const isSameAuthor = currentEntry.actor.uuid === previousEntry.actor.uuid;
        const TIME_GAP = 5; // 5 minutes
        const isRecent = (0, $2O50j.default)(currentEntry.timestamp, previousEntry.timestamp) <= TIME_GAP;
        // never merge things that aren't close together in time and the same actor
        if (isRecent && isSameAuthor) {
            // collapse the reviewers added if they match (note this includes reviewers removed because reviewers added is a misnomer)
            if ((0, $3omLR.isReviewersAddedEntry)(currentEntry) && (0, $3omLR.isReviewersAddedEntry)(previousEntry)) {
                $a87640ed760259e0$var$combineReviewersAddedAndRemoved(previousEntry, currentEntry);
                return previousEntries;
            }
            // collapse the created tasks if they match
            if ((0, $3omLR.isTasksCreatedEntry)(currentEntry) && (0, $3omLR.isTasksCreatedEntry)(previousEntry)) return $a87640ed760259e0$var$combineTasks(previousEntries, previousEntry, currentEntry);
            // collapse the resolved tasks if they match
            if ((0, $3omLR.isTasksResolvedEntry)(currentEntry) && (0, $3omLR.isTasksResolvedEntry)(previousEntry)) return $a87640ed760259e0$var$combineTasks(previousEntries, previousEntry, currentEntry);
            if ((0, $3omLR.isDescriptionChangeEntry)(currentEntry) && (0, $3omLR.isDescriptionChangeEntry)(previousEntry)) {
                $a87640ed760259e0$var$combineDescriptionChanges(previousEntry, currentEntry);
                return previousEntries;
            }
        }
        // This return is the result of it being a brand new entry that doesn't match the previous entry
        return [
            ...previousEntries,
            currentEntry
        ];
    }, []);
};

});
parcelRegister("2O50j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20b421f6dd66b274$export$2e2bcd8739ae039; });

var $9UOAF = parcelRequire("9UOAF");

var $cwsqP = parcelRequire("cwsqP");

var $kYqHr = parcelRequire("kYqHr");

var $22StA = parcelRequire("22StA");
function $20b421f6dd66b274$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $kYqHr.default)(2, arguments);
    var diff = (0, $cwsqP.default)(dateLeft, dateRight) / (0, $9UOAF.millisecondsInMinute);
    return (0, $22StA.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("67vw2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $474bd7e94b6a2e91$export$2e2bcd8739ae039; });

var $h1rDP = parcelRequire("h1rDP");

var $kYqHr = parcelRequire("kYqHr");
function $474bd7e94b6a2e91$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $kYqHr.default)(2, arguments);
    var dateLeftStartOfDay = (0, $h1rDP.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $h1rDP.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});

parcelRegister("dPFph", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1202846016495f2$export$2e2bcd8739ae039; });

var $iaY3b = parcelRequire("iaY3b");

var $jFSoh = parcelRequire("jFSoh");

var $01Qmm = parcelRequire("01Qmm");

var $dEaOb = parcelRequire("dEaOb");

var $l3LBL = parcelRequire("l3LBL");

var $3CsZM = parcelRequire("3CsZM");

var $lt0RS = parcelRequire("lt0RS");

var $gsxmc = parcelRequire("gsxmc");
/** `Object#toString` result references. */ var $a1202846016495f2$var$mapTag = "[object Map]", $a1202846016495f2$var$setTag = "[object Set]";
/** Used for built-in method references. */ var $a1202846016495f2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a1202846016495f2$var$hasOwnProperty = $a1202846016495f2$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $a1202846016495f2$var$isEmpty(value) {
    if (value == null) return true;
    if ((0, $l3LBL.default)(value) && ((0, $dEaOb.default)(value) || typeof value == "string" || typeof value.splice == "function" || (0, $3CsZM.default)(value) || (0, $gsxmc.default)(value) || (0, $01Qmm.default)(value))) return !value.length;
    var tag = (0, $jFSoh.default)(value);
    if (tag == $a1202846016495f2$var$mapTag || tag == $a1202846016495f2$var$setTag) return !value.size;
    if ((0, $lt0RS.default)(value)) return !(0, $iaY3b.default)(value).length;
    for(var key in value){
        if ($a1202846016495f2$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
var $a1202846016495f2$export$2e2bcd8739ae039 = $a1202846016495f2$var$isEmpty;

});



parcelRegister("7p7CY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24cb1e7b2567663e$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $8Ao0D = parcelRequire("8Ao0D");

var $g8glp = parcelRequire("g8glp");
function* $24cb1e7b2567663e$var$fetchBranchSyncInfoSaga(owner, slug, id) {
    try {
        const api = yield* (0, $g8glp.getPullRequestApis)();
        const info = yield (0, $5NpoY.P)(api.getBranchSyncInfo, owner, slug, id);
        yield (0, $5NpoY.Y)({
            type: (0, $8Ao0D.FETCH_BRANCH_SYNC_INFO).SUCCESS,
            payload: info
        });
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $8Ao0D.FETCH_BRANCH_SYNC_INFO).ERROR
        });
    }
}
var $24cb1e7b2567663e$export$2e2bcd8739ae039 = $24cb1e7b2567663e$var$fetchBranchSyncInfoSaga;

});

parcelRegister("j2CMC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a48a22534df7f353$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $g8glp = parcelRequire("g8glp");
function* $a48a22534df7f353$var$fetchConflictsSaga(owner, slug, id) {
    try {
        const api = yield* (0, $g8glp.getPullRequestApis)();
        // @ts-ignore
        const conflicts = yield (0, $5NpoY.P)(api.getConflicts, owner, slug, id);
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.FETCH_CONFLICTS).SUCCESS,
            payload: conflicts
        });
    } catch (e) {
    // We aren't concerned with this request erroring for now
    }
}
var $a48a22534df7f353$export$2e2bcd8739ae039 = $a48a22534df7f353$var$fetchConflictsSaga;

});

parcelRegister("d3vpB", function(module, exports) {

$parcel$export(module.exports, "fetchDestinationBranch", function () { return $4f01fb0f2f8f9d7e$export$1315110dcb36d731; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $1EkdU = parcelRequire("1EkdU");

var $cOITW = parcelRequire("cOITW");
function* $4f01fb0f2f8f9d7e$export$1315110dcb36d731(owner, slug) {
    let destinationBranchName = yield (0, $5NpoY.a3)((0, $1EkdU.getDestinationBranchName));
    if (!destinationBranchName) {
        yield (0, $5NpoY.M)((0, $6D21P.LOAD_PULL_REQUEST).SUCCESS);
        destinationBranchName = yield (0, $5NpoY.a3)((0, $1EkdU.getDestinationBranchName));
    }
    yield (0, $5NpoY.Y)((0, $cOITW.default)((0, $6D21P.FETCH_DESTINATION_BRANCH), `${owner}/${slug}`, destinationBranchName));
}

});
parcelRegister("cOITW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71f334eda214b96d$export$2e2bcd8739ae039; });
parcelRequire("5YpaN");
var $fICwP = parcelRequire("fICwP");

var $kZnTB = parcelRequire("kZnTB");
var // @ts-ignore TODO: fix noImplicitAny error here
$71f334eda214b96d$export$2e2bcd8739ae039 = (action, repositoryFullName, branchName)=>{
    const [owner, slug] = repositoryFullName.split("/");
    return (0, $fICwP.fetchAction)(action, {
        url: `${(0, $kZnTB.default).api.v20.branch(owner, slug, branchName)}`
    });
};

});


parcelRegister("lf0Id", function(module, exports) {

$parcel$export(module.exports, "watchSaga", function () { return $f2e3d88e99ab0f4e$export$c2a8472a829b8e2c; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("24sAG");
var $39E4H = parcelRequire("39E4H");

var $1EkdU = parcelRequire("1EkdU");
function* $f2e3d88e99ab0f4e$export$c2a8472a829b8e2c(f, passedArgs) {
    try {
        // In some instances, we cannot count on `getCurrentPullRequestUrlPieces`
        // being defined in the store yet. For example, when the PR is first
        // mounted and `ENTERED_CODE_REVIEW` + `codeReviewDataSaga` is called, the
        // current PR may not be available yet. To make sure we have those values,
        // we can check if the action explicitly passed them along as an argument.
        //  If they are not defined, we can default to looking them up in the store like before.
        const hasUrlArgs = passedArgs && passedArgs.owner && passedArgs.slug && passedArgs.id;
        const { owner: owner, slug: slug, id: id } = hasUrlArgs ? passedArgs : yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
        if (owner && slug && id) {
            yield (0, $5NpoY.Y)((0, $39E4H.watchLoading)());
            // Watch api returns either an error or a watch result.
            const result = yield (0, $5NpoY.P)(f, owner, slug, id);
            // Parse the result or in case of errors ignore them and default to not watching.
            const watch = result.map((r)=>r.watching).getOrElse(false);
            yield (0, $5NpoY.Y)((0, $39E4H.watchLoadingEnd)(watch));
        }
    } catch (e) {
        yield (0, $5NpoY.Y)((0, $39E4H.watchLoadingEnd)(false));
    }
}

});


parcelRegister("3Eq4L", function(module, exports) {

$parcel$export(module.exports, "commentsContextSaga", function () { return $01d9e346a9b4e211$export$8220f39d56bb49d1; });

var $2Bfet = parcelRequire("2Bfet");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $axaTk = parcelRequire("axaTk");

var $i2O3k = parcelRequire("i2O3k");

var $dkkN8 = parcelRequire("dkkN8");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $1EkdU = parcelRequire("1EkdU");

var $7b2YZ = parcelRequire("7b2YZ");

var $cCrBH = parcelRequire("cCrBH");

var $K8Ikq = parcelRequire("K8Ikq");

var $k2cPS = parcelRequire("k2cPS");

var $6EIJN = parcelRequire("6EIJN");

var $czBtW = parcelRequire("czBtW");

var $arN8q = parcelRequire("arN8q");

var $3XCf5 = parcelRequire("3XCf5");
const $01d9e346a9b4e211$var$isIncompleteConversation = (conversation)=>!(conversation.meta.from !== null && conversation.meta.to !== null);
const $01d9e346a9b4e211$var$none = (array, predicate)=>!array.some(predicate);
const $01d9e346a9b4e211$var$containsConversation = (conversation)=>(chunk)=>{
        // FROM | TO are the terms for the gutter column line numbers
        const fromStart = chunk.oldStart;
        const fromEnd = chunk.oldStart + chunk.oldLines - 1;
        const toStart = chunk.newStart;
        const toEnd = chunk.newStart + chunk.newLines - 1;
        const { from: convoFrom, to: convoTo } = conversation.meta;
        // This is redundant if the consumer has already checked this but this function doesn't know
        const isFileOrGlobalComment = convoFrom === null && convoTo === null;
        if (isFileOrGlobalComment) return false;
        const isFromLineInChunk = !!fromStart && convoFrom !== null && (0, $2Bfet.default)(convoFrom, fromStart, fromEnd + 1);
        const isToLineInChunk = !!toStart && convoTo !== null && (0, $2Bfet.default)(convoTo, toStart, toEnd + 1);
        return isFromLineInChunk || isToLineInChunk;
    };
const $01d9e346a9b4e211$var$needsRendered = (diffs, diffRenderingFlags, renderingLimits)=>(conversation)=>{
        const { path: path, outdated: outdated } = conversation.meta;
        const relevantDiff = diffs.find((diff)=>diff.to === path);
        if (!relevantDiff) return false;
        const { chunks: chunks } = relevantDiff;
        return (0, $K8Ikq.hasRenderableLines)(relevantDiff, diffRenderingFlags, renderingLimits) && !outdated && !(0, $7b2YZ.isFileLevelComment)(conversation) && $01d9e346a9b4e211$var$none(chunks, $01d9e346a9b4e211$var$containsConversation(conversation));
    };
const $01d9e346a9b4e211$var$getCommentWithClosestChunk = (diffs)=>(conversation)=>{
        const { path: path } = conversation.meta;
        const relevantDiff = diffs.find((diff)=>diff.to === path);
        const { chunks: chunks } = relevantDiff;
        let minDistToChunk = Number.MAX_SAFE_INTEGER;
        let closestChunk;
        // find closest chunk above the convo if any
        chunks.forEach((chunk)=>{
            const { from: convoFrom, to: convoTo } = conversation.meta;
            // incomplete convo will have either a non-null "from" or "to" field
            if (convoFrom !== null) {
                const fromEnd = chunk.oldStart + chunk.oldLines - 1;
                if (convoFrom > fromEnd) {
                    const currDist = Math.abs(fromEnd - convoFrom);
                    if (currDist < minDistToChunk) {
                        minDistToChunk = currDist;
                        closestChunk = chunk;
                    }
                }
            } else if (convoTo !== null) {
                const toEnd = chunk.newStart + chunk.newLines - 1;
                if (convoTo > toEnd) {
                    const currDist = Math.abs(toEnd - convoTo);
                    if (currDist < minDistToChunk) {
                        minDistToChunk = currDist;
                        closestChunk = chunk;
                    }
                }
            }
        });
        return {
            conversation: conversation,
            // @ts-ignore closestChunk will be non-null
            chunk: closestChunk
        };
    };
function* $01d9e346a9b4e211$var$fetchContextLines(path, linesRange, retries = 2) {
    if (retries <= 0) // Fail-safe because recursion
    return;
    const sourceHash = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestSourceHash));
    const destinationHash = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestDestinationHash));
    const { owner: owner, slug: slug } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    const topicDiffType = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestDiffType));
    const topicDiff = topicDiffType === (0, $axaTk.DiffType).TOPIC_DIFF;
    const diffs = yield (0, $5NpoY.a3)((0, $1EkdU.getRenderedPullRequestDiff));
    const relevantDiff = diffs.find((diff)=>diff.to === path);
    const prevFilepath = relevantDiff && relevantDiff.from;
    try {
        (0, $6EIJN.validateContextLineRanges)(linesRange);
    } catch (e) {
    // Only logging these in Sentry for now
    }
    const url = topicDiff ? (0, $czBtW.default).api.internal.contextFromSrcTopicDiff({
        owner: // lookup the source hash in the destination repo
        // to avoid issues with repo permissions
        owner,
        slug: slug,
        sourceHash: sourceHash,
        filepath: path
    }, linesRange) : (0, $czBtW.default).api.internal.contextFromSrcPreviewMerge({
        owner: owner,
        slug: slug,
        destinationHash: destinationHash,
        filepath: prevFilepath || path
    }, linesRange);
    const response = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
    const json = response.status === 200 ? // @ts-ignore
    yield response.json() : // @ts-ignore
    yield Promise.resolve({
        lines: []
    });
    const lines = json.data && (0, $3XCf5.parseSrcApiLines)(json.data) || [];
    const { startingFrom: startingFrom, startingTo: startingTo } = linesRange;
    const fromLineNumbers = (0, $3XCf5.buildLineNumbers)(lines.length, startingFrom);
    const toLineNumbers = (0, $3XCf5.buildLineNumbers)(lines.length, startingTo);
    const decodedLines = lines.map((line, index)=>({
            content: ` ${line}`,
            // diff content starts with +, - or ' '
            from_line: fromLineNumbers[index],
            to_line: toLineNumbers[index]
        }));
    yield (0, $5NpoY.Y)({
        type: (0, $6D21P.FETCH_COMMENT_CONTEXT).SUCCESS,
        payload: {
            path: path,
            newChunk: (0, $arN8q.buildChunk)(decodedLines)
        }
    });
}
function* $01d9e346a9b4e211$export$a3fcf8feffc4da95(conversationWithChunk) {
    const EXTRA_LINES = 1; // line ranges are inclusive
    const { from: from, to: to, path: path } = conversationWithChunk.conversation.meta;
    let initialLineNums;
    // "incomplete" comment that needs special handling
    if ($01d9e346a9b4e211$var$isIncompleteConversation(conversationWithChunk.conversation)) {
        // initial line numbers inferred from closest chunk above if any
        const { chunk: chunk } = conversationWithChunk;
        let offset = 0;
        if (chunk) {
            // chunk above
            const { oldStart: fromStart, newStart: toStart, oldLines: oldLines, newLines: newLines } = chunk;
            offset = toStart - fromStart + (newLines - oldLines);
        }
        // @ts-ignore
        const correctedFrom = from === null ? to + -1 * offset : from;
        // @ts-ignore
        const correctedTo = to === null ? from + offset : to;
        initialLineNums = {
            startingFrom: Math.max(1, correctedFrom - EXTRA_LINES),
            startingTo: Math.max(1, correctedTo - EXTRA_LINES),
            endingFrom: correctedFrom + EXTRA_LINES,
            endingTo: correctedTo + EXTRA_LINES
        };
    } else initialLineNums = {
        // @ts-ignore FROM will be non null
        startingFrom: Math.max(1, from - EXTRA_LINES),
        // @ts-ignore TO will be non null
        startingTo: Math.max(1, to - EXTRA_LINES),
        // @ts-ignore FROM will be non null
        endingFrom: from + EXTRA_LINES,
        // @ts-ignore TO will be non null
        endingTo: to + EXTRA_LINES
    };
    yield* $01d9e346a9b4e211$var$fetchContextLines(// @ts-ignore PATH will be non null
    path, initialLineNums);
}
function* $01d9e346a9b4e211$var$userEntersCodeReviewPage(effects) {
    yield (0, $5NpoY.M)((0, $6D21P.ENTERED_CODE_REVIEW));
    yield (0, $5NpoY._)(effects);
}
function* $01d9e346a9b4e211$var$userTogglesWhitespace(effects) {
    yield (0, $5NpoY.M)((0, $i2O3k.UPDATE_GLOBAL_SHOULD_IGNORE_WHITESPACE_SUCCESS));
    yield (0, $5NpoY._)(effects);
}
function* $01d9e346a9b4e211$var$userRefreshsPullRequestDiff(effects) {
    yield (0, $5NpoY.M)((0, $6D21P.REFRESH_CODE_REVIEW_DATA_FROM_POLL_RESULTS));
    yield (0, $5NpoY._)(effects);
}
function* $01d9e346a9b4e211$export$fbc26778f2e0d73a() {
    const diffs = yield (0, $5NpoY.a3)((0, $1EkdU.getRenderedPullRequestDiff));
    const conversations = yield (0, $5NpoY.a3)((0, $cCrBH.getConversations));
    const isSingleFileModeActive = yield (0, $5NpoY.a3)((0, $1EkdU.getIsSingleFileModeActive));
    const renderingLimits = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestRenderingLimits));
    const conversationsToRender = conversations.filter($01d9e346a9b4e211$var$needsRendered(diffs, isSingleFileModeActive, renderingLimits)).map($01d9e346a9b4e211$var$getCommentWithClosestChunk(diffs));
    const contextTasks = conversationsToRender.map((conversationToRender)=>(0, $5NpoY.a1)($01d9e346a9b4e211$export$a3fcf8feffc4da95, conversationToRender));
    yield (0, $5NpoY._)(contextTasks);
}
function* $01d9e346a9b4e211$export$8220f39d56bb49d1() {
    let task;
    // wait for features to be set in redux
    yield (0, $5NpoY.M)([
        (0, $dkkN8.LoadGlobal).SUCCESS,
        (0, $6D21P.LOAD_SSR_COMMENTS_CONTEXT)
    ]);
    const effects = [
        (0, $5NpoY.M)((0, $6D21P.FETCH_DIFF).SUCCESS),
        (0, $5NpoY.M)((0, $6D21P.LOAD_DIFFSTAT).SUCCESS)
    ];
    while(true){
        yield (0, $5NpoY.T)([
            (0, $5NpoY.P)($01d9e346a9b4e211$var$userEntersCodeReviewPage, [
                (0, $5NpoY.M)((0, $6D21P.FETCH_COMMENTS).SUCCESS)
            ].concat(effects)),
            (0, $5NpoY.P)($01d9e346a9b4e211$var$userTogglesWhitespace, effects),
            (0, $5NpoY.P)($01d9e346a9b4e211$var$userRefreshsPullRequestDiff, effects)
        ]);
        if (task !== undefined && task.isRunning()) yield task.cancel();
        task = yield (0, $5NpoY.N)($01d9e346a9b4e211$export$fbc26778f2e0d73a);
    }
}

});
parcelRegister("2Bfet", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e4ada57ab57a23c$export$2e2bcd8739ae039; });

var $bOTwN = parcelRequire("bOTwN");

var $7llIE = parcelRequire("7llIE");

var $jkkPC = parcelRequire("jkkPC");
/**
 * Checks if `n` is between `start` and up to, but not including, `end`. If
 * `end` is not specified, it's set to `start` with `start` then set to `0`.
 * If `start` is greater than `end` the params are swapped to support
 * negative ranges.
 *
 * @static
 * @memberOf _
 * @since 3.3.0
 * @category Number
 * @param {number} number The number to check.
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 * @see _.range, _.rangeRight
 * @example
 *
 * _.inRange(3, 2, 4);
 * // => true
 *
 * _.inRange(4, 8);
 * // => true
 *
 * _.inRange(4, 2);
 * // => false
 *
 * _.inRange(2, 2);
 * // => false
 *
 * _.inRange(1.2, 2);
 * // => true
 *
 * _.inRange(5.2, 4);
 * // => false
 *
 * _.inRange(-3, -2, -6);
 * // => true
 */ function $1e4ada57ab57a23c$var$inRange(number, start, end) {
    start = (0, $7llIE.default)(start);
    if (end === undefined) {
        end = start;
        start = 0;
    } else end = (0, $7llIE.default)(end);
    number = (0, $jkkPC.default)(number);
    return (0, $bOTwN.default)(number, start, end);
}
var $1e4ada57ab57a23c$export$2e2bcd8739ae039 = $1e4ada57ab57a23c$var$inRange;

});
parcelRegister("bOTwN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89af6ff133844dad$export$2e2bcd8739ae039; });
/* Built-in method references for those with the same name as other `lodash` methods. */ var $89af6ff133844dad$var$nativeMax = Math.max, $89af6ff133844dad$var$nativeMin = Math.min;
/**
 * The base implementation of `_.inRange` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to check.
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 */ function $89af6ff133844dad$var$baseInRange(number, start, end) {
    return number >= $89af6ff133844dad$var$nativeMin(start, end) && number < $89af6ff133844dad$var$nativeMax(start, end);
}
var $89af6ff133844dad$export$2e2bcd8739ae039 = $89af6ff133844dad$var$baseInRange;

});


parcelRegister("6EIJN", function(module, exports) {

$parcel$export(module.exports, "validateContextLineRanges", function () { return $ab10fc5c5ce38297$export$5f1417e679572bab; });

var $628YF = parcelRequire("628YF");
const $ab10fc5c5ce38297$var$isNegative = (n)=>n !== undefined && n < 0;
const $ab10fc5c5ce38297$var$hasNoRangeParams = ({ endingFrom: endingFrom, endingTo: endingTo, startingFrom: startingFrom, startingTo: startingTo })=>!endingFrom && !endingTo && !startingFrom && !startingTo;
const $ab10fc5c5ce38297$var$hasNegativeValues = ({ endingFrom: endingFrom, endingTo: endingTo, startingFrom: startingFrom, startingTo: startingTo })=>$ab10fc5c5ce38297$var$isNegative(endingFrom) || $ab10fc5c5ce38297$var$isNegative(endingTo) || $ab10fc5c5ce38297$var$isNegative(startingFrom) || $ab10fc5c5ce38297$var$isNegative(startingTo);
const $ab10fc5c5ce38297$var$hasInvertedRange = ({ endingFrom: endingFrom, endingTo: endingTo, startingFrom: startingFrom, startingTo: startingTo })=>startingFrom !== undefined && endingFrom !== undefined && startingFrom > endingFrom || startingTo !== undefined && endingTo !== undefined && startingTo > endingTo;
// A value of 1 will return a 204 (there's no content above the 1st line of a file)
// A value of 0 should get caught by hasNoRangeParams or hasInvertedRange, but leaving it in just in case
const $ab10fc5c5ce38297$var$hasOutOfBoundRange = ({ endingFrom: endingFrom, endingTo: endingTo })=>endingFrom !== undefined && endingFrom <= 1 || endingTo !== undefined && endingTo <= 1;
// eslint-disable-next-line no-underscore-dangle
const $ab10fc5c5ce38297$var$_validateContextLineRanges = (ranges)=>{
    if ($ab10fc5c5ce38297$var$hasNoRangeParams(ranges) || $ab10fc5c5ce38297$var$hasNegativeValues(ranges) || $ab10fc5c5ce38297$var$hasInvertedRange(ranges) || $ab10fc5c5ce38297$var$hasOutOfBoundRange(ranges)) throw new Error("The context line ranges are invalid");
};
const $ab10fc5c5ce38297$export$5f1417e679572bab = (contextLines)=>{
    try {
        $ab10fc5c5ce38297$var$_validateContextLineRanges(contextLines);
    } catch (e) {
        (0, $628YF.captureExceptionWithTags)(e, {}, {
            endingFrom: `${contextLines.endingFrom}`,
            endingTo: `${contextLines.endingTo}`,
            startingFrom: `${contextLines.startingFrom}`,
            startingTo: `${contextLines.startingTo}`
        });
        throw e;
    }
};

});

parcelRegister("arN8q", function(module, exports) {

$parcel$export(module.exports, "buildChunk", function () { return $1a7f007c632c8cff$export$d64b353b6d05444e; });
const $1a7f007c632c8cff$export$d64b353b6d05444e = (lines)=>{
    const content = `@@ -${lines[0].from_line},${lines.length} +${lines[0].to_line},${lines.length} @@`;
    return {
        id: content,
        content: content,
        oldStart: lines[0].from_line,
        oldLines: lines.length,
        newStart: lines[0].to_line,
        newLines: lines.length,
        extra: {
            isLoadingAbove: false,
            isLoadingBelow: false,
            before: {
                hasMoreLines: lines[0].from_line !== 1
            },
            after: {
                hasMoreLines: true
            }
        },
        changes: lines.map((line)=>({
                type: "normal",
                normal: true,
                oldLine: line.from_line,
                newLine: line.to_line,
                content: line.content
            }))
    };
};

});

parcelRegister("3XCf5", function(module, exports) {

$parcel$export(module.exports, "buildLineNumbers", function () { return $2315f91549fd150a$export$8c5e1bc8a4ee34fe; });
$parcel$export(module.exports, "getContextData", function () { return $2315f91549fd150a$export$20bf38724f2ed1b2; });
$parcel$export(module.exports, "getContextDataTopicDiff", function () { return $2315f91549fd150a$export$f007dfac4b0a6f40; });
$parcel$export(module.exports, "parseSrcApiLines", function () { return $2315f91549fd150a$export$b02e704536e18715; });
const $2315f91549fd150a$var$NUM_CONTEXT_LINES = 10;
const $2315f91549fd150a$export$bb66661bdc9aa13e = 9;
function $2315f91549fd150a$export$8c5e1bc8a4ee34fe(length, startingFrom) {
    return Array.from({
        length: length
    }, (_, k)=>k + startingFrom);
}
function $2315f91549fd150a$var$chunksWillConnect(chunks, chunkIndex, shouldExpandDown) {
    const chunk = chunks[chunkIndex];
    const isFirstChunk = chunkIndex === 0;
    const isLastChunk = chunkIndex >= chunks.length - 1;
    if (shouldExpandDown) {
        if (isLastChunk) return false;
        const contextLinesBottom = chunk.oldStart + chunk.oldLines + $2315f91549fd150a$var$NUM_CONTEXT_LINES;
        const nextChunk = chunks[chunkIndex + 1] || {};
        const nextChunkTop = nextChunk.oldStart;
        return contextLinesBottom >= nextChunkTop;
    } else {
        if (isFirstChunk) return false;
        const contextLinesTop = chunk.oldStart - $2315f91549fd150a$var$NUM_CONTEXT_LINES;
        const nextChunk = chunks[chunkIndex - 1] || {};
        const nextChunkBottom = nextChunk.oldStart + nextChunk.oldLines;
        return contextLinesTop <= nextChunkBottom;
    }
}
function $2315f91549fd150a$var$lineNumsBefore(chunk, startingFrom) {
    const endingFrom = chunk.oldStart - 1;
    const endingTo = chunk.newStart - 1;
    return {
        startingFrom: startingFrom || Math.max(endingFrom - $2315f91549fd150a$export$bb66661bdc9aa13e, 1),
        endingFrom: endingFrom,
        startingTo: startingFrom ? endingTo - (endingFrom - startingFrom) : Math.max(endingTo - $2315f91549fd150a$export$bb66661bdc9aa13e, 1)
    };
}
function $2315f91549fd150a$var$lineNumsAfter(chunk, endingFrom) {
    const from = chunk.oldStart + chunk.oldLines;
    const to = chunk.newStart + chunk.newLines;
    return {
        startingFrom: from,
        endingFrom: endingFrom || from + $2315f91549fd150a$export$bb66661bdc9aa13e,
        startingTo: to
    };
}
function $2315f91549fd150a$export$20bf38724f2ed1b2(chunks, expanderIndex, shouldExpandDown) {
    if (shouldExpandDown) {
        const chunkIndex = expanderIndex - 1;
        const chunk = chunks[chunkIndex];
        let lineNums;
        if ($2315f91549fd150a$var$chunksWillConnect(chunks, chunkIndex, true)) {
            const nextChunk = chunks[chunkIndex + 1];
            lineNums = $2315f91549fd150a$var$lineNumsAfter(chunk, nextChunk.oldStart - 1);
        } else lineNums = $2315f91549fd150a$var$lineNumsAfter(chunk);
        return {
            beforeOrAfter: "after",
            chunkId: chunk.id,
            lineNums: lineNums
        };
    } else {
        const chunkIndex = expanderIndex;
        const chunk = chunks[chunkIndex];
        let lineNums;
        if ($2315f91549fd150a$var$chunksWillConnect(chunks, chunkIndex, false)) {
            const prevChunk = chunks[chunkIndex - 1];
            lineNums = $2315f91549fd150a$var$lineNumsBefore(chunk, prevChunk.oldStart + prevChunk.oldLines);
        } else lineNums = $2315f91549fd150a$var$lineNumsBefore(chunk);
        return {
            beforeOrAfter: "before",
            chunkId: chunk.id,
            lineNums: lineNums
        };
    }
}
function $2315f91549fd150a$var$lineNumsBeforeTopicDiff(chunk, startingTo) {
    const endingFrom = chunk.oldStart - 1;
    const endingTo = chunk.newStart - 1;
    return {
        endingTo: endingTo,
        startingTo: startingTo || Math.max(endingTo - $2315f91549fd150a$export$bb66661bdc9aa13e, 1),
        startingFrom: startingTo ? endingFrom - (endingTo - startingTo) : Math.max(endingFrom - $2315f91549fd150a$export$bb66661bdc9aa13e, 1)
    };
}
function $2315f91549fd150a$var$lineNumsAfterTopicDiff(chunk, endingTo) {
    const from = chunk.oldStart + chunk.oldLines;
    const to = chunk.newStart + chunk.newLines;
    return {
        startingFrom: from,
        startingTo: to,
        endingTo: endingTo || to + $2315f91549fd150a$export$bb66661bdc9aa13e
    };
}
function $2315f91549fd150a$export$f007dfac4b0a6f40(chunks, expanderIndex, shouldExpandDown) {
    if (shouldExpandDown) {
        const chunkIndex = expanderIndex - 1;
        const chunk = chunks[chunkIndex];
        let lineNums;
        if ($2315f91549fd150a$var$chunksWillConnect(chunks, chunkIndex, true)) {
            const nextChunk = chunks[chunkIndex + 1];
            lineNums = $2315f91549fd150a$var$lineNumsAfterTopicDiff(chunk, nextChunk.newStart - 1);
        } else lineNums = $2315f91549fd150a$var$lineNumsAfterTopicDiff(chunk);
        return {
            beforeOrAfter: "after",
            chunkId: chunk.id,
            lineNums: lineNums
        };
    } else {
        const chunkIndex = expanderIndex;
        const chunk = chunks[chunkIndex];
        let lineNums;
        if ($2315f91549fd150a$var$chunksWillConnect(chunks, chunkIndex, false)) {
            const prevChunk = chunks[chunkIndex - 1];
            lineNums = $2315f91549fd150a$var$lineNumsBeforeTopicDiff(chunk, prevChunk.newStart + prevChunk.newLines);
        } else lineNums = $2315f91549fd150a$var$lineNumsBeforeTopicDiff(chunk);
        return {
            beforeOrAfter: "before",
            chunkId: chunk.id,
            lineNums: lineNums
        };
    }
}
function $2315f91549fd150a$export$b02e704536e18715(srcLines) {
    // some files are not newline terminated (BCLOUD-22333)
    if (srcLines.slice(-1) === "\n") return srcLines.split("\n").slice(0, -1);
    else return srcLines.split("\n");
}

});


parcelRegister("a3m1Q", function(module, exports) {

$parcel$export(module.exports, "createPendingMergeSaga", function () { return $45333cebe6fc2f41$export$a62cbdf579bea643; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $k6zif = parcelRequire("k6zif");

var $58TOz = parcelRequire("58TOz");

var $1EkdU = parcelRequire("1EkdU");

var $czBtW = parcelRequire("czBtW");

var $k2cPS = parcelRequire("k2cPS");
function* $45333cebe6fc2f41$export$a62cbdf579bea643(action) {
    // eslint-disable-next-line prefer-destructuring
    const payload = action.payload;
    const { owner: owner, slug: slug, id: id } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    const url = (0, $czBtW.default).api.internal.pendingMerge(owner, slug, id);
    const authWrapped = (0, $k2cPS.default)(url, {
        method: "POST",
        headers: (0, $k2cPS.jsonHeaders),
        body: JSON.stringify({
            close_source_branch: payload.closeSourceBranch,
            message: payload.message,
            merge_strategy: payload.mergeStrategy,
            newstatus: "fulfilled"
        })
    });
    try {
        const response = yield (0, $5NpoY.P)(fetch, authWrapped);
        if (!response.ok) {
            // @ts-ignore
            const message = yield (0, $5NpoY.P)((0, $58TOz.getJsonErrorMessageWithCode), response.clone());
            throw message;
        }
        yield (0, $5NpoY.Y)({
            type: (0, $k6zif.CREATE_PENDING_MERGE).SUCCESS,
            payload: payload
        });
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $k6zif.CREATE_PENDING_MERGE).ERROR,
            payload: e,
            error: true
        });
    }
}

});
parcelRegister("58TOz", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", function () { return $bf55e72e074d36cd$export$82f46aa4e6535a45; });
$parcel$export(module.exports, "getErrorMessageAsync", function () { return $bf55e72e074d36cd$export$890ca37d9d28953b; });
$parcel$export(module.exports, "getJsonErrorMessageWithCode", function () { return $bf55e72e074d36cd$export$b57369d09657a56f; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
const $bf55e72e074d36cd$var$contentTypeMatchers = {
    html: /html/,
    json: /json/
};
function* $bf55e72e074d36cd$export$82f46aa4e6535a45(response) {
    const contentType = response.headers.get("Content-Type") || "";
    if ($bf55e72e074d36cd$var$contentTypeMatchers.json.test(contentType)) {
        var _json$error, _json$error2;
        // @ts-ignore
        const json = yield response.json();
        const errorMessage = Object.values(((_json$error = json.error) === null || _json$error === void 0 ? void 0 : _json$error.fields) || {}).join("\n");
        return errorMessage || ((_json$error2 = json.error) === null || _json$error2 === void 0 ? void 0 : _json$error2.message) || "Unknown error";
    }
    const text = yield response.text();
    if ($bf55e72e074d36cd$var$contentTypeMatchers.html.test(contentType)) {
        const domParser = new DOMParser();
        const doc = yield (0, $5NpoY.P)({
            context: domParser,
            fn: domParser.parseFromString
        }, text, "text/html");
        const content = doc.getElementById("content");
        const innerText = content ? content.innerText : doc.body.innerText;
        const [result] = innerText.trim().split("\n");
        return result;
    }
    return text;
}
async function $bf55e72e074d36cd$export$890ca37d9d28953b(response) {
    const contentType = response.headers.get("Content-Type") || "";
    if ($bf55e72e074d36cd$var$contentTypeMatchers.json.test(contentType)) {
        var _json$error3, _json$error4;
        const json = await response.json();
        const errorMessage = Object.values(((_json$error3 = json.error) === null || _json$error3 === void 0 ? void 0 : _json$error3.fields) || {}).join("\n");
        return errorMessage || ((_json$error4 = json.error) === null || _json$error4 === void 0 ? void 0 : _json$error4.message) || "Unknown error";
    }
    const text = await response.text();
    if ($bf55e72e074d36cd$var$contentTypeMatchers.html.test(contentType)) {
        var _ref, _content$textContent;
        const domParser = new DOMParser();
        const doc = domParser.parseFromString(text, "text/html");
        const content = doc.getElementById("content");
        // This implementation is slightly different than the saga version.
        // `innerText` isn't supported in tests, so we use textContent instead and
        // add an extra last-resort fallback.
        const innerText = (_ref = (_content$textContent = content === null || content === void 0 ? void 0 : content.textContent) !== null && _content$textContent !== void 0 ? _content$textContent : doc.body.textContent) !== null && _ref !== void 0 ? _ref : "";
        const [result] = innerText.trim().split("\n");
        return result;
    }
    return text;
}
function* $bf55e72e074d36cd$export$b57369d09657a56f(response) {
    const contentType = response.headers.get("Content-Type") || "";
    if ($bf55e72e074d36cd$var$contentTypeMatchers.json.test(contentType)) {
        // @ts-ignore
        const json = yield response.json();
        return json.error;
    }
    return {};
}

});


parcelRegister("etixh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6344ac92bc490ca9$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $3XbtU = parcelRequire("3XbtU");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $1EkdU = parcelRequire("1EkdU");

var $czBtW = parcelRequire("czBtW");

var $k2cPS = parcelRequire("k2cPS");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $58TOz = parcelRequire("58TOz");
function* $6344ac92bc490ca9$export$2e2bcd8739ae039() {
    while(true){
        const { payload: { task: task, commentId: commentId, isTaskPending: isTaskPending, isGlobal: isGlobal } } = yield (0, $5NpoY.M)((0, $6D21P.TASK_CREATE).REQUEST);
        const { owner: owner, slug: slug, id: id } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
        const authWrapped = (0, $k2cPS.default)((0, $czBtW.default).api.v20.tasks(owner, slug, id), {
            method: "POST",
            headers: (0, $k2cPS.jsonHeaders),
            body: JSON.stringify({
                content: {
                    raw: task
                },
                pending: !!isTaskPending,
                ...commentId && {
                    comment: {
                        id: parseInt(commentId, 10)
                    }
                }
            })
        });
        try {
            const response = yield (0, $5NpoY.P)(fetch, authWrapped);
            if (!response.ok) {
                const message = yield (0, $5NpoY.P)((0, $58TOz.getErrorMessage), response.clone());
                throw new Error(message);
            }
            // @ts-ignore
            const newTask = yield response.json();
            yield (0, $5NpoY.Y)({
                type: (0, $6D21P.TASK_CREATE).SUCCESS,
                payload: {
                    commentId: commentId,
                    newTask: newTask,
                    isGlobal: isGlobal
                }
            });
        } catch (e) {
            $3XbtU.captureException(e);
            yield (0, $5NpoY.Y)({
                type: (0, $6D21P.TASK_CREATE).ERROR,
                payload: {
                    isGlobal: isGlobal,
                    commentId: commentId,
                    error: e.message
                }
            });
        }
    }
}

});

parcelRegister("2DnR8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $549b325c5320cb3e$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $b2RHC = parcelRequire("b2RHC");

var $1EkdU = parcelRequire("1EkdU");

var $czBtW = parcelRequire("czBtW");

var $aanBq = parcelRequire("aanBq");

var $5utbt = parcelRequire("5utbt");

var $k2cPS = parcelRequire("k2cPS");

var $ha5uu = parcelRequire("ha5uu");

var $58TOz = parcelRequire("58TOz");

var $9HLnY = parcelRequire("9HLnY");
function* $549b325c5320cb3e$export$2e2bcd8739ae039() {
    while(true){
        const { payload: message } = yield (0, $5NpoY.M)((0, $ha5uu.DECLINE).REQUEST);
        const { owner: owner, slug: slug, id: id } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
        const url = (0, $czBtW.default).api.v20.decline(owner, slug, id);
        const request = (0, $k2cPS.default)(url, {
            method: "POST",
            headers: (0, $k2cPS.jsonHeaders),
            body: JSON.stringify({
                message: message
            })
        });
        try {
            const response = yield (0, $5NpoY.P)(fetch, request);
            if (!response.ok) {
                const err = yield (0, $5NpoY.P)((0, $58TOz.getErrorMessage), response.clone());
                throw new Error(err);
            }
            // @ts-ignore
            const updatedPullRequest = yield response.json();
            yield (0, $5NpoY.Y)({
                type: (0, $ha5uu.DECLINE).SUCCESS,
                payload: updatedPullRequest,
                meta: {
                    schema: (0, $b2RHC.pullRequest)
                }
            });
            // publish analytics event
            const { isWorkspacePaid: isWorkspacePaid } = yield (0, $5NpoY.a3)((0, $5utbt.getWorkspacePlan));
            const repoUuid = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryUuid));
            const comments = yield (0, $5NpoY.a3)((0, $1EkdU.getInlineComments));
            const role = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestRoleForCurrentUser));
            (0, $9HLnY.publishPullRequestEvent)("DECLINED", updatedPullRequest, comments, isWorkspacePaid, repoUuid, role);
        } catch (e) {
            yield (0, $5NpoY.Y)({
                type: (0, $ha5uu.DECLINE).ERROR,
                payload: e.message
            });
        }
    }
}

});
parcelRegister("9HLnY", function(module, exports) {

$parcel$export(module.exports, "publishPullRequestEvent", function () { return $8dfe7ca166d80eb7$export$befdfe257573fa82; });

var $6aoKW = parcelRequire("6aoKW");
const $8dfe7ca166d80eb7$export$befdfe257573fa82 = (prAction, updatedPullRequest, comments, paid, repoUuid, role)=>{
    // pull request closed_on field definitely exists since it is set when a pull request is merged or declined
    const closedOn = new Date(updatedPullRequest.closed_on);
    const createdOn = new Date(updatedPullRequest.created_on);
    const hoursOpen = (closedOn.valueOf() - createdOn.valueOf()) / 3600000;
    const numComments = updatedPullRequest.comment_count;
    const pullRequestLocalId = updatedPullRequest.id;
    // We only want to count comments that don't have parents, as those are the top-level comments that can be resolved
    const numResolvedConvos = comments.filter((comment)=>!comment.parent && comment.resolution).length;
    const numUnresolvedConvos = comments.filter((comment)=>!comment.parent && !comment.resolution).length;
    let action = "";
    let actionSubjectId = "";
    if (prAction === "DECLINED") {
        action = "declined";
        actionSubjectId = "pullRequestDeclined";
    } else if (prAction === "MERGED") {
        action = "merged";
        actionSubjectId = "pullRequestMerged";
    }
    // COREX-5987: include number of unresolved/resolved comments once functionality is added (TODO)
    (0, $6aoKW.publishTrackEvent)({
        action: action,
        actionSubject: "pullRequest",
        actionSubjectId: actionSubjectId,
        source: "pullRequestScreen",
        attributes: {
            role: role,
            paid: paid,
            numUnresolvedConvos: numUnresolvedConvos,
            numResolvedConvos: numResolvedConvos,
            numComments: numComments,
            hoursOpen: hoursOpen,
            pullRequestLocalId: pullRequestLocalId,
            repoUuid: repoUuid
        }
    });
};

});


parcelRegister("3CRlf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c01bc6091fba1525$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $3XbtU = parcelRequire("3XbtU");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $1EkdU = parcelRequire("1EkdU");

var $czBtW = parcelRequire("czBtW");

var $67NwJ = parcelRequire("67NwJ");

var $k2cPS = parcelRequire("k2cPS");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $58TOz = parcelRequire("58TOz");
function* $c01bc6091fba1525$export$ffd699a207631220(action) {
    const { payload: task } = action;
    const { owner: owner, slug: slug, id: id } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    const authWrapped = (0, $k2cPS.default)((0, $czBtW.default).api.v20.task(owner, slug, id, task.id), {
        method: "DELETE"
    });
    try {
        const response = yield (0, $5NpoY.P)(fetch, authWrapped);
        if (!response.ok) {
            const message = yield (0, $5NpoY.P)((0, $58TOz.getErrorMessage), response.clone());
            throw new Error(message);
        }
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.TASK_DELETE).SUCCESS,
            payload: task
        });
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.TASK_DELETE).ERROR,
            payload: {
                task: task,
                errors: {
                    [(0, $67NwJ.taskKey)(task)]: e.message
                }
            }
        });
    }
}
function* $c01bc6091fba1525$export$2e2bcd8739ae039() {
    yield (0, $jeUNF.takeEvery)((0, $6D21P.TASK_DELETE).REQUEST, $c01bc6091fba1525$export$ffd699a207631220);
}

});

parcelRegister("dkZ38", function(module, exports) {

$parcel$export(module.exports, "editTaskSaga", function () { return $b4b2c5b1fc7386b0$export$5effcd2ce202ef1e; });
$parcel$export(module.exports, "editTasksSaga", function () { return $b4b2c5b1fc7386b0$export$e89c1d2e97bb30a2; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $3XbtU = parcelRequire("3XbtU");
var $i3ov7 = parcelRequire("i3ov7");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $1EkdU = parcelRequire("1EkdU");

var $czBtW = parcelRequire("czBtW");

var $67NwJ = parcelRequire("67NwJ");

var $krSFm = parcelRequire("krSFm");

var $k2cPS = parcelRequire("k2cPS");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $58TOz = parcelRequire("58TOz");
function* $b4b2c5b1fc7386b0$var$saveTaskSaga(task, nextRawContent) {
    const { owner: owner, slug: slug, id: pullRequestId } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    const authWrapped = (0, $k2cPS.default)((0, $czBtW.default).api.v20.task(owner, slug, pullRequestId, task.id), {
        method: "PUT",
        headers: (0, $k2cPS.jsonHeaders),
        body: JSON.stringify({
            content: {
                raw: nextRawContent
            }
        })
    });
    try {
        const response = yield (0, $5NpoY.P)(fetch, authWrapped);
        if (response.ok) {
            // @ts-ignore
            const newTask = yield response.json();
            return {
                task: newTask,
                isError: false
            };
        } else {
            const message = yield (0, $5NpoY.P)((0, $58TOz.getErrorMessage), response.clone());
            throw new Error(message);
        }
    } catch (e) {
        $3XbtU.captureException(e);
        return {
            task: task,
            isError: true,
            errorMessage: e.message
        };
    }
}
function* $b4b2c5b1fc7386b0$export$5effcd2ce202ef1e(action) {
    const { payload: { taskId: taskId, newValue: newValue } } = action;
    // @ts-ignore
    const tasks = yield (0, $5NpoY.a3)((0, $krSFm.getTasks));
    const saveTask = tasks.find((task)=>task.id === taskId);
    const result = yield (0, $5NpoY.P)($b4b2c5b1fc7386b0$var$saveTaskSaga, saveTask, newValue);
    if (!result.isError) yield (0, $5NpoY.Y)({
        type: (0, $6D21P.TASK_EDIT).SUCCESS,
        payload: {
            taskId: taskId,
            newTask: result.task
        }
    });
    else yield (0, $5NpoY.Y)({
        type: (0, $6D21P.TASK_EDIT).ERROR,
        payload: {
            taskId: taskId,
            error: result.errorMessage
        }
    });
}
function* $b4b2c5b1fc7386b0$export$e89c1d2e97bb30a2() {
    while(true){
        const { payload: editTasksFormData } = yield (0, $5NpoY.M)((0, $6D21P.TASKS_EDIT).REQUEST);
        const tasks = yield (0, $5NpoY.a3)((0, $krSFm.getTasks));
        const saveParams = tasks.filter((task)=>editTasksFormData[(0, $67NwJ.taskKey)(task)].trim() !== task.content.raw.trim()).map((task)=>({
                task: task,
                nextRawContent: editTasksFormData[(0, $67NwJ.taskKey)(task)]
            }));
        const saveTaskResults = yield (0, $5NpoY._)(saveParams.map(({ task: task, nextRawContent: nextRawContent })=>$b4b2c5b1fc7386b0$var$saveTaskSaga(task, nextRawContent)));
        const successfulResults = saveTaskResults.filter((result)=>!result.isError);
        const failedResults = saveTaskResults.filter((result)=>result.isError);
        const successPayload = successfulResults.map(({ task: task })=>task);
        const errorPayload = {};
        saveTaskResults.forEach(({ task: task, isError: isError, errorMessage: errorMessage })=>{
            if (isError) // @ts-ignore TODO: fix noImplicitAny error here
            errorPayload[(0, $67NwJ.taskKey)(task)] = errorMessage;
        });
        if (successPayload.length && failedResults.length) // We're making N requests for N edited tasks,
        // and there's no guarantee that requests
        // will either all fail or all succeed.
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.TASKS_EDIT).PARTIAL_SUCCESS,
            payload: {
                updatedTasks: successPayload,
                errors: errorPayload
            }
        });
        else if (successfulResults.length) yield (0, $5NpoY.Y)({
            type: (0, $6D21P.TASKS_EDIT).SUCCESS,
            payload: successPayload
        });
        else if (failedResults.length) yield (0, $5NpoY.Y)({
            type: (0, $6D21P.TASKS_EDIT).ERROR,
            payload: errorPayload
        });
        else {
            // This shouldn't happen because the "save tasks" button is
            // disabled until an edit is made
            $3XbtU.captureMessage(`Tried to save tasks without making changes`, $i3ov7.Severity.Info);
            // Fire a dummy success action to clear loading state
            yield (0, $5NpoY.Y)({
                type: (0, $6D21P.TASKS_EDIT).SUCCESS,
                payload: []
            });
        }
    }
}

});

parcelRegister("h5rrr", function(module, exports) {

$parcel$export(module.exports, "expandContextSaga", function () { return $3a2fd55f1eb9ffbf$export$e38a36a589274539; });

var $a47Nm = parcelRequire("a47Nm");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $axaTk = parcelRequire("axaTk");

var $2kKDW = parcelRequire("2kKDW");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $ecsiI = parcelRequire("ecsiI");

var $k2cPS = parcelRequire("k2cPS");

var $6EIJN = parcelRequire("6EIJN");

var $1EkdU = parcelRequire("1EkdU");

var $czBtW = parcelRequire("czBtW");

var $eAd3n = parcelRequire("eAd3n");

var $3XCf5 = parcelRequire("3XCf5");
function $3a2fd55f1eb9ffbf$export$adb10748e6d26565(contextLines) {
    return contextLines.map((contextLine)=>({
            ...contextLine,
            content: (0, $a47Nm.default)(contextLine.content)
        }));
}
// @ts-ignore TODO: fix noImplicitAny error here
function $3a2fd55f1eb9ffbf$var$getJson(response) {
    return response.status === 200 ? response.json() : Promise.resolve({
        lines: []
    });
}
function* $3a2fd55f1eb9ffbf$export$e38a36a589274539({ payload: payload }) {
    const { filepath: filepath, prevFilepath: prevFilepath, expanderIndex: expanderIndex, shouldExpandDown: shouldExpandDown, selectedDiffSourceHash: selectedDiffSourceHash, selectedDiffDestHash: selectedDiffDestHash } = payload;
    const diffs = yield (0, $5NpoY.a3)((0, $1EkdU.getAllDiffFiles));
    const indexFromFullDiff = diffs.findIndex((diff)=>(0, $ecsiI.getDiffPath)(diff) === filepath);
    const file = diffs[indexFromFullDiff];
    const { chunks: chunks } = file;
    const { owner: owner, slug: repoSlug } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    const destinationHash = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestDestinationHash));
    const sourceHash = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestSourceHash));
    const topicDiffType = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestDiffType));
    const topicDiff = topicDiffType === (0, $axaTk.DiffType).TOPIC_DIFF;
    const contextData = topicDiff ? (0, $3XCf5.getContextDataTopicDiff)(chunks, expanderIndex, shouldExpandDown) : (0, $3XCf5.getContextData)(chunks, expanderIndex, shouldExpandDown);
    const buildContextUrl = (contextDatum)=>topicDiff ? (0, $czBtW.default).api.internal.contextFromSrcTopicDiff({
            owner: // lookup the source hash in the destination repo
            // to avoid issues with repo permissions
            owner,
            slug: repoSlug,
            sourceHash: selectedDiffSourceHash || sourceHash,
            filepath: filepath
        }, contextDatum.lineNums) : (0, $czBtW.default).api.internal.contextFromSrcPreviewMerge({
            owner: owner,
            slug: repoSlug,
            destinationHash: selectedDiffDestHash || destinationHash,
            filepath: prevFilepath || filepath
        }, contextDatum.lineNums);
    // @ts-ignore TODO: fix noImplicitAny error here
    function putSuccess(json) {
        const lines = json.data && (0, $3XCf5.parseSrcApiLines)(json.data) || [];
        const { chunkId: chunkId, beforeOrAfter: beforeOrAfter } = contextData;
        const lineNums = contextData.lineNums;
        const convertedJson = (0, $eAd3n.convertToChunksFormat)(lines, lineNums);
        convertedJson.contextLines = $3a2fd55f1eb9ffbf$export$adb10748e6d26565(convertedJson.contextLines);
        return (0, $5NpoY.Y)({
            type: (0, $6D21P.EXPAND_CONTEXT).SUCCESS,
            payload: {
                ...convertedJson,
                fileIndex: indexFromFullDiff,
                chunkId: chunkId,
                beforeOrAfter: beforeOrAfter
            }
        });
    }
    try {
        try {
            (0, $6EIJN.validateContextLineRanges)(contextData.lineNums);
        } catch (e) {
        // Only logging these in Sentry for now
        }
        const url = buildContextUrl(contextData);
        const response = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (response.ok) {
            // @ts-ignore
            const jsonObjects = yield $3a2fd55f1eb9ffbf$var$getJson(response);
            yield putSuccess(jsonObjects);
        } else if (response.status === 403 || response.status === 404) {
            yield (0, $5NpoY.Y)((0, $2kKDW.showFlagComponent)("load-context-forbidden-not-found"));
            yield (0, $5NpoY.Y)({
                type: (0, $6D21P.EXPAND_CONTEXT).ERROR,
                payload: {
                    fileIndex: indexFromFullDiff
                },
                error: true
            });
        } else {
            yield (0, $5NpoY.Y)((0, $2kKDW.showFlagComponent)("load-context-error"));
            yield (0, $5NpoY.Y)({
                type: (0, $6D21P.EXPAND_CONTEXT).ERROR,
                payload: {
                    fileIndex: indexFromFullDiff
                },
                error: true
            });
        }
    } catch (error) {
        yield (0, $5NpoY.Y)((0, $2kKDW.showFlagComponent)("load-context-error"));
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.EXPAND_CONTEXT).ERROR,
            payload: {
                message: error.message,
                fileIndex: indexFromFullDiff
            },
            error: true
        });
    }
}

});
parcelRegister("a47Nm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $754053101298290d$export$2e2bcd8739ae039; });

var $aV88P = parcelRequire("aV88P");

var $1rnkM = parcelRequire("1rnkM");
/** Used to match HTML entities and HTML characters. */ var $754053101298290d$var$reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, $754053101298290d$var$reHasEscapedHtml = RegExp($754053101298290d$var$reEscapedHtml.source);
/**
 * The inverse of `_.escape`; this method converts the HTML entities
 * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
 * their corresponding characters.
 *
 * **Note:** No other HTML entities are unescaped. To unescape additional
 * HTML entities use a third-party library like [_he_](https://mths.be/he).
 *
 * @static
 * @memberOf _
 * @since 0.6.0
 * @category String
 * @param {string} [string=''] The string to unescape.
 * @returns {string} Returns the unescaped string.
 * @example
 *
 * _.unescape('fred, barney, &amp; pebbles');
 * // => 'fred, barney, & pebbles'
 */ function $754053101298290d$var$unescape(string) {
    string = (0, $aV88P.default)(string);
    return string && $754053101298290d$var$reHasEscapedHtml.test(string) ? string.replace($754053101298290d$var$reEscapedHtml, (0, $1rnkM.default)) : string;
}
var $754053101298290d$export$2e2bcd8739ae039 = $754053101298290d$var$unescape;

});
parcelRegister("1rnkM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10ca69b727ba0e63$export$2e2bcd8739ae039; });

var $io4qF = parcelRequire("io4qF");
/** Used to map HTML entities to characters. */ var $10ca69b727ba0e63$var$htmlUnescapes = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#39;": "'"
};
/**
 * Used by `_.unescape` to convert HTML entities to characters.
 *
 * @private
 * @param {string} chr The matched character to unescape.
 * @returns {string} Returns the unescaped character.
 */ var $10ca69b727ba0e63$var$unescapeHtmlChar = (0, $io4qF.default)($10ca69b727ba0e63$var$htmlUnescapes);
var $10ca69b727ba0e63$export$2e2bcd8739ae039 = $10ca69b727ba0e63$var$unescapeHtmlChar;

});
parcelRegister("io4qF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d62de76649590fd1$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $d62de76649590fd1$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
var $d62de76649590fd1$export$2e2bcd8739ae039 = $d62de76649590fd1$var$basePropertyOf;

});



parcelRegister("eAd3n", function(module, exports) {

$parcel$export(module.exports, "convertToChunksFormat", function () { return $d809c0807c1e53b3$export$d3d5c0e8c3f1ff42; });
/**
 * Convert incoming context lines to match the format
 * of the existing diff chunks. Also flags if there are
 * more lines of content available.
 */ 
var $3XCf5 = parcelRequire("3XCf5");
// @ts-ignore TODO: fix noImplicitAny error here
function $d809c0807c1e53b3$var$formatLine(line) {
    return {
        normal: true,
        // Context lines are always 'normal'
        type: "normal",
        oldLine: line.from_line,
        newLine: line.to_line,
        content: line.content
    };
}
function $d809c0807c1e53b3$export$d3d5c0e8c3f1ff42(originalContextLines, lineNums) {
    const converted = {
        hasMoreLines: true,
        contextLines: []
    };
    if (!Array.isArray(originalContextLines) || !originalContextLines.length) {
        converted.hasMoreLines = false;
        return converted;
    }
    const { startingFrom: startingFrom, startingTo: startingTo, endingFrom: endingFrom, endingTo: endingTo } = lineNums;
    const fromLineNumbers = (0, $3XCf5.buildLineNumbers)(originalContextLines.length, startingFrom);
    const toLineNumbers = (0, $3XCf5.buildLineNumbers)(originalContextLines.length, startingTo);
    // there is no indication of whether there is more content so we check here
    let expectedNumLines;
    if (endingTo !== undefined) expectedNumLines = endingTo - startingTo + 1;
    else if (endingFrom !== undefined) expectedNumLines = endingFrom - startingFrom + 1;
    if (originalContextLines.length !== expectedNumLines || startingFrom === 0) converted.hasMoreLines = false;
    const contextLines = originalContextLines.map((value, index)=>{
        return {
            content: ` ${value}`,
            // diff content starts with +, - or ' '
            from_line: fromLineNumbers[index],
            to_line: toLineNumbers[index]
        };
    });
    converted.contextLines = contextLines.map($d809c0807c1e53b3$var$formatLine);
    return converted;
}

});


parcelRegister("gLU6V", function(module, exports) {

$parcel$export(module.exports, "publishBasePullRequestFactSaga", function () { return $717b983bd7f35867$export$cfd2b8e4e6aebe85; });
$parcel$export(module.exports, "publishPullRequestDiffFactSaga", function () { return $717b983bd7f35867$export$97daee57ccb943e1; });

var $lIZwG = parcelRequire("lIZwG");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("3hzea");
var $a5HLv = parcelRequire("a5HLv");

var $1EkdU = parcelRequire("1EkdU");

var $io3dF = parcelRequire("io3dF");

var $6aoKW = parcelRequire("6aoKW");
function* $717b983bd7f35867$var$getBasePullRequestFactData() {
    const pullRequestId = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestId));
    const sourceRepo = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestSourceRepo));
    const destRepo = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestDestinationRepo));
    // With a pull request, it's possible for source repos to have
    // been deleted, but not destination repos.
    if (!destRepo) return null;
    return {
        from_repository_uuid: (0, $a5HLv.uncurlyUuid)((0, $lIZwG.default)(sourceRepo, "uuid", "")),
        pull_request_id: pullRequestId,
        to_repository_uuid: (0, $a5HLv.uncurlyUuid)(destRepo.uuid),
        to_repository_owner_uuid: (0, $a5HLv.uncurlyUuid)((0, $lIZwG.default)(destRepo, "owner.uuid", null))
    };
}
function* $717b983bd7f35867$var$makePullRequestBaseFact(action) {
    if (!action || !action.payload) return null;
    const eventName = action.payload.name;
    if (!eventName) return null;
    // @ts-ignore
    const prFactData = yield $717b983bd7f35867$var$getBasePullRequestFactData();
    if (!prFactData) return null;
    const factData = {
        ...prFactData,
        ...action.payload.extraFactData
    };
    return new (0, $io3dF.PullRequestFact)(eventName, factData);
}
function* $717b983bd7f35867$export$cfd2b8e4e6aebe85(action) {
    // @ts-ignore
    const fact = yield $717b983bd7f35867$var$makePullRequestBaseFact(action);
    if (!fact) return;
    yield (0, $5NpoY.P)((0, $6aoKW.publishFact), fact);
}
function* $717b983bd7f35867$export$97daee57ccb943e1(action) {
    // @ts-ignore
    const fact = yield $717b983bd7f35867$var$makePullRequestBaseFact(action);
    if (!fact) return;
    // @ts-ignore
    fact.data.number_of_diff_lines = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestDiffLinesCount));
    // @ts-ignore
    fact.data.number_of_files = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestDiffFileCount));
    yield (0, $5NpoY.P)((0, $6aoKW.publishFact), fact);
}

});
parcelRegister("io3dF", function(module, exports) {

$parcel$export(module.exports, "PullRequestFact", function () { return $e28a4ccf24173e9d$export$350d618303e40bb0; });
parcelRequire("3hzea");
var $6E7t8 = parcelRequire("6E7t8");
class $e28a4ccf24173e9d$export$350d618303e40bb0 extends (0, $6E7t8.default) {
    constructor(name, factProperties){
        super({
            ...factProperties,
            // @ts-ignore
            frontbucket_view: true
        });
        this.name = name;
    }
}

});


parcelRegister("7pCcb", function(module, exports) {

$parcel$export(module.exports, "fetchActivityFeed", function () { return $68659b0d6a240313$export$967c92ed76f908b6; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $3XbtU = parcelRequire("3XbtU");
var $i3ov7 = parcelRequire("i3ov7");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $1EkdU = parcelRequire("1EkdU");

var $czBtW = parcelRequire("czBtW");

var $g8glp = parcelRequire("g8glp");

var $14kRW = parcelRequire("14kRW");
function* $68659b0d6a240313$export$24f2582553220329(url) {
    if (!url) return;
    const api = yield* (0, $g8glp.getPullRequestApis)();
    try {
        // @ts-ignore
        const response = yield (0, $5NpoY.P)(api.getActivity, url);
        yield (0, $5NpoY.Y)({
            type: (0, $14kRW.FETCH_ACTIVITY).SUCCESS,
            payload: {
                activityEvents: response.values,
                nextUrl: response.next || null
            }
        });
        yield* $68659b0d6a240313$export$24f2582553220329(response.next);
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $14kRW.FETCH_ACTIVITY).ERROR,
            payload: e.message
        });
    }
}
function* $68659b0d6a240313$export$967c92ed76f908b6(pieces) {
    const hasPieces = pieces && pieces.owner && pieces.slug && pieces.id;
    const { owner: owner, slug: slug, id: id } = hasPieces ? pieces : yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    if (!owner || !slug || !id) {
        $3XbtU.captureMessage(`Tried to fetch activity feed but lacked something ${JSON.stringify({
            owner: owner,
            slug: slug,
            id: id
        })}`, $i3ov7.Severity.Info);
        return;
    }
    const activityFirstPageUrl = (0, $czBtW.default).api.internal.activity({
        owner: owner,
        slug: slug,
        id: id
    });
    yield* $68659b0d6a240313$export$24f2582553220329(activityFirstPageUrl);
}

});

parcelRegister("aAhXh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f39f0998ddaffef6$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $1EkdU = parcelRequire("1EkdU");

var $1WShj = parcelRequire("1WShj");

var $k2cPS = parcelRequire("k2cPS");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $eCTLi = parcelRequire("eCTLi");

var $aBXBT = parcelRequire("aBXBT");
function* $f39f0998ddaffef6$export$c733153e2160bfe1(commitHash) {
    const { owner: owner, slug: slug } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    const url = `${(0, $eCTLi.annotationsBaseUrl)("2.0")}/repositories/${owner}/${slug}/commit/${commitHash}` + `/reports?page=1&pagelen=${0, $1WShj.CODE_INSIGHTS_REPORTS_PAGE_SIZE}`;
    try {
        let reports = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        // @ts-ignore
        reports = (yield reports.json()).values;
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.FETCH_CODE_INSIGHTS_REPORTS).SUCCESS,
            payload: reports || []
        });
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.FETCH_CODE_INSIGHTS_REPORTS).ERROR,
            payload: e.message
        });
    }
}
function* $f39f0998ddaffef6$export$6d6d84c2e2b2d4bd(commitHash, reportId) {
    const { owner: owner, slug: slug } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    const url = `${(0, $eCTLi.annotationsBaseUrl)("2.0")}/repositories/${owner}/${slug}/commit/${commitHash}` + `/reports/${reportId}/annotations?sort=-severity&page=1`;
    try {
        const annotations = yield (0, $5NpoY.P)((0, $aBXBT.fetchAllPages), url, (0, $1WShj.CODE_INSIGHTS_ANNOTATIONS_PAGE_SIZE));
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.FETCH_CODE_INSIGHTS_ANNOTATIONS).SUCCESS,
            meta: {
                reportId: reportId
            },
            payload: annotations || []
        });
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.FETCH_CODE_INSIGHTS_ANNOTATIONS).ERROR,
            payload: e.message
        });
    }
}
function* $f39f0998ddaffef6$export$56dbb9612822529() {
    try {
        const commitHash = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestSourceHash));
        yield (0, $5NpoY.P)($f39f0998ddaffef6$export$c733153e2160bfe1, commitHash);
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.FETCH_CODE_INSIGHTS_REPORTS).ERROR,
            payload: e.message
        });
    }
}
function* $f39f0998ddaffef6$export$5dbbf042aa9398e7(action) {
    const commitHash = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestSourceHash));
    yield (0, $5NpoY.P)($f39f0998ddaffef6$export$6d6d84c2e2b2d4bd, commitHash, action.payload);
}
function* $f39f0998ddaffef6$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLatest)((0, $6D21P.FETCH_CODE_INSIGHTS_REPORTS).REQUEST, $f39f0998ddaffef6$export$56dbb9612822529),
        (0, $jeUNF.takeLatest)((0, $6D21P.FETCH_CODE_INSIGHTS_ANNOTATIONS).REQUEST, $f39f0998ddaffef6$export$5dbbf042aa9398e7)
    ]);
}

});
parcelRegister("1WShj", function(module, exports) {

$parcel$export(module.exports, "CODE_INSIGHTS_REPORTS_PAGE_SIZE", function () { return $90b1529a9a126891$export$5dfe4ac62482dec4; });
$parcel$export(module.exports, "CODE_INSIGHTS_ANNOTATIONS_PAGE_SIZE", function () { return $90b1529a9a126891$export$788ff84cc55c7fec; });
const $90b1529a9a126891$export$5dfe4ac62482dec4 = 10;
const $90b1529a9a126891$export$788ff84cc55c7fec = 100;

});

parcelRegister("eCTLi", function(module, exports) {

$parcel$export(module.exports, "annotationsBaseUrl", function () { return $60e9c43c798d44b7$export$43f37aab14740d3a; });

var $6Tn56 = parcelRequire("6Tn56");
const $60e9c43c798d44b7$export$43f37aab14740d3a = (prodSuffix)=>{
    const urlBase = "/!api";
    return (0, $6Tn56.getBbEnv)() === (0, $6Tn56.BbEnv).Production ? `${urlBase}/${prodSuffix}` : `${urlBase}/internal/pipelines/stg-west/internal`;
};

});


parcelRegister("cBYtK", function(module, exports) {

$parcel$export(module.exports, "fetchOutdatedCommentContext", function () { return $193e75ad71f33c47$export$5f0ac343e06d523b; });
$parcel$export(module.exports, "fetchCommentContext", function () { return $193e75ad71f33c47$export$222983671433a2f3; });
$parcel$export(module.exports, "fetchPendingCommentContext", function () { return $193e75ad71f33c47$export$ae2006d93dc187ab; });
$parcel$export(module.exports, "fetchBaseRevCommentContext", function () { return $193e75ad71f33c47$export$a50cd8a70f3e8e2; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $3efkv = parcelRequire("3efkv");

var $1EkdU = parcelRequire("1EkdU");

var $cCrBH = parcelRequire("cCrBH");
function $193e75ad71f33c47$var$createFetchCommentContextSaga(action, conversationsSelector) {
    return function*(getCommentById) {
        while(true)try {
            const { payload: payload } = yield (0, $5NpoY.M)(action.REQUEST);
            const { owner: owner, slug: slug, id: id } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
            // `payload` will be undefined when fetching pending comments since we're fetching
            // all conversations with pending comments, not just conversations for a particular
            // file like we do in the outdated comment dialog.
            const conversations = yield (0, $5NpoY.a3)(conversationsSelector, payload === null || payload === void 0 ? void 0 : payload.file);
            const conversationsWithoutContext = conversations.filter((c)=>{
                return c.meta && c.meta.context_lines === undefined;
            });
            // If none need updating then bail out
            if (conversationsWithoutContext.length === 0) {
                // Trigger success action to update loading state to false
                yield (0, $5NpoY.Y)({
                    type: action.SUCCESS
                });
                continue;
            }
            // @ts-ignore
            const contextsResults = yield (0, $5NpoY._)(// @ts-ignore
            conversationsWithoutContext.map((c)=>(0, $5NpoY.P)(getCommentById, owner, slug, id, (0, $3efkv.parseId)(c))));
            // @ts-ignore TODO: fix noImplicitAny error here
            const contexts = contextsResults.map((cr)=>{
                if ("status" in cr) return {
                    inline: {
                        context_lines: ""
                    }
                };
                else return cr;
            });
            const updatedConversations = conversationsWithoutContext.map(// @ts-ignore TODO: fix noImplicitAny error here
            (cv, i)=>({
                    ...cv,
                    meta: {
                        ...cv.meta,
                        context_lines: contexts[i].inline.context_lines
                    }
                }));
            yield (0, $5NpoY.Y)({
                type: action.SUCCESS,
                payload: updatedConversations
            });
        } catch (e) {
        // do nothing
        }
    };
}
const $193e75ad71f33c47$export$5f0ac343e06d523b = $193e75ad71f33c47$var$createFetchCommentContextSaga((0, $6D21P.FETCH_OUTDATED_COMMENT_CONTEXT), (0, $cCrBH.getOutdatedConversationsForFile));
const $193e75ad71f33c47$export$222983671433a2f3 = $193e75ad71f33c47$var$createFetchCommentContextSaga((0, $6D21P.FETCH_LARGE_FILE_COMMENT_CONTEXT), (0, $cCrBH.getAllConversationsForFile));
const $193e75ad71f33c47$export$ae2006d93dc187ab = $193e75ad71f33c47$var$createFetchCommentContextSaga((0, $6D21P.FETCH_PENDING_COMMENT_CONTEXT), (0, $cCrBH.getPendingInlineConversations));
const $193e75ad71f33c47$export$a50cd8a70f3e8e2 = $193e75ad71f33c47$var$createFetchCommentContextSaga((0, $6D21P.FETCH_BASE_REV_COMMENT_CONTEXT), (0, $cCrBH.getBaseRevConversationsForFile));

});
parcelRegister("3efkv", function(module, exports) {

$parcel$export(module.exports, "parseId", function () { return $547918527d700382$export$bf3b66d897b985f1; });
const $547918527d700382$export$bf3b66d897b985f1 = (c)=>c.conversationId.replace("conversation-", "");

});


parcelRegister("i1nwo", function(module, exports) {

$parcel$export(module.exports, "fetchCommentLikes", function () { return $ac794915219653d6$export$4f42383f43179b60; });

var $3XbtU = parcelRequire("3XbtU");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $b2RHC = parcelRequire("b2RHC");

var $czBtW = parcelRequire("czBtW");

var $g8glp = parcelRequire("g8glp");

var $1EkdU = parcelRequire("1EkdU");
function* $ac794915219653d6$export$dc6d76f9c9e0e942(url) {
    if (!url) return;
    const api = yield* (0, $g8glp.getPullRequestApis)();
    try {
        const response = yield (0, $5NpoY.P)(api.getCommentLikes, url);
        const commentLikes = response.values.map((clEntry)=>({
                commentId: clEntry.comment_id,
                users: clEntry.users
            }));
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.FETCH_COMMENT_LIKES).SUCCESS,
            payload: {
                commentLikes: commentLikes
            },
            meta: {
                schema: {
                    commentLikes: [
                        (0, $b2RHC.commentLikes)
                    ]
                }
            }
        });
        yield* $ac794915219653d6$export$dc6d76f9c9e0e942(response.next);
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.FETCH_COMMENT_LIKES).ERROR
        });
    }
}
function* $ac794915219653d6$export$4f42383f43179b60() {
    const { owner: owner, slug: slug, id: id } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    if (!owner || !slug || !id) {
        $3XbtU.captureMessage(`Tried to fetch comment likes but lacked something ${JSON.stringify({
            owner: owner,
            slug: slug,
            id: id
        })}`);
        return;
    }
    const commentLikesFirstPageUrl = (0, $czBtW.default).api.internal.commentLikes(owner, slug, id);
    yield* $ac794915219653d6$export$dc6d76f9c9e0e942(commentLikesFirstPageUrl);
}

});

parcelRegister("fTGX3", function(module, exports) {

$parcel$export(module.exports, "fetchCommitsStatusesSaga", function () { return $c969112dfdfc94b6$export$c3adbf3d6d8f1e2d; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $3XbtU = parcelRequire("3XbtU");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $b2RHC = parcelRequire("b2RHC");

var $8Ao0D = parcelRequire("8Ao0D");

var $lkmX7 = parcelRequire("lkmX7");

var $f8qFH = parcelRequire("f8qFH");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");

var $aanBq = parcelRequire("aanBq");

var $4oBYE = parcelRequire("4oBYE");

var $k2cPS = parcelRequire("k2cPS");
const $c969112dfdfc94b6$export$72e3afa9ac8966be = (fullName, commits)=>{
    const url = (0, $4oBYE.default).api.internal.commitsBuildStatuses(fullName);
    return (0, $k2cPS.default)(url, {
        method: "POST",
        body: commits.map((commit)=>`commits=${commit.hash}`).join("&"),
        headers: {
            "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
    });
};
function* $c969112dfdfc94b6$export$c3adbf3d6d8f1e2d() {
    const { commits: commits } = yield (0, $5NpoY.a3)((0, $lkmX7.getRepoCommitsState));
    if (!commits || !commits.length) return;
    let repository = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    if (!repository) {
        yield (0, $5NpoY.M)((0, $jJd6W.LoadRepositoryPage).SUCCESS);
        repository = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    }
    const { full_name: fullName } = repository;
    try {
        const request = $c969112dfdfc94b6$export$72e3afa9ac8966be(fullName, commits);
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            // @ts-ignore
            const statuses = yield response.json();
            // Statuses is a dictionary mapping commit SHAs to statuses
            if (Object.keys(statuses).length === 0) return;
            const addStatus = (0, $f8qFH.createCommitStatusMapper)(statuses);
            yield (0, $5NpoY.Y)({
                type: (0, $8Ao0D.PR_UPDATE_COMMITS_STATUS).SUCCESS,
                payload: commits.map(addStatus),
                meta: {
                    schema: [
                        (0, $b2RHC.commit)
                    ]
                }
            });
        }
    } catch (e) {
        $3XbtU.captureException(e);
    }
}

});
parcelRegister("f8qFH", function(module, exports) {

$parcel$export(module.exports, "createCommitStatusMapper", function () { return $1217196a6079b098$export$39a4509fe32a0ce1; });

var $26wAJ = parcelRequire("26wAJ");
function $1217196a6079b098$export$39a4509fe32a0ce1(statuses) {
    return (commit)=>{
        const status = statuses[(0, $26wAJ.short12Hash)(commit.hash)];
        return {
            ...commit,
            extra: {
                ...commit.extra,
                builds: status ? [
                    status.commit_status
                ] : [],
                status_counts: status ? status.status_counts : undefined
            }
        };
    };
}

});


parcelRegister("63mqJ", function(module, exports) {

$parcel$export(module.exports, "viewEntireDiffFileSaga", function () { return $2a4d88163b20f79b$export$58a66fe9e71e1cd9; });
$parcel$export(module.exports, "fetchDiffByCompareSpecSaga", function () { return $2a4d88163b20f79b$export$c75129a554f683e4; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("ffOxH");
var $kSAPO = parcelRequire("kSAPO");

var $7oXTo = parcelRequire("7oXTo");

var $i2O3k = parcelRequire("i2O3k");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $gLU6V = parcelRequire("gLU6V");

var $1EkdU = parcelRequire("1EkdU");

var $g8glp = parcelRequire("g8glp");

var $K8Ikq = parcelRequire("K8Ikq");

var $7Yccf = parcelRequire("7Yccf");

var $8mswv = parcelRequire("8mswv");
const $2a4d88163b20f79b$var$FALLBACK_CONTEXT_LINE_COUNT = 2000; // used in unexpected case where rendering limit values aren't available in Redux
function* $2a4d88163b20f79b$var$publishDiffsFetchedFact() {
    let timings = (0, $7oXTo.getResourceTimings)("/diff?");
    if (!timings.present) timings = (0, $7oXTo.getResourceTimings)("/diff/");
    const diffsFetchedFactAction = {
        type: (0, $6D21P.PUBLISH_BASE_PULL_REQUEST_FACT),
        payload: {
            name: "bitbucket.pullrequests.diffs.fetched",
            extraFactData: {
                encoded_body_size: timings.encodedBodySize,
                request_waiting_time: timings.requestWaitingTime,
                response_duration: timings.responseDuration,
                total_fetch_duration: Math.floor(timings.duration) || null,
                transfer_size: timings.transferSize
            }
        }
    };
    yield (0, $5NpoY.a1)((0, $gLU6V.publishBasePullRequestFactSaga), diffsFetchedFactAction);
}
function* $2a4d88163b20f79b$var$publishDiffsParsedFact() {
    const diffsParsedFactAction = {
        type: (0, $6D21P.PUBLISH_PULL_REQUEST_DIFF_FACT),
        payload: {
            name: "bitbucket.pullrequests.diffs.parsed"
        }
    };
    yield (0, $5NpoY.a1)((0, $gLU6V.publishPullRequestDiffFactSaga), diffsParsedFactAction);
}

function* $2a4d88163b20f79b$var$diffWorkerLazyImport() {
    const importPromise = new Promise((resolve)=>(parcelRequire("aen6S")).then((module)=>resolve(module.default)));
    const awaitPromise = ()=>Promise.resolve(importPromise);
    // @ts-ignore
    return yield (0, $5NpoY.P)(awaitPromise);
}
function* $2a4d88163b20f79b$export$2a63c539056c61b4(url, action, options = {}) {
    try {
        const api = yield* (0, $g8glp.getPullRequestApis)();
        yield (0, $5NpoY.Y)({
            type: action.REQUEST
        });
        const { diff: diff } = yield (0, $5NpoY.P)(api.getDiff, url);
        if (options.collectDiffFetchedAnalytics) yield options.collectDiffFetchedAnalytics();
        const isWordDiffEnabled = yield (0, $5NpoY.a3)((0, $i2O3k.getGlobalIsWordDiffEnabled));
        // @ts-ignore
        const WordDiffWorker = yield (0, $5NpoY.P)($2a4d88163b20f79b$var$diffWorkerLazyImport);
        const worker = WordDiffWorker();
        let processedDiffs = yield (0, $5NpoY.P)(worker.processDiff, diff, {
            isWordDiffEnabled: isWordDiffEnabled
        });
        if (options.postProcessDiff) processedDiffs = options.postProcessDiff(processedDiffs);
        const renderingLimits = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestRenderingLimits));
        const globalIsSingleFileModeEnabled = yield (0, $5NpoY.a3)((0, $i2O3k.getGlobalIsSingleFileModeEnabled));
        const isSingleFileModeThresholdMet = (0, $K8Ikq.shouldTriggerSingleFileMode)(processedDiffs, renderingLimits);
        if (isSingleFileModeThresholdMet) yield (0, $5NpoY.Y)({
            type: (0, $6D21P.TOGGLE_SINGLE_FILE_MODE_ELIGIBILITY),
            payload: true
        });
        const isSingleFileModeActive = yield (0, $5NpoY.a3)((0, $1EkdU.getIsSingleFileModeActive));
        if (!isSingleFileModeActive && (isSingleFileModeThresholdMet || globalIsSingleFileModeEnabled)) yield (0, $5NpoY.Y)({
            type: (0, $6D21P.TOGGLE_SINGLE_FILE_MODE),
            payload: true
        });
        // Diff success should be posted after single file mode status is posted,
        // so that the initial diff is rendered in the correct mode.
        yield (0, $5NpoY.Y)({
            type: action.SUCCESS,
            payload: processedDiffs
        });
        if (options.collectDiffParsedAnalytics) yield options.collectDiffParsedAnalytics();
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: action.ERROR,
            payload: e.status
        });
    }
}
function* $2a4d88163b20f79b$export$736a50d09d2bdeac(url) {
    yield (0, $5NpoY.P)($2a4d88163b20f79b$export$2a63c539056c61b4, url, (0, $6D21P.FETCH_DIFF), {
        collectDiffFetchedAnalytics: $2a4d88163b20f79b$var$publishDiffsFetchedFact,
        collectDiffParsedAnalytics: $2a4d88163b20f79b$var$publishDiffsParsedFact
    });
}
function* $2a4d88163b20f79b$export$58a66fe9e71e1cd9(action) {
    const { path: path, url: url, topicDiff: topicDiff } = action.payload;
    const renderingLimits = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestRenderingLimits));
    const isSingleFileModeActive = yield (0, $5NpoY.a3)((0, $1EkdU.getIsSingleFileModeActive));
    if (!url) return;
    const ignoreWhitespace = yield (0, $5NpoY.a3)((0, $i2O3k.getGlobalShouldIgnoreWhitespace));
    // Only fetch up to our current per-file limit, because we won't be rendering the content
    // if the file is larger than this
    const { lineLimit: contextLineCount } = renderingLimits ? (0, $K8Ikq.getEffectivePerFileLimits)(isSingleFileModeActive, renderingLimits) : {
        lineLimit: $2a4d88163b20f79b$var$FALLBACK_CONTEXT_LINE_COUNT
    };
    const urlWithParams = (0, $7Yccf.addQueryParams)(url, {
        context: contextLineCount,
        ignore_whitespace: ignoreWhitespace,
        topic: topicDiff ? true : null,
        path: path
    });
    yield (0, $5NpoY.P)($2a4d88163b20f79b$export$2a63c539056c61b4, urlWithParams, (0, $8mswv.FetchEntireFile), {
        // We set MAX_CONTEXT_EXPANSION high enough so that it's almost impossible that the entire file
        // won't be rendered in a single chunk, so we shouldn't render the context expansion buttons at the
        // top or bottom. We're OK with this behavior being "wrong" for enormous files, because we don't
        // render files that would be large enough to run into that situation (we render a placeholder
        // message instead).
        postProcessDiff: (0, $kSAPO.clearContextExpansions)
    });
}
function* $2a4d88163b20f79b$export$c75129a554f683e4() {
    const ignoreWhitespace = yield (0, $5NpoY.a3)((0, $i2O3k.getGlobalShouldIgnoreWhitespace));
    const topicDiff = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestInTopicDiffMode));
    const serverGeneratedDiffUrl = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestCompareSpecDiffUrl));
    // Only run saga for PR page diffs
    if (serverGeneratedDiffUrl === undefined) return;
    const url = (0, $7Yccf.addQueryParams)(serverGeneratedDiffUrl, (0, $7Yccf.normalizeDiffParams)({
        topicDiff: topicDiff,
        ignoreWhitespace: ignoreWhitespace
    }));
    yield (0, $5NpoY.P)($2a4d88163b20f79b$export$736a50d09d2bdeac, url);
}

});
parcelRegister("ffOxH", function(module, exports) {
$parcel$export(module.exports, "clearContextExpansions", function () { return (parcelRequire("kSAPO")).clearContextExpansions; });
parcelRequire("kSAPO");

});
parcelRegister("kSAPO", function(module, exports) {

$parcel$export(module.exports, "clearContextExpansions", function () { return $d3ea2e1a59ca3451$export$56b19388f69da681; });
function $d3ea2e1a59ca3451$var$amendChunk(chunk, index) {
    const isFirstChunk = index === 0;
    const { changes: changes } = chunk;
    const extra = {
        isLoadingBelow: false,
        isLoadingAbove: false,
        before: {
            hasMoreLines: true
        },
        after: {
            hasMoreLines: true
        }
    };
    if (isFirstChunk) {
        const firstChange = changes[0];
        const isLineOne = firstChange.oldLine === 1 || firstChange.newLine === 1;
        extra.before.hasMoreLines = !isLineOne;
        // check for added or deleted files
        extra.after.hasMoreLines = !(chunk.oldLines === 0 || chunk.newLines === 0);
    }
    return {
        ...chunk,
        id: chunk.content,
        extra: extra
    };
}
function $d3ea2e1a59ca3451$export$4bc02934d9e00439(diffs) {
    return diffs.map((diff)=>({
            ...diff,
            chunks: diff.chunks.map($d3ea2e1a59ca3451$var$amendChunk)
        }));
}
function $d3ea2e1a59ca3451$var$clearContextExpansion(chunk) {
    return {
        ...chunk,
        extra: {
            ...chunk.extra,
            after: {
                hasMoreLines: false
            },
            before: {
                hasMoreLines: false
            }
        }
    };
}
function $d3ea2e1a59ca3451$export$56b19388f69da681(diffs) {
    return diffs.map((diff)=>({
            ...diff,
            chunks: diff.chunks.map($d3ea2e1a59ca3451$var$clearContextExpansion)
        }));
}

});


parcelRegister("7oXTo", function(module, exports) {

$parcel$export(module.exports, "getResourceTimings", function () { return $84ae2ad3ba573af5$export$9eebb59359c2e9e5; });
/**
 * Find last instance in an array that satisfies the given predicate
 */ // @ts-ignore TODO: fix noImplicitAny error here
function $84ae2ad3ba573af5$var$findLast(array, predicate) {
    for(let i = array.length - 1; i >= 0; i--){
        if (predicate(array[i])) return array[i];
    }
    return null;
}
function $84ae2ad3ba573af5$export$9eebb59359c2e9e5(urlSubstring) {
    const emptyTimings = {
        transferSize: -1,
        duration: -1,
        responseDuration: -1,
        requestWaitingTime: -1,
        encodedBodySize: -1,
        present: false
    };
    if (!window.performance || typeof window.performance.getEntriesByType !== "function") return emptyTimings;
    const resources = window.performance.getEntriesByType("resource");
    // @ts-ignore TODO: fix noImplicitAny error here
    const timings = $84ae2ad3ba573af5$var$findLast(resources, (r)=>r.name.includes(urlSubstring));
    if (!timings) return emptyTimings;
    timings.present = true;
    timings.requestWaitingTime = Math.ceil(timings.responseStart - timings.requestStart);
    timings.responseDuration = Math.ceil(timings.responseEnd - timings.responseStart);
    return timings;
}

});

parcelRegister("aen6S", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("dRLzG")).then(()=>parcelRequire("9cB35"));

});


parcelRegister("gzGkQ", function(module, exports) {

$parcel$export(module.exports, "fetchDiffStatForCurrentPullRequest", function () { return $58602268f8adbc66$export$d42d171c21ea0aaa; });
$parcel$export(module.exports, "fetchDiffStatByCompareSpecSaga", function () { return $58602268f8adbc66$export$1f34053b3afa76f1; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $i2O3k = parcelRequire("i2O3k");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $czBtW = parcelRequire("czBtW");

var $g8glp = parcelRequire("g8glp");

var $aanBq = parcelRequire("aanBq");

var $1EkdU = parcelRequire("1EkdU");

var $7Yccf = parcelRequire("7Yccf");
function* $58602268f8adbc66$export$9e6be4299244a19c(url, // If maxPages is undefined, fetch all pages, otherwise return only the number of pages specified
maxPages, values = [], isFirstFetch = true) {
    try {
        if (isFirstFetch) yield (0, $5NpoY.Y)({
            type: (0, $6D21P.LOAD_DIFFSTAT).REQUEST
        });
        const api = yield* (0, $g8glp.getPullRequestApis)();
        // @ts-ignore
        const diffStat = yield (0, $5NpoY.P)(api.getDiffStat, url);
        const newValues = diffStat.values;
        values.push(...newValues);
        const pagesLeft = maxPages === undefined ? undefined : maxPages - 1;
        const fetchMore = (pagesLeft !== null && pagesLeft !== void 0 ? pagesLeft : 1) > 0;
        // Diffstat is paginated.  Auto fetch the rest of diffstat data
        if (diffStat.next && fetchMore) yield (0, $5NpoY.P)($58602268f8adbc66$export$9e6be4299244a19c, diffStat.next, pagesLeft, values, false);
        else // All diffstat pages loaded, no additional data
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.LOAD_DIFFSTAT).SUCCESS,
            payload: {
                values: values
            }
        });
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.LOAD_DIFFSTAT).ERROR,
            payload: {
                diffStatErrorCode: e.status,
                diffStatErrorKey: e.key
            }
        });
    }
}
function* $58602268f8adbc66$export$5b2f97c85bd93883(owner, slug, id) {
    const ignoreWhitespace = yield (0, $5NpoY.a3)((0, $i2O3k.getGlobalShouldIgnoreWhitespace));
    const url = (0, $czBtW.default).api.v20.diffstat(owner, slug, id, {
        ignoreWhitespace: ignoreWhitespace
    });
    const maxPages = 1;
    // We don't add the topic diff param here because PR data isn't avaible in the redux store when this function gets run.
    // The backend redirect that results from this call will override some parameters, including adding the topic diff param
    yield (0, $5NpoY.P)($58602268f8adbc66$export$9e6be4299244a19c, url, maxPages);
}
function* $58602268f8adbc66$export$d42d171c21ea0aaa() {
    const id = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestId));
    const owner = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryOwnerName));
    const slug = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositorySlug));
    yield (0, $5NpoY.P)($58602268f8adbc66$export$5b2f97c85bd93883, owner, slug, id);
}
function* $58602268f8adbc66$export$1f34053b3afa76f1() {
    const serverGeneratedDiffStatUrl = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestCompareSpecDiffStatUrl));
    // Only run saga for PR page diffs
    if (serverGeneratedDiffStatUrl === undefined) return;
    const ignoreWhitespace = yield (0, $5NpoY.a3)((0, $i2O3k.getGlobalShouldIgnoreWhitespace));
    const topicDiff = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestInTopicDiffMode));
    const url = (0, $7Yccf.addQueryParams)(serverGeneratedDiffStatUrl, (0, $7Yccf.normalizeDiffStatParams)({
        topicDiff: topicDiff,
        ignoreWhitespace: ignoreWhitespace
    }));
    const maxPages = 1;
    yield (0, $5NpoY.P)($58602268f8adbc66$export$9e6be4299244a19c, url, maxPages);
}

});

parcelRegister("8jjaz", function(module, exports) {

$parcel$export(module.exports, "retryFetchMergeChecks", function () { return $cfa20d5795271189$export$b5e7db4350a4c2b8; });
$parcel$export(module.exports, "retryFetchConcreteMergeChecks", function () { return $cfa20d5795271189$export$67c80b71287870f8; });
$parcel$export(module.exports, "retryFetchAllMergeChecksIfNeeded", function () { return $cfa20d5795271189$export$8dd012bb7e15b051; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $bGUx6 = parcelRequire("bGUx6");

var $1EkdU = parcelRequire("1EkdU");

var $czBtW = parcelRequire("czBtW");

var $g8glp = parcelRequire("g8glp");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $cKQdu = parcelRequire("cKQdu");
function* $cfa20d5795271189$export$ac0f285d84e14879(user, slug, pullRequestId) {
    const api = yield* (0, $g8glp.getPullRequestApis)();
    const mergeCheckUrl = (0, $czBtW.default).api.internal.mergeChecks(user, slug, pullRequestId);
    try {
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.FETCH_MERGE_CHECKS).REQUEST
        });
        // @ts-ignore
        const response = yield (0, $5NpoY.P)(api.getMergeChecks, mergeCheckUrl);
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.FETCH_MERGE_CHECKS).SUCCESS,
            // label is null for checks that aren't run
            payload: (0, $bGUx6.mergeCheckPayloadTransformer)(response)
        });
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.FETCH_MERGE_CHECKS).ERROR,
            payload: e.message
        });
    }
}
function* $cfa20d5795271189$export$b5e7db4350a4c2b8() {
    const { owner: owner, slug: slug, id: id } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    yield* $cfa20d5795271189$export$ac0f285d84e14879(owner, slug, id);
    yield* (0, $cKQdu.fetchPendingMergeStatusSaga)();
}
function* $cfa20d5795271189$export$67c80b71287870f8(keys) {
    const mergeChecks = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestMergeChecks));
    const hasGivenMergeKeys = mergeChecks.some((c)=>keys.includes(c.key));
    if (hasGivenMergeKeys) {
        yield (0, $5NpoY.S)(1000);
        yield* $cfa20d5795271189$export$b5e7db4350a4c2b8();
    }
}
function* $cfa20d5795271189$export$8dd012bb7e15b051() {
    const mergeChecks = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestMergeChecks));
    if (mergeChecks.length) yield* $cfa20d5795271189$export$b5e7db4350a4c2b8();
}

});
parcelRegister("cKQdu", function(module, exports) {

$parcel$export(module.exports, "fetchPendingMergeStatusSaga", function () { return $faa56b3877658125$export$afb7675725e1e11b; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $k6zif = parcelRequire("k6zif");

var $1EkdU = parcelRequire("1EkdU");

var $czBtW = parcelRequire("czBtW");

var $k2cPS = parcelRequire("k2cPS");
function* $faa56b3877658125$export$afb7675725e1e11b() {
    const { owner: owner, slug: slug, id: id } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    const url = (0, $czBtW.default).api.internal.pendingMerge(owner, slug, id);
    try {
        const response = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!response.ok) {
            const error = yield response.text();
            throw new Error(error);
        }
        // @ts-ignore
        const json = yield response.json();
        const { can_create_post_build_merge: canCreatePendingMerge = false, pullrequest: pullrequest, commit_message: message, merge_strategy: mergeStrategy, close_anchor_branch: closeSourceBranch } = json;
        yield (0, $5NpoY.Y)({
            type: (0, $k6zif.FETCH_PENDING_MERGE_STATUS).SUCCESS,
            payload: {
                canCreatePendingMerge: canCreatePendingMerge,
                isMergePending: !!pullrequest,
                mergeInfo: {
                    message: message,
                    mergeStrategy: mergeStrategy,
                    closeSourceBranch: closeSourceBranch
                }
            }
        });
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $k6zif.FETCH_PENDING_MERGE_STATUS).ERROR,
            payload: e.message,
            error: true
        });
    }
}

});


parcelRegister("gB6Wt", function(module, exports) {

$parcel$export(module.exports, "fetchPullRequestAnnotations", function () { return $1f0fab2185f794d0$export$b257a49746729aa6; });

var $3XbtU = parcelRequire("3XbtU");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $i2O3k = parcelRequire("i2O3k");

var $1EkdU = parcelRequire("1EkdU");

var $1WShj = parcelRequire("1WShj");

var $g2R3c = parcelRequire("g2R3c");

var $kvnVB = parcelRequire("kvnVB");

var $9NUw3 = parcelRequire("9NUw3");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $eCTLi = parcelRequire("eCTLi");

var $aBXBT = parcelRequire("aBXBT");
function* $1f0fab2185f794d0$export$ccc9788d31f86f1c() {
    const account = yield (0, $5NpoY.a3)((0, $g2R3c.getTargetUser));
    const url = `${(0, $kvnVB.settings)().API_CANON_URL}/internal/site/addons/account/${account.uuid}/install/`;
    try {
        const accessToken = yield (0, $5NpoY.P)((0, $9NUw3.default), `site:code-insights-installer`);
        yield (0, $5NpoY.P)((0, $aBXBT.default), url, accessToken, false, "POST");
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.FETCH_CODE_INSIGHTS_PREINSTALL).SUCCESS
        });
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.FETCH_CODE_INSIGHTS_PREINSTALL).ERROR
        });
        if (e instanceof Error) $3XbtU.captureException(e);
    }
}
function* $1f0fab2185f794d0$export$20f6b62d67ced347() {
    const { owner: owner, slug: slug, id: id } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    const commitHash = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestSourceHash));
    const url = `${(0, $eCTLi.annotationsBaseUrl)("internal")}/repositories/${owner}/${slug}/pullrequests/${id}/annotations?sort=-severity&commitHash=${commitHash}&page=1`;
    try {
        const annotations = yield (0, $5NpoY.P)((0, $aBXBT.fetchAllPages), url, (0, $1WShj.CODE_INSIGHTS_ANNOTATIONS_PAGE_SIZE));
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.FETCH_PULL_REQUEST_ANNOTATIONS).SUCCESS,
            payload: annotations || []
        });
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.FETCH_PULL_REQUEST_ANNOTATIONS).ERROR,
            payload: e.message
        });
    }
}
function* $1f0fab2185f794d0$export$b257a49746729aa6() {
    const isAnnotationsUserPrefsEnabled = yield (0, $5NpoY.a3)((0, $i2O3k.getGlobalIsAnnotationsEnabled));
    if (!isAnnotationsUserPrefsEnabled) return;
    try {
        const { error: error } = yield (0, $5NpoY.T)({
            success: (0, $5NpoY.P)($1f0fab2185f794d0$export$20f6b62d67ced347),
            error: (0, $5NpoY.M)((0, $6D21P.FETCH_PULL_REQUEST_ANNOTATIONS).ERROR)
        });
        if (error !== null && error !== void 0 && error.payload && error.payload.indexOf("status: 404") !== -1) {
            yield (0, $5NpoY.P)($1f0fab2185f794d0$export$ccc9788d31f86f1c);
            yield (0, $5NpoY.P)($1f0fab2185f794d0$export$20f6b62d67ced347);
        }
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.FETCH_PULL_REQUEST_ANNOTATIONS).ERROR,
            payload: e.message
        });
    }
}

});

parcelRegister("AunSz", function(module, exports) {

$parcel$export(module.exports, "fetchPullRequestComments", function () { return $87cbd0c59ddac8b4$export$a1a0a2117a6b1dc4; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $1EkdU = parcelRequire("1EkdU");

var $czBtW = parcelRequire("czBtW");

var $eh30r = parcelRequire("eh30r");
// @ts-ignore TODO: fix noImplicitAny error here
function* $87cbd0c59ddac8b4$var$completeComments({ containerId: containerId, url: url, previousPagesComments: previousPagesComments = [] }) {
    const { nextUrl: nextUrl, commentValues: commentValues, error: error } = yield* (0, $eh30r.fetchComments)({
        url: url
    });
    if (error) {
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.FETCH_COMMENTS).ERROR,
            error: true
        });
        return;
    }
    const isDoneFetching = !nextUrl;
    const allComments = [
        ...previousPagesComments,
        ...commentValues || []
    ];
    if (isDoneFetching) yield (0, $5NpoY.Y)({
        type: (0, $6D21P.FETCH_COMMENTS).SUCCESS,
        payload: {
            rawComments: allComments
        }
    });
    else yield (0, $5NpoY.N)($87cbd0c59ddac8b4$var$completeComments, {
        containerId: containerId,
        url: nextUrl,
        // Conversations need all parents to build threads correctly
        previousPagesComments: allComments
    });
}
function* $87cbd0c59ddac8b4$export$a1a0a2117a6b1dc4() {
    const { owner: owner, slug: slug, id: id } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    const containerId = yield (0, $5NpoY.a3)((0, $1EkdU.getContainerId));
    const url = (0, $czBtW.default).api.internal.orderedCommentsFetch(owner, slug, id);
    yield* $87cbd0c59ddac8b4$var$completeComments({
        containerId: containerId,
        url: url
    });
}

});
parcelRegister("eh30r", function(module, exports) {

$parcel$export(module.exports, "fetchComments", function () { return $444d043a3feae0c1$export$6026ae6c58b4c197; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $k2cPS = parcelRequire("k2cPS");
function* $444d043a3feae0c1$export$6026ae6c58b4c197({ url: url }) {
    try {
        const response = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        if (!response.ok) throw new Error("An error occured while fetching conversations");
        // @ts-ignore
        const json = yield response.json();
        const commentValues = json.values;
        const nextUrl = json.next;
        return {
            commentValues: commentValues,
            nextUrl: nextUrl
        };
    } catch (e) {
        return {
            error: e
        };
    }
}

});


parcelRegister("dXUHi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $092cedc8c2bfede7$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("24sAG");
var $azI4e = parcelRequire("azI4e");

var $1EkdU = parcelRequire("1EkdU");
function* $092cedc8c2bfede7$export$2e2bcd8739ae039() {
    const sourceRepo = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestSourceRepo));
    const sourceBranchName = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestBranchName));
    const repoName = sourceRepo ? sourceRepo.full_name : "";
    const [owner, slug] = repoName.split("/");
    yield (0, $5NpoY.Y)((0, $azI4e.default)(owner, slug, sourceBranchName));
}

});

parcelRegister("1lUhL", function(module, exports) {

$parcel$export(module.exports, "fetchStackedPullRequestsCountSaga", function () { return $c17292c49a8aad46$export$73f6f50b5365bd3d; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $3XbtU = parcelRequire("3XbtU");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $k6zif = parcelRequire("k6zif");

var $g8glp = parcelRequire("g8glp");

var $1EkdU = parcelRequire("1EkdU");
function* $c17292c49a8aad46$export$73f6f50b5365bd3d() {
    const api = yield* (0, $g8glp.getPullRequestApis)();
    const { owner: owner, slug: slug } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    const branch = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestBranchName));
    try {
        yield (0, $5NpoY.Y)({
            type: (0, $k6zif.FETCH_STACKED_PULL_REQUESTS_COUNT).REQUEST
        });
        // @ts-ignore
        const stackedPrCount = yield (0, $5NpoY.P)(api.getStackedPullRequestsCount, owner, slug, branch);
        yield (0, $5NpoY.Y)({
            type: (0, $k6zif.FETCH_STACKED_PULL_REQUESTS_COUNT).SUCCESS,
            payload: stackedPrCount
        });
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $k6zif.FETCH_STACKED_PULL_REQUESTS_COUNT).ERROR,
            payload: e.message
        });
    }
}

});

parcelRegister("6wffr", function(module, exports) {

$parcel$export(module.exports, "globalSingleFileModeEnabledSaga", function () { return $68c2eaa4a29cacbc$export$7c99edac4ff832ee; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $i2O3k = parcelRequire("i2O3k");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $1EkdU = parcelRequire("1EkdU");
function* $68c2eaa4a29cacbc$export$7c99edac4ff832ee() {
    const isGlobalSingleFileModeEnabled = yield (0, $5NpoY.a3)((0, $i2O3k.getGlobalIsSingleFileModeEnabled));
    const isSingleFiledModeEligible = yield (0, $5NpoY.a3)((0, $1EkdU.getIsSingleFileModeEligible));
    // only change mode for small PRs
    if (!isSingleFiledModeEligible) yield (0, $5NpoY.Y)({
        type: (0, $6D21P.TOGGLE_SINGLE_FILE_MODE),
        payload: isGlobalSingleFileModeEnabled
    });
}

});

parcelRegister("e7ae2", function(module, exports) {

$parcel$export(module.exports, "rememberImageUploadCallbacks", function () { return $cbdac089c650fd1d$export$a1c303993ffc2cf6; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $2WdMK = parcelRequire("2WdMK");
function* $cbdac089c650fd1d$export$a1c303993ffc2cf6() {
    while(true){
        // If user opens the dialog or drops a file in, remember the editor callback
        // @ts-ignore
        const initiatingAction = yield (0, $5NpoY.M)([
            (0, $2WdMK.CHOOSE_IMAGE),
            (0, $2WdMK.UPLOAD_IMAGE).REQUEST
        ]);
        const { editorCallback: editorCallback } = initiatingAction.payload;
        // Wait until they cancel, successfully upload, or fail to upload
        const { type: type, payload: payload } = yield (0, $5NpoY.M)([
            (0, $2WdMK.CANCEL_IMAGE_CHOICE),
            (0, $2WdMK.UPLOAD_IMAGE).SUCCESS,
            (0, $2WdMK.UPLOAD_IMAGE).ERROR
        ]);
        // If they sucessfully uploaded, invoke Fabric callback
        if (type === (0, $2WdMK.UPLOAD_IMAGE).SUCCESS) yield (0, $5NpoY.P)(editorCallback, {
            ...payload
        });
    }
}

});

parcelRegister("4eFnp", function(module, exports) {

$parcel$export(module.exports, "imageUploaderSaga", function () { return $f04be0b2a9cf9a18$export$b6e7d408b18087e9; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $1EkdU = parcelRequire("1EkdU");

var $czBtW = parcelRequire("czBtW");

var $aanBq = parcelRequire("aanBq");

var $k2cPS = parcelRequire("k2cPS");

var $2WdMK = parcelRequire("2WdMK");
function* $f04be0b2a9cf9a18$export$b6e7d408b18087e9(action) {
    const { payload: payload } = action;
    let { owner: owner, slug: slug } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    if (!owner && !slug) {
        // @ts-ignore
        owner = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryOwnerName));
        // @ts-ignore
        slug = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositorySlug));
    }
    const uploadUrl = (0, $czBtW.default).api.internal.imageUpload(owner, slug);
    const imageUploadUrl = (0, $k2cPS.default)(uploadUrl);
    const data = new FormData();
    // need to modify file name as parenthesis broke image upload.
    // See https://softwareteams.atlassian.net/browse/NPR-837
    const fileName = payload.file.name.replace(/\(/g, "%28").replace(/\)/g, "%29");
    data.append("file", payload.file, fileName);
    try {
        const response = yield (0, $5NpoY.P)(fetch, imageUploadUrl, {
            method: "POST",
            body: data
        });
        if (!response.ok) {
            const error = yield response.text();
            throw new Error(error);
        }
        // @ts-ignore
        const json = yield response.json();
        yield (0, $5NpoY.Y)({
            type: (0, $2WdMK.UPLOAD_IMAGE).SUCCESS,
            payload: {
                src: json.href,
                alt: json.filename,
                title: json.filename
            }
        });
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $2WdMK.UPLOAD_IMAGE).ERROR,
            payload: e.message
        });
    }
}

});

parcelRegister("jIQcY", function(module, exports) {

$parcel$export(module.exports, "viewPullRequestCapabilitySaga", function () { return $a663a671090624d3$export$9ae5a1882a0388f7; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $M3cyx = parcelRequire("M3cyx");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");
const $a663a671090624d3$var$VIEW_PR_TIMEOUT = 30000;
function* $a663a671090624d3$export$9ae5a1882a0388f7() {
    const { viewPRSuccess: viewPRSuccess, viewPRFailure: viewPRFailure, timeout: timeout } = yield (0, $5NpoY.T)({
        viewPRSuccess: (0, $5NpoY._)([
            (0, $5NpoY.M)((0, $6D21P.INITIAL_DIFFS_RENDERED)),
            (0, $5NpoY.M)((0, $6D21P.LOAD_PULL_REQUEST).SUCCESS),
            (0, $5NpoY.M)((0, $6D21P.LOAD_DIFFSTAT).SUCCESS),
            (0, $5NpoY.M)((0, $6D21P.FETCH_DIFF).SUCCESS)
        ]),
        viewPRFailure: (0, $5NpoY.T)({
            pullRequest: (0, $5NpoY.M)((0, $6D21P.LOAD_PULL_REQUEST).ERROR),
            diffstat: (0, $5NpoY.M)((0, $6D21P.LOAD_DIFFSTAT).ERROR),
            diff: (0, $5NpoY.M)((0, $6D21P.FETCH_DIFF).ERROR)
        }),
        timeout: (0, $5NpoY.S)($a663a671090624d3$var$VIEW_PR_TIMEOUT)
    });
    if (viewPRSuccess) {
        (0, $M3cyx.statsdApiClient).increment("frontbucket.capability.viewPullRequest.success");
        return;
    }
    let failureKind = "unknown";
    if (viewPRFailure) {
        const { diff: diff, diffstat: diffstat, pullRequest: pullRequest } = viewPRFailure;
        if (diff) failureKind = "load-diff";
        else if (diffstat) failureKind = "load-diffstat";
        else if (pullRequest) failureKind = "load-pullRequest";
    } else if (timeout) failureKind = "timeout";
    (0, $M3cyx.statsdApiClient).increment("frontbucket.capability.viewPullRequest.failure", {
        tags: [
            `failure_kind:${failureKind}`
        ]
    });
}

});

parcelRegister("5mCUg", function(module, exports) {

$parcel$export(module.exports, "pollMergeTaskStatusSaga", function () { return $d5c84afb30bb6d5e$export$e7431666101d06d6; });
$parcel$export(module.exports, "mergePullRequestSaga", function () { return $d5c84afb30bb6d5e$export$c64eefb1586ab090; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("fojQl");
var $4cfLu = parcelRequire("4cfLu");
var $j7nzB = parcelRequire("j7nzB");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $k6zif = parcelRequire("k6zif");

var $fTGX3 = parcelRequire("fTGX3");

var $1EkdU = parcelRequire("1EkdU");

var $czBtW = parcelRequire("czBtW");

var $lp4Gn = parcelRequire("lp4Gn");

var $lkmX7 = parcelRequire("lkmX7");

var $aanBq = parcelRequire("aanBq");

var $5utbt = parcelRequire("5utbt");

var $k2cPS = parcelRequire("k2cPS");

var $e9BOm = parcelRequire("e9BOm");

var $58TOz = parcelRequire("58TOz");

var $9HLnY = parcelRequire("9HLnY");
const $d5c84afb30bb6d5e$export$bdc4cbc7def1c97b = 3000;
var $d5c84afb30bb6d5e$export$eb07605ac0796818;
(function(MERGE_TASK_STATUSES) {
    MERGE_TASK_STATUSES["PENDING"] = "PENDING";
    MERGE_TASK_STATUSES["SUCCESS"] = "SUCCESS";
})($d5c84afb30bb6d5e$export$eb07605ac0796818 || ($d5c84afb30bb6d5e$export$eb07605ac0796818 = {}));
function* $d5c84afb30bb6d5e$export$40b06f55b2b80d8() {
    const { owner: owner, slug: slug, id: id } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    const currentPullRequest = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequest));
    const { hash: merge_commit_hash } = currentPullRequest.merge_commit;
    // After merging, this should fetch the *merge commit* itself.
    yield (0, $5NpoY.P)((0, $lp4Gn.prefetchCommits), {
        owner: owner,
        slug: slug,
        id: id
    });
    const commits = yield (0, $5NpoY.a3)((0, $lkmX7.getCurrentRepoCommits));
    // The merge commit should then be the first commit in the "current pull request commits".
    if (commits && commits.length !== 0 && commits[0].hash === merge_commit_hash) // Fetch the statuses multiple times (waiting some time between fetches).
    // We don't really know if we can stop, because there might be more than 1 build.
    // Build statuses can also be posted from external places that poll the repository, so we
    // can't rely on it being fast.
    // Why do we do this? Because we want to show the build status in the merge success message
    // so that the user can click through to the build straight after merging (instead of having
    // to go via commit or look at all the builds and find theirs).
    for (const delaySeconds of [
        2,
        4,
        8,
        16
    ]){
        // Delay before first fetch because `prefetchCommits` above causes a status fetch already.
        yield (0, $5NpoY.S)(delaySeconds * 1000);
        yield (0, $5NpoY.P)((0, $fTGX3.fetchCommitsStatusesSaga));
    }
}
function* $d5c84afb30bb6d5e$var$updatePullRequestStatus(json) {
    const { owner: owner, slug: repoSlug } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    const currentPullRequest = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequest));
    const updatedPullRequest = {
        ...currentPullRequest,
        state: json.state,
        updated_on: json.updated_on,
        closed_by: json.closed_by,
        closed_on: json.closed_on,
        merge_commit: json.merge_commit
    };
    yield (0, $5NpoY.Y)((0, $e9BOm.updatePullRequest)({
        type: (0, $k6zif.MERGE).SUCCESS,
        pullRequest: updatedPullRequest
    }));
    // publish analytics event
    const { isWorkspacePaid: isWorkspacePaid } = yield (0, $5NpoY.a3)((0, $5utbt.getWorkspacePlan));
    const repoUuid = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryUuid));
    const comments = yield (0, $5NpoY.a3)((0, $1EkdU.getInlineComments));
    const role = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestRoleForCurrentUser));
    (0, $9HLnY.publishPullRequestEvent)("MERGED", updatedPullRequest, comments, isWorkspacePaid, repoUuid, role);
    yield (0, $5NpoY.a1)($d5c84afb30bb6d5e$export$40b06f55b2b80d8);
    const destinationBranchName = yield (0, $5NpoY.a3)((0, $1EkdU.getDestinationBranchName));
    const { development: development, production: production } = yield (0, $5NpoY.a3)((0, $4cfLu.getBranchingModel));
    const checkBranchName = (branch)=>{
        return !!branch && branch.name === destinationBranchName;
    };
    // If the destination branch is the "development" or "production" branch
    // we need to refetch the branching model in order to update the hashes to
    // the latest commit.
    if (checkBranchName(development) || checkBranchName(production)) yield (0, $5NpoY.Y)((0, $j7nzB.loadBranchingModel)({
        repositoryOwner: owner,
        repositorySlug: repoSlug
    }));
}
function* $d5c84afb30bb6d5e$export$8f6ea22fe0b6214d(pollingLink) {
    while(true){
        yield (0, $5NpoY.S)($d5c84afb30bb6d5e$export$bdc4cbc7def1c97b);
        yield (0, $5NpoY.Y)((0, $k6zif.fetchPullRequestMergeStatus)(pollingLink));
        const { success: success, error: error } = yield (0, $5NpoY.T)({
            success: (0, $5NpoY.M)((0, $k6zif.FETCH_PULL_REQUEST_MERGE_STATUS).SUCCESS),
            error: (0, $5NpoY.M)((0, $k6zif.FETCH_PULL_REQUEST_MERGE_STATUS).ERROR)
        });
        if (error) throw Error(error.payload);
        const { payload: json } = success;
        if (json.task_status === "SUCCESS") {
            const { merge_result: pullRequest } = json;
            return pullRequest;
        }
    }
}
function* $d5c84afb30bb6d5e$export$8ce39c2c014043bd(pollingLink) {
    yield (0, $5NpoY.Y)((0, $k6zif.setAsyncMergeInProgress)(true));
    try {
        // @ts-ignore
        return yield (0, $5NpoY.T)({
            json: (0, $5NpoY.P)($d5c84afb30bb6d5e$export$8f6ea22fe0b6214d, pollingLink),
            exitedCodeReview: (0, $5NpoY.M)((0, $6D21P.EXITED_CODE_REVIEW))
        });
    } finally{
        // clear banner on initial merge request
        yield (0, $5NpoY.Y)((0, $k6zif.setAsyncMergeInProgress)(false));
        // clear banner on in-progress merge
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.CLEAR_IN_PROGRESS_MERGE_TASK)
        });
    }
}
function* $d5c84afb30bb6d5e$export$e7431666101d06d6() {
    // @ts-ignore
    const mergeInProgress = yield (0, $5NpoY.a3)((0, $1EkdU.getInProgressMergeTask));
    if (!mergeInProgress) return;
    try {
        const { json: json } = yield (0, $5NpoY.P)($d5c84afb30bb6d5e$export$8ce39c2c014043bd, mergeInProgress);
        if (json) yield (0, $5NpoY.P)($d5c84afb30bb6d5e$var$updatePullRequestStatus, json);
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $k6zif.MERGE).ERROR,
            payload: e.message,
            error: true
        });
    }
}
function* $d5c84afb30bb6d5e$export$c64eefb1586ab090() {
    while(true){
        const { payload: mergeInfo } = yield (0, $5NpoY.M)((0, $k6zif.MERGE).REQUEST);
        const { owner: owner, slug: repoSlug, id: pullRequestId } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
        const endpoint_parameters = {
            owner: owner,
            repoSlug: repoSlug,
            pullRequestId: pullRequestId
        };
        const endpoint = (0, $czBtW.default).api.v20.merge_async(endpoint_parameters);
        try {
            const authWrapped = (0, $k2cPS.default)(endpoint, {
                method: "POST",
                headers: (0, $k2cPS.jsonHeaders),
                body: JSON.stringify({
                    close_source_branch: mergeInfo.closeSourceBranch,
                    message: mergeInfo.message,
                    merge_strategy: mergeInfo.mergeStrategy
                })
            });
            const response = yield (0, $5NpoY.P)(fetch, authWrapped);
            if (!response.ok) {
                const message = yield (0, $5NpoY.P)((0, $58TOz.getErrorMessage), response.clone());
                throw Error(message);
            }
            const pullRequestMergeStatusPollingLink = response.headers.get("location");
            if (!pullRequestMergeStatusPollingLink) return {
                json: null
            };
            const { json: json } = yield (0, $5NpoY.P)($d5c84afb30bb6d5e$export$8ce39c2c014043bd, pullRequestMergeStatusPollingLink);
            // If json is falsey it means that the user has exited the code review page
            // or there is an error occured while the async merge polling was happening
            if (json) yield (0, $5NpoY.P)($d5c84afb30bb6d5e$var$updatePullRequestStatus, json);
        } catch (e) {
            yield (0, $5NpoY.Y)({
                type: (0, $k6zif.MERGE).ERROR,
                payload: e.message,
                error: true
            });
        }
    }
}

});
parcelRegister("e9BOm", function(module, exports) {

$parcel$export(module.exports, "updatePullRequest", function () { return $bcd8c6bc662b56d5$export$43216e28c44e23f1; });

var $b2RHC = parcelRequire("b2RHC");
const $bcd8c6bc662b56d5$export$43216e28c44e23f1 = ({ type: type, pullRequest: pullRequest, oldTitle: oldTitle, userAaid: userAaid, currentUser: currentUser, removedUser: removedUser })=>({
        type: type,
        payload: {
            currentPullRequest: pullRequest,
            oldTitle: oldTitle,
            userAaid: userAaid,
            currentUser: currentUser,
            removedUser: removedUser
        },
        meta: {
            schema: {
                currentPullRequest: (0, $b2RHC.pullRequest)
            }
        }
    });

});


parcelRegister("lSc3Y", function(module, exports) {

$parcel$export(module.exports, "startingPollingForUpdates", function () { return $af838b889e7d7007$export$bff2b722a3f9a0dd; });
$parcel$export(module.exports, "dismissUpdateFlag", function () { return $af838b889e7d7007$export$13dab429ec69fec; });
$parcel$export(module.exports, "minimalUpdateSaga", function () { return $af838b889e7d7007$export$339b6faaf1ea78d9; });
$parcel$export(module.exports, "minimalUpdateFromPollResults", function () { return $af838b889e7d7007$export$6950c39b8c34ca46; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("hw8PW");
var $7JtYi = parcelRequire("7JtYi");
var $l9p9x = parcelRequire("l9p9x");

var $2kKDW = parcelRequire("2kKDW");

var $jOlj7 = parcelRequire("jOlj7");

var $8Ao0D = parcelRequire("8Ao0D");

var $lp4Gn = parcelRequire("lp4Gn");

var $g8glp = parcelRequire("g8glp");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");
var $bQYeX = parcelRequire("bQYeX");

var $e9BOm = parcelRequire("e9BOm");

var $14kRW = parcelRequire("14kRW");

var $cYhXG = parcelRequire("cYhXG");

var $1EkdU = parcelRequire("1EkdU");

var $cwHQh = parcelRequire("cwHQh");

var $7p7CY = parcelRequire("7p7CY");

var $j2CMC = parcelRequire("j2CMC");

var $8jjaz = parcelRequire("8jjaz");

var $AunSz = parcelRequire("AunSz");

var $66z6m = parcelRequire("66z6m");
const $af838b889e7d7007$export$f0233d11e628176 = 20000;
const $af838b889e7d7007$export$5491945648b4e4ab = "pull-request-updated";
const $af838b889e7d7007$var$shouldShowFlag = (response, updatedOn)=>{
    // Response from server is a UTC date string without a defined timezone
    // The UTC timezone must be defined otherwise older browsers may
    // interpret the date as a local timezone, instead of UTC
    const lastModified = response.lastModified.endsWith("Z") ? response.lastModified : `${response.lastModified}Z`;
    // Inline edits update the current pull request data in the Redux store
    // to match the lastModified data returned in the updates/ response
    const recentInlineEdit = new Date(lastModified).getTime() === new Date(updatedOn).getTime();
    return response.anchorMoved || // response.destRevMoved || // Ignored for now because of noisy amount of updates
    /* If only the PR Details are modified, we will not show the flag if
     the change was a result of a recent inline edit */ response.prDetailsModified && !recentInlineEdit || response.reviewersModified || response.approvalsAdded.length > 0 || response.approvalsRemoved.length > 0 || response.requestChangesAdded.length > 0 || response.requestChangesRemoved.length > 0 || response.commentsAdded.length > 0 || response.commentsDeleted.length > 0 || response.commentsReplied.length > 0 || response.commentsEdited.length > 0 || response.commentsResolved.length > 0 || response.commentsReopened.length > 0 || response.needsTasks || response.statusChanged;
};
function* $af838b889e7d7007$export$e5457ea77e7f1707(lastPollTime) {
    const api = yield* (0, $g8glp.getPullRequestApis)();
    const { owner: owner, slug: slug, id: id } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    const response = yield (0, $5NpoY.P)(api.getUpdates, owner, slug, id, lastPollTime);
    if ("error" in response) throw response.error;
    const { updated_on: updatedOn } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequest));
    if ($af838b889e7d7007$var$shouldShowFlag(response, updatedOn)) {
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.POLLED_PULLREQUEST),
            payload: {
                lastModified: response.lastModified,
                needsPullRequest: response.prDetailsModified || response.reviewersModified || response.approvalsAdded.length > 0 || response.approvalsRemoved.length > 0 || response.requestChangesAdded.length > 0 || response.requestChangesRemoved.length > 0 || response.anchorMoved || response.statusChanged,
                needsDiff: response.anchorMoved,
                needsComments: response.commentsAdded.length > 0 || response.commentsDeleted.length > 0 || response.commentsReplied.length > 0 || response.commentsEdited.length > 0 || response.commentsResolved.length > 0 || response.commentsReopened.length > 0,
                needsTasks: response.needsTasks,
                links: response.links
            }
        });
        const descriptivePrUpdateFlag = yield (0, $5NpoY.P)((0, $l9p9x.getFlagValue), (0, $7JtYi.FeatureKeys).descriptivePrUpdateFlag, false);
        if (descriptivePrUpdateFlag) // Including the response in the props allows the flag to choose its text based on the values in the response
        yield (0, $5NpoY.Y)((0, $2kKDW.showFlagComponent)($af838b889e7d7007$export$5491945648b4e4ab, {
            props: {
                response: response
            }
        }));
        else // The original implementation; not including the response causes the flag to default to the original generic text
        yield (0, $5NpoY.Y)((0, $2kKDW.showFlagComponent)($af838b889e7d7007$export$5491945648b4e4ab));
    }
}
function* $af838b889e7d7007$export$72b5c99507c6edbd() {
    const { calculateDelay: calculateDelay, cleanup: cleanupPoller } = (0, $cwHQh.backOffPoller)($af838b889e7d7007$export$f0233d11e628176);
    while(true){
        // @ts-ignore
        const lastPollTime = yield (0, $5NpoY.a3)((0, $1EkdU.getLastPollTime));
        if (!lastPollTime) {
            yield (0, $5NpoY.S)(calculateDelay());
            continue;
        }
        try {
            yield (0, $5NpoY.P)($af838b889e7d7007$export$e5457ea77e7f1707, lastPollTime);
        } catch (e) {
        // Unhandled currently, just delay and try again
        } finally{
            // @ts-ignore
            if (yield (0, $5NpoY.a4)()) cleanupPoller();
        }
        yield (0, $5NpoY.S)(calculateDelay());
    }
}
function* $af838b889e7d7007$export$bff2b722a3f9a0dd(_action) {
    // @ts-ignore
    const pollingLoop = yield (0, $5NpoY.N)($af838b889e7d7007$export$72b5c99507c6edbd);
    const { pageWasHidden: pageWasHidden } = yield (0, $5NpoY.T)({
        pageWasHidden: (0, $5NpoY.M)((0, $jOlj7.PAGE_HIDDEN)),
        exitedPage: (0, $5NpoY.M)((0, $6D21P.EXITED_CODE_REVIEW))
    });
    yield (0, $5NpoY.O)(pollingLoop);
    if (pageWasHidden) {
        yield (0, $5NpoY.M)((0, $jOlj7.PAGE_VISIBLE));
        yield* $af838b889e7d7007$export$bff2b722a3f9a0dd({});
    }
}
function* $af838b889e7d7007$export$13dab429ec69fec() {
    yield (0, $5NpoY.Y)((0, $2kKDW.dismissFlag)($af838b889e7d7007$export$5491945648b4e4ab));
}
function* $af838b889e7d7007$export$339b6faaf1ea78d9(action) {
    const { owner: owner, slug: slug, id: id } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    const { needsDiff: needsDiff, needsComments: needsComments, needsTasks: needsTasks, needsPullRequest: needsPullRequest, links: links, forceNeedsMergeChecks: forceNeedsMergeChecks } = action.payload;
    // This clears the existing activity feed and refetches from the beginning
    yield (0, $5NpoY.Y)({
        type: (0, $14kRW.FETCH_ACTIVITY).REQUEST,
        owner: owner,
        slug: slug,
        id: id
    });
    if (needsDiff) yield (0, $5NpoY.a1)((0, $lp4Gn.prefetchCommits), {
        owner: owner,
        slug: slug,
        id: id
    });
    if (needsPullRequest) {
        yield (0, $5NpoY.a1)((0, $66z6m.fetchPullRequest));
        if (forceNeedsMergeChecks) yield (0, $5NpoY.a1)((0, $8jjaz.retryFetchMergeChecks));
        else yield (0, $5NpoY.a1)((0, $8jjaz.retryFetchAllMergeChecksIfNeeded));
        yield (0, $5NpoY.M)([
            (0, $6D21P.LOAD_PULL_REQUEST).SUCCESS
        ]);
    }
    if (needsComments) yield (0, $5NpoY.a1)((0, $AunSz.fetchPullRequestComments));
    if (needsTasks) yield (0, $5NpoY.Y)((0, $bQYeX.default)({
        owner: owner,
        repoSlug: slug,
        pullRequestId: id
    }));
    if (needsDiff) {
        if (links) {
            const pullRequest = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequest));
            const updatedPullRequest = {
                ...pullRequest,
                links: {
                    ...pullRequest.links,
                    ...links
                }
            };
            yield (0, $5NpoY.Y)((0, $e9BOm.updatePullRequest)({
                type: (0, $6D21P.UPDATE_PULL_REQUEST_LINKS),
                pullRequest: updatedPullRequest
            }));
        }
        yield (0, $5NpoY.a1)((0, $7p7CY.default), owner, slug, id);
        yield (0, $5NpoY.M)((0, $8Ao0D.prCommitActions).UPDATE_COMMITS);
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.REFETCH_IR_DIFF).TRUE
        });
        yield (0, $5NpoY.M)([
            (0, $6D21P.FETCH_DIFF).SUCCESS,
            (0, $6D21P.LOAD_DIFFSTAT).SUCCESS,
            (0, $6D21P.MOCK_IR_DIFF_FETCH)
        ]);
        yield (0, $5NpoY.a1)((0, $j2CMC.default), owner, slug, id);
        // reset the iterative review completed state
        yield (0, $5NpoY.Y)({
            type: (0, $cYhXG.ITERATIVE_REVIEW_COMPLETED).FALSE
        });
    }
    // refreshes builds card (currently on every reload)
    yield (0, $5NpoY.Y)({
        type: (0, $6D21P.TOGGLE_REFETCH_BUILDS_DUMMY)
    });
}
function* $af838b889e7d7007$export$6950c39b8c34ca46() {
    // @ts-ignore
    const updateNeeds = yield (0, $5NpoY.a3)((0, $1EkdU.getUpdateNeeds));
    yield (0, $5NpoY.a1)($af838b889e7d7007$export$339b6faaf1ea78d9, {
        type: "IRRELEVANT",
        payload: updateNeeds
    });
}

});
parcelRegister("cYhXG", function(module, exports) {

$parcel$export(module.exports, "ITERATIVE_REVIEW_COMPLETED", function () { return $ccb2e8832399630f$export$8b90e2fc0ce4387d; });
$parcel$export(module.exports, "iterativeReviewReducer", function () { return $ccb2e8832399630f$export$72ba6175352ca6cd; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");
const $ccb2e8832399630f$export$8b90e2fc0ce4387d = (0, $2MctD.createBoolAction)((0, $6D21P.prefixed)("ITERATIVE_REVIEW_COMPLETED"));
const $ccb2e8832399630f$export$d4c72bab9d6cc13a = {
    isIterativeReviewComplete: false
};
const $ccb2e8832399630f$export$72ba6175352ca6cd = (state = $ccb2e8832399630f$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case $ccb2e8832399630f$export$8b90e2fc0ce4387d.TRUE:
            return {
                ...state,
                isIterativeReviewComplete: true
            };
        case $ccb2e8832399630f$export$8b90e2fc0ce4387d.FALSE:
            return {
                ...state,
                isIterativeReviewComplete: false
            };
        default:
            return state;
    }
};

});

parcelRegister("cwHQh", function(module, exports) {

$parcel$export(module.exports, "backOffPoller", function () { return $284d3434d2a2fa93$export$91762c539b835a9b; });

var $62zzi = parcelRequire("62zzi");
const $284d3434d2a2fa93$var$DEFAULT_INACTIVITY = 60000; // one minute
const $284d3434d2a2fa93$var$MAX_INTERVAL = 600000; // 10 minutes
const $284d3434d2a2fa93$export$91762c539b835a9b = (initialInterval, inactivityInterval = $284d3434d2a2fa93$var$DEFAULT_INACTIVITY)=>{
    // eslint-disable-next-line no-param-reassign
    initialInterval = Math.min(Number.MAX_SAFE_INTEGER, Math.max(1, initialInterval)); // safety clamp
    let intervalMultiplier = 1;
    const incrementor = setInterval(()=>{
        intervalMultiplier = intervalMultiplier + 1;
    }, inactivityInterval);
    // eslint-disable-next-line no-return-assign
    const resetMultiplier = ()=>intervalMultiplier = 1;
    const debouncedReset = (0, $62zzi.default)(resetMultiplier, 100);
    // Listen for activity
    document.body.addEventListener("click", resetMultiplier);
    document.body.addEventListener("touchstart", resetMultiplier);
    window.addEventListener("scroll", debouncedReset);
    return {
        // For polling we cap the interval at 10min
        calculateDelay: ()=>Math.min($284d3434d2a2fa93$var$MAX_INTERVAL, initialInterval * intervalMultiplier),
        cleanup: ()=>{
            clearInterval(incrementor);
            document.body.removeEventListener("click", resetMultiplier);
            document.body.removeEventListener("touchstart", resetMultiplier);
            window.removeEventListener("scroll", debouncedReset);
        }
    };
};

});


parcelRegister("VXZCu", function(module, exports) {

$parcel$export(module.exports, "reprocessDiffSaga", function () { return $6622f9df4f729177$export$32f658388fb00a4a; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $i2O3k = parcelRequire("i2O3k");

var $63mqJ = parcelRequire("63mqJ");

var $gzGkQ = parcelRequire("gzGkQ");
const $6622f9df4f729177$var$DEBOUNCE_DELAY_MS = 100;
function* $6622f9df4f729177$var$reprocessDiff() {
    yield (0, $jeUNF.debounce)($6622f9df4f729177$var$DEBOUNCE_DELAY_MS, [
        (0, $i2O3k.UPDATE_GLOBAL_IS_WORD_DIFF_ENABLED_SUCCESS),
        (0, $i2O3k.UPDATE_GLOBAL_SHOULD_IGNORE_WHITESPACE_SUCCESS)
    ], (0, $63mqJ.fetchDiffByCompareSpecSaga));
}
function* $6622f9df4f729177$var$reprocessDiffStat() {
    yield (0, $jeUNF.takeLatest)((0, $i2O3k.UPDATE_GLOBAL_SHOULD_IGNORE_WHITESPACE_SUCCESS), (0, $gzGkQ.fetchDiffStatByCompareSpecSaga));
}
function* $6622f9df4f729177$export$32f658388fb00a4a() {
    yield (0, $5NpoY._)([
        $6622f9df4f729177$var$reprocessDiff(),
        $6622f9df4f729177$var$reprocessDiffStat()
    ]);
}

});

parcelRegister("e06Gc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $225f092428ecfa62$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $czBtW = parcelRequire("czBtW");

var $38jen = parcelRequire("38jen");

var $g2R3c = parcelRequire("g2R3c");

var $k2cPS = parcelRequire("k2cPS");

var $cYhXG = parcelRequire("cYhXG");

var $1EkdU = parcelRequire("1EkdU");

var $gadFw = parcelRequire("gadFw");

var $58TOz = parcelRequire("58TOz");
function* $225f092428ecfa62$var$requestPullRequestChanges() {
    const { owner: owner, slug: slug, id: id } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    // @ts-ignore
    const sourceBranchHash = yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestSourceHash));
    // @ts-ignore
    const currentUser = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
    const url = (0, $czBtW.default).api.v20.requestChanges(owner, slug, id);
    const authUrl = (0, $k2cPS.default)(url);
    try {
        const response = yield (0, $5NpoY.P)(fetch, authUrl, {
            method: "POST"
        });
        if (!response.ok) {
            const message = yield (0, $5NpoY.P)((0, $58TOz.getErrorMessage), response.clone());
            throw Error(message);
        }
        yield (0, $5NpoY.P)((0, $gadFw.default));
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.REQUEST_CHANGES).SUCCESS,
            payload: {
                currentUser: currentUser
            }
        });
        yield (0, $5NpoY.P)((0, $38jen.updateLastReviewedCommit), sourceBranchHash, owner, slug, id);
        // Publish a success event to trigger sagas to mark the iterative review as completed.
        yield (0, $5NpoY.Y)({
            type: (0, $cYhXG.ITERATIVE_REVIEW_COMPLETED).TRUE
        });
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.REQUEST_CHANGES).ERROR,
            payload: e.message,
            error: true
        });
    }
}
var $225f092428ecfa62$export$2e2bcd8739ae039 = $225f092428ecfa62$var$requestPullRequestChanges;

});
parcelRegister("38jen", function(module, exports) {

$parcel$export(module.exports, "updateLastReviewedCommit", function () { return $d362856b4ca30b34$export$7dfb17aba252163b; });
$parcel$export(module.exports, "getLastReviewedCommit", function () { return $d362856b4ca30b34$export$b419ee6f046ac287; });
$parcel$export(module.exports, "getCommitMessage", function () { return $d362856b4ca30b34$export$bd7d320ec5c9278e; });

var $czBtW = parcelRequire("czBtW");

var $k2cPS = parcelRequire("k2cPS");

var $h3kk7 = parcelRequire("h3kk7");
const $d362856b4ca30b34$var$LAST_REVIEWED_COMMIT_KEY = "last-reviewed-commit";
const $d362856b4ca30b34$export$7dfb17aba252163b = async (commitHash, owner, slug, id)=>{
    if (!commitHash || !id) return;
    // store in local storage
    const key = `${$d362856b4ca30b34$var$LAST_REVIEWED_COMMIT_KEY}:${owner}/${slug}/${id}`;
    const sevenDayExpiry = new Date().getTime() + 604800000;
    (0, $h3kk7.default).set(key, commitHash, sevenDayExpiry);
    // store in PR service
    const url = (0, $czBtW.default).api.internal.checkpoint(owner, slug, id);
    const response = await fetch((0, $k2cPS.default)(url, {
        method: "POST",
        headers: (0, $k2cPS.jsonHeaders),
        body: JSON.stringify({
            commit: commitHash
        })
    }));
    response.ok;
};
const $d362856b4ca30b34$export$b419ee6f046ac287 = async (owner, slug, id)=>{
    if (!id) return "";
    // fetch from local storage
    const key = `${$d362856b4ca30b34$var$LAST_REVIEWED_COMMIT_KEY}:${owner}/${slug}/${id}`;
    const localStorageValue = (0, $h3kk7.default).get(key);
    // fetch from PR service
    const url = (0, $czBtW.default).api.internal.checkpoint(owner, slug, id);
    const response = await fetch((0, $k2cPS.default)(url));
    const json = await response.json();
    // if request is successful and last_reviewed_commit is present, return from PR service
    // else fallback to local storage
    // if FF was just turned on, commit could be null in PR service but present in local storage
    if (response.ok && json.last_reviewed_commit) return json.last_reviewed_commit;
    return localStorageValue;
};
const $d362856b4ca30b34$export$bd7d320ec5c9278e = (commit)=>{
    const newlineOrTabRegex = /[\n\r\t]+/g;
    const renderedMessage = commit.rendered && commit.rendered.message || commit.summary;
    return (renderedMessage === null || renderedMessage === void 0 ? void 0 : renderedMessage.raw.replace(newlineOrTabRegex, " ")) || commit.message.replace(newlineOrTabRegex, " ");
};

});

parcelRegister("gadFw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $425f0f7e7535dccd$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $1EkdU = parcelRequire("1EkdU");

var $czBtW = parcelRequire("czBtW");

var $k2cPS = parcelRequire("k2cPS");

var $e9BOm = parcelRequire("e9BOm");
function* $425f0f7e7535dccd$var$updateParticipantsSaga() {
    const { owner: owner, slug: slug, id: id } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    const url = (0, $czBtW.default).api.v20.participants(owner, slug, id);
    const authUrl = (0, $k2cPS.default)(url);
    try {
        const response = yield (0, $5NpoY.P)(fetch, authUrl);
        // @ts-ignore
        const json = yield response.json();
        if (!response.ok) throw Error(json.error.message);
        const currentPullRequest = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequest));
        const updatedPullRequest = {
            ...currentPullRequest,
            participants: json.participants
        };
        yield (0, $5NpoY.Y)((0, $e9BOm.updatePullRequest)({
            type: (0, $6D21P.UPDATE_PARTICIPANTS).SUCCESS,
            pullRequest: updatedPullRequest
        }));
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.UPDATE_PARTICIPANTS).ERROR,
            payload: e.message
        });
    }
}
var $425f0f7e7535dccd$export$2e2bcd8739ae039 = $425f0f7e7535dccd$var$updateParticipantsSaga;

});


parcelRegister("8NUP2", function(module, exports) {

$parcel$export(module.exports, "revertPullRequestSaga", function () { return $6d6942fd2e1f83ba$export$96306e7e33e361fe; });

var $cJH1T = parcelRequire("cJH1T");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $2kKDW = parcelRequire("2kKDW");

var $kZnTB = parcelRequire("kZnTB");

var $aanBq = parcelRequire("aanBq");

var $k2cPS = parcelRequire("k2cPS");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $1EkdU = parcelRequire("1EkdU");

var $czBtW = parcelRequire("czBtW");
function* $6d6942fd2e1f83ba$export$96306e7e33e361fe({ payload: payload }) {
    const owner = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryOwnerName));
    const slug = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositorySlug));
    const id = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestId));
    try {
        const response = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)((0, $czBtW.default).api.internal.revert(owner, slug, id), {
            method: "POST",
            body: (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify({
                branch_name: payload.branchName,
                commit_message: payload.commitMessage ? payload.commitMessage : null
            }, {
                skipNulls: true
            }),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
            }
        }));
        const data = yield (0, $5NpoY.P)([
            response,
            "json"
        ]);
        if (data.type === "error") throw new Error(data.error.message);
        yield (0, $5NpoY.P)([
            location,
            "replace"
        ], (0, $kZnTB.default).ui.createPullRequest(owner, slug, data.name));
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.REVERT_PULL_REQUEST).ERROR,
            payload: e.message
        });
        yield (0, $5NpoY.Y)((0, $2kKDW.showFlagComponent)("revert-pull-request-error"));
    }
}

});

parcelRegister("4H339", function(module, exports) {

$parcel$export(module.exports, "scrollToLine", function () { return $5ff8e1a92071966a$export$2a0439691c0dd5c5; });
$parcel$export(module.exports, "scrollToFilepath", function () { return $5ff8e1a92071966a$export$da3b7829a89132eb; });
$parcel$export(module.exports, "scrollToGenericPermalink", function () { return $5ff8e1a92071966a$export$3f501b605ebf6bd8; });
$parcel$export(module.exports, "pullRequestCommentPermalinkScrollerSaga", function () { return $5ff8e1a92071966a$export$77af9b6a78cc9ab1; });
$parcel$export(module.exports, "commitCommentPermalinkScrollerSaga", function () { return $5ff8e1a92071966a$export$9d841d294c23b204; });
$parcel$export(module.exports, "permalinkClickedScrollerSaga", function () { return $5ff8e1a92071966a$export$643615c4c9e0b984; });
$parcel$export(module.exports, "permalinkChangedScrollerSaga", function () { return $5ff8e1a92071966a$export$fcbde04e9331a2fa; });
$parcel$export(module.exports, "fileScrollerSaga", function () { return $5ff8e1a92071966a$export$8a9e95bf3065662; });
$parcel$export(module.exports, "activeFileCollapsedScrollerSaga", function () { return $5ff8e1a92071966a$export$a99a8dc1374b46cd; });
$parcel$export(module.exports, "scrollToHiddenFile", function () { return $5ff8e1a92071966a$export$3442ba9125cdff16; });
$parcel$export(module.exports, "scrollToFilteredSingleFile", function () { return $5ff8e1a92071966a$export$36683e999b46890f; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $aDsOl = parcelRequire("aDsOl");
parcelRequire("hfhvV");
var $9kTpj = parcelRequire("9kTpj");

var $90kWr = parcelRequire("90kWr");

var $1D6WP = parcelRequire("1D6WP");

var $fEXRj = parcelRequire("fEXRj");

var $iAWzg = parcelRequire("iAWzg");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");
var $dkXlf = parcelRequire("dkXlf");

var $1EkdU = parcelRequire("1EkdU");

var $677Fr = parcelRequire("677Fr");

var $6P2Ar = parcelRequire("6P2Ar");

var $cCrBH = parcelRequire("cCrBH");

var $cw2D7 = parcelRequire("cw2D7");
function* $5ff8e1a92071966a$export$4b20dff7585680d1(filePath) {
    const singleFileModeActiveDiff = yield (0, $5NpoY.a3)((0, $1EkdU.getSingleFileModeActiveDiff));
    if (singleFileModeActiveDiff && filePath !== singleFileModeActiveDiff) {
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.HIGHLIGHT_ACTIVE_TREE_ITEM),
            payload: filePath
        });
        yield (0, $5NpoY.M)((0, $6D21P.DIFFS_HAVE_RENDERED));
        yield (0, $5NpoY.S)((0, $1D6WP.PERMALINK_DELAY));
    }
}
const $5ff8e1a92071966a$export$fb12130627cd2adb = (permalink, isPullRequestPage, additionalOffset)=>{
    const stickyHeaderOffset = (0, $6P2Ar.calculateStickyHeaderOffset)(isPullRequestPage);
    let offsetToApply = stickyHeaderOffset + (0, $6P2Ar.STICKY_FILE_HEIGHT) + (0, $aDsOl.HORIZONTAL_GLOBAL_NAV_HEIGHT);
    if ((0, $9kTpj.LINE_PERMALINK_MATCHER).test(permalink)) offsetToApply += (0, $1D6WP.LINE_PERMALINK_SCROLL_OFFSET);
    else if ((0, $9kTpj.COMMENT_PERMALINK_MATCHER).test(permalink)) offsetToApply += (0, $1D6WP.COMMENT_PERMALINK_SCROLL_OFFSET);
    else if ((0, $9kTpj.SIDEBAR_EXPANDER_HASH_MATCHER).test(permalink)) offsetToApply = (0, $1D6WP.SIDEBAR_EXPANDER_SCROLL_OFFSET);
    if (additionalOffset) offsetToApply += additionalOffset;
    /**
   * This is a scroll behavior function that takes the numbers provided
   * by smooth-scroll-into-view-if-needed library and performs a custom scroll.
   * @param {*} actions See https://www.npmjs.com/package/scroll-into-view-if-needed#function
   */ const customScrollBehavior = (actions)=>{
        // @ts-ignore TODO: fix noImplicitAny error here
        actions.forEach(({ el: el, top: top })=>{
            if (top - offsetToApply >= 0) {
                el.scrollTop = top - offsetToApply;
                offsetToApply = 0;
            } else {
                offsetToApply = offsetToApply - top;
                el.scrollTop = 0;
            }
        });
    };
    return customScrollBehavior;
};
function* $5ff8e1a92071966a$var$openPermalinksFile(filepath) {
    const expansions = yield (0, $5NpoY.a3)((0, $1EkdU.getDiffsExpansions));
    if (filepath && expansions[filepath] !== true) yield (0, $5NpoY.Y)({
        type: (0, $dkXlf.TOGGLE_DIFF_EXPANSION),
        payload: {
            filepath: filepath,
            isOpening: true
        }
    });
}
function* $5ff8e1a92071966a$export$18ace537f0e87ab1(targetId, permalink, additionalOffset = 0) {
    if ((0, $9kTpj.SIDE_BY_SIDE_LINE_PERMALINK_MATCHER).test(permalink)) yield (0, $5NpoY.Y)((0, $dkXlf.toggleSideBySideMode)({
        filePath: (0, $9kTpj.getFilepathFromPermalink)(permalink),
        isSideBySide: true
    }));
    // If the permalink exists in the DOM then the diff has rendered
    // so no need to scroll to the file first.
    const permalinkElement = document.getElementById(permalink);
    // detect whether we are on the pull request page for additional sticky header offset
    const currentPullRequest = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequest));
    const isPullRequestPage = currentPullRequest != null;
    if (permalinkElement) yield (0, $5NpoY.Y)((0, $fEXRj.default)({
        targetId: permalink,
        customBehavior: $5ff8e1a92071966a$export$fb12130627cd2adb(permalink, isPullRequestPage, additionalOffset)
    }));
    else {
        // delay for file anchors to render
        yield (0, $5NpoY.S)((0, $1D6WP.PERMALINK_DELAY));
        yield (0, $5NpoY.Y)((0, $fEXRj.default)({
            targetId: targetId
        }));
        // adjust for rendering delays
        yield (0, $5NpoY.S)((0, $1D6WP.PERMALINK_DELAY));
        yield (0, $5NpoY.Y)((0, $fEXRj.default)({
            targetId: permalink,
            customBehavior: $5ff8e1a92071966a$export$fb12130627cd2adb(permalink, isPullRequestPage, additionalOffset)
        }));
    }
}
function* $5ff8e1a92071966a$export$2a0439691c0dd5c5() {
    const permalink = (0, $9kTpj.getPermalink)() || "";
    if (!permalink || !(0, $9kTpj.LINE_PERMALINK_MATCHER).test(permalink)) return;
    const filepath = (0, $9kTpj.getFilepathFromPermalink)(permalink) || "";
    if (filepath) {
        yield (0, $5NpoY.P)($5ff8e1a92071966a$export$4b20dff7585680d1, (0, $9kTpj.createDiffPermalink)(filepath));
        yield (0, $5NpoY.P)($5ff8e1a92071966a$var$openPermalinksFile, filepath);
    }
    const targetId = permalink && (0, $9kTpj.createDiffPermalink)(filepath);
    if (targetId) yield (0, $5NpoY.P)($5ff8e1a92071966a$export$18ace537f0e87ab1, targetId, permalink);
}
function* $5ff8e1a92071966a$export$32f49e2f92b2df33(targetId) {
    // delay for file anchors to render
    yield (0, $5NpoY.S)((0, $1D6WP.PERMALINK_DELAY));
    yield (0, $5NpoY.Y)((0, $fEXRj.default)({
        targetId: targetId
    }));
}
function* $5ff8e1a92071966a$export$da3b7829a89132eb() {
    const permalink = (0, $9kTpj.getPermalink)() || "";
    if (!permalink || !(0, $9kTpj.FILEPATH_PERMALINK_MATCHER).test(permalink)) return;
    yield (0, $5NpoY.P)($5ff8e1a92071966a$export$4b20dff7585680d1, permalink);
    yield (0, $5NpoY.P)($5ff8e1a92071966a$var$openPermalinksFile, permalink.replace(/chg-/, ""));
    yield (0, $5NpoY.P)($5ff8e1a92071966a$export$32f49e2f92b2df33, permalink);
}
function* $5ff8e1a92071966a$export$aef622e3f3b1b275(filepath) {
    yield (0, $5NpoY.Y)({
        type: (0, $6D21P.OPEN_OUTDATED_COMMENTS_DIALOG),
        payload: filepath
    });
}
function* $5ff8e1a92071966a$export$1206ed5cea67a06e(filepath) {
    yield (0, $5NpoY.Y)({
        type: (0, $6D21P.OPEN_NONRENDERED_DIFF_COMMENTS_DIALOG),
        payload: filepath
    });
}
const $5ff8e1a92071966a$var$isDiffTabSelected = ()=>{
    const segments = location.pathname.split("/");
    // Second pop is needed in case there is a trailing slash
    return (segments.pop() || segments.pop()) === "diff";
};
function* $5ff8e1a92071966a$export$db9eae89818590a4() {
    const isThread = ((0, $9kTpj.getPermalink)() || "").includes("thread");
    const permalink = ((0, $9kTpj.getPermalink)() || "").replace("thread-", "");
    if (!permalink || !(0, $9kTpj.COMMENT_PERMALINK_MATCHER).test(permalink)) return;
    // scroll to comment in permalink
    yield (0, $5NpoY.Y)({
        type: (0, $6D21P.HIGHLIGHT_COMMENT),
        payload: {
            commentId: Number(permalink.replace((0, $9kTpj.COMMENT_PERMALINK_MATCHER), "")),
            highlightThread: isThread
        }
    });
    const allDiffFiles = yield (0, $5NpoY.a3)((0, $1EkdU.getAllDiffFiles));
    const diffFiles = yield (0, $5NpoY.a3)((0, $1EkdU.getDiffFiles));
    const commentsMetaData = yield (0, $5NpoY.a3)((0, $cCrBH.getCommentsMetaData));
    const hiddenDiffComments = yield (0, $5NpoY.a3)((0, $1EkdU.getHiddenDiffComments));
    const isOutdatedCommentsDialogOpen = yield (0, $5NpoY.a3)((0, $1EkdU.getIsOutdatedDialogOpen));
    const isNonRenderedDiffCommentsDialogOpen = yield (0, $5NpoY.a3)((0, $1EkdU.getIsNonRenderedDiffCommentsDialogOpen));
    const matchingCommentForPermalink = commentsMetaData && commentsMetaData.filter(// @ts-ignore TODO: fix noImplicitAny error here
    (commentMetaData)=>commentMetaData.permalink === permalink)[0];
    const offsetForResolutionHeader = matchingCommentForPermalink && matchingCommentForPermalink.isResolved ? 50 : 0;
    const isFilePresentButNotRendered = matchingCommentForPermalink && matchingCommentForPermalink.filepath && (0, $1EkdU.findFileInDiffFiles)(allDiffFiles, matchingCommentForPermalink.filepath) && !(0, $1EkdU.findFileInDiffFiles)(diffFiles, matchingCommentForPermalink.filepath);
    const isCommentHidden = matchingCommentForPermalink && matchingCommentForPermalink.filepath && hiddenDiffComments.includes(matchingCommentForPermalink.filepath) && (0, $1EkdU.findFileInDiffFiles)(diffFiles, matchingCommentForPermalink.filepath);
    const diffTabSelected = $5ff8e1a92071966a$var$isDiffTabSelected();
    const overviewTabSelected = !diffTabSelected;
    const isCommentInOutdatedFile = matchingCommentForPermalink && matchingCommentForPermalink.filepath && !(0, $1EkdU.findFileInDiffFiles)(allDiffFiles, matchingCommentForPermalink.filepath);
    const shouldShowOutdatedCommentsDialog = // since diff files aren't loaded in redux on overview tab, comments can be mistakenly identified as outdated
    !overviewTabSelected && (matchingCommentForPermalink && matchingCommentForPermalink.isOutdated || isCommentInOutdatedFile);
    // global comment
    let targetId = permalink;
    if (matchingCommentForPermalink && matchingCommentForPermalink.filepath) // inline or file-level comment
    targetId = (0, $9kTpj.createDiffPermalink)(matchingCommentForPermalink.filepath);
    // If the file is in the full set of diff files but not in the rendered set,
    // open a modal to show the comment(s) since there's nothing to scroll to
    if (isFilePresentButNotRendered) {
        const singleFileModeActiveDiff = yield (0, $5NpoY.a3)((0, $1EkdU.getSingleFileModeActiveDiff));
        if (singleFileModeActiveDiff && singleFileModeActiveDiff !== targetId) {
            yield (0, $5NpoY.P)($5ff8e1a92071966a$export$4b20dff7585680d1, targetId);
            yield (0, $5NpoY.N)($5ff8e1a92071966a$export$db9eae89818590a4); // scrollToComment
        } else if (!isNonRenderedDiffCommentsDialogOpen) yield (0, $5NpoY.N)($5ff8e1a92071966a$export$1206ed5cea67a06e, matchingCommentForPermalink.filepath);
    } else if (isCommentHidden) {
        yield (0, $5NpoY.Y)((0, $6D21P.toggleDiffComments)(matchingCommentForPermalink.filepath));
        yield (0, $5NpoY.N)($5ff8e1a92071966a$export$db9eae89818590a4);
    } else if (shouldShowOutdatedCommentsDialog) // If the comment is outdated, open that modal otherwise scroll to the file
    // & then the comment in it.
    {
        if (!isOutdatedCommentsDialogOpen) {
            // Only scroll the page & open the modal dialog if it is not already open.
            // This helps prevent the UI from moving all over the place if a user clicks
            // on a comment permalink inside the outdated comments modal dialog.
            if (!isCommentInOutdatedFile) // If the comment is in an outdated file, don't scroll to it since
            // it isn't in shown in the diff set
            yield (0, $5NpoY.P)($5ff8e1a92071966a$export$32f49e2f92b2df33, targetId);
            yield (0, $5NpoY.N)($5ff8e1a92071966a$export$aef622e3f3b1b275, matchingCommentForPermalink.filepath);
        }
    } else {
        if (matchingCommentForPermalink && matchingCommentForPermalink.filepath) yield (0, $5NpoY.P)($5ff8e1a92071966a$var$openPermalinksFile, matchingCommentForPermalink.filepath);
        yield (0, $5NpoY.N)($5ff8e1a92071966a$export$18ace537f0e87ab1, targetId, permalink, offsetForResolutionHeader);
    }
}
function* $5ff8e1a92071966a$export$3f501b605ebf6bd8() {
    const permalink = (0, $9kTpj.getPermalink)() || "";
    if (!permalink || (0, $9kTpj.LINE_PERMALINK_MATCHER).test(permalink) || (0, $9kTpj.COMMENT_PERMALINK_MATCHER).test(permalink) || (0, $9kTpj.FILEPATH_PERMALINK_MATCHER).test(permalink)) return;
    // delay for anchors to render
    yield (0, $5NpoY.S)((0, $1D6WP.PERMALINK_DELAY));
    yield (0, $5NpoY.Y)((0, $fEXRj.default)({
        targetId: permalink
    }));
}
function* $5ff8e1a92071966a$export$1d6350bda6f199f1(permalink) {
    const isDiffPreviouslyLoaded = (yield (0, $5NpoY.a3)((0, $1EkdU.getDiffStat))) && (yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestDiff)));
    const commentsMetaData = yield (0, $5NpoY.a3)((0, $cCrBH.getCommentsMetaData));
    const commentOnDiffTab = commentsMetaData.some((c)=>c.permalink === permalink && c.filepath);
    const diffTabSelected = $5ff8e1a92071966a$var$isDiffTabSelected();
    // Wait for the diff to render before scrolling from a comment tab redirect
    if (commentOnDiffTab && !isDiffPreviouslyLoaded && diffTabSelected) yield (0, $5NpoY._)([
        (0, $5NpoY.M)((0, $6D21P.INITIAL_DIFFS_RENDERED)),
        (0, $5NpoY.M)((0, $6D21P.FETCH_DIFF).SUCCESS),
        (0, $5NpoY.M)((0, $6D21P.LOAD_DIFFSTAT).SUCCESS)
    ]);
    if ((0, $9kTpj.LINE_PERMALINK_MATCHER).test(permalink)) yield (0, $5NpoY.P)($5ff8e1a92071966a$export$2a0439691c0dd5c5);
    else if ((0, $9kTpj.COMMENT_PERMALINK_MATCHER).test(permalink)) yield (0, $5NpoY.P)($5ff8e1a92071966a$export$db9eae89818590a4);
    else if ((0, $9kTpj.FILEPATH_PERMALINK_MATCHER).test(permalink)) yield (0, $5NpoY.P)($5ff8e1a92071966a$export$da3b7829a89132eb);
    else yield (0, $5NpoY.P)($5ff8e1a92071966a$export$3f501b605ebf6bd8);
}
function* $5ff8e1a92071966a$export$77af9b6a78cc9ab1() {
    const commentsLoadingStatus = yield (0, $5NpoY.a3)((0, $cCrBH.getCommentsLoadingState));
    const diffTabSelected = $5ff8e1a92071966a$var$isDiffTabSelected();
    const permalink = ((0, $9kTpj.getPermalink)() || "").replace("thread-", "");
    const isDiffPreviouslyLoaded = (yield (0, $5NpoY.a3)((0, $1EkdU.getDiffStat))) && (yield (0, $5NpoY.a3)((0, $1EkdU.getPullRequestDiff)));
    const commentsMetaData = yield (0, $5NpoY.a3)((0, $cCrBH.getCommentsMetaData));
    const commentOnDiffTab = commentsMetaData.some((c)=>c.permalink === permalink && c.filepath);
    // Wait for the diff to render before scrolling to a permalink if the comment could be in a diff
    if (diffTabSelected || commentOnDiffTab && !isDiffPreviouslyLoaded) yield (0, $5NpoY._)([
        (0, $5NpoY.M)((0, $6D21P.INITIAL_DIFFS_RENDERED)),
        (0, $5NpoY.M)((0, $6D21P.FETCH_DIFF).SUCCESS),
        (0, $5NpoY.M)((0, $6D21P.LOAD_DIFFSTAT).SUCCESS)
    ]);
    // Wait for comments fetch to complete if it is in progress or hasn't started yet
    if (commentsLoadingStatus === (0, $90kWr.LoadingStatus).Fetching || commentsLoadingStatus === (0, $90kWr.LoadingStatus).Before) yield (0, $5NpoY.M)((0, $6D21P.FETCH_COMMENTS).SUCCESS);
    yield (0, $5NpoY.N)($5ff8e1a92071966a$export$db9eae89818590a4);
}
function* $5ff8e1a92071966a$export$9d841d294c23b204() {
    // pullRequestCommentPermalinkScrollerSaga will handle scrolling to comments on the PR page
    const isPullRequestPage = /^\/(.*)\/(.*)\/pull-requests\/(\d+)(\/.*)?/.test(location.pathname);
    if (isPullRequestPage) return;
    yield (0, $5NpoY._)([
        (0, $5NpoY.M)((0, $6D21P.INITIAL_DIFFS_RENDERED)),
        (0, $5NpoY.M)((0, $6D21P.FETCH_COMMENTS).SUCCESS),
        (0, $5NpoY.M)((0, $6D21P.FETCH_DIFF).SUCCESS),
        (0, $5NpoY.M)((0, $6D21P.LOAD_DIFFSTAT).SUCCESS)
    ]);
    yield (0, $5NpoY.N)($5ff8e1a92071966a$export$db9eae89818590a4);
}
function* $5ff8e1a92071966a$export$643615c4c9e0b984() {
    // detect whether we are on the pull request page for additional sticky header offset
    const currentPullRequest = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequest));
    const isPullRequestPage = currentPullRequest != null;
    while(true){
        const { payload: activePermalink } = yield (0, $5NpoY.M)((0, $6D21P.ACTIVE_DIFF_PERMALINK));
        yield (0, $5NpoY.Y)((0, $fEXRj.default)({
            targetId: activePermalink,
            customBehavior: $5ff8e1a92071966a$export$fb12130627cd2adb(activePermalink, isPullRequestPage)
        }));
        (0, $9kTpj.updateHashInURL)(activePermalink, (0, $677Fr.default));
    }
}
function* $5ff8e1a92071966a$export$fcbde04e9331a2fa() {
    while(true){
        const { payload: permalink } = yield (0, $5NpoY.M)((0, $6D21P.PERMALINK_HASH_CHANGE));
        yield (0, $5NpoY.P)($5ff8e1a92071966a$export$1d6350bda6f199f1, permalink);
    }
}
function* $5ff8e1a92071966a$export$8a9e95bf3065662(action) {
    const { payload: targetId, skipSagaScroll: skipSagaScroll } = action;
    const isSingleFileModeActive = yield (0, $5NpoY.a3)((0, $1EkdU.getIsSingleFileModeActive));
    const isPullRequestPage = /^\/(.*)\/(.*)\/pull-requests\/(\d+)(\/.*)?/.test(location.pathname);
    // Scroll to the root instead of the file anchor in IA SFM to avoid the compact
    // header transitioning sporadically between files
    const shouldScrollToRoot = isSingleFileModeActive && isPullRequestPage;
    if (isSingleFileModeActive && !shouldScrollToRoot) // When in single file mode, clicking a new file in the file tree should cause
    // the page to scroll to the top of the new file. Since scrolling requres the
    // correct filepath-based anchor element to be rendered on the page, we need to
    // wait for the diff to render before starting scrolling. If scrolling to the top,
    // we don't need to wait for the diff to render.
    yield (0, $5NpoY.M)((0, $6D21P.DIFFS_HAVE_RENDERED));
    if (shouldScrollToRoot) window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
    else if (!skipSagaScroll) yield (0, $5NpoY.P)($5ff8e1a92071966a$export$32f49e2f92b2df33, targetId);
    (0, $9kTpj.updateHashInURL)(targetId, (0, $677Fr.default));
}
function* $5ff8e1a92071966a$export$a99a8dc1374b46cd(action) {
    const activeDiff = yield (0, $5NpoY.a3)((0, $1EkdU.getActiveDiff));
    const { payload: payload } = action;
    const filePath = payload.filepath;
    const targetId = (0, $9kTpj.createDiffPermalink)(filePath);
    if (activeDiff === targetId) yield (0, $5NpoY.Y)((0, $fEXRj.default)({
        targetId: targetId
    }));
}
function* $5ff8e1a92071966a$export$c44ffa7368b507d(anchorId) {
    yield (0, $5NpoY.P)($5ff8e1a92071966a$export$4b20dff7585680d1, anchorId);
    yield (0, $5NpoY.S)((0, $1D6WP.PERMALINK_DELAY));
    yield (0, $5NpoY.Y)((0, $iAWzg.default)("none"));
    yield (0, $5NpoY.Y)((0, $6D21P.scrollToAnchor)(anchorId));
}
function* $5ff8e1a92071966a$export$3442ba9125cdff16() {
    while(true){
        const { payload: anchor } = yield (0, $5NpoY.M)((0, $6D21P.HIDDEN_FILE_DIALOG).CONFIRM);
        yield (0, $5NpoY.P)($5ff8e1a92071966a$export$c44ffa7368b507d, anchor);
    }
}
function* $5ff8e1a92071966a$export$36683e999b46890f() {
    const isSingleFileModeActive = yield (0, $5NpoY.a3)((0, $1EkdU.getIsSingleFileModeActive));
    // getFileTreeHrefs will return list of hrefs that's already filtered/sorted
    const fileHrefs = yield (0, $5NpoY.a3)((0, $cw2D7.getFileTreeHrefs));
    const activeDiff = yield (0, $5NpoY.a3)((0, $1EkdU.getActiveDiff));
    if (!isSingleFileModeActive || !fileHrefs.length) return;
    const newAnchor = fileHrefs[0].replace(/#/, "");
    // don't scroll to file if it's already being viewed
    if (activeDiff !== newAnchor) yield (0, $5NpoY.P)($5ff8e1a92071966a$export$c44ffa7368b507d, newAnchor);
}

});
parcelRegister("6P2Ar", function(module, exports) {

$parcel$export(module.exports, "STICKY_FILE_HEIGHT", function () { return $f931cde2b130ab96$export$c00fb1df58bfbf28; });
$parcel$export(module.exports, "STICKY_DIFF_HEADER_HEIGHT_OFFSET", function () { return $f931cde2b130ab96$export$d4b0efd487f56c5c; });
$parcel$export(module.exports, "STICKY_FILE_HEADER_HEIGHT_OFFSET", function () { return $f931cde2b130ab96$export$ffe4cfb0caaeb235; });
$parcel$export(module.exports, "TABBED_STICKY_HEADER_HEIGHT", function () { return $f931cde2b130ab96$export$fde53128274398c1; });
$parcel$export(module.exports, "TABBED_STICKY_HEADER_DIFF_PADDING", function () { return $f931cde2b130ab96$export$b76c28d35b6bc79f; });
$parcel$export(module.exports, "TABBED_STICKY_HEADER_FILE_TREE_PADDING", function () { return $f931cde2b130ab96$export$c6b03ada55e1776c; });
$parcel$export(module.exports, "TABBED_MOBILE_STICKY_HEADER_HEIGHT", function () { return $f931cde2b130ab96$export$b033241e5559b8d0; });
$parcel$export(module.exports, "MOBILE_NAV_HEIGHT", function () { return $f931cde2b130ab96$export$f2b895ab4ce26701; });
$parcel$export(module.exports, "calculateStickyHeaderOffset", function () { return $f931cde2b130ab96$export$9e8b6510304c65cd; });
$parcel$export(module.exports, "calculateOffsetForNavNext", function () { return $f931cde2b130ab96$export$4faf1ed19e3a5548; });

var $aP6k3 = parcelRequire("aP6k3");
const $f931cde2b130ab96$export$c00fb1df58bfbf28 = 42;
const $f931cde2b130ab96$export$d4b0efd487f56c5c = 54;
const $f931cde2b130ab96$export$ffe4cfb0caaeb235 = 56;
const $f931cde2b130ab96$export$fde53128274398c1 = 70;
const $f931cde2b130ab96$export$b76c28d35b6bc79f = 15;
const $f931cde2b130ab96$export$c6b03ada55e1776c = 16;
const $f931cde2b130ab96$export$b033241e5559b8d0 = 40;
const $f931cde2b130ab96$export$f2b895ab4ce26701 = 54;
const $f931cde2b130ab96$export$9e8b6510304c65cd = (hasCommentNav, fileHeaderHeight)=>{
    const offset = fileHeaderHeight || $f931cde2b130ab96$export$ffe4cfb0caaeb235;
    return hasCommentNav ? $f931cde2b130ab96$export$d4b0efd487f56c5c + offset : $f931cde2b130ab96$export$d4b0efd487f56c5c;
};
// Ak Navigation widths are copied from @atlaskit/navigation-next because they can't be imported
const $f931cde2b130ab96$var$closedProductNavWidth = (0, $aP6k3.gridSize)() * 2.5;
const $f931cde2b130ab96$export$4faf1ed19e3a5548 = (isNavigationOpen, isMobileHeaderActive, sidebarWidth, productNavWidth)=>{
    let offset;
    if (isNavigationOpen && isMobileHeaderActive) return 0;
    if (isNavigationOpen) offset = productNavWidth;
    else offset = $f931cde2b130ab96$var$closedProductNavWidth;
    offset += sidebarWidth;
    return offset;
};

});

parcelRegister("cw2D7", function(module, exports) {

$parcel$export(module.exports, "getFileTree", function () { return $ecd74d36cfe7a891$export$f4c6651e7b26bd32; });
$parcel$export(module.exports, "makeGetIsActiveDiff", function () { return $ecd74d36cfe7a891$export$972a180f4b171105; });
$parcel$export(module.exports, "getFileTreeHrefs", function () { return $ecd74d36cfe7a891$export$d67bb152feeb81d2; });

var $aXXtM = parcelRequire("aXXtM");

var $1EkdU = parcelRequire("1EkdU");

var $ecsiI = parcelRequire("ecsiI");

var $cCrBH = parcelRequire("cCrBH");

var $70vW8 = parcelRequire("70vW8");

var $4coax = parcelRequire("4coax");
// @ts-ignore TODO: fix noImplicitAny error here
const $ecd74d36cfe7a891$var$addConflictMarkers = (diffStat, conflicts)=>diffStat.map((stat)=>{
        const filepath = (0, $4coax.extractFilepath)(stat);
        // @ts-ignore TODO: fix noImplicitAny error here
        const hasConflict = conflicts.find((c)=>c.path === filepath);
        return {
            ...stat,
            isConflicted: !!hasConflict
        };
    });
// @ts-ignore TODO: fix noImplicitAny error here
const $ecd74d36cfe7a891$var$addCommentCounts = (diffStat, conversations)=>// @ts-ignore TODO: fix noImplicitAny error here
    diffStat.map((stat)=>{
        const filepath = (0, $4coax.extractFilepath)(stat);
        const conversationsForFile = conversations.filter(// @ts-ignore TODO: fix noImplicitAny error here
        (conversation)=>filepath === conversation.meta.path);
        const totalComments = conversationsForFile.reduce(// @ts-ignore TODO: fix noImplicitAny error here
        (runningCount, currentConversation)=>runningCount + currentConversation.numOfComments, 0);
        return {
            ...stat,
            comments: totalComments
        };
    });
const $ecd74d36cfe7a891$var$addHiddenFileMarker = (diffStat, filteredDiffStat)=>{
    return diffStat.map((stat)=>{
        stat.isHidden = !filteredDiffStat.find((filteredStat)=>(0, $ecsiI.getDiffStatPath)(stat, (0, $ecsiI.DiffStatPathType).Unescaped) === (0, $ecsiI.getDiffStatPath)(filteredStat, (0, $ecsiI.DiffStatPathType).Unescaped));
        return stat;
    });
};
const $ecd74d36cfe7a891$export$f4c6651e7b26bd32 = (0, $aXXtM.createSelector)((0, $1EkdU.getFilteredDiffStat), (0, $1EkdU.getConflicts), (0, $cCrBH.getConversations), (filteredDiffStat, conflicts = [], conversations = [])=>{
    if (!filteredDiffStat) return null;
    let annotatedDiffStat = $ecd74d36cfe7a891$var$addConflictMarkers(filteredDiffStat, conflicts);
    annotatedDiffStat = $ecd74d36cfe7a891$var$addHiddenFileMarker(annotatedDiffStat, filteredDiffStat);
    annotatedDiffStat = $ecd74d36cfe7a891$var$addCommentCounts(annotatedDiffStat, conversations);
    return (0, $70vW8.diffStatToFileTree)(annotatedDiffStat);
});
const $ecd74d36cfe7a891$export$972a180f4b171105 = (href)=>(0, $aXXtM.createSelector)((0, $1EkdU.getActiveDiff), (activeDiff)=>!!activeDiff && `#${activeDiff}` === href);
const $ecd74d36cfe7a891$export$d67bb152feeb81d2 = (0, $aXXtM.createSelector)((0, $1EkdU.getFilteredDiffStat), (filteredAndSortedDiffStat)=>(filteredAndSortedDiffStat || []).map((diffStat)=>`#chg-${(0, $ecsiI.getDiffStatPath)(diffStat, (0, $ecsiI.DiffStatPathType).Unescaped)}`));

});


parcelRegister("3qdsi", function(module, exports) {

$parcel$export(module.exports, "startWatchSaga", function () { return $3dc6c5fcf6ea8bde$export$ab4b45f54439e648; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $lf0Id = parcelRequire("lf0Id");

var $g8glp = parcelRequire("g8glp");
function* $3dc6c5fcf6ea8bde$export$ab4b45f54439e648() {
    const api = yield* (0, $g8glp.getPullRequestApis)();
    while(true){
        yield (0, $5NpoY.M)((0, $6D21P.START_WATCH).BEGIN);
        yield* (0, $lf0Id.watchSaga)(api.startWatch);
    }
}

});

parcelRegister("ffege", function(module, exports) {

$parcel$export(module.exports, "stopWatchSaga", function () { return $d0c5196802d72bc9$export$339856d023fbab; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $lf0Id = parcelRequire("lf0Id");

var $g8glp = parcelRequire("g8glp");
function* $d0c5196802d72bc9$export$339856d023fbab() {
    const api = yield* (0, $g8glp.getPullRequestApis)();
    while(true){
        yield (0, $5NpoY.M)((0, $6D21P.STOP_WATCH).BEGIN);
        yield* (0, $lf0Id.watchSaga)(api.stopWatch);
    }
}

});

parcelRegister("b88QV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26feb2e10f2be947$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $krSFm = parcelRequire("krSFm");

var $g2R3c = parcelRequire("g2R3c");

var $k2cPS = parcelRequire("k2cPS");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");
function* $26feb2e10f2be947$export$3db2bac75a00cf1f(action) {
    const { payload: { url: url, task: selectedTask, nextTaskState: nextTaskState } } = action;
    const user = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
    const tasks = yield (0, $5NpoY.a3)((0, $krSFm.getTasks));
    const nextTask = {
        ...selectedTask,
        state: nextTaskState
    };
    const nextTasks = tasks.map((task)=>task.id === selectedTask.id ? nextTask : task);
    yield (0, $5NpoY.Y)({
        type: (0, $6D21P.TASK_STATE_CHANGE).SUCCESS,
        payload: {
            user: user,
            task: nextTask,
            nextTasks: nextTasks
        }
    });
    const authWrapped = (0, $k2cPS.default)(url, {
        method: "PUT",
        headers: (0, $k2cPS.jsonHeaders),
        body: JSON.stringify({
            state: nextTaskState
        })
    });
    const response = yield (0, $5NpoY.P)(fetch, authWrapped);
    if (!response.ok) yield (0, $5NpoY.Y)({
        type: (0, $6D21P.TASK_STATE_CHANGE).ERROR,
        payload: [
            ...tasks
        ]
    });
}
function* $26feb2e10f2be947$export$2e2bcd8739ae039() {
    yield (0, $jeUNF.takeEvery)((0, $6D21P.TASK_STATE_CHANGE).REQUEST, $26feb2e10f2be947$export$3db2bac75a00cf1f);
}

});

parcelRegister("dBEfZ", function(module, exports) {

$parcel$export(module.exports, "toggleCommentLike", function () { return $7b96c273e3c4aebf$export$8f132e047e7e4777; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $3XbtU = parcelRequire("3XbtU");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $b2RHC = parcelRequire("b2RHC");

var $czBtW = parcelRequire("czBtW");

var $8d101 = parcelRequire("8d101");

var $aanBq = parcelRequire("aanBq");

var $g2R3c = parcelRequire("g2R3c");

var $k2cPS = parcelRequire("k2cPS");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $1EkdU = parcelRequire("1EkdU");
function* $7b96c273e3c4aebf$export$8f132e047e7e4777(action) {
    if (!action.payload) return;
    const { owner: owner, slug: slug, id: id } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    const { result: { commentId: commentId, setToLike: setToLike, autoreviewFeedbackAttributes: autoreviewFeedbackAttributes } } = action.payload;
    const commentLikesUrl = (0, $czBtW.default).api.internal.likeComment(owner, slug, id, commentId);
    const authUrl = (0, $k2cPS.default)(commentLikesUrl, {
        method: setToLike ? "POST" : "DELETE"
    });
    const repoUUID = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryUuid));
    const prId = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestId));
    (0, $8d101.publishCommentLikesUiEvent)(repoUUID, prId, commentId, setToLike, autoreviewFeedbackAttributes);
    const currentUserUuid = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUserKey));
    const commentLikes = yield (0, $5NpoY.a3)((0, $1EkdU.getCommentLikes), [
        {
            id: commentId
        }
    ]);
    try {
        const response = yield (0, $5NpoY.P)(fetch, authUrl);
        if (response.ok) yield (0, $5NpoY.Y)({
            type: (0, $6D21P.TOGGLE_COMMENT_LIKE).SUCCESS
        });
        else if (setToLike && response.status === 400 || !setToLike && response.status === 404) yield (0, $5NpoY.Y)({
            type: (0, $6D21P.TOGGLE_COMMENT_LIKE).SUCCESS
        });
        else // An unknown situation occured, reverse the pre-emptive comment likes change
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.TOGGLE_COMMENT_LIKE).ERROR,
            payload: (0, $8d101.toggledCommentLike)(commentId, commentLikes, currentUserUuid),
            meta: {
                schema: (0, $b2RHC.commentLikes)
            }
        });
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.TOGGLE_COMMENT_LIKE).ERROR,
            payload: (0, $8d101.toggledCommentLike)(commentId, commentLikes, currentUserUuid),
            meta: {
                schema: (0, $b2RHC.commentLikes)
            }
        });
        $3XbtU.captureException(e);
    }
}

});
parcelRegister("8d101", function(module, exports) {

$parcel$export(module.exports, "isCommentLikedByUser", function () { return $dbe7acc43d67e63a$export$681553961ff9dce3; });
$parcel$export(module.exports, "getCommentLikers", function () { return $dbe7acc43d67e63a$export$b37a3d7261c91cb8; });
$parcel$export(module.exports, "toggledCommentLike", function () { return $dbe7acc43d67e63a$export$2455bcf97b212cf8; });
$parcel$export(module.exports, "toggleCommentLikeAction", function () { return $dbe7acc43d67e63a$export$6a0e72bb6591c16c; });
$parcel$export(module.exports, "publishCommentLikesUiEvent", function () { return $dbe7acc43d67e63a$export$abfcb87e4ff2d0e2; });
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $b2RHC = parcelRequire("b2RHC");

var $6aoKW = parcelRequire("6aoKW");
const $dbe7acc43d67e63a$export$681553961ff9dce3 = (commentId, commentLikes, currentUserUuid)=>{
    if (!commentLikes || !currentUserUuid) return false;
    const likes = commentLikes.find((commentLike)=>commentLike.commentId === commentId);
    if (likes) return !!likes.users.find((user)=>user.uuid === currentUserUuid);
    return false;
};
const $dbe7acc43d67e63a$export$b37a3d7261c91cb8 = (commentId, commentLikes)=>{
    if (!commentId || !commentLikes || commentLikes.length === 0) return [];
    const likes = commentLikes.find((commentLike)=>commentLike.commentId === commentId);
    return likes ? likes.users : [];
};
const $dbe7acc43d67e63a$export$2455bcf97b212cf8 = (commentId, commentLikes, currentUserUuid)=>{
    if (!currentUserUuid || !commentLikes) return {};
    const likers = $dbe7acc43d67e63a$export$b37a3d7261c91cb8(commentId, commentLikes);
    if (likers.find((user)=>user.uuid === currentUserUuid)) return {
        commentId: commentId,
        users: likers.filter((user)=>user.uuid !== currentUserUuid).map((u)=>u.uuid)
    };
    return {
        commentId: commentId,
        users: [
            ...likers.map((u)=>u.uuid),
            currentUserUuid
        ]
    };
};
const $dbe7acc43d67e63a$export$6a0e72bb6591c16c = (commentId, commentLikes, currentUserUuid, autoreviewFeedbackAttributes)=>({
        type: (0, $6D21P.TOGGLE_COMMENT_LIKE).REQUEST,
        payload: {
            commentId: commentId,
            setToLike: !$dbe7acc43d67e63a$export$681553961ff9dce3(commentId, commentLikes, currentUserUuid),
            commentLike: $dbe7acc43d67e63a$export$2455bcf97b212cf8(commentId, commentLikes, currentUserUuid),
            autoreviewFeedbackAttributes: autoreviewFeedbackAttributes
        },
        meta: {
            schema: {
                commentLike: (0, $b2RHC.commentLikes)
            }
        }
    });
const $dbe7acc43d67e63a$export$abfcb87e4ff2d0e2 = (repoUUID, prId, commentId, setToLike, autoreviewFeedbackAttributes)=>{
    (0, $6aoKW.publishUiEvent)({
        action: "clicked",
        actionSubject: "button",
        actionSubjectId: "likePullRequestCommentButton",
        source: "pullRequestScreen",
        objectId: `${repoUUID}/${prId}`,
        objectType: "repository",
        attributes: {
            action: setToLike ? "liked" : "unlike",
            commentId: commentId,
            ...autoreviewFeedbackAttributes
        }
    });
};

});


parcelRegister("a8V3A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $954001b72b53d21a$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $czBtW = parcelRequire("czBtW");

var $k2cPS = parcelRequire("k2cPS");

var $1EkdU = parcelRequire("1EkdU");

var $gadFw = parcelRequire("gadFw");

var $58TOz = parcelRequire("58TOz");
function* $954001b72b53d21a$var$undoPullRequestChangesRequest() {
    const { owner: owner, slug: slug, id: id } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    const url = (0, $czBtW.default).api.v20.requestChanges(owner, slug, id);
    const authUrl = (0, $k2cPS.default)(url);
    try {
        const response = yield (0, $5NpoY.P)(fetch, authUrl, {
            method: "DELETE"
        });
        if (!response.ok) {
            const message = yield (0, $5NpoY.P)((0, $58TOz.getErrorMessage), response.clone());
            throw Error(message);
        }
        yield (0, $5NpoY.P)((0, $gadFw.default));
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.UNDO_REQUEST_CHANGES).SUCCESS
        });
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.UNDO_REQUEST_CHANGES).ERROR,
            payload: e.message,
            error: true
        });
    }
}
var $954001b72b53d21a$export$2e2bcd8739ae039 = $954001b72b53d21a$var$undoPullRequestChangesRequest;

});

parcelRegister("bjEV1", function(module, exports) {

$parcel$export(module.exports, "updateLastSeenSaga", function () { return $80c32265b7133c54$export$192b2f1643d75a; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $1EkdU = parcelRequire("1EkdU");

var $aanBq = parcelRequire("aanBq");

var $3zw71 = parcelRequire("3zw71");
function* $80c32265b7133c54$export$192b2f1643d75a() {
    const repositoryFullSlug = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryFullSlug));
    const pullRequestId = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestId));
    yield (0, $5NpoY.P)((0, $3zw71.updatePullRequestLastSeen), repositoryFullSlug, pullRequestId);
}

});
parcelRegister("3zw71", function(module, exports) {

$parcel$export(module.exports, "hasUnseenActivity", function () { return $afff1e1e61c4f964$export$1c5038b793f01ebe; });
$parcel$export(module.exports, "updatePullRequestLastSeen", function () { return $afff1e1e61c4f964$export$45dd4c06627b1b54; });

var $lIZwG = parcelRequire("lIZwG");

var $37k4E = parcelRequire("37k4E");
// Can't guarantee activity timestamp fidelity under 1 second
const $afff1e1e61c4f964$var$PR_ACTIVITY_FIDELITY = 1000;
const $afff1e1e61c4f964$export$1c5038b793f01ebe = (pullRequest)=>{
    const lastCommented = (pullRequest.extra || {}).last_comment;
    if (!lastCommented) return false;
    // Lacking this for any reason will result in TRUE - "having unseen activity"
    const repositoryFullSlug = (0, $lIZwG.default)(pullRequest, "destination.repository.full_name");
    const id = (0, $lIZwG.default)(pullRequest, "id");
    const lastViewed = (0, $37k4E.default).get(repositoryFullSlug, id);
    if (!lastViewed) return true;
    // `lastCommented` has a timezone, but Bitbucket does not store `lastViewed`
    // with one. They need to both have a TZ in order to properly create the dates
    // and compare them
    const lastViewedWithTimezone = `${lastViewed}Z`;
    return new Date(lastCommented).getTime() - new Date(lastViewedWithTimezone).getTime() > $afff1e1e61c4f964$var$PR_ACTIVITY_FIDELITY;
};
const $afff1e1e61c4f964$export$45dd4c06627b1b54 = (repositoryFullSlug, id)=>{
    const nowWithoutTimezone = new Date().toISOString().replace(/Z/, "");
    (0, $37k4E.default).set(repositoryFullSlug, id, nowWithoutTimezone);
};

});
parcelRegister("37k4E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8adea00c04d2ebe0$export$2e2bcd8739ae039; });

var $h3kk7 = parcelRequire("h3kk7");
const $8adea00c04d2ebe0$var$storageKey = "pullrequest-history";
const $8adea00c04d2ebe0$var$getAll = ()=>(0, $h3kk7.default).get($8adea00c04d2ebe0$var$storageKey) || {};
const $8adea00c04d2ebe0$var$buildKey = (repositoryFullSlug, pullRequestId)=>`${repositoryFullSlug}:${pullRequestId}`;
var $8adea00c04d2ebe0$export$2e2bcd8739ae039 = {
    clearAll () {
        (0, $h3kk7.default).clearAll();
    },
    get (repositoryFullSlug, pullRequestId) {
        return $8adea00c04d2ebe0$var$getAll()[$8adea00c04d2ebe0$var$buildKey(repositoryFullSlug, pullRequestId)];
    },
    set (repositoryFullSlug, pullRequestId, lastUpdated) {
        const lastViewedMap = $8adea00c04d2ebe0$var$getAll();
        lastViewedMap[$8adea00c04d2ebe0$var$buildKey(repositoryFullSlug, pullRequestId)] = lastUpdated;
        (0, $h3kk7.default).set($8adea00c04d2ebe0$var$storageKey, lastViewedMap);
    }
};

});



parcelRegister("k94X1", function(module, exports) {

$parcel$export(module.exports, "updatePrDescriptionSaga", function () { return $550bfe7105ec52a3$export$d7c5bd09d7658a9a; });
$parcel$export(module.exports, "updatePrTitleSaga", function () { return $550bfe7105ec52a3$export$be1fc742abe03568; });
$parcel$export(module.exports, "removeReviewerSaga", function () { return $550bfe7105ec52a3$export$c8ef4d5ed7dc565d; });
$parcel$export(module.exports, "addReviewerSaga", function () { return $550bfe7105ec52a3$export$1821a2abcef045ca; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $3XbtU = parcelRequire("3XbtU");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $2kKDW = parcelRequire("2kKDW");

var $1EkdU = parcelRequire("1EkdU");

var $g2R3c = parcelRequire("g2R3c");

var $6aoKW = parcelRequire("6aoKW");

var $k2cPS = parcelRequire("k2cPS");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $e9BOm = parcelRequire("e9BOm");

var $czBtW = parcelRequire("czBtW");

var $6vkvB = parcelRequire("6vkvB");

var $58TOz = parcelRequire("58TOz");
const $550bfe7105ec52a3$export$defe85febe8b728c = {
    prTitleFlagTitleError: {
        id: "frontbucket.repository.pullrequest.flags.updatePrTitle.titleError",
        description: "Text for title of flag indicating updating PR title has failed",
        defaultMessage: "Something went wrong"
    },
    prTitleFlagDescriptionError: {
        id: "frontbucket.repository.pullrequest.flags.updatePrTitle.descriptionError",
        description: "Text for description of flag indicating updating PR title has failed",
        defaultMessage: "We couldn\u2019t update the title. Wait a few minutes and then try again."
    },
    prDescriptionFlagTitleError: {
        id: "frontbucket.repository.pullrequest.flags.updatePrDesc.titleError",
        description: "Text for title of flag indicating updating PR description has failed",
        defaultMessage: "Something went wrong"
    },
    prDescriptionFlagDescriptionError: {
        id: "frontbucket.repository.pullrequest.flags.updatePrDesc.descriptionError",
        description: "Text for description of flag indicating updating PR description has failed",
        defaultMessage: "We couldn\u2019t update the description. Wait a few minutes and then try again."
    },
    prAddReviewerFlagDescriptionError: {
        id: "frontbucket.repository.pullrequest.flags.addReviewer.descriptionError",
        description: "Text for description of flag indicating adding a reviewer has failed",
        defaultMessage: "We couldn\u2019t add a reviewer. Wait a few minutes and then try again."
    },
    prRemoveReviewerFlagTitleError: {
        id: "frontbucket.repository.pullrequest.flags.removeReviewer.titleError",
        description: "Text for title of flag indicating removing a reviewer has failed",
        defaultMessage: "Something went wrong"
    },
    prAddReviewerFlagTitleError: {
        id: "frontbucket.repository.pullrequest.flags.addReviewer.titleError",
        description: "Text for title of flag indicating removing a reviewer has failed",
        defaultMessage: "Something went wrong"
    },
    prDescriptionFlagTitleSuccess: {
        id: "frontbucket.repository.pullrequest.flags.updatePrDesc.titleSuccess",
        description: "Text for title of flag indicating updating PR description has succeeded",
        defaultMessage: "Success"
    }
};
const $550bfe7105ec52a3$var$errorDescriptionFlag = (0, $2kKDW.showFlag)({
    id: (0, $6D21P.UPDATE_DESCRIPTION).ERROR,
    iconType: "error",
    title: {
        msg: $550bfe7105ec52a3$export$defe85febe8b728c.prDescriptionFlagTitleError
    },
    description: {
        msg: $550bfe7105ec52a3$export$defe85febe8b728c.prDescriptionFlagDescriptionError
    },
    autoDismiss: true
});
const $550bfe7105ec52a3$var$errorTitleFlag = (0, $2kKDW.showFlag)({
    id: (0, $6D21P.UPDATE_TITLE).ERROR,
    iconType: "error",
    title: {
        msg: $550bfe7105ec52a3$export$defe85febe8b728c.prTitleFlagTitleError
    },
    description: {
        msg: $550bfe7105ec52a3$export$defe85febe8b728c.prTitleFlagDescriptionError
    },
    autoDismiss: true
});
const $550bfe7105ec52a3$var$errorAddReviewerFlag = (0, $2kKDW.showFlag)({
    id: (0, $6D21P.ADD_REVIEWER).ERROR,
    iconType: "error",
    title: {
        msg: $550bfe7105ec52a3$export$defe85febe8b728c.prAddReviewerFlagTitleError
    },
    description: {
        msg: $550bfe7105ec52a3$export$defe85febe8b728c.prAddReviewerFlagDescriptionError
    },
    autoDismiss: true
});
function* $550bfe7105ec52a3$export$d7c5bd09d7658a9a(action) {
    const newDescription = action.payload.description;
    const { owner: owner, slug: slug, id: id } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    const url = (0, $czBtW.default).api.v20.pullRequest(owner, slug, id);
    const updateRequest = (0, $k2cPS.default)(url, {
        method: "PUT",
        headers: (0, $k2cPS.jsonHeaders),
        body: JSON.stringify({
            description: newDescription
        })
    });
    try {
        const response = yield (0, $5NpoY.P)(fetch, updateRequest);
        if (!response.ok) {
            const message = yield (0, $5NpoY.P)((0, $58TOz.getErrorMessage), response.clone());
            yield (0, $5NpoY.Y)({
                type: (0, $6D21P.UPDATE_DESCRIPTION).ERROR,
                payload: {
                    error: message
                }
            });
            yield (0, $5NpoY.Y)($550bfe7105ec52a3$var$errorDescriptionFlag);
        } else {
            const respPr = yield response.json();
            // merge current and updated PR from resp
            const currentPr = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequest));
            const currentUser = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
            const updatedPr = {
                ...currentPr,
                description: respPr.description,
                rendered: respPr.rendered,
                updated_on: respPr.updated_on
            };
            yield (0, $5NpoY.Y)((0, $e9BOm.updatePullRequest)({
                type: (0, $6D21P.UPDATE_DESCRIPTION).SUCCESS,
                pullRequest: updatedPr,
                currentUser: currentUser
            }));
            (0, $6aoKW.publishTrackEvent)({
                action: "editedSuccess",
                actionSubject: "prDescInlineEdit",
                actionSubjectId: `${owner}/${slug}/${id}`,
                source: (0, $6vkvB.PULL_REQUEST_SCREEN_NAME)
            });
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.UPDATE_DESCRIPTION).ERROR,
            payload: {
                error: e.toString()
            }
        });
        yield (0, $5NpoY.Y)($550bfe7105ec52a3$var$errorDescriptionFlag);
    }
}
function* $550bfe7105ec52a3$export$be1fc742abe03568(action) {
    const newTitle = action.payload.title;
    const { owner: owner, slug: slug, id: id } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    const url = (0, $czBtW.default).api.v20.pullRequest(owner, slug, id);
    // API requires title, current reviewers and closes_source_branch to be sent to prevent
    // clearing of this data after PUT
    const updateRequest = (0, $k2cPS.default)(url, {
        method: "PUT",
        headers: (0, $k2cPS.jsonHeaders),
        body: JSON.stringify({
            title: newTitle
        })
    });
    try {
        const response = yield (0, $5NpoY.P)(fetch, updateRequest);
        if (!response.ok) {
            const message = yield (0, $5NpoY.P)((0, $58TOz.getErrorMessage), response.clone());
            yield (0, $5NpoY.Y)({
                type: (0, $6D21P.UPDATE_TITLE).ERROR,
                payload: {
                    error: message
                }
            });
            yield (0, $5NpoY.Y)($550bfe7105ec52a3$var$errorTitleFlag);
        } else {
            const respPr = yield response.json();
            // merge current and updated PR from resp
            const currentPr = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequest));
            const currentUser = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
            const updatedPr = {
                ...currentPr,
                rendered: respPr.rendered,
                updated_on: respPr.updated_on,
                title: respPr.title
            };
            yield (0, $5NpoY.Y)((0, $e9BOm.updatePullRequest)({
                type: (0, $6D21P.UPDATE_TITLE).SUCCESS,
                pullRequest: updatedPr,
                oldTitle: currentPr.title,
                currentUser: currentUser
            }));
            (0, $6aoKW.publishTrackEvent)({
                action: "editedSuccess",
                actionSubject: "prTitleInlineEdit",
                actionSubjectId: `${owner}/${slug}/${id}`,
                source: (0, $6vkvB.PULL_REQUEST_SCREEN_NAME)
            });
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.UPDATE_TITLE).ERROR,
            payload: {
                error: e.toString()
            }
        });
        yield (0, $5NpoY.Y)($550bfe7105ec52a3$var$errorTitleFlag);
    }
}
function* $550bfe7105ec52a3$export$c8ef4d5ed7dc565d(action) {
    const { payload: { userAaid: userAaid } } = action;
    const { owner: owner, slug: slug, id: id } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    const url = (0, $czBtW.default).api.internal.updateReviewer(owner, slug, id, userAaid);
    const deleteRequest = (0, $k2cPS.default)(url, {
        method: "DELETE"
    });
    try {
        const response = yield (0, $5NpoY.P)(fetch, deleteRequest);
        if (!response.ok) {
            const message = yield (0, $5NpoY.P)((0, $58TOz.getErrorMessage), response.clone());
            throw new Error(message);
        } else {
            const respPr = yield response.json();
            const currentPr = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequest));
            const currentUser = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
            const removedUser = currentPr.participants.find((participant)=>{
                var _participant$user;
                return ((_participant$user = participant.user) === null || _participant$user === void 0 ? void 0 : _participant$user.account_id) === userAaid;
            });
            const updatedPr = {
                ...currentPr,
                participants: respPr.participants
            };
            yield (0, $5NpoY.Y)((0, $e9BOm.updatePullRequest)({
                type: (0, $6D21P.REMOVE_REVIEWER).SUCCESS,
                pullRequest: updatedPr,
                userAaid: userAaid,
                currentUser: currentUser,
                removedUser: (removedUser === null || removedUser === void 0 ? void 0 : removedUser.user) || undefined
            }));
            (0, $6aoKW.publishTrackEvent)({
                action: "removed",
                actionSubject: "prReviewers",
                actionSubjectId: `${owner}/${slug}/${id}`,
                source: (0, $6vkvB.PULL_REQUEST_SCREEN_NAME)
            });
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.REMOVE_REVIEWER).ERROR,
            payload: {
                error: e
            }
        });
        yield (0, $5NpoY.Y)((0, $2kKDW.showFlag)({
            id: (0, $6D21P.REMOVE_REVIEWER).ERROR,
            iconType: "error",
            title: {
                msg: $550bfe7105ec52a3$export$defe85febe8b728c.prRemoveReviewerFlagTitleError
            },
            description: e.toString(),
            autoDismiss: true
        }));
    }
}
function* $550bfe7105ec52a3$export$1821a2abcef045ca(action) {
    const { payload: { userAaid: userAaid } } = action;
    const { owner: owner, slug: slug, id: id } = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestUrlPieces));
    const url = (0, $czBtW.default).api.internal.updateReviewer(owner, slug, id, userAaid);
    const updateRequest = (0, $k2cPS.default)(url, {
        method: "PUT"
    });
    try {
        const response = yield (0, $5NpoY.P)(fetch, updateRequest);
        if (!response.ok) {
            const message = yield (0, $5NpoY.P)((0, $58TOz.getErrorMessage), response.clone());
            throw new Error(message);
        } else {
            const respPr = yield response.json();
            const currentPr = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequest));
            const currentUser = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
            const updatedPr = {
                ...currentPr,
                participants: respPr.participants
            };
            yield (0, $5NpoY.Y)((0, $e9BOm.updatePullRequest)({
                type: (0, $6D21P.ADD_REVIEWER).SUCCESS,
                pullRequest: updatedPr,
                userAaid: userAaid,
                currentUser: currentUser
            }));
            (0, $6aoKW.publishTrackEvent)({
                action: "added",
                actionSubject: "prReviewers",
                actionSubjectId: `${owner}/${slug}/${id}`,
                source: (0, $6vkvB.PULL_REQUEST_SCREEN_NAME)
            });
            // Verify recently added reviewer has access
            yield (0, $5NpoY.Y)((0, $6D21P.verifyRepoMember)(userAaid));
        }
    } catch (e) {
        $3XbtU.captureException(e);
        yield (0, $5NpoY.Y)({
            type: (0, $6D21P.ADD_REVIEWER).ERROR,
            payload: {
                error: e,
                userAaid: userAaid
            }
        });
        yield (0, $5NpoY.Y)($550bfe7105ec52a3$var$errorAddReviewerFlag);
    }
}

});

parcelRegister("XatWx", function(module, exports) {

$parcel$export(module.exports, "verifyRepoMemberSaga", function () { return $409c5dc52ec4b4ca$export$9f9285661bd19184; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $3XbtU = parcelRequire("3XbtU");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $2kKDW = parcelRequire("2kKDW");

var $czBtW = parcelRequire("czBtW");

var $5nyeq = parcelRequire("5nyeq");

var $aanBq = parcelRequire("aanBq");

var $k2cPS = parcelRequire("k2cPS");

var $1EkdU = parcelRequire("1EkdU");

var $58TOz = parcelRequire("58TOz");
function* $409c5dc52ec4b4ca$export$9f9285661bd19184({ payload: { userAaid: userAaid, displayName: displayName } }) {
    const { owner: owner, slug: slug, is_private: isPrivate } = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
    if (!isPrivate) // don't verify member unless repo is private
    return;
    const repoPermissionsUrl = (0, $czBtW.default).api.v20.repositoryPermissions(owner.username, slug, userAaid);
    const verifyMember = (0, $k2cPS.default)(repoPermissionsUrl);
    try {
        const verifyMemberResp = yield (0, $5NpoY.P)(fetch, verifyMember);
        if (!verifyMemberResp.ok) {
            if (verifyMemberResp.status === 403) // We don't need to capture 403 errors. This is expected behavior.
            // This will happen when the requesting user isn't an admin of the repository.
            return;
            const message = yield (0, $5NpoY.P)((0, $58TOz.getErrorMessage), verifyMemberResp.clone());
            throw new Error(message);
        }
        const { values: values = [] } = yield verifyMemberResp.json();
        if (values.length === 0) {
            var _participant$user;
            const participants = yield (0, $5NpoY.a3)((0, $1EkdU.getCurrentPullRequestParticipants));
            const participant = participants.find(({ user: user })=>(user === null || user === void 0 ? void 0 : user.account_id) === userAaid);
            yield (0, $5NpoY.Y)((0, $2kKDW.showFlagComponent)(`${(0, $5nyeq.USER_NEEDS_ACCESS_FLAG_ID)}_${userAaid}`, {
                componentId: (0, $5nyeq.USER_NEEDS_ACCESS_FLAG_ID),
                props: {
                    displayName: (participant === null || participant === void 0 ? void 0 : (_participant$user = participant.user) === null || _participant$user === void 0 ? void 0 : _participant$user.display_name) || displayName
                }
            }));
        }
    } catch (e) {
        // silently fail and capture exception
        // this is a warning to the user that PR reviewer/mention
        // doesn't have access to the repository
        $3XbtU.captureException(e);
    }
}

});
parcelRegister("5nyeq", function(module, exports) {

$parcel$export(module.exports, "USER_NEEDS_ACCESS_FLAG_ID", function () { return $856cb686488c3f81$export$1d438fe7b79b6d; });
$parcel$export(module.exports, "default", function () { return $856cb686488c3f81$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $aMNOk = parcelRequire("aMNOk");

var $9hjCt = parcelRequire("9hjCt");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $jajUg = parcelRequire("jajUg");

var $a9ixz = parcelRequire("a9ixz");
const $856cb686488c3f81$export$1d438fe7b79b6d = "user-needs-access";
const $856cb686488c3f81$export$defe85febe8b728c = (0, $agjvf.defineMessages)({
    userNeedsAccessFlagTitleWarning: {
        "id": "frontbucket.flags.userNeedsAccess.titleWarning",
        "defaultMessage": "{displayName} needs access"
    },
    userNeedsAccessFlagDescriptionWarning: {
        "id": "frontbucket.flags.userNeedsAccess.descriptionWarning",
        "defaultMessage": "You mentioned {displayName}, but they don\u2019t have the necessary permissions to view or access the content. {link} about granting access to users and groups."
    },
    userNeedsAccessFlagLinkText: {
        "id": "frontbucket.flags.userNeedsAccess.linkText",
        "defaultMessage": "Learn more"
    },
    defaultUser: {
        "id": "frontbucket.flags.userNeedsAccess.defaultUser",
        "defaultMessage": "User"
    }
});
const $856cb686488c3f81$var$UserNeedsAccessWarningFlag = ({ id: id, props: props, ...otherProps })=>{
    const intl = (0, $jajUg.useIntl)();
    const displayName = (props === null || props === void 0 ? void 0 : props.displayName) || intl.formatMessage($856cb686488c3f81$export$defe85febe8b728c.defaultUser);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aMNOk.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
        id: id,
        title: intl.formatMessage($856cb686488c3f81$export$defe85febe8b728c.userNeedsAccessFlagTitleWarning, {
            displayName: displayName
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, $856cb686488c3f81$export$defe85febe8b728c.userNeedsAccessFlagDescriptionWarning, {
            values: {
                displayName: displayName,
                link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("a", {
                    href: (0, $a9ixz.default).external.grantRepositoryAccessToUsersAndGroups,
                    target: "_blank"
                }, intl.formatMessage($856cb686488c3f81$export$defe85febe8b728c.userNeedsAccessFlagLinkText))
            }
        })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9hjCt))), {
            label: "Warning",
            primaryColor: (0, $h39Sh.default)("color.icon.warning", (0, $jp7ng).Y300)
        })
    }));
};
var $856cb686488c3f81$export$2e2bcd8739ae039 = $856cb686488c3f81$var$UserNeedsAccessWarningFlag;

});



parcelRegister("9vzNQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d1637227fe2e488$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $grdQ5 = parcelRequire("grdQ5");

var $g2R3c = parcelRequire("g2R3c");

var $7hVkj = parcelRequire("7hVkj");

var $4uvOm = parcelRequire("4uvOm");
function* $0d1637227fe2e488$var$cacheRecentlyViewedRepository() {
    while(true){
        // @ts-ignore
        const action = yield (0, $5NpoY.M)((0, $grdQ5.ADD_RECENTLY_VIEWED_REPOSITORY));
        const currentUser = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
        if (!currentUser) continue;
        // add workspace to recent workspaces
        (0, $4uvOm.default).add(currentUser, action.meta.workspaceUuid);
        // writes to localStorage key: 'recently-viewed-repo-uuids-v2:<userId>'
        yield (0, $5NpoY.P)((0, $7hVkj.default).add, currentUser, action.payload.result, action.meta.workspaceUuid);
    }
}
var $0d1637227fe2e488$export$2e2bcd8739ae039 = $0d1637227fe2e488$var$cacheRecentlyViewedRepository;

});

parcelRegister("k96Kn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $636457da219ea60a$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $kZnTB = parcelRequire("kZnTB");

var $aanBq = parcelRequire("aanBq");

var $k2cPS = parcelRequire("k2cPS");

var $9Wjm3 = parcelRequire("9Wjm3");
function* $636457da219ea60a$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLatest)((0, $9Wjm3.UPDATE_SOURCE_BRANCH_HASH).REQUEST, $636457da219ea60a$export$41951548276fd503)
    ]);
}
function* $636457da219ea60a$export$41951548276fd503() {
    // make the call to the branches endpoint and return the target value
    try {
        const owner = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryOwnerName));
        const slug = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositorySlug));
        const branchName = yield (0, $5NpoY.a3)((0, $9Wjm3.getBranchViewSourceBranchName));
        const url = (0, $kZnTB.default).api.v20.branch(owner, slug, branchName);
        const request = (0, $k2cPS.default)(url);
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            // @ts-ignore
            const data = yield response.json();
            yield (0, $5NpoY.Y)({
                type: (0, $9Wjm3.UPDATE_SOURCE_BRANCH_HASH).SUCCESS,
                payload: {
                    sourceBranchHash: data.target.hash,
                    targetLinksSelf: data.target.links.self,
                    targetLinksHtml: data.target.links.html
                }
            });
        }
    } catch (e) {
    // COREX-4845: Add error handling logic (TO-DO)
    }
}

});
parcelRegister("9Wjm3", function(module, exports) {

$parcel$export(module.exports, "FETCH_DEST_BRANCH_DATA", function () { return $b9f65fdba305f3bf$export$1e2b3c1ebf3c7ce7; });
$parcel$export(module.exports, "CHANGE_DEST_BRANCH", function () { return $b9f65fdba305f3bf$export$3c0aae96c94eaa2c; });
$parcel$export(module.exports, "UNLOAD_BRANCH_STATE", function () { return $b9f65fdba305f3bf$export$4135658c01a6f554; });
$parcel$export(module.exports, "UPDATE_SOURCE_BRANCH_HASH", function () { return $b9f65fdba305f3bf$export$8bb47335bde65562; });
$parcel$export(module.exports, "hydrateBranchData", function () { return $b9f65fdba305f3bf$export$10785d42a73af10b; });
$parcel$export(module.exports, "branchReducer", function () { return $b9f65fdba305f3bf$export$7db577eaaa2f41ea; });
$parcel$export(module.exports, "getBranchCanViewParentRepo", function () { return $b9f65fdba305f3bf$export$cbe0e8e260ac227e; });
$parcel$export(module.exports, "getDefaultDestBranchName", function () { return $b9f65fdba305f3bf$export$efe50140cb0f7c30; });
$parcel$export(module.exports, "getBranchViewDestinationBranchName", function () { return $b9f65fdba305f3bf$export$ea57315a4ffc597a; });
$parcel$export(module.exports, "getBranchViewDestinationBranchHash", function () { return $b9f65fdba305f3bf$export$7f2b38db7512440f; });
$parcel$export(module.exports, "getBranchViewDestinationRepoName", function () { return $b9f65fdba305f3bf$export$37ef7742b3904a7c; });
$parcel$export(module.exports, "getBranchViewDestinationPermissions", function () { return $b9f65fdba305f3bf$export$380efe720901e116; });
$parcel$export(module.exports, "getBranchViewSourceBranchHash", function () { return $b9f65fdba305f3bf$export$6a350aaea1e76304; });
$parcel$export(module.exports, "getBranchViewSourceBranchName", function () { return $b9f65fdba305f3bf$export$a28ea50cb48380b4; });
$parcel$export(module.exports, "getBranchViewSourceBranchIsMainBranch", function () { return $b9f65fdba305f3bf$export$24f1d030b3bffcfa; });
$parcel$export(module.exports, "getBranchViewSourceBranchPermissions", function () { return $b9f65fdba305f3bf$export$6a962bcf2e9eafbf; });
$parcel$export(module.exports, "getBranchViewDestinationBranch", function () { return $b9f65fdba305f3bf$export$f92f5970e43d0105; });
$parcel$export(module.exports, "getBranchViewSyncStrategies", function () { return $b9f65fdba305f3bf$export$e10209e840c48bd7; });

var $aXXtM = parcelRequire("aXXtM");
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
var $fICwP = parcelRequire("fICwP");

var $7qdXF = parcelRequire("7qdXF");

var $gsXeO = parcelRequire("gsXeO");
const $b9f65fdba305f3bf$export$9a2fc1c7ba0e7e26 = (0, $2MctD.createAsyncAction)("repo/HYDRATE_BRANCH_DATA");
const $b9f65fdba305f3bf$export$b0736cc2885788c1 = (0, $2MctD.createAsyncAction)("branch/FETCH_BRANCH_OPTIONS");
const $b9f65fdba305f3bf$export$1e2b3c1ebf3c7ce7 = (0, $2MctD.createAsyncAction)("branch/FETCH_DEST_BRANCH_DATA");
const $b9f65fdba305f3bf$export$3c0aae96c94eaa2c = "branch/CHANGE_DEST_BRANCH";
const $b9f65fdba305f3bf$export$4135658c01a6f554 = "branch/UNLOAD_BRANCH_STATE";
const $b9f65fdba305f3bf$export$8bb47335bde65562 = (0, $2MctD.createAsyncAction)("branch/UPDATE_SOURCE_BRANCH_HASH");
const $b9f65fdba305f3bf$export$10785d42a73af10b = (repositoryFullSlug, branchName)=>(0, $fICwP.hydrateAction)($b9f65fdba305f3bf$export$9a2fc1c7ba0e7e26, "repositories.branch", {
        url: `/${repositoryFullSlug}/branch/${branchName}`
    });
const $b9f65fdba305f3bf$export$d4c72bab9d6cc13a = {
    sourceBranch: undefined,
    destinationBranch: undefined,
    destRepoName: "",
    defaultDestBranch: undefined,
    showParentRepo: false
};
const $b9f65fdba305f3bf$export$7db577eaaa2f41ea = (0, $gsXeO.default)($b9f65fdba305f3bf$export$d4c72bab9d6cc13a, {
    [$b9f65fdba305f3bf$export$9a2fc1c7ba0e7e26.SUCCESS] (state, action) {
        const source = {
            isMainBranch: action.payload.source_branch.ismainbranch,
            permissions: action.payload.source_branch.permissions,
            name: action.payload.source_branch.name,
            links: action.payload.source_branch.links,
            target: action.payload.source_branch.target,
            sync_strategies: action.payload.source_branch.sync_strategies
        };
        return {
            ...state,
            destRepoName: action.payload.dest_repo,
            sourceBranch: source,
            destinationBranch: action.payload.dest_branch,
            defaultDestBranch: action.payload.dest_branch,
            showParentRepo: action.payload.can_access_parent_repo
        };
    },
    [$b9f65fdba305f3bf$export$3c0aae96c94eaa2c] (state, action) {
        const { ref: ref, repo: repo } = action.payload;
        return {
            ...state,
            destRepoName: repo,
            destinationBranch: {
                name: ref.name,
                target: {
                    type: "commit",
                    hash: ref.hash
                }
            }
        };
    },
    [$b9f65fdba305f3bf$export$8bb47335bde65562.SUCCESS] (state, action) {
        const { sourceBranchHash: sourceBranchHash, targetLinksSelf: targetLinksSelf, targetLinksHtml: targetLinksHtml } = action.payload;
        const branch = {
            ...state.sourceBranch,
            target: {
                ...state.sourceBranch.target,
                hash: sourceBranchHash,
                links: {
                    ...state.sourceBranch.target.links,
                    self: targetLinksSelf,
                    html: targetLinksHtml
                }
            }
        };
        return {
            ...state,
            sourceBranch: branch
        };
    },
    [$b9f65fdba305f3bf$export$1e2b3c1ebf3c7ce7.SUCCESS] (state, action) {
        const { destination: destination } = action.payload;
        const destinationBranch = {
            ...state.destinationBranch,
            permissions: destination.permissions,
            isMainBranch: destination.isMainBranch,
            merge_strategies: destination.merge_strategies,
            default_merge_strategy: destination.default_merge_strategy,
            sync_strategies: destination.sync_strategies
        };
        return {
            ...state,
            destinationBranch: destinationBranch
        };
    },
    [$b9f65fdba305f3bf$export$4135658c01a6f554] () {
        return $b9f65fdba305f3bf$export$d4c72bab9d6cc13a;
    }
});
const $b9f65fdba305f3bf$export$cbe0e8e260ac227e = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (state)=>state.branch.showParentRepo);
const $b9f65fdba305f3bf$export$efe50140cb0f7c30 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (state)=>{
    var _state$branch$default;
    return (_state$branch$default = state.branch.defaultDestBranch) === null || _state$branch$default === void 0 ? void 0 : _state$branch$default.name;
});
const $b9f65fdba305f3bf$export$ea57315a4ffc597a = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (state)=>{
    var _state$branch$destina;
    return (_state$branch$destina = state.branch.destinationBranch) === null || _state$branch$destina === void 0 ? void 0 : _state$branch$destina.name;
});
const $b9f65fdba305f3bf$export$7f2b38db7512440f = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (state)=>{
    var _state$branch$destina2;
    return (_state$branch$destina2 = state.branch.destinationBranch) === null || _state$branch$destina2 === void 0 ? void 0 : _state$branch$destina2.target.hash;
});
const $b9f65fdba305f3bf$export$37ef7742b3904a7c = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (state)=>state.branch.destRepoName);
const $b9f65fdba305f3bf$export$380efe720901e116 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (state)=>{
    var _state$branch$destina3;
    return (_state$branch$destina3 = state.branch.destinationBranch) === null || _state$branch$destina3 === void 0 ? void 0 : _state$branch$destina3.permissions;
});
const $b9f65fdba305f3bf$export$6a350aaea1e76304 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (state)=>{
    var _state$branch$sourceB;
    return (_state$branch$sourceB = state.branch.sourceBranch) === null || _state$branch$sourceB === void 0 ? void 0 : _state$branch$sourceB.target.hash;
});
const $b9f65fdba305f3bf$export$a28ea50cb48380b4 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (state)=>{
    var _state$branch$sourceB2;
    return (_state$branch$sourceB2 = state.branch.sourceBranch) === null || _state$branch$sourceB2 === void 0 ? void 0 : _state$branch$sourceB2.name;
});
const $b9f65fdba305f3bf$export$24f1d030b3bffcfa = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (state)=>{
    var _state$branch$sourceB3;
    return (_state$branch$sourceB3 = state.branch.sourceBranch) === null || _state$branch$sourceB3 === void 0 ? void 0 : _state$branch$sourceB3.isMainBranch;
});
const $b9f65fdba305f3bf$export$6a962bcf2e9eafbf = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (state)=>{
    var _state$branch$sourceB4;
    return (_state$branch$sourceB4 = state.branch.sourceBranch) === null || _state$branch$sourceB4 === void 0 ? void 0 : _state$branch$sourceB4.permissions;
});
const $b9f65fdba305f3bf$export$f92f5970e43d0105 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (state)=>state.branch.destinationBranch);
const $b9f65fdba305f3bf$export$2aa7f709b75cb92a = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (state)=>state.branch.sourceBranch);
const $b9f65fdba305f3bf$export$e10209e840c48bd7 = (0, $aXXtM.createSelector)($b9f65fdba305f3bf$export$2aa7f709b75cb92a, (branch)=>branch === null || branch === void 0 ? void 0 : branch.sync_strategies);

});


parcelRegister("7sn3o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1e78aceea7f391b$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");
parcelRequire("i00rV");
var $kVfUE = parcelRequire("kVfUE");
var $7JMVp = parcelRequire("7JMVp");
var $666GI = parcelRequire("666GI");
var $gwTjV = parcelRequire("gwTjV");

var $9KRhx = parcelRequire("9KRhx");

var $duBZe = parcelRequire("duBZe");

var $975h4 = parcelRequire("975h4");

var $jUiUX = parcelRequire("jUiUX");
function* $f1e78aceea7f391b$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $jeUNF.takeLatest)((0, $kVfUE.FetchSearchResults).REQUEST, (0, $9KRhx.default)),
        (0, $jeUNF.takeLatest)((0, $7JMVp.OptInToBeta).REQUEST, (0, $duBZe.default)),
        (0, $jeUNF.takeLatest)((0, $666GI.REFINE_QUERY), (0, $975h4.default)),
        (0, $jeUNF.takeLatest)((0, $gwTjV.SYNC_URL_TO_STATE), (0, $jUiUX.default))
    ]);
}

});
parcelRegister("i00rV", function(module, exports) {

$parcel$export(module.exports, "FetchSearchResults", function () { return (parcelRequire("kVfUE")).FetchSearchResults; });
$parcel$export(module.exports, "syncUrlToState", function () { return (parcelRequire("gwTjV")).default; });
$parcel$export(module.exports, "RESET_SEARCH", function () { return (parcelRequire("gwTjV")).RESET_SEARCH; });
$parcel$export(module.exports, "SYNC_URL_TO_STATE", function () { return (parcelRequire("gwTjV")).SYNC_URL_TO_STATE; });
$parcel$export(module.exports, "loadSearchPage", function () { return (parcelRequire("96rtx")).default; });
$parcel$export(module.exports, "LoadSearchPage", function () { return (parcelRequire("96rtx")).LoadSearchPage; });
$parcel$export(module.exports, "optInToBeta", function () { return (parcelRequire("7JMVp")).default; });
$parcel$export(module.exports, "OptInToBeta", function () { return (parcelRequire("7JMVp")).OptInToBeta; });
$parcel$export(module.exports, "refineQuery", function () { return (parcelRequire("666GI")).default; });
$parcel$export(module.exports, "REFINE_QUERY", function () { return (parcelRequire("666GI")).REFINE_QUERY; });

var $kVfUE = parcelRequire("kVfUE");

var $gwTjV = parcelRequire("gwTjV");

var $96rtx = parcelRequire("96rtx");

var $7JMVp = parcelRequire("7JMVp");

var $666GI = parcelRequire("666GI");

});
parcelRegister("kVfUE", function(module, exports) {

$parcel$export(module.exports, "FetchSearchResults", function () { return $a47f8d11921f8bb3$export$ac876986283c4c39; });
$parcel$export(module.exports, "default", function () { return $a47f8d11921f8bb3$export$2e2bcd8739ae039; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
const $a47f8d11921f8bb3$export$ac876986283c4c39 = (0, $2MctD.createAsyncAction)("search/FETCH_SEARCH_RESULTS");
var $a47f8d11921f8bb3$export$2e2bcd8739ae039 = (searchParams)=>({
        type: $a47f8d11921f8bb3$export$ac876986283c4c39.REQUEST,
        payload: {
            ...searchParams
        }
    });

});

parcelRegister("gwTjV", function(module, exports) {

$parcel$export(module.exports, "RESET_SEARCH", function () { return $4a98ef17f5f49730$export$1357260dfbbdd047; });
$parcel$export(module.exports, "SYNC_URL_TO_STATE", function () { return $4a98ef17f5f49730$export$d4cb97fb6e7ba807; });
$parcel$export(module.exports, "default", function () { return $4a98ef17f5f49730$export$2e2bcd8739ae039; });
const $4a98ef17f5f49730$export$1357260dfbbdd047 = "search/RESET_SEARCH";
const $4a98ef17f5f49730$export$d4cb97fb6e7ba807 = "search/SYNC_URL_TO_STATE";
var $4a98ef17f5f49730$export$2e2bcd8739ae039 = (params)=>{
    return {
        type: $4a98ef17f5f49730$export$d4cb97fb6e7ba807,
        payload: {
            params: params
        }
    };
};

});

parcelRegister("96rtx", function(module, exports) {

$parcel$export(module.exports, "LoadSearchPage", function () { return $2d62a0350763cd50$export$8a766f82b1a29011; });
$parcel$export(module.exports, "default", function () { return $2d62a0350763cd50$export$2e2bcd8739ae039; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
var $fICwP = parcelRequire("fICwP");

var $8saZD = parcelRequire("8saZD");

var $2HyTs = parcelRequire("2HyTs");
const $2d62a0350763cd50$export$8a766f82b1a29011 = (0, $2MctD.createAsyncAction)("search/LOAD_PAGE");
var $2d62a0350763cd50$export$2e2bcd8739ae039 = (accountUuid)=>(0, $fICwP.hydrateAction)($2d62a0350763cd50$export$8a766f82b1a29011, "search", {
        url: (0, $2HyTs.default).ui.search({
            accountUuid: accountUuid
        }),
        schema: {
            accounts: [
                (0, $8saZD.user)
            ]
        }
    });

});
parcelRegister("2HyTs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6faf8bb3baacbe7$export$2e2bcd8739ae039; });

var $9H597 = parcelRequire("9H597");
var $e6faf8bb3baacbe7$export$2e2bcd8739ae039 = {
    api: {
        v20: {
            code (owner) {
                return `/!api/2.0/${owner.type}s/${owner.uuid}/search/code`;
            }
        }
    },
    external: {
        docs: "https://confluence.atlassian.com/bitbucket/code-search-in-bitbucket-873876782.html"
    },
    ui: {
        search (params) {
            const { accountUuid: accountUuid } = params || {};
            const url = "/search";
            const query = (0, $9H597.stringify)({
                account: accountUuid
            });
            return `${url}${query}`;
        }
    }
};

});


parcelRegister("7JMVp", function(module, exports) {

$parcel$export(module.exports, "OptInToBeta", function () { return $87df9095161ac8c2$export$3a6efd63750b7724; });
$parcel$export(module.exports, "default", function () { return $87df9095161ac8c2$export$2e2bcd8739ae039; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
const $87df9095161ac8c2$export$3a6efd63750b7724 = (0, $2MctD.createAsyncAction)("search/OPT_IN_TO_BETA");
var $87df9095161ac8c2$export$2e2bcd8739ae039 = (account)=>{
    const { uuid: accountUuid } = account;
    if (!accountUuid) return;
    // eslint-disable-next-line consistent-return
    return {
        type: $87df9095161ac8c2$export$3a6efd63750b7724.REQUEST,
        payload: {
            account: account
        }
    };
};

});

parcelRegister("666GI", function(module, exports) {

$parcel$export(module.exports, "REFINE_QUERY", function () { return $6bca0148cc34775b$export$dcbd36184010e69a; });
$parcel$export(module.exports, "default", function () { return $6bca0148cc34775b$export$2e2bcd8739ae039; });
const $6bca0148cc34775b$export$dcbd36184010e69a = "search/REFINE_QUERY";
var $6bca0148cc34775b$export$2e2bcd8739ae039 = (item)=>{
    return {
        type: $6bca0148cc34775b$export$dcbd36184010e69a,
        payload: {
            item: item
        }
    };
};

});


parcelRegister("9KRhx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75b51331b1f194f0$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $3XbtU = parcelRequire("3XbtU");

var $cJH1T = parcelRequire("cJH1T");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("3hzea");
var $a5HLv = parcelRequire("a5HLv");

var $4EVFU = parcelRequire("4EVFU");
parcelRequire("i00rV");
var $kVfUE = parcelRequire("kVfUE");

var $g5nij = parcelRequire("g5nij");

var $2HyTs = parcelRequire("2HyTs");

var $6aoKW = parcelRequire("6aoKW");

var $k2cPS = parcelRequire("k2cPS");

var $M3cyx = parcelRequire("M3cyx");

var $h3kk7 = parcelRequire("h3kk7");

var $f1PXl = parcelRequire("f1PXl");
function* $75b51331b1f194f0$export$2e2bcd8739ae039({ payload: { q: q, account: account, page: page, extra: extra } }) {
    const targetAccount = yield (0, $5NpoY.a3)((0, $f1PXl.getSearchAccount), {
        account: account
    });
    const params = {
        search_query: q,
        page: page,
        fields: "+values.file.commit.repository.mainbranch.name"
    };
    const url = `${(0, $2HyTs.default).api.v20.code(targetAccount)}?${(0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).stringify(params)}`;
    (0, $h3kk7.default).set((0, $4EVFU.SEARCH_RECENT_LOCALSTORAGE_KEY), targetAccount.uuid);
    const start = Date.now();
    try {
        const searchTrackEvent = {
            action: "searched",
            actionSubject: "code",
            actionSubjectId: (0, $a5HLv.uncurlyUuid)(targetAccount.uuid),
            source: (extra === null || extra === void 0 ? void 0 : extra.source) || "",
            attributes: {}
        };
        const response = yield (0, $5NpoY.P)(fetch, (0, $k2cPS.default)(url));
        // @ts-ignore
        const json = yield response.json();
        const tags = [
            `response:${response.status === 200 ? "ok" : "error"}`,
            `status:${response.status}`
        ];
        (0, $M3cyx.statsdApiClient).histogram({
            "search_results.search.timing": Math.round(Date.now() - start)
        }, {
            tags: tags
        });
        if (response.ok) {
            if (!page) {
                // only fire on initial query
                yield (0, $5NpoY.P)((0, $6aoKW.publishTrackEvent), {
                    ...searchTrackEvent,
                    attributes: {
                        status: "success"
                    }
                });
                yield (0, $5NpoY.P)((0, $6aoKW.publishFact), new (0, $g5nij.SearchResultsViewedFact)({
                    total_result_count: json.size,
                    is_substituted: json.query_substituted
                }));
            }
            yield (0, $5NpoY.Y)({
                type: (0, $kVfUE.FetchSearchResults).SUCCESS,
                payload: json
            });
        } else {
            if (!page && json.error && json.error.data && json.error.data.key) {
                const errorKey = json.error.data.key;
                yield (0, $5NpoY.P)((0, $6aoKW.publishTrackEvent), {
                    ...searchTrackEvent,
                    attributes: {
                        status: "error",
                        error: errorKey
                    }
                });
                yield (0, $5NpoY.P)((0, $6aoKW.publishFact), new (0, $g5nij.SearchResultsViewedFact)({
                    error: errorKey
                }));
            }
            yield (0, $5NpoY.Y)({
                type: (0, $kVfUE.FetchSearchResults).ERROR,
                error: true,
                meta: json
            });
        }
    } catch (err) {
        (0, $M3cyx.statsdApiClient).histogram({
            "search_results.search.timing": Math.round(Date.now() - start)
        }, {
            tags: [
                "response:error"
            ]
        });
        yield (0, $5NpoY.Y)({
            type: (0, $kVfUE.FetchSearchResults).ERROR,
            error: true,
            // An empty object (`{}`) will trigger the display of a generic error msg
            meta: {}
        });
        if (err instanceof Error) $3XbtU.captureException(err);
    }
}

});
parcelRegister("4EVFU", function(module, exports) {

$parcel$export(module.exports, "FORM_KEY", function () { return $cb38c692510d4129$export$9a2e657c58d610a7; });
$parcel$export(module.exports, "SEARCH_SYNTAX_WRONG_OPERATORS", function () { return $cb38c692510d4129$export$8bad6f1b9d38b078; });
$parcel$export(module.exports, "SEARCH_SYNTAX_WRONG_EXTENSION", function () { return $cb38c692510d4129$export$c4c57f6f5aadd076; });
$parcel$export(module.exports, "SEARCH_SYNTAX_QUOTES", function () { return $cb38c692510d4129$export$5a1d6a1bc7be8286; });
$parcel$export(module.exports, "SEARCH_RECENT_LOCALSTORAGE_KEY", function () { return $cb38c692510d4129$export$8ce135d4e8f8f4d5; });
const $cb38c692510d4129$var$WRONG_OPERATORS = "\\bAND\\b|\\bOR\\b";
const $cb38c692510d4129$var$WRONG_EXTENSION = "\\bext:\\w+\\.\\w+\\b";
const $cb38c692510d4129$var$QUOTES = '(\\s|^)"(\\\\.|[^"\\\\])*"(?=\\s|$)';
const $cb38c692510d4129$export$9a2e657c58d610a7 = "search-query-form";
const $cb38c692510d4129$export$8bad6f1b9d38b078 = new RegExp($cb38c692510d4129$var$WRONG_OPERATORS, "g");
const $cb38c692510d4129$export$c4c57f6f5aadd076 = new RegExp($cb38c692510d4129$var$WRONG_EXTENSION, "g");
const $cb38c692510d4129$export$5a1d6a1bc7be8286 = new RegExp($cb38c692510d4129$var$QUOTES, "g");
const $cb38c692510d4129$export$8ce135d4e8f8f4d5 = "search.recent-account";

});

parcelRegister("g5nij", function(module, exports) {

$parcel$export(module.exports, "SearchResultsViewedFact", function () { return $4a8e401224f4d3e1$export$e3a15be2e959664e; });
$parcel$export(module.exports, "SearchAccountSelectorClickedFact", function () { return $4a8e401224f4d3e1$export$47c5d6d08e23f5db; });
$parcel$export(module.exports, "SearchAccountSelectorChangedFact", function () { return $4a8e401224f4d3e1$export$da318220a9eb747e; });
$parcel$export(module.exports, "SearchResultsPaginationClickedFact", function () { return $4a8e401224f4d3e1$export$fae70b79b065bdb8; });
$parcel$export(module.exports, "SearchResultsSourceFileClickedFact", function () { return $4a8e401224f4d3e1$export$28a4e23e51de8ef4; });
$parcel$export(module.exports, "SearchResultsSourceFileLineClickedFact", function () { return $4a8e401224f4d3e1$export$8a94398f8b8b62fd; });
$parcel$export(module.exports, "SearchResultsRepositorySearchHintClickedFact", function () { return $4a8e401224f4d3e1$export$315948cd0929c9ef; });
$parcel$export(module.exports, "SearchResultsSourcePathClickedFact", function () { return $4a8e401224f4d3e1$export$af039b4aa7cf5b20; });
$parcel$export(module.exports, "SearchResultsCodeExpandClickedFact", function () { return $4a8e401224f4d3e1$export$86b7a236b05f5c3d; });
$parcel$export(module.exports, "SearchResultsCodeCollapseClickedFact", function () { return $4a8e401224f4d3e1$export$7bec5acc35d110; });
$parcel$export(module.exports, "SearchFormRefineMenuItemAddedFact", function () { return $4a8e401224f4d3e1$export$c479fec4a303f4ef; });
$parcel$export(module.exports, "SearchFormSubmittedFact", function () { return $4a8e401224f4d3e1$export$4aea468f0b8ec89; });
$parcel$export(module.exports, "SearchFormOpenedFact", function () { return $4a8e401224f4d3e1$export$eb10cfeaa349f2c4; });
parcelRequire("3hzea");
var $6E7t8 = parcelRequire("6E7t8");
class $4a8e401224f4d3e1$export$e3a15be2e959664e extends (0, $6E7t8.default) {
    constructor(...args){
        super(...args);
        this.name = "bitbucket.search_results.viewed";
    }
}
class $4a8e401224f4d3e1$export$47c5d6d08e23f5db extends (0, $6E7t8.default) {
    constructor(...args){
        super(...args);
        this.name = "bitbucket.search_results.account_switcher.clicked";
    }
}
class $4a8e401224f4d3e1$export$da318220a9eb747e extends (0, $6E7t8.default) {
    constructor(...args){
        super(...args);
        this.name = "bitbucket.search_results.account_switcher.changed";
    }
}
class $4a8e401224f4d3e1$export$fae70b79b065bdb8 extends (0, $6E7t8.default) {
    constructor(...args){
        super(...args);
        this.name = "bitbucket.search_results.pagination.clicked";
    }
}
class $4a8e401224f4d3e1$export$28a4e23e51de8ef4 extends (0, $6E7t8.default) {
    constructor(...args){
        super(...args);
        this.name = "bitbucket.search_results.source_file.clicked";
    }
}
class $4a8e401224f4d3e1$export$8a94398f8b8b62fd extends (0, $6E7t8.default) {
    constructor(...args){
        super(...args);
        this.name = "bitbucket.search_results.source_file.line.clicked";
    }
}
class $4a8e401224f4d3e1$export$315948cd0929c9ef extends (0, $6E7t8.default) {
    constructor(...args){
        super(...args);
        this.name = "bitbucket.search_results.repository_search_hint.clicked";
    }
}
class $4a8e401224f4d3e1$export$af039b4aa7cf5b20 extends (0, $6E7t8.default) {
    constructor(...args){
        super(...args);
        this.name = "bitbucket.search_results.source_path.clicked";
    }
}
class $4a8e401224f4d3e1$export$86b7a236b05f5c3d extends (0, $6E7t8.default) {
    constructor(...args){
        super(...args);
        this.name = "bitbucket.search_results.code_expand.clicked";
    }
}
class $4a8e401224f4d3e1$export$7bec5acc35d110 extends (0, $6E7t8.default) {
    constructor(...args){
        super(...args);
        this.name = "bitbucket.search_results.code_collapse.clicked";
    }
}
class $4a8e401224f4d3e1$export$c479fec4a303f4ef extends (0, $6E7t8.default) {
    constructor(...args){
        super(...args);
        this.name = "bitbucket.search_form.refine_menu.item_added";
    }
}
class $4a8e401224f4d3e1$export$4aea468f0b8ec89 extends (0, $6E7t8.default) {
    constructor(...args){
        super(...args);
        this.name = "bitbucket.search_form.submitted";
    }
}
class $4a8e401224f4d3e1$export$eb10cfeaa349f2c4 extends (0, $6E7t8.default) {
    constructor(...args){
        super(...args);
        this.name = "bitbucket.search_form.opened";
    }
}

});

parcelRegister("f1PXl", function(module, exports) {

$parcel$export(module.exports, "getSearchAccount", function () { return $e54288db1d9cc2e2$export$bbfe89d1c6510c36; });

var $ga67g = parcelRequire("ga67g");

var $8saZD = parcelRequire("8saZD");
const $e54288db1d9cc2e2$export$bbfe89d1c6510c36 = (state, params)=>{
    const { entities: entities } = state;
    const { account: account } = (0, $ga67g.denormalize)({
        account: params.account
    }, {
        account: (0, $8saZD.user)
    }, entities);
    return account;
};

});


parcelRegister("duBZe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d40a7a3b27cf2daa$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $3XbtU = parcelRequire("3XbtU");

var $XgUNY = parcelRequire("XgUNY");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $4EVFU = parcelRequire("4EVFU");
parcelRequire("i00rV");
var $7JMVp = parcelRequire("7JMVp");

var $8saZD = parcelRequire("8saZD");

var $kvnVB = parcelRequire("kvnVB");

var $9NUw3 = parcelRequire("9NUw3");
function* $d40a7a3b27cf2daa$export$2e2bcd8739ae039({ payload: { account: account } }) {
    const url = `${(0, $kvnVB.settings)().API_CANON_URL}/internal/site/addons/account/${account.uuid}/install/`;
    try {
        const accessToken = yield (0, $5NpoY.P)((0, $9NUw3.default), `site:search-installer`);
        const response = yield (0, $5NpoY.P)(fetch, url, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${accessToken.token}`
            }
        });
        if (!response.ok) throw new Error("Authorization error");
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $7JMVp.OptInToBeta).ERROR,
            error: true
        });
        if (e instanceof Error) $3XbtU.captureException(e);
        return;
    }
    // We want to update our normalized account to reflect the new search state
    const updatedAccount = {
        ...account,
        extra: {
            ...account.extra,
            search_state: "ENABLED"
        }
    };
    // Also update the separate state in the account switcher form.
    // Otherwise the search form doesn't work after opting in.
    yield (0, $5NpoY.Y)((0, $XgUNY.change)((0, $4EVFU.FORM_KEY), "account", updatedAccount));
    yield (0, $5NpoY.Y)({
        type: (0, $7JMVp.OptInToBeta).SUCCESS,
        payload: updatedAccount,
        meta: {
            schema: (0, $8saZD.user)
        }
    });
}

});
parcelRegister("XgUNY", function(module, exports) {

$parcel$export(module.exports, "change", function () { return $0b22a1cf9576e561$export$d8a7b8f475ec0161; });

var $3EivG = parcelRequire("3EivG");

var $avrKI = parcelRequire("avrKI");










var $jL7BL = parcelRequire("jL7BL");







var $kuUjF = parcelRequire("kuUjF");















var $bDK33 = parcelRequire("bDK33");

var $8JyOg = parcelRequire("8JyOg");

var $0b22a1cf9576e561$export$1fa6c04dd35d59ff = $avrKI;
var $0b22a1cf9576e561$export$214afe3ea4014a58 = (0, $3EivG.default).arrayInsert;
var $0b22a1cf9576e561$export$5d49d615ad5ea2b0 = (0, $3EivG.default).arrayMove;
var $0b22a1cf9576e561$export$82e7627f0a357dca = (0, $3EivG.default).arrayPop;
var $0b22a1cf9576e561$export$ebdeef2dcdcc4b9e = (0, $3EivG.default).arrayPush;
var $0b22a1cf9576e561$export$30a014203d0d7e4f = (0, $3EivG.default).arrayRemove;
var $0b22a1cf9576e561$export$b916bf42407a3fd7 = (0, $3EivG.default).arrayRemoveAll;
var $0b22a1cf9576e561$export$a212a361831d19b7 = (0, $3EivG.default).arrayShift;
var $0b22a1cf9576e561$export$5bd6afcd61c04c28 = (0, $3EivG.default).arraySplice;
var $0b22a1cf9576e561$export$5d3a3e794fd2dcef = (0, $3EivG.default).arraySwap;
var $0b22a1cf9576e561$export$9960f372da16bace = (0, $3EivG.default).arrayUnshift;
var $0b22a1cf9576e561$export$ed7cd791d8b3b60b = (0, $3EivG.default).autofill;
var $0b22a1cf9576e561$export$2cc7ff91bcacba5e = (0, $3EivG.default).blur;
var $0b22a1cf9576e561$export$d8a7b8f475ec0161 = (0, $3EivG.default).change;
var $0b22a1cf9576e561$export$fca940a9a618af0d = (0, $3EivG.default).clearAsyncError;
var $0b22a1cf9576e561$export$7cc8c73a5b1ceb0e = (0, $3EivG.default).clearFields;
var $0b22a1cf9576e561$export$fdb63864c8b86b11 = (0, $3EivG.default).clearSubmit;
var $0b22a1cf9576e561$export$7f8489b64c770b22 = (0, $3EivG.default).clearSubmitErrors;
var $0b22a1cf9576e561$export$b1fb4cac938035f7 = (0, $3EivG.default).destroy;
var $0b22a1cf9576e561$export$d7ddd398f22d79ef = (0, $3EivG.default).focus;
var $0b22a1cf9576e561$export$2a47f398eeff8b01 = (0, $3EivG.default).initialize;
var $0b22a1cf9576e561$export$f9151748993804f2 = (0, $3EivG.default).registerField;
var $0b22a1cf9576e561$export$aad8462122ac592b = (0, $3EivG.default).reset;
var $0b22a1cf9576e561$export$afed87afac5cd687 = (0, $3EivG.default).resetSection;
var $0b22a1cf9576e561$export$4a1a0e303db5c007 = (0, $3EivG.default).setSubmitFailed;
var $0b22a1cf9576e561$export$a5ce319b9ff695db = (0, $3EivG.default).setSubmitSucceeded;
var $0b22a1cf9576e561$export$7409b33d21591102 = (0, $3EivG.default).startAsyncValidation;
var $0b22a1cf9576e561$export$6392ea0de8ae848d = (0, $3EivG.default).startSubmit;
var $0b22a1cf9576e561$export$bbdf6554e7baf5ab = (0, $3EivG.default).stopAsyncValidation;
var $0b22a1cf9576e561$export$bbd8c99f2e51b188 = (0, $3EivG.default).stopSubmit;
var $0b22a1cf9576e561$export$853c27de4ce0f746 = (0, $3EivG.default).submit;
var $0b22a1cf9576e561$export$d0b7ea69ab6056df = (0, $3EivG.default).touch;
var $0b22a1cf9576e561$export$c181c4d2d2f00f3d = (0, $3EivG.default).unregisterField;
var $0b22a1cf9576e561$export$85e6d6f49dbee4b9 = (0, $3EivG.default).untouch;
var $0b22a1cf9576e561$export$4dafe867bce8919b = (0, $3EivG.default).updateSyncWarnings;
var $0b22a1cf9576e561$export$15495f22f17c93fb = (0, $3EivG.default).updateSyncErrors;

});
parcelRegister("3EivG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a837737b88c98bf$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $avrKI = parcelRequire("avrKI");
var $2a837737b88c98bf$var$arrayInsert = function arrayInsert(form, field, index, value) {
    return {
        type: (0, $avrKI.ARRAY_INSERT),
        meta: {
            form: form,
            field: field,
            index: index
        },
        payload: value
    };
};
var $2a837737b88c98bf$var$arrayMove = function arrayMove(form, field, from, to) {
    return {
        type: (0, $avrKI.ARRAY_MOVE),
        meta: {
            form: form,
            field: field,
            from: from,
            to: to
        }
    };
};
var $2a837737b88c98bf$var$arrayPop = function arrayPop(form, field) {
    return {
        type: (0, $avrKI.ARRAY_POP),
        meta: {
            form: form,
            field: field
        }
    };
};
var $2a837737b88c98bf$var$arrayPush = function arrayPush(form, field, value) {
    return {
        type: (0, $avrKI.ARRAY_PUSH),
        meta: {
            form: form,
            field: field
        },
        payload: value
    };
};
var $2a837737b88c98bf$var$arrayRemove = function arrayRemove(form, field, index) {
    return {
        type: (0, $avrKI.ARRAY_REMOVE),
        meta: {
            form: form,
            field: field,
            index: index
        }
    };
};
var $2a837737b88c98bf$var$arrayRemoveAll = function arrayRemoveAll(form, field) {
    return {
        type: (0, $avrKI.ARRAY_REMOVE_ALL),
        meta: {
            form: form,
            field: field
        }
    };
};
var $2a837737b88c98bf$var$arrayShift = function arrayShift(form, field) {
    return {
        type: (0, $avrKI.ARRAY_SHIFT),
        meta: {
            form: form,
            field: field
        }
    };
};
var $2a837737b88c98bf$var$arraySplice = function arraySplice(form, field, index, removeNum, value) {
    var action = {
        type: (0, $avrKI.ARRAY_SPLICE),
        meta: {
            form: form,
            field: field,
            index: index,
            removeNum: removeNum
        }
    };
    if (value !== undefined) action.payload = value;
    return action;
};
var $2a837737b88c98bf$var$arraySwap = function arraySwap(form, field, indexA, indexB) {
    if (indexA === indexB) throw new Error("Swap indices cannot be equal");
    if (indexA < 0 || indexB < 0) throw new Error("Swap indices cannot be negative");
    return {
        type: (0, $avrKI.ARRAY_SWAP),
        meta: {
            form: form,
            field: field,
            indexA: indexA,
            indexB: indexB
        }
    };
};
var $2a837737b88c98bf$var$arrayUnshift = function arrayUnshift(form, field, value) {
    return {
        type: (0, $avrKI.ARRAY_UNSHIFT),
        meta: {
            form: form,
            field: field
        },
        payload: value
    };
};
var $2a837737b88c98bf$var$autofill = function autofill(form, field, value) {
    return {
        type: (0, $avrKI.AUTOFILL),
        meta: {
            form: form,
            field: field
        },
        payload: value
    };
};
var $2a837737b88c98bf$var$blur = function blur(form, field, value, touch) {
    return {
        type: (0, $avrKI.BLUR),
        meta: {
            form: form,
            field: field,
            touch: touch
        },
        payload: value
    };
};
var $2a837737b88c98bf$var$change = function change(form, field, value, touch, persistentSubmitErrors) {
    return {
        type: (0, $avrKI.CHANGE),
        meta: {
            form: form,
            field: field,
            touch: touch,
            persistentSubmitErrors: persistentSubmitErrors
        },
        payload: value
    };
};
var $2a837737b88c98bf$var$clearSubmit = function clearSubmit(form) {
    return {
        type: (0, $avrKI.CLEAR_SUBMIT),
        meta: {
            form: form
        }
    };
};
var $2a837737b88c98bf$var$clearSubmitErrors = function clearSubmitErrors(form) {
    return {
        type: (0, $avrKI.CLEAR_SUBMIT_ERRORS),
        meta: {
            form: form
        }
    };
};
var $2a837737b88c98bf$var$clearAsyncError = function clearAsyncError(form, field) {
    return {
        type: (0, $avrKI.CLEAR_ASYNC_ERROR),
        meta: {
            form: form,
            field: field
        }
    };
};
var $2a837737b88c98bf$var$clearFields = function clearFields(form, keepTouched, persistentSubmitErrors) {
    for(var _len = arguments.length, fields = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)fields[_key - 3] = arguments[_key];
    return {
        type: (0, $avrKI.CLEAR_FIELDS),
        meta: {
            form: form,
            keepTouched: keepTouched,
            persistentSubmitErrors: persistentSubmitErrors,
            fields: fields
        }
    };
};
var $2a837737b88c98bf$var$destroy = function destroy() {
    for(var _len2 = arguments.length, form = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)form[_key2] = arguments[_key2];
    return {
        type: (0, $avrKI.DESTROY),
        meta: {
            form: form
        }
    };
};
var $2a837737b88c98bf$var$focus = function focus(form, field) {
    return {
        type: (0, $avrKI.FOCUS),
        meta: {
            form: form,
            field: field
        }
    };
};
var $2a837737b88c98bf$var$initialize = function initialize(form, values, keepDirty, otherMeta) {
    if (otherMeta === void 0) otherMeta = {};
    if (keepDirty instanceof Object) {
        otherMeta = keepDirty;
        keepDirty = false;
    }
    return {
        type: (0, $avrKI.INITIALIZE),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            form: form,
            keepDirty: keepDirty
        }, otherMeta),
        payload: values
    };
};
var $2a837737b88c98bf$var$registerField = function registerField(form, name, type) {
    return {
        type: (0, $avrKI.REGISTER_FIELD),
        meta: {
            form: form
        },
        payload: {
            name: name,
            type: type
        }
    };
};
var $2a837737b88c98bf$var$reset = function reset(form) {
    return {
        type: (0, $avrKI.RESET),
        meta: {
            form: form
        }
    };
};
var $2a837737b88c98bf$var$resetSection = function resetSection(form) {
    for(var _len3 = arguments.length, sections = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)sections[_key3 - 1] = arguments[_key3];
    return {
        type: (0, $avrKI.RESET_SECTION),
        meta: {
            form: form,
            sections: sections
        }
    };
};
var $2a837737b88c98bf$var$startAsyncValidation = function startAsyncValidation(form, field) {
    return {
        type: (0, $avrKI.START_ASYNC_VALIDATION),
        meta: {
            form: form,
            field: field
        }
    };
};
var $2a837737b88c98bf$var$startSubmit = function startSubmit(form) {
    return {
        type: (0, $avrKI.START_SUBMIT),
        meta: {
            form: form
        }
    };
};
var $2a837737b88c98bf$var$stopAsyncValidation = function stopAsyncValidation(form, errors) {
    return {
        type: (0, $avrKI.STOP_ASYNC_VALIDATION),
        meta: {
            form: form
        },
        payload: errors,
        error: !!(errors && Object.keys(errors).length)
    };
};
var $2a837737b88c98bf$var$stopSubmit = function stopSubmit(form, errors) {
    return {
        type: (0, $avrKI.STOP_SUBMIT),
        meta: {
            form: form
        },
        payload: errors,
        error: !!(errors && Object.keys(errors).length)
    };
};
var $2a837737b88c98bf$var$submit = function submit(form) {
    return {
        type: (0, $avrKI.SUBMIT),
        meta: {
            form: form
        }
    };
};
var $2a837737b88c98bf$var$setSubmitFailed = function setSubmitFailed(form) {
    for(var _len4 = arguments.length, fields = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)fields[_key4 - 1] = arguments[_key4];
    return {
        type: (0, $avrKI.SET_SUBMIT_FAILED),
        meta: {
            form: form,
            fields: fields
        },
        error: true
    };
};
var $2a837737b88c98bf$var$setSubmitSucceeded = function setSubmitSucceeded(form) {
    for(var _len5 = arguments.length, fields = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)fields[_key5 - 1] = arguments[_key5];
    return {
        type: (0, $avrKI.SET_SUBMIT_SUCCEEDED),
        meta: {
            form: form,
            fields: fields
        },
        error: false
    };
};
var $2a837737b88c98bf$var$touch = function touch(form) {
    for(var _len6 = arguments.length, fields = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++)fields[_key6 - 1] = arguments[_key6];
    return {
        type: (0, $avrKI.TOUCH),
        meta: {
            form: form,
            fields: fields
        }
    };
};
var $2a837737b88c98bf$var$unregisterField = function unregisterField(form, name, destroyOnUnmount) {
    if (destroyOnUnmount === void 0) destroyOnUnmount = true;
    return {
        type: (0, $avrKI.UNREGISTER_FIELD),
        meta: {
            form: form
        },
        payload: {
            name: name,
            destroyOnUnmount: destroyOnUnmount
        }
    };
};
var $2a837737b88c98bf$var$untouch = function untouch(form) {
    for(var _len7 = arguments.length, fields = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++)fields[_key7 - 1] = arguments[_key7];
    return {
        type: (0, $avrKI.UNTOUCH),
        meta: {
            form: form,
            fields: fields
        }
    };
};
var $2a837737b88c98bf$var$updateSyncErrors = function updateSyncErrors(form, syncErrors, error) {
    if (syncErrors === void 0) syncErrors = {};
    return {
        type: (0, $avrKI.UPDATE_SYNC_ERRORS),
        meta: {
            form: form
        },
        payload: {
            syncErrors: syncErrors,
            error: error
        }
    };
};
var $2a837737b88c98bf$var$updateSyncWarnings = function updateSyncWarnings(form, syncWarnings, warning) {
    if (syncWarnings === void 0) syncWarnings = {};
    return {
        type: (0, $avrKI.UPDATE_SYNC_WARNINGS),
        meta: {
            form: form
        },
        payload: {
            syncWarnings: syncWarnings,
            warning: warning
        }
    };
};
var $2a837737b88c98bf$var$actions = {
    arrayInsert: $2a837737b88c98bf$var$arrayInsert,
    arrayMove: $2a837737b88c98bf$var$arrayMove,
    arrayPop: $2a837737b88c98bf$var$arrayPop,
    arrayPush: $2a837737b88c98bf$var$arrayPush,
    arrayRemove: $2a837737b88c98bf$var$arrayRemove,
    arrayRemoveAll: $2a837737b88c98bf$var$arrayRemoveAll,
    arrayShift: $2a837737b88c98bf$var$arrayShift,
    arraySplice: $2a837737b88c98bf$var$arraySplice,
    arraySwap: $2a837737b88c98bf$var$arraySwap,
    arrayUnshift: $2a837737b88c98bf$var$arrayUnshift,
    autofill: $2a837737b88c98bf$var$autofill,
    blur: $2a837737b88c98bf$var$blur,
    change: $2a837737b88c98bf$var$change,
    clearFields: $2a837737b88c98bf$var$clearFields,
    clearSubmit: $2a837737b88c98bf$var$clearSubmit,
    clearSubmitErrors: $2a837737b88c98bf$var$clearSubmitErrors,
    clearAsyncError: $2a837737b88c98bf$var$clearAsyncError,
    destroy: $2a837737b88c98bf$var$destroy,
    focus: $2a837737b88c98bf$var$focus,
    initialize: $2a837737b88c98bf$var$initialize,
    registerField: $2a837737b88c98bf$var$registerField,
    reset: $2a837737b88c98bf$var$reset,
    resetSection: $2a837737b88c98bf$var$resetSection,
    startAsyncValidation: $2a837737b88c98bf$var$startAsyncValidation,
    startSubmit: $2a837737b88c98bf$var$startSubmit,
    stopAsyncValidation: $2a837737b88c98bf$var$stopAsyncValidation,
    stopSubmit: $2a837737b88c98bf$var$stopSubmit,
    submit: $2a837737b88c98bf$var$submit,
    setSubmitFailed: $2a837737b88c98bf$var$setSubmitFailed,
    setSubmitSucceeded: $2a837737b88c98bf$var$setSubmitSucceeded,
    touch: $2a837737b88c98bf$var$touch,
    unregisterField: $2a837737b88c98bf$var$unregisterField,
    untouch: $2a837737b88c98bf$var$untouch,
    updateSyncErrors: $2a837737b88c98bf$var$updateSyncErrors,
    updateSyncWarnings: $2a837737b88c98bf$var$updateSyncWarnings
};
var $2a837737b88c98bf$export$2e2bcd8739ae039 = $2a837737b88c98bf$var$actions;

});
parcelRegister("avrKI", function(module, exports) {

$parcel$export(module.exports, "prefix", function () { return $7a6253acadafc0fd$export$82e9f45cca5ba907; });
$parcel$export(module.exports, "ARRAY_INSERT", function () { return $7a6253acadafc0fd$export$2fa18eff08da1d53; });
$parcel$export(module.exports, "ARRAY_MOVE", function () { return $7a6253acadafc0fd$export$a85f06355cbe10f1; });
$parcel$export(module.exports, "ARRAY_POP", function () { return $7a6253acadafc0fd$export$45fcb236d553a280; });
$parcel$export(module.exports, "ARRAY_PUSH", function () { return $7a6253acadafc0fd$export$fe66c080f1ad85df; });
$parcel$export(module.exports, "ARRAY_REMOVE", function () { return $7a6253acadafc0fd$export$2b384dc8ecab97ef; });
$parcel$export(module.exports, "ARRAY_REMOVE_ALL", function () { return $7a6253acadafc0fd$export$5ad69c3ad617243d; });
$parcel$export(module.exports, "ARRAY_SHIFT", function () { return $7a6253acadafc0fd$export$4edfbb4666e727b2; });
$parcel$export(module.exports, "ARRAY_SPLICE", function () { return $7a6253acadafc0fd$export$96d6d95dfce21148; });
$parcel$export(module.exports, "ARRAY_UNSHIFT", function () { return $7a6253acadafc0fd$export$212aafcafc66e01e; });
$parcel$export(module.exports, "ARRAY_SWAP", function () { return $7a6253acadafc0fd$export$d3d1b9914d28d734; });
$parcel$export(module.exports, "AUTOFILL", function () { return $7a6253acadafc0fd$export$ca815ec44133a387; });
$parcel$export(module.exports, "BLUR", function () { return $7a6253acadafc0fd$export$565566e3df4dad53; });
$parcel$export(module.exports, "CHANGE", function () { return $7a6253acadafc0fd$export$4bef51da9b53f613; });
$parcel$export(module.exports, "CLEAR_FIELDS", function () { return $7a6253acadafc0fd$export$11ec03a468ece532; });
$parcel$export(module.exports, "CLEAR_SUBMIT", function () { return $7a6253acadafc0fd$export$5337d014aa2e70dc; });
$parcel$export(module.exports, "CLEAR_SUBMIT_ERRORS", function () { return $7a6253acadafc0fd$export$7970655d3b4aebc8; });
$parcel$export(module.exports, "CLEAR_ASYNC_ERROR", function () { return $7a6253acadafc0fd$export$a03676fb78b12172; });
$parcel$export(module.exports, "DESTROY", function () { return $7a6253acadafc0fd$export$31bf7b39daf71c67; });
$parcel$export(module.exports, "FOCUS", function () { return $7a6253acadafc0fd$export$82de3c1c31c751e2; });
$parcel$export(module.exports, "INITIALIZE", function () { return $7a6253acadafc0fd$export$6823add66d608438; });
$parcel$export(module.exports, "REGISTER_FIELD", function () { return $7a6253acadafc0fd$export$d9ae3161da4a1cd6; });
$parcel$export(module.exports, "RESET", function () { return $7a6253acadafc0fd$export$4a991c87e640ef77; });
$parcel$export(module.exports, "RESET_SECTION", function () { return $7a6253acadafc0fd$export$fd146e50f86b9922; });
$parcel$export(module.exports, "SET_SUBMIT_FAILED", function () { return $7a6253acadafc0fd$export$c11b013cb3567dd9; });
$parcel$export(module.exports, "SET_SUBMIT_SUCCEEDED", function () { return $7a6253acadafc0fd$export$ad89c3618e52d82; });
$parcel$export(module.exports, "START_ASYNC_VALIDATION", function () { return $7a6253acadafc0fd$export$25fe4362a8215d1b; });
$parcel$export(module.exports, "START_SUBMIT", function () { return $7a6253acadafc0fd$export$84b27c7a842faa32; });
$parcel$export(module.exports, "STOP_ASYNC_VALIDATION", function () { return $7a6253acadafc0fd$export$a9c1f85ffbd276cc; });
$parcel$export(module.exports, "STOP_SUBMIT", function () { return $7a6253acadafc0fd$export$84d0049f96ffecc5; });
$parcel$export(module.exports, "SUBMIT", function () { return $7a6253acadafc0fd$export$324ecb06850cfa68; });
$parcel$export(module.exports, "TOUCH", function () { return $7a6253acadafc0fd$export$d46bd3ead7cc759b; });
$parcel$export(module.exports, "UNREGISTER_FIELD", function () { return $7a6253acadafc0fd$export$cd19d19dad056f20; });
$parcel$export(module.exports, "UNTOUCH", function () { return $7a6253acadafc0fd$export$17ef2d9ab5fa260a; });
$parcel$export(module.exports, "UPDATE_SYNC_ERRORS", function () { return $7a6253acadafc0fd$export$6b6a856472683c7f; });
$parcel$export(module.exports, "UPDATE_SYNC_WARNINGS", function () { return $7a6253acadafc0fd$export$951c6c57692b5935; });
var $7a6253acadafc0fd$export$82e9f45cca5ba907 = "@@redux-form/";
var $7a6253acadafc0fd$export$2fa18eff08da1d53 = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "ARRAY_INSERT";
var $7a6253acadafc0fd$export$a85f06355cbe10f1 = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "ARRAY_MOVE";
var $7a6253acadafc0fd$export$45fcb236d553a280 = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "ARRAY_POP";
var $7a6253acadafc0fd$export$fe66c080f1ad85df = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "ARRAY_PUSH";
var $7a6253acadafc0fd$export$2b384dc8ecab97ef = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "ARRAY_REMOVE";
var $7a6253acadafc0fd$export$5ad69c3ad617243d = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "ARRAY_REMOVE_ALL";
var $7a6253acadafc0fd$export$4edfbb4666e727b2 = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "ARRAY_SHIFT";
var $7a6253acadafc0fd$export$96d6d95dfce21148 = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "ARRAY_SPLICE";
var $7a6253acadafc0fd$export$212aafcafc66e01e = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "ARRAY_UNSHIFT";
var $7a6253acadafc0fd$export$d3d1b9914d28d734 = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "ARRAY_SWAP";
var $7a6253acadafc0fd$export$ca815ec44133a387 = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "AUTOFILL";
var $7a6253acadafc0fd$export$565566e3df4dad53 = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "BLUR";
var $7a6253acadafc0fd$export$4bef51da9b53f613 = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "CHANGE";
var $7a6253acadafc0fd$export$11ec03a468ece532 = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "CLEAR_FIELDS";
var $7a6253acadafc0fd$export$5337d014aa2e70dc = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "CLEAR_SUBMIT";
var $7a6253acadafc0fd$export$7970655d3b4aebc8 = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "CLEAR_SUBMIT_ERRORS";
var $7a6253acadafc0fd$export$a03676fb78b12172 = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "CLEAR_ASYNC_ERROR";
var $7a6253acadafc0fd$export$31bf7b39daf71c67 = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "DESTROY";
var $7a6253acadafc0fd$export$82de3c1c31c751e2 = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "FOCUS";
var $7a6253acadafc0fd$export$6823add66d608438 = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "INITIALIZE";
var $7a6253acadafc0fd$export$d9ae3161da4a1cd6 = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "REGISTER_FIELD";
var $7a6253acadafc0fd$export$4a991c87e640ef77 = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "RESET";
var $7a6253acadafc0fd$export$fd146e50f86b9922 = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "RESET_SECTION";
var $7a6253acadafc0fd$export$c11b013cb3567dd9 = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "SET_SUBMIT_FAILED";
var $7a6253acadafc0fd$export$ad89c3618e52d82 = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "SET_SUBMIT_SUCCEEDED";
var $7a6253acadafc0fd$export$25fe4362a8215d1b = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "START_ASYNC_VALIDATION";
var $7a6253acadafc0fd$export$84b27c7a842faa32 = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "START_SUBMIT";
var $7a6253acadafc0fd$export$a9c1f85ffbd276cc = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "STOP_ASYNC_VALIDATION";
var $7a6253acadafc0fd$export$84d0049f96ffecc5 = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "STOP_SUBMIT";
var $7a6253acadafc0fd$export$324ecb06850cfa68 = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "SUBMIT";
var $7a6253acadafc0fd$export$d46bd3ead7cc759b = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "TOUCH";
var $7a6253acadafc0fd$export$cd19d19dad056f20 = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "UNREGISTER_FIELD";
var $7a6253acadafc0fd$export$17ef2d9ab5fa260a = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "UNTOUCH";
var $7a6253acadafc0fd$export$6b6a856472683c7f = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "UPDATE_SYNC_ERRORS";
var $7a6253acadafc0fd$export$951c6c57692b5935 = $7a6253acadafc0fd$export$82e9f45cca5ba907 + "UPDATE_SYNC_WARNINGS";

});


parcelRegister("jL7BL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6284ee480955bd3$export$2e2bcd8739ae039; });

var $6So50 = parcelRequire("6So50");

var $hdOPR = parcelRequire("hdOPR");
var $e6284ee480955bd3$export$2e2bcd8739ae039 = (0, $6So50.default)((0, $hdOPR.default));

});
parcelRegister("6So50", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $501a76f5bd147ff0$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $eVDe4 = parcelRequire("eVDe4");

var $2mGxr = parcelRequire("2mGxr");

var $9nHZC = parcelRequire("9nHZC");

var $eLE6M = parcelRequire("eLE6M");

var $blCBi = parcelRequire("blCBi");

var $5kF1c = parcelRequire("5kF1c");

var $eTVcW = parcelRequire("eTVcW");

var $3lzsQ = parcelRequire("3lzsQ");

var $1BS7f = parcelRequire("1BS7f");

var $hdOPR = parcelRequire("hdOPR");

var $lyNli = parcelRequire("lyNli");

var $7XxTT = parcelRequire("7XxTT");
var $501a76f5bd147ff0$var$createField = function createField(structure) {
    var ConnectedField = (0, $eTVcW.default)(structure);
    var setIn = structure.setIn;
    var Field = /*#__PURE__*/ function(_Component) {
        (0, (/*@__PURE__*/$parcel$interopDefault($2mGxr)))(Field, _Component);
        function Field(props) {
            var _this;
            _this = _Component.call(this, props) || this;
            _this.ref = (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createRef();
            _this.ref = (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createRef();
            _this.normalize = function(name, value) {
                var normalize = _this.props.normalize;
                if (!normalize) return value;
                var previousValues = _this.props._reduxForm.getValues();
                var previousValue = _this.value;
                var nextValues = setIn(previousValues, name, value);
                return normalize(value, previousValue, nextValues, previousValues, name);
            };
            if (!props._reduxForm) throw new Error("Field must be inside a component decorated with reduxForm()");
            return _this;
        }
        var _proto = Field.prototype;
        _proto.componentDidMount = function componentDidMount() {
            var _this2 = this;
            this.props._reduxForm.register(this.name, "Field", function() {
                return _this2.props.validate;
            }, function() {
                return _this2.props.warn;
            });
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            return (0, $3lzsQ.default)(this, nextProps, nextState);
        };
        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
            var oldName = (0, $1BS7f.default)(this.props, this.props.name);
            var newName = (0, $1BS7f.default)(nextProps, nextProps.name);
            if (oldName !== newName || // use deepEqual here because they could be a function or an array of functions
            !(0, $hdOPR.default).deepEqual(this.props.validate, nextProps.validate) || !(0, $hdOPR.default).deepEqual(this.props.warn, nextProps.warn)) {
                // unregister old name
                this.props._reduxForm.unregister(oldName); // register new name
                this.props._reduxForm.register(newName, "Field", function() {
                    return nextProps.validate;
                }, function() {
                    return nextProps.warn;
                });
            }
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.props._reduxForm.unregister(this.name);
        };
        _proto.getRenderedComponent = function getRenderedComponent() {
            (0, (/*@__PURE__*/$parcel$interopDefault($5kF1c)))(this.props.forwardRef, "If you want to access getRenderedComponent(), you must specify a forwardRef prop to Field");
            return this.ref.current ? this.ref.current.getRenderedComponent() : undefined;
        };
        _proto.render = function render() {
            return (0, $9nHZC.createElement)(ConnectedField, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, this.props, {
                name: this.name,
                normalize: this.normalize,
                ref: this.ref
            }));
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(Field, [
            {
                key: "name",
                get: function get() {
                    return (0, $1BS7f.default)(this.props, this.props.name);
                }
            },
            {
                key: "dirty",
                get: function get() {
                    return !this.pristine;
                }
            },
            {
                key: "pristine",
                get: function get() {
                    return !!(this.ref.current && this.ref.current.isPristine());
                }
            },
            {
                key: "value",
                get: function get() {
                    return this.ref.current && this.ref.current.getValue();
                }
            }
        ]);
        return Field;
    }((0, $9nHZC.Component));
    Field.propTypes = {
        name: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).string.isRequired,
        component: (0, $7XxTT.default),
        format: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
        normalize: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
        onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
        onChange: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
        onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
        onDragStart: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
        onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
        parse: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
        props: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).object,
        validate: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func)
        ]),
        warn: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func)
        ]),
        forwardRef: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).bool,
        immutableProps: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).string),
        _reduxForm: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).object
    };
    (0, $eLE6M.polyfill)(Field);
    return (0, $lyNli.withReduxForm)(Field);
};
var $501a76f5bd147ff0$export$2e2bcd8739ae039 = $501a76f5bd147ff0$var$createField;

});
parcelRegister("eTVcW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad9294072af5a705$export$2e2bcd8739ae039; });

var $j7eBO = parcelRequire("j7eBO");

var $fPPqr = parcelRequire("fPPqr");

var $2mGxr = parcelRequire("2mGxr");

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");
parcelRequire("dGzLf");
var $5oGLl = parcelRequire("5oGLl");

var $c0WRT = parcelRequire("c0WRT");

var $clyMk = parcelRequire("clyMk");

var $iDRly = parcelRequire("iDRly");

var $hdOPR = parcelRequire("hdOPR");

var $2DrVG = parcelRequire("2DrVG");

var $7XxTT = parcelRequire("7XxTT");

var $kYlkY = parcelRequire("kYlkY");
var $ad9294072af5a705$var$propsToNotUpdateFor = [
    "_reduxForm"
];
var $ad9294072af5a705$var$isObject = function isObject(entity) {
    return entity && typeof entity === "object";
};
var $ad9294072af5a705$var$isFunction = function isFunction(entity) {
    return entity && typeof entity === "function";
};
var $ad9294072af5a705$var$eventPreventDefault = function eventPreventDefault(event) {
    if ($ad9294072af5a705$var$isObject(event) && $ad9294072af5a705$var$isFunction(event.preventDefault)) event.preventDefault();
};
var $ad9294072af5a705$var$eventDataTransferGetData = function eventDataTransferGetData(event, key) {
    if ($ad9294072af5a705$var$isObject(event) && $ad9294072af5a705$var$isObject(event.dataTransfer) && $ad9294072af5a705$var$isFunction(event.dataTransfer.getData)) return event.dataTransfer.getData(key);
};
var $ad9294072af5a705$var$eventDataTransferSetData = function eventDataTransferSetData(event, key, value) {
    if ($ad9294072af5a705$var$isObject(event) && $ad9294072af5a705$var$isObject(event.dataTransfer) && $ad9294072af5a705$var$isFunction(event.dataTransfer.setData)) event.dataTransfer.setData(key, value);
};
var $ad9294072af5a705$var$createConnectedField = function createConnectedField(structure) {
    var deepEqual = structure.deepEqual, getIn = structure.getIn;
    var getSyncError = function getSyncError(syncErrors, name) {
        var error = (0, $hdOPR.default).getIn(syncErrors, name); // Because the error for this field might not be at a level in the error structure where
        // it can be set directly, it might need to be unwrapped from the _error property
        return error && error._error ? error._error : error;
    };
    var getSyncWarning = function getSyncWarning(syncWarnings, name) {
        var warning = getIn(syncWarnings, name); // Because the warning for this field might not be at a level in the warning structure where
        // it can be set directly, it might need to be unwrapped from the _warning property
        return warning && warning._warning ? warning._warning : warning;
    };
    var ConnectedField = /*#__PURE__*/ function(_Component) {
        (0, (/*@__PURE__*/$parcel$interopDefault($2mGxr)))(ConnectedField, _Component);
        function ConnectedField() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _Component.call.apply(_Component, [
                this
            ].concat(args)) || this;
            _this.ref = (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createRef();
            _this.isPristine = function() {
                return _this.props.pristine;
            };
            _this.getValue = function() {
                return _this.props.value;
            };
            _this.handleChange = function(event) {
                var _this$props = _this.props, name = _this$props.name, dispatch = _this$props.dispatch, parse = _this$props.parse, normalize = _this$props.normalize, onChange = _this$props.onChange, _reduxForm = _this$props._reduxForm, previousValue = _this$props.value;
                var newValue = (0, $clyMk.default)(event, {
                    name: name,
                    parse: parse,
                    normalize: normalize
                });
                var defaultPrevented = false;
                if (onChange) {
                    // Can't seem to find a way to extend Event in React Native,
                    // thus I simply avoid adding preventDefault() in a RN environment
                    // to prevent the following error:
                    // `One of the sources for assign has an enumerable key on the prototype chain`
                    // Reference: https://github.com/facebook/react-native/issues/5507
                    if (!(0, $2DrVG.default) && (0, $kYlkY.default)(event)) onChange((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, event, {
                        preventDefault: function preventDefault() {
                            defaultPrevented = true;
                            return $ad9294072af5a705$var$eventPreventDefault(event);
                        }
                    }), newValue, previousValue, name);
                    else defaultPrevented = onChange(event, newValue, previousValue, name);
                }
                if (!defaultPrevented) {
                    // dispatch change action
                    dispatch(_reduxForm.change(name, newValue)); // call post-change callback
                    if (_reduxForm.asyncValidate) _reduxForm.asyncValidate(name, newValue, "change");
                }
            };
            _this.handleFocus = function(event) {
                var _this$props2 = _this.props, name = _this$props2.name, dispatch = _this$props2.dispatch, onFocus = _this$props2.onFocus, _reduxForm = _this$props2._reduxForm;
                var defaultPrevented = false;
                if (onFocus) {
                    if (!(0, $2DrVG.default)) onFocus((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, event, {
                        preventDefault: function preventDefault() {
                            defaultPrevented = true;
                            return $ad9294072af5a705$var$eventPreventDefault(event);
                        }
                    }), name);
                    else defaultPrevented = onFocus(event, name);
                }
                if (!defaultPrevented) dispatch(_reduxForm.focus(name));
            };
            _this.handleBlur = function(event) {
                var _this$props3 = _this.props, name = _this$props3.name, dispatch = _this$props3.dispatch, parse = _this$props3.parse, normalize = _this$props3.normalize, onBlur = _this$props3.onBlur, _reduxForm = _this$props3._reduxForm, _value = _this$props3._value, previousValue = _this$props3.value;
                var newValue = (0, $clyMk.default)(event, {
                    name: name,
                    parse: parse,
                    normalize: normalize
                }); // for checkbox and radio, if the value property of checkbox or radio equals
                // the value passed by blur event, then fire blur action with previousValue.
                if (newValue === _value && _value !== undefined) newValue = previousValue;
                var defaultPrevented = false;
                if (onBlur) {
                    if (!(0, $2DrVG.default)) onBlur((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, event, {
                        preventDefault: function preventDefault() {
                            defaultPrevented = true;
                            return $ad9294072af5a705$var$eventPreventDefault(event);
                        }
                    }), newValue, previousValue, name);
                    else defaultPrevented = onBlur(event, newValue, previousValue, name);
                }
                if (!defaultPrevented) {
                    // dispatch blur action
                    dispatch(_reduxForm.blur(name, newValue)); // call post-blur callback
                    if (_reduxForm.asyncValidate) _reduxForm.asyncValidate(name, newValue, "blur");
                }
            };
            _this.handleDragStart = function(event) {
                var _this$props4 = _this.props, name = _this$props4.name, onDragStart = _this$props4.onDragStart, value = _this$props4.value;
                $ad9294072af5a705$var$eventDataTransferSetData(event, (0, $iDRly.dataKey), value == null ? "" : value);
                if (onDragStart) onDragStart(event, name);
            };
            _this.handleDrop = function(event) {
                var _this$props5 = _this.props, name = _this$props5.name, dispatch = _this$props5.dispatch, onDrop = _this$props5.onDrop, _reduxForm = _this$props5._reduxForm, previousValue = _this$props5.value;
                var newValue = $ad9294072af5a705$var$eventDataTransferGetData(event, (0, $iDRly.dataKey));
                var defaultPrevented = false;
                if (onDrop) onDrop((0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, event, {
                    preventDefault: function preventDefault() {
                        defaultPrevented = true;
                        return $ad9294072af5a705$var$eventPreventDefault(event);
                    }
                }), newValue, previousValue, name);
                if (!defaultPrevented) {
                    // dispatch change action
                    dispatch(_reduxForm.change(name, newValue));
                    $ad9294072af5a705$var$eventPreventDefault(event);
                }
            };
            return _this;
        }
        var _proto = ConnectedField.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            var _this2 = this;
            var nextPropsKeys = Object.keys(nextProps);
            var thisPropsKeys = Object.keys(this.props); // if we have children, we MUST update in React 16
            // https://twitter.com/erikras/status/915866544558788608
            return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function(prop) {
                if (~(nextProps.immutableProps || []).indexOf(prop)) return _this2.props[prop] !== nextProps[prop];
                return !~$ad9294072af5a705$var$propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
            }));
        };
        _proto.getRenderedComponent = function getRenderedComponent() {
            return this.ref.current;
        };
        _proto.render = function render() {
            var _this$props6 = this.props, component = _this$props6.component, forwardRef = _this$props6.forwardRef, name = _this$props6.name, _reduxForm = _this$props6._reduxForm, normalize = _this$props6.normalize, onBlur = _this$props6.onBlur, onChange = _this$props6.onChange, onFocus = _this$props6.onFocus, onDragStart = _this$props6.onDragStart, onDrop = _this$props6.onDrop, immutableProps = _this$props6.immutableProps, rest = (0, (/*@__PURE__*/$parcel$interopDefault($j7eBO)))(_this$props6, [
                "component",
                "forwardRef",
                "name",
                "_reduxForm",
                "normalize",
                "onBlur",
                "onChange",
                "onFocus",
                "onDragStart",
                "onDrop",
                "immutableProps"
            ]);
            var _createFieldProps = (0, $c0WRT.default)(structure, name, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
                form: _reduxForm.form,
                onBlur: this.handleBlur,
                onChange: this.handleChange,
                onDrop: this.handleDrop,
                onDragStart: this.handleDragStart,
                onFocus: this.handleFocus
            })), custom = _createFieldProps.custom, props = (0, (/*@__PURE__*/$parcel$interopDefault($j7eBO)))(_createFieldProps, [
                "custom"
            ]);
            if (forwardRef) custom.ref = this.ref;
            if (typeof component === "string") {
                var input = props.input, meta = props.meta; // eslint-disable-line no-unused-vars
                // flatten input into other props
                return (0, $9nHZC.createElement)(component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, input, custom));
            } else return (0, $9nHZC.createElement)(component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, custom));
        };
        return ConnectedField;
    }((0, $9nHZC.Component));
    ConnectedField.propTypes = {
        component: (0, $7XxTT.default),
        props: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).object
    };
    var connector = (0, $5oGLl.default)(function(state, ownProps) {
        var name = ownProps.name, _ownProps$_reduxForm = ownProps._reduxForm, initialValues = _ownProps$_reduxForm.initialValues, getFormState = _ownProps$_reduxForm.getFormState;
        var formState = getFormState(state);
        var initialState = getIn(formState, "initial." + name);
        var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
        var value = getIn(formState, "values." + name);
        var submitting = getIn(formState, "submitting");
        var syncError = getSyncError(getIn(formState, "syncErrors"), name);
        var syncWarning = getSyncWarning(getIn(formState, "syncWarnings"), name);
        var pristine = deepEqual(value, initial);
        return {
            asyncError: getIn(formState, "asyncErrors." + name),
            asyncValidating: getIn(formState, "asyncValidating") === name,
            dirty: !pristine,
            pristine: pristine,
            state: getIn(formState, "fields." + name),
            submitError: getIn(formState, "submitErrors." + name),
            submitFailed: getIn(formState, "submitFailed"),
            submitting: submitting,
            syncError: syncError,
            syncWarning: syncWarning,
            initial: initial,
            value: value,
            _value: ownProps.value // save value passed in (for radios)
        };
    }, undefined, undefined, {
        forwardRef: true
    });
    return connector(ConnectedField);
};
var $ad9294072af5a705$export$2e2bcd8739ae039 = $ad9294072af5a705$var$createConnectedField;

});
parcelRegister("c0WRT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8bf3262250ea6b24$export$2e2bcd8739ae039; });

var $j7eBO = parcelRequire("j7eBO");

var $fPPqr = parcelRequire("fPPqr");
var $8bf3262250ea6b24$var$processProps = function processProps(type, props, _value, deepEqual) {
    var value = props.value;
    if (type === "checkbox") return (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        checked: !!value
    });
    if (type === "radio") return (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        checked: deepEqual(value, _value),
        value: _value
    });
    if (type === "select-multiple") return (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        value: value || []
    });
    if (type === "file") return (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        value: value || undefined
    });
    return props;
};
var $8bf3262250ea6b24$var$createFieldProps = function createFieldProps(_ref, name, _ref2) {
    var getIn = _ref.getIn, toJS = _ref.toJS, deepEqual = _ref.deepEqual;
    var asyncError = _ref2.asyncError, asyncValidating = _ref2.asyncValidating, onBlur = _ref2.onBlur, onChange = _ref2.onChange, onDrop = _ref2.onDrop, onDragStart = _ref2.onDragStart, dirty = _ref2.dirty, dispatch = _ref2.dispatch, onFocus = _ref2.onFocus, form = _ref2.form, format = _ref2.format, initial = _ref2.initial, parse = _ref2.parse, pristine = _ref2.pristine, props = _ref2.props, state = _ref2.state, submitError = _ref2.submitError, submitFailed = _ref2.submitFailed, submitting = _ref2.submitting, syncError = _ref2.syncError, syncWarning = _ref2.syncWarning, validate = _ref2.validate, value = _ref2.value, _value = _ref2._value, warn = _ref2.warn, custom = (0, (/*@__PURE__*/$parcel$interopDefault($j7eBO)))(_ref2, [
        "asyncError",
        "asyncValidating",
        "onBlur",
        "onChange",
        "onDrop",
        "onDragStart",
        "dirty",
        "dispatch",
        "onFocus",
        "form",
        "format",
        "initial",
        "parse",
        "pristine",
        "props",
        "state",
        "submitError",
        "submitFailed",
        "submitting",
        "syncError",
        "syncWarning",
        "validate",
        "value",
        "_value",
        "warn"
    ]);
    var error = syncError || asyncError || submitError;
    var warning = syncWarning;
    var formatFieldValue = function formatFieldValue(value, format) {
        if (format === null) return value;
        var defaultFormattedValue = value == null ? "" : value;
        return format ? format(value, name) : defaultFormattedValue;
    };
    var formattedFieldValue = formatFieldValue(value, format);
    return {
        input: $8bf3262250ea6b24$var$processProps(custom.type, {
            name: name,
            onBlur: onBlur,
            onChange: onChange,
            onDragStart: onDragStart,
            onDrop: onDrop,
            onFocus: onFocus,
            value: formattedFieldValue
        }, _value, deepEqual),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, toJS(state), {
            active: !!(state && getIn(state, "active")),
            asyncValidating: asyncValidating,
            autofilled: !!(state && getIn(state, "autofilled")),
            dirty: dirty,
            dispatch: dispatch,
            error: error,
            form: form,
            initial: initial,
            warning: warning,
            invalid: !!error,
            pristine: pristine,
            submitting: !!submitting,
            submitFailed: !!submitFailed,
            touched: !!(state && getIn(state, "touched")),
            valid: !error,
            visited: !!(state && getIn(state, "visited"))
        }),
        custom: (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, custom, props)
    };
};
var $8bf3262250ea6b24$export$2e2bcd8739ae039 = $8bf3262250ea6b24$var$createFieldProps;

});

parcelRegister("clyMk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0251d875a4dc183b$export$2e2bcd8739ae039; });

var $lOLbO = parcelRequire("lOLbO");

var $2DrVG = parcelRequire("2DrVG");
var $0251d875a4dc183b$var$onChangeValue = function onChangeValue(event, _ref) {
    var name = _ref.name, parse = _ref.parse, normalize = _ref.normalize;
    // read value from input
    var value = (0, $lOLbO.default)(event, (0, $2DrVG.default)); // parse value if we have a parser
    if (parse) value = parse(value, name);
     // normalize value
    if (normalize) value = normalize(name, value);
    return value;
};
var $0251d875a4dc183b$export$2e2bcd8739ae039 = $0251d875a4dc183b$var$onChangeValue;

});
parcelRegister("lOLbO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe22df53039d974f$export$2e2bcd8739ae039; });

var $kYlkY = parcelRequire("kYlkY");
var $fe22df53039d974f$var$getSelectedValues = function getSelectedValues(options) {
    var result = [];
    if (options) for(var index = 0; index < options.length; index++){
        var option = options[index];
        if (option.selected) result.push(option.value);
    }
    return result;
};
var $fe22df53039d974f$var$getValue = function getValue(event, isReactNative) {
    if ((0, $kYlkY.default)(event)) {
        if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) return event.nativeEvent.text;
        if (isReactNative && event.nativeEvent !== undefined) return event.nativeEvent.text;
        var detypedEvent = event;
        var _detypedEvent$target = detypedEvent.target, type = _detypedEvent$target.type, value = _detypedEvent$target.value, checked = _detypedEvent$target.checked, files = _detypedEvent$target.files, dataTransfer = detypedEvent.dataTransfer;
        if (type === "checkbox") return !!checked;
        if (type === "file") return files || dataTransfer && dataTransfer.files;
        if (type === "select-multiple") return $fe22df53039d974f$var$getSelectedValues(event.target.options);
        return value;
    }
    return event;
};
var $fe22df53039d974f$export$2e2bcd8739ae039 = $fe22df53039d974f$var$getValue;

});
parcelRegister("kYlkY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f449f65ccd076460$export$2e2bcd8739ae039; });
var $f449f65ccd076460$var$isEvent = function isEvent(candidate) {
    return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
};
var $f449f65ccd076460$export$2e2bcd8739ae039 = $f449f65ccd076460$var$isEvent;

});


parcelRegister("2DrVG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1eb4e3783984d9ed$export$2e2bcd8739ae039; });
var $1eb4e3783984d9ed$var$isReactNative = typeof window !== "undefined" && window.navigator && window.navigator.product && window.navigator.product === "ReactNative";
var $1eb4e3783984d9ed$export$2e2bcd8739ae039 = $1eb4e3783984d9ed$var$isReactNative;

});


parcelRegister("iDRly", function(module, exports) {

$parcel$export(module.exports, "dataKey", function () { return $d925400926b102ba$export$c5302c530e8c11ba; });
var $d925400926b102ba$export$c5302c530e8c11ba = "text";

});

parcelRegister("hdOPR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c89b156fa1389467$export$2e2bcd8739ae039; });

var $cHFz2 = parcelRequire("cHFz2");

var $3eCr4 = parcelRequire("3eCr4");

var $hLcJR = parcelRequire("hLcJR");

var $ak0By = parcelRequire("ak0By");

var $2B1ug = parcelRequire("2B1ug");

var $1XixV = parcelRequire("1XixV");
var $c89b156fa1389467$var$structure = {
    allowsArrayErrors: true,
    empty: {},
    emptyList: [],
    getIn: (0, $3eCr4.default),
    setIn: (0, $hLcJR.default),
    deepEqual: (0, $ak0By.default),
    deleteIn: (0, $2B1ug.default),
    forEach: function forEach(items, callback) {
        return items.forEach(callback);
    },
    fromJS: function fromJS(value) {
        return value;
    },
    keys: (0, $1XixV.default),
    size: function size(array) {
        return array ? array.length : 0;
    },
    some: function some(items, callback) {
        return items.some(callback);
    },
    splice: (0, $cHFz2.default),
    equals: function equals(a, b) {
        return b.every(function(val) {
            return ~a.indexOf(val);
        });
    },
    orderChanged: function orderChanged(a, b) {
        return b.some(function(val, index) {
            return val !== a[index];
        });
    },
    toJS: function toJS(value) {
        return value;
    }
};
var $c89b156fa1389467$export$2e2bcd8739ae039 = $c89b156fa1389467$var$structure;

});
parcelRegister("cHFz2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93f9bdf149eb1476$export$2e2bcd8739ae039; });
var $93f9bdf149eb1476$var$splice = function splice(array, index, removeNum, value) {
    array = array || [];
    if (index < array.length) {
        if (value === undefined && !removeNum) {
            // inserting undefined
            var _copy2 = [].concat(array);
            _copy2.splice(index, 0, true); // temporary placeholder
            _copy2[index] = undefined; // set to undefined
            return _copy2;
        }
        if (value != null) {
            var _copy3 = [].concat(array);
            _copy3.splice(index, removeNum, value); // removing and adding
            return _copy3;
        }
        var _copy = [].concat(array);
        _copy.splice(index, removeNum); // removing
        return _copy;
    }
    if (removeNum) // trying to remove non-existant item: return original array
    return array;
     // trying to add outside of range: just set value
    var copy = [].concat(array);
    copy[index] = value;
    return copy;
};
var $93f9bdf149eb1476$export$2e2bcd8739ae039 = $93f9bdf149eb1476$var$splice;

});

parcelRegister("3eCr4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25b07e6b25e5a841$export$2e2bcd8739ae039; });

var $fyzH0 = parcelRequire("fyzH0");
var $25b07e6b25e5a841$var$getIn = function getIn(state, field) {
    if (!state) return state;
    var path = (0, (/*@__PURE__*/$parcel$interopDefault($fyzH0)))(field);
    var length = path.length;
    if (!length) return undefined;
    var result = state;
    for(var i = 0; i < length && result; ++i)result = result[path[i]];
    return result;
};
var $25b07e6b25e5a841$export$2e2bcd8739ae039 = $25b07e6b25e5a841$var$getIn;

});
parcelRegister("fyzH0", function(module, exports) {

var $Ne8Zl = parcelRequire("Ne8Zl");

var $8HdJ8 = parcelRequire("8HdJ8");

var $lsPUZ = parcelRequire("lsPUZ");

var $eE9rN = parcelRequire("eE9rN");

var $8ceA6 = parcelRequire("8ceA6");

var $fyTMm = parcelRequire("fyTMm");

var $1srqY = parcelRequire("1srqY");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $b535b7cc008834c8$var$toPath(value) {
    if ($lsPUZ(value)) return $Ne8Zl(value, $fyTMm);
    return $eE9rN(value) ? [
        value
    ] : $8HdJ8($8ceA6($1srqY(value)));
}
module.exports = $b535b7cc008834c8$var$toPath;

});


parcelRegister("hLcJR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cee0b51670a3ad59$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $fyzH0 = parcelRequire("fyzH0");
var $cee0b51670a3ad59$var$setInWithPath = function setInWithPath(state, value, path, pathIndex) {
    var _extends2;
    if (pathIndex >= path.length) return value;
    var first = path[pathIndex];
    var firstState = state && (Array.isArray(state) ? state[Number(first)] : state[first]);
    var next = setInWithPath(firstState, value, path, pathIndex + 1);
    if (!state) {
        if (isNaN(first)) {
            var _ref;
            return _ref = {}, _ref[first] = next, _ref;
        }
        var initialized = [];
        initialized[parseInt(first, 10)] = next;
        return initialized;
    }
    if (Array.isArray(state)) {
        var copy = [].concat(state);
        copy[parseInt(first, 10)] = next;
        return copy;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, state, (_extends2 = {}, _extends2[first] = next, _extends2));
};
var $cee0b51670a3ad59$var$setIn = function setIn(state, field, value) {
    return $cee0b51670a3ad59$var$setInWithPath(state, value, (0, (/*@__PURE__*/$parcel$interopDefault($fyzH0)))(field), 0);
};
var $cee0b51670a3ad59$export$2e2bcd8739ae039 = $cee0b51670a3ad59$var$setIn;

});

parcelRegister("ak0By", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $783c3dbb891c5546$export$2e2bcd8739ae039; });

var $dFpgK = parcelRequire("dFpgK");

var $coDhE = parcelRequire("coDhE");

var $9nHZC = parcelRequire("9nHZC");
var $783c3dbb891c5546$var$isEmpty = function isEmpty(obj) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($dFpgK)))(obj) || obj === "" || isNaN(obj);
};
var $783c3dbb891c5546$var$customizer = function customizer(obj, other) {
    if (obj === other) return true;
    if (!obj && !other) return $783c3dbb891c5546$var$isEmpty(obj) === $783c3dbb891c5546$var$isEmpty(other);
    if (obj && other && obj._error !== other._error) return false;
    if (obj && other && obj._warning !== other._warning) return false;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).isValidElement(obj) || (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).isValidElement(other)) return false;
};
var $783c3dbb891c5546$var$deepEqual = function deepEqual(a, b) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($coDhE)))(a, b, $783c3dbb891c5546$var$customizer);
};
var $783c3dbb891c5546$export$2e2bcd8739ae039 = $783c3dbb891c5546$var$deepEqual;

});
parcelRegister("dFpgK", function(module, exports) {
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $9f32b4a1e9ae0080$var$isNil(value) {
    return value == null;
}
module.exports = $9f32b4a1e9ae0080$var$isNil;

});

parcelRegister("coDhE", function(module, exports) {

var $6Ewzi = parcelRequire("6Ewzi");
/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */ function $906632dc4a8e1fd4$var$isEqualWith(value, other, customizer) {
    customizer = typeof customizer == "function" ? customizer : undefined;
    var result = customizer ? customizer(value, other) : undefined;
    return result === undefined ? $6Ewzi(value, other, undefined, customizer) : !!result;
}
module.exports = $906632dc4a8e1fd4$var$isEqualWith;

});


parcelRegister("2B1ug", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e4030c7f9db701e$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $fyzH0 = parcelRequire("fyzH0");
function $1e4030c7f9db701e$var$deleteInWithPath(state, first) {
    if (state === undefined || state === null || first === undefined || first === null) return state;
    for(var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)rest[_key - 2] = arguments[_key];
    if (rest.length) {
        if (Array.isArray(state)) {
            if (isNaN(first)) throw new Error('Must access array elements with a number, not "' + String(first) + '".');
            var firstIndex = Number(first);
            if (firstIndex < state.length) {
                var result = $1e4030c7f9db701e$var$deleteInWithPath.apply(void 0, [
                    state && state[firstIndex]
                ].concat(rest));
                if (result !== state[firstIndex]) {
                    var copy = [].concat(state);
                    copy[firstIndex] = result;
                    return copy;
                }
            }
            return state;
        }
        if (first in state) {
            var _extends2;
            var _result = $1e4030c7f9db701e$var$deleteInWithPath.apply(void 0, [
                state && state[first]
            ].concat(rest));
            return state[first] === _result ? state : (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, state, (_extends2 = {}, _extends2[first] = _result, _extends2));
        }
        return state;
    }
    if (Array.isArray(state)) {
        if (isNaN(first)) throw new Error('Cannot delete non-numerical index from an array. Given: "' + String(first));
        var _firstIndex = Number(first);
        if (_firstIndex < state.length) {
            var _copy = [].concat(state);
            _copy.splice(_firstIndex, 1);
            return _copy;
        }
        return state;
    }
    if (first in state) {
        var _copy2 = (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, state);
        delete _copy2[first];
        return _copy2;
    }
    return state;
}
var $1e4030c7f9db701e$var$deleteIn = function deleteIn(state, field) {
    return $1e4030c7f9db701e$var$deleteInWithPath.apply(void 0, [
        state
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fyzH0)))(field)));
};
var $1e4030c7f9db701e$export$2e2bcd8739ae039 = $1e4030c7f9db701e$var$deleteIn;

});

parcelRegister("1XixV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16c9b00284840e40$export$2e2bcd8739ae039; });
function $16c9b00284840e40$var$keys(value) {
    if (!value) return [];
    if (Array.isArray(value)) return value.map(function(i) {
        return i.name;
    });
    return Object.keys(value);
}
var $16c9b00284840e40$export$2e2bcd8739ae039 = $16c9b00284840e40$var$keys;

});


parcelRegister("7XxTT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5cb85708c2dc3cc4$export$2e2bcd8739ae039; });

var $fAROH = parcelRequire("fAROH");
var $5cb85708c2dc3cc4$var$validateComponentProp = function validateComponentProp(props, propName, componentName) {
    if (!(0, $fAROH.isValidElementType)(props[propName])) return new Error("Invalid prop `" + propName + "` supplied to" + " `" + componentName + "`.");
    return null;
};
var $5cb85708c2dc3cc4$export$2e2bcd8739ae039 = $5cb85708c2dc3cc4$var$validateComponentProp;

});


parcelRegister("3lzsQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26fed7bd6f38164f$export$2e2bcd8739ae039; });

var $coDhE = parcelRequire("coDhE");
var $26fed7bd6f38164f$var$customizer = function customizer(objectValue, otherValue, indexOrkey, object, other, stack) {
    // https://lodash.com/docs/4.17.4#isEqualWith
    if (stack) // Shallow compares
    // For 1st level, stack === undefined.
    //   -> Do nothing (and implicitly return undefined so that it goes to compare 2nd level)
    // For 2nd level and up, stack !== undefined.
    //   -> Compare by === operator
    return objectValue === otherValue;
};
var $26fed7bd6f38164f$var$shallowCompare = function shallowCompare(instance, nextProps, nextState) {
    var propsEqual = (0, (/*@__PURE__*/$parcel$interopDefault($coDhE)))(instance.props, nextProps, $26fed7bd6f38164f$var$customizer);
    var stateEqual = (0, (/*@__PURE__*/$parcel$interopDefault($coDhE)))(instance.state, nextState, $26fed7bd6f38164f$var$customizer);
    return !propsEqual || !stateEqual;
};
var $26fed7bd6f38164f$export$2e2bcd8739ae039 = $26fed7bd6f38164f$var$shallowCompare;

});

parcelRegister("1BS7f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12c339759028f129$export$2e2bcd8739ae039; });
var $12c339759028f129$var$formatName = function formatName(_ref, name) {
    var sectionPrefix = _ref._reduxForm.sectionPrefix;
    return sectionPrefix ? sectionPrefix + "." + name : name;
};
var $12c339759028f129$export$2e2bcd8739ae039 = $12c339759028f129$var$formatName;

});

parcelRegister("lyNli", function(module, exports) {

$parcel$export(module.exports, "ReduxFormContext", function () { return $fb230c5b66c2e82c$export$b494835337bd6220; });
$parcel$export(module.exports, "withReduxForm", function () { return $fb230c5b66c2e82c$export$cf2e8d3a9f27b794; });

var $2mGxr = parcelRequire("2mGxr");

var $fPPqr = parcelRequire("fPPqr");

var $j7eBO = parcelRequire("j7eBO");

var $9nHZC = parcelRequire("9nHZC");
var $fb230c5b66c2e82c$export$b494835337bd6220 = $9nHZC.createContext(null);
var $fb230c5b66c2e82c$export$cd762ccf1a583d69 = function renderChildren(Component, _ref) {
    var forwardedRef = _ref.forwardedRef, rest = (0, (/*@__PURE__*/$parcel$interopDefault($j7eBO)))(_ref, [
        "forwardedRef"
    ]);
    return function(_reduxForm) {
        return $9nHZC.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
            _reduxForm: _reduxForm,
            ref: forwardedRef
        }));
    };
};
var $fb230c5b66c2e82c$export$cf2e8d3a9f27b794 = function withReduxForm(Component) {
    var Hoc = /*#__PURE__*/ function(_React$Component) {
        (0, (/*@__PURE__*/$parcel$interopDefault($2mGxr)))(Hoc, _React$Component);
        function Hoc() {
            return _React$Component.apply(this, arguments) || this;
        }
        var _proto = Hoc.prototype;
        _proto.render = function render() {
            return $9nHZC.createElement($fb230c5b66c2e82c$export$b494835337bd6220.Consumer, {
                children: $fb230c5b66c2e82c$export$cd762ccf1a583d69(Component, this.props)
            });
        };
        return Hoc;
    }($9nHZC.Component);
    var ref = $9nHZC.forwardRef(function(props, ref) {
        return $9nHZC.createElement(Hoc, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
            forwardedRef: ref
        }));
    });
    ref.displayName = Component.displayName || Component.name || "Component";
    return ref;
};

});



parcelRegister("kuUjF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eec24b326ed66a00$export$2e2bcd8739ae039; });

var $6yKzj = parcelRequire("6yKzj");

var $hdOPR = parcelRequire("hdOPR");
var $eec24b326ed66a00$export$2e2bcd8739ae039 = (0, $6yKzj.default)((0, $hdOPR.default));

});
parcelRegister("6yKzj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c6a0a95a7b573f6$export$2e2bcd8739ae039; });
var $4c6a0a95a7b573f6$var$createGetFormValues = function createGetFormValues(_ref) {
    var getIn = _ref.getIn;
    return function(form, getFormState) {
        return function(state) {
            var nonNullGetFormState = getFormState || function(state) {
                return getIn(state, "form");
            };
            return getIn(nonNullGetFormState(state), form + ".values");
        };
    };
};
var $4c6a0a95a7b573f6$export$2e2bcd8739ae039 = $4c6a0a95a7b573f6$var$createGetFormValues;

});


parcelRegister("bDK33", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87970e70355da2b9$export$2e2bcd8739ae039; });

var $jxZ2j = parcelRequire("jxZ2j");

var $hdOPR = parcelRequire("hdOPR");
var $87970e70355da2b9$export$2e2bcd8739ae039 = (0, $jxZ2j.default)((0, $hdOPR.default));

});
parcelRegister("jxZ2j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3b071efa5f53406$export$2e2bcd8739ae039; });

var $eVDe4 = parcelRequire("eVDe4");

var $2mGxr = parcelRequire("2mGxr");

var $fPPqr = parcelRequire("fPPqr");

var $j7eBO = parcelRequire("j7eBO");

var $dGehf = parcelRequire("dGehf");

var $3GtlK = parcelRequire("3GtlK");

var $eLE6M = parcelRequire("eLE6M");

var $1t1PC = parcelRequire("1t1PC");

var $5kF1c = parcelRequire("5kF1c");

var $9MfJv = parcelRequire("9MfJv");

var $blCBi = parcelRequire("blCBi");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("dGzLf");
var $5oGLl = parcelRequire("5oGLl");

var $jF3Yx = parcelRequire("jF3Yx");

var $3EivG = parcelRequire("3EivG");

var $4Fgv6 = parcelRequire("4Fgv6");

var $cCWIW = parcelRequire("cCWIW");

var $gSxRJ = parcelRequire("gSxRJ");

var $iN2IY = parcelRequire("iN2IY");

var $hXbCw = parcelRequire("hXbCw");

var $hFyW0 = parcelRequire("hFyW0");

var $1mO82 = parcelRequire("1mO82");

var $jQyfO = parcelRequire("jQyfO");

var $6FwlZ = parcelRequire("6FwlZ");

var $5oOSJ = parcelRequire("5oOSJ");

var $hdOPR = parcelRequire("hdOPR");

var $fmjGQ = parcelRequire("fmjGQ");

var $kRXsl = parcelRequire("kRXsl");

var $lyNli = parcelRequire("lyNli");
var $e3b071efa5f53406$var$isClassComponent = function isClassComponent(Component) {
    return Boolean(Component && Component.prototype && typeof Component.prototype.isReactComponent === "object");
}; // extract field-specific actions
var $e3b071efa5f53406$var$arrayInsert = (0, $3EivG.default).arrayInsert, $e3b071efa5f53406$var$arrayMove = (0, $3EivG.default).arrayMove, $e3b071efa5f53406$var$arrayPop = (0, $3EivG.default).arrayPop, $e3b071efa5f53406$var$arrayPush = (0, $3EivG.default).arrayPush, $e3b071efa5f53406$var$arrayRemove = (0, $3EivG.default).arrayRemove, $e3b071efa5f53406$var$arrayRemoveAll = (0, $3EivG.default).arrayRemoveAll, $e3b071efa5f53406$var$arrayShift = (0, $3EivG.default).arrayShift, $e3b071efa5f53406$var$arraySplice = (0, $3EivG.default).arraySplice, $e3b071efa5f53406$var$arraySwap = (0, $3EivG.default).arraySwap, $e3b071efa5f53406$var$arrayUnshift = (0, $3EivG.default).arrayUnshift, $e3b071efa5f53406$var$blur = (0, $3EivG.default).blur, $e3b071efa5f53406$var$change = (0, $3EivG.default).change, $e3b071efa5f53406$var$focus = (0, $3EivG.default).focus, $e3b071efa5f53406$var$formActions = (0, (/*@__PURE__*/$parcel$interopDefault($j7eBO)))((0, $3EivG.default), [
    "arrayInsert",
    "arrayMove",
    "arrayPop",
    "arrayPush",
    "arrayRemove",
    "arrayRemoveAll",
    "arrayShift",
    "arraySplice",
    "arraySwap",
    "arrayUnshift",
    "blur",
    "change",
    "focus"
]);
var $e3b071efa5f53406$var$arrayActions = {
    arrayInsert: $e3b071efa5f53406$var$arrayInsert,
    arrayMove: $e3b071efa5f53406$var$arrayMove,
    arrayPop: $e3b071efa5f53406$var$arrayPop,
    arrayPush: $e3b071efa5f53406$var$arrayPush,
    arrayRemove: $e3b071efa5f53406$var$arrayRemove,
    arrayRemoveAll: $e3b071efa5f53406$var$arrayRemoveAll,
    arrayShift: $e3b071efa5f53406$var$arrayShift,
    arraySplice: $e3b071efa5f53406$var$arraySplice,
    arraySwap: $e3b071efa5f53406$var$arraySwap,
    arrayUnshift: $e3b071efa5f53406$var$arrayUnshift
};
var $e3b071efa5f53406$var$propsToNotUpdateFor = [].concat(Object.keys((0, $3EivG.default)), [
    "array",
    "asyncErrors",
    "initialValues",
    "syncErrors",
    "syncWarnings",
    "values",
    "registeredFields"
]);
var $e3b071efa5f53406$var$checkSubmit = function checkSubmit(submit) {
    if (!submit || typeof submit !== "function") throw new Error("You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop");
    return submit;
};
/**
 * The decorator that is the main API to redux-form
 */ var $e3b071efa5f53406$var$createReduxForm = function createReduxForm(structure) {
    var deepEqual = structure.deepEqual, empty = structure.empty, getIn = structure.getIn, setIn = structure.setIn, keys = structure.keys, fromJS = structure.fromJS;
    var isValid = (0, $5oOSJ.default)(structure);
    return function(initialConfig) {
        var config = (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            touchOnBlur: true,
            touchOnChange: false,
            persistentSubmitErrors: false,
            destroyOnUnmount: true,
            shouldAsyncValidate: (0, $cCWIW.default),
            shouldValidate: (0, $gSxRJ.default),
            shouldError: (0, $iN2IY.default),
            shouldWarn: (0, $hXbCw.default),
            enableReinitialize: false,
            keepDirtyOnReinitialize: false,
            updateUnregisteredFields: false,
            getFormState: function getFormState(state) {
                return getIn(state, "form");
            },
            pure: true,
            forceUnregisterOnUnmount: false,
            submitAsSideEffect: false
        }, initialConfig);
        return function(WrappedComponent) {
            var Form = /*#__PURE__*/ function(_React$Component) {
                (0, (/*@__PURE__*/$parcel$interopDefault($2mGxr)))(Form, _React$Component);
                function Form() {
                    var _this;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    _this = _React$Component.call.apply(_React$Component, [
                        this
                    ].concat(args)) || this;
                    _this.wrapped = (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createRef();
                    _this.destroyed = false;
                    _this.fieldCounts = {};
                    _this.fieldValidators = {};
                    _this.lastFieldValidatorKeys = [];
                    _this.fieldWarners = {};
                    _this.lastFieldWarnerKeys = [];
                    _this.innerOnSubmit = undefined;
                    _this.submitPromise = undefined;
                    _this.getValues = function() {
                        return _this.props.values;
                    };
                    _this.isValid = function() {
                        return _this.props.valid;
                    };
                    _this.isPristine = function() {
                        return _this.props.pristine;
                    };
                    _this.register = function(name, type, getValidator, getWarner) {
                        var lastCount = _this.fieldCounts[name];
                        var nextCount = (lastCount || 0) + 1;
                        _this.fieldCounts[name] = nextCount;
                        _this.props.registerField(name, type);
                        if (getValidator) _this.fieldValidators[name] = getValidator;
                        if (getWarner) _this.fieldWarners[name] = getWarner;
                    };
                    _this.unregister = function(name) {
                        var lastCount = _this.fieldCounts[name];
                        if (lastCount === 1) delete _this.fieldCounts[name];
                        else if (lastCount != null) _this.fieldCounts[name] = lastCount - 1;
                        if (!_this.destroyed) {
                            var _this$props = _this.props, _destroyOnUnmount = _this$props.destroyOnUnmount, forceUnregisterOnUnmount = _this$props.forceUnregisterOnUnmount, unregisterField = _this$props.unregisterField;
                            if (_destroyOnUnmount || forceUnregisterOnUnmount) {
                                unregisterField(name, _destroyOnUnmount);
                                if (!_this.fieldCounts[name]) {
                                    delete _this.fieldValidators[name];
                                    delete _this.fieldWarners[name];
                                    _this.lastFieldValidatorKeys = _this.lastFieldValidatorKeys.filter(function(key) {
                                        return key !== name;
                                    });
                                }
                            } else unregisterField(name, false);
                        }
                    };
                    _this.getFieldList = function(options) {
                        var registeredFields = _this.props.registeredFields;
                        var list = [];
                        if (!registeredFields) return list;
                        var keySeq = keys(registeredFields);
                        if (options) {
                            if (options.excludeFieldArray) keySeq = keySeq.filter(function(name) {
                                return getIn(registeredFields, "['" + name + "'].type") !== "FieldArray";
                            });
                            if (options.excludeUnregistered) keySeq = keySeq.filter(function(name) {
                                return getIn(registeredFields, "['" + name + "'].count") !== 0;
                            });
                        }
                        return fromJS(keySeq.reduce(function(acc, key) {
                            acc.push(key);
                            return acc;
                        }, list));
                    };
                    _this.getValidators = function() {
                        var validators = {};
                        Object.keys(_this.fieldValidators).forEach(function(name) {
                            var validator = _this.fieldValidators[name]();
                            if (validator) validators[name] = validator;
                        });
                        return validators;
                    };
                    _this.generateValidator = function() {
                        var validators = _this.getValidators();
                        return Object.keys(validators).length ? (0, $jQyfO.default)(validators, structure) : undefined;
                    };
                    _this.getWarners = function() {
                        var warners = {};
                        Object.keys(_this.fieldWarners).forEach(function(name) {
                            var warner = _this.fieldWarners[name]();
                            if (warner) warners[name] = warner;
                        });
                        return warners;
                    };
                    _this.generateWarner = function() {
                        var warners = _this.getWarners();
                        return Object.keys(warners).length ? (0, $jQyfO.default)(warners, structure) : undefined;
                    };
                    _this.asyncValidate = function(name, value, trigger) {
                        var _this$props2 = _this.props, asyncBlurFields = _this$props2.asyncBlurFields, asyncChangeFields = _this$props2.asyncChangeFields, asyncErrors = _this$props2.asyncErrors, asyncValidate = _this$props2.asyncValidate, dispatch = _this$props2.dispatch, initialized = _this$props2.initialized, pristine = _this$props2.pristine, shouldAsyncValidate = _this$props2.shouldAsyncValidate, startAsyncValidation = _this$props2.startAsyncValidation, stopAsyncValidation = _this$props2.stopAsyncValidation, syncErrors = _this$props2.syncErrors, values = _this$props2.values;
                        var submitting = !name;
                        var fieldNeedsValidation = function fieldNeedsValidation() {
                            var fieldNeedsValidationForBlur = asyncBlurFields && name && ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, "[]"));
                            var fieldNeedsValidationForChange = asyncChangeFields && name && ~asyncChangeFields.indexOf(name.replace(/\[[0-9]+\]/g, "[]"));
                            var asyncValidateByDefault = !(asyncBlurFields || asyncChangeFields);
                            return submitting || asyncValidateByDefault || (trigger === "blur" ? fieldNeedsValidationForBlur : fieldNeedsValidationForChange);
                        };
                        if (asyncValidate) {
                            var valuesToValidate = submitting ? values : setIn(values, name, value);
                            var syncValidationPasses = submitting || !getIn(syncErrors, name);
                            if (fieldNeedsValidation() && shouldAsyncValidate({
                                asyncErrors: asyncErrors,
                                initialized: initialized,
                                trigger: submitting ? "submit" : trigger,
                                blurredField: name,
                                pristine: pristine,
                                syncValidationPasses: syncValidationPasses
                            })) return (0, $4Fgv6.default)(function() {
                                return asyncValidate(valuesToValidate, dispatch, _this.props, name);
                            }, startAsyncValidation, stopAsyncValidation, name);
                        }
                    };
                    _this.submitCompleted = function(result) {
                        delete _this.submitPromise;
                        return result;
                    };
                    _this.submitFailed = function(error) {
                        delete _this.submitPromise;
                        throw error;
                    };
                    _this.listenToSubmit = function(promise) {
                        if (!(0, (/*@__PURE__*/$parcel$interopDefault($9MfJv)))(promise)) return promise;
                        _this.submitPromise = promise;
                        return promise.then(_this.submitCompleted, _this.submitFailed);
                    };
                    _this.submit = function(submitOrEvent) {
                        var _this$props3 = _this.props, onSubmit = _this$props3.onSubmit, blur = _this$props3.blur, change = _this$props3.change, dispatch = _this$props3.dispatch;
                        if (!submitOrEvent || (0, $hFyW0.default)(submitOrEvent)) // submitOrEvent is an event: fire submit if not already submitting
                        {
                            if (!_this.submitPromise) {
                                // avoid recursive stack trace if use Form with onSubmit as handleSubmit
                                if (_this.innerOnSubmit && _this.innerOnSubmit !== _this.submit) // will call "submitOrEvent is the submit function" block below
                                return _this.innerOnSubmit();
                                else return _this.listenToSubmit((0, $6FwlZ.default)($e3b071efa5f53406$var$checkSubmit(onSubmit), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, _this.props, (0, $jF3Yx.bindActionCreators)({
                                    blur: blur,
                                    change: change
                                }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({
                                    excludeFieldArray: true,
                                    excludeUnregistered: true
                                })));
                            }
                        } else // submitOrEvent is the submit function: return deferred submit thunk
                        return (0, $1mO82.default)(function() {
                            return !_this.submitPromise && _this.listenToSubmit((0, $6FwlZ.default)($e3b071efa5f53406$var$checkSubmit(submitOrEvent), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, _this.props, (0, $jF3Yx.bindActionCreators)({
                                blur: blur,
                                change: change
                            }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({
                                excludeFieldArray: true,
                                excludeUnregistered: true
                            })));
                        });
                    };
                    _this.reset = function() {
                        return _this.props.reset();
                    };
                    return _this;
                }
                var _proto = Form.prototype;
                _proto.initIfNeeded = function initIfNeeded(nextProps) {
                    var enableReinitialize = this.props.enableReinitialize;
                    if (nextProps) {
                        if ((enableReinitialize || !nextProps.initialized) && !deepEqual(this.props.initialValues, nextProps.initialValues)) {
                            var _keepDirty = nextProps.initialized && this.props.keepDirtyOnReinitialize;
                            this.props.initialize(nextProps.initialValues, _keepDirty, {
                                keepValues: nextProps.keepValues,
                                lastInitialValues: this.props.initialValues,
                                updateUnregisteredFields: nextProps.updateUnregisteredFields
                            });
                        }
                    } else if (this.props.initialValues && (!this.props.initialized || enableReinitialize)) this.props.initialize(this.props.initialValues, this.props.keepDirtyOnReinitialize, {
                        keepValues: this.props.keepValues,
                        updateUnregisteredFields: this.props.updateUnregisteredFields
                    });
                };
                _proto.updateSyncErrorsIfNeeded = function updateSyncErrorsIfNeeded(nextSyncErrors, nextError, lastSyncErrors) {
                    var _this$props4 = this.props, error = _this$props4.error, updateSyncErrors = _this$props4.updateSyncErrors;
                    var noErrors = (!lastSyncErrors || !Object.keys(lastSyncErrors).length) && !error;
                    var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;
                    if (!(noErrors && nextNoErrors) && (!(0, $hdOPR.default).deepEqual(lastSyncErrors, nextSyncErrors) || !(0, $hdOPR.default).deepEqual(error, nextError))) updateSyncErrors(nextSyncErrors, nextError);
                };
                _proto.clearSubmitPromiseIfNeeded = function clearSubmitPromiseIfNeeded(nextProps) {
                    var submitting = this.props.submitting;
                    if (this.submitPromise && submitting && !nextProps.submitting) delete this.submitPromise;
                };
                _proto.submitIfNeeded = function submitIfNeeded(nextProps) {
                    var _this$props5 = this.props, clearSubmit = _this$props5.clearSubmit, triggerSubmit = _this$props5.triggerSubmit;
                    if (!triggerSubmit && nextProps.triggerSubmit) {
                        clearSubmit();
                        this.submit();
                    }
                };
                _proto.shouldErrorFunction = function shouldErrorFunction() {
                    var _this$props6 = this.props, shouldValidate = _this$props6.shouldValidate, shouldError = _this$props6.shouldError;
                    var shouldValidateOverridden = shouldValidate !== (0, $gSxRJ.default);
                    var shouldErrorOverridden = shouldError !== (0, $iN2IY.default);
                    return shouldValidateOverridden && !shouldErrorOverridden ? shouldValidate : shouldError;
                };
                _proto.validateIfNeeded = function validateIfNeeded(nextProps) {
                    var _this$props7 = this.props, validate = _this$props7.validate, values = _this$props7.values;
                    var shouldError = this.shouldErrorFunction();
                    var fieldLevelValidate = this.generateValidator();
                    if (validate || fieldLevelValidate) {
                        var initialRender = nextProps === undefined;
                        var fieldValidatorKeys = Object.keys(this.getValidators());
                        var validateParams = {
                            values: values,
                            nextProps: nextProps,
                            props: this.props,
                            initialRender: initialRender,
                            lastFieldValidatorKeys: this.lastFieldValidatorKeys,
                            fieldValidatorKeys: fieldValidatorKeys,
                            structure: structure
                        };
                        if (shouldError(validateParams)) {
                            var propsToValidate = initialRender || !nextProps ? this.props : nextProps;
                            var _merge2 = (0, (/*@__PURE__*/$parcel$interopDefault($dGehf)))(validate ? validate(propsToValidate.values, propsToValidate) || {} : {}, fieldLevelValidate ? fieldLevelValidate(propsToValidate.values, propsToValidate) || {} : {}), _error = _merge2._error, nextSyncErrors = (0, (/*@__PURE__*/$parcel$interopDefault($j7eBO)))(_merge2, [
                                "_error"
                            ]);
                            this.lastFieldValidatorKeys = fieldValidatorKeys;
                            this.updateSyncErrorsIfNeeded(nextSyncErrors, _error, propsToValidate.syncErrors);
                        }
                    } else this.lastFieldValidatorKeys = [];
                };
                _proto.updateSyncWarningsIfNeeded = function updateSyncWarningsIfNeeded(nextSyncWarnings, nextWarning, lastSyncWarnings) {
                    var _this$props8 = this.props, warning = _this$props8.warning, updateSyncWarnings = _this$props8.updateSyncWarnings;
                    var noWarnings = (!lastSyncWarnings || !Object.keys(lastSyncWarnings).length) && !warning;
                    var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;
                    if (!(noWarnings && nextNoWarnings) && (!(0, $hdOPR.default).deepEqual(lastSyncWarnings, nextSyncWarnings) || !(0, $hdOPR.default).deepEqual(warning, nextWarning))) updateSyncWarnings(nextSyncWarnings, nextWarning);
                };
                _proto.shouldWarnFunction = function shouldWarnFunction() {
                    var _this$props9 = this.props, shouldValidate = _this$props9.shouldValidate, shouldWarn = _this$props9.shouldWarn;
                    var shouldValidateOverridden = shouldValidate !== (0, $gSxRJ.default);
                    var shouldWarnOverridden = shouldWarn !== (0, $hXbCw.default);
                    return shouldValidateOverridden && !shouldWarnOverridden ? shouldValidate : shouldWarn;
                };
                _proto.warnIfNeeded = function warnIfNeeded(nextProps) {
                    var _this$props10 = this.props, warn = _this$props10.warn, values = _this$props10.values;
                    var shouldWarn = this.shouldWarnFunction();
                    var fieldLevelWarn = this.generateWarner();
                    if (warn || fieldLevelWarn) {
                        var initialRender = nextProps === undefined;
                        var fieldWarnerKeys = Object.keys(this.getWarners());
                        var validateParams = {
                            values: values,
                            nextProps: nextProps,
                            props: this.props,
                            initialRender: initialRender,
                            lastFieldValidatorKeys: this.lastFieldWarnerKeys,
                            fieldValidatorKeys: fieldWarnerKeys,
                            structure: structure
                        };
                        if (shouldWarn(validateParams)) {
                            var propsToWarn = initialRender || !nextProps ? this.props : nextProps;
                            var _merge3 = (0, (/*@__PURE__*/$parcel$interopDefault($dGehf)))(warn ? warn(propsToWarn.values, propsToWarn) : {}, fieldLevelWarn ? fieldLevelWarn(propsToWarn.values, propsToWarn) : {}), _warning = _merge3._warning, nextSyncWarnings = (0, (/*@__PURE__*/$parcel$interopDefault($j7eBO)))(_merge3, [
                                "_warning"
                            ]);
                            this.lastFieldWarnerKeys = fieldWarnerKeys;
                            this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning, propsToWarn.syncWarnings);
                        }
                    }
                };
                _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                    if (!(0, $kRXsl.default)()) {
                        this.initIfNeeded();
                        this.validateIfNeeded();
                        this.warnIfNeeded();
                    }
                    (0, (/*@__PURE__*/$parcel$interopDefault($5kF1c)))(this.props.shouldValidate, "shouldValidate() is deprecated and will be removed in v9.0.0. Use shouldWarn() or shouldError() instead.");
                };
                _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
                    this.initIfNeeded(nextProps);
                    this.validateIfNeeded(nextProps);
                    this.warnIfNeeded(nextProps);
                    this.clearSubmitPromiseIfNeeded(nextProps);
                    this.submitIfNeeded(nextProps);
                    var onChange = nextProps.onChange, values = nextProps.values, dispatch = nextProps.dispatch;
                    if (onChange && !deepEqual(values, this.props.values)) onChange(values, dispatch, nextProps, this.props.values);
                };
                _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
                    var _this2 = this;
                    if (!this.props.pure) return true;
                    var _config$immutableProp = config.immutableProps, immutableProps = _config$immutableProp === void 0 ? [] : _config$immutableProp; // if we have children, we MUST update in React 16
                    // https://twitter.com/erikras/status/915866544558788608
                    return !!(this.props.children || nextProps.children || Object.keys(nextProps).some(function(prop) {
                        // useful to debug rerenders
                        // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
                        //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
                        // }
                        if (~immutableProps.indexOf(prop)) return _this2.props[prop] !== nextProps[prop];
                        return !~$e3b071efa5f53406$var$propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
                    }));
                };
                _proto.componentDidMount = function componentDidMount() {
                    if (!(0, $kRXsl.default)()) {
                        this.initIfNeeded(this.props);
                        this.validateIfNeeded();
                        this.warnIfNeeded();
                    }
                    (0, (/*@__PURE__*/$parcel$interopDefault($5kF1c)))(this.props.shouldValidate, "shouldValidate() is deprecated and will be removed in v9.0.0. Use shouldWarn() or shouldError() instead.");
                };
                _proto.componentWillUnmount = function componentWillUnmount() {
                    var _this$props11 = this.props, destroyOnUnmount = _this$props11.destroyOnUnmount, destroy = _this$props11.destroy;
                    if (destroyOnUnmount && !(0, $kRXsl.default)()) {
                        this.destroyed = true;
                        destroy();
                    }
                };
                _proto.render = function render() {
                    var _ref, _this3 = this;
                    // remove some redux-form config-only props
                    /* eslint-disable no-unused-vars */ var _this$props12 = this.props, anyTouched = _this$props12.anyTouched, array = _this$props12.array, arrayInsert = _this$props12.arrayInsert, arrayMove = _this$props12.arrayMove, arrayPop = _this$props12.arrayPop, arrayPush = _this$props12.arrayPush, arrayRemove = _this$props12.arrayRemove, arrayRemoveAll = _this$props12.arrayRemoveAll, arrayShift = _this$props12.arrayShift, arraySplice = _this$props12.arraySplice, arraySwap = _this$props12.arraySwap, arrayUnshift = _this$props12.arrayUnshift, asyncErrors = _this$props12.asyncErrors, asyncValidate = _this$props12.asyncValidate, asyncValidating = _this$props12.asyncValidating, blur = _this$props12.blur, change = _this$props12.change, clearSubmit = _this$props12.clearSubmit, destroy = _this$props12.destroy, destroyOnUnmount = _this$props12.destroyOnUnmount, forceUnregisterOnUnmount = _this$props12.forceUnregisterOnUnmount, dirty = _this$props12.dirty, dispatch = _this$props12.dispatch, enableReinitialize = _this$props12.enableReinitialize, error = _this$props12.error, focus = _this$props12.focus, form = _this$props12.form, getFormState = _this$props12.getFormState, immutableProps = _this$props12.immutableProps, initialize = _this$props12.initialize, initialized = _this$props12.initialized, initialValues = _this$props12.initialValues, invalid = _this$props12.invalid, keepDirtyOnReinitialize = _this$props12.keepDirtyOnReinitialize, keepValues = _this$props12.keepValues, updateUnregisteredFields = _this$props12.updateUnregisteredFields, pristine = _this$props12.pristine, propNamespace = _this$props12.propNamespace, registeredFields = _this$props12.registeredFields, registerField = _this$props12.registerField, reset = _this$props12.reset, resetSection = _this$props12.resetSection, setSubmitFailed = _this$props12.setSubmitFailed, setSubmitSucceeded = _this$props12.setSubmitSucceeded, shouldAsyncValidate = _this$props12.shouldAsyncValidate, shouldValidate = _this$props12.shouldValidate, shouldError = _this$props12.shouldError, shouldWarn = _this$props12.shouldWarn, startAsyncValidation = _this$props12.startAsyncValidation, startSubmit = _this$props12.startSubmit, stopAsyncValidation = _this$props12.stopAsyncValidation, stopSubmit = _this$props12.stopSubmit, submitAsSideEffect = _this$props12.submitAsSideEffect, submitting = _this$props12.submitting, submitFailed = _this$props12.submitFailed, submitSucceeded = _this$props12.submitSucceeded, touch = _this$props12.touch, touchOnBlur = _this$props12.touchOnBlur, touchOnChange = _this$props12.touchOnChange, persistentSubmitErrors = _this$props12.persistentSubmitErrors, syncErrors = _this$props12.syncErrors, syncWarnings = _this$props12.syncWarnings, unregisterField = _this$props12.unregisterField, untouch = _this$props12.untouch, updateSyncErrors = _this$props12.updateSyncErrors, updateSyncWarnings = _this$props12.updateSyncWarnings, valid = _this$props12.valid, validExceptSubmit = _this$props12.validExceptSubmit, values = _this$props12.values, warning = _this$props12.warning, rest = (0, (/*@__PURE__*/$parcel$interopDefault($j7eBO)))(_this$props12, [
                        "anyTouched",
                        "array",
                        "arrayInsert",
                        "arrayMove",
                        "arrayPop",
                        "arrayPush",
                        "arrayRemove",
                        "arrayRemoveAll",
                        "arrayShift",
                        "arraySplice",
                        "arraySwap",
                        "arrayUnshift",
                        "asyncErrors",
                        "asyncValidate",
                        "asyncValidating",
                        "blur",
                        "change",
                        "clearSubmit",
                        "destroy",
                        "destroyOnUnmount",
                        "forceUnregisterOnUnmount",
                        "dirty",
                        "dispatch",
                        "enableReinitialize",
                        "error",
                        "focus",
                        "form",
                        "getFormState",
                        "immutableProps",
                        "initialize",
                        "initialized",
                        "initialValues",
                        "invalid",
                        "keepDirtyOnReinitialize",
                        "keepValues",
                        "updateUnregisteredFields",
                        "pristine",
                        "propNamespace",
                        "registeredFields",
                        "registerField",
                        "reset",
                        "resetSection",
                        "setSubmitFailed",
                        "setSubmitSucceeded",
                        "shouldAsyncValidate",
                        "shouldValidate",
                        "shouldError",
                        "shouldWarn",
                        "startAsyncValidation",
                        "startSubmit",
                        "stopAsyncValidation",
                        "stopSubmit",
                        "submitAsSideEffect",
                        "submitting",
                        "submitFailed",
                        "submitSucceeded",
                        "touch",
                        "touchOnBlur",
                        "touchOnChange",
                        "persistentSubmitErrors",
                        "syncErrors",
                        "syncWarnings",
                        "unregisterField",
                        "untouch",
                        "updateSyncErrors",
                        "updateSyncWarnings",
                        "valid",
                        "validExceptSubmit",
                        "values",
                        "warning"
                    ]);
                    /* eslint-enable no-unused-vars */ var reduxFormProps = (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                        array: array,
                        anyTouched: anyTouched,
                        asyncValidate: this.asyncValidate,
                        asyncValidating: asyncValidating
                    }, (0, $jF3Yx.bindActionCreators)({
                        blur: blur,
                        change: change
                    }, dispatch), {
                        clearSubmit: clearSubmit,
                        destroy: destroy,
                        dirty: dirty,
                        dispatch: dispatch,
                        error: error,
                        form: form,
                        handleSubmit: this.submit,
                        initialize: initialize,
                        initialized: initialized,
                        initialValues: initialValues,
                        invalid: invalid,
                        pristine: pristine,
                        reset: reset,
                        resetSection: resetSection,
                        submitting: submitting,
                        submitAsSideEffect: submitAsSideEffect,
                        submitFailed: submitFailed,
                        submitSucceeded: submitSucceeded,
                        touch: touch,
                        untouch: untouch,
                        valid: valid,
                        warning: warning
                    });
                    var propsToPass = (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, propNamespace ? (_ref = {}, _ref[propNamespace] = reduxFormProps, _ref) : reduxFormProps, rest);
                    if ($e3b071efa5f53406$var$isClassComponent(WrappedComponent)) propsToPass.ref = this.wrapped;
                    var _reduxForm = (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, this.props, {
                        getFormState: function getFormState(state) {
                            return getIn(_this3.props.getFormState(state), _this3.props.form);
                        },
                        asyncValidate: this.asyncValidate,
                        getValues: this.getValues,
                        sectionPrefix: undefined,
                        register: this.register,
                        unregister: this.unregister,
                        registerInnerOnSubmit: function registerInnerOnSubmit(innerOnSubmit) {
                            return _this3.innerOnSubmit = innerOnSubmit;
                        }
                    });
                    return (0, $9nHZC.createElement)((0, $lyNli.ReduxFormContext).Provider, {
                        value: _reduxForm,
                        children: (0, $9nHZC.createElement)(WrappedComponent, propsToPass)
                    });
                };
                return Form;
            }((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component);
            Form.displayName = "Form(" + (0, $fmjGQ.default)(WrappedComponent) + ")";
            Form.WrappedComponent = WrappedComponent;
            Form.propTypes = {
                destroyOnUnmount: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).bool,
                forceUnregisterOnUnmount: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).bool,
                form: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).string.isRequired,
                immutableProps: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).string),
                initialValues: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).oneOfType([
                    (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).array,
                    (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).object
                ]),
                getFormState: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
                onSubmitFail: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
                onSubmitSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
                propNamespace: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).string,
                validate: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
                warn: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
                touchOnBlur: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).bool,
                touchOnChange: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).bool,
                triggerSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).bool,
                persistentSubmitErrors: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).bool,
                registeredFields: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).any
            };
            var connector = (0, $5oGLl.default)(function(state, props) {
                var form = props.form, getFormState = props.getFormState, initialValues = props.initialValues, enableReinitialize = props.enableReinitialize, keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;
                var formState = getIn(getFormState(state) || empty, form) || empty;
                var stateInitial = getIn(formState, "initial");
                var initialized = !!stateInitial;
                var shouldUpdateInitialValues = enableReinitialize && initialized && !deepEqual(initialValues, stateInitial);
                var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;
                var initial = initialValues || stateInitial || empty;
                if (!shouldUpdateInitialValues) initial = stateInitial || empty;
                var values = getIn(formState, "values") || initial;
                if (shouldResetValues) values = initial;
                var pristine = shouldResetValues || deepEqual(initial, values);
                var asyncErrors = getIn(formState, "asyncErrors");
                var syncErrors = getIn(formState, "syncErrors") || (0, $hdOPR.default).empty;
                var syncWarnings = getIn(formState, "syncWarnings") || (0, $hdOPR.default).empty;
                var registeredFields = getIn(formState, "registeredFields");
                var valid = isValid(form, getFormState, false)(state);
                var validExceptSubmit = isValid(form, getFormState, true)(state);
                var anyTouched = !!getIn(formState, "anyTouched");
                var submitting = !!getIn(formState, "submitting");
                var submitFailed = !!getIn(formState, "submitFailed");
                var submitSucceeded = !!getIn(formState, "submitSucceeded");
                var error = getIn(formState, "error");
                var warning = getIn(formState, "warning");
                var triggerSubmit = getIn(formState, "triggerSubmit");
                return {
                    anyTouched: anyTouched,
                    asyncErrors: asyncErrors,
                    asyncValidating: getIn(formState, "asyncValidating") || false,
                    dirty: !pristine,
                    error: error,
                    initialized: initialized,
                    invalid: !valid,
                    pristine: pristine,
                    registeredFields: registeredFields,
                    submitting: submitting,
                    submitFailed: submitFailed,
                    submitSucceeded: submitSucceeded,
                    syncErrors: syncErrors,
                    syncWarnings: syncWarnings,
                    triggerSubmit: triggerSubmit,
                    values: values,
                    valid: valid,
                    validExceptSubmit: validExceptSubmit,
                    warning: warning
                };
            }, function(dispatch, initialProps) {
                var bindForm = function bindForm(actionCreator) {
                    return actionCreator.bind(null, initialProps.form);
                }; // Bind the first parameter on `props.form`
                var boundFormACs = (0, (/*@__PURE__*/$parcel$interopDefault($3GtlK)))($e3b071efa5f53406$var$formActions, bindForm);
                var boundArrayACs = (0, (/*@__PURE__*/$parcel$interopDefault($3GtlK)))($e3b071efa5f53406$var$arrayActions, bindForm);
                var boundBlur = function boundBlur(field, value) {
                    return $e3b071efa5f53406$var$blur(initialProps.form, field, value, !!initialProps.touchOnBlur);
                };
                var boundChange = function boundChange(field, value) {
                    return $e3b071efa5f53406$var$change(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
                };
                var boundFocus = bindForm($e3b071efa5f53406$var$focus); // Wrap action creators with `dispatch`
                var connectedFormACs = (0, $jF3Yx.bindActionCreators)(boundFormACs, dispatch);
                var connectedArrayACs = {
                    insert: (0, $jF3Yx.bindActionCreators)(boundArrayACs.arrayInsert, dispatch),
                    move: (0, $jF3Yx.bindActionCreators)(boundArrayACs.arrayMove, dispatch),
                    pop: (0, $jF3Yx.bindActionCreators)(boundArrayACs.arrayPop, dispatch),
                    push: (0, $jF3Yx.bindActionCreators)(boundArrayACs.arrayPush, dispatch),
                    remove: (0, $jF3Yx.bindActionCreators)(boundArrayACs.arrayRemove, dispatch),
                    removeAll: (0, $jF3Yx.bindActionCreators)(boundArrayACs.arrayRemoveAll, dispatch),
                    shift: (0, $jF3Yx.bindActionCreators)(boundArrayACs.arrayShift, dispatch),
                    splice: (0, $jF3Yx.bindActionCreators)(boundArrayACs.arraySplice, dispatch),
                    swap: (0, $jF3Yx.bindActionCreators)(boundArrayACs.arraySwap, dispatch),
                    unshift: (0, $jF3Yx.bindActionCreators)(boundArrayACs.arrayUnshift, dispatch)
                };
                return (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, connectedFormACs, boundArrayACs, {
                    blur: boundBlur,
                    change: boundChange,
                    array: connectedArrayACs,
                    focus: boundFocus,
                    dispatch: dispatch
                });
            }, undefined, {
                forwardRef: true
            });
            var ConnectedForm = (0, (/*@__PURE__*/$parcel$interopDefault($1t1PC)))(connector(Form), WrappedComponent);
            ConnectedForm.defaultProps = config; // build outer component to expose instance api
            var ReduxForm = /*#__PURE__*/ function(_React$Component2) {
                (0, (/*@__PURE__*/$parcel$interopDefault($2mGxr)))(ReduxForm, _React$Component2);
                function ReduxForm() {
                    var _this4;
                    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                    _this4 = _React$Component2.call.apply(_React$Component2, [
                        this
                    ].concat(args)) || this;
                    _this4.ref = (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createRef();
                    return _this4;
                }
                var _proto2 = ReduxForm.prototype;
                _proto2.submit = function submit() {
                    return this.ref.current && this.ref.current.submit();
                };
                _proto2.reset = function reset() {
                    if (this.ref) this.ref.current.reset();
                };
                _proto2.render = function render() {
                    var _this$props13 = this.props, initialValues = _this$props13.initialValues, rest = (0, (/*@__PURE__*/$parcel$interopDefault($j7eBO)))(_this$props13, [
                        "initialValues"
                    ]);
                    return (0, $9nHZC.createElement)(ConnectedForm, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, rest, {
                        ref: this.ref,
                        // convert initialValues if need to
                        initialValues: fromJS(initialValues)
                    }));
                };
                (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ReduxForm, [
                    {
                        key: "valid",
                        get: function get() {
                            return !!(this.ref.current && this.ref.current.isValid());
                        }
                    },
                    {
                        key: "invalid",
                        get: function get() {
                            return !this.valid;
                        }
                    },
                    {
                        key: "pristine",
                        get: function get() {
                            return !!(this.ref.current && this.ref.current.isPristine());
                        }
                    },
                    {
                        key: "dirty",
                        get: function get() {
                            return !this.pristine;
                        }
                    },
                    {
                        key: "values",
                        get: function get() {
                            return this.ref.current ? this.ref.current.getValues() : empty;
                        }
                    },
                    {
                        key: "fieldList",
                        get: function get() {
                            // mainly provided for testing
                            return this.ref.current ? this.ref.current.getFieldList() : [];
                        }
                    },
                    {
                        key: "wrappedInstance",
                        get: function get() {
                            // for testing
                            return this.ref.current && this.ref.current.wrapped.current;
                        }
                    }
                ]);
                return ReduxForm;
            }((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Component);
            (0, $eLE6M.polyfill)(ReduxForm);
            var WithContext = (0, (/*@__PURE__*/$parcel$interopDefault($1t1PC)))((0, $lyNli.withReduxForm)(ReduxForm), WrappedComponent);
            WithContext.defaultProps = config;
            return WithContext;
        };
    };
};
var $e3b071efa5f53406$export$2e2bcd8739ae039 = $e3b071efa5f53406$var$createReduxForm;

});
parcelRegister("3GtlK", function(module, exports) {

var $5BVtC = parcelRequire("5BVtC");

var $6ktZT = parcelRequire("6ktZT");

var $dpOau = parcelRequire("dpOau");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $2aec0f9e934fbaf6$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $dpOau(iteratee, 3);
    $6ktZT(object, function(value, key, object) {
        $5BVtC(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $2aec0f9e934fbaf6$var$mapValues;

});
parcelRegister("6ktZT", function(module, exports) {

var $en3ln = parcelRequire("en3ln");

var $196L7 = parcelRequire("196L7");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $49bbe125925337d9$var$baseForOwn(object, iteratee) {
    return object && $en3ln(object, iteratee, $196L7);
}
module.exports = $49bbe125925337d9$var$baseForOwn;

});


parcelRegister("9MfJv", function(module, exports) {
module.exports = $71e4ccf7b34da824$var$isPromise;
module.exports.default = $71e4ccf7b34da824$var$isPromise;
function $71e4ccf7b34da824$var$isPromise(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
}

});

parcelRegister("4Fgv6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3657ca6de989356d$export$2e2bcd8739ae039; });

var $9MfJv = parcelRequire("9MfJv");
var $3657ca6de989356d$var$asyncValidation = function asyncValidation(fn, start, stop, field) {
    start(field);
    var promise = fn();
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($9MfJv)))(promise)) throw new Error("asyncValidate function passed to reduxForm must return a promise");
    var handleErrors = function handleErrors(rejected) {
        return function(errors) {
            if (rejected) {
                if (errors && Object.keys(errors).length) {
                    stop(errors);
                    return errors;
                } else {
                    stop();
                    throw new Error("Asynchronous validation promise was rejected without errors.");
                }
            }
            stop();
            return Promise.resolve();
        };
    };
    return promise.then(handleErrors(false), handleErrors(true));
};
var $3657ca6de989356d$export$2e2bcd8739ae039 = $3657ca6de989356d$var$asyncValidation;

});

parcelRegister("cCWIW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $931695ffc14785d2$export$2e2bcd8739ae039; });
var $931695ffc14785d2$var$defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
    var initialized = _ref.initialized, trigger = _ref.trigger, pristine = _ref.pristine, syncValidationPasses = _ref.syncValidationPasses;
    if (!syncValidationPasses) return false;
    switch(trigger){
        case "blur":
        case "change":
            // blurring
            return true;
        case "submit":
            // submitting, so only async validate if form is dirty or was never initialized
            // conversely, DON'T async validate if the form is pristine just as it was initialized
            return !pristine || !initialized;
        default:
            return false;
    }
};
var $931695ffc14785d2$export$2e2bcd8739ae039 = $931695ffc14785d2$var$defaultShouldAsyncValidate;

});

parcelRegister("gSxRJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c49bf5817ed5700d$export$2e2bcd8739ae039; });
var $c49bf5817ed5700d$var$defaultShouldValidate = function defaultShouldValidate(_ref) {
    var values = _ref.values, nextProps = _ref.nextProps, initialRender = _ref.initialRender, lastFieldValidatorKeys = _ref.lastFieldValidatorKeys, fieldValidatorKeys = _ref.fieldValidatorKeys, structure = _ref.structure;
    if (initialRender) return true;
    return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};
var $c49bf5817ed5700d$export$2e2bcd8739ae039 = $c49bf5817ed5700d$var$defaultShouldValidate;

});

parcelRegister("iN2IY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dadeea9af2861929$export$2e2bcd8739ae039; });
var $dadeea9af2861929$var$defaultShouldError = function defaultShouldError(_ref) {
    var values = _ref.values, nextProps = _ref.nextProps, initialRender = _ref.initialRender, lastFieldValidatorKeys = _ref.lastFieldValidatorKeys, fieldValidatorKeys = _ref.fieldValidatorKeys, structure = _ref.structure;
    if (initialRender) return true;
    return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};
var $dadeea9af2861929$export$2e2bcd8739ae039 = $dadeea9af2861929$var$defaultShouldError;

});

parcelRegister("hXbCw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d120f5ef50693430$export$2e2bcd8739ae039; });
var $d120f5ef50693430$var$defaultShouldWarn = function defaultShouldWarn(_ref) {
    var values = _ref.values, nextProps = _ref.nextProps, initialRender = _ref.initialRender, lastFieldValidatorKeys = _ref.lastFieldValidatorKeys, fieldValidatorKeys = _ref.fieldValidatorKeys, structure = _ref.structure;
    if (initialRender) return true;
    return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};
var $d120f5ef50693430$export$2e2bcd8739ae039 = $d120f5ef50693430$var$defaultShouldWarn;

});

parcelRegister("hFyW0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdd15d4611eba35b$export$2e2bcd8739ae039; });

var $kYlkY = parcelRequire("kYlkY");
var $cdd15d4611eba35b$var$silenceEvent = function silenceEvent(event) {
    var is = (0, $kYlkY.default)(event);
    if (is) event.preventDefault();
    return is;
};
var $cdd15d4611eba35b$export$2e2bcd8739ae039 = $cdd15d4611eba35b$var$silenceEvent;

});

parcelRegister("1mO82", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0feebb0a7148369c$export$2e2bcd8739ae039; });

var $hFyW0 = parcelRequire("hFyW0");
var $0feebb0a7148369c$var$silenceEvents = function silenceEvents(fn) {
    return function(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return (0, $hFyW0.default)(event) ? fn.apply(void 0, args) : fn.apply(void 0, [
            event
        ].concat(args));
    };
};
var $0feebb0a7148369c$export$2e2bcd8739ae039 = $0feebb0a7148369c$var$silenceEvents;

});

parcelRegister("jQyfO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e72d71c6395859c1$export$2e2bcd8739ae039; });

var $hdOPR = parcelRequire("hdOPR");
var $e72d71c6395859c1$var$toArray = function toArray(value) {
    return Array.isArray(value) ? value : [
        value
    ];
};
var $e72d71c6395859c1$var$getError = function getError(value, values, props, validators, name) {
    var array = $e72d71c6395859c1$var$toArray(validators);
    for(var i = 0; i < array.length; i++){
        var error = array[i](value, values, props, name);
        if (error) return error;
    }
};
var $e72d71c6395859c1$var$generateValidator = function generateValidator(validators, _ref) {
    var getIn = _ref.getIn;
    return function(values, props) {
        var errors = {};
        Object.keys(validators).forEach(function(name) {
            var value = getIn(values, name);
            var error = $e72d71c6395859c1$var$getError(value, values, props, validators[name], name);
            if (error) errors = (0, $hdOPR.default).setIn(errors, name, error);
        });
        return errors;
    };
};
var $e72d71c6395859c1$export$2e2bcd8739ae039 = $e72d71c6395859c1$var$generateValidator;

});

parcelRegister("6FwlZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4dafab289c7db186$export$2e2bcd8739ae039; });

var $fPPqr = parcelRequire("fPPqr");

var $9MfJv = parcelRequire("9MfJv");

var $3nKfx = parcelRequire("3nKfx");
var $4dafab289c7db186$var$isSubmissionError = function isSubmissionError(error) {
    return error && error.name === (0, $3nKfx.default).name;
};
var $4dafab289c7db186$var$mergeErrors = function mergeErrors(_ref) {
    var asyncErrors = _ref.asyncErrors, syncErrors = _ref.syncErrors;
    return asyncErrors && typeof asyncErrors.merge === "function" ? asyncErrors.merge(syncErrors).toJS() : (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, asyncErrors, syncErrors);
};
var $4dafab289c7db186$var$isImmutableList;

try {
    // ImmutableJS isList implementation if available
    // eslint-disable-next-line import/no-extraneous-dependencies
    var $4dafab289c7db186$var$_require = (parcelRequire("ikeiT")), $4dafab289c7db186$var$List = $4dafab289c7db186$var$_require.List;
    $4dafab289c7db186$var$isImmutableList = $4dafab289c7db186$var$List.isList;
} catch (err) {
    $4dafab289c7db186$var$isImmutableList = function isImmutableList(maybeList) {
        return false;
    };
} // fields may be an Immutable List which cannot be spread
// convert the fields to an array if necessary
var $4dafab289c7db186$var$makeFieldsArray = function makeFieldsArray(fields) {
    return $4dafab289c7db186$var$isImmutableList(fields) ? fields.toArray() : fields;
};
var $4dafab289c7db186$var$executeSubmit = function executeSubmit(submit, fields, props) {
    var dispatch = props.dispatch, submitAsSideEffect = props.submitAsSideEffect, onSubmitFail = props.onSubmitFail, onSubmitSuccess = props.onSubmitSuccess, startSubmit = props.startSubmit, stopSubmit = props.stopSubmit, setSubmitFailed = props.setSubmitFailed, setSubmitSucceeded = props.setSubmitSucceeded, values = props.values;
    fields = $4dafab289c7db186$var$makeFieldsArray(fields);
    var result;
    try {
        result = submit(values, dispatch, props);
    } catch (submitError) {
        var error = $4dafab289c7db186$var$isSubmissionError(submitError) ? submitError.errors : undefined;
        stopSubmit(error);
        setSubmitFailed.apply(void 0, fields);
        if (onSubmitFail) onSubmitFail(error, dispatch, submitError, props);
        if (error || onSubmitFail) // if you've provided an onSubmitFail callback, don't re-throw the error
        return error;
        else throw submitError;
    }
    if (submitAsSideEffect) {
        if (result) dispatch(result);
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($9MfJv)))(result)) {
        startSubmit();
        return result.then(function(submitResult) {
            stopSubmit();
            setSubmitSucceeded();
            if (onSubmitSuccess) onSubmitSuccess(submitResult, dispatch, props);
            return submitResult;
        }, function(submitError) {
            var error = $4dafab289c7db186$var$isSubmissionError(submitError) ? submitError.errors : undefined;
            stopSubmit(error);
            setSubmitFailed.apply(void 0, fields);
            if (onSubmitFail) onSubmitFail(error, dispatch, submitError, props);
            if (error || onSubmitFail) // if you've provided an onSubmitFail callback, don't re-throw the error
            return error;
            else throw submitError;
        });
    } else {
        setSubmitSucceeded();
        if (onSubmitSuccess) onSubmitSuccess(result, dispatch, props);
    }
    return result;
};
var $4dafab289c7db186$var$handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
    var dispatch = props.dispatch, onSubmitFail = props.onSubmitFail, setSubmitFailed = props.setSubmitFailed, syncErrors = props.syncErrors, asyncErrors = props.asyncErrors, touch = props.touch, persistentSubmitErrors = props.persistentSubmitErrors;
    fields = $4dafab289c7db186$var$makeFieldsArray(fields);
    touch.apply(void 0, fields); // mark all fields as touched
    if (valid || persistentSubmitErrors) {
        var asyncValidateResult = asyncValidate && asyncValidate();
        if (asyncValidateResult) return asyncValidateResult.then(function(asyncErrors) {
            if (asyncErrors) throw asyncErrors;
            return $4dafab289c7db186$var$executeSubmit(submit, fields, props);
        })["catch"](function(asyncErrors) {
            setSubmitFailed.apply(void 0, fields);
            if (onSubmitFail) onSubmitFail(asyncErrors, dispatch, null, props);
            return Promise.reject(asyncErrors);
        });
        else return $4dafab289c7db186$var$executeSubmit(submit, fields, props);
    } else {
        setSubmitFailed.apply(void 0, fields);
        var errors = $4dafab289c7db186$var$mergeErrors({
            asyncErrors: asyncErrors,
            syncErrors: syncErrors
        });
        if (onSubmitFail) onSubmitFail(errors, dispatch, null, props);
        return errors;
    }
};
var $4dafab289c7db186$export$2e2bcd8739ae039 = $4dafab289c7db186$var$handleSubmit;

});
parcelRegister("3nKfx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27676544235592e3$export$2e2bcd8739ae039; });

var $2mGxr = parcelRequire("2mGxr");

var $kEI6F = parcelRequire("kEI6F");
var $27676544235592e3$var$SubmissionError = /*#__PURE__*/ function(_ExtendableError) {
    (0, (/*@__PURE__*/$parcel$interopDefault($2mGxr)))(SubmissionError, _ExtendableError);
    function SubmissionError(errors) {
        var _this;
        _this = _ExtendableError.call(this, "Submit Validation Failed") || this;
        _this.errors = errors;
        return _this;
    }
    return SubmissionError;
}((0, $kEI6F.default));
var $27676544235592e3$export$2e2bcd8739ae039 = $27676544235592e3$var$SubmissionError;

});
parcelRegister("kEI6F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f099c1b883e0a9a4$export$2e2bcd8739ae039; });
function $f099c1b883e0a9a4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f099c1b883e0a9a4$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $f099c1b883e0a9a4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $f099c1b883e0a9a4$var$_extendableBuiltin(cls) {
    function ExtendableBuiltin() {
        cls.apply(this, arguments);
    }
    ExtendableBuiltin.prototype = Object.create(cls.prototype, {
        constructor: {
            value: cls,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (Object.setPrototypeOf) Object.setPrototypeOf(ExtendableBuiltin, cls);
    else ExtendableBuiltin.__proto__ = cls;
    return ExtendableBuiltin;
}
var $f099c1b883e0a9a4$var$ExtendableError = function(_extendableBuiltin2) {
    $f099c1b883e0a9a4$var$_inherits(ExtendableError, _extendableBuiltin2);
    function ExtendableError() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        $f099c1b883e0a9a4$var$_classCallCheck(this, ExtendableError);
        // extending Error is weird and does not propagate `message`
        var _this = $f099c1b883e0a9a4$var$_possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));
        Object.defineProperty(_this, "message", {
            configurable: true,
            enumerable: false,
            value: message,
            writable: true
        });
        Object.defineProperty(_this, "name", {
            configurable: true,
            enumerable: false,
            value: _this.constructor.name,
            writable: true
        });
        if (Error.hasOwnProperty("captureStackTrace")) {
            Error.captureStackTrace(_this, _this.constructor);
            return $f099c1b883e0a9a4$var$_possibleConstructorReturn(_this);
        }
        Object.defineProperty(_this, "stack", {
            configurable: true,
            enumerable: false,
            value: new Error(message).stack,
            writable: true
        });
        return _this;
    }
    return ExtendableError;
}($f099c1b883e0a9a4$var$_extendableBuiltin(Error));
var $f099c1b883e0a9a4$export$2e2bcd8739ae039 = $f099c1b883e0a9a4$var$ExtendableError;

});


parcelRegister("ikeiT", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    var SLICE$0 = Array.prototype.slice;
    function createClass(ctor, superClass) {
        if (superClass) ctor.prototype = Object.create(superClass.prototype);
        ctor.prototype.constructor = ctor;
    }
    function Iterable(value) {
        return isIterable(value) ? value : Seq(value);
    }
    createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
        return isKeyed(value) ? value : KeyedSeq(value);
    }
    createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
        return isIndexed(value) ? value : IndexedSeq(value);
    }
    createClass(SetIterable, Iterable);
    function SetIterable(value) {
        return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }
    function isIterable(maybeIterable) {
        return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
    }
    function isKeyed(maybeKeyed) {
        return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
    }
    function isIndexed(maybeIndexed) {
        return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
    }
    function isAssociative(maybeAssociative) {
        return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
    }
    function isOrdered(maybeOrdered) {
        return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
    }
    Iterable.isIterable = isIterable;
    Iterable.isKeyed = isKeyed;
    Iterable.isIndexed = isIndexed;
    Iterable.isAssociative = isAssociative;
    Iterable.isOrdered = isOrdered;
    Iterable.Keyed = KeyedIterable;
    Iterable.Indexed = IndexedIterable;
    Iterable.Set = SetIterable;
    var IS_ITERABLE_SENTINEL = "@@__IMMUTABLE_ITERABLE__@@";
    var IS_KEYED_SENTINEL = "@@__IMMUTABLE_KEYED__@@";
    var IS_INDEXED_SENTINEL = "@@__IMMUTABLE_INDEXED__@@";
    var IS_ORDERED_SENTINEL = "@@__IMMUTABLE_ORDERED__@@";
    // Used for setting prototype methods that IE8 chokes on.
    var DELETE = "delete";
    // Constants describing the size of trie nodes.
    var SHIFT = 5; // Resulted in best performance after ______?
    var SIZE = 1 << SHIFT;
    var MASK = SIZE - 1;
    // A consistent shared value representing "not set" which equals nothing other
    // than itself, and nothing that could be provided externally.
    var NOT_SET = {};
    // Boolean references, Rough equivalent of `bool &`.
    var CHANGE_LENGTH = {
        value: false
    };
    var DID_ALTER = {
        value: false
    };
    function MakeRef(ref) {
        ref.value = false;
        return ref;
    }
    function SetRef(ref) {
        ref && (ref.value = true);
    }
    // A function which returns a value representing an "owner" for transient writes
    // to tries. The return value will only ever equal itself, and will not equal
    // the return of any subsequent call of this function.
    function OwnerID() {}
    // http://jsperf.com/copy-array-inline
    function arrCopy(arr, offset) {
        offset = offset || 0;
        var len = Math.max(0, arr.length - offset);
        var newArr = new Array(len);
        for(var ii = 0; ii < len; ii++)newArr[ii] = arr[ii + offset];
        return newArr;
    }
    function ensureSize(iter) {
        if (iter.size === undefined) iter.size = iter.__iterate(returnTrue);
        return iter.size;
    }
    function wrapIndex(iter, index) {
        // This implements "is array index" which the ECMAString spec defines as:
        //
        //     A String property name P is an array index if and only if
        //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
        //     to 2^32−1.
        //
        // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
        if (typeof index !== "number") {
            var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
            if ("" + uint32Index !== index || uint32Index === 4294967295) return NaN;
            index = uint32Index;
        }
        return index < 0 ? ensureSize(iter) + index : index;
    }
    function returnTrue() {
        return true;
    }
    function wholeSlice(begin, end, size) {
        return (begin === 0 || size !== undefined && begin <= -size) && (end === undefined || size !== undefined && end >= size);
    }
    function resolveBegin(begin, size) {
        return resolveIndex(begin, size, 0);
    }
    function resolveEnd(end, size) {
        return resolveIndex(end, size, size);
    }
    function resolveIndex(index, size, defaultIndex) {
        return index === undefined ? defaultIndex : index < 0 ? Math.max(0, size + index) : size === undefined ? index : Math.min(size, index);
    }
    /* global Symbol */ var ITERATE_KEYS = 0;
    var ITERATE_VALUES = 1;
    var ITERATE_ENTRIES = 2;
    var REAL_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
    function Iterator(next) {
        this.next = next;
    }
    Iterator.prototype.toString = function() {
        return "[Iterator]";
    };
    Iterator.KEYS = ITERATE_KEYS;
    Iterator.VALUES = ITERATE_VALUES;
    Iterator.ENTRIES = ITERATE_ENTRIES;
    Iterator.prototype.inspect = Iterator.prototype.toSource = function() {
        return this.toString();
    };
    Iterator.prototype[ITERATOR_SYMBOL] = function() {
        return this;
    };
    function iteratorValue(type, k, v, iteratorResult) {
        var value = type === 0 ? k : type === 1 ? v : [
            k,
            v
        ];
        iteratorResult ? iteratorResult.value = value : iteratorResult = {
            value: value,
            done: false
        };
        return iteratorResult;
    }
    function iteratorDone() {
        return {
            value: undefined,
            done: true
        };
    }
    function hasIterator(maybeIterable) {
        return !!getIteratorFn(maybeIterable);
    }
    function isIterator(maybeIterator) {
        return maybeIterator && typeof maybeIterator.next === "function";
    }
    function getIterator(iterable) {
        var iteratorFn = getIteratorFn(iterable);
        return iteratorFn && iteratorFn.call(iterable);
    }
    function getIteratorFn(iterable) {
        var iteratorFn = iterable && (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || iterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") return iteratorFn;
    }
    function isArrayLike(value) {
        return value && typeof value.length === "number";
    }
    createClass(Seq, Iterable);
    function Seq(value) {
        return value === null || value === undefined ? emptySequence() : isIterable(value) ? value.toSeq() : seqFromValue(value);
    }
    Seq.of = function() {
        return Seq(arguments);
    };
    Seq.prototype.toSeq = function() {
        return this;
    };
    Seq.prototype.toString = function() {
        return this.__toString("Seq {", "}");
    };
    Seq.prototype.cacheResult = function() {
        if (!this._cache && this.__iterateUncached) {
            this._cache = this.entrySeq().toArray();
            this.size = this._cache.length;
        }
        return this;
    };
    // abstract __iterateUncached(fn, reverse)
    Seq.prototype.__iterate = function(fn, reverse) {
        return seqIterate(this, fn, reverse, true);
    };
    // abstract __iteratorUncached(type, reverse)
    Seq.prototype.__iterator = function(type, reverse) {
        return seqIterator(this, type, reverse, true);
    };
    createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
        return value === null || value === undefined ? emptySequence().toKeyedSeq() : isIterable(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : keyedSeqFromValue(value);
    }
    KeyedSeq.prototype.toKeyedSeq = function() {
        return this;
    };
    createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
        return value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }
    IndexedSeq.of = function() {
        return IndexedSeq(arguments);
    };
    IndexedSeq.prototype.toIndexedSeq = function() {
        return this;
    };
    IndexedSeq.prototype.toString = function() {
        return this.__toString("Seq [", "]");
    };
    IndexedSeq.prototype.__iterate = function(fn, reverse) {
        return seqIterate(this, fn, reverse, false);
    };
    IndexedSeq.prototype.__iterator = function(type, reverse) {
        return seqIterator(this, type, reverse, false);
    };
    createClass(SetSeq, Seq);
    function SetSeq(value) {
        return (value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value).toSetSeq();
    }
    SetSeq.of = function() {
        return SetSeq(arguments);
    };
    SetSeq.prototype.toSetSeq = function() {
        return this;
    };
    Seq.isSeq = isSeq;
    Seq.Keyed = KeyedSeq;
    Seq.Set = SetSeq;
    Seq.Indexed = IndexedSeq;
    var IS_SEQ_SENTINEL = "@@__IMMUTABLE_SEQ__@@";
    Seq.prototype[IS_SEQ_SENTINEL] = true;
    createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
        this._array = array;
        this.size = array.length;
    }
    ArraySeq.prototype.get = function(index, notSetValue) {
        return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };
    ArraySeq.prototype.__iterate = function(fn, reverse) {
        var array = this._array;
        var maxIndex = array.length - 1;
        for(var ii = 0; ii <= maxIndex; ii++){
            if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) return ii + 1;
        }
        return ii;
    };
    ArraySeq.prototype.__iterator = function(type, reverse) {
        var array = this._array;
        var maxIndex = array.length - 1;
        var ii = 0;
        return new Iterator(function() {
            return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++]);
        });
    };
    createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
        var keys = Object.keys(object);
        this._object = object;
        this._keys = keys;
        this.size = keys.length;
    }
    ObjectSeq.prototype.get = function(key, notSetValue) {
        if (notSetValue !== undefined && !this.has(key)) return notSetValue;
        return this._object[key];
    };
    ObjectSeq.prototype.has = function(key) {
        return this._object.hasOwnProperty(key);
    };
    ObjectSeq.prototype.__iterate = function(fn, reverse) {
        var object = this._object;
        var keys = this._keys;
        var maxIndex = keys.length - 1;
        for(var ii = 0; ii <= maxIndex; ii++){
            var key = keys[reverse ? maxIndex - ii : ii];
            if (fn(object[key], key, this) === false) return ii + 1;
        }
        return ii;
    };
    ObjectSeq.prototype.__iterator = function(type, reverse) {
        var object = this._object;
        var keys = this._keys;
        var maxIndex = keys.length - 1;
        var ii = 0;
        return new Iterator(function() {
            var key = keys[reverse ? maxIndex - ii : ii];
            return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, key, object[key]);
        });
    };
    ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
    createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
        this._iterable = iterable;
        this.size = iterable.length || iterable.size;
    }
    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterable = this._iterable;
        var iterator = getIterator(iterable);
        var iterations = 0;
        if (isIterator(iterator)) {
            var step;
            while(!(step = iterator.next()).done){
                if (fn(step.value, iterations++, this) === false) break;
            }
        }
        return iterations;
    };
    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterable = this._iterable;
        var iterator = getIterator(iterable);
        if (!isIterator(iterator)) return new Iterator(iteratorDone);
        var iterations = 0;
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, iterations++, step.value);
        });
    };
    createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
        this._iterator = iterator;
        this._iteratorCache = [];
    }
    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterator = this._iterator;
        var cache = this._iteratorCache;
        var iterations = 0;
        while(iterations < cache.length){
            if (fn(cache[iterations], iterations++, this) === false) return iterations;
        }
        var step;
        while(!(step = iterator.next()).done){
            var val = step.value;
            cache[iterations] = val;
            if (fn(val, iterations++, this) === false) break;
        }
        return iterations;
    };
    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = this._iterator;
        var cache = this._iteratorCache;
        var iterations = 0;
        return new Iterator(function() {
            if (iterations >= cache.length) {
                var step = iterator.next();
                if (step.done) return step;
                cache[iterations] = step.value;
            }
            return iteratorValue(type, iterations, cache[iterations++]);
        });
    };
    // # pragma Helper functions
    function isSeq(maybeSeq) {
        return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
    }
    var EMPTY_SEQ;
    function emptySequence() {
        return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
    }
    function keyedSeqFromValue(value) {
        var seq = Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() : isIterator(value) ? new IteratorSeq(value).fromEntrySeq() : hasIterator(value) ? new IterableSeq(value).fromEntrySeq() : typeof value === "object" ? new ObjectSeq(value) : undefined;
        if (!seq) throw new TypeError("Expected Array or iterable object of [k, v] entries, or keyed object: " + value);
        return seq;
    }
    function indexedSeqFromValue(value) {
        var seq = maybeIndexedSeqFromValue(value);
        if (!seq) throw new TypeError("Expected Array or iterable object of values: " + value);
        return seq;
    }
    function seqFromValue(value) {
        var seq = maybeIndexedSeqFromValue(value) || typeof value === "object" && new ObjectSeq(value);
        if (!seq) throw new TypeError("Expected Array or iterable object of values, or keyed object: " + value);
        return seq;
    }
    function maybeIndexedSeqFromValue(value) {
        return isArrayLike(value) ? new ArraySeq(value) : isIterator(value) ? new IteratorSeq(value) : hasIterator(value) ? new IterableSeq(value) : undefined;
    }
    function seqIterate(seq, fn, reverse, useKeys) {
        var cache = seq._cache;
        if (cache) {
            var maxIndex = cache.length - 1;
            for(var ii = 0; ii <= maxIndex; ii++){
                var entry = cache[reverse ? maxIndex - ii : ii];
                if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) return ii + 1;
            }
            return ii;
        }
        return seq.__iterateUncached(fn, reverse);
    }
    function seqIterator(seq, type, reverse, useKeys) {
        var cache = seq._cache;
        if (cache) {
            var maxIndex = cache.length - 1;
            var ii = 0;
            return new Iterator(function() {
                var entry = cache[reverse ? maxIndex - ii : ii];
                return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
            });
        }
        return seq.__iteratorUncached(type, reverse);
    }
    function fromJS(json, converter) {
        return converter ? fromJSWith(converter, json, "", {
            "": json
        }) : fromJSDefault(json);
    }
    function fromJSWith(converter, json, key, parentJSON) {
        if (Array.isArray(json)) return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k) {
            return fromJSWith(converter, v, k, json);
        }));
        if (isPlainObj(json)) return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k) {
            return fromJSWith(converter, v, k, json);
        }));
        return json;
    }
    function fromJSDefault(json) {
        if (Array.isArray(json)) return IndexedSeq(json).map(fromJSDefault).toList();
        if (isPlainObj(json)) return KeyedSeq(json).map(fromJSDefault).toMap();
        return json;
    }
    function isPlainObj(value) {
        return value && (value.constructor === Object || value.constructor === undefined);
    }
    /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */ function is(valueA, valueB) {
        if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
        if (!valueA || !valueB) return false;
        if (typeof valueA.valueOf === "function" && typeof valueB.valueOf === "function") {
            valueA = valueA.valueOf();
            valueB = valueB.valueOf();
            if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
            if (!valueA || !valueB) return false;
        }
        if (typeof valueA.equals === "function" && typeof valueB.equals === "function" && valueA.equals(valueB)) return true;
        return false;
    }
    function deepEqual(a, b) {
        if (a === b) return true;
        if (!isIterable(b) || a.size !== undefined && b.size !== undefined && a.size !== b.size || a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || isOrdered(a) !== isOrdered(b)) return false;
        if (a.size === 0 && b.size === 0) return true;
        var notAssociative = !isAssociative(a);
        if (isOrdered(a)) {
            var entries = a.entries();
            return b.every(function(v, k) {
                var entry = entries.next().value;
                return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
            }) && entries.next().done;
        }
        var flipped = false;
        if (a.size === undefined) {
            if (b.size === undefined) {
                if (typeof a.cacheResult === "function") a.cacheResult();
            } else {
                flipped = true;
                var _ = a;
                a = b;
                b = _;
            }
        }
        var allEqual = true;
        var bSize = b.__iterate(function(v, k) {
            if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
                allEqual = false;
                return false;
            }
        });
        return allEqual && a.size === bSize;
    }
    createClass(Repeat, IndexedSeq);
    function Repeat(value, times) {
        if (!(this instanceof Repeat)) return new Repeat(value, times);
        this._value = value;
        this.size = times === undefined ? Infinity : Math.max(0, times);
        if (this.size === 0) {
            if (EMPTY_REPEAT) return EMPTY_REPEAT;
            EMPTY_REPEAT = this;
        }
    }
    Repeat.prototype.toString = function() {
        if (this.size === 0) return "Repeat []";
        return "Repeat [ " + this._value + " " + this.size + " times ]";
    };
    Repeat.prototype.get = function(index, notSetValue) {
        return this.has(index) ? this._value : notSetValue;
    };
    Repeat.prototype.includes = function(searchValue) {
        return is(this._value, searchValue);
    };
    Repeat.prototype.slice = function(begin, end) {
        var size = this.size;
        return wholeSlice(begin, end, size) ? this : new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };
    Repeat.prototype.reverse = function() {
        return this;
    };
    Repeat.prototype.indexOf = function(searchValue) {
        if (is(this._value, searchValue)) return 0;
        return -1;
    };
    Repeat.prototype.lastIndexOf = function(searchValue) {
        if (is(this._value, searchValue)) return this.size;
        return -1;
    };
    Repeat.prototype.__iterate = function(fn, reverse) {
        for(var ii = 0; ii < this.size; ii++){
            if (fn(this._value, ii, this) === false) return ii + 1;
        }
        return ii;
    };
    Repeat.prototype.__iterator = function(type, reverse) {
        var this$0 = this;
        var ii = 0;
        return new Iterator(function() {
            return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone();
        });
    };
    Repeat.prototype.equals = function(other) {
        return other instanceof Repeat ? is(this._value, other._value) : deepEqual(other);
    };
    var EMPTY_REPEAT;
    function invariant(condition, error) {
        if (!condition) throw new Error(error);
    }
    createClass(Range, IndexedSeq);
    function Range(start, end, step) {
        if (!(this instanceof Range)) return new Range(start, end, step);
        invariant(step !== 0, "Cannot step a Range by 0");
        start = start || 0;
        if (end === undefined) end = Infinity;
        step = step === undefined ? 1 : Math.abs(step);
        if (end < start) step = -step;
        this._start = start;
        this._end = end;
        this._step = step;
        this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
        if (this.size === 0) {
            if (EMPTY_RANGE) return EMPTY_RANGE;
            EMPTY_RANGE = this;
        }
    }
    Range.prototype.toString = function() {
        if (this.size === 0) return "Range []";
        return "Range [ " + this._start + "..." + this._end + (this._step !== 1 ? " by " + this._step : "") + " ]";
    };
    Range.prototype.get = function(index, notSetValue) {
        return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
    };
    Range.prototype.includes = function(searchValue) {
        var possibleIndex = (searchValue - this._start) / this._step;
        return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
    };
    Range.prototype.slice = function(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        begin = resolveBegin(begin, this.size);
        end = resolveEnd(end, this.size);
        if (end <= begin) return new Range(0, 0);
        return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };
    Range.prototype.indexOf = function(searchValue) {
        var offsetValue = searchValue - this._start;
        if (offsetValue % this._step === 0) {
            var index = offsetValue / this._step;
            if (index >= 0 && index < this.size) return index;
        }
        return -1;
    };
    Range.prototype.lastIndexOf = function(searchValue) {
        return this.indexOf(searchValue);
    };
    Range.prototype.__iterate = function(fn, reverse) {
        var maxIndex = this.size - 1;
        var step = this._step;
        var value = reverse ? this._start + maxIndex * step : this._start;
        for(var ii = 0; ii <= maxIndex; ii++){
            if (fn(value, ii, this) === false) return ii + 1;
            value += reverse ? -step : step;
        }
        return ii;
    };
    Range.prototype.__iterator = function(type, reverse) {
        var maxIndex = this.size - 1;
        var step = this._step;
        var value = reverse ? this._start + maxIndex * step : this._start;
        var ii = 0;
        return new Iterator(function() {
            var v = value;
            value += reverse ? -step : step;
            return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
        });
    };
    Range.prototype.equals = function(other) {
        return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual(this, other);
    };
    var EMPTY_RANGE;
    createClass(Collection, Iterable);
    function Collection() {
        throw TypeError("Abstract");
    }
    createClass(KeyedCollection, Collection);
    function KeyedCollection() {}
    createClass(IndexedCollection, Collection);
    function IndexedCollection() {}
    createClass(SetCollection, Collection);
    function SetCollection() {}
    Collection.Keyed = KeyedCollection;
    Collection.Indexed = IndexedCollection;
    Collection.Set = SetCollection;
    var imul = typeof Math.imul === "function" && Math.imul(0xffffffff, 2) === -2 ? Math.imul : function imul(a, b) {
        a = a | 0; // int
        b = b | 0; // int
        var c = a & 0xffff;
        var d = b & 0xffff;
        // Shift by 0 fixes the sign on the high part.
        return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0; // int
    };
    // v8 has an optimization for storing 31-bit signed numbers.
    // Values which have either 00 or 11 as the high order bits qualify.
    // This function drops the highest order bit in a signed number, maintaining
    // the sign bit.
    function smi(i32) {
        return i32 >>> 1 & 0x40000000 | i32 & 0xBFFFFFFF;
    }
    function hash(o) {
        if (o === false || o === null || o === undefined) return 0;
        if (typeof o.valueOf === "function") {
            o = o.valueOf();
            if (o === false || o === null || o === undefined) return 0;
        }
        if (o === true) return 1;
        var type = typeof o;
        if (type === "number") {
            if (o !== o || o === Infinity) return 0;
            var h = o | 0;
            if (h !== o) h ^= o * 0xFFFFFFFF;
            while(o > 0xFFFFFFFF){
                o /= 0xFFFFFFFF;
                h ^= o;
            }
            return smi(h);
        }
        if (type === "string") return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
        if (typeof o.hashCode === "function") return o.hashCode();
        if (type === "object") return hashJSObj(o);
        if (typeof o.toString === "function") return hashString(o.toString());
        throw new Error("Value type " + type + " cannot be hashed.");
    }
    function cachedHashString(string) {
        var hash = stringHashCache[string];
        if (hash === undefined) {
            hash = hashString(string);
            if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
                STRING_HASH_CACHE_SIZE = 0;
                stringHashCache = {};
            }
            STRING_HASH_CACHE_SIZE++;
            stringHashCache[string] = hash;
        }
        return hash;
    }
    // http://jsperf.com/hashing-strings
    function hashString(string) {
        // This is the hash from JVM
        // The hash code for a string is computed as
        // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
        // where s[i] is the ith character of the string and n is the length of
        // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
        // (exclusive) by dropping high bits.
        var hash = 0;
        for(var ii = 0; ii < string.length; ii++)hash = 31 * hash + string.charCodeAt(ii) | 0;
        return smi(hash);
    }
    function hashJSObj(obj) {
        var hash;
        if (usingWeakMap) {
            hash = weakMap.get(obj);
            if (hash !== undefined) return hash;
        }
        hash = obj[UID_HASH_KEY];
        if (hash !== undefined) return hash;
        if (!canDefineProperty) {
            hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
            if (hash !== undefined) return hash;
            hash = getIENodeHash(obj);
            if (hash !== undefined) return hash;
        }
        hash = ++objHashUID;
        if (objHashUID & 0x40000000) objHashUID = 0;
        if (usingWeakMap) weakMap.set(obj, hash);
        else if (isExtensible !== undefined && isExtensible(obj) === false) throw new Error("Non-extensible objects are not allowed as keys.");
        else if (canDefineProperty) Object.defineProperty(obj, UID_HASH_KEY, {
            "enumerable": false,
            "configurable": false,
            "writable": false,
            "value": hash
        });
        else if (obj.propertyIsEnumerable !== undefined && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
            // Since we can't define a non-enumerable property on the object
            // we'll hijack one of the less-used non-enumerable properties to
            // save our hash on it. Since this is a function it will not show up in
            // `JSON.stringify` which is what we want.
            obj.propertyIsEnumerable = function() {
                return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
            };
            obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
        } else if (obj.nodeType !== undefined) // At this point we couldn't get the IE `uniqueID` to use as a hash
        // and we couldn't use a non-enumerable property to exploit the
        // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
        // itself.
        obj[UID_HASH_KEY] = hash;
        else throw new Error("Unable to set a non-enumerable property on object.");
        return hash;
    }
    // Get references to ES5 object methods.
    var isExtensible = Object.isExtensible;
    // True if Object.defineProperty works as expected. IE8 fails this test.
    var canDefineProperty = function() {
        try {
            Object.defineProperty({}, "@", {});
            return true;
        } catch (e) {
            return false;
        }
    }();
    // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
    // and avoid memory leaks from the IE cloneNode bug.
    function getIENodeHash(node) {
        if (node && node.nodeType > 0) switch(node.nodeType){
            case 1:
                return node.uniqueID;
            case 9:
                return node.documentElement && node.documentElement.uniqueID;
        }
    }
    // If possible, use a WeakMap.
    var usingWeakMap = typeof WeakMap === "function";
    var weakMap;
    if (usingWeakMap) weakMap = new WeakMap();
    var objHashUID = 0;
    var UID_HASH_KEY = "__immutablehash__";
    if (typeof Symbol === "function") UID_HASH_KEY = Symbol(UID_HASH_KEY);
    var STRING_HASH_CACHE_MIN_STRLEN = 16;
    var STRING_HASH_CACHE_MAX_SIZE = 255;
    var STRING_HASH_CACHE_SIZE = 0;
    var stringHashCache = {};
    function assertNotInfinite(size) {
        invariant(size !== Infinity, "Cannot perform this action with an infinite size.");
    }
    createClass(Map, KeyedCollection);
    // @pragma Construction
    function Map(value) {
        return value === null || value === undefined ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function(map) {
            var iter = KeyedIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    Map.of = function() {
        var keyValues = SLICE$0.call(arguments, 0);
        return emptyMap().withMutations(function(map) {
            for(var i = 0; i < keyValues.length; i += 2){
                if (i + 1 >= keyValues.length) throw new Error("Missing value for key: " + keyValues[i]);
                map.set(keyValues[i], keyValues[i + 1]);
            }
        });
    };
    Map.prototype.toString = function() {
        return this.__toString("Map {", "}");
    };
    // @pragma Access
    Map.prototype.get = function(k, notSetValue) {
        return this._root ? this._root.get(0, undefined, k, notSetValue) : notSetValue;
    };
    // @pragma Modification
    Map.prototype.set = function(k, v) {
        return updateMap(this, k, v);
    };
    Map.prototype.setIn = function(keyPath, v) {
        return this.updateIn(keyPath, NOT_SET, function() {
            return v;
        });
    };
    Map.prototype.remove = function(k) {
        return updateMap(this, k, NOT_SET);
    };
    Map.prototype.deleteIn = function(keyPath) {
        return this.updateIn(keyPath, function() {
            return NOT_SET;
        });
    };
    Map.prototype.update = function(k, notSetValue, updater) {
        return arguments.length === 1 ? k(this) : this.updateIn([
            k
        ], notSetValue, updater);
    };
    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
        if (!updater) {
            updater = notSetValue;
            notSetValue = undefined;
        }
        var updatedValue = updateInDeepMap(this, forceIterator(keyPath), notSetValue, updater);
        return updatedValue === NOT_SET ? undefined : updatedValue;
    };
    Map.prototype.clear = function() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._root = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyMap();
    };
    // @pragma Composition
    Map.prototype.merge = function() {
        return mergeIntoMapWith(this, undefined, arguments);
    };
    Map.prototype.mergeWith = function(merger) {
        var iters = SLICE$0.call(arguments, 1);
        return mergeIntoMapWith(this, merger, iters);
    };
    Map.prototype.mergeIn = function(keyPath) {
        var iters = SLICE$0.call(arguments, 1);
        return this.updateIn(keyPath, emptyMap(), function(m) {
            return typeof m.merge === "function" ? m.merge.apply(m, iters) : iters[iters.length - 1];
        });
    };
    Map.prototype.mergeDeep = function() {
        return mergeIntoMapWith(this, deepMerger, arguments);
    };
    Map.prototype.mergeDeepWith = function(merger) {
        var iters = SLICE$0.call(arguments, 1);
        return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };
    Map.prototype.mergeDeepIn = function(keyPath) {
        var iters = SLICE$0.call(arguments, 1);
        return this.updateIn(keyPath, emptyMap(), function(m) {
            return typeof m.mergeDeep === "function" ? m.mergeDeep.apply(m, iters) : iters[iters.length - 1];
        });
    };
    Map.prototype.sort = function(comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator));
    };
    Map.prototype.sortBy = function(mapper, comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator, mapper));
    };
    // @pragma Mutability
    Map.prototype.withMutations = function(fn) {
        var mutable = this.asMutable();
        fn(mutable);
        return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };
    Map.prototype.asMutable = function() {
        return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };
    Map.prototype.asImmutable = function() {
        return this.__ensureOwner();
    };
    Map.prototype.wasAltered = function() {
        return this.__altered;
    };
    Map.prototype.__iterator = function(type, reverse) {
        return new MapIterator(this, type, reverse);
    };
    Map.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        var iterations = 0;
        this._root && this._root.iterate(function(entry) {
            iterations++;
            return fn(entry[1], entry[0], this$0);
        }, reverse);
        return iterations;
    };
    Map.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeMap(this.size, this._root, ownerID, this.__hash);
    };
    function isMap(maybeMap) {
        return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
    }
    Map.isMap = isMap;
    var IS_MAP_SENTINEL = "@@__IMMUTABLE_MAP__@@";
    var MapPrototype = Map.prototype;
    MapPrototype[IS_MAP_SENTINEL] = true;
    MapPrototype[DELETE] = MapPrototype.remove;
    MapPrototype.removeIn = MapPrototype.deleteIn;
    // #pragma Trie Nodes
    function ArrayMapNode(ownerID, entries) {
        this.ownerID = ownerID;
        this.entries = entries;
    }
    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
        var entries = this.entries;
        for(var ii = 0, len = entries.length; ii < len; ii++){
            if (is(key, entries[ii][0])) return entries[ii][1];
        }
        return notSetValue;
    };
    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        var removed = value === NOT_SET;
        var entries = this.entries;
        var idx = 0;
        for(var len = entries.length; idx < len; idx++){
            if (is(key, entries[idx][0])) break;
        }
        var exists = idx < len;
        if (exists ? entries[idx][1] === value : removed) return this;
        SetRef(didAlter);
        (removed || !exists) && SetRef(didChangeSize);
        if (removed && entries.length === 1) return; // undefined
        if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) return createNodes(ownerID, entries, key, value);
        var isEditable = ownerID && ownerID === this.ownerID;
        var newEntries = isEditable ? entries : arrCopy(entries);
        if (exists) {
            if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
            else newEntries[idx] = [
                key,
                value
            ];
        } else newEntries.push([
            key,
            value
        ]);
        if (isEditable) {
            this.entries = newEntries;
            return this;
        }
        return new ArrayMapNode(ownerID, newEntries);
    };
    function BitmapIndexedNode(ownerID, bitmap, nodes) {
        this.ownerID = ownerID;
        this.bitmap = bitmap;
        this.nodes = nodes;
    }
    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
        if (keyHash === undefined) keyHash = hash(key);
        var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
        var bitmap = this.bitmap;
        return (bitmap & bit) === 0 ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
    };
    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        if (keyHash === undefined) keyHash = hash(key);
        var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
        var bit = 1 << keyHashFrag;
        var bitmap = this.bitmap;
        var exists = (bitmap & bit) !== 0;
        if (!exists && value === NOT_SET) return this;
        var idx = popCount(bitmap & bit - 1);
        var nodes = this.nodes;
        var node = exists ? nodes[idx] : undefined;
        var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
        if (newNode === node) return this;
        if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
        if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) return nodes[idx ^ 1];
        if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) return newNode;
        var isEditable = ownerID && ownerID === this.ownerID;
        var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
        var newNodes = exists ? newNode ? setIn(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);
        if (isEditable) {
            this.bitmap = newBitmap;
            this.nodes = newNodes;
            return this;
        }
        return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };
    function HashArrayMapNode(ownerID, count, nodes) {
        this.ownerID = ownerID;
        this.count = count;
        this.nodes = nodes;
    }
    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
        if (keyHash === undefined) keyHash = hash(key);
        var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
        var node = this.nodes[idx];
        return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };
    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        if (keyHash === undefined) keyHash = hash(key);
        var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
        var removed = value === NOT_SET;
        var nodes = this.nodes;
        var node = nodes[idx];
        if (removed && !node) return this;
        var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
        if (newNode === node) return this;
        var newCount = this.count;
        if (!node) newCount++;
        else if (!newNode) {
            newCount--;
            if (newCount < MIN_HASH_ARRAY_MAP_SIZE) return packNodes(ownerID, nodes, newCount, idx);
        }
        var isEditable = ownerID && ownerID === this.ownerID;
        var newNodes = setIn(nodes, idx, newNode, isEditable);
        if (isEditable) {
            this.count = newCount;
            this.nodes = newNodes;
            return this;
        }
        return new HashArrayMapNode(ownerID, newCount, newNodes);
    };
    function HashCollisionNode(ownerID, keyHash, entries) {
        this.ownerID = ownerID;
        this.keyHash = keyHash;
        this.entries = entries;
    }
    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
        var entries = this.entries;
        for(var ii = 0, len = entries.length; ii < len; ii++){
            if (is(key, entries[ii][0])) return entries[ii][1];
        }
        return notSetValue;
    };
    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        if (keyHash === undefined) keyHash = hash(key);
        var removed = value === NOT_SET;
        if (keyHash !== this.keyHash) {
            if (removed) return this;
            SetRef(didAlter);
            SetRef(didChangeSize);
            return mergeIntoNode(this, ownerID, shift, keyHash, [
                key,
                value
            ]);
        }
        var entries = this.entries;
        var idx = 0;
        for(var len = entries.length; idx < len; idx++){
            if (is(key, entries[idx][0])) break;
        }
        var exists = idx < len;
        if (exists ? entries[idx][1] === value : removed) return this;
        SetRef(didAlter);
        (removed || !exists) && SetRef(didChangeSize);
        if (removed && len === 2) return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
        var isEditable = ownerID && ownerID === this.ownerID;
        var newEntries = isEditable ? entries : arrCopy(entries);
        if (exists) {
            if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
            else newEntries[idx] = [
                key,
                value
            ];
        } else newEntries.push([
            key,
            value
        ]);
        if (isEditable) {
            this.entries = newEntries;
            return this;
        }
        return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };
    function ValueNode(ownerID, keyHash, entry) {
        this.ownerID = ownerID;
        this.keyHash = keyHash;
        this.entry = entry;
    }
    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
        return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };
    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        var removed = value === NOT_SET;
        var keyMatch = is(key, this.entry[0]);
        if (keyMatch ? value === this.entry[1] : removed) return this;
        SetRef(didAlter);
        if (removed) {
            SetRef(didChangeSize);
            return; // undefined
        }
        if (keyMatch) {
            if (ownerID && ownerID === this.ownerID) {
                this.entry[1] = value;
                return this;
            }
            return new ValueNode(ownerID, this.keyHash, [
                key,
                value
            ]);
        }
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, hash(key), [
            key,
            value
        ]);
    };
    // #pragma Iterators
    ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function(fn, reverse) {
        var entries = this.entries;
        for(var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++){
            if (fn(entries[reverse ? maxIndex - ii : ii]) === false) return false;
        }
    };
    BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function(fn, reverse) {
        var nodes = this.nodes;
        for(var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++){
            var node = nodes[reverse ? maxIndex - ii : ii];
            if (node && node.iterate(fn, reverse) === false) return false;
        }
    };
    ValueNode.prototype.iterate = function(fn, reverse) {
        return fn(this.entry);
    };
    createClass(MapIterator, Iterator);
    function MapIterator(map, type, reverse) {
        this._type = type;
        this._reverse = reverse;
        this._stack = map._root && mapIteratorFrame(map._root);
    }
    MapIterator.prototype.next = function() {
        var type = this._type;
        var stack = this._stack;
        while(stack){
            var node = stack.node;
            var index = stack.index++;
            var maxIndex;
            if (node.entry) {
                if (index === 0) return mapIteratorValue(type, node.entry);
            } else if (node.entries) {
                maxIndex = node.entries.length - 1;
                if (index <= maxIndex) return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
            } else {
                maxIndex = node.nodes.length - 1;
                if (index <= maxIndex) {
                    var subNode = node.nodes[this._reverse ? maxIndex - index : index];
                    if (subNode) {
                        if (subNode.entry) return mapIteratorValue(type, subNode.entry);
                        stack = this._stack = mapIteratorFrame(subNode, stack);
                    }
                    continue;
                }
            }
            stack = this._stack = this._stack.__prev;
        }
        return iteratorDone();
    };
    function mapIteratorValue(type, entry) {
        return iteratorValue(type, entry[0], entry[1]);
    }
    function mapIteratorFrame(node, prev) {
        return {
            node: node,
            index: 0,
            __prev: prev
        };
    }
    function makeMap(size, root, ownerID, hash) {
        var map = Object.create(MapPrototype);
        map.size = size;
        map._root = root;
        map.__ownerID = ownerID;
        map.__hash = hash;
        map.__altered = false;
        return map;
    }
    var EMPTY_MAP;
    function emptyMap() {
        return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
    }
    function updateMap(map, k, v) {
        var newRoot;
        var newSize;
        if (!map._root) {
            if (v === NOT_SET) return map;
            newSize = 1;
            newRoot = new ArrayMapNode(map.__ownerID, [
                [
                    k,
                    v
                ]
            ]);
        } else {
            var didChangeSize = MakeRef(CHANGE_LENGTH);
            var didAlter = MakeRef(DID_ALTER);
            newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
            if (!didAlter.value) return map;
            newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
        }
        if (map.__ownerID) {
            map.size = newSize;
            map._root = newRoot;
            map.__hash = undefined;
            map.__altered = true;
            return map;
        }
        return newRoot ? makeMap(newSize, newRoot) : emptyMap();
    }
    function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        if (!node) {
            if (value === NOT_SET) return node;
            SetRef(didAlter);
            SetRef(didChangeSize);
            return new ValueNode(ownerID, keyHash, [
                key,
                value
            ]);
        }
        return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
    }
    function isLeafNode(node) {
        return node.constructor === ValueNode || node.constructor === HashCollisionNode;
    }
    function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
        if (node.keyHash === keyHash) return new HashCollisionNode(ownerID, keyHash, [
            node.entry,
            entry
        ]);
        var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
        var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
        var newNode;
        var nodes = idx1 === idx2 ? [
            mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)
        ] : (newNode = new ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [
            node,
            newNode
        ] : [
            newNode,
            node
        ]);
        return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
    }
    function createNodes(ownerID, entries, key, value) {
        if (!ownerID) ownerID = new OwnerID();
        var node = new ValueNode(ownerID, hash(key), [
            key,
            value
        ]);
        for(var ii = 0; ii < entries.length; ii++){
            var entry = entries[ii];
            node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
        }
        return node;
    }
    function packNodes(ownerID, nodes, count, excluding) {
        var bitmap = 0;
        var packedII = 0;
        var packedNodes = new Array(count);
        for(var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1){
            var node = nodes[ii];
            if (node !== undefined && ii !== excluding) {
                bitmap |= bit;
                packedNodes[packedII++] = node;
            }
        }
        return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
    }
    function expandNodes(ownerID, nodes, bitmap, including, node) {
        var count = 0;
        var expandedNodes = new Array(SIZE);
        for(var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1)expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
        expandedNodes[including] = node;
        return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
    }
    function mergeIntoMapWith(map, merger, iterables) {
        var iters = [];
        for(var ii = 0; ii < iterables.length; ii++){
            var value = iterables[ii];
            var iter = KeyedIterable(value);
            if (!isIterable(value)) iter = iter.map(function(v) {
                return fromJS(v);
            });
            iters.push(iter);
        }
        return mergeIntoCollectionWith(map, merger, iters);
    }
    function deepMerger(existing, value, key) {
        return existing && existing.mergeDeep && isIterable(value) ? existing.mergeDeep(value) : is(existing, value) ? existing : value;
    }
    function deepMergerWith(merger) {
        return function(existing, value, key) {
            if (existing && existing.mergeDeepWith && isIterable(value)) return existing.mergeDeepWith(merger, value);
            var nextValue = merger(existing, value, key);
            return is(existing, nextValue) ? existing : nextValue;
        };
    }
    function mergeIntoCollectionWith(collection, merger, iters) {
        iters = iters.filter(function(x) {
            return x.size !== 0;
        });
        if (iters.length === 0) return collection;
        if (collection.size === 0 && !collection.__ownerID && iters.length === 1) return collection.constructor(iters[0]);
        return collection.withMutations(function(collection) {
            var mergeIntoMap = merger ? function(value, key) {
                collection.update(key, NOT_SET, function(existing) {
                    return existing === NOT_SET ? value : merger(existing, value, key);
                });
            } : function(value, key) {
                collection.set(key, value);
            };
            for(var ii = 0; ii < iters.length; ii++)iters[ii].forEach(mergeIntoMap);
        });
    }
    function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
        var isNotSet = existing === NOT_SET;
        var step = keyPathIter.next();
        if (step.done) {
            var existingValue = isNotSet ? notSetValue : existing;
            var newValue = updater(existingValue);
            return newValue === existingValue ? existing : newValue;
        }
        invariant(isNotSet || existing && existing.set, "invalid keyPath");
        var key = step.value;
        var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
        var nextUpdated = updateInDeepMap(nextExisting, keyPathIter, notSetValue, updater);
        return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? existing.remove(key) : (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
    }
    function popCount(x) {
        x = x - (x >> 1 & 0x55555555);
        x = (x & 0x33333333) + (x >> 2 & 0x33333333);
        x = x + (x >> 4) & 0x0f0f0f0f;
        x = x + (x >> 8);
        x = x + (x >> 16);
        return x & 0x7f;
    }
    function setIn(array, idx, val, canEdit) {
        var newArray = canEdit ? array : arrCopy(array);
        newArray[idx] = val;
        return newArray;
    }
    function spliceIn(array, idx, val, canEdit) {
        var newLen = array.length + 1;
        if (canEdit && idx + 1 === newLen) {
            array[idx] = val;
            return array;
        }
        var newArray = new Array(newLen);
        var after = 0;
        for(var ii = 0; ii < newLen; ii++)if (ii === idx) {
            newArray[ii] = val;
            after = -1;
        } else newArray[ii] = array[ii + after];
        return newArray;
    }
    function spliceOut(array, idx, canEdit) {
        var newLen = array.length - 1;
        if (canEdit && idx === newLen) {
            array.pop();
            return array;
        }
        var newArray = new Array(newLen);
        var after = 0;
        for(var ii = 0; ii < newLen; ii++){
            if (ii === idx) after = 1;
            newArray[ii] = array[ii + after];
        }
        return newArray;
    }
    var MAX_ARRAY_MAP_SIZE = SIZE / 4;
    var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
    var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
    createClass(List, IndexedCollection);
    // @pragma Construction
    function List(value) {
        var empty = emptyList();
        if (value === null || value === undefined) return empty;
        if (isList(value)) return value;
        var iter = IndexedIterable(value);
        var size = iter.size;
        if (size === 0) return empty;
        assertNotInfinite(size);
        if (size > 0 && size < SIZE) return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
        return empty.withMutations(function(list) {
            list.setSize(size);
            iter.forEach(function(v, i) {
                return list.set(i, v);
            });
        });
    }
    List.of = function() {
        return this(arguments);
    };
    List.prototype.toString = function() {
        return this.__toString("List [", "]");
    };
    // @pragma Access
    List.prototype.get = function(index, notSetValue) {
        index = wrapIndex(this, index);
        if (index >= 0 && index < this.size) {
            index += this._origin;
            var node = listNodeFor(this, index);
            return node && node.array[index & MASK];
        }
        return notSetValue;
    };
    // @pragma Modification
    List.prototype.set = function(index, value) {
        return updateList(this, index, value);
    };
    List.prototype.remove = function(index) {
        return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
    };
    List.prototype.insert = function(index, value) {
        return this.splice(index, 0, value);
    };
    List.prototype.clear = function() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = this._origin = this._capacity = 0;
            this._level = SHIFT;
            this._root = this._tail = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyList();
    };
    List.prototype.push = function() {
        var values = arguments;
        var oldSize = this.size;
        return this.withMutations(function(list) {
            setListBounds(list, 0, oldSize + values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(oldSize + ii, values[ii]);
        });
    };
    List.prototype.pop = function() {
        return setListBounds(this, 0, -1);
    };
    List.prototype.unshift = function() {
        var values = arguments;
        return this.withMutations(function(list) {
            setListBounds(list, -values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(ii, values[ii]);
        });
    };
    List.prototype.shift = function() {
        return setListBounds(this, 1);
    };
    // @pragma Composition
    List.prototype.merge = function() {
        return mergeIntoListWith(this, undefined, arguments);
    };
    List.prototype.mergeWith = function(merger) {
        var iters = SLICE$0.call(arguments, 1);
        return mergeIntoListWith(this, merger, iters);
    };
    List.prototype.mergeDeep = function() {
        return mergeIntoListWith(this, deepMerger, arguments);
    };
    List.prototype.mergeDeepWith = function(merger) {
        var iters = SLICE$0.call(arguments, 1);
        return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };
    List.prototype.setSize = function(size) {
        return setListBounds(this, 0, size);
    };
    // @pragma Iteration
    List.prototype.slice = function(begin, end) {
        var size = this.size;
        if (wholeSlice(begin, end, size)) return this;
        return setListBounds(this, resolveBegin(begin, size), resolveEnd(end, size));
    };
    List.prototype.__iterator = function(type, reverse) {
        var index = 0;
        var values = iterateList(this, reverse);
        return new Iterator(function() {
            var value = values();
            return value === DONE ? iteratorDone() : iteratorValue(type, index++, value);
        });
    };
    List.prototype.__iterate = function(fn, reverse) {
        var index = 0;
        var values = iterateList(this, reverse);
        var value;
        while((value = values()) !== DONE){
            if (fn(value, index++, this) === false) break;
        }
        return index;
    };
    List.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            this.__ownerID = ownerID;
            return this;
        }
        return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };
    function isList(maybeList) {
        return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
    }
    List.isList = isList;
    var IS_LIST_SENTINEL = "@@__IMMUTABLE_LIST__@@";
    var ListPrototype = List.prototype;
    ListPrototype[IS_LIST_SENTINEL] = true;
    ListPrototype[DELETE] = ListPrototype.remove;
    ListPrototype.setIn = MapPrototype.setIn;
    ListPrototype.deleteIn = ListPrototype.removeIn = MapPrototype.removeIn;
    ListPrototype.update = MapPrototype.update;
    ListPrototype.updateIn = MapPrototype.updateIn;
    ListPrototype.mergeIn = MapPrototype.mergeIn;
    ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
    ListPrototype.withMutations = MapPrototype.withMutations;
    ListPrototype.asMutable = MapPrototype.asMutable;
    ListPrototype.asImmutable = MapPrototype.asImmutable;
    ListPrototype.wasAltered = MapPrototype.wasAltered;
    function VNode(array, ownerID) {
        this.array = array;
        this.ownerID = ownerID;
    }
    // TODO: seems like these methods are very similar
    VNode.prototype.removeBefore = function(ownerID, level, index) {
        if (index === level ? 1 << level : this.array.length === 0) return this;
        var originIndex = index >>> level & MASK;
        if (originIndex >= this.array.length) return new VNode([], ownerID);
        var removingFirst = originIndex === 0;
        var newChild;
        if (level > 0) {
            var oldChild = this.array[originIndex];
            newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
            if (newChild === oldChild && removingFirst) return this;
        }
        if (removingFirst && !newChild) return this;
        var editable = editableVNode(this, ownerID);
        if (!removingFirst) for(var ii = 0; ii < originIndex; ii++)editable.array[ii] = undefined;
        if (newChild) editable.array[originIndex] = newChild;
        return editable;
    };
    VNode.prototype.removeAfter = function(ownerID, level, index) {
        if (index === (level ? 1 << level : 0) || this.array.length === 0) return this;
        var sizeIndex = index - 1 >>> level & MASK;
        if (sizeIndex >= this.array.length) return this;
        var newChild;
        if (level > 0) {
            var oldChild = this.array[sizeIndex];
            newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
            if (newChild === oldChild && sizeIndex === this.array.length - 1) return this;
        }
        var editable = editableVNode(this, ownerID);
        editable.array.splice(sizeIndex + 1);
        if (newChild) editable.array[sizeIndex] = newChild;
        return editable;
    };
    var DONE = {};
    function iterateList(list, reverse) {
        var left = list._origin;
        var right = list._capacity;
        var tailPos = getTailOffset(right);
        var tail = list._tail;
        return iterateNodeOrLeaf(list._root, list._level, 0);
        function iterateNodeOrLeaf(node, level, offset) {
            return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
        }
        function iterateLeaf(node, offset) {
            var array = offset === tailPos ? tail && tail.array : node && node.array;
            var from = offset > left ? 0 : left - offset;
            var to = right - offset;
            if (to > SIZE) to = SIZE;
            return function() {
                if (from === to) return DONE;
                var idx = reverse ? --to : from++;
                return array && array[idx];
            };
        }
        function iterateNode(node, level, offset) {
            var values;
            var array = node && node.array;
            var from = offset > left ? 0 : left - offset >> level;
            var to = (right - offset >> level) + 1;
            if (to > SIZE) to = SIZE;
            return function() {
                do {
                    if (values) {
                        var value = values();
                        if (value !== DONE) return value;
                        values = null;
                    }
                    if (from === to) return DONE;
                    var idx = reverse ? --to : from++;
                    values = iterateNodeOrLeaf(array && array[idx], level - SHIFT, offset + (idx << level));
                }while (true);
            };
        }
    }
    function makeList(origin, capacity, level, root, tail, ownerID, hash) {
        var list = Object.create(ListPrototype);
        list.size = capacity - origin;
        list._origin = origin;
        list._capacity = capacity;
        list._level = level;
        list._root = root;
        list._tail = tail;
        list.__ownerID = ownerID;
        list.__hash = hash;
        list.__altered = false;
        return list;
    }
    var EMPTY_LIST;
    function emptyList() {
        return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
    }
    function updateList(list, index, value) {
        index = wrapIndex(list, index);
        if (index !== index) return list;
        if (index >= list.size || index < 0) return list.withMutations(function(list) {
            index < 0 ? setListBounds(list, index).set(0, value) : setListBounds(list, 0, index + 1).set(index, value);
        });
        index += list._origin;
        var newTail = list._tail;
        var newRoot = list._root;
        var didAlter = MakeRef(DID_ALTER);
        if (index >= getTailOffset(list._capacity)) newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
        else newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
        if (!didAlter.value) return list;
        if (list.__ownerID) {
            list._root = newRoot;
            list._tail = newTail;
            list.__hash = undefined;
            list.__altered = true;
            return list;
        }
        return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
    }
    function updateVNode(node, ownerID, level, index, value, didAlter) {
        var idx = index >>> level & MASK;
        var nodeHas = node && idx < node.array.length;
        if (!nodeHas && value === undefined) return node;
        var newNode;
        if (level > 0) {
            var lowerNode = node && node.array[idx];
            var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
            if (newLowerNode === lowerNode) return node;
            newNode = editableVNode(node, ownerID);
            newNode.array[idx] = newLowerNode;
            return newNode;
        }
        if (nodeHas && node.array[idx] === value) return node;
        SetRef(didAlter);
        newNode = editableVNode(node, ownerID);
        if (value === undefined && idx === newNode.array.length - 1) newNode.array.pop();
        else newNode.array[idx] = value;
        return newNode;
    }
    function editableVNode(node, ownerID) {
        if (ownerID && node && ownerID === node.ownerID) return node;
        return new VNode(node ? node.array.slice() : [], ownerID);
    }
    function listNodeFor(list, rawIndex) {
        if (rawIndex >= getTailOffset(list._capacity)) return list._tail;
        if (rawIndex < 1 << list._level + SHIFT) {
            var node = list._root;
            var level = list._level;
            while(node && level > 0){
                node = node.array[rawIndex >>> level & MASK];
                level -= SHIFT;
            }
            return node;
        }
    }
    function setListBounds(list, begin, end) {
        // Sanitize begin & end using this shorthand for ToInt32(argument)
        // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
        if (begin !== undefined) begin = begin | 0;
        if (end !== undefined) end = end | 0;
        var owner = list.__ownerID || new OwnerID();
        var oldOrigin = list._origin;
        var oldCapacity = list._capacity;
        var newOrigin = oldOrigin + begin;
        var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
        if (newOrigin === oldOrigin && newCapacity === oldCapacity) return list;
        // If it's going to end after it starts, it's empty.
        if (newOrigin >= newCapacity) return list.clear();
        var newLevel = list._level;
        var newRoot = list._root;
        // New origin might need creating a higher root.
        var offsetShift = 0;
        while(newOrigin + offsetShift < 0){
            newRoot = new VNode(newRoot && newRoot.array.length ? [
                undefined,
                newRoot
            ] : [], owner);
            newLevel += SHIFT;
            offsetShift += 1 << newLevel;
        }
        if (offsetShift) {
            newOrigin += offsetShift;
            oldOrigin += offsetShift;
            newCapacity += offsetShift;
            oldCapacity += offsetShift;
        }
        var oldTailOffset = getTailOffset(oldCapacity);
        var newTailOffset = getTailOffset(newCapacity);
        // New size might need creating a higher root.
        while(newTailOffset >= 1 << newLevel + SHIFT){
            newRoot = new VNode(newRoot && newRoot.array.length ? [
                newRoot
            ] : [], owner);
            newLevel += SHIFT;
        }
        // Locate or create the new tail.
        var oldTail = list._tail;
        var newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
        // Merge Tail into tree.
        if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
            newRoot = editableVNode(newRoot, owner);
            var node = newRoot;
            for(var level = newLevel; level > SHIFT; level -= SHIFT){
                var idx = oldTailOffset >>> level & MASK;
                node = node.array[idx] = editableVNode(node.array[idx], owner);
            }
            node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
        }
        // If the size has been reduced, there's a chance the tail needs to be trimmed.
        if (newCapacity < oldCapacity) newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
        // If the new origin is within the tail, then we do not need a root.
        if (newOrigin >= newTailOffset) {
            newOrigin -= newTailOffset;
            newCapacity -= newTailOffset;
            newLevel = SHIFT;
            newRoot = null;
            newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
        // Otherwise, if the root has been trimmed, garbage collect.
        } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
            offsetShift = 0;
            // Identify the new top root node of the subtree of the old root.
            while(newRoot){
                var beginIndex = newOrigin >>> newLevel & MASK;
                if (beginIndex !== newTailOffset >>> newLevel & MASK) break;
                if (beginIndex) offsetShift += (1 << newLevel) * beginIndex;
                newLevel -= SHIFT;
                newRoot = newRoot.array[beginIndex];
            }
            // Trim the new sides of the new root.
            if (newRoot && newOrigin > oldOrigin) newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
            if (newRoot && newTailOffset < oldTailOffset) newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
            if (offsetShift) {
                newOrigin -= offsetShift;
                newCapacity -= offsetShift;
            }
        }
        if (list.__ownerID) {
            list.size = newCapacity - newOrigin;
            list._origin = newOrigin;
            list._capacity = newCapacity;
            list._level = newLevel;
            list._root = newRoot;
            list._tail = newTail;
            list.__hash = undefined;
            list.__altered = true;
            return list;
        }
        return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
    }
    function mergeIntoListWith(list, merger, iterables) {
        var iters = [];
        var maxSize = 0;
        for(var ii = 0; ii < iterables.length; ii++){
            var value = iterables[ii];
            var iter = IndexedIterable(value);
            if (iter.size > maxSize) maxSize = iter.size;
            if (!isIterable(value)) iter = iter.map(function(v) {
                return fromJS(v);
            });
            iters.push(iter);
        }
        if (maxSize > list.size) list = list.setSize(maxSize);
        return mergeIntoCollectionWith(list, merger, iters);
    }
    function getTailOffset(size) {
        return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
    }
    createClass(OrderedMap, Map);
    // @pragma Construction
    function OrderedMap(value) {
        return value === null || value === undefined ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function(map) {
            var iter = KeyedIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    OrderedMap.of = function() {
        return this(arguments);
    };
    OrderedMap.prototype.toString = function() {
        return this.__toString("OrderedMap {", "}");
    };
    // @pragma Access
    OrderedMap.prototype.get = function(k, notSetValue) {
        var index = this._map.get(k);
        return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };
    // @pragma Modification
    OrderedMap.prototype.clear = function() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._map.clear();
            this._list.clear();
            return this;
        }
        return emptyOrderedMap();
    };
    OrderedMap.prototype.set = function(k, v) {
        return updateOrderedMap(this, k, v);
    };
    OrderedMap.prototype.remove = function(k) {
        return updateOrderedMap(this, k, NOT_SET);
    };
    OrderedMap.prototype.wasAltered = function() {
        return this._map.wasAltered() || this._list.wasAltered();
    };
    OrderedMap.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        return this._list.__iterate(function(entry) {
            return entry && fn(entry[1], entry[0], this$0);
        }, reverse);
    };
    OrderedMap.prototype.__iterator = function(type, reverse) {
        return this._list.fromEntrySeq().__iterator(type, reverse);
    };
    OrderedMap.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        var newList = this._list.__ensureOwner(ownerID);
        if (!ownerID) {
            this.__ownerID = ownerID;
            this._map = newMap;
            this._list = newList;
            return this;
        }
        return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };
    function isOrderedMap(maybeOrderedMap) {
        return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
    }
    OrderedMap.isOrderedMap = isOrderedMap;
    OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
    OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
    function makeOrderedMap(map, list, ownerID, hash) {
        var omap = Object.create(OrderedMap.prototype);
        omap.size = map ? map.size : 0;
        omap._map = map;
        omap._list = list;
        omap.__ownerID = ownerID;
        omap.__hash = hash;
        return omap;
    }
    var EMPTY_ORDERED_MAP;
    function emptyOrderedMap() {
        return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
    }
    function updateOrderedMap(omap, k, v) {
        var map = omap._map;
        var list = omap._list;
        var i = map.get(k);
        var has = i !== undefined;
        var newMap;
        var newList;
        if (v === NOT_SET) {
            if (!has) return omap;
            if (list.size >= SIZE && list.size >= map.size * 2) {
                newList = list.filter(function(entry, idx) {
                    return entry !== undefined && i !== idx;
                });
                newMap = newList.toKeyedSeq().map(function(entry) {
                    return entry[0];
                }).flip().toMap();
                if (omap.__ownerID) newMap.__ownerID = newList.__ownerID = omap.__ownerID;
            } else {
                newMap = map.remove(k);
                newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
            }
        } else if (has) {
            if (v === list.get(i)[1]) return omap;
            newMap = map;
            newList = list.set(i, [
                k,
                v
            ]);
        } else {
            newMap = map.set(k, list.size);
            newList = list.set(list.size, [
                k,
                v
            ]);
        }
        if (omap.__ownerID) {
            omap.size = newMap.size;
            omap._map = newMap;
            omap._list = newList;
            omap.__hash = undefined;
            return omap;
        }
        return makeOrderedMap(newMap, newList);
    }
    createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
        this._iter = indexed;
        this._useKeys = useKeys;
        this.size = indexed.size;
    }
    ToKeyedSequence.prototype.get = function(key, notSetValue) {
        return this._iter.get(key, notSetValue);
    };
    ToKeyedSequence.prototype.has = function(key) {
        return this._iter.has(key);
    };
    ToKeyedSequence.prototype.valueSeq = function() {
        return this._iter.valueSeq();
    };
    ToKeyedSequence.prototype.reverse = function() {
        var this$0 = this;
        var reversedSequence = reverseFactory(this, true);
        if (!this._useKeys) reversedSequence.valueSeq = function() {
            return this$0._iter.toSeq().reverse();
        };
        return reversedSequence;
    };
    ToKeyedSequence.prototype.map = function(mapper, context) {
        var this$0 = this;
        var mappedSequence = mapFactory(this, mapper, context);
        if (!this._useKeys) mappedSequence.valueSeq = function() {
            return this$0._iter.toSeq().map(mapper, context);
        };
        return mappedSequence;
    };
    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        var ii;
        return this._iter.__iterate(this._useKeys ? function(v, k) {
            return fn(v, k, this$0);
        } : (ii = reverse ? resolveSize(this) : 0, function(v) {
            return fn(v, reverse ? --ii : ii++, this$0);
        }), reverse);
    };
    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
        if (this._useKeys) return this._iter.__iterator(type, reverse);
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        var ii = reverse ? resolveSize(this) : 0;
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, reverse ? --ii : ii++, step.value, step);
        });
    };
    ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
    createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    ToIndexedSequence.prototype.includes = function(value) {
        return this._iter.includes(value);
    };
    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        var iterations = 0;
        return this._iter.__iterate(function(v) {
            return fn(v, iterations++, this$0);
        }, reverse);
    };
    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        var iterations = 0;
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, iterations++, step.value, step);
        });
    };
    createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    ToSetSequence.prototype.has = function(key) {
        return this._iter.includes(key);
    };
    ToSetSequence.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        return this._iter.__iterate(function(v) {
            return fn(v, v, this$0);
        }, reverse);
    };
    ToSetSequence.prototype.__iterator = function(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, step.value, step.value, step);
        });
    };
    createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
        this._iter = entries;
        this.size = entries.size;
    }
    FromEntriesSequence.prototype.entrySeq = function() {
        return this._iter.toSeq();
    };
    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        return this._iter.__iterate(function(entry) {
            // Check if entry exists first so array access doesn't throw for holes
            // in the parent iteration.
            if (entry) {
                validateEntry(entry);
                var indexedIterable = isIterable(entry);
                return fn(indexedIterable ? entry.get(1) : entry[1], indexedIterable ? entry.get(0) : entry[0], this$0);
            }
        }, reverse);
    };
    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                // Check if entry exists first so array access doesn't throw for holes
                // in the parent iteration.
                if (entry) {
                    validateEntry(entry);
                    var indexedIterable = isIterable(entry);
                    return iteratorValue(type, indexedIterable ? entry.get(0) : entry[0], indexedIterable ? entry.get(1) : entry[1], step);
                }
            }
        });
    };
    ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough;
    function flipFactory(iterable) {
        var flipSequence = makeSequence(iterable);
        flipSequence._iter = iterable;
        flipSequence.size = iterable.size;
        flipSequence.flip = function() {
            return iterable;
        };
        flipSequence.reverse = function() {
            var reversedSequence = iterable.reverse.apply(this); // super.reverse()
            reversedSequence.flip = function() {
                return iterable.reverse();
            };
            return reversedSequence;
        };
        flipSequence.has = function(key) {
            return iterable.includes(key);
        };
        flipSequence.includes = function(key) {
            return iterable.has(key);
        };
        flipSequence.cacheResult = cacheResultThrough;
        flipSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            return iterable.__iterate(function(v, k) {
                return fn(k, v, this$0) !== false;
            }, reverse);
        };
        flipSequence.__iteratorUncached = function(type, reverse) {
            if (type === ITERATE_ENTRIES) {
                var iterator = iterable.__iterator(type, reverse);
                return new Iterator(function() {
                    var step = iterator.next();
                    if (!step.done) {
                        var k = step.value[0];
                        step.value[0] = step.value[1];
                        step.value[1] = k;
                    }
                    return step;
                });
            }
            return iterable.__iterator(type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES, reverse);
        };
        return flipSequence;
    }
    function mapFactory(iterable, mapper, context) {
        var mappedSequence = makeSequence(iterable);
        mappedSequence.size = iterable.size;
        mappedSequence.has = function(key) {
            return iterable.has(key);
        };
        mappedSequence.get = function(key, notSetValue) {
            var v = iterable.get(key, NOT_SET);
            return v === NOT_SET ? notSetValue : mapper.call(context, v, key, iterable);
        };
        mappedSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            return iterable.__iterate(function(v, k, c) {
                return fn(mapper.call(context, v, k, c), k, this$0) !== false;
            }, reverse);
        };
        mappedSequence.__iteratorUncached = function(type, reverse) {
            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
            return new Iterator(function() {
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                var key = entry[0];
                return iteratorValue(type, key, mapper.call(context, entry[1], key, iterable), step);
            });
        };
        return mappedSequence;
    }
    function reverseFactory(iterable, useKeys) {
        var reversedSequence = makeSequence(iterable);
        reversedSequence._iter = iterable;
        reversedSequence.size = iterable.size;
        reversedSequence.reverse = function() {
            return iterable;
        };
        if (iterable.flip) reversedSequence.flip = function() {
            var flipSequence = flipFactory(iterable);
            flipSequence.reverse = function() {
                return iterable.flip();
            };
            return flipSequence;
        };
        reversedSequence.get = function(key, notSetValue) {
            return iterable.get(useKeys ? key : -1 - key, notSetValue);
        };
        reversedSequence.has = function(key) {
            return iterable.has(useKeys ? key : -1 - key);
        };
        reversedSequence.includes = function(value) {
            return iterable.includes(value);
        };
        reversedSequence.cacheResult = cacheResultThrough;
        reversedSequence.__iterate = function(fn, reverse) {
            var this$0 = this;
            return iterable.__iterate(function(v, k) {
                return fn(v, k, this$0);
            }, !reverse);
        };
        reversedSequence.__iterator = function(type, reverse) {
            return iterable.__iterator(type, !reverse);
        };
        return reversedSequence;
    }
    function filterFactory(iterable, predicate, context, useKeys) {
        var filterSequence = makeSequence(iterable);
        if (useKeys) {
            filterSequence.has = function(key) {
                var v = iterable.get(key, NOT_SET);
                return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
            };
            filterSequence.get = function(key, notSetValue) {
                var v = iterable.get(key, NOT_SET);
                return v !== NOT_SET && predicate.call(context, v, key, iterable) ? v : notSetValue;
            };
        }
        filterSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            var iterations = 0;
            iterable.__iterate(function(v, k, c) {
                if (predicate.call(context, v, k, c)) {
                    iterations++;
                    return fn(v, useKeys ? k : iterations - 1, this$0);
                }
            }, reverse);
            return iterations;
        };
        filterSequence.__iteratorUncached = function(type, reverse) {
            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
            var iterations = 0;
            return new Iterator(function() {
                while(true){
                    var step = iterator.next();
                    if (step.done) return step;
                    var entry = step.value;
                    var key = entry[0];
                    var value = entry[1];
                    if (predicate.call(context, value, key, iterable)) return iteratorValue(type, useKeys ? key : iterations++, value, step);
                }
            });
        };
        return filterSequence;
    }
    function countByFactory(iterable, grouper, context) {
        var groups = Map().asMutable();
        iterable.__iterate(function(v, k) {
            groups.update(grouper.call(context, v, k, iterable), 0, function(a) {
                return a + 1;
            });
        });
        return groups.asImmutable();
    }
    function groupByFactory(iterable, grouper, context) {
        var isKeyedIter = isKeyed(iterable);
        var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
        iterable.__iterate(function(v, k) {
            groups.update(grouper.call(context, v, k, iterable), function(a) {
                return a = a || [], a.push(isKeyedIter ? [
                    k,
                    v
                ] : v), a;
            });
        });
        var coerce = iterableClass(iterable);
        return groups.map(function(arr) {
            return reify(iterable, coerce(arr));
        });
    }
    function sliceFactory(iterable, begin, end, useKeys) {
        var originalSize = iterable.size;
        // Sanitize begin & end using this shorthand for ToInt32(argument)
        // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
        if (begin !== undefined) begin = begin | 0;
        if (end !== undefined) {
            if (end === Infinity) end = originalSize;
            else end = end | 0;
        }
        if (wholeSlice(begin, end, originalSize)) return iterable;
        var resolvedBegin = resolveBegin(begin, originalSize);
        var resolvedEnd = resolveEnd(end, originalSize);
        // begin or end will be NaN if they were provided as negative numbers and
        // this iterable's size is unknown. In that case, cache first so there is
        // a known size and these do not resolve to NaN.
        if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
        // Note: resolvedEnd is undefined when the original sequence's length is
        // unknown and this slice did not supply an end and should contain all
        // elements after resolvedBegin.
        // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
        var resolvedSize = resolvedEnd - resolvedBegin;
        var sliceSize;
        if (resolvedSize === resolvedSize) sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
        var sliceSeq = makeSequence(iterable);
        // If iterable.size is undefined, the size of the realized sliceSeq is
        // unknown at this point unless the number of items to slice is 0
        sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
        if (!useKeys && isSeq(iterable) && sliceSize >= 0) sliceSeq.get = function(index, notSetValue) {
            index = wrapIndex(this, index);
            return index >= 0 && index < sliceSize ? iterable.get(index + resolvedBegin, notSetValue) : notSetValue;
        };
        sliceSeq.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            if (sliceSize === 0) return 0;
            if (reverse) return this.cacheResult().__iterate(fn, reverse);
            var skipped = 0;
            var isSkipping = true;
            var iterations = 0;
            iterable.__iterate(function(v, k) {
                if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
                    iterations++;
                    return fn(v, useKeys ? k : iterations - 1, this$0) !== false && iterations !== sliceSize;
                }
            });
            return iterations;
        };
        sliceSeq.__iteratorUncached = function(type, reverse) {
            if (sliceSize !== 0 && reverse) return this.cacheResult().__iterator(type, reverse);
            // Don't bother instantiating parent iterator if taking 0.
            var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
            var skipped = 0;
            var iterations = 0;
            return new Iterator(function() {
                while(skipped++ < resolvedBegin)iterator.next();
                if (++iterations > sliceSize) return iteratorDone();
                var step = iterator.next();
                if (useKeys || type === ITERATE_VALUES) return step;
                else if (type === ITERATE_KEYS) return iteratorValue(type, iterations - 1, undefined, step);
                else return iteratorValue(type, iterations - 1, step.value[1], step);
            });
        };
        return sliceSeq;
    }
    function takeWhileFactory(iterable, predicate, context) {
        var takeSequence = makeSequence(iterable);
        takeSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            if (reverse) return this.cacheResult().__iterate(fn, reverse);
            var iterations = 0;
            iterable.__iterate(function(v, k, c) {
                return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0);
            });
            return iterations;
        };
        takeSequence.__iteratorUncached = function(type, reverse) {
            var this$0 = this;
            if (reverse) return this.cacheResult().__iterator(type, reverse);
            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
            var iterating = true;
            return new Iterator(function() {
                if (!iterating) return iteratorDone();
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                var k = entry[0];
                var v = entry[1];
                if (!predicate.call(context, v, k, this$0)) {
                    iterating = false;
                    return iteratorDone();
                }
                return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
            });
        };
        return takeSequence;
    }
    function skipWhileFactory(iterable, predicate, context, useKeys) {
        var skipSequence = makeSequence(iterable);
        skipSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            if (reverse) return this.cacheResult().__iterate(fn, reverse);
            var isSkipping = true;
            var iterations = 0;
            iterable.__iterate(function(v, k, c) {
                if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
                    iterations++;
                    return fn(v, useKeys ? k : iterations - 1, this$0);
                }
            });
            return iterations;
        };
        skipSequence.__iteratorUncached = function(type, reverse) {
            var this$0 = this;
            if (reverse) return this.cacheResult().__iterator(type, reverse);
            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
            var skipping = true;
            var iterations = 0;
            return new Iterator(function() {
                var step, k, v;
                do {
                    step = iterator.next();
                    if (step.done) {
                        if (useKeys || type === ITERATE_VALUES) return step;
                        else if (type === ITERATE_KEYS) return iteratorValue(type, iterations++, undefined, step);
                        else return iteratorValue(type, iterations++, step.value[1], step);
                    }
                    var entry = step.value;
                    k = entry[0];
                    v = entry[1];
                    skipping && (skipping = predicate.call(context, v, k, this$0));
                }while (skipping);
                return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
            });
        };
        return skipSequence;
    }
    function concatFactory(iterable, values) {
        var isKeyedIterable = isKeyed(iterable);
        var iters = [
            iterable
        ].concat(values).map(function(v) {
            if (!isIterable(v)) v = isKeyedIterable ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [
                v
            ]);
            else if (isKeyedIterable) v = KeyedIterable(v);
            return v;
        }).filter(function(v) {
            return v.size !== 0;
        });
        if (iters.length === 0) return iterable;
        if (iters.length === 1) {
            var singleton = iters[0];
            if (singleton === iterable || isKeyedIterable && isKeyed(singleton) || isIndexed(iterable) && isIndexed(singleton)) return singleton;
        }
        var concatSeq = new ArraySeq(iters);
        if (isKeyedIterable) concatSeq = concatSeq.toKeyedSeq();
        else if (!isIndexed(iterable)) concatSeq = concatSeq.toSetSeq();
        concatSeq = concatSeq.flatten(true);
        concatSeq.size = iters.reduce(function(sum, seq) {
            if (sum !== undefined) {
                var size = seq.size;
                if (size !== undefined) return sum + size;
            }
        }, 0);
        return concatSeq;
    }
    function flattenFactory(iterable, depth, useKeys) {
        var flatSequence = makeSequence(iterable);
        flatSequence.__iterateUncached = function(fn, reverse) {
            var iterations = 0;
            var stopped = false;
            function flatDeep(iter, currentDepth) {
                var this$0 = this;
                iter.__iterate(function(v, k) {
                    if ((!depth || currentDepth < depth) && isIterable(v)) flatDeep(v, currentDepth + 1);
                    else if (fn(v, useKeys ? k : iterations++, this$0) === false) stopped = true;
                    return !stopped;
                }, reverse);
            }
            flatDeep(iterable, 0);
            return iterations;
        };
        flatSequence.__iteratorUncached = function(type, reverse) {
            var iterator = iterable.__iterator(type, reverse);
            var stack = [];
            var iterations = 0;
            return new Iterator(function() {
                while(iterator){
                    var step = iterator.next();
                    if (step.done !== false) {
                        iterator = stack.pop();
                        continue;
                    }
                    var v = step.value;
                    if (type === ITERATE_ENTRIES) v = v[1];
                    if ((!depth || stack.length < depth) && isIterable(v)) {
                        stack.push(iterator);
                        iterator = v.__iterator(type, reverse);
                    } else return useKeys ? step : iteratorValue(type, iterations++, v, step);
                }
                return iteratorDone();
            });
        };
        return flatSequence;
    }
    function flatMapFactory(iterable, mapper, context) {
        var coerce = iterableClass(iterable);
        return iterable.toSeq().map(function(v, k) {
            return coerce(mapper.call(context, v, k, iterable));
        }).flatten(true);
    }
    function interposeFactory(iterable, separator) {
        var interposedSequence = makeSequence(iterable);
        interposedSequence.size = iterable.size && iterable.size * 2 - 1;
        interposedSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            var iterations = 0;
            iterable.__iterate(function(v, k) {
                return (!iterations || fn(separator, iterations++, this$0) !== false) && fn(v, iterations++, this$0) !== false;
            }, reverse);
            return iterations;
        };
        interposedSequence.__iteratorUncached = function(type, reverse) {
            var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
            var iterations = 0;
            var step;
            return new Iterator(function() {
                if (!step || iterations % 2) {
                    step = iterator.next();
                    if (step.done) return step;
                }
                return iterations % 2 ? iteratorValue(type, iterations++, separator) : iteratorValue(type, iterations++, step.value, step);
            });
        };
        return interposedSequence;
    }
    function sortFactory(iterable, comparator, mapper) {
        if (!comparator) comparator = defaultComparator;
        var isKeyedIterable = isKeyed(iterable);
        var index = 0;
        var entries = iterable.toSeq().map(function(v, k) {
            return [
                k,
                v,
                index++,
                mapper ? mapper(v, k, iterable) : v
            ];
        }).toArray();
        entries.sort(function(a, b) {
            return comparator(a[3], b[3]) || a[2] - b[2];
        }).forEach(isKeyedIterable ? function(v, i) {
            entries[i].length = 2;
        } : function(v, i) {
            entries[i] = v[1];
        });
        return isKeyedIterable ? KeyedSeq(entries) : isIndexed(iterable) ? IndexedSeq(entries) : SetSeq(entries);
    }
    function maxFactory(iterable, comparator, mapper) {
        if (!comparator) comparator = defaultComparator;
        if (mapper) {
            var entry = iterable.toSeq().map(function(v, k) {
                return [
                    v,
                    mapper(v, k, iterable)
                ];
            }).reduce(function(a, b) {
                return maxCompare(comparator, a[1], b[1]) ? b : a;
            });
            return entry && entry[0];
        } else return iterable.reduce(function(a, b) {
            return maxCompare(comparator, a, b) ? b : a;
        });
    }
    function maxCompare(comparator, a, b) {
        var comp = comparator(b, a);
        // b is considered the new max if the comparator declares them equal, but
        // they are not equal and b is in fact a nullish value.
        return comp === 0 && b !== a && (b === undefined || b === null || b !== b) || comp > 0;
    }
    function zipWithFactory(keyIter, zipper, iters) {
        var zipSequence = makeSequence(keyIter);
        zipSequence.size = new ArraySeq(iters).map(function(i) {
            return i.size;
        }).min();
        // Note: this a generic base implementation of __iterate in terms of
        // __iterator which may be more generically useful in the future.
        zipSequence.__iterate = function(fn, reverse) {
            /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */ // indexed:
            var iterator = this.__iterator(ITERATE_VALUES, reverse);
            var step;
            var iterations = 0;
            while(!(step = iterator.next()).done){
                if (fn(step.value, iterations++, this) === false) break;
            }
            return iterations;
        };
        zipSequence.__iteratorUncached = function(type, reverse) {
            var iterators = iters.map(function(i) {
                return i = Iterable(i), getIterator(reverse ? i.reverse() : i);
            });
            var iterations = 0;
            var isDone = false;
            return new Iterator(function() {
                var steps;
                if (!isDone) {
                    steps = iterators.map(function(i) {
                        return i.next();
                    });
                    isDone = steps.some(function(s) {
                        return s.done;
                    });
                }
                if (isDone) return iteratorDone();
                return iteratorValue(type, iterations++, zipper.apply(null, steps.map(function(s) {
                    return s.value;
                })));
            });
        };
        return zipSequence;
    }
    // #pragma Helper Functions
    function reify(iter, seq) {
        return isSeq(iter) ? seq : iter.constructor(seq);
    }
    function validateEntry(entry) {
        if (entry !== Object(entry)) throw new TypeError("Expected [K, V] tuple: " + entry);
    }
    function resolveSize(iter) {
        assertNotInfinite(iter.size);
        return ensureSize(iter);
    }
    function iterableClass(iterable) {
        return isKeyed(iterable) ? KeyedIterable : isIndexed(iterable) ? IndexedIterable : SetIterable;
    }
    function makeSequence(iterable) {
        return Object.create((isKeyed(iterable) ? KeyedSeq : isIndexed(iterable) ? IndexedSeq : SetSeq).prototype);
    }
    function cacheResultThrough() {
        if (this._iter.cacheResult) {
            this._iter.cacheResult();
            this.size = this._iter.size;
            return this;
        } else return Seq.prototype.cacheResult.call(this);
    }
    function defaultComparator(a, b) {
        return a > b ? 1 : a < b ? -1 : 0;
    }
    function forceIterator(keyPath) {
        var iter = getIterator(keyPath);
        if (!iter) {
            // Array might not be iterable in this environment, so we need a fallback
            // to our wrapped type.
            if (!isArrayLike(keyPath)) throw new TypeError("Expected iterable or array-like: " + keyPath);
            iter = getIterator(Iterable(keyPath));
        }
        return iter;
    }
    createClass(Record, KeyedCollection);
    function Record(defaultValues, name) {
        var hasInitialized;
        var RecordType = function Record(values) {
            if (values instanceof RecordType) return values;
            if (!(this instanceof RecordType)) return new RecordType(values);
            if (!hasInitialized) {
                hasInitialized = true;
                var keys = Object.keys(defaultValues);
                setProps(RecordTypePrototype, keys);
                RecordTypePrototype.size = keys.length;
                RecordTypePrototype._name = name;
                RecordTypePrototype._keys = keys;
                RecordTypePrototype._defaultValues = defaultValues;
            }
            this._map = Map(values);
        };
        var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
        RecordTypePrototype.constructor = RecordType;
        return RecordType;
    }
    Record.prototype.toString = function() {
        return this.__toString(recordName(this) + " {", "}");
    };
    // @pragma Access
    Record.prototype.has = function(k) {
        return this._defaultValues.hasOwnProperty(k);
    };
    Record.prototype.get = function(k, notSetValue) {
        if (!this.has(k)) return notSetValue;
        var defaultVal = this._defaultValues[k];
        return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };
    // @pragma Modification
    Record.prototype.clear = function() {
        if (this.__ownerID) {
            this._map && this._map.clear();
            return this;
        }
        var RecordType = this.constructor;
        return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };
    Record.prototype.set = function(k, v) {
        if (!this.has(k)) throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
        if (this._map && !this._map.has(k)) {
            var defaultVal = this._defaultValues[k];
            if (v === defaultVal) return this;
        }
        var newMap = this._map && this._map.set(k, v);
        if (this.__ownerID || newMap === this._map) return this;
        return makeRecord(this, newMap);
    };
    Record.prototype.remove = function(k) {
        if (!this.has(k)) return this;
        var newMap = this._map && this._map.remove(k);
        if (this.__ownerID || newMap === this._map) return this;
        return makeRecord(this, newMap);
    };
    Record.prototype.wasAltered = function() {
        return this._map.wasAltered();
    };
    Record.prototype.__iterator = function(type, reverse) {
        var this$0 = this;
        return KeyedIterable(this._defaultValues).map(function(_, k) {
            return this$0.get(k);
        }).__iterator(type, reverse);
    };
    Record.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        return KeyedIterable(this._defaultValues).map(function(_, k) {
            return this$0.get(k);
        }).__iterate(fn, reverse);
    };
    Record.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map && this._map.__ensureOwner(ownerID);
        if (!ownerID) {
            this.__ownerID = ownerID;
            this._map = newMap;
            return this;
        }
        return makeRecord(this, newMap, ownerID);
    };
    var RecordPrototype = Record.prototype;
    RecordPrototype[DELETE] = RecordPrototype.remove;
    RecordPrototype.deleteIn = RecordPrototype.removeIn = MapPrototype.removeIn;
    RecordPrototype.merge = MapPrototype.merge;
    RecordPrototype.mergeWith = MapPrototype.mergeWith;
    RecordPrototype.mergeIn = MapPrototype.mergeIn;
    RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
    RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
    RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
    RecordPrototype.setIn = MapPrototype.setIn;
    RecordPrototype.update = MapPrototype.update;
    RecordPrototype.updateIn = MapPrototype.updateIn;
    RecordPrototype.withMutations = MapPrototype.withMutations;
    RecordPrototype.asMutable = MapPrototype.asMutable;
    RecordPrototype.asImmutable = MapPrototype.asImmutable;
    function makeRecord(likeRecord, map, ownerID) {
        var record = Object.create(Object.getPrototypeOf(likeRecord));
        record._map = map;
        record.__ownerID = ownerID;
        return record;
    }
    function recordName(record) {
        return record._name || record.constructor.name || "Record";
    }
    function setProps(prototype, names) {
        try {
            names.forEach(setProp.bind(undefined, prototype));
        } catch (error) {
        // Object.defineProperty failed. Probably IE8.
        }
    }
    function setProp(prototype, name) {
        Object.defineProperty(prototype, name, {
            get: function() {
                return this.get(name);
            },
            set: function(value) {
                invariant(this.__ownerID, "Cannot set on an immutable record.");
                this.set(name, value);
            }
        });
    }
    createClass(Set, SetCollection);
    // @pragma Construction
    function Set(value) {
        return value === null || value === undefined ? emptySet() : isSet(value) && !isOrdered(value) ? value : emptySet().withMutations(function(set) {
            var iter = SetIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    Set.of = function() {
        return this(arguments);
    };
    Set.fromKeys = function(value) {
        return this(KeyedIterable(value).keySeq());
    };
    Set.prototype.toString = function() {
        return this.__toString("Set {", "}");
    };
    // @pragma Access
    Set.prototype.has = function(value) {
        return this._map.has(value);
    };
    // @pragma Modification
    Set.prototype.add = function(value) {
        return updateSet(this, this._map.set(value, true));
    };
    Set.prototype.remove = function(value) {
        return updateSet(this, this._map.remove(value));
    };
    Set.prototype.clear = function() {
        return updateSet(this, this._map.clear());
    };
    // @pragma Composition
    Set.prototype.union = function() {
        var iters = SLICE$0.call(arguments, 0);
        iters = iters.filter(function(x) {
            return x.size !== 0;
        });
        if (iters.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && iters.length === 1) return this.constructor(iters[0]);
        return this.withMutations(function(set) {
            for(var ii = 0; ii < iters.length; ii++)SetIterable(iters[ii]).forEach(function(value) {
                return set.add(value);
            });
        });
    };
    Set.prototype.intersect = function() {
        var iters = SLICE$0.call(arguments, 0);
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetIterable(iter);
        });
        var originalSet = this;
        return this.withMutations(function(set) {
            originalSet.forEach(function(value) {
                if (!iters.every(function(iter) {
                    return iter.includes(value);
                })) set.remove(value);
            });
        });
    };
    Set.prototype.subtract = function() {
        var iters = SLICE$0.call(arguments, 0);
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetIterable(iter);
        });
        var originalSet = this;
        return this.withMutations(function(set) {
            originalSet.forEach(function(value) {
                if (iters.some(function(iter) {
                    return iter.includes(value);
                })) set.remove(value);
            });
        });
    };
    Set.prototype.merge = function() {
        return this.union.apply(this, arguments);
    };
    Set.prototype.mergeWith = function(merger) {
        var iters = SLICE$0.call(arguments, 1);
        return this.union.apply(this, iters);
    };
    Set.prototype.sort = function(comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator));
    };
    Set.prototype.sortBy = function(mapper, comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator, mapper));
    };
    Set.prototype.wasAltered = function() {
        return this._map.wasAltered();
    };
    Set.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        return this._map.__iterate(function(_, k) {
            return fn(k, k, this$0);
        }, reverse);
    };
    Set.prototype.__iterator = function(type, reverse) {
        return this._map.map(function(_, k) {
            return k;
        }).__iterator(type, reverse);
    };
    Set.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        if (!ownerID) {
            this.__ownerID = ownerID;
            this._map = newMap;
            return this;
        }
        return this.__make(newMap, ownerID);
    };
    function isSet(maybeSet) {
        return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
    }
    Set.isSet = isSet;
    var IS_SET_SENTINEL = "@@__IMMUTABLE_SET__@@";
    var SetPrototype = Set.prototype;
    SetPrototype[IS_SET_SENTINEL] = true;
    SetPrototype[DELETE] = SetPrototype.remove;
    SetPrototype.mergeDeep = SetPrototype.merge;
    SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
    SetPrototype.withMutations = MapPrototype.withMutations;
    SetPrototype.asMutable = MapPrototype.asMutable;
    SetPrototype.asImmutable = MapPrototype.asImmutable;
    SetPrototype.__empty = emptySet;
    SetPrototype.__make = makeSet;
    function updateSet(set, newMap) {
        if (set.__ownerID) {
            set.size = newMap.size;
            set._map = newMap;
            return set;
        }
        return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
    }
    function makeSet(map, ownerID) {
        var set = Object.create(SetPrototype);
        set.size = map ? map.size : 0;
        set._map = map;
        set.__ownerID = ownerID;
        return set;
    }
    var EMPTY_SET;
    function emptySet() {
        return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
    }
    createClass(OrderedSet, Set);
    // @pragma Construction
    function OrderedSet(value) {
        return value === null || value === undefined ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function(set) {
            var iter = SetIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    OrderedSet.of = function() {
        return this(arguments);
    };
    OrderedSet.fromKeys = function(value) {
        return this(KeyedIterable(value).keySeq());
    };
    OrderedSet.prototype.toString = function() {
        return this.__toString("OrderedSet {", "}");
    };
    function isOrderedSet(maybeOrderedSet) {
        return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
    }
    OrderedSet.isOrderedSet = isOrderedSet;
    var OrderedSetPrototype = OrderedSet.prototype;
    OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
    OrderedSetPrototype.__empty = emptyOrderedSet;
    OrderedSetPrototype.__make = makeOrderedSet;
    function makeOrderedSet(map, ownerID) {
        var set = Object.create(OrderedSetPrototype);
        set.size = map ? map.size : 0;
        set._map = map;
        set.__ownerID = ownerID;
        return set;
    }
    var EMPTY_ORDERED_SET;
    function emptyOrderedSet() {
        return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
    }
    createClass(Stack, IndexedCollection);
    // @pragma Construction
    function Stack(value) {
        return value === null || value === undefined ? emptyStack() : isStack(value) ? value : emptyStack().unshiftAll(value);
    }
    Stack.of = function() {
        return this(arguments);
    };
    Stack.prototype.toString = function() {
        return this.__toString("Stack [", "]");
    };
    // @pragma Access
    Stack.prototype.get = function(index, notSetValue) {
        var head = this._head;
        index = wrapIndex(this, index);
        while(head && index--)head = head.next;
        return head ? head.value : notSetValue;
    };
    Stack.prototype.peek = function() {
        return this._head && this._head.value;
    };
    // @pragma Modification
    Stack.prototype.push = function() {
        if (arguments.length === 0) return this;
        var newSize = this.size + arguments.length;
        var head = this._head;
        for(var ii = arguments.length - 1; ii >= 0; ii--)head = {
            value: arguments[ii],
            next: head
        };
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pushAll = function(iter) {
        iter = IndexedIterable(iter);
        if (iter.size === 0) return this;
        assertNotInfinite(iter.size);
        var newSize = this.size;
        var head = this._head;
        iter.reverse().forEach(function(value) {
            newSize++;
            head = {
                value: value,
                next: head
            };
        });
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pop = function() {
        return this.slice(1);
    };
    Stack.prototype.unshift = function() {
        return this.push.apply(this, arguments);
    };
    Stack.prototype.unshiftAll = function(iter) {
        return this.pushAll(iter);
    };
    Stack.prototype.shift = function() {
        return this.pop.apply(this, arguments);
    };
    Stack.prototype.clear = function() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._head = undefined;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyStack();
    };
    Stack.prototype.slice = function(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        var resolvedBegin = resolveBegin(begin, this.size);
        var resolvedEnd = resolveEnd(end, this.size);
        if (resolvedEnd !== this.size) // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
        var newSize = this.size - resolvedBegin;
        var head = this._head;
        while(resolvedBegin--)head = head.next;
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    // @pragma Mutability
    Stack.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeStack(this.size, this._head, ownerID, this.__hash);
    };
    // @pragma Iteration
    Stack.prototype.__iterate = function(fn, reverse) {
        if (reverse) return this.reverse().__iterate(fn);
        var iterations = 0;
        var node = this._head;
        while(node){
            if (fn(node.value, iterations++, this) === false) break;
            node = node.next;
        }
        return iterations;
    };
    Stack.prototype.__iterator = function(type, reverse) {
        if (reverse) return this.reverse().__iterator(type);
        var iterations = 0;
        var node = this._head;
        return new Iterator(function() {
            if (node) {
                var value = node.value;
                node = node.next;
                return iteratorValue(type, iterations++, value);
            }
            return iteratorDone();
        });
    };
    function isStack(maybeStack) {
        return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
    }
    Stack.isStack = isStack;
    var IS_STACK_SENTINEL = "@@__IMMUTABLE_STACK__@@";
    var StackPrototype = Stack.prototype;
    StackPrototype[IS_STACK_SENTINEL] = true;
    StackPrototype.withMutations = MapPrototype.withMutations;
    StackPrototype.asMutable = MapPrototype.asMutable;
    StackPrototype.asImmutable = MapPrototype.asImmutable;
    StackPrototype.wasAltered = MapPrototype.wasAltered;
    function makeStack(size, head, ownerID, hash) {
        var map = Object.create(StackPrototype);
        map.size = size;
        map._head = head;
        map.__ownerID = ownerID;
        map.__hash = hash;
        map.__altered = false;
        return map;
    }
    var EMPTY_STACK;
    function emptyStack() {
        return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
    }
    /**
   * Contributes additional methods to a constructor
   */ function mixin(ctor, methods) {
        var keyCopier = function(key) {
            ctor.prototype[key] = methods[key];
        };
        Object.keys(methods).forEach(keyCopier);
        Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
        return ctor;
    }
    Iterable.Iterator = Iterator;
    mixin(Iterable, {
        // ### Conversion to other types
        toArray: function() {
            assertNotInfinite(this.size);
            var array = new Array(this.size || 0);
            this.valueSeq().__iterate(function(v, i) {
                array[i] = v;
            });
            return array;
        },
        toIndexedSeq: function() {
            return new ToIndexedSequence(this);
        },
        toJS: function() {
            return this.toSeq().map(function(value) {
                return value && typeof value.toJS === "function" ? value.toJS() : value;
            }).__toJS();
        },
        toJSON: function() {
            return this.toSeq().map(function(value) {
                return value && typeof value.toJSON === "function" ? value.toJSON() : value;
            }).__toJS();
        },
        toKeyedSeq: function() {
            return new ToKeyedSequence(this, true);
        },
        toMap: function() {
            // Use Late Binding here to solve the circular dependency.
            return Map(this.toKeyedSeq());
        },
        toObject: function() {
            assertNotInfinite(this.size);
            var object = {};
            this.__iterate(function(v, k) {
                object[k] = v;
            });
            return object;
        },
        toOrderedMap: function() {
            // Use Late Binding here to solve the circular dependency.
            return OrderedMap(this.toKeyedSeq());
        },
        toOrderedSet: function() {
            // Use Late Binding here to solve the circular dependency.
            return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
        },
        toSet: function() {
            // Use Late Binding here to solve the circular dependency.
            return Set(isKeyed(this) ? this.valueSeq() : this);
        },
        toSetSeq: function() {
            return new ToSetSequence(this);
        },
        toSeq: function() {
            return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
        },
        toStack: function() {
            // Use Late Binding here to solve the circular dependency.
            return Stack(isKeyed(this) ? this.valueSeq() : this);
        },
        toList: function() {
            // Use Late Binding here to solve the circular dependency.
            return List(isKeyed(this) ? this.valueSeq() : this);
        },
        // ### Common JavaScript methods and properties
        toString: function() {
            return "[Iterable]";
        },
        __toString: function(head, tail) {
            if (this.size === 0) return head + tail;
            return head + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + tail;
        },
        // ### ES6 Collection methods (ES6 Array and Map)
        concat: function() {
            var values = SLICE$0.call(arguments, 0);
            return reify(this, concatFactory(this, values));
        },
        includes: function(searchValue) {
            return this.some(function(value) {
                return is(value, searchValue);
            });
        },
        entries: function() {
            return this.__iterator(ITERATE_ENTRIES);
        },
        every: function(predicate, context) {
            assertNotInfinite(this.size);
            var returnValue = true;
            this.__iterate(function(v, k, c) {
                if (!predicate.call(context, v, k, c)) {
                    returnValue = false;
                    return false;
                }
            });
            return returnValue;
        },
        filter: function(predicate, context) {
            return reify(this, filterFactory(this, predicate, context, true));
        },
        find: function(predicate, context, notSetValue) {
            var entry = this.findEntry(predicate, context);
            return entry ? entry[1] : notSetValue;
        },
        forEach: function(sideEffect, context) {
            assertNotInfinite(this.size);
            return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
        },
        join: function(separator) {
            assertNotInfinite(this.size);
            separator = separator !== undefined ? "" + separator : ",";
            var joined = "";
            var isFirst = true;
            this.__iterate(function(v) {
                isFirst ? isFirst = false : joined += separator;
                joined += v !== null && v !== undefined ? v.toString() : "";
            });
            return joined;
        },
        keys: function() {
            return this.__iterator(ITERATE_KEYS);
        },
        map: function(mapper, context) {
            return reify(this, mapFactory(this, mapper, context));
        },
        reduce: function(reducer, initialReduction, context) {
            assertNotInfinite(this.size);
            var reduction;
            var useFirst;
            if (arguments.length < 2) useFirst = true;
            else reduction = initialReduction;
            this.__iterate(function(v, k, c) {
                if (useFirst) {
                    useFirst = false;
                    reduction = v;
                } else reduction = reducer.call(context, reduction, v, k, c);
            });
            return reduction;
        },
        reduceRight: function(reducer, initialReduction, context) {
            var reversed = this.toKeyedSeq().reverse();
            return reversed.reduce.apply(reversed, arguments);
        },
        reverse: function() {
            return reify(this, reverseFactory(this, true));
        },
        slice: function(begin, end) {
            return reify(this, sliceFactory(this, begin, end, true));
        },
        some: function(predicate, context) {
            return !this.every(not(predicate), context);
        },
        sort: function(comparator) {
            return reify(this, sortFactory(this, comparator));
        },
        values: function() {
            return this.__iterator(ITERATE_VALUES);
        },
        // ### More sequential methods
        butLast: function() {
            return this.slice(0, -1);
        },
        isEmpty: function() {
            return this.size !== undefined ? this.size === 0 : !this.some(function() {
                return true;
            });
        },
        count: function(predicate, context) {
            return ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
        },
        countBy: function(grouper, context) {
            return countByFactory(this, grouper, context);
        },
        equals: function(other) {
            return deepEqual(this, other);
        },
        entrySeq: function() {
            var iterable = this;
            if (iterable._cache) // We cache as an entries array, so we can just return the cache!
            return new ArraySeq(iterable._cache);
            var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
            entriesSequence.fromEntrySeq = function() {
                return iterable.toSeq();
            };
            return entriesSequence;
        },
        filterNot: function(predicate, context) {
            return this.filter(not(predicate), context);
        },
        findEntry: function(predicate, context, notSetValue) {
            var found = notSetValue;
            this.__iterate(function(v, k, c) {
                if (predicate.call(context, v, k, c)) {
                    found = [
                        k,
                        v
                    ];
                    return false;
                }
            });
            return found;
        },
        findKey: function(predicate, context) {
            var entry = this.findEntry(predicate, context);
            return entry && entry[0];
        },
        findLast: function(predicate, context, notSetValue) {
            return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
        },
        findLastEntry: function(predicate, context, notSetValue) {
            return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
        },
        findLastKey: function(predicate, context) {
            return this.toKeyedSeq().reverse().findKey(predicate, context);
        },
        first: function() {
            return this.find(returnTrue);
        },
        flatMap: function(mapper, context) {
            return reify(this, flatMapFactory(this, mapper, context));
        },
        flatten: function(depth) {
            return reify(this, flattenFactory(this, depth, true));
        },
        fromEntrySeq: function() {
            return new FromEntriesSequence(this);
        },
        get: function(searchKey, notSetValue) {
            return this.find(function(_, key) {
                return is(key, searchKey);
            }, undefined, notSetValue);
        },
        getIn: function(searchKeyPath, notSetValue) {
            var nested = this;
            // Note: in an ES6 environment, we would prefer:
            // for (var key of searchKeyPath) {
            var iter = forceIterator(searchKeyPath);
            var step;
            while(!(step = iter.next()).done){
                var key = step.value;
                nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
                if (nested === NOT_SET) return notSetValue;
            }
            return nested;
        },
        groupBy: function(grouper, context) {
            return groupByFactory(this, grouper, context);
        },
        has: function(searchKey) {
            return this.get(searchKey, NOT_SET) !== NOT_SET;
        },
        hasIn: function(searchKeyPath) {
            return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
        },
        isSubset: function(iter) {
            iter = typeof iter.includes === "function" ? iter : Iterable(iter);
            return this.every(function(value) {
                return iter.includes(value);
            });
        },
        isSuperset: function(iter) {
            iter = typeof iter.isSubset === "function" ? iter : Iterable(iter);
            return iter.isSubset(this);
        },
        keyOf: function(searchValue) {
            return this.findKey(function(value) {
                return is(value, searchValue);
            });
        },
        keySeq: function() {
            return this.toSeq().map(keyMapper).toIndexedSeq();
        },
        last: function() {
            return this.toSeq().reverse().first();
        },
        lastKeyOf: function(searchValue) {
            return this.toKeyedSeq().reverse().keyOf(searchValue);
        },
        max: function(comparator) {
            return maxFactory(this, comparator);
        },
        maxBy: function(mapper, comparator) {
            return maxFactory(this, comparator, mapper);
        },
        min: function(comparator) {
            return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
        },
        minBy: function(mapper, comparator) {
            return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
        },
        rest: function() {
            return this.slice(1);
        },
        skip: function(amount) {
            return this.slice(Math.max(0, amount));
        },
        skipLast: function(amount) {
            return reify(this, this.toSeq().reverse().skip(amount).reverse());
        },
        skipWhile: function(predicate, context) {
            return reify(this, skipWhileFactory(this, predicate, context, true));
        },
        skipUntil: function(predicate, context) {
            return this.skipWhile(not(predicate), context);
        },
        sortBy: function(mapper, comparator) {
            return reify(this, sortFactory(this, comparator, mapper));
        },
        take: function(amount) {
            return this.slice(0, Math.max(0, amount));
        },
        takeLast: function(amount) {
            return reify(this, this.toSeq().reverse().take(amount).reverse());
        },
        takeWhile: function(predicate, context) {
            return reify(this, takeWhileFactory(this, predicate, context));
        },
        takeUntil: function(predicate, context) {
            return this.takeWhile(not(predicate), context);
        },
        valueSeq: function() {
            return this.toIndexedSeq();
        },
        // ### Hashable Object
        hashCode: function() {
            return this.__hash || (this.__hash = hashIterable(this));
        }
    });
    // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
    // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
    // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
    // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
    var IterablePrototype = Iterable.prototype;
    IterablePrototype[IS_ITERABLE_SENTINEL] = true;
    IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
    IterablePrototype.__toJS = IterablePrototype.toArray;
    IterablePrototype.__toStringMapper = quoteString;
    IterablePrototype.inspect = IterablePrototype.toSource = function() {
        return this.toString();
    };
    IterablePrototype.chain = IterablePrototype.flatMap;
    IterablePrototype.contains = IterablePrototype.includes;
    mixin(KeyedIterable, {
        // ### More sequential methods
        flip: function() {
            return reify(this, flipFactory(this));
        },
        mapEntries: function(mapper, context) {
            var this$0 = this;
            var iterations = 0;
            return reify(this, this.toSeq().map(function(v, k) {
                return mapper.call(context, [
                    k,
                    v
                ], iterations++, this$0);
            }).fromEntrySeq());
        },
        mapKeys: function(mapper, context) {
            var this$0 = this;
            return reify(this, this.toSeq().flip().map(function(k, v) {
                return mapper.call(context, k, v, this$0);
            }).flip());
        }
    });
    var KeyedIterablePrototype = KeyedIterable.prototype;
    KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
    KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
    KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
    KeyedIterablePrototype.__toStringMapper = function(v, k) {
        return JSON.stringify(k) + ": " + quoteString(v);
    };
    mixin(IndexedIterable, {
        // ### Conversion to other types
        toKeyedSeq: function() {
            return new ToKeyedSequence(this, false);
        },
        // ### ES6 Collection methods (ES6 Array and Map)
        filter: function(predicate, context) {
            return reify(this, filterFactory(this, predicate, context, false));
        },
        findIndex: function(predicate, context) {
            var entry = this.findEntry(predicate, context);
            return entry ? entry[0] : -1;
        },
        indexOf: function(searchValue) {
            var key = this.keyOf(searchValue);
            return key === undefined ? -1 : key;
        },
        lastIndexOf: function(searchValue) {
            var key = this.lastKeyOf(searchValue);
            return key === undefined ? -1 : key;
        },
        reverse: function() {
            return reify(this, reverseFactory(this, false));
        },
        slice: function(begin, end) {
            return reify(this, sliceFactory(this, begin, end, false));
        },
        splice: function(index, removeNum /*, ...values*/ ) {
            var numArgs = arguments.length;
            removeNum = Math.max(removeNum | 0, 0);
            if (numArgs === 0 || numArgs === 2 && !removeNum) return this;
            // If index is negative, it should resolve relative to the size of the
            // collection. However size may be expensive to compute if not cached, so
            // only call count() if the number is in fact negative.
            index = resolveBegin(index, index < 0 ? this.count() : this.size);
            var spliced = this.slice(0, index);
            return reify(this, numArgs === 1 ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum)));
        },
        // ### More collection methods
        findLastIndex: function(predicate, context) {
            var entry = this.findLastEntry(predicate, context);
            return entry ? entry[0] : -1;
        },
        first: function() {
            return this.get(0);
        },
        flatten: function(depth) {
            return reify(this, flattenFactory(this, depth, false));
        },
        get: function(index, notSetValue) {
            index = wrapIndex(this, index);
            return index < 0 || this.size === Infinity || this.size !== undefined && index > this.size ? notSetValue : this.find(function(_, key) {
                return key === index;
            }, undefined, notSetValue);
        },
        has: function(index) {
            index = wrapIndex(this, index);
            return index >= 0 && (this.size !== undefined ? this.size === Infinity || index < this.size : this.indexOf(index) !== -1);
        },
        interpose: function(separator) {
            return reify(this, interposeFactory(this, separator));
        },
        interleave: function() {
            var iterables = [
                this
            ].concat(arrCopy(arguments));
            var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
            var interleaved = zipped.flatten(true);
            if (zipped.size) interleaved.size = zipped.size * iterables.length;
            return reify(this, interleaved);
        },
        keySeq: function() {
            return Range(0, this.size);
        },
        last: function() {
            return this.get(-1);
        },
        skipWhile: function(predicate, context) {
            return reify(this, skipWhileFactory(this, predicate, context, false));
        },
        zip: function() {
            var iterables = [
                this
            ].concat(arrCopy(arguments));
            return reify(this, zipWithFactory(this, defaultZipper, iterables));
        },
        zipWith: function(zipper /*, ...iterables */ ) {
            var iterables = arrCopy(arguments);
            iterables[0] = this;
            return reify(this, zipWithFactory(this, zipper, iterables));
        }
    });
    IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
    IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
    mixin(SetIterable, {
        // ### ES6 Collection methods (ES6 Array and Map)
        get: function(value, notSetValue) {
            return this.has(value) ? value : notSetValue;
        },
        includes: function(value) {
            return this.has(value);
        },
        // ### More sequential methods
        keySeq: function() {
            return this.valueSeq();
        }
    });
    SetIterable.prototype.has = IterablePrototype.includes;
    SetIterable.prototype.contains = SetIterable.prototype.includes;
    // Mixin subclasses
    mixin(KeyedSeq, KeyedIterable.prototype);
    mixin(IndexedSeq, IndexedIterable.prototype);
    mixin(SetSeq, SetIterable.prototype);
    mixin(KeyedCollection, KeyedIterable.prototype);
    mixin(IndexedCollection, IndexedIterable.prototype);
    mixin(SetCollection, SetIterable.prototype);
    // #pragma Helper functions
    function keyMapper(v, k) {
        return k;
    }
    function entryMapper(v, k) {
        return [
            k,
            v
        ];
    }
    function not(predicate) {
        return function() {
            return !predicate.apply(this, arguments);
        };
    }
    function neg(predicate) {
        return function() {
            return -predicate.apply(this, arguments);
        };
    }
    function quoteString(value) {
        return typeof value === "string" ? JSON.stringify(value) : String(value);
    }
    function defaultZipper() {
        return arrCopy(arguments);
    }
    function defaultNegComparator(a, b) {
        return a < b ? 1 : a > b ? -1 : 0;
    }
    function hashIterable(iterable) {
        if (iterable.size === Infinity) return 0;
        var ordered = isOrdered(iterable);
        var keyed = isKeyed(iterable);
        var h = ordered ? 1 : 0;
        var size = iterable.__iterate(keyed ? ordered ? function(v, k) {
            h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
        } : function(v, k) {
            h = h + hashMerge(hash(v), hash(k)) | 0;
        } : ordered ? function(v) {
            h = 31 * h + hash(v) | 0;
        } : function(v) {
            h = h + hash(v) | 0;
        });
        return murmurHashOfSize(size, h);
    }
    function murmurHashOfSize(size, h) {
        h = imul(h, 0xCC9E2D51);
        h = imul(h << 15 | h >>> -15, 0x1B873593);
        h = imul(h << 13 | h >>> -13, 5);
        h = (h + 0xE6546B64 | 0) ^ size;
        h = imul(h ^ h >>> 16, 0x85EBCA6B);
        h = imul(h ^ h >>> 13, 0xC2B2AE35);
        h = smi(h ^ h >>> 16);
        return h;
    }
    function hashMerge(a, b) {
        return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
    }
    var Immutable = {
        Iterable: Iterable,
        Seq: Seq,
        Collection: Collection,
        Map: Map,
        OrderedMap: OrderedMap,
        List: List,
        Stack: Stack,
        Set: Set,
        OrderedSet: OrderedSet,
        Record: Record,
        Range: Range,
        Repeat: Repeat,
        is: is,
        fromJS: fromJS
    };
    return Immutable;
});

});


parcelRegister("5oOSJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ee6a9adbefd87f8$export$2e2bcd8739ae039; });

var $9mJZ7 = parcelRequire("9mJZ7");
var $3ee6a9adbefd87f8$var$createIsValid = function createIsValid(structure) {
    var getIn = structure.getIn, keys = structure.keys;
    var hasError = (0, $9mJZ7.default)(structure);
    return function(form, getFormState, ignoreSubmitErrors) {
        if (ignoreSubmitErrors === void 0) ignoreSubmitErrors = false;
        return function(state) {
            var nonNullGetFormState = getFormState || function(state) {
                return getIn(state, "form");
            };
            var formState = nonNullGetFormState(state);
            var syncError = getIn(formState, form + ".syncError");
            if (syncError) return false;
            if (!ignoreSubmitErrors) {
                var error = getIn(formState, form + ".error");
                if (error) return false;
            }
            var syncErrors = getIn(formState, form + ".syncErrors");
            var asyncErrors = getIn(formState, form + ".asyncErrors");
            var submitErrors = ignoreSubmitErrors ? undefined : getIn(formState, form + ".submitErrors");
            if (!syncErrors && !asyncErrors && !submitErrors) return true;
            var registeredFields = getIn(formState, form + ".registeredFields");
            if (!registeredFields) return true;
            return !keys(registeredFields).filter(function(name) {
                return getIn(registeredFields, "['" + name + "'].count") > 0;
            }).some(function(name) {
                return hasError(getIn(registeredFields, "['" + name + "']"), syncErrors, asyncErrors, submitErrors);
            });
        };
    };
};
var $3ee6a9adbefd87f8$export$2e2bcd8739ae039 = $3ee6a9adbefd87f8$var$createIsValid;

});
parcelRegister("9mJZ7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d19d6ba126b17d4$export$2e2bcd8739ae039; });
var $6d19d6ba126b17d4$var$getErrorKeys = function getErrorKeys(name, type) {
    switch(type){
        case "Field":
            return [
                name,
                name + "._error"
            ];
        case "FieldArray":
            return [
                name + "._error"
            ];
        default:
            throw new Error("Unknown field type");
    }
};
var $6d19d6ba126b17d4$var$createHasError = function createHasError(_ref) {
    var getIn = _ref.getIn;
    var hasError = function hasError(field, syncErrors, asyncErrors, submitErrors) {
        if (!syncErrors && !asyncErrors && !submitErrors) return false;
        var name = getIn(field, "name");
        var type = getIn(field, "type");
        return $6d19d6ba126b17d4$var$getErrorKeys(name, type).some(function(key) {
            return getIn(syncErrors, key) || getIn(asyncErrors, key) || getIn(submitErrors, key);
        });
    };
    return hasError;
};
var $6d19d6ba126b17d4$export$2e2bcd8739ae039 = $6d19d6ba126b17d4$var$createHasError;

});


parcelRegister("fmjGQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2e82f227ac8b696$export$2e2bcd8739ae039; });
var $b2e82f227ac8b696$var$getDisplayName = function getDisplayName(Comp) {
    return Comp.displayName || Comp.name || "Component";
};
var $b2e82f227ac8b696$export$2e2bcd8739ae039 = $b2e82f227ac8b696$var$getDisplayName;

});

parcelRegister("kRXsl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f316e0a89af13a3e$export$2e2bcd8739ae039; });
var isHotReloading = function isHotReloading() {
    var castModule = module;
    return !!(typeof castModule !== "undefined" && castModule.hot && typeof castModule.hot.status === "function" && castModule.hot.status() === "apply");
};
var $f316e0a89af13a3e$export$2e2bcd8739ae039 = isHotReloading;

});



parcelRegister("8JyOg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65bd8729e924ea83$export$2e2bcd8739ae039; });

var $7Btkr = parcelRequire("7Btkr");

var $hdOPR = parcelRequire("hdOPR");
var $65bd8729e924ea83$export$2e2bcd8739ae039 = (0, $7Btkr.default)((0, $hdOPR.default));

});
parcelRegister("7Btkr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5892bd32df2a2137$export$2e2bcd8739ae039; });

var $j7eBO = parcelRequire("j7eBO");

var $ikNgc = parcelRequire("ikNgc");

var $avrKI = parcelRequire("avrKI");

var $6iihU = parcelRequire("6iihU");

var $hdOPR = parcelRequire("hdOPR");
var $5892bd32df2a2137$var$shouldDelete = function shouldDelete(_ref) {
    var getIn = _ref.getIn;
    return function(state, path) {
        var initialValuesPath = null;
        if (/^values/.test(path)) initialValuesPath = path.replace("values", "initial");
        var initialValueComparison = initialValuesPath ? getIn(state, initialValuesPath) === undefined : true;
        return getIn(state, path) !== undefined && initialValueComparison;
    };
};
var $5892bd32df2a2137$var$isReduxFormAction = function isReduxFormAction(action) {
    return action && action.type && action.type.length > (0, $avrKI.prefix).length && action.type.substring(0, (0, $avrKI.prefix).length) === (0, $avrKI.prefix);
};
function $5892bd32df2a2137$var$createReducer(structure) {
    var _behaviors;
    var deepEqual = structure.deepEqual, empty = structure.empty, forEach = structure.forEach, getIn = structure.getIn, setIn = structure.setIn, deleteIn = structure.deleteIn, fromJS = structure.fromJS, keys = structure.keys, size = structure.size, some = structure.some, splice = structure.splice;
    var deleteInWithCleanUp = (0, $6iihU.default)(structure)($5892bd32df2a2137$var$shouldDelete);
    var plainDeleteInWithCleanUp = (0, $6iihU.default)((0, $hdOPR.default))($5892bd32df2a2137$var$shouldDelete);
    var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
        var existing = getIn(state, key + "." + field);
        return existing || force ? setIn(state, key + "." + field, splice(existing, index, removeNum, value)) : state;
    };
    var doPlainSplice = function doPlainSplice(state, key, field, index, removeNum, value, force) {
        var slice = getIn(state, key);
        var existing = (0, $hdOPR.default).getIn(slice, field);
        return existing || force ? setIn(state, key, (0, $hdOPR.default).setIn(slice, field, (0, $hdOPR.default).splice(existing, index, removeNum, value))) : state;
    };
    var rootKeys = [
        "values",
        "fields",
        "submitErrors",
        "asyncErrors"
    ];
    var arraySplice = function arraySplice(state, field, index, removeNum, value) {
        var result = state;
        var nonValuesValue = value != null ? empty : undefined;
        result = doSplice(result, "values", field, index, removeNum, value, true);
        result = doSplice(result, "fields", field, index, removeNum, nonValuesValue);
        result = doPlainSplice(result, "syncErrors", field, index, removeNum, undefined);
        result = doPlainSplice(result, "syncWarnings", field, index, removeNum, undefined);
        result = doSplice(result, "submitErrors", field, index, removeNum, undefined);
        result = doSplice(result, "asyncErrors", field, index, removeNum, undefined);
        return result;
    };
    var behaviors = (_behaviors = {}, _behaviors[0, $avrKI.ARRAY_INSERT] = function(state, _ref2) {
        var _ref2$meta = _ref2.meta, field = _ref2$meta.field, index = _ref2$meta.index, payload = _ref2.payload;
        return arraySplice(state, field, index, 0, payload);
    }, _behaviors[0, $avrKI.ARRAY_MOVE] = function(state, _ref3) {
        var _ref3$meta = _ref3.meta, field = _ref3$meta.field, from = _ref3$meta.from, to = _ref3$meta.to;
        var array = getIn(state, "values." + field);
        var length = array ? size(array) : 0;
        var result = state;
        if (length) rootKeys.forEach(function(key) {
            var path = key + "." + field;
            if (getIn(result, path)) {
                var value = getIn(result, path + "[" + from + "]");
                result = setIn(result, path, splice(getIn(result, path), from, 1)); // remove
                result = setIn(result, path, splice(getIn(result, path), to, 0, value)); // insert
            }
        });
        return result;
    }, _behaviors[0, $avrKI.ARRAY_POP] = function(state, _ref4) {
        var field = _ref4.meta.field;
        var array = getIn(state, "values." + field);
        var length = array ? size(array) : 0;
        return length ? arraySplice(state, field, length - 1, 1) : state;
    }, _behaviors[0, $avrKI.ARRAY_PUSH] = function(state, _ref5) {
        var field = _ref5.meta.field, payload = _ref5.payload;
        var array = getIn(state, "values." + field);
        var length = array ? size(array) : 0;
        return arraySplice(state, field, length, 0, payload);
    }, _behaviors[0, $avrKI.ARRAY_REMOVE] = function(state, _ref6) {
        var _ref6$meta = _ref6.meta, field = _ref6$meta.field, index = _ref6$meta.index;
        return arraySplice(state, field, index, 1);
    }, _behaviors[0, $avrKI.ARRAY_REMOVE_ALL] = function(state, _ref7) {
        var field = _ref7.meta.field;
        var array = getIn(state, "values." + field);
        var length = array ? size(array) : 0;
        return length ? arraySplice(state, field, 0, length) : state;
    }, _behaviors[0, $avrKI.ARRAY_SHIFT] = function(state, _ref8) {
        var field = _ref8.meta.field;
        return arraySplice(state, field, 0, 1);
    }, _behaviors[0, $avrKI.ARRAY_SPLICE] = function(state, _ref9) {
        var _ref9$meta = _ref9.meta, field = _ref9$meta.field, index = _ref9$meta.index, removeNum = _ref9$meta.removeNum, payload = _ref9.payload;
        return arraySplice(state, field, index, removeNum, payload);
    }, _behaviors[0, $avrKI.ARRAY_SWAP] = function(state, _ref10) {
        var _ref10$meta = _ref10.meta, field = _ref10$meta.field, indexA = _ref10$meta.indexA, indexB = _ref10$meta.indexB;
        var result = state;
        rootKeys.forEach(function(key) {
            var valueA = getIn(result, key + "." + field + "[" + indexA + "]");
            var valueB = getIn(result, key + "." + field + "[" + indexB + "]");
            if (valueA !== undefined || valueB !== undefined) {
                result = setIn(result, key + "." + field + "[" + indexA + "]", valueB);
                result = setIn(result, key + "." + field + "[" + indexB + "]", valueA);
            }
        });
        return result;
    }, _behaviors[0, $avrKI.ARRAY_UNSHIFT] = function(state, _ref11) {
        var field = _ref11.meta.field, payload = _ref11.payload;
        return arraySplice(state, field, 0, 0, payload);
    }, _behaviors[0, $avrKI.AUTOFILL] = function(state, _ref12) {
        var field = _ref12.meta.field, payload = _ref12.payload;
        var result = state;
        result = deleteInWithCleanUp(result, "asyncErrors." + field);
        result = deleteInWithCleanUp(result, "submitErrors." + field);
        result = setIn(result, "fields." + field + ".autofilled", true);
        result = setIn(result, "values." + field, payload);
        return result;
    }, _behaviors[0, $avrKI.BLUR] = function(state, _ref13) {
        var _ref13$meta = _ref13.meta, field = _ref13$meta.field, touch = _ref13$meta.touch, payload = _ref13.payload;
        var result = state;
        var initial = getIn(result, "initial." + field);
        if (initial === undefined && payload === "") result = deleteInWithCleanUp(result, "values." + field);
        else if (payload !== undefined) result = setIn(result, "values." + field, payload);
        if (field === getIn(result, "active")) result = deleteIn(result, "active");
        result = deleteIn(result, "fields." + field + ".active");
        if (touch) {
            result = setIn(result, "fields." + field + ".touched", true);
            result = setIn(result, "anyTouched", true);
        }
        return result;
    }, _behaviors[0, $avrKI.CHANGE] = function(state, _ref14) {
        var _ref14$meta = _ref14.meta, field = _ref14$meta.field, touch = _ref14$meta.touch, persistentSubmitErrors = _ref14$meta.persistentSubmitErrors, payload = _ref14.payload;
        var result = state;
        var initial = getIn(result, "initial." + field);
        if (initial === undefined && payload === "" || payload === undefined) result = deleteInWithCleanUp(result, "values." + field);
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($ikNgc)))(payload)) {
            var fieldCurrentValue = getIn(state, "values." + field);
            result = setIn(result, "values." + field, payload(fieldCurrentValue, state.values));
        } else result = setIn(result, "values." + field, payload);
        result = deleteInWithCleanUp(result, "asyncErrors." + field);
        if (!persistentSubmitErrors) result = deleteInWithCleanUp(result, "submitErrors." + field);
        result = deleteInWithCleanUp(result, "fields." + field + ".autofilled");
        if (touch) {
            result = setIn(result, "fields." + field + ".touched", true);
            result = setIn(result, "anyTouched", true);
        }
        return result;
    }, _behaviors[0, $avrKI.CLEAR_SUBMIT] = function(state) {
        return deleteIn(state, "triggerSubmit");
    }, _behaviors[0, $avrKI.CLEAR_SUBMIT_ERRORS] = function(state) {
        var result = state;
        result = deleteInWithCleanUp(result, "submitErrors");
        result = deleteIn(result, "error");
        return result;
    }, _behaviors[0, $avrKI.CLEAR_ASYNC_ERROR] = function(state, _ref15) {
        var field = _ref15.meta.field;
        return deleteIn(state, "asyncErrors." + field);
    }, _behaviors[0, $avrKI.CLEAR_FIELDS] = function(state, _ref16) {
        var _ref16$meta = _ref16.meta, keepTouched = _ref16$meta.keepTouched, persistentSubmitErrors = _ref16$meta.persistentSubmitErrors, fields = _ref16$meta.fields;
        var result = state;
        fields.forEach(function(field) {
            result = deleteInWithCleanUp(result, "values." + field);
            result = deleteInWithCleanUp(result, "asyncErrors." + field);
            if (!persistentSubmitErrors) result = deleteInWithCleanUp(result, "submitErrors." + field);
            result = deleteInWithCleanUp(result, "fields." + field + ".autofilled");
            if (!keepTouched) result = deleteIn(result, "fields." + field + ".touched");
        });
        var anyTouched = some(keys(getIn(result, "registeredFields")), function(key) {
            return getIn(result, "fields." + key + ".touched");
        });
        result = anyTouched ? setIn(result, "anyTouched", true) : deleteIn(result, "anyTouched");
        return result;
    }, _behaviors[0, $avrKI.FOCUS] = function(state, _ref17) {
        var field = _ref17.meta.field;
        var result = state;
        var previouslyActive = getIn(state, "active");
        result = deleteIn(result, "fields." + previouslyActive + ".active");
        result = setIn(result, "fields." + field + ".visited", true);
        result = setIn(result, "fields." + field + ".active", true);
        result = setIn(result, "active", field);
        return result;
    }, _behaviors[0, $avrKI.INITIALIZE] = function(state, _ref18) {
        var payload = _ref18.payload, _ref18$meta = _ref18.meta, keepDirty = _ref18$meta.keepDirty, keepSubmitSucceeded = _ref18$meta.keepSubmitSucceeded, updateUnregisteredFields = _ref18$meta.updateUnregisteredFields, keepValues = _ref18$meta.keepValues;
        var mapData = fromJS(payload);
        var result = empty; // clean all field state
        // persist old warnings, they will get recalculated if the new form values are different from the old values
        var warning = getIn(state, "warning");
        if (warning) result = setIn(result, "warning", warning);
        var syncWarnings = getIn(state, "syncWarnings");
        if (syncWarnings) result = setIn(result, "syncWarnings", syncWarnings);
         // persist old errors, they will get recalculated if the new form values are different from the old values
        var error = getIn(state, "error");
        if (error) result = setIn(result, "error", error);
        var syncErrors = getIn(state, "syncErrors");
        if (syncErrors) result = setIn(result, "syncErrors", syncErrors);
        var registeredFields = getIn(state, "registeredFields");
        if (registeredFields) result = setIn(result, "registeredFields", registeredFields);
        var previousValues = getIn(state, "values");
        var previousInitialValues = getIn(state, "initial");
        var newInitialValues = mapData;
        var newValues = previousValues;
        if (keepDirty && registeredFields) {
            if (!deepEqual(newInitialValues, previousInitialValues)) {
                //
                // Keep the value of dirty fields while updating the value of
                // pristine fields. This way, apps can reinitialize forms while
                // avoiding stomping on user edits.
                //
                // Note 1: The initialize action replaces all initial values
                // regardless of keepDirty.
                //
                // Note 2: When a field is dirty, keepDirty is enabled, and the field
                // value is the same as the new initial value for the field, the
                // initialize action causes the field to become pristine. That effect
                // is what we want.
                //
                var overwritePristineValue = function overwritePristineValue(name) {
                    var previousInitialValue = getIn(previousInitialValues, name);
                    var previousValue = getIn(previousValues, name);
                    if (deepEqual(previousValue, previousInitialValue)) {
                        // Overwrite the old pristine value with the new pristine value
                        var newInitialValue = getIn(newInitialValues, name); // This check prevents any 'setIn' call that would create useless
                        // nested objects, since the path to the new field value would
                        // evaluate to the same (especially for undefined values)
                        if (getIn(newValues, name) !== newInitialValue) newValues = setIn(newValues, name, newInitialValue);
                    }
                };
                if (!updateUnregisteredFields) forEach(keys(registeredFields), function(name) {
                    return overwritePristineValue(name);
                });
                forEach(keys(newInitialValues), function(name) {
                    var previousInitialValue = getIn(previousInitialValues, name);
                    if (typeof previousInitialValue === "undefined") {
                        // Add new values at the root level.
                        var newInitialValue = getIn(newInitialValues, name);
                        newValues = setIn(newValues, name, newInitialValue);
                    }
                    if (updateUnregisteredFields) overwritePristineValue(name);
                });
            }
        } else newValues = newInitialValues;
        if (keepValues) {
            forEach(keys(previousValues), function(name) {
                var previousValue = getIn(previousValues, name);
                newValues = setIn(newValues, name, previousValue);
            });
            forEach(keys(previousInitialValues), function(name) {
                var previousInitialValue = getIn(previousInitialValues, name);
                newInitialValues = setIn(newInitialValues, name, previousInitialValue);
            });
        }
        if (keepSubmitSucceeded && getIn(state, "submitSucceeded")) result = setIn(result, "submitSucceeded", true);
        result = setIn(result, "values", newValues);
        result = setIn(result, "initial", newInitialValues);
        return result;
    }, _behaviors[0, $avrKI.REGISTER_FIELD] = function(state, _ref19) {
        var _ref19$payload = _ref19.payload, name = _ref19$payload.name, type = _ref19$payload.type;
        var key = "registeredFields['" + name + "']";
        var field = getIn(state, key);
        if (field) {
            var count = getIn(field, "count") + 1;
            field = setIn(field, "count", count);
        } else field = fromJS({
            name: name,
            type: type,
            count: 1
        });
        return setIn(state, key, field);
    }, _behaviors[0, $avrKI.RESET] = function(state) {
        var result = empty;
        var registeredFields = getIn(state, "registeredFields");
        if (registeredFields) result = setIn(result, "registeredFields", registeredFields);
        var values = getIn(state, "initial");
        if (values) {
            result = setIn(result, "values", values);
            result = setIn(result, "initial", values);
        }
        return result;
    }, _behaviors[0, $avrKI.RESET_SECTION] = function(state, _ref20) {
        var sections = _ref20.meta.sections;
        var result = state;
        sections.forEach(function(section) {
            result = deleteInWithCleanUp(result, "asyncErrors." + section);
            result = deleteInWithCleanUp(result, "submitErrors." + section);
            result = deleteInWithCleanUp(result, "fields." + section);
            var values = getIn(state, "initial." + section);
            result = values ? setIn(result, "values." + section, values) : deleteInWithCleanUp(result, "values." + section);
        });
        var anyTouched = some(keys(getIn(result, "registeredFields")), function(key) {
            return getIn(result, "fields." + key + ".touched");
        });
        result = anyTouched ? setIn(result, "anyTouched", true) : deleteIn(result, "anyTouched");
        return result;
    }, _behaviors[0, $avrKI.SUBMIT] = function(state) {
        return setIn(state, "triggerSubmit", true);
    }, _behaviors[0, $avrKI.START_ASYNC_VALIDATION] = function(state, _ref21) {
        var field = _ref21.meta.field;
        return setIn(state, "asyncValidating", field || true);
    }, _behaviors[0, $avrKI.START_SUBMIT] = function(state) {
        return setIn(state, "submitting", true);
    }, _behaviors[0, $avrKI.STOP_ASYNC_VALIDATION] = function(state, _ref22) {
        var payload = _ref22.payload;
        var result = state;
        result = deleteIn(result, "asyncValidating");
        if (payload && Object.keys(payload).length) {
            var _error = payload._error, fieldErrors = (0, (/*@__PURE__*/$parcel$interopDefault($j7eBO)))(payload, [
                "_error"
            ]);
            if (_error) result = setIn(result, "error", _error);
            if (Object.keys(fieldErrors).length) result = setIn(result, "asyncErrors", fromJS(fieldErrors));
        } else {
            result = deleteIn(result, "error");
            result = deleteIn(result, "asyncErrors");
        }
        return result;
    }, _behaviors[0, $avrKI.STOP_SUBMIT] = function(state, _ref23) {
        var payload = _ref23.payload;
        var result = state;
        result = deleteIn(result, "submitting");
        result = deleteIn(result, "submitFailed");
        result = deleteIn(result, "submitSucceeded");
        if (payload && Object.keys(payload).length) {
            var _error = payload._error, fieldErrors = (0, (/*@__PURE__*/$parcel$interopDefault($j7eBO)))(payload, [
                "_error"
            ]);
            if (_error) result = setIn(result, "error", _error);
            else result = deleteIn(result, "error");
            if (Object.keys(fieldErrors).length) result = setIn(result, "submitErrors", fromJS(fieldErrors));
            else result = deleteIn(result, "submitErrors");
            result = setIn(result, "submitFailed", true);
        } else {
            result = deleteIn(result, "error");
            result = deleteIn(result, "submitErrors");
        }
        return result;
    }, _behaviors[0, $avrKI.SET_SUBMIT_FAILED] = function(state, _ref24) {
        var fields = _ref24.meta.fields;
        var result = state;
        result = setIn(result, "submitFailed", true);
        result = deleteIn(result, "submitSucceeded");
        result = deleteIn(result, "submitting");
        fields.forEach(function(field) {
            return result = setIn(result, "fields." + field + ".touched", true);
        });
        if (fields.length) result = setIn(result, "anyTouched", true);
        return result;
    }, _behaviors[0, $avrKI.SET_SUBMIT_SUCCEEDED] = function(state) {
        var result = state;
        result = deleteIn(result, "submitFailed");
        result = setIn(result, "submitSucceeded", true);
        return result;
    }, _behaviors[0, $avrKI.TOUCH] = function(state, _ref25) {
        var fields = _ref25.meta.fields;
        var result = state;
        fields.forEach(function(field) {
            return result = setIn(result, "fields." + field + ".touched", true);
        });
        result = setIn(result, "anyTouched", true);
        return result;
    }, _behaviors[0, $avrKI.UNREGISTER_FIELD] = function(state, _ref26) {
        var _ref26$payload = _ref26.payload, name = _ref26$payload.name, destroyOnUnmount = _ref26$payload.destroyOnUnmount;
        var result = state;
        var key = "registeredFields['" + name + "']";
        var field = getIn(result, key);
        if (!field) return result;
        var count = getIn(field, "count") - 1;
        if (count <= 0 && destroyOnUnmount) {
            // Note: Cannot use deleteWithCleanUp here because of the flat nature of registeredFields
            result = deleteIn(result, key);
            if (deepEqual(getIn(result, "registeredFields"), empty)) result = deleteIn(result, "registeredFields");
            var syncErrors = getIn(result, "syncErrors");
            if (syncErrors) {
                syncErrors = plainDeleteInWithCleanUp(syncErrors, name);
                if ((0, $hdOPR.default).deepEqual(syncErrors, (0, $hdOPR.default).empty)) result = deleteIn(result, "syncErrors");
                else result = setIn(result, "syncErrors", syncErrors);
            }
            var syncWarnings = getIn(result, "syncWarnings");
            if (syncWarnings) {
                syncWarnings = plainDeleteInWithCleanUp(syncWarnings, name);
                if ((0, $hdOPR.default).deepEqual(syncWarnings, (0, $hdOPR.default).empty)) result = deleteIn(result, "syncWarnings");
                else result = setIn(result, "syncWarnings", syncWarnings);
            }
            result = deleteInWithCleanUp(result, "submitErrors." + name);
            result = deleteInWithCleanUp(result, "asyncErrors." + name);
        } else {
            field = setIn(field, "count", count);
            result = setIn(result, key, field);
        }
        return result;
    }, _behaviors[0, $avrKI.UNTOUCH] = function(state, _ref27) {
        var fields = _ref27.meta.fields;
        var result = state;
        fields.forEach(function(field) {
            return result = deleteIn(result, "fields." + field + ".touched");
        });
        var anyTouched = some(keys(getIn(result, "registeredFields")), function(key) {
            return getIn(result, "fields." + key + ".touched");
        });
        result = anyTouched ? setIn(result, "anyTouched", true) : deleteIn(result, "anyTouched");
        return result;
    }, _behaviors[0, $avrKI.UPDATE_SYNC_ERRORS] = function(state, _ref28) {
        var _ref28$payload = _ref28.payload, syncErrors = _ref28$payload.syncErrors, error = _ref28$payload.error;
        var result = state;
        if (error) {
            result = setIn(result, "error", error);
            result = setIn(result, "syncError", true);
        } else {
            result = deleteIn(result, "error");
            result = deleteIn(result, "syncError");
        }
        if (Object.keys(syncErrors).length) result = setIn(result, "syncErrors", syncErrors);
        else result = deleteIn(result, "syncErrors");
        return result;
    }, _behaviors[0, $avrKI.UPDATE_SYNC_WARNINGS] = function(state, _ref29) {
        var _ref29$payload = _ref29.payload, syncWarnings = _ref29$payload.syncWarnings, warning = _ref29$payload.warning;
        var result = state;
        if (warning) result = setIn(result, "warning", warning);
        else result = deleteIn(result, "warning");
        if (Object.keys(syncWarnings).length) result = setIn(result, "syncWarnings", syncWarnings);
        else result = deleteIn(result, "syncWarnings");
        return result;
    }, _behaviors);
    var reducer = function reducer(state, action) {
        if (state === void 0) state = empty;
        var behavior = behaviors[action.type];
        return behavior ? behavior(state, action) : state;
    };
    var byForm = function byForm(reducer) {
        return function(state, action) {
            if (state === void 0) state = empty;
            if (action === void 0) action = {
                type: "NONE"
            };
            var form = action && action.meta && action.meta.form;
            if (!form || !$5892bd32df2a2137$var$isReduxFormAction(action)) return state;
            if (action.type === (0, $avrKI.DESTROY) && action.meta && action.meta.form) return action.meta.form.reduce(function(result, form) {
                return deleteInWithCleanUp(result, form);
            }, state);
            var formState = getIn(state, form);
            var result = reducer(formState, action);
            return result === formState ? state : setIn(state, form, result);
        };
    };
    /**
   * Adds additional functionality to the reducer
   */ function decorate(target) {
        target.plugin = function(reducers, config) {
            var _this = this;
            if (config === void 0) config = {};
            // use 'function' keyword to enable 'this'
            return decorate(function(state, action) {
                if (state === void 0) state = empty;
                if (action === void 0) action = {
                    type: "NONE"
                };
                var callPlugin = function callPlugin(processed, key) {
                    var previousState = getIn(processed, key);
                    var nextState = reducers[key](previousState, action, getIn(state, key));
                    return nextState !== previousState ? setIn(processed, key, nextState) : processed;
                };
                var processed = _this(state, action); // run through redux-form reducer
                var form = action && action.meta && action.meta.form;
                if (form && !config.receiveAllFormActions) // this is an action aimed at forms, so only give it to the specified form's plugin
                return reducers[form] ? callPlugin(processed, form) : processed;
                else // this is not a form-specific action, so send it to all the plugins
                return Object.keys(reducers).reduce(callPlugin, processed);
            });
        };
        return target;
    }
    return decorate(byForm(reducer));
}
var $5892bd32df2a2137$export$2e2bcd8739ae039 = $5892bd32df2a2137$var$createReducer;

});
parcelRegister("6iihU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49529c1942f581a9$export$2e2bcd8739ae039; });

var $fyzH0 = parcelRequire("fyzH0");
function $49529c1942f581a9$var$createDeleteInWithCleanUp(structure) {
    var shouldDeleteDefault = function shouldDeleteDefault(structure) {
        return function(state, path) {
            return structure.getIn(state, path) !== undefined;
        };
    };
    var deepEqual = structure.deepEqual, empty = structure.empty, getIn = structure.getIn, deleteIn = structure.deleteIn, setIn = structure.setIn;
    return function(shouldDelete) {
        if (shouldDelete === void 0) shouldDelete = shouldDeleteDefault;
        var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
            if (path[path.length - 1] === "]") {
                // array path
                var pathTokens = (0, (/*@__PURE__*/$parcel$interopDefault($fyzH0)))(path);
                pathTokens.pop();
                var parent = getIn(state, pathTokens.join("."));
                return parent ? setIn(state, path) : state;
            }
            var result = state;
            if (shouldDelete(structure)(state, path)) result = deleteIn(state, path);
            var dotIndex = path.lastIndexOf(".");
            if (dotIndex > 0) {
                var parentPath = path.substring(0, dotIndex);
                if (parentPath[parentPath.length - 1] !== "]") {
                    var _parent = getIn(result, parentPath);
                    if (deepEqual(_parent, empty)) return deleteInWithCleanUp(result, parentPath);
                }
            }
            return result;
        };
        return deleteInWithCleanUp;
    };
}
var $49529c1942f581a9$export$2e2bcd8739ae039 = $49529c1942f581a9$var$createDeleteInWithCleanUp;

});





parcelRegister("975h4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2195f0c548b3ce13$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $XgUNY = parcelRequire("XgUNY");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("3hzea");
var $a5HLv = parcelRequire("a5HLv");

var $4EVFU = parcelRequire("4EVFU");

var $g5nij = parcelRequire("g5nij");

var $6aoKW = parcelRequire("6aoKW");
function* $2195f0c548b3ce13$export$2e2bcd8739ae039({ payload: { item: item } }) {
    // @ts-ignore
    const state = yield (0, $5NpoY.a3)();
    const { values: values } = state.form[0, $4EVFU.FORM_KEY];
    const { query: query, account: account } = values;
    let refinedQuery;
    if (query && item.modifier) refinedQuery = `${values.query} ${item.modifier}:`;
    else if (item.modifier) refinedQuery = `${item.modifier}:`;
    yield (0, $5NpoY.P)((0, $6aoKW.publishFact), new (0, $g5nij.SearchFormRefineMenuItemAddedFact)({
        modifier: item.modifier ? item.modifier : undefined
    }));
    yield (0, $5NpoY.P)((0, $6aoKW.publishTrackEvent), {
        action: "added",
        actionSubject: "menu",
        actionSubjectId: "refineMenuItem",
        source: "search",
        containerType: "account",
        containerId: (0, $a5HLv.uncurlyUuid)(account.uuid),
        attributes: {
            modifier: item.modifier ? item.modifier : undefined
        }
    });
    yield (0, $5NpoY.Y)((0, $XgUNY.change)((0, $4EVFU.FORM_KEY), "query", refinedQuery));
}

});

parcelRegister("jUiUX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ff6a5cba1e409cc$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ 
var $XgUNY = parcelRequire("XgUNY");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $4EVFU = parcelRequire("4EVFU");
parcelRequire("i00rV");
var $gwTjV = parcelRequire("gwTjV");

var $kVfUE = parcelRequire("kVfUE");

var $f1PXl = parcelRequire("f1PXl");
function* $0ff6a5cba1e409cc$export$2e2bcd8739ae039({ payload: { params: params } }) {
    var _params$extra;
    const account = yield (0, $5NpoY.a3)((0, $f1PXl.getSearchAccount), params);
    const query = params.q;
    yield (0, $5NpoY.Y)((0, $XgUNY.change)((0, $4EVFU.FORM_KEY), "account", account));
    yield (0, $5NpoY.Y)((0, $XgUNY.change)((0, $4EVFU.FORM_KEY), "query", query));
    if (!account || !account.extra || account.extra.search_state !== "ENABLED" || (_params$extra = params.extra) !== null && _params$extra !== void 0 && _params$extra.modifiersOnly) {
        yield (0, $5NpoY.Y)({
            type: (0, $gwTjV.RESET_SEARCH)
        });
        return;
    }
    if (query) yield (0, $5NpoY.Y)((0, $kVfUE.default)(params));
    else // reset the results
    yield (0, $5NpoY.Y)({
        type: (0, $kVfUE.FetchSearchResults).SUCCESS,
        payload: null
    });
}

});


parcelRegister("mNHVL", function(module, exports) {
$parcel$export(module.exports, "UPDATE_SIDEBAR_STATE", function () { return (parcelRequire("kncIe")).UPDATE_SIDEBAR_STATE; });
$parcel$export(module.exports, "updateSidebarState", function () { return (parcelRequire("kncIe")).updateSidebarState; });

$parcel$export(module.exports, "reducer", function () { return (parcelRequire("8Y02R")).default; });
$parcel$export(module.exports, "isBranchSidebarOpen", function () { return (parcelRequire("8Y02R")).isBranchSidebarOpen; });
$parcel$export(module.exports, "isCommitSidebarOpen", function () { return (parcelRequire("8Y02R")).isCommitSidebarOpen; });
$parcel$export(module.exports, "isSourceSidebarOpen", function () { return (parcelRequire("8Y02R")).isSourceSidebarOpen; });
$parcel$export(module.exports, "getCodeReviewSidebarWidth", function () { return (parcelRequire("8Y02R")).getCodeReviewSidebarWidth; });
$parcel$export(module.exports, "getSourceSidebarWidth", function () { return (parcelRequire("8Y02R")).getSourceSidebarWidth; });
$parcel$export(module.exports, "getBranchSidebarWidth", function () { return (parcelRequire("8Y02R")).getBranchSidebarWidth; });
$parcel$export(module.exports, "getCommitSidebarWidth", function () { return (parcelRequire("8Y02R")).getCommitSidebarWidth; });
$parcel$export(module.exports, "getBranchSidebarTabIndex", function () { return (parcelRequire("8Y02R")).getBranchSidebarTabIndex; });
$parcel$export(module.exports, "getCommitSidebarTabIndex", function () { return (parcelRequire("8Y02R")).getCommitSidebarTabIndex; });
$parcel$export(module.exports, "toggleSidebarSaga", function () { return (parcelRequire("1d3DX")).default; });
$parcel$export(module.exports, "updateSidebarStateSaga", function () { return (parcelRequire("6Fbvl")).default; });
parcelRequire("kncIe");

var $8Y02R = parcelRequire("8Y02R");

var $1d3DX = parcelRequire("1d3DX");

var $6Fbvl = parcelRequire("6Fbvl");
 // TODO: P2X-920 Remove explicitly stated type

});
parcelRegister("kncIe", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_SIDEBAR", function () { return $516d5f034a843065$export$658c05a40550f51d; });
$parcel$export(module.exports, "toggleSidebar", function () { return $516d5f034a843065$export$99bd370461527b0; });
$parcel$export(module.exports, "UPDATE_SIDEBAR_STATE", function () { return $516d5f034a843065$export$a7955c9d3d56afcb; });
$parcel$export(module.exports, "updateSidebarState", function () { return $516d5f034a843065$export$a4287a7f46590598; });
const $516d5f034a843065$export$658c05a40550f51d = "sidebar/TOGGLE";
const $516d5f034a843065$export$99bd370461527b0 = (payload)=>({
        type: $516d5f034a843065$export$658c05a40550f51d,
        payload: payload
    });
const $516d5f034a843065$export$a7955c9d3d56afcb = "sidebar/UPDATE_STATE";
const $516d5f034a843065$export$a4287a7f46590598 = (payload)=>({
        type: $516d5f034a843065$export$a7955c9d3d56afcb,
        payload: payload
    });

});

parcelRegister("8Y02R", function(module, exports) {

$parcel$export(module.exports, "getCodeReviewSidebarWidth", function () { return $0638fc3fff338dcc$export$1ea185c648717b4b; });
$parcel$export(module.exports, "getBranchSidebarWidth", function () { return $0638fc3fff338dcc$export$b6e3a17888740514; });
$parcel$export(module.exports, "getCommitSidebarWidth", function () { return $0638fc3fff338dcc$export$1511a7cc73b0e5a2; });
$parcel$export(module.exports, "getCreatePRSidebarWidth", function () { return $0638fc3fff338dcc$export$97a961626833edfb; });
$parcel$export(module.exports, "getSourceSidebarWidth", function () { return $0638fc3fff338dcc$export$a0ec639b985cfe2a; });
$parcel$export(module.exports, "getPipelinesListSidebarWidth", function () { return $0638fc3fff338dcc$export$55b0801bf05b3f23; });
$parcel$export(module.exports, "isBranchSidebarOpen", function () { return $0638fc3fff338dcc$export$df41adbccf7a162d; });
$parcel$export(module.exports, "isCommitSidebarOpen", function () { return $0638fc3fff338dcc$export$8389389d16ec3eee; });
$parcel$export(module.exports, "isCreatePRSidebarOpen", function () { return $0638fc3fff338dcc$export$166239ed439abc53; });
$parcel$export(module.exports, "isSourceSidebarOpen", function () { return $0638fc3fff338dcc$export$4287110b472313de; });
$parcel$export(module.exports, "isPipelineListSidebarOpen", function () { return $0638fc3fff338dcc$export$e4e49793c2b88b54; });
$parcel$export(module.exports, "isSidebarOpen", function () { return $0638fc3fff338dcc$export$fa0e0590cbd95971; });
$parcel$export(module.exports, "getSidebarWidth", function () { return $0638fc3fff338dcc$export$a8a02ec6650a5f78; });
$parcel$export(module.exports, "getBranchSidebarTabIndex", function () { return $0638fc3fff338dcc$export$d3fe5f5219f92031; });
$parcel$export(module.exports, "getCommitSidebarTabIndex", function () { return $0638fc3fff338dcc$export$cf8e503e6c6b90f8; });
$parcel$export(module.exports, "getCreatePRSidebarTabIndex", function () { return $0638fc3fff338dcc$export$96345760bfc585cd; });
$parcel$export(module.exports, "default", function () { return $0638fc3fff338dcc$export$2e2bcd8739ae039; });

var $aXXtM = parcelRequire("aXXtM");

var $dkkN8 = parcelRequire("dkkN8");
parcelRequire("gFLTd");
var $kSdYv = parcelRequire("kSdYv");

var $kncIe = parcelRequire("kncIe");
const $0638fc3fff338dcc$export$1ea185c648717b4b = (0, $aXXtM.createSelector)((state)=>state.sidebar["code-review"], (sidebarState)=>sidebarState.width);
const $0638fc3fff338dcc$export$b6e3a17888740514 = (0, $aXXtM.createSelector)((state)=>state.sidebar.branch, (sidebarState)=>sidebarState.width);
const $0638fc3fff338dcc$export$1511a7cc73b0e5a2 = (0, $aXXtM.createSelector)((state)=>state.sidebar.commit, (sidebarState)=>sidebarState.width);
const $0638fc3fff338dcc$export$97a961626833edfb = (0, $aXXtM.createSelector)((state)=>state.sidebar["create-pr"], (sidebarState)=>sidebarState.width);
const $0638fc3fff338dcc$export$a0ec639b985cfe2a = (0, $aXXtM.createSelector)((state)=>state.sidebar.source, (sidebarState)=>sidebarState.width);
const $0638fc3fff338dcc$export$55b0801bf05b3f23 = (0, $aXXtM.createSelector)((state)=>state.sidebar["pipeline-list"], (sidebarState)=>sidebarState.width);
const $0638fc3fff338dcc$export$6835f1de1bbe11ca = (0, $aXXtM.createSelector)((state)=>state.sidebar["code-review"], (sidebarState)=>sidebarState.isOpen);
const $0638fc3fff338dcc$export$df41adbccf7a162d = (0, $aXXtM.createSelector)((state)=>state.sidebar.branch, (sidebarState)=>sidebarState.isOpen);
const $0638fc3fff338dcc$export$8389389d16ec3eee = (0, $aXXtM.createSelector)((state)=>state.sidebar.commit, (sidebarState)=>sidebarState.isOpen);
const $0638fc3fff338dcc$export$166239ed439abc53 = (0, $aXXtM.createSelector)((state)=>state.sidebar["create-pr"], (sidebarState)=>sidebarState.isOpen);
const $0638fc3fff338dcc$export$4287110b472313de = (0, $aXXtM.createSelector)((state)=>state.sidebar.source, (sidebarState)=>sidebarState.isOpen);
const $0638fc3fff338dcc$export$e4e49793c2b88b54 = (0, $aXXtM.createSelector)((state)=>state.sidebar["pipeline-list"], (sidebarState)=>sidebarState.isOpen);
const $0638fc3fff338dcc$export$fa0e0590cbd95971 = (0, $aXXtM.createSelector)((state, sidebarType)=>state.sidebar[sidebarType], (sidebarState)=>sidebarState.isOpen);
const $0638fc3fff338dcc$export$a8a02ec6650a5f78 = (0, $aXXtM.createSelector)((state, sidebarType)=>state.sidebar[sidebarType], (sidebarState)=>sidebarState.width);
const $0638fc3fff338dcc$export$10bd1e8933b7e247 = (0, $aXXtM.createSelector)((state)=>state.sidebar["code-review"], (sidebarState)=>(sidebarState === null || sidebarState === void 0 ? void 0 : sidebarState.tabIndex) || 0);
const $0638fc3fff338dcc$export$d3fe5f5219f92031 = (0, $aXXtM.createSelector)((state)=>state.sidebar.branch, (sidebarState)=>(sidebarState === null || sidebarState === void 0 ? void 0 : sidebarState.tabIndex) || 0);
const $0638fc3fff338dcc$export$cf8e503e6c6b90f8 = (0, $aXXtM.createSelector)((state)=>state.sidebar.commit, (sidebarState)=>(sidebarState === null || sidebarState === void 0 ? void 0 : sidebarState.tabIndex) || 0);
const $0638fc3fff338dcc$export$96345760bfc585cd = (0, $aXXtM.createSelector)((state)=>state.sidebar["create-pr"], (sidebarState)=>(sidebarState === null || sidebarState === void 0 ? void 0 : sidebarState.tabIndex) || 0);
// Reducer
const $0638fc3fff338dcc$var$initialState = {
    "code-review": {
        isOpen: true,
        width: (0, $kSdYv.SIDEBAR_EXPANDED_WIDTH),
        tabIndex: 0
    },
    branch: {
        isOpen: false,
        width: (0, $kSdYv.SIDEBAR_COLLAPSED_WIDTH),
        tabIndex: 0
    },
    commit: {
        isOpen: false,
        width: (0, $kSdYv.SIDEBAR_COLLAPSED_WIDTH),
        tabIndex: 0
    },
    "create-pr": {
        isOpen: true,
        width: (0, $kSdYv.SIDEBAR_EXPANDED_WIDTH),
        tabIndex: 0
    },
    source: {
        isOpen: false,
        width: (0, $kSdYv.SIDEBAR_COLLAPSED_WIDTH)
    },
    "pipeline-list": {
        isOpen: true,
        width: (0, $kSdYv.PIPELINE_SIDEBAR_EXPANDED_WIDTH)
    }
};
const $0638fc3fff338dcc$var$parseSidebarWidth = (width)=>{
    const intWidth = parseInt(width, 10);
    if (isNaN(intWidth)) return 0, $kSdYv.SIDEBAR_EXPANDED_WIDTH;
    return intWidth;
};
var $0638fc3fff338dcc$export$2e2bcd8739ae039 = (state = $0638fc3fff338dcc$var$initialState, action)=>{
    switch(action.type){
        case 0, $kncIe.TOGGLE_SIDEBAR:
            {
                const { isOpen: isOpen, sidebarType: sidebarType, width: newWidth, tabIndex: newTabIndex } = action.payload;
                // @ts-ignore TODO: fix noImplicitAny error here
                const sidebarState = state[sidebarType];
                if (!sidebarState) return state;
                const newIsOpen = isOpen !== undefined ? isOpen : !sidebarState.isOpen;
                if (sidebarState.isOpen === newIsOpen && sidebarState.width === newWidth) return state;
                const newSidebarState = {
                    ...sidebarState,
                    isOpen: newIsOpen
                };
                if (newIsOpen && newWidth) newSidebarState.width = newWidth;
                if (newIsOpen && newTabIndex !== undefined) newSidebarState.tabIndex = newTabIndex;
                return {
                    ...state,
                    [sidebarType]: newSidebarState
                };
            }
        case (0, $dkkN8.LoadGlobal).SUCCESS:
            {
                const { result: result } = action.payload;
                return {
                    ...state,
                    "code-review": {
                        ...state["code-review"],
                        isOpen: result.isCodeReviewSidebarOpen,
                        width: $0638fc3fff338dcc$var$parseSidebarWidth(result.codeReviewSidebarWidth),
                        tabIndex: result.getCodeReviewSidebarTabIndex
                    },
                    branch: {
                        ...state.branch,
                        isOpen: result.isBranchSidebarOpen,
                        width: $0638fc3fff338dcc$var$parseSidebarWidth(result.branchSidebarWidth)
                    },
                    commit: {
                        ...state.commit,
                        isOpen: result.isCommitSidebarOpen,
                        width: $0638fc3fff338dcc$var$parseSidebarWidth(result.commitSidebarWidth)
                    },
                    "create-pr": {
                        ...state["create-pr"],
                        isOpen: result.isCreatePRSidebarOpen,
                        width: $0638fc3fff338dcc$var$parseSidebarWidth(result.createPRSidebarWidth),
                        tabIndex: result.getCreatePRSidebarTabIndex
                    },
                    source: {
                        ...state.source,
                        isOpen: result.isSourceBrowserSidebarOpen,
                        width: $0638fc3fff338dcc$var$parseSidebarWidth(result.sourceBrowserSidebarWidth)
                    },
                    "pipeline-list": {
                        ...state["pipeline-list"],
                        isOpen: result.isPipelineListSidebarOpen,
                        width: $0638fc3fff338dcc$var$parseSidebarWidth(result.pipelineListSidebarWidth)
                    }
                };
            }
        default:
            return state;
    }
};

});
parcelRegister("gFLTd", function(module, exports) {
$parcel$export(module.exports, "PIPELINE_SIDEBAR_EXPANDED_WIDTH", function () { return (parcelRequire("kSdYv")).PIPELINE_SIDEBAR_EXPANDED_WIDTH; });
$parcel$export(module.exports, "SIDEBAR_COLLAPSED_WIDTH", function () { return (parcelRequire("kSdYv")).SIDEBAR_COLLAPSED_WIDTH; });
$parcel$export(module.exports, "SIDEBAR_EXPANDED_WIDTH", function () { return (parcelRequire("kSdYv")).SIDEBAR_EXPANDED_WIDTH; });
$parcel$export(module.exports, "SIDEBAR_MAX_EXPANDED_WIDTH", function () { return (parcelRequire("kSdYv")).SIDEBAR_MAX_EXPANDED_WIDTH; });
$parcel$export(module.exports, "SIDEBAR_MIN_EXPANDED_WIDTH", function () { return (parcelRequire("kSdYv")).SIDEBAR_MIN_EXPANDED_WIDTH; });

$parcel$export(module.exports, "WINDOW_RESIZE_DEBOUNCE_DELAY", function () { return $04442aad800a3188$export$3e16ff88d199f57c; });
$parcel$export(module.exports, "UP_TO_SMALL_BREAKPOINT_ACTIVE_WIDTH", function () { return $04442aad800a3188$export$4ddef55244cd126; });
parcelRequire("kSdYv");
const $04442aad800a3188$export$3e16ff88d199f57c = 300;
const $04442aad800a3188$export$b248be90da05b83e = 768;
const $04442aad800a3188$export$4ddef55244cd126 = 576;

});
parcelRegister("kSdYv", function(module, exports) {

$parcel$export(module.exports, "SIDEBAR_COLLAPSED_WIDTH", function () { return $6d1a40df2dd4910b$export$6e23a84424e5ea66; });
$parcel$export(module.exports, "SIDEBAR_EXPANDED_WIDTH", function () { return $6d1a40df2dd4910b$export$f14400cf36178c48; });
$parcel$export(module.exports, "PIPELINE_SIDEBAR_EXPANDED_WIDTH", function () { return $6d1a40df2dd4910b$export$86109643c9c1de01; });
$parcel$export(module.exports, "SIDEBAR_MAX_EXPANDED_WIDTH", function () { return $6d1a40df2dd4910b$export$aeeb595f55103c26; });
$parcel$export(module.exports, "SIDEBAR_MIN_EXPANDED_WIDTH", function () { return $6d1a40df2dd4910b$export$e8a711b1fddb35dd; });
const $6d1a40df2dd4910b$export$6e23a84424e5ea66 = 64;
const $6d1a40df2dd4910b$export$f14400cf36178c48 = 280;
const $6d1a40df2dd4910b$export$86109643c9c1de01 = 320;
const $6d1a40df2dd4910b$export$aeeb595f55103c26 = 800;
const $6d1a40df2dd4910b$export$e8a711b1fddb35dd = 200;

});



parcelRegister("1d3DX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a77c342cd86a7be$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $g2R3c = parcelRequire("g2R3c");

var $j9gxd = parcelRequire("j9gxd");

var $kncIe = parcelRequire("kncIe");

var $8Y02R = parcelRequire("8Y02R");
function* $7a77c342cd86a7be$export$eb7823d7b410f5c8(action) {
    const { sidebarType: sidebarType } = action.payload;
    const currentUser = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
    const isOpen = yield (0, $5NpoY.a3)((0, $8Y02R.isSidebarOpen), sidebarType);
    const width = yield (0, $5NpoY.a3)((0, $8Y02R.getSidebarWidth), sidebarType);
    if (currentUser) {
        yield (0, $5NpoY.P)((0, $j9gxd.default).set, currentUser.uuid, `right-sidebar-${sidebarType}-collapsed`, !isOpen);
        if (isOpen) yield (0, $5NpoY.P)((0, $j9gxd.default).set, currentUser.uuid, `right-sidebar-${sidebarType}-width`, width);
    }
}
function* $7a77c342cd86a7be$export$2e2bcd8739ae039() {
    // Debouncing the saga reduces load on the preferences API when rapidly toggling the sidebar
    // It also limits this saga to running once per toggle (the TOGGLE_SIDEBAR action can fire
    // twice if the sidebar collapsed/expanded state is triggered externally: once to open/close
    // and once via the sidebar onResize callback to update redux to the new width)
    // Taken from redux-saga-debounce-effect library, copied because we've bumped to newer redux-saga
    // @ts-ignore TODO: fix noImplicitAny error here
    function* delayedSaga(action) {
        yield (0, $5NpoY.S)(500);
        yield (0, $5NpoY.P)($7a77c342cd86a7be$export$eb7823d7b410f5c8, action);
    }
    let task;
    while(true){
        // @ts-ignore
        const action = yield (0, $5NpoY.M)((0, $kncIe.TOGGLE_SIDEBAR));
        if (task) yield (0, $5NpoY.O)(task);
        // @ts-ignore
        task = yield (0, $5NpoY.N)(delayedSaga, action);
    }
}

});

parcelRegister("6Fbvl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37eb46b9ad4876ef$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $iAWzg = parcelRequire("iAWzg");

var $8MnfV = parcelRequire("8MnfV");

var $kncIe = parcelRequire("kncIe");
function* $37eb46b9ad4876ef$export$2e2bcd8739ae039(action) {
    const isMobileHeaderActive = yield (0, $5NpoY.a3)((0, $8MnfV.getIsMobileHeaderActive));
    if (isMobileHeaderActive && !action.payload.isOpen) yield (0, $5NpoY.Y)((0, $iAWzg.default)("none"));
    else yield (0, $5NpoY.Y)((0, $kncIe.toggleSidebar)(action.payload));
}

});


parcelRegister("bBuHW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2635f8f6f949952d$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $5Put2 = parcelRequire("5Put2");

var $g2R3c = parcelRequire("g2R3c");

var $4uvOm = parcelRequire("4uvOm");
function* $2635f8f6f949952d$var$cacheRecentlyViewedWorkspace() {
    while(true){
        // @ts-ignore
        const action = yield (0, $5NpoY.M)((0, $5Put2.ADD_RECENTLY_VIEWED_WORKSPACE));
        const workspaceUuid = action.payload.result;
        const currentUser = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
        if (!currentUser) continue;
        if (workspaceUuid) yield (0, $5NpoY.P)((0, $4uvOm.default).add, currentUser, workspaceUuid);
    }
}
var $2635f8f6f949952d$export$2e2bcd8739ae039 = $2635f8f6f949952d$var$cacheRecentlyViewedWorkspace;

});

parcelRegister("bRCxm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb88440e253847c1$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("85vJP");
var $5Put2 = parcelRequire("5Put2");

var $ksfVj = parcelRequire("ksfVj");

var $k2cPS = parcelRequire("k2cPS");
function* $bb88440e253847c1$export$bb5008299b9c4990({ payload: payload }) {
    try {
        if (!payload.workspaceSlug) throw new Error(`Workspace slug not available`);
        const url = (0, $ksfVj.default).api.internal.plan(payload.workspaceSlug);
        const request = (0, $k2cPS.default)(url);
        const response = yield (0, $5NpoY.P)(fetch, request);
        if (response.ok) {
            // @ts-ignore
            const plan = yield response.json();
            yield (0, $5NpoY.Y)({
                type: (0, $5Put2.FETCH_WORKSPACE_PLAN).SUCCESS,
                payload: {
                    isWorkspacePremium: plan.extra.has_premium,
                    isWorkspacePaid: plan.extra.is_paid
                }
            });
        } else yield (0, $5NpoY.Y)({
            type: (0, $5Put2.FETCH_WORKSPACE_PLAN).ERROR
        });
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $5Put2.FETCH_WORKSPACE_PLAN).ERROR,
            payload: e.message
        });
    }
}
function* $bb88440e253847c1$export$2e2bcd8739ae039() {
    while(true){
        const { payload: workspaceSlug } = yield (0, $5NpoY.M)((0, $5Put2.FETCH_WORKSPACE_PLAN).REQUEST);
        const { timeout: timeout } = yield (0, $5NpoY.T)({
            response: (0, $5NpoY.P)($bb88440e253847c1$export$bb5008299b9c4990, {
                payload: workspaceSlug
            }),
            timeout: (0, $5NpoY.S)(60000)
        });
        if (timeout) yield (0, $5NpoY.Y)({
            type: (0, $5Put2.FETCH_WORKSPACE_PLAN).ERROR
        });
    }
}

});

parcelRegister("9LI2I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40e5b28ed14f6382$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $k5ZQb = parcelRequire("k5ZQb");

var $evdW4 = parcelRequire("evdW4");

var $cUW3c = parcelRequire("cUW3c");
function* $40e5b28ed14f6382$var$loadWorkspaceSuccess() {
    while(true){
        yield (0, $5NpoY.M)((0, $k5ZQb.LoadProfilePage).SUCCESS);
        const workspace = yield (0, $5NpoY.a3)((0, $evdW4.getCurrentWorkspace));
        if (workspace) yield (0, $5NpoY.Y)((0, $cUW3c.default)(workspace));
    }
}
var $40e5b28ed14f6382$export$2e2bcd8739ae039 = $40e5b28ed14f6382$var$loadWorkspaceSuccess;

});
parcelRegister("evdW4", function(module, exports) {

$parcel$export(module.exports, "getProfileRepositoriesLanguagesStateSlice", function () { return $76506cb56bcfd5dc$export$1144461a7536fccf; });
$parcel$export(module.exports, "getCurrentWorkspace", function () { return $76506cb56bcfd5dc$export$2e21ae02c36d8af0; });
$parcel$export(module.exports, "getProfileNavigationPieces", function () { return $76506cb56bcfd5dc$export$23a63e259948aa84; });
$parcel$export(module.exports, "getProfileUpgradeBannerPieces", function () { return $76506cb56bcfd5dc$export$99a97b70c9db01f8; });
$parcel$export(module.exports, "getIsProfileAdminStatus", function () { return $76506cb56bcfd5dc$export$30a21d1ad33cf7aa; });
$parcel$export(module.exports, "getProfileUuid", function () { return $76506cb56bcfd5dc$export$65fbf57e33036fd2; });

var $aXXtM = parcelRequire("aXXtM");

var $g2R3c = parcelRequire("g2R3c");

var $R3kDb = parcelRequire("R3kDb");
// @ts-ignore TODO: fix noImplicitAny error here
const $76506cb56bcfd5dc$var$getProfileStateSlice = (state)=>state.profile;
const $76506cb56bcfd5dc$export$4028a64da874dc5c = (0, $aXXtM.createSelector)($76506cb56bcfd5dc$var$getProfileStateSlice, (profile)=>profile.repositories);
const $76506cb56bcfd5dc$export$1144461a7536fccf = (0, $aXXtM.createSelector)($76506cb56bcfd5dc$var$getProfileStateSlice, (profile)=>profile.repositoriesLanguages);
const $76506cb56bcfd5dc$export$f44b0c8c2d945f55 = (0, $aXXtM.createSelector)($76506cb56bcfd5dc$var$getProfileStateSlice, (profile)=>profile.section);
const $76506cb56bcfd5dc$export$6609c7ece0dbf334 = (0, $aXXtM.createSelector)($76506cb56bcfd5dc$export$f44b0c8c2d945f55, (section)=>section.menuItems);
const $76506cb56bcfd5dc$export$f0ca9530e02fd663 = (0, $aXXtM.createSelector)($76506cb56bcfd5dc$export$f44b0c8c2d945f55, (section)=>section.currentUser);
const $76506cb56bcfd5dc$export$f6bafc3bc3ab9b06 = (0, $aXXtM.createSelector)($76506cb56bcfd5dc$export$1144461a7536fccf, (repositoriesLanguages)=>repositoriesLanguages.languages);
const $76506cb56bcfd5dc$export$2e21ae02c36d8af0 = (0, $aXXtM.createSelector)($76506cb56bcfd5dc$export$f44b0c8c2d945f55, (section)=>section.currentWorkspace);
const $76506cb56bcfd5dc$export$23a63e259948aa84 = (0, $aXXtM.createSelector)($76506cb56bcfd5dc$export$f0ca9530e02fd663, $76506cb56bcfd5dc$export$2e21ae02c36d8af0, (currentUser, currentWorkspace)=>{
    if (currentWorkspace) return {
        name: currentWorkspace.name,
        htmlUrl: currentWorkspace.links.html.href,
        avatarUrl: currentWorkspace.links.avatar.href
    };
    if (currentUser) return {
        name: currentUser.display_name,
        htmlUrl: currentUser.links.html ? currentUser.links.html.href : "",
        avatarUrl: currentUser.links.avatar.href
    };
    return undefined;
});
const $76506cb56bcfd5dc$export$99a97b70c9db01f8 = (0, $aXXtM.createSelector)($76506cb56bcfd5dc$export$f0ca9530e02fd663, $76506cb56bcfd5dc$export$2e21ae02c36d8af0, (currentUser, currentWorkspace)=>{
    if (currentWorkspace && currentWorkspace.extra) return {
        uuid: currentWorkspace.uuid,
        hasPremium: currentWorkspace.extra.has_premium,
        isAdmin: currentWorkspace.extra.admin_status === "admin"
    };
    if (currentUser && (0, $R3kDb.isTeam)(currentUser) && currentUser.extra) return {
        uuid: currentUser.uuid,
        hasPremium: currentUser.extra.has_premium,
        isAdmin: currentUser.extra.admin_status === "admin"
    };
    return undefined;
});
const $76506cb56bcfd5dc$export$30a21d1ad33cf7aa = (0, $aXXtM.createSelector)($76506cb56bcfd5dc$export$f0ca9530e02fd663, $76506cb56bcfd5dc$export$2e21ae02c36d8af0, (0, $g2R3c.getCurrentUser), (currentUser, currentWorkspace, globalCurrentUser)=>{
    if (currentWorkspace && currentWorkspace.extra) return currentWorkspace.extra.admin_status === "admin" || currentWorkspace.extra.admin_status === "collaborator";
    if (currentUser && globalCurrentUser && currentUser.uuid === globalCurrentUser.uuid) return true;
    if (currentUser && (0, $R3kDb.isTeam)(currentUser) && currentUser.extra) return currentUser.extra.admin_status === "admin" || currentUser.extra.admin_status === "collaborator";
    return false;
});
const $76506cb56bcfd5dc$export$65fbf57e33036fd2 = (0, $aXXtM.createSelector)($76506cb56bcfd5dc$export$2e21ae02c36d8af0, $76506cb56bcfd5dc$export$f0ca9530e02fd663, (profileWorkspace, profileUser)=>{
    if (profileWorkspace) return profileWorkspace.uuid;
    if (profileUser) return profileUser.uuid;
    return null;
});

});
parcelRegister("R3kDb", function(module, exports) {

$parcel$export(module.exports, "isTeam", function () { return $871a7f96bd2f643e$export$f8c4277cb588611f; });
function $871a7f96bd2f643e$export$f8c4277cb588611f(currentUser) {
    return currentUser.type === "team";
}

});


parcelRegister("cUW3c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe016fc1bc7de0d0$export$2e2bcd8739ae039; });

var $d8wMK = parcelRequire("d8wMK");

var $5Put2 = parcelRequire("5Put2");
var $fe016fc1bc7de0d0$export$2e2bcd8739ae039 = (workspace)=>({
        type: (0, $5Put2.ADD_RECENTLY_VIEWED_WORKSPACE),
        payload: workspace,
        meta: {
            schema: (0, $d8wMK.workspace)
        }
    });

});
parcelRegister("d8wMK", function(module, exports) {

$parcel$export(module.exports, "workspace", function () { return $04b6283f95f41c3f$export$ed275788a758bd76; });

var $ga67g = parcelRequire("ga67g");
const $04b6283f95f41c3f$export$ed275788a758bd76 = new (0, $ga67g.schema).Entity("workspaces.uuid", {}, {
    idAttribute: "uuid"
});

});



parcelRegister("8oYaU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b541bea5da732868$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");

var $aanBq = parcelRequire("aanBq");

var $fEutT = parcelRequire("fEutT");
function* $b541bea5da732868$export$295b124978408031() {
    try {
        const baseUrl = (0, $fEutT.default)("/!api/internal");
        const fullSlug = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepositoryFullSlug));
        if (!fullSlug) throw new Error(`Repository slug not available`);
        const url = `${baseUrl}/repositories/${fullSlug}/pipelines_config/capabilities/?fields=repository_config,allowance`;
        const response = yield (0, $5NpoY.P)(fetch, url);
        // @ts-ignore
        const json = yield (0, $5NpoY.P)([
            response,
            "json"
        ]);
        const { repository_config: repoConfig, allowance: allowance } = json;
        if (allowance) yield (0, $5NpoY.Y)({
            type: (0, $jJd6W.FETCH_IS_PIPELINES_ENABLED).SUCCESS,
            payload: {
                isPipelinesEnabled: repoConfig.pipelines_enabled,
                isPipelinesPremium: allowance.premium || allowance.paid,
                ...json
            }
        });
        else yield (0, $5NpoY.Y)({
            type: (0, $jJd6W.FETCH_IS_PIPELINES_ENABLED).SUCCESS,
            payload: {
                isPipelinesEnabled: repoConfig.pipelines_enabled,
                ...json
            }
        });
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $jJd6W.FETCH_IS_PIPELINES_ENABLED).ERROR,
            payload: e.message
        });
    }
}
function* $b541bea5da732868$export$3ec12a54c20df8f2() {
    try {
        yield (0, $5NpoY.P)($b541bea5da732868$export$295b124978408031);
    } catch (e) {
        yield (0, $5NpoY.Y)({
            type: (0, $jJd6W.FETCH_IS_PIPELINES_ENABLED).ERROR,
            payload: e.message
        });
    }
}
function* $b541bea5da732868$export$2e2bcd8739ae039() {
    yield (0, $jeUNF.takeLatest)((0, $jJd6W.FETCH_IS_PIPELINES_ENABLED).REQUEST, $b541bea5da732868$export$3ec12a54c20df8f2);
}

});

parcelRegister("RmFDb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf1ecf9b0fcded5f$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $2kKDW = parcelRequire("2kKDW");

var $k2cPS = parcelRequire("k2cPS");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");

var $kZnTB = parcelRequire("kZnTB");

var $3MkRe = parcelRequire("3MkRe");
function* $bf1ecf9b0fcded5f$export$2e2bcd8739ae039() {
    while(true){
        // @ts-ignore
        const action = yield (0, $5NpoY.M)((0, $jJd6W.TOGGLE_REPOSITORY_WATCH).REQUEST);
        const { repositoryFullSlug: repositoryFullSlug } = action.payload;
        const endpoint = (0, $kZnTB.default).api.internal.toggleWatch(repositoryFullSlug);
        try {
            const request = (0, $k2cPS.default)(endpoint, {
                method: "POST"
            });
            const response = yield (0, $5NpoY.P)(fetch, request);
            if (!response.ok) throw Error(response.statusText);
            // @ts-ignore
            const json = yield response.json();
            const watchMessage = json.following ? (0, $3MkRe.default).watchedRepository : (0, $3MkRe.default).unwatchedRepository;
            yield (0, $5NpoY.Y)({
                type: (0, $jJd6W.TOGGLE_REPOSITORY_WATCH).SUCCESS,
                payload: {
                    isWatching: json.following,
                    watcherCount: json.followers
                }
            });
            yield (0, $5NpoY.Y)((0, $2kKDW.showFlag)({
                id: `${json.following ? "watch" : "unwatch"}-success`,
                iconType: "success",
                title: {
                    msg: watchMessage
                },
                autoDismiss: true
            }));
        } catch (e) {
            yield (0, $5NpoY.Y)({
                type: (0, $jJd6W.TOGGLE_REPOSITORY_WATCH).ERROR,
                payload: e.message
            });
            yield (0, $5NpoY.Y)((0, $2kKDW.showFlag)({
                id: "watch-error",
                iconType: "error",
                title: "Something went wrong!",
                description: e.message
            }));
        }
    }
}

});
parcelRegister("3MkRe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $935dbc3f9bd62fbe$export$2e2bcd8739ae039; });

var $agjvf = parcelRequire("agjvf");
var $935dbc3f9bd62fbe$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    watchedRepository: {
        "id": "frontbucket.repository.source.watchedRepository",
        "defaultMessage": "You are now watching this repository."
    },
    unwatchedRepository: {
        "id": "frontbucket.repository.source.unwatchedRepository",
        "defaultMessage": "You are no longer watching this repository."
    }
});

});


parcelRegister("7pIWM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4e5748eea1d2683$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $f286l = parcelRequire("f286l");

var $hreZc = parcelRequire("hreZc");

var $e3DLv = parcelRequire("e3DLv");

var $fZJ8T = parcelRequire("fZJ8T");
function* $b4e5748eea1d2683$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        (0, $f286l.default)(),
        (0, $hreZc.default)(),
        (0, $e3DLv.default)(),
        (0, $fZJ8T.default)()
    ]);
}

});
parcelRegister("f286l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21db1e50eea3a386$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $XWFsz = parcelRequire("XWFsz");

var $3UXCH = parcelRequire("3UXCH");

var $kWOUe = parcelRequire("kWOUe");

var $dxHyo = parcelRequire("dxHyo");

var $htrWd = parcelRequire("htrWd");
function $21db1e50eea3a386$var$createFilteredFiles(values) {
    const { isCleared: isCleared, isLoading: isLoading, errorCode: errorCode, files: files } = values;
    if (isCleared) return null;
    return {
        isLoading: !!isLoading,
        errorCode: errorCode,
        files: files
    };
}
/* eslint-disable @typescript-eslint/no-use-before-define */ // @ts-ignore TODO: fix noImplicitAny error here
function* $21db1e50eea3a386$var$filterFilesAgain(action) {
    yield (0, $5NpoY.S)(250);
    yield (0, $5NpoY.P)($21db1e50eea3a386$var$filterFiles, action);
}
// @ts-ignore TODO: fix noImplicitAny error here
function* $21db1e50eea3a386$var$filterFiles(action) {
    const query = action.payload;
    if (!query) {
        yield (0, $5NpoY.Y)({
            type: (0, $kWOUe.FilterFiles).SUCCESS,
            payload: $21db1e50eea3a386$var$createFilteredFiles({
                isCleared: true
            })
        });
        return;
    }
    const fileTree = yield (0, $5NpoY.a3)((0, $dxHyo.getFileTree));
    if (!fileTree) {
        yield (0, $5NpoY.Y)({
            type: (0, $kWOUe.FilterFiles).SUCCESS,
            payload: $21db1e50eea3a386$var$createFilteredFiles({
                isLoading: true,
                files: []
            })
        });
        // The tree might be available in a moment, so try filtering again
        yield (0, $5NpoY.N)($21db1e50eea3a386$var$filterFilesAgain, action);
        return;
    }
    if (!fileTree.tree) {
        const sourceTimeoutFixEnabled = yield (0, $5NpoY.a3)((0, $3UXCH.getIsSourceTimeoutFixEnabled));
        const sourceFiles = yield (0, $5NpoY.a3)((0, $dxHyo.getSourceDirectoryContents));
        if (sourceTimeoutFixEnabled && sourceFiles) yield (0, $5NpoY.Y)({
            type: (0, $kWOUe.FilterFiles).ERROR,
            payload: $21db1e50eea3a386$var$createFilteredFiles({
                isLoading: false,
                errorCode: fileTree.errorCode || undefined,
                files: (0, $htrWd.limitedFilter)(sourceFiles, query)
            })
        });
        else yield (0, $5NpoY.Y)({
            type: (0, $kWOUe.FilterFiles).ERROR,
            payload: $21db1e50eea3a386$var$createFilteredFiles({
                isLoading: false,
                errorCode: 404
            })
        });
        return;
    }
    yield (0, $5NpoY.Y)({
        type: (0, $kWOUe.FilterFiles).SUCCESS,
        payload: $21db1e50eea3a386$var$createFilteredFiles({
            isLoading: false,
            files: (0, $htrWd.findFiles)(fileTree.tree, query)
        })
    });
}
function* $21db1e50eea3a386$export$2e2bcd8739ae039() {
    yield (0, $XWFsz.default)((0, $kWOUe.FilterFiles).REQUEST, $21db1e50eea3a386$var$filterFiles);
}

});
parcelRegister("XWFsz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb54cac1f214c21c$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
function $eb54cac1f214c21c$export$2e2bcd8739ae039(pattern, saga) {
    return (0, $5NpoY.N)(function* forkedGen() {
        // @ts-ignore
        const channel = yield (0, $5NpoY.Q)(pattern);
        while(true){
            // @ts-ignore
            const action = yield (0, $5NpoY.M)(channel);
            yield (0, $5NpoY.P)(saga, action);
        }
    });
}

});

parcelRegister("kWOUe", function(module, exports) {

$parcel$export(module.exports, "FetchDirectory", function () { return $24db446893c67c78$export$25205d72db1e883c; });
$parcel$export(module.exports, "FetchFileTree", function () { return $24db446893c67c78$export$29ba813861578825; });
$parcel$export(module.exports, "FetchSource", function () { return $24db446893c67c78$export$da55bbd2ae5caa76; });
$parcel$export(module.exports, "FetchSourceDirMetadata", function () { return $24db446893c67c78$export$881d6499db55960e; });
$parcel$export(module.exports, "FetchSourceObjectMeta", function () { return $24db446893c67c78$export$5f8db07b7805268c; });
$parcel$export(module.exports, "LOAD_SOURCE_FILE", function () { return $24db446893c67c78$export$ef1176ddef84c7ab; });
$parcel$export(module.exports, "LoadFileMeta", function () { return $24db446893c67c78$export$3dfbc2f83cce3517; });
$parcel$export(module.exports, "LoadFileContents", function () { return $24db446893c67c78$export$302643eee6e6e941; });
$parcel$export(module.exports, "LoadFileTree", function () { return $24db446893c67c78$export$e44391ccfe9399c2; });
$parcel$export(module.exports, "LoadLfsInfo", function () { return $24db446893c67c78$export$d60c13d7d557ecff; });
$parcel$export(module.exports, "LoadSourceObject", function () { return $24db446893c67c78$export$3cb63083a0e03f77; });
$parcel$export(module.exports, "FilterFiles", function () { return $24db446893c67c78$export$e6eff110434f599; });
$parcel$export(module.exports, "FetchDiff", function () { return $24db446893c67c78$export$1e3942902e4f0455; });
$parcel$export(module.exports, "UNLOAD_DIFF", function () { return $24db446893c67c78$export$cc9e539d76ceee; });
$parcel$export(module.exports, "UNLOAD_FILE", function () { return $24db446893c67c78$export$614a94c25312e58c; });
$parcel$export(module.exports, "UNLOAD_SOURCE", function () { return $24db446893c67c78$export$c8036bcd3f0b6e6a; });
$parcel$export(module.exports, "FILTER_MODE_CHANGE", function () { return $24db446893c67c78$export$bd68f9892514e5d1; });
$parcel$export(module.exports, "CODE_SEARCH_CHANGE", function () { return $24db446893c67c78$export$b5ef45db27c67633; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
const $24db446893c67c78$export$25205d72db1e883c = (0, $2MctD.createAsyncAction)("source/FETCH_DIRECTORY");
const $24db446893c67c78$export$29ba813861578825 = (0, $2MctD.createAsyncAction)("source/FETCH_FILE_TREE");
const $24db446893c67c78$export$da55bbd2ae5caa76 = (0, $2MctD.createAsyncAction)("source/FETCH_SOURCE");
const $24db446893c67c78$export$881d6499db55960e = (0, $2MctD.createAsyncAction)("source/FETCH_DIR_METADATA");
const $24db446893c67c78$export$5f8db07b7805268c = (0, $2MctD.createAsyncAction)("source/FETCH_SOURCE_OBJECT_META");
const $24db446893c67c78$export$ef1176ddef84c7ab = "source/LOAD_SOURCE_FILE";
const $24db446893c67c78$export$3dfbc2f83cce3517 = (0, $2MctD.createAsyncAction)("source/LOAD_FILE_META");
const $24db446893c67c78$export$302643eee6e6e941 = (0, $2MctD.createAsyncAction)("source/LOAD_FILE_CONTENTS");
const $24db446893c67c78$export$e44391ccfe9399c2 = (0, $2MctD.createAsyncAction)("source/LOAD_FILE_TREE");
const $24db446893c67c78$export$d60c13d7d557ecff = (0, $2MctD.createAsyncAction)("source/LOAD_LFS_INFO");
const $24db446893c67c78$export$3cb63083a0e03f77 = (0, $2MctD.createAsyncAction)("source/LOAD_SOURCE_OBJECT");
const $24db446893c67c78$export$e6eff110434f599 = (0, $2MctD.createAsyncAction)("source/FILTER_FILES");
const $24db446893c67c78$export$1e3942902e4f0455 = (0, $2MctD.createAsyncAction)("source/FETCH_DIFF");
const $24db446893c67c78$export$cc9e539d76ceee = "source/UNLOAD_DIFF";
const $24db446893c67c78$export$614a94c25312e58c = "source/UNLOAD_FILE";
const $24db446893c67c78$export$c8036bcd3f0b6e6a = "source/UNLOAD_SOURCE";
const $24db446893c67c78$export$bd68f9892514e5d1 = "source/FILTER_MODE_CHANGE";
const $24db446893c67c78$export$b5ef45db27c67633 = "source/CODE_SEARCH_CHANGE";

});

parcelRegister("dxHyo", function(module, exports) {

$parcel$export(module.exports, "getFileTree", function () { return $f6181d4f6c8d1953$export$f4c6651e7b26bd32; });
$parcel$export(module.exports, "getFilteredFiles", function () { return $f6181d4f6c8d1953$export$e587b42e2869c120; });
$parcel$export(module.exports, "getFilterQuery", function () { return $f6181d4f6c8d1953$export$af27e998c5db692c; });
$parcel$export(module.exports, "getFilterMode", function () { return $f6181d4f6c8d1953$export$d1bdd4c6527e770b; });
$parcel$export(module.exports, "getSourceDirectoryContents", function () { return $f6181d4f6c8d1953$export$c4126e30edc620fe; });
$parcel$export(module.exports, "default", function () { return $f6181d4f6c8d1953$export$2e2bcd8739ae039; });

var $aXXtM = parcelRequire("aXXtM");

var $gsXeO = parcelRequire("gsXeO");

var $kWOUe = parcelRequire("kWOUe");

var $7cGfh = parcelRequire("7cGfh");

var $bAMD3 = parcelRequire("bAMD3");
const $f6181d4f6c8d1953$export$d4c72bab9d6cc13a = {
    isLoading: false,
    filterMode: (0, $7cGfh.FilterMode).Files,
    filteredFiles: null,
    filterQuery: "",
    fileTree: null,
    sourceObject: null,
    maxItemsDisplayed: 500
};
const $f6181d4f6c8d1953$export$b8d9b7bbcd48b9b7 = (state)=>state.repository.source.section;
const $f6181d4f6c8d1953$export$f4c6651e7b26bd32 = (0, $aXXtM.createSelector)($f6181d4f6c8d1953$export$b8d9b7bbcd48b9b7, (section)=>section.fileTree);
const $f6181d4f6c8d1953$export$e587b42e2869c120 = (0, $aXXtM.createSelector)($f6181d4f6c8d1953$export$b8d9b7bbcd48b9b7, (section)=>section.filteredFiles);
const $f6181d4f6c8d1953$export$af27e998c5db692c = (0, $aXXtM.createSelector)($f6181d4f6c8d1953$export$b8d9b7bbcd48b9b7, (section)=>section.filterQuery);
const $f6181d4f6c8d1953$export$d1bdd4c6527e770b = (0, $aXXtM.createSelector)($f6181d4f6c8d1953$export$b8d9b7bbcd48b9b7, (section)=>section.filterMode);
const $f6181d4f6c8d1953$export$c4126e30edc620fe = (0, $aXXtM.createSelector)($f6181d4f6c8d1953$export$b8d9b7bbcd48b9b7, (section)=>{
    var _section$sourceObject, _section$sourceObject2;
    return ((_section$sourceObject = section.sourceObject) === null || _section$sourceObject === void 0 ? void 0 : (_section$sourceObject2 = _section$sourceObject.treeEntry) === null || _section$sourceObject2 === void 0 ? void 0 : _section$sourceObject2.type) === "directory" ? section.sourceObject.treeEntry.contents : [];
});
var $f6181d4f6c8d1953$export$2e2bcd8739ae039 = (0, $gsXeO.default)($f6181d4f6c8d1953$export$d4c72bab9d6cc13a, {
    [(0, $kWOUe.FetchDiff).REQUEST] (state) {
        return {
            ...state,
            isLoading: true
        };
    },
    [(0, $kWOUe.FetchDiff).SUCCESS] (state, action) {
        return {
            ...state,
            ...action.payload,
            isLoading: false
        };
    },
    [(0, $kWOUe.FetchSource).REQUEST] (state) {
        return {
            ...state,
            isLoading: true
        };
    },
    [(0, $kWOUe.FetchSource).SUCCESS] (state, action) {
        return {
            ...state,
            ...action.payload,
            isLoading: false
        };
    },
    [(0, $kWOUe.FILTER_MODE_CHANGE)] (state, action) {
        return {
            ...state,
            filterMode: action.payload
        };
    },
    [(0, $kWOUe.CODE_SEARCH_CHANGE)] (state, action) {
        return {
            ...state,
            filterQuery: action.payload
        };
    },
    [(0, $kWOUe.FilterFiles).REQUEST] (state, action) {
        return {
            ...state,
            filterQuery: action.payload
        };
    },
    [(0, $kWOUe.FilterFiles).SUCCESS] (state, action) {
        return {
            ...state,
            filteredFiles: action.payload,
            maxItemsDisplayed: 500
        };
    },
    [(0, $kWOUe.FilterFiles).ERROR] (state, action) {
        return {
            ...state,
            filteredFiles: action.payload,
            maxItemsDisplayed: 1000
        };
    },
    [(0, $kWOUe.LoadFileTree).REQUEST] (state, action) {
        const { repository: repository, hash: hash } = action.payload;
        if (state.fileTree && state.fileTree.id !== (0, $bAMD3.default)(repository, hash)) return {
            ...state,
            fileTree: null
        };
        return state;
    },
    [(0, $kWOUe.FetchFileTree).SUCCESS] (state, action) {
        const { meta: meta, payload: payload } = action;
        return {
            ...state,
            fileTree: {
                id: meta && meta.data.treeId,
                tree: payload[0]
            }
        };
    },
    [(0, $kWOUe.FetchFileTree).ERROR] (state, action) {
        const { meta: meta } = action;
        return {
            ...state,
            fileTree: {
                id: meta && meta.data.treeId,
                tree: null,
                errorCode: meta && meta.status
            }
        };
    },
    [(0, $kWOUe.LoadSourceObject).REQUEST] (state) {
        return {
            ...state,
            sourceObject: {
                ...state.sourceObject,
                isLoading: true,
                errorCode: null
            }
        };
    },
    [(0, $kWOUe.LoadSourceObject).SUCCESS] (state, action) {
        return {
            ...state,
            sourceObject: {
                ...action.payload,
                isLoading: false,
                errorCode: null
            }
        };
    },
    [(0, $kWOUe.LoadSourceObject).ERROR] (state, action) {
        return {
            ...state,
            sourceObject: {
                ...state.sourceObject,
                ...action.payload,
                isLoading: false,
                treeEntry: null
            }
        };
    },
    [(0, $kWOUe.UNLOAD_DIFF)] (state) {
        return {
            ...state,
            diff: null
        };
    },
    [(0, $kWOUe.UNLOAD_SOURCE)] (state) {
        return {
            ...state,
            atRef: undefined,
            hash: undefined,
            ref: undefined,
            fileTree: null,
            sourceObject: null
        };
    }
});

});
parcelRegister("7cGfh", function(module, exports) {

$parcel$export(module.exports, "NEW_USER_EXPERIMENT_AGE_IN_DAYS", function () { return $4852bb260a4b4194$export$572d7eb2fc6e827b; });
$parcel$export(module.exports, "FilterMode", function () { return $4852bb260a4b4194$export$ec1e12eead838acf; });
const $4852bb260a4b4194$export$572d7eb2fc6e827b = 14;
var $4852bb260a4b4194$export$ec1e12eead838acf;
(function(FilterMode) {
    FilterMode["Files"] = "FILES";
    FilterMode["Code"] = "CODE";
})($4852bb260a4b4194$export$ec1e12eead838acf || ($4852bb260a4b4194$export$ec1e12eead838acf = {}));

});

parcelRegister("bAMD3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee346c76359bd3ad$export$2e2bcd8739ae039; });
function $ee346c76359bd3ad$export$2e2bcd8739ae039(repository, hash) {
    return `${repository.uuid}:${hash}`;
}

});


parcelRegister("htrWd", function(module, exports) {

$parcel$export(module.exports, "findFiles", function () { return $1a9b097f2ab198ee$export$ea5af3cfbbe0553a; });
$parcel$export(module.exports, "limitedFilter", function () { return $1a9b097f2ab198ee$export$cc895af2f4d44cc6; });
$parcel$export(module.exports, "getMatchParts", function () { return $1a9b097f2ab198ee$export$473713f6efdc3a54; });
// @ts-ignore TODO: fix noImplicitAny error here

var $3sZZK = parcelRequire("3sZZK");

var $fLzne = parcelRequire("fLzne");
const $1a9b097f2ab198ee$var$sortFirst = (item)=>{
    return (a, b)=>{
        const isA = a.type === item;
        const isB = b.type === item;
        if (isA && !isB) return -1;
        if (isB && !isA) return 1;
        return 0;
    };
};
const $1a9b097f2ab198ee$var$filesFirst = $1a9b097f2ab198ee$var$sortFirst("file");
const $1a9b097f2ab198ee$var$directoriesFirst = $1a9b097f2ab198ee$var$sortFirst("directory");
const $1a9b097f2ab198ee$var$flattenTree = (directory, parent = "")=>{
    let flat = [];
    directory.contents.slice().sort($1a9b097f2ab198ee$var$filesFirst).forEach((content)=>{
        if (content.type === "directory") flat = flat.concat($1a9b097f2ab198ee$var$flattenTree(content, `${parent}${content.name}/`));
        else flat.push({
            ...content,
            name: `${parent}${content.name}`
        });
    });
    return flat;
};
const $1a9b097f2ab198ee$var$memoTree = (0, $fLzne.default)($1a9b097f2ab198ee$var$flattenTree);
const $1a9b097f2ab198ee$export$ea5af3cfbbe0553a = (tree, query)=>{
    if (!tree || query === null || query === undefined) return [];
    const files = $1a9b097f2ab198ee$var$memoTree(tree);
    if (query === "") return files;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3sZZK))).filter(files, query, {
        key: "name"
    });
};
const $1a9b097f2ab198ee$export$cc895af2f4d44cc6 = (srcFiles, query)=>{
    if (query === "") return srcFiles;
    // Sorted by directory first to make the results
    // more visually consistent pre-search
    return (0, (/*@__PURE__*/$parcel$interopDefault($3sZZK))).filter(srcFiles, query, {
        key: "name"
    }).sort($1a9b097f2ab198ee$var$directoriesFirst);
};
const $1a9b097f2ab198ee$var$matchPart = (text, matches)=>matches ? {
        text: text,
        match: true
    } : {
        text: text
    };
const $1a9b097f2ab198ee$export$473713f6efdc3a54 = (path, query)=>{
    if (!query) return [
        $1a9b097f2ab198ee$var$matchPart(path)
    ];
    if (path === query) return [
        $1a9b097f2ab198ee$var$matchPart(path, true)
    ];
    const matches = (0, (/*@__PURE__*/$parcel$interopDefault($3sZZK))).match(path, query);
    if (!matches.length) return [
        $1a9b097f2ab198ee$var$matchPart(path)
    ];
    // Stolen shamelessly from https://github.com/jeancroy/fuzz-aldrin-plus/blob/master/src/matcher.coffee#L42
    const slices = [];
    let strIdx = 0;
    let matchIdx = -1;
    while(++matchIdx < matches.length){
        let match = matches[matchIdx];
        // Get text before the match position
        if (match > strIdx) {
            slices.push($1a9b097f2ab198ee$var$matchPart(path.slice(strIdx, match)));
            strIdx = match;
        }
        // put consecutive matches together
        while(++matchIdx < matches.length)if (matches[matchIdx] === match + 1) match++;
        else {
            matchIdx--;
            break;
        }
        // Get matched text
        match++;
        slices.push($1a9b097f2ab198ee$var$matchPart(path.slice(strIdx, match), true));
        strIdx = match;
    }
    // Get text after match position
    if (strIdx < path.length) slices.push($1a9b097f2ab198ee$var$matchPart(path.slice(strIdx)));
    return slices;
};

});
parcelRegister("3sZZK", function(module, exports) {

var $8ovux = parcelRequire("8ovux");





(function() {
    var Query, defaultPathSeparator, filter, matcher, parseOptions, pathScorer, preparedQueryCache, scorer;
    filter = (parcelRequire("fYAPA"));
    matcher = (parcelRequire("jvKw3"));
    scorer = (parcelRequire("4ur3R"));
    pathScorer = (parcelRequire("1afIB"));
    Query = (parcelRequire("c4DJD"));
    preparedQueryCache = null;
    defaultPathSeparator = (typeof $8ovux !== "undefined" && $8ovux !== null ? $8ovux.platform : void 0) === "win32" ? "\\" : "/";
    module.exports = {
        filter: function(candidates, query, options) {
            if (options == null) options = {};
            if (!((query != null ? query.length : void 0) && (candidates != null ? candidates.length : void 0))) return [];
            options = parseOptions(options, query);
            return filter(candidates, query, options);
        },
        score: function(string, query, options) {
            if (options == null) options = {};
            if (!((string != null ? string.length : void 0) && (query != null ? query.length : void 0))) return 0;
            options = parseOptions(options, query);
            if (options.usePathScoring) return pathScorer.score(string, query, options);
            else return scorer.score(string, query, options);
        },
        match: function(string, query, options) {
            var _i, _ref, _results;
            if (options == null) options = {};
            if (!string) return [];
            if (!query) return [];
            if (string === query) return (function() {
                _results = [];
                for(var _i = 0, _ref = string.length; 0 <= _ref ? _i < _ref : _i > _ref; 0 <= _ref ? _i++ : _i--)_results.push(_i);
                return _results;
            }).apply(this);
            options = parseOptions(options, query);
            return matcher.match(string, query, options);
        },
        wrap: function(string, query, options) {
            if (options == null) options = {};
            if (!string) return [];
            if (!query) return [];
            options = parseOptions(options, query);
            return matcher.wrap(string, query, options);
        },
        prepareQuery: function(query, options) {
            if (options == null) options = {};
            options = parseOptions(options, query);
            return options.preparedQuery;
        }
    };
    parseOptions = function(options, query) {
        if (options.allowErrors == null) options.allowErrors = false;
        if (options.usePathScoring == null) options.usePathScoring = true;
        if (options.useExtensionBonus == null) options.useExtensionBonus = false;
        if (options.pathSeparator == null) options.pathSeparator = defaultPathSeparator;
        if (options.optCharRegEx == null) options.optCharRegEx = null;
        if (options.wrap == null) options.wrap = null;
        if (options.preparedQuery == null) options.preparedQuery = preparedQueryCache && preparedQueryCache.query === query ? preparedQueryCache : preparedQueryCache = new Query(query, options);
        return options;
    };
}).call(module.exports);

});
parcelRegister("fYAPA", function(module, exports) {



(function() {
    var Query, pathScorer, pluckCandidates, scorer, sortCandidates;
    scorer = (parcelRequire("4ur3R"));
    pathScorer = (parcelRequire("1afIB"));
    Query = (parcelRequire("c4DJD"));
    pluckCandidates = function(a) {
        return a.candidate;
    };
    sortCandidates = function(a, b) {
        return b.score - a.score;
    };
    module.exports = function(candidates, query, options) {
        var bKey, candidate, key, maxInners, maxResults, score, scoreProvider, scoredCandidates, spotLeft, string, usePathScoring, _i, _len;
        scoredCandidates = [];
        key = options.key, maxResults = options.maxResults, maxInners = options.maxInners, usePathScoring = options.usePathScoring;
        spotLeft = maxInners != null && maxInners > 0 ? maxInners : candidates.length + 1;
        bKey = key != null;
        scoreProvider = usePathScoring ? pathScorer : scorer;
        for(_i = 0, _len = candidates.length; _i < _len; _i++){
            candidate = candidates[_i];
            string = bKey ? candidate[key] : candidate;
            if (!string) continue;
            score = scoreProvider.score(string, query, options);
            if (score > 0) {
                scoredCandidates.push({
                    candidate: candidate,
                    score: score
                });
                if (!--spotLeft) break;
            }
        }
        scoredCandidates.sort(sortCandidates);
        candidates = scoredCandidates.map(pluckCandidates);
        if (maxResults != null) candidates = candidates.slice(0, maxResults);
        return candidates;
    };
}).call(module.exports);

});
parcelRegister("4ur3R", function(module, exports) {
(function() {
    var AcronymResult, computeScore, emptyAcronymResult, isAcronymFullWord, isMatch, isSeparator, isWordEnd, isWordStart, miss_coeff, pos_bonus, scoreAcronyms, scoreCharacter, scoreConsecutives, scoreExact, scoreExactMatch, scorePattern, scorePosition, scoreSize, tau_size, wm;
    wm = 150;
    pos_bonus = 20;
    tau_size = 150;
    miss_coeff = 0.75;
    exports.score = function(string, query, options) {
        var allowErrors, preparedQuery, score, string_lw;
        preparedQuery = options.preparedQuery, allowErrors = options.allowErrors;
        if (!(allowErrors || isMatch(string, preparedQuery.core_lw, preparedQuery.core_up))) return 0;
        string_lw = string.toLowerCase();
        score = computeScore(string, string_lw, preparedQuery);
        return Math.ceil(score);
    };
    exports.isMatch = isMatch = function(subject, query_lw, query_up) {
        var i, j, m, n, qj_lw, qj_up, si;
        m = subject.length;
        n = query_lw.length;
        if (!m || n > m) return false;
        i = -1;
        j = -1;
        while(++j < n){
            qj_lw = query_lw.charCodeAt(j);
            qj_up = query_up.charCodeAt(j);
            while(++i < m){
                si = subject.charCodeAt(i);
                if (si === qj_lw || si === qj_up) break;
            }
            if (i === m) return false;
        }
        return true;
    };
    exports.computeScore = computeScore = function(subject, subject_lw, preparedQuery) {
        var acro, acro_score, align, csc_diag, csc_row, csc_score, csc_should_rebuild, i, j, m, miss_budget, miss_left, n, pos, query, query_lw, record_miss, score, score_diag, score_row, score_up, si_lw, start, sz;
        query = preparedQuery.query;
        query_lw = preparedQuery.query_lw;
        m = subject.length;
        n = query.length;
        acro = scoreAcronyms(subject, subject_lw, query, query_lw);
        acro_score = acro.score;
        if (acro.count === n) return scoreExact(n, m, acro_score, acro.pos);
        pos = subject_lw.indexOf(query_lw);
        if (pos > -1) return scoreExactMatch(subject, subject_lw, query, query_lw, pos, n, m);
        score_row = new Array(n);
        csc_row = new Array(n);
        sz = scoreSize(n, m);
        miss_budget = Math.ceil(miss_coeff * n) + 5;
        miss_left = miss_budget;
        csc_should_rebuild = true;
        j = -1;
        while(++j < n){
            score_row[j] = 0;
            csc_row[j] = 0;
        }
        i = -1;
        while(++i < m){
            si_lw = subject_lw[i];
            if (!si_lw.charCodeAt(0) in preparedQuery.charCodes) {
                if (csc_should_rebuild) {
                    j = -1;
                    while(++j < n)csc_row[j] = 0;
                    csc_should_rebuild = false;
                }
                continue;
            }
            score = 0;
            score_diag = 0;
            csc_diag = 0;
            record_miss = true;
            csc_should_rebuild = true;
            j = -1;
            while(++j < n){
                score_up = score_row[j];
                if (score_up > score) score = score_up;
                csc_score = 0;
                if (query_lw[j] === si_lw) {
                    start = isWordStart(i, subject, subject_lw);
                    csc_score = csc_diag > 0 ? csc_diag : scoreConsecutives(subject, subject_lw, query, query_lw, i, j, start);
                    align = score_diag + scoreCharacter(i, j, start, acro_score, csc_score);
                    if (align > score) {
                        score = align;
                        miss_left = miss_budget;
                    } else {
                        if (record_miss && --miss_left <= 0) return Math.max(score, score_row[n - 1]) * sz;
                        record_miss = false;
                    }
                }
                score_diag = score_up;
                csc_diag = csc_row[j];
                csc_row[j] = csc_score;
                score_row[j] = score;
            }
        }
        score = score_row[n - 1];
        return score * sz;
    };
    exports.isWordStart = isWordStart = function(pos, subject, subject_lw) {
        var curr_s, prev_s;
        if (pos === 0) return true;
        curr_s = subject[pos];
        prev_s = subject[pos - 1];
        return isSeparator(prev_s) || curr_s !== subject_lw[pos] && prev_s === subject_lw[pos - 1];
    };
    exports.isWordEnd = isWordEnd = function(pos, subject, subject_lw, len) {
        var curr_s, next_s;
        if (pos === len - 1) return true;
        curr_s = subject[pos];
        next_s = subject[pos + 1];
        return isSeparator(next_s) || curr_s === subject_lw[pos] && next_s !== subject_lw[pos + 1];
    };
    isSeparator = function(c) {
        return c === " " || c === "." || c === "-" || c === "_" || c === "/" || c === "\\";
    };
    scorePosition = function(pos) {
        var sc;
        if (pos < pos_bonus) {
            sc = pos_bonus - pos;
            return 100 + sc * sc;
        } else return Math.max(100 + pos_bonus - pos, 0);
    };
    exports.scoreSize = scoreSize = function(n, m) {
        return tau_size / (tau_size + Math.abs(m - n));
    };
    scoreExact = function(n, m, quality, pos) {
        return 2 * n * (wm * quality + scorePosition(pos)) * scoreSize(n, m);
    };
    exports.scorePattern = scorePattern = function(count, len, sameCase, start, end) {
        var bonus, sz;
        sz = count;
        bonus = 6;
        if (sameCase === count) bonus += 2;
        if (start) bonus += 3;
        if (end) bonus += 1;
        if (count === len) {
            if (start) {
                if (sameCase === len) sz += 2;
                else sz += 1;
            }
            if (end) bonus += 1;
        }
        return sameCase + sz * (sz + bonus);
    };
    exports.scoreCharacter = scoreCharacter = function(i, j, start, acro_score, csc_score) {
        var posBonus;
        posBonus = scorePosition(i);
        if (start) return posBonus + wm * ((acro_score > csc_score ? acro_score : csc_score) + 10);
        return posBonus + wm * csc_score;
    };
    exports.scoreConsecutives = scoreConsecutives = function(subject, subject_lw, query, query_lw, i, j, startOfWord) {
        var k, m, mi, n, nj, sameCase, sz;
        m = subject.length;
        n = query.length;
        mi = m - i;
        nj = n - j;
        k = mi < nj ? mi : nj;
        sameCase = 0;
        sz = 0;
        if (query[j] === subject[i]) sameCase++;
        while(++sz < k && query_lw[++j] === subject_lw[++i])if (query[j] === subject[i]) sameCase++;
        if (sz < k) i--;
        if (sz === 1) return 1 + 2 * sameCase;
        return scorePattern(sz, n, sameCase, startOfWord, isWordEnd(i, subject, subject_lw, m));
    };
    exports.scoreExactMatch = scoreExactMatch = function(subject, subject_lw, query, query_lw, pos, n, m) {
        var end, i, pos2, sameCase, start;
        start = isWordStart(pos, subject, subject_lw);
        if (!start) {
            pos2 = subject_lw.indexOf(query_lw, pos + 1);
            if (pos2 > -1) {
                start = isWordStart(pos2, subject, subject_lw);
                if (start) pos = pos2;
            }
        }
        i = -1;
        sameCase = 0;
        while(++i < n)if (query[pos + i] === subject[i]) sameCase++;
        end = isWordEnd(pos + n - 1, subject, subject_lw, m);
        return scoreExact(n, m, scorePattern(n, n, sameCase, start, end), pos);
    };
    AcronymResult = function() {
        function AcronymResult(score, pos, count) {
            this.score = score;
            this.pos = pos;
            this.count = count;
        }
        return AcronymResult;
    }();
    emptyAcronymResult = new AcronymResult(0, 0.1, 0);
    exports.scoreAcronyms = scoreAcronyms = function(subject, subject_lw, query, query_lw) {
        var count, fullWord, i, j, m, n, qj_lw, sameCase, score, sepCount, sumPos;
        m = subject.length;
        n = query.length;
        if (!(m > 1 && n > 1)) return emptyAcronymResult;
        count = 0;
        sepCount = 0;
        sumPos = 0;
        sameCase = 0;
        i = -1;
        j = -1;
        while(++j < n){
            qj_lw = query_lw[j];
            if (isSeparator(qj_lw)) {
                i = subject_lw.indexOf(qj_lw, i + 1);
                if (i > -1) {
                    sepCount++;
                    continue;
                } else break;
            }
            while(++i < m)if (qj_lw === subject_lw[i] && isWordStart(i, subject, subject_lw)) {
                if (query[j] === subject[i]) sameCase++;
                sumPos += i;
                count++;
                break;
            }
            if (i === m) break;
        }
        if (count < 2) return emptyAcronymResult;
        fullWord = count === n ? isAcronymFullWord(subject, subject_lw, query, count) : false;
        score = scorePattern(count, n, sameCase, true, fullWord);
        return new AcronymResult(score, sumPos / count, count + sepCount);
    };
    isAcronymFullWord = function(subject, subject_lw, query, nbAcronymInQuery) {
        var count, i, m, n;
        m = subject.length;
        n = query.length;
        count = 0;
        if (m > 12 * n) return false;
        i = -1;
        while(++i < m){
            if (isWordStart(i, subject, subject_lw) && ++count > nbAcronymInQuery) return false;
        }
        return true;
    };
}).call(this);

});

parcelRegister("1afIB", function(module, exports) {

(function() {
    var computeScore, countDir, file_coeff, getExtension, getExtensionScore, isMatch, scorePath, scoreSize, tau_depth, _ref;
    _ref = (parcelRequire("4ur3R")), isMatch = _ref.isMatch, computeScore = _ref.computeScore, scoreSize = _ref.scoreSize;
    tau_depth = 20;
    file_coeff = 2.5;
    module.exports.score = function(string, query, options) {
        var allowErrors, preparedQuery, score, string_lw;
        preparedQuery = options.preparedQuery, allowErrors = options.allowErrors;
        if (!(allowErrors || isMatch(string, preparedQuery.core_lw, preparedQuery.core_up))) return 0;
        string_lw = string.toLowerCase();
        score = computeScore(string, string_lw, preparedQuery);
        score = scorePath(string, string_lw, score, options);
        return Math.ceil(score);
    };
    scorePath = function(subject, subject_lw, fullPathScore, options) {
        var alpha, basePathScore, basePos, depth, end, extAdjust, fileLength, pathSeparator, preparedQuery, useExtensionBonus;
        if (fullPathScore === 0) return 0;
        preparedQuery = options.preparedQuery, useExtensionBonus = options.useExtensionBonus, pathSeparator = options.pathSeparator;
        end = subject.length - 1;
        while(subject[end] === pathSeparator)end--;
        basePos = subject.lastIndexOf(pathSeparator, end);
        fileLength = end - basePos;
        extAdjust = 1.0;
        if (useExtensionBonus) {
            extAdjust += getExtensionScore(subject_lw, preparedQuery.ext, basePos, end, 2);
            fullPathScore *= extAdjust;
        }
        if (basePos === -1) return fullPathScore;
        depth = preparedQuery.depth;
        while(basePos > -1 && depth-- > 0)basePos = subject.lastIndexOf(pathSeparator, basePos - 1);
        basePathScore = basePos === -1 ? fullPathScore : extAdjust * computeScore(subject.slice(basePos + 1, end + 1), subject_lw.slice(basePos + 1, end + 1), preparedQuery);
        alpha = 0.5 * tau_depth / (tau_depth + countDir(subject, end + 1, pathSeparator));
        return alpha * basePathScore + (1 - alpha) * fullPathScore * scoreSize(0, file_coeff * fileLength);
    };
    module.exports.countDir = countDir = function(path, end, pathSeparator) {
        var count, i;
        if (end < 1) return 0;
        count = 0;
        i = -1;
        while(++i < end && path[i] === pathSeparator)continue;
        while(++i < end)if (path[i] === pathSeparator) {
            count++;
            while(++i < end && path[i] === pathSeparator)continue;
        }
        return count;
    };
    module.exports.getExtension = getExtension = function(str) {
        var pos;
        pos = str.lastIndexOf(".");
        if (pos < 0) return "";
        else return str.substr(pos + 1);
    };
    getExtensionScore = function(candidate, ext, startPos, endPos, maxDepth) {
        var m, matched, n, pos;
        if (!ext.length) return 0;
        pos = candidate.lastIndexOf(".", endPos);
        if (!(pos > startPos)) return 0;
        n = ext.length;
        m = endPos - pos;
        if (m < n) {
            n = m;
            m = ext.length;
        }
        pos++;
        matched = -1;
        while(++matched < n){
            if (candidate[pos + matched] !== ext[matched]) break;
        }
        if (matched === 0 && maxDepth > 0) return 0.9 * getExtensionScore(candidate, ext, startPos, pos - 2, maxDepth - 1);
        return matched / m;
    };
}).call(module.exports);

});

parcelRegister("c4DJD", function(module, exports) {

(function() {
    var Query, coreChars, countDir, getCharCodes, getExtension, opt_char_re, truncatedUpperCase, _ref;
    _ref = (parcelRequire("1afIB")), countDir = _ref.countDir, getExtension = _ref.getExtension;
    module.exports = Query = function() {
        function Query(query, _arg) {
            var optCharRegEx, pathSeparator, _ref1;
            _ref1 = _arg != null ? _arg : {}, optCharRegEx = _ref1.optCharRegEx, pathSeparator = _ref1.pathSeparator;
            if (!(query && query.length)) return null;
            this.query = query;
            this.query_lw = query.toLowerCase();
            this.core = coreChars(query, optCharRegEx);
            this.core_lw = this.core.toLowerCase();
            this.core_up = truncatedUpperCase(this.core);
            this.depth = countDir(query, query.length, pathSeparator);
            this.ext = getExtension(this.query_lw);
            this.charCodes = getCharCodes(this.query_lw);
        }
        return Query;
    }();
    opt_char_re = /[ _\-:\/\\]/g;
    coreChars = function(query, optCharRegEx) {
        if (optCharRegEx == null) optCharRegEx = opt_char_re;
        return query.replace(optCharRegEx, "");
    };
    truncatedUpperCase = function(str) {
        var char, upper, _i, _len;
        upper = "";
        for(_i = 0, _len = str.length; _i < _len; _i++){
            char = str[_i];
            upper += char.toUpperCase()[0];
        }
        return upper;
    };
    getCharCodes = function(str) {
        var charCodes, i, len;
        len = str.length;
        i = -1;
        charCodes = [];
        while(++i < len)charCodes[str.charCodeAt(i)] = true;
        return charCodes;
    };
}).call(module.exports);

});


parcelRegister("jvKw3", function(module, exports) {

(function() {
    var basenameMatch, computeMatch, isMatch, isWordStart, match, mergeMatches, scoreAcronyms, scoreCharacter, scoreConsecutives, _ref;
    _ref = (parcelRequire("4ur3R")), isMatch = _ref.isMatch, isWordStart = _ref.isWordStart, scoreConsecutives = _ref.scoreConsecutives, scoreCharacter = _ref.scoreCharacter, scoreAcronyms = _ref.scoreAcronyms;
    module.exports.match = match = function(string, query, options) {
        var allowErrors, baseMatches, matches, pathSeparator, preparedQuery, string_lw;
        allowErrors = options.allowErrors, preparedQuery = options.preparedQuery, pathSeparator = options.pathSeparator;
        if (!(allowErrors || isMatch(string, preparedQuery.core_lw, preparedQuery.core_up))) return [];
        string_lw = string.toLowerCase();
        matches = computeMatch(string, string_lw, preparedQuery);
        if (matches.length === 0) return matches;
        if (string.indexOf(pathSeparator) > -1) {
            baseMatches = basenameMatch(string, string_lw, preparedQuery, pathSeparator);
            matches = mergeMatches(matches, baseMatches);
        }
        return matches;
    };
    module.exports.wrap = function(string, query, options) {
        var matchIndex, matchPos, matchPositions, output, strPos, tagClass, tagClose, tagOpen, _ref1;
        if (options.wrap != null) _ref1 = options.wrap, tagClass = _ref1.tagClass, tagOpen = _ref1.tagOpen, tagClose = _ref1.tagClose;
        if (tagClass == null) tagClass = "highlight";
        if (tagOpen == null) tagOpen = '<strong class="' + tagClass + '">';
        if (tagClose == null) tagClose = "</strong>";
        if (string === query) return tagOpen + string + tagClose;
        matchPositions = match(string, query, options);
        if (matchPositions.length === 0) return string;
        output = "";
        matchIndex = -1;
        strPos = 0;
        while(++matchIndex < matchPositions.length){
            matchPos = matchPositions[matchIndex];
            if (matchPos > strPos) {
                output += string.substring(strPos, matchPos);
                strPos = matchPos;
            }
            while(++matchIndex < matchPositions.length)if (matchPositions[matchIndex] === matchPos + 1) matchPos++;
            else {
                matchIndex--;
                break;
            }
            matchPos++;
            if (matchPos > strPos) {
                output += tagOpen;
                output += string.substring(strPos, matchPos);
                output += tagClose;
                strPos = matchPos;
            }
        }
        if (strPos <= string.length - 1) output += string.substring(strPos);
        return output;
    };
    basenameMatch = function(subject, subject_lw, preparedQuery, pathSeparator) {
        var basePos, depth, end;
        end = subject.length - 1;
        while(subject[end] === pathSeparator)end--;
        basePos = subject.lastIndexOf(pathSeparator, end);
        if (basePos === -1) return [];
        depth = preparedQuery.depth;
        while(depth-- > 0){
            basePos = subject.lastIndexOf(pathSeparator, basePos - 1);
            if (basePos === -1) return [];
        }
        basePos++;
        end++;
        return computeMatch(subject.slice(basePos, end), subject_lw.slice(basePos, end), preparedQuery, basePos);
    };
    mergeMatches = function(a, b) {
        var ai, bj, i, j, m, n, out;
        m = a.length;
        n = b.length;
        if (n === 0) return a.slice();
        if (m === 0) return b.slice();
        i = -1;
        j = 0;
        bj = b[j];
        out = [];
        while(++i < m){
            ai = a[i];
            while(bj <= ai && ++j < n){
                if (bj < ai) out.push(bj);
                bj = b[j];
            }
            out.push(ai);
        }
        while(j < n)out.push(b[j++]);
        return out;
    };
    computeMatch = function(subject, subject_lw, preparedQuery, offset) {
        var DIAGONAL, LEFT, STOP, UP, acro_score, align, backtrack, csc_diag, csc_row, csc_score, i, j, m, matches, move, n, pos, query, query_lw, score, score_diag, score_row, score_up, si_lw, start, trace;
        if (offset == null) offset = 0;
        query = preparedQuery.query;
        query_lw = preparedQuery.query_lw;
        m = subject.length;
        n = query.length;
        acro_score = scoreAcronyms(subject, subject_lw, query, query_lw).score;
        score_row = new Array(n);
        csc_row = new Array(n);
        STOP = 0;
        UP = 1;
        LEFT = 2;
        DIAGONAL = 3;
        trace = new Array(m * n);
        pos = -1;
        j = -1;
        while(++j < n){
            score_row[j] = 0;
            csc_row[j] = 0;
        }
        i = -1;
        while(++i < m){
            score = 0;
            score_up = 0;
            csc_diag = 0;
            si_lw = subject_lw[i];
            j = -1;
            while(++j < n){
                csc_score = 0;
                align = 0;
                score_diag = score_up;
                if (query_lw[j] === si_lw) {
                    start = isWordStart(i, subject, subject_lw);
                    csc_score = csc_diag > 0 ? csc_diag : scoreConsecutives(subject, subject_lw, query, query_lw, i, j, start);
                    align = score_diag + scoreCharacter(i, j, start, acro_score, csc_score);
                }
                score_up = score_row[j];
                csc_diag = csc_row[j];
                if (score > score_up) move = LEFT;
                else {
                    score = score_up;
                    move = UP;
                }
                if (align > score) {
                    score = align;
                    move = DIAGONAL;
                } else csc_score = 0;
                score_row[j] = score;
                csc_row[j] = csc_score;
                trace[++pos] = score > 0 ? move : STOP;
            }
        }
        i = m - 1;
        j = n - 1;
        pos = i * n + j;
        backtrack = true;
        matches = [];
        while(backtrack && i >= 0 && j >= 0)switch(trace[pos]){
            case UP:
                i--;
                pos -= n;
                break;
            case LEFT:
                j--;
                pos--;
                break;
            case DIAGONAL:
                matches.push(i + offset);
                j--;
                i--;
                pos -= n + 1;
                break;
            default:
                backtrack = false;
        }
        matches.reverse();
        return matches;
    };
}).call(module.exports);

});




parcelRegister("hreZc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $191ad5c866b12aa4$export$2e2bcd8739ae039; });

var $lIZwG = parcelRequire("lIZwG");
parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $81XY6 = parcelRequire("81XY6");

var $aanBq = parcelRequire("aanBq");

var $M3cyx = parcelRequire("M3cyx");

var $kWOUe = parcelRequire("kWOUe");

var $1TVZd = parcelRequire("1TVZd");

var $3LIzP = parcelRequire("3LIzP");

var $ezDRt = parcelRequire("ezDRt");
function* $191ad5c866b12aa4$var$loadFile() {
    while(true){
        // @ts-ignore
        const loadFileAction = yield (0, $5NpoY.M)((0, $kWOUe.LOAD_SOURCE_FILE));
        const path = loadFileAction.payload;
        const repo = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
        // @ts-ignore
        const hash = yield (0, $5NpoY.a3)((state)=>(0, $lIZwG.default)(state, "repository.source.section.hash", ""));
        const response = yield (0, $81XY6.default)((0, $3LIzP.default)(repo, hash, path));
        if (response.error) continue;
        const { attributes: attributes } = response.payload;
        if (attributes.includes("lfs")) {
            yield (0, $5NpoY.Y)((0, $ezDRt.default)(repo, hash, path));
            continue;
        }
        if (attributes.includes("binary")) continue;
        yield (0, $5NpoY.Y)((0, $1TVZd.default)(repo.full_name, path, {
            hash: hash
        }));
    }
}
// @ts-ignore TODO: fix noImplicitAny error here
function $191ad5c866b12aa4$var$getAttributeTags(attributes) {
    if (attributes.length === 0) return [
        "type:source"
    ];
    // @ts-ignore TODO: fix noImplicitAny error here
    return attributes.map((attribute)=>`type:${attribute}`);
}
// @ts-ignore TODO: fix noImplicitAny error here
function $191ad5c866b12aa4$var$postMetaStats(loadMetaAction) {
    const { attributes: attributes, size: size } = loadMetaAction.payload;
    (0, $M3cyx.statsdApiClient).histogram({
        "frontbucket.source.size": size
    }, {
        tags: $191ad5c866b12aa4$var$getAttributeTags(attributes)
    });
}
function* $191ad5c866b12aa4$export$2e2bcd8739ae039() {
    yield (0, $5NpoY._)([
        $191ad5c866b12aa4$var$loadFile(),
        (0, $jeUNF.takeEvery)((0, $kWOUe.LoadFileMeta).SUCCESS, $191ad5c866b12aa4$var$postMetaStats)
    ]);
}

});
parcelRegister("81XY6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60f6658d4a81d5da$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
function* $60f6658d4a81d5da$export$2e2bcd8739ae039(action) {
    const result = yield (0, $5NpoY.Y)(action);
    // It might already be a SUCCESS, e.g. if the response was cached
    const { type: type, meta: { asyncAction: asyncAction } } = result;
    if (type === asyncAction.SUCCESS) return result;
    const { success: success, error: error } = yield (0, $5NpoY.T)({
        success: (0, $5NpoY.M)(asyncAction.SUCCESS),
        error: (0, $5NpoY.M)(asyncAction.ERROR)
    });
    return success || error;
}

});

parcelRegister("1TVZd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3451b9655c067b6f$export$2e2bcd8739ae039; });
parcelRequire("5YpaN");
var $fICwP = parcelRequire("fICwP");

var $635SY = parcelRequire("635SY");

var $kWOUe = parcelRequire("kWOUe");
var $3451b9655c067b6f$export$2e2bcd8739ae039 = (repositoryFullSlug, path, { hash: hash })=>(0, $fICwP.fetchAction)((0, $kWOUe.LoadFileContents), {
        url: (0, $635SY.default).api.v20.source(repositoryFullSlug, hash, path),
        fetchOptions: {
            responseType: "text"
        }
    });

});

parcelRegister("3LIzP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be199e6fcac3959c$export$2e2bcd8739ae039; });
parcelRequire("5YpaN");
var $fICwP = parcelRequire("fICwP");

var $635SY = parcelRequire("635SY");

var $kWOUe = parcelRequire("kWOUe");
var $be199e6fcac3959c$export$2e2bcd8739ae039 = (repository, ref, path)=>(0, $fICwP.fetchAction)((0, $kWOUe.LoadFileMeta), {
        url: (0, $635SY.default).api.v20.source(repository.full_name, ref, path, {
            format: "meta"
        }),
        fetchOptions: {
            errorType: "text"
        }
    });

});

parcelRegister("ezDRt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a856048119bb6bc3$export$2e2bcd8739ae039; });
parcelRequire("5YpaN");
var $fICwP = parcelRequire("fICwP");

var $635SY = parcelRequire("635SY");

var $kWOUe = parcelRequire("kWOUe");
var $a856048119bb6bc3$export$2e2bcd8739ae039 = (repository, ref, path)=>(0, $fICwP.fetchAction)((0, $kWOUe.LoadLfsInfo), {
        url: (0, $635SY.default).api.internal.lfsInfo(repository.full_name, ref, path)
    });

});


parcelRegister("e3DLv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9d42470a701e4c8$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $kWOUe = parcelRequire("kWOUe");

var $7W3UV = parcelRequire("7W3UV");

var $dxHyo = parcelRequire("dxHyo");

var $bAMD3 = parcelRequire("bAMD3");
function* $a9d42470a701e4c8$export$af6e8ba36cd75d3e(action) {
    // eslint-disable-next-line prefer-destructuring
    const payload = action.payload;
    const { repository: repository, hash: hash } = payload;
    const treeId = (0, $bAMD3.default)(repository, hash);
    // See if the tree is already loaded
    const currentFileTree = yield (0, $5NpoY.a3)((0, $dxHyo.getFileTree));
    if (currentFileTree && currentFileTree.id === treeId && currentFileTree.tree) return;
    // A tree is needed, go and get it.
    yield (0, $5NpoY.Y)((0, $7W3UV.default)(repository.full_name, hash, treeId));
}
function* $a9d42470a701e4c8$export$2e2bcd8739ae039() {
    yield (0, $jeUNF.takeLatest)((0, $kWOUe.LoadFileTree).REQUEST, $a9d42470a701e4c8$export$af6e8ba36cd75d3e);
}

});
parcelRegister("7W3UV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db9613611c706864$export$2e2bcd8739ae039; });
parcelRequire("5YpaN");
var $fICwP = parcelRequire("fICwP");

var $635SY = parcelRequire("635SY");

var $kWOUe = parcelRequire("kWOUe");
var $db9613611c706864$export$2e2bcd8739ae039 = (repoFullName, hash, treeId)=>(0, $fICwP.fetchAction)((0, $kWOUe.FetchFileTree), {
        url: (0, $635SY.default).api.internal.tree(repoFullName, hash),
        data: {
            repoFullName: repoFullName,
            hash: hash,
            treeId: treeId
        }
    });

});


parcelRegister("fZJ8T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5a6a3d8465d3423$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");

var $81XY6 = parcelRequire("81XY6");

var $kWOUe = parcelRequire("kWOUe");

var $NQwsu = parcelRequire("NQwsu");

var $7Ju3s = parcelRequire("7Ju3s");

var $dxHyo = parcelRequire("dxHyo");

var $bAMD3 = parcelRequire("bAMD3");

var $g6Mnr = parcelRequire("g6Mnr");
function* $f5a6a3d8465d3423$var$fetchObjectType(repo, hash, path) {
    if (path === "") return {
        objectType: "directory"
    };
    const { error: error, payload: payload, meta: meta } = yield (0, $81XY6.default)((0, $7Ju3s.default)(repo.full_name, hash, path));
    if (error) {
        const { status: errorCode } = meta;
        return {
            objectType: "error",
            errorCode: errorCode
        };
    }
    if (payload.type === "commit_directory") return {
        objectType: "directory"
    };
    return {
        objectType: "file"
    };
}
/**
 * Load the contents of a single directory.
 */ function* $f5a6a3d8465d3423$var$getDirectory(repo, hash, path) {
    const { error: error, payload: payload } = yield (0, $81XY6.default)((0, $NQwsu.default)(repo.full_name, hash, path));
    if (error) {
        yield (0, $5NpoY.Y)({
            type: (0, $kWOUe.LoadSourceObject).ERROR,
            error: true,
            payload: {
                errorCode: -1
            }
        });
        return;
    }
    const fileTree = payload[0];
    yield (0, $5NpoY.Y)({
        type: (0, $kWOUe.LoadSourceObject).SUCCESS,
        payload: {
            hash: hash,
            path: path,
            treeEntry: fileTree
        }
    });
}
function* $f5a6a3d8465d3423$export$e11a13095696747c(action) {
    // eslint-disable-next-line prefer-destructuring
    const payload = action.payload;
    const { repo: repo, hash: hash, path: path } = payload;
    const treeId = (0, $bAMD3.default)(repo, hash);
    // Pull from the tree if it's available
    const fileTree = yield (0, $5NpoY.a3)((0, $dxHyo.getFileTree));
    if (fileTree && fileTree.id === treeId && fileTree.tree) {
        yield (0, $5NpoY.Y)({
            type: (0, $kWOUe.LoadSourceObject).SUCCESS,
            payload: {
                hash: hash,
                path: path,
                treeEntry: (0, $g6Mnr.default)(fileTree.tree, path)
            }
        });
        return;
    }
    // We don't know what this object is, so get metadata about it
    // so we can choose the right thing to do.
    const { objectType: objectType, errorCode: errorCode } = yield (0, $5NpoY.P)($f5a6a3d8465d3423$var$fetchObjectType, repo, hash, path);
    switch(objectType){
        case "directory":
            yield (0, $5NpoY.P)($f5a6a3d8465d3423$var$getDirectory, repo, hash, path);
            break;
        case "file":
            yield (0, $5NpoY.Y)({
                type: (0, $kWOUe.LoadSourceObject).SUCCESS,
                payload: {
                    hash: hash,
                    path: path,
                    treeEntry: {
                        name: path.split("/").slice(-1)[0],
                        type: "file"
                    }
                }
            });
            break;
        default:
            yield (0, $5NpoY.Y)({
                type: (0, $kWOUe.LoadSourceObject).ERROR,
                error: true,
                payload: {
                    errorCode: errorCode
                }
            });
            break;
    }
}
function* $f5a6a3d8465d3423$export$2e2bcd8739ae039() {
    yield (0, $jeUNF.takeLatest)((0, $kWOUe.LoadSourceObject).REQUEST, $f5a6a3d8465d3423$export$e11a13095696747c);
}

});
parcelRegister("NQwsu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66f32994ca5ec610$export$2e2bcd8739ae039; });
parcelRequire("5YpaN");
var $fICwP = parcelRequire("fICwP");

var $635SY = parcelRequire("635SY");

var $kWOUe = parcelRequire("kWOUe");
var $66f32994ca5ec610$export$2e2bcd8739ae039 = (repoFullName, hash, path)=>(0, $fICwP.fetchAction)((0, $kWOUe.FetchDirectory), {
        url: (0, $635SY.default).api.internal.tree(repoFullName, hash, {
            maxDepth: 1,
            path: path
        })
    });

});

parcelRegister("7Ju3s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7fc1ec36445bebd$export$2e2bcd8739ae039; });
parcelRequire("5YpaN");
var $fICwP = parcelRequire("fICwP");

var $635SY = parcelRequire("635SY");

var $kWOUe = parcelRequire("kWOUe");
var $f7fc1ec36445bebd$export$2e2bcd8739ae039 = (repoFullName, ref, path)=>(0, $fICwP.fetchAction)((0, $kWOUe.FetchSourceObjectMeta), {
        url: (0, $635SY.default).api.v20.source(repoFullName, ref, path, {
            format: "meta"
        }),
        fetchOptions: {
            errorType: "text"
        }
    });

});

parcelRegister("g6Mnr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $249521ef6c94bdad$export$2e2bcd8739ae039; });
function $249521ef6c94bdad$export$2e2bcd8739ae039(directory, path) {
    const adjustedPath = path ? `./${path}` : ".";
    const pathParts = adjustedPath.split("/");
    let pathToCheck = [];
    let treeEntry;
    while(pathParts.length){
        if (treeEntry && treeEntry.type !== "directory") return undefined;
        pathToCheck.push(pathParts.shift());
        const currentPath = pathToCheck.join("/");
        // @ts-ignore TODO: fix noImplicitAny error here
        const contents = treeEntry ? treeEntry.contents : [
            directory
        ];
        // @ts-ignore TODO: fix noImplicitAny error here
        const [matchingEntry] = contents.filter(// @ts-ignore TODO: fix noImplicitAny error here
        (entry)=>entry.name === currentPath);
        if (matchingEntry) {
            pathToCheck = [];
            treeEntry = matchingEntry;
        }
    }
    return pathToCheck.length ? undefined : treeEntry;
}

});



parcelRegister("jBylV", function(module, exports) {

$parcel$export(module.exports, "fetchLatestActionSaga", function () { return $e5416410878d8933$export$e83191f55de58ab6; });
$parcel$export(module.exports, "default", function () { return $e5416410878d8933$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
var $jeUNF = parcelRequire("jeUNF");
parcelRequire("5YpaN");
var $kTw57 = parcelRequire("kTw57");
function* $e5416410878d8933$export$1686aec5678ceb1c(action) {
    if (action.meta.isRouterResource) return;
    // @ts-ignore
    yield (0, $5NpoY.Y)((0, $kTw57.fetchData)(action));
}
function* $e5416410878d8933$var$loadAllDatas() {
    yield (0, $jeUNF.takeEvery)(// @ts-ignore TODO: fix noImplicitAny error here
    (a)=>a.meta && a.meta.asyncAction && a.type === a.meta.asyncAction.REQUEST && !a.meta.isCached && !a.meta.takeLatest, $e5416410878d8933$export$1686aec5678ceb1c);
}
function* $e5416410878d8933$export$e83191f55de58ab6() {
    yield (0, $jeUNF.takeLatest)(// @ts-ignore TODO: fix noImplicitAny error here
    (a)=>a.meta && a.meta.asyncAction && a.type === a.meta.asyncAction.REQUEST && !a.meta.isCached && a.meta.takeLatest, $e5416410878d8933$export$1686aec5678ceb1c);
}
var $e5416410878d8933$export$2e2bcd8739ae039 = $e5416410878d8933$var$loadAllDatas;

});

parcelRegister("gJJYb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce82abd0d117a7b8$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");

var $4ZJ1X = parcelRequire("4ZJ1X");

var $3UXCH = parcelRequire("3UXCH");
function* $ce82abd0d117a7b8$var$loadRepositoryErrorSaga() {
    const isRepositoryPageLoadingErrorGuardEnabled = (0, $5NpoY.a3)((0, $3UXCH.getIsRepositoryPageLoadingErrorGuardEnabled));
    if (isRepositoryPageLoadingErrorGuardEnabled) while(true){
        yield (0, $5NpoY.M)((0, $jJd6W.LoadRepositoryPage).ERROR);
        yield (0, $5NpoY.Y)((0, $4ZJ1X.default)());
    }
}
var $ce82abd0d117a7b8$export$2e2bcd8739ae039 = $ce82abd0d117a7b8$var$loadRepositoryErrorSaga;

});
parcelRegister("4ZJ1X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b75c7aa32546dd76$export$2e2bcd8739ae039; });
parcelRequire("5YpaN");
var $fICwP = parcelRequire("fICwP");

var $jJd6W = parcelRequire("jJd6W");

var $kZnTB = parcelRequire("kZnTB");
const $b75c7aa32546dd76$var$fetchUserEmails = ()=>(0, $fICwP.fetchAction)((0, $jJd6W.FetchUserEmails), {
        url: `${(0, $kZnTB.default).api.v20.email()}`
    });
var $b75c7aa32546dd76$export$2e2bcd8739ae039 = $b75c7aa32546dd76$var$fetchUserEmails;

});


parcelRegister("gEKvy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14bb7101b1dcb6e3$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("fojQl");
var $j7nzB = parcelRequire("j7nzB");

var $grdQ5 = parcelRequire("grdQ5");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");

var $jz394 = parcelRequire("jz394");

var $aanBq = parcelRequire("aanBq");

var $g2R3c = parcelRequire("g2R3c");

var $cOITW = parcelRequire("cOITW");
function* $14bb7101b1dcb6e3$var$loadRepositorySuccess() {
    while(true){
        yield (0, $5NpoY.M)((0, $jJd6W.LoadRepositoryPage).SUCCESS);
        const repository = yield (0, $5NpoY.a3)((0, $aanBq.getCurrentRepository));
        yield (0, $5NpoY.Y)((0, $grdQ5.addRecentlyViewedRepository)(repository));
        // At this point the currentUser should have been set by the GlobalState reducer in src/redux/global/reducer.ts
        const user = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
        if (user) yield (0, $5NpoY.Y)((0, $jz394.default)(repository));
        if (repository.mainbranch && repository.mainbranch.name) yield (0, $5NpoY.Y)((0, $cOITW.default)((0, $jJd6W.FetchRepositoryMainBranch), repository.full_name, repository.mainbranch.name));
        const [repositoryOwner, repositorySlug] = repository.full_name.split("/");
        const options = {
            repositoryOwner: repositoryOwner,
            repositorySlug: repositorySlug
        };
        yield (0, $5NpoY.Y)((0, $j7nzB.loadBranchingModel)(options));
    }
}
var $14bb7101b1dcb6e3$export$2e2bcd8739ae039 = $14bb7101b1dcb6e3$var$loadRepositorySuccess;

});
parcelRegister("jz394", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf724522c1171941$export$2e2bcd8739ae039; });
parcelRequire("5YpaN");
var $fICwP = parcelRequire("fICwP");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");
function $cf724522c1171941$export$2e2bcd8739ae039(repository) {
    const repoSlug = repository.slug;
    const { workspace: workspace } = repository;
    const { slug: workspaceSlug } = workspace || {};
    if (workspaceSlug && repoSlug) return (0, $fICwP.fetchAction)((0, $jJd6W.FETCH_FORGE_REPO_MENU_ITEMS), {
        url: `/!api/internal/repositories/${workspaceSlug}/${repoSlug}/forge/menu-items`
    });
    else return {
        type: (0, $jJd6W.FETCH_FORGE_REPO_MENU_ITEMS).ERROR,
        payload: "Missing workspace and/or repository slug."
    };
}

});


parcelRegister("1a7QU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d75a1632a4b94700$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");

var $grdQ5 = parcelRequire("grdQ5");

var $7qdXF = parcelRequire("7qdXF");

var $g2R3c = parcelRequire("g2R3c");

var $5utbt = parcelRequire("5utbt");

var $7hVkj = parcelRequire("7hVkj");
function* $d75a1632a4b94700$var$removeRecentlyViewedRepository() {
    while(true){
        // @ts-ignore
        const action = yield (0, $5NpoY.M)((0, $grdQ5.FetchRecentlyViewedRepository).ERROR);
        const currentUser = yield (0, $5NpoY.a3)((0, $g2R3c.getCurrentUser));
        if (!currentUser) continue;
        const { status: status } = action.meta;
        if (status === 404 || status === 403) {
            /**
       * By the time this saga runs, the reducer (in `src/redux/recently-viewed-repositories/index.ts`) has already
       * updated the data in redux to reflect the correct set of repositories based on the
       * `FetchRecentlyViewedRepository.ERROR` action. That way the removal logic and the source of truth are
       * consolidated in one spot (the reducer)
       *
       * We retrieve the entity keys directly instead of denormalizing because we might have some in-flight
       * requests where the repository entity doesn't exist quite yet, and we don't want to remove
       * those from localstorage. Also it's a bit faster to skip denormalization.
       */ const recentlyViewedRepositoryUuids = yield (0, $5NpoY.a3)((0, $7qdXF.getRecentlyViewedRepositoriesKeys));
            const workspaceUuid = yield (0, $5NpoY.a3)((0, $5utbt.getCurrentWorkspaceUUID));
            const recentlyViewedRepositoriesStore = yield (0, $5NpoY.P)((0, $7hVkj.default).get, currentUser);
            const { workspaceUuids: workspaceUuids } = recentlyViewedRepositoriesStore;
            const recentRepositoryUuidsStore = workspaceUuids[workspaceUuid];
            if (!recentRepositoryUuidsStore) return;
            /* 
        We return the intersection of the two arrays (redux repo uuids and local store repo uuids) since
        we only want to update recent repo uuids for a given workspace.
         `recentlyViewedRepositoryUuids` will be an array of uuids that may or may not include repo uuids
        across many workspaces but is also the source of truth with the correct set of repo uuids.
         `recentRepositoryUuidsStore` will be an array of repo uuids from local storage that is scoped to
        a workspace but may not be accurately updated for reasons such as the repository was deleted.
         We filter out repo uuids outside the scope of the given workspace and also filter out repo
        uuids that should be removed from local storage. See `recently-viewed-repositories-store.ts`
        for context on how recently-viewed-repositories local storage changed.
        */ const filteredRepositoryUuids = recentlyViewedRepositoryUuids.filter((uuid)=>recentRepositoryUuidsStore.includes(uuid));
            workspaceUuids[workspaceUuid] = filteredRepositoryUuids;
            yield (0, $5NpoY.P)((0, $7hVkj.default).set, currentUser, {
                workspaceUuids: workspaceUuids
            });
        }
    }
}
var $d75a1632a4b94700$export$2e2bcd8739ae039 = $d75a1632a4b94700$var$removeRecentlyViewedRepository;

});

parcelRegister("hZ2vI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb056eda1e6d37bb$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("fojQl");
var $j7nzB = parcelRequire("j7nzB");
parcelRequire("erZj9");
var $g7vJB = parcelRequire("g7vJB");
parcelRequire("5vUfT");
var $gAfkB = parcelRequire("gAfkB");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");
function* $bb056eda1e6d37bb$var$unloadRepository() {
    while(true){
        yield (0, $5NpoY.M)((0, $jJd6W.UNLOAD_REPOSITORY));
        yield (0, $5NpoY._)([
            (0, $5NpoY.Y)((0, $j7nzB.unloadBranches)()),
            (0, $5NpoY.Y)((0, $gAfkB.unloadPullRequests)()),
            // We currently cache the connected sites, projects, and issue metadata information
            // in the reducer for creating Jira issue feature.
            // This needs to be cleared when users move to the repo in a different workspace.
            // Currently, we don't have an easier way to tell if the user has moved to a repo
            // in a different workspace, but we can easily tell when the user moves
            // out from the repository context. So when the user moves out of the repository
            // context we are triggering an action to clear the create Jira issue reducer state.
            (0, $5NpoY.Y)((0, $g7vJB.unloadCreateJiraIssue)())
        ]);
    }
}
var $bb056eda1e6d37bb$export$2e2bcd8739ae039 = $bb056eda1e6d37bb$var$unloadRepository;

});
parcelRegister("5vUfT", function(module, exports) {
$parcel$export(module.exports, "loadPullRequests", function () { return (parcelRequire("gAfkB")).loadPullRequests; });
$parcel$export(module.exports, "unloadPullRequests", function () { return (parcelRequire("gAfkB")).unloadPullRequests; });
$parcel$export(module.exports, "getPullRequestList", function () { return (parcelRequire("6rydh")).getPullRequestList; });
$parcel$export(module.exports, "getPullRequests", function () { return (parcelRequire("6rydh")).getPullRequests; });
$parcel$export(module.exports, "getPullRequestsPagination", function () { return (parcelRequire("6rydh")).getPullRequestsPagination; });

$parcel$export(module.exports, "default", function () { return $036f2f5b13418dcf$export$2e2bcd8739ae039; });

var $jF3Yx = parcelRequire("jF3Yx");

var $5hDiW = parcelRequire("5hDiW");

var $aXS95 = parcelRequire("aXS95");

var $lCRpl = parcelRequire("lCRpl");
parcelRequire("gAfkB");
parcelRequire("6rydh");
parcelRequire("fc3RG");
var $036f2f5b13418dcf$export$2e2bcd8739ae039 = (0, $jF3Yx.combineReducers)({
    pullRequests: $aXS95.default,
    pullRequestAuthors: $5hDiW.default,
    pullRequestPreloadedAuthor: $lCRpl.default
});

});
parcelRegister("5hDiW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $207368df473f9656$export$2e2bcd8739ae039; });

var $gsXeO = parcelRequire("gsXeO");
parcelRequire("gAfkB");
var $a3bLa = parcelRequire("a3bLa");
const $207368df473f9656$export$fea0d869ab229f3f = {
    authors: [],
    filteredAuthors: [],
    isLoading: false,
    isError: false
};
var $207368df473f9656$export$2e2bcd8739ae039 = (0, $gsXeO.default)($207368df473f9656$export$fea0d869ab229f3f, {
    [(0, $a3bLa.LoadPullRequestAuthors).REQUEST] (state) {
        return {
            ...state,
            isLoading: true,
            isError: false
        };
    },
    [(0, $a3bLa.LoadPullRequestAuthors).SUCCESS] (state, action) {
        if (action.meta && action.meta.data.query) return {
            ...state,
            filteredAuthors: action.payload.values,
            isLoading: false,
            isError: false
        };
        return {
            ...state,
            authors: action.payload.values,
            isLoading: false,
            isError: false
        };
    },
    [(0, $a3bLa.LoadPullRequestAuthors).ERROR] (state) {
        return {
            ...state,
            isLoading: false,
            isError: true
        };
    },
    [(0, $a3bLa.ClearFilteredAuthors)] (state) {
        return {
            ...state,
            filteredAuthors: $207368df473f9656$export$fea0d869ab229f3f.filteredAuthors
        };
    }
});

});

parcelRegister("aXS95", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e89579bfbc1b522$export$2e2bcd8739ae039; });

var $gsXeO = parcelRequire("gsXeO");

var $gAfkB = parcelRequire("gAfkB");
const $8e89579bfbc1b522$export$d3d0e1e4a436cad9 = {
    listItems: [],
    nextUrl: null,
    isLoading: false,
    isError: false,
    isPreRequestState: true,
    reloadUrl: null,
    size: 0,
    pagelen: 0
};
var $8e89579bfbc1b522$export$2e2bcd8739ae039 = (0, $gsXeO.default)($8e89579bfbc1b522$export$d3d0e1e4a436cad9, {
    [(0, $gAfkB.LoadPullRequests).REQUEST] (state, action) {
        const reloadUrl = action.meta && action.meta.url ? action.meta.url : null;
        return {
            ...state,
            isLoading: true,
            isError: false,
            isPreRequestState: false,
            reloadUrl: reloadUrl
        };
    },
    [(0, $gAfkB.LoadPullRequests).ERROR] (state) {
        return {
            ...state,
            isLoading: false,
            isError: true
        };
    },
    [(0, $gAfkB.LoadPullRequests).SUCCESS] (state, action) {
        const { values: values, next: next, size: size, pagelen: pagelen } = action.payload.result;
        return {
            ...state,
            listItems: [
                ...values
            ],
            nextUrl: next,
            isLoading: false,
            isError: false,
            pagelen: pagelen,
            size: size
        };
    },
    [(0, $gAfkB.UnloadPullRequests)] () {
        return $8e89579bfbc1b522$export$d3d0e1e4a436cad9;
    }
});

});

parcelRegister("lCRpl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6673cd6e172d546b$export$2e2bcd8739ae039; });

var $gsXeO = parcelRequire("gsXeO");
parcelRequire("gAfkB");
var $a3bLa = parcelRequire("a3bLa");
const $6673cd6e172d546b$export$2e74b5416fb60176 = {
    author: null,
    isLoading: false,
    isError: false
};
var $6673cd6e172d546b$export$2e2bcd8739ae039 = (0, $gsXeO.default)($6673cd6e172d546b$export$2e74b5416fb60176, {
    [(0, $a3bLa.LoadPullRequestAuthor).REQUEST] (state) {
        return {
            ...state,
            isLoading: true,
            isError: false
        };
    },
    [(0, $a3bLa.LoadPullRequestAuthor).SUCCESS] (state, action) {
        return {
            ...state,
            author: action.payload,
            isLoading: false,
            isError: false
        };
    },
    [(0, $a3bLa.LoadPullRequestAuthor).ERROR] (state) {
        return {
            ...state,
            author: $6673cd6e172d546b$export$2e74b5416fb60176.author,
            isLoading: false,
            isError: true
        };
    },
    [(0, $a3bLa.UpdatePreloadedAuthor)] (state, action) {
        return {
            ...state,
            author: action.payload
        };
    }
});

});

parcelRegister("fc3RG", function(module, exports) {

});



parcelRegister("nVTIu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6350016f8776d2f$export$2e2bcd8739ae039; });
/* eslint frontbucket-patterns/no-new-sagas: "warn" */ parcelRequire("fJWTD");
var $5NpoY = parcelRequire("5NpoY");
parcelRequire("6ePRx");
var $iaicX = parcelRequire("iaicX");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");

var $aanBq = parcelRequire("aanBq");
function* $f6350016f8776d2f$export$2e2bcd8739ae039() {
    while(true){
        const { payload: { oldRepoSlug: oldRepoSlug, newRepoSlug: newRepoSlug } } = yield (0, $5NpoY.M)((0, $jJd6W.UPDATE_MENU_ITEM_URLS_REPO_NAME));
        const repoNavMenuItems = yield (0, $5NpoY.a3)((0, $aanBq.getMenuItems));
        if (!oldRepoSlug || !newRepoSlug || !Array.isArray(repoNavMenuItems)) return false;
        const matchRegex = new RegExp(`^/(.+?)/(${oldRepoSlug})/`);
        const updatedMenuItems = (0, $iaicX.mapNestedMenuItems)(repoNavMenuItems, (item)=>{
            if (item.url) return {
                ...item,
                url: item.url.replace(matchRegex, `/$1/${newRepoSlug}/`)
            };
            return item;
        });
        yield (0, $5NpoY.Y)({
            type: (0, $jJd6W.UPDATE_REPOSITORY_SECTION_MENU_ITEMS),
            payload: updatedMenuItems
        });
    }
}

});


parcelRegister("1sh9M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bac730e70de14d96$export$2e2bcd8739ae039; });

var $ga67g = parcelRequire("ga67g");
var // All destructured elements are unused.
// @ts-ignore
$bac730e70de14d96$export$2e2bcd8739ae039 = ()=>({ // @ts-ignore TODO: fix noImplicitAny error here
    dispatch: _dispatch, // @ts-ignore TODO: fix noImplicitAny error here
    getState: _getState })=>// @ts-ignore TODO: fix noImplicitAny error here
        (next)=>// @ts-ignore TODO: fix noImplicitAny error here
            (action)=>{
                const schema = action.meta && action.meta.schema;
                if (schema && action.payload && !action.error) return next({
                    ...action,
                    payload: (0, $ga67g.normalize)(action.payload, schema)
                });
                return next(action);
            };

});

parcelRegister("mL4xD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $866267241ca9236d$export$2e2bcd8739ae039; });

var $bF7K9 = parcelRequire("bF7K9");

var $5i6ab = parcelRequire("5i6ab");
const $866267241ca9236d$var$sentryMiddleware = (0, (/*@__PURE__*/$parcel$interopDefault($5i6ab)))($bF7K9, {
    // This controls what gets set as `extra.lastAction` on each Sentry error event
    // We only record the action "type" to avoid leaking PII
    actionTransformer: (action)=>action ? action.type : "unknown type",
    // This controls what gets set as `extra.state` on each Sentry error event
    // We omit this data entirely (for now) to avoid leaking PII
    stateTransformer: ()=>"INTENTIONALLY_REMOVED"
});
var $866267241ca9236d$export$2e2bcd8739ae039 = $866267241ca9236d$var$sentryMiddleware;

});
parcelRegister("bF7K9", function(module, exports) {

$parcel$export(module.exports, "Integrations", function () { return $87d987b307b7eac0$export$99d02219d259eb94; });
$parcel$export(module.exports, "Transports", function () { return (parcelRequire("gfJO1")); });

var $l5MLt = parcelRequire("l5MLt");

var $aeif1 = parcelRequire("aeif1");

var $fFFFb = parcelRequire("fFFFb");
parcelRequire("4TfCJ");
var $fU0Yz = parcelRequire("fU0Yz");

var $9NFFc = parcelRequire("9NFFc");

var $gfJO1 = parcelRequire("gfJO1");
var $87d987b307b7eac0$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $87d987b307b7eac0$var$_window = (0, $fU0Yz.getGlobalObject)();
if ($87d987b307b7eac0$var$_window.Sentry && $87d987b307b7eac0$var$_window.Sentry.Integrations) $87d987b307b7eac0$var$windowIntegrations = $87d987b307b7eac0$var$_window.Sentry.Integrations;
var $87d987b307b7eac0$export$99d02219d259eb94 = (0, $l5MLt.__assign)((0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, $87d987b307b7eac0$var$windowIntegrations), (0, $fFFFb)), $9NFFc);
$parcel$exportWildcard(module.exports, $aeif1);

});
parcelRegister("aeif1", function(module, exports) {

$parcel$export(module.exports, "Severity", function () { return (parcelRequire("i3ov7")).Severity; });
$parcel$export(module.exports, "addGlobalEventProcessor", function () { return (parcelRequire("l6Sat")).addGlobalEventProcessor; });
$parcel$export(module.exports, "addBreadcrumb", function () { return (parcelRequire("3XbtU")).addBreadcrumb; });
$parcel$export(module.exports, "captureException", function () { return (parcelRequire("3XbtU")).captureException; });
$parcel$export(module.exports, "captureEvent", function () { return (parcelRequire("3XbtU")).captureEvent; });
$parcel$export(module.exports, "captureMessage", function () { return (parcelRequire("3XbtU")).captureMessage; });
$parcel$export(module.exports, "configureScope", function () { return (parcelRequire("3XbtU")).configureScope; });
$parcel$export(module.exports, "getHubFromCarrier", function () { return (parcelRequire("4IkmO")).getHubFromCarrier; });
$parcel$export(module.exports, "getCurrentHub", function () { return (parcelRequire("4IkmO")).getCurrentHub; });
$parcel$export(module.exports, "Hub", function () { return (parcelRequire("4IkmO")).Hub; });
$parcel$export(module.exports, "makeMain", function () { return (parcelRequire("4IkmO")).makeMain; });
$parcel$export(module.exports, "Scope", function () { return (parcelRequire("l6Sat")).Scope; });
$parcel$export(module.exports, "Session", function () { return (parcelRequire("jA7RW")).Session; });
$parcel$export(module.exports, "startTransaction", function () { return (parcelRequire("3XbtU")).startTransaction; });
$parcel$export(module.exports, "SDK_VERSION", function () { return (parcelRequire("cLshu")).SDK_VERSION; });
$parcel$export(module.exports, "setContext", function () { return (parcelRequire("3XbtU")).setContext; });
$parcel$export(module.exports, "setExtra", function () { return (parcelRequire("3XbtU")).setExtra; });
$parcel$export(module.exports, "setExtras", function () { return (parcelRequire("3XbtU")).setExtras; });
$parcel$export(module.exports, "setTag", function () { return (parcelRequire("3XbtU")).setTag; });
$parcel$export(module.exports, "setTags", function () { return (parcelRequire("3XbtU")).setTags; });
$parcel$export(module.exports, "setUser", function () { return (parcelRequire("3XbtU")).setUser; });
$parcel$export(module.exports, "withScope", function () { return (parcelRequire("3XbtU")).withScope; });
$parcel$export(module.exports, "BrowserClient", function () { return (parcelRequire("7i9JW")).BrowserClient; });
$parcel$export(module.exports, "injectReportDialog", function () { return (parcelRequire("aHBFP")).injectReportDialog; });
$parcel$export(module.exports, "eventFromException", function () { return (parcelRequire("5p3Zc")).eventFromException; });
$parcel$export(module.exports, "eventFromMessage", function () { return (parcelRequire("5p3Zc")).eventFromMessage; });
$parcel$export(module.exports, "defaultIntegrations", function () { return (parcelRequire("lC9T5")).defaultIntegrations; });
$parcel$export(module.exports, "forceLoad", function () { return (parcelRequire("lC9T5")).forceLoad; });
$parcel$export(module.exports, "init", function () { return (parcelRequire("lC9T5")).init; });
$parcel$export(module.exports, "lastEventId", function () { return (parcelRequire("lC9T5")).lastEventId; });
$parcel$export(module.exports, "onLoad", function () { return (parcelRequire("lC9T5")).onLoad; });
$parcel$export(module.exports, "showReportDialog", function () { return (parcelRequire("lC9T5")).showReportDialog; });
$parcel$export(module.exports, "flush", function () { return (parcelRequire("lC9T5")).flush; });
$parcel$export(module.exports, "close", function () { return (parcelRequire("lC9T5")).close; });
$parcel$export(module.exports, "wrap", function () { return (parcelRequire("lC9T5")).wrap; });
$parcel$export(module.exports, "SDK_NAME", function () { return (parcelRequire("dUVJD")).SDK_NAME; });

var $i3ov7 = parcelRequire("i3ov7");

var $3XbtU = parcelRequire("3XbtU");
var $l6Sat = parcelRequire("l6Sat");
var $4IkmO = parcelRequire("4IkmO");
var $cLshu = parcelRequire("cLshu");
var $jA7RW = parcelRequire("jA7RW");

var $7i9JW = parcelRequire("7i9JW");

var $aHBFP = parcelRequire("aHBFP");

var $5p3Zc = parcelRequire("5p3Zc");

var $lC9T5 = parcelRequire("lC9T5");

var $dUVJD = parcelRequire("dUVJD");

});
parcelRegister("lC9T5", function(module, exports) {

$parcel$export(module.exports, "defaultIntegrations", function () { return $fbc4d10bb2bd4c49$export$5ef831fccfce35e5; });
$parcel$export(module.exports, "init", function () { return $fbc4d10bb2bd4c49$export$2cd8252107eb640b; });
$parcel$export(module.exports, "showReportDialog", function () { return $fbc4d10bb2bd4c49$export$3a8fd680da42627b; });
$parcel$export(module.exports, "lastEventId", function () { return $fbc4d10bb2bd4c49$export$5d4e9fd7fac8e617; });
$parcel$export(module.exports, "forceLoad", function () { return $fbc4d10bb2bd4c49$export$a3f323d81eede727; });
$parcel$export(module.exports, "onLoad", function () { return $fbc4d10bb2bd4c49$export$4e4d8b287d028b6b; });
$parcel$export(module.exports, "flush", function () { return $fbc4d10bb2bd4c49$export$4909b86c8034bf73; });
$parcel$export(module.exports, "close", function () { return $fbc4d10bb2bd4c49$export$8360e631d277ea4d; });
$parcel$export(module.exports, "wrap", function () { return $fbc4d10bb2bd4c49$export$4997ffc0176396a6; });

var $l5MLt = parcelRequire("l5MLt");

var $4IkmO = parcelRequire("4IkmO");
var $9qBf7 = parcelRequire("9qBf7");
var $fFFFb = parcelRequire("fFFFb");
parcelRequire("4TfCJ");
var $fMu7V = parcelRequire("fMu7V");
var $fU0Yz = parcelRequire("fU0Yz");
var $6uhZG = parcelRequire("6uhZG");
var $eFWdY = parcelRequire("eFWdY");

var $7i9JW = parcelRequire("7i9JW");

var $aNuE0 = parcelRequire("aNuE0");

var $aHBFP = parcelRequire("aHBFP");

var $6ZyCi = parcelRequire("6ZyCi");
var $b1IeA = parcelRequire("b1IeA");
var $ftOIN = parcelRequire("ftOIN");
var $1xpWL = parcelRequire("1xpWL");
var $l6nSr = parcelRequire("l6nSr");
var $7YIjv = parcelRequire("7YIjv");
var $fbc4d10bb2bd4c49$export$5ef831fccfce35e5 = [
    new (0, $fFFFb).InboundFilters(),
    new (0, $fFFFb).FunctionToString(),
    new (0, $l6nSr.TryCatch)(),
    new (0, $6ZyCi.Breadcrumbs)(),
    new (0, $ftOIN.GlobalHandlers)(),
    new (0, $1xpWL.LinkedErrors)(),
    new (0, $b1IeA.Dedupe)(),
    new (0, $7YIjv.UserAgent)()
];
function $fbc4d10bb2bd4c49$export$2cd8252107eb640b(options) {
    if (options === void 0) options = {};
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $fbc4d10bb2bd4c49$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        var window_1 = (0, $fU0Yz.getGlobalObject)();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) options.release = window_1.SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    (0, $9qBf7.initAndBind)((0, $7i9JW.BrowserClient), options);
    if (options.autoSessionTracking) $fbc4d10bb2bd4c49$var$startSessionTracking();
}
function $fbc4d10bb2bd4c49$export$3a8fd680da42627b(options) {
    if (options === void 0) options = {};
    var hub = (0, $4IkmO.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) options.user = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, scope.getUser()), options.user);
    if (!options.eventId) options.eventId = hub.lastEventId();
    var client = hub.getClient();
    if (client) client.showReportDialog(options);
}
function $fbc4d10bb2bd4c49$export$5d4e9fd7fac8e617() {
    return (0, $4IkmO.getCurrentHub)().lastEventId();
}
function $fbc4d10bb2bd4c49$export$a3f323d81eede727() {
// Noop
}
function $fbc4d10bb2bd4c49$export$4e4d8b287d028b6b(callback) {
    callback();
}
function $fbc4d10bb2bd4c49$export$4909b86c8034bf73(timeout) {
    var client = (0, $4IkmO.getCurrentHub)().getClient();
    if (client) return client.flush(timeout);
    (0, $aNuE0.IS_DEBUG_BUILD) && (0, $6uhZG.logger).warn("Cannot flush events. No client defined.");
    return (0, $eFWdY.resolvedSyncPromise)(false);
}
function $fbc4d10bb2bd4c49$export$8360e631d277ea4d(timeout) {
    var client = (0, $4IkmO.getCurrentHub)().getClient();
    if (client) return client.close(timeout);
    (0, $aNuE0.IS_DEBUG_BUILD) && (0, $6uhZG.logger).warn("Cannot flush events and disable SDK. No client defined.");
    return (0, $eFWdY.resolvedSyncPromise)(false);
}
function $fbc4d10bb2bd4c49$export$4997ffc0176396a6(fn) {
    return (0, $aHBFP.wrap)(fn)();
}
function $fbc4d10bb2bd4c49$var$startSessionOnHub(hub) {
    hub.startSession({
        ignoreDuration: true
    });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $fbc4d10bb2bd4c49$var$startSessionTracking() {
    var window = (0, $fU0Yz.getGlobalObject)();
    var document = window.document;
    if (typeof document === "undefined") {
        (0, $aNuE0.IS_DEBUG_BUILD) && (0, $6uhZG.logger).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    var hub = (0, $4IkmO.getCurrentHub)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) return;
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    $fbc4d10bb2bd4c49$var$startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0, $fMu7V.addInstrumentationHandler)("history", function(_a) {
        var from = _a.from, to = _a.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) $fbc4d10bb2bd4c49$var$startSessionOnHub((0, $4IkmO.getCurrentHub)());
    });
}

});
parcelRegister("9qBf7", function(module, exports) {

$parcel$export(module.exports, "initAndBind", function () { return $6dd36e6b622f5591$export$5333c3f1c58d9bc1; });

var $4IkmO = parcelRequire("4IkmO");
parcelRequire("4TfCJ");
var $6uhZG = parcelRequire("6uhZG");

var $cNRiV = parcelRequire("cNRiV");
function $6dd36e6b622f5591$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $cNRiV.IS_DEBUG_BUILD) (0, $6uhZG.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        // eslint-disable-next-line no-console
        console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
    }
    var hub = (0, $4IkmO.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) scope.update(options.initialScope);
    var client = new clientClass(options);
    hub.bindClient(client);
}

});

parcelRegister("fFFFb", function(module, exports) {

$parcel$export(module.exports, "FunctionToString", function () { return (parcelRequire("k7jZg")).FunctionToString; });
$parcel$export(module.exports, "InboundFilters", function () { return (parcelRequire("k11FU")).InboundFilters; });

var $k7jZg = parcelRequire("k7jZg");

var $k11FU = parcelRequire("k11FU");

});
parcelRegister("k7jZg", function(module, exports) {

$parcel$export(module.exports, "FunctionToString", function () { return $ea53f71bff7737bb$export$da4704525c20ae79; });
parcelRequire("4TfCJ");
var $QXRHa = parcelRequire("QXRHa");
var $ea53f71bff7737bb$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ var $ea53f71bff7737bb$export$da4704525c20ae79 = /** @class */ function() {
    function FunctionToString() {
        /**
         * @inheritDoc
         */ this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */ FunctionToString.prototype.setupOnce = function() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        $ea53f71bff7737bb$var$originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var context = (0, $QXRHa.getOriginalFunction)(this) || this;
            return $ea53f71bff7737bb$var$originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */ FunctionToString.id = "FunctionToString";
    return FunctionToString;
}();

});

parcelRegister("k11FU", function(module, exports) {

$parcel$export(module.exports, "InboundFilters", function () { return $e925333d2f85eff2$export$2ffbb5359dcc6be4; });

var $l5MLt = parcelRequire("l5MLt");
parcelRequire("4TfCJ");
var $49X0E = parcelRequire("49X0E");
var $5Q0pQ = parcelRequire("5Q0pQ");
var $6uhZG = parcelRequire("6uhZG");

var $cNRiV = parcelRequire("cNRiV");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var $e925333d2f85eff2$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
/** Inbound filters configurable by the user */ var $e925333d2f85eff2$export$2ffbb5359dcc6be4 = /** @class */ function() {
    function InboundFilters(_options) {
        if (_options === void 0) _options = {};
        this._options = _options;
        /**
         * @inheritDoc
         */ this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */ InboundFilters.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var hub = getCurrentHub();
            if (hub) {
                var self_1 = hub.getIntegration(InboundFilters);
                if (self_1) {
                    var client = hub.getClient();
                    var clientOptions = client ? client.getOptions() : {};
                    var options = $e925333d2f85eff2$export$6620a151868b99aa(self_1._options, clientOptions);
                    return $e925333d2f85eff2$export$3c6361fddf6cd929(event, options) ? null : event;
                }
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ InboundFilters.id = "InboundFilters";
    return InboundFilters;
}();
function $e925333d2f85eff2$export$6620a151868b99aa(internalOptions, clientOptions) {
    if (internalOptions === void 0) internalOptions = {};
    if (clientOptions === void 0) clientOptions = {};
    return {
        allowUrls: (0, $l5MLt.__spread)(internalOptions.whitelistUrls || [], internalOptions.allowUrls || [], clientOptions.whitelistUrls || [], clientOptions.allowUrls || []),
        denyUrls: (0, $l5MLt.__spread)(internalOptions.blacklistUrls || [], internalOptions.denyUrls || [], clientOptions.blacklistUrls || [], clientOptions.denyUrls || []),
        ignoreErrors: (0, $l5MLt.__spread)(internalOptions.ignoreErrors || [], clientOptions.ignoreErrors || [], $e925333d2f85eff2$var$DEFAULT_IGNORE_ERRORS),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $e925333d2f85eff2$export$3c6361fddf6cd929(event, options) {
    if (options.ignoreInternal && $e925333d2f85eff2$var$_isSentryError(event)) {
        (0, $cNRiV.IS_DEBUG_BUILD) && (0, $6uhZG.logger).warn("Event dropped due to being internal Sentry Error.\nEvent: " + (0, $49X0E.getEventDescription)(event));
        return true;
    }
    if ($e925333d2f85eff2$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $cNRiV.IS_DEBUG_BUILD) && (0, $6uhZG.logger).warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + (0, $49X0E.getEventDescription)(event));
        return true;
    }
    if ($e925333d2f85eff2$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $cNRiV.IS_DEBUG_BUILD) && (0, $6uhZG.logger).warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + (0, $49X0E.getEventDescription)(event) + ".\nUrl: " + $e925333d2f85eff2$var$_getEventFilterUrl(event));
        return true;
    }
    if (!$e925333d2f85eff2$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $cNRiV.IS_DEBUG_BUILD) && (0, $6uhZG.logger).warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + (0, $49X0E.getEventDescription)(event) + ".\nUrl: " + $e925333d2f85eff2$var$_getEventFilterUrl(event));
        return true;
    }
    return false;
}
function $e925333d2f85eff2$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors || !ignoreErrors.length) return false;
    return $e925333d2f85eff2$var$_getPossibleEventMessages(event).some(function(message) {
        return ignoreErrors.some(function(pattern) {
            return (0, $5Q0pQ.isMatchingPattern)(message, pattern);
        });
    });
}
function $e925333d2f85eff2$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    var url = $e925333d2f85eff2$var$_getEventFilterUrl(event);
    return !url ? false : denyUrls.some(function(pattern) {
        return (0, $5Q0pQ.isMatchingPattern)(url, pattern);
    });
}
function $e925333d2f85eff2$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    var url = $e925333d2f85eff2$var$_getEventFilterUrl(event);
    return !url ? true : allowUrls.some(function(pattern) {
        return (0, $5Q0pQ.isMatchingPattern)(url, pattern);
    });
}
function $e925333d2f85eff2$var$_getPossibleEventMessages(event) {
    if (event.message) return [
        event.message
    ];
    if (event.exception) try {
        var _a = event.exception.values && event.exception.values[0] || {}, _b = _a.type, type = _b === void 0 ? "" : _b, _c = _a.value, value = _c === void 0 ? "" : _c;
        return [
            "" + value,
            type + ": " + value
        ];
    } catch (oO) {
        (0, $cNRiV.IS_DEBUG_BUILD) && (0, $6uhZG.logger).error("Cannot extract message for event " + (0, $49X0E.getEventDescription)(event));
        return [];
    }
    return [];
}
function $e925333d2f85eff2$var$_isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $e925333d2f85eff2$var$_getLastValidUrl(frames) {
    if (frames === void 0) frames = [];
    for(var i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $e925333d2f85eff2$var$_getEventFilterUrl(event) {
    try {
        if (event.stacktrace) return $e925333d2f85eff2$var$_getLastValidUrl(event.stacktrace.frames);
        var frames_1;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames_1 = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames_1 ? $e925333d2f85eff2$var$_getLastValidUrl(frames_1) : null;
    } catch (oO) {
        (0, $cNRiV.IS_DEBUG_BUILD) && (0, $6uhZG.logger).error("Cannot extract url for event " + (0, $49X0E.getEventDescription)(event));
        return null;
    }
}

});


parcelRegister("b1IeA", function(module, exports) {

$parcel$export(module.exports, "Dedupe", function () { return $807219b4b287726f$export$688d98c249d31ad3; });
parcelRequire("4TfCJ");
var $6uhZG = parcelRequire("6uhZG");

var $aNuE0 = parcelRequire("aNuE0");
/** Deduplication filter */ var $807219b4b287726f$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($807219b4b287726f$var$_shouldDropEvent(currentEvent, self._previousEvent)) {
                        (0, $aNuE0.IS_DEBUG_BUILD) && (0, $6uhZG.logger).warn("Event dropped due to being a duplicate of previously captured event.");
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = "Dedupe";
    return Dedupe;
}();
/** JSDoc */ function $807219b4b287726f$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($807219b4b287726f$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($807219b4b287726f$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $807219b4b287726f$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$807219b4b287726f$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$807219b4b287726f$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $807219b4b287726f$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $807219b4b287726f$var$_getExceptionFromEvent(previousEvent);
    var currentException = $807219b4b287726f$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$807219b4b287726f$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$807219b4b287726f$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $807219b4b287726f$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $807219b4b287726f$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $807219b4b287726f$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $807219b4b287726f$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $807219b4b287726f$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $807219b4b287726f$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}

});

parcelRegister("ftOIN", function(module, exports) {

$parcel$export(module.exports, "GlobalHandlers", function () { return $b450e8b1f0098aca$export$204155decbc90e5a; });

var $l5MLt = parcelRequire("l5MLt");

var $4IkmO = parcelRequire("4IkmO");

var $i3ov7 = parcelRequire("i3ov7");
parcelRequire("4TfCJ");
var $49X0E = parcelRequire("49X0E");
var $fMu7V = parcelRequire("fMu7V");
var $hPLeT = parcelRequire("hPLeT");
var $7CXdk = parcelRequire("7CXdk");
var $6uhZG = parcelRequire("6uhZG");

var $5p3Zc = parcelRequire("5p3Zc");

var $aNuE0 = parcelRequire("aNuE0");

var $aHBFP = parcelRequire("aHBFP");
/** Global handlers */ var $b450e8b1f0098aca$export$204155decbc90e5a = /** @class */ function() {
    /** JSDoc */ function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */ this.name = GlobalHandlers.id;
        /**
         * Stores references functions to installing handlers. Will set to undefined
         * after they have been run so that they are not used twice.
         */ this._installFunc = {
            onerror: $b450e8b1f0098aca$var$_installGlobalOnErrorHandler,
            onunhandledrejection: $b450e8b1f0098aca$var$_installGlobalOnUnhandledRejectionHandler
        };
        this._options = (0, $l5MLt.__assign)({
            onerror: true,
            onunhandledrejection: true
        }, options);
    }
    /**
     * @inheritDoc
     */ GlobalHandlers.prototype.setupOnce = function() {
        Error.stackTraceLimit = 50;
        var options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for(var key in options){
            var installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                $b450e8b1f0098aca$var$globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    };
    /**
     * @inheritDoc
     */ GlobalHandlers.id = "GlobalHandlers";
    return GlobalHandlers;
}();
/** JSDoc */ function $b450e8b1f0098aca$var$_installGlobalOnErrorHandler() {
    (0, $fMu7V.addInstrumentationHandler)("error", // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(data) {
        var _a = (0, $l5MLt.__read)($b450e8b1f0098aca$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($b450e8b1f0098aca$export$204155decbc90e5a)) return;
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        if ((0, $aHBFP.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return;
        var event = error === undefined && (0, $7CXdk.isString)(msg) ? $b450e8b1f0098aca$var$_eventFromIncompleteOnError(msg, url, line, column) : $b450e8b1f0098aca$var$_enhanceEventWithInitialFrame((0, $5p3Zc.eventFromUnknownInput)(error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = (0, $i3ov7.Severity).Error;
        $b450e8b1f0098aca$var$addMechanismAndCapture(hub, error, event, "onerror");
    });
}
/** JSDoc */ function $b450e8b1f0098aca$var$_installGlobalOnUnhandledRejectionHandler() {
    (0, $fMu7V.addInstrumentationHandler)("unhandledrejection", // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(e) {
        var _a = (0, $l5MLt.__read)($b450e8b1f0098aca$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($b450e8b1f0098aca$export$204155decbc90e5a)) return;
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ("reason" in e) error = e.reason;
            else if ("detail" in e && "reason" in e.detail) error = e.detail.reason;
        } catch (_oO) {
        // no-empty
        }
        if ((0, $aHBFP.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return true;
        var event = (0, $7CXdk.isPrimitive)(error) ? $b450e8b1f0098aca$var$_eventFromRejectionWithPrimitive(error) : (0, $5p3Zc.eventFromUnknownInput)(error, undefined, attachStacktrace, true);
        event.level = (0, $i3ov7.Severity).Error;
        $b450e8b1f0098aca$var$addMechanismAndCapture(hub, error, event, "onunhandledrejection");
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $b450e8b1f0098aca$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: " + String(reason)
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b450e8b1f0098aca$var$_eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = (0, $7CXdk.isErrorEvent)(msg) ? msg.message : msg;
    var name = "Error";
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $b450e8b1f0098aca$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b450e8b1f0098aca$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = event.exception = event.exception || {};
    // event.exception.values
    var ev = e.values = e.values || [];
    // event.exception.values[0]
    var ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    var ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    var ev0sf = ev0s.frames = ev0s.frames || [];
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0, $7CXdk.isString)(url) && url.length > 0 ? url : (0, $hPLeT.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: "?",
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $b450e8b1f0098aca$var$globalHandlerLog(type) {
    (0, $aNuE0.IS_DEBUG_BUILD) && (0, $6uhZG.logger).log("Global Handler attached: " + type);
}
function $b450e8b1f0098aca$var$addMechanismAndCapture(hub, error, event, type) {
    (0, $49X0E.addExceptionMechanism)(event, {
        handled: false,
        type: type
    });
    hub.captureEvent(event, {
        originalException: error
    });
}
function $b450e8b1f0098aca$var$getHubAndAttachStacktrace() {
    var hub = (0, $4IkmO.getCurrentHub)();
    var client = hub.getClient();
    var attachStacktrace = client && client.getOptions().attachStacktrace;
    return [
        hub,
        attachStacktrace
    ];
}

});

parcelRegister("1xpWL", function(module, exports) {

$parcel$export(module.exports, "LinkedErrors", function () { return $11ecfffe4fbdb912$export$8d1e60aaf616fb4f; });

var $l5MLt = parcelRequire("l5MLt");

var $l6Sat = parcelRequire("l6Sat");
var $4IkmO = parcelRequire("4IkmO");
parcelRequire("4TfCJ");
var $7CXdk = parcelRequire("7CXdk");

var $5p3Zc = parcelRequire("5p3Zc");
var $11ecfffe4fbdb912$var$DEFAULT_KEY = "cause";
var $11ecfffe4fbdb912$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ var $11ecfffe4fbdb912$export$8d1e60aaf616fb4f = /** @class */ function() {
    /**
     * @inheritDoc
     */ function LinkedErrors(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = LinkedErrors.id;
        this._key = options.key || $11ecfffe4fbdb912$var$DEFAULT_KEY;
        this._limit = options.limit || $11ecfffe4fbdb912$var$DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */ LinkedErrors.prototype.setupOnce = function() {
        (0, $l6Sat.addGlobalEventProcessor)(function(event, hint) {
            var self = (0, $4IkmO.getCurrentHub)().getIntegration(LinkedErrors);
            return self ? $11ecfffe4fbdb912$export$7bd713d0612d8839(self._key, self._limit, event, hint) : event;
        });
    };
    /**
     * @inheritDoc
     */ LinkedErrors.id = "LinkedErrors";
    return LinkedErrors;
}();
function $11ecfffe4fbdb912$export$7bd713d0612d8839(key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $7CXdk.isInstanceOf)(hint.originalException, Error)) return event;
    var linkedErrors = $11ecfffe4fbdb912$export$e4e3ecf6f8f76c75(limit, hint.originalException, key);
    event.exception.values = (0, $l5MLt.__spread)(linkedErrors, event.exception.values);
    return event;
}
function $11ecfffe4fbdb912$export$e4e3ecf6f8f76c75(limit, error, key, stack) {
    if (stack === void 0) stack = [];
    if (!(0, $7CXdk.isInstanceOf)(error[key], Error) || stack.length + 1 >= limit) return stack;
    var exception = (0, $5p3Zc.exceptionFromError)(error[key]);
    return $11ecfffe4fbdb912$export$e4e3ecf6f8f76c75(limit, error[key], key, (0, $l5MLt.__spread)([
        exception
    ], stack));
}

});

parcelRegister("l6nSr", function(module, exports) {

$parcel$export(module.exports, "TryCatch", function () { return $f5ccadfcb7a7f1ac$export$f1a018517668e6d3; });

var $l5MLt = parcelRequire("l5MLt");
parcelRequire("4TfCJ");
var $QXRHa = parcelRequire("QXRHa");
var $7sb6o = parcelRequire("7sb6o");
var $fU0Yz = parcelRequire("fU0Yz");

var $aHBFP = parcelRequire("aHBFP");
var $f5ccadfcb7a7f1ac$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ var $f5ccadfcb7a7f1ac$export$f1a018517668e6d3 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function TryCatch(options) {
        /**
         * @inheritDoc
         */ this.name = TryCatch.id;
        this._options = (0, $l5MLt.__assign)({
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true
        }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */ TryCatch.prototype.setupOnce = function() {
        var global = (0, $fU0Yz.getGlobalObject)();
        if (this._options.setTimeout) (0, $QXRHa.fill)(global, "setTimeout", $f5ccadfcb7a7f1ac$var$_wrapTimeFunction);
        if (this._options.setInterval) (0, $QXRHa.fill)(global, "setInterval", $f5ccadfcb7a7f1ac$var$_wrapTimeFunction);
        if (this._options.requestAnimationFrame) (0, $QXRHa.fill)(global, "requestAnimationFrame", $f5ccadfcb7a7f1ac$var$_wrapRAF);
        if (this._options.XMLHttpRequest && "XMLHttpRequest" in global) (0, $QXRHa.fill)(XMLHttpRequest.prototype, "send", $f5ccadfcb7a7f1ac$var$_wrapXHR);
        var eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $f5ccadfcb7a7f1ac$var$DEFAULT_EVENT_TARGET;
            eventTarget.forEach($f5ccadfcb7a7f1ac$var$_wrapEventTarget);
        }
    };
    /**
     * @inheritDoc
     */ TryCatch.id = "TryCatch";
    return TryCatch;
}();
/** JSDoc */ function $f5ccadfcb7a7f1ac$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var originalCallback = args[0];
        args[0] = (0, $aHBFP.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $7sb6o.getFunctionName)(original)
                },
                handled: true,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f5ccadfcb7a7f1ac$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $aHBFP.wrap)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $7sb6o.getFunctionName)(original)
                    },
                    handled: true,
                    type: "instrument"
                }
            })
        ]);
    };
}
/** JSDoc */ function $f5ccadfcb7a7f1ac$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach(function(prop) {
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $QXRHa.fill)(xhr, prop, function(original) {
                var wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $7sb6o.getFunctionName)(original)
                        },
                        handled: true,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                var originalFunction = (0, $QXRHa.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $7sb6o.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $aHBFP.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */ function $f5ccadfcb7a7f1ac$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = (0, $fU0Yz.getGlobalObject)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = global[target] && global[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $QXRHa.fill)(proto, "addEventListener", function(original) {
        return function(eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") fn.handleEvent = (0, $aHBFP.wrap)(fn.handleEvent.bind(fn), {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $7sb6o.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $aHBFP.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $7sb6o.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $QXRHa.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
             * There are 2 possible scenarios here:
             *
             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
             * as a pass-through, and call original `removeEventListener` with it.
             *
             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
             *
             * When someone adds a handler prior to initialization, and then do it again, but after,
             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
             * to get rid of the initial handler and it'd stick there forever.
             */ var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});

parcelRegister("7YIjv", function(module, exports) {

$parcel$export(module.exports, "UserAgent", function () { return $5cf082bfec3e0107$export$5fba5e10934a4faf; });

var $l5MLt = parcelRequire("l5MLt");

var $l6Sat = parcelRequire("l6Sat");
var $4IkmO = parcelRequire("4IkmO");
parcelRequire("4TfCJ");
var $fU0Yz = parcelRequire("fU0Yz");
var $5cf082bfec3e0107$var$global = (0, $fU0Yz.getGlobalObject)();
/** UserAgent */ var $5cf082bfec3e0107$export$5fba5e10934a4faf = /** @class */ function() {
    function UserAgent() {
        /**
         * @inheritDoc
         */ this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */ UserAgent.prototype.setupOnce = function() {
        (0, $l6Sat.addGlobalEventProcessor)(function(event) {
            if ((0, $4IkmO.getCurrentHub)().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!$5cf082bfec3e0107$var$global.navigator && !$5cf082bfec3e0107$var$global.location && !$5cf082bfec3e0107$var$global.document) return event;
                // grab as much info as exists and add it to the event
                var url = event.request && event.request.url || $5cf082bfec3e0107$var$global.location && $5cf082bfec3e0107$var$global.location.href;
                var referrer = ($5cf082bfec3e0107$var$global.document || {}).referrer;
                var userAgent = ($5cf082bfec3e0107$var$global.navigator || {}).userAgent;
                var headers = (0, $l5MLt.__assign)((0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, event.request && event.request.headers), referrer && {
                    Referer: referrer
                }), userAgent && {
                    "User-Agent": userAgent
                });
                var request = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, url && {
                    url: url
                }), {
                    headers: headers
                });
                return (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, event), {
                    request: request
                });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ UserAgent.id = "UserAgent";
    return UserAgent;
}();

});


parcelRegister("dUVJD", function(module, exports) {

$parcel$export(module.exports, "SDK_NAME", function () { return $a21d4a52cd9b076c$export$ca61d37259221480; });
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $a21d4a52cd9b076c$export$ca61d37259221480 = "sentry.javascript.browser";

});


parcelRegister("9NFFc", function(module, exports) {

$parcel$export(module.exports, "GlobalHandlers", function () { return (parcelRequire("ftOIN")).GlobalHandlers; });
$parcel$export(module.exports, "TryCatch", function () { return (parcelRequire("l6nSr")).TryCatch; });
$parcel$export(module.exports, "Breadcrumbs", function () { return (parcelRequire("6ZyCi")).Breadcrumbs; });
$parcel$export(module.exports, "LinkedErrors", function () { return (parcelRequire("1xpWL")).LinkedErrors; });
$parcel$export(module.exports, "UserAgent", function () { return (parcelRequire("7YIjv")).UserAgent; });
$parcel$export(module.exports, "Dedupe", function () { return (parcelRequire("b1IeA")).Dedupe; });

var $ftOIN = parcelRequire("ftOIN");

var $l6nSr = parcelRequire("l6nSr");

var $6ZyCi = parcelRequire("6ZyCi");

var $1xpWL = parcelRequire("1xpWL");

var $7YIjv = parcelRequire("7YIjv");

var $b1IeA = parcelRequire("b1IeA");

});

parcelRegister("gfJO1", function(module, exports) {

$parcel$export(module.exports, "BaseTransport", function () { return (parcelRequire("bD0gR")).BaseTransport; });
$parcel$export(module.exports, "FetchTransport", function () { return (parcelRequire("2vKvu")).FetchTransport; });
$parcel$export(module.exports, "XHRTransport", function () { return (parcelRequire("iBm6I")).XHRTransport; });
$parcel$export(module.exports, "makeNewFetchTransport", function () { return (parcelRequire("lk4e6")).makeNewFetchTransport; });
$parcel$export(module.exports, "makeNewXHRTransport", function () { return (parcelRequire("a8gGK")).makeNewXHRTransport; });

var $bD0gR = parcelRequire("bD0gR");

var $2vKvu = parcelRequire("2vKvu");

var $iBm6I = parcelRequire("iBm6I");

var $lk4e6 = parcelRequire("lk4e6");

var $a8gGK = parcelRequire("a8gGK");

});


parcelRegister("5i6ab", function(module, exports) {
(function(global, factory) {
    factory();
})(module.exports, function() {
    "use strict";
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    var identity = function identity(x) {
        return x;
    };
    var getUndefined = function getUndefined() {};
    var filter = function filter() {
        return true;
    };
    var getType = function getType(action) {
        return action.type;
    };
    var createSentryMiddleware = function createSentryMiddleware(Sentry) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _options$breadcrumbDa = options.breadcrumbDataFromAction, breadcrumbDataFromAction = _options$breadcrumbDa === void 0 ? getUndefined : _options$breadcrumbDa, _options$breadcrumbMe = options.breadcrumbMessageFromAction, breadcrumbMessageFromAction = _options$breadcrumbMe === void 0 ? getType : _options$breadcrumbMe, _options$actionTransf = options.actionTransformer, actionTransformer = _options$actionTransf === void 0 ? identity : _options$actionTransf, _options$stateTransfo = options.stateTransformer, stateTransformer = _options$stateTransfo === void 0 ? identity : _options$stateTransfo, _options$breadcrumbCa = options.breadcrumbCategory, breadcrumbCategory = _options$breadcrumbCa === void 0 ? "redux-action" : _options$breadcrumbCa, _options$filterBreadc = options.filterBreadcrumbActions, filterBreadcrumbActions = _options$filterBreadc === void 0 ? filter : _options$filterBreadc, getUserContext = options.getUserContext, getTags = options.getTags;
        return function(store) {
            var lastAction = null; // assigning null is a workaround since sentry api normalizes the store data and converts undefined to '[undefined]'
            Sentry.configureScope(function(scope) {
                scope.addEventProcessor(function(event, hint) {
                    var state = store.getState();
                    event.extra = _objectSpread2(_objectSpread2({}, event.extra), {}, {
                        lastAction: actionTransformer(lastAction),
                        state: stateTransformer(state)
                    });
                    if (getUserContext) event.user = _objectSpread2(_objectSpread2({}, event.user), getUserContext(state));
                    if (getTags) {
                        var tags = getTags(state);
                        Object.keys(tags).forEach(function(key) {
                            event.tags = _objectSpread2(_objectSpread2({}, event.tags), {}, _defineProperty({}, key, tags[key]));
                        });
                    }
                    return event;
                });
            });
            return function(next) {
                return function(action) {
                    if (filterBreadcrumbActions(action)) Sentry.addBreadcrumb({
                        category: breadcrumbCategory,
                        message: breadcrumbMessageFromAction(action),
                        level: "info",
                        data: breadcrumbDataFromAction(action)
                    });
                    lastAction = action;
                    return next(action);
                };
            };
        };
    };
    module.exports = createSentryMiddleware;
});

});


parcelRegister("lT98D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b2118f543d03cc4$export$2e2bcd8739ae039; });
var $8b2118f543d03cc4$export$2e2bcd8739ae039 = ()=>// @ts-ignore TODO: fix noImplicitAny error here
    ({ dispatch: dispatch, getState: getState })=>// @ts-ignore TODO: fix noImplicitAny error here
        (next)=>// @ts-ignore TODO: fix noImplicitAny error here
            (action)=>{
                if (typeof action === "function") return action(dispatch, getState);
                return next(action);
            };

});

parcelRegister("2IWOH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32f20c35152c6a04$export$2e2bcd8739ae039; });

var $jF3Yx = parcelRequire("jF3Yx");

var $8JyOg = parcelRequire("8JyOg");

var $8x4GW = parcelRequire("8x4GW");

var $hoqst = parcelRequire("hoqst");

var $9nued = parcelRequire("9nued");

var $i2O3k = parcelRequire("i2O3k");

var $jffME = parcelRequire("jffME");

var $2kKDW = parcelRequire("2kKDW");

var $c2Pbi = parcelRequire("c2Pbi");

var $2oiZ1 = parcelRequire("2oiZ1");

var $g3kOv = parcelRequire("g3kOv");

var $fQtaJ = parcelRequire("fQtaJ");

var $jb5Ea = parcelRequire("jb5Ea");

var $grdQ5 = parcelRequire("grdQ5");

var $fKGO7 = parcelRequire("fKGO7");

var $7HRn3 = parcelRequire("7HRn3");
parcelRequire("mNHVL");
var $8Y02R = parcelRequire("8Y02R");

var $bdxjy = parcelRequire("bdxjy");

var $ijBEs = parcelRequire("ijBEs");

var $dqjg0 = parcelRequire("dqjg0");

var $d69he = parcelRequire("d69he");
var $32f20c35152c6a04$export$2e2bcd8739ae039 = (0, $jF3Yx.combineReducers)({
    dashboard: $9nued.default,
    entities: $ijBEs.default,
    favicon: $jffME.default,
    flags: (0, $2kKDW.reducer),
    // @ts-ignore Unsure what redux-form + redux wants here
    form: (0, $8JyOg.default),
    global: $c2Pbi.default,
    keyboardShortcuts: $g3kOv.reducer,
    recentlyViewedRepositories: $grdQ5.reducer,
    recentlyViewedWorkspaces: $dqjg0.default,
    project: (0, $jb5Ea.reducer),
    repository: $bdxjy.default,
    search: $7HRn3.default,
    sidebar: $8Y02R.default,
    createBranch: $hoqst.default,
    profile: $fQtaJ.default,
    commits: $fKGO7.default,
    diffSettings: $i2O3k.reducer,
    jira: $2oiZ1.default,
    workspacePlan: $d69he.default,
    pipelines: $8x4GW.pipelinesReducer
});

});
parcelRegister("8x4GW", function(module, exports) {

$parcel$export(module.exports, "pipelinesReducer", function () { return $f1ab7f197662e381$export$33a386a78f1b116a; });

var $jF3Yx = parcelRequire("jF3Yx");

var $k82zL = parcelRequire("k82zL");

var $iQmD7 = parcelRequire("iQmD7");

var $eiz6k = parcelRequire("eiz6k");

var $2IFJC = parcelRequire("2IFJC");

var $bjNJf = parcelRequire("bjNJf");

var $hcD4a = parcelRequire("hcD4a");

var $6WaEw = parcelRequire("6WaEw");

var $cQZpi = parcelRequire("cQZpi");

var $3lQZy = parcelRequire("3lQZy");

var $5vxHs = parcelRequire("5vxHs");

var $WBrVC = parcelRequire("WBrVC");

var $j3sjB = parcelRequire("j3sjB");

var $6r33o = parcelRequire("6r33o");

var $4ko1t = parcelRequire("4ko1t");

var $Omq5t = parcelRequire("Omq5t");

var $dQjgB = parcelRequire("dQjgB");

var $ds8Mw = parcelRequire("ds8Mw");

var $auJkg = parcelRequire("auJkg");

var $huDvF = parcelRequire("huDvF");

var $3CLTq = parcelRequire("3CLTq");

var $2cAGx = parcelRequire("2cAGx");

var $4CW0V = parcelRequire("4CW0V");

var $gJEav = parcelRequire("gJEav");

var $3hkYJ = parcelRequire("3hkYJ");

var $97yx8 = parcelRequire("97yx8");
const $f1ab7f197662e381$export$33a386a78f1b116a = (0, $jF3Yx.combineReducers)({
    account: $k82zL.default,
    allowance: $iQmD7.default,
    artifacts: $eiz6k.default,
    buildConfiguration: $2IFJC.default,
    caches: $bjNJf.default,
    capabilities: $hcD4a.default,
    commitPullRequests: $6WaEw.default,
    currentPipeline: $cQZpi.default,
    definitions: $3lQZy.default,
    jsdChecks: $WBrVC.default,
    environmentVariables: $5vxHs.default,
    log: $j3sjB.log,
    metrics: $6r33o.metricsReducer,
    officialTemplates: $4ko1t.default,
    pipelines: $Omq5t.default,
    reports: $dQjgB.default,
    repository: $ds8Mw.default,
    schedules: $auJkg.default,
    searchLog: $huDvF.default,
    stepPreview: $3CLTq.default,
    stepRedeployment: $2cAGx.default,
    steps: $4CW0V.steps,
    testReport: $gJEav.default,
    validator: $3hkYJ.default,
    variables: $97yx8.default
});

});
parcelRegister("k82zL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03957bf8a3b1a592$export$2e2bcd8739ae039; });
parcelRequire("e9n2v");
var $bAYsY = parcelRequire("bAYsY");

var $dkkN8 = parcelRequire("dkkN8");

var $gsXeO = parcelRequire("gsXeO");

var $fEutT = parcelRequire("fEutT");

var $IQU41 = parcelRequire("IQU41");
var $03957bf8a3b1a592$export$2e2bcd8739ae039 = (0, $gsXeO.default)(new (0, $bAYsY.Account)({
    addonKey: (0, $fEutT.getAddonKey)()
}), {
    [(0, $dkkN8.LoadGlobal).SUCCESS] (state, action) {
        var _action$payload, _action$payload$entit, _action$payload$entit2, _action$payload2, _action$payload2$resu, _state$toJS;
        const currentUser = (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : (_action$payload$entit = _action$payload.entities) === null || _action$payload$entit === void 0 ? void 0 : (_action$payload$entit2 = _action$payload$entit.users) === null || _action$payload$entit2 === void 0 ? void 0 : _action$payload$entit2[(_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : (_action$payload2$resu = _action$payload2.result) === null || _action$payload2$resu === void 0 ? void 0 : _action$payload2$resu.currentUser];
        return new (0, $bAYsY.Account)({
            ...state === null || state === void 0 ? void 0 : (_state$toJS = state.toJS) === null || _state$toJS === void 0 ? void 0 : _state$toJS.call(state),
            userHas2FaEnabled: currentUser === null || currentUser === void 0 ? void 0 : currentUser.has_2fa_enabled
        });
    },
    [(0, $IQU41.SET_ACCOUNT_META)] (state, action) {
        var _state$toJS2;
        return new (0, $bAYsY.Account)({
            ...state === null || state === void 0 ? void 0 : (_state$toJS2 = state.toJS) === null || _state$toJS2 === void 0 ? void 0 : _state$toJS2.call(state),
            ...action.payload
        });
    }
});

});

parcelRegister("iQmD7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8d12eec24106afb$export$2e2bcd8739ae039; });
parcelRequire("e9n2v");
var $lB68V = parcelRequire("lB68V");

var $gsXeO = parcelRequire("gsXeO");

var $jPcDa = parcelRequire("jPcDa");
function $b8d12eec24106afb$var$toOneDecimalPlace(num) {
    return Math.round(num * 10) / 10;
}
function $b8d12eec24106afb$var$calculatePercentageUsed(usage, quota) {
    return usage / quota;
}
var $b8d12eec24106afb$export$2e2bcd8739ae039 = (0, $gsXeO.default)(new (0, $lB68V.Allowance)(), {
    [(0, $jPcDa.REQUEST_ALLOWANCE).SUCCESS] (state, action) {
        var _state$toJS;
        return new (0, $lB68V.Allowance)({
            ...state === null || state === void 0 ? void 0 : (_state$toJS = state.toJS) === null || _state$toJS === void 0 ? void 0 : _state$toJS.call(state),
            startDate: action.payload.start_date,
            endDate: action.payload.end_date,
            isTrusted: action.payload.is_trusted,
            totalUsage: $b8d12eec24106afb$var$toOneDecimalPlace(action.payload.usage_seconds / 60),
            quota: $b8d12eec24106afb$var$toOneDecimalPlace(action.payload.quota_seconds / 60),
            percentageUsed: $b8d12eec24106afb$var$calculatePercentageUsed(action.payload.usage_seconds, action.payload.quota_seconds),
            hasFetched: true,
            hasPermissionToView: true
        });
    },
    [(0, $jPcDa.REQUEST_ALLOWANCE).ERROR] (state) {
        var _state$toJS2;
        return new (0, $lB68V.Allowance)({
            ...state === null || state === void 0 ? void 0 : (_state$toJS2 = state.toJS) === null || _state$toJS2 === void 0 ? void 0 : _state$toJS2.call(state),
            hasFetched: true,
            totalUsage: 0,
            percentageUsed: 0,
            isErrored: true
        });
    }
});

});

parcelRegister("eiz6k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db57d6df3a9dff06$export$2e2bcd8739ae039; });
parcelRequire("e9n2v");
var $arCf2 = parcelRequire("arCf2");

var $90kWr = parcelRequire("90kWr");

var $gsXeO = parcelRequire("gsXeO");

var $jPcDa = parcelRequire("jPcDa");
const $db57d6df3a9dff06$export$d4c72bab9d6cc13a = {
    map: {},
    fetchedStatus: {}
};
var $db57d6df3a9dff06$export$2e2bcd8739ae039 = (0, $gsXeO.default)($db57d6df3a9dff06$export$d4c72bab9d6cc13a, {
    [(0, $jPcDa.REQUEST_ARTIFACTS).REQUEST] (state, action) {
        var _action$meta;
        if (!((_action$meta = action.meta) !== null && _action$meta !== void 0 && _action$meta.stepUuid)) return state;
        return {
            ...state,
            fetchedStatus: {
                ...state.fetchedStatus,
                [action.meta.stepUuid]: (0, $90kWr.LoadingStatus).Fetching
            }
        };
    },
    [(0, $jPcDa.REQUEST_ARTIFACTS).SUCCESS] (state, action) {
        var _action$payload, _action$meta2;
        if (!((_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.values) || !((_action$meta2 = action.meta) !== null && _action$meta2 !== void 0 && _action$meta2.stepUuid)) return state;
        const map = {
            ...state.map
        };
        map[action.meta.stepUuid] = action.payload.values.filter((artifactData)=>artifactData.step_uuid === action.meta.stepUuid).map((data)=>new (0, $arCf2.Artifact)(data));
        return {
            ...state,
            fetchedStatus: {
                ...state.fetchedStatus,
                [action.meta.stepUuid]: (0, $90kWr.LoadingStatus).Success
            },
            map: map
        };
    }
});

});

parcelRegister("2IFJC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $630da605c618779c$export$2e2bcd8739ae039; });
parcelRequire("e9n2v");
var $04RLv = parcelRequire("04RLv");

var $gsXeO = parcelRequire("gsXeO");

var $jPcDa = parcelRequire("jPcDa");
function $630da605c618779c$var$searchConfiguration(pattern, file) {
    const lines = file.split(/\r\n|\r|\n/);
    let matchingLineNumber = 0;
    lines.some((line, i)=>{
        if (line.startsWith(`${"    "}${pattern}:`)) {
            matchingLineNumber = i;
            return true;
        }
        return false;
    });
    return matchingLineNumber + 1; // Source code line numbers start at 1.
}
var $630da605c618779c$export$2e2bcd8739ae039 = (0, $gsXeO.default)(new (0, $04RLv.BuildConfiguration)(), {
    [(0, $jPcDa.CLEAR_BUILD_CONFIGURATION)] () {
        return new (0, $04RLv.BuildConfiguration)();
    },
    [(0, $jPcDa.REQUEST_BUILD_CONFIGURATION).REQUEST] (state) {
        var _state$toJS;
        return new (0, $04RLv.BuildConfiguration)({
            ...state === null || state === void 0 ? void 0 : (_state$toJS = state.toJS) === null || _state$toJS === void 0 ? void 0 : _state$toJS.call(state),
            hasFetchedRawYmlFile: false
        });
    },
    [(0, $jPcDa.REQUEST_BUILD_CONFIGURATION).SUCCESS] (state, action) {
        var _state$toJS2;
        return new (0, $04RLv.BuildConfiguration)({
            ...state === null || state === void 0 ? void 0 : (_state$toJS2 = state.toJS) === null || _state$toJS2 === void 0 ? void 0 : _state$toJS2.call(state),
            hasFetchedRawYmlFile: true,
            hasYmlFile: true,
            matchingLineNumber: $630da605c618779c$var$searchConfiguration(action.meta.pattern, action.payload || ""),
            yml: action.payload
        });
    },
    [(0, $jPcDa.REQUEST_BUILD_CONFIGURATION).ERROR] (state) {
        var _state$toJS3;
        return new (0, $04RLv.BuildConfiguration)({
            ...state === null || state === void 0 ? void 0 : (_state$toJS3 = state.toJS) === null || _state$toJS3 === void 0 ? void 0 : _state$toJS3.call(state),
            hasFetchedRawYmlFile: true,
            hasYmlFile: false
        });
    },
    [(0, $jPcDa.REQUEST_COMMIT_CONFIGURATION).REQUEST] (state) {
        var _state$toJS4;
        return new (0, $04RLv.BuildConfiguration)({
            ...state === null || state === void 0 ? void 0 : (_state$toJS4 = state.toJS) === null || _state$toJS4 === void 0 ? void 0 : _state$toJS4.call(state),
            isCommiting: true
        });
    },
    [(0, $jPcDa.REQUEST_COMMIT_CONFIGURATION).SUCCESS] (state) {
        var _state$toJS5;
        return new (0, $04RLv.BuildConfiguration)({
            ...state === null || state === void 0 ? void 0 : (_state$toJS5 = state.toJS) === null || _state$toJS5 === void 0 ? void 0 : _state$toJS5.call(state),
            isCommiting: false
        });
    },
    [(0, $jPcDa.REQUEST_COMMIT_CONFIGURATION).ERROR] (state, action) {
        var _state$toJS6;
        return new (0, $04RLv.BuildConfiguration)({
            ...state === null || state === void 0 ? void 0 : (_state$toJS6 = state.toJS) === null || _state$toJS6 === void 0 ? void 0 : _state$toJS6.call(state),
            isCommiting: false,
            isCommitingError: action.payload
        });
    }
});

});

parcelRegister("bjNJf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5029933f3ada23a6$export$2e2bcd8739ae039; });
parcelRequire("e9n2v");
var $elUoI = parcelRequire("elUoI");

var $90kWr = parcelRequire("90kWr");

var $gsXeO = parcelRequire("gsXeO");

var $jPcDa = parcelRequire("jPcDa");
const $5029933f3ada23a6$export$d4c72bab9d6cc13a = {
    list: [],
    fetchedStatus: (0, $90kWr.LoadingStatus).Before
};
const $5029933f3ada23a6$var$convertToCacheList = (caches)=>{
    const cacheMap = {};
    caches.forEach((cache)=>{
        if (!cacheMap[cache.name]) cacheMap[cache.name] = new (0, $elUoI.Cache)({
            name: cache.name,
            path: cache.path,
            pipeline_uuid: cache.pipeline_uuid,
            versions: []
        });
        cacheMap[cache.name].versions.push(new (0, $elUoI.CacheVersion)({
            uuid: cache.uuid,
            created_on: cache.created_on,
            file_size_bytes: cache.file_size_bytes,
            key_hash: cache.key_hash || ""
        }));
    });
    return Object.values(cacheMap);
};
const $5029933f3ada23a6$var$removeCacheVersion = (caches, { cache: cache, cacheUuid: cacheUuid })=>caches.map((c)=>{
        if (c.name === cache.name) return {
            ...c,
            versions: c.versions.filter((version)=>version.uuid !== cacheUuid)
        };
        return c;
    }).filter((c)=>c.versions.length !== 0);
const $5029933f3ada23a6$var$restoreRemovedCache = (caches, removedCache)=>{
    const cacheGroupExists = caches.find((cache)=>cache.name === removedCache.name);
    if (!cacheGroupExists) return [
        ...caches,
        removedCache
    ];
    else return caches.map((cache)=>{
        if (cache.name === removedCache.name) return removedCache;
        return cache;
    });
};
var $5029933f3ada23a6$export$2e2bcd8739ae039 = (0, $gsXeO.default)($5029933f3ada23a6$export$d4c72bab9d6cc13a, {
    [(0, $jPcDa.REQUEST_CACHES).REQUEST] (state) {
        return {
            ...state,
            fetchedStatus: (0, $90kWr.LoadingStatus).Fetching
        };
    },
    [(0, $jPcDa.REQUEST_CACHES).SUCCESS] (state, action) {
        var _action$payload;
        if (!((_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.values)) return state;
        return {
            ...state,
            list: $5029933f3ada23a6$var$convertToCacheList(action.payload.values),
            fetchedStatus: (0, $90kWr.LoadingStatus).Success
        };
    },
    [(0, $jPcDa.REQUEST_DELETE_CACHE).REQUEST] (state, action) {
        return {
            ...state,
            list: $5029933f3ada23a6$var$removeCacheVersion(state.list, action.meta)
        };
    },
    [(0, $jPcDa.REQUEST_DELETE_CACHE).ERROR] (state, action) {
        return {
            ...state,
            list: $5029933f3ada23a6$var$restoreRemovedCache(state.list, action.meta.cache)
        };
    },
    [(0, $jPcDa.REQUEST_DELETE_CACHES).REQUEST] (state, action) {
        return {
            ...state,
            list: state.list.filter((cache)=>cache.name !== action.meta.cache.name)
        };
    },
    [(0, $jPcDa.REQUEST_DELETE_CACHES).ERROR] (state, action) {
        return {
            ...state,
            list: [
                ...state.list,
                action.meta.cache
            ]
        };
    }
});

});

parcelRegister("hcD4a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c2b1bd287333d2c$export$2e2bcd8739ae039; });
parcelRequire("e9n2v");
var $3ikki = parcelRequire("3ikki");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");

var $gsXeO = parcelRequire("gsXeO");

var $jPcDa = parcelRequire("jPcDa");
var $5c2b1bd287333d2c$export$2e2bcd8739ae039 = (0, $gsXeO.default)(new (0, $3ikki.Capabilities)(), {
    [(0, $jJd6W.FETCH_IS_PIPELINES_ENABLED).SUCCESS] (state, action) {
        const { repository_config: repository_config, allowance: allowance } = action.payload;
        if (allowance) {
            var _state$toJS;
            return new (0, $3ikki.Capabilities)({
                ...state === null || state === void 0 ? void 0 : (_state$toJS = state.toJS) === null || _state$toJS === void 0 ? void 0 : _state$toJS.call(state),
                pipelinesEnabled: repository_config === null || repository_config === void 0 ? void 0 : repository_config.pipelines_enabled,
                limited: allowance.limit_usage,
                isPremium: allowance.premium,
                isPaid: allowance.paid,
                allowancePercentageUsed: allowance.percentage_used,
                hasMinutesLeft: allowance.has_minutes_left,
                hasFetchedCapabilities: true
            });
        } else {
            var _state$toJS2;
            // In Pipelines' staging and ddev environments there is no allowance information,
            // and thus we do not get an allowance object as a result of this action.
            return new (0, $3ikki.Capabilities)({
                ...state === null || state === void 0 ? void 0 : (_state$toJS2 = state.toJS) === null || _state$toJS2 === void 0 ? void 0 : _state$toJS2.call(state),
                pipelinesEnabled: repository_config === null || repository_config === void 0 ? void 0 : repository_config.pipelines_enabled,
                hasFetchedCapabilities: true
            });
        }
    },
    [(0, $jPcDa.REQUEST_ENABLE_PIPELINES).REQUEST] (state) {
        var _state$toJS3;
        return new (0, $3ikki.Capabilities)({
            ...state === null || state === void 0 ? void 0 : (_state$toJS3 = state.toJS) === null || _state$toJS3 === void 0 ? void 0 : _state$toJS3.call(state),
            pipelinesEnabled: false
        });
    },
    [(0, $jPcDa.REQUEST_ENABLE_PIPELINES).SUCCESS] (state) {
        var _state$toJS4;
        return new (0, $3ikki.Capabilities)({
            ...state === null || state === void 0 ? void 0 : (_state$toJS4 = state.toJS) === null || _state$toJS4 === void 0 ? void 0 : _state$toJS4.call(state),
            pipelinesEnabled: true
        });
    },
    [(0, $jPcDa.REQUEST_ENABLE_PIPELINES).ERROR] (state, action) {
        var _state$toJS5;
        return new (0, $3ikki.Capabilities)({
            ...state === null || state === void 0 ? void 0 : (_state$toJS5 = state.toJS) === null || _state$toJS5 === void 0 ? void 0 : _state$toJS5.call(state),
            pipelinesEnabled: false,
            pipelinesEnabledError: action === null || action === void 0 ? void 0 : action.payload
        });
    },
    [(0, $jPcDa.REQUEST_DISABLE_PIPELINES).REQUEST] (state) {
        var _state$toJS6;
        return new (0, $3ikki.Capabilities)({
            ...state === null || state === void 0 ? void 0 : (_state$toJS6 = state.toJS) === null || _state$toJS6 === void 0 ? void 0 : _state$toJS6.call(state),
            pipelinesEnabled: true
        });
    },
    [(0, $jPcDa.REQUEST_DISABLE_PIPELINES).SUCCESS] (state) {
        var _state$toJS7;
        return new (0, $3ikki.Capabilities)({
            ...state === null || state === void 0 ? void 0 : (_state$toJS7 = state.toJS) === null || _state$toJS7 === void 0 ? void 0 : _state$toJS7.call(state),
            pipelinesEnabled: false
        });
    },
    [(0, $jPcDa.REQUEST_DISABLE_PIPELINES).ERROR] (state, action) {
        var _state$toJS8;
        return new (0, $3ikki.Capabilities)({
            ...state === null || state === void 0 ? void 0 : (_state$toJS8 = state.toJS) === null || _state$toJS8 === void 0 ? void 0 : _state$toJS8.call(state),
            pipelinesEnabled: true,
            pipelinesEnabledError: action === null || action === void 0 ? void 0 : action.payload
        });
    }
});

});

parcelRegister("6WaEw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4375e31272559738$export$2e2bcd8739ae039; });
parcelRequire("e9n2v");
var $f7wkq = parcelRequire("f7wkq");

var $gsXeO = parcelRequire("gsXeO");

var $jPcDa = parcelRequire("jPcDa");
const $4375e31272559738$export$d4c72bab9d6cc13a = [];
var $4375e31272559738$export$2e2bcd8739ae039 = (0, $gsXeO.default)($4375e31272559738$export$d4c72bab9d6cc13a, {
    [(0, $jPcDa.CLEAR_CURRENT_PIPELINE)] () {
        return [];
    },
    [(0, $jPcDa.REQUEST_COMMIT_PULL_REQUESTS).REQUEST] () {
        return [];
    },
    [(0, $jPcDa.REQUEST_COMMIT_PULL_REQUESTS).SUCCESS] (state, action) {
        var _action$payload;
        if (!((_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.values)) return state;
        return action.payload.values.map((data)=>new (0, $f7wkq.PullRequest)(data));
    }
});

});

parcelRegister("cQZpi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f622278daefee643$export$2e2bcd8739ae039; });
parcelRequire("e9n2v");
var $gB1lx = parcelRequire("gB1lx");
var $2Od6r = parcelRequire("2Od6r");

var $90kWr = parcelRequire("90kWr");

var $gsXeO = parcelRequire("gsXeO");

var $jPcDa = parcelRequire("jPcDa");
const $f622278daefee643$export$d4c72bab9d6cc13a = {
    pipeline: new (0, $gB1lx.Pipeline)(),
    fetchedStatus: (0, $90kWr.LoadingStatus).Before
};
const $f622278daefee643$var$reduceCurrentPipeline = (state, action)=>{
    var _action$payload;
    if (!((_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.uuid)) return state;
    return {
        pipeline: new (0, $gB1lx.Pipeline)({
            ...action.payload
        }),
        fetchedStatus: (0, $90kWr.LoadingStatus).Success
    };
};
var $f622278daefee643$export$2e2bcd8739ae039 = (0, $gsXeO.default)($f622278daefee643$export$d4c72bab9d6cc13a, {
    [(0, $jPcDa.CLEAR_CURRENT_PIPELINE)] () {
        return $f622278daefee643$export$d4c72bab9d6cc13a;
    },
    [(0, $jPcDa.SET_CURRENT_PIPELINE)]: $f622278daefee643$var$reduceCurrentPipeline,
    [(0, $jPcDa.REQUEST_CURRENT_PIPELINE).SUCCESS]: $f622278daefee643$var$reduceCurrentPipeline,
    [(0, $jPcDa.REQUEST_CURRENT_PIPELINE).ERROR] (state) {
        var _state$pipeline$toJS, _state$pipeline;
        return {
            pipeline: new (0, $gB1lx.Pipeline)({
                ...state === null || state === void 0 ? void 0 : (_state$pipeline$toJS = (_state$pipeline = state.pipeline).toJS) === null || _state$pipeline$toJS === void 0 ? void 0 : _state$pipeline$toJS.call(_state$pipeline),
                error: new (0, $2Od6r.PipelineError)({
                    key: "pipeline-error"
                })
            }),
            fetchedStatus: state.fetchedStatus
        };
    },
    [(0, $jPcDa.REQUEST_UPDATE_PIPELINE).SUCCESS] (state, action) {
        var _action$payload2;
        if (!state.pipeline.uuid || ((_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.data.uuid) !== state.pipeline.uuid) return state;
        return {
            pipeline: new (0, $gB1lx.Pipeline)({
                ...action.payload.data
            }),
            fetchedStatus: state.fetchedStatus
        };
    },
    [(0, $jPcDa.REQUEST_CREATE_PIPELINE).REQUEST] (state) {
        var _state$pipeline$toJS2, _state$pipeline2;
        return {
            pipeline: new (0, $gB1lx.Pipeline)({
                ...state === null || state === void 0 ? void 0 : (_state$pipeline$toJS2 = (_state$pipeline2 = state.pipeline).toJS) === null || _state$pipeline$toJS2 === void 0 ? void 0 : _state$pipeline$toJS2.call(_state$pipeline2),
                isCreating: true
            }),
            fetchedStatus: (0, $90kWr.LoadingStatus).Fetching
        };
    },
    [(0, $jPcDa.REQUEST_CREATE_PIPELINE).SUCCESS] (state, action) {
        var _state$pipeline$toJS3, _state$pipeline3;
        return {
            pipeline: new (0, $gB1lx.Pipeline)({
                ...state === null || state === void 0 ? void 0 : (_state$pipeline$toJS3 = (_state$pipeline3 = state.pipeline).toJS) === null || _state$pipeline$toJS3 === void 0 ? void 0 : _state$pipeline$toJS3.call(_state$pipeline3),
                build_number: action.payload.build_number,
                uuid: action.payload.uuid,
                error: null
            }),
            fetchedStatus: state.fetchedStatus
        };
    },
    [(0, $jPcDa.REQUEST_CREATE_PIPELINE).ERROR] (state, action) {
        var _action$payload3, _state$pipeline$toJS4, _state$pipeline4;
        if (!((_action$payload3 = action.payload) !== null && _action$payload3 !== void 0 && _action$payload3.body)) return state;
        return {
            pipeline: new (0, $gB1lx.Pipeline)({
                ...state === null || state === void 0 ? void 0 : (_state$pipeline$toJS4 = (_state$pipeline4 = state.pipeline).toJS) === null || _state$pipeline$toJS4 === void 0 ? void 0 : _state$pipeline$toJS4.call(_state$pipeline4),
                isCreating: false,
                error: new (0, $2Od6r.PipelineError)(action.payload.body)
            }),
            fetchedStatus: state.fetchedStatus
        };
    },
    [(0, $jPcDa.REQUEST_STOP_PIPELINE).REQUEST] (state) {
        var _state$pipeline$toJS5, _state$pipeline5;
        return {
            pipeline: new (0, $gB1lx.Pipeline)({
                ...state === null || state === void 0 ? void 0 : (_state$pipeline$toJS5 = (_state$pipeline5 = state.pipeline).toJS) === null || _state$pipeline$toJS5 === void 0 ? void 0 : _state$pipeline$toJS5.call(_state$pipeline5),
                isStopping: true
            }),
            fetchedStatus: state.fetchedStatus
        };
    },
    [(0, $jPcDa.REQUEST_STOP_PIPELINE).ERROR] (state, action) {
        var _state$pipeline$toJS6, _state$pipeline6;
        return {
            pipeline: new (0, $gB1lx.Pipeline)({
                ...state === null || state === void 0 ? void 0 : (_state$pipeline$toJS6 = (_state$pipeline6 = state.pipeline).toJS) === null || _state$pipeline$toJS6 === void 0 ? void 0 : _state$pipeline$toJS6.call(_state$pipeline6),
                isStopping: false,
                error: new (0, $2Od6r.PipelineError)(action.payload.body)
            }),
            fetchedStatus: state.fetchedStatus
        };
    },
    [(0, $jPcDa.REQUEST_REDEPLOY_STEP).SUCCESS]: (state, action)=>{
        var _state$pipeline$toJS7, _state$pipeline7;
        if (!action.payload) return state;
        return {
            pipeline: new (0, $gB1lx.Pipeline)({
                ...state === null || state === void 0 ? void 0 : (_state$pipeline$toJS7 = (_state$pipeline7 = state.pipeline).toJS) === null || _state$pipeline$toJS7 === void 0 ? void 0 : _state$pipeline$toJS7.call(_state$pipeline7),
                ...action.payload
            }),
            fetchedStatus: state.fetchedStatus
        };
    },
    [(0, $jPcDa.REQUEST_RERUN_STEPS).SUCCESS]: (state, action)=>{
        var _state$pipeline$toJS8, _state$pipeline8;
        if (!action.payload) return state;
        return {
            pipeline: new (0, $gB1lx.Pipeline)({
                ...state === null || state === void 0 ? void 0 : (_state$pipeline$toJS8 = (_state$pipeline8 = state.pipeline).toJS) === null || _state$pipeline$toJS8 === void 0 ? void 0 : _state$pipeline$toJS8.call(_state$pipeline8),
                ...action.payload
            }),
            fetchedStatus: state.fetchedStatus
        };
    }
});

});

parcelRegister("3lQZy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb07a7ffc1feac4d$export$2e2bcd8739ae039; });
parcelRequire("e9n2v");
var $h5CwE = parcelRequire("h5CwE");

var $gsXeO = parcelRequire("gsXeO");

var $jPcDa = parcelRequire("jPcDa");
const $bb07a7ffc1feac4d$export$d4c72bab9d6cc13a = [];
const $bb07a7ffc1feac4d$var$reducePipelineDefintions = (state, action)=>{
    var _action$payload, _action$payload2, _action$payload2$valu;
    if (!((_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.values)) return state;
    return (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : (_action$payload2$valu = _action$payload2.values) === null || _action$payload2$valu === void 0 ? void 0 : _action$payload2$valu.map((data)=>new (0, $h5CwE.PipelineDefinition)(data));
};
var $bb07a7ffc1feac4d$export$2e2bcd8739ae039 = (0, $gsXeO.default)([], {
    [(0, $jPcDa.REQUEST_PIPELINE_DEFINITIONS).SUCCESS]: $bb07a7ffc1feac4d$var$reducePipelineDefintions,
    [(0, $jPcDa.SET_PIPELINE_DEFINITIONS)]: $bb07a7ffc1feac4d$var$reducePipelineDefintions
});

});

parcelRegister("5vxHs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77cac5905f1eb591$export$2e2bcd8739ae039; });

var $gsXeO = parcelRequire("gsXeO");

var $iyRMZ = parcelRequire("iyRMZ");

var $97yx8 = parcelRequire("97yx8");
const $77cac5905f1eb591$export$d4c72bab9d6cc13a = {
    map: {}
};
const $77cac5905f1eb591$var$getVariableStore = (state, action)=>{
    var _action$meta;
    return state.map[action === null || action === void 0 ? void 0 : (_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : _action$meta.environmentUuid] || (0, $97yx8.initialState);
};
var $77cac5905f1eb591$export$2e2bcd8739ae039 = (0, $gsXeO.default)($77cac5905f1eb591$export$d4c72bab9d6cc13a, {
    [(0, $iyRMZ.REQUEST_CREATE_ENVIRONMENT_VARIABLE).REQUEST] (state, action) {
        if (!action.meta) return state;
        return {
            map: {
                ...state.map,
                [action.meta.environmentUuid]: (0, $97yx8.requestCreateVariableBegin)($77cac5905f1eb591$var$getVariableStore(state, action), action)
            }
        };
    },
    [(0, $iyRMZ.REQUEST_CREATE_ENVIRONMENT_VARIABLE).SUCCESS]: (state, action)=>{
        if (!action.meta) return state;
        return {
            map: {
                ...state.map,
                [action.meta.environmentUuid]: (0, $97yx8.requestCreateVariableSuccess)($77cac5905f1eb591$var$getVariableStore(state, action), action)
            }
        };
    },
    [(0, $iyRMZ.REQUEST_CREATE_ENVIRONMENT_VARIABLE).ERROR]: (state, action)=>{
        if (!action.meta) return state;
        return {
            map: {
                ...state.map,
                [action.meta.environmentUuid]: (0, $97yx8.requestCreateVariableError)($77cac5905f1eb591$var$getVariableStore(state, action), action)
            }
        };
    },
    [(0, $iyRMZ.REQUEST_ENVIRONMENT_VARIABLES).REQUEST]: (state, action)=>{
        if (!action.meta) return state;
        return {
            map: {
                ...state.map,
                [action.meta.environmentUuid]: (0, $97yx8.requestVariablesBegin)($77cac5905f1eb591$var$getVariableStore(state, action))
            }
        };
    },
    [(0, $iyRMZ.REQUEST_ENVIRONMENT_VARIABLES).SUCCESS]: (state, action)=>{
        if (!action.meta) return state;
        return {
            map: {
                ...state.map,
                [action.meta.environmentUuid]: (0, $97yx8.requestVariablesSuccess)($77cac5905f1eb591$var$getVariableStore(state, action), action)
            }
        };
    },
    [(0, $iyRMZ.REQUEST_UPDATE_ENVIRONMENT_VARIABLE).REQUEST]: (state, action)=>{
        if (!action.meta) return state;
        return {
            map: {
                ...state.map,
                [action.meta.environmentUuid]: (0, $97yx8.requestUpdateVariableBegin)($77cac5905f1eb591$var$getVariableStore(state, action), action)
            }
        };
    },
    [(0, $iyRMZ.REQUEST_UPDATE_ENVIRONMENT_VARIABLE).SUCCESS]: (state, action)=>{
        if (!action.meta) return state;
        return {
            map: {
                ...state.map,
                [action.meta.environmentUuid]: (0, $97yx8.requestUpdateVariableSuccess)($77cac5905f1eb591$var$getVariableStore(state, action), action)
            }
        };
    },
    [(0, $iyRMZ.REQUEST_UPDATE_ENVIRONMENT_VARIABLE).ERROR]: (state, action)=>{
        if (!action.meta) return state;
        return {
            map: {
                ...state.map,
                [action.meta.environmentUuid]: (0, $97yx8.requestUpdateVariableError)($77cac5905f1eb591$var$getVariableStore(state, action), action)
            }
        };
    },
    [(0, $iyRMZ.REQUEST_DELETE_ENVIRONMENT_VARIABLE).REQUEST]: (state, action)=>{
        if (!action.meta) return state;
        return {
            map: {
                ...state.map,
                [action.meta.environmentUuid]: (0, $97yx8.requestDeleteVariableBegin)($77cac5905f1eb591$var$getVariableStore(state, action), action)
            }
        };
    }
});

});
parcelRegister("97yx8", function(module, exports) {

$parcel$export(module.exports, "initialState", function () { return $920c03daddb9b1d9$export$d4c72bab9d6cc13a; });
$parcel$export(module.exports, "requestCreateVariableBegin", function () { return $920c03daddb9b1d9$export$fe7eab46ee11f814; });
$parcel$export(module.exports, "requestCreateVariableSuccess", function () { return $920c03daddb9b1d9$export$856690475198a2bc; });
$parcel$export(module.exports, "requestCreateVariableError", function () { return $920c03daddb9b1d9$export$d838992e7d552da2; });
$parcel$export(module.exports, "requestVariablesBegin", function () { return $920c03daddb9b1d9$export$7ced4590aa5d1bbe; });
$parcel$export(module.exports, "requestVariablesSuccess", function () { return $920c03daddb9b1d9$export$ec4d777056515ab2; });
$parcel$export(module.exports, "requestUpdateVariableBegin", function () { return $920c03daddb9b1d9$export$8e118fcea13affea; });
$parcel$export(module.exports, "requestUpdateVariableSuccess", function () { return $920c03daddb9b1d9$export$97ef0b4a42245a9d; });
$parcel$export(module.exports, "requestUpdateVariableError", function () { return $920c03daddb9b1d9$export$bc6d0c8872396b6a; });
$parcel$export(module.exports, "requestDeleteVariableBegin", function () { return $920c03daddb9b1d9$export$24083d15278ccf94; });
$parcel$export(module.exports, "default", function () { return $920c03daddb9b1d9$export$2e2bcd8739ae039; });
parcelRequire("e9n2v");
var $iUiPN = parcelRequire("iUiPN");

var $90kWr = parcelRequire("90kWr");

var $gsXeO = parcelRequire("gsXeO");

var $i3LMs = parcelRequire("i3LMs");

var $iyRMZ = parcelRequire("iyRMZ");
const $920c03daddb9b1d9$export$d4c72bab9d6cc13a = {
    // SSR has a bug where it passes {} in initial state if set as new Map()
    map: [],
    fetchedStatus: (0, $90kWr.LoadingStatus).Before,
    page: 1,
    loadMore: false
};
function $920c03daddb9b1d9$export$94e0242ec35453d6() {
    return {
        ...$920c03daddb9b1d9$export$d4c72bab9d6cc13a
    };
}
function $920c03daddb9b1d9$export$fe7eab46ee11f814(state, action) {
    if (!action.meta) return state;
    const newMap = new Map(state.map);
    newMap.delete(action.meta.variable.key);
    const map = new Map([
        ...newMap,
        [
            action.meta.variable.key,
            new (0, $iUiPN.Variable)({
                ...action.meta.variable,
                isSyncing: true
            })
        ]
    ]);
    return {
        ...state,
        map: map
    };
}
function $920c03daddb9b1d9$export$856690475198a2bc(state, action) {
    var _action$payload, _action$payload2;
    if (!action.payload) return state;
    const newMap = new Map(state.map);
    newMap.delete((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.key);
    const map = new Map([
        ...newMap,
        [
            (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.uuid,
            new (0, $iUiPN.Variable)(action.payload)
        ]
    ]);
    return {
        ...state,
        map: map
    };
}
function $920c03daddb9b1d9$export$d838992e7d552da2(state, action) {
    var _action$meta, _action$meta$variable, _action$payload3, _action$payload3$body, _action$payload4;
    if (!action.meta) return state;
    const map = new Map(state.map);
    map.set((_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : (_action$meta$variable = _action$meta.variable) === null || _action$meta$variable === void 0 ? void 0 : _action$meta$variable.key, new (0, $iUiPN.Variable)({
        ...action.meta.variable,
        error: ((_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : (_action$payload3$body = _action$payload3.body) === null || _action$payload3$body === void 0 ? void 0 : _action$payload3$body.error) || ((_action$payload4 = action.payload) === null || _action$payload4 === void 0 ? void 0 : _action$payload4.error) || action.payload,
        isSyncing: false
    }));
    return {
        ...state,
        map: map
    };
}
function $920c03daddb9b1d9$export$7ced4590aa5d1bbe(state) {
    return {
        ...state,
        fetchedStatus: (0, $90kWr.LoadingStatus).Fetching
    };
}
function $920c03daddb9b1d9$export$ec4d777056515ab2(state, action) {
    var _action$payload5, _action$payload5$valu;
    if (!action.payload) return state;
    const map = new Map(state.map);
    (_action$payload5 = action.payload) === null || _action$payload5 === void 0 || (_action$payload5$valu = _action$payload5.values) === null || _action$payload5$valu === void 0 || _action$payload5$valu.forEach((variableData)=>{
        const variable = new (0, $iUiPN.Variable)(variableData);
        map.set(variable.uuid, variable);
    });
    return {
        ...state,
        page: state.page + 1,
        loadMore: action.payload.pagelen >= (0, $i3LMs.VARIABLES_PAGELEN),
        fetchedStatus: (0, $90kWr.LoadingStatus).Success,
        map: map
    };
}
function $920c03daddb9b1d9$export$8e118fcea13affea(state, action) {
    var _map$get;
    if (!action.meta) return state;
    const map = new Map(state.map);
    map.set(action.meta.previousVariable.uuid, new (0, $iUiPN.Variable)({
        ...(_map$get = map.get(action.meta.previousVariable.uuid)) === null || _map$get === void 0 ? void 0 : _map$get.toJS(),
        ...action.meta.variable,
        isSyncing: true
    }));
    return {
        ...state,
        map: map
    };
}
function $920c03daddb9b1d9$export$97ef0b4a42245a9d(state, action) {
    if (!action.payload || !action.meta) return state;
    const map = new Map(state.map);
    map.set(action.meta.previousVariable.uuid, new (0, $iUiPN.Variable)(action.payload));
    return {
        ...state,
        map: map
    };
}
function $920c03daddb9b1d9$export$bc6d0c8872396b6a(state, action) {
    var _map$get2, _action$payload6, _action$payload6$body, _action$payload7;
    if (!action.payload || !action.meta) return state;
    const map = new Map(state.map);
    map.set(action.meta.previousVariable.uuid, new (0, $iUiPN.Variable)({
        ...(_map$get2 = map.get(action.meta.previousVariable.uuid)) === null || _map$get2 === void 0 ? void 0 : _map$get2.toJS(),
        error: ((_action$payload6 = action.payload) === null || _action$payload6 === void 0 ? void 0 : (_action$payload6$body = _action$payload6.body) === null || _action$payload6$body === void 0 ? void 0 : _action$payload6$body.error) || ((_action$payload7 = action.payload) === null || _action$payload7 === void 0 ? void 0 : _action$payload7.error) || action.payload,
        isSyncing: false
    }));
    return {
        ...state,
        map: map
    };
}
function $920c03daddb9b1d9$export$24083d15278ccf94(state, action) {
    if (!action.meta) return state;
    const map = new Map(state.map);
    map.delete(action.meta.variable.uuid);
    return {
        ...state,
        map: map
    };
}
var $920c03daddb9b1d9$export$2e2bcd8739ae039 = (0, $gsXeO.default)($920c03daddb9b1d9$export$d4c72bab9d6cc13a, {
    // TODO: Replace the entire pipelines.variables with resource and hook in CICD-3682
    [(0, $iyRMZ.CLEAR_VARIABLES)]: $920c03daddb9b1d9$export$94e0242ec35453d6,
    [(0, $iyRMZ.REQUEST_CREATE_VARIABLE).REQUEST]: $920c03daddb9b1d9$export$fe7eab46ee11f814,
    [(0, $iyRMZ.REQUEST_CREATE_VARIABLE).SUCCESS]: $920c03daddb9b1d9$export$856690475198a2bc,
    [(0, $iyRMZ.REQUEST_CREATE_VARIABLE).ERROR]: $920c03daddb9b1d9$export$d838992e7d552da2,
    [(0, $iyRMZ.REQUEST_VARIABLES).REQUEST]: $920c03daddb9b1d9$export$7ced4590aa5d1bbe,
    [(0, $iyRMZ.REQUEST_VARIABLES).SUCCESS]: $920c03daddb9b1d9$export$ec4d777056515ab2,
    [(0, $iyRMZ.REQUEST_UPDATE_VARIABLE).REQUEST]: $920c03daddb9b1d9$export$8e118fcea13affea,
    [(0, $iyRMZ.REQUEST_UPDATE_VARIABLE).SUCCESS]: $920c03daddb9b1d9$export$97ef0b4a42245a9d,
    [(0, $iyRMZ.REQUEST_UPDATE_VARIABLE).ERROR]: $920c03daddb9b1d9$export$bc6d0c8872396b6a,
    [(0, $iyRMZ.REQUEST_DELETE_VARIABLE).REQUEST]: $920c03daddb9b1d9$export$24083d15278ccf94
});

});


parcelRegister("WBrVC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0486affb9b1b0c9c$export$2e2bcd8739ae039; });
parcelRequire("e9n2v");
var $faK9I = parcelRequire("faK9I");
var $goDEr = parcelRequire("goDEr");

var $gsXeO = parcelRequire("gsXeO");

var $jPcDa = parcelRequire("jPcDa");
const $0486affb9b1b0c9c$export$d4c72bab9d6cc13a = {
    checks: new (0, $faK9I.Checks)(),
    deployments: []
};
var $0486affb9b1b0c9c$export$2e2bcd8739ae039 = (0, $gsXeO.default)($0486affb9b1b0c9c$export$d4c72bab9d6cc13a, {
    [(0, $jPcDa.REQUEST_CHECK_SUITES).REQUEST] (state) {
        var _state$checks, _state$checks$toJS;
        return {
            ...state,
            checks: new (0, $faK9I.Checks)({
                ...(_state$checks = state.checks) === null || _state$checks === void 0 ? void 0 : (_state$checks$toJS = _state$checks.toJS) === null || _state$checks$toJS === void 0 ? void 0 : _state$checks$toJS.call(_state$checks),
                check_suites: {}
            })
        };
    },
    [(0, $jPcDa.REQUEST_CHECK_SUITE).SUCCESS] (state, action) {
        var _action$payload, _check_suites$checkSu, _state$checks2, _state$checks2$toJS;
        if (!((_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.uuid)) return state;
        const checkSuite = action.payload;
        const check_suites = {
            ...state.checks.check_suites
        };
        check_suites[checkSuite.uuid] = new (0, $faK9I.CheckSuite)({
            ...checkSuite,
            check_runs: ((_check_suites$checkSu = check_suites[checkSuite.uuid]) === null || _check_suites$checkSu === void 0 ? void 0 : _check_suites$checkSu.check_runs) || []
        });
        return {
            ...state,
            checks: new (0, $faK9I.Checks)({
                ...(_state$checks2 = state.checks) === null || _state$checks2 === void 0 ? void 0 : (_state$checks2$toJS = _state$checks2.toJS) === null || _state$checks2$toJS === void 0 ? void 0 : _state$checks2$toJS.call(_state$checks2),
                check_suites: check_suites
            })
        };
    },
    [(0, $jPcDa.REQUEST_CHECK_SUITES).SUCCESS] (state, action) {
        var _action$payload2, _state$checks3, _state$checks3$toJS;
        if (!((_action$payload2 = action.payload) !== null && _action$payload2 !== void 0 && _action$payload2.values)) return state;
        return {
            ...state,
            checks: new (0, $faK9I.Checks)({
                ...(_state$checks3 = state.checks) === null || _state$checks3 === void 0 ? void 0 : (_state$checks3$toJS = _state$checks3.toJS) === null || _state$checks3$toJS === void 0 ? void 0 : _state$checks3$toJS.call(_state$checks3),
                check_suites: {
                    ...state.checks.check_suites,
                    ...action.payload.values.reduce((acc, curr)=>{
                        acc[curr.uuid] = new (0, $faK9I.CheckSuite)(curr);
                        return acc;
                    }, {})
                }
            })
        };
    },
    [(0, $jPcDa.REQUEST_CHECK_SUITES).ERROR] (state) {
        var _state$checks4, _state$checks4$toJS;
        return {
            ...state,
            checks: new (0, $faK9I.Checks)({
                ...(_state$checks4 = state.checks) === null || _state$checks4 === void 0 ? void 0 : (_state$checks4$toJS = _state$checks4.toJS) === null || _state$checks4$toJS === void 0 ? void 0 : _state$checks4$toJS.call(_state$checks4),
                check_suites: {}
            })
        };
    },
    [(0, $jPcDa.REQUEST_CHECK_RUNS).REQUEST] (state, action) {
        var _action$meta, _checkSuite$toJS, _state$checks5, _state$checks5$toJS;
        if (!((_action$meta = action.meta) !== null && _action$meta !== void 0 && _action$meta.checkSuiteUuid)) return state;
        const check_suites = {
            ...state.checks.check_suites
        };
        const checkSuite = check_suites[action.meta.checkSuiteUuid] || new (0, $faK9I.CheckSuite)();
        check_suites[action.meta.checkSuiteUuid] = new (0, $faK9I.CheckSuite)({
            ...checkSuite === null || checkSuite === void 0 ? void 0 : (_checkSuite$toJS = checkSuite.toJS) === null || _checkSuite$toJS === void 0 ? void 0 : _checkSuite$toJS.call(checkSuite),
            check_runs: []
        });
        return {
            ...state,
            checks: new (0, $faK9I.Checks)({
                ...(_state$checks5 = state.checks) === null || _state$checks5 === void 0 ? void 0 : (_state$checks5$toJS = _state$checks5.toJS) === null || _state$checks5$toJS === void 0 ? void 0 : _state$checks5$toJS.call(_state$checks5),
                check_suites: check_suites
            })
        };
    },
    [(0, $jPcDa.REQUEST_CHECK_RUN).SUCCESS] (state, action) {
        var _action$payload3, _state$checks6, _state$checks6$toJS;
        if (!((_action$payload3 = action.payload) !== null && _action$payload3 !== void 0 && _action$payload3.uuid)) return state;
        const checkRun = action.payload;
        const check_runs = {
            ...state.checks.check_runs
        };
        const check_suites = {
            ...state.checks.check_suites
        };
        check_runs[checkRun.uuid] = new (0, $faK9I.CheckRun)(checkRun);
        const previousCheckSuite = check_suites[checkRun.check_suite.uuid] || new (0, $faK9I.CheckSuite)();
        check_suites[checkRun.check_suite.uuid] = new (0, $faK9I.CheckSuite)({
            ...previousCheckSuite.toJS(),
            check_runs: previousCheckSuite.check_runs.concat(checkRun.uuid)
        });
        return {
            ...state,
            checks: new (0, $faK9I.Checks)({
                ...(_state$checks6 = state.checks) === null || _state$checks6 === void 0 ? void 0 : (_state$checks6$toJS = _state$checks6.toJS) === null || _state$checks6$toJS === void 0 ? void 0 : _state$checks6$toJS.call(_state$checks6),
                check_runs: check_runs,
                check_suites: check_suites
            })
        };
    },
    [(0, $jPcDa.REQUEST_CHECK_RUNS).SUCCESS] (state, action) {
        var _action$payload4, _state$checks7, _state$checks7$toJS;
        if (!((_action$payload4 = action.payload) !== null && _action$payload4 !== void 0 && _action$payload4.values)) return state;
        const payloadValues = action.payload.values;
        const check_runs = payloadValues.reduce((checkRuns, nextCheckRun)=>{
            checkRuns[nextCheckRun.uuid] = new (0, $faK9I.CheckRun)(nextCheckRun);
            return checkRuns;
        }, {
            ...state.checks.check_runs
        });
        const check_suites = payloadValues.reduce((checkSuites, nextCheckRun)=>{
            const previousCheckSuite = checkSuites[nextCheckRun.check_suite.uuid] || new (0, $faK9I.CheckSuite)();
            const checkRuns = Array.isArray(previousCheckSuite.check_runs) ? previousCheckSuite.check_runs : [];
            checkSuites[nextCheckRun.check_suite.uuid] = new (0, $faK9I.CheckSuite)({
                ...previousCheckSuite.toJS(),
                check_runs: checkRuns.concat(nextCheckRun.uuid)
            });
            return checkSuites;
        }, {
            ...state.checks.check_suites
        });
        return {
            ...state,
            checks: new (0, $faK9I.Checks)({
                ...(_state$checks7 = state.checks) === null || _state$checks7 === void 0 ? void 0 : (_state$checks7$toJS = _state$checks7.toJS) === null || _state$checks7$toJS === void 0 ? void 0 : _state$checks7$toJS.call(_state$checks7),
                check_runs: check_runs,
                check_suites: check_suites
            })
        };
    },
    [(0, $jPcDa.REQUEST_CHECK_RUNS).ERROR] (state, action) {
        var _action$meta2, _check_suites$action$, _check_suites$action$2, _state$checks8, _state$checks8$toJS;
        if (!((_action$meta2 = action.meta) !== null && _action$meta2 !== void 0 && _action$meta2.checkSuiteUuid)) return state;
        const check_suites = {
            ...state.checks.check_suites
        };
        check_suites[action.meta.checkSuiteUuid] = new (0, $faK9I.CheckSuite)({
            ...(_check_suites$action$ = check_suites[action.meta.checkSuiteUuid]) === null || _check_suites$action$ === void 0 ? void 0 : (_check_suites$action$2 = _check_suites$action$.toJS) === null || _check_suites$action$2 === void 0 ? void 0 : _check_suites$action$2.call(_check_suites$action$),
            check_runs: []
        });
        return {
            ...state,
            checks: new (0, $faK9I.Checks)({
                ...(_state$checks8 = state.checks) === null || _state$checks8 === void 0 ? void 0 : (_state$checks8$toJS = _state$checks8.toJS) === null || _state$checks8$toJS === void 0 ? void 0 : _state$checks8$toJS.call(_state$checks8),
                check_suites: check_suites
            })
        };
    },
    [(0, $jPcDa.REQUEST_CHECKS_DEPLOYMENTS).SUCCESS] (state, action) {
        if (!(action !== null && action !== void 0 && action.payload)) return state;
        return {
            ...state,
            deployments: action.payload.map((d)=>new (0, $goDEr.Deployment)(d))
        };
    }
});

});

parcelRegister("j3sjB", function(module, exports) {

$parcel$export(module.exports, "log", function () { return $b591aec92aa33db7$export$bef1f36f5486a6a3; });

var $euNQ6 = parcelRequire("euNQ6");

var $90kWr = parcelRequire("90kWr");

var $gsXeO = parcelRequire("gsXeO");

var $jPcDa = parcelRequire("jPcDa");
const $b591aec92aa33db7$export$d4c72bab9d6cc13a = {
    commands: {},
    commandsV2: {},
    stepLogs: {},
    fullLog: {},
    fullLogError: {},
    serviceLog: {},
    serviceLogError: {},
    fetchedStatus: {}
};
const $b591aec92aa33db7$export$bef1f36f5486a6a3 = (0, $gsXeO.default)($b591aec92aa33db7$export$d4c72bab9d6cc13a, {
    [(0, $jPcDa.CLEAR_CURRENT_PIPELINE)] () {
        return {
            ...$b591aec92aa33db7$export$d4c72bab9d6cc13a
        };
    },
    [(0, $jPcDa.REQUEST_LOG).REQUEST] (state, action) {
        var _action$meta, _action$meta2;
        if (!((_action$meta = action.meta) !== null && _action$meta !== void 0 && _action$meta.stepUuid)) return state;
        return {
            ...state,
            ...!((_action$meta2 = action.meta) !== null && _action$meta2 !== void 0 && _action$meta2.index) ? {
                fullLogError: {
                    ...state.fullLogError,
                    [action.meta.stepUuid]: undefined
                }
            } : {},
            fetchedStatus: {
                ...state.fetchedStatus,
                [action.meta.stepUuid]: (0, $90kWr.LoadingStatus).Fetching
            }
        };
    },
    [(0, $jPcDa.REQUEST_FLAT_NESTED_LOGS).SUCCESS] (state, action) {
        const { logLines: logLines, stepLog: stepLog } = action.payload || {};
        if (!(0, $euNQ6.default)(action.meta.index) || !logLines || !stepLog) return state;
        const commandsV2 = state.commandsV2[action.meta.stepUuid] || [];
        commandsV2[action.meta.index] = logLines;
        return {
            ...state,
            commandsV2: {
                ...state.commandsV2,
                [action.meta.stepUuid]: commandsV2
            },
            stepLogs: {
                ...state.stepLogs,
                [action.meta.stepUuid]: stepLog
            }
        };
    },
    [(0, $jPcDa.REQUEST_LOG).SUCCESS] (state, action) {
        var _action$meta3;
        if (!((_action$meta3 = action.meta) !== null && _action$meta3 !== void 0 && _action$meta3.stepUuid) || !Array.isArray(action.payload)) return state;
        const commands = state.commands[action.meta.stepUuid] || [];
        if ((0, $euNQ6.default)(action.meta.index)) commands[action.meta.index] = action.payload;
        return {
            ...state,
            ...!Object.prototype.hasOwnProperty.call(action.meta, "index") ? {
                fullLog: {
                    ...state.fullLog,
                    [action.meta.stepUuid]: action.payload.join("\r\n")
                }
            } : {
                commands: {
                    ...state.commands,
                    [action.meta.stepUuid]: commands
                }
            },
            fetchedStatus: {
                ...state.fetchedStatus,
                [action.meta.stepUuid]: (0, $90kWr.LoadingStatus).Success
            }
        };
    },
    [(0, $jPcDa.REQUEST_LOG).ERROR] (state, action) {
        var _action$meta4, _action$payload;
        if (!((_action$meta4 = action.meta) !== null && _action$meta4 !== void 0 && _action$meta4.stepUuid)) return state;
        return {
            ...state,
            ...!Object.prototype.hasOwnProperty.call(action.meta, "index") ? {
                fullLogError: {
                    ...state.fullLogError,
                    [action.meta.stepUuid]: (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.message
                }
            } : {},
            fetchedStatus: {
                ...state.fetchedStatus,
                [action.meta.stepUuid]: (0, $90kWr.LoadingStatus).Failed
            }
        };
    },
    [(0, $jPcDa.REQUEST_SERVICE_LOG).REQUEST] (state, action) {
        var _action$meta5;
        if (!((_action$meta5 = action.meta) !== null && _action$meta5 !== void 0 && _action$meta5.serviceUuid)) return state;
        return {
            ...state,
            serviceLogError: {
                ...state.serviceLogError,
                [action.meta.serviceUuid]: undefined
            },
            fetchedStatus: {
                ...state.fetchedStatus,
                [action.meta.serviceUuid]: (0, $90kWr.LoadingStatus).Fetching
            }
        };
    },
    [(0, $jPcDa.REQUEST_SERVICE_LOG).SUCCESS] (state, action) {
        var _action$meta6;
        if (!((_action$meta6 = action.meta) !== null && _action$meta6 !== void 0 && _action$meta6.serviceUuid)) return state;
        const chunkLines = [
            ""
        ].concat(action.payload ? action.payload.split(/\r?\n|\r/) : []);
        return {
            ...state,
            serviceLog: {
                ...state.serviceLog,
                [action.meta.serviceUuid]: chunkLines
            },
            fetchedStatus: {
                ...state.fetchedStatus,
                [action.meta.serviceUuid]: (0, $90kWr.LoadingStatus).Success
            }
        };
    },
    [(0, $jPcDa.REQUEST_SERVICE_LOG).ERROR] (state, action) {
        var _action$meta7, _action$payload2;
        if (!((_action$meta7 = action.meta) !== null && _action$meta7 !== void 0 && _action$meta7.serviceUuid)) return state;
        return {
            ...state,
            serviceLogError: {
                ...state.serviceLogError,
                [action.meta.serviceUuid]: (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.message
            },
            fetchedStatus: {
                ...state.fetchedStatus,
                [action.meta.serviceUuid]: (0, $90kWr.LoadingStatus).Failed
            }
        };
    },
    [(0, $jPcDa.REQUEST_DELETE_LOG).REQUEST] (state) {
        return {
            ...state,
            fetchedStatus: {
                ...state.fetchedStatus,
                DELETE_LOG: (0, $90kWr.LoadingStatus).Fetching
            }
        };
    },
    [(0, $jPcDa.REQUEST_DELETE_LOG).SUCCESS] (state, action) {
        var _action$meta8;
        if (!((_action$meta8 = action.meta) !== null && _action$meta8 !== void 0 && _action$meta8.stepUuid)) return state;
        return {
            ...state,
            ...action.meta.serviceUuid ? {
                serviceLog: {
                    ...state.serviceLog,
                    [action.meta.serviceUuid]: []
                }
            } : {
                commands: {
                    ...state.commands,
                    [action.meta.stepUuid]: []
                },
                fullLog: {
                    ...state.fullLog,
                    [action.meta.stepUuid]: ""
                },
                ...action.meta.incrementalRequestEnabled ? {
                    stepLogs: {
                        ...state.stepLogs,
                        [action.meta.stepUuid]: new Map()
                    }
                } : {},
                ...action.meta.incrementalRequestEnabled ? {
                    commandsV2: {
                        ...state.commandsV2,
                        [action.meta.stepUuid]: []
                    }
                } : {}
            },
            fetchedStatus: {
                ...state.fetchedStatus,
                DELETE_LOG: (0, $90kWr.LoadingStatus).Success
            }
        };
    }
});

});
parcelRegister("euNQ6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8da871209ecf54a$export$2e2bcd8739ae039; });

var $9mt1a = parcelRequire("9mt1a");

var $bqTHd = parcelRequire("bqTHd");
/** `Object#toString` result references. */ var $a8da871209ecf54a$var$numberTag = "[object Number]";
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $a8da871209ecf54a$var$isNumber(value) {
    return typeof value == "number" || (0, $bqTHd.default)(value) && (0, $9mt1a.default)(value) == $a8da871209ecf54a$var$numberTag;
}
var $a8da871209ecf54a$export$2e2bcd8739ae039 = $a8da871209ecf54a$var$isNumber;

});


parcelRegister("6r33o", function(module, exports) {

$parcel$export(module.exports, "metricsReducer", function () { return $753871443196529d$export$de2482c1dfa4412e; });
parcelRequire("e9n2v");
var $7tNBI = parcelRequire("7tNBI");

var $90kWr = parcelRequire("90kWr");

var $gsXeO = parcelRequire("gsXeO");

var $jPcDa = parcelRequire("jPcDa");
const $753871443196529d$export$d4c72bab9d6cc13a = {
    metrics: {},
    fetchedStatus: (0, $90kWr.LoadingStatus).Before
};
const $753871443196529d$export$de2482c1dfa4412e = (0, $gsXeO.default)($753871443196529d$export$d4c72bab9d6cc13a, {
    [(0, $jPcDa.REQUEST_METRICS).REQUEST] (state) {
        return {
            ...state,
            fetchedStatus: (0, $90kWr.LoadingStatus).Fetching
        };
    },
    [(0, $jPcDa.REQUEST_METRICS).ERROR] (state) {
        return {
            ...state,
            fetchedStatus: (0, $90kWr.LoadingStatus).Failed
        };
    },
    [(0, $jPcDa.REQUEST_METRICS).SUCCESS] (state, action) {
        if (!action.payload || !action.meta) return state;
        const stepMetrics = state.metrics[action.meta.stepUuid] || {
            MEMORY: {},
            CPU: {},
            MEMORY_PERCENTAGE: {}
        };
        action.payload.forEach((metric)=>{
            if (metric.metric_type && metric.sample_time) stepMetrics[metric.metric_type][metric.sample_time] = new (0, $7tNBI.Metric)(metric);
        });
        return {
            metrics: {
                ...state.metrics,
                [action.meta.stepUuid]: stepMetrics
            },
            fetchedStatus: (0, $90kWr.LoadingStatus).Success
        };
    }
});

});

parcelRegister("4ko1t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fea43e0f0d21d5fd$export$2e2bcd8739ae039; });
parcelRequire("e9n2v");
var $7gE4v = parcelRequire("7gE4v");

var $gsXeO = parcelRequire("gsXeO");

var $jPcDa = parcelRequire("jPcDa");
const $fea43e0f0d21d5fd$export$d4c72bab9d6cc13a = [];
var $fea43e0f0d21d5fd$export$2e2bcd8739ae039 = (0, $gsXeO.default)($fea43e0f0d21d5fd$export$d4c72bab9d6cc13a, {
    [(0, $jPcDa.REQUEST_OFFICIAL_TEMPLATES).SUCCESS] (state, action) {
        var _action$payload;
        if (!action.payload) return state;
        return (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.map((officialTemplate, id)=>new (0, $7gE4v.OfficialTemplate)({
                ...officialTemplate,
                id: id
            }));
    }
});

});

parcelRegister("Omq5t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c7233dbbfb365ce$export$2e2bcd8739ae039; });
parcelRequire("e9n2v");
var $gB1lx = parcelRequire("gB1lx");
var $7Re2y = parcelRequire("7Re2y");

var $90kWr = parcelRequire("90kWr");

var $gsXeO = parcelRequire("gsXeO");

var $i3LMs = parcelRequire("i3LMs");

var $kMBn7 = parcelRequire("kMBn7");

var $jPcDa = parcelRequire("jPcDa");
const $2c7233dbbfb365ce$export$d4c72bab9d6cc13a = {
    list: [],
    creators: [],
    fetchedStatus: (0, $90kWr.LoadingStatus).Before,
    size: -1,
    page: 1
};

const $2c7233dbbfb365ce$var$createUser = (pipeline)=>{
    var _pipeline$creator, _pipeline$trigger, _pipeline$creator2, _pipeline$creator3, _pipeline$trigger2, _pipeline$creator4, _pipeline$creator5, _pipeline$trigger3;
    let user = pipeline.creator;
    if ((_pipeline$creator = pipeline.creator) !== null && _pipeline$creator !== void 0 && _pipeline$creator.uuid && ((_pipeline$trigger = pipeline.trigger) === null || _pipeline$trigger === void 0 ? void 0 : _pipeline$trigger.type) === "pipeline_trigger_schedule") user = {
        uuid: pipeline.creator.uuid,
        display_name: "Scheduled",
        links: {
            avatar: {
                href: (parcelRequire("4ggkH"))
            }
        }
    };
    else if ((_pipeline$creator2 = pipeline.creator) !== null && _pipeline$creator2 !== void 0 && _pipeline$creator2.uuid && !((_pipeline$creator3 = pipeline.creator) !== null && _pipeline$creator3 !== void 0 && _pipeline$creator3.display_name) && ((_pipeline$trigger2 = pipeline.trigger) === null || _pipeline$trigger2 === void 0 ? void 0 : _pipeline$trigger2.type) === "pipeline_trigger_push") user = {
        uuid: pipeline.creator.uuid,
        display_name: "Push"
    };
    else if ((_pipeline$creator4 = pipeline.creator) !== null && _pipeline$creator4 !== void 0 && _pipeline$creator4.uuid && !((_pipeline$creator5 = pipeline.creator) !== null && _pipeline$creator5 !== void 0 && _pipeline$creator5.display_name) && ((_pipeline$trigger3 = pipeline.trigger) === null || _pipeline$trigger3 === void 0 ? void 0 : _pipeline$trigger3.type) === "pipeline_trigger_manual") user = {
        uuid: pipeline.creator.uuid,
        display_name: "Manual"
    };
    return new (0, $7Re2y.User)(user);
};
const $2c7233dbbfb365ce$var$reducePipelines = (state, action)=>{
    var _action$payload, _action$payload2;
    if (!((_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.values)) return state;
    const { values: values, page: page } = action.payload;
    const list = values === null || values === void 0 ? void 0 : values.reduce((reducer, pipelineData, index)=>{
        reducer[index + (0, $i3LMs.PIPELINE_PAGE_SIZE) * (page - 1)] = new (0, $gB1lx.Pipeline)(pipelineData);
        return reducer;
    }, [
        ...state.list
    ]);
    return {
        ...state,
        size: (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.size,
        fetchedStatus: (0, $90kWr.LoadingStatus).Success,
        list: list
    };
};
const $2c7233dbbfb365ce$var$reducePipelineCreators = (state, action)=>{
    var _action$payload3, _action$payload$value;
    if (!((_action$payload3 = action.payload) !== null && _action$payload3 !== void 0 && _action$payload3.values)) return state;
    const creators = (_action$payload$value = action.payload.values) === null || _action$payload$value === void 0 ? void 0 : _action$payload$value.map($2c7233dbbfb365ce$var$createUser);
    return {
        ...state,
        creators: creators.filter((user, index)=>(creators === null || creators === void 0 ? void 0 : creators.findIndex((u)=>u.uuid === (user === null || user === void 0 ? void 0 : user.uuid))) === index)
    };
};
var $2c7233dbbfb365ce$export$2e2bcd8739ae039 = (0, $gsXeO.default)($2c7233dbbfb365ce$export$d4c72bab9d6cc13a, {
    [(0, $jPcDa.REMOVE_PIPELINES_DATA)] (state) {
        return {
            ...$2c7233dbbfb365ce$export$d4c72bab9d6cc13a,
            creators: state.creators
        };
    },
    [(0, $jPcDa.REQUEST_PIPELINES).REQUEST] (state, action) {
        var _action$meta, _action$meta$queryPar;
        return {
            ...state,
            page: (action === null || action === void 0 ? void 0 : (_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : (_action$meta$queryPar = _action$meta.queryParams) === null || _action$meta$queryPar === void 0 ? void 0 : _action$meta$queryPar.page) || 1,
            fetchedStatus: (0, $90kWr.LoadingStatus).Fetching
        };
    },
    [(0, $jPcDa.SET_PIPELINES)]: $2c7233dbbfb365ce$var$reducePipelines,
    [(0, $jPcDa.REQUEST_PIPELINES).SUCCESS]: $2c7233dbbfb365ce$var$reducePipelines,
    [(0, $jPcDa.REQUEST_UPDATE_PIPELINE).SUCCESS] (state, action) {
        var _action$payload4;
        if (!(action !== null && action !== void 0 && (_action$payload4 = action.payload) !== null && _action$payload4 !== void 0 && _action$payload4.data.uuid)) return state;
        const { data: data, selectedBranch: selectedBranch } = action.payload;
        const pipeline = new (0, $gB1lx.Pipeline)(data);
        if (selectedBranch && pipeline.sourceBranch !== selectedBranch) return state;
        const index = state.list.findIndex((i)=>(i === null || i === void 0 ? void 0 : i.uuid) === (pipeline === null || pipeline === void 0 ? void 0 : pipeline.uuid));
        const hasFilters = Object.values((0, $kMBn7.parseFilterPathParam)(location.pathname)).some((f)=>!!f);
        let newList = state.list;
        if (index > -1) {
            newList = [
                ...state.list
            ];
            newList[index] = pipeline;
        } else if (!hasFilters && state.page === 1) newList = [
            pipeline,
            ...state.list
        ];
        return newList === state.list ? state : {
            ...state,
            list: newList
        };
    },
    [(0, $jPcDa.REQUEST_PIPELINE_CREATORS).SUCCESS]: $2c7233dbbfb365ce$var$reducePipelineCreators,
    [(0, $jPcDa.SET_PIPELINE_CREATORS)]: $2c7233dbbfb365ce$var$reducePipelineCreators
});

});
parcelRegister("4ggkH", function(module, exports) {

module.exports = (parcelRequire("1sJKT")).getBundleURL("ekZ4q") + "calendar-icon.0245dede.png";

});


parcelRegister("dQjgB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed54b8482b549e01$export$2e2bcd8739ae039; });
parcelRequire("e9n2v");
var $4nYUB = parcelRequire("4nYUB");
var $akm6L = parcelRequire("akm6L");

var $90kWr = parcelRequire("90kWr");

var $gsXeO = parcelRequire("gsXeO");

var $jPcDa = parcelRequire("jPcDa");
const $ed54b8482b549e01$export$d4c72bab9d6cc13a = {
    list: [],
    annotations: [],
    fetchedAnnotationStatus: (0, $90kWr.LoadingStatus).Before,
    fetchedStatus: (0, $90kWr.LoadingStatus).Before
};
var $ed54b8482b549e01$export$2e2bcd8739ae039 = (0, $gsXeO.default)($ed54b8482b549e01$export$d4c72bab9d6cc13a, {
    [(0, $jPcDa.REQUEST_REPORTS).REQUEST] (state) {
        return {
            ...state,
            list: [],
            annotations: [],
            fetchedStatus: (0, $90kWr.LoadingStatus).Fetching
        };
    },
    [(0, $jPcDa.REQUEST_REPORTS).SUCCESS] (state, action) {
        var _action$payload;
        if (!((_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.values)) return state;
        return {
            ...state,
            fetchedStatus: (0, $90kWr.LoadingStatus).Success,
            list: action.payload.values.map((data)=>new (0, $akm6L.Report)(data))
        };
    },
    [(0, $jPcDa.REQUEST_REPORTS).ERROR] (state) {
        return {
            ...state,
            fetchedStatus: (0, $90kWr.LoadingStatus).Failed
        };
    },
    [(0, $jPcDa.REQUEST_REPORT).SUCCESS] (state, action) {
        if (!(action !== null && action !== void 0 && action.payload)) return state;
        const list = [
            ...state.list
        ];
        const report = new (0, $akm6L.Report)(action.payload);
        const index = state.list.findIndex((r)=>(r === null || r === void 0 ? void 0 : r.uuid) === report.uuid);
        if (index !== -1) list[index] = report;
        else list.push(report);
        return {
            ...state,
            list: list
        };
    },
    [(0, $jPcDa.REQUEST_ANNOTATIONS).REQUEST] (state) {
        return {
            ...state,
            annotations: [],
            fetchedAnnotationStatus: (0, $90kWr.LoadingStatus).Fetching
        };
    },
    [(0, $jPcDa.REQUEST_ANNOTATIONS).SUCCESS] (state, action) {
        if (!action.payload) return state;
        return {
            ...state,
            annotations: action.payload.map((data)=>new (0, $4nYUB.Annotation)(data)),
            fetchedAnnotationStatus: (0, $90kWr.LoadingStatus).Success
        };
    },
    [(0, $jPcDa.REQUEST_ANNOTATIONS).ERROR] (state) {
        return {
            ...state,
            fetchedAnnotationStatus: (0, $90kWr.LoadingStatus).Failed
        };
    }
});

});

parcelRegister("ds8Mw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $241cd6ef1aee8e15$export$2e2bcd8739ae039; });
// @ts-ignore TODO: fix noImplicitAny error here

var $2b0jZ = parcelRequire("2b0jZ");
parcelRequire("e9n2v");
var $6WfB6 = parcelRequire("6WfB6");

var $gsXeO = parcelRequire("gsXeO");

var $kH3GU = parcelRequire("kH3GU");

var $gVLH7 = parcelRequire("gVLH7");

var $jPcDa = parcelRequire("jPcDa");
var $241cd6ef1aee8e15$export$2e2bcd8739ae039 = (0, $gsXeO.default)(new (0, $6WfB6.Repository)(), {
    [(0, $jPcDa.SET_REPOSITORY)] (state, action) {
        var _repoData$mainbranch, _repoData$links, _repoData$links$html, _repoData$owner;
        if (!action.payload) return state;
        const repoData = action.payload;
        return new (0, $6WfB6.Repository)({
            ...repoData,
            hasFetched: true,
            mainbranch: (_repoData$mainbranch = repoData.mainbranch) === null || _repoData$mainbranch === void 0 ? void 0 : _repoData$mainbranch.name,
            link: (_repoData$links = repoData.links) === null || _repoData$links === void 0 ? void 0 : (_repoData$links$html = _repoData$links.html) === null || _repoData$links$html === void 0 ? void 0 : _repoData$links$html.href,
            path: repoData.full_name,
            displayName: ((_repoData$owner = repoData.owner) === null || _repoData$owner === void 0 ? void 0 : _repoData$owner.display_name) || repoData.full_name
        });
    },
    [(0, $jPcDa.REQUEST_REPOSITORY_USER_IS_MEMBER).SUCCESS] (state, action) {
        var _action$meta, _action$meta2, _state$toJS;
        let perms = {};
        if (((_action$meta = action.meta) === null || _action$meta === void 0 ? void 0 : _action$meta.role) === "admin") {
            var _action$payload;
            perms = {
                hasFetchedUserIsAdmin: true,
                userIsAdmin: (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.values.some((repository)=>repository.full_name === state.path)
            };
        } else if (((_action$meta2 = action.meta) === null || _action$meta2 === void 0 ? void 0 : _action$meta2.role) === "contributor") {
            var _action$payload2;
            perms = {
                canWrite: (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.values.some((repository)=>repository.full_name === state.path)
            };
        }
        return new (0, $6WfB6.Repository)({
            ...state === null || state === void 0 ? void 0 : (_state$toJS = state.toJS) === null || _state$toJS === void 0 ? void 0 : _state$toJS.call(state),
            ...perms
        });
    },
    [(0, $jPcDa.REQUEST_REPOSITORY_BRANCH_RESTRICTIONS).SUCCESS] (state, action) {
        var _action$meta3, _action$payload3, _state$toJS2;
        if (!action.payload || !((_action$meta3 = action.meta) !== null && _action$meta3 !== void 0 && _action$meta3.userUuid)) return state;
        const canWriteMainBranch = !((_action$payload3 = action.payload) !== null && _action$payload3 !== void 0 && _action$payload3.some((restriction)=>{
            var _restriction$kind$pus, _restriction$kind$pus2;
            return !!restriction.kind.push && (0, (/*@__PURE__*/$parcel$interopDefault($2b0jZ)))(restriction.pattern).test(state.mainbranch) && !((_restriction$kind$pus = restriction.kind.push) !== null && _restriction$kind$pus !== void 0 && (_restriction$kind$pus2 = _restriction$kind$pus.users) !== null && _restriction$kind$pus2 !== void 0 && _restriction$kind$pus2.some((user)=>{
                var _action$meta4;
                return (user === null || user === void 0 ? void 0 : user.uuid) === ((_action$meta4 = action.meta) === null || _action$meta4 === void 0 ? void 0 : _action$meta4.userUuid);
            }));
        }));
        return new (0, $6WfB6.Repository)({
            ...state === null || state === void 0 ? void 0 : (_state$toJS2 = state.toJS) === null || _state$toJS2 === void 0 ? void 0 : _state$toJS2.call(state),
            hasFetchedCanWriteMainBranch: true,
            canWriteMainBranch: canWriteMainBranch
        });
    },
    [(0, $jPcDa.REQUEST_REPOSITORY_BRANCH_RESTRICTIONS).ERROR]: (state)=>{
        var _state$toJS3;
        return new (0, $6WfB6.Repository)({
            ...state === null || state === void 0 ? void 0 : (_state$toJS3 = state.toJS) === null || _state$toJS3 === void 0 ? void 0 : _state$toJS3.call(state),
            hasFetchedCanWriteMainBranch: true,
            canWriteMainBranch: true
        });
    },
    [(0, $jPcDa.REQUEST_REPOSITORY_FILES).SUCCESS]: (state, action)=>{
        var _action$payload4, _action$payload4$, _state$toJS4;
        if (!((_action$payload4 = action.payload) !== null && _action$payload4 !== void 0 && (_action$payload4$ = _action$payload4[0]) !== null && _action$payload4$ !== void 0 && _action$payload4$.contents)) return state;
        const files = (0, $gVLH7.default)(action.payload[0].contents);
        return new (0, $6WfB6.Repository)({
            ...state === null || state === void 0 ? void 0 : (_state$toJS4 = state.toJS) === null || _state$toJS4 === void 0 ? void 0 : _state$toJS4.call(state),
            language: state.language || (0, $kH3GU.default)(files),
            files: files
        });
    }
});

});
parcelRegister("2b0jZ", function(module, exports) {
module.exports = function(glob, opts) {
    if (typeof glob !== "string") throw new TypeError("Expected a string");
    var str = String(glob);
    // The regexp we are building, as a string.
    var reStr = "";
    // Whether we are matching so called "extended" globs (like bash) and should
    // support single character matching, matching ranges of characters, group
    // matching, etc.
    var extended = opts ? !!opts.extended : false;
    // When globstar is _false_ (default), '/foo/*' is translated a regexp like
    // '^\/foo\/.*$' which will match any string beginning with '/foo/'
    // When globstar is _true_, '/foo/*' is translated to regexp like
    // '^\/foo\/[^/]*$' which will match any string beginning with '/foo/' BUT
    // which does not have a '/' to the right of it.
    // E.g. with '/foo/*' these will match: '/foo/bar', '/foo/bar.txt' but
    // these will not '/foo/bar/baz', '/foo/bar/baz.txt'
    // Lastely, when globstar is _true_, '/foo/**' is equivelant to '/foo/*' when
    // globstar is _false_
    var globstar = opts ? !!opts.globstar : false;
    // If we are doing extended matching, this boolean is true when we are inside
    // a group (eg {*.html,*.js}), and false otherwise.
    var inGroup = false;
    // RegExp flags (eg "i" ) to pass in to RegExp constructor.
    var flags = opts && typeof opts.flags === "string" ? opts.flags : "";
    var c;
    for(var i = 0, len = str.length; i < len; i++){
        c = str[i];
        switch(c){
            case "/":
            case "$":
            case "^":
            case "+":
            case ".":
            case "(":
            case ")":
            case "=":
            case "!":
            case "|":
                reStr += "\\" + c;
                break;
            case "?":
                if (extended) {
                    reStr += ".";
                    break;
                }
            case "[":
            case "]":
                if (extended) {
                    reStr += c;
                    break;
                }
            case "{":
                if (extended) {
                    inGroup = true;
                    reStr += "(";
                    break;
                }
            case "}":
                if (extended) {
                    inGroup = false;
                    reStr += ")";
                    break;
                }
            case ",":
                if (inGroup) {
                    reStr += "|";
                    break;
                }
                reStr += "\\" + c;
                break;
            case "*":
                // Move over all consecutive "*"'s.
                // Also store the previous and next characters
                var prevChar = str[i - 1];
                var starCount = 1;
                while(str[i + 1] === "*"){
                    starCount++;
                    i++;
                }
                var nextChar = str[i + 1];
                if (!globstar) // globstar is disabled, so treat any number of "*" as one
                reStr += ".*";
                else {
                    // globstar is enabled, so determine if this is a globstar segment
                    var isGlobstar = starCount > 1 // multiple "*"'s
                     && (prevChar === "/" || prevChar === undefined // from the start of the segment
                    ) && (nextChar === "/" || nextChar === undefined // to the end of the segment
                    );
                    if (isGlobstar) {
                        // it's a globstar, so match zero or more path segments
                        reStr += "((?:[^/]*(?:/|$))*)";
                        i++; // move over the "/"
                    } else // it's not a globstar, so only match one path segment
                    reStr += "([^/]*)";
                }
                break;
            default:
                reStr += c;
        }
    }
    // When regexp 'g' flag is specified don't
    // constrain the regular expression with ^ & $
    if (!flags || !~flags.indexOf("g")) reStr = "^" + reStr + "$";
    return new RegExp(reStr, flags);
};

});

parcelRegister("kH3GU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4b84ee5901a1276$export$2e2bcd8739ae039; });
function $f4b84ee5901a1276$export$2e2bcd8739ae039(repositoryFiles) {
    let assumedLanguage = "";
    const languageSpecificFiles = {
        php: [
            "composer.json"
        ],
        python: [
            "requirements.txt",
            "manage.py"
        ],
        java: [
            "pom.xml"
        ],
        javascript: [
            "package.json",
            "bower.json"
        ],
        gradle: [
            "gradlew"
        ],
        haskell: [
            "stack.yaml"
        ],
        go: [
            "main.go"
        ],
        rust: [
            "Cargo.toml",
            "build.rs"
        ],
        scala: [
            "build.sbt"
        ],
        ruby: [
            "Rakefile",
            "Gemfile"
        ],
        clojure: [
            "project.clj"
        ],
        "c\\+\\+": [
            "Makefile"
        ],
        docker: [
            "Dockerfile"
        ],
        "vb.net": [
            "build.proj"
        ]
    };
    Object.keys(languageSpecificFiles).some((language)=>{
        const foundLanguageFile = languageSpecificFiles[language].some((file)=>repositoryFiles.indexOf(file) !== -1);
        if (foundLanguageFile) assumedLanguage = language;
        return foundLanguageFile;
    });
    return assumedLanguage;
}

});

parcelRegister("gVLH7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90a61af2e4a102ec$export$2e2bcd8739ae039; });
const $90a61af2e4a102ec$var$updatePath = (fileTree, files, path)=>{
    fileTree.forEach((item)=>{
        if (item.type === "file") files.push(`${path}${item.name}`);
        else if (item.type === "directory") // eslint-disable-next-line no-param-reassign
        files = $90a61af2e4a102ec$var$updatePath(item.contents, files, `${path && !path.endsWith("/") ? `${path}/` : path}${item.name}/`);
    });
    return files;
};
function $90a61af2e4a102ec$export$2e2bcd8739ae039(fileTree) {
    return $90a61af2e4a102ec$var$updatePath(fileTree, [], "");
}

});


parcelRegister("auJkg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47364ba805f49343$export$2e2bcd8739ae039; });
parcelRequire("e9n2v");
var $d0InP = parcelRequire("d0InP");

var $90kWr = parcelRequire("90kWr");

var $gsXeO = parcelRequire("gsXeO");

var $jPcDa = parcelRequire("jPcDa");
const $47364ba805f49343$export$d4c72bab9d6cc13a = {
    list: [],
    fetchedStatus: (0, $90kWr.LoadingStatus).Before,
    createdStatus: (0, $90kWr.LoadingStatus).Before
};
var $47364ba805f49343$export$2e2bcd8739ae039 = (0, $gsXeO.default)($47364ba805f49343$export$d4c72bab9d6cc13a, {
    [(0, $jPcDa.REQUEST_SCHEDULES).REQUEST] (state) {
        return {
            ...state,
            fetchedStatus: (0, $90kWr.LoadingStatus).Fetching
        };
    },
    [(0, $jPcDa.REQUEST_SCHEDULES).SUCCESS] (state, action) {
        if (!action.payload) return state;
        return {
            ...state,
            list: action.payload.map((schedule)=>new (0, $d0InP.Schedule)(schedule)),
            fetchedStatus: (0, $90kWr.LoadingStatus).Success
        };
    },
    [(0, $jPcDa.REQUEST_CREATE_SCHEDULE).REQUEST] (state, action) {
        var _action$meta;
        if (!((_action$meta = action.meta) !== null && _action$meta !== void 0 && _action$meta.schedule)) return state;
        return {
            ...state,
            createdStatus: (0, $90kWr.LoadingStatus).Fetching
        };
    },
    [(0, $jPcDa.REQUEST_CREATE_SCHEDULE).ERROR] (state, action) {
        var _action$meta2;
        if (!((_action$meta2 = action.meta) !== null && _action$meta2 !== void 0 && _action$meta2.schedule)) return state;
        return {
            ...state,
            createdStatus: (0, $90kWr.LoadingStatus).Failed
        };
    },
    [(0, $jPcDa.REQUEST_TOGGLE_SCHEDULE).REQUEST] (state, action) {
        var _action$meta3;
        if (!((_action$meta3 = action.meta) !== null && _action$meta3 !== void 0 && _action$meta3.schedule)) return state;
        return {
            ...state,
            list: state.list.map((s)=>s.uuid === action.meta.schedule.uuid ? new (0, $d0InP.Schedule)({
                    ...s.toJS(),
                    enabled: !s.enabled
                }) : s)
        };
    },
    [(0, $jPcDa.REQUEST_TOGGLE_SCHEDULE).ERROR] (state, action) {
        var _action$meta4;
        if (!((_action$meta4 = action.meta) !== null && _action$meta4 !== void 0 && _action$meta4.schedule)) return state;
        return {
            ...state,
            list: state.list.map((s)=>s.uuid === action.meta.schedule.uuid ? new (0, $d0InP.Schedule)({
                    ...s.toJS(),
                    enabled: !s.enabled
                }) : s)
        };
    },
    [(0, $jPcDa.REQUEST_CREATE_SCHEDULE).SUCCESS] (state, action) {
        if (!(action !== null && action !== void 0 && action.payload)) return state;
        return {
            ...state,
            list: [
                new (0, $d0InP.Schedule)(action.payload)
            ].concat(state.list),
            createdStatus: (0, $90kWr.LoadingStatus).Success
        };
    },
    [(0, $jPcDa.REQUEST_DELETE_SCHEDULE).REQUEST] (state, action) {
        var _action$meta5;
        if (!((_action$meta5 = action.meta) !== null && _action$meta5 !== void 0 && _action$meta5.schedule)) return state;
        return {
            ...state,
            list: state.list.filter((c)=>(c === null || c === void 0 ? void 0 : c.uuid) !== action.meta.schedule.uuid)
        };
    },
    [(0, $jPcDa.REQUEST_DELETE_SCHEDULE).ERROR] (state, action) {
        var _action$meta6;
        if (!((_action$meta6 = action.meta) !== null && _action$meta6 !== void 0 && _action$meta6.schedule)) return state;
        return {
            ...state,
            list: state.list.concat(action.meta.schedule)
        };
    }
});

});

parcelRegister("huDvF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edbd210217536244$export$2e2bcd8739ae039; });
parcelRequire("e9n2v");
var $8qMkI = parcelRequire("8qMkI");

var $90kWr = parcelRequire("90kWr");

var $gsXeO = parcelRequire("gsXeO");

var $jPcDa = parcelRequire("jPcDa");
const $edbd210217536244$export$d4c72bab9d6cc13a = {
    searchLog: new (0, $8qMkI.SearchLog)(),
    fetchedStatus: (0, $90kWr.LoadingStatus).Before,
    searchedStatus: (0, $90kWr.LoadingStatus).Before
};
var $edbd210217536244$export$2e2bcd8739ae039 = (0, $gsXeO.default)($edbd210217536244$export$d4c72bab9d6cc13a, {
    [(0, $jPcDa.SEARCH_LOG).REQUEST] (state) {
        return {
            ...state,
            searchedStatus: (0, $90kWr.LoadingStatus).Fetching
        };
    },
    [(0, $jPcDa.SEARCH_LOG).SUCCESS] (state, action) {
        return {
            ...state,
            searchedStatus: (0, $90kWr.LoadingStatus).Success,
            searchLog: new (0, $8qMkI.SearchLog)({
                ...state.searchLog,
                currentLineIndex: 0,
                matchedLines: action.payload,
                search: action.meta
            })
        };
    },
    [(0, $jPcDa.SEARCH_LOG_NEXT_LINE)] (state) {
        return {
            ...state,
            searchLog: new (0, $8qMkI.SearchLog)({
                ...state.searchLog,
                currentLineIndex: state.searchLog.currentLineIndex > state.searchLog.matchedLines.length - 2 ? 0 : state.searchLog.currentLineIndex + 1
            })
        };
    },
    [(0, $jPcDa.SEARCH_LOG_PREV_LINE)] (state) {
        return {
            ...state,
            searchLog: new (0, $8qMkI.SearchLog)({
                ...state.searchLog,
                currentLineIndex: state.searchLog.currentLineIndex < 1 ? state.searchLog.matchedLines.length - 1 : state.searchLog.currentLineIndex - 1
            })
        };
    },
    [(0, $jPcDa.ENABLE_LOG_SEARCH)] (state) {
        return {
            ...state,
            searchLog: new (0, $8qMkI.SearchLog)({
                isEnabled: true
            })
        };
    },
    [(0, $jPcDa.DISABLE_LOG_SEARCH)] () {
        return {
            ...$edbd210217536244$export$d4c72bab9d6cc13a
        };
    },
    [(0, $jPcDa.DOWNLOAD_ALL_COMMANDS).REQUEST] (state) {
        return {
            ...state,
            fetchedStatus: (0, $90kWr.LoadingStatus).Fetching
        };
    },
    [(0, $jPcDa.DOWNLOAD_ALL_COMMANDS).SUCCESS] (state) {
        return {
            ...state,
            fetchedStatus: (0, $90kWr.LoadingStatus).Success
        };
    },
    [(0, $jPcDa.DOWNLOAD_ALL_COMMANDS).ERROR] (state) {
        return {
            ...state,
            searchLog: new (0, $8qMkI.SearchLog)({
                isErrored: true
            }),
            fetchedStatus: (0, $90kWr.LoadingStatus).Failed
        };
    }
});

});

parcelRegister("3CLTq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $335aebef6758eba2$export$2e2bcd8739ae039; });
parcelRequire("e9n2v");
var $goDEr = parcelRequire("goDEr");
var $eRckJ = parcelRequire("eRckJ");

var $gsXeO = parcelRequire("gsXeO");

var $7Ic5Q = parcelRequire("7Ic5Q");

var $jPcDa = parcelRequire("jPcDa");
const $335aebef6758eba2$export$d4c72bab9d6cc13a = {
    deployment: new (0, $goDEr.Deployment)(),
    environment: new (0, $eRckJ.Environment)()
};
var $335aebef6758eba2$export$2e2bcd8739ae039 = (0, $gsXeO.default)($335aebef6758eba2$export$d4c72bab9d6cc13a, {
    [(0, $7Ic5Q.REMOVE_DEPLOYMENT_DATA)] () {
        return $335aebef6758eba2$export$d4c72bab9d6cc13a;
    },
    [(0, $jPcDa.REQUEST_STEP_PROMOTION).SUCCESS]: (state, action)=>{
        if (!action.payload || !action.meta) return state;
        const { environments: { groupings: groupings }, deployment: deployment } = action.payload;
        const { environmentUuid: environmentUuid } = action.meta;
        const environments = groupings.reduce((dashboard, group)=>dashboard.concat(group.environment_summaries), []);
        const environmentData = environments.find((env)=>env.uuid === environmentUuid);
        return {
            deployment: new (0, $goDEr.Deployment)(deployment),
            environment: new (0, $eRckJ.Environment)(environmentData)
        };
    }
});

});

parcelRegister("2cAGx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f11302b37adf5a9$export$2e2bcd8739ae039; });
parcelRequire("e9n2v");
var $goDEr = parcelRequire("goDEr");
var $eRckJ = parcelRequire("eRckJ");

var $gsXeO = parcelRequire("gsXeO");

var $7Ic5Q = parcelRequire("7Ic5Q");

var $jPcDa = parcelRequire("jPcDa");
const $8f11302b37adf5a9$export$d4c72bab9d6cc13a = {
    deployment: new (0, $goDEr.Deployment)(),
    lastSuccessfulDeployment: new (0, $goDEr.Deployment)(),
    environment: new (0, $eRckJ.Environment)()
};
var $8f11302b37adf5a9$export$2e2bcd8739ae039 = (0, $gsXeO.default)($8f11302b37adf5a9$export$d4c72bab9d6cc13a, {
    [(0, $7Ic5Q.REMOVE_DEPLOYMENT_DATA)] () {
        return $8f11302b37adf5a9$export$d4c72bab9d6cc13a;
    },
    [(0, $jPcDa.REQUEST_STEP_REDEPLOYMENT).REQUEST] () {
        return $8f11302b37adf5a9$export$d4c72bab9d6cc13a;
    },
    [(0, $jPcDa.REQUEST_STEP_REDEPLOYMENT).SUCCESS] (state, action) {
        return {
            ...state,
            ...action.payload
        };
    }
});

});

parcelRegister("4CW0V", function(module, exports) {

$parcel$export(module.exports, "steps", function () { return $a5f916823c00b4f9$export$be3f796aed065412; });
parcelRequire("e9n2v");
var $ienSH = parcelRequire("ienSH");
var $eRckJ = parcelRequire("eRckJ");
var $gPp1Y = parcelRequire("gPp1Y");
var $hwD0l = parcelRequire("hwD0l");
var $xJcp7 = parcelRequire("xJcp7");

var $90kWr = parcelRequire("90kWr");

var $gsXeO = parcelRequire("gsXeO");

var $i3LMs = parcelRequire("i3LMs");

var $jPcDa = parcelRequire("jPcDa");
const $a5f916823c00b4f9$export$d4c72bab9d6cc13a = {
    currentStepUuid: "",
    stepForPreviousRun: false,
    downloadedCommands: {},
    environments: {},
    erroredCommands: {},
    expandedCommands: {},
    groups: [],
    map: [],
    streamingCommands: {},
    commands: {},
    runningManualStep: false,
    stageActionInProgress: undefined,
    fetchedBranchRestrictions: {},
    fetchedStepRerunStatus: (0, $90kWr.LoadingStatus).Before,
    failureReasonUpdated: "DEFAULT",
    fetchedStatus: (0, $90kWr.LoadingStatus).Before
};
function $a5f916823c00b4f9$var$isParallelStep(step) {
    return !!step.parallel_group;
}
function $a5f916823c00b4f9$var$isStageStep(step) {
    return !!(step !== null && step !== void 0 && step.stage);
}
function $a5f916823c00b4f9$var$isStepLogV2Enabled(step) {
    var _find;
    return (_find = (step.feature_flags || []).find((ff)=>ff.name === (0, $i3LMs.BITBUCKET_PIPELINES_FEATURE_FLAG_KEYS).LOG_V2)) === null || _find === void 0 ? void 0 : _find.value;
}
function $a5f916823c00b4f9$var$createStepGroups(stepsData) {
    const stepGroups = [];
    let i = 0;
    while(i < stepsData.length){
        let step = stepsData[i];
        if (!$a5f916823c00b4f9$var$isParallelStep(step) && !$a5f916823c00b4f9$var$isStageStep(step)) {
            stepGroups.push(new (0, $hwD0l.StepGroup)({
                steps: [
                    step.uuid
                ],
                type: (0, $hwD0l.StepGroupType).SINGLE
            }));
            i++;
        } else if ($a5f916823c00b4f9$var$isParallelStep(step)) {
            // find all consecutive steps in same parallel group
            const currentParallelGroupName = step.parallel_group.group_name;
            const currentParallelSteps = [];
            while(i < stepsData.length && $a5f916823c00b4f9$var$isParallelStep(step) && step.parallel_group.group_name === currentParallelGroupName){
                currentParallelSteps.push(step);
                i++;
                step = stepsData[i];
            }
            if (currentParallelSteps.length > 0) stepGroups.push(new (0, $hwD0l.StepGroup)({
                steps: currentParallelSteps.sort((left, right)=>left.parallel_group.step_index - right.parallel_group.step_index).map((s)=>s.uuid),
                type: (0, $hwD0l.StepGroupType).PARALLEL
            }));
        } else if ($a5f916823c00b4f9$var$isStageStep(step)) {
            const currentStageGroupIndex = step.stage.index;
            const currentStageSteps = [];
            while(i < stepsData.length && $a5f916823c00b4f9$var$isStageStep(step) && step.stage.index === currentStageGroupIndex){
                currentStageSteps.push(step);
                i++;
                step = stepsData[i];
            }
            if (currentStageSteps.length > 0) stepGroups.push(new (0, $hwD0l.StepGroup)({
                steps: currentStageSteps.map((s)=>s.uuid),
                type: (0, $hwD0l.StepGroupType).STAGE
            }));
        }
    }
    return stepGroups;
}
const $a5f916823c00b4f9$var$createCommands = (data)=>{
    const tasks = new (0, $xJcp7.Tasks)(data);
    return tasks.convertToCommands();
};
const $a5f916823c00b4f9$var$createCommandsWithMergingLogRanges = (existingCommands, stepData)=>{
    const commands = $a5f916823c00b4f9$var$createCommands(stepData.tasks);
    return !existingCommands || existingCommands.length === 0 ? commands : commands.map((command, index)=>{
        const existingCommand = existingCommands[index];
        if (!existingCommand) return command;
        if (!command) return existingCommand;
        return {
            ...existingCommand,
            ...existingCommand.log_range.byte_count === 0 ? {
                log_range: command.log_range
            } : {}
        };
    });
};
const $a5f916823c00b4f9$var$updateIndex = (array, index, value)=>{
    // eslint-disable-next-line no-param-reassign
    array = (array || []).slice(); // copy of array needed to trigger redux updates
    if (index === -1) // eslint-disable-next-line no-param-reassign
    array = array.map(()=>false);
    else array[index] = value;
    return array;
};
const $a5f916823c00b4f9$export$81d46cbe2a5cce6e = (commands)=>{
    const filteredCommands = (commands === null || commands === void 0 ? void 0 : commands.filter((cmd)=>cmd.execution_phase === (0, $ienSH.ExecutionPhase).MAIN && cmd.log_range.byte_count > 0)) || [];
    if (!filteredCommands.length) return [];
    const failedCommandIndex = commands.findIndex((cmd)=>cmd.name === filteredCommands[filteredCommands.length - 1].name);
    return new Array(failedCommandIndex + 1).fill(false).fill(true, -1);
};
const $a5f916823c00b4f9$export$d8455d87010f7438 = (commandType, oldCommands, stepsMaps, commands)=>{
    const entries = Object.entries(oldCommands).filter(([key])=>{
        var _stepsMaps$key, _stepsMaps$key$state;
        return [
            "IN_PROGRESS",
            "PENDING"
        ].includes((_stepsMaps$key = stepsMaps[key]) === null || _stepsMaps$key === void 0 ? void 0 : (_stepsMaps$key$state = _stepsMaps$key.state) === null || _stepsMaps$key$state === void 0 ? void 0 : _stepsMaps$key$state.name);
    }).map(([key, value])=>[
            key,
            new Array(value.length).fill(false).fill(true, -1)
        ]);
    Object.keys(stepsMaps).forEach((key)=>{
        var _stepsMaps$key2, _stepsMaps$key2$state, _stepsMaps$key2$state2;
        if (commandType === (0, $ienSH.CommandToggleOption).EXPANDED && ((_stepsMaps$key2 = stepsMaps[key]) === null || _stepsMaps$key2 === void 0 ? void 0 : (_stepsMaps$key2$state = _stepsMaps$key2.state) === null || _stepsMaps$key2$state === void 0 ? void 0 : (_stepsMaps$key2$state2 = _stepsMaps$key2$state.result) === null || _stepsMaps$key2$state2 === void 0 ? void 0 : _stepsMaps$key2$state2.name) === "FAILED") {
            const failedCommand = $a5f916823c00b4f9$export$81d46cbe2a5cce6e(commands[key]);
            if (failedCommand.length > 0) entries.push([
                key,
                failedCommand
            ]);
        }
    });
    return Object.fromEntries(entries);
};
const $a5f916823c00b4f9$var$getStreamingCommands = (step, data)=>{
    if (!step.isSyncing) return [];
    const tasks = new (0, $xJcp7.Tasks)(data);
    const runnerDetailsCommand = true;
    const setupCommand = tasks.runnerDetailsCommand === undefined || tasks.setupCommand.log_range && tasks.setupCommand.log_range.byte_count !== 0;
    const mainCommands = tasks.mainCommands.map((scriptCommand)=>scriptCommand.log_range && scriptCommand.log_range.byte_count !== 0);
    const afterMainCommands = tasks.afterMainCommands.map((scriptCommand)=>scriptCommand.log_range && scriptCommand.log_range.byte_count !== 0);
    const teardownCommand = tasks.teardownCommand.log_range && tasks.teardownCommand.log_range.byte_count !== 0;
    const streamingCommands = tasks.runnerDetailsCommand === undefined ? [
        setupCommand,
        ...mainCommands,
        ...afterMainCommands,
        teardownCommand
    ] : [
        runnerDetailsCommand,
        setupCommand,
        ...mainCommands,
        ...afterMainCommands,
        teardownCommand
    ];
    const streamingCommandIndex = streamingCommands.lastIndexOf(true);
    const commands = [];
    commands[streamingCommandIndex] = true;
    return commands;
};
const $a5f916823c00b4f9$var$reduceSteps = (state, action)=>{
    var _action$meta, _action$payload, _action$payload$value3, _action$payload$value4, _action$payload$value5;
    // Ignore any in-flight Websocket step updates if switched to a previous run to avoid them incorrectly rewriting step state
    if (state.stepForPreviousRun && !((_action$meta = action.meta) !== null && _action$meta !== void 0 && _action$meta.pipelineRunUuid)) return state;
    if (!((_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.values)) return state;
    let { currentStepUuid: currentStepUuid } = state;
    if (!currentStepUuid) {
        if ((action.payload.values || []).filter((step)=>{
            var _action$meta2;
            return (step === null || step === void 0 ? void 0 : step.uuid) === ((_action$meta2 = action.meta) === null || _action$meta2 === void 0 ? void 0 : _action$meta2.stepUuid);
        }).length) {
            var _action$meta3;
            currentStepUuid = ((_action$meta3 = action.meta) === null || _action$meta3 === void 0 ? void 0 : _action$meta3.stepUuid) || "";
        } else {
            var _action$payload$value, _action$payload$value2;
            currentStepUuid = ((_action$payload$value = action.payload.values) === null || _action$payload$value === void 0 ? void 0 : (_action$payload$value2 = _action$payload$value[0]) === null || _action$payload$value2 === void 0 ? void 0 : _action$payload$value2.uuid) || "";
        }
    }
    const map = new Map();
    (_action$payload$value3 = action.payload.values) === null || _action$payload$value3 === void 0 || _action$payload$value3.forEach((data)=>{
        const step = new (0, $gPp1Y.Step)(data);
        map.set(step.uuid, step);
    });
    const commands = (_action$payload$value4 = action.payload.values) === null || _action$payload$value4 === void 0 ? void 0 : _action$payload$value4.reduce((obj, stepData)=>{
        const currentStepCommands = $a5f916823c00b4f9$var$isStepLogV2Enabled(stepData) ? $a5f916823c00b4f9$var$createCommandsWithMergingLogRanges(state.commands[stepData.uuid], stepData) : $a5f916823c00b4f9$var$createCommands(stepData.tasks);
        return {
            ...obj,
            [stepData.uuid]: currentStepCommands
        };
    }, {});
    const streamingCommands = (_action$payload$value5 = action.payload.values) === null || _action$payload$value5 === void 0 ? void 0 : _action$payload$value5.reduce((obj, stepData)=>({
            ...obj,
            [stepData.uuid]: $a5f916823c00b4f9$var$isStepLogV2Enabled(stepData) ? state.streamingCommands[stepData.uuid] : $a5f916823c00b4f9$var$getStreamingCommands(map.get(stepData.uuid), stepData.tasks)
        }), {});
    const environments = action.payload.values.filter((s)=>s.environment).reduce((reducer, step)=>{
        var _state$environments$s;
        reducer[step.uuid] = new (0, $eRckJ.Environment)({
            ...step.environment,
            branchRestrictions: ((_state$environments$s = state.environments[step.uuid]) === null || _state$environments$s === void 0 ? void 0 : _state$environments$s.branchRestrictions) || []
        });
        return reducer;
    }, {
        ...state.environments
    });
    return {
        ...state,
        currentStepUuid: currentStepUuid,
        map: map,
        groups: $a5f916823c00b4f9$var$createStepGroups(action.payload.values),
        environments: environments,
        commands: {
            ...state.commands,
            ...commands
        },
        streamingCommands: {
            ...state.streamingCommands,
            ...streamingCommands
        },
        fetchedStatus: (0, $90kWr.LoadingStatus).Success
    };
};
const $a5f916823c00b4f9$export$be3f796aed065412 = (0, $gsXeO.default)($a5f916823c00b4f9$export$d4c72bab9d6cc13a, {
    [(0, $jPcDa.CLEAR_CURRENT_PIPELINE)] () {
        return {
            ...$a5f916823c00b4f9$export$d4c72bab9d6cc13a
        };
    },
    [(0, $jPcDa.CLEAR_STEPS)] (_state) {
        return {
            ...$a5f916823c00b4f9$export$d4c72bab9d6cc13a
        };
    },
    [(0, $jPcDa.SET_STEPS_FOR_PREVIOUS_RUN)] (state) {
        return {
            ...state,
            stepForPreviousRun: true
        };
    },
    [(0, $jPcDa.SET_STEP)] (state, action) {
        if (!(action !== null && action !== void 0 && action.payload)) return state;
        return {
            ...state,
            currentStepUuid: action.payload
        };
    },
    [(0, $jPcDa.REQUEST_STEPS).REQUEST] (state) {
        return {
            ...state,
            fetchedStatus: (0, $90kWr.LoadingStatus).Fetching
        };
    },
    [(0, $jPcDa.REQUEST_STEPS).ERROR] (state) {
        return {
            ...state,
            fetchedStatus: (0, $90kWr.LoadingStatus).Failed
        };
    },
    [(0, $jPcDa.SET_STEPS)]: $a5f916823c00b4f9$var$reduceSteps,
    [(0, $jPcDa.REQUEST_STEPS).SUCCESS]: $a5f916823c00b4f9$var$reduceSteps,
    [(0, $jPcDa.EXPAND_COMMAND)] (state, action) {
        var _action$meta4;
        if (!((_action$meta4 = action.meta) !== null && _action$meta4 !== void 0 && _action$meta4.stepUuid)) return state;
        const expandedCommands = {
            [action.meta.stepUuid]: $a5f916823c00b4f9$var$updateIndex([
                ...state.expandedCommands[action.meta.stepUuid] || []
            ], action.meta.index, true)
        };
        return {
            ...state,
            expandedCommands: {
                ...state.expandedCommands,
                ...expandedCommands
            }
        };
    },
    [(0, $jPcDa.COLLAPSE_COMMAND)] (state, action) {
        var _action$meta5;
        if (!((_action$meta5 = action.meta) !== null && _action$meta5 !== void 0 && _action$meta5.stepUuid)) return state;
        const expandedCommands = {
            [action.meta.stepUuid]: $a5f916823c00b4f9$var$updateIndex([
                ...state.expandedCommands[action.meta.stepUuid] || []
            ], action.meta.index, false)
        };
        return {
            ...state,
            expandedCommands: {
                ...state.expandedCommands,
                ...expandedCommands
            }
        };
    },
    [(0, $jPcDa.RESET_DOWNLOADED_COMMANDS)] (state) {
        const stepsMaps = Object.fromEntries(state.map);
        return {
            ...state,
            downloadedCommands: $a5f916823c00b4f9$export$d8455d87010f7438((0, $ienSH.CommandToggleOption).DOWNLOADED, state.downloadedCommands, stepsMaps, state.commands),
            expandedCommands: $a5f916823c00b4f9$export$d8455d87010f7438((0, $ienSH.CommandToggleOption).EXPANDED, state.expandedCommands, stepsMaps, state.commands)
        };
    },
    [(0, $jPcDa.COLLAPSE_ALL_COMMANDS)] (state, action) {
        var _action$meta6;
        if (!((_action$meta6 = action.meta) !== null && _action$meta6 !== void 0 && _action$meta6.stepUuid)) return state;
        const expandedCommands = {
            [action.meta.stepUuid]: $a5f916823c00b4f9$var$updateIndex([
                ...state.expandedCommands[action.meta.stepUuid] || []
            ], -1, false)
        };
        return {
            ...state,
            expandedCommands: {
                ...state.expandedCommands,
                ...expandedCommands
            }
        };
    },
    [(0, $jPcDa.REQUEST_LOG).REQUEST] (state, action) {
        var _action$meta7;
        if (!((_action$meta7 = action.meta) !== null && _action$meta7 !== void 0 && _action$meta7.stepUuid)) return state;
        const erroredCommands = {
            [action.meta.stepUuid]: $a5f916823c00b4f9$var$updateIndex([
                ...state.erroredCommands[action.meta.stepUuid] || []
            ], action.meta.index, false)
        };
        return {
            ...state,
            erroredCommands: {
                ...state.erroredCommands,
                ...erroredCommands
            }
        };
    },
    [(0, $jPcDa.REQUEST_FLAT_NESTED_LOGS).SUCCESS] (state, action) {
        var _action$meta8, _action$meta9;
        if (!((_action$meta8 = action.meta) !== null && _action$meta8 !== void 0 && _action$meta8.stepUuid) || ((_action$meta9 = action.meta) === null || _action$meta9 === void 0 ? void 0 : _action$meta9.index) === undefined) return state;
        const downloadedCommands = {
            [action.meta.stepUuid]: $a5f916823c00b4f9$var$updateIndex([
                ...state.downloadedCommands[action.meta.stepUuid] || []
            ], action.meta.index, true)
        };
        const erroredCommands = {
            [action.meta.stepUuid]: $a5f916823c00b4f9$var$updateIndex([
                ...state.erroredCommands[action.meta.stepUuid] || []
            ], action.meta.index, false)
        };
        return {
            ...state,
            downloadedCommands: {
                ...state.downloadedCommands,
                ...downloadedCommands
            },
            erroredCommands: {
                ...state.erroredCommands,
                ...erroredCommands
            }
        };
    },
    [(0, $jPcDa.REQUEST_LOG).SUCCESS] (state, action) {
        var _action$meta10, _action$meta11, _action$meta12;
        if ((_action$meta10 = action.meta) !== null && _action$meta10 !== void 0 && _action$meta10.incrementalRequestEnabled || !((_action$meta11 = action.meta) !== null && _action$meta11 !== void 0 && _action$meta11.stepUuid) || ((_action$meta12 = action.meta) === null || _action$meta12 === void 0 ? void 0 : _action$meta12.index) === undefined) return state;
        const downloadedCommands = {
            [action.meta.stepUuid]: $a5f916823c00b4f9$var$updateIndex([
                ...state.downloadedCommands[action.meta.stepUuid] || []
            ], action.meta.index, true)
        };
        const erroredCommands = {
            [action.meta.stepUuid]: $a5f916823c00b4f9$var$updateIndex([
                ...state.erroredCommands[action.meta.stepUuid] || []
            ], action.meta.index, false)
        };
        return {
            ...state,
            downloadedCommands: {
                ...state.downloadedCommands,
                ...downloadedCommands
            },
            erroredCommands: {
                ...state.erroredCommands,
                ...erroredCommands
            }
        };
    },
    [(0, $jPcDa.REQUEST_LOG).ERROR] (state, action) {
        var _action$meta13;
        if (!((_action$meta13 = action.meta) !== null && _action$meta13 !== void 0 && _action$meta13.stepUuid)) return state;
        const erroredCommands = {
            [action.meta.stepUuid]: $a5f916823c00b4f9$var$updateIndex([
                ...state.erroredCommands[action.meta.stepUuid] || []
            ], action.meta.index, true)
        };
        const expandedCommands = {
            [action.meta.stepUuid]: $a5f916823c00b4f9$var$updateIndex([
                ...state.expandedCommands[action.meta.stepUuid] || []
            ], action.meta.index, false)
        };
        return {
            ...state,
            erroredCommands: {
                ...state.erroredCommands,
                ...erroredCommands
            },
            expandedCommands: {
                ...state.expandedCommands,
                ...expandedCommands
            }
        };
    },
    [(0, $jPcDa.REQUEST_DELETE_LOG).SUCCESS] (state, action) {
        var _action$meta14, _action$meta15;
        const serviceUuid = (_action$meta14 = action.meta) === null || _action$meta14 === void 0 ? void 0 : _action$meta14.serviceUuid;
        const stepUuid = (_action$meta15 = action.meta) === null || _action$meta15 === void 0 ? void 0 : _action$meta15.stepUuid;
        if (serviceUuid) return state;
        const map = new Map(state.map);
        map.set(stepUuid, new (0, $gPp1Y.Step)({
            ...map.get(stepUuid),
            log_byte_count: 0
        }));
        return {
            ...state,
            map: map
        };
    },
    [(0, $jPcDa.REQUEST_START_STEP).REQUEST] (state, action) {
        var _action$meta16;
        if (!((_action$meta16 = action.meta) !== null && _action$meta16 !== void 0 && _action$meta16.stepUuid)) return state;
        return {
            ...state,
            runningManualStep: action.meta.stepUuid,
            stageActionInProgress: action.meta.stageIndex
        };
    },
    [(0, $jPcDa.REQUEST_REDEPLOY_STEP).REQUEST] (state, action) {
        var _action$meta17;
        if (!((_action$meta17 = action.meta) !== null && _action$meta17 !== void 0 && _action$meta17.stepUuid)) return state;
        return {
            ...state,
            runningManualStep: action.meta.stepUuid,
            stageActionInProgress: action.meta.stageIndex
        };
    },
    [(0, $jPcDa.REQUEST_RESUME_STAGE_REDEPLOY).REQUEST] (state, action) {
        var _action$meta18;
        if (!((_action$meta18 = action.meta) !== null && _action$meta18 !== void 0 && _action$meta18.stageIndex)) return state;
        return {
            ...state,
            stageActionInProgress: action.meta.stageIndex
        };
    },
    [(0, $jPcDa.REQUEST_RERUN_STEPS).REQUEST] (state) {
        return {
            ...state,
            currentStepUuid: "",
            fetchedStepRerunStatus: (0, $90kWr.LoadingStatus).Fetching
        };
    },
    [(0, $jPcDa.REQUEST_START_STEP).SUCCESS] (state) {
        return {
            ...state,
            runningManualStep: false,
            stageActionInProgress: undefined
        };
    },
    [(0, $jPcDa.REQUEST_REDEPLOY_STEP).SUCCESS] (state) {
        return {
            ...state,
            runningManualStep: false,
            stageActionInProgress: undefined
        };
    },
    [(0, $jPcDa.REQUEST_RESUME_STAGE_REDEPLOY).SUCCESS]: (state)=>{
        return {
            ...state,
            stageActionInProgress: undefined
        };
    },
    [(0, $jPcDa.REQUEST_RERUN_STEPS).SUCCESS]: (state)=>{
        return {
            ...state,
            fetchedStepRerunStatus: (0, $90kWr.LoadingStatus).Success
        };
    },
    [(0, $jPcDa.REQUEST_START_STEP).ERROR] (state) {
        return {
            ...state,
            runningManualStep: false,
            stageActionInProgress: undefined
        };
    },
    [(0, $jPcDa.REQUEST_REDEPLOY_STEP).ERROR] (state) {
        return {
            ...state,
            runningManualStep: false,
            stageActionInProgress: undefined
        };
    },
    [(0, $jPcDa.REQUEST_RESUME_STAGE_REDEPLOY).ERROR]: (state)=>{
        return {
            ...state,
            stageActionInProgress: undefined
        };
    },
    [(0, $jPcDa.REQUEST_RERUN_STEPS).ERROR]: (state)=>{
        return {
            ...state,
            fetchedStepRerunStatus: (0, $90kWr.LoadingStatus).Failed
        };
    },
    [(0, $jPcDa.REQUEST_STEP_BRANCH_RESTRICTIONS).REQUEST] (state, action) {
        var _action$meta19;
        if (!((_action$meta19 = action.meta) !== null && _action$meta19 !== void 0 && _action$meta19.environmentUuids)) return state;
        const fetchedBranchRestrictions = action.meta.environmentUuids.reduce((reducer, uuid)=>{
            reducer[uuid] = (0, $90kWr.LoadingStatus).Fetching;
            return reducer;
        }, {
            ...state.fetchedBranchRestrictions
        });
        return {
            ...state,
            fetchedBranchRestrictions: fetchedBranchRestrictions
        };
    },
    [(0, $jPcDa.REQUEST_STEP_BRANCH_RESTRICTIONS).SUCCESS] (state, action) {
        var _action$meta20, _action$payload2;
        if (!((_action$meta20 = action.meta) !== null && _action$meta20 !== void 0 && _action$meta20.environmentUuids) || !((_action$payload2 = action.payload) !== null && _action$payload2 !== void 0 && _action$payload2.values)) return state;
        const environments = action.meta.environmentUuids.reduce((reducer, uuid)=>{
            const stepUuid = Object.keys(reducer).find((key)=>{
                var _reducer$key;
                return ((_reducer$key = reducer[key]) === null || _reducer$key === void 0 ? void 0 : _reducer$key.uuid) === uuid;
            });
            if (stepUuid) {
                var _reducer$stepUuid, _reducer$stepUuid$toJ, _action$payload3;
                reducer[stepUuid] = new (0, $eRckJ.Environment)({
                    ...(_reducer$stepUuid = reducer[stepUuid]) === null || _reducer$stepUuid === void 0 ? void 0 : (_reducer$stepUuid$toJ = _reducer$stepUuid.toJS) === null || _reducer$stepUuid$toJ === void 0 ? void 0 : _reducer$stepUuid$toJ.call(_reducer$stepUuid),
                    branchRestrictions: (_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.values.filter((r)=>r.environmentUuid === uuid)
                });
            }
            return reducer;
        }, {
            ...state.environments
        });
        const fetchedBranchRestrictions = action.meta.environmentUuids.reduce((reducer, uuid)=>{
            reducer[uuid] = (0, $90kWr.LoadingStatus).Success;
            return reducer;
        }, {
            ...state.fetchedBranchRestrictions
        });
        return {
            ...state,
            environments: environments,
            fetchedBranchRestrictions: fetchedBranchRestrictions
        };
    },
    [(0, $jPcDa.REQUEST_UPDATE_FAILURE_REASON).SUCCESS] (state) {
        return {
            ...state,
            failureReasonUpdated: "SUCCESS"
        };
    },
    [(0, $jPcDa.REQUEST_UPDATE_FAILURE_REASON).ERROR] (state) {
        return {
            ...state,
            failureReasonUpdated: "FAILURE"
        };
    },
    [(0, $jPcDa.RESET_UPDATE_FAILURE_REASON).REQUEST] (state) {
        return {
            ...state,
            failureReasonUpdated: "DEFAULT"
        };
    },
    [(0, $jPcDa.REQUEST_STEP_BRANCH_RESTRICTIONS).ERROR] (state, action) {
        var _action$meta21;
        if (!((_action$meta21 = action.meta) !== null && _action$meta21 !== void 0 && _action$meta21.environmentUuids)) return state;
        const fetchedBranchRestrictions = action.meta.environmentUuids.reduce((reducer, uuid)=>{
            reducer[uuid] = (0, $90kWr.LoadingStatus).Failed;
            return reducer;
        }, {
            ...state.fetchedBranchRestrictions
        });
        return {
            ...state,
            fetchedBranchRestrictions: fetchedBranchRestrictions
        };
    },
    [(0, $jPcDa.REQUEST_LOG_RANGES).SUCCESS] (state, action) {
        var _action$meta22;
        // sanity check
        if (!((_action$meta22 = action.meta) !== null && _action$meta22 !== void 0 && _action$meta22.stepUuid)) return state;
        // from log ranges, perform the merge
        const { stepUuid: stepUuid } = action.meta;
        const payload = action === null || action === void 0 ? void 0 : action.payload;
        // if no records of steps, return.
        const map = new Map(state.map);
        const step = map.get(stepUuid);
        if (!step) return state;
        const streamingCommands = $a5f916823c00b4f9$var$getStreamingCommands(step, payload);
        map.set(stepUuid, new (0, $gPp1Y.Step)({
            ...step,
            log_byte_count: payload.log_byte_count
        }));
        const streamingCommandsMap = state.streamingCommands;
        streamingCommandsMap[stepUuid] = streamingCommands;
        const commandsMap = state.commands;
        const commands = $a5f916823c00b4f9$var$createCommands(payload);
        const existingCommands = commandsMap[stepUuid];
        const newCommands = existingCommands.map((command, index)=>{
            const { log_range: log_range, ...currentCommand } = command;
            const updatedCommand = commands[index];
            if (!updatedCommand) return command;
            const commandToUpdate = {
                ...currentCommand,
                execution_duration: updatedCommand.execution_duration
            };
            if (command instanceof (0, $ienSH.RunnerDetailsCommand)) return new (0, $ienSH.RunnerDetailsCommand)([
                commandToUpdate
            ], updatedCommand.log_range, index);
            else if (command instanceof (0, $ienSH.SetupCommand)) return new (0, $ienSH.SetupCommand)([
                commandToUpdate
            ], updatedCommand.log_range, index);
            else if (command instanceof (0, $ienSH.TeardownCommand)) return new (0, $ienSH.TeardownCommand)([
                commandToUpdate
            ], updatedCommand.log_range, index);
            else if (command instanceof (0, $ienSH.AfterScriptCommand)) return new (0, $ienSH.AfterScriptCommand)({
                ...commandToUpdate,
                log_range: updatedCommand.log_range,
                index: index
            });
            else return new (0, $ienSH.ScriptCommand)({
                ...commandToUpdate,
                log_range: updatedCommand.log_range,
                index: index
            });
        });
        return {
            ...state,
            map: map,
            commands: {
                ...state.commands,
                [stepUuid]: newCommands
            },
            streamingCommands: streamingCommandsMap
        };
    }
});

});

parcelRegister("gJEav", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe14eeb0ab7a150c$export$2e2bcd8739ae039; });
parcelRequire("e9n2v");
var $e8xZi = parcelRequire("e8xZi");

var $gsXeO = parcelRequire("gsXeO");

var $jPcDa = parcelRequire("jPcDa");
const $fe14eeb0ab7a150c$export$d4c72bab9d6cc13a = {
    expandedTestCaseMap: {},
    fetchingFailedTestCases: false,
    fetchingTestReasonMap: {},
    testCaseReasonMap: {},
    testCaseErrorMap: {},
    failedTestCases: {}
};
var $fe14eeb0ab7a150c$export$2e2bcd8739ae039 = (0, $gsXeO.default)($fe14eeb0ab7a150c$export$d4c72bab9d6cc13a, {
    [(0, $jPcDa.CLEAR_CURRENT_PIPELINE)] () {
        return {
            ...$fe14eeb0ab7a150c$export$d4c72bab9d6cc13a
        };
    },
    [(0, $jPcDa.EXPAND_TEST_CASE)] (state, action) {
        var _action$meta;
        if (!((_action$meta = action.meta) !== null && _action$meta !== void 0 && _action$meta.testCaseUuid)) return state;
        return {
            ...state,
            expandedTestCaseMap: {
                ...state.expandedTestCaseMap,
                [action.meta.testCaseUuid]: true
            }
        };
    },
    [(0, $jPcDa.COLLAPSE_TEST_CASE)] (state, action) {
        var _action$meta2;
        if (!((_action$meta2 = action.meta) !== null && _action$meta2 !== void 0 && _action$meta2.testCaseUuid)) return state;
        return {
            ...state,
            expandedTestCaseMap: {
                ...state.expandedTestCaseMap,
                [action.meta.testCaseUuid]: false
            }
        };
    },
    [(0, $jPcDa.REQUEST_FAILED_TEST_CASES).REQUEST] (state) {
        return {
            ...state,
            fetchingFailedTestCases: true
        };
    },
    [(0, $jPcDa.REQUEST_FAILED_TEST_CASES).SUCCESS] (state, action) {
        var _action$meta3, _action$payload;
        if (!((_action$meta3 = action.meta) !== null && _action$meta3 !== void 0 && _action$meta3.stepUuid) || !(action !== null && action !== void 0 && (_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.values)) return state;
        return {
            ...state,
            fetchingFailedTestCases: false,
            failedTestCases: {
                ...state.failedTestCases,
                [action.meta.stepUuid]: action.payload.values.map((data)=>new (0, $e8xZi.TestCase)(data))
            }
        };
    },
    [(0, $jPcDa.REQUEST_TEST_CASE_REASON).REQUEST] (state, action) {
        var _action$meta4;
        if (!((_action$meta4 = action.meta) !== null && _action$meta4 !== void 0 && _action$meta4.testCaseUuid)) return state;
        return {
            ...state,
            fetchingTestReasonMap: {
                ...state.fetchingTestReasonMap,
                [action.meta.testCaseUuid]: true
            }
        };
    },
    [(0, $jPcDa.REQUEST_TEST_CASE_REASON).SUCCESS] (state, action) {
        var _action$meta5;
        if (!((_action$meta5 = action.meta) !== null && _action$meta5 !== void 0 && _action$meta5.testCaseUuid) || !action.payload) return state;
        return {
            ...state,
            fetchingTestReasonMap: {
                ...state.fetchingTestReasonMap,
                [action.meta.testCaseUuid]: false
            },
            testCaseReasonMap: {
                ...state.testCaseReasonMap,
                [action.meta.testCaseUuid]: new (0, $e8xZi.TestCaseReason)(action.payload)
            }
        };
    },
    [(0, $jPcDa.REQUEST_TEST_CASE_REASON).ERROR] (state, action) {
        var _action$meta6;
        if (!((_action$meta6 = action.meta) !== null && _action$meta6 !== void 0 && _action$meta6.testCaseUuid) || !action.payload) return state;
        return {
            ...state,
            fetchingTestReasonMap: {
                ...state.fetchingTestReasonMap,
                [action.meta.testCaseUuid]: false
            },
            testCaseErrorMap: {
                ...state.testCaseErrorMap,
                [action.meta.testCaseUuid]: new (0, $e8xZi.TestCaseReasonError)(action.payload)
            }
        };
    }
});

});

parcelRegister("3hkYJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $449d698b00537301$export$2e2bcd8739ae039; });
parcelRequire("e9n2v");
var $6vGsr = parcelRequire("6vGsr");

var $gsXeO = parcelRequire("gsXeO");

var $jPcDa = parcelRequire("jPcDa");
var $449d698b00537301$export$2e2bcd8739ae039 = (0, $gsXeO.default)(new (0, $6vGsr.Validator)(), {
    [(0, $jPcDa.SET_VALIDATOR)] (state, action) {
        return new (0, $6vGsr.Validator)({
            ...state,
            ...action.payload
        });
    }
});

});


parcelRegister("hoqst", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9dfe2529a6b0914c$export$2e2bcd8739ae039; });

var $4MHvX = parcelRequire("4MHvX");
var $9dfe2529a6b0914c$export$2e2bcd8739ae039 = (0, $4MHvX.default);

});
parcelRegister("4MHvX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e43b53140ae5f2f$export$2e2bcd8739ae039; });

var $biyfN = parcelRequire("biyfN");

var $5gF7V = parcelRequire("5gF7V");

var $683bT = parcelRequire("683bT");

var $abRa1 = parcelRequire("abRa1");

var $gsXeO = parcelRequire("gsXeO");
parcelRequire("9waDg");
var $1kvgs = parcelRequire("1kvgs");
const $0e43b53140ae5f2f$var$findTypeByKind = (branchTypes, kind)=>{
    if (kind === (0, $5gF7V.EXTENDED_BRANCH_KINDS).OTHER) return 0, $5gF7V.BRANCH_TYPE_OTHER;
    return branchTypes.find((type)=>type.kind === kind) || null;
};
const $0e43b53140ae5f2f$export$d4c72bab9d6cc13a = {
    isGlobalDialogOpen: false,
    isRepoDialogOpen: false,
    isCreating: false,
    error: null,
    params: {
        name: "",
        target: null
    },
    refSelector: {
        loadingState: (0, $5gF7V.LOADING_STATE).LOADING,
        refs: [],
        hasMoreRefs: false,
        suggestedRef: null,
        selected: null,
        selectedByUser: false,
        selectedCommitStatuses: []
    },
    workflowBranches: {
        main: null,
        development: null,
        production: null
    },
    branchTypeSelector: {
        loadingState: (0, $5gF7V.LOADING_STATE).LOADING,
        isVisible: false,
        branchTypes: [],
        selected: null
    },
    successFlag: {
        branch: null
    },
    repositorySelector: {
        loadingState: (0, $5gF7V.LOADING_STATE).LOADING,
        repositories: [],
        selected: null,
        selectedDetails: null
    }
};
var $0e43b53140ae5f2f$export$2e2bcd8739ae039 = (0, $gsXeO.default)($0e43b53140ae5f2f$export$d4c72bab9d6cc13a, {
    [(0, $1kvgs.CREATE_BRANCH_REPO_DIALOG).OPEN] (state) {
        return {
            ...state,
            isGlobalDialogOpen: false,
            isRepoDialogOpen: true
        };
    },
    [(0, $1kvgs.CREATE_BRANCH_REPO_DIALOG).CLOSE] () {
        return {
            // Reset the state when the modal closes, so that it won't display anything
            // from the previous open state, next time the modal opens.
            ...$0e43b53140ae5f2f$export$d4c72bab9d6cc13a
        };
    },
    [(0, $1kvgs.CREATE_BRANCH_GLOBAL_DIALOG).OPEN] (state) {
        return {
            ...state,
            isGlobalDialogOpen: true,
            isRepoDialogOpen: false
        };
    },
    [(0, $1kvgs.CREATE_BRANCH_GLOBAL_DIALOG).CLOSE] () {
        return {
            // Reset the state when the modal closes, so that it won't display anything
            // from the previous open state, next time the modal opens.
            ...$0e43b53140ae5f2f$export$d4c72bab9d6cc13a
        };
    },
    [(0, $1kvgs.FETCH_REF_OPTIONS).REQUEST] (state) {
        return {
            ...state,
            refSelector: {
                ...state.refSelector,
                refs: [],
                hasMoreRefs: false,
                loadingState: (0, $5gF7V.LOADING_STATE).LOADING
            }
        };
    },
    [(0, $1kvgs.FETCH_REF_OPTIONS).SUCCESS] (state, action) {
        const { refs: refs, mainRef: mainRef, hasMoreRefs: hasMoreRefs } = action.payload;
        return {
            ...state,
            refSelector: {
                ...state.refSelector,
                refs: refs,
                hasMoreRefs: hasMoreRefs,
                loadingState: (0, $5gF7V.LOADING_STATE).SUCCESS
            },
            workflowBranches: {
                ...state.workflowBranches,
                main: mainRef
            }
        };
    },
    [(0, $1kvgs.FETCH_REF_OPTIONS).ERROR] (state) {
        return {
            ...state,
            refSelector: {
                ...state.refSelector,
                loadingState: (0, $5gF7V.LOADING_STATE).ERROR
            }
        };
    },
    [(0, $1kvgs.FETCH_COMMIT_STATUSES).SUCCESS] (state, action) {
        return {
            ...state,
            refSelector: {
                ...state.refSelector,
                // @ts-ignore
                selectedCommitStatuses: action.payload
            }
        };
    },
    [(0, $1kvgs.FETCH_COMMIT_STATUSES).ERROR] (state) {
        return {
            ...state,
            refSelector: {
                ...state.refSelector,
                selectedCommitStatuses: []
            }
        };
    },
    [(0, $1kvgs.FETCH_BRANCHING_MODEL).REQUEST] (state) {
        return {
            ...state,
            branchTypeSelector: {
                ...state.branchTypeSelector,
                branchTypes: [],
                loadingState: (0, $5gF7V.LOADING_STATE).LOADING
            }
        };
    },
    [(0, $1kvgs.FETCH_BRANCHING_MODEL).SUCCESS] (state, action) {
        const { development: development, production: production, branchTypes: branchTypes } = action.payload;
        const previousSelectedBranchType = state.branchTypeSelector.selected;
        const previousSelectedKind = previousSelectedBranchType && previousSelectedBranchType.kind;
        let selectedBranchType;
        selectedBranchType = previousSelectedKind ? $0e43b53140ae5f2f$var$findTypeByKind(branchTypes, previousSelectedKind) : null;
        if (!selectedBranchType && state.issue) {
            const isBugfixEnabled = Boolean(branchTypes.find((br)=>br.kind === (0, $biyfN.BRANCH_KIND).BUG_FIX));
            const kind = (0, $683bT.branchTypeFromIssue)(state.issue, isBugfixEnabled);
            if (kind !== (0, $5gF7V.EXTENDED_BRANCH_KINDS).OTHER) selectedBranchType = $0e43b53140ae5f2f$var$findTypeByKind(branchTypes, kind);
        }
        const hasBranchTypes = branchTypes.length > 0;
        if (!selectedBranchType && hasBranchTypes) selectedBranchType = (0, $5gF7V.BRANCH_TYPE_OTHER);
        return {
            ...state,
            branchTypeSelector: {
                branchTypes: branchTypes,
                loadingState: (0, $5gF7V.LOADING_STATE).SUCCESS,
                isVisible: hasBranchTypes,
                selected: selectedBranchType
            },
            workflowBranches: {
                ...state.workflowBranches,
                development: development,
                production: production
            }
        };
    },
    [(0, $1kvgs.FETCH_BRANCHING_MODEL).ERROR] (state) {
        return {
            ...state,
            branchTypeSelector: {
                ...state.branchTypeSelector,
                isVisible: false,
                loadingState: (0, $5gF7V.LOADING_STATE).ERROR,
                selected: null
            }
        };
    },
    [(0, $1kvgs.SET_SUGGESTED_FROM_BRANCH)] (state, action) {
        return {
            ...state,
            refSelector: {
                ...state.refSelector,
                suggestedRef: action.payload
            }
        };
    },
    [(0, $1kvgs.CHANGE_FROM_BRANCH)] (state, action) {
        const { ref: ref, selectedByUser: selectedByUser } = action.payload;
        return {
            ...state,
            refSelector: {
                ...state.refSelector,
                selected: (0, $abRa1.getRefOption)(ref),
                selectedByUser: selectedByUser
            },
            params: {
                ...state.params,
                target: ref
            }
        };
    },
    [(0, $1kvgs.CHANGE_NEW_BRANCH_NAME)] (state, action) {
        return {
            ...state,
            params: {
                ...state.params,
                name: action.payload
            },
            error: null
        };
    },
    [(0, $1kvgs.CHANGE_BRANCH_TYPE)] (state, action) {
        return {
            ...state,
            branchTypeSelector: {
                ...state.branchTypeSelector,
                selected: action.payload
            },
            error: null
        };
    },
    [(0, $1kvgs.CREATE_BRANCH).REQUEST] (state) {
        return {
            ...state,
            isCreating: true,
            error: null
        };
    },
    [(0, $1kvgs.CREATE_BRANCH).SUCCESS] (state) {
        return {
            ...state,
            isCreating: false
        };
    },
    [(0, $1kvgs.CREATE_BRANCH).ERROR] (state, action) {
        return {
            ...state,
            isCreating: false,
            error: action.payload
        };
    },
    [(0, $1kvgs.SHOW_CREATE_BRANCH_SUCCESS_FLAG)] (state, action) {
        return {
            ...state,
            successFlag: {
                branch: action.payload
            }
        };
    },
    [(0, $1kvgs.CHANGE_REPOSITORY)] (state, action) {
        return {
            ...state,
            repositorySelector: {
                ...state.repositorySelector,
                selected: action.payload.selected
            },
            branchTypeSelector: {
                // When user switches the repository we need to clear some elements
                // which are irrelevant after the switch, such as "branch from" name
                // and hash as well as active branching model. However, we need to keep
                // the branch type that user might've selected before switching the repo
                // until its branching model is fetched to then pre-select the same
                // branch type if it is configured for the new repo.
                // Hence, we don't override `selected` property.
                // This is to avoid flickering in the UI, we also need to keep `isVisible`
                // property to continue showing/hiding the branch type selector until
                // the new branching model is fetched.
                ...state.branchTypeSelector,
                branchTypes: []
            },
            params: {
                ...state.params,
                target: null
            },
            error: null,
            workflowBranches: {
                main: null,
                development: null,
                production: null
            },
            refSelector: {
                ...state.refSelector,
                refs: [],
                hasMoreRefs: false,
                suggestedRef: null,
                selected: null,
                selectedByUser: false,
                selectedCommitStatuses: []
            }
        };
    },
    [(0, $1kvgs.SET_CURRENT_REPOSITORY)] (state) {
        // This is called in the dialog and on the repo page when we only have
        // one repository. We never trigger a repository load in this case so
        // we the state to SUCCESS to ensure we can create branches.
        return {
            ...state,
            repositorySelector: {
                ...state.repositorySelector,
                loadingState: (0, $5gF7V.LOADING_STATE).SUCCESS
            }
        };
    },
    [(0, $1kvgs.LOAD_REPOSITORIES).REQUEST] (state) {
        return {
            ...state,
            repositorySelector: {
                loadingState: (0, $5gF7V.LOADING_STATE).LOADING,
                repositories: [],
                selected: null,
                selectedDetails: null
            }
        };
    },
    [(0, $1kvgs.LOAD_REPOSITORIES).SUCCESS] (state, action) {
        const repos = action.payload.repositories || [];
        return {
            ...state,
            repositorySelector: {
                loadingState: (0, $5gF7V.LOADING_STATE).SUCCESS,
                // @ts-ignore TODO: fix noImplicitAny error here
                repositories: repos.map(({ full_name: fullName })=>({
                        label: fullName,
                        value: fullName,
                        data: {}
                    })),
                selected: null,
                selectedDetails: null
            },
            branchTypeSelector: {
                ...state.branchTypeSelector,
                // Set the loading state to 'success' if there are no repos
                // to hide the loading icon on the ref selector
                loadingState: repos.length === 0 ? (0, $5gF7V.LOADING_STATE).SUCCESS : state.branchTypeSelector.loadingState
            },
            refSelector: {
                ...state.refSelector,
                // Set the loading state to 'success' if there are no repos
                // to hide the loading icon on the ref selector
                loadingState: repos.length === 0 ? (0, $5gF7V.LOADING_STATE).SUCCESS : state.refSelector.loadingState
            }
        };
    },
    [(0, $1kvgs.LOAD_REPOSITORIES).ERROR] (state) {
        return {
            ...state,
            repositorySelector: {
                ...state.repositorySelector,
                loadingState: (0, $5gF7V.LOADING_STATE).ERROR
            },
            branchTypeSelector: {
                ...state.branchTypeSelector,
                isVisible: false,
                loadingState: (0, $5gF7V.LOADING_STATE).ERROR
            },
            refSelector: {
                ...state.refSelector,
                loadingState: (0, $5gF7V.LOADING_STATE).ERROR
            }
        };
    },
    [(0, $1kvgs.LOAD_REPOSITORY).SUCCESS] (state, action) {
        return {
            ...state,
            repositorySelector: {
                ...state.repositorySelector,
                selectedDetails: action.payload
            }
        };
    },
    [(0, $1kvgs.SET_JIRA_ISSUE)] (state, action) {
        const { params: params } = state;
        const issue = action.payload;
        return {
            ...state,
            issue: issue,
            params: {
                ...params,
                name: params.name || (0, $683bT.generateBranchNameFromIssue)(issue)
            }
        };
    }
});

});


parcelRegister("9nued", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd71e1414868dfc8$export$2e2bcd8739ae039; });

var $jF3Yx = parcelRequire("jF3Yx");

var $5JIc0 = parcelRequire("5JIc0");

var $enqsd = parcelRequire("enqsd");

var $dE7fQ = parcelRequire("dE7fQ");
parcelRequire("eGPIr");
var $9EuIy = parcelRequire("9EuIy");
var $lOTNC = parcelRequire("lOTNC");
var $bGtez = parcelRequire("bGtez");

var $a0FRM = parcelRequire("a0FRM");
var $fd71e1414868dfc8$export$2e2bcd8739ae039 = (0, $jF3Yx.combineReducers)({
    pullRequests: $enqsd.default,
    section: $a0FRM.default,
    repositories: $dE7fQ.default,
    repositoryFilters: (0, $jF3Yx.combineReducers)({
        owners: $9EuIy.default,
        projects: $lOTNC.default,
        workspaces: $bGtez.default
    }),
    overviewRepositories: $5JIc0.default
});

});
parcelRegister("5JIc0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fa2780fd1cb68d9$export$2e2bcd8739ae039; });

var $gsXeO = parcelRequire("gsXeO");

var $jKnoY = parcelRequire("jKnoY");
const $8fa2780fd1cb68d9$var$initialState = {
    isLoading: false,
    isError: false
};
var $8fa2780fd1cb68d9$export$2e2bcd8739ae039 = (0, $gsXeO.default)($8fa2780fd1cb68d9$var$initialState, {
    [(0, $jKnoY.LoadDashboardOverview).REQUEST] (state) {
        return {
            ...state,
            isLoading: true
        };
    },
    [(0, $jKnoY.LoadDashboardOverview).SUCCESS] (state) {
        return {
            ...state,
            isLoading: false,
            isError: false
        };
    },
    [(0, $jKnoY.LoadDashboardOverview).ERROR] (state) {
        return {
            ...state,
            isLoading: false,
            isError: true
        };
    }
});

});

parcelRegister("enqsd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5d838070c12c67a$export$2e2bcd8739ae039; });

var $gsXeO = parcelRequire("gsXeO");

var $jKnoY = parcelRequire("jKnoY");
const $a5d838070c12c67a$var$initialState = {
    expandedPullRequestSets: [],
    isLoading: true,
    pullRequests: {
        authored: [],
        reviewing: [],
        closed: []
    },
    pullRequestFilters: []
};
var $a5d838070c12c67a$export$2e2bcd8739ae039 = (0, $gsXeO.default)($a5d838070c12c67a$var$initialState, {
    [(0, $jKnoY.CLEAR_PULL_REQUEST_FILTERS)] (state) {
        return {
            ...state,
            pullRequestFilters: []
        };
    },
    [(0, $jKnoY.EXPAND_PULL_REQUESTS)] (state, action) {
        if (state.expandedPullRequestSets.indexOf(action.payload) !== -1) return state;
        return {
            ...state,
            expandedPullRequestSets: [
                ...state.expandedPullRequestSets,
                action.payload
            ]
        };
    },
    [(0, $jKnoY.LoadDashboardOverview).REQUEST] (state) {
        return {
            ...state,
            isLoading: true
        };
    },
    [(0, $jKnoY.LoadDashboardOverview).SUCCESS] (state, action) {
        return {
            ...state,
            pullRequests: action.payload.result.pullRequests,
            pullRequestFilters: action.payload.result.pullRequestFilters,
            isLoading: false
        };
    },
    [(0, $jKnoY.LoadDashboardOverview).ERROR] (state) {
        return {
            ...state,
            isLoading: false
        };
    },
    [(0, $jKnoY.FILTER_PULL_REQUESTS)] (state, action) {
        if (action.payload.state) {
            if (state.pullRequestFilters.indexOf(action.payload.filter) !== -1) return state;
            return {
                ...state,
                pullRequestFilters: [
                    ...state.pullRequestFilters,
                    action.payload.filter
                ]
            };
        }
        if (state.pullRequestFilters.indexOf(action.payload.filter) === -1) return state;
        return {
            ...state,
            pullRequestFilters: state.pullRequestFilters.filter((f)=>f !== action.payload.filter)
        };
    }
});

});

parcelRegister("dE7fQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee1e430f9876cc69$export$2e2bcd8739ae039; });

var $gsXeO = parcelRequire("gsXeO");

var $jKnoY = parcelRequire("jKnoY");
const $ee1e430f9876cc69$var$initialState = {
    isLoading: false,
    isError: false,
    isPreRequestState: true,
    repositories: [],
    size: 0,
    pagelen: 0
};
var $ee1e430f9876cc69$export$2e2bcd8739ae039 = (0, $gsXeO.default)($ee1e430f9876cc69$var$initialState, {
    [(0, $jKnoY.FetchRepositories).REQUEST] (state) {
        return {
            ...state,
            isLoading: true,
            isError: false,
            isPreRequestState: false
        };
    },
    [(0, $jKnoY.FetchRepositories).ERROR] (state) {
        return {
            ...state,
            isLoading: false,
            isError: true
        };
    },
    [(0, $jKnoY.FetchRepositories).SUCCESS] (state, action) {
        return {
            ...state,
            isLoading: false,
            repositories: action.payload.result.values,
            size: action.payload.result.size,
            pagelen: action.payload.result.pagelen
        };
    }
});

});

parcelRegister("eGPIr", function(module, exports) {

$parcel$export(module.exports, "owners", function () { return (parcelRequire("9EuIy")).default; });
$parcel$export(module.exports, "projects", function () { return (parcelRequire("lOTNC")).default; });
$parcel$export(module.exports, "workspaces", function () { return (parcelRequire("bGtez")).default; });

var $9EuIy = parcelRequire("9EuIy");

var $lOTNC = parcelRequire("lOTNC");

var $bGtez = parcelRequire("bGtez");
 // TODO: P2X-920 Remove explicitly stated type

});
parcelRegister("9EuIy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f443c825e9760b1f$export$2e2bcd8739ae039; });

var $4fI1Y = parcelRequire("4fI1Y");

var $gsXeO = parcelRequire("gsXeO");
const $f443c825e9760b1f$var$initialState = {
    isLoading: false,
    isError: false,
    owners: [],
    selectedOwner: null
};
var $f443c825e9760b1f$export$2e2bcd8739ae039 = (0, $gsXeO.default)($f443c825e9760b1f$var$initialState, {
    [(0, $4fI1Y.FetchOwners).REQUEST] (state) {
        return {
            ...state,
            isLoading: true
        };
    },
    [(0, $4fI1Y.FetchOwners).ERROR] (state) {
        return {
            ...state,
            isLoading: false,
            isError: true
        };
    },
    [(0, $4fI1Y.FetchOwners).SUCCESS] (state, action) {
        return {
            ...state,
            isLoading: false,
            owners: action.payload
        };
    },
    [(0, $4fI1Y.CLEAR_FILTERED_OWNERS)] (state) {
        return {
            ...state,
            isLoading: false,
            owners: []
        };
    },
    [(0, $4fI1Y.FetchAndSelectOwner).REQUEST] (state) {
        return {
            ...state,
            isLoading: true
        };
    },
    [(0, $4fI1Y.FetchAndSelectOwner).ERROR] (state) {
        return {
            ...state,
            isLoading: false,
            isError: true
        };
    },
    [(0, $4fI1Y.FetchAndSelectOwner).SUCCESS] (state, action) {
        const user = action.payload;
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const { display_name: display_name, nickname: nickname, uuid: uuid, links: links } = user;
        const avatarUrl = links.avatar.href;
        return {
            ...state,
            isLoading: false,
            selectedOwner: {
                display_name: display_name,
                nickname: nickname,
                uuid: uuid,
                avatar_url: avatarUrl
            }
        };
    },
    [(0, $4fI1Y.SELECT_OWNER)] (state, action) {
        return {
            ...state,
            selectedOwner: action.payload
        };
    }
});

});
parcelRegister("4fI1Y", function(module, exports) {

$parcel$export(module.exports, "FetchOwners", function () { return $7be7bd84cefe1cac$export$67d86a5d1371963e; });
$parcel$export(module.exports, "FetchAndSelectOwner", function () { return $7be7bd84cefe1cac$export$4a589f492f1d132c; });
$parcel$export(module.exports, "CLEAR_FILTERED_OWNERS", function () { return $7be7bd84cefe1cac$export$9db85d130a889408; });
$parcel$export(module.exports, "SELECT_OWNER", function () { return $7be7bd84cefe1cac$export$f4e3e759cb41509b; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
var $fICwP = parcelRequire("fICwP");

var $6OwE2 = parcelRequire("6OwE2");

var $3rtV2 = parcelRequire("3rtV2");
const $7be7bd84cefe1cac$export$67d86a5d1371963e = (0, $2MctD.createAsyncAction)("dashboard/FETCH_OWNERS");
const $7be7bd84cefe1cac$export$b1da3665e607dae6 = (query)=>{
    return (0, $fICwP.fetchAction)($7be7bd84cefe1cac$export$67d86a5d1371963e, {
        url: (0, $6OwE2.default).api.internal.repositoryOwners(query)
    });
};
const $7be7bd84cefe1cac$export$4a589f492f1d132c = (0, $2MctD.createAsyncAction)("dashboard/FETCH_AND_SELECT_OWNER");
const $7be7bd84cefe1cac$export$190254aa86c72950 = (uuid)=>{
    return (0, $fICwP.fetchAction)($7be7bd84cefe1cac$export$4a589f492f1d132c, {
        url: (0, $3rtV2.default).api.v20.user(uuid)
    });
};
const $7be7bd84cefe1cac$export$9db85d130a889408 = `dashboard/CLEAR_FILTERED_OWNERS`;
const $7be7bd84cefe1cac$export$19f96730df10a653 = ()=>({
        type: $7be7bd84cefe1cac$export$9db85d130a889408
    });
const $7be7bd84cefe1cac$export$f4e3e759cb41509b = `dashboard/SELECT_OWNER`;
const $7be7bd84cefe1cac$export$2e1f48b4c4a55b0b = (owner)=>({
        type: $7be7bd84cefe1cac$export$f4e3e759cb41509b,
        payload: owner
    });

});


parcelRegister("lOTNC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55da99d3c926bcf1$export$2e2bcd8739ae039; });

var $dnit1 = parcelRequire("dnit1");

var $gsXeO = parcelRequire("gsXeO");
const $55da99d3c926bcf1$var$initialState = {
    isLoading: false,
    isError: false,
    data: [],
    filteredProjects: [],
    project: null
};
var $55da99d3c926bcf1$export$2e2bcd8739ae039 = (0, $gsXeO.default)($55da99d3c926bcf1$var$initialState, {
    [(0, $dnit1.FetchProjects).REQUEST] (state) {
        return {
            ...state,
            isLoading: true
        };
    },
    [(0, $dnit1.FetchProjects).ERROR] (state) {
        return {
            ...state,
            isError: true,
            isLoading: false
        };
    },
    [(0, $dnit1.FetchProjects).SUCCESS] (state, action) {
        if (action.meta && action.meta.data.filter) return {
            ...state,
            isLoading: false,
            filteredProjects: action.payload.values
        };
        return {
            ...state,
            isLoading: false,
            data: action.payload.values
        };
    },
    [(0, $dnit1.FetchProject).REQUEST] (state) {
        return {
            ...state,
            isLoading: true
        };
    },
    [(0, $dnit1.FetchProject).ERROR] (state) {
        return {
            ...state,
            isError: true,
            isLoading: false
        };
    },
    [(0, $dnit1.FetchProject).SUCCESS] (state, action) {
        return {
            ...state,
            isLoading: false,
            project: action.payload.values[0]
        };
    },
    [(0, $dnit1.SELECT_PROJECT)] (state, action) {
        return {
            ...state,
            isLoading: false,
            project: action.payload
        };
    },
    [(0, $dnit1.CLEAR_FILTERED_PROJECTS)] (state) {
        return {
            ...state,
            isLoading: false,
            filteredProjects: $55da99d3c926bcf1$var$initialState.filteredProjects
        };
    }
});

});
parcelRegister("dnit1", function(module, exports) {

$parcel$export(module.exports, "FetchProjects", function () { return $ddf39c118347c03d$export$8ce14a52d919f12b; });
$parcel$export(module.exports, "FetchProject", function () { return $ddf39c118347c03d$export$2174c9778d6f11b; });
$parcel$export(module.exports, "CLEAR_FILTERED_PROJECTS", function () { return $ddf39c118347c03d$export$46fafc0b9477e4cb; });
$parcel$export(module.exports, "SELECT_PROJECT", function () { return $ddf39c118347c03d$export$5d494d3f115ccae3; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
var $fICwP = parcelRequire("fICwP");

var $6OwE2 = parcelRequire("6OwE2");
const $ddf39c118347c03d$export$8ce14a52d919f12b = (0, $2MctD.createAsyncAction)("dashboard/FETCH_PROJECTS");
const $ddf39c118347c03d$export$2174c9778d6f11b = (0, $2MctD.createAsyncAction)("dashboard/FETCH_PROJECT");
var $ddf39c118347c03d$export$2e2bcd8739ae039 = (search)=>(0, $fICwP.fetchAction)($ddf39c118347c03d$export$8ce14a52d919f12b, {
        url: (0, $6OwE2.default).api.internal.repositoryProjects({
            fields: "+values.owner",
            q: search ? `(name ~ "${search}" OR key ~ "${search}")` : null
        }),
        data: {
            filter: !!search
        }
    });
const $ddf39c118347c03d$export$1a7fd375605c6cad = (project)=>(0, $fICwP.fetchAction)($ddf39c118347c03d$export$2174c9778d6f11b, {
        url: (0, $6OwE2.default).api.internal.repositoryProjects({
            fields: "+values.owner",
            q: `(owner.uuid = "${project.owner}") AND (key = "${project.key}")`
        })
    });
const $ddf39c118347c03d$export$46fafc0b9477e4cb = `dashboard/CLEAR_FILTERED_PROJECTS`;
const $ddf39c118347c03d$export$6aa4ce983d798751 = ()=>({
        type: $ddf39c118347c03d$export$46fafc0b9477e4cb
    });
const $ddf39c118347c03d$export$5d494d3f115ccae3 = `dashboard/SELECT_PROJECT`;
const $ddf39c118347c03d$export$6a772d98df0515d3 = (project)=>({
        type: $ddf39c118347c03d$export$5d494d3f115ccae3,
        payload: project
    });

});


parcelRegister("bGtez", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2875399e2db2588$export$2e2bcd8739ae039; });

var $dFxSt = parcelRequire("dFxSt");

var $gsXeO = parcelRequire("gsXeO");
const $a2875399e2db2588$var$initialState = {
    isLoading: false,
    isError: false,
    workspaces: [],
    selectedWorkspace: null
};
var $a2875399e2db2588$export$2e2bcd8739ae039 = (0, $gsXeO.default)($a2875399e2db2588$var$initialState, {
    [(0, $dFxSt.FetchWorkspaces).REQUEST] (state) {
        return {
            ...state,
            isLoading: true
        };
    },
    [(0, $dFxSt.FetchWorkspaces).ERROR] (state) {
        return {
            ...state,
            isLoading: false,
            isError: true
        };
    },
    [(0, $dFxSt.FetchWorkspaces).SUCCESS] (state, action) {
        return {
            ...state,
            isLoading: false,
            workspaces: action.payload.values
        };
    },
    [(0, $dFxSt.CLEAR_FILTERED_WORKSPACES)] (state) {
        return {
            ...state,
            isLoading: false,
            workspaces: []
        };
    },
    [(0, $dFxSt.FetchAndSelectWorkspace).REQUEST] (state) {
        return {
            ...state,
            isLoading: true
        };
    },
    [(0, $dFxSt.FetchAndSelectWorkspace).ERROR] (state) {
        return {
            ...state,
            isLoading: false,
            isError: true
        };
    },
    [(0, $dFxSt.FetchAndSelectWorkspace).SUCCESS] (state, action) {
        const workspace = action.payload;
        return {
            ...state,
            isLoading: false,
            selectedWorkspace: workspace
        };
    },
    [(0, $dFxSt.SELECT_WORKSPACE)] (state, action) {
        return {
            ...state,
            selectedWorkspace: action.payload
        };
    }
});

});
parcelRegister("dFxSt", function(module, exports) {

$parcel$export(module.exports, "FetchWorkspaces", function () { return $176f9449e1af135c$export$a3f78455585e955b; });
$parcel$export(module.exports, "FetchAndSelectWorkspace", function () { return $176f9449e1af135c$export$68e49e09c52bd9e; });
$parcel$export(module.exports, "CLEAR_FILTERED_WORKSPACES", function () { return $176f9449e1af135c$export$e778d48920936439; });
$parcel$export(module.exports, "SELECT_WORKSPACE", function () { return $176f9449e1af135c$export$38c6492e2218cfd1; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
var $fICwP = parcelRequire("fICwP");

var $6OwE2 = parcelRequire("6OwE2");

var $ksfVj = parcelRequire("ksfVj");
const $176f9449e1af135c$export$a3f78455585e955b = (0, $2MctD.createAsyncAction)("dashboard/FETCH_WORKSPACES");
const $176f9449e1af135c$export$ca20d481cfd05248 = (query)=>{
    return (0, $fICwP.fetchAction)($176f9449e1af135c$export$a3f78455585e955b, {
        // get workspaces that a user has access to, filtered based on matching the `query`
        url: (0, $6OwE2.default).api.v20.filterUserWorkspaces(query)
    });
};
const $176f9449e1af135c$export$68e49e09c52bd9e = (0, $2MctD.createAsyncAction)("dashboard/FETCH_AND_SELECT_WORKSPACE");
const $176f9449e1af135c$export$a989c3e0451438f0 = (uuid)=>{
    return (0, $fICwP.fetchAction)($176f9449e1af135c$export$68e49e09c52bd9e, {
        url: (0, $ksfVj.default).api.v20.get(uuid)
    });
};
const $176f9449e1af135c$export$e778d48920936439 = `dashboard/CLEAR_FILTERED_WORKSPACES`;
const $176f9449e1af135c$export$6804f9cfe765c95c = ()=>({
        type: $176f9449e1af135c$export$e778d48920936439
    });
const $176f9449e1af135c$export$38c6492e2218cfd1 = `dashboard/SELECT_WORKSPACE`;
const $176f9449e1af135c$export$82f4ec3885fd9bd2 = (workspace)=>({
        type: $176f9449e1af135c$export$38c6492e2218cfd1,
        payload: workspace
    });

});



parcelRegister("a0FRM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eaecbd29dd696dad$export$2e2bcd8739ae039; });

var $gsXeO = parcelRequire("gsXeO");

var $jKnoY = parcelRequire("jKnoY");
const $eaecbd29dd696dad$var$initialState = {
    isLoading: false,
    menuItems: []
};
var $eaecbd29dd696dad$export$2e2bcd8739ae039 = (0, $gsXeO.default)($eaecbd29dd696dad$var$initialState, {
    [(0, $jKnoY.LoadDashboard).REQUEST] (state) {
        return {
            ...state,
            isLoading: true
        };
    },
    [(0, $jKnoY.LoadDashboard).SUCCESS] (state, action) {
        return {
            ...state,
            ...action.payload,
            isLoading: false
        };
    },
    [(0, $jKnoY.LoadDashboard).ERROR] (state) {
        return {
            ...state,
            isLoading: false
        };
    }
});

});


parcelRegister("jffME", function(module, exports) {

$parcel$export(module.exports, "getFaviconUrl", function () { return $a20c9103aa148650$export$179f5d628a6b9050; });
$parcel$export(module.exports, "default", function () { return $a20c9103aa148650$export$2e2bcd8739ae039; });

var $aXXtM = parcelRequire("aXXtM");

var $9haAh = parcelRequire("9haAh");
const $a20c9103aa148650$var$UPDATE_FAVICON = "favicon/UPDATE";
const $a20c9103aa148650$var$initialState = {
    url: (0, $9haAh.default)
};
const $a20c9103aa148650$export$1e6380d3562a2b55 = (url)=>({
        type: $a20c9103aa148650$var$UPDATE_FAVICON,
        payload: {
            url: url
        }
    });
const $a20c9103aa148650$export$9ab8c178227281e7 = ()=>({
        type: $a20c9103aa148650$var$UPDATE_FAVICON,
        payload: {
            url: (0, $9haAh.default)
        }
    });
const $a20c9103aa148650$export$179f5d628a6b9050 = (0, $aXXtM.createSelector)((state)=>state.favicon, (state)=>state.url);
var $a20c9103aa148650$export$2e2bcd8739ae039 = (state = $a20c9103aa148650$var$initialState, action)=>{
    switch(action.type){
        case $a20c9103aa148650$var$UPDATE_FAVICON:
            {
                const { url: url } = action.payload;
                return {
                    ...state,
                    url: url
                };
            }
        default:
            return state;
    }
};

});
parcelRegister("9haAh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3a5bb3b0c6e7a0c$export$2e2bcd8739ae039; });
var $f3a5bb3b0c6e7a0c$export$2e2bcd8739ae039 = `data:image/png;base64,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`;

});


parcelRegister("c2Pbi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f335623d02dfabc2$export$2e2bcd8739ae039; });

var $jmonP = parcelRequire("jmonP");

var $d3E7J = parcelRequire("d3E7J");

var $90kWr = parcelRequire("90kWr");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");

var $gsXeO = parcelRequire("gsXeO");

var $4dd8Y = parcelRequire("4dd8Y");

var $dkkN8 = parcelRequire("dkkN8");

var $jOlj7 = parcelRequire("jOlj7");

var $iyyGb = parcelRequire("iyyGb");

var $3pyKL = parcelRequire("3pyKL");
const $f335623d02dfabc2$var$initialState = {
    needsTermsAndConditions: false,
    bitbucketActions: [],
    currentUser: null,
    features: {},
    focusedTaskBackButtonUrl: "",
    geoipCountry: "",
    horizontalNavigationItems: {
        mainItems: [],
        secondaryItems: [],
        settingsItems: []
    },
    isAtlassianSwitcherOpen: false,
    isCreateDrawerOpen: false,
    isFocusedTask: false,
    isKeyboardShortcutMenuOpen: false,
    isFeedbackModalOpen: false,
    isNavigationOpen: true,
    isMobileHeaderActive: (0, $jmonP.default)(),
    isUpToSmallBreakpointActive: (0, $4dd8Y.isUpToSmallBreakpoint)(),
    mobileHeaderState: "none",
    isSearchDrawerOpen: false,
    issues: [],
    marketingConsentLocale: "UNKNOWN",
    needsMarketingConsent: false,
    pullRequests: [],
    repositories: [],
    searchQuery: "",
    targetFeatures: {},
    targetUser: null,
    theme: null,
    isPageVisible: true,
    isOffline: false,
    repositoryPageLoadingStatus: {
        status: (0, $90kWr.LoadingStatus).Before
    },
    currentUserEmail: null,
    workspaceBootstrapping: null
};
var $f335623d02dfabc2$export$2e2bcd8739ae039 = (0, $gsXeO.default)($f335623d02dfabc2$var$initialState, {
    [(0, $dkkN8.LoadGlobal).SUCCESS] (state, action) {
        if (!action.payload) return state;
        const { needsTermsAndConditions: needsTermsAndConditions, bitbucketActions: bitbucketActions, currentUser: currentUser, features: features, focusedTaskBackButtonUrl: focusedTaskBackButtonUrl, horizontalNavigationItems: horizontalNavigationItems, marketing_consent_locale: marketingConsentLocale, needs_marketing_consent: needsMarketingConsent, whats_new_feed: whatsNewUrl, geoip_country: geoipCountry, isFocusedTask: isFocusedTask, isNavigationOpen: isNavigationOpen, isOrgAdmin: isOrgAdmin, workspaceOrgId: workspaceOrgId, isWorkspaceSumEnabled: isWorkspaceSumEnabled, isWorkspaceAdmin: isWorkspaceAdmin, site_message: siteMessage, targetFeatures: targetFeatures, targetUser: targetUser, theme: theme, workspaceBootstrapping: workspaceBootstrapping } = action.payload.result;
        return {
            ...state,
            needsTermsAndConditions: needsTermsAndConditions,
            // As we are moving towards loading navigation data from Resources
            // instead of redux, some views may not have navigation data. In that
            // case, fall back to the existing state
            bitbucketActions: bitbucketActions !== null && bitbucketActions !== void 0 ? bitbucketActions : state.bitbucketActions,
            currentUser: currentUser,
            features: features,
            focusedTaskBackButtonUrl: focusedTaskBackButtonUrl,
            // As we are moving towards loading navigation data from Resources
            // instead of redux, some views may not have navigation data. In that
            // case, fall back to the existing state
            horizontalNavigationItems: horizontalNavigationItems !== null && horizontalNavigationItems !== void 0 ? horizontalNavigationItems : state.horizontalNavigationItems,
            isFocusedTask: isFocusedTask,
            isNavigationOpen: isNavigationOpen,
            isOrgAdmin: !!isOrgAdmin && !!isWorkspaceSumEnabled,
            workspaceOrgId: workspaceOrgId,
            isWorkspaceSumEnabled: isWorkspaceSumEnabled,
            isWorkspaceAdmin: isWorkspaceAdmin,
            marketingConsentLocale: marketingConsentLocale,
            needsMarketingConsent: needsMarketingConsent,
            whatsNewUrl: whatsNewUrl,
            geoipCountry: geoipCountry,
            siteMessage: siteMessage,
            targetFeatures: targetFeatures,
            targetUser: targetUser,
            theme: theme,
            workspaceBootstrapping: workspaceBootstrapping
        };
    },
    [(0, $iyyGb.LOAD_STATUSPAGE_INCIDENTS).SUCCESS] (state, action) {
        // If there are no Statuspage incidents, clear the state so we can resume rendering normal
        // SiteMessage banners if they exist.
        const incidents = action.payload || [];
        const majorIncidents = (0, $3pyKL.getMajorIncidents)(incidents);
        if (majorIncidents.length === 0) return {
            ...state,
            siteMessageStatuspageIncident: null
        };
        return {
            ...state,
            siteMessageStatuspageIncident: (0, $3pyKL.getGenericStatusPageIncident)(majorIncidents)
        };
    },
    [(0, $dkkN8.SEARCH)] (state, action) {
        return {
            ...state,
            searchQuery: action.payload
        };
    },
    [(0, $dkkN8.TOGGLE_ATLASSIAN_SWITCHER)] (state, action) {
        return {
            ...state,
            isAtlassianSwitcherOpen: action.payload,
            isCreateDrawerOpen: false,
            isSearchDrawerOpen: false
        };
    },
    [(0, $dkkN8.TOGGLE_CREATE_DRAWER)] (state, action) {
        return {
            ...state,
            isAtlassianSwitcherOpen: false,
            isCreateDrawerOpen: action.payload,
            isSearchDrawerOpen: false
        };
    },
    [(0, $dkkN8.TOGGLE_KB_SHORTCUT_MENU)] (state, action) {
        return {
            ...state,
            isKeyboardShortcutMenuOpen: action.payload !== undefined ? action.payload : !state.isKeyboardShortcutMenuOpen
        };
    },
    [(0, $dkkN8.TOGGLE_FEEDBACK_BUTTON)] (state, action) {
        return {
            ...state,
            isFeedbackModalOpen: action.payload !== undefined ? action.payload : !state.isFeedbackModalOpen
        };
    },
    [(0, $dkkN8.TOGGLE_MOBILE_HEADER)] (state, action) {
        return {
            ...state,
            isMobileHeaderActive: action.payload,
            mobileHeaderState: "none"
        };
    },
    [(0, $dkkN8.UPDATE_MOBILE_HEADER_STATE)] (state, action) {
        return {
            ...state,
            mobileHeaderState: action.payload
        };
    },
    [(0, $dkkN8.TOGGLE_UP_TO_SMALL_BREAKPOINT)] (state, action) {
        if (action.payload !== state.isUpToSmallBreakpointActive) return {
            ...state,
            isUpToSmallBreakpointActive: action.payload
        };
        return state;
    },
    [(0, $dkkN8.TOGGLE_SEARCH_DRAWER)] (state, action) {
        return {
            ...state,
            isAtlassianSwitcherOpen: false,
            isCreateDrawerOpen: false,
            isSearchDrawerOpen: action.payload === undefined ? !state.isSearchDrawerOpen : action.payload,
            searchQuery: ""
        };
    },
    [(0, $dkkN8.TOGGLE_MARKETING_CONSENT_NEEDED)] (state, action) {
        return {
            ...state,
            needsMarketingConsent: action.payload
        };
    },
    [(0, $jOlj7.PAGE_HIDDEN)] (state) {
        return {
            ...state,
            isPageVisible: false
        };
    },
    [(0, $jOlj7.PAGE_VISIBLE)] (state) {
        return {
            ...state,
            isPageVisible: true
        };
    },
    [(0, $dkkN8.NETWORK_OFFLINE)] (state) {
        return {
            ...state,
            isOffline: true
        };
    },
    [(0, $dkkN8.NETWORK_ONLINE)] (state) {
        return {
            ...state,
            isOffline: false
        };
    },
    [(0, $jJd6W.LoadRepositoryPage).SUCCESS] (state) {
        return {
            ...state,
            repositoryPageLoadingStatus: {
                status: (0, $90kWr.LoadingStatus).Success
            }
        };
    },
    [(0, $jJd6W.LoadRepositoryPage).ERROR] (state, action) {
        if (action.meta && action.meta.status && [
            (0, $d3E7J.default).FORBIDDEN,
            (0, $d3E7J.default).NOT_FOUND
        ].includes(action.meta.status)) return {
            ...state,
            repositoryPageLoadingStatus: {
                status: (0, $90kWr.LoadingStatus).Failed,
                statusCode: action.meta.status
            }
        };
        return {
            ...state
        };
    },
    [(0, $jJd6W.FetchUserEmails).SUCCESS] (state, action) {
        const emailData = action.payload.values.find((data)=>data.is_primary);
        if (emailData) return {
            ...state,
            currentUserEmail: emailData.email
        };
        return {
            ...state
        };
    },
    // Used for overriding features in tests.
    [(0, $dkkN8.OVERRIDE_FEATURE)] (state, action) {
        const { featureKey: featureKey, featureValue: featureValue } = action.payload;
        return {
            ...state,
            features: {
                ...state.features,
                [featureKey]: featureValue
            }
        };
    }
});

});
parcelRegister("d3E7J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1cc5805b62c1193$export$2e2bcd8739ae039; });
var $e1cc5805b62c1193$var$ErrorCodes;
(function(ErrorCodes) {
    ErrorCodes[ErrorCodes["FORBIDDEN"] = 403] = "FORBIDDEN";
    ErrorCodes[ErrorCodes["NOT_FOUND"] = 404] = "NOT_FOUND";
})($e1cc5805b62c1193$var$ErrorCodes || ($e1cc5805b62c1193$var$ErrorCodes = {}));
var $e1cc5805b62c1193$export$2e2bcd8739ae039 = $e1cc5805b62c1193$var$ErrorCodes;

});

parcelRegister("4dd8Y", function(module, exports) {

$parcel$export(module.exports, "isUpToSmallBreakpoint", function () { return $33fc4dc1b2350185$export$908ac6996c8b5aeb; });

var $gFLTd = parcelRequire("gFLTd");
const $33fc4dc1b2350185$export$908ac6996c8b5aeb = ()=>{
    var _document, _document$documentEle;
    const clientWidth = ((_document = document) === null || _document === void 0 ? void 0 : (_document$documentEle = _document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.clientWidth) || 0;
    const innerWidth = window.innerWidth || 0;
    const windowWidth = clientWidth && innerWidth ? Math.min(clientWidth, innerWidth) : Math.max(clientWidth, innerWidth);
    return windowWidth < (0, $gFLTd.UP_TO_SMALL_BREAKPOINT_ACTIVE_WIDTH);
};

});

parcelRegister("3pyKL", function(module, exports) {

$parcel$export(module.exports, "getGenericStatusPageIncident", function () { return $b88237ddf70e8054$export$b2f60f5f5a3ca89c; });
$parcel$export(module.exports, "getMajorIncidents", function () { return $b88237ddf70e8054$export$b51a316a44338bef; });
$parcel$export(module.exports, "getIncidents", function () { return $b88237ddf70e8054$export$ef651e9c94dfc6c9; });

var $lIZwG = parcelRequire("lIZwG");
const $b88237ddf70e8054$var$CRITICAL = "critical";
const $b88237ddf70e8054$var$MAJOR = "major";
const $b88237ddf70e8054$var$getStatuspageApiHost = ()=>{
    const host = document.head ? document.head.querySelector("meta[name=statuspage-api-host]") : undefined;
    return host ? host.content : "";
};
const $b88237ddf70e8054$export$b2f60f5f5a3ca89c = (incidents)=>{
    const incident = incidents.shift();
    return {
        id: parseInt(incident.id, 10),
        title: incident.name,
        appearance: "banner",
        // This is hardcoded for now since incident messages can have a varying length.
        text: "Bitbucket is experiencing an incident, but we're on it. Check our status page for more details.",
        url: incident.shortlink,
        isIncident: true
    };
};
const $b88237ddf70e8054$export$b51a316a44338bef = (incidents)=>incidents.filter((i)=>i.impact === $b88237ddf70e8054$var$CRITICAL || i.impact === $b88237ddf70e8054$var$MAJOR);
const $b88237ddf70e8054$export$ef651e9c94dfc6c9 = async ()=>{
    const resp = await fetch(`${$b88237ddf70e8054$var$getStatuspageApiHost()}/api/v2/incidents/unresolved.json`);
    if (!resp.ok) throw new Error("Failed to fetch Statuspage incidents");
    const json = await resp.json();
    // Pluck out the list of incidents from the API response
    return (0, $lIZwG.default)(json, "incidents", []);
};

});


parcelRegister("2oiZ1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6503d64851c1ed4$export$2e2bcd8739ae039; });

var $jF3Yx = parcelRequire("jF3Yx");

var $lknbE = parcelRequire("lknbE");

var $k6kNf = parcelRequire("k6kNf");

var $21sfB = parcelRequire("21sfB");

var $5ji45 = parcelRequire("5ji45");

var $7n0YR = parcelRequire("7n0YR");
var $d6503d64851c1ed4$export$2e2bcd8739ae039 = (0, $jF3Yx.combineReducers)({
    jiraRepoPage: $5ji45.default,
    createJiraIssue: $lknbE.default,
    pullRequestJiraIssues: $7n0YR.default,
    dashboardJiraIssues: $k6kNf.default,
    jiraMigration: $21sfB.default
});

});
parcelRegister("lknbE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b80b1738f030ba1$export$2e2bcd8739ae039; });

var $90kWr = parcelRequire("90kWr");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $gsXeO = parcelRequire("gsXeO");
parcelRequire("erZj9");
var $g7vJB = parcelRequire("g7vJB");

var $hahvB = parcelRequire("hahvB");
const $0b80b1738f030ba1$var$initialState = {
    connectedSites: [],
    connectedSitesFetchedStatus: (0, $90kWr.LoadingStatus).Before,
    onboarding: {
        viewed: (0, $hahvB.OnboardingViewed).Seen,
        fetchedStatus: (0, $90kWr.LoadingStatus).Before
    },
    issueCreationMetadata: {},
    defaultProject: {},
    projects: {},
    createForm: {},
    jiraTabCreateForm: {
        failureReason: (0, $hahvB.IssueCreationFailureReason).None,
        status: (0, $90kWr.LoadingStatus).Before
    },
    preferences: {
        fetchedStatus: (0, $90kWr.LoadingStatus).Before,
        value: undefined
    }
};
var $0b80b1738f030ba1$export$2e2bcd8739ae039 = (0, $gsXeO.default)($0b80b1738f030ba1$var$initialState, {
    // Connected Jira sites
    [(0, $g7vJB.FETCH_CONNECTED_JIRA_SITES).REQUEST]: (state)=>({
            ...state,
            connectedSitesFetchedStatus: (0, $90kWr.LoadingStatus).Fetching,
            connectedSites: []
        }),
    [(0, $g7vJB.FETCH_CONNECTED_JIRA_SITES).SUCCESS]: (state, { payload: payload })=>({
            ...state,
            connectedSitesFetchedStatus: (0, $90kWr.LoadingStatus).Success,
            connectedSites: payload
        }),
    [(0, $g7vJB.FETCH_CONNECTED_JIRA_SITES).ERROR]: (state)=>({
            ...state,
            connectedSitesFetchedStatus: (0, $90kWr.LoadingStatus).Failed,
            connectedSites: []
        }),
    // Jira project
    [(0, $g7vJB.FETCH_JIRA_PROJECT).REQUEST]: (state, { payload: payload })=>({
            ...state,
            defaultProject: {
                ...state.defaultProject,
                [payload.cloudId]: {
                    project: {},
                    fetchedStatus: (0, $90kWr.LoadingStatus).Fetching
                }
            }
        }),
    [(0, $g7vJB.FETCH_JIRA_PROJECT).SUCCESS]: (state, { payload: payload })=>({
            ...state,
            defaultProject: {
                ...state.defaultProject,
                ...payload
            }
        }),
    [(0, $g7vJB.FETCH_JIRA_PROJECT).ERROR]: (state, { payload: payload })=>({
            ...state,
            defaultProject: {
                ...state.defaultProject,
                ...payload
            }
        }),
    // Jira projects
    [(0, $g7vJB.FETCH_JIRA_PROJECTS_FOR_SITE).REQUEST]: (state, { payload: payload })=>({
            ...state,
            projects: {
                ...state.projects,
                [payload.commentId]: {
                    [payload.site.cloudId]: {
                        list: [],
                        fetchedStatus: (0, $90kWr.LoadingStatus).Fetching
                    }
                }
            }
        }),
    [(0, $g7vJB.FETCH_JIRA_PROJECTS_FOR_SITE).SUCCESS]: (state, { payload: payload })=>({
            ...state,
            projects: {
                ...state.projects,
                ...payload
            }
        }),
    [(0, $g7vJB.FETCH_JIRA_PROJECTS_FOR_SITE).ERROR]: (state, { payload: payload })=>({
            ...state,
            projects: {
                ...state.projects,
                ...payload
            }
        }),
    // Jira issue creation metadata
    [(0, $g7vJB.FETCH_JIRA_ISSUE_CREATION_METADATA).REQUEST]: (state, { payload: payload })=>({
            ...state,
            issueCreationMetadata: {
                ...state.issueCreationMetadata,
                [payload.cloudId]: {
                    ...state.issueCreationMetadata[payload.cloudId] || {},
                    [payload.projectId]: {
                        issueTypes: [],
                        fetchedStatus: (0, $90kWr.LoadingStatus).Fetching
                    }
                }
            }
        }),
    [(0, $g7vJB.FETCH_JIRA_ISSUE_CREATION_METADATA).SUCCESS]: (state, { payload: payload })=>({
            ...state,
            issueCreationMetadata: {
                ...state.issueCreationMetadata,
                [payload.cloudId]: {
                    ...state.issueCreationMetadata[payload.cloudId] || {},
                    [payload.projectId]: {
                        issueTypes: payload.issueTypes,
                        fetchedStatus: (0, $90kWr.LoadingStatus).Success
                    }
                }
            }
        }),
    [(0, $g7vJB.FETCH_JIRA_ISSUE_CREATION_METADATA).ERROR]: (state, { payload: payload })=>({
            ...state,
            issueCreationMetadata: {
                ...state.issueCreationMetadata,
                [payload.cloudId]: {
                    ...state.issueCreationMetadata[payload.cloudId] || {},
                    [payload.projectId]: {
                        issueTypes: [],
                        fetchedStatus: payload.fetchedStatus
                    }
                }
            }
        }),
    // Create issue form
    [(0, $g7vJB.CREATE_JIRA_ISSUE_FORM_VISIBILITY_CHANGE)] (state, { payload: payload }) {
        const { commentId: commentId, isVisible: isVisible } = payload;
        return {
            ...state,
            createForm: {
                ...state.createForm,
                [commentId]: {
                    isVisible: isVisible
                }
            }
        };
    },
    [(0, $6D21P.TOGGLE_CREATE_COMMENT_TASK_INPUT)] (state, { payload: payload }) {
        // Hides the create task input if the create Jira issue input becomes visible
        const { commentId: commentId, isCreating: isTaskInputVisible } = payload;
        if (!isTaskInputVisible) return state;
        return {
            ...state,
            createForm: {
                ...state.createForm,
                [commentId]: {
                    isVisible: false
                }
            }
        };
    },
    [(0, $g7vJB.CREATE_JIRA_ISSUE).REQUEST]: (state)=>({
            ...state,
            jiraTabCreateForm: {
                failureReason: (0, $hahvB.IssueCreationFailureReason).None,
                status: (0, $90kWr.LoadingStatus).Fetching
            }
        }),
    [(0, $g7vJB.CREATE_JIRA_ISSUE).SUCCESS]: (state, { payload: payload })=>({
            ...state,
            jiraTabCreateForm: {
                failureReason: (0, $hahvB.IssueCreationFailureReason).None,
                status: (0, $90kWr.LoadingStatus).Success,
                issue: payload
            }
        }),
    [(0, $g7vJB.CREATE_JIRA_ISSUE).ERROR] (state, { payload: payload }) {
        const { failureReason: failureReason = (0, $hahvB.IssueCreationFailureReason).Unknown } = payload;
        return {
            ...state,
            jiraTabCreateForm: {
                failureReason: failureReason,
                status: (0, $90kWr.LoadingStatus).Failed
            }
        };
    },
    [(0, $g7vJB.CREATE_PR_JIRA_ISSUE).REQUEST] (state, { payload: payload }) {
        const { commentId: commentId } = payload;
        const form = state.createForm[commentId] || {};
        return {
            ...state,
            createForm: {
                ...state.createForm,
                [commentId]: {
                    ...form,
                    status: (0, $90kWr.LoadingStatus).Fetching,
                    failureReason: (0, $hahvB.IssueCreationFailureReason).None
                }
            }
        };
    },
    [(0, $g7vJB.CREATE_PR_JIRA_ISSUE).SUCCESS] (state, { payload: payload }) {
        const { commentId: commentId } = payload;
        const form = state.createForm[commentId] || {};
        return {
            ...state,
            createForm: {
                ...state.createForm,
                [commentId]: {
                    ...form,
                    status: (0, $90kWr.LoadingStatus).Success
                }
            }
        };
    },
    [(0, $g7vJB.CREATE_PR_JIRA_ISSUE).ERROR] (state, { payload: payload }) {
        const { commentId: commentId, failureReason: failureReason = (0, $hahvB.IssueCreationFailureReason).Unknown } = payload;
        const form = state.createForm[commentId] || {};
        return {
            ...state,
            createForm: {
                ...state.createForm,
                [commentId]: {
                    ...form,
                    failureReason: failureReason,
                    status: (0, $90kWr.LoadingStatus).Failed
                }
            }
        };
    },
    [(0, $g7vJB.SET_PR_FORM_ERROR_STATE)] (state, { payload: payload }) {
        const { commentId: commentId, failureReason: failureReason, status: status } = payload;
        const form = state.createForm[commentId] || {};
        return {
            ...state,
            createForm: {
                ...state.createForm,
                [commentId]: {
                    ...form,
                    failureReason: failureReason,
                    status: status
                }
            }
        };
    },
    [(0, $g7vJB.SET_FORM_ERROR_STATE)] (state, { payload: payload }) {
        const { failureReason: failureReason, status: status } = payload;
        return {
            ...state,
            jiraTabCreateForm: {
                ...state.jiraTabCreateForm,
                failureReason: failureReason,
                status: status
            }
        };
    },
    // Onboarding viewed status
    [(0, $g7vJB.FETCH_CREATE_JIRA_ISSUE_ONBOARDING_VIEWED).SUCCESS] (state, { payload: payload }) {
        return {
            ...state,
            onboarding: {
                viewed: payload,
                fetchedStatus: (0, $90kWr.LoadingStatus).Success
            }
        };
    },
    [(0, $g7vJB.UPDATE_CREATE_JIRA_ISSUE_ONBOARDING_VIEWED).SUCCESS] (state, { payload: payload }) {
        return {
            ...state,
            onboarding: {
                viewed: payload,
                fetchedStatus: (0, $90kWr.LoadingStatus).Success
            }
        };
    },
    [(0, $g7vJB.UNLOAD_CREATE_JIRA_ISSUE)] () {
        return $0b80b1738f030ba1$var$initialState;
    },
    // User preferences
    [(0, $g7vJB.FETCH_CREATE_JIRA_ISSUE_PREFERENCES).SUCCESS] (state, { payload: payload }) {
        return {
            ...state,
            preferences: {
                value: payload,
                fetchedStatus: (0, $90kWr.LoadingStatus).Success
            }
        };
    },
    [(0, $g7vJB.FETCH_CREATE_JIRA_ISSUE_PREFERENCES).ERROR] (state, { payload: payload }) {
        return {
            ...state,
            preferences: {
                value: payload,
                fetchedStatus: (0, $90kWr.LoadingStatus).Failed
            }
        };
    },
    [(0, $g7vJB.FETCH_JIRA_TAB_CREATE_ISSUE_USER_PREFERENCE).SUCCESS] (state, { payload: payload }) {
        return {
            ...state,
            preferences: {
                value: payload,
                fetchedStatus: (0, $90kWr.LoadingStatus).Success
            }
        };
    },
    [(0, $g7vJB.FETCH_JIRA_TAB_CREATE_ISSUE_USER_PREFERENCE).ERROR] (state, { payload: payload }) {
        return {
            ...state,
            preferences: {
                value: payload,
                fetchedStatus: (0, $90kWr.LoadingStatus).Failed
            }
        };
    },
    [(0, $g7vJB.UPDATE_CREATE_JIRA_ISSUE_PREFERENCES).SUCCESS] (state, { payload: payload }) {
        return {
            ...state,
            preferences: {
                value: payload,
                fetchedStatus: (0, $90kWr.LoadingStatus).Success
            }
        };
    },
    [(0, $g7vJB.CREATE_JIRA_ISSUE_SELECTED_PROJECT)] (state, { payload: payload }) {
        return {
            ...state,
            preferences: {
                value: payload,
                fetchedStatus: (0, $90kWr.LoadingStatus).Success
            }
        };
    }
});

});

parcelRegister("k6kNf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7602f500f186cf0b$export$2e2bcd8739ae039; });

var $90kWr = parcelRequire("90kWr");

var $gsXeO = parcelRequire("gsXeO");
parcelRequire("erZj9");
var $9KZ2S = parcelRequire("9KZ2S");
const $7602f500f186cf0b$var$initialState = {
    availableSites: [],
    availableSitesLoadingStatus: (0, $90kWr.LoadingStatus).Before,
    jiraIssues: [],
    jiraIssuesLoadingStatus: (0, $90kWr.LoadingStatus).Before,
    jiraIssuesCount: 0,
    devActivity: {}
};
var $7602f500f186cf0b$export$2e2bcd8739ae039 = (0, $gsXeO.default)($7602f500f186cf0b$var$initialState, {
    [(0, $9KZ2S.INIT_DASHBOARD_JIRA).REQUEST]: (state)=>({
            ...state,
            selectedSite: undefined,
            availableSites: [],
            availableSitesLoadingStatus: (0, $90kWr.LoadingStatus).Fetching,
            devActivity: {}
        }),
    [(0, $9KZ2S.INIT_DASHBOARD_JIRA).SUCCESS]: (state, { payload: payload })=>({
            ...state,
            selectedSite: payload.selectedSite,
            availableSites: payload.availableSites,
            availableSitesLoadingStatus: (0, $90kWr.LoadingStatus).Success
        }),
    [(0, $9KZ2S.INIT_DASHBOARD_JIRA).ERROR]: (state)=>({
            ...state,
            selectedSite: undefined,
            availableSites: [],
            availableSitesLoadingStatus: (0, $90kWr.LoadingStatus).Failed
        }),
    [(0, $9KZ2S.SET_DASHBOARD_JIRA_DEFAULT_CLOUD_ID)]: (state, { payload: payload })=>({
            ...state,
            defaultSiteCloudId: payload
        }),
    [(0, $9KZ2S.ON_DASHBOARD_JIRA_SITE_CHANGE)]: (state, { payload: payload })=>({
            ...state,
            selectedSite: payload,
            // Reset the state when the selected site changes
            jiraIssues: [],
            jiraIssuesLoadingStatus: (0, $90kWr.LoadingStatus).Before,
            jiraIssuesCount: 0,
            jiraIssuesJql: undefined
        }),
    [(0, $9KZ2S.FETCH_DASHBOARD_JIRA_ISSUES).REQUEST]: (state)=>({
            ...state,
            jiraIssues: [],
            jiraIssuesLoadingStatus: (0, $90kWr.LoadingStatus).Fetching,
            jiraIssuesCount: 0,
            jiraIssuesJql: undefined
        }),
    [(0, $9KZ2S.FETCH_DASHBOARD_JIRA_ISSUES).SUCCESS]: (state, { payload: payload })=>({
            ...state,
            jiraIssues: payload.jiraIssues,
            jiraIssuesLoadingStatus: (0, $90kWr.LoadingStatus).Success,
            jiraIssuesCount: payload.jiraIssuesCount,
            jiraIssuesJql: payload.jiraIssuesJql
        }),
    [(0, $9KZ2S.FETCH_DASHBOARD_JIRA_ISSUES).ERROR]: (state)=>({
            ...state,
            jiraIssues: [],
            jiraIssuesLoadingStatus: (0, $90kWr.LoadingStatus).Failed,
            jiraIssuesCount: 0,
            jiraIssuesJql: undefined
        }),
    [(0, $9KZ2S.FETCH_DASHBOARD_DEV_ACTIVITY).SUCCESS]: (state, { payload: payload })=>{
        // Update existing dev activity data for sites where we already had data,
        // instead of overwriting all the data for a site (which the normal shallow
        // spread would do). That means if you switch back and forth between sites,
        // the dev activity shows up immediately after issues are loaded.
        const devActivity = {
            ...state.devActivity
        };
        Object.keys(payload).forEach((cloudId)=>{
            devActivity[cloudId] = {
                ...devActivity[cloudId],
                ...payload[cloudId]
            };
        });
        return {
            ...state,
            devActivity: devActivity
        };
    }
});

});

parcelRegister("21sfB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $219fc33f2ee18417$export$2e2bcd8739ae039; });

var $90kWr = parcelRequire("90kWr");

var $gsXeO = parcelRequire("gsXeO");
parcelRequire("erZj9");
var $5KwLw = parcelRequire("5KwLw");

var $hahvB = parcelRequire("hahvB");
const $219fc33f2ee18417$export$d4c72bab9d6cc13a = {
    activeStepIndex: 0,
    availableSites: [],
    availableSitesFetchedStatus: (0, $90kWr.LoadingStatus).Before,
    appInstalledStatus: (0, $hahvB.AppInstalledStatus).Before,
    selectedSiteCloudId: undefined,
    projectName: "",
    projectKey: ""
};
var $219fc33f2ee18417$export$2e2bcd8739ae039 = (0, $gsXeO.default)($219fc33f2ee18417$export$d4c72bab9d6cc13a, {
    [(0, $5KwLw.GO_TO_STEP)]: (state, { payload: activeStepIndex })=>({
            ...state,
            activeStepIndex: activeStepIndex
        }),
    [(0, $5KwLw.RESET_JIRA_MIGRATION_STATE)]: (state)=>({
            ...$219fc33f2ee18417$export$d4c72bab9d6cc13a,
            // We don't want to reset the app installed status.
            appInstalledStatus: state.appInstalledStatus
        }),
    // Install addon
    [(0, $5KwLw.INSTALL_ADDON_JIRA_MIGRATION).REQUEST]: (state)=>({
            ...state,
            appInstalledStatus: (0, $hahvB.AppInstalledStatus).Installing
        }),
    [(0, $5KwLw.INSTALL_ADDON_JIRA_MIGRATION).SUCCESS]: (state)=>({
            ...state,
            appInstalledStatus: (0, $hahvB.AppInstalledStatus).Installed
        }),
    [(0, $5KwLw.INSTALL_ADDON_JIRA_MIGRATION).ERROR]: (state)=>({
            ...state,
            appInstalledStatus: (0, $hahvB.AppInstalledStatus).FailedToInstall
        }),
    // Fetch available sites
    [(0, $5KwLw.FETCH_SITES_FOR_JIRA_MIGRATION).REQUEST]: (state)=>({
            ...state,
            availableSites: [],
            availableSitesFetchedStatus: (0, $90kWr.LoadingStatus).Fetching
        }),
    [(0, $5KwLw.FETCH_SITES_FOR_JIRA_MIGRATION).SUCCESS]: (state, { payload: payload })=>({
            ...state,
            availableSites: payload,
            availableSitesFetchedStatus: (0, $90kWr.LoadingStatus).Success
        }),
    [(0, $5KwLw.FETCH_SITES_FOR_JIRA_MIGRATION).ERROR]: (state)=>({
            ...state,
            availableSites: [],
            availableSitesFetchedStatus: (0, $90kWr.LoadingStatus).Failed
        }),
    [(0, $5KwLw.SET_SELECTED_SITE)]: (state, { payload: selectedSiteCloudId })=>({
            ...state,
            selectedSiteCloudId: selectedSiteCloudId
        }),
    [(0, $5KwLw.SET_PROJECT)]: (state, { payload: project })=>({
            ...state,
            projectKey: project.projectKey,
            projectName: project.projectName
        }),
    [(0, $5KwLw.FETCH_ISSUE_MIGRATION_TO_JIRA_STATUS).SUCCESS]: (state, { payload: migrationProgress })=>({
            ...state,
            migrationProgress: migrationProgress
        }),
    [(0, $5KwLw.START_ISSUE_MIGRATION_TO_JIRA).REQUEST]: (state)=>({
            ...state,
            migrationStarted: {
                status: (0, $90kWr.LoadingStatus).Fetching
            }
        }),
    [(0, $5KwLw.START_ISSUE_MIGRATION_TO_JIRA).SUCCESS]: (state)=>({
            ...state,
            migrationStarted: {
                status: (0, $90kWr.LoadingStatus).Success
            }
        }),
    [(0, $5KwLw.START_ISSUE_MIGRATION_TO_JIRA).ERROR]: (state, { payload: statusCode })=>({
            ...state,
            migrationStarted: {
                status: (0, $90kWr.LoadingStatus).Failed,
                statusCode: statusCode
            }
        }),
    // Fetch migration logs
    [(0, $5KwLw.FETCH_ISSUE_MIGRATION_TO_JIRA_LOGS).REQUEST]: (state)=>({
            ...state,
            migrationLogs: {
                status: (0, $90kWr.LoadingStatus).Fetching
            }
        }),
    [(0, $5KwLw.FETCH_ISSUE_MIGRATION_TO_JIRA_LOGS).SUCCESS]: (state, { payload: logs })=>({
            ...state,
            migrationLogs: {
                status: (0, $90kWr.LoadingStatus).Success,
                logs: logs
            }
        }),
    [(0, $5KwLw.FETCH_ISSUE_MIGRATION_TO_JIRA_LOGS).ERROR]: (state)=>({
            ...state,
            migrationLogs: {
                status: (0, $90kWr.LoadingStatus).Failed
            }
        })
});

});

parcelRegister("5ji45", function(module, exports) {

$parcel$export(module.exports, "emptyFilterState", function () { return $76d8f769abf72ca0$export$cbc1e9f967e76825; });
$parcel$export(module.exports, "default", function () { return $76d8f769abf72ca0$export$2e2bcd8739ae039; });

var $fapR5 = parcelRequire("fapR5");

var $90kWr = parcelRequire("90kWr");

var $gsXeO = parcelRequire("gsXeO");
parcelRequire("erZj9");
var $3OKoD = parcelRequire("3OKoD");

var $hahvB = parcelRequire("hahvB");

var $9Og0J = parcelRequire("9Og0J");
const $76d8f769abf72ca0$export$cbc1e9f967e76825 = {
    siteCloudId: "",
    projectIds: [],
    issueCategories: [],
    textFilterQuery: "",
    assignees: [],
    sort: {
        field: "updated",
        order: "DESC"
    },
    currentPage: 1
};
const $76d8f769abf72ca0$export$76f9cf2ec852a055 = {
    ...$76d8f769abf72ca0$export$cbc1e9f967e76825,
    issueCategories: [
        (0, $hahvB.IssueCategory).Todo,
        (0, $hahvB.IssueCategory).InProgress
    ]
};
const $76d8f769abf72ca0$export$aec3dd404fad8512 = {
    selectedProject: undefined
};
const $76d8f769abf72ca0$export$d4c72bab9d6cc13a = {
    appInstalledStatus: (0, $hahvB.AppInstalledStatus).Before,
    emptyStateKind: (0, $hahvB.EmptyStateKind).Before,
    projectAssociations: [],
    relevantProjectsFetchedStatus: (0, $90kWr.LoadingStatus).Before,
    relevantSites: [],
    relevantSitesFetchedStatus: (0, $90kWr.LoadingStatus).Before,
    sites: [],
    sitesFetchedStatus: (0, $90kWr.LoadingStatus).Before,
    jiraRelevantIssuesFetchedStatus: (0, $90kWr.LoadingStatus).Before,
    jiraRelevantIssues: [],
    jiraRelevantIssuesPages: 0,
    devActivity: {},
    workspacePermission: undefined,
    workspacePermissionFetchedStatus: (0, $90kWr.LoadingStatus).Before,
    filterState: $76d8f769abf72ca0$export$76f9cf2ec852a055,
    assignees: [],
    assigneesFetchedStatus: (0, $90kWr.LoadingStatus).Before,
    filterPreferencesFetchedStatus: (0, $90kWr.LoadingStatus).Before,
    isManageProjectsDialogOpen: false,
    isProjectsMenuOpen: false,
    projectToUnlink: undefined,
    linkJiraProjectStatus: (0, $90kWr.LoadingStatus).Before,
    unlinkJiraProjectStatus: (0, $90kWr.LoadingStatus).Before,
    projects: {},
    isCreateIssueDialogOpen: false
};
var $76d8f769abf72ca0$export$2e2bcd8739ae039 = (0, $gsXeO.default)($76d8f769abf72ca0$export$d4c72bab9d6cc13a, {
    [(0, $3OKoD.HYDRATE_JIRA_DATA).REQUEST]: (state)=>({
            ...state,
            appInstalledStatus: (0, $hahvB.AppInstalledStatus).Fetching
        }),
    [(0, $3OKoD.HYDRATE_JIRA_DATA).SUCCESS]: (state, { payload: payload })=>({
            ...state,
            appInstalledStatus: payload.appInstalled ? (0, $hahvB.AppInstalledStatus).Installed : (0, $hahvB.AppInstalledStatus).NotInstalled
        }),
    [(0, $3OKoD.HYDRATE_JIRA_DATA).ERROR]: (state)=>({
            ...state,
            appInstalledStatus: (0, $hahvB.AppInstalledStatus).FailedToFetch
        }),
    [(0, $3OKoD.INSTALL_ADDON_JIRA_TAB).REQUEST]: (state)=>({
            ...state,
            appInstalledStatus: (0, $hahvB.AppInstalledStatus).Installing
        }),
    [(0, $3OKoD.INSTALL_ADDON_JIRA_TAB).SUCCESS]: (state)=>({
            ...state,
            appInstalledStatus: (0, $hahvB.AppInstalledStatus).Installed
        }),
    [(0, $3OKoD.INSTALL_ADDON_JIRA_TAB).ERROR]: (state)=>({
            ...state,
            appInstalledStatus: (0, $hahvB.AppInstalledStatus).FailedToInstall
        }),
    // Jira sites
    [(0, $3OKoD.FETCH_JIRA_SITES).REQUEST]: (state)=>({
            ...state,
            sitesFetchedStatus: (0, $90kWr.LoadingStatus).Fetching,
            sites: []
        }),
    [(0, $3OKoD.FETCH_JIRA_SITES).SUCCESS]: (state, { payload: payload })=>({
            ...state,
            sitesFetchedStatus: (0, $90kWr.LoadingStatus).Success,
            sites: payload
        }),
    [(0, $3OKoD.FETCH_JIRA_SITES).ERROR]: (state)=>({
            ...state,
            sitesFetchedStatus: (0, $90kWr.LoadingStatus).Failed,
            sites: []
        }),
    // Jira projects
    [(0, $3OKoD.FETCH_JIRA_PROJECTS).REQUEST]: (state, { payload: payload })=>({
            ...state,
            projects: {
                ...state.projects,
                [payload.cloudId]: {
                    fetchedStatus: (0, $90kWr.LoadingStatus).Fetching,
                    projects: []
                }
            }
        }),
    [(0, $3OKoD.FETCH_JIRA_PROJECTS).SUCCESS]: (state, { payload: payload })=>({
            ...state,
            projects: {
                ...state.projects,
                ...payload
            }
        }),
    [(0, $3OKoD.FETCH_JIRA_PROJECTS).ERROR]: (state, { payload: payload })=>({
            ...state,
            projects: {
                ...state.projects,
                [payload.cloudId]: {
                    fetchedStatus: (0, $90kWr.LoadingStatus).Failed,
                    projects: []
                }
            }
        }),
    // Jira relevant issues
    [(0, $3OKoD.FETCH_JIRA_RELEVANT_ISSUES).REQUEST]: (state)=>({
            ...state,
            jiraRelevantIssuesFetchedStatus: (0, $90kWr.LoadingStatus).Fetching,
            jiraRelevantIssues: [],
            devActivity: {}
        }),
    [(0, $3OKoD.FETCH_JIRA_RELEVANT_ISSUES).SUCCESS]: (state, { payload: payload })=>({
            ...state,
            jiraRelevantIssuesFetchedStatus: (0, $90kWr.LoadingStatus).Success,
            jiraRelevantIssues: payload.values,
            jiraRelevantIssuesPages: Math.ceil(payload.size / payload.pagelen)
        }),
    [(0, $3OKoD.FETCH_JIRA_RELEVANT_ISSUES).ERROR]: (state)=>({
            ...state,
            jiraRelevantIssuesFetchedStatus: (0, $90kWr.LoadingStatus).Failed,
            jiraRelevantIssues: [],
            devActivity: {}
        }),
    // Dev activity (for icon with branch/pull request status for issues)
    [(0, $3OKoD.FETCH_DEV_ACTIVITY).REQUEST]: (state)=>({
            ...state,
            devActivity: {}
        }),
    [(0, $3OKoD.FETCH_DEV_ACTIVITY).SUCCESS]: (state, { payload: payload })=>{
        // Update existing dev activity data for sites where we already had data,
        // instead of overwriting all the data for a site (which the normal shallow
        // spread would do). That means if you switch back and forth between pages,
        // the dev activity shows up immediately after issues are loaded.
        const devActivity = {
            ...state.devActivity
        };
        Object.keys(payload).forEach((cloudId)=>{
            devActivity[cloudId] = {
                ...devActivity[cloudId],
                ...payload[cloudId]
            };
        });
        return {
            ...state,
            devActivity: devActivity
        };
    },
    // Relevant Jira sites
    [(0, $3OKoD.FETCH_RELEVANT_JIRA_SITES).REQUEST]: (state)=>({
            ...state,
            relevantSitesFetchedStatus: (0, $90kWr.LoadingStatus).Fetching,
            relevantSites: []
        }),
    [(0, $3OKoD.FETCH_RELEVANT_JIRA_SITES).SUCCESS]: (state, { payload: { values: values, hasPermission: hasPermission } })=>({
            ...state,
            relevantSitesFetchedStatus: hasPermission ? (0, $90kWr.LoadingStatus).Success : (0, $90kWr.LoadingStatus).Forbidden,
            relevantSites: values
        }),
    [(0, $3OKoD.FETCH_RELEVANT_JIRA_SITES).ERROR]: (state)=>({
            ...state,
            relevantSitesFetchedStatus: (0, $90kWr.LoadingStatus).Failed,
            relevantSites: []
        }),
    // Jira relevant projects
    [(0, $3OKoD.FETCH_JIRA_RELEVANT_PROJECTS).REQUEST]: (state)=>({
            ...state,
            relevantProjectsFetchedStatus: (0, $90kWr.LoadingStatus).Fetching,
            projectAssociations: []
        }),
    [(0, $3OKoD.FETCH_JIRA_RELEVANT_PROJECTS).SUCCESS]: (state, { payload: { projectAssociations: projectAssociations, projectIds: projectIds, hasPermission: hasPermission } })=>{
        return {
            ...state,
            filterState: {
                ...state.filterState,
                projectIds: projectIds
            },
            relevantProjectsFetchedStatus: hasPermission ? (0, $90kWr.LoadingStatus).Success : (0, $90kWr.LoadingStatus).Forbidden,
            projectAssociations: projectAssociations
        };
    },
    [(0, $3OKoD.FETCH_JIRA_RELEVANT_PROJECTS).ERROR]: (state)=>({
            ...state,
            relevantProjectsFetchedStatus: (0, $90kWr.LoadingStatus).Failed,
            projectAssociations: []
        }),
    // Jira relevant assignees
    [(0, $3OKoD.FETCH_JIRA_ASSIGNEES).REQUEST]: (state)=>({
            ...state,
            assigneesFetchedStatus: (0, $90kWr.LoadingStatus).Before,
            assignees: []
        }),
    [(0, $3OKoD.FETCH_JIRA_ASSIGNEES).SUCCESS]: (state, { payload: { values: values } })=>({
            ...state,
            assigneesFetchedStatus: (0, $90kWr.LoadingStatus).Success,
            assignees: values
        }),
    [(0, $3OKoD.FETCH_JIRA_ASSIGNEES).ERROR]: (state)=>({
            ...state,
            assigneesFetchedStatus: (0, $90kWr.LoadingStatus).Failed,
            assignees: []
        }),
    // Filters user preference
    [(0, $3OKoD.FETCH_JIRA_TAB_FILTERS_USER_PREFERENCE).REQUEST]: (state)=>({
            ...state,
            filterPreferencesFetchedStatus: (0, $90kWr.LoadingStatus).Fetching
        }),
    [(0, $3OKoD.FETCH_JIRA_TAB_FILTERS_USER_PREFERENCE).SUCCESS]: (state)=>({
            ...state,
            filterPreferencesFetchedStatus: (0, $90kWr.LoadingStatus).Success
        }),
    [(0, $3OKoD.FETCH_JIRA_TAB_FILTERS_USER_PREFERENCE).ERROR]: (state)=>({
            ...state,
            filterPreferencesFetchedStatus: (0, $90kWr.LoadingStatus).Failed
        }),
    [(0, $3OKoD.JIRA_TAB_FILTERS_USER_PREFERENCE_NOT_REQUIRED)]: (state)=>({
            ...state,
            filterPreferencesFetchedStatus: "NOT_REQUIRED"
        }),
    // Workspace permission
    [(0, $3OKoD.FETCH_WORKSPACE_PERMISSION).REQUEST]: (state)=>({
            ...state,
            workspacePermission: undefined,
            workspacePermissionFetchedStatus: (0, $90kWr.LoadingStatus).Fetching
        }),
    [(0, $3OKoD.FETCH_WORKSPACE_PERMISSION).SUCCESS]: (state, { payload: payload })=>({
            ...state,
            workspacePermission: payload[0] && payload[0].permission,
            workspacePermissionFetchedStatus: (0, $90kWr.LoadingStatus).Success
        }),
    [(0, $3OKoD.FETCH_WORKSPACE_PERMISSION).ERROR]: (state)=>({
            ...state,
            workspacePermission: undefined,
            workspacePermissionFetchedStatus: (0, $90kWr.LoadingStatus).Failed
        }),
    [(0, $3OKoD.FILTER_STATE).SAVE]: (state, { payload: payload })=>({
            ...state,
            filterState: {
                ...state.filterState,
                ...payload
            }
        }),
    [(0, $3OKoD.SET_EMPTY_STATE_KIND)]: (state, { payload: payload })=>({
            ...state,
            emptyStateKind: payload
        }),
    [(0, $3OKoD.RESET_STATE)]: ()=>({
            ...$76d8f769abf72ca0$export$d4c72bab9d6cc13a
        }),
    [(0, $3OKoD.MANAGE_PROJECTS_DIALOG_OPEN_CHANGE)]: (state, { payload: payload })=>({
            ...state,
            isManageProjectsDialogOpen: payload
        }),
    [(0, $3OKoD.PROJECTS_MENU_OPEN_CHANGE)]: (state, { payload: payload })=>({
            ...state,
            isProjectsMenuOpen: payload
        }),
    [(0, $3OKoD.UNLINK_PROJECT_DIALOG_OPEN_CHANGE)]: (state, { payload: payload })=>({
            ...state,
            projectToUnlink: payload
        }),
    // Link Jira project
    [(0, $3OKoD.LINK_JIRA_PROJECT).REQUEST]: (state)=>({
            ...state,
            linkJiraProjectStatus: (0, $90kWr.LoadingStatus).Fetching
        }),
    [(0, $3OKoD.LINK_JIRA_PROJECT).SUCCESS]: (state)=>({
            ...state,
            linkJiraProjectStatus: (0, $90kWr.LoadingStatus).Success
        }),
    [(0, $3OKoD.LINK_JIRA_PROJECT).ERROR]: (state)=>({
            ...state,
            linkJiraProjectStatus: (0, $90kWr.LoadingStatus).Failed
        }),
    // Unlink Jira project
    [(0, $3OKoD.UNLINK_JIRA_PROJECT).REQUEST]: (state)=>({
            ...state,
            unlinkJiraProjectStatus: (0, $90kWr.LoadingStatus).Fetching
        }),
    [(0, $3OKoD.UNLINK_JIRA_PROJECT).SUCCESS]: (state)=>({
            ...state,
            unlinkJiraProjectStatus: (0, $90kWr.LoadingStatus).Success
        }),
    [(0, $3OKoD.UNLINK_JIRA_PROJECT).ERROR]: (state)=>({
            ...state,
            unlinkJiraProjectStatus: (0, $90kWr.LoadingStatus).Failed
        }),
    [(0, $3OKoD.UPDATE_RELEVANT_JIRA_PROJECTS)]: (state, { payload: payload })=>({
            ...state,
            projectAssociations: payload,
            relevantProjectsFetchedStatus: (0, $90kWr.LoadingStatus).Success
        }),
    [(0, $3OKoD.CREATE_ISSUE_DIALOG_OPEN_CHANGE)]: (state, { payload: payload })=>({
            ...state,
            isCreateIssueDialogOpen: payload
        }),
    [(0, $3OKoD.SET_ISSUE_ASSIGNEE).SUCCESS]: (state, { payload: payload })=>{
        const currentIssues = (0, $fapR5.default)(state.jiraRelevantIssues);
        const selectedIssue = currentIssues.find((issue)=>issue.key === payload.issueKey);
        const currentSort = state.filterState.sort;
        const sortOrderMultiplier = currentSort.order === (0, $9Og0J.SORT_ORDER).DESC ? -1 : 1;
        selectedIssue.assignee = payload.currentJiraUser;
        selectedIssue.updated = new Date().toISOString();
        if (currentSort.field === "assignee") currentIssues.sort((a, b)=>{
            var _a$assignee, _b$assignee;
            if (((_a$assignee = a.assignee) === null || _a$assignee === void 0 ? void 0 : _a$assignee.accountId) === ((_b$assignee = b.assignee) === null || _b$assignee === void 0 ? void 0 : _b$assignee.accountId)) return 0;
            else if (!a.assignee) return sortOrderMultiplier;
            else if (!b.assignee) return -sortOrderMultiplier;
            return sortOrderMultiplier * a.assignee.displayName.localeCompare(b.assignee.displayName);
        });
        else if (currentSort.field === "updated") currentIssues.sort((a, b)=>{
            if (a.updated === b.updated) return 0;
            else if (!a.updated) return sortOrderMultiplier;
            else if (!b.updated) return -sortOrderMultiplier;
            return sortOrderMultiplier * (new Date(a.updated) > new Date(b.updated) ? 1 : -1);
        });
        return {
            ...state,
            jiraRelevantIssues: currentIssues
        };
    }
});

});

parcelRegister("7n0YR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11647932bbb7f5b0$export$2e2bcd8739ae039; });

var $90kWr = parcelRequire("90kWr");

var $gsXeO = parcelRequire("gsXeO");
parcelRequire("erZj9");
var $fYcHx = parcelRequire("fYcHx");
const $11647932bbb7f5b0$var$initialState = {
    jiraIssues: [],
    jiraIssuesFetchedStatus: (0, $90kWr.LoadingStatus).Before,
    issueTransitionFormData: [],
    transitionStatus: (0, $90kWr.LoadingStatus).Before,
    issueTransitionPreference: undefined,
    issueTransitionPreferenceFetchedStatus: (0, $90kWr.LoadingStatus).Before
};
var $11647932bbb7f5b0$export$2e2bcd8739ae039 = (0, $gsXeO.default)($11647932bbb7f5b0$var$initialState, {
    [(0, $fYcHx.FETCH_TRANSITION_USER_PREFERENCE).SUCCESS]: (state, { payload: payload })=>{
        return {
            ...state,
            issueTransitionPreferenceFetchedStatus: (0, $90kWr.LoadingStatus).Success,
            issueTransitionPreference: payload
        };
    },
    [(0, $fYcHx.FETCH_TRANSITION_USER_PREFERENCE).REQUEST]: (state)=>{
        return {
            ...state,
            issueTransitionPreferenceFetchedStatus: (0, $90kWr.LoadingStatus).Fetching,
            issueTransitionPreference: undefined
        };
    },
    [(0, $fYcHx.FETCH_TRANSITION_USER_PREFERENCE).ERROR]: (state)=>{
        return {
            ...state,
            issueTransitionPreferenceFetchedStatus: (0, $90kWr.LoadingStatus).Failed,
            issueTransitionPreference: undefined
        };
    },
    [(0, $fYcHx.FETCH_PULL_REQUEST_JIRA_ISSUES).SUCCESS]: (state, { payload: payload })=>{
        return {
            ...state,
            jiraIssuesFetchedStatus: (0, $90kWr.LoadingStatus).Success,
            jiraIssues: payload
        };
    },
    [(0, $fYcHx.FETCH_PULL_REQUEST_JIRA_ISSUES).REQUEST]: (state)=>{
        return {
            ...state,
            jiraIssuesFetchedStatus: (0, $90kWr.LoadingStatus).Before,
            jiraIssues: []
        };
    },
    [(0, $fYcHx.FETCH_PULL_REQUEST_JIRA_ISSUES).ERROR]: (state)=>({
            ...state,
            jiraIssuesFetchedStatus: (0, $90kWr.LoadingStatus).Failed,
            jiraIssues: []
        }),
    [(0, $fYcHx.FETCH_AVAILABLE_ISSUE_TRANSITIONS).SUCCESS]: (state, { payload: payload })=>{
        const { updatedTransitionForm: updatedTransitionForm, index: index } = payload;
        const updatedIssueTransitionFormData = state.issueTransitionFormData;
        updatedIssueTransitionFormData[index] = updatedTransitionForm;
        return {
            ...state,
            issueTransitionFormData: updatedIssueTransitionFormData
        };
    },
    [(0, $fYcHx.FETCH_AVAILABLE_ISSUE_TRANSITIONS).REQUEST]: (state, { payload: payload })=>{
        return {
            ...state,
            issueTransitionFormData: state.issueTransitionFormData.map((row, i)=>i === payload ? {
                    ...row,
                    availableIssueTransitions: [],
                    availableIssueTransitionsFetchedStatus: (0, $90kWr.LoadingStatus).Before
                } : row)
        };
    },
    [(0, $fYcHx.FETCH_AVAILABLE_ISSUE_TRANSITIONS).ERROR]: (state, { payload: payload })=>{
        return {
            ...state,
            issueTransitionFormData: state.issueTransitionFormData.map((row, i)=>i === payload ? {
                    ...row,
                    availableIssueTransitions: [],
                    availableIssueTransitionsFetchedStatus: (0, $90kWr.LoadingStatus).Failed
                } : row)
        };
    },
    [(0, $fYcHx.UPDATE_JIRA_ISSUES_LIST_AFTER_CREATION)]: (state, { payload: payload })=>({
            ...state,
            jiraIssues: [
                ...state.jiraIssues,
                payload
            ]
        }),
    [(0, $fYcHx.UPDATE_ISSUE_TRANSITION)]: (state, { payload: payload })=>({
            ...state,
            issueTransitionFormData: state.issueTransitionFormData.map((currentTransition, i)=>i === payload.index ? payload.newTransition : currentTransition)
        }),
    [(0, $fYcHx.INIT_ISSUE_TRANSITIONS)]: (state, { payload: payload })=>({
            ...state,
            issueTransitionFormData: payload
        }),
    [(0, $fYcHx.TRANSITION_ISSUES).REQUEST]: (state)=>({
            ...state,
            transitionStatus: (0, $90kWr.LoadingStatus).Before
        }),
    [(0, $fYcHx.TRANSITION_ISSUES).SUCCESS]: (state)=>({
            ...state,
            transitionStatus: (0, $90kWr.LoadingStatus).Success
        }),
    [(0, $fYcHx.TRANSITION_ISSUES).ERROR]: (state)=>({
            ...state,
            transitionStatus: (0, $90kWr.LoadingStatus).Failed
        })
});

});


parcelRegister("g3kOv", function(module, exports) {

$parcel$export(module.exports, "registerShortcuts", function () { return $4aa7f45cdabfd38b$export$598ec0e6047cbdca; });
$parcel$export(module.exports, "unRegisterShortcuts", function () { return $4aa7f45cdabfd38b$export$cb8e9e171c4799cb; });
$parcel$export(module.exports, "reducer", function () { return $4aa7f45cdabfd38b$export$1650419e431d3ba3; });
// Action Types
const $4aa7f45cdabfd38b$var$REGISTER_SHORTCUTS = "keyboard/REGISTER_SHORTCUTS";
const $4aa7f45cdabfd38b$var$UNREGISTER_SHORTCUTS = "keyboard/UNREGISTER_SHORTCUTS";
const $4aa7f45cdabfd38b$export$598ec0e6047cbdca = (group)=>({
        type: $4aa7f45cdabfd38b$var$REGISTER_SHORTCUTS,
        payload: group
    });
const $4aa7f45cdabfd38b$export$cb8e9e171c4799cb = (groupId)=>({
        type: $4aa7f45cdabfd38b$var$UNREGISTER_SHORTCUTS,
        payload: groupId
    });
const $4aa7f45cdabfd38b$var$initialState = {};
const $4aa7f45cdabfd38b$export$1650419e431d3ba3 = (state = $4aa7f45cdabfd38b$var$initialState, action)=>{
    switch(action.type){
        case $4aa7f45cdabfd38b$var$REGISTER_SHORTCUTS:
            {
                const { groupId: groupId, groupTitle: groupTitle, groupWeight: groupWeight, shortcuts: shortcuts } = action.payload;
                return {
                    ...state,
                    [groupId]: {
                        groupTitle: groupTitle,
                        groupWeight: groupWeight,
                        shortcuts: shortcuts
                    }
                };
            }
        case $4aa7f45cdabfd38b$var$UNREGISTER_SHORTCUTS:
            {
                const groupId = action.payload;
                if (!state[groupId]) return state;
                const newState = {
                    ...state
                };
                delete newState[groupId];
                return newState;
            }
        default:
            return state;
    }
};

});

parcelRegister("fQtaJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e272def6af7fe451$export$2e2bcd8739ae039; });

var $jF3Yx = parcelRequire("jF3Yx");

var $1mRr2 = parcelRequire("1mRr2");

var $3WXeO = parcelRequire("3WXeO");

var $fNIYc = parcelRequire("fNIYc");
var $e272def6af7fe451$export$2e2bcd8739ae039 = (0, $jF3Yx.combineReducers)({
    repositories: $1mRr2.default,
    repositoriesLanguages: $3WXeO.default,
    section: $fNIYc.default
});

});
parcelRegister("1mRr2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3cc7e4ec9ae1eee$export$2e2bcd8739ae039; });

var $fjo3O = parcelRequire("fjo3O");

var $gsXeO = parcelRequire("gsXeO");
const $f3cc7e4ec9ae1eee$export$8327d3901076fd3a = {
    listItems: [],
    nextUrl: null,
    isLoading: false,
    isError: false,
    isPreRequestState: true,
    size: 0,
    pagelen: 0
};
var $f3cc7e4ec9ae1eee$export$2e2bcd8739ae039 = (0, $gsXeO.default)($f3cc7e4ec9ae1eee$export$8327d3901076fd3a, {
    [(0, $fjo3O.PageUnload)] () {
        return $f3cc7e4ec9ae1eee$export$8327d3901076fd3a;
    }
});

});
parcelRegister("fjo3O", function(module, exports) {

$parcel$export(module.exports, "FetchProfileRepositoriesLanguages", function () { return $b3ad5eb8721a83e4$export$4e6fb5f150e7dc3b; });
$parcel$export(module.exports, "PageUnload", function () { return $b3ad5eb8721a83e4$export$226b4e6021a9ee05; });
$parcel$export(module.exports, "pageUnload", function () { return $b3ad5eb8721a83e4$export$4e3385f910e23c73; });
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
const $b3ad5eb8721a83e4$export$4e6fb5f150e7dc3b = (0, $2MctD.createAsyncAction)("profile-repositories/FETCH_PROFILE_REPOSITORIES_LANGUAGES");
const $b3ad5eb8721a83e4$export$226b4e6021a9ee05 = `profile-repositories/PAGE_UNLOAD`;
const $b3ad5eb8721a83e4$export$4e3385f910e23c73 = ()=>({
        type: $b3ad5eb8721a83e4$export$226b4e6021a9ee05
    });

});


parcelRegister("3WXeO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73464ab25930c2c0$export$2e2bcd8739ae039; });

var $fjo3O = parcelRequire("fjo3O");

var $gsXeO = parcelRequire("gsXeO");
const $73464ab25930c2c0$export$327904739a888dc9 = {
    languages: [],
    isLoading: false,
    isError: false
};
var $73464ab25930c2c0$export$2e2bcd8739ae039 = (0, $gsXeO.default)($73464ab25930c2c0$export$327904739a888dc9, {
    [(0, $fjo3O.FetchProfileRepositoriesLanguages).REQUEST] (state) {
        return {
            ...state,
            isLoading: true
        };
    },
    [(0, $fjo3O.FetchProfileRepositoriesLanguages).SUCCESS] (state, action) {
        return {
            ...state,
            languages: action.payload,
            isLoading: false
        };
    },
    [(0, $fjo3O.FetchProfileRepositoriesLanguages).ERROR] (state) {
        return {
            ...state,
            isLoading: false,
            isError: true
        };
    }
});

});

parcelRegister("fNIYc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79726d6580a08da3$export$2e2bcd8739ae039; });
parcelRequire("6ePRx");
var $iaicX = parcelRequire("iaicX");

var $gsXeO = parcelRequire("gsXeO");
parcelRequire("6tQ7a");
var $k5ZQb = parcelRequire("k5ZQb");
const $79726d6580a08da3$var$initialState = {
    menuItems: [],
    currentUser: undefined,
    currentWorkspace: undefined,
    activeMenuItem: ""
};
var $79726d6580a08da3$export$2e2bcd8739ae039 = (0, $gsXeO.default)($79726d6580a08da3$var$initialState, {
    [(0, $k5ZQb.LoadProfilePage).REQUEST] (state) {
        return {
            ...$79726d6580a08da3$var$initialState,
            ...state
        };
    },
    [(0, $k5ZQb.LoadProfilePage).SUCCESS] (state, action) {
        return {
            ...state,
            ...action.payload,
            menuItems: (0, $iaicX.createNestedMenu)(action.payload.menuItems)
        };
    }
});

});


parcelRegister("jb5Ea", function(module, exports) {

$parcel$export(module.exports, "UNLOAD_PROJECT", function () { return $89d2668d598994f3$export$9c155f8313883e44; });
$parcel$export(module.exports, "loadProjectPage", function () { return $89d2668d598994f3$export$dfcc8737dbf74c41; });
$parcel$export(module.exports, "reducer", function () { return $89d2668d598994f3$export$1650419e431d3ba3; });

var $jF3Yx = parcelRequire("jF3Yx");
parcelRequire("6ePRx");
var $iaicX = parcelRequire("iaicX");
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
var $fICwP = parcelRequire("fICwP");

var $48ZQ3 = parcelRequire("48ZQ3");

var $gsXeO = parcelRequire("gsXeO");
const $89d2668d598994f3$export$f2a0dedde8f846ae = (0, $2MctD.createAsyncAction)("project/LOAD_PROJECT_PAGE");
const $89d2668d598994f3$export$9c155f8313883e44 = "project/UNLOAD_PROJECT";
const $89d2668d598994f3$export$77b371d6becc8882 = [
    "project.section",
    "section.project"
];
const $89d2668d598994f3$export$dfcc8737dbf74c41 = (workspaceSlug, projectKey)=>(0, $fICwP.hydrateAction)($89d2668d598994f3$export$f2a0dedde8f846ae, $89d2668d598994f3$export$77b371d6becc8882, {
        url: `/${workspaceSlug}/workspace/projects/${projectKey}`,
        schema: {
            currentProject: (0, $48ZQ3.project)
        }
    });
// Reducer
const $89d2668d598994f3$var$initialState = {
    currentProject: null,
    menuItems: []
};
const $89d2668d598994f3$var$section = (0, $gsXeO.default)($89d2668d598994f3$var$initialState, {
    [$89d2668d598994f3$export$f2a0dedde8f846ae.SUCCESS] (state, action) {
        const { menuItems: menuItems, ...result } = action.payload.result;
        return {
            ...state,
            ...result,
            ...menuItems && {
                menuItems: (0, $iaicX.createNestedMenu)(menuItems)
            }
        };
    },
    [$89d2668d598994f3$export$9c155f8313883e44] (state) {
        return {
            ...state,
            currentProject: null
        };
    }
});
const $89d2668d598994f3$export$1650419e431d3ba3 = (0, $jF3Yx.combineReducers)({
    section: $89d2668d598994f3$var$section
});

});

parcelRegister("fKGO7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9319be2e92fcfd7$export$2e2bcd8739ae039; });
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $8Ao0D = parcelRequire("8Ao0D");
const $f9319be2e92fcfd7$var$initialState = {
    isLoading: true,
    hasError: false,
    commits: undefined,
    nextCommitsUrl: undefined,
    branchSyncInfo: null
};
var $f9319be2e92fcfd7$export$2e2bcd8739ae039 = (state = $f9319be2e92fcfd7$var$initialState, // @ts-ignore TODO: fix noImplicitAny error here
action)=>{
    switch(action.type){
        case (0, $6D21P.LOAD_PULL_REQUEST).SUCCESS:
            {
                const { result: result } = action.payload;
                // If we're NOT using commits api then the LOAD_PULL_REQUEST will have commits for us
                if (result.commits) return {
                    ...state,
                    commits: result.commits,
                    isLoading: false,
                    hasError: false,
                    nextCommitsUrl: undefined
                };
                return state;
            }
        case 0, $6D21P.UNLOAD_PULL_REQUEST:
            return $f9319be2e92fcfd7$var$initialState;
        case (0, $8Ao0D.prCommitActions).UPDATE_COMMITS:
            {
                const { commits: commits, page: page, next: next } = action.payload.result;
                return {
                    ...state,
                    commits: page === 1 ? commits : [
                        ...state.commits || [],
                        ...commits
                    ],
                    isLoading: false,
                    hasError: false,
                    nextCommitsUrl: next
                };
            }
        case (0, $8Ao0D.prCommitActions).COMMIT_FETCH_ERROR:
            return {
                ...state,
                hasError: true,
                isLoading: false,
                nextCommitsUrl: undefined
            };
        case (0, $8Ao0D.prCommitActions).RETRY_COMMITS:
            return {
                ...state,
                hasError: false,
                isLoading: true,
                nextCommitsUrl: undefined
            };
        case (0, $8Ao0D.prCommitActions).FETCH_MORE_COMMITS:
            return {
                ...state,
                hasError: false,
                isLoading: true
            };
        case (0, $8Ao0D.branchCommitActions).FETCH_COMMITS:
            {
                const { commits: commits, page: page, next: next } = action.payload.result;
                return {
                    ...state,
                    commits: page === 1 ? commits : [
                        ...state.commits || [],
                        ...commits
                    ],
                    isLoading: false,
                    hasError: false,
                    nextCommitsUrl: next
                };
            }
        case (0, $8Ao0D.branchCommitActions).FETCH_MORE_COMMITS:
            return {
                ...state,
                hasError: false,
                isLoading: true
            };
        case (0, $8Ao0D.branchCommitActions).RETRY_COMMITS:
            return {
                ...state,
                hasError: false,
                isLoading: true,
                nextCommitsUrl: undefined
            };
        case (0, $8Ao0D.branchCommitActions).COMMIT_FETCH_ERROR:
            return {
                ...state,
                hasError: true,
                isLoading: false,
                nextCommitsUrl: undefined
            };
        case 0, $8Ao0D.UNLOAD_BRANCH_COMMITS:
            return $f9319be2e92fcfd7$var$initialState;
        case (0, $8Ao0D.FETCH_BRANCH_SYNC_INFO).SUCCESS:
            return {
                ...state,
                branchSyncInfo: {
                    behind: action.payload.behind,
                    behindTruncated: action.payload.behind_truncated
                }
            };
        default:
            return state;
    }
};

});

parcelRegister("7HRn3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $132e59c8eb2919ae$export$2e2bcd8739ae039; });

var $gsXeO = parcelRequire("gsXeO");
parcelRequire("i00rV");
var $kVfUE = parcelRequire("kVfUE");
var $96rtx = parcelRequire("96rtx");
var $7JMVp = parcelRequire("7JMVp");
var $gwTjV = parcelRequire("gwTjV");
const $132e59c8eb2919ae$var$initialState = {
    accounts: [],
    isLoading: false,
    isOptInLoading: false,
    isOptInSuccess: false,
    optInFailed: false,
    response: null
};
var $132e59c8eb2919ae$export$2e2bcd8739ae039 = (0, $gsXeO.default)($132e59c8eb2919ae$var$initialState, {
    [(0, $96rtx.LoadSearchPage).SUCCESS] (state, action) {
        return {
            ...state,
            accounts: action.payload.result.accounts
        };
    },
    [(0, $gwTjV.RESET_SEARCH)] (state) {
        return {
            ...state,
            isLoading: false,
            isOptInLoading: false,
            optInFailed: false,
            response: null
        };
    },
    [(0, $kVfUE.FetchSearchResults).REQUEST] (state) {
        return {
            ...state,
            response: null,
            isLoading: true
        };
    },
    [(0, $kVfUE.FetchSearchResults).SUCCESS] (state, action) {
        return {
            ...state,
            response: action.payload,
            isLoading: false
        };
    },
    [(0, $kVfUE.FetchSearchResults).ERROR] (state, action) {
        return {
            ...state,
            isLoading: false,
            response: action.meta
        };
    },
    [(0, $7JMVp.OptInToBeta).REQUEST] (state) {
        return {
            ...state,
            isOptInLoading: true,
            isOptInSuccess: false,
            optInFailed: false
        };
    },
    [(0, $7JMVp.OptInToBeta).SUCCESS] (state) {
        return {
            ...state,
            isOptInLoading: false,
            isOptInSuccess: true,
            optInFailed: false
        };
    },
    [(0, $7JMVp.OptInToBeta).ERROR] (state) {
        return {
            ...state,
            isOptInLoading: false,
            isOptInSuccess: false,
            optInFailed: true
        };
    }
});

});

parcelRegister("bdxjy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2de04e32f9e560d$export$2e2bcd8739ae039; });

var $jF3Yx = parcelRequire("jF3Yx");

var $9vsX2 = parcelRequire("9vsX2");

var $2Nc6d = parcelRequire("2Nc6d");

var $d5yyK = parcelRequire("d5yyK");

var $lFFki = parcelRequire("lFFki");

var $5vUfT = parcelRequire("5vUfT");

var $14kRW = parcelRequire("14kRW");

var $ha5uu = parcelRequire("ha5uu");

var $2WdMK = parcelRequire("2WdMK");

var $cYhXG = parcelRequire("cYhXG");

var $k6zif = parcelRequire("k6zif");

var $5gbji = parcelRequire("5gbji");

var $dRthA = parcelRequire("dRthA");

var $e2kK7 = parcelRequire("e2kK7");

var $5uWUR = parcelRequire("5uWUR");

var $8mswv = parcelRequire("8mswv");

var $9Wjm3 = parcelRequire("9Wjm3");

var $4gyJT = parcelRequire("4gyJT");

var $k9TzH = parcelRequire("k9TzH");

var $iHsg5 = parcelRequire("iHsg5");

var $lTWCn = parcelRequire("lTWCn");

var $ea7l9 = parcelRequire("ea7l9");
const $c2de04e32f9e560d$var$reducer = (0, $jF3Yx.combineReducers)({
    branch: (0, $9Wjm3.branchReducer),
    commitList: (0, $d5yyK.reducer),
    details: $iHsg5.default,
    deployments: $9vsX2.default,
    pendingCommit: $lFFki.reducer,
    // Interim duct tape to append reducer to parent slice
    pullRequest: (state, action)=>({
            ...(0, $dRthA.pullRequestReducer)(state, action),
            decline: (0, $ha5uu.default)(state ? state.decline : undefined, action),
            merge: (0, $k6zif.default)(state ? state.merge : undefined, action),
            imageUpload: (0, $2WdMK.default)(state ? state.imageUpload : undefined, action),
            activity: (0, $14kRW.activityReducer)(state ? state.activity : undefined, action),
            iterativeReview: (0, $cYhXG.iterativeReviewReducer)(state ? state.iterativeReview : undefined, action),
            polling: (0, $5gbji.default)(state ? state.polling : undefined, action),
            sidebarCardCollapsed: (0, $e2kK7.default)(state ? state.sidebarCardCollapsed : undefined, action),
            tasks: (0, $5uWUR.default)(state ? state.tasks : undefined, action),
            viewEntireFile: (0, $8mswv.default)(state ? state.viewEntireFile : undefined, action)
        }),
    pullRequestList: $5vUfT.default,
    branches: $2Nc6d.default,
    section: $lTWCn.default,
    source: $k9TzH.default,
    subscriptions: $ea7l9.default,
    security: (0, $4gyJT.repoSecurityReducer)
});
var $c2de04e32f9e560d$export$2e2bcd8739ae039 = $c2de04e32f9e560d$var$reducer;

});
parcelRegister("9vsX2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9b2d58734d5fea0$export$2e2bcd8739ae039; });

var $jF3Yx = parcelRequire("jF3Yx");

var $6ahUy = parcelRequire("6ahUy");

var $5FHpB = parcelRequire("5FHpB");

var $fvA1q = parcelRequire("fvA1q");

var $goYrK = parcelRequire("goYrK");

var $akwuo = parcelRequire("akwuo");

var $aEXVJ = parcelRequire("aEXVJ");

var $E5fPa = parcelRequire("E5fPa");
var $d9b2d58734d5fea0$export$2e2bcd8739ae039 = (0, $jF3Yx.combineReducers)({
    changes: $6ahUy.default,
    dashboard: $5FHpB.default,
    environmentHistory: $fvA1q.default,
    preview: $goYrK.default,
    redeployment: $akwuo.default,
    summary: $aEXVJ.default,
    websocket: $E5fPa.default
});

});
parcelRegister("6ahUy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d0a58cfd6452f4f$export$2e2bcd8739ae039; });

var $90kWr = parcelRequire("90kWr");

var $gsXeO = parcelRequire("gsXeO");

var $7Ic5Q = parcelRequire("7Ic5Q");
const $9d0a58cfd6452f4f$export$d4c72bab9d6cc13a = {
    commitDiff: [],
    fileDiff: [],
    jiraIssues: [],
    pullRequests: [],
    isJiraConnected: true,
    fetchedCommitsPageStatus: (0, $90kWr.LoadingStatus).Before,
    fetchedStatus: (0, $90kWr.LoadingStatus).Before
};
var $9d0a58cfd6452f4f$export$2e2bcd8739ae039 = (0, $gsXeO.default)($9d0a58cfd6452f4f$export$d4c72bab9d6cc13a, {
    [(0, $7Ic5Q.REMOVE_DEPLOYMENT_DATA)] () {
        return $9d0a58cfd6452f4f$export$d4c72bab9d6cc13a;
    },
    [(0, $7Ic5Q.REQUEST_DEPLOYMENT_CHANGES).REQUEST] () {
        return {
            ...$9d0a58cfd6452f4f$export$d4c72bab9d6cc13a,
            fetchedStatus: (0, $90kWr.LoadingStatus).Fetching
        };
    },
    [(0, $7Ic5Q.REQUEST_DEPLOYMENT_CHANGES).SUCCESS] (state, action) {
        var _action$payload, _action$payload2, _action$payload3, _action$payload4;
        return {
            ...state,
            commitDiff: ((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.commitDiff) || [],
            jiraIssues: ((_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.jiraIssues) || [],
            fileDiff: ((_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.fileDiff) || [],
            fetchedStatus: (0, $90kWr.LoadingStatus).Success,
            isJiraConnected: !!((_action$payload4 = action.payload) !== null && _action$payload4 !== void 0 && _action$payload4.isJiraConnected)
        };
    },
    [(0, $7Ic5Q.REQUEST_DEPLOYMENT_COMMITS).REQUEST] (state) {
        return {
            ...state,
            fetchedCommitsPageStatus: (0, $90kWr.LoadingStatus).Fetching
        };
    },
    [(0, $7Ic5Q.REQUEST_DEPLOYMENT_COMMITS).SUCCESS] (state, action) {
        const commitDiff = action.payload || [];
        return {
            ...state,
            commitDiff: state.commitDiff.filter((commit)=>!commitDiff.some((newCommit)=>newCommit.hash === commit.hash)).concat(commitDiff),
            fetchedCommitsPageStatus: (0, $90kWr.LoadingStatus).Success
        };
    },
    [(0, $7Ic5Q.REQUEST_DEPLOYMENT_PULL_REQUESTS).SUCCESS] (state, action) {
        const pullRequests = action.payload || [];
        return {
            ...state,
            pullRequests: pullRequests
        };
    }
});

});

parcelRegister("5FHpB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af12270b893b7b50$export$2e2bcd8739ae039; });

var $fapR5 = parcelRequire("fapR5");
var $gwyeW = parcelRequire("gwyeW");
parcelRequire("e9n2v");
var $eRckJ = parcelRequire("eRckJ");

var $jPcDa = parcelRequire("jPcDa");

var $90kWr = parcelRequire("90kWr");

var $gsXeO = parcelRequire("gsXeO");

var $7Ic5Q = parcelRequire("7Ic5Q");
const $af12270b893b7b50$export$d4c72bab9d6cc13a = {
    fetchedStatus: (0, $90kWr.LoadingStatus).Before,
    reorderedStatus: (0, $90kWr.LoadingStatus).Before,
    type: {
        Test: [],
        Staging: [],
        Production: []
    },
    updatingEnvironmentUuids: {},
    version: -1
};
function $af12270b893b7b50$var$findPath(state, environmentUuid) {
    let typeName = "";
    let index = -1;
    let path = "";
    Object.values(state.type).some((type)=>type.some((environment, environmentIndex)=>{
            if (environment.uuid === environmentUuid) {
                typeName = environment["environment_type.name"];
                index = environmentIndex;
                path = `${environment["environment_type.name"]}[${environmentIndex}]`;
                return true;
            }
            return false;
        }));
    return {
        index: index,
        path: path,
        type: typeName
    };
}
function $af12270b893b7b50$var$getUpdatingWith(state, environmentUuid) {
    return {
        ...state.updatingEnvironmentUuids,
        [environmentUuid]: true
    };
}
function $af12270b893b7b50$var$getUpdatingWithOut(state, environmentUuid) {
    const updatingEnvironmentUuids = {
        ...state.updatingEnvironmentUuids
    };
    delete updatingEnvironmentUuids[environmentUuid];
    return updatingEnvironmentUuids;
}
function $af12270b893b7b50$var$updateEnvironmentFinishedReducer(state, action) {
    const { environmentUuid: environmentUuid } = action.payload;
    return {
        ...state,
        updatingEnvironmentUuids: $af12270b893b7b50$var$getUpdatingWithOut(state, environmentUuid)
    };
}
function $af12270b893b7b50$export$a7f129fc23747575(restrictions, state) {
    return Object.keys(restrictions).reduce((tempState, environmentUuid)=>{
        if (!Object.values(state.type).every((val)=>Array.isArray(val))) return state;
        const { path: path } = $af12270b893b7b50$var$findPath(tempState, environmentUuid);
        const branchRestrictions = restrictions[environmentUuid];
        return {
            ...tempState,
            type: (0, $gwyeW.default)(tempState.type, path, (environment)=>new (0, $eRckJ.Environment)({
                    ...environment ? environment.toJS() : {},
                    branchRestrictions: branchRestrictions
                }))
        };
    }, state);
}
const $af12270b893b7b50$var$reduceDeploymentDashboard = (state, action)=>{
    var _action$payload, _action$payload$group;
    if (!((_action$payload = action.payload) !== null && _action$payload !== void 0 && (_action$payload$group = _action$payload.groupings) !== null && _action$payload$group !== void 0 && _action$payload$group.length)) return state;
    const type = {
        ...$af12270b893b7b50$export$d4c72bab9d6cc13a.type
    };
    action.payload.groupings.forEach((group)=>{
        type[group.environment_type.name] = group.environment_summaries.map((e)=>new (0, $eRckJ.Environment)(e));
    });
    return {
        ...state,
        fetchedStatus: (0, $90kWr.LoadingStatus).Success,
        type: type,
        version: action.payload.version
    };
};
const $af12270b893b7b50$var$reduceBranchRestrictions = (state, action)=>{
    var _action$payload2, _action$payload2$valu;
    if (!((_action$payload2 = action.payload) !== null && _action$payload2 !== void 0 && (_action$payload2$valu = _action$payload2.values) !== null && _action$payload2$valu !== void 0 && _action$payload2$valu.length)) return state;
    const restrictions = action.payload.values.reduce((tempRestrictions, restriction)=>{
        if (tempRestrictions[restriction.environmentUuid]) tempRestrictions[restriction.environmentUuid].push(restriction);
        else tempRestrictions[restriction.environmentUuid] = [
            restriction
        ];
        return tempRestrictions;
    }, {});
    return $af12270b893b7b50$export$a7f129fc23747575(restrictions, state);
};
var $af12270b893b7b50$export$2e2bcd8739ae039 = (0, $gsXeO.default)($af12270b893b7b50$export$d4c72bab9d6cc13a, {
    [(0, $jPcDa.SET_REPOSITORY)] () {
        return {
            ...$af12270b893b7b50$export$d4c72bab9d6cc13a
        };
    },
    [(0, $7Ic5Q.REQUEST_DEPLOYMENT_DASHBOARD).REQUEST] () {
        return {
            ...$af12270b893b7b50$export$d4c72bab9d6cc13a,
            fetchedStatus: (0, $90kWr.LoadingStatus).Fetching
        };
    },
    [(0, $7Ic5Q.SET_DEPLOYMENT_DASHBOARD)]: $af12270b893b7b50$var$reduceDeploymentDashboard,
    [(0, $7Ic5Q.REQUEST_DEPLOYMENT_DASHBOARD).SUCCESS]: $af12270b893b7b50$var$reduceDeploymentDashboard,
    [(0, $7Ic5Q.REQUEST_DEPLOYMENT_DASHBOARD).ERROR] (state) {
        return {
            ...state,
            fetchedStatus: (0, $90kWr.LoadingStatus).Failed
        };
    },
    [(0, $7Ic5Q.SET_BRANCH_RESTRICTIONS)]: $af12270b893b7b50$var$reduceBranchRestrictions,
    [(0, $7Ic5Q.REQUEST_BRANCH_RESTRICTIONS).SUCCESS]: $af12270b893b7b50$var$reduceBranchRestrictions,
    [(0, $7Ic5Q.REQUEST_CREATE_BRANCH_RESTRICTION).REQUEST]: (state, action)=>{
        const { environmentUuid: environmentUuid } = action.payload;
        return {
            ...state,
            updatingEnvironmentUuids: $af12270b893b7b50$var$getUpdatingWith(state, environmentUuid)
        };
    },
    [(0, $7Ic5Q.REQUEST_CREATE_BRANCH_RESTRICTION).SUCCESS]: (state, action)=>{
        const { environmentUuid: environmentUuid, data: data } = action.payload;
        const { path: path } = $af12270b893b7b50$var$findPath(state, environmentUuid);
        const type = (0, $gwyeW.default)((0, $fapR5.default)(state.type), path, (env)=>new (0, $eRckJ.Environment)({
                ...env.toJS(),
                branchRestrictions: [
                    ...env.branchRestrictions,
                    data
                ]
            }));
        return {
            ...state,
            type: type,
            updatingEnvironmentUuids: $af12270b893b7b50$var$getUpdatingWithOut(state, environmentUuid)
        };
    },
    [(0, $7Ic5Q.REQUEST_CREATE_BRANCH_RESTRICTION).ERROR]: $af12270b893b7b50$var$updateEnvironmentFinishedReducer,
    [(0, $7Ic5Q.REQUEST_DELETE_BRANCH_RESTRICTION).REQUEST]: (state, action)=>{
        const { environmentUuid: environmentUuid } = action.payload;
        return {
            ...state,
            updatingEnvironmentUuids: $af12270b893b7b50$var$getUpdatingWith(state, environmentUuid)
        };
    },
    [(0, $7Ic5Q.REQUEST_DELETE_BRANCH_RESTRICTION).SUCCESS]: (state, action)=>{
        const { environmentUuid: environmentUuid, restrictionUuid: restrictionUuid } = action.payload;
        const { path: path } = $af12270b893b7b50$var$findPath(state, environmentUuid);
        const type = (0, $gwyeW.default)((0, $fapR5.default)(state.type), path, (env)=>new (0, $eRckJ.Environment)({
                ...env.toJS(),
                branchRestrictions: env.branchRestrictions.filter((restriction)=>restriction.uuid !== restrictionUuid)
            }));
        return {
            ...state,
            type: type,
            updatingEnvironmentUuids: $af12270b893b7b50$var$getUpdatingWithOut(state, environmentUuid)
        };
    },
    [(0, $7Ic5Q.REQUEST_DELETE_BRANCH_RESTRICTION).ERROR]: $af12270b893b7b50$var$updateEnvironmentFinishedReducer,
    [(0, $7Ic5Q.REQUEST_CREATE_ENVIRONMENT).REQUEST]: (state, action)=>{
        const { environmentName: environmentName, environmentType: environmentType } = action.payload;
        const type = {
            ...state.type,
            [environmentType]: [
                ...state.type[environmentType],
                // Append the temp environment object
                new (0, $eRckJ.Environment)({
                    name: environmentName,
                    environment_type: {
                        name: environmentType
                    }
                })
            ]
        };
        return {
            ...state,
            type: type
        };
    },
    [(0, $7Ic5Q.REQUEST_CREATE_ENVIRONMENT).SUCCESS]: (state, action)=>{
        const { environment: environment, environmentName: environmentName, environmentType: environmentType } = action.payload;
        const type = {
            ...state.type
        };
        type[environmentType] = type[environmentType].map((env)=>// Replace the temp environment object
            env.name !== environmentName ? env : new (0, $eRckJ.Environment)(environment));
        return {
            ...state,
            type: type
        };
    },
    [(0, $7Ic5Q.REQUEST_CREATE_ENVIRONMENT).ERROR]: (state, action)=>{
        const { environmentName: environmentName, environmentType: environmentType } = action.payload;
        const type = {
            ...state.type,
            [environmentType]: state.type[environmentType].filter(// Remove the temp environment object
            (env)=>env.name !== environmentName)
        };
        return {
            ...state,
            type: type
        };
    },
    [(0, $7Ic5Q.REQUEST_UPDATE_ENVIRONMENT).REQUEST]: (state, action)=>{
        const { environmentUuid: environmentUuid } = action.payload;
        return {
            ...state,
            updatingEnvironmentUuids: $af12270b893b7b50$var$getUpdatingWith(state, environmentUuid)
        };
    },
    [(0, $7Ic5Q.REQUEST_UPDATE_ENVIRONMENT).SUCCESS]: (state, action)=>{
        const { environmentUuid: environmentUuid, data: data } = action.payload;
        const { type: environmentType } = $af12270b893b7b50$var$findPath(state, environmentUuid);
        const type = {
            ...state.type,
            [environmentType]: state.type[environmentType].map((env)=>// Replace the updated environment
                env.uuid !== environmentUuid ? env : new (0, $eRckJ.Environment)(data))
        };
        return {
            ...state,
            type: type,
            updatingEnvironmentUuids: $af12270b893b7b50$var$getUpdatingWithOut(state, environmentUuid)
        };
    },
    [(0, $7Ic5Q.REQUEST_UPDATE_ENVIRONMENT).ERROR]: $af12270b893b7b50$var$updateEnvironmentFinishedReducer,
    [(0, $7Ic5Q.REQUEST_DELETE_ENVIRONMENT).REQUEST]: (state, action)=>{
        const { environmentUuid: environmentUuid } = action.payload;
        return {
            ...state,
            updatingEnvironmentUuids: $af12270b893b7b50$var$getUpdatingWith(state, environmentUuid)
        };
    },
    [(0, $7Ic5Q.REQUEST_DELETE_ENVIRONMENT).SUCCESS]: (state, action)=>{
        const { environmentUuid: environmentUuid } = action.payload;
        const { type: environmentType } = $af12270b893b7b50$var$findPath(state, environmentUuid);
        const type = {
            ...state.type,
            [environmentType]: state.type[environmentType].filter(// Remove the deleted environment
            (env)=>env.uuid !== environmentUuid)
        };
        return {
            ...state,
            type: type,
            updatingEnvironmentUuids: $af12270b893b7b50$var$getUpdatingWithOut(state, environmentUuid)
        };
    },
    [(0, $7Ic5Q.REQUEST_DELETE_ENVIRONMENT).ERROR]: $af12270b893b7b50$var$updateEnvironmentFinishedReducer,
    [(0, $7Ic5Q.REQUEST_REORDER_ENVIRONMENTS).REQUEST]: (state, action)=>{
        const { environmentType: environmentType, environmentTypeOrder: environmentTypeOrder } = action.payload;
        const type = {
            ...state.type,
            [environmentType]: environmentTypeOrder.map(({ uuid: uuid })=>state.type[environmentType].find((env)=>env.uuid === uuid))
        };
        return {
            ...state,
            reorderedStatus: (0, $90kWr.LoadingStatus).Fetching,
            type: type
        };
    },
    [(0, $7Ic5Q.REQUEST_REORDER_ENVIRONMENTS).SUCCESS]: (state)=>{
        return {
            ...state,
            reorderedStatus: (0, $90kWr.LoadingStatus).Success
        };
    },
    [(0, $7Ic5Q.REQUEST_REORDER_ENVIRONMENTS).ERROR]: (state)=>{
        return {
            ...state,
            reorderedStatus: (0, $90kWr.LoadingStatus).Failed
        };
    }
});

});
parcelRegister("gwyeW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c07a31da16e68fec$export$2e2bcd8739ae039; });

var $4vUSo = parcelRequire("4vUSo");

var $9eSdh = parcelRequire("9eSdh");
/**
 * This method is like `_.set` except that accepts `updater` to produce the
 * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
 * is invoked with one argument: (value).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.6.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {Function} updater The function to produce the updated value.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.update(object, 'a[0].b.c', function(n) { return n * n; });
 * console.log(object.a[0].b.c);
 * // => 9
 *
 * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
 * console.log(object.x[0].y.z);
 * // => 0
 */ function $c07a31da16e68fec$var$update(object, path, updater) {
    return object == null ? object : (0, $4vUSo.default)(object, path, (0, $9eSdh.default)(updater));
}
var $c07a31da16e68fec$export$2e2bcd8739ae039 = $c07a31da16e68fec$var$update;

});
parcelRegister("4vUSo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34962d21665b37f4$export$2e2bcd8739ae039; });

var $fVuMG = parcelRequire("fVuMG");

var $5pez5 = parcelRequire("5pez5");
/**
 * The base implementation of `_.update`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to update.
 * @param {Function} updater The function to produce the updated value.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $34962d21665b37f4$var$baseUpdate(object, path, updater, customizer) {
    return (0, $5pez5.default)(object, path, updater((0, $fVuMG.default)(object, path)), customizer);
}
var $34962d21665b37f4$export$2e2bcd8739ae039 = $34962d21665b37f4$var$baseUpdate;

});

parcelRegister("9eSdh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b9f797d7704a014$export$2e2bcd8739ae039; });

var $1P6AC = parcelRequire("1P6AC");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $6b9f797d7704a014$var$castFunction(value) {
    return typeof value == "function" ? value : (0, $1P6AC.default);
}
var $6b9f797d7704a014$export$2e2bcd8739ae039 = $6b9f797d7704a014$var$castFunction;

});



parcelRegister("fvA1q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $074fd0e05b5cb11b$export$2e2bcd8739ae039; });
parcelRequire("e9n2v");
var $goDEr = parcelRequire("goDEr");

var $90kWr = parcelRequire("90kWr");

var $gsXeO = parcelRequire("gsXeO");

var $7Ic5Q = parcelRequire("7Ic5Q");
const $074fd0e05b5cb11b$export$d4c72bab9d6cc13a = {
    map: {},
    fetchedStatus: {}
};
var $074fd0e05b5cb11b$export$2e2bcd8739ae039 = (0, $gsXeO.default)($074fd0e05b5cb11b$export$d4c72bab9d6cc13a, {
    [(0, $7Ic5Q.REQUEST_ENVIRONMENT_HISTORY).REQUEST] (state, action) {
        const { environmentUuid: environmentUuid } = action.meta;
        return {
            map: {
                ...state.map,
                [environmentUuid]: state.map[environmentUuid] || []
            },
            fetchedStatus: {
                ...state.fetchedStatus,
                [environmentUuid]: (0, $90kWr.LoadingStatus).Fetching
            }
        };
    },
    [(0, $7Ic5Q.REQUEST_ENVIRONMENT_HISTORY).SUCCESS] (state, action) {
        var _action$payload;
        const { environmentUuid: environmentUuid } = action.meta;
        const existingHistory = state.map[environmentUuid] || [];
        const newHistory = ((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.values.filter((newDeployment)=>!existingHistory.some((existingDeployment)=>existingDeployment.uuid === newDeployment.uuid)).map((d)=>new (0, $goDEr.Deployment)(d)).filter((newDeployment)=>{
            var _newDeployment$state;
            return ((_newDeployment$state = newDeployment.state) === null || _newDeployment$state === void 0 ? void 0 : _newDeployment$state.parsedStatus) !== "UNDEPLOYED";
        })) || [];
        return {
            map: {
                ...state.map,
                [environmentUuid]: existingHistory.concat(newHistory)
            },
            fetchedStatus: {
                ...state.fetchedStatus,
                [environmentUuid]: (0, $90kWr.LoadingStatus).Success
            }
        };
    },
    [(0, $7Ic5Q.REQUEST_ENVIRONMENT_HISTORY).ERROR] (state, action) {
        const { environmentUuid: environmentUuid } = action.meta;
        return {
            ...state,
            fetchedStatus: {
                ...state.fetchedStatus,
                [environmentUuid]: (0, $90kWr.LoadingStatus).Failed
            }
        };
    }
});

});

parcelRegister("goYrK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17f54892efbb188a$export$2e2bcd8739ae039; });
parcelRequire("e9n2v");
var $goDEr = parcelRequire("goDEr");
var $eRckJ = parcelRequire("eRckJ");

var $gsXeO = parcelRequire("gsXeO");

var $7Ic5Q = parcelRequire("7Ic5Q");
const $17f54892efbb188a$export$d4c72bab9d6cc13a = {
    deployment: new (0, $goDEr.Deployment)(),
    environment: new (0, $eRckJ.Environment)()
};
var $17f54892efbb188a$export$2e2bcd8739ae039 = (0, $gsXeO.default)($17f54892efbb188a$export$d4c72bab9d6cc13a, {
    [(0, $7Ic5Q.REMOVE_DEPLOYMENT_DATA)] () {
        return $17f54892efbb188a$export$d4c72bab9d6cc13a;
    },
    [(0, $7Ic5Q.SET_DEPLOYMENT_PREVIEW)] (state, action) {
        return {
            ...state,
            ...action.payload
        };
    }
});

});

parcelRegister("akwuo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76462059973e8ae0$export$2e2bcd8739ae039; });
parcelRequire("e9n2v");
var $goDEr = parcelRequire("goDEr");
var $eRckJ = parcelRequire("eRckJ");

var $gsXeO = parcelRequire("gsXeO");

var $7Ic5Q = parcelRequire("7Ic5Q");
const $76462059973e8ae0$export$d4c72bab9d6cc13a = {
    deployment: new (0, $goDEr.Deployment)(),
    lastSuccessfulDeployment: new (0, $goDEr.Deployment)(),
    environment: new (0, $eRckJ.Environment)()
};
var $76462059973e8ae0$export$2e2bcd8739ae039 = (0, $gsXeO.default)($76462059973e8ae0$export$d4c72bab9d6cc13a, {
    [(0, $7Ic5Q.REMOVE_DEPLOYMENT_DATA)] () {
        return $76462059973e8ae0$export$d4c72bab9d6cc13a;
    },
    [(0, $7Ic5Q.REQUEST_REDEPLOYMENT).REQUEST] () {
        return $76462059973e8ae0$export$d4c72bab9d6cc13a;
    },
    [(0, $7Ic5Q.REQUEST_REDEPLOYMENT).SUCCESS] (state, action) {
        return {
            ...state,
            ...action.payload
        };
    }
});

});

parcelRegister("aEXVJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $567d353c2b6b7b08$export$2e2bcd8739ae039; });
parcelRequire("e9n2v");
var $goDEr = parcelRequire("goDEr");
var $eRckJ = parcelRequire("eRckJ");

var $gsXeO = parcelRequire("gsXeO");

var $7Ic5Q = parcelRequire("7Ic5Q");
const $567d353c2b6b7b08$export$d4c72bab9d6cc13a = {
    deployment: new (0, $goDEr.Deployment)(),
    lastSuccessfulDeployment: undefined,
    environment: new (0, $eRckJ.Environment)()
};
const $567d353c2b6b7b08$var$updateDeployment = (deploymentData)=>{
    var _deploymentData$state, _deploymentData$state2, _deploymentData$state3;
    return {
        deployment: new (0, $goDEr.Deployment)(deploymentData),
        lastSuccessfulDeployment: deploymentData !== null && deploymentData !== void 0 && (_deploymentData$state = deploymentData.state) !== null && _deploymentData$state !== void 0 && (_deploymentData$state2 = _deploymentData$state.last_successful_deployment) !== null && _deploymentData$state2 !== void 0 && _deploymentData$state2.uuid ? new (0, $goDEr.Deployment)(deploymentData === null || deploymentData === void 0 ? void 0 : (_deploymentData$state3 = deploymentData.state) === null || _deploymentData$state3 === void 0 ? void 0 : _deploymentData$state3.last_successful_deployment) : undefined,
        environment: new (0, $eRckJ.Environment)(deploymentData === null || deploymentData === void 0 ? void 0 : deploymentData.environment)
    };
};
var $567d353c2b6b7b08$export$2e2bcd8739ae039 = (0, $gsXeO.default)($567d353c2b6b7b08$export$d4c72bab9d6cc13a, {
    [(0, $7Ic5Q.REMOVE_DEPLOYMENT_DATA)] () {
        return $567d353c2b6b7b08$export$d4c72bab9d6cc13a;
    },
    [(0, $7Ic5Q.REQUEST_DEPLOYMENT_SUMMARY).REQUEST] () {
        return $567d353c2b6b7b08$export$d4c72bab9d6cc13a;
    },
    [(0, $7Ic5Q.REQUEST_DEPLOYMENT_SUMMARY).SUCCESS] (state, action) {
        return {
            ...state,
            ...$567d353c2b6b7b08$var$updateDeployment(action === null || action === void 0 ? void 0 : action.payload)
        };
    }
});

});

parcelRegister("E5fPa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33ee35198d15f644$export$2e2bcd8739ae039; });

var $gsXeO = parcelRequire("gsXeO");

var $jPcDa = parcelRequire("jPcDa");
const $33ee35198d15f644$export$d4c72bab9d6cc13a = [];
var $33ee35198d15f644$export$2e2bcd8739ae039 = (0, $gsXeO.default)($33ee35198d15f644$export$d4c72bab9d6cc13a, {
    [(0, $jPcDa.WEBSOCKET_SUBSCRIBE)] (state, action) {
        return state.concat(action.payload || []);
    },
    [(0, $jPcDa.WEBSOCKET_UNSUBSCRIBE)] (state, action) {
        return state.filter((subscription)=>{
            var _action$payload;
            // it there is no criteria remove all event subscriptions
            if (!((_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.criteria)) {
                var _action$payload2;
                return subscription.event !== ((_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.event);
            }
            return JSON.stringify(subscription) !== JSON.stringify(action.payload);
        });
    }
});

});


parcelRegister("lFFki", function(module, exports) {

$parcel$export(module.exports, "initiatePendingEdit", function () { return $f6a40536075add54$export$c1c96805bb83c39f; });
$parcel$export(module.exports, "initiatePendingDelete", function () { return $f6a40536075add54$export$e362bee2ac58f981; });
$parcel$export(module.exports, "initiatePendingRename", function () { return $f6a40536075add54$export$70f7c772e1162d53; });
$parcel$export(module.exports, "resetPendingCommit", function () { return $f6a40536075add54$export$a47044613836545e; });
$parcel$export(module.exports, "reducer", function () { return $f6a40536075add54$export$1650419e431d3ba3; });
// Action Types
const $f6a40536075add54$var$INITIATE_PENDING_COMMIT = "source/INITIATE_PENDING_COMMIT";
const $f6a40536075add54$var$RESET_PENDING_COMMIT = "source/RESET_PENDING_COMMIT";
// Action Creators
const $f6a40536075add54$var$initiatePendingCommit = (payload)=>({
        type: $f6a40536075add54$var$INITIATE_PENDING_COMMIT,
        payload: payload
    });
const $f6a40536075add54$export$c1c96805bb83c39f = (options)=>$f6a40536075add54$var$initiatePendingCommit({
        action: "commit",
        ...options
    });
const $f6a40536075add54$export$e362bee2ac58f981 = (filePath)=>$f6a40536075add54$var$initiatePendingCommit({
        action: "delete",
        filePath: filePath
    });
const $f6a40536075add54$export$70f7c772e1162d53 = (filePath, fileContents)=>$f6a40536075add54$var$initiatePendingCommit({
        action: "rename",
        fileContents: fileContents,
        filePath: filePath
    });
const $f6a40536075add54$export$a47044613836545e = ()=>({
        type: $f6a40536075add54$var$RESET_PENDING_COMMIT
    });
const $f6a40536075add54$var$initialState = {
    action: undefined,
    fileContents: undefined,
    filePath: undefined,
    newFilePath: undefined
};
const $f6a40536075add54$export$1650419e431d3ba3 = (state = $f6a40536075add54$var$initialState, action)=>{
    switch(action.type){
        case $f6a40536075add54$var$INITIATE_PENDING_COMMIT:
            return {
                ...state,
                ...action.payload
            };
        case $f6a40536075add54$var$RESET_PENDING_COMMIT:
            return {
                ...state,
                ...$f6a40536075add54$var$initialState
            };
        default:
            return state;
    }
};

});

parcelRegister("e2kK7", function(module, exports) {

$parcel$export(module.exports, "collapseCard", function () { return $62a6f01d8cb862d5$export$b7fc4aaf8384e271; });
$parcel$export(module.exports, "expandCard", function () { return $62a6f01d8cb862d5$export$443ab190f50c8aee; });
$parcel$export(module.exports, "getIsCardCollapsed", function () { return $62a6f01d8cb862d5$export$57e9a2609a841e71; });
$parcel$export(module.exports, "default", function () { return $62a6f01d8cb862d5$export$2e2bcd8739ae039; });

var $aXXtM = parcelRequire("aXXtM");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $1EkdU = parcelRequire("1EkdU");
const $62a6f01d8cb862d5$export$7e1c40cdb2b85b37 = (0, $6D21P.prefixed)("COLLAPSE_CARD");
const $62a6f01d8cb862d5$export$d4c8a72a9a025567 = (0, $6D21P.prefixed)("EXPAND_CARD");
const $62a6f01d8cb862d5$export$49b7dd85a3222972 = (0, $6D21P.prefixed)("COLLAPSE_ALL_CARDS");
const $62a6f01d8cb862d5$export$337513998426fbb5 = (0, $6D21P.prefixed)("EXPAND_CARDS");
const $62a6f01d8cb862d5$export$b7fc4aaf8384e271 = (key)=>({
        type: $62a6f01d8cb862d5$export$7e1c40cdb2b85b37,
        payload: key
    });
const $62a6f01d8cb862d5$export$443ab190f50c8aee = (key)=>({
        type: $62a6f01d8cb862d5$export$d4c8a72a9a025567,
        payload: key
    });
const $62a6f01d8cb862d5$export$dd6dbe3f8733441f = ()=>({
        type: $62a6f01d8cb862d5$export$49b7dd85a3222972
    });
const $62a6f01d8cb862d5$export$4faba97a45b041bd = (payload)=>({
        type: $62a6f01d8cb862d5$export$337513998426fbb5,
        payload: payload
    });
const $62a6f01d8cb862d5$export$65306939d1a8a37b = {};
const $62a6f01d8cb862d5$export$f283a605f491eb76 = (0, $aXXtM.createSelector)((0, $1EkdU.getPullRequestSlice), (state)=>state === null || state === void 0 ? void 0 : state.sidebarCardCollapsed);
const $62a6f01d8cb862d5$export$57e9a2609a841e71 = (0, $aXXtM.createSelector)($62a6f01d8cb862d5$export$f283a605f491eb76, (_, key)=>key, (state, key)=>state[key]);
var // Reducer
$62a6f01d8cb862d5$export$2e2bcd8739ae039 = (state = $62a6f01d8cb862d5$export$65306939d1a8a37b, action)=>{
    const newStateCollapse = {};
    const newStateExpand = {};
    switch(action.type){
        case $62a6f01d8cb862d5$export$7e1c40cdb2b85b37:
            return {
                ...state,
                [action.payload]: true
            };
        case $62a6f01d8cb862d5$export$d4c8a72a9a025567:
            return {
                ...state,
                [action.payload]: false
            };
        case $62a6f01d8cb862d5$export$49b7dd85a3222972:
            Object.keys(state).forEach((key)=>{
                newStateCollapse[key] = true;
            });
            return newStateCollapse;
        case $62a6f01d8cb862d5$export$337513998426fbb5:
            action.payload.forEach((key)=>{
                newStateExpand[key] = false;
            });
            return {
                ...state,
                ...newStateExpand
            };
        default:
            return state;
    }
};

});

parcelRegister("4gyJT", function(module, exports) {

$parcel$export(module.exports, "hydrateRepoSecurityData", function () { return $b1e05a09d2478363$export$87b2c741802dfed6; });
$parcel$export(module.exports, "repoSecurityReducer", function () { return $b1e05a09d2478363$export$7d8392335220b39e; });
$parcel$export(module.exports, "getSnykDescriptor", function () { return $b1e05a09d2478363$export$5762250be395dc9; });
$parcel$export(module.exports, "getSnykDescriptorUrl", function () { return $b1e05a09d2478363$export$4716401136c12e20; });

var $aXXtM = parcelRequire("aXXtM");
parcelRequire("5YpaN");
var $2MctD = parcelRequire("2MctD");
var $fICwP = parcelRequire("fICwP");

var $7qdXF = parcelRequire("7qdXF");

var $gsXeO = parcelRequire("gsXeO");
const $b1e05a09d2478363$export$bcb98d07d12eac89 = (0, $2MctD.createAsyncAction)("repoSecurity/HYDRATE_REPO_SECURITY_DATA");
const $b1e05a09d2478363$export$87b2c741802dfed6 = (repositoryFullSlug)=>(0, $fICwP.hydrateAction)($b1e05a09d2478363$export$bcb98d07d12eac89, "repository.security", {
        url: `/${repositoryFullSlug}/security/`
    });
const $b1e05a09d2478363$export$d4c72bab9d6cc13a = {
    snykDescriptor: undefined,
    snykDescriptorUrl: undefined,
    snykPrivacyPolicyUrl: undefined,
    snykEulaUrl: undefined
};
const $b1e05a09d2478363$export$7d8392335220b39e = (0, $gsXeO.default)($b1e05a09d2478363$export$d4c72bab9d6cc13a, {
    [$b1e05a09d2478363$export$bcb98d07d12eac89.SUCCESS]: (state, { payload: { snykDescriptor: snykDescriptor, snykDescriptorUrl: snykDescriptorUrl } })=>({
            ...state,
            snykDescriptor: snykDescriptor,
            snykDescriptorUrl: snykDescriptorUrl
        })
});
const $b1e05a09d2478363$export$5762250be395dc9 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (state)=>state.security.snykDescriptor);
const $b1e05a09d2478363$export$4716401136c12e20 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (state)=>state.security.snykDescriptorUrl);
const $b1e05a09d2478363$export$c742de47d8b81fc9 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (state)=>state.security.snykPrivacyPolicyUrl);
const $b1e05a09d2478363$export$daeb27391fa21352 = (0, $aXXtM.createSelector)((0, $7qdXF.getRepository), (state)=>state.security.snykEulaUrl);

});

parcelRegister("k9TzH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9a4aed3b8c0514c$export$2e2bcd8739ae039; });

var $jF3Yx = parcelRequire("jF3Yx");

var $5UG4S = parcelRequire("5UG4S");

var $dxHyo = parcelRequire("dxHyo");

var $8tKjm = parcelRequire("8tKjm");
var $c9a4aed3b8c0514c$export$2e2bcd8739ae039 = (0, $jF3Yx.combineReducers)({
    file: $5UG4S.default,
    section: $dxHyo.default,
    srcDirMetadata: $8tKjm.default
});

});
parcelRegister("5UG4S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $943115fbed7a7f88$export$2e2bcd8739ae039; });

var $gsXeO = parcelRequire("gsXeO");

var $kWOUe = parcelRequire("kWOUe");
const $943115fbed7a7f88$var$initialState = {
    isLoading: false
};
var $943115fbed7a7f88$export$2e2bcd8739ae039 = (0, $gsXeO.default)($943115fbed7a7f88$var$initialState, {
    [(0, $kWOUe.LoadFileMeta).REQUEST] (state) {
        return {
            ...state,
            file: undefined,
            meta: undefined,
            isLoading: true
        };
    },
    [(0, $kWOUe.LoadFileMeta).SUCCESS] (state, action) {
        const { attributes: attributes, path: path, mimetype: mimetype, size: size } = action.payload;
        return {
            ...state,
            isLoading: false,
            meta: {
                attributes: attributes,
                path: path,
                mimetype: mimetype,
                size: size
            }
        };
    },
    [(0, $kWOUe.LoadLfsInfo).REQUEST] (state) {
        return {
            ...state,
            lfs: null
        };
    },
    [(0, $kWOUe.LoadLfsInfo).SUCCESS] (state, action) {
        return {
            ...state,
            lfs: action.payload
        };
    },
    [(0, $kWOUe.LoadFileContents).SUCCESS] (state, action) {
        return {
            ...state,
            file: {
                contents: action.payload
            }
        };
    },
    [(0, $kWOUe.UNLOAD_FILE)] () {
        return $943115fbed7a7f88$var$initialState;
    }
});

});

parcelRegister("8tKjm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e33971234128de30$export$2e2bcd8739ae039; });

var $gsXeO = parcelRequire("gsXeO");

var $kWOUe = parcelRequire("kWOUe");
const $e33971234128de30$var$initialState = {};
var $e33971234128de30$export$2e2bcd8739ae039 = (0, $gsXeO.default)($e33971234128de30$var$initialState, {
    [(0, $kWOUe.FetchSourceDirMetadata).REQUEST] (state, action) {
        const { ref: ref, path: path } = action.payload;
        const id = `${ref}:${path}`;
        return {
            ...state,
            [id]: {
                ...state[id],
                isLoading: true
            }
        };
    },
    [(0, $kWOUe.FetchSourceDirMetadata).SUCCESS] (state, action) {
        const { ref: ref, path: path, srcDirMetadata: srcDirMetadata } = action.payload;
        const id = `${ref}:${path}`;
        return {
            ...state,
            [id]: {
                ...state[id],
                data: srcDirMetadata,
                isLoading: false
            }
        };
    }
});

});


parcelRegister("lTWCn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a9b41a20a0a76b6$export$2e2bcd8739ae039; });
parcelRequire("6ePRx");
var $iaicX = parcelRequire("iaicX");

var $gsXeO = parcelRequire("gsXeO");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");
const $7a9b41a20a0a76b6$var$initialState = {
    currentRepository: null,
    isCloneDialogOpen: false,
    isSyncDialogOpen: false,
    menuItems: [],
    bitbucketActions: [],
    connectActions: [],
    mirrors: null,
    sizeLimits: {
        soft: Infinity,
        hard: Infinity,
        readOnly: Infinity
    },
    overrideSettings: {}
};
var $7a9b41a20a0a76b6$export$2e2bcd8739ae039 = (0, $gsXeO.default)($7a9b41a20a0a76b6$var$initialState, {
    [(0, $jJd6W.LoadRepositoryPage).SUCCESS] (state, action) {
        const { menuItems: menuItems, sizeLimits: sizeLimits, overrideSettings: overrideSettings, override_settings: override_settings, ...result } = action.payload.result;
        return {
            ...state,
            ...result,
            ...menuItems && {
                menuItems: (0, $iaicX.createNestedMenu)(menuItems)
            },
            sizeLimits: {
                soft: (sizeLimits === null || sizeLimits === void 0 ? void 0 : sizeLimits.soft) || Infinity,
                hard: (sizeLimits === null || sizeLimits === void 0 ? void 0 : sizeLimits.hard) || Infinity,
                readOnly: (sizeLimits === null || sizeLimits === void 0 ? void 0 : sizeLimits.readOnly) || Infinity
            },
            // This should work if backend changes snake-casing to
            // camel-casing to follow current convention
            overrideSettings: overrideSettings || override_settings
        };
    },
    [(0, $jJd6W.UNLOAD_REPOSITORY)] (state) {
        return {
            ...state,
            currentRepository: null,
            mirrors: null,
            menuItems: []
        };
    },
    [(0, $jJd6W.UPDATE_MENU_ITEMS)] (state, action) {
        return {
            ...state,
            menuItems: (0, $iaicX.createNestedMenu)(action.payload)
        };
    },
    [(0, $jJd6W.UPDATE_REPOSITORY_SECTION_OVERRIDE_SETTINGS)] (state, action) {
        return {
            ...state,
            overrideSettings: {
                ...state.overrideSettings,
                ...action.payload
            }
        };
    },
    [(0, $jJd6W.UPDATE_REPOSITORY_SECTION_MENU_ITEMS)] (state, action) {
        return {
            ...state,
            menuItems: (0, $iaicX.createNestedMenu)(action.payload)
        };
    },
    [(0, $jJd6W.TOGGLE_CLONE_DIALOG)] (state, action) {
        return {
            ...state,
            isCloneDialogOpen: action.payload
        };
    },
    [(0, $jJd6W.TOGGLE_SYNC_DIALOG)] (state, action) {
        if (action.payload === state.isSyncDialogOpen) return state;
        return {
            ...state,
            isSyncDialogOpen: action.payload
        };
    },
    [(0, $jJd6W.FETCH_FORGE_REPO_MENU_ITEMS).SUCCESS] (state, action) {
        let { menuItems: menuItems } = state;
        const { menu_items: forgeMenuItems, admin_menu_items: forgeAdminMenuItems } = action.payload;
        if (forgeMenuItems && forgeMenuItems.length > 0) menuItems = (0, $iaicX.addMenuItemsById)(menuItems, (0, $iaicX.ROOT_MENU_ID), forgeMenuItems);
        if (forgeAdminMenuItems && forgeAdminMenuItems.length > 0) menuItems = (0, $iaicX.addMenuItemsById)(menuItems, "repo-settings-link", forgeAdminMenuItems);
        return {
            ...state,
            menuItems: (0, $iaicX.createNestedMenu)(menuItems)
        };
    },
    [(0, $jJd6W.FETCH_FORGE_REPO_MENU_ITEMS).ERROR] (state) {
        // Swallow error since showing an error to customers will be too noisy
        return state;
    }
});

});

parcelRegister("ea7l9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96cccb5eab11a55a$export$2e2bcd8739ae039; });

var $gsXeO = parcelRequire("gsXeO");
parcelRequire("gKeEi");
var $jJd6W = parcelRequire("jJd6W");
const $96cccb5eab11a55a$var$initialState = {
    hasError: false,
    isDialogOpen: false,
    isLoading: false,
    settings: null
};
var $96cccb5eab11a55a$export$2e2bcd8739ae039 = (0, $gsXeO.default)($96cccb5eab11a55a$var$initialState, {
    [(0, $jJd6W.FetchRepositorySubscriptions).REQUEST] (state) {
        return {
            ...state,
            isLoading: true
        };
    },
    [(0, $jJd6W.FetchRepositorySubscriptions).SUCCESS] (state, action) {
        return {
            ...state,
            isLoading: false,
            settings: action.payload
        };
    },
    [(0, $jJd6W.FetchRepositorySubscriptions).ERROR] (state) {
        return {
            ...state,
            hasError: true,
            isLoading: false
        };
    }
});

});


parcelRegister("ijBEs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa17a0cd38006b32$export$2e2bcd8739ae039; });

var $9u5BN = parcelRequire("9u5BN");
// Don't merge arrays; treat them like other non-object values and override
// @ts-ignore TODO: fix noImplicitAny error here
const $fa17a0cd38006b32$var$mergeArrayStrategy = (existingValue, incomingValue)=>{
    if (Array.isArray(existingValue) || Array.isArray(incomingValue)) return incomingValue;
    return undefined;
};
const $fa17a0cd38006b32$var$initialState = {
    users: {},
    projects: {},
    pullRequests: {},
    branches: {},
    repositories: {},
    commits: {},
    comments: {},
    tasks: {},
    commentLikes: {}
};
const $fa17a0cd38006b32$var$updateEntitiesWithinMap = (currentEntities, incomingEntities)=>{
    const startEmpty = {};
    return Object.keys(currentEntities).reduce((combinedMap, entityId)=>{
        const currentEntityById = currentEntities[entityId];
        const incomingEntityById = incomingEntities[entityId];
        // @ts-ignore TODO: fix noImplicitAny error here
        combinedMap[entityId] = (0, $9u5BN.default)({}, currentEntityById, incomingEntityById, $fa17a0cd38006b32$var$mergeArrayStrategy);
        return combinedMap;
    }, startEmpty);
};
/**
 * Takes two maps, each being a map of maps of normalized (normalizr) entities,
 * and composes a new map - adding and overwriting any fields found on incoming entities
 * in their place on the current entities while maintaining any values that the incoming
 * entity does not contain or update.
 *
 * @param {{}} currentEntityState
 * @param {{}} incomingEntityState
 * @return {{}} A new entity state object
 */ const $fa17a0cd38006b32$var$mergeAllEntities = (currentEntityState, // @ts-ignore TODO: fix noImplicitAny error here
incomingEntityState)=>Object.keys(currentEntityState).reduce((previousValue, entityType)=>{
        // @ts-ignore TODO: fix noImplicitAny error here
        const currentEntitiesByType = currentEntityState[entityType];
        const incomingEntitiesByType = incomingEntityState[entityType] || {};
        const combinedMap = $fa17a0cd38006b32$var$updateEntitiesWithinMap(currentEntitiesByType, incomingEntitiesByType);
        return {
            ...previousValue,
            [entityType]: {
                ...incomingEntitiesByType,
                ...combinedMap
            }
        };
    }, {});
var $fa17a0cd38006b32$export$2e2bcd8739ae039 = (state = $fa17a0cd38006b32$var$initialState, action)=>{
    if (action.payload && action.payload.entities) // TS does not like our merge function
    return $fa17a0cd38006b32$var$mergeAllEntities(state, action.payload.entities);
    return state;
};

});
parcelRegister("9u5BN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e7b442a76a14bfc$export$2e2bcd8739ae039; });

var $aSTrQ = parcelRequire("aSTrQ");

var $5sSw0 = parcelRequire("5sSw0");
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var $6e7b442a76a14bfc$var$mergeWith = (0, $5sSw0.default)(function(object, source, srcIndex, customizer) {
    (0, $aSTrQ.default)(object, source, srcIndex, customizer);
});
var $6e7b442a76a14bfc$export$2e2bcd8739ae039 = $6e7b442a76a14bfc$var$mergeWith;

});
parcelRegister("aSTrQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $020b83f5260ea2b1$export$2e2bcd8739ae039; });

var $9FAVP = parcelRequire("9FAVP");

var $kTYih = parcelRequire("kTYih");

var $eIeLQ = parcelRequire("eIeLQ");

var $f0lvK = parcelRequire("f0lvK");

var $bmzpf = parcelRequire("bmzpf");

var $a8rEz = parcelRequire("a8rEz");

var $aSkMU = parcelRequire("aSkMU");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $020b83f5260ea2b1$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, $eIeLQ.default)(source, function(srcValue, key) {
        stack || (stack = new (0, $9FAVP.default));
        if ((0, $bmzpf.default)(srcValue)) (0, $f0lvK.default)(object, source, key, srcIndex, $020b83f5260ea2b1$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, $aSkMU.default)(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, $kTYih.default)(object, key, newValue);
        }
    }, (0, $a8rEz.default));
}
var $020b83f5260ea2b1$export$2e2bcd8739ae039 = $020b83f5260ea2b1$var$baseMerge;

});
parcelRegister("kTYih", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f377b6cba1e9c67c$export$2e2bcd8739ae039; });

var $6x2Ar = parcelRequire("6x2Ar");

var $i9zf9 = parcelRequire("i9zf9");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $f377b6cba1e9c67c$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, $i9zf9.default)(object[key], value) || value === undefined && !(key in object)) (0, $6x2Ar.default)(object, key, value);
}
var $f377b6cba1e9c67c$export$2e2bcd8739ae039 = $f377b6cba1e9c67c$var$assignMergeValue;

});

parcelRegister("f0lvK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aec78abd76a6e471$export$2e2bcd8739ae039; });

var $kTYih = parcelRequire("kTYih");

var $7MC22 = parcelRequire("7MC22");

var $8akCi = parcelRequire("8akCi");

var $17hbZ = parcelRequire("17hbZ");

var $fU3gg = parcelRequire("fU3gg");

var $01Qmm = parcelRequire("01Qmm");

var $dEaOb = parcelRequire("dEaOb");

var $W5uJ7 = parcelRequire("W5uJ7");

var $3CsZM = parcelRequire("3CsZM");

var $EmE07 = parcelRequire("EmE07");

var $bmzpf = parcelRequire("bmzpf");

var $4vOvC = parcelRequire("4vOvC");

var $gsxmc = parcelRequire("gsxmc");

var $aSkMU = parcelRequire("aSkMU");

var $564Tg = parcelRequire("564Tg");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $aec78abd76a6e471$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, $aSkMU.default)(object, key), srcValue = (0, $aSkMU.default)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, $kTYih.default)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, $dEaOb.default)(srcValue), isBuff = !isArr && (0, $3CsZM.default)(srcValue), isTyped = !isArr && !isBuff && (0, $gsxmc.default)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, $dEaOb.default)(objValue)) newValue = objValue;
            else if ((0, $W5uJ7.default)(objValue)) newValue = (0, $17hbZ.default)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, $7MC22.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, $8akCi.default)(srcValue, true);
            } else newValue = [];
        } else if ((0, $4vOvC.default)(srcValue) || (0, $01Qmm.default)(srcValue)) {
            newValue = objValue;
            if ((0, $01Qmm.default)(objValue)) newValue = (0, $564Tg.default)(objValue);
            else if (!(0, $bmzpf.default)(objValue) || (0, $EmE07.default)(objValue)) newValue = (0, $fU3gg.default)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    (0, $kTYih.default)(object, key, newValue);
}
var $aec78abd76a6e471$export$2e2bcd8739ae039 = $aec78abd76a6e471$var$baseMergeDeep;

});
parcelRegister("W5uJ7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ae9ae016e083983$export$2e2bcd8739ae039; });

var $l3LBL = parcelRequire("l3LBL");

var $bqTHd = parcelRequire("bqTHd");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $0ae9ae016e083983$var$isArrayLikeObject(value) {
    return (0, $bqTHd.default)(value) && (0, $l3LBL.default)(value);
}
var $0ae9ae016e083983$export$2e2bcd8739ae039 = $0ae9ae016e083983$var$isArrayLikeObject;

});

parcelRegister("aSkMU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7eaf129347fe37ce$export$2e2bcd8739ae039; });
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $7eaf129347fe37ce$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
var $7eaf129347fe37ce$export$2e2bcd8739ae039 = $7eaf129347fe37ce$var$safeGet;

});

parcelRegister("564Tg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b614e6b6982062c$export$2e2bcd8739ae039; });

var $bSXSS = parcelRequire("bSXSS");

var $a8rEz = parcelRequire("a8rEz");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $3b614e6b6982062c$var$toPlainObject(value) {
    return (0, $bSXSS.default)(value, (0, $a8rEz.default)(value));
}
var $3b614e6b6982062c$export$2e2bcd8739ae039 = $3b614e6b6982062c$var$toPlainObject;

});



parcelRegister("5sSw0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fa9dae2c7d86aab$export$2e2bcd8739ae039; });

var $5qd1l = parcelRequire("5qd1l");

var $gjAj0 = parcelRequire("gjAj0");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $3fa9dae2c7d86aab$var$createAssigner(assigner) {
    return (0, $5qd1l.default)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && (0, $gjAj0.default)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
var $3fa9dae2c7d86aab$export$2e2bcd8739ae039 = $3fa9dae2c7d86aab$var$createAssigner;

});



parcelRegister("dqjg0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38bb82746ef128aa$export$2e2bcd8739ae039; });
parcelRequire("85vJP");
var $5Put2 = parcelRequire("5Put2");

var $gsXeO = parcelRequire("gsXeO");
const $38bb82746ef128aa$export$a4c7352cee32ee65 = 5;
const $38bb82746ef128aa$var$initialState = [];
var $38bb82746ef128aa$export$2e2bcd8739ae039 = (0, $gsXeO.default)($38bb82746ef128aa$var$initialState, {
    [(0, $5Put2.ADD_RECENTLY_VIEWED_WORKSPACE)] (state, action) {
        const workspaceId = action.payload.result;
        const idx = state.indexOf(workspaceId);
        if (idx === 0) return state;
        if (idx !== -1) return [
            workspaceId,
            ...state.slice(0, idx),
            ...state.slice(idx + 1)
        ];
        return [
            workspaceId,
            ...state.slice(0, $38bb82746ef128aa$export$a4c7352cee32ee65 - 1)
        ];
    },
    // Load cached UUIDs from localstorage
    [(0, $5Put2.GET_RECENTLY_VIEWED_WORKSPACES)] (state, action) {
        if (!action.payload) return state;
        return [
            ...action.payload
        ];
    }
});

});

parcelRegister("d69he", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2974847aa573b354$export$2e2bcd8739ae039; });

var $gsXeO = parcelRequire("gsXeO");
parcelRequire("85vJP");
var $5Put2 = parcelRequire("5Put2");
const $2974847aa573b354$export$d4c72bab9d6cc13a = {
    isWorkspacePremium: false,
    isWorkspacePaid: false,
    isFetchWorkspacePlanLoading: true,
    isFetchWorkspacePlanError: false
};
var $2974847aa573b354$export$2e2bcd8739ae039 = (0, $gsXeO.default)($2974847aa573b354$export$d4c72bab9d6cc13a, {
    [(0, $5Put2.FETCH_WORKSPACE_PLAN).REQUEST] (state) {
        return {
            ...state,
            isWorkspacePremium: false,
            isWorkspacePaid: false,
            isFetchWorkspacePlanLoading: true,
            isFetchWorkspacePlanError: false
        };
    },
    [(0, $5Put2.FETCH_WORKSPACE_PLAN).SUCCESS] (state, action) {
        return {
            ...state,
            ...action.payload,
            isWorkspacePremium: action.payload.isWorkspacePremium,
            isWorkspacePaid: action.payload.isWorkspacePaid,
            isFetchWorkspacePlanLoading: false,
            isFetchWorkspacePlanError: false
        };
    },
    [(0, $5Put2.FETCH_WORKSPACE_PLAN).ERROR] (state) {
        return {
            ...state,
            isWorkspacePremium: false,
            isWorkspacePaid: false,
            isFetchWorkspacePlanLoading: false,
            isFetchWorkspacePlanError: true
        };
    }
});

});



parcelRegister("kCp7J", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("1N8JN")).then(()=>parcelRequire("kq8Tr"));

});

parcelRegister("6xLEs", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("a4k5R")).then(()=>parcelRequire("3ZEu3"));

});

parcelRegister("8nu7L", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("bTH2r")).then(()=>parcelRequire("HpOHH"));

});

parcelRegister("kRJE7", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("kvQLU")).then(()=>parcelRequire("9wZs8"));

});

parcelRegister("7gMlt", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2t3s3")).then(()=>parcelRequire("puxwY"));

});

parcelRegister("4FzLb", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fqQTG")).then(()=>parcelRequire("6zsDZ"));

});

parcelRegister("2cVQD", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("gDl3h")).then(()=>parcelRequire("ktP5N"));

});

parcelRegister("fQYPZ", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("cCyht")).then(()=>parcelRequire("5qj9U"));

});

parcelRegister("9ofb8", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("gYwK2")).then(()=>parcelRequire("keL4x"));

});

parcelRegister("1IVLa", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("9z6XO")).then(()=>parcelRequire("aUFIX"));

});

parcelRegister("hMVYi", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("ilUbO")).then(()=>parcelRequire("7cUg8"));

});

parcelRegister("htYlK", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("l7Wn2")).then(()=>parcelRequire("fR0Gh"));

});

parcelRegister("3t2Eq", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("iXyKI")).then(()=>parcelRequire("48uWV"));

});

parcelRegister("lU3F6", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("fAhu1")).then(()=>parcelRequire("imnND"));

});

parcelRegister("e4QQi", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("jnGI9")).then(()=>parcelRequire("kOEwC"));

});

parcelRegister("j3WOu", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("2n7Tp")).then(()=>parcelRequire("9F9iv"));

});

parcelRegister("fmSVZ", function(module, exports) {


module.exports = (parcelRequire("3T95l"))((parcelRequire("7kEWw")).resolve("cQC9g")).then(()=>parcelRequire("aTzPn"));

});

var $90e340d1ce2a69aa$exports = {};


(parcelRequire("7kEWw")).register((parcelRequire("1sJKT")).getBundleURL("ekZ4q"), JSON.parse('["ekZ4q","app.js","82YIU","view.e889e989.js","dHQda","view.f715000b.js","6ju3c","global-error-image.c1b47184.svg","3op3S","version-dialog.3f64b206.js","7xLkx","star.5b133f96.js","fDD7i","star-filled.89aeb699.js","e0Fn7","version-dialog.38bea9aa.js","akPjh","custom-theme.126551ba.js","4MBts","atlassian-light.140dbb9c.js","2skkc","atlassian-light-future.01015342.js","2V7HR","atlassian-light-increased-contrast.781300c5.js","9vZaV","atlassian-dark.99f3068f.js","8TLP4","atlassian-dark-future.cf368378.js","iOiFq","atlassian-dark-increased-contrast.d769f8bf.js","iI02h","atlassian-legacy-light.c4a09fd8.js","fIlgO","atlassian-legacy-dark.3e2c8a7c.js","iLky3","atlassian-spacing.760a8048.js","bJEaP","atlassian-typography-adg3.22722b99.js","kmd9v","atlassian-shape.f1189818.js","3pgJS","atlassian-typography-modernized.669e568e.js","h2fOm","atlassian-typography-refreshed.cd32b75a.js","bccg2","atlassian-light-brand-refresh.18249ad6.js","6bI8z","atlassian-dark-brand-refresh.fe28004b.js","if9Mh","dev-tools.a0bb8494.js","l3ERW","dev-tools.f25ed4bb.css","5tg7m","chevron-down-circle.8afe0bc0.js","5tP4L","chevron-up-circle.a5b4d4ed.js","9ImEi","esm.2a42aa60.js","lphpO","payment.d41553c6.js","eJNfd","stripe.esm.b359b5ca.js","9r5Qy","payment.ec2047d2.js","kjN9y","payment.9bc45243.js","6qh0x","room-menu.ed75d2f8.js","9fvUP","menu.bad45e13.js","3XkvO","horizontal-navigation.5fa29607.js","fnf31","horizontal-platform-search.f2129bd6.js","h0ONo","result-provider.e23ea2d4.js","kXe4O","image.75d90f18.js","jTNOM","image.a97389de.js","c5HtY","no-results-light.bd1585ad.svg","iml8F","no-results-dark.ee3b67f2.svg","ifrTj","autocorrection-renderer.e50c624a.js","iU0qx","error-image.02c0cefb.js","hk8vR","image.58086f56.js","g8T2K","search-error-light.06089531.svg","lFxUG","search-error-dark.0c8be35a.svg","4Qxdd","drop-down-links.6ca64e1d.js","jOUMe","async-select.85de10a5.js","1WKZ5","feedback-collector.5472c71a.js","cYPPE","static-select-filter.8faba1b1.js","juVgr","multi-select-filter.864844f0.js","kETIY","multi-select-filter.c7a5faa2.js","a6U7k","result-provider.8114d88a.js","4nclW","frequent.8dca0ff8.js","lvTr3","esm.37f15d82.js","6LXwM","esm.165b3097.js","yPYUf","cs.a376dc10.js","d0lXL","da.13316247.js","esMSN","de.2d28b591.js","ak0KU","en.266cb415.js","90Qa9","en_GB.c671e67e.js","ePHPV","es.2d3cab14.js","dyW0o","et.1cb7af9a.js","45iSO","fi.e203860c.js","7bd1U","fr.d4053728.js","iJ8Ta","hu.f2b3e528.js","lodlZ","is.6d03de96.js","6tpNE","it.b5e41291.js","4Ctdv","ja.cd5b0df1.js","2AG5P","ko.280d70ed.js","4g3qk","nb.91820f3a.js","fJF8O","nl.0dc7b958.js","4VfFx","pl.dd94f5b3.js","cJ7vx","pt_BR.75a9cada.js","7hUwb","pt_PT.a72ffd26.js","laqJi","ro.d9518119.js","hGVFJ","ru.814b00e0.js","93sXv","sk.f256ce08.js","d4gHS","sv.865355d5.js","fQBQ4","th.1f29f8de.js","8DDKp","tr.79f9a858.js","jktRQ","uk.befcebb9.js","sBY1p","vi.277f7f7c.js","g2Jfg","zh_TW.2014ff0d.js","cTeiQ","zh.da00fe80.js","2K4u4","esm.dc5ea0ef.js","jSISz","esm.5462a8f7.js","iniB0","esm.6f037feb.js","cBRum","main.93309802.js","61VTW","main.eea917f8.js","kkz95","main.86cfdc0c.js","8tLXc","main.c5144a46.js","jT0BA","main.0467453f.js","akwb8","cs.c4e9fad3.js","kKs7U","da.5d9f30a1.js","3z0QL","de.f69e59e7.js","lhkM6","en.cc8b367d.js","gfK9e","en_GB.9112d094.js","cl8FP","es.335e933a.js","eD5Nu","et.ca6475d7.js","6I4OO","fi.9b3e5123.js","l1suV","fr.a116c3b0.js","fHSW7","hu.a1b69892.js","clnwz","is.ffccbcd9.js","862Ku","it.3f27267c.js","kvKwV","ja.b31f3c47.js","modtW","ko.b1865dfb.js","cMWp3","nb.fa3d966f.js","l3Ps9","nl.71748125.js","dXOwY","pl.8940597a.js","4gAsE","pt_BR.2bb33c18.js","95e78","pt_PT.61bf5c55.js","4Hdtc","ro.5acb5b60.js","73tO5","ru.117ce91f.js","fS8O9","sk.6fc3008d.js","783aK","sv.d935b958.js","imwLI","th.2ca77265.js","jTAR0","tr.4e6be4c5.js","1XhqM","uk.80d8519c.js","61TNZ","vi.c6861755.js","gM9ME","zh_TW.5ff10b3d.js","be7Ld","zh.39ae030a.js","bUF8s","search.0c670dc6.js","2MxGY","esm.0cc544a6.js","8AR8M","async-select.136366fc.js","akE9p","ai-answer-prompt.652bd31a.js","3eASR","ai-answer-prompt.3fb840c1.js","jFvy9","ai-answer-prompt.47cc4865.js","8Kj03","ai-answer-prompt.1ff551a9.js","8iMgb","esm.61536ed8.js","7RBPs","esm.78a7bb00.js","5xUPw","esm.5c776b2b.js","2Ju5h","chevron-up.73da11a9.js","i97km","esm.de92867b.js","7cR5y","component.7e763602.js","6HOT5","component.8f769efb.js","3iPrQ","component.f0ee46ed.js","bh9kU","16.0905c365.js","itBah","16.47eac7c0.js","2UKnc","16.9c468ccf.js","3MkXV","16.203543b5.js","ksv5q","16.2aaab64b.js","jciPY","16.2ab93edb.js","6bVMt","16.64ffcd51.js","c3sEy","16.a122ca49.js","ij39p","document-filled.777b62c2.js","Qm4tJ","16.02d25271.js","9MaaJ","16.61ed621c.js","86BdA","16.b5993c38.js","7q58B","16.8b0ef5da.js","kehQq","16.e4a121f2.js","f6qbw","16.9e9499ee.js","1xdwt","16.b27e0ad9.js","ee4wP","16.471f56f8.js","jw1mJ","attachment.1ef280e1.js","jbRKD","code.8f00bfcc.js","STtcd","component.5dd56bad.js","9uabR","lock-filled.d4a03a0d.js","iYCuF","component-lazy.2aff228b.js","icGKH","component-lazy.0a448313.js","7knCY","esm.683405e1.js","8axMs","esm.5fc51d14.js","3PHhR","16.bfe18b0c.js","fAbFO","16.a33fdbde.js","1BkNw","16.ddb51b2f.js","2f0r9","16.a6128a40.js","5Hrtp","16.25c1bbdd.js","fo2Zj","16.26a447c1.js","lBVVW","16.87c1c05d.js","gZB7T","16.df851563.js","22EIV","16.4d0984e5.js","i4KJ2","16.47c9833d.js","46kTO","16.bebd12c5.js","7vutF","16.4184ac9b.js","8wInW","16.84e243ed.js","3RW3t","16.ed97da10.js","bBicm","16.34c1d896.js","6uTCq","16.09b1039e.js","fTceL","16.a2963225.js","bktJl","EmbedModal.5ea4f64f.js","f9ZkJ","vid-full-screen-off.db83f308.js","2Nsyz","watch.14d90b00.js","dPXJe","like.48f54ebb.js","5YdNQ","arrow-up.6e3771a8.js","eZlQo","priority-blocker.2247eb84.js","fUpeR","priority-critical.30e0323e.js","cuc3F","priority-high.9972abff.js","dUh2Z","priority-highest.27eee714.js","9L8sN","priority-low.46eab333.js","2YbCy","priority-lowest.ea95122e.js","4QD9O","priority-major.2fd2179f.js","3quiL","priority-medium.09786be1.js","eQmAT","priority-minor.8d717b72.js","3ZX5A","priority-trivial.e53e2dd8.js","bg8pj","question.de2aaece.js","d2Sui","subtask.2451517e.js","8om1p","goal-icon.d94264aa.js","c3gQE","projects-icon.a9d1aaa3.js","4xtmq","manual-triggers-modal.ae02fdd0.js","4LbOP","manual-triggers-modal.79607895.js","5PrZD","RelatedLinksModal.46ad625e.js","3B6sv","esm.e883f6c3.js","3xV3Z","vid-full-screen-on.981840e2.js","9jmnm","link.c4ba2d75.js","c7qp4","copy.2bd4761f.js","6GaHv","edit.86b6b479.js","eaknl","invite-team.3850c979.js","d8Eky","actual-size.cb4f3589.js","6ONT9","child-issues.115cb5cd.js","lz5xF","hoverCard.4eb0b7da.js","bIraA","esm.fe2ed91a.js","ehpDH","esm.998d4d8a.js","E1SXg","windowedCodeBlock.25a0d1a7.js","kBrbX","block.9e38872a.js","dK06P","block.48c2c27e.js","4uFRJ","refractor.25e4f45b.js","fpPjH","refractor.83d9c3b2.js","1IFKx","windowedCodeBlock.8d3ba1c4.js","hEOlU","codeBlock.37451fbe.js","gNx4W","taskList.1cf64dc9.js","dBTOe","taskItem.3a7cabb6.js","dsH1h","checkbox.a5472d11.js","01reX","decisionList.a3b82eef.js","fYlmG","decisionItem.e1876946.js","dHS4R","decision.0599b2c0.js","ivUsM","date.ba6e5955.js","e0AHq","status.cebc5f17.js","2SKnt","emoji.88f6c180.js","5DtdX","ResourcedEmojiComponent.3320d3a4.js","hynlO","ResourcedEmojiComponent.848b524c.js","7I7DM","ResourcedEmojiComponent.d7ff867e.js","j5FWd","ResourcedEmojiComponent.3a93af71.js","qGqZn","emoji.210ed349.js","crcCZ","panel.372d37f3.js","29CQK","hint.f97b5319.js","brR7w","emoji.19b77bdc.js","4g3mE","embedCard.7ab845a9.js","jt4B0","datasourceRenderFailedAnalyticsWrapper.01dcc766.js","d6YFj","datasourceRenderFailedAnalyticsWrapper.8de05384.js","kVBe2","embedCard.05c5faaf.js","f0u79","inlineCard.e69e02b7.js","1Raok","blockCard.a5f6ec19.js","1J1xw","datasourceTableView.28b55231.js","7EpGy","datasourceTableView.dc16417b.js","69qfB","datasourceTableView.c14887bc.js","c7GjM","board.81a16bca.js","6JUPH","datasourceTableView.4e94fd8e.js","9QfrB","refresh.49bdb036.js","wYmWv","modal.bb8dd53b.js","8AvSa","modal.ee1e858d.js","1I1lF","modal.feaebde4.js","7hWLY","modal.44053537.js","jlbhG","modal.3f5389df.js","eVxMg","modal.0ec7bef8.js","hTBiX","modal.0744b1d4.js","j4ixL","ParseTreePatternMatcher.94d21788.js","1E2va","fit-to-page.7a0b8676.js","2kjCa","modal.9cf860dc.js","2Zgcf","modal.4107e1e7.js","1iczu","media.20f4bf0e.js","6aCG6","media.e27bf699.js","5to2p","media.43033944.js","j7saI","cardWithMediaClient.82b0ff0a.js","GTgpE","esm.97245915.js","5u5yM","media-viewer.d117ad73.js","5Fjzp","archive.9cd0fc04.js","4D3Fg","archive.ed946ad8.js","aUxPj","archive.e5674493.js","gYBdw","vid-play.8b53fff2.js","cy3jE","vid-pause.293a8176.js","hynw4","outgoing-sound.96b0ade2.js","alk8w","archive.e7e32ffe.js","aiOzU","audio.0c1bf19c.js","galje","archive.f2eafafa.js","aQBIW","78-EUC-H.7cc42a8e.js","fNIC9","78-EUC-V.7ca9ea80.js","5nW3N","78-H.88825b98.js","fQ2Kz","78-RKSJ-H.35703f06.js","1NuQM","78-RKSJ-V.65892088.js","4ks44","78-V.fd5ce4c1.js","kkcry","78ms-RKSJ-H.2212d4a6.js","dWtGR","78ms-RKSJ-V.cff3a20e.js","aU0pW","83pv-RKSJ-H.8b27175f.js","3uUsr","90ms-RKSJ-H.5944087a.js","2tt7e","90ms-RKSJ-V.f04c709e.js","36fkm","90msp-RKSJ-H.8edb47fe.js","lMqSh","90msp-RKSJ-V.e2437f5b.js","6qyhi","90pv-RKSJ-H.da666300.js","4aGNa","90pv-RKSJ-V.0f52a2c9.js","iQkdI","Add-H.02f41415.js","h4j01","Add-RKSJ-H.692f64b3.js","6IIYh","Add-RKSJ-V.f0da15a8.js","fFZSE","Add-V.05ce2b46.js","howDK","Adobe-CNS1-0.33672524.js","bSoSX","Adobe-CNS1-1.837286b5.js","7rz9x","Adobe-CNS1-2.f7930f1c.js","aDbDD","Adobe-CNS1-3.61bd86f6.js","aFyGw","Adobe-CNS1-4.cc4549b2.js","iQ2Mo","Adobe-CNS1-5.a6d3d0d8.js","iZbxI","Adobe-CNS1-6.96d0ae43.js","fHbHb","Adobe-CNS1-UCS2.7a848ac2.js","7girC","Adobe-GB1-0.4ad6f395.js","dyZEs","Adobe-GB1-1.5ea06d58.js","21f7q","Adobe-GB1-2.4641b42c.js","kXGCi","Adobe-GB1-3.ce36b07c.js","2mJ3V","Adobe-GB1-4.17e97da5.js","jwAV4","Adobe-GB1-5.15cdd66c.js","eYUIo","Adobe-GB1-UCS2.389fbe40.js","2PlrE","Adobe-Japan1-0.45d1ba55.js","ggsuh","Adobe-Japan1-1.7d3dad29.js","kE5yB","Adobe-Japan1-2.b181f998.js","iT96R","Adobe-Japan1-3.87323606.js","hNyJd","Adobe-Japan1-4.1a8ad9fa.js","9sPLL","Adobe-Japan1-5.d291922b.js","bEqnW","Adobe-Japan1-6.76d9d98c.js","8b0OC","Adobe-Japan1-UCS2.fe6011ff.js","6iMBd","Adobe-Korea1-0.33e0258f.js","fe3KX","Adobe-Korea1-1.a4c93ad5.js","fmBiD","Adobe-Korea1-2.2a3d518c.js","dHury","Adobe-Korea1-UCS2.beb7d725.js","banmc","B5-H.3e540c3f.js","86LUE","B5-V.51040136.js","34XIy","B5pc-H.cb319ae1.js","czgvK","B5pc-V.cd48fba0.js","9kYGW","CNS-EUC-H.9837c9eb.js","knGJX","CNS-EUC-V.ff1ec732.js","aBBQZ","CNS1-H.64c656b1.js","phZJR","CNS1-V.69f16c26.js","gAxUt","CNS2-H.e0c6886e.js","hFak3","CNS2-V.265147ca.js","4mHtt","ETHK-B5-H.3a5682b2.js","kPeQ3","ETHK-B5-V.299a6c75.js","foXUJ","ETen-B5-H.f6a27220.js","gHT9X","ETen-B5-V.dd89d84c.js","3C0vA","ETenms-B5-H.548a1944.js","iy0Lf","ETenms-B5-V.c696ab38.js","d8KwX","EUC-H.16be6997.js","1K2Vr","EUC-V.15205df9.js","fPWvx","Ext-H.920c8e61.js","23gbU","Ext-RKSJ-H.4eb6b638.js","cHR4Y","Ext-RKSJ-V.0adf8443.js","dT7R0","Ext-V.ab79e8d5.js","aC3ih","GB-EUC-H.6a951a5b.js","3Gav5","GB-EUC-V.440200b9.js","djjFe","GB-H.cdfbb08b.js","1AJCa","GB-V.cc924630.js","2CJpA","GBK-EUC-H.35bb4c6c.js","fwJmE","GBK-EUC-V.974d734a.js","fDH1o","GBK2K-H.34d7e55e.js","kpAPm","GBK2K-V.847904d3.js","bScXe","GBKp-EUC-H.f6778134.js","5MOh0","GBKp-EUC-V.cf8b0ac9.js","blexB","GBT-EUC-H.9a1de716.js","jtpkq","GBT-EUC-V.50243afd.js","905pC","GBT-H.aecec5de.js","eflQ1","GBT-V.882153ef.js","jnHf6","GBTpc-EUC-H.c55ae85f.js","9WclZ","GBTpc-EUC-V.181c6a40.js","6RLuK","GBpc-EUC-H.82858220.js","iwYE4","GBpc-EUC-V.48792281.js","9xWOL","H.d7585bd1.js","8hDEQ","HKdla-B5-H.ca0eb71d.js","eh0az","HKdla-B5-V.5b69e842.js","cL73x","HKdlb-B5-H.10059dec.js","8rKYd","HKdlb-B5-V.d1c44ce1.js","1IvpX","HKgccs-B5-H.a750a7f4.js","lvizP","HKgccs-B5-V.a5712237.js","9LquG","HKm314-B5-H.8b2ca07a.js","7TjM3","HKm314-B5-V.5fd00c2d.js","74WC2","HKm471-B5-H.18e10a85.js","dx7uJ","HKm471-B5-V.4eb1148b.js","bXaD9","HKscs-B5-H.27497baf.js","5w7S0","HKscs-B5-V.594af8f9.js","fRJ76","Hankaku.01384ef4.js","gQFeM","Hiragana.ae2e4a61.js","burpz","KSC-EUC-H.9961e65b.js","hFRT1","KSC-EUC-V.8798a1c3.js","hTOo7","KSC-H.aa954fdd.js","62CAk","KSC-Johab-H.bd809190.js","hOnLN","KSC-Johab-V.9a171a52.js","7qfSx","KSC-V.22204e1f.js","1ZGdB","KSCms-UHC-H.33def82b.js","8W5kP","KSCms-UHC-HW-H.eacb625a.js","dLgX6","KSCms-UHC-HW-V.51729cb4.js","euoKj","KSCms-UHC-V.6dc67e91.js","2vMo7","KSCpc-EUC-H.68c93ba8.js","4uTw8","KSCpc-EUC-V.497a6cbe.js","3Np5N","Katakana.14900ff0.js","7BW0W","NWP-H.0e17859e.js","1LpG4","NWP-V.28aedbf8.js","6bnN4","RKSJ-H.1ddd85ef.js","2ybGo","RKSJ-V.6af87819.js","1VkFr","Roman.611d2cca.js","gnKuS","UniCNS-UCS2-H.46e89d61.js","7tlQV","UniCNS-UCS2-V.70def79c.js","7yv4D","UniCNS-UTF16-H.dbaaa85b.js","8LHOi","UniCNS-UTF16-V.95317253.js","iDDdB","UniCNS-UTF32-H.2baea116.js","hEccv","UniCNS-UTF32-V.2b2451fe.js","dzYbB","UniCNS-UTF8-H.c1b448fa.js","hxBPo","UniCNS-UTF8-V.ff72400b.js","d0Iyy","UniGB-UCS2-H.efd301f0.js","8aYN7","UniGB-UCS2-V.6fff0150.js","cqzuj","UniGB-UTF16-H.51656082.js","h4zuB","UniGB-UTF16-V.81cc7027.js","4gXqR","UniGB-UTF32-H.fff1cf0d.js","gFPC1","UniGB-UTF32-V.8b716767.js","jlEWY","UniGB-UTF8-H.6fe19b61.js","fXey3","UniGB-UTF8-V.1121c901.js","5486R","UniJIS-UCS2-H.53c1b3c0.js","30DIx","UniJIS-UCS2-HW-H.75c6f5ad.js","aqzgd","UniJIS-UCS2-HW-V.1da09673.js","1qFoo","UniJIS-UCS2-V.45110c2a.js","3yBIn","UniJIS-UTF16-H.851776b1.js","8TDos","UniJIS-UTF16-V.9e6a2782.js","gSDOT","UniJIS-UTF32-H.32804f50.js","igPPV","UniJIS-UTF32-V.348b64d8.js","fTrt2","UniJIS-UTF8-H.b158613f.js","dkAgU","UniJIS-UTF8-V.4f4a9641.js","46n8W","UniJIS2004-UTF16-H.14e09b24.js","miO6Q","UniJIS2004-UTF16-V.0bf76633.js","bGqmy","UniJIS2004-UTF32-H.d0bf84d4.js","2TuMo","UniJIS2004-UTF32-V.2c0f6553.js","dXuL8","UniJIS2004-UTF8-H.2737c073.js","jt7K1","UniJIS2004-UTF8-V.4e2b469e.js","8tYDg","UniJISPro-UCS2-HW-V.be315299.js","ayXmA","UniJISPro-UCS2-V.aac90eba.js","ivgzH","UniJISPro-UTF8-V.623f362c.js","b6jK9","UniJISX0213-UTF32-H.6f08bb01.js","ku0YN","UniJISX0213-UTF32-V.8664920c.js","igXjS","UniJISX02132004-UTF32-H.1549972d.js","55uP9","UniJISX02132004-UTF32-V.351937e8.js","lHcRT","UniKS-UCS2-H.12cae7f5.js","k4k9H","UniKS-UCS2-V.864858b8.js","1iLQM","UniKS-UTF16-H.3c02968a.js","huJUl","UniKS-UTF16-V.c080e004.js","6wr4A","UniKS-UTF32-H.6d20aab7.js","49Ik9","UniKS-UTF32-V.1843cdf6.js","j0p9g","UniKS-UTF8-H.4b8d6eba.js","adBcv","UniKS-UTF8-V.88b2d321.js","ebAnA","V.6eebcadb.js","lHoTr","WP-Symbol.60d0ee50.js","56JCT","archive.8990b5c7.js","jg61y","home.3f2fc963.js","jusCF","codeViewerRenderer.37f18ff6.js","fzOIk","refractor.a56a864f.js","6I09Q","image.182952dc.js","gdIYx","video.ea842c66.js","4oI5Z","audio.94f8ef8d.js","bst22","doc.02c6ec2f.js","3b92b","codeViewer.66126188.js","5B0yY","horizontal-platform-search.47b9dbc2.js","WkV8T","codeViewer.c40c3bf5.js","9gTvo","svg.3428079a.js","fuXqt","svg.8a14e7b6.js","dhkTA","media-viewer.cf645e93.js","24cHP","vid-hd-circle.4859877a.js","eprgk","zoom-out.b236425b.js","intUE","zoom-in.6454ea28.js","kNQm7","media-viewer.50ff930d.js","8PEnp","chevron-left-circle.bc1e2ddd.js","j5HKS","chevron-right-circle.8c09c6d5.js","fSkXQ","media-viewer-analytics-error-boundary.7d4f5860.js","kf53N","inlinePlayer.1376c3de.js","hXt8u","esm.84e6a9ff.js","kzfRi","mobile-upload.cd7bb15a.js","aJhSx","mobile-upload.aae649a6.js","k4kQT","sha256SimpleHasher.6ce66c9a.js","eObrv","workerHasher.2b9b6cb6.js","jOr85","workerHasher.f047f7b7.js","2FaeY","simpleHasher.c0f05f03.js","dxn0d","cardWithMediaClient.a3409335.js","8Dio3","cardWithMediaClient.e32e7b3c.js","1QkO4","cardWithMediaClient.de808ef1.js","ekDEV","cardWithMediaClient.91c19014.js","hXKIr","cardWithMediaClient.f61e85ca.js","fDIac","js.35ec8a82.js","ewDhV","png-chunks-extract.c641a16a.js","c3BIL","horizontal-navigation.b2c9dd6a.js","gvTvM","cardWithMediaClient.73e05000.js","3ECa9","warning.7cedc322.js","jwKde","cardWithMediaClientV2.d89de2b7.js","7EFul","inlinePlayerV2.28a412b8.js","hUxd3","cardWithMediaClientV2.56e47e67.js","bnZXK","media.bb54abb8.js","lXgoP","media.bb33ee6c.js","jf1Fr","mediaGroup.2a95b533.js","apPbw","arrow-right.c6e8eb13.js","iI95P","mediaInline.48b35f1b.js","dO7De","mediaInline.c30bf403.js","4mfL8","media-viewer.a8a17094.js","5PPaJ","archive.c39089dc.js","2qONt","archive.6e08df6e.js","2laPL","78-EUC-H.40aae0b3.js","bzG85","78-EUC-V.328cf1d4.js","kxuTg","78-H.692fc6d4.js","agm3j","78-RKSJ-H.fbfbc469.js","8ITsE","78-RKSJ-V.083c0a72.js","fan6c","78-V.47db1af4.js","g09BE","78ms-RKSJ-H.ef42e630.js","kHnNV","78ms-RKSJ-V.cf72b6cd.js","lyb4z","83pv-RKSJ-H.1c0b3ccc.js","1RbVy","90ms-RKSJ-H.2aa30af6.js","143ij","90ms-RKSJ-V.5a4d0893.js","bi7KU","90msp-RKSJ-H.ea6750de.js","8hXpK","90msp-RKSJ-V.a1a6b671.js","fyB4x","90pv-RKSJ-H.f0ef88a1.js","jnByc","90pv-RKSJ-V.d3e3db63.js","gh48d","Add-H.117d422f.js","fmKV3","Add-RKSJ-H.be0aa40d.js","14KCl","Add-RKSJ-V.0bd02f88.js","brSJq","Add-V.74eb70c3.js","7IdOH","Adobe-CNS1-0.5a95bd3d.js","hdvPj","Adobe-CNS1-1.0a1f8b5c.js","ieMf1","Adobe-CNS1-2.9908fc85.js","8T9CU","Adobe-CNS1-3.3fdd6664.js","cqSFD","Adobe-CNS1-4.c7445516.js","aeMuV","Adobe-CNS1-5.f3f0d3b4.js","fwHSZ","Adobe-CNS1-6.7f40c90e.js","3Dbsy","Adobe-CNS1-UCS2.b6bb862f.js","kup4F","Adobe-GB1-0.19377eb4.js","iGYH9","Adobe-GB1-1.14f8fd5b.js","8ChDF","Adobe-GB1-2.d1610c69.js","i5lLV","Adobe-GB1-3.2902f19c.js","bTkuN","Adobe-GB1-4.cb2208e5.js","lexYz","Adobe-GB1-5.cecb3b75.js","jibe6","Adobe-GB1-UCS2.40d2ec25.js","bitWb","Adobe-Japan1-0.4521930b.js","ejd47","Adobe-Japan1-1.e805d733.js","gyN3v","Adobe-Japan1-2.91c30662.js","69XfV","Adobe-Japan1-3.10bf649a.js","jn471","Adobe-Japan1-4.863f170c.js","fSdcF","Adobe-Japan1-5.363555af.js","KpTfZ","Adobe-Japan1-6.c30e3d5f.js","dFbZO","Adobe-Japan1-UCS2.235cfd6a.js","ktXox","Adobe-Korea1-0.9c9b692e.js","j3GAm","Adobe-Korea1-1.4e907900.js","hC1Qg","Adobe-Korea1-2.fe143f24.js","5cAYC","Adobe-Korea1-UCS2.f7c4eac7.js","1jl7L","B5-H.d4b4bf31.js","lPY9O","B5-V.f89e63a1.js","53RT6","B5pc-H.98544041.js","7ogE0","B5pc-V.ff2c0b53.js","bFzNV","CNS-EUC-H.31697d92.js","ehXyd","CNS-EUC-V.78b99d74.js","dH0w1","CNS1-H.65463c6a.js","58rgQ","CNS1-V.a384db3a.js","e677D","CNS2-H.88ed5331.js","kr79K","CNS2-V.61fa5d36.js","jiuav","ETHK-B5-H.4a6f92ca.js","6EZhN","ETHK-B5-V.92029bbe.js","3Wmsc","ETen-B5-H.2924cddc.js","eYe5q","ETen-B5-V.12caaeb2.js","7dNbC","ETenms-B5-H.1bcf5ef5.js","1tJDg","ETenms-B5-V.4601b590.js","44T7T","EUC-H.6bde8fa9.js","axVGH","EUC-V.61f5fa98.js","9xJ3I","Ext-H.e573d362.js","gicVM","Ext-RKSJ-H.7d787422.js","k5teH","Ext-RKSJ-V.52f42b10.js","6BJWE","Ext-V.89845295.js","6wT6N","GB-EUC-H.4e695e36.js","jziBO","GB-EUC-V.0ad9de8d.js","5XF7F","GB-H.5a110a45.js","3VTPC","GB-V.706a4d8c.js","9ClWF","GBK-EUC-H.a27d4d24.js","jtno6","GBK-EUC-V.e6cc06c1.js","74wOR","GBK2K-H.6e8e1bc7.js","kYyE1","GBK2K-V.2b18713b.js","9FrOj","GBKp-EUC-H.cd72e59a.js","dBXy2","GBKp-EUC-V.6e7e0830.js","3dGBx","GBT-EUC-H.328ad454.js","cidn9","GBT-EUC-V.01d3a535.js","3IIxw","GBT-H.ea4d9fd2.js","hgMXu","GBT-V.8342cfde.js","lW6UM","GBTpc-EUC-H.75dbb61b.js","6J9x9","GBTpc-EUC-V.02ce4b0d.js","62V31","GBpc-EUC-H.42a84964.js","jowlA","GBpc-EUC-V.00a4e09b.js","dNvQH","H.6382654d.js","g4jDC","HKdla-B5-H.d98712a4.js","eu3t9","HKdla-B5-V.d81383ad.js","cBRTl","HKdlb-B5-H.8ed4ce67.js","M1j7O","HKdlb-B5-V.b0838687.js","49nnu","HKgccs-B5-H.8bcbb550.js","2MsEc","HKgccs-B5-V.e1dedbbe.js","9m7zm","HKm314-B5-H.4d5cadf7.js","ilIty","HKm314-B5-V.6259db40.js","bDUDM","HKm471-B5-H.00f4f072.js","lDbmq","HKm471-B5-V.d3b6e751.js","fJ15A","HKscs-B5-H.74d7a73b.js","e0G3R","HKscs-B5-V.4bb0e9d6.js","fmwUi","Hankaku.bffb9f82.js","d6h94","Hiragana.3efb3a7b.js","4EAVH","KSC-EUC-H.9e8db5a8.js","5Ci6H","KSC-EUC-V.1c1ca109.js","9pdXF","KSC-H.26c98983.js","f1BjO","KSC-Johab-H.513149cc.js","jYGnq","KSC-Johab-V.6a44d1db.js","8Cq1d","KSC-V.52e425b5.js","7rhvr","KSCms-UHC-H.477ddba9.js","7wQff","KSCms-UHC-HW-H.b7445d3a.js","2A03n","KSCms-UHC-HW-V.29da55ef.js","9aF6A","KSCms-UHC-V.eab30930.js","4PjEU","KSCpc-EUC-H.69033867.js","dRVbn","KSCpc-EUC-V.3a7a8a0d.js","6Hmur","Katakana.8f3ffafd.js","jBQ7g","NWP-H.9507c002.js","jnjn0","NWP-V.42d4500b.js","iWeeJ","RKSJ-H.a1396856.js","3myzB","RKSJ-V.dbdc1590.js","kcVeB","Roman.c3473fab.js","9CxXe","UniCNS-UCS2-H.eea641b1.js","7Ttip","UniCNS-UCS2-V.66aa23b7.js","2mMOY","UniCNS-UTF16-H.fb2a0941.js","aaImI","UniCNS-UTF16-V.23a9980a.js","2MYN7","UniCNS-UTF32-H.21acf101.js","eWPcW","UniCNS-UTF32-V.cd2a6f33.js","dZXOt","UniCNS-UTF8-H.b0cdab86.js","1XRu7","UniCNS-UTF8-V.1f62f2ea.js","2kJML","UniGB-UCS2-H.1fd86c86.js","5Ixkz","UniGB-UCS2-V.f18a4657.js","2D6TQ","UniGB-UTF16-H.851adbe5.js","6zUja","UniGB-UTF16-V.dea0b22f.js","7ihXQ","UniGB-UTF32-H.ba047dae.js","2YzgM","UniGB-UTF32-V.99ac0b1a.js","fADBj","UniGB-UTF8-H.3ec8446d.js","gjkuA","UniGB-UTF8-V.c19faea4.js","9pYsW","UniJIS-UCS2-H.2a8498eb.js","kyl3J","UniJIS-UCS2-HW-H.71b3a9a2.js","btY7z","UniJIS-UCS2-HW-V.0b878c42.js","3GcVJ","UniJIS-UCS2-V.5854064e.js","7S7vs","UniJIS-UTF16-H.fc29a1f9.js","8l504","UniJIS-UTF16-V.0c2ab77b.js","8t5DY","UniJIS-UTF32-H.9391fea8.js","cBHzL","UniJIS-UTF32-V.7da86f8b.js","49UCi","UniJIS-UTF8-H.ad2f6d78.js","drRDe","UniJIS-UTF8-V.5f73e408.js","audNp","UniJIS2004-UTF16-H.ba5f7024.js","cClRN","UniJIS2004-UTF16-V.8757d72e.js","5gGLZ","UniJIS2004-UTF32-H.b0fb0a83.js","7VbGz","UniJIS2004-UTF32-V.f7c07897.js","1o0e2","UniJIS2004-UTF8-H.ef0cc164.js","1Mj1g","UniJIS2004-UTF8-V.31e76399.js","lh2JL","UniJISPro-UCS2-HW-V.dd665807.js","44CBf","UniJISPro-UCS2-V.0083063a.js","cNy4d","UniJISPro-UTF8-V.a71feb02.js","2CuhU","UniJISX0213-UTF32-H.9e479ae4.js","3FMX7","UniJISX0213-UTF32-V.0b384f3d.js","eSOCC","UniJISX02132004-UTF32-H.aa365326.js","4cM5e","UniJISX02132004-UTF32-V.59fc4d72.js","5UdDg","UniKS-UCS2-H.bd78b55d.js","9m7xi","UniKS-UCS2-V.d594a9e7.js","xC9D4","UniKS-UTF16-H.872985de.js","aDI2d","UniKS-UTF16-V.0650ac3b.js","fulvI","UniKS-UTF32-H.d9a62fe0.js","8oCWJ","UniKS-UTF32-V.cc297b78.js","aVIFz","UniKS-UTF8-H.31ef8550.js","cclla","UniKS-UTF8-V.ed52a19b.js","h9eee","V.94d3d178.js","7Zsu3","WP-Symbol.63eed434.js","7U08v","archive.15c101dc.js","e3Xcl","codeViewerRenderer.72373499.js","aD4VA","refractor.e7818cc2.js","okfIf","image.8fb43973.js","gGC3c","video.f60b06f9.js","g1IQw","audio.3a316b99.js","9cF8r","doc.b4adca4b.js","ci7YD","codeViewer.40dc3b9e.js","6TeDQ","svg.1f43ce9a.js","84o1B","media-viewer.c41ca51e.js","dkJNI","media-viewer-analytics-error-boundary.5d5d80c2.js","eu5qW","mediaInlineCard.0631ed99.js","4ogeA","mediaInlineAnalyticsErrorBoundary.0b245592.js","cayk5","mediaSingle.bb68d88d.js","jQVVt","mention.6b3f2c35.js","4UyJR","mention.df1605fd.js","eLjSD","cs.48f1dc8a.js","dCD4z","da.9a097ff4.js","gltSi","de.1a0c7073.js","df4Ao","en.bede9a4b.js","cgRaE","en_GB.d2171c82.js","agfN3","es.b36e9a96.js","h02cj","et.672b33f7.js","a6GKl","fi.dec12674.js","gvsPT","fr.8d064065.js","4mCPA","hu.390b13dd.js","jZQm8","is.3653055e.js","ddA2o","it.b0360dc7.js","1JBtm","ja.40ca163a.js","8kNL6","ko.80f46d38.js","fmHN2","nb.dd9a20f0.js","28nic","nl.97c94b3f.js","f17lG","pl.2febece6.js","jkjhP","pt_BR.d46b882c.js","8zXtG","pt_PT.d2892ae0.js","kTSGo","ro.ff675fc4.js","5lDhW","ru.12850d1c.js","45JmX","sk.8aae620f.js","dI9rd","sv.b8d9a3f2.js","1W1z4","th.51728b00.js","bDWI9","tr.92d7115b.js","72m0T","uk.7becb7cb.js","4ZxTF","vi.535ad623.js","jXErC","zh_TW.6b9b9860.js","4hmm6","zh.f9bdeda3.js","GLuUR","main.b8eb41b9.js","eDWY0","Expand.858b2052.js","60Elp","esm.468e7888.js","hNX3j","esm.313908ef.js","1GCzw","react-markdown.2f5431e0.js","eEZpb","react-markdown.e41ec5ed.js","54byL","department.6146dff9.js","8HD1T","suitcase.9e944653.js","e5QpB","edit.53b8e5ff.js","7mZyb","annotate.855d3845.js","hawMg","book.5413b696.js","3rlr8","esm.788d57b6.js","I1qEo","quote.bde96afd.js","2tLqL","esm.ae01d39d.js","eFDzv","upsell-modal.731e801e.js","4WcBM","compass-bitbucket-upsell-banner.b40abb75.png","bUF79","horizontal-platform-search.d4af7219.js","kyrzF","platform-notifications.4aa39ef7.js","iELTY","main.50c2f212.js","eKLrc","toolbox-background.e4d51bfd.svg","gXXDs","cs.4c72a46e.js","11LWf","da.cf8a16a9.js","3ObIO","de.6b4d83ca.js","6Ckuf","es.292eb3a1.js","k9045","et.2840ef4b.js","cDvqP","fi.bf4a0e15.js","xVxIw","fr.8440829e.js","ryAXg","hu.727b1eef.js","6lb90","it.d3248088.js","37g8U","ja.d92375c4.js","fPQ0C","ko.3722c3cf.js","jpJSu","nb.72653057.js","l1taN","nl.b903e75a.js","bXNK8","pl.5bbea877.js","jTcOW","pt_BR.b4884f74.js","3vLHX","pt_PT.17475be3.js","2K0XF","ru.ecef5ed3.js","5mXuA","sk.727afe53.js","22fFA","sv.91354585.js","ftqiE","tr.e62c2994.js","KXa1G","th.3bca571e.js","l6jJg","uk.2f04e204.js","dYbv5","vi.78742f3f.js","biCkj","zh_TW.94202be8.js","1AZgA","zh.7f64e47a.js","iX5fn","main.d066412a.js","kKzZs","main.b7b2016b.js","8cyo3","main.50d57cc0.js","1jazd","check-circle-outline.f138a7a3.js","fli8N","list.cbcc35e5.js","eA4bz","more-vertical.ca005534.js","hQWQd","main.9d375e63.js","lLlFR","generic-error.5ff6294e.js","cJiP1","shortcut-pro-tip.9a754690.js","iQZT4","arrow-down.bbc82ec8.js","3IemL","inbox-announcement-banner.9c1a163b.js","02VRb","main.abd9e9fa.js","7B0aG","main.bcb57127.js","hfMvz","main.affd4960.js","3q79w","link-filled.2e3f8aa8.js","5zssi","document.85822f6b.js","jmG3K","video.40569ece.js","5697p","main.5465dd2e.js","hOgsX","main.b6e0666c.js","feaDC","esm.eafea156.js","3fjrW","notification.e609ef4a.js","oRkrx","horizontal-navigation.dd0fb427.js","6Ax6e","app-recommendation-flag.42eafdb0.js","3BlBN","ufo.ac964223.js","4GlgZ","app-recommendation-menu.f5fdb022.js","2ZuUc","atlassian-switcher.257f6675.js","jbxIS","cs.ef274f1d.js","aqwZy","da.f512040f.js","9aQRg","de.42a32f3e.js","03cGw","en_GB.8cfc3064.js","bhDYB","en_ZZ.b8b300f4.js","kO3Vu","en.dc89a923.js","04JL8","es.121d3bd1.js","gITLD","et.a949a771.js","c49zT","fi.f113d495.js","b2wWO","fr.a127d9ac.js","iYNx0","hu.f95d5f15.js","hHRcu","is.deb61e96.js","9zW9W","it.64081714.js","iKWtZ","ja.6e61a153.js","8Acul","ko.b3078310.js","ccTDC","nb.209c3d75.js","c3WsT","nl.deba8eae.js","bwpaB","pl.0db3977a.js","kNyCV","pt_BR.13fc2a2d.js","ztJjR","pt_PT.bbc92be5.js","lER9A","ro.ad1940ea.js","1J845","ru.4b510c0d.js","3kkD8","sk.0e4545c6.js","cpEXx","sv.4b847a80.js","gcYkr","th.1d4dc630.js","8WsaJ","tr.292ebe82.js","lMS5K","uk.09283bca.js","3xri8","vi.f20c8749.js","bDrwM","zh_TW.2652129c.js","4pcjo","zh.3d86566f.js","9TgNz","jira-switcher.6dbcdba8.js","jqvxK","jira-switcher.f9838652.js","7CWLI","ufo.b8852db6.js","8iumh","add.bf9d4d0a.js","k4j7y","discover-filled.9eeadd08.js","iSOsc","confluence-switcher.83c4c239.js","2MlK5","generic-switcher.afee8d37.js","knuV0","trello-switcher.886e8c69.js","86Mep","robot-error.5381259d.js","3KPVt","dark-mode.fd95cecc.svg","eaCtM","light-mode.9ae6186d.svg","2LsGx","match-browser.defc82cb.svg","1y6Fu","app-switcher.bcec7cc2.js","9fvz8","horizontal-navigation.486e913a.js","5M5fs","add.1f9a50f7.js","clqsk","horizontal-navigation.ce07f0a3.js","jvY8h","activity.5e5f63c1.js","fFNJN","atlassian.c1f98a11.js","3Sey2","labs.7cef0269.js","chFsr","person-circle.55bee247.js","fpwEn","main.7764ad2c.js","1iiJ8","web-vitals.ad998b0c.js","f4LfZ","tti-polyfill.5936b005.js","I0pYx","horizontal-mobile-nav.1bec0f3f.js","gBGtw","chevron-left.3ed31900.js","h77Cr","plan-selector.4dbd4bfc.js","inxIo","modal_bb_pricing_jswint.52dbb0b8.png","5vs0u","modal_bb_pricing_cicd.c9036311.png","1xkQW","modal_bb_pricing_chk.30c8a259.png","hcJnJ","modal_bb_pricing_ip.d2e9cb1e.png","kjUeY","modal_bb_pricing_enfchk.30c8a259.png","ewMX4","modal_bb_pricing_2fa.d2e9cb1e.png","70NH5","modal_bb_pricing_deperm.affd6f1c.png","1iik4","logo-atlassian-auth-box.921cf46f.svg","ekcoM","logo-gradient-blue-bitbucket.26647cfd.svg","aBBp0","page.4e140659.js","gQqOh","page.e8c3a4bc.css","5chan","add-circle.abfe8e90.js","aNQri","page.d4eadb04.js","gsLE0","search-empty.30342eab.svg","kc6Wc","search-nothing-found.524b4f56.svg","dx5v1","page.9063227b.js","2PGRk","search-error.7deca030.svg","i5DDp","page.08ddb6bd.js","6XRs7","page.07373a9e.js","3FKL4","empty-state.bbc38aa2.js","gsDjW","spot-hero-software-development.c9876bd2.svg","kTfQn","spot-hero-team-onboarding.d42ecfb6.svg","gSn8f","empty-state.455a624f.js","lHmBe","empty-state.28f1b56d.js","8FZFT","empty-state.5b8ac742.js","4lXxI","lock-circle.492c1da1.js","a0pdz","arrow-left-circle.2716f405.js","jokVj","empty-state.a6d27cdc.js","d6TmC","global-page.c1993472.js","j3iYS","dashboard-route.acdffb02.js","6zh6R","page.e3297729.js","4a5xy","access-keys.4cef802e.js","1kPIJ","access-keys.9c103069.js","1fgMc","security-shield.429c18dc.svg","6cSLd","error.da89091d.js","6SfDR","watch-filled.8bfbdf43.js","1fE2F","body.9de34772.js","4UJOf","esm.e8d44e68.js","7Ep3f","access-keys-legacy.b5dcbc55.js","69yuI","access-tokens.0450787f.js","eWB8F","access-tokens.d0ed1b55.js","fe2Co","access-tokens-empty-state-premium.89dc2e8c.svg","88Fvd","access-tokens-empty-state.534d1b5b.svg","auPO7","access-tokens-table-premium.c76d2198.svg","2H5Nx","access-tokens.d41a9514.js","g4iR0","branch-restrictions.bae4878d.js","hCFmN","branch-restrictions.eddbd876.js","cZR2e","git-branch.83e1fbbe.svg","fVUDo","branch-restrictions.92134c5c.js","kBzNL","branch-restrictions.4d225b0f.js","4vqEE","branching-model.1f1e3f92.js","567XC","branching-model.4f50b5c6.js","hKTti","default-reviewers.aa4c1614.js","3IMuw","default-reviewers.f0a5fed8.js","i3VAf","approved-versions.4846b639.svg","haDM0","project-details-page.8f8017a6.js","lpKC0","avatar-picker-dialog.3f4fca63.js","7CuNA","scale-large.c709808b.js","eWSpY","scale-small.f0ba3eca.js","at0ep","more.8443231f.js","9cz44","camera.33b8fb50.js","5QFiP","merge-strategies.99fe4523.js","6FBBc","permissions.51acbfe0.js","5ctRf","project-repositories-layout.d67aa5a1.js","a1B1B","file-cabinet-image.6e6312c2.svg","N6nXV","project-repositories-layout.c52dd5da.js","ic2sg","layout.f74da126.js","7ymi8","project-navigation-next.c8bfe255.js","5DZC4","routes.0b61b371.js","4CIKm","onboarding.382e41a1.js","8qtp1","onboarding.42eff580.css","7xaJ2","attachment.46670717.js","hfsfp","onboarding.19f538d8.js","kvXHM","large-file-storage.e0785573.png","bFmgq","pipeline.01d3d96a.png","iOpeK","pipes.16bbe4e2.png","4xsb5","deployments-logo.7cb8b9ef.png","ckejK","highlights.3d3f318f.js","133AZ","onboarding.47135b77.js","2cqKR","onboarding.bfec39be.js","8ZE02","refractor.71227548.js","wQ8eQ","onboarding.68175566.js","3vzef","remove.3613d232.js","9oryG","onboarding.9c698022.js","aMKTe","routes.e0821180.js","aaPJ5","routes.3933d747.js","jIhN8","onboarding.59747ed9.js","7V9cn","result-page.b9fb7483.js","5lGFs","CalendarIcon.0245dede.png","8nABb","step-viewer.e53ea74e.js","24toS","artifacts-viewer.f5e67308.js","65opU","metrics-viewer.503e9d07.js","5uJK1","service-log-viewer.360aca69.js","kAt7z","step-log-viewer.6159e22b.js","dDvRT","step-navigation.2250bbff.js","5skIl","test-reports-viewer.95cbbb85.js","iEY8M","expand.a4baee93.js","dnwag","trash.34be6b4c.js","agNXV","checkbox-indeterminate.f333159d.js","dQ1iV","notification-direct.4dc50b4f.js","8mnXo","export.db01c1f2.js","1LRGV","result-page.ea89fd18.js","72CA3","notification-all.68d5e845.js","6FvKn","open.d7b1351b.js","3eQpI","filter.6e937730.js","jkg4B","routes.d82f5385.js","cFFKC","routes.cf05dc71.js","jDJuC","folder-filled.9052fc8f.js","k7j7T","failed-build-status.b9b761db.js","HOeIP","routes.ea560a4d.js","hss6y","routes.a0969a6f.js","jJ9M1","log-line-worker.f8666c36.js","8JOMf","test-management-page.422bec15.js","iv1DM","test-execution-page.d19d363b.js","73MXG","merge-checks-empty-state.9f3f5bf0.svg","2dNQi","default-icon.94aec26c.svg","bEMdz","page.50523b12.js","dGcc6","access-keys.52556397.js","6kPvB","access-keys-legacy.86187c2a.js","1ysBT","access-tokens.f57b386c.js","16eyk","branch-restrictions.b1b55c2a.js","cuZzM","branching-model.f2a62f71.js","8sXwO","default-review-groups.72e5cd00.js","7B5O3","approved-versions.4846b639.svg","8CUpx","default-reviewers.738a82b4.js","luqjn","merge-checks.33595a07.js","2pPjJ","merge-strategies.dea8365e.js","hZpa1","permissions.3d524c80.js","lzNGy","deployments.29e9cb15.js","ilr10","dynamic-pipelines.a57e23cd.js","m4cCz","premium.8628b06e.svg","eWSl0","dynamic-pipelines.8e9b5ab3.js","9aMm2","openid.36c2ec39.js","kZ0dj","runners.4103fd14.js","cbM7u","runners.b41b173d.png","5gMKg","runners.47bd33b4.js","9gDpJ","runners.976844d9.js","gDBZz","settings.e5862d31.js","3pLdI","ssh-keys.727232c1.js","2F5GI","variables.201a9a28.js","vzwqp","page.04f81624.js","heAIB","kanban.8d92a07d.svg","jfUvg","error-state.3816ca6b.svg","eifma","bb-jira-integration.248fc0d9.svg","aOvmN","empty-state.5862907d.svg","hjhO6","route.41c3cc8f.js","02Tlq","empty-state.34f16b81.svg","cZ7JN","route.cdc099bd.js","7imFj","route.b3b872e8.js","cFY8F","file-cabinet-open.6e6312c2.svg","kQVXz","route.caaa63fa.js","76UCu","empty-state.d5f3bbe7.svg","3zl8N","route.580b5dee.js","5yI7S","route.a13236a4.js","5JtgB","label.43ce261f.js","kMnHx","route.39b125e4.js","5GGCj","route.31b91031.js","4A73m","empty-state.c4e885df.svg","l7t3y","resource-router-route.d07170fb.js","7ftH0","word-diff.worker.dda38847.js","kprU6","resource-router-route.9153e85d.css","cMAkB","page.186518f7.js","fCKzu","simple-workflow.a19e6c0c.svg","bLyWb","conflicts-dialog.0a739136.js","cSgD2","repo-pull-request-action-apps-list.e1d9e326.js","dFon2","repo-pull-request-action-apps-list.92411c0d.js","kYGbr","esm.1a9510c5.js","9Lzy7","loading-button.d41dc36d.js","ddhyi","add-item.454488b5.js","awnQp","app-access.f2fa5604.js","4bXCA","archive.6376b12a.js","2OMl6","arrow-down-circle.4234c6cb.js","6z5Tf","arrow-up-circle.33202927.js","fsshK","audio.f8d5f9ba.js","lrSWp","audio-circle.162b0f34.js","3toOp","backlog.a9baf1b6.js","7KQqa","billing.e1d5c057.js","koeuQ","billing-filled.5396712c.js","kVcqP","builds.ff16db90.js","9y808","clone.d1559db5.js","9IICp","forks.50a19d7c.js","9OtZz","output.0436a104.js","tqSGW","pipelines.475dc023.js","h5XFk","source.4d5f3fff.js","gCGMA","bullet-list.1f1ffbd6.js","dnZXC","calendar-filled.fd5021c0.js","fv7Ah","camera-filled.bcfaa20d.js","ay8tn","camera-rotate.2304c924.js","bKXsb","camera-take-picture.5ed6fbc7.js","j4t3j","canvas.3a4f7259.js","4RqtW","component.c5160e3c.js","fGnTz","creditcard.f369861c.js","4LeHE","creditcard-filled.6bcc8fd0.js","af2HE","decision.f40a57bf.js","aeFEn","detail-view.a5a07aed.js","7hqIv","discover.8c0ac25e.js","8fpfd","drag-handler.477910f4.js","8IroF","dropbox.ff712f28.js","fNHv1","edit-filled.9993bbfe.js","99l41","addon.50fcdd30.js","26Ac7","advanced.c14d673d.js","a8QsI","align-center.45935689.js","8vvQu","align-image-center.ef5740a3.js","bBRDC","align-image-left.c348a840.js","698Wy","align-image-right.be729c2a.js","4Z5gK","align-left.e6a9d168.js","OFubD","align-right.098187d7.js","6lXv2","background-color.d11d421b.js","67hVF","bold.2cfecd75.js","01Cq0","bullet-list.c4f621a3.js","9Z72W","collapse.d584a3da.js","gpX2l","date.0c70809b.js","atRgW","divider.993182a2.js","8F1w0","feedback.a7e93bc6.js","7O5Qv","file.78064d9f.js","cKH7w","file-preview.a8e887f0.js","yZTYR","help.20825d16.js","kOxHj","horizontal-rule.d55a342c.js","kFZFZ","image.97e2d747.js","cLi6K","image-border.084a6912.js","7BFVV","image-resize.61477770.js","5WB2D","indent.f6384882.js","1h5yN","italic.8d602c02.js","lPfXR","layout-single.e3281aba.js","7i3Vu","layout-three-equal.a7aa49f9.js","cop1u","layout-three-with-sidebars.26f6a846.js","dqScQ","layout-two-equal.f05fada5.js","eWMy1","layout-two-left-sidebar.8a618f34.js","cIRhG","layout-two-right-sidebar.5642dd88.js","16BZO","link.5235926a.js","8ijqV","media-center.97e099e3.js","hYn14","media-full-width.f69263d9.js","gLuK6","media-wide.924098a1.js","4xWwJ","media-wrap-left.9218ee8c.js","9Folh","media-wrap-right.97be5e1f.js","iFjY6","mention.dcefa3a8.js","hjU5N","note.f428b0ee.js","3EpCD","number-list.3d95e273.js","fLUvl","open.bb3e04d6.js","1i9uw","outdent.cc49d239.js","4iAh2","photo.5e7f2d93.js","1yZph","quote.fa7ba5de.js","iAueb","recent.f08c15a5.js","aYrej","redo.95999e44.js","8E7Zu","remove-emoji.c7d34bfb.js","dR023","settings.4ea74156.js","gSeiC","strikethrough.cbdeb0da.js","ft4wJ","table.9acc664e.js","fU6Ng","table-display-options.ea04f54a.js","5UxS7","task.ef64c58f.js","7TlRo","text-color.41b15602.js","f03da","text-style.cc9c301e.js","6GgRg","underline.26f5a0a1.js","6bxJD","undo.499ca7e0.js","g9sBw","unlink.4dad4e0b.js","lBdfD","emoji.c28fd3d5.js","b8hKF","emoji-add.41a05315.js","bpNUN","activity.3de8b72a.js","ftesi","custom.3fe59c81.js","1qY1e","emoji.7fbe6417.js","1hlQ5","flags.c1ecbc38.js","gNBOb","food.d5ee0eda.js","CPo0M","keyboard.2a4e22ec.js","5Y6KE","nature.0f505f64.js","ieknt","objects.97a3c5a7.js","kJCcp","people.1fb28f33.js","c4NpR","productivity.db439e39.js","asqSS","symbols.2de0a4e3.js","10D8Z","travel.fb9885ce.js","7ADv0","flag-filled.73de3e14.js","ebgg1","googledrive.3dc5e43c.js","bbKup","graph-bar.7f9c1ce3.js","2TwWt","gsuite.dfa644a2.js","2gq22","audio-only.2395625f.js","aUSU1","chevron-double-down.55837e35.js","ki5R7","chevron-double-up.818153e0.js","jPfkg","dial-out.40d087e6.js","klXjV","lobby.cef0df85.js","gQtNU","media-attachment-count.7fdacae3.js","4R7s1","sd-video.201e59ce.js","eGOei","home-circle.2db6e53c.js","j9iNG","image-border.25aca839.js","fu5Yv","image-resize.65687f54.js","6GySU","issue.fae7083c.js","erWLG","issue-raise.32542b81.js","dDZ2X","capture.2b08d85d.js","bb9TT","test-session.f374d27e.js","4K3b7","lightbulb.f1f11657.js","af4NI","lightbulb-filled.4b026f53.js","8Dm3b","add-comment.2786dea7.js","f91Ek","arrow.eef4f5ac.js","15w0C","blur.00511c4b.js","9uEVK","brush.994fcb5e.js","byav5","button-option.cab44c05.js","hLj91","code.b777cfff.js","jJkuG","document.d469874b.js","8pnXJ","filter.402a6068.js","dZBmy","full-screen.b99d581d.js","gMI60","grid.f41ac276.js","4DIic","image.bbca6618.js","6l9nr","line.31017163.js","a1ZF2","line-thickness.d2591044.js","egXzu","open-mediaviewer.6d6f5c1f.js","iClVX","oval.b8a81042.js","62Ugo","pdf.29ef2a78.js","ild7M","preselected.1c247440.js","dRnsz","presentation.65b3b0f0.js","243TO","rectangle.b9b35028.js","kgEuw","spreadsheet.b827e136.js","4ZXXT","text.39eb7902.js","3KCL8","unknown.bb28bfae.js","kvIy2","zip.650c984f.js","1chJ5","mention.13f78af0.js","9bwIv","menu-expand.3beeb629.js","jaeWe","mobile.cc401b2c.js","bWaXp","office-building-filled.9b9bbbbc.js","b46lZ","overview.e35627aa.js","7SZxm","page-filled.2578a6bd.js","q6fQg","pdf.eb2124df.js","hUhM7","person-with-circle.b4eb75da.js","aUAQc","person-with-cross.4082404c.js","9pHZJ","person-with-tick.d38911cc.js","llEzD","portfolio.825389a6.js","afvgz","preferences.44d387ff.js","8hFrM","presence-active.58f15fed.js","Sn3hW","presence-busy.d25aa9a4.js","fVWN1","presence-unavailable.a1e50e74.js","1vJPP","questions.68ec0101.js","j6ag7","queues.d7cea5bc.js","1jnBW","radio.6859f7b5.js","7K9PJ","redo.6c4a8879.js","18ZX7","retry.11a6ee45.js","hrgSf","roadmap.a8aa813b.js","2AiGM","schedule.1e43acc1.js","AD5rS","schedule-filled.10124499.js","e5mj4","screen.cba582da.js","5wyZc","send.71808c05.js","e0fQ7","share.7e13558e.js","qTRgf","sign-in.b4070e4d.js","harKM","sign-out.3306cbd5.js","dOGjZ","sprint.c8c50dc9.js","eDupc","star-large.23956b1a.js","4E3FO","status.ad6683ac.js","3OrRr","stopwatch.8b23784e.js","asyn3","switcher.8b48c6dd.js","gp02u","table.66e75c4f.js","7G2Vs","teams.290406a0.js","kwnzn","undo.f9e77d57.js","doZNo","unlink.2d8ec4c0.js","bTHWK","unlock.a83d9ca5.js","eyKsI","unlock-circle.bba7ac3b.js","7eRCI","unlock-filled.d238bd33.js","1lMUy","upload.7649a584.js","dCDSO","user-avatar-circle.2a558321.js","1Y2v0","vid-audio-muted.e2f040ad.js","4KVSZ","vid-audio-on.f6bb8657.js","aM68V","vid-backward.67567685.js","jet83","vid-camera-off.b1b280ac.js","d4UpB","vid-camera-on.56d137ab.js","iozRZ","vid-connection-circle.cc46a167.js","d25Dj","vid-forward.1bbb22cf.js","cisCZ","vid-hang-up.cccff4ba.js","iAvCM","vid-raised-hand.a21cfde4.js","aWFfM","vid-share-screen.8654d8ce.js","7CTFP","vid-speaking-circle.c674b03e.js","am1ax","vid-volume-full.90abeee7.js","fHW3L","vid-volume-half.69d3683d.js","3VG4m","vid-volume-muted.5e6ba25a.js","aLXAE","video-circle.f46489a4.js","d8ZUO","video-filled.c0cf26fc.js","6FPcR","world-small.5e10754e.js","b3NGT","custom-theme-button.8d660a20.js","gkJuP","section-message-action.27e70db8.js","jRFyR","esm.e793688b.js","1uXlZ","esm.d7e62633.js","lKlTo","esm.adc20961.js","4yFa9","esm.183427f3.js","aoYvC","refractor.55a66b1e.js","bkTT0","esm.87158d94.js","gKhww","esm.8335940b.js","7OuIm","esm.e30af3a4.js","euYDN","esm.6396f2de.js","eB43l","esm.5cb7d675.js","ckVCX","field.01f15784.js","2QwAM","esm.0ee861c5.js","4t92X","esm.77e69706.js","8mASu","esm.25da192d.js","lxLM5","esm.8943e2f3.js","79o2V","esm.67208590.js","913Ql","esm.571124c5.js","hw3vF","esm.1ffda047.js","2N6SR","esm.9cc7e4a9.js","TlbG8","esm.46966327.js","cX6ww","esm.25795195.js","7veky","charts.a772bd41.js","9qBUy","esm.67406d8d.js","hTbWp","esm.4774d6c6.js","694Si","repo-pull-request-action-single-app.a54ef2f5.js","fILzg","repo-pull-request-cards.489ce1cb.js","d7I0I","jira.304a1bac.png","a2ID6","code-insights-collapsed.6739b3b1.js","jrQ5d","code-insights.85466041.js","1Vcka","code-insights-empty-state.dd3fd996.png","4k1IN","attachments-panel-content.4735851c.js","lYtL8","pipelines-promotion-icon.8b4bf826.png","5jbPB","route.8ddd34f7.js","eWKx4","action.586502a0.js","27hCf","code.e1517d5a.js","dNR3c","date.28a18e6c.js","bTlrY","decision.d24e94e2.js","et0J8","divider.ae54221e.js","7ACTo","emoji.0d923daa.js","6V1h5","images.49bc776b.js","fRB4Z","layout.bf6aa14b.js","9p5iL","link.e92661d3.js","iRzjc","list-number.d718a487.js","jfC5B","list.41124848.js","7sznO","mention.48cd8c8f.js","dL8Pk","panel-error.7df71a00.js","dPJ8H","panel-note.ba44b812.js","hDmaR","panel-success.32ab6253.js","e9wnI","panel-warning.e97a77e8.js","lviFS","panel.d65ab71a.js","6rkhZ","quote.a2ca3e8b.js","2LC3x","status.2c7213a5.js","kyCop","heading1.7e951d78.js","72iwB","heading2.f9780306.js","f5NIO","heading3.5f012baf.js","54VvE","heading4.8abccbca.js","j8L5i","heading5.44ae70a3.js","292lS","heading6.0231afe2.js","8VZF2","feedback.1ca5b454.js","2N6R9","expand.632565c3.js","jbxSH","datasource-jira-issue.4e32dc45.js","d7HHU","datasource-assets-objects.4886ce87.js","gQjN1","datasource-confluence-search.9b97374c.js","DsT8O","loom.d57dc91a.js","21M28","link-picker.0eb2a4d2.js","gd2JB","cs.b90dce64.js","gXqC8","da.d73623bf.js","fma6l","de.73effcbd.js","aIqIw","en_GB.6cafcccf.js","WCl1h","en_ZZ.74fbc4b4.js","iChRc","es.4be0aaac.js","9XoFZ","fi.e1479c13.js","iV5YG","fr.c08b4a3c.js","7T6yl","hu.556d41b8.js","cklky","it.c320fccc.js","aPEj3","ja.ed152b10.js","40FCn","ko.b753a06a.js","lfrQ7","nb.4780c14a.js","3W32l","nl.9b46374b.js","bKYy4","pl.8b133168.js","lNUQS","pt_BR.cd863128.js","gU0kB","ru.5dabff0f.js","b1dZT","sv.ae184fa7.js","kf1BS","th.bc1b0913.js","13crn","tr.55e7128f.js","cFGML","uk.9570324b.js","3TMBV","vi.7e0c5151.js","2cyCq","zh_TW.0b74ad46.js","aUnWG","zh.e7ace534.js","aKZay","fire-event.d1ae5f28.js","5IjQ3","DatePicker.5db79949.js","82NEU","ConfigPanelFieldsLoader.86c98456.js","4xbBO","ui.9ecab538.js","d7Qoj","EmojiPickerComponent.cae4bf6d.js","f6nXA","ElementBrowser.1dfe0bfb.js","k88r7","dropzone.f78c3270.js","j7UAJ","dropzone.6ecdb915.js","1eq6r","media-picker-analytics-error-boundary.a53f3472.js","4VXXb","clipboard.0135a5ab.js","4jRVi","browser.0321ee36.js","7al9D","table.19a8fca0.js","Tdr9Q","Toolbar.c1a3db3d.js","fqtiY","global-opt-in-default-image-banner.8c1c680b.svg","3FjAl","outdated-annotations-button.2b74e339.js","6cFsM","source-diff.f1d72142.js","5NvlX","annotation-result-failed-icon.551564eb.svg","4gHiV","annotation-result-ignored-icon.526423e4.svg","5rkmV","annotation-result-passed-icon.3dc0e2a9.svg","2QQI9","annotation-result-skipped-icon.324bf075.svg","1lKHr","annotation-severity-critical-icon.c8c3531f.svg","4pINr","annotation-severity-high-icon.06924edc.svg","joEZi","annotation-severity-low-icon.a318221a.svg","bCUph","annotation-severity-medium-icon.02bebc0c.svg","hFPDk","route.20035b24.js","7O1Mm","route.4262bca6.js","dRLzG","word-diff.worker.6da66202.js","lsxs9","calendar-icon.0245dede.png","2YIib","security-landing-page.3760438c.js","kdyDL","snyk.b184e020.svg","luFYU","devsecops.f3991b86.svg","iUMXo","hero.7ab6e120.png","kephU","scanning.801e1b65.svg","hohJU","security-landing-page.c359e7a3.js","24vFm","security-learn-more-page.d7bf72ef.js","cfyPA","learn-more-1.74b9d019.png","lBxBM","learn-more-2.1954a07a.png","5VZZV","learn-more-3.b7596166.png","dS02E","snyk-companies.b5146bea.png","2glIO","snyk-with-wordmark.6e38faf4.png","gw4te","layout.9bdb79e1.js","3hpBM","error-illustration.5855be79.svg","k7DuI","repository-navigation-next.e2af5f50.js","17ruM","repository-redirect.c44f24c1.js","N69WE","source-diff.b3a631a5.js","6l0sN","source-diff.16809578.js","fVP4k","source-diff.d1ed373c.js","ktqxM","source-diff.8deca64d.js","bs5cl","repo-code-overview-action-apps-list.c5cd964b.js","Wc2nS","repo-code-overview-action-single-app.4f80ba0a.js","4Ebsp","repo-code-overview-cards.8a183f36.js","i6lKf","component.4de44e77.js","5hZqZ","component.92ade25f.js","5tls0","EmbedModal.efdcc54c.js","cORgh","goal-icon.108c82eb.js","6phTk","projects-icon.984f3b21.js","aUHU9","manual-triggers-modal.ccd1ae20.js","5cave","component-lazy.99035a4f.js","b1ziB","source-diff.64dfb417.js","bIgAg","source-diff.c568cdf5.js","cPZvG","compass-banner.9eb9b2c9.svg","95va2","compass-empty-state-card.055b7a63.svg","lfoTT","file-history-wrapped.96e52f08.js","dycjn","history-redirect.18772e25.js","fwSZ4","source-browser-resource-router.f16d54dd.js","5qPod","empty-folder.c06d9939.svg","2G5Hh","editor.worker.36cffd90.js","7Nirq","editor.worker.62578e99.js","l5qvr","css.worker.4a9daee3.js","7Nirq","editor.worker.62578e99.js","crWmG","html.worker.d3d3e27a.js","7Nirq","editor.worker.62578e99.js","dS8k6","json.worker.d3f692e7.js","7Nirq","editor.worker.62578e99.js","idBan","ts.worker.d52b7031.js","7Nirq","editor.worker.62578e99.js","jXS8d","react-monaco-editor.3c0158d4.js","37t3V","tsMode.b82816ce.js","4wefn","cssMode.2d0e1d57.js","aULNx","jsonMode.5dab08d4.js","fqYs9","htmlMode.75a9345e.js","4bOrL","bat.2dbeb350.js","31a9S","coffee.002ebf1d.js","ghpcm","cpp.7f8af8ef.js","4HusA","csharp.e477dfe4.js","guPzV","csp.0b0ad6c6.js","6Stu5","css.39a01cde.js","07FGM","dockerfile.5f0c66d5.js","dsHqB","fsharp.b22fa44b.js","a5rrb","go.3212b8ae.js","jT6lN","handlebars.1fcff257.js","gspfW","html.1ecd33d0.js","cjH14","ini.bf84112d.js","9c7Cl","java.9a0e1a0a.js","dAOuu","less.e0215193.js","gvyPc","lua.fa39685f.js","jnLqY","markdown.20c6f06f.js","eysEz","msdax.3ab5153b.js","3rS3A","mysql.50ca0ab1.js","hQSsZ","objective-c.8d96018b.js","cXhWt","pgsql.b54864e4.js","25BjT","php.e9b43616.js","5APyg","postiats.72086485.js","gZek0","powershell.f94eec4b.js","5igAu","pug.7f930d31.js","5HCvt","python.21db2435.js","fxs0n","r.53184daf.js","145Uw","razor.f27d70e1.js","bnaP0","redis.d0ac8500.js","e5Jmr","redshift.edaaf35a.js","4askW","ruby.3217f71e.js","4lWn6","rust.57879fed.js","4S7kc","sb.712ee3ab.js","6fTej","scss.cc6d2087.js","b7Dkz","solidity.f55121a9.js","fK9bg","sql.a29e63b3.js","pyuBk","st.fc09fc67.js","9KhS4","swift.effccedf.js","aBoe3","vb.a14be9da.js","jac9L","xml.a4b2a561.js","gb7tZ","yaml.852c087f.js","hdIaF","react-monaco-editor.2f22223c.css","9JIkx","route.9463914b.js","CdPRh","route.2d21368e.js","f9iih","repo-main-menu-page.e570b36f.js","7K1lz","repo-settings-menu-page.cff29180.js","iHB3M","jira.ea9bb3b5.js","fDxQD","page.01d2b269.js","7A97d","empty-state-connect.3e3653a7.svg","is7G0","empty-state-try-screen-1.441ffb20.png","48t4Y","empty-state-try-screen-2.97e7b8f1.mp4","Z3qou","empty-state-try-screen-2.c4b4ebec.png","lYc9R","empty-state-try-screen-3.f68d71bd.mp4","dJ3Ce","empty-state-try-screen-3.087d5fe5.png","dvei2","empty-state-try-screen-4.5e2902b8.png","dZdkW","onboarding-step-1.537d9448.png","c95nK","onboarding-step-2.36283014.png","69lfQ","onboarding-step-3.133f09e6.png","hIKrw","firewall-key.ab7b7a13.svg","6Jsra","backlog.03338775.svg","7099w","generic-no-results.17483eb6.svg","gCcdw","empty-folder.a877d856.svg","9FCbj","issues-list-preview.6b7c6e1a.png","e2MIJ","linking-options.f4ff41d4.svg","8p5ny","project-icon-white.58c28598.svg","6V3GV","project-icon.893ec8ff.svg","fgeUo","page.fd817c67.js","kozTx","pages.0c3dab31.js","a52Df","index.esm.6e5eef7e.js","eLvrF","index.esm.e7fa38f9.js","dLN2R","details.93292cc5.js","8mm1s","compliance.34b695ae.js","4P6f0","username-aliases.4a366a0f.js","1v9LL","route.c7fee17c.js","3s4yG","to-frontbucket-deployments.c0e058f9.js","8bIbR","to-frontbucket-runners.42d446fd.js","c2d9Y","access-tokens.c57a1092.js","dp5FD","permissions.ca63f313.js","9Qnhv","dynamic-pipelines.990f6e39.js","8R4F2","runners.94f4bd3a.js","5TlsJ","variables.4c8ac491.js","buqAL","root-redirect.12cf9b47.js","duu9J","containers.5129c1d0.js","faC7A","empty-repo-avatar.aa6b33d2.svg","8sy36","empty-state.c9bcc4ee.svg","8YPZB","layout.6744e620.js","cQPJu","container-navigation.211acefb.js","2iDSb","settings-layout.2b5fae50.js","8KT6g","profile-navigation-next.ef842739.js","hI4T6","create-workspace-page.d645f4f8.js","4VY1u","create-workspace.e0c140bc.svg","cdT6X","route.a3f4a921.js","ewUvT","route.57afa1e7.js","lcAz2","route.8e9f5c11.js","c8k6J","resource-router-route.60569787.js","k923v","settings-connect-iframe.11080956.js","azvsv","workspace-settings-menu-page.3bf37f51.js","jmLwq","settings-iframe.949793e7.js","ltrPs","group.00fd66c7.js","5ZKZo","group.ce44dc8c.js","iIO0Z","groups.057503d0.js","fyTtw","settings-index.cdc58d1a.js","kPXIw","user-directory.055a4d42.js","kSZdj","atlassian-intelligence.6455a27f.js","2KoxF","compass-workspace-settings-page.d254261d.js","7p8ty","compass-background.ce5ec93a.svg","9epQ8","merge-checks-workspace-settings-page.12da673a.js","8XOzv","to-frontbucket-settings.e12e853a.js","kO3S7","to-frontbucket-runners.20e65ced.js","li3nF","termsofservice_modalimage.69da62b8.png","1N8JN","cs.6b0a638c.js","a4k5R","de.7405ce01.js","bTH2r","es.150f12ba.js","kvQLU","fr.dcb35f63.js","2t3s3","it.9e0b4d4c.js","fqQTG","ja.7b02e799.js","gDl3h","ko.12bcb9d5.js","cCyht","nl.185e21be.js","gYwK2","pl.1f9be4c7.js","9z6XO","pt_BR.43729125.js","ilUbO","ru.66e6643e.js","l7Wn2","sv.c167935a.js","iXyKI","tr.f6933c7e.js","fAhu1","uk.40c9037f.js","jnGI9","vi.225bd94d.js","2n7Tp","zh.f5744f44.js","cQC9g","en.6d74e2aa.js"]'));

// This will get expanded by babel-preset-env's useBuiltins so we only get the polyfills needed
// for our targeted browsers.
var $29d6451600dfd5bb$exports = {};
var $29d6451600dfd5bb$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$29d6451600dfd5bb$exports = // eslint-disable-next-line es/no-global-this -- safe
$29d6451600dfd5bb$var$check(typeof globalThis == "object" && globalThis) || $29d6451600dfd5bb$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$29d6451600dfd5bb$var$check(typeof self == "object" && self) || $29d6451600dfd5bb$var$check(typeof $parcel$global == "object" && $parcel$global) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();


var $914f9d5e042cd52c$exports = {};
var $785f01b450cff054$exports = {};
$785f01b450cff054$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$914f9d5e042cd52c$exports = !$785f01b450cff054$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});


var $134ed1e28f84dc44$exports = {};
var $ef4a3456c7dbf9ed$exports = {};
var $e7c42e8ddd2b26fb$exports = {};
var $bf16ccdb59a4d1f9$exports = {};

$bf16ccdb59a4d1f9$exports = !$785f01b450cff054$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $e7c42e8ddd2b26fb$var$FunctionPrototype = Function.prototype;
var $e7c42e8ddd2b26fb$var$call = $e7c42e8ddd2b26fb$var$FunctionPrototype.call;
var $e7c42e8ddd2b26fb$var$uncurryThisWithBind = $bf16ccdb59a4d1f9$exports && $e7c42e8ddd2b26fb$var$FunctionPrototype.bind.bind($e7c42e8ddd2b26fb$var$call, $e7c42e8ddd2b26fb$var$call);
$e7c42e8ddd2b26fb$exports = $bf16ccdb59a4d1f9$exports ? $e7c42e8ddd2b26fb$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $e7c42e8ddd2b26fb$var$call.apply(fn, arguments);
    };
};



var $e857ae4b90351a33$exports = {};
var $f78d19799c92f446$exports = {};
var $f78d19799c92f446$var$documentAll = typeof document == "object" && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var $f78d19799c92f446$var$IS_HTMLDDA = typeof $f78d19799c92f446$var$documentAll == "undefined" && $f78d19799c92f446$var$documentAll !== undefined;
$f78d19799c92f446$exports = {
    all: $f78d19799c92f446$var$documentAll,
    IS_HTMLDDA: $f78d19799c92f446$var$IS_HTMLDDA
};


var $e857ae4b90351a33$var$documentAll = $f78d19799c92f446$exports.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
$e857ae4b90351a33$exports = $f78d19799c92f446$exports.IS_HTMLDDA ? function(argument) {
    return typeof argument == "function" || argument === $e857ae4b90351a33$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};


var $3959dbb6e98149cc$exports = {};

var $fe377fc6c61a7ce1$exports = {};
var $fe00a6e80b387ac1$exports = {};
var $c402ab447eedfa45$exports = {};
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$c402ab447eedfa45$exports = function(it) {
    return it === null || it === undefined;
};


var $fe00a6e80b387ac1$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$fe00a6e80b387ac1$exports = function(it) {
    if ($c402ab447eedfa45$exports(it)) throw $fe00a6e80b387ac1$var$$TypeError("Can't call method on " + it);
    return it;
};


var $fe377fc6c61a7ce1$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$fe377fc6c61a7ce1$exports = function(argument) {
    return $fe377fc6c61a7ce1$var$$Object($fe00a6e80b387ac1$exports(argument));
};


var $3959dbb6e98149cc$var$hasOwnProperty = $e7c42e8ddd2b26fb$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$3959dbb6e98149cc$exports = Object.hasOwn || function hasOwn(it, key) {
    return $3959dbb6e98149cc$var$hasOwnProperty($fe377fc6c61a7ce1$exports(it), key);
};



var $aa3e8552473de647$exports = {};


var $aa3e8552473de647$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $aa3e8552473de647$var$getDescriptor = $914f9d5e042cd52c$exports && Object.getOwnPropertyDescriptor;
var $aa3e8552473de647$var$EXISTS = $3959dbb6e98149cc$exports($aa3e8552473de647$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $aa3e8552473de647$var$PROPER = $aa3e8552473de647$var$EXISTS && (function something() {}).name === "something";
var $aa3e8552473de647$var$CONFIGURABLE = $aa3e8552473de647$var$EXISTS && (!$914f9d5e042cd52c$exports || $914f9d5e042cd52c$exports && $aa3e8552473de647$var$getDescriptor($aa3e8552473de647$var$FunctionPrototype, "name").configurable);
$aa3e8552473de647$exports = {
    EXISTS: $aa3e8552473de647$var$EXISTS,
    PROPER: $aa3e8552473de647$var$PROPER,
    CONFIGURABLE: $aa3e8552473de647$var$CONFIGURABLE
};


var $ef4a3456c7dbf9ed$require$CONFIGURABLE_FUNCTION_NAME = $aa3e8552473de647$exports.CONFIGURABLE;
var $73a352fb9d151a74$exports = {};


var $38e9b23635a041cc$exports = {};

var $3803ab888f1a7d44$exports = {};

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $3803ab888f1a7d44$var$defineProperty = Object.defineProperty;
$3803ab888f1a7d44$exports = function(key, value) {
    try {
        $3803ab888f1a7d44$var$defineProperty($29d6451600dfd5bb$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $29d6451600dfd5bb$exports[key] = value;
    }
    return value;
};


var $38e9b23635a041cc$var$SHARED = "__core-js_shared__";
var $38e9b23635a041cc$var$store = $29d6451600dfd5bb$exports[$38e9b23635a041cc$var$SHARED] || $3803ab888f1a7d44$exports($38e9b23635a041cc$var$SHARED, {});
$38e9b23635a041cc$exports = $38e9b23635a041cc$var$store;


var $73a352fb9d151a74$var$functionToString = $e7c42e8ddd2b26fb$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$e857ae4b90351a33$exports($38e9b23635a041cc$exports.inspectSource)) $38e9b23635a041cc$exports.inspectSource = function(it) {
    return $73a352fb9d151a74$var$functionToString(it);
};
$73a352fb9d151a74$exports = $38e9b23635a041cc$exports.inspectSource;


var $68639cbf8bec6c8f$exports = {};
var $374bc02c35eb3df6$exports = {};


var $374bc02c35eb3df6$var$WeakMap = $29d6451600dfd5bb$exports.WeakMap;
$374bc02c35eb3df6$exports = $e857ae4b90351a33$exports($374bc02c35eb3df6$var$WeakMap) && /native code/.test(String($374bc02c35eb3df6$var$WeakMap));



var $e2b40057776e4ecf$exports = {};


var $e2b40057776e4ecf$var$documentAll = $f78d19799c92f446$exports.all;
$e2b40057776e4ecf$exports = $f78d19799c92f446$exports.IS_HTMLDDA ? function(it) {
    return typeof it == "object" ? it !== null : $e857ae4b90351a33$exports(it) || it === $e2b40057776e4ecf$var$documentAll;
} : function(it) {
    return typeof it == "object" ? it !== null : $e857ae4b90351a33$exports(it);
};


var $e2a7ba2084340e9c$exports = {};

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $5b3b5e53fb7b085c$export$2d1720544b23b823;

var $92feab208e75d616$exports = {};


var $390d2a11631acc00$exports = {};


var $390d2a11631acc00$var$document = $29d6451600dfd5bb$exports.document;
// typeof document.createElement is 'object' in old IE
var $390d2a11631acc00$var$EXISTS = $e2b40057776e4ecf$exports($390d2a11631acc00$var$document) && $e2b40057776e4ecf$exports($390d2a11631acc00$var$document.createElement);
$390d2a11631acc00$exports = function(it) {
    return $390d2a11631acc00$var$EXISTS ? $390d2a11631acc00$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$92feab208e75d616$exports = !$914f9d5e042cd52c$exports && !$785f01b450cff054$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($390d2a11631acc00$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});


var $0de256c44a607733$exports = {};


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$0de256c44a607733$exports = $914f9d5e042cd52c$exports && $785f01b450cff054$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});


var $4b6e4422f7650ef8$exports = {};

var $4b6e4422f7650ef8$var$$String = String;
var $4b6e4422f7650ef8$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$4b6e4422f7650ef8$exports = function(argument) {
    if ($e2b40057776e4ecf$exports(argument)) return argument;
    throw $4b6e4422f7650ef8$var$$TypeError($4b6e4422f7650ef8$var$$String(argument) + " is not an object");
};


var $91a2f0650ce7f630$exports = {};
var $eb890f83c71bfc69$exports = {};
var $eba1506f186f3fba$exports = {};

var $eba1506f186f3fba$var$call = Function.prototype.call;
$eba1506f186f3fba$exports = $bf16ccdb59a4d1f9$exports ? $eba1506f186f3fba$var$call.bind($eba1506f186f3fba$var$call) : function() {
    return $eba1506f186f3fba$var$call.apply($eba1506f186f3fba$var$call, arguments);
};



var $e32b0157e2db371f$exports = {};
var $5e18c84a1764ce92$exports = {};


var $5e18c84a1764ce92$var$aFunction = function(argument) {
    return $e857ae4b90351a33$exports(argument) ? argument : undefined;
};
$5e18c84a1764ce92$exports = function(namespace, method) {
    return arguments.length < 2 ? $5e18c84a1764ce92$var$aFunction($29d6451600dfd5bb$exports[namespace]) : $29d6451600dfd5bb$exports[namespace] && $29d6451600dfd5bb$exports[namespace][method];
};



var $1005762df60f0c6e$exports = {};

$1005762df60f0c6e$exports = $e7c42e8ddd2b26fb$exports({}.isPrototypeOf);


var $2551bc57b010ef20$exports = {};
/* eslint-disable es/no-symbol -- required for testing */ var $3b8f094cc7213ba8$exports = {};
/* eslint-disable es/no-symbol -- required for testing */ var $28c6686a1dbddd4a$exports = {};

var $ffcc5eac89666467$exports = {};
$ffcc5eac89666467$exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";


var $28c6686a1dbddd4a$var$process = $29d6451600dfd5bb$exports.process;
var $28c6686a1dbddd4a$var$Deno = $29d6451600dfd5bb$exports.Deno;
var $28c6686a1dbddd4a$var$versions = $28c6686a1dbddd4a$var$process && $28c6686a1dbddd4a$var$process.versions || $28c6686a1dbddd4a$var$Deno && $28c6686a1dbddd4a$var$Deno.version;
var $28c6686a1dbddd4a$var$v8 = $28c6686a1dbddd4a$var$versions && $28c6686a1dbddd4a$var$versions.v8;
var $28c6686a1dbddd4a$var$match, $28c6686a1dbddd4a$var$version;
if ($28c6686a1dbddd4a$var$v8) {
    $28c6686a1dbddd4a$var$match = $28c6686a1dbddd4a$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $28c6686a1dbddd4a$var$version = $28c6686a1dbddd4a$var$match[0] > 0 && $28c6686a1dbddd4a$var$match[0] < 4 ? 1 : +($28c6686a1dbddd4a$var$match[0] + $28c6686a1dbddd4a$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$28c6686a1dbddd4a$var$version && $ffcc5eac89666467$exports) {
    $28c6686a1dbddd4a$var$match = $ffcc5eac89666467$exports.match(/Edge\/(\d+)/);
    if (!$28c6686a1dbddd4a$var$match || $28c6686a1dbddd4a$var$match[1] >= 74) {
        $28c6686a1dbddd4a$var$match = $ffcc5eac89666467$exports.match(/Chrome\/(\d+)/);
        if ($28c6686a1dbddd4a$var$match) $28c6686a1dbddd4a$var$version = +$28c6686a1dbddd4a$var$match[1];
    }
}
$28c6686a1dbddd4a$exports = $28c6686a1dbddd4a$var$version;



// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$3b8f094cc7213ba8$exports = !!Object.getOwnPropertySymbols && !$785f01b450cff054$exports(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $28c6686a1dbddd4a$exports && $28c6686a1dbddd4a$exports < 41;
});


$2551bc57b010ef20$exports = $3b8f094cc7213ba8$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $e32b0157e2db371f$var$$Object = Object;
$e32b0157e2db371f$exports = $2551bc57b010ef20$exports ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $5e18c84a1764ce92$exports("Symbol");
    return $e857ae4b90351a33$exports($Symbol) && $1005762df60f0c6e$exports($Symbol.prototype, $e32b0157e2db371f$var$$Object(it));
};


var $f0a532d01d0435b3$exports = {};
var $cd89a9b629732d8c$exports = {};

var $3249913aaf1fb732$exports = {};
var $3249913aaf1fb732$var$$String = String;
$3249913aaf1fb732$exports = function(argument) {
    try {
        return $3249913aaf1fb732$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $cd89a9b629732d8c$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$cd89a9b629732d8c$exports = function(argument) {
    if ($e857ae4b90351a33$exports(argument)) return argument;
    throw $cd89a9b629732d8c$var$$TypeError($3249913aaf1fb732$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$f0a532d01d0435b3$exports = function(V, P) {
    var func = V[P];
    return $c402ab447eedfa45$exports(func) ? undefined : $cd89a9b629732d8c$exports(func);
};


var $8a1005c6d7ca14ef$exports = {};



var $8a1005c6d7ca14ef$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$8a1005c6d7ca14ef$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $e857ae4b90351a33$exports(fn = input.toString) && !$e2b40057776e4ecf$exports(val = $eba1506f186f3fba$exports(fn, input))) return val;
    if ($e857ae4b90351a33$exports(fn = input.valueOf) && !$e2b40057776e4ecf$exports(val = $eba1506f186f3fba$exports(fn, input))) return val;
    if (pref !== "string" && $e857ae4b90351a33$exports(fn = input.toString) && !$e2b40057776e4ecf$exports(val = $eba1506f186f3fba$exports(fn, input))) return val;
    throw $8a1005c6d7ca14ef$var$$TypeError("Can't convert object to primitive value");
};


var $3bb8abfddd62ac58$exports = {};

var $5f5471381c9c9083$exports = {};
var $6b193324dec22e27$exports = {};
$6b193324dec22e27$exports = false;



($5f5471381c9c9083$exports = function(key, value) {
    return $38e9b23635a041cc$exports[key] || ($38e9b23635a041cc$exports[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.29.0",
    mode: $6b193324dec22e27$exports ? "pure" : "global",
    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.29.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
});



var $8db71328614e29d0$exports = {};

var $8db71328614e29d0$var$id = 0;
var $8db71328614e29d0$var$postfix = Math.random();
var $8db71328614e29d0$var$toString = $e7c42e8ddd2b26fb$exports(1.0.toString);
$8db71328614e29d0$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $8db71328614e29d0$var$toString(++$8db71328614e29d0$var$id + $8db71328614e29d0$var$postfix, 36);
};




var $3bb8abfddd62ac58$var$Symbol = $29d6451600dfd5bb$exports.Symbol;
var $3bb8abfddd62ac58$var$WellKnownSymbolsStore = $5f5471381c9c9083$exports("wks");
var $3bb8abfddd62ac58$var$createWellKnownSymbol = $2551bc57b010ef20$exports ? $3bb8abfddd62ac58$var$Symbol["for"] || $3bb8abfddd62ac58$var$Symbol : $3bb8abfddd62ac58$var$Symbol && $3bb8abfddd62ac58$var$Symbol.withoutSetter || $8db71328614e29d0$exports;
$3bb8abfddd62ac58$exports = function(name) {
    if (!$3959dbb6e98149cc$exports($3bb8abfddd62ac58$var$WellKnownSymbolsStore, name)) $3bb8abfddd62ac58$var$WellKnownSymbolsStore[name] = $3b8f094cc7213ba8$exports && $3959dbb6e98149cc$exports($3bb8abfddd62ac58$var$Symbol, name) ? $3bb8abfddd62ac58$var$Symbol[name] : $3bb8abfddd62ac58$var$createWellKnownSymbol("Symbol." + name);
    return $3bb8abfddd62ac58$var$WellKnownSymbolsStore[name];
};


var $eb890f83c71bfc69$var$$TypeError = TypeError;
var $eb890f83c71bfc69$var$TO_PRIMITIVE = $3bb8abfddd62ac58$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$eb890f83c71bfc69$exports = function(input, pref) {
    if (!$e2b40057776e4ecf$exports(input) || $e32b0157e2db371f$exports(input)) return input;
    var exoticToPrim = $f0a532d01d0435b3$exports(input, $eb890f83c71bfc69$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $eba1506f186f3fba$exports(exoticToPrim, input, pref);
        if (!$e2b40057776e4ecf$exports(result) || $e32b0157e2db371f$exports(result)) return result;
        throw $eb890f83c71bfc69$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $8a1005c6d7ca14ef$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$91a2f0650ce7f630$exports = function(argument) {
    var key = $eb890f83c71bfc69$exports(argument, "string");
    return $e32b0157e2db371f$exports(key) ? key : key + "";
};


var $5b3b5e53fb7b085c$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $5b3b5e53fb7b085c$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $5b3b5e53fb7b085c$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $5b3b5e53fb7b085c$var$ENUMERABLE = "enumerable";
var $5b3b5e53fb7b085c$var$CONFIGURABLE = "configurable";
var $5b3b5e53fb7b085c$var$WRITABLE = "writable";
$5b3b5e53fb7b085c$export$2d1720544b23b823 = $914f9d5e042cd52c$exports ? $0de256c44a607733$exports ? function defineProperty(O, P, Attributes) {
    $4b6e4422f7650ef8$exports(O);
    P = $91a2f0650ce7f630$exports(P);
    $4b6e4422f7650ef8$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $5b3b5e53fb7b085c$var$WRITABLE in Attributes && !Attributes[$5b3b5e53fb7b085c$var$WRITABLE]) {
        var current = $5b3b5e53fb7b085c$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$5b3b5e53fb7b085c$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $5b3b5e53fb7b085c$var$CONFIGURABLE in Attributes ? Attributes[$5b3b5e53fb7b085c$var$CONFIGURABLE] : current[$5b3b5e53fb7b085c$var$CONFIGURABLE],
                enumerable: $5b3b5e53fb7b085c$var$ENUMERABLE in Attributes ? Attributes[$5b3b5e53fb7b085c$var$ENUMERABLE] : current[$5b3b5e53fb7b085c$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $5b3b5e53fb7b085c$var$$defineProperty(O, P, Attributes);
} : $5b3b5e53fb7b085c$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $4b6e4422f7650ef8$exports(O);
    P = $91a2f0650ce7f630$exports(P);
    $4b6e4422f7650ef8$exports(Attributes);
    if ($92feab208e75d616$exports) try {
        return $5b3b5e53fb7b085c$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $5b3b5e53fb7b085c$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};


var $75d65f564e675b00$exports = {};
$75d65f564e675b00$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


$e2a7ba2084340e9c$exports = $914f9d5e042cd52c$exports ? function(object, key, value) {
    return $5b3b5e53fb7b085c$export$2d1720544b23b823(object, key, $75d65f564e675b00$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};




var $f035665c9cf8c5c4$exports = {};


var $f035665c9cf8c5c4$var$keys = $5f5471381c9c9083$exports("keys");
$f035665c9cf8c5c4$exports = function(key) {
    return $f035665c9cf8c5c4$var$keys[key] || ($f035665c9cf8c5c4$var$keys[key] = $8db71328614e29d0$exports(key));
};


var $166cb7e72c0241a0$exports = {};
$166cb7e72c0241a0$exports = {};


var $68639cbf8bec6c8f$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $68639cbf8bec6c8f$var$TypeError = $29d6451600dfd5bb$exports.TypeError;
var $68639cbf8bec6c8f$var$WeakMap = $29d6451600dfd5bb$exports.WeakMap;
var $68639cbf8bec6c8f$var$set, $68639cbf8bec6c8f$var$get, $68639cbf8bec6c8f$var$has;
var $68639cbf8bec6c8f$var$enforce = function(it) {
    return $68639cbf8bec6c8f$var$has(it) ? $68639cbf8bec6c8f$var$get(it) : $68639cbf8bec6c8f$var$set(it, {});
};
var $68639cbf8bec6c8f$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$e2b40057776e4ecf$exports(it) || (state = $68639cbf8bec6c8f$var$get(it)).type !== TYPE) throw $68639cbf8bec6c8f$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($374bc02c35eb3df6$exports || $38e9b23635a041cc$exports.state) {
    var $68639cbf8bec6c8f$var$store = $38e9b23635a041cc$exports.state || ($38e9b23635a041cc$exports.state = new $68639cbf8bec6c8f$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $68639cbf8bec6c8f$var$store.get = $68639cbf8bec6c8f$var$store.get;
    $68639cbf8bec6c8f$var$store.has = $68639cbf8bec6c8f$var$store.has;
    $68639cbf8bec6c8f$var$store.set = $68639cbf8bec6c8f$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $68639cbf8bec6c8f$var$set = function(it, metadata) {
        if ($68639cbf8bec6c8f$var$store.has(it)) throw $68639cbf8bec6c8f$var$TypeError($68639cbf8bec6c8f$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $68639cbf8bec6c8f$var$store.set(it, metadata);
        return metadata;
    };
    $68639cbf8bec6c8f$var$get = function(it) {
        return $68639cbf8bec6c8f$var$store.get(it) || {};
    };
    $68639cbf8bec6c8f$var$has = function(it) {
        return $68639cbf8bec6c8f$var$store.has(it);
    };
} else {
    var $68639cbf8bec6c8f$var$STATE = $f035665c9cf8c5c4$exports("state");
    $166cb7e72c0241a0$exports[$68639cbf8bec6c8f$var$STATE] = true;
    $68639cbf8bec6c8f$var$set = function(it, metadata) {
        if ($3959dbb6e98149cc$exports(it, $68639cbf8bec6c8f$var$STATE)) throw $68639cbf8bec6c8f$var$TypeError($68639cbf8bec6c8f$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $e2a7ba2084340e9c$exports(it, $68639cbf8bec6c8f$var$STATE, metadata);
        return metadata;
    };
    $68639cbf8bec6c8f$var$get = function(it) {
        return $3959dbb6e98149cc$exports(it, $68639cbf8bec6c8f$var$STATE) ? it[$68639cbf8bec6c8f$var$STATE] : {};
    };
    $68639cbf8bec6c8f$var$has = function(it) {
        return $3959dbb6e98149cc$exports(it, $68639cbf8bec6c8f$var$STATE);
    };
}
$68639cbf8bec6c8f$exports = {
    set: $68639cbf8bec6c8f$var$set,
    get: $68639cbf8bec6c8f$var$get,
    has: $68639cbf8bec6c8f$var$has,
    enforce: $68639cbf8bec6c8f$var$enforce,
    getterFor: $68639cbf8bec6c8f$var$getterFor
};


var $ef4a3456c7dbf9ed$var$enforceInternalState = $68639cbf8bec6c8f$exports.enforce;
var $ef4a3456c7dbf9ed$var$getInternalState = $68639cbf8bec6c8f$exports.get;
var $ef4a3456c7dbf9ed$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $ef4a3456c7dbf9ed$var$defineProperty = Object.defineProperty;
var $ef4a3456c7dbf9ed$var$stringSlice = $e7c42e8ddd2b26fb$exports("".slice);
var $ef4a3456c7dbf9ed$var$replace = $e7c42e8ddd2b26fb$exports("".replace);
var $ef4a3456c7dbf9ed$var$join = $e7c42e8ddd2b26fb$exports([].join);
var $ef4a3456c7dbf9ed$var$CONFIGURABLE_LENGTH = $914f9d5e042cd52c$exports && !$785f01b450cff054$exports(function() {
    return $ef4a3456c7dbf9ed$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $ef4a3456c7dbf9ed$var$TEMPLATE = String(String).split("String");
var $ef4a3456c7dbf9ed$var$makeBuiltIn = $ef4a3456c7dbf9ed$exports = function(value, name, options) {
    if ($ef4a3456c7dbf9ed$var$stringSlice($ef4a3456c7dbf9ed$var$$String(name), 0, 7) === "Symbol(") name = "[" + $ef4a3456c7dbf9ed$var$replace($ef4a3456c7dbf9ed$var$$String(name), /^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$3959dbb6e98149cc$exports(value, "name") || $ef4a3456c7dbf9ed$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($914f9d5e042cd52c$exports) $ef4a3456c7dbf9ed$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($ef4a3456c7dbf9ed$var$CONFIGURABLE_LENGTH && options && $3959dbb6e98149cc$exports(options, "arity") && value.length !== options.arity) $ef4a3456c7dbf9ed$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $3959dbb6e98149cc$exports(options, "constructor") && options.constructor) {
            if ($914f9d5e042cd52c$exports) $ef4a3456c7dbf9ed$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $ef4a3456c7dbf9ed$var$enforceInternalState(value);
    if (!$3959dbb6e98149cc$exports(state, "source")) state.source = $ef4a3456c7dbf9ed$var$join($ef4a3456c7dbf9ed$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $ef4a3456c7dbf9ed$var$makeBuiltIn(function toString() {
    return $e857ae4b90351a33$exports(this) && $ef4a3456c7dbf9ed$var$getInternalState(this).source || $73a352fb9d151a74$exports(this);
}, "toString");



$134ed1e28f84dc44$exports = function(target, name, descriptor) {
    if (descriptor.get) $ef4a3456c7dbf9ed$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $ef4a3456c7dbf9ed$exports(descriptor.set, name, {
        setter: true
    });
    return $5b3b5e53fb7b085c$export$2d1720544b23b823(target, name, descriptor);
};


var $9e63f8b41682d4f4$exports = {};
"use strict";

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$9e63f8b41682d4f4$exports = function() {
    var that = $4b6e4422f7650ef8$exports(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};



// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var $4171c5b35a386b3d$var$RegExp = $29d6451600dfd5bb$exports.RegExp;
var $4171c5b35a386b3d$var$RegExpPrototype = $4171c5b35a386b3d$var$RegExp.prototype;
var $4171c5b35a386b3d$var$FORCED = $914f9d5e042cd52c$exports && $785f01b450cff054$exports(function() {
    var INDICES_SUPPORT = true;
    try {
        $4171c5b35a386b3d$var$RegExp(".", "d");
    } catch (error) {
        INDICES_SUPPORT = false;
    }
    var O = {};
    // modern V8 bug
    var calls = "";
    var expected = INDICES_SUPPORT ? "dgimsy" : "gimsy";
    var addGetter = function(key, chr) {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty(O, key, {
            get: function() {
                calls += chr;
                return true;
            }
        });
    };
    var pairs = {
        dotAll: "s",
        global: "g",
        ignoreCase: "i",
        multiline: "m",
        sticky: "y"
    };
    if (INDICES_SUPPORT) pairs.hasIndices = "d";
    for(var key in pairs)addGetter(key, pairs[key]);
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var result = Object.getOwnPropertyDescriptor($4171c5b35a386b3d$var$RegExpPrototype, "flags").get.call(O);
    return result !== expected || calls !== expected;
});
// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if ($4171c5b35a386b3d$var$FORCED) $134ed1e28f84dc44$exports($4171c5b35a386b3d$var$RegExpPrototype, "flags", {
    configurable: true,
    get: $9e63f8b41682d4f4$exports
});


"use strict";


var $894aa5fbe999f147$exports = {};
"use strict";
var $6ced1a9ccd9bee65$exports = {};
// eslint-disable-next-line es/no-typed-arrays -- safe
$6ced1a9ccd9bee65$exports = typeof ArrayBuffer != "undefined" && typeof DataView != "undefined";







var $933185f996d4ed86$exports = {};
var $c675ae7f563c8716$exports = {};

var $c675ae7f563c8716$var$TO_STRING_TAG = $3bb8abfddd62ac58$exports("toStringTag");
var $c675ae7f563c8716$var$test = {};
$c675ae7f563c8716$var$test[$c675ae7f563c8716$var$TO_STRING_TAG] = "z";
$c675ae7f563c8716$exports = String($c675ae7f563c8716$var$test) === "[object z]";



var $7de8679a125e05a7$exports = {};

var $7de8679a125e05a7$var$toString = $e7c42e8ddd2b26fb$exports({}.toString);
var $7de8679a125e05a7$var$stringSlice = $e7c42e8ddd2b26fb$exports("".slice);
$7de8679a125e05a7$exports = function(it) {
    return $7de8679a125e05a7$var$stringSlice($7de8679a125e05a7$var$toString(it), 8, -1);
};



var $933185f996d4ed86$var$TO_STRING_TAG = $3bb8abfddd62ac58$exports("toStringTag");
var $933185f996d4ed86$var$$Object = Object;
// ES3 wrong here
var $933185f996d4ed86$var$CORRECT_ARGUMENTS = $7de8679a125e05a7$exports(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $933185f996d4ed86$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$933185f996d4ed86$exports = $c675ae7f563c8716$exports ? $7de8679a125e05a7$exports : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $933185f996d4ed86$var$tryGet(O = $933185f996d4ed86$var$$Object(it), $933185f996d4ed86$var$TO_STRING_TAG)) == "string" ? tag : $933185f996d4ed86$var$CORRECT_ARGUMENTS ? $7de8679a125e05a7$exports(O) : (result = $7de8679a125e05a7$exports(O)) == "Object" && $e857ae4b90351a33$exports(O.callee) ? "Arguments" : result;
};




var $b7d215e83ba7310f$exports = {};




$b7d215e83ba7310f$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($e857ae4b90351a33$exports(value)) $ef4a3456c7dbf9ed$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $3803ab888f1a7d44$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $5b3b5e53fb7b085c$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};




var $58018b2b057169a5$exports = {};




var $ccf6dd7c473474b1$exports = {};

$ccf6dd7c473474b1$exports = !$785f01b450cff054$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $58018b2b057169a5$var$IE_PROTO = $f035665c9cf8c5c4$exports("IE_PROTO");
var $58018b2b057169a5$var$$Object = Object;
var $58018b2b057169a5$var$ObjectPrototype = $58018b2b057169a5$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$58018b2b057169a5$exports = $ccf6dd7c473474b1$exports ? $58018b2b057169a5$var$$Object.getPrototypeOf : function(O) {
    var object = $fe377fc6c61a7ce1$exports(O);
    if ($3959dbb6e98149cc$exports(object, $58018b2b057169a5$var$IE_PROTO)) return object[$58018b2b057169a5$var$IE_PROTO];
    var constructor = object.constructor;
    if ($e857ae4b90351a33$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $58018b2b057169a5$var$$Object ? $58018b2b057169a5$var$ObjectPrototype : null;
};


var $71a556f6299247af$exports = {};
/* eslint-disable no-proto -- safe */ var $ad468e1c4326d6ee$exports = {};


$ad468e1c4326d6ee$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $e7c42e8ddd2b26fb$exports($cd89a9b629732d8c$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};



var $bce866457c4c535d$exports = {};

var $bce866457c4c535d$var$$String = String;
var $bce866457c4c535d$var$$TypeError = TypeError;
$bce866457c4c535d$exports = function(argument) {
    if (typeof argument == "object" || $e857ae4b90351a33$exports(argument)) return argument;
    throw $bce866457c4c535d$var$$TypeError("Can't set " + $bce866457c4c535d$var$$String(argument) + " as a prototype");
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$71a556f6299247af$exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $ad468e1c4326d6ee$exports(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $4b6e4422f7650ef8$exports(O);
        $bce866457c4c535d$exports(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);





var $894aa5fbe999f147$var$enforceInternalState = $68639cbf8bec6c8f$exports.enforce;
var $894aa5fbe999f147$var$getInternalState = $68639cbf8bec6c8f$exports.get;
var $894aa5fbe999f147$var$Int8Array = $29d6451600dfd5bb$exports.Int8Array;
var $894aa5fbe999f147$var$Int8ArrayPrototype = $894aa5fbe999f147$var$Int8Array && $894aa5fbe999f147$var$Int8Array.prototype;
var $894aa5fbe999f147$var$Uint8ClampedArray = $29d6451600dfd5bb$exports.Uint8ClampedArray;
var $894aa5fbe999f147$var$Uint8ClampedArrayPrototype = $894aa5fbe999f147$var$Uint8ClampedArray && $894aa5fbe999f147$var$Uint8ClampedArray.prototype;
var $894aa5fbe999f147$var$TypedArray = $894aa5fbe999f147$var$Int8Array && $58018b2b057169a5$exports($894aa5fbe999f147$var$Int8Array);
var $894aa5fbe999f147$var$TypedArrayPrototype = $894aa5fbe999f147$var$Int8ArrayPrototype && $58018b2b057169a5$exports($894aa5fbe999f147$var$Int8ArrayPrototype);
var $894aa5fbe999f147$var$ObjectPrototype = Object.prototype;
var $894aa5fbe999f147$var$TypeError = $29d6451600dfd5bb$exports.TypeError;
var $894aa5fbe999f147$var$TO_STRING_TAG = $3bb8abfddd62ac58$exports("toStringTag");
var $894aa5fbe999f147$var$TYPED_ARRAY_TAG = $8db71328614e29d0$exports("TYPED_ARRAY_TAG");
var $894aa5fbe999f147$var$TYPED_ARRAY_CONSTRUCTOR = "TypedArrayConstructor";
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var $894aa5fbe999f147$var$NATIVE_ARRAY_BUFFER_VIEWS = $6ced1a9ccd9bee65$exports && !!$71a556f6299247af$exports && $933185f996d4ed86$exports($29d6451600dfd5bb$exports.opera) !== "Opera";
var $894aa5fbe999f147$var$TYPED_ARRAY_TAG_REQUIRED = false;
var $894aa5fbe999f147$var$NAME, $894aa5fbe999f147$var$Constructor, $894aa5fbe999f147$var$Prototype;
var $894aa5fbe999f147$var$TypedArrayConstructorsList = {
    Int8Array: 1,
    Uint8Array: 1,
    Uint8ClampedArray: 1,
    Int16Array: 2,
    Uint16Array: 2,
    Int32Array: 4,
    Uint32Array: 4,
    Float32Array: 4,
    Float64Array: 8
};
var $894aa5fbe999f147$var$BigIntArrayConstructorsList = {
    BigInt64Array: 8,
    BigUint64Array: 8
};
var $894aa5fbe999f147$var$isView = function isView(it) {
    if (!$e2b40057776e4ecf$exports(it)) return false;
    var klass = $933185f996d4ed86$exports(it);
    return klass === "DataView" || $3959dbb6e98149cc$exports($894aa5fbe999f147$var$TypedArrayConstructorsList, klass) || $3959dbb6e98149cc$exports($894aa5fbe999f147$var$BigIntArrayConstructorsList, klass);
};
var $894aa5fbe999f147$var$getTypedArrayConstructor = function(it) {
    var proto = $58018b2b057169a5$exports(it);
    if (!$e2b40057776e4ecf$exports(proto)) return;
    var state = $894aa5fbe999f147$var$getInternalState(proto);
    return state && $3959dbb6e98149cc$exports(state, $894aa5fbe999f147$var$TYPED_ARRAY_CONSTRUCTOR) ? state[$894aa5fbe999f147$var$TYPED_ARRAY_CONSTRUCTOR] : $894aa5fbe999f147$var$getTypedArrayConstructor(proto);
};
var $894aa5fbe999f147$var$isTypedArray = function(it) {
    if (!$e2b40057776e4ecf$exports(it)) return false;
    var klass = $933185f996d4ed86$exports(it);
    return $3959dbb6e98149cc$exports($894aa5fbe999f147$var$TypedArrayConstructorsList, klass) || $3959dbb6e98149cc$exports($894aa5fbe999f147$var$BigIntArrayConstructorsList, klass);
};
var $894aa5fbe999f147$var$aTypedArray = function(it) {
    if ($894aa5fbe999f147$var$isTypedArray(it)) return it;
    throw $894aa5fbe999f147$var$TypeError("Target is not a typed array");
};
var $894aa5fbe999f147$var$aTypedArrayConstructor = function(C) {
    if ($e857ae4b90351a33$exports(C) && (!$71a556f6299247af$exports || $1005762df60f0c6e$exports($894aa5fbe999f147$var$TypedArray, C))) return C;
    throw $894aa5fbe999f147$var$TypeError($3249913aaf1fb732$exports(C) + " is not a typed array constructor");
};
var $894aa5fbe999f147$var$exportTypedArrayMethod = function(KEY, property, forced, options) {
    if (!$914f9d5e042cd52c$exports) return;
    if (forced) for(var ARRAY in $894aa5fbe999f147$var$TypedArrayConstructorsList){
        var TypedArrayConstructor = $29d6451600dfd5bb$exports[ARRAY];
        if (TypedArrayConstructor && $3959dbb6e98149cc$exports(TypedArrayConstructor.prototype, KEY)) try {
            delete TypedArrayConstructor.prototype[KEY];
        } catch (error) {
            // old WebKit bug - some methods are non-configurable
            try {
                TypedArrayConstructor.prototype[KEY] = property;
            } catch (error2) {}
        }
    }
    if (!$894aa5fbe999f147$var$TypedArrayPrototype[KEY] || forced) $b7d215e83ba7310f$exports($894aa5fbe999f147$var$TypedArrayPrototype, KEY, forced ? property : $894aa5fbe999f147$var$NATIVE_ARRAY_BUFFER_VIEWS && $894aa5fbe999f147$var$Int8ArrayPrototype[KEY] || property, options);
};
var $894aa5fbe999f147$var$exportTypedArrayStaticMethod = function(KEY, property, forced) {
    var ARRAY, TypedArrayConstructor;
    if (!$914f9d5e042cd52c$exports) return;
    if ($71a556f6299247af$exports) {
        if (forced) for(ARRAY in $894aa5fbe999f147$var$TypedArrayConstructorsList){
            TypedArrayConstructor = $29d6451600dfd5bb$exports[ARRAY];
            if (TypedArrayConstructor && $3959dbb6e98149cc$exports(TypedArrayConstructor, KEY)) try {
                delete TypedArrayConstructor[KEY];
            } catch (error) {}
        }
        if (!$894aa5fbe999f147$var$TypedArray[KEY] || forced) // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
        try {
            return $b7d215e83ba7310f$exports($894aa5fbe999f147$var$TypedArray, KEY, forced ? property : $894aa5fbe999f147$var$NATIVE_ARRAY_BUFFER_VIEWS && $894aa5fbe999f147$var$TypedArray[KEY] || property);
        } catch (error) {}
        else return;
    }
    for(ARRAY in $894aa5fbe999f147$var$TypedArrayConstructorsList){
        TypedArrayConstructor = $29d6451600dfd5bb$exports[ARRAY];
        if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) $b7d215e83ba7310f$exports(TypedArrayConstructor, KEY, property);
    }
};
for($894aa5fbe999f147$var$NAME in $894aa5fbe999f147$var$TypedArrayConstructorsList){
    $894aa5fbe999f147$var$Constructor = $29d6451600dfd5bb$exports[$894aa5fbe999f147$var$NAME];
    $894aa5fbe999f147$var$Prototype = $894aa5fbe999f147$var$Constructor && $894aa5fbe999f147$var$Constructor.prototype;
    if ($894aa5fbe999f147$var$Prototype) $894aa5fbe999f147$var$enforceInternalState($894aa5fbe999f147$var$Prototype)[$894aa5fbe999f147$var$TYPED_ARRAY_CONSTRUCTOR] = $894aa5fbe999f147$var$Constructor;
    else $894aa5fbe999f147$var$NATIVE_ARRAY_BUFFER_VIEWS = false;
}
for($894aa5fbe999f147$var$NAME in $894aa5fbe999f147$var$BigIntArrayConstructorsList){
    $894aa5fbe999f147$var$Constructor = $29d6451600dfd5bb$exports[$894aa5fbe999f147$var$NAME];
    $894aa5fbe999f147$var$Prototype = $894aa5fbe999f147$var$Constructor && $894aa5fbe999f147$var$Constructor.prototype;
    if ($894aa5fbe999f147$var$Prototype) $894aa5fbe999f147$var$enforceInternalState($894aa5fbe999f147$var$Prototype)[$894aa5fbe999f147$var$TYPED_ARRAY_CONSTRUCTOR] = $894aa5fbe999f147$var$Constructor;
}
// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!$894aa5fbe999f147$var$NATIVE_ARRAY_BUFFER_VIEWS || !$e857ae4b90351a33$exports($894aa5fbe999f147$var$TypedArray) || $894aa5fbe999f147$var$TypedArray === Function.prototype) {
    // eslint-disable-next-line no-shadow -- safe
    $894aa5fbe999f147$var$TypedArray = function TypedArray() {
        throw $894aa5fbe999f147$var$TypeError("Incorrect invocation");
    };
    if ($894aa5fbe999f147$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($894aa5fbe999f147$var$NAME in $894aa5fbe999f147$var$TypedArrayConstructorsList)if ($29d6451600dfd5bb$exports[$894aa5fbe999f147$var$NAME]) $71a556f6299247af$exports($29d6451600dfd5bb$exports[$894aa5fbe999f147$var$NAME], $894aa5fbe999f147$var$TypedArray);
    }
}
if (!$894aa5fbe999f147$var$NATIVE_ARRAY_BUFFER_VIEWS || !$894aa5fbe999f147$var$TypedArrayPrototype || $894aa5fbe999f147$var$TypedArrayPrototype === $894aa5fbe999f147$var$ObjectPrototype) {
    $894aa5fbe999f147$var$TypedArrayPrototype = $894aa5fbe999f147$var$TypedArray.prototype;
    if ($894aa5fbe999f147$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($894aa5fbe999f147$var$NAME in $894aa5fbe999f147$var$TypedArrayConstructorsList)if ($29d6451600dfd5bb$exports[$894aa5fbe999f147$var$NAME]) $71a556f6299247af$exports($29d6451600dfd5bb$exports[$894aa5fbe999f147$var$NAME].prototype, $894aa5fbe999f147$var$TypedArrayPrototype);
    }
}
// WebKit bug - one more object in Uint8ClampedArray prototype chain
if ($894aa5fbe999f147$var$NATIVE_ARRAY_BUFFER_VIEWS && $58018b2b057169a5$exports($894aa5fbe999f147$var$Uint8ClampedArrayPrototype) !== $894aa5fbe999f147$var$TypedArrayPrototype) $71a556f6299247af$exports($894aa5fbe999f147$var$Uint8ClampedArrayPrototype, $894aa5fbe999f147$var$TypedArrayPrototype);
if ($914f9d5e042cd52c$exports && !$3959dbb6e98149cc$exports($894aa5fbe999f147$var$TypedArrayPrototype, $894aa5fbe999f147$var$TO_STRING_TAG)) {
    $894aa5fbe999f147$var$TYPED_ARRAY_TAG_REQUIRED = true;
    $134ed1e28f84dc44$exports($894aa5fbe999f147$var$TypedArrayPrototype, $894aa5fbe999f147$var$TO_STRING_TAG, {
        configurable: true,
        get: function() {
            return $e2b40057776e4ecf$exports(this) ? this[$894aa5fbe999f147$var$TYPED_ARRAY_TAG] : undefined;
        }
    });
    for($894aa5fbe999f147$var$NAME in $894aa5fbe999f147$var$TypedArrayConstructorsList)if ($29d6451600dfd5bb$exports[$894aa5fbe999f147$var$NAME]) $e2a7ba2084340e9c$exports($29d6451600dfd5bb$exports[$894aa5fbe999f147$var$NAME], $894aa5fbe999f147$var$TYPED_ARRAY_TAG, $894aa5fbe999f147$var$NAME);
}
$894aa5fbe999f147$exports = {
    NATIVE_ARRAY_BUFFER_VIEWS: $894aa5fbe999f147$var$NATIVE_ARRAY_BUFFER_VIEWS,
    TYPED_ARRAY_TAG: $894aa5fbe999f147$var$TYPED_ARRAY_TAG_REQUIRED && $894aa5fbe999f147$var$TYPED_ARRAY_TAG,
    aTypedArray: $894aa5fbe999f147$var$aTypedArray,
    aTypedArrayConstructor: $894aa5fbe999f147$var$aTypedArrayConstructor,
    exportTypedArrayMethod: $894aa5fbe999f147$var$exportTypedArrayMethod,
    exportTypedArrayStaticMethod: $894aa5fbe999f147$var$exportTypedArrayStaticMethod,
    getTypedArrayConstructor: $894aa5fbe999f147$var$getTypedArrayConstructor,
    isView: $894aa5fbe999f147$var$isView,
    isTypedArray: $894aa5fbe999f147$var$isTypedArray,
    TypedArray: $894aa5fbe999f147$var$TypedArray,
    TypedArrayPrototype: $894aa5fbe999f147$var$TypedArrayPrototype
};


var $3f4798ea5f1fa5fb$exports = {};
var $d32fdef928b095d3$exports = {};
var $1cf1c9f022a81769$exports = {};
var $f0f42c32d56019a2$exports = {};
var $f0f42c32d56019a2$var$ceil = Math.ceil;
var $f0f42c32d56019a2$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$f0f42c32d56019a2$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $f0f42c32d56019a2$var$floor : $f0f42c32d56019a2$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$1cf1c9f022a81769$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $f0f42c32d56019a2$exports(number);
};


var $d32fdef928b095d3$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$d32fdef928b095d3$exports = function(argument) {
    return argument > 0 ? $d32fdef928b095d3$var$min($1cf1c9f022a81769$exports(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$3f4798ea5f1fa5fb$exports = function(obj) {
    return $d32fdef928b095d3$exports(obj.length);
};


var $07569008b847c970$exports = {};
var $0f4d4db66a0407e5$exports = {};

var $0f4d4db66a0407e5$var$$RangeError = RangeError;
$0f4d4db66a0407e5$exports = function(it) {
    var result = $1cf1c9f022a81769$exports(it);
    if (result < 0) throw $0f4d4db66a0407e5$var$$RangeError("The argument can't be less than 0");
    return result;
};


var $07569008b847c970$var$$RangeError = RangeError;
$07569008b847c970$exports = function(it, BYTES) {
    var offset = $0f4d4db66a0407e5$exports(it);
    if (offset % BYTES) throw $07569008b847c970$var$$RangeError("Wrong offset");
    return offset;
};




var $88db0f4fc1f9192d$var$RangeError = $29d6451600dfd5bb$exports.RangeError;
var $88db0f4fc1f9192d$var$Int8Array = $29d6451600dfd5bb$exports.Int8Array;
var $88db0f4fc1f9192d$var$Int8ArrayPrototype = $88db0f4fc1f9192d$var$Int8Array && $88db0f4fc1f9192d$var$Int8Array.prototype;
var $88db0f4fc1f9192d$var$$set = $88db0f4fc1f9192d$var$Int8ArrayPrototype && $88db0f4fc1f9192d$var$Int8ArrayPrototype.set;
var $88db0f4fc1f9192d$var$aTypedArray = $894aa5fbe999f147$exports.aTypedArray;
var $88db0f4fc1f9192d$var$exportTypedArrayMethod = $894aa5fbe999f147$exports.exportTypedArrayMethod;
var $88db0f4fc1f9192d$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !$785f01b450cff054$exports(function() {
    // eslint-disable-next-line es/no-typed-arrays -- required for testing
    var array = new Uint8ClampedArray(2);
    $eba1506f186f3fba$exports($88db0f4fc1f9192d$var$$set, array, {
        length: 1,
        0: 3
    }, 1);
    return array[1] !== 3;
});
// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var $88db0f4fc1f9192d$var$TO_OBJECT_BUG = $88db0f4fc1f9192d$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && $894aa5fbe999f147$exports.NATIVE_ARRAY_BUFFER_VIEWS && $785f01b450cff054$exports(function() {
    var array = new $88db0f4fc1f9192d$var$Int8Array(2);
    array.set(1);
    array.set("2", 1);
    return array[0] !== 0 || array[1] !== 2;
});
// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
$88db0f4fc1f9192d$var$exportTypedArrayMethod("set", function set(arrayLike /* , offset */ ) {
    $88db0f4fc1f9192d$var$aTypedArray(this);
    var offset = $07569008b847c970$exports(arguments.length > 1 ? arguments[1] : undefined, 1);
    var src = $fe377fc6c61a7ce1$exports(arrayLike);
    if ($88db0f4fc1f9192d$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return $eba1506f186f3fba$exports($88db0f4fc1f9192d$var$$set, this, src, offset);
    var length = this.length;
    var len = $3f4798ea5f1fa5fb$exports(src);
    var index = 0;
    if (len + offset > length) throw $88db0f4fc1f9192d$var$RangeError("Wrong length");
    while(index < len)this[offset + index] = src[index++];
}, !$88db0f4fc1f9192d$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || $88db0f4fc1f9192d$var$TO_OBJECT_BUG);


// TODO: Remove this module from `core-js@4` since it's split to modules listed below
var $9948541b6667030f$exports = {};

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $46b98426d3d5cded$export$2d1720544b23b823;


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $7aea7a47d5c31d95$export$2d1720544b23b823;
"use strict";
var $7aea7a47d5c31d95$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $7aea7a47d5c31d95$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $7aea7a47d5c31d95$var$NASHORN_BUG = $7aea7a47d5c31d95$var$getOwnPropertyDescriptor && !$7aea7a47d5c31d95$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$7aea7a47d5c31d95$export$2d1720544b23b823 = $7aea7a47d5c31d95$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $7aea7a47d5c31d95$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $7aea7a47d5c31d95$var$$propertyIsEnumerable;



var $4c806ae0594ef444$exports = {};
// toObject with fallback for non-array-like ES3 strings
var $12bf8018c781c0a7$exports = {};



var $12bf8018c781c0a7$var$$Object = Object;
var $12bf8018c781c0a7$var$split = $e7c42e8ddd2b26fb$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$12bf8018c781c0a7$exports = $785f01b450cff054$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$12bf8018c781c0a7$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $7de8679a125e05a7$exports(it) == "String" ? $12bf8018c781c0a7$var$split(it, "") : $12bf8018c781c0a7$var$$Object(it);
} : $12bf8018c781c0a7$var$$Object;



$4c806ae0594ef444$exports = function(it) {
    return $12bf8018c781c0a7$exports($fe00a6e80b387ac1$exports(it));
};





// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $46b98426d3d5cded$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$46b98426d3d5cded$export$2d1720544b23b823 = $914f9d5e042cd52c$exports ? $46b98426d3d5cded$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $4c806ae0594ef444$exports(O);
    P = $91a2f0650ce7f630$exports(P);
    if ($92feab208e75d616$exports) try {
        return $46b98426d3d5cded$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($3959dbb6e98149cc$exports(O, P)) return $75d65f564e675b00$exports(!$eba1506f186f3fba$exports($7aea7a47d5c31d95$export$2d1720544b23b823, O, P), O[P]);
};


var $9948541b6667030f$require$getOwnPropertyDescriptor = $46b98426d3d5cded$export$2d1720544b23b823;



var $6606008467187c54$exports = {};

var $916d0ed465ef6c6b$exports = {};


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $f71def37578ad6a0$export$2d1720544b23b823;
var $9406da29640acaea$exports = {};



var $4d3ff288454810b9$exports = {};

var $87dd059b570abfce$exports = {};

var $87dd059b570abfce$var$max = Math.max;
var $87dd059b570abfce$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$87dd059b570abfce$exports = function(index, length) {
    var integer = $1cf1c9f022a81769$exports(index);
    return integer < 0 ? $87dd059b570abfce$var$max(integer + length, 0) : $87dd059b570abfce$var$min(integer, length);
};



// `Array.prototype.{ indexOf, includes }` methods implementation
var $4d3ff288454810b9$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $4c806ae0594ef444$exports($this);
        var length = $3f4798ea5f1fa5fb$exports(O);
        var index = $87dd059b570abfce$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$4d3ff288454810b9$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $4d3ff288454810b9$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $4d3ff288454810b9$var$createMethod(false)
};


var $9406da29640acaea$require$indexOf = $4d3ff288454810b9$exports.indexOf;

var $9406da29640acaea$var$push = $e7c42e8ddd2b26fb$exports([].push);
$9406da29640acaea$exports = function(object, names) {
    var O = $4c806ae0594ef444$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$3959dbb6e98149cc$exports($166cb7e72c0241a0$exports, key) && $3959dbb6e98149cc$exports(O, key) && $9406da29640acaea$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($3959dbb6e98149cc$exports(O, key = names[i++])) ~$9406da29640acaea$require$indexOf(result, key) || $9406da29640acaea$var$push(result, key);
    return result;
};


var $65b1a9273ade2280$exports = {};
// IE8- don't enum bug keys
$65b1a9273ade2280$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $f71def37578ad6a0$var$hiddenKeys = $65b1a9273ade2280$exports.concat("length", "prototype");
$f71def37578ad6a0$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $9406da29640acaea$exports(O, $f71def37578ad6a0$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $159143877df2dda4$export$2d1720544b23b823;
$159143877df2dda4$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $916d0ed465ef6c6b$var$concat = $e7c42e8ddd2b26fb$exports([].concat);
// all object keys, includes non-enumerable and symbols
$916d0ed465ef6c6b$exports = $5e18c84a1764ce92$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $f71def37578ad6a0$export$2d1720544b23b823($4b6e4422f7650ef8$exports(it));
    var getOwnPropertySymbols = $159143877df2dda4$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $916d0ed465ef6c6b$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$6606008467187c54$exports = function(target, source, exceptions) {
    var keys = $916d0ed465ef6c6b$exports(source);
    var defineProperty = $5b3b5e53fb7b085c$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $46b98426d3d5cded$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$3959dbb6e98149cc$exports(target, key) && !(exceptions && $3959dbb6e98149cc$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $ab36692785f65f91$exports = {};


var $ab36692785f65f91$var$replacement = /#|\.prototype\./;
var $ab36692785f65f91$var$isForced = function(feature, detection) {
    var value = $ab36692785f65f91$var$data[$ab36692785f65f91$var$normalize(feature)];
    return value == $ab36692785f65f91$var$POLYFILL ? true : value == $ab36692785f65f91$var$NATIVE ? false : $e857ae4b90351a33$exports(detection) ? $785f01b450cff054$exports(detection) : !!detection;
};
var $ab36692785f65f91$var$normalize = $ab36692785f65f91$var$isForced.normalize = function(string) {
    return String(string).replace($ab36692785f65f91$var$replacement, ".").toLowerCase();
};
var $ab36692785f65f91$var$data = $ab36692785f65f91$var$isForced.data = {};
var $ab36692785f65f91$var$NATIVE = $ab36692785f65f91$var$isForced.NATIVE = "N";
var $ab36692785f65f91$var$POLYFILL = $ab36692785f65f91$var$isForced.POLYFILL = "P";
$ab36692785f65f91$exports = $ab36692785f65f91$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $9948541b6667030f$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $29d6451600dfd5bb$exports;
    else if (STATIC) target = $29d6451600dfd5bb$exports[TARGET] || $3803ab888f1a7d44$exports(TARGET, {});
    else target = ($29d6451600dfd5bb$exports[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $9948541b6667030f$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $ab36692785f65f91$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $6606008467187c54$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $e2a7ba2084340e9c$exports(sourceProperty, "sham", true);
        $b7d215e83ba7310f$exports(target, key, sourceProperty, options);
    }
};



var $eb78275e0fbbee9c$exports = {};

var $a93d1da99e0614d9$exports = {};

var $a93d1da99e0614d9$var$FunctionPrototype = Function.prototype;
var $a93d1da99e0614d9$var$apply = $a93d1da99e0614d9$var$FunctionPrototype.apply;
var $a93d1da99e0614d9$var$call = $a93d1da99e0614d9$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$a93d1da99e0614d9$exports = typeof Reflect == "object" && Reflect.apply || ($bf16ccdb59a4d1f9$exports ? $a93d1da99e0614d9$var$call.bind($a93d1da99e0614d9$var$apply) : function() {
    return $a93d1da99e0614d9$var$call.apply($a93d1da99e0614d9$var$apply, arguments);
});


var $ef78e71ca695bed1$exports = {};
var $d4ea417bd97fa122$exports = {};


$d4ea417bd97fa122$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($7de8679a125e05a7$exports(fn) === "Function") return $e7c42e8ddd2b26fb$exports(fn);
};




var $ef78e71ca695bed1$var$bind = $d4ea417bd97fa122$exports($d4ea417bd97fa122$exports.bind);
// optional / simple context binding
$ef78e71ca695bed1$exports = function(fn, that) {
    $cd89a9b629732d8c$exports(fn);
    return that === undefined ? fn : $bf16ccdb59a4d1f9$exports ? $ef78e71ca695bed1$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $4828dc6a126e81b9$exports = {};

$4828dc6a126e81b9$exports = $5e18c84a1764ce92$exports("document", "documentElement");


var $e58d911bcedaa28d$exports = {};

$e58d911bcedaa28d$exports = $e7c42e8ddd2b26fb$exports([].slice);



var $b2931f60720117c8$exports = {};
var $b2931f60720117c8$var$$TypeError = TypeError;
$b2931f60720117c8$exports = function(passed, required) {
    if (passed < required) throw $b2931f60720117c8$var$$TypeError("Not enough arguments");
    return passed;
};


var $32a6e2516061cf38$exports = {};

// eslint-disable-next-line redos/no-vulnerable -- safe
$32a6e2516061cf38$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($ffcc5eac89666467$exports);


var $9944facdac079459$exports = {};

var $8ovux = parcelRequire("8ovux");

$9944facdac079459$exports = typeof $8ovux != "undefined" && $7de8679a125e05a7$exports($8ovux) == "process";


var $eb78275e0fbbee9c$var$set = $29d6451600dfd5bb$exports.setImmediate;
var $eb78275e0fbbee9c$var$clear = $29d6451600dfd5bb$exports.clearImmediate;
var $eb78275e0fbbee9c$var$process = $29d6451600dfd5bb$exports.process;
var $eb78275e0fbbee9c$var$Dispatch = $29d6451600dfd5bb$exports.Dispatch;
var $eb78275e0fbbee9c$var$Function = $29d6451600dfd5bb$exports.Function;
var $eb78275e0fbbee9c$var$MessageChannel = $29d6451600dfd5bb$exports.MessageChannel;
var $eb78275e0fbbee9c$var$String = $29d6451600dfd5bb$exports.String;
var $eb78275e0fbbee9c$var$counter = 0;
var $eb78275e0fbbee9c$var$queue = {};
var $eb78275e0fbbee9c$var$ONREADYSTATECHANGE = "onreadystatechange";
var $eb78275e0fbbee9c$var$$location, $eb78275e0fbbee9c$var$defer, $eb78275e0fbbee9c$var$channel, $eb78275e0fbbee9c$var$port;
$785f01b450cff054$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $eb78275e0fbbee9c$var$$location = $29d6451600dfd5bb$exports.location;
});
var $eb78275e0fbbee9c$var$run = function(id) {
    if ($3959dbb6e98149cc$exports($eb78275e0fbbee9c$var$queue, id)) {
        var fn = $eb78275e0fbbee9c$var$queue[id];
        delete $eb78275e0fbbee9c$var$queue[id];
        fn();
    }
};
var $eb78275e0fbbee9c$var$runner = function(id) {
    return function() {
        $eb78275e0fbbee9c$var$run(id);
    };
};
var $eb78275e0fbbee9c$var$eventListener = function(event) {
    $eb78275e0fbbee9c$var$run(event.data);
};
var $eb78275e0fbbee9c$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $29d6451600dfd5bb$exports.postMessage($eb78275e0fbbee9c$var$String(id), $eb78275e0fbbee9c$var$$location.protocol + "//" + $eb78275e0fbbee9c$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$eb78275e0fbbee9c$var$set || !$eb78275e0fbbee9c$var$clear) {
    $eb78275e0fbbee9c$var$set = function setImmediate(handler) {
        $b2931f60720117c8$exports(arguments.length, 1);
        var fn = $e857ae4b90351a33$exports(handler) ? handler : $eb78275e0fbbee9c$var$Function(handler);
        var args = $e58d911bcedaa28d$exports(arguments, 1);
        $eb78275e0fbbee9c$var$queue[++$eb78275e0fbbee9c$var$counter] = function() {
            $a93d1da99e0614d9$exports(fn, undefined, args);
        };
        $eb78275e0fbbee9c$var$defer($eb78275e0fbbee9c$var$counter);
        return $eb78275e0fbbee9c$var$counter;
    };
    $eb78275e0fbbee9c$var$clear = function clearImmediate(id) {
        delete $eb78275e0fbbee9c$var$queue[id];
    };
    // Node.js 0.8-
    if ($9944facdac079459$exports) $eb78275e0fbbee9c$var$defer = function(id) {
        $eb78275e0fbbee9c$var$process.nextTick($eb78275e0fbbee9c$var$runner(id));
    };
    else if ($eb78275e0fbbee9c$var$Dispatch && $eb78275e0fbbee9c$var$Dispatch.now) $eb78275e0fbbee9c$var$defer = function(id) {
        $eb78275e0fbbee9c$var$Dispatch.now($eb78275e0fbbee9c$var$runner(id));
    };
    else if ($eb78275e0fbbee9c$var$MessageChannel && !$32a6e2516061cf38$exports) {
        $eb78275e0fbbee9c$var$channel = new $eb78275e0fbbee9c$var$MessageChannel();
        $eb78275e0fbbee9c$var$port = $eb78275e0fbbee9c$var$channel.port2;
        $eb78275e0fbbee9c$var$channel.port1.onmessage = $eb78275e0fbbee9c$var$eventListener;
        $eb78275e0fbbee9c$var$defer = $ef78e71ca695bed1$exports($eb78275e0fbbee9c$var$port.postMessage, $eb78275e0fbbee9c$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($29d6451600dfd5bb$exports.addEventListener && $e857ae4b90351a33$exports($29d6451600dfd5bb$exports.postMessage) && !$29d6451600dfd5bb$exports.importScripts && $eb78275e0fbbee9c$var$$location && $eb78275e0fbbee9c$var$$location.protocol !== "file:" && !$785f01b450cff054$exports($eb78275e0fbbee9c$var$globalPostMessageDefer)) {
        $eb78275e0fbbee9c$var$defer = $eb78275e0fbbee9c$var$globalPostMessageDefer;
        $29d6451600dfd5bb$exports.addEventListener("message", $eb78275e0fbbee9c$var$eventListener, false);
    // IE8-
    } else if ($eb78275e0fbbee9c$var$ONREADYSTATECHANGE in $390d2a11631acc00$exports("script")) $eb78275e0fbbee9c$var$defer = function(id) {
        $4828dc6a126e81b9$exports.appendChild($390d2a11631acc00$exports("script"))[$eb78275e0fbbee9c$var$ONREADYSTATECHANGE] = function() {
            $4828dc6a126e81b9$exports.removeChild(this);
            $eb78275e0fbbee9c$var$run(id);
        };
    };
    else $eb78275e0fbbee9c$var$defer = function(id) {
        setTimeout($eb78275e0fbbee9c$var$runner(id), 0);
    };
}
$eb78275e0fbbee9c$exports = {
    set: $eb78275e0fbbee9c$var$set,
    clear: $eb78275e0fbbee9c$var$clear
};


var $52fb3d3531e175a3$require$clearImmediate = $eb78275e0fbbee9c$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$9948541b6667030f$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $29d6451600dfd5bb$exports.clearImmediate !== $52fb3d3531e175a3$require$clearImmediate
}, {
    clearImmediate: $52fb3d3531e175a3$require$clearImmediate
});





var $c3623e34adf3c47c$require$setTask = $eb78275e0fbbee9c$exports.set;
var $33bbcbb55e4c1239$exports = {};
"use strict";



var $b97c82f710002b7c$exports = {};
/* global Bun -- Deno case */ $b97c82f710002b7c$exports = typeof Bun == "function" && Bun && typeof Bun.version == "string";





var $33bbcbb55e4c1239$var$Function = $29d6451600dfd5bb$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $33bbcbb55e4c1239$var$WRAP = /MSIE .\./.test($ffcc5eac89666467$exports) || $b97c82f710002b7c$exports && function() {
    var version = $29d6451600dfd5bb$exports.Bun.version.split(".");
    return version.length < 3 || version[0] == 0 && (version[1] < 3 || version[1] == 3 && version[2] == 0);
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$33bbcbb55e4c1239$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $33bbcbb55e4c1239$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $b2931f60720117c8$exports(arguments.length, 1) > firstParamIndex;
        var fn = $e857ae4b90351a33$exports(handler) ? handler : $33bbcbb55e4c1239$var$Function(handler);
        var params = boundArgs ? $e58d911bcedaa28d$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $a93d1da99e0614d9$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $c3623e34adf3c47c$var$setImmediate = $29d6451600dfd5bb$exports.setImmediate ? $33bbcbb55e4c1239$exports($c3623e34adf3c47c$require$setTask, false) : $c3623e34adf3c47c$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$9948541b6667030f$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $29d6451600dfd5bb$exports.setImmediate !== $c3623e34adf3c47c$var$setImmediate
}, {
    setImmediate: $c3623e34adf3c47c$var$setImmediate
});




var $6eea7630e1b4f68d$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6eea7630e1b4f68d$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError(typeof iterable + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $6eea7630e1b4f68d$exports));
try {
    regeneratorRuntime = $6eea7630e1b4f68d$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $6eea7630e1b4f68d$var$runtime;
    else Function("r", "regeneratorRuntime = r")($6eea7630e1b4f68d$var$runtime);
}


var $8f0c139a7157e8ff$exports = {};
(function(self1) {
    "use strict";
    if (self1.fetch) return;
    var support = {
        searchParams: "URLSearchParams" in self1,
        iterable: "Symbol" in self1 && "iterator" in Symbol,
        blob: "FileReader" in self1 && "Blob" in self1 && function() {
            try {
                new Blob();
                return true;
            } catch (e) {
                return false;
            }
        }(),
        formData: "FormData" in self1,
        arrayBuffer: "ArrayBuffer" in self1
    };
    if (support.arrayBuffer) {
        var viewClasses = [
            "[object Int8Array]",
            "[object Uint8Array]",
            "[object Uint8ClampedArray]",
            "[object Int16Array]",
            "[object Uint16Array]",
            "[object Int32Array]",
            "[object Uint32Array]",
            "[object Float32Array]",
            "[object Float64Array]"
        ];
        var isDataView = function(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        };
        var isArrayBufferView = ArrayBuffer.isView || function(obj) {
            return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
        };
    }
    function normalizeName(name) {
        if (typeof name !== "string") name = String(name);
        if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
        return name.toLowerCase();
    }
    function normalizeValue(value) {
        if (typeof value !== "string") value = String(value);
        return value;
    }
    // Build a destructive iterator for the value list
    function iteratorFor(items) {
        var iterator = {
            next: function() {
                var value = items.shift();
                return {
                    done: value === undefined,
                    value: value
                };
            }
        };
        if (support.iterable) iterator[Symbol.iterator] = function() {
            return iterator;
        };
        return iterator;
    }
    function Headers(headers) {
        this.map = {};
        if (headers instanceof Headers) headers.forEach(function(value, name) {
            this.append(name, value);
        }, this);
        else if (Array.isArray(headers)) headers.forEach(function(header) {
            this.append(header[0], header[1]);
        }, this);
        else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
            this.append(name, headers[name]);
        }, this);
    }
    Headers.prototype.append = function(name, value) {
        name = normalizeName(name);
        value = normalizeValue(value);
        var oldValue = this.map[name];
        this.map[name] = oldValue ? oldValue + "," + value : value;
    };
    Headers.prototype["delete"] = function(name) {
        delete this.map[normalizeName(name)];
    };
    Headers.prototype.get = function(name) {
        name = normalizeName(name);
        return this.has(name) ? this.map[name] : null;
    };
    Headers.prototype.has = function(name) {
        return this.map.hasOwnProperty(normalizeName(name));
    };
    Headers.prototype.set = function(name, value) {
        this.map[normalizeName(name)] = normalizeValue(value);
    };
    Headers.prototype.forEach = function(callback, thisArg) {
        for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
    };
    Headers.prototype.keys = function() {
        var items = [];
        this.forEach(function(value, name) {
            items.push(name);
        });
        return iteratorFor(items);
    };
    Headers.prototype.values = function() {
        var items = [];
        this.forEach(function(value) {
            items.push(value);
        });
        return iteratorFor(items);
    };
    Headers.prototype.entries = function() {
        var items = [];
        this.forEach(function(value, name) {
            items.push([
                name,
                value
            ]);
        });
        return iteratorFor(items);
    };
    if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
    function consumed(body) {
        if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
        body.bodyUsed = true;
    }
    function fileReaderReady(reader) {
        return new Promise(function(resolve, reject) {
            reader.onload = function() {
                resolve(reader.result);
            };
            reader.onerror = function() {
                reject(reader.error);
            };
        });
    }
    function readBlobAsArrayBuffer(blob) {
        var reader = new FileReader();
        var promise = fileReaderReady(reader);
        reader.readAsArrayBuffer(blob);
        return promise;
    }
    function readBlobAsText(blob) {
        var reader = new FileReader();
        var promise = fileReaderReady(reader);
        reader.readAsText(blob);
        return promise;
    }
    function readArrayBufferAsText(buf) {
        var view = new Uint8Array(buf);
        var chars = new Array(view.length);
        for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
        return chars.join("");
    }
    function bufferClone(buf) {
        if (buf.slice) return buf.slice(0);
        else {
            var view = new Uint8Array(buf.byteLength);
            view.set(new Uint8Array(buf));
            return view.buffer;
        }
    }
    function Body() {
        this.bodyUsed = false;
        this._initBody = function(body) {
            this._bodyInit = body;
            if (!body) this._bodyText = "";
            else if (typeof body === "string") this._bodyText = body;
            else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
            else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
            else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
            else if (support.arrayBuffer && support.blob && isDataView(body)) {
                this._bodyArrayBuffer = bufferClone(body.buffer);
                // IE 10-11 can't handle a DataView body.
                this._bodyInit = new Blob([
                    this._bodyArrayBuffer
                ]);
            } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
            else throw new Error("unsupported BodyInit type");
            if (!this.headers.get("content-type")) {
                if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
            }
        };
        if (support.blob) {
            this.blob = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                    this._bodyArrayBuffer
                ]));
                else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                else return Promise.resolve(new Blob([
                    this._bodyText
                ]));
            };
            this.arrayBuffer = function() {
                if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                else return this.blob().then(readBlobAsArrayBuffer);
            };
        }
        this.text = function() {
            var rejected = consumed(this);
            if (rejected) return rejected;
            if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
            else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
            else if (this._bodyFormData) throw new Error("could not read FormData body as text");
            else return Promise.resolve(this._bodyText);
        };
        if (support.formData) this.formData = function() {
            return this.text().then(decode);
        };
        this.json = function() {
            return this.text().then(JSON.parse);
        };
        return this;
    }
    // HTTP methods whose capitalization should be normalized
    var methods = [
        "DELETE",
        "GET",
        "HEAD",
        "OPTIONS",
        "POST",
        "PUT"
    ];
    function normalizeMethod(method) {
        var upcased = method.toUpperCase();
        return methods.indexOf(upcased) > -1 ? upcased : method;
    }
    function Request(input, options) {
        options = options || {};
        var body = options.body;
        if (input instanceof Request) {
            if (input.bodyUsed) throw new TypeError("Already read");
            this.url = input.url;
            this.credentials = input.credentials;
            if (!options.headers) this.headers = new Headers(input.headers);
            this.method = input.method;
            this.mode = input.mode;
            if (!body && input._bodyInit != null) {
                body = input._bodyInit;
                input.bodyUsed = true;
            }
        } else this.url = String(input);
        this.credentials = options.credentials || this.credentials || "omit";
        if (options.headers || !this.headers) this.headers = new Headers(options.headers);
        this.method = normalizeMethod(options.method || this.method || "GET");
        this.mode = options.mode || this.mode || null;
        this.referrer = null;
        if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
        this._initBody(body);
    }
    Request.prototype.clone = function() {
        return new Request(this, {
            body: this._bodyInit
        });
    };
    function decode(body) {
        var form = new FormData();
        body.trim().split("&").forEach(function(bytes) {
            if (bytes) {
                var split = bytes.split("=");
                var name = split.shift().replace(/\+/g, " ");
                var value = split.join("=").replace(/\+/g, " ");
                form.append(decodeURIComponent(name), decodeURIComponent(value));
            }
        });
        return form;
    }
    function parseHeaders(rawHeaders) {
        var headers = new Headers();
        // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
        // https://tools.ietf.org/html/rfc7230#section-3.2
        var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
        preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
            var parts = line.split(":");
            var key = parts.shift().trim();
            if (key) {
                var value = parts.join(":").trim();
                headers.append(key, value);
            }
        });
        return headers;
    }
    Body.call(Request.prototype);
    function Response(bodyInit, options) {
        if (!options) options = {};
        this.type = "default";
        this.status = options.status === undefined ? 200 : options.status;
        this.ok = this.status >= 200 && this.status < 300;
        this.statusText = "statusText" in options ? options.statusText : "OK";
        this.headers = new Headers(options.headers);
        this.url = options.url || "";
        this._initBody(bodyInit);
    }
    Body.call(Response.prototype);
    Response.prototype.clone = function() {
        return new Response(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new Headers(this.headers),
            url: this.url
        });
    };
    Response.error = function() {
        var response = new Response(null, {
            status: 0,
            statusText: ""
        });
        response.type = "error";
        return response;
    };
    var redirectStatuses = [
        301,
        302,
        303,
        307,
        308
    ];
    Response.redirect = function(url, status) {
        if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
        return new Response(null, {
            status: status,
            headers: {
                location: url
            }
        });
    };
    self1.Headers = Headers;
    self1.Request = Request;
    self1.Response = Response;
    self1.fetch = function(input, init) {
        return new Promise(function(resolve, reject) {
            var request = new Request(input, init);
            var xhr = new XMLHttpRequest();
            xhr.onload = function() {
                var options = {
                    status: xhr.status,
                    statusText: xhr.statusText,
                    headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                };
                options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                var body = "response" in xhr ? xhr.response : xhr.responseText;
                resolve(new Response(body, options));
            };
            xhr.onerror = function() {
                reject(new TypeError("Network request failed"));
            };
            xhr.ontimeout = function() {
                reject(new TypeError("Network request failed"));
            };
            xhr.open(request.method, request.url, true);
            if (request.credentials === "include") xhr.withCredentials = true;
            else if (request.credentials === "omit") xhr.withCredentials = false;
            if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
            request.headers.forEach(function(value, name) {
                xhr.setRequestHeader(name, value);
            });
            xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
        });
    };
    self1.fetch.polyfill = true;
})(typeof self !== "undefined" ? self : $8f0c139a7157e8ff$exports);


/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */ (function() {
    "use strict";
    // Exit early if we're not running in a browser.
    if (typeof window !== "object") return;
    // Exit early if all IntersectionObserver and IntersectionObserverEntry
    // features are natively supported.
    if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
        // Minimal polyfill for Edge 15's lack of `isIntersecting`
        // See: https://github.com/w3c/IntersectionObserver/issues/211
        if (!("isIntersecting" in window.IntersectionObserverEntry.prototype)) Object.defineProperty(window.IntersectionObserverEntry.prototype, "isIntersecting", {
            get: function() {
                return this.intersectionRatio > 0;
            }
        });
        return;
    }
    /**
 * Returns the embedding frame element, if any.
 * @param {!Document} doc
 * @return {!Element}
 */ function getFrameElement(doc) {
        try {
            return doc.defaultView && doc.defaultView.frameElement || null;
        } catch (e) {
            // Ignore the error.
            return null;
        }
    }
    /**
 * A local reference to the root document.
 */ var document = function(startDoc) {
        var doc = startDoc;
        var frame = getFrameElement(doc);
        while(frame){
            doc = frame.ownerDocument;
            frame = getFrameElement(doc);
        }
        return doc;
    }(window.document);
    /**
 * An IntersectionObserver registry. This registry exists to hold a strong
 * reference to IntersectionObserver instances currently observing a target
 * element. Without this registry, instances without another reference may be
 * garbage collected.
 */ var registry = [];
    /**
 * The signal updater for cross-origin intersection. When not null, it means
 * that the polyfill is configured to work in a cross-origin mode.
 * @type {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */ var crossOriginUpdater = null;
    /**
 * The current cross-origin intersection. Only used in the cross-origin mode.
 * @type {DOMRect|ClientRect}
 */ var crossOriginRect = null;
    /**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */ function IntersectionObserverEntry(entry) {
        this.time = entry.time;
        this.target = entry.target;
        this.rootBounds = ensureDOMRect(entry.rootBounds);
        this.boundingClientRect = ensureDOMRect(entry.boundingClientRect);
        this.intersectionRect = ensureDOMRect(entry.intersectionRect || getEmptyRect());
        this.isIntersecting = !!entry.intersectionRect;
        // Calculates the intersection ratio.
        var targetRect = this.boundingClientRect;
        var targetArea = targetRect.width * targetRect.height;
        var intersectionRect = this.intersectionRect;
        var intersectionArea = intersectionRect.width * intersectionRect.height;
        // Sets intersection ratio.
        if (targetArea) // Round the intersection ratio to avoid floating point math issues:
        // https://github.com/w3c/IntersectionObserver/issues/324
        this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
        else // If area is zero and is intersecting, sets to 1, otherwise to 0
        this.intersectionRatio = this.isIntersecting ? 1 : 0;
    }
    /**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */ function IntersectionObserver(callback, opt_options) {
        var options = opt_options || {};
        if (typeof callback != "function") throw new Error("callback must be a function");
        if (options.root && options.root.nodeType != 1 && options.root.nodeType != 9) throw new Error("root must be a Document or Element");
        // Binds and throttles `this._checkForIntersections`.
        this._checkForIntersections = throttle(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);
        // Private properties.
        this._callback = callback;
        this._observationTargets = [];
        this._queuedEntries = [];
        this._rootMarginValues = this._parseRootMargin(options.rootMargin);
        // Public properties.
        this.thresholds = this._initThresholds(options.threshold);
        this.root = options.root || null;
        this.rootMargin = this._rootMarginValues.map(function(margin) {
            return margin.value + margin.unit;
        }).join(" ");
        /** @private @const {!Array<!Document>} */ this._monitoringDocuments = [];
        /** @private @const {!Array<function()>} */ this._monitoringUnsubscribes = [];
    }
    /**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */ IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;
    /**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */ IntersectionObserver.prototype.POLL_INTERVAL = null;
    /**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */ IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;
    /**
 * Sets up the polyfill in the cross-origin mode. The result is the
 * updater function that accepts two arguments: `boundingClientRect` and
 * `intersectionRect` - just as these fields would be available to the
 * parent via `IntersectionObserverEntry`. This function should be called
 * each time the iframe receives intersection information from the parent
 * window, e.g. via messaging.
 * @return {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */ IntersectionObserver._setupCrossOriginUpdater = function() {
        if (!crossOriginUpdater) /**
     * @param {DOMRect|ClientRect} boundingClientRect
     * @param {DOMRect|ClientRect} intersectionRect
     */ crossOriginUpdater = function(boundingClientRect, intersectionRect) {
            if (!boundingClientRect || !intersectionRect) crossOriginRect = getEmptyRect();
            else crossOriginRect = convertFromParentRect(boundingClientRect, intersectionRect);
            registry.forEach(function(observer) {
                observer._checkForIntersections();
            });
        };
        return crossOriginUpdater;
    };
    /**
 * Resets the cross-origin mode.
 */ IntersectionObserver._resetCrossOriginUpdater = function() {
        crossOriginUpdater = null;
        crossOriginRect = null;
    };
    /**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */ IntersectionObserver.prototype.observe = function(target) {
        var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
            return item.element == target;
        });
        if (isTargetAlreadyObserved) return;
        if (!(target && target.nodeType == 1)) throw new Error("target must be an Element");
        this._registerInstance();
        this._observationTargets.push({
            element: target,
            entry: null
        });
        this._monitorIntersections(target.ownerDocument);
        this._checkForIntersections();
    };
    /**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */ IntersectionObserver.prototype.unobserve = function(target) {
        this._observationTargets = this._observationTargets.filter(function(item) {
            return item.element != target;
        });
        this._unmonitorIntersections(target.ownerDocument);
        if (this._observationTargets.length == 0) this._unregisterInstance();
    };
    /**
 * Stops observing all target elements for intersection changes.
 */ IntersectionObserver.prototype.disconnect = function() {
        this._observationTargets = [];
        this._unmonitorAllIntersections();
        this._unregisterInstance();
    };
    /**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */ IntersectionObserver.prototype.takeRecords = function() {
        var records = this._queuedEntries.slice();
        this._queuedEntries = [];
        return records;
    };
    /**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */ IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
        var threshold = opt_threshold || [
            0
        ];
        if (!Array.isArray(threshold)) threshold = [
            threshold
        ];
        return threshold.sort().filter(function(t, i, a) {
            if (typeof t != "number" || isNaN(t) || t < 0 || t > 1) throw new Error("threshold must be a number between 0 and 1 inclusively");
            return t !== a[i - 1];
        });
    };
    /**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */ IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
        var marginString = opt_rootMargin || "0px";
        var margins = marginString.split(/\s+/).map(function(margin) {
            var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
            if (!parts) throw new Error("rootMargin must be specified in pixels or percent");
            return {
                value: parseFloat(parts[1]),
                unit: parts[2]
            };
        });
        // Handles shorthand.
        margins[1] = margins[1] || margins[0];
        margins[2] = margins[2] || margins[0];
        margins[3] = margins[3] || margins[1];
        return margins;
    };
    /**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibility state is visible.
 * @param {!Document} doc
 * @private
 */ IntersectionObserver.prototype._monitorIntersections = function(doc) {
        var win = doc.defaultView;
        if (!win) // Already destroyed.
        return;
        if (this._monitoringDocuments.indexOf(doc) != -1) // Already monitoring.
        return;
        // Private state for monitoring.
        var callback = this._checkForIntersections;
        var monitoringInterval = null;
        var domObserver = null;
        // If a poll interval is set, use polling instead of listening to
        // resize and scroll events or DOM mutations.
        if (this.POLL_INTERVAL) monitoringInterval = win.setInterval(callback, this.POLL_INTERVAL);
        else {
            addEvent(win, "resize", callback, true);
            addEvent(doc, "scroll", callback, true);
            if (this.USE_MUTATION_OBSERVER && "MutationObserver" in win) {
                domObserver = new win.MutationObserver(callback);
                domObserver.observe(doc, {
                    attributes: true,
                    childList: true,
                    characterData: true,
                    subtree: true
                });
            }
        }
        this._monitoringDocuments.push(doc);
        this._monitoringUnsubscribes.push(function() {
            // Get the window object again. When a friendly iframe is destroyed, it
            // will be null.
            var win = doc.defaultView;
            if (win) {
                if (monitoringInterval) win.clearInterval(monitoringInterval);
                removeEvent(win, "resize", callback, true);
            }
            removeEvent(doc, "scroll", callback, true);
            if (domObserver) domObserver.disconnect();
        });
        // Also monitor the parent.
        var rootDoc = this.root && (this.root.ownerDocument || this.root) || document;
        if (doc != rootDoc) {
            var frame = getFrameElement(doc);
            if (frame) this._monitorIntersections(frame.ownerDocument);
        }
    };
    /**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */ IntersectionObserver.prototype._unmonitorIntersections = function(doc) {
        var index = this._monitoringDocuments.indexOf(doc);
        if (index == -1) return;
        var rootDoc = this.root && (this.root.ownerDocument || this.root) || document;
        // Check if any dependent targets are still remaining.
        var hasDependentTargets = this._observationTargets.some(function(item) {
            var itemDoc = item.element.ownerDocument;
            // Target is in this context.
            if (itemDoc == doc) return true;
            // Target is nested in this context.
            while(itemDoc && itemDoc != rootDoc){
                var frame = getFrameElement(itemDoc);
                itemDoc = frame && frame.ownerDocument;
                if (itemDoc == doc) return true;
            }
            return false;
        });
        if (hasDependentTargets) return;
        // Unsubscribe.
        var unsubscribe = this._monitoringUnsubscribes[index];
        this._monitoringDocuments.splice(index, 1);
        this._monitoringUnsubscribes.splice(index, 1);
        unsubscribe();
        // Also unmonitor the parent.
        if (doc != rootDoc) {
            var frame = getFrameElement(doc);
            if (frame) this._unmonitorIntersections(frame.ownerDocument);
        }
    };
    /**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */ IntersectionObserver.prototype._unmonitorAllIntersections = function() {
        var unsubscribes = this._monitoringUnsubscribes.slice(0);
        this._monitoringDocuments.length = 0;
        this._monitoringUnsubscribes.length = 0;
        for(var i = 0; i < unsubscribes.length; i++)unsubscribes[i]();
    };
    /**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */ IntersectionObserver.prototype._checkForIntersections = function() {
        if (!this.root && crossOriginUpdater && !crossOriginRect) // Cross origin monitoring, but no initial data available yet.
        return;
        var rootIsInDom = this._rootIsInDom();
        var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();
        this._observationTargets.forEach(function(item) {
            var target = item.element;
            var targetRect = getBoundingClientRect(target);
            var rootContainsTarget = this._rootContainsTarget(target);
            var oldEntry = item.entry;
            var intersectionRect = rootIsInDom && rootContainsTarget && this._computeTargetAndRootIntersection(target, targetRect, rootRect);
            var rootBounds = null;
            if (!this._rootContainsTarget(target)) rootBounds = getEmptyRect();
            else if (!crossOriginUpdater || this.root) rootBounds = rootRect;
            var newEntry = item.entry = new IntersectionObserverEntry({
                time: now(),
                target: target,
                boundingClientRect: targetRect,
                rootBounds: rootBounds,
                intersectionRect: intersectionRect
            });
            if (!oldEntry) this._queuedEntries.push(newEntry);
            else if (rootIsInDom && rootContainsTarget) // If the new entry intersection ratio has crossed any of the
            // thresholds, add a new entry.
            {
                if (this._hasCrossedThreshold(oldEntry, newEntry)) this._queuedEntries.push(newEntry);
            } else // If the root is not in the DOM or target is not contained within
            // root but the previous entry for this target had an intersection,
            // add a new record indicating removal.
            if (oldEntry && oldEntry.isIntersecting) this._queuedEntries.push(newEntry);
        }, this);
        if (this._queuedEntries.length) this._callback(this.takeRecords(), this);
    };
    /**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} targetRect The bounding rect of the target.
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */ IntersectionObserver.prototype._computeTargetAndRootIntersection = function(target, targetRect, rootRect) {
        // If the element isn't displayed, an intersection can't happen.
        if (window.getComputedStyle(target).display == "none") return;
        var intersectionRect = targetRect;
        var parent = getParentNode(target);
        var atRoot = false;
        while(!atRoot && parent){
            var parentRect = null;
            var parentComputedStyle = parent.nodeType == 1 ? window.getComputedStyle(parent) : {};
            // If the parent isn't displayed, an intersection can't happen.
            if (parentComputedStyle.display == "none") return null;
            if (parent == this.root || parent.nodeType == /* DOCUMENT */ 9) {
                atRoot = true;
                if (parent == this.root || parent == document) {
                    if (crossOriginUpdater && !this.root) {
                        if (!crossOriginRect || crossOriginRect.width == 0 && crossOriginRect.height == 0) {
                            // A 0-size cross-origin intersection means no-intersection.
                            parent = null;
                            parentRect = null;
                            intersectionRect = null;
                        } else parentRect = crossOriginRect;
                    } else parentRect = rootRect;
                } else {
                    // Check if there's a frame that can be navigated to.
                    var frame = getParentNode(parent);
                    var frameRect = frame && getBoundingClientRect(frame);
                    var frameIntersect = frame && this._computeTargetAndRootIntersection(frame, frameRect, rootRect);
                    if (frameRect && frameIntersect) {
                        parent = frame;
                        parentRect = convertFromParentRect(frameRect, frameIntersect);
                    } else {
                        parent = null;
                        intersectionRect = null;
                    }
                }
            } else {
                // If the element has a non-visible overflow, and it's not the <body>
                // or <html> element, update the intersection rect.
                // Note: <body> and <html> cannot be clipped to a rect that's not also
                // the document rect, so no need to compute a new intersection.
                var doc = parent.ownerDocument;
                if (parent != doc.body && parent != doc.documentElement && parentComputedStyle.overflow != "visible") parentRect = getBoundingClientRect(parent);
            }
            // If either of the above conditionals set a new parentRect,
            // calculate new intersection data.
            if (parentRect) intersectionRect = computeRectIntersection(parentRect, intersectionRect);
            if (!intersectionRect) break;
            parent = parent && getParentNode(parent);
        }
        return intersectionRect;
    };
    /**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {ClientRect} The expanded root rect.
 * @private
 */ IntersectionObserver.prototype._getRootRect = function() {
        var rootRect;
        if (this.root && !isDoc(this.root)) rootRect = getBoundingClientRect(this.root);
        else {
            // Use <html>/<body> instead of window since scroll bars affect size.
            var doc = isDoc(this.root) ? this.root : document;
            var html = doc.documentElement;
            var body = doc.body;
            rootRect = {
                top: 0,
                left: 0,
                right: html.clientWidth || body.clientWidth,
                width: html.clientWidth || body.clientWidth,
                bottom: html.clientHeight || body.clientHeight,
                height: html.clientHeight || body.clientHeight
            };
        }
        return this._expandRectByRootMargin(rootRect);
    };
    /**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {DOMRect|ClientRect} rect The rect object to expand.
 * @return {ClientRect} The expanded rect.
 * @private
 */ IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
        var margins = this._rootMarginValues.map(function(margin, i) {
            return margin.unit == "px" ? margin.value : margin.value * (i % 2 ? rect.width : rect.height) / 100;
        });
        var newRect = {
            top: rect.top - margins[0],
            right: rect.right + margins[1],
            bottom: rect.bottom + margins[2],
            left: rect.left - margins[3]
        };
        newRect.width = newRect.right - newRect.left;
        newRect.height = newRect.bottom - newRect.top;
        return newRect;
    };
    /**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */ IntersectionObserver.prototype._hasCrossedThreshold = function(oldEntry, newEntry) {
        // To make comparing easier, an entry that has a ratio of 0
        // but does not actually intersect is given a value of -1
        var oldRatio = oldEntry && oldEntry.isIntersecting ? oldEntry.intersectionRatio || 0 : -1;
        var newRatio = newEntry.isIntersecting ? newEntry.intersectionRatio || 0 : -1;
        // Ignore unchanged ratios
        if (oldRatio === newRatio) return;
        for(var i = 0; i < this.thresholds.length; i++){
            var threshold = this.thresholds[i];
            // Return true if an entry matches a threshold or if the new ratio
            // and the old ratio are on the opposite sides of a threshold.
            if (threshold == oldRatio || threshold == newRatio || threshold < oldRatio !== threshold < newRatio) return true;
        }
    };
    /**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */ IntersectionObserver.prototype._rootIsInDom = function() {
        return !this.root || containsDeep(document, this.root);
    };
    /**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */ IntersectionObserver.prototype._rootContainsTarget = function(target) {
        var rootDoc = this.root && (this.root.ownerDocument || this.root) || document;
        return containsDeep(rootDoc, target) && (!this.root || rootDoc == target.ownerDocument);
    };
    /**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */ IntersectionObserver.prototype._registerInstance = function() {
        if (registry.indexOf(this) < 0) registry.push(this);
    };
    /**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */ IntersectionObserver.prototype._unregisterInstance = function() {
        var index = registry.indexOf(this);
        if (index != -1) registry.splice(index, 1);
    };
    /**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */ function now() {
        return window.performance && performance.now && performance.now();
    }
    /**
 * Throttles a function and delays its execution, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */ function throttle(fn, timeout) {
        var timer = null;
        return function() {
            if (!timer) timer = setTimeout(function() {
                fn();
                timer = null;
            }, timeout);
        };
    }
    /**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */ function addEvent(node, event, fn, opt_useCapture) {
        if (typeof node.addEventListener == "function") node.addEventListener(event, fn, opt_useCapture || false);
        else if (typeof node.attachEvent == "function") node.attachEvent("on" + event, fn);
    }
    /**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */ function removeEvent(node, event, fn, opt_useCapture) {
        if (typeof node.removeEventListener == "function") node.removeEventListener(event, fn, opt_useCapture || false);
        else if (typeof node.detachEvent == "function") node.detachEvent("on" + event, fn);
    }
    /**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object|?ClientRect} The intersection rect or undefined if no
 *     intersection is found.
 */ function computeRectIntersection(rect1, rect2) {
        var top = Math.max(rect1.top, rect2.top);
        var bottom = Math.min(rect1.bottom, rect2.bottom);
        var left = Math.max(rect1.left, rect2.left);
        var right = Math.min(rect1.right, rect2.right);
        var width = right - left;
        var height = bottom - top;
        return width >= 0 && height >= 0 && {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            width: width,
            height: height
        } || null;
    }
    /**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {DOMRect|ClientRect} The (possibly shimmed) rect of the element.
 */ function getBoundingClientRect(el) {
        var rect;
        try {
            rect = el.getBoundingClientRect();
        } catch (err) {
        // Ignore Windows 7 IE11 "Unspecified error"
        // https://github.com/w3c/IntersectionObserver/pull/205
        }
        if (!rect) return getEmptyRect();
        // Older IE
        if (!(rect.width && rect.height)) rect = {
            top: rect.top,
            right: rect.right,
            bottom: rect.bottom,
            left: rect.left,
            width: rect.right - rect.left,
            height: rect.bottom - rect.top
        };
        return rect;
    }
    /**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {ClientRect} The empty rect.
 */ function getEmptyRect() {
        return {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            width: 0,
            height: 0
        };
    }
    /**
 * Ensure that the result has all of the necessary fields of the DOMRect.
 * Specifically this ensures that `x` and `y` fields are set.
 *
 * @param {?DOMRect|?ClientRect} rect
 * @return {?DOMRect}
 */ function ensureDOMRect(rect) {
        // A `DOMRect` object has `x` and `y` fields.
        if (!rect || "x" in rect) return rect;
        // A IE's `ClientRect` type does not have `x` and `y`. The same is the case
        // for internally calculated Rect objects. For the purposes of
        // `IntersectionObserver`, it's sufficient to simply mirror `left` and `top`
        // for these fields.
        return {
            top: rect.top,
            y: rect.top,
            bottom: rect.bottom,
            left: rect.left,
            x: rect.left,
            right: rect.right,
            width: rect.width,
            height: rect.height
        };
    }
    /**
 * Inverts the intersection and bounding rect from the parent (frame) BCR to
 * the local BCR space.
 * @param {DOMRect|ClientRect} parentBoundingRect The parent's bound client rect.
 * @param {DOMRect|ClientRect} parentIntersectionRect The parent's own intersection rect.
 * @return {ClientRect} The local root bounding rect for the parent's children.
 */ function convertFromParentRect(parentBoundingRect, parentIntersectionRect) {
        var top = parentIntersectionRect.top - parentBoundingRect.top;
        var left = parentIntersectionRect.left - parentBoundingRect.left;
        return {
            top: top,
            left: left,
            height: parentIntersectionRect.height,
            width: parentIntersectionRect.width,
            bottom: top + parentIntersectionRect.height,
            right: left + parentIntersectionRect.width
        };
    }
    /**
 * Checks to see if a parent element contains a child element (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */ function containsDeep(parent, child) {
        var node = child;
        while(node){
            if (node == parent) return true;
            node = getParentNode(node);
        }
        return false;
    }
    /**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */ function getParentNode(node) {
        var parent = node.parentNode;
        if (node.nodeType == /* DOCUMENT */ 9 && node != document) // If this node is a document node, look for the embedding frame.
        return getFrameElement(node);
        // If the parent has element that is assigned through shadow root slot
        if (parent && parent.assignedSlot) parent = parent.assignedSlot.parentNode;
        if (parent && parent.nodeType == 11 && parent.host) // If the parent is a shadow root, return the host element.
        return parent.host;
        return parent;
    }
    /**
 * Returns true if `node` is a Document.
 * @param {!Node} node
 * @returns {boolean}
 */ function isDoc(node) {
        return node && node.nodeType === 9;
    }
    // Exposes the constructors globally.
    window.IntersectionObserver = IntersectionObserver;
    window.IntersectionObserverEntry = IntersectionObserverEntry;
})();


// polyfill .remove() for any element in DOM (specifically for IE11)
// https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove
// https://caniuse.com/#search=.remove
if (!Element.prototype.remove) Element.prototype.remove = function remove() {
    if (this.parentNode) this.parentNode.removeChild(this);
};
// Polyfill for Promise.allSettled
// Used by @atlassiansox/analytics-web-client
// https://caniuse.com/mdn-javascript_builtins_promise_allsettled
Promise.allSettled = Promise.allSettled || ((promises)=>{
    return Promise.all(promises.map((promise)=>{
        return promise.then((value)=>{
            return {
                status: "fulfilled",
                value: value
            };
        }).catch((reason)=>{
            return {
                status: "rejected",
                reason: reason
            };
        });
    }));
});



var $lC9T5 = parcelRequire("lC9T5");

var $lRlFX = parcelRequire("lRlFX");
var $ciA2E = parcelRequire("ciA2E");
var $gtIV9 = parcelRequire("gtIV9");
if (window.__sentry__) {
    const config = window.__sentry__;
    const blacklistUrls = [
        ...config.blacklistUrls || [],
        /localhost:3000/,
        // This isn't covered by Sentry's built-in browser extension detection, for some reason
        /^chrome-extension:\/\//i
    ];
    const ignoreErrors = [
        ...config.ignoreErrors || [],
        /**
   * This covers 2 separate exceptions that we see but are out of our control:
   *
   * - "TypeError: Failed to construct 'Request': Request cannot be constructed from a URL that includes credentials: <url>"
   * - "TypeError: Failed to execute 'fetch' on 'Window': Request cannot be constructed from a URL that includes credentials: <url>"
   *
   * We don't ever build URLs that include a username and password in them, so these are likely caused by browser extensions,
   * bookmarklets, a user script, etc. The 3rd party code itself could be constructing `Request` objects or making `fetch` requests
   * with URLs containing credentials, overriding the native behavior of `fetch`, or even navigating to a Bitbucket page with
   * credentials inserted. `fetch` requests to relative URLs carry over the username and password used on the current page rather than
   * dropping them, which could inadvertently add those to the `fetch` requests our code tries to make.
   */ "Request cannot be constructed from a URL that includes credentials",
        // (likely) Caused by ad-blocking in Firefox (only occurs for requests made to our metrics endpoint)
        "AbortError: The operation was aborted",
        // (likely) Caused by ad-blocking in IE11 (only occurs for requests made to our metrics endpoint)
        "Network request failed",
        // Caused by ad-blocking in Firefox
        "NetworkError when attempting to fetch resource",
        // Caused by ad-blocking in Safari and Edge
        "Resource blocked by content blocker",
        /**
   * This is thrown by `window.fetch`, but not for non-2XX responses. It's only thrown when fetch itself breaks, which could be
   * caused by:
   *
   *   - DNS issues
   *   - Bad HTTP headers
   *   - Malformed URL
   *   - The request was aborted by the browser (user navigates to another page before the request completes)
   *   - The request was blocked by an extension (i.e., an ad-blocker)
   *
   * Source: https://stackoverflow.com/questions/45383874/fetch-api-yields-typeerror-failed-to-fetch/47423883#47423883
   *
   * As of the date this comment was written, 97% of these errors are caused by requests to our metrics endpoint. This rules out
   * the first 3. The 4th is unlikely because it's not a slow request to make, which leaves ad-blocking as the most likely
   * source.
   */ "Failed to fetch",
        /**
   * Apparently this is a benign error. It triggers *a lot* of Sentry noise. We don't use ResizeObserver directly, so it could
   * be coming from a dependency (possibly the nav, since it seems to happen across a variety of pages)
   *
   * https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded/50387233#50387233
   */ "ResizeObserver loop limit exceeded",
        "ResizeObserver loop completed with undelivered notifications"
    ];
    const nrWrapperPattern = /\bnrWrapper\b/;
    const rewriteFrames = new $gtIV9.RewriteFrames({
        iteratee: (frame)=>{
            // 'nrWrapper' is from NewRelic and in the stack trace, it would show up with the filename being the current URL
            // (including things like the repository slug). That meant that every stack trace was different, breaking Sentry's
            // grouping of errors. So rewrite those frames to fix that, see https://github.com/getsentry/sentry/issues/7709
            if (frame.function && nrWrapperPattern.test(frame.function)) {
                frame.filename = "?";
                frame.lineno = 0;
                frame.colno = 0;
                frame.in_app = false;
            }
            return frame;
        }
    });
    $lC9T5.init({
        ...config,
        release: "3ae736c0c20949d4aecaca91e90f7e6fc1850bc7",
        blacklistUrls: blacklistUrls,
        ignoreErrors: ignoreErrors,
        integrations: [
            new $lRlFX.Dedupe(),
            new $ciA2E.ExtraErrorData(),
            rewriteFrames
        ]
    });
}



var $1ZBmx = parcelRequire("1ZBmx");
if (!(0, $1ZBmx.IS_SERVER)) /* eslint-disable prefer-destructuring, @typescript-eslint/naming-convention, no-undef */ // @ts-ignore
__webpack_nonce__ = window.__webpack_nonce__;
var $488d25fbd31ca789$export$2e2bcd8739ae039 = window.__webpack_nonce__;


/* eslint-disable prefer-destructuring, @typescript-eslint/naming-convention, no-undef */ // @ts-ignore
__webpack_public_path__ = window.__webpack_public_path__;
var $0179fbf509518ee6$export$2e2bcd8739ae039 = window.__webpack_public_path__;



var $9nHZC = parcelRequire("9nHZC");

var $lnOmc = parcelRequire("lnOmc");

var $agjvf = parcelRequire("agjvf");

var $8shKB = parcelRequire("8shKB");
parcelRequire("hw8PW");
var $l9p9x = parcelRequire("l9p9x");
var $hw8PW = parcelRequire("hw8PW");

var $1ZBmx = parcelRequire("1ZBmx");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("dOsQd");
var $5gpbZ = parcelRequire("5gpbZ");

var $3XbtU = parcelRequire("3XbtU");
var $3d4f2a5260e82ed0$exports = {};

$parcel$defineInteropFlag($3d4f2a5260e82ed0$exports);
$parcel$export($3d4f2a5260e82ed0$exports, "ApolloClient", function () { return (parcelRequire("grvSO")).ApolloClient; });

$parcel$export($3d4f2a5260e82ed0$exports, "HttpLink", function () { return $27300495728577b8$export$f4bbf1aec241cc1; });

var $l5MLt = parcelRequire("l5MLt");

var $grvSO = parcelRequire("grvSO");

var $cHmNF = parcelRequire("cHmNF");
var $jTh3A = parcelRequire("jTh3A");

var $l5MLt = parcelRequire("l5MLt");

var $jm5tp = parcelRequire("jm5tp");
function $86a96b991c4fae67$var$queryFromPojo(obj) {
    var op = {
        kind: "OperationDefinition",
        operation: "query",
        name: {
            kind: "Name",
            value: "GeneratedClientQuery"
        },
        selectionSet: $86a96b991c4fae67$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: "Document",
        definitions: [
            op
        ]
    };
    return out;
}
function $86a96b991c4fae67$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: "FragmentDefinition",
        typeCondition: {
            kind: "NamedType",
            name: {
                kind: "Name",
                value: typename || "__FakeType"
            }
        },
        name: {
            kind: "Name",
            value: "GeneratedClientQuery"
        },
        selectionSet: $86a96b991c4fae67$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: "Document",
        definitions: [
            frag
        ]
    };
    return out;
}
function $86a96b991c4fae67$var$selectionSetFromObj(obj) {
    if (typeof obj === "number" || typeof obj === "boolean" || typeof obj === "string" || typeof obj === "undefined" || obj === null) return null;
    if (Array.isArray(obj)) return $86a96b991c4fae67$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $86a96b991c4fae67$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: "Field",
            name: {
                kind: "Name",
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: "SelectionSet",
        selections: selections
    };
    return selectionSet;
}
var $86a96b991c4fae67$var$justTypenameQuery = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: null,
                        name: {
                            kind: "Name",
                            value: "__typename"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $86a96b991c4fae67$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $jm5tp.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: "ROOT_QUERY",
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $jm5tp.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== "undefined") {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $86a96b991c4fae67$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || "__ClientData";
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $86a96b991c4fae67$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $86a96b991c4fae67$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $86a96b991c4fae67$export$94affb487e701bf2;
$86a96b991c4fae67$export$94affb487e701bf2 || ($86a96b991c4fae67$export$94affb487e701bf2 = {});



var $jm5tp = parcelRequire("jm5tp");
var $4OFPo = parcelRequire("4OFPo");
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $77c8fbdcb2909bf5$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $77c8fbdcb2909bf5$var$MISSING_VALUE = {};
var $77c8fbdcb2909bf5$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $77c8fbdcb2909bf5$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $77c8fbdcb2909bf5$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $77c8fbdcb2909bf5$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $77c8fbdcb2909bf5$var$MISSING_VALUE) break;
                if (context_1 !== $77c8fbdcb2909bf5$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $77c8fbdcb2909bf5$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($77c8fbdcb2909bf5$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $77c8fbdcb2909bf5$var$currentContext.slots[this.id] = $77c8fbdcb2909bf5$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $77c8fbdcb2909bf5$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $77c8fbdcb2909bf5$var$currentContext;
            $77c8fbdcb2909bf5$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $77c8fbdcb2909bf5$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $77c8fbdcb2909bf5$var$currentContext;
            return function() {
                var saved = $77c8fbdcb2909bf5$var$currentContext;
                try {
                    $77c8fbdcb2909bf5$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $77c8fbdcb2909bf5$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($77c8fbdcb2909bf5$var$currentContext) {
                var saved = $77c8fbdcb2909bf5$var$currentContext;
                try {
                    $77c8fbdcb2909bf5$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $77c8fbdcb2909bf5$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $77c8fbdcb2909bf5$var$globalKey = "@wry/context:Slot";
var $77c8fbdcb2909bf5$var$host = Array;
var $77c8fbdcb2909bf5$export$8c6ed5c666ac1360 = $77c8fbdcb2909bf5$var$host[$77c8fbdcb2909bf5$var$globalKey] || function() {
    var Slot = $77c8fbdcb2909bf5$var$makeSlotClass();
    try {
        Object.defineProperty($77c8fbdcb2909bf5$var$host, $77c8fbdcb2909bf5$var$globalKey, {
            value: $77c8fbdcb2909bf5$var$host[$77c8fbdcb2909bf5$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $77c8fbdcb2909bf5$export$2385a24977818dd0 = $77c8fbdcb2909bf5$export$8c6ed5c666ac1360.bind, $77c8fbdcb2909bf5$export$9fa6f2e300a97f8 = $77c8fbdcb2909bf5$export$8c6ed5c666ac1360.noContext;
function $77c8fbdcb2909bf5$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($77c8fbdcb2909bf5$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $77c8fbdcb2909bf5$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $77c8fbdcb2909bf5$export$2385a24977818dd0(gen.next);
        var boundThrow = $77c8fbdcb2909bf5$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($77c8fbdcb2909bf5$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $77c8fbdcb2909bf5$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $77c8fbdcb2909bf5$var$wrappedFibers = [];
function $77c8fbdcb2909bf5$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($77c8fbdcb2909bf5$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $77c8fbdcb2909bf5$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $77c8fbdcb2909bf5$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}


function $2907ea7c5c8773f2$var$defaultDispose() {}
var $2907ea7c5c8773f2$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $2907ea7c5c8773f2$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $2907ea7c5c8773f2$var$parentEntrySlot = new (0, $77c8fbdcb2909bf5$export$8c6ed5c666ac1360)();
var $2907ea7c5c8773f2$var$reusableEmptyArray = [];
var $2907ea7c5c8773f2$var$emptySetPool = [];
var $2907ea7c5c8773f2$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $2907ea7c5c8773f2$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $2907ea7c5c8773f2$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $2907ea7c5c8773f2$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $2907ea7c5c8773f2$var$valueCopy(value) {
    return value.slice(0);
}
var $2907ea7c5c8773f2$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $2907ea7c5c8773f2$var$assert(!this.recomputing, "already recomputing");
        if (!$2907ea7c5c8773f2$var$rememberParent(this) && $2907ea7c5c8773f2$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $2907ea7c5c8773f2$var$mightBeDirty(this) ? $2907ea7c5c8773f2$var$reallyRecompute(this) : $2907ea7c5c8773f2$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $2907ea7c5c8773f2$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $2907ea7c5c8773f2$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $2907ea7c5c8773f2$var$forgetChildren(this).forEach($2907ea7c5c8773f2$var$maybeReportOrphan);
        $2907ea7c5c8773f2$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $2907ea7c5c8773f2$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $2907ea7c5c8773f2$var$rememberParent(child) {
    var parent = $2907ea7c5c8773f2$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($2907ea7c5c8773f2$var$mightBeDirty(child)) $2907ea7c5c8773f2$var$reportDirtyChild(parent, child);
        else $2907ea7c5c8773f2$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $2907ea7c5c8773f2$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $2907ea7c5c8773f2$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $2907ea7c5c8773f2$var$parentEntrySlot.withValue(entry, $2907ea7c5c8773f2$var$recomputeNewValue, [
        entry
    ]);
    if ($2907ea7c5c8773f2$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $2907ea7c5c8773f2$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($2907ea7c5c8773f2$var$maybeReportOrphan);
    return $2907ea7c5c8773f2$var$valueGet(entry.value);
}
function $2907ea7c5c8773f2$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $2907ea7c5c8773f2$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $2907ea7c5c8773f2$var$setClean(entry) {
    entry.dirty = false;
    if ($2907ea7c5c8773f2$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $2907ea7c5c8773f2$var$reportClean(entry);
}
function $2907ea7c5c8773f2$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $2907ea7c5c8773f2$var$reportDirtyChild(parent, child);
    });
}
function $2907ea7c5c8773f2$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $2907ea7c5c8773f2$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $2907ea7c5c8773f2$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $2907ea7c5c8773f2$var$assert(parent.childValues.has(child));
    $2907ea7c5c8773f2$var$assert($2907ea7c5c8773f2$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $2907ea7c5c8773f2$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $2907ea7c5c8773f2$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $2907ea7c5c8773f2$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $2907ea7c5c8773f2$var$assert(parent.childValues.has(child));
    $2907ea7c5c8773f2$var$assert(!$2907ea7c5c8773f2$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $2907ea7c5c8773f2$var$valueCopy(child.value));
    else if (!$2907ea7c5c8773f2$var$valueIs(childValue, child.value)) parent.setDirty();
    $2907ea7c5c8773f2$var$removeDirtyChild(parent, child);
    if ($2907ea7c5c8773f2$var$mightBeDirty(parent)) return;
    $2907ea7c5c8773f2$var$reportClean(parent);
}
function $2907ea7c5c8773f2$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($2907ea7c5c8773f2$var$emptySetPool.length < $2907ea7c5c8773f2$var$POOL_TARGET_SIZE) $2907ea7c5c8773f2$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $2907ea7c5c8773f2$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $2907ea7c5c8773f2$var$forgetChildren(parent) {
    var children = $2907ea7c5c8773f2$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $2907ea7c5c8773f2$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $2907ea7c5c8773f2$var$assert(parent.dirtyChildren === null);
    return children;
}
function $2907ea7c5c8773f2$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $2907ea7c5c8773f2$var$removeDirtyChild(parent, child);
}
function $2907ea7c5c8773f2$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $2907ea7c5c8773f2$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $2907ea7c5c8773f2$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $2907ea7c5c8773f2$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $2907ea7c5c8773f2$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $2907ea7c5c8773f2$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $2907ea7c5c8773f2$var$keyTrie = new $2907ea7c5c8773f2$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $2907ea7c5c8773f2$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $2907ea7c5c8773f2$var$keyTrie.lookupArray(args);
}
var $2907ea7c5c8773f2$var$caches = new Set();
function $2907ea7c5c8773f2$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $2907ea7c5c8773f2$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $2907ea7c5c8773f2$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$2907ea7c5c8773f2$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $2907ea7c5c8773f2$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $2907ea7c5c8773f2$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$2907ea7c5c8773f2$var$parentEntrySlot.hasValue()) {
            $2907ea7c5c8773f2$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $2907ea7c5c8773f2$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}



var $Tvg0H = parcelRequire("Tvg0H");
var $cba9a046ce2ed465$var$haveWarned = false;
function $cba9a046ce2ed465$var$shouldWarn() {
    var answer = !$cba9a046ce2ed465$var$haveWarned;
    if (!(0, $jm5tp.isTest)()) $cba9a046ce2ed465$var$haveWarned = true;
    return answer;
}
var $cba9a046ce2ed465$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === "ROOT_QUERY";
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && "Query" : _a;
        if (!__typename) {
            $cba9a046ce2ed465$var$shouldWarn();
            return "heuristic";
        }
        if (__typename === typeCondition) return true;
        $cba9a046ce2ed465$var$shouldWarn();
        return "heuristic";
    };
    return HeuristicFragmentMatcher;
}();
var $cba9a046ce2ed465$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $Tvg0H.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === "ROOT_QUERY";
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && "Query" : _a;
        (0, $Tvg0H.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === "UNION" || type.kind === "INTERFACE") typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $cba9a046ce2ed465$var$hasOwn = Object.prototype.hasOwnProperty;
var $cba9a046ce2ed465$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $2907ea7c5c8773f2$export$4997ffc0176396a6)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($cba9a046ce2ed465$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$cba9a046ce2ed465$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $cba9a046ce2ed465$var$defaultNormalizedCacheFactory(seed) {
    return new $cba9a046ce2ed465$var$DepTrackingCache(seed);
}
var $cba9a046ce2ed465$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $2907ea7c5c8773f2$export$6bd8d8299be3ac82)((0, $jm5tp.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $2907ea7c5c8773f2$export$4997ffc0176396a6)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $cba9a046ce2ed465$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $2907ea7c5c8773f2$export$4997ffc0176396a6)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $cba9a046ce2ed465$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $2907ea7c5c8773f2$export$4997ffc0176396a6)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $cba9a046ce2ed465$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? "ROOT_QUERY" : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $jm5tp.getQueryDefinition)(query);
        variables = (0, $jm5tp.assign)({}, (0, $jm5tp.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: "id",
                id: rootId,
                generated: true,
                typename: "Query"
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $Tvg0H.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $4OFPo.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $cba9a046ce2ed465$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $jm5tp.getMainDefinition)(query);
        var fragments = (0, $jm5tp.getFragmentDefinitions)(query);
        var fragmentMap = (0, $jm5tp.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === "ROOT_QUERY" && "Query" || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jm5tp.shouldInclude)(selection, variables)) return;
            if ((0, $jm5tp.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== "undefined") objectsToMerge.push((_a = {}, _a[(0, $jm5tp.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $jm5tp.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $Tvg0H.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === "heuristic" && fragmentExecResult.missing) fragmentExecResult = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $jm5tp.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $jm5tp.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $jm5tp.resultKeyNameFromField)(field),
            directives: (0, $jm5tp.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $cba9a046ce2ed465$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $cba9a046ce2ed465$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $cba9a046ce2ed465$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $cba9a046ce2ed465$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $jm5tp.isIdValue)(value)) throw new (0, $Tvg0H.InvariantError)(10);
}
function $cba9a046ce2ed465$var$defaultFragmentMatcher() {
    return true;
}
function $cba9a046ce2ed465$export$7a4899fe13f33235(idValue) {
    (0, $Tvg0H.invariant)((0, $jm5tp.isIdValue)(idValue), 11);
}
function $cba9a046ce2ed465$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $jm5tp.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === "undefined" && context.cacheRedirects && typeof typename === "string") {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $jm5tp.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === "undefined") return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $jm5tp.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $cba9a046ce2ed465$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $cba9a046ce2ed465$export$7e2b40d1002de152(seed) {
    return new $cba9a046ce2ed465$export$ee7258b8691956a3(seed);
}
var $cba9a046ce2ed465$export$de4e6870dc6ac801 = function(_super) {
    (0, $l5MLt.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "WriteError";
        return _this;
    }
    return WriteError;
}(Error);
function $cba9a046ce2ed465$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $cba9a046ce2ed465$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += "\n" + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $cba9a046ce2ed465$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $cba9a046ce2ed465$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: "ROOT_QUERY",
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $cba9a046ce2ed465$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $jm5tp.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $jm5tp.assign)({}, (0, $jm5tp.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $jm5tp.createFragmentMap)((0, $jm5tp.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $cba9a046ce2ed465$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jm5tp.shouldInclude)(selection, variables)) return;
            if ((0, $jm5tp.isField)(selection)) {
                var resultFieldKey = (0, $jm5tp.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== "undefined") _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === "defer";
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === "client";
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $jm5tp.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $Tvg0H.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || "self";
                    var idValue = (0, $jm5tp.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $cba9a046ce2ed465$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $jm5tp.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $jm5tp.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === "object" ? {
            type: "json",
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$cba9a046ce2ed465$var$isGeneratedId(valueDataId)) valueDataId = "$" + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $Tvg0H.invariant)(!semanticId || !$cba9a046ce2ed465$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === "number" && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$cba9a046ce2ed465$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $jm5tp.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $jm5tp.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $Tvg0H.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $Tvg0H.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $cba9a046ce2ed465$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $4OFPo.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$cba9a046ce2ed465$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $jm5tp.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $cba9a046ce2ed465$var$isGeneratedId(id) {
    return id[0] === "$";
}
function $cba9a046ce2ed465$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $jm5tp.isIdValue)(value) && $cba9a046ce2ed465$var$isGeneratedId(value.id) && (0, $jm5tp.isIdValue)(realValue) && !(0, $4OFPo.equal)(value, realValue) && $cba9a046ce2ed465$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, generated), real);
    if ((0, $4OFPo.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $cba9a046ce2ed465$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $cba9a046ce2ed465$var$defaultConfig = {
    fragmentMatcher: new $cba9a046ce2ed465$export$5d3fcf53267091de(),
    dataIdFromObject: $cba9a046ce2ed465$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $cba9a046ce2ed465$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $cba9a046ce2ed465$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $cba9a046ce2ed465$var$OptimisticCacheLayer = function(_super) {
    (0, $l5MLt.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $cba9a046ce2ed465$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($cba9a046ce2ed465$export$ee7258b8691956a3);
var $cba9a046ce2ed465$export$467265324939f47f = function(_super) {
    (0, $l5MLt.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $2907ea7c5c8773f2$export$6bd8d8299be3ac82)((0, $jm5tp.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, $cba9a046ce2ed465$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $cba9a046ce2ed465$var$DepTrackingCache() : new $cba9a046ce2ed465$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $cba9a046ce2ed465$export$eb8361c5d132fb8f();
        _this.storeReader = new $cba9a046ce2ed465$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $2907ea7c5c8773f2$export$4997ffc0176396a6)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $cba9a046ce2ed465$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === "string" && typeof this.data.get(options.rootId) === "undefined") return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $Tvg0H.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $cba9a046ce2ed465$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === "string") this.data = this.optimisticData = new $cba9a046ce2ed465$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $jm5tp.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $86a96b991c4fae67$export$5fc74f25506aa9c));



var $l5MLt = parcelRequire("l5MLt");

var $cHmNF = parcelRequire("cHmNF");
var $jTh3A = parcelRequire("jTh3A");

var $l5MLt = parcelRequire("l5MLt");
var $05cefe5a7272afc1$exports = {};
"use strict";
Object.defineProperty($05cefe5a7272afc1$exports, "__esModule", {
    value: true
});
$05cefe5a7272afc1$exports.print = $05cefe5a7272afc1$var$print;

var $dOVPe = parcelRequire("dOVPe");
var $9bf275487cba0982$exports = {};
"use strict";
Object.defineProperty($9bf275487cba0982$exports, "__esModule", {
    value: true
});
$9bf275487cba0982$exports.dedentBlockStringValue = $9bf275487cba0982$var$dedentBlockStringValue;
$9bf275487cba0982$exports.getBlockStringIndentation = $9bf275487cba0982$var$getBlockStringIndentation;
$9bf275487cba0982$exports.printBlockString = $9bf275487cba0982$var$printBlockString;
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $9bf275487cba0982$var$dedentBlockStringValue(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $9bf275487cba0982$var$getBlockStringIndentation(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $9bf275487cba0982$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $9bf275487cba0982$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join("\n");
}
function $9bf275487cba0982$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== " " && str[i] !== "	") return false;
    }
    return true;
}
/**
 * @internal
 */ function $9bf275487cba0982$var$getBlockStringIndentation(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */ function $9bf275487cba0982$var$printBlockString(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf("\n") === -1;
    var hasLeadingSpace = value[0] === " " || value[0] === "	";
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === "\\";
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ""; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += "\n" + indentation;
    result += indentation ? value.replace(/\n/g, "\n" + indentation) : value;
    if (printAsMultipleLines) result += "\n";
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}


/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */ function $05cefe5a7272afc1$var$print(ast) {
    return (0, $dOVPe.visit)(ast, {
        leave: $05cefe5a7272afc1$var$printDocASTReducer
    });
}
var $05cefe5a7272afc1$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $05cefe5a7272afc1$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return "$" + node.name;
    },
    // Document
    Document: function Document(node) {
        return $05cefe5a7272afc1$var$join(node.definitions, "\n\n") + "\n";
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $05cefe5a7272afc1$var$wrap("(", $05cefe5a7272afc1$var$join(node.variableDefinitions, ", "), ")");
        var directives = $05cefe5a7272afc1$var$join(node.directives, " ");
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === "query" ? selectionSet : $05cefe5a7272afc1$var$join([
            op,
            $05cefe5a7272afc1$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], " ");
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ": " + type + $05cefe5a7272afc1$var$wrap(" = ", defaultValue) + $05cefe5a7272afc1$var$wrap(" ", $05cefe5a7272afc1$var$join(directives, " "));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $05cefe5a7272afc1$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $05cefe5a7272afc1$var$wrap("", alias, ": ") + name;
        var argsLine = prefix + $05cefe5a7272afc1$var$wrap("(", $05cefe5a7272afc1$var$join(args, ", "), ")");
        if (argsLine.length > $05cefe5a7272afc1$var$MAX_LINE_LENGTH) argsLine = prefix + $05cefe5a7272afc1$var$wrap("(\n", $05cefe5a7272afc1$var$indent($05cefe5a7272afc1$var$join(args, "\n")), "\n)");
        return $05cefe5a7272afc1$var$join([
            argsLine,
            $05cefe5a7272afc1$var$join(directives, " "),
            selectionSet
        ], " ");
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ": " + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return "..." + name + $05cefe5a7272afc1$var$wrap(" ", $05cefe5a7272afc1$var$join(directives, " "));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $05cefe5a7272afc1$var$join([
            "...",
            $05cefe5a7272afc1$var$wrap("on ", typeCondition),
            $05cefe5a7272afc1$var$join(directives, " "),
            selectionSet
        ], " ");
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($05cefe5a7272afc1$var$wrap("(", $05cefe5a7272afc1$var$join(variableDefinitions, ", "), ")"), " ") + "on ".concat(typeCondition, " ").concat($05cefe5a7272afc1$var$wrap("", $05cefe5a7272afc1$var$join(directives, " "), " ")) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $9bf275487cba0982$exports.printBlockString)(value, key === "description" ? "" : "  ") : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? "true" : "false";
    },
    NullValue: function NullValue() {
        return "null";
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return "[" + $05cefe5a7272afc1$var$join(values, ", ") + "]";
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return "{" + $05cefe5a7272afc1$var$join(fields, ", ") + "}";
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ": " + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return "@" + name + $05cefe5a7272afc1$var$wrap("(", $05cefe5a7272afc1$var$join(args, ", "), ")");
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return "[" + type + "]";
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + "!";
    },
    // Type System Definitions
    SchemaDefinition: $05cefe5a7272afc1$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $05cefe5a7272afc1$var$join([
            "schema",
            $05cefe5a7272afc1$var$join(directives, " "),
            $05cefe5a7272afc1$var$block(operationTypes)
        ], " ");
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ": " + type;
    },
    ScalarTypeDefinition: $05cefe5a7272afc1$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $05cefe5a7272afc1$var$join([
            "scalar",
            name,
            $05cefe5a7272afc1$var$join(directives, " ")
        ], " ");
    }),
    ObjectTypeDefinition: $05cefe5a7272afc1$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $05cefe5a7272afc1$var$join([
            "type",
            name,
            $05cefe5a7272afc1$var$wrap("implements ", $05cefe5a7272afc1$var$join(interfaces, " & ")),
            $05cefe5a7272afc1$var$join(directives, " "),
            $05cefe5a7272afc1$var$block(fields)
        ], " ");
    }),
    FieldDefinition: $05cefe5a7272afc1$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($05cefe5a7272afc1$var$hasMultilineItems(args) ? $05cefe5a7272afc1$var$wrap("(\n", $05cefe5a7272afc1$var$indent($05cefe5a7272afc1$var$join(args, "\n")), "\n)") : $05cefe5a7272afc1$var$wrap("(", $05cefe5a7272afc1$var$join(args, ", "), ")")) + ": " + type + $05cefe5a7272afc1$var$wrap(" ", $05cefe5a7272afc1$var$join(directives, " "));
    }),
    InputValueDefinition: $05cefe5a7272afc1$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $05cefe5a7272afc1$var$join([
            name + ": " + type,
            $05cefe5a7272afc1$var$wrap("= ", defaultValue),
            $05cefe5a7272afc1$var$join(directives, " ")
        ], " ");
    }),
    InterfaceTypeDefinition: $05cefe5a7272afc1$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $05cefe5a7272afc1$var$join([
            "interface",
            name,
            $05cefe5a7272afc1$var$wrap("implements ", $05cefe5a7272afc1$var$join(interfaces, " & ")),
            $05cefe5a7272afc1$var$join(directives, " "),
            $05cefe5a7272afc1$var$block(fields)
        ], " ");
    }),
    UnionTypeDefinition: $05cefe5a7272afc1$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $05cefe5a7272afc1$var$join([
            "union",
            name,
            $05cefe5a7272afc1$var$join(directives, " "),
            types && types.length !== 0 ? "= " + $05cefe5a7272afc1$var$join(types, " | ") : ""
        ], " ");
    }),
    EnumTypeDefinition: $05cefe5a7272afc1$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $05cefe5a7272afc1$var$join([
            "enum",
            name,
            $05cefe5a7272afc1$var$join(directives, " "),
            $05cefe5a7272afc1$var$block(values)
        ], " ");
    }),
    EnumValueDefinition: $05cefe5a7272afc1$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $05cefe5a7272afc1$var$join([
            name,
            $05cefe5a7272afc1$var$join(directives, " ")
        ], " ");
    }),
    InputObjectTypeDefinition: $05cefe5a7272afc1$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $05cefe5a7272afc1$var$join([
            "input",
            name,
            $05cefe5a7272afc1$var$join(directives, " "),
            $05cefe5a7272afc1$var$block(fields)
        ], " ");
    }),
    DirectiveDefinition: $05cefe5a7272afc1$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return "directive @" + name + ($05cefe5a7272afc1$var$hasMultilineItems(args) ? $05cefe5a7272afc1$var$wrap("(\n", $05cefe5a7272afc1$var$indent($05cefe5a7272afc1$var$join(args, "\n")), "\n)") : $05cefe5a7272afc1$var$wrap("(", $05cefe5a7272afc1$var$join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + $05cefe5a7272afc1$var$join(locations, " | ");
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $05cefe5a7272afc1$var$join([
            "extend schema",
            $05cefe5a7272afc1$var$join(directives, " "),
            $05cefe5a7272afc1$var$block(operationTypes)
        ], " ");
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $05cefe5a7272afc1$var$join([
            "extend scalar",
            name,
            $05cefe5a7272afc1$var$join(directives, " ")
        ], " ");
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $05cefe5a7272afc1$var$join([
            "extend type",
            name,
            $05cefe5a7272afc1$var$wrap("implements ", $05cefe5a7272afc1$var$join(interfaces, " & ")),
            $05cefe5a7272afc1$var$join(directives, " "),
            $05cefe5a7272afc1$var$block(fields)
        ], " ");
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $05cefe5a7272afc1$var$join([
            "extend interface",
            name,
            $05cefe5a7272afc1$var$wrap("implements ", $05cefe5a7272afc1$var$join(interfaces, " & ")),
            $05cefe5a7272afc1$var$join(directives, " "),
            $05cefe5a7272afc1$var$block(fields)
        ], " ");
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $05cefe5a7272afc1$var$join([
            "extend union",
            name,
            $05cefe5a7272afc1$var$join(directives, " "),
            types && types.length !== 0 ? "= " + $05cefe5a7272afc1$var$join(types, " | ") : ""
        ], " ");
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $05cefe5a7272afc1$var$join([
            "extend enum",
            name,
            $05cefe5a7272afc1$var$join(directives, " "),
            $05cefe5a7272afc1$var$block(values)
        ], " ");
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $05cefe5a7272afc1$var$join([
            "extend input",
            name,
            $05cefe5a7272afc1$var$join(directives, " "),
            $05cefe5a7272afc1$var$block(fields)
        ], " ");
    }
};
function $05cefe5a7272afc1$var$addDescription(cb) {
    return function(node) {
        return $05cefe5a7272afc1$var$join([
            node.description,
            cb(node)
        ], "\n");
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $05cefe5a7272afc1$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $05cefe5a7272afc1$var$block(array) {
    return $05cefe5a7272afc1$var$wrap("{\n", $05cefe5a7272afc1$var$indent($05cefe5a7272afc1$var$join(array, "\n")), "\n}");
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $05cefe5a7272afc1$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    return maybeString != null && maybeString !== "" ? start + maybeString + end : "";
}
function $05cefe5a7272afc1$var$indent(str) {
    return $05cefe5a7272afc1$var$wrap("  ", str.replace(/\n/g, "\n  "));
}
function $05cefe5a7272afc1$var$isMultiline(str) {
    return str.indexOf("\n") !== -1;
}
function $05cefe5a7272afc1$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($05cefe5a7272afc1$var$isMultiline);
}



var $Tvg0H = parcelRequire("Tvg0H");
var $9e83cb1a35bc050d$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $9e83cb1a35bc050d$var$defaultHeaders = {
    accept: "*/*",
    "content-type": "application/json"
};
var $9e83cb1a35bc050d$var$defaultOptions = {
    method: "POST"
};
var $9e83cb1a35bc050d$export$dd86f00dc866e75d = {
    http: $9e83cb1a35bc050d$var$defaultHttpOptions,
    headers: $9e83cb1a35bc050d$var$defaultHeaders,
    options: $9e83cb1a35bc050d$var$defaultOptions
};
var $9e83cb1a35bc050d$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = "ServerError";
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $9e83cb1a35bc050d$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = "ServerParseError";
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $9e83cb1a35bc050d$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty("data") && !result.hasOwnProperty("errors")) $9e83cb1a35bc050d$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $9e83cb1a35bc050d$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === "undefined") {
        var library = "unfetch";
        if (typeof window === "undefined") library = "node-fetch";
        throw new (0, $Tvg0H.InvariantError)(1);
    }
};
var $9e83cb1a35bc050d$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === "undefined") return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $9e83cb1a35bc050d$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $l5MLt.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $l5MLt.__assign)({}, options, config.options, {
            headers: (0, $l5MLt.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $l5MLt.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $05cefe5a7272afc1$exports.print)(query);
    return {
        options: options,
        body: body
    };
};
var $9e83cb1a35bc050d$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $Tvg0H.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $9e83cb1a35bc050d$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === "function") return fallbackURI(operation);
    else return fallbackURI || "/graphql";
};


var $27300495728577b8$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? "/graphql" : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, requestOptions = (0, $l5MLt.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries"
    ]);
    (0, $9e83cb1a35bc050d$export$8423f0cd3773115e)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $cHmNF.ApolloLink)(function(operation) {
        var chosenURI = (0, $9e83cb1a35bc050d$export$63ccc2571850f81a)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders["apollographql-client-name"] = name_1;
            if (version) clientAwarenessHeaders["apollographql-client-version"] = version;
        }
        var contextHeaders = (0, $l5MLt.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $9e83cb1a35bc050d$export$a00ebfd5f1eebfb1)(operation, (0, $9e83cb1a35bc050d$export$dd86f00dc866e75d), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $9e83cb1a35bc050d$export$f5853cd1fc39aea6)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "mutation";
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = "GET";
        if (options.method === "GET") {
            var _d = $27300495728577b8$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $cHmNF.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $9e83cb1a35bc050d$export$5f8e80ac52052e28)(body, "Payload");
        } catch (parseError) {
            return (0, $cHmNF.fromError)(parseError);
        }
        return new (0, $jTh3A.default)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $9e83cb1a35bc050d$export$d4051215bea0639f)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === "AbortError") return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $27300495728577b8$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ("query" in body) addQueryParam("query", body.query);
    if (body.operationName) addQueryParam("operationName", body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $9e83cb1a35bc050d$export$5f8e80ac52052e28)(body.variables, "Variables map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("variables", serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $9e83cb1a35bc050d$export$5f8e80ac52052e28)(body.extensions, "Extensions map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("extensions", serializedExtensions);
    }
    var fragment = "", preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf("#");
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf("?") === -1 ? "?" : "&";
    var newURI = preFragment + queryParamsPrefix + queryParams.join("&") + fragment;
    return {
        newURI: newURI
    };
}
var $27300495728577b8$export$f4bbf1aec241cc1 = function(_super) {
    (0, $l5MLt.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $27300495728577b8$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $cHmNF.ApolloLink));



var $l5MLt = parcelRequire("l5MLt");

var $cHmNF = parcelRequire("cHmNF");
var $jTh3A = parcelRequire("jTh3A");
function $4d0de6278ee54a35$export$2288787135a8f66e(errorHandler) {
    return new (0, $cHmNF.ApolloLink)(function(operation, forward) {
        return new (0, $jTh3A.default)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $4d0de6278ee54a35$export$d2c8415987899609 = function(_super) {
    (0, $l5MLt.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $4d0de6278ee54a35$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $cHmNF.ApolloLink));



var $gbiiY = parcelRequire("gbiiY");

var $Tvg0H = parcelRequire("Tvg0H");
var $3d4f2a5260e82ed0$var$PRESET_CONFIG_KEYS = [
    "request",
    "uri",
    "credentials",
    "headers",
    "fetch",
    "fetchOptions",
    "clientState",
    "onError",
    "cacheRedirects",
    "cache",
    "name",
    "version",
    "resolvers",
    "typeDefs",
    "fragmentMatcher"
];
var $3d4f2a5260e82ed0$var$DefaultClient = function(_super) {
    (0, $l5MLt.__extends)(DefaultClient, _super);
    function DefaultClient(config) {
        if (config === void 0) config = {};
        var _this = this;
        if (config) {
            var diff = Object.keys(config).filter(function(key) {
                return $3d4f2a5260e82ed0$var$PRESET_CONFIG_KEYS.indexOf(key) === -1;
            });
            diff.length;
        }
        var request = config.request, uri = config.uri, credentials = config.credentials, headers = config.headers, fetch = config.fetch, fetchOptions = config.fetchOptions, clientState = config.clientState, cacheRedirects = config.cacheRedirects, errorCallback = config.onError, name = config.name, version = config.version, resolvers = config.resolvers, typeDefs = config.typeDefs, fragmentMatcher = config.fragmentMatcher;
        var cache = config.cache;
        (0, $Tvg0H.invariant)(!cache || !cacheRedirects, 1);
        if (!cache) cache = cacheRedirects ? new (0, $cba9a046ce2ed465$export$467265324939f47f)({
            cacheRedirects: cacheRedirects
        }) : new (0, $cba9a046ce2ed465$export$467265324939f47f)();
        var errorLink = errorCallback ? (0, $4d0de6278ee54a35$export$2288787135a8f66e)(errorCallback) : (0, $4d0de6278ee54a35$export$2288787135a8f66e)(function(_a) {
            var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError;
            if (graphQLErrors) graphQLErrors.forEach(function(_a) {
                var message = _a.message, locations = _a.locations, path = _a.path;
                return true;
            });
            networkError;
        });
        var requestHandler = request ? new (0, $cHmNF.ApolloLink)(function(operation, forward) {
            return new (0, $jTh3A.default)(function(observer) {
                var handle;
                Promise.resolve(operation).then(function(oper) {
                    return request(oper);
                }).then(function() {
                    handle = forward(operation).subscribe({
                        next: observer.next.bind(observer),
                        error: observer.error.bind(observer),
                        complete: observer.complete.bind(observer)
                    });
                }).catch(observer.error.bind(observer));
                return function() {
                    if (handle) handle.unsubscribe();
                };
            });
        }) : false;
        var httpLink = new (0, $27300495728577b8$export$f4bbf1aec241cc1)({
            uri: uri || "/graphql",
            fetch: fetch,
            fetchOptions: fetchOptions || {},
            credentials: credentials || "same-origin",
            headers: headers || {}
        });
        var link = (0, $cHmNF.ApolloLink).from([
            errorLink,
            requestHandler,
            httpLink
        ].filter(function(x) {
            return !!x;
        }));
        var activeResolvers = resolvers;
        var activeTypeDefs = typeDefs;
        var activeFragmentMatcher = fragmentMatcher;
        if (clientState) {
            if (clientState.defaults) cache.writeData({
                data: clientState.defaults
            });
            activeResolvers = clientState.resolvers;
            activeTypeDefs = clientState.typeDefs;
            activeFragmentMatcher = clientState.fragmentMatcher;
        }
        _this = _super.call(this, {
            cache: cache,
            link: link,
            name: name,
            version: version,
            resolvers: activeResolvers,
            typeDefs: activeTypeDefs,
            fragmentMatcher: activeFragmentMatcher
        }) || this;
        return _this;
    }
    return DefaultClient;
}((0, $grvSO.default));
var $3d4f2a5260e82ed0$export$2e2bcd8739ae039 = $3d4f2a5260e82ed0$var$DefaultClient;
$parcel$exportWildcard($3d4f2a5260e82ed0$exports, $cHmNF);


var $grvSO = parcelRequire("grvSO");
var $cHmNF = parcelRequire("cHmNF");


var $dV1BF = parcelRequire("dV1BF");

var $agjvf = parcelRequire("agjvf");

var $huxZk = parcelRequire("huxZk");
parcelRequire("dGzLf");
var $64MZm = parcelRequire("64MZm");
parcelRequire("koRrl");
var $e2zNv = parcelRequire("e2zNv");
var $4L3N1 = parcelRequire("4L3N1");

var $jNWOd = parcelRequire("jNWOd");

var $kBIj3 = parcelRequire("kBIj3");
parcelRequire("6x4M3");
var $1WaGk = parcelRequire("1WaGk");
parcelRequire("3hzea");
var $d6ANX = parcelRequire("d6ANX");
var $1yXM1 = parcelRequire("1yXM1");

var $4mVfk = parcelRequire("4mVfk");

var $8DpVo = parcelRequire("8DpVo");

var $jtYt3 = parcelRequire("jtYt3");
var $91Q2o = parcelRequire("91Q2o");
var $4mVfk = parcelRequire("4mVfk");

var $8DpVo = parcelRequire("8DpVo");

var $lHRVb = parcelRequire("lHRVb");
var $b127238131c07692$var$TIME_IN_MS = 1000;
var $b127238131c07692$var$MAX_WAIT_TIME = 300 * $b127238131c07692$var$TIME_IN_MS;
var $b127238131c07692$var$INITIAL_WAIT_TIME = 2 * $b127238131c07692$var$TIME_IN_MS;
var $b127238131c07692$export$cc1c284801c32a43 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee() {
        var waitTime, totalElapsedTime, _args = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    waitTime = _args.length > 0 && _args[0] !== undefined ? _args[0] : $b127238131c07692$var$INITIAL_WAIT_TIME;
                    totalElapsedTime = _args.length > 1 && _args[1] !== undefined ? _args[1] : 0;
                    return _context.abrupt("return", $b127238131c07692$var$pollForFeatureFlag("platform.moonjelly.browser-storage-controls", waitTime, totalElapsedTime));
                case 3:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function pollForBrowserControlsFlag() {
        return _ref.apply(this, arguments);
    };
}();
var $b127238131c07692$var$pollForFeatureFlag = function pollForFeatureFlag(featureFlag) {
    var waitTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $b127238131c07692$var$INITIAL_WAIT_TIME;
    var totalElapsedTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    /*
     We don't know exactly if/when the FF will be enabled, so we want to exponentially poll from 2s to a max of ~5min
     If it never comes back as 'true' then we assume that:
       a) it's correctly set to false and thus we don't override the document.cookie behavior
       b) the FF client failed to load in time, don't override the behavior by making false assumptions
   */ var shouldCancelPolling = totalElapsedTime > $b127238131c07692$var$MAX_WAIT_TIME;
    if (shouldCancelPolling) return Promise.resolve(false);
    // eslint-disable-next-line @atlaskit/platform/static-feature-flags
    if (!(0, $lHRVb.fg)(featureFlag)) {
        var newWaitTime = waitTime * 2;
        // Use the max if new wait time exceeds it
        var cappedWaitTime = Math.min(newWaitTime, $b127238131c07692$var$MAX_WAIT_TIME);
        return new Promise(function(resolve) {
            setTimeout(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee2() {
                var updatedElapsedTime, newFlagState;
                return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee2$(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            updatedElapsedTime = totalElapsedTime + cappedWaitTime;
                            _context2.next = 3;
                            return $b127238131c07692$export$cc1c284801c32a43(cappedWaitTime, updatedElapsedTime);
                        case 3:
                            newFlagState = _context2.sent;
                            resolve(newFlagState);
                        case 5:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee2);
            })), cappedWaitTime);
        });
    }
    return Promise.resolve(true);
};



var $eHk0O = parcelRequire("eHk0O");

var $JZBNd = parcelRequire("JZBNd");

var $lHRVb = parcelRequire("lHRVb");

var $jtYt3 = parcelRequire("jtYt3");

var $JZBNd = parcelRequire("JZBNd");

var $kFnE9 = parcelRequire("kFnE9");

var $4mVfk = parcelRequire("4mVfk");

var $8DpVo = parcelRequire("8DpVo");

var $1Qo9y = parcelRequire("1Qo9y");

var $lHRVb = parcelRequire("lHRVb");

var $jtYt3 = parcelRequire("jtYt3");

var $g5A4y = parcelRequire("g5A4y");

var $JZBNd = parcelRequire("JZBNd");

var $eT61T = parcelRequire("eT61T");

var $g5F2H = parcelRequire("g5F2H");
var $496c873e417be6e6$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    return Status;
}({});


function $8dcd76c5285105ae$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8dcd76c5285105ae$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8dcd76c5285105ae$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8dcd76c5285105ae$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8dcd76c5285105ae$var$findStartsWithPatternMatch = function findStartsWithPatternMatch(cookieName, _ref) {
    var startsWith = _ref.startsWith;
    // Setup initial pattern step and position
    var currentStep = startsWith;
    var position = 0;
    // Iterate through cookie name symbol by symbol
    while(position < cookieName.length){
        // The value of cookie character at the position
        var currentStepValue = currentStep[cookieName[position]];
        // If there is no match for cookie symbol in cache, this means there is no
        // pattern match for the cookie name
        if (currentStepValue === undefined) return null;
        // If current step value is a number, this means we reached the end of the pattern
        // and should return category number
        if (typeof currentStepValue === "number") return currentStepValue;
        // Continue to going through pattern
        currentStep = currentStepValue;
        position++;
    }
    // No pattern match - all patterns longer or shorter than cookie name
    return null;
};
var $8dcd76c5285105ae$var$getPreferenceCategory = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee(cookieName) {
        var storageControlsData;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return (0, $g5A4y.loadStorageControlsData)();
                case 2:
                    storageControlsData = _context.sent;
                    if (storageControlsData) {
                        _context.next = 7;
                        break;
                    }
                    return _context.abrupt("return", null);
                case 7:
                    return _context.abrupt("return", $8dcd76c5285105ae$export$b48b796182639b54(cookieName, storageControlsData));
                case 8:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function getPreferenceCategory(_x) {
        return _ref2.apply(this, arguments);
    };
}();
var $8dcd76c5285105ae$export$b48b796182639b54 = function getPreferenceCategoryFromPassedCache(cookieName, storageControlsData) {
    var _numToCategoryMap;
    var cookieCategoryNumber = null;
    var keys = storageControlsData.keys, categories = storageControlsData.categories, patterns = storageControlsData.patterns;
    // Find direct match in keys
    if (cookieName in Object(keys)) cookieCategoryNumber = keys[cookieName];
    else // Find pattern match or null
    cookieCategoryNumber = $8dcd76c5285105ae$var$findStartsWithPatternMatch(cookieName, patterns);
    var numToCategoryMap = (_numToCategoryMap = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_numToCategoryMap, categories.STRICTLY_NECESSARY, (0, $eT61T.PreferenceCategory).StrictlyNecessary), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_numToCategoryMap, categories.FUNCTIONAL, (0, $eT61T.PreferenceCategory).Functional), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_numToCategoryMap, categories.ANALYTICS, (0, $eT61T.PreferenceCategory).Analytics), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_numToCategoryMap, categories.MARKETING, (0, $eT61T.PreferenceCategory).Marketing), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_numToCategoryMap, categories.UNKNOWN, (0, $eT61T.PreferenceCategory).Unknown), _numToCategoryMap);
    return cookieCategoryNumber !== null ? numToCategoryMap[cookieCategoryNumber] : null;
};
var $8dcd76c5285105ae$export$92f79a86880ed80 = /*#__PURE__*/ function() {
    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee2(_ref3) {
        var cookieKey, _ref3$allowedCallback, allowedCallback, _ref3$blockedCallback, blockedCallback, shouldSetCookie, cookieCategory, preferences, hasPreferencesForCategory;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    cookieKey = _ref3.cookieKey, _ref3$allowedCallback = _ref3.allowedCallback, allowedCallback = _ref3$allowedCallback === void 0 ? function() {} : _ref3$allowedCallback, _ref3$blockedCallback = _ref3.blockedCallback, blockedCallback = _ref3$blockedCallback === void 0 ? function() {} : _ref3$blockedCallback;
                    _context2.next = 3;
                    return $8dcd76c5285105ae$var$getPreferenceCategory(cookieKey);
                case 3:
                    cookieCategory = _context2.sent;
                    if (!(cookieCategory === (0, $eT61T.PreferenceCategory).StrictlyNecessary)) {
                        _context2.next = 8;
                        break;
                    }
                    shouldSetCookie = true;
                    _context2.next = 14;
                    break;
                case 8:
                    _context2.next = 10;
                    return (0, $g5F2H.getPreferences)();
                case 10:
                    preferences = _context2.sent;
                    hasPreferencesForCategory = false;
                    if (!!preferences) {
                        if (!!cookieCategory) hasPreferencesForCategory = preferences[cookieCategory];
                    }
                    shouldSetCookie = hasPreferencesForCategory;
                case 14:
                    if (shouldSetCookie) allowedCallback === null || allowedCallback === void 0 || allowedCallback();
                    else blockedCallback === null || blockedCallback === void 0 || blockedCallback({
                        cookieHasCategory: cookieCategory != null
                    });
                    return _context2.abrupt("return", shouldSetCookie);
                case 16:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function canSetCookie(_x2) {
        return _ref4.apply(this, arguments);
    };
}();
var $8dcd76c5285105ae$export$110700823644f4a6 = /*#__PURE__*/ function() {
    var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee3(key, value, attributes) {
        var _eventAttributes, shouldSetCookie, eventAttributes;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    if ((0, $lHRVb.fg)("platform.moonjelly.browser-storage-controls")) {
                        _context3.next = 11;
                        break;
                    }
                    _eventAttributes = {
                        wasRejected: false,
                        cookieKey: key
                    };
                    _context3.prev = 2;
                    (0, (/*@__PURE__*/$parcel$interopDefault($1Qo9y))).set(key, value, attributes);
                    return _context3.abrupt("return", (0, $496c873e417be6e6$export$96e9906d6d93a972).SUCCESS);
                case 7:
                    _context3.prev = 7;
                    _context3.t0 = _context3["catch"](2);
                    (0, $JZBNd.Logger).errorWithOperationalEvent({
                        action: "usedSetCookieError",
                        attributes: _eventAttributes,
                        message: "Failed to use set cookie. ".concat(_context3.t0.message || "")
                    });
                    return _context3.abrupt("return", (0, $496c873e417be6e6$export$96e9906d6d93a972).FAILED);
                case 11:
                    _context3.next = 13;
                    return $8dcd76c5285105ae$export$92f79a86880ed80({
                        cookieKey: key
                    });
                case 13:
                    shouldSetCookie = _context3.sent;
                    eventAttributes = {
                        wasRejected: !shouldSetCookie,
                        cookieKey: key
                    };
                    _context3.prev = 15;
                    (0, $jtYt3.sendPackageOperationalEvent)({
                        action: "usedSetCookie",
                        attributes: eventAttributes
                    });
                    if (!shouldSetCookie) {
                        _context3.next = 22;
                        break;
                    }
                    (0, (/*@__PURE__*/$parcel$interopDefault($1Qo9y))).set(key, value, $8dcd76c5285105ae$var$_objectSpread($8dcd76c5285105ae$var$_objectSpread({}, attributes), {}, {
                        "atl-set-cookie": true
                    }));
                    return _context3.abrupt("return", (0, $496c873e417be6e6$export$96e9906d6d93a972).SUCCESS);
                case 22:
                    return _context3.abrupt("return", (0, $496c873e417be6e6$export$96e9906d6d93a972).BLOCKED);
                case 23:
                    _context3.next = 29;
                    break;
                case 25:
                    _context3.prev = 25;
                    _context3.t1 = _context3["catch"](15);
                    (0, $JZBNd.Logger).errorWithOperationalEvent({
                        action: "usedSetCookieError",
                        attributes: eventAttributes,
                        message: "Failed to use set cookie. ".concat(_context3.t1.message || "")
                    });
                    return _context3.abrupt("return", (0, $496c873e417be6e6$export$96e9906d6d93a972).BLOCKED);
                case 29:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                2,
                7
            ],
            [
                15,
                25
            ]
        ]);
    }));
    return function setCookie(_x3, _x4, _x5) {
        return _ref5.apply(this, arguments);
    };
}();


var $99914ee87c9ddffc$export$b7364c41ddbfdb0a = function getSetCookieOverride(originalSetter) {
    return function(originalCookieValue) {
        var cookieSetByPackage = originalCookieValue.includes("atl-set-cookie");
        if (cookieSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetter.apply(document, [
                originalCookieValue
            ]);
        } catch (e) {
            (0, $JZBNd.Logger).errorWithOperationalEvent({
                action: "usedDocumentCookieError",
                message: "document.cookie setter failed to set cookie set by package. ".concat(e.message || ""),
                attributes: {
                    outsidePackage: false
                }
            });
        }
        try {
            // Raw cookies and query params can contain sensitive PII/UGC we can't store, so we want to
            // strip that out before we log it out to our analytics client.
            var sanitizedCookieKey = originalCookieValue.slice(0, originalCookieValue.indexOf("=")) || "";
            (0, $jtYt3.sendPackageOperationalEvent)({
                action: "usedDocumentCookie",
                attributes: {
                    cookieKey: sanitizedCookieKey,
                    outsidePackage: !cookieSetByPackage
                }
            });
            try {
                // Attempt to set a known cookie that was set from outside the package
                (0, $8dcd76c5285105ae$export$92f79a86880ed80)({
                    cookieKey: sanitizedCookieKey,
                    allowedCallback: function allowedCallback() {
                        return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                    },
                    blockedCallback: function blockedCallback(_ref) {
                        var cookieHasCategory = _ref.cookieHasCategory;
                        if ((0, $lHRVb.fg)("platform.moonjelly.block-unknown-cookies")) return;
                        else {
                            if (!cookieHasCategory) return originalSetter.apply(document, [
                                originalCookieValue
                            ]);
                            else return;
                        }
                    }
                });
            } catch (e) {
                (0, $JZBNd.Logger).errorWithOperationalEvent({
                    action: "usedDocumentCookieError",
                    message: "Failed to set cookie. ".concat(e.message || ""),
                    attributes: {
                        cookieKey: sanitizedCookieKey
                    }
                });
            }
        } catch (e) {
            (0, $JZBNd.Logger).errorWithOperationalEvent({
                action: "usedDocumentCookieError",
                message: "Failed to send document.cookie setter event. ".concat(e.message || "")
            });
        }
    };
};


var $171cc51a435734dd$export$45a5573b04db016c = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee() {
        var args, isFlagEnabled, documentCookieProperty, originalSetter, originalGetter, analyticsWebClientInstance, isAnalyticsInitialized, _args = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    args = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                    if (!(0, $91Q2o.isSSR)()) {
                        _context.next = 3;
                        break;
                    }
                    return _context.abrupt("return");
                case 3:
                    _context.t0 = args.flagEnabled;
                    if (_context.t0) {
                        _context.next = 8;
                        break;
                    }
                    _context.next = 7;
                    return (0, $b127238131c07692$export$cc1c284801c32a43)();
                case 7:
                    _context.t0 = _context.sent;
                case 8:
                    isFlagEnabled = _context.t0;
                    if (isFlagEnabled) {
                        _context.next = 11;
                        break;
                    }
                    return _context.abrupt("return");
                case 11:
                    (0, $eHk0O.initializeGlobalState)(args);
                    documentCookieProperty = Object.getOwnPropertyDescriptor(Document.prototype, "cookie");
                    originalSetter = documentCookieProperty === null || documentCookieProperty === void 0 ? void 0 : documentCookieProperty.set;
                    originalGetter = documentCookieProperty === null || documentCookieProperty === void 0 ? void 0 : documentCookieProperty.get;
                    if (!(!originalSetter || !originalGetter)) {
                        _context.next = 18;
                        break;
                    }
                    (0, $JZBNd.Logger).warn("No document.cookie capabilities found");
                    return _context.abrupt("return");
                case 18:
                    // Ensures that the AWC is constructed before overwriting document.cookie. Not
                    // doing so was allowing for cases of infinite recursion.
                    analyticsWebClientInstance = (0, $jtYt3.getAnalyticsClient)(); // If AWC is not initialized, it will be undefined
                    isAnalyticsInitialized = !!analyticsWebClientInstance;
                    if (isAnalyticsInitialized) {
                        _context.next = 22;
                        break;
                    }
                    throw new Error("Failed to initialize AnalyticsWebClient. Analytics logging will not be set for document.cookie.");
                case 22:
                    // Override document.cookie setter
                    Object.defineProperty(document, "cookie", {
                        get: originalGetter,
                        set: (0, $99914ee87c9ddffc$export$b7364c41ddbfdb0a)(originalSetter),
                        configurable: true
                    });
                case 23:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function createDocumentCookiePassthrough() {
        return _ref.apply(this, arguments);
    };
}();
var $171cc51a435734dd$export$919040c32a62c7db = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee2() {
        var args, _args2 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    args = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
                    _context2.prev = 1;
                    _context2.next = 4;
                    return $171cc51a435734dd$export$45a5573b04db016c(args);
                case 4:
                    _context2.next = 9;
                    break;
                case 6:
                    _context2.prev = 6;
                    _context2.t0 = _context2["catch"](1);
                    (0, $JZBNd.Logger).errorWithOperationalEvent({
                        action: "initializeControlsError",
                        message: "Failed to initialize browser storage controls. ".concat(_context2.t0.message || "")
                    });
                case 9:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                1,
                6
            ]
        ]);
    }));
    return function initializeControls() {
        return _ref2.apply(this, arguments);
    };
}();



var $6gjHX = parcelRequire("6gjHX");

var $cHmNF = parcelRequire("cHmNF");

var $9FrJk = parcelRequire("9FrJk");
var $1d7d2cb53f75cedb$export$fb326ed954631f3f = new (0, $cHmNF.ApolloLink)(function(operation, forward) {
    var networkStart = performance.now();
    return forward(operation).map(function(response) {
        var _operation$operationN;
        var networkComplete = performance.now();
        var operationName = (_operation$operationN = operation.operationName) !== null && _operation$operationN !== void 0 ? _operation$operationN : "unnamed";
        (0, $9FrJk.addSpanToAll)("graphql", operationName, [
            {
                name: "network"
            }
        ], networkStart, networkComplete);
        return response;
    });
});



var $kI8WJ = parcelRequire("kI8WJ");

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $9q1kH = parcelRequire("9q1kH");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("fTXuo");
var $2ABou = parcelRequire("2ABou");
var $h898w = parcelRequire("h898w");

var $fMSHR = parcelRequire("fMSHR");

var $8HwYi = parcelRequire("8HwYi");

var $7Qr4H = parcelRequire("7Qr4H");
var $f972c9e039093a36$export$91b4dd3bfc301325 = function analyticsWrapper(analyticsClient) {
    return function(event) {
        return Promise.resolve(analyticsClient).then(function(client) {
            switch(event.eventType){
                case 0, $7Qr4H.UI_EVENT_TYPE:
                    client.sendUIEvent(event);
                    break;
                case 0, $7Qr4H.TRACK_EVENT_TYPE:
                    client.sendTrackEvent(event);
                    break;
                case 0, $7Qr4H.OPERATIONAL_EVENT_TYPE:
                    client.sendOperationalEvent(event);
                    break;
                case 0, $7Qr4H.SCREEN_EVENT_TYPE:
                    client.sendScreenEvent(event);
                    break;
            }
        });
    };
};



var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $7Qr4H = parcelRequire("7Qr4H");
var $97b625fcf2d310b8$var$_excluded = [
    "attributes"
];
function $97b625fcf2d310b8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $97b625fcf2d310b8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $97b625fcf2d310b8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $97b625fcf2d310b8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $97b625fcf2d310b8$var$GROWTH_TAG = "growth";
var $97b625fcf2d310b8$var$extractFromEventContext = function extractFromEventContext(propertyNames, context) {
    return context.reduce(function(acc, contextItem) {
        propertyNames.forEach(function(propertyName) {
            var navContextProp = contextItem ? contextItem[propertyName] : null;
            acc.push(navContextProp || contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
};
var $97b625fcf2d310b8$var$getSources = function getSources(context) {
    return $97b625fcf2d310b8$var$extractFromEventContext([
        "source"
    ], context);
};
var $97b625fcf2d310b8$var$getExtraAttributes = function getExtraAttributes(context) {
    return context.reduce(function(ans, _ref) {
        var attributes = _ref.attributes, contextProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $97b625fcf2d310b8$var$_excluded);
        var newAttributes = $97b625fcf2d310b8$var$_objectSpread($97b625fcf2d310b8$var$_objectSpread({}, ans), contextProps);
        return attributes ? $97b625fcf2d310b8$var$_objectSpread($97b625fcf2d310b8$var$_objectSpread({}, newAttributes), attributes) : newAttributes;
    }, {});
};
var $97b625fcf2d310b8$var$getPackageInfo = function getPackageInfo(context) {
    return context.map(function(contextItem) {
        return {
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        };
    }).filter(function(p) {
        return p.packageName;
    });
};
var $97b625fcf2d310b8$var$last = function last(values) {
    return values[values.length - 1];
};
var $97b625fcf2d310b8$export$3f40e8c44448be30 = function transformEvent(event) {
    var context = event.context, payload = event.payload;
    if (!payload) return null;
    var sources = $97b625fcf2d310b8$var$getSources(context);
    var source = $97b625fcf2d310b8$var$last(sources) || (0, $7Qr4H.DEFAULT_SOURCE);
    var extraAttributes = $97b625fcf2d310b8$var$getExtraAttributes(context);
    var _ref2 = $97b625fcf2d310b8$var$last($97b625fcf2d310b8$var$getPackageInfo(context)) || {}, _ref2$packageName = _ref2.packageName, packageName = _ref2$packageName === void 0 ? undefined : _ref2$packageName, _ref2$packageVersion = _ref2.packageVersion, packageVersion = _ref2$packageVersion === void 0 ? undefined : _ref2$packageVersion;
    var _payload$eventType = payload.eventType, eventType = _payload$eventType === void 0 ? (0, $7Qr4H.UI_EVENT_TYPE) : _payload$eventType, action = payload.action, actionSubject = payload.actionSubject, actionSubjectId = payload.actionSubjectId, payloadAttributes = payload.attributes, name = payload.name;
    var attributes = $97b625fcf2d310b8$var$_objectSpread($97b625fcf2d310b8$var$_objectSpread({
        packageName: packageName,
        packageVersion: packageVersion
    }, extraAttributes), payloadAttributes);
    var tags = payload.tags || [];
    tags.push($97b625fcf2d310b8$var$GROWTH_TAG);
    switch(eventType){
        case 0, $7Qr4H.UI_EVENT_TYPE:
        case 0, $7Qr4H.OPERATIONAL_EVENT_TYPE:
        case 0, $7Qr4H.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: tags.slice(0)
            };
        case 0, $7Qr4H.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                source: source,
                tags: tags.slice(0)
            };
        default:
            break;
    }
    return null;
};



var $kFnE9 = parcelRequire("kFnE9");
parcelRequire("dRHNf");
var $17HSd = parcelRequire("17HSd");
var $b01bd27bbcba4136$export$c37558e5c67d2b01 = "https://qa-wac.internal.atlassian.com";
var $b01bd27bbcba4136$export$f199baf8dfc7621e = "https://www.atlassian.com";
var $b01bd27bbcba4136$export$fb1e43fdafe12e9b = "/software/opsgenie/try";
var $b01bd27bbcba4136$export$e6c04a1dd86d1c14 = "/try/cloud/signup";
var $b01bd27bbcba4136$export$2a45a00073911255 = "/software";


var $4f7502c9d6647fd4$export$fc604aa353a97e10 = /*#__PURE__*/ function(UtmCampaign) {
    UtmCampaign["atlassian-switcher"] = "atlassian_switcher";
    return UtmCampaign;
}({});


var $9e49290f6c5bf9f8$var$utmCampaignMap = {
    "atlassian-switcher": (0, $4f7502c9d6647fd4$export$fc604aa353a97e10)["atlassian-switcher"]
};
var $9e49290f6c5bf9f8$var$isBundledProduct = function isBundledProduct(productKey) {
    return [
        (0, $17HSd.Targets).JIRA_SOFTWARE,
        (0, $17HSd.Targets).JIRA_SERVICE_DESK,
        (0, $17HSd.Targets).JIRA_CORE,
        (0, $17HSd.Targets).CONFLUENCE
    ].includes(productKey);
};
var $9e49290f6c5bf9f8$var$getBundleSignUpParams = function getBundleSignUpParams(productKey) {
    var _bundles;
    var bundles = (_bundles = {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_bundles, (0, $17HSd.Targets).JIRA_SOFTWARE, "jira-software"), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_bundles, (0, $17HSd.Targets).JIRA_SERVICE_DESK, "jira-service-desk"), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_bundles, (0, $17HSd.Targets).JIRA_CORE, "jira-core"), (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(_bundles, (0, $17HSd.Targets).CONFLUENCE, "confluence"), _bundles);
    // Bundles default to free
    return "bundle=".concat(bundles[productKey], "&edition=free");
};
var $9e49290f6c5bf9f8$var$isProductWithCustomSignUpPath = function isProductWithCustomSignUpPath(productKey) {
    return [
        (0, $17HSd.Targets).OPSGENIE
    ].includes(productKey);
};
var $9e49290f6c5bf9f8$var$getProductCustomSignUpPath = function getProductCustomSignUpPath(productKey) {
    // Only Opsgenie. Trello, Bitbucket and Statuspage are handled by Product Store directly.
    var links = (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, (0, $17HSd.Targets).OPSGENIE, (0, $b01bd27bbcba4136$export$fb1e43fdafe12e9b));
    return links[productKey];
};
var $9e49290f6c5bf9f8$var$isSourceComponentWithUtmParams = function isSourceComponentWithUtmParams(sourceComponent) {
    return Boolean($9e49290f6c5bf9f8$var$utmCampaignMap[sourceComponent]);
};
var $9e49290f6c5bf9f8$var$getUtmParams = function getUtmParams(sourceComponent, sourceContext) {
    var utmParams = "";
    if (sourceComponent && $9e49290f6c5bf9f8$var$isSourceComponentWithUtmParams(sourceComponent)) {
        utmParams = utmParams + "utm_campaign=".concat($9e49290f6c5bf9f8$var$utmCampaignMap[sourceComponent], "&utm_medium=in_product_ad");
        if (sourceContext) utmParams = utmParams + "&utm_source=".concat(sourceContext);
    }
    return utmParams;
};
var $9e49290f6c5bf9f8$export$39eab502fc96327d = function getProductSignUpLink(productKey, env, sourceComponent, sourceContext) {
    var wacUrl = env === "staging" ? (0, $b01bd27bbcba4136$export$c37558e5c67d2b01) : (0, $b01bd27bbcba4136$export$f199baf8dfc7621e);
    var utmParams = $9e49290f6c5bf9f8$var$getUtmParams(sourceComponent, sourceContext);
    var queryParams = "";
    var bundleParams = "";
    var path = (0, $b01bd27bbcba4136$export$2a45a00073911255);
    if ($9e49290f6c5bf9f8$var$isBundledProduct(productKey)) {
        path = (0, $b01bd27bbcba4136$export$e6c04a1dd86d1c14);
        bundleParams = $9e49290f6c5bf9f8$var$getBundleSignUpParams(productKey);
    } else if ($9e49290f6c5bf9f8$var$isProductWithCustomSignUpPath(productKey)) path = $9e49290f6c5bf9f8$var$getProductCustomSignUpPath(productKey);
    if (!!bundleParams) queryParams = queryParams + "?".concat(bundleParams);
    if (!!utmParams) queryParams = queryParams + (!!queryParams ? "&" : "?") + utmParams;
    return wacUrl + path + queryParams;
};
var $9e49290f6c5bf9f8$export$2827e2473cb9a346 = function setProductSignUpLocation(productKey) {
    var env = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "production";
    var sourceComponent = arguments.length > 2 ? arguments[2] : undefined;
    var sourceContext = arguments.length > 3 ? arguments[3] : undefined;
    var url = $9e49290f6c5bf9f8$export$39eab502fc96327d(productKey, env, sourceComponent, sourceContext);
    window.open(url, "_blank");
};



var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $bA7Lf = parcelRequire("bA7Lf");
var $7Qr4H = parcelRequire("7Qr4H");
function $7cf5eef3e8ea21aa$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7cf5eef3e8ea21aa$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $7cf5eef3e8ea21aa$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7cf5eef3e8ea21aa$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $7cf5eef3e8ea21aa$var$name = "@atlassiansox/cross-flow-support";
var $7cf5eef3e8ea21aa$var$version = "3.12.1";
var $7cf5eef3e8ea21aa$var$payload = {
    eventType: (0, $7Qr4H.OPERATIONAL_EVENT_TYPE),
    action: (0, $bA7Lf.errorBoundaryAction),
    actionSubject: (0, $bA7Lf.errorBoundaryActionSubject)
};
var $7cf5eef3e8ea21aa$var$context = [
    {
        source: (0, $bA7Lf.source)
    },
    {
        packageName: $7cf5eef3e8ea21aa$var$name,
        packageVersion: $7cf5eef3e8ea21aa$var$version
    }
];
var $7cf5eef3e8ea21aa$export$e926676385687eaf = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(ErrorBoundary, _Component);
    var _super = $7cf5eef3e8ea21aa$var$_createSuper(ErrorBoundary);
    function ErrorBoundary() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ErrorBoundary);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "state", {
            hasError: false
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error) {
                this.props.onAnalyticsEvent({
                    payload: $7cf5eef3e8ea21aa$var$payload,
                    context: $7cf5eef3e8ea21aa$var$context
                });
                if (this.props.onError) this.props.onError(error);
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.hasError) return null;
                return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError() {
                return {
                    hasError: true
                };
            }
        }
    ]);
    return ErrorBoundary;
}((0, $9nHZC.Component));



var $kFnE9 = parcelRequire("kFnE9");
function $2d09dfdc3e681755$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2d09dfdc3e681755$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2d09dfdc3e681755$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2d09dfdc3e681755$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2d09dfdc3e681755$var$version = "3.12.1";
var $2d09dfdc3e681755$export$84f9cf7ef89d4c26 = {
    version: $2d09dfdc3e681755$var$version
};
var $2d09dfdc3e681755$export$59518efab336a8b5 = function enrichWithPackageDetails(event) {
    var attributes = $2d09dfdc3e681755$var$_objectSpread($2d09dfdc3e681755$var$_objectSpread({}, event.attributes || {}), {}, {
        crossFlowSupport: $2d09dfdc3e681755$export$84f9cf7ef89d4c26
    });
    return $2d09dfdc3e681755$var$_objectSpread($2d09dfdc3e681755$var$_objectSpread({}, event), {}, {
        attributes: attributes
    });
};



var $kFnE9 = parcelRequire("kFnE9");
function $b79043f9ce5189a9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b79043f9ce5189a9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b79043f9ce5189a9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b79043f9ce5189a9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b79043f9ce5189a9$export$a5a156dc5df42f0 = function enrichWithRequestOptions(event, requestOptions) {
    if (!requestOptions) return event;
    var attributes = $b79043f9ce5189a9$var$_objectSpread($b79043f9ce5189a9$var$_objectSpread($b79043f9ce5189a9$var$_objectSpread({}, requestOptions.extraAnalyticsAttributes || {}), event.attributes || {}), {}, {
        sourceComponent: requestOptions.sourceComponent,
        sourceContext: requestOptions.sourceContext
    });
    return $b79043f9ce5189a9$var$_objectSpread($b79043f9ce5189a9$var$_objectSpread({}, event), {}, {
        attributes: attributes
    });
};



var $bA7Lf = parcelRequire("bA7Lf");
var $7Qr4H = parcelRequire("7Qr4H");
var $981f27e03954c52a$var$_excluded = [
    "children",
    "analyticsClient",
    "originProduct",
    "redirectToWac",
    "env",
    "plugins",
    "globalExperimentalOptions",
    "onError"
];
function $981f27e03954c52a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $981f27e03954c52a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $981f27e03954c52a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $981f27e03954c52a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

var $981f27e03954c52a$var$IntegrationView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).lazy(function() {
    return (parcelRequire("cvpxy"));
});
var $981f27e03954c52a$export$79d79d8dd8574306 = function createCrossFlowProvider(IntegrationView) {
    return function(props) {
        var _requestOptions$zInde;
        var children = props.children, analyticsClient = props.analyticsClient, originProduct = props.originProduct, redirectToWac = props.redirectToWac, env = props.env, _props$plugins = props.plugins, plugins = _props$plugins === void 0 ? [] : _props$plugins, globalExperimentalOptions = props.globalExperimentalOptions, onError = props.onError, baseProviderProps = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(props, $981f27e03954c52a$var$_excluded);
        // TBLZ-852: Product Store - Personal Use Case
        // go/trailblazerexperiments
        var tblz852ExperimentCohort = (0, $8HwYi.default).getExperimentValue("product_store_personal_use_case", "cohort", "not-enrolled", {
            fireExperimentExposure: false
        });
        var isInTblz852ExperimentCohort = tblz852ExperimentCohort === "variation";
        // TBLZ-852
        var onCloseResolver = (0, $9nHZC.useRef)();
        var _useState = (0, $9nHZC.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), firstHandshakeReceived = _useState2[0], setFirstHandshakeReceived = _useState2[1];
        var fireEvent = (0, $9nHZC.useMemo)(function() {
            return (0, $f972c9e039093a36$export$91b4dd3bfc301325)(analyticsClient);
        }, [
            analyticsClient
        ]);
        var _useState3 = (0, $9nHZC.useState)(), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState3, 2), requestOptions = _useState4[0], setRequestOptions = _useState4[1];
        var onAnalyticsEvent = (0, $9nHZC.useCallback)(function(payload) {
            var gasV3Event = (0, $97b625fcf2d310b8$export$3f40e8c44448be30)(payload);
            if (gasV3Event) {
                var enrichedEvent = (0, $b79043f9ce5189a9$export$a5a156dc5df42f0)((0, $2d09dfdc3e681755$export$59518efab336a8b5)(gasV3Event), requestOptions);
                fireEvent(enrichedEvent);
            }
        }, [
            fireEvent,
            requestOptions
        ]);
        var onHandShake = (0, $9nHZC.useCallback)(function(appName) {
            if (!firstHandshakeReceived) {
                onAnalyticsEvent({
                    payload: {
                        eventType: (0, $7Qr4H.OPERATIONAL_EVENT_TYPE),
                        action: (0, $bA7Lf.uiInitialized),
                        actionSubject: (0, $bA7Lf.crossFlowActionSubject),
                        attributes: {
                            appName: appName
                        }
                    },
                    context: [
                        {
                            source: (0, $bA7Lf.source)
                        }
                    ]
                });
                setFirstHandshakeReceived(true);
            }
        }, [
            firstHandshakeReceived,
            onAnalyticsEvent
        ]);
        var onOpen = (0, $9nHZC.useCallback)(function(options) {
            /**
       * Reset first handshake state to ensure 1:1 value of open invoked and handshake received
       * Caveat that if open api is invoked while cross flow support UI is already mounted there will be mismatch of openInvoked events to uiInitialized events
       */ setFirstHandshakeReceived(false);
            var analyticsEvent = {
                // setRequestOptions does not update the state right away (updates on the next render) so for the openInvoked event we need to manually append the sourceComponent and sourceContext
                payload: (0, $b79043f9ce5189a9$export$a5a156dc5df42f0)({
                    eventType: (0, $7Qr4H.OPERATIONAL_EVENT_TYPE),
                    action: (0, $bA7Lf.openInvoked),
                    actionSubject: (0, $bA7Lf.crossFlowActionSubject)
                }, options),
                context: [
                    {
                        source: (0, $bA7Lf.source)
                    }
                ]
            };
            onAnalyticsEvent(analyticsEvent);
            // Short circuit requestOptions for WAC expansions
            if (options.journey === (0, $h898w.Journeys).GET_STARTED && redirectToWac) {
                (0, $9e49290f6c5bf9f8$export$2827e2473cb9a346)(options.targetProduct, env, options.sourceComponent, options.sourceContext);
                var _completionStatus = {};
                return Promise.resolve(_completionStatus);
            }
            var updatedExperimentalOptions = $981f27e03954c52a$var$_objectSpread($981f27e03954c52a$var$_objectSpread({}, globalExperimentalOptions || {}), options.experimentalOptions || {});
            options.experimentalOptions = updatedExperimentalOptions;
            setRequestOptions(options);
            return new Promise(function(resolve) {
                onCloseResolver.current = resolve;
            });
        }, [
            onAnalyticsEvent,
            env,
            redirectToWac,
            globalExperimentalOptions
        ]);
        var onClose = (0, $9nHZC.useCallback)(function(completionStatus) {
            setFirstHandshakeReceived(false);
            setRequestOptions(undefined);
            onCloseResolver.current && onCloseResolver.current(completionStatus);
        }, []);
        var _getGlobalTheme = (0, $fMSHR.default)(), colorMode = _getGlobalTheme.colorMode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2ABou.BaseCrossFlowApiProvider), {
            onOpen: onOpen
        }, children, requestOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7cf5eef3e8ea21aa$export$e926676385687eaf), {
            onAnalyticsEvent: onAnalyticsEvent,
            onError: onError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(IntegrationView, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, baseProviderProps, requestOptions, {
            onAnalyticsEvent: onAnalyticsEvent,
            originProduct: originProduct,
            theme: colorMode,
            onClose: onClose,
            onHandShake: onHandShake,
            plugins: plugins,
            env: env,
            redirectToWac: redirectToWac,
            isInTblz852ExperimentCohort: isInTblz852ExperimentCohort,
            zIndex: (_requestOptions$zInde = requestOptions.zIndex) !== null && _requestOptions$zInde !== void 0 ? _requestOptions$zInde : 1000
        })))));
    };
};
var $981f27e03954c52a$export$d900e4062895cd7c = $981f27e03954c52a$export$79d79d8dd8574306($981f27e03954c52a$var$IntegrationView);


parcelRequire("hS1rT");
var $2ABou = parcelRequire("2ABou");
var $h898w = parcelRequire("h898w");
var $17HSd = parcelRequire("17HSd");
var $c64aecdef2700081$var$BitBucketProvider = function BitBucketProvider(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $981f27e03954c52a$export$d900e4062895cd7c), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        originProduct: "bitbucket"
    }));
};
var $c64aecdef2700081$export$2e2bcd8739ae039 = $c64aecdef2700081$var$BitBucketProvider;



var $9nHZC = parcelRequire("9nHZC");

var $8shKB = parcelRequire("8shKB");

var $1D3HA = parcelRequire("1D3HA");

var $3wXS7 = parcelRequire("3wXS7");

const $a29cb53c8d78462e$var$DevAssetLoader = (0, (/*@__PURE__*/$parcel$interopDefault($8shKB)))({
    loading: (0, $3wXS7.HiddenLoader),
    loader: ()=>(parcelRequire("eWrF8")),
    modules: [
        "./version-dialog"
    ],
    webpack: ()=>[
            undefined("./version-dialog")
        ]
});
var $a29cb53c8d78462e$export$2e2bcd8739ae039 = ()=>{
    const { user: user } = (0, $1D3HA.useAppData)();
    if (!user || !user.isAtlassian) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($a29cb53c8d78462e$var$DevAssetLoader, null);
};



var $9nHZC = parcelRequire("9nHZC");
var $a95b205c63fe13b2$exports = {};
"use strict";
var $a95b205c63fe13b2$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $a95b205c63fe13b2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a95b205c63fe13b2$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a95b205c63fe13b2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $9nHZC = parcelRequire("9nHZC");
var $a95b205c63fe13b2$var$linkEl;
function $a95b205c63fe13b2$var$drawIcon(src, num, cb) {
    var img = document.createElement("img");
    img.onload = function() {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var context = canvas.getContext("2d");
        context.clearRect(0, 0, img.width, img.height);
        context.drawImage(img, 0, 0);
        var top = img.height - 9, left = img.width - 7 - 1, bottom = 16, right = 16, radius = 2;
        context.fillStyle = "#F03D25";
        context.strokeStyle = "#F03D25";
        context.lineWidth = 1;
        context.beginPath();
        context.moveTo(left + radius, top);
        context.quadraticCurveTo(left, top, left, top + radius);
        context.lineTo(left, bottom - radius);
        context.quadraticCurveTo(left, bottom, left + radius, bottom);
        context.lineTo(right - radius, bottom);
        context.quadraticCurveTo(right, bottom, right, bottom - radius);
        context.lineTo(right, top + radius);
        context.quadraticCurveTo(right, top, right - radius, top);
        context.closePath();
        context.fill();
        context.font = "bold 10px arial";
        context.fillStyle = "#FFF";
        context.textAlign = "right";
        context.textBaseline = "top";
        context.fillText(num, 15, 6);
        cb(null, context.canvas.toDataURL());
    };
    img.src = src;
}
var $a95b205c63fe13b2$var$Favicon = function(_React$Component) {
    $a95b205c63fe13b2$var$_inherits(Favicon, _React$Component);
    function Favicon() {
        var _ref;
        var _temp, _this, _ret;
        $a95b205c63fe13b2$var$_classCallCheck(this, Favicon);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $a95b205c63fe13b2$var$_possibleConstructorReturn(this, (_ref = Favicon.__proto__ || Object.getPrototypeOf(Favicon)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            animationIndex: 0,
            animationLoop: null,
            animationRunning: false
        }, _temp), $a95b205c63fe13b2$var$_possibleConstructorReturn(_this, _ret);
    }
    $a95b205c63fe13b2$var$_createClass(Favicon, [
        {
            key: "componentWillMount",
            value: function componentWillMount() {
                Favicon.mountedInstances.push(this);
                Favicon.update();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var activeInstance = Favicon.getActiveInstance();
                clearInterval(activeInstance.state.animationLoop);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (prevProps.url === this.props.url && prevProps.animated === this.props.animated && prevProps.alertCount === this.props.alertCount && prevProps.keepIconLink === this.props.keepIconLink) return;
                Favicon.update();
            }
        },
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ], [
        {
            key: "getActiveInstance",
            value: function getActiveInstance() {
                return Favicon.mountedInstances[Favicon.mountedInstances.length - 1];
            }
        },
        {
            key: "draw",
            value: function draw() {
                if (typeof document === "undefined") return;
                var activeInstance = Favicon.getActiveInstance();
                if (typeof $a95b205c63fe13b2$var$linkEl === "undefined") {
                    var head = document.getElementsByTagName("head")[0];
                    $a95b205c63fe13b2$var$linkEl = document.createElement("link");
                    $a95b205c63fe13b2$var$linkEl.type = "image/x-icon";
                    $a95b205c63fe13b2$var$linkEl.rel = "icon";
                    // remove existing favicons
                    var links = head.getElementsByTagName("link");
                    for(var i = links.length; --i >= 0;)if (/\bicon\b/i.test(links[i].getAttribute("rel")) && !activeInstance.props.keepIconLink(links[i])) head.removeChild(links[i]);
                    head.appendChild($a95b205c63fe13b2$var$linkEl);
                }
                var currentUrl;
                if (activeInstance.props.url instanceof Array) currentUrl = activeInstance.props.url[activeInstance.state.animationIndex];
                else currentUrl = activeInstance.props.url;
                if (activeInstance.props.alertCount) $a95b205c63fe13b2$var$drawIcon(currentUrl, activeInstance.props.alertCount, function(err, url) {
                    $a95b205c63fe13b2$var$linkEl.href = url;
                });
                else $a95b205c63fe13b2$var$linkEl.href = currentUrl;
            }
        },
        {
            key: "update",
            value: function update() {
                if (typeof document === "undefined") return;
                var activeInstance = Favicon.getActiveInstance();
                var isAnimated = activeInstance.props.url instanceof Array && activeInstance.props.animated;
                // clear any running animations
                var intervalId = null;
                clearInterval(activeInstance.state.animationLoop);
                if (isAnimated) {
                    var animateFavicon = function animateFavicon() {
                        var nextAnimationIndex = (activeInstance.state.animationIndex + 1) % activeInstance.props.url.length;
                        Favicon.draw();
                        activeInstance.setState({
                            animationIndex: nextAnimationIndex
                        });
                    };
                    intervalId = setInterval(animateFavicon, activeInstance.props.animationDelay);
                    animateFavicon();
                } else Favicon.draw();
                activeInstance.setState({
                    animationLoop: intervalId
                });
            }
        }
    ]);
    return Favicon;
}($9nHZC.Component);
$a95b205c63fe13b2$var$Favicon.displayName = "Favicon";
$a95b205c63fe13b2$var$Favicon.defaultProps = {
    alertCount: null,
    animated: true,
    animationDelay: 500,
    keepIconLink: function keepIconLink() {
        return false;
    }
};
$a95b205c63fe13b2$var$Favicon.mountedInstances = [];
$a95b205c63fe13b2$exports = $a95b205c63fe13b2$var$Favicon;


parcelRequire("dGzLf");
var $5oGLl = parcelRequire("5oGLl");

var $jffME = parcelRequire("jffME");
const $32c976254f03ed59$var$mapStateToProps = (state)=>({
        url: (0, $jffME.getFaviconUrl)(state)
    });
var $32c976254f03ed59$export$2e2bcd8739ae039 = (0, $5oGLl.default)($32c976254f03ed59$var$mapStateToProps)(class extends (0, $9nHZC.PureComponent) {
    render() {
        const { url: url } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a95b205c63fe13b2$exports))), {
            url: url
        });
    }
});



var $9nHZC = parcelRequire("9nHZC");
parcelRequire("dGzLf");
var $aAre5 = parcelRequire("aAre5");
var $6da6434b58c8ef37$export$4496080a0271e85d = "/gateway/api/session/heartbeat";
var $6da6434b58c8ef37$export$af2ff676951003fe = 60000;
var $6da6434b58c8ef37$export$f2b2f5ef0b498d26 = 10000;



var $9nHZC = parcelRequire("9nHZC");

var $9nHZC = parcelRequire("9nHZC");
var $59738db6cc26cfca$var$useInterval = function useInterval(callback, delay) {
    var savedCallbackRef = (0, $9nHZC.useRef)();
    (0, $9nHZC.useEffect)(function() {
        savedCallbackRef.current = callback;
    }, [
        callback
    ]);
    (0, $9nHZC.useEffect)(function() {
        var handler = function handler() {
            return savedCallbackRef.current.apply(savedCallbackRef, arguments);
        };
        if (delay !== null) {
            var intervalId = setInterval(handler, delay);
            return function() {
                return clearInterval(intervalId);
            };
        }
    }, [
        delay
    ]);
};
var $59738db6cc26cfca$export$2e2bcd8739ae039 = $59738db6cc26cfca$var$useInterval;




var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ var $c0d7d50677d6925a$var$__assign = function() {
    $c0d7d50677d6925a$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c0d7d50677d6925a$var$__assign.apply(this, arguments);
};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $c0d7d50677d6925a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $c0d7d50677d6925a$var$isObject_1 = $c0d7d50677d6925a$var$isObject;
var $c0d7d50677d6925a$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
/** Detect free variable `global` from Node.js. */ var $c0d7d50677d6925a$var$freeGlobal = typeof $c0d7d50677d6925a$var$commonjsGlobal == "object" && $c0d7d50677d6925a$var$commonjsGlobal && $c0d7d50677d6925a$var$commonjsGlobal.Object === Object && $c0d7d50677d6925a$var$commonjsGlobal;
var $c0d7d50677d6925a$var$_freeGlobal = $c0d7d50677d6925a$var$freeGlobal;
/** Detect free variable `self`. */ var $c0d7d50677d6925a$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $c0d7d50677d6925a$var$root = $c0d7d50677d6925a$var$_freeGlobal || $c0d7d50677d6925a$var$freeSelf || Function("return this")();
var $c0d7d50677d6925a$var$_root = $c0d7d50677d6925a$var$root;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $c0d7d50677d6925a$var$now = function() {
    return $c0d7d50677d6925a$var$_root.Date.now();
};
var $c0d7d50677d6925a$var$now_1 = $c0d7d50677d6925a$var$now;
/** Built-in value references. */ var $c0d7d50677d6925a$var$Symbol = $c0d7d50677d6925a$var$_root.Symbol;
var $c0d7d50677d6925a$var$_Symbol = $c0d7d50677d6925a$var$Symbol;
/** Used for built-in method references. */ var $c0d7d50677d6925a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c0d7d50677d6925a$var$hasOwnProperty = $c0d7d50677d6925a$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $c0d7d50677d6925a$var$nativeObjectToString = $c0d7d50677d6925a$var$objectProto.toString;
/** Built-in value references. */ var $c0d7d50677d6925a$var$symToStringTag = $c0d7d50677d6925a$var$_Symbol ? $c0d7d50677d6925a$var$_Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $c0d7d50677d6925a$var$getRawTag(value) {
    var isOwn = $c0d7d50677d6925a$var$hasOwnProperty.call(value, $c0d7d50677d6925a$var$symToStringTag), tag = value[$c0d7d50677d6925a$var$symToStringTag];
    try {
        value[$c0d7d50677d6925a$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $c0d7d50677d6925a$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$c0d7d50677d6925a$var$symToStringTag] = tag;
        else delete value[$c0d7d50677d6925a$var$symToStringTag];
    }
    return result;
}
var $c0d7d50677d6925a$var$_getRawTag = $c0d7d50677d6925a$var$getRawTag;
/** Used for built-in method references. */ var $c0d7d50677d6925a$var$objectProto$1 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $c0d7d50677d6925a$var$nativeObjectToString$1 = $c0d7d50677d6925a$var$objectProto$1.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $c0d7d50677d6925a$var$objectToString(value) {
    return $c0d7d50677d6925a$var$nativeObjectToString$1.call(value);
}
var $c0d7d50677d6925a$var$_objectToString = $c0d7d50677d6925a$var$objectToString;
/** `Object#toString` result references. */ var $c0d7d50677d6925a$var$nullTag = "[object Null]", $c0d7d50677d6925a$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $c0d7d50677d6925a$var$symToStringTag$1 = $c0d7d50677d6925a$var$_Symbol ? $c0d7d50677d6925a$var$_Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $c0d7d50677d6925a$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $c0d7d50677d6925a$var$undefinedTag : $c0d7d50677d6925a$var$nullTag;
    return $c0d7d50677d6925a$var$symToStringTag$1 && $c0d7d50677d6925a$var$symToStringTag$1 in Object(value) ? $c0d7d50677d6925a$var$_getRawTag(value) : $c0d7d50677d6925a$var$_objectToString(value);
}
var $c0d7d50677d6925a$var$_baseGetTag = $c0d7d50677d6925a$var$baseGetTag;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $c0d7d50677d6925a$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $c0d7d50677d6925a$var$isObjectLike_1 = $c0d7d50677d6925a$var$isObjectLike;
/** `Object#toString` result references. */ var $c0d7d50677d6925a$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $c0d7d50677d6925a$var$isSymbol(value) {
    return typeof value == "symbol" || $c0d7d50677d6925a$var$isObjectLike_1(value) && $c0d7d50677d6925a$var$_baseGetTag(value) == $c0d7d50677d6925a$var$symbolTag;
}
var $c0d7d50677d6925a$var$isSymbol_1 = $c0d7d50677d6925a$var$isSymbol;
/** Used as references for various `Number` constants. */ var $c0d7d50677d6925a$var$NAN = 0 / 0;
/** Used to match leading and trailing whitespace. */ var $c0d7d50677d6925a$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $c0d7d50677d6925a$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $c0d7d50677d6925a$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $c0d7d50677d6925a$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $c0d7d50677d6925a$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $c0d7d50677d6925a$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($c0d7d50677d6925a$var$isSymbol_1(value)) return $c0d7d50677d6925a$var$NAN;
    if ($c0d7d50677d6925a$var$isObject_1(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $c0d7d50677d6925a$var$isObject_1(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($c0d7d50677d6925a$var$reTrim, "");
    var isBinary = $c0d7d50677d6925a$var$reIsBinary.test(value);
    return isBinary || $c0d7d50677d6925a$var$reIsOctal.test(value) ? $c0d7d50677d6925a$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $c0d7d50677d6925a$var$reIsBadHex.test(value) ? $c0d7d50677d6925a$var$NAN : +value;
}
var $c0d7d50677d6925a$var$toNumber_1 = $c0d7d50677d6925a$var$toNumber;
/** Error message constants. */ var $c0d7d50677d6925a$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c0d7d50677d6925a$var$nativeMax = Math.max, $c0d7d50677d6925a$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $c0d7d50677d6925a$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($c0d7d50677d6925a$var$FUNC_ERROR_TEXT);
    wait = $c0d7d50677d6925a$var$toNumber_1(wait) || 0;
    if ($c0d7d50677d6925a$var$isObject_1(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $c0d7d50677d6925a$var$nativeMax($c0d7d50677d6925a$var$toNumber_1(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $c0d7d50677d6925a$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $c0d7d50677d6925a$var$now_1();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($c0d7d50677d6925a$var$now_1());
    }
    function debounced() {
        var time = $c0d7d50677d6925a$var$now_1(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $c0d7d50677d6925a$var$debounce_1 = $c0d7d50677d6925a$var$debounce;
/** Error message constants. */ var $c0d7d50677d6925a$var$FUNC_ERROR_TEXT$1 = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $c0d7d50677d6925a$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($c0d7d50677d6925a$var$FUNC_ERROR_TEXT$1);
    if ($c0d7d50677d6925a$var$isObject_1(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $c0d7d50677d6925a$var$debounce_1(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
var $c0d7d50677d6925a$var$throttle_1 = $c0d7d50677d6925a$var$throttle;
var $c0d7d50677d6925a$var$windowIdleEvents = [
    "scroll",
    "resize"
];
var $c0d7d50677d6925a$var$documentIdleEvents = [
    "wheel",
    "keydown",
    "keyup",
    "mousedown",
    "mousemove",
    "touchstart",
    "touchmove",
    "click",
    "contextmenu"
];
var $c0d7d50677d6925a$var$BrowserInteractionTime = /** @class */ function() {
    function BrowserInteractionTime(_a) {
        var _b = _a.timeIntervalEllapsedCallbacks, timeIntervalEllapsedCallbacks = _b === void 0 ? [] : _b, _c = _a.absoluteTimeEllapsedCallbacks, absoluteTimeEllapsedCallbacks = _c === void 0 ? [] : _c, _d = _a.checkCallbacksIntervalMs, checkCallbacksIntervalMs = _d === void 0 ? 100 : _d, _e = _a.browserTabInactiveCallbacks, browserTabInactiveCallbacks = _e === void 0 ? [] : _e, _f = _a.idleCallbacks, idleCallbacks = _f === void 0 ? [] : _f, _g = _a.stopTimerOnTabchange, stopTimerOnTabchange = _g === void 0 ? true : _g, _h = _a.activeCallbacks, activeCallbacks = _h === void 0 ? [] : _h, _j = _a.browserTabActiveCallbacks, browserTabActiveCallbacks = _j === void 0 ? [] : _j, _k = _a.idleTimeoutMs, idleTimeoutMs = _k === void 0 ? 3000 : _k;
        var _this = this;
        this.onBrowserTabInactive = function() {
            // if running pause timer
            if (_this.isRunning() && _this.stopTimerOnTabchange) _this.stopTimer();
            _this.browserTabInactiveCallbacks.forEach(function(fn) {
                return fn(_this.getTimeInMilliseconds());
            });
        };
        this.onBrowserTabActive = function() {
            // if not running start timer
            if (!_this.isRunning()) _this.startTimer();
            _this.browserTabActiveCallbacks.forEach(function(fn) {
                return fn(_this.getTimeInMilliseconds());
            });
        };
        this.onBrowserActiveChange = function() {
            if (document.visibilityState === "visible") _this.onBrowserTabActive();
            else _this.onBrowserTabInactive();
        };
        this.onTimePassed = function() {
            // check all callbacks time and if passed execute callback
            _this.absoluteTimeEllapsedCallbacks.forEach(function(_a, index) {
                var callback = _a.callback, pending = _a.pending, timeInMilliseconds = _a.timeInMilliseconds;
                if (pending && timeInMilliseconds <= _this.getTimeInMilliseconds()) {
                    callback(_this.getTimeInMilliseconds());
                    _this.absoluteTimeEllapsedCallbacks[index].pending = false;
                }
            });
            _this.timeIntervalEllapsedCallbacks.forEach(function(_a, index) {
                var callback = _a.callback, timeInMilliseconds = _a.timeInMilliseconds, multiplier = _a.multiplier;
                if (timeInMilliseconds <= _this.getTimeInMilliseconds()) {
                    callback(_this.getTimeInMilliseconds());
                    _this.timeIntervalEllapsedCallbacks[index].timeInMilliseconds = multiplier(timeInMilliseconds);
                }
            });
            if (_this.currentIdleTimeMs >= _this.idleTimeoutMs && _this.isRunning()) {
                _this.idle = true;
                _this.stopTimer();
                _this.idleCallbacks.forEach(function(fn) {
                    return fn(_this.getTimeInMilliseconds());
                });
            } else _this.currentIdleTimeMs += _this.checkCallbacksIntervalMs;
        };
        this.resetIdleTime = function() {
            if (_this.idle) _this.startTimer();
            _this.activeCallbacks.forEach(function(fn) {
                return fn(_this.getTimeInMilliseconds());
            });
            _this.idle = false;
            _this.currentIdleTimeMs = 0;
        };
        this.registerEventListeners = function() {
            var documentListenerOptions = {
                passive: true
            };
            var windowListenerOptions = $c0d7d50677d6925a$var$__assign({}, documentListenerOptions, {
                capture: true
            });
            document.addEventListener("visibilitychange", _this.onBrowserActiveChange);
            var throttleResetIdleTime = $c0d7d50677d6925a$var$throttle_1(_this.resetIdleTime, 2000, {
                leading: true,
                trailing: false
            });
            $c0d7d50677d6925a$var$windowIdleEvents.forEach(function(event) {
                window.addEventListener(event, throttleResetIdleTime, windowListenerOptions);
            });
            $c0d7d50677d6925a$var$documentIdleEvents.forEach(function(event) {
                return document.addEventListener(event, throttleResetIdleTime, documentListenerOptions);
            });
        };
        this.unregisterEventListeners = function() {
            document.removeEventListener("visibilitychange", _this.onBrowserActiveChange);
            $c0d7d50677d6925a$var$windowIdleEvents.forEach(function(event) {
                return window.removeEventListener(event, _this.resetIdleTime);
            });
            $c0d7d50677d6925a$var$documentIdleEvents.forEach(function(event) {
                return document.removeEventListener(event, _this.resetIdleTime);
            });
        };
        this.checkCallbacksOnInterval = function() {
            _this.checkCallbackIntervalId = window.setInterval(function() {
                _this.onTimePassed();
            }, _this.checkCallbacksIntervalMs);
        };
        this.startTimer = function() {
            if (!_this.checkCallbackIntervalId) _this.checkCallbacksOnInterval();
            var last = _this.times[_this.times.length - 1];
            if (last && last.stop === null) return;
            _this.times.push({
                start: performance.now(),
                stop: null
            });
            _this.running = true;
        };
        this.stopTimer = function() {
            if (!_this.times.length) return;
            _this.times[_this.times.length - 1].stop = performance.now();
            _this.running = false;
        };
        this.addTimeIntervalEllapsedCallback = function(timeIntervalEllapsedCallback) {
            _this.timeIntervalEllapsedCallbacks.push(timeIntervalEllapsedCallback);
        };
        this.addAbsoluteTimeEllapsedCallback = function(absoluteTimeEllapsedCallback) {
            _this.absoluteTimeEllapsedCallbacks.push(absoluteTimeEllapsedCallback);
        };
        this.addBrowserTabInactiveCallback = function(browserTabInactiveCallback) {
            _this.browserTabInactiveCallbacks.push(browserTabInactiveCallback);
        };
        this.addBrowserTabActiveCallback = function(browserTabActiveCallback) {
            _this.browserTabActiveCallbacks.push(browserTabActiveCallback);
        };
        this.addIdleCallback = function(inactiveCallback) {
            _this.idleCallbacks.push(inactiveCallback);
        };
        this.addActiveCallback = function(activeCallback) {
            _this.activeCallbacks.push(activeCallback);
        };
        this.getTimeInMilliseconds = function() {
            return _this.times.reduce(function(acc, current) {
                if (current.stop) acc = acc + (current.stop - current.start);
                else acc = acc + (performance.now() - current.start);
                return acc;
            }, 0);
        };
        this.isRunning = function() {
            return _this.running;
        };
        this.isIdle = function() {
            return _this.idle;
        };
        this.reset = function() {
            _this.times = [];
        };
        this.destroy = function() {
            _this.unregisterEventListeners();
            if (_this.checkCallbackIntervalId) window.clearInterval(_this.checkCallbackIntervalId);
        };
        this.running = false;
        this.times = [];
        this.idle = false;
        this.currentIdleTimeMs = 0;
        this.marks = {};
        this.measures = {};
        this.stopTimerOnTabchange = stopTimerOnTabchange;
        this.browserTabActiveCallbacks = browserTabActiveCallbacks;
        this.browserTabInactiveCallbacks = browserTabInactiveCallbacks;
        this.checkCallbacksIntervalMs = checkCallbacksIntervalMs;
        this.idleTimeoutMs = idleTimeoutMs;
        this.timeIntervalEllapsedCallbacks = timeIntervalEllapsedCallbacks;
        this.absoluteTimeEllapsedCallbacks = absoluteTimeEllapsedCallbacks;
        this.idleCallbacks = idleCallbacks;
        this.activeCallbacks = activeCallbacks;
        this.registerEventListeners();
    }
    BrowserInteractionTime.prototype.mark = function(key) {
        if (!this.marks[key]) this.marks[key] = [];
        this.marks[key].push({
            time: this.getTimeInMilliseconds()
        });
    };
    BrowserInteractionTime.prototype.getMarks = function(name) {
        if (this.marks[name].length < 1) return;
        return this.marks[name];
    };
    BrowserInteractionTime.prototype.measure = function(name, startMarkName, endMarkName) {
        var startMarks = this.marks[startMarkName];
        var startMark = startMarks[startMarks.length - 1];
        var endMarks = this.marks[endMarkName];
        var endMark = endMarks[endMarks.length - 1];
        if (!this.measures[name]) this.measures[name] = [];
        this.measures[name].push({
            name: name,
            startTime: startMark.time,
            duration: endMark.time - startMark.time
        });
    };
    BrowserInteractionTime.prototype.getMeasures = function(name) {
        if (!this.measures[name] && this.measures[name].length < 1) return;
        return this.measures[name];
    };
    return BrowserInteractionTime;
}();
var $c0d7d50677d6925a$export$2e2bcd8739ae039 = $c0d7d50677d6925a$var$BrowserInteractionTime;


var $7e65dda107884747$export$430908eb26d619ec = function useBrowserInteractionTime(threshold) {
    var _useState = (0, $9nHZC.useState)(true), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), active = _useState2[0], setActive = _useState2[1];
    var _useState3 = (0, $9nHZC.useState)(true), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState3, 2), tabActive = _useState4[0], setTabActive = _useState4[1];
    var activeRef = (0, $9nHZC.useRef)(active);
    activeRef.current = active;
    (0, $9nHZC.useEffect)(function() {
        var timer;
        timer = new (0, $c0d7d50677d6925a$export$2e2bcd8739ae039)({
            idleTimeoutMs: threshold,
            stopTimerOnTabchange: false,
            browserTabActiveCallbacks: [
                function() {
                    setTabActive(true);
                }
            ],
            browserTabInactiveCallbacks: [
                function() {
                    setTabActive(false);
                }
            ],
            idleCallbacks: [
                function() {
                    if (activeRef.current) setActive(false);
                }
            ],
            activeCallbacks: [
                function() {
                    if (!activeRef.current) setActive(true);
                }
            ]
        });
        timer.startTimer();
        return function() {
            timer && timer.destroy();
            timer = null;
        };
    }, [
        threshold
    ]);
    return {
        active: active,
        tabActive: tabActive
    };
};



var $4mVfk = parcelRequire("4mVfk");

var $9q1kH = parcelRequire("9q1kH");

var $8DpVo = parcelRequire("8DpVo");

var $9nHZC = parcelRequire("9nHZC");

var $4mVfk = parcelRequire("4mVfk");

var $8DpVo = parcelRequire("8DpVo");
var $e7b6142494d6e9bc$var$RETRY_HTTP_CODES = [
    408,
    500,
    502,
    503,
    504,
    522,
    524
];
function $e7b6142494d6e9bc$var$timeout(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
}
function $e7b6142494d6e9bc$var$fetchRetry(_x) {
    return $e7b6142494d6e9bc$var$_fetchRetry.apply(this, arguments);
}
function $e7b6142494d6e9bc$var$_fetchRetry() {
    $e7b6142494d6e9bc$var$_fetchRetry = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee2(url) {
        var options, retries, backoff, response, _args2 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
                    retries = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : 5;
                    backoff = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : 300;
                    _context2.next = 5;
                    return fetch(url, options);
                case 5:
                    response = _context2.sent;
                    if (!(response.ok || response.status === 401)) {
                        _context2.next = 8;
                        break;
                    }
                    return _context2.abrupt("return", response);
                case 8:
                    if (!(retries > 0 && $e7b6142494d6e9bc$var$RETRY_HTTP_CODES.includes(response.status))) {
                        _context2.next = 16;
                        break;
                    }
                    _context2.next = 11;
                    return $e7b6142494d6e9bc$var$timeout(backoff);
                case 11:
                    _context2.next = 13;
                    return $e7b6142494d6e9bc$var$fetchRetry(url, options, retries - 1, backoff * 2);
                case 13:
                    return _context2.abrupt("return", _context2.sent);
                case 16:
                    return _context2.abrupt("return", Promise.reject(response));
                case 17:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $e7b6142494d6e9bc$var$_fetchRetry.apply(this, arguments);
}
var $e7b6142494d6e9bc$export$931f43089f67754c = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee(endpoint, onAuthenticationFailed, onBadRequest) {
        var response, errorResponse;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return $e7b6142494d6e9bc$var$fetchRetry(endpoint, {
                        method: "POST",
                        credentials: "include",
                        headers: {
                            "Content-Type": "application/json"
                        }
                    });
                case 3:
                    response = _context.sent;
                    if (!(response && response.ok)) {
                        _context.next = 6;
                        break;
                    }
                    return _context.abrupt("return", response.json());
                case 6:
                    if (!(response && response.status === 401 && onAuthenticationFailed)) {
                        _context.next = 9;
                        break;
                    }
                    onAuthenticationFailed();
                    return _context.abrupt("return");
                case 9:
                    _context.next = 18;
                    break;
                case 11:
                    _context.prev = 11;
                    _context.t0 = _context["catch"](0);
                    errorResponse = _context.t0;
                    if (!(errorResponse.status === 400)) {
                        _context.next = 17;
                        break;
                    }
                    onBadRequest === null || onBadRequest === void 0 || onBadRequest();
                    return _context.abrupt("return", Promise.reject(errorResponse));
                case 17:
                    if ($e7b6142494d6e9bc$var$RETRY_HTTP_CODES.includes(errorResponse.status)) console.warn("Heartbeat: Retried 5x, stopped to call api");
                case 18:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function postHeartbeat(_x2, _x3, _x4) {
        return _ref.apply(this, arguments);
    };
}();


var $55b2f5f7a08648ca$export$5cc515bf8ee32bda = function useHearbeatService(endpoint, onAuthenticationFailed, onBadRequest) {
    var _useState = (0, $9nHZC.useState)(undefined), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), nextCallTimestamp = _useState2[0], setNextCallTimestamp = _useState2[1];
    var _useState3 = (0, $9nHZC.useState)(undefined), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState3, 2), sessionExpiryTimestamp = _useState4[0], setSessionExpiryTimestamp = _useState4[1];
    var _useState5 = (0, $9nHZC.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState5, 2), callHeartbeatService = _useState6[0], setCallHeartbeatService = _useState6[1];
    var _useState7 = (0, $9nHZC.useState)(false), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState7, 2), deactivated = _useState8[0], setDeactivated = _useState8[1];
    (0, $9nHZC.useEffect)(function() {
        if (callHeartbeatService && endpoint && !deactivated) {
            var callAsync = /*#__PURE__*/ function() {
                var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee() {
                    var response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return (0, $e7b6142494d6e9bc$export$931f43089f67754c)(endpoint, onAuthenticationFailed, onBadRequest);
                            case 3:
                                response = _context.sent;
                                setCallHeartbeatService(false);
                                if (response && response.nextCallTimestamp) setNextCallTimestamp(new Date(response.nextCallTimestamp));
                                if (response && response.sessionExpiryTime) setSessionExpiryTimestamp(new Date(response.sessionExpiryTime));
                                _context.next = 12;
                                break;
                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context["catch"](0);
                                setDeactivated(true);
                            case 12:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, null, [
                        [
                            0,
                            9
                        ]
                    ]);
                }));
                return function callAsync() {
                    return _ref.apply(this, arguments);
                };
            }();
            callAsync();
        }
    }, [
        callHeartbeatService,
        endpoint,
        onAuthenticationFailed,
        onBadRequest,
        deactivated
    ]);
    return {
        nextCallTimestamp: nextCallTimestamp,
        sessionExpiryTimestamp: sessionExpiryTimestamp,
        callHeartbeatService: callHeartbeatService,
        setCallHeartbeatService: setCallHeartbeatService,
        deactivated: deactivated
    };
};


var $f83cb59ee3fb1c67$export$27f64c06d2059d33 = function useHeartbeatOnInterval(endpoint, idleTime, onAuthenticationFailed, onBadRequest) {
    var _useHearbeatService = (0, $55b2f5f7a08648ca$export$5cc515bf8ee32bda)(endpoint, onAuthenticationFailed, onBadRequest), nextCallTimestamp = _useHearbeatService.nextCallTimestamp, sessionExpiryTimestamp = _useHearbeatService.sessionExpiryTimestamp, callHeartbeatService = _useHearbeatService.callHeartbeatService, setCallHeartbeatService = _useHearbeatService.setCallHeartbeatService, deactivated = _useHearbeatService.deactivated;
    var _useBrowserInteractio = (0, $7e65dda107884747$export$430908eb26d619ec)(idleTime), active = _useBrowserInteractio.active, tabActive = _useBrowserInteractio.tabActive;
    /**
   * Initial heartbeat api request
   */ (0, $9nHZC.useEffect)(function() {
        setCallHeartbeatService(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * Call heartbeat api when user is idle and the tab is active
   */ (0, $9nHZC.useEffect)(function() {
        if (!active && tabActive) setCallHeartbeatService(true);
    }, [
        active,
        tabActive,
        setCallHeartbeatService
    ]);
    (0, $59738db6cc26cfca$export$2e2bcd8739ae039)(function() {
        if (callHeartbeatService) return;
        /**
     * Call heartbeat api when session has expired to initiate redirect.
     */ if (sessionExpiryTimestamp && sessionExpiryTimestamp.getTime() <= Date.now()) {
            setCallHeartbeatService(true);
            return;
        }
        /**
     * Call heartbeat api if user is active and nextCallTimestamp is reached.
     */ if (active && tabActive && nextCallTimestamp && nextCallTimestamp.getTime() <= Date.now()) setCallHeartbeatService(true);
    }, (0, $6da6434b58c8ef37$export$f2b2f5ef0b498d26));
    return {
        nextCallTimestamp: nextCallTimestamp,
        sessionExpiryTimestamp: sessionExpiryTimestamp,
        active: active,
        tabActive: tabActive,
        deactivated: deactivated
    };
};


var $7ac4f7fdc007f823$var$Heartbeat = function Heartbeat(_ref) {
    var _ref$endpoint = _ref.endpoint, endpoint = _ref$endpoint === void 0 ? (0, $6da6434b58c8ef37$export$4496080a0271e85d) : _ref$endpoint, _ref$idleTime = _ref.idleTime, idleTime = _ref$idleTime === void 0 ? (0, $6da6434b58c8ef37$export$af2ff676951003fe) : _ref$idleTime, onAuthenticationFailed = _ref.onAuthenticationFailed, onBadRequest = _ref.onBadRequest;
    (0, $f83cb59ee3fb1c67$export$27f64c06d2059d33)(endpoint, idleTime, onAuthenticationFailed, onBadRequest);
    return null;
};
var $7ac4f7fdc007f823$export$2e2bcd8739ae039 = $7ac4f7fdc007f823$var$Heartbeat;



var $g2R3c = parcelRequire("g2R3c");

var $1gtcM = parcelRequire("1gtcM");
const $62f778ac26257bce$export$38f39b921d5551c1 = ()=>{
    const isCurrentUserAnon = (0, $aAre5.useSelector)((0, $g2R3c.getCurrentUserIsAnonymous));
    return !isCurrentUserAnon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7ac4f7fdc007f823$export$2e2bcd8739ae039), {
        onAuthenticationFailed: ()=>{
            // redirect to the page they were on after logging in
            window.location.href = `${(0, $1gtcM.default).ui.login()}?session_invalid=1&next=${window.location.pathname}${window.location.search}`;
        }
    }) : null;
};



var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");
parcelRequire("dGzLf");
var $5oGLl = parcelRequire("5oGLl");

var $ltQcg = parcelRequire("ltQcg");

var $33dmM = parcelRequire("33dmM");

var $9nHZC = parcelRequire("9nHZC");

var $dCs3M = parcelRequire("dCs3M");
var $2c6bL = parcelRequire("2c6bL");

var $33dmM = parcelRequire("33dmM");

var $2xJU3 = parcelRequire("2xJU3");

var $aP6k3 = parcelRequire("aP6k3");
var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */ function $c254bb7ae9a19187$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c254bb7ae9a19187$export$9078d361292dfaea = (0, $2xJU3.default)("div", {
    target: "e1i2pqq70"
})("margin-bottom:", (0, $h39Sh.default)("space.200", "16px"), ";");
const $c254bb7ae9a19187$export$161318b2ba42cf2b = (0, $2xJU3.default)("h5", {
    target: "e1i2pqq71"
})("border-bottom:2px solid ", (0, $h39Sh.default)("color.border", (0, $jp7ng).N40), ";padding-bottom:", (0, $h39Sh.default)("space.050", "4px"), ";");
const $c254bb7ae9a19187$export$b326d77e4b8b7664 = (0, $2xJU3.default)("dl", {
    target: "e1i2pqq72"
})({
    name: "131yq1t",
    styles: "padding-left:0;"
});
const $c254bb7ae9a19187$export$59451aa6b6270879 = (0, $2xJU3.default)("div", {
    target: "e1i2pqq73"
})("align-items:center;display:flex;justify-content:space-between;margin-top:", (0, $h39Sh.default)("space.050", "4px"), ";");
const $c254bb7ae9a19187$export$4384767a59dc851d = (0, $2xJU3.default)("dd", {
    target: "e1i2pqq74"
})({
    name: "8kn4zf",
    styles: "margin-top:0;"
});
const $c254bb7ae9a19187$export$f20a7ed0751474c1 = (0, $2xJU3.default)("kbd", {
    target: "e1i2pqq75"
})("align-items:center;background-clip:padding-box;border:1px solid ", (0, $h39Sh.default)("color.border", (0, $jp7ng).N50), ";border-radius:", (0, $aP6k3.borderRadius)(), "px;box-sizing:border-box;display:flex;background-color:", (0, $h39Sh.default)("color.background.input.hovered", (0, $jp7ng).N10), ";background-image:linear-gradient( to bottom,", (0, $h39Sh.default)("color.background.input.pressed", (0, $jp7ng).N0), ",", (0, $h39Sh.default)("color.background.input.hovered", (0, $jp7ng).N20), " );background-repeat:repeat-x;font-size:0.9em;justify-content:center;margin:0 2px;min-height:20px;min-width:20px;padding:0 5px;white-space:nowrap;");


class $ccb1ab2da6696162$export$41a17656f51892d6 extends (0, $9nHZC.PureComponent) {
    render() {
        const { shortcuts: shortcuts, intl: intl } = this.props;
        const sortedGroupIds = Object.keys(shortcuts).sort((idA, idB)=>(shortcuts[idA].groupWeight || 0) - (shortcuts[idB].groupWeight || 0));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, sortedGroupIds.map((id)=>!!shortcuts[id].groupTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($c254bb7ae9a19187$export$9078d361292dfaea, {
                key: id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($c254bb7ae9a19187$export$161318b2ba42cf2b, null, shortcuts[id].groupTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($c254bb7ae9a19187$export$b326d77e4b8b7664, null, shortcuts[id].shortcuts.map((shortcut)=>!!shortcut.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($c254bb7ae9a19187$export$59451aa6b6270879, {
                    key: shortcut.id
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("dt", null, shortcut.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("dd", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dCs3M.default), null, shortcut.keys[0].match(/[A-Z]/) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($c254bb7ae9a19187$export$f20a7ed0751474c1, null, intl.formatMessage((0, $33dmM.keyboardShortcutDialogMessages).shiftKey)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2c6bL.default), null, "+")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($c254bb7ae9a19187$export$f20a7ed0751474c1, null, shortcut.keys[0].toLowerCase())))))))));
    }
}
$ccb1ab2da6696162$export$41a17656f51892d6.defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */ shortcuts: {}
};



var $ci5gC = parcelRequire("ci5gC");
class $3ed2e22f70195a21$var$KeyboardShortcutDialog extends (0, $9nHZC.PureComponent) {
    constructor(...args){
        super(...args);
        this.actions = [
            {
                onClick: ()=>this.close(),
                text: this.props.intl.formatMessage((0, $33dmM.keyboardShortcutDialogMessages).closeButton)
            }
        ];
        this.close = ()=>{
            this.props.toggleMenu(false);
        };
    }
    render() {
        const { intl: intl, isOpen: isOpen, shortcuts: shortcuts } = this.props;
        if (!isOpen) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ci5gC.default), {
            actions: this.actions,
            heading: intl.formatMessage((0, $33dmM.keyboardShortcutDialogMessages).heading),
            onClose: this.close,
            width: "small"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ccb1ab2da6696162$export$41a17656f51892d6), {
            shortcuts: shortcuts,
            intl: intl
        }));
    }
}
$3ed2e22f70195a21$var$KeyboardShortcutDialog.defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */ shortcuts: {},
    toggleMenu: ()=>{}
};
const $3ed2e22f70195a21$var$mapDispatchToProps = {
    toggleMenu: $ltQcg.default
};
const $3ed2e22f70195a21$var$mapStateToProps = (state)=>({
        isOpen: state.global.isKeyboardShortcutMenuOpen,
        shortcuts: state.keyboardShortcuts
    });
var $3ed2e22f70195a21$export$2e2bcd8739ae039 = (0, $5oGLl.default)($3ed2e22f70195a21$var$mapStateToProps, $3ed2e22f70195a21$var$mapDispatchToProps)((0, $agjvf.injectIntl)($3ed2e22f70195a21$var$KeyboardShortcutDialog));



var $1JlAz = parcelRequire("1JlAz");
parcelRequire("lM4y8");
var $aF7fC = parcelRequire("aF7fC");

var $9q1kH = parcelRequire("9q1kH");

var $wmpq0 = parcelRequire("wmpq0");

var $dObIf = parcelRequire("dObIf");

var $41O29 = parcelRequire("41O29");

var $hDvgZ = parcelRequire("hDvgZ");

var $8B4n6 = parcelRequire("8B4n6");

var $9FrJk = parcelRequire("9FrJk");

var $fcJSo = parcelRequire("fcJSo");
var $43cb35567badd834$var$initialized = false;
function $43cb35567badd834$var$sinkInteraction(instance, payloadPackage) {
    (0, $9FrJk.sinkInteractionHandler)(function(interactionId, interaction) {
        (0, $wmpq0.unstable_scheduleCallback)((0, $wmpq0.unstable_IdlePriority), function() {
            var payloads = payloadPackage.createPayloads(interactionId, interaction);
            payloads === null || payloads === void 0 || payloads.forEach(function(payload) {
                instance.sendOperationalEvent(payload);
            });
        });
    });
}

var $43cb35567badd834$export$2cd8252107eb640b = function init(analyticsWebClientAsync, config) {
    var _config$vc;
    if ($43cb35567badd834$var$initialized) return;
    (0, $41O29.setUFOConfig)(config);
    if (config.enableTTVC) (0, $hDvgZ.initTTVC)();
    if ((_config$vc = config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled) (0, $fcJSo.getVCObserver)({
        heatmapSize: config.vc.heatmapSize,
        oldDomUpdates: config.vc.oldDomUpdates,
        devToolsEnabled: config.vc.devToolsEnabled,
        selectorConfig: config.vc.selectorConfig
    }).start({
        startTime: 0
    });
    (0, $8B4n6.setupHiddenTimingCapture)();
    (0, $dObIf.startLighthouseObserver)();
    $43cb35567badd834$var$initialized = true;
    Promise.all([
        analyticsWebClientAsync,
        // eslint-disable-next-line import/dynamic-import-chunkname
        (parcelRequire("80e8L"))
    ]).then(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_ref, 2), awc = _ref2[0], payloadPackage = _ref2[1];
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then(function(client) {
            var instance = client.getInstance();
            $43cb35567badd834$var$sinkInteraction(instance, payloadPackage);
        });
        else if (awc.sendOperationalEvent) $43cb35567badd834$var$sinkInteraction(awc, payloadPackage);
    });
};



var $keeLf = parcelRequire("keeLf");
function $9649d2f2536110b4$export$2e2bcd8739ae039(route) {
    if (route.ufoName != null) return route.ufoName;
    return route.name;
}



var $5m0MG = parcelRequire("5m0MG");

var $4Pw3J = parcelRequire("4Pw3J");

var $41O29 = parcelRequire("41O29");

var $4wIrX = parcelRequire("4wIrX");

var $2xpzD = parcelRequire("2xpzD");

var $9FrJk = parcelRequire("9FrJk");

var $hVUKx = parcelRequire("hVUKx");
var $28896ec61047bbbe$var$AWAITING_PAGELOAD_NAME = "awaiting_pageload_name";
function $28896ec61047bbbe$export$2e2bcd8739ae039(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    var activeInteraction = (0, $9FrJk.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, $hVUKx.default).current = routeName || null;
    var rate = ufoName ? (0, $41O29.getInteractionRate)(ufoName, "page_load") : 1;
    var enabledBySamplingRate = (0, $4Pw3J.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        var newId = (0, $5m0MG.v4)();
        (0, $2xpzD.DefaultInteractionID).current = newId;
        (0, $9FrJk.addNewInteraction)(newId, ufoName || "", "page_load", 0, rate, null, routeName, (0, $4wIrX.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $9FrJk.addHoldByID)(newId, [], $28896ec61047bbbe$var$AWAITING_PAGELOAD_NAME, $28896ec61047bbbe$var$AWAITING_PAGELOAD_NAME, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === "page_load") // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $9FrJk.abort)(activeInteraction.id, "excluded_by_sampling");
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === "page_load") {
        (0, $9FrJk.updatePageLoadInteractionName)(ufoName, routeName);
        (0, $9FrJk.removeHoldByID)(activeInteraction.id, $28896ec61047bbbe$var$AWAITING_PAGELOAD_NAME);
    }
}
function $28896ec61047bbbe$export$d0f99433cd4f4028(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    var interaction = (0, $9FrJk.getActiveInteraction)();
    if (!interaction || interaction.type !== "page_load" && interaction.type !== "transition") return;
    if (ufoName) {
        var rate = (0, $41O29.getInteractionRate)(ufoName, "page_load");
        (0, $9FrJk.updatePageLoadInteractionName)(ufoName, routeName);
        if ((0, $4Pw3J.default)(rate)) (0, $hVUKx.default).current = ufoName;
        else (0, $9FrJk.abort)(interaction.id, "excluded_by_sampling");
    }
    (0, $9FrJk.removeHoldByID)(interaction.id, $28896ec61047bbbe$var$AWAITING_PAGELOAD_NAME);
}


parcelRequire("j1bBw");
var $e5hNf = parcelRequire("e5hNf");
var $kjZQW = parcelRequire("kjZQW");

var $bBcuy = parcelRequire("bBcuy");

var $1jQQK = parcelRequire("1jQQK");

var $c7cuD = parcelRequire("c7cuD");
const $9eec41ea49884cb9$var$FIRST_PAINT_MARK = "first-paint";
const $9eec41ea49884cb9$var$ssrTimings = ()=>{
    const ssrTime = (0, $c7cuD.getMark)((0, $1jQQK.PERFORMANCE_MARK_SSR_HTML));
    if (!ssrTime) return [];
    return [
        {
            label: "ssr",
            data: {
                startTime: 0,
                duration: ssrTime
            }
        }
    ];
};
const $9eec41ea49884cb9$export$aa3aaccc271de5f7 = {
    enabled: true,
    doNotAbortActivePressInteraction: [],
    doNotAbortActivePressInteractionOnTransition: [],
    awaitBM3TTI: [],
    ufoNameOverrides: {},
    autoGeneratedRate: 1000,
    namePrefix: "ufo-",
    segmentPrefix: "ufo-",
    rates: {},
    rules: [],
    killswitch: [],
    typingMethod: "timeout",
    capability: {
        feature_flag_access: 0,
        react_profiler: 1
    },
    kind: {
        page_load: 1,
        transition: 1,
        hover: 0,
        legacy: 0,
        press: 1,
        typing: 0
    },
    // disable collection of resource timings for 'fetch' requests, as they
    // currently contain UGC, e.g. workspace/repository/branch names
    // TODO: remove `allowedResource` config once `sanitiseEndpoints` function is provided
    allowedResources: [
        "script",
        "link"
    ],
    removePageSegmentsUFOPrefixes: false,
    removeInteractionsUFOPrefixes: true,
    product: "bitbucket",
    region: "unknown",
    ssr: {
        getSSRTimings: ()=>$9eec41ea49884cb9$var$ssrTimings(),
        getSSRDoneTime: ()=>(0, $c7cuD.getMark)($9eec41ea49884cb9$var$FIRST_PAINT_MARK)
    },
    vc: {
        enabled: true,
        heatmapSize: 200,
        oldDomUpdates: false,
        devToolsEnabled: true,
        selectorConfig: {
            // This must be false because our README markup contains UGC in some ids
            // and we cannot log that data.
            id: false,
            role: true,
            className: true,
            testId: true
        }
    },
    enableCompleteUsingDoubleRAF: true
};
const $9eec41ea49884cb9$export$d556aa935cef5c0c = {
    ...$9eec41ea49884cb9$export$aa3aaccc271de5f7,
    rates: {
        view_page: 1000
    }
};


// not explicitly required, but just defensive programming to ensure we only
// initialise React UFO once
let $f1a43714fa02266c$var$isInitialised = false;
function $f1a43714fa02266c$export$af995ee1d7017fea(appData) {
    if (!appData.features["enable-react-ufo"] || $f1a43714fa02266c$var$isInitialised) return;
    const isProd = appData.frontbucket_environment === "production";
    const config = isProd ? (0, $9eec41ea49884cb9$export$d556aa935cef5c0c) : (0, $9eec41ea49884cb9$export$aa3aaccc271de5f7);
    (0, $keeLf.configure)({
        mapResources: (url)=>url,
        // Fetch requests URLs currently contain UGC, e.g. workspace/repository/branch names
        // TODO: provide a `sanitiseEndpoints` function that strips-out /
        // anonymizes UGC out of fetch requests url
        sanitiseEndpoints: (url)=>url
    });
    (0, $43cb35567badd834$export$2cd8252107eb640b)(Promise.resolve((0, $bBcuy.analyticsClient)()), config);
    const routes = (0, $kjZQW.getRoutes)((0, $e5hNf.getRouteFeaturesFromAppData)(appData));
    const matchedRoute = (0, $aF7fC.default)(routes, window.location.pathname, // NOTE: we don't need any matching for query params, weird that the
    // library won't make this an optional argument (instead have to set it
    // to undefined manually)
    undefined);
    // NOTE: call `traceUFOPageLoad` as early as possible, but _after_ calling
    // `initReactUFO`
    if (matchedRoute !== null && matchedRoute !== void 0 && matchedRoute.route) {
        const ufoName = (0, $9649d2f2536110b4$export$2e2bcd8739ae039)(matchedRoute === null || matchedRoute === void 0 ? void 0 : matchedRoute.route).toLowerCase();
        (0, $28896ec61047bbbe$export$2e2bcd8739ae039)(ufoName, matchedRoute.route.name);
    }
    $f1a43714fa02266c$var$isInitialised = true;
}



var $9nHZC = parcelRequire("9nHZC");

var $9nHZC = parcelRequire("9nHZC");

var $59ZFR = parcelRequire("59ZFR");

var $2xpzD = parcelRequire("2xpzD");

var $9FrJk = parcelRequire("9FrJk");
function $b93de9c22854ca6c$export$2e2bcd8739ae039(_ref) {
    var data = _ref.data;
    var interactionContext = (0, $9nHZC.useContext)((0, $59ZFR.default));
    (0, $9nHZC.useMemo)(function() {
        if (!interactionContext) return;
        interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $b93de9c22854ca6c$export$d12f56a472cdbe6c(data) {
    var interactionId = (0, $2xpzD.getInteractionId)();
    var currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $9FrJk.addCustomData)(currentInteractionId, [], data);
}



var $hp1uP = parcelRequire("hp1uP");

var $1D3HA = parcelRequire("1D3HA");
parcelRequire("3hzea");
var $a5HLv = parcelRequire("a5HLv");
const $8b225077396da2ef$export$ced06283ca897aa8 = ()=>{
    var _user$isAtlassian, _user$isBitbucket;
    const { user: user } = (0, $9nHZC.useContext)((0, $1D3HA.AppDataContext));
    const { repository: repository } = (0, $9nHZC.useContext)((0, $hp1uP.CurrentDataContext));
    const data = {
        isAtlassian: (_user$isAtlassian = user === null || user === void 0 ? void 0 : user.isAtlassian) !== null && _user$isAtlassian !== void 0 ? _user$isAtlassian : false,
        isBitbucket: (_user$isBitbucket = user === null || user === void 0 ? void 0 : user.isBitbucket) !== null && _user$isBitbucket !== void 0 ? _user$isBitbucket : false
    };
    if (repository !== null && repository !== void 0 && repository.uuid) data.repositoryId = (0, $a5HLv.uncurlyUuid)(repository.uuid);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $b93de9c22854ca6c$export$2e2bcd8739ae039), {
        data: data
    });
};


parcelRequire("lM4y8");
var $b7V6F = parcelRequire("b7V6F");


var $9nHZC = parcelRequire("9nHZC");

var $5m0MG = parcelRequire("5m0MG");

var $4Pw3J = parcelRequire("4Pw3J");

var $41O29 = parcelRequire("41O29");

var $4wIrX = parcelRequire("4wIrX");

var $2xpzD = parcelRequire("2xpzD");

var $9FrJk = parcelRequire("9FrJk");

var $hVUKx = parcelRequire("hVUKx");

var $4wIrX = parcelRequire("4wIrX");
var $2b2a3a6acea8346d$export$295213bc4d0c54ad = function generateSpanId() {
    return Array.from(new Array(16), function() {
        return Math.floor(Math.random() * 16).toString(16);
    }).join("");
};


var $54742e490135446a$export$f2e521e495a88544 = function setInteractionActiveTrace(newId) {
    (0, $4wIrX.setActiveTrace)(newId.replace(/-/g, ""), (0, $2b2a3a6acea8346d$export$295213bc4d0c54ad)(), "transition");
};


function $7755565a8564e7b5$export$2e2bcd8739ae039(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    var pressInteractionsList = (0, $41O29.getDoNotAbortActivePressInteractionOnTransition)();
    var interaction = (0, $9FrJk.getActiveInteraction)();
    if (pressInteractionsList && interaction) {
        if (pressInteractionsList.includes(interaction.ufoName)) return;
    }
    (0, $9FrJk.abortAll)("transition", ufoName !== null && ufoName !== void 0 ? ufoName : undefined);
    // if (ff('uip.vc')) {
    //     startTTVC();
    // }
    if (ufoName) {
        (0, $hVUKx.default).current = ufoName;
        var rate = (0, $41O29.getInteractionRate)(ufoName, "transition");
        if ((0, $4Pw3J.default)(rate)) {
            var newId = (0, $5m0MG.v4)();
            (0, $54742e490135446a$export$f2e521e495a88544)(newId);
            (0, $2xpzD.DefaultInteractionID).current = newId;
            (0, $9FrJk.addNewInteraction)(newId, ufoName, "transition", performance.now(), rate, null, routeName, (0, $4wIrX.getActiveTrace)());
        }
    }
}
function $7755565a8564e7b5$export$369f0ded13ce6c50() {
    var interactionId = (0, $9nHZC.useContext)((0, $2xpzD.default));
    var capturedInteractionId = interactionId.current;
    (0, $9nHZC.useEffect)(function() {
        // If we have a current interaction set...
        if (capturedInteractionId != null) {
            var cancel = requestAnimationFrame(function() {
                cancel = requestAnimationFrame(function() {
                    if (capturedInteractionId === interactionId.current) (0, $9FrJk.tryComplete)(capturedInteractionId);
                });
            });
            (0, $9FrJk.addOnCancelCallback)(capturedInteractionId, function() {
                cancelAnimationFrame(cancel);
            });
        }
    }, [
        capturedInteractionId,
        interactionId
    ]);
}



var $3Dg4T = parcelRequire("3Dg4T");
const $939ca968d77ff06f$export$c1a838a491a42b2 = ()=>{
    const [routerState] = (0, $b7V6F.useRouter)();
    const { route: route, action: action } = routerState;
    const pageLoadType = (0, $3Dg4T.getPageLoadType)();
    if (route.name && pageLoadType !== "full_page" && action !== "REPLACE") {
        const ufoName = (0, $9649d2f2536110b4$export$2e2bcd8739ae039)(route).toLowerCase();
        // Ignore REPLACE actions because they are redirects
        (0, $7755565a8564e7b5$export$2e2bcd8739ae039)(ufoName, route.name);
    }
};





var $9nHZC = parcelRequire("9nHZC");

var $ikMGL = parcelRequire("ikMGL");
const $5e9fe9c4f5c3127f$export$ec900a63d6c1e95b = ()=>{
    const { loadRecentWorkspaces: loadRecentWorkspaces } = (0, $ikMGL.useRecentData)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $9nHZC.useEffect)(loadRecentWorkspaces, []);
    return null;
};



var $9nHZC = parcelRequire("9nHZC");
parcelRequire("dGzLf");
var $eeHDY = parcelRequire("eeHDY");

var $iyyGb = parcelRequire("iyyGb");

var $3pyKL = parcelRequire("3pyKL");
const $b769e8e9e9257822$var$StatuspagePoller = ()=>{
    const dispatch = (0, $eeHDY.useDispatch)();
    const [polling, setPolling] = (0, $9nHZC.useState)(true);
    (0, $9nHZC.useEffect)(()=>{
        const pollStatuspageOnInterval = async ()=>{
            if (!document.hidden && polling) try {
                const resp = await (0, $3pyKL.getIncidents)();
                dispatch((0, $iyyGb.LoadStatusPageIncidentsSuccess)(resp));
            } catch (error) {
                dispatch((0, $iyyGb.LoadStatusPageIncidentsError));
                setPolling(false);
            }
        };
        pollStatuspageOnInterval();
        const interval = setInterval(pollStatuspageOnInterval, 60000);
        return ()=>clearInterval(interval);
    }, [
        dispatch,
        polling
    ]);
    return null;
};
var $b769e8e9e9257822$export$2e2bcd8739ae039 = $b769e8e9e9257822$var$StatuspagePoller;



var $lIZwG = parcelRequire("lIZwG");
parcelRequire("g2goG");
var $QQQjQ = parcelRequire("QQQjQ");
var $kNA8C = parcelRequire("kNA8C");
var $5kmFR = parcelRequire("5kmFR");
var $c5dog = parcelRequire("c5dog");

var $6aoKW = parcelRequire("6aoKW");
parcelRequire("3hzea");
var $6E7t8 = parcelRequire("6E7t8");
function $a7e0e23186ee1bf0$export$e99b890fe9020b87(eventName, eventData) {
    const fact = new (0, $6E7t8.default)(eventData);
    fact.name = eventName;
    return fact;
}



var $k2cPS = parcelRequire("k2cPS");
// This handles connect analytics events. e.g. WebItem clicked, Iframe loaded, etc...
// @ts-ignore TODO: fix noImplicitAny error here
(0, $5kmFR.registerAnalyticsListener)((eventName, eventData)=>{
    (0, $6aoKW.publishFact)((0, $a7e0e23186ee1bf0$export$e99b890fe9020b87)(eventName, eventData));
});
async function $5ee31a41a09676be$var$getScopes() {
    const response = await fetch("/site/oauth2/scopes");
    return response.json();
}
async function $5ee31a41a09676be$var$denyOAuth(clientId) {
    const response = await fetch((0, $k2cPS.default)(`/!api/internal/consumers/${encodeURIComponent(clientId)}/denials`, {
        method: "PUT"
    }));
    if (!response.ok) throw Error(response.statusText);
    return Promise.resolve();
}
(0, $QQQjQ.default).setOAuthScopesHandler((onSucess, onError)=>{
    $5ee31a41a09676be$var$getScopes().then(onSucess).catch(onError);
});
(0, $QQQjQ.default).setDenyOAuthHandler((moduleId, onSuccess, onError)=>{
    const mod = (0, $QQQjQ.default).modules.get(moduleId);
    const clientId = (0, $lIZwG.default)(mod, "options.client-id");
    if (!mod || !clientId) onError(); // call error handler
    $5ee31a41a09676be$var$denyOAuth(clientId).then(onSuccess).catch(onError);
});
(0, $QQQjQ.default).setManagePermissionsUrlProvider(()=>`/account/settings/app-authorizations/`);


var $QQQjQ = parcelRequire("QQQjQ");
var $kNA8C = parcelRequire("kNA8C");
var $c5dog = parcelRequire("c5dog");

var $61bjs = parcelRequire("61bjs");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("hw8PW");
var $7JtYi = parcelRequire("7JtYi");
var $hw8PW = parcelRequire("hw8PW");
const $a07e2801589e28b7$export$d33b097e0a285bc2 = {
    START: "start",
    STOP: "stop"
};
const $a07e2801589e28b7$export$f6a9504bc1305cf0 = {
    BLOCKED: "blocked",
    CANCELED: "canceled",
    ERROR: "error",
    STARTED: "started",
    STOPPED: "stopped",
    UNREGISTERED: "unregistered"
};
let $a07e2801589e28b7$export$7fb117db98868be6 = /*#__PURE__*/ function(ProductIds) {
    ProductIds["CONFLUENCE"] = "confluence";
    ProductIds["ENGAGEKIT"] = "Engagekit";
    ProductIds["INTERCOM"] = "intercom";
    ProductIds["JIRA"] = "jira";
    ProductIds["PENDO"] = "pendo";
    ProductIds["CLOUDADMIN"] = "cloudadmin";
    ProductIds["BITBUCKET"] = "bitbucket";
    return ProductIds;
}({});
const $a07e2801589e28b7$export$94e85cf3348f045a = {
    ENGAGEMENT: "engagement",
    MARKETING: "marketing",
    TRANSACTIONAL: "transactional"
};
const $a07e2801589e28b7$export$dbe9e38c9d6f26d0 = [
    $a07e2801589e28b7$export$94e85cf3348f045a.ENGAGEMENT,
    $a07e2801589e28b7$export$94e85cf3348f045a.MARKETING
];
const $a07e2801589e28b7$export$865c0eaaa43d90f8 = {
    START: "messageStart",
    STOP: "messageStop"
};
const $a07e2801589e28b7$export$fc6a8b8cb405f50 = {
    INFO: "info",
    VERBOSE: "verbose"
};



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $ll9SN = parcelRequire("ll9SN");

var $9nHZC = parcelRequire("9nHZC");
function $cf61e13c1f825b98$export$2e2bcd8739ae039(Component) {
    var PreventNestedInstancesContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createContext(false);
    return function PreventNestedInstances(props) {
        return(/*#__PURE__*/ // TODO: Replace usage of PreventNestedInstancesContext.Consumer with useContext(PreventNestedInstancesContext)
        (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(PreventNestedInstancesContext.Consumer, null, function(shouldPreventInstantiation) {
            return shouldPreventInstantiation ? props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(PreventNestedInstancesContext.Provider, {
                value: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Component, props));
        }));
    };
}



var $kFnE9 = parcelRequire("kFnE9");

var $7ojd4 = parcelRequire("7ojd4");

var $4vOvC = parcelRequire("4vOvC");

var $8tqiY = parcelRequire("8tqiY");
var $2ceb6b7347c6a90b$export$1385d81a6c6bbcd4 = {
    INIT: "@@redux/INIT"
};
function $2ceb6b7347c6a90b$export$2e2bcd8739ae039(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error("Expected the enhancer to be a function.");
        return enhancer($2ceb6b7347c6a90b$export$2e2bcd8739ae039)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error("Expected the reducer to be a function.");
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error("Expected listener to be a function.");
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!(0, $4vOvC.default)(action)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (typeof action.type === "undefined") throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (isDispatching) throw new Error("Reducers may not dispatch actions.");
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error("Expected the nextReducer to be a function.");
        currentReducer = nextReducer;
        dispatch({
            type: $2ceb6b7347c6a90b$export$1385d81a6c6bbcd4.INIT
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object") throw new TypeError("Expected the observer to be an object.");
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[0, $8tqiY.default] = function() {
            return this;
        }, _ref;
    }
    // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $2ceb6b7347c6a90b$export$1385d81a6c6bbcd4.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[0, $8tqiY.default] = observable, _ref2;
}




var $4vOvC = parcelRequire("4vOvC");
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $ccee9a692120c16d$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $4ee4af6fe58db7cd$var$getUndefinedStateErrorMessage(key, action) {
    var actionType = action && action.type;
    var actionName = actionType && '"' + actionType.toString() + '"' || "an action";
    return "Given action " + actionName + ', reducer "' + key + '" returned undefined. ' + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}
function $4ee4af6fe58db7cd$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === (0, $2ceb6b7347c6a90b$export$1385d81a6c6bbcd4).INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!(0, $4vOvC.default)(inputState)) return "The " + argumentName + ' has unexpected type of "' + ({}).toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $4ee4af6fe58db7cd$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: (0, $2ceb6b7347c6a90b$export$1385d81a6c6bbcd4).INIT
        });
        if (typeof initialState === "undefined") throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
        var type = "@@redux/PROBE_UNKNOWN_ACTION_" + Math.random().toString(36).substring(7).split("").join(".");
        if (typeof reducer(undefined, {
            type: type
        }) === "undefined") throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ("Don't try to handle " + (0, $2ceb6b7347c6a90b$export$1385d81a6c6bbcd4).INIT + ' or other actions in "redux/*" ') + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    });
}
function $4ee4af6fe58db7cd$export$2e2bcd8739ae039(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache = void 0;
    var shapeAssertionError = void 0;
    try {
        $4ee4af6fe58db7cd$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var errorMessage = $4ee4af6fe58db7cd$var$getUndefinedStateErrorMessage(_key, action);
                throw new Error(errorMessage);
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        return hasChanged ? nextState : state;
    };
}


function $31d8a49f17b9f0ae$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(undefined, arguments));
    };
}
function $31d8a49f17b9f0ae$export$2e2bcd8739ae039(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $31d8a49f17b9f0ae$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? "null" : typeof actionCreators) + ". " + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
    var keys = Object.keys(actionCreators);
    var boundActionCreators = {};
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $31d8a49f17b9f0ae$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}


/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $6349137023569db2$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(undefined, arguments));
        };
    });
}


var $c4777911b98eb4ef$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $c4777911b98eb4ef$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function(reducer, preloadedState, enhancer) {
            var store = createStore(reducer, preloadedState, enhancer);
            var _dispatch = store.dispatch;
            var chain = [];
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch(action) {
                    return _dispatch(action);
                }
            };
            chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = (0, $6349137023569db2$export$2e2bcd8739ae039).apply(undefined, chain)(store.dispatch);
            return $c4777911b98eb4ef$var$_extends({}, store, {
                dispatch: _dispatch
            });
        };
    };
}




/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/ function $45288bc7c5d2c9cc$var$isCrushed() {}


function $d6d939b947d85a22$export$eac027797b968991() {
    var isCancelled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return {
        isCancelled: isCancelled
    };
}



var $a4QC0 = parcelRequire("a4QC0");
function $080cd6a6641f1295$export$a77934ac158768dd() {
    return !(0, $a4QC0.isFedRamp)();
}


var $d1a917d05ac92efc$export$d05fe3e897340c89 = "SET_MESSAGE_MAPPING";
var $d1a917d05ac92efc$export$eacd3ec165715d8 = "SET_INITIALIZING";
var $d1a917d05ac92efc$export$874c5149d7f0e3b8 = "RESET_STORE";
var $d1a917d05ac92efc$export$cb5041d68cb18859 = "CLEAR_CURRENT";
var $d1a917d05ac92efc$export$a9319af002a4c677 = "SET_CURRENT";
var $d1a917d05ac92efc$export$a20a1205b2a2b7e4 = function resetStore() {
    return {
        type: $d1a917d05ac92efc$export$874c5149d7f0e3b8
    };
};
var $d1a917d05ac92efc$export$2a47f398eeff8b01 = function initialize(config) {
    return {
        type: $d1a917d05ac92efc$export$eacd3ec165715d8,
        config: config
    };
};
var $d1a917d05ac92efc$export$375dd0a76fecd4c7 = function setMessageMapping(messageMapping) {
    return {
        type: $d1a917d05ac92efc$export$d05fe3e897340c89,
        messageMapping: messageMapping
    };
};
function $d1a917d05ac92efc$export$5f80f094fd31fffd(eventMapping) {
    return {
        type: $d1a917d05ac92efc$export$a9319af002a4c677,
        eventMapping: eventMapping
    };
}
function $d1a917d05ac92efc$export$96105f873ade39d7() {
    return {
        type: $d1a917d05ac92efc$export$cb5041d68cb18859
    };
}



var $4mVfk = parcelRequire("4mVfk");

var $kFnE9 = parcelRequire("kFnE9");

var $8DpVo = parcelRequire("8DpVo");

var $4mVfk = parcelRequire("4mVfk");

var $8DpVo = parcelRequire("8DpVo");
var $5258d0c7398e5f78$exports = {};
(function(root, factory) {
    $5258d0c7398e5f78$exports = factory();
})($5258d0c7398e5f78$exports, function() {
    /**
   * @constructor
   */ function UrlTemplate() {}
    /**
   * @private
   * @param {string} str
   * @return {string}
   */ UrlTemplate.prototype.encodeReserved = function(str) {
        return str.split(/(%[0-9A-Fa-f]{2})/g).map(function(part) {
            if (!/%[0-9A-Fa-f]/.test(part)) part = encodeURI(part).replace(/%5B/g, "[").replace(/%5D/g, "]");
            return part;
        }).join("");
    };
    /**
   * @private
   * @param {string} str
   * @return {string}
   */ UrlTemplate.prototype.encodeUnreserved = function(str) {
        return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
            return "%" + c.charCodeAt(0).toString(16).toUpperCase();
        });
    };
    /**
   * @private
   * @param {string} operator
   * @param {string} value
   * @param {string} key
   * @return {string}
   */ UrlTemplate.prototype.encodeValue = function(operator, value, key) {
        value = operator === "+" || operator === "#" ? this.encodeReserved(value) : this.encodeUnreserved(value);
        if (key) return this.encodeUnreserved(key) + "=" + value;
        else return value;
    };
    /**
   * @private
   * @param {*} value
   * @return {boolean}
   */ UrlTemplate.prototype.isDefined = function(value) {
        return value !== undefined && value !== null;
    };
    /**
   * @private
   * @param {string}
   * @return {boolean}
   */ UrlTemplate.prototype.isKeyOperator = function(operator) {
        return operator === ";" || operator === "&" || operator === "?";
    };
    /**
   * @private
   * @param {Object} context
   * @param {string} operator
   * @param {string} key
   * @param {string} modifier
   */ UrlTemplate.prototype.getValues = function(context, operator, key, modifier) {
        var value = context[key], result = [];
        if (this.isDefined(value) && value !== "") {
            if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
                value = value.toString();
                if (modifier && modifier !== "*") value = value.substring(0, parseInt(modifier, 10));
                result.push(this.encodeValue(operator, value, this.isKeyOperator(operator) ? key : null));
            } else if (modifier === "*") {
                if (Array.isArray(value)) value.filter(this.isDefined).forEach(function(value) {
                    result.push(this.encodeValue(operator, value, this.isKeyOperator(operator) ? key : null));
                }, this);
                else Object.keys(value).forEach(function(k) {
                    if (this.isDefined(value[k])) result.push(this.encodeValue(operator, value[k], k));
                }, this);
            } else {
                var tmp = [];
                if (Array.isArray(value)) value.filter(this.isDefined).forEach(function(value) {
                    tmp.push(this.encodeValue(operator, value));
                }, this);
                else Object.keys(value).forEach(function(k) {
                    if (this.isDefined(value[k])) {
                        tmp.push(this.encodeUnreserved(k));
                        tmp.push(this.encodeValue(operator, value[k].toString()));
                    }
                }, this);
                if (this.isKeyOperator(operator)) result.push(this.encodeUnreserved(key) + "=" + tmp.join(","));
                else if (tmp.length !== 0) result.push(tmp.join(","));
            }
        } else {
            if (operator === ";") {
                if (this.isDefined(value)) result.push(this.encodeUnreserved(key));
            } else if (value === "" && (operator === "&" || operator === "?")) result.push(this.encodeUnreserved(key) + "=");
            else if (value === "") result.push("");
        }
        return result;
    };
    /**
   * @param {string} template
   * @return {function(Object):string}
   */ UrlTemplate.prototype.parse = function(template) {
        var that = this;
        var operators = [
            "+",
            "#",
            ".",
            "/",
            ";",
            "?",
            "&"
        ];
        return {
            expand: function(context) {
                return template.replace(/\{([^\{\}]+)\}|([^\{\}]+)/g, function(_, expression, literal) {
                    if (expression) {
                        var operator = null, values = [];
                        if (operators.indexOf(expression.charAt(0)) !== -1) {
                            operator = expression.charAt(0);
                            expression = expression.substr(1);
                        }
                        expression.split(/,/g).forEach(function(variable) {
                            var tmp = /([^:\*]*)(?::(\d+)|(\*))?/.exec(variable);
                            values.push.apply(values, that.getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        });
                        if (operator && operator !== "+") {
                            var separator = ",";
                            if (operator === "?") separator = "&";
                            else if (operator !== "#") separator = operator;
                            return (values.length !== 0 ? operator : "") + values.join(separator);
                        } else return values.join(",");
                    } else return that.encodeReserved(literal);
                });
            }
        };
    };
    return new UrlTemplate();
});



var $kFnE9 = parcelRequire("kFnE9");

var $kFnE9 = parcelRequire("kFnE9");


var $kFnE9 = parcelRequire("kFnE9");
function $2c6aac9c6dcbe44d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2c6aac9c6dcbe44d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2c6aac9c6dcbe44d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2c6aac9c6dcbe44d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2c6aac9c6dcbe44d$var$getCurrentLoggingLevel() {
    return window.choreographerLoggingLevel;
}
function $2c6aac9c6dcbe44d$var$logMessageIfValidLoggingLevel(loggingLevel, data) {
    if ($2c6aac9c6dcbe44d$var$getCurrentLoggingLevel() === loggingLevel) // eslint-disable-next-line no-console
    console.table(data);
}
function $2c6aac9c6dcbe44d$var$traceMessageIfValidLoggingLevel(loggingLevel, productId, messageId, message) {
    if ($2c6aac9c6dcbe44d$var$getCurrentLoggingLevel() === loggingLevel) // eslint-disable-next-line no-console
    console.log(`CHOREOGRAPHER - ${productId} - ${messageId} - ${message}`);
}
class $2c6aac9c6dcbe44d$export$21e6cc849c1dc1ab {
    constructor(productId, messageId){
        /**
     * A function that takes an object of properties for each logging level
     * name, e.g. log.info and log.verbose, which are functions that take an
     * object of any key/value pairs, which will be merged with the productId
     * and the messageId values passed to the constructor, and output via
     * console.table.
     *
     * Example: debugLogger.log({
     *   info: { foo: true },
     *   verbose: {
     *     foo: true,
     *     bar: 123,
     *     baz 'abc',
     *     timestamp: performance.now()
     *   },
     * });
     *
     * @param messages Record<LoggingLevels, Record<string, unknown>> An object
     * keyed by the desired log-level, with each value being an object of any
     * key/value pairs to be output to console.table.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "log", (messages)=>{
            [
                ...Object.keys(messages)
            ].forEach((loggingLevel)=>{
                var _messages;
                $2c6aac9c6dcbe44d$var$logMessageIfValidLoggingLevel(loggingLevel, $2c6aac9c6dcbe44d$var$_objectSpread($2c6aac9c6dcbe44d$var$_objectSpread({
                    productId: this.state.productId,
                    messageId: this.state.messageId
                }, (_messages = messages[loggingLevel]) !== null && _messages !== void 0 ? _messages : {}), loggingLevel === "verbose" ? {
                    timestamp: performance.now()
                } : {}));
            });
        });
        /**
     * A function that takes an object of properties for each logging level
     * name, e.g. trace.info and trace.verbose, which are functions that take
     * a string to be used as the label for a stack trace via console.trace.
     *
     * Example: debugLogger.trace({
     *   info: 'This is a stack trace',
     *   verbose: `This is a stack trace with a much more verbose message which
     * contains data about the ${productId} and ${messageId} within my function,
     * invoked at ${performance.now()}ms`,
     * });
     *
     * @param messages Record<LoggingLevels, string> An object keyed by the
     * desired log-level, with each value being a string to be output as the
     * label to console.trace.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "trace", (messages)=>{
            [
                ...Object.keys(messages)
            ].forEach((loggingLevel)=>{
                $2c6aac9c6dcbe44d$var$traceMessageIfValidLoggingLevel(loggingLevel, this.state.productId, this.state.messageId, `${messages[loggingLevel]}${loggingLevel === "verbose" ? ` (${performance.now()})` : ""}`);
            });
        });
        this.state = {
            productId: productId,
            messageId: messageId
        };
    }
}



var $kFnE9 = parcelRequire("kFnE9");
var $9379780092580c74$var$_ref, $9379780092580c74$var$_process, $9379780092580c74$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $9379780092580c74$var$TESTS_MODE = ($9379780092580c74$var$_ref = (globalThis === null || globalThis === void 0 || ($9379780092580c74$var$_process = globalThis.process) === null || $9379780092580c74$var$_process === void 0 || ($9379780092580c74$var$_process = $9379780092580c74$var$_process.env) === null || $9379780092580c74$var$_process === void 0 ? void 0 : $9379780092580c74$var$_process.JEST_WORKER_ID) !== undefined, $9379780092580c74$var$_ref !== void 0) ? $9379780092580c74$var$_ref : false;
var $9379780092580c74$var$DEBUG_MODE = !$9379780092580c74$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($9379780092580c74$var$_process2 = globalThis.process) === null || $9379780092580c74$var$_process2 === void 0 || ($9379780092580c74$var$_process2 = $9379780092580c74$var$_process2.env) === null || $9379780092580c74$var$_process2 === void 0 ? void 0 : $9379780092580c74$var$_process2.NODE_ENV) !== "production";
var $9379780092580c74$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$9379780092580c74$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $8ovux = parcelRequire("8ovux");
var $b5ba33686b3f9073$var$pkgName = "@atlaskit/platform-feature-flags";
var $b5ba33686b3f9073$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $b5ba33686b3f9073$var$hasProcessEnv = typeof $8ovux !== "undefined" && typeof $8ovux.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $b5ba33686b3f9073$var$ENV_ENABLE_PLATFORM_FF = $b5ba33686b3f9073$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $b5ba33686b3f9073$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $b5ba33686b3f9073$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $b5ba33686b3f9073$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $b5ba33686b3f9073$var$ENV_ENABLE_PLATFORM_FF || $b5ba33686b3f9073$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $b5ba33686b3f9073$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $b5ba33686b3f9073$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$b5ba33686b3f9073$var$globalVar[$b5ba33686b3f9073$export$7e41b1b2bdee3f98] = $b5ba33686b3f9073$var$globalVar[$b5ba33686b3f9073$export$7e41b1b2bdee3f98] || $b5ba33686b3f9073$var$DEFAULT_PFF_GLOBAL;
function $b5ba33686b3f9073$export$f2b591175b3e424c(resolver) {
    $b5ba33686b3f9073$var$globalVar[$b5ba33686b3f9073$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $b5ba33686b3f9073$export$6333b6aff9fc6275(flagKey) {
    if ($b5ba33686b3f9073$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $9379780092580c74$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $b5ba33686b3f9073$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $b5ba33686b3f9073$var$globalVar[$b5ba33686b3f9073$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $70819d069deac9da$export$ba05d765b8392e5e(flagResolver) {
    (0, $b5ba33686b3f9073$export$f2b591175b3e424c)(flagResolver);
}
function $70819d069deac9da$export$470e5c2be1411c89(name) {
    return (0, $b5ba33686b3f9073$export$6333b6aff9fc6275)(name);
}
function $70819d069deac9da$export$b40ec24ac8275656(name) {
    return (0, $b5ba33686b3f9073$export$6333b6aff9fc6275)(name);
}



function $66eec087bbb31d8e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $66eec087bbb31d8e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $66eec087bbb31d8e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $66eec087bbb31d8e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $66eec087bbb31d8e$export$efa9a398d6368992 {
    /**
   * Utility class to simplify and allow for wider use of sending operational event to the Analytics web client for logging/metrics.
   *
   * @param actionSubject A (MessageActions) string denoting either the start or stop phase of a message.
   * @param actionSubjectId Unique messageId to be logged with this even.
   * @param metricsData Additional data from plugin to be sent with event for metrics logging.
   * @param analyticsClient An instance of AnalyticsWebClient, unique to each caller
   */ constructor(actionSubject, actionSubjectId, metricsData, analyticsClient){
        this.state = {
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            metricsData: metricsData,
            analyticsClient: analyticsClient
        };
    }
    /**
   * Send operational event to the Analytics web client for logging/metrics.
   *
   * @param action A (MessageDeliveryStatuses) string denoting the ultimate disposition of this message start or stop request.
   */ sendOperationalEvent(action, additionalAttributes) {
        if ((0, $70819d069deac9da$export$b40ec24ac8275656)("platform.post-office.enable-full-choreographer-logging")) {
            const { analyticsClient: analyticsClient, actionSubject: actionSubject, actionSubjectId: actionSubjectId, metricsData: attributes } = this.state;
            analyticsClient.sendOperationalEvent({
                source: "choreographer",
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                attributes: $66eec087bbb31d8e$var$_objectSpread($66eec087bbb31d8e$var$_objectSpread({}, attributes !== null && attributes !== void 0 ? attributes : {}), additionalAttributes !== null && additionalAttributes !== void 0 ? additionalAttributes : {}),
                tags: [
                    "postOffice"
                ]
            });
        }
    }
    blocked(additionalAttributes) {
        this.sendOperationalEvent((0, $a07e2801589e28b7$export$f6a9504bc1305cf0).BLOCKED, additionalAttributes);
    }
    error(additionalAttributes) {
        this.sendOperationalEvent((0, $a07e2801589e28b7$export$f6a9504bc1305cf0).ERROR, additionalAttributes);
    }
    unregistered(additionalAttributes) {
        this.sendOperationalEvent((0, $a07e2801589e28b7$export$f6a9504bc1305cf0).UNREGISTERED, additionalAttributes);
    }
    started(additionalAttributes) {
        this.sendOperationalEvent((0, $a07e2801589e28b7$export$f6a9504bc1305cf0).STARTED, additionalAttributes);
    }
    stopped(additionalAttributes) {
        this.sendOperationalEvent((0, $a07e2801589e28b7$export$f6a9504bc1305cf0).STOPPED, additionalAttributes);
    }
}


function $0c5ab92473e7ba94$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0c5ab92473e7ba94$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0c5ab92473e7ba94$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0c5ab92473e7ba94$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// This timeout is used for any long-running messages that are either stuck for some reason, or that the user has yet to clear, to ensure that messaging doesn't stay blocked indefinitely
const $0c5ab92473e7ba94$var$CHOREOGRAPHER_MESSAGE_TTL = 300000; // 5 minute TTL for messages
// Lazily instantiate this the first time it's requested
let $0c5ab92473e7ba94$var$singleton;
class $0c5ab92473e7ba94$export$236158f15971c92e {
    /**
   * Static method to create and/or return a singleton of the choreographer API.
   *
   * @returns Shared instance of choreographer API.
   */ static getInstance() {
        if (!$0c5ab92473e7ba94$var$singleton) $0c5ab92473e7ba94$var$singleton = new this();
        return $0c5ab92473e7ba94$var$singleton;
    }
    constructor(){
        this.state = {
            currentMessage: null,
            isDisabled: false,
            messages: new Map(),
            messageQueue: [],
            messageTtl: null,
            plugins: new Map(),
            queueingBehindMessage: null,
            shouldQueueMessages: false
        };
    }
    stopCurrentMessage() {
        if (this.state.currentMessage) this.stopMessageInternal(this.state.currentMessage.productId, this.state.currentMessage.messageId, this.state.currentMessage.analyticsClient, this.state.currentMessage.metricsData, true).then(()=>{
            // Manually clear the message TTL and reenable plugins here just in case the unregistered plugin's message denied the
            // stop request. We may still get a collision on-screen, but we're considering the message forcibly stopped at this
            // point, so need to allow new requests.
            this.clearMessageTtl();
            this.enablePlugins();
        });
    }
    /**
   * Enables the message queue, and logs which message everybody else is queueing up behind.
   *
   * @param productId Unique identifier for the product making the current startMessage request blocking others.
   * @param messageId Unique identifier for the messageId blocking others.
   */ queueMessages(productId, messageId) {
        this.state.shouldQueueMessages = true;
        this.state.queueingBehindMessage = {
            productId: productId,
            messageId: messageId,
            timestamp: Date.now()
        };
    }
    /**
   * Pushes all data associated with a startMessage request onto an internal queue, to potentially be processed at a later time.
   * If a pending message request opts out (or otherwise fails to start), this data will be used to reinitiate the startMessage
   * request for this message request instance. Returns a Promise that the caller can await as normal, and which will eventually
   * either be resolved as 'blocked' if any prior pending message is started, or will be resolved with its eventual outcome when
   * its startMessage request is processed.
   *
   * @param productId Unique identifier for the product making the current startMessage request being queued.
   * @param messageId Unique identifier for the messageId being queued.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param metricsData Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance to prevent from being disabled when this request starts.
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
   */ queueMessage(productId, messageId, analyticsClient, metricsData, plugin) {
        return new Promise((resolve)=>{
            this.state.messageQueue.push({
                productId: productId,
                messageId: messageId,
                analyticsClient: analyticsClient,
                metricsData: metricsData,
                plugin: plugin,
                resolve: resolve
            });
        });
    }
    /**
   * Responsible for pulling a previously queued message request that was received while a message request was already in flight.
   * Shift the first message off the top of the queue, and use the stored resolve function to kickstart another pass through the
   * startMessage function, ultimately resolving with the final disposition of the request. Set the internal state for shouldQueueMessages
   * to false if we're restarting a startMessage request, so that this doesn't get immediately thrown back into the queue. If it
   * makes it through to its start callback being fired, that code will turn the shouldQueueMessages state back on.
   */ processQueuedMessage() {
        const queuedMessage = this.state.messageQueue.shift();
        // Disable the shouldQueueMessages state here. If we have a queued message, it will turn the shouldQueueMessages state back on when it
        // hits the call to its message's startCallback function. Otherwise, the queue is now empty, and we let things process normally.
        this.state.shouldQueueMessages = false;
        // Also null out the queueingBehindMessage value, which will be recreated if/when another message opens the queue below.
        this.state.queueingBehindMessage = null;
        if (queuedMessage) queuedMessage.resolve(this.startMessage(queuedMessage.productId, queuedMessage.messageId, queuedMessage.analyticsClient, queuedMessage.metricsData, queuedMessage.plugin));
    }
    /**
   * Responsible for flushing out any queued messages and resolving their Promises as "blocked". We don't officially consider a
   * message as "blocked" until one of the prior calls has signaled a valid "started" state. This way, any async callbacks that
   * are in flight can allow additional messages to queue up, and if they eventually opt out, we can move on to the next message
   * in the queue and see if it will signal success. Only when we get a successful start to we consider all queued up messages to
   * be "blocked". Run a loop to shift each of them off of the array and resolve them as blocked, until the array is empty.
   */ destroyMessageQueue() {
        this.state.shouldQueueMessages = false;
        this.state.queueingBehindMessage = null;
        while(this.state.messageQueue.length > 0){
            var _this$state$currentMe, _this$state$currentMe2;
            const { analyticsClient: analyticsClient, messageId: messageId, metricsData: metricsData, productId: productId, resolve: resolve } = this.state.messageQueue.shift();
            const attributes = $0c5ab92473e7ba94$var$_objectSpread($0c5ab92473e7ba94$var$_objectSpread({}, metricsData), {}, {
                productId: productId,
                messageId: messageId
            });
            const actionSubject = (0, $a07e2801589e28b7$export$865c0eaaa43d90f8).START;
            const logger = new (0, $66eec087bbb31d8e$export$efa9a398d6368992)(actionSubject, messageId, attributes, analyticsClient);
            const debugLogger = new (0, $2c6aac9c6dcbe44d$export$21e6cc849c1dc1ab)(productId, messageId);
            logger.blocked({
                blockedByProductId: (_this$state$currentMe = this.state.currentMessage) === null || _this$state$currentMe === void 0 ? void 0 : _this$state$currentMe.productId,
                blockedByMessageId: (_this$state$currentMe2 = this.state.currentMessage) === null || _this$state$currentMe2 === void 0 ? void 0 : _this$state$currentMe2.messageId
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $a07e2801589e28b7$export$f6a9504bc1305cf0).BLOCKED
                }
            });
            resolve((0, $a07e2801589e28b7$export$f6a9504bc1305cf0).BLOCKED);
        }
    }
    /**
   * Sets a timeout to auto-expire any messaging that stays open for too long, to prevent messaging from being blocked indefinitely.
   *
   * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
   * @param messageId Unique identifier for the messageId that triggered this message timeout.
   * @param AnalyticsClient The analytics client to be used for logging/metrics.
   * @param metricsData Additional data from plugin to be sent for metrics logging.
   */ setMessageTtl(productId, messageId, analyticsClient, metricsData) {
        this.state.currentMessage = {
            productId: productId,
            messageId: messageId,
            analyticsClient: analyticsClient,
            metricsData: metricsData,
            timestamp: Date.now()
        };
        this.state.messageTtl = setTimeout(()=>{
            if (this.isCurrentMessage(productId, messageId)) this.stopCurrentMessage();
        }, $0c5ab92473e7ba94$var$CHOREOGRAPHER_MESSAGE_TTL);
    }
    /**
   * Checks to see if the requesting productId/messageId pair matches the data for the currently-displayed message.
   *
   * @param productId Unique identifier for the product being checked for a current message match.
   * @param messageId Unique identifier for the messageId being checked for a current message match.
   */ isCurrentMessage(productId, messageId) {
        return Boolean(this.state.currentMessage && this.state.currentMessage.productId === productId && this.state.currentMessage.messageId === messageId);
    }
    /**
   * Returns the currentMessage object.
   */ getCurrentMessage() {
        return this.state.currentMessage;
    }
    /**
   * Returns the queueingBehindMessage object.
   */ getCurrentPendingMessage() {
        return this.state.queueingBehindMessage;
    }
    /**
   * Clears the timeout that was established for the currently-displayed message.
   */ clearMessageTtl() {
        this.state.currentMessage = null;
        if (this.state.messageTtl) clearTimeout(this.state.messageTtl);
    }
    /**
   * Disables all plugins that are currently registered with the choreographer, called when a startMessage call is being dispatched.
   *
   * @param [exceptFor] An optional plugin instance to exclude from the items being disabled, e.g. the plugin responsible for the current startMessage call.
   */ disablePlugins(exceptFor) {
        this.state.isDisabled = true;
        [
            ...this.state.plugins.values()
        ].forEach((p)=>{
            if (p !== exceptFor) p.disable();
        });
    }
    /**
   * Enables all plugins that are currently registered with the choreographer, called when a matching stopMessage call is successful.
   */ enablePlugins() {
        [
            ...this.state.plugins.values()
        ].forEach((p)=>p.enable());
        this.state.isDisabled = false;
    }
    /**
   * A callback used to remove a plugin from the list of subscribers for the choreographer service.
   *
   * @param productId A unique string representing the plugin to be unregistered from the choreographer API.
   */ unregisterPlugin(productId) {
        var _this$state$currentMe3;
        // If we're unregistering this productId's plugin, and the currentMessage is from this productId, we need to stop it to clear the choreographer
        if (((_this$state$currentMe3 = this.state.currentMessage) === null || _this$state$currentMe3 === void 0 ? void 0 : _this$state$currentMe3.productId) === productId) this.stopCurrentMessage();
        this.state.messages.delete(productId);
        this.state.plugins.delete(productId);
    }
    /**
   * Determines whether any message is currently being displayed, by checking its own status and optionally, asking each registered plugin for its individual status.
   *
   * @returns A value reflecting whether a message is currently being displayed on screen.
   */ isDisplayingMessage() {
        return Boolean(this.state.currentMessage || [
            ...this.state.plugins.values()
        ].reduce((isDisplayingMessage, p)=>{
            return isDisplayingMessage || p.isDisplayingMessage();
        }, false));
    }
    /**
   * This function is intended for test cleanup purposes only, *not* to be called by external callers.
   *
   * @ignore
   * @param productId Unique identifier for the product whose messages are being requested
   * @returns A Map of IMessage objects, keyed by unique messageId strings.
   */ getMessages(productId) {
        var _this$state$messages$;
        return (_this$state$messages$ = this.state.messages.get(productId)) !== null && _this$state$messages$ !== void 0 ? _this$state$messages$ : new Map();
    }
    /**
   * Requests to start a message via the choreographer service, ensuring only a single message instance at a time on the screen.
   * A successful request will block any other message attempts until such time as the matching stopMessage request is received,
   * or a message TTL timeout has expired.
   *
   * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
   * @param messageId Unique identifier for the messageId that triggered this message timeout.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param metricsData Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance to prevent from being disabled when this request starts.
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
   */ async startMessage(productId, messageId, analyticsClient, metricsData = {}, plugin) {
        const debugLogger = new (0, $2c6aac9c6dcbe44d$export$21e6cc849c1dc1ab)(productId, messageId);
        const actionSubject = (0, $a07e2801589e28b7$export$865c0eaaa43d90f8).START;
        const requestTimestamp = performance.now();
        debugLogger.log({
            info: {
                phase: actionSubject,
                timestamp: requestTimestamp
            },
            verbose: {
                phase: actionSubject,
                timestamp: requestTimestamp
            }
        });
        const attributes = $0c5ab92473e7ba94$var$_objectSpread($0c5ab92473e7ba94$var$_objectSpread({}, metricsData), {}, {
            productId: productId,
            messageId: messageId
        });
        const logger = new (0, $66eec087bbb31d8e$export$efa9a398d6368992)(actionSubject, messageId, attributes, analyticsClient);
        try {
            var _await$message$start, _message$start;
            if (!this.hasMessageRecord(productId, messageId)) {
                // Bail early here, before even checking if we're in a queueing situation, or blocked, or anything else
                logger.unregistered();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $a07e2801589e28b7$export$f6a9504bc1305cf0).UNREGISTERED
                    }
                });
                return (0, $a07e2801589e28b7$export$f6a9504bc1305cf0).UNREGISTERED;
            }
            // If we're currently queueing messages, push this one onto the queue and return the new Promise
            if (this.state.shouldQueueMessages) {
                var _this$state$queueingB, _this$state$queueingB2;
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: `queued behind ${(_this$state$queueingB = this.state.queueingBehindMessage) === null || _this$state$queueingB === void 0 ? void 0 : _this$state$queueingB.productId} ${(_this$state$queueingB2 = this.state.queueingBehindMessage) === null || _this$state$queueingB2 === void 0 ? void 0 : _this$state$queueingB2.messageId}`
                    }
                });
                return this.queueMessage(productId, messageId, analyticsClient, metricsData, plugin);
            }
            if (this.state.isDisabled || this.isDisplayingMessage()) {
                var _this$state$currentMe4, _this$state$currentMe5;
                logger.blocked({
                    blockedByProductId: (_this$state$currentMe4 = this.state.currentMessage) === null || _this$state$currentMe4 === void 0 ? void 0 : _this$state$currentMe4.productId,
                    blockedByMessageId: (_this$state$currentMe5 = this.state.currentMessage) === null || _this$state$currentMe5 === void 0 ? void 0 : _this$state$currentMe5.messageId
                });
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $a07e2801589e28b7$export$f6a9504bc1305cf0).BLOCKED
                    }
                });
                return (0, $a07e2801589e28b7$export$f6a9504bc1305cf0).BLOCKED;
            }
            const message = this.ensureMessageRecord(productId, messageId);
            this.queueMessages(productId, messageId);
            const didStart = (_await$message$start = await ((_message$start = message.start) === null || _message$start === void 0 ? void 0 : _message$start.call(message))) !== null && _await$message$start !== void 0 ? _await$message$start : true;
            if (didStart) {
                var _message$onStart;
                // Fire the onStart callback, if provided, to handle any post-start concerns for the consumer
                (_message$onStart = message.onStart) === null || _message$onStart === void 0 || _message$onStart.call(message);
                logger.started();
                this.disablePlugins(plugin);
                this.setMessageTtl(productId, messageId, analyticsClient, metricsData);
                // Successfully started the message, flush the queue and mark any pending requests as "blocked"
                this.destroyMessageQueue();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $a07e2801589e28b7$export$f6a9504bc1305cf0).STARTED
                    }
                });
                return (0, $a07e2801589e28b7$export$f6a9504bc1305cf0).STARTED;
            }
            // Check to see if we have any pending requests in the message queue and attempt to start the next one in line
            this.processQueuedMessage();
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $a07e2801589e28b7$export$f6a9504bc1305cf0).CANCELED
                }
            });
            return (0, $a07e2801589e28b7$export$f6a9504bc1305cf0).CANCELED;
        } catch (error) {
            const e = error;
            logger.error({
                reason: e.message
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $a07e2801589e28b7$export$f6a9504bc1305cf0).ERROR
                }
            });
            return (0, $a07e2801589e28b7$export$f6a9504bc1305cf0).ERROR;
        }
    }
    /**
   * Requests to stop a message via the choreographer service. A successful request will allow any other plugins to begin issuing startMessage requests again.
   * This version of the stopMessage function is private, and only intended to be called internally, so that it can make use of the forceStop parameter without exposing that to external callers.
   *
   * @param productId Unique identifier for the product making the current stopMessage request.
   * @param messageId Unique identifier for the messageId to be stopped.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param metricsData Additional data from plugin to be sent for metrics logging.
   * @param forceStop A boolean to denote whether to forcefully clear the Choreographer's blocked state (used for TTL expiration and unregistering a plugin).
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
   */ async stopMessageInternal(productId, messageId, analyticsClient, metricsData = {}, forceStop = false) {
        const debugLogger = new (0, $2c6aac9c6dcbe44d$export$21e6cc849c1dc1ab)(productId, messageId);
        const actionSubject = (0, $a07e2801589e28b7$export$865c0eaaa43d90f8).STOP;
        const requestTimestamp = performance.now();
        debugLogger.log({
            info: {
                phase: actionSubject,
                timestamp: requestTimestamp
            },
            verbose: {
                phase: actionSubject,
                timestamp: requestTimestamp
            }
        });
        const attributes = $0c5ab92473e7ba94$var$_objectSpread($0c5ab92473e7ba94$var$_objectSpread({}, metricsData), {}, {
            productId: productId,
            messageId: messageId
        });
        const logger = new (0, $66eec087bbb31d8e$export$efa9a398d6368992)(actionSubject, messageId, attributes, analyticsClient);
        try {
            var _await$message$stop, _message$stop;
            if (!this.hasMessageRecord(productId, messageId)) {
                logger.unregistered();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $a07e2801589e28b7$export$f6a9504bc1305cf0).UNREGISTERED
                    }
                });
                return (0, $a07e2801589e28b7$export$f6a9504bc1305cf0).UNREGISTERED;
            }
            const message = this.ensureMessageRecord(productId, messageId);
            // Enable the message queue *if* the current stopMessage request matches the currentMessage data.
            // Any incoming startMessage requests will be queued while this stopMessage request is in-flight,
            // so that they can be immediately honored if this request comes back successfully.
            if (this.isCurrentMessage(productId, messageId)) this.queueMessages(productId, messageId);
            const didStop = (_await$message$stop = await ((_message$stop = message.stop) === null || _message$stop === void 0 ? void 0 : _message$stop.call(message))) !== null && _await$message$stop !== void 0 ? _await$message$stop : true;
            // If we're hitting this from stopCurrentMessage, it means either a TTL has expired, or we're
            // unregistering a plugin. We forceStop the choreographer blocked state here, even if the stop
            // callback returned false.We don't want to block the UI indefinitely, we'll just have to risk
            // 1 additional message collision if the current message's stop callback refuses to clear.
            if (didStop || forceStop) {
                if (this.isCurrentMessage(productId, messageId)) {
                    var _message$onStop;
                    // Fire the onStop callback, if provided, to handle any post-stop concerns for the consumer
                    (_message$onStop = message.onStop) === null || _message$onStop === void 0 || _message$onStop.call(message);
                    // Only log this even if we're stopping the current message, so we have a 1:1 mapping of starts to stops.
                    // If this is a forced stop, log that in the attributes, so we can track those events specifically.
                    // Also log the value of didStop, so we know if this was a rejected stop attempt that *had* to be force stopped.
                    logger.stopped(forceStop ? {
                        forceStop: forceStop,
                        didStop: didStop
                    } : undefined);
                    // Only clear the message TTL and reenable plugins if we're stopping the *current* message
                    this.clearMessageTtl();
                    this.enablePlugins();
                }
                // Check to see if we have any pending requests in the message queue and attempt to start them
                this.processQueuedMessage();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $a07e2801589e28b7$export$f6a9504bc1305cf0).STOPPED
                    }
                });
                return (0, $a07e2801589e28b7$export$f6a9504bc1305cf0).STOPPED;
            }
            // Stopping the message failed, so the UI is still intentionally blocked, flush the queue and mark any pending requests as "blocked"
            this.destroyMessageQueue();
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $a07e2801589e28b7$export$f6a9504bc1305cf0).CANCELED
                }
            });
            return (0, $a07e2801589e28b7$export$f6a9504bc1305cf0).CANCELED;
        } catch (error) {
            const e = error;
            logger.error({
                reason: e.message
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $a07e2801589e28b7$export$f6a9504bc1305cf0).ERROR
                }
            });
            return (0, $a07e2801589e28b7$export$f6a9504bc1305cf0).ERROR;
        }
    }
    /**
   * Requests to stop a message via the choreographer service. A successful request will allow any other plugins to begin issuing startMessage requests again.
   *
   * @param productId Unique identifier for the product making the current stopMessage request.
   * @param messageId Unique identifier for the messageId to be stopped.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param metricsData Additional data from plugin to be sent for metrics logging.
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
   */ async stopMessage(productId, messageId, analyticsClient, metricsData = {}) {
        return this.stopMessageInternal(productId, messageId, analyticsClient, metricsData);
    }
    /**
   * Registers a plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
   *
   * @param productId Unique identifier to register as the product owner of this plugin.
   * @param plugin A plugin instance to be registered with the choreographer instance.
   * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
   */ registerPlugin(productId, plugin) {
        if (this.state.plugins.has(productId)) throw new Error(`Choreographer plugin already registered for ${productId}!`);
        this.state.plugins = this.state.plugins.set(productId, plugin);
        if (this.state.isDisabled) plugin.disable();
        return ()=>{
            this.unregisterPlugin(productId);
        };
    }
    /**
   * Validates that a message record is present and ready to be retrieved and/or manipulated.
   * Creates the message instance if it doesn't yet exist, initializing both start and stop callbacks to noop functions.
   *
   * @param productId Unique identifier to retrieve map of IMessage objects.
   * @param messageId Unique identifier for the messageId to be retrieved.
   * @returns IMessage object for the requested productId/messageId combination.
   */ ensureMessageRecord(productId, messageId) {
        let productMessages = this.state.messages.get(productId);
        if (!productMessages) {
            productMessages = new Map();
            this.state.messages.set(productId, productMessages);
        }
        let message = productMessages.get(messageId);
        if (!message) {
            message = {};
            productMessages.set(messageId, message);
        }
        return message;
    }
    /**
   * Checks for the existance of a message record for a given productId/messageId combination.
   *
   * @param productId Unique identifier to check for a map of IMessage objects.
   * @param messageId Unique identifier to check for within the map of productId IMessage objects.
   * @returns Boolean indicating whether or not an IMessage record exists for the requested productId/messageId combination.
   */ hasMessageRecord(productId, messageId) {
        var _this$state$messages$2, _this$state$messages$3;
        return Boolean((_this$state$messages$2 = this.state.messages.get(productId)) === null || _this$state$messages$2 === void 0 || (_this$state$messages$3 = _this$state$messages$2.has) === null || _this$state$messages$3 === void 0 ? void 0 : _this$state$messages$3.call(_this$state$messages$2, messageId));
    }
    /**
   * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for this message subscription.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
   * @param options An object containing optional start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
   * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
   */ on(productId, messageId, options = {}, finalizers = {}) {
        const message = $0c5ab92473e7ba94$var$_objectSpread($0c5ab92473e7ba94$var$_objectSpread($0c5ab92473e7ba94$var$_objectSpread({}, this.ensureMessageRecord(productId, messageId)), options), finalizers);
        this.state.messages.get(productId).set(messageId, message);
    }
    /**
   * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for this message subscription.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
   * @param startCallback A callback to be invoked upon successful requests to startMessage.
   * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
   */ onStart(productId, messageId, startCallback, finalizers) {
        this.on(productId, messageId, {
            start: startCallback
        }, finalizers);
    }
    /**
   * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for this message subscription.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
   * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
   * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
   */ onStop(productId, messageId, stopCallback, finalizers = {}) {
        this.on(productId, messageId, {
            stop: stopCallback
        }, finalizers);
    }
    /**
   * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for unsubscribing this message.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for unsubscribing this message.
   */ off(productId, messageId) {
        var _this$state$messages$4, _this$state$messages$5;
        (_this$state$messages$4 = this.state.messages.get(productId)) === null || _this$state$messages$4 === void 0 || (_this$state$messages$5 = _this$state$messages$4.delete) === null || _this$state$messages$5 === void 0 || _this$state$messages$5.call(_this$state$messages$4, messageId);
    }
}






var $kFnE9 = parcelRequire("kFnE9");

var $gJmMp = parcelRequire("gJmMp");
var $7xQTz = parcelRequire("7xQTz");

function $9a71062b918fe9f5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9a71062b918fe9f5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9a71062b918fe9f5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9a71062b918fe9f5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $9a71062b918fe9f5$export$71324a662782c710 {
    /**
   * Instantiates a plugin to be used with the main choreographer API. Requires a productId string
   * to be used for segmenting registered messageIds in other parts of the API, which ensures uniqueness
   * between individual products for tracking purposes.
   *
   * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
   * @param env The environment type for the product, to be used for analytics events.
   * @param metaMetricsData An object containing additional metadata to be sent along with every message request.
   * @returns A new instance of this plugin to use for integrating a 1P or 3P product with the choreographer API.
   */ constructor(productId, env, metaMetricsData = {}){
        this.state = {
            isDisabled: false,
            isDisplayingMessage: false,
            metaMetricsData: metaMetricsData,
            productId: productId,
            unregisterPlugin: ()=>{}
        };
        this.analyticsClient = this.createAnalyticsClient(env);
        /**
     * These finalizers are callbacks to be invoked after a valid start or stop request in the Choreographer core.
     * Declaring them in the constructor because it's the same onStart/onStop pair that will be passed ot all of the
     * .on, .onStart, and .onStop function registrations.
     *
     * This behavior used to be managed by a decorator function that would auto-set the isDisplayingMessage value
     * whenever its start or stop callbacks were invoked. However, those start and stop callbacks are optional from
     * this layer, so if a consumer did *not* register a stop callback, the display state would never be cleared here
     * in the plugin, and would continue blocking messages.
     *
     * We're now passing these onStart and onStop callbacks as part of the message registration, so that any time a
     * message is started or stopped at the core layer, we can fire these callbacks to update the plugin's local state,
     * whether or not an actual start or stop callback was registered by the consumer.
     */ this.finalizers = {
            onStart: ()=>this.blockDisplayState(),
            onStop: ()=>this.clearDisplayState()
        };
        this.state.unregisterPlugin = this.registerPlugin(productId);
    }
    /**
   * Public method to clean up this plugin instance, which will handle unregistering it from the choreographer API.
   */ destroy() {
        this.state.unregisterPlugin();
    }
    /**
   * Determines whether this plugin is currently displaying a message on the screen. By default, is a simple boolean
   * toggle that gets flipped back and forth, but it could also be a function that checks the DOM for a given message
   * container to be present, or checks with some external API to tell it whether a message is being displayed, or
   * anything else. The logic is up to the consumer to implement, if something custom is desired.
   *
   * @returns A boolean that represents whether this plugin is currently displaying a message on the screen.
   */ isDisplayingMessage() {
        return this.state.isDisplayingMessage;
    }
    /**
   * Sets the internal isDisplayingMessage state to true, to denote that this plugin is currently blocking the UI.
   */ blockDisplayState() {
        this.state.isDisplayingMessage = true;
    }
    /**
   * Sets the internal isDisplayingMessage state to false, to denote that this plugin is no longer blocking the UI.
   */ clearDisplayState() {
        this.state.isDisplayingMessage = false;
    }
    /**
   * Disables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
   * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
   * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
   */ disable() {
        this.state.isDisabled = true;
    }
    /**
   * Enables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
   * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
   * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
   */ enable() {
        this.state.isDisabled = false;
    }
    /**
   * Makes a request to start a message through the choreographer API. Will immediately return false if this plugin
   * is currently in a disabled state, and will otherwise return the ultimate result of the startMessage request.
   *
   * @param messageId The messageId for the message to be started through the choreographer API.
   * @param additionalData An object containing additional metadata to be sent along with the message start request
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
   */ async startMessage(messageId, additionalData = {}) {
        return (0, $0c5ab92473e7ba94$export$236158f15971c92e).getInstance().startMessage(this.state.productId, messageId, this.analyticsClient, $9a71062b918fe9f5$var$_objectSpread($9a71062b918fe9f5$var$_objectSpread({}, this.state.metaMetricsData), additionalData), this);
    }
    /**
   * Makes a request to stop a message through the choreographer API. Will return the ultimate result of the stopMessage request.
   *
   * @param messageId The messageId for the message to be stopped through the choreographer API.
   * @param additionalData An object containing additional metadata to be sent along with the message stop request
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
   */ async stopMessage(messageId, additionalData = {}) {
        return (0, $0c5ab92473e7ba94$export$236158f15971c92e).getInstance().stopMessage(this.state.productId, messageId, this.analyticsClient, $9a71062b918fe9f5$var$_objectSpread($9a71062b918fe9f5$var$_objectSpread({}, this.state.metaMetricsData), additionalData));
    }
    /**
   * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
   * @param options An object containing start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
   */ on(messageId, options = {}) {
        return (0, $0c5ab92473e7ba94$export$236158f15971c92e).getInstance().on(this.state.productId, messageId, options, this.finalizers);
    }
    /**
   * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
   * @param startCallback A callback to be invoked upon successful requests to startMessage.
   */ onStart(messageId, startCallback) {
        return (0, $0c5ab92473e7ba94$export$236158f15971c92e).getInstance().onStart(this.state.productId, messageId, startCallback, this.finalizers);
    }
    /**
   * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
   * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
   */ onStop(messageId, stopCallback) {
        return (0, $0c5ab92473e7ba94$export$236158f15971c92e).getInstance().onStop(this.state.productId, messageId, stopCallback, this.finalizers);
    }
    /**
   * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for unsubscribing this message subscription.
   */ off(messageId) {
        return (0, $0c5ab92473e7ba94$export$236158f15971c92e).getInstance().off(this.state.productId, messageId);
    }
    /**
   * Registers this plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
   *
   * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
   * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
   */ registerPlugin(productId) {
        return (0, $0c5ab92473e7ba94$export$236158f15971c92e).getInstance().registerPlugin(productId, this);
    }
    /**
   * Creates a new instance of the Analytics Web Client for a plugin to use for sending analytics events.
   *
   * @param env environment type used to create the analytics client
   * @returns AnalyticsWebClient instance
   */ createAnalyticsClient(env) {
        const analyticsClient = new (0, $gJmMp.default)({
            env: env,
            product: "postOffice",
            origin: (0, $7xQTz.originType).WEB
        });
        return analyticsClient;
    }
}


function $2ed114fd6cc4de46$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2ed114fd6cc4de46$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2ed114fd6cc4de46$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2ed114fd6cc4de46$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $2ed114fd6cc4de46$export$da23bd36e2d631b extends (0, $9a71062b918fe9f5$export$71324a662782c710) {
    constructor(env, metaMetricsData = {}){
        super((0, $a07e2801589e28b7$export$7fb117db98868be6).ENGAGEKIT, env, metaMetricsData);
    }
    isValidDuplicateStartRequest(messageId) {
        var _Choreographer$getIns;
        const currentMessage = (_Choreographer$getIns = (0, $0c5ab92473e7ba94$export$236158f15971c92e).getInstance().getCurrentMessage()) !== null && _Choreographer$getIns !== void 0 ? _Choreographer$getIns : (0, $0c5ab92473e7ba94$export$236158f15971c92e).getInstance().getCurrentPendingMessage();
        return Boolean(currentMessage && currentMessage.productId === this.state.productId && currentMessage.messageId === messageId && Date.now() - currentMessage.timestamp < 100);
    }
    async startMessageWithPlugin(messageId, callback, additionalData = {}) {
        const debugLogger = new (0, $2c6aac9c6dcbe44d$export$21e6cc849c1dc1ab)(this.state.productId, messageId);
        const actionSubject = (0, $a07e2801589e28b7$export$865c0eaaa43d90f8).START;
        debugLogger.trace({
            verbose: `EngagekitChoreographerPlugin::startMessageWithPlugin`
        });
        /**
     * The Choreographer sets a 5m TTL for any message that opens, before forcefully closing it.
     * EP also allows a messageId to re-request its start if it hasn't yet been dismissed (this is a
     * feature of HISI. For this reason, we can mimic that functionality here (otherwise, Choreographer
     * will block the subsequest start request attempt altogether), by checking the Choreographer's
     * currentMessage against our productId/messageId combo here. If this *is* the currentMessage being
     * displayed, it means it hasn't been dismissed, and we let the request dispatch for EP to make the call.
     */ const isValidDuplicateStartRequest = this.isValidDuplicateStartRequest(messageId);
        if (isValidDuplicateStartRequest) {
            const logger = new (0, $66eec087bbb31d8e$export$efa9a398d6368992)(actionSubject, messageId, $2ed114fd6cc4de46$var$_objectSpread($2ed114fd6cc4de46$var$_objectSpread({}, this.state.metaMetricsData), additionalData), this.analyticsClient);
            const didStart = Boolean(await callback());
            if (didStart) {
                logger.started();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        plugin: this.constructor.name,
                        disposition: (0, $a07e2801589e28b7$export$f6a9504bc1305cf0).STARTED,
                        timestamp: performance.now()
                    }
                });
            }
            return didStart;
        }
        // Do a just-in-time message start subscription with our callback to stargate
        this.onStart(messageId, callback);
        /**
     * Dispatch the request to start the message, and return the response, which will
     * either be 'started' if successful, and anything else if unsuccessful. Convert
     * that value with a boolean check, because the consumer only cares about true/false.
     */ const result = await this.startMessage(messageId, additionalData);
        return result === (0, $a07e2801589e28b7$export$f6a9504bc1305cf0).STARTED;
    }
    async stopMessageWithPlugin(messageId, callback, additionalData = {}) {
        const debugLogger = new (0, $2c6aac9c6dcbe44d$export$21e6cc849c1dc1ab)(this.state.productId, messageId);
        debugLogger.trace({
            verbose: `EngagekitChoreographerPlugin::stopMessageWithPlugin`
        });
        // Do a just-in-time message stop subscription with our callback to stargate
        this.onStop(messageId, callback);
        /**
     * Dispatch the request to stop the message, and return the response, which will
     * either be 'stopped' if successful, and anything else if unsuccessful. Convert
     * that value with a boolean check, because the consumer only cares about true/false.
     */ const result = await this.stopMessage(messageId, additionalData);
        return result === (0, $a07e2801589e28b7$export$f6a9504bc1305cf0).STOPPED;
    }
}


var $f0fef4f0d69712c2$export$3288b14b6745c572 = 204;
var $f0fef4f0d69712c2$export$c09e7ea0fc79f34f = 409;
var $f0fef4f0d69712c2$export$974c37534b0191b1 = 503;



var $kFnE9 = parcelRequire("kFnE9");

var $4mVfk = parcelRequire("4mVfk");

var $8DpVo = parcelRequire("8DpVo");

var $de505ac6a0f71ab0$export$2e2bcd8739ae039 = [
    // Bitbucket Pipelines domains (is an iframe and require CORS)
    "bitbucket-pipelines.dev.public.atl-paas.net",
    "bitbucket-pipelines.staging.public.atl-paas.net",
    "bitbucket-pipelines.prod.public.atl-paas.net"
];


function $e215735b489502b1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e215735b489502b1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e215735b489502b1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e215735b489502b1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e215735b489502b1$export$3410cacbbaf2b385 = 60;
function $e215735b489502b1$export$4adbd37839ed7718(_x) {
    return $e215735b489502b1$var$_errorIfNotOk.apply(this, arguments);
}
function $e215735b489502b1$var$_errorIfNotOk() {
    $e215735b489502b1$var$_errorIfNotOk = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee(response) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (response.ok) {
                        _context.next = 8;
                        break;
                    }
                    _context.t0 = Error;
                    _context.t1 = "".concat(response.status, ": ");
                    _context.next = 5;
                    return response.text();
                case 5:
                    _context.t2 = _context.sent;
                    _context.t3 = _context.t1.concat.call(_context.t1, _context.t2);
                    throw (0, _context.t0)(_context.t3);
                case 8:
                    return _context.abrupt("return", response);
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $e215735b489502b1$var$_errorIfNotOk.apply(this, arguments);
}
function $e215735b489502b1$export$2ba4cde277adb6b1(_x2) {
    return $e215735b489502b1$var$_pullResponseTextIfNotOk.apply(this, arguments);
}
function $e215735b489502b1$var$_pullResponseTextIfNotOk() {
    $e215735b489502b1$var$_pullResponseTextIfNotOk = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee2(response) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if (response.ok) {
                        _context2.next = 3;
                        break;
                    }
                    _context2.next = 3;
                    return response.text();
                case 3:
                    return _context2.abrupt("return", response);
                case 4:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $e215735b489502b1$var$_pullResponseTextIfNotOk.apply(this, arguments);
}
function $e215735b489502b1$var$basicStargateRetryCondition(response) {
    var failureCategory = response.headers.get("X-Failure-Category");
    var failureCategoryIsThrottled = !!failureCategory && failureCategory.toLowerCase() === "throttled";
    return response.status === (0, $f0fef4f0d69712c2$export$974c37534b0191b1) && failureCategoryIsThrottled;
}
function $e215735b489502b1$export$317bcea84a3bea48(input, reqOptions) {
    var retryCondition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $e215735b489502b1$var$basicStargateRetryCondition;
    return $e215735b489502b1$var$fetchWithRetry(input, retryCondition, $e215735b489502b1$export$d63a365100d81d24(reqOptions));
}
function $e215735b489502b1$export$2d9a5db60a4c50cd(input, reqOptions) {
    return $e215735b489502b1$export$317bcea84a3bea48(input, reqOptions, function(response) {
        return response.status >= 500 && response.status <= 599;
    });
}
function $e215735b489502b1$export$d63a365100d81d24(reqOptions) {
    return $e215735b489502b1$var$_objectSpread($e215735b489502b1$var$_objectSpread({}, reqOptions), {}, {
        credentials: (0, $de505ac6a0f71ab0$export$2e2bcd8739ae039).includes(location.host) ? "include" : "same-origin"
    });
}
function $e215735b489502b1$var$handleFetchResultAndRetryIfNeeded(fetchResult, retryCondition, retry) {
    return fetchResult.then(function(r) {
        return retryCondition(r) ? retry() : Promise.resolve(r);
    }).catch(retry);
}
function $e215735b489502b1$var$fetchWithRetry(input, retryCondition, reqOptions) {
    return $e215735b489502b1$var$handleFetchResultAndRetryIfNeeded(fetch(input, reqOptions), retryCondition, function() {
        return $e215735b489502b1$var$retryFetchWithBackoff(input, retryCondition, reqOptions);
    });
}
function $e215735b489502b1$var$retryFetchWithBackoff(input, retryCondition, reqOptions) {
    var waitTimeMinutes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    return $e215735b489502b1$var$handleFetchResultAndRetryIfNeeded($e215735b489502b1$var$fetchAfter(input, waitTimeMinutes, reqOptions), retryCondition, function() {
        return $e215735b489502b1$var$retryFetchWithBackoff(input, retryCondition, reqOptions, Math.min(waitTimeMinutes === 0 ? 1 : waitTimeMinutes * 2, $e215735b489502b1$export$3410cacbbaf2b385));
    });
}
var $e215735b489502b1$export$1e8d24b3235d31db = 5000;
function $e215735b489502b1$var$fetchAfter(input, waitTimeMinutes, reqOptions) {
    var staggerDelay = Math.round(Math.random() * $e215735b489502b1$export$1e8d24b3235d31db);
    var delay = waitTimeMinutes ? waitTimeMinutes * 60000 + staggerDelay : 0;
    return new Promise(function(resolve, reject) {
        setTimeout(function() {
            fetch(input, reqOptions).then(resolve).catch(reject);
        }, delay);
    });
}


var $12add2565ec0488f$export$f4d1b02d312560f5 = "2";
var $12add2565ec0488f$var$inProductMessagesUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($5258d0c7398e5f78$exports))).parse("/engage-targeting/api/v2/user/{cloudId}/in-product-messages{?product,schema,locale}");
function $12add2565ec0488f$export$8c20ab16ac9cf14f(_x, _x2, _x3, _x4) {
    return $12add2565ec0488f$var$_getMessages.apply(this, arguments);
}
function $12add2565ec0488f$var$_getMessages() {
    $12add2565ec0488f$var$_getMessages = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee(cloudId, stargateUrl, product, locale) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", (0, $e215735b489502b1$export$2d9a5db60a4c50cd)("".concat(stargateUrl).concat($12add2565ec0488f$var$inProductMessagesUrlTemplate.expand({
                        cloudId: cloudId,
                        product: product,
                        schema: $12add2565ec0488f$export$f4d1b02d312560f5,
                        locale: locale
                    }))).then((0, $e215735b489502b1$export$4adbd37839ed7718)).then(function(r) {
                        return r.json().then(function(messages) {
                            return {
                                messages: messages,
                                interval: Number.parseFloat(r.headers.get("POLL-INTERVAL") || "0")
                            };
                        });
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $12add2565ec0488f$var$_getMessages.apply(this, arguments);
}
function $12add2565ec0488f$var$handleStartStopMessageResponse(response) {
    return response.status === (0, $f0fef4f0d69712c2$export$3288b14b6745c572);
}
var $12add2565ec0488f$var$startMessageUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($5258d0c7398e5f78$exports))).parse("/engage-targeting/api/v2/user/messages/{messageId}/start");
var $12add2565ec0488f$var$startMessageWithVariationIdUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($5258d0c7398e5f78$exports))).parse("/engage-targeting/api/v2/user/messages/{messageId}/start/{variationId}");
var $12add2565ec0488f$var$stopMessageUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($5258d0c7398e5f78$exports))).parse("/engage-targeting/api/v2/user/messages/{messageId}/stop");
var $12add2565ec0488f$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
// Initialize the choreographer plugin on module load
// const choreographerPlugin = new EngagekitChoreographerPlugin();
var $12add2565ec0488f$var$choreographerPlugin;
function $12add2565ec0488f$export$7a77c9a7b182680b(_x5, _x6) {
    return $12add2565ec0488f$var$_startMessage.apply(this, arguments);
}
function $12add2565ec0488f$var$_startMessage() {
    $12add2565ec0488f$var$_startMessage = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee2(startMessageConfig, options) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if (!(options !== null && options !== void 0 && options.enableChoreographer)) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return", $12add2565ec0488f$var$startMessageWithChoreographer(startMessageConfig, options));
                case 2:
                    return _context2.abrupt("return", $12add2565ec0488f$var$startMessageWithCoordination(startMessageConfig));
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $12add2565ec0488f$var$_startMessage.apply(this, arguments);
}
function $12add2565ec0488f$export$159ff839f1f095d2(_x7, _x8) {
    return $12add2565ec0488f$var$_stopMessage.apply(this, arguments);
}
function $12add2565ec0488f$var$_stopMessage() {
    $12add2565ec0488f$var$_stopMessage = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee3(stopMessageConfig, options) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    if (!(options !== null && options !== void 0 && options.enableChoreographer)) {
                        _context3.next = 2;
                        break;
                    }
                    return _context3.abrupt("return", $12add2565ec0488f$var$stopMessageWithChoreographer(stopMessageConfig, options));
                case 2:
                    return _context3.abrupt("return", $12add2565ec0488f$var$stopMessageWithCoordination(stopMessageConfig));
                case 3:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return $12add2565ec0488f$var$_stopMessage.apply(this, arguments);
}
function $12add2565ec0488f$var$startMessageWithChoreographer(_x9, _x10) {
    return $12add2565ec0488f$var$_startMessageWithChoreographer.apply(this, arguments);
}
function $12add2565ec0488f$var$_startMessageWithChoreographer() {
    $12add2565ec0488f$var$_startMessageWithChoreographer = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee4(startMessageConfig, options) {
        var _options$envType;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    if (!$12add2565ec0488f$var$choreographerPlugin) $12add2565ec0488f$var$choreographerPlugin = new (0, $2ed114fd6cc4de46$export$da23bd36e2d631b)((_options$envType = options.envType) !== null && _options$envType !== void 0 ? _options$envType : $12add2565ec0488f$export$56ac8ebc9870b1b9.LOCAL);
                    return _context4.abrupt("return", $12add2565ec0488f$var$choreographerPlugin.startMessageWithPlugin(startMessageConfig.messageId, function() {
                        return $12add2565ec0488f$var$startMessageWithCoordination(startMessageConfig, true);
                    }, options.additionalData));
                case 2:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return $12add2565ec0488f$var$_startMessageWithChoreographer.apply(this, arguments);
}
function $12add2565ec0488f$var$stopMessageWithChoreographer(_x11, _x12) {
    return $12add2565ec0488f$var$_stopMessageWithChoreographer.apply(this, arguments);
}
function $12add2565ec0488f$var$_stopMessageWithChoreographer() {
    $12add2565ec0488f$var$_stopMessageWithChoreographer = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee5(stopMessageConfig, options) {
        var _options$envType2;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee5$(_context5) {
            while(true)switch(_context5.prev = _context5.next){
                case 0:
                    if (!$12add2565ec0488f$var$choreographerPlugin) $12add2565ec0488f$var$choreographerPlugin = new (0, $2ed114fd6cc4de46$export$da23bd36e2d631b)((_options$envType2 = options.envType) !== null && _options$envType2 !== void 0 ? _options$envType2 : $12add2565ec0488f$export$56ac8ebc9870b1b9.LOCAL);
                    return _context5.abrupt("return", $12add2565ec0488f$var$choreographerPlugin.stopMessageWithPlugin(stopMessageConfig.messageId, function() {
                        return $12add2565ec0488f$var$stopMessageWithCoordination(stopMessageConfig, true);
                    }, options.additionalData));
                case 2:
                case "end":
                    return _context5.stop();
            }
        }, _callee5);
    }));
    return $12add2565ec0488f$var$_stopMessageWithChoreographer.apply(this, arguments);
}
function $12add2565ec0488f$var$startMessageWithCoordination(_x13) {
    return $12add2565ec0488f$var$_startMessageWithCoordination.apply(this, arguments);
}
function $12add2565ec0488f$var$_startMessageWithCoordination() {
    $12add2565ec0488f$var$_startMessageWithCoordination = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee6(startMessageConfig) {
        var choreographerEnabled, requestBody, _args6 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee6$(_context6) {
            while(true)switch(_context6.prev = _context6.next){
                case 0:
                    choreographerEnabled = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : false;
                    requestBody = {
                        cloudId: startMessageConfig.cloudId,
                        orgId: startMessageConfig.orgId,
                        workspaceId: startMessageConfig.workspaceId,
                        choreographerEnabled: choreographerEnabled
                    };
                    return _context6.abrupt("return", (0, $e215735b489502b1$export$2d9a5db60a4c50cd)(startMessageConfig.variationId ? "".concat(startMessageConfig.stargateUrl).concat($12add2565ec0488f$var$startMessageWithVariationIdUrlTemplate.expand({
                        messageId: startMessageConfig.messageId,
                        variationId: startMessageConfig.variationId
                    })) : "".concat(startMessageConfig.stargateUrl).concat($12add2565ec0488f$var$startMessageUrlTemplate.expand({
                        messageId: startMessageConfig.messageId
                    })), {
                        method: "post",
                        body: JSON.stringify(requestBody),
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }).then((0, $e215735b489502b1$export$2ba4cde277adb6b1)).then($12add2565ec0488f$var$handleStartStopMessageResponse));
                case 3:
                case "end":
                    return _context6.stop();
            }
        }, _callee6);
    }));
    return $12add2565ec0488f$var$_startMessageWithCoordination.apply(this, arguments);
}
function $12add2565ec0488f$var$stopMessageWithCoordination(_x14) {
    return $12add2565ec0488f$var$_stopMessageWithCoordination.apply(this, arguments);
}
function $12add2565ec0488f$var$_stopMessageWithCoordination() {
    $12add2565ec0488f$var$_stopMessageWithCoordination = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee7(stopMessageConfig) {
        var choreographerEnabled, requestBody, _args7 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee7$(_context7) {
            while(true)switch(_context7.prev = _context7.next){
                case 0:
                    choreographerEnabled = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : false;
                    requestBody = {
                        cloudId: stopMessageConfig.cloudId,
                        orgId: stopMessageConfig.orgId,
                        workspaceId: stopMessageConfig.workspaceId,
                        choreographerEnabled: choreographerEnabled
                    };
                    return _context7.abrupt("return", (0, $e215735b489502b1$export$2d9a5db60a4c50cd)("".concat(stopMessageConfig.stargateUrl).concat($12add2565ec0488f$var$stopMessageUrlTemplate.expand({
                        messageId: stopMessageConfig.messageId
                    })), {
                        method: "post",
                        body: JSON.stringify(requestBody),
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }).then((0, $e215735b489502b1$export$2ba4cde277adb6b1)).then($12add2565ec0488f$var$handleStartStopMessageResponse));
                case 3:
                case "end":
                    return _context7.stop();
            }
        }, _callee7);
    }));
    return $12add2565ec0488f$var$_stopMessageWithCoordination.apply(this, arguments);
}
var $12add2565ec0488f$var$userResponseUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($5258d0c7398e5f78$exports))).parse("/engage-targeting/api/v2/user/{cloudId}/messages/{messageId}/response");
function $12add2565ec0488f$export$e1fd1449cf83c1f5(_x15, _x16, _x17, _x18) {
    return $12add2565ec0488f$var$_sendUserResponse.apply(this, arguments);
}
function $12add2565ec0488f$var$_sendUserResponse() {
    $12add2565ec0488f$var$_sendUserResponse = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee8(cloudId, stargateUrl, messageId, payload) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee8$(_context8) {
            while(true)switch(_context8.prev = _context8.next){
                case 0:
                    return _context8.abrupt("return", (0, $e215735b489502b1$export$2d9a5db60a4c50cd)("".concat(stargateUrl).concat($12add2565ec0488f$var$userResponseUrlTemplate.expand({
                        cloudId: cloudId,
                        messageId: messageId
                    })), {
                        method: "post",
                        body: JSON.stringify(payload),
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }).then((0, $e215735b489502b1$export$2ba4cde277adb6b1)).then(function() {
                        return Promise.resolve();
                    }));
                case 1:
                case "end":
                    return _context8.stop();
            }
        }, _callee8);
    }));
    return $12add2565ec0488f$var$_sendUserResponse.apply(this, arguments);
}
var $12add2565ec0488f$var$markSeenAndFatigueUrlTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($5258d0c7398e5f78$exports))).parse("/engage-targeting/api/v2/user/messages/{messageId}/seen");
function $12add2565ec0488f$export$3683393f780c6905(_x19) {
    return $12add2565ec0488f$var$_markAsSeenAndFatigued.apply(this, arguments);
}
function $12add2565ec0488f$var$_markAsSeenAndFatigued() {
    $12add2565ec0488f$var$_markAsSeenAndFatigued = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee9(seenMessageConfig) {
        var requestBody;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee9$(_context9) {
            while(true)switch(_context9.prev = _context9.next){
                case 0:
                    requestBody = {
                        cloudId: seenMessageConfig.cloudId,
                        orgId: seenMessageConfig.orgId,
                        workspaceId: seenMessageConfig.workspaceId
                    };
                    return _context9.abrupt("return", (0, $e215735b489502b1$export$2d9a5db60a4c50cd)("".concat(seenMessageConfig.stargateUrl).concat($12add2565ec0488f$var$markSeenAndFatigueUrlTemplate.expand({
                        messageId: seenMessageConfig.messageId
                    })), {
                        method: "post",
                        body: JSON.stringify(requestBody),
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }).then((0, $e215735b489502b1$export$2ba4cde277adb6b1)).then(function() {
                        return Promise.resolve();
                    }));
                case 2:
                case "end":
                    return _context9.stop();
            }
        }, _callee9);
    }));
    return $12add2565ec0488f$var$_markAsSeenAndFatigued.apply(this, arguments);
}




function $69fc311fd26bf3c4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $69fc311fd26bf3c4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $69fc311fd26bf3c4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $69fc311fd26bf3c4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $69fc311fd26bf3c4$export$a9d4ce3abb5d2365 = function getEventToMessageMapping(messages) {
    var mapping = new Map();
    messages.forEach(function(message) {
        var components = message.components;
        components.forEach(function(component, index) {
            component.triggers.forEach(function(trigger) {
                mapping.set(trigger, {
                    message: message,
                    component: $69fc311fd26bf3c4$var$_objectSpread({
                        componentId: index,
                        isLast: index === components.length - 1
                    }, component)
                });
            });
        });
    });
    return mapping;
};
function $69fc311fd26bf3c4$export$d2e92820f98a2592(_x, _x2, _x3) {
    return $69fc311fd26bf3c4$var$_processMessages.apply(this, arguments);
}
function $69fc311fd26bf3c4$var$_processMessages() {
    $69fc311fd26bf3c4$var$_processMessages = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee(engagementStore, config, cancellationToken) {
        var state, cloudId, stargateUrl, product, locale, messages, interval, results, messageMapping;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!cancellationToken.isCancelled) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    state = (0, $9b9a98b154dbc99d$export$6f57813fe9f31bf9).getState();
                    cloudId = config.cloudId, stargateUrl = config.stargateUrl, product = config.product, locale = config.locale;
                    _context.prev = 4;
                    _context.next = 7;
                    return (0, $12add2565ec0488f$export$8c20ab16ac9cf14f)(cloudId, stargateUrl, product, locale);
                case 7:
                    results = _context.sent;
                    if (!cancellationToken.isCancelled) {
                        _context.next = 10;
                        break;
                    }
                    return _context.abrupt("return");
                case 10:
                    messages = results.messages;
                    interval = results.interval;
                    _context.next = 17;
                    break;
                case 14:
                    _context.prev = 14;
                    _context.t0 = _context["catch"](4);
                    return _context.abrupt("return");
                case 17:
                    // Don't overwrite the messageMapping if there's an active message
                    if (state.current === null) {
                        messageMapping = $69fc311fd26bf3c4$export$a9d4ce3abb5d2365(messages);
                        engagementStore.dispatch((0, $d1a917d05ac92efc$export$375dd0a76fecd4c7)(messageMapping));
                    }
                    if (interval !== 0) setTimeout(function() {
                        $69fc311fd26bf3c4$export$d2e92820f98a2592(engagementStore, config, cancellationToken);
                    }, interval * 1000);
                // TODO: Configure metal to monitor success response here
                case 19:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                4,
                14
            ]
        ]);
    }));
    return $69fc311fd26bf3c4$var$_processMessages.apply(this, arguments);
}


function $9b9a98b154dbc99d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9b9a98b154dbc99d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9b9a98b154dbc99d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9b9a98b154dbc99d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9b9a98b154dbc99d$export$36d128238e6b60f5 = {
    messageMapping: new Map(),
    current: null,
    initialized: false,
    initializing: false,
    config: {
        cloudId: "",
        aaid: "",
        locale: "",
        product: "",
        stargateUrl: "",
        orgId: "",
        workspaceId: ""
    }
};
var $9b9a98b154dbc99d$var$processMessagesCancellationToken = (0, $d6d939b947d85a22$export$eac027797b968991)();
function $9b9a98b154dbc99d$export$7a10f46f72407bc5(messageMapping, component) {
    var newMapping = new Map();
    messageMapping.forEach(function(value, key) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($7ojd4)))(value.component, component)) newMapping.set(key, value);
    });
    return newMapping;
}
var $9b9a98b154dbc99d$export$6f57813fe9f31bf9 = (0, $2ceb6b7347c6a90b$export$2e2bcd8739ae039)(function() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $9b9a98b154dbc99d$export$36d128238e6b60f5;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $d1a917d05ac92efc$export$d05fe3e897340c89:
            return $9b9a98b154dbc99d$var$_objectSpread($9b9a98b154dbc99d$var$_objectSpread({}, state), {}, {
                initialized: true,
                initializing: false,
                messageMapping: action.messageMapping
            });
        case 0, $d1a917d05ac92efc$export$eacd3ec165715d8:
            return $9b9a98b154dbc99d$var$_objectSpread($9b9a98b154dbc99d$var$_objectSpread({}, state), {}, {
                config: action.config,
                initializing: true
            });
        case 0, $d1a917d05ac92efc$export$a9319af002a4c677:
            var eventMapping = action.eventMapping;
            var message = eventMapping.message, component = eventMapping.component;
            var messageMapping = $9b9a98b154dbc99d$export$7a10f46f72407bc5(state.messageMapping, component);
            return $9b9a98b154dbc99d$var$_objectSpread($9b9a98b154dbc99d$var$_objectSpread({}, state), {}, {
                current: $9b9a98b154dbc99d$var$_objectSpread({
                    messageId: message.messageId,
                    variationId: message.variationId
                }, component),
                messageMapping: messageMapping
            });
        case 0, $d1a917d05ac92efc$export$cb5041d68cb18859:
            return $9b9a98b154dbc99d$var$_objectSpread($9b9a98b154dbc99d$var$_objectSpread({}, state), {}, {
                current: null
            });
        case 0, $d1a917d05ac92efc$export$874c5149d7f0e3b8:
            return $9b9a98b154dbc99d$export$36d128238e6b60f5;
        default:
            return state;
    }
});
var $9b9a98b154dbc99d$export$2e2bcd8739ae039 = function(config) {
    var state = $9b9a98b154dbc99d$export$6f57813fe9f31bf9.getState();
    if (state.initializing || state.initialized) {
        if (state.config.cloudId === config.cloudId) return $9b9a98b154dbc99d$export$6f57813fe9f31bf9;
        // CloudId has changed, cancel any in process processMessages request
        $9b9a98b154dbc99d$var$processMessagesCancellationToken.isCancelled = true;
        $9b9a98b154dbc99d$var$processMessagesCancellationToken = (0, $d6d939b947d85a22$export$eac027797b968991)();
        $9b9a98b154dbc99d$export$6f57813fe9f31bf9.dispatch((0, $d1a917d05ac92efc$export$a20a1205b2a2b7e4)());
    }
    var newConfig = $9b9a98b154dbc99d$var$_objectSpread({}, config);
    newConfig.locale = newConfig.locale.replace("_", "-");
    $9b9a98b154dbc99d$export$6f57813fe9f31bf9.dispatch((0, $d1a917d05ac92efc$export$2a47f398eeff8b01)(newConfig));
    if ((0, $080cd6a6641f1295$export$a77934ac158768dd)()) (0, $69fc311fd26bf3c4$export$d2e92820f98a2592)($9b9a98b154dbc99d$export$6f57813fe9f31bf9, newConfig, $9b9a98b154dbc99d$var$processMessagesCancellationToken);
    return $9b9a98b154dbc99d$export$6f57813fe9f31bf9;
};



var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $4mVfk = parcelRequire("4mVfk");

var $b4Ivn = parcelRequire("b4Ivn");

var $kFnE9 = parcelRequire("kFnE9");

var $8DpVo = parcelRequire("8DpVo");

var $9nHZC = parcelRequire("9nHZC");
var $db4fd98a1578ffce$exports = {};

var $4sMvO = parcelRequire("4sMvO");

var $dYZYl = parcelRequire("dYZYl");
/**
 * Performs a partial deep comparison between `object` and `source` to
 * determine if `object` contains equivalent property values.
 *
 * **Note:** This method is equivalent to `_.matches` when `source` is
 * partially applied.
 *
 * Partial comparisons will match empty array and empty object `source`
 * values against any array or object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.isMatch(object, { 'b': 2 });
 * // => true
 *
 * _.isMatch(object, { 'b': 1 });
 * // => false
 */ function $db4fd98a1578ffce$var$isMatch(object, source) {
    return object === source || $4sMvO(object, source, $dYZYl(source));
}
$db4fd98a1578ffce$exports = $db4fd98a1578ffce$var$isMatch;


var $88d1abe7196edd11$exports = {};
var $1ed4455d7a833878$exports = {};

var $jjdf2 = parcelRequire("jjdf2");
/** Error message constants. */ var $1ed4455d7a833878$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */ function $1ed4455d7a833878$var$before(n, func) {
    var result;
    if (typeof func != "function") throw new TypeError($1ed4455d7a833878$var$FUNC_ERROR_TEXT);
    n = $jjdf2(n);
    return function() {
        if (--n > 0) result = func.apply(this, arguments);
        if (n <= 1) func = undefined;
        return result;
    };
}
$1ed4455d7a833878$exports = $1ed4455d7a833878$var$before;


/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */ function $88d1abe7196edd11$var$once(func) {
    return $1ed4455d7a833878$exports(2, func);
}
$88d1abe7196edd11$exports = $88d1abe7196edd11$var$once;



var $blCBi = parcelRequire("blCBi");
var $c044cb731c737d30$exports = {};
"use strict";
$c044cb731c737d30$exports = typeof self === "object" && self.self === self && self || typeof $parcel$global === "object" && $parcel$global.global === $parcel$global && $parcel$global || $c044cb731c737d30$exports;



var $PvaWJ = parcelRequire("PvaWJ");
var $9nHZC = parcelRequire("9nHZC");

var $dEQSq = parcelRequire("dEQSq");

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $blCBi = parcelRequire("blCBi");

var $kZnbM = parcelRequire("kZnbM");
function $b8884be5ac85f965$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b8884be5ac85f965$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $b8884be5ac85f965$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b8884be5ac85f965$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $b8884be5ac85f965$var$ContextTypes = {
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func,
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func
};
var $b8884be5ac85f965$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $b8884be5ac85f965$var$AnalyticsListener = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(AnalyticsListener, _Component);
    var _super = $b8884be5ac85f965$var$_createSuper(AnalyticsListener);
    function AnalyticsListener(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsListener);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers,
                getAtlaskitAnalyticsContext: _this.getAtlaskitAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getAnalyticsEventHandlers", function() {
            var _this$props = _this.props, channel = _this$props.channel, onEvent = _this$props.onEvent;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla === void 0 ? $b8884be5ac85f965$var$noop : _this$context$getAtla;
            var handler = function handler(event, eventChannel) {
                if (channel === "*" || channel === eventChannel) onEvent(event, eventChannel);
            };
            return [
                handler
            ].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(getAtlaskitAnalyticsEventHandlers()));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getAtlaskitAnalyticsContext", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla2 === void 0 ? $b8884be5ac85f965$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsContext();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsListener, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kZnbM.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsListener;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($b8884be5ac85f965$var$AnalyticsListener, "contextTypes", $b8884be5ac85f965$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($b8884be5ac85f965$var$AnalyticsListener, "childContextTypes", $b8884be5ac85f965$var$ContextTypes);
var $b8884be5ac85f965$export$2e2bcd8739ae039 = $b8884be5ac85f965$var$AnalyticsListener;



var $b4Ivn = parcelRequire("b4Ivn");

var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");

var $iWzne = parcelRequire("iWzne");

var $9nHZC = parcelRequire("9nHZC");
var $86671d92260f7f38$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    ref.current = value;
    return ref;
};


var $f12c16600a48adb1$var$AnalyticsListener = function AnalyticsListener(_ref) {
    var children = _ref.children, channel = _ref.channel, onEvent = _ref.onEvent;
    var analyticsContext = (0, $iWzne.useAnalyticsContext)();
    var onEventRef = (0, $86671d92260f7f38$export$1d27a74659855e44)(onEvent);
    var channelRef = (0, $86671d92260f7f38$export$1d27a74659855e44)(channel);
    var getAtlaskitAnalyticsEventHandlers = (0, $9nHZC.useCallback)(function() {
        var thisHandler = function thisHandler(event, eventChannel) {
            if (channelRef.current === "*" || channelRef.current === eventChannel) onEventRef.current(event, eventChannel);
        };
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(analyticsContext.getAtlaskitAnalyticsEventHandlers()), [
            thisHandler
        ]);
    }, [
        analyticsContext,
        channelRef,
        onEventRef
    ]);
    var value = (0, $9nHZC.useMemo)(function() {
        return {
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers,
            getAtlaskitAnalyticsContext: analyticsContext.getAtlaskitAnalyticsContext
        };
    }, [
        analyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kZnbM.default).Provider, {
        value: value
    }, children);
};
var $f12c16600a48adb1$export$2e2bcd8739ae039 = $f12c16600a48adb1$var$AnalyticsListener;



var $8ovux = parcelRequire("8ovux");
var $a8bfa4001f3119fd$var$ExportedAnalyticsListener = function ExportedAnalyticsListener(props) {
    var _process$env;
    var isModernContextEnabledEnv = typeof $8ovux !== "undefined" && $8ovux !== null && ((_process$env = {}, _process$env === void 0) ? void 0 : _process$env["ANALYTICS_NEXT_MODERN_CONTEXT"]);
    return isModernContextEnabledEnv || (0, $dEQSq.getBooleanFF)("platform.analytics-next-use-modern-context_fqgbx") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $f12c16600a48adb1$export$2e2bcd8739ae039), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $b8884be5ac85f965$export$2e2bcd8739ae039), props);
};
var $a8bfa4001f3119fd$export$2e2bcd8739ae039 = $a8bfa4001f3119fd$var$ExportedAnalyticsListener;



function $45780ffed9d9fa24$export$22a3b1671f38a193(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then(function(client) {
        client.sendScreenEvent(payload);
    });
}
function $45780ffed9d9fa24$export$1aecf263098db667(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then(function(client) {
        client.sendUIEvent(payload);
    });
}
function $45780ffed9d9fa24$export$e5f89b51c6d4e36b(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then(function(client) {
        client.sendOperationalEvent(payload);
    });
}


function $bab2e32d4ae0ad1b$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $bab2e32d4ae0ad1b$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $bab2e32d4ae0ad1b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bab2e32d4ae0ad1b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bab2e32d4ae0ad1b$var$_arrayLikeToArray(o, minLen);
}
function $bab2e32d4ae0ad1b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $bab2e32d4ae0ad1b$var$browserMatchers = [
    {
        name: "IE",
        pattern: /Trident\/.*; rv:([^;)]+)/
    },
    {
        name: "Chrome",
        pattern: /Chrome\/([^ )]+)/
    },
    {
        name: "Firefox",
        pattern: /Firefox\/([^ )]+)/
    }
];
var $bab2e32d4ae0ad1b$export$cda2203640e08931 = {
    name: "unknown",
    version: "unknown"
};
function $bab2e32d4ae0ad1b$export$6c724a6ffa2dc3e1(userAgent) {
    if (!window.navigator) return $bab2e32d4ae0ad1b$export$cda2203640e08931;
    if (!userAgent) userAgent = window.navigator.userAgent;
    var _iterator = $bab2e32d4ae0ad1b$var$_createForOfIteratorHelper($bab2e32d4ae0ad1b$var$browserMatchers), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var matcher = _step.value;
            var versionMatch = userAgent.match(matcher.pattern);
            if (versionMatch) return {
                name: matcher.name,
                version: versionMatch[1]
            };
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return $bab2e32d4ae0ad1b$export$cda2203640e08931;
}


// @ts-nocheck
var $8e5ef91628948dcc$var$createCustomEvent = function createCustomEvent(_ref) {
    var eventName = _ref.eventName, canBubble = _ref.canBubble, cancellable = _ref.cancellable, detail = _ref.detail;
    var customEvent = document.createEvent("CustomEvent");
    customEvent.initCustomEvent(eventName, canBubble, cancellable, detail);
    return customEvent;
};
var $8e5ef91628948dcc$export$2e2bcd8739ae039 = $8e5ef91628948dcc$var$createCustomEvent;





var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");
var $f0d80c12308e6121$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Queue(maxSize) {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, Queue);
        this.queue = [];
        this.maxSize = maxSize;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(Queue, [
        {
            key: "enqueue",
            value: function enqueue(item) {
                if (this.queue.length === this.maxSize) return false;
                this.queue.push(item);
                return true;
            }
        },
        {
            key: "flush",
            value: function flush(callback) {
                this.queue.forEach(callback);
                this.queue = [];
            }
        },
        {
            key: "getSize",
            value: function getSize() {
                return this.queue.length;
            }
        }
    ]);
    return Queue;
}();


function $9a447817e41be01c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $9a447817e41be01c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $9a447817e41be01c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9a447817e41be01c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $9a447817e41be01c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9a447817e41be01c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9a447817e41be01c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9a447817e41be01c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9a447817e41be01c$var$MAX_EVENT_QUEUE_SIZE = 100;
var $9a447817e41be01c$var$EK_LOADED_EVENT = "engagement.inproduct.loaded";
var $9a447817e41be01c$export$5306bd00631dbf8c = "ep.analyticEvent";
function $9a447817e41be01c$var$collapseEventToPayload(event) {
    var payload = $9a447817e41be01c$var$_objectSpread($9a447817e41be01c$var$_objectSpread({}, event.payload), {}, {
        context: {}
    });
    Object.assign.apply(Object, [
        payload.context
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(event.context)));
    return payload;
}
function $9a447817e41be01c$var$findMatchingTrigger(messageMapping, payload) {
    return Array.from(messageMapping.keys()).find(function(trigger) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($db4fd98a1578ffce$exports)))(payload, trigger);
    });
}
function $9a447817e41be01c$var$fireExposureEvent(attributes, clientOrPromise) {
    var analyticsEvent = new (0, $PvaWJ.default)({
        payload: {
            action: "exposed",
            actionSubject: "feature",
            actionSubjectId: attributes.flagKey,
            source: "engagement-platform",
            attributes: attributes
        }
    });
    Promise.resolve(clientOrPromise).then(function(client) {
        client.sendTrackEvent(analyticsEvent.payload);
    });
}
function $9a447817e41be01c$var$getExposureAttributes(messageId, cohort, additionalProps) {
    return $9a447817e41be01c$var$_objectSpread({
        reason: "RULE_MATCH",
        ruleId: "engagement.inproduct",
        flagKey: "engagement.inproduct.".concat(messageId),
        value: cohort
    }, additionalProps);
}
function $9a447817e41be01c$var$getBaseAttributes(messageId, variationId, componentId, locale) {
    return {
        messageId: messageId,
        variationId: variationId,
        componentIndex: componentId,
        locale: locale
    };
}
function $9a447817e41be01c$export$473a2bbbfd90c87b(_x, _x2, _x3, _x4, _x5) {
    return $9a447817e41be01c$var$_triggerShown.apply(this, arguments);
}
function $9a447817e41be01c$var$_triggerShown() {
    $9a447817e41be01c$var$_triggerShown = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee(eventMapping, config, store, clientOrPromise, coordinationOptions) {
        var locale, message, component, success;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    locale = config.locale;
                    message = eventMapping.message, component = eventMapping.component;
                    if (!message.holdout) {
                        _context.next = 9;
                        break;
                    }
                    _context.next = 5;
                    return (0, $12add2565ec0488f$export$7a77c9a7b182680b)({
                        cloudId: config.cloudId,
                        stargateUrl: config.stargateUrl,
                        messageId: message.messageId,
                        variationId: message.variationId,
                        orgId: config.orgId,
                        workspaceId: config.workspaceId
                    }, coordinationOptions);
                case 5:
                    _context.next = 7;
                    return (0, $12add2565ec0488f$export$159ff839f1f095d2)({
                        cloudId: config.cloudId,
                        stargateUrl: config.stargateUrl,
                        messageId: message.messageId,
                        orgId: config.orgId,
                        workspaceId: config.workspaceId
                    }, coordinationOptions);
                case 7:
                    $9a447817e41be01c$var$fireExposureEvent($9a447817e41be01c$var$getExposureAttributes(message.messageId, "holdout", {
                        locale: locale
                    }), clientOrPromise);
                    return _context.abrupt("return");
                case 9:
                    if (!(component.componentId === 0)) {
                        _context.next = 16;
                        break;
                    }
                    _context.next = 12;
                    return (0, $12add2565ec0488f$export$7a77c9a7b182680b)({
                        cloudId: config.cloudId,
                        stargateUrl: config.stargateUrl,
                        messageId: message.messageId,
                        variationId: message.variationId,
                        orgId: config.orgId,
                        workspaceId: config.workspaceId
                    }, coordinationOptions);
                case 12:
                    success = _context.sent;
                    if (success) {
                        $9a447817e41be01c$var$fireExposureEvent($9a447817e41be01c$var$getExposureAttributes(message.messageId, message.variationId, {
                            locale: locale
                        }), clientOrPromise);
                        store.dispatch((0, $d1a917d05ac92efc$export$5f80f094fd31fffd)(eventMapping));
                    }
                    _context.next = 18;
                    break;
                case 16:
                    $9a447817e41be01c$var$fireExposureEvent($9a447817e41be01c$var$getExposureAttributes(message.messageId, message.variationId, {
                        locale: locale
                    }), clientOrPromise);
                    store.dispatch((0, $d1a917d05ac92efc$export$5f80f094fd31fffd)(eventMapping));
                case 18:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $9a447817e41be01c$var$_triggerShown.apply(this, arguments);
}
var $9a447817e41be01c$export$83b8ae7ce7b4d59c = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(EngagementProvider, _Component);
    var _super = $9a447817e41be01c$var$_createSuper(EngagementProvider);
    function EngagementProvider(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, EngagementProvider);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onStoreChange", function(state) {
            var createAnalyticsEvent = _this.props.createAnalyticsEvent;
            var config = _this.getConfig();
            var locale = config.locale;
            if (state.initialized) {
                if (!EngagementProvider.hasInitializedAtLeastOneEngagementProvider) {
                    _this.sendOperationalEventWithClient({
                        action: "loaded",
                        actionSubject: "messages",
                        actionSubjectId: undefined,
                        source: "engagekit",
                        attributes: {
                            locale: locale
                        }
                    });
                    var browserInfo = (0, $bab2e32d4ae0ad1b$export$6c724a6ffa2dc3e1)();
                    _this.onEvent(createAnalyticsEvent({
                        event: $9a447817e41be01c$var$EK_LOADED_EVENT,
                        properties: {
                            browser: browserInfo.name,
                            browserVersion: browserInfo.version
                        }
                    }));
                    EngagementProvider.hasInitializedAtLeastOneEngagementProvider = true;
                }
                _this.analyticsEventQueue.flush(_this.onEvent);
                if (_this.unsubscribeFromStore) _this.unsubscribeFromStore();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onEvent", function(event) {
            var state = _this.getState();
            if (!state.initialized) {
                var success = _this.analyticsEventQueue.enqueue(event);
                if (!success) _this.fireQueueOverflowEvent();
                return;
            }
            var _this$props = _this.props, eventTarget = _this$props.eventTarget, store = _this$props.store, analyticsClientInstance = _this$props.analyticsClientInstance;
            var config = _this.getConfig();
            var current = state.current, messageMapping = state.messageMapping;
            var payload = $9a447817e41be01c$var$collapseEventToPayload(event);
            eventTarget.dispatchEvent((0, $8e5ef91628948dcc$export$2e2bcd8739ae039)({
                eventName: $9a447817e41be01c$export$5306bd00631dbf8c,
                canBubble: false,
                cancellable: false,
                detail: payload
            }));
            if (!(0, $080cd6a6641f1295$export$a77934ac158768dd)()) return;
            // existing message found
            if (current) return;
            var trigger = $9a447817e41be01c$var$findMatchingTrigger(messageMapping, payload);
            // No messages found for trigger
            if (!trigger) return;
            $9a447817e41be01c$export$473a2bbbfd90c87b(messageMapping.get(trigger), config, store, analyticsClientInstance, _this.props.coordinationOptions);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onEngagementEvent", function(event) {
            var _event$payload = event.payload, action = _event$payload.action, clickType = _event$payload.clickType, ekMessageId = _event$payload.ekMessageId, ekVariationId = _event$payload.ekVariationId, ekComponentId = _event$payload.ekComponentId, ekComponentType = _event$payload.ekComponentType, ekIsLast = _event$payload.ekIsLast;
            var config = _this.getConfig();
            var locale = config.locale;
            var attributes = $9a447817e41be01c$var$getBaseAttributes(ekMessageId, ekVariationId, ekComponentId, locale);
            if (action === "click") {
                _this.handleClickEvent(ekMessageId, ekVariationId, ekComponentId);
                attributes.buttonType = clickType;
                _this.sendUIEventWithClient({
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "".concat(clickType, "Button"),
                    source: "engagement_".concat(ekComponentType),
                    attributes: attributes
                });
            } else {
                if (action === "shown") {
                    attributes.componentType = ekComponentType;
                    _this.sendScreenEventWithClient({
                        name: "engagement_".concat(ekComponentType),
                        attributes: attributes
                    });
                }
                if (action === "hidden") {
                    attributes.isLast = ekIsLast;
                    _this.sendUIEventWithClient({
                        action: "hid",
                        actionSubject: "component",
                        actionSubjectId: undefined,
                        source: "engagement_".concat(ekComponentType),
                        attributes: attributes
                    });
                }
            }
            _this.onEvent(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "subscribeEngagementState", function(callback) {
            var store = _this.props.store;
            callback(store.getState());
            return store.subscribe(function() {
                callback(store.getState());
            });
        });
        var _analyticsClientInstance = _this.props.analyticsClientInstance;
        _this.sendUIEventWithClient = (0, $45780ffed9d9fa24$export$1aecf263098db667).bind(null, _analyticsClientInstance);
        _this.sendScreenEventWithClient = (0, $45780ffed9d9fa24$export$22a3b1671f38a193).bind(null, _analyticsClientInstance);
        _this.sendOperationalEventWithClient = (0, $45780ffed9d9fa24$export$e5f89b51c6d4e36b).bind(null, _analyticsClientInstance);
        _this.analyticsEventQueue = new (0, $f0d80c12308e6121$export$2e2bcd8739ae039)($9a447817e41be01c$var$MAX_EVENT_QUEUE_SIZE);
        _this.unsubscribeFromStore = _this.subscribeEngagementState(_this.onStoreChange);
        _this.fireQueueOverflowEvent = (0, (/*@__PURE__*/$parcel$interopDefault($88d1abe7196edd11$exports)))(// TODO: create metric for this with Metal
        function() {});
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(EngagementProvider, [
        {
            key: "getConfig",
            value: function getConfig() {
                var _this$getState = this.getState(), config = _this$getState.config;
                return config;
            }
        },
        {
            key: "getChildContext",
            value: function getChildContext() {
                return {
                    subscribeEngagementState: this.subscribeEngagementState
                };
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.props.store.getState();
            }
        },
        {
            key: "getActiveMessage",
            value: function getActiveMessage() {
                return this.getState().current;
            }
        },
        {
            key: "completeMessage",
            value: function completeMessage(messageId) {
                var config = this.getConfig();
                (0, $12add2565ec0488f$export$159ff839f1f095d2)({
                    cloudId: config.cloudId,
                    stargateUrl: config.stargateUrl,
                    messageId: messageId,
                    orgId: config.orgId,
                    workspaceId: config.workspaceId
                }, this.props.coordinationOptions);
            }
        },
        {
            key: "handleClickEvent",
            value: function handleClickEvent(messageId, variationId, componentId) {
                var activeMessage = this.getActiveMessage();
                // It is important to check that the event we're handling matches the
                // current active message because it is possible for an event to come
                // through for a past message. We don't want to mess up the current
                // message by calling clearCurrent just because the old message is done.
                if (!activeMessage || activeMessage.messageId !== messageId || activeMessage.variationId !== variationId || activeMessage.componentId !== componentId) return;
                if (activeMessage.isLast) this.completeMessage(messageId);
                this.props.store.dispatch((0, $d1a917d05ac92efc$export$96105f873ade39d7)());
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unsubscribeFromStore && this.unsubscribeFromStore();
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $a8bfa4001f3119fd$export$2e2bcd8739ae039), {
                    channel: "*",
                    onEvent: this.onEvent
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $a8bfa4001f3119fd$export$2e2bcd8739ae039), {
                    channel: "engagement",
                    onEvent: this.onEngagementEvent
                }, this.props.children));
            }
        }
    ]);
    return EngagementProvider;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($9a447817e41be01c$export$83b8ae7ce7b4d59c, "childContextTypes", {
    subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($blCBi))).func
});
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($9a447817e41be01c$export$83b8ae7ce7b4d59c, "defaultProps", {
    eventTarget: (0, (/*@__PURE__*/$parcel$interopDefault($c044cb731c737d30$exports)))
});
/*
 * We use this flag for ensuring that we only fire the engagement.inproduct.loaded event once. This is an interim solution
 * until we can more holistically rethink our code architecture to eliminate duplicate behaviour across EngagementProviders.
 */ (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($9a447817e41be01c$export$83b8ae7ce7b4d59c, "hasInitializedAtLeastOneEngagementProvider", false);


// This extra bit of typing is required because typing on analytics-next
// doesn't seem to be working properly and we haven't been able to
// come up with a solution for it yet. Also analytics-next is in
// maintenance mode so will need to be replaced anyway.
var $9d38c7423aafe124$var$EngagementProviderWithEvents = (0, $ll9SN.default)()((0, $9a447817e41be01c$export$83b8ae7ce7b4d59c));
var $9d38c7423aafe124$var$EngagementProviderWithDefaultStore = function EngagementProviderWithDefaultStore(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($9d38c7423aafe124$var$EngagementProviderWithEvents, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        store: (0, $9b9a98b154dbc99d$export$2e2bcd8739ae039)(props.config)
    }));
};
var $9d38c7423aafe124$export$2e2bcd8739ae039 = (0, $cf61e13c1f825b98$export$2e2bcd8739ae039)($9d38c7423aafe124$var$EngagementProviderWithDefaultStore);



var $1D3HA = parcelRequire("1D3HA");
var $9c5590b5873af733$export$2e2bcd8739ae039 = window.__locale__ || {
    locale: "en",
    isDummyLocale: false,
    localeData: null,
    messages: {}
};



var $bBcuy = parcelRequire("bBcuy");

var $6Tn56 = parcelRequire("6Tn56");
parcelRequire("hw8PW");
var $7JtYi = parcelRequire("7JtYi");
var $l9p9x = parcelRequire("l9p9x");


var $7xQTz = parcelRequire("7xQTz");

var $4mVfk = parcelRequire("4mVfk");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $8DpVo = parcelRequire("8DpVo");


var $2d3e4a8ec5de9ec1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function CoordinationClient(configOrCloudId, stargateUrl) {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, CoordinationClient);
        var config;
        if (typeof configOrCloudId === "string") config = {
            cloudId: configOrCloudId,
            stargateUrl: stargateUrl,
            isFedRAMPEnvironment: false
        };
        else config = configOrCloudId;
        if (!config.cloudId || !config.stargateUrl) throw new Error("Need a valid CloudId and Stargate url");
        this.cloudId = config.cloudId;
        this.stargateUrl = config.stargateUrl;
        this.orgId = config.orgId;
        this.workspaceId = config.workspaceId;
        this.coordinationOptions = config.coordinationOptions;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(CoordinationClient, [
        {
            key: "start",
            value: function() {
                var _start = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee(messageId, variationId) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if ((0, $080cd6a6641f1295$export$a77934ac158768dd)()) {
                                    _context.next = 2;
                                    break;
                                }
                                return _context.abrupt("return", false);
                            case 2:
                                return _context.abrupt("return", (0, $12add2565ec0488f$export$7a77c9a7b182680b)({
                                    cloudId: this.cloudId,
                                    stargateUrl: this.stargateUrl,
                                    messageId: messageId,
                                    variationId: variationId,
                                    orgId: this.orgId,
                                    workspaceId: this.workspaceId
                                }, this.coordinationOptions));
                            case 3:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function start(_x, _x2) {
                    return _start.apply(this, arguments);
                }
                return start;
            }()
        },
        {
            key: "stop",
            value: function() {
                var _stop = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee2(messageId) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                if ((0, $080cd6a6641f1295$export$a77934ac158768dd)()) {
                                    _context2.next = 2;
                                    break;
                                }
                                return _context2.abrupt("return", false);
                            case 2:
                                return _context2.abrupt("return", (0, $12add2565ec0488f$export$159ff839f1f095d2)({
                                    cloudId: this.cloudId,
                                    stargateUrl: this.stargateUrl,
                                    messageId: messageId,
                                    orgId: this.orgId,
                                    workspaceId: this.workspaceId
                                }, this.coordinationOptions));
                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function stop(_x3) {
                    return _stop.apply(this, arguments);
                }
                return stop;
            }()
        }
    ]);
    return CoordinationClient;
}();



var $6Tn56 = parcelRequire("6Tn56");
let $c357775698b1c91f$var$globalCoordinationClient = null;
const $c357775698b1c91f$export$7275ad0859d00fd0 = ()=>{
    const env = (0, $6Tn56.getBbEnv)();
    if (env === (0, $6Tn56.BbEnv).Production) return (0, $7xQTz.envType).PROD;
    else if (env === (0, $6Tn56.BbEnv).Staging) return (0, $7xQTz.envType).STAGING;
    else return (0, $7xQTz.envType).DEV;
};
const $c357775698b1c91f$export$a3f969ef7d35205d = ()=>{
    if (!$c357775698b1c91f$var$globalCoordinationClient) {
        // We don't have cloudIds, we use the environment instead. Default to development
        // if we can't find an environment since the CoordinationClient requires a cloudId
        const cloudId = (0, $6Tn56.getBbEnv)() || (0, $6Tn56.BbEnv).Development;
        const stargateUrl = "/gateway/api";
        const coordinationOptions = {
            enableChoreographer: !!(0, $l9p9x.getFlagValue)((0, $7JtYi.FeatureKeys).enableChoreographer, false),
            envType: $c357775698b1c91f$export$7275ad0859d00fd0(),
            additionalData: {
                sourceProductId: (0, $a07e2801589e28b7$export$7fb117db98868be6).BITBUCKET
            }
        };
        $c357775698b1c91f$var$globalCoordinationClient = new (0, $2d3e4a8ec5de9ec1$export$2e2bcd8739ae039)({
            cloudId: cloudId,
            stargateUrl: stargateUrl,
            coordinationOptions: coordinationOptions
        });
    }
    return $c357775698b1c91f$var$globalCoordinationClient;
};



var $1ZBmx = parcelRequire("1ZBmx");
const $bf3105324a2239b9$var$getEngagementProviderConfig = (cloudId, currentUserAccountId, workspaceId)=>{
    return {
        cloudId: cloudId,
        aaid: currentUserAccountId || "",
        workspaceId: workspaceId || "",
        locale: (0, $9c5590b5873af733$export$2e2bcd8739ae039).locale,
        product: "bitbucket",
        stargateUrl: "/gateway/api"
    };
};
const $bf3105324a2239b9$export$83b8ae7ce7b4d59c = ({ children: children })=>{
    var _appData$user;
    const appData = (0, $1D3HA.useAppData)();
    // We don't have cloudIds, we use the environment instead.
    const cloudId = (0, $6Tn56.getBbEnv)();
    const currentUserAccountId = (_appData$user = appData.user) === null || _appData$user === void 0 ? void 0 : _appData$user.aaid;
    const workspaceId = appData.tenantId;
    const config = (0, $9nHZC.useMemo)(()=>$bf3105324a2239b9$var$getEngagementProviderConfig(cloudId, currentUserAccountId, workspaceId), [
        cloudId,
        currentUserAccountId,
        workspaceId
    ]);
    const enableChoreographer = !!(0, $hw8PW.useFeature)((0, $7JtYi.FeatureKeys).enableChoreographer, false);
    const analyticsEnv = (0, $c357775698b1c91f$export$7275ad0859d00fd0)();
    const coordinationOptions = (0, $9nHZC.useMemo)(()=>({
            enableChoreographer: enableChoreographer,
            envType: analyticsEnv,
            additionalData: {
                sourceProductId: (0, $a07e2801589e28b7$export$7fb117db98868be6).BITBUCKET
            }
        }), [
        enableChoreographer,
        analyticsEnv
    ]);
    if ((0, $1ZBmx.IS_SERVER) || !currentUserAccountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9d38c7423aafe124$export$2e2bcd8739ae039), {
        config: config,
        analyticsClientInstance: (0, $bBcuy.analyticsClient)(),
        coordinationOptions: coordinationOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, children));
};



var $2FglY = parcelRequire("2FglY");

var $iihFv = parcelRequire("iihFv");

var $9nHZC = parcelRequire("9nHZC");

var $b7ZcK = parcelRequire("b7ZcK");

var $kEV2T = parcelRequire("kEV2T");

var $1D3HA = parcelRequire("1D3HA");

var $6Tn56 = parcelRequire("6Tn56");
const $ea76bedfcea4cca5$export$7115c339b7c11972 = (env)=>{
    if (env === "dev-west2") return "test";
    else if (env === "development") return "dev";
    else if (env === "staging") return "staging";
    return "production";
};
/*
 * This component is used to provide the PostOfficeContext to the application. It provides the product, subproduct and locale at the application level.
 */ const $ea76bedfcea4cca5$var$PostOfficeContextProviderImpl = ({ children: children })=>{
    const { locale: locale } = (0, $b7ZcK.default)();
    const { tenantId: tenantId } = (0, $1D3HA.useAppData)();
    const env = (0, $6Tn56.getBbEnv)();
    const workspaceAri = tenantId ? `ari:cloud:bitbucket::workspace/${tenantId}` : undefined; // Bitbucket tenantId is the equivalent of Atlassian workspaceId
    const context = (0, $9nHZC.useMemo)(()=>({
            current: {
                product: "bitbucket",
                locale: locale,
                workspaceId: workspaceAri
            }
        }), [
        locale,
        workspaceAri
    ]);
    const environment = (0, $9nHZC.useMemo)(()=>({
            env: $ea76bedfcea4cca5$export$7115c339b7c11972(env)
        }), [
        env
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kEV2T.PostOfficeProvider), {
        context: context,
        environment: environment
    }, children);
};
const $ea76bedfcea4cca5$export$b77983be89bb0a4e = $ea76bedfcea4cca5$var$PostOfficeContextProviderImpl;



var $jajUg = parcelRequire("jajUg");
parcelRequire("j1bBw");
var $e5hNf = parcelRequire("e5hNf");
var $kjZQW = parcelRequire("kjZQW");
var $677Fr = parcelRequire("677Fr");
var $9A93V = parcelRequire("9A93V");

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $4KCOO = parcelRequire("4KCOO");

var $5gF7V = parcelRequire("5gF7V");

var $fqfFF = parcelRequire("fqfFF");
var $3faeaafd07ec4edc$export$2e2bcd8739ae039 = (0, $fqfFF.default)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $4KCOO.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, props, {
        createFrom: (0, $5gF7V.CREATE_FROM).GLOBAL_DIALOG,
        shouldRenderCreateBranchButton: false
    })));



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");
parcelRequire("dGzLf");
var $5oGLl = parcelRequire("5oGLl");

var $fPPqr = parcelRequire("fPPqr");

var $lOQkO = parcelRequire("lOQkO");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $8FAjc = parcelRequire("8FAjc");
var $4nGYJ = parcelRequire("4nGYJ");

var $cGPG3 = parcelRequire("cGPG3");
var $ljrFr = parcelRequire("ljrFr");
var $5vrjy = parcelRequire("5vrjy");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $avKww = parcelRequire("avKww");

var $dCDrX = parcelRequire("dCDrX");
var $336a6c49e4921753$var$modalBodyStyles = (0, $avKww.css)({
    padding: "var(--ds-space-500, 40px)".concat(" ", "var(--ds-space-200, 16px)"),
    textAlign: "center"
});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-array-arguments -- Ignored via go/DSP-18766
var $336a6c49e4921753$var$modalHeadingStyles = (0, $avKww.css)([
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $avKww.css)((0, $dCDrX.h600)({
        theme: {
            mode: "light"
        }
    })),
    {
        marginBottom: "var(--ds-space-100, 8px)",
        color: "inherit"
    }
]);
var $336a6c49e4921753$var$modalImageStyles = (0, $avKww.css)({
    width: "100%",
    height: "auto",
    borderStartEndRadius: "var(--ds-border-radius, 3px)",
    borderStartStartRadius: "var(--ds-border-radius, 3px)",
    "@media (min-width: 320px) and (max-width: 480px)": {
        borderRadius: 0
    }
});
var $336a6c49e4921753$var$modalActionContainerStyles = (0, $avKww.css)({
    display: "flex",
    padding: "var(--ds-space-0, 0px)".concat(" ", "var(--ds-space-500, 40px)", " 36px"),
    justifyContent: "center",
    flexDirection: "row",
    flexFlow: "wrap"
});
var $336a6c49e4921753$var$modalActionContainerReversedStyles = (0, $avKww.css)({
    flexDirection: "row-reverse"
});
var $336a6c49e4921753$var$modalActionItemStyles = (0, $avKww.css)({
    margin: "var(--ds-space-0, 0px)".concat(" ", "var(--ds-space-050, 4px)", " ", "var(--ds-space-050, 4px)")
});
var $336a6c49e4921753$export$cb540d8b0ef7906c = function ModalBody(_ref) {
    var children = _ref.children;
    return (0, $avKww.jsx)("div", {
        css: $336a6c49e4921753$var$modalBodyStyles
    }, children);
};
var $336a6c49e4921753$export$9af27c346834c182 = function ModalHeading(_ref2) {
    var children = _ref2.children, id = _ref2.id;
    return (0, $avKww.jsx)("h1", {
        css: $336a6c49e4921753$var$modalHeadingStyles,
        id: id
    }, children);
};
var $336a6c49e4921753$export$1355685fd5f8d257 = function ModalImage(_ref3) {
    var alt = _ref3.alt, src = _ref3.src;
    return (0, $avKww.jsx)("img", {
        css: $336a6c49e4921753$var$modalImageStyles,
        alt: alt,
        src: src
    });
};
var $336a6c49e4921753$export$633dda6b40ac1ac3 = function ModalActionContainer(_ref4) {
    var children = _ref4.children, shouldReverseButtonOrder = _ref4.shouldReverseButtonOrder;
    return (0, $avKww.jsx)("div", {
        css: [
            $336a6c49e4921753$var$modalActionContainerStyles,
            shouldReverseButtonOrder && $336a6c49e4921753$var$modalActionContainerReversedStyles
        ]
    }, children);
};
var $336a6c49e4921753$export$c245e9f76e3299b1 = function ModalActionItem(_ref5) {
    var children = _ref5.children;
    return (0, $avKww.jsx)("div", {
        css: $336a6c49e4921753$var$modalActionItemStyles
    }, children);
};



var $fA3mK = parcelRequire("fA3mK");
var $1cbc8fabed6bd9b0$var$_excluded = [
    "text",
    "key"
], $1cbc8fabed6bd9b0$var$_excluded2 = [
    "actions",
    "children",
    "heading"
];
function $1cbc8fabed6bd9b0$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1cbc8fabed6bd9b0$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $1cbc8fabed6bd9b0$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1cbc8fabed6bd9b0$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
// TODO: DSP-1250 - use a composable API consistent with normal modal dialog
/**
 * __Benefits modal__
 *
 * A benefits modal explains the benefits of a significant new feature or experience change.
 *
 * - [Examples](https://atlassian.design/components/onboarding/benefits-modal/examples)
 * - [Code](https://atlassian.design/components/onboarding/benefits-modal/code)
 * - [Usage](https://atlassian.design/components/onboarding/benefits-modal/usage)
 */ var $1cbc8fabed6bd9b0$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(BenefitsModal, _Component);
    var _super = $1cbc8fabed6bd9b0$var$_createSuper(BenefitsModal);
    function BenefitsModal() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, BenefitsModal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "headerComponent", function(props) {
            var HeaderElement = props.header, src = props.image;
            var ImageElement = function ImageElement() {
                return (0, $avKww.jsx)((0, $336a6c49e4921753$export$1355685fd5f8d257), {
                    src: src,
                    alt: ""
                });
            };
            return HeaderElement || ImageElement;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "footerComponent", function(props) {
            var FooterElement = props.footer, actionList = props.actions, _props$experimental_s = props.experimental_shouldShowPrimaryButtonOnRight, experimental_shouldShowPrimaryButtonOnRight = _props$experimental_s === void 0 ? false : _props$experimental_s;
            var ActionsElement = function ActionsElement() {
                return actionList ? (0, $avKww.jsx)((0, $4nGYJ.default).Provider, {
                    value: (0, $fA3mK.modalButtonTheme)
                }, (0, $avKww.jsx)((0, $336a6c49e4921753$export$633dda6b40ac1ac3), {
                    shouldReverseButtonOrder: experimental_shouldShowPrimaryButtonOnRight
                }, actionList.map(function(_ref, idx) {
                    var text = _ref.text, key = _ref.key, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_ref, $1cbc8fabed6bd9b0$var$_excluded);
                    var variant = idx ? "subtle-link" : "primary";
                    return (0, $avKww.jsx)((0, $336a6c49e4921753$export$c245e9f76e3299b1), {
                        key: key || (typeof text === "string" ? text : "".concat(idx))
                    }, (0, $avKww.jsx)((0, $8FAjc.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                        appearance: variant,
                        autoFocus: !idx
                    }, rest), text));
                }))) : null;
            };
            return FooterElement || ActionsElement;
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(BenefitsModal, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, actions = _this$props.actions, children = _this$props.children, heading = _this$props.heading, props = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(_this$props, $1cbc8fabed6bd9b0$var$_excluded2);
                var Header = this.headerComponent(this.props);
                var Footer = this.footerComponent(this.props);
                var CustomHeader = function CustomHeader() {
                    var _useModal = (0, $5vrjy.useModal)(), titleId = _useModal.titleId;
                    return (0, $avKww.jsx)((0, $336a6c49e4921753$export$9af27c346834c182), {
                        id: titleId
                    }, heading);
                };
                return (0, $avKww.jsx)((0, $cGPG3.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                    autoFocus: true,
                    shouldScrollInViewport: true,
                    shouldCloseOnOverlayClick: false,
                    shouldCloseOnEscapePress: false
                }, props), (0, $avKww.jsx)(Header, null), (0, $avKww.jsx)((0, $ljrFr.default), null, (0, $avKww.jsx)((0, $336a6c49e4921753$export$cb540d8b0ef7906c), null, heading && (0, $avKww.jsx)(CustomHeader, null), children)), (0, $avKww.jsx)(Footer, null));
            }
        }
    ]);
    return BenefitsModal;
}((0, $9nHZC.Component));



var $jmonP = parcelRequire("jmonP");

var $6aoKW = parcelRequire("6aoKW");

var $k2cPS = parcelRequire("k2cPS");

var $agjvf = parcelRequire("agjvf");
var $f529ad2df7157056$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    title: {
        "id": "frontbucket.modals.termsAndConditions.title",
        "defaultMessage": "We\u2019ve updated our terms of service"
    },
    // This message should stay in-sync with changes to TOS
    description: {
        "id": "frontbucket.modals.termsAndConditions.description",
        "defaultMessage": "As we grow, we occasionally need to update our terms of service. To keep using Bitbucket Cloud, review and agree to the updated {termsLink}. To learn more, please see our {summaryLink}."
    },
    link: {
        "id": "frontbucket.modals.termsAndConditions.link",
        "defaultMessage": "terms"
    },
    summaryLink: {
        "id": "frontbucket.modals.termsAndConditions.summaryLink",
        "defaultMessage": "Summary of Changes"
    },
    agree: {
        "id": "frontbucket.modals.termsAndConditions.agree",
        "defaultMessage": "Agree"
    },
    remindMeLater: {
        "id": "frontbucket.modals.termsAndConditions.remindMeLater",
        "defaultMessage": "Not now"
    }
});


var $bd7bb49d30469985$exports = {};

$bd7bb49d30469985$exports = (parcelRequire("1sJKT")).getBundleURL("ekZ4q") + "termsofservice_modalimage.69da62b8.png";


// @ts-ignore TODO: fix noImplicitAny error here
function $b5226a7b1123738a$var$publishEvent(actionSubjectId) {
    (0, $6aoKW.publishUiEvent)({
        action: "clicked",
        actionSubject: "button",
        actionSubjectId: actionSubjectId,
        source: "termsAndConditionsModal"
    });
}
class $b5226a7b1123738a$export$c5f9f38979adda62 extends (0, $9nHZC.PureComponent) {
    constructor(...args){
        super(...args);
        this.state = {
            active: true,
            hasTriggered: false
        };
        this.submit = async ()=>{
            try {
                await fetch((0, $k2cPS.default)("/!api/internal/user/consent", {
                    method: "POST",
                    body: JSON.stringify([
                        "termsOfService"
                    ])
                }));
            } catch (e) {
            // Silently fail for now
            }
            $b5226a7b1123738a$var$publishEvent("acceptButton");
            this.setState({
                active: false
            });
        };
        this.snooze = async ()=>{
            try {
                await fetch((0, $k2cPS.default)("/!api/internal/user/terms/snooze", {
                    method: "POST"
                }));
            } catch (e) {
            // Silently fail for now
            }
            $b5226a7b1123738a$var$publishEvent("dismissButton");
            this.setState({
                active: false
            });
        };
    }
    componentDidMount() {
        this.publishScreenEvent();
    }
    componentDidUpdate() {
        this.publishScreenEvent();
    }
    publishScreenEvent() {
        if (this.props.showTermsAndConditions && this.state.hasTriggered === false) {
            this.setState({
                hasTriggered: true
            });
            (0, $6aoKW.publishScreenEvent)("termsAndConditionsModal");
        }
    }
    render() {
        const { active: active } = this.state;
        const { intl: intl, showTermsAndConditions: showTermsAndConditions } = this.props;
        if (!showTermsAndConditions || !active) return null;
        const termsLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("a", {
            href: "https://www.atlassian.com/legal/cloud-terms-of-service",
            target: "_blank"
        }, intl.formatMessage((0, $f529ad2df7157056$export$2e2bcd8739ae039).link));
        const summaryLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("a", {
            href: "https://www.atlassian.com/legal/summary-of-changes",
            target: "_blank"
        }, intl.formatMessage((0, $f529ad2df7157056$export$2e2bcd8739ae039).summaryLink));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $1cbc8fabed6bd9b0$export$2e2bcd8739ae039), {
            actions: [
                {
                    onClick: this.submit,
                    text: intl.formatMessage((0, $f529ad2df7157056$export$2e2bcd8739ae039).agree)
                },
                {
                    onClick: this.snooze,
                    text: intl.formatMessage((0, $f529ad2df7157056$export$2e2bcd8739ae039).remindMeLater)
                }
            ],
            heading: intl.formatMessage((0, $f529ad2df7157056$export$2e2bcd8739ae039).title),
            image: (0, (/*@__PURE__*/$parcel$interopDefault($bd7bb49d30469985$exports)))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, (0, $f529ad2df7157056$export$2e2bcd8739ae039).description, {
            values: {
                termsLink: termsLink,
                summaryLink: summaryLink
            }
        })));
    }
}
const $b5226a7b1123738a$var$mapStateToProps = (state)=>({
        showTermsAndConditions: !!state.global.needsTermsAndConditions && !(0, $jmonP.default)()
    });
var $b5226a7b1123738a$export$2e2bcd8739ae039 = (0, $5oGLl.default)($b5226a7b1123738a$var$mapStateToProps)((0, $agjvf.injectIntl)($b5226a7b1123738a$export$c5f9f38979adda62));



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $3XbtU = parcelRequire("3XbtU");
parcelRequire("dGzLf");
var $5oGLl = parcelRequire("5oGLl");

var $1zBji = parcelRequire("1zBji");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $9nHZC = parcelRequire("9nHZC");
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths, @atlassian/tangerine/import/no-parent-imports */ 
var $b8tvv = parcelRequire("b8tvv");

var $eeQJ3 = parcelRequire("eeQJ3");

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $hlgjl = parcelRequire("hlgjl");
parcelRequire("45CBz");
var $7KAwG = parcelRequire("7KAwG");
var $45CBz = parcelRequire("45CBz");

var $3Jogu = parcelRequire("3Jogu");

var $aP6k3 = parcelRequire("aP6k3");

var $aP6k3 = parcelRequire("aP6k3");
var $9f9b3ba0a917f12c$export$cac609a3cdfd0268 = (0, $aP6k3.gridSize)() * 55; // 440
var $9f9b3ba0a917f12c$export$d3b22831e495441e = (0, $aP6k3.gridSize)() * 6; // 48


var $12cee0110ac9c403$var$_templateObject;
var $12cee0110ac9c403$var$animationDuration = 300;
var $12cee0110ac9c403$var$offscreen = {
    translateX: "".concat((0, $9f9b3ba0a917f12c$export$cac609a3cdfd0268) + (0, $9f9b3ba0a917f12c$export$d3b22831e495441e), "px"),
    opacity: "0"
};
var $12cee0110ac9c403$var$getAnimationProps = function getAnimationProps(state) {
    switch(state){
        case "entering":
            return $12cee0110ac9c403$var$offscreen;
        case "entered":
            return {
                translateX: "0",
                opacity: "1"
            };
        case "exited":
        case "exiting":
            return $12cee0110ac9c403$var$offscreen;
    }
};
function $12cee0110ac9c403$export$2e2bcd8739ae039(props) {
    var children = props.children, shouldShow = props.shouldShow;
    return (0, $45CBz.jsx)((0, $3Jogu.default), {
        in: shouldShow,
        timeout: $12cee0110ac9c403$var$animationDuration,
        unmountOnExit: true
    }, function(state) {
        var _getAnimationProps = $12cee0110ac9c403$var$getAnimationProps(state), translateX = _getAnimationProps.translateX, opacity = _getAnimationProps.opacity;
        return (0, $45CBz.jsx)("div", {
            css: (0, $7KAwG.default)($12cee0110ac9c403$var$_templateObject || ($12cee0110ac9c403$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
                "\n              position: fixed;\n              right: ",
                "px;\n              bottom: ",
                "px;\n              z-index: ",
                ";\n              transform: translateX(",
                ");\n              opacity: ",
                ";\n              transition: all ",
                "ms ease-in-out;\n              transition-property: transform, opacity;\n            "
            ])), (0, $9f9b3ba0a917f12c$export$d3b22831e495441e), (0, $9f9b3ba0a917f12c$export$d3b22831e495441e), (0, $aP6k3.layers).flag(), translateX, opacity, $12cee0110ac9c403$var$animationDuration)
        }, children());
    });
}




var $4mVfk = parcelRequire("4mVfk");

var $8DpVo = parcelRequire("8DpVo");


var $be885d7a781cc839$var$hisiGetFlagTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($5258d0c7398e5f78$exports))).parse("/engage-targeting/api/v2/user/{cloudId}/hisi/flag{?userKey,flagKey}");
var $be885d7a781cc839$export$9388e2e6cf5978f0 = "/engage-targeting/api/v2/user/{cloudId}/hisi/flag";
function $be885d7a781cc839$export$a19b74191e00c5e(_x, _x2, _x3, _x4) {
    return $be885d7a781cc839$var$_getFlag.apply(this, arguments);
}
function $be885d7a781cc839$var$_getFlag() {
    $be885d7a781cc839$var$_getFlag = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee(stargateUrl, cloudId, flagKey, userKey) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", (0, $e215735b489502b1$export$317bcea84a3bea48)("".concat(stargateUrl).concat($be885d7a781cc839$var$hisiGetFlagTemplate.expand({
                        cloudId: cloudId,
                        userKey: userKey,
                        flagKey: flagKey
                    })), {
                        method: "GET"
                    }).then((0, $e215735b489502b1$export$4adbd37839ed7718)).then(function(r) {
                        return r.json();
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $be885d7a781cc839$var$_getFlag.apply(this, arguments);
}
function $be885d7a781cc839$export$5e165df1e30a1331(_x5, _x6, _x7, _x8) {
    return $be885d7a781cc839$var$_setFlag.apply(this, arguments);
}
function $be885d7a781cc839$var$_setFlag() {
    $be885d7a781cc839$var$_setFlag = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee2(stargateUrl, cloudId, flagKey, userKey) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    return _context2.abrupt("return", (0, $e215735b489502b1$export$317bcea84a3bea48)("".concat(stargateUrl).concat($be885d7a781cc839$export$9388e2e6cf5978f0), {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            userKey: userKey,
                            flagKey: flagKey
                        })
                    }).then((0, $e215735b489502b1$export$4adbd37839ed7718)).then(function(r) {
                        return r;
                    }).then(function() {
                        return Promise.resolve();
                    }));
                case 1:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $be885d7a781cc839$var$_setFlag.apply(this, arguments);
}



var $fPPqr = parcelRequire("fPPqr");

var $4mVfk = parcelRequire("4mVfk");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $8DpVo = parcelRequire("8DpVo");

var $9nHZC = parcelRequire("9nHZC");

var $4mVfk = parcelRequire("4mVfk");

var $9q1kH = parcelRequire("9q1kH");

var $8DpVo = parcelRequire("8DpVo");

var $9nHZC = parcelRequire("9nHZC");

var $hlgjl = parcelRequire("hlgjl");
parcelRequire("45CBz");
var $7KAwG = parcelRequire("7KAwG");
var $45CBz = parcelRequire("45CBz");

var $aP6k3 = parcelRequire("aP6k3");

var $hlgjl = parcelRequire("hlgjl");
parcelRequire("45CBz");
var $7KAwG = parcelRequire("7KAwG");
var $45CBz = parcelRequire("45CBz");
var $a5434e2c392a8c3e$exports = {};
"use strict";
Object.defineProperty($a5434e2c392a8c3e$exports, "__esModule", {
    value: true
});
$a5434e2c392a8c3e$exports.default = void 0;

var $a5434e2c392a8c3e$var$_react = $a5434e2c392a8c3e$var$_interopRequireDefault((parcelRequire("9nHZC")));

var $fPPqr = parcelRequire("fPPqr");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $5LVXk = parcelRequire("5LVXk");
var $5e2713b53801d295$var$themedBackground = {
    light: "var(--ds-surface, #FFFFFF)",
    dark: "var(--ds-surface, #1B2638)"
};
var $5e2713b53801d295$export$18cb9425622d4e06 = function getBackground() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "light";
    return $5e2713b53801d295$var$themedBackground[mode];
};


var $09ee12e0ea913c44$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $09ee12e0ea913c44$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $09ee12e0ea913c44$export$62ad7b0c781000e9 = {
    small: {
        width: $09ee12e0ea913c44$export$c647cb0ee6e282fe.small,
        height: $09ee12e0ea913c44$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $09ee12e0ea913c44$export$c647cb0ee6e282fe.medium,
        height: $09ee12e0ea913c44$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $09ee12e0ea913c44$export$c647cb0ee6e282fe.large,
        height: $09ee12e0ea913c44$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $09ee12e0ea913c44$export$c647cb0ee6e282fe.xlarge,
        height: $09ee12e0ea913c44$export$c647cb0ee6e282fe.xlarge
    }
};



var $avKww = parcelRequire("avKww");
var $b0b1a2a973253c3d$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
var $b0b1a2a973253c3d$var$smallStyles = (0, $avKww.css)((0, $09ee12e0ea913c44$export$62ad7b0c781000e9).small);
var $b0b1a2a973253c3d$var$mediumStyles = (0, $avKww.css)((0, $09ee12e0ea913c44$export$62ad7b0c781000e9).medium);
var $b0b1a2a973253c3d$var$largeStyles = (0, $avKww.css)((0, $09ee12e0ea913c44$export$62ad7b0c781000e9).large);
var $b0b1a2a973253c3d$var$xlargeStyles = (0, $avKww.css)((0, $09ee12e0ea913c44$export$62ad7b0c781000e9).xlarge);
var $b0b1a2a973253c3d$export$ef0ad74202575b64 = {
    small: $b0b1a2a973253c3d$var$smallStyles,
    medium: $b0b1a2a973253c3d$var$mediumStyles,
    large: $b0b1a2a973253c3d$var$largeStyles,
    xlarge: $b0b1a2a973253c3d$var$xlargeStyles
};
var $b0b1a2a973253c3d$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $09ee12e0ea913c44$export$62ad7b0c781000e9)[size];
    return undefined;
};


function $0f7f8444ec54dc66$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0f7f8444ec54dc66$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0f7f8444ec54dc66$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0f7f8444ec54dc66$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $0f7f8444ec54dc66$var$iconStyles = (0, $avKww.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "> svg": $0f7f8444ec54dc66$var$_objectSpread($0f7f8444ec54dc66$var$_objectSpread({}, (0, $b0b1a2a973253c3d$export$16374db1c3e6dfba)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $0f7f8444ec54dc66$var$baseHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $0f7f8444ec54dc66$var$primaryEqualsSecondaryHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $0f7f8444ec54dc66$var$secondaryTransparentHcmStyles = (0, $avKww.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $0f7f8444ec54dc66$export$f04a61298a47a40f = /*#__PURE__*/ (0, $9nHZC.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $avKww.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $b0b1a2a973253c3d$export$3eb7d6130acfda37)({
        width: width,
        height: height,
        size: size
    });
    var _useGlobalTheme = (0, $5LVXk.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $avKww.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            "--icon-secondary-color": secondaryColor || (0, $5e2713b53801d295$export$18cb9425622d4e06)(mode)
        }
    }, glyphProps, {
        css: [
            $0f7f8444ec54dc66$var$iconStyles,
            $0f7f8444ec54dc66$var$baseHcmStyles,
            primaryColor === secondaryColor && $0f7f8444ec54dc66$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $0f7f8444ec54dc66$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsualting them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $avKww.css)({
                width: dimensions.width,
                height: dimensions.height,
                "> svg": dimensions
            })
        ]
    }));
});
var $0f7f8444ec54dc66$export$2e2bcd8739ae039 = $0f7f8444ec54dc66$export$f04a61298a47a40f;


function $a5434e2c392a8c3e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a5434e2c392a8c3e$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $a5434e2c392a8c3e$var$_react.default.createElement($0f7f8444ec54dc66$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><path d="M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z" fill="inherit"/></g></svg>`
    }, props));
$a5434e2c392a8c3e$var$CheckCircleIcon.displayName = "CheckCircleIcon";
var $a5434e2c392a8c3e$var$_default = $a5434e2c392a8c3e$var$CheckCircleIcon;
$a5434e2c392a8c3e$exports.default = $a5434e2c392a8c3e$var$_default;



var $jp7ng = parcelRequire("jp7ng");
var $21f38931e77dbfda$var$_templateObject, $21f38931e77dbfda$var$_templateObject2;
var $21f38931e77dbfda$export$2e2bcd8739ae039 = function(_ref) {
    var children = _ref.children;
    return (0, $45CBz.jsx)("section", {
        css: (0, $7KAwG.default)($21f38931e77dbfda$var$_templateObject || ($21f38931e77dbfda$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
            "\n      margin-left: ",
            ";\n    "
        ])), "var(--ds-space-500, 40px)")
    }, (0, $45CBz.jsx)("div", {
        css: (0, $7KAwG.default)($21f38931e77dbfda$var$_templateObject2 || ($21f38931e77dbfda$var$_templateObject2 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
            "\n        position: absolute;\n        top: ",
            ";\n        left: ",
            ";\n      "
        ])), "var(--ds-space-300, 24px)", "var(--ds-space-300, 24px)")
    }, (0, $45CBz.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a5434e2c392a8c3e$exports))), {
        label: "",
        "aria-hidden": true,
        primaryColor: "var(--ds-icon-success, ".concat((0, $jp7ng.G300), ")")
    })), children);
};


var $66a534f1cd958bf7$var$_templateObject;
var $66a534f1cd958bf7$export$2e2bcd8739ae039 = function() {
    return (0, $45CBz.jsx)((0, $21f38931e77dbfda$export$2e2bcd8739ae039), null, (0, $45CBz.jsx)("h1", {
        css: (0, $7KAwG.default)($66a534f1cd958bf7$var$_templateObject || ($66a534f1cd958bf7$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
            "\n        font-size: ",
            "px;\n        font-weight: 600;\n        margin-top: 0;\n        line-height: ",
            ";\n      "
        ])), (0, $aP6k3.fontSize)(), "var(--ds-font-lineHeight-300, 24px)")
    }, "Thanks for your feedback"));
};



var $hlgjl = parcelRequire("hlgjl");

var $4mVfk = parcelRequire("4mVfk");

var $9q1kH = parcelRequire("9q1kH");

var $8DpVo = parcelRequire("8DpVo");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("45CBz");
var $7KAwG = parcelRequire("7KAwG");
var $45CBz = parcelRequire("45CBz");

var $EKmRU = parcelRequire("EKmRU");

var $aP6k3 = parcelRequire("aP6k3");

var $ee10509ebcf90542$var$_templateObject, $ee10509ebcf90542$var$_templateObject2;
var $ee10509ebcf90542$export$2e2bcd8739ae039 = function(_ref) {
    var onAnswer = _ref.onAnswer;
    var _useState = (0, $9nHZC.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), pending = _useState2[0], setPending = _useState2[1];
    var answeredWith = (0, $9nHZC.useCallback)(/*#__PURE__*/ function() {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee(answer) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        setPending(answer ? "yes" : "no");
                        _context.next = 3;
                        return onAnswer(answer);
                    case 3:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function(_x) {
            return _ref2.apply(this, arguments);
        };
    }(), [
        setPending,
        onAnswer
    ]);
    var isDisabled = Boolean(pending);
    return (0, $45CBz.jsx)((0, $21f38931e77dbfda$export$2e2bcd8739ae039), null, (0, $45CBz.jsx)("h1", {
        css: (0, $7KAwG.default)($ee10509ebcf90542$var$_templateObject || ($ee10509ebcf90542$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
            "\n          font-size: ",
            "px;\n          font-weight: 600;\n          margin: 0;\n          line-height: ",
            ";\n        "
        ])), (0, $aP6k3.fontSize)(), "var(--ds-font-lineHeight-300, 24px)")
    }, "Thanks for your feedback"), (0, $45CBz.jsx)("p", null, "Are you interested in participating in our research?"), (0, $45CBz.jsx)("p", null, "Sign up for the", " ", (0, $45CBz.jsx)("a", {
        href: "https://www.atlassian.com/research-group"
    }, "Atlassian Research Group"), " ", "and we may contact you in the future with research opportunities."), (0, $45CBz.jsx)("div", {
        css: (0, $7KAwG.default)($ee10509ebcf90542$var$_templateObject2 || ($ee10509ebcf90542$var$_templateObject2 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
            "\n          margin-top: ",
            ";\n          display: flex;\n          justify-content: flex-end;\n\n          & > * + * {\n            margin-left: ",
            ";\n          }\n        "
        ])), "var(--ds-space-400, 32px)", "var(--ds-space-100, 8px)")
    }, (0, $45CBz.jsx)((0, $EKmRU.default), {
        appearance: "subtle",
        onClick: function onClick() {
            return answeredWith(false);
        },
        isDisabled: isDisabled,
        isLoading: pending === "no"
    }, "No, thanks"), (0, $45CBz.jsx)((0, $EKmRU.default), {
        appearance: "primary",
        onClick: function onClick() {
            return answeredWith(true);
        },
        isDisabled: isDisabled,
        isLoading: pending === "yes"
    }, "Yes, sign me up")));
};



var $hlgjl = parcelRequire("hlgjl");

var $fI6ia = parcelRequire("fI6ia");
parcelRequire("45CBz");
var $7KAwG = parcelRequire("7KAwG");
var $45CBz = parcelRequire("45CBz");

var $aP6k3 = parcelRequire("aP6k3");

var $789e05248dc00a8c$var$_templateObject;
var $789e05248dc00a8c$export$2e2bcd8739ae039 = function(_ref) {
    (0, (/*@__PURE__*/$parcel$interopDefault($fI6ia)))(_ref);
    return (0, $45CBz.jsx)((0, $21f38931e77dbfda$export$2e2bcd8739ae039), null, (0, $45CBz.jsx)("h1", {
        css: (0, $7KAwG.default)($789e05248dc00a8c$var$_templateObject || ($789e05248dc00a8c$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
            "\n        font-size: ",
            "px;\n        font-weight: 600;\n        line-height: ",
            ";\n        margin: 0;\n      "
        ])), (0, $aP6k3.fontSize)(), "var(--ds-font-lineHeight-300, 24px)")
    }, "Thanks for signing up"), (0, $45CBz.jsx)("p", null, "We may reach out to you in the future to participate in additional research."));
};



var $hlgjl = parcelRequire("hlgjl");
parcelRequire("45CBz");
var $7KAwG = parcelRequire("7KAwG");
var $45CBz = parcelRequire("45CBz");

var $EKmRU = parcelRequire("EKmRU");
var $b7fbcff9351709a8$exports = {};
"use strict";
Object.defineProperty($b7fbcff9351709a8$exports, "__esModule", {
    value: true
});
$b7fbcff9351709a8$exports.default = void 0;

var $b7fbcff9351709a8$var$_react = $b7fbcff9351709a8$var$_interopRequireDefault((parcelRequire("9nHZC")));

function $b7fbcff9351709a8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b7fbcff9351709a8$var$CrossIcon = (props)=>/*#__PURE__*/ $b7fbcff9351709a8$var$_react.default.createElement($0f7f8444ec54dc66$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 10.586L6.707 5.293a1 1 0 00-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 001.414 1.414L12 13.414l5.293 5.293a1 1 0 001.414-1.414L13.414 12l5.293-5.293a1 1 0 10-1.414-1.414L12 10.586z" fill="currentColor"/></svg>`
    }, props));
$b7fbcff9351709a8$var$CrossIcon.displayName = "CrossIcon";
var $b7fbcff9351709a8$var$_default = $b7fbcff9351709a8$var$CrossIcon;
$b7fbcff9351709a8$exports.default = $b7fbcff9351709a8$var$_default;



var $jp7ng = parcelRequire("jp7ng");

var $aP6k3 = parcelRequire("aP6k3");

var $898b9ec033c0a039$var$_templateObject, $898b9ec033c0a039$var$_templateObject2;
var $898b9ec033c0a039$export$2e2bcd8739ae039 = function(_ref) {
    var children = _ref.children, onDismiss = _ref.onDismiss;
    return (0, $45CBz.jsx)("div", {
        css: (0, $7KAwG.default)($898b9ec033c0a039$var$_templateObject || ($898b9ec033c0a039$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
            "\n        background-color: ",
            ";\n        border-radius: ",
            "px;\n        padding: ",
            ";\n        box-shadow: ",
            ";\n        width: ",
            "px;\n      "
        ])), "var(--ds-surface-overlay, ".concat((0, $jp7ng.N0), ")"), (0, $aP6k3.borderRadius)(), "var(--ds-space-300, 24px)", "var(--ds-shadow-overlay, ".concat("0 20px 32px -8px ".concat((0, $jp7ng.N50A), ", 0 0 1px ").concat((0, $jp7ng.N60A)), ")"), (0, $9f9b3ba0a917f12c$export$cac609a3cdfd0268))
    }, (0, $45CBz.jsx)("div", {
        css: (0, $7KAwG.default)($898b9ec033c0a039$var$_templateObject2 || ($898b9ec033c0a039$var$_templateObject2 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
            "\n          position: absolute;\n          top: ",
            ";\n          right: ",
            ";\n        "
        ])), "var(--ds-space-200, 16px)", "var(--ds-space-200, 16px)")
    }, (0, $45CBz.jsx)((0, $EKmRU.default), {
        iconBefore: (0, $45CBz.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b7fbcff9351709a8$exports))), {
            label: "",
            primaryColor: "var(--ds-icon-subtle, ".concat((0, $jp7ng.N50), ")")
        }),
        "aria-label": "Dismiss",
        appearance: "subtle",
        onClick: onDismiss
    })), children);
};



var $fPPqr = parcelRequire("fPPqr");

var $hlgjl = parcelRequire("hlgjl");

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("45CBz");
var $7KAwG = parcelRequire("7KAwG");
var $45CBz = parcelRequire("45CBz");

var $3Jogu = parcelRequire("3Jogu");

var $EKmRU = parcelRequire("EKmRU");

var $5oo0Y = parcelRequire("5oo0Y");

var $1K9zK = parcelRequire("1K9zK");
var $ezi8k = parcelRequire("ezi8k");
var $7S5Ao = parcelRequire("7S5Ao");
var $5H0cN = parcelRequire("5H0cN");

var $fPPqr = parcelRequire("fPPqr");

var $340K4 = parcelRequire("340K4");

var $kFnE9 = parcelRequire("kFnE9");

var $lOQkO = parcelRequire("lOQkO");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $dNznA = parcelRequire("dNznA");

var $b4Ivn = parcelRequire("b4Ivn");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $h4cnL = parcelRequire("h4cnL");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $340K4 = parcelRequire("340K4");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $kFnE9 = parcelRequire("kFnE9");
function $acd54e91cbb198ce$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $acd54e91cbb198ce$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $acd54e91cbb198ce$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $acd54e91cbb198ce$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $acd54e91cbb198ce$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $acd54e91cbb198ce$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $acd54e91cbb198ce$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $acd54e91cbb198ce$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(updater) === "object") this.payload = $acd54e91cbb198ce$var$_objectSpread($acd54e91cbb198ce$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();


function $b055691920f7b5a0$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b055691920f7b5a0$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $b055691920f7b5a0$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b055691920f7b5a0$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $b055691920f7b5a0$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $b055691920f7b5a0$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $b055691920f7b5a0$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $b055691920f7b5a0$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($h4cnL)))((0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $acd54e91cbb198ce$export$2e2bcd8739ae039));



var $9nHZC = parcelRequire("9nHZC");

var $kZnbM = parcelRequire("kZnbM");
var $c7e192b94b8719f2$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $9nHZC.useContext)((0, $kZnbM.default));
};


function $bcbdccc2039a7b2d$export$5bf35293e545f20c() {
    var analyticsContext = (0, $c7e192b94b8719f2$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $dNznA.useCallbackOne)(function(payload) {
        return new (0, $b055691920f7b5a0$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $9nHZC = parcelRequire("9nHZC");
var $a5eb7ac08d80421a$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $9nHZC.useRef)(value);
    ref.current = value;
    return ref;
};


function $177af0ccb9b233f3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $177af0ccb9b233f3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $177af0ccb9b233f3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $177af0ccb9b233f3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $177af0ccb9b233f3$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $bcbdccc2039a7b2d$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $a5eb7ac08d80421a$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $a5eb7ac08d80421a$export$1d27a74659855e44)(fn);
    var handler = (0, $9nHZC.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $177af0ccb9b233f3$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $5LVXk = parcelRequire("5LVXk");

var $kFnE9 = parcelRequire("kFnE9");

var $avKww = parcelRequire("avKww");

var $dEQSq = parcelRequire("dEQSq");

var $aP6k3 = parcelRequire("aP6k3");
function $9233558c6eeea5d6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9233558c6eeea5d6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9233558c6eeea5d6$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9233558c6eeea5d6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $9233558c6eeea5d6$var$grid = (0, $aP6k3.gridSize)();
var $9233558c6eeea5d6$var$borderRadius = 3;
var $9233558c6eeea5d6$var$lineHeightBase = $9233558c6eeea5d6$var$grid * 2.5;
var $9233558c6eeea5d6$var$lineHeightCompact = $9233558c6eeea5d6$var$grid * 2;
var $9233558c6eeea5d6$var$compactVerticalPadding = 2;
var $9233558c6eeea5d6$var$verticalPadding = 6;
var $9233558c6eeea5d6$var$horizontalPadding = $9233558c6eeea5d6$var$grid;
var $9233558c6eeea5d6$var$transitionDuration = "0.2s";
var $9233558c6eeea5d6$var$fontSize = (0, $aP6k3.fontSize)();
var $9233558c6eeea5d6$var$fontFamily = (0, $aP6k3.fontFamily)();
var $9233558c6eeea5d6$var$codeFontFamily = (0, $aP6k3.codeFontFamily)();
var $9233558c6eeea5d6$export$12879c7697ed953d = 2;
// Safari puts on some difficult to remove styles, mainly for disabled inputs
// but we want full control so need to override them in all cases
var $9233558c6eeea5d6$var$overrideSafariDisabledStyles = {
    WebkitTextFillColor: "unset",
    WebkitOpacity: "1"
};
var $9233558c6eeea5d6$var$borderBoxMinHeight = function borderBoxMinHeight(minimumRows, borderHeight) {
    var contentHeight = $9233558c6eeea5d6$var$lineHeightBase * minimumRows;
    return contentHeight + $9233558c6eeea5d6$var$verticalPadding * 2 + borderHeight * 2;
};
var $9233558c6eeea5d6$var$borderBoxMinHeightCompact = function borderBoxMinHeightCompact(minimumRows, borderHeight) {
    var contentHeightCompact = $9233558c6eeea5d6$var$lineHeightCompact * minimumRows;
    return contentHeightCompact + $9233558c6eeea5d6$var$compactVerticalPadding * 2 + borderHeight * 2;
};
var $9233558c6eeea5d6$var$bgAndBorderColorStyles = function bgAndBorderColorStyles(props, appearance) {
    return (0, $avKww.css)($9233558c6eeea5d6$var$_objectSpread({
        "&:focus": {
            backgroundColor: props.backgroundColorFocus,
            borderColor: props.borderColorFocus,
            boxShadow: (0, $dEQSq.getBooleanFF)("platform.design-system-team.update-border-input_ff9l1") ? "inset 0 0 0 1px ".concat(props.borderColorFocus) : undefined
        },
        "&:not(:focus)": {
            backgroundColor: props.backgroundColor,
            borderColor: props.borderColor
        },
        // eslint-disable-next-line @repo/internal/styles/no-nested-styles
        "&[data-invalid]:focus": {
            backgroundColor: props.invalidRules.backgroundColorFocus,
            borderColor: props.invalidRules.borderColorFocus,
            boxShadow: (0, $dEQSq.getBooleanFF)("platform.design-system-team.update-border-input_ff9l1") ? "inset 0 0 0 1px ".concat(props.invalidRules.borderColorFocus) : undefined
        },
        // eslint-disable-next-line @repo/internal/styles/no-nested-styles
        "&[data-invalid]:not(:focus)": {
            backgroundColor: props.invalidRules.backgroundColor,
            borderColor: props.invalidRules.borderColor,
            boxShadow: (0, $dEQSq.getBooleanFF)("platform.design-system-team.update-border-input_ff9l1") ? "inset 0 0 0 1px ".concat(props.invalidRules.borderColor) : undefined
        }
    }, appearance === "standard" ? {
        "&:disabled:focus": {
            backgroundColor: props.disabledRules.backgroundColorFocus,
            borderColor: props.disabledRules.borderColorFocus
        },
        "&:disabled:not(:focus)": {
            backgroundColor: props.disabledRules.backgroundColor,
            borderColor: props.disabledRules.borderColor
        }
    } : {}));
};
var $9233558c6eeea5d6$var$placeholderStyle = function placeholderStyle(placeholderTextColor) {
    return (0, $avKww.css)({
        "&::placeholder": {
            color: placeholderTextColor
        }
    });
};
var $9233558c6eeea5d6$var$hoverBackgroundAndBorderStyles = function hoverBackgroundAndBorderStyles(props) {
    return (0, $avKww.css)({
        "&:hover:not(:read-only):not(:focus)": {
            backgroundColor: props.backgroundColorHover,
            borderColor: props.borderColorHover,
            "&:disabled": {
                backgroundColor: props.disabledRules.backgroundColorHover
            },
            // eslint-disable-next-line @repo/internal/styles/no-nested-styles
            "&[data-invalid]": {
                backgroundColor: props.invalidRules.backgroundColorHover,
                borderColor: props.invalidRules.borderColor,
                boxShadow: (0, $dEQSq.getBooleanFF)("platform.design-system-team.update-border-input_ff9l1") ? "inset 0 0 0 1px ".concat(props.invalidRules.borderColor) : undefined
            }
        }
    });
};
var $9233558c6eeea5d6$var$resizeStyle = function resizeStyle(resize) {
    if (resize === "horizontal" || resize === "vertical") return (0, $avKww.css)({
        resize: resize
    });
    if (resize === "auto") return (0, $avKww.css)({
        resize: "both"
    });
    return (0, $avKww.css)({
        resize: "none"
    });
};
var $9233558c6eeea5d6$var$borderStyle = function borderStyle(appearance) {
    return (0, $avKww.css)({
        borderStyle: appearance === "none" ? "none" : "solid"
    });
};
var $9233558c6eeea5d6$var$fontFamilyStyle = function fontFamilyStyle(isMonospaced) {
    return (0, $avKww.css)({
        fontFamily: isMonospaced ? $9233558c6eeea5d6$var$codeFontFamily : $9233558c6eeea5d6$var$fontFamily
    });
};
var $9233558c6eeea5d6$var$borderPaddingAndHeightStyles = function borderPaddingAndHeightStyles() {
    var minimumRows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var appearance = arguments.length > 1 ? arguments[1] : undefined;
    var borderWidth = (0, $dEQSq.getBooleanFF)("platform.design-system-team.update-border-input_ff9l1") && appearance !== "none" ? 1 : 2;
    var horizontalPaddingWithoutBorderWidth = $9233558c6eeea5d6$var$horizontalPadding - borderWidth;
    var borderHeight = borderWidth;
    return (0, $avKww.css)({
        // eslint-disable-next-line @repo/internal/styles/no-nested-styles
        "&[data-compact]": {
            minHeight: $9233558c6eeea5d6$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage-spacing
            padding: "".concat($9233558c6eeea5d6$var$compactVerticalPadding, "px ").concat(horizontalPaddingWithoutBorderWidth, "px"),
            lineHeight: $9233558c6eeea5d6$var$lineHeightCompact / $9233558c6eeea5d6$var$fontSize
        },
        "&:not([data-compact])": {
            minHeight: $9233558c6eeea5d6$var$borderBoxMinHeight(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage-spacing
            padding: "".concat($9233558c6eeea5d6$var$verticalPadding, "px ").concat(horizontalPaddingWithoutBorderWidth, "px"),
            lineHeight: $9233558c6eeea5d6$var$lineHeightBase / $9233558c6eeea5d6$var$fontSize
        }
    });
};
var $9233558c6eeea5d6$var$staticStyles = (0, $avKww.css)({
    display: "block",
    boxSizing: "border-box",
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
    margin: 0,
    position: "relative",
    flex: "1 1 100%",
    borderRadius: $9233558c6eeea5d6$var$borderRadius,
    borderWidth: (0, $dEQSq.getBooleanFF)("platform.design-system-team.update-border-input_ff9l1") ? 1 : $9233558c6eeea5d6$export$12879c7697ed953d,
    fontSize: $9233558c6eeea5d6$var$fontSize,
    outline: "none",
    overflow: "auto",
    transition: "background-color ".concat($9233558c6eeea5d6$var$transitionDuration, " ease-in-out,\n               border-color ").concat($9233558c6eeea5d6$var$transitionDuration, " ease-in-out"),
    wordWrap: "break-word",
    "&:disabled": $9233558c6eeea5d6$var$_objectSpread({
        cursor: "not-allowed"
    }, $9233558c6eeea5d6$var$overrideSafariDisabledStyles),
    "&::-ms-clear": {
        display: "none"
    },
    "&:invalid": {
        boxShadow: "none"
    }
});
var $9233558c6eeea5d6$export$bff8031d86bb089 = function getBaseStyles(_ref) {
    var minimumRows = _ref.minimumRows, resize = _ref.resize, appearance = _ref.appearance, isMonospaced = _ref.isMonospaced, maxHeight = _ref.maxHeight;
    return(// eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $avKww.css)([
        $9233558c6eeea5d6$var$staticStyles,
        $9233558c6eeea5d6$var$borderPaddingAndHeightStyles(minimumRows, appearance),
        $9233558c6eeea5d6$var$resizeStyle(resize),
        $9233558c6eeea5d6$var$borderStyle(appearance),
        $9233558c6eeea5d6$var$fontFamilyStyle(isMonospaced),
        {
            maxHeight: maxHeight
        }
    ]));
};
var $9233558c6eeea5d6$export$ded1c27b355b104 = function themeStyles(props, appearance) {
    return(// eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $avKww.css)([
        $9233558c6eeea5d6$var$bgAndBorderColorStyles(props, appearance),
        $9233558c6eeea5d6$var$hoverBackgroundAndBorderStyles(props),
        $9233558c6eeea5d6$var$placeholderStyle(props.placeholderTextColor),
        {
            color: props.textColor,
            "&:disabled": {
                color: props.disabledRules.textColor
            }
        }
    ]));
};



var $dHFxE = parcelRequire("dHFxE");

var $dEQSq = parcelRequire("dEQSq");

var $jp7ng = parcelRequire("jp7ng");
var $ed10471c65f0492c$export$ae3cba7672df0890 = {
    light: "var(--ds-background-disabled, ".concat((0, $jp7ng.N20), ")"),
    dark: "var(--ds-background-disabled, ".concat((0, $jp7ng.DN20), ")")
};
var $ed10471c65f0492c$export$fe505fe3c5edbdf6 = {
    light: "var(--ds-border-disabled, ".concat((0, $jp7ng.N40), ")"),
    dark: "var(--ds-border-disabled, ".concat((0, $jp7ng.DN40), ")")
};
var $ed10471c65f0492c$export$7f333bbf7ddab792 = {
    light: "var(--ds-border-danger, ".concat((0, $jp7ng.R400), ")"),
    dark: "var(--ds-border-danger, ".concat((0, $jp7ng.R400), ")")
};
var $ed10471c65f0492c$export$dafd83031c202ca8 = {
    light: "var(--ds-border-input, ".concat((0, $dEQSq.getBooleanFF)("platform.design-system-team.update-border-input_ff9l1") ? (0, $jp7ng.N100) : (0, $jp7ng.N40), ")"),
    dark: "var(--ds-border-input, ".concat((0, $dEQSq.getBooleanFF)("platform.design-system-team.update-border-input_ff9l1") ? (0, $jp7ng.DN200) : (0, $jp7ng.DN40), ")")
};
var $ed10471c65f0492c$export$e8320c09dc1e4012 = {
    light: "var(--ds-border-focused, ".concat((0, $jp7ng.B100), ")"),
    dark: "var(--ds-border-focused, ".concat((0, $jp7ng.B75), ")")
};
var $ed10471c65f0492c$export$b13414ee9ac9cae6 = {
    light: "var(--ds-background-input, ".concat((0, $jp7ng.N10), ")"),
    dark: "var(--ds-background-input, ".concat((0, $jp7ng.DN10), ")")
};
var $ed10471c65f0492c$export$bca15982c103d57b = {
    light: "var(--ds-background-input-hovered, ".concat((0, $jp7ng.N30), ")"),
    dark: "var(--ds-background-input-hovered, ".concat((0, $jp7ng.DN30), ")")
};
var $ed10471c65f0492c$export$21287e4b7f134f09 = {
    light: "var(--ds-background-input-pressed, ".concat((0, $jp7ng.N0), ")"),
    dark: "var(--ds-background-input-pressed, ".concat((0, $jp7ng.DN10), ")")
};
var $ed10471c65f0492c$export$a87538d56ee366ec = {
    light: "var(--ds-border-input, transparent)",
    dark: "var(--ds-border-input, transparent)"
};
var $ed10471c65f0492c$export$5e076b2557ef7bbb = {
    light: "var(--ds-text-subtlest, ".concat((0, $jp7ng.N200), ")"),
    dark: "var(--ds-text-subtlest, ".concat((0, $jp7ng.DN200), ")")
};
var $ed10471c65f0492c$export$32f78bffcd82ff28 = {
    light: "var(--ds-text, ".concat((0, $jp7ng.N900), ")"),
    dark: "var(--ds-text, ".concat((0, $jp7ng.DN600), ")")
};
var $ed10471c65f0492c$export$eb4a7d363eec53c8 = {
    light: "var(--ds-text-disabled, ".concat((0, $jp7ng.N70), ")"),
    dark: "var(--ds-text-disabled, ".concat((0, $jp7ng.DN90), ")")
};
var $ed10471c65f0492c$export$f4d082c200a4b4b8 = {
    light: "transparent",
    dark: "transparent"
};


var $31adc09ecfd48db9$var$disabledRules = {
    light: {
        backgroundColor: $ed10471c65f0492c$export$ae3cba7672df0890.light,
        backgroundColorFocus: $ed10471c65f0492c$export$ae3cba7672df0890.light,
        backgroundColorHover: $ed10471c65f0492c$export$ae3cba7672df0890.light,
        borderColor: $ed10471c65f0492c$export$fe505fe3c5edbdf6.light,
        borderColorFocus: $ed10471c65f0492c$export$e8320c09dc1e4012.light,
        textColor: $ed10471c65f0492c$export$eb4a7d363eec53c8.light
    },
    dark: {
        backgroundColor: $ed10471c65f0492c$export$ae3cba7672df0890.dark,
        backgroundColorFocus: $ed10471c65f0492c$export$ae3cba7672df0890.dark,
        backgroundColorHover: $ed10471c65f0492c$export$ae3cba7672df0890.dark,
        borderColor: $ed10471c65f0492c$export$fe505fe3c5edbdf6.dark,
        borderColorFocus: $ed10471c65f0492c$export$e8320c09dc1e4012.dark,
        textColor: $ed10471c65f0492c$export$eb4a7d363eec53c8.dark
    }
};
var $31adc09ecfd48db9$var$invalidRules = {
    light: {
        borderColor: $ed10471c65f0492c$export$7f333bbf7ddab792.light,
        borderColorFocus: $ed10471c65f0492c$export$e8320c09dc1e4012.light,
        backgroundColor: $ed10471c65f0492c$export$b13414ee9ac9cae6.light,
        backgroundColorFocus: $ed10471c65f0492c$export$21287e4b7f134f09.light,
        backgroundColorHover: $ed10471c65f0492c$export$bca15982c103d57b.light
    },
    dark: {
        borderColor: $ed10471c65f0492c$export$7f333bbf7ddab792.dark,
        borderColorFocus: $ed10471c65f0492c$export$e8320c09dc1e4012.dark,
        backgroundColor: $ed10471c65f0492c$export$b13414ee9ac9cae6.dark,
        backgroundColorFocus: $ed10471c65f0492c$export$21287e4b7f134f09.dark,
        backgroundColorHover: $ed10471c65f0492c$export$bca15982c103d57b.dark
    }
};
var $31adc09ecfd48db9$var$backgroundColor = {
    standard: $ed10471c65f0492c$export$b13414ee9ac9cae6,
    subtle: $ed10471c65f0492c$export$f4d082c200a4b4b8,
    none: $ed10471c65f0492c$export$f4d082c200a4b4b8
};
var $31adc09ecfd48db9$var$backgroundColorFocus = {
    standard: $ed10471c65f0492c$export$21287e4b7f134f09,
    subtle: $ed10471c65f0492c$export$21287e4b7f134f09,
    none: $ed10471c65f0492c$export$f4d082c200a4b4b8
};
var $31adc09ecfd48db9$var$backgroundColorHover = {
    standard: $ed10471c65f0492c$export$bca15982c103d57b,
    subtle: $ed10471c65f0492c$export$bca15982c103d57b,
    none: $ed10471c65f0492c$export$f4d082c200a4b4b8
};
var $31adc09ecfd48db9$var$borderColor = {
    standard: $ed10471c65f0492c$export$dafd83031c202ca8,
    subtle: $ed10471c65f0492c$export$f4d082c200a4b4b8,
    none: $ed10471c65f0492c$export$f4d082c200a4b4b8
};
var $31adc09ecfd48db9$var$borderColorFocus = {
    standard: $ed10471c65f0492c$export$e8320c09dc1e4012,
    subtle: $ed10471c65f0492c$export$e8320c09dc1e4012,
    none: $ed10471c65f0492c$export$f4d082c200a4b4b8
};
var $31adc09ecfd48db9$var$borderColorHover = {
    standard: $ed10471c65f0492c$export$dafd83031c202ca8,
    subtle: $ed10471c65f0492c$export$a87538d56ee366ec,
    none: $ed10471c65f0492c$export$f4d082c200a4b4b8
};
var $31adc09ecfd48db9$export$8c52b1fd9e189b5 = {
    borderColor: $31adc09ecfd48db9$var$borderColor,
    borderColorFocus: $31adc09ecfd48db9$var$borderColorFocus,
    backgroundColor: $31adc09ecfd48db9$var$backgroundColor,
    backgroundColorFocus: $31adc09ecfd48db9$var$backgroundColorFocus,
    backgroundColorHover: $31adc09ecfd48db9$var$backgroundColorHover,
    disabledRules: $31adc09ecfd48db9$var$disabledRules,
    invalidRules: $31adc09ecfd48db9$var$invalidRules,
    textColor: $ed10471c65f0492c$export$32f78bffcd82ff28,
    placeholderTextColor: $ed10471c65f0492c$export$5e076b2557ef7bbb
};
var $31adc09ecfd48db9$export$14faa19a0f3bbeb2 = (0, $dHFxE.createTheme)(function(_ref) {
    var appearance = _ref.appearance, mode = _ref.mode;
    return {
        borderColor: $31adc09ecfd48db9$var$borderColor[appearance][mode],
        borderColorFocus: $31adc09ecfd48db9$var$borderColorFocus[appearance][mode],
        borderColorHover: $31adc09ecfd48db9$var$borderColorHover[appearance][mode],
        backgroundColorHover: $31adc09ecfd48db9$var$backgroundColorHover[appearance][mode],
        backgroundColorFocus: $31adc09ecfd48db9$var$backgroundColorFocus[appearance][mode],
        backgroundColor: $31adc09ecfd48db9$var$backgroundColor[appearance][mode],
        disabledRules: $31adc09ecfd48db9$var$disabledRules[mode],
        invalidRules: $31adc09ecfd48db9$var$invalidRules[mode],
        textColor: $ed10471c65f0492c$export$32f78bffcd82ff28[mode],
        placeholderTextColor: $ed10471c65f0492c$export$5e076b2557ef7bbb[mode]
    };
});


var $7cbe013dbbe44d2d$var$_excluded = [
    "resize",
    "appearance",
    "isCompact",
    "isRequired",
    "isReadOnly",
    "isDisabled",
    "isInvalid",
    "isMonospaced",
    "minimumRows",
    "theme",
    "testId",
    "maxHeight",
    "onBlur",
    "onFocus",
    "onChange",
    "tokens",
    "value"
];
function $7cbe013dbbe44d2d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7cbe013dbbe44d2d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7cbe013dbbe44d2d$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7cbe013dbbe44d2d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $7cbe013dbbe44d2d$var$packageName = "@atlaskit/textarea";
var $7cbe013dbbe44d2d$var$packageVersion = "4.7.1";
var $7cbe013dbbe44d2d$var$analyticsParams = {
    componentName: "textArea",
    packageName: $7cbe013dbbe44d2d$var$packageName,
    packageVersion: $7cbe013dbbe44d2d$var$packageVersion
};
var $7cbe013dbbe44d2d$var$setSmartHeight = function setSmartHeight(el) {
    // Always reset height to auto before calculating new height
    el.style.height = "auto";
    var borderHeight = (0, $9233558c6eeea5d6$export$12879c7697ed953d);
    var paddingBoxHeight = el.scrollHeight;
    var borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = "".concat(borderBoxHeight, "px");
};
var $7cbe013dbbe44d2d$var$TextAreaWithTokens = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function(props, ref) {
    var ourRef = (0, $9nHZC.useRef)(null);
    var _props$resize = props.resize, resize = _props$resize === void 0 ? "smart" : _props$resize, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "standard" : _props$appearance, _props$isCompact = props.isCompact, isCompact = _props$isCompact === void 0 ? false : _props$isCompact, _props$isRequired = props.isRequired, isRequired = _props$isRequired === void 0 ? false : _props$isRequired, _props$isReadOnly = props.isReadOnly, isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isMonospaced = props.isMonospaced, isMonospaced = _props$isMonospaced === void 0 ? false : _props$isMonospaced, _props$minimumRows = props.minimumRows, minimumRows = _props$minimumRows === void 0 ? 2 : _props$minimumRows, theme = props.theme, testId = props.testId, _props$maxHeight = props.maxHeight, maxHeight = _props$maxHeight === void 0 ? "50vh" : _props$maxHeight, onBlur = props.onBlur, onFocus = props.onFocus, onChange = props.onChange, tokens = props.tokens, value = props.value, rest = (0, (/*@__PURE__*/$parcel$interopDefault($lOQkO)))(props, $7cbe013dbbe44d2d$var$_excluded);
    (0, $9nHZC.useEffect)(function() {
        var el = ourRef.current;
        if (resize === "smart" && el) $7cbe013dbbe44d2d$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    var onBlurWithAnalytics = (0, $177af0ccb9b233f3$export$a4687b0234b40e28)($7cbe013dbbe44d2d$var$_objectSpread({
        fn: function fn(event) {
            onBlur && onBlur(event);
        },
        action: "blurred"
    }, $7cbe013dbbe44d2d$var$analyticsParams));
    var onFocusWithAnalytics = (0, $177af0ccb9b233f3$export$a4687b0234b40e28)($7cbe013dbbe44d2d$var$_objectSpread({
        fn: function fn(event) {
            onFocus && onFocus(event);
        },
        action: "focused"
    }, $7cbe013dbbe44d2d$var$analyticsParams));
    var getTextAreaRef = function getTextAreaRef(elementRef) {
        ourRef.current = elementRef;
        if (ref && (0, (/*@__PURE__*/$parcel$interopDefault($340K4)))(ref) === "object") // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === "function") ref(elementRef);
    };
    var handleOnChange = (0, $9nHZC.useCallback)(function(e) {
        var el = ourRef.current;
        if (resize === "smart" && el) $7cbe013dbbe44d2d$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    var controlProps = {
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-compact": isCompact ? isCompact : undefined,
        "data-testid": testId ? testId : undefined
    };
    var baseStyles = (0, $9nHZC.useMemo)(function() {
        return (0, $9233558c6eeea5d6$export$bff8031d86bb089)({
            minimumRows: minimumRows,
            resize: resize,
            appearance: appearance,
            isMonospaced: isMonospaced,
            maxHeight: maxHeight
        });
    }, [
        minimumRows,
        resize,
        appearance,
        isMonospaced,
        maxHeight
    ]);
    var textAreaStyles = (0, $avKww.css)([
        baseStyles,
        // not memoizing themeStyles as `tokens` is an unstable reference
        (0, $9233558c6eeea5d6$export$ded1c27b355b104)(tokens, appearance)
    ]);
    return (0, $avKww.jsx)("textarea", (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, controlProps, {
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        css: textAreaStyles
    }, rest));
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ var $7cbe013dbbe44d2d$var$TextArea = /*#__PURE__*/ (0, $9nHZC.memo)(/*#__PURE__*/ (0, $9nHZC.forwardRef)(function TextArea(props, ref) {
    var _useGlobalTheme = (0, $5LVXk.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $avKww.jsx)((0, $31adc09ecfd48db9$export$14faa19a0f3bbeb2).Provider, {
        value: props.theme
    }, (0, $avKww.jsx)((0, $31adc09ecfd48db9$export$14faa19a0f3bbeb2).Consumer, {
        appearance: props.appearance || "standard",
        mode: mode
    }, function(tokens) {
        return (0, $avKww.jsx)($7cbe013dbbe44d2d$var$TextAreaWithTokens, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            ref: ref
        }, props, {
            tokens: tokens
        }));
    }));
}));
$7cbe013dbbe44d2d$var$TextArea.displayName = "TextArea";
var $7cbe013dbbe44d2d$export$2e2bcd8739ae039 = $7cbe013dbbe44d2d$var$TextArea;



var $aP6k3 = parcelRequire("aP6k3");

var $hlgjl = parcelRequire("hlgjl");
parcelRequire("45CBz");
var $7KAwG = parcelRequire("7KAwG");
var $45CBz = parcelRequire("45CBz");

var $EKmRU = parcelRequire("EKmRU");

var $jp7ng = parcelRequire("jp7ng");

var $fPPqr = parcelRequire("fPPqr");

var $9q1kH = parcelRequire("9q1kH");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");
var $4a8fac132624c9ae$exports = {};
"use strict";
Object.defineProperty($4a8fac132624c9ae$exports, "__esModule", {
    value: true
});
$4a8fac132624c9ae$exports.bindAll = $4a8fac132624c9ae$exports.bind = void 0;
var $5e72d8410702dca2$exports = {};
"use strict";
Object.defineProperty($5e72d8410702dca2$exports, "__esModule", {
    value: true
});
$5e72d8410702dca2$exports.bind = void 0;
function $5e72d8410702dca2$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
$5e72d8410702dca2$exports.bind = $5e72d8410702dca2$var$bind;


Object.defineProperty($4a8fac132624c9ae$exports, "bind", {
    enumerable: true,
    get: function() {
        return $5e72d8410702dca2$exports.bind;
    }
});
var $34c36228841c3426$exports = {};
"use strict";
var $34c36228841c3426$var$__assign = $34c36228841c3426$exports && $34c36228841c3426$exports.__assign || function() {
    $34c36228841c3426$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $34c36228841c3426$var$__assign.apply(this, arguments);
};
Object.defineProperty($34c36228841c3426$exports, "__esModule", {
    value: true
});
$34c36228841c3426$exports.bindAll = void 0;

function $34c36228841c3426$var$toOptions(value) {
    if (typeof value === "undefined") return undefined;
    if (typeof value === "boolean") return {
        capture: value
    };
    return value;
}
function $34c36228841c3426$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $34c36228841c3426$var$__assign($34c36228841c3426$var$__assign({}, original), {
        options: $34c36228841c3426$var$__assign($34c36228841c3426$var$__assign({}, $34c36228841c3426$var$toOptions(sharedOptions)), $34c36228841c3426$var$toOptions(original.options))
    });
    return binding;
}
function $34c36228841c3426$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $34c36228841c3426$var$getBinding(original, sharedOptions);
        return (0, $5e72d8410702dca2$exports.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
$34c36228841c3426$exports.bindAll = $34c36228841c3426$var$bindAll;


Object.defineProperty($4a8fac132624c9ae$exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $34c36228841c3426$exports.bindAll;
    }
});



var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");


function $0b10b05ed4884ea3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0b10b05ed4884ea3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0b10b05ed4884ea3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0b10b05ed4884ea3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0b10b05ed4884ea3$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $bcbdccc2039a7b2d$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $a5eb7ac08d80421a$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $a5eb7ac08d80421a$export$1d27a74659855e44)(fn);
    var handler = (0, $9nHZC.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $0b10b05ed4884ea3$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $8p2GL = parcelRequire("8p2GL");

var $ay1rd = parcelRequire("ay1rd");

var $JcvLo = parcelRequire("JcvLo");
var $gWA00 = parcelRequire("gWA00");

var $htChF = parcelRequire("htChF");

var $b4Ivn = parcelRequire("b4Ivn");

var $9q1kH = parcelRequire("9q1kH");

var $9nHZC = parcelRequire("9nHZC");

var $cjxQA = parcelRequire("cjxQA");

// Export types from PopperJS / React Popper
var $ce948b1b32577156$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: 5,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    },
    {
        name: "preventOverflow",
        options: {
            padding: 5,
            rootBoundary: "document"
        }
    }
];
function $ce948b1b32577156$var$defaultChildrenFn() {
    return null;
}
var $ce948b1b32577156$var$defaultOffset = [
    0,
    8
];
function $ce948b1b32577156$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $ce948b1b32577156$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $ce948b1b32577156$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    // Merge a new offset modifier only if new offset values passed in
    var internalModifiers = (0, $9nHZC.useMemo)(function() {
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        return [].concat($ce948b1b32577156$var$constantModifiers, [
            offsetModifier
        ]);
    }, [
        offsetX,
        offsetY
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $9nHZC.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($b4Ivn)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $cjxQA.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}



var $97YIy = parcelRequire("97YIy");

var $aP6k3 = parcelRequire("aP6k3");
var $1b80738580613073$var$delayId = null;
function $1b80738580613073$export$eaf678f6f93f5250() {
    if ($1b80738580613073$var$delayId != null) {
        window.clearTimeout($1b80738580613073$var$delayId);
        $1b80738580613073$var$delayId = null;
    }
}
function $1b80738580613073$export$5f4d6617421d489b(fn, delay) {
    $1b80738580613073$export$eaf678f6f93f5250();
    $1b80738580613073$var$delayId = window.setTimeout(function() {
        $1b80738580613073$var$delayId = null;
        fn();
    }, delay);
}


// This file is a singleton for managing tooltips
var $123e51d108dda6a1$var$active = null;
function $123e51d108dda6a1$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($123e51d108dda6a1$var$active && $123e51d108dda6a1$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $1b80738580613073$export$eaf678f6f93f5250)();
            $123e51d108dda6a1$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $1b80738580613073$export$eaf678f6f93f5250)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $1b80738580613073$export$eaf678f6f93f5250)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $1b80738580613073$export$5f4d6617421d489b)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($123e51d108dda6a1$var$active && $123e51d108dda6a1$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($123e51d108dda6a1$var$active) {
            (0, $1b80738580613073$export$eaf678f6f93f5250)();
            $123e51d108dda6a1$var$active.entry.hide({
                isImmediate: true
            });
            $123e51d108dda6a1$var$active.entry.done();
            $123e51d108dda6a1$var$active = null;
        }
        // this tooltip is now the active tooltip
        $123e51d108dda6a1$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $1b80738580613073$export$5f4d6617421d489b)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}



var $9SZaS = parcelRequire("9SZaS");
function $75cf2166e84fa0fc$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $9SZaS.useUIDSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}


/** @jsx jsx */ 
var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $jp7ng = parcelRequire("jp7ng");

var $5LVXk = parcelRequire("5LVXk");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $avKww = parcelRequire("avKww");

var $aP6k3 = parcelRequire("aP6k3");
function $8c85daeba6a0da8d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8c85daeba6a0da8d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8c85daeba6a0da8d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8c85daeba6a0da8d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8c85daeba6a0da8d$var$VAR_PRIMITIVE_ZINDEX = "tooltipPrimitiveZindex";
var $8c85daeba6a0da8d$var$primitiveStyles = (0, $avKww.css)({
    zindex: "var(".concat($8c85daeba6a0da8d$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
var $8c85daeba6a0da8d$var$TooltipPrimitive = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $8c85daeba6a0da8d$var$_objectSpread($8c85daeba6a0da8d$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))({}, $8c85daeba6a0da8d$var$VAR_PRIMITIVE_ZINDEX, (0, $aP6k3.layers).tooltip()));
    return (0, $avKww.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $avKww.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $8c85daeba6a0da8d$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$8c85daeba6a0da8d$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $8c85daeba6a0da8d$export$2e2bcd8739ae039 = $8c85daeba6a0da8d$var$TooltipPrimitive;


var $b6437a33f3edcf5b$var$baseStyles = (0, $avKww.css)({
    boxSizing: "border-box",
    maxWidth: "240px",
    padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-075, 6px)"),
    insetBlockStart: "var(--ds-space-0, 0px)",
    insetInlineStart: "var(--ds-space-0, 0px)",
    borderRadius: "var(--ds-border-radius, 3px)",
    fontSize: "var(--ds-font-size-075, 12px)",
    lineHeight: 1.3,
    overflowWrap: "break-word",
    wordWrap: "break-word"
});
var $b6437a33f3edcf5b$var$truncateStyles = (0, $avKww.css)({
    maxWidth: "420px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $b6437a33f3edcf5b$var$lightStyles = (0, $avKww.css)({
    backgroundColor: "var(--ds-background-neutral-bold, ".concat((0, $jp7ng.N800), ")"),
    color: "var(--ds-text-inverse, ".concat((0, $jp7ng.N0), ")")
});
var $b6437a33f3edcf5b$var$darkStyles = (0, $avKww.css)({
    backgroundColor: "var(--ds-background-neutral-bold, ".concat((0, $jp7ng.DN0), ")"),
    color: "var(--ds-text-inverse, ".concat((0, $jp7ng.DN600), ")")
});
var $b6437a33f3edcf5b$var$TooltipContainer = /*#__PURE__*/ (0, $9nHZC.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return (0, $avKww.jsx)((0, $5LVXk.default).Consumer, null, function(_ref2) {
        var mode = _ref2.mode;
        return (0, $avKww.jsx)((0, $8c85daeba6a0da8d$export$2e2bcd8739ae039), {
            ref: ref,
            style: style,
            className: className,
            placement: placement,
            testId: testId,
            id: id,
            onMouseOut: onMouseOut,
            onMouseOver: onMouseOver,
            css: [
                $b6437a33f3edcf5b$var$baseStyles,
                truncate ? $b6437a33f3edcf5b$var$truncateStyles : null,
                mode === "light" ? $b6437a33f3edcf5b$var$lightStyles : $b6437a33f3edcf5b$var$darkStyles
            ]
        }, children);
    });
});
$b6437a33f3edcf5b$var$TooltipContainer.displayName = "TooltipContainer";
var $b6437a33f3edcf5b$export$2e2bcd8739ae039 = $b6437a33f3edcf5b$var$TooltipContainer;


function $18b7f5dbcd5aa180$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}


function $f35b8913ee094823$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f35b8913ee094823$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f35b8913ee094823$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f35b8913ee094823$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f35b8913ee094823$var$tooltipZIndex = (0, $aP6k3.layers).tooltip();
var $f35b8913ee094823$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "17.8.8"
};
// Inverts motion direction
var $f35b8913ee094823$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param position - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $f35b8913ee094823$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
function $f35b8913ee094823$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $b6437a33f3edcf5b$export$2e2bcd8739ae039) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $8p2GL.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $8p2GL.default) : _ref$onHide, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy;
    var tooltipPosition = position === "mouse" ? mousePosition : position;
    var onShowHandler = (0, $0b10b05ed4884ea3$export$1a04351537078b55)($f35b8913ee094823$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $f35b8913ee094823$var$analyticsAttributes));
    var onHideHandler = (0, $0b10b05ed4884ea3$export$1a04351537078b55)($f35b8913ee094823$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $f35b8913ee094823$var$analyticsAttributes));
    var apiRef = (0, $9nHZC.useRef)(null);
    var _useState = (0, $9nHZC.useState)("hide"), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $9nHZC.useRef)(null);
    var containerRef = (0, $9nHZC.useRef)(null);
    var hasFunctionalChildren = typeof children === "function"; // Stored to keep our `setRef` callback cleaner.
    var setRef = (0, $9nHZC.useCallback)(function(node) {
        if (!node) return;
        if (hasFunctionalChildren) targetRef.current = node;
        else {
            containerRef.current = node;
            targetRef.current = node.firstChild;
        }
    }, [
        hasFunctionalChildren
    ]);
    // Putting a few things into refs so that we don't have to break memoization
    var lastState = (0, $9nHZC.useRef)(state);
    var lastDelay = (0, $9nHZC.useRef)(delay);
    var lastHandlers = (0, $9nHZC.useRef)({
        onShowHandler: onShowHandler,
        onHideHandler: onHideHandler
    });
    var hasCalledShowHandler = (0, $9nHZC.useRef)(false);
    (0, $9nHZC.useEffect)(function() {
        lastState.current = state;
        lastDelay.current = delay;
        lastHandlers.current = {
            onShowHandler: onShowHandler,
            onHideHandler: onHideHandler
        };
    }, [
        delay,
        onHideHandler,
        onShowHandler,
        state
    ]);
    var start = (0, $9nHZC.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $9nHZC.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, []);
    var abort = (0, $9nHZC.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
    }, []);
    (0, $9nHZC.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var showTooltip = (0, $9nHZC.useCallback)(function(source) {
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // Tell the tooltip to keep showing
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        var entry = {
            source: source,
            delay: lastDelay.current,
            show: function show(_ref2) {
                var isImmediate = _ref2.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    lastHandlers.current.onShowHandler();
                }
                setState(isImmediate ? "show-immediate" : "fade-in");
            },
            hide: function hide(_ref3) {
                var isImmediate = _ref3.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done
        };
        var api = (0, $123e51d108dda6a1$export$57bf213be019eeb0)(entry);
        start(api);
    }, [
        abort,
        done,
        start
    ]);
    var hideTooltipOnEsc = (0, $9nHZC.useCallback)(function() {
        var _apiRef$current;
        (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $ay1rd.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $9nHZC.useEffect)(function() {
        if (state === "hide") return 0, $8p2GL.default;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $4a8fac132624c9ae$exports.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $9nHZC.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $9nHZC.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $9nHZC.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === "mouse" ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            mouse: (0, $18b7f5dbcd5aa180$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: "keyboard"
        };
        showTooltip(source);
    }, [
        position,
        showTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $9nHZC.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === "mouse" ? function(event) {
        var _apiRef$current2;
        if ((_apiRef$current2 = apiRef.current) !== null && _apiRef$current2 !== void 0 && _apiRef$current2.isActive()) apiRef.current.mousePosition = (0, $18b7f5dbcd5aa180$export$642213d516a9b928)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $9nHZC.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $9nHZC.useCallback)(function() {
        showTooltip({
            type: "keyboard"
        });
    }, [
        showTooltip
    ]);
    var onBlur = (0, $9nHZC.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $9nHZC.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && lastState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, []);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipContainer = state !== "hide" && Boolean(content);
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current3;
        if (position === "mouse" && (_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.mousePosition) {
            var _apiRef$current4;
            return (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 ? void 0 : _apiRef$current4.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipId = (0, $75cf2166e84fa0fc$export$2e2bcd8739ae039)("tooltip", shouldRenderTooltipContainer);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        ref: setRef
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    (0, $9nHZC.useEffect)(function() {
        // If there is no container element, we should exit early, because that
        // means they are using the render prop API, and that is implemented in a
        // different way. If there is no target element yet or tooltipId, we also
        // shouldn't do anything because there is nothing to operate on or with.
        if (!containerRef.current || !targetRef.current || !tooltipId) return;
        // Necessary for TS to know that it has the attribute methods
        var target = targetRef.current;
        if (shouldRenderTooltipContainer) target.setAttribute("aria-describedby", tooltipId);
        else target.removeAttribute("aria-describedby");
    }, [
        shouldRenderTooltipContainer,
        tooltipId
    ]);
    return (0, $avKww.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, typeof children === "function" ? // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    children($f35b8913ee094823$var$_objectSpread($f35b8913ee094823$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipId
    })) : (0, $avKww.jsx)(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, tooltipTriggerProps, {
        role: "presentation"
    }), children), shouldRenderTooltipContainer ? (0, $avKww.jsx)((0, $97YIy.default), {
        zIndex: $f35b8913ee094823$var$tooltipZIndex
    }, (0, $avKww.jsx)((0, $ce948b1b32577156$export$badac9ada3a0bdf9), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref4) {
        var ref = _ref4.ref, style = _ref4.style, update = _ref4.update, placement = _ref4.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === "mouse" ? undefined : $f35b8913ee094823$var$invertedDirection[$f35b8913ee094823$var$getDirectionFromPlacement(placement)];
        return (0, $avKww.jsx)((0, $JcvLo.default), {
            appear: true
        }, shouldRenderTooltipChildren && (0, $avKww.jsx)((0, $gWA00.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state === "show-immediate" ? 0 : (0, $htChF.mediumDurationMs)
        }, function(_ref5) {
            var className = _ref5.className;
            return (0, $avKww.jsx)(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: style,
                truncate: truncate,
                placement: tooltipPosition,
                testId: testId,
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                id: tooltipId
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$f35b8913ee094823$var$Tooltip.displayName = "Tooltip";
var $f35b8913ee094823$export$2e2bcd8739ae039 = $f35b8913ee094823$var$Tooltip;


var $eb10a5fdb5c4803b$var$_templateObject, $eb10a5fdb5c4803b$var$_templateObject2, $eb10a5fdb5c4803b$var$_templateObject3, $eb10a5fdb5c4803b$var$_templateObject4;
var $eb10a5fdb5c4803b$var$tooltipMessage = [
    "Strongly disagree",
    "Disagree",
    "Slightly disagree",
    "Neutral",
    "Slightly agree",
    "Agree",
    "Strongly agree"
];
var $eb10a5fdb5c4803b$export$2e2bcd8739ae039 = function(_ref) {
    var onChange = _ref.onChange, value = _ref.value;
    return (0, $45CBz.jsx)("div", null, (0, $45CBz.jsx)("div", {
        css: (0, $7KAwG.default)($eb10a5fdb5c4803b$var$_templateObject || ($eb10a5fdb5c4803b$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
            "\n        display: flex;\n        justify-content: space-between;\n\n        & > * + * {\n          margin-left: ",
            ";\n        }\n\n        & > * {\n          flex: 1;\n\n          & > button {\n            justify-content: center;\n          }\n        }\n      "
        ])), "var(--ds-space-100, 8px)")
    }, Array.from({
        length: 7
    }, function(_, i) {
        var score = i + 1;
        var isSelected = value === score;
        return (0, $45CBz.jsx)((0, $f35b8913ee094823$export$2e2bcd8739ae039), {
            content: $eb10a5fdb5c4803b$var$tooltipMessage[i],
            key: score,
            hideTooltipOnClick: true
        }, (0, $45CBz.jsx)((0, $EKmRU.default), {
            onClick: function onClick() {
                return onChange(score);
            },
            isSelected: isSelected,
            "aria-pressed": isSelected,
            "aria-describedby": "contextualSurveyStatement",
            "aria-label": $eb10a5fdb5c4803b$var$tooltipMessage[i],
            shouldFitContainer: true
        }, score));
    })), (0, $45CBz.jsx)("div", {
        css: (0, $7KAwG.default)($eb10a5fdb5c4803b$var$_templateObject2 || ($eb10a5fdb5c4803b$var$_templateObject2 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
            "\n        font-size: 12px;\n        font-weight: 600;\n        color: ",
            ";\n        display: flex;\n        margin-top: ",
            ";\n        margin-bottom: ",
            ";\n\n        & > span {\n          width: ",
            ";\n        }\n      "
        ])), "var(--ds-text-subtlest, ".concat((0, $jp7ng.N200), ")"), "var(--ds-space-100, 8px)", "var(--ds-space-300, 24px)", "var(--ds-space-1000, 80px)"),
        "aria-hidden": true
    }, (0, $45CBz.jsx)("span", null, "Strongly disagree"), (0, $45CBz.jsx)("span", {
        css: (0, $7KAwG.default)($eb10a5fdb5c4803b$var$_templateObject3 || ($eb10a5fdb5c4803b$var$_templateObject3 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
            "\n          text-align: center;\n          margin: 0 auto;\n          padding: 0 ",
            ";\n        "
        ])), "var(--ds-space-600, 48px)")
    }, "Neutral"), (0, $45CBz.jsx)("span", {
        css: (0, $7KAwG.default)($eb10a5fdb5c4803b$var$_templateObject4 || ($eb10a5fdb5c4803b$var$_templateObject4 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
            "\n          text-align: right;\n        "
        ])))
    }, "Strongly agree")));
};


var $17aa2e2672d3a7fe$var$_templateObject, $17aa2e2672d3a7fe$var$_templateObject2;
var $17aa2e2672d3a7fe$var$getExpandedHeight = function getExpandedHeight(ref, state) {
    if (!ref.current) return "0";
    switch(state){
        case "entering":
            return "".concat(ref.current.scrollHeight, "px");
        case "entered":
            // needed for TextField auto height expand
            return "none";
        default:
            return "0";
    }
};
var $17aa2e2672d3a7fe$var$transitionDuration = 200;
var $17aa2e2672d3a7fe$export$2e2bcd8739ae039 = function(_ref) {
    var question = _ref.question, statement = _ref.statement, textPlaceholder = _ref.textPlaceholder, textLabel = _ref.textLabel, onSubmit = _ref.onSubmit;
    var _useState = (0, $9nHZC.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), expanded = _useState2[0], setExpanded = _useState2[1];
    var _useState3 = (0, $9nHZC.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState3, 2), canContactDefault = _useState4[0], setCanContactDefault = _useState4[1];
    var hasAutoFilledCanContactRef = (0, $9nHZC.useRef)(false);
    var expandedAreaRef = (0, $9nHZC.useRef)(null);
    var onScoreSelect = (0, $9nHZC.useCallback)(function() {
        setExpanded(true);
    }, [
        setExpanded
    ]);
    // On the first type the user types some feedback we auto select
    // the option for allowing feedback. This automatic selection only
    // happens once. After that it is up to the user to control
    var onFeedbackChange = (0, $9nHZC.useCallback)(function() {
        if (hasAutoFilledCanContactRef.current) return;
        hasAutoFilledCanContactRef.current = true;
        setCanContactDefault(true);
    }, []);
    return (0, $45CBz.jsx)("section", {
        "aria-labelledby": "contextualSurveyQuestion"
    }, (0, $45CBz.jsx)("h1", {
        id: "contextualSurveyQuestion",
        css: (0, $7KAwG.default)($17aa2e2672d3a7fe$var$_templateObject || ($17aa2e2672d3a7fe$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
            "\n          font-size: ",
            "px;\n          font-weight: 600;\n        "
        ])), (0, $aP6k3.fontSize)())
    }, question), statement && (0, $45CBz.jsx)("p", {
        id: "contextualSurveyStatement"
    }, statement), (0, $45CBz.jsx)((0, $ezi8k.default), {
        onSubmit: onSubmit
    }, function(_ref2) {
        var formProps = _ref2.formProps, submitting = _ref2.submitting;
        return (0, $45CBz.jsx)("form", formProps, (0, $45CBz.jsx)((0, $7S5Ao.default), {
            name: "feedbackScore",
            isDisabled: submitting,
            isRequired: true
        }, function(_ref3) {
            var fieldProps = _ref3.fieldProps;
            return (0, $45CBz.jsx)((0, $eb10a5fdb5c4803b$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, fieldProps, {
                onChange: function onChange(score) {
                    fieldProps.onChange(score);
                    onScoreSelect();
                }
            }));
        }), (0, $45CBz.jsx)((0, $3Jogu.default), {
            in: expanded,
            timeout: $17aa2e2672d3a7fe$var$transitionDuration,
            mountOnEnter: true
        }, function(state) {
            return (0, $45CBz.jsx)("div", {
                css: (0, $7KAwG.default)($17aa2e2672d3a7fe$var$_templateObject2 || ($17aa2e2672d3a7fe$var$_templateObject2 = (0, (/*@__PURE__*/$parcel$interopDefault($hlgjl)))([
                    "\n                    transition: max-height ",
                    "ms ease-in-out;\n                    overflow: hidden;\n                    max-height: ",
                    ";\n                  "
                ])), $17aa2e2672d3a7fe$var$transitionDuration, $17aa2e2672d3a7fe$var$getExpandedHeight(expandedAreaRef, state)),
                ref: expandedAreaRef
            }, (0, $45CBz.jsx)((0, $7S5Ao.default), {
                name: "writtenFeedback",
                defaultValue: "",
                isDisabled: submitting
            }, function(_ref4) {
                var fieldProps = _ref4.fieldProps;
                return (0, $45CBz.jsx)((0, $7cbe013dbbe44d2d$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, fieldProps, {
                    "aria-label": textLabel,
                    placeholder: textPlaceholder,
                    onChange: function onChange(event) {
                        fieldProps.onChange(event);
                        onFeedbackChange();
                    }
                }));
            }), (0, $45CBz.jsx)((0, $1K9zK.default), {
                name: "canContact",
                isDisabled: submitting,
                defaultIsChecked: canContactDefault
            }, function(_ref5) {
                var fieldProps = _ref5.fieldProps;
                return (0, $45CBz.jsx)((0, $5oo0Y.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, fieldProps, {
                    label: "Atlassian can contact me about this feedback"
                }));
            }), (0, $45CBz.jsx)((0, $5H0cN.default), null, (0, $45CBz.jsx)((0, $EKmRU.default), {
                type: "submit",
                appearance: "primary",
                isLoading: submitting
            }, "Submit")));
        }));
    }));
};



var $9nHZC = parcelRequire("9nHZC");
var $34d5ed15a2859261$export$4e7f196112fea3c5 = 27;
function $34d5ed15a2859261$var$bind(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return function unbind() {
        target.removeEventListener(eventName, handler, options);
    };
}
function $34d5ed15a2859261$var$shouldDismiss(target) {
    if (!target) return true;
    if (!(target instanceof HTMLElement)) return true;
    // Closest doesn't exist for ie11
    // Because we cannot be sure if in a text area - just don't allow dismissing
    if (!target.closest) return false;
    var inTextArea = Boolean(target.closest("textarea"));
    // Allow dismissing if not in a textarea
    return !inTextArea;
}
function $34d5ed15a2859261$export$2e2bcd8739ae039(_ref) {
    var onDismiss = _ref.onDismiss;
    var onDismissRef = (0, $9nHZC.useRef)(onDismiss);
    // Defensively accounting for consumer passing in a new function
    // each time. We just want to call the latest one
    (0, $9nHZC.useEffect)(function() {
        onDismissRef.current = onDismiss;
    }, [
        onDismiss
    ]);
    (0, $9nHZC.useEffect)(function() {
        var unbind;
        function onKeyDown(event) {
            if (event.keyCode !== $34d5ed15a2859261$export$4e7f196112fea3c5) return;
            // Escape pressed
            // We don't want to close if the user is typing in the text area
            if (!$34d5ed15a2859261$var$shouldDismiss(event.target)) return;
            if (unbind) // only want to call dismiss once
            unbind();
            onDismissRef.current();
        }
        unbind = $34d5ed15a2859261$var$bind(window, "keydown", // @ts-ignore: the typescript for this is lame
        onKeyDown, {
            passive: true
        });
        // double calls to unbind is fine
        return unbind;
    }, []);
}


var $da161680f06728ea$export$151efc60ac534d42 = /*#__PURE__*/ function(DismissTrigger) {
    DismissTrigger["AutoDismiss"] = "AUTO_DISMISS";
    DismissTrigger["Manual"] = "MANUAL";
    DismissTrigger["Finished"] = "FINISHED";
    DismissTrigger["Unmount"] = "UNMOUNT";
    return DismissTrigger;
}({});
var $da161680f06728ea$export$3e8963a077f85f25 = 8000;
var $da161680f06728ea$export$2e2bcd8739ae039 = function(_ref) {
    var question = _ref.question, statement = _ref.statement, onDismiss = _ref.onDismiss, onSubmit = _ref.onSubmit, onMailingListAnswer = _ref.onMailingListAnswer, getUserHasAnsweredMailingList = _ref.getUserHasAnsweredMailingList, _ref$textLabel = _ref.textLabel, textLabel = _ref$textLabel === void 0 ? "Why did you give that rating" : _ref$textLabel, _ref$textPlaceholder = _ref.textPlaceholder, textPlaceholder = _ref$textPlaceholder === void 0 ? "Tell us why" : _ref$textPlaceholder;
    var autoDisappearTimeoutRef = (0, $9nHZC.useRef)(null);
    // only allow a single dismiss for a component
    var isDismissedRef = (0, $9nHZC.useRef)(false);
    var tryDismiss = (0, $9nHZC.useCallback)(function(trigger) {
        // Already called dismiss once
        if (isDismissedRef.current) return;
        isDismissedRef.current = true;
        onDismissRef.current({
            trigger: trigger
        });
    }, []);
    var _useState = (0, $9nHZC.useState)("SURVEY"), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($9q1kH)))(_useState, 2), currentStep = _useState2[0], setCurrentStep = _useState2[1];
    var trySetCurrentStep = (0, $9nHZC.useCallback)(function(step) {
        // Already dismissed - cannot update the step
        if (isDismissedRef.current) return;
        setCurrentStep(step);
    }, [
        setCurrentStep
    ]);
    // using a ref so that we don't break all of our caches if a consumer is using an arrow function
    var onDismissRef = (0, $9nHZC.useRef)(onDismiss);
    (0, $9nHZC.useEffect)(function() {
        onDismissRef.current = onDismiss;
    }, [
        onDismiss
    ]);
    var tryClearTimeout = (0, $9nHZC.useCallback)(function() {
        var id = autoDisappearTimeoutRef.current;
        if (id) {
            clearTimeout(id);
            autoDisappearTimeoutRef.current = null;
        }
    }, []);
    // Cleanup any auto dismiss after dismiss
    (0, $9nHZC.useEffect)(function() {
        return function unmount() {
            tryClearTimeout();
            tryDismiss($da161680f06728ea$export$151efc60ac534d42.Unmount);
        };
    }, [
        tryClearTimeout,
        tryDismiss
    ]);
    var onSurveySubmit = (0, $9nHZC.useCallback)(/*#__PURE__*/ function() {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee(formValues, form) {
            var callback, userHasAnswered, _args = arguments;
            return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        callback = _args.length > 2 && _args[2] !== undefined ? _args[2] : function() {};
                        _context.next = 3;
                        return onSubmit(formValues);
                    case 3:
                        if (!isDismissedRef.current) {
                            _context.next = 6;
                            break;
                        }
                        callback();
                        return _context.abrupt("return");
                    case 6:
                        if (formValues.canContact) {
                            _context.next = 10;
                            break;
                        }
                        callback();
                        trySetCurrentStep("POST_SURVEY_NO_CONSENT");
                        return _context.abrupt("return");
                    case 10:
                        _context.next = 12;
                        return getUserHasAnsweredMailingList();
                    case 12:
                        userHasAnswered = _context.sent;
                        callback();
                        // Not entering phase 2: user has already answered this question
                        if (!userHasAnswered) {
                            _context.next = 17;
                            break;
                        }
                        trySetCurrentStep("POST_SURVEY_HAS_SIGN_UP");
                        return _context.abrupt("return");
                    case 17:
                        // Enter phase 2
                        trySetCurrentStep("SIGN_UP_PROMPT");
                    case 18:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function(_x, _x2) {
            return _ref2.apply(this, arguments);
        };
    }(), [
        getUserHasAnsweredMailingList,
        onSubmit,
        trySetCurrentStep
    ]);
    var onMailingListResponse = (0, $9nHZC.useCallback)(/*#__PURE__*/ function() {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee2(answer) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        _context2.next = 2;
                        return onMailingListAnswer(answer);
                    case 2:
                        if (!answer) {
                            _context2.next = 5;
                            break;
                        }
                        trySetCurrentStep("SIGN_UP_SUCCESS");
                        return _context2.abrupt("return");
                    case 5:
                        // We have already thanked to user, we can simply close
                        tryDismiss($da161680f06728ea$export$151efc60ac534d42.Finished);
                    case 6:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2);
        }));
        return function(_x3) {
            return _ref3.apply(this, arguments);
        };
    }(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        tryDismiss,
        trySetCurrentStep
    ]);
    // Start the auto disappear when we are finished
    (0, $9nHZC.useEffect)(function() {
        // Already dismissed
        if (isDismissedRef.current) return;
        // Timeout already scheduled
        if (autoDisappearTimeoutRef.current) return;
        if ([
            "SIGN_UP_SUCCESS",
            "POST_SURVEY_NO_CONSENT",
            "POST_SURVEY_HAS_SIGN_UP"
        ].includes(currentStep)) autoDisappearTimeoutRef.current = window.setTimeout(function() {
            return tryDismiss($da161680f06728ea$export$151efc60ac534d42.AutoDismiss);
        }, $da161680f06728ea$export$3e8963a077f85f25);
    }, [
        currentStep,
        tryDismiss
    ]);
    (0, $34d5ed15a2859261$export$2e2bcd8739ae039)({
        onDismiss: function onDismiss() {
            return tryDismiss($da161680f06728ea$export$151efc60ac534d42.Manual);
        }
    });
    var content = function() {
        if (currentStep === "SURVEY") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $17aa2e2672d3a7fe$export$2e2bcd8739ae039), {
            question: question,
            statement: statement,
            textLabel: textLabel,
            textPlaceholder: textPlaceholder,
            onSubmit: onSurveySubmit
        });
        if (currentStep === "SIGN_UP_PROMPT") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ee10509ebcf90542$export$2e2bcd8739ae039), {
            onAnswer: onMailingListResponse
        });
        if (currentStep === "SIGN_UP_SUCCESS") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $789e05248dc00a8c$export$2e2bcd8739ae039), null);
        if (currentStep === "POST_SURVEY_NO_CONSENT" || currentStep === "POST_SURVEY_HAS_SIGN_UP") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $66a534f1cd958bf7$export$2e2bcd8739ae039), null);
        return null;
    }();
    var manualDismiss = (0, $9nHZC.useCallback)(function() {
        // clear any pending timers
        tryClearTimeout();
        tryDismiss($da161680f06728ea$export$151efc60ac534d42.Manual);
    }, [
        tryDismiss,
        tryClearTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $898b9ec033c0a039$export$2e2bcd8739ae039), {
        onDismiss: manualDismiss
    }, content);
};


function $7fb285925cf1b002$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7fb285925cf1b002$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $7fb285925cf1b002$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7fb285925cf1b002$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $7fb285925cf1b002$var$flagKey = "atlassian_research_group_mailinglist_actioned";
// eslint-disable-next-line @repo/internal/react/no-class-components
var $7fb285925cf1b002$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_PureComponent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(ContextualSurvey, _PureComponent);
    var _super = $7fb285925cf1b002$var$_createSuper(ContextualSurvey);
    function ContextualSurvey() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ContextualSurvey);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onDismiss", function(onDismissArgs) {
            var _this$props = _this.props, cloudId = _this$props.cloudId, messageId = _this$props.messageId, fireClickEvent = _this$props.fireClickEvent, stargateUrl = _this$props.stargateUrl, markAsSeenAndFatigued = _this$props.markAsSeenAndFatigued, orgId = _this$props.orgId, workspaceId = _this$props.workspaceId;
            if (onDismissArgs.trigger === (0, $da161680f06728ea$export$151efc60ac534d42).Manual) markAsSeenAndFatigued({
                stargateUrl: stargateUrl,
                cloudId: cloudId,
                messageId: messageId,
                orgId: orgId,
                workspaceId: workspaceId
            });
            fireClickEvent("dismiss");
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "getUserHasAnsweredMailingList", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee() {
            var _this$props2, stargateUrl, aaid, cloudId, getFlag;
            return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _this$props2 = _this.props, stargateUrl = _this$props2.stargateUrl, aaid = _this$props2.aaid, cloudId = _this$props2.cloudId, getFlag = _this$props2.getFlag;
                        _context.prev = 1;
                        _context.next = 4;
                        return getFlag(stargateUrl, cloudId, $7fb285925cf1b002$var$flagKey, aaid);
                    case 4:
                        return _context.abrupt("return", Promise.resolve(false));
                    case 7:
                        _context.prev = 7;
                        _context.t0 = _context["catch"](1);
                        return _context.abrupt("return", Promise.resolve(true));
                    case 10:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    1,
                    7
                ]
            ]);
        })));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onSubmit", /*#__PURE__*/ function() {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee2(formValues) {
                var _this$props3, cloudId, messageId, question, statement, stargateUrl, markAsSeenAndFatigued, sendUserResponse, orgId, workspaceId, canContact, feedbackScore, writtenFeedback, payload;
                return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee2$(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            _this$props3 = _this.props, cloudId = _this$props3.cloudId, messageId = _this$props3.messageId, question = _this$props3.question, statement = _this$props3.statement, stargateUrl = _this$props3.stargateUrl, markAsSeenAndFatigued = _this$props3.markAsSeenAndFatigued, sendUserResponse = _this$props3.sendUserResponse, orgId = _this$props3.orgId, workspaceId = _this$props3.workspaceId;
                            canContact = formValues.canContact, feedbackScore = formValues.feedbackScore, writtenFeedback = formValues.writtenFeedback;
                            payload = {
                                responseType: "ACCEPTANCE_SURVEY",
                                properties: {
                                    surveyTimestamp: Date.now(),
                                    contextualQuestion: question,
                                    contextualStatement: statement,
                                    quantitativeResponse: feedbackScore,
                                    qualitativeResponse: writtenFeedback,
                                    contactable: canContact
                                }
                            };
                            markAsSeenAndFatigued({
                                stargateUrl: stargateUrl,
                                cloudId: cloudId,
                                messageId: messageId,
                                orgId: orgId,
                                workspaceId: workspaceId
                            });
                            _this.firePrimaryClickEvent();
                            // Resolving the promise to ensure that spinner of Submit button does not spin forever in case of errors
                            return _context2.abrupt("return", sendUserResponse(cloudId, stargateUrl, messageId, payload).catch(function() {
                                return Promise.resolve();
                            }));
                        case 6:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee2);
            }));
            return function(_x) {
                return _ref2.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onMailingListAnswer", /*#__PURE__*/ function() {
            var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($4mVfk)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).mark(function _callee3(answer) {
                var _this$props4, aaid, cloudId, stargateUrl, messageId, sendUserResponse, setFlag, payload;
                return (0, (/*@__PURE__*/$parcel$interopDefault($8DpVo))).wrap(function _callee3$(_context3) {
                    while(true)switch(_context3.prev = _context3.next){
                        case 0:
                            _this$props4 = _this.props, aaid = _this$props4.aaid, cloudId = _this$props4.cloudId, stargateUrl = _this$props4.stargateUrl, messageId = _this$props4.messageId, sendUserResponse = _this$props4.sendUserResponse, setFlag = _this$props4.setFlag;
                            payload = {
                                responseType: "MAILING_LIST_RESPONSE",
                                properties: {}
                            };
                            setFlag(stargateUrl, cloudId, $7fb285925cf1b002$var$flagKey, aaid);
                            if (answer) {
                                _context3.next = 5;
                                break;
                            }
                            return _context3.abrupt("return");
                        case 5:
                            return _context3.abrupt("return", sendUserResponse(cloudId, stargateUrl, messageId, payload));
                        case 6:
                        case "end":
                            return _context3.stop();
                    }
                }, _callee3);
            }));
            return function(_x2) {
                return _ref3.apply(this, arguments);
            };
        }());
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ContextualSurvey, [
        {
            key: "firePrimaryClickEvent",
            value: function firePrimaryClickEvent() {
                this.props.fireClickEvent("primary");
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $da161680f06728ea$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                    onDismiss: this.onDismiss,
                    getUserHasAnsweredMailingList: this.getUserHasAnsweredMailingList,
                    onMailingListAnswer: this.onMailingListAnswer,
                    onSubmit: this.onSubmit
                }, this.props));
            }
        }
    ]);
    return ContextualSurvey;
}((0, $9nHZC.PureComponent));


function $38696d6d0ea5e4c9$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $12cee0110ac9c403$export$2e2bcd8739ae039), {
        shouldShow: true
    }, function() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7fb285925cf1b002$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            markAsSeenAndFatigued: (0, $12add2565ec0488f$export$3683393f780c6905),
            sendUserResponse: (0, $12add2565ec0488f$export$e1fd1449cf83c1f5),
            getFlag: (0, $be885d7a781cc839$export$a19b74191e00c5e),
            setFlag: (0, $be885d7a781cc839$export$5e165df1e30a1331)
        }, props));
    });
}


var $8bf2014f0ca811d8$export$42b694a35bb75eda = (0, $b8tvv.default)((0, $38696d6d0ea5e4c9$export$2e2bcd8739ae039));
var $8bf2014f0ca811d8$export$2e2bcd8739ae039 = (0, $eeQJ3.default)($8bf2014f0ca811d8$export$42b694a35bb75eda, "contextualSurvey");



var $b8tvv = parcelRequire("b8tvv");

var $eeQJ3 = parcelRequire("eeQJ3");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");

var $9tjXs = parcelRequire("9tjXs");

var $aMNOk = parcelRequire("aMNOk");
var $1zBji = parcelRequire("1zBji");

var $29P43 = parcelRequire("29P43");

var $itT3v = parcelRequire("itT3v");
/* eslint-disable @atlassian/tangerine/import/no-relative-package-imports, @atlassian/tangerine/import/no-restricted-paths, @atlassian/tangerine/import/entry-points, @atlassian/tangerine/import/no-parent-imports */ 
var $5eELe = parcelRequire("5eELe");

var $iQHUe = parcelRequire("iQHUe");

var $fBtgO = parcelRequire("fBtgO");

var $3UtzK = parcelRequire("3UtzK");

var $4dJkZ = parcelRequire("4dJkZ");

var $867dg = parcelRequire("867dg");

var $g3VDW = parcelRequire("g3VDW");

var $9hjCt = parcelRequire("9hjCt");

var $jp7ng = parcelRequire("jp7ng");
var $2ef51bc5ed6b4231$var$flagMapping = {
    success: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($5eELe))),
        label: "success",
        color: "var(--ds-icon-success, ".concat((0, $jp7ng).G300, ")")
    },
    error: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($4dJkZ))),
        label: "error",
        color: "var(--ds-icon-danger, ".concat((0, $jp7ng).R300, ")")
    },
    info: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($g3VDW))),
        label: "info",
        color: "var(--ds-icon-information, ".concat((0, $jp7ng).T300, ")")
    },
    warning: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($9hjCt))),
        label: "warning",
        color: "var(--ds-icon-warning, ".concat((0, $jp7ng).Y300, ")")
    },
    smallInfo: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3UtzK))),
        label: "info",
        color: "var(--ds-icon-discovery, ".concat((0, $jp7ng).P300, ")")
    },
    comment: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($iQHUe))),
        label: "comment",
        color: "var(--ds-icon, ".concat((0, $jp7ng).N300, ")")
    },
    download: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fBtgO))),
        label: "download",
        color: "var(--ds-icon, ".concat((0, $jp7ng).N300, ")")
    },
    feedback: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($867dg))),
        label: "comment",
        color: "var(--ds-icon, ".concat((0, $jp7ng).N300, ")")
    }
};
var $2ef51bc5ed6b4231$export$2e2bcd8739ae039 = $2ef51bc5ed6b4231$var$flagMapping;


function $750f9b1234abcf1d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $750f9b1234abcf1d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $750f9b1234abcf1d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($750f9b1234abcf1d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
// eslint-disable-next-line @repo/internal/react/no-class-components
var $750f9b1234abcf1d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(EngagementFlag, _Component);
    var _super = $750f9b1234abcf1d$var$_createSuper(EngagementFlag);
    function EngagementFlag() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, EngagementFlag);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onDismiss", function() {
            _this.props.fireClickEvent("dismiss");
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onPrimaryClick", function() {
            var _this$props = _this.props, fireClickEvent = _this$props.fireClickEvent, primaryAction = _this$props.primaryAction;
            fireClickEvent("primary");
            _this.onClickActionHandler(primaryAction);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onSecondaryClick", function() {
            var _this$props2 = _this.props, fireClickEvent = _this$props2.fireClickEvent, secondaryAction = _this$props2.secondaryAction;
            fireClickEvent("secondary");
            _this.onClickActionHandler(secondaryAction);
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(EngagementFlag, [
        {
            key: "onClickActionHandler",
            value: function onClickActionHandler(action) {
                if (action && action.type === (0, $29P43.buttonActionTypes).LINK && action.data) window.open(action.data.url, action.data.target);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props3 = this.props, title = _this$props3.title, body = _this$props3.body, primaryText = _this$props3.primaryText, secondaryText = _this$props3.secondaryText, icon = _this$props3.icon;
                var actions = [
                    {
                        content: primaryText,
                        onClick: this.onPrimaryClick
                    }
                ];
                if (secondaryText) actions.push({
                    content: secondaryText,
                    onClick: this.onSecondaryClick
                });
                var selectedIcon = (0, $2ef51bc5ed6b4231$export$2e2bcd8739ae039)[icon];
                var FlagIconComponent = selectedIcon && selectedIcon.component;
                var FlagIcon = FlagIconComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(FlagIconComponent, {
                    label: selectedIcon.label,
                    primaryColor: selectedIcon.color
                }) : null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $1zBji.default), {
                    onDismissed: this.onDismiss
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aMNOk.default), {
                    id: "engagement-flag",
                    appearance: "normal",
                    icon: FlagIcon,
                    title: title,
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $itT3v.default), {
                        html: body
                    }),
                    actions: actions
                }));
            }
        }
    ]);
    return EngagementFlag;
}((0, $9nHZC.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))($750f9b1234abcf1d$export$2e2bcd8739ae039, "defaultProps", {
    fireClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($9tjXs))),
    primaryText: null,
    primaryAction: null,
    secondaryText: null,
    secondaryAction: null,
    icon: "smallInfo"
});


var $dbd43fe9674ac551$export$8423d11067fbf579 = (0, $b8tvv.default)((0, $750f9b1234abcf1d$export$2e2bcd8739ae039));
var $dbd43fe9674ac551$export$2e2bcd8739ae039 = (0, $eeQJ3.default)($dbd43fe9674ac551$export$8423d11067fbf579, "flag");



var $b8tvv = parcelRequire("b8tvv");

var $eeQJ3 = parcelRequire("eeQJ3");

var $fPPqr = parcelRequire("fPPqr");

var $uqRmf = parcelRequire("uqRmf");

var $eVDe4 = parcelRequire("eVDe4");

var $lwdaQ = parcelRequire("lwdaQ");

var $3BD5g = parcelRequire("3BD5g");

var $ck3YL = parcelRequire("ck3YL");

var $lH0U2 = parcelRequire("lH0U2");

var $kFnE9 = parcelRequire("kFnE9");

var $9nHZC = parcelRequire("9nHZC");


var $29P43 = parcelRequire("29P43");

var $itT3v = parcelRequire("itT3v");
function $800f012cfcf73e69$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $800f012cfcf73e69$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $800f012cfcf73e69$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($800f012cfcf73e69$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $800f012cfcf73e69$var$header() {
    return null;
}
// eslint-disable-next-line @repo/internal/react/no-class-components
var $800f012cfcf73e69$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(ModalDialog, _Component);
    var _super = $800f012cfcf73e69$var$_createSuper(ModalDialog);
    function ModalDialog() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, ModalDialog);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onPrimaryAction", function() {
            _this.props.fireClickEvent("primary");
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($kFnE9)))((0, (/*@__PURE__*/$parcel$interopDefault($lwdaQ)))(_this), "onSecondaryAction", function() {
            _this.props.fireClickEvent("secondary");
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(ModalDialog, [
        {
            key: "getActionButton",
            value: function getActionButton(action, text, _onClick) {
                return {
                    text: text,
                    onClick: function onClick(e) {
                        if (action.type === (0, $29P43.buttonActionTypes).LINK && action.data) window.open(action.data.url, action.data.target);
                        _onClick(e);
                    }
                };
            }
        },
        {
            key: "getActions",
            value: function getActions() {
                var _this$props = this.props, primaryAction = _this$props.primaryAction, primaryText = _this$props.primaryText, secondaryAction = _this$props.secondaryAction, secondaryText = _this$props.secondaryText;
                var actions = [];
                if (primaryAction && primaryText) actions.push(this.getActionButton(primaryAction, primaryText, this.onPrimaryAction));
                if (secondaryAction && secondaryText) actions.push(this.getActionButton(secondaryAction, secondaryText, this.onSecondaryAction));
                return actions;
            }
        },
        {
            key: "getAdditionalModalProps",
            value: function getAdditionalModalProps() {
                var props = {};
                var imageSrc = this.props.imageSrc;
                if (imageSrc) props.image = imageSrc;
                else props.header = $800f012cfcf73e69$var$header;
                return props;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, title = _this$props2.title, body = _this$props2.body;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $1cbc8fabed6bd9b0$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
                    actions: this.getActions(),
                    heading: title
                }, this.getAdditionalModalProps()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $itT3v.default), {
                    html: body
                }));
            }
        }
    ]);
    return ModalDialog;
}((0, $9nHZC.Component));


var $98952fac76afb35e$export$404a075b2b026e91 = (0, $b8tvv.default)((0, $800f012cfcf73e69$export$2e2bcd8739ae039));
var $98952fac76afb35e$export$2e2bcd8739ae039 = (0, $eeQJ3.default)($98952fac76afb35e$export$404a075b2b026e91, "modalDialog");


function $c58870b4d49a025f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c58870b4d49a025f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lH0U2)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ck3YL)))(this, result);
    };
}
function $c58870b4d49a025f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c58870b4d49a025f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
// eslint-disable-next-line @repo/internal/react/no-class-components
var $c58870b4d49a025f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($3BD5g)))(EngagementMessages, _Component);
    var _super = $c58870b4d49a025f$var$_createSuper(EngagementMessages);
    function EngagementMessages() {
        (0, (/*@__PURE__*/$parcel$interopDefault($uqRmf)))(this, EngagementMessages);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eVDe4)))(EngagementMessages, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $98952fac76afb35e$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dbd43fe9674ac551$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $8bf2014f0ca811d8$export$2e2bcd8739ae039), null));
            }
        }
    ]);
    return EngagementMessages;
}((0, $9nHZC.Component)); // duplicate the export as a named one. That way, the export name in



var $2kKDW = parcelRequire("2kKDW");

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");
parcelRequire("dGzLf");
var $5oGLl = parcelRequire("5oGLl");

var $aMNOk = parcelRequire("aMNOk");

var $g3VDW = parcelRequire("g3VDW");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $d5yyK = parcelRequire("d5yyK");

var $gtaeM = parcelRequire("gtaeM");

var $8MzLl = parcelRequire("8MzLl");

var $agjvf = parcelRequire("agjvf");
var $20d5a53a3464344d$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    showUpdatedCommits: {
        "id": "frontbucket.commitsList.updatedCommitsFlag.showUpdatedCommits",
        "defaultMessage": "Load updates"
    },
    title: {
        "id": "frontbucket.commitsList.updatedCommitsFlag.title",
        "defaultMessage": "The commits list was updated"
    }
});


class $d460a4dd4da50814$export$20c5448601c38fd6 extends (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).PureComponent {
    constructor(...args){
        super(...args);
        this.showNewCommits = ()=>{
            (0, $8MzLl.startApdex)({
                task: (0, $gtaeM.ApdexTask).Commits,
                type: "transition"
            });
            this.props.showNewCommits();
        };
    }
    render() {
        const actions = [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, $20d5a53a3464344d$export$2e2bcd8739ae039).showUpdatedCommits),
                onClick: this.showNewCommits
            }
        ];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aMNOk.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
            actions: actions,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g3VDW))), {
                primaryColor: (0, $h39Sh.default)("color.icon.information", (0, $jp7ng).B400),
                label: "Info"
            }),
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, $20d5a53a3464344d$export$2e2bcd8739ae039).title)
        }, this.props));
    }
}
const $d460a4dd4da50814$var$mapDispatchToProps = {
    showNewCommits: $d5yyK.showNewCommits
};
var $d460a4dd4da50814$export$2e2bcd8739ae039 = (0, $5oGLl.default)(null, $d460a4dd4da50814$var$mapDispatchToProps)((0, $agjvf.injectIntl)($d460a4dd4da50814$export$20c5448601c38fd6));



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");
parcelRequire("dGzLf");
var $5oGLl = parcelRequire("5oGLl");

var $fBIHI = parcelRequire("fBIHI");
var $aMNOk = parcelRequire("aMNOk");

var $4dJkZ = parcelRequire("4dJkZ");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $5gF7V = parcelRequire("5gF7V");

var $9waMY = parcelRequire("9waMY");

var $f0vcS = parcelRequire("f0vcS");
const $3381ab07353c52ce$var$errorMessage = (error)=>{
    switch(error.type){
        case (0, $5gF7V.CREATE_BRANCH_ERROR_TYPE).BRANCH_ALREADY_EXISTS:
        case (0, $5gF7V.CREATE_BRANCH_ERROR_TYPE).BRANCH_PERMISSION_VIOLATED:
        case (0, $5gF7V.CREATE_BRANCH_ERROR_TYPE).INVALID_BRANCH_NAME:
            // These errors are shown inlined with the branch name input field, so not showing any flag
            return null;
        case (0, $5gF7V.CREATE_BRANCH_ERROR_TYPE).INSUFFICIENT_RIGHTS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, $f0vcS.default).insufficientRepoAccessRightsDescription);
        case (0, $5gF7V.CREATE_BRANCH_ERROR_TYPE).OTHER:
            // For these errors we simply show the message returned in API response
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("span", null, error.message);
        default:
        case (0, $5gF7V.CREATE_BRANCH_ERROR_TYPE).GENERIC:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, (0, $f0vcS.default).genericErrorDescription, {
                values: {
                    supportLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("a", {
                        target: "_blank",
                        href: (0, $9waMY.default).external.support
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, $f0vcS.default).supportLink))
                }
            }));
    }
};
const $3381ab07353c52ce$var$ErrorFlag = (0, $agjvf.injectIntl)(({ error: error, intl: intl, ...otherProps })=>{
    if (error) {
        const message = $3381ab07353c52ce$var$errorMessage(error);
        if (message) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aMNOk.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4dJkZ))), {
                label: "error",
                primaryColor: (0, $h39Sh.default)("color.icon.danger", (0, $jp7ng).R300)
            }),
            title: intl.formatMessage((0, $f0vcS.default).createBranchErrorTitle),
            description: $3381ab07353c52ce$var$errorMessage(error)
        }));
    }
    return null;
});
const $3381ab07353c52ce$var$mapStateToProps = (state)=>{
    const { error: error } = state.createBranch;
    return {
        error: error
    };
};
const $3381ab07353c52ce$export$da32fafae5bc420e = (0, $5oGLl.default)($3381ab07353c52ce$var$mapStateToProps)($3381ab07353c52ce$var$ErrorFlag);
const $3381ab07353c52ce$var$LoadRepositoriesErrorFlagBase = ({ id: id, intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fBIHI.default), {
        id: id,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4dJkZ))), {
            label: "error",
            primaryColor: (0, $h39Sh.default)("color.icon.danger", (0, $jp7ng).R300)
        }),
        title: intl.formatMessage((0, $f0vcS.default).loadRepositoriesErrorTitle),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, (0, $f0vcS.default).genericErrorDescription, {
            values: {
                supportLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("a", {
                    target: "_blank",
                    href: (0, $9waMY.default).external.support
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, $f0vcS.default).supportLink))
            }
        }))
    });
const $3381ab07353c52ce$export$511413daec44ce2b = (0, $agjvf.injectIntl)($3381ab07353c52ce$var$LoadRepositoriesErrorFlagBase);



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");
parcelRequire("dGzLf");
var $5oGLl = parcelRequire("5oGLl");

var $fBIHI = parcelRequire("fBIHI");

var $5eELe = parcelRequire("5eELe");

var $dLTSq = parcelRequire("dLTSq");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $agjvf = parcelRequire("agjvf");
var $5ae8c0cb69704954$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    createBranchSuccessTitle: {
        "id": "frontbucket.branches.createBranchSuccessTitle",
        "defaultMessage": "Branch created"
    },
    createBranchSuccessDescription: {
        "id": "frontbucket.branches.createBranchSuccessDescription",
        "defaultMessage": "You successfully created the {branchLabel} branch."
    },
    createBranchSuccessLinkText: {
        "id": "frontbucket.branches.createBranchSuccessLinkText",
        "defaultMessage": "Go to it"
    }
});


const $cec9ce4b636aa9a2$var$SuccessFlag = ({ id: id, branch: branch, intl: intl, ...otherProps })=>{
    if (!branch) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fBIHI.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
        id: id,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5eELe))), {
            label: "Success",
            primaryColor: (0, $h39Sh.default)("color.icon.success", (0, $jp7ng).G300)
        }),
        title: intl.formatMessage((0, $5ae8c0cb69704954$export$2e2bcd8739ae039).createBranchSuccessTitle),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, (0, $5ae8c0cb69704954$export$2e2bcd8739ae039).createBranchSuccessDescription, {
            values: {
                branchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dLTSq.default), {
                    text: branch.name
                })
            }
        })),
        actions: [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("a", {
                    href: branch.links.html.href
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, $5ae8c0cb69704954$export$2e2bcd8739ae039).createBranchSuccessLinkText)),
                onClick: ()=>{}
            }
        ]
    }));
};
const $cec9ce4b636aa9a2$var$mapStateToProps = (state)=>{
    const { successFlag: { branch: branch } } = state.createBranch;
    return {
        branch: branch
    };
};
const $cec9ce4b636aa9a2$export$5a60cab8a94c560e = (0, $5oGLl.default)($cec9ce4b636aa9a2$var$mapStateToProps)((0, $agjvf.injectIntl)($cec9ce4b636aa9a2$var$SuccessFlag));



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("dGzLf");
var $aAre5 = parcelRequire("aAre5");

var $aMNOk = parcelRequire("aMNOk");

var $g3VDW = parcelRequire("g3VDW");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $jajUg = parcelRequire("jajUg");

var $11JYn = parcelRequire("11JYn");

var $g2R3c = parcelRequire("g2R3c");

var $5utbt = parcelRequire("5utbt");

var $cjZE0 = parcelRequire("cjZE0");

var $5vIkm = parcelRequire("5vIkm");

var $agjvf = parcelRequire("agjvf");
var $6da91cc08f53d957$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    description: {
        "id": "frontbucket.workspace.settings.flags.defaultGroupIntroFlag.description",
        "defaultMessage": "Default groups are needed for members to invite new people into this workspace. Bitbucket will make a default group for you if you don\u2019t create one the next time an invite is sent to new user."
    },
    title: {
        "id": "frontbucket.workspace.settings.flags.defaultGroupIntroFlag.title",
        "defaultMessage": "Introducing default groups"
    },
    chooseExistingAction: {
        "id": "frontbucket.workspace.settings.flags.defaultGroupIntroFlag.chooseExistingAction",
        "defaultMessage": "Choose existing group"
    },
    createDefaultGroupAction: {
        "id": "frontbucket.workspace.settings.flags.defaultGroupIntroFlag.createDefaultGroupAction",
        "defaultMessage": "Create default group"
    }
});


const $35816828a7b837ec$export$893a3c233589dd2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo((props)=>{
    const intl = (0, $jajUg.useIntl)();
    const currentUser = (0, $aAre5.useSelector)((0, $g2R3c.getCurrentUser));
    const currentWorkspaceSlug = (0, $aAre5.useSelector)((0, $5utbt.getCurrentWorkspaceSlug));
    const markDismissed = (0, $9nHZC.useCallback)(()=>{
        if (currentUser && currentWorkspaceSlug) {
            (0, $5vIkm.setDismissed)(currentUser, currentWorkspaceSlug);
            // dismissal confirms that a user has seen the flag
            (0, $5vIkm.setShownNow)(currentUser, currentWorkspaceSlug);
        }
    }, [
        currentUser,
        currentWorkspaceSlug
    ]);
    const { id: id, handleDismissed: handleDismissed } = props;
    const actions = (0, $9nHZC.useMemo)(()=>{
        return [
            {
                content: intl.formatMessage((0, $6da91cc08f53d957$export$2e2bcd8739ae039).createDefaultGroupAction),
                onClick: ()=>{
                    markDismissed();
                    location.hash = `#${(0, $cjZE0.ModalDialogUrlHash).CREATE_GROUP_MODAL_KEY}`;
                    handleDismissed(id);
                }
            },
            {
                content: intl.formatMessage((0, $6da91cc08f53d957$export$2e2bcd8739ae039).chooseExistingAction),
                onClick: ()=>{
                    markDismissed();
                    location.hash = `#${(0, $cjZE0.ModalDialogUrlHash).CHOOSE_GROUP_MODAL_KEY}`;
                    handleDismissed(id);
                }
            }
        ];
    }, [
        intl,
        handleDismissed,
        markDismissed,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aMNOk.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        onDismissed: markDismissed,
        actions: actions,
        appearance: (0, $11JYn.AppearanceTypes).normal,
        description: intl.formatMessage((0, $6da91cc08f53d957$export$2e2bcd8739ae039).description),
        title: intl.formatMessage((0, $6da91cc08f53d957$export$2e2bcd8739ae039).title),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g3VDW))), {
            label: "",
            primaryColor: (0, $h39Sh.default)("color.icon.discovery", (0, $jp7ng).P300)
        })
    }, props));
});



var $6aoKW = parcelRequire("6aoKW");

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");
parcelRequire("dGzLf");
var $5oGLl = parcelRequire("5oGLl");

var $jF3Yx = parcelRequire("jF3Yx");

var $fBIHI = parcelRequire("fBIHI");

var $4dJkZ = parcelRequire("4dJkZ");

var $dLTSq = parcelRequire("dLTSq");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $a7iuM = parcelRequire("a7iuM");
parcelRequire("fojQl");
var $4cfLu = parcelRequire("4cfLu");

var $14luU = parcelRequire("14luU");

var $agjvf = parcelRequire("agjvf");
const $18d6a19b8a6220e7$var$sync = (0, $agjvf.defineMessages)({
    compareBranchesErrorTitle: {
        "id": "frontbucket.branches.syncBranchErrorTitle",
        "defaultMessage": "Unable to sync branch"
    },
    compareBranchesErrorDescription: {
        "id": "frontbucket.branches.syncBranchErrorDescription",
        "defaultMessage": "{destinationBranch} wasn't synced with {sourceBranch}"
    }
});
const $18d6a19b8a6220e7$var$merge = (0, $agjvf.defineMessages)({
    compareBranchesErrorTitle: {
        "id": "frontbucket.branches.mergeBranchErrorTitle",
        "defaultMessage": "Unable to merge branch"
    },
    compareBranchesErrorDescription: {
        "id": "frontbucket.branches.mergeBranchErrorDescription",
        "defaultMessage": "{sourceBranch} wasn't merged into {destinationBranch}"
    }
});
var $18d6a19b8a6220e7$export$2e2bcd8739ae039 = {
    sync: $18d6a19b8a6220e7$var$sync,
    merge: $18d6a19b8a6220e7$var$merge
};


const $74dcf812702c668d$var$ErrorFlag = ({ id: id, intl: intl, action: action, sourceBranchName: sourceBranchName, destinationBranchName: destinationBranchName, errorMessage: errorMessage, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fBIHI.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
        id: id,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4dJkZ))), {
            label: "error",
            primaryColor: (0, $h39Sh.default)("color.icon.danger", (0, $jp7ng).R300)
        }),
        title: intl.formatMessage((0, $18d6a19b8a6220e7$export$2e2bcd8739ae039)[action].compareBranchesErrorTitle),
        description: errorMessage || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, (0, $18d6a19b8a6220e7$export$2e2bcd8739ae039)[action].compareBranchesErrorDescription, {
            values: {
                sourceBranch: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $a7iuM.default), {
                    content: sourceBranchName,
                    tag: "span"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dLTSq.default), {
                    text: sourceBranchName
                })),
                destinationBranch: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $a7iuM.default), {
                    content: destinationBranchName,
                    tag: "span"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dLTSq.default), {
                    text: destinationBranchName
                }))
            }
        }))
    }));
const $74dcf812702c668d$var$mapStateToProps = (state)=>{
    const { sourceBranchName: sourceBranchName, destinationBranchName: destinationBranchName, sourceRepositoryFullName: sourceRepositoryFullName, destinationRepositoryFullName: destinationRepositoryFullName, isMerge: isMerge, errorMessage: errorMessage } = (0, $4cfLu.getCompareBranchesDialogSlice)(state);
    const fullNames = (0, $14luU.getBranchesFullNames)(sourceBranchName, destinationBranchName, sourceRepositoryFullName, destinationRepositoryFullName);
    return {
        action: isMerge ? "merge" : "sync",
        sourceBranchName: fullNames.sourceBranchName,
        destinationBranchName: fullNames.destinationBranchName,
        errorMessage: errorMessage
    };
};
const $74dcf812702c668d$export$caa4342d17f8bd05 = (0, $jF3Yx.compose)((0, $agjvf.injectIntl), (0, $5oGLl.default)($74dcf812702c668d$var$mapStateToProps))($74dcf812702c668d$var$ErrorFlag);



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");
parcelRequire("dGzLf");
var $5oGLl = parcelRequire("5oGLl");

var $jF3Yx = parcelRequire("jF3Yx");

var $fBIHI = parcelRequire("fBIHI");

var $5eELe = parcelRequire("5eELe");

var $dLTSq = parcelRequire("dLTSq");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $a7iuM = parcelRequire("a7iuM");
parcelRequire("fojQl");
var $4cfLu = parcelRequire("4cfLu");

var $14luU = parcelRequire("14luU");

var $agjvf = parcelRequire("agjvf");
const $4286ebd1121cde89$var$sync = (0, $agjvf.defineMessages)({
    compareBranchesSuccessTitle: {
        "id": "frontbucket.branches.syncBranchSuccessTitle",
        "defaultMessage": "Branch synced"
    },
    compareBranchesSuccessDescription: {
        "id": "frontbucket.branches.syncBranchSuccessDescription",
        "defaultMessage": "{destinationBranch} successfully synced with {sourceBranch}"
    }
});
const $4286ebd1121cde89$var$merge = (0, $agjvf.defineMessages)({
    compareBranchesSuccessTitle: {
        "id": "frontbucket.branches.mergeBranchSuccessTitle",
        "defaultMessage": "Branch merged"
    },
    compareBranchesSuccessDescription: {
        "id": "frontbucket.branches.mergeBranchSuccessDescription",
        "defaultMessage": "{sourceBranch} successfully merged into {destinationBranch}"
    }
});
var $4286ebd1121cde89$export$2e2bcd8739ae039 = {
    sync: $4286ebd1121cde89$var$sync,
    merge: $4286ebd1121cde89$var$merge
};


const $11f9aca16ae3305f$var$SuccessFlag = ({ intl: intl, id: id, action: action, sourceBranchName: sourceBranchName, destinationBranchName: destinationBranchName, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fBIHI.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
        id: id,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5eELe))), {
            label: "success",
            primaryColor: (0, $h39Sh.default)("color.icon.success", (0, $jp7ng).G300)
        }),
        title: intl.formatMessage((0, $4286ebd1121cde89$export$2e2bcd8739ae039)[action].compareBranchesSuccessTitle),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, (0, $4286ebd1121cde89$export$2e2bcd8739ae039)[action].compareBranchesSuccessDescription, {
            values: {
                sourceBranch: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $a7iuM.default), {
                    content: sourceBranchName,
                    tag: "span"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dLTSq.default), {
                    text: sourceBranchName
                })),
                destinationBranch: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $a7iuM.default), {
                    content: destinationBranchName,
                    tag: "span"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dLTSq.default), {
                    text: destinationBranchName
                }))
            }
        }))
    }));
const $11f9aca16ae3305f$var$mapStateToProps = (state)=>{
    const { sourceBranchName: sourceBranchName, destinationBranchName: destinationBranchName, sourceRepositoryFullName: sourceRepositoryFullName, destinationRepositoryFullName: destinationRepositoryFullName, isMerge: isMerge } = (0, $4cfLu.getCompareBranchesDialogSlice)(state);
    const fullNames = (0, $14luU.getBranchesFullNames)(sourceBranchName, destinationBranchName, sourceRepositoryFullName, destinationRepositoryFullName);
    return {
        action: isMerge ? "merge" : "sync",
        sourceBranchName: fullNames.sourceBranchName,
        destinationBranchName: fullNames.destinationBranchName
    };
};
const $11f9aca16ae3305f$export$fe418da0fcae36b6 = (0, $jF3Yx.compose)((0, $agjvf.injectIntl), (0, $5oGLl.default)($11f9aca16ae3305f$var$mapStateToProps))($11f9aca16ae3305f$var$SuccessFlag);



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");
parcelRequire("dGzLf");
var $aAre5 = parcelRequire("aAre5");

var $aMNOk = parcelRequire("aMNOk");

var $g3VDW = parcelRequire("g3VDW");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $jajUg = parcelRequire("jajUg");
parcelRequire("fojQl");
var $4cfLu = parcelRequire("4cfLu");

var $agjvf = parcelRequire("agjvf");
const $10e58d47fc5b7176$var$sync = (0, $agjvf.defineMessages)({
    compareBranchesTimeoutTitle: {
        "id": "frontbucket.branches.updatedSyncBranchTimeoutTitle",
        "defaultMessage": "Branch sync"
    },
    compareBranchesTimeoutDescription: {
        "id": "frontbucket.branches.updatedSyncBranchTimeoutDescription",
        "defaultMessage": "The sync is still running in the background. Wait a few minutes and then refresh the page."
    },
    compareBranchesTimeoutAction: {
        "id": "frontbucket.branches.updatedSyncBranchTimeoutAction",
        "defaultMessage": "Refresh"
    }
});
const $10e58d47fc5b7176$var$merge = (0, $agjvf.defineMessages)({
    compareBranchesTimeoutTitle: {
        "id": "frontbucket.branches.updatedMergeBranchTimeoutTitle",
        "defaultMessage": "Branch merge"
    },
    compareBranchesTimeoutDescription: {
        "id": "frontbucket.branches.updatedMergeBranchTimeoutDescription",
        "defaultMessage": "The merge is still running in the background. Wait a few minutes and then refresh the page."
    },
    compareBranchesTimeoutAction: {
        "id": "frontbucket.branches.updatedMergeBranchTimeoutAction",
        "defaultMessage": "Refresh"
    }
});
var $10e58d47fc5b7176$export$2e2bcd8739ae039 = {
    sync: $10e58d47fc5b7176$var$sync,
    merge: $10e58d47fc5b7176$var$merge
};


const $811cf4b3608ce069$export$a7f5ef9f67c4bcc9 = ({ id: id, ...otherProps })=>{
    const intl = (0, $jajUg.useIntl)();
    const { isMerge: isMerge } = (0, $aAre5.useSelector)((0, $4cfLu.getCompareBranchesDialogSlice));
    const action = isMerge ? "merge" : "sync";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aMNOk.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
        id: id,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g3VDW))), {
            label: "info",
            primaryColor: (0, $h39Sh.default)("color.icon.discovery", (0, $jp7ng).P300)
        }),
        title: intl.formatMessage((0, $10e58d47fc5b7176$export$2e2bcd8739ae039)[action].compareBranchesTimeoutTitle),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, $10e58d47fc5b7176$export$2e2bcd8739ae039)[action].compareBranchesTimeoutDescription)
    }));
};



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $fBIHI = parcelRequire("fBIHI");

var $4dJkZ = parcelRequire("4dJkZ");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $jajUg = parcelRequire("jajUg");

var $kvnVB = parcelRequire("kvnVB");

var $agjvf = parcelRequire("agjvf");
var $fce90c9a722b6afc$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    workspaceCreateErrorTitle: {
        "id": "frontbucket.workspace.createWorkspaceError.title",
        "defaultMessage": "We couldn't create a workspace"
    },
    workspaceCreateErrorDescription: {
        "id": "frontbucket.workspace.createWorkspaceError.description",
        "defaultMessage": "If this keeps happening, {checkStatus}."
    },
    workspaceCreateCheckStatusPage: {
        "id": "frontbucket.workspace.createWorkspaceError.checkStatusPage",
        "defaultMessage": "check our status page"
    }
});


const $a76fd752d0c4fa54$var$CreateWorkspaceErrorFlag = ({ id: id, description: description, ...otherProps })=>{
    const intl = (0, $jajUg.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fBIHI.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
        id: id,
        title: intl.formatMessage((0, $fce90c9a722b6afc$export$2e2bcd8739ae039).workspaceCreateErrorTitle),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4dJkZ))), {
            label: "Error",
            primaryColor: (0, $h39Sh.default)("color.icon.danger", (0, $jp7ng).R300)
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, (0, $fce90c9a722b6afc$export$2e2bcd8739ae039).workspaceCreateErrorDescription, {
            values: {
                checkStatus: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("a", {
                    href: (0, $kvnVB.settings)().STATUSPAGE_URL
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, $fce90c9a722b6afc$export$2e2bcd8739ae039).workspaceCreateCheckStatusPage))
            }
        }))
    }));
};
var $a76fd752d0c4fa54$export$2e2bcd8739ae039 = $a76fd752d0c4fa54$var$CreateWorkspaceErrorFlag;



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");
parcelRequire("dGzLf");
var $5oGLl = parcelRequire("5oGLl");

var $jF3Yx = parcelRequire("jF3Yx");

var $fBIHI = parcelRequire("fBIHI");

var $4dJkZ = parcelRequire("4dJkZ");

var $dLTSq = parcelRequire("dLTSq");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");
parcelRequire("fojQl");
var $pUQWs = parcelRequire("pUQWs");
var $4cfLu = parcelRequire("4cfLu");

var $agjvf = parcelRequire("agjvf");
var $9fd9b98d579da04f$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    deleteBranchErrorTitle: {
        "id": "frontbucket.branches.deleteBranchErrorTitle",
        "defaultMessage": "Unable to delete branch"
    },
    deleteBranchErrorDescriptionNotFound: {
        "id": "frontbucket.branches.deleteBranchErrorDescriptionNotFound",
        "defaultMessage": "We couldn't find the {branchLabel} branch.  It might have already been deleted."
    },
    deleteBranchErrorDescriptionAccessDenied: {
        "id": "frontbucket.branches.deleteBranchErrorDescriptionAccessDenied",
        "defaultMessage": "You do not have permission to delete the {branchLabel} branch."
    },
    deleteBranchErrorDescriptionGeneric: {
        "id": "frontbucket.branches.deleteBranchErrorDescriptionGeneric",
        "defaultMessage": "We were unable to delete the {branchLabel} branch."
    }
});


const $a77f0171a73b7ce2$var$getErrorMessage = (errorType)=>{
    switch(errorType){
        case (0, $pUQWs.DeleteBranchErrorTypes).BRANCH_NOT_FOUND:
            return (0, $9fd9b98d579da04f$export$2e2bcd8739ae039).deleteBranchErrorDescriptionNotFound;
        case (0, $pUQWs.DeleteBranchErrorTypes).ACCESS_DENIED:
            return (0, $9fd9b98d579da04f$export$2e2bcd8739ae039).deleteBranchErrorDescriptionAccessDenied;
        default:
        case (0, $pUQWs.DeleteBranchErrorTypes).GENERIC:
            return (0, $9fd9b98d579da04f$export$2e2bcd8739ae039).deleteBranchErrorDescriptionGeneric;
    }
};
const $a77f0171a73b7ce2$var$ErrorFlag = ({ branchName: branchName, errorType: errorType, intl: intl, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fBIHI.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4dJkZ))), {
            label: "error",
            primaryColor: (0, $h39Sh.default)("color.icon.danger", (0, $jp7ng).R300)
        }),
        title: intl.formatMessage((0, $9fd9b98d579da04f$export$2e2bcd8739ae039).deleteBranchErrorTitle),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, $a77f0171a73b7ce2$var$getErrorMessage(errorType), {
            values: {
                branchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dLTSq.default), {
                    text: branchName
                })
            }
        }))
    }));
const $a77f0171a73b7ce2$var$mapStateToProps = (state)=>{
    const { errorFlag: { branchName: branchName, errorType: errorType } } = (0, $4cfLu.getDeleteBranchDialogSlice)(state);
    return {
        branchName: branchName,
        errorType: errorType
    };
};
const $a77f0171a73b7ce2$export$da4b6bd6e8d7af2b = (0, $jF3Yx.compose)((0, $agjvf.injectIntl), (0, $5oGLl.default)($a77f0171a73b7ce2$var$mapStateToProps))($a77f0171a73b7ce2$var$ErrorFlag);



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");
parcelRequire("dGzLf");
var $5oGLl = parcelRequire("5oGLl");

var $jF3Yx = parcelRequire("jF3Yx");

var $fBIHI = parcelRequire("fBIHI");

var $5eELe = parcelRequire("5eELe");

var $dLTSq = parcelRequire("dLTSq");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");
parcelRequire("fojQl");
var $4cfLu = parcelRequire("4cfLu");

var $agjvf = parcelRequire("agjvf");
var $42c368be5db8bec6$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    deleteBranchSuccessTitle: {
        "id": "frontbucket.branches.deleteBranchSuccessTitle",
        "defaultMessage": "Branch deleted"
    },
    deleteBranchSuccessDescription: {
        "id": "frontbucket.branches.deleteBranchSuccessDescription",
        "defaultMessage": "You successfully deleted the {branchLabel} branch."
    }
});


const $b8364e436207393f$var$SuccessFlag = ({ branchName: branchName, intl: intl, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fBIHI.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5eELe))), {
            label: "success",
            primaryColor: (0, $h39Sh.default)("color.icon.success", (0, $jp7ng).G300)
        }),
        title: intl.formatMessage((0, $42c368be5db8bec6$export$2e2bcd8739ae039).deleteBranchSuccessTitle),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, (0, $42c368be5db8bec6$export$2e2bcd8739ae039).deleteBranchSuccessDescription, {
            values: {
                branchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dLTSq.default), {
                    text: branchName
                })
            }
        }))
    }));
const $b8364e436207393f$var$mapStateToProps = (state)=>{
    const { successFlag: { branchName: branchName } } = (0, $4cfLu.getDeleteBranchDialogSlice)(state);
    return {
        branchName: branchName
    };
};
const $b8364e436207393f$export$ff0385180b3a2e36 = (0, $jF3Yx.compose)((0, $agjvf.injectIntl), (0, $5oGLl.default)($b8364e436207393f$var$mapStateToProps))($b8364e436207393f$var$SuccessFlag);



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $fBIHI = parcelRequire("fBIHI");

var $4dJkZ = parcelRequire("4dJkZ");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $jajUg = parcelRequire("jajUg");

var $agjvf = parcelRequire("agjvf");
var $405786e9e6ba20d9$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    deleteRepositoryErrorTitle: {
        "id": "frontbucket.dashboard.deleteRepositoryErrorTitle",
        "defaultMessage": "Unable to delete repository"
    },
    deleteRepositoryErrorDescription: {
        "id": "frontbucket.dashboard.deleteRepositoryErrorDescription",
        "defaultMessage": "The repository cannot be deleted due to being under SOX compliance"
    }
});


const $1d33c18b6e0b6433$var$DeleteRepositoryErrorFlag = ({ id: id, description: description, ...otherProps })=>{
    const intl = (0, $jajUg.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fBIHI.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
        id: id,
        description: intl.formatMessage((0, $405786e9e6ba20d9$export$2e2bcd8739ae039).deleteRepositoryErrorDescription),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4dJkZ))), {
            label: "Error",
            primaryColor: (0, $h39Sh.default)("color.icon.danger", (0, $jp7ng).R300)
        }),
        title: intl.formatMessage((0, $405786e9e6ba20d9$export$2e2bcd8739ae039).deleteRepositoryErrorTitle)
    }));
};
var $1d33c18b6e0b6433$export$2e2bcd8739ae039 = $1d33c18b6e0b6433$var$DeleteRepositoryErrorFlag;



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $cJH1T = parcelRequire("cJH1T");

var $agjvf = parcelRequire("agjvf");

var $fBIHI = parcelRequire("fBIHI");

var $5eELe = parcelRequire("5eELe");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $jajUg = parcelRequire("jajUg");

var $agjvf = parcelRequire("agjvf");
var $5a5b60de710f8e25$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    deleteMessageSuccessTitle: {
        "id": "frontbucket.dashboard.deleteMessageSuccessTitle",
        "defaultMessage": "Repository deleted"
    },
    deleteMessageDescription: {
        "id": "frontbucket.dashboard.deleteMessageDescription",
        "defaultMessage": "{repoName} was successfully deleted."
    },
    deleteUnknownRepoDescription: {
        "id": "frontbucket.dashboard.deleteUnknownRepoDescription",
        "defaultMessage": "Repository was successfully deleted."
    }
});


const $442b36f5e69cb88d$var$DeleteRepositorySuccessFlag = ({ id: id, description: description, ...otherProps })=>{
    const intl = (0, $jajUg.useIntl)();
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($cJH1T))).parse(window.location.search, {
        ignoreQueryPrefix: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fBIHI.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
        id: id,
        description: query.repo_name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, (0, $5a5b60de710f8e25$export$2e2bcd8739ae039).deleteMessageDescription, {
            values: {
                repoName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("strong", null, query.repo_name)
            }
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, $5a5b60de710f8e25$export$2e2bcd8739ae039).deleteUnknownRepoDescription),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5eELe))), {
            label: "Success",
            primaryColor: (0, $h39Sh.default)("color.icon.success", (0, $jp7ng).G300)
        }),
        title: intl.formatMessage((0, $5a5b60de710f8e25$export$2e2bcd8739ae039).deleteMessageSuccessTitle)
    }));
};
var $442b36f5e69cb88d$export$2e2bcd8739ae039 = $442b36f5e69cb88d$var$DeleteRepositorySuccessFlag;



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("dGzLf");
var $eeHDY = parcelRequire("eeHDY");

var $aMNOk = parcelRequire("aMNOk");

var $9hjCt = parcelRequire("9hjCt");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $jajUg = parcelRequire("jajUg");

var $i2O3k = parcelRequire("i2O3k");

var $19fn8 = parcelRequire("19fn8");

var $11JYn = parcelRequire("11JYn");
const $78e6616f1be08880$export$1454caeeb6d6e203 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo((props)=>{
    const intl = (0, $jajUg.useIntl)();
    const dispatch = (0, $eeHDY.useDispatch)();
    const { id: id, handleDismissed: handleDismissed } = props;
    const actions = (0, $9nHZC.useMemo)(()=>[
            {
                content: intl.formatMessage((0, $19fn8.default).errorFlagRetryButton),
                onClick: ()=>{
                    dispatch((0, $i2O3k.toggleSettingsDialog)(true));
                    handleDismissed(id);
                }
            }
        ], [
        dispatch,
        id,
        intl,
        handleDismissed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aMNOk.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        actions: actions,
        appearance: (0, $11JYn.AppearanceTypes).normal,
        description: intl.formatMessage((0, $19fn8.default).errorFlagDescription),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9hjCt))), {
            label: "",
            primaryColor: (0, $h39Sh.default)("color.icon.warning", (0, $jp7ng).Y300)
        }),
        title: intl.formatMessage((0, $19fn8.default).errorFlagTitle)
    }, props));
});



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $fBIHI = parcelRequire("fBIHI");

var $4dJkZ = parcelRequire("4dJkZ");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $jajUg = parcelRequire("jajUg");

var $agjvf = parcelRequire("agjvf");
var $bc9a6a4fd42eff16$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    loadContextErrorTitle: {
        "id": "frontbucket.dashboard.loadContextErrorTitle",
        "defaultMessage": "Something went wrong"
    },
    loadContextErrorDescription: {
        "id": "frontbucket.dashboard.loadContextErrorDescription",
        "defaultMessage": "We are unable to load additional context. Please try again."
    },
    loadContextForbiddenNotFoundTitle: {
        "id": "frontbucket.dashboard.loadContextForbiddenNoFoundTitle",
        "defaultMessage": "Unable to load context"
    },
    loadContextForbiddenNotFoundDescription: {
        "id": "frontbucket.dashboard.loadContextForbiddenNotFoundDescription",
        "defaultMessage": "The source repository either does not exist or you do not have access."
    }
});


const $4feaa5b6cabce4b9$export$ace7ccade6f072f6 = ({ id: id, description: description, ...otherProps })=>{
    const intl = (0, $jajUg.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fBIHI.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
        id: id,
        description: intl.formatMessage((0, $bc9a6a4fd42eff16$export$2e2bcd8739ae039).loadContextErrorDescription),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4dJkZ))), {
            label: "Error",
            primaryColor: (0, $h39Sh.default)("color.icon.danger", (0, $jp7ng).R300)
        }),
        title: intl.formatMessage((0, $bc9a6a4fd42eff16$export$2e2bcd8739ae039).loadContextErrorTitle)
    }));
};



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $fBIHI = parcelRequire("fBIHI");

var $4dJkZ = parcelRequire("4dJkZ");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $jajUg = parcelRequire("jajUg");

const $b966ba30b96d2234$export$6a97e614955acf5c = ({ id: id, description: description, ...otherProps })=>{
    const intl = (0, $jajUg.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fBIHI.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
        id: id,
        description: intl.formatMessage((0, $bc9a6a4fd42eff16$export$2e2bcd8739ae039).loadContextForbiddenNotFoundDescription),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4dJkZ))), {
            label: "Error",
            primaryColor: (0, $h39Sh.default)("color.icon.danger", (0, $jp7ng).R300)
        }),
        title: intl.formatMessage((0, $bc9a6a4fd42eff16$export$2e2bcd8739ae039).loadContextForbiddenNotFoundTitle)
    }));
};



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $fBIHI = parcelRequire("fBIHI");

var $5eELe = parcelRequire("5eELe");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $jajUg = parcelRequire("jajUg");

var $agjvf = parcelRequire("agjvf");
var $44af5d7154479453$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    giveFeedbackSuccessTitle: {
        "id": "frontbucket.feedback.give.title",
        "defaultMessage": "Thanks!"
    },
    giveFeedbackSuccessBody: {
        "id": "frontbucket.repository.feedback.give.description",
        "defaultMessage": "Your valuable feedback helps us continually improve our products."
    }
});


const $627a311121ec7dd7$export$7e4c14bc1ac529f4 = ({ id: id, props: props, ...otherProps })=>{
    const intl = (0, $jajUg.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fBIHI.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
        id: id,
        description: intl.formatMessage((0, $44af5d7154479453$export$2e2bcd8739ae039).giveFeedbackSuccessBody),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5eELe))), {
            primaryColor: (0, $h39Sh.default)("color.icon.success", (0, $jp7ng).G300),
            label: "success"
        }),
        title: intl.formatMessage((0, $44af5d7154479453$export$2e2bcd8739ae039).giveFeedbackSuccessTitle)
    }));
};



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("dGzLf");
var $eeHDY = parcelRequire("eeHDY");

var $aMNOk = parcelRequire("aMNOk");

var $g3VDW = parcelRequire("g3VDW");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $jajUg = parcelRequire("jajUg");

var $i2O3k = parcelRequire("i2O3k");

var $11JYn = parcelRequire("11JYn");

var $agjvf = parcelRequire("agjvf");
var $ef86f7f5324063e7$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    fileModeOnboardingFlagTitle: {
        "id": "frontbucket.pullRequest.fileModeOnboardingFlagTitle",
        "defaultMessage": "You can now load files individually"
    },
    fileModeOnboardingFlagDescription: {
        "id": "frontbucket.pullRequest.fileModeOnboardingFlagDescription",
        "defaultMessage": "Improve performance and stay focused by configuring your diff settings."
    },
    gotItAction: {
        "id": "frontbucket.pullRequest.gotItAction",
        "defaultMessage": "Got it"
    },
    viewPrefsAction: {
        "id": "frontbucket.pullRequest.viewPrefsAction",
        "defaultMessage": "Take me to diff settings"
    }
});


const $b20c1739fdb8f525$export$13c2f39f3e05520f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo((props)=>{
    const intl = (0, $jajUg.useIntl)();
    const dispatch = (0, $eeHDY.useDispatch)();
    const { id: id, handleDismissed: handleDismissed } = props;
    const actions = (0, $9nHZC.useMemo)(()=>{
        const actionItems = [
            {
                content: intl.formatMessage((0, $ef86f7f5324063e7$export$2e2bcd8739ae039).gotItAction),
                onClick: ()=>{
                    handleDismissed(id);
                }
            }
        ];
        actionItems.push({
            content: intl.formatMessage((0, $ef86f7f5324063e7$export$2e2bcd8739ae039).viewPrefsAction),
            onClick: ()=>{
                dispatch((0, $i2O3k.toggleSettingsDialog)(true));
                handleDismissed(id);
            }
        });
        return actionItems;
    }, [
        dispatch,
        intl,
        handleDismissed,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aMNOk.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        actions: actions,
        appearance: (0, $11JYn.AppearanceTypes).normal,
        description: intl.formatMessage((0, $ef86f7f5324063e7$export$2e2bcd8739ae039).fileModeOnboardingFlagDescription),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g3VDW))), {
            label: "",
            primaryColor: (0, $h39Sh.default)("color.icon.discovery", (0, $jp7ng).P300)
        }),
        title: intl.formatMessage((0, $ef86f7f5324063e7$export$2e2bcd8739ae039).fileModeOnboardingFlagTitle)
    }, props));
});



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $aMNOk = parcelRequire("aMNOk");

var $g3VDW = parcelRequire("g3VDW");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $9H597 = parcelRequire("9H597");
const $b863230eb484c4d4$export$670485040d4f2b22 = ({ id: id, props: props, ...otherProps })=>{
    const { bugReportLink: bugReportLink } = props;
    const newUrl = (0, $9H597.appendParamToPath)({
        spa: 0
    });
    const actions = [
        {
            content: "Take me to the old page",
            href: newUrl
        }
    ];
    if (bugReportLink) actions.push({
        content: "Found a bug?",
        href: bugReportLink
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aMNOk.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
        id: id,
        description: "We are testing a new design of this page internally with fellow Atlassians. If you need to view the old page please click the link below.",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g3VDW))), {
            primaryColor: (0, $h39Sh.default)("color.icon.information", (0, $jp7ng).B300),
            label: "success"
        }),
        title: "Like the new look?",
        actions: actions
    }));
};



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");
parcelRequire("dGzLf");
var $aAre5 = parcelRequire("aAre5");

var $fBIHI = parcelRequire("fBIHI");

var $5eELe = parcelRequire("5eELe");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $26ud1 = parcelRequire("26ud1");

var $lALYr = parcelRequire("lALYr");

var $agjvf = parcelRequire("agjvf");
var $61a8661fddabdae2$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    successTitle: {
        "id": "frontbucket.jiraTab.createIssueFlag.successTitle",
        "defaultMessage": "Issue successfully created!"
    },
    successDescription: {
        "id": "frontbucket.jiraTab.createIssueFlag.successDescription",
        "defaultMessage": "The issue {issueKey} was successfully created in the {projectName} ({projectKey}) project."
    },
    viewIssueLink: {
        "id": "frontbucket.jiraTab.createIssueSuccessFlag.viewIssueLink",
        "defaultMessage": "View issue"
    }
});


const $0550b464c586551d$export$ff0874adeb1c1e4c = ({ id: id, handleDismissed: handleDismissed, ...otherProps })=>{
    const issue = (0, $aAre5.useSelector)((0, $lALYr.getCreatedJiraIssue));
    if (!issue) return null;
    const handleClick = (e)=>{
        const uiEvent = {
            action: "clicked",
            actionSubject: "link",
            actionSubjectId: "createdJiraIssue",
            source: "createJiraIssueSuccessFlag"
        };
        (0, $26ud1.handleJiraIssueLinkClick)(e, uiEvent, issue.site.cloudUrl, issue.key);
        // Dismiss the flag unless issue was opened in new tab
        if (!e.metaKey && !e.ctrlKey) handleDismissed(id);
    };
    const issueLink = (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("a", {
            href: `${issue.site.cloudUrl}/browse/${issue.key}`,
            target: "_blank",
            onClick: handleClick
        }, text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fBIHI.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
        id: id,
        onDismissed: handleDismissed,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5eELe))), {
            label: "",
            primaryColor: (0, $h39Sh.default)("color.icon.success", (0, $jp7ng).G300)
        }),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, $61a8661fddabdae2$export$2e2bcd8739ae039).successTitle),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, (0, $61a8661fddabdae2$export$2e2bcd8739ae039).successDescription, {
            values: {
                issueKey: issueLink(issue.key),
                projectName: issue.project.name,
                projectKey: issue.project.key
            }
        })),
        actions: [
            {
                content: issueLink(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, $61a8661fddabdae2$export$2e2bcd8739ae039).viewIssueLink))
            }
        ],
        testId: "jira-tab-issue-created-flag"
    }));
};



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("dGzLf");
var $5oGLl = parcelRequire("5oGLl");
var $eeHDY = parcelRequire("eeHDY");

var $aMNOk = parcelRequire("aMNOk");

var $g3VDW = parcelRequire("g3VDW");

var $dEKDm = parcelRequire("dEKDm");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $jajUg = parcelRequire("jajUg");

var $dkkN8 = parcelRequire("dkkN8");
function $9a012ee674853dcf$export$2e2bcd8739ae039(needsMarketingConsent) {
    return {
        type: (0, $dkkN8.TOGGLE_MARKETING_CONSENT_NEEDED),
        payload: needsMarketingConsent
    };
}



var $k2cPS = parcelRequire("k2cPS");

var $2xJU3 = parcelRequire("2xJU3");
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */ function $f00a350f326f4ad5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f00a350f326f4ad5$export$2f8a82f9bac44423 = (0, $2xJU3.default)("div", {
    target: "eavqdug0"
})({
    name: "g3pwx8",
    styles: "button{text-decoration:none !important;}div::before{content:'';}"
});



var $agjvf = parcelRequire("agjvf");
var $95c6c2caa7205830$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    marketingConsentTitle: {
        "id": "frontbucket.flags.marketingConsent.title",
        "defaultMessage": "Let's update your email settings"
    },
    marketingConsentDescription: {
        "id": "frontbucket.flags.marketingConsent.description",
        "defaultMessage": "Would you like to receive news and offers from Atlassian about products, events, and more?"
    },
    marketingConsentButtonYes: {
        "id": "frontbucket.flags.marketingConsent.button.yes",
        "defaultMessage": "Yes, please"
    },
    marketingConsentButtonNo: {
        "id": "frontbucket.flags.marketingConsent.button.no",
        "defaultMessage": "No, thanks"
    },
    marketingConsentFailedTitle: {
        "id": "frontbucket.flags.marketingConsent.error.title",
        "defaultMessage": "Something went wrong"
    },
    marketingConsentSubmitFailedDescription: {
        "id": "frontbucket.flags.marketingConsent.error.description",
        "defaultMessage": "Please try again later."
    },
    marketingConsentSubmitFailedButton: {
        "id": "frontbucket.flags.marketingConsent.error.button",
        "defaultMessage": "OK"
    }
});


const $05040d36a41c7955$export$1d836d150202abf8 = /*#__PURE__*/ (0, $9nHZC.memo)(({ geoipCountry: geoipCountry, marketingConsentLocale: marketingConsentLocale, id: id, handleDismissed: handleDismissed, ...flagProps })=>{
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    const [isSubmitting, setIsSubmitting] = (0, $9nHZC.useState)(false);
    const [submitFailed, setSubmitFailed] = (0, $9nHZC.useState)(false);
    const dispatch = (0, $eeHDY.useDispatch)();
    const showErrorMessage = (0, $9nHZC.useCallback)(()=>{
        setIsSubmitting(false);
        setSubmitFailed(true);
    }, []);
    const closeFlag = (0, $9nHZC.useCallback)(()=>{
        dispatch((0, $9a012ee674853dcf$export$2e2bcd8739ae039)(false));
        handleDismissed(id);
    }, [
        id,
        handleDismissed,
        dispatch
    ]);
    const submitConsent = (0, $9nHZC.useCallback)(async (consent)=>{
        if (isSubmitting) return;
        setIsSubmitting(true);
        const locale = marketingConsentLocale !== "UNKNOWN" ? marketingConsentLocale : geoipCountry;
        try {
            const resp = await fetch((0, $k2cPS.default)("/!api/internal/user/marketing_consent", {
                method: "POST",
                body: JSON.stringify({
                    marketing_consent: consent,
                    marketing_consent_locale: locale,
                    marketing_consent_verbiage: formatMessage((0, $95c6c2caa7205830$export$2e2bcd8739ae039).marketingConsentDescription)
                })
            }));
            if (resp.ok) closeFlag();
            else showErrorMessage();
        } catch (error) {
            showErrorMessage();
        }
    }, [
        closeFlag,
        formatMessage,
        geoipCountry,
        marketingConsentLocale,
        isSubmitting,
        showErrorMessage
    ]);
    const actions = (0, $9nHZC.useMemo)(()=>submitFailed ? [
            {
                content: formatMessage((0, $95c6c2caa7205830$export$2e2bcd8739ae039).marketingConsentSubmitFailedButton),
                onClick: closeFlag
            }
        ] : [
            {
                content: formatMessage((0, $95c6c2caa7205830$export$2e2bcd8739ae039).marketingConsentButtonYes),
                onClick: ()=>submitConsent(true)
            },
            {
                content: formatMessage((0, $95c6c2caa7205830$export$2e2bcd8739ae039).marketingConsentButtonNo),
                onClick: ()=>submitConsent(false)
            }
        ], [
        closeFlag,
        formatMessage,
        submitConsent,
        submitFailed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement($f00a350f326f4ad5$export$2f8a82f9bac44423, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aMNOk.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        id: id,
        appearance: "normal",
        title: submitFailed ? formatMessage((0, $95c6c2caa7205830$export$2e2bcd8739ae039).marketingConsentFailedTitle) : formatMessage((0, $95c6c2caa7205830$export$2e2bcd8739ae039).marketingConsentTitle),
        description: submitFailed ? formatMessage((0, $95c6c2caa7205830$export$2e2bcd8739ae039).marketingConsentSubmitFailedDescription) : formatMessage((0, $95c6c2caa7205830$export$2e2bcd8739ae039).marketingConsentDescription),
        icon: isSubmitting ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dEKDm.default), {
            testId: "marketing-content-spinner",
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g3VDW))), {
            label: "",
            primaryColor: (0, $h39Sh.default)("color.icon.discovery", (0, $jp7ng).P300),
            size: "medium"
        }),
        actions: actions
    }, flagProps)));
});
const $05040d36a41c7955$var$mapStateToProps = (state)=>({
        geoipCountry: state.global.geoipCountry,
        marketingConsentLocale: state.global.marketingConsentLocale
    });
var $05040d36a41c7955$export$2e2bcd8739ae039 = (0, $5oGLl.default)($05040d36a41c7955$var$mapStateToProps, {})($05040d36a41c7955$export$1d836d150202abf8);



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $aMNOk = parcelRequire("aMNOk");

var $4dJkZ = parcelRequire("4dJkZ");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $agjvf = parcelRequire("agjvf");
var $5628877e6b5708c2$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    offlineTitle: {
        "id": "frontbucket.flags.network.offlineTitle",
        "defaultMessage": "You are currently offline."
    },
    offlineDescription: {
        "id": "frontbucket.flags.network.offlineDescription",
        "defaultMessage": "You can\u2019t save any changes, but you can still review code."
    },
    reconnectText: {
        "id": "frontbucket.flags.network.reconnectText",
        "defaultMessage": "Try to reconnect"
    }
});


const $92a1618df5cbec3d$var$OfflineFlag = ({ id: id, intl: intl, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aMNOk.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
        id: id,
        appearance: "error",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4dJkZ))), {
            label: "error",
            secondaryColor: (0, $h39Sh.default)("color.icon.danger", (0, $jp7ng).R300)
        }),
        title: intl.formatMessage((0, $5628877e6b5708c2$export$2e2bcd8739ae039).offlineTitle),
        description: intl.formatMessage((0, $5628877e6b5708c2$export$2e2bcd8739ae039).offlineDescription)
    }));
var $92a1618df5cbec3d$export$2e2bcd8739ae039 = (0, $agjvf.injectIntl)($92a1618df5cbec3d$var$OfflineFlag);



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");

var $aMNOk = parcelRequire("aMNOk");

var $5eELe = parcelRequire("5eELe");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $agjvf = parcelRequire("agjvf");
var $1be88132f7b82a3b$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    onlineTitle: {
        "id": "frontbucket.flags.network.onlineTitle",
        "defaultMessage": "Connected"
    }
});


const $f065e42998ea550a$var$OnlineFlag = ({ id: id, intl: intl, handleDismissed: handleDismissed, ...otherProps })=>{
    (0, $9nHZC.useEffect)(()=>{
        const dismissFlag = setTimeout(()=>{
            handleDismissed(id);
        }, 2000);
        return ()=>{
            clearTimeout(dismissFlag);
        };
    }, [
        id,
        handleDismissed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aMNOk.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
        id: id,
        appearance: "success",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5eELe))), {
            label: "success",
            secondaryColor: (0, $h39Sh.default)("color.icon.success", (0, $jp7ng).G300)
        }),
        title: intl.formatMessage((0, $1be88132f7b82a3b$export$2e2bcd8739ae039).onlineTitle)
    }));
};
var $f065e42998ea550a$export$2e2bcd8739ae039 = (0, $agjvf.injectIntl)($f065e42998ea550a$var$OnlineFlag);



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $agjvf = parcelRequire("agjvf");
parcelRequire("dGzLf");
var $eeHDY = parcelRequire("eeHDY");
var $aAre5 = parcelRequire("aAre5");

var $aMNOk = parcelRequire("aMNOk");

var $g3VDW = parcelRequire("g3VDW");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $jajUg = parcelRequire("jajUg");

var $fEXRj = parcelRequire("fEXRj");
parcelRequire("24sAG");
var $6D21P = parcelRequire("6D21P");

var $1EkdU = parcelRequire("1EkdU");

var $aTiUP = parcelRequire("aTiUP");

var $cy76E = parcelRequire("cy76E");

var $11JYn = parcelRequire("11JYn");
function $c6259e5c0ee4565e$var$getFlagText(response) {
    if (response) {
        if (response.anchorMoved) return {
            title: (0, $cy76E.default).anchorMovedTitle,
            description: (0, $cy76E.default).anchorMovedDescription
        };
    }
    return {
        title: (0, $cy76E.default).pullRequestUpdated
    };
}
const $c6259e5c0ee4565e$export$67eeeab6a1ceabfc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo((props)=>{
    var _flagProps$props;
    const { id: id, handleDismissed: handleDismissed, ...flagProps } = props;
    const isEditorOpen = (0, $aAre5.useSelector)((0, $1EkdU.getEditorState));
    const [showDiscardCommentsDialog, setShowDiscardCommentsDialog] = (0, $9nHZC.useState)(false);
    const intl = (0, $jajUg.useIntl)();
    const dispatch = (0, $eeHDY.useDispatch)();
    const handleUpdate = (0, $9nHZC.useCallback)(()=>{
        dispatch({
            type: (0, $6D21P.REFRESH_CODE_REVIEW_DATA_FROM_POLL_RESULTS)
        });
        dispatch((0, $fEXRj.default)({
            targetId: "root"
        }));
        handleDismissed(id);
    }, [
        dispatch,
        id,
        handleDismissed
    ]);
    const refreshAction = (0, $9nHZC.useMemo)(()=>({
            content: intl.formatMessage((0, $cy76E.default).reload),
            onClick: ()=>{
                if (isEditorOpen) setShowDiscardCommentsDialog(true);
                else handleUpdate();
            }
        }), [
        handleUpdate,
        intl,
        isEditorOpen
    ]);
    const handleDiscardComments = (0, $9nHZC.useCallback)(()=>{
        setShowDiscardCommentsDialog(false);
        handleUpdate();
    }, [
        handleUpdate
    ]);
    const handleDiscardCommentsCancel = (0, $9nHZC.useCallback)(()=>{
        setShowDiscardCommentsDialog(false);
    }, []);
    const { title: title, description: description } = $c6259e5c0ee4565e$var$getFlagText((_flagProps$props = flagProps.props) === null || _flagProps$props === void 0 ? void 0 : _flagProps$props.response);
    const formattedTitle = title ? intl.formatMessage(title) : "";
    const formattedDescription = description ? intl.formatMessage(description) : "";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9nHZC.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aMNOk.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({
        id: id,
        title: formattedTitle,
        appearance: (0, $11JYn.AppearanceTypes).normal,
        description: formattedDescription,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g3VDW))), {
            label: "",
            primaryColor: (0, $h39Sh.default)("color.icon.discovery", (0, $jp7ng).P300)
        }),
        actions: [
            refreshAction
        ]
    }, flagProps)), showDiscardCommentsDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aTiUP.default), {
        onCancel: handleDiscardCommentsCancel,
        onDiscard: handleDiscardComments
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.FormattedMessage), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, (0, $cy76E.default).discardCommentsModalBody, {
        tagName: "p"
    }))));
});



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $fBIHI = parcelRequire("fBIHI");

var $4dJkZ = parcelRequire("4dJkZ");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $jajUg = parcelRequire("jajUg");

var $i8uLY = parcelRequire("i8uLY");

var $agjvf = parcelRequire("agjvf");
var $1a811bcd5723d402$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    retargetPullRequestSuccessTitle: {
        "id": "frontbucket.repository.pullRequest.retargetPullRequestSuccess.title",
        "defaultMessage": "Pull request retargeted"
    },
    retargetPullRequestSuccessBody: {
        "id": "frontbucket.repository.pullRequest.retargetPullRequestSuccess.description",
        "defaultMessage": "The pull request was successfully retargeted to {branch}."
    },
    retargetPullRequestErrorBody: {
        "id": "frontbucket.repository.pullRequest.retargetPullRequestError.description",
        "defaultMessage": "We ran into an issue while retargeting the pull request. Refresh the page to try again."
    }
});


const $434937f4d7ec5688$export$f4d7683d9f3a630f = ({ id: id, ...otherProps })=>{
    const intl = (0, $jajUg.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fBIHI.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
        id: id,
        description: intl.formatMessage((0, $1a811bcd5723d402$export$2e2bcd8739ae039).retargetPullRequestErrorBody),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4dJkZ))), {
            label: "error",
            primaryColor: (0, $h39Sh.default)("color.icon.danger", (0, $jp7ng).R300)
        }),
        title: intl.formatMessage((0, $i8uLY.default).errorHeading)
    }));
};



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $fBIHI = parcelRequire("fBIHI");

var $5eELe = parcelRequire("5eELe");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $jajUg = parcelRequire("jajUg");

const $ede827879df90978$export$6025857663106903 = ({ id: id, props: props, ...otherProps })=>{
    const intl = (0, $jajUg.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fBIHI.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
        id: id,
        description: intl.formatMessage((0, $1a811bcd5723d402$export$2e2bcd8739ae039).retargetPullRequestSuccessBody, {
            branch: props === null || props === void 0 ? void 0 : props.branchName
        }),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5eELe))), {
            primaryColor: (0, $h39Sh.default)("color.icon.success", (0, $jp7ng).G300),
            label: "success"
        }),
        title: intl.formatMessage((0, $1a811bcd5723d402$export$2e2bcd8739ae039).retargetPullRequestSuccessTitle)
    }));
};



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $eygjM = parcelRequire("eygjM");

var $fBIHI = parcelRequire("fBIHI");

var $4dJkZ = parcelRequire("4dJkZ");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $bRi2x = parcelRequire("bRi2x");

var $9waMY = parcelRequire("9waMY");
const $5b9f679d69e74319$var$generalErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eygjM.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, (0, $bRi2x.default).generalErrorDescription, {
    values: {
        supportLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement("a", {
            href: (0, $9waMY.default).external.support
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eygjM.default), (0, $bRi2x.default).supportLink))
    }
}));
const $5b9f679d69e74319$export$9c218d5821aa04d7 = ({ id: id, ...otherProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fBIHI.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eygjM.default), (0, $bRi2x.default).errorDiscardTitle),
        description: $5b9f679d69e74319$var$generalErrorMessage,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4dJkZ))), {
            label: "info",
            primaryColor: (0, $h39Sh.default)("color.icon.danger", (0, $jp7ng).R500)
        }),
        id: id
    }));
};
const $5b9f679d69e74319$export$69fc6f277bae8a1a = ({ id: id, props: props, ...otherProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fBIHI.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $eygjM.default), (0, $bRi2x.default).errorSubmitTitle),
        description: props.errorMessage || $5b9f679d69e74319$var$generalErrorMessage,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4dJkZ))), {
            label: "info",
            primaryColor: (0, $h39Sh.default)("color.icon.danger", (0, $jp7ng).R500)
        }),
        id: id
    }));
};



var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");

var $fBIHI = parcelRequire("fBIHI");

var $4dJkZ = parcelRequire("4dJkZ");

var $jp7ng = parcelRequire("jp7ng");

var $h39Sh = parcelRequire("h39Sh");

var $jajUg = parcelRequire("jajUg");

var $agjvf = parcelRequire("agjvf");
var $717f80502709c91e$export$2e2bcd8739ae039 = (0, $agjvf.defineMessages)({
    title: {
        "id": "frontbucket.repository.pullRequest.revert.errorFlag.title",
        "defaultMessage": "Unable to revert pull request"
    },
    learnMore: {
        "id": "frontbucket.repository.pullRequest.revert.errorFlag.learnMore",
        "defaultMessage": "Learn more"
    },
    description: {
        "id": "frontbucket.repository.pullRequest.revert.errorFlag.description",
        "defaultMessage": "The resulting revert would cause conflicts on one or more files. You will need to resolve these conflicts manually or create a new pull request to revert these changes."
    }
});


const $9e0b815e68f7d47d$export$be7f57c294a426a6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).memo(({ id: id, ...otherProps })=>{
    const intl = (0, $jajUg.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $fBIHI.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, otherProps, {
        id: id,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4dJkZ))), {
            label: "error",
            primaryColor: (0, $h39Sh.default)("color.icon.danger", (0, $jp7ng).R300)
        }),
        title: intl.formatMessage((0, $717f80502709c91e$export$2e2bcd8739ae039).title),
        description: intl.formatMessage((0, $717f80502709c91e$export$2e2bcd8739ae039).description),
        actions: [
            {
                content: intl.formatMessage((0, $717f80502709c91e$export$2e2bcd8739ae039).learnMore),
                href: "https://www.atlassian.com/git/tutorials/undoing-changes/git-revert",
                target: "_blank"
            }
        ]
    }));
});



var $11JYn = parcelRequire("11JYn");

var $fPPqr = parcelRequire("fPPqr");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("dGzLf");
var $aAre5 = parcelRequire("aAre5");

var $aMNOk = parcelRequire("aMNOk");

var $g3VDW = parcelRequire("g3VDW");

var $jajUg = parcelRequire("jajUg");

var $8MnfV = parcelRequire("8MnfV");

var $g2R3c = parcelRequire("g2R3c");

var $50zD2 = parcelRequire("50zD2");

var $7Om57 = parcelRequire("7Om57");
const $093bf571a615e46c$export$66569167fa73f94f = /*#__PURE__*/ (0, $9nHZC.memo)(({ id: id, handleDismissed: handleDismissed, ...flagProps })=>{
    const currentUserUuid = (0, $aAre5.useSelector)((0, $g2R3c.getCurrentUserUuid));
    const siteMessage = (0, $aAre5.useSelector)((0, $8MnfV.getSiteMessageFlag));
    const { formatMessage: formatMessage } = (0, $jajUg.useIntl)();
    const markSiteMessageSeen = (0, $9nHZC.useCallback)((messageId)=>{
        if (currentUserUuid) (0, $7Om57.messageDismissed)(currentUserUuid, messageId);
    }, [
        currentUserUuid
    ]);
    const actions = (0, $9nHZC.useMemo)(()=>{
        if (!siteMessage) return [];
        const { id: siteMessageId, url: url } = siteMessage;
        const dismiss = {
            content: formatMessage((0, $50zD2.default).dismissButton),
            onClick: ()=>{
                markSiteMessageSeen(siteMessageId);
                handleDismissed(id);
            }
        };
        const learnMore = {
            content: formatMessage((0, $50zD2.default).learnMoreButton),
            href: url,
            target: "_new",
            onClick: ()=>{
                markSiteMessageSeen(siteMessageId);
            }
        };
        return url ? [
            dismiss,
            learnMore
        ] : [
            dismiss
        ];
    }, [
        formatMessage,
        id,
        markSiteMessageSeen,
        handleDismissed,
        siteMessage
    ]);
    if (!siteMessage) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $aMNOk.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, flagProps, {
        actions: actions,
        appearance: "info",
        description: siteMessage.text,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g3VDW))), {
            label: "",
            secondaryColor: "inherit"
        }),
        id: id,
        title: siteMessage.title
    }));
});



var $05iag = parcelRequire("05iag");

var $iaxMc = parcelRequire("iaxMc");

var $5nyeq = parcelRequire("5nyeq");

var $bUo4Z = parcelRequire("bUo4Z");
const $c1c72199445b7a03$var$flagRegistry = {
    "create-branch-load-repositories-error": (0, $3381ab07353c52ce$export$511413daec44ce2b),
    "create-branch-success": (0, $cec9ce4b636aa9a2$export$5a60cab8a94c560e),
    "create-branch-error": (0, $3381ab07353c52ce$export$da32fafae5bc420e),
    "create-workspace-error": (0, $a76fd752d0c4fa54$export$2e2bcd8739ae039),
    "delete-branch-success": (0, $b8364e436207393f$export$ff0385180b3a2e36),
    "delete-branch-error": (0, $a77f0171a73b7ce2$export$da4b6bd6e8d7af2b),
    "compare-branches-success": (0, $11f9aca16ae3305f$export$fe418da0fcae36b6),
    "compare-branches-error": (0, $74dcf812702c668d$export$caa4342d17f8bd05),
    "compare-branches-timeout": (0, $811cf4b3608ce069$export$a7f5ef9f67c4bcc9),
    "marketing-consent": (0, $05040d36a41c7955$export$2e2bcd8739ae039),
    "site-message": (0, $093bf571a615e46c$export$66569167fa73f94f),
    "diff-settings-error": (0, $78e6616f1be08880$export$1454caeeb6d6e203),
    "file-mode-onboarding": (0, $b20c1739fdb8f525$export$13c2f39f3e05520f),
    "pull-request-updated": (0, $c6259e5c0ee4565e$export$67eeeab6a1ceabfc),
    "commits-list-updated": (0, $d460a4dd4da50814$export$2e2bcd8739ae039),
    "load-context-error": (0, $4feaa5b6cabce4b9$export$ace7ccade6f072f6),
    "load-context-forbidden-not-found": (0, $b966ba30b96d2234$export$6a97e614955acf5c),
    "network-offline": (0, $92a1618df5cbec3d$export$2e2bcd8739ae039),
    "network-online": (0, $f065e42998ea550a$export$2e2bcd8739ae039),
    "revert-pull-request-error": (0, $9e0b815e68f7d47d$export$be7f57c294a426a6),
    "delete-repository-success": (0, $442b36f5e69cb88d$export$2e2bcd8739ae039),
    "error-cannot-be-deleted-sox": (0, $1d33c18b6e0b6433$export$2e2bcd8739ae039),
    "create-jira-issue-success": (0, $0550b464c586551d$export$ff0874adeb1c1e4c),
    "horizontal-nav-feedback-button": (0, $627a311121ec7dd7$export$7e4c14bc1ac529f4),
    [(0, $5nyeq.USER_NEEDS_ACCESS_FLAG_ID)]: (0, $5nyeq.default),
    "pull-request-retarget-success": (0, $ede827879df90978$export$6025857663106903),
    "pull-request-retarget-error": (0, $434937f4d7ec5688$export$f4d7683d9f3a630f),
    [(0, $05iag.SYNTAX_HIGHLIGHTING_FLAG_ID)]: (0, $05iag.SyntaxHighlightingFlag),
    "default-group-intro": (0, $35816828a7b837ec$export$893a3c233589dd2),
    "internal-new-page": (0, $b863230eb484c4d4$export$670485040d4f2b22),
    "user-ai-onboarding": (0, $iaxMc.UserAiOnboardingFlag),
    "discard-review-error": (0, $5b9f679d69e74319$export$9c218d5821aa04d7),
    "submit-review-error": (0, $5b9f679d69e74319$export$69fc6f277bae8a1a)
};
const $c1c72199445b7a03$var$mapDispatchToProps = {
    dismissFlag: $2kKDW.dismissFlag
};
const $c1c72199445b7a03$var$mapStateToProps = (state)=>({
        flags: state.flags
    });
const $c1c72199445b7a03$var$isComponentFlagId = (id)=>id in $c1c72199445b7a03$var$flagRegistry;
var $c1c72199445b7a03$export$2e2bcd8739ae039 = (0, $5oGLl.default)($c1c72199445b7a03$var$mapStateToProps, $c1c72199445b7a03$var$mapDispatchToProps)(class Flags extends (0, $9nHZC.PureComponent) {
    constructor(...args){
        super(...args);
        this.handleDismissed = (id)=>{
            const { flags: flags } = this.props;
            const flag = flags.find((f)=>f.id === id);
            if (!flag) return;
            (0, $6aoKW.publishFact)(new (0, $bUo4Z.FlagDismissed)({
                flag_id: flag.id
            }));
            (0, $6aoKW.publishUiEvent)({
                action: "dismissed",
                actionSubject: "flag",
                actionSubjectId: "bitbucketFlag",
                source: "flag",
                attributes: {
                    flag_id: flag.id
                }
            });
            const simpleFlag = flag;
            if (typeof simpleFlag.onDismissed === "function") simpleFlag.onDismissed(simpleFlag.id);
            this.props.dismissFlag(flag.id);
        };
        this.renderFlag = (flagObj)=>{
            if (flagObj.type === "component") {
                let FlagComponent = flagObj.componentId && $c1c72199445b7a03$var$flagRegistry[flagObj.componentId];
                if (!FlagComponent && $c1c72199445b7a03$var$isComponentFlagId(flagObj.id)) FlagComponent = $c1c72199445b7a03$var$flagRegistry[flagObj.id];
                if (!FlagComponent) {
                    $3XbtU.withScope((scope)=>{
                        scope.setTag("flagId", flagObj.id);
                        $3XbtU.captureMessage("UNKNOWN_FLAG");
                    });
                    // eslint-disable-next-line no-console
                    console.warn(`UNKNOWN_FLAG: ${flagObj.id}`);
                    return null;
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(FlagComponent, {
                    id: flagObj.id,
                    key: flagObj.id,
                    props: flagObj.props,
                    handleDismissed: this.handleDismissed
                });
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $11JYn.default), (0, (/*@__PURE__*/$parcel$interopDefault($fPPqr)))({}, flagObj, {
                key: flagObj.id,
                handleDismissed: this.handleDismissed
            }));
        };
    }
    render() {
        const { flags: flags } = this.props;
        const renderedFlags = flags.map(this.renderFlag).filter((f)=>f !== null);
        if (renderedFlags.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $1zBji.default), {
            onDismissed: this.handleDismissed
        }, renderedFlags);
        else // EngagementMessages uses their own FlagGroup. If we rendered both this and the above at the same time,
        // and both were showing flags, they would overlap. So render our own first, and if there are none, render the
        // ones from engagement platform.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $c58870b4d49a025f$export$2e2bcd8739ae039), null);
    }
});


parcelRequire("dGzLf");
var $5oGLl = parcelRequire("5oGLl");

var $2kKDW = parcelRequire("2kKDW");

var $8MnfV = parcelRequire("8MnfV");

var $9nHZC = parcelRequire("9nHZC");
class $7e5451c4ded2a916$export$fbcc1358ab5305dc extends (0, $9nHZC.PureComponent) {
    componentDidMount() {
        if (this.props.needsMarketingConsent) this.props.showMarketingConsentFlag();
    }
    componentDidUpdate(prevProps) {
        const { needsMarketingConsent: needsMarketingConsent } = this.props;
        if (needsMarketingConsent && prevProps.needsMarketingConsent !== needsMarketingConsent) this.props.showMarketingConsentFlag();
    }
    render() {
        return null;
    }
}


const $2b2ec1f4ae87505c$var$mapStateToProps = (state)=>({
        needsMarketingConsent: !(0, $8MnfV.getIsMobileHeaderActive)(state) && state.global.needsMarketingConsent
    });
const $2b2ec1f4ae87505c$var$mapDispatchToProps = (dispatch)=>({
        showMarketingConsentFlag: ()=>{
            dispatch((0, $2kKDW.showFlagComponent)("marketing-consent"));
        }
    });
var $2b2ec1f4ae87505c$export$2e2bcd8739ae039 = (0, $5oGLl.default)($2b2ec1f4ae87505c$var$mapStateToProps, $2b2ec1f4ae87505c$var$mapDispatchToProps)((0, $7e5451c4ded2a916$export$fbcc1358ab5305dc));


parcelRequire("dGzLf");
var $5oGLl = parcelRequire("5oGLl");

var $2kKDW = parcelRequire("2kKDW");

var $8MnfV = parcelRequire("8MnfV");

var $9nHZC = parcelRequire("9nHZC");
class $4cd474e82a9f78cf$export$9f18500a8eb4cf81 extends (0, $9nHZC.PureComponent) {
    componentDidMount() {
        if (this.props.siteMessageFlag) this.props.showSiteMessageFlag();
    }
    componentDidUpdate(prevProps) {
        const { siteMessageFlag: siteMessageFlag } = this.props;
        if (siteMessageFlag && prevProps.siteMessageFlag !== siteMessageFlag) this.props.showSiteMessageFlag();
        if (!siteMessageFlag && prevProps.siteMessageFlag !== siteMessageFlag) this.props.dismissSiteMessageFlag();
    }
    render() {
        return null;
    }
}


// @ts-ignore TODO: fix noImplicitAny error here
const $08a2cfe39e79d9be$var$mapDispatchToProps = (dispatch)=>({
        dismissSiteMessageFlag: ()=>{
            dispatch((0, $2kKDW.dismissFlag)("site-message"));
        },
        showSiteMessageFlag: ()=>{
            dispatch((0, $2kKDW.showFlagComponent)("site-message"));
        }
    });
const $08a2cfe39e79d9be$var$mapStateToProps = (state)=>({
        siteMessageFlag: !!(0, $8MnfV.getSiteMessageFlag)(state)
    });
var $08a2cfe39e79d9be$export$2e2bcd8739ae039 = (0, $5oGLl.default)($08a2cfe39e79d9be$var$mapStateToProps, $08a2cfe39e79d9be$var$mapDispatchToProps)((0, $4cd474e82a9f78cf$export$9f18500a8eb4cf81));



var $9nHZC = parcelRequire("9nHZC");

var $dbdtR = parcelRequire("dbdtR");

var $c03Tp = parcelRequire("c03Tp");
var $a3lEo = parcelRequire("a3lEo");

var $4ym3q = parcelRequire("4ym3q");

var $c03Tp = parcelRequire("c03Tp");

var $l5MLt = parcelRequire("l5MLt");

var $b82uS = parcelRequire("b82uS");

var $a3lEo = parcelRequire("a3lEo");

var $9NMTI = parcelRequire("9NMTI");

var $dGehf = parcelRequire("dGehf");

var $4ym3q = parcelRequire("4ym3q");
var $e9e1e1bcfbaad30a$exports = {};

var $olABV = parcelRequire("olABV");
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $e9e1e1bcfbaad30a$var$uniq(array) {
    return array && array.length ? $olABV(array) : [];
}
$e9e1e1bcfbaad30a$exports = $e9e1e1bcfbaad30a$var$uniq;


var $5bf719a5c976a5f9$var$extractFromContext = function(event, property) {
    return event.context.map(function(item) {
        return item[property];
    });
};
var $5bf719a5c976a5f9$export$a3569ac53b82a914 = function(event) {
    return event.payload.analyticsType;
};
var $5bf719a5c976a5f9$export$fe94072fee8a6976 = function(event) {
    var contextAttributes = $5bf719a5c976a5f9$var$extractFromContext(event, "attributes");
    var payloadAttributes = event.payload.attributes;
    var allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($dGehf)))(contextAttributes.reduce(function(result, extraAttributes) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dGehf)))(result, extraAttributes);
    }, {}), payloadAttributes);
    var sources = $5bf719a5c976a5f9$var$extractFromContext(event, "source");
    var namespaces = sources.filter(Boolean).join(".");
    return (0, (/*@__PURE__*/$parcel$interopDefault($4ym3q)))((0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, allAttributes), {
        namespaces: namespaces
    }), (0, (/*@__PURE__*/$parcel$interopDefault($a3lEo))));
};
var $5bf719a5c976a5f9$export$dd2b6e807fb37ba3 = function(event) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))($5bf719a5c976a5f9$var$extractFromContext(event, "source").filter(Boolean));
};
var $5bf719a5c976a5f9$export$6f40cdf6d42c018d = function(event) {
    var actionSubject = event.payload.actionSubject;
    if (actionSubject) return actionSubject;
    var component = (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))($5bf719a5c976a5f9$var$extractFromContext(event, "component").filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))($5bf719a5c976a5f9$var$extractFromContext(event, "componentName").filter(Boolean));
    return component;
};
var $5bf719a5c976a5f9$export$6ca3170acb89054 = function(event) {
    return event.payload.action;
};
var $5bf719a5c976a5f9$export$b6f8db3ad0711b02 = function(event) {
    return event.payload.actionSubjectId;
};
var $5bf719a5c976a5f9$export$7c8178cc9001d237 = function(event) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))($5bf719a5c976a5f9$var$extractFromContext(event, "containerId").filter(Boolean));
};
var $5bf719a5c976a5f9$export$acc6f3e19803b3dc = function(event) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))($5bf719a5c976a5f9$var$extractFromContext(event, "containerType").filter(Boolean));
};
var $5bf719a5c976a5f9$export$fa986b91291934c7 = function(event) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))($5bf719a5c976a5f9$var$extractFromContext(event, "objectId").filter(Boolean));
};
var $5bf719a5c976a5f9$export$11cc42aebef2ef3a = function(event) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9NMTI)))($5bf719a5c976a5f9$var$extractFromContext(event, "objectType").filter(Boolean));
};
var $5bf719a5c976a5f9$export$af63d7414243dad3 = function(event) {
    var tags = (0, (/*@__PURE__*/$parcel$interopDefault($e9e1e1bcfbaad30a$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($b82uS)))($5bf719a5c976a5f9$var$extractFromContext(event, "tags"))).filter(Boolean);
    return tags.length ? tags : undefined;
};


var $b6d5e155e1cb0577$export$1c850cf68c053906 = function(event) {
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    var castedEvent = event;
    var analyticsType = (0, $5bf719a5c976a5f9$export$a3569ac53b82a914)(castedEvent);
    var attributes = (0, $5bf719a5c976a5f9$export$fe94072fee8a6976)(castedEvent);
    var source = (0, $5bf719a5c976a5f9$export$dd2b6e807fb37ba3)(castedEvent);
    var actionSubject = (0, $5bf719a5c976a5f9$export$6f40cdf6d42c018d)(castedEvent);
    if (analyticsType === (0, $c03Tp.SCREEN_EVENT_TYPE)) return {
        type: (0, $c03Tp.SCREEN_EVENT_TYPE),
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case 0, $c03Tp.UI_EVENT_TYPE:
        case 0, $c03Tp.TRACK_EVENT_TYPE:
        case 0, $c03Tp.OPERATIONAL_EVENT_TYPE:
            var action = (0, $5bf719a5c976a5f9$export$6ca3170acb89054)(castedEvent);
            var actionSubjectId = (0, $5bf719a5c976a5f9$export$b6f8db3ad0711b02)(castedEvent);
            var containerId = (0, $5bf719a5c976a5f9$export$7c8178cc9001d237)(castedEvent);
            var containerType = (0, $5bf719a5c976a5f9$export$acc6f3e19803b3dc)(castedEvent);
            var objectId = (0, $5bf719a5c976a5f9$export$fa986b91291934c7)(castedEvent);
            var objectType = (0, $5bf719a5c976a5f9$export$11cc42aebef2ef3a)(castedEvent);
            var tags = (0, $5bf719a5c976a5f9$export$af63d7414243dad3)(castedEvent);
            return {
                type: analyticsType,
                payload: (0, (/*@__PURE__*/$parcel$interopDefault($4ym3q)))({
                    action: action,
                    actionSubject: actionSubject,
                    actionSubjectId: actionSubjectId,
                    source: source,
                    tags: tags,
                    containerType: containerType,
                    containerId: containerId,
                    objectType: objectType,
                    objectId: objectId,
                    attributes: attributes
                }, (0, (/*@__PURE__*/$parcel$interopDefault($a3lEo))))
            };
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};



var $6aoKW = parcelRequire("6aoKW");
const $8e789fa46e2903e9$export$2de2f921d50c769c = ({ children: children })=>{
    const sendEvent = (event)=>{
        const { type: type, payload: payload } = event;
        switch(type){
            case 0, $c03Tp.UI_EVENT_TYPE:
                (0, $6aoKW.publishUiEvent)(payload);
                break;
            case 0, $c03Tp.TRACK_EVENT_TYPE:
                (0, $6aoKW.publishTrackEvent)(payload);
                break;
            case 0, $c03Tp.OPERATIONAL_EVENT_TYPE:
                (0, $6aoKW.publishOperationalEvent)(payload);
                break;
            case 0, $c03Tp.SCREEN_EVENT_TYPE:
                (0, $6aoKW.publishScreenEvent)(payload.name, payload.attributes);
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dbdtR.default), {
        channel: (0, $c03Tp.ANALYTICS_BRIDGE_CHANNEL),
        onEvent: (event)=>sendEvent((0, $b6d5e155e1cb0577$export$1c850cf68c053906)(event))
    }, children);
};



var $bBcuy = parcelRequire("bBcuy");

var $fpWfS = parcelRequire("fpWfS");

var $6aoKW = parcelRequire("6aoKW");
parcelRequire("4FqTo");
var $3REYY = parcelRequire("3REYY");
// Data Plugin definition and utility types
var $aa306ac883f32b2d$export$a235a73f7b906dce = {
    GetContainers: "GetContainers",
    GetUsers: "GetUsers",
    GetSuggestedSiteNames: "GetSuggestedSiteNames",
    GetAvailableSites: "GetAvailableSites"
};
var $aa306ac883f32b2d$export$6e383182a26455ff = {
    BITBUCKET_WORKSPACE: "bitbucket-workspace",
    ATLASSIAN_CLOUD_ID: "ATLASSIAN_CLOUD_ID",
    JIRA_SOFTWARE_PROJECT: "JIRA_SOFTWARE_PROJECT"
};
var $aa306ac883f32b2d$export$e391bab95adb8396 = {
    ATLASSIAN_ACCOUNT_ID: "ATLASSIAN_ACCOUNT_ID",
    TRELLO_ID: "TRELLO_ID"
};
var $aa306ac883f32b2d$export$4f378ba35c571906 = {
    JIRA_BUSINESS: "JIRA_BUSINESS",
    JIRA_SERVICE_DESK: "JIRA_SERVICE_DESK",
    JIRA_SOFTWARE: "JIRA_SOFTWARE",
    CONFLUENCE: "CONFLUENCE",
    OPSGENIE: "OPSGENIE",
    BITBUCKET: "BITBUCKET",
    STATUSPAGE: "STATUSPAGE",
    TRELLO: "TRELLO",
    COMPASS: "COMPASS"
};


var $a32191b9ed81e9dc$export$76378b0f825c024c = function createGetContainersPlugin(fetch) {
    return [
        (0, $aa306ac883f32b2d$export$a235a73f7b906dce).GetContainers,
        fetch
    ];
};
var $a32191b9ed81e9dc$export$8feb7eae83cf8cd5 = function createGetUsersPlugin(fetch) {
    return [
        (0, $aa306ac883f32b2d$export$a235a73f7b906dce).GetUsers,
        fetch
    ];
};
var $a32191b9ed81e9dc$export$21d120847be2aff4 = function createGetSuggestedSiteNamesPlugin(fetch) {
    return [
        (0, $aa306ac883f32b2d$export$a235a73f7b906dce).GetSuggestedSiteNames,
        fetch
    ];
};
var $a32191b9ed81e9dc$export$d7c1699c6a2ca18a = function createGetAvailableSitesPlugin(fetch) {
    return [
        (0, $aa306ac883f32b2d$export$a235a73f7b906dce).GetAvailableSites,
        fetch
    ];
};


const $969241ac99501645$export$7b8e1149e9b95a97 = async ()=>{
    const getWorkspacesUrl = '/!api/2.0/user/permissions/workspaces?q=permission="owner"';
    const response = await fetch(getWorkspacesUrl, {
        credentials: "same-origin"
    });
    if (response.ok) {
        const data = await response.json();
        const { values: values } = data;
        const containers = values.map((value)=>({
                id: value.workspace.uuid,
                displayName: value.workspace.name,
                type: (0, $aa306ac883f32b2d$export$6e383182a26455ff).BITBUCKET_WORKSPACE
            }));
        return {
            type: (0, $aa306ac883f32b2d$export$6e383182a26455ff).BITBUCKET_WORKSPACE,
            containers: containers
        };
    }
    throw new Error(`Unable to fetch ${getWorkspacesUrl} ${response.status} ${response.statusText}`);
};
const $969241ac99501645$export$925a4945a6cd0f3e = async (containerId)=>{
    const getUsersUrl = `/!api/2.0/workspaces/${containerId}/permissions`;
    const response = await fetch(getUsersUrl, {
        credentials: "same-origin"
    });
    if (response.ok) {
        const data = await response.json();
        const { values: values } = data;
        return values.map((value)=>({
                id: value.user.account_id,
                idType: (0, $aa306ac883f32b2d$export$e391bab95adb8396).ATLASSIAN_ACCOUNT_ID,
                displayName: value.user.display_name,
                avatarUrl: value.user.links.avatar ? value.user.links.avatar.href : undefined
            }));
    }
    throw new Error(`Unable to fetch ${getUsersUrl} ${response.status} ${response.statusText}`);
};
const $969241ac99501645$export$81d1d40061d190bc = (0, $a32191b9ed81e9dc$export$76378b0f825c024c)($969241ac99501645$export$7b8e1149e9b95a97);
const $969241ac99501645$export$7c44908d2777db01 = (0, $a32191b9ed81e9dc$export$8feb7eae83cf8cd5)($969241ac99501645$export$925a4945a6cd0f3e);






var $kvnVB = parcelRequire("kvnVB");

var $bjxwU = parcelRequire("bjxwU");

var $hp1uP = parcelRequire("hp1uP");

var $1D3HA = parcelRequire("1D3HA");
const $829a1a6b0b76cfb2$export$5e0aad59cce4677 = (intl)=>{
    return intl.default && typeof intl.default !== "string" ? intl.default : intl;
};

















const $829a1a6b0b76cfb2$export$7d7e7a6f338b08d2 = (locale)=>{
    switch(locale){
        case "cs":
            return [
                (parcelRequire("kCp7J"))
            ];
        case "de":
            return [
                (parcelRequire("6xLEs"))
            ];
        case "es":
            return [
                (parcelRequire("8nu7L"))
            ];
        case "fr":
            return [
                (parcelRequire("kRJE7"))
            ];
        case "it":
            return [
                (parcelRequire("7gMlt"))
            ];
        case "ja":
            return [
                (parcelRequire("4FzLb"))
            ];
        case "ko":
            return [
                (parcelRequire("2cVQD"))
            ];
        case "nl":
            return [
                (parcelRequire("fQYPZ"))
            ];
        case "pl":
            return [
                (parcelRequire("9ofb8"))
            ];
        case "pt-BR":
            return [
                (parcelRequire("1IVLa"))
            ];
        case "ru":
            return [
                (parcelRequire("hMVYi"))
            ];
        case "sv":
            return [
                (parcelRequire("htYlK"))
            ];
        case "tr":
            return [
                (parcelRequire("3t2Eq"))
            ];
        case "uk":
            return [
                (parcelRequire("lU3F6"))
            ];
        case "vi":
            return [
                (parcelRequire("e4QQi"))
            ];
        case "zh-CN":
            return [
                (parcelRequire("j3WOu"))
            ];
        case "en":
        default:
            return [
                (parcelRequire("fmSVZ"))
            ];
    }
};



var $9nHZC = parcelRequire("9nHZC");
parcelRequire("lM4y8");
var $cpagJ = parcelRequire("cpagJ");
var $b7V6F = parcelRequire("b7V6F");

var $9nHZC = parcelRequire("9nHZC");
parcelRequire("ilJwJ");
var $dL9SL = parcelRequire("dL9SL");
const $2bf32ca49c4f1430$export$eef8c9c165a5b267 = (history)=>{
    (0, $9nHZC.useEffect)(()=>{
        return history.listen((_location, action)=>{
            // Set marker for use in timing.  Possible action types
            // are PUSH, POP and REPLACE. Ignore REPLACE actions because
            // they are redirects
            if (action !== "REPLACE" && typeof performance.mark === "function") {
                performance.clearMarks("ROUTECHANGE");
                performance.mark("ROUTECHANGE");
            }
        });
    // This listener on `history` is only meant to be called on the initial mount of the component
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
const $2bf32ca49c4f1430$var$HistoryWatcher = (props)=>{
    $2bf32ca49c4f1430$export$eef8c9c165a5b267(props.history);
    return null;
};
var $2bf32ca49c4f1430$export$2e2bcd8739ae039 = (0, $dL9SL.default)($2bf32ca49c4f1430$var$HistoryWatcher);



var $7IfQd = parcelRequire("7IfQd");
const $7295113d629d111e$export$bb91f19f7a9cf65a = ()=>{
    const [routerState] = (0, $b7V6F.useRouter)();
    const { route: route } = routerState;
    if (// The root route "/" is a redirect, so we don't want to render any additional components yet
    route.name === (0, $7IfQd.ROUTE_NAME).ROOT) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $cpagJ.RouteComponent), null);
    const Wrapper = route.layout;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2bf32ca49c4f1430$export$2e2bcd8739ae039), null), Wrapper ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $cpagJ.RouteComponent), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $cpagJ.RouteComponent), null));
};


const $5219b9fa5d30a870$var$EXCLUDED_CHANNELS = [
    (0, $4L3N1.FabricChannel).atlaskit,
    (0, $4L3N1.FabricChannel).elements,
    (0, $4L3N1.FabricChannel).editor
];
const $5219b9fa5d30a870$var$GRAPHQL_CLIENT_NAME = "Bitbucket Front End";
const $5219b9fa5d30a870$var$Root = ({ appSettings: appSettings = (0, $kvnVB.settings)(), isSsr: isSsr = false, location: location = "", appData: appData = {
    navigationIsOpen: true,
    features: {},
    frontbucket_environment: "local",
    frontbucket_version: "local",
    links: {
        overviewUrl: "",
        backButtonUrl: undefined
    },
    initialContext: {}
} })=>{
    (0, $1JlAz.useStatsdMeasuredRender)("performance.app.mounted");
    (0, $3REYY.useBrowserMetricsWatcher)();
    (0, $939ca968d77ff06f$export$c1a838a491a42b2)();
    const routes = (0, $kjZQW.getRoutes)((0, $e5hNf.getRouteFeaturesFromAppData)(appData));
    const [platformMessages, setPlatformMessages] = (0, $9nHZC.useState)({});
    (0, $9nHZC.useEffect)(()=>{
        (0, $171cc51a435734dd$export$919040c32a62c7db)({
            product: "Bitbucket"
        });
    }, []);
    (0, $9nHZC.useEffect)(()=>{
        const fetchPlatformMessages = async ()=>{
            try {
                const translations = await Promise.all((0, $829a1a6b0b76cfb2$export$7d7e7a6f338b08d2)((0, $9c5590b5873af733$export$2e2bcd8739ae039).locale));
                const allTranslations = translations.reduce((acc, translation)=>{
                    const defaults = (0, $829a1a6b0b76cfb2$export$5e0aad59cce4677)(translation);
                    // Only merge the keys with string values from the default messages
                    // See https://ops.internal.atlassian.com/jira/browse/HOT-84998
                    const filteredDefaults = Object.fromEntries(Object.entries(defaults).filter(([_key, value])=>typeof value === "string"));
                    return {
                        ...acc,
                        ...filteredDefaults
                    };
                }, {});
                setPlatformMessages(allTranslations);
            } catch (e) {
                $3XbtU.captureException(e);
            }
        };
        fetchPlatformMessages();
    }, []);
    const apolloClient = (0, $9nHZC.useMemo)(()=>{
        return new (0, $grvSO.ApolloClient)({
            connectToDevTools: false,
            link: (0, $cHmNF.from)([
                (0, $1d7d2cb53f75cedb$export$fb326ed954631f3f),
                new (0, $27300495728577b8$export$f4bbf1aec241cc1)({
                    credentials: "include",
                    uri: "/gateway/api/graphql",
                    headers: {
                        "atl-client-name": $5219b9fa5d30a870$var$GRAPHQL_CLIENT_NAME,
                        "atl-client-version": appData.frontbucket_version
                    }
                })
            ]),
            cache: new (0, $cba9a046ce2ed465$export$467265324939f47f)()
        });
    }, [
        appData.frontbucket_version
    ]);
    // Locale messages are sent from transifex and contain all of the translated frontbucket + bitkit strings.
    // Platform messages are included from the platform package distributions.
    const combinedMessages = {
        ...(0, $9c5590b5873af733$export$2e2bcd8739ae039).messages,
        ...platformMessages
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kI8WJ.default), {
        name: "bitbucket-root"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $agjvf.IntlProvider), {
        locale: (0, $9c5590b5873af733$export$2e2bcd8739ae039).locale,
        messages: combinedMessages
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $huxZk.default), {
        locale: (0, $9c5590b5873af733$export$2e2bcd8739ae039).locale,
        messages: combinedMessages
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $jajUg.InjectIntlContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $1D3HA.AppDataProvider), {
        appData: appData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $hp1uP.CurrentDataProvider), {
        initialContext: appData.initialContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $hp1uP.CurrentDataContext).Consumer, null, (currentData)=>{
        var _appData$user, _currentData$workspac;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $d6ANX.AnalyticsClientManager), {
            analyticsClient: (0, $bBcuy.analyticsClient)(),
            accountId: ((_appData$user = appData.user) === null || _appData$user === void 0 ? void 0 : _appData$user.aaid) || undefined,
            workspaceId: ((_currentData$workspac = currentData.workspace) === null || _currentData$workspac === void 0 ? void 0 : _currentData$workspac.uuid) || appData.tenantId
        });
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5gpbZ.ApolloProvider), {
        client: apolloClient
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $ea76bedfcea4cca5$export$b77983be89bb0a4e), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $c64aecdef2700081$export$2e2bcd8739ae039), {
        analyticsClient: (0, $bBcuy.analyticsClient)(),
        locale: (0, $9c5590b5873af733$export$2e2bcd8739ae039).locale,
        plugins: [
            (0, $969241ac99501645$export$81d1d40061d190bc),
            (0, $969241ac99501645$export$7c44908d2777db01)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $jNWOd.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $64MZm.default), {
        store: (0, $bjxwU.bitbucketStore)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5e9fe9c4f5c3127f$export$ec900a63d6c1e95b), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $1WaGk.default), {
        connectHost: (0, $kNA8C.default),
        addonManager: (0, $QQQjQ.default),
        analyticsEventHandler: (0, $c5dog.sendEvent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $1yXM1.default).Provider, {
        value: {
            publishFact: $6aoKW.publishFact
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $e2zNv.default), {
        client: (0, $bBcuy.analyticsClient)(),
        excludedChannels: $5219b9fa5d30a870$var$EXCLUDED_CHANNELS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $8e789fa46e2903e9$export$2de2f921d50c769c), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $kBIj3.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $6gjHX.ExperienceTrackerContext).Provider, {
        value: (0, $fpWfS.getExperienceTracker)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $9A93V.default), {
        history: (0, $677Fr.default),
        routes: routes,
        resourceContext: {
            reduxStore: (0, $bjxwU.bitbucketStore),
            appSettings: appSettings,
            appData: appData
        },
        isSsr: isSsr,
        location: location
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2FglY.FeatureProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $bf3105324a2239b9$export$83b8ae7ce7b4d59c), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2FglY.StatsigFeatures), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $iihFv.ForgeAppsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $8b225077396da2ef$export$ced06283ca897aa8), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3ed2e22f70195a21$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $32c976254f03ed59$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $b769e8e9e9257822$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $a29cb53c8d78462e$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $c1c72199445b7a03$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $dV1BF.default), {
        defaultTitle: (0, $61bjs.DEFAULT_TITLE),
        titleTemplate: (0, $61bjs.TITLE_TEMPLATE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $2b2ec1f4ae87505c$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $08a2cfe39e79d9be$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $b5226a7b1123738a$export$2e2bcd8739ae039), null), /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $3faeaafd07ec4edc$export$2e2bcd8739ae039), null), /*#__PURE__*/ // @ts-ignore: requires @atlaskit/router to be bumped after AKR-23 released
    (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $7295113d629d111e$export$bb91f19f7a9cf65a), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $62f778ac26257bce$export$38f39b921d5551c1), null))))))))))))))))))))));
};
var $5219b9fa5d30a870$export$2e2bcd8739ae039 = $5219b9fa5d30a870$var$Root;


parcelRequire("4FqTo");
var $3REYY = parcelRequire("3REYY");


var $b1Qv2 = parcelRequire("b1Qv2");

var $2FglY = parcelRequire("2FglY");


var $bBcuy = parcelRequire("bBcuy");

var $6Tn56 = parcelRequire("6Tn56");
var $bef1398bd08cb05e$var$_appData$user;
if ((0, $9c5590b5873af733$export$2e2bcd8739ae039).localeData) {
    (0, $agjvf.addLocaleData)((0, $9c5590b5873af733$export$2e2bcd8739ae039).localeData);
    if ((0, $9c5590b5873af733$export$2e2bcd8739ae039).isDummyLocale) // @ts-ignore Is this argument even used?
    (0, $agjvf.addLocaleData)({
        locale: (0, $9c5590b5873af733$export$2e2bcd8739ae039).locale,
        parentLocale: "en"
    });
}
// This is the one place we should reference app data from the window
// eslint-disable-next-line no-restricted-properties
const $bef1398bd08cb05e$var$appData = window.__app_data__;
function $bef1398bd08cb05e$var$createFeatureFlagClient() {
    const env = (0, $2FglY.envMap)[(0, $6Tn56.getBbEnv)() || (0, $6Tn56.BbEnv).Development];
    const apiKey = (0, $b1Qv2.FeatureKeys)[env];
    const featureFlagUser = (0, $hw8PW.getUserIdentifier)($bef1398bd08cb05e$var$appData.user);
    return (0, $l9p9x.getGlobalFeatureFlagClient)({
        apiKey: apiKey,
        analyticsWebClient: (0, $bBcuy.analyticsClient)(),
        featureFlagUser: featureFlagUser,
        options: {
            productKey: "bitbucket",
            environment: env
        }
    });
}
// Initialise the feature flag client before we start rendering.
// Kicking this off before the react render prevents components
// from rerendering once flag values are populated from the remote.
const $bef1398bd08cb05e$var$featureFlagClient = $bef1398bd08cb05e$var$createFeatureFlagClient();
// Start up Browser Metrics
(0, $3REYY.initializeBrowserMetrics)({
    isAtlassian: (($bef1398bd08cb05e$var$_appData$user = $bef1398bd08cb05e$var$appData.user) === null || $bef1398bd08cb05e$var$_appData$user === void 0 ? void 0 : $bef1398bd08cb05e$var$_appData$user.isAtlassian) || false,
    featureFlagClient: $bef1398bd08cb05e$var$featureFlagClient,
    frontbucket_version: $bef1398bd08cb05e$var$appData.frontbucket_version || "local",
    tenantId: $bef1398bd08cb05e$var$appData.tenantId
});
(0, $f1a43714fa02266c$export$af995ee1d7017fea)($bef1398bd08cb05e$var$appData);
const $bef1398bd08cb05e$var$rootEl = document.getElementById("root");
if ($bef1398bd08cb05e$var$rootEl) {
    if ((0, $1ZBmx.appWasServerSideRendered)()) (0, (/*@__PURE__*/$parcel$interopDefault($8shKB))).preloadReady().then(()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($lnOmc))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5219b9fa5d30a870$export$2e2bcd8739ae039), {
            appData: $bef1398bd08cb05e$var$appData
        }), $bef1398bd08cb05e$var$rootEl);
    });
    else (0, (/*@__PURE__*/$parcel$interopDefault($lnOmc))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nHZC))).createElement((0, $5219b9fa5d30a870$export$2e2bcd8739ae039), {
        appData: $bef1398bd08cb05e$var$appData
    }), $bef1398bd08cb05e$var$rootEl);
}

})();
//# sourceMappingURL=app.js.map
